function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
var $parcel$modules = {};
var $parcel$inits = {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
    parcelRequire = function(id) {
        if (id in $parcel$modules) {
            return $parcel$modules[id].exports;
        }
        if (id in $parcel$inits) {
            var init = $parcel$inits[id];
            delete $parcel$inits[id];
            var module = {
                id: id,
                exports: {}
            };
            $parcel$modules[id] = module;
            init.call(module.exports, module, module.exports);
            return module.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    parcelRequire.register = function register(id, init) {
        $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire94c2"] = parcelRequire;
}
var parcelRegister = parcelRequire.register;
if (!$parcel$global.lb) {
    $parcel$global.lb = new Set();
    $parcel$global.bq = [];
    $parcel$global.rlb = (bundle)=>{
        $parcel$global.lb.add(bundle);
        $parcel$global.pq();
    };
    $parcel$global.rwr = (b, r, d)=>{
        $parcel$global.bq.push({
            b,
            r,
            d
        });
        $parcel$global.pq();
    };
    $parcel$global.pq = ()=>{
        var runnableEntry = $parcel$global.bq.find((i)=>{
            return i.d.every((dep)=>{
                return $parcel$global.lb.has(dep);
            });
        });
        if (runnableEntry) {
            $parcel$global.bq = $parcel$global.bq.filter((i)=>{
                return i.b !== runnableEntry.b;
            });
            runnableEntry.r();
            $parcel$global.pq();
        }
    };
}
parcelRegister("65Ltd", function(module, exports) {
    $parcel$export(module.exports, "ROUTE_GROUPS_SUPPORT_CENTER_SETTINGS", ()=>$d90d8ce15e0e3233$export$dda94bb6f1904d59);
    $parcel$export(module.exports, "ROUTE_GROUPS_ARCHIVE_ISSUES", ()=>$d90d8ce15e0e3233$export$1ba937db1fe6ef01);
    $parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$bbf08d4d25df5504);
    $parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_SOFTWARE", ()=>$d90d8ce15e0e3233$export$e3e759b7f50aaee1);
    $parcel$export(module.exports, "ROUTE_GROUPS_COMPONENTS", ()=>$d90d8ce15e0e3233$export$89337611b52bc9a3);
    $parcel$export(module.exports, "ROUTE_GROUPS_CONNECT", ()=>$d90d8ce15e0e3233$export$3d7937b12eb9e5d5);
    $parcel$export(module.exports, "ROUTE_GROUPS_CUSTOMER_SERVICE", ()=>$d90d8ce15e0e3233$export$b5f9c9cfeafb79a2);
    $parcel$export(module.exports, "ROUTE_GROUPS_DASHBOARD", ()=>$d90d8ce15e0e3233$export$7a3d181d86fce9e6);
    $parcel$export(module.exports, "ROUTE_GROUPS_DEVOPS", ()=>$d90d8ce15e0e3233$export$7a22726acd7d6021);
    $parcel$export(module.exports, "ROUTE_GROUPS_DIRECTORIES", ()=>$d90d8ce15e0e3233$export$f3f4a9f53ba00861);
    $parcel$export(module.exports, "ROUTE_GROUPS_EOC", ()=>$d90d8ce15e0e3233$export$112d69653b2f1d8b);
    $parcel$export(module.exports, "ROUTE_GROUPS_ERRORS", ()=>$d90d8ce15e0e3233$export$74e0426b66571086);
    $parcel$export(module.exports, "ROUTE_GROUPS_GLOBAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$c2e20e142c95c1ce);
    $parcel$export(module.exports, "ROUTE_GROUPS_HELP_CENTER_SETTINGS", ()=>$d90d8ce15e0e3233$export$f8cea29bebf098c);
    $parcel$export(module.exports, "ROUTE_GROUPS_HOME", ()=>$d90d8ce15e0e3233$export$5801ef8dfc9a2f70);
    $parcel$export(module.exports, "ROUTE_GROUPS_ISSUE", ()=>$d90d8ce15e0e3233$export$7246838143f848f3);
    $parcel$export(module.exports, "ROUTE_GROUPS_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$54f96702980a2f87);
    $parcel$export(module.exports, "ROUTE_GROUPS_LEGACY", ()=>$d90d8ce15e0e3233$export$5566db8fbd042fc4);
    $parcel$export(module.exports, "ROUTE_GROUPS_MARKETPLACE", ()=>$d90d8ce15e0e3233$export$656d0cc2c67b2708);
    $parcel$export(module.exports, "ROUTE_GROUPS_PEOPLE_PROFILES", ()=>$d90d8ce15e0e3233$export$bfdbcebc4c81b043);
    $parcel$export(module.exports, "ROUTE_GROUPS_PERSONAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$82021d71ad19e227);
    $parcel$export(module.exports, "ROUTE_GROUPS_PLAN_SETTINGS", ()=>$d90d8ce15e0e3233$export$6f266218a6973848);
    $parcel$export(module.exports, "ROUTE_GROUPS_POLARIS", ()=>$d90d8ce15e0e3233$export$a846fcaeeea8e0ff);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROFORMA", ()=>$d90d8ce15e0e3233$export$6c87a9dff4e7a2de);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC", ()=>$d90d8ce15e0e3233$export$ab79970dcfac06a1);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CORE", ()=>$d90d8ce15e0e3233$export$d1a70f80bb22f18a);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$bd925e9fcb6ce37f);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE", ()=>$d90d8ce15e0e3233$export$86509a1baabd62ee);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE_BOARDS", ()=>$d90d8ce15e0e3233$export$98823ed9eedfc756);
    $parcel$export(module.exports, "ROUTE_GROUPS_REDIRECTS", ()=>$d90d8ce15e0e3233$export$da8d13fe1ccd5c09);
    $parcel$export(module.exports, "ROUTE_GROUPS_SANDBOX", ()=>$d90d8ce15e0e3233$export$e46610825208f0d8);
    $parcel$export(module.exports, "ROUTE_GROUPS_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$78fb2f6176b7c6b8);
    $parcel$export(module.exports, "ROUTE_GROUPS_SOFTWARE", ()=>$d90d8ce15e0e3233$export$26efaec7a7a8b361);
    $parcel$export(module.exports, "ROUTE_NAMES_AGENT_STUDIO", ()=>$d90d8ce15e0e3233$export$89c26097a5edf8cb);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY", ()=>$d90d8ce15e0e3233$export$88041353cc69458d);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PLANS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$f88d57dcb03ba452);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$e8aa63af071c2da9);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK", ()=>$d90d8ce15e0e3233$export$b114d0da2ebcff6c);
    $parcel$export(module.exports, "ROUTE_NAMES_BOARDS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$29cc94b8cea5c920);
    $parcel$export(module.exports, "ROUTE_NAMES_BROWSE_PROJECT_REDIRECT", ()=>$d90d8ce15e0e3233$export$4d1b45005cdcfb39);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_BOARD", ()=>$d90d8ce15e0e3233$export$a42ea04fdf53eeaf);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_CLASSIC_REPORTS", ()=>$d90d8ce15e0e3233$export$ca4c5f5b3e2daa18);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_REPORTS", ()=>$d90d8ce15e0e3233$export$d58a5411a2ac6260);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED", ()=>$d90d8ce15e0e3233$export$24514ee19772b5af);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR", ()=>$d90d8ce15e0e3233$export$ec333dd1d6a8b38);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT", ()=>$d90d8ce15e0e3233$export$ed495fbad44791af);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY", ()=>$d90d8ce15e0e3233$export$5281552f8109b7c0);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE", ()=>$d90d8ce15e0e3233$export$6e8473713ed4557a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS", ()=>$d90d8ce15e0e3233$export$cbdd5c24d69b2cb1);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS", ()=>$d90d8ce15e0e3233$export$e7f012f402be01ea);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD", ()=>$d90d8ce15e0e3233$export$b34d3882b42d660d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED", ()=>$d90d8ce15e0e3233$export$ed869c60c6a56182);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR", ()=>$d90d8ce15e0e3233$export$5013269f29c75b37);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED", ()=>$d90d8ce15e0e3233$export$fc8b48319e993d43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM", ()=>$d90d8ce15e0e3233$export$d6e60a2059f028d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER", ()=>$d90d8ce15e0e3233$export$3d589aae17a00bc9);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT", ()=>$d90d8ce15e0e3233$export$bd92ef03b23dd672);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED", ()=>$d90d8ce15e0e3233$export$fa7fc44c718fc850);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST", ()=>$d90d8ce15e0e3233$export$1dffaf831e01e2b4);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED", ()=>$d90d8ce15e0e3233$export$5f8187412dd60f35);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING", ()=>$d90d8ce15e0e3233$export$3d2c1c04d18f6c43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT", ()=>$d90d8ce15e0e3233$export$cd22a5d8f560a1d8);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY", ()=>$d90d8ce15e0e3233$export$cad1b1aa5ce26bbc);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED", ()=>$d90d8ce15e0e3233$export$ee073463b4144367);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE", ()=>$d90d8ce15e0e3233$export$ea034943499772ea);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED", ()=>$d90d8ce15e0e3233$export$19bc888bcf37d22d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT", ()=>$d90d8ce15e0e3233$export$e0746183e11767fb);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CODE", ()=>$d90d8ce15e0e3233$export$3e2d215ce157adc8);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS", ()=>$d90d8ce15e0e3233$export$8a8485bb05daf40b);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$a2799b01de5bb62);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_FEATURES", ()=>$d90d8ce15e0e3233$export$2d4f89c4b1ee3640);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT", ()=>$d90d8ce15e0e3233$export$75609d3416c31f79);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$79793dc26e0b7b1a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_OPSGENIE", ()=>$d90d8ce15e0e3233$export$2eda7466fbfdef43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS", ()=>$d90d8ce15e0e3233$export$417297669917ee1a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$8c79f3309ac0737);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", ()=>$d90d8ce15e0e3233$export$ef71a22e7befd35c);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS", ()=>$d90d8ce15e0e3233$export$62ba1e294f5007c1);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS", ()=>$d90d8ce15e0e3233$export$a4315324546ecc89);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_TOOLCHAIN", ()=>$d90d8ce15e0e3233$export$a653cf6d478b3df1);
    $parcel$export(module.exports, "ROUTE_NAMES_COMPASS_PRODUCT_SETTINGS", ()=>$d90d8ce15e0e3233$export$b0f268fe53a03e98);
    $parcel$export(module.exports, "ROUTE_NAMES_CONFLUENCE_PRODUCT_SETTINGS", ()=>$d90d8ce15e0e3233$export$f4160b48e4ab8f39);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL", ()=>$d90d8ce15e0e3233$export$608f359cf8b08d2e);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_INVALID", ()=>$d90d8ce15e0e3233$export$8bfbf790fe89f8d3);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT", ()=>$d90d8ce15e0e3233$export$d7011d1ed949f970);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_PROJECT", ()=>$d90d8ce15e0e3233$export$bd2506db44585db6);
    $parcel$export(module.exports, "ROUTE_NAMES_CREATE_PROJECT", ()=>$d90d8ce15e0e3233$export$200fa5ad16f8c112);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD", ()=>$d90d8ce15e0e3233$export$a296bb962bea95b5);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$b9960c143c0414eb);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE", ()=>$d90d8ce15e0e3233$export$411171d2fcaefaea);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_EDIT", ()=>$d90d8ce15e0e3233$export$ee104ed514f63003);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_SELECTED", ()=>$d90d8ce15e0e3233$export$9233f9ddcecd3062);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW", ()=>$d90d8ce15e0e3233$export$b3240ec044a6c70f);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW_EMBED", ()=>$d90d8ce15e0e3233$export$2463c779e12367e3);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_WALLBOARD", ()=>$d90d8ce15e0e3233$export$dd3e5187eae2abe9);
    $parcel$export(module.exports, "ROUTE_NAMES_DEVOPS_CONNECTED_PROJECT", ()=>$d90d8ce15e0e3233$export$38ca7e07048a5bfd);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING", ()=>$d90d8ce15e0e3233$export$48749e87cc44a5a5);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_CREATE", ()=>$d90d8ce15e0e3233$export$21c230ef79df9e9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_DETAIL", ()=>$d90d8ce15e0e3233$export$d2d813dd057a8352);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_API_KEY_MANAGEMENT", ()=>$d90d8ce15e0e3233$export$54ed2374d14a7e88);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ASSIGN_CUSTOM_ROLES", ()=>$d90d8ce15e0e3233$export$58368fe796f5ecb4);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_AUTOMATIONS", ()=>$d90d8ce15e0e3233$export$bbb4032f8f259109);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_CUSTOM_ROLES", ()=>$d90d8ce15e0e3233$export$5b17b30c2dd69cf2);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERTS", ()=>$d90d8ce15e0e3233$export$d18d0b9a9e85e59c);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL", ()=>$d90d8ce15e0e3233$export$5126a481501fc518);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL", ()=>$d90d8ce15e0e3233$export$40e720d8c26e6804);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_MAINTENANCE", ()=>$d90d8ce15e0e3233$export$dc8ac1f7e9373a32);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORTS", ()=>$d90d8ce15e0e3233$export$8ca3e3f0326ba27f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD", ()=>$d90d8ce15e0e3233$export$c3d17be12795c864);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_HEARTBEATS", ()=>$d90d8ce15e0e3233$export$9cd1c70eda5cae15);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL", ()=>$d90d8ce15e0e3233$export$99f769b27f537a72);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL_DETAIL", ()=>$d90d8ce15e0e3233$export$5c5fe79d3f9ec214);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATIONS", ()=>$d90d8ce15e0e3233$export$901b974cf0954c88);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_CREATE", ()=>$d90d8ce15e0e3233$export$b2dd23a345bd5cb3);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_DETAIL", ()=>$d90d8ce15e0e3233$export$8ae7cbc0a73f9351);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LIST", ()=>$d90d8ce15e0e3233$export$8057ebe7fb7f7f8d);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LOG", ()=>$d90d8ce15e0e3233$export$a22387b9744e62e3);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_MAINTENANCE", ()=>$d90d8ce15e0e3233$export$f6fefa9d2e5bbda1);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL", ()=>$d90d8ce15e0e3233$export$e6de4aa6c719d2b);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL_REDIRECT", ()=>$d90d8ce15e0e3233$export$b195ada84b7e695f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW", ()=>$d90d8ce15e0e3233$export$1800d32171b754a6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS", ()=>$d90d8ce15e0e3233$export$d22a153bfcbaaaa0);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$a9a41c76994b6ae9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_POLICIES", ()=>$d90d8ce15e0e3233$export$5bd6f2569c3cfd5c);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS", ()=>$d90d8ce15e0e3233$export$dc70eff53ff26c70);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_TEAM", ()=>$d90d8ce15e0e3233$export$1fe2ca96b360df19);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE", ()=>$d90d8ce15e0e3233$export$1ff01e77517a80b0);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$de3f8f3198f8213a);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS_DETAIL", ()=>$d90d8ce15e0e3233$export$b2cb569d360db382);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_SCHEDULES", ()=>$d90d8ce15e0e3233$export$a0d9033eb64fd80f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ESCALATIONS", ()=>$d90d8ce15e0e3233$export$4c2fd998d73d2b83);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERTS", ()=>$d90d8ce15e0e3233$export$da985e953465731f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS", ()=>$d90d8ce15e0e3233$export$b7eee2afd0a5c6b9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING", ()=>$d90d8ce15e0e3233$export$9b6c84986db47d98);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE", ()=>$d90d8ce15e0e3233$export$89276f76fdd700d6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL", ()=>$d90d8ce15e0e3233$export$ea64769f19da8c95);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS", ()=>$d90d8ce15e0e3233$export$4a584839d9a9eb6f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD", ()=>$d90d8ce15e0e3233$export$27d27c817eeb97cc);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL", ()=>$d90d8ce15e0e3233$export$9f533c13cfb48a8f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATIONS", ()=>$d90d8ce15e0e3233$export$6889e571e5aa6ba6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE", ()=>$d90d8ce15e0e3233$export$bdd811277711c53d);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL", ()=>$d90d8ce15e0e3233$export$c7b51c0e8ad6f77a);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST", ()=>$d90d8ce15e0e3233$export$a348fc7f3b4cfe34);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG", ()=>$d90d8ce15e0e3233$export$a4eff769c94da831);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_POLICIES", ()=>$d90d8ce15e0e3233$export$7c928ca9c9822772);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_UNLOCK_OPERATIONS", ()=>$d90d8ce15e0e3233$export$b48311a8f24f4b63);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_WHO_IS_ON_CALL", ()=>$d90d8ce15e0e3233$export$20649eac204f7661);
    $parcel$export(module.exports, "ROUTE_NAMES_ERRORS_NOT_FOUND", ()=>$d90d8ce15e0e3233$export$62170875a111d729);
    $parcel$export(module.exports, "ROUTE_NAMES_EXTERNAL_IMPORT", ()=>$d90d8ce15e0e3233$export$2928f3d69e7ac609);
    $parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$259e18cafd820487);
    $parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY_SECURE", ()=>$d90d8ce15e0e3233$export$4b8f333757e638a4);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN", ()=>$d90d8ce15e0e3233$export$ac4f65a14002f892);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN_SETTINGS", ()=>$d90d8ce15e0e3233$export$c73ddc4b44ccb359);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$7ad826b482229119);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_GLOBAL", ()=>$d90d8ce15e0e3233$export$3df864df9b639033);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_PROJECT", ()=>$d90d8ce15e0e3233$export$7d67bf4077ebe18d);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_PERSONAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$d025408d02e64fb9);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE", ()=>$d90d8ce15e0e3233$export$5ff797dfd5df551f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG", ()=>$d90d8ce15e0e3233$export$8a66ba1da5efa2c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$eadf5aff28def565);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT", ()=>$d90d8ce15e0e3233$export$8f9c045e8fd449b7);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_MAIL_SETTINGS", ()=>$d90d8ce15e0e3233$export$1bf439327974644b);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR", ()=>$d90d8ce15e0e3233$export$e2a9d163770d0d46);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS", ()=>$d90d8ce15e0e3233$export$21b497c57bcd299a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$8d4d1f7df6e5d4e4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_CONFIGURE", ()=>$d90d8ce15e0e3233$export$df5ca261227a6052);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_DELETE", ()=>$d90d8ce15e0e3233$export$9f2f4303259b8508);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_EDIT", ()=>$d90d8ce15e0e3233$export$7fd53fe07eecc273);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_MANAGE", ()=>$d90d8ce15e0e3233$export$c8e9ba2b5bc9dab2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_TRANSLATE", ()=>$d90d8ce15e0e3233$export$e05a6c9e9b9b0c48);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST", ()=>$d90d8ce15e0e3233$export$f9759b206b651b1f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES", ()=>$d90d8ce15e0e3233$export$7a337a2687b5d5e3);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS", ()=>$d90d8ce15e0e3233$export$a41998c1a3572e41);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_CONFIGURE", ()=>$d90d8ce15e0e3233$export$2c9fe9e6005a9c36);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_COPY", ()=>$d90d8ce15e0e3233$export$5d8d82ff1de3586e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES", ()=>$d90d8ce15e0e3233$export$8a0ed100d885c17c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_CONFIGURE", ()=>$d90d8ce15e0e3233$export$1c7041445acf79e8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_COPY", ()=>$d90d8ce15e0e3233$export$e4712523d95125f6);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$7401274ad357ff94);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$6984b21077857555);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT_ENTRY", ()=>$d90d8ce15e0e3233$export$5a2dae98f768aedf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_VIEW", ()=>$d90d8ce15e0e3233$export$5eef1c6eb1388ac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS", ()=>$d90d8ce15e0e3233$export$69bcf2c26d45e030);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_GLOBAL_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$ba1417cf5de80f81);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES", ()=>$d90d8ce15e0e3233$export$fdcfcb2e2eb16afd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_ACTIVATE", ()=>$d90d8ce15e0e3233$export$5d3e6bffd6b5abfe);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DEACTIVATE", ()=>$d90d8ce15e0e3233$export$5c676bbb7e3aae9e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DELETE", ()=>$d90d8ce15e0e3233$export$8bb013ced097489a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_EDIT", ()=>$d90d8ce15e0e3233$export$e384ae6a87fadedd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH", ()=>$d90d8ce15e0e3233$export$8f55a911c4bd95bf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_VIEW", ()=>$d90d8ce15e0e3233$export$d7b98892cb31fba5);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_ADD", ()=>$d90d8ce15e0e3233$export$8be4b203f526b2cd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_DELETE", ()=>$d90d8ce15e0e3233$export$df09947903c514c4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_EDIT", ()=>$d90d8ce15e0e3233$export$cf4a57a81e0bfbca);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_ADD", ()=>$d90d8ce15e0e3233$export$bc64365bbb09c05e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_DELETE", ()=>$d90d8ce15e0e3233$export$5b12571311ebe766);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_EDIT", ()=>$d90d8ce15e0e3233$export$56dc46fe1de63994);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW", ()=>$d90d8ce15e0e3233$export$65af0e5a36d4b4e9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES", ()=>$d90d8ce15e0e3233$export$dec448f9d2e50c90);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_ADD", ()=>$d90d8ce15e0e3233$export$9ff4144e1dcf9fa4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$8aab6fb9a62dda95);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$9f804a2650117f51);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES", ()=>$d90d8ce15e0e3233$export$7dd4b916600f670);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_DELETE", ()=>$d90d8ce15e0e3233$export$c1b40a8a70c0aafa);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_EDIT", ()=>$d90d8ce15e0e3233$export$ff10d812380db045);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_TRANSLATE", ()=>$d90d8ce15e0e3233$export$8deeffdf8dfed878);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES", ()=>$d90d8ce15e0e3233$export$561687f2fa9b9cc9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS", ()=>$d90d8ce15e0e3233$export$691d30818c14141c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DEFAULT", ()=>$d90d8ce15e0e3233$export$8fa58495105f8fb0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DELETE", ()=>$d90d8ce15e0e3233$export$8304c57494d82ffd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_EDIT", ()=>$d90d8ce15e0e3233$export$353609deec72a2ba);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_TRANSLATE", ()=>$d90d8ce15e0e3233$export$1cb56e4c132ac8fd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_EDIT", ()=>$d90d8ce15e0e3233$export$5fe3eec0a6bda09);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_ADD", ()=>$d90d8ce15e0e3233$export$12b56880d6fb7ac7);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_DELETE", ()=>$d90d8ce15e0e3233$export$9986e8be82998857);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_EDIT", ()=>$d90d8ce15e0e3233$export$3280ec16231916af);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES", ()=>$d90d8ce15e0e3233$export$54885d105d1e2b37);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_ADD", ()=>$d90d8ce15e0e3233$export$f34d87c870f3bf43);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$4108ebf71e36e461);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$d42ec33a6e69686e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES", ()=>$d90d8ce15e0e3233$export$8d2cfabd01e2feaa);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES_TRANSLATE", ()=>$d90d8ce15e0e3233$export$d0fe3726dffeca80);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE", ()=>$d90d8ce15e0e3233$export$b4aa4b2b8fb7267a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE_EDIT", ()=>$d90d8ce15e0e3233$export$3743711165f5dd4f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES", ()=>$d90d8ce15e0e3233$export$5df6f81deab9567c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_ADD", ()=>$d90d8ce15e0e3233$export$b3db2a2ee8a9a8e4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_CONFIGURE", ()=>$d90d8ce15e0e3233$export$d5fc8cd4b3fd2b84);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_COPY", ()=>$d90d8ce15e0e3233$export$a03360d8b616ef34);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$336e54edc189df7f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$53572e9a81205523);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT_ITEM", ()=>$d90d8ce15e0e3233$export$b71f2ef452117a2a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS", ()=>$d90d8ce15e0e3233$export$f79745fee583cd62);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_COPY", ()=>$d90d8ce15e0e3233$export$2281663e19f399c1);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_DELETE", ()=>$d90d8ce15e0e3233$export$38c52d8c5e5dad29);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_EDIT", ()=>$d90d8ce15e0e3233$export$10babc3f11b4e6e2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY", ()=>$d90d8ce15e0e3233$export$adf2f51c41b4e22a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT", ()=>$d90d8ce15e0e3233$export$11b217754d4c7d24);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS", ()=>$d90d8ce15e0e3233$export$3414f0d81f1c11d);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_DISABLE", ()=>$d90d8ce15e0e3233$export$5574c73a9a5878ca);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_EDIT", ()=>$d90d8ce15e0e3233$export$cb2626c385b72992);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_TRANSLATE", ()=>$d90d8ce15e0e3233$export$fa7aa7cabc3ec459);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TIME_TRACKING", ()=>$d90d8ce15e0e3233$export$8b0450672651ef67);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$ef510a15f840e437);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_DELETE", ()=>$d90d8ce15e0e3233$export$bc159fa4984a907f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_EDIT", ()=>$d90d8ce15e0e3233$export$47bfbce13af95d24);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES", ()=>$d90d8ce15e0e3233$export$c8cb78e94cd3f83c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ADD_OR_COPY", ()=>$d90d8ce15e0e3233$export$4496279df22177be);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$afdfef5d17c56988);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$ac9b4b1136300033);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES", ()=>$d90d8ce15e0e3233$export$4aa31dc2a6d4f2ee);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_CONFIGURE", ()=>$d90d8ce15e0e3233$export$c56f5509b93eba68);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_COPY", ()=>$d90d8ce15e0e3233$export$dd9462e97e11637a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$11f8c53e10f63cfb);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$758ad3ad6916c9f6);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_ENTITY", ()=>$d90d8ce15e0e3233$export$9d65a754315eb617);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_TRANSLATE", ()=>$d90d8ce15e0e3233$export$564b665f6ca740dd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW", ()=>$d90d8ce15e0e3233$export$256fc89c38c1b9e9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT", ()=>$d90d8ce15e0e3233$export$ddeae77164bfac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES", ()=>$d90d8ce15e0e3233$export$fa2b355372963545);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$45511e437e54fa02);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION", ()=>$d90d8ce15e0e3233$export$ad76895f03f27a7c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION_META_ATTRIBUTES", ()=>$d90d8ce15e0e3233$export$1c291d65a59b1636);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD", ()=>$d90d8ce15e0e3233$export$d9bb14d665bfeea5);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE", ()=>$d90d8ce15e0e3233$export$8b44cb3da7b8f857);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME", ()=>$d90d8ce15e0e3233$export$9ca6a09e1518d3bb);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD", ()=>$d90d8ce15e0e3233$export$4c211b3188348679);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE", ()=>$d90d8ce15e0e3233$export$24757bb1837e33af);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL", ()=>$d90d8ce15e0e3233$export$95b5d0bd29a3a076);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW", ()=>$d90d8ce15e0e3233$export$d55d4330b58683da);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP", ()=>$d90d8ce15e0e3233$export$f4d5833f0b40a26b);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR", ()=>$d90d8ce15e0e3233$export$c78577545f514ca8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERMISSION_SCHEMES", ()=>$d90d8ce15e0e3233$export$253eb3db7152d010);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_APPLICATION_LINKS", ()=>$d90d8ce15e0e3233$export$16b4392a63a3eacf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_DVCS", ()=>$d90d8ce15e0e3233$export$b2d5a7bc804ed9c9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_SDMAIL", ()=>$d90d8ce15e0e3233$export$f870832f94ca5009);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_STATUS_PAGE", ()=>$d90d8ce15e0e3233$export$8b3a1b2e8e954dc2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_DELETE", ()=>$d90d8ce15e0e3233$export$15603150075c3d64);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_EDIT", ()=>$d90d8ce15e0e3233$export$92536fe760c41862);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_VIEW", ()=>$d90d8ce15e0e3233$export$3f4d05032349dae0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SHARED_DASHBOARDS", ()=>$d90d8ce15e0e3233$export$8ff94a2e5f98315f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_NOTIFICATION_HELPER", ()=>$d90d8ce15e0e3233$export$c906c6946fef5d99);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_PERMISSION_HELPER", ()=>$d90d8ce15e0e3233$export$a1916b723e186494);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_ATTACHMENTS", ()=>$d90d8ce15e0e3233$export$5070b4c974017f28);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS", ()=>$d90d8ce15e0e3233$export$bee7f9f93cb74124);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_ADD", ()=>$d90d8ce15e0e3233$export$efe4008073ab3b69);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_DELETE", ()=>$d90d8ce15e0e3233$export$9e40228f1c62d4d9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_EDIT", ()=>$d90d8ce15e0e3233$export$223f8094878fea34);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_LEXORANK_MANAGEMENT", ()=>$d90d8ce15e0e3233$export$2f589c572415c043);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_SERVICES", ()=>$d90d8ce15e0e3233$export$8cc394a1f5ca4ac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_WEBHOOKS", ()=>$d90d8ce15e0e3233$export$a11311cd333dae90);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_BULK_MAIL", ()=>$d90d8ce15e0e3233$export$2b2f159267202dcc);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_ADVANCED_SETTINGS", ()=>$d90d8ce15e0e3233$export$c5a6874288d2e609);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_EDIT_SETTINGS", ()=>$d90d8ce15e0e3233$export$55dd30b027c838fe);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GLOBAL_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$aee9c7dbf672403c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_BACKUP_MANAGER", ()=>$d90d8ce15e0e3233$export$75f2fbd33e76028e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_CLOUD_OR_SERVER_IMPORT", ()=>$d90d8ce15e0e3233$export$ca57c3dfefb2c826);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT", ()=>$d90d8ce15e0e3233$export$8f2e6f133c022a59);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_CSV", ()=>$d90d8ce15e0e3233$export$bcd741cf5a35ece8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_JSON", ()=>$d90d8ce15e0e3233$export$bfd8ab4625d5c275);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_TRELLO", ()=>$d90d8ce15e0e3233$export$750a33c4058af733);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ISSUE_COLLECTORS", ()=>$d90d8ce15e0e3233$export$1b66c7594340363f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_DELETE_MAIL_HANDLER", ()=>$d90d8ce15e0e3233$export$fe2fa966509db649);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_INCOMING_MAIL", ()=>$d90d8ce15e0e3233$export$373b97e8d136f558);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_OUTGOING_MAIL", ()=>$d90d8ce15e0e3233$export$64909bb6f2181592);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_SEND_MAIL", ()=>$d90d8ce15e0e3233$export$53d6ade2eaa2ae84);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_GLOBAL_PERMISSIONS_OLD", ()=>$d90d8ce15e0e3233$export$e49d7a1ddf301d09);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES", ()=>$d90d8ce15e0e3233$export$9469cfde1d14fcac);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS", ()=>$d90d8ce15e0e3233$export$be2e231547dca6dd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_GROUPS", ()=>$d90d8ce15e0e3233$export$ad6f28bbfe57d0a0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_USERS", ()=>$d90d8ce15e0e3233$export$2fb73d5c1c0e7186);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_DELETE", ()=>$d90d8ce15e0e3233$export$46b4f43d6ece38fc);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_EDIT", ()=>$d90d8ce15e0e3233$export$49d1c20d84d46735);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_USAGE", ()=>$d90d8ce15e0e3233$export$265062715b11a1ef);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SHARED_FILTERS", ()=>$d90d8ce15e0e3233$export$e9f5eae9444c9b46);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_TROUBLESHOOTING_AUDIT_LOG", ()=>$d90d8ce15e0e3233$export$e19bf9459d6eba56);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER", ()=>$d90d8ce15e0e3233$export$40097704c31872d8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_DASHBOARD_EDIT", ()=>$d90d8ce15e0e3233$export$dcdf0405aa7e2078);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_LOOK_AND_FEEL", ()=>$d90d8ce15e0e3233$export$fb75113636566d39);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_PREFERENCES_APPLY", ()=>$d90d8ce15e0e3233$export$e27baa0c7747e67f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_USER_DEFAULTS", ()=>$d90d8ce15e0e3233$export$40d189100899f572);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SERVICE_HUBS", ()=>$d90d8ce15e0e3233$export$f9ccf81fdbc46591);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS", ()=>$d90d8ce15e0e3233$export$341933b279728599);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$ae4b815061537207);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_ACCESS", ()=>$d90d8ce15e0e3233$export$e4fb7ce0fc5e3a75);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_EMAIL", ()=>$d90d8ce15e0e3233$export$5cd0dd5a6be6aa2b);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_KNOWLEDGE_BASE", ()=>$d90d8ce15e0e3233$export$bee46016693b19dc);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_FORMS", ()=>$d90d8ce15e0e3233$export$ca253bc3d237c17f);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_FORM_EDIT", ()=>$d90d8ce15e0e3233$export$a4cba48257cb118a);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_WEB_PORTAL", ()=>$d90d8ce15e0e3233$export$2e90ab5aa3463c0d);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$c39a25878c902e0a);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPE_FIELDS", ()=>$d90d8ce15e0e3233$export$6eaa6ce8101f6468);
    $parcel$export(module.exports, "ROUTE_NAMES_HOME_ONBOARDING_REDIRECT", ()=>$d90d8ce15e0e3233$export$d70320ae3b4d9e43);
    $parcel$export(module.exports, "ROUTE_NAMES_HOME_REDIRECT", ()=>$d90d8ce15e0e3233$export$b2b57cde1fa39bf5);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE", ()=>$d90d8ce15e0e3233$export$e8e3b3a04b70a016);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE_CREATE_EMBED", ()=>$d90d8ce15e0e3233$export$1a3116351e4f3550);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE_EMBED", ()=>$d90d8ce15e0e3233$export$6e2629d41c380b47);
    $parcel$export(module.exports, "ROUTE_NAMES_JIRA_SEARCH", ()=>$d90d8ce15e0e3233$export$ced38e55e6d33a4e);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES", ()=>$d90d8ce15e0e3233$export$d61d16755cb40ff3);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR", ()=>$d90d8ce15e0e3233$export$bb6392f1b2e80781);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY", ()=>$d90d8ce15e0e3233$export$6fd25e722e91a0d8);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES", ()=>$d90d8ce15e0e3233$export$18f32f825e7a5a6f);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES", ()=>$d90d8ce15e0e3233$export$b17f22f274f4cd5e);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE", ()=>$d90d8ce15e0e3233$export$285854ec33f7cc);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY", ()=>$d90d8ce15e0e3233$export$77cf9c44bbdaa05b);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE", ()=>$d90d8ce15e0e3233$export$d6f1b92110a16f2a);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS", ()=>$d90d8ce15e0e3233$export$fea47b97c6086336);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS", ()=>$d90d8ce15e0e3233$export$264d0a2b60d052cd);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_LANDING", ()=>$d90d8ce15e0e3233$export$991ba0c465b48539);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH", ()=>$d90d8ce15e0e3233$export$904b472d57dee40d);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH_ARTICLES", ()=>$d90d8ce15e0e3233$export$bbe98dfa7f6a1e4a);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SETUP", ()=>$d90d8ce15e0e3233$export$8cfdaccf43a32440);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_ALL_REPORTS", ()=>$d90d8ce15e0e3233$export$37bd400c00057d64);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BACKLOG", ()=>$d90d8ce15e0e3233$export$eb66bd587b5f093d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BOARD", ()=>$d90d8ce15e0e3233$export$521baa72494c2a67);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_GENERAL", ()=>$d90d8ce15e0e3233$export$ca255c93be51d5bc);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_PROJECT", ()=>$d90d8ce15e0e3233$export$51e45f736a60769b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CUSTOM_REPORT", ()=>$d90d8ce15e0e3233$export$e64c3c8f45d7eb28);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_FALLBACK", ()=>$d90d8ce15e0e3233$export$5475ba822739444a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN", ()=>$d90d8ce15e0e3233$export$8483f5c57513e386);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_ISSUE", ()=>$d90d8ce15e0e3233$export$93c4d1960660bdb3);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_QUICKSEARCH", ()=>$d90d8ce15e0e3233$export$a5421dcc88027406);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS", ()=>$d90d8ce15e0e3233$export$81d5ef2e5cb06446);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_CUSTOMERS", ()=>$d90d8ce15e0e3233$export$77f5621cd10b53c5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_GETTING_STARTED", ()=>$d90d8ce15e0e3233$export$41008c2b014795bf);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_JIRA_AUTOMATION", ()=>$d90d8ce15e0e3233$export$3001841111579cf2);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_KNOWLEDGE", ()=>$d90d8ce15e0e3233$export$28dc2fac9c08502e);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES", ()=>$d90d8ce15e0e3233$export$4487dfcd6dce7088);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES_MANAGE", ()=>$d90d8ce15e0e3233$export$c344587fa7092e8c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS", ()=>$d90d8ce15e0e3233$export$3fbd487079a23c0f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS_CUSTOM", ()=>$d90d8ce15e0e3233$export$d6822df31c37b21a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_FALLBACK", ()=>$d90d8ce15e0e3233$export$d39bcac6fced7707);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE", ()=>$d90d8ce15e0e3233$export$da975f212e8a3e43);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE_PAGES", ()=>$d90d8ce15e0e3233$export$6e6feddeb62a0825);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_WIDGETS", ()=>$d90d8ce15e0e3233$export$d7df906c2ffbeab4);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PIN", ()=>$d90d8ce15e0e3233$export$c71836085985a7d3);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES", ()=>$d90d8ce15e0e3233$export$a17a19a9de903839);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_BAMBOO", ()=>$d90d8ce15e0e3233$export$e66c1e847a52ebb5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE", ()=>$d90d8ce15e0e3233$export$f0254c80025ed0fc);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG", ()=>$d90d8ce15e0e3233$export$1d4a64220d5b474d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS", ()=>$d90d8ce15e0e3233$export$8af215d394bc18c1);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_ADD", ()=>$d90d8ce15e0e3233$export$b6b536a795b08b39);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_HELP", ()=>$d90d8ce15e0e3233$export$59cde094247fca1a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_VIEW", ()=>$d90d8ce15e0e3233$export$d27bf19e22921164);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG", ()=>$d90d8ce15e0e3233$export$3467807847c0a87d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$1996eeee6a067f1c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DELETE", ()=>$d90d8ce15e0e3233$export$ec7cb9394e8994c9);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV", ()=>$d90d8ce15e0e3233$export$f01730982626c4af);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT", ()=>$d90d8ce15e0e3233$export$9d1758ddc1563e90);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS", ()=>$d90d8ce15e0e3233$export$ecff223feb9d08be);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$487bc26cddb34312);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT", ()=>$d90d8ce15e0e3233$export$118290072826cd87);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY", ()=>$d90d8ce15e0e3233$export$e5994b7b1acebe82);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$84b0e53f785e02cf);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$d58992a667105ce8);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$bb1cea2d23743f65);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$76dac5f55ab3705e);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$a7c4adb03bc6e997);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE", ()=>$d90d8ce15e0e3233$export$2dc565d0b2334780);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE", ()=>$d90d8ce15e0e3233$export$28687a1181a7676f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$2e74a7026073fa54);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$58fdfc78d176c564);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS", ()=>$d90d8ce15e0e3233$export$cb8548f16119b181);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$66e3f6af203a567f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY", ()=>$d90d8ce15e0e3233$export$658e7e21f1c7b69b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS", ()=>$d90d8ce15e0e3233$export$1fa628a4527d424c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$c2989c5c00f9f64b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REDIRECT", ()=>$d90d8ce15e0e3233$export$2d21e5416485b195);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE", ()=>$d90d8ce15e0e3233$export$e514491aa85dd54a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CONFIG", ()=>$d90d8ce15e0e3233$export$d9662297242bfcb5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED", ()=>$d90d8ce15e0e3233$export$2a53516b15393945);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD", ()=>$d90d8ce15e0e3233$export$62e00190aa938a43);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_PIE", ()=>$d90d8ce15e0e3233$export$22a3924a6eab79ab);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED", ()=>$d90d8ce15e0e3233$export$677cf3d89d18bb74);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME", ()=>$d90d8ce15e0e3233$export$7eef86163449ad98);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY", ()=>$d90d8ce15e0e3233$export$8f56061e1403fa5a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE", ()=>$d90d8ce15e0e3233$export$adeb429de8df1e02);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT", ()=>$d90d8ce15e0e3233$export$931d6222073b5708);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD", ()=>$d90d8ce15e0e3233$export$2106f1ac8ba807e1);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE", ()=>$d90d8ce15e0e3233$export$36678521a86f620b);
    $parcel$export(module.exports, "ROUTE_NAMES_LOGIN_EMBED", ()=>$d90d8ce15e0e3233$export$55248356780fc584);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE", ()=>$d90d8ce15e0e3233$export$cd84c5a333c8d16a);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE_PUBLIC", ()=>$d90d8ce15e0e3233$export$624af6f61b05f55);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_APP_REQUESTS", ()=>$d90d8ce15e0e3233$export$2ed9525182145b82);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_INDEX", ()=>$d90d8ce15e0e3233$export$7fb2b42fc4e7df8b);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_MANAGE_APPS", ()=>$d90d8ce15e0e3233$export$fa962db82ae571b2);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_PROMOTIONS", ()=>$d90d8ce15e0e3233$export$e145bf76b1aef705);
    $parcel$export(module.exports, "ROUTE_NAMES_NOTIFICATION_LOGS", ()=>$d90d8ce15e0e3233$export$8febbfb647e4c8b9);
    $parcel$export(module.exports, "ROUTE_NAMES_OPSGENIE_SCHEDULE", ()=>$d90d8ce15e0e3233$export$4b34f3d336f4ccd2);
    $parcel$export(module.exports, "ROUTE_NAMES_PEOPLE_INDEX", ()=>$d90d8ce15e0e3233$export$a979a5c1f5e3631c);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$ffcbf91dfadffd0);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL", ()=>$d90d8ce15e0e3233$export$1807a39cc63b856c);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$2be8d3c6fedd5276);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$6268da7263eb670d);
    $parcel$export(module.exports, "ROUTE_NAMES_PLANS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$93bd4a896a0fc581);
    $parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_EDIT", ()=>$d90d8ce15e0e3233$export$2b9b1bfb538ab810);
    $parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_LIST", ()=>$d90d8ce15e0e3233$export$d1217085321b2648);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_COLLECTIONS", ()=>$d90d8ce15e0e3233$export$39624171b7c8a10a);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_IDEAS", ()=>$d90d8ce15e0e3233$export$1654cd6813e90e6b);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_INSIGHTS", ()=>$d90d8ce15e0e3233$export$33059cd02df2febd);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ONBOARDING", ()=>$d90d8ce15e0e3233$export$1d746ff2bc48ceb4);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_PLAYS", ()=>$d90d8ce15e0e3233$export$145c578104a45fd2);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ROOMS", ()=>$d90d8ce15e0e3233$export$a51df1bc877c58e5);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_ACCESS", ()=>$d90d8ce15e0e3233$export$45208fff8de46880);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_GLOBAL_FIELDS", ()=>$d90d8ce15e0e3233$export$c710a35d40378fa5);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_UNLICENSED", ()=>$d90d8ce15e0e3233$export$15d6b93ff5273ce3);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_AUTHENTICATION_SETTINGS", ()=>$d90d8ce15e0e3233$export$e26f2863c7ccd504);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS", ()=>$d90d8ce15e0e3233$export$496da9aa0fe819ff);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_COMPLIANCE", ()=>$d90d8ce15e0e3233$export$f7bbc23b5f8e2d3b);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$53ce69fb34f6d286);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CUSTOMER_ACCESS", ()=>$d90d8ce15e0e3233$export$b6e861786143eb1b);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_EMAIL_REQUESTS", ()=>$d90d8ce15e0e3233$export$f7e3d3b413c017e1);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_FEATURE_USAGE", ()=>$d90d8ce15e0e3233$export$b84d34b8175abde5);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS", ()=>$d90d8ce15e0e3233$export$50e4e3e5231fb74f);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS", ()=>$d90d8ce15e0e3233$export$39d913ae557ba8f3);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_KB_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$a2d9bcceac584c93);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS", ()=>$d90d8ce15e0e3233$export$eb2e5f1608ec8b32);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$9ac90b948c53bf58);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_STORAGE_MANAGEMENT", ()=>$d90d8ce15e0e3233$export$bb5665894498893f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT", ()=>$d90d8ce15e0e3233$export$dd4c319b26f01664);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$a934caa57ac0ac0b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$25a4e6c77f91c259);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SOFTWARE", ()=>$d90d8ce15e0e3233$export$2a9a9bab313fd713);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$82ad2da638fc34d8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$ff67cffdbd881a41);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SOFTWARE", ()=>$d90d8ce15e0e3233$export$c41c7d73df3fc08c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL", ()=>$d90d8ce15e0e3233$export$f07fd5696f888ae);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$ff1365ce4d652337);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA", ()=>$d90d8ce15e0e3233$export$79b30013cbfdee04);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE", ()=>$d90d8ce15e0e3233$export$33c2dcc7c7abc45e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_REDIRECT", ()=>$d90d8ce15e0e3233$export$a6ef20aa08a533b1);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_COMPONENTS", ()=>$d90d8ce15e0e3233$export$5908e15483da8a45);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_DIRECTORY_REDIRECT", ()=>$d90d8ce15e0e3233$export$a3812f6f4e60d897);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$3c8c119f40a061a9);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC", ()=>$d90d8ce15e0e3233$export$47e034646abefdb2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE", ()=>$d90d8ce15e0e3233$export$f36f4cf8b17f250f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_NOT_FOUND", ()=>$d90d8ce15e0e3233$export$841e880a0d425b3e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_PAGES", ()=>$d90d8ce15e0e3233$export$1fde4a6e7df24a97);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION", ()=>$d90d8ce15e0e3233$export$69335bf8b709edc7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS", ()=>$d90d8ce15e0e3233$export$946b472f7559a889);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS", ()=>$d90d8ce15e0e3233$export$373fdf6888021ed0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS_REDIRECT", ()=>$d90d8ce15e0e3233$export$d6a5f13a3d30923c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPROVALS", ()=>$d90d8ce15e0e3233$export$adfff93b0b015409);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS", ()=>$d90d8ce15e0e3233$export$404de4ddea701cff);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS_FIELDS", ()=>$d90d8ce15e0e3233$export$596e1f6f6f4997b2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION", ()=>$d90d8ce15e0e3233$export$8da0e4cdbdd0cd0b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$d610a17dff3a01fa);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT", ()=>$d90d8ce15e0e3233$export$284db5107f3db516);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS", ()=>$d90d8ce15e0e3233$export$fbce46826eefc586);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FIELDS", ()=>$d90d8ce15e0e3233$export$c86b29c76317ac6f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS", ()=>$d90d8ce15e0e3233$export$3160b86e1b5dc391);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$690c0080c930fca);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW", ()=>$d90d8ce15e0e3233$export$171ba8c33c05c4ef);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$e2f2c23286c3255c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS_ISSUE_LOGS", ()=>$d90d8ce15e0e3233$export$5a262d40e10207a1);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$ab790cb87175797e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER", ()=>$d90d8ce15e0e3233$export$db780b39656c673a);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS", ()=>$d90d8ce15e0e3233$export$a77cb4dafc511d3);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS", ()=>$d90d8ce15e0e3233$export$253fd82874264ee4);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS_NEXTGEN", ()=>$d90d8ce15e0e3233$export$eaf9ab4ec0c25813);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_APPS_FIELDS", ()=>$d90d8ce15e0e3233$export$574bcdf6b73fcf1f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT", ()=>$d90d8ce15e0e3233$export$a14853dfff8da872);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$ba8fd0e6db8d3e08);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$1c74da1e52e6d212);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS", ()=>$d90d8ce15e0e3233$export$d416059b17fe7d4e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS", ()=>$d90d8ce15e0e3233$export$d5a3a037d2760bb7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN", ()=>$d90d8ce15e0e3233$export$eb187d42a7448d45);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS", ()=>$d90d8ce15e0e3233$export$688de32d31fc70f5);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS", ()=>$d90d8ce15e0e3233$export$13d770f8814d480a);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$3a628f9376166ffb);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES_FIELDS", ()=>$d90d8ce15e0e3233$export$649dafa225625f30);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$dbfe76dd37018b2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$20db7bb9d1bd8b38);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$a1fa8e6e125780ae);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$fc6b949fd2bc782d);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$c940f866ac7760a0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES_FIELDS", ()=>$d90d8ce15e0e3233$export$184d4979f6f9fe7e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$959f50de166cc45e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES_FIELDS", ()=>$d90d8ce15e0e3233$export$b13b8c8bb4e30a75);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS", ()=>$d90d8ce15e0e3233$export$40d6fc2b9a4f09d2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_APPS_FIELDS", ()=>$d90d8ce15e0e3233$export$cc1af211e3feda50);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_AUTOMATION", ()=>$d90d8ce15e0e3233$export$3873539001f5aed7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD", ()=>$d90d8ce15e0e3233$export$89fcbafce559080b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM", ()=>$d90d8ce15e0e3233$export$c3f05da9e4e13249);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS", ()=>$d90d8ce15e0e3233$export$619694ab37142384);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_DETAILS", ()=>$d90d8ce15e0e3233$export$cb89b516b9cf418b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_FEATURES", ()=>$d90d8ce15e0e3233$export$50680f54e95bb859);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_INSIGHTS", ()=>$d90d8ce15e0e3233$export$194c2b4da7e38757);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT", ()=>$d90d8ce15e0e3233$export$962d838817f090f8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP", ()=>$d90d8ce15e0e3233$export$eacbdb340a470309);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_SWIMLANES", ()=>$d90d8ce15e0e3233$export$6a7782d87a21425d);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE", ()=>$d90d8ce15e0e3233$export$c2f56336162e799e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$ba419378ad70624e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DETAILS", ()=>$d90d8ce15e0e3233$export$62f38c589a73d386);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FIELDS", ()=>$d90d8ce15e0e3233$export$77c8066c0822f152);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FEATURES", ()=>$d90d8ce15e0e3233$export$90900ebfa6f48861);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$93ff02c205edd1a8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$db7f5d93be70ee30);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", ()=>$d90d8ce15e0e3233$export$432229516b7f82da);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$8f554d4ef9f084c0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_OPSGENIE", ()=>$d90d8ce15e0e3233$export$6b2b99b0055772a3);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_TOOLCHAIN", ()=>$d90d8ce15e0e3233$export$83c7a51057be6264);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS", ()=>$d90d8ce15e0e3233$export$46706d786aab3829);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_VERSIONS", ()=>$d90d8ce15e0e3233$export$b690025ef7e3cf6c);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD", ()=>$d90d8ce15e0e3233$export$ea48cc6bf1183d11);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG", ()=>$d90d8ce15e0e3233$export$930e4881302bbd54);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED", ()=>$d90d8ce15e0e3233$export$375801b708576466);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD", ()=>$d90d8ce15e0e3233$export$5b1e8463bd590143);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED", ()=>$d90d8ce15e0e3233$export$1606662a398a24be);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT", ()=>$d90d8ce15e0e3233$export$c5b19a37e49ceb28);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_REPORT", ()=>$d90d8ce15e0e3233$export$c46680afe70295f3);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_UIF_BACKLOG", ()=>$d90d8ce15e0e3233$export$831fc7eba98b58c9);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG", ()=>$d90d8ce15e0e3233$export$4061c0c586f3b7c8);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BOARD", ()=>$d90d8ce15e0e3233$export$99e0abd8ba1de289);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_REPORT", ()=>$d90d8ce15e0e3233$export$cd96a6a0cc4831ab);
    $parcel$export(module.exports, "ROUTE_NAMES_ROVO_DEMAND_TESTS", ()=>$d90d8ce15e0e3233$export$36e61e70347174cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SANDBOX_BUNDLER", ()=>$d90d8ce15e0e3233$export$3bddd65f2541c4d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS", ()=>$d90d8ce15e0e3233$export$db1b3d2fee80859);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY", ()=>$d90d8ce15e0e3233$export$b0f3f3214ab1b150);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_BOARDS", ()=>$d90d8ce15e0e3233$export$fb4e3ee7e7c21e9f);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CALENDAR", ()=>$d90d8ce15e0e3233$export$8c8f03e75b6708ac);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR", ()=>$d90d8ce15e0e3233$export$3c3d8caf61c9aa0c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS", ()=>$d90d8ce15e0e3233$export$f9cc808094ce0ddd);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE", ()=>$d90d8ce15e0e3233$export$9bde4a0b155f2972);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT", ()=>$d90d8ce15e0e3233$export$a52f5ffbbe135078);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA", ()=>$d90d8ce15e0e3233$export$e6773bf0fbccdb9c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$8e3dd8487a7b65bd);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$258b44fcc29a5961);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS", ()=>$d90d8ce15e0e3233$export$ea1146ebce07be6d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT", ()=>$d90d8ce15e0e3233$export$53731240ce2d3b76);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE", ()=>$d90d8ce15e0e3233$export$956eb40834ddee22);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT", ()=>$d90d8ce15e0e3233$export$9057470ebf41169);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME", ()=>$d90d8ce15e0e3233$export$c42e107c5275b36);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE", ()=>$d90d8ce15e0e3233$export$3e7c6a54a9d2267a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE", ()=>$d90d8ce15e0e3233$export$c3e2697b35a149c4);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT", ()=>$d90d8ce15e0e3233$export$288c7dd61dd0c291);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA", ()=>$d90d8ce15e0e3233$export$37161a981d69c891);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$cfe61aa92a4d585d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$9ed512ab4c81669c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT", ()=>$d90d8ce15e0e3233$export$37a9bdd8513f462d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT", ()=>$d90d8ce15e0e3233$export$f01162415f3a2ee3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2", ()=>$d90d8ce15e0e3233$export$860dd13b1e836ed8);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS", ()=>$d90d8ce15e0e3233$export$5eaf1dce55090ff3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS", ()=>$d90d8ce15e0e3233$export$1fe309e7cdbd1c1);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS", ()=>$d90d8ce15e0e3233$export$fcd9750494ff0236);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_EARLY_ACCESS_ITSM", ()=>$d90d8ce15e0e3233$export$ad856b38e93b93b2);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE", ()=>$d90d8ce15e0e3233$export$a833209ca71d2e56);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INCIDENTS", ()=>$d90d8ce15e0e3233$export$829d1776460a6ad3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INDEX", ()=>$d90d8ce15e0e3233$export$d30ab2da08d8b7b9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUE", ()=>$d90d8ce15e0e3233$export$3c71889849aeaa08);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUES", ()=>$d90d8ce15e0e3233$export$354bf2df81f6ffb0);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ITSM_SAMPLE_SPACE", ()=>$d90d8ce15e0e3233$export$f8880b461acd270d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_JIRA_AUTOMATION", ()=>$d90d8ce15e0e3233$export$876055c0ede2f8df);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS", ()=>$d90d8ce15e0e3233$export$bf493c66e34711c8);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE", ()=>$d90d8ce15e0e3233$export$212f6e2c7c2a53bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE", ()=>$d90d8ce15e0e3233$export$7c28c6e8d8a6545);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE", ()=>$d90d8ce15e0e3233$export$8d55b6ef2cd92f8c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS", ()=>$d90d8ce15e0e3233$export$f7fbe9a4717b7a50);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS", ()=>$d90d8ce15e0e3233$export$8c800f176d079d28);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2", ()=>$d90d8ce15e0e3233$export$1c5fbcbfc0923176);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE", ()=>$d90d8ce15e0e3233$export$59644e5d8d69a016);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT", ()=>$d90d8ce15e0e3233$export$c7074ebe0ca83f98);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE", ()=>$d90d8ce15e0e3233$export$2b4737953287a354);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING", ()=>$d90d8ce15e0e3233$export$e7a8d6d534c5e2fe);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW", ()=>$d90d8ce15e0e3233$export$5dcba309e2bfa88b);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW", ()=>$d90d8ce15e0e3233$export$2d961b0101f8733e);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_CONVERSION", ()=>$d90d8ce15e0e3233$export$195fe2558f1a8591);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON", ()=>$d90d8ce15e0e3233$export$1b3cf68be370a45b);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE", ()=>$d90d8ce15e0e3233$export$45c35381e5da2232);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT", ()=>$d90d8ce15e0e3233$export$d479ba53b9bf65a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE", ()=>$d90d8ce15e0e3233$export$ccd12890649c59cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING", ()=>$d90d8ce15e0e3233$export$8c84064031188e80);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW", ()=>$d90d8ce15e0e3233$export$46c6fef035fbe8ba);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_NEW", ()=>$d90d8ce15e0e3233$export$6fb23ec5a12d5c24);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REDIRECT", ()=>$d90d8ce15e0e3233$export$156b2dfbd87d576f);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS", ()=>$d90d8ce15e0e3233$export$6961f1ed0407cb26);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM", ()=>$d90d8ce15e0e3233$export$ba284efd679bf637);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE", ()=>$d90d8ce15e0e3233$export$e48a3df597407767);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT", ()=>$d90d8ce15e0e3233$export$c73718d4a6efea1d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE", ()=>$d90d8ce15e0e3233$export$ed454783ba1bacb9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE", ()=>$d90d8ce15e0e3233$export$48f6285d4729ca9d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION", ()=>$d90d8ce15e0e3233$export$8066418cead2d2ef);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE", ()=>$d90d8ce15e0e3233$export$b3db7857ac710a89);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE", ()=>$d90d8ce15e0e3233$export$d574810e3edad044);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY", ()=>$d90d8ce15e0e3233$export$be4b2ffade787316);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE", ()=>$d90d8ce15e0e3233$export$3caf79b5f4be02d7);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD", ()=>$d90d8ce15e0e3233$export$29bc361328055683);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES", ()=>$d90d8ce15e0e3233$export$a4a5a333fe874d97);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_NEW", ()=>$d90d8ce15e0e3233$export$2193b681ac1ae132);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT", ()=>$d90d8ce15e0e3233$export$f1bfd5b3918619a9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS", ()=>$d90d8ce15e0e3233$export$a4c4f7898d6b914a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_NEW", ()=>$d90d8ce15e0e3233$export$6cffae90b9277bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT", ()=>$d90d8ce15e0e3233$export$17e76ebd53424ed5);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_EDIT", ()=>$d90d8ce15e0e3233$export$b1329dc26a81a277);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_NEW", ()=>$d90d8ce15e0e3233$export$e1cba0bfe330f5c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS", ()=>$d90d8ce15e0e3233$export$8e68c55c334de101);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICES", ()=>$d90d8ce15e0e3233$export$5cb7cfba189a0240);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICE_DETAILS", ()=>$d90d8ce15e0e3233$export$d28aab4a6d6f1d0d);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_AUTOMATION", ()=>$d90d8ce15e0e3233$export$1cf56e2d6c4edb35);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG", ()=>$d90d8ce15e0e3233$export$27c1770584d7e3fe);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS", ()=>$d90d8ce15e0e3233$export$22e0ebdea08537f7);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_RECOMMENDATIONS", ()=>$d90d8ce15e0e3233$export$4db732436e4edfaf);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_VIEW_CUSTOM_FIELDS", ()=>$d90d8ce15e0e3233$export$e832418dbed0717e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS", ()=>$d90d8ce15e0e3233$export$ee09be798f0e4471);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT", ()=>$d90d8ce15e0e3233$export$653bf90ae3578f21);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT", ()=>$d90d8ce15e0e3233$export$9da4125a0c62444d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP", ()=>$d90d8ce15e0e3233$export$fbcc0fd9b402bb12);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES", ()=>$d90d8ce15e0e3233$export$e74fe5bd41e23fbd);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT", ()=>$d90d8ce15e0e3233$export$1a93e63ddbe4aa06);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR", ()=>$d90d8ce15e0e3233$export$3b6dbbe49882589d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS", ()=>$d90d8ce15e0e3233$export$eb01394789016fd4);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT", ()=>$d90d8ce15e0e3233$export$f17f4523583fa8e5);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$eaa4d6eec75a6778);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT", ()=>$d90d8ce15e0e3233$export$dcc96e4abbdc0d39);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG", ()=>$d90d8ce15e0e3233$export$9eaf39ba5a56c72a);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG_EMBED", ()=>$d90d8ce15e0e3233$export$495be3320b67814a);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS", ()=>$d90d8ce15e0e3233$export$25752eb5bb5e3d32);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS_EMBED", ()=>$d90d8ce15e0e3233$export$f116716aedb35e10);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR", ()=>$d90d8ce15e0e3233$export$36fffb6b49d9f31d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC", ()=>$d90d8ce15e0e3233$export$a6d07be4ff318f84);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC_EMBED", ()=>$d90d8ce15e0e3233$export$a9a43f1114df1ad9);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_EMBED", ()=>$d90d8ce15e0e3233$export$3a4c7a521a900b4d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT", ()=>$d90d8ce15e0e3233$export$9dcf51a9040a4fd6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED", ()=>$d90d8ce15e0e3233$export$a74f9f6bd0d4fb26);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE", ()=>$d90d8ce15e0e3233$export$f8cb86acf6b74661);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE_CLASSIC", ()=>$d90d8ce15e0e3233$export$2d3d850c64058bfb);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS", ()=>$d90d8ce15e0e3233$export$af6b51164f66908b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC", ()=>$d90d8ce15e0e3233$export$12efc96fc9c9fb34);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM", ()=>$d90d8ce15e0e3233$export$6ab1901e04e623ba);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_CLASSIC", ()=>$d90d8ce15e0e3233$export$bccc7d0812737c4e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER", ()=>$d90d8ce15e0e3233$export$458fb992f2637a20);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC", ()=>$d90d8ce15e0e3233$export$c9c9c64f68ba51e3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT", ()=>$d90d8ce15e0e3233$export$50264cbc90a39f19);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_EMBED", ()=>$d90d8ce15e0e3233$export$fd12b611e297e41f);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC", ()=>$d90d8ce15e0e3233$export$b9d0cbe0888fa72e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC_EMBED", ()=>$d90d8ce15e0e3233$export$92ee2005b2bb1c0e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS", ()=>$d90d8ce15e0e3233$export$b8045610416fa8ca);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC", ()=>$d90d8ce15e0e3233$export$8e80136ad13099e3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS", ()=>$d90d8ce15e0e3233$export$b5fe44c0bc324494);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC", ()=>$d90d8ce15e0e3233$export$7a4f52d9060a20d2);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$d6a9e4695952522e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST", ()=>$d90d8ce15e0e3233$export$deab88d0814c564b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC", ()=>$d90d8ce15e0e3233$export$906faff110f898ef);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC_EMBED", ()=>$d90d8ce15e0e3233$export$ab3f2a34a3b0db87);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_EMBED", ()=>$d90d8ce15e0e3233$export$4ed84a2011fdc400);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_NEXTGEN_REDIRECT", ()=>$d90d8ce15e0e3233$export$f7b286b39bf6051b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING", ()=>$d90d8ce15e0e3233$export$6c4337c0332c8c7f);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED", ()=>$d90d8ce15e0e3233$export$e7c78887745b2326);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE", ()=>$d90d8ce15e0e3233$export$3805e4f07dca7584);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC", ()=>$d90d8ce15e0e3233$export$f77254983320e888);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR", ()=>$d90d8ce15e0e3233$export$2e784832f1c6bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED", ()=>$d90d8ce15e0e3233$export$7f97fa79520a4c5b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES", ()=>$d90d8ce15e0e3233$export$9e53cdb1ac02195c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES_EMBED", ()=>$d90d8ce15e0e3233$export$58bd507904dc221c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT", ()=>$d90d8ce15e0e3233$export$7a821e22be2c2f14);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT_EMBED", ()=>$d90d8ce15e0e3233$export$ca8966ef80bfafc6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS", ()=>$d90d8ce15e0e3233$export$e7423156dba31a7c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_RELEASES", ()=>$d90d8ce15e0e3233$export$cba7e383b2409c7b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER", ()=>$d90d8ce15e0e3233$export$d5378fb71d5242c0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS", ()=>$d90d8ce15e0e3233$export$4b16b72c72da8833);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES", ()=>$d90d8ce15e0e3233$export$10114d78cefb1f53);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE", ()=>$d90d8ce15e0e3233$export$92fe23ed30100817);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES", ()=>$d90d8ce15e0e3233$export$e824495554c83069);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$8df2e9efdd625a44);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PLAN_INFO", ()=>$d90d8ce15e0e3233$export$aeb4d3006e298033);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS", ()=>$d90d8ce15e0e3233$export$e15d3c40985c4b53);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES", ()=>$d90d8ce15e0e3233$export$1d8c84454fd2d571);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS", ()=>$d90d8ce15e0e3233$export$db61a12efb59745c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCENARIOS", ()=>$d90d8ce15e0e3233$export$2da67fb5bd6bc2ee);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCHEDULING", ()=>$d90d8ce15e0e3233$export$182e0167fd960de6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY", ()=>$d90d8ce15e0e3233$export$2d9e2484ee02e7da);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY_EMBED", ()=>$d90d8ce15e0e3233$export$b7fff19fd89b617f);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TEAMS", ()=>$d90d8ce15e0e3233$export$ea23f150f64e8a4e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE", ()=>$d90d8ce15e0e3233$export$116338bd93f78ad0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE_EMBED", ()=>$d90d8ce15e0e3233$export$c9cd65a78227cf18);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_RELEASE_NOTES", ()=>$d90d8ce15e0e3233$export$d75d93e5d44182cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS", ()=>$d90d8ce15e0e3233$export$cc3027ae3767801);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN", ()=>$d90d8ce15e0e3233$export$3492ce83b8884e0e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP", ()=>$d90d8ce15e0e3233$export$b4798b7e62733393);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL", ()=>$d90d8ce15e0e3233$export$388685c701d6e0d3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE", ()=>$d90d8ce15e0e3233$export$5ff4d2d4257ea2b0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME", ()=>$d90d8ce15e0e3233$export$fa83895c1eac55e7);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC", ()=>$d90d8ce15e0e3233$export$5c82bb95a06a1846);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY", ()=>$d90d8ce15e0e3233$export$c725b9c7e11dd69e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC", ()=>$d90d8ce15e0e3233$export$90594f89c675ba05);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY", ()=>$d90d8ce15e0e3233$export$ae0d999dd2bdd59b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP", ()=>$d90d8ce15e0e3233$export$296115eb5b7129d3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC", ()=>$d90d8ce15e0e3233$export$17574f41c3925d64);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_REDIRECT", ()=>$d90d8ce15e0e3233$export$955692fbfe35fc16);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY", ()=>$d90d8ce15e0e3233$export$30af3a767b8ad2d8);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC", ()=>$d90d8ce15e0e3233$export$f47d664298c2c2f0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SUMMARY", ()=>$d90d8ce15e0e3233$export$2d1ed852d9885250);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SUMMARY_CLASSIC", ()=>$d90d8ce15e0e3233$export$312796fc15876480);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE", ()=>$d90d8ce15e0e3233$export$1714b5ad9b672bc7);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC", ()=>$d90d8ce15e0e3233$export$c9634bf15518a3a1);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL", ()=>$d90d8ce15e0e3233$export$3b5eb3ea8cbeeed);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED", ()=>$d90d8ce15e0e3233$export$118bb1785acc3d0b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT", ()=>$d90d8ce15e0e3233$export$c29d90ae9a4b648e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH", ()=>$d90d8ce15e0e3233$export$8f2717a951373c25);
    $parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$831acb5098f5706d);
    $parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT", ()=>$d90d8ce15e0e3233$export$d218cda46c433fe1);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK", ()=>$d90d8ce15e0e3233$export$61147168ac2833f9);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASH_PLANS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$9fe0117c0fd486a8);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$a49474778d15635d);
    $parcel$export(module.exports, "ROUTE_NAMES_USER_SEGMENTATION", ()=>$d90d8ce15e0e3233$export$af3296e54e7fb362);
    $parcel$export(module.exports, "ROUTE_NAMES_YOUR_WORK", ()=>$d90d8ce15e0e3233$export$281f2e01ee9e4977);
    const $d90d8ce15e0e3233$export$dda94bb6f1904d59 = 'support-center-settings';
    const $d90d8ce15e0e3233$export$1ba937db1fe6ef01 = 'archive-issues';
    const $d90d8ce15e0e3233$export$3fd002e197e83a30 = 'arj-settings';
    const $d90d8ce15e0e3233$export$bbf08d4d25df5504 = 'classic-business';
    const $d90d8ce15e0e3233$export$e3e759b7f50aaee1 = 'classic-software';
    const $d90d8ce15e0e3233$export$89337611b52bc9a3 = 'components';
    const $d90d8ce15e0e3233$export$3d7937b12eb9e5d5 = 'connect';
    const $d90d8ce15e0e3233$export$b5f9c9cfeafb79a2 = 'customer-service';
    const $d90d8ce15e0e3233$export$7a3d181d86fce9e6 = 'dashboard';
    const $d90d8ce15e0e3233$export$294c878a3842c859 = 'dashboards';
    const $d90d8ce15e0e3233$export$7a22726acd7d6021 = 'devops';
    const $d90d8ce15e0e3233$export$f3f4a9f53ba00861 = 'directories';
    const $d90d8ce15e0e3233$export$112d69653b2f1d8b = 'eoc';
    const $d90d8ce15e0e3233$export$74e0426b66571086 = 'errors';
    const $d90d8ce15e0e3233$export$c2e20e142c95c1ce = 'global-settings';
    const $d90d8ce15e0e3233$export$f8cea29bebf098c = 'helpcenter-settings';
    const $d90d8ce15e0e3233$export$5801ef8dfc9a2f70 = 'home';
    const $d90d8ce15e0e3233$export$7246838143f848f3 = 'issue';
    const $d90d8ce15e0e3233$export$54f96702980a2f87 = 'issue-navigator';
    const $d90d8ce15e0e3233$export$5566db8fbd042fc4 = 'legacy';
    const $d90d8ce15e0e3233$export$20344ad17b5fca86 = 'legacy-jsd-settings';
    const $d90d8ce15e0e3233$export$656d0cc2c67b2708 = 'marketplace';
    const $d90d8ce15e0e3233$export$bfdbcebc4c81b043 = 'people-profiles';
    const $d90d8ce15e0e3233$export$82021d71ad19e227 = 'personal-settings';
    const $d90d8ce15e0e3233$export$6f266218a6973848 = 'plan-settings';
    const $d90d8ce15e0e3233$export$a846fcaeeea8e0ff = 'polaris';
    const $d90d8ce15e0e3233$export$6c87a9dff4e7a2de = 'proforma';
    const $d90d8ce15e0e3233$export$ab79970dcfac06a1 = 'project-settings-classic';
    const $d90d8ce15e0e3233$export$d1a70f80bb22f18a = 'project-settings-core';
    const $d90d8ce15e0e3233$export$bd925e9fcb6ce37f = 'project-settings-servicedesk';
    const $d90d8ce15e0e3233$export$86509a1baabd62ee = 'project-settings-software';
    const $d90d8ce15e0e3233$export$98823ed9eedfc756 = 'project-settings-software-boards';
    const $d90d8ce15e0e3233$export$da8d13fe1ccd5c09 = 'redirects';
    const $d90d8ce15e0e3233$export$e46610825208f0d8 = 'sandbox';
    const $d90d8ce15e0e3233$export$78fb2f6176b7c6b8 = 'servicedesk';
    const $d90d8ce15e0e3233$export$d4a2a2e87da2135a = 'services';
    const $d90d8ce15e0e3233$export$26efaec7a7a8b361 = 'software';
    const $d90d8ce15e0e3233$export$db781fb68c08f7e2 = 'versions';
    const $d90d8ce15e0e3233$export$89c26097a5edf8cb = 'agent-studio';
    const $d90d8ce15e0e3233$export$88041353cc69458d = 'archived-issues-directory';
    const $d90d8ce15e0e3233$export$f88d57dcb03ba452 = 'archived-plans-directory';
    const $d90d8ce15e0e3233$export$e8aa63af071c2da9 = 'archived-projects-directory';
    const $d90d8ce15e0e3233$export$b114d0da2ebcff6c = 'archived-project-direct-link';
    const $d90d8ce15e0e3233$export$29cc94b8cea5c920 = 'boards-directory';
    const $d90d8ce15e0e3233$export$4d1b45005cdcfb39 = 'browse-project-redirect';
    const $d90d8ce15e0e3233$export$a42ea04fdf53eeaf = 'next-gen-business-board';
    const $d90d8ce15e0e3233$export$ca4c5f5b3e2daa18 = 'business-classic-reports';
    const $d90d8ce15e0e3233$export$d58a5411a2ac6260 = 'next-gen-business-reports';
    const $d90d8ce15e0e3233$export$24514ee19772b5af = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-onboarding-get-started`;
    const $d90d8ce15e0e3233$export$ec333dd1d6a8b38 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-calendar`;
    const $d90d8ce15e0e3233$export$ed495fbad44791af = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-redirect`;
    const $d90d8ce15e0e3233$export$5281552f8109b7c0 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-summary`;
    const $d90d8ce15e0e3233$export$6e8473713ed4557a = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-timeline`;
    const $d90d8ce15e0e3233$export$cbdd5c24d69b2cb1 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-approvals`;
    const $d90d8ce15e0e3233$export$e7f012f402be01ea = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-attachments`;
    const $d90d8ce15e0e3233$export$b34d3882b42d660d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-board`;
    const $d90d8ce15e0e3233$export$ed869c60c6a56182 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-board-embed`;
    const $d90d8ce15e0e3233$export$5013269f29c75b37 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-calendar`;
    const $d90d8ce15e0e3233$export$fc8b48319e993d43 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-calendar-embed`;
    const $d90d8ce15e0e3233$export$40903feb5b038923 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-files`;
    const $d90d8ce15e0e3233$export$d6e60a2059f028d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form`;
    const $d90d8ce15e0e3233$export$3d589aae17a00bc9 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-builder`;
    const $d90d8ce15e0e3233$export$bd92ef03b23dd672 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-submit`;
    const $d90d8ce15e0e3233$export$fa7fc44c718fc850 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-submit-embed`;
    const $d90d8ce15e0e3233$export$1dffaf831e01e2b4 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-list`;
    const $d90d8ce15e0e3233$export$5f8187412dd60f35 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-list-embed`;
    const $d90d8ce15e0e3233$export$3d2c1c04d18f6c43 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-sample-onboarding`;
    const $d90d8ce15e0e3233$export$cd22a5d8f560a1d8 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-shortcut`;
    const $d90d8ce15e0e3233$export$cad1b1aa5ce26bbc = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-summary`;
    const $d90d8ce15e0e3233$export$ee073463b4144367 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-summary-embed`;
    const $d90d8ce15e0e3233$export$ea034943499772ea = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-timeline`;
    const $d90d8ce15e0e3233$export$19bc888bcf37d22d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-timeline-embed`;
    const $d90d8ce15e0e3233$export$e0746183e11767fb = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-redirect`;
    const $d90d8ce15e0e3233$export$3e2d215ce157adc8 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-code`;
    const $d90d8ce15e0e3233$export$8a8485bb05daf40b = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-project-forms`;
    const $d90d8ce15e0e3233$export$a2799b01de5bb62 = `${$d90d8ce15e0e3233$export$ab79970dcfac06a1}-data-classifications`;
    const $d90d8ce15e0e3233$export$1bc2b66dcb07293a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-details`;
    const $d90d8ce15e0e3233$export$2d4f89c4b1ee3640 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-features`;
    const $d90d8ce15e0e3233$export$75609d3416c31f79 = `${$d90d8ce15e0e3233$export$ab79970dcfac06a1}-issue-layout`;
    const $d90d8ce15e0e3233$export$79793dc26e0b7b1a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications-notification-email`;
    const $d90d8ce15e0e3233$export$2eda7466fbfdef43 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-link-opsgenie`;
    const $d90d8ce15e0e3233$export$417297669917ee1a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-details`;
    const $d90d8ce15e0e3233$export$8c79f3309ac0737 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications`;
    const $d90d8ce15e0e3233$export$ef71a22e7befd35c = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications-issue-logs`;
    const $d90d8ce15e0e3233$export$62ba1e294f5007c1 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-proforma-edit-forms`;
    const $d90d8ce15e0e3233$export$a4315324546ecc89 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-proforma-project-forms`;
    const $d90d8ce15e0e3233$export$a653cf6d478b3df1 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-toolchain-company-managed`;
    const $d90d8ce15e0e3233$export$b0f268fe53a03e98 = 'compass-product-settings';
    const $d90d8ce15e0e3233$export$f4160b48e4ab8f39 = 'confluence-product-settings';
    const $d90d8ce15e0e3233$export$608f359cf8b08d2e = 'connect-general';
    const $d90d8ce15e0e3233$export$8bfbf790fe89f8d3 = 'connect-general-invalid';
    const $d90d8ce15e0e3233$export$d7011d1ed949f970 = 'connect-general-service-desk-project';
    const $d90d8ce15e0e3233$export$bd2506db44585db6 = 'connect-project';
    const $d90d8ce15e0e3233$export$200fa5ad16f8c112 = 'create-project';
    const $d90d8ce15e0e3233$export$21702f145fe1bbb0 = 'customer-service-accounts';
    const $d90d8ce15e0e3233$export$a296bb962bea95b5 = 'dashboard';
    const $d90d8ce15e0e3233$export$b9960c143c0414eb = 'dashboards-directory';
    const $d90d8ce15e0e3233$export$411171d2fcaefaea = 'dashboards-directory-secure';
    const $d90d8ce15e0e3233$export$ee104ed514f63003 = 'dashboard-edit';
    const $d90d8ce15e0e3233$export$9233f9ddcecd3062 = 'dashboard-selected';
    const $d90d8ce15e0e3233$export$b3240ec044a6c70f = 'dashboard-view';
    const $d90d8ce15e0e3233$export$2463c779e12367e3 = 'dashboard-view-embed';
    const $d90d8ce15e0e3233$export$dd3e5187eae2abe9 = 'dashboard-wallboard';
    const $d90d8ce15e0e3233$export$38ca7e07048a5bfd = 'devops-connected-project';
    const $d90d8ce15e0e3233$export$a9044bbb0247378d = 'eoc-alerts';
    const $d90d8ce15e0e3233$export$ae7376e552380ac0 = 'eoc-alert-detail';
    const $d90d8ce15e0e3233$export$48749e87cc44a5a5 = 'eoc-alert-issue-syncing';
    const $d90d8ce15e0e3233$export$21c230ef79df9e9 = 'eoc-alert-issue-syncing-create';
    const $d90d8ce15e0e3233$export$d2d813dd057a8352 = 'eoc-alert-issue-syncing-detail';
    const $d90d8ce15e0e3233$export$54ed2374d14a7e88 = 'eoc-api-key-management';
    const $d90d8ce15e0e3233$export$58368fe796f5ecb4 = 'eoc-assign-custom-roles';
    const $d90d8ce15e0e3233$export$bbb4032f8f259109 = 'eoc-automations';
    const $d90d8ce15e0e3233$export$5b17b30c2dd69cf2 = 'eoc-custom-roles';
    const $d90d8ce15e0e3233$export$d18d0b9a9e85e59c = 'eoc-global-alerts';
    const $d90d8ce15e0e3233$export$5126a481501fc518 = 'eoc-global-alert-detail';
    const $d90d8ce15e0e3233$export$40e720d8c26e6804 = 'eoc-global-group-detail';
    const $d90d8ce15e0e3233$export$dc8ac1f7e9373a32 = 'eoc-global-maintenance';
    const $d90d8ce15e0e3233$export$8ca3e3f0326ba27f = 'eoc-global-reports';
    const $d90d8ce15e0e3233$export$c3d17be12795c864 = 'eoc-global-report-dashboard';
    const $d90d8ce15e0e3233$export$9cd1c70eda5cae15 = 'eoc-heartbeats';
    const $d90d8ce15e0e3233$export$99f769b27f537a72 = 'eoc-incoming-call';
    const $d90d8ce15e0e3233$export$5c5fe79d3f9ec214 = 'eoc-incoming-call-detail';
    const $d90d8ce15e0e3233$export$901b974cf0954c88 = 'eoc-integrations';
    const $d90d8ce15e0e3233$export$b2dd23a345bd5cb3 = 'eoc-integration-create';
    const $d90d8ce15e0e3233$export$8ae7cbc0a73f9351 = 'eoc-integration-detail';
    const $d90d8ce15e0e3233$export$8057ebe7fb7f7f8d = 'eoc-integration-list';
    const $d90d8ce15e0e3233$export$a22387b9744e62e3 = 'eoc-integration-log';
    const $d90d8ce15e0e3233$export$f6fefa9d2e5bbda1 = 'eoc-maintenance';
    const $d90d8ce15e0e3233$export$e6de4aa6c719d2b = 'eoc-on-call';
    const $d90d8ce15e0e3233$export$b195ada84b7e695f = `${$d90d8ce15e0e3233$export$e6de4aa6c719d2b}-redirect`;
    const $d90d8ce15e0e3233$export$1800d32171b754a6 = 'eoc-overview';
    const $d90d8ce15e0e3233$export$d22a153bfcbaaaa0 = 'eoc-overview-all-teams';
    const $d90d8ce15e0e3233$export$a9a41c76994b6ae9 = 'eoc-permissions';
    const $d90d8ce15e0e3233$export$5bd6f2569c3cfd5c = 'eoc-policies';
    const $d90d8ce15e0e3233$export$dc70eff53ff26c70 = 'eoc-reports';
    const $d90d8ce15e0e3233$export$1fe2ca96b360df19 = 'eoc-reports-team';
    const $d90d8ce15e0e3233$export$1ff01e77517a80b0 = 'eoc-reports-unsubscribe';
    const $d90d8ce15e0e3233$export$de3f8f3198f8213a = 'eoc-role-based-notifications';
    const $d90d8ce15e0e3233$export$b2cb569d360db382 = 'eoc-role-based-notifications-detail';
    const $d90d8ce15e0e3233$export$a0d9033eb64fd80f = 'eoc-schedules';
    const $d90d8ce15e0e3233$export$4c2fd998d73d2b83 = 'eoc-global-escalations';
    const $d90d8ce15e0e3233$export$c4531cbbea51b6a1 = 'eoc-settings';
    const $d90d8ce15e0e3233$export$da985e953465731f = 'eoc-team-alerts';
    const $d90d8ce15e0e3233$export$b7eee2afd0a5c6b9 = 'eoc-team-alert-detail';
    const $d90d8ce15e0e3233$export$9b6c84986db47d98 = 'eoc-team-alert-issue-syncing';
    const $d90d8ce15e0e3233$export$89276f76fdd700d6 = 'eoc-team-alert-issue-syncing-create';
    const $d90d8ce15e0e3233$export$ea64769f19da8c95 = 'eoc-team-alert-issue-syncing-detail';
    const $d90d8ce15e0e3233$export$4a584839d9a9eb6f = 'eoc-team-customer-logs';
    const $d90d8ce15e0e3233$export$27d27c817eeb97cc = 'eoc-team-customer-logs-download';
    const $d90d8ce15e0e3233$export$9f533c13cfb48a8f = 'eoc-team-group-detail';
    const $d90d8ce15e0e3233$export$6889e571e5aa6ba6 = 'eoc-team-integrations';
    const $d90d8ce15e0e3233$export$bdd811277711c53d = 'eoc-team-integration-create';
    const $d90d8ce15e0e3233$export$c7b51c0e8ad6f77a = 'eoc-team-integration-detail';
    const $d90d8ce15e0e3233$export$a348fc7f3b4cfe34 = 'eoc-team-integration-list';
    const $d90d8ce15e0e3233$export$a4eff769c94da831 = 'eoc-team-integration-log';
    const $d90d8ce15e0e3233$export$7c928ca9c9822772 = 'eoc-team-policies';
    const $d90d8ce15e0e3233$export$b48311a8f24f4b63 = 'eoc-unlock-operations';
    const $d90d8ce15e0e3233$export$20649eac204f7661 = 'eoc-who-is-on-call';
    const $d90d8ce15e0e3233$export$62170875a111d729 = 'errors-not-found';
    const $d90d8ce15e0e3233$export$2928f3d69e7ac609 = 'external-import';
    const $d90d8ce15e0e3233$export$259e18cafd820487 = 'filters-directory';
    const $d90d8ce15e0e3233$export$4b8f333757e638a4 = 'filters-directory-secure';
    const $d90d8ce15e0e3233$export$ac4f65a14002f892 = 'forge-spa-admin';
    const $d90d8ce15e0e3233$export$c73ddc4b44ccb359 = 'forge-spa-admin-settings';
    const $d90d8ce15e0e3233$export$7ad826b482229119 = 'forge-spa-field-context-config';
    const $d90d8ce15e0e3233$export$3df864df9b639033 = 'forge-spa-global';
    const $d90d8ce15e0e3233$export$7d67bf4077ebe18d = 'forge-spa-project';
    const $d90d8ce15e0e3233$export$d025408d02e64fb9 = 'forge-spa-personal-settings';
    const $d90d8ce15e0e3233$export$5ff797dfd5df551f = 'forge-spa-servicedesk-queue';
    const $d90d8ce15e0e3233$export$8a66ba1da5efa2c = 'global-admin-helper-email-notifications-log';
    const $d90d8ce15e0e3233$export$eadf5aff28def565 = 'global-issue-navigator';
    const $d90d8ce15e0e3233$export$8f9c045e8fd449b7 = 'global-issue-navigator-browse-issue-redirect';
    const $d90d8ce15e0e3233$export$1bf439327974644b = 'global-mail-settings';
    const $d90d8ce15e0e3233$export$e2a9d163770d0d46 = 'global-settings-contact-administrator';
    const $d90d8ce15e0e3233$export$21b497c57bcd299a = 'global-settings-issues-custom-fields-view';
    const $d90d8ce15e0e3233$export$8d4d1f7df6e5d4e4 = 'global-settings-issues-custom-fields-associate';
    const $d90d8ce15e0e3233$export$df5ca261227a6052 = 'global-settings-issues-custom-fields-config';
    const $d90d8ce15e0e3233$export$9f2f4303259b8508 = 'global-settings-issues-custom-fields-delete';
    const $d90d8ce15e0e3233$export$7fd53fe07eecc273 = 'global-settings-issues-custom-fields-edit';
    const $d90d8ce15e0e3233$export$c8e9ba2b5bc9dab2 = 'global-settings-issues-custom-fields-manage';
    const $d90d8ce15e0e3233$export$e05a6c9e9b9b0c48 = 'global-settings-issues-custom-fields-translate';
    const $d90d8ce15e0e3233$export$f9759b206b651b1f = 'global-settings-issues-explicit-field-association-project-list';
    const $d90d8ce15e0e3233$export$7a337a2687b5d5e3 = 'global-settings-issues-edit-permissions-schemes';
    const $d90d8ce15e0e3233$export$a41998c1a3572e41 = 'global-settings-issues-fieldlayouts-view';
    const $d90d8ce15e0e3233$export$2c9fe9e6005a9c36 = 'global-settings-issues-fieldview';
    const $d90d8ce15e0e3233$export$5d8d82ff1de3586e = 'global-settings-issues-fieldlayouts-copy';
    const $d90d8ce15e0e3233$export$8a0ed100d885c17c = 'global-settings-issues-fieldlayouts-schemes-view';
    const $d90d8ce15e0e3233$export$1c7041445acf79e8 = 'global-settings-issues-fieldlayouts-schemes-config';
    const $d90d8ce15e0e3233$export$e4712523d95125f6 = 'global-settings-issues-fieldlayouts-schemes-copy';
    const $d90d8ce15e0e3233$export$7401274ad357ff94 = 'global-settings-issues-fieldlayouts-schemes-delete';
    const $d90d8ce15e0e3233$export$6984b21077857555 = 'global-settings-issues-fieldlayouts-schemes-edit';
    const $d90d8ce15e0e3233$export$5a2dae98f768aedf = 'global-settings-issues-fieldlayouts-schemes-entity';
    const $d90d8ce15e0e3233$export$5eef1c6eb1388ac0 = 'global-settings-issues-fieldlayouts-config';
    const $d90d8ce15e0e3233$export$69bcf2c26d45e030 = 'global-settings-issues-form-data-connections';
    const $d90d8ce15e0e3233$export$ba1417cf5de80f81 = 'global-settings-global-permissions';
    const $d90d8ce15e0e3233$export$fdcfcb2e2eb16afd = 'global-settings-issues-linktypes-view';
    const $d90d8ce15e0e3233$export$5d3e6bffd6b5abfe = 'global-settings-issues-linktypes-activate';
    const $d90d8ce15e0e3233$export$5c676bbb7e3aae9e = 'global-settings-issues-linktypes-deactivate';
    const $d90d8ce15e0e3233$export$8bb013ced097489a = 'global-settings-issues-linktypes-delete';
    const $d90d8ce15e0e3233$export$e384ae6a87fadedd = 'global-settings-issues-linktypes-edit';
    const $d90d8ce15e0e3233$export$8f55a911c4bd95bf = 'global-settings-issues-new-issue-search';
    const $d90d8ce15e0e3233$export$d7b98892cb31fba5 = 'global-settings-issues-new-issue-view';
    const $d90d8ce15e0e3233$export$8be4b203f526b2cd = 'global-settings-issues-notification-add';
    const $d90d8ce15e0e3233$export$df09947903c514c4 = 'global-settings-issues-notification-delete';
    const $d90d8ce15e0e3233$export$cf4a57a81e0bfbca = 'global-settings-issues-notification-edit';
    const $d90d8ce15e0e3233$export$bc64365bbb09c05e = 'global-settings-issues-notification-scheme-add';
    const $d90d8ce15e0e3233$export$5b12571311ebe766 = 'global-settings-issues-notification-scheme-delete';
    const $d90d8ce15e0e3233$export$56dc46fe1de63994 = 'global-settings-issues-notification-scheme-edit';
    const $d90d8ce15e0e3233$export$65af0e5a36d4b4e9 = 'global-settings-issues-notification-view';
    const $d90d8ce15e0e3233$export$dec448f9d2e50c90 = 'global-settings-issues-permissions-schemes-view';
    const $d90d8ce15e0e3233$export$9ff4144e1dcf9fa4 = 'global-settings-issues-permissions-schemes-add';
    const $d90d8ce15e0e3233$export$8aab6fb9a62dda95 = 'global-settings-issues-permissions-schemes-delete';
    const $d90d8ce15e0e3233$export$9f804a2650117f51 = 'global-settings-issues-permissions-schemes-edit';
    const $d90d8ce15e0e3233$export$7dd4b916600f670 = 'global-settings-issues-priorities';
    const $d90d8ce15e0e3233$export$c1b40a8a70c0aafa = 'global-settings-issues-priorities-delete';
    const $d90d8ce15e0e3233$export$ff10d812380db045 = 'global-settings-issues-priorities-edit';
    const $d90d8ce15e0e3233$export$8deeffdf8dfed878 = 'global-settings-issues-priorities-translations';
    const $d90d8ce15e0e3233$export$561687f2fa9b9cc9 = 'global-settings-issues-priority-schemes';
    const $d90d8ce15e0e3233$export$691d30818c14141c = 'global-settings-issues-resolutions';
    const $d90d8ce15e0e3233$export$8fa58495105f8fb0 = 'global-settings-issues-resolutions-default';
    const $d90d8ce15e0e3233$export$8304c57494d82ffd = 'global-settings-issues-resolutions-delete';
    const $d90d8ce15e0e3233$export$353609deec72a2ba = 'global-settings-issues-resolutions-edit';
    const $d90d8ce15e0e3233$export$1cb56e4c132ac8fd = 'global-settings-issues-resolutions-translations';
    const $d90d8ce15e0e3233$export$5fe3eec0a6bda09 = 'global-settings-issues-security-edit';
    const $d90d8ce15e0e3233$export$12b56880d6fb7ac7 = 'global-settings-issues-security-level-add';
    const $d90d8ce15e0e3233$export$9986e8be82998857 = 'global-settings-issues-security-level-delete';
    const $d90d8ce15e0e3233$export$3280ec16231916af = 'global-settings-issues-security-level-edit';
    const $d90d8ce15e0e3233$export$54885d105d1e2b37 = 'global-settings-issues-security-schemes';
    const $d90d8ce15e0e3233$export$f34d87c870f3bf43 = 'global-settings-issues-security-schemes-add';
    const $d90d8ce15e0e3233$export$4108ebf71e36e461 = 'global-settings-issues-security-schemes-delete';
    const $d90d8ce15e0e3233$export$d42ec33a6e69686e = 'global-settings-issues-security-schemes-edit';
    const $d90d8ce15e0e3233$export$8d2cfabd01e2feaa = 'global-settings-issues-statuses';
    const $d90d8ce15e0e3233$export$d0fe3726dffeca80 = 'global-settings-issues-statuses-translations';
    const $d90d8ce15e0e3233$export$b4aa4b2b8fb7267a = 'global-settings-issues-field-configure';
    const $d90d8ce15e0e3233$export$3743711165f5dd4f = 'global-settings-issues-field-configure-edit';
    const $d90d8ce15e0e3233$export$5df6f81deab9567c = 'global-settings-issues-field-schemes-view';
    const $d90d8ce15e0e3233$export$b3db2a2ee8a9a8e4 = 'global-settings-issues-field-schemes-add';
    const $d90d8ce15e0e3233$export$d5fc8cd4b3fd2b84 = 'global-settings-issues-field-schemes-configure';
    const $d90d8ce15e0e3233$export$a03360d8b616ef34 = 'global-settings-issues-field-schemes-copy';
    const $d90d8ce15e0e3233$export$336e54edc189df7f = 'global-settings-issues-field-schemes-delete';
    const $d90d8ce15e0e3233$export$53572e9a81205523 = 'global-settings-issues-field-schemes-edit';
    const $d90d8ce15e0e3233$export$b71f2ef452117a2a = 'global-settings-issues-field-schemes-edit-item';
    const $d90d8ce15e0e3233$export$f79745fee583cd62 = 'global-settings-issues-field-screens';
    const $d90d8ce15e0e3233$export$2281663e19f399c1 = 'global-settings-issues-field-copy';
    const $d90d8ce15e0e3233$export$38c52d8c5e5dad29 = 'global-settings-issues-field-delete';
    const $d90d8ce15e0e3233$export$10babc3f11b4e6e2 = 'global-settings-issues-field-edit';
    const $d90d8ce15e0e3233$export$adf2f51c41b4e22a = 'global-settings-issues-hierarchy-view';
    const $d90d8ce15e0e3233$export$11b217754d4c7d24 = 'global-settings-issues-hierarchy-redirect';
    const $d90d8ce15e0e3233$export$3414f0d81f1c11d = 'global-settings-issues-subtasks-manage';
    const $d90d8ce15e0e3233$export$5574c73a9a5878ca = 'global-settings-issues-subtasks-disable';
    const $d90d8ce15e0e3233$export$cb2626c385b72992 = 'global-settings-issues-subtasks-edit';
    const $d90d8ce15e0e3233$export$fa7aa7cabc3ec459 = 'global-settings-issues-subtasks-tranlations';
    const $d90d8ce15e0e3233$export$8b0450672651ef67 = 'global-settings-issues-time-tracking';
    const $d90d8ce15e0e3233$export$ef510a15f840e437 = 'global-settings-issues-types-view';
    const $d90d8ce15e0e3233$export$bc159fa4984a907f = 'global-settings-issues-types-delete';
    const $d90d8ce15e0e3233$export$47bfbce13af95d24 = 'global-settings-issues-types-edit';
    const $d90d8ce15e0e3233$export$c8cb78e94cd3f83c = 'global-settings-issues-types-schemes-manage';
    const $d90d8ce15e0e3233$export$4496279df22177be = 'global-settings-issues-types-schemes-option';
    const $d90d8ce15e0e3233$export$afdfef5d17c56988 = 'global-settings-issues-types-schemes-associate-default';
    const $d90d8ce15e0e3233$export$ac9b4b1136300033 = 'global-settings-issues-types-schemes-option-delete';
    const $d90d8ce15e0e3233$export$4aa31dc2a6d4f2ee = 'global-settings-issues-types-screen-schemes-view';
    const $d90d8ce15e0e3233$export$c56f5509b93eba68 = 'global-settings-issues-types-screen-schemes-configure';
    const $d90d8ce15e0e3233$export$dd9462e97e11637a = 'global-settings-issues-types-screen-schemes-copy';
    const $d90d8ce15e0e3233$export$11f8c53e10f63cfb = 'global-settings-issues-types-screen-schemes-delete';
    const $d90d8ce15e0e3233$export$758ad3ad6916c9f6 = 'global-settings-issues-types-screen-schemes-edit';
    const $d90d8ce15e0e3233$export$9d65a754315eb617 = 'global-settings-issues-types-screen-schemes-entity';
    const $d90d8ce15e0e3233$export$564b665f6ca740dd = 'global-settings-issues-types-translations';
    const $d90d8ce15e0e3233$export$256fc89c38c1b9e9 = 'global-settings-issues-workflows-pages';
    const $d90d8ce15e0e3233$export$ddeae77164bfac0 = 'global-settings-issues-workflow-edit';
    const $d90d8ce15e0e3233$export$fa2b355372963545 = 'global-settings-issues-workflows-schemes-view';
    const $d90d8ce15e0e3233$export$45511e437e54fa02 = 'global-settings-issues-workflows-schemes-edit';
    const $d90d8ce15e0e3233$export$ad76895f03f27a7c = 'global-settings-issues-workflow-transition';
    const $d90d8ce15e0e3233$export$1c291d65a59b1636 = 'global-settings-issues-workflow-transition-meta-attributes';
    const $d90d8ce15e0e3233$export$d9bb14d665bfeea5 = 'global-settings-migrations-dashboard';
    const $d90d8ce15e0e3233$export$8b44cb3da7b8f857 = 'global-settings-migrations-focus-page';
    const $d90d8ce15e0e3233$export$9ca6a09e1518d3bb = 'global-settings-migrations-home';
    const $d90d8ce15e0e3233$export$4c211b3188348679 = 'global-settings-performance-custom-field';
    const $d90d8ce15e0e3233$export$24757bb1837e33af = 'global-settings-performance-issue';
    const $d90d8ce15e0e3233$export$95b5d0bd29a3a076 = 'global-settings-performance-metric-detail';
    const $d90d8ce15e0e3233$export$d55d4330b58683da = 'global-settings-performance-overview';
    const $d90d8ce15e0e3233$export$f4d5833f0b40a26b = 'global-settings-performance-project-cleanup';
    const $d90d8ce15e0e3233$export$c78577545f514ca8 = 'global-settings-performance-project-role-actor';
    const $d90d8ce15e0e3233$export$253eb3db7152d010 = 'global-settings-permissions-schemes';
    const $d90d8ce15e0e3233$export$16b4392a63a3eacf = 'global-settings-products-applinks';
    const $d90d8ce15e0e3233$export$b2d5a7bc804ed9c9 = 'global-settings-products-dvcs';
    const $d90d8ce15e0e3233$export$f870832f94ca5009 = 'global-settings-products-sdmail';
    const $d90d8ce15e0e3233$export$8b3a1b2e8e954dc2 = 'global-settings-products-jsd-status';
    const $d90d8ce15e0e3233$export$15603150075c3d64 = 'global-settings-projects-categories-delete';
    const $d90d8ce15e0e3233$export$92536fe760c41862 = 'global-settings-projects-categories-edit';
    const $d90d8ce15e0e3233$export$3f4d05032349dae0 = 'global-settings-projects-categories-view';
    const $d90d8ce15e0e3233$export$8ff94a2e5f98315f = 'global-settings-system-shared-dashboards';
    const $d90d8ce15e0e3233$export$c906c6946fef5d99 = 'global-settings-system-helper-notification';
    const $d90d8ce15e0e3233$export$a1916b723e186494 = 'global-settings-system-helper-permission';
    const $d90d8ce15e0e3233$export$5070b4c974017f28 = 'global-settings-system-attachments';
    const $d90d8ce15e0e3233$export$bee7f9f93cb74124 = 'global-settings-system-events';
    const $d90d8ce15e0e3233$export$efe4008073ab3b69 = 'global-settings-system-events-add';
    const $d90d8ce15e0e3233$export$9e40228f1c62d4d9 = 'global-settings-system-events-delete';
    const $d90d8ce15e0e3233$export$223f8094878fea34 = 'global-settings-system-events-edit';
    const $d90d8ce15e0e3233$export$2f589c572415c043 = 'global-settings-system-lexorank';
    const $d90d8ce15e0e3233$export$8cc394a1f5ca4ac0 = 'global-settings-system-services';
    const $d90d8ce15e0e3233$export$a11311cd333dae90 = 'global-settings-system-webhooks';
    const $d90d8ce15e0e3233$export$2b2f159267202dcc = 'global-settings-system-bulk-mail';
    const $d90d8ce15e0e3233$export$c5a6874288d2e609 = 'global-settings-system-application-advanced';
    const $d90d8ce15e0e3233$export$55dd30b027c838fe = 'global-settings-system-application-edit';
    const $d90d8ce15e0e3233$export$aee9c7dbf672403c = 'global-settings-system-global-permissions';
    const $d90d8ce15e0e3233$export$75f2fbd33e76028e = 'global-settings-system-export';
    const $d90d8ce15e0e3233$export$ca57c3dfefb2c826 = 'global-settings-system-import-cloud';
    const $d90d8ce15e0e3233$export$8f2e6f133c022a59 = 'global-settings-system-import-external';
    const $d90d8ce15e0e3233$export$bcd741cf5a35ece8 = 'global-settings-system-import-csv';
    const $d90d8ce15e0e3233$export$bfd8ab4625d5c275 = 'global-settings-system-import-json';
    const $d90d8ce15e0e3233$export$750a33c4058af733 = 'global-settings-system-import-trello';
    const $d90d8ce15e0e3233$export$1b66c7594340363f = 'global-settings-system-collectors';
    const $d90d8ce15e0e3233$export$fe2fa966509db649 = 'global-settings-system-delete-mail-handler';
    const $d90d8ce15e0e3233$export$373b97e8d136f558 = 'global-settings-system-mail-incoming';
    const $d90d8ce15e0e3233$export$64909bb6f2181592 = 'global-settings-system-mail-outgoing';
    const $d90d8ce15e0e3233$export$53d6ade2eaa2ae84 = 'global-settings-system-mail-send';
    const $d90d8ce15e0e3233$export$e49d7a1ddf301d09 = 'global-settings-system-permissions';
    const $d90d8ce15e0e3233$export$9469cfde1d14fcac = 'global-settings-system-roles-view';
    const $d90d8ce15e0e3233$export$be2e231547dca6dd = 'global-settings-system-roles-actors';
    const $d90d8ce15e0e3233$export$ad6f28bbfe57d0a0 = 'global-settings-system-roles-actors-groups';
    const $d90d8ce15e0e3233$export$2fb73d5c1c0e7186 = 'global-settings-system-roles-actors-users';
    const $d90d8ce15e0e3233$export$46b4f43d6ece38fc = 'global-settings-system-roles-delete';
    const $d90d8ce15e0e3233$export$49d1c20d84d46735 = 'global-settings-system-roles-edit';
    const $d90d8ce15e0e3233$export$265062715b11a1ef = 'global-settings-system-roles-usage';
    const $d90d8ce15e0e3233$export$e9f5eae9444c9b46 = 'global-settings-system-shared-filters';
    const $d90d8ce15e0e3233$export$e19bf9459d6eba56 = 'global-settings-system-auditing';
    const $d90d8ce15e0e3233$export$40097704c31872d8 = 'global-settings-system-ui-announcement-banner';
    const $d90d8ce15e0e3233$export$dcdf0405aa7e2078 = 'global-settings-system-ui-dashboard-edit';
    const $d90d8ce15e0e3233$export$fb75113636566d39 = 'global-settings-system-look';
    const $d90d8ce15e0e3233$export$e27baa0c7747e67f = 'global-settings-system-ui-default-user-preferences-apply';
    const $d90d8ce15e0e3233$export$40d189100899f572 = 'global-settings-system-default-settings';
    const $d90d8ce15e0e3233$export$f9ccf81fdbc46591 = `${$d90d8ce15e0e3233$export$b5f9c9cfeafb79a2}-helpcenter`;
    const $d90d8ce15e0e3233$export$341933b279728599 = $d90d8ce15e0e3233$export$f8cea29bebf098c;
    const $d90d8ce15e0e3233$export$ae4b815061537207 = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-customer-notifications`;
    const $d90d8ce15e0e3233$export$e4fb7ce0fc5e3a75 = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-customer-access`;
    const $d90d8ce15e0e3233$export$5cd0dd5a6be6aa2b = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-email`;
    const $d90d8ce15e0e3233$export$bee46016693b19dc = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-kb`;
    const $d90d8ce15e0e3233$export$ca253bc3d237c17f = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-forms`;
    const $d90d8ce15e0e3233$export$a4cba48257cb118a = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-form-edit`;
    const $d90d8ce15e0e3233$export$2e90ab5aa3463c0d = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-web-portal`;
    const $d90d8ce15e0e3233$export$c39a25878c902e0a = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-unassigned-ticket-types-config`;
    const $d90d8ce15e0e3233$export$6eaa6ce8101f6468 = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-unassigned-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$d70320ae3b4d9e43 = 'home-onboarding-redirect';
    const $d90d8ce15e0e3233$export$b2b57cde1fa39bf5 = 'home-redirect';
    const $d90d8ce15e0e3233$export$e8e3b3a04b70a016 = 'issue';
    const $d90d8ce15e0e3233$export$1a3116351e4f3550 = 'issue-create-embed';
    const $d90d8ce15e0e3233$export$6e2629d41c380b47 = 'issue-embed';
    const $d90d8ce15e0e3233$export$ced38e55e6d33a4e = 'jira-search';
    const $d90d8ce15e0e3233$export$d61d16755cb40ff3 = 'knowledge-hub-all-articles';
    const $d90d8ce15e0e3233$export$bb6392f1b2e80781 = 'kb-article-embed-editor';
    const $d90d8ce15e0e3233$export$6fd25e722e91a0d8 = 'knowledge-hub-article-in-category';
    const $d90d8ce15e0e3233$export$18f32f825e7a5a6f = 'knowledge-hub-browse-all-articles';
    const $d90d8ce15e0e3233$export$b17f22f274f4cd5e = 'knowledge-hub-browse-all-categories';
    const $d90d8ce15e0e3233$export$285854ec33f7cc = 'knowledge-hub-browse-view-article';
    const $d90d8ce15e0e3233$export$77cf9c44bbdaa05b = 'knowledge-hub-category';
    const $d90d8ce15e0e3233$export$d6f1b92110a16f2a = 'knowledge-hub-category-page';
    const $d90d8ce15e0e3233$export$fea47b97c6086336 = 'knowledge-hub-drafts';
    const $d90d8ce15e0e3233$export$264d0a2b60d052cd = 'knowledge-hub-suggested-topics';
    const $d90d8ce15e0e3233$export$991ba0c465b48539 = 'knowledge-hub-landing';
    const $d90d8ce15e0e3233$export$904b472d57dee40d = 'knowledge-hub-search';
    const $d90d8ce15e0e3233$export$bbe98dfa7f6a1e4a = 'knowledge-hub-search-articles';
    const $d90d8ce15e0e3233$export$8cfdaccf43a32440 = 'knowledge-hub-setup';
    const $d90d8ce15e0e3233$export$37bd400c00057d64 = 'legacy-all-reports';
    const $d90d8ce15e0e3233$export$eb66bd587b5f093d = 'legacy-backlog';
    const $d90d8ce15e0e3233$export$521baa72494c2a67 = 'legacy-board';
    const $d90d8ce15e0e3233$export$ca255c93be51d5bc = 'legacy-connect-general';
    const $d90d8ce15e0e3233$export$51e45f736a60769b = 'legacy-connect-project';
    const $d90d8ce15e0e3233$export$2da88c0583f7fff0 = 'legacy-core-reports';
    const $d90d8ce15e0e3233$export$e64c3c8f45d7eb28 = 'legacy-custom-report';
    const $d90d8ce15e0e3233$export$5475ba822739444a = 'legacy-fallback';
    const $d90d8ce15e0e3233$export$8483f5c57513e386 = 'legacy-gin';
    const $d90d8ce15e0e3233$export$93c4d1960660bdb3 = 'legacy-gin-issue';
    const $d90d8ce15e0e3233$export$a5421dcc88027406 = 'legacy-gin-quicksearch';
    const $d90d8ce15e0e3233$export$81d5ef2e5cb06446 = 'legacy-gin-subscriptions';
    const $d90d8ce15e0e3233$export$bf4001a5c23bef67 = 'legacy-issue';
    const $d90d8ce15e0e3233$export$77f5621cd10b53c5 = 'legacy-jsd-customers';
    const $d90d8ce15e0e3233$export$93a199a38574778b = 'legacy-jsd-customer-permissions';
    const $d90d8ce15e0e3233$export$41008c2b014795bf = 'legacy-jsd-getting-started';
    const $d90d8ce15e0e3233$export$3001841111579cf2 = 'legacy-jsd-jira-automation';
    const $d90d8ce15e0e3233$export$28dc2fac9c08502e = 'legacy-jsd-knowledge';
    const $d90d8ce15e0e3233$export$4487dfcd6dce7088 = 'legacy-jsd-queues';
    const $d90d8ce15e0e3233$export$c344587fa7092e8c = 'legacy-jsd-queues-manage';
    const $d90d8ce15e0e3233$export$3fbd487079a23c0f = 'legacy-jsd-reports';
    const $d90d8ce15e0e3233$export$d6822df31c37b21a = 'legacy-jsd-reports-custom';
    const $d90d8ce15e0e3233$export$d39bcac6fced7707 = 'legacy-jsd-settings-fallback';
    const $d90d8ce15e0e3233$export$da975f212e8a3e43 = 'legacy-jsd-settings-language';
    const $d90d8ce15e0e3233$export$6e6feddeb62a0825 = 'legacy-jsd-settings-language-pages';
    const $d90d8ce15e0e3233$export$d3822e148f92bddb = 'legacy-jsd-settings-portal-pages';
    const $d90d8ce15e0e3233$export$d7df906c2ffbeab4 = 'legacy-jsd-widgets';
    const $d90d8ce15e0e3233$export$c71836085985a7d3 = 'legacy-pin';
    const $d90d8ce15e0e3233$export$a17a19a9de903839 = 'legacy-project-releases';
    const $d90d8ce15e0e3233$export$e66c1e847a52ebb5 = 'legacy-project-releases-bamboo';
    const $d90d8ce15e0e3233$export$f0254c80025ed0fc = 'legacy-project-releases-note';
    const $d90d8ce15e0e3233$export$1d4a64220d5b474d = 'legacy-project-releases-note-config';
    const $d90d8ce15e0e3233$export$8af215d394bc18c1 = 'legacy-project-settings-collectors';
    const $d90d8ce15e0e3233$export$b6b536a795b08b39 = 'legacy-project-settings-collectors-add';
    const $d90d8ce15e0e3233$export$59cde094247fca1a = 'legacy-project-settings-collectors-help';
    const $d90d8ce15e0e3233$export$d27bf19e22921164 = 'legacy-project-settings-collectors-view';
    const $d90d8ce15e0e3233$export$3467807847c0a87d = 'legacy-project-settings-config';
    const $d90d8ce15e0e3233$export$1996eeee6a067f1c = 'project-settings-classic-data-classifications';
    const $d90d8ce15e0e3233$export$ec7cb9394e8994c9 = 'legacy-project-settings-delete';
    const $d90d8ce15e0e3233$export$f01730982626c4af = 'legacy-project-settings-dev';
    const $d90d8ce15e0e3233$export$9d1758ddc1563e90 = 'legacy-project-settings-edit';
    const $d90d8ce15e0e3233$export$ecff223feb9d08be = 'legacy-project-settings-fields';
    const $d90d8ce15e0e3233$export$487bc26cddb34312 = 'legacy-project-settings-fields-associate';
    const $d90d8ce15e0e3233$export$118290072826cd87 = 'legacy-project-settings-issue-layout';
    const $d90d8ce15e0e3233$export$e5994b7b1acebe82 = 'legacy-project-settings-issue-security';
    const $d90d8ce15e0e3233$export$84b0e53f785e02cf = 'legacy-project-settings-issue-security-associate';
    const $d90d8ce15e0e3233$export$d58992a667105ce8 = 'legacy-project-settings-issue-types';
    const $d90d8ce15e0e3233$export$bb1cea2d23743f65 = 'legacy-project-settings-issue-types-associate';
    const $d90d8ce15e0e3233$export$76dac5f55ab3705e = 'legacy-project-settings-notifications';
    const $d90d8ce15e0e3233$export$a7c4adb03bc6e997 = 'legacy-project-settings-notifications-associate';
    const $d90d8ce15e0e3233$export$2dc565d0b2334780 = 'legacy-project-settings-opsgenie';
    const $d90d8ce15e0e3233$export$28687a1181a7676f = 'legacy-project-settings-people';
    const $d90d8ce15e0e3233$export$2e74a7026073fa54 = 'legacy-project-settings-permissions';
    const $d90d8ce15e0e3233$export$58fdfc78d176c564 = 'legacy-project-settings-permissions-associate';
    const $d90d8ce15e0e3233$export$cb8548f16119b181 = 'legacy-project-settings-screens';
    const $d90d8ce15e0e3233$export$66e3f6af203a567f = 'legacy-project-settings-screens-associate';
    const $d90d8ce15e0e3233$export$658e7e21f1c7b69b = 'legacy-project-settings-summary';
    const $d90d8ce15e0e3233$export$1fa628a4527d424c = 'legacy-project-settings-workflows';
    const $d90d8ce15e0e3233$export$c2989c5c00f9f64b = 'legacy-project-settings-workflows-associate';
    const $d90d8ce15e0e3233$export$2d21e5416485b195 = 'legacy-redirect';
    const $d90d8ce15e0e3233$export$e514491aa85dd54a = 'legacy-reports-average-age-report';
    const $d90d8ce15e0e3233$export$d9662297242bfcb5 = 'legacy-reports-configure';
    const $d90d8ce15e0e3233$export$2a53516b15393945 = 'legacy-reports-created-vs-resolved-report';
    const $d90d8ce15e0e3233$export$62e00190aa938a43 = 'legacy-reports-developer-workload-report';
    const $d90d8ce15e0e3233$export$22a3924a6eab79ab = 'legacy-reports-pie-report';
    const $d90d8ce15e0e3233$export$677cf3d89d18bb74 = 'legacy-reports-recently-created-report';
    const $d90d8ce15e0e3233$export$7eef86163449ad98 = 'legacy-reports-resolution-time-report';
    const $d90d8ce15e0e3233$export$8f56061e1403fa5a = 'legacy-reports-single-level-group-by-report';
    const $d90d8ce15e0e3233$export$adeb429de8df1e02 = 'legacy-reports-time-since-report';
    const $d90d8ce15e0e3233$export$931d6222073b5708 = 'legacy-reports-time-tracking-report';
    const $d90d8ce15e0e3233$export$2106f1ac8ba807e1 = 'legacy-reports-version-workload-report';
    const $d90d8ce15e0e3233$export$36678521a86f620b = 'legacy-reports-workload-pie-report';
    const $d90d8ce15e0e3233$export$55248356780fc584 = 'login-embed';
    const $d90d8ce15e0e3233$export$cd84c5a333c8d16a = 'global-settings-addons-emcee';
    const $d90d8ce15e0e3233$export$624af6f61b05f55 = 'addons-emcee-public';
    const $d90d8ce15e0e3233$export$2ed9525182145b82 = 'marketplace-app-requests';
    const $d90d8ce15e0e3233$export$7fb2b42fc4e7df8b = 'marketplace-index';
    const $d90d8ce15e0e3233$export$fa962db82ae571b2 = 'global-settings-addons-upm';
    const $d90d8ce15e0e3233$export$e145bf76b1aef705 = 'marketplace-promotions';
    const $d90d8ce15e0e3233$export$8febbfb647e4c8b9 = 'notification-logs';
    const $d90d8ce15e0e3233$export$4b34f3d336f4ccd2 = 'opsgenie-schedule';
    const $d90d8ce15e0e3233$export$a979a5c1f5e3631c = 'people-index';
    const $d90d8ce15e0e3233$export$ffcbf91dfadffd0 = 'personal-settings';
    const $d90d8ce15e0e3233$export$1807a39cc63b856c = 'personal-settings-general';
    const $d90d8ce15e0e3233$export$2be8d3c6fedd5276 = 'personal-settings-notifications';
    const $d90d8ce15e0e3233$export$6268da7263eb670d = 'personal-settings-ops-notifications';
    const $d90d8ce15e0e3233$export$93bd4a896a0fc581 = 'plans-directory';
    const $d90d8ce15e0e3233$export$2b9b1bfb538ab810 = 'project-settings-playbooks-edit';
    const $d90d8ce15e0e3233$export$d1217085321b2648 = 'project-settings-playbooks-list';
    const $d90d8ce15e0e3233$export$39624171b7c8a10a = 'polaris-collections';
    const $d90d8ce15e0e3233$export$1654cd6813e90e6b = 'polaris-ideas';
    const $d90d8ce15e0e3233$export$33059cd02df2febd = 'polaris-insights';
    const $d90d8ce15e0e3233$export$1d746ff2bc48ceb4 = 'polaris-onboarding';
    const $d90d8ce15e0e3233$export$145c578104a45fd2 = 'polaris-plays';
    const $d90d8ce15e0e3233$export$a51df1bc877c58e5 = 'polaris-rooms';
    const $d90d8ce15e0e3233$export$45208fff8de46880 = 'polaris-settings-access';
    const $d90d8ce15e0e3233$export$c710a35d40378fa5 = 'polaris-settings-global-fields';
    const $d90d8ce15e0e3233$export$15d6b93ff5273ce3 = 'polaris-unlicensed';
    const $d90d8ce15e0e3233$export$e26f2863c7ccd504 = 'products-jsm-authentication-settings';
    const $d90d8ce15e0e3233$export$496da9aa0fe819ff = 'products-jsm-chatops-and-videos-tools';
    const $d90d8ce15e0e3233$export$f7bbc23b5f8e2d3b = 'products-jsm-compliance';
    const $d90d8ce15e0e3233$export$53ce69fb34f6d286 = 'products-jsm-configuration';
    const $d90d8ce15e0e3233$export$b6e861786143eb1b = 'products-jsm-customer-access';
    const $d90d8ce15e0e3233$export$f7e3d3b413c017e1 = 'products-jsm-email-requests';
    const $d90d8ce15e0e3233$export$b84d34b8175abde5 = 'products-jsm-feature-usage';
    const $d90d8ce15e0e3233$export$50e4e3e5231fb74f = 'products-jsm-global-ops-reports';
    const $d90d8ce15e0e3233$export$39d913ae557ba8f3 = 'products-jsm-incident-management-tools';
    const $d90d8ce15e0e3233$export$a2d9bcceac584c93 = 'products-jsm-kb-permissions';
    const $d90d8ce15e0e3233$export$eb2e5f1608ec8b32 = 'products-jsm-organizations';
    const $d90d8ce15e0e3233$export$9ac90b948c53bf58 = 'products-jsw-configuration';
    const $d90d8ce15e0e3233$export$bb5665894498893f = 'products-jsw-storage-management';
    const $d90d8ce15e0e3233$export$dd4c319b26f01664 = 'proforma-export';
    const $d90d8ce15e0e3233$export$a934caa57ac0ac0b = 'classic-business-proforma-issue-forms-direct';
    const $d90d8ce15e0e3233$export$25a4e6c77f91c259 = 'servicedesk-proforma-issue-forms-direct';
    const $d90d8ce15e0e3233$export$2a9a9bab313fd713 = 'software-proforma-issue-forms-direct';
    const $d90d8ce15e0e3233$export$82ad2da638fc34d8 = 'classic-business-proforma-issue-forms-direct-embed';
    const $d90d8ce15e0e3233$export$ff67cffdbd881a41 = 'servicedesk-proforma-issue-forms-direct-embed';
    const $d90d8ce15e0e3233$export$c41c7d73df3fc08c = 'software-proforma-issue-forms-direct-embed';
    const $d90d8ce15e0e3233$export$f07fd5696f888ae = 'proforma-issue-forms-general';
    const $d90d8ce15e0e3233$export$ff1365ce4d652337 = 'projects-directory';
    const $d90d8ce15e0e3233$export$79b30013cbfdee04 = 'projects-directory-legacy-path-spa';
    const $d90d8ce15e0e3233$export$33c2dcc7c7abc45e = 'projects-directory-manage';
    const $d90d8ce15e0e3233$export$a6ef20aa08a533b1 = 'projects-redirect';
    const $d90d8ce15e0e3233$export$5908e15483da8a45 = 'project-components';
    const $d90d8ce15e0e3233$export$a3812f6f4e60d897 = 'project-directory-redirect';
    const $d90d8ce15e0e3233$export$3c8c119f40a061a9 = 'issue-navigator';
    const $d90d8ce15e0e3233$export$47e034646abefdb2 = 'issue-navigator-classic';
    const $d90d8ce15e0e3233$export$f36f4cf8b17f250f = 'issue-navigator-core';
    const $d90d8ce15e0e3233$export$841e880a0d425b3e = 'project-not-found';
    const $d90d8ce15e0e3233$export$1fde4a6e7df24a97 = 'project-pages';
    const $d90d8ce15e0e3233$export$69335bf8b709edc7 = 'project-settings-automation';
    const $d90d8ce15e0e3233$export$946b472f7559a889 = 'project-settings-components';
    const $d90d8ce15e0e3233$export$373fdf6888021ed0 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-access`;
    const $d90d8ce15e0e3233$export$d6a5f13a3d30923c = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-access-redirect`;
    const $d90d8ce15e0e3233$export$adfff93b0b015409 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-approvals`;
    const $d90d8ce15e0e3233$export$404de4ddea701cff = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-apps`;
    const $d90d8ce15e0e3233$export$596e1f6f6f4997b2 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-apps-fields`;
    const $d90d8ce15e0e3233$export$8da0e4cdbdd0cd0b = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-automation`;
    const $d90d8ce15e0e3233$export$d610a17dff3a01fa = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-data-classifications`;
    const $d90d8ce15e0e3233$export$284db5107f3db516 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-redirect`;
    const $d90d8ce15e0e3233$export$fbce46826eefc586 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-details`;
    const $d90d8ce15e0e3233$export$c86b29c76317ac6f = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-fields`;
    const $d90d8ce15e0e3233$export$3160b86e1b5dc391 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-forge-apps`;
    const $d90d8ce15e0e3233$export$690c0080c930fca = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-issuetypes`;
    const $d90d8ce15e0e3233$export$171ba8c33c05c4ef = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-issuetypes-workflow`;
    const $d90d8ce15e0e3233$export$e2f2c23286c3255c = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications`;
    const $d90d8ce15e0e3233$export$5a262d40e10207a1 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications-issue-logs`;
    const $d90d8ce15e0e3233$export$ab790cb87175797e = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications-notification-email`;
    const $d90d8ce15e0e3233$export$db780b39656c673a = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-jira-form-builder`;
    const $d90d8ce15e0e3233$export$a77cb4dafc511d3 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-project-forms`;
    const $d90d8ce15e0e3233$export$253fd82874264ee4 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-forge-apps`;
    const $d90d8ce15e0e3233$export$eaf9ab4ec0c25813 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-apps-forge`;
    const $d90d8ce15e0e3233$export$574bcdf6b73fcf1f = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-apps-fields`;
    const $d90d8ce15e0e3233$export$a14853dfff8da872 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-chat`;
    const $d90d8ce15e0e3233$export$ba8fd0e6db8d3e08 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-customer-notifications`;
    const $d90d8ce15e0e3233$export$1c74da1e52e6d212 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-customer-permissions`;
    const $d90d8ce15e0e3233$export$d416059b17fe7d4e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-email`;
    const $d90d8ce15e0e3233$export$d5a3a037d2760bb7 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-widget`;
    const $d90d8ce15e0e3233$export$eb187d42a7448d45 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-internal-notifications-nextGen`;
    const $d90d8ce15e0e3233$export$688de32d31fc70f5 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-details`;
    const $d90d8ce15e0e3233$export$13d770f8814d480a = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-forge-apps`;
    const $d90d8ce15e0e3233$export$3a628f9376166ffb = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-itsm-ticket-types-config`;
    const $d90d8ce15e0e3233$export$649dafa225625f30 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-itsm-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$dbfe76dd37018b2 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notifications`;
    const $d90d8ce15e0e3233$export$20db7bb9d1bd8b38 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notifications-notification-email`;
    const $d90d8ce15e0e3233$export$a1fa8e6e125780ae = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notification-email`;
    const $d90d8ce15e0e3233$export$fc6b949fd2bc782d = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-portal-settings`;
    const $d90d8ce15e0e3233$export$c940f866ac7760a0 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-ticket-types-config`;
    const $d90d8ce15e0e3233$export$184d4979f6f9fe7e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$959f50de166cc45e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-unassigned-ticket-types-config`;
    const $d90d8ce15e0e3233$export$b13b8c8bb4e30a75 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-unassigned-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$40d6fc2b9a4f09d2 = 'project-settings-software-access';
    const $d90d8ce15e0e3233$export$cc1af211e3feda50 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-apps-fields`;
    const $d90d8ce15e0e3233$export$3873539001f5aed7 = 'project-settings-software-automation';
    const $d90d8ce15e0e3233$export$89fcbafce559080b = 'project-settings-software-boards-card';
    const $d90d8ce15e0e3233$export$c3f05da9e4e13249 = 'project-settings-software-boards-csm';
    const $d90d8ce15e0e3233$export$619694ab37142384 = 'project-settings-software-boards-custom-filters';
    const $d90d8ce15e0e3233$export$cb89b516b9cf418b = 'project-settings-software-boards-details';
    const $d90d8ce15e0e3233$export$50680f54e95bb859 = 'project-settings-software-boards-features';
    const $d90d8ce15e0e3233$export$194c2b4da7e38757 = 'project-settings-software-boards-insights';
    const $d90d8ce15e0e3233$export$962d838817f090f8 = 'project-settings-software-boards-redirect';
    const $d90d8ce15e0e3233$export$eacbdb340a470309 = 'project-settings-software-boards-roadmap';
    const $d90d8ce15e0e3233$export$6a7782d87a21425d = 'project-settings-software-boards-swimlanes';
    const $d90d8ce15e0e3233$export$c2f56336162e799e = 'project-settings-software-boards-timeline';
    const $d90d8ce15e0e3233$export$ba419378ad70624e = 'project-settings-software-data-classifications';
    const $d90d8ce15e0e3233$export$62f38c589a73d386 = 'project-settings-software-details';
    const $d90d8ce15e0e3233$export$77c8066c0822f152 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-fields`;
    const $d90d8ce15e0e3233$export$90900ebfa6f48861 = 'project-settings-software-next-gen-features';
    const $d90d8ce15e0e3233$export$93ff02c205edd1a8 = 'project-settings-software-issuetypes';
    const $d90d8ce15e0e3233$export$db7f5d93be70ee30 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-notifications`;
    const $d90d8ce15e0e3233$export$432229516b7f82da = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-notifications-issue-logs`;
    const $d90d8ce15e0e3233$export$8f554d4ef9f084c0 = 'project-settings-software-notifications-notification-email';
    const $d90d8ce15e0e3233$export$6b2b99b0055772a3 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-link-opsgenie`;
    const $d90d8ce15e0e3233$export$83c7a51057be6264 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-toolchain-team-managed`;
    const $d90d8ce15e0e3233$export$46706d786aab3829 = 'project-settings-versions';
    const $d90d8ce15e0e3233$export$b690025ef7e3cf6c = 'project-versions';
    const $d90d8ce15e0e3233$export$ea48cc6bf1183d11 = 'rapidboard';
    const $d90d8ce15e0e3233$export$930e4881302bbd54 = 'rapidboard-backlog';
    const $d90d8ce15e0e3233$export$375801b708576466 = 'rapidboard-backlog-embed';
    const $d90d8ce15e0e3233$export$5b1e8463bd590143 = 'rapidboard-board';
    const $d90d8ce15e0e3233$export$1606662a398a24be = 'rapidboard-board-embed';
    const $d90d8ce15e0e3233$export$83a890b48b63829a = 'rapidboard-board-pretty-url-redirect';
    const $d90d8ce15e0e3233$export$c5b19a37e49ceb28 = 'rapidboard-last-visited-project-redirect';
    const $d90d8ce15e0e3233$export$c46680afe70295f3 = 'rapidboard-report';
    const $d90d8ce15e0e3233$export$831fc7eba98b58c9 = 'rapidboard-uif-backlog';
    const $d90d8ce15e0e3233$export$4061c0c586f3b7c8 = 'rapidboard-user-backlog';
    const $d90d8ce15e0e3233$export$99e0abd8ba1de289 = 'rapidboard-user-board';
    const $d90d8ce15e0e3233$export$cd96a6a0cc4831ab = 'rapidboard-user-report';
    const $d90d8ce15e0e3233$export$36e61e70347174cc = 'rovo-demand-tests';
    const $d90d8ce15e0e3233$export$3bddd65f2541c4d = 'sandbox-bundler';
    const $d90d8ce15e0e3233$export$db1b3d2fee80859 = 'servicedesk-atlassian-analytics';
    const $d90d8ce15e0e3233$export$b0f3f3214ab1b150 = 'servicedesk-project-summary';
    const $d90d8ce15e0e3233$export$fb4e3ee7e7c21e9f = 'servicedesk-boards';
    const $d90d8ce15e0e3233$export$8c8f03e75b6708ac = 'servicedesk-calendar';
    const $d90d8ce15e0e3233$export$3c3d8caf61c9aa0c = 'servicedesk-change-calendar';
    const $d90d8ce15e0e3233$export$f9cc808094ce0ddd = 'servicedesk-cmdb-assets';
    const $d90d8ce15e0e3233$export$9bde4a0b155f2972 = 'servicedesk-cmdb-configure';
    const $d90d8ce15e0e3233$export$a52f5ffbbe135078 = 'servicedesk-cmdb-object';
    const $d90d8ce15e0e3233$export$e6773bf0fbccdb9c = 'servicedesk-cmdb-object-schema';
    const $d90d8ce15e0e3233$export$8e3dd8487a7b65bd = 'servicedesk-cmdb-object-schema-configuration';
    const $d90d8ce15e0e3233$export$258b44fcc29a5961 = 'servicedesk-cmdb-object-type-configuration';
    const $d90d8ce15e0e3233$export$ea1146ebce07be6d = 'servicedesk-cmdb-assets-reports';
    const $d90d8ce15e0e3233$export$53731240ce2d3b76 = 'servicedesk-cmdb-assets-reports-default-redirect';
    const $d90d8ce15e0e3233$export$956eb40834ddee22 = 'servicedesk-cmdb-assets-reports-unsubscribe';
    const $d90d8ce15e0e3233$export$9057470ebf41169 = 'servicedesk-cmdb-manage-object-schemas';
    const $d90d8ce15e0e3233$export$c42e107c5275b36 = 'servicedesk-cmdb-insight';
    const $d90d8ce15e0e3233$export$3e7c6a54a9d2267a = 'servicedesk-cmdb-configure';
    const $d90d8ce15e0e3233$export$c3e2697b35a149c4 = 'servicedesk-cmdb-landing-page';
    const $d90d8ce15e0e3233$export$288c7dd61dd0c291 = 'servicedesk-cmdb-object';
    const $d90d8ce15e0e3233$export$37161a981d69c891 = 'servicedesk-cmdb-object-schema';
    const $d90d8ce15e0e3233$export$cfe61aa92a4d585d = 'servicedesk-cmdb-object-schema-configuration';
    const $d90d8ce15e0e3233$export$9ed512ab4c81669c = 'servicedesk-cmdb-object-type-configuration';
    const $d90d8ce15e0e3233$export$37a9bdd8513f462d = 'servicedesk-connect-project';
    const $d90d8ce15e0e3233$export$f01162415f3a2ee3 = 'servicedesk-create-project';
    const $d90d8ce15e0e3233$export$860dd13b1e836ed8 = 'servicedesk-customers-v2';
    const $d90d8ce15e0e3233$export$5eaf1dce55090ff3 = 'servicedesk-customer-details';
    const $d90d8ce15e0e3233$export$1fe309e7cdbd1c1 = 'servicedesk-customer-service-escalations';
    const $d90d8ce15e0e3233$export$fcd9750494ff0236 = 'servicedesk-customer-service-products';
    const $d90d8ce15e0e3233$export$ad856b38e93b93b2 = 'servicedesk-early-access-itsm';
    const $d90d8ce15e0e3233$export$a833209ca71d2e56 = 'servicedesk-getting-started-page';
    const $d90d8ce15e0e3233$export$829d1776460a6ad3 = 'servicedesk-incidents';
    const $d90d8ce15e0e3233$export$d30ab2da08d8b7b9 = 'servicedesk-index';
    const $d90d8ce15e0e3233$export$3c71889849aeaa08 = 'servicedesk-issue';
    const $d90d8ce15e0e3233$export$354bf2df81f6ffb0 = 'servicedesk-issues';
    const $d90d8ce15e0e3233$export$f8880b461acd270d = 'servicedesk-itsm-sample-space';
    const $d90d8ce15e0e3233$export$876055c0ede2f8df = 'servicedesk-automation';
    const $d90d8ce15e0e3233$export$bf493c66e34711c8 = 'servicedesk-kb-requests-reports';
    const $d90d8ce15e0e3233$export$212f6e2c7c2a53bb = 'servicedesk-kb-requests-reports-time-scale-issue';
    const $d90d8ce15e0e3233$export$7c28c6e8d8a6545 = 'servicedesk-kb-requests-reports-time-scale';
    const $d90d8ce15e0e3233$export$8d55b6ef2cd92f8c = 'servicedesk-oncall-schedule';
    const $d90d8ce15e0e3233$export$f7fbe9a4717b7a50 = 'servicedesk-organizations';
    const $d90d8ce15e0e3233$export$8c800f176d079d28 = 'servicedesk-organization-details';
    const $d90d8ce15e0e3233$export$1c5fbcbfc0923176 = 'servicedesk-organization_v2';
    const $d90d8ce15e0e3233$export$59644e5d8d69a016 = 'servicedesk-practice-custom-and-issue';
    const $d90d8ce15e0e3233$export$c7074ebe0ca83f98 = 'servicedesk-practice-edit';
    const $d90d8ce15e0e3233$export$2b4737953287a354 = 'servicedesk-practice-issue';
    const $d90d8ce15e0e3233$export$e7a8d6d534c5e2fe = 'servicedesk-practice-landing';
    const $d90d8ce15e0e3233$export$5dcba309e2bfa88b = 'servicedesk-practice-manage-view';
    const $d90d8ce15e0e3233$export$2d961b0101f8733e = 'servicedesk-practice-new';
    const $d90d8ce15e0e3233$export$195fe2558f1a8591 = 'servicedesk-project-conversion';
    const $d90d8ce15e0e3233$export$1b3cf68be370a45b = 'servicedesk-queues-addon';
    const $d90d8ce15e0e3233$export$45c35381e5da2232 = 'servicedesk-queues-custom-and-issue';
    const $d90d8ce15e0e3233$export$d479ba53b9bf65a = 'servicedesk-queues-edit';
    const $d90d8ce15e0e3233$export$ccd12890649c59cc = 'servicedesk-queues-issue';
    const $d90d8ce15e0e3233$export$8c84064031188e80 = 'servicedesk-queues-landing';
    const $d90d8ce15e0e3233$export$46c6fef035fbe8ba = 'servicedesk-queues-manage-view';
    const $d90d8ce15e0e3233$export$6fb23ec5a12d5c24 = 'servicedesk-queues-new';
    const $d90d8ce15e0e3233$export$156b2dfbd87d576f = 'servicedesk-redirect';
    const $d90d8ce15e0e3233$export$6961f1ed0407cb26 = 'servicedesk-reports';
    const $d90d8ce15e0e3233$export$ba284efd679bf637 = 'servicedesk-reports-custom';
    const $d90d8ce15e0e3233$export$e48a3df597407767 = 'servicedesk-reports-custom-create';
    const $d90d8ce15e0e3233$export$c73718d4a6efea1d = 'servicedesk-reports-custom-edit';
    const $d90d8ce15e0e3233$export$ed454783ba1bacb9 = 'servicedesk-reports-custom-time-scale-issue';
    const $d90d8ce15e0e3233$export$48f6285d4729ca9d = 'servicedesk-reports-custom-time-scale';
    const $d90d8ce15e0e3233$export$8066418cead2d2ef = 'servicedesk-reports-satisfaction';
    const $d90d8ce15e0e3233$export$b3db7857ac710a89 = 'servicedesk-reports-satisfaction-time-scale-issue';
    const $d90d8ce15e0e3233$export$d574810e3edad044 = 'servicedesk-reports-satisfaction-time-scale';
    const $d90d8ce15e0e3233$export$be4b2ffade787316 = 'servicedesk-reports-summary';
    const $d90d8ce15e0e3233$export$3caf79b5f4be02d7 = 'servicedesk-reports-type';
    const $d90d8ce15e0e3233$export$29bc361328055683 = 'servicedesk-reports-workload';
    const $d90d8ce15e0e3233$export$a4a5a333fe874d97 = 'servicedesk-services';
    const $d90d8ce15e0e3233$export$2193b681ac1ae132 = 'servicedesk-services-new';
    const $d90d8ce15e0e3233$export$f1bfd5b3918619a9 = 'servicedesk-services-without-project';
    const $d90d8ce15e0e3233$export$a4c4f7898d6b914a = 'servicedesk-service-details';
    const $d90d8ce15e0e3233$export$6cffae90b9277bb = 'servicedesk-service-details-new';
    const $d90d8ce15e0e3233$export$17e76ebd53424ed5 = 'servicedesk-service-details-without-project';
    const $d90d8ce15e0e3233$export$b1329dc26a81a277 = 'servicedesk-service-modal-edit';
    const $d90d8ce15e0e3233$export$e1cba0bfe330f5c = 'servicedesk-service-modal-new';
    const $d90d8ce15e0e3233$export$8e68c55c334de101 = 'servicedesk-sla-settings';
    const $d90d8ce15e0e3233$export$5cb7cfba189a0240 = 'service-hub-services';
    const $d90d8ce15e0e3233$export$d28aab4a6d6f1d0d = 'service-hub-service-details';
    const $d90d8ce15e0e3233$export$1cf56e2d6c4edb35 = 'global-automation';
    const $d90d8ce15e0e3233$export$27c1770584d7e3fe = 'global-settings-issues-cmdb-field-config';
    const $d90d8ce15e0e3233$export$22e0ebdea08537f7 = 'admin-oauth-credentials';
    const $d90d8ce15e0e3233$export$4db732436e4edfaf = 'recommendations';
    const $d90d8ce15e0e3233$export$e832418dbed0717e = 'view-custom-fields';
    const $d90d8ce15e0e3233$export$ee09be798f0e4471 = 'software-advanced-roadmaps';
    const $d90d8ce15e0e3233$export$653bf90ae3578f21 = 'software-advanced-roadmaps-getting-started-redirect';
    const $d90d8ce15e0e3233$export$9da4125a0c62444d = 'software-advanced-roadmaps-redirect';
    const $d90d8ce15e0e3233$export$fbcc0fd9b402bb12 = 'software-advanced-roadmaps-setup';
    const $d90d8ce15e0e3233$export$e74fe5bd41e23fbd = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-dependencies`;
    const $d90d8ce15e0e3233$export$1a93e63ddbe4aa06 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-dependencies-redirect`;
    const $d90d8ce15e0e3233$export$3b6dbbe49882589d = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-financial-year`;
    const $d90d8ce15e0e3233$export$eb01394789016fd4 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-loading-limits`;
    const $d90d8ce15e0e3233$export$f17f4523583fa8e5 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-loading-limits-redirect`;
    const $d90d8ce15e0e3233$export$eaa4d6eec75a6778 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-permissions`;
    const $d90d8ce15e0e3233$export$dcc96e4abbdc0d39 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-permissions-redirect`;
    const $d90d8ce15e0e3233$export$9eaf39ba5a56c72a = 'software-backlog';
    const $d90d8ce15e0e3233$export$495be3320b67814a = 'software-backlog-embed';
    const $d90d8ce15e0e3233$export$25752eb5bb5e3d32 = 'software-boards';
    const $d90d8ce15e0e3233$export$f116716aedb35e10 = 'software-boards-embed';
    const $d90d8ce15e0e3233$export$36fffb6b49d9f31d = 'software-calendar';
    const $d90d8ce15e0e3233$export$a6d07be4ff318f84 = 'software-calendar-classic';
    const $d90d8ce15e0e3233$export$a9a43f1114df1ad9 = 'software-calendar-classic-embed';
    const $d90d8ce15e0e3233$export$3a4c7a521a900b4d = 'software-calendar-embed';
    const $d90d8ce15e0e3233$export$9dcf51a9040a4fd6 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-proforma-issue-forms-direct`;
    const $d90d8ce15e0e3233$export$a74f9f6bd0d4fb26 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-proforma-issue-forms-direct-embed`;
    const $d90d8ce15e0e3233$export$f8cb86acf6b74661 = 'software-code';
    const $d90d8ce15e0e3233$export$2d3d850c64058bfb = 'software-code-classic';
    const $d90d8ce15e0e3233$export$af6b51164f66908b = 'software-deployments';
    const $d90d8ce15e0e3233$export$12efc96fc9c9fb34 = 'software-deployments-classic';
    const $d90d8ce15e0e3233$export$6ab1901e04e623ba = 'software-form';
    const $d90d8ce15e0e3233$export$bccc7d0812737c4e = 'software-form-classic';
    const $d90d8ce15e0e3233$export$458fb992f2637a20 = 'software-form-builder';
    const $d90d8ce15e0e3233$export$c9c9c64f68ba51e3 = 'software-form-builder-classic';
    const $d90d8ce15e0e3233$export$50264cbc90a39f19 = 'software-form-submit';
    const $d90d8ce15e0e3233$export$fd12b611e297e41f = 'software-form-submit-embed';
    const $d90d8ce15e0e3233$export$b9d0cbe0888fa72e = 'software-form-submit-classic';
    const $d90d8ce15e0e3233$export$92ee2005b2bb1c0e = 'software-form-submit-classic-embed';
    const $d90d8ce15e0e3233$export$b8045610416fa8ca = 'software-goals';
    const $d90d8ce15e0e3233$export$8e80136ad13099e3 = 'software-goals-classic';
    const $d90d8ce15e0e3233$export$b5fe44c0bc324494 = 'software-incidents';
    const $d90d8ce15e0e3233$export$7a4f52d9060a20d2 = 'software-incidents-classic';
    const $d90d8ce15e0e3233$export$d6a9e4695952522e = 'software-issue-navigator';
    const $d90d8ce15e0e3233$export$deab88d0814c564b = 'software-list';
    const $d90d8ce15e0e3233$export$906faff110f898ef = 'software-list-classic';
    const $d90d8ce15e0e3233$export$ab3f2a34a3b0db87 = 'software-list-classic-embed';
    const $d90d8ce15e0e3233$export$4ed84a2011fdc400 = 'software-list-embed';
    const $d90d8ce15e0e3233$export$f7b286b39bf6051b = 'software-nextgen-redirect';
    const $d90d8ce15e0e3233$export$6c4337c0332c8c7f = 'software-onboarding';
    const $d90d8ce15e0e3233$export$e7c78887745b2326 = 'software-onboarding-get-started';
    const $d90d8ce15e0e3233$export$3805e4f07dca7584 = 'software-periscope';
    const $d90d8ce15e0e3233$export$f77254983320e888 = 'software-periscope-classic';
    const $d90d8ce15e0e3233$export$2e784832f1c6bb = 'software-plan-calendar';
    const $d90d8ce15e0e3233$export$7f97fa79520a4c5b = 'software-plan-calendar-embed';
    const $d90d8ce15e0e3233$export$9e53cdb1ac02195c = 'software-plan-dependencies';
    const $d90d8ce15e0e3233$export$58bd507904dc221c = 'software-plan-dependencies-embed';
    const $d90d8ce15e0e3233$export$7a821e22be2c2f14 = 'software-plan-increment';
    const $d90d8ce15e0e3233$export$ca8966ef80bfafc6 = 'software-plan-increment-embed';
    const $d90d8ce15e0e3233$export$e7423156dba31a7c = 'software-plan-increments';
    const $d90d8ce15e0e3233$export$cba7e383b2409c7b = 'software-plan-releases';
    const $d90d8ce15e0e3233$export$d5378fb71d5242c0 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-auto-scheduler`;
    const $d90d8ce15e0e3233$export$4b16b72c72da8833 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-custom-fields`;
    const $d90d8ce15e0e3233$export$10114d78cefb1f53 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-exclusion-rules`;
    const $d90d8ce15e0e3233$export$92fe23ed30100817 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-find-your-issue`;
    const $d90d8ce15e0e3233$export$e824495554c83069 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-issue-sources`;
    const $d90d8ce15e0e3233$export$8df2e9efdd625a44 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-permissions`;
    const $d90d8ce15e0e3233$export$aeb4d3006e298033 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-plan-info`;
    const $d90d8ce15e0e3233$export$e15d3c40985c4b53 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-program-boards`;
    const $d90d8ce15e0e3233$export$1d8c84454fd2d571 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-removed-issues`;
    const $d90d8ce15e0e3233$export$db61a12efb59745c = `${$d90d8ce15e0e3233$export$6f266218a6973848}-saved-views`;
    const $d90d8ce15e0e3233$export$2da67fb5bd6bc2ee = `${$d90d8ce15e0e3233$export$6f266218a6973848}-scenarios`;
    const $d90d8ce15e0e3233$export$182e0167fd960de6 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-scheduling`;
    const $d90d8ce15e0e3233$export$2d9e2484ee02e7da = 'software-plan-summary';
    const $d90d8ce15e0e3233$export$b7fff19fd89b617f = 'software-plan-summary-embed';
    const $d90d8ce15e0e3233$export$ea23f150f64e8a4e = 'software-plan-teams';
    const $d90d8ce15e0e3233$export$116338bd93f78ad0 = 'software-plan-timeline';
    const $d90d8ce15e0e3233$export$c9cd65a78227cf18 = 'software-advanced-roadmaps-embed';
    const $d90d8ce15e0e3233$export$d75d93e5d44182cc = 'software-release-notes';
    const $d90d8ce15e0e3233$export$cc3027ae3767801 = 'software-reports';
    const $d90d8ce15e0e3233$export$3492ce83b8884e0e = 'software-reports-burndown';
    const $d90d8ce15e0e3233$export$b4798b7e62733393 = 'software-reports-burnup';
    const $d90d8ce15e0e3233$export$388685c701d6e0d3 = 'software-reports-control';
    const $d90d8ce15e0e3233$export$5ff4d2d4257ea2b0 = 'software-reports-cumulative';
    const $d90d8ce15e0e3233$export$fa83895c1eac55e7 = 'software-reports-cycle-time';
    const $d90d8ce15e0e3233$export$5c82bb95a06a1846 = 'software-reports-cycle-time-classic';
    const $d90d8ce15e0e3233$export$c725b9c7e11dd69e = 'software-reports-deployment-frequency';
    const $d90d8ce15e0e3233$export$90594f89c675ba05 = 'software-reports-deployment-frequency-classic';
    const $d90d8ce15e0e3233$export$ae0d999dd2bdd59b = 'software-reports-velocity';
    const $d90d8ce15e0e3233$export$296115eb5b7129d3 = 'software-roadmap';
    const $d90d8ce15e0e3233$export$17574f41c3925d64 = 'software-roadmap-classic';
    const $d90d8ce15e0e3233$export$955692fbfe35fc16 = 'software-roadmap-redirect';
    const $d90d8ce15e0e3233$export$30af3a767b8ad2d8 = 'software-security';
    const $d90d8ce15e0e3233$export$f47d664298c2c2f0 = 'software-security-classic';
    const $d90d8ce15e0e3233$export$2d1ed852d9885250 = 'software-summary';
    const $d90d8ce15e0e3233$export$312796fc15876480 = 'software-summary-classic';
    const $d90d8ce15e0e3233$export$a16645495fb1d5ef = 'software-staffing';
    const $d90d8ce15e0e3233$export$1714b5ad9b672bc7 = 'software-timeline';
    const $d90d8ce15e0e3233$export$c9634bf15518a3a1 = 'software-timeline-classic';
    const $d90d8ce15e0e3233$export$3b5eb3ea8cbeeed = 'software-version-detail';
    const $d90d8ce15e0e3233$export$118bb1785acc3d0b = 'software-version-detail-embed';
    const $d90d8ce15e0e3233$export$c29d90ae9a4b648e = 'software-version-detail-legacy-redirect';
    const $d90d8ce15e0e3233$export$8f2717a951373c25 = 'software-version-detail-no-tab-path';
    const $d90d8ce15e0e3233$export$831acb5098f5706d = 'system-configuration-general';
    const $d90d8ce15e0e3233$export$d218cda46c433fe1 = 'system-dashboard-edit';
    const $d90d8ce15e0e3233$export$61147168ac2833f9 = 'trashed-plan-direct-link';
    const $d90d8ce15e0e3233$export$9fe0117c0fd486a8 = 'trash-plans-directory';
    const $d90d8ce15e0e3233$export$a49474778d15635d = 'trash-projects-directory';
    const $d90d8ce15e0e3233$export$af3296e54e7fb362 = 'user-segmentation';
    const $d90d8ce15e0e3233$export$281f2e01ee9e4977 = 'your-work';
});
parcelRegister("adY3A", function(module, exports) {
    $parcel$export(module.exports, "topNavigationEntryPoint", ()=>$e6a45c27809ae082$export$f780be9e138f456f);
    var $eufEc;
    var $fEDBv;
    const $e6a45c27809ae082$export$f780be9e138f456f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("9bzz4")), {
            moduleId: "1f1265b4"
        }),
        getPreloadProps: (extraProps)=>({
                extraProps: extraProps
            })
    });
});
parcelRegister("9bzz4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1eG9i")
    ]).then(()=>parcelRequire('9DfkH'));
});
parcelRegister("2G9Bk", function(module, exports) {
    $parcel$export(module.exports, "createEntry", ()=>$2b838b47862d019e$export$344b9c9ab5e66c9a);
    const $2b838b47862d019e$export$344b9c9ab5e66c9a = (baseRoute, opts)=>{
        baseRoute.lazyOpts = opts;
        return baseRoute;
    };
});
parcelRegister("aPfsS", function(module, exports) {
    $parcel$export(module.exports, "coalesce", ()=>$ba604ddd48a07730$export$6e5538615c060df7);
    $parcel$export(module.exports, "renderGlobalComponents", ()=>$ba604ddd48a07730$export$fc28c9563350e5b8);
    $parcel$export(module.exports, "createLayout", ()=>$ba604ddd48a07730$export$3dd437ade36ede40);
    $parcel$export(module.exports, "composeLayouts", ()=>$ba604ddd48a07730$export$6c041b39c370853f);
    $parcel$export(module.exports, "withProjectContext", ()=>$ba604ddd48a07730$export$e97a7da67a5b8ce4);
    var $5uXOq = parcelRequire("5uXOq");
    var $lpwtK;
    var $lfTZh;
    const $ba604ddd48a07730$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
    const $ba604ddd48a07730$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
            const { displayName: displayName, name: name } = Component;
            const key = $ba604ddd48a07730$export$6e5538615c060df7(displayName) ?? $ba604ddd48a07730$export$6e5538615c060df7(name) ?? i;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: key?.toString(),
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
                key: key
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null)));
        });
    const $ba604ddd48a07730$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
            isChromeless: isChromeless,
            globalComponents: Array.from(new Set(globalComponents)),
            rightSidebars: Array.from(new Set(rightSidebars))
        });
    const $ba604ddd48a07730$export$6c041b39c370853f = (...layouts)=>{
        if (layouts.length === 1) return $ba604ddd48a07730$export$3dd437ade36ede40(layouts[0]);
        const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
                isChromeless: isChromeless,
                globalComponents: [
                    ...l.globalComponents,
                    ...globalComponents
                ],
                rightSidebars: [
                    ...l.rightSidebars,
                    ...rightSidebars
                ]
            }), {
            globalComponents: [],
            rightSidebars: [],
            isChromeless: false
        });
        return $ba604ddd48a07730$export$3dd437ade36ede40(layout);
    };
    const $ba604ddd48a07730$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
    const $ba604ddd48a07730$var$formatPrefix = (style, type)=>{
        if (!style && !type) return 'Empty';
        if (style === 'any' && type === 'any') return 'Any';
        const formattedStyle = $ba604ddd48a07730$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
        if (type === 'any') return formattedStyle;
        const formattedType = $ba604ddd48a07730$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
        if (style === 'any') return formattedType;
        return `${formattedStyle}${formattedType}`;
    };
    const $ba604ddd48a07730$export$e97a7da67a5b8ce4 = (Component, options)=>{
        const { project: expectedProject } = options;
        const ScopedComponent = ()=>{
            const { data: project, loading: loading } = (0, (0, parcelRequire("lpwtK")).useProject)();
            if (loading) return null;
            if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null);
        };
        const name = $ba604ddd48a07730$export$6e5538615c060df7(Component.displayName) ?? $ba604ddd48a07730$export$6e5538615c060df7(Component.name) ?? 'Component';
        const prefix = $ba604ddd48a07730$var$formatPrefix(expectedProject?.style, expectedProject?.type);
        ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
        return ScopedComponent;
    };
});
parcelRegister("lpwtK", function(module, exports) {
    $parcel$export(module.exports, "useProject", ()=>$f3d7644b5666677d$export$51b1383ef8844a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bsuuc;
    var $1J3t1;
    const $f3d7644b5666677d$export$51b1383ef8844a7 = (customContext)=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectSidebarNavigation)(customContext);
        const project = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("bsuuc")).extractData)(data), [
            data
        ]);
        return {
            data: project,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("bsuuc", function(module, exports) {
    $parcel$export(module.exports, "getStyle", ()=>$36c780ae7e3dc8c8$export$3d2f074408bd1b82);
    $parcel$export(module.exports, "extractData", ()=>$36c780ae7e3dc8c8$export$9df5fa0a366163d2);
    var $2vSU6;
    const $36c780ae7e3dc8c8$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, (0, parcelRequire("2vSU6")).ProjectStyle).NEXT_GEN : (0, (0, parcelRequire("2vSU6")).ProjectStyle).CLASSIC;
    const $36c780ae7e3dc8c8$var$getProject = (project)=>({
            avatarUrl: project.avatarUrls['48x48'],
            id: Number(project.id),
            isSimplified: project.simplified,
            key: project.key,
            name: project.name,
            style: $36c780ae7e3dc8c8$export$3d2f074408bd1b82(project.simplified),
            type: project.projectTypeKey
        });
    const $36c780ae7e3dc8c8$export$9df5fa0a366163d2 = (data)=>{
        const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
        switch(projectType){
            case 'jira_work_management':
                return jiraWorkManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraWorkManagementNavData.project) : null;
            case 'jira_software':
                return jiraSoftwareNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraSoftwareNavData.project) : null;
            case 'jira_service_management':
            case 'jira_customer_service':
                return jiraServiceManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraServiceManagementNavData.project) : null;
            case 'jira_product_discovery':
                return jiraProductDiscoveryNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraProductDiscoveryNavData.project) : null;
            case null:
            default:
                return null;
        }
    };
});
parcelRegister("1J3t1", function(module, exports) {
    $parcel$export(module.exports, "useProjectSidebarNavigation", ()=>$bb292f58b8ec7804$export$5a85006c180fb373);
    $parcel$export(module.exports, "useProjectSidebarConnectNavigation", ()=>$bb292f58b8ec7804$export$2bed15cd7d167db5);
    $parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", ()=>$bb292f58b8ec7804$export$a9d05fc2c1d94895);
    $parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", ()=>$bb292f58b8ec7804$export$d48e3c3556894533);
    $parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", ()=>$bb292f58b8ec7804$export$24a781cd863077aa);
    $parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", ()=>$bb292f58b8ec7804$export$e16ecd2512eb0dc7);
    $parcel$export(module.exports, "useJiraSoftwareProjectNavigation", ()=>$bb292f58b8ec7804$export$68dc0ecbea8211d2);
    $parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", ()=>$bb292f58b8ec7804$export$5cf90b625d0e1248);
    $parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", ()=>$bb292f58b8ec7804$export$d63d92edebe543d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $b2pl3;
    var $6zFAI;
    var $gcI3W;
    var $loy04;
    var $ggg5j;
    var $324W5;
    var $2YP9W;
    var $727Q1;
    const $bb292f58b8ec7804$export$5a85006c180fb373 = (customContext)=>{
        const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource), customContext);
        const memoizedResponse = (0, $5uXOq.useMemo)(()=>navResponse, [
            navResponse
        ]);
        (0, (0, parcelRequire("727Q1")).useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
        return {
            data: memoizedResponse,
            loading: memoizedResponse != null ? false : loading,
            refresh: refresh,
            clearAll: clearAll,
            error: error,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$2bed15cd7d167db5 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$a9d05fc2c1d94895 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$d48e3c3556894533 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("loy04")).staticProjectSettingsSidebarConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$24a781cd863077aa = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("b2pl3")).staticJSMProjectConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$e16ecd2512eb0dc7 = ()=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
        const response = data?.jiraWorkManagementNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$68dc0ecbea8211d2 = ()=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
        const response = data?.jiraSoftwareNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$5cf90b625d0e1248 = (customContext)=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373(customContext);
        const response = data?.jiraServiceManagementNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$d63d92edebe543d9 = ()=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
        const response = data?.jiraProductDiscoveryNavData || null;
        return {
            data: response,
            ...rest
        };
    };
});
parcelRegister("b2pl3", function(module, exports) {
    $parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", ()=>$565682b770797f58$export$fab84295e18e9246);
    var $1nb22;
    var $2M1hQ;
    var $jAGOQ;
    const $565682b770797f58$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $565682b770797f58$export$fab84295e18e9246 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
        getKey: ({ match: match, query: query })=>$565682b770797f58$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $565682b770797f58$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
            return navInfo;
        },
        maxAge: 300000
    });
});
parcelRegister("1nb22", function(module, exports) {
    $parcel$export(module.exports, "getProjectKeyId", ()=>$061afadfbcc74f44$export$1f7213d0f9054f06);
    const $061afadfbcc74f44$export$1f7213d0f9054f06 = (match, query)=>{
        const projectId = query.selectedProjectId || query.pid || query.projectId || query['project.id'];
        const projectKey = match.params.projectKey || query.projectKey || query['project.key'] || (match.params.issueKey || '').split('-')[0];
        return {
            projectKey: projectKey,
            projectId: projectId
        };
    };
});
parcelRegister("jAGOQ", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", ()=>$45e9310ad65e3e88$export$b15f9f5cf6db359e);
    var $eusud;
    const $45e9310ad65e3e88$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
        if (projectKeyOrId == null) throw new Error('invalid identifier specified');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
    };
});
parcelRegister("eusud", function(module, exports) {
    $parcel$export(module.exports, "transformValidationErrorFromServer", ()=>$3637c0f7edbd2bb4$export$8e9baed7697e4959);
    $parcel$export(module.exports, "applyErrorHandling", ()=>$3637c0f7edbd2bb4$export$e174dc943a170ff);
    $parcel$export(module.exports, "performGetRequest", ()=>$3637c0f7edbd2bb4$export$4a53ae1be8ec80c7);
    $parcel$export(module.exports, "performPutRequest", ()=>$3637c0f7edbd2bb4$export$9ead1f9103e6de6b);
    $parcel$export(module.exports, "performPostRequest", ()=>$3637c0f7edbd2bb4$export$692a4d9808143175);
    $parcel$export(module.exports, "performDeleteRequest", ()=>$3637c0f7edbd2bb4$export$8ef51cba9d28f819);
    $parcel$export(module.exports, "performPatchRequest", ()=>$3637c0f7edbd2bb4$export$52be6ab13d7e758d);
    $parcel$export(module.exports, "performGetRequestWithRetry", ()=>$3637c0f7edbd2bb4$export$659b5ee69e6eb976);
    $parcel$export(module.exports, "performPutRequestWithRetry", ()=>$3637c0f7edbd2bb4$export$d7b48b2904a5d812);
    $parcel$export(module.exports, "performPostRequestWithRetry", ()=>$3637c0f7edbd2bb4$export$a5717cbee13f28b7);
    var $aDvGo;
    var $jQsty;
    var $jJZqs;
    var $8KpGl;
    var $51xpa;
    var $6b2ko;
    var $iwPwz;
    const $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
                field: field,
                error: fieldErrors[field]
            }));
    const $3637c0f7edbd2bb4$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
        const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
        const fieldErrorsJson = json.errors ?? json.fieldErrors;
        const fieldErrors = fieldErrorsJson ? $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
        return new (0, (0, parcelRequire("jJZqs")).ValidationError)(message, fieldErrors, statusCode, traceId, json);
    };
    const $3637c0f7edbd2bb4$var$putOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PUT'
    };
    const $3637c0f7edbd2bb4$var$postOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'POST'
    };
    const $3637c0f7edbd2bb4$var$deleteOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'DELETE'
    };
    const $3637c0f7edbd2bb4$var$patchOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PATCH'
    };
    const $3637c0f7edbd2bb4$var$handleNetworkErrors = (err)=>{
        if (err instanceof TypeError) throw new Error('Failed to fetch', {
            cause: err
        });
        throw err;
    };
    const $3637c0f7edbd2bb4$var$handleErrors = (response)=>{
        const traceId = (0, (0, parcelRequire("iwPwz")).getTraceId)(response);
        if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status || (0, $3cd8a0ece36fbae5$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
            throw $3637c0f7edbd2bb4$export$8e9baed7697e4959(errorContent, response.status, traceId);
        });
        if (!response.ok) {
            if (traceId !== undefined && traceId.length > 0) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`, traceId, response);
            else throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`, undefined, response);
        }
        return response;
    };
    const $3637c0f7edbd2bb4$var$processResponseFromServer = (response)=>{
        if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
        return response.text().then((text)=>text ? JSON.parse(text) : null);
    };
    const $3637c0f7edbd2bb4$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$22411cbfb09a5c5c = (url, options)=>{
        const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
        const executeRequest = ()=>$3637c0f7edbd2bb4$export$e174dc943a170ff(fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, requestOptions)));
        if ((0, (0, parcelRequire("jQsty")).default)('platform_fetch_retries')) return executeRequest();
        return (0, (0, parcelRequire("6b2ko")).retryOnError)(executeRequest, {
            retryFunc: executeRequest,
            retryPredicate: retryPredicate,
            retryAttempts: retryAttempts,
            onRetry: onRetry
        });
    };
    const $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$putOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$692a4d9808143175 = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$postOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$deleteOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$patchOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$659b5ee69e6eb976 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        });
    const $3637c0f7edbd2bb4$export$d7b48b2904a5d812 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$putOptions,
            ...options
        });
    const $3637c0f7edbd2bb4$export$a5717cbee13f28b7 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$postOptions,
            ...options
        });
    const $3637c0f7edbd2bb4$export$6d01bf1146815b9b = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$deleteOptions,
            ...options
        });
    const $3637c0f7edbd2bb4$export$560989ee94ad2a20 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$patchOptions,
            ...options
        });
});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;
parcelRegister("6b2ko", function(module, exports) {
    $parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", ()=>$6910b563ec955346$export$81189edc9b923717);
    $parcel$export(module.exports, "retryOnError", ()=>$6910b563ec955346$export$f859c88bfac2cf2c);
    const $6910b563ec955346$export$81189edc9b923717 = 1;
    const $6910b563ec955346$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $6910b563ec955346$export$81189edc9b923717, onRetry: onRetry })=>{
        const maxAttempts = retryAttempts > $6910b563ec955346$export$81189edc9b923717 ? $6910b563ec955346$export$81189edc9b923717 : retryAttempts;
        const execute = async (getPromise, retryAttempt = 0)=>{
            try {
                return await getPromise();
            } catch (error) {
                const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
                if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                    onRetry && onRetry(error, retryAttempt + 1);
                    return execute(retryFunc, retryAttempt + 1);
                }
                throw error;
            }
        };
        return execute(initialPromiseGetter);
    };
});
parcelRegister("6zFAI", function(module, exports) {
    $parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", ()=>$ee61b377cbb3343f$export$b8c6e2666f12f4bb);
    $parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only", ()=>$ee61b377cbb3343f$export$a799c58e7bee6de4);
    var $4R6GH;
    var $3HwlS;
    var $1nb22;
    var $gNStA;
    var $2M1hQ;
    var $jAGOQ;
    const $ee61b377cbb3343f$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $ee61b377cbb3343f$export$b8c6e2666f12f4bb = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$ee61b377cbb3343f$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $ee61b377cbb3343f$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const projectHomeAddonNavInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
            return projectHomeAddonNavInfo;
        },
        maxAge: 300000
    });
    const $ee61b377cbb3343f$export$a799c58e7bee6de4 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('perf-push-big-components-nav-remove-resources')), $ee61b377cbb3343f$export$b8c6e2666f12f4bb);
});
parcelRegister("3HwlS", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4", ()=>$30254f1a9a5ebb1a$export$f1ce4aa22fe8768a);
    var $4R6GH;
    var $c0dQj;
    var $Z0r3L;
    var $ifO6r;
    var $9qXgw;
    const $30254f1a9a5ebb1a$export$f1ce4aa22fe8768a = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4') && ((0, (0, parcelRequire("ifO6r")).getWillShowNav4ForDogfooding)() || (0, (0, parcelRequire("9qXgw")).getWillShowNav4ForEap)() || (0, (0, parcelRequire("Z0r3L")).getWillShowNav4ForBeta)() || (0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)());
});
parcelRegister("c0dQj", function(module, exports) {
    $parcel$export(module.exports, "isMobileAndInMVPExperiment", ()=>$7275e40842570ace$export$f29d7974ab92d702);
    $parcel$export(module.exports, "MobileWebExperimentExposure", ()=>$7275e40842570ace$export$b93f740e619fc842);
    $parcel$export(module.exports, "MobileWebExperimentExistingUserExposure", ()=>$7275e40842570ace$export$2902862a932a4ef9);
    var $bCdIp;
    var $6s1PB;
    var $4R6GH;
    const $7275e40842570ace$export$d684035fae1c53e6 = ()=>{
        const [mobileWebConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_mobile_web_mvp_2');
        return ((0, (0, parcelRequire("4R6GH")).fg)('jira_mobile_web_mvp_2_feature_gate') && (0, (0, parcelRequire("bCdIp")).default)() && mobileWebConfig.get('isEnabled', false));
    };
    const $7275e40842570ace$export$b9e037608558a01a = ()=>{
        const [existingUsersMobileWebConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_mobile_web_mvp_existing_users');
        return ((0, (0, parcelRequire("4R6GH")).fg)('jira_mobile_web_mvp_existing_users_feature_gate') && (0, (0, parcelRequire("bCdIp")).default)() && existingUsersMobileWebConfig.get('isEnabled', false));
    };
    const $7275e40842570ace$export$f29d7974ab92d702 = ()=>{
        return $7275e40842570ace$export$d684035fae1c53e6() || $7275e40842570ace$export$b9e037608558a01a();
    };
    const $7275e40842570ace$export$b93f740e619fc842 = ()=>{
        const [, manuallyFireExposure] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_mobile_web_mvp_2');
        if ((0, (0, parcelRequire("bCdIp")).default)()) manuallyFireExposure();
        return null;
    };
    const $7275e40842570ace$export$2902862a932a4ef9 = ()=>{
        const [, manuallyFireExposure] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_mobile_web_mvp_existing_users');
        if ((0, (0, parcelRequire("bCdIp")).default)()) manuallyFireExposure();
        return null;
    };
});
parcelRegister("6s1PB", function(module, exports) {
    $parcel$export(module.exports, "expVal", ()=>$d0d3e1363a65fa96$export$9db1624a8af791a4);
    $parcel$export(module.exports, "expValEquals", ()=>$d0d3e1363a65fa96$export$45abdb3f977b5b14);
    $parcel$export(module.exports, "UNSAFE_noExposureExp", ()=>$d0d3e1363a65fa96$export$677f9fa2e1ae6fec);
    var $5IPCv;
    var $gSA3s;
    var $40Gox;
    function $d0d3e1363a65fa96$export$9db1624a8af791a4(experimentName, param, defaultValue) {
        (0, (0, parcelRequire("40Gox")).UNSAFE_initIfNeeded)();
        const value = (0, (0, parcelRequire("5IPCv")).default).getExperimentValue(experimentName, param, defaultValue);
        (0, (0, parcelRequire("gSA3s")).addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
        return value;
    }
    function $d0d3e1363a65fa96$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
        return $d0d3e1363a65fa96$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
    }
    class $d0d3e1363a65fa96$var$ExperimentConfig {
        constructor(experimentName, config){
            this._experimentName = experimentName;
            this._config = config;
        }
        get(key, defaultValue, typeGuard) {
            const value = this._config.get(key, defaultValue, typeGuard);
            (0, (0, parcelRequire("gSA3s")).addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
            return value;
        }
    }
    const $d0d3e1363a65fa96$var$cache = new Map();
    function $d0d3e1363a65fa96$export$677f9fa2e1ae6fec(experimentName) {
        let instance = $d0d3e1363a65fa96$var$cache.get(experimentName);
        if (instance == null) {
            (0, (0, parcelRequire("40Gox")).UNSAFE_initIfNeeded)();
            const config = (0, (0, parcelRequire("5IPCv")).default).getExperiment(experimentName, {
                fireExperimentExposure: false
            });
            const fireExposure = ()=>(0, (0, parcelRequire("5IPCv")).default).manuallyLogExperimentExposure(experimentName);
            instance = [
                new $d0d3e1363a65fa96$var$ExperimentConfig(experimentName, config),
                fireExposure
            ];
            $d0d3e1363a65fa96$var$cache.set(experimentName, instance);
        }
        return instance;
    }
});
parcelRegister("Z0r3L", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4ForBeta", ()=>$857b5c92d68cd7c3$export$f4f16573b5c2e67b);
    var $6s1PB;
    var $4R6GH;
    var $1MhR0;
    const $857b5c92d68cd7c3$export$f4f16573b5c2e67b = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_existing-customers') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)() || (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_sandboxes') || (0, (0, parcelRequire("6s1PB")).expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false) || (0, (0, parcelRequire("6s1PB")).expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false);
});
parcelRegister("1MhR0", function(module, exports) {
    $parcel$export(module.exports, "getMetaBoolean", ()=>$039259847fa24143$export$9683360b0ae70629);
    $parcel$export(module.exports, "getIsNav4UserOptOut", ()=>$039259847fa24143$export$3fbfe0fdf05e0f9f);
    var $gJBT6 = parcelRequire("gJBT6");
    var $j8DrX;
    var $7qZOo;
    const $039259847fa24143$export$9683360b0ae70629 = (0, ($parcel$interopDefault($gJBT6)))((name)=>(0, (0, parcelRequire("j8DrX")).default)(`ajs-${name}`) === 'true');
    const $039259847fa24143$export$7d046765d192af80 = ()=>$039259847fa24143$export$9683360b0ae70629((0, (0, parcelRequire("7qZOo")).IS_ADMIN));
    const $039259847fa24143$export$ba89637357392be6 = ()=>$039259847fa24143$export$9683360b0ae70629((0, (0, parcelRequire("7qZOo")).IS_NAV4_USER_OPT_IN));
    const $039259847fa24143$export$3fbfe0fdf05e0f9f = ()=>$039259847fa24143$export$9683360b0ae70629((0, (0, parcelRequire("7qZOo")).IS_NAV4_USER_OPT_OUT));
});
parcelRegister("7qZOo", function(module, exports) {
    $parcel$export(module.exports, "IS_ADMIN", ()=>$92928f70e02753a5$export$4261d5d429e288ec);
    $parcel$export(module.exports, "IS_NAV4_USER_OPT_IN", ()=>$92928f70e02753a5$export$153ded4d539b820d);
    $parcel$export(module.exports, "IS_NAV4_USER_OPT_OUT", ()=>$92928f70e02753a5$export$9c962957701a4fe8);
    $parcel$export(module.exports, "NAV4_ROLLOUT_NONE", ()=>$92928f70e02753a5$export$3b602cac1f385c06);
    $parcel$export(module.exports, "NAV4_ROLLOUT_MOBILE", ()=>$92928f70e02753a5$export$e748a16828d2f61f);
    const $92928f70e02753a5$export$4261d5d429e288ec = 'is-admin';
    const $92928f70e02753a5$export$153ded4d539b820d = 'is-nav4-user-opt-in';
    const $92928f70e02753a5$export$9c962957701a4fe8 = 'is-nav4-user-opt-out';
    const $92928f70e02753a5$export$3b602cac1f385c06 = {
        stage: 'none'
    };
    const $92928f70e02753a5$export$e748a16828d2f61f = {
        stage: 'mobile'
    };
    const $92928f70e02753a5$export$9cd4b8dc5f7153b8 = {
        NONE: 'none',
        DOGFOODING: 'dogfooding',
        EAP: 'eap',
        BETA: 'beta',
        GA: 'ga'
    };
});
parcelRegister("ifO6r", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4ForDogfooding", ()=>$b6db23b0cddd1764$export$9ca0d92d31816d4f);
    var $4R6GH;
    var $1MhR0;
    const $b6db23b0cddd1764$export$9ca0d92d31816d4f = ()=>{
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding')) return false;
        const phase1 = (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-1');
        const phase2 = (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-2');
        const phase3 = !(phase1 || phase2);
        return phase3 || phase2 && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)() || phase1 && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
    };
});
parcelRegister("9qXgw", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4ForEap", ()=>$77cd593041adc2b6$export$393f53ae320de085);
    var $4R6GH;
    var $1MhR0;
    const $77cd593041adc2b6$export$393f53ae320de085 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
});
parcelRegister("gNStA", function(module, exports) {
    $parcel$export(module.exports, "resourceWithCondition", ()=>$4fbc57fe7e788209$export$cac04afc5a06c544);
    $parcel$export(module.exports, "resourceWithCondition2", ()=>$4fbc57fe7e788209$export$78488a529a07cd46);
    $parcel$export(module.exports, "browserOnlyResourceWithCondition", ()=>$4fbc57fe7e788209$export$5284559c6d2f1a7b);
    var $kbVA4;
    const $4fbc57fe7e788209$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
            get type () {
                return conditionGetter() ? resourceTrue.type : (0, (0, parcelRequire("kbVA4")).RESOURCE_TYPE_NOOP);
            },
            getKey: resourceTrue.getKey,
            get maxAge () {
                return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
            },
            getData: (routerContext, customContext)=>conditionGetter() ? resourceTrue.getData(routerContext, customContext) : Promise.resolve(null),
            maxCache: resourceTrue.maxCache,
            get isBrowserOnly () {
                return resourceTrue.isBrowserOnly;
            },
            get depends () {
                return resourceTrue.depends;
            },
            get skipBrowser () {
                return resourceTrue.skipBrowser;
            }
        };
    const $4fbc57fe7e788209$export$fbf6681b373be4c4 = (resource, amendments = {})=>resource && Object.defineProperties({}, {
            ...Object.getOwnPropertyDescriptors(resource),
            ...Object.getOwnPropertyDescriptors(amendments)
        });
    const $4fbc57fe7e788209$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $4fbc57fe7e788209$export$fbf6681b373be4c4(itemTrue, {
        getKey: ()=>'DEGENERATE_KEY',
        getData: ()=>null,
        maxAge: Number.MAX_SAFE_INTEGER
    }))=>itemTrue && Object.defineProperties({}, Object.fromEntries([
            ...Object.keys(itemTrue),
            ...Object.keys(itemFalse)
        ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
                key,
                {
                    configurable: false,
                    enumerable: true,
                    get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
                }
            ])));
    const $4fbc57fe7e788209$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
            ...resource,
            get isBrowserOnly () {
                return !!conditionGetter();
            }
        };
});
parcelRegister("kbVA4", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_NOOP", ()=>$513d12eeb22c04a1$export$eb37f5d331ea4de4);
    $parcel$export(module.exports, "MIN_MAX_AGE", ()=>$513d12eeb22c04a1$export$5664a170ac5a9781);
    const $513d12eeb22c04a1$export$eb37f5d331ea4de4 = 'NOOP';
    const $513d12eeb22c04a1$export$5664a170ac5a9781 = 5000;
});
parcelRegister("gcI3W", function(module, exports) {
    $parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", ()=>$e60f9280597d4f0e$export$b662f3f877add30d);
    var $1nb22;
    var $2M1hQ;
    var $jAGOQ;
    const $e60f9280597d4f0e$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $e60f9280597d4f0e$export$b662f3f877add30d = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$e60f9280597d4f0e$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $e60f9280597d4f0e$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
            return navInfo;
        },
        maxAge: 300000
    });
});
parcelRegister("loy04", function(module, exports) {
    $parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", ()=>$c5a0b9808c0c3182$export$e4bf33528101348c);
    $parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", ()=>$c5a0b9808c0c3182$export$2d5a704ae6f6b050);
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    var $jAGOQ;
    const $c5a0b9808c0c3182$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $c5a0b9808c0c3182$export$e4bf33528101348c = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$c5a0b9808c0c3182$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $c5a0b9808c0c3182$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
            return navInfo;
        },
        maxAge: 300000
    });
    const $c5a0b9808c0c3182$export$2d5a704ae6f6b050 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($c5a0b9808c0c3182$export$e4bf33528101348c);
});
parcelRegister("ggg5j", function(module, exports) {
    $parcel$export(module.exports, "getIdentifier", ()=>$3ec7290d9b237c27$export$adb27ddab077e944);
    $parcel$export(module.exports, "staticProjectSidebarNavigationResource", ()=>$3ec7290d9b237c27$export$f2dfc0f7b2d92691);
    $parcel$export(module.exports, "useSidebarNavigationResource", ()=>$3ec7290d9b237c27$export$b692cfadccf4e047);
    var $65Ltd;
    var $95bh0;
    var $8YTna;
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    var $gDyED;
    const $3ec7290d9b237c27$export$adb27ddab077e944 = (routeName, match, query)=>{
        if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR) || query['servicedesk.serviceDeskId']) {
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
                projectKey: projectKey,
                projectId: projectId
            });
        }
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
        return (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId,
            boardId: boardId
        });
    };
    const $3ec7290d9b237c27$var$getRouterKey = (routeName, match, query)=>{
        const { identifierType: identifierType, identifierValue: identifierValue } = $3ec7290d9b237c27$export$adb27ddab077e944(routeName, match, query);
        if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
        return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
    };
    const $3ec7290d9b237c27$export$f2dfc0f7b2d92691 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
        getKey: ({ match: match, query: query, route: { name: name } })=>$3ec7290d9b237c27$var$getRouterKey(name, match, query),
        getData: async ({ match: match, query: query, route: { name: name } })=>{
            const scopeIdentifier = $3ec7290d9b237c27$export$adb27ddab077e944(name, match, query);
            if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
            const navInfo = await (0, (0, parcelRequire("gDyED")).fetchProjectSidebarNavInfo)(scopeIdentifier);
            return navInfo;
        },
        maxAge: 300000
    });
    const $3ec7290d9b237c27$export$b692cfadccf4e047 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($3ec7290d9b237c27$export$f2dfc0f7b2d92691);
});
parcelRegister("95bh0", function(module, exports) {
    $parcel$export(module.exports, "getScopeIdentifier", ()=>$4cc145d0cf66273c$export$68278f7cf66944f9);
    const $4cc145d0cf66273c$export$68278f7cf66944f9 = (scope)=>{
        const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
        let identifierType = null;
        if (scope.boardId) identifierType = (0, $87844bbe4c23d937$export$929d50f83189406c);
        else if (scope.projectKey) identifierType = (0, $87844bbe4c23d937$export$b5a308a17bc991f3);
        else if (scope.projectId) identifierType = (0, $87844bbe4c23d937$export$da6f46390e1a426f);
        return {
            identifierValue: identifierValue,
            identifierType: identifierType
        };
    };
});
const $87844bbe4c23d937$export$b5a308a17bc991f3 = 'projectKey';
const $87844bbe4c23d937$export$929d50f83189406c = 'boardId';
const $87844bbe4c23d937$export$da6f46390e1a426f = 'projectId';
parcelRegister("8YTna", function(module, exports) {
    $parcel$export(module.exports, "getBoardId", ()=>$f7f12dfb24bc320d$export$557c2f222778cea6);
    const $f7f12dfb24bc320d$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];
});
parcelRegister("gDyED", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectSidebarNavInfo", ()=>$b6d61a4c2e3b518c$export$8a51470472777e11);
    var $eusud;
    const $b6d61a4c2e3b518c$export$8a51470472777e11 = (scopeIdentifier)=>{
        const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
        if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
        let queryParam = '';
        switch(identifierType){
            case 'boardId':
                queryParam = `boardId=${identifierValue}`;
                break;
            case 'projectKey':
            case 'projectId':
                queryParam = `projectIdOrKey=${identifierValue}`;
                break;
            default:
                break;
        }
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
    };
});
parcelRegister("324W5", function(module, exports) {
    $parcel$export(module.exports, "useResourceWithCustomRouterContext", ()=>$0c2698427b7aacc1$export$61dad767cf446185);
    var $jNUyg;
    var $2YP9W;
    var $geWXd;
    const $0c2698427b7aacc1$var$DUMMY_ROUTE = {
        name: 'DUMMY_ROUTE_NAME',
        path: '/projects/:projectKey/dummyroute'
    };
    function $0c2698427b7aacc1$export$61dad767cf446185(resource, customRouterContext, options = {}) {
        let resourceOptions;
        if (customRouterContext) {
            const { route: route = $0c2698427b7aacc1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
            if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
                routerContext: (0, (0, parcelRequire("jNUyg")).createRouterContext)(route, {
                    params: matchParams
                })
            };
        }
        const { shouldPrefetch: shouldPrefetch } = options;
        const resourceResponse = (0, (0, parcelRequire("2YP9W")).useResource)(resource, resourceOptions);
        (0, (0, parcelRequire("geWXd")).usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
        return resourceResponse;
    }
});
parcelRegister("geWXd", function(module, exports) {
    $parcel$export(module.exports, "usePrefetchableResource", ()=>$b632b0c18495344b$export$99f17ace416cfe75);
    var $5uXOq = parcelRequire("5uXOq");
    function $b632b0c18495344b$export$99f17ace416cfe75(resource, shouldPrefetch) {
        (0, $5uXOq.useEffect)(()=>{
            if (!shouldPrefetch) return;
            if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
        }, []);
    }
});
parcelRegister("727Q1", function(module, exports) {
    $parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", ()=>$5300bc04c6e3c00f$export$780174995da89d60);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $ggg5j;
    var $jNUyg;
    var $2YP9W;
    var $doZTA;
    const $5300bc04c6e3c00f$export$90dbde7e33e6e21 = ()=>null;
    const $5300bc04c6e3c00f$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, (0, parcelRequire("jNUyg")).createRouterContext)({
            name: 'software',
            path: '/dummyroute/c/projects/:projectKey/dummyroute',
            component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
        }, {
            params: {
                projectKey: projectKey
            }
        }) : undefined;
    const $5300bc04c6e3c00f$export$19001bab9e4b7f8f = (projectKey)=>{
        const { data: data, update: update } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource), {
            routerContext: $5300bc04c6e3c00f$export$d647718555c2fdd8(projectKey)
        });
        return {
            data: data,
            update: update
        };
    };
    const $5300bc04c6e3c00f$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, (0, parcelRequire("jNUyg")).createRouterContext)({
            name: 'software',
            path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
            component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
        }, {
            params: {
                boardId: `${boardId}`
            }
        }) : undefined;
    const $5300bc04c6e3c00f$export$e2bb7877e6cec3eb = (boardId)=>{
        const { data: data, update: update } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource), {
            routerContext: $5300bc04c6e3c00f$export$23dc6491016cabdc(boardId)
        });
        return {
            data: data,
            update: update
        };
    };
    const $5300bc04c6e3c00f$export$780174995da89d60 = (latestNavInfo)=>{
        const [{ match: match, query: query, route: { name: name } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const isOnBoardBasedRoute = (0, (0, parcelRequire("ggg5j")).getIdentifier)(name, match, query)?.identifierType === 'boardId';
        const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
        const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
        const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
        const { data: projectRouteNavInfo, update: updateProjectRoute } = $5300bc04c6e3c00f$export$19001bab9e4b7f8f(pKey);
        const { data: boardRouteNavInfo, update: updateBoardRoute } = $5300bc04c6e3c00f$export$e2bb7877e6cec3eb(boardId);
        (0, $5uXOq.useEffect)(()=>{
            if (latestNavInfo != null && isSoftwareCMP) {
                if (isOnBoardBasedRoute && !(0, ($parcel$interopDefault($ajpes)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
                else if (!(0, ($parcel$interopDefault($ajpes)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
            }
        }, [
            isOnBoardBasedRoute,
            latestNavInfo,
            updateProjectRoute,
            updateBoardRoute,
            projectRouteNavInfo,
            boardRouteNavInfo,
            isSoftwareCMP
        ]);
    };
});
parcelRegister("c3WQb", function(module, exports) {
    $parcel$export(module.exports, "advancedRoadmapsReduxStoreStateResource", ()=>$20c66b93015d9910$export$6ca262338f199e4b);
    $parcel$export(module.exports, "advancedRoadmapsScenarioIdResource", ()=>$20c66b93015d9910$export$aec847b4ce72891);
    $parcel$export(module.exports, "advancedRoadmapsPlanPageInitialChecksResource", ()=>$20c66b93015d9910$export$7431e46c7ad56c3d);
    $parcel$export(module.exports, "advancedRoadmapsPlanReportPageInitialChecksResource", ()=>$20c66b93015d9910$export$bf0c5395c73cc255);
    $parcel$export(module.exports, "advancedRoadmapsLastVisitedProgramBoardIdResource", ()=>$20c66b93015d9910$export$f5b159e1fb19e04e);
    var $hGgHi = parcelRequire("hGgHi");
    var $eusud;
    var $2M1hQ;
    const $20c66b93015d9910$export$6ca262338f199e4b = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ADVANCED_ROADMAPS_REDUX_STORE_STATE',
        getKey: ({ match: match })=>{
            const { params: params, query: query } = match;
            if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
            if (params.reportId != null) return params.reportId;
            if (query.r != null) return query.r;
            throw new Error('Unable to get resource key for ADVANCED_ROADMAPS_REDUX_STORE_STATE.');
        },
        getData: async ()=>undefined,
        isBrowserOnly: true,
        maxAge: Infinity
    });
    const $20c66b93015d9910$export$aec847b4ce72891 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $025c2a539475c8ec$export$a0893d695ebee984),
        getKey: ({ query: query })=>`scenarioId_${query.id}`,
        getData: async ({ query: query })=>{
            const planId = query.id;
            const { id: id } = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/jpo/1.0/scenarios/${planId}`);
            return {
                scenarioId: id
            };
        },
        maxAge: 0
    });
    const $20c66b93015d9910$export$7431e46c7ad56c3d = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $025c2a539475c8ec$export$68390102872336b6),
        getKey: ({ match: match })=>{
            const { planId: planId, scenarioId: scenarioId } = match.params;
            return `planPageInitialChecks_${planId != null ? planId : ''}_${scenarioId != null ? scenarioId : ''}`;
        },
        getData: async ({ match: match })=>{
            const { planId: planId, scenarioId: scenarioId } = match.params;
            if (planId == null || planId === 'null' && planId === 'undefined' && planId === '') throw new Error('Plan cannot be loaded without a planId');
            let url = `/rest/jpo/1.0/plans/${planId}/checks`;
            if (scenarioId != null && scenarioId !== 'null' && scenarioId !== 'undefined' && scenarioId !== '') url = `${url}?sid=${scenarioId}`;
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            return response;
        },
        maxAge: Infinity
    });
    const $20c66b93015d9910$export$bf0c5395c73cc255 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $025c2a539475c8ec$export$a00e869cafd63140),
        getKey: ({ match: match })=>`planReportPageInitialChecks_${match.params.reportId == null ? '' : match.params.reportId}`,
        getData: async ({ match: match })=>{
            const initialPlanChecksPromise = window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
            delete window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
            if (initialPlanChecksPromise) {
                const response = await initialPlanChecksPromise;
                return response;
            }
            const { reportId: reportId } = match.params;
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}/checks`);
            return response;
        },
        maxAge: Infinity
    });
    const $20c66b93015d9910$export$f5b159e1fb19e04e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $025c2a539475c8ec$export$179a0d35e95a4d61),
        getKey: ({ query: query, match: match })=>`lastVisitedProgramBoardId_${query.id}_${match.params.planId}_${match.params.scenarioId}`,
        getData: async ({ match: match })=>{
            const RETRIES = 3;
            const DELAY = 500;
            const attemptFetch = async (remainingRetries)=>{
                const currentPlanId = match.params.planId;
                if (!(0, ($parcel$interopDefault($hGgHi)))(currentPlanId)) {
                    const defaultBoardIdResponse = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/jpo/2.0/plans/${currentPlanId}/increments/default`);
                    if (defaultBoardIdResponse === null) return {
                        boardId: null
                    };
                    const { id: id } = defaultBoardIdResponse;
                    return {
                        boardId: id
                    };
                }
                if (remainingRetries > 0) {
                    await new Promise((resolve)=>setTimeout(resolve, DELAY));
                    return attemptFetch(remainingRetries - 1);
                }
                throw new Error('Attempted to get the last visited program board of a plan without a plan id after multiple retries.');
            };
            return attemptFetch(RETRIES);
        },
        maxAge: Infinity
    });
});
const $025c2a539475c8ec$export$68390102872336b6 = 'ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a00e869cafd63140 = 'ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a0893d695ebee984 = 'ADVANCED_ROADMAPS_SCENARIO_ID';
const $025c2a539475c8ec$export$179a0d35e95a4d61 = 'ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID';
parcelRegister("2Ql51", function(module, exports) {
    $parcel$export(module.exports, "themePreferenceResource", ()=>$14feb59df5995657$export$e5a423d1eb1cf1d0);
    $parcel$export(module.exports, "useThemePreference", ()=>$14feb59df5995657$export$3416635c8aeb5bab);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $2M1hQ;
    var $2YP9W;
    var $Y0b1l;
    const $14feb59df5995657$var$getDataLoader = ()=>(parcelRequire("7QoEx"));
    const $14feb59df5995657$export$e5a423d1eb1cf1d0 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'RESOURCE_THEME_PREFERENCE',
        getKey: ()=>'state',
        getDataLoader: $14feb59df5995657$var$getDataLoader,
        maxAge: 300000
    });
    const $14feb59df5995657$export$3416635c8aeb5bab = ()=>{
        const { data: data, update: updateThemePreferenceResource } = (0, (0, parcelRequire("2YP9W")).useResource)($14feb59df5995657$export$e5a423d1eb1cf1d0);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireThemeAnalytics = (0, $5uXOq.useCallback)((current, next)=>{
            const OStheme = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
            const analyticsEvent = createAnalyticsEvent({
                action: (0, $d0956fbcd917153f$export$89c5cf64ad15c3ea),
                actionSubject: (0, $d0956fbcd917153f$export$9e2cc65718a61846)
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                newPreference: next,
                oldPreference: current,
                OStheme: OStheme
            });
        }, [
            createAnalyticsEvent
        ]);
        const setTheme = (0, $5uXOq.useCallback)(async (theme)=>{
            updateThemePreferenceResource(()=>({
                    theme: theme
                }));
            if (data?.theme !== theme) {
                fireThemeAnalytics(data?.theme, theme);
                await (0, (0, parcelRequire("Y0b1l")).setThemePreference)(theme);
            }
        }, [
            data?.theme,
            updateThemePreferenceResource,
            fireThemeAnalytics
        ]);
        return {
            theme: data?.theme,
            setTheme: setTheme
        };
    };
});
const $d0956fbcd917153f$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $d0956fbcd917153f$export$9e2cc65718a61846 = 'themePreference';
const $d0956fbcd917153f$export$89c5cf64ad15c3ea = 'changed';
parcelRegister("Y0b1l", function(module, exports) {
    $parcel$export(module.exports, "setThemePreference", ()=>$fb319b2ef1da4e47$export$a6b84eebd33787e2);
    $parcel$export(module.exports, "getThemePreference", ()=>$fb319b2ef1da4e47$export$2f7a12048d96237);
    var $b9op4;
    var $jcw0u;
    var $aHuqL;
    const $fb319b2ef1da4e47$export$a6b84eebd33787e2 = (theme)=>{
        const promise = (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).set((0, $d0956fbcd917153f$export$40bd77e1c9f49c27), theme);
        promise.catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: error,
                attributes: {
                    op: 'put',
                    errName: String(error.name),
                    statusCode: error.statusCode,
                    param: `to:${theme}`
                }
            });
        });
        return promise;
    };
    const $fb319b2ef1da4e47$export$2f7a12048d96237 = async ()=>{
        const promise = (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, $d0956fbcd917153f$export$40bd77e1c9f49c27));
        promise.catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: error,
                attributes: {
                    op: 'get',
                    errName: String(error.name),
                    statusCode: error.statusCode
                }
            });
        });
        promise.then((theme)=>{
            if (theme && !(0, (0, parcelRequire("b9op4")).ThemeOptions).includes(theme)) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: new Error('Unrecognized theme!'),
                attributes: {
                    op: 'get',
                    theme: theme,
                    errName: 'unrecognized value!'
                }
            });
        });
        const theme = await promise;
        return theme && (0, (0, parcelRequire("b9op4")).ThemeOptions).includes(theme) ? theme : undefined;
    };
});
parcelRegister("b9op4", function(module, exports) {
    $parcel$export(module.exports, "ThemeOptions", ()=>$a1d11c8212b90b3e$export$abe7936539cefefe);
    $parcel$export(module.exports, "DEFAULT_THEME", ()=>$a1d11c8212b90b3e$export$2faeed762aac6741);
    const $a1d11c8212b90b3e$export$abe7936539cefefe = [
        'light',
        'dark',
        'auto'
    ];
    const $a1d11c8212b90b3e$export$2faeed762aac6741 = 'light';
});
parcelRegister("aHuqL", function(module, exports) {
    $parcel$export(module.exports, "userPreferenceAPI", ()=>$0f87ed1c6d708024$export$4f7929ca6b50a436);
    var $eusud;
    const $0f87ed1c6d708024$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
    const $0f87ed1c6d708024$var$get = async (key)=>{
        try {
            const result = await (0, (0, parcelRequire("eusud")).performGetRequest)($0f87ed1c6d708024$var$url(key));
            return result?.value;
        } catch (error) {
            if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) return null;
            throw error;
        }
    };
    const $0f87ed1c6d708024$var$set = (key, value)=>(0, (0, parcelRequire("eusud")).performPutRequest)($0f87ed1c6d708024$var$url(key), {
            body: JSON.stringify({
                value: value
            })
        });
    const $0f87ed1c6d708024$var$remove = (key)=>(0, (0, parcelRequire("eusud")).performDeleteRequest)($0f87ed1c6d708024$var$url(key));
    const $0f87ed1c6d708024$export$4f7929ca6b50a436 = {
        get: $0f87ed1c6d708024$var$get,
        set: $0f87ed1c6d708024$var$set,
        remove: $0f87ed1c6d708024$var$remove
    };
});
parcelRegister("7QoEx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5DvFw")
    ]).then(()=>parcelRequire('jyeNt'));
});
parcelRegister("5lsNZ", function(module, exports) {
    $parcel$export(module.exports, "LazyNotFoundErrorPage", ()=>$5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7);
    $parcel$export(module.exports, "default", ()=>$5ed1828a3f7dd5a7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jqHqY")), {
        moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
    });
    var $5ed1828a3f7dd5a7$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7,
            pageId: "errors-404",
            shouldShowSpinner: false
        });
});
parcelRegister("5j7Th", function(module, exports) {
    $parcel$export(module.exports, "LazyPage", ()=>$63937a96c08aaddb$export$a18c9c3dd309b8e6);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $dJl1T;
    var $lfTZh;
    var $6jY6G;
    var $7LpuY;
    var $dZw8H;
    const $63937a96c08aaddb$var$LOCATION = 'lazy-page';
    const $63937a96c08aaddb$export$fb85bbdbfb3e6869 = ()=>null;
    const $63937a96c08aaddb$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const Skeleton = route.skeleton || (shouldShowSpinner ? (0, (0, parcelRequire("kb4zh")).default) : $63937a96c08aaddb$export$fb85bbdbfb3e6869);
        (0, $5uXOq.useEffect)(()=>{
            if (route.isRedirect) (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData($63937a96c08aaddb$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
        }, [
            route.isRedirect,
            route.name
        ]);
        return route.isRedirect ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "lazy_page_redirect",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Page, null)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7LpuY")).default), {
            pageId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateContainer), {
            isGlobal: true,
            appId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateAppStartWithMatchCheck), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "lazy_page",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Page, null))));
    };
});
parcelRegister("kb4zh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c26967b2e10d397c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fNobW;
    var $eZJjh;
    function $c26967b2e10d397c$export$2e2bcd8739ae039({ testId: testId }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "legacy-spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large",
            testId: testId
        }))));
    }
    const $c26967b2e10d397c$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
                __cmplp.className
            ])
        });
    });
    const $c26967b2e10d397c$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wpz1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6jY6G", function(module, exports) {
    $parcel$export(module.exports, "useCurrentRoute", ()=>$dda4cada2257eb1d$export$c4b7ea2942f2d0e);
    $parcel$export(module.exports, "useRouteByName", ()=>$dda4cada2257eb1d$export$d69a946e2d0a1c12);
    $parcel$export(module.exports, "usePreviousRouterState", ()=>$dda4cada2257eb1d$export$1e5fb68306bd0b92);
    var $lODMY;
    var $doZTA;
    var $cfDZ3;
    const $dda4cada2257eb1d$export$c4b7ea2942f2d0e = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.route);
    const $dda4cada2257eb1d$export$d69a946e2d0a1c12 = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state, routeName)=>state.routes.find(({ name: name })=>name === routeName) ?? null);
    const $dda4cada2257eb1d$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
            name: name,
            path: path,
            query: query,
            exact: exact
        });
    const $dda4cada2257eb1d$export$1e5fb68306bd0b92 = ()=>{
        (0, (0, parcelRequire("doZTA")).useRouter)();
        return (0, (0, parcelRequire("cfDZ3")).getPreviousRouterState)();
    };
});
parcelRegister("7LpuY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c62dfc18679e80c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kUU4G;
    var $x9xyg;
    var $5h5Fg;
    var $7N30e;
    var $6b6Tk;
    var $8Qrwl;
    var $hXKq5;
    class $6c62dfc18679e80c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { children: children, pageId: pageId } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Qrwl")).default).Provider, {
                value: {
                    pageId: pageId,
                    onReady: this.onReady,
                    onCustomMark: this.onCustomMark
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5h5Fg")).default), {
                op: this.onStart,
                args: [
                    pageId
                ]
            }), children));
        }
        constructor(...args){
            super(...args), this.customMarks = [], this.onStart = ()=>{
                (0, (0, parcelRequire("kUU4G")).default)((0, $ce556f125dee8174$export$56940a9488e85199));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$45c4b6bf7935c69a));
            }, this.onCustomMark = (markName)=>{
                (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)(markName));
                this.customMarks.push(markName);
            }, this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
                metric.stop({
                    customData: extra
                });
                if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
            };
        }
    }
});
parcelRegister("kUU4G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cb4d2f8b5a69f79$export$2e2bcd8739ae039);
    var $6RCeq;
    var $6cb4d2f8b5a69f79$export$2e2bcd8739ae039 = (prefix)=>{
        if ((0, (0, parcelRequire("6RCeq")).default) && (0, (0, parcelRequire("6RCeq")).default).getEntries && (0, (0, parcelRequire("6RCeq")).default).clearMarks) return (0, (0, parcelRequire("6RCeq")).default).getEntries().filter((mark)=>mark.name.startsWith(prefix)).map((mark)=>{
            (0, (0, parcelRequire("6RCeq")).default).clearMarks(mark.name);
            return mark;
        });
        return [];
    };
});
parcelRegister("5h5Fg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec2154d63d4be857$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    class $ec2154d63d4be857$var$OpTrigger extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                args: []
            };
        }
        componentDidMount() {
            this.props.op(...this.props.args);
        }
        shouldComponentUpdate(nextProps) {
            return !(0, ($parcel$interopDefault($ajpes)))(this.props.args, nextProps.args);
        }
        componentDidUpdate() {
            this.props.op(...this.props.args);
        }
        render() {
            return null;
        }
    }
    var $ec2154d63d4be857$export$2e2bcd8739ae039 = $ec2154d63d4be857$var$OpTrigger;
});
parcelRegister("7N30e", function(module, exports) {
    $parcel$export(module.exports, "stopLowPriorityEventDelay", ()=>$5d68e3874efadecb$export$a928755af449867);
    $parcel$export(module.exports, "startLowPriorityEventDelay", ()=>$5d68e3874efadecb$export$8bb8df5a93e9525);
    $parcel$export(module.exports, "default", ()=>$5d68e3874efadecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kUU4G;
    var $x9xyg;
    var $3vBBc;
    var $fjcgS;
    var $lsa9q;
    var $6b6Tk;
    const $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT = 10000;
    let $5d68e3874efadecb$var$stopDelayTimeout;
    let $5d68e3874efadecb$var$lastDelayActionPromise = (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
    const $5d68e3874efadecb$export$a928755af449867 = ()=>{
        $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
            if (!(0, (0, parcelRequire("3vBBc")).isEventDelayActive)()) return client;
            clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
            (0, (0, parcelRequire("x9xyg")).setMark)((0, $2eb1df3f82c48b0d$export$2d91d3eed1108e72));
            (0, (0, parcelRequire("3vBBc")).setEventDelayActive)(false);
            client.stopLowPriorityEventDelay();
            return client;
        });
    };
    const $5d68e3874efadecb$export$8bb8df5a93e9525 = ()=>{
        $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
            if (!(0, (0, parcelRequire("3vBBc")).isEventDelayActive)()) {
                (0, (0, parcelRequire("kUU4G")).default)((0, $2eb1df3f82c48b0d$export$358721a9d6125914));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $2eb1df3f82c48b0d$export$b2122dce85a27912));
            }
            client.startLowPriorityEventDelay();
            (0, (0, parcelRequire("3vBBc")).setEventDelayActive)(true);
            clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
            $5d68e3874efadecb$var$stopDelayTimeout = setTimeout($5d68e3874efadecb$export$a928755af449867, $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT);
            return client;
        });
    };
    const $5d68e3874efadecb$export$778ebe2a4fab1ba7 = ()=>$5d68e3874efadecb$var$lastDelayActionPromise;
    const $5d68e3874efadecb$var$EventDelayController = ()=>{
        const [loadedState] = (0, (0, parcelRequire("lsa9q")).default)();
        (0, $5uXOq.useEffect)(()=>{
            if (!loadedState.hasLoaded && (0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) $5d68e3874efadecb$export$8bb8df5a93e9525();
        }, [
            loadedState.hasLoaded
        ]);
        return null;
    };
    var $5d68e3874efadecb$export$2e2bcd8739ae039 = $5d68e3874efadecb$var$EventDelayController;
});
parcelRegister("3vBBc", function(module, exports) {
    $parcel$export(module.exports, "setEventDelayActive", ()=>$63f3b8c0745d0500$export$9a4add6d6ddcc1a);
    $parcel$export(module.exports, "isEventDelayActive", ()=>$63f3b8c0745d0500$export$3536b0184fa98d19);
    let $63f3b8c0745d0500$var$eventDelayActive = false;
    const $63f3b8c0745d0500$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
        $63f3b8c0745d0500$var$eventDelayActive = isEventDelayActive;
    };
    const $63f3b8c0745d0500$export$3536b0184fa98d19 = ()=>$63f3b8c0745d0500$var$eventDelayActive;
});
parcelRegister("lsa9q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f20cb56a66aca22$export$2e2bcd8739ae039);
    var $3sQ5x;
    var $7w9eZ;
    const $4f20cb56a66aca22$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
        const { apps: apps } = currentPage;
        const appIds = Object.keys(apps);
        const determineHasLoaded = ()=>{
            if (appIds.length === 1 && appIds[0] === (0, $146ecce9d079a34d$export$3a54edb6ba4daa82)) return !__SPA__;
            return appIds.length ? appIds.filter((id)=>id !== (0, $146ecce9d079a34d$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
        };
        const hasLoaded = determineHasLoaded();
        return {
            hasLoaded: hasLoaded
        };
    };
    const $4f20cb56a66aca22$var$usePageLoadedSubscriber = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: $4f20cb56a66aca22$export$4a361c7505f72f5c
    });
    var $4f20cb56a66aca22$export$2e2bcd8739ae039 = $4f20cb56a66aca22$var$usePageLoadedSubscriber;
});
const $146ecce9d079a34d$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $146ecce9d079a34d$export$2ee9e5a3556c1e43 = 'SIDEBAR';
parcelRegister("7w9eZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85db42238a8acf29$export$2e2bcd8739ae039);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $iXqE5;
    var $6Bj8c;
    const $85db42238a8acf29$export$d4c72bab9d6cc13a = {
        transitionCheckTimestamp: -1,
        currentPage: {
            uuid: false ? '' : (0, ($parcel$interopDefault($7Jxgt))).v4(),
            startTime: typeof performance !== 'undefined' && performance.timing !== undefined && performance.timing.navigationStart || 0,
            apps: {},
            userLocation: ''
        },
        visitedPages: [],
        navigation: {
            isCollapsed: false,
            viewId: 'noView',
            viewType: '',
            projectType: null,
            isInitialEventSent: false,
            pageId: null,
            nextViewId: ''
        }
    };
    const $85db42238a8acf29$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'spa-state',
        initialState: $85db42238a8acf29$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("6Bj8c"))
    });
    var $85db42238a8acf29$export$2e2bcd8739ae039 = $85db42238a8acf29$var$store;
});
parcelRegister("6Bj8c", function(module, exports) {
    $parcel$export(module.exports, "setAppStart", ()=>(parcelRequire("fI6Pg")).setAppStart);
    $parcel$export(module.exports, "setAppReady", ()=>(parcelRequire("fI6Pg")).setAppReady);
    $parcel$export(module.exports, "setAppStartWithAppId", ()=>(parcelRequire("fI6Pg")).setAppStartWithAppId);
    $parcel$export(module.exports, "setAppReadyWithAppId", ()=>(parcelRequire("fI6Pg")).setAppReadyWithAppId);
    $parcel$export(module.exports, "setAppErrorReady", ()=>(parcelRequire("fI6Pg")).setAppErrorReady);
    $parcel$export(module.exports, "setTimeoutReady", ()=>(parcelRequire("fI6Pg")).setTimeoutReady);
    $parcel$export(module.exports, "setTimeoutReadyWithAppId", ()=>(parcelRequire("fI6Pg")).setTimeoutReadyWithAppId);
    $parcel$export(module.exports, "resetCurrentPage", ()=>(parcelRequire("fI6Pg")).resetCurrentPage);
    $parcel$export(module.exports, "setResourceMetrics", ()=>(parcelRequire("fI6Pg")).setResourceMetrics);
    var $fI6Pg;
});
parcelRegister("fI6Pg", function(module, exports) {
    $parcel$export(module.exports, "resetCurrentPage", ()=>$4a986cd3487bf863$export$5639685a1fb81722);
    $parcel$export(module.exports, "setTimeoutReadyWithAppId", ()=>$4a986cd3487bf863$export$8a98548dad2fa97b);
    $parcel$export(module.exports, "setTimeoutReady", ()=>$4a986cd3487bf863$export$b9cc4378ea785421);
    $parcel$export(module.exports, "setAppStartWithAppId", ()=>$4a986cd3487bf863$export$9d528722f2ff2999);
    $parcel$export(module.exports, "setAppStart", ()=>$4a986cd3487bf863$export$71192061050856ad);
    $parcel$export(module.exports, "setAppReadyWithAppId", ()=>$4a986cd3487bf863$export$6a25429a42d30f9a);
    $parcel$export(module.exports, "setAppReady", ()=>$4a986cd3487bf863$export$fc59cc4ed9bba7cd);
    $parcel$export(module.exports, "setAppErrorReady", ()=>$4a986cd3487bf863$export$aff63c1e41443b6a);
    $parcel$export(module.exports, "setResourceMetrics", ()=>$4a986cd3487bf863$export$8ad155d489dcf34d);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $1ciso;
    var $21pfT;
    var $cfDZ3;
    var $1AZST;
    const $4a986cd3487bf863$export$7bd623b29ec8e1eb = 10000;
    const $4a986cd3487bf863$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            performance.mark('resetCurrentPage');
            (0, (0, parcelRequire("21pfT")).browserMetrics).startPageLoad({
                isInitial: false
            });
            (0, (0, parcelRequire("1ciso")).default)(nextRouteUfoName, nextRouteName);
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).abort({
                force: true
            });
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
            if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
                currentPage: {
                    uuid: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                    apps: {},
                    startTime: Date.now(),
                    userLocation: ''
                },
                visitedPages: [
                    ...currentState.visitedPages,
                    {
                        ...currentState.currentPage
                    }
                ],
                transitionCheckTimestamp: 0
            });
        };
    const $4a986cd3487bf863$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
                const apps = {
                    ...currentPage.apps
                };
                if (apps[appId] && apps[appId].expectingTimeout) {
                    const updatedPage = {
                        ...currentPage,
                        apps: {
                            ...apps,
                            [appId]: {
                                ...apps[appId],
                                timeoutTime: timeoutTime,
                                expectingTimeout: 0
                            }
                        }
                    };
                    setState({
                        currentPage: updatedPage
                    });
                }
            }
        };
    const $4a986cd3487bf863$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId, timeoutTime));
        };
    const $4a986cd3487bf863$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
                const timeoutId = setTimeout(()=>{
                    dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId));
                }, $4a986cd3487bf863$export$7bd623b29ec8e1eb);
                const updatedPage = {
                    ...currentPage,
                    userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)(),
                    apps: {
                        ...currentPage.apps,
                        [appId]: {
                            startTime: startTime,
                            expectingTimeout: timeoutId
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $4a986cd3487bf863$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($4a986cd3487bf863$export$9d528722f2ff2999(appId, startTime));
        };
    const $4a986cd3487bf863$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
                const apps = {
                    ...currentPage.apps
                };
                clearTimeout(currentPage.apps[appId].expectingTimeout);
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            endTime: endTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $4a986cd3487bf863$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($4a986cd3487bf863$export$6a25429a42d30f9a(appId, endTime));
        };
    const $4a986cd3487bf863$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        'error-page': {
                            endTime: Date.now()
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $4a986cd3487bf863$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            setState({
                currentPage: {
                    ...currentState.currentPage,
                    resources: [
                        ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                        resourceMetrics
                    ]
                }
            });
        };
});
const $2eb1df3f82c48b0d$export$358721a9d6125914 = 'event-delay-controller.';
const $2eb1df3f82c48b0d$export$b2122dce85a27912 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}start`;
const $2eb1df3f82c48b0d$export$2d91d3eed1108e72 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}end`;
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("8Qrwl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d87d05828c384551$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $d87d05828c384551$var$contextName = 'SpaApdexAnalytics';
    var $d87d05828c384551$export$2e2bcd8739ae039 = (0, $5uXOq.createContext)($d87d05828c384551$var$contextName);
});
parcelRegister("hXKq5", function(module, exports) {
    $parcel$export(module.exports, "getPrefixedMarkName", ()=>$f6cddc52a08e036c$export$c8f0e9837e7e9425);
    const $f6cddc52a08e036c$export$c8f0e9837e7e9425 = (name)=>`${0, $ce556f125dee8174$export$56940a9488e85199}${name}`;
});
parcelRegister("dZw8H", function(module, exports) {
    $parcel$export(module.exports, "SpaStateContainer", ()=>$b1cd152eb196251c$export$e9a92b877fe80e80);
    $parcel$export(module.exports, "SpaStateAppStart", ()=>$b1cd152eb196251c$export$d18dd27183a635c);
    $parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", ()=>$b1cd152eb196251c$export$95a2912d76fb5433);
    $parcel$export(module.exports, "SpaStatePageReady", ()=>$b1cd152eb196251c$export$c34439f945fccbdf);
    $parcel$export(module.exports, "SpaStatePageReadyOnUpdate", ()=>$b1cd152eb196251c$export$41e70078eeddaddc);
    $parcel$export(module.exports, "SpaStatePageErrorReady", ()=>$b1cd152eb196251c$export$2583aa269898885c);
    $parcel$export(module.exports, "getSpaStateLastUserLocation", ()=>$b1cd152eb196251c$export$6e9ab893e97cccef);
    var $5uXOq = parcelRequire("5uXOq");
    var $5h5Fg;
    var $lODMY;
    var $gg7kZ;
    var $3sQ5x;
    var $bKpgX;
    var $4oDnX;
    var $7w9eZ;
    const $b1cd152eb196251c$export$e9a92b877fe80e80 = (0, (0, parcelRequire("gg7kZ")).createContainer)((0, (0, parcelRequire("7w9eZ")).default));
    const $b1cd152eb196251c$export$d18dd27183a635c = ()=>{
        const startRef = (0, $5uXOq.useRef)(Date.now());
        const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, (0, parcelRequire("4oDnX")).useSpaState)();
        (0, $5uXOq.useMemo)(()=>{
            startRef.current = Date.now();
        }, [
            visitedPages
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setAppStart(startRef.current);
        }, [
            setAppStart,
            visitedPages
        ]);
        return null;
    };
    const $b1cd152eb196251c$var$useRouterMatchSelector = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.match);
    const $b1cd152eb196251c$var$useSpaStatePagesCount = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: ({ visitedPages: visitedPages })=>visitedPages.length
    });
    const $b1cd152eb196251c$export$95a2912d76fb5433 = ()=>{
        const match = $b1cd152eb196251c$var$useRouterMatchSelector();
        const [count, { setAppStart: setAppStart }] = $b1cd152eb196251c$var$useSpaStatePagesCount();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b1cd152eb196251c$export$ada7e0ec445851a2, {
            visitedPagesLength: count,
            onSetAppStart: setAppStart,
            match: match
        });
    };
    const $b1cd152eb196251c$export$c34439f945fccbdf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5h5Fg")).default), {
                op: setAppReady
            }));
    const $b1cd152eb196251c$export$41e70078eeddaddc = ({ comparer: comparer })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5h5Fg")).default), {
                op: setAppReady,
                args: comparer
            }));
    const $b1cd152eb196251c$export$2583aa269898885c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppErrorReady: setAppErrorReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5h5Fg")).default), {
                op: setAppErrorReady
            }));
    class $b1cd152eb196251c$export$ada7e0ec445851a2 extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props, state) {
            const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
            const matchHasChanged = props.match !== state.match;
            const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
            if (setAppStart) props.onSetAppStart(Date.now());
            if (setAppStart || !visitedPageLengthHasChanged) return {
                started: true,
                visitedPagesLength: props.visitedPagesLength,
                match: props.match
            };
            return state;
        }
        render() {
            return null;
        }
        constructor(...args){
            super(...args), this.state = {
                visitedPagesLength: 0,
                started: false,
                match: null
            };
        }
    }
    const $b1cd152eb196251c$export$6e9ab893e97cccef = ()=>{
        const { visitedPages: visitedPages } = (0, (0, parcelRequire("bKpgX")).defaultRegistry).getStore((0, (0, parcelRequire("7w9eZ")).default)).storeState.getState();
        return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
    };
});
parcelRegister("4oDnX", function(module, exports) {
    $parcel$export(module.exports, "SpaStateSubscriber", ()=>$363cd3235a9267e4$export$fd52daf2a3c1ec68);
    $parcel$export(module.exports, "SpaStateActionsSubscriber", ()=>$363cd3235a9267e4$export$3dfa91988c213fbc);
    $parcel$export(module.exports, "useSpaState", ()=>$363cd3235a9267e4$export$a57865516f6345d1);
    $parcel$export(module.exports, "useSpaStateActions", ()=>$363cd3235a9267e4$export$b134752525935b78);
    var $3sQ5x;
    var $51nlc;
    var $7w9eZ;
    const $363cd3235a9267e4$export$fd52daf2a3c1ec68 = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("7w9eZ")).default));
    const $363cd3235a9267e4$export$3dfa91988c213fbc = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: null
    });
    const $363cd3235a9267e4$export$a57865516f6345d1 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default));
    const $363cd3235a9267e4$export$b134752525935b78 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: null
    });
});
parcelRegister("jqHqY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("i5RRW"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("8uqRL")
    ]).then(()=>parcelRequire('6iSaB'));
});
parcelRegister("kZOse", function(module, exports) {
    $parcel$export(module.exports, "CalendarSkeleton", ()=>$7999bdaf81f7939b$export$ebc7c47cc535837e);
    $parcel$export(module.exports, "CalendarEmbedSkeleton", ()=>$7999bdaf81f7939b$export$bf543fe31d33292e);
    $parcel$export(module.exports, "CalendarNoHeaderSkeleton", ()=>$7999bdaf81f7939b$export$504e7b05f3c54bf2);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $3a8Pq = parcelRequire("3a8Pq");
    var $eqvk7 = parcelRequire("eqvk7");
    var $hbVDT = parcelRequire("hbVDT");
    const $7999bdaf81f7939b$var$customCssStyles = null;
    const $7999bdaf81f7939b$export$ebc7c47cc535837e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($3a8Pq)))
        });
    const $7999bdaf81f7939b$export$bf543fe31d33292e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($eqvk7)))
        });
    const $7999bdaf81f7939b$export$504e7b05f3c54bf2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($hbVDT))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        });
});
parcelRegister("hCy6k", function(module, exports) {
    $parcel$export(module.exports, "AppSkeletonImage", ()=>$a2cd0a6153845fd0$export$45b107c5dc7b51a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fNobW;
    var $koVbs;
    var $d0Ozr;
    const $a2cd0a6153845fd0$var$skeletonImageStyles = null;
    const $a2cd0a6153845fd0$export$45b107c5dc7b51a5 = ({ src: src, className: className, containerStyles: containerStyles })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "app-skeleton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a2cd0a6153845fd0$var$SkeletonWrapper, {
            style: containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: src,
            alt: `${formatMessage((0, (0, parcelRequire("d0Ozr")).default).loading)}...`,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _vchhusvi _1bsb1osq _1dqonqa1 _1h6d3acm _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
                className
            ])
        })));
    };
    const $a2cd0a6153845fd0$var$SkeletonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("d0Ozr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6abc81adadf77f72$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6abc81adadf77f72$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        loading: {
            "id": "skeletons.common.loading",
            "defaultMessage": "Loading"
        }
    });
});
parcelRegister("3a8Pq", function(module, exports) {
    module.exports = new URL("calendar-app-skeleton.tpl.77b09222.svg", import.meta.url).toString();
});
parcelRegister("eqvk7", function(module, exports) {
    module.exports = new URL("calendar-embed-app-skeleton.tpl.29c9a641.svg", import.meta.url).toString();
});
parcelRegister("hbVDT", function(module, exports) {
    module.exports = new URL("calendar-no-header-skeleton.tpl.d6779107.svg", import.meta.url).toString();
});
parcelRegister("59Yu1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("axKNq")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gsa5D")
    ]).then(()=>parcelRequire('5zu1k'));
});
parcelRegister("aMHR6", function(module, exports) {
    "use strict";
    var $g1Pp8 = parcelRequire("g1Pp8");
    module.exports = $g1Pp8(function(bundle) {
        return new Promise(function(resolve, reject) {
            var existingLinks = document.getElementsByTagName('link');
            if ([].concat(existingLinks).some(function isCurrentBundle(link) {
                return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
            })) {
                resolve();
                return;
            }
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = bundle;
            link.onerror = function(e) {
                link.onerror = link.onload = null;
                link.remove();
                reject(e);
            };
            link.onload = function() {
                link.onerror = link.onload = null;
                resolve();
            };
            document.getElementsByTagName('head')[0].appendChild(link);
        });
    });
});
parcelRegister("g1Pp8", function(module, exports) {
    "use strict";
    var $bab49d2fea43af49$var$cachedBundles = {};
    var $bab49d2fea43af49$var$cachedPreloads = {};
    var $bab49d2fea43af49$var$cachedPrefetches = {};
    function $bab49d2fea43af49$var$getCache(type) {
        switch(type){
            case 'preload':
                return $bab49d2fea43af49$var$cachedPreloads;
            case 'prefetch':
                return $bab49d2fea43af49$var$cachedPrefetches;
            default:
                return $bab49d2fea43af49$var$cachedBundles;
        }
    }
    module.exports = function(loader, type) {
        return function(bundle) {
            var cache = $bab49d2fea43af49$var$getCache(type);
            if (cache[bundle]) return cache[bundle];
            return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
                delete cache[bundle];
                throw e;
            });
        };
    };
});
parcelRegister("7yO8g", function(module, exports) {
    $parcel$export(module.exports, "markAsProductBundleReady", ()=>$beda9c6123873bbb$export$ff83c57004505abd);
    var $2SVPM;
    const $beda9c6123873bbb$export$ff83c57004505abd = (importedBundle)=>{
        if (!false) importedBundle.then(()=>{
            (0, (0, parcelRequire("2SVPM")).setProductBundleReadyForInitialRender)();
        });
        return importedBundle;
    };
});
parcelRegister("cQB2d", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("8kWVn")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("83FIe")
    ]).then(()=>parcelRequire('3Wpua'));
});
parcelRegister("5JvHC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("4XDQa")),
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8czeq")
    ]).then(()=>parcelRequire('9WfFd'));
});
parcelRegister("dcrIA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("bxjtM")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jcetw")
    ]).then(()=>parcelRequire('f3Kyg'));
});
parcelRegister("lv9xW", function(module, exports) {
    $parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", ()=>$f87ae7e2901ac155$export$f9061628830b5175);
    $parcel$export(module.exports, "fetchAdvancedRoadmapsSummaryData", ()=>$f87ae7e2901ac155$export$2dfe99460dae6bc6);
    var $4R6GH;
    var $7f4tk;
    var $2M1hQ;
    var $5m5rT;
    var $iz4dr;
    const $f87ae7e2901ac155$var$getQueryParams = (routerQuery)=>{
        if (typeof window !== 'undefined') return Object.fromEntries(new URLSearchParams(window.location.search));
        return routerQuery;
    };
    const $f87ae7e2901ac155$export$f9061628830b5175 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ADVANCED_ROADMAPS_SUMMARY_DATA',
        getKey: ({ match: match })=>{
            const { params: params } = match;
            if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
            return 'none';
        },
        getData: async ({ match: match, query: query })=>{
            if (window.__ARJ_SUMMARY_PAGE_PROMISE__) {
                const response = window.__ARJ_SUMMARY_PAGE_PROMISE__;
                window.__ARJ_SUMMARY_PAGE_PROMISE__ = null;
                return response;
            }
            const { params: params } = match;
            return $f87ae7e2901ac155$export$2dfe99460dae6bc6(params, query, (0, (0, parcelRequire("5m5rT")).AVAILABLE_CHARTS));
        },
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $f87ae7e2901ac155$export$2dfe99460dae6bc6 = async (params, query, chartTypes)=>{
        if (params.planId == null) throw new Error('Unable to get fetch data for ADVANCED_ROADMAPS_SUMMARY_DATA. planId is not defined');
        if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) {
            const dateRange = (0, (0, parcelRequire("iz4dr")).validateDateRange)((0, (0, parcelRequire("iz4dr")).parseDateRange)($f87ae7e2901ac155$var$getQueryParams(query)));
            const data = await (0, (0, parcelRequire("7f4tk")).default)('/rest/jpo/1.0/summary/data', {
                method: 'POST',
                body: JSON.stringify({
                    planId: params.planId,
                    scenarioId: params.scenarioId,
                    chartTypes: chartTypes,
                    ...dateRange ? {
                        dateRange: dateRange
                    } : {}
                })
            });
            return dateRange ? {
                ...data,
                customDateRange: dateRange
            } : data;
        }
        const { startDate: startDate, endDate: endDate } = $f87ae7e2901ac155$var$getQueryParams(query);
        const customDateRangeParams = startDate && endDate ? {
            startDate: startDate,
            endDate: endDate
        } : {};
        const data = await (0, (0, parcelRequire("7f4tk")).default)('/rest/jpo/1.0/summary/data', {
            method: 'POST',
            body: JSON.stringify({
                planId: params.planId,
                scenarioId: params.scenarioId,
                chartTypes: chartTypes,
                ...customDateRangeParams
            })
        });
        return data;
    };
});
parcelRegister("5m5rT", function(module, exports) {
    $parcel$export(module.exports, "CHART_TYPES", ()=>$d315f648a94f47c0$export$3251435144ca69e2);
    $parcel$export(module.exports, "AVAILABLE_CHARTS", ()=>$d315f648a94f47c0$export$79cf9c14f738d70b);
    $parcel$export(module.exports, "SCHEDULING_MODES", ()=>$d315f648a94f47c0$export$92daf59e30346cd2);
    $parcel$export(module.exports, "CAPACITY_UNIT", ()=>$d315f648a94f47c0$export$494e761f17fc60a9);
    $parcel$export(module.exports, "SPRINT_STATE", ()=>$d315f648a94f47c0$export$38e437924c2adbda);
    const $d315f648a94f47c0$export$3251435144ca69e2 = {
        statusCategory: 'STATUS_CATEGORY',
        issueProgress: 'ISSUE_PROGRESS',
        teamProgress: 'TEAM_PROGRESS',
        teamCapacity: 'TEAM_CAPACITY',
        blockers: 'BLOCKERS',
        highestPriority: 'HIGHEST_PRIORITY',
        unassignedIssues: 'UNASSIGNED_ISSUES',
        overlappingBlockers: 'OVERLAPPING_BLOCKERS',
        overdue: 'OVERDUE'
    };
    const $d315f648a94f47c0$export$79cf9c14f738d70b = [
        $d315f648a94f47c0$export$3251435144ca69e2.statusCategory,
        $d315f648a94f47c0$export$3251435144ca69e2.issueProgress,
        $d315f648a94f47c0$export$3251435144ca69e2.teamProgress,
        $d315f648a94f47c0$export$3251435144ca69e2.teamCapacity,
        $d315f648a94f47c0$export$3251435144ca69e2.blockers,
        $d315f648a94f47c0$export$3251435144ca69e2.highestPriority,
        $d315f648a94f47c0$export$3251435144ca69e2.unassignedIssues,
        $d315f648a94f47c0$export$3251435144ca69e2.overlappingBlockers,
        $d315f648a94f47c0$export$3251435144ca69e2.overdue
    ];
    const $d315f648a94f47c0$export$92daf59e30346cd2 = {
        SCRUM: 'Scrum',
        KANBAN: 'Kanban'
    };
    const $d315f648a94f47c0$export$494e761f17fc60a9 = {
        HOURS: 'HOURS',
        POINTS: 'STORY_POINTS',
        DAYS: 'DAYS'
    };
    const $d315f648a94f47c0$export$38e437924c2adbda = {
        CLOSED: 'CLOSED',
        ACTIVE: 'ACTIVE',
        FUTURE: 'FUTURE'
    };
});
parcelRegister("iz4dr", function(module, exports) {
    $parcel$export(module.exports, "parseDateRange", ()=>$8d575024c745c5c9$export$1cd7060bc72a318c);
    $parcel$export(module.exports, "validateDateRange", ()=>$8d575024c745c5c9$export$b3e10550232e39db);
    var $gZ6zR;
    const $8d575024c745c5c9$export$637d8b0948b783c7 = {
        [(0, (0, parcelRequire("gZ6zR")).DATE_UNITS).DAYS]: 3650,
        [(0, (0, parcelRequire("gZ6zR")).DATE_UNITS).WEEKS]: 520,
        [(0, (0, parcelRequire("gZ6zR")).DATE_UNITS).MONTHS]: 120
    };
    const $8d575024c745c5c9$export$cf70eebe96d0cb07 = (type)=>{
        switch(type){
            case (0, (0, parcelRequire("gZ6zR")).CUSTOM_TIME_RANGE_TYPES).FIXED:
            case (0, (0, parcelRequire("gZ6zR")).CUSTOM_TIME_RANGE_TYPES).RELATIVE:
                return type;
            default:
                return undefined;
        }
    };
    const $8d575024c745c5c9$export$6bf0e8cf8e1d780d = (value)=>{
        if (value === undefined) return undefined;
        const parsed = parseInt(value, 10);
        return Number.isNaN(parsed) ? undefined : parsed;
    };
    const $8d575024c745c5c9$export$c777dd44ece05114 = (unit)=>{
        switch(unit){
            case (0, (0, parcelRequire("gZ6zR")).DATE_UNITS).DAYS:
            case (0, (0, parcelRequire("gZ6zR")).DATE_UNITS).WEEKS:
            case (0, (0, parcelRequire("gZ6zR")).DATE_UNITS).MONTHS:
                return unit;
            default:
                return undefined;
        }
    };
    const $8d575024c745c5c9$export$1cd7060bc72a318c = (query)=>{
        const { fromDate: fromDate, toDate: toDate, toNow: toNow, fromNow: fromNow, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit, dateRangeType: dateRangeType } = query;
        return {
            typeOfCustomDateRange: $8d575024c745c5c9$export$cf70eebe96d0cb07(dateRangeType),
            fromDate: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(fromDate),
            toDate: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(toDate),
            fromNowUnitCount: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(fromNow),
            toNowUnitCount: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(toNow),
            fromNowUnit: $8d575024c745c5c9$export$c777dd44ece05114(fromNowUnit),
            toNowUnit: $8d575024c745c5c9$export$c777dd44ece05114(toNowUnit)
        };
    };
    const $8d575024c745c5c9$export$68346777682e262 = (count, unit)=>{
        if (count === undefined || unit === undefined) return false;
        return count >= 0 && count <= $8d575024c745c5c9$export$637d8b0948b783c7[unit];
    };
    const $8d575024c745c5c9$export$1ba31c57b50b4374 = (timestamp)=>{
        if (timestamp === undefined) return false;
        const date = new Date(timestamp);
        return !Number.isNaN(date.getTime());
    };
    const $8d575024c745c5c9$export$b3e10550232e39db = (dateRange)=>{
        const { fromDate: fromDate, toDate: toDate, toNowUnitCount: toNowUnitCount, toNowUnit: toNowUnit, fromNowUnitCount: fromNowUnitCount, fromNowUnit: fromNowUnit, typeOfCustomDateRange: typeOfCustomDateRange } = dateRange;
        if (typeOfCustomDateRange === (0, (0, parcelRequire("gZ6zR")).CUSTOM_TIME_RANGE_TYPES).RELATIVE && $8d575024c745c5c9$export$68346777682e262(toNowUnitCount, toNowUnit) && $8d575024c745c5c9$export$68346777682e262(fromNowUnitCount, fromNowUnit)) return {
            toNowUnitCount: toNowUnitCount,
            toNowUnit: toNowUnit,
            fromNowUnitCount: fromNowUnitCount,
            fromNowUnit: fromNowUnit,
            typeOfCustomDateRange: typeOfCustomDateRange
        };
        if (typeOfCustomDateRange === (0, (0, parcelRequire("gZ6zR")).CUSTOM_TIME_RANGE_TYPES).FIXED && $8d575024c745c5c9$export$1ba31c57b50b4374(fromDate) && $8d575024c745c5c9$export$1ba31c57b50b4374(toDate)) return {
            fromDate: fromDate,
            toDate: toDate,
            typeOfCustomDateRange: typeOfCustomDateRange
        };
        return undefined;
    };
});
parcelRegister("gZ6zR", function(module, exports) {
    $parcel$export(module.exports, "CUSTOM_TIME_RANGE_TYPES", ()=>$ad83cd0410dc011b$export$78e07fecfaf51c7b);
    $parcel$export(module.exports, "DATE_UNITS", ()=>$ad83cd0410dc011b$export$c99d20cdba4a5739);
    $parcel$export(module.exports, "IssueStatus", ()=>$ad83cd0410dc011b$export$559eb15a98685419);
    $parcel$export(module.exports, "BlockType", ()=>$ad83cd0410dc011b$export$48808c686fe495c4);
    const $ad83cd0410dc011b$export$78e07fecfaf51c7b = {
        FIXED: 'fixed',
        RELATIVE: 'relative'
    };
    const $ad83cd0410dc011b$export$c99d20cdba4a5739 = {
        DAYS: 'days',
        MONTHS: 'months',
        WEEKS: 'weeks'
    };
    const $ad83cd0410dc011b$export$559eb15a98685419 = {
        TODO: 'TODO',
        IN_PROGRESS: 'IN_PROGRESS',
        DONE: 'DONE'
    };
    const $ad83cd0410dc011b$export$de194318c6dccbc1 = {
        INITIATIVE: 'INITIATIVE',
        EPIC: 'EPIC'
    };
    const $ad83cd0410dc011b$export$48808c686fe495c4 = {
        DELAY_WORK: 'DELAY_WORK',
        CRITICAL_PATH: 'CRITICAL_PATH',
        BLOCK_WORK: 'BLOCK_WORK'
    };
});
parcelRegister("3RJkv", function(module, exports) {
    $parcel$export(module.exports, "getModernIssueTransitionResources", ()=>$4f455891fb36bf50$export$e1afa08027b1e44b);
    $parcel$export(module.exports, "getNavigationResources", ()=>$4f455891fb36bf50$export$75cffd1aaecf4a2c);
    $parcel$export(module.exports, "getUserBoardNavigationResources", ()=>$4f455891fb36bf50$export$c57dc1ea7f76f91f);
    $parcel$export(module.exports, "getNavigationSidebarPlanResources", ()=>$4f455891fb36bf50$export$af2259a87f79645d);
    $parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", ()=>$4f455891fb36bf50$export$a103e99ad51f7bc3);
    $parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", ()=>$4f455891fb36bf50$export$808691f5a412afa3);
    var $5kYzp;
    var $co1wz;
    var $4R6GH;
    var $5bkvv;
    var $7xTO3;
    var $c1N9v;
    var $loy04;
    var $2fwuR;
    var $fwzEJ;
    var $3HwlS;
    var $h9iZl;
    var $2eyDn;
    var $drGWM;
    var $kMiZJ;
    var $bHhiy;
    var $aA974;
    var $f5nIZ;
    var $hZhhj;
    var $9MiT2;
    var $fNOVA;
    var $14XJw;
    var $kJQXA;
    var $atU1t;
    var $c34Wf;
    var $eOlBz;
    var $3X1Xr;
    var $dxCvy;
    var $4dc0x;
    var $51Yl2;
    var $lXNZG;
    var $kkNtb;
    var $2Ql51;
    var $9vlEn;
    var $gNStA;
    const $4f455891fb36bf50$var$getNewIssueTransitionExperienceInJiraLabsVariation = ()=>(0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', [
            'OFF',
            'BY_DEFAULT_USER_OPT_IN',
            'BY_DEFAULT_USER_OPT_OUT'
        ]);
    const $4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled = ()=>{
        const variation = $4f455891fb36bf50$var$getNewIssueTransitionExperienceInJiraLabsVariation();
        return variation !== 'OFF';
    };
    const $4f455891fb36bf50$var$conditionalGicOptInStatusResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('render_modern_global_issue_create_modal_experience'), (0, (0, parcelRequire("f5nIZ")).gicOptInStatusResources));
    const $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)($4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled, (0, (0, parcelRequire("fNOVA")).issueTransitionOptInStatusResource));
    const $4f455891fb36bf50$var$conditionalGicSmartFieldsOptoutResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs'), (0, (0, parcelRequire("aA974")).gicSmartFieldsFeatureResource));
    const $4f455891fb36bf50$var$conditionalConsentBannerUserPreferencesResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('platform.moonjelly.browser-storage-controls-v2'), (0, (0, parcelRequire("2eyDn")).consentBannerUserPreferencesResource));
    const $4f455891fb36bf50$export$e1afa08027b1e44b = ()=>[
            $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource,
            (0, (0, parcelRequire("9MiT2")).issueTransitionChangeboardingPreferencesResource)
        ];
    const $4f455891fb36bf50$var$dedupableConditionalResources = [
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, (0, parcelRequire("kMiZJ")).consolidationUserStateResource)),
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("2fwuR")).sidebarNav4Resource)),
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("2fwuR")).sidebarNav4UiStateResource)),
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("fwzEJ")).topNav4UIStateResource))
    ];
    const $4f455891fb36bf50$export$75cffd1aaecf4a2c = ()=>[
            (0, (0, parcelRequire("c34Wf")).navigationUiStateResource),
            (0, (0, parcelRequire("h9iZl")).navigationPlansVisibilityResource),
            (0, (0, parcelRequire("9vlEn")).userHomepageResource),
            $4f455891fb36bf50$var$conditionalGicOptInStatusResource,
            (0, (0, parcelRequire("5kYzp")).announcementBannerSettingsV4Resource),
            $4f455891fb36bf50$var$conditionalConsentBannerUserPreferencesResource,
            ...$4f455891fb36bf50$var$dedupableConditionalResources,
            (0, (0, parcelRequire("14XJw")).organizationIdResource),
            (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
            ...$4f455891fb36bf50$export$e1afa08027b1e44b(),
            (0, (0, parcelRequire("3X1Xr")).persistentIssueCreateModalViewResource),
            $4f455891fb36bf50$var$conditionalGicSmartFieldsOptoutResource,
            (0, (0, parcelRequire("hZhhj")).incomingMailServerExpiryStatusResource),
            (0, (0, parcelRequire("kkNtb")).rovoEntitlementResource),
            (0, (0, parcelRequire("lXNZG")).jpdRecommendationDismissedResource),
            (0, (0, parcelRequire("51Yl2")).fetchUserTraitsResource),
            (0, (0, parcelRequire("4dc0x")).fetchSiteTraitsResource)
        ];
    const $4f455891fb36bf50$export$c57dc1ea7f76f91f = ()=>[
            (0, (0, parcelRequire("7xTO3")).staticJSWUserBoardSidebarNavigationResource)
        ];
    const $4f455891fb36bf50$export$af2259a87f79645d = ()=>[
            (0, (0, parcelRequire("c1N9v")).staticPlanSidebarNavigationResource)
        ];
    const $4f455891fb36bf50$export$a103e99ad51f7bc3 = ()=>[
            (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
            (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
            (0, (0, parcelRequire("drGWM")).checkApiKeyManagementKeysResource)()
        ];
    const $4f455891fb36bf50$export$808691f5a412afa3 = ()=>[
            (0, (0, parcelRequire("eOlBz")).newIssueViewTransitionLockInStatusResource),
            (0, (0, parcelRequire("kJQXA")).navigationSidebarAutomationLegacyEnabledResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
            (0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleResource),
            (0, (0, parcelRequire("loy04")).staticProjectSettingsSidebarConnectAddonsNavigationResource)
        ];
});
parcelRegister("5kYzp", function(module, exports) {
    $parcel$export(module.exports, "announcementBannerSettingsV4Resource", ()=>$76a68e4d8702ab58$export$8fbe7f8de07afffd);
    $parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", ()=>$76a68e4d8702ab58$export$6fb72f4a0c177494);
    var $2M1hQ;
    var $2YP9W;
    var $4AdUG;
    var $2EmJy;
    var $9UEf0;
    const $76a68e4d8702ab58$export$2a421cd16fa9a95a = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ANNOUNCEMENT_BANNER_SETTINGS',
        getKey: ()=>'settings',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
            const [settings, hashIdLastDimissed] = await Promise.all([
                (0, (0, parcelRequire("2EmJy")).get)(),
                (0, (0, parcelRequire("9UEf0")).get)(atlassianAccountId)
            ]);
            return {
                ...settings,
                isDismissable: isAnonymous ? false : settings?.isDismissable,
                isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
            };
        },
        maxAge: 900000
    });
    const $76a68e4d8702ab58$export$8fbe7f8de07afffd = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
        getKey: ()=>'settings',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
            const [settings, hashIdLastDimissed] = await Promise.all([
                (0, (0, parcelRequire("4AdUG")).get)(),
                (0, (0, parcelRequire("9UEf0")).get)(atlassianAccountId)
            ]);
            return {
                ...settings,
                isDismissable: isAnonymous ? false : settings?.isDismissable,
                isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
            };
        },
        maxAge: 900000
    });
    const $76a68e4d8702ab58$export$43d4950a3e443fd3 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($76a68e4d8702ab58$export$2a421cd16fa9a95a);
    const $76a68e4d8702ab58$export$6fb72f4a0c177494 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($76a68e4d8702ab58$export$8fbe7f8de07afffd);
});
parcelRegister("4AdUG", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$90a9ae99ea774144$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$90a9ae99ea774144$export$adaa4cf7ef1b65be);
    var $jcw0u;
    var $eusud;
    const $90a9ae99ea774144$export$3988ae62b71be9a3 = async ()=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/internal/4/announcement-banner');
        } catch (error) {
            if (error.statusCode === 403) return {
                content: '',
                bgColor: 'grey',
                isEnabled: false,
                isDismissable: false,
                visibility: 'private',
                hashId: ''
            };
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'settingsV4Get',
                    packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                    teamName: 'jira-cosmos'
                },
                error: error
            });
            throw error;
        }
    };
    const $90a9ae99ea774144$export$adaa4cf7ef1b65be = async (body)=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/internal/4/announcement-banner', {
                body: JSON.stringify(body)
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'settingsV4Set',
                    packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                    teamName: 'jira-cosmos'
                },
                error: error
            });
            throw error;
        }
    };
});
parcelRegister("2EmJy", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$02ac2f2e29fd92e6$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$02ac2f2e29fd92e6$export$adaa4cf7ef1b65be);
    var $jcw0u;
    var $eusud;
    const $02ac2f2e29fd92e6$export$3988ae62b71be9a3 = async ()=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/internal/3/announcement-banner');
        } catch (error) {
            if (error.statusCode === 403) return {
                message: '',
                isEnabled: false,
                isDismissable: false,
                visibility: 'private',
                hashId: ''
            };
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'settingsGet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
    const $02ac2f2e29fd92e6$export$adaa4cf7ef1b65be = async (body)=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/internal/3/announcement-banner', {
                body: JSON.stringify(body)
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'settingsSet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
});
const $981adbf91eeefd26$export$b8b9d90f9e5bd72b = '@atlassian/jira-admin-pages-system-ui-announcement-banner-resources';
const $981adbf91eeefd26$export$5e0c0e8c940630f8 = 'private';
const $981adbf91eeefd26$export$1d5a5b6462188eb3 = 'public';
parcelRegister("9UEf0", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$0fff4d2d98ff5692$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$0fff4d2d98ff5692$export$adaa4cf7ef1b65be);
    var $89SaW;
    var $jcw0u;
    const $0fff4d2d98ff5692$var$key = 'announcementBannerDismissedLast';
    const $0fff4d2d98ff5692$export$3988ae62b71be9a3 = async (accoundId)=>{
        try {
            return accoundId != null ? (await (0, (0, parcelRequire("89SaW")).getUserProperty)(accoundId, $0fff4d2d98ff5692$var$key)).hashId : null;
        } catch (error) {
            if (error.statusCode === 404) return null;
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'userDismissGet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
    const $0fff4d2d98ff5692$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
        try {
            return await (0, (0, parcelRequire("89SaW")).setUserProperties)(accoundId, $0fff4d2d98ff5692$var$key, JSON.stringify({
                hashId: hashId
            }));
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'userDismissSet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
});
parcelRegister("89SaW", function(module, exports) {
    $parcel$export(module.exports, "getUserPropertiesUrl", ()=>$646571db30c23ce6$export$f474e53c8191800a);
    $parcel$export(module.exports, "setUserProperties", ()=>$646571db30c23ce6$export$d0e176862bf869b8);
    $parcel$export(module.exports, "getUserProperty", ()=>$646571db30c23ce6$export$b3126db2ef6e34ed);
    var $gHS8W;
    var $jJZqs;
    const $646571db30c23ce6$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
    const $646571db30c23ce6$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>fetch($646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey), {
            ...(0, (0, parcelRequire("gHS8W")).default),
            method: 'PUT',
            body: data
        });
    const $646571db30c23ce6$export$b3126db2ef6e34ed = (accountId, propertyKey)=>fetch($646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey), (0, (0, parcelRequire("gHS8W")).default)).then((res)=>{
            if (res.status === 200) return res.json();
            return res.text().then((errResp)=>{
                throw new (0, (0, parcelRequire("jJZqs")).default)(res.status, errResp);
            });
        }).then((data)=>data.value);
});
parcelRegister("gHS8W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33c6318209de3901$export$2e2bcd8739ae039);
    const $33c6318209de3901$var$defaultOptions = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-force-account-id': 'true',
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ]
        }
    };
    var $33c6318209de3901$export$2e2bcd8739ae039 = $33c6318209de3901$var$defaultOptions;
});
parcelRegister("5bkvv", function(module, exports) {
    $parcel$export(module.exports, "forgeAdminModuleV1Resource", ()=>$3d515a0fe8e87c81$export$168ac1f97221e90b);
    $parcel$export(module.exports, "forgeAdminModuleV2Resource", ()=>$3d515a0fe8e87c81$export$536a08360f048bac);
    $parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", ()=>$3d515a0fe8e87c81$export$dcc98f4b36ce9223);
    $parcel$export(module.exports, "forgeProjectModuleV1Resource", ()=>$3d515a0fe8e87c81$export$ad95e2d07d6fa1a);
    $parcel$export(module.exports, "forgeProjectModuleV2Resource", ()=>$3d515a0fe8e87c81$export$1a17680eb0746291);
    $parcel$export(module.exports, "forgeProjectModuleResource", ()=>$3d515a0fe8e87c81$export$72db683c2914a65e);
    $parcel$export(module.exports, "forgeProjectModuleResourceOnNav3Only", ()=>$3d515a0fe8e87c81$export$9f19b684a7493211);
    $parcel$export(module.exports, "forgeBacklogModuleResource", ()=>$3d515a0fe8e87c81$export$7523db37432ba090);
    $parcel$export(module.exports, "forgeBoardModuleResource", ()=>$3d515a0fe8e87c81$export$cfd99f451b423d3a);
    $parcel$export(module.exports, "forgePersonalSettingsPageModuleResource", ()=>$3d515a0fe8e87c81$export$8a5aed164e925eb6);
    $parcel$export(module.exports, "getNavigationForgePersonalSettingsPageResources", ()=>$3d515a0fe8e87c81$export$ec3265610584f9ce);
    $parcel$export(module.exports, "forgeProjectSettingsModuleV1Resource", ()=>$3d515a0fe8e87c81$export$fa67d109c2a45864);
    $parcel$export(module.exports, "forgeProjectSettingsModuleV2Resource", ()=>$3d515a0fe8e87c81$export$23c2bb87c561c9db);
    $parcel$export(module.exports, "forgeProjectSettingsModuleResource", ()=>$3d515a0fe8e87c81$export$7a928d209faf75f);
    $parcel$export(module.exports, "useForgeProjectSettingsModuleResource", ()=>$3d515a0fe8e87c81$export$e81e11bbc3239153);
    $parcel$export(module.exports, "forgeGlobalModuleV1Resource", ()=>$3d515a0fe8e87c81$export$60e774d0427b56fc);
    $parcel$export(module.exports, "forgeGlobalModuleV2Resource", ()=>$3d515a0fe8e87c81$export$75f594fe5ce76af);
    $parcel$export(module.exports, "getNavigationForgeGlobalPageResources", ()=>$3d515a0fe8e87c81$export$80b2f91dabb3dd65);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleV1Resource", ()=>$3d515a0fe8e87c81$export$b555dc3ff28ae9cc);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleV2Resource", ()=>$3d515a0fe8e87c81$export$d2d6bc2f3bd0f942);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", ()=>$3d515a0fe8e87c81$export$ebf5369e4dcfad00);
    $parcel$export(module.exports, "forgeCustomFieldTypeResource", ()=>$3d515a0fe8e87c81$export$e6be2f0ca0849869);
    var $8O7FC;
    var $4R6GH;
    var $k2DRb;
    var $5vSAE;
    var $iVaKa;
    var $3HwlS;
    var $dK8AG;
    var $gNStA;
    var $2M1hQ;
    var $2YP9W;
    var $47m5i;
    var $1yLrr;
    const $3d515a0fe8e87c81$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
        const isModuleWithAccessNarrowing = [
            (0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE)
        ].includes(moduleName);
        const projectIdOrKey = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(params);
        if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
            projectIdOrKey: projectIdOrKey
        };
        return null;
    };
    const $3d515a0fe8e87c81$var$createDataGetter = (moduleName, shouldReturnANExtensions = false, createContextIds)=>(route, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>{
            const { match: params } = route;
            const dataClassification = $3d515a0fe8e87c81$export$eb46cc3d7c1a6649(params, moduleName);
            const contextIds = typeof createContextIds === 'function' && createContextIds({
                cloudId: cloudId,
                activationId: activationId
            }) || undefined;
            return (0, (0, parcelRequire("47m5i")).fetchForgeModule)({
                cloudId: cloudId,
                moduleName: moduleName,
                dataClassification: dataClassification,
                shouldReturnANExtensions: shouldReturnANExtensions,
                contextIds: contextIds,
                locale: locale
            });
        };
    const $3d515a0fe8e87c81$var$createContextIds = ({ cloudId: cloudId, activationId: activationId })=>[
            `ari:cloud:jira:${cloudId}:workspace/${activationId}`
        ];
    const $3d515a0fe8e87c81$export$168ac1f97221e90b = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_ADMIN_MODULE',
        getKey: ()=>'extensions',
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE), false, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$536a08360f048bac = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_ADMIN_MODULE',
        getKey: ()=>'extensions',
        getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE)
                ],
                context: {},
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).adminPageFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$var$forgeAdminModuleResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$536a08360f048bac, $3d515a0fe8e87c81$export$168ac1f97221e90b);
    const $3d515a0fe8e87c81$export$dcc98f4b36ce9223 = ()=>[
            $3d515a0fe8e87c81$var$forgeAdminModuleResource
        ];
    const $3d515a0fe8e87c81$export$ad95e2d07d6fa1a = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_PROJECT_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$1a17680eb0746291 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_PROJECT_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$72db683c2914a65e = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$1a17680eb0746291, $3d515a0fe8e87c81$export$ad95e2d07d6fa1a);
    const $3d515a0fe8e87c81$export$9f19b684a7493211 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('perf-push-big-components-nav-remove-resources')), $3d515a0fe8e87c81$export$72db683c2914a65e);
    const $3d515a0fe8e87c81$export$88e58f509f84795a = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_BACKLOG_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).BACKLOG_ACTION_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: false,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_ROUTER)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).BACKLOG_ACTION_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$7523db37432ba090 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('forge-ui-project-web-items'), $3d515a0fe8e87c81$export$88e58f509f84795a);
    const $3d515a0fe8e87c81$export$21d6f142a9a5af9d = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_BOARD_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).BOARD_ACTION_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: false,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_ROUTER)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).BOARD_ACTION_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$cfd99f451b423d3a = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('forge-ui-project-web-items'), $3d515a0fe8e87c81$export$21d6f142a9a5af9d);
    const $3d515a0fe8e87c81$export$72583833ca0600c0 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_PERSONAL_SETTINGS_MODULE',
        getKey: ()=>'extensions',
        getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).PERSONAL_SETTINGS_PAGE_MODULE)
                ],
                context: {},
                includeHidden: false,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).PERSONAL_SETTINGS_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$8a5aed164e925eb6 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('forge-ui-project-web-items'), $3d515a0fe8e87c81$export$72583833ca0600c0);
    const $3d515a0fe8e87c81$export$ec3265610584f9ce = ()=>[
            $3d515a0fe8e87c81$export$8a5aed164e925eb6
        ];
    const $3d515a0fe8e87c81$export$fa67d109c2a45864 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_PROJECT_SETTINGS_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$23c2bb87c561c9db = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_PROJECT_SETTINGS_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$7a928d209faf75f = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$23c2bb87c561c9db, $3d515a0fe8e87c81$export$fa67d109c2a45864);
    const $3d515a0fe8e87c81$export$e81e11bbc3239153 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($3d515a0fe8e87c81$export$7a928d209faf75f);
    const $3d515a0fe8e87c81$export$60e774d0427b56fc = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_GLOBAL_MODULE',
        getKey: ()=>'extensions',
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE), false, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$75f594fe5ce76af = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_GLOBAL_MODULE',
        getKey: ()=>'extensions',
        getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE)
                ],
                context: {},
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$var$forgeGlobalModuleResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$75f594fe5ce76af, $3d515a0fe8e87c81$export$60e774d0427b56fc);
    const $3d515a0fe8e87c81$export$80b2f91dabb3dd65 = ()=>[
            $3d515a0fe8e87c81$var$forgeGlobalModuleResource
        ];
    const $3d515a0fe8e87c81$export$b555dc3ff28ae9cc = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$d2d6bc2f3bd0f942 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$ebf5369e4dcfad00 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$d2d6bc2f3bd0f942, $3d515a0fe8e87c81$export$b555dc3ff28ae9cc);
    const $3d515a0fe8e87c81$export$e6be2f0ca0849869 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
        getKey: ()=>'extensions',
        getData: (_route, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous, activationId: activationId, locale: locale } })=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') ? (0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE)
                ],
                context: {},
                includeHidden: false,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_NAVIGATION)
            }).then((modules)=>modules[0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE]) : (0, (0, parcelRequire("iVaKa")).default)(cloudId, [
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE)
            ], null, undefined, (0, (0, parcelRequire("k2DRb")).SOURCE_NAVIGATION), $3d515a0fe8e87c81$var$createContextIds({
                cloudId: cloudId,
                activationId: activationId
            }), locale).then((modules)=>modules.extensions.jiraCustomFieldType),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    function $3d515a0fe8e87c81$var$normalizeModules(modules, filter) {
        return filter(modules).sort((a, b)=>(0, (0, parcelRequire("8O7FC")).alphabeticalSort)(a.properties.title, b.properties.title));
    }
});
parcelRegister("8O7FC", function(module, exports) {
    $parcel$export(module.exports, "alphabeticalSort", ()=>$7c4745a46edf6307$export$89a1f01f2a7cb2a1);
    var $dJl1T;
    const $7c4745a46edf6307$export$89a1f01f2a7cb2a1 = (a, b)=>{
        if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
            numeric: true,
            caseFirst: 'upper'
        });
        const typeOfA = a === null ? 'null' : typeof a;
        const typeOfB = b === null ? 'null' : typeof b;
        const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
        return 1;
    };
});
parcelRegister("k2DRb", function(module, exports) {
    $parcel$export(module.exports, "STAGING_ENVIRONMENT", ()=>$e80aa4d4aac5b0dc$export$71acbd662c478c42);
    $parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", ()=>$e80aa4d4aac5b0dc$export$978072fd3fd149);
    $parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", ()=>$e80aa4d4aac5b0dc$export$ebc15d9cebfd6063);
    $parcel$export(module.exports, "BACKLOG_ACTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$516a8fb49ad5d50e);
    $parcel$export(module.exports, "BOARD_ACTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$6cc3a1f2111dee11);
    $parcel$export(module.exports, "ISSUE_ACTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$fcc4a18f46f80f16);
    $parcel$export(module.exports, "ISSUE_GLANCE_MODULE", ()=>$e80aa4d4aac5b0dc$export$259bab989b0129d0);
    $parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", ()=>$e80aa4d4aac5b0dc$export$75f224942f595e13);
    $parcel$export(module.exports, "ISSUE_PANEL_MODULE", ()=>$e80aa4d4aac5b0dc$export$ba0968f9752844);
    $parcel$export(module.exports, "ISSUE_NAVIGATOR_ACTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$7e2136b4285d29f5);
    $parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", ()=>$e80aa4d4aac5b0dc$export$cc20a5638825fbb0);
    $parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", ()=>$e80aa4d4aac5b0dc$export$9069d4b945c3d532);
    $parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", ()=>$e80aa4d4aac5b0dc$export$811b7f067a43b422);
    $parcel$export(module.exports, "CUSTOM_FIELD_MODULE", ()=>$e80aa4d4aac5b0dc$export$e3887d6bafe8a17);
    $parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", ()=>$e80aa4d4aac5b0dc$export$7b7866c04a2ad947);
    $parcel$export(module.exports, "ADMIN_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$52e4945e96bd2aa0);
    $parcel$export(module.exports, "PERSONAL_SETTINGS_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58);
    $parcel$export(module.exports, "PROJECT_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$151b03356f566603);
    $parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$ea0d6ac082b0d636);
    $parcel$export(module.exports, "GLOBAL_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$31ac745ab2add7cc);
    $parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", ()=>$e80aa4d4aac5b0dc$export$353acf28daa75c79);
    $parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", ()=>$e80aa4d4aac5b0dc$export$25627f012b21b0b9);
    $parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", ()=>$e80aa4d4aac5b0dc$export$42d6a8740fd42e58);
    $parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", ()=>$e80aa4d4aac5b0dc$export$a7186e5a73395db4);
    $parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$8fbcfe84dc845d17);
    $parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$8af4cb794979f60d);
    $parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", ()=>$e80aa4d4aac5b0dc$export$5592ab836d562168);
    $parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", ()=>$e80aa4d4aac5b0dc$export$842eb4236828ac9);
    $parcel$export(module.exports, "SUPPORTED_MODULES", ()=>$e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7);
    $parcel$export(module.exports, "ENTRY_POINT_EDIT", ()=>$e80aa4d4aac5b0dc$export$2b8aeda236486576);
    $parcel$export(module.exports, "ENTRY_POINT_VIEW", ()=>$e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d);
    $parcel$export(module.exports, "ENTRY_POINT_CREATE", ()=>$e80aa4d4aac5b0dc$export$b37d58c3ed77c139);
    $parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", ()=>$e80aa4d4aac5b0dc$export$ab94dbd1d02ac251);
    $parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", ()=>$e80aa4d4aac5b0dc$export$b6a67a3131c6c48d);
    $parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", ()=>$e80aa4d4aac5b0dc$export$b75dc2bfd20898fe);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", ()=>$e80aa4d4aac5b0dc$export$8e96118a698216cb);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", ()=>$e80aa4d4aac5b0dc$export$9b72a8e9b92658fb);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", ()=>$e80aa4d4aac5b0dc$export$2d6539e7d0553ae7);
    $parcel$export(module.exports, "SOURCE_UNKNOWN", ()=>$e80aa4d4aac5b0dc$export$ecbd7135d66cb322);
    $parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", ()=>$e80aa4d4aac5b0dc$export$61d882aa7aba51c);
    $parcel$export(module.exports, "SOURCE_ISSUE_VIEW", ()=>$e80aa4d4aac5b0dc$export$46cb92762d68a048);
    $parcel$export(module.exports, "SOURCE_NAVIGATION", ()=>$e80aa4d4aac5b0dc$export$fe90e46aea58e30b);
    $parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", ()=>$e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a);
    $parcel$export(module.exports, "SOURCE_ROUTER", ()=>$e80aa4d4aac5b0dc$export$eae46a3c13473a8d);
    $parcel$export(module.exports, "SOURCE_LEGACY", ()=>$e80aa4d4aac5b0dc$export$ac11ee191d09688f);
    $parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", ()=>$e80aa4d4aac5b0dc$export$4346e4e240c84319);
    $parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", ()=>$e80aa4d4aac5b0dc$export$d719bb340dc354e4);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", ()=>$e80aa4d4aac5b0dc$export$4b6228758e800433);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", ()=>$e80aa4d4aac5b0dc$export$70495c8cc141a7a4);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", ()=>$e80aa4d4aac5b0dc$export$bc3d408418fdf9d2);
    $parcel$export(module.exports, "getEmptyExtensionsObject", ()=>$e80aa4d4aac5b0dc$export$218a328f66b86f7d);
    $parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", ()=>$e80aa4d4aac5b0dc$export$3193d714ab54ee26);
    $parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", ()=>$e80aa4d4aac5b0dc$export$df7774a415710cce);
    $parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", ()=>$e80aa4d4aac5b0dc$export$51ab2784839ce348);
    const $e80aa4d4aac5b0dc$export$9af0088c49bdedb = 'PRODUCTION';
    const $e80aa4d4aac5b0dc$export$71acbd662c478c42 = 'STAGING';
    const $e80aa4d4aac5b0dc$export$978072fd3fd149 = 'DEVELOPMENT';
    const $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063 = 'default';
    const $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e = 'jira:backlogAction';
    const $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11 = 'jira:boardAction';
    const $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16 = 'jira:issueAction';
    const $e80aa4d4aac5b0dc$export$259bab989b0129d0 = 'jira:issueGlance';
    const $e80aa4d4aac5b0dc$export$75f224942f595e13 = 'jira:issueContext';
    const $e80aa4d4aac5b0dc$export$ba0968f9752844 = 'jira:issuePanel';
    const $e80aa4d4aac5b0dc$export$7e2136b4285d29f5 = 'jira:issueNavigatorAction';
    const $e80aa4d4aac5b0dc$export$cc20a5638825fbb0 = 'jira:issueActivity';
    const $e80aa4d4aac5b0dc$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
    const $e80aa4d4aac5b0dc$export$811b7f067a43b422 = 'jira:uiModifications';
    const $e80aa4d4aac5b0dc$export$e3887d6bafe8a17 = 'jira:customField';
    const $e80aa4d4aac5b0dc$export$7b7866c04a2ad947 = 'jira:customFieldType';
    const $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0 = 'jira:adminPage';
    const $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58 = 'jira:personalSettingsPage';
    const $e80aa4d4aac5b0dc$export$151b03356f566603 = 'jira:projectPage';
    const $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
    const $e80aa4d4aac5b0dc$export$31ac745ab2add7cc = 'jira:globalPage';
    const $e80aa4d4aac5b0dc$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
    const $e80aa4d4aac5b0dc$export$25627f012b21b0b9 = 'jira:dashboardGadget';
    const $e80aa4d4aac5b0dc$export$42d6a8740fd42e58 = 'jira:workflowValidator';
    const $e80aa4d4aac5b0dc$export$a7186e5a73395db4 = 'jira:workflowCondition';
    const $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
    const $e80aa4d4aac5b0dc$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
    const $e80aa4d4aac5b0dc$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
    const $e80aa4d4aac5b0dc$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
    const $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7 = [
        $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e,
        $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11,
        $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16,
        $e80aa4d4aac5b0dc$export$259bab989b0129d0,
        $e80aa4d4aac5b0dc$export$75f224942f595e13,
        $e80aa4d4aac5b0dc$export$7e2136b4285d29f5,
        $e80aa4d4aac5b0dc$export$ba0968f9752844,
        $e80aa4d4aac5b0dc$export$cc20a5638825fbb0,
        $e80aa4d4aac5b0dc$export$9069d4b945c3d532,
        $e80aa4d4aac5b0dc$export$811b7f067a43b422,
        $e80aa4d4aac5b0dc$export$e3887d6bafe8a17,
        $e80aa4d4aac5b0dc$export$7b7866c04a2ad947,
        $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0,
        $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58,
        $e80aa4d4aac5b0dc$export$151b03356f566603,
        $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636,
        $e80aa4d4aac5b0dc$export$31ac745ab2add7cc,
        $e80aa4d4aac5b0dc$export$353acf28daa75c79,
        $e80aa4d4aac5b0dc$export$25627f012b21b0b9,
        $e80aa4d4aac5b0dc$export$8af4cb794979f60d,
        $e80aa4d4aac5b0dc$export$5592ab836d562168,
        $e80aa4d4aac5b0dc$export$842eb4236828ac9,
        $e80aa4d4aac5b0dc$export$42d6a8740fd42e58,
        $e80aa4d4aac5b0dc$export$a7186e5a73395db4,
        $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17
    ];
    const $e80aa4d4aac5b0dc$export$2b8aeda236486576 = 'edit';
    const $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d = 'view';
    const $e80aa4d4aac5b0dc$export$b37d58c3ed77c139 = 'create';
    const $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251 = 'contextConfig';
    const $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d = 'none';
    const $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe = 5;
    const $e80aa4d4aac5b0dc$export$8e96118a698216cb = 'native';
    const $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb = 'basic';
    const $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7 = 'blank';
    const $e80aa4d4aac5b0dc$export$ecbd7135d66cb322 = 'unknownSource';
    const $e80aa4d4aac5b0dc$export$61d882aa7aba51c = 'global-issue-create';
    const $e80aa4d4aac5b0dc$export$46cb92762d68a048 = 'issue-view';
    const $e80aa4d4aac5b0dc$export$fe90e46aea58e30b = 'navigation';
    const $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a = 'full-page-app';
    const $e80aa4d4aac5b0dc$export$eae46a3c13473a8d = 'router';
    const $e80aa4d4aac5b0dc$export$ac11ee191d09688f = 'legacy';
    const $e80aa4d4aac5b0dc$export$6d00582aa947900f = 'workflow-list';
    const $e80aa4d4aac5b0dc$export$4346e4e240c84319 = 'organization-panel';
    const $e80aa4d4aac5b0dc$export$d719bb340dc354e4 = 'assets-import-type';
    const $e80aa4d4aac5b0dc$export$bf75cf7720bd8fde = 'transition-view';
    const $e80aa4d4aac5b0dc$export$4b6228758e800433 = 'jira';
    const $e80aa4d4aac5b0dc$export$70495c8cc141a7a4 = 'jsm';
    const $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2 = 'cmdb';
    const $e80aa4d4aac5b0dc$export$a48dade1864725a = {
        jiraBacklogAction: [],
        jiraBoardAction: [],
        jiraIssueAction: [],
        jiraIssueContext: [],
        jiraIssueGlance: [],
        jiraIssuePanel: [],
        jiraIssueNavigatorAction: [],
        jiraIssueActivity: [],
        jiraIssueViewBackgroundScript: [],
        jiraCustomField: [],
        jiraCustomFieldType: [],
        jiraUiModifications: [],
        jiraAdminPage: [],
        jiraGlobalPage: [],
        jiraPersonalSettingsPage: [],
        jiraProjectPage: [],
        jiraProjectSettingsPage: [],
        jiraDashboardBackgroundScript: [],
        jiraDashboardGadget: [],
        jiraServiceManagementQueuePage: [],
        jiraServiceManagementOrganizationPanel: [],
        jiraServiceManagementAssetsImportType: [],
        jiraWorkflowValidator: [],
        jiraWorkflowCondition: [],
        jiraWorkflowPostFunction: []
    };
    const $e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
        ...$e80aa4d4aac5b0dc$export$a48dade1864725a
    };
    const $e80aa4d4aac5b0dc$export$218a328f66b86f7d = ()=>({
            ...$e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT
        });
    const $e80aa4d4aac5b0dc$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
    const $e80aa4d4aac5b0dc$export$df7774a415710cce = 'com.atlassian.forge:';
    const $e80aa4d4aac5b0dc$export$51ab2784839ce348 = `${$e80aa4d4aac5b0dc$export$df7774a415710cce}${$e80aa4d4aac5b0dc$export$3193d714ab54ee26}`;
});
parcelRegister("5vSAE", function(module, exports) {
    $parcel$export(module.exports, "fetchModules", ()=>$f16089506a319d17$export$24d8e11b15325c53);
    var $gPjkL;
    var $8Uumt = parcelRequire("8Uumt");
    var $4R6GH;
    var $bPtOr;
    var $dYScp;
    var $hBuqR;
    var $bOLUk;
    var $k2DRb;
    var $5yJb9;
    var $gPjkL;
    var $d5W4H;
    var $dyPNS;
    var $829Wu;
    const $f16089506a319d17$export$24d8e11b15325c53 = async (params)=>{
        const { types: types, cloudId: cloudId, isAnonymous: isAnonymous, source: source = (0, (0, parcelRequire("k2DRb")).SOURCE_UNKNOWN) } = params;
        if (!(0, (0, parcelRequire("d5W4H")).canFetchForgeModulesV2)({
            cloudId: cloudId,
            isAnonymous: isAnonymous
        })) return (0, (0, parcelRequire("dyPNS")).toMappedExtensions)(types, []);
        try {
            const extensions = await (0, (0, parcelRequire("dYScp")).measureExecutionTimeMetrics)(()=>$f16089506a319d17$export$9f9fdbce0829073d(params));
            if (Math.random() * 100 < (0, (0, parcelRequire("hBuqR")).FORGE_SAMPLING_RATE)) (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFinishedEvent)(source);
            return (0, (0, parcelRequire("dyPNS")).toMappedExtensions)(types, extensions);
        } catch (error) {
            const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
            (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFailedEvent)(source, {
                isSSR: false,
                errorType: errorType,
                error: error
            });
            if ($f16089506a319d17$export$458cbcb6374269d2.includes(errorType)) return (0, (0, parcelRequire("dyPNS")).toMappedExtensions)(types, []);
            throw error;
        }
    };
    function $f16089506a319d17$export$9f9fdbce0829073d(props) {
        const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = false } = props;
        if (types.length === 0) throw new Error('No modules to fetch provided');
        const operationName = (0, (0, parcelRequire("gPjkL")).default).params.name;
        const { stopGraphQLErrorTracking: stopGraphQLErrorTracking, getGraphQLError: getGraphQLError } = (0, (0, parcelRequire("829Wu")).trackGraphQLErrors)(operationName);
        let extensions;
        return new Promise((resolve, reject)=>{
            const subscription = (0, $8Uumt.fetchQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("gPjkL")).default), {
                cloudId: cloudId,
                context: context,
                types: types,
                includeHidden: includeHidden,
                includeScopes: includeScopes,
                includeUserAccess: (0, (0, parcelRequire("4R6GH")).fg)('forge_query_include_user_access')
            }).subscribe({
                next: (response)=>{
                    stopGraphQLErrorTracking();
                    extensions = response.jira?.forge?.extensions?.concat() || null;
                },
                error: (error)=>{
                    stopGraphQLErrorTracking();
                    reject(error);
                    subscription.unsubscribe();
                },
                complete: ()=>{
                    const graphQLError = getGraphQLError();
                    if (graphQLError) extensions != null ? resolve(extensions || []) : reject(graphQLError);
                    else resolve(extensions || []);
                    subscription.unsubscribe();
                }
            });
        });
    }
    const $f16089506a319d17$export$458cbcb6374269d2 = [
        (0, (0, parcelRequire("bPtOr")).FAILED_TO_FETCH),
        (0, (0, parcelRequire("bPtOr")).AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
        (0, (0, parcelRequire("bPtOr")).DATA_CLASSIFICATION_NO_ACCESS)
    ];
});
parcelRegister("gPjkL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13cd104237d48c31$export$2e2bcd8739ae039);
    const $13cd104237d48c31$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeScopes"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeUserAccess"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }, v6 = {
            "kind": "ScalarField",
            "name": "type"
        }, v7 = [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraForgeQuery",
                        "kind": "LinkedField",
                        "name": "forge",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "context",
                                        "variableName": "context"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeHidden",
                                        "variableName": "includeHidden"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "types",
                                        "variableName": "types"
                                    }
                                ],
                                "concreteType": "JiraForgeExtension",
                                "kind": "LinkedField",
                                "name": "extensions",
                                "plural": true,
                                "selections": [
                                    {
                                        "condition": "includeHidden",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hiddenBy"
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "includeScopes",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "scopes"
                                            }
                                        ]
                                    },
                                    v6,
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "environmentId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "environmentKey"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "environmentType"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "installationId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "appVersion"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "consentUrl"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "properties"
                                    },
                                    {
                                        "condition": "includeUserAccess",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraUserAppAccess",
                                                "kind": "LinkedField",
                                                "name": "userAccess",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasAccess"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraForgeAppEgressDeclaration",
                                        "kind": "LinkedField",
                                        "name": "egress",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "addresses"
                                            },
                                            v6
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraForgeExtensionLicense",
                                        "kind": "LinkedField",
                                        "name": "license",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "active"
                                            },
                                            v6,
                                            {
                                                "kind": "ScalarField",
                                                "name": "supportEntitlementNumber"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "trialEndDate"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "subscriptionEndDate"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isEvaluation"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "billingPeriod"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "ccpEntitlementId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "ccpEntitlementSlug"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "capabilitySet"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5
                ],
                "kind": "Fragment",
                "name": "fetchModulesV2Query",
                "selections": v7,
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v5,
                    v2,
                    v3,
                    v4
                ],
                "kind": "Operation",
                "name": "fetchModulesV2Query",
                "selections": v7
            },
            "params": {
                "id": "013cf62d6837e0c985239a3d2175c1ef4b66da117b6d059ea93c8b36d45996d1",
                "metadata": {},
                "name": "fetchModulesV2Query",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $13cd104237d48c31$var$node.hash = "f1fe4da40ce9fa9017b516cd18afaefb";
    var $13cd104237d48c31$export$2e2bcd8739ae039 = $13cd104237d48c31$var$node;
});
parcelRegister("bPtOr", function(module, exports) {
    $parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", ()=>$e4bddb38a31390d9$export$23de3198bfe70090);
    $parcel$export(module.exports, "FAILED_TO_FETCH", ()=>$e4bddb38a31390d9$export$f52aa41ccd776f01);
    $parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", ()=>$e4bddb38a31390d9$export$31d2ab0be67934f0);
    $parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", ()=>$e4bddb38a31390d9$export$89a175d4190df42e);
    $parcel$export(module.exports, "userConsentErrorRegex", ()=>$e4bddb38a31390d9$export$dddade71b333c01d);
    $parcel$export(module.exports, "getErrorType", ()=>$e4bddb38a31390d9$export$e19f9f08a6d79fd2);
    var $fZneA;
    var $bvblX;
    var $bCf8q;
    const $e4bddb38a31390d9$var$commonErrors = {
        MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
        OPERATION_ABORTED: 'The operation was aborted. ',
        CANCELLED: 'cancelled',
        UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
        NETWORK_CONNECTION_LOST: 'The network connection was lost.',
        TIMEOUT: 'The request timed out.',
        AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
        GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504',
        GADGET_PREFERENCES: 'failed to put gadget preference: Error server response: 429'
    };
    const $e4bddb38a31390d9$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
    const $e4bddb38a31390d9$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
    const $e4bddb38a31390d9$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
    const $e4bddb38a31390d9$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
    const $e4bddb38a31390d9$export$89a175d4190df42e = 'Invoke value functions failed:';
    const $e4bddb38a31390d9$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
    const $e4bddb38a31390d9$export$8a5d666d6e5b82fc = (error)=>{
        if ((0, (0, parcelRequire("bCf8q")).isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
        const KNOWN_NETWORK_ERRORS = [
            'Failed to fetch dynamically imported module',
            'error loading dynamically imported module',
            'Importing a module script failed'
        ];
        const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>message.includes(networkErrorMessage));
        return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
    };
    const $e4bddb38a31390d9$export$e19f9f08a6d79fd2 = (_error)=>{
        if (_error == null) return 'NULL_OR_UNDEFINED';
        const error = _error;
        const message = String(error instanceof Error ? error.message : error).trim();
        const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
        if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
        const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
        if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
        const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
        const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
        if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $e4bddb38a31390d9$export$7a1bd8c001e7e9c;
        const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
        if (serverErrorRegex.test(message)) {
            const match = message.match(serverErrorRegex);
            const statusCode = match ? match[1] : 'NO_STATUS_CODE';
            return `ERROR_SERVER_RESPONSE_${statusCode}`;
        }
        const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
        if (aggGiraServerErrorRegex.test(message)) {
            const match = message.match(aggGiraServerErrorRegex);
            const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
            return `AGG_GIRA_ERROR_${statusCode}`;
        }
        if (error instanceof (0, (0, parcelRequire("bvblX")).TrackedGraphQLError)) {
            if (error.statusCode && error.statusCode >= 400) return error.statusCode === 429 ? $e4bddb38a31390d9$export$7a1bd8c001e7e9c : `ERROR_SERVER_RESPONSE_${error.statusCode}`;
            return 'TRACKED_GRAPHQL_ERROR';
        }
        const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
        const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
        if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $e4bddb38a31390d9$export$23de3198bfe70090;
        if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
        const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
        if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
        if ($e4bddb38a31390d9$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
        const appValueFunction = new RegExp("The app's value function failed", 'i');
        const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
        const invokeValueFunctionFailed = new RegExp($e4bddb38a31390d9$export$89a175d4190df42e, 'i');
        const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977);
        const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$fa405bbf47d510e2);
        if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
        const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
        if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
        const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
        if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
        if ($e4bddb38a31390d9$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
        if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
        if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
        if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
        const entry = Object.entries($e4bddb38a31390d9$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
        if (entry) return entry[0];
        if ((0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) return $e4bddb38a31390d9$export$f52aa41ccd776f01;
        return 'OTHER';
    };
});
parcelRegister("bvblX", function(module, exports) {
    $parcel$export(module.exports, "TrackedGraphQLError", ()=>$b1b2278e9c04b70b$export$f2062ad173e74c75);
    class $b1b2278e9c04b70b$export$f2062ad173e74c75 extends Error {
        constructor(errorMessage, errors, traceIds){
            super(errorMessage), this.errorMessage = errorMessage, this.errors = errors, this.traceIds = traceIds;
            this.errors = errors;
            this.traceId = traceIds?.[0];
            this.statusCode = errors?.map((graphQLError)=>graphQLError && 'extensions' in graphQLError ? graphQLError?.extensions?.statusCode : null).filter(Boolean)?.[0];
            this.message = errors?.map((graphQLError)=>graphQLError?.message).filter(Boolean).join('; ') ?? errorMessage;
        }
    }
});
parcelRegister("dYScp", function(module, exports) {
    $parcel$export(module.exports, "measureExecutionTimeMetrics", ()=>$d79aabebae5ffeb3$export$a859f6866f4653e0);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4R6GH;
    var $hBuqR;
    var $8kVg1;
    const $d79aabebae5ffeb3$export$a859f6866f4653e0 = async (action)=>{
        const concurrentId = (0, ($parcel$interopDefault($7Jxgt)))();
        const shouldSendTimeMetric = Math.random() * 100 < (0, (0, parcelRequire("hBuqR")).FORGE_SAMPLING_RATE);
        if ((0, (0, parcelRequire("4R6GH")).fg)('ditto-fcf_forge_fetch_time_metric_fix')) try {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentFetchTime)(concurrentId).start({
                startTime: performance.now()
            });
            const result = await action();
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentFetchTime)(concurrentId).stop({
                stopTime: performance.now()
            });
            return result;
        } catch (error) {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentFetchTime)(concurrentId).cancel();
            throw error;
        }
        else try {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesFetchTime).start({
                startTime: performance.now()
            });
            const result = await action();
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesFetchTime).stop({
                stopTime: performance.now()
            });
            return result;
        } catch (error) {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesFetchTime).cancel();
            throw error;
        }
    };
});
parcelRegister("hBuqR", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME_GASV3", ()=>$bbc089ab376d4a7b$export$f892f621fb508154);
    $parcel$export(module.exports, "MODULE_TYPE_TRIGGER", ()=>$bbc089ab376d4a7b$export$ed63b053e04e26df);
    $parcel$export(module.exports, "MODULE_TYPE_EXTENSION", ()=>$bbc089ab376d4a7b$export$725bacc669333eef);
    $parcel$export(module.exports, "FORGE_SAMPLING_RATE", ()=>$bbc089ab376d4a7b$export$d920cee73ec094d0);
    $parcel$export(module.exports, "PERFORMANCE_KEYS", ()=>$bbc089ab376d4a7b$export$f048d91ccaf92408);
    $parcel$export(module.exports, "UI_ACTIONS", ()=>$bbc089ab376d4a7b$export$2b7367f125154866);
    $parcel$export(module.exports, "OPERATIONAL_ACTIONS", ()=>$bbc089ab376d4a7b$export$42bcca5cae2ce90b);
    $parcel$export(module.exports, "TRACK_ACTIONS", ()=>$bbc089ab376d4a7b$export$2af0438304d7c4b2);
    const $bbc089ab376d4a7b$export$f892f621fb508154 = 'jiraForgeUi';
    const $bbc089ab376d4a7b$export$273f5980517336e2 = 'jiraforgeui';
    const $bbc089ab376d4a7b$export$ed63b053e04e26df = 'trigger';
    const $bbc089ab376d4a7b$export$725bacc669333eef = 'extension';
    const $bbc089ab376d4a7b$export$d920cee73ec094d0 = 10;
    const $bbc089ab376d4a7b$export$f048d91ccaf92408 = {
        FORGE_MODULES: {
            FETCH_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.fetch-time`,
            LOAD_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.load-time`
        },
        REAL_TIME_ISSUE_EVENTS: {
            INVOKE_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.real-time-issue-events.invoke-time`
        },
        MARKS: {
            TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
            TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
            ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
        }
    };
    const $bbc089ab376d4a7b$export$2b7367f125154866 = {
        CLICKED: 'clicked',
        SELECTED: 'selected',
        CANCELED: 'canceled',
        ACTION_CLICKED: 'action clicked',
        COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
        REMOVE_CLICKED: 'remove clicked'
    };
    const $bbc089ab376d4a7b$export$42bcca5cae2ce90b = {
        FAILED: 'failed',
        INITIALIZED: 'initialized',
        EDIT_FAILED: 'edit failed',
        ACTION_FAILED: 'action failed',
        SAVE_FAILED: 'save failed',
        REMOVE_FAILED: 'remove failed',
        UPDATE_FAILED: 'update failed'
    };
    const $bbc089ab376d4a7b$export$2af0438304d7c4b2 = {
        EDITED: 'edited',
        SAVED: 'saved',
        REMOVED: 'removed',
        ACTION_SUCCEED: 'action succeed',
        UPDATE_SUCCEED: 'update succeed'
    };
});
parcelRegister("8kVg1", function(module, exports) {
    $parcel$export(module.exports, "forgeModulesFetchTime", ()=>$f1fed22795d0c676$export$cd129f3639657eae);
    $parcel$export(module.exports, "forgeModulesConcurrentFetchTime", ()=>$f1fed22795d0c676$export$c3d8833fbea3e976);
    $parcel$export(module.exports, "forgeModulesConcurrentLoadTime", ()=>$f1fed22795d0c676$export$292f3b557281044f);
    $parcel$export(module.exports, "realTimeIssueEventInvokeTime", ()=>$f1fed22795d0c676$export$89ace7e2bb7d7685);
    $parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", ()=>$f1fed22795d0c676$export$94f65f3b2556df23);
    $parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", ()=>$f1fed22795d0c676$export$116d5e25caf0018d);
    $parcel$export(module.exports, "customFieldPageSegmentLoadMetric", ()=>$f1fed22795d0c676$export$3bd38623c2543fc0);
    $parcel$export(module.exports, "customFieldInteractionMetric", ()=>$f1fed22795d0c676$export$a318f99472db73c8);
    var $dGrdR;
    var $6RCeq;
    var $atdLB;
    var $duUGa;
    var $hBuqR;
    const $f1fed22795d0c676$export$cd129f3639657eae = (0, (0, parcelRequire("dGrdR")).metrics).custom({
        key: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
    });
    const $f1fed22795d0c676$export$c3d8833fbea3e976 = (0, (0, parcelRequire("dGrdR")).metrics).concurrent.custom({
        key: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
    });
    const $f1fed22795d0c676$export$292f3b557281044f = (0, (0, parcelRequire("dGrdR")).metrics).concurrent.custom({
        key: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
    });
    const $f1fed22795d0c676$export$89ace7e2bb7d7685 = new (0, (0, parcelRequire("duUGa")).UFOExperience)((0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    });
    async function $f1fed22795d0c676$export$94f65f3b2556df23(startMark, endMark, fn) {
        if (false || (0, (0, parcelRequire("6RCeq")).default).getEntriesByName(startMark).length > 0 || (0, (0, parcelRequire("6RCeq")).default).getEntriesByName(endMark).length > 0) return fn();
        (0, (0, parcelRequire("6RCeq")).default).mark(startMark);
        const result = await fn();
        (0, (0, parcelRequire("6RCeq")).default).mark(endMark);
        return result;
    }
    const $f1fed22795d0c676$export$116d5e25caf0018d = (metric, additionalTimings)=>{
        additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
                ...(0, (0, parcelRequire("6RCeq")).default).getEntriesByName(startMark).map((entry)=>({
                        name: entry.name,
                        startTime: entry.startTime,
                        cleanStart: cleanStart,
                        cleanEnd: undefined
                    })),
                ...(0, (0, parcelRequire("6RCeq")).default).getEntriesByName(endMark).map((entry)=>({
                        name: entry.name,
                        startTime: entry.startTime,
                        cleanStart: undefined,
                        cleanEnd: cleanEnd
                    }))
            ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
            metric.mark(name, startTime);
            if (cleanStart || cleanEnd) (0, (0, parcelRequire("6RCeq")).default).clearMarks(name);
        });
    };
    const $f1fed22795d0c676$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, (0, parcelRequire("dGrdR")).metrics).pageSegmentLoad({
            key: 'forge-custom-field',
            timings: [
                ...additionalTimings,
                {
                    key: 'tti',
                    startMark: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.TTI_START,
                    endMark: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.TTI_END
                }
            ]
        });
    const $f1fed22795d0c676$export$a318f99472db73c8 = (additionalTimings = [])=>(0, (0, parcelRequire("dGrdR")).metrics).interaction({
            key: 'forge-custom-field',
            timings: [
                ...additionalTimings
            ]
        });
});
parcelRegister("bOLUk", function(module, exports) {
    $parcel$export(module.exports, "fireInitializationFetchFinishedEvent", ()=>$2f4555f4bd0f0eef$export$132ca822850e455f);
    $parcel$export(module.exports, "fireInitializationFetchFailedEvent", ()=>$2f4555f4bd0f0eef$export$b5ca88b1053f1ad0);
    $parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", ()=>$2f4555f4bd0f0eef$export$e914f7df1e4ad79b);
    $parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", ()=>$2f4555f4bd0f0eef$export$b274c658390b491b);
    var $4R6GH;
    var $6yg2S;
    var $8uOa6;
    const $2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS = {
        STARTED: 'started',
        FINISHED: 'finished',
        FAILED: 'failed'
    };
    const $2f4555f4bd0f0eef$export$917d0643b0111a02 = (0, (0, parcelRequire("6yg2S")).toEventId)('issueViewInitialization');
    const $2f4555f4bd0f0eef$export$43e875fd63e64525 = (0, (0, parcelRequire("6yg2S")).toEventId)('fetchModulesInitialization');
    const $2f4555f4bd0f0eef$export$132ca822850e455f = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
            id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
    const $2f4555f4bd0f0eef$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
            id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
    const $2f4555f4bd0f0eef$export$e914f7df1e4ad79b = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
            id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
    const $2f4555f4bd0f0eef$export$b274c658390b491b = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
            id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
});
parcelRegister("6yg2S", function(module, exports) {
    $parcel$export(module.exports, "toEventId", ()=>$cb46d7d052e3d68d$export$75e84ef5a3771f9a);
    const $cb46d7d052e3d68d$export$75e84ef5a3771f9a = (value)=>value;
});
parcelRegister("8uOa6", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalEvent", ()=>$73635d33815c9f98$export$a1fb57756f0de62b);
    $parcel$export(module.exports, "fireUiEvent", ()=>$73635d33815c9f98$export$bed7f228c94e5f2a);
    $parcel$export(module.exports, "fireTrackEvent", ()=>$73635d33815c9f98$export$574d2f19a52d67ca);
    $parcel$export(module.exports, "fireInitializationEvent", ()=>$73635d33815c9f98$export$390a62413962e4f0);
    var $fjcgS;
    var $hBuqR;
    var $6MtPV;
    var $7yD9b;
    var $eGXs2;
    const $73635d33815c9f98$var$createAnalyticsProps = ({ id: id, source: source = 'unknownSource', action: action, attributes: attributes })=>({
            actionSubject: `${0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3}.${id}`,
            attributes: (0, (0, parcelRequire("6MtPV")).createAttributes)(attributes),
            source: source,
            action: action
        });
    const $73635d33815c9f98$var$getAnalyticsClient = async ()=>(await (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)()).getInstance();
    const $73635d33815c9f98$var$sendOperationalEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendOperationalEvent($73635d33815c9f98$var$createAnalyticsProps(props));
    const $73635d33815c9f98$var$sendUiEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendUIEvent($73635d33815c9f98$var$createAnalyticsProps(props));
    const $73635d33815c9f98$var$sendTrackEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendTrackEvent($73635d33815c9f98$var$createAnalyticsProps(props));
    const $73635d33815c9f98$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendOperationalEvent({
            ...eventProps,
            source: (0, (0, parcelRequire("6MtPV")).parseSource)(source),
            action: action
        });
    const $73635d33815c9f98$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendUiEvent({
            ...eventProps,
            source: (0, (0, parcelRequire("6MtPV")).parseSource)(source),
            action: action
        });
    const $73635d33815c9f98$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendTrackEvent({
            ...eventProps,
            source: (0, (0, parcelRequire("6MtPV")).parseSource)(source),
            action: action
        });
    const $73635d33815c9f98$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
            $73635d33815c9f98$export$a1fb57756f0de62b(action, {
                id: id,
                attributes: attributes,
                source: source
            }),
            attributes?.error && (0, (0, parcelRequire("7yD9b")).logError)((0, (0, parcelRequire("7yD9b")).ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, (0, parcelRequire("eGXs2")).isSynthetic)().toString()}, id=${id}, source=${(0, (0, parcelRequire("6MtPV")).parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
        ]);
});
parcelRegister("6MtPV", function(module, exports) {
    $parcel$export(module.exports, "parseSource", ()=>$31dca5b0e1651a2f$export$e98201ef9a88ba70);
    $parcel$export(module.exports, "createAttributes", ()=>$31dca5b0e1651a2f$export$c7c9603a6b1fd815);
    var $84Tib = parcelRequire("84Tib");
    var $9uiWt;
    var $bPtOr;
    var $eGXs2;
    const $31dca5b0e1651a2f$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
    const $31dca5b0e1651a2f$export$78c6267359db7e73 = (error)=>({
            ...error,
            stack: error.stack,
            message: error?.message
        });
    const $31dca5b0e1651a2f$export$c7c9603a6b1fd815 = (rawAttributes)=>{
        const attributes = {
            isSynthetic: (0, (0, parcelRequire("eGXs2")).isSynthetic)(),
            isOverridingFragments: (0, (0, parcelRequire("9uiWt")).isOverridingFragments)(),
            isSSR: false
        };
        if (rawAttributes) {
            const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
            if (source) attributes.source = $31dca5b0e1651a2f$export$e98201ef9a88ba70(source);
            if (error) {
                attributes.error = $31dca5b0e1651a2f$export$78c6267359db7e73(error);
                attributes.errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
            }
            if ((0, ($parcel$interopDefault($84Tib)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
        }
        return {
            ...rawAttributes,
            ...attributes
        };
    };
});
parcelRegister("9uiWt", function(module, exports) {
    $parcel$export(module.exports, "isOverridingFragments", ()=>$c677f4c9cc5e982f$export$1d1321d2b374d697);
    const $c677f4c9cc5e982f$export$1d1321d2b374d697 = ()=>{
        if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
        if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
        return false;
    };
});
parcelRegister("eGXs2", function(module, exports) {
    $parcel$export(module.exports, "isSynthetic", ()=>$58ae13ec31f88266$export$947749d756ccb0a);
    var $4R6GH;
    var $j8DrX;
    const $58ae13ec31f88266$export$947749d756ccb0a = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true' || (0, (0, parcelRequire("4R6GH")).fg)('forge_ui_synthetic_check');
});
parcelRegister("7yD9b", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_UTIL", ()=>$187fc325525eefe3$export$d1e4f308040bb0d5);
    $parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", ()=>$187fc325525eefe3$export$36f315a5c6daf40b);
    $parcel$export(module.exports, "logError", ()=>$187fc325525eefe3$export$58da9968c3170cb1);
    var $dJl1T;
    var $hBuqR;
    const $187fc325525eefe3$export$e31edcd35abe3bb1 = 'environment-mapping';
    const $187fc325525eefe3$export$d1e4f308040bb0d5 = 'analytics';
    const $187fc325525eefe3$export$36f315a5c6daf40b = 'custom-field-object-type';
    const $187fc325525eefe3$export$6ee8198f29fffdb4 = {
        [$187fc325525eefe3$export$d1e4f308040bb0d5]: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.error.utils.analytics`,
        [$187fc325525eefe3$export$e31edcd35abe3bb1]: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
        [$187fc325525eefe3$export$36f315a5c6daf40b]: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
    };
    const $187fc325525eefe3$export$58da9968c3170cb1 = (key, message, event)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($187fc325525eefe3$export$6ee8198f29fffdb4[key], message, event);
    };
});
parcelRegister("5yJb9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0dfb67cb8d2ba29a$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    var $aWXMn;
    let $0dfb67cb8d2ba29a$var$relayEnvironment;
    function $0dfb67cb8d2ba29a$export$2e2bcd8739ae039() {
        if (!$0dfb67cb8d2ba29a$var$relayEnvironment) {
            const environmentConfig = (0, (0, parcelRequire("aWXMn")).getRelayEnvironmentConfig)();
            $0dfb67cb8d2ba29a$var$relayEnvironment = new (0, $eiowN.Environment)(environmentConfig);
        }
        return $0dfb67cb8d2ba29a$var$relayEnvironment;
    }
});
parcelRegister("aWXMn", function(module, exports) {
    $parcel$export(module.exports, "getRelayEnvironmentConfig", ()=>$eb7981c11bea2531$export$a451c85db2d1cda3);
    var $4XQuR;
    var $d89yU;
    var $6LmWt;
    const $eb7981c11bea2531$export$a451c85db2d1cda3 = ()=>(0, (0, parcelRequire("6LmWt")).getDefaultRelayEnvironmentConfig)({
            network: (0, (0, parcelRequire("d89yU")).getNetwork)(),
            log: (0, (0, parcelRequire("4XQuR")).default),
            requiredFieldLogger: (0, parcelRequire("4XQuR")).requiredFieldLogger
        });
});
parcelRegister("4XQuR", function(module, exports) {
    $parcel$export(module.exports, "requiredFieldLogger", ()=>$50b0aa0805b37d6d$export$1ab8b98d209afe85);
    $parcel$export(module.exports, "default", ()=>$50b0aa0805b37d6d$export$2e2bcd8739ae039);
    var $bFU4G;
    var $dJl1T;
    var $jQsty;
    const $50b0aa0805b37d6d$var$RELAY_CLIENT_ID = 'AGG';
    const $50b0aa0805b37d6d$var$LOG_NAMESPACE = `relay.${$50b0aa0805b37d6d$var$RELAY_CLIENT_ID}.error.graphql`;
    const $50b0aa0805b37d6d$var$requests = {};
    const $50b0aa0805b37d6d$var$queries = {};
    const $50b0aa0805b37d6d$var$resources = {};
    const $50b0aa0805b37d6d$var$executes = {};
    const $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT = 300000;
    const $50b0aa0805b37d6d$export$1ab8b98d209afe85 = (event)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($50b0aa0805b37d6d$var$LOG_NAMESPACE, '[relay required field error]', {
            kind: event.kind,
            owner: event.owner,
            fieldPath: event.fieldPath,
            message: event.kind === 'relay_resolver.error' ? event.error?.message : null
        });
    };
    const $50b0aa0805b37d6d$var$getResponseSize = (resp)=>{
        if (resp.data === undefined) return 0;
        try {
            return JSON.stringify(resp.data).length;
        } catch (e) {
            return 0;
        }
    };
    function $50b0aa0805b37d6d$export$2e2bcd8739ae039(event) {
        if ((0, (0, parcelRequire("jQsty")).default)('relay_log')) return;
        switch(event.name){
            case 'network.start':
                {
                    const networkStart = performance.now();
                    const { networkRequestId: networkRequestId } = event;
                    const { name: name } = event.params;
                    const requestInfo = $50b0aa0805b37d6d$var$requests[networkRequestId];
                    if (requestInfo == null) {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: networkStart,
                            networkStart: networkStart
                        };
                        $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                        $50b0aa0805b37d6d$var$requests[networkRequestId] = newRequestInfo;
                        setTimeout(()=>{
                            delete $50b0aa0805b37d6d$var$requests[networkRequestId];
                            delete $50b0aa0805b37d6d$var$queries[name];
                        }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                    } else requestInfo.networkStart = networkStart;
                    break;
                }
            case 'network.next':
                {
                    const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                    if (requestInfo != null) {
                        const { response: response } = event;
                        const addFlush = (resp)=>{
                            if (resp.data !== null) {
                                const res = resp;
                                const flush = {
                                    label: res.label != null ? res.label : 'root',
                                    time: performance.now(),
                                    size: $50b0aa0805b37d6d$var$getResponseSize(res)
                                };
                                requestInfo.flushes?.push(flush);
                            }
                        };
                        Array.isArray(response) ? response.forEach(addFlush) : addFlush(response);
                    }
                    break;
                }
            case 'network.error':
                {
                    const info = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                    if (info != null) info.error = event.error;
                    break;
                }
            case 'network.info':
                break;
            case 'network.complete':
                {
                    const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                    const networkComplete = performance.now();
                    if (requestInfo != null) {
                        const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                        requestInfo.size = size;
                        requestInfo.networkComplete = networkComplete;
                        requestInfo.flushes = [];
                        (0, (0, parcelRequire("bFU4G")).addSpanToAll)('relay', requestInfo.name, [
                            {
                                name: 'network'
                            }
                        ], requestInfo.start, requestInfo.networkComplete, size);
                    }
                    break;
                }
            case 'network.unsubscribe':
                break;
            case 'suspense.fragment':
                break;
            case 'suspense.query':
                break;
            case 'queryresource.fetch':
                {
                    const { node: node } = event.operation.root;
                    const fetchStart = performance.now();
                    if (node.name != null) {
                        const { name: name } = node;
                        const requestInfo = $50b0aa0805b37d6d$var$queries[name];
                        if (requestInfo != null) {
                            requestInfo.fetchStart = fetchStart;
                            $50b0aa0805b37d6d$var$resources[event.resourceID] = requestInfo;
                        } else {
                            const newRequestInfo = {
                                name: name,
                                flushes: [],
                                start: fetchStart,
                                fetchStart: fetchStart
                            };
                            $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                            $50b0aa0805b37d6d$var$resources[event.resourceID] = newRequestInfo;
                            setTimeout(()=>{
                                delete $50b0aa0805b37d6d$var$queries[node.name];
                            }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                        }
                        setTimeout(()=>{
                            delete $50b0aa0805b37d6d$var$resources[event.resourceID];
                        }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                    }
                    break;
                }
            case 'queryresource.retain':
                {
                    const requestInfo = $50b0aa0805b37d6d$var$resources[event.resourceID];
                    if (requestInfo != null && event.profilerContext != null) {
                        requestInfo.end = performance.now();
                        const context = event.profilerContext;
                        context?.retainQuery?.(requestInfo);
                    }
                    break;
                }
            case 'execute.start':
                $50b0aa0805b37d6d$var$executes[event.executeId] = {
                    name: event.params.name,
                    kind: event.params.operationKind,
                    start: performance.now(),
                    duration: 0
                };
                break;
            case 'execute.next':
                $50b0aa0805b37d6d$var$executes[event.executeId].duration += event.duration;
                break;
            case 'execute.async.module':
                break;
            case 'execute.flight.payload_deserialize':
                break;
            case 'execute.error':
                delete $50b0aa0805b37d6d$var$executes[event.executeId];
                break;
            case 'execute.complete':
                {
                    const op = $50b0aa0805b37d6d$var$executes[event.executeId];
                    if (op != null) {
                        op.end = performance.now();
                        delete $50b0aa0805b37d6d$var$executes[event.executeId];
                    }
                    break;
                }
            case 'store.publish':
                break;
            case 'store.snapshot':
                break;
            case 'store.restore':
                break;
            case 'store.gc':
                break;
            case 'store.notify.start':
                break;
            case 'store.notify.complete':
                break;
            case 'store.notify.subscription':
                break;
            case 'entrypoint.root.consume':
                break;
            default:
                break;
        }
    }
});
parcelRegister("d89yU", function(module, exports) {
    $parcel$export(module.exports, "getNetwork", ()=>$7997274d03790a98$export$7de4970ebfd8206d);
    var $eiowN = parcelRequire("eiowN");
    var $gIJXH;
    var $k1TrK;
    var $fwvto;
    const $7997274d03790a98$export$7de4970ebfd8206d = ()=>{
        if ((0, (0, parcelRequire("fwvto")).isSSR)()) (0, $eiowN.Network).create((0, (0, parcelRequire("gIJXH")).fetch));
        return (0, $eiowN.Network).create((0, (0, parcelRequire("gIJXH")).fetch), (0, (0, parcelRequire("k1TrK")).subscribe));
    };
});
parcelRegister("gIJXH", function(module, exports) {
    $parcel$export(module.exports, "fetch", ()=>$2963ed038d5e3581$export$e7aa7bc5c1b3cfb3);
    var $hGgHi = parcelRequire("hGgHi");
    var $1UikQ = parcelRequire("1UikQ");
    var $eiowN = parcelRequire("eiowN");
    var $kTK0a;
    var $2I8bw;
    var $aDvGo;
    var $jJZqs;
    var $eusud;
    var $6b2ko;
    var $4tcSU;
    var $5a0Nh;
    var $gwtGO;
    var $kipqU;
    var $7pVV3;
    var $ajjqZ;
    var $4pgHP;
    var $eCZ6m;
    var $5Wobd;
    var $lKFKm;
    var $7isEg;
    let $2963ed038d5e3581$var$redirecting = false;
    const $2963ed038d5e3581$var$redirect = ()=>{
        const identity = (0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id');
        const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
        window.location.href = redirectUrl;
    };
    const $2963ed038d5e3581$var$blocklist = [
        'issueAggQuery'
    ];
    const $2963ed038d5e3581$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
        if (operationKind === 'query') return 0, (0, parcelRequire("6b2ko")).RETRY_ATTEMPTS_LIMIT;
        return 0;
    };
    const $2963ed038d5e3581$var$getTraceIdFromExtensions = ({ extensions: extensions })=>{
        if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.request_id === 'string') return extensions.gateway.request_id;
        return undefined;
    };
    const $2963ed038d5e3581$var$generateOptions = (options = {})=>{
        const csrfToken = !false ? (0, (0, parcelRequire("4tcSU")).default)() : undefined;
        const csrfTokenHeader = (0, ($parcel$interopDefault($hGgHi)))(csrfToken) ? {} : {
            'atl-xsrf-token': csrfToken
        };
        return (0, ($parcel$interopDefault($1UikQ)))({}, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        }, {
            headers: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'X-ExperimentalApi': (0, (0, parcelRequire("gwtGO")).default).join(','),
                ...csrfTokenHeader
            }
        });
    };
    const $2963ed038d5e3581$var$checkAuthentication = ()=>{
        if (!false && !$2963ed038d5e3581$var$redirecting) {
            const heartbeatService = (0, (0, parcelRequire("2I8bw")).getInstance)();
            if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
                $2963ed038d5e3581$var$redirect();
                $2963ed038d5e3581$var$redirecting = true;
            }
        }
    };
    const $2963ed038d5e3581$export$7bfea3c3d460ecd8 = (error)=>{
        if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) return [
            502,
            503,
            504
        ].includes(error.statusCode);
        return false;
    };
    const $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
        $2963ed038d5e3581$var$checkAuthentication();
        if ($2963ed038d5e3581$var$redirecting) return (0, $eiowN.Observable).from(new Promise(()=>{}));
        const { name: queryName, operationKind: operationKind } = request;
        const earlyScriptPromise = !false && (0, (0, parcelRequire("ajjqZ")).claimEarlyScriptPromise)((0, (0, parcelRequire("ajjqZ")).getEarlyScriptPromiseKey)(request, variables)) || undefined;
        const loggingMetadata = {
            queryName: queryName,
            operationKind: operationKind
        };
        const loggingAndMetrics = (0, (0, parcelRequire("7isEg")).getLoggingAndMetricsHelper)(loggingMetadata);
        return (0, $eiowN.Observable).create((sink)=>{
            try {
                const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
                const endpoint = (0, (0, parcelRequire("eCZ6m")).getAggEndpoint)(request, cacheConfig);
                const body = (0, (0, parcelRequire("eCZ6m")).getRequestBody)(request, variables);
                let ssrCache = null;
                if (!false && requestID != null) ssrCache = (0, (0, parcelRequire("7pVV3")).QueryResponseCache).get(requestID, variables);
                if (!false && !(0, ($parcel$interopDefault($hGgHi)))(ssrCache)) {
                    sink.next(ssrCache);
                    if (requestID != null) (0, (0, parcelRequire("7pVV3")).QueryResponseCache).delete(requestID, variables);
                    sink.complete();
                    return;
                }
                const wrappedEarlyScriptPromise = earlyScriptPromise && (0, (0, parcelRequire("6b2ko")).retryOnError)(()=>(0, (0, parcelRequire("eusud")).applyErrorHandling)(earlyScriptPromise), {
                    retryFunc: ()=>(0, (0, parcelRequire("eusud")).performPostRequest)(endpoint, $2963ed038d5e3581$var$generateOptions({
                            body: body
                        })),
                    retryPredicate: $2963ed038d5e3581$export$7bfea3c3d460ecd8,
                    retryAttempts: $2963ed038d5e3581$export$9dec0f42cc67f6ab(queryName, operationKind),
                    onRetry: loggingAndMetrics.logErrorRetry
                });
                const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, (0, parcelRequire("eusud")).performPostRequestWithRetry)(endpoint, {
                    ...$2963ed038d5e3581$var$generateOptions({
                        body: body
                    }),
                    retryPredicate: $2963ed038d5e3581$export$7bfea3c3d460ecd8,
                    retryAttempts: $2963ed038d5e3581$export$9dec0f42cc67f6ab(queryName, operationKind),
                    onRetry: (error, attempt)=>{
                        loggingAndMetrics.logErrorRetry(error, attempt);
                    }
                }));
                promise.then((response)=>{
                    (0, (0, parcelRequire("5Wobd")).addTraceId)(queryName, $2963ed038d5e3581$var$getTraceIdFromExtensions(response));
                    (0, (0, parcelRequire("4pgHP")).putExtensions)(queryName, response.extensions);
                    const errors = response.errors || undefined;
                    if (errors != null) {
                        const requestId = response?.extensions?.gateway?.request_id;
                        if (!$2963ed038d5e3581$var$blocklist.includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                        (0, (0, parcelRequire("5a0Nh")).captureErrors)(errors, {
                            operationName: queryName,
                            requestId: requestId
                        });
                        if ((0, (0, parcelRequire("5a0Nh")).isUnauthenticated)(errors)) {
                            (0, (0, parcelRequire("lKFKm")).showUnauthenticatedFlag)(queryName);
                            return;
                        }
                    }
                    if (response.data && (response.data.jira === null || response.data.customerService === null)) response.data = null;
                    if (false && requestID != null) (0, (0, parcelRequire("7pVV3")).QueryResponseCache).setWithMetadata(requestID, variables, response, loggingMetadata);
                    sink.next(response);
                    sink.complete();
                }).catch((error)=>{
                    loggingAndMetrics.logError(error);
                    sink.error(error);
                });
                if (requestID != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).set(requestID, promise);
            } catch (error) {
                loggingAndMetrics.logError(error);
                sink.error(error);
            }
        });
    };
});
parcelRegister("5a0Nh", function(module, exports) {
    $parcel$export(module.exports, "startCaptureGraphQlErrors", ()=>$cf86a52470c84b66$export$c211170518c6d0f6);
    $parcel$export(module.exports, "stopCaptureGraphQlErrors", ()=>$cf86a52470c84b66$export$e0491a0d974dadfa);
    $parcel$export(module.exports, "captureErrors", ()=>$cf86a52470c84b66$export$7a973c0ff390eb47);
    $parcel$export(module.exports, "isUnauthenticated", ()=>$cf86a52470c84b66$export$1724ecfee73c4768);
    var $7Jxgt = parcelRequire("7Jxgt");
    const $cf86a52470c84b66$var$errorCollector = new Map();
    const $cf86a52470c84b66$export$da396ad2a542b095 = 120000;
    const $cf86a52470c84b66$var$scheduleCleanup = (key)=>{
        setTimeout(()=>{
            $cf86a52470c84b66$var$errorCollector.delete(key);
        }, $cf86a52470c84b66$export$da396ad2a542b095);
    };
    const $cf86a52470c84b66$export$c211170518c6d0f6 = (key = (0, ($parcel$interopDefault($7Jxgt))).v4())=>{
        $cf86a52470c84b66$var$errorCollector.set(key, []);
        $cf86a52470c84b66$var$scheduleCleanup(key);
        return key;
    };
    const $cf86a52470c84b66$export$e0491a0d974dadfa = (key)=>{
        const errors = $cf86a52470c84b66$var$errorCollector.get(key);
        $cf86a52470c84b66$var$errorCollector.delete(key);
        return errors || [];
    };
    const $cf86a52470c84b66$export$7a973c0ff390eb47 = (errors, meta)=>{
        if (errors) $cf86a52470c84b66$var$errorCollector.forEach((value, key)=>{
            $cf86a52470c84b66$var$errorCollector.set(key, [
                ...value,
                {
                    errors: errors,
                    meta: meta
                }
            ]);
        });
    };
    const $cf86a52470c84b66$export$1724ecfee73c4768 = (errors)=>{
        if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
        return false;
    };
});
parcelRegister("gwtGO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1019e315ad42f34a$export$2e2bcd8739ae039);
    var $1019e315ad42f34a$export$2e2bcd8739ae039 = [
        'ariGraph',
        'boardCardMove',
        'deleteCard',
        'JiraJqlBuilder',
        'SoftwareCardTypeTransitions',
        'jira-releases-v0',
        'JiraDevOps',
        'JiraDevOpsProviders',
        'createCustomFilter',
        'updateCustomFilter',
        'deleteCustomFilter',
        'customFilters',
        'PermissionScheme',
        'JiraIssue',
        'projectStyle',
        'startSprintPrototype',
        'AddIssuesToFixVersion',
        'JiraVersionResult',
        'JiraIssueConnectionJql',
        'JiraFieldOptionSearching',
        'JiraIssueFieldMutations',
        'JiraIssueDevInfoDetails',
        'JiraIssueDevSummaryCache',
        'JiraVersionWarningConfig',
        'JiraReleaseNotesConfiguration',
        'JiraUpdateReleaseNotesConfiguration',
        'ReleaseNotes',
        'ReleaseNotesOptions',
        'DeploymentsFeaturePrecondition',
        'UpdateVersionWarningConfig',
        'UpdateVersionName',
        'UpdateVersionDescription',
        'UpdateVersionStartDate',
        'UpdateVersionReleaseDate',
        'VersionsForProject',
        'RelatedWork',
        'SuggestedRelatedWorkCategories',
        'setIssueMediaVisibility',
        'toggleBoardFeature',
        'DevOpsProvider',
        'DevOpsSummarisedDeployments',
        'JiraProject',
        'DevOpsSummarisedEntities',
        'RoadmapsMutation',
        'RoadmapsQuery',
        'JiraApplicationProperties',
        'JiraIssueSearch',
        'JiraFilter',
        'featureGroups',
        'setBoardEstimationType',
        'devOps',
        'softwareBoards',
        'name',
        'AddRelatedWorkToVersion',
        'RemoveRelatedWorkFromVersion',
        'admins',
        'canAdministerBoard',
        'jql',
        'globalCardCreateAdditionalFields',
        'GlobalTimeTrackingSettings',
        'ReleaseNotesOptions',
        'search-experience',
        'MoveOrRemoveIssuesToFixVersion',
        'compass-beta',
        'JiraIssueSearchStatus',
        'Townsquare',
        'JiraNavigationItems',
        'JiraVersionsForProjects',
        'columnConfigs'
    ];
});
parcelRegister("kipqU", function(module, exports) {
    $parcel$export(module.exports, "QueryPromisesMap", ()=>$f428f7f15822f637$export$607b80f5bc6e396d);
    const $f428f7f15822f637$export$607b80f5bc6e396d = new Map();
});
parcelRegister("7pVV3", function(module, exports) {
    $parcel$export(module.exports, "QueryResponseCache", ()=>$675c7f0a9d659efe$export$688bd21be71b9e5d);
    var $jqONe = parcelRequire("jqONe");
    var $9XE6b = parcelRequire("9XE6b");
    var $eiowN = parcelRequire("eiowN");
    var $dJl1T;
    var $4R6GH;
    var $jJZqs;
    var $kizcd;
    function $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables) {
        return JSON.stringify((0, $eiowN.stableCopy)({
            queryID: queryID,
            variables: variables
        }));
    }
    function $675c7f0a9d659efe$export$1e65e863cf3a0f21(cacheKey) {
        return JSON.parse(cacheKey).queryID;
    }
    const $675c7f0a9d659efe$export$da2711d74cd28aed = [
        'fetchModulesV2Query'
    ];
    class $675c7f0a9d659efe$export$be21c283b097d175 extends (0, $eiowN.QueryResponseCache) {
        constructor({ cacheName: cacheName, size: size, ttl: ttl }){
            super({
                size: size,
                ttl: ttl
            });
            let cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || {};
            if (!false && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1')) cachedData = window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
            this.cacheName = cacheName;
            this.requestMetadata = new Map(cachedData.requestMetadata);
            this._responses = new Map(cachedData.responses);
            if (!false) setTimeout(()=>{
                this.logUnusedPayloadErrors();
                this.requestMetadata.clear();
                this._responses.clear();
            }, 60000);
        }
        logUnusedPayloadErrors() {
            const loggedQueries = new Set();
            this._responses.forEach((response, key)=>{
                const queryID = $675c7f0a9d659efe$export$1e65e863cf3a0f21(key);
                const metadata = this.requestMetadata.get(queryID);
                const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                    queryName: 'unknown',
                    operationKind: 'unknown'
                };
                if (!loggedQueries.has(queryName) && !$675c7f0a9d659efe$export$da2711d74cd28aed.includes(queryName)) {
                    loggedQueries.add(queryName);
                    const error = new (0, (0, parcelRequire("kizcd")).UnusedRelayResponseError)(queryID);
                    const statusCode = (0, ($parcel$interopDefault($9XE6b)))(error, [
                        'statusCode'
                    ], null);
                    const errorType = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? 'network' : 'unknown';
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                        message: `[${(0, ($parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                        errorType: errorType,
                        statusCode: statusCode,
                        queryName: queryName,
                        operationKind: operationKind,
                        errorName: (0, ($parcel$interopDefault($9XE6b)))(error, [
                            'name'
                        ], null)
                    });
                }
            });
        }
        setWithMetadata(queryID, variables, payload, metadata) {
            this.requestMetadata.set(queryID, metadata);
            this.set(queryID, variables, payload);
        }
        delete(queryID, variables) {
            const cacheKey = $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables);
            return this._responses.delete(cacheKey);
        }
        serialize() {
            return {
                [this.cacheName]: {
                    requestMetadata: Array.from(this.requestMetadata.entries()),
                    responses: Array.from(this._responses.entries())
                }
            };
        }
    }
    const $675c7f0a9d659efe$export$688bd21be71b9e5d = new $675c7f0a9d659efe$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    });
    const $675c7f0a9d659efe$export$94e535e06b7ade61 = ()=>$675c7f0a9d659efe$export$688bd21be71b9e5d.serialize();
});
parcelRegister("kizcd", function(module, exports) {
    $parcel$export(module.exports, "UnusedRelayResponseError", ()=>$f174935352f053b0$export$8431e42d062de453);
    class $f174935352f053b0$export$8431e42d062de453 extends Error {
        constructor(queryID){
            super(`Relay Query ${queryID} was made during SSR but never used in the browser`), this.name = 'UnusedRelayResponseError';
        }
    }
});
parcelRegister("ajjqZ", function(module, exports) {
    $parcel$export(module.exports, "getEarlyScriptPromiseKey", ()=>$383b599fde987e1e$export$1102c06c7da91223);
    $parcel$export(module.exports, "claimEarlyScriptPromise", ()=>$383b599fde987e1e$export$828ac0325bce4536);
    $parcel$export(module.exports, "putEarlyScriptPromise", ()=>$383b599fde987e1e$export$e1336d32be02faf4);
    $parcel$export(module.exports, "earlyFetch", ()=>$383b599fde987e1e$export$5b55058781674413);
    var $tcn7E;
    var $l83Uu;
    var $eKonk;
    var $eCZ6m;
    const $383b599fde987e1e$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
    const $383b599fde987e1e$export$b5fbc1430cbfd6e1 = (value)=>value;
    const $383b599fde987e1e$export$6d670d323806bb37 = new Map();
    const $383b599fde987e1e$export$1102c06c7da91223 = (params, variables)=>{
        if (params.name === 'mainIssueAggQuery') return `${params.name}|${params.id}|${variables?.cloudId}|${variables?.issueKey}`;
        const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
        const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
        return `${params.name}|${String(queryId)}|${serializedVariables}`;
    };
    const $383b599fde987e1e$export$828ac0325bce4536 = (key)=>{
        const result = $383b599fde987e1e$export$6d670d323806bb37.get(key);
        if (result != null) $383b599fde987e1e$export$6d670d323806bb37.delete(key);
        return result;
    };
    const $383b599fde987e1e$export$e1336d32be02faf4 = (key, promise)=>{
        if (!$383b599fde987e1e$export$6d670d323806bb37.has(key)) $383b599fde987e1e$export$6d670d323806bb37.set(key, promise);
    };
    const $383b599fde987e1e$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [], capability)=>{
        (0, (0, parcelRequire("l83Uu")).setMark)('jira.fe-spa.early-preload:start');
        const endpoint = (0, (0, parcelRequire("eCZ6m")).getAggEndpoint)(compiledQuery.params);
        const body = (0, (0, parcelRequire("eCZ6m")).getRequestBody)(compiledQuery.params, variables);
        const capabilityHeader = (0, (0, parcelRequire("eKonk")).getEnhancedCapabilityHeader)(capability ?? null);
        $383b599fde987e1e$export$e1336d32be02faf4($383b599fde987e1e$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
            credentials: 'same-origin',
            headers: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'Content-Type': 'application/json',
                Accept: 'application/json,text/javascript,*/*',
                'X-ExperimentalApi': experimentalApis.join(','),
                ...(0, (0, parcelRequire("tcn7E")).getActiveTraceHttpRequestHeaders)(endpoint),
                ...capabilityHeader ? {
                    [$383b599fde987e1e$var$CAPABILITY_HEADER_NAME]: capabilityHeader
                } : {}
            },
            method: 'POST',
            body: body
        }).then((response)=>{
            (0, (0, parcelRequire("l83Uu")).setMark)('jira.fe-spa.early-preload:end');
            return response;
        }));
    };
});
parcelRegister("l83Uu", function(module, exports) {
    $parcel$export(module.exports, "setMark", ()=>$ef655a7b07a35675$export$f7a1fb90d8604165);
    $parcel$export(module.exports, "getTraceId", ()=>$ef655a7b07a35675$export$e88cb5bfb57ce9c4);
    const $ef655a7b07a35675$export$f7a1fb90d8604165 = (mark)=>{
        if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
        performance.mark(mark);
    };
    const $ef655a7b07a35675$var$TRACE_ID_HEADER = 'atl-traceid';
    const $ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
    const $ef655a7b07a35675$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER) || response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS);
});
parcelRegister("lKFKm", function(module, exports) {
    $parcel$export(module.exports, "showUnauthenticatedFlag", ()=>$42cb6e1c2fdc593e$export$758fcc357484571e);
    var $pa9q9;
    var $fjcgS;
    var $8iiwm;
    const $42cb6e1c2fdc593e$var$reloadPage = ()=>window.location.reload();
    const $42cb6e1c2fdc593e$var$sendAnalyticEvent = (operationName)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return;
            analyticsClient.sendTrackEvent({
                action: 'showed',
                actionSubject: 'unauthorizedFlag',
                attributes: {
                    operation: operationName
                },
                source: 'jiraRelayFetch'
            });
        });
    };
    const $42cb6e1c2fdc593e$export$758fcc357484571e = (operationName)=>{
        (0, (0, parcelRequire("pa9q9")).showFlag)({
            type: 'error',
            title: (0, (0, parcelRequire("8iiwm")).default).title,
            description: (0, (0, parcelRequire("8iiwm")).default).description,
            actions: [
                {
                    content: (0, (0, parcelRequire("8iiwm")).default).login,
                    onClick: $42cb6e1c2fdc593e$var$reloadPage
                }
            ]
        });
        $42cb6e1c2fdc593e$var$sendAnalyticEvent(operationName);
    };
});
parcelRegister("pa9q9", function(module, exports) {
    $parcel$export(module.exports, "showFlag", ()=>$00ff685527f9e8c1$export$e12b2cc6b75b006b);
    $parcel$export(module.exports, "dismissFlag", ()=>$00ff685527f9e8c1$export$900a08a292ad23cd);
    $parcel$export(module.exports, "flagService", ()=>$00ff685527f9e8c1$export$dbb055af53fd81a0);
    $parcel$export(module.exports, "useFlagsService", ()=>$00ff685527f9e8c1$export$eee61a1aafe3884);
    $parcel$export(module.exports, "useFlagService", ()=>$00ff685527f9e8c1$export$dc4f8132c3090b32);
    $parcel$export(module.exports, "isDismissFlag", ()=>$00ff685527f9e8c1$export$14b1864d9cf0809f);
    $parcel$export(module.exports, "isFlagComponent", ()=>$00ff685527f9e8c1$export$d84ce5adcee46025);
    $parcel$export(module.exports, "isBatchAction", ()=>$00ff685527f9e8c1$export$c126d8b307b8ab86);
    var $fHfPB;
    var $gEdnQ;
    var $01A9Z;
    var $7HGHK;
    const $00ff685527f9e8c1$export$e12b2cc6b75b006b = (0, (0, parcelRequire("gEdnQ")).default)((0, (0, parcelRequire("01A9Z")).store).dispatch);
    const $00ff685527f9e8c1$export$900a08a292ad23cd = (0, (0, parcelRequire("fHfPB")).default)((0, (0, parcelRequire("01A9Z")).store).dispatch);
    const $00ff685527f9e8c1$var$dismissFlagById = (id)=>{
        $00ff685527f9e8c1$export$900a08a292ad23cd((0, (0, parcelRequire("fHfPB")).dismissFlag)(id));
    };
    const $00ff685527f9e8c1$var$hasFlag = (id)=>Boolean((0, (0, parcelRequire("01A9Z")).store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
    const $00ff685527f9e8c1$export$dbb055af53fd81a0 = {
        showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
        dismissFlag: $00ff685527f9e8c1$export$900a08a292ad23cd
    };
    const $00ff685527f9e8c1$export$eee61a1aafe3884 = ()=>({
            showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
            dismissFlag: $00ff685527f9e8c1$var$dismissFlagById,
            hasFlag: $00ff685527f9e8c1$var$hasFlag
        });
    const $00ff685527f9e8c1$export$dc4f8132c3090b32 = ()=>$00ff685527f9e8c1$export$dbb055af53fd81a0;
    const $00ff685527f9e8c1$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, (0, parcelRequire("7HGHK")).DISMISS_COMMAND);
    const $00ff685527f9e8c1$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
    const $00ff685527f9e8c1$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
    const $00ff685527f9e8c1$export$63ffd7d99470afd4 = (flag)=>!$00ff685527f9e8c1$export$14b1864d9cf0809f(flag) && !$00ff685527f9e8c1$export$d84ce5adcee46025(flag) && !$00ff685527f9e8c1$export$cd5f9f2b991b82d9(flag);
    const $00ff685527f9e8c1$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);
});
parcelRegister("fHfPB", function(module, exports) {
    $parcel$export(module.exports, "dismissFlag", ()=>$8eb241d1a1f5d9b7$export$900a08a292ad23cd);
    $parcel$export(module.exports, "default", ()=>$8eb241d1a1f5d9b7$export$2e2bcd8739ae039);
    var $d6YjM;
    var $7HGHK;
    const $8eb241d1a1f5d9b7$export$900a08a292ad23cd = (flagId)=>({
            command: (0, (0, parcelRequire("7HGHK")).DISMISS_COMMAND),
            id: flagId
        });
    var $8eb241d1a1f5d9b7$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
            dispatch((0, (0, parcelRequire("d6YjM")).dismissFlagAction)(action.id));
        };
});
parcelRegister("d6YjM", function(module, exports) {
    $parcel$export(module.exports, "SHOW", ()=>$07f19e2fef34903b$export$9d04158a25ce4cd);
    $parcel$export(module.exports, "show", ()=>$07f19e2fef34903b$export$57bf213be019eeb0);
    $parcel$export(module.exports, "DISMISS_INSTANCE", ()=>$07f19e2fef34903b$export$b31a07d2e6382678);
    $parcel$export(module.exports, "dismiss", ()=>$07f19e2fef34903b$export$abf286bbe7073aba);
    $parcel$export(module.exports, "DISMISS_FLAG", ()=>$07f19e2fef34903b$export$1eb56620df104bf);
    $parcel$export(module.exports, "dismissFlagAction", ()=>$07f19e2fef34903b$export$4818b3c52448050d);
    $parcel$export(module.exports, "RESET", ()=>$07f19e2fef34903b$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$07f19e2fef34903b$export$aad8462122ac592b);
    const $07f19e2fef34903b$export$9d04158a25ce4cd = 'state.SHOW';
    const $07f19e2fef34903b$export$57bf213be019eeb0 = (payload)=>({
            type: $07f19e2fef34903b$export$9d04158a25ce4cd,
            payload: payload
        });
    const $07f19e2fef34903b$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
    const $07f19e2fef34903b$export$abf286bbe7073aba = (payload)=>({
            type: $07f19e2fef34903b$export$b31a07d2e6382678,
            payload: payload
        });
    const $07f19e2fef34903b$export$1eb56620df104bf = 'state.DISMISS_FLAG';
    const $07f19e2fef34903b$export$4818b3c52448050d = (payload)=>({
            type: $07f19e2fef34903b$export$1eb56620df104bf,
            payload: payload
        });
    const $07f19e2fef34903b$export$4a991c87e640ef77 = 'state.RESET';
    const $07f19e2fef34903b$export$aad8462122ac592b = ()=>({
            type: $07f19e2fef34903b$export$4a991c87e640ef77
        });
});
parcelRegister("7HGHK", function(module, exports) {
    $parcel$export(module.exports, "DISMISS_COMMAND", ()=>$9deb2cdefe93babb$export$e705274c5e156b93);
    $parcel$export(module.exports, "toFlagId", ()=>$9deb2cdefe93babb$export$8184bc29de2aea90);
    $parcel$export(module.exports, "fromFlagId", ()=>$9deb2cdefe93babb$export$188cdb77b72629d7);
    const $9deb2cdefe93babb$export$e705274c5e156b93 = 'DISMISS';
    const $9deb2cdefe93babb$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
    const $9deb2cdefe93babb$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();
});
parcelRegister("gEdnQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c019df33694ffbe1$export$2e2bcd8739ae039);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $d6YjM;
    var $7HGHK;
    var $c019df33694ffbe1$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
            if (typeof flag === 'function') {
                dispatch((0, (0, parcelRequire("d6YjM")).show)(flag));
                return undefined;
            }
            const flagId = flag.id || (0, (0, parcelRequire("7HGHK")).toFlagId)((0, ($parcel$interopDefault($7Jxgt))).v4());
            const newFlag = {
                ...flag,
                id: flagId
            };
            dispatch((0, (0, parcelRequire("d6YjM")).show)(newFlag));
            return flagId;
        };
});
parcelRegister("01A9Z", function(module, exports) {
    $parcel$export(module.exports, "store", ()=>$5787309a6ab0ba9c$export$6f57813fe9f31bf9);
    var $imvpl;
    const $5787309a6ab0ba9c$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("imvpl")).createStore)();
});
parcelRegister("imvpl", function(module, exports) {
    $parcel$export(module.exports, "createStore", ()=>$6bbcd4b408b9a94e$export$f51a9068ac82ea43);
    var $F2Mxm;
    var $gG398;
    const $6bbcd4b408b9a94e$export$f51a9068ac82ea43 = (rootEpic)=>(0, (0, parcelRequire("F2Mxm")).default)({
            appName: 'flags',
            rootReducer: (0, parcelRequire("gG398")).default,
            rootEpic: rootEpic
        });
});
parcelRegister("F2Mxm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fca77440264e922e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3f2cs = parcelRequire("3f2cs");
    var $aB8eX = parcelRequire("aB8eX");
    var $e1AU2 = parcelRequire("e1AU2");
    var $iGv2H;
    var $hkadP;
    var $i9gPl;
    var $fca77440264e922e$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
        const actionListenerMiddleware = new (0, (0, parcelRequire("i9gPl")).default)();
        middlewares.push(actionListenerMiddleware.perform);
        if ((0, (0, parcelRequire("iGv2H")).debugEnabled)('redux-logger')) {
            const { logger: logger } = (parcelRequire("korqb"));
            middlewares.push(logger);
        }
        if (rootEpic) middlewares.push((0, $e1AU2.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
            dependencies: rootEpicDependencies
        } : undefined));
        const store = (0, $3f2cs.createStore)((0, $aB8eX.enableBatching)(rootReducer), initialState, (0, (0, parcelRequire("hkadP")).default)({
            name: appName,
            serialize: {
                replacer: (key, value)=>{
                    if ((0, $5uXOq.isValidElement)(value)) {
                        if (value.type && value.type.displayName) return `React Element <${value.type.displayName}>`;
                        return 'React Element';
                    }
                    if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                    return value;
                }
            }
        })((0, $3f2cs.compose)(...enhancers, (0, $3f2cs.applyMiddleware)(...middlewares))));
        store.addActionListener = actionListenerMiddleware.add;
        store.removeActionListener = actionListenerMiddleware.remove;
        return store;
    };
});
parcelRegister("iGv2H", function(module, exports) {
    $parcel$export(module.exports, "debugEnabled", ()=>$a4079cece44c0fab$export$342c99cc1e9bc5c6);
    const $a4079cece44c0fab$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);
});
parcelRegister("hkadP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$607c98afd3082218$export$2e2bcd8739ae039);
    var $3f2cs = parcelRequire("3f2cs");
    var $607c98afd3082218$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
        const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
        const config = {
            ...devtoolsConfig
        };
        if (config.name != null && config.instanceId == null) config.instanceId = config.name;
        return 0, $3f2cs.compose;
    };
});
parcelRegister("i9gPl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$330df53c22ed8aaf$export$2e2bcd8739ae039);
    class $330df53c22ed8aaf$export$2e2bcd8739ae039 {
        constructor(){
            this.listeners = [];
            this.add = (listener)=>{
                this.listeners.push(listener);
            };
            this.remove = (listener)=>{
                this.listeners = this.listeners.filter((l)=>l !== listener);
            };
            this.perform = (api)=>(next)=>(action)=>{
                        const result = next(action);
                        this.listeners.forEach((listener)=>listener(action, api.getState()));
                        return result;
                    };
        }
    }
});
parcelRegister("gG398", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1feeabef4760da78$export$2e2bcd8739ae039);
    var $ifg6x = parcelRequire("ifg6x");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $d6YjM;
    const $1feeabef4760da78$var$defaultState = {
        flags: []
    };
    var $1feeabef4760da78$export$2e2bcd8739ae039 = (state = $1feeabef4760da78$var$defaultState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("d6YjM")).SHOW:
                {
                    const [lowPriorityFlags, highPriorityFlags] = (0, ($parcel$interopDefault($ifg6x)))([
                        {
                            id: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                            flag: action.payload
                        },
                        ...state.flags
                    ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                    const flags = [
                        ...highPriorityFlags,
                        ...lowPriorityFlags
                    ];
                    return {
                        ...state,
                        flags: flags
                    };
                }
            case 0, (0, parcelRequire("d6YjM")).DISMISS_INSTANCE:
                {
                    const id = action.payload;
                    return {
                        ...state,
                        flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                    };
                }
            case 0, (0, parcelRequire("d6YjM")).DISMISS_FLAG:
                {
                    const id = action.payload;
                    return {
                        ...state,
                        flags: state.flags.filter((flagInstance)=>{
                            if (flagInstance.flag.id) return flagInstance.flag.id !== id;
                            return true;
                        })
                    };
                }
            case 0, (0, parcelRequire("d6YjM")).RESET:
                return $1feeabef4760da78$var$defaultState;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("8iiwm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c7ec0f26423b786$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2c7ec0f26423b786$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "relay-fetch.services.error-flags.title",
            "defaultMessage": "Something's gone wrong"
        },
        description: {
            "id": "relay-fetch.services.error-flags.description",
            "defaultMessage": "Looks like you've been signed out. Try logging in again. "
        },
        login: {
            "id": "relay-fetch.services.error-flags.login",
            "defaultMessage": "Log in"
        }
    });
});
parcelRegister("7isEg", function(module, exports) {
    $parcel$export(module.exports, "getLoggingAndMetricsHelper", ()=>$6c554999a424d172$export$726e1df8186bb981);
    var $jqONe = parcelRequire("jqONe");
    var $9XE6b = parcelRequire("9XE6b");
    var $hGgHi = parcelRequire("hGgHi");
    var $dJl1T;
    var $jJZqs;
    const $6c554999a424d172$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
    const $6c554999a424d172$export$726e1df8186bb981 = (graphqlDetails)=>{
        const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
        return {
            logNonBreakingErrors: (errors, requestId)=>{
                if (false || (0, ($parcel$interopDefault($hGgHi)))(errors) || !Array.isArray(errors)) return;
                errors.forEach((error)=>{
                    error && (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, '[graphql error]', {
                        queryName: queryName,
                        operationKind: operationKind,
                        errorType: 'graphql',
                        message: error.message,
                        requestId: requestId
                    });
                });
            },
            logError: (error)=>{
                const statusCode = (0, ($parcel$interopDefault($9XE6b)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? 'network' : 'unknown';
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                    message: `[${(0, ($parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, ($parcel$interopDefault($9XE6b)))(error, [
                        'name'
                    ], null)
                });
            },
            logErrorRetry: (error, retryAttempt)=>{
                const statusCode = (0, ($parcel$interopDefault($9XE6b)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? 'network' : 'unknown';
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                    message: `[${(0, ($parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, ($parcel$interopDefault($9XE6b)))(error, [
                        'name'
                    ], null),
                    retryAttempt: retryAttempt
                });
            }
        };
    };
});
parcelRegister("k1TrK", function(module, exports) {
    $parcel$export(module.exports, "subscribe", ()=>$4ced6779db298dc0$export$ec068583843480e7);
    var $eiowN = parcelRequire("eiowN");
    var $jcw0u;
    var $lWhTC;
    var $1Uhm6;
    var $cfDZ3;
    const $4ced6779db298dc0$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $eiowN.Observable).create((sink)=>{
            const client = (0, (0, parcelRequire("lWhTC")).getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id
                }
            };
            let requestId;
            return client.subscribe(payload, {
                ...sink,
                next: (value)=>{
                    const aggRequestId = value?.extensions?.agg?.request_id;
                    requestId = aggRequestId ?? requestId;
                    sink.next(value);
                },
                error: (sinkError)=>{
                    const errorInfo = (0, (0, parcelRequire("1Uhm6")).getSinkError)(sinkError);
                    const attributes = {
                        operationName: operationName,
                        requestId: requestId,
                        userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)()
                    };
                    sink.error(errorInfo);
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'subscription',
                            packageName: 'jiraRelaySubscription',
                            teamName: 'uip-graphql'
                        },
                        error: errorInfo,
                        attributes: attributes,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        });
});
parcelRegister("lWhTC", function(module, exports) {
    $parcel$export(module.exports, "getClient", ()=>$2a46eca1e9133707$export$6bb76d6eba7e258c);
    var $4U1PW;
    var $jQsty;
    var $gwtGO;
    var $hoQbP;
    let $2a46eca1e9133707$var$client;
    const $2a46eca1e9133707$export$6bb76d6eba7e258c = ()=>{
        if ((0, (0, parcelRequire("hoQbP")).isSSR)() || (0, (0, parcelRequire("jQsty")).default)('graphql_subscriptions')) return null;
        if (!$2a46eca1e9133707$var$client) $2a46eca1e9133707$var$client = (0, (0, parcelRequire("4U1PW")).createClient)({
            url: (0, (0, parcelRequire("hoQbP")).getAggSubscriptionEndpoint)(),
            lazy: true,
            keepAlive: (0, $37d1b046897e548f$export$8b012b965402e06a),
            retryAttempts: (0, $37d1b046897e548f$export$bf6cd96e19b2987f),
            connectionParams: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'X-ExperimentalApi': (0, (0, parcelRequire("gwtGO")).default).join(',')
            }
        });
        return $2a46eca1e9133707$var$client;
    };
    const $2a46eca1e9133707$export$2f0afd443356d36f = ()=>{
        $2a46eca1e9133707$var$client = null;
    };
});
const $37d1b046897e548f$export$8b012b965402e06a = 580000;
const $37d1b046897e548f$export$bf6cd96e19b2987f = 100;
const $37d1b046897e548f$export$1ad8434180c5936c = 300000;
parcelRegister("hoQbP", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$9e6d9986231c3fe5$export$48d7c418edadb60c);
    $parcel$export(module.exports, "getAggSubscriptionEndpoint", ()=>$9e6d9986231c3fe5$export$29a72e89601dfc59);
    const $9e6d9986231c3fe5$export$48d7c418edadb60c = ()=>false ?? false;
    const $9e6d9986231c3fe5$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
});
parcelRegister("1Uhm6", function(module, exports) {
    $parcel$export(module.exports, "getSinkError", ()=>$db2d4e9951ebaa0f$export$ece4736473c28965);
    const $db2d4e9951ebaa0f$export$ece4736473c28965 = (error)=>{
        let errorInfo;
        if (Array.isArray(error)) [errorInfo] = error;
        else if (error instanceof Error) errorInfo = error;
        else if (typeof error === 'object' && 'type' in error && error.type === 'close') errorInfo = new Error(`CloseEvent: ${error.reason}`);
        else if (error instanceof Event) errorInfo = new Error(`Event: ${error.type}`);
        else errorInfo = new Error(`Unknown sink error: ${error}`);
        return errorInfo;
    };
});
parcelRegister("fwvto", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$c5bf640417859136$export$48d7c418edadb60c);
    const $c5bf640417859136$export$48d7c418edadb60c = ()=>false ?? false;
});
parcelRegister("d5W4H", function(module, exports) {
    $parcel$export(module.exports, "canFetchForgeModules", ()=>$f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08);
    $parcel$export(module.exports, "canFetchForgeModulesV2", ()=>$f4d6ea2b45e6b20f$export$8d182bef16e04eb0);
    var $4Pf62;
    const $f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08 = ()=>{
        const { isAnonymous: isAnonymous, cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        if (String(cloudId) === 'bob') return false;
        return !isAnonymous;
    };
    const $f4d6ea2b45e6b20f$export$8d182bef16e04eb0 = ({ isAnonymous: isAnonymous, cloudId: cloudId })=>{
        if (String(cloudId) === 'bob') return false;
        return !isAnonymous;
    };
});
parcelRegister("dyPNS", function(module, exports) {
    $parcel$export(module.exports, "toMappedExtensions", ()=>$12d1a959cf63073a$export$e073e0c0d1c23345);
    function $12d1a959cf63073a$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
        const result = Object.fromEntries(requestedModules.map((type)=>[
                type,
                []
            ]));
        returnedExtensions.forEach((extension)=>{
            result[extension.type]?.push(extension);
        });
        return result;
    }
});
parcelRegister("829Wu", function(module, exports) {
    $parcel$export(module.exports, "trackGraphQLErrors", ()=>$c9a2f92573d2ebfa$export$a5c00ff206a4c88b);
    var $bvblX;
    var $5a0Nh;
    var $5Wobd;
    function $c9a2f92573d2ebfa$export$a5c00ff206a4c88b(operationName) {
        const queryId = (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)();
        (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(operationName);
        return {
            stopGraphQLErrorTracking: ()=>(0, (0, parcelRequire("5Wobd")).stopCapturingTraceIds)(operationName),
            getGraphQLError: ()=>$c9a2f92573d2ebfa$var$getGraphQLError(queryId, operationName)
        };
    }
    function $c9a2f92573d2ebfa$var$getGraphQLError(key, operationName) {
        const errors = (0, (0, parcelRequire("5a0Nh")).stopCaptureGraphQlErrors)(key).filter((errorWrapper)=>errorWrapper.meta.operationName === operationName).flatMap((errorWrapper)=>errorWrapper.errors);
        if (errors.length) return new (0, (0, parcelRequire("bvblX")).TrackedGraphQLError)(`Query ${operationName} had graphql errors`, errors, (0, (0, parcelRequire("5Wobd")).getTraceIds)(operationName));
        return undefined;
    }
});
parcelRegister("iVaKa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b1a9656c7bb4ee4$export$2e2bcd8739ae039);
    var $e4eHl = parcelRequire("e4eHl");
    var $fn8B5 = parcelRequire("fn8B5");
    var $cuHs1 = parcelRequire("cuHs1");
    var $1UikQ = parcelRequire("1UikQ");
    var $4R6GH;
    var $eusud;
    var $bPtOr;
    var $dYScp;
    var $hBuqR;
    var $bOLUk;
    var $k2DRb;
    var $d5W4H;
    var $1MlDe;
    var $lG6pQ;
    var $ioGTN;
    var $dnsCJ;
    var $eIGUr;
    const $1b1a9656c7bb4ee4$var$moduleToVariableKey = (module)=>(0, ($parcel$interopDefault($e4eHl)))(module);
    const $1b1a9656c7bb4ee4$export$3361e9be8093ddcc = (extensions)=>{
        const groupedExtensions = (0, ($parcel$interopDefault($fn8B5)))(extensions, 'type');
        const groupedExtensionsWithMappedKeys = (0, ($parcel$interopDefault($cuHs1)))(groupedExtensions, (_, key)=>$1b1a9656c7bb4ee4$var$moduleToVariableKey(key));
        return (0, ($parcel$interopDefault($1UikQ)))(groupedExtensionsWithMappedKeys, (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)());
    };
    const $1b1a9656c7bb4ee4$export$44097e02a91cd11a = (extensions)=>{
        const groupedExtensions = (0, ($parcel$interopDefault($fn8B5)))(extensions, 'type');
        const groupedExtensionsWithMappedKeys = (0, ($parcel$interopDefault($1UikQ)))((0, ($parcel$interopDefault($cuHs1)))(groupedExtensions, (_, key)=>$1b1a9656c7bb4ee4$var$moduleToVariableKey(key)), (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)());
        const filteredOutDuplicatedExtensions = (0, (0, parcelRequire("1MlDe")).filterOutDuplicatedExtensions)(groupedExtensionsWithMappedKeys);
        const allowedExtensions = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        const accessNarrowedExtensions = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        Object.entries(filteredOutDuplicatedExtensions).forEach(([key, module])=>{
            const allowedExtensionsMap = new Map();
            const accessNarrowedExtensionsMap = new Map();
            module.forEach((moduleItem)=>{
                if (moduleItem?.dataClassificationPolicyDecision?.status === 'BLOCKED') accessNarrowedExtensionsMap.set(moduleItem.id, moduleItem);
                else allowedExtensionsMap.set(moduleItem.id, moduleItem);
            });
            allowedExtensions[key] = [
                ...allowedExtensionsMap.values()
            ];
            accessNarrowedExtensions[key] = [
                ...accessNarrowedExtensionsMap.values()
            ];
        });
        return {
            extensions: allowedExtensions,
            accessNarrowedExtensions: accessNarrowedExtensions
        };
    };
    const $1b1a9656c7bb4ee4$var$EXCLUDED_ERROR_TYPES = [
        (0, (0, parcelRequire("bPtOr")).FAILED_TO_FETCH),
        (0, (0, parcelRequire("bPtOr")).AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
        (0, (0, parcelRequire("bPtOr")).DATA_CLASSIFICATION_NO_ACCESS)
    ];
    const $1b1a9656c7bb4ee4$var$fetchModulesWithTraceId = async (cloudId, modules, dataClassification, extras, contextIds, source, locale)=>{
        if (modules.length === 0) throw new Error('No modules to fetch provided');
        const { data: data, errors: errors, extensions: extensions } = await (0, (0, parcelRequire("dYScp")).measureExecutionTimeMetrics)(async ()=>{
            const dataClassificationTags = await (0, (0, parcelRequire("lG6pQ")).getDataClassification)(dataClassification, source);
            const includeConfig = extras?.include || {};
            const query = (0, (0, parcelRequire("eIGUr")).buildForgeQuery)(includeConfig);
            const variables = {
                contextIds: contextIds || [
                    `ari:cloud:jira::site/${cloudId}`
                ],
                extensionsFilter: [
                    {
                        type: 'EXTENSION_TYPE',
                        value: modules
                    }
                ],
                dataClassificationTags: dataClassificationTags.map((id)=>`ari:cloud:platform::classification-tag/${id}`),
                locale: (0, (0, parcelRequire("4R6GH")).fg)('forge-ui-i18n-locale-enabled') ? locale : undefined
            };
            return (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: query,
                    variables: variables
                }),
                method: 'POST'
            });
        });
        const traceId = (0, (0, parcelRequire("dnsCJ")).getTraceIdFromExtensions)({
            extensions: extensions
        });
        if (errors) throw new (0, (0, parcelRequire("ioGTN")).ForgeFetchError)(`Response ended with an error message: ${errors[0].message}`, traceId, errors);
        if (!data) throw new (0, (0, parcelRequire("ioGTN")).ForgeFetchError)('No data returned', traceId, errors);
        if (data.extensionContexts.length < 1) throw new (0, (0, parcelRequire("ioGTN")).ForgeFetchError)('No extensionContext returned', traceId, errors);
        return {
            data: data,
            traceId: traceId
        };
    };
    var $1b1a9656c7bb4ee4$export$2e2bcd8739ae039 = async (cloudId, modules, dataClassification, extras, source = (0, (0, parcelRequire("k2DRb")).SOURCE_UNKNOWN), contextIds, locale)=>{
        try {
            if (!(0, (0, parcelRequire("d5W4H")).canFetchForgeModules)()) return {
                extensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)(),
                accessNarrowedExtensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)()
            };
            const { data: data, traceId: traceId } = await $1b1a9656c7bb4ee4$var$fetchModulesWithTraceId(cloudId, modules, dataClassification, extras, contextIds, source, locale);
            if (Math.random() * 100 < (0, (0, parcelRequire("hBuqR")).FORGE_SAMPLING_RATE)) (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFinishedEvent)(source, {
                traceId: traceId
            });
            return $1b1a9656c7bb4ee4$export$44097e02a91cd11a(data.extensionContexts[0].extensions);
        } catch (error) {
            const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
            const traceId = (0, (0, parcelRequire("dnsCJ")).getTraceIdFromError)(error);
            (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFailedEvent)(source, {
                isSSR: false,
                errorType: errorType,
                error: error,
                traceId: traceId
            });
            if ($1b1a9656c7bb4ee4$var$EXCLUDED_ERROR_TYPES.includes(errorType)) return {
                extensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)(),
                accessNarrowedExtensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)()
            };
            throw error;
        }
    };
});
parcelRegister("1MlDe", function(module, exports) {
    $parcel$export(module.exports, "filterOutDuplicatedExtensions", ()=>$11a6461020d3329a$export$e0393e97f15a28a5);
    var $lbWm4 = parcelRequire("lbWm4");
    var $k2DRb;
    const $11a6461020d3329a$export$e0393e97f15a28a5 = (modules)=>{
        const filteredModules = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        (0, ($parcel$interopDefault($lbWm4)))(modules, (module, propName)=>{
            const moduleExtensions = new Map();
            (0, ($parcel$interopDefault($lbWm4)))(module, (moduleItem)=>{
                const moduleExtension = moduleExtensions.get(moduleItem.id);
                const appVersion = moduleItem?.appVersion || '0.0.0';
                const moduleAppVersion = moduleExtension?.appVersion || '0.0.0';
                if (!moduleExtension || moduleExtension && appVersion >= moduleAppVersion) moduleExtensions.set(moduleItem.id, moduleItem);
            });
            filteredModules[propName] = [
                ...moduleExtensions.values()
            ];
        });
        return filteredModules;
    };
});
parcelRegister("lG6pQ", function(module, exports) {
    $parcel$export(module.exports, "getDataClassification", ()=>$013c8a0b6d7ef450$export$1635afa94064952c);
    var $eusud;
    var $bPtOr;
    var $bOLUk;
    var $dqtU7;
    var $6P5IG;
    const $013c8a0b6d7ef450$var$handleError = (err, source)=>{
        const errorMessage = err instanceof Error ? err.message : String(err);
        const error = Error(`Data classification request failed: ${errorMessage}`);
        const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
        if (errorType === (0, (0, parcelRequire("bPtOr")).DATA_CLASSIFICATION_NO_ACCESS)) throw error;
        (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        return [];
    };
    async function $013c8a0b6d7ef450$var$getDataClassificationIssue(props, source) {
        try {
            const now = Date.now();
            const cachedResult = (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).get(`${(0, (0, parcelRequire("6P5IG")).issueKeyPrefix)}-${props.issueKey}`);
            const isCacheResultTimePassed = Boolean(cachedResult && (0, (0, parcelRequire("6P5IG")).TTL) < now - cachedResult.timestamp);
            if (isCacheResultTimePassed || !cachedResult) {
                const data = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/3/data-classification/resource/issue/${props.issueKey}`);
                (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).set(`${(0, (0, parcelRequire("6P5IG")).issueKeyPrefix)}-${props.issueKey}`, {
                    tags: data.tags,
                    timestamp: now
                });
                return data.tags;
            }
            return cachedResult.tags;
        } catch (err) {
            return $013c8a0b6d7ef450$var$handleError(err, source);
        }
    }
    async function $013c8a0b6d7ef450$var$getDataClassificationProject(props, source) {
        try {
            const now = Date.now();
            const cachedResult = (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).get(`${(0, (0, parcelRequire("6P5IG")).projectKeyPrefix)}-${props.projectIdOrKey}`);
            const isCacheResultTimePassed = Boolean(cachedResult && (0, (0, parcelRequire("6P5IG")).TTL) < now - cachedResult.timestamp);
            if (isCacheResultTimePassed || !cachedResult) {
                const data = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/3/data-classification/resource/container/${props.projectIdOrKey}`);
                (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).set(`${(0, (0, parcelRequire("6P5IG")).projectKeyPrefix)}-${props.projectIdOrKey}`, {
                    tags: data.tags,
                    timestamp: now
                });
                return data.tags;
            }
            return cachedResult.tags;
        } catch (err) {
            return $013c8a0b6d7ef450$var$handleError(err, source);
        }
    }
    const $013c8a0b6d7ef450$export$1635afa94064952c = async (props, source)=>{
        if (props !== null) {
            if ((0, (0, parcelRequire("dqtU7")).hasPrefetchedData)(props)) return props.tags;
            if ((0, (0, parcelRequire("dqtU7")).hasProjectIdOrKey)(props)) {
                const tags = await $013c8a0b6d7ef450$var$getDataClassificationProject(props, source);
                return tags;
            }
            if ((0, (0, parcelRequire("dqtU7")).hasIssueKey)(props)) {
                const tags = await $013c8a0b6d7ef450$var$getDataClassificationIssue(props, source);
                return tags;
            }
        }
        return [];
    };
});
parcelRegister("dqtU7", function(module, exports) {
    $parcel$export(module.exports, "hasPrefetchedData", ()=>$3920146879a40338$export$c19d255b92c7c2da);
    $parcel$export(module.exports, "hasProjectIdOrKey", ()=>$3920146879a40338$export$494434246e5dea0d);
    $parcel$export(module.exports, "hasIssueKey", ()=>$3920146879a40338$export$b1490cfc7a90c75b);
    var $8LQ84 = parcelRequire("8LQ84");
    const $3920146879a40338$export$c19d255b92c7c2da = (props)=>props !== null && 'tags' in props && (0, ($parcel$interopDefault($8LQ84)))(props.tags);
    const $3920146879a40338$export$494434246e5dea0d = (props)=>props !== null && 'projectIdOrKey' in props;
    const $3920146879a40338$export$b1490cfc7a90c75b = (props)=>props !== null && 'issueKey' in props;
});
parcelRegister("6P5IG", function(module, exports) {
    $parcel$export(module.exports, "TTL", ()=>$ca591e08be1a6f54$export$6ebb1381174e92a7);
    $parcel$export(module.exports, "issueKeyPrefix", ()=>$ca591e08be1a6f54$export$a040db2850f159b0);
    $parcel$export(module.exports, "projectKeyPrefix", ()=>$ca591e08be1a6f54$export$df256a06d24ff906);
    $parcel$export(module.exports, "DataClassificationTagsCache", ()=>$ca591e08be1a6f54$export$b7adc37405b5ff0d);
    const $ca591e08be1a6f54$export$6ebb1381174e92a7 = 60000;
    const $ca591e08be1a6f54$export$a040db2850f159b0 = 'issue';
    const $ca591e08be1a6f54$export$df256a06d24ff906 = 'project';
    const $ca591e08be1a6f54$export$b7adc37405b5ff0d = new Map();
});
parcelRegister("ioGTN", function(module, exports) {
    $parcel$export(module.exports, "ForgeFetchError", ()=>$03e8a2344fd340fa$export$2e3b53e53bafa);
    class $03e8a2344fd340fa$export$2e3b53e53bafa extends Error {
        constructor(message, traceId, errors){
            super(message);
            this.name = $03e8a2344fd340fa$export$2e3b53e53bafa.name;
            this.traceId = traceId;
            this.statusCodes = errors?.map((graphQLError)=>graphQLError?.extensions?.statusCode).filter((x)=>x != null);
            if ('captureStackTrace' in Error) Error.captureStackTrace(this, $03e8a2344fd340fa$export$2e3b53e53bafa);
        }
    }
});
parcelRegister("dnsCJ", function(module, exports) {
    $parcel$export(module.exports, "getTraceIdFromExtensions", ()=>$06cecb1cf20a09b8$export$eefb7f54c3b07211);
    $parcel$export(module.exports, "getTraceIdFromError", ()=>$06cecb1cf20a09b8$export$9955d05ba83067ba);
    var $jJZqs;
    var $ioGTN;
    const $06cecb1cf20a09b8$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
        const traceId = extensions?.gateway?.request_id;
        if (traceId && typeof traceId === 'string') return traceId;
        return undefined;
    };
    const $06cecb1cf20a09b8$export$9955d05ba83067ba = (error)=>{
        if (error instanceof (0, (0, parcelRequire("ioGTN")).ForgeFetchError) || error instanceof (0, (0, parcelRequire("jJZqs")).default)) return error.traceId;
        return undefined;
    };
});
parcelRegister("eIGUr", function(module, exports) {
    $parcel$export(module.exports, "buildForgeQuery", ()=>$5112ddb3344b355d$export$497b2dc04db7bd76);
    const $5112ddb3344b355d$export$497b2dc04db7bd76 = (include)=>{
        const consentFields = `
    consentUrl
    currentUserConsent {
        user {
            aaid
        }
        appEnvironmentVersion {
            id
        }
        consentedAt
    }
    requiresUserConsent`;
        const scopesField = include.scopes === true ? 'scopes' : '';
        const licenseFields = `
    license {
        active
        type
        supportEntitlementNumber
        trialEndDate
        subscriptionEndDate
        isEvaluation
        billingPeriod
        ccpEntitlementId
        ccpEntitlementSlug
        capabilitySet
    }`;
        return `query jira_forge_frontendModules($contextIds: [ID!]! $extensionsFilter: [ExtensionContextsFilter!]! $dataClassificationTags: [ID!]!, $locale: String) {
        extensionContexts(contextIds: $contextIds) @optIn(to: "Access-Narrowing") {
            extensions(filter: $extensionsFilter, locale: $locale) {
                id
                appVersion
                installationId
                environmentId
                environmentType
                environmentKey
                properties
                ${licenseFields}
                ${scopesField}
                type
                __typename
                ${consentFields}
                egress {
                    type
                    addresses
                }
                dataClassificationPolicyDecision(input: {
                    dataClassificationTags: $dataClassificationTags
                }) {
                    status
                }
            }
        }
    }`;
    };
});
parcelRegister("dK8AG", function(module, exports) {
    $parcel$export(module.exports, "getProjectKeyOrId", ()=>$9ffe1ab8f180b628$export$43cde151f667c69e);
    $parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", ()=>$9ffe1ab8f180b628$export$b87af5b274141bd6);
    var $1nb22;
    const $9ffe1ab8f180b628$export$43cde151f667c69e = (match)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, match.query);
        return projectKey || projectId || '';
    };
    const $9ffe1ab8f180b628$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
});
parcelRegister("47m5i", function(module, exports) {
    $parcel$export(module.exports, "fetchForgeModule", ()=>$9024d8f047e9df37$export$e1683e15cedb5f17);
    var $e4eHl = parcelRequire("e4eHl");
    var $8O7FC;
    var $k2DRb;
    var $iVaKa;
    var $g5X3G;
    var $gLloR;
    const $9024d8f047e9df37$var$dataClassificatedModulesConfig = {
        names: new Set(),
        request: Promise.resolve({})
    };
    const $9024d8f047e9df37$export$e1683e15cedb5f17 = async ({ cloudId: cloudId, moduleName: moduleName, dataClassification: dataClassification, shouldReturnANExtensions: shouldReturnANExtensions = false, contextIds: contextIds, locale: locale })=>{
        $9024d8f047e9df37$var$dataClassificatedModulesConfig.names.add(moduleName);
        await new Promise((resolve)=>setTimeout(resolve, 0));
        const moduleNamesToFetch = Array.from($9024d8f047e9df37$var$dataClassificatedModulesConfig.names);
        let extensions = [];
        let accessNarrowedExtensions = [];
        if (moduleNamesToFetch.length > 0) {
            $9024d8f047e9df37$var$dataClassificatedModulesConfig.names = new Set();
            $9024d8f047e9df37$var$dataClassificatedModulesConfig.request = (0, (0, parcelRequire("iVaKa")).default)((0, (0, parcelRequire("g5X3G")).toCloudId)(cloudId), moduleNamesToFetch, dataClassification, undefined, (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP), contextIds, locale).then((extensionsMap)=>extensionsMap);
        }
        const result = await $9024d8f047e9df37$var$dataClassificatedModulesConfig.request;
        extensions = result.extensions[(0, ($parcel$interopDefault($e4eHl)))(moduleName)];
        if (shouldReturnANExtensions) accessNarrowedExtensions = result.accessNarrowedExtensions[(0, ($parcel$interopDefault($e4eHl)))(moduleName)];
        const getExtensionsFilter = (fullPageModuleName)=>{
            switch(fullPageModuleName){
                case 0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE:
                    return 0, (0, parcelRequire("gLloR")).adminPageFilter;
                default:
                    return 0, (0, parcelRequire("gLloR")).uniqueExtensionsFilter;
            }
        };
        return {
            extensions: getExtensionsFilter(moduleName)(extensions).sort((a, b)=>(0, (0, parcelRequire("8O7FC")).alphabeticalSort)(a.properties.title, b.properties.title)),
            accessNarrowedExtensions: getExtensionsFilter(moduleName)(accessNarrowedExtensions).sort((a, b)=>(0, (0, parcelRequire("8O7FC")).alphabeticalSort)(a.properties.title, b.properties.title))
        };
    };
});
parcelRegister("gLloR", function(module, exports) {
    $parcel$export(module.exports, "uniqueExtensionsFilter", ()=>$11790a142fe832e3$export$2b91ba95eded67f6);
    $parcel$export(module.exports, "adminPageFilter", ()=>$11790a142fe832e3$export$1eefd1d9cde49fd5);
    var $3JOCw = parcelRequire("3JOCw");
    var $e0AC8;
    const $11790a142fe832e3$export$2b91ba95eded67f6 = (extensions)=>(0, ($parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
            const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
            return `${appId}_${envId}`;
        });
    const $11790a142fe832e3$export$1eefd1d9cde49fd5 = (extensions)=>{
        const configPageFilter = (extension)=>extension.properties.useAsConfig;
        const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
        const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
        const adminExtensions = extensions;
        return [
            ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(mainPageFilter)),
            ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(configPageFilter)),
            ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(getStartedPageFilter))
        ];
    };
});
parcelRegister("e0AC8", function(module, exports) {
    $parcel$export(module.exports, "parseExtensionId", ()=>$d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b);
    $parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", ()=>$d4c89d40e0b3eaac$export$a92b17288693d366);
    const $d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b = (extensionId)=>{
        const [, appId, envId] = extensionId.split('/');
        return {
            appId: appId,
            envId: envId
        };
    };
    const $d4c89d40e0b3eaac$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');
});
parcelRegister("1yLrr", function(module, exports) {
    $parcel$export(module.exports, "uniqueExtensionsFilter", ()=>$8bb90f56b7c2b78a$export$2b91ba95eded67f6);
    $parcel$export(module.exports, "adminPageFilter", ()=>$8bb90f56b7c2b78a$export$1eefd1d9cde49fd5);
    var $3JOCw = parcelRequire("3JOCw");
    var $e0AC8;
    const $8bb90f56b7c2b78a$export$2b91ba95eded67f6 = (extensions)=>(0, ($parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
            const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
            return `${appId}_${envId}`;
        });
    const $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5 = (extensions)=>{
        const configPageFilter = (extension)=>extension.properties.useAsConfig;
        const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
        const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
        return [
            ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
            ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
            ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
        ];
    };
});
parcelRegister("7xTO3", function(module, exports) {
    $parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", ()=>$7371ef5d04dd1248$export$5839dd8142de842e);
    var $dJl1T;
    var $8YTna;
    var $2M1hQ;
    var $55UpE;
    const $7371ef5d04dd1248$export$5839dd8142de842e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
        getKey: ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            return boardId ? `board-${boardId}` : 'none';
        },
        getData: async ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            if (boardId == null) return null;
            try {
                const response = await (0, (0, parcelRequire("55UpE")).fetchUserBoardNavigationData)(boardId);
                return response;
            } catch (e) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
                return null;
            }
        },
        maxAge: 300000
    });
});
parcelRegister("55UpE", function(module, exports) {
    $parcel$export(module.exports, "fetchUserBoardNavigationData", ()=>$e577b36e40c022cb$export$306fb49fca60b34);
    var $eusud;
    const $e577b36e40c022cb$export$306fb49fca60b34 = (boardId)=>{
        if (boardId == null) throw new Error('invalid boardId');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
    };
});
parcelRegister("c1N9v", function(module, exports) {
    $parcel$export(module.exports, "staticPlanSidebarNavigationResource", ()=>$4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7);
    var $2M1hQ;
    var $ijN6s;
    const $4a8a43738dc54d5c$var$getRouterKey = (match)=>{
        if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
        return 'none';
    };
    const $4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
        getKey: ({ match: match })=>$4a8a43738dc54d5c$var$getRouterKey(match),
        getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
            if (planId == null || scenarioId == null) return null;
            return (0, (0, parcelRequire("ijN6s")).fetchPlanSidebarNavInfo)(planId, scenarioId);
        },
        maxAge: 300000
    });
});
parcelRegister("ijN6s", function(module, exports) {
    $parcel$export(module.exports, "fetchPlanSidebarNavInfo", ()=>$b2d0559c1bc2bb35$export$a49729698cfc5310);
    var $eusud;
    const $b2d0559c1bc2bb35$var$requestSideBarInfo = (planId, scenarioId)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
    const $b2d0559c1bc2bb35$export$a49729698cfc5310 = (planId, scenarioId)=>{
        if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
        if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
        return $b2d0559c1bc2bb35$var$requestSideBarInfo(planId, scenarioId);
    };
});
parcelRegister("2fwuR", function(module, exports) {
    $parcel$export(module.exports, "sidebarNav4Resource", ()=>$692dbcae1edae2a1$export$7648dc6f76f4f83d);
    $parcel$export(module.exports, "sidebarNav4UiStateResource", ()=>$692dbcae1edae2a1$export$a46129bd512544d7);
    var $jhS4y;
    var $3Jbkp;
    var $fMcVX;
    var $ao2h1;
    var $2OeZv;
    var $fZBia;
    const $692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
    const $692dbcae1edae2a1$export$7648dc6f76f4f83d = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${$692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
        getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
            const initialSelectedPath = (0, (0, parcelRequire("3Jbkp")).getInitialSelectedPath)(routerContext);
            return {
                parameters: (0, (0, parcelRequire("2OeZv")).default),
                variables: {
                    cloudId: cloudId,
                    isAppsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_APPS)),
                    isDashboardsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS)),
                    isFiltersExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS)),
                    isPlansExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS)),
                    isProjectsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS)),
                    isOperationsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS)),
                    isOverviewsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS))
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
    const $692dbcae1edae2a1$export$a46129bd512544d7 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
        getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
                parameters: (0, (0, parcelRequire("fZBia")).default),
                variables: {
                    cloudId: cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("jhS4y", function(module, exports) {
    $parcel$export(module.exports, "CONFIGURABLE_MENU_ID", ()=>$d66e3a3484b422c6$export$7838b734e4cd5e8d);
    $parcel$export(module.exports, "ENTITY_ID", ()=>$d66e3a3484b422c6$export$103ff18fe29ee1b);
    $parcel$export(module.exports, "MENU_ID_APPS", ()=>$d66e3a3484b422c6$export$441cd608ea3204f4);
    $parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", ()=>$d66e3a3484b422c6$export$5baa9c2e3c3931c5);
    $parcel$export(module.exports, "MENU_ID_ASSETS", ()=>$d66e3a3484b422c6$export$75c65bfc98b3a6e1);
    $parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", ()=>$d66e3a3484b422c6$export$8a0af92d49f1d13d);
    $parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", ()=>$d66e3a3484b422c6$export$a09300d15acc958a);
    $parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$4d718fbd418eef5c);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS", ()=>$d66e3a3484b422c6$export$dd009509c2dabb5e);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$d3da0455b4200fb2);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", ()=>$d66e3a3484b422c6$export$b9dd2b5309d19763);
    $parcel$export(module.exports, "MENU_ID_FILTERS", ()=>$d66e3a3484b422c6$export$3d81af172a8e3c57);
    $parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", ()=>$d66e3a3484b422c6$export$1e2599eaf0039a97);
    $parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$53d274d993c9d5b5);
    $parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", ()=>$d66e3a3484b422c6$export$7661ea763be69cfa);
    $parcel$export(module.exports, "MENU_ID_GOALS", ()=>$d66e3a3484b422c6$export$47c6ce6a83a59eab);
    $parcel$export(module.exports, "MENU_ID_OPERATIONS", ()=>$d66e3a3484b422c6$export$ef89639b7d9c162a);
    $parcel$export(module.exports, "MENU_ID_OPS_ALERTS", ()=>$d66e3a3484b422c6$export$af4ab6d4e920522a);
    $parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", ()=>$d66e3a3484b422c6$export$25c40acb2c53a294);
    $parcel$export(module.exports, "MENU_ID_OPS_REPORTS", ()=>$d66e3a3484b422c6$export$c7d8892f1628b844);
    $parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", ()=>$d66e3a3484b422c6$export$bb19a52e3df99541);
    $parcel$export(module.exports, "MENU_ID_OVERVIEWS", ()=>$d66e3a3484b422c6$export$3bd12c092f8db11b);
    $parcel$export(module.exports, "MENU_ID_PLANS", ()=>$d66e3a3484b422c6$export$f2533da33c749933);
    $parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$8468c5b6648f4f1f);
    $parcel$export(module.exports, "MENU_ID_PROJECT_APPS", ()=>$d66e3a3484b422c6$export$fed17b4c0866b97d);
    $parcel$export(module.exports, "MENU_ID_PROJECTS", ()=>$d66e3a3484b422c6$export$9c5278bd360a285);
    $parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$85389c606bb641dd);
    $parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", ()=>$d66e3a3484b422c6$export$4a1974b63c858e9c);
    $parcel$export(module.exports, "MENU_ID_RECENT", ()=>$d66e3a3484b422c6$export$692b796030a796f3);
    $parcel$export(module.exports, "MENU_ID_ROADMAPS", ()=>$d66e3a3484b422c6$export$cdc80d4b5ce0c6a);
    $parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$7606c0134aabf3d7);
    $parcel$export(module.exports, "MENU_ID_STARRED", ()=>$d66e3a3484b422c6$export$5637ca42a4d77f32);
    $parcel$export(module.exports, "MENU_ID_TEAMS", ()=>$d66e3a3484b422c6$export$d4f6fcf571f9c50);
    $parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE", ()=>$d66e3a3484b422c6$export$11fcdf33179ef88e);
    $parcel$export(module.exports, "MENU_ID_YOUR_WORK", ()=>$d66e3a3484b422c6$export$80dc576e446bdb6b);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", ()=>$d66e3a3484b422c6$export$79c15668ed799a1b);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", ()=>$d66e3a3484b422c6$export$e299bb06c4370c0d);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", ()=>$d66e3a3484b422c6$export$713b9b0a69a79cf9);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", ()=>$d66e3a3484b422c6$export$f1d9c0f27216aa1c);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", ()=>$d66e3a3484b422c6$export$45763fa331781074);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", ()=>$d66e3a3484b422c6$export$6ee20c845dbab3e3);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", ()=>$d66e3a3484b422c6$export$b3815dd180ce5e61);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", ()=>$d66e3a3484b422c6$export$100a1a639a0db980);
    const $d66e3a3484b422c6$export$7838b734e4cd5e8d = {
        APPS: 'jira.sidebar.apps',
        ASSETS: 'jira.sidebar.assets',
        DASHBOARDS: 'jira.sidebar.dashboards',
        FILTERS: 'jira.sidebar.filters',
        GOALS: 'jira.sidebar.goals',
        OPERATIONS: 'jira.sidebar.operations',
        OVERVIEWS: 'jira.sidebar.overviews',
        PLANS: 'jira.sidebar.plans',
        PROJECTS: 'jira.sidebar.projects',
        RECENT: 'jira.sidebar.recent',
        STARRED: 'jira.sidebar.starred',
        TEAMS: 'jira.sidebar.teams',
        ROADMAPS: 'jira.sidebar.roadmaps',
        CUSTOMER_SERVICE: 'jira.sidebar.customerService'
    };
    const $d66e3a3484b422c6$export$103ff18fe29ee1b = {
        ALARM_QUEUE: (id)=>`alrm_${id}`,
        APP: (id)=>`app_${id}`,
        BOARD: (id)=>`boar_${id}`,
        DASHBOARD: (id)=>`dash_${id}`,
        FILTER: (id)=>`filt_${id}`,
        FORM: (id)=>`form_${id}`,
        OVERVIEW: (id)=>`over_${id}`,
        PLAN: (id)=>`plan_${id}`,
        PROJECT: (id)=>`proj_${id}`,
        PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
        PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
        PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
        PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
        PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
        PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
        PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
        PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
        PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
        PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
        PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
        PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
        PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
        PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
        PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
        PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
        ROADMAP: (id)=>`roadmap_${id}`,
        QUEUE: (id)=>`queu_${id}`
    };
    const $d66e3a3484b422c6$export$441cd608ea3204f4 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.APPS;
    const $d66e3a3484b422c6$export$5baa9c2e3c3931c5 = 'app_mrkt';
    const $d66e3a3484b422c6$export$75c65bfc98b3a6e1 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ASSETS;
    const $d66e3a3484b422c6$export$8a0af92d49f1d13d = 'asst_schm';
    const $d66e3a3484b422c6$export$a09300d15acc958a = 'asst_rprt';
    const $d66e3a3484b422c6$export$4d718fbd418eef5c = 'board-view-all';
    const $d66e3a3484b422c6$export$dd009509c2dabb5e = $d66e3a3484b422c6$export$7838b734e4cd5e8d.DASHBOARDS;
    const $d66e3a3484b422c6$export$d3da0455b4200fb2 = 'dash-view';
    const $d66e3a3484b422c6$export$b9dd2b5309d19763 = 'dash-view-starred';
    const $d66e3a3484b422c6$export$3d81af172a8e3c57 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.FILTERS;
    const $d66e3a3484b422c6$export$1e2599eaf0039a97 = 'filt-search';
    const $d66e3a3484b422c6$export$53d274d993c9d5b5 = 'filt-view-all';
    const $d66e3a3484b422c6$export$7661ea763be69cfa = 'filt-view-starred';
    const $d66e3a3484b422c6$export$47c6ce6a83a59eab = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GOALS;
    const $d66e3a3484b422c6$export$ef89639b7d9c162a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OPERATIONS;
    const $d66e3a3484b422c6$export$af4ab6d4e920522a = 'ops-alrt';
    const $d66e3a3484b422c6$export$25c40acb2c53a294 = 'ops-over';
    const $d66e3a3484b422c6$export$c7d8892f1628b844 = 'ops-rprt';
    const $d66e3a3484b422c6$export$bb19a52e3df99541 = 'ops-oncl';
    const $d66e3a3484b422c6$export$3bd12c092f8db11b = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OVERVIEWS;
    const $d66e3a3484b422c6$export$f2533da33c749933 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PLANS;
    const $d66e3a3484b422c6$export$8468c5b6648f4f1f = 'plan-view-all';
    const $d66e3a3484b422c6$export$fed17b4c0866b97d = 'proj-app';
    const $d66e3a3484b422c6$export$e682260eda678e61 = 'proj-dir';
    const $d66e3a3484b422c6$export$9c5278bd360a285 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PROJECTS;
    const $d66e3a3484b422c6$export$85389c606bb641dd = 'proj-view-all';
    const $d66e3a3484b422c6$export$4a1974b63c858e9c = 'proj-view-starred';
    const $d66e3a3484b422c6$export$692b796030a796f3 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.RECENT;
    const $d66e3a3484b422c6$export$cdc80d4b5ce0c6a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ROADMAPS;
    const $d66e3a3484b422c6$export$7606c0134aabf3d7 = 'roadmaps-view-all';
    const $d66e3a3484b422c6$export$5637ca42a4d77f32 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.STARRED;
    const $d66e3a3484b422c6$export$d4f6fcf571f9c50 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.TEAMS;
    const $d66e3a3484b422c6$export$11fcdf33179ef88e = $d66e3a3484b422c6$export$7838b734e4cd5e8d.CUSTOMER_SERVICE;
    const $d66e3a3484b422c6$export$80dc576e446bdb6b = 'yrwk';
    const $d66e3a3484b422c6$export$79c15668ed799a1b = 'sd-sett-acc';
    const $d66e3a3484b422c6$export$e299bb06c4370c0d = 'sd-sett-req-man';
    const $d66e3a3484b422c6$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
    const $d66e3a3484b422c6$export$f1d9c0f27216aa1c = 'sd-sett-aut';
    const $d66e3a3484b422c6$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
    const $d66e3a3484b422c6$export$6ee20c845dbab3e3 = 'sd-sett-not';
    const $d66e3a3484b422c6$export$b3815dd180ce5e61 = 'sd-sett-apps';
    const $d66e3a3484b422c6$export$100a1a639a0db980 = 'sd-sett-ops';
});
parcelRegister("3Jbkp", function(module, exports) {
    $parcel$export(module.exports, "getInitialSelectedPath", ()=>$e52131b0b61339d3$export$39f409bc5f59c5e);
    var $bxYf9 = parcelRequire("bxYf9");
    var $7Ckoi;
    const $e52131b0b61339d3$export$39f409bc5f59c5e = (0, ($parcel$interopDefault($bxYf9)))((0, (0, parcelRequire("7Ckoi")).routeToSelectedPath));
});
parcelRegister("7Ckoi", function(module, exports) {
    $parcel$export(module.exports, "routeToSelectedPath", ()=>$551cdf5d088747a1$export$a92474c098a1fd13);
    var $4R6GH;
    var $fBDpl;
    var $ezq2z;
    var $j3mSh;
    var $1RoZ2;
    var $hdJn1;
    var $2m3Yb;
    var $3weqe;
    var $c6hlO;
    var $3lNyZ;
    var $8bXrC;
    var $eReVn;
    function $551cdf5d088747a1$export$a92474c098a1fd13(routeContext) {
        const routeName = routeContext.route.name;
        if ((0, (0, parcelRequire("2m3Yb")).topLevelConverter).routes.has(routeName)) return (0, (0, parcelRequire("2m3Yb")).topLevelConverter).convert(routeContext);
        if ((0, (0, parcelRequire("fBDpl")).appsConverter).routes.has(routeName)) return (0, (0, parcelRequire("fBDpl")).appsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("ezq2z")).assetsConverter).routes.has(routeName)) return (0, (0, parcelRequire("ezq2z")).assetsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("j3mSh")).dashboardsConverter).routes.has(routeName)) return (0, (0, parcelRequire("j3mSh")).dashboardsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("1RoZ2")).filtersConverter).routes.has(routeName)) return (0, (0, parcelRequire("1RoZ2")).filtersConverter).convert(routeContext);
        if ((0, (0, parcelRequire("hdJn1")).operationsConverter).routes.has(routeName)) return (0, (0, parcelRequire("hdJn1")).operationsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("3weqe")).overviewsConverter).routes.has(routeName)) return (0, (0, parcelRequire("3weqe")).overviewsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("3weqe")).overviewsConverter).routes.has(routeName)) return (0, (0, parcelRequire("3weqe")).overviewsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("c6hlO")).plansConverter).routes.has(routeName)) return (0, (0, parcelRequire("c6hlO")).plansConverter).convert(routeContext);
        if ((0, (0, parcelRequire("3lNyZ")).projectsConverter).routes.has(routeName)) return (0, (0, parcelRequire("3lNyZ")).projectsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("8bXrC")).roadmapsConverter).routes.has(routeName)) return (0, (0, parcelRequire("8bXrC")).roadmapsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_1')) {
            if ((0, (0, parcelRequire("eReVn")).serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, (0, parcelRequire("eReVn")).serviceManagementProjectSettingsConverter).convert(routeContext);
        }
        return [];
    }
});
parcelRegister("fBDpl", function(module, exports) {
    $parcel$export(module.exports, "appsConverter", ()=>$55a8ac7f9c56fb94$export$d017a63045c88c47);
    var $65Ltd;
    var $jhS4y;
    const $55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_INVALID),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT)
    ];
    const $55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_GLOBAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_INDEX),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PERSONAL_SETTINGS)
    ];
    const $55a8ac7f9c56fb94$export$66b32f6f30eb4b4 = new Set([
        ...$55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES,
        ...$55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES
    ]);
    function $55a8ac7f9c56fb94$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_APPS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_INDEX:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_APP_MARKETPLACE_DISCOVER));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_INVALID:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_GLOBAL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PERSONAL_SETTINGS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL:
                path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).APP(match.url.replace(/\/$/, '')));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_PROJECT:
                {
                    const { projectKey: projectKey } = match.params;
                    return [
                        (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS),
                        (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey || '')
                    ];
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT:
                {
                    const { projectKey: projectKey } = query;
                    return [
                        (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS),
                        (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey || '')
                    ];
                }
            default:
                break;
        }
        return path;
    }
    const $55a8ac7f9c56fb94$export$d017a63045c88c47 = {
        routes: $55a8ac7f9c56fb94$export$66b32f6f30eb4b4,
        convert: $55a8ac7f9c56fb94$var$convert
    };
});
parcelRegister("ezq2z", function(module, exports) {
    $parcel$export(module.exports, "assetsConverter", ()=>$bdd6509d07f3cefb$export$6cfeba0849032a84);
    var $65Ltd;
    var $jhS4y;
    const $bdd6509d07f3cefb$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION)
    ]);
    function $bdd6509d07f3cefb$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_SCHEMAS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_SCHEMAS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_REPORTS));
                break;
            default:
                break;
        }
        return path;
    }
    const $bdd6509d07f3cefb$export$6cfeba0849032a84 = {
        routes: $bdd6509d07f3cefb$var$routes,
        convert: $bdd6509d07f3cefb$var$convert
    };
});
parcelRegister("j3mSh", function(module, exports) {
    $parcel$export(module.exports, "dashboardsConverter", ()=>$257dabfdf8711aa2$export$6468819b4be328b1);
    var $65Ltd;
    var $jhS4y;
    const $257dabfdf8711aa2$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD)
    ]);
    function $257dabfdf8711aa2$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD:
                query.dashboardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).DASHBOARD(query.dashboardId));
                break;
            default:
                {
                    const dashboardId = match.params.dashboardId;
                    if (dashboardId === 'last-visited') path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS_VIEW_ALL));
                    else dashboardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).DASHBOARD(dashboardId));
                    break;
                }
        }
        return path;
    }
    const $257dabfdf8711aa2$export$6468819b4be328b1 = {
        routes: $257dabfdf8711aa2$var$routes,
        convert: $257dabfdf8711aa2$var$convert
    };
});
parcelRegister("1RoZ2", function(module, exports) {
    $parcel$export(module.exports, "filtersConverter", ()=>$c2ae3b230f933dc6$export$6e91331b5debb7c8);
    var $65Ltd;
    var $jhS4y;
    const $c2ae3b230f933dc6$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS)
    ]);
    function $c2ae3b230f933dc6$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { query: query, match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE:
                {
                    const filterId = query.filter || query.filterId;
                    if (filterId) path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).FILTER(filterId));
                    else if (match.params?.issueKey) {
                        const [projectKey] = (match.params?.issueKey || '').split('-');
                        return [
                            (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS),
                            (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey)
                        ];
                    }
                    break;
                }
            default:
                {
                    const filterId = query.filter || query.filterId;
                    if (filterId === undefined) path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS_SEARCH));
                    else path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).FILTER(filterId));
                    break;
                }
        }
        return path;
    }
    const $c2ae3b230f933dc6$export$6e91331b5debb7c8 = {
        routes: $c2ae3b230f933dc6$var$routes,
        convert: $c2ae3b230f933dc6$var$convert
    };
});
parcelRegister("hdJn1", function(module, exports) {
    $parcel$export(module.exports, "operationsConverter", ()=>$9b181cf5d70a46b3$export$7fc92455d5020e1);
    var $65Ltd;
    var $jhS4y;
    const $9b181cf5d70a46b3$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_AUTOMATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_CUSTOM_ROLES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_HEARTBEATS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_MAINTENANCE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_PERMISSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_TEAM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_SCHEDULES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_POLICIES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_WHO_IS_ON_CALL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ESCALATIONS)
    ]);
    function $9b181cf5d70a46b3$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_WHO_IS_ON_CALL:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_ON_CALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL:
                {
                    path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_ALERTS));
                    const { query: alarmQueue = '', view: view } = query;
                    view && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).ALARM_QUEUE(alarmQueue));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_REPORTS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_AUTOMATIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_HEARTBEATS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_MAINTENANCE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_PERMISSIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL_REDIRECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_TEAM:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_SCHEDULES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_POLICIES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_OVERVIEW));
                break;
            default:
                break;
        }
        return path;
    }
    const $9b181cf5d70a46b3$export$7fc92455d5020e1 = {
        routes: $9b181cf5d70a46b3$var$routes,
        convert: $9b181cf5d70a46b3$var$convert
    };
});
parcelRegister("2m3Yb", function(module, exports) {
    $parcel$export(module.exports, "topLevelConverter", ()=>$c60c27b55fbcd9c5$export$a33f2d74a674bf8a);
    var $65Ltd;
    var $jhS4y;
    const $c60c27b55fbcd9c5$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PEOPLE_INDEX)
    ]);
    function $c60c27b55fbcd9c5$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_YOUR_WORK));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PEOPLE_INDEX:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_TEAMS));
                break;
            default:
        }
        return path;
    }
    const $c60c27b55fbcd9c5$export$a33f2d74a674bf8a = {
        routes: $c60c27b55fbcd9c5$var$routes,
        convert: $c60c27b55fbcd9c5$var$convert
    };
});
parcelRegister("3weqe", function(module, exports) {
    $parcel$export(module.exports, "overviewsConverter", ()=>$b8a10fc0a37e731b$export$5469f6c6536ca9c5);
    var $65Ltd;
    var $jhS4y;
    const $b8a10fc0a37e731b$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE)
    ]);
    function $b8a10fc0a37e731b$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS)
        ];
        routeName;
        {
            const { overviewId: overviewId } = match.params;
            overviewId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).OVERVIEW(overviewId));
        }
        return path;
    }
    const $b8a10fc0a37e731b$export$5469f6c6536ca9c5 = {
        routes: $b8a10fc0a37e731b$var$routes,
        convert: $b8a10fc0a37e731b$var$convert
    };
});
parcelRegister("c6hlO", function(module, exports) {
    $parcel$export(module.exports, "plansConverter", ()=>$a783e1b6f52291a3$export$3bde637b58016d1);
    var $65Ltd;
    var $jhS4y;
    const $a783e1b6f52291a3$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLANS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_RELEASES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TEAMS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK)
    ]);
    function $a783e1b6f52291a3$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLANS_DIRECTORY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK:
                break;
            default:
                {
                    const { planId: planId } = match.params;
                    planId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PLAN(planId));
                }
        }
        return path;
    }
    const $a783e1b6f52291a3$export$3bde637b58016d1 = {
        routes: $a783e1b6f52291a3$var$routes,
        convert: $a783e1b6f52291a3$var$convert
    };
});
parcelRegister("3lNyZ", function(module, exports) {
    $parcel$export(module.exports, "projectsConverter", ()=>$6eaade1a69d23d1d$export$c41b724886e5872b);
    var $65Ltd;
    var $jhS4y;
    const $6eaade1a69d23d1d$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_ALL_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_COMPONENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_NOT_FOUND),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_VERSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_IDEAS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_ONBOARDING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_EMBED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC_EMBED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_LANDING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SETUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_NOTIFICATION_LOGS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_NEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED)
    ]);
    function $6eaade1a69d23d1d$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_ONBOARDING:
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE:
                {
                    const { projectKey: projectKey, appId: appId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECT_APPS));
                    appId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).APP(appId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_LANDING:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SETUP:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_NOTIFICATION_LOGS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_SUMMARY(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS:
                {
                    const { projectKey: projectKey, boardId: boardId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_VIEWS(projectKey));
                    boardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).BOARD(boardId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_VIEWS(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_CALENDAR(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_REPORTS(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES:
                {
                    const { projectKey: projectKey } = match.params;
                    const filterId = query.filter || query.filterId;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    if (projectKey && filterId) {
                        path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_FILTERS(projectKey));
                        path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                    }
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW:
                {
                    const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && practiceType && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                    queueId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).QUEUE(queueId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_NEW:
                {
                    const { projectKey: projectKey, queueId: queueId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_QUEUES(projectKey));
                    queueId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).QUEUE(queueId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_SERVICES(projectKey));
                    break;
                }
            default:
                {
                    const { projectKey: projectKey, boardId: boardId, formId: formId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    boardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).BOARD(boardId));
                    formId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).FORM(formId));
                }
        }
        return path;
    }
    const $6eaade1a69d23d1d$export$c41b724886e5872b = {
        routes: $6eaade1a69d23d1d$var$routes,
        convert: $6eaade1a69d23d1d$var$convert
    };
});
parcelRegister("8bXrC", function(module, exports) {
    $parcel$export(module.exports, "roadmapsConverter", ()=>$8c39d6aa787bb969$export$5761942b1e0c2dd0);
    var $65Ltd;
    var $jhS4y;
    const $8c39d6aa787bb969$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_COLLECTIONS)
    ]);
    function $8c39d6aa787bb969$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_COLLECTIONS:
                {
                    const collectionId = match.params.collectionUUID;
                    if (collectionId) path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).ROADMAP(collectionId));
                    else path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS_VIEW_ALL));
                    break;
                }
            default:
        }
        return path;
    }
    const $8c39d6aa787bb969$export$5761942b1e0c2dd0 = {
        routes: $8c39d6aa787bb969$var$routes,
        convert: $8c39d6aa787bb969$var$convert
    };
});
parcelRegister("eReVn", function(module, exports) {
    $parcel$export(module.exports, "serviceManagementProjectSettingsConverter", ()=>$59806d8088c642c3$export$dd307ede503fe0e);
    var $65Ltd;
    var $7HDop;
    var $9ujoJ;
    var $buwAo;
    var $knvrl;
    var $1upsT;
    var $cARMJ;
    var $hXPqO;
    var $hj1rS;
    var $6QV1R;
    var $c7Cuy;
    var $fCKoM;
    var $k3pgS;
    var $5AlVM;
    var $e9ygf;
    var $bHuHZ;
    var $hllBd;
    var $kEqE6;
    var $6MVjO;
    var $5lhuE;
    var $6pNsO;
    var $iMriO;
    var $f8kSl;
    var $6oHQj;
    var $dDinN;
    var $hjrxI;
    var $gIHTV;
    var $jol6L;
    var $9sAYT;
    var $jJkuR;
    var $kuaoc;
    var $ieCBx;
    var $6t7hJ;
    var $f4T09;
    var $jpwsu;
    var $hewRX;
    var $k3the;
    var $jZoZG;
    var $j1kdz;
    var $jhS4y;
    const $59806d8088c642c3$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
        (0, (0, parcelRequire("knvrl")).routeGroupsProjectSettingsLegacyAutomationRoute).name,
        (0, (0, parcelRequire("1upsT")).routeGroupsProjectSettingsServicedeskAccessRoute).name,
        (0, (0, parcelRequire("6QV1R")).routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
        (0, (0, parcelRequire("e9ygf")).routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name,
        (0, (0, parcelRequire("kEqE6")).routeGroupsProjectSettingsServicedeskFeedbackRoute).name,
        (0, (0, parcelRequire("6MVjO")).routeGroupsProjectSettingsServicedeskFieldsRoute).name,
        (0, (0, parcelRequire("dDinN")).routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name,
        (0, (0, parcelRequire("hjrxI")).routeGroupsProjectSettingsServicedeskRequestTypesWorkCategoryRoute).name,
        (0, (0, parcelRequire("k3pgS")).routeGroupsProjectSettingsServicedeskChatRoute).name,
        (0, (0, parcelRequire("bHuHZ")).routeGroupsProjectSettingsServicedeskEmailRoute).name,
        (0, (0, parcelRequire("hllBd")).routeGroupsProjectSettingsServicedeskExternalLinksRoute).name,
        (0, (0, parcelRequire("6oHQj")).routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name,
        (0, (0, parcelRequire("gIHTV")).routeGroupsProjectSettingsServicedeskWidgetRoute).name,
        (0, (0, parcelRequire("hXPqO")).routeGroupsProjectSettingsServicedeskChangeManagementRoute).name,
        (0, (0, parcelRequire("5lhuE")).routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name,
        (0, (0, parcelRequire("5AlVM")).routeGroupsProjectSettingsServicedeskClassicAppsRoute).name,
        (0, (0, parcelRequire("jol6L")).routeGroupsProjectSettingsVirtualAgentSettingsRoute).name,
        (0, (0, parcelRequire("hj1rS")).routeGroupsProjectSettingsServicedeskChannelsChatRoute).name,
        (0, (0, parcelRequire("fCKoM")).routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name,
        (0, (0, parcelRequire("9sAYT")).virtualAgentConversationsRoute).name,
        (0, (0, parcelRequire("jJkuR")).virtualAgentIntentsRoute).name,
        (0, (0, parcelRequire("kuaoc")).virtualAgentSettingsRoute).name,
        (0, (0, parcelRequire("ieCBx")).virtualAgentStandardFlowsRoute).name,
        (0, (0, parcelRequire("9ujoJ")).projectSettingsServicedeskNotificationsEmailRoute).name,
        (0, (0, parcelRequire("buwAo")).projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
        (0, (0, parcelRequire("f8kSl")).routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
        (0, (0, parcelRequire("cARMJ")).routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name,
        (0, (0, parcelRequire("6t7hJ")).routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name,
        (0, (0, parcelRequire("f4T09")).routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
        (0, (0, parcelRequire("jpwsu")).routeGroupsProjectSettingsServicedeskKbRoute).name,
        (0, (0, parcelRequire("k3the")).routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name,
        (0, (0, parcelRequire("jZoZG")).routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
        (0, (0, parcelRequire("j1kdz")).routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name,
        (0, (0, parcelRequire("iMriO")).routeGroupsProjectSettingsServicedeskIssuetypesRoute).name,
        (0, (0, parcelRequire("c7Cuy")).routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name,
        (0, (0, parcelRequire("7HDop")).projectSettingsServicedeskAutomationRoute).name,
        (0, (0, parcelRequire("hewRX")).servicedeskSlaSettingsRoute).name,
        (0, (0, parcelRequire("6pNsO")).routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name
    ]);
    function $59806d8088c642c3$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE:
            case (0, (0, parcelRequire("1upsT")).routeGroupsProjectSettingsServicedeskAccessRoute).name:
            case (0, (0, parcelRequire("e9ygf")).routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name:
            case (0, (0, parcelRequire("6QV1R")).routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_ACCESS));
                break;
            case (0, (0, parcelRequire("hjrxI")).routeGroupsProjectSettingsServicedeskRequestTypesWorkCategoryRoute).name:
            case (0, (0, parcelRequire("jZoZG")).routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
                break;
            case (0, (0, parcelRequire("k3the")).routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name:
            case (0, (0, parcelRequire("dDinN")).routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS:
            case (0, (0, parcelRequire("j1kdz")).routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS:
            case (0, (0, parcelRequire("hewRX")).servicedeskSlaSettingsRoute).name:
            case (0, (0, parcelRequire("kEqE6")).routeGroupsProjectSettingsServicedeskFeedbackRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES:
            case (0, (0, parcelRequire("iMriO")).routeGroupsProjectSettingsServicedeskIssuetypesRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS:
            case (0, (0, parcelRequire("6MVjO")).routeGroupsProjectSettingsServicedeskFieldsRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION:
            case (0, (0, parcelRequire("knvrl")).routeGroupsProjectSettingsLegacyAutomationRoute).name:
            case (0, (0, parcelRequire("7HDop")).projectSettingsServicedeskAutomationRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_AUTOMATION));
                break;
            case (0, (0, parcelRequire("6oHQj")).routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name:
            case (0, (0, parcelRequire("c7Cuy")).routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name:
            case (0, (0, parcelRequire("bHuHZ")).routeGroupsProjectSettingsServicedeskEmailRoute).name:
            case (0, (0, parcelRequire("k3pgS")).routeGroupsProjectSettingsServicedeskChatRoute).name:
            case (0, (0, parcelRequire("gIHTV")).routeGroupsProjectSettingsServicedeskWidgetRoute).name:
            case (0, (0, parcelRequire("jpwsu")).routeGroupsProjectSettingsServicedeskKbRoute).name:
            case (0, (0, parcelRequire("hllBd")).routeGroupsProjectSettingsServicedeskExternalLinksRoute).name:
            case (0, (0, parcelRequire("hj1rS")).routeGroupsProjectSettingsServicedeskChannelsChatRoute).name:
            case (0, (0, parcelRequire("fCKoM")).routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name:
            case (0, (0, parcelRequire("jol6L")).routeGroupsProjectSettingsVirtualAgentSettingsRoute).name:
            case (0, (0, parcelRequire("jJkuR")).virtualAgentIntentsRoute).name:
            case (0, (0, parcelRequire("ieCBx")).virtualAgentStandardFlowsRoute).name:
            case (0, (0, parcelRequire("9sAYT")).virtualAgentConversationsRoute).name:
            case (0, (0, parcelRequire("kuaoc")).virtualAgentSettingsRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
                break;
            case (0, (0, parcelRequire("hXPqO")).routeGroupsProjectSettingsServicedeskChangeManagementRoute).name:
            case (0, (0, parcelRequire("5lhuE")).routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_OPERATIONS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS:
            case (0, (0, parcelRequire("6t7hJ")).routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name:
            case (0, (0, parcelRequire("f8kSl")).routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
            case (0, (0, parcelRequire("f4T09")).routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
            case (0, (0, parcelRequire("9ujoJ")).projectSettingsServicedeskNotificationsEmailRoute).name:
            case (0, (0, parcelRequire("buwAo")).projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
            case (0, (0, parcelRequire("6pNsO")).routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_NOTIFICATIONS));
                break;
            case (0, (0, parcelRequire("5AlVM")).routeGroupsProjectSettingsServicedeskClassicAppsRoute).name:
            case (0, (0, parcelRequire("cARMJ")).routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_APPS));
                break;
            default:
                break;
        }
        return path;
    }
    const $59806d8088c642c3$export$dd307ede503fe0e = {
        routes: $59806d8088c642c3$var$routes,
        convert: $59806d8088c642c3$var$convert
    };
});
parcelRegister("7HDop", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", ()=>$a850596cfe5a4de7$export$1a2228d5e07202a0);
    var $65Ltd;
    var $fFv0O;
    const $a850596cfe5a4de7$export$1a2228d5e07202a0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/automate`
    };
});
parcelRegister("fFv0O", function(module, exports) {
    $parcel$export(module.exports, "getJsmProjectSettingsUrl", ()=>$b31415be17178b2c$export$b7cec47cdf9c76f1);
    $parcel$export(module.exports, "jsmProjectSettingsUrl", ()=>$b31415be17178b2c$export$c629540cad20d48);
    const $b31415be17178b2c$export$5575497f0592ee94 = 'servicedesk';
    const $b31415be17178b2c$export$b7cec47cdf9c76f1 = (projectKey)=>`/jira/${$b31415be17178b2c$export$5575497f0592ee94}/projects/${projectKey || ':projectKey'}/settings`;
    const $b31415be17178b2c$export$c629540cad20d48 = $b31415be17178b2c$export$b7cec47cdf9c76f1();
});
parcelRegister("9ujoJ", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", ()=>$0bae5d3040b6efcd$export$1f37a1aff4f594af);
    var $65Ltd;
    var $fFv0O;
    const $0bae5d3040b6efcd$export$1f37a1aff4f594af = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/notification-email`,
        exact: true
    };
});
parcelRegister("buwAo", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", ()=>$a41537dc6d61dc3d$export$40539cb16771014e);
    var $65Ltd;
    var $fFv0O;
    const $a41537dc6d61dc3d$export$40539cb16771014e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/notifications/notification-email`,
        exact: true
    };
});
parcelRegister("knvrl", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsLegacyAutomationRoute", ()=>$2e8d72e888be5e69$export$abc6508b4dce2d9b);
    var $65Ltd;
    var $fFv0O;
    const $2e8d72e888be5e69$export$abc6508b4dce2d9b = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/automation`,
        exact: true
    };
});
parcelRegister("1upsT", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRoute", ()=>$d1b7cbe53df6cfdd$export$f7e149bf217bbb2c);
    var $65Ltd;
    var $fFv0O;
    const $d1b7cbe53df6cfdd$export$f7e149bf217bbb2c = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-access`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/access`,
        exact: true
    };
});
parcelRegister("cARMJ", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAppsFieldsRoute", ()=>$bd3d99d74534c3dc$export$e382068c2b8a7b9f);
    var $65Ltd;
    var $fFv0O;
    const $bd3d99d74534c3dc$export$e382068c2b8a7b9f = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-apps-fields`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/apps/app-fields`,
        exact: true
    };
});
parcelRegister("hXPqO", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChangeManagementRoute", ()=>$4f076959804fd438$export$10089d339d8e30d1);
    var $65Ltd;
    var $fFv0O;
    const $4f076959804fd438$export$10089d339d8e30d1 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-change-management`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/change-management`,
        exact: true
    };
});
parcelRegister("hj1rS", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsChatRoute", ()=>$4341c271b95d7fc4$export$8e2543080acfc7c2);
    var $65Ltd;
    var $fFv0O;
    const $4341c271b95d7fc4$export$8e2543080acfc7c2 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-chat`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/channels/chat`,
        exact: true
    };
});
parcelRegister("6QV1R", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute", ()=>$a451b0b54b384e55$export$e184fa302b6981b6);
    var $65Ltd;
    var $fFv0O;
    const $a451b0b54b384e55$export$e184fa302b6981b6 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-permissions-next-gen`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/channels/customer-permissions`,
        exact: true
    };
});
parcelRegister("c7Cuy", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPortalRoute", ()=>$a85341672714267c$export$394d5ca6ce9e5949);
    var $65Ltd;
    var $fFv0O;
    const $a85341672714267c$export$394d5ca6ce9e5949 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-portal`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/channels/portal-settings`,
        exact: true
    };
});
parcelRegister("fCKoM", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsWidgetRoute", ()=>$f0656f46d1b254a7$export$fe54e02c94ff5613);
    var $65Ltd;
    var $fFv0O;
    const $f0656f46d1b254a7$export$fe54e02c94ff5613 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-widget`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/channels/widget`,
        exact: true
    };
});
parcelRegister("k3pgS", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChatRoute", ()=>$50fc73683d1ea5cf$export$3a3e70b8651d8d57);
    var $65Ltd;
    var $fFv0O;
    const $50fc73683d1ea5cf$export$3a3e70b8651d8d57 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/chat`,
        exact: true
    };
});
parcelRegister("5AlVM", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskClassicAppsRoute", ()=>$bc33d5c523e4a706$export$3ab501c22b91462b);
    var $65Ltd;
    var $fFv0O;
    const $bc33d5c523e4a706$export$3ab501c22b91462b = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-classic-apps`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/apps`,
        exact: true
    };
});
parcelRegister("e9ygf", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute", ()=>$cbb732a2fe1a233f$export$dd22cfc45fe86c35);
    var $65Ltd;
    var $fFv0O;
    const $cbb732a2fe1a233f$export$dd22cfc45fe86c35 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/customer-permissions`,
        exact: true
    };
});
parcelRegister("bHuHZ", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskEmailRoute", ()=>$370b0a2ea8de3100$export$d29fa1140db9296d);
    var $65Ltd;
    var $fFv0O;
    const $370b0a2ea8de3100$export$d29fa1140db9296d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/email`,
        exact: true
    };
});
parcelRegister("hllBd", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskExternalLinksRoute", ()=>$89b8c48cda692359$export$d0198d2da30de212);
    var $65Ltd;
    var $fFv0O;
    const $89b8c48cda692359$export$d0198d2da30de212 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-external-links`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/external-links`,
        exact: true
    };
});
parcelRegister("kEqE6", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFeedbackRoute", ()=>$637247174e022f86$export$cd46cad965f517e2);
    var $65Ltd;
    var $fFv0O;
    const $637247174e022f86$export$cd46cad965f517e2 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-feedback`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/feedback-settings`
    };
});
parcelRegister("6MVjO", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFieldsRoute", ()=>$9a67d1911e679919$export$87914ccacd42ab35);
    var $65Ltd;
    var $fFv0O;
    const $9a67d1911e679919$export$87914ccacd42ab35 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-fields`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/fields`,
        exact: true
    };
});
parcelRegister("5lhuE", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIncidentManagementRoute", ()=>$0126764fb1c62a7a$export$ff20eaee6cf19401);
    var $65Ltd;
    var $fFv0O;
    const $0126764fb1c62a7a$export$ff20eaee6cf19401 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-incident-management`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/incident-management`,
        exact: true
    };
});
parcelRegister("6pNsO", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute", ()=>$1f8f0e8b1243d49b$export$4ef3eecacde57780);
    var $65Ltd;
    var $fFv0O;
    const $1f8f0e8b1243d49b$export$4ef3eecacde57780 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/internal-notifications`
    };
});
parcelRegister("iMriO", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesRoute", ()=>$4f8fe6be3c4832c3$export$666cdeccf1f430a6);
    var $65Ltd;
    var $fFv0O;
    const $4f8fe6be3c4832c3$export$666cdeccf1f430a6 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/issuetypes/:issueTypeId?`,
        exact: true
    };
});
parcelRegister("f8kSl", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute", ()=>$e9c423a6409f74f5$export$e6f711e47860f891);
    var $65Ltd;
    var $fFv0O;
    const $e9c423a6409f74f5$export$e6f711e47860f891 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-internal-notifications`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/notifications/internal-notifications`
    };
});
parcelRegister("6oHQj", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskPortalSettingsRoute", ()=>$ba2f5c799cade0df$export$e856498dc02e46e8);
    var $65Ltd;
    var $fFv0O;
    const $ba2f5c799cade0df$export$e856498dc02e46e8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/portal-settings/:subPath(portal-groups)?`,
        exact: true
    };
});
parcelRegister("dDinN", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute", ()=>$8d02cc755c143227$export$f919d82b98f9257a);
    var $65Ltd;
    var $fFv0O;
    const $8d02cc755c143227$export$f919d82b98f9257a = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-proforma-project-forms`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/forms`,
        exact: true
    };
});
parcelRegister("hjrxI", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskRequestTypesWorkCategoryRoute", ()=>$019b6d280449a542$export$16e1aef7db297100);
    var $65Ltd;
    var $fFv0O;
    const $019b6d280449a542$export$16e1aef7db297100 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-request-types-work-category`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/request-types/category/:practice`,
        exact: true
    };
});
parcelRegister("gIHTV", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskWidgetRoute", ()=>$dcd5265395e9ce2e$export$164572fb58075291);
    var $65Ltd;
    var $fFv0O;
    const $dcd5265395e9ce2e$export$164572fb58075291 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/widget`,
        exact: true
    };
});
parcelRegister("jol6L", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsVirtualAgentSettingsRoute", ()=>$0b7f80951fa212fe$export$680ccfe6e5af63a8);
    var $65Ltd;
    var $fFv0O;
    const $0b7f80951fa212fe$export$680ccfe6e5af63a8 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/virtual-agent`,
        exact: true
    };
});
parcelRegister("9sAYT", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentConversationsRoute", ()=>$411142b46ae04f14$export$837f003bb6f40f9);
    var $65Ltd;
    var $fFv0O;
    const $411142b46ae04f14$export$837f003bb6f40f9 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-conversations`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/virtual-agent/conversations`,
        exact: true
    };
});
parcelRegister("jJkuR", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentIntentsRoute", ()=>$0338de7d8107d11d$export$1e70273fc2a407f5);
    var $65Ltd;
    var $fFv0O;
    const $0338de7d8107d11d$export$1e70273fc2a407f5 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-intents`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/virtual-agent/intents`,
        exact: true
    };
});
parcelRegister("kuaoc", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentSettingsRoute", ()=>$bc551cda135ca5dc$export$80422a49e17dfd6b);
    var $65Ltd;
    var $fFv0O;
    const $bc551cda135ca5dc$export$80422a49e17dfd6b = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-settings`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/virtual-agent/settings`,
        exact: true
    };
});
parcelRegister("ieCBx", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentStandardFlowsRoute", ()=>$b2e651b968a46995$export$f45c942ecfcc5682);
    var $65Ltd;
    var $fFv0O;
    const $b2e651b968a46995$export$f45c942ecfcc5682 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-standard-flows`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/virtual-agent/standard-flows`,
        exact: true
    };
});
parcelRegister("6t7hJ", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute", ()=>$b044870715f195c9$export$7fc567ce6cdc6b52);
    var $65Ltd;
    var $7h0Ka;
    const $b044870715f195c9$export$7fc567ce6cdc6b52 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS),
        path: `${(0, (0, parcelRequire("7h0Ka")).projectSettingsUrl)((0, (0, parcelRequire("7h0Ka")).SERVICE_DESK_PRODUCT))}/customer-notifications`
    };
});
parcelRegister("7h0Ka", function(module, exports) {
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$31520c4854f633ad$export$5575497f0592ee94);
    $parcel$export(module.exports, "projectSettingsUrl", ()=>$31520c4854f633ad$export$5132c64eefe46250);
    const $31520c4854f633ad$export$5575497f0592ee94 = 'servicedesk';
    const $31520c4854f633ad$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
});
parcelRegister("f4T09", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute", ()=>$088e43233c871db8$export$688d2c8abd7b3661);
    var $65Ltd;
    var $7h0Ka;
    const $088e43233c871db8$export$688d2c8abd7b3661 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-customer-notifications`,
        path: `${(0, (0, parcelRequire("7h0Ka")).projectSettingsUrl)((0, (0, parcelRequire("7h0Ka")).SERVICE_DESK_PRODUCT))}/notifications/customer-notifications`
    };
});
parcelRegister("jpwsu", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskKbRoute", ()=>$c6a2b8c452ec83e7$export$8855316927afaed1);
    var $65Ltd;
    var $kJto6;
    const $c6a2b8c452ec83e7$export$8855316927afaed1 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-kb`,
        path: `${(0, (0, parcelRequire("kJto6")).projectSettingsUrl)((0, (0, parcelRequire("kJto6")).SERVICE_DESK_PRODUCT))}/confluence-kb`,
        exact: true
    };
});
parcelRegister("kJto6", function(module, exports) {
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$dc6b55290d887514$export$5575497f0592ee94);
    $parcel$export(module.exports, "projectSettingsUrl", ()=>$dc6b55290d887514$export$5132c64eefe46250);
    const $dc6b55290d887514$export$5575497f0592ee94 = 'servicedesk';
    const $dc6b55290d887514$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
});
parcelRegister("hewRX", function(module, exports) {
    $parcel$export(module.exports, "servicedeskSlaSettingsRoute", ()=>$e50829694a27cbc2$export$bfbf66468910573e);
    var $65Ltd;
    const $e50829694a27cbc2$export$bfbf66468910573e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
        path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
    };
});
parcelRegister("k3the", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute", ()=>$92bd89e52eb8855f$export$1eebd582a7db1c90);
    var $65Ltd;
    const $92bd89e52eb8855f$export$1eebd582a7db1c90 = {
        exact: true,
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-ticket-types-config`,
        path: `/jira/${(0, $c537a1906485aaa6$export$5575497f0592ee94)}/projects/:projectKey/settings/request-types`
    };
});
const $c537a1906485aaa6$export$5575497f0592ee94 = 'servicedesk';
parcelRegister("jZoZG", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute", ()=>$5ac461fd134ed29c$export$cd0f363eecbc2379);
    var $65Ltd;
    const $5ac461fd134ed29c$export$cd0f363eecbc2379 = {
        exact: true,
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-unassigned-ticket-types-config`,
        path: `/jira/${(0, $c537a1906485aaa6$export$5575497f0592ee94)}/projects/:projectKey/settings/request-types/unassigned`
    };
});
parcelRegister("j1kdz", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsWorkflowSchemeConfigRoute", ()=>$ab54ce032aaceb6d$export$ad30542ae2fd7196);
    var $65Ltd;
    const $ab54ce032aaceb6d$export$ad30542ae2fd7196 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-workflow-scheme-config`,
        path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
        exact: true
    };
});
parcelRegister("fMcVX", function(module, exports) {
    $parcel$export(module.exports, "isSelectedPath", ()=>$ad785f9726254880$export$cdcd6885320eec31);
    var $lhMtU;
    function $ad785f9726254880$export$cdcd6885320eec31(path, ...args) {
        const next = (menuId)=>{
            return (0, (0, parcelRequire("lhMtU")).isMenuIdList)(menuId) ? (0, (0, parcelRequire("lhMtU")).toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
        };
        if (args.length === 0) return next;
        return next(args[0]);
    }
});
parcelRegister("lhMtU", function(module, exports) {
    $parcel$export(module.exports, "toMenuIdFromMenuIdList", ()=>$dc9d941dfadd4b5a$export$253323efd0c41e72);
    $parcel$export(module.exports, "isMenuIdList", ()=>$dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed);
    $parcel$export(module.exports, "toMenuIdList", ()=>$dc9d941dfadd4b5a$export$d8e017f58178e379);
    const $dc9d941dfadd4b5a$var$MENU_ID_DELIM = '   ';
    function $dc9d941dfadd4b5a$export$253323efd0c41e72(menuIds) {
        return menuIds.join($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
    }
    function $dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
        return maybeMenuIdList.indexOf($dc9d941dfadd4b5a$var$MENU_ID_DELIM) !== -1;
    }
    function $dc9d941dfadd4b5a$export$d8e017f58178e379(menuIdList) {
        return menuIdList.split($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
    }
});
parcelRegister("ao2h1", function(module, exports) {
    $parcel$export(module.exports, "RELAY_RESOURCE_TYPE", ()=>$5f6ac21695ec30bb$export$c6c8c12c0f1d8e54);
    $parcel$export(module.exports, "createRelayResource", ()=>$5f6ac21695ec30bb$export$1cc887c62079ea32);
    $parcel$export(module.exports, "useRelayResource", ()=>$5f6ac21695ec30bb$export$42ca7b248c7aaee);
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $x9xyg;
    var $4R6GH;
    var $5yJb9;
    var $5a0Nh;
    var $kipqU;
    var $2M1hQ;
    var $2YP9W;
    var $5Wobd;
    const $5f6ac21695ec30bb$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
    const $5f6ac21695ec30bb$var$getDataOld = async ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
        const measureName = `relay_resource_get_data:${type}`;
        const startMark = `relay_resource_get_data:${type}:start`;
        const endMark = `relay_resource_get_data:${type}:end`;
        (0, (0, parcelRequire("x9xyg")).setMark)(startMark);
        const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
        const query = parameters ?? await loadParameters?.();
        const queryReference = (0, (0, parcelRequire("x9xyg")).measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), query, variables || {}, options));
        if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
        if (queryReference.id != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id)?.then(()=>{
            (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
            (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
        });
        if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
        if (captureTraceIds) (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(queryReference.name);
        return queryReference;
    };
    const $5f6ac21695ec30bb$var$getDataNew = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
        const measureName = `relay_resource_get_data:${type}`;
        const startMark = `relay_resource_get_data:${type}:start`;
        const endMark = `relay_resource_get_data:${type}:end`;
        (0, (0, parcelRequire("x9xyg")).setMark)(startMark);
        const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
        const queryReference = (0, (0, parcelRequire("x9xyg")).measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), parameters, variables || {}, options));
        if (false && queryReference.id != null) {
            const promise = (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            if (promise) return promise.then(()=>{
                (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
                (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
                if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
                if (captureTraceIds) (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(queryReference.name);
                return queryReference;
            });
        }
        if (queryReference.id != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id)?.then(()=>{
            (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
            (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
        });
        if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
        if (captureTraceIds) (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(queryReference.name);
        return queryReference;
    };
    const $5f6ac21695ec30bb$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: `${$5f6ac21695ec30bb$export$c6c8c12c0f1d8e54}_${type}`,
            getKey: (routerContext, customContext)=>{
                const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
                if (!preloadableRequest) return JSON.stringify(variables || {});
                let queryId;
                let params;
                if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                    const preloadableConcreteRequest = preloadableRequest;
                    ({ params: params } = preloadableConcreteRequest);
                    ({ id: queryId } = params);
                } else {
                    const graphQlTaggedNode = preloadableRequest;
                    const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                    params = request.params;
                    queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
                }
                return `${String(queryId)}${JSON.stringify(variables || {})}`;
            },
            getData: (routerContext, customContext)=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('blu-3813-improve-ssr-hydration-of-relay')) return $5f6ac21695ec30bb$var$getDataNew({
                    routerContext: routerContext,
                    customContext: customContext,
                    type: type,
                    getQuery: getQuery,
                    captureErrors: captureErrors,
                    captureTraceIds: captureTraceIds
                });
                return $5f6ac21695ec30bb$var$getDataOld({
                    routerContext: routerContext,
                    customContext: customContext,
                    type: type,
                    loadParameters: loadParameters,
                    getQuery: getQuery,
                    captureErrors: captureErrors,
                    captureTraceIds: captureTraceIds
                });
            },
            maxAge: 0,
            isBrowserOnly: isBrowserOnly
        });
    const $5f6ac21695ec30bb$export$1cc887c62079ea32 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
    const $5f6ac21695ec30bb$export$bbe949b85c06f763 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
    const $5f6ac21695ec30bb$export$42ca7b248c7aaee = (resource, options)=>{
        const { data: queryReference, loading: loading, promise: promise } = (0, (0, parcelRequire("2YP9W")).useResource)(resource);
        if (options?.suspendWhenLoading && loading) throw promise;
        return {
            queryReference: queryReference
        };
    };
});
parcelRegister("2OeZv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70949048397986dd$export$2e2bcd8739ae039);
    const $70949048397986dd$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isAppsExpanded"
        }, v2 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isDashboardsExpanded"
        }, v3 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isFiltersExpanded"
        }, v4 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isOperationsExpanded"
        }, v5 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isOverviewsExpanded"
        }, v6 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isPlansExpanded"
        }, v7 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isProjectsExpanded"
        }, v8 = {
            "kind": "ScalarField",
            "name": "id"
        }, v9 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v10 = [
            v9
        ], v11 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v12 = {
            "kind": "ScalarField",
            "name": "label"
        }, v13 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v14 = {
            "kind": "ScalarField",
            "name": "url"
        }, v15 = {
            "order": "DESC"
        }, v16 = {
            "kind": "Literal",
            "name": "first",
            "value": 15
        }, v17 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v18 = {
            "kind": "ScalarField",
            "name": "name"
        }, v19 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v20 = {
            "kind": "InlineFragment",
            "selections": [
                v8
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v21 = [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ], v22 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v23 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v24 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v11,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8,
                            {
                                "alias": "projectKey",
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectType"
                            },
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "large"
                                    }
                                ]
                            },
                            v18,
                            {
                                "kind": "ScalarField",
                                "name": "projectId"
                            },
                            v19,
                            {
                                "kind": "LinkedField",
                                "name": "defaultNavigationItem",
                                "plural": false,
                                "selections": [
                                    v11,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "typeKey"
                                            }
                                        ],
                                        "type": "JiraNavigationItem",
                                        "abstractKey": "__isJiraNavigationItem"
                                    },
                                    v20
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "navigationMetadata",
                                "plural": false,
                                "selections": [
                                    v11,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "boardId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isSimpleBoard"
                                            },
                                            v8
                                        ],
                                        "type": "JiraSoftwareProjectNavigationMetadata"
                                    }
                                ]
                            },
                            {
                                "alias": "editProjectConfig",
                                "args": v21,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectStyle"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "webUrl"
                            },
                            {
                                "alias": "canEditProjectConfig",
                                "args": v21,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "alias": "canViewProjectConfig",
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "VIEW_PROJECT_CONFIG"
                                    }
                                ],
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                            },
                            v23,
                            {
                                "args": v21,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "softwareBoardCount"
                            }
                        ],
                        "type": "JiraProject"
                    },
                    v20
                ]
            }
        ], v25 = {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }, v26 = {
            "kind": "ScalarField",
            "name": "filterId"
        }, v27 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v28 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                        v11,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v8
                    ]
                }
            ],
            "type": "JiraCustomFilter"
        }, v29 = {
            "kind": "ScalarField",
            "name": "title"
        }, v30 = {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                v19,
                v8
            ]
        }, v31 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v11,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8,
                            {
                                "kind": "ScalarField",
                                "name": "planId"
                            },
                            v29,
                            {
                                "kind": "ScalarField",
                                "name": "isReadOnly"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "planStatus"
                            },
                            v30,
                            {
                                "concreteType": "JiraScenario",
                                "kind": "LinkedField",
                                "name": "scenario",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "scenarioId"
                                    },
                                    v8
                                ]
                            }
                        ],
                        "type": "JiraPlan"
                    },
                    v20
                ]
            }
        ], v32 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v11,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8,
                            {
                                "kind": "ScalarField",
                                "name": "dashboardId"
                            },
                            v29,
                            v30
                        ],
                        "type": "JiraDashboard"
                    },
                    v20
                ]
            }
        ], v33 = [
            v8,
            v18,
            {
                "kind": "ScalarField",
                "name": "alertSearchQuery"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7
                ],
                "kind": "Fragment",
                "name": "L1MenuItemsQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "ConfigurableMenuItems"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v6,
                    v7,
                    v4,
                    v5
                ],
                "kind": "Operation",
                "name": "L1MenuItemsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudID",
                                        "variableName": "cloudId"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "navKey",
                                        "value": "NAV_SIDEBAR"
                                    }
                                ],
                                "concreteType": "JiraUserNavigationConfiguration",
                                "kind": "LinkedField",
                                "name": "userNavigationConfiguration",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfigurableNavigationItem",
                                        "kind": "LinkedField",
                                        "name": "navItems",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "menuId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isVisible"
                                            }
                                        ]
                                    },
                                    v8
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "canCreateProject",
                                "args": [
                                    v9,
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "CREATE_PROJECT"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "canPerform"
                            },
                            {
                                "condition": "isAppsExpanded",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": v10,
                                        "concreteType": "JiraNavigationItemConnection",
                                        "kind": "LinkedField",
                                        "name": "globalAppNavigationItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraNavigationItemEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11,
                                                            v8,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v12,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "appId"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "appType"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "envLabel"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "iconUrl"
                                                                    },
                                                                    v13,
                                                                    {
                                                                        "concreteType": "JiraAppSection",
                                                                        "kind": "LinkedField",
                                                                        "name": "sections",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v12,
                                                                            {
                                                                                "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                "kind": "LinkedField",
                                                                                "name": "links",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v12,
                                                                                    v14,
                                                                                    v13
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "settingsUrl"
                                                                    },
                                                                    v14
                                                                ],
                                                                "type": "JiraAppNavigationItem"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v10,
                                "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                "kind": "LinkedField",
                                "name": "jwmOverviews",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "totalCount"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v10,
                                "concreteType": "JiraAdvancedRoadmapsNavigation",
                                "kind": "LinkedField",
                                "name": "advancedRoadmapsNavigation",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasEditPermissions"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasCreateSamplePlanPermissions"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasGlobalPlansAdminPermissions"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isProjectsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouriteProjects",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "includeArchivedProjects": false,
                                                    "sort": v15,
                                                    "type": "PROJECT"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v24
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "recentProjects",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "includeArchivedProjects": false
                                                }
                                            },
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "PROJECT"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v24
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "args": v10,
                                        "concreteType": "JiraWorkManagementLicensing",
                                        "kind": "LinkedField",
                                        "name": "jwmLicensing",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "currentUserSeatEdition"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "GrowthRecQuery",
                                "kind": "LinkedField",
                                "name": "growthRecommendations",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "fields": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "product",
                                                        "value": "jira"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "tenantId",
                                                        "variableName": "cloudId"
                                                    },
                                                    {
                                                        "kind": "Literal",
                                                        "name": "useCase",
                                                        "value": "jiraProjectMenuRecommendations"
                                                    }
                                                ],
                                                "kind": "ObjectValue",
                                                "name": "context"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 2
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "recommendations",
                                        "plural": false,
                                        "selections": [
                                            v11,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "data",
                                                        "plural": true,
                                                        "selections": [
                                                            v11,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "entityId"
                                                                    }
                                                                ],
                                                                "type": "GrowthRecJiraTemplateRecommendation"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "GrowthRecRecommendations"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isFiltersExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouriteFilters",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "FILTER"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v26,
                                                                    v18,
                                                                    v8,
                                                                    v19,
                                                                    v27,
                                                                    v28
                                                                ],
                                                                "type": "JiraFilter",
                                                                "abstractKey": "__isJiraFilter"
                                                            },
                                                            v20
                                                        ]
                                                    }
                                                ]
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "recentFilters",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "FILTER"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v26,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v18,
                                                                            v8,
                                                                            v19,
                                                                            v27,
                                                                            v28
                                                                        ],
                                                                        "type": "JiraFilter",
                                                                        "abstractKey": "__isJiraFilter"
                                                                    }
                                                                ],
                                                                "type": "JiraCustomFilter"
                                                            },
                                                            v20
                                                        ]
                                                    }
                                                ]
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "args": v10,
                                        "concreteType": "JiraSystemFilterConnection",
                                        "kind": "LinkedField",
                                        "name": "systemFilters",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSystemFilterEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraSystemFilter",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v26,
                                                            v8,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v18,
                                                                    v11,
                                                                    v19,
                                                                    v27,
                                                                    v28
                                                                ],
                                                                "type": "JiraFilter",
                                                                "abstractKey": "__isJiraFilter"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isPlansExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouritePlans",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "PLAN"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v31
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "recentPlans",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "PLAN"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v31
                                            },
                                            v23
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isDashboardsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "dashboardFavourites",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "DASHBOARD"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v32
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "dashboardRecents",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "DASHBOARD"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v32
                                            },
                                            v23
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isOperationsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "OpsgenieQuery",
                                "kind": "LinkedField",
                                "name": "opsgenie",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v10,
                                        "concreteType": "OpsgenieSavedSearches",
                                        "kind": "LinkedField",
                                        "name": "savedSearches",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "OpsgenieSavedSearch",
                                                "kind": "LinkedField",
                                                "name": "sharedWithMe",
                                                "plural": true,
                                                "selections": v33
                                            },
                                            {
                                                "concreteType": "OpsgenieSavedSearch",
                                                "kind": "LinkedField",
                                                "name": "createdByMe",
                                                "plural": true,
                                                "selections": v33
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isOverviewsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v10,
                                        "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                        "kind": "LinkedField",
                                        "name": "jwmOverviews",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraWorkManagementGiraOverview",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            v18
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "faa97c300a02a1c211a1d8fb98b94ee77ff42830e6a0ae5e214e0115a18e635a",
                "metadata": {},
                "name": "L1MenuItemsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $70949048397986dd$var$node.hash = "3924b1f11b61ac6cf33dddcea40b965b";
    var $70949048397986dd$export$2e2bcd8739ae039 = $70949048397986dd$var$node;
});
parcelRegister("fZBia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79c8513a288fea00$export$2e2bcd8739ae039);
    const $79c8513a288fea00$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "isLeftSidebarCollapsed"
        }, v3 = {
            "kind": "ScalarField",
            "name": "leftSidebarWidth"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "sidebarSelectorQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v2,
                                            "action": "THROW",
                                            "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v3,
                                            "action": "THROW",
                                            "path": "jira.navigationUIState.leftSidebarWidth"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "sidebarSelectorQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "2b594593303f12c91ba380135535d6cde24ab3377ce6133c443e711b338621c8",
                "metadata": {},
                "name": "sidebarSelectorQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $79c8513a288fea00$var$node.hash = "e5c64c6d4b80524f3da4efcb8ecca3f4";
    var $79c8513a288fea00$export$2e2bcd8739ae039 = $79c8513a288fea00$var$node;
});
parcelRegister("fwzEJ", function(module, exports) {
    $parcel$export(module.exports, "topNav4UIStateResource", ()=>$92bcd9e21d74460f$export$2d81c2e40eea9fba);
    var $ao2h1;
    var $9ZLcT;
    const $92bcd9e21d74460f$export$2d81c2e40eea9fba = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_TOPNAV_UI_STATE_RELAY`,
        getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
                parameters: (0, (0, parcelRequire("9ZLcT")).default),
                variables: {
                    cloudId: cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("9ZLcT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b5c5aa00eda199b$export$2e2bcd8739ae039);
    const $3b5c5aa00eda199b$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "isLeftSidebarCollapsed"
        }, v3 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "AtlaskitAtlassianNavigationNav4UIQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v2,
                                            "action": "THROW",
                                            "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4Profile"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "AtlaskitAtlassianNavigationNav4UIQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "AuthenticationContext",
                        "kind": "LinkedField",
                        "name": "me",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    },
                                    v3
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "a2ee613e496049f542ad423691c1955453d0e307763b1d389f0f5008b024eb83",
                "metadata": {},
                "name": "AtlaskitAtlassianNavigationNav4UIQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $3b5c5aa00eda199b$var$node.hash = "53566dec28c1571bc52a10d224ea82eb";
    var $3b5c5aa00eda199b$export$2e2bcd8739ae039 = $3b5c5aa00eda199b$var$node;
});
parcelRegister("h9iZl", function(module, exports) {
    $parcel$export(module.exports, "navigationPlansVisibilityResource", ()=>$66eb980ebca35ddf$export$fa475a9581133779);
    $parcel$export(module.exports, "useNavigationPlansVisibility", ()=>$66eb980ebca35ddf$export$4524245d4e74edb2);
    $parcel$export(module.exports, "useNavigationViewPlansPermission", ()=>$66eb980ebca35ddf$export$98eef08fd4586a4);
    $parcel$export(module.exports, "useNavigationEditPlansPermission", ()=>$66eb980ebca35ddf$export$525db876ed776e0d);
    $parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", ()=>$66eb980ebca35ddf$export$54805a2120a31ad0);
    var $dJl1T;
    var $7f4tk;
    var $2M1hQ;
    var $2YP9W;
    const $66eb980ebca35ddf$export$fa475a9581133779 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $94526093207618a3$export$9260ddb6dfeafd7b),
        getKey: ()=>'state',
        getData: async (_, { tenantContext: tenantContext })=>{
            try {
                if (tenantContext.isAnonymous) return false;
                const response = await (0, (0, parcelRequire("7f4tk")).default)(`${tenantContext.baseUrl}/rest/jpo/1.0/navigation/simple`);
                return response;
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $94526093207618a3$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
            }
            return false;
        },
        maxAge: Infinity
    });
    const $66eb980ebca35ddf$export$4524245d4e74edb2 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let isVisible = false;
        if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
        return [
            isVisible
        ];
    };
    const $66eb980ebca35ddf$export$98eef08fd4586a4 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let hasEditOrViewPermissions = false;
        if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
        return [
            hasEditOrViewPermissions
        ];
    };
    const $66eb980ebca35ddf$export$525db876ed776e0d = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let canEditPlans = false;
        if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
        return canEditPlans;
    };
    const $66eb980ebca35ddf$export$54805a2120a31ad0 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let isAdvancedRoadmapsTrial = false;
        if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
        return isAdvancedRoadmapsTrial;
    };
});
const $94526093207618a3$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $94526093207618a3$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';
parcelRegister("2eyDn", function(module, exports) {
    $parcel$export(module.exports, "consentBannerUserPreferencesResource", ()=>$7912ae5bd04d670f$export$785c22104b6f2285);
    $parcel$export(module.exports, "useConsentBannerUserPreferencesResource", ()=>$7912ae5bd04d670f$export$5bc7e83e85567fb4);
    var $21KEY;
    var $3TzYp;
    var $4R6GH;
    var $eusud;
    var $2M1hQ;
    var $2YP9W;
    const $7912ae5bd04d670f$export$785c22104b6f2285 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $f92ba51f7e46c4ce$export$c5397b7748ed6c7b),
        getKey: ()=>(0, $f92ba51f7e46c4ce$export$4a9dd42dbc707155),
        getData: async ()=>{
            const consentToken = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("21KEY")).ATLASSIAN_CONSENT_COOKIE_KEY));
            const fallbackConsentToken = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("21KEY")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
            if ((0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-browser-storage-bump-3')) {
                if (consentToken) return {
                    consentToken: consentToken,
                    fallbackConsentToken: fallbackConsentToken
                };
            } else {
                const currentLocale = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("21KEY")).ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY));
                if (consentToken && currentLocale) return {
                    consentToken: consentToken,
                    currentLocale: currentLocale,
                    fallbackConsentToken: fallbackConsentToken
                };
            }
            const data = await (0, (0, parcelRequire("eusud")).performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
            return data;
        },
        maxAge: 900000,
        isBrowserOnly: true
    });
    const $7912ae5bd04d670f$export$5bc7e83e85567fb4 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($7912ae5bd04d670f$export$785c22104b6f2285);
});
parcelRegister("21KEY", function(module, exports) {
    $parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", ()=>$ef0dec1a357b404c$export$10d7db8e1a856fd8);
    $parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", ()=>$ef0dec1a357b404c$export$435de28e5b000487);
    $parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", ()=>$ef0dec1a357b404c$export$4b17acc0e875ba2a);
    $parcel$export(module.exports, "ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY", ()=>$ef0dec1a357b404c$export$f57af01b64fc97b8);
    $parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", ()=>$ef0dec1a357b404c$export$23a1e02c3c0b0d08);
    $parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", ()=>$ef0dec1a357b404c$export$37073d560ecebada);
    $parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", ()=>$ef0dec1a357b404c$export$5dc0026db06844f3);
    $parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", ()=>$ef0dec1a357b404c$export$b28b5d760fe14a21);
    $parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", ()=>$ef0dec1a357b404c$export$4a12f9e99971760a);
    $parcel$export(module.exports, "DEFAULT_PREFERENCES", ()=>$ef0dec1a357b404c$export$f0fd1d13ec1d48f2);
    $parcel$export(module.exports, "V001_SCHEMA_KEY", ()=>$ef0dec1a357b404c$export$f95182b7aa141c57);
    $parcel$export(module.exports, "V002_SCHEMA_KEY", ()=>$ef0dec1a357b404c$export$1f25427b34f9c405);
    $parcel$export(module.exports, "V003_SCHEMA_KEY", ()=>$ef0dec1a357b404c$export$31deaeaebce525bb);
    var $8FFpF;
    const $ef0dec1a357b404c$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
    const $ef0dec1a357b404c$export$435de28e5b000487 = 'atl-bsc-consent-token';
    const $ef0dec1a357b404c$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
    const $ef0dec1a357b404c$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
    const $ef0dec1a357b404c$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
    const $ef0dec1a357b404c$export$37073d560ecebada = 'atl-testing-consents';
    const $ef0dec1a357b404c$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
    const $ef0dec1a357b404c$export$b28b5d760fe14a21 = {
        [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).StrictlyNecessary]: true,
        [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Functional]: true,
        [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Marketing]: true,
        [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Analytics]: true,
        [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Unknown]: true
    };
    const $ef0dec1a357b404c$export$4a12f9e99971760a = {
        [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).StrictlyNecessary]: true,
        [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Functional]: false,
        [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Marketing]: false,
        [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Analytics]: false,
        [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Unknown]: false
    };
    const $ef0dec1a357b404c$export$f0fd1d13ec1d48f2 = {
        ...$ef0dec1a357b404c$export$4a12f9e99971760a,
        [(0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).ConsentsAreDefault]: true,
        [(0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).UserIsAuthenticated]: false,
        [(0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).ConsentDataUnavailable]: true
    };
    const $ef0dec1a357b404c$export$f95182b7aa141c57 = '001';
    const $ef0dec1a357b404c$export$1f25427b34f9c405 = '002';
    const $ef0dec1a357b404c$export$31deaeaebce525bb = '003';
});
const $f92ba51f7e46c4ce$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $f92ba51f7e46c4ce$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';
parcelRegister("drGWM", function(module, exports) {
    $parcel$export(module.exports, "checkApiKeyManagementKeysResource", ()=>$ea67ffb8a72e0299$export$b16eaa5246afc9b6);
    var $j74qU;
    var $3H5ry;
    var $2M1hQ;
    const $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, isTransitioning, appPermissions)=>{
        if (!isTransitioning || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
    };
    const $ea67ffb8a72e0299$export$b16eaa5246afc9b6 = ()=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: (0, $9b8f6422d397a375$export$5879151f0d972f18),
            getKey: ()=>'check-api-key-management-keys',
            getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
                const tenantInfo = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734]?.promise;
                const isTransitioning = (0, (0, parcelRequire("3H5ry")).checkIsTransitioning)(tenantInfo);
                return $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, isTransitioning, appPermissions);
            },
            maxAge: Infinity,
            isBrowserOnly: true,
            depends: [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]
        });
});
parcelRegister("3H5ry", function(module, exports) {
    $parcel$export(module.exports, "checkShouldUseJSM", ()=>$bc03080c674ccba2$export$5e0f3a0d8463fa21);
    $parcel$export(module.exports, "checkIsTransitioning", ()=>$bc03080c674ccba2$export$d2f281fd4bf10855);
    $parcel$export(module.exports, "checkIsConsolidated", ()=>$bc03080c674ccba2$export$57f75aebff17dd1e);
    $parcel$export(module.exports, "checkIsTransitioned", ()=>$bc03080c674ccba2$export$b6461b23ee0e1471);
    $parcel$export(module.exports, "checkIsTransitionEligible", ()=>$bc03080c674ccba2$export$24040115cac5fdc3);
    $parcel$export(module.exports, "checkShouldAccessUnlockOperations", ()=>$bc03080c674ccba2$export$cd227238525e8d57);
    $parcel$export(module.exports, "checkIsOpsAdmin", ()=>$bc03080c674ccba2$export$66a96ac2f07f6730);
    var $bgC2H;
    const $bc03080c674ccba2$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo !== (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED : tenantInfo.consolidationState !== (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED;
    };
    const $bc03080c674ccba2$export$d2f281fd4bf10855 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONING : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONING;
    };
    const $bc03080c674ccba2$export$57f75aebff17dd1e = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, (0, parcelRequire("bgC2H")).ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).CONSOLIDATED;
    };
    const $bc03080c674ccba2$export$b6461b23ee0e1471 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONED : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONED;
    };
    const $bc03080c674ccba2$export$24040115cac5fdc3 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1);
    };
    const $bc03080c674ccba2$export$cd227238525e8d57 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState !== (0, (0, parcelRequire("bgC2H")).ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$a101f3562b5f0742));
    };
    const $bc03080c674ccba2$export$66a96ac2f07f6730 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? false : Boolean(tenantInfo.isAdmin);
    };
});
parcelRegister("bgC2H", function(module, exports) {
    $parcel$export(module.exports, "ConsolidationState", ()=>$927cd31b0e0ee4e8$export$9ef498b0a11fd37d);
    const $927cd31b0e0ee4e8$export$9ef498b0a11fd37d = {
        NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
        TRANSITIONING: 'TRANSITIONING',
        TRANSITIONED: 'TRANSITIONED',
        CONSOLIDATED: 'CONSOLIDATED'
    };
});
const $47a35bf911de1c9b$export$650f6934db1290c1 = 'cohort3';
const $47a35bf911de1c9b$export$a101f3562b5f0742 = 'cohort3.5';
const $5a94e356f9d5e220$export$25ee35b01de9d734 = 'EOC_TENANT';
const $9b8f6422d397a375$export$5879151f0d972f18 = 'EOC_CHECK_API_KEY';
parcelRegister("kMiZJ", function(module, exports) {
    $parcel$export(module.exports, "consolidationUserStateResource", ()=>$1e0457dbe68ab17d$export$4b870505c49999ef);
    var $jcw0u;
    var $2M1hQ;
    var $9QTNT;
    const $1e0457dbe68ab17d$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
    const $1e0457dbe68ab17d$export$4b870505c49999ef = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $1e0457dbe68ab17d$var$RESOURCE_KEY,
        getKey: ()=>$1e0457dbe68ab17d$var$RESOURCE_KEY,
        getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, (0, parcelRequire("9QTNT")).getOgConsolidationUserState)(accountId).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'consolidationUserStateResource',
                        packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                        teamName: 'alexstrasza'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }),
        maxAge: Infinity
    });
});
parcelRegister("9QTNT", function(module, exports) {
    $parcel$export(module.exports, "getOgConsolidationUserState", ()=>$1a9945d1ee35f024$export$df7594d56c9ebe57);
    var $89SaW;
    var $jcw0u;
    var $jJZqs;
    var $iXaZ3;
    const $1a9945d1ee35f024$export$df7594d56c9ebe57 = (accountId)=>{
        if (!accountId) return Promise.resolve((0, (0, parcelRequire("iXaZ3")).ERROR_CONSOLIDATION_USER_STATE));
        return (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, (0, (0, parcelRequire("iXaZ3")).OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
            if (!val || typeof val !== 'object') {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'getUserProperty',
                        packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                        teamName: 'alexstrasza'
                    },
                    error: new (0, (0, parcelRequire("jJZqs")).ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                    sendToPrivacyUnsafeSplunk: true
                });
                return 0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE;
            }
            if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
                ...(0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE),
                ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE), key)))
            };
            if (!Object.keys((0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) return {
                ...(0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE),
                ...val
            };
            return val;
        }).catch((error)=>{
            if (error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.statusCode === 404) return 0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE;
            throw error;
        });
    };
});
parcelRegister("iXaZ3", function(module, exports) {
    $parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", ()=>$58f10b27bad0d860$export$1980758e2622af02);
    $parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", ()=>$58f10b27bad0d860$export$51d9907e9d716d);
    $parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", ()=>$58f10b27bad0d860$export$23da4710c3a29eae);
    const $58f10b27bad0d860$export$1980758e2622af02 = 'eoc_consolidation_user_state';
    const $58f10b27bad0d860$export$51d9907e9d716d = {
        isPromotionBannerDismissed: false,
        isWelcomeModalDisplayed: false,
        isTransitionHomeHidden: false,
        isTransitionBannerDismissed: false,
        isBroadcastWidgetDismissed: false,
        transitionBannerDismissedAt: null,
        isBenefitModalDismissed: false
    };
    const $58f10b27bad0d860$export$23da4710c3a29eae = {
        isPromotionBannerDismissed: true,
        isWelcomeModalDisplayed: true,
        isTransitionHomeHidden: true,
        isTransitionBannerDismissed: true,
        isBroadcastWidgetDismissed: true,
        transitionBannerDismissedAt: null,
        isBenefitModalDismissed: true
    };
});
parcelRegister("bHhiy", function(module, exports) {
    $parcel$export(module.exports, "getConsolidationStateResource", ()=>$cd33a435a46904ef$export$a6cf5054d4f9f5dd);
    var $j74qU;
    var $co1wz;
    var $4R6GH;
    var $2M1hQ;
    var $bgC2H;
    const $cd33a435a46904ef$export$de6c19ae237c1eb9 = (cloudId, atlassianAccountId, appPermissions)=>{
        let url = (0, (0, parcelRequire("4R6GH")).fg)('operations-tenant-info-endpoint-update') ? '/internal/v1/users/ops-user-info' : '/internal/v1/customers/tenant-info';
        if (cloudId) url = `${url}/${cloudId}`;
        else throw new Error('No tenant info exists.');
        if ((0, (0, parcelRequire("4R6GH")).fg)('operations-tenant-info-endpoint-update')) {
            if (!atlassianAccountId) throw new Error('No atlassian account id exists.');
            url = `${url}/${atlassianAccountId}`;
        }
        let promise;
        if (appPermissions && appPermissions.hasServiceDeskAccess === false) {
            promise = new Promise((resolve)=>{
                resolve({
                    consolidationState: (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('operations-tenant-info-endpoint-update') ? {
                        isAdmin: false
                    } : {}
                });
            });
            return promise;
        }
        if (false) promise = (0, (0, parcelRequire("j74qU")).eocFetch)(url, {
            exactUrl: true,
            headers: {
                'x-ssr-service-name': (0, (0, parcelRequire("4R6GH")).fg)('operations-tenant-info-endpoint-update') ? 'og-apps-user-int-api' : 'og-customer-int-api'
            }
        });
        else {
            const clientUrl = (0, (0, parcelRequire("4R6GH")).fg)('operations-tenant-info-endpoint-update') ? '/v1/users/ops-user-info' : '/v1/customers/tenant-info';
            promise = (0, (0, parcelRequire("j74qU")).eocFetch)(clientUrl).then(({ data: data })=>data);
        }
        if ((0, (0, parcelRequire("co1wz")).ff)('eoc-tenant-info-hook_dq6ke')) return promise;
        return promise.then((response)=>response.consolidationState);
    };
    const $cd33a435a46904ef$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: (0, $5a94e356f9d5e220$export$25ee35b01de9d734),
            getKey: ()=>'tenantInformation',
            getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions, atlassianAccountId: atlassianAccountId } })=>$cd33a435a46904ef$export$de6c19ae237c1eb9(cloudId, atlassianAccountId, appPermissions),
            maxAge: Infinity,
            isBrowserOnly: forceBrowser
        });
});
parcelRegister("aA974", function(module, exports) {
    $parcel$export(module.exports, "gicSmartFieldsFeatureResource", ()=>$d18db694553f5610$export$ee94bb1f59b07e35);
    $parcel$export(module.exports, "useIsSmartFieldsOptIn", ()=>$d18db694553f5610$export$3870b1ff1b155c73);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $4R6GH;
    var $aHuqL;
    var $2M1hQ;
    var $2YP9W;
    const $d18db694553f5610$export$ee94bb1f59b07e35 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $814b0a0376a60368$export$6f0555de4f60e84e),
        getKey: ()=>(0, $814b0a0376a60368$export$7e7d7930e22ba39f),
        getData: async ()=>{
            try {
                const data = await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, $814b0a0376a60368$export$b94951a11282ae6a));
                if (!data) return {
                    hasUserOptedOut: false,
                    hasUserDismissedReadMore: false,
                    hasUserDismissedGicOnboarding: (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? false : undefined
                };
                return data;
            } catch (error) {
                if (error.statusCode === 404) return {
                    hasUserOptedOut: false,
                    hasUserDismissedReadMore: false,
                    hasUserDismissedGicOnboarding: (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? false : undefined
                };
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'gicSmartFieldsFeatureResource',
                        packageName: (0, $814b0a0376a60368$export$b8b9d90f9e5bd72b),
                        teamName: 'deliveroo'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? false : undefined
            };
        },
        maxAge: Number.MAX_VALUE
    });
    const $d18db694553f5610$export$3870b1ff1b155c73 = ()=>{
        const { data: data, update: update, loading: loading } = (0, (0, parcelRequire("2YP9W")).useResource)($d18db694553f5610$export$ee94bb1f59b07e35);
        const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
        const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
        const currentDismissedGicOnboarding = (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false : undefined;
        const dismissReadMore = (0, $5uXOq.useCallback)(()=>{
            update((previousData)=>({
                    ...previousData?.hasUserOptedOut ? {
                        hasUserOptedOut: previousData.hasUserOptedOut
                    } : {
                        hasUserOptedOut: false
                    },
                    hasUserDismissedReadMore: true,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? previousData?.hasUserDismissedGicOnboarding ? {
                        hasUserDismissedGicOnboarding: previousData.hasUserDismissedGicOnboarding
                    } : {
                        hasUserDismissedGicOnboarding: false
                    } : {}
                }));
        }, [
            update
        ]);
        const dismissGicOnboarding = (0, $5uXOq.useCallback)(()=>{
            update((previousData)=>({
                    ...previousData?.hasUserOptedOut ? {
                        hasUserOptedOut: previousData.hasUserOptedOut
                    } : {
                        hasUserOptedOut: false
                    },
                    ...previousData?.hasUserDismissedReadMore ? {
                        hasUserDismissedReadMore: previousData.hasUserDismissedReadMore
                    } : {
                        hasUserDismissedReadMore: false
                    },
                    hasUserDismissedGicOnboarding: true
                }));
        }, [
            update
        ]);
        return {
            isSmartFieldsOptIn: loading ? null : currentOptInStatus,
            isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
            isSmartFieldsGicOnboardingDismissed: loading ? null : currentDismissedGicOnboarding,
            dismissReadMore: dismissReadMore,
            dismissGicOnboarding: dismissGicOnboarding,
            loading: loading
        };
    };
});
const $814b0a0376a60368$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $814b0a0376a60368$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key';
const $814b0a0376a60368$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $814b0a0376a60368$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';
parcelRegister("f5nIZ", function(module, exports) {
    $parcel$export(module.exports, "gicOptInStatusResources", ()=>$1dd3138bca6cac05$export$14c89b6b6a261524);
    var $dJl1T;
    var $eusud;
    var $2M1hQ;
    const $1dd3138bca6cac05$export$14c89b6b6a261524 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $8e5bc4e5db4905c7$export$fe522736b61f6709),
        getKey: ()=>'gic_optin_status',
        getData: async ()=>{
            let gicOptInStatus = null;
            try {
                gicOptInStatus = await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
            } catch (e) {
                if (e.statusCode !== 404) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
            }
            return {
                gicOptInStatus: gicOptInStatus ?? {
                    isEnabled: false
                }
            };
        },
        maxAge: Number.MAX_VALUE
    });
});
const $8e5bc4e5db4905c7$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';
parcelRegister("hZhhj", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_RESPONSE", ()=>$0f1ada479bbc578a$export$32d9db53927095d3);
    $parcel$export(module.exports, "incomingMailServerExpiryStatusResource", ()=>$0f1ada479bbc578a$export$369caf52ed1ad2b1);
    $parcel$export(module.exports, "useIncomingMailExpiryStatus", ()=>$0f1ada479bbc578a$export$283aa034b7d4e2a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $eusud;
    var $2M1hQ;
    var $2YP9W;
    const $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, (0, parcelRequire("eusud")).performGetRequest)((0, $b9c933d7a799fa71$export$5bf8eb915287f5f4));
    const $0f1ada479bbc578a$export$32d9db53927095d3 = {
        isAdmin: false,
        showBanner: true,
        OauthTypes: [
            'GMAIL_OAUTH'
        ]
    };
    const $0f1ada479bbc578a$export$369caf52ed1ad2b1 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $b9c933d7a799fa71$export$3b9494e0dfc4de09),
        getKey: ()=>(0, $b9c933d7a799fa71$export$f2f2f265ccc09f82),
        getData: async ()=>{
            let incomingMailServerExpiryStatus = null;
            try {
                incomingMailServerExpiryStatus = await $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus();
            } catch (error) {
                if (error.statusCode === 404) (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'incomingMailServerExpiryStatus',
                        packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                        teamName: 'maverick'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $0f1ada479bbc578a$export$32d9db53927095d3
            };
        },
        maxAge: 3600000
    });
    const $0f1ada479bbc578a$export$283aa034b7d4e2a0 = ()=>{
        const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, (0, parcelRequire("2YP9W")).useResource)($0f1ada479bbc578a$export$369caf52ed1ad2b1);
        const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $5uXOq.useState)(()=>{
            if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
            return $0f1ada479bbc578a$export$32d9db53927095d3;
        });
        const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
        (0, $5uXOq.useEffect)(()=>{
            if (loadingGetResource) {
                setResponseStatusGet('loading');
                return;
            }
            if (errorGetResource) {
                setResponseStatusGet('error');
                return;
            }
            if (data?.incomingMailServerExpiryStatus) {
                setResponseStatusGet('success');
                setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
            }
        }, [
            loadingGetResource,
            errorGetResource,
            data?.incomingMailServerExpiryStatus
        ]);
        return {
            responseStatus: responseStatusGet,
            state: incomingMailServerExpiryStatus
        };
    };
});
const $b9c933d7a799fa71$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $b9c933d7a799fa71$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $b9c933d7a799fa71$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';
parcelRegister("9MiT2", function(module, exports) {
    $parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", ()=>$2d6f7831c4394a60$export$1b6468a6eb7d9b09);
    $parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", ()=>$2d6f7831c4394a60$export$e21c345b2538e96e);
    var $5uXOq = parcelRequire("5uXOq");
    var $561FV = parcelRequire("561FV");
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    var $2M1hQ;
    var $2YP9W;
    var $erLlC;
    const $2d6f7831c4394a60$export$1b6468a6eb7d9b09 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("erLlC")).RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
        getKey: ()=>(0, (0, parcelRequire("erLlC")).ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
        getData: async ()=>{
            let modalViewCount = 0;
            try {
                const apiResult = await (0, (0, parcelRequire("eusud")).performGetRequest)((0, (0, parcelRequire("erLlC")).ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
                if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) {
                    if (!(0, ($parcel$interopDefault($561FV)))(apiResult, 'value') || !(0, ($parcel$interopDefault($561FV)))(apiResult, 'benefitsModalValue')) {
                        const error = new Error('Invalid preference value');
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                id: 'issueTransitionChangeboardingPreferencesResource',
                                packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                    }
                    return {
                        numberOfTimesUserHasSeenChangeboarding: Number(apiResult.value) || 0,
                        benefitsModal: {
                            isDisabled: apiResult?.benefitsModal?.isDisabled || false,
                            nextDateToShowBenefitsModal: apiResult?.benefitsModal?.nextDateToShowBenefitsModal || null
                        }
                    };
                }
                if (typeof apiResult !== 'object' || !(0, ($parcel$interopDefault($561FV)))(apiResult, 'value')) {
                    const error = new Error('Invalid preference value');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'issueTransitionChangeboardingPreferencesResource',
                            packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                } else {
                    modalViewCount = Number(apiResult.value);
                    return {
                        numberOfTimesUserHasSeenChangeboarding: modalViewCount
                    };
                }
            } catch (error) {
                if (error.statusCode === 404) {
                    if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) return {
                        numberOfTimesUserHasSeenChangeboarding: 0,
                        benefitsModal: {
                            isDisabled: false,
                            nextDateToShowBenefitsModal: null
                        }
                    };
                    return {
                        numberOfTimesUserHasSeenChangeboarding: 0
                    };
                }
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                numberOfTimesUserHasSeenChangeboarding: modalViewCount,
                benefitsModal: {
                    isDisabled: true,
                    nextDateToShowBenefitsModal: null
                }
            };
        }
    });
    const $2d6f7831c4394a60$export$e21c345b2538e96e = ()=>{
        const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, (0, parcelRequire("2YP9W")).useResource)($2d6f7831c4394a60$export$1b6468a6eb7d9b09);
        const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $5uXOq.useState)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) return {
                numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                benefitsModal: {
                    isDisabled: Boolean(data?.benefitsModal?.isDisabled),
                    nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            };
            if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
            return 0, (0, parcelRequire("erLlC")).USER_SEEN_CARDINALITY_UNKNOWN;
        });
        const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
        const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
        const updateIssueTranstitionChangeboardingPreferences = (0, $5uXOq.useCallback)(async (updates)=>{
            let response = 'loading';
            setResponseStatusPut('loading');
            const body = typeof updates !== 'number' && (0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal') ? {
                value: updates?.numberOfTimesUserHasSeenChangeboarding,
                benefitsModal: {
                    isDisabled: updates?.benefitsModal?.isDisabled,
                    nextDateToShowBenefitsModal: updates?.benefitsModal?.nextDateToShowBenefitsModal
                }
            } : {
                value: updates
            };
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)((0, (0, parcelRequire("erLlC")).ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                    body: JSON.stringify(body)
                });
                setResponseStatusPut('success');
                let updateData;
                if (typeof updates !== 'number' && (0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) updateData = {
                    numberOfTimesUserHasSeenChangeboarding: updates?.numberOfTimesUserHasSeenChangeboarding,
                    benefitsModal: {
                        isDisabled: updates?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: String(updates?.benefitsModal?.nextDateToShowBenefitsModal) || null
                    }
                };
                if (typeof updates === 'number') updateData = {
                    numberOfTimesUserHasSeenChangeboarding: updates
                };
                update(()=>updateData);
                response = 'success';
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesUpdate',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setResponseStatusPut('error');
                response = 'error';
            }
            return response;
        }, [
            update
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loadingGetResource) {
                setResponseStatusGet('loading');
                return;
            }
            if (errorGetResource) {
                setResponseStatusGet('error');
                return;
            }
            if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) {
                setResponseStatusGet('success');
                setIssueTransitionChangeboardingPreference({
                    numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                    benefitsModal: {
                        isDisabled: data?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                    }
                });
                return;
            }
            if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
                setResponseStatusGet('success');
                setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
            }
        }, [
            loadingGetResource,
            errorGetResource,
            data?.numberOfTimesUserHasSeenChangeboarding,
            data?.benefitsModal?.isDisabled,
            data?.benefitsModal?.nextDateToShowBenefitsModal
        ]);
        return {
            stateGet: {
                responseStatus: responseStatusGet,
                state: issueTransitionChangeboardingPreference
            },
            stateUpdate: {
                responseStatus: responseStatusPut,
                setState: updateIssueTranstitionChangeboardingPreferences
            }
        };
    };
});
parcelRegister("erLlC", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", ()=>$ca7314633d486db1$export$d66d4b761db3d20f);
    $parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", ()=>$ca7314633d486db1$export$79fd70b908f71ddd);
    $parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", ()=>$ca7314633d486db1$export$e5007258addba8aa);
    $parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", ()=>$ca7314633d486db1$export$91880069e7e73b18);
    $parcel$export(module.exports, "DURATION_IN_DAYS_DEFAULT", ()=>$ca7314633d486db1$export$9ccdfd91f2512a27);
    const $ca7314633d486db1$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
    const $ca7314633d486db1$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
    const $ca7314633d486db1$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
    const $ca7314633d486db1$export$91880069e7e73b18 = -1;
    const $ca7314633d486db1$export$9ccdfd91f2512a27 = 14;
});
parcelRegister("fNOVA", function(module, exports) {
    $parcel$export(module.exports, "issueTransitionOptInStatusResource", ()=>$cf959888902c771b$export$5fbcf4d7a6d9c477);
    $parcel$export(module.exports, "useIssueTransitionLabsOptIn", ()=>$cf959888902c771b$export$bc11d4816053db5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $aIZdc;
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    var $2M1hQ;
    var $2YP9W;
    var $dO2g2;
    const $cf959888902c771b$var$fetchGetIssueTransitionOptInState = async ()=>(0, (0, parcelRequire("eusud")).performGetRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca));
    const $cf959888902c771b$export$5fbcf4d7a6d9c477 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $267ed65766cf1bd0$export$eb01e12fc3db65c0),
        getKey: ()=>(0, $267ed65766cf1bd0$export$a964df7bc15d81e),
        getData: async ()=>{
            let issueTransitionOptInStatus = null;
            const isModernIssueTransitionSRBCohort = (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-customisation-for-srb') || (0, (0, parcelRequire("aIZdc")).isFedRamp)();
            const isModernITSRenderEnabled = (0, (0, parcelRequire("4R6GH")).fg)('render-modern-issue-transition') || (0, (0, parcelRequire("aIZdc")).isFedRamp)();
            if (!isModernITSRenderEnabled) return {
                issueTransitionOptInStatus: {
                    isEnabled: false,
                    expiryTime: -1
                }
            };
            if (isModernIssueTransitionSRBCohort) return {
                issueTransitionOptInStatus: {
                    isEnabled: true
                }
            };
            try {
                issueTransitionOptInStatus = await $cf959888902c771b$var$fetchGetIssueTransitionOptInState();
            } catch (error) {
                if (error.statusCode === 404) (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'issueTransitionOptInStatusResource',
                        packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                        teamName: 'gryffindor'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, (0, parcelRequire("dO2g2")).default)()
            };
        },
        maxAge: Number.MAX_VALUE
    });
    const $cf959888902c771b$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, (0, parcelRequire("eusud")).performPutRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca), {
            body: JSON.stringify(payload)
        });
    const $cf959888902c771b$export$bc11d4816053db5c = ()=>{
        const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, (0, parcelRequire("2YP9W")).useResource)($cf959888902c771b$export$5fbcf4d7a6d9c477);
        const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $5uXOq.useState)(()=>{
            if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
            return (0, (0, parcelRequire("dO2g2")).default)();
        });
        const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
        const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
        const updateIssueTransitionOptInStatus = (0, $5uXOq.useCallback)(async (updates)=>{
            let response = 'loading';
            setResponseStatusPut('loading');
            try {
                const updatedPreferences = await $cf959888902c771b$var$fetchModifyIssueTransitionOptInState(updates);
                setResponseStatusPut('success');
                update(()=>({
                        issueTransitionOptInStatus: updatedPreferences
                    }));
                response = 'success';
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: err,
                    meta: {
                        id: 'issueTransitionOptInStatusUpdate',
                        packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                        teamName: 'gryffindor'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setResponseStatusPut('error');
                response = 'error';
            }
            return response;
        }, [
            update
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loadingGetResource) {
                setResponseStatusGet('loading');
                return;
            }
            if (errorGetResource) {
                setResponseStatusGet('error');
                return;
            }
            if (data?.issueTransitionOptInStatus) {
                setResponseStatusGet('success');
                setIssueTransitionOptInState(data.issueTransitionOptInStatus);
            }
        }, [
            loadingGetResource,
            errorGetResource,
            data?.issueTransitionOptInStatus
        ]);
        return {
            stateGet: {
                responseStatus: responseStatusGet,
                state: issueTransitionLabsOptInState
            },
            stateUpdate: {
                responseStatus: responseStatusPut,
                setState: updateIssueTransitionOptInStatus
            }
        };
    };
});
const $267ed65766cf1bd0$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $267ed65766cf1bd0$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $267ed65766cf1bd0$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $267ed65766cf1bd0$export$880a78695d76498e = 8;
parcelRegister("dO2g2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8fa107364a5021d3$export$2e2bcd8739ae039);
    var $aIZdc;
    var $co1wz;
    var $4R6GH;
    const $8fa107364a5021d3$var$FF_POSSIBLE_VALUES = [
        'OFF',
        'BY_DEFAULT_USER_OPT_IN',
        'BY_DEFAULT_USER_OPT_OUT'
    ];
    const $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState = ()=>{
        const isModernITSRenderEnabled = (0, (0, parcelRequire("4R6GH")).fg)('render-modern-issue-transition') || (0, (0, parcelRequire("aIZdc")).isFedRamp)();
        if (!isModernITSRenderEnabled) return {
            isEnabled: false,
            expiryTime: -1
        };
        const isModernIssueTransitionSRBCohort = (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-customisation-for-srb') || (0, (0, parcelRequire("aIZdc")).isFedRamp)();
        if (isModernIssueTransitionSRBCohort) return {
            isEnabled: true
        };
        const isExplicitlyUseTurnedOff = (0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', $8fa107364a5021d3$var$FF_POSSIBLE_VALUES) === 'BY_DEFAULT_USER_OPT_OUT';
        return isExplicitlyUseTurnedOff ? {
            isEnabled: false,
            expiryTime: -1
        } : {
            isEnabled: true
        };
    };
    var $8fa107364a5021d3$export$2e2bcd8739ae039 = $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState;
});
parcelRegister("kJQXA", function(module, exports) {
    $parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", ()=>$273ba0463e1e3cac$export$fa191d7d71460a98);
    var $4Pf62;
    var $eusud;
    var $2M1hQ;
    const $273ba0463e1e3cac$export$fa191d7d71460a98 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $b830026e722fc8e6$export$fd4fc70ec71927d1),
        getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
        getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
            const defaultValue = {
                enabled: true
            };
            if (!licensedProducts || !licensedProducts[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
            const { enabled: enabled } = await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
            return {
                enabled: enabled
            };
        },
        maxAge: Infinity
    });
});
const $b830026e722fc8e6$export$fd4fc70ec71927d1 = 'AUTOMATION_IS_LEGACY_ENABLED';
parcelRegister("atU1t", function(module, exports) {
    $parcel$export(module.exports, "navigationSidebarGlobalResource", ()=>$587727b78e9bd173$export$44e7ad3c66a3f25f);
    var $3NIpU;
    var $1nb22;
    var $2M1hQ;
    const $587727b78e9bd173$export$44e7ad3c66a3f25f = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $f9d36ddc532997a4$export$fa5743fc6a1da5d8),
        getKey: ({ match: match, query: query })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return projectKey || projectId || '__state';
        },
        getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { baseUrl: baseUrl } = tenantContext;
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const scope = {
                projectKey: projectKey,
                projectId: projectId
            };
            const response = await (0, (0, parcelRequire("3NIpU")).fetchSidebarConfig)(baseUrl, scope, false);
            return {
                response: response,
                scope: scope
            };
        },
        maxAge: 300000
    });
});
parcelRegister("3NIpU", function(module, exports) {
    $parcel$export(module.exports, "fetchSidebarConfig", ()=>$8ba40d865239bafe$export$d1d13c4b972a22f1);
    var $dJl1T;
    var $7f4tk;
    const $8ba40d865239bafe$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';
    const $8ba40d865239bafe$var$fetchUsingProtobuf = async (url)=>{
        try {
            const fetchProtobuf = await (parcelRequire("aOyKS"));
            if (!fetchProtobuf) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($8ba40d865239bafe$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
            return fetchProtobuf.default(url);
        } catch (err) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($8ba40d865239bafe$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
            throw err;
        }
    };
    const $8ba40d865239bafe$export$94e808b2557f52e = (baseUrl, requestQuery, version = '2', queryParams)=>{
        const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
        const params = {
            exclude: [
                'webItems.reports',
                'webItems.home',
                'webItems.gin',
                exclude
            ].filter(Boolean).join(',')
        };
        let path = '';
        if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
        else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
        else if (identifierValue != null) path = `project/${identifierValue}`;
        else {
            path = 'product';
            const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
            const projectIdOrKey = projectId || projectKey;
            if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
        }
        const queryString = [
            new URLSearchParams(params).toString(),
            queryParams
        ].filter(Boolean).join('&');
        return `${baseUrl}/rest/navigation/${version}/${path}?${queryString}`;
    };
    const $8ba40d865239bafe$export$d1d13c4b972a22f1 = async (baseUrl, requestQuery, isServer, queryParams)=>{
        if (isServer) {
            const protoUrl = $8ba40d865239bafe$export$94e808b2557f52e(baseUrl, requestQuery, '2.1', queryParams);
            return $8ba40d865239bafe$var$fetchUsingProtobuf(protoUrl);
        }
        const sidebarUrl = $8ba40d865239bafe$export$94e808b2557f52e(baseUrl, requestQuery, undefined, queryParams);
        return (0, (0, parcelRequire("7f4tk")).default)(sidebarUrl);
    };
});
parcelRegister("aOyKS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7erVk").then(()=>parcelRequire('g4I8Z'));
});
const $f9d36ddc532997a4$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';
parcelRegister("c34Wf", function(module, exports) {
    $parcel$export(module.exports, "navigationUiStateResource", ()=>$976a0f933d5d0ba8$export$14c178691841b423);
    var $8QpSo;
    var $2M1hQ;
    var $kJPyG;
    const $976a0f933d5d0ba8$var$getNavigationUiStateMemoized = (0, (0, parcelRequire("8QpSo")).default)((atlassianAccountId)=>(0, (0, parcelRequire("kJPyG")).getNavigationUiState)({
            tenantContext: {
                atlassianAccountId: atlassianAccountId
            }
        }));
    const $976a0f933d5d0ba8$export$14c178691841b423 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'RESOURCE_TYPE_NAVIGATION_UI',
        getKey: ()=>'state',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$976a0f933d5d0ba8$var$getNavigationUiStateMemoized(atlassianAccountId),
        maxAge: Infinity
    });
});
parcelRegister("kJPyG", function(module, exports) {
    $parcel$export(module.exports, "getNavigationUiState", ()=>$a5efaf793a61ef5e$export$29999268b070c9bd);
    var $89SaW;
    var $1yqku;
    const $a5efaf793a61ef5e$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
        const { atlassianAccountId: accountId } = tenantContext;
        let uiState = await (0, (0, parcelRequire("1yqku")).queryLocalStorage)();
        if (uiState || !accountId) return uiState;
        try {
            uiState = await (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
            (0, (0, parcelRequire("1yqku")).updateLocalStorageData)(uiState);
        } catch (e) {}
        return uiState;
    };
});
const $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $2ed2f0cf8ecb933e$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';
parcelRegister("1yqku", function(module, exports) {
    $parcel$export(module.exports, "queryLocalStorage", ()=>$fa4273588466a1c1$export$e192dcb908272d5);
    $parcel$export(module.exports, "updateLocalStorageData", ()=>$fa4273588466a1c1$export$ec13c725e067146a);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dJl1T;
    const $fa4273588466a1c1$export$e7db3fa51c63bc5c = ()=>{
        if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
        return {
            setItem: (0, ($parcel$interopDefault($8Rkzz))),
            getItem: (0, ($parcel$interopDefault($8Rkzz)))
        };
    };
    const $fa4273588466a1c1$var$queryLocalStorageSync = ()=>{
        const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
        const item = localStorage.getItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
        if (!false && item) try {
            return JSON.parse(item);
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $2ed2f0cf8ecb933e$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
        }
    };
    const $fa4273588466a1c1$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
            const item = $fa4273588466a1c1$var$queryLocalStorageSync();
            resolve(item);
        });
    const $fa4273588466a1c1$export$ec13c725e067146a = (data)=>{
        const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
        localStorage.setItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(data));
    };
});
parcelRegister("eOlBz", function(module, exports) {
    $parcel$export(module.exports, "newIssueViewTransitionLockInStatusResource", ()=>$4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);
    $parcel$export(module.exports, "DEFAULT_TO_OLD_ISSUE_VIEW", ()=>$4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2);
    $parcel$export(module.exports, "useNewIssueViewLockedInStatus", ()=>$4e2e5fcdbf62dfaf$export$3b09097f2a423abd);
    var $2M1hQ;
    var $2YP9W;
    const $4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $103a13dfd187b85c$export$fdb92aeacda42553),
        getKey: ()=>'newIssueViewTransitionLockingStatus',
        getDataLoader: ()=>(parcelRequire("l81Mv")),
        maxAge: Number.MAX_VALUE
    });
    const $4e2e5fcdbf62dfaf$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
    const $4e2e5fcdbf62dfaf$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
    const $4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
    const $4e2e5fcdbf62dfaf$export$3b09097f2a423abd = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);
});
const $103a13dfd187b85c$export$fdb92aeacda42553 = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';
parcelRegister("l81Mv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bDo1N").then(()=>parcelRequire('2RVA3'));
});
parcelRegister("3X1Xr", function(module, exports) {
    $parcel$export(module.exports, "persistentIssueCreateModalViewResource", ()=>$950f2f2a5a65ba3f$export$266a039a005e8314);
    var $2M1hQ;
    const $950f2f2a5a65ba3f$export$266a039a005e8314 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $fa76c7a777da2375$export$f658cfd591eb583e),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("cptV5")),
        maxAge: Number.MAX_VALUE
    });
});
const $fa76c7a777da2375$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $fa76c7a777da2375$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $fa76c7a777da2375$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';
parcelRegister("cptV5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1Kt13").then(()=>parcelRequire('8FYIq'));
});
parcelRegister("dxCvy", function(module, exports) {
    $parcel$export(module.exports, "projectContextResource", ()=>$fb0493b5a465ed74$export$27ad0d75c619be68);
    $parcel$export(module.exports, "projectContextResourceWithCache", ()=>$fb0493b5a465ed74$export$d75816e37af81473);
    var $1nb22;
    var $2M1hQ;
    const $fb0493b5a465ed74$var$getDataLoader = ()=>(parcelRequire("2VAeN"));
    const $fb0493b5a465ed74$export$27ad0d75c619be68 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $0f463a88567f1621$export$80a60a092d9ab81),
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return projectKey || projectId;
        },
        getDataLoader: $fb0493b5a465ed74$var$getDataLoader,
        maxAge: 1800000
    });
    const $fb0493b5a465ed74$export$d75816e37af81473 = $fb0493b5a465ed74$export$27ad0d75c619be68;
});
const $0f463a88567f1621$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';
parcelRegister("2VAeN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7UkBG").then(()=>parcelRequire('fsLhR'));
});
parcelRegister("4dc0x", function(module, exports) {
    $parcel$export(module.exports, "fetchSiteTraitsResource", ()=>$6bcb8e2c3d1b4192$export$379923e7c903a55d);
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    var $3HwlS;
    var $gNStA;
    var $2M1hQ;
    const $6bcb8e2c3d1b4192$export$379923e7c903a55d = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('hot-113350-move-resources-to-rrr'), (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $ecc0251f1d9f8566$export$6f0555de4f60e84e),
        getKey: ()=>(0, $ecc0251f1d9f8566$export$7e7d7930e22ba39f),
        getData: async (_, { tenantContext: tenantContext })=>{
            try {
                if (tenantContext.isAnonymous) return null;
                const cloudId = tenantContext.cloudId;
                const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
                const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
                if (response?.attributes) return response.attributes;
                return null;
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $ecc0251f1d9f8566$export$7f111648ca05f056),
                        packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return null;
        },
        maxAge: Number.MAX_VALUE
    }));
});
const $2ffc5f2215c16253$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGrowthRecommendations';
const $ecc0251f1d9f8566$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_SITE_TRAITS';
const $ecc0251f1d9f8566$export$7e7d7930e22ba39f = 'recommendations-fetch-site-traits-resource-key';
const $ecc0251f1d9f8566$export$7f111648ca05f056 = 'useResource.fetchRecommendationsSiteTraits';
parcelRegister("51Yl2", function(module, exports) {
    $parcel$export(module.exports, "fetchUserTraitsResource", ()=>$7ddcc0e078ed27cf$export$d5198d02e9089545);
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    var $3HwlS;
    var $gNStA;
    var $2M1hQ;
    const $7ddcc0e078ed27cf$export$d5198d02e9089545 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('hot-113350-move-resources-to-rrr'), (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $e07bc74223fe458d$export$6f0555de4f60e84e),
        getKey: ()=>(0, $e07bc74223fe458d$export$7e7d7930e22ba39f),
        getData: async (_, { tenantContext: tenantContext })=>{
            try {
                if (tenantContext.isAnonymous) return null;
                const accountId = tenantContext.atlassianAccountId;
                const cloudId = tenantContext.cloudId;
                const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
                const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
                if (response?.attributes) return response.attributes;
                return null;
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $e07bc74223fe458d$export$7f111648ca05f056),
                        packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return null;
        },
        maxAge: Number.MAX_VALUE
    }));
});
const $e07bc74223fe458d$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_USER_TRAITS';
const $e07bc74223fe458d$export$7e7d7930e22ba39f = 'recommendations-fetch-traits-resource-key';
const $e07bc74223fe458d$export$7f111648ca05f056 = 'useResource.fetchRecommendationsUserTraits';
parcelRegister("lXNZG", function(module, exports) {
    $parcel$export(module.exports, "jpdRecommendationDismissedResource", ()=>$5630a429b63403f9$export$5db7c4562b672f52);
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    var $3HwlS;
    var $gNStA;
    var $2M1hQ;
    const $5630a429b63403f9$export$5db7c4562b672f52 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('hot-113350-move-resources-to-rrr'), (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $2a8d22514dc25dbd$export$6f0555de4f60e84e),
        getKey: ()=>(0, $2a8d22514dc25dbd$export$7e7d7930e22ba39f),
        getData: async (_, { tenantContext: tenantContext })=>{
            try {
                if (tenantContext.isAnonymous) return {
                    hasDismissed: true
                };
                const accountId = tenantContext.atlassianAccountId;
                const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/latest/user/properties/JpdRecommendationDismissed?accountId=${accountId}`);
                return {
                    hasDismissed: response?.value ?? false
                };
            } catch (error) {
                const initialValueNeverSet = error.statusCode === 404;
                if (initialValueNeverSet) return {
                    hasDismissed: false
                };
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $2a8d22514dc25dbd$export$7f111648ca05f056),
                        packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                hasDismissed: true
            };
        },
        maxAge: Number.MAX_VALUE
    }));
});
const $2a8d22514dc25dbd$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_DISMISSED_JPD';
const $2a8d22514dc25dbd$export$7e7d7930e22ba39f = 'recommendations-dismissed-jpd-resource-key';
const $2a8d22514dc25dbd$export$7f111648ca05f056 = 'useResource.fetchRecommendationsDismissedJpd';
parcelRegister("kkNtb", function(module, exports) {
    $parcel$export(module.exports, "rovoEntitlementResource", ()=>$10274390833bf523$export$a0974cf24d16bc5d);
    $parcel$export(module.exports, "useRovoEntitlementResource", ()=>$10274390833bf523$export$b9cee3799212b85a);
    var $jcw0u;
    var $eusud;
    var $2M1hQ;
    var $2YP9W;
    const $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
    const $10274390833bf523$var$fetchRovoEntitlement = async (cloudId)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $34f68d752b7fdd6c$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId
                    }
                }),
                headers: {
                    'content-type': 'application/json'
                }
            });
            if (response.errors) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'navigationResource',
                    packageName: 'jiraRouterResourcesRovoEntitlement',
                    teamName: 'ai-mate'
                },
                error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                isRovoEnabled: response.data?.jira?.isRovoEnabled ?? null
            };
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'navigationResource',
                    packageName: 'jiraRouterResourcesRovoEntitlement',
                    teamName: 'ai-mate'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            isRovoEnabled: null
        };
    };
    const $10274390833bf523$export$a0974cf24d16bc5d = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
        getKey: ()=>$10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
        getData: (_, { tenantContext: { cloudId: cloudId } })=>$10274390833bf523$var$fetchRovoEntitlement(cloudId),
        maxAge: Infinity
    });
    const $10274390833bf523$export$b9cee3799212b85a = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($10274390833bf523$export$a0974cf24d16bc5d);
});
const $34f68d752b7fdd6c$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
  }
}
`;
parcelRegister("9vlEn", function(module, exports) {
    $parcel$export(module.exports, "userHomepageResource", ()=>$ea929e6a42e03883$export$16320dd0d1e6c145);
    var $eusud;
    var $2M1hQ;
    const $ea929e6a42e03883$export$16320dd0d1e6c145 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $a4d0f361741078de$export$2026a6db44b15de7),
        getKey: ()=>'state',
        getData: async (_, { tenantContext: { baseUrl: baseUrl } })=>{
            const { homepagePreference: homepagePreference } = await (0, (0, parcelRequire("eusud")).performGetRequest)(`${baseUrl}/rest/internal/3/homepage/`);
            return {
                homepagePreference: homepagePreference
            };
        },
        maxAge: Infinity
    });
});
const $a4d0f361741078de$export$2026a6db44b15de7 = 'USER_HOMEPAGE';
parcelRegister("2GNwF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("6uHGD")),
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("29Kha")
    ]).then(()=>parcelRequire('iL9n8'));
});
parcelRegister("ffza4", function(module, exports) {
    $parcel$export(module.exports, "LazyAtlassianNavigation", ()=>$772c987a24839dcf$export$4caed23aa0274abb);
    var $fDtbf;
    var $2SVPM;
    var $kxZPA;
    const $772c987a24839dcf$export$4caed23aa0274abb = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        const bundleReady = (parcelRequire("fAyVj"));
        if (!false) bundleReady.then(()=>{
            (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))) {
                (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                break;
            }
        });
        return bundleReady;
    }, {
        moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/index.tsx"
    });
});
parcelRegister("fAyVj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kV4Fy")
    ]).then(()=>parcelRequire('jC2al'));
});
parcelRegister("2BrOV", function(module, exports) {
    $parcel$export(module.exports, "globalLayout", ()=>$6d4ecb0834e594e8$export$929cb72e7acb7fd9);
    var $aPfsS;
    const $6d4ecb0834e594e8$var$rightSidebars = ()=>[];
    const $6d4ecb0834e594e8$export$929cb72e7acb7fd9 = (0, (0, parcelRequire("aPfsS")).createLayout)({
        rightSidebars: $6d4ecb0834e594e8$var$rightSidebars()
    });
});
parcelRegister("lmyls", function(module, exports) {
    $parcel$export(module.exports, "ADDON_ID", ()=>$ee51d260cb059727$export$6c4866a933650d1d);
    $parcel$export(module.exports, "MENU_ID", ()=>$ee51d260cb059727$export$d4cd258d01c03112);
    $parcel$export(module.exports, "SIDEBAR_ID", ()=>$ee51d260cb059727$export$adf978edbdfaf080);
    const $ee51d260cb059727$export$6c4866a933650d1d = {
        DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
    };
    const $ee51d260cb059727$export$d4cd258d01c03112 = {
        ADDONS: 'ADDONS',
        APP_SWITCHER: 'APP_SWITCHER',
        DASHBOARDS: 'DASHBOARDS',
        FILTERS: 'FILTERS',
        HELP: 'HELP',
        HOME: 'HOME',
        INSIGHT: 'INSIGHT',
        NOTIFICATIONS: 'NOTIFICATIONS',
        PEOPLE: 'PEOPLE',
        PLANS: 'PLANS',
        PROFILE: 'PROFILE',
        PROJECTS: 'PROJECTS',
        ROADMAPS: 'ROADMAPS',
        SEARCH: 'SEARCH',
        SERVICE_HUB: 'SERVICE_HUB',
        SETTINGS: 'SETTINGS',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
    };
    const $ee51d260cb059727$export$adf978edbdfaf080 = {
        BOARD_SETTINGS: 'BOARD_SETTINGS',
        GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
        GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
        GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
        GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
        GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
        PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
        PLAN_SETTINGS: 'PLAN_SETTINGS',
        PROJECT_SETTINGS: 'PROJECT_SETTINGS'
    };
});
parcelRegister("7OYJs", function(module, exports) {
    $parcel$export(module.exports, "ScreenRedirect", ()=>$49ac470f4c9a751a$export$fdd3e60cd227c2f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $bVDE5;
    var $7tQej;
    var $doZTA;
    const $49ac470f4c9a751a$export$fdd3e60cd227c2f7 = ({ to: to, persistSearchParams: persistSearchParams = true })=>{
        const [{ route: route, location: location, query: query }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ isInitialRender: isInitial }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!route || !eventRef.current) return;
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            route,
            isInitial
        ]);
        if (Array.isArray(persistSearchParams)) {
            const persistParams = Object.keys(query).reduce((result, currentKey)=>{
                const shouldPersist = persistSearchParams.some((persistKey)=>currentKey.includes(persistKey));
                if (shouldPersist) result.push(`${currentKey}=${query[currentKey]}`);
                return result;
            }, []).join('&');
            if (persistParams !== '') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `${to}?${persistParams}`
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: to
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `${to}${persistSearchParams ? location.search : ''}`
        });
    };
});
parcelRegister("bVDE5", function(module, exports) {
    $parcel$export(module.exports, "useSpaStateTransition", ()=>$1f866bb77da3c907$export$4d1974344641a2c9);
    $parcel$export(module.exports, "default", ()=>$1f866bb77da3c907$export$2e2bcd8739ae039);
    var $6RCeq;
    var $3sQ5x;
    var $51nlc;
    var $7w9eZ;
    const $1f866bb77da3c907$var$getNavigationStart = ()=>{
        const timestamp = (0, (0, parcelRequire("6RCeq")).default) && (0, (0, parcelRequire("6RCeq")).default).timing && (0, (0, parcelRequire("6RCeq")).default).timing.navigationStart;
        return timestamp ? new Date(timestamp).toISOString() : undefined;
    };
    const $1f866bb77da3c907$var$getLastTransition = (currentPage, visitedPages)=>{
        if (visitedPages.length === 0) return undefined;
        const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
        const appNamesToStr = (appNames)=>appNames.join('+') || '?';
        const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
        const currPage = appNamesToStr(collectAppNames(currentPage));
        return `${prevPage} > ${currPage}`;
    };
    const $1f866bb77da3c907$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
        if (visitedPages.length === 0) return undefined;
        return currentPage.startTime;
    };
    const $1f866bb77da3c907$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
            isInitialRender: visitedPages.length === 0,
            transitionsCount: visitedPages.length,
            lastTransition: $1f866bb77da3c907$var$getLastTransition(currentPage, visitedPages),
            lastTransitionStartTime: $1f866bb77da3c907$var$getLastTransitionStartTime(currentPage, visitedPages),
            navigationStart: $1f866bb77da3c907$var$getNavigationStart(),
            currentPageId: currentPage.uuid
        });
    const $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("7w9eZ")).default), {
        displayName: 'SpaStateTransitionStateSubscriber',
        selector: $1f866bb77da3c907$export$aea217a45095ce11
    });
    const $1f866bb77da3c907$export$4d1974344641a2c9 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: $1f866bb77da3c907$export$aea217a45095ce11
    });
    var $1f866bb77da3c907$export$2e2bcd8739ae039 = $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber;
});
parcelRegister("5W2CW", function(module, exports) {
    $parcel$export(module.exports, "ErrorScreen", ()=>$50454f3b2d1014d6$export$42f84e610f279c31);
    var $5uXOq = parcelRequire("5uXOq");
    var $38Y30;
    var $6AaZy;
    var $1v2QX;
    var $jMY1T;
    const $50454f3b2d1014d6$export$42f84e610f279c31 = ({ errorMessage: errorMessage, isEmbedded: isEmbedded = false, planId: planId })=>{
        delete window.__ARJ_BACKLOG_PROMISE__;
        delete window.__ARJ_INFO_METADATA_PROMISE__;
        switch(errorMessage){
            case 0, $b31dd89598859846$export$aa64437890e7b596:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38Y30")).RedirectToLoginPage), null);
            case 0, $b31dd89598859846$export$3fe2400c9d24940d:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6AaZy")).AsyncLicenseViolationErrorPage), {
                    isEmbedded: isEmbedded
                });
            case 0, $b31dd89598859846$export$4589763db20bfd7f:
            case 0, $b31dd89598859846$export$7e6358a0c21dff8c:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jMY1T")).AsyncNotFoundErrorPage), {
                    entity: (0, $b31dd89598859846$export$c303e491e026ebc6),
                    isEmbedded: isEmbedded
                });
            case 0, $b31dd89598859846$export$6519152a5f0e081:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jMY1T")).AsyncNotFoundErrorPage), {
                    entity: (0, $b31dd89598859846$export$9b928fc5e710e864),
                    isEmbedded: isEmbedded,
                    planId: planId
                });
            case 0, $b31dd89598859846$export$6128dc888243fa0a:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1v2QX")).AsyncNoPlanPermissionErrorPage), {
                    isEmbedded: isEmbedded
                });
            default:
                return null;
        }
    };
});
parcelRegister("38Y30", function(module, exports) {
    $parcel$export(module.exports, "RedirectToLoginPage", ()=>$08f8c3f776d557a9$export$938182bd3fddc3a8);
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    var $ieDtd;
    var $doZTA;
    const $08f8c3f776d557a9$export$3da29de62ed7a388 = ({ to: to })=>(0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            dangerouslySetInnerHTML: {
                __html: `window.location.assign("${to}")`
            }
        });
    $08f8c3f776d557a9$export$3da29de62ed7a388.displayName = 'InlineRedirect';
    const $08f8c3f776d557a9$export$938182bd3fddc3a8 = ()=>{
        const [{ location: { pathname: pathname, search: search } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const redirectUrl = pathname + search;
        const encodedRedirectUrl = encodeURIComponent(redirectUrl);
        let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
        const parentProductQueryName = 'parentProduct';
        const [parentProduct] = (0, (0, parcelRequire("ieDtd")).useQueryParam)(parentProductQueryName);
        if (pathname.endsWith('/embed')) {
            const searchParams = new URLSearchParams(search);
            searchParams.delete(parentProductQueryName);
            let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
            if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
            const encodedParentProduct = encodeURIComponent(parentProduct || '');
            path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
        }
        return false ? (0, ($parcel$interopDefault($5uXOq))).createElement($08f8c3f776d557a9$export$3da29de62ed7a388, {
            to: path
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: path
        });
    };
});
const $b31dd89598859846$export$aa64437890e7b596 = 'permission-violation';
const $b31dd89598859846$export$3fe2400c9d24940d = 'license-violation';
const $b31dd89598859846$export$4589763db20bfd7f = 'plan-not-found';
const $b31dd89598859846$export$6519152a5f0e081 = 'scenario-not-found';
const $b31dd89598859846$export$7e6358a0c21dff8c = 'report-not-found';
const $b31dd89598859846$export$6128dc888243fa0a = 'no-plan-permission';
const $b31dd89598859846$export$c303e491e026ebc6 = 'PLAN';
const $b31dd89598859846$export$9b928fc5e710e864 = 'SCENARIO';
parcelRegister("6AaZy", function(module, exports) {
    $parcel$export(module.exports, "AsyncLicenseViolationErrorPage", ()=>$05d56fdddce8137e$export$f5d9764f07badc4d);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $lfTZh;
    var $kxZPA;
    const $05d56fdddce8137e$var$LazyLicenseViolationErrorPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("6HaR7")), {
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/license-violation/index.tsx"
    });
    const $05d56fdddce8137e$export$f5d9764f07badc4d = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "arj-license-violation-page",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($05d56fdddce8137e$var$LazyLicenseViolationErrorPage, props));
});
parcelRegister("6HaR7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ikYJz").then(()=>parcelRequire('cGdIS'));
});
parcelRegister("1v2QX", function(module, exports) {
    $parcel$export(module.exports, "AsyncNoPlanPermissionErrorPage", ()=>$d08fb773ac6c1816$export$e595d2c5dfcb1d5a);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $lfTZh;
    var $kxZPA;
    const $d08fb773ac6c1816$var$LazyNoPlanPermissionErrorPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("bBOev")), {
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/no-plan-permission/index.tsx"
    });
    const $d08fb773ac6c1816$export$e595d2c5dfcb1d5a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "arj-no-plan-permission",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d08fb773ac6c1816$var$LazyNoPlanPermissionErrorPage, props));
});
parcelRegister("bBOev", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("db3ID").then(()=>parcelRequire('dycHB'));
});
parcelRegister("jMY1T", function(module, exports) {
    $parcel$export(module.exports, "AsyncNotFoundErrorPage", ()=>$900bf2ccc30cc7be$export$8f6c907860218fdc);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $lfTZh;
    var $kxZPA;
    const $900bf2ccc30cc7be$var$LazyNotFoundErrorPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hElcm")), {
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/not-found/index.tsx"
    });
    const $900bf2ccc30cc7be$export$8f6c907860218fdc = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "arj-not-found-page",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($900bf2ccc30cc7be$var$LazyNotFoundErrorPage, props));
});
parcelRegister("hElcm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4cS57").then(()=>parcelRequire('3jte6'));
});
parcelRegister("5V8wX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("ioM1b")),
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("LIqdo")
    ]).then(()=>parcelRequire('ecw8s'));
});
parcelRegister("BXMfg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9iCqI").then(()=>parcelRequire('ikoZN'));
});
parcelRegister("5KRXt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("gWdbV")),
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gF51l")
    ]).then(()=>parcelRequire('9UXSF'));
});
parcelRegister("dq5QR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aRh7g")
    ]).then(()=>parcelRequire('bF4NR'));
});
parcelRegister("8iyFV", function(module, exports) {
    $parcel$export(module.exports, "AsyncHorizontalNavPlans", ()=>$ee88d7a7192b9e04$export$84e1a5f003939496);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $ee88d7a7192b9e04$var$LazyHorizontalPlansNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("eYMnB")).then(({ HorizontalPlansNav: HorizontalPlansNav })=>HorizontalPlansNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-plans/src/ui/index.tsx"
    });
    const $ee88d7a7192b9e04$export$84e1a5f003939496 = ({ store: store })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-software-plans-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ee88d7a7192b9e04$var$LazyHorizontalPlansNav, {
            store: store
        }));
});
parcelRegister("eYMnB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("gnY34")),
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("aqH3P")
    ]).then(()=>parcelRequire('fYibJ'));
});
parcelRegister("937TY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$375ae1bde651f684$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $375ae1bde651f684$var$LazyPlanSidebar = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("ezRmi")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/plan/src/index.tsx"
    });
    const $375ae1bde651f684$var$PlanSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "Plan"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($375ae1bde651f684$var$LazyPlanSidebar, null)));
    $375ae1bde651f684$var$PlanSidebar.displayName = 'PlanSidebar';
    var $375ae1bde651f684$export$2e2bcd8739ae039 = $375ae1bde651f684$var$PlanSidebar;
});
parcelRegister("dZQxE", function(module, exports) {
    $parcel$export(module.exports, "SidebarBoundary", ()=>$e39fc1e1d73100a0$export$1edc778464f08256);
    var $5uXOq = parcelRequire("5uXOq");
    var $5e7oM;
    var $azzrO;
    var $lfTZh;
    var $5Hj3V;
    var $acDan;
    var $lGo7j;
    const $e39fc1e1d73100a0$export$1edc778464f08256 = ({ children: children, id: id })=>{
        const onFail = (0, (0, parcelRequire("acDan")).useSidebarFail)();
        const onSuccess = (0, (0, parcelRequire("acDan")).useSidebarSuccess)();
        const onError = (0, $5uXOq.useCallback)((location, error)=>{
            const { statusCode: statusCode } = error;
            if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
            else onFail(location, error);
        }, [
            onFail,
            onSuccess
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Hj3V")).SidebarErrorBoundary), {
            id: id,
            packageName: "jiraSpaAppsSidebarCommon",
            onError: onError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderAttempt
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarSSRPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrStart
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).PlaceholderNew), {
            name: "nav-sidebar",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), {
                isFull: true
            })
        }, children));
    };
});
parcelRegister("5e7oM", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", ()=>$83022b592d1d8567$export$6635720e40ea7a7a);
    $parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", ()=>$83022b592d1d8567$export$1d3c3cb357af0e86);
    $parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", ()=>$83022b592d1d8567$export$e7a14fa81b3c6488);
    $parcel$export(module.exports, "NAVIGATION_TOP_MARKS", ()=>$83022b592d1d8567$export$ad760bb9734bf93f);
    $parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", ()=>$83022b592d1d8567$export$1d10ee0c85c3cb21);
    const $83022b592d1d8567$export$6635720e40ea7a7a = 'navigation.top';
    const $83022b592d1d8567$export$1d3c3cb357af0e86 = 'navigation.sidebar';
    const $83022b592d1d8567$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
    const $83022b592d1d8567$export$ad760bb9734bf93f = {
        renderStart: 'navigation-top.render.start',
        renderEnd: 'navigation-top.render.end',
        renderSsrStart: 'navigation-top.render.ssr.start',
        renderSsrEnd: 'navigation-top.render.ssr.end',
        bundleLoadStart: 'navigation-top.bundle-load.start'
    };
    const $83022b592d1d8567$export$1d10ee0c85c3cb21 = {
        renderAttempt: 'navigation-sidebar.render.attempt',
        renderStart: 'navigation-sidebar.render.start',
        renderEnd: 'navigation-sidebar.render.end',
        renderSsrStart: 'navigation-sidebar.render.ssr.start',
        renderSsrEnd: 'navigation-sidebar.render.ssr.end',
        loadStart: 'navigation-sidebar.load.start',
        loadEnd: 'navigation-sidebar.load.end'
    };
});
parcelRegister("azzrO", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", ()=>$4d07bc740e316cc0$export$8df02628d98cae7e);
    $parcel$export(module.exports, "pageSegmentStore", ()=>$4d07bc740e316cc0$export$26cadbe0bcaabcde);
    $parcel$export(module.exports, "useNavPerformanceMetrics", ()=>$4d07bc740e316cc0$export$906025848d54198d);
    $parcel$export(module.exports, "NavTopPerformanceMark", ()=>$4d07bc740e316cc0$export$b7f4caa65b0906fc);
    $parcel$export(module.exports, "NavTopSSRPerformanceMark", ()=>$4d07bc740e316cc0$export$2c4a101f2cde4fc2);
    $parcel$export(module.exports, "NavTopPerformanceReport", ()=>$4d07bc740e316cc0$export$c64b31449a6177d);
    $parcel$export(module.exports, "NavSidebarPerformanceMark", ()=>$4d07bc740e316cc0$export$35b2aeea5cbc963e);
    $parcel$export(module.exports, "NavSidebarSSRPerformanceMark", ()=>$4d07bc740e316cc0$export$14f711a2cb6a655a);
    $parcel$export(module.exports, "NavSidebarPerformanceReport", ()=>$4d07bc740e316cc0$export$a018e347341b3640);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $dGrdR;
    var $cfDZ3;
    var $5M3R9;
    var $5e7oM;
    const $4d07bc740e316cc0$var$createTopNavPageSegment = ()=>(0, (0, parcelRequire("dGrdR")).metrics).pageSegmentLoad({
            key: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME),
            timings: [
                {
                    key: 'ttic',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderEnd
                },
                {
                    key: 'tti',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderEnd
                },
                {
                    key: 'ttr',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrEnd
                },
                {
                    key: 'ttrc',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrEnd
                },
                {
                    key: 'bundle-load',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).bundleLoadStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderStart
                }
            ],
            histogram: {
                initial: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '4000_4500_5000_6000_7000_8000_9000'
                },
                transition: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '2500_3000_3500_4000_5000_6000'
                }
            }
        });
    const $4d07bc740e316cc0$export$8df02628d98cae7e = {
        ADDONS: (0, (0, parcelRequire("dGrdR")).metrics).interaction({
            key: 'navigation-top.addons-dropdown-opened'
        })
    };
    const $4d07bc740e316cc0$var$createSidebarPageSegment = ()=>(0, (0, parcelRequire("dGrdR")).metrics).pageSegmentLoad({
            key: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME),
            timings: [
                {
                    key: 'renderAttempt',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderAttempt
                },
                {
                    key: 'ttic',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderEnd
                },
                {
                    key: 'tti',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderEnd
                },
                {
                    key: 'ttr',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
                },
                {
                    key: 'ttrc',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
                },
                {
                    key: 'load',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadEnd
                }
            ],
            histogram: {
                initial: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '4000_4500_5000_6000_7000_8000_9000'
                },
                transition: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '2500_3000_3500_4000_5000_6000'
                }
            }
        });
    const $4d07bc740e316cc0$export$26cadbe0bcaabcde = (()=>{
        const segmentConstructors = {
            [(0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createTopNavPageSegment,
            [(0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createSidebarPageSegment
        };
        const segments = {};
        return {
            getSegment: (key)=>{
                if (!segments[key]) {
                    if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                    segments[key] = segmentConstructors[key]();
                }
                return segments[key];
            }
        };
    })();
    const $4d07bc740e316cc0$export$906025848d54198d = (segmentKey = (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME))=>{
        const startedRef = (0, $5uXOq.useRef)(false);
        const segment = (0, $5uXOq.useRef)($4d07bc740e316cc0$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
        if (!false && !startedRef.current) {
            segment && segment.startFromPageLoad();
            startedRef.current = true;
        }
        return (0, $5uXOq.useMemo)(()=>Object.assign(segment, {
                markSSR: (metricKey)=>{
                    const tmpSsrMetricKey = `${(0, (0, parcelRequire("5e7oM")).NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                    if (window.SPA_STATE) {
                        const { startTime: startTime = 0, duration: duration = 0 } = (0, ($parcel$interopDefault($9XE6b)))((0, (0, parcelRequire("5M3R9")).getRenderTraceFromSSRGlobal)(), [
                            'traces',
                            `render/${tmpSsrMetricKey}`
                        ]) || {};
                        const markTime = startTime + duration;
                        markTime && markTime > 0 && segment.mark(metricKey, markTime);
                    }
                }
            }), [
            segment
        ]);
    };
    const $4d07bc740e316cc0$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
        const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
        (0, $5uXOq.useEffect)(()=>navSegment.mark(metricKey), []);
        return null;
    };
    const $4d07bc740e316cc0$var$NavigationSSRPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
        const tmpSsrMetricKey = `${(0, (0, parcelRequire("5e7oM")).NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
        const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
        (0, $5uXOq.useEffect)(()=>navSegment.markSSR(metricKey), []);
        return false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "end",
            traceKey: tmpSsrMetricKey
        }) : null;
    };
    const $4d07bc740e316cc0$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
        const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
        (0, $5uXOq.useEffect)(()=>{
            navSegment.stop({
                customData: {
                    ...customData,
                    userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)()
                }
            });
            navSegment.clear();
        }, []);
        return null;
    };
    const $4d07bc740e316cc0$export$b7f4caa65b0906fc = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$2c4a101f2cde4fc2 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$c64b31449a6177d = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$35b2aeea5cbc963e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$14f711a2cb6a655a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$a018e347341b3640 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
});
parcelRegister("5M3R9", function(module, exports) {
    $parcel$export(module.exports, "RenderTracerMark", ()=>$ca67b9a5090b457c$export$54c89059bb435049);
    $parcel$export(module.exports, "getRenderTraceFromSSRGlobal", ()=>$ca67b9a5090b457c$export$345f21b0287f67e5);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Csk1 = parcelRequire("6Csk1");
    var $9XE6b = parcelRequire("9XE6b");
    var $jR67t;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $ca67b9a5090b457c$var$initialState = {
        start: undefined,
        traces: {}
    };
    let $ca67b9a5090b457c$var$currentTraces = {};
    const $ca67b9a5090b457c$export$2365ecd8218e21c7 = ()=>$ca67b9a5090b457c$var$currentTraces;
    const $ca67b9a5090b457c$export$5c757eaa1990d0d7 = (key)=>{
        if ($ca67b9a5090b457c$var$currentTraces[key]) return;
        $ca67b9a5090b457c$var$currentTraces[key] = {
            startTime: (0, (0, parcelRequire("jR67t")).performance).now()
        };
    };
    const $ca67b9a5090b457c$export$16854dc18f8d976 = (key)=>{
        if (!$ca67b9a5090b457c$var$currentTraces[key] || $ca67b9a5090b457c$var$currentTraces[key].duration != null) return;
        $ca67b9a5090b457c$var$currentTraces[key].duration = (0, (0, parcelRequire("jR67t")).performance).now() - $ca67b9a5090b457c$var$currentTraces[key].startTime;
    };
    const $ca67b9a5090b457c$var$actions = {
        startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
                const { start: start, traces: traces } = getState();
                if (start === undefined) return;
                const key = name === startKey ? name : `${startKey}/${name}`;
                if (traces[key]) return;
                setState({
                    traces: (0, ($parcel$interopDefault($6Csk1)))({}, traces, {
                        [key]: {
                            startTime: time
                        }
                    })
                });
            },
        endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
                const { start: start, traces: traces } = getState();
                if (start === undefined) return;
                const key = name === startKey ? name : `${startKey}/${name}`;
                const trace = traces[key] || {
                    startTime: 0
                };
                setState({
                    traces: (0, ($parcel$interopDefault($6Csk1)))({}, traces, {
                        [key]: {
                            ...trace,
                            duration: time - trace.startTime
                        }
                    })
                });
                $ca67b9a5090b457c$var$currentTraces = Object.assign($ca67b9a5090b457c$var$currentTraces, getState().traces);
            }
    };
    const $ca67b9a5090b457c$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'jira-render-tracer',
        initialState: $ca67b9a5090b457c$var$initialState,
        actions: $ca67b9a5090b457c$var$actions
    });
    const $ca67b9a5090b457c$var$RenderTracerActions = (0, (0, parcelRequire("51nlc")).createSubscriber)($ca67b9a5090b457c$var$Store, {
        selector: null
    });
    const $ca67b9a5090b457c$export$719a95758870be58 = (0, (0, parcelRequire("3sQ5x")).createHook)($ca67b9a5090b457c$var$Store, {
        selector: null
    });
    const $ca67b9a5090b457c$var$RenderTracerContainerBase = (0, (0, parcelRequire("gg7kZ")).createContainer)($ca67b9a5090b457c$var$Store, {
        onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
                setState({
                    start: startTime,
                    traces: {
                        [startKey]: {
                            startTime: (0, (0, parcelRequire("jR67t")).performance).now()
                        }
                    }
                });
            }
    });
    const $ca67b9a5090b457c$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>(0, ($parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerContainerBase, {
            startKey: startKey,
            startTime: startTime
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$export$54c89059bb435049, {
            traceKey: startKey,
            type: "end"
        }));
    const $ca67b9a5090b457c$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>(0, ($parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
            if (type === 'start') startTrace(traceKey, (0, (0, parcelRequire("jR67t")).performance).now());
            else if (type === 'end') endTrace(traceKey, (0, (0, parcelRequire("jR67t")).performance).now());
            return null;
        });
    const $ca67b9a5090b457c$export$cba8addc8743389c = (appName = 'unknown', traces = $ca67b9a5090b457c$var$currentTraces)=>({
            [(0, $eb0760a6ada94ab6$export$3c96fa14fb694e11)]: {
                data: {
                    traces: traces,
                    routeName: appName
                }
            }
        });
    const $ca67b9a5090b457c$export$345f21b0287f67e5 = ()=>(0, ($parcel$interopDefault($9XE6b)))(window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
            (0, $eb0760a6ada94ab6$export$3c96fa14fb694e11),
            'data'
        ], {});
});
parcelRegister("jR67t", function(module, exports) {
    $parcel$export(module.exports, "performance", ()=>$c026bc7061377d6e$export$f2d2284f5fec51f8);
    const $c026bc7061377d6e$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
    class $c026bc7061377d6e$export$9a0dbed22cbf63be {
        start() {
            if (false) this.startAt = $c026bc7061377d6e$var$now();
        }
        now() {
            if (false) return $c026bc7061377d6e$var$now() - this.startAt;
            return $c026bc7061377d6e$var$now();
        }
        constructor(){
            this.startAt = $c026bc7061377d6e$var$now();
        }
    }
    const $c026bc7061377d6e$export$f2d2284f5fec51f8 = new $c026bc7061377d6e$export$9a0dbed22cbf63be();
});
const $eb0760a6ada94ab6$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';
parcelRegister("5Hj3V", function(module, exports) {
    $parcel$export(module.exports, "SidebarErrorBoundary", ()=>$c3958cf153a091e2$export$62853c5766dad0c4);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $cfDZ3;
    var $kqzba;
    const $c3958cf153a091e2$export$62853c5766dad0c4 = (props)=>{
        const userLocation = (0, (0, parcelRequire("cfDZ3")).getUserLocation)();
        const extraEventData = (0, $5uXOq.useMemo)(()=>({
                ...props.extraEventData,
                userLocation: userLocation
            }), [
            props.extraEventData,
            userLocation
        ]);
        const fallback = (0, $5uXOq.useCallback)(({ error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kqzba")).Fallback), {
                error: error
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            ...props,
            extraEventData: extraEventData,
            fallback: fallback
        });
    };
});
parcelRegister("kqzba", function(module, exports) {
    $parcel$export(module.exports, "Fallback", ()=>$790c5d1c3d335eca$export$fb8d7f40caaeea67);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $l1N8i;
    var $kobfu;
    var $koVbs;
    var $evbHg = parcelRequire("evbHg");
    var $h8OaL;
    const $790c5d1c3d335eca$var$styles = {
        wrapper: "_bfhk1jdc _syaz1mjl _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc _1e0c1txw _2lx21bp4",
        error: "_2rko9j3y _1wybqk37 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
        image: "_4t3i12am"
    };
    const $790c5d1c3d335eca$export$fb8d7f40caaeea67 = (props)=>{
        const { error: error } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $790c5d1c3d335eca$var$styles.wrapper
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            alt: "",
            src: (0, ($parcel$interopDefault($evbHg))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $790c5d1c3d335eca$var$styles.image
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("h8OaL")).default).errorHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("h8OaL")).default).errorBody)), (0, ($parcel$interopDefault($5uXOq))).createElement("code", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $790c5d1c3d335eca$var$styles.error
            ])
        }, "ERROR: ", (0, (0, parcelRequire("kobfu")).getErrorHash)(error)));
    };
});
parcelRegister("evbHg", function(module, exports) {
    module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();
});
parcelRegister("h8OaL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7c8a71ff5065c1e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e7c8a71ff5065c1e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorHeading: {
            "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
            "defaultMessage": "Something went wrong"
        },
        errorBody: {
            "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
            "defaultMessage": "Try refreshing or navigating to another page."
        }
    });
});
parcelRegister("acDan", function(module, exports) {
    $parcel$export(module.exports, "SidebarStart", ()=>$b5a3a4467dac2130$export$6738d1299dc79710);
    $parcel$export(module.exports, "SidebarRenderStart", ()=>$b5a3a4467dac2130$export$ba19e3624956e66);
    $parcel$export(module.exports, "SidebarReady", ()=>$b5a3a4467dac2130$export$a06ecbbe5820282);
    $parcel$export(module.exports, "useSidebarFail", ()=>$b5a3a4467dac2130$export$661ed14c8f75da9f);
    $parcel$export(module.exports, "useSidebarSuccess", ()=>$b5a3a4467dac2130$export$ddb17534fdfb7dc6);
    var $5uXOq = parcelRequire("5uXOq");
    var $5e7oM;
    var $azzrO;
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $4QcD9;
    var $6jY6G;
    var $8zOmE;
    var $2NMNM;
    var $6IzHB;
    var $doZTA;
    var $kvHKs;
    const { useValue: $b5a3a4467dac2130$var$useSidebarId } = (0, (0, parcelRequire("4QcD9")).createValueController)('sidebar-id');
    const $b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
        experience: (0, (0, parcelRequire("kvHKs")).SIDEBAR_EXPERIENCE),
        attributes: {
            sidebar: 'v3'
        }
    };
    const $b5a3a4467dac2130$export$6738d1299dc79710 = ()=>{
        const [{ route: route, match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const pageId = (0, (0, parcelRequire("6IzHB")).usePageId)();
        const startRef = (0, $5uXOq.useRef)(Date.now());
        const onStartExperience = (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experienceId: pageId,
            experience: (0, (0, parcelRequire("kvHKs")).SIDEBAR_EXPERIENCE),
            analyticsSource: 'Sidebar'
        });
        (0, $5uXOq.useMemo)(()=>{
            if (route.isRedirect ?? false) return;
            onStartExperience();
            startRef.current = Date.now();
        }, [
            route,
            match
        ]);
        return null;
    };
    const $b5a3a4467dac2130$export$ba19e3624956e66 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderStart
        });
    const $b5a3a4467dac2130$export$a06ecbbe5820282 = ({ id: id })=>{
        const [, setSidebarId] = $b5a3a4467dac2130$var$useSidebarId();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const routeName = route.name ?? route.group ?? 'UNKNOWN';
        const onSuccess = (0, (0, parcelRequire("3bQtK")).useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
        (0, $5uXOq.useEffect)(()=>{
            setSidebarId(id);
            return ()=>setSidebarId();
        }, [
            setSidebarId,
            id
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (route.isRedirect ?? false) return;
            onSuccess();
        }, [
            onSuccess,
            route
        ]);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            window.__POLLINATOR__ = {
                ...window.__POLLINATOR__,
                routeName: routeName
            };
            const event = createAnalyticsEvent({
                action: 'ready',
                actionSubject: 'sidebar',
                meta: {
                    teamName: 'endeavour'
                }
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'Sidebar Ready', {
                route: routeName
            });
        }, [
            createAnalyticsEvent,
            routeName
        ]);
        const customData = (0, $5uXOq.useMemo)(()=>({
                route: routeName,
                sidebarId: id
            }), [
            routeName,
            id
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderEnd
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceReport), {
            customData: customData
        }));
    };
    const $b5a3a4467dac2130$export$661ed14c8f75da9f = ()=>{
        const onFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: (0, (0, parcelRequire("kvHKs")).SIDEBAR_EXPERIENCE)
        });
        return (0, $5uXOq.useCallback)((location, error)=>{
            onFail(location, error);
        }, [
            onFail
        ]);
    };
    const $b5a3a4467dac2130$export$ddb17534fdfb7dc6 = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
});
parcelRegister("93jKl", function(module, exports) {
    $parcel$export(module.exports, "useExperienceFail", ()=>$e2626e1ab0692489$export$606da7704d8eaf06);
    var $5uXOq = parcelRequire("5uXOq");
    var $fZneA;
    var $bCf8q;
    var $l9g16;
    const $e2626e1ab0692489$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const self = (0, $5uXOq.useRef)({
            name: experience,
            attributes: attributes,
            experienceTracker: experienceTracker
        });
        self.current.name = experience;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        return (0, $5uXOq.useCallback)((location, error, extraAttributes = {})=>{
            const { current: current } = self;
            if ((0, (0, parcelRequire("bCf8q")).isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) return;
            current.experienceTracker.fail({
                name: current.name,
                error: error,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes,
                    location: location
                }
            });
        }, [
            self
        ]);
    };
});
parcelRegister("l9g16", function(module, exports) {
    $parcel$export(module.exports, "useExperienceContext", ()=>$79f23c22d88dd8d5$export$be8ec22ac9208049);
    var $5uXOq = parcelRequire("5uXOq");
    var $bSOOm;
    const $79f23c22d88dd8d5$export$be8ec22ac9208049 = ()=>{
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bSOOm")).ExperienceTrackerContext));
        return context;
    };
});
parcelRegister("kaHBi", function(module, exports) {
    $parcel$export(module.exports, "useExperienceStart", ()=>$e1187df33c58b997$export$675e0d25df38d426);
    $parcel$export(module.exports, "ExperienceStart", ()=>$e1187df33c58b997$export$f20b867e738a222c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $l9g16;
    const $e1187df33c58b997$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
        const self = (0, $5uXOq.useRef)({
            experienceId: experienceId,
            experience: experience,
            timeout: timeout,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            experienceTracker: experienceTracker,
            disableSli: disableSli,
            userLocation: userLocation,
            collect: collect
        });
        self.current.experienceId = experienceId;
        self.current.experience = experience;
        self.current.timeout = timeout;
        self.current.analyticsSource = analyticsSource;
        self.current.application = application;
        self.current.edition = edition;
        self.current.experienceTracker = experienceTracker;
        self.current.userLocation = userLocation;
        self.current.collect = collect;
        return (0, $5uXOq.useCallback)(()=>{
            const { current: current } = self;
            current.experienceTracker.start({
                id: current.experienceId,
                name: current.experience,
                timeout: current.timeout,
                attributes: {
                    analyticsSource: current.analyticsSource,
                    experience: current.experience,
                    experienceId: current.experienceId,
                    application: current.application,
                    edition: current.edition,
                    disableSli: current.disableSli,
                    userLocation: current.userLocation
                },
                collect: current.collect,
                onSuccess: ()=>undefined
            });
        }, [
            self
        ]);
    };
    const $e1187df33c58b997$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
        const onStart = $e1187df33c58b997$export$675e0d25df38d426({
            experienceId: experienceId,
            experience: experience,
            timeout: timeout,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            disableSli: disableSli,
            collect: collect
        });
        (0, $5uXOq.useMemo)(()=>{
            onStart();
        }, [
            onStart,
            experienceId,
            experience,
            timeout,
            analyticsSource,
            application,
            edition,
            disableSli,
            collect
        ]);
        return null;
    };
});
parcelRegister("3bQtK", function(module, exports) {
    $parcel$export(module.exports, "useExperienceSuccess", ()=>$f46ca4b214d7cdb6$export$e94f0da4fc0603c6);
    $parcel$export(module.exports, "ExperienceSuccess", ()=>$f46ca4b214d7cdb6$export$4962f3898bd5c829);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $l9g16;
    const $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT = {};
    const $f46ca4b214d7cdb6$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const self = (0, $5uXOq.useRef)({
            experience: experience,
            attributes: attributes,
            experienceTracker: experienceTracker,
            route: route
        });
        self.current.route = route;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        self.current.experience = experience;
        return (0, $5uXOq.useCallback)((extraAttributes = {})=>{
            const { current: current } = self;
            if (current.route && current.route.isRedirect === true) return;
            current.experienceTracker.succeed({
                name: current.experience,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes
                }
            });
        }, [
            self
        ]);
    };
    const $f46ca4b214d7cdb6$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
        const onExperienceSuccess = $f46ca4b214d7cdb6$export$e94f0da4fc0603c6({
            experience: experience,
            attributes: attributes
        });
        (0, $5uXOq.useEffect)(()=>{
            onExperienceSuccess();
        }, [
            attributes,
            onExperienceSuccess
        ]);
        (0, $5uXOq.useMemo)(()=>{
            if (false) onExperienceSuccess();
        }, [
            onExperienceSuccess
        ]);
        return null;
    };
});
parcelRegister("4QcD9", function(module, exports) {
    $parcel$export(module.exports, "createValueController", ()=>$3f293f209341d999$export$ff0ab9dd4ceb4a93);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $3f293f209341d999$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
        const actions = {
            setValue: (value)=>({ setState: setState })=>setState({
                        value: value
                    })
        };
        const initialState = {
            value: defaultValue
        };
        const store = (0, (0, parcelRequire("iXqE5")).createStore)({
            name: name,
            initialState: initialState,
            actions: actions
        });
        const ValueContainer = (0, (0, parcelRequire("gg7kZ")).createContainer)(store);
        const selector = (state)=>state.value;
        const useValueInternal = (0, (0, parcelRequire("3sQ5x")).createHook)(store, {
            selector: selector
        });
        const useValue = ()=>{
            const [value, { setValue: setValue }] = useValueInternal();
            return [
                value,
                setValue
            ];
        };
        return {
            ValueContainer: ValueContainer,
            useValue: useValue
        };
    };
});
parcelRegister("6IzHB", function(module, exports) {
    $parcel$export(module.exports, "usePageId", ()=>$57184c749af08735$export$3434ba5eadb360dc);
    var $3sQ5x;
    var $7w9eZ;
    const $57184c749af08735$var$useSweetStatePageId = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: (state)=>state.currentPage.uuid
    });
    const $57184c749af08735$export$3434ba5eadb360dc = ()=>{
        const [pageId] = $57184c749af08735$var$useSweetStatePageId();
        return pageId;
    };
});
parcelRegister("kvHKs", function(module, exports) {
    $parcel$export(module.exports, "REPO_TYPE", ()=>$f1419662a60c783a$export$399c7e6858236b4);
    $parcel$export(module.exports, "LINK_TYPE", ()=>$f1419662a60c783a$export$58125ce2bb1c3378);
    $parcel$export(module.exports, "EMOJI_REGEX", ()=>$f1419662a60c783a$export$c79ed2783644934c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", ()=>$f1419662a60c783a$export$25ae65041c800c9);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", ()=>$f1419662a60c783a$export$e03c9beea817d44b);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", ()=>$f1419662a60c783a$export$3d575bdf28c0d17c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", ()=>$f1419662a60c783a$export$af84baced6970a17);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", ()=>$f1419662a60c783a$export$c767f253046b1ea7);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", ()=>$f1419662a60c783a$export$265b9384cc2dfbd4);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", ()=>$f1419662a60c783a$export$2de77b357e71c7a7);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", ()=>$f1419662a60c783a$export$7de7abb92169d6c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", ()=>$f1419662a60c783a$export$fd7df8bd7600c65c);
    $parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", ()=>$f1419662a60c783a$export$dde074e512e80dff);
    $parcel$export(module.exports, "REPORTS_IDS", ()=>$f1419662a60c783a$export$1f70a76cb421b107);
    $parcel$export(module.exports, "SIDEBAR_EXPERIENCE", ()=>$f1419662a60c783a$export$71aaf2625ee54d10);
    $parcel$export(module.exports, "staticLegacyIds", ()=>$f1419662a60c783a$export$f57650e6e7be03dc);
    const $f1419662a60c783a$export$399c7e6858236b4 = 'source.code.link';
    const $f1419662a60c783a$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
    const $f1419662a60c783a$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
    const $f1419662a60c783a$export$25ae65041c800c9 = 'pin-filter-myopenissues';
    const $f1419662a60c783a$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
    const $f1419662a60c783a$export$3d575bdf28c0d17c = 'pin-filter-allissues';
    const $f1419662a60c783a$export$af84baced6970a17 = 'pin-filter-allopenissues';
    const $f1419662a60c783a$export$c767f253046b1ea7 = 'pin-filter-doneissues';
    const $f1419662a60c783a$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
    const $f1419662a60c783a$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
    const $f1419662a60c783a$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
    const $f1419662a60c783a$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
    const $f1419662a60c783a$export$dde074e512e80dff = 'global-create-spotlight';
    const $f1419662a60c783a$export$1f70a76cb421b107 = {
        REPORTS_ADDONS: 'sd-reports-addons'
    };
    const $f1419662a60c783a$export$83016cff6318a5dd = Object.freeze({
        CODE_TAB: 'CODE_TAB',
        ONCALL_TAB: 'ONCALL_TAB',
        PAGES_TAB: 'PAGES_TAB'
    });
    const $f1419662a60c783a$export$f371b4c263b142af = {
        [$f1419662a60c783a$export$83016cff6318a5dd.CODE_TAB]: 'code',
        [$f1419662a60c783a$export$83016cff6318a5dd.ONCALL_TAB]: 'opsgenie',
        [$f1419662a60c783a$export$83016cff6318a5dd.PAGES_TAB]: 'pages'
    };
    const $f1419662a60c783a$export$b66c40cadee12a0b = 'project/agility/index';
    const $f1419662a60c783a$export$6f454e69bce3a691 = 'project/business/index';
    const $f1419662a60c783a$export$3a0f7f7a8a0b306b = 'project/ops/index';
    const $f1419662a60c783a$export$1346c9aa3cbb477d = 'project/software/index';
    const $f1419662a60c783a$export$4598dd67943205cf = 'project/software/issues';
    const $f1419662a60c783a$export$8f36e85c5afae5 = 'project/software/reports';
    const $f1419662a60c783a$export$8151e5564c0016a1 = 'attachments';
    const $f1419662a60c783a$export$4acd0d06a25e56b5 = 'eventtypes';
    const $f1419662a60c783a$export$211ab01804585e09 = 'webhooks-admin';
    const $f1419662a60c783a$export$294b9ab8545a9f36 = 'services';
    const $f1419662a60c783a$export$665efe695022359b = 'greenhopper-lexorank-manage';
    const $f1419662a60c783a$export$47fbefc73055eb9d = 'admin-helper-admin-section';
    const $f1419662a60c783a$export$76e6bd729450de52 = 'advanced_section';
    const $f1419662a60c783a$export$ac928a90c0d3daa8 = 'collectors';
    const $f1419662a60c783a$export$309ac0136b7d5dfa = 'dark_features';
    const $f1419662a60c783a$export$998f1706a6ca29b = 'general_configuration';
    const $f1419662a60c783a$export$e9af81a594543847 = 'import_export_section';
    const $f1419662a60c783a$export$bbf19cc23216c6b = 'mail_section';
    const $f1419662a60c783a$export$693dd06b18660b78 = 'security_section';
    const $f1419662a60c783a$export$c6d1221ea0bce75e = 'shared_section';
    const $f1419662a60c783a$export$c7d7c0d436dd54b1 = 'troubleshooting_and_support';
    const $f1419662a60c783a$export$af156d8e27fc5458 = 'user_interface';
    const $f1419662a60c783a$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
    const $f1419662a60c783a$export$f57650e6e7be03dc = [
        'general_configuration',
        'dark_features',
        'troubleshooting_and_support',
        'view_auditing',
        'pluginViewer',
        'pluginViewer',
        'system_info',
        'integrity_checker',
        'logging_profiling',
        'scheduler_details',
        'security_section',
        'project_role_browser',
        'global_permissions',
        'collectors',
        'user_interface',
        'user_defaults',
        'edit_default_dashboard',
        'lookandfeel',
        'com.atlassian.pas:pas-admin-link-jira',
        'import_export_section',
        'vertigo_export',
        'external_import',
        'vertigo_import',
        'vertigo_import_jira_cloud',
        'vertigo_import_jira_server',
        'mail_section',
        'global_mail_settings',
        'outgoing_mail',
        'incoming_mail',
        'send_email',
        'admin-helper-admin-section',
        'permissionhelper-admin-page',
        'notificationhelper-admin-page',
        'shared_section',
        'shared_filters',
        'shared_dashboards',
        'advanced_section',
        'attachments',
        'eventtypes',
        'webhooks-admin',
        'services',
        'manage_dashboards',
        'manage_filters',
        'greenhopper-lexorank-manage',
        'jira.webfragments.view.project.operations:edit_project',
        'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
        'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
        'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
        'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
        'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
        'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
        'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
        'com.atlassian.jira.jira-projects-plugin:administer_project_components',
        'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
        'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
        'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
        'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
        'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
        'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
        'com.atlassian.jira.jira-projects-plugin:administer_project_code',
        'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
        'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
        'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
        'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
        'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
        'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
        'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
        'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
        'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
        'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
        'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
        'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
        'com.codebarrel.addons.automation__cb-automation'
    ];
});
parcelRegister("lGo7j", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$0c703bf4651638aa$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fNobW;
    var $gjTBi;
    var $bWqXX;
    const $0c703bf4651638aa$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "sidebar-skeleton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$BackgroundedWrapper, null, isFull && (0, ($parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$HeadingWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: true
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }))));
    const $0c703bf4651638aa$var$BackgroundedWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tem _1yt4s5g3",
                __cmplp.className
            ])
        });
    });
    const $0c703bf4651638aa$var$HeadingWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41k9c",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("gjTBi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab78cae21894a64c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9UCCQ;
    var $jsTfk;
    var $j9VTE;
    const $ab78cae21894a64c$var$Section = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        if (!shouldRender) return props.children;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            ...props,
            ref: ref,
            overrides: {
                HeadingItem: {
                    cssFn: (0, (0, parcelRequire("jsTfk")).sectionHeaderSpacingStyles)
                }
            }
        });
    });
    var $ab78cae21894a64c$export$2e2bcd8739ae039 = $ab78cae21894a64c$var$Section;
});
parcelRegister("jsTfk", function(module, exports) {
    $parcel$export(module.exports, "overrideStyleFunction", ()=>$0d8b3d5d608d86de$export$505cedac1a39aacf);
    $parcel$export(module.exports, "baseSideNavItemStyle", ()=>$0d8b3d5d608d86de$export$aed216a85ec468ac);
    $parcel$export(module.exports, "sectionHeaderSpacingStyles", ()=>$0d8b3d5d608d86de$export$a5c27bed78cfecb9);
    const $0d8b3d5d608d86de$export$505cedac1a39aacf = (baseStyle, newStyle = ()=>({}))=>{
        return (state)=>{
            return [
                baseStyle(state),
                newStyle(state)
            ];
        };
    };
    const $0d8b3d5d608d86de$var$defaultStyles = {
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        },
        '&:active': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`
        }
    };
    const $0d8b3d5d608d86de$var$selectedStyles = {
        backgroundColor: `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        ':visited': {
            color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        }
    };
    const $0d8b3d5d608d86de$export$aed216a85ec468ac = ({ isSelected: isSelected, isDisabled: isDisabled })=>{
        return {
            paddingBlock: "var(--ds-space-100, 8px)",
            paddingInline: "var(--ds-space-100, 8px)",
            borderRadius: "var(--ds-border-radius, 3px)",
            backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
            ...!isDisabled && !isSelected && $0d8b3d5d608d86de$var$defaultStyles,
            ...!isDisabled && isSelected && $0d8b3d5d608d86de$var$selectedStyles,
            ['& [data-item-elem-before]']: {
                height: '1.5rem',
                width: '1.5rem'
            }
        };
    };
    const $0d8b3d5d608d86de$export$a5c27bed78cfecb9 = ()=>{
        return {
            paddingInline: "var(--ds-space-100, 8px)"
        };
    };
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("bWqXX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c4e822429ecf69c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iwwXK;
    var $jsTfk;
    var $j9VTE;
    const $9c4e822429ecf69c$var$SkeletonItem = (props)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            cssFn: ()=>({
                    ...(0, (0, parcelRequire("jsTfk")).sectionHeaderSpacingStyles)(),
                    '&&::before': {
                        height: '1.5rem',
                        marginRight: "var(--ds-space-200, 16px)",
                        width: '1.5rem'
                    }
                }),
            ...props
        });
    };
    var $9c4e822429ecf69c$export$2e2bcd8739ae039 = $9c4e822429ecf69c$var$SkeletonItem;
});
parcelRegister("gbGmI", function(module, exports) {
    $parcel$export(module.exports, "setPerformanceMarkLoadStart", ()=>$46c186c6902de7dc$export$4166241bf9111f66);
    $parcel$export(module.exports, "setPerformanceMarkLoadEnd", ()=>$46c186c6902de7dc$export$edbd543f308bbef5);
    var $5e7oM;
    var $azzrO;
    const $46c186c6902de7dc$export$4166241bf9111f66 = ()=>{
        const sideBarSegment = (0, (0, parcelRequire("azzrO")).pageSegmentStore).getSegment((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME));
        sideBarSegment.mark((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadStart);
    };
    const $46c186c6902de7dc$export$edbd543f308bbef5 = ()=>{
        const sideBarSegment = (0, (0, parcelRequire("azzrO")).pageSegmentStore).getSegment((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME));
        sideBarSegment.mark((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadEnd);
    };
});
parcelRegister("ezRmi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("exGqx")
    ]).then(()=>parcelRequire('5q8CD'));
});
parcelRegister("cp9L3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("auj8r")),
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aEaZR")
    ]).then(()=>parcelRequire('1rmO9'));
});
parcelRegister("jxlwh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("5TMh3")),
        $6fhBS("kssvB")
    ]).then(()=>parcelRequire('9U7wJ'));
});
parcelRegister("8jCIm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("4NK3n")),
        $6fhBS("1osJI")
    ]).then(()=>parcelRequire('j09X0'));
});
parcelRegister("8RcGG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("krPFv")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cQMR4")
    ]).then(()=>parcelRequire('8InOA'));
});
parcelRegister("gBsS7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("jGDgV")),
        $6fhBS("fi5lj")
    ]).then(()=>parcelRequire('ZLjUl'));
});
parcelRegister("1Nhzp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("h4JBs")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9lRZr")
    ]).then(()=>parcelRequire('1GCm8'));
});
parcelRegister("fhZxp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("cSV9k")),
        $6fhBS("fHQhR")
    ]).then(()=>parcelRequire('dx76p'));
});
parcelRegister("cs3SK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("deC5G")),
        $6fhBS("8REMF")
    ]).then(()=>parcelRequire('8aOgd'));
});
parcelRegister("4gfsQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("1QmTP")),
        $6fhBS("6qkFP")
    ]).then(()=>parcelRequire('cckoo'));
});
parcelRegister("9ben8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("4f2RV")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5hVzx")
    ]).then(()=>parcelRequire('mRA5P'));
});
parcelRegister("3ZFGv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("4IywT")),
        $6fhBS("81iXg")
    ]).then(()=>parcelRequire('k5TsF'));
});
parcelRegister("d6TuG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("a8N0m")),
        $6fhBS("dZydx")
    ]).then(()=>parcelRequire('iF2yt'));
});
parcelRegister("28rR3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("5gjrg")),
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("X6lWy")
    ]).then(()=>parcelRequire('j3U5Q'));
});
parcelRegister("iQWcF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("g1QGP")),
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("itwp0")
    ]).then(()=>parcelRequire('j7IwW'));
});
parcelRegister("2oTRI", function(module, exports) {
    $parcel$export(module.exports, "softwarePlanTimelineRoute", ()=>$946f497d921d5041$export$61abeb6a03d23dd3);
    var $65Ltd;
    const $946f497d921d5041$export$61abeb6a03d23dd3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE),
        path: '/jira/plans/:planId/scenarios/:scenarioId/timeline'
    };
});
parcelRegister("ibkIl", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsLayout", ()=>$3eb51436f6201a33$export$e6aef6083548e882);
    var $2BrOV;
    var $aPfsS;
    const $3eb51436f6201a33$export$e6aef6083548e882 = (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout));
});
parcelRegister("2Fj5v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9ddf603830cf6c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("fzGrA")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
    });
    const $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalProductsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar, null)));
    $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
    var $a9ddf603830cf6c5$export$2e2bcd8739ae039 = $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar;
});
parcelRegister("fzGrA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3FDyC")
    ]).then(()=>parcelRequire('hTSvC'));
});
parcelRegister("3DNgf", function(module, exports) {
    $parcel$export(module.exports, "issueLinkInformationResource", ()=>$8163e55c16e335dc$export$8d8544ca08d98837);
    var $eusud;
    var $2M1hQ;
    const $8163e55c16e335dc$var$body = {
        providers: [
            'issueLinks',
            'dependencySettings'
        ]
    };
    const $8163e55c16e335dc$var$url = '/rest/jpo/1.0/info/query';
    const $8163e55c16e335dc$var$fetchIssueLinkInformation = ()=>(0, (0, parcelRequire("eusud")).performPostRequest)($8163e55c16e335dc$var$url, {
            body: JSON.stringify($8163e55c16e335dc$var$body)
        });
    const $8163e55c16e335dc$export$8d8544ca08d98837 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ISSUE_LINK_INFORMATION',
        getKey: ()=>'issue-link-information',
        getData: async ()=>$8163e55c16e335dc$var$fetchIssueLinkInformation(),
        maxAge: 0
    });
});
parcelRegister("iLgJ6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bLzp5").then(()=>parcelRequire('1Ba8D'));
});
parcelRegister("3Uhkm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("7EBJU")),
        $6fhBS("bDZ6z")
    ]).then(()=>parcelRequire('ieFCi'));
});
parcelRegister("aMm01", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("31VzL").then(()=>parcelRequire('luimD'));
});
parcelRegister("azWKH", function(module, exports) {
    $parcel$export(module.exports, "arjSettingsLoadingLimitsResource", ()=>$a9399ce8867d02dc$export$c9e47fa9b57975f5);
    var $7f4tk;
    var $2M1hQ;
    const $a9399ce8867d02dc$export$c9e47fa9b57975f5 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $a9d74ae4a12ce55b$export$cd7bb91dd2e30684),
        getKey: ()=>'loading-limits-information',
        getData: async ()=>(0, (0, parcelRequire("7f4tk")).default)('/rest/jpo/1.0/configuration'),
        maxAge: 0
    });
});
const $a9d74ae4a12ce55b$export$cd7bb91dd2e30684 = 'RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS';
parcelRegister("1aR84", function(module, exports) {
    $parcel$export(module.exports, "grantedPermissionsResource", ()=>$d675e556a71c706a$export$aa3daf3280e2a2d7);
    $parcel$export(module.exports, "permissionGroupsResource", ()=>$d675e556a71c706a$export$950060d83722e3bd);
    $parcel$export(module.exports, "getGlobalPermissionPageResources", ()=>$d675e556a71c706a$export$a09a91246a866817);
    var $eusud;
    var $2M1hQ;
    const $d675e556a71c706a$var$fetchGrantedPermissions = ()=>(0, (0, parcelRequire("eusud")).performPostRequest)('/rest/roadmaps/1.0/info/query', {
            body: JSON.stringify({
                providers: [
                    'permissions'
                ]
            })
        });
    const $d675e556a71c706a$var$fetchPermissionGroups = ()=>(0, (0, parcelRequire("eusud")).performPostRequest)('/rest/jpo/1.0/groupsandusers', {
            body: JSON.stringify({
                includeUsers: false,
                excludedGroups: [],
                excludedUsers: [],
                query: ''
            })
        });
    const $d675e556a71c706a$export$aa3daf3280e2a2d7 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ARJ_GLOBAL_PERMISSIONS_GRANTED',
        getKey: ()=>'arj-granted-permissions',
        getData: async ()=>$d675e556a71c706a$var$fetchGrantedPermissions(),
        maxAge: 0
    });
    const $d675e556a71c706a$export$950060d83722e3bd = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ARJ_GLOBAL_PERMISSIONS_GROUPS',
        getKey: ()=>'arj-permission-groups',
        getData: async ()=>$d675e556a71c706a$var$fetchPermissionGroups(),
        maxAge: 0
    });
    const $d675e556a71c706a$export$a09a91246a866817 = ()=>[
            $d675e556a71c706a$export$aa3daf3280e2a2d7,
            $d675e556a71c706a$export$950060d83722e3bd
        ];
});
parcelRegister("lHxXl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("19M8q").then(()=>parcelRequire('14EEk'));
});
parcelRegister("7j3uW", function(module, exports) {
    $parcel$export(module.exports, "arjSettingsFinancialYearResource", ()=>$59a235170c0d382a$export$da45020eede4a793);
    var $7f4tk;
    var $2M1hQ;
    const $59a235170c0d382a$export$da45020eede4a793 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $b242b5aa0787944c$export$e8e0384e95388aa3),
        getKey: ()=>'financial-year-information',
        getData: async ()=>(0, (0, parcelRequire("7f4tk")).default)('/rest/jpo/1.0/fiscalYear'),
        maxAge: 0
    });
});
const $b242b5aa0787944c$export$e8e0384e95388aa3 = 'RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR';
parcelRegister("462Ae", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hCaEC").then(()=>parcelRequire('7bDNN'));
});
parcelRegister("irnSu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("64R0p")),
        $6fhBS("8elb9")
    ]).then(()=>parcelRequire('laRNy'));
});
parcelRegister("1VgiI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1U1DX").then(()=>parcelRequire('kIqMQ'));
});
parcelRegister("7nBbQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("573g9").then(()=>parcelRequire('95BjK'));
});
parcelRegister("2A0mx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jXSqo").then(()=>parcelRequire('hGKeE'));
});
parcelRegister("aKeDz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aLLse").then(()=>parcelRequire('hCnfn'));
});
parcelRegister("4jMkc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb7b1354cffbd527$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("aIAac")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
    });
    const $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalProjectsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar, null)));
    $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
    var $bb7b1354cffbd527$export$2e2bcd8739ae039 = $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar;
});
parcelRegister("aIAac", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lhVk0").then(()=>parcelRequire('1tunp'));
});
parcelRegister("gL0L0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("8Dqf0")
    ]).then(()=>parcelRequire('jOclj'));
});
parcelRegister("9QpK7", function(module, exports) {
    $parcel$export(module.exports, "componentWithFF", ()=>$4adaf4a620447263$export$377d327ec8da8be);
    var $co1wz;
    var $7XYc4;
    const $4adaf4a620447263$export$377d327ec8da8be = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)(featureFlagName), ComponentTrue, ComponentFalse);
});
parcelRegister("iEUaw", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarShortcutsResource", ()=>$681ca3c44ff39b04$export$4847c29b4786b3b4);
    var $1nb22;
    var $2M1hQ;
    var $bskkv;
    const $681ca3c44ff39b04$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $681ca3c44ff39b04$export$4847c29b4786b3b4 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
        getKey: ({ match: match, query: query })=>$681ca3c44ff39b04$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $681ca3c44ff39b04$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const shortcuts = await (0, (0, parcelRequire("bskkv")).fetchShortcuts)(projectKeyOrId);
            return shortcuts;
        },
        maxAge: 300000
    });
});
parcelRegister("bskkv", function(module, exports) {
    $parcel$export(module.exports, "fetchShortcuts", ()=>$b1e90e13aab5fe84$export$49d696bf2525d700);
    var $jcw0u;
    var $7f4tk;
    const $b1e90e13aab5fe84$export$49d696bf2525d700 = (projectKeyOrId)=>{
        try {
            return (0, (0, parcelRequire("7f4tk")).default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'fetchProjectShortcuts',
                packageName: 'jiraNavigationAppsResources'
            });
            throw error;
        }
    };
});
parcelRegister("h0bZU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca3f1b5dd616f02b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $ca3f1b5dd616f02b$export$5b9febabdab63fba = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("icdgh")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
    });
    const $ca3f1b5dd616f02b$var$ServicedeskSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "servicedeskProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$export$5b9febabdab63fba, null)));
    $ca3f1b5dd616f02b$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
    var $ca3f1b5dd616f02b$export$2e2bcd8739ae039 = $ca3f1b5dd616f02b$var$ServicedeskSidebar;
});
parcelRegister("icdgh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kWrFZ"),
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aOxtZ")
    ]).then(()=>parcelRequire('eufGV'));
});
parcelRegister("7GnDe", function(module, exports) {
    $parcel$export(module.exports, "incidentsInitialPageChecksResource", ()=>$08a008dcde68e650$export$b2b94ce8ba590cc8);
    $parcel$export(module.exports, "incidentsCustomFieldIdResource", ()=>$08a008dcde68e650$export$e81d7afef87ae597);
    $parcel$export(module.exports, "incidentExperimentTraitResource", ()=>$08a008dcde68e650$export$31c6945718067be3);
    $parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3Only", ()=>$08a008dcde68e650$export$6fc19cf1d90e9453);
    $parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes", ()=>$08a008dcde68e650$export$2e6b9e6402ff1d9b);
    var $4R6GH;
    var $3HwlS;
    var $gNStA;
    var $2M1hQ;
    const $08a008dcde68e650$export$b2b94ce8ba590cc8 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $0ec4f2aa733ae93d$export$9018fdf9116edd9b),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("1Y6Un"))
    });
    const $08a008dcde68e650$export$e81d7afef87ae597 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("7F1l2"))
    });
    const $08a008dcde68e650$export$31c6945718067be3 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $0ec4f2aa733ae93d$export$1d954e05e596a51e),
        getKey: ()=>'incident_experiment_traits',
        getDataLoader: ()=>(parcelRequire("7I42N")),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $08a008dcde68e650$export$6fc19cf1d90e9453 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && ((0, (0, parcelRequire("4R6GH")).fg)('perf-push-big-components-remove-incidents-resource') || (0, (0, parcelRequire("4R6GH")).fg)('perf-push-big-components-nav-remove-resources'))), $08a008dcde68e650$export$31c6945718067be3);
    const $08a008dcde68e650$export$2e6b9e6402ff1d9b = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('blu-5573-remove-incident-resouce')), $08a008dcde68e650$export$31c6945718067be3);
});
const $0ec4f2aa733ae93d$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $0ec4f2aa733ae93d$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';
parcelRegister("1Y6Un", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jEfvB").then(()=>parcelRequire('8lQN4'));
});
parcelRegister("7F1l2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8rk6s").then(()=>parcelRequire('i0mY9'));
});
parcelRegister("7I42N", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ajWVH").then(()=>parcelRequire('iwLnj'));
});
parcelRegister("6Z2mh", function(module, exports) {
    $parcel$export(module.exports, "serviceProjectLayout", ()=>$0836cf39cca1e468$export$e321cb31c875d1ba);
    $parcel$export(module.exports, "rightSidebarsLayout", ()=>$0836cf39cca1e468$export$820f9bb834280408);
    var $2vSU6;
    var $2BrOV;
    var $i90UH;
    var $1Du13;
    var $aPfsS;
    var $ln7rs;
    var $kxZPA;
    const $0836cf39cca1e468$var$withServiceProjectContext = (Component)=>(0, (0, parcelRequire("aPfsS")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)
            }
        });
    const $0836cf39cca1e468$var$ProjectBuilder = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("dXRDz")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/ProjectBuilderWithQueryParam.tsx"
    });
    const $0836cf39cca1e468$var$Onboarding = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("hqzS2")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
    });
    const $0836cf39cca1e468$var$RightSidebars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("cK8Jl")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
    });
    const $0836cf39cca1e468$export$e321cb31c875d1ba = (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout), {
        globalComponents: [
            $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$Onboarding),
            ...(0, (0, parcelRequire("ln7rs")).serviceProjectFirstImpressionsLayout).globalComponents.map($0836cf39cca1e468$var$withServiceProjectContext),
            $0836cf39cca1e468$var$withServiceProjectContext((0, (0, parcelRequire("i90UH")).AsyncJsmCustomDomainChangeBoardingFlag)),
            $0836cf39cca1e468$var$ProjectBuilder
        ],
        rightSidebars: [
            $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$RightSidebars),
            ...(0, (0, parcelRequire("ln7rs")).serviceProjectFirstImpressionsLayout).rightSidebars.map($0836cf39cca1e468$var$withServiceProjectContext)
        ]
    });
    const $0836cf39cca1e468$export$820f9bb834280408 = (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), {
        rightSidebars: [
            $0836cf39cca1e468$var$RightSidebars
        ]
    });
});
parcelRegister("i90UH", function(module, exports) {
    $parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", ()=>$3ba5f01428db990d$export$b1ef5e3da6e1959d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("fPVwK")), {
        moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
    });
    const $3ba5f01428db990d$export$b1ef5e3da6e1959d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "async-jsm-custom-domain-change-boarding-flag",
            packageName: "jira-help-center-custom-domain-change-boarding"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-custom-domain-change-boarding-flag",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag, null)));
});
parcelRegister("fPVwK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("fgCot")
    ]).then(()=>parcelRequire('9d42Z'));
});
parcelRegister("1Du13", function(module, exports) {
    $parcel$export(module.exports, "projectLayout", ()=>$08491b76212b7395$export$204149bac601d20c);
    var $fpzhz;
    var $aPfsS;
    var $kxZPA;
    var $hMrxB;
    const $08491b76212b7395$var$withAnyProjectContext = (Component)=>(0, (0, parcelRequire("aPfsS")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: 'any'
            }
        });
    const $08491b76212b7395$var$ProjectTrackers = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("8bzg2")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
    });
    const $08491b76212b7395$var$ProjectFavicon = ()=>{
        (0, (0, parcelRequire("hMrxB")).useProjectFavicon)();
        return null;
    };
    const $08491b76212b7395$var$rightSidebars = ()=>[];
    const $08491b76212b7395$var$globalComponents = [
        $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectFavicon),
        $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectTrackers),
        $08491b76212b7395$var$withAnyProjectContext((0, (0, parcelRequire("fpzhz")).ProjectRouteListener))
    ];
    const $08491b76212b7395$export$204149bac601d20c = (0, (0, parcelRequire("aPfsS")).createLayout)({
        globalComponents: $08491b76212b7395$var$globalComponents,
        rightSidebars: $08491b76212b7395$var$rightSidebars()
    });
});
parcelRegister("fpzhz", function(module, exports) {
    $parcel$export(module.exports, "ProjectRouteListener", ()=>$a96b9050ddfb05f9$export$159f09d701320911);
    var $5uXOq = parcelRequire("5uXOq");
    var $dxCvy;
    var $itmJb;
    var $2YP9W;
    var $hVf1M;
    const $a96b9050ddfb05f9$export$159f09d701320911 = ()=>{
        const isSiteAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const { data: data, loading: loading } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        (0, $5uXOq.useEffect)(()=>{
            if (isSiteAdmin) (0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: true
            });
            else if (data != null) (0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: data.isProjectAdmin
            });
            else (0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                loading: loading,
                isProjectAdmin: null
            });
        }, [
            data,
            loading,
            isSiteAdmin
        ]);
        (0, $5uXOq.useEffect)(()=>()=>(0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                    loading: false,
                    isProjectAdmin: null
                }), []);
        return null;
    };
});
parcelRegister("itmJb", function(module, exports) {
    $parcel$export(module.exports, "useIsAdmin", ()=>$dfb6d33a8a8c98ed$export$99a5e4bc80d231ca);
    var $9OXo1;
    const $dfb6d33a8a8c98ed$export$99a5e4bc80d231ca = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.isAdmin || false;
    };
});
parcelRegister("hVf1M", function(module, exports) {
    $parcel$export(module.exports, "getIsProjectAdmin", ()=>$d8c128d9b214e073$export$34ff06260ad17f2b);
    $parcel$export(module.exports, "setIsProjectAdmin", ()=>$d8c128d9b214e073$export$d53e6d79d3fa5f31);
    let $d8c128d9b214e073$var$projectAdmin = null;
    const $d8c128d9b214e073$export$34ff06260ad17f2b = ()=>{
        if ($d8c128d9b214e073$var$projectAdmin == null || !$d8c128d9b214e073$var$projectAdmin.loading && $d8c128d9b214e073$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
        if ($d8c128d9b214e073$var$projectAdmin.loading === true) return 'LOADING';
        return Boolean($d8c128d9b214e073$var$projectAdmin.isProjectAdmin);
    };
    const $d8c128d9b214e073$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
        $d8c128d9b214e073$var$projectAdmin = projectAdminState;
    };
});
parcelRegister("hMrxB", function(module, exports) {
    $parcel$export(module.exports, "useProjectFavicon", ()=>$6ee68e956a566e2d$export$32abcb1f939de016);
    var $5uXOq = parcelRequire("5uXOq");
    var $j8DrX;
    var $lpwtK;
    const $6ee68e956a566e2d$export$32abcb1f939de016 = false ? ()=>undefined : ()=>{
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const iconEle = document.querySelector("link[rel='shortcut icon']");
        const defaultFavicon = (0, $5uXOq.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
            iconEle
        ]);
        const enabled = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-favicon-use-projecticon') === 'true', []);
        (0, $5uXOq.useEffect)(()=>{
            const favicon = project ? project.avatarUrl : defaultFavicon;
            if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = favicon;
            return ()=>{
                if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
            };
        }, [
            project,
            iconEle,
            defaultFavicon,
            enabled
        ]);
    };
});
parcelRegister("8bzg2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gw9ua").then(()=>parcelRequire('8DuT4'));
});
parcelRegister("ln7rs", function(module, exports) {
    $parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", ()=>$f6f2168537ade4c7$export$2562b2d784eadc10);
    var $5uXOq = parcelRequire("5uXOq");
    var $4YIAU;
    var $aPfsS;
    var $kxZPA;
    const $f6f2168537ade4c7$var$withServiceProjectAccess = (Component)=>{
        const ScopedComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4YIAU")).default), {
                hasServiceDeskAccess: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null));
        const name = (0, (0, parcelRequire("aPfsS")).coalesce)(Component.displayName) ?? (0, (0, parcelRequire("aPfsS")).coalesce)(Component.name) ?? 'Component';
        ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
        return ScopedComponent;
    };
    const $f6f2168537ade4c7$var$Onboarding = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("d2WEB")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
    });
    const $f6f2168537ade4c7$var$RightSidebars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("1Np2S")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/RightSidebars.tsx"
    });
    const $f6f2168537ade4c7$export$2562b2d784eadc10 = (0, (0, parcelRequire("aPfsS")).createLayout)({
        globalComponents: [
            $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$Onboarding)
        ],
        rightSidebars: [
            $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$RightSidebars)
        ]
    });
});
parcelRegister("4YIAU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d82237ab91dce08$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9OXo1;
    var $1Yett;
    const $8d82237ab91dce08$var$AppPermissionsCheck = (props)=>{
        const { appPermissions: appPermissions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
            if ((0, (0, parcelRequire("1Yett")).isDevelopmentEnv)()) console.warn('AppPermissionsCheck should have defined at least one of access prop');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        }
        return null;
    };
    $8d82237ab91dce08$var$AppPermissionsCheck.defaultProps = {
        hasCoreAccess: undefined,
        hasSoftwareAccess: undefined,
        hasServiceDeskAccess: undefined
    };
    var $8d82237ab91dce08$export$2e2bcd8739ae039 = $8d82237ab91dce08$var$AppPermissionsCheck;
});
parcelRegister("1Yett", function(module, exports) {
    $parcel$export(module.exports, "isDevelopmentEnv", ()=>$7b47955f7b675219$export$48e5fb80244b95c5);
    const $7b47955f7b675219$export$48e5fb80244b95c5 = ()=>false;
});
parcelRegister("d2WEB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("lBhEF")
    ]).then(()=>parcelRequire('fY1ne'));
});
parcelRegister("1Np2S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("aEk0C")
    ]).then(()=>parcelRequire('71Xxe'));
});
parcelRegister("dXRDz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("9gTl3")
    ]).then(()=>parcelRequire('ekO4Z'));
});
parcelRegister("hqzS2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eZivQ")
    ]).then(()=>parcelRequire('dOvA3'));
});
parcelRegister("cK8Jl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("0xcBC")
    ]).then(()=>parcelRequire('islsJ'));
});
parcelRegister("gyYxw", function(module, exports) {
    $parcel$export(module.exports, "genericProjectLayout", ()=>$177735c975452188$export$85dad8e9886563f6);
    var $18N1t;
    var $aPfsS;
    var $6Z2mh;
    var $e7bC3;
    var $9Y3Lc;
    const $177735c975452188$export$85dad8e9886563f6 = (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, (0, parcelRequire("18N1t")).coreProjectLayout), (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, (0, parcelRequire("9Y3Lc")).userBoardLayout));
});
parcelRegister("18N1t", function(module, exports) {
    $parcel$export(module.exports, "coreProjectLayout", ()=>$32b20434a17da609$export$3c06ced9943ca671);
    var $1Du13;
    var $aPfsS;
    const $32b20434a17da609$export$3c06ced9943ca671 = (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout));
});
parcelRegister("e7bC3", function(module, exports) {
    $parcel$export(module.exports, "classicSoftwareProjectLayout", ()=>$43d4c7537a1fee65$export$3791efdd32024063);
    $parcel$export(module.exports, "softwareProjectLayout", ()=>$43d4c7537a1fee65$export$9a918616afa3328c);
    $parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", ()=>$43d4c7537a1fee65$export$ada52b1309832862);
    $parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", ()=>$43d4c7537a1fee65$export$6c1958653c44ba37);
    $parcel$export(module.exports, "softwareProjectLayoutCode", ()=>$43d4c7537a1fee65$export$ab7e607e8441dc61);
    var $2vSU6;
    var $1Du13;
    var $aPfsS;
    var $kxZPA;
    const $43d4c7537a1fee65$var$withAnySoftwareProjectContext = (Component)=>(0, (0, parcelRequire("aPfsS")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)
            }
        });
    const $43d4c7537a1fee65$var$Onboarding = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("iIRH3")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
    });
    const $43d4c7537a1fee65$var$OnboardingCode = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("gTjUw")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/OnboardingCode.tsx"
    });
    const $43d4c7537a1fee65$var$RightSidebars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fYAv3")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
    });
    const $43d4c7537a1fee65$var$RightSidebarsCode = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("ja7Cq")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/RightSidebarsCode.tsx"
    });
    const $43d4c7537a1fee65$var$SoftWareOnboarding = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$Onboarding);
    const $43d4c7537a1fee65$var$SoftWareOnboardingCode = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$OnboardingCode);
    const $43d4c7537a1fee65$var$nonSettingsRightSidebars = [
        $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebars)
    ];
    const $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode = [
        $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebarsCode)
    ];
    const $43d4c7537a1fee65$var$sharedSoftwareProjectLayout = (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout), {});
    const $43d4c7537a1fee65$export$3791efdd32024063 = (0, (0, parcelRequire("aPfsS")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
        rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
        globalComponents: [
            $43d4c7537a1fee65$var$SoftWareOnboarding
        ]
    });
    const $43d4c7537a1fee65$export$9a918616afa3328c = (0, (0, parcelRequire("aPfsS")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
        rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
        globalComponents: [
            $43d4c7537a1fee65$var$SoftWareOnboarding
        ]
    });
    const $43d4c7537a1fee65$export$ada52b1309832862 = (0, (0, parcelRequire("aPfsS")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
    const $43d4c7537a1fee65$export$6c1958653c44ba37 = (0, (0, parcelRequire("aPfsS")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
    const $43d4c7537a1fee65$export$ab7e607e8441dc61 = (0, (0, parcelRequire("aPfsS")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
        rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode,
        globalComponents: [
            $43d4c7537a1fee65$var$SoftWareOnboardingCode
        ]
    });
});
parcelRegister("iIRH3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("5zn1B")
    ]).then(()=>parcelRequire('67mQl'));
});
parcelRegister("gTjUw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3aL8T")
    ]).then(()=>parcelRequire('g03yq'));
});
parcelRegister("fYAv3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("9w7x8")
    ]).then(()=>parcelRequire('jorgl'));
});
parcelRegister("ja7Cq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("4mQEr")
    ]).then(()=>parcelRequire('egnL1'));
});
parcelRegister("9Y3Lc", function(module, exports) {
    $parcel$export(module.exports, "userBoardLayout", ()=>$1760a1663e36faa5$export$7092b4ee86ae0b71);
    var $aPfsS;
    const $1760a1663e36faa5$export$7092b4ee86ae0b71 = (0, (0, parcelRequire("aPfsS")).createLayout)();
});
parcelRegister("lWPxc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2y2gh").then(()=>parcelRequire('f45ZV'));
});
parcelRegister("8uKLe", function(module, exports) {
    $parcel$export(module.exports, "staticSoftwareProjectHorizontalNavResource", ()=>$ee0fa1168e64c074$export$c5680a2101ae5345);
    var $1WQct;
    var $j5YhT;
    var $95bh0;
    var $dJl1T;
    var $4R6GH;
    var $7uLIV;
    var $3HwlS;
    var $eM91u;
    var $ao2h1;
    var $aqYy6;
    var $8YTna;
    var $1nb22;
    var $gNStA;
    const $ee0fa1168e64c074$var$getProjectAri = (projectId, cloudId)=>{
        try {
            return projectId ? (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
                siteId: cloudId,
                projectId: String(projectId)
            }).toString() : '';
        } catch (err) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('navigation-apps.resources.software-horizontal-navigation', 'Failed to get project ari');
            return '';
        }
    };
    const $ee0fa1168e64c074$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        let scope;
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
        const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
        if (isTMPBoardRoute) scope = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
        else scope = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId,
            boardId: boardId
        });
        const boardAri = scope.identifierType === 'boardId' ? (0, (0, parcelRequire("1WQct")).JiraSoftwareBoardAri).create({
            siteId: tenantContext.cloudId,
            boardId: String(match.params.boardId)
        }).toString() : null;
        const projectAri = $ee0fa1168e64c074$var$getProjectAri(projectId, tenantContext.cloudId);
        const containerNavigationInput = boardAri || projectAri ? {
            scopeId: String(boardAri || projectAri)
        } : {
            projectKeyQuery: {
                cloudId: tenantContext.cloudId,
                projectKey: projectKey
            }
        };
        const boardAriTemp = boardId ? (0, (0, parcelRequire("1WQct")).JiraSoftwareBoardAri).create({
            siteId: tenantContext.cloudId,
            boardId: boardId
        }).toString() : (0, (0, parcelRequire("1WQct")).JiraSoftwareBoardAri).create({
            siteId: tenantContext.cloudId,
            boardId: '0'
        }).toString();
        return {
            parameters: (0, (0, parcelRequire("aqYy6")).default),
            variables: {
                cloudId: tenantContext.cloudId,
                projectKey: projectKey,
                projectAri: projectAri,
                first: (0, (0, parcelRequire("eM91u")).NAVIGATION_ITEMS_PAGE_SIZE),
                isConsolidatedQuery: false,
                containerNavigationInput: containerNavigationInput,
                boardId: boardAriTemp,
                useProjectKey: Boolean(projectKey),
                useProjectAri: Boolean(projectAri),
                hasBoardId: Boolean(boardId),
                isTmpRoute: Boolean(isTMPBoardRoute)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    };
    const $ee0fa1168e64c074$export$2d211e899ea8ddf9 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)(), (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'HORIZONTAL_NAVIGATION_PROJECT_QUERY',
        getQuery: $ee0fa1168e64c074$export$71eec30d9db46a56
    }));
    const $ee0fa1168e64c074$export$c5680a2101ae5345 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('blu-5473-consolidate-business-and-software-nav'), (0, (0, parcelRequire("7uLIV")).horizontalNavJiraResource), $ee0fa1168e64c074$export$2d211e899ea8ddf9);
});
parcelRegister("7uLIV", function(module, exports) {
    $parcel$export(module.exports, "horizontalNavJiraResource", ()=>$1769860a1d0fe224$export$faeb8c89315e20da);
    var $1WQct;
    var $j5YhT;
    var $95bh0;
    var $dJl1T;
    var $eM91u;
    var $ao2h1;
    var $ivm9B;
    var $8YTna;
    var $1nb22;
    const $1769860a1d0fe224$var$getProjectAri = (projectId, cloudId)=>{
        try {
            return projectId ? (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
                siteId: cloudId,
                projectId: String(projectId)
            }).toString() : '';
        } catch (err) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('navigation-apps.resources.horizontal-nav-jira', 'Failed to get project ari');
            return '';
        }
    };
    const $1769860a1d0fe224$export$faeb8c89315e20da = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'HORIZONTAL_NAVIGATION_JIRA_QUERY',
        getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            let scope;
            const { cloudId: cloudId } = tenantContext;
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
            if (isTMPBoardRoute) scope = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
                projectKey: projectKey,
                projectId: projectId
            });
            else scope = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
                projectKey: projectKey,
                projectId: projectId,
                boardId: boardId
            });
            const boardAri = scope.identifierType === 'boardId' ? (0, (0, parcelRequire("1WQct")).JiraSoftwareBoardAri).create({
                siteId: cloudId,
                boardId: String(match.params.boardId)
            }).toString() : null;
            const projectAri = $1769860a1d0fe224$var$getProjectAri(projectId, cloudId);
            const containerNavigationInput = boardAri || projectAri ? {
                scopeId: String(boardAri || projectAri)
            } : {
                projectKeyQuery: {
                    cloudId: cloudId,
                    projectKey: projectKey
                }
            };
            const boardAriTemp = boardId ? (0, (0, parcelRequire("1WQct")).JiraSoftwareBoardAri).create({
                siteId: cloudId,
                boardId: boardId
            }).toString() : (0, (0, parcelRequire("1WQct")).JiraSoftwareBoardAri).create({
                siteId: cloudId,
                boardId: '0'
            }).toString();
            return {
                parameters: (0, (0, parcelRequire("ivm9B")).default),
                variables: {
                    cloudId: cloudId,
                    projectKey: projectKey,
                    projectAri: projectAri,
                    projectIdOrKey: projectIdOrKey,
                    first: (0, (0, parcelRequire("eM91u")).NAVIGATION_ITEMS_PAGE_SIZE),
                    isConsolidatedQuery: true,
                    containerNavigationInput: containerNavigationInput,
                    boardId: boardAriTemp,
                    useProjectKey: Boolean(projectKey),
                    useProjectAri: Boolean(projectAri),
                    hasBoardId: Boolean(boardId),
                    isTMPBoardRoute: Boolean(isTMPBoardRoute)
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
});
parcelRegister("eM91u", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_ITEMS_PAGE_SIZE", ()=>$8ade7fd740dbd607$export$4653cda61a4943d6);
    $parcel$export(module.exports, "TAB_UNDERLINE_HEIGHT", ()=>$8ade7fd740dbd607$export$d1b9ea3245b6a5de);
    $parcel$export(module.exports, "TAB_HEIGHT", ()=>$8ade7fd740dbd607$export$d07bba395c9390f1);
    $parcel$export(module.exports, "TAB_HEIGHT_REFRESH", ()=>$8ade7fd740dbd607$export$7795e1ec8bf78852);
    $parcel$export(module.exports, "TAB_GAP", ()=>$8ade7fd740dbd607$export$b61e6f89a9db76de);
    const $8ade7fd740dbd607$export$4653cda61a4943d6 = 75;
    const $8ade7fd740dbd607$export$d1b9ea3245b6a5de = 2;
    const $8ade7fd740dbd607$export$d07bba395c9390f1 = 36;
    const $8ade7fd740dbd607$export$7795e1ec8bf78852 = 56;
    const $8ade7fd740dbd607$export$29911ec08ab2ca2d = 5;
    const $8ade7fd740dbd607$export$b61e6f89a9db76de = 12;
    const $8ade7fd740dbd607$export$7fd2e391116c6ef5 = 9;
    const $8ade7fd740dbd607$export$e1633e494d305bfb = 'MORE';
});
parcelRegister("ivm9B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e7cee9907baeab7$export$2e2bcd8739ae039);
    const $5e7cee9907baeab7$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerNavigationInput"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useProjectAri"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useProjectKey"
        }, v6 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v7 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v8 = {
            "kind": "ScalarField",
            "name": "id"
        }, v9 = [
            {
                "kind": "ScalarField",
                "name": "projectType"
            },
            {
                "kind": "ScalarField",
                "name": "projectId"
            },
            {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "large"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "projectStyle"
            },
            {
                "alias": "canEditProjectConfig",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "EDIT_PROJECT_CONFIG"
                    }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": v7,
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
            },
            {
                "alias": "canViewProjectConfig",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "VIEW_PROJECT_CONFIG"
                    }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": v7,
                "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
            },
            v8,
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "key"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5
                ],
                "kind": "Fragment",
                "name": "HorizontalNavJiraInnerQuery",
                "selections": [
                    {
                        "args": [
                            v6,
                            {
                                "kind": "Variable",
                                "name": "containerNavigationInput",
                                "variableName": "containerNavigationInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectAri",
                                "variableName": "projectAri"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "useProjectAri",
                                "variableName": "useProjectAri"
                            },
                            {
                                "kind": "Variable",
                                "name": "useProjectKey",
                                "variableName": "useProjectKey"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "JiraProjectNavigationContent"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v5,
                    v0,
                    v3,
                    v2,
                    v4,
                    v1
                ],
                "kind": "Operation",
                "name": "HorizontalNavJiraInnerQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": [
                                            v6,
                                            {
                                                "kind": "Variable",
                                                "name": "key",
                                                "variableName": "projectKey"
                                            }
                                        ],
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": v9
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectAri",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "id",
                                                "variableName": "projectAri"
                                            }
                                        ],
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": v9
                                    }
                                ]
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "input",
                                        "variableName": "containerNavigationInput"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "containerNavigation",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "canEdit"
                                            }
                                        ],
                                        "type": "JiraContainerNavigation"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v8
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            },
                            {
                                "args": [
                                    v6
                                ],
                                "concreteType": "JiraWorkManagementLicensing",
                                "kind": "LinkedField",
                                "name": "jwmLicensing",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "currentUserSeatEdition"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "e13e8111ed21bae2a0edf7a53f724b3c2c585d4d3210547daf4e49a347e1fa08",
                "metadata": {},
                "name": "HorizontalNavJiraInnerQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $5e7cee9907baeab7$var$node.hash = "1a3afbf86be1c4ab2f5f6bc237098d0e";
    var $5e7cee9907baeab7$export$2e2bcd8739ae039 = $5e7cee9907baeab7$var$node;
});
parcelRegister("aqYy6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea1c475e7aa0ff0f$export$2e2bcd8739ae039);
    const $ea1c475e7aa0ff0f$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerNavigationInput"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hasBoardId"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConsolidatedQuery"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTmpRoute"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v9 = {
            "defaultValue": true,
            "kind": "LocalArgument",
            "name": "useContainerNavigation"
        }, v10 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useProjectAri"
        }, v11 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useProjectKey"
        }, v12 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "containerNavigationInput"
            }
        ], v13 = {
            "kind": "ScalarField",
            "name": "canEdit"
        }, v14 = {
            "kind": "ScalarField",
            "name": "scopeId"
        }, v15 = [
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
            }
        ], v16 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v17 = [
            v16,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v18 = {
            "kind": "ScalarField",
            "name": "name"
        }, v19 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v20 = {
            "kind": "ScalarField",
            "name": "projectType"
        }, v21 = {
            "kind": "ScalarField",
            "name": "projectStyle"
        }, v22 = {
            "kind": "ScalarField",
            "name": "key"
        }, v23 = {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        }, v24 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v25 = {
            "alias": "canEditProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v24,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }, v26 = {
            "alias": "canViewProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v24,
            "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
        }, v27 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        }, v28 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v29 = [
            {
                "kind": "FragmentSpread",
                "name": "extraComponentsFar_horizontalNavHeader"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isTmpRoute",
                        "variableName": "isTmpRoute"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "boardHeader_horizontalNavHeader_projectFragment"
            },
            {
                "kind": "FragmentSpread",
                "name": "projectHeader_horizontalNavHeader_projectFragment"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_navigationKitTabList_TabList_projectFragment"
            },
            v18,
            v19,
            v20,
            v21,
            v22,
            v23,
            v25,
            v26,
            v27,
            v28
        ], v30 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectAri"
            }
        ], v31 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v32 = {
            "kind": "ScalarField",
            "name": "id"
        }, v33 = {
            "kind": "ScalarField",
            "name": "label"
        }, v34 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v35 = {
            "kind": "ScalarField",
            "name": "url"
        }, v36 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v37 = [
            v28
        ], v38 = {
            "kind": "InlineFragment",
            "selections": [
                v32
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v39 = {
            "kind": "ScalarField",
            "name": "boardId"
        }, v40 = {
            "kind": "ScalarField",
            "name": "boardType"
        }, v41 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v42 = [
            v31,
            {
                "kind": "InlineFragment",
                "selections": [
                    v39,
                    v18,
                    v13,
                    v40,
                    {
                        "concreteType": "JiraFavouriteValue",
                        "kind": "LinkedField",
                        "name": "favouriteValue",
                        "plural": false,
                        "selections": [
                            v41,
                            v32
                        ]
                    },
                    v28
                ],
                "type": "JiraBoard"
            },
            v38
        ], v43 = [
            {
                "kind": "LinkedField",
                "name": "mostRecentlyViewedBoard",
                "plural": false,
                "selections": v42
            },
            v32
        ], v44 = [
            {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            v18,
            v19,
            v21,
            v20,
            v27,
            v25,
            v26,
            v22,
            v32,
            v41,
            {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            v23,
            v28,
            {
                "condition": "isConsolidatedQuery",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "mostRecentlyViewedBoard",
                        "plural": false,
                        "selections": [
                            v31,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v39
                                ],
                                "type": "JiraBoard"
                            },
                            v38
                        ]
                    }
                ]
            },
            {
                "condition": "useContainerNavigation",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "navigationMetadata",
                        "plural": false,
                        "selections": [
                            v31,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v39,
                                    {
                                        "kind": "ScalarField",
                                        "name": "isSimpleBoard"
                                    },
                                    v32
                                ],
                                "type": "JiraSoftwareProjectNavigationMetadata"
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "name": "mostRecentlyViewedBoard",
                        "plural": false,
                        "selections": [
                            v31,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v39,
                                    v40
                                ],
                                "type": "JiraBoard"
                            },
                            v38
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11
                ],
                "kind": "Fragment",
                "name": "uiHorizontalSoftwareProjectNavQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v12,
                                        "kind": "LinkedField",
                                        "name": "containerNavigation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_navigationKitTabList_TabList_containerFragment"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_navigationKitAddTab_AddTab"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v13,
                                                    v14,
                                                    {
                                                        "args": v15,
                                                        "concreteType": "JiraNavigationItemConnection",
                                                        "kind": "LinkedField",
                                                        "name": "navigationItems",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "ui_navigationKitTabList_TabList_tabsFragment"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraContainerNavigation"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.containerNavigation"
                                },
                                {
                                    "condition": "isTmpRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "boardId",
                                                    "variableName": "boardId"
                                                },
                                                v16,
                                                {
                                                    "kind": "Variable",
                                                    "name": "hasBoardId",
                                                    "variableName": "hasBoardId"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "projectAri",
                                                    "variableName": "projectAri"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "projectKey",
                                                    "variableName": "projectKey"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "useProjectAri",
                                                    "variableName": "useProjectAri"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "useProjectKey",
                                                    "variableName": "useProjectKey"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "boardHeader_horizontalNavHeader_boardFragment"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "projectDataByKey",
                                                "args": v17,
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "jiraProjectByKey",
                                                "plural": false,
                                                "selections": v29
                                            },
                                            "action": "THROW",
                                            "path": "jira.projectDataByKey"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "condition": "useProjectAri",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "alias": "projectDataById",
                                                        "args": v30,
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "jiraProject",
                                                        "plural": false,
                                                        "selections": v29
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.projectDataById"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0,
                    v8,
                    v7,
                    v3,
                    v5,
                    v2,
                    v11,
                    v10,
                    v4,
                    v6,
                    v9
                ],
                "kind": "Operation",
                "name": "uiHorizontalSoftwareProjectNavQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v12,
                                "kind": "LinkedField",
                                "name": "containerNavigation",
                                "plural": false,
                                "selections": [
                                    v31,
                                    {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isJiraContainerNavigationResult"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v32,
                                            v13,
                                            v14,
                                            {
                                                "args": v15,
                                                "concreteType": "JiraNavigationItemConnection",
                                                "kind": "LinkedField",
                                                "name": "navigationItems",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraNavigationItemEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v31,
                                                                    v32,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "isDefault"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "typeKey"
                                                                    },
                                                                    {
                                                                        "kind": "TypeDiscriminator",
                                                                        "abstractKey": "__isJiraNavigationItem"
                                                                    },
                                                                    v33,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "canRemove"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "canSetAsDefault"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "appId"
                                                                            },
                                                                            {
                                                                                "concreteType": "JiraAppSection",
                                                                                "kind": "LinkedField",
                                                                                "name": "sections",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v33,
                                                                                    {
                                                                                        "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "links",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v33,
                                                                                            v34,
                                                                                            v35,
                                                                                            v36
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v35,
                                                                            v34,
                                                                            v36,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "appType"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "envLabel"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v37,
                                                                                "type": "JiraNavigationItem",
                                                                                "abstractKey": "__isJiraNavigationItem"
                                                                            }
                                                                        ],
                                                                        "type": "JiraAppNavigationItem"
                                                                    },
                                                                    {
                                                                        "condition": "isConsolidatedQuery",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": v37
                                                                    },
                                                                    v28
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraContainerNavigation"
                                    },
                                    v38
                                ]
                            },
                            {
                                "condition": "isTmpRoute",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "condition": "hasBoardId",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "boardId"
                                                    }
                                                ],
                                                "kind": "LinkedField",
                                                "name": "jiraBoard",
                                                "plural": false,
                                                "selections": v42
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "useProjectKey",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "condition": "hasBoardId",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "alias": "projectDataByKey",
                                                        "args": v17,
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "jiraProjectByKey",
                                                        "plural": false,
                                                        "selections": v43
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "useProjectAri",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "condition": "hasBoardId",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "alias": "projectDataById",
                                                        "args": v30,
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "jiraProject",
                                                        "plural": false,
                                                        "selections": v43
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v17,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": v44
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "condition": "useProjectAri",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "alias": "projectDataById",
                                                "args": v30,
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "jiraProject",
                                                "plural": false,
                                                "selections": v44
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "8c65b84d3a1322ba1658776483fd043df6503a128de1a589acd5d986358533eb",
                "metadata": {},
                "name": "uiHorizontalSoftwareProjectNavQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $ea1c475e7aa0ff0f$var$node.hash = "2ed172c4910e035ebb76e4653224154c";
    var $ea1c475e7aa0ff0f$export$2e2bcd8739ae039 = $ea1c475e7aa0ff0f$var$node;
});
parcelRegister("9s3j1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed71aad279526f75$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $ed71aad279526f75$var$LazyClassicSoftwareProjectSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("68Yoa")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
    });
    const $ed71aad279526f75$var$ClassicSoftwareProjectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "classicSoftwareProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$LazyClassicSoftwareProjectSidebar, null)));
    $ed71aad279526f75$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
    var $ed71aad279526f75$export$2e2bcd8739ae039 = $ed71aad279526f75$var$ClassicSoftwareProjectSidebar;
});
parcelRegister("68Yoa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hXBFn")
    ]).then(()=>parcelRequire('dydBa'));
});
parcelRegister("5PD5h", function(module, exports) {
    $parcel$export(module.exports, "AsyncHorizontalSoftwareProjectNav", ()=>$a816ddf70513a004$export$128d5d79815580ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $a816ddf70513a004$var$LazyHorizontalSoftwareProjectNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("j4PFg")).then(({ HorizontalSoftwareProjectNav: HorizontalSoftwareProjectNav })=>HorizontalSoftwareProjectNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-software/src/ui/index.tsx"
    });
    const $a816ddf70513a004$export$128d5d79815580ca = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-software-project-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a816ddf70513a004$var$LazyHorizontalSoftwareProjectNav, null));
});
parcelRegister("j4PFg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("djQ7G")
    ]).then(()=>parcelRequire('1f09g'));
});
parcelRegister("koWFd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73e9a7a50d60fc40$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $73e9a7a50d60fc40$var$LazyClassicSoftwareProjectSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("lsLuI")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
    });
    const $73e9a7a50d60fc40$var$SoftwareProjectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "softwareProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$LazyClassicSoftwareProjectSidebar, null)));
    $73e9a7a50d60fc40$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
    var $73e9a7a50d60fc40$export$2e2bcd8739ae039 = $73e9a7a50d60fc40$var$SoftwareProjectSidebar;
});
parcelRegister("lsLuI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4OI1j")
    ]).then(()=>parcelRequire('4WgKv'));
});
parcelRegister("l71WK", function(module, exports) {
    $parcel$export(module.exports, "AsyncHorizontalProjectNav", ()=>$7e6dac351b79a914$export$862dd1c0126bb181);
    $parcel$export(module.exports, "AsyncHorizontalOverviewNav", ()=>$7e6dac351b79a914$export$beabdf5c49f01377);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $7e6dac351b79a914$var$LazyHorizontalProjectNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("7Z5eX")), {
        moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/project-navigation/index.tsx"
    });
    const $7e6dac351b79a914$export$862dd1c0126bb181 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-project-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalProjectNav, null));
    const $7e6dac351b79a914$var$LazyHorizontalOverviewNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lgttv")), {
        moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/overview-navigation/index.tsx"
    });
    const $7e6dac351b79a914$export$beabdf5c49f01377 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-overview-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalOverviewNav, null));
});
parcelRegister("7Z5eX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("4RRJO")
    ]).then(()=>parcelRequire('bwmXM'));
});
parcelRegister("lgttv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hTo1l")
    ]).then(()=>parcelRequire('bNzBR'));
});
parcelRegister("dmKXV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac63d95d52d9688b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $ac63d95d52d9688b$var$LazyCoreProjectSidebar = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return Promise.resolve((parcelRequire("8rIQt"))).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
    });
    const $ac63d95d52d9688b$var$CoreProjectSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "coreProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac63d95d52d9688b$var$LazyCoreProjectSidebar, null));
    var $ac63d95d52d9688b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($ac63d95d52d9688b$var$CoreProjectSidebar);
});
parcelRegister("lNicp", function(module, exports) {
    $parcel$export(module.exports, "getBusinessProjectResources", ()=>$492115de1a4c9f28$export$20e8c2951e444b08);
    $parcel$export(module.exports, "getProjectViewResources", ()=>$492115de1a4c9f28$export$fcbe882e18ee4a35);
    $parcel$export(module.exports, "getOverviewViewResources", ()=>$492115de1a4c9f28$export$21c5527b459d56fe);
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $dAmbh;
    var $g4ZHz;
    var $1E3vT;
    var $iNzEe;
    var $jrO9m;
    var $l2N2a;
    var $9yEpR;
    var $3RJkv;
    var $dxCvy;
    var $aFVvc;
    var $7GnDe;
    const $492115de1a4c9f28$var$commonResources = [
        (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource),
        (0, (0, parcelRequire("iNzEe")).navigationResource)
    ];
    const $492115de1a4c9f28$export$20e8c2951e444b08 = ()=>[
            ...$492115de1a4c9f28$var$commonResources,
            (0, (0, parcelRequire("l2N2a")).projectDetailsResource),
            (0, (0, parcelRequire("9yEpR")).storageDetailsResource),
            (0, (0, parcelRequire("1E3vT")).navigationItemsResource)
        ];
    const $492115de1a4c9f28$export$46471673e66df5c1 = ()=>[
            ...$492115de1a4c9f28$var$commonResources,
            (0, (0, parcelRequire("jrO9m")).overviewDetailsResource)
        ];
    const $492115de1a4c9f28$export$fcbe882e18ee4a35 = ()=>[
            ...$492115de1a4c9f28$export$20e8c2951e444b08(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("dAmbh")).configurationResource),
            (0, (0, parcelRequire("g4ZHz")).fieldsResource)
        ];
    const $492115de1a4c9f28$export$21c5527b459d56fe = ()=>[
            ...$492115de1a4c9f28$export$46471673e66df5c1(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("dAmbh")).configurationResource),
            (0, (0, parcelRequire("g4ZHz")).fieldsResource)
        ];
});
parcelRegister("dAmbh", function(module, exports) {
    $parcel$export(module.exports, "configurationResource", ()=>$43ad736dfc62d10f$export$5c4ad441346dc154);
    $parcel$export(module.exports, "useRankField", ()=>$43ad736dfc62d10f$export$fffa1172af8de100);
    $parcel$export(module.exports, "useStartDateField", ()=>$43ad736dfc62d10f$export$bf78b0881400efef);
    $parcel$export(module.exports, "useIsLinkingEnabled", ()=>$43ad736dfc62d10f$export$76fc5a1eecec5a35);
    $parcel$export(module.exports, "useIsSubtasksEnabled", ()=>$43ad736dfc62d10f$export$dca58a051cb58f03);
    var $2M1hQ;
    var $2YP9W;
    var $58BMJ;
    const $43ad736dfc62d10f$var$RESOURCE_KEY = 'BUSINESS_CONFIGURATION';
    const $43ad736dfc62d10f$export$5c4ad441346dc154 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $43ad736dfc62d10f$var$RESOURCE_KEY,
        getKey: ()=>$43ad736dfc62d10f$var$RESOURCE_KEY,
        getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("58BMJ")).fetchConfiguration)(cloudId),
        maxAge: Infinity
    });
    const $43ad736dfc62d10f$export$b629b793d58e3884 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($43ad736dfc62d10f$export$5c4ad441346dc154);
    const $43ad736dfc62d10f$export$fffa1172af8de100 = ()=>{
        const { data: data, loading: loading, error: error } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return {
            data: data?.rankField ?? null,
            loading: loading,
            error: error
        };
    };
    const $43ad736dfc62d10f$export$bf78b0881400efef = ()=>{
        const { data: data, loading: loading, error: error } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return {
            data: data?.startDateField ?? null,
            loading: loading,
            error: error
        };
    };
    const $43ad736dfc62d10f$export$76fc5a1eecec5a35 = ()=>{
        const { data: data } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return data?.isLinkingEnabled ?? false;
    };
    const $43ad736dfc62d10f$export$dca58a051cb58f03 = ()=>{
        const { data: data } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return data?.isSubtasksEnabled ?? false;
    };
});
parcelRegister("58BMJ", function(module, exports) {
    $parcel$export(module.exports, "fetchConfiguration", ()=>$1cb1e84b048c3101$export$9911e92fcb5c83c0);
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $lKH3S;
    const $1cb1e84b048c3101$export$9911e92fcb5c83c0 = async (cloudId)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JiraBusinessConfiguration', {
                body: JSON.stringify({
                    query: (0, $5c0554031841947d$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId
                    }
                })
            });
            if (response.data == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            return (0, (0, parcelRequire("lKH3S")).transformData)(response);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessConfiguration', 'Something went wrong while fetching business configuration');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'configurationResource',
                    packageName: 'jiraRouterResourcesBusinessConfiguration',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return null;
    };
});
parcelRegister("jlq4V", function(module, exports) {
    $parcel$export(module.exports, "GraphQLErrors", ()=>$503bc83696833cc0$export$89c202e66b2de2b6);
    var $7hpBk = parcelRequire("7hpBk");
    var $8LQ84 = parcelRequire("8LQ84");
    const $503bc83696833cc0$var$generateErrorMessage = (err)=>{
        let message = '';
        if ((0, ($parcel$interopDefault($8LQ84)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
            const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
            message += `${errorMessage}\n`;
        });
        message = message.replace(/\n$/, '');
        return message;
    };
    class $503bc83696833cc0$export$89c202e66b2de2b6 extends Error {
        constructor(graphQLErrors){
            super();
            this.graphQLErrors = graphQLErrors != null ? (0, ($parcel$interopDefault($7hpBk)))(graphQLErrors) : [];
            this.message = $503bc83696833cc0$var$generateErrorMessage(this);
            this.cause = this.graphQLErrors?.[0];
            this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
            this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
        }
    }
});
parcelRegister("7hpBk", function(module, exports) {
    var $8LQ84 = parcelRequire("8LQ84");
    function $54cdfac2bc83c2a9$var$castArray() {
        if (!arguments.length) return [];
        var value = arguments[0];
        return $8LQ84(value) ? value : [
            value
        ];
    }
    module.exports = $54cdfac2bc83c2a9$var$castArray;
});
const $5c0554031841947d$export$2b91517d6d5b4365 = `
query JiraBusinessConfiguration($cloudId: ID!) {
  jira {
    rankField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: RANK) {
      fieldId
      name
    }
    startDateField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: START_DATE) {
      fieldId
      name
    }
    issueLinkTypes(cloudId: $cloudId) {
      totalCount
    }
    isSubtasksEnabled(cloudId: $cloudId)
  }
}
`;
parcelRegister("lKH3S", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$0ad069c9956cd674$export$3ceb62baab058c6b);
    const $0ad069c9956cd674$export$3ceb62baab058c6b = (response)=>{
        let rankField = null;
        const rankFieldNode = response.data?.jira?.rankField;
        if (rankFieldNode != null) rankField = {
            id: rankFieldNode.fieldId,
            name: rankFieldNode.name
        };
        let startDateField = null;
        const startDateFieldNode = response.data?.jira?.startDateField;
        if (startDateFieldNode != null) startDateField = {
            id: startDateFieldNode.fieldId,
            name: startDateFieldNode.name
        };
        const isLinkingEnabled = (response.data?.jira?.issueLinkTypes?.totalCount ?? 0) !== 0;
        const isSubtasksEnabled = response.data?.jira?.isSubtasksEnabled ?? false;
        return {
            rankField: rankField,
            startDateField: startDateField,
            isLinkingEnabled: isLinkingEnabled,
            isSubtasksEnabled: isSubtasksEnabled
        };
    };
});
parcelRegister("g4ZHz", function(module, exports) {
    $parcel$export(module.exports, "fieldsResource", ()=>$410efef54f79d33f$export$8bca6c1954ae9308);
    $parcel$export(module.exports, "useFieldsResource", ()=>$410efef54f79d33f$export$c0cd85886917fe89);
    var $7q3cr;
    var $jlq4V;
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    var $ljySl;
    var $kig09;
    const $410efef54f79d33f$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
    const $410efef54f79d33f$var$handleProjectResponse = async (promise)=>{
        const response = await promise;
        if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
        return (0, (0, parcelRequire("kig09")).transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
    };
    const $410efef54f79d33f$var$handleOverviewResponse = async (promise)=>{
        const response = await promise;
        if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
        return (0, (0, parcelRequire("kig09")).transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
    };
    const $410efef54f79d33f$export$8bca6c1954ae9308 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $410efef54f79d33f$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            if (matchedRoute.match.params.overviewId) return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            const projectIdOrKey = projectKey || projectId;
            return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
            if (match.params.overviewId) return (0, (0, parcelRequire("ljySl")).fetchFields)((0, $8441414a9e015afb$export$c378ca4a0e2c9fec), $410efef54f79d33f$var$handleOverviewResponse, {
                overviewAri: (0, (0, parcelRequire("7q3cr")).JiraProjectOverviewAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    overviewId: match.params.overviewId
                }).toString()
            });
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            return (0, (0, parcelRequire("ljySl")).fetchFields)((0, $8441414a9e015afb$export$4d41378da3f70f0f), $410efef54f79d33f$var$handleProjectResponse, {
                cloudId: cloudId,
                jqlContext: `project = '${projectIdOrKey}'`
            });
        },
        maxAge: 3600000
    });
    const $410efef54f79d33f$export$c0cd85886917fe89 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($410efef54f79d33f$export$8bca6c1954ae9308);
});
parcelRegister("7q3cr", function(module, exports) {
    $parcel$export(module.exports, "JiraProjectOverviewAri", ()=>$566d717b3b39d3ba$export$714879003922a622);
    var $gPEvR;
    var $9KGzW;
    var $1C2Ux;
    var $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("gPEvR")).JiraProjectOverviewAriResourceOwner),
        resourceType: (0, (0, parcelRequire("gPEvR")).JiraProjectOverviewAriResourceType),
        resourceIdSlug: "activation/{activationId}/{overviewId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/,
            overviewId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
        }
    };
    var $566d717b3b39d3ba$export$714879003922a622 = class _JiraProjectOverviewAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._overviewId = opts.resourceIdSegmentValues.overviewId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        get overviewId() {
            return this._overviewId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.qualifier,
                platformQualifier: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.resourceOwner,
                resourceType: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.resourceType,
                resourceId: `activation/${opts.activationId}/${opts.overviewId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId,
                    overviewId: opts.overviewId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts);
            return new _JiraProjectOverviewAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts);
            return new _JiraProjectOverviewAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId,
                overviewId: this.overviewId
            };
        }
    };
});
parcelRegister("gPEvR", function(module, exports) {
    $parcel$export(module.exports, "JiraProjectOverviewAriResourceOwner", ()=>$c410d5ca87dd2023$export$d68ef32d028cea3e);
    $parcel$export(module.exports, "JiraProjectOverviewAriResourceType", ()=>$c410d5ca87dd2023$export$491d1b3b0151dbc4);
    var $c410d5ca87dd2023$export$d68ef32d028cea3e = "jira", $c410d5ca87dd2023$export$491d1b3b0151dbc4 = "project-overview";
});
const $8441414a9e015afb$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $8441414a9e015afb$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;
parcelRegister("ljySl", function(module, exports) {
    $parcel$export(module.exports, "fetchFields", ()=>$90e7c5e5920e8507$export$f3ddd735c360919);
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    const $90e7c5e5920e8507$var$PAGE_SIZE = 100;
    const $90e7c5e5920e8507$export$f3ddd735c360919 = async (query, handler, params)=>{
        try {
            const promise = (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: query,
                    variables: {
                        first: $90e7c5e5920e8507$var$PAGE_SIZE,
                        ...params
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'JiraJqlBuilder'
                }
            });
            return await handler(promise);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fieldsResource',
                    packageName: 'jiraRouterResourcesBusinessFields',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return null;
    };
});
parcelRegister("kig09", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$3d209f684c72dca4$export$3ceb62baab058c6b);
    const $3d209f684c72dca4$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);
});
parcelRegister("1E3vT", function(module, exports) {
    $parcel$export(module.exports, "navigationItemsResource", ()=>$4f364072ed560b43$export$8446b129b5aba359);
    var $j5YhT;
    var $dJl1T;
    var $4R6GH;
    var $7uLIV;
    var $3HwlS;
    var $eM91u;
    var $ao2h1;
    var $6SGt4;
    var $1nb22;
    var $gNStA;
    const $4f364072ed560b43$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_HORIZONTAL_NAVIGATION';
    const $4f364072ed560b43$var$getProjectAri = (projectId, cloudId)=>{
        try {
            return projectId ? (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString() : '';
        } catch (err) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesNavigationItems', 'Failed to get project ari');
            return '';
        }
    };
    const $4f364072ed560b43$export$38c041bf3215c084 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $4f364072ed560b43$var$RESOURCE_TYPE_KEY,
        getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const { cloudId: cloudId } = tenantContext;
            const projectIdOrKey = projectKey || projectId;
            const scopeId = $4f364072ed560b43$var$getProjectAri(projectId, cloudId);
            return {
                parameters: (0, (0, parcelRequire("6SGt4")).default),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    first: (0, (0, parcelRequire("eM91u")).NAVIGATION_ITEMS_PAGE_SIZE),
                    isConsolidatedQuery: false,
                    containerNavigationInput: scopeId ? {
                        scopeId: scopeId
                    } : {
                        projectKeyQuery: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    },
                    useContainerNavigation: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)(),
                    useNewProjectHeader: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)(),
                    projectKey: projectKey,
                    projectAri: scopeId,
                    useProjectKey: Boolean(projectKey)
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
    const $4f364072ed560b43$export$8446b129b5aba359 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('blu-5473-consolidate-business-and-software-nav'), (0, (0, parcelRequire("7uLIV")).horizontalNavJiraResource), $4f364072ed560b43$export$38c041bf3215c084);
});
parcelRegister("6SGt4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fed7f561d3a05da6$export$2e2bcd8739ae039);
    const $fed7f561d3a05da6$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerNavigationInput"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConsolidatedQuery"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useContainerNavigation"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useNewProjectHeader"
        }, v9 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useProjectKey"
        }, v10 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v11 = [
            v10,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v12 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        }, v13 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v14 = {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        }, v15 = {
            "kind": "ScalarField",
            "name": "name"
        }, v16 = {
            "condition": "useNewProjectHeader",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "projectBoardHeader_horizontalNavHeader_projectFragment"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "projectHeader_horizontalNavHeader_projectFragment"
                }
            ]
        }, v17 = {
            "kind": "FragmentSpread",
            "name": "tabs_businessHorizontalNav_TabsContent_projectFragment"
        }, v18 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectAri"
            }
        ], v19 = {
            "args": [
                v10
            ],
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "currentUserSeatEdition"
                }
            ]
        }, v20 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }, v21 = [
            v10,
            v20,
            {
                "kind": "Variable",
                "name": "projectIdOrKey",
                "variableName": "projectIdOrKey"
            }
        ], v22 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v23 = {
            "kind": "ScalarField",
            "name": "id"
        }, v24 = {
            "kind": "ScalarField",
            "name": "label"
        }, v25 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v26 = {
            "kind": "ScalarField",
            "name": "url"
        }, v27 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v28 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v29 = [
            v28
        ], v30 = {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v22,
                v23,
                {
                    "kind": "ScalarField",
                    "name": "isDefault"
                },
                {
                    "kind": "ScalarField",
                    "name": "typeKey"
                },
                {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isJiraNavigationItem"
                },
                v24,
                {
                    "kind": "ScalarField",
                    "name": "canRemove"
                },
                {
                    "kind": "ScalarField",
                    "name": "canSetAsDefault"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "appId"
                        },
                        {
                            "concreteType": "JiraAppSection",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                                v24,
                                {
                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                        v24,
                                        v25,
                                        v26,
                                        v27
                                    ]
                                }
                            ]
                        },
                        v26,
                        v25,
                        v27,
                        {
                            "kind": "ScalarField",
                            "name": "appType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "envLabel"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v29,
                            "type": "JiraNavigationItem",
                            "abstractKey": "__isJiraNavigationItem"
                        }
                    ],
                    "type": "JiraAppNavigationItem"
                },
                {
                    "condition": "isConsolidatedQuery",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": v29
                },
                v28
            ]
        }, v31 = [
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v22,
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    }
                ]
            }
        ], v32 = {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": v31
        }, v33 = {
            "kind": "ScalarField",
            "name": "canEdit"
        }, v34 = {
            "kind": "InlineFragment",
            "selections": [
                v23
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v35 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v36 = {
            "kind": "ScalarField",
            "name": "projectStyle"
        }, v37 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v38 = {
            "kind": "ScalarField",
            "name": "key"
        }, v39 = {
            "kind": "ScalarField",
            "name": "boardId"
        }, v40 = [
            v12,
            v13,
            v14,
            v15,
            {
                "kind": "ScalarField",
                "name": "projectType"
            },
            v23,
            {
                "condition": "useNewProjectHeader",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v35,
                    v36,
                    {
                        "kind": "ScalarField",
                        "name": "webUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "status"
                    },
                    {
                        "alias": "canEditProjectConfig",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_PROJECT_CONFIG"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": v37,
                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                    },
                    {
                        "alias": "canViewProjectConfig",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "VIEW_PROJECT_CONFIG"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": v37,
                        "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                    },
                    v38,
                    {
                        "kind": "ScalarField",
                        "name": "softwareBoardCount"
                    },
                    {
                        "concreteType": "JiraBoardConnection",
                        "kind": "LinkedField",
                        "name": "boards",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraBoardEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraBoard",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v39,
                                            {
                                                "concreteType": "JiraFavouriteValue",
                                                "kind": "LinkedField",
                                                "name": "favouriteValue",
                                                "plural": false,
                                                "selections": [
                                                    v35,
                                                    v23
                                                ]
                                            },
                                            v33,
                                            v23,
                                            v28
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v28
                ]
            },
            {
                "condition": "isConsolidatedQuery",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v36,
                    {
                        "kind": "LinkedField",
                        "name": "mostRecentlyViewedBoard",
                        "plural": false,
                        "selections": [
                            v22,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v39
                                ],
                                "type": "JiraBoard"
                            },
                            v34
                        ]
                    },
                    {
                        "condition": "isConsolidatedQuery",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            v38
                        ]
                    }
                ]
            },
            {
                "condition": "useContainerNavigation",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "navigationMetadata",
                        "plural": false,
                        "selections": [
                            v22,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v39,
                                    {
                                        "kind": "ScalarField",
                                        "name": "isSimpleBoard"
                                    },
                                    v23
                                ],
                                "type": "JiraSoftwareProjectNavigationMetadata"
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "name": "mostRecentlyViewedBoard",
                        "plural": false,
                        "selections": [
                            v22,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v39,
                                    {
                                        "kind": "ScalarField",
                                        "name": "boardType"
                                    }
                                ],
                                "type": "JiraBoard"
                            },
                            v34
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9
                ],
                "kind": "Fragment",
                "name": "projectNavigation_horizontalNavigationQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "tabs_businessHorizontalNav_TabsContent_jiraQueryFragment"
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "projectDataByKey",
                                            "args": v11,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProjectByKey",
                                            "plural": false,
                                            "selections": [
                                                v12,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v13,
                                                    "action": "THROW",
                                                    "path": "jira.projectDataByKey.projectId"
                                                },
                                                v14,
                                                v15,
                                                v16,
                                                v17
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectDataById",
                                            "args": v18,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProject",
                                            "plural": false,
                                            "selections": [
                                                v12,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v13,
                                                    "action": "THROW",
                                                    "path": "jira.projectDataById.projectId"
                                                },
                                                v14,
                                                v15,
                                                v16,
                                                v17
                                            ]
                                        }
                                    ]
                                },
                                v19
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v5,
                    v2,
                    v3,
                    v1,
                    v7,
                    v6,
                    v4,
                    v9,
                    v8
                ],
                "kind": "Operation",
                "name": "projectNavigation_horizontalNavigationQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v19,
                            {
                                "condition": "useContainerNavigation",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "navigationItems",
                                        "args": v21,
                                        "concreteType": "JiraNavigationItemConnection",
                                        "kind": "LinkedField",
                                        "name": "jwmSavedViewsByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraNavigationItemEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v30,
                                                    v22,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "cursor"
                                                    }
                                                ]
                                            },
                                            v32,
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "endCursor"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "alias": "navigationItems",
                                        "args": v21,
                                        "filters": [
                                            "cloudId",
                                            "projectIdOrKey"
                                        ],
                                        "handle": "connection",
                                        "key": "tabs_jiraNavigation__navigationItems",
                                        "kind": "LinkedHandle",
                                        "name": "jwmSavedViewsByProject"
                                    }
                                ]
                            },
                            {
                                "condition": "useContainerNavigation",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "input",
                                                "variableName": "containerNavigationInput"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "containerNavigation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isJiraContainerNavigationResult"
                                            },
                                            v22,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v23,
                                                    v33,
                                                    {
                                                        "args": [
                                                            v20
                                                        ],
                                                        "concreteType": "JiraNavigationItemConnection",
                                                        "kind": "LinkedField",
                                                        "name": "navigationItems",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraNavigationItemEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    v30,
                                                                    v22
                                                                ]
                                                            },
                                                            v32
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraContainerNavigation"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v31,
                                                "type": "QueryError"
                                            },
                                            v34
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v11,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": v40
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "projectDataById",
                                        "args": v18,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": v40
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "6d49a582f38a072ccb9f12581830b939f48a2ab461d7881d3494c38c8f24651d",
                "metadata": {},
                "name": "projectNavigation_horizontalNavigationQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $fed7f561d3a05da6$var$node.hash = "5f0fc5f96f73c473950545dece8490fe";
    var $fed7f561d3a05da6$export$2e2bcd8739ae039 = $fed7f561d3a05da6$var$node;
});
parcelRegister("iNzEe", function(module, exports) {
    $parcel$export(module.exports, "navigationResource", ()=>$6b942b0827824c4b$export$62940941ee574cdc);
    $parcel$export(module.exports, "useNavigationResource", ()=>$6b942b0827824c4b$export$c17011c09e042a31);
    $parcel$export(module.exports, "useIsPremiumUserSeat", ()=>$6b942b0827824c4b$export$90749419e9042370);
    $parcel$export(module.exports, "useTriggerOverviewChangeboarding", ()=>$6b942b0827824c4b$export$30f6f0b00bf4f2f8);
    var $gccSB = parcelRequire("gccSB");
    var $j5YhT;
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    var $geiy6;
    const $6b942b0827824c4b$export$62940941ee574cdc = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'BUSINESS_NAVIGATION',
        getKey: ()=>'BUSINESS_NAVIGATION',
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
            if (isAnonymous) return null;
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            if (!(0, ($parcel$interopDefault($gccSB)))(projectKey)) return (0, (0, parcelRequire("geiy6")).fetchNavigation)((0, $77516b48757f52de$export$a40c5d12b8a53ba2), {
                cloudId: cloudId,
                projectKey: projectKey
            });
            if (!(0, ($parcel$interopDefault($gccSB)))(projectId)) return (0, (0, parcelRequire("geiy6")).fetchNavigation)((0, $77516b48757f52de$export$7c9197b656229b53), {
                cloudId: cloudId,
                projectId: (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
                    siteId: cloudId,
                    projectId: projectId
                }).toString()
            });
            return (0, (0, parcelRequire("geiy6")).fetchNavigation)((0, $77516b48757f52de$export$c378ca4a0e2c9fec), {
                cloudId: cloudId
            });
        },
        maxAge: Infinity
    });
    const $6b942b0827824c4b$export$c17011c09e042a31 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($6b942b0827824c4b$export$62940941ee574cdc);
    const $6b942b0827824c4b$export$90749419e9042370 = ()=>{
        const { data: data } = $6b942b0827824c4b$export$c17011c09e042a31();
        if (data === 'NOT_APPLICABLE') return false;
        return Boolean(data?.isPremiumUserSeat);
    };
    const $6b942b0827824c4b$export$30f6f0b00bf4f2f8 = ()=>{
        const { data: data } = $6b942b0827824c4b$export$c17011c09e042a31();
        if (data === 'NOT_APPLICABLE') return false;
        return Boolean(data?.showPlansOnboarding);
    };
});
const $77516b48757f52de$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $77516b48757f52de$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $77516b48757f52de$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $77516b48757f52de$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $77516b48757f52de$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
  jwmOverviewPlanMigrationState {
    ... on JiraOverviewPlanMigrationState {
      changeboardingActive
    }
  }
}
`;
const $77516b48757f52de$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
parcelRegister("geiy6", function(module, exports) {
    $parcel$export(module.exports, "fetchNavigation", ()=>$446f8b979bebb841$export$1fc5fff73d9a570c);
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $ifwpM;
    const $446f8b979bebb841$var$EMPTY_RESPONSE = {
        recents: [],
        favorites: [],
        hasMoreFavorite: false,
        overviews: [],
        overviewsError: null,
        isPremiumUserSeat: false,
        showPlansOnboarding: false,
        shouldHideOverviews: false
    };
    const $446f8b979bebb841$export$1fc5fff73d9a570c = async (query, params)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: query,
                    variables: {
                        first: (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd),
                        ...params
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'projectStyle'
                }
            });
            if (response.data?.jira?.navigation === undefined) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            let areOverviewsGone = false;
            if (Array.isArray(response.errors)) areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
            return (0, (0, parcelRequire("ifwpM")).transformData)(response.data.jira.navigation, areOverviewsGone);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'navigationResource',
                    packageName: 'jiraRouterResourcesBusinessNavigation',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return $446f8b979bebb841$var$EMPTY_RESPONSE;
    };
});
const $4ee2cfa1c76e72ed$export$3349219a88ac77cd = 10;
const $4ee2cfa1c76e72ed$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';
parcelRegister("ifwpM", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$9031e5290b70d3d6$export$3ceb62baab058c6b);
    var $6cG4N;
    var $027FQ;
    const $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
    const $9031e5290b70d3d6$var$PREMIUM = 'PREMIUM';
    const $9031e5290b70d3d6$var$mapProjectNode = (node)=>({
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite,
            permissions: {
                viewIssues: node.viewIssues.canPerform
            },
            defaultView: node.defaultView?.typeKey?.toLowerCase()
        });
    const $9031e5290b70d3d6$var$mapOverviewNode = (node)=>({
            id: node.id,
            name: node.name,
            theme: node?.theme ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name
        });
    const $9031e5290b70d3d6$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
        if (navigation == null) return 0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71;
        let overviews = [];
        let overviewsError = null;
        const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $9031e5290b70d3d6$var$PREMIUM;
        if (isPremiumUserSeat) {
            if (navigation.overviews?.__typename === (0, (0, parcelRequire("027FQ")).OVERVIEWS_SUCCESS_RESPONSE_TYPE)) overviews = navigation.overviews.edges.map((edge)=>$9031e5290b70d3d6$var$mapOverviewNode(edge.node));
            else overviewsError = navigation.overviews ?? new Error('Unknown overviews error');
        }
        let recents = navigation.recentProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
        const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
        recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
        const showPlansOnboarding = Boolean(navigation.jwmOverviewPlanMigrationState?.changeboardingActive);
        const shouldHideOverviews = areOverviewsGone && !showPlansOnboarding;
        return {
            recents: recents,
            favorites: favorites,
            hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
            overviews: overviews,
            overviewsError: overviewsError,
            isPremiumUserSeat: isPremiumUserSeat,
            showPlansOnboarding: showPlansOnboarding,
            shouldHideOverviews: shouldHideOverviews
        };
    };
});
parcelRegister("6cG4N", function(module, exports) {
    $parcel$export(module.exports, "STAR_ICON_COLOR", ()=>$cd302866fea6f361$export$9e0962e0cb41695d);
    $parcel$export(module.exports, "Variables", ()=>$cd302866fea6f361$export$8bb9d79ea938efc9);
    $parcel$export(module.exports, "Tokens", ()=>$cd302866fea6f361$export$8e1e81ac145e31be);
    $parcel$export(module.exports, "BASE_THEME", ()=>$cd302866fea6f361$export$8a6e9b3370a0f87a);
    $parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", ()=>$cd302866fea6f361$export$f286efa6bd1e8f9d);
    $parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", ()=>$cd302866fea6f361$export$97cb21c6432e07e8);
    $parcel$export(module.exports, "GRADIENT_THEME", ()=>$cd302866fea6f361$export$b124f62a6aab972);
    $parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", ()=>$cd302866fea6f361$export$9441e0d8f766c59a);
    $parcel$export(module.exports, "NO_BACKGROUND_CONFIG", ()=>$cd302866fea6f361$export$4c351ec1dc290344);
    $parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", ()=>$cd302866fea6f361$export$34373eced7ee212e);
    $parcel$export(module.exports, "BACKGROUND_COLOR_CONFIGS", ()=>$cd302866fea6f361$export$5ddfadab7b1e12c1);
    $parcel$export(module.exports, "SOLID_COLOR_BACKGROUND_CONFIGS", ()=>$cd302866fea6f361$export$349e5dbeac874253);
    $parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", ()=>$cd302866fea6f361$export$242b2d2213fedf27);
    $parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", ()=>$cd302866fea6f361$export$fe05a238062e2c3d);
    $parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", ()=>$cd302866fea6f361$export$cab9d853866386f2);
    $parcel$export(module.exports, "BANNER_HEIGHT", ()=>$cd302866fea6f361$export$ed7cc0d417ee89e);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", ()=>$cd302866fea6f361$export$8e357501548afe78);
    $parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", ()=>$cd302866fea6f361$export$baaf8255c30ea280);
    $parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", ()=>$cd302866fea6f361$export$d9035bc768f8226d);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", ()=>$cd302866fea6f361$export$4810531e30462f89);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$cd302866fea6f361$export$1c0b806722927549);
    $parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT", ()=>$cd302866fea6f361$export$2af5673c2fa63c55);
    $parcel$export(module.exports, "NAV4_BUSINESS_NAV_HEIGHT", ()=>$cd302866fea6f361$export$5771162cdeebfb85);
    $parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_HEIGHT", ()=>$cd302866fea6f361$export$a1626d6d785092a2);
    $parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$cd302866fea6f361$export$410e3d6221a052e);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_HORIZONTAL_NAV_HEIGHT", ()=>$cd302866fea6f361$export$8588194807a0ca4b);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_NAV_HEIGHT", ()=>$cd302866fea6f361$export$254a8b23553b7df3);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_WRAPPER_HEIGHT", ()=>$cd302866fea6f361$export$41cffad47189e5bd);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$cd302866fea6f361$export$ef343e01db40c562);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", ()=>$cd302866fea6f361$export$77cdace62a821419);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", ()=>$cd302866fea6f361$export$3efe68325dd9dc02);
    var $22jFS;
    var $44v1T;
    const $cd302866fea6f361$export$9e0962e0cb41695d = '#FFAB00';
    const $cd302866fea6f361$export$8bb9d79ea938efc9 = {
        BACKDROP_FILTER: '--project-backdrop-filter',
        COLOR_BACKGROUND_BRAND_BOLD: '--project-color-background-brand-bold',
        COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--project-color-background-brand-bold-hovered',
        COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--project-color-background-brand-bold-pressed',
        COLOR_BACKGROUND_DISABLED: '--project-color-background-disabled',
        COLOR_BACKGROUND_INPUT: '--project-background-input',
        COLOR_BACKGROUND_NEUTRAL: '--project-background-neutral',
        COLOR_BACKGROUND_NEUTRAL_HOVERED: '--project-background-neutral-hovered',
        COLOR_BACKGROUND_NEUTRAL_PRESSED: '--project-background-neutral-pressed',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--project-background-neutral-subtle-hovered',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--project-background-neutral-subtle-pressed',
        COLOR_BACKGROUND_SELECTED: '--project-background-selected',
        COLOR_BORDER: '--project-color-border',
        COLOR_BORDER_INPUT: '--project-color-border-input',
        COLOR_BORDER_INVERSE: '--project-color-border-inverse',
        COLOR_BORDER_SELECTED: '--project-color-border-selected',
        COLOR_ELEVATION_SURFACE: '--project-color-elevation-surface',
        COLOR_ICON_DANGER: '--project-color-icon-danger',
        COLOR_ICON_INFORMATION: '--project-color-icon-information',
        COLOR_ICON_SUCCESS: '--project-color-icon-success',
        COLOR_ICON_WARNING: '--project-color-icon-warning',
        COLOR_LINK: '--project-color-link',
        COLOR_LINK_PRESSED: '--project-color-link-pressed',
        COLOR_SKELETON: '--project-skeleton',
        COLOR_TEXT: '--project-color-text',
        COLOR_TEXT_DISABLED: '--project-color-text-disabled',
        COLOR_TEXT_INVERSE: '--project-color-text-inverse',
        COLOR_TEXT_SELECTED: '--project-color-text-selected',
        COLOR_TEXT_SUBTLE: '--project-color-text-subtle',
        COLOR_TEXT_SUBTLEST: '--project-color-text-subtlest',
        CONTENT_HEIGHT: '--project-content-height',
        CONTENT_WIDTH: '--project-content-width',
        ELEVATION_SURFACE: '--project-elevation-surface',
        ELEVATION_SURFACE_CONTRAST: '--project-elevation-surface-contrast',
        ELEVATION_SURFACE_CONTRAST_BOLDER: '--project-elevation-surface-contrast-bolder',
        WRAPPER_BACKGROUND: '--project-wrapper-background',
        WRAPPER_BORDER_RADIUS: '--project-wrapper-border-radius',
        WRAPPER_HEIGHT: '--project-wrapper-height',
        WRAPPER_PADDING: '--project-wrapper-padding',
        WRAPPER_WIDTH: '--project-wrapper-width'
    };
    const $cd302866fea6f361$export$8e1e81ac145e31be = {
        BACKDROP_FILTER: 'var(--project-backdrop-filter)',
        COLOR_BACKGROUND_BRAND_BOLD: 'var(--project-color-background-brand-bold)',
        COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--project-color-background-brand-bold-hovered)',
        COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--project-color-background-brand-bold-pressed)',
        COLOR_BACKGROUND_DISABLED: 'var(--project-color-background-disabled)',
        COLOR_BACKGROUND_INPUT: 'var(--project-background-input)',
        COLOR_BACKGROUND_NEUTRAL: 'var(--project-background-neutral)',
        COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--project-background-neutral-hovered)',
        COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--project-background-neutral-pressed)',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--project-background-neutral-subtle-hovered)',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--project-background-neutral-subtle-pressed)',
        COLOR_BACKGROUND_SELECTED: 'var(--project-background-selected)',
        COLOR_BORDER: 'var(--project-color-border)',
        COLOR_BORDER_INPUT: 'var(--project-color-border-input)',
        COLOR_BORDER_INVERSE: 'var(--project-color-border-inverse)',
        COLOR_BORDER_SELECTED: 'var(--project-color-border-selected)',
        COLOR_ELEVATION_SURFACE: 'var(--project-color-elevation-surface)',
        COLOR_ICON_DANGER: 'var(--project-color-icon-danger)',
        COLOR_ICON_INFORMATION: 'var(--project-color-icon-information)',
        COLOR_ICON_SUCCESS: 'var(--project-color-icon-success)',
        COLOR_ICON_WARNING: 'var(--project-color-icon-warning)',
        COLOR_LINK: 'var(--project-color-link)',
        COLOR_LINK_PRESSED: 'var(--project-color-link-pressed)',
        COLOR_SKELETON: 'var(--project-skeleton)',
        COLOR_TEXT: 'var(--project-color-text)',
        COLOR_TEXT_DISABLED: 'var(--project-color-text-disabled)',
        COLOR_TEXT_INVERSE: 'var(--project-color-text-inverse)',
        COLOR_TEXT_SELECTED: 'var(--project-color-text-selected)',
        COLOR_TEXT_SUBTLE: 'var(--project-color-text-subtle)',
        COLOR_TEXT_SUBTLEST: 'var(--project-color-text-subtlest)',
        CONTENT_HEIGHT: 'var(--project-content-height)',
        CONTENT_WIDTH: 'var(--project-content-width)',
        ELEVATION_SURFACE: 'var(--project-elevation-surface)',
        ELEVATION_SURFACE_CONTRAST: 'var(--project-elevation-surface-contrast)',
        ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--project-elevation-surface-contrast-bolder)',
        WRAPPER_BACKGROUND: 'var(--project-wrapper-background)',
        WRAPPER_BORDER_RADIUS: 'var(--project-wrapper-border-radius)',
        WRAPPER_HEIGHT: 'var(--project-wrapper-height)',
        WRAPPER_PADDING: 'var(--project-wrapper-padding)',
        WRAPPER_WIDTH: 'var(--project-wrapper-width)'
    };
    const $cd302866fea6f361$export$8a6e9b3370a0f87a = {
        'color.background.brand.bold': "var(--ds-background-brand-bold, #09326C)",
        'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0C66E4)",
        'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
        'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
        'color.background.input': `var(--ds-background-input, ${(0, $829f609a65d26a98$exports).N0})`,
        'color.background.neutral': `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N30A})`,
        'color.background.neutral.hovered': `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$exports).N40A})`,
        'color.background.neutral.pressed': `var(--ds-background-neutral-pressed, ${(0, $829f609a65d26a98$exports).N50A})`,
        'color.background.neutral.subtle.hovered': `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$exports).N40A})`,
        'color.background.neutral.subtle.pressed': `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$exports).N50A})`,
        'color.background.selected': `var(--ds-background-selected, ${(0, $829f609a65d26a98$exports).B400})`,
        'color.elevation.surface': `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
        'color.border': `var(--ds-border, ${(0, $829f609a65d26a98$exports).N40A})`,
        'color.border.input': "var(--ds-border-input, #091E4224)",
        'color.border.inverse': `var(--ds-border-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        'color.border.selected': `var(--ds-border-selected, ${(0, $829f609a65d26a98$exports).B400})`,
        'color.icon.danger': `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R200})`,
        'color.icon.information': `var(--ds-icon-information, ${(0, $829f609a65d26a98$exports).B200})`,
        'color.icon.success': `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G200})`,
        'color.icon.warning': `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y200})`,
        'color.link': "var(--ds-link, #0c66e4)",
        'color.link.pressed': "var(--ds-link-pressed, #0055cc)",
        'color.skeleton': `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N20A})`,
        'color.text': `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
        'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
        'color.text.inverse': `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        'color.text.selected': `var(--ds-text-selected, ${(0, $829f609a65d26a98$exports).B400})`,
        'color.text.subtle': `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
        'color.text.subtlest': "var(--ds-text-subtlest, #626f86)",
        'elevation.surface.contrast': 'transparent',
        'elevation.surface.contrast.bolder': 'transparent'
    };
    const $cd302866fea6f361$export$f286efa6bd1e8f9d = {
        'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
        'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
        'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
        'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
        'color.background.input': 'rgba(255, 255, 255, 0.8)',
        'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
        'color.text.selected': `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`
    };
    const $cd302866fea6f361$export$97cb21c6432e07e8 = {
        'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
        'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
        'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
        'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
        'color.background.input': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
        'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
        'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
        'color.background.selected': 'rgba(255, 255, 255, 0.6)',
        'color.elevation.surface': '#172b4d',
        'color.border': 'rgba(255, 255, 255, 0.14)',
        'color.border.input': 'rgba(255, 255, 255, 0.3)',
        'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
        'color.border.selected': (0, $829f609a65d26a98$exports).N0,
        'color.icon.danger': (0, $829f609a65d26a98$exports).N0,
        'color.icon.information': (0, $829f609a65d26a98$exports).N0,
        'color.icon.success': (0, $829f609a65d26a98$exports).N0,
        'color.icon.warning': (0, $829f609a65d26a98$exports).N0,
        'color.skeleton': 'rgba(255,255,255,0.08)',
        'color.text': (0, $829f609a65d26a98$exports).N0,
        'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
        'color.text.inverse': '#172B4D',
        'color.text.selected': '#172B4D',
        'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
        'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
    };
    const $cd302866fea6f361$export$b124f62a6aab972 = {
        'color.link': '#CCE0FF',
        'color.link.pressed': '#E9F2FF'
    };
    const $cd302866fea6f361$export$9441e0d8f766c59a = {
        name: 'image',
        brightness: 'high',
        theme: {
            light: {
                'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
                'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
                'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
                'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
                'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
                'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
                'color.text.selected': `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
                'elevation.surface.contrast.bolder': `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`
            },
            dark: {
                'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #8C9BAB)",
                'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #9FADBC)",
                'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
                'color.background.input': 'rgba(34, 39, 43, 0.8)',
                'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
                'color.elevation.surface': '#172b4d',
                'color.border': 'rgba(255, 255, 255, 0.14)',
                'color.border.input': 'rgba(255, 255, 255, 0.3)',
                'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
                'color.icon.danger': (0, $829f609a65d26a98$exports).N0,
                'color.icon.information': (0, $829f609a65d26a98$exports).N0,
                'color.icon.success': (0, $829f609a65d26a98$exports).N0,
                'color.icon.warning': (0, $829f609a65d26a98$exports).N0,
                'color.link': "var(--ds-text-accent-blue-bolder, #CCE0FF)",
                'color.link.pressed': "var(--ds-text-accent-blue, #85B8FF)",
                'color.skeleton': 'rgba(255,255,255,0.8)',
                'color.text': (0, $829f609a65d26a98$exports).N0,
                'color.text.selected': "var(--ds-text-inverse, #1D2125)",
                'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
                'elevation.surface.contrast.bolder': "var(--ds-surface, #1D2125)"
            }
        }
    };
    const $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG = {
        name: 'white'
    };
    const $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
        name: 'light-purple'
    };
    const $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
        name: 'light-blue'
    };
    const $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
        name: 'light-teal'
    };
    const $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
        name: 'light-green'
    };
    const $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
        name: 'light-yellow'
    };
    const $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG = {
        name: 'light-red'
    };
    const $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
        name: 'light-magenta'
    };
    const $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
        name: 'light-orange'
    };
    const $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG = {
        name: 'dark'
    };
    const $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG = {
        name: 'purple'
    };
    const $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG = {
        name: 'blue'
    };
    const $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG = {
        name: 'teal'
    };
    const $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG = {
        name: 'green'
    };
    const $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG = {
        name: 'yellow'
    };
    const $cd302866fea6f361$var$RED_BACKGROUND_CONFIG = {
        name: 'red'
    };
    const $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG = {
        name: 'magenta'
    };
    const $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG = {
        name: 'orange'
    };
    const $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG = {
        name: 'darker-gray',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
        name: 'darker-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            },
            dark: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG = {
        name: 'darker-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            },
            dark: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG = {
        name: 'darker-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            },
            dark: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG = {
        name: 'darker-green',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            },
            dark: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG = {
        name: 'darker-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            },
            dark: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
        name: 'darker-yellow',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            },
            dark: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
        name: 'darker-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            },
            dark: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG = {
        name: 'darker-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            },
            dark: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
        name: 'darker-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            },
            dark: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
        name: 'darkest-gray',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            },
            dark: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
        name: 'darkest-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            },
            dark: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
        name: 'darkest-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            },
            dark: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
        name: 'darkest-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            },
            dark: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
        name: 'darkest-green',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            },
            dark: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG = {
        name: 'darkest-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            },
            dark: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
        name: 'darkest-yellow',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            },
            dark: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
        name: 'darkest-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            },
            dark: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG = {
        name: 'darkest-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            },
            dark: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
        name: 'darkest-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            },
            dark: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
        name: 'lightest-gray',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F1F2F4',
                'color.link': '#44546F',
                'color.link.pressed': '#091E42'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
        name: 'lightest-purple',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F3F0FF',
                'color.link': '#5E4DB2',
                'color.link.pressed': '#352C63'
            },
            dark: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
        name: 'lightest-blue',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#E9F2FF',
                'color.link': '#0055CC',
                'color.link.pressed': '#09326C'
            },
            dark: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
        name: 'lightest-teal',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#E7F9FF',
                'color.link': '#206A83',
                'color.link.pressed': '#164555'
            },
            dark: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
        name: 'lightest-green',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DCFFF1',
                'color.link': '#216E4E',
                'color.link.pressed': '#164B35'
            },
            dark: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
        name: 'lightest-lime',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#EFFFD6',
                'color.link': '#4C6B1F',
                'color.link.pressed': '#37471F'
            },
            dark: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
        name: 'lightest-yellow',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFF7D6',
                'color.link': '#7F5F01',
                'color.link.pressed': '#533F04'
            },
            dark: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
        name: 'lightest-orange',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFF3EB',
                'color.link': '#A54800',
                'color.link.pressed': '#702E00'
            },
            dark: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
        name: 'lightest-red',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFECEB',
                'color.link': '#AE2E24',
                'color.link.pressed': '#5D1F1A'
            },
            dark: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
        name: 'lightest-magenta',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFECF8',
                'color.link': '#943D73',
                'color.link.pressed': '#50253F'
            },
            dark: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
        name: 'lighter-gray',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DCDFE4',
                'color.link': '#44546F',
                'color.link.pressed': '#091E42'
            },
            dark: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
        name: 'lighter-purple',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DFD8FD',
                'color.link': '#5E4DB2',
                'color.link.pressed': '#352C63'
            },
            dark: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
        name: 'lighter-blue',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#CCE0FF',
                'color.link': '#0055CC',
                'color.link.pressed': '#09326C'
            },
            dark: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
        name: 'lighter-teal',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#C6EDFB',
                'color.link': '#206A83',
                'color.link.pressed': '#164555'
            },
            dark: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
        name: 'lighter-green',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#BAF3DB',
                'color.link': '#216E4E',
                'color.link.pressed': '#164B35'
            },
            dark: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
        name: 'lighter-lime',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#D3F1A7',
                'color.link': '#4C6B1F',
                'color.link.pressed': '#37471F'
            },
            dark: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
        name: 'lighter-yellow',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F8E6A0',
                'color.link': '#7F5F01',
                'color.link.pressed': '#533F04'
            },
            dark: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
        name: 'lighter-orange',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FEDEC8',
                'color.link': '#A54800',
                'color.link.pressed': '#702E00'
            },
            dark: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG = {
        name: 'lighter-red',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFD5D2',
                'color.link': '#AE2E24',
                'color.link.pressed': '#5D1F1A'
            },
            dark: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
        name: 'lighter-magenta',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FDD0EC',
                'color.link': '#943D73',
                'color.link.pressed': '#50253F'
            },
            dark: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$export$4c351ec1dc290344 = {
        name: 'no-background',
        brightness: 'high',
        theme: {
            light: $cd302866fea6f361$export$8a6e9b3370a0f87a,
            dark: $cd302866fea6f361$export$8a6e9b3370a0f87a
        }
    };
    const $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META = {
        name: 'gradient-gray-to-black',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
        name: 'gradient-dark-to-medium-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
        name: 'gradient-light-to-dark-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META = {
        name: 'gradient-blue-to-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
        name: 'gradient-purple-to-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
        name: 'gradient-magenta-to-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
        name: 'gradient-dark-to-light-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
        name: 'gradient-dark-to-light-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
        name: 'gradient-dark-green-to-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
        name: 'gradient-dark-to-medium-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
            }
        }
    };
    const $cd302866fea6f361$export$34373eced7ee212e = [
        $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG
    ];
    const $cd302866fea6f361$export$5ddfadab7b1e12c1 = [
        $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
    ];
    const $cd302866fea6f361$export$349e5dbeac874253 = [
        ...$cd302866fea6f361$export$5ddfadab7b1e12c1,
        $cd302866fea6f361$export$4c351ec1dc290344
    ];
    const $cd302866fea6f361$export$242b2d2213fedf27 = [
        $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META,
        $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META,
        $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
        $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META,
        $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META,
        $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
        $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
        $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
        $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META,
        $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META
    ];
    const $cd302866fea6f361$export$8f118a95a310853a = [
        ...$cd302866fea6f361$export$242b2d2213fedf27,
        ...$cd302866fea6f361$export$349e5dbeac874253
    ];
    const $cd302866fea6f361$export$fe05a238062e2c3d = {
        white: $cd302866fea6f361$export$4c351ec1dc290344,
        'light-purple': $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
        'light-blue': $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
        'light-teal': $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
        'light-green': $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
        'light-yellow': $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
        'light-orange': $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
        'light-red': $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
        'light-magenta': $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
        dark: $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
        purple: $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
        blue: $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
        teal: $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
        green: $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
        yellow: $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
        orange: $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
        red: $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
        magenta: $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG
    };
    const $cd302866fea6f361$export$cab9d853866386f2 = $cd302866fea6f361$export$4c351ec1dc290344;
    const $cd302866fea6f361$export$ed7cc0d417ee89e = '--jwm-banner-height';
    const $cd302866fea6f361$export$7009ab5fba189797 = `var(${$cd302866fea6f361$export$ed7cc0d417ee89e}, 0px)`;
    const $cd302866fea6f361$export$8e357501548afe78 = 24;
    const $cd302866fea6f361$export$baaf8255c30ea280 = 95;
    const $cd302866fea6f361$export$d9035bc768f8226d = `calc(${$cd302866fea6f361$export$baaf8255c30ea280}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
    const $cd302866fea6f361$export$4810531e30462f89 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$d9035bc768f8226d})`;
    const $cd302866fea6f361$export$1c0b806722927549 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$d9035bc768f8226d} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
    const $cd302866fea6f361$export$2af5673c2fa63c55 = 126;
    const $cd302866fea6f361$export$5771162cdeebfb85 = `calc(${$cd302866fea6f361$export$2af5673c2fa63c55}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
    const $cd302866fea6f361$export$a1626d6d785092a2 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$5771162cdeebfb85})`;
    const $cd302866fea6f361$export$410e3d6221a052e = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$5771162cdeebfb85} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
    const $cd302866fea6f361$export$8588194807a0ca4b = 146;
    const $cd302866fea6f361$export$254a8b23553b7df3 = `calc(${$cd302866fea6f361$export$8588194807a0ca4b}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
    const $cd302866fea6f361$export$41cffad47189e5bd = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$254a8b23553b7df3})`;
    const $cd302866fea6f361$export$ef343e01db40c562 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$254a8b23553b7df3} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
    const $cd302866fea6f361$export$77cdace62a821419 = `calc(100vw - ${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH)}) !important`;
    const $cd302866fea6f361$export$3efe68325dd9dc02 = `calc(100vw - ${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH)} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px) !important`;
});
parcelRegister("44v1T", function(module, exports) {
    $parcel$export(module.exports, "PAGE_LAYOUT_OFFSET_TOP", ()=>$81918a2ef6db1f93$export$d60454526e2281af);
    var $22jFS;
    const $81918a2ef6db1f93$export$d60454526e2281af = `(${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT)} + ${(0, (0, parcelRequire("22jFS")).BANNER_HEIGHT)})`;
});
parcelRegister("027FQ", function(module, exports) {
    $parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", ()=>$fd4c320fd9ec6c35$export$ddf2fc82885279d);
    const $fd4c320fd9ec6c35$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
    const $fd4c320fd9ec6c35$export$39284f7325536558 = {
        ServiceDesk: 'SERVICE_DESK',
        Business: 'BUSINESS',
        Software: 'SOFTWARE'
    };
    const $fd4c320fd9ec6c35$export$1f66f9f05afa05a8 = {
        TeamManagedProject: 'TEAM_MANAGED_PROJECT',
        CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
    };
});
parcelRegister("jrO9m", function(module, exports) {
    $parcel$export(module.exports, "overviewDetailsResource", ()=>$e1715b61e2fa96e9$export$cd57aa046b167312);
    $parcel$export(module.exports, "useOverview", ()=>$e1715b61e2fa96e9$export$626541a5c6f2cfa1);
    var $2M1hQ;
    var $2YP9W;
    var $hFi7P;
    const $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
    const $e1715b61e2fa96e9$export$cd57aa046b167312 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY,
        getKey: ({ match: match })=>`${$e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
        getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, (0, parcelRequire("hFi7P")).fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
        maxAge: 3600000
    });
    const $e1715b61e2fa96e9$export$626541a5c6f2cfa1 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($e1715b61e2fa96e9$export$cd57aa046b167312);
});
parcelRegister("hFi7P", function(module, exports) {
    $parcel$export(module.exports, "fetchOverviewDetails", ()=>$692d3aa28ecf0a74$export$f0395142dbdd6c61);
    var $7q3cr;
    var $63wRx;
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $dpLxG;
    const $692d3aa28ecf0a74$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
        if (!overviewId) return null;
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, (0, parcelRequire("dpLxG")).QUERY),
                    variables: {
                        id: (0, (0, parcelRequire("7q3cr")).JiraProjectOverviewAri).create({
                            siteId: cloudId,
                            activationId: activationId,
                            overviewId: overviewId
                        }).toString()
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'projectStyle'
                }
            });
            if (response?.data?.jira?.overview?.__typename === (0, $4bd5c695609ae115$export$62a5da7e3fa5ff88)) return (0, (0, parcelRequire("63wRx")).mapOverviewFragment)(response.data.jira.overview);
            throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response?.data?.jira?.overview ?? response.errors);
        } catch (error) {
            if (error?.statusCode === 410) throw error;
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'overviewDetailsResource',
                        packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                        teamName: 'wanjel'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
        return null;
    };
});
parcelRegister("63wRx", function(module, exports) {
    $parcel$export(module.exports, "mapOverviewFragment", ()=>$bc1a4d4cd369fa52$export$e79bf238de33eabb);
    const $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
    const $bc1a4d4cd369fa52$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
            const { node: node } = edge || {};
            if (node == null) return null;
            return {
                key: node.key,
                id: Number(node.projectId),
                avatarUrl: node.avatar?.large ?? '',
                name: node.name,
                type: node.projectType.toLowerCase(),
                isSimplified: node.projectStyle === $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE,
                isFavorite: node.isFavourite === true,
                permissions: {
                    assignIssues: false,
                    administerProject: node.administerProject.canPerform,
                    createIssues: node.createIssues.canPerform,
                    deleteIssues: node.deleteIssues.canPerform,
                    editIssues: node.editIssues.canPerform,
                    linkIssues: node.linkIssues.canPerform,
                    scheduleIssues: node.scheduleIssues.canPerform,
                    transitionIssues: node.transitionIssues?.canPerform === true,
                    viewIssues: node.viewIssues.canPerform
                }
            };
        }).filter((project)=>project);
    const $bc1a4d4cd369fa52$export$e79bf238de33eabb = (overview)=>{
        const { id: id, name: name, theme: theme, projects: projectsData } = overview;
        const projects = $bc1a4d4cd369fa52$var$mapProjectsNode(projectsData.edges);
        const unreachableProjectsCount = projectsData.edges.length - projects.length;
        return {
            id: id,
            name: name,
            theme: theme,
            projects: projects,
            unreachableProjectsCount: unreachableProjectsCount
        };
    };
});
parcelRegister("dpLxG", function(module, exports) {
    $parcel$export(module.exports, "QUERY", ()=>$42259e945f9fd88b$export$2b91517d6d5b4365);
    const $42259e945f9fd88b$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892)}
`;
});
const $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;
const $4bd5c695609ae115$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';
parcelRegister("l2N2a", function(module, exports) {
    $parcel$export(module.exports, "projectDetailsResource", ()=>$a72df1053ff3c9a0$export$e541d9eb202b4972);
    $parcel$export(module.exports, "useProject", ()=>$a72df1053ff3c9a0$export$51b1383ef8844a7);
    $parcel$export(module.exports, "useMediaConfiguration", ()=>$a72df1053ff3c9a0$export$ab5cf8327e07f046);
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    var $8s4PA;
    const $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
    const $a72df1053ff3c9a0$export$e541d9eb202b4972 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            const projectIdOrKey = projectKey || projectId;
            return `${$a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return (0, (0, parcelRequire("8s4PA")).fetchProjectDetails)(cloudId, projectKey, projectId);
        },
        maxAge: 3600000
    });
    const $a72df1053ff3c9a0$export$51b1383ef8844a7 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($a72df1053ff3c9a0$export$e541d9eb202b4972);
        return {
            data: data?.currentProject ?? null,
            loading: loading,
            error: error
        };
    };
    const $a72df1053ff3c9a0$export$ab5cf8327e07f046 = ()=>{
        const { data: data } = (0, (0, parcelRequire("2YP9W")).useResource)($a72df1053ff3c9a0$export$e541d9eb202b4972);
        return data?.media ?? null;
    };
});
parcelRegister("8s4PA", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectDetails", ()=>$3400333a67b09775$export$78aa221476efa1c6);
    var $j5YhT;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $2D9kr;
    const $3400333a67b09775$var$EMPTY_VALUE = {
        themeSetting: null,
        media: null
    };
    const $3400333a67b09775$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
        const projectIdOrKey = projectId || projectKey;
        if (!projectIdOrKey) return null;
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
                body: JSON.stringify({
                    query: (0, $7ceb2e31b4137f58$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        usingProjectKey: projectId == null,
                        projectId: projectId != null ? (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
                            siteId: cloudId,
                            projectId: projectId
                        }).toString() : ''
                    }
                })
            });
            return (0, (0, parcelRequire("2D9kr")).transformData)(response.data, projectIdOrKey);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'projectDetailsResource',
                        packageName: 'jiraRouterResourcesBusinessProjectDetails',
                        teamName: 'wanjel'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
        return $3400333a67b09775$var$EMPTY_VALUE;
    };
});
const $7ceb2e31b4137f58$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  status
  simplified
  favorite
  assignIssues: action(type: ASSIGN_ISSUES) {
    canPerform
  }
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  deleteIssues: action(type: DELETE_ISSUES) {
    canPerform
  }
  editIssues: action(type: EDIT_ISSUES) {
    canPerform
  }
  linkIssues: action(type: LINK_ISSUES) {
    canPerform
  }
  scheduleIssues: action(type: SCHEDULE_ISSUES) {
    canPerform
  }
  transitionIssues: action(type: TRANSITION_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $7ceb2e31b4137f58$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jira {
    mediaClientId(cloudId: $cloudId)
    mediaExternalEndpointUrl(cloudId: $cloudId)
  }
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
    theme: jwmActiveBackgroundByProject(projectIdOrKey: $projectIdOrKey) {
      __typename
      ... on QueryError {
        identifier
        message
        extensions {
          statusCode
          errorType
        }
      }
      ... on JiraWorkManagementBackground {
        ... on JiraWorkManagementColorBackground {
          colorValue
        }
        ... on JiraWorkManagementGradientBackground {
          gradientValue
        }
        ... on JiraWorkManagementMediaBackground {
          customBackground {
            id
            mediaApiFileId
            mediaReadToken (durationInSeconds: 600)
            sourceType
            sourceIdentifier
            altText
          }
        }
      }
    }
  }
}
${$7ceb2e31b4137f58$var$PROJECT_FRAGMENT}
`;
parcelRegister("2D9kr", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$a9016a2d391e1663$export$3ceb62baab058c6b);
    const $a9016a2d391e1663$var$mapProjectNode = (node)=>{
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            status: node.status,
            isSimplified: node.simplified,
            isFavorite: node.favorite === true,
            permissions: {
                assignIssues: node.assignIssues.canPerform,
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                transitionIssues: node.transitionIssues.canPerform,
                viewIssues: node.viewIssues.canPerform
            }
        };
    };
    const $a9016a2d391e1663$var$parseThemeSetting = (data)=>{
        const theme = data?.jwmSidebar?.theme;
        if (theme?.__typename === 'JiraWorkManagementColorBackground') return {
            type: 'color',
            value: theme.colorValue
        };
        if (theme?.__typename === 'JiraWorkManagementGradientBackground') return {
            type: 'color',
            value: theme.gradientValue
        };
        if (theme?.__typename === 'JiraWorkManagementMediaBackground') {
            const { customBackground: customBackground } = theme;
            const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText } = customBackground;
            return {
                type: 'image',
                value: 'image',
                id: id,
                mediaApiFileId: mediaApiFileId,
                mediaReadToken: mediaReadToken,
                sourceType: sourceType,
                sourceIdentifier: sourceIdentifier,
                altText: altText
            };
        }
        return null;
    };
    const $a9016a2d391e1663$var$parseMediaConfiguration = (data)=>{
        const clientId = data?.jira?.mediaClientId;
        const externalEndpointUrl = data?.jira?.mediaExternalEndpointUrl;
        if (clientId == null || externalEndpointUrl == null) return null;
        return {
            clientId: clientId,
            externalEndpointUrl: externalEndpointUrl
        };
    };
    const $a9016a2d391e1663$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
            themeSetting: $a9016a2d391e1663$var$parseThemeSetting(data),
            currentProject: $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
            projectIdOrKey: projectIdOrKey,
            media: $a9016a2d391e1663$var$parseMediaConfiguration(data)
        });
});
parcelRegister("9yEpR", function(module, exports) {
    $parcel$export(module.exports, "storageDetailsResource", ()=>$920f9d6e578a6c36$export$76c871115d0c70a1);
    $parcel$export(module.exports, "useStorageDetails", ()=>$920f9d6e578a6c36$export$8c295c187914aac1);
    var $2M1hQ;
    var $2YP9W;
    var $6Z2DE;
    const $920f9d6e578a6c36$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_INSTANCE_STORAGE';
    const $920f9d6e578a6c36$export$76c871115d0c70a1 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $920f9d6e578a6c36$var$RESOURCE_TYPE_KEY,
        getKey: ()=>$920f9d6e578a6c36$var$RESOURCE_TYPE_KEY,
        getData: async (_, { tenantContext: { appEditions: appEditions } })=>(0, (0, parcelRequire("6Z2DE")).fetchStorageDetails)(appEditions),
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $920f9d6e578a6c36$export$8c295c187914aac1 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($920f9d6e578a6c36$export$76c871115d0c70a1);
});
parcelRegister("6Z2DE", function(module, exports) {
    $parcel$export(module.exports, "fetchStorageDetails", ()=>$6e4752d8c4202fab$export$576d1c3de6af9760);
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $ldyPw;
    const $6e4752d8c4202fab$export$576d1c3de6af9760 = async (appEditions)=>{
        try {
            if (appEditions?.core !== (0, (0, parcelRequire("ldyPw")).FREE_EDITION)) return null;
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/latest?query', {
                body: JSON.stringify({
                    query: (0, $3d489d21cba189e7$export$2b91517d6d5b4365),
                    variables: {
                        productKey: 'jira-core'
                    }
                }),
                headers: {
                    'content-type': 'application/json'
                }
            });
            if (response.errors != null) {
                const error = response.errors?.[0];
                const isClientError = error?.extensions?.statusCode >= 400 && error?.extensions?.statusCode < 500;
                if (!isClientError) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            }
            const usageLimit = response?.data?.attachmentStorage;
            if (usageLimit && usageLimit?.allowed) {
                const percentageUsed = Math.round(usageLimit?.used / usageLimit.allowed * 100);
                return percentageUsed;
            }
            return null;
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('getStorageAmountService', 'Something went wrong while fetching storage amount');
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getStorageAmountService',
                    packageName: 'jiraRouterResourcesBusinessStorageDetails',
                    teamName: 'jira-warepil'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
const $3d489d21cba189e7$export$2b91517d6d5b4365 = `
query Storage($productKey: String!) {
  attachmentStorage(productKey: $productKey) {
    used
    allowed
    isUnlimited
  }
}`;
parcelRegister("aFVvc", function(module, exports) {
    $parcel$export(module.exports, "projectCreatePermissionsResource", ()=>$9880b75bed11d4d0$export$f6c05eaea53ab4ae);
    $parcel$export(module.exports, "useProjectCreatePermissionsResource", ()=>$9880b75bed11d4d0$export$2bd0d3b374549a68);
    var $2M1hQ;
    var $2YP9W;
    const $9880b75bed11d4d0$var$getDataLoader = ()=>(parcelRequire("axsKz"));
    const $9880b75bed11d4d0$export$f6c05eaea53ab4ae = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $acc15b1fbe2101c5$export$8bc44dee8c6d28f),
        getKey: ()=>'state',
        getDataLoader: $9880b75bed11d4d0$var$getDataLoader,
        maxAge: Infinity
    });
    const $9880b75bed11d4d0$export$2bd0d3b374549a68 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($9880b75bed11d4d0$export$f6c05eaea53ab4ae);
});
const $acc15b1fbe2101c5$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';
parcelRegister("axsKz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bqWWL").then(()=>parcelRequire('5Yzmr'));
});
parcelRegister("hBv66", function(module, exports) {
    $parcel$export(module.exports, "genericProjectSidebars", ()=>$0b920001492d0ef4$export$d88d2d25355bc89a);
    $parcel$export(module.exports, "classicBoardSidebars", ()=>$0b920001492d0ef4$export$c04daf123cec1f1e);
    $parcel$export(module.exports, "genericConnectSidebars", ()=>$0b920001492d0ef4$export$844d342b575ead35);
    var $cin8p;
    var $dmKXV;
    var $iHiHz;
    var $cOg46;
    var $koWFd;
    var $h0bZU;
    var $9s3j1;
    var $2IHt2;
    const $0b920001492d0ef4$export$d88d2d25355bc89a = [
        (0, (0, parcelRequire("dmKXV")).default),
        (0, (0, parcelRequire("koWFd")).default),
        (0, (0, parcelRequire("h0bZU")).default),
        (0, (0, parcelRequire("9s3j1")).default),
        (0, (0, parcelRequire("2IHt2")).default)
    ];
    const $0b920001492d0ef4$export$c04daf123cec1f1e = [
        (0, (0, parcelRequire("9s3j1")).default),
        (0, (0, parcelRequire("2IHt2")).default)
    ];
    const $0b920001492d0ef4$export$844d342b575ead35 = [
        ...$0b920001492d0ef4$export$d88d2d25355bc89a,
        (0, (0, parcelRequire("cin8p")).default),
        (0, (0, parcelRequire("iHiHz")).default),
        (0, (0, parcelRequire("cOg46")).default)
    ];
});
parcelRegister("cin8p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$760a63d3e4200cc2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $760a63d3e4200cc2$var$LazyConnectSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("bxwfY")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
    });
    const $760a63d3e4200cc2$var$ConnectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "connect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($760a63d3e4200cc2$var$LazyConnectSidebar, null)));
    $760a63d3e4200cc2$var$ConnectSidebar.displayName = 'ConnectSidebar';
    var $760a63d3e4200cc2$export$2e2bcd8739ae039 = $760a63d3e4200cc2$var$ConnectSidebar;
});
parcelRegister("bxwfY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("a8u2l")
    ]).then(()=>parcelRequire('caET0'));
});
parcelRegister("iHiHz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$883820dc444dc59c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("6xFyF")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
    });
    const $883820dc444dc59c$var$GlobalAppsSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalAppsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar, null)));
    $883820dc444dc59c$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
    var $883820dc444dc59c$export$2e2bcd8739ae039 = $883820dc444dc59c$var$GlobalAppsSettingsSidebar;
});
parcelRegister("6xFyF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3EO4A")
    ]).then(()=>parcelRequire('kO26e'));
});
parcelRegister("cOg46", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$18dc7dd640caeb91$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("jjusI")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
    });
    const $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalSystemSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar, null)));
    $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
    var $18dc7dd640caeb91$export$2e2bcd8739ae039 = $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar;
});
parcelRegister("jjusI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("gQZpl")
    ]).then(()=>parcelRequire('6Pefo'));
});
parcelRegister("2IHt2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8627747b0236ab96$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $8627747b0236ab96$var$LazyUserSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("j9Afm")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
    });
    const $8627747b0236ab96$var$UserSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "user"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8627747b0236ab96$var$LazyUserSidebar, null)));
    $8627747b0236ab96$var$UserSidebar.displayName = 'UserSidebar';
    var $8627747b0236ab96$export$2e2bcd8739ae039 = $8627747b0236ab96$var$UserSidebar;
});
parcelRegister("j9Afm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("36IoX")
    ]).then(()=>parcelRequire('3AQ56'));
});
parcelRegister("1WlLE", function(module, exports) {
    $parcel$export(module.exports, "queuesNavigationItems", ()=>$c68314f43531feff$export$4fed8be571897bef);
    $parcel$export(module.exports, "priorityGroupResource", ()=>$c68314f43531feff$export$1f9ab301771fe42e);
    $parcel$export(module.exports, "priorityGroupByProjectIdResource", ()=>$c68314f43531feff$export$f6133a181a1ec201);
    $parcel$export(module.exports, "issueListSsrResource", ()=>$c68314f43531feff$export$3d03cbaac8581e65);
    var $9XE6b = parcelRequire("9XE6b");
    var $jcw0u;
    var $jthxb;
    var $1nb22;
    var $2M1hQ;
    var $8w6CZ;
    var $fRrvi;
    const $c68314f43531feff$var$getDataLoader = ()=>(parcelRequire("dxxie"));
    const $c68314f43531feff$var$getPriorityGroupDataLoader = ()=>(parcelRequire("jyy5p"));
    const $c68314f43531feff$var$fetchIssueListDataLoader = ()=>(parcelRequire("9mhm7"));
    const $c68314f43531feff$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}-${(0, ($parcel$interopDefault($9XE6b)))(match, 'params.queueId', '')}`;
    const $c68314f43531feff$export$4fed8be571897bef = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("8w6CZ")).RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
        getDataLoader: $c68314f43531feff$var$getDataLoader,
        maxAge: (0, (0, parcelRequire("8w6CZ")).ONE_DAY_IN_MILLIS)
    });
    const $c68314f43531feff$export$1f9ab301771fe42e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("8w6CZ")).RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
        getDataLoader: $c68314f43531feff$var$getPriorityGroupDataLoader,
        maxAge: (0, (0, parcelRequire("8w6CZ")).ONE_DAY_IN_MILLIS),
        isBrowserOnly: true
    });
    const $c68314f43531feff$export$f6133a181a1ec201 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("8w6CZ")).RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS_BY_PROJECT_ID),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
        getData: async ({ match: match, query: query, dependencies: dependencies }, { tenantContext: { cloudId: cloudId } })=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            try {
                const { projectId: projectId } = await (0, (0, parcelRequire("jthxb")).consumeDependency)(dependencies, (0, $0f463a88567f1621$export$80a60a092d9ab81));
                return (0, (0, parcelRequire("fRrvi")).getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchProjectContextError',
                        packageName: 'jiraRouterResourcesServiceDeskQueues',
                        teamName: 'jsm-flash'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                return (0, (0, parcelRequire("fRrvi")).getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
            }
        },
        maxAge: (0, (0, parcelRequire("8w6CZ")).ONE_DAY_IN_MILLIS),
        isBrowserOnly: true,
        depends: [
            (0, $0f463a88567f1621$export$80a60a092d9ab81)
        ]
    });
    const $c68314f43531feff$export$3d03cbaac8581e65 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("8w6CZ")).RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
        getKey: $c68314f43531feff$var$getCombinedProjectKeyAndQueueId,
        getDataLoader: $c68314f43531feff$var$fetchIssueListDataLoader,
        maxAge: 0,
        skipBrowser: true
    });
});
parcelRegister("jthxb", function(module, exports) {
    $parcel$export(module.exports, "consumeDependency", ()=>$c406e66b8b597668$export$a973ef9e17a326f);
    async function $c406e66b8b597668$export$a973ef9e17a326f(dependencies, key) {
        if (dependencies[key]?.loading) return dependencies[key]?.promise;
        if (dependencies[key]?.error) throw dependencies[key]?.error;
        return dependencies[key]?.data;
    }
});
parcelRegister("8w6CZ", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", ()=>$a4c66eaf20e13a4d$export$a401e6d6b205c72b);
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", ()=>$a4c66eaf20e13a4d$export$2064262c540606ba);
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS_BY_PROJECT_ID", ()=>$a4c66eaf20e13a4d$export$efa043b0bbc0ab6d);
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", ()=>$a4c66eaf20e13a4d$export$2733615da5b906f0);
    $parcel$export(module.exports, "ONE_DAY_IN_MILLIS", ()=>$a4c66eaf20e13a4d$export$5a00268156ea5027);
    const $a4c66eaf20e13a4d$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
    const $a4c66eaf20e13a4d$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
    const $a4c66eaf20e13a4d$export$efa043b0bbc0ab6d = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS_BY_PROJECT_ID';
    const $a4c66eaf20e13a4d$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
    const $a4c66eaf20e13a4d$export$5a00268156ea5027 = 86400000;
});
parcelRegister("fRrvi", function(module, exports) {
    $parcel$export(module.exports, "getPriorityGroupDataByProjectId", ()=>$2d01df2d1057a1ad$export$cf2bd2ec601ed920);
    var $fn8B5 = parcelRequire("fn8B5");
    var $bFU4G;
    var $jcw0u;
    var $7f4tk;
    const $2d01df2d1057a1ad$var$fetchGroupsByKey = async (projectKey, cloudId)=>{
        return (0, (0, parcelRequire("7f4tk")).default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}`);
    };
    const $2d01df2d1057a1ad$var$fetchGroupsById = async (projectId, cloudId)=>{
        return (0, (0, parcelRequire("7f4tk")).default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectId=${projectId}`);
    };
    const $2d01df2d1057a1ad$export$cf2bd2ec601ed920 = async (projectId, projectKey, cloudId)=>{
        const fetchStartTime = performance.now();
        let data;
        if (projectId) {
            data = await $2d01df2d1057a1ad$var$fetchGroupsById(projectId, cloudId);
            (0, (0, parcelRequire("bFU4G")).addSpanToAll)('fetch', 'fetchPriorityGroupsByProjectId', [
                {
                    name: 'network'
                }
            ], fetchStartTime, performance.now());
        } else {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fetchPriorityGroupsProjectIdUndefined',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            data = await $2d01df2d1057a1ad$var$fetchGroupsByKey(projectKey, cloudId);
            (0, (0, parcelRequire("bFU4G")).addSpanToAll)('fetch', 'fetchPriorityGroups', [
                {
                    name: 'network'
                }
            ], fetchStartTime, performance.now());
        }
        const processedData = (0, ($parcel$interopDefault($fn8B5)))(data.results.map((group)=>({
                ...group,
                queues: group.queueIds || []
            })), 'category');
        return processedData;
    };
});
parcelRegister("dxxie", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("fYHqp")
    ]).then(()=>parcelRequire('lini2'));
});
parcelRegister("jyy5p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2mLKW").then(()=>parcelRequire('etJR3'));
});
parcelRegister("9mhm7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jmkWj").then(()=>parcelRequire('bmzqI'));
});
parcelRegister("iN5FK", function(module, exports) {
    $parcel$export(module.exports, "browseProjectRedirectRoute", ()=>$84aa7aa5982a6e60$export$f9cac37753487f39);
    var $65Ltd;
    const $84aa7aa5982a6e60$export$f9cac37753487f39 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
        path: "/browse/:projectKey([0-9a-zA-Z_$.+!*']+)",
        exact: true
    };
});
parcelRegister("7MCPm", function(module, exports) {
    $parcel$export(module.exports, "RedirectToLastVisitedProjectPage", ()=>$4c121c4cc7d1faa6$export$86041af020f4c959);
    var $5uXOq = parcelRequire("5uXOq");
    var $hqxtv;
    const $4c121c4cc7d1faa6$export$86041af020f4c959 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hqxtv")).default), null);
});
parcelRegister("hqxtv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bda9d95137e1a17a$export$2e2bcd8739ae039);
    var $1bQGJ;
    var $aNBa3;
    var $bda9d95137e1a17a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("1bQGJ")).withRouter)((0, (0, parcelRequire("aNBa3")).default));
});
parcelRegister("aNBa3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d9c467899b3389b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $ebyGx = parcelRequire("ebyGx");
    var $fNobW;
    var $fDtbf;
    var $kUU4G;
    var $4Pf62;
    var $dJl1T;
    var $7f4tk;
    var $ebbSc;
    const $8d9c467899b3389b$var$buildEndpoint = (projectKey, initialRedirect)=>`/rest/internal/2/projectlandingpage/${projectKey}${initialRedirect ? '?initialRedirect=true' : ''}`;
    const $8d9c467899b3389b$var$allowListedSearchParams = [
        (0, $0592ef8772eedefd$export$29d3926e3d72cfb),
        (0, $0592ef8772eedefd$export$b3233b76460c1e7c)
    ];
    const $8d9c467899b3389b$var$redirectForAnonymousUser = (projectKey, history, startTime)=>{
        const destination = `/projects/${projectKey}/issues/?filter=allissues`;
        history.replace(destination);
        (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'History replace correctly triggered for anonymous user', {
            requestTime: (0, (0, parcelRequire("ebbSc")).getNow)() - startTime,
            destination: destination
        });
    };
    const $8d9c467899b3389b$export$c79af62ad7a1fe8a = (query)=>Object.fromEntries(Object.entries(query).filter(([key])=>$8d9c467899b3389b$var$allowListedSearchParams.some((allowedParam)=>key === allowedParam) || key.includes((0, $0592ef8772eedefd$export$29d3926e3d72cfb))));
    const $8d9c467899b3389b$export$283f1587d7a5369f = (searchQuery, queryInitializer)=>{
        const queryKeys = new URLSearchParams(searchQuery).toString();
        return queryKeys.length > 0 ? `${queryInitializer}${queryKeys}` : '';
    };
    class $8d9c467899b3389b$export$bf8d1fdc3b47a835 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { history: history, location: location, query: query, match: { params: params } } = this.props;
            const { initial: initial } = query;
            (0, (0, parcelRequire("kUU4G")).default)((0, (0, parcelRequire("fDtbf")).SPA_SSR_RENDERED_MARK));
            const startTime = (0, (0, parcelRequire("ebbSc")).getNow)();
            const projectKey = params.projectKey || (0, ($parcel$interopDefault($ebyGx))).parse((0, ($parcel$interopDefault($9XE6b)))(location, 'search', {})).projectKey;
            if (!params.projectKey) (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'queryString', {
                duration: (0, (0, parcelRequire("ebbSc")).getNow)() - startTime
            });
            if (projectKey) (0, (0, parcelRequire("7f4tk")).default)($8d9c467899b3389b$var$buildEndpoint(projectKey, !!initial)).then((response)=>{
                const endTime = (0, (0, parcelRequire("ebbSc")).getNow)();
                let searchQueryParams = '';
                const searchQuery = $8d9c467899b3389b$export$c79af62ad7a1fe8a(query);
                const queryInitializer = response.data.url.includes('?') ? '&' : '?';
                searchQueryParams = $8d9c467899b3389b$export$283f1587d7a5369f(searchQuery, queryInitializer);
                const destination = response.data.url + searchQueryParams;
                history.replace(destination);
                (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'History replace correctly triggered', {
                    requestTime: endTime - startTime,
                    destination: destination
                });
            }, (error)=>{
                const endTime = (0, (0, parcelRequire("ebbSc")).getNow)();
                if ((0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)().isAnonymous) $8d9c467899b3389b$var$redirectForAnonymousUser(projectKey, history, startTime);
                else (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), `Error on request. Request time: ${endTime - startTime}`, error);
            });
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
                name: "last-visited-project-page-redirect"
            });
        }
    }
    var $8d9c467899b3389b$export$2e2bcd8739ae039 = $8d9c467899b3389b$export$bf8d1fdc3b47a835;
});
const $0592ef8772eedefd$export$25a759e49d5049db = 'spa-apps.common.redirect.last-visited-project-page';
const $0592ef8772eedefd$export$29d3926e3d72cfb = 'search';
const $0592ef8772eedefd$export$b3233b76460c1e7c = 'showProjectBuilder';
parcelRegister("ebbSc", function(module, exports) {
    $parcel$export(module.exports, "getNow", ()=>$fa5a995d36ebfbde$export$3991332aae1fc754);
    const $fa5a995d36ebfbde$export$3991332aae1fc754 = ()=>Date.now();
});
parcelRegister("cXVVY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8VawK").then(()=>parcelRequire('3PxNF'));
});
parcelRegister("izvSW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("b2COn").then(()=>parcelRequire('lktzL'));
});
parcelRegister("aVFIE", function(module, exports) {
    $parcel$export(module.exports, "ThemedLazySkeleton", ()=>$136611be2ae39444$export$ddeb5d943c4f17e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fNobW;
    var $lob44;
    const $136611be2ae39444$export$ddeb5d943c4f17e3 = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($136611be2ae39444$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "themed-spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lob44")).ThemedSpinner), null))));
    const $136611be2ae39444$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lob44", function(module, exports) {
    $parcel$export(module.exports, "ThemedSpinner", ()=>$150e941eee16207a$export$271c7b154ad6c401);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    const $150e941eee16207a$export$271c7b154ad6c401 = (0, $5uXOq.memo)((props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($150e941eee16207a$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large",
            ...props,
            testId: "project-theme-components.ui.themed-spinner"
        })));
    const $150e941eee16207a$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1xjgvy9e",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lGGIs", function(module, exports) {
    $parcel$export(module.exports, "markAsBentoBundleReady", ()=>$7671cdebcdce4d73$export$d9ff0b3329728986);
    var $fDtbf;
    var $2SVPM;
    let $7671cdebcdce4d73$var$reportedBentoBundleReady = false;
    const $7671cdebcdce4d73$export$d9ff0b3329728986 = (importedBundle)=>{
        if (!false) importedBundle.then(()=>{
            if ($7671cdebcdce4d73$var$reportedBentoBundleReady) return;
            $7671cdebcdce4d73$var$reportedBentoBundleReady = true;
            (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))) {
                (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
                break;
            }
        });
        return importedBundle;
    };
});
parcelRegister("zLcoH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("i5RRW"),
        $6fhBS("dsiAd"),
        $6fhBS("kWrFZ"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4GOBq")
    ]).then(()=>parcelRequire('kW74N'));
});
parcelRegister("jO7eF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("i5RRW"),
        $6fhBS("dsiAd"),
        $6fhBS("kWrFZ"),
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cggv6")
    ]).then(()=>parcelRequire('6qbjz'));
});
parcelRegister("4NxWn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("c6aDa").then(()=>parcelRequire('4n6tJ'));
});
parcelRegister("d8VYe", function(module, exports) {
    $parcel$export(module.exports, "workflowIssuesResource", ()=>$6a9e21653771d63a$export$49027035af709702);
    $parcel$export(module.exports, "useWorkflowIssues", ()=>$6a9e21653771d63a$export$86b7de71bf71360d);
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    var $9YrR3;
    const $6a9e21653771d63a$var$RESOURCE_TYPE_KEY = 'BUSINESS_WORKFLOW_ISSUES';
    const $6a9e21653771d63a$export$49027035af709702 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $6a9e21653771d63a$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return `${$6a9e21653771d63a$var$RESOURCE_TYPE_KEY}_${projectKey}`;
        },
        getDataLoader: ()=>Promise.resolve((parcelRequire("9YrR3"))),
        getData: (0, (0, parcelRequire("9YrR3")).default),
        maxAge: 1000,
        isBrowserOnly: true
    });
    const $6a9e21653771d63a$export$86b7de71bf71360d = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($6a9e21653771d63a$export$49027035af709702);
});
parcelRegister("9YrR3", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$465154b480a996b2$export$2e2bcd8739ae039);
    var $7juH2;
    var $x9xyg;
    var $jJZqs;
    var $8PRuf;
    var $iR3GG;
    const $465154b480a996b2$var$EMPTY_DATA = {
        workflows: [],
        lastChangedTime: null
    };
    function $465154b480a996b2$var$getEarlyPreload() {
        if (window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__) {
            const earlyPreloadPromise = window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__;
            window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__ = null;
            return earlyPreloadPromise.then((response)=>{
                if (!response.success) {
                    if (response.error.status === 304) throw new (0, (0, parcelRequire("7juH2")).Unchanged)('Workflow issues have not changed since the last request');
                    throw new (0, (0, parcelRequire("jJZqs")).default)(response.error.status);
                }
                return {
                    workflows: response.workflows,
                    lastChangedTime: null
                };
            });
        }
        return null;
    }
    function $465154b480a996b2$var$fetchData(projectKey) {
        const earlyPreload = $465154b480a996b2$var$getEarlyPreload();
        if (earlyPreload !== null) return earlyPreload;
        return (0, (0, parcelRequire("7juH2")).fetchWorkflowIssues)(projectKey);
    }
    async function $465154b480a996b2$export$2e2bcd8739ae039({ match: match }, { tenantContext: tenantContext }) {
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return $465154b480a996b2$var$EMPTY_DATA;
        try {
            (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("8PRuf")).prefetchApiStartMark));
            const workflows = await $465154b480a996b2$var$fetchData(match.params.projectKey ?? '');
            (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("8PRuf")).prefetchApiReadyMark));
            return workflows;
        } catch (error) {
            throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.business.board-workflows.getData',
                message: 'An error was thrown while prefetching board data',
                name: 'ResourceError'
            }, error);
        }
    }
});
parcelRegister("7juH2", function(module, exports) {
    $parcel$export(module.exports, "Unchanged", ()=>$16e71a1b1f979cb0$export$eccd6db33b8f6a89);
    $parcel$export(module.exports, "fetchWorkflowIssues", ()=>$16e71a1b1f979cb0$export$17e2e8212d93f58d);
    var $gKZoD;
    var $gN11a;
    var $aDvGo;
    var $jJZqs;
    class $16e71a1b1f979cb0$export$eccd6db33b8f6a89 extends Error {
    }
    const $16e71a1b1f979cb0$export$17e2e8212d93f58d = async (projectKey, ifChangedSince)=>{
        (0, (0, parcelRequire("gKZoD")).di)(fetch);
        try {
            (0, (0, parcelRequire("gN11a")).markViewMetric)('jwm-board', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
            const url = `/rest/board-api/1/board/${projectKey}/workflows?excludeLabels=true`;
            const response = await fetch(url, {
                ...(0, (0, parcelRequire("aDvGo")).default),
                headers: ifChangedSince ? {
                    'x-aif-changed-since': ifChangedSince
                } : undefined
            });
            if (!response.ok) {
                if (response.status === 304) throw new $16e71a1b1f979cb0$export$eccd6db33b8f6a89('Workflow issues have not changed since the last request');
                throw new (0, (0, parcelRequire("jJZqs")).default)(response.status);
            }
            const lastChangedTime = response.headers.get('x-alast-changed-time');
            const workflows = await response.json();
            return {
                workflows: workflows.data,
                lastChangedTime: lastChangedTime
            };
        } finally{
            (0, (0, parcelRequire("gN11a")).markViewMetric)('jwm-board', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
        }
    };
});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';
parcelRegister("gN11a", function(module, exports) {
    $parcel$export(module.exports, "pageLoadMetrics", ()=>$f9c6206c3cbbca63$export$2878bf482e539059);
    $parcel$export(module.exports, "markViewMetric", ()=>$f9c6206c3cbbca63$export$8d15b4fb25f90514);
    var $dGrdR;
    const $f9c6206c3cbbca63$var$slo = {
        fmp: {
            initial: {
                threshold: (0, $a286480ec63fa4c8$export$747aad128920134d)
            },
            transition: {
                threshold: (0, $a286480ec63fa4c8$export$747aad128920134d)
            }
        },
        tti: {
            initial: {
                threshold: (0, $a286480ec63fa4c8$export$e4f8d353742c04ac)
            },
            transition: {
                threshold: (0, $a286480ec63fa4c8$export$e4f8d353742c04ac)
            }
        }
    };
    const $f9c6206c3cbbca63$var$timings = [
        {
            key: (0, $a286480ec63fa4c8$export$540ffd289e5e0562),
            startMark: (0, $a286480ec63fa4c8$export$23e322eb7c526958),
            endMark: (0, $a286480ec63fa4c8$export$83ca21a50372ea3b)
        },
        {
            key: (0, $a286480ec63fa4c8$export$821ca6ff41f300ec),
            startMark: (0, $a286480ec63fa4c8$export$7b887ee35f2b465e),
            endMark: (0, $a286480ec63fa4c8$export$ac953882305d6102)
        },
        {
            key: (0, $a286480ec63fa4c8$export$7f7f60b5526c5ee3),
            startMark: (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4),
            endMark: (0, $a286480ec63fa4c8$export$88ea1e280513690f)
        }
    ];
    const $f9c6206c3cbbca63$export$2878bf482e539059 = {
        'approvals-view': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.approvals-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        summary: (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.summary-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'summary-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.summary-view-embed',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        list: (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.list-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'list-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.list-embed-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'software-form-submit-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jsw.form-submit-embed',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'software-list': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jsw.list-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'software-list-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jsw.list-view-embed',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        timeline: (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.timeline-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'timeline-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.timeline-embed-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        calendar: (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.calendar-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'calendar-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.calendar-embed-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        form: (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.form-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'form-submit': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.form-submit-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'form-submit-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.form-submit-embed-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'form-directory': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.form-directory-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        board: (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.board-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'jwm-board': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.jwm-board',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'jwm-board-embed': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.jwm-board-embed',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'jwm-pages': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jwm.jwm-pages',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'software-plan-calendar': (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
            key: 'jsw.plan-calendar-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        })
    };
    const $f9c6206c3cbbca63$var$startedMarks = {};
    const $f9c6206c3cbbca63$export$8d15b4fb25f90514 = (view, mark)=>{
        const markKey = `${view}-${mark}`;
        if ($f9c6206c3cbbca63$var$startedMarks[markKey]) return;
        $f9c6206c3cbbca63$var$startedMarks[markKey] = true;
        const metric = $f9c6206c3cbbca63$export$2878bf482e539059[view];
        metric?.mark(mark);
    };
});
parcelRegister("8PRuf", function(module, exports) {
    $parcel$export(module.exports, "appBundleReadyMark", ()=>$0ec5205bf4957ca4$export$7e50945a65dd40e);
    $parcel$export(module.exports, "prefetchApiReadyMark", ()=>$0ec5205bf4957ca4$export$17cbe723d23101d8);
    $parcel$export(module.exports, "prefetchApiStartMark", ()=>$0ec5205bf4957ca4$export$887fadb22e7c7735);
    $parcel$export(module.exports, "jswRenderStartMark", ()=>$0ec5205bf4957ca4$export$bd099c0a906f4b3f);
    $parcel$export(module.exports, "jswCreateReduxStoreStartMark", ()=>$0ec5205bf4957ca4$export$d23ef9e7633e30e7);
    $parcel$export(module.exports, "jswCreateReduxStoreEndMark", ()=>$0ec5205bf4957ca4$export$319da6d901948a6d);
    $parcel$export(module.exports, "jswTransformCriticalDataStartMark", ()=>$0ec5205bf4957ca4$export$f0b6622cdc5c7e4f);
    $parcel$export(module.exports, "jswTransformCriticalDataEndMark", ()=>$0ec5205bf4957ca4$export$37e82663aa1e79a8);
    $parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", ()=>$0ec5205bf4957ca4$export$21146514eacceb12);
    $parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", ()=>$0ec5205bf4957ca4$export$4eb8d44ddb14424a);
    var $hXKq5;
    const $0ec5205bf4957ca4$export$7e50945a65dd40e = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$ff834eccc35b9089));
    const $0ec5205bf4957ca4$export$17cbe723d23101d8 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$86b05e34d462ead8));
    const $0ec5205bf4957ca4$export$887fadb22e7c7735 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$d6a604a7d9a390fb));
    const $0ec5205bf4957ca4$export$bd099c0a906f4b3f = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$3ae43cc1782d058f));
    const $0ec5205bf4957ca4$export$d23ef9e7633e30e7 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$363f6703ffa600be));
    const $0ec5205bf4957ca4$export$319da6d901948a6d = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$e87b74567b79c8));
    const $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$99fe642459a8b02));
    const $0ec5205bf4957ca4$export$37e82663aa1e79a8 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$ab1f5705fc8e0571));
    const $0ec5205bf4957ca4$export$21146514eacceb12 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$8c3a9046da692c35));
    const $0ec5205bf4957ca4$export$4eb8d44ddb14424a = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$5aa497d1efdcc5bf));
});
parcelRegister("iR3GG", function(module, exports) {
    $parcel$export(module.exports, "createResourceError", ()=>$d895341acba1e817$export$13487d18466bc8a5);
    var $dJl1T;
    class $d895341acba1e817$var$ResourceErrorClass extends Error {
        constructor(message, options){
            super(message);
            this.name = options.name || 'ResourceError';
            this.skipSentry = options.skipSentry;
        }
    }
    const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, errorOverride)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(component, message, errorOverride);
        if (errorOverride) return errorOverride;
        return new $d895341acba1e817$var$ResourceErrorClass(message, {
            name: name,
            skipSentry: skipSentry
        });
    };
});
parcelRegister("bY2uJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("7VyyJ")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hFoqy")
    ]).then(()=>parcelRequire('VWhbc'));
});
parcelRegister("iXXDL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("hUhek")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fRBgo")
    ]).then(()=>parcelRequire('azXNC'));
});
parcelRegister("2HZX8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("59VHv")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4LMnP")
    ]).then(()=>parcelRequire('5VL16'));
});
parcelRegister("9JsLN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("3xlWT")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iL8G9")
    ]).then(()=>parcelRequire('ac4Ca'));
});
parcelRegister("5ydcY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5NrjM")
    ]).then(()=>parcelRequire('zU4ax'));
});
parcelRegister("hqguB", function(module, exports) {
    $parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", ()=>$abd9824736763ae8$export$73b60789ceb8e1eb);
    var $65Ltd;
    const $abd9824736763ae8$export$73b60789ceb8e1eb = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
        path: '/jira/core/projects/:projectKey',
        exact: true
    };
});
parcelRegister("kqhaB", function(module, exports) {
    $parcel$export(module.exports, "activityFeedResource", ()=>$1609d8a65ae37e85$export$928ea152e5c5de54);
    $parcel$export(module.exports, "useActivityFeed", ()=>$1609d8a65ae37e85$export$ee1fe267047f502f);
    var $4NbWL;
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    const $1609d8a65ae37e85$var$RESOURCE_TYPE_KEY = 'BUSINESS_ACTIVITY_FEED';
    const $1609d8a65ae37e85$var$EMPTY_DATA = {
        data: [],
        pageInfo: {
            hasNextPage: false,
            endCursor: ''
        }
    };
    const $1609d8a65ae37e85$export$928ea152e5c5de54 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $1609d8a65ae37e85$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return `${$1609d8a65ae37e85$var$RESOURCE_TYPE_KEY}_${projectKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { isAnonymous: isAnonymous } })=>{
            if (isAnonymous) return $1609d8a65ae37e85$var$EMPTY_DATA;
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return (0, (0, parcelRequire("4NbWL")).fetchActivityFeed)(null, projectKey);
        },
        maxAge: 5000,
        isBrowserOnly: true
    });
    const $1609d8a65ae37e85$export$ee1fe267047f502f = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($1609d8a65ae37e85$export$928ea152e5c5de54);
});
parcelRegister("4NbWL", function(module, exports) {
    $parcel$export(module.exports, "fetchActivityFeed", ()=>$72e600639fed107e$export$967c92ed76f908b6);
    var $gKZoD;
    var $jJZqs;
    var $a8I18;
    const $72e600639fed107e$var$PAGE_SIZE = 10;
    const $72e600639fed107e$var$CONTENT_TYPE = 'application/atom+xml; charset=UTF-8';
    const $72e600639fed107e$var$STREAM_PROVIDERS = 'thirdparty issues';
    const $72e600639fed107e$export$967c92ed76f908b6 = (after, projectKey)=>{
        (0, (0, parcelRequire("gKZoD")).di)(fetch);
        const firstIndex = after != null ? Number(after) : 0;
        const maxResults = firstIndex + $72e600639fed107e$var$PAGE_SIZE;
        return fetch(`/plugins/servlet/streams?${new URLSearchParams({
            maxResults: maxResults,
            relativeLinks: true,
            streams: `key IS ${projectKey}`,
            providers: $72e600639fed107e$var$STREAM_PROVIDERS
        }).toString()}`, {
            headers: {
                'content-type': $72e600639fed107e$var$CONTENT_TYPE
            }
        }).then((response)=>{
            if (!response.ok) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`);
            return response.text();
        }).then((rawResponse)=>{
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(rawResponse, 'application/xml');
            const entries = (0, (0, parcelRequire("a8I18")).transformData)(xmlDoc);
            return {
                data: entries,
                pageInfo: {
                    hasNextPage: entries.length >= maxResults,
                    endCursor: String(entries.length)
                }
            };
        });
    };
});
parcelRegister("a8I18", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$26b06333cc6e5e1f$export$3ceb62baab058c6b);
    const $26b06333cc6e5e1f$export$3ceb62baab058c6b = (xmlDoc)=>{
        const result = [];
        for (const entry of xmlDoc.querySelectorAll('entry')){
            const id = entry.querySelector('id')?.textContent ?? '';
            const published = entry.querySelector('published')?.textContent ?? '';
            const name = entry.querySelector('author > name')?.textContent ?? '';
            const title = entry.querySelector('title')?.textContent ?? '';
            const iconUrl = entry.querySelector('[rel="http://streams.atlassian.com/syndication/icon"]')?.getAttribute('href') ?? '';
            const content = entry.querySelector('content')?.textContent;
            const feedItem = {
                id: id,
                author: {
                    name: name,
                    avatarUrl: ''
                },
                published: published,
                title: title,
                iconUrl: iconUrl,
                content: content
            };
            entry.querySelectorAll('author > link[rel=photo]').forEach((link)=>{
                if (link.getAttribute('media:height') === '48') feedItem.author.avatarUrl = link.getAttribute('href') ?? '';
            });
            result.push(feedItem);
        }
        return result;
    };
});
parcelRegister("3zj3N", function(module, exports) {
    $parcel$export(module.exports, "summaryDataResource", ()=>$acdbc5801b5f9bec$export$cdfee963587c1ea4);
    $parcel$export(module.exports, "useSummaryData", ()=>$acdbc5801b5f9bec$export$c82acf736eaa253c);
    var $aR4Ot;
    var $iR3GG;
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    const $acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY = 'BUSINESS_SUMMARY_DATA';
    const $acdbc5801b5f9bec$var$EMPTY_DATA = {
        overviewItems: null,
        issuesByStatus: null,
        issuesByPriority: null,
        issuesByAssignee: null,
        issuesByType: null,
        workflowsCount: null
    };
    const $acdbc5801b5f9bec$export$cdfee963587c1ea4 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return `${$acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY}_${projectKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
            if (isAnonymous) return $acdbc5801b5f9bec$var$EMPTY_DATA;
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const jqlContext = `project = "${projectKey}"`;
            try {
                return await (0, (0, parcelRequire("aR4Ot")).fetchSummaryPageData)({
                    cloudId: cloudId,
                    jqlContext: jqlContext,
                    projectKey: projectKey
                });
            } catch (error) {
                const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
                throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                    component: 'spa.view.routes.business.summary-data.getData',
                    message: `An error was thrown while prefetching the summary data. Status code: ${error?.statusCode}. Message: ${error?.message}`,
                    name: 'ResourceError',
                    skipSentry: isClientError
                });
            }
        },
        maxAge: 5000,
        isBrowserOnly: true
    });
    const $acdbc5801b5f9bec$export$c82acf736eaa253c = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($acdbc5801b5f9bec$export$cdfee963587c1ea4);
});
parcelRegister("aR4Ot", function(module, exports) {
    $parcel$export(module.exports, "fetchSummaryPageData", ()=>$86d3799d8fb43b74$export$a3fa5b61d6f8cf86);
    var $jlq4V;
    var $6s1PB;
    var $4R6GH;
    var $eusud;
    var $6FqTo;
    var $7P4vu;
    const $86d3799d8fb43b74$var$QUERY_NAME = 'SummaryPageData';
    const $86d3799d8fb43b74$export$a3fa5b61d6f8cf86 = async ({ cloudId: cloudId, jqlContext: jqlContext, projectKey: projectKey })=>{
        const [expInlineStatusConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('business_summary_page_inline_status');
        const isExperimentSummaryPageInlineStatusEnabled = expInlineStatusConfig.get('isInlineStatusChangeEnabled', false);
        const response = await (0, (0, parcelRequire("eusud")).performPostRequest)(`/rest/gira/1/?operation=${$86d3799d8fb43b74$var$QUERY_NAME}`, {
            body: JSON.stringify({
                query: (0, (0, parcelRequire("4R6GH")).fg)('summary_page_query_priority_jql_term') ? (0, (0, parcelRequire("6FqTo")).SUMMARY_PAGE_DATA_QUERY) : (0, (0, parcelRequire("6FqTo")).SUMMARY_PAGE_DATA_QUERY_NO_PRIORITY_JQL),
                variables: {
                    cloudId: cloudId,
                    jqlContext: jqlContext,
                    projectKey: projectKey,
                    doneThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$d5aac1de7fafa2b0)}`,
                    updatedThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$b10a33c38cc20983)}`,
                    createdThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$48eb4b4c930c6378)}`,
                    dueThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$2573f5b8014b4068)}`,
                    issuesByStatusJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$8cca17e1017ba894)}`,
                    issuesByPriorityJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                    issuesByAssigneeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                    issuesByTypeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                    pagedDataPageSize: (0, $cd053842fd66588d$export$c0ecd9bd08a86184),
                    isWorkflowsCountEnabled: isExperimentSummaryPageInlineStatusEnabled
                }
            })
        });
        if (response.errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
        if (response.data == null) throw new Error('GraphQL response has no data');
        return (0, (0, parcelRequire("7P4vu")).transformData)(response.data);
    };
});
const $cd053842fd66588d$export$d5aac1de7fafa2b0 = 'statusCategory = Done AND statusCategoryChangedDate >= -1w';
const $cd053842fd66588d$export$b10a33c38cc20983 = 'updatedDate >= -1w';
const $cd053842fd66588d$export$48eb4b4c930c6378 = 'createdDate >= -1w';
const $cd053842fd66588d$export$2573f5b8014b4068 = 'statusCategory != Done AND (duedate >= 0d AND duedate < 1w)';
const $cd053842fd66588d$export$8cca17e1017ba894 = '(statusCategory != Done OR (statusCategory = Done AND statusCategoryChangedDate >= -2w))';
const $cd053842fd66588d$export$c49e48bfa75ab23c = 'statusCategory != Done';
const $cd053842fd66588d$export$c0ecd9bd08a86184 = 8;
const $cd053842fd66588d$export$27f4fb65edc908d0 = `
  fragment IssuesByAssigneeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on UserField {
          userValue {
            accountId,
            avatarUrl,
            displayName
          }
        }
      }
      id,
      totalCount
    }
  }
`;
const $cd053842fd66588d$export$5b2a5373659a0414 = `
  fragment IssuesByTypeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on IssueTypeField {
              id
              name
              iconUrl
        }
      }
      id,
      totalCount
    }
  }
`;
parcelRegister("6FqTo", function(module, exports) {
    $parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY_NO_PRIORITY_JQL", ()=>$7511339abc68f96a$export$bee4f05bf1bd2627);
    $parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY", ()=>$7511339abc68f96a$export$7ea8f81ff5bf6361);
    const $7511339abc68f96a$export$bee4f05bf1bd2627 = `
  query JiraBusinessSummaryPageData($cloudId: ID!, $jqlContext: String!, $doneThisWeekJql: String!, $updatedThisWeekJql: String!, $createdThisWeekJql: String!, $dueThisWeekJql: String!, $issuesByStatusJql: String!, $issuesByPriorityJql: String!, $issuesByAssigneeJql: String!, $issuesByTypeJql: String!, $pagedDataPageSize: Int!, $projectKey: String!, $isWorkflowsCountEnabled: Boolean!) {
    jira {
      jqlBuilder(cloudId: $cloudId) {
        status: fieldValues(
          jqlTerm: "status"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
      }
      doneThisWeek: jwmViewItems(cloudId: $cloudId, jql: $doneThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      updatedThisWeek: jwmViewItems(cloudId: $cloudId, jql: $updatedThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      createdThisWeek: jwmViewItems(cloudId: $cloudId, jql: $createdThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      dueThisWeek: jwmViewItems(cloudId: $cloudId, jql: $dueThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      totalUnresolvedIssues: jwmViewItems(cloudId: $cloudId, jql: $issuesByAssigneeJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
    }
    issuesByStatus: jwmItemGroups(jql: $issuesByStatusJql, groupByFieldId: "status", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on StatusField {
              name
							statusId
              category {
                key
              }
          }
        }
        totalCount
      }
    }
    issuesByPriority: jwmItemGroups(jql: $issuesByPriorityJql, groupByFieldId: "priority", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on PriorityField {
            iconUrl
            name
          }
        }
        totalCount
      }
    }
    issuesByAssignee: jwmItemGroups(jql: $issuesByAssigneeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
    issuesByType: jwmItemGroups(jql: $issuesByTypeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
    workflowsCount: jwmWorkflowWithIssueTypes(projectIdOrKey: $projectKey) @include(if: $isWorkflowsCountEnabled) {
      totalCount
    }
  }

  ${(0, $cd053842fd66588d$export$27f4fb65edc908d0)}
  ${(0, $cd053842fd66588d$export$5b2a5373659a0414)}
`;
    const $7511339abc68f96a$export$7ea8f81ff5bf6361 = `
  query JiraBusinessSummaryPageData($cloudId: ID!, $jqlContext: String!, $doneThisWeekJql: String!, $updatedThisWeekJql: String!, $createdThisWeekJql: String!, $dueThisWeekJql: String!, $issuesByStatusJql: String!, $issuesByPriorityJql: String!, $issuesByAssigneeJql: String!, $issuesByTypeJql: String!, $pagedDataPageSize: Int!, $projectKey: String!, $isWorkflowsCountEnabled: Boolean!) {
    jira {
      jqlBuilder(cloudId: $cloudId) {
        status: fieldValues(
          jqlTerm: "status"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
        priority: fieldValues(
          jqlTerm: "priority"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
      }
      doneThisWeek: jwmViewItems(cloudId: $cloudId, jql: $doneThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      updatedThisWeek: jwmViewItems(cloudId: $cloudId, jql: $updatedThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      createdThisWeek: jwmViewItems(cloudId: $cloudId, jql: $createdThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      dueThisWeek: jwmViewItems(cloudId: $cloudId, jql: $dueThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      totalUnresolvedIssues: jwmViewItems(cloudId: $cloudId, jql: $issuesByAssigneeJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
    }
    issuesByStatus: jwmItemGroups(jql: $issuesByStatusJql, groupByFieldId: "status", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on StatusField {
              name
							statusId
              category {
                key
              }
          }
        }
        totalCount
      }
    }
    issuesByPriority: jwmItemGroups(jql: $issuesByPriorityJql, groupByFieldId: "priority", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on PriorityField {
            iconUrl
            name
          }
        }
        totalCount
      }
    }
    issuesByAssignee: jwmItemGroups(jql: $issuesByAssigneeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
    issuesByType: jwmItemGroups(jql: $issuesByTypeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
    workflowsCount: jwmWorkflowWithIssueTypes(projectIdOrKey: $projectKey) @include(if: $isWorkflowsCountEnabled) {
      totalCount
    }
  }

  ${(0, $cd053842fd66588d$export$27f4fb65edc908d0)}
  ${(0, $cd053842fd66588d$export$5b2a5373659a0414)}
`;
});
parcelRegister("7P4vu", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$583dacb5a6b553e9$export$3ceb62baab058c6b);
    var $4R6GH;
    var $egekd;
    const $583dacb5a6b553e9$export$3ceb62baab058c6b = (data)=>{
        return {
            overviewItems: {
                doneThisWeek: data.jira.doneThisWeek?.totalCount ?? 0,
                updatedThisWeek: data.jira.updatedThisWeek?.totalCount ?? 0,
                createdThisWeek: data.jira.createdThisWeek?.totalCount ?? 0,
                dueThisWeek: data.jira.dueThisWeek?.totalCount ?? 0
            },
            issuesByStatus: data.issuesByStatus?.nodes.map((node)=>({
                    id: node.id,
                    count: node.totalCount,
                    status: {
                        name: node.field.name,
                        statusId: node.field.statusId,
                        jqlTerm: data.jira.jqlBuilder?.status.edges.find((status)=>status.node.displayName === node.field.name)?.node.jqlTerm,
                        category: {
                            key: node.field.category.key
                        }
                    }
                })) ?? null,
            issuesByPriority: data.issuesByPriority?.nodes.map((node)=>{
                const priorityJqlTerm = data.jira.jqlBuilder?.priority?.edges.find((priority)=>priority.node?.displayName === node.field.name)?.node?.jqlTerm;
                if (!priorityJqlTerm && (0, (0, parcelRequire("4R6GH")).fg)('summary_page_query_priority_jql_term')) throw new Error('jqlTerm for priority is empty');
                return {
                    id: node.id,
                    count: node.totalCount,
                    priority: {
                        name: node.field.name,
                        iconUrl: node.field.iconUrl,
                        jqlTerm: priorityJqlTerm
                    }
                };
            }) ?? null,
            issuesByAssignee: data.issuesByAssignee ? {
                ...(0, (0, parcelRequire("egekd")).transformIssuesByAssigneeData)(data.issuesByAssignee),
                totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
            } : null,
            issuesByType: data.issuesByType ? {
                ...(0, (0, parcelRequire("egekd")).transformIssuesByTypeData)(data.issuesByType),
                totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
            } : null,
            workflowsCount: data?.workflowsCount?.totalCount ?? null
        };
    };
});
parcelRegister("egekd", function(module, exports) {
    $parcel$export(module.exports, "transformIssuesByAssigneeData", ()=>$0d59c4e7b34bf6f1$export$cef1c6c4edf3287b);
    $parcel$export(module.exports, "transformIssuesByTypeData", ()=>$0d59c4e7b34bf6f1$export$bc7f7d59cba70a26);
    const $0d59c4e7b34bf6f1$export$cef1c6c4edf3287b = (data)=>({
            pageInfo: {
                hasNextPage: data.pageInfo.hasNextPage,
                endCursor: data.pageInfo.endCursor
            },
            data: data.nodes.map((node)=>({
                    id: node.id,
                    user: node.field.userValue ? {
                        avatarUrl: node.field.userValue.avatarUrl ?? '',
                        displayName: node.field.userValue.displayName,
                        accountId: node.field.userValue.accountId
                    } : null,
                    count: node.totalCount
                }))
        });
    const $0d59c4e7b34bf6f1$export$bc7f7d59cba70a26 = (data)=>({
            pageInfo: {
                hasNextPage: data.pageInfo.hasNextPage,
                endCursor: data.pageInfo.endCursor
            },
            data: data.nodes.map((node)=>({
                    id: node.id,
                    issueType: node.field ? {
                        iconUrl: node.field.iconUrl,
                        name: node.field.name,
                        id: node.field.id
                    } : null,
                    count: node.totalCount
                }))
        });
});
parcelRegister("gZLHI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("4uhfd")
    ]).then(()=>parcelRequire('kB5po'));
});
parcelRegister("hU6op", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8VzxY")
    ]).then(()=>parcelRequire('j5uWP'));
});
parcelRegister("g209c", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("kReyQ")
    ]).then(()=>parcelRequire('d2N12'));
});
parcelRegister("ikYqv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("9xAs4")
    ]).then(()=>parcelRequire('7wwNa'));
});
parcelRegister("fJgPj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("d88J6")
    ]).then(()=>parcelRequire('fm6i9'));
});
parcelRegister("l9J3G", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bvt9E")
    ]).then(()=>parcelRequire('2sFVY'));
});
parcelRegister("8y7Tc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eDxDm")
    ]).then(()=>parcelRequire('4g3zN'));
});
parcelRegister("hmqZp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cvno5")
    ]).then(()=>parcelRequire('bBWt7'));
});
parcelRegister("8Cz9F", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fb3um")
    ]).then(()=>parcelRequire('2xWnc'));
});
parcelRegister("ehclT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bZeJi")
    ]).then(()=>parcelRequire('iJtUd'));
});
parcelRegister("hDgu1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hg0ML").then(()=>parcelRequire('hLT0c'));
});
parcelRegister("4gbcC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("2rB63")
    ]).then(()=>parcelRequire('iWx9F'));
});
parcelRegister("346g2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1IlDx")
    ]).then(()=>parcelRequire('icB4w'));
});
parcelRegister("4w2X9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kkvf2")
    ]).then(()=>parcelRequire('jJF0P'));
});
parcelRegister("hd6bU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("md6xq")
    ]).then(()=>parcelRequire('g9p3T'));
});
parcelRegister("bZ8KB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("fBNW3")
    ]).then(()=>parcelRequire('425eT'));
});
parcelRegister("1VAUG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4nk9B")
    ]).then(()=>parcelRequire('fU1n9'));
});
parcelRegister("3q8eE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lY6ya")
    ]).then(()=>parcelRequire('7H3bY'));
});
parcelRegister("4itvs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("d9GTB")
    ]).then(()=>parcelRequire('hcjUE'));
});
parcelRegister("aWQgu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jA7gz").then(()=>parcelRequire('4qzdE'));
});
parcelRegister("453PM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lOtTG")
    ]).then(()=>parcelRequire('ik71Z'));
});
parcelRegister("flfyB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("fukyz")
    ]).then(()=>parcelRequire('UcTEy'));
});
parcelRegister("3lzAA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("6hewl")
    ]).then(()=>parcelRequire('6QJpB'));
});
parcelRegister("3TIie", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8IHqF")
    ]).then(()=>parcelRequire('ge8BQ'));
});
parcelRegister("5G6aX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lKmFv")
    ]).then(()=>parcelRequire('719qB'));
});
parcelRegister("aSkBG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lkM4h")
    ]).then(()=>parcelRequire('ePHET'));
});
parcelRegister("k1jrD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2SFRj")
    ]).then(()=>parcelRequire('jf3z5'));
});
parcelRegister("ixusT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dczku")
    ]).then(()=>parcelRequire('7WItf'));
});
parcelRegister("gADc2", function(module, exports) {
    $parcel$export(module.exports, "classicProjectSettingsDataClassificationsRoute", ()=>$fa8df43e7f1ddeea$export$952eefa1907e877a);
    var $65Ltd;
    const $fa8df43e7f1ddeea$export$952eefa1907e877a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS),
        path: '/plugins/servlet/project-config/:projectKey/data-classifications',
        exact: true
    };
});
parcelRegister("dYp24", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6ibtl")
    ]).then(()=>parcelRequire('9iqsx'));
});
parcelRegister("h5Sqc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6BhXI")
    ]).then(()=>parcelRequire('8SAZe'));
});
parcelRegister("lfnsv", function(module, exports) {
    $parcel$export(module.exports, "boardDetailsResource", ()=>$d78990d38f225e07$export$6c6984c55b171c5d);
    $parcel$export(module.exports, "getBoardDetailsResource", ()=>$d78990d38f225e07$export$b67eabcfc08e7c62);
    var $jcw0u;
    var $4R6GH;
    var $7f4tk;
    var $gNStA;
    var $2M1hQ;
    const $d78990d38f225e07$export$90ce361a5838e31e = async (boardId)=>{
        try {
            return await (0, (0, parcelRequire("7f4tk")).default)(`/rest/agile/1.0/board/${boardId}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getBoardDetailsRequest',
                    packageName: 'jiraRouterResourcesClassicProjects',
                    teamName: 'a4t-pandora'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $d78990d38f225e07$export$6c6984c55b171c5d = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
        getKey: (routerContext)=>routerContext.query?.config ? 'cmp-board-settings' : 'not-cmp-board-setting',
        getData: async (routerContext)=>{
            const boardId = routerContext.match.params?.boardId ?? '';
            if (routerContext.query?.config) return $d78990d38f225e07$export$90ce361a5838e31e(boardId);
            return null;
        }
    });
    const $d78990d38f225e07$export$b67eabcfc08e7c62 = ()=>(0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('simplified-boards-milestone-2_07hbk'), $d78990d38f225e07$export$6c6984c55b171c5d);
});
parcelRegister("lJ1FP", function(module, exports) {
    $parcel$export(module.exports, "editModelResource", ()=>$16cc53c7df259df5$export$ab9a4786826fd2d);
    $parcel$export(module.exports, "getEditModelResource", ()=>$16cc53c7df259df5$export$5b9bac2cc4bf4511);
    var $jcw0u;
    var $4R6GH;
    var $7f4tk;
    var $gNStA;
    var $2M1hQ;
    const $16cc53c7df259df5$export$ddbb511f9111736a = async (boardId)=>{
        try {
            return await (0, (0, parcelRequire("7f4tk")).default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getEditModelRequest',
                    packageName: 'jiraRouterResourcesClassicProjects',
                    teamName: 'a4t-pandora'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $16cc53c7df259df5$export$ab9a4786826fd2d = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
        getKey: (routerContext)=>routerContext.query?.config ? 'edit-model' : 'not-edit-model',
        getData: async (routerContext)=>{
            if (routerContext.query?.config) {
                const boardId = routerContext.match.params?.boardId ?? '';
                return $16cc53c7df259df5$export$ddbb511f9111736a(boardId);
            }
            return null;
        }
    });
    const $16cc53c7df259df5$export$5b9bac2cc4bf4511 = ()=>(0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('simplified-boards-milestone-2_07hbk') && !(0, (0, parcelRequire("4R6GH")).fg)('board-settings-graphql-refactor_cyvz9'), $16cc53c7df259df5$export$ab9a4786826fd2d);
});
parcelRegister("f5kpo", function(module, exports) {
    $parcel$export(module.exports, "shouldLoadUIFBoardResources", ()=>$e96bf35f407138bb$export$d8d4641986a9ac7f);
    $parcel$export(module.exports, "getRapidboardResources", ()=>$e96bf35f407138bb$export$3a5e56bd5231a56b);
    $parcel$export(module.exports, "getRapidBoardDataResource", ()=>$e96bf35f407138bb$export$1c63de7f548f965f);
    $parcel$export(module.exports, "getUIFBacklogDataResource", ()=>$e96bf35f407138bb$export$ee826506b3baa13a);
    var $4R6GH;
    var $5Nutl;
    var $gNStA;
    var $i6CNv;
    var $kdyVI;
    var $gQ2J4;
    var $fox5Q;
    const $e96bf35f407138bb$export$d8d4641986a9ac7f = ()=>!false;
    const $e96bf35f407138bb$export$462ca08d6ce67848 = ()=>!$e96bf35f407138bb$export$d8d4641986a9ac7f();
    const $e96bf35f407138bb$export$3a5e56bd5231a56b = ()=>[
            (0, (0, parcelRequire("fox5Q")).wrmBundleResource),
            (0, (0, parcelRequire("i6CNv")).boardConfigApiResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)($e96bf35f407138bb$export$462ca08d6ce67848, (0, (0, parcelRequire("gQ2J4")).rapidboardResource))
        ];
    const $e96bf35f407138bb$export$1c63de7f548f965f = ()=>(0, (0, parcelRequire("kdyVI")).boardDataResource);
    const $e96bf35f407138bb$export$ee826506b3baa13a = ()=>[
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && !(0, (0, parcelRequire("4R6GH")).fg)('indexeddb_cache_for_backlog'), (0, (0, parcelRequire("5Nutl")).uifBacklogResourceOld)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && (0, (0, parcelRequire("4R6GH")).fg)('indexeddb_cache_for_backlog'), (0, (0, parcelRequire("5Nutl")).uifBacklogResource))
        ];
});
parcelRegister("5Nutl", function(module, exports) {
    $parcel$export(module.exports, "uifBacklogResourceOld", ()=>$9905b3c28d313f7e$export$db83ef0443397b85);
    $parcel$export(module.exports, "uifBacklogResource", ()=>$9905b3c28d313f7e$export$c182dffb98985208);
    var $2M1hQ;
    const $9905b3c28d313f7e$export$db83ef0443397b85 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $2fdbe99f6cbea4f1$export$8f9824ba4409b537),
        getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>[
                'uif-backlog-data'
            ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
        getDataLoader: ()=>(parcelRequire("6b32i")),
        maxAge: 0
    });
    const $9905b3c28d313f7e$export$c182dffb98985208 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $2fdbe99f6cbea4f1$export$d15ce4feabd76ea),
        getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>[
                'uif-backlog-data'
            ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
        getDataLoader: ()=>(parcelRequire("6zLm4")),
        maxAge: 0
    });
});
const $2fdbe99f6cbea4f1$export$d15ce4feabd76ea = 'NEXTGEN_BACKLOG_REST';
const $2fdbe99f6cbea4f1$export$8f9824ba4409b537 = 'NEXTGEN_BACKLOG_REST_OLD';
parcelRegister("6b32i", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hgAfI").then(()=>parcelRequire('gTjY8'));
});
parcelRegister("6zLm4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8723H").then(()=>parcelRequire('cpSf8'));
});
parcelRegister("i6CNv", function(module, exports) {
    $parcel$export(module.exports, "boardConfigApiResource", ()=>$8a55ba0bef7e0e2a$export$dd9dec064acb0c4e);
    var $6s1PB;
    var $2M1hQ;
    var $1odlY;
    const $8a55ba0bef7e0e2a$var$getMaxAge = ()=>false ? 0 : (0, (0, parcelRequire("6s1PB")).expVal)('jsw-classic-board-api-calls-config-cache-time', 'value', 0) * 1000;
    const $8a55ba0bef7e0e2a$export$dd9dec064acb0c4e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG),
        getKey: ({ match: match, query: query })=>{
            const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
            return `rapidViewConfig-${boardId}`;
        },
        getDataLoader: ()=>(parcelRequire("ifUKB")),
        maxAge: $8a55ba0bef7e0e2a$var$getMaxAge(),
        isBrowserOnly: true
    });
});
parcelRegister("1odlY", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", ()=>$fa7f7a1583a8dcf1$export$88e2a0b89be042c1);
    $parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", ()=>$fa7f7a1583a8dcf1$export$ba075d0985968d1c);
    $parcel$export(module.exports, "RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS", ()=>$fa7f7a1583a8dcf1$export$395f77888d07f2e0);
    $parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", ()=>$fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07);
    $parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", ()=>$fa7f7a1583a8dcf1$export$3328c8e71fda97bb);
    $parcel$export(module.exports, "WRM_RESOURCES_ARRAY", ()=>$fa7f7a1583a8dcf1$export$ef21257df3d71188);
    $parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", ()=>$fa7f7a1583a8dcf1$export$ccd0929652c235de);
    $parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", ()=>$fa7f7a1583a8dcf1$export$1d16bdcc94a40107);
    $parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", ()=>$fa7f7a1583a8dcf1$export$1f599d2eef0a7281);
    const $fa7f7a1583a8dcf1$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
    const $fa7f7a1583a8dcf1$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
    const $fa7f7a1583a8dcf1$export$395f77888d07f2e0 = 'PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS';
    const $fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
    const $fa7f7a1583a8dcf1$export$75dfa03544a19422 = 'ROADMAP';
    const $fa7f7a1583a8dcf1$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
    const $fa7f7a1583a8dcf1$export$ef21257df3d71188 = [
        '_super',
        'wrc!greenhopper-rapid-non-gadget',
        'wrc!gh-rapid',
        'wrc!jira.global',
        'wrc!jira.general',
        'wrc!atl.global',
        'wrc!jira.webresources:header',
        'wrc!jira.webresources:calendar',
        'wrc!jira.webresources:calendar-en',
        'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
        'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
        'wrc!gh-rapid-config',
        'wrc!gh-rapid-analytics',
        'wrc!gh-rapid-charts',
        'wrc!jira.webresources:mentions-feature',
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
    ];
    const $fa7f7a1583a8dcf1$export$ccd0929652c235de = [];
    const $fa7f7a1583a8dcf1$export$1d16bdcc94a40107 = [
        'wrc!gh-rapid-lwf-board-fhd',
        'wrc!jira.webresources:skate',
        'wrc!jira.webresources:feature-flags',
        'wrc!com.atlassian.auiplugin:aui-spinner',
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!com.atlassian.analytics.analytics-client:js-events'
    ];
    const $fa7f7a1583a8dcf1$export$1f599d2eef0a7281 = [
        'wrc!gh-rapid-backlog-fhd',
        'wrc!jira.webresources:skate',
        'wrc!jira.webresources:header',
        'wrc!jira.webresources:feature-flags',
        'wrc!com.atlassian.auiplugin:aui-spinner',
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!com.atlassian.analytics.analytics-client:js-events'
    ];
});
parcelRegister("ifUKB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dz3p9").then(()=>parcelRequire('aCQV9'));
});
parcelRegister("kdyVI", function(module, exports) {
    $parcel$export(module.exports, "boardDataResource", ()=>$18aa0ee73b651f62$export$138fa635416978f7);
    var $2M1hQ;
    var $1odlY;
    var $9g2vH;
    const $18aa0ee73b651f62$export$138fa635416978f7 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
        getKey: ({ match: match, query: query, route: route })=>{
            const { name: name = '' } = route || {};
            const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
            const { config: config } = query;
            const hasConfig = Boolean(config);
            let key = 'rapidBoardData';
            if ((0, (0, parcelRequire("9g2vH")).isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
            else if ((0, (0, parcelRequire("9g2vH")).isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
            return key;
        },
        getDataLoader: ()=>(parcelRequire("bnQeN")),
        maxAge: 0,
        isBrowserOnly: true
    });
});
parcelRegister("9g2vH", function(module, exports) {
    $parcel$export(module.exports, "isBoardRoute", ()=>$ccbac8c858ea0da2$export$437d4d6e25681588);
    $parcel$export(module.exports, "isBacklogRoute", ()=>$ccbac8c858ea0da2$export$bcb853db5e3e8054);
    var $65Ltd;
    const $ccbac8c858ea0da2$export$437d4d6e25681588 = (routeName)=>routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS);
    const $ccbac8c858ea0da2$export$bcb853db5e3e8054 = (routeName)=>routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED);
});
parcelRegister("bnQeN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("75jqm").then(()=>parcelRequire('iW9CS'));
});
parcelRegister("gQ2J4", function(module, exports) {
    $parcel$export(module.exports, "rapidboardResource", ()=>$b172ecb4db4f1d22$export$d0f42a55e7c5752c);
    var $2M1hQ;
    var $1odlY;
    const $b172ecb4db4f1d22$export$d0f42a55e7c5752c = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
        getKey: ({ match: match })=>match.query.rapidView || '',
        getDataLoader: ()=>(parcelRequire("4ajRG")),
        maxAge: Number.MAX_VALUE,
        isBrowserOnly: true
    });
});
parcelRegister("4ajRG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hq4Ox").then(()=>parcelRequire('LP66E'));
});
parcelRegister("fox5Q", function(module, exports) {
    $parcel$export(module.exports, "wrmBundleResource", ()=>$bb15c3971b88e6fc$export$f199d15b7cd18df1);
    var $2M1hQ;
    var $1odlY;
    const $bb15c3971b88e6fc$export$f199d15b7cd18df1 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("8kiyc")),
        maxAge: Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
});
parcelRegister("8kiyc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3c33e").then(()=>parcelRequire('bdOyr'));
});
parcelRegister("2GkDw", function(module, exports) {
    $parcel$export(module.exports, "devOpsProviderResource", ()=>$3640b01f63c1fd17$export$19e58e21b24ae0d8);
    var $2M1hQ;
    var $2YP9W;
    const $3640b01f63c1fd17$export$19e58e21b24ae0d8 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $e9cf201ab81d4288$export$5f92e516f4b78544),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("f6n3Y")),
        maxAge: 60000
    });
    const $3640b01f63c1fd17$export$b80f5852c41a5ca8 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($3640b01f63c1fd17$export$19e58e21b24ae0d8);
});
const $e9cf201ab81d4288$export$5f92e516f4b78544 = 'SOFTWARE_DEVOPS_PROVIDERS';
const $e9cf201ab81d4288$export$d7f081d6dd0e72fc = 'bitbucket';
const $e9cf201ab81d4288$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $e9cf201ab81d4288$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';
parcelRegister("f6n3Y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7G5IV").then(()=>parcelRequire('2MQ7j'));
});
parcelRegister("hJAri", function(module, exports) {
    $parcel$export(module.exports, "classicRoadmapResource", ()=>$b200b290d50f82d3$export$e755913caca1ab8e);
    var $2M1hQ;
    const $b200b290d50f82d3$export$e755913caca1ab8e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $87d7efe6336d8b83$export$75dfa03544a19422),
        getKey: ({ match: match })=>match.params.boardId || '',
        getDataLoader: ()=>(parcelRequire("2Pkdr")),
        isBrowserOnly: true
    });
});
const $87d7efe6336d8b83$export$75dfa03544a19422 = 'ROADMAP';
const $87d7efe6336d8b83$export$e905b9170ecbb599 = 'BOARD_CONTEXT_ROADMAP_SETTINGS';
parcelRegister("2Pkdr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8MG8R").then(()=>parcelRequire('g52eJ'));
});
parcelRegister("iZ82x", function(module, exports) {
    $parcel$export(module.exports, "codePageResource", ()=>$06e9ff5230710b90$export$642ce64cf3689406);
    var $65Ltd;
    var $ao2h1;
    var $euUUL;
    var $6mT2K;
    let $06e9ff5230710b90$var$numPullRequestsToFetch = 0;
    const $06e9ff5230710b90$export$642ce64cf3689406 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $96625f88cf395132$export$94a43d2ac55ac375),
        getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId } }) {
            const isCodeRoute = name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE) || name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE_CLASSIC);
            if (!$06e9ff5230710b90$var$numPullRequestsToFetch && isCodeRoute) $06e9ff5230710b90$var$numPullRequestsToFetch = (0, (0, parcelRequire("6mT2K")).getNumPullRequestsToFetch)(query);
            if (!isCodeRoute) $06e9ff5230710b90$var$numPullRequestsToFetch = 0;
            return {
                parameters: (0, (0, parcelRequire("euUUL")).default),
                options: {
                    fetchPolicy: 'store-and-network'
                },
                variables: {
                    cloudId: cloudId,
                    projectKey: params.projectKey ?? '',
                    pullRequestsUpdatedFrom: (0, (0, parcelRequire("6mT2K")).getPullRequestsUpdatedFromDate)(),
                    numPullRequestsToFetch: $06e9ff5230710b90$var$numPullRequestsToFetch,
                    siteAri: `ari:cloud:jira::site/${cloudId}`
                }
            };
        }
    });
});
parcelRegister("euUUL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1914e75096664626$export$2e2bcd8739ae039);
    var $h8xcT;
    const $1914e75096664626$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "numPullRequestsToFetch"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pullRequestsUpdatedFrom"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "siteAri"
        }, v5 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "siteAri"
            },
            {
                "kind": "Literal",
                "name": "providerTypes",
                "value": [
                    "DEV_INFO"
                ]
            }
        ], v6 = {
            "kind": "ScalarField",
            "name": "id"
        }, v7 = {
            "kind": "ScalarField",
            "name": "name"
        }, v8 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v9 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v10 = [
            v9
        ], v11 = {
            "kind": "ScalarField",
            "name": "status"
        }, v12 = {
            "concreteType": "JiraConfigStateConnection",
            "kind": "LinkedField",
            "name": "config",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraConfigState",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "appId"
                        },
                        v11
                    ]
                }
            ]
        }, v13 = [
            v12
        ], v14 = [
            v8
        ], v15 = [
            {
                "kind": "Literal",
                "name": "appId",
                "value": "bitbucket"
            },
            v9
        ], v16 = [
            v9,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v17 = [
            {
                "kind": "Literal",
                "name": "sort",
                "value": {
                    "lastModified": {
                        "direction": "DESC",
                        "priority": 1
                    }
                }
            }
        ], v18 = [
            v12,
            v6
        ], v19 = {
            "kind": "ScalarField",
            "name": "lastUpdated"
        }, v20 = {
            "kind": "ScalarField",
            "name": "url"
        }, v21 = [
            v8,
            {
                "kind": "ScalarField",
                "name": "accountId"
            },
            v7,
            {
                "kind": "ScalarField",
                "name": "picture"
            },
            v6
        ], v22 = [
            v6
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4
                ],
                "kind": "Fragment",
                "name": "mainCodeInJiraUpdatedQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "DevOps",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v5,
                                        "concreteType": "DevOpsProviders",
                                        "kind": "LinkedField",
                                        "name": "providers",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "DevOpsDevInfoProvider",
                                                "kind": "LinkedField",
                                                "name": "devInfoProviders",
                                                "plural": true,
                                                "selections": [
                                                    v6,
                                                    v7,
                                                    v8,
                                                    {
                                                        "args": v10,
                                                        "concreteType": "JiraAppConfigState",
                                                        "kind": "LinkedField",
                                                        "name": "configState",
                                                        "plural": false,
                                                        "selections": v13
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "devOps.providers"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "devOps"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v10,
                            "concreteType": "CodeInJira",
                            "kind": "LinkedField",
                            "name": "codeInJira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "CodeInJiraUserConfiguration",
                                        "kind": "LinkedField",
                                        "name": "userConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "CodeInJiraBitbucketWorkspace",
                                                    "kind": "LinkedField",
                                                    "name": "ownedBitbucketWorkspaces",
                                                    "plural": true,
                                                    "selections": v14
                                                },
                                                "action": "THROW",
                                                "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "codeInJira.userConfiguration"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "codeInJira"
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraDevOpsQuery",
                                "kind": "LinkedField",
                                "name": "devOps",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v15,
                                        "concreteType": "JiraAppConfigState",
                                        "kind": "LinkedField",
                                        "name": "configState",
                                        "plural": false,
                                        "selections": v13
                                    }
                                ]
                            },
                            {
                                "args": v16,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v17,
                                        "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                        "kind": "LinkedField",
                                        "name": "repositories",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v14
                                            }
                                        ],
                                        "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "main_softwareCodePage_MainPage"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "main_softwareCodePage_Header"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "main_softwareCodePage_ConnectionPage"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v2,
                    v1,
                    v3,
                    v4,
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcimprovecodepageemptystaterelayprovider"
                    }
                ],
                "kind": "Operation",
                "name": "mainCodeInJiraUpdatedQuery",
                "selections": [
                    {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v5,
                                "concreteType": "DevOpsProviders",
                                "kind": "LinkedField",
                                "name": "providers",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "DevOpsDevInfoProvider",
                                        "kind": "LinkedField",
                                        "name": "devInfoProviders",
                                        "plural": true,
                                        "selections": [
                                            v6,
                                            v7,
                                            v8,
                                            {
                                                "args": v10,
                                                "concreteType": "JiraAppConfigState",
                                                "kind": "LinkedField",
                                                "name": "configState",
                                                "plural": false,
                                                "selections": v18
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "homeUrl"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "namespace"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "args": v10,
                        "concreteType": "CodeInJira",
                        "kind": "LinkedField",
                        "name": "codeInJira",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "CodeInJiraUserConfiguration",
                                "kind": "LinkedField",
                                "name": "userConfiguration",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CodeInJiraBitbucketWorkspace",
                                        "kind": "LinkedField",
                                        "name": "ownedBitbucketWorkspaces",
                                        "plural": true,
                                        "selections": [
                                            v8,
                                            {
                                                "kind": "ScalarField",
                                                "name": "uuid"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "slug"
                                            },
                                            v7
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraDevOpsQuery",
                                "kind": "LinkedField",
                                "name": "devOps",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v15,
                                        "concreteType": "JiraAppConfigState",
                                        "kind": "LinkedField",
                                        "name": "configState",
                                        "plural": false,
                                        "selections": v18
                                    }
                                ]
                            },
                            {
                                "args": v16,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v17,
                                        "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                        "kind": "LinkedField",
                                        "name": "repositories",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v8,
                                                    v6,
                                                    v19,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v6,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "providerId"
                                                                    },
                                                                    v7,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "avatarUrl"
                                                                    },
                                                                    v20
                                                                ],
                                                                "type": "DevOpsRepository"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                    },
                                    v6,
                                    {
                                        "args": [
                                            {
                                                "fields": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "updatedFrom",
                                                        "variableName": "pullRequestsUpdatedFrom"
                                                    }
                                                ],
                                                "kind": "ObjectValue",
                                                "name": "filter"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "first",
                                                "variableName": "numPullRequestsToFetch"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "sort",
                                                "value": {
                                                    "lastUpdatedSortDirection": "DESC"
                                                }
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "type",
                                                "value": "project-associated-pr"
                                            }
                                        ],
                                        "concreteType": "AriGraphRelationshipConnection",
                                        "kind": "LinkedField",
                                        "name": "devOpsEntityRelationships",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "AriGraphRelationshipEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "AriGraphRelationship",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AriGraphRelationshipNode",
                                                                "kind": "LinkedField",
                                                                "name": "to",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "data",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v8,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v11,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "repositoryName"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "repositoryId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "author",
                                                                                        "plural": false,
                                                                                        "selections": v21
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "DevOpsReviewer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "reviewers",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "user",
                                                                                                "plural": false,
                                                                                                "selections": v21
                                                                                            },
                                                                                            v8,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "approvalStatus"
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "userId"
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "title"
                                                                                    },
                                                                                    v6,
                                                                                    v19,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "commentCount"
                                                                                    },
                                                                                    v20,
                                                                                    {
                                                                                        "concreteType": "DevOpsBranchInfo",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "destinationBranch",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v7,
                                                                                            v20
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "pullRequestInternalId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "repositoryUrl"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "authorId"
                                                                                    }
                                                                                ],
                                                                                "type": "DevOpsPullRequestDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "Node",
                                                                                "abstractKey": "__isNode"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "ConfluencePage"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "ConfluenceSpace"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsFeatureFlag"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsOperationsComponentDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsOperationsIncidentDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsRepository"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsSecurityVulnerabilityDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "JiraConfluenceRemoteIssueLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "JiraCustomRemoteIssueLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "JiraIssueRemoteIssueLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "JiraWebRemoteIssueLink"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v6
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "133ff17ae88c722ba1d91f8fc407b9e8f0d1a640a4c93ec27cfe43dd6ef0142b",
                "metadata": {},
                "name": "mainCodeInJiraUpdatedQuery",
                "operationKind": "query",
                "text": null,
                "providedVariables": {
                    "__relay_internal__pv__atlassianjirarelayprovidersrcimprovecodepageemptystaterelayprovider": (0, (0, parcelRequire("h8xcT")).default)
                }
            }
        };
    }();
    $1914e75096664626$var$node.hash = "02f9224d53652182a109e4936760d09f";
    var $1914e75096664626$export$2e2bcd8739ae039 = $1914e75096664626$var$node;
});
parcelRegister("h8xcT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f9ec23850e5424c$export$2e2bcd8739ae039);
    var $6s1PB;
    var $7f9ec23850e5424c$export$2e2bcd8739ae039 = {
        get () {
            const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_improve_scm_onboarding');
            return expConfig.get('isEnabled', false);
        }
    };
});
parcelRegister("6mT2K", function(module, exports) {
    $parcel$export(module.exports, "isBitbucketProvider", ()=>$e46b745b21c77b2f$export$1f508885be28c4e);
    $parcel$export(module.exports, "codeErrorBoundaryAttributes", ()=>$e46b745b21c77b2f$export$ea10bb8bdf2072e5);
    $parcel$export(module.exports, "toSanitizedUrl", ()=>$e46b745b21c77b2f$export$36fdccbdcd093523);
    $parcel$export(module.exports, "useIsOverflowWidth", ()=>$e46b745b21c77b2f$export$2dcd60313c8d761b);
    $parcel$export(module.exports, "getPullRequestsUpdatedFromDate", ()=>$e46b745b21c77b2f$export$3784bdf6b4807521);
    $parcel$export(module.exports, "getNumPullRequestsToFetch", ()=>$e46b745b21c77b2f$export$a837c7c9c7670570);
    var $5uXOq = parcelRequire("5uXOq");
    var $5kchp = parcelRequire("5kchp");
    var $it1wb;
    var $gn1v9;
    var $eY2eW;
    var $1tSBh;
    const $e46b745b21c77b2f$export$36ebc9cd52c6b517 = (repository)=>repository === (0, (0, parcelRequire("1tSBh")).RepositoryTypes).REPO_BITBUCKET;
    const $e46b745b21c77b2f$export$1f508885be28c4e = (providerId)=>providerId === (0, (0, parcelRequire("eY2eW")).VcsProviderIds).BITBUCKET || providerId === (0, (0, parcelRequire("eY2eW")).DataDepotProviderIds).BITBUCKET_PROD || providerId === (0, (0, parcelRequire("eY2eW")).DataDepotProviderIds).BITBUCKET_STG;
    const $e46b745b21c77b2f$var$shouldCountToReliability = (error)=>{
        const okayErrors = [
            ...(0, (0, parcelRequire("eY2eW")).nonCriticalGqlErrors),
            ...(0, (0, parcelRequire("eY2eW")).nonReliabilityCriticalErrors)
        ];
        return !okayErrors.includes(error.message);
    };
    const $e46b745b21c77b2f$export$ea10bb8bdf2072e5 = (error)=>{
        if (error instanceof Error) return {
            countToReliability: $e46b745b21c77b2f$var$shouldCountToReliability(error)
        };
        return {
            countToReliability: true
        };
    };
    const $e46b745b21c77b2f$export$36fdccbdcd093523 = (url)=>(0, $5kchp.sanitizeUrl)(url);
    const $e46b745b21c77b2f$export$2dcd60313c8d761b = (ref, callback)=>{
        const [isOverflow, setIsOverflow] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const { current: current } = ref;
            const trigger = ()=>{
                const hasOverflow = current.scrollWidth > current.clientWidth;
                setIsOverflow(hasOverflow);
                if (callback) callback(hasOverflow);
            };
            if (current) {
                if ('ResizeObserver' in window) new ResizeObserver(trigger).observe(current);
                trigger();
            }
        }, [
            callback,
            ref
        ]);
        return isOverflow;
    };
    const $e46b745b21c77b2f$export$3784bdf6b4807521 = ()=>(0, (0, parcelRequire("it1wb")).default)((0, (0, parcelRequire("gn1v9")).default)(new Date(), {
            days: (0, (0, parcelRequire("eY2eW")).PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS)
        })).toISOString();
    const $e46b745b21c77b2f$export$a837c7c9c7670570 = (queryParams)=>{
        const hasFilterOrSortQueryParam = Object.entries(queryParams).some(([key, value])=>(0, (0, parcelRequire("eY2eW")).queryParamsToWatch).includes(key) && value !== '');
        return hasFilterOrSortQueryParam ? (0, (0, parcelRequire("eY2eW")).MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY) : (0, (0, parcelRequire("eY2eW")).PULL_REQUESTS_TABLE_PAGE_SIZE);
    };
});
parcelRegister("5kchp", function(module, exports) {
    'use strict';
    var $3e0858899f98084b$var$invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
    var $3e0858899f98084b$var$ctrlCharactersRegex = /[^\x20-\x7E]/gmi;
    var $3e0858899f98084b$var$urlSchemeRegex = /^([^:]+):/gm;
    var $3e0858899f98084b$var$relativeFirstCharacters = [
        '.',
        '/'
    ];
    function $3e0858899f98084b$var$isRelativeUrl(url) {
        return $3e0858899f98084b$var$relativeFirstCharacters.indexOf(url[0]) > -1;
    }
    function $3e0858899f98084b$var$sanitizeUrl(url) {
        if (!url) return 'about:blank';
        var urlScheme, urlSchemeParseResults;
        var sanitizedUrl = url.replace($3e0858899f98084b$var$ctrlCharactersRegex, '');
        if ($3e0858899f98084b$var$isRelativeUrl(sanitizedUrl)) return sanitizedUrl;
        urlSchemeParseResults = sanitizedUrl.match($3e0858899f98084b$var$urlSchemeRegex);
        if (!urlSchemeParseResults) return 'about:blank';
        urlScheme = urlSchemeParseResults[0];
        if ($3e0858899f98084b$var$invalidPrototcolRegex.test(urlScheme)) return 'about:blank';
        return sanitizedUrl;
    }
    module.exports = {
        sanitizeUrl: $3e0858899f98084b$var$sanitizeUrl
    };
});
parcelRegister("eY2eW", function(module, exports) {
    $parcel$export(module.exports, "nonCriticalGqlErrors", ()=>$a2f3556545768e94$export$4b1abe4db5ed7515);
    $parcel$export(module.exports, "nonReliabilityCriticalErrors", ()=>$a2f3556545768e94$export$687544614e0812da);
    $parcel$export(module.exports, "cardBoxShadow", ()=>$a2f3556545768e94$export$7527a73da794030d);
    $parcel$export(module.exports, "cardBoxHoverShadow", ()=>$a2f3556545768e94$export$2ecfdc24b216c295);
    $parcel$export(module.exports, "MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY", ()=>$a2f3556545768e94$export$f84c6b6609a3dd30);
    $parcel$export(module.exports, "PULL_REQUESTS_TABLE_PAGE_SIZE", ()=>$a2f3556545768e94$export$ea15b38f3901f518);
    $parcel$export(module.exports, "PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS", ()=>$a2f3556545768e94$export$2b8b0a4489f9147b);
    $parcel$export(module.exports, "COLLAPSIBLE_REGION_ID", ()=>$a2f3556545768e94$export$3b8f88133d28aaa6);
    $parcel$export(module.exports, "REPOSITORIES_HEADER_ID", ()=>$a2f3556545768e94$export$256a9f141103f328);
    $parcel$export(module.exports, "COLLAPSIBLE_REGION_DESCRIPTION_ID", ()=>$a2f3556545768e94$export$b0d4e90e40369b80);
    $parcel$export(module.exports, "featureIdToHelpMap", ()=>$a2f3556545768e94$export$1de4eaccc23a8747);
    $parcel$export(module.exports, "FILTER_CONTAINER_TEST_ID", ()=>$a2f3556545768e94$export$5c00a6bedc2037c8);
    $parcel$export(module.exports, "NO_RESULTS_CLEAR_FILTERS_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$f70ce14ba902adcb);
    $parcel$export(module.exports, "PULL_REQUESTS_TABLE_TEST_ID", ()=>$a2f3556545768e94$export$19381ed4387aa05b);
    $parcel$export(module.exports, "PULL_REQUESTS_DYNAMIC_TABLE_TEST_ID", ()=>$a2f3556545768e94$export$f3e116f999d4c5c1);
    $parcel$export(module.exports, "PULL_REQUESTS_EMPTY_STATE_TEST_ID", ()=>$a2f3556545768e94$export$c28f1cd40ae0394c);
    $parcel$export(module.exports, "SUMMARY_CELL_TEST_ID", ()=>$a2f3556545768e94$export$f69d7aa9c5e17d55);
    $parcel$export(module.exports, "SUMMARY_CELL_TITLE_LINK_TEST_ID", ()=>$a2f3556545768e94$export$4ed9a8a7faf641f);
    $parcel$export(module.exports, "SUMMARY_CELL_TARGET_BRANCH_LINK_TEST_ID", ()=>$a2f3556545768e94$export$c5322e755fd1028d);
    $parcel$export(module.exports, "SUMMARY_CELL_REPOSITORY_LINK_TEST_ID", ()=>$a2f3556545768e94$export$72fcd104fde041d6);
    $parcel$export(module.exports, "REVIEWERS_CELL_TEST_ID", ()=>$a2f3556545768e94$export$d8f600a480a9c2d4);
    $parcel$export(module.exports, "STATUS_CELL_TEST_ID", ()=>$a2f3556545768e94$export$9d9ab707c4e446cc);
    $parcel$export(module.exports, "COMMENTS_CELL_TEST_ID", ()=>$a2f3556545768e94$export$4da3056fdbfaf111);
    $parcel$export(module.exports, "LAST_UPDATED_CELL_TEST_ID", ()=>$a2f3556545768e94$export$e1134688b6a1032);
    $parcel$export(module.exports, "PULL_REQUESTS_ERROR_STATE_TEST_ID", ()=>$a2f3556545768e94$export$143249aa50321d51);
    $parcel$export(module.exports, "REPOSITORIES_ERROR_STATE_TEST_ID", ()=>$a2f3556545768e94$export$a46febdd3fe90de0);
    $parcel$export(module.exports, "IMPROVED_SCM_CONFIG_SCREEN_ERROR_TEST_ID", ()=>$a2f3556545768e94$export$333db4cac7ee017);
    $parcel$export(module.exports, "IMPROVE_READY_TO_CONNECT_EMPTY_STATE_TEST_ID", ()=>$a2f3556545768e94$export$5cbae081959768bd);
    $parcel$export(module.exports, "REPOSITORIES_FILTER_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$4939c117ba49bc9e);
    $parcel$export(module.exports, "AUTHOR_FILTER_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$5a92d7579dac6294);
    $parcel$export(module.exports, "REVIEWERS_FILTER_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$a77ea162c15f0290);
    $parcel$export(module.exports, "STATUS_FILTER_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$b7477204cae64b46);
    $parcel$export(module.exports, "QUERY_PARAM_SUMMARY", ()=>$a2f3556545768e94$export$39983b6fb040a5eb);
    $parcel$export(module.exports, "QUERY_PARAM_AUTHORS", ()=>$a2f3556545768e94$export$3d96f5f9ccd35be6);
    $parcel$export(module.exports, "QUERY_PARAM_REVIEWERS", ()=>$a2f3556545768e94$export$8a8927c29ab32b10);
    $parcel$export(module.exports, "QUERY_PARAM_STATUS", ()=>$a2f3556545768e94$export$3e8168848b996f7);
    $parcel$export(module.exports, "QUERY_PARAM_REPOSITORIES", ()=>$a2f3556545768e94$export$4adc519ba40b72a6);
    $parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", ()=>$a2f3556545768e94$export$6da773286c35ef41);
    $parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", ()=>$a2f3556545768e94$export$810a1f7ed2facfcb);
    $parcel$export(module.exports, "queryParamsToWatch", ()=>$a2f3556545768e94$export$ba75fb5089c0eb0b);
    $parcel$export(module.exports, "VcsProviderIds", ()=>$a2f3556545768e94$export$7d5c3d28df5f438a);
    $parcel$export(module.exports, "DataDepotProviderIds", ()=>$a2f3556545768e94$export$7912a169c18abe9d);
    $parcel$export(module.exports, "FEEDBACK_COLLECTOR_LOCATION", ()=>$a2f3556545768e94$export$74189cec821240a6);
    $parcel$export(module.exports, "eligibleForConfigurationScreenStatuses", ()=>$a2f3556545768e94$export$3f3fc252f5066c72);
    $parcel$export(module.exports, "notEligibleForConfigurationScreenStatuses", ()=>$a2f3556545768e94$export$9ce5b1bba5f17875);
    const $a2f3556545768e94$export$4b1abe4db5ed7515 = [
        'HTTP status [403] while retrieving Bitbucket repository.',
        'HTTP status [404] while retrieving Bitbucket repository.',
        "Failed to retrieve Bitbucket repository because the user wasn't authorized."
    ];
    const $a2f3556545768e94$export$687544614e0812da = [
        'HTTP status [429] while retrieving Bitbucket repository.',
        "The user does not have 'View Development Tools' permission for the Jira project or the project does not exist",
        'The user does not have admin permission for the site, Jira, project or the project does not exist.',
        'Unable to get providers when contacting Jira due to 401 Unauthorized'
    ];
    const $a2f3556545768e94$export$7527a73da794030d = "var(--ds-shadow-overflow, 0 1px 1px rgb(9 30 66 / 25%), 0 0 1px 1px rgb(9 30 66 / 13%))";
    const $a2f3556545768e94$export$2ecfdc24b216c295 = "var(--ds-shadow-overflow, rgba(9, 30, 66, 0.31) 0px 0px 1px 0px, rgba(9, 30, 66, 0.25) 0px 8px 16px -6px)";
    const $a2f3556545768e94$export$f84c6b6609a3dd30 = 1000;
    const $a2f3556545768e94$export$ea15b38f3901f518 = 12;
    const $a2f3556545768e94$export$2b8b0a4489f9147b = 30;
    const $a2f3556545768e94$export$3b8f88133d28aaa6 = 'collapsible-repository-list';
    const $a2f3556545768e94$export$256a9f141103f328 = 'repository-list-header';
    const $a2f3556545768e94$export$b0d4e90e40369b80 = 'repository-list-description';
    const $a2f3556545768e94$export$1de4eaccc23a8747 = {
        'repository-list.pull-requests.empty-state': {
            helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
            href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
        },
        'repository-list.pull-requests.description': {
            helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
            href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
        }
    };
    const $a2f3556545768e94$export$5c00a6bedc2037c8 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.filter-container';
    const $a2f3556545768e94$export$f70ce14ba902adcb = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.no-results.clearfiltersbutton';
    const $a2f3556545768e94$export$19381ed4387aa05b = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table';
    const $a2f3556545768e94$export$f3e116f999d4c5c1 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table.dynamic-table';
    const $a2f3556545768e94$export$c28f1cd40ae0394c = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-empty-state';
    const $a2f3556545768e94$export$f69d7aa9c5e17d55 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.summary-cell';
    const $a2f3556545768e94$export$4ed9a8a7faf641f = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.title-link`;
    const $a2f3556545768e94$export$c5322e755fd1028d = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.target-branch-link`;
    const $a2f3556545768e94$export$72fcd104fde041d6 = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.repository-link`;
    const $a2f3556545768e94$export$d8f600a480a9c2d4 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.reviewers-cell';
    const $a2f3556545768e94$export$9d9ab707c4e446cc = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.status-cell';
    const $a2f3556545768e94$export$4da3056fdbfaf111 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.comments-cell';
    const $a2f3556545768e94$export$e1134688b6a1032 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.last-updated-cell';
    const $a2f3556545768e94$export$143249aa50321d51 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-error-state';
    const $a2f3556545768e94$export$a46febdd3fe90de0 = 'software-code-page.ui.pages.main-page.repositories.repository-error-state';
    const $a2f3556545768e94$export$333db4cac7ee017 = 'software-code-page.ui.pages.improved-configure-step-error-state';
    const $a2f3556545768e94$export$5cbae081959768bd = 'software-code-page.ui.pages.ready-to-connect-empty-state-error-state';
    const $a2f3556545768e94$export$4939c117ba49bc9e = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.repository-filter.filter-button';
    const $a2f3556545768e94$export$5a92d7579dac6294 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.author-filter.filter-button';
    const $a2f3556545768e94$export$a77ea162c15f0290 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.reviewers-filter.filter-button';
    const $a2f3556545768e94$export$b7477204cae64b46 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.status-filter.filter-button';
    const $a2f3556545768e94$export$39983b6fb040a5eb = 'summaryFilter';
    const $a2f3556545768e94$export$3d96f5f9ccd35be6 = 'authorsFilter';
    const $a2f3556545768e94$export$8a8927c29ab32b10 = 'reviewersFilter';
    const $a2f3556545768e94$export$3e8168848b996f7 = 'statusFilter';
    const $a2f3556545768e94$export$4adc519ba40b72a6 = 'repositoriesFilter';
    const $a2f3556545768e94$export$6da773286c35ef41 = 'sortKey';
    const $a2f3556545768e94$export$810a1f7ed2facfcb = 'sortOrder';
    const $a2f3556545768e94$export$ba75fb5089c0eb0b = [
        $a2f3556545768e94$export$39983b6fb040a5eb,
        $a2f3556545768e94$export$3d96f5f9ccd35be6,
        $a2f3556545768e94$export$8a8927c29ab32b10,
        $a2f3556545768e94$export$3e8168848b996f7,
        $a2f3556545768e94$export$4adc519ba40b72a6,
        $a2f3556545768e94$export$6da773286c35ef41,
        $a2f3556545768e94$export$810a1f7ed2facfcb
    ];
    const $a2f3556545768e94$export$7d5c3d28df5f438a = {
        BITBUCKET: 'bitbucket'
    };
    const $a2f3556545768e94$export$7912a169c18abe9d = {
        BITBUCKET_PROD: 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9',
        BITBUCKET_STG: 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N',
        GITHUB_PROD: 'com.github.integration.production',
        GITHUB_STG: 'com.github.integration.staging'
    };
    const $a2f3556545768e94$export$74189cec821240a6 = 'jsw.code.page.header';
    const $a2f3556545768e94$export$3f3fc252f5066c72 = [
        'NOT_CONFIGURED',
        'NOT_SET',
        'PARTIALLY_CONFIGURED'
    ];
    const $a2f3556545768e94$export$9ce5b1bba5f17875 = [
        'CONFIGURED',
        'PROVIDER_ACTION_CONFIGURED',
        'PROVIDER_ACTION_NOT_CONFIGURED'
    ];
});
parcelRegister("1tSBh", function(module, exports) {
    $parcel$export(module.exports, "numberToTimestamp", ()=>$dbe340acf3f0dbdc$export$9a7be8324d19a048);
    $parcel$export(module.exports, "toProjectAri", ()=>$dbe340acf3f0dbdc$export$9429718a5f74f761);
    $parcel$export(module.exports, "RepositoryTypes", ()=>$dbe340acf3f0dbdc$export$b5ab924fb433d9ea);
    const $dbe340acf3f0dbdc$export$9a7be8324d19a048 = (time)=>{
        if (time < 0) throw new Error(`Trying to case invalid number(${time}) to Timestamp opaque type`);
        return time;
    };
    const $dbe340acf3f0dbdc$export$9429718a5f74f761 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
    const $dbe340acf3f0dbdc$export$b5ab924fb433d9ea = {
        REPO_BITBUCKET: 'REPO_BITBUCKET',
        REPO_GITHUB: 'REPO_GITHUB',
        REPO_GITLAB: 'REPO_GITLAB'
    };
    const $dbe340acf3f0dbdc$export$60dabe06d83cf844 = {
        CLASSIC: 'classic',
        OAUTH: 'oauth',
        BITBUCKET: 'bitbucket'
    };
});
const $96625f88cf395132$export$94a43d2ac55ac375 = 'SOFTWARE_CODE';
parcelRegister("evtTp", function(module, exports) {
    $parcel$export(module.exports, "rapidboardBacklogEmbedRoute", ()=>$5bc9e87087d9dc80$export$8c354886c7c664ea);
    var $65Ltd;
    const $5bc9e87087d9dc80$export$8c354886c7c664ea = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog/embed'
    };
});
parcelRegister("9LHPC", function(module, exports) {
    $parcel$export(module.exports, "IncidentsPageSkeleton", ()=>$cc84120449e592c1$export$3105d59d9ca899bd);
    $parcel$export(module.exports, "IncidentsTableSkeleton", ()=>$cc84120449e592c1$export$7092b8ea63ebf9be);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $c1yjJ = parcelRequire("c1yjJ");
    var $80wl3 = parcelRequire("80wl3");
    const $cc84120449e592c1$var$incidentsPageSkeletonStyles = null;
    const $cc84120449e592c1$var$incidentsTableSkeletonStyles = null;
    const $cc84120449e592c1$export$3105d59d9ca899bd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-page",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1x27 _4t3i1osq _ca0q1ejb _19bv1jfw _u5f31jfw _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($c1yjJ)))
        }));
    const $cc84120449e592c1$export$7092b8ea63ebf9be = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-table",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($80wl3)))
        }));
});
parcelRegister("c1yjJ", function(module, exports) {
    module.exports = new URL("incidents-page-app-skeleton.tpl.5b656159.svg", import.meta.url).toString();
});
parcelRegister("80wl3", function(module, exports) {
    module.exports = new URL("incidents-page-table-skeleton.tpl.e8f337f1.svg", import.meta.url).toString();
});
parcelRegister("f0J9E", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cRbOs")
    ]).then(()=>parcelRequire('cwNeR'));
});
parcelRegister("10MlP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9C5Ze").then(()=>parcelRequire('8c2Ir'));
});
parcelRegister("ipmBb", function(module, exports) {
    $parcel$export(module.exports, "nextBestTaskFeatureResource", ()=>$b97b42683de1c9b3$export$5d472f7d515300ca);
    var $jcw0u;
    var $eusud;
    var $2M1hQ;
    const $b97b42683de1c9b3$export$5d472f7d515300ca = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $167b031bfd6a6b6e$export$6f0555de4f60e84e),
        getKey: ()=>(0, $167b031bfd6a6b6e$export$7e7d7930e22ba39f),
        getData: async ()=>{
            try {
                return await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/mypreferences?key=${(0, $167b031bfd6a6b6e$export$b94951a11282ae6a)}`);
            } catch (error) {
                const initialValueNeverSet = error.statusCode === 404;
                if (initialValueNeverSet) return {
                    hasUserOptedIn: true
                };
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $167b031bfd6a6b6e$export$7f111648ca05f056),
                        packageName: (0, $167b031bfd6a6b6e$export$b8b9d90f9e5bd72b)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                hasUserOptedIn: false
            };
        },
        maxAge: Number.MAX_VALUE
    });
});
const $167b031bfd6a6b6e$export$6f0555de4f60e84e = 'RESOURCE_TYPE_NEXT_BEST_TASK_FEATURE';
const $167b031bfd6a6b6e$export$7e7d7930e22ba39f = 'nbt-opt-in-resource-key';
const $167b031bfd6a6b6e$export$b94951a11282ae6a = 'next-best-task-feature';
const $167b031bfd6a6b6e$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesNextBestTask';
const $167b031bfd6a6b6e$export$7f111648ca05f056 = 'useResource.fetchNextBestTaskOptInPreference';
parcelRegister("f7Y15", function(module, exports) {
    $parcel$export(module.exports, "uifBoardResource", ()=>$6f8724e78df4e830$export$b65bcbbccad354ac);
    var $2M1hQ;
    const $6f8724e78df4e830$export$b65bcbbccad354ac = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $16d4c226f5e6f5f8$export$cfae566ecf2855f8),
        getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
            if (config) return `uif-board::${routeName}::config`;
            if (boardId == null) return `uif-board::${routeName}::not-found`;
            return `uif-board::${routeName}::${boardId}`;
        },
        getDataLoader: ()=>(parcelRequire("8SSc2")),
        maxAge: 0
    });
});
const $16d4c226f5e6f5f8$export$cfae566ecf2855f8 = 'UIF_BOARD';
parcelRegister("8SSc2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bLcEa").then(()=>parcelRequire('1HjYz'));
});
parcelRegister("fEr2a", function(module, exports) {
    $parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", ()=>$4d20da2caca0ff94$export$122afcef7dfd252);
    var $65Ltd;
    const $4d20da2caca0ff94$export$122afcef7dfd252 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed'
    };
});
parcelRegister("lB6pS", function(module, exports) {
    $parcel$export(module.exports, "classicSoftwareBoardRoute", ()=>$9dbec22457c8ec85$export$131d51ca54849e97);
    var $65Ltd;
    const $9dbec22457c8ec85$export$131d51ca54849e97 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId'
    };
});
parcelRegister("8N7Nn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("427Sh")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3dc2I")
    ]).then(()=>parcelRequire('dnhKp'));
});
parcelRegister("3ucvC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1QTgA")
    ]).then(()=>parcelRequire('1Xeln'));
});
parcelRegister("dpJFJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fO0AD")
    ]).then(()=>parcelRequire('iYOPQ'));
});
parcelRegister("hpfxj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5OUMf").then(()=>parcelRequire('Gk4RP'));
});
parcelRegister("eFW1U", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bcehj").then(()=>parcelRequire('73mZu'));
});
parcelRegister("g87MG", function(module, exports) {
    $parcel$export(module.exports, "issueHierarchyPageResource", ()=>$6f06dee5876402c3$export$98d50a2e19509817);
    var $ao2h1;
    var $7a4aR;
    const $6f06dee5876402c3$export$98d50a2e19509817 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'RESOURCE1',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("7a4aR")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                }
            })
    });
});
parcelRegister("7a4aR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ea8bf05e90a48f8$export$2e2bcd8739ae039);
    const $0ea8bf05e90a48f8$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "name"
        }, v3 = {
            "kind": "ScalarField",
            "name": "level"
        }, v4 = [
            {
                "concreteType": "JiraIssueTypeHierarchyLevel",
                "kind": "LinkedField",
                "name": "hierarchyLevel",
                "plural": false,
                "selections": [
                    v2,
                    v3
                ]
            },
            {
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "cmpIssueTypes",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "issueTypeId"
                                    },
                                    v2,
                                    {
                                        "kind": "ScalarField",
                                        "name": "description"
                                    },
                                    {
                                        "concreteType": "JiraIssueTypeHierarchyLevel",
                                        "kind": "LinkedField",
                                        "name": "hierarchy",
                                        "plural": false,
                                        "selections": [
                                            v3
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "small"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ], v5 = {
            "concreteType": "JiraHierarchyConfigError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "code"
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }, v6 = {
            "args": v1,
            "concreteType": "JiraIssueHierarchyConfigurationQuery",
            "kind": "LinkedField",
            "name": "issueHierarchyConfig",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueHierarchyConfigData",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": v4
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                v5
            ]
        }, v7 = {
            "args": v1,
            "concreteType": "JiraIssueHierarchyLimits",
            "kind": "LinkedField",
            "name": "issueHierarchyLimits",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "maxLevels"
                },
                {
                    "kind": "ScalarField",
                    "name": "nameLength"
                }
            ]
        }, v8 = {
            "args": v1,
            "kind": "ScalarField",
            "name": "lockedIssueTypeIds"
        }, v9 = {
            "concreteType": "JiraIssueHierarchyConfigData",
            "kind": "LinkedField",
            "name": "issueHierarchyConfig",
            "plural": true,
            "selections": v4
        }, v10 = {
            "concreteType": "JiraLongRunningTaskProgress",
            "kind": "LinkedField",
            "name": "taskProgress",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "kind": "ScalarField",
                    "name": "progress"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "mainIssueHierarchyQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v6,
                            v7,
                            v8,
                            {
                                "args": v1,
                                "concreteType": "JiraHierarchyConfigTask",
                                "kind": "LinkedField",
                                "name": "issueHierarchyConfigUpdateTask",
                                "plural": false,
                                "selections": [
                                    v9,
                                    v10,
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "saveButton_adminPagesIssueHierarchyDirectory"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "saveDialog_adminPagesIssueHierarchyDirectory"
                                    },
                                    v5
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "mainIssueHierarchyQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v6,
                            v7,
                            v8,
                            {
                                "args": v1,
                                "concreteType": "JiraHierarchyConfigTask",
                                "kind": "LinkedField",
                                "name": "issueHierarchyConfigUpdateTask",
                                "plural": false,
                                "selections": [
                                    v9,
                                    v10,
                                    v5
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b",
                "metadata": {},
                "name": "mainIssueHierarchyQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $0ea8bf05e90a48f8$var$node.hash = "e780e64aedcd2278004df68a042f1343";
    var $0ea8bf05e90a48f8$export$2e2bcd8739ae039 = $0ea8bf05e90a48f8$var$node;
});
parcelRegister("i8JTM", function(module, exports) {
    $parcel$export(module.exports, "NextGenBacklogSkeleton", ()=>$de21fa38a510bb6d$export$33cd465913cf178f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7XYc4;
    var $dCm1o;
    var $hCy6k;
    var $bOdHA = parcelRequire("bOdHA");
    const $de21fa38a510bb6d$export$433c2e8574f2e911 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($bOdHA)))
        });
    const $de21fa38a510bb6d$export$88189b56881f213e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($de21fa38a510bb6d$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($bOdHA)))
        }));
    const $de21fa38a510bb6d$export$33cd465913cf178f = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $de21fa38a510bb6d$export$88189b56881f213e, $de21fa38a510bb6d$export$433c2e8574f2e911);
    const $de21fa38a510bb6d$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dCm1o", function(module, exports) {
    $parcel$export(module.exports, "isVisualRefreshEnabled", ()=>$322f7f27e3ad3058$export$48345cb467db19b6);
    var $6s1PB;
    var $4R6GH;
    var $1MhR0;
    const $322f7f27e3ad3058$export$48345cb467db19b6 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh') && ($322f7f27e3ad3058$var$isVisualRefreshInDogfooding() || $322f7f27e3ad3058$var$isVisualRefreshInEAP() || $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta());
    const $322f7f27e3ad3058$var$isVisualRefreshInDogfooding = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-dogfood') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
    const $322f7f27e3ad3058$var$isVisualRefreshInEAP = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-eap') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
    const $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-beta-existing-customers') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)() || (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-beta-sandboxes') || (0, (0, parcelRequire("6s1PB")).expVal)('jira_nav4_beta_free-customers', 'isVisualRefreshEnabled', false) || (0, (0, parcelRequire("6s1PB")).expVal)('jira_nav4_beta_new-customers', 'isVisualRefreshEnabled', false);
});
parcelRegister("bOdHA", function(module, exports) {
    module.exports = new URL("next-gen-backlog-app-skeleton.tpl.28e29051.svg", import.meta.url).toString();
});
parcelRegister("ibA3M", function(module, exports) {
    $parcel$export(module.exports, "useSelectedConfigTab", ()=>$a2554898b8aa72da$export$9b386f1a3e61b385);
    const $a2554898b8aa72da$export$9b386f1a3e61b385 = ()=>{
        const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';
        const getSelectedConfigTab = ()=>localStorage.getItem(SELECTED_CONFIG_TAB_KEY) || '';
        const setSelectedConfigTab = (newConfigTab)=>localStorage.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
        return {
            getSelectedConfigTab: getSelectedConfigTab,
            setSelectedConfigTab: setSelectedConfigTab
        };
    };
});
parcelRegister("b4koY", function(module, exports) {
    $parcel$export(module.exports, "deploymentPreconditionRelayResource", ()=>$b79457e490ba4467$export$50e4eedb9e6127c8);
    var $ao2h1;
    var $ajgeO;
    var $2M1hQ;
    const $b79457e490ba4467$export$a1c09d7f7318f85c = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $c47c39dbdbc02648$export$2171160371fac588),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("hM28Z")),
        maxAge: 60000
    });
    const $b79457e490ba4467$export$50e4eedb9e6127c8 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $c47c39dbdbc02648$export$a969d0487e348031),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("ajgeO")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    projectKey: String(match.params.projectKey)
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("ajgeO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0f41d4aeb9b6b93$export$2e2bcd8739ae039);
    const $e0f41d4aeb9b6b93$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            }
        ], v1 = {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                }
            ],
            "kind": "ScalarField",
            "name": "deploymentsFeaturePreconditionByProjectKey"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "uiDeploymentsFeaturePreconditionQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": v1,
                                    "action": "THROW",
                                    "path": "jira.deploymentsFeaturePreconditionByProjectKey"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "uiDeploymentsFeaturePreconditionQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v1
                        ]
                    }
                ]
            },
            "params": {
                "id": "0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2",
                "metadata": {},
                "name": "uiDeploymentsFeaturePreconditionQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $e0f41d4aeb9b6b93$var$node.hash = "3337e3d6b76da02b643c63aacd15b239";
    var $e0f41d4aeb9b6b93$export$2e2bcd8739ae039 = $e0f41d4aeb9b6b93$var$node;
});
const $c47c39dbdbc02648$export$2171160371fac588 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION';
const $c47c39dbdbc02648$export$a969d0487e348031 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION_RELAY';
parcelRegister("hM28Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f0to4").then(()=>parcelRequire('96xO4'));
});
parcelRegister("kfztd", function(module, exports) {
    $parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", ()=>$064393a36b21cb6e$export$18bfef4995ec57b7);
    var $aIZdc;
    var $eIXQk;
    const $064393a36b21cb6e$export$18bfef4995ec57b7 = ()=>(0, (0, parcelRequire("eIXQk")).isDisableDevopsFeaturesInFedRampEnvEnabled)() && (0, (0, parcelRequire("aIZdc")).isFedRamp)();
});
parcelRegister("eIXQk", function(module, exports) {
    $parcel$export(module.exports, "isDisableDevopsFeaturesInFedRampEnvEnabled", ()=>$4ce1ad45498aedfa$export$a803c452d83c73b6);
    var $co1wz;
    const $4ce1ad45498aedfa$export$a803c452d83c73b6 = ()=>(0, (0, parcelRequire("co1wz")).ff)('core-x-fedramp-m1-disable-devops-features_ag5zy');
});
parcelRegister("lChVn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("cBa2R")
    ]).then(()=>parcelRequire('5EQGR'));
});
parcelRegister("2M4nF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kWlGu")
    ]).then(()=>parcelRequire('jM2sL'));
});
parcelRegister("9bKt5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("636Ie").then(()=>parcelRequire('jqjLM'));
});
parcelRegister("2Whxf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9kKye")
    ]).then(()=>parcelRequire('91Ac2'));
});
parcelRegister("53AYd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9z4nz")
    ]).then(()=>parcelRequire('6SZAm'));
});
parcelRegister("ajKFd", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$b9eb4b3f312b449f$export$8f31e4c4a37b8e9c);
    $parcel$export(module.exports, "InsightsSkeleton", ()=>$b9eb4b3f312b449f$export$dd0b74c715df3275);
    $parcel$export(module.exports, "SuggestionsSkeleton", ()=>$b9eb4b3f312b449f$export$91f27b306afd627b);
    $parcel$export(module.exports, "WorkItemsSkeleton", ()=>$b9eb4b3f312b449f$export$1660f3159b79b22b);
    $parcel$export(module.exports, "WorkItemsVulnTabSkeleton", ()=>$b9eb4b3f312b449f$export$5aea7d4ed03d6ea6);
    $parcel$export(module.exports, "WorkItemsDeploymentTabSkeleton", ()=>$b9eb4b3f312b449f$export$ff38ee81427877e9);
    $parcel$export(module.exports, "OnCallPanelSkeleton", ()=>$b9eb4b3f312b449f$export$91b639eac52af99f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $koVbs;
    var $gUTyu;
    var $29cNf;
    const $b9eb4b3f312b449f$export$8f31e4c4a37b8e9c = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $b9eb4b3f312b449f$var$MainContainerStyles,
            "data-testId": "software-periscope-periscope-page.ui.loading",
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).labelNonFinal),
            gap: "space.300"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $b9eb4b3f312b449f$var$leftColumnStyles,
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$InsightsContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUTyu")).PeriscopeInsightsSkeleton), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUTyu")).PeriscopeWorkItemsSkeleton), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $b9eb4b3f312b449f$var$rightColumnStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$SuggestionsContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUTyu")).PeriscopeSuggestionsSkeleton), null))));
    };
    const $b9eb4b3f312b449f$export$dd0b74c715df3275 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$InsightsContainerStyles,
            "data-testId": "software-periscope-periscope-page.insights-ui.loading",
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).insightsLabelNonFinal),
            paddingBlockEnd: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUTyu")).PeriscopeInsightsSkeleton), null));
    };
    const $b9eb4b3f312b449f$export$91f27b306afd627b = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$SuggestionsContainerStyles,
            "data-testId": "software-periscope-periscope-page.suggestions-ui.loading",
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).suggestionsLabelNonFinal),
            paddingBlockEnd: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUTyu")).PeriscopeSuggestionsSkeleton), null));
    };
    const $b9eb4b3f312b449f$export$1660f3159b79b22b = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles,
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).workItemsLabelNonFinal),
            paddingBlockEnd: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUTyu")).PeriscopeWorkItemsSkeleton), null));
    };
    const $b9eb4b3f312b449f$export$5aea7d4ed03d6ea6 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$WorkItemsVulnTabContainerStyles,
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).workItemsVulnTabLabelNonFinal)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUTyu")).DevelopmentPageWorkItemsVulnTabSkeleton), null));
    };
    const $b9eb4b3f312b449f$export$ff38ee81427877e9 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles,
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).workItemsDeploymentTabLabelNonFinal),
            paddingBlockEnd: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUTyu")).DevelopmentPageWorkItemsDeploymentTabSkeleton), null));
    };
    const $b9eb4b3f312b449f$export$91b639eac52af99f = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b9eb4b3f312b449f$var$OnCallPanelContainterStyles,
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).onCallPanelLabelNonFinal),
            paddingBlockEnd: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUTyu")).DevelopmentPageOnCallPanelSkeleton), null));
    };
    const $b9eb4b3f312b449f$var$MainContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%',
        display: 'flex',
        boxSizing: 'border-box',
        overflow: 'hidden'
    });
    const $b9eb4b3f312b449f$var$leftColumnStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: '2 1 0'
    });
    const $b9eb4b3f312b449f$var$rightColumnStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: '1 1 0'
    });
    const $b9eb4b3f312b449f$var$SuggestionsContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        overflow: 'hidden',
        height: '650px',
        boxSizing: 'border-box'
    });
    const $b9eb4b3f312b449f$var$InsightsContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        width: '100%',
        height: '385px',
        boxSizing: 'border-box'
    });
    const $b9eb4b3f312b449f$var$WorkItemsContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '600px',
        boxSizing: 'border-box',
        overflow: 'hidden'
    });
    const $b9eb4b3f312b449f$var$WorkItemsVulnTabContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '420px',
        boxSizing: 'border-box',
        overflow: 'hidden'
    });
    const $b9eb4b3f312b449f$var$OnCallPanelContainterStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '96px',
        boxSizing: 'border-box',
        overflow: 'hidden'
    });
});
parcelRegister("gUTyu", function(module, exports) {
    $parcel$export(module.exports, "PeriscopeSuggestionsSkeleton", ()=>$c6fead338751845c$export$176dfe4c14771136);
    $parcel$export(module.exports, "PeriscopeInsightsSkeleton", ()=>$c6fead338751845c$export$afb44f298901be44);
    $parcel$export(module.exports, "PeriscopeWorkItemsSkeleton", ()=>$c6fead338751845c$export$298a6b6a251923c2);
    $parcel$export(module.exports, "DevelopmentPageWorkItemsVulnTabSkeleton", ()=>$c6fead338751845c$export$8940e0b80e4066d6);
    $parcel$export(module.exports, "DevelopmentPageWorkItemsDeploymentTabSkeleton", ()=>$c6fead338751845c$export$2f5ed71a7df2d4e6);
    $parcel$export(module.exports, "DevelopmentPageOnCallPanelSkeleton", ()=>$c6fead338751845c$export$e70f5fa3451855e2);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $2vpp7 = parcelRequire("2vpp7");
    var $47suu = parcelRequire("47suu");
    var $2AftB = parcelRequire("2AftB");
    var $aR5hR = parcelRequire("aR5hR");
    var $bIAib = parcelRequire("bIAib");
    var $gqrFB = parcelRequire("gqrFB");
    var $2aQWX = parcelRequire("2aQWX");
    const $c6fead338751845c$var$PeriscopePageSkeletonStyles = null;
    const $c6fead338751845c$export$4aecc030c4d69f74 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.periscope-page.app-skeleton-image-periscope-page-new",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($aR5hR)))
        }));
    const $c6fead338751845c$export$176dfe4c14771136 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.periscope-page.app-suggestions-skeleton",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($bIAib)))
        }));
    const $c6fead338751845c$export$afb44f298901be44 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.periscope-page.app-insights-skeleton",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($47suu)))
        }));
    const $c6fead338751845c$export$298a6b6a251923c2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($2aQWX)))
        }));
    const $c6fead338751845c$export$8940e0b80e4066d6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($gqrFB)))
        }));
    const $c6fead338751845c$export$2f5ed71a7df2d4e6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($2vpp7)))
        }));
    const $c6fead338751845c$export$e70f5fa3451855e2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.periscope-page.app-on-call-panel-skeleton",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($2AftB)))
        }));
});
parcelRegister("2vpp7", function(module, exports) {
    module.exports = new URL("deployment-tab-skeleton.tpl.6442d1f9.svg", import.meta.url).toString();
});
parcelRegister("47suu", function(module, exports) {
    module.exports = new URL("insights.tpl.c29b665e.svg", import.meta.url).toString();
});
parcelRegister("2AftB", function(module, exports) {
    module.exports = new URL("on-call-panel-skeleton.tpl.d7139b03.svg", import.meta.url).toString();
});
parcelRegister("aR5hR", function(module, exports) {
    module.exports = new URL("periscope-page-full-layout.tpl.762dcdba.svg", import.meta.url).toString();
});
parcelRegister("bIAib", function(module, exports) {
    module.exports = new URL("suggestions.tpl.52cb06d0.svg", import.meta.url).toString();
});
parcelRegister("gqrFB", function(module, exports) {
    module.exports = new URL("vuln-tab-skeleton.tpl.1a18ea24.svg", import.meta.url).toString();
});
parcelRegister("2aQWX", function(module, exports) {
    module.exports = new URL("work-items.tpl.4ee9e4f3.svg", import.meta.url).toString();
});
parcelRegister("29cNf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34a050fcfbf5d355$export$2e2bcd8739ae039);
    var $7VHMR;
    var $34a050fcfbf5d355$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        labelNonFinal: {
            "id": "periscope.skeleton.label-non-final",
            "defaultMessage": "Loading"
        },
        suggestionsLabelNonFinal: {
            "id": "periscope.suggestions-skeleton.label-non-final",
            "defaultMessage": "Suggestions loading"
        },
        insightsLabelNonFinal: {
            "id": "periscope.insights-skeleton.label-non-final",
            "defaultMessage": "Developer insights loading"
        },
        workItemsLabelNonFinal: {
            "id": "periscope.work-items-skeleton.work-items-label-non-final",
            "defaultMessage": "Work items loading"
        },
        workItemsVulnTabLabelNonFinal: {
            "id": "periscope.work-items-skeleton.work-items-vuln-tab-label-non-final",
            "defaultMessage": "Work items vulnerability tab loading"
        },
        workItemsDeploymentTabLabelNonFinal: {
            "id": "periscope.work-items-skeleton.work-items-deployment-tab-label-non-final",
            "defaultMessage": "Work items deployment tab loading"
        },
        onCallPanelLabelNonFinal: {
            "id": "periscope.on-call-skeleton.label-non-final",
            "defaultMessage": "On call panel loading"
        }
    });
});
parcelRegister("gUniW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("WP2Js")
    ]).then(()=>parcelRequire('k9ngM'));
});
parcelRegister("bwLf9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a7ec252b6b084884$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a7ec252b6b084884$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
        const ComponentWithCondition = (props)=>conditionGetter() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, props) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, props);
        if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
        return ComponentWithCondition;
    };
});
parcelRegister("en8e6", function(module, exports) {
    $parcel$export(module.exports, "securityPageResource", ()=>$ae0f760fa9a80a3f$export$2c5e3c161b8fe98);
    var $65Ltd;
    var $dXq4S;
    var $ao2h1;
    var $1UBcC;
    var $ac0bf;
    const $ae0f760fa9a80a3f$var$getNumberOfVulnerabilitiesToFetch = ()=>40;
    const $ae0f760fa9a80a3f$var$getNumberOfSecurityContainersToFetch = ()=>100;
    let $ae0f760fa9a80a3f$var$filters;
    const $ae0f760fa9a80a3f$export$2c5e3c161b8fe98 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $0a72320b8bc3a1aa$export$f24db22c3c834cb1),
        getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId, activationId: activationId } }) {
            const isSecRoute = name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY) || name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC);
            if (!$ae0f760fa9a80a3f$var$filters && isSecRoute) {
                const connectionAri = (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'security-container',
                    cloudId: cloudId,
                    activationId: activationId,
                    resourceId: ''
                });
                $ae0f760fa9a80a3f$var$filters = (0, (0, parcelRequire("ac0bf")).getGqlFiltersFromQueryParams)(query, connectionAri);
            }
            if (!isSecRoute) $ae0f760fa9a80a3f$var$filters = undefined;
            return {
                parameters: (0, (0, parcelRequire("1UBcC")).default),
                options: {
                    fetchPolicy: 'store-and-network'
                },
                variables: {
                    cloudAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira',
                        resourceType: 'site',
                        resourceId: cloudId
                    }),
                    cloudId: cloudId,
                    projectKey: params.projectKey ?? '',
                    numberOfVulnsToFetch: $ae0f760fa9a80a3f$var$getNumberOfVulnerabilitiesToFetch(),
                    getContainers: false,
                    numberOfContainersToFetch: $ae0f760fa9a80a3f$var$getNumberOfSecurityContainersToFetch(),
                    filter: $ae0f760fa9a80a3f$var$filters
                }
            };
        }
    });
});
parcelRegister("dXq4S", function(module, exports) {
    $parcel$export(module.exports, "isAri", ()=>$5c4418bd595ae8cf$export$8e68286aef4c3a8b);
    $parcel$export(module.exports, "createAri", ()=>$5c4418bd595ae8cf$export$594d18a0ad2e0e57);
    $parcel$export(module.exports, "toAri", ()=>$5c4418bd595ae8cf$export$24b47820a324e614);
    $parcel$export(module.exports, "toAriOrDefault", ()=>$5c4418bd595ae8cf$export$e2789192113e8b07);
    $parcel$export(module.exports, "parseAri", ()=>$5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
    $parcel$export(module.exports, "getAriConfig", ()=>$5c4418bd595ae8cf$export$3d8d7031a11613fd);
    const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
    const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
    const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
    const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
    const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
    const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
        if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
        if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
        return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
    };
    const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
        if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
        return undefined;
    };
    const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
    const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
        if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
            const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
            if (parts?.groups) {
                const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
                return {
                    resourceOwner: resourceOwner,
                    cloudId: cloudId,
                    resourceType: resourceType,
                    workspaceId: workspaceId,
                    resourceId: resourceId,
                    activationId: activationId
                };
            }
        }
        return undefined;
    };
    const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
        const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
        if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
        return config;
    };
});
parcelRegister("1UBcC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$511d4548ae93769f$export$2e2bcd8739ae039);
    const $511d4548ae93769f$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "getContainers"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "numberOfContainersToFetch"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "numberOfVulnsToFetch"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v7 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v8 = {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }, v9 = {
            "kind": "ScalarField",
            "name": "totalLinkedSecurityContainerCount"
        }, v10 = [
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "numberOfContainersToFetch"
            }
        ], v11 = {
            "kind": "ScalarField",
            "name": "providerId"
        }, v12 = [
            v11
        ], v13 = {
            "kind": "InlineFragment",
            "selections": v12,
            "type": "ThirdPartySecurityContainer"
        }, v14 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v15 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "numberOfVulnsToFetch"
        }, v16 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": {
                    "and": {
                        "lastUpdated": {
                            "sort": {
                                "order": "ASC",
                                "priority": 1
                            }
                        }
                    }
                }
            },
            v15
        ], v17 = {
            "kind": "ScalarField",
            "name": "id"
        }, v18 = {
            "kind": "ScalarField",
            "name": "name"
        }, v19 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v20 = {
            "concreteType": "DevOps",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "cloudAri"
                        },
                        {
                            "kind": "Literal",
                            "name": "providerTypes",
                            "value": [
                                "SECURITY"
                            ]
                        }
                    ],
                    "concreteType": "DevOpsProviders",
                    "kind": "LinkedField",
                    "name": "providers",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DevOpsSecurityProvider",
                            "kind": "LinkedField",
                            "name": "securityProviders",
                            "plural": true,
                            "selections": [
                                v17,
                                {
                                    "kind": "ScalarField",
                                    "name": "appInstallationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "logoUrl"
                                },
                                v18,
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedWorkspaces",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationship",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v19
                                            ]
                                        }
                                    ],
                                    "storageKey": "linkedWorkspaces(first:100)"
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v21 = [
            v17
        ], v22 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "Node",
            "abstractKey": "__isNode"
        }, v23 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "ConfluencePage"
        }, v24 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "ConfluenceSpace"
        }, v25 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsFeatureFlag"
        }, v26 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsOperationsComponentDetails"
        }, v27 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsOperationsIncidentDetails"
        }, v28 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsOperationsPostIncidentReviewDetails"
        }, v29 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsPullRequestDetails"
        }, v30 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsRepository"
        }, v31 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsSecurityVulnerabilityDetails"
        }, v32 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "JiraConfluenceRemoteIssueLink"
        }, v33 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "JiraCustomRemoteIssueLink"
        }, v34 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "JiraIssueRemoteIssueLink"
        }, v35 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "JiraWebRemoteIssueLink"
        }, v36 = [
            v8,
            v15
        ], v37 = {
            "kind": "ScalarField",
            "name": "url"
        }, v38 = {
            "kind": "ScalarField",
            "name": "key"
        }, v39 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v40 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6
                ],
                "kind": "Fragment",
                "name": "mainSecurityInJiraQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                v8,
                                                {
                                                    "kind": "Variable",
                                                    "name": "getContainers",
                                                    "variableName": "getContainers"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "numberOfContainersToFetch",
                                                    "variableName": "numberOfContainersToFetch"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "main_softwareSecurityPage_MainPage"
                                        },
                                        v9,
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v10,
                                                "concreteType": "AriGraphRelationshipConnection",
                                                "kind": "LinkedField",
                                                "name": "linkedSecurityContainers",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AriGraphRelationshipEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AriGraphRelationship",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AriGraphRelationshipNode",
                                                                        "kind": "LinkedField",
                                                                        "name": "to",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "condition": "getContainers",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "data",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v13
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v14
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.linkedSecurityContainers"
                                        },
                                        {
                                            "alias": "linkedVulnsForAnalytics",
                                            "args": v16,
                                            "concreteType": "GraphJiraVulnerabilityConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityVulnerabilitiesByProject",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerabilityEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "GraphJiraVulnerability",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                            "kind": "LinkedField",
                                                                            "name": "vulnerability",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ThirdPartySecurityContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "securityContainer",
                                                                                    "plural": false,
                                                                                    "selections": v12
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    v20
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v6,
                    v5,
                    v3,
                    v4,
                    v2
                ],
                "kind": "Operation",
                "name": "mainSecurityInJiraQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v9,
                                    v17,
                                    {
                                        "args": v10,
                                        "concreteType": "AriGraphRelationshipConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityContainers",
                                        "plural": false,
                                        "selections": [
                                            v14,
                                            {
                                                "concreteType": "AriGraphRelationshipEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "AriGraphRelationship",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AriGraphRelationshipNode",
                                                                "kind": "LinkedField",
                                                                "name": "to",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "condition": "getContainers",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "data",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v19,
                                                                                    v13,
                                                                                    v22,
                                                                                    v23,
                                                                                    v24,
                                                                                    v25,
                                                                                    v26,
                                                                                    v27,
                                                                                    v28,
                                                                                    v29,
                                                                                    v30,
                                                                                    v31,
                                                                                    v32,
                                                                                    v33,
                                                                                    v34,
                                                                                    v35
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v17
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "args": [
                                            v8
                                        ],
                                        "kind": "ScalarField",
                                        "name": "totalLinkedSecurityVulnerabilityCount"
                                    },
                                    {
                                        "args": v36,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                "kind": "LinkedField",
                                                                "name": "vulnerability",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "title"
                                                                    },
                                                                    {
                                                                        "condition": "getContainers",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v17,
                                                                                    v18,
                                                                                    v37
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityIdentifier",
                                                                        "kind": "LinkedField",
                                                                        "name": "identifiers",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "displayName"
                                                                            },
                                                                            v37
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityAdditionalInfo",
                                                                        "kind": "LinkedField",
                                                                        "name": "additionalInfo",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "content"
                                                                            },
                                                                            v37
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "status"
                                                                    },
                                                                    {
                                                                        "concreteType": "AriGraphRelationshipConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "linkedJiraIssues",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "AriGraphRelationship",
                                                                                "kind": "LinkedField",
                                                                                "name": "nodes",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "AriGraphRelationshipNode",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "to",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v17,
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "data",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v19,
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "args": [
                                                                                                                    {
                                                                                                                        "kind": "Literal",
                                                                                                                        "name": "idsOrAliases",
                                                                                                                        "value": [
                                                                                                                            "summary",
                                                                                                                            "assignee",
                                                                                                                            "status",
                                                                                                                            "issuetype"
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ],
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "fieldsByIdOrAlias",
                                                                                                                "plural": true,
                                                                                                                "selections": [
                                                                                                                    v19,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "concreteType": "JiraStatus",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "status",
                                                                                                                                "plural": false,
                                                                                                                                "selections": [
                                                                                                                                    v18,
                                                                                                                                    v17,
                                                                                                                                    {
                                                                                                                                        "concreteType": "JiraStatusCategory",
                                                                                                                                        "kind": "LinkedField",
                                                                                                                                        "name": "statusCategory",
                                                                                                                                        "plural": false,
                                                                                                                                        "selections": [
                                                                                                                                            v38,
                                                                                                                                            v17
                                                                                                                                        ]
                                                                                                                                    }
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraStatusField"
                                                                                                                    },
                                                                                                                    v17,
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "fieldId"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "ScalarField",
                                                                                                                                "name": "text"
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraSingleLineTextField"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "user",
                                                                                                                                "plural": false,
                                                                                                                                "selections": [
                                                                                                                                    v19,
                                                                                                                                    v18,
                                                                                                                                    {
                                                                                                                                        "kind": "ScalarField",
                                                                                                                                        "name": "picture"
                                                                                                                                    },
                                                                                                                                    v17
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraSingleSelectUserPickerField"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "concreteType": "JiraIssueType",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "issueType",
                                                                                                                                "plural": false,
                                                                                                                                "selections": [
                                                                                                                                    v18,
                                                                                                                                    {
                                                                                                                                        "concreteType": "JiraAvatar",
                                                                                                                                        "kind": "LinkedField",
                                                                                                                                        "name": "avatar",
                                                                                                                                        "plural": false,
                                                                                                                                        "selections": [
                                                                                                                                            {
                                                                                                                                                "kind": "ScalarField",
                                                                                                                                                "name": "small"
                                                                                                                                            }
                                                                                                                                        ]
                                                                                                                                    },
                                                                                                                                    v17
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraIssueTypeField"
                                                                                                                    }
                                                                                                                ],
                                                                                                                "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "issueId"
                                                                                                            },
                                                                                                            v38,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "webUrl"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraIssue"
                                                                                                    },
                                                                                                    v22,
                                                                                                    v23,
                                                                                                    v24,
                                                                                                    v25,
                                                                                                    v26,
                                                                                                    v27,
                                                                                                    v28,
                                                                                                    v29,
                                                                                                    v30,
                                                                                                    v31,
                                                                                                    v32,
                                                                                                    v33,
                                                                                                    v34,
                                                                                                    v35
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v14
                                                                        ]
                                                                    },
                                                                    v17,
                                                                    v37,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "introducedDate"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "providerVulnerabilityId"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "securityContainerId"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "severity"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "description"
                                                                    }
                                                                ]
                                                            },
                                                            v17,
                                                            v19
                                                        ]
                                                    },
                                                    v39
                                                ]
                                            },
                                            v40
                                        ]
                                    },
                                    {
                                        "args": v36,
                                        "filters": [
                                            "filter"
                                        ],
                                        "handle": "connection",
                                        "key": "security__linkedSecurityVulnerabilitiesByProject",
                                        "kind": "LinkedHandle",
                                        "name": "linkedSecurityVulnerabilitiesByProject"
                                    },
                                    {
                                        "alias": "projectHaveVulnerabilityCheck",
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 1
                                            }
                                        ],
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                "kind": "LinkedField",
                                                                "name": "vulnerability",
                                                                "plural": false,
                                                                "selections": [
                                                                    v19,
                                                                    v17
                                                                ]
                                                            },
                                                            v17
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "linkedSecurityVulnerabilitiesByProject(first:1)"
                                    },
                                    {
                                        "alias": "linkedVulnsForAnalytics",
                                        "args": v16,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "condition": "getContainers",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                        "kind": "LinkedField",
                                                                        "name": "vulnerability",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v11,
                                                                                    v17
                                                                                ]
                                                                            },
                                                                            v17
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            v17
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "getContainers",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": v10,
                                                "concreteType": "AriGraphRelationshipConnection",
                                                "kind": "LinkedField",
                                                "name": "linkedSecurityContainers",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AriGraphRelationshipEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AriGraphRelationship",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AriGraphRelationshipNode",
                                                                        "kind": "LinkedField",
                                                                        "name": "to",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "data",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v19,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v18,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "icon"
                                                                                            },
                                                                                            v37,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "providerName"
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "lastUpdated"
                                                                                            },
                                                                                            v14,
                                                                                            v17
                                                                                        ],
                                                                                        "type": "ThirdPartySecurityContainer"
                                                                                    },
                                                                                    v22,
                                                                                    v23,
                                                                                    v24,
                                                                                    v25,
                                                                                    v26,
                                                                                    v27,
                                                                                    v28,
                                                                                    v29,
                                                                                    v30,
                                                                                    v31,
                                                                                    v32,
                                                                                    v33,
                                                                                    v34,
                                                                                    v35
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v19
                                                                ]
                                                            },
                                                            v39
                                                        ]
                                                    },
                                                    v40
                                                ]
                                            },
                                            {
                                                "args": v10,
                                                "handle": "connection",
                                                "key": "security__linkedSecurityContainers",
                                                "kind": "LinkedHandle",
                                                "name": "linkedSecurityContainers"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v20
                ]
            },
            "params": {
                "id": "a1a80f3ccfe8934408165144c558b877d997fe187322dd28b0da2044aa214fed",
                "metadata": {},
                "name": "mainSecurityInJiraQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $511d4548ae93769f$var$node.hash = "e0029e5d1d9e6e62c9b62d69cc3a9f72";
    var $511d4548ae93769f$export$2e2bcd8739ae039 = $511d4548ae93769f$var$node;
});
parcelRegister("ac0bf", function(module, exports) {
    $parcel$export(module.exports, "getGqlFiltersFromQueryParams", ()=>$526907709998fa0b$export$2af359d48d48e5f1);
    var $5eeaw;
    var $3zFAD;
    var $3o4IF;
    const $526907709998fa0b$var$getFilterValue = (values, fieldStortKey, sortKey = (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).sortKey, sortOrder = (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).sortOrder)=>({
            ...values.length > 0 ? {
                values: values
            } : {},
            ...sortKey === fieldStortKey && {
                sort: {
                    priority: 2,
                    order: (0, (0, parcelRequire("3o4IF")).parseSortDirection)(sortOrder, (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC)
                }
            }
        });
    const $526907709998fa0b$var$getOrDefault = (input, defaultArray)=>input.length ? input : defaultArray;
    const $526907709998fa0b$export$2af359d48d48e5f1 = (queryParams, connectionAri)=>{
        const containerValues = $526907709998fa0b$var$getOrDefault((0, (0, parcelRequire("3o4IF")).connectionQueryParamToFilter)(queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_CONTAINER], connectionAri).filter(Boolean), (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).connectionFilter);
        const statusQueryParams = (0, (0, parcelRequire("3o4IF")).arrayQueryParamToFilter)(queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_VULN_STATUS]);
        return {
            and: [
                {
                    lastUpdated: {
                        sort: {
                            priority: 1,
                            order: (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC
                        }
                    },
                    to_severity: $526907709998fa0b$var$getFilterValue($526907709998fa0b$var$getOrDefault((0, (0, parcelRequire("3o4IF")).arrayQueryParamToFilter)(queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SEVERITY]).map((0, (0, parcelRequire("3o4IF")).parseSeverity)).filter(Boolean), (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).severityFilter), 'severity', queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_KEY], queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_ORDER]),
                    to_status: $526907709998fa0b$var$getFilterValue(statusQueryParams.includes((0, (0, parcelRequire("3zFAD")).NO_FILTER_VULN_STATUS)) ? [] : $526907709998fa0b$var$getOrDefault(statusQueryParams.map((0, (0, parcelRequire("3o4IF")).parseStatus)).filter(Boolean), (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).statusFilter), 'status', queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_KEY], queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_ORDER]),
                    createdAt: {
                        ...queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_KEY] === 'introduced' && {
                            sort: {
                                priority: 2,
                                order: (0, (0, parcelRequire("3o4IF")).parseSortDirection)(queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_ORDER], (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC)
                            }
                        }
                    },
                    to_container: {
                        containerAri: {
                            value: {
                                ...containerValues.length > 0 ? {
                                    values: containerValues
                                } : {}
                            }
                        }
                    }
                }
            ]
        };
    };
});
parcelRegister("5eeaw", function(module, exports) {
    $parcel$export(module.exports, "AriGraphSortOrderInput", ()=>$f98addb8b52ad07a$export$3b69903df4cd6048);
    const $f98addb8b52ad07a$export$3b69903df4cd6048 = {
        ASC: 'ASC',
        DESC: 'DESC'
    };
});
parcelRegister("3zFAD", function(module, exports) {
    $parcel$export(module.exports, "QUERY_PARAM_SEARCH", ()=>$d1be2b44eb126533$export$a181206198b7f50c);
    $parcel$export(module.exports, "QUERY_PARAM_CONTAINER", ()=>$d1be2b44eb126533$export$3873b20ffa21b004);
    $parcel$export(module.exports, "QUERY_PARAM_SEVERITY", ()=>$d1be2b44eb126533$export$af01a3d59250f3d3);
    $parcel$export(module.exports, "QUERY_PARAM_VULN_STATUS", ()=>$d1be2b44eb126533$export$c315695f017955dc);
    $parcel$export(module.exports, "QUERY_PARAM_ISSUE_STATUS", ()=>$d1be2b44eb126533$export$2e69a24fe65d4109);
    $parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", ()=>$d1be2b44eb126533$export$6da773286c35ef41);
    $parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", ()=>$d1be2b44eb126533$export$810a1f7ed2facfcb);
    $parcel$export(module.exports, "NO_FILTER_VULN_STATUS", ()=>$d1be2b44eb126533$export$d8115099d465de4c);
    $parcel$export(module.exports, "initialVulnerabilityTableOptions", ()=>$d1be2b44eb126533$export$e9b4ea84d666c490);
    const $d1be2b44eb126533$export$a181206198b7f50c = 'search';
    const $d1be2b44eb126533$export$3873b20ffa21b004 = 'container';
    const $d1be2b44eb126533$export$af01a3d59250f3d3 = 'severity';
    const $d1be2b44eb126533$export$c315695f017955dc = 'vulnerabilityStatus';
    const $d1be2b44eb126533$export$2e69a24fe65d4109 = 'issueStatus';
    const $d1be2b44eb126533$export$6da773286c35ef41 = 'sortKey';
    const $d1be2b44eb126533$export$810a1f7ed2facfcb = 'sortOrder';
    const $d1be2b44eb126533$export$d8115099d465de4c = 'NO-FILTERS';
    const $d1be2b44eb126533$export$afbc65bcea0cf17e = {
        searchFilter: '',
        connectionFilter: [],
        severityFilter: [],
        statusFilter: [
            'OPEN'
        ],
        jiraIssueStatusFilter: []
    };
    const $d1be2b44eb126533$export$e9b4ea84d666c490 = {
        sortKey: 'severity',
        sortOrder: 'DESC',
        ...$d1be2b44eb126533$export$afbc65bcea0cf17e
    };
});
parcelRegister("3o4IF", function(module, exports) {
    $parcel$export(module.exports, "arrayQueryParamToFilter", ()=>$dbe4482e2428caff$export$7500862c6689a767);
    $parcel$export(module.exports, "arrayFilterToQueryParam", ()=>$dbe4482e2428caff$export$b0dee3c5bfc7249e);
    $parcel$export(module.exports, "connectionFilterToQueryParam", ()=>$dbe4482e2428caff$export$a6950ca4fdc8498f);
    $parcel$export(module.exports, "connectionQueryParamToFilter", ()=>$dbe4482e2428caff$export$1040034504af5b41);
    $parcel$export(module.exports, "parseSeverity", ()=>$dbe4482e2428caff$export$3551b8a2cbdb5162);
    $parcel$export(module.exports, "parseStatus", ()=>$dbe4482e2428caff$export$2188844eb84f7f06);
    $parcel$export(module.exports, "parseSortDirection", ()=>$dbe4482e2428caff$export$85cf5c73b48a482e);
    var $chc6P = parcelRequire("chc6P");
    var $80afZ = parcelRequire("80afZ");
    var $5eeaw;
    var $i3r1A;
    const $dbe4482e2428caff$var$DELIMITER = ',';
    const $dbe4482e2428caff$var$ENCODED_DELIMITER = encodeURIComponent($dbe4482e2428caff$var$DELIMITER);
    const $dbe4482e2428caff$var$encodeDelimiter = (input)=>{
        const regex = new RegExp($dbe4482e2428caff$var$DELIMITER, 'g');
        return input.replace(regex, $dbe4482e2428caff$var$ENCODED_DELIMITER);
    };
    const $dbe4482e2428caff$var$decodeDelimiter = (input)=>{
        const regex = new RegExp($dbe4482e2428caff$var$ENCODED_DELIMITER, 'g');
        return input.replace(regex, $dbe4482e2428caff$var$DELIMITER);
    };
    const $dbe4482e2428caff$export$7500862c6689a767 = (queryParamString)=>queryParamString?.split($dbe4482e2428caff$var$DELIMITER)?.map($dbe4482e2428caff$var$decodeDelimiter) ?? [];
    const $dbe4482e2428caff$export$b0dee3c5bfc7249e = (filterArray)=>{
        if (filterArray.length === 0) return undefined;
        return filterArray.map((entity)=>$dbe4482e2428caff$var$encodeDelimiter(entity)).join($dbe4482e2428caff$var$DELIMITER);
    };
    const $dbe4482e2428caff$export$a6950ca4fdc8498f = (connectionArray)=>{
        if (connectionArray.length === 0) return undefined;
        const groupedConnectionsByAppKey = connectionArray.reduce((acc, connection)=>{
            const [, , , , securityParts] = connection.split(':');
            const [, , , appKey, ...containerId] = securityParts.split('/');
            if (!acc[appKey]) acc[appKey] = [];
            acc[appKey].push(containerId.join('/'));
            return acc;
        }, {});
        return JSON.stringify(groupedConnectionsByAppKey);
    };
    const $dbe4482e2428caff$export$1040034504af5b41 = (queryParamString, connectionAri)=>{
        if (!queryParamString) return [];
        const groupedConnectionsByAppKey = JSON.parse(queryParamString);
        return (0, ($parcel$interopDefault($chc6P)))(groupedConnectionsByAppKey, (containerIds, appKey)=>(0, ($parcel$interopDefault($80afZ)))(containerIds, (containerId)=>`${connectionAri}${appKey}/${containerId}`));
    };
    const $dbe4482e2428caff$export$3551b8a2cbdb5162 = (maybeSeverity)=>{
        switch(maybeSeverity?.toUpperCase()){
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).CRITICAL.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).CRITICAL;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).HIGH.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).HIGH;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).LOW.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).LOW;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).MEDIUM.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).MEDIUM;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).UNKNOWN.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).UNKNOWN;
            default:
                return undefined;
        }
    };
    const $dbe4482e2428caff$export$2188844eb84f7f06 = (maybeStatus)=>{
        switch(maybeStatus?.toUpperCase()){
            case (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).OPEN.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).OPEN;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).UNKNOWN.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).UNKNOWN;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).CLOSED.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).CLOSED;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).IGNORED.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).IGNORED;
            default:
                return undefined;
        }
    };
    const $dbe4482e2428caff$export$85cf5c73b48a482e = (maybeDirection, defaultValue)=>{
        switch(maybeDirection?.toUpperCase()){
            case (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).ASC.toUpperCase():
                return (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).ASC;
            case (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC.toUpperCase():
                return (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC;
            default:
                return defaultValue;
        }
    };
});
parcelRegister("chc6P", function(module, exports) {
    var $ekcP3 = parcelRequire("ekcP3");
    var $80afZ = parcelRequire("80afZ");
    function $8f007734a6a4d9ac$var$flatMap(collection, iteratee) {
        return $ekcP3($80afZ(collection, iteratee), 1);
    }
    module.exports = $8f007734a6a4d9ac$var$flatMap;
});
parcelRegister("80afZ", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $bxDef = parcelRequire("bxDef");
    var $jXnVG = parcelRequire("jXnVG");
    var $8LQ84 = parcelRequire("8LQ84");
    function $5d3647a04b83e8d6$var$map(collection, iteratee) {
        var func = $8LQ84(collection) ? $1nIHN : $jXnVG;
        return func(collection, $bxDef(iteratee, 3));
    }
    module.exports = $5d3647a04b83e8d6$var$map;
});
parcelRegister("i3r1A", function(module, exports) {
    $parcel$export(module.exports, "VulnerabilitySeverityEnums", ()=>$e40f3ad586d15bb3$export$c1a102938d8dc10);
    $parcel$export(module.exports, "VulnerabilityStatusEnums", ()=>$e40f3ad586d15bb3$export$2d6749bded378262);
    const $e40f3ad586d15bb3$export$c1a102938d8dc10 = {
        CRITICAL: 'CRITICAL',
        HIGH: 'HIGH',
        LOW: 'LOW',
        MEDIUM: 'MEDIUM',
        UNKNOWN: 'UNKNOWN'
    };
    const $e40f3ad586d15bb3$export$2d6749bded378262 = {
        CLOSED: 'CLOSED',
        IGNORED: 'IGNORED',
        OPEN: 'OPEN',
        UNKNOWN: 'UNKNOWN'
    };
    const $e40f3ad586d15bb3$export$abf926511a2b65de = {
        DAST: 'DAST',
        SAST: 'SAST',
        SCA: 'SCA',
        UNKNOWN: 'UNKNOWN'
    };
});
const $0a72320b8bc3a1aa$export$f24db22c3c834cb1 = 'SOFTWARE_SECURITY';
parcelRegister("lIOEX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eHlvD")
    ]).then(()=>parcelRequire('jbq29'));
});
parcelRegister("6TXTk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4VHZG").then(()=>parcelRequire('iPGiI'));
});
parcelRegister("lyCs2", function(module, exports) {
    $parcel$export(module.exports, "userBoardRoute", ()=>$a9c2c98045690ca6$export$57a2a0fe739f16);
    var $65Ltd;
    const $a9c2c98045690ca6$export$57a2a0fe739f16 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD),
        path: '/jira/people/:accountId/boards/:boardId'
    };
});
parcelRegister("8STJR", function(module, exports) {
    $parcel$export(module.exports, "RoadmapSkeleton", ()=>$e0f5f5cb925a5d1c$export$66a1e8bb48359566);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7XYc4;
    var $4R6GH;
    var $3HwlS;
    var $dCm1o;
    var $hCy6k;
    var $7jB1k = parcelRequire("7jB1k");
    var $aIPZQ = parcelRequire("aIPZQ");
    const $e0f5f5cb925a5d1c$var$customCssStyles = null;
    const $e0f5f5cb925a5d1c$export$66a1e8bb48359566 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($e0f5f5cb925a5d1c$var$AppSkeletonImageContainer, null, (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($7jB1k))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1idpf"
            ])
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($aIPZQ))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1idpf"
            ])
        }));
    const $e0f5f5cb925a5d1c$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
                __cmplp.className
            ])
        });
    });
    const $e0f5f5cb925a5d1c$var$AppSkeletonImageContainer = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2'), ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($e0f5f5cb925a5d1c$var$Wrapper, null, children), (0, $5uXOq.Fragment));
});
parcelRegister("7jB1k", function(module, exports) {
    module.exports = new URL("roadmap-app-skeleton-nav-refresh.tpl.ce6eb42e.svg", import.meta.url).toString();
});
parcelRegister("aIPZQ", function(module, exports) {
    module.exports = new URL("roadmap-app-skeleton.tpl.a54a882d.svg", import.meta.url).toString();
});
parcelRegister("48Ij3", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarJSWReportsResource", ()=>$d94d5098764be5f8$export$5910307042ab3f6f);
    var $8YTna;
    var $2M1hQ;
    var $7xeIG;
    const $d94d5098764be5f8$export$5910307042ab3f6f = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'JIRA_SOFTWARE_REPORTS',
        getKey: ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            return boardId ? `board-${boardId}` : 'none';
        },
        getData: async ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            if (boardId == null) return null;
            const response = await (0, (0, parcelRequire("7xeIG")).fetchJSWReports)(boardId);
            return response?.reports;
        },
        maxAge: 300000
    });
});
parcelRegister("7xeIG", function(module, exports) {
    $parcel$export(module.exports, "fetchJSWReports", ()=>$61400f9195fc4c28$export$a93a577d6971da2c);
    var $eusud;
    const $61400f9195fc4c28$export$a93a577d6971da2c = (boardId)=>{
        if (boardId == null) throw new Error('invalid boardId');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
    };
});
parcelRegister("4Bwc0", function(module, exports) {
    $parcel$export(module.exports, "devOpsReportPreconditionResource", ()=>$5073d432665dfcf8$export$96cb0eae1b3413f4);
    $parcel$export(module.exports, "useDevOpsReportPreconditionResource", ()=>$5073d432665dfcf8$export$e9adc6103e9ed514);
    var $2M1hQ;
    var $2YP9W;
    const $5073d432665dfcf8$export$96cb0eae1b3413f4 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $16165c7eb855363c$export$14c5ce449424c281),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("fUjXk")),
        maxAge: 60000
    });
    const $5073d432665dfcf8$export$e9adc6103e9ed514 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($5073d432665dfcf8$export$96cb0eae1b3413f4);
});
const $16165c7eb855363c$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $16165c7eb855363c$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $16165c7eb855363c$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';
parcelRegister("fUjXk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("goFaC").then(()=>parcelRequire('5aldt'));
});
parcelRegister("6Aupt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hG41q").then(()=>parcelRequire('ksDNa'));
});
parcelRegister("5LZ4w", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("a0moB")
    ]).then(()=>parcelRequire('4RuJw'));
});
parcelRegister("1NWtC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jmhtg")
    ]).then(()=>parcelRequire('izbAs'));
});
parcelRegister("bTGYj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("39IYm")
    ]).then(()=>parcelRequire('9PBZj'));
});
parcelRegister("eqReh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iePIJ")
    ]).then(()=>parcelRequire('71XRW'));
});
parcelRegister("kt9Vo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("donBI")
    ]).then(()=>parcelRequire('6LEOw'));
});
parcelRegister("eSbew", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("62r1i")
    ]).then(()=>parcelRequire('ycm07'));
});
parcelRegister("bmORQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("haEOE")
    ]).then(()=>parcelRequire('6xPmp'));
});
parcelRegister("dyzSB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6uzq3").then(()=>parcelRequire('iX103'));
});
parcelRegister("pXexG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1pebU").then(()=>parcelRequire('6pwND'));
});
parcelRegister("bTLzO", function(module, exports) {
    $parcel$export(module.exports, "compassProductSettingsResource", ()=>$cfea6057f91373db$export$d18ff068d6c25455);
    $parcel$export(module.exports, "useCompassProductSettingsResource", ()=>$cfea6057f91373db$export$6cbcbd11d26ae36f);
    var $jcw0u;
    var $eusud;
    var $2M1hQ;
    var $2YP9W;
    const $cfea6057f91373db$export$d18ff068d6c25455 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $0e2163be65099f64$export$6f0555de4f60e84e),
        getKey: ()=>'state',
        getData: async ()=>{
            try {
                const isCompassEnabledForNewProjects = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/application-properties?key=${(0, $0e2163be65099f64$export$5685d70c20140008)}`).then(({ value: value })=>value.toLowerCase().trim() === 'true');
                return {
                    isCompassEnabledForNewProjects: isCompassEnabledForNewProjects
                };
            } catch (error) {
                if (error?.statusCode === 404) return {
                    isCompassEnabledForNewProjects: true
                };
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'compassProductSettingsResource',
                        packageName: 'jiraRouterResourcesCompassProductSettings',
                        teamName: 'compass-lodestone'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
    });
    const $cfea6057f91373db$export$6cbcbd11d26ae36f = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($cfea6057f91373db$export$d18ff068d6c25455);
});
const $0e2163be65099f64$export$6f0555de4f60e84e = 'RESOURCE_TYPE_COMPASS_PRODUCT_SETTINGS';
const $0e2163be65099f64$export$5685d70c20140008 = 'jira.admin.compass.is-enabled-for-new-project';
parcelRegister("6Bdj6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8asz0").then(()=>parcelRequire('lIMc4'));
});
parcelRegister("bri2h", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("di7zh").then(()=>parcelRequire('6AMhj'));
});
parcelRegister("hz6Yb", function(module, exports) {
    $parcel$export(module.exports, "connectGeneralResources", ()=>$07e636c36bc19b52$export$f34ab0d904621847);
    $parcel$export(module.exports, "useConnectGeneralResource", ()=>$07e636c36bc19b52$export$53479840ec6d4024);
    var $2M1hQ;
    var $2YP9W;
    const $07e636c36bc19b52$export$f34ab0d904621847 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $1130bd470474fe6f$export$d5eed449bb62d4c1),
        getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
            if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
            return 'state';
        },
        getDataLoader: ()=>(parcelRequire("bBygl"))
    });
    const $07e636c36bc19b52$export$53479840ec6d4024 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($07e636c36bc19b52$export$f34ab0d904621847);
});
const $1130bd470474fe6f$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';
parcelRegister("bBygl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("W2aDd").then(()=>parcelRequire('6LiLg'));
});
parcelRegister("9UABi", function(module, exports) {
    $parcel$export(module.exports, "connectProjectResources", ()=>$fce046ce7cfaa8c3$export$7d2d082a4b91a6c7);
    var $8Vh1q;
    var $ggg5j;
    var $2M1hQ;
    const $fce046ce7cfaa8c3$export$7d2d082a4b91a6c7 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $35b0c7feb103121f$export$da32d27651782c3),
        getKey: ({ query: query })=>{
            const { addonKey: addonKey, moduleKey: moduleKey } = (0, (0, parcelRequire("8Vh1q")).transformUrlToAddonAndModuleKeys)(query);
            if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
            return 'state';
        },
        depends: [
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource).type
        ],
        getDataLoader: ()=>(parcelRequire("actZ1"))
    });
});
parcelRegister("8Vh1q", function(module, exports) {
    $parcel$export(module.exports, "transformResponse", ()=>$beff5be7f4728df2$export$3361e9be8093ddcc);
    $parcel$export(module.exports, "extractContext", ()=>$beff5be7f4728df2$export$efdbd45f3e77a161);
    $parcel$export(module.exports, "transformQueryParams", ()=>$beff5be7f4728df2$export$9e3c3f47fc3ab3d0);
    $parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", ()=>$beff5be7f4728df2$export$752ef5ab3d7ab15f);
    var $dJl1T;
    var $4R6GH;
    var $6VnTH;
    var $3HwlS;
    var $bsuuc;
    const $beff5be7f4728df2$export$3361e9be8093ddcc = (response)=>{
        try {
            const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
            let structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
            if ((0, (0, parcelRequire("4R6GH")).fg)('blu-3664-horizontal-nav-context')) structuredContext = {
                ...structuredContext,
                jira: {
                    ...structuredContext.jira,
                    horizontalNavigation: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)()
                }
            };
            const context = {
                productContext: productContext,
                structuredContext: structuredContext,
                productCtx: productContext
            };
            return {
                ...response,
                ...context,
                isFullPage: response.general === '1',
                user: {
                    timeZone: response.timeZone,
                    uid: response.uid || undefined,
                    ukey: response.ukey || undefined,
                    fullName: response.fullName || undefined
                },
                targets: {
                    env: {
                        resize: 'both'
                    }
                },
                history: {
                    state: ''
                },
                autoresize: true,
                ns: response.uniqueKey,
                containerId: `embedded-${response.uniqueKey}`,
                contextPath: response.cp,
                width: response.w || response.width,
                height: response.h || response.height
            };
        } catch (error) {
            const location = 'connect-iframe.transformer';
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
            return {
                autoresize: true,
                productCtx: undefined,
                structuredContext: undefined,
                isFullPage: true,
                history: {
                    state: ''
                },
                targets: {
                    env: {
                        resize: 'both'
                    }
                }
            };
        }
    };
    const $beff5be7f4728df2$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
        const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
        return newValue !== null ? {
            [newName]: newValue
        } : null;
    };
    const $beff5be7f4728df2$export$1f8eea5a5a32169f = (contextData)=>{
        const scope = contextData && contextData.scope || null;
        const project = contextData && contextData.project || null;
        const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
        const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
        const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
        const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
        return {
            ...projectId,
            ...projectKey,
            ...boardType,
            ...boardId
        };
    };
    const $beff5be7f4728df2$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
        const project = projectSidebarNavInfo && (0, (0, parcelRequire("bsuuc")).extractData)(projectSidebarNavInfo) || null;
        const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, (0, parcelRequire("6VnTH")).extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
        const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
        const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
        const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'type', 'board.type');
        const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'id', 'board.id');
        return {
            ...projectId,
            ...projectKey,
            ...boardType,
            ...boardId
        };
    };
    const $beff5be7f4728df2$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
        const context = $beff5be7f4728df2$export$1f8eea5a5a32169f(contextData);
        return {
            ...query,
            ...context
        };
    };
    const $beff5be7f4728df2$export$752ef5ab3d7ab15f = (query)=>{
        const { selectedItem: selectedItem } = query;
        let addonKey = '';
        let moduleKey = '';
        if (selectedItem) {
            const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
            [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
        }
        return {
            addonKey: addonKey,
            moduleKey: moduleKey
        };
    };
});
parcelRegister("6VnTH", function(module, exports) {
    $parcel$export(module.exports, "extractData", ()=>$4d73b10ca351bbb3$export$9df5fa0a366163d2);
    $parcel$export(module.exports, "extractUserBoard", ()=>$4d73b10ca351bbb3$export$67db9e2d1b6ed865);
    const $4d73b10ca351bbb3$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
        if (jiraSoftwareNavData.boardInfo == null) return null;
        const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
        return {
            id: id,
            type: type,
            name: name,
            isProjectBoard: true
        };
    };
    const $4d73b10ca351bbb3$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
        const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
        return {
            id: id,
            type: type,
            name: name,
            isProjectBoard: false
        };
    };
});
const $35b0c7feb103121f$export$da32d27651782c3 = 'CONNECT_PROJECT';
parcelRegister("actZ1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g7yss").then(()=>parcelRequire('4ECv0'));
});
parcelRegister("iGYap", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cTtOi").then(()=>parcelRequire('crFp4'));
});
parcelRegister("fpjJX", function(module, exports) {
    $parcel$export(module.exports, "getServiceDeskNavigationResources", ()=>$491f4fde535ee8ab$export$bc0bd65e6da57c1f);
    $parcel$export(module.exports, "getServiceDeskNavigationSingleResources", ()=>$491f4fde535ee8ab$export$41a9145ddbba28e5);
    $parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", ()=>$491f4fde535ee8ab$export$2c543d6accc1eb9b);
    $parcel$export(module.exports, "getServiceDeskSettingsResources", ()=>$491f4fde535ee8ab$export$7bb3c4a2f6b127fb);
    $parcel$export(module.exports, "getServicedeskPageContextResources", ()=>$491f4fde535ee8ab$export$a8b852f03a310dc0);
    $parcel$export(module.exports, "getQueuesResources", ()=>$491f4fde535ee8ab$export$70b97995f4d5ef9f);
    $parcel$export(module.exports, "getIssueListSsrResource", ()=>$491f4fde535ee8ab$export$e1016cce62543991);
    $parcel$export(module.exports, "getKnowledgeBaseResources", ()=>$491f4fde535ee8ab$export$ed87d3b71544c4ef);
    $parcel$export(module.exports, "getInsightResources", ()=>$491f4fde535ee8ab$export$9e0cf1fab0581096);
    var $aIZdc;
    var $co1wz;
    var $4R6GH;
    var $5bkvv;
    var $b2pl3;
    var $gS5PF;
    var $6zFAI;
    var $gcI3W;
    var $ggg5j;
    var $iEUaw;
    var $3HwlS;
    var $bjZiV;
    var $3RJkv;
    var $dxCvy;
    var $8H3A4;
    var $cAofY;
    var $eUvlM;
    var $lbaDt;
    var $1WlLE;
    var $2cxgG;
    var $6sNnq;
    var $7GnDe;
    var $gNStA;
    var $gRzZD;
    const $491f4fde535ee8ab$export$bc0bd65e6da57c1f = ()=>[
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...$491f4fde535ee8ab$export$41a9145ddbba28e5()
        ];
    const $491f4fde535ee8ab$var$fetchPriorityGroupByProjectId = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jsm_flash_priority_group_api_optimisation') && !(0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
    const $491f4fde535ee8ab$export$41a9145ddbba28e5 = ()=>[
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>$491f4fde535ee8ab$var$fetchPriorityGroupByProjectId(), (0, (0, parcelRequire("dxCvy")).projectContextResource)),
            ...$491f4fde535ee8ab$export$9c1c5e389bd00e56(),
            ...$491f4fde535ee8ab$export$2c543d6accc1eb9b()
        ];
    const $491f4fde535ee8ab$export$9c1c5e389bd00e56 = ()=>[
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!$491f4fde535ee8ab$var$fetchPriorityGroupByProjectId(), (0, (0, parcelRequire("1WlLE")).priorityGroupResource)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>$491f4fde535ee8ab$var$fetchPriorityGroupByProjectId(), (0, (0, parcelRequire("1WlLE")).priorityGroupByProjectIdResource)),
            (0, (0, parcelRequire("6sNnq")).featuresResource),
            (0, (0, parcelRequire("gS5PF")).staticSidebarJsmReportsResource)
        ];
    const $491f4fde535ee8ab$export$2c543d6accc1eb9b = ()=>[
            (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ssr_nav4_queues_sidebar'), (0, (0, parcelRequire("lbaDt")).requiredProjectProperties)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ssr_nav4_queues_sidebar'), (0, (0, parcelRequire("lbaDt")).requiredFrontendProperties)),
            (0, (0, parcelRequire("5bkvv")).forgeServiceDeskQueueModuleResource),
            (0, (0, parcelRequire("b2pl3")).staticJSMProjectConnectAddonsNavigationResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $491f4fde535ee8ab$export$7bb3c4a2f6b127fb = ()=>[
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource),
            (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
            (0, (0, parcelRequire("8H3A4")).serviceDeskAnalyticsContextResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!(0, (0, parcelRequire("aIZdc")).isFedRamp)(), (0, (0, parcelRequire("2cxgG")).virtualAgentOnboardingResource))
        ];
    const $491f4fde535ee8ab$export$a8b852f03a310dc0 = ()=>[
            (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
            (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
            (0, (0, parcelRequire("8H3A4")).serviceDeskAnalyticsContextResource)
        ];
    const $491f4fde535ee8ab$export$70b97995f4d5ef9f = ()=>[
            ...$491f4fde535ee8ab$export$a8b852f03a310dc0(),
            ...$491f4fde535ee8ab$export$bc0bd65e6da57c1f(),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('automation-templates-team-types-refactor-m1_isj0e'), (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource))
        ];
    const $491f4fde535ee8ab$export$e1016cce62543991 = ()=>[
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ssr_view_queues_issuelist'), (0, (0, parcelRequire("1WlLE")).issueListSsrResource))
        ];
    const $491f4fde535ee8ab$export$ed87d3b71544c4ef = ()=>[
            (0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource)
        ];
    const $491f4fde535ee8ab$export$9e0cf1fab0581096 = ()=>[
            (0, (0, parcelRequire("gRzZD")).workspaceResource)
        ];
});
parcelRegister("gS5PF", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarJsmReportsResource", ()=>$e7e607725980fdf6$export$ec28065a31cce4ce);
    var $1nb22;
    var $2M1hQ;
    var $cQGRH;
    const $e7e607725980fdf6$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $e7e607725980fdf6$export$ec28065a31cce4ce = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
        getKey: ({ match: match, query: query })=>$e7e607725980fdf6$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $e7e607725980fdf6$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            return (0, (0, parcelRequire("cQGRH")).fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
        },
        maxAge: 300000
    });
});
parcelRegister("cQGRH", function(module, exports) {
    $parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", ()=>$ed2ba0d649a8d8eb$export$c1dd51127051647d);
    var $eusud;
    const $ed2ba0d649a8d8eb$export$c1dd51127051647d = (projectIdOrKey)=>{
        if (projectIdOrKey == null) throw new Error('invalid project id or key');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
    };
});
parcelRegister("bjZiV", function(module, exports) {
    $parcel$export(module.exports, "kbConfluenceContextResource", ()=>$450040dc63d5cc0e$export$8b58be1423986d17);
    var $2M1hQ;
    const $450040dc63d5cc0e$var$getDataLoader = ()=>(parcelRequire("f43qF"));
    const $450040dc63d5cc0e$export$8b58be1423986d17 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $3139e13cdf89be01$export$54b5a0d1e8c78de6),
        getKey: ({ match: match })=>match.params.projectKey || '',
        getDataLoader: $450040dc63d5cc0e$var$getDataLoader,
        maxAge: Infinity
    });
});
const $3139e13cdf89be01$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';
parcelRegister("f43qF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2CTCs").then(()=>parcelRequire('2SeLy'));
});
parcelRegister("8H3A4", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskAnalyticsContextResource", ()=>$4d76b3bac8f2b7c8$export$d6f4f0483916919f);
    $parcel$export(module.exports, "useServiceDeskAnalyticsContext", ()=>$4d76b3bac8f2b7c8$export$bc2de1c42df30b10);
    var $5uXOq = parcelRequire("5uXOq");
    var $dK8AG;
    var $2M1hQ;
    var $2YP9W;
    const $4d76b3bac8f2b7c8$var$getDataLoader = ()=>(parcelRequire("1M51R"));
    const $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS = 86400000;
    const $4d76b3bac8f2b7c8$export$d6f4f0483916919f = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $3b4b6bf0bbdfa955$export$285b47583a5bdd0f),
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $4d76b3bac8f2b7c8$var$getDataLoader,
        maxAge: $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS
    });
    const $4d76b3bac8f2b7c8$export$bc2de1c42df30b10 = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, (0, parcelRequire("2YP9W")).useResource)($4d76b3bac8f2b7c8$export$d6f4f0483916919f);
        (0, $5uXOq.useEffect)(()=>{
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            error,
            refresh
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: data,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    };
});
const $3b4b6bf0bbdfa955$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';
parcelRegister("1M51R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("3rvO2")
    ]).then(()=>parcelRequire('btHFe'));
});
parcelRegister("cAofY", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskContextResource", ()=>$9c517de0cdc23225$export$5eaaf465969a9171);
    var $dK8AG;
    var $2M1hQ;
    const $9c517de0cdc23225$var$getDataLoader = ()=>(parcelRequire("jxdf6"));
    const $9c517de0cdc23225$export$5eaaf465969a9171 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $4595635dbd9fca21$export$ac01662d5287bc5c),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrIdFromMatchAndQuery)({
                match: match,
                query: query
            }),
        getDataLoader: $9c517de0cdc23225$var$getDataLoader,
        maxAge: Infinity
    });
});
const $4595635dbd9fca21$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';
parcelRegister("jxdf6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iNITq").then(()=>parcelRequire('g4PUK'));
});
parcelRegister("eUvlM", function(module, exports) {
    $parcel$export(module.exports, "servicedeskPracticesResource", ()=>$9479f477b801290f$export$2ae319305481e7de);
    $parcel$export(module.exports, "useWorkCategoriesQueueSupported", ()=>$9479f477b801290f$export$a86ac771006f14b3);
    $parcel$export(module.exports, "useWorkCategoriesAllSupported", ()=>$9479f477b801290f$export$fe081b1a59d3c818);
    $parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", ()=>$9479f477b801290f$export$4d46346ef0bdc6b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $dK8AG;
    var $oCMSG;
    var $2M1hQ;
    var $2YP9W;
    const $9479f477b801290f$var$getDataLoader = ()=>(parcelRequire("bvW9G"));
    const $9479f477b801290f$var$ONE_DAY_IN_MILLIS = 86400000;
    const $9479f477b801290f$export$2ae319305481e7de = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $990f0449915d93bf$export$45919c8f50bb1db5),
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $9479f477b801290f$var$getDataLoader,
        maxAge: $9479f477b801290f$var$ONE_DAY_IN_MILLIS
    });
    const $9479f477b801290f$var$queuesOrder = [
        ...(0, (0, parcelRequire("oCMSG")).WORK_CATEGORIES_QUEUE_SUPPORTED)
    ];
    const $9479f477b801290f$var$workCategoryOrder = [
        ...$9479f477b801290f$var$queuesOrder,
        (0, (0, parcelRequire("oCMSG")).DEVELOPER_ESCALATION)
    ];
    const $9479f477b801290f$var$transformItsmPracticesList = (data)=>{
        if (!data?.practices) return null;
        return $9479f477b801290f$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
    };
    const $9479f477b801290f$var$transformServiceDeskPracticesList = (data)=>{
        if (!data?.practices) return null;
        return $9479f477b801290f$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
    };
    const $9479f477b801290f$export$a86ac771006f14b3 = ()=>{
        const { data: data, loading: loading, ...resource } = (0, (0, parcelRequire("2YP9W")).useResource)($9479f477b801290f$export$2ae319305481e7de);
        const error = resource.error;
        return (0, $5uXOq.useMemo)(()=>({
                data: $9479f477b801290f$var$transformItsmPracticesList(data),
                loading: loading,
                error: error
            }), [
            data,
            error,
            loading
        ]);
    };
    const $9479f477b801290f$export$fe081b1a59d3c818 = ()=>{
        const { data: data, loading: loading, ...resource } = (0, (0, parcelRequire("2YP9W")).useResource)($9479f477b801290f$export$2ae319305481e7de);
        const error = resource.error;
        return (0, $5uXOq.useMemo)(()=>({
                data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
                loading: loading,
                error: error
            }), [
            data,
            error,
            loading
        ]);
    };
    const $9479f477b801290f$export$4d46346ef0bdc6b9 = ()=>{
        const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, (0, parcelRequire("2YP9W")).useResource)($9479f477b801290f$export$2ae319305481e7de);
        const error = resource.error;
        (0, $5uXOq.useEffect)(()=>{
            if (!loading && !data && !error) refreshPractices();
        }, [
            data,
            error,
            loading,
            refreshPractices
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
                loading: loading,
                error: error
            }), [
            data,
            error,
            loading
        ]);
    };
});
parcelRegister("oCMSG", function(module, exports) {
    $parcel$export(module.exports, "CHANGES", ()=>$4f9c4406e75c8aa5$export$8598196f74460271);
    $parcel$export(module.exports, "INCIDENTS", ()=>$4f9c4406e75c8aa5$export$a50b49a533b5f7bc);
    $parcel$export(module.exports, "PROBLEMS", ()=>$4f9c4406e75c8aa5$export$ceba70db1edb1def);
    $parcel$export(module.exports, "SERVICE_REQUEST", ()=>$4f9c4406e75c8aa5$export$3d1cda9bd50505e8);
    $parcel$export(module.exports, "POST_INCIDENT_REVIEWS", ()=>$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f);
    $parcel$export(module.exports, "DEVELOPER_ESCALATION", ()=>$4f9c4406e75c8aa5$export$81e62964cc725098);
    $parcel$export(module.exports, "NO_CATEGORY", ()=>$4f9c4406e75c8aa5$export$485b1216c42d8d4);
    $parcel$export(module.exports, "NO_PRACTICE", ()=>$4f9c4406e75c8aa5$export$52bf3f16b7812704);
    $parcel$export(module.exports, "SHORT_FORM_CHANGES", ()=>$4f9c4406e75c8aa5$export$a50185c8e9fb007e);
    $parcel$export(module.exports, "SHORT_FORM_INCIDENTS", ()=>$4f9c4406e75c8aa5$export$a54a30a3c3cce634);
    $parcel$export(module.exports, "SHORT_FORM_PROBLEMS", ()=>$4f9c4406e75c8aa5$export$354f3a4c6ac0c903);
    $parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", ()=>$4f9c4406e75c8aa5$export$335d3ac0c367f03f);
    $parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", ()=>$4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f);
    $parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", ()=>$4f9c4406e75c8aa5$export$cb41b99ca54e6bd);
    $parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED", ()=>$4f9c4406e75c8aa5$export$a2b1f8f055150f02);
    $parcel$export(module.exports, "ItsmPracticeToShortForm", ()=>$4f9c4406e75c8aa5$export$56c57f7ad650c45c);
    $parcel$export(module.exports, "PRACTICE_LABEL_MAP", ()=>$4f9c4406e75c8aa5$export$fbf0dfd01228e38d);
    $parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", ()=>$4f9c4406e75c8aa5$export$45ba5f49e9509c4d);
    $parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS", ()=>$4f9c4406e75c8aa5$export$45952424a7f29b99);
    $parcel$export(module.exports, "CHANGES_JQL_NAME", ()=>$4f9c4406e75c8aa5$export$6c24c440228eac9c);
    $parcel$export(module.exports, "INCIDENTS_JQL_NAME", ()=>$4f9c4406e75c8aa5$export$5b65d27ec2d28d18);
    $parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", ()=>$4f9c4406e75c8aa5$export$3f757c5e00588ffd);
    $parcel$export(module.exports, "practiceKeyJqlNameMapping", ()=>$4f9c4406e75c8aa5$export$b78213db77524b5b);
    var $7c0in;
    var $kVZSN;
    const $4f9c4406e75c8aa5$export$8598196f74460271 = 'change-management';
    const $4f9c4406e75c8aa5$export$a50b49a533b5f7bc = 'incident-management';
    const $4f9c4406e75c8aa5$export$ceba70db1edb1def = 'problem-management';
    const $4f9c4406e75c8aa5$export$3d1cda9bd50505e8 = 'service-request';
    const $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f = 'post-incident-review';
    const $4f9c4406e75c8aa5$export$81e62964cc725098 = 'developer-escalation';
    const $4f9c4406e75c8aa5$export$485b1216c42d8d4 = 'no-category';
    const $4f9c4406e75c8aa5$export$f929a394dd190451 = 'no-category-new';
    const $4f9c4406e75c8aa5$export$52bf3f16b7812704 = 'no-practice';
    const $4f9c4406e75c8aa5$export$a50185c8e9fb007e = 'changes';
    const $4f9c4406e75c8aa5$export$a54a30a3c3cce634 = 'incidents';
    const $4f9c4406e75c8aa5$export$354f3a4c6ac0c903 = 'problems';
    const $4f9c4406e75c8aa5$export$335d3ac0c367f03f = 'service-requests';
    const $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
    const $4f9c4406e75c8aa5$export$cb41b99ca54e6bd = 'developer-escalations';
    const $4f9c4406e75c8aa5$export$a613d808168c7b25 = [
        $4f9c4406e75c8aa5$export$8598196f74460271,
        $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
        $4f9c4406e75c8aa5$export$ceba70db1edb1def,
        $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
        $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f,
        $4f9c4406e75c8aa5$export$81e62964cc725098
    ];
    const $4f9c4406e75c8aa5$export$a2b1f8f055150f02 = [
        $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
        $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
        $4f9c4406e75c8aa5$export$ceba70db1edb1def,
        $4f9c4406e75c8aa5$export$8598196f74460271,
        $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f
    ];
    const $4f9c4406e75c8aa5$export$5a9122a4028fb8ef = [
        ...$4f9c4406e75c8aa5$export$a2b1f8f055150f02,
        $4f9c4406e75c8aa5$export$485b1216c42d8d4
    ];
    const $4f9c4406e75c8aa5$export$f1b813cd23817ade = [
        $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
        $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
        $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
        $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
        $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
        $4f9c4406e75c8aa5$export$cb41b99ca54e6bd
    ];
    const $4f9c4406e75c8aa5$export$56c57f7ad650c45c = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
        [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: $4f9c4406e75c8aa5$export$f929a394dd190451
    };
    const $4f9c4406e75c8aa5$export$fbf0dfd01228e38d = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, (0, parcelRequire("kVZSN")).default).changes,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, (0, parcelRequire("kVZSN")).default).serviceRequests,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, (0, parcelRequire("kVZSN")).default).problems,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, (0, parcelRequire("kVZSN")).default).incidents,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, (0, parcelRequire("kVZSN")).default).postIncidentReviews,
        [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, (0, parcelRequire("kVZSN")).default).queues,
        [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, (0, parcelRequire("kVZSN")).default).developerEscalation,
        [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, (0, parcelRequire("kVZSN")).default).noCategory
    };
    const $4f9c4406e75c8aa5$export$45ba5f49e9509c4d = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, (0, parcelRequire("kVZSN")).default).changesLower,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, (0, parcelRequire("kVZSN")).default).serviceRequestsLower,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, (0, parcelRequire("kVZSN")).default).problemsLower,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, (0, parcelRequire("kVZSN")).default).incidentsLower,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, (0, parcelRequire("kVZSN")).default).postIncidentReviewsLower,
        [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, (0, parcelRequire("kVZSN")).default).queuesLower,
        [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, (0, parcelRequire("kVZSN")).default).developerEscalationLower,
        [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, (0, parcelRequire("kVZSN")).default).noCategoryLower
    };
    const $4f9c4406e75c8aa5$export$45952424a7f29b99 = (0, (0, parcelRequire("7c0in")).getTypedKeys)($4f9c4406e75c8aa5$export$fbf0dfd01228e38d).reduce((acc, labelMapKey)=>{
        const queueKey = $4f9c4406e75c8aa5$export$a2b1f8f055150f02.find((key)=>key === labelMapKey);
        if (queueKey) acc[queueKey] = $4f9c4406e75c8aa5$export$fbf0dfd01228e38d[labelMapKey];
        return acc;
    }, {});
    const $4f9c4406e75c8aa5$export$6c24c440228eac9c = 'Changes';
    const $4f9c4406e75c8aa5$export$5b65d27ec2d28d18 = 'Incidents';
    const $4f9c4406e75c8aa5$export$51618dc8334072b = 'Problems';
    const $4f9c4406e75c8aa5$export$a34586940ac9c374 = 'Service requests';
    const $4f9c4406e75c8aa5$export$5497b62b513b7853 = 'Post-incident reviews';
    const $4f9c4406e75c8aa5$export$3f757c5e00588ffd = 'Developer escalation';
    const $4f9c4406e75c8aa5$export$b78213db77524b5b = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$6c24c440228eac9c,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$5b65d27ec2d28d18,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$export$51618dc8334072b,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$export$a34586940ac9c374,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$export$5497b62b513b7853,
        [$4f9c4406e75c8aa5$export$81e62964cc725098]: $4f9c4406e75c8aa5$export$3f757c5e00588ffd
    };
});
parcelRegister("7c0in", function(module, exports) {
    $parcel$export(module.exports, "hasProp", ()=>$2dc9189f096b533d$export$dd642ef726dcde21);
    $parcel$export(module.exports, "getTypedKeys", ()=>$2dc9189f096b533d$export$5206d47972fefe20);
    const $2dc9189f096b533d$export$dd642ef726dcde21 = (data, prop)=>prop in data;
    const $2dc9189f096b533d$export$5206d47972fefe20 = (obj)=>{
        return Object.keys(obj);
    };
});
parcelRegister("kVZSN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d218b9a030da8fd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5d218b9a030da8fd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        queues: {
            "id": "work-category.common.queues",
            "defaultMessage": "Queues"
        },
        serviceRequests: {
            "id": "work-category.common.service-requests",
            "defaultMessage": "Service requests"
        },
        incidents: {
            "id": "work-category.common.incidents",
            "defaultMessage": "Incidents"
        },
        changes: {
            "id": "work-category.common.changes",
            "defaultMessage": "Changes"
        },
        problems: {
            "id": "work-category.common.problems",
            "defaultMessage": "Problems"
        },
        postIncidentReviews: {
            "id": "work-category.common.post-incident-reviews",
            "defaultMessage": "Post-incident reviews"
        },
        noCategory: {
            "id": "work-category.common.no-category",
            "defaultMessage": "General"
        },
        queuesLower: {
            "id": "work-category.common.queues-lower",
            "defaultMessage": "queues"
        },
        serviceRequestsLower: {
            "id": "work-category.common.service-requests-lower",
            "defaultMessage": "service requests"
        },
        incidentsLower: {
            "id": "work-category.common.incidents-lower",
            "defaultMessage": "incidents"
        },
        changesLower: {
            "id": "work-category.common.changes-lower",
            "defaultMessage": "changes"
        },
        problemsLower: {
            "id": "work-category.common.problems-lower",
            "defaultMessage": "problems"
        },
        postIncidentReviewsLower: {
            "id": "work-category.common.post-incident-reviews-lower",
            "defaultMessage": "post-incident reviews"
        },
        noCategoryLower: {
            "id": "work-category.common.no-category-lower",
            "defaultMessage": "general"
        },
        developerEscalation: {
            "id": "work-category.common.developer-escalation",
            "defaultMessage": "Developer escalations"
        },
        developerEscalationLower: {
            "id": "work-category.common.developer-escalation-lower",
            "defaultMessage": "developer escalations"
        }
    });
});
const $990f0449915d93bf$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';
parcelRegister("bvW9G", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jhLKO").then(()=>parcelRequire('8khb6'));
});
parcelRegister("lbaDt", function(module, exports) {
    $parcel$export(module.exports, "requiredProjectProperties", ()=>$3477ceb4f9b98b2e$export$fbeae45a65f4a5a6);
    $parcel$export(module.exports, "requiredFrontendProperties", ()=>$3477ceb4f9b98b2e$export$47241956725e3029);
    var $9XE6b = parcelRequire("9XE6b");
    var $1nb22;
    var $2M1hQ;
    var $13HHi;
    const $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("gssgh"));
    const $3477ceb4f9b98b2e$var$getKey = ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0];
    const $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("13HHi")).RESOURCE_TYPE_SERVICEDESK_REQUIRED_PROJECT_PROPERTIES),
        getKey: $3477ceb4f9b98b2e$var$getKey,
        getDataLoader: $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader
    });
    const $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("fTSMy"));
    const $3477ceb4f9b98b2e$export$47241956725e3029 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("13HHi")).RESOURCE_TYPE_SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES),
        getKey: $3477ceb4f9b98b2e$var$getKey,
        getDataLoader: $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader,
        maxAge: (0, (0, parcelRequire("13HHi")).ONE_DAY_IN_MILLIS)
    });
});
parcelRegister("13HHi", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_REQUIRED_PROJECT_PROPERTIES", ()=>$e7877c2ea997c7d8$export$54b53cba12671494);
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES", ()=>$e7877c2ea997c7d8$export$7d9318d6cfb0a4df);
    $parcel$export(module.exports, "ONE_DAY_IN_MILLIS", ()=>$e7877c2ea997c7d8$export$5a00268156ea5027);
    const $e7877c2ea997c7d8$export$54b53cba12671494 = 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES';
    const $e7877c2ea997c7d8$export$7d9318d6cfb0a4df = 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES';
    const $e7877c2ea997c7d8$export$5a00268156ea5027 = 86400000;
});
parcelRegister("gssgh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7aPU6").then(()=>parcelRequire('d4USv'));
});
parcelRegister("fTSMy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4Lrpj").then(()=>parcelRequire('7UDgf'));
});
parcelRegister("2cxgG", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentOnboardingResource", ()=>$e9d51fb7135f5412$export$d39827c053fda3aa);
    var $ao2h1;
    var $2j6fy;
    const $e9d51fb7135f5412$export$d39827c053fda3aa = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
        isBrowserOnly: true,
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("2j6fy")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    key: match.params.projectKey || ''
                }
            })
    });
});
parcelRegister("2j6fy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45b605658e5ce20d$export$2e2bcd8739ae039);
    var $7oHmH;
    const $45b605658e5ce20d$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "f9088e152f36ba09b78f1e067be176d1d2e7e1bab920efd3620300fc8bf9722e",
            "metadata": {},
            "name": "mainVirtualAgentSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $45b605658e5ce20d$export$2e2bcd8739ae039 = $45b605658e5ce20d$var$node;
});
parcelRegister("7oHmH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f0ef421b1798a33$export$2e2bcd8739ae039);
    var $4R6GH;
    var $3f0ef421b1798a33$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('require_ai_enabled_for_jsm_virtual_agent');
        }
    };
});
parcelRegister("6sNnq", function(module, exports) {
    $parcel$export(module.exports, "featuresResource", ()=>$d0a02e466fb63798$export$16f81cc9da2c6c47);
    var $9XE6b = parcelRequire("9XE6b");
    var $1nb22;
    var $2M1hQ;
    const $d0a02e466fb63798$var$getDataLoader = ()=>(parcelRequire("1WW6q"));
    const $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS = 86400000;
    const $d0a02e466fb63798$export$16f81cc9da2c6c47 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $68b2e6d16c6e9952$export$3441b129810f29ed),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
        getDataLoader: $d0a02e466fb63798$var$getDataLoader,
        maxAge: $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS
    });
});
const $68b2e6d16c6e9952$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';
parcelRegister("1WW6q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("aOISr")
    ]).then(()=>parcelRequire('frQmB'));
});
parcelRegister("gRzZD", function(module, exports) {
    $parcel$export(module.exports, "workspaceResource", ()=>$d68afc54033ea939$export$2f02c3f971168d17);
    var $2M1hQ;
    var $ahEft;
    const $d68afc54033ea939$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
    const $d68afc54033ea939$export$2f02c3f971168d17 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $d68afc54033ea939$export$9b3a4d71d46e5ee7,
        getKey: ()=>'state',
        getData: async (_, routerContext)=>{
            const workspaceId = await (0, (0, parcelRequire("ahEft")).default)(_, routerContext);
            return workspaceId;
        },
        maxAge: Infinity
    });
});
parcelRegister("ahEft", function(module, exports) {
    $parcel$export(module.exports, "isPremiumInstance", ()=>$b8bed038f2dce149$export$abb609d3bcbb74f6);
    $parcel$export(module.exports, "isLicensedPremiumUser", ()=>$b8bed038f2dce149$export$d7b4c32773b1c643);
    $parcel$export(module.exports, "default", ()=>$b8bed038f2dce149$export$2e2bcd8739ae039);
    var $dJl1T;
    var $4VpwK;
    var $ktP1V;
    var $5Ny9E;
    var $ldyPw;
    const $b8bed038f2dce149$export$530f260cc76f04ff = (baseUrl)=>`${baseUrl}/rest/servicedesk/cmdb/latest/workspace`;
    const $b8bed038f2dce149$export$abb609d3bcbb74f6 = (tenantContext)=>{
        const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
        const isPremium = serviceDeskAppEdition === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
        return isPremium;
    };
    const $b8bed038f2dce149$export$d7b4c32773b1c643 = (tenantContext)=>{
        const { appPermissions: appPermissions } = tenantContext;
        const isPremium = $b8bed038f2dce149$export$abb609d3bcbb74f6(tenantContext);
        const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
        return isPremium && isLicensedUser;
    };
    const $b8bed038f2dce149$var$transformResponse = (response)=>{
        const ids = response.results ?? [];
        return ids.length ? (0, (0, parcelRequire("5Ny9E")).toWorkspaceId)(ids[0].id) : null;
    };
    const $b8bed038f2dce149$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        if ($b8bed038f2dce149$export$d7b4c32773b1c643(tenantContext) === false || !(0, (0, parcelRequire("ktP1V")).isCMDBEnabledInEnvironment)()) return null;
        return (0, (0, parcelRequire("4VpwK")).performCmdbGetRequest)($b8bed038f2dce149$export$530f260cc76f04ff(baseUrl)).then($b8bed038f2dce149$var$transformResponse).catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
            return null;
        });
    };
    var $b8bed038f2dce149$export$2e2bcd8739ae039 = $b8bed038f2dce149$export$e1d718dfe6dad973;
});
parcelRegister("4VpwK", function(module, exports) {
    $parcel$export(module.exports, "performCmdbGetRequest", ()=>$270bf98960acb19c$export$a252413f43ec7247);
    $parcel$export(module.exports, "performCmdbPostRequest", ()=>$270bf98960acb19c$export$d68a9f67166d25a2);
    $parcel$export(module.exports, "performCmdbPutRequest", ()=>$270bf98960acb19c$export$326b7407f501f98b);
    $parcel$export(module.exports, "performCmdbDeleteRequest", ()=>$270bf98960acb19c$export$b198eb14f22c12e6);
    var $aDvGo;
    var $4R6GH;
    var $eusud;
    const $270bf98960acb19c$export$d5e211a0106aa636 = {
        'X-Request-Source': 'cmdb-frontend'
    };
    const $270bf98960acb19c$export$a252413f43ec7247 = (url, options)=>(0, (0, parcelRequire("eusud")).performGetRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(options));
    const $270bf98960acb19c$export$d68a9f67166d25a2 = (url, options)=>(0, (0, parcelRequire("eusud")).performPostRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(options));
    const $270bf98960acb19c$export$326b7407f501f98b = (url, options)=>(0, (0, parcelRequire("eusud")).performPutRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(options));
    const $270bf98960acb19c$export$b198eb14f22c12e6 = (url, options)=>(0, (0, parcelRequire("eusud")).performDeleteRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(options));
    const $270bf98960acb19c$export$235b7fc70b9fc359 = (options)=>(0, (0, parcelRequire("4R6GH")).fg)('fly-2529-cmdb-client-send-request-source-header') ? {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options,
            headers: {
                ...(0, (0, parcelRequire("aDvGo")).default).headers,
                ...options?.headers,
                ...$270bf98960acb19c$export$d5e211a0106aa636
            }
        } : options;
});
parcelRegister("ktP1V", function(module, exports) {
    $parcel$export(module.exports, "isCMDBEnabledInEnvironment", ()=>$84a32a7226f836c4$export$6dbfb62369f79a64);
    var $aIZdc;
    const $84a32a7226f836c4$export$6dbfb62369f79a64 = ()=>!(0, (0, parcelRequire("aIZdc")).isFedRamp)();
});
parcelRegister("5Ny9E", function(module, exports) {
    $parcel$export(module.exports, "toSchemaId", ()=>$a330a4171d28d64c$export$d577b7f3b832f656);
    $parcel$export(module.exports, "toCmdbObjectId", ()=>$a330a4171d28d64c$export$1ba342595bc7be13);
    $parcel$export(module.exports, "toCmdbObjectTypeId", ()=>$a330a4171d28d64c$export$b46e25afa2bab6a);
    $parcel$export(module.exports, "toObjectCommentId", ()=>$a330a4171d28d64c$export$ece2917434bb0a8c);
    $parcel$export(module.exports, "toWorkspaceId", ()=>$a330a4171d28d64c$export$d002b8d7821b6b59);
    $parcel$export(module.exports, "toObjectTypeAttributeId", ()=>$a330a4171d28d64c$export$cfd92c18cee8add7);
    const $a330a4171d28d64c$export$d577b7f3b832f656 = (id)=>id;
    const $a330a4171d28d64c$export$1ba342595bc7be13 = (id)=>id;
    const $a330a4171d28d64c$export$b46e25afa2bab6a = (id)=>id;
    const $a330a4171d28d64c$export$ece2917434bb0a8c = (id)=>id;
    const $a330a4171d28d64c$export$d002b8d7821b6b59 = (id)=>id;
    const $a330a4171d28d64c$export$cfd92c18cee8add7 = (id)=>id;
});
parcelRegister("dwmMO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6lBjo").then(()=>parcelRequire('2GYK9'));
});
parcelRegister("1OvmD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("p91SI").then(()=>parcelRequire('6cT2s'));
});
parcelRegister("8o619", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7t741").then(()=>parcelRequire('bjmK5'));
});
parcelRegister("gh1hi", function(module, exports) {
    $parcel$export(module.exports, "dashboardConfigAndWRMResource", ()=>$ca62b878c99c7128$export$2853c0e656e89346);
    $parcel$export(module.exports, "useDashboardResource", ()=>$ca62b878c99c7128$export$e5e5b3f462d6a4cb);
    $parcel$export(module.exports, "useMultiDashboardsResource", ()=>$ca62b878c99c7128$export$6a46406b05d8d13c);
    $parcel$export(module.exports, "dashboardAMDModulesResource", ()=>$ca62b878c99c7128$export$ef3fa55626812fa4);
    $parcel$export(module.exports, "useDashboardAMDModulesResource", ()=>$ca62b878c99c7128$export$efe0eb9a44e08d38);
    $parcel$export(module.exports, "dashboardReactGadgetsResource", ()=>$ca62b878c99c7128$export$39804ce8cc42cd04);
    $parcel$export(module.exports, "useDashboardReactGadgetsResource", ()=>$ca62b878c99c7128$export$31b430e01a1caab5);
    $parcel$export(module.exports, "dashboardForgeResource", ()=>$ca62b878c99c7128$export$4e0719e53da01e93);
    $parcel$export(module.exports, "gadgetDirectoryResource", ()=>$ca62b878c99c7128$export$36c9632be21fbb06);
    $parcel$export(module.exports, "useGadgetDirectoryResource", ()=>$ca62b878c99c7128$export$27f4c12e781b4572);
    $parcel$export(module.exports, "useDashboardForgeResource", ()=>$ca62b878c99c7128$export$75ca1b431898fd09);
    var $4R6GH;
    var $k2DRb;
    var $5vSAE;
    var $iVaKa;
    var $2M1hQ;
    var $2YP9W;
    var $3Yd87;
    var $abozY;
    var $04Brv;
    var $3cb5I;
    var $aVFmC;
    var $3Zhqx;
    var $8oOn8;
    const $ca62b878c99c7128$export$2853c0e656e89346 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16),
        getKey: (0, parcelRequire("abozY")).getKey,
        getData: (0, (0, parcelRequire("3cb5I")).default),
        maxAge: Infinity
    });
    const $ca62b878c99c7128$var$extractFirstPromise = (promise)=>promise ? promise.then((configs)=>configs && configs[0]) : null;
    const $ca62b878c99c7128$export$e5e5b3f462d6a4cb = ()=>{
        const resourceResponse = $ca62b878c99c7128$export$6a46406b05d8d13c();
        const { loading: loading, error: error, data: data, promise: promiseOfMultiConfigs, ...rest } = resourceResponse;
        const extractFirstUpdate = (getNewData)=>resourceResponse.update(([a])=>[
                    getNewData(a)
                ]);
        if (loading) return {
            ...rest,
            error: null,
            data: null,
            promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
            loading: true,
            update: extractFirstUpdate
        };
        if (error) return {
            ...rest,
            error: error,
            data: null,
            promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
            loading: false,
            update: extractFirstUpdate
        };
        if (data && !error) return {
            ...rest,
            loading: false,
            update: extractFirstUpdate,
            data: data[0],
            error: null,
            promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs)
        };
        return {
            ...rest,
            loading: false,
            error: error,
            data: null,
            promise: null,
            update: extractFirstUpdate
        };
    };
    const $ca62b878c99c7128$export$6a46406b05d8d13c = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($ca62b878c99c7128$export$2853c0e656e89346);
    const $ca62b878c99c7128$export$ef3fa55626812fa4 = (0, (0, parcelRequire("3Yd87")).createDependentResource)({
        type: (0, $e03099b7bef7f4cd$export$e239393fd4e2bc85),
        getKey: (0, parcelRequire("abozY")).getKey,
        depends: [
            (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
        ],
        mapToSharedValue: (0, (0, parcelRequire("3Yd87")).withEitherDataOrError)((data)=>{
            const { gadgets: gadgets, preloadedModuleNames: preloadedModuleNames } = data.reduce((prev, curr)=>({
                    gadgets: prev.gadgets.concat(curr.gadgets),
                    preloadedModuleNames: prev.preloadedModuleNames.concat(curr.preloadedModuleNames)
                }), {
                gadgets: [],
                preloadedModuleNames: []
            });
            const moduleNames = (0, (0, parcelRequire("8oOn8")).gadgetsToUniqueSortedAmdModules)(gadgets);
            const isPreloaded = moduleNames.every((name)=>preloadedModuleNames.includes(name));
            return {
                moduleNames: moduleNames,
                isPreloaded: isPreloaded
            };
        }, (x)=>x),
        shouldUpdate: ({ sharedValue: a, amdModules: amdModules }, b)=>(0, (0, parcelRequire("3Yd87")).withEitherDataOrError)((prev, next)=>next.moduleNames.length > prev.moduleNames.length || next.moduleNames.some((name)=>amdModules?.[name] == null), ()=>true)(a, b),
        getData: (0, (0, parcelRequire("04Brv")).default),
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $ca62b878c99c7128$export$efe0eb9a44e08d38 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($ca62b878c99c7128$export$ef3fa55626812fa4);
    const $ca62b878c99c7128$export$39804ce8cc42cd04 = (0, (0, parcelRequire("3Yd87")).createDependentResource)({
        type: (0, $e03099b7bef7f4cd$export$9e5db01432b13b67),
        getKey: (0, parcelRequire("abozY")).getKey,
        depends: [
            (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
        ],
        mapToSharedValue: (0, (0, parcelRequire("3Yd87")).withEitherDataOrError)((data)=>{
            const gadgets = data.flatMap((dashboard)=>dashboard.gadgets);
            return {
                reactGadgets: (0, (0, parcelRequire("8oOn8")).gadgetsToSortedReactGadgets)(gadgets)
            };
        }, (x)=>x),
        shouldUpdate: ({ sharedValue: a, reactGadgetsState: reactGadgetsState }, b)=>(0, (0, parcelRequire("3Yd87")).withEitherDataOrError)((prev, next)=>JSON.stringify(next.reactGadgets) !== JSON.stringify(prev.reactGadgets) || reactGadgetsState != null && Object.values(reactGadgetsState).some((v)=>!v), ()=>true)(a, b),
        getData: (0, (0, parcelRequire("3Zhqx")).default),
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $ca62b878c99c7128$export$31b430e01a1caab5 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($ca62b878c99c7128$export$39804ce8cc42cd04);
    const $ca62b878c99c7128$export$4e0719e53da01e93 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $e03099b7bef7f4cd$export$bce41807cc929d0f),
        getKey: (0, parcelRequire("abozY")).getKey,
        getData: async (_, { tenantContext: { cloudId: cloudId, activationId: activationId, isAnonymous: isAnonymous, locale: locale } })=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')) {
                const modules = await (0, (0, parcelRequire("5vSAE")).fetchModules)({
                    cloudId: cloudId,
                    isAnonymous: isAnonymous,
                    types: [
                        (0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE),
                        (0, (0, parcelRequire("k2DRb")).DASHBOARD_BACKGROUND_SCRIPT_MODULE)
                    ],
                    context: {},
                    includeHidden: false,
                    source: (0, (0, parcelRequire("k2DRb")).SOURCE_ROUTER)
                });
                return {
                    gadgets: modules[0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE],
                    backgroundScripts: modules[0, (0, parcelRequire("k2DRb")).DASHBOARD_BACKGROUND_SCRIPT_MODULE]
                };
            }
            const contextIds = [
                `ari:cloud:jira:${cloudId}:workspace/${activationId}`
            ];
            const { extensions: extensions } = await (0, (0, parcelRequire("iVaKa")).default)(cloudId, [
                (0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE),
                (0, (0, parcelRequire("k2DRb")).DASHBOARD_BACKGROUND_SCRIPT_MODULE)
            ], null, undefined, (0, (0, parcelRequire("k2DRb")).SOURCE_ROUTER), contextIds, locale);
            return {
                gadgets: extensions.jiraDashboardGadget,
                backgroundScripts: extensions.jiraDashboardBackgroundScript
            };
        },
        maxAge: Infinity
    });
    const $ca62b878c99c7128$export$36c9632be21fbb06 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $e03099b7bef7f4cd$export$c07a25ebb6af1e84),
        getKey: ()=>'gadgetDirectoryItems',
        getData: (0, (0, parcelRequire("aVFmC")).default),
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $ca62b878c99c7128$export$27f4c12e781b4572 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($ca62b878c99c7128$export$36c9632be21fbb06);
    const $ca62b878c99c7128$export$75ca1b431898fd09 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($ca62b878c99c7128$export$4e0719e53da01e93);
});
parcelRegister("3Yd87", function(module, exports) {
    $parcel$export(module.exports, "withEitherDataOrError", ()=>$3e606a4e02c14aae$export$54e973088fdd59a1);
    $parcel$export(module.exports, "createDependentResource", ()=>$3e606a4e02c14aae$export$7f8dd41bdfd85a47);
    $parcel$export(module.exports, "SharedValueAggregateError", ()=>$3e606a4e02c14aae$export$36d5102d613df7c6);
    var $2M1hQ;
    var $htn2f;
    const $3e606a4e02c14aae$export$54e973088fdd59a1 = (dataFn, errorFn)=>(...args)=>{
            const invalidArgs = args.filter((v)=>v == null || v instanceof Error);
            return invalidArgs.length ? errorFn(invalidArgs[0]) : dataFn(...args);
        };
    const $3e606a4e02c14aae$export$fcdc85dfc621ec7a = (dependencies, type)=>{
        const { [type]: resourceSlice } = dependencies;
        if (!resourceSlice) throw new (0, (0, parcelRequire("htn2f")).ResourceDependencyError)(`Cannot decode dependency "${type}", it may be missing from resource depends field`);
        return resourceSlice.data;
    };
    const $3e606a4e02c14aae$export$bee6a631bfb54474 = (dependencies, type)=>{
        const { [type]: resourceSlice } = dependencies;
        if (!resourceSlice) throw new Error(`Cannot decode dependency: "${type}" must be included in the resource depends field`);
        const { loading: loading, data: data, promise: promise, error: error } = resourceSlice;
        return loading && promise ? promise.then((v)=>v, (e)=>data ?? e) : data ?? error;
    };
    const $3e606a4e02c14aae$export$7f8dd41bdfd85a47 = ({ type: type, depends: depends, mapToSharedValue: mapToSharedValue, shouldUpdate: shouldUpdate, getData: getData, ...rest })=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            ...rest,
            type: type,
            depends: [
                ...depends,
                type
            ],
            getData: (dataContext, storeContext)=>{
                const { dependencies: dependencies } = dataContext;
                const prevValue = $3e606a4e02c14aae$export$fcdc85dfc621ec7a(dependencies, type);
                const valuesOrPromises = depends.map((d)=>$3e606a4e02c14aae$export$bee6a631bfb54474(dependencies, d));
                const implementation = (depDataOrErrorOrNull)=>{
                    const newShared = mapToSharedValue(...depDataOrErrorOrNull);
                    return prevValue == null || prevValue instanceof Error || shouldUpdate(prevValue, newShared) ? getData(prevValue, newShared)(dataContext, storeContext) : prevValue;
                };
                return valuesOrPromises.some((v)=>v instanceof Promise) ? Promise.allSettled(valuesOrPromises).then((arr)=>arr.map((v)=>v.status === 'fulfilled' ? v.value : v.reason)).then(implementation) : implementation(valuesOrPromises);
            }
        });
    class $3e606a4e02c14aae$export$36d5102d613df7c6 extends Error {
        constructor({ name: name, isPrefetch: isPrefetch, sharedValue: sharedValue }){
            super(`${name} is missing dependency, prefetch [${isPrefetch}] sharedValue [${sharedValue}]`);
            this.skipSentry = true;
        }
    }
});
parcelRegister("abozY", function(module, exports) {
    $parcel$export(module.exports, "getKey", ()=>$707c98c2b1b4b40d$export$a47fb462a08de82f);
    var $65Ltd;
    var $JIPqS;
    const $707c98c2b1b4b40d$export$a47fb462a08de82f = ({ route: route, query: query, match: { params: params } })=>{
        if (route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT)) return 0, (0, parcelRequire("JIPqS")).SYSTEM_DASHBOARD_ID;
        if (route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD)) return query.dashboardId?.split(',')[0];
        return params.dashboardId?.replace('last-visited', 'lastVisited') ?? query.selectPageId ?? 'lastVisited';
    };
});
parcelRegister("JIPqS", function(module, exports) {
    $parcel$export(module.exports, "GADGET_DISPLAY", ()=>$6c7fd970bbaee123$export$d7e1dfcefcde2410);
    $parcel$export(module.exports, "MAXIMIZED_PARAM", ()=>$6c7fd970bbaee123$export$86eaa19ea940a4f5);
    $parcel$export(module.exports, "CONNECT_ITEM_AMD_MODULE", ()=>$6c7fd970bbaee123$export$a1baea8b97610fd);
    $parcel$export(module.exports, "WEB_RESOURCE_MAP", ()=>$6c7fd970bbaee123$export$c6d360a8456d120a);
    $parcel$export(module.exports, "PRELOADED_GADGET_DATA_KEY", ()=>$6c7fd970bbaee123$export$30b970d16c2f5e0a);
    $parcel$export(module.exports, "SYSTEM_DASHBOARD_ID", ()=>$6c7fd970bbaee123$export$50eac80bcbebc737);
    $parcel$export(module.exports, "DASHBOARD_HEADER_HEIGHT", ()=>$6c7fd970bbaee123$export$e11ffd0409aa6522);
    $parcel$export(module.exports, "FOOTER_MARGIN", ()=>$6c7fd970bbaee123$export$4d708f4c16ae3a73);
    $parcel$export(module.exports, "GADGET_LOCAL_STORAGE_NAME", ()=>$6c7fd970bbaee123$export$255117c9adec50a5);
    $parcel$export(module.exports, "DASHBOARD_LOCAL_STORAGE_KEY_NAME", ()=>$6c7fd970bbaee123$export$e281465c09f561d4);
    $parcel$export(module.exports, "GADGET_DEFAULT_HEIGHT", ()=>$6c7fd970bbaee123$export$46dd0168a7875b47);
    $parcel$export(module.exports, "COLOR_MAP", ()=>$6c7fd970bbaee123$export$1468aefba37090f9);
    $parcel$export(module.exports, "COLOR_NAME_MAP", ()=>$6c7fd970bbaee123$export$5d9e688e192a63ae);
    $parcel$export(module.exports, "COLOR_CHECKMARK_MAP", ()=>$6c7fd970bbaee123$export$6906a4beef307ac4);
    $parcel$export(module.exports, "MODAL_ID", ()=>$6c7fd970bbaee123$export$ebdd5a8e5b1c2de5);
    $parcel$export(module.exports, "LAYOUTS", ()=>$6c7fd970bbaee123$export$87e50aced9c52ebb);
    $parcel$export(module.exports, "GADGET_HEIGHT_UPDATE_WAIT_TIME", ()=>$6c7fd970bbaee123$export$b0234a47b1a4a515);
    $parcel$export(module.exports, "GADGET_DRAG_CONTAINER_HEIGHT", ()=>$6c7fd970bbaee123$export$9674cd14c20d1c89);
    $parcel$export(module.exports, "GADGET_METRICS_TYPE", ()=>$6c7fd970bbaee123$export$46b6c8eb53069613);
    $parcel$export(module.exports, "PAGE_READY_METRIC_KEY", ()=>$6c7fd970bbaee123$export$464d2a6bcb398791);
    $parcel$export(module.exports, "DELETE_DASHBOARD_EXPERIENCE", ()=>$6c7fd970bbaee123$export$4f74f1f13671c49d);
    $parcel$export(module.exports, "COPY_DASHBOARD_EXPERIENCE", ()=>$6c7fd970bbaee123$export$3853fce65645c557);
    $parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE", ()=>$6c7fd970bbaee123$export$c8c77659771c38b9);
    $parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD_EXPERIENCE", ()=>$6c7fd970bbaee123$export$707702c47e5b9648);
    $parcel$export(module.exports, "CREATE_DASHBOARD_EXPERIENCE", ()=>$6c7fd970bbaee123$export$efbab4efa7252143);
    $parcel$export(module.exports, "VIEW_DASHBOARD_EDITABLE_EXPERIENCE", ()=>$6c7fd970bbaee123$export$7b6f3ec1189de156);
    $parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EXPERIENCE", ()=>$6c7fd970bbaee123$export$f0e105144716a420);
    $parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EMBED_EXPERIENCE", ()=>$6c7fd970bbaee123$export$5ba84cd082269cd5);
    $parcel$export(module.exports, "VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE", ()=>$6c7fd970bbaee123$export$6c84c6099fed3c23);
    $parcel$export(module.exports, "ADD_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$3b17b4f7f722b1ae);
    $parcel$export(module.exports, "SAVE_AMD_GADGET_CONFIG_PREFERENCES", ()=>$6c7fd970bbaee123$export$c8900d7e874d42ca);
    $parcel$export(module.exports, "SAVE_FORGE_GADGET_CONFIG_PREFERENCES", ()=>$6c7fd970bbaee123$export$bac5a3e9d008da59);
    $parcel$export(module.exports, "SAVE_CUSTOM_GADGET_TITLE_PREFERENCES", ()=>$6c7fd970bbaee123$export$18b54b2c53cf6acd);
    $parcel$export(module.exports, "VIEW_WRM_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$a3d5b76ea0c8f4ca);
    $parcel$export(module.exports, "CHANGE_LAYOUT_EXPERIENCE", ()=>$6c7fd970bbaee123$export$7254246f25b4cbc8);
    $parcel$export(module.exports, "DELETE_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$40c4d345e57fce2d);
    $parcel$export(module.exports, "VIEW_REACT_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$43fb10a4d8374f1a);
    $parcel$export(module.exports, "DASHBOARD_VIEW_SOURCENAME", ()=>$6c7fd970bbaee123$export$2f961c74af6d8735);
    $parcel$export(module.exports, "DASHBOARD_VIEW_EMBED_SOURCENAME", ()=>$6c7fd970bbaee123$export$dab1096b356df1cc);
    $parcel$export(module.exports, "DASHBOARD_EDIT_SOURCENAME", ()=>$6c7fd970bbaee123$export$32f0edca4eebb9c7);
    $parcel$export(module.exports, "DASHBOARD_WALLBOARD_VIEW_SOURCENAME", ()=>$6c7fd970bbaee123$export$791f7067c41dc5b1);
    $parcel$export(module.exports, "SYSTEM_DASHBOARD_EDIT_SOURCENAME", ()=>$6c7fd970bbaee123$export$eba1a497984af3ae);
    $parcel$export(module.exports, "COPY_DASHBOARD", ()=>$6c7fd970bbaee123$export$3578044b625436f9);
    $parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH", ()=>$6c7fd970bbaee123$export$48bb59a846d62ea0);
    $parcel$export(module.exports, "DELETE_DASHBOARD", ()=>$6c7fd970bbaee123$export$e7dfbcf33cf2b19a);
    $parcel$export(module.exports, "DUPLICATE_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$fabf79b25b44377f);
    $parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD", ()=>$6c7fd970bbaee123$export$abba919f32a1a776);
    $parcel$export(module.exports, "GADGET_ERROR_TYPE", ()=>$6c7fd970bbaee123$export$768dad6811159849);
    $parcel$export(module.exports, "DASHBOARD_REFRESH_LOAD_BUFFER_MS", ()=>$6c7fd970bbaee123$export$ada294d471e7dfc3);
    $parcel$export(module.exports, "REFRESH_LABEL_UPDATE_INTERVAL", ()=>$6c7fd970bbaee123$export$f4280aaeba4d1d08);
    $parcel$export(module.exports, "CONNECT_GADGET_REFRESH_REQUEST_EVENT", ()=>$6c7fd970bbaee123$export$685171fdf5112bc4);
    $parcel$export(module.exports, "FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT", ()=>$6c7fd970bbaee123$export$4d8c12b9aaeac619);
    $parcel$export(module.exports, "ISSUE_SEARCH_DEFAULT_COLUMNS", ()=>$6c7fd970bbaee123$export$f07dac7b8de3bda);
    $parcel$export(module.exports, "DEPRECATED_GADGETS_MAP", ()=>$6c7fd970bbaee123$export$4ac59ce79d9e7591);
    $parcel$export(module.exports, "DEPRECATION_BANNER_V1", ()=>$6c7fd970bbaee123$export$b5d0f99a1924c478);
    var $gwIPs;
    var $cKw8Y;
    const $6c7fd970bbaee123$export$d7e1dfcefcde2410 = {
        MAXIMIZED: 'maximized',
        NORMAL: 'normal',
        HIDDEN: 'hidden'
    };
    const $6c7fd970bbaee123$export$86eaa19ea940a4f5 = 'maximized';
    const $6c7fd970bbaee123$export$a1baea8b97610fd = 'atlassian-connect/connect-dashboard-item';
    const $6c7fd970bbaee123$export$c6d360a8456d120a = {
        'jira-dashboard-items/assigned-to-me': 'com.atlassian.jira.gadgets:assigned-to-me-dashboard-item-resources',
        'jira-dashboard-items/filter-results': 'com.atlassian.jira.gadgets:filter-results-dashboard-item-resources',
        'jira-dashboard-items/createdvsresolved': 'com.atlassian.jira.gadgets:createdvsresolved-dashboard-item-resources',
        'jira-dashboard-items/favourite-filters': 'com.atlassian.jira.gadgets:favourite-filters-dashboard-item-resources',
        'jira-dashboard-items/in-progress': 'com.atlassian.jira.gadgets:in-progress-dashboard-item-resources',
        'jira-dashboard-items/stats': 'com.atlassian.jira.gadgets:stats-dashboard-item-resources',
        'jira-dashboard-items/watched': 'com.atlassian.jira.gadgets:watched-dashboard-item-resources',
        'jira-dashboard-items/labels': 'com.atlassian.jira.gadgets:labels-dashboard-item-resources',
        'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item-resources',
        'jira-dashboard-items/piechart': 'com.atlassian.jira.gadgets:piechart-dashboard-item-resources',
        'jira-dashboard-items/voted': 'com.atlassian.jira.gadgets:voted-dashboard-item-resources',
        'jira-dashboard-items/two-dimensional-stats': 'com.atlassian.jira.gadgets:two-dimensional-stats-dashboard-item-resources',
        'jira-dashboard-items/sprint-health': 'com.pyxis.greenhopper.jira:greenhopper-sprint-health-dashboard-item-resources',
        'jira-dashboard-items/sprint-days-remaining': 'com.pyxis.greenhopper.jira:greenhopper-days-remaining-dashboard-item-resources',
        'servicedesk/internal/dashboard-items/filter/filter-dashboard-item': 'com.atlassian.servicedesk.dashboard-items-plugin:spa-filter-dashboard-item-resources',
        'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'com.atlassian.servicedesk.servicedesk-reports-plugin:custom-report-dashboard-item-resources-spa',
        'jira-dashboard-items/projects': 'com.atlassian.jira.gadgets:projects-dashboard-item-resources',
        'jira-dashboard-items/issuescalendar': 'com.atlassian.jira.ext.calendar:issues-calendar-dashboard-item-resources',
        'jira-dashboard-items/activitystream': 'com.atlassian.streams.streams-jira-plugin:activitystream-dashboard-item-resources',
        'jira-dashboard-items/recently-created': 'com.atlassian.jira.gadgets:recently-created-chart-dashboard-item-resources',
        'jira-dashboard-items/resolution-time': 'com.atlassian.jira.gadgets:resolution-time-dashboard-item-resources',
        'jira-dashboard-items/timesince': 'com.atlassian.jira.gadgets:timesince-dashboard-item-resources',
        'jira-dashboard-items/spacer': 'com.atlassian.jira.gadgets:spacer-dashboard-item-resources',
        'jira-dashboard-items/sprint-burndown': 'com.pyxis.greenhopper.jira:greenhopper-sprint-burndown-dashboard-item-resources',
        'jira-dashboard-items/workload-pie-chart': 'com.atlassian.jira.gadgets:workload-pie-chart-dashboard-item-resources',
        'jira-dashboard-items/roadmap': 'com.atlassian.jira.gadgets:roadmap-dashboard-item-resources',
        'jira-dashboard-items/average-age-chart': 'com.atlassian.jira.gadgets:average-age-chart-dashboard-item-resources',
        'jira-dashboard-items/average-time-in-status-chart': 'com.atlassian.jira.gadgets:average-time-in-status-chart-dashboard-item-resources',
        'jira-dashboard-items/average-number-of-times-in-status-chart': 'com.atlassian.jira.gadgets:average-number-of-times-in-status-chart-dashboard-item-resources',
        'jira-dashboard-items/heat-map': 'com.atlassian.jira.gadgets:heat-map-dashboard-item-resources',
        'jira-dashboard-items/time-to-first-response': 'com.atlassian.jira.gadgets:time-to-first-response-dashboard-item-resources',
        'jira-dashboard-items/rapid-view': 'com.pyxis.greenhopper.jira:greenhopper-rapid-view-dashboard-item-resources',
        'jira-dashboard-items/version-report': 'com.pyxis.greenhopper.jira:greenhopper-version-report-dashboard-item-resources'
    };
    const $6c7fd970bbaee123$export$30b970d16c2f5e0a = 'DASHBOARD_GADGET_PRELOADED_DATA';
    const $6c7fd970bbaee123$export$50eac80bcbebc737 = '10000';
    const $6c7fd970bbaee123$export$e11ffd0409aa6522 = (0, (0, parcelRequire("gwIPs")).gridSize) * 10;
    const $6c7fd970bbaee123$export$4d708f4c16ae3a73 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $6c7fd970bbaee123$export$504bf5c8f7d402e9 = (0, (0, parcelRequire("gwIPs")).gridSize) * 3;
    const $6c7fd970bbaee123$export$255117c9adec50a5 = 'AG.congolmerate.cookie';
    const $6c7fd970bbaee123$export$e281465c09f561d4 = 'dashboard-data';
    const $6c7fd970bbaee123$export$46dd0168a7875b47 = 160;
    const $6c7fd970bbaee123$var$COLOR_BLUE = '#2684ff';
    const $6c7fd970bbaee123$var$COLOR_RED = '#ff5630';
    const $6c7fd970bbaee123$var$COLOR_YELLOW = '#ffab00';
    const $6c7fd970bbaee123$var$COLOR_GREEN = '#36b37e';
    const $6c7fd970bbaee123$var$COLOR_TEAL = '#00b8d9';
    const $6c7fd970bbaee123$var$COLOR_PURPLE = '#6554c0';
    const $6c7fd970bbaee123$var$COLOR_GRAY = '#97a0af';
    const $6c7fd970bbaee123$var$COLOR_WHITE = '#ffffff';
    const $6c7fd970bbaee123$export$1468aefba37090f9 = {
        color1: $6c7fd970bbaee123$var$COLOR_BLUE,
        color2: $6c7fd970bbaee123$var$COLOR_RED,
        color3: $6c7fd970bbaee123$var$COLOR_YELLOW,
        color4: $6c7fd970bbaee123$var$COLOR_GREEN,
        color5: $6c7fd970bbaee123$var$COLOR_TEAL,
        color6: $6c7fd970bbaee123$var$COLOR_PURPLE,
        color7: $6c7fd970bbaee123$var$COLOR_GRAY,
        color8: $6c7fd970bbaee123$var$COLOR_WHITE
    };
    const $6c7fd970bbaee123$export$5d9e688e192a63ae = {
        [$6c7fd970bbaee123$var$COLOR_BLUE]: (0, (0, parcelRequire("cKw8Y")).default).blue,
        [$6c7fd970bbaee123$var$COLOR_RED]: (0, (0, parcelRequire("cKw8Y")).default).red,
        [$6c7fd970bbaee123$var$COLOR_YELLOW]: (0, (0, parcelRequire("cKw8Y")).default).yellow,
        [$6c7fd970bbaee123$var$COLOR_GREEN]: (0, (0, parcelRequire("cKw8Y")).default).green,
        [$6c7fd970bbaee123$var$COLOR_TEAL]: (0, (0, parcelRequire("cKw8Y")).default).teal,
        [$6c7fd970bbaee123$var$COLOR_PURPLE]: (0, (0, parcelRequire("cKw8Y")).default).purple,
        [$6c7fd970bbaee123$var$COLOR_GRAY]: (0, (0, parcelRequire("cKw8Y")).default).gray,
        [$6c7fd970bbaee123$var$COLOR_WHITE]: (0, (0, parcelRequire("cKw8Y")).default).white
    };
    const $6c7fd970bbaee123$export$6906a4beef307ac4 = {
        color1: (0, $829f609a65d26a98$exports).N10,
        color2: (0, $829f609a65d26a98$exports).N10,
        color3: (0, $829f609a65d26a98$exports).N500,
        color4: (0, $829f609a65d26a98$exports).N10,
        color5: (0, $829f609a65d26a98$exports).N500,
        color6: (0, $829f609a65d26a98$exports).N10,
        color7: (0, $829f609a65d26a98$exports).N10,
        color8: (0, $829f609a65d26a98$exports).N500
    };
    const $6c7fd970bbaee123$export$ebdd5a8e5b1c2de5 = {
        EDIT_LAYOUT: 'edit-layout',
        DASHBOARD_COPY: 'dashboard-copy',
        AUTOMATIC_REFRESH: 'dashboard-automatic-refresh',
        DASHBOARD_RENAME_OR_SHARE: 'dashboard-rename-or-share',
        DASHBOARD_DELETE: 'dashboard-delete',
        CONFIGURE_WALLBOARD: 'configure-wallboard',
        DASHBOARD_CREATE: 'dashboard-create-on-dashboard-page'
    };
    const $6c7fd970bbaee123$export$87e50aced9c52ebb = [
        'A',
        'AA',
        'AAA',
        'BA',
        'AB'
    ];
    const $6c7fd970bbaee123$export$b0234a47b1a4a515 = 350;
    const $6c7fd970bbaee123$export$9674cd14c20d1c89 = 250;
    const $6c7fd970bbaee123$export$46b6c8eb53069613 = {
        REPORT: 'REPORT_GADGET_METRICS',
        TIMEOUT: 'TIMEOUT_GADGET_METRICS'
    };
    const $6c7fd970bbaee123$export$464d2a6bcb398791 = 'JIRA_SPA_PAGE_READY';
    const $6c7fd970bbaee123$export$4f74f1f13671c49d = 'delete-dashboard';
    const $6c7fd970bbaee123$export$3853fce65645c557 = 'copy-dashboard';
    const $6c7fd970bbaee123$export$c8c77659771c38b9 = 'dashboard-automatic-refresh';
    const $6c7fd970bbaee123$export$707702c47e5b9648 = 'rename-or-share-dashboard';
    const $6c7fd970bbaee123$export$efbab4efa7252143 = 'create-dashboard';
    const $6c7fd970bbaee123$export$7b6f3ec1189de156 = 'view-dashboard-editable';
    const $6c7fd970bbaee123$export$f0e105144716a420 = 'view-dashboard-readonly';
    const $6c7fd970bbaee123$export$5ba84cd082269cd5 = 'view-dashboard-readonly-embed';
    const $6c7fd970bbaee123$export$6c84c6099fed3c23 = 'view-dashboard-wallboard-readonly';
    const $6c7fd970bbaee123$export$3b17b4f7f722b1ae = 'add-gadget';
    const $6c7fd970bbaee123$export$c8900d7e874d42ca = 'save-amd-gadget-config';
    const $6c7fd970bbaee123$export$bac5a3e9d008da59 = 'save-forge-gadget-config';
    const $6c7fd970bbaee123$export$18b54b2c53cf6acd = 'save-custom-gadget-title-config';
    const $6c7fd970bbaee123$export$a3d5b76ea0c8f4ca = 'view-wrm-gadget';
    const $6c7fd970bbaee123$export$7254246f25b4cbc8 = 'change-layout';
    const $6c7fd970bbaee123$export$40c4d345e57fce2d = 'delete-gadget';
    const $6c7fd970bbaee123$export$43fb10a4d8374f1a = 'view-react-gadget';
    const $6c7fd970bbaee123$export$2f961c74af6d8735 = 'dashboardView';
    const $6c7fd970bbaee123$export$dab1096b356df1cc = 'dashboardViewEmbed';
    const $6c7fd970bbaee123$export$32f0edca4eebb9c7 = 'dashboardEdit';
    const $6c7fd970bbaee123$export$791f7067c41dc5b1 = 'dashboardWallboardView';
    const $6c7fd970bbaee123$export$eba1a497984af3ae = 'systemDashboardEdit';
    const $6c7fd970bbaee123$export$3578044b625436f9 = 'copyDashboard';
    const $6c7fd970bbaee123$export$48bb59a846d62ea0 = 'automaticRefresh';
    const $6c7fd970bbaee123$export$e7dfbcf33cf2b19a = 'deleteDashboard';
    const $6c7fd970bbaee123$export$fabf79b25b44377f = 'duplicateGadget';
    const $6c7fd970bbaee123$export$abba919f32a1a776 = 'renameOrShareDashboard';
    const $6c7fd970bbaee123$export$768dad6811159849 = {
        VIEW_ERROR: 'viewError',
        EDIT_ERROR: 'editError',
        CONFIG_ERROR: 'configError',
        NOT_SUPPORTED_ERROR: 'notSupportedError'
    };
    const $6c7fd970bbaee123$export$f8e04d62c0b5d07e = /^endeavour\.(spa|dashboard|gadget)\.[\w-]+$/;
    const $6c7fd970bbaee123$export$ada294d471e7dfc3 = 1000;
    const $6c7fd970bbaee123$export$f4280aaeba4d1d08 = 30000;
    const $6c7fd970bbaee123$export$685171fdf5112bc4 = 'jira_dashboard_item_refresh';
    const $6c7fd970bbaee123$export$4d8c12b9aaeac619 = 'JIRA_DASHBOARD_GADGET_REFRESH';
    const $6c7fd970bbaee123$export$f07dac7b8de3bda = [
        'issuetype',
        'issuekey',
        'summary',
        'priority'
    ];
    const $6c7fd970bbaee123$export$4ac59ce79d9e7591 = {
        'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item',
        'jira-dashboard-items/heat-map': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:heat-map-gadget/gadgets/heatmap-gadget.xml',
        'jira-dashboard-items/projects': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:project-gadget/gadgets/project-gadget.xml',
        'jira-dashboard-items/labels': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:labels-gadget/gadgets/labels-gadget.xml',
        'jira-dashboard-items/roadmap': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:road-map-gadget/gadgets/roadmap-gadget.xml'
    };
    const $6c7fd970bbaee123$export$b5d0f99a1924c478 = 'deprecatedGadgetBannerDismissedV1';
});
parcelRegister("gwIPs", function(module, exports) {
    $parcel$export(module.exports, "gridSize", ()=>$80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
    $parcel$export(module.exports, "borderRadius", ()=>$80d528dbc2b11cbc$export$7a57f79000377ca2);
    $parcel$export(module.exports, "fontSize", ()=>$80d528dbc2b11cbc$export$85e3c3ca0c6fb93);
    $parcel$export(module.exports, "fontFamily", ()=>$80d528dbc2b11cbc$export$a5975749f0374264);
    $parcel$export(module.exports, "codeFontFamily", ()=>$80d528dbc2b11cbc$export$356129969ee49c55);
    $parcel$export(module.exports, "contentHorizontalSpacing", ()=>$80d528dbc2b11cbc$export$22dec01f2c854397);
    $parcel$export(module.exports, "layers", ()=>$80d528dbc2b11cbc$export$7be255094ccdc533);
    $parcel$export(module.exports, "layout", ()=>$80d528dbc2b11cbc$export$b3219800bda33a1f);
    var $k5uoT;
    const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, (0, parcelRequire("k5uoT")).borderRadius)();
    const $80d528dbc2b11cbc$export$85e3c3ca0c6fb93 = (0, (0, parcelRequire("k5uoT")).fontSize)();
    const $80d528dbc2b11cbc$export$a5975749f0374264 = (0, (0, parcelRequire("k5uoT")).fontFamily)();
    const $80d528dbc2b11cbc$export$356129969ee49c55 = (0, (0, parcelRequire("k5uoT")).codeFontFamily)();
    const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
    const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
    const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
        banner: (0, (0, parcelRequire("k5uoT")).layers).navigation(),
        card: (0, (0, parcelRequire("k5uoT")).layers).card(),
        dialog: (0, (0, parcelRequire("k5uoT")).layers).dialog(),
        navigation: (0, (0, parcelRequire("k5uoT")).layers).navigation(),
        leftSidebar: (0, (0, parcelRequire("k5uoT")).layers).navigation() - 1,
        rightSidebar: (0, (0, parcelRequire("k5uoT")).layers).navigation() - 1,
        layer: (0, (0, parcelRequire("k5uoT")).layers).layer(),
        blanket: (0, (0, parcelRequire("k5uoT")).layers).blanket(),
        modal: (0, (0, parcelRequire("k5uoT")).layers).modal(),
        flag: (0, (0, parcelRequire("k5uoT")).layers).flag(),
        spotlight: (0, (0, parcelRequire("k5uoT")).layers).spotlight(),
        tooltip: (0, (0, parcelRequire("k5uoT")).layers).tooltip(),
        mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
    };
    const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
        issueIconSize: $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 * 2
    };
});
parcelRegister("cKw8Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81c05dd6e2dcad70$export$2e2bcd8739ae039);
    var $7VHMR;
    var $81c05dd6e2dcad70$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        blue: {
            "id": "dashboard-common.blue",
            "defaultMessage": "Blue"
        },
        red: {
            "id": "dashboard-common.red",
            "defaultMessage": "Red"
        },
        yellow: {
            "id": "dashboard-common.yellow",
            "defaultMessage": "Yellow"
        },
        green: {
            "id": "dashboard-common.green",
            "defaultMessage": "Green"
        },
        teal: {
            "id": "dashboard-common.teal",
            "defaultMessage": "Teal"
        },
        purple: {
            "id": "dashboard-common.purple",
            "defaultMessage": "Purple"
        },
        gray: {
            "id": "dashboard-common.gray",
            "defaultMessage": "Gray"
        },
        white: {
            "id": "dashboard-common.white",
            "defaultMessage": "White"
        }
    });
});
const $e03099b7bef7f4cd$export$ca03ff6cc792cc16 = 'DASHBOARD_CONFIG_AND_WRM';
const $e03099b7bef7f4cd$export$e239393fd4e2bc85 = 'DASHBOARD_AMD_MODULES';
const $e03099b7bef7f4cd$export$9e5db01432b13b67 = 'DASHBOARD_REACT_GADGETS';
const $e03099b7bef7f4cd$export$dd4bac16c565acb1 = 'DASHBOARD_FORGE_GADGETS';
const $e03099b7bef7f4cd$export$bce41807cc929d0f = 'DASHBOARD_FORGE';
const $e03099b7bef7f4cd$export$c07a25ebb6af1e84 = 'DASHBOARD_GADGET_DIRECTORY';
const $e03099b7bef7f4cd$export$58e1e8808435e4be = 'AVP_DASHBOARD';
parcelRegister("04Brv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff7f8eda58c85578$export$2e2bcd8739ae039);
    var $4su49;
    var $3Yd87;
    var $1IY2I;
    var $ff7f8eda58c85578$export$2e2bcd8739ae039 = (_maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch })=>{
            if (!sharedValue || sharedValue instanceof Error) throw new (0, (0, parcelRequire("3Yd87")).SharedValueAggregateError)({
                sharedValue: sharedValue,
                isPrefetch: isPrefetch,
                name: 'AMD modules resource'
            });
            return (async ()=>{
                const { moduleNames: moduleNames, isPreloaded: isPreloaded } = sharedValue;
                const maybePromiseAmdModules = isPreloaded || await (0, (0, parcelRequire("1IY2I")).loadAmdModules)((0, (0, parcelRequire("4su49")).asyncWrmRequire), moduleNames) ? (0, (0, parcelRequire("1IY2I")).evalAmdModules)(moduleNames) : null;
                const amdModules = maybePromiseAmdModules instanceof Promise ? await maybePromiseAmdModules : maybePromiseAmdModules;
                return {
                    sharedValue: sharedValue,
                    amdModules: amdModules
                };
            })();
        };
});
parcelRegister("4su49", function(module, exports) {
    $parcel$export(module.exports, "asyncWrmRequire", ()=>$ae90ef6541667ecb$export$1024fe099ca05f05);
    $parcel$export(module.exports, "asyncWrmRequireWithPrefetch", ()=>$ae90ef6541667ecb$export$3ca0de203efa570e);
    var $8JNtu;
    var $5Ik5Y;
    const $ae90ef6541667ecb$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, (0, parcelRequire("8JNtu")).wrmRequire)(resourcesToRequire);
    const $ae90ef6541667ecb$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, (0, parcelRequire("5Ik5Y")).wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);
});
parcelRegister("8JNtu", function(module, exports) {
    $parcel$export(module.exports, "wrmRequire", ()=>$17e2d7d864398bad$export$cc9d8f51375ef66a);
    var $fVOHM;
    var $fqWWz;
    const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR))=>(0, (0, parcelRequire("fVOHM")).loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
});
parcelRegister("fVOHM", function(module, exports) {
    $parcel$export(module.exports, "loadWrmResources", ()=>$0c0552c7bb135144$export$6cda16b6eff75f59);
    var $wRU6t;
    var $294PS;
    var $9B86Q;
    var $fqWWz;
    const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
        const isPrefetch = 'batchUrl' in options;
        let newWrmKeys = wrmKeys;
        try {
            const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
            const wrmRequireModule = await (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: name
            });
            const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
            newWrmKeys = (0, (0, parcelRequire("294PS")).prependSuperBatchDepsOnce)(wrmKeys);
            if (isPrefetch) return await new Promise((resolve, reject)=>wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
            return await new Promise((resolve, reject)=>wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        } catch (error) {
            if (shouldLogError) (0, (0, parcelRequire("fqWWz")).safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
                isSpa: __SPA__,
                wrmKeys: JSON.stringify(newWrmKeys),
                error: (0, (0, parcelRequire("wRU6t")).safeStringify)(error)
            });
            throw new Error('Unable to load wrm resource', {
                cause: error
            });
        }
    };
});
parcelRegister("wRU6t", function(module, exports) {
    $parcel$export(module.exports, "safeStringify", ()=>$7e2bd894031d4476$export$56831a8b9cb27763);
    const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
        if (!object) return '';
        if (object instanceof Error) return object.stack || object.message;
        return JSON.stringify(object, Object.getOwnPropertyNames(object));
    };
});
parcelRegister("294PS", function(module, exports) {
    $parcel$export(module.exports, "prependSuperBatchDepsOnce", ()=>$a437264dd6b89021$export$93d9db5fbabad1b0);
    var $1r4rO;
    let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
    const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
        const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
        const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
        const { pathname: pathname } = window.location;
        return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || window.location.href.includes('secure/RapidBoard.jspa');
    };
    const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
        if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
        $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
        return (0, (0, parcelRequire("1r4rO")).jiraSuperBatchDependencies).concat(wrmKeys);
    };
});
parcelRegister("1r4rO", function(module, exports) {
    $parcel$export(module.exports, "jiraSuperBatchDependencies", ()=>$e87d6a02e2466ae8$export$f14a6b583ce9e077);
    const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
        'wrc!jira.webresources:skate',
        'wrc!jira.webresources:util-lite',
        'wrc!jira.webresources:util',
        'wrc!jira.webresources:feature-flags',
        'wrc!jira.webresources:dialogs',
        'wrc!jira.webresources:jira-global',
        'wrc!com.atlassian.auiplugin:aui-spinner'
    ];
});
parcelRegister("9B86Q", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeWeak", ()=>$61b2a5aa3a2a1160$export$3cefda82396756a1);
    var $ifVVd;
    let $61b2a5aa3a2a1160$var$pollingSingleton = null;
    const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
        const getter = $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, (0, parcelRequire("ifVVd")).createPollingCollection)((v)=>window.require(v), 100);
        $61b2a5aa3a2a1160$var$pollingSingleton = getter;
        return getter(name);
    };
});
parcelRegister("ifVVd", function(module, exports) {
    $parcel$export(module.exports, "createPollingCollection", ()=>$60e6b0d4bc46beac$export$f163446a982a8077);
    var $gKZoD;
    var $aePFs;
    const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
        (0, (0, parcelRequire("gKZoD")).di)(setTimeout);
        let isPolling = false;
        const deferredMap = new Map();
        const promiseMap = new Map();
        const evaluateForKey = (key)=>{
            let result;
            try {
                result = fn(key);
            } catch (error) {
                return;
            }
            const deferred = deferredMap.get(key);
            if (deferred instanceof (0, (0, parcelRequire("aePFs")).default)) {
                deferred.resolve(result);
                deferredMap.delete(key);
            }
        };
        const maybePoll = ()=>{
            if (!isPolling && deferredMap.size > 0) {
                isPolling = true;
                setTimeout(()=>{
                    isPolling = false;
                    [
                        ...deferredMap.keys()
                    ].forEach(evaluateForKey);
                    maybePoll();
                }, timeout);
            }
        };
        const getter = (key)=>{
            if (!promiseMap.has(key)) {
                const deferred = new (0, (0, parcelRequire("aePFs")).default)();
                const promise = deferred.then((v)=>v);
                deferredMap.set(key, deferred);
                promiseMap.set(key, promise);
                evaluateForKey(key);
                maybePoll();
            }
            return promiseMap.get(key);
        };
        return getter;
    };
});
parcelRegister("aePFs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02f3c6551bf5b1ff$export$2e2bcd8739ae039);
    class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
        static resolve(v) {
            const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
            instance.resolve(v);
            return instance;
        }
        static reject(e) {
            const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
            instance.reject(e);
            return instance;
        }
        constructor(){
            const [fn] = Array.prototype.slice.call(arguments);
            const callbacks = [];
            super(fn ?? callbacks.push.bind(callbacks));
            this.#resolve = callbacks[0];
            this.#reject = callbacks[1];
        }
        #resolve;
        #reject;
        resolve(v) {
            this.#resolve?.(v);
        }
        reject(e) {
            this.#reject?.(e);
        }
    }
});
parcelRegister("fqWWz", function(module, exports) {
    $parcel$export(module.exports, "safeErrorWithoutCustomerData", ()=>$71bf66166926d1dc$export$f19a2d31722e3428);
    $parcel$export(module.exports, "MAX_RETRIES", ()=>$71bf66166926d1dc$export$1f86472c1374185a);
    $parcel$export(module.exports, "DEFAULT_TIMEOUT", ()=>$71bf66166926d1dc$export$7bd623b29ec8e1eb);
    $parcel$export(module.exports, "SHOULD_LOG_ERROR", ()=>$71bf66166926d1dc$export$37f20f0ff732fcd7);
    var $dJl1T;
    const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, (0, parcelRequire("dJl1T")).default);
    const $71bf66166926d1dc$export$1f86472c1374185a = 40;
    const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
    const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;
});
parcelRegister("5Ik5Y", function(module, exports) {
    $parcel$export(module.exports, "wrmRequireWithPrefetch", ()=>$a1df1daee76d40f7$export$e53a5db19a39ed2f);
    var $fVOHM;
    var $fqWWz;
    const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR))=>(0, (0, parcelRequire("fVOHM")).loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError,
            batchUrl: batchUrl
        });
});
parcelRegister("1IY2I", function(module, exports) {
    $parcel$export(module.exports, "loadAmdModules", ()=>$d6efeb87a1192ef7$export$2c79895bd69a8d54);
    $parcel$export(module.exports, "evalAmdModules", ()=>$d6efeb87a1192ef7$export$d74eab33af9baaea);
    var $dJl1T;
    var $JIPqS;
    class $d6efeb87a1192ef7$var$ConnectDashboardItem {
        render() {}
        renderEdit() {}
    }
    const $d6efeb87a1192ef7$export$3bf37adbbdcafcc8 = (moduleName, retries = 5)=>{
        try {
            if (typeof window.require !== 'function') throw new TypeError('window.require is not a function');
            return window.require(moduleName);
        } catch (error) {
            if (error instanceof Error && /^No \S+$|^\S+ missing \S+$/.test(error.message)) {
                if (retries > 0) return new Promise((r)=>setTimeout(r, 100)).then(()=>$d6efeb87a1192ef7$export$3bf37adbbdcafcc8(moduleName, retries - 1));
            }
            throw error;
        }
    };
    const $d6efeb87a1192ef7$export$2c79895bd69a8d54 = async (wrmRequire, moduleNames)=>{
        if (moduleNames.length === 0) return false;
        const prefixedAmdResources = moduleNames.map((amdModule)=>(0, (0, parcelRequire("JIPqS")).WEB_RESOURCE_MAP)[amdModule]).map((resourceName)=>`wrc!${resourceName}`);
        try {
            await wrmRequire(prefixedAmdResources);
            return true;
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.resource', `Failed to load web resources [${prefixedAmdResources.join(',')}]`, error);
            return false;
        }
    };
    const $d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples = (tuples)=>tuples.map(([moduleName])=>moduleName).sort((a, b)=>a.localeCompare(b)).join(',');
    const $d6efeb87a1192ef7$export$d74eab33af9baaea = (amdModuleNames)=>{
        const tuplesOrPromises = amdModuleNames.map((amdModuleName)=>{
            try {
                const module = amdModuleName === (0, (0, parcelRequire("JIPqS")).CONNECT_ITEM_AMD_MODULE) ? $d6efeb87a1192ef7$var$ConnectDashboardItem : $d6efeb87a1192ef7$export$3bf37adbbdcafcc8(amdModuleName);
                return module instanceof Promise ? module.then((v)=>[
                        amdModuleName,
                        v
                    ]) : [
                    amdModuleName,
                    module
                ];
            } catch (error) {
                return Promise.reject(error);
            }
        });
        const hasPromise = tuplesOrPromises.some((entry)=>entry instanceof Promise);
        if (!hasPromise) {
            (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful synchronous bulk eval AMD modules');
            return Object.fromEntries(tuplesOrPromises);
        }
        return Promise.allSettled(tuplesOrPromises).then((results)=>{
            const tuples = results.map((result, i)=>{
                if (result.status === 'fulfilled') return result.value;
                const { reason: error } = result;
                const amdModuleName = amdModuleNames[i];
                const message = error instanceof Error ? error.message : String(error);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD module [${amdModuleName}] with error [${message}]`, error);
                return [
                    amdModuleName,
                    null
                ];
            });
            const failedTuples = tuples.filter((module)=>module[1] === null);
            failedTuples.length > 0 ? (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD modules [${$d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples(failedTuples)}]`) : (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful asynchronous bulk eval AMD modules');
            return Object.fromEntries(tuples);
        });
    };
});
parcelRegister("3cb5I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f465c16c9ac91f45$export$2e2bcd8739ae039);
    var $65Ltd;
    var $7RGnr;
    var $2j5ho;
    var $1LNzH;
    var $hoLk6;
    var $6T8HZ;
    var $abozY;
    var $8oOn8;
    const $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames = async (configs)=>{
        const gadgets = configs.flatMap((config)=>config.gadgets);
        const preloadedModuleNames = (0, (0, parcelRequire("8oOn8")).gadgetsToUniqueSortedAmdModules)(gadgets);
        const wrmBundleDescriptor = await (0, (0, parcelRequire("1LNzH")).default)(preloadedModuleNames);
        return configs.map((config)=>{
            const scriptTags = [
                wrmBundleDescriptor ? (0, (0, parcelRequire("6T8HZ")).default)(wrmBundleDescriptor) : null,
                (0, (0, parcelRequire("hoLk6")).default)(config)
            ].filter(Boolean).join('\n') || null;
            return {
                ...config,
                scriptTags: scriptTags,
                preloadedModuleNames: preloadedModuleNames
            };
        });
    };
    var $f465c16c9ac91f45$export$2e2bcd8739ae039 = async (context)=>{
        const { route: route, query: query } = context;
        const originalConfigs = route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD) ? await (0, (0, parcelRequire("2j5ho")).getDashboardsConfig)(query.dashboardId) : [
            await (0, (0, parcelRequire("2j5ho")).default)((0, (0, parcelRequire("abozY")).getKey)(context))
        ];
        const configs = originalConfigs.map((config)=>({
                ...config,
                gadgets: (0, (0, parcelRequire("7RGnr")).mapToReactGadgets)(config.gadgets)
            }));
        if (!false) return configs.map((config)=>({
                ...config,
                preloadedModuleNames: []
            }));
        return $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames(configs);
    };
});
parcelRegister("7RGnr", function(module, exports) {
    $parcel$export(module.exports, "mapToReactGadgets", ()=>$119a071fe5fec8f8$export$c90615c5eb218d50);
    var $4R6GH;
    const $119a071fe5fec8f8$export$c90615c5eb218d50 = (gadgets)=>{
        const gadgetMapping = {
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_filter_results_gadget') ? {
                'jira-dashboard-items/filter-results': 'react/filter-results'
            } : {},
            'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'react/custom-report',
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_assigned_to_me_gadget') ? {
                'jira-dashboard-items/assigned-to-me': 'react/assigned-to-me'
            } : {},
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_issues_in_progress_gadget') ? {
                'jira-dashboard-items/in-progress': 'react/issues-in-progress'
            } : {},
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_voted_issues_gadget') ? {
                'jira-dashboard-items/voted': 'react/voted-issues'
            } : {},
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_watched_issues_gadget') ? {
                'jira-dashboard-items/watched': 'react/watched-issues'
            } : {}
        };
        const isMapped = (module)=>module !== undefined && module in gadgetMapping;
        return gadgets.map((gadget)=>{
            if (isMapped(gadget.amdModule)) return {
                ...gadget,
                reactKey: gadgetMapping[gadget.amdModule],
                amdModule: undefined,
                configurable: false,
                inlineHtml: undefined
            };
            return gadget;
        });
    };
});
parcelRegister("2j5ho", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ef874ace7c3cd69$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "getDashboardsConfig", ()=>$3ef874ace7c3cd69$export$1264b6af3adf5084);
    var $7f4tk;
    var $3ef874ace7c3cd69$export$2e2bcd8739ae039 = (id)=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/dashboards/1.0/${id}.json`);
    const $3ef874ace7c3cd69$export$1264b6af3adf5084 = (idsCsv)=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);
});
parcelRegister("1LNzH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e5794ac0c0d1780$export$2e2bcd8739ae039);
    var $JIPqS;
    var $7f4tk;
    const $1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES = [
        'jira.webresources:util',
        'jira.webresources:feature-flags',
        'com.atlassian.jira.jira-atlaskit-plugin:overrides-general'
    ];
    const $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
    var $1e5794ac0c0d1780$export$2e2bcd8739ae039 = async (moduleNames)=>{
        if (moduleNames.length === 0) return Promise.resolve(null);
        const contextsToRequire = moduleNames.map((amdModule)=>(0, (0, parcelRequire("JIPqS")).WEB_RESOURCE_MAP)[amdModule]);
        const payload = {
            r: [],
            c: [
                ...$1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES,
                ...contextsToRequire
            ],
            xc: [
                $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH
            ],
            xr: []
        };
        return (0, (0, parcelRequire("7f4tk")).default)('/rest/webResources/1.0/resources', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };
});
parcelRegister("hoLk6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9b2d88076d11343$export$2e2bcd8739ae039);
    var $JIPqS;
    var $83oax;
    var $d9b2d88076d11343$export$2e2bcd8739ae039 = (dashboardConfig)=>{
        if (dashboardConfig.gadgets.length === 0) return null;
        const prefetches = (0, (0, parcelRequire("83oax")).getPrefetches)(dashboardConfig);
        const preloadLinks = prefetches.map((prefetch)=>`<link rel="preload" as="fetch" href="${prefetch.url}" crossorigin="anonymous" />`).join('\n') || null;
        const syncPrefetchUrls = prefetches.filter((prefetch)=>prefetch.isSyncLoadingSupported()).map((prefetch)=>prefetch.url);
        if (preloadLinks != null && syncPrefetchUrls.length > 0) {
            const fetchScript = `
            <script type="text/javascript" data-defer-skip>
                const preloadUrls = ${JSON.stringify(syncPrefetchUrls)};
                window['${(0, (0, parcelRequire("JIPqS")).PRELOADED_GADGET_DATA_KEY)}'] = {};

                preloadUrls.forEach((preloadUrl) => {
                    fetch(preloadUrl)
                        .then(res => res.json())
                        .then(data => {
                            window['${(0, (0, parcelRequire("JIPqS")).PRELOADED_GADGET_DATA_KEY)}'][preloadUrl] = data;
                        });
                });
            </script>
        `;
            return preloadLinks + fetchScript;
        }
        return preloadLinks;
    };
});
parcelRegister("83oax", function(module, exports) {
    $parcel$export(module.exports, "getPrefetches", ()=>$6e3ee08c53b7707c$export$3144db3718ad5e57);
    var $bT0sh;
    const $6e3ee08c53b7707c$export$3144db3718ad5e57 = ({ gadgets: gadgets })=>{
        const lookup = (0, (0, parcelRequire("bT0sh")).getPrefetchDict)();
        return gadgets.flatMap((gadget)=>{
            const identifier = gadget.amdModule;
            const prefechProp = identifier != null ? lookup[identifier] : undefined;
            if (!prefechProp || !prefechProp.enabled) return [];
            const { func: func, priority: priority, isSyncLoadingSupported: isSyncLoadingSupported } = prefechProp;
            return func(gadget).map((url)=>({
                    url: url,
                    priority: priority,
                    isSyncLoadingSupported: isSyncLoadingSupported
                }));
        });
    };
});
parcelRegister("bT0sh", function(module, exports) {
    $parcel$export(module.exports, "getPrefetchDict", ()=>$e3f3a590c57f26d7$export$244cea94cab19e07);
    var $4R6GH;
    var $ltNbR;
    var $8lc67;
    var $cdUf4;
    const $e3f3a590c57f26d7$export$244cea94cab19e07 = ()=>({
            'jira-dashboard-items/activitystream': {
                func: (0, (0, parcelRequire("8lc67")).getActivityStreamPrefetchLink),
                priority: (0, (0, parcelRequire("ltNbR")).LOADING_PRIORITY).HIGH,
                enabled: true,
                isSyncLoadingSupported: ()=>false
            },
            'jira-dashboard-items/filter-results': {
                func: (0, (0, parcelRequire("cdUf4")).getFilterResultsPrefetchLink),
                priority: (0, (0, parcelRequire("ltNbR")).LOADING_PRIORITY).LOW,
                enabled: !(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_filter_results_gadget'),
                isSyncLoadingSupported: ()=>true
            }
        });
});
parcelRegister("ltNbR", function(module, exports) {
    $parcel$export(module.exports, "LOADING_PRIORITY", ()=>$5a106311215627b2$export$cb9b1f2232733c1b);
    const $5a106311215627b2$export$cb9b1f2232733c1b = {
        HIGH: 'preload',
        LOW: 'prefetch'
    };
});
parcelRegister("8lc67", function(module, exports) {
    $parcel$export(module.exports, "getActivityStreamPrefetchLink", ()=>$cadf517d0dd42b8b$export$360928f5bf059a9e);
    var $ebyGx = parcelRequire("ebyGx");
    const $cadf517d0dd42b8b$var$replacer = (match, part1)=>String.fromCharCode(part1);
    const $cadf517d0dd42b8b$var$getDateValue = (dateValue, operatorLower)=>{
        const dateStr = `${dateValue}`;
        const operator = operatorLower.toUpperCase();
        let dateArr;
        if (dateStr.indexOf(' ') !== -1) dateArr = dateStr.split(' ');
        else if (operator === 'BETWEEN') dateArr = [
            dateValue,
            dateValue
        ];
        else dateArr = [
            dateValue
        ];
        return dateArr.map((date, index)=>{
            const dateInt = parseInt(date, 10);
            if (operator === 'AFTER' || operator === 'BETWEEN' && index === 1) return dateInt + 86400000 - 1;
            return dateInt;
        }).join(' ');
    };
    const $cadf517d0dd42b8b$var$handleSpecialCases = (rule)=>{
        let { value: value, operator: operator } = rule;
        const { type: type } = rule;
        if (Array.isArray(value)) {
            const encodedValues = [];
            value.forEach((val)=>{
                encodedValues.push(val.replace(/_/g, '\\_').replace(/ /g, '_'));
            });
            value = encodedValues.join(' ');
        }
        if (type === 'date') {
            if (operator === 'is') operator = 'between';
            value = $cadf517d0dd42b8b$var$getDateValue(value, operator);
            if (value.indexOf('NaN') !== -1) return {};
        } else if (type === 'list' || type === 'user') {
            value = value.replace(/,/g, ' ');
            value = value.replace(/_/g, '\\_');
        }
        return {
            value: value,
            operator: operator
        };
    };
    const $cadf517d0dd42b8b$var$getParamsFromRules = (rules)=>{
        const params = {};
        const providers = JSON.parse(decodeURIComponent(rules.replace(/&#([0-9]+);/g, $cadf517d0dd42b8b$var$replacer)))?.providers || [];
        const enabledProviders = [];
        providers.forEach((provider)=>{
            const providerKey = provider.provider;
            const { rules: providerRules } = provider;
            const stringifiedRules = [];
            if (!provider.disabled) {
                if (providerKey !== 'streams') enabledProviders.push(providerKey);
                providerRules.forEach((rule)=>{
                    const modifiedRuleObj = $cadf517d0dd42b8b$var$handleSpecialCases(rule);
                    const { operator: operator, value: value } = modifiedRuleObj;
                    if (operator && value) stringifiedRules.push([
                        rule.rule,
                        operator.toUpperCase(),
                        value
                    ].join(' '));
                });
                params[providerKey] = stringifiedRules;
            }
        });
        if (enabledProviders.length < providers.length - 1) params.providers = enabledProviders.join(' ');
        return params;
    };
    const $cadf517d0dd42b8b$export$3d7deb7cf8a9de04 = (gadget)=>{
        const prefs = Object.fromEntries(gadget.userPrefs?.fields.map((field)=>[
                field.name,
                field.value
            ]) ?? []);
        const params = {
            maxResults: prefs.numofentries ?? 25,
            relativeLinks: true,
            ...prefs.rules ? $cadf517d0dd42b8b$var$getParamsFromRules(prefs.rules) : {}
        };
        return (0, ($parcel$interopDefault($ebyGx))).stringify(params).replace(/%20/g, '+');
    };
    const $cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL = 'plugins/servlet/streams';
    const $cadf517d0dd42b8b$export$360928f5bf059a9e = (gadgetData)=>{
        const paramStr = $cadf517d0dd42b8b$export$3d7deb7cf8a9de04(gadgetData);
        return [
            `/${$cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL}?${paramStr}`
        ];
    };
});
parcelRegister("cdUf4", function(module, exports) {
    $parcel$export(module.exports, "getFilterResultsPrefetchLink", ()=>$7e69dbaeb4189994$export$947cd90004054337);
    var $ebyGx = parcelRequire("ebyGx");
    const $7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL = 'rest/gadget/1.0/issueTable';
    const $7e69dbaeb4189994$export$947cd90004054337 = (gadgetData)=>{
        const { properties: properties } = gadgetData.context.dashboardItem;
        const data = {
            num: properties.num,
            tableContext: 'jira.table.cols.dashboard',
            addDefault: false,
            columnNames: typeof properties.columnNames === 'string' ? properties.columnNames.split('|') : undefined,
            enableSorting: true,
            paging: true,
            showActions: true,
            filterId: undefined,
            jql: undefined,
            sortBy: String(properties.sortBy && properties.sortBy !== '' ? properties.sortBy : null),
            startIndex: properties.startIndex ? properties.startIndex : 0
        };
        let queryType = '';
        if (properties.filterId) {
            queryType = 'filter';
            Object.assign(data, {
                filterId: properties.filterId
            });
        } else if (properties.jql) {
            queryType = 'jql';
            Object.assign(data, {
                jql: properties.jql
            });
        }
        const paramStr = (0, ($parcel$interopDefault($ebyGx))).stringify(data, {
            sort: false
        }).replace(/%20/g, '+');
        const preloadUrl = `/${$7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL}/${queryType}?${paramStr}`;
        return [
            preloadUrl
        ];
    };
});
parcelRegister("6T8HZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c547330881220e9$export$2e2bcd8739ae039);
    var $8c547330881220e9$export$2e2bcd8739ae039 = (response)=>{
        let resourceHtml = `
        <script type="text/javascript" data-defer-skip>
            window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
            WRM._unparsedData = Object.assign({}, WRM._unparsedData, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedData))}));
            WRM._unparsedErrors = Object.assign({}, WRM._unparsedErrors, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedErrors))}));
            if(window.WRM._dataArrived)window.WRM._dataArrived();
        </script>
    `;
        response.resources.forEach((resource)=>{
            const { url: url, resourceType: resourceType, key: key } = resource;
            if (resourceType === 'CSS') {
                const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
                resourceHtml += cssResource;
            } else {
                const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
                resourceHtml += jsResource;
            }
        });
        return resourceHtml;
    };
});
parcelRegister("8oOn8", function(module, exports) {
    $parcel$export(module.exports, "gadgetsToUniqueSortedAmdModules", ()=>$d83f51a78c4f458b$export$598e0ea2a7525181);
    $parcel$export(module.exports, "gadgetsToSortedReactGadgets", ()=>$d83f51a78c4f458b$export$f98787198c197952);
    var $JIPqS;
    var $kspzT;
    const $d83f51a78c4f458b$export$598e0ea2a7525181 = (gadgets)=>gadgets.map(({ amdModule: amdModule })=>amdModule).filter(Boolean).filter((amdModule)=>amdModule in (0, (0, parcelRequire("JIPqS")).WEB_RESOURCE_MAP)).filter((v, i, a)=>a.indexOf(v) === i).sort() ?? [];
    const $d83f51a78c4f458b$export$f98787198c197952 = (gadgets)=>gadgets.reduce((gadgetsAccumulator, gadget)=>{
            if (!(0, (0, parcelRequire("kspzT")).isReactKey)(gadget.reactKey)) return gadgetsAccumulator;
            gadgetsAccumulator.push({
                reactKey: gadget.reactKey,
                id: gadget.id,
                userPrefs: gadget.userPrefs
            });
            return gadgetsAccumulator;
        }, []).sort((a, b)=>a.id.localeCompare(b.id));
});
parcelRegister("kspzT", function(module, exports) {
    $parcel$export(module.exports, "isReactKey", ()=>$7a81ea406ace6c08$export$6acd06c99f745b49);
    $parcel$export(module.exports, "default", ()=>$7a81ea406ace6c08$export$2e2bcd8739ae039);
    var $9zbBl;
    var $kvkwL;
    var $26UOd;
    const $7a81ea406ace6c08$var$GADGETS_DEFINITION = {
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).FILTER_RESULTS]: (0, (0, parcelRequire("kvkwL")).FILTER_RESULTS_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).ASSIGNED_TO_ME]: (0, (0, parcelRequire("kvkwL")).ASSIGNED_TO_ME_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).ISSUES_IN_PROGRESS]: (0, (0, parcelRequire("kvkwL")).ISSUES_IN_PROGRESS_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).VOTED_ISSUES]: (0, (0, parcelRequire("kvkwL")).VOTED_ISSUES_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).WATCHED_ISSUES]: (0, (0, parcelRequire("kvkwL")).WATCHED_ISSUES_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).CUSTOM_REPORT]: (0, (0, parcelRequire("9zbBl")).default)
    };
    function $7a81ea406ace6c08$export$6acd06c99f745b49(key) {
        return !!(key && Object.values((0, (0, parcelRequire("26UOd")).REACT_KEY)).includes(key));
    }
    var $7a81ea406ace6c08$export$2e2bcd8739ae039 = $7a81ea406ace6c08$var$GADGETS_DEFINITION;
});
parcelRegister("9zbBl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$088534adc4ba7ffc$export$2e2bcd8739ae039);
    var $cDOH2;
    var $jUheV;
    var $gM7kh;
    const $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION = {
        componentView: (0, (0, parcelRequire("jUheV")).LazyCustomReportGadgetView),
        componentEdit: (0, (0, parcelRequire("cDOH2")).LazyCustomReportGadgetEdit),
        getInitialState: (0, parcelRequire("gM7kh")).default,
        preload: (0, parcelRequire("jUheV")).preload
    };
    var $088534adc4ba7ffc$export$2e2bcd8739ae039 = $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION;
});
parcelRegister("cDOH2", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomReportGadgetEdit", ()=>$e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116);
    var $kxZPA;
    const $e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jY7jn")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/edit/main.tsx"
    });
});
parcelRegister("jY7jn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3Na4y").then(()=>parcelRequire('chhAm'));
});
parcelRegister("jUheV", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomReportGadgetView", ()=>$e43675722e4e42c6$export$27df795d4f3ff173);
    $parcel$export(module.exports, "preload", ()=>$e43675722e4e42c6$export$513ccb98c53b8039);
    var $kxZPA;
    const $e43675722e4e42c6$export$27df795d4f3ff173 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5b6PY")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/view/main.tsx"
    });
    const { preload: $e43675722e4e42c6$export$513ccb98c53b8039 } = $e43675722e4e42c6$export$27df795d4f3ff173;
});
parcelRegister("5b6PY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fBPHr").then(()=>parcelRequire('e2l8c'));
});
parcelRegister("gM7kh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1132aa73a645b93$export$2e2bcd8739ae039);
    const $d1132aa73a645b93$var$getInitialState = ()=>Promise.resolve({
            intervalValue: '1',
            isCustom: 'false',
            projectValue: '0',
            refresh: 'false',
            reportValue: '0',
            gadgetContentTitle: ''
        });
    var $d1132aa73a645b93$export$2e2bcd8739ae039 = $d1132aa73a645b93$var$getInitialState;
});
parcelRegister("kvkwL", function(module, exports) {
    $parcel$export(module.exports, "FILTER_RESULTS_DEFINITION", ()=>$676d00abfb59f2ab$export$3581891d04da6bb8);
    $parcel$export(module.exports, "ASSIGNED_TO_ME_DEFINITION", ()=>$676d00abfb59f2ab$export$652d5a9cc2c18d2e);
    $parcel$export(module.exports, "ISSUES_IN_PROGRESS_DEFINITION", ()=>$676d00abfb59f2ab$export$54b46348d1ed5d22);
    $parcel$export(module.exports, "VOTED_ISSUES_DEFINITION", ()=>$676d00abfb59f2ab$export$ea96ce30d34ce354);
    $parcel$export(module.exports, "WATCHED_ISSUES_DEFINITION", ()=>$676d00abfb59f2ab$export$5109728db227eae);
    var $5uXOq = parcelRequire("5uXOq");
    var $2egG3;
    var $eZ5lN;
    var $kdIR9;
    var $dzPNh;
    var $9KhHm;
    var $5ALJk;
    var $hfHPa;
    const $676d00abfb59f2ab$var$componentViewWithAdditionalState = (Component, additionalStateProps)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                state: props.state ? {
                    ...props.state,
                    ...additionalStateProps
                } : null
            });
    const $676d00abfb59f2ab$var$componentEditWithAdditionalState = (Component, additionalStateProps)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                state: props.state ? {
                    ...props.state,
                    ...additionalStateProps
                } : null
            });
    const $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG = {
        testId: 'react-issue-table-gadgets.filter-results.view'
    };
    const $676d00abfb59f2ab$export$3581891d04da6bb8 = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
        componentEdit: (0, (0, parcelRequire("eZ5lN")).FilterResultsGadgetEdit),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
    const $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG = {
        predeterminedJql: 'assignee = currentUser() AND statusCategory != 3 ORDER BY priority DESC, created ASC',
        defaultSortPrefs: {
            field: 'priority',
            direction: 'DESC'
        },
        testId: 'react-issue-table-gadgets.assigned-to-me.view'
    };
    const $676d00abfb59f2ab$export$652d5a9cc2c18d2e = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
        componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, (0, parcelRequire("2egG3")).AssignedToMeGadgetEdit), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
    const $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG = {
        predeterminedJql: 'status = "In Progress" AND statusCategory != Done AND assignee = currentUser() ORDER BY priority DESC, created ASC',
        defaultSortPrefs: {
            field: 'priority',
            direction: 'DESC'
        },
        testId: 'react-issue-table-gadgets.issues-in-progress.view'
    };
    const $676d00abfb59f2ab$export$54b46348d1ed5d22 = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
        componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, (0, parcelRequire("kdIR9")).IssuesInProgressGadgetEdit), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
    const $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG = {
        predeterminedJql: 'issue in votedIssues() AND statusCategory != Done ORDER BY votes DESC',
        predeterminedJqlIncludeResolved: 'issue in votedIssues() ORDER BY votes DESC',
        defaultSortPrefs: {
            field: 'votes',
            direction: 'DESC'
        },
        testId: 'react-issue-table-gadgets.voted-issues.view'
    };
    const $676d00abfb59f2ab$export$ea96ce30d34ce354 = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
        componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, (0, parcelRequire("9KhHm")).VotedIssuesGadgetEdit), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
    const $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG = {
        predeterminedJql: 'issue in watchedIssues() AND statusCategory != Done ORDER BY watchers DESC',
        predeterminedJqlIncludeResolved: 'issue in watchedIssues() ORDER BY watchers DESC',
        defaultSortPrefs: {
            field: 'watchers',
            direction: 'DESC'
        },
        testId: 'react-issue-table-gadgets.watched-issues.view'
    };
    const $676d00abfb59f2ab$export$5109728db227eae = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
        componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, (0, parcelRequire("5ALJk")).WatchedIssuesGadgetEdit), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
});
parcelRegister("2egG3", function(module, exports) {
    $parcel$export(module.exports, "AssignedToMeGadgetEdit", ()=>$91d75e80303bba8c$export$3ae3568d16dc8f35);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $kxZPA;
    const $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("Aw8dO")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/assigned-to-me/edit/main.tsx"
    });
    const $91d75e80303bba8c$export$3ae3568d16dc8f35 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "assigned-to-me-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit, props));
    const { preload: $91d75e80303bba8c$export$513ccb98c53b8039 } = $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit;
});
parcelRegister("834mM", function(module, exports) {
    $parcel$export(module.exports, "FilterResultsEditSkeleton", ()=>$92b82de956011a8a$export$e10d91ce257e7374);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $cuyZg = parcelRequire("cuyZg");
    const $92b82de956011a8a$var$customCssStyles = null;
    const $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';
    const $92b82de956011a8a$export$e10d91ce257e7374 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($cuyZg))),
            containerStyles: {
                height: $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        });
});
parcelRegister("cuyZg", function(module, exports) {
    module.exports = new URL("filter-results-edit-skeleton.tpl.783fb7b7.svg", import.meta.url).toString();
});
parcelRegister("Aw8dO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("a1jim")
    ]).then(()=>parcelRequire('1SEAb'));
});
parcelRegister("eZ5lN", function(module, exports) {
    $parcel$export(module.exports, "FilterResultsGadgetEdit", ()=>$fa7c1c640e166488$export$6dfceca003c43832);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $kxZPA;
    const $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("7FH2x")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/filter-results/edit/main.tsx"
    });
    const $fa7c1c640e166488$export$6dfceca003c43832 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "filter-results-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($fa7c1c640e166488$var$LazyFilterResultsGadgetEdit, props));
    const { preload: $fa7c1c640e166488$export$513ccb98c53b8039 } = $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit;
});
parcelRegister("7FH2x", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("2WaJa")
    ]).then(()=>parcelRequire('eKgKX'));
});
parcelRegister("kdIR9", function(module, exports) {
    $parcel$export(module.exports, "IssuesInProgressGadgetEdit", ()=>$04f85077310bce7f$export$199fec410a0f70a2);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $kxZPA;
    const $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ggX7A")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/issues-in-progress/edit/main.tsx"
    });
    const $04f85077310bce7f$export$199fec410a0f70a2 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issues-in-progress-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit, props));
    const { preload: $04f85077310bce7f$export$513ccb98c53b8039 } = $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit;
});
parcelRegister("ggX7A", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("lNlvX")
    ]).then(()=>parcelRequire('dk51x'));
});
parcelRegister("dzPNh", function(module, exports) {
    $parcel$export(module.exports, "IssueTableGadgetView", ()=>$0c0c24e495111ec5$export$da0765a3c10e16a3);
    $parcel$export(module.exports, "preload", ()=>$0c0c24e495111ec5$export$513ccb98c53b8039);
    var $5uXOq = parcelRequire("5uXOq");
    var $JIPqS;
    var $lfTZh;
    var $dNZVN;
    var $kxZPA;
    const $0c0c24e495111ec5$var$LazyIssueTableGadgetView = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9o6Yv")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/view/main.tsx"
    });
    const $0c0c24e495111ec5$export$da0765a3c10e16a3 = ({ customSkeletonHeightInPx: customSkeletonHeightInPx, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "filter-results-gadget-view",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dNZVN")).FilterResultsIssueTableSkeleton), {
                height: `${customSkeletonHeightInPx ?? (0, (0, parcelRequire("JIPqS")).GADGET_DEFAULT_HEIGHT)}px`
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0c0c24e495111ec5$var$LazyIssueTableGadgetView, {
            customSkeletonHeightInPx: customSkeletonHeightInPx,
            ...props
        }));
    const { preload: $0c0c24e495111ec5$export$513ccb98c53b8039 } = $0c0c24e495111ec5$var$LazyIssueTableGadgetView;
});
parcelRegister("dNZVN", function(module, exports) {
    $parcel$export(module.exports, "FilterResultsIssueTableSkeleton", ()=>$a73c71eae267b518$export$35d754053deeac73);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $dCGjE = parcelRequire("dCGjE");
    const $a73c71eae267b518$var$customCssStyles = null;
    const $a73c71eae267b518$export$35d754053deeac73 = ({ height: height })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($dCGjE))),
            containerStyles: {
                height: height
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        });
});
parcelRegister("dCGjE", function(module, exports) {
    module.exports = new URL("filter-results-issue-table-skeleton.tpl.a502204a.svg", import.meta.url).toString();
});
parcelRegister("9o6Yv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("kLRoU")
    ]).then(()=>parcelRequire('dfMo9'));
});
parcelRegister("9KhHm", function(module, exports) {
    $parcel$export(module.exports, "VotedIssuesGadgetEdit", ()=>$0ca7bf6a0d6f5346$export$7650b85a7a54914);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $kxZPA;
    const $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3Ymqe")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/voted-issues/edit/main.tsx"
    });
    const $0ca7bf6a0d6f5346$export$7650b85a7a54914 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "voted-issues-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit, props));
    const { preload: $0ca7bf6a0d6f5346$export$513ccb98c53b8039 } = $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit;
});
parcelRegister("3Ymqe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("bNNoR")
    ]).then(()=>parcelRequire('irHWu'));
});
parcelRegister("5ALJk", function(module, exports) {
    $parcel$export(module.exports, "WatchedIssuesGadgetEdit", ()=>$278dbe55a7acf378$export$a53864bd0bf8a85f);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $kxZPA;
    const $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3Q7LP")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/watched-issues/edit/main.tsx"
    });
    const $278dbe55a7acf378$export$a53864bd0bf8a85f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "watched-issues-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit, props));
    const { preload: $278dbe55a7acf378$export$513ccb98c53b8039 } = $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit;
});
parcelRegister("3Q7LP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h7Bte")
    ]).then(()=>parcelRequire('iLll9'));
});
parcelRegister("hfHPa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f27ae6f4005fc53$export$2e2bcd8739ae039);
    var $fJpBG;
    var $lgZ6q;
    var $8rq2P;
    var $jyMtv;
    const $9f27ae6f4005fc53$var$createGetInitialState = ({ predeterminedJql: predeterminedJql, predeterminedJqlIncludeResolved: predeterminedJqlIncludeResolved, defaultSortPrefs: defaultSortPrefs, testId: testId })=>async (resourceContext, userPrefs)=>{
            if (resourceContext?.tenantContext == null) throw new Error('Tenant context is not available');
            const { cloudId: cloudId, activationId: activationId } = resourceContext.tenantContext;
            const validUserPrefs = (0, (0, parcelRequire("jyMtv")).transformToValidUserPrefs)((0, (0, parcelRequire("fJpBG")).decodeUserPreferences)(userPrefs));
            if (validUserPrefs.filterId === undefined && predeterminedJql === undefined && predeterminedJqlIncludeResolved === undefined) throw new Error('FilterId or JQL has to be available to be able to load the gadget initial state');
            const sortPrefs = (()=>{
                if (validUserPrefs.sortField) return {
                    sortField: validUserPrefs.sortField,
                    sortDirection: validUserPrefs.sortDirection
                };
                if (defaultSortPrefs) return {
                    sortField: defaultSortPrefs.field,
                    sortDirection: defaultSortPrefs.direction
                };
            })();
            const includeResolved = validUserPrefs.showResolved;
            const jql = includeResolved ? predeterminedJqlIncludeResolved : predeterminedJql;
            const queryReference = await (0, (0, parcelRequire("8rq2P")).loadQueryWithUserPrefs)({
                ...validUserPrefs,
                ...sortPrefs
            }, (0, (0, parcelRequire("lgZ6q")).default), cloudId, activationId, 'store-and-network', jql);
            return {
                queryReference: queryReference,
                predeterminedJql: predeterminedJql,
                defaultSortPrefs: defaultSortPrefs,
                testId: testId
            };
        };
    var $9f27ae6f4005fc53$export$2e2bcd8739ae039 = $9f27ae6f4005fc53$var$createGetInitialState;
});
parcelRegister("fJpBG", function(module, exports) {
    $parcel$export(module.exports, "getUserPreferences", ()=>$a6145919a3771254$export$ae3f5fa351e2f57a);
    $parcel$export(module.exports, "decodeUserPreferences", ()=>$a6145919a3771254$export$ebdfc6c2778ef8e2);
    var $7f4tk;
    const $a6145919a3771254$var$isBooleanString = (str)=>[
            'true',
            'false'
        ].includes(str.toLowerCase().trim());
    const $a6145919a3771254$var$stringToBoolean = (str)=>str.toLowerCase().trim() === 'true';
    const $a6145919a3771254$export$ae3f5fa351e2f57a = (action)=>(0, (0, parcelRequire("7f4tk")).default)(action);
    const $a6145919a3771254$export$ebdfc6c2778ef8e2 = (userPreferences = [])=>userPreferences.reduce((output, { value: value, name: name })=>({
                ...output,
                [name]: $a6145919a3771254$var$isBooleanString(value) ? $a6145919a3771254$var$stringToBoolean(value) : value
            }), {});
});
parcelRegister("lgZ6q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$328d775330990290$export$2e2bcd8739ae039);
    var $hLeia;
    var $5oQtH;
    var $1ZvTA;
    var $G39h7;
    var $6vKPN;
    var $dttgK;
    var $1kHcz;
    const $328d775330990290$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "amountOfColumns"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fieldSetIds"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fieldSetsInput"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterId"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isNotFilterFetch"
        }, v9 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        }, v10 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueTypeId"
        }, v11 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "namespace"
        }, v12 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }, v13 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryFieldSetsById"
        }, v14 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewId"
        }, v15 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v16 = {
            "kind": "ScalarField",
            "name": "key"
        }, v17 = {
            "kind": "ScalarField",
            "name": "id"
        }, v18 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v19 = {
            "kind": "ScalarField",
            "name": "fieldId"
        }, v20 = {
            "kind": "ScalarField",
            "name": "statusCategoryId"
        }, v21 = {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                v20,
                v17
            ]
        }, v22 = {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        }, v23 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }, v24 = {
            "kind": "ScalarField",
            "name": "type"
        }, v25 = {
            "kind": "ScalarField",
            "name": "fieldSetId"
        }, v26 = {
            "kind": "ScalarField",
            "name": "name"
        }, v27 = [
            v26,
            v17
        ], v28 = {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        }, v29 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lazyIsEditableInIssueView"
                }
            ]
        }, v30 = {
            "kind": "ScalarField",
            "name": "text"
        }, v31 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v32 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }, v33 = [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v24,
                            v25,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v18,
                                                    v19,
                                                    v24,
                                                    {
                                                        "kind": "TypeDiscriminator",
                                                        "abstractKey": "__isJiraIssueField"
                                                    },
                                                    v17,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraAffectedServiceConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedAffectedServicesConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraAffectedServiceEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraAffectedService",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "serviceId"
                                                                                    },
                                                                                    v26,
                                                                                    v17
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraAffectedServicesField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraCmdbObjectConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedCmdbObjectsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraCmdbObjectEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraCmdbObject",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "objectId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "label"
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraCmdbAvatar",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "avatar",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrccmdbmediaavatarfgrelayprovider",
                                                                                                "kind": "Condition",
                                                                                                "passingValue": true,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "mediaClientConfig",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "clientId"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "fileId"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "mediaBaseUrl"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "mediaJwtToken"
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "url48"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "QueryError",
                                                                        "kind": "LinkedField",
                                                                        "name": "errors",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "message"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraCMDBField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraComponentConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedComponentsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraComponentEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponent",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v27
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraComponentsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "date"
                                                            },
                                                            v26,
                                                            v28,
                                                            v29
                                                        ],
                                                        "type": "JiraDatePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "dateTime"
                                                            }
                                                        ],
                                                        "type": "JiraDateTimePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraEpic",
                                                                "kind": "LinkedField",
                                                                "name": "epic",
                                                                "plural": false,
                                                                "selections": [
                                                                    v16,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "summary"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "color"
                                                                    },
                                                                    v17
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraEpicLinkField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "renderedFieldHtml"
                                                            }
                                                        ],
                                                        "type": "JiraFallbackField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v30,
                                                            v26,
                                                            v29
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    v26,
                                                                    v20,
                                                                    v17
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusCategoryField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    v26,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusId"
                                                                    },
                                                                    v21,
                                                                    v17
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "first",
                                                                        "value": 1000
                                                                    }
                                                                ],
                                                                "concreteType": "JiraLabelConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedLabelsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraLabelEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraLabel",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v26
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v31
                                                                ],
                                                                "storageKey": "selectedLabelsConnection(first:1000)"
                                                            },
                                                            v26,
                                                            v29
                                                        ],
                                                        "type": "JiraLabelsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "small"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v26,
                                                                    v17
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssue",
                                                                "kind": "LinkedField",
                                                                "name": "parentIssue",
                                                                "plural": false,
                                                                "selections": [
                                                                    v16,
                                                                    {
                                                                        "concreteType": "JiraSingleLineTextField",
                                                                        "kind": "LinkedField",
                                                                        "name": "summaryField",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v30,
                                                                            v17
                                                                        ]
                                                                    },
                                                                    v17,
                                                                    {
                                                                        "concreteType": "JiraColorField",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueColorField",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraColor",
                                                                                "kind": "LinkedField",
                                                                                "name": "color",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "colorKey"
                                                                                    },
                                                                                    v17
                                                                                ]
                                                                            },
                                                                            v17
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraIssueTypeField",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypeField",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueType",
                                                                                "kind": "LinkedField",
                                                                                "name": "issueType",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v32,
                                                                                    v26,
                                                                                    v17
                                                                                ]
                                                                            },
                                                                            v17
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraParentIssueField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraPriority",
                                                                "kind": "LinkedField",
                                                                "name": "priority",
                                                                "plural": false,
                                                                "selections": [
                                                                    v26,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "iconUrl"
                                                                    },
                                                                    v17
                                                                ]
                                                            },
                                                            v26,
                                                            v29
                                                        ],
                                                        "type": "JiraPriorityField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                    v26,
                                                                    v16,
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "large"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v17
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraProjectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraResolution",
                                                                "kind": "LinkedField",
                                                                "name": "resolution",
                                                                "plural": false,
                                                                "selections": v27
                                                            }
                                                        ],
                                                        "type": "JiraResolutionField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSprintConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedSprintsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprintEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSprint",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v17,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "sprintId"
                                                                                    },
                                                                                    v26,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "state"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "endDate"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            v26,
                                                            v29
                                                        ],
                                                        "type": "JiraSprintField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v18,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "accountId"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "picture"
                                                                    },
                                                                    v26,
                                                                    v17,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "accountStatus"
                                                                    }
                                                                ]
                                                            },
                                                            v26,
                                                            v28,
                                                            v29
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v26,
                                                            {
                                                                "concreteType": "JiraVersionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedVersionsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraVersion",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v27
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraMultipleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraRichText",
                                                                "kind": "LinkedField",
                                                                "name": "richText",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraADF",
                                                                        "kind": "LinkedField",
                                                                        "name": "adfValue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "json"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraRichTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraServiceManagementRequestType",
                                                                "kind": "LinkedField",
                                                                "name": "requestType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v26,
                                                                    v32,
                                                                    v17
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraServiceManagementRequestTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Variable",
                                                                        "name": "first",
                                                                        "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueLinkConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issueLinkConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                                                                        "kind": "Condition",
                                                                        "passingValue": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "PageInfo",
                                                                                "kind": "LinkedField",
                                                                                "name": "pageInfo",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "hasNextPage"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            v31
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraIssueLinkEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueLink",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssue",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "issue",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "webUrl"
                                                                                            },
                                                                                            v16,
                                                                                            {
                                                                                                "args": [
                                                                                                    {
                                                                                                        "kind": "Literal",
                                                                                                        "name": "ids",
                                                                                                        "value": [
                                                                                                            "statusCategory"
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "fieldsById",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "edges",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "node",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v18,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v21
                                                                                                                        ],
                                                                                                                        "type": "JiraStatusCategoryField"
                                                                                                                    },
                                                                                                                    v17
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                            },
                                                                                            v17
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "relationName"
                                                                                    },
                                                                                    v17
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueLinkField"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "isStoryPointField"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "number"
                                                                    },
                                                                    v26,
                                                                    v29
                                                                ],
                                                                "type": "JiraNumberField"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ], v34 = {
            "kind": "ScalarField",
            "name": "__id"
        }, v35 = [
            {
                "kind": "ScalarField",
                "name": "cursor"
            },
            {
                "kind": "ScalarField",
                "name": "pageNumber"
            },
            {
                "kind": "ScalarField",
                "name": "isCurrent"
            }
        ], v36 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v37 = {
            "kind": "ScalarField",
            "name": "displayName"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14
                ],
                "kind": "Fragment",
                "name": "issueTableViewQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "issueTableView_reactIssueTableGadgets"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v9,
                    v11,
                    v14,
                    v1,
                    v3,
                    v13,
                    v4,
                    v0,
                    v7,
                    v5,
                    v8,
                    v6,
                    v10,
                    v12,
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrccmdbmediaavatarfgrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider"
                    }
                ],
                "kind": "Operation",
                "name": "issueTableViewQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "after",
                                        "variableName": "after"
                                    },
                                    v15,
                                    {
                                        "kind": "Variable",
                                        "name": "fieldSetsInput",
                                        "variableName": "fieldSetsInput"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "first",
                                        "variableName": "first"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "issueSearchInput",
                                        "variableName": "issueSearchInput"
                                    }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issueSearchStable",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v16,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "issueId"
                                                    },
                                                    v17,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isResolved"
                                                    },
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "ids",
                                                                "value": [
                                                                    "status"
                                                                ]
                                                            }
                                                        ],
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldsById",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v18,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v19,
                                                                                    {
                                                                                        "concreteType": "JiraStatus",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "status",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v21,
                                                                                            v17
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraStatusField"
                                                                            },
                                                                            v17
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "storageKey": "fieldsById(ids:[\"status\"])"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "hasChildren"
                                                            },
                                                            {
                                                                "concreteType": "JiraIssueTypeField",
                                                                "kind": "LinkedField",
                                                                "name": "issueTypeField",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                "kind": "LinkedField",
                                                                                "name": "hierarchy",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "level"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v17
                                                                        ]
                                                                    },
                                                                    v17
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                            {
                                                                "condition": "shouldQueryFieldSetsById",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "args": [
                                                                            v22,
                                                                            v23
                                                                        ],
                                                                        "concreteType": "JiraIssueFieldSetConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "fieldSetsById",
                                                                        "plural": false,
                                                                        "selections": v33
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "condition": "shouldQueryFieldSetsById",
                                                                "kind": "Condition",
                                                                "passingValue": false,
                                                                "selections": [
                                                                    {
                                                                        "args": [
                                                                            {
                                                                                "fields": [
                                                                                    {
                                                                                        "fields": [
                                                                                            {
                                                                                                "kind": "Variable",
                                                                                                "name": "issueType",
                                                                                                "variableName": "issueTypeId"
                                                                                            },
                                                                                            {
                                                                                                "kind": "Variable",
                                                                                                "name": "project",
                                                                                                "variableName": "projectId"
                                                                                            }
                                                                                        ],
                                                                                        "kind": "ObjectValue",
                                                                                        "name": "projectContext"
                                                                                    }
                                                                                ],
                                                                                "kind": "ObjectValue",
                                                                                "name": "context"
                                                                            },
                                                                            {
                                                                                "kind": "Variable",
                                                                                "name": "filterId",
                                                                                "variableName": "filterId"
                                                                            },
                                                                            v23,
                                                                            {
                                                                                "kind": "Variable",
                                                                                "name": "namespace",
                                                                                "variableName": "namespace"
                                                                            },
                                                                            {
                                                                                "kind": "Variable",
                                                                                "name": "viewId",
                                                                                "variableName": "viewId"
                                                                            }
                                                                        ],
                                                                        "concreteType": "JiraIssueFieldSetConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "fieldSetsForIssueSearchView",
                                                                        "plural": false,
                                                                        "selections": v33
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "isHighlightedIssueRow"
                                                            },
                                                            v34
                                                        ]
                                                    }
                                                ]
                                            },
                                            v18,
                                            {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "first",
                                                                "value": 500
                                                            }
                                                        ],
                                                        "concreteType": "JiraIssueFieldSetConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSets",
                                                        "plural": false,
                                                        "selections": v33,
                                                        "storageKey": "fieldSets(first:500)"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "totalIssueSearchResultCount"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isCappingIssueSearchResult"
                                    },
                                    {
                                        "concreteType": "JiraIssueNavigatorPageInfo",
                                        "kind": "LinkedField",
                                        "name": "issueNavigatorPageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "firstIssuePosition"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "lastIssuePosition"
                                            }
                                        ]
                                    },
                                    {
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "maxCursors",
                                                "value": 7
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "pageSize",
                                                "variableName": "first"
                                            }
                                        ],
                                        "concreteType": "JiraPageCursors",
                                        "kind": "LinkedField",
                                        "name": "pageCursors",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraPageCursor",
                                                "kind": "LinkedField",
                                                "name": "first",
                                                "plural": false,
                                                "selections": v35
                                            },
                                            {
                                                "concreteType": "JiraPageCursor",
                                                "kind": "LinkedField",
                                                "name": "around",
                                                "plural": true,
                                                "selections": v35
                                            },
                                            {
                                                "concreteType": "JiraPageCursor",
                                                "kind": "LinkedField",
                                                "name": "last",
                                                "plural": false,
                                                "selections": v35
                                            }
                                        ]
                                    },
                                    v36,
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            v34
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    v15,
                                    v22
                                ],
                                "concreteType": "JiraIssueSearchFieldSetConnection",
                                "kind": "LinkedField",
                                "name": "fieldSetsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueSearchFieldSetEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueSearchFieldSet",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v25,
                                                    v24,
                                                    v37,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "jqlTerm"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isSortable"
                                                    },
                                                    {
                                                        "concreteType": "JiraFieldSetPreferences",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSetPreferences",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "width"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraFieldType",
                                                        "kind": "LinkedField",
                                                        "name": "fieldType",
                                                        "plural": false,
                                                        "selections": [
                                                            v37
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v31
                                ]
                            },
                            {
                                "condition": "isNotFilterFetch",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "id",
                                                "variableName": "filterAri"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "filter",
                                        "plural": false,
                                        "selections": [
                                            v18,
                                            v26,
                                            v36,
                                            v17
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "62916fb0cee4a7a87d8d551efe8ab24149d69bbf8f24eaba53e646a966f22caf",
                "metadata": {},
                "name": "issueTableViewQuery",
                "operationKind": "query",
                "text": null,
                "providedVariables": {
                    "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, (0, parcelRequire("dttgK")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, (0, parcelRequire("5oQtH")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider": (0, (0, parcelRequire("1kHcz")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrccmdbmediaavatarfgrelayprovider": (0, (0, parcelRequire("hLeia")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider": (0, (0, parcelRequire("G39h7")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider": (0, (0, parcelRequire("1ZvTA")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider": (0, (0, parcelRequire("6vKPN")).default)
                }
            }
        };
    }();
    $328d775330990290$var$node.hash = "14228d16ddcf32403e7f9f5dcc5e1b5e";
    var $328d775330990290$export$2e2bcd8739ae039 = $328d775330990290$var$node;
});
parcelRegister("hLeia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a923685b3e947cff$export$2e2bcd8739ae039);
    var $4R6GH;
    const $a923685b3e947cff$export$8a1714fad3e3d003 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('cmdb_field_avatar_issue_table_from_media');
        }
    };
    var $a923685b3e947cff$export$2e2bcd8739ae039 = $a923685b3e947cff$export$8a1714fad3e3d003;
});
parcelRegister("5oQtH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63783baa7e252f12$export$2e2bcd8739ae039);
    var $6s1PB;
    var $63783baa7e252f12$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("6s1PB")).expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false);
        }
    };
});
parcelRegister("1ZvTA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d6cdb57bd1e2ae2$export$2e2bcd8739ae039);
    var $4R6GH;
    var $2d6cdb57bd1e2ae2$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('nin-issue-links-entry-point') ? 1 : 1000;
        }
    };
});
parcelRegister("G39h7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21fc1eb961f329e9$export$2e2bcd8739ae039);
    var $4R6GH;
    var $21fc1eb961f329e9$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('nin-issue-links-entry-point');
        }
    };
});
parcelRegister("6vKPN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea3753541dd030fd$export$2e2bcd8739ae039);
    var $4R6GH;
    var $ea3753541dd030fd$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('jira_spreadsheet_component_m1_api_updates');
        }
    };
});
parcelRegister("dttgK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7b98ab24c97dab4$export$2e2bcd8739ae039);
    var $4R6GH;
    const $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('jsc_m2_hierarchy_fe_changes');
        }
    };
    var $c7b98ab24c97dab4$export$2e2bcd8739ae039 = $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider;
});
parcelRegister("1kHcz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f1be49b7b7e3e3c$export$2e2bcd8739ae039);
    var $4R6GH;
    var $9f1be49b7b7e3e3c$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('nike_chin_story_points_inline_edit');
        }
    };
});
parcelRegister("8rq2P", function(module, exports) {
    $parcel$export(module.exports, "loadQueryWithUserPrefs", ()=>$3de2b9db429d32f1$export$700e212b8b5c678f);
    var $8Uumt = parcelRequire("8Uumt");
    var $5yJb9;
    var $kipqU;
    var $2mSjU;
    async function $3de2b9db429d32f1$export$700e212b8b5c678f({ filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection }, query, cloudId, activationId, fetchPolicy = 'store-or-network', jql) {
        const { variables: variables } = await (0, (0, parcelRequire("2mSjU")).transformToVariables)({
            userPrefs: {
                filterId: filterId,
                columnNames: columnNames,
                num: num,
                sortField: sortField,
                sortDirection: sortDirection
            },
            cloudId: cloudId,
            activationId: activationId,
            jql: jql
        });
        const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), query, variables, {
            fetchPolicy: fetchPolicy
        });
        if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
        return queryReference;
    }
});
parcelRegister("2mSjU", function(module, exports) {
    $parcel$export(module.exports, "transformToVariables", ()=>$1eea58ad38e5fdd1$export$a5cefa50115212b3);
    var $gbLWS;
    var $6s1PB;
    var $czfFt;
    var $t3Q07;
    var $796ok;
    const $1eea58ad38e5fdd1$export$a5cefa50115212b3 = async ({ userPrefs: userPrefs, cloudId: cloudId, activationId: activationId, jql: jql, fetchIssueTableJqlFields: fetchIssueTableJqlFields })=>{
        const { filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection, showResolved: showResolved } = userPrefs;
        const filterAri = !jql && filterId ? (0, (0, parcelRequire("gbLWS")).JiraFilterAri).create({
            filterId: filterId,
            siteId: cloudId,
            activationId: activationId
        }).toString() : '';
        const variables = {
            cloudId: cloudId,
            issueSearchInput: {
                ...jql ? {
                    jql: jql
                } : {
                    filterId: filterId
                }
            },
            after: null,
            first: num,
            fieldSetIds: columnNames,
            amountOfColumns: (0, (0, parcelRequire("czfFt")).MAX_COLUMNS),
            shouldQueryFieldSetsById: true,
            fieldSetsInput: (0, (0, parcelRequire("6s1PB")).expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? {
                fieldSetIds: columnNames
            } : null,
            isNotFilterFetch: !filterAri,
            filterAri: filterAri
        };
        let fieldToJqlTermMap = new Map();
        if (!sortField || !sortDirection || ![
            'ASC',
            'DESC'
        ].includes(sortDirection)) return {
            variables: variables,
            fieldToJqlTermMap: fieldToJqlTermMap
        };
        let jqlToModify = jql;
        if (fetchIssueTableJqlFields && !jqlToModify && filterAri) {
            const result = await fetchIssueTableJqlFields(filterAri, variables.fieldSetIds, cloudId);
            fieldToJqlTermMap = result.fieldToJqlTermMap;
            jqlToModify = result.searchJql;
        }
        if (!jqlToModify) return {
            variables: variables,
            fieldToJqlTermMap: fieldToJqlTermMap
        };
        const [{ JqlUtils: JqlUtils }, { default: removeFieldClauseFromJql }, { default: findClauseInAst }] = await Promise.all([
            (parcelRequire("aH9Ys")),
            (parcelRequire("dbjD6")),
            (parcelRequire("6nHQF"))
        ]);
        const jqlUtils = new JqlUtils();
        const jqlTermForSortField = (0, (0, parcelRequire("796ok")).getJqlTermForField)(sortField, fieldToJqlTermMap);
        const modifiedJql = jqlUtils.jql(jqlToModify);
        const oldPrimarySortField = modifiedJql.getPrimarySortField();
        if (oldPrimarySortField) {
            const aliases = (0, (0, parcelRequire("t3Q07")).getAliasesForField)(jqlTermForSortField, fieldToJqlTermMap);
            const inclusiveAliases = Array.from(new Set([
                ...aliases,
                oldPrimarySortField
            ]));
            modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, inclusiveAliases);
        } else modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, []);
        let finalJql = modifiedJql.jqlString;
        if (showResolved) {
            const jast = modifiedJql.jast;
            if (jast) {
                const statusClause = findClauseInAst(jast, 'statusCategory');
                if (statusClause) finalJql = removeFieldClauseFromJql(jast, statusClause);
            }
        }
        return {
            variables: {
                ...variables,
                issueSearchInput: {
                    jql: finalJql
                }
            },
            fieldToJqlTermMap: fieldToJqlTermMap
        };
    };
});
parcelRegister("czfFt", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$7f8ee02f08da8eac$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$7f8ee02f08da8eac$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "SORT_ASC", ()=>$7f8ee02f08da8eac$export$88956207daf9a17e);
    $parcel$export(module.exports, "SORT_DESC", ()=>$7f8ee02f08da8eac$export$bc14f97913aaf2a);
    $parcel$export(module.exports, "SORT_NONE", ()=>$7f8ee02f08da8eac$export$9c424bf3e8ffe64e);
    $parcel$export(module.exports, "MODIFY_COLUMNS", ()=>$7f8ee02f08da8eac$export$1f921c78ce6d243c);
    $parcel$export(module.exports, "REORDER_COLUMNS", ()=>$7f8ee02f08da8eac$export$83371d6c41a974aa);
    $parcel$export(module.exports, "MOVE_COLUMN_FIRST", ()=>$7f8ee02f08da8eac$export$957d455bb65919d8);
    $parcel$export(module.exports, "MOVE_COLUMN_LEFT", ()=>$7f8ee02f08da8eac$export$2082861c970802b0);
    $parcel$export(module.exports, "MOVE_COLUMN_RIGHT", ()=>$7f8ee02f08da8eac$export$21847d308b0769ad);
    $parcel$export(module.exports, "MOVE_COLUMN_LAST", ()=>$7f8ee02f08da8eac$export$c32913bc261af82d);
    $parcel$export(module.exports, "ROW_HEIGHT", ()=>$7f8ee02f08da8eac$export$88e6c5bab2ff80e8);
    $parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", ()=>$7f8ee02f08da8eac$export$de4c02b525d877fa);
    $parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", ()=>$7f8ee02f08da8eac$export$c3266da279aa6b84);
    $parcel$export(module.exports, "COLUMN_ID_CHECKBOX", ()=>$7f8ee02f08da8eac$export$66b2a4a5f67468ac);
    $parcel$export(module.exports, "ACTION_COLUMNS", ()=>$7f8ee02f08da8eac$export$3dbdc5c16825be4d);
    $parcel$export(module.exports, "EXPAND_BUTTON_WIDTH", ()=>$7f8ee02f08da8eac$export$a1c171a82c45d53f);
    $parcel$export(module.exports, "CREATE_CHILD_BUTTON_WIDTH", ()=>$7f8ee02f08da8eac$export$43ff8c492b8a2e1b);
    $parcel$export(module.exports, "EXPAND_CELL_PADDING", ()=>$7f8ee02f08da8eac$export$9c5dd6078b37aac2);
    $parcel$export(module.exports, "DEPTH_WIDTH", ()=>$7f8ee02f08da8eac$export$a8273d7d48e89fce);
    $parcel$export(module.exports, "MAX_COLUMNS", ()=>$7f8ee02f08da8eac$export$7ec4af037f372df4);
    $parcel$export(module.exports, "CHILD_QUERY_PAGE_SIZE", ()=>$7f8ee02f08da8eac$export$d2372dfbd4e91a11);
    $parcel$export(module.exports, "KNOWN_COLUMN_TYPES", ()=>$7f8ee02f08da8eac$export$bbc2e8c301f97f97);
    $parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", ()=>$7f8ee02f08da8eac$export$1adf7afff96bbf16);
    $parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH_COMPACT", ()=>$7f8ee02f08da8eac$export$10016003aa27fa67);
    $parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", ()=>$7f8ee02f08da8eac$export$5575b9e0ed3ff59f);
    $parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", ()=>$7f8ee02f08da8eac$export$7c3f559e2ca95fa);
    $parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", ()=>$7f8ee02f08da8eac$export$e1a42c2fefb5af25);
    $parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", ()=>$7f8ee02f08da8eac$export$bfe09a9186b98f8f);
    $parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", ()=>$7f8ee02f08da8eac$export$f2540f34b796306d);
    $parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", ()=>$7f8ee02f08da8eac$export$954afb0fcf5a326);
    $parcel$export(module.exports, "COLUMN_OPERATION_REORDER", ()=>$7f8ee02f08da8eac$export$93758649595b2d58);
    $parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", ()=>$7f8ee02f08da8eac$export$cad8c6a0b6e78898);
    $parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", ()=>$7f8ee02f08da8eac$export$754b76ac8fa63350);
    $parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", ()=>$7f8ee02f08da8eac$export$fa5c7dad7ee16383);
    $parcel$export(module.exports, "DENSITY_COMPACT", ()=>$7f8ee02f08da8eac$export$6c0a5a77457ca62);
    $parcel$export(module.exports, "DENSITY_FULL", ()=>$7f8ee02f08da8eac$export$119d8ab9a5bc4b2);
    $parcel$export(module.exports, "LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE", ()=>$7f8ee02f08da8eac$export$9ef77944c441ad07);
    $parcel$export(module.exports, "LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE", ()=>$7f8ee02f08da8eac$export$c1f680390b97c9e1);
    $parcel$export(module.exports, "CHILD_ITEMS_EXPERIENCE", ()=>$7f8ee02f08da8eac$export$e03155205bf92428);
    $parcel$export(module.exports, "CHILD_ITEMS_LOAD_MORE_EXPERIENCE", ()=>$7f8ee02f08da8eac$export$311c64c0d94dcdf3);
    $parcel$export(module.exports, "GROUPED_ITEMS_EXPERIENCE", ()=>$7f8ee02f08da8eac$export$f5d215df3c6473e9);
    $parcel$export(module.exports, "GROUPED_LOAD_MORE_EXPERIENCE", ()=>$7f8ee02f08da8eac$export$b4fd503bf7cccacd);
    $parcel$export(module.exports, "INLINE_ISSUE_CREATE_EXPERIENCE", ()=>$7f8ee02f08da8eac$export$70f80a241e016093);
    $parcel$export(module.exports, "ANALYTICS_SOURCE", ()=>$7f8ee02f08da8eac$export$f7109619a5e9e0d6);
    const $7f8ee02f08da8eac$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
    const $7f8ee02f08da8eac$export$d57b6b390e78d90f = 'empanada';
    const $7f8ee02f08da8eac$export$88956207daf9a17e = 'ASC';
    const $7f8ee02f08da8eac$export$bc14f97913aaf2a = 'DESC';
    const $7f8ee02f08da8eac$export$9c424bf3e8ffe64e = 'NONE';
    const $7f8ee02f08da8eac$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
    const $7f8ee02f08da8eac$export$83371d6c41a974aa = 'REORDER_COLUMNS';
    const $7f8ee02f08da8eac$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
    const $7f8ee02f08da8eac$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
    const $7f8ee02f08da8eac$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
    const $7f8ee02f08da8eac$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
    const $7f8ee02f08da8eac$export$e2bd4c1faded7921 = '1px';
    const $7f8ee02f08da8eac$export$cdb7fd9d999c7168 = 40;
    const $7f8ee02f08da8eac$export$88e6c5bab2ff80e8 = 40;
    const $7f8ee02f08da8eac$export$d5120333bf67ced2 = ()=>"var(--ds-space-300, 24px)";
    const $7f8ee02f08da8eac$export$a3c854b50595c804 = ()=>"var(--ds-space-050, 4px)";
    const $7f8ee02f08da8eac$export$de4c02b525d877fa = '__issuetable_internal_meatball';
    const $7f8ee02f08da8eac$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
    const $7f8ee02f08da8eac$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
    const $7f8ee02f08da8eac$export$3dbdc5c16825be4d = [
        $7f8ee02f08da8eac$export$c3266da279aa6b84,
        $7f8ee02f08da8eac$export$de4c02b525d877fa
    ];
    const $7f8ee02f08da8eac$export$a1c171a82c45d53f = 24;
    const $7f8ee02f08da8eac$export$43ff8c492b8a2e1b = 24;
    const $7f8ee02f08da8eac$export$9c5dd6078b37aac2 = 16;
    const $7f8ee02f08da8eac$export$a8273d7d48e89fce = 24;
    const $7f8ee02f08da8eac$export$7ec4af037f372df4 = 500;
    const $7f8ee02f08da8eac$export$d2372dfbd4e91a11 = 50;
    const $7f8ee02f08da8eac$export$bbc2e8c301f97f97 = {
        ASSIGNEE: 'assignee',
        CHECKBOX: '__issuetable_internal_checkbox',
        DESCRIPTION: 'description',
        ENVIRONMENT: 'environment',
        EXPAND_BUTTON: '__issuetable_internal_expand_button',
        ISSUE_KEY: 'issuekey',
        ISSUE_OPERATIONS: '__issuetable_internal_meatball',
        STATUS: 'status',
        SUMMARY: 'summary',
        ISSUE_TYPE: 'issuetype',
        RESOLUTION: 'resolution',
        PARENT: 'parent',
        LABELS: 'labels',
        COMPONENTS: 'components',
        FIX_VERSIONS: 'fixVersions',
        STATUS_CATEGORY: 'statusCategory',
        PROJECT: 'project',
        READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
        SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
        TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
        EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
        CREATED: 'created',
        RESOLUTION_DATE: 'resolutiondate',
        TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
        UPDATED: 'updated',
        DUE_DATE: 'duedate',
        REPORTER: 'reporter',
        CREATOR: 'creator',
        PRIORITY: 'priority',
        AFFECTS_VERSIONS: 'versions',
        REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
        NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
        STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points'
    };
    const $7f8ee02f08da8eac$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
    const $7f8ee02f08da8eac$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
    const $7f8ee02f08da8eac$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
    const $7f8ee02f08da8eac$export$10016003aa27fa67 = 40;
    const $7f8ee02f08da8eac$export$5575b9e0ed3ff59f = 69;
    const $7f8ee02f08da8eac$export$7c3f559e2ca95fa = 170;
    const $7f8ee02f08da8eac$export$e1a42c2fefb5af25 = 999;
    const $7f8ee02f08da8eac$export$bfe09a9186b98f8f = 400;
    const $7f8ee02f08da8eac$export$f2540f34b796306d = 300;
    const $7f8ee02f08da8eac$export$954afb0fcf5a326 = 450;
    const $7f8ee02f08da8eac$export$93758649595b2d58 = 'reorder';
    const $7f8ee02f08da8eac$export$cad8c6a0b6e78898 = 'resize';
    const $7f8ee02f08da8eac$export$754b76ac8fa63350 = 'FULL_HEIGHT';
    const $7f8ee02f08da8eac$export$fa5c7dad7ee16383 = 'HEADER_ONLY';
    const $7f8ee02f08da8eac$export$4e8abe16cd1126dd = 'rowReorder';
    const $7f8ee02f08da8eac$export$6c0a5a77457ca62 = 'COMPACT';
    const $7f8ee02f08da8eac$export$119d8ab9a5bc4b2 = 'FULL';
    const $7f8ee02f08da8eac$export$9ef77944c441ad07 = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
    const $7f8ee02f08da8eac$export$c1f680390b97c9e1 = 'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';
    const $7f8ee02f08da8eac$export$e03155205bf92428 = 'loadChildItems';
    const $7f8ee02f08da8eac$export$311c64c0d94dcdf3 = 'loadMoreChildItems';
    const $7f8ee02f08da8eac$export$f5d215df3c6473e9 = 'loadGroupedItems';
    const $7f8ee02f08da8eac$export$b4fd503bf7cccacd = 'loadMoreGroupedItems';
    const $7f8ee02f08da8eac$export$70f80a241e016093 = 'createIssue';
    const $7f8ee02f08da8eac$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
});
parcelRegister("t3Q07", function(module, exports) {
    $parcel$export(module.exports, "getAliasesForField", ()=>$a3816529ae558e1d$export$94d69942fbe58a01);
    const $a3816529ae558e1d$export$94d69942fbe58a01 = (field, fieldToJqlTermMap)=>{
        let term = fieldToJqlTermMap.get(field);
        if (term === undefined) {
            for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === field) {
                term = keyValuePair[1];
                break;
            }
        }
        if (term === undefined) return [];
        const set = new Set();
        set.add(term);
        for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === term) set.add(keyValuePair[0]);
        return Array.from(set);
    };
});
parcelRegister("796ok", function(module, exports) {
    $parcel$export(module.exports, "getJqlTermForField", ()=>$ad837b869bddcad8$export$ef4e8b2c9bc7bd4d);
    var $bCU3R;
    const $ad837b869bddcad8$export$ef4e8b2c9bc7bd4d = (field, fieldToJqlTermMap)=>{
        const convertedField = (0, (0, parcelRequire("bCU3R")).convertFieldToJqlTerm)(field);
        const jqlTermForField = fieldToJqlTermMap.get(convertedField) ?? convertedField;
        return jqlTermForField;
    };
});
parcelRegister("bCU3R", function(module, exports) {
    $parcel$export(module.exports, "convertFieldToJqlTerm", ()=>$1e1011370a3a12e2$export$29f734dc2c61ea9d);
    const $1e1011370a3a12e2$export$29f734dc2c61ea9d = (fieldName)=>{
        if (/^customfield_\d+$/.test(fieldName)) {
            const customFieldId = fieldName.split('customfield_')[1];
            return `cf[${customFieldId}]`;
        }
        return fieldName;
    };
});
parcelRegister("aH9Ys", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dsheJ").then(()=>parcelRequire('aWG9Z'));
});
parcelRegister("dbjD6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1OMFw").then(()=>parcelRequire('eWn4R'));
});
parcelRegister("6nHQF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kK5xY").then(()=>parcelRequire('ajrrh'));
});
parcelRegister("jyMtv", function(module, exports) {
    $parcel$export(module.exports, "transformToValidUserPrefs", ()=>$8cfaebab7e294873$export$e9345b021afd3cc3);
    var $hwva3;
    var $Z4X9T;
    var $hCluT;
    const $8cfaebab7e294873$export$e9345b021afd3cc3 = (rawUserPrefs)=>{
        const pageSize = parseInt(rawUserPrefs.num, 10);
        const fieldSetIds = (0, (0, parcelRequire("hwva3")).convertUserPrefsToColumnNames)(rawUserPrefs.columnNames);
        const stringifiedFilterId = `${rawUserPrefs.filterId}`;
        const { sortDirection: sortDirection, sortField: sortField } = (0, (0, parcelRequire("Z4X9T")).getSortFieldAndDirection)(rawUserPrefs.sortBy);
        const showResolved = !!rawUserPrefs.showResolved;
        return {
            filterId: (0, (0, parcelRequire("hCluT")).isFilterId)(stringifiedFilterId) ? stringifiedFilterId : undefined,
            columnNames: fieldSetIds,
            num: !Number.isNaN(pageSize) ? pageSize : 10,
            sortDirection: sortDirection,
            sortField: sortField,
            showResolved: showResolved
        };
    };
});
parcelRegister("hwva3", function(module, exports) {
    $parcel$export(module.exports, "convertUserPrefsToColumnNames", ()=>$ffa5f3be2fc11704$export$6e5cdc232ebb20cf);
    var $JIPqS;
    const $ffa5f3be2fc11704$export$6e5cdc232ebb20cf = (columns)=>typeof columns === 'string' && columns !== '' && columns !== '--Default--' ? columns.split((0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d)).map((col)=>col.replaceAll((0, $e997f85ca70fa8bf$export$952287cc7aef3a4c), (0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d))) : (0, (0, parcelRequire("JIPqS")).ISSUE_SEARCH_DEFAULT_COLUMNS);
});
const $e997f85ca70fa8bf$export$dd03181e30c7d559 = 5;
const $e997f85ca70fa8bf$export$a3d4af30107c4f4d = '|';
const $e997f85ca70fa8bf$export$952287cc7aef3a4c = '%7C';
parcelRegister("Z4X9T", function(module, exports) {
    $parcel$export(module.exports, "getSortFieldAndDirection", ()=>$834bd6f85e4a1e0d$export$e535bb2dfaa4d10b);
    const $834bd6f85e4a1e0d$export$e535bb2dfaa4d10b = (sortByFromUserPrefs)=>{
        const [sortField, sortDirection] = typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
        if (!sortField || sortDirection !== 'ASC' && sortDirection !== 'DESC') return {};
        return {
            sortField: sortField,
            sortDirection: sortDirection
        };
    };
});
parcelRegister("hCluT", function(module, exports) {
    $parcel$export(module.exports, "isFilterId", ()=>$39fbd6b125bd3cbf$export$23be85030bd58047);
    const $39fbd6b125bd3cbf$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);
});
parcelRegister("26UOd", function(module, exports) {
    $parcel$export(module.exports, "REACT_KEY", ()=>$c373d1a6bf5d7ef6$export$e0e89108956f58f6);
    const $c373d1a6bf5d7ef6$export$c8ae0b83405368ed = 'react/filter-results';
    const $c373d1a6bf5d7ef6$export$d473668bb8826dfe = 'react/assigned-to-me';
    const $c373d1a6bf5d7ef6$export$e079ced6d62149e8 = 'react/issues-in-progress';
    const $c373d1a6bf5d7ef6$export$28c72363adc3f53a = 'react/voted-issues';
    const $c373d1a6bf5d7ef6$export$99faee4082b644a = 'react/watched-issues';
    const $c373d1a6bf5d7ef6$export$25f168992476ecb5 = 'react/custom-report';
    const $c373d1a6bf5d7ef6$export$e0e89108956f58f6 = {
        FILTER_RESULTS: $c373d1a6bf5d7ef6$export$c8ae0b83405368ed,
        ASSIGNED_TO_ME: $c373d1a6bf5d7ef6$export$d473668bb8826dfe,
        ISSUES_IN_PROGRESS: $c373d1a6bf5d7ef6$export$e079ced6d62149e8,
        VOTED_ISSUES: $c373d1a6bf5d7ef6$export$28c72363adc3f53a,
        WATCHED_ISSUES: $c373d1a6bf5d7ef6$export$99faee4082b644a,
        CUSTOM_REPORT: $c373d1a6bf5d7ef6$export$25f168992476ecb5
    };
});
parcelRegister("aVFmC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31463ce0406b73cb$export$2e2bcd8739ae039);
    var $eusud;
    var $31463ce0406b73cb$export$2e2bcd8739ae039 = async ()=>(0, (0, parcelRequire("eusud")).performGetRequest)('/rest/config/1.0/directoryitems.json');
});
parcelRegister("3Zhqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1c788e303134293$export$2e2bcd8739ae039);
    var $5IKQ6;
    var $kspzT;
    var $3Yd87;
    var $kGR9w;
    var $b1c788e303134293$export$2e2bcd8739ae039 = (maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch }, spaContext)=>{
            if (!sharedValue || sharedValue instanceof Error) throw new (0, (0, parcelRequire("3Yd87")).SharedValueAggregateError)({
                sharedValue: sharedValue,
                isPrefetch: isPrefetch,
                name: 'AMD modules resource'
            });
            return (async ()=>{
                const { reactGadgets: nextGadgets } = sharedValue;
                const prev = maybePrevData != null && !(maybePrevData instanceof Error) && maybePrevData.reactGadgetsState || {};
                const persistedGadgets = nextGadgets.filter(({ id: id })=>!!prev[id]);
                const gadgetsToLoad = nextGadgets.filter((gadget)=>{
                    const isConfigurable = !!(0, (0, parcelRequire("kspzT")).default)[gadget.reactKey].componentEdit;
                    const isUnconfigured = isConfigurable && !(0, (0, parcelRequire("5IKQ6")).isGadgetConfigured)(gadget.userPrefs);
                    return !prev[gadget.id] && !isUnconfigured;
                });
                const skippedGadgets = nextGadgets.filter((gadget)=>!prev[gadget.id] && !gadgetsToLoad.some(({ id: id })=>id === gadget.id));
                const reactGadgetsState = {
                    ...Object.fromEntries(persistedGadgets.map(({ id: id })=>[
                            id,
                            prev[id]
                        ])),
                    ...Object.fromEntries(skippedGadgets.map(({ id: id })=>[
                            id,
                            {}
                        ])),
                    ...await (0, (0, parcelRequire("kGR9w")).loadReactGadgets)(gadgetsToLoad, spaContext)
                };
                return {
                    sharedValue: sharedValue,
                    reactGadgetsState: reactGadgetsState
                };
            })();
        };
});
parcelRegister("5IKQ6", function(module, exports) {
    $parcel$export(module.exports, "isGadgetConfigured", ()=>$ce7e823be599a5b0$export$b625fae487818738);
    const $ce7e823be599a5b0$export$b625fae487818738 = (userPrefs)=>userPrefs?.fields.some(({ name: name, value: value })=>name === 'isConfigured' && value === 'true') ?? false;
});
parcelRegister("kGR9w", function(module, exports) {
    $parcel$export(module.exports, "loadReactGadgets", ()=>$ae0204181dcaff49$export$7e1a3455761184a2);
    var $kspzT;
    const $ae0204181dcaff49$var$preloadGadgetBundles = (reactKeys)=>reactKeys.forEach((reactKey)=>{
            (0, (0, parcelRequire("kspzT")).default)[reactKey].preload();
        });
    const $ae0204181dcaff49$export$7e1a3455761184a2 = async (gadgets, spaContext)=>{
        const distinctReactKeys = [
            ...new Set(gadgets.map((gadget)=>gadget.reactKey))
        ];
        $ae0204181dcaff49$var$preloadGadgetBundles(distinctReactKeys);
        return Object.fromEntries(await Promise.all(gadgets.map(({ id: id, reactKey: reactKey, userPrefs: userPrefs })=>(0, (0, parcelRequire("kspzT")).default)[reactKey]?.getInitialState(spaContext, userPrefs?.fields || []).then((state)=>[
                    id,
                    state
                ], (error)=>[
                    id,
                    error
                ]))));
    };
});
parcelRegister("j5mZS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gsMi3")
    ]).then(()=>parcelRequire('iqENN'));
});
parcelRegister("dtemB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hXx3W")
    ]).then(()=>parcelRequire('9aF4A'));
});
parcelRegister("3G01R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("luD3r").then(()=>parcelRequire('7ykDM'));
});
parcelRegister("gE8Ee", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9VuHS")
    ]).then(()=>parcelRequire('7AfLj'));
});
parcelRegister("l7bAo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8AY7a")
    ]).then(()=>parcelRequire('3VYlm'));
});
parcelRegister("hgT7Q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b3iUB")
    ]).then(()=>parcelRequire('dsKht'));
});
parcelRegister("7K4Fs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9RY0k")
    ]).then(()=>parcelRequire('cKcai'));
});
parcelRegister("5gOBf", function(module, exports) {
    $parcel$export(module.exports, "dashboardViewRoute", ()=>$1aac2fbaf8a5979b$export$24f1b2ff97b9d3e6);
    var $65Ltd;
    const $1aac2fbaf8a5979b$export$24f1b2ff97b9d3e6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW),
        path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
        query: [
            'maximized?'
        ],
        exact: true
    };
});
parcelRegister("65UbN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aS4l7").then(()=>parcelRequire('kGKHk'));
});
parcelRegister("bPjHb", function(module, exports) {
    $parcel$export(module.exports, "boardsDirectoryResource", ()=>$817f387e86427323$export$2646f173fa2c14f2);
    var $kbVA4;
    var $2M1hQ;
    const $817f387e86427323$export$2646f173fa2c14f2 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $ee6731a28d0b2341$export$87526c4bd9c78abc),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("4stqG")),
        maxAge: (0, (0, parcelRequire("kbVA4")).MIN_MAX_AGE)
    });
});
const $ee6731a28d0b2341$export$87526c4bd9c78abc = 'BOARDS_DIRECTORY';
parcelRegister("4stqG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5815h").then(()=>parcelRequire('goVIR'));
});
parcelRegister("cFtGt", function(module, exports) {
    $parcel$export(module.exports, "BoardsDirectorySkeleton", ()=>$4855316d4f3a3ac5$export$8194d6e87709f042);
    $parcel$export(module.exports, "DashboardsDirectorySkeleton", ()=>$4855316d4f3a3ac5$export$75ef2bfed3801fb1);
    $parcel$export(module.exports, "FiltersDirectorySkeleton", ()=>$4855316d4f3a3ac5$export$e76f94817327da1);
    $parcel$export(module.exports, "ProjectsDirectorySkeleton", ()=>$4855316d4f3a3ac5$export$d94befb0e231760c);
    $parcel$export(module.exports, "PlansDirectorySkeleton", ()=>$4855316d4f3a3ac5$export$6cd26a09efd6d158);
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $5SWcj = parcelRequire("5SWcj");
    var $8Ta6q = parcelRequire("8Ta6q");
    var $4vyYK = parcelRequire("4vyYK");
    var $4653I = parcelRequire("4653I");
    const $4855316d4f3a3ac5$export$8194d6e87709f042 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($5SWcj)))
        });
    const $4855316d4f3a3ac5$export$75ef2bfed3801fb1 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($8Ta6q)))
        });
    const $4855316d4f3a3ac5$export$e76f94817327da1 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($4vyYK)))
        });
    const $4855316d4f3a3ac5$export$d94befb0e231760c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($4653I)))
        });
    const $4855316d4f3a3ac5$export$6cd26a09efd6d158 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($4653I)))
        });
});
parcelRegister("5SWcj", function(module, exports) {
    module.exports = new URL("boards-directory-app-skeleton.tpl.e4de30a4.svg", import.meta.url).toString();
});
parcelRegister("8Ta6q", function(module, exports) {
    module.exports = new URL("dashboards-directory-app-skeleton.tpl.eb730072.svg", import.meta.url).toString();
});
parcelRegister("4vyYK", function(module, exports) {
    module.exports = new URL("filters-directory-app-skeleton.tpl.6583ea61.svg", import.meta.url).toString();
});
parcelRegister("4653I", function(module, exports) {
    module.exports = new URL("projects-directory-app-skeleton.tpl.a21368f6.svg", import.meta.url).toString();
});
parcelRegister("dg2Zd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("as2Yi")
    ]).then(()=>parcelRequire('3geiu'));
});
parcelRegister("jP33S", function(module, exports) {
    $parcel$export(module.exports, "boardsDirectoryRoute", ()=>$3c2c0ea0e55873e8$export$f0fc6f4e8be87e85);
    var $65Ltd;
    const $3c2c0ea0e55873e8$export$f0fc6f4e8be87e85 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BOARDS_DIRECTORY),
        path: '/jira/boards'
    };
});
parcelRegister("4yCf0", function(module, exports) {
    $parcel$export(module.exports, "dashboardsDirectoryResource", ()=>$c9ec3cc3b6c0608d$export$1cf6c7815471c2a2);
    var $kbVA4;
    var $2M1hQ;
    const $c9ec3cc3b6c0608d$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY = 'DASHBOARDS_DIRECTORY';
    const $c9ec3cc3b6c0608d$export$1cf6c7815471c2a2 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $c9ec3cc3b6c0608d$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY,
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("heoI0")),
        maxAge: (0, (0, parcelRequire("kbVA4")).MIN_MAX_AGE)
    });
});
parcelRegister("heoI0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("yne3O").then(()=>parcelRequire('ciD6c'));
});
parcelRegister("64Xr4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("e9jXk")
    ]).then(()=>parcelRequire('76rrf'));
});
parcelRegister("dDmlh", function(module, exports) {
    $parcel$export(module.exports, "dashboardsDirectoryRoute", ()=>$fd66dc0239264856$export$41bba408475cab16);
    var $65Ltd;
    const $fd66dc0239264856$export$41bba408475cab16 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        path: '/jira/dashboards'
    };
});
parcelRegister("dRl24", function(module, exports) {
    $parcel$export(module.exports, "filtersDirectoryResource", ()=>$8b127055fac893b8$export$53f99086c62225b6);
    var $kbVA4;
    var $2M1hQ;
    const $8b127055fac893b8$export$53f99086c62225b6 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $6d3ffd6df613c846$export$79e191bf6cb15284),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("1EVqG")),
        maxAge: (0, (0, parcelRequire("kbVA4")).MIN_MAX_AGE)
    });
});
const $6d3ffd6df613c846$export$79e191bf6cb15284 = 'FILTERS_DIRECTORY';
parcelRegister("1EVqG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8fxmU").then(()=>parcelRequire('cK9UE'));
});
parcelRegister("lOSli", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7rph3")
    ]).then(()=>parcelRequire('3Zqmb'));
});
parcelRegister("b6S3k", function(module, exports) {
    $parcel$export(module.exports, "filtersDirectoryRoute", ()=>$45a85df0dbaf23d9$export$6350f52c8b40042d);
    var $65Ltd;
    const $45a85df0dbaf23d9$export$6350f52c8b40042d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY),
        path: '/jira/filters'
    };
});
parcelRegister("fsqMg", function(module, exports) {
    $parcel$export(module.exports, "manageProjectsDirectoryRoute", ()=>$3dd7670289805d41$export$281a4490a0f8fb4c);
    var $65Ltd;
    const $3dd7670289805d41$export$281a4490a0f8fb4c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE),
        path: '/jira/settings/projects/manage'
    };
});
parcelRegister("hW253", function(module, exports) {
    $parcel$export(module.exports, "projectsDirectoryPageResource", ()=>$4c805bc331263d5b$export$aabb201a7f7100c5);
    var $8Uumt = parcelRequire("8Uumt");
    var $65Ltd;
    var $gkT9B;
    var $8pIiT;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $lVQ0r;
    var $2M1hQ;
    const $4c805bc331263d5b$export$aabb201a7f7100c5 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, $ce818d5819645fe8$export$2150caade62dc875)}`,
        getKey: ()=>'projects-directory-relay',
        getData: async ({ query: query, route: route }, { tenantContext: tenantContext })=>{
            const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
            if (false && isAnonymous) return null;
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("lVQ0r")).default), {
                cloudId: tenantContext.cloudId,
                filter: (0, (0, parcelRequire("8pIiT")).mapQueryToFilter)((0, (0, parcelRequire("gkT9B")).filterInitialState), {
                    cloudId: cloudId,
                    query: (0, (0, parcelRequire("8pIiT")).sanitizeLegacyQuery)(query),
                    aliases: (0, (0, parcelRequire("gkT9B")).filterAliasMap)
                }),
                first: query?.page ? (0, (0, parcelRequire("gkT9B")).DEFAULT_LIMIT) * (parseInt(query.page, 10) || 1) : (0, (0, parcelRequire("gkT9B")).DEFAULT_LIMIT),
                last: (0, (0, parcelRequire("gkT9B")).DEFAULT_LIMIT),
                isAdminSettingsContext: route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE),
                isAnonymous: isAnonymous
            }, {
                fetchPolicy: 'network-only'
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        }
    });
});
parcelRegister("gkT9B", function(module, exports) {
    $parcel$export(module.exports, "TableColumns", ()=>$4e4ac97bc1b1894b$export$b0e68791ad9c52df);
    $parcel$export(module.exports, "SortableColumns", ()=>$4e4ac97bc1b1894b$export$f9e740ef44a4c43a);
    $parcel$export(module.exports, "FilterFields", ()=>$4e4ac97bc1b1894b$export$e38c2fbdcbc20613);
    $parcel$export(module.exports, "filterAliasMap", ()=>$4e4ac97bc1b1894b$export$5bc0ad9873e5cd89);
    $parcel$export(module.exports, "filterInitialState", ()=>$4e4ac97bc1b1894b$export$fcb7b3e474e67781);
    $parcel$export(module.exports, "DEFAULT_LIMIT", ()=>$4e4ac97bc1b1894b$export$ebc5ec3267fbcf57);
    $parcel$export(module.exports, "PROJECTS_DIRECTORY_EXPERIENCE", ()=>$4e4ac97bc1b1894b$export$7c1bd7128901e2c4);
    $parcel$export(module.exports, "MANAGE_PROJECTS_DIRECTORY_EXPERIENCE", ()=>$4e4ac97bc1b1894b$export$72fb94bf1b8ec849);
    var $7OwSg;
    const $4e4ac97bc1b1894b$export$b0e68791ad9c52df = {
        Favourites: 'favourite',
        Key: 'key',
        Name: 'name',
        Type: 'type',
        Lead: 'lead',
        Category: 'category',
        LastIssueUpdate: 'last_issue_updated_time',
        Url: 'url',
        Action: 'actions'
    };
    const $4e4ac97bc1b1894b$export$f9e740ef44a4c43a = [
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Favourites,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Key,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Name,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Lead,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Category,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.LastIssueUpdate
    ];
    const $4e4ac97bc1b1894b$export$e38c2fbdcbc20613 = {
        Keyword: 'keyword',
        ProjectType: 'types',
        ProjectTypeLabel: 'ProjectTypeLabel',
        ProjectCategoryId: 'projectCategoryId',
        ProjectCategoryLabel: 'projectCategoryLabel',
        ...(0, (0, parcelRequire("7OwSg")).DefaultFilterFields)
    };
    const $4e4ac97bc1b1894b$export$5bc0ad9873e5cd89 = {
        contains: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Keyword,
        selectedProjectType: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectType,
        selectedCategory: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryId
    };
    const $4e4ac97bc1b1894b$export$fcb7b3e474e67781 = {
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Keyword]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectType]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectTypeLabel]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryId]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryLabel]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.SortOrder]: 'ASC',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.SortKey]: $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Name,
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Page]: '1'
    };
    const $4e4ac97bc1b1894b$export$ebc5ec3267fbcf57 = 25;
    const $4e4ac97bc1b1894b$export$7c1bd7128901e2c4 = 'viewProjectsDirectoryV3';
    const $4e4ac97bc1b1894b$export$72fb94bf1b8ec849 = 'viewManageProjectsDirectoryV3';
});
parcelRegister("7OwSg", function(module, exports) {
    $parcel$export(module.exports, "DefaultFilterFields", ()=>$30cd11272c627f6b$export$7ecdd4b6ae40e139);
    $parcel$export(module.exports, "createUseFilter", ()=>$30cd11272c627f6b$export$ef79d9c1dcb09f8f);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $30cd11272c627f6b$export$7ecdd4b6ae40e139 = {
        SortOrder: 'sortOrder',
        SortKey: 'sortKey',
        Page: 'page'
    };
    const $30cd11272c627f6b$export$ef79d9c1dcb09f8f = (storeName, { getInitialState: getInitialState })=>{
        const actions = {
            updateFilter: (nameOrFilter, value)=>({ setState: setState, getState: getState }, { onUpdate: onUpdate })=>{
                    const newFilter = typeof nameOrFilter === 'object' ? nameOrFilter : {
                        [nameOrFilter]: value
                    };
                    setState({
                        ...getState(),
                        [$30cd11272c627f6b$export$7ecdd4b6ae40e139.Page]: 1,
                        ...newFilter
                    });
                    onUpdate(getState());
                },
            forceUpdate: ()=>({ getState: getState }, { onUpdate: onUpdate })=>onUpdate(getState())
        };
        const Store = (0, (0, parcelRequire("iXqE5")).createStore)({
            initialState: {},
            actions: actions,
            name: storeName
        });
        const useFilter = (0, (0, parcelRequire("3sQ5x")).createHook)(Store);
        const useScopedFilter = (0, (0, parcelRequire("3sQ5x")).createHook)(Store, {
            selector: (state, name)=>state[name]
        });
        const FilterContainer = (0, (0, parcelRequire("gg7kZ")).createContainer)(Store, {
            onInit: ()=>({ setState: setState })=>{
                    try {
                        const routeQuery = (0, ($parcel$interopDefault($ebyGx))).parse(window.location.search);
                        setState(getInitialState({
                            routeQuery: routeQuery
                        }));
                    } catch (error) {
                        (0, (0, parcelRequire("jcw0u")).default)({
                            error: error,
                            meta: {
                                id: 'createUseFilter',
                                packageName: 'jiraDirectoryBaseV3',
                                teamName: 'jira-cosmos'
                            }
                        });
                    }
                },
            onCleanup: ()=>({ setState: setState })=>setState(getInitialState({
                        routeQuery: {}
                    }))
        });
        return {
            useFilter: useFilter,
            useScopedFilter: useScopedFilter,
            FilterContainer: FilterContainer
        };
    };
});
parcelRegister("8pIiT", function(module, exports) {
    $parcel$export(module.exports, "sanitizeLegacyQuery", ()=>$ddc7efe5cefc2e09$export$b6d5141c3209bd35);
    $parcel$export(module.exports, "mapQueryToFilter", ()=>$ddc7efe5cefc2e09$export$2274cd5f35844a96);
    var $2vSU6;
    var $dZhZb;
    var $dXq4S;
    var $gkT9B;
    const $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE = 'all';
    const $ddc7efe5cefc2e09$export$b6d5141c3209bd35 = (query)=>({
            ...query,
            selectedProjectType: query.selectedProjectType === $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE ? (0, (0, parcelRequire("gkT9B")).filterInitialState)[(0, (0, parcelRequire("gkT9B")).FilterFields).ProjectType] : query.selectedProjectType,
            selectedCategory: query.selectedCategory === $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE ? (0, (0, parcelRequire("gkT9B")).filterInitialState)[(0, (0, parcelRequire("gkT9B")).FilterFields).ProjectCategoryId] : query.selectedCategory
        });
    const $ddc7efe5cefc2e09$export$2274cd5f35844a96 = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
        const variables = {};
        const { [(0, (0, parcelRequire("gkT9B")).FilterFields).Keyword]: keyword, [(0, (0, parcelRequire("gkT9B")).FilterFields).ProjectCategoryId]: projectCategoryId, [(0, (0, parcelRequire("gkT9B")).FilterFields).ProjectType]: types, [(0, (0, parcelRequire("gkT9B")).FilterFields).SortOrder]: sortOrder, [(0, (0, parcelRequire("gkT9B")).FilterFields).SortKey]: sortKey } = aliases && query ? (0, (0, parcelRequire("dZhZb")).matchAliases)(filter, query, aliases) : filter;
        if (keyword) variables.keyword = keyword;
        if (projectCategoryId) variables.projectCategoryId = (0, (0, parcelRequire("dXq4S")).isAri)(projectCategoryId) ? projectCategoryId : (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
        if (sortKey || sortOrder) {
            const sortByValue = sortKey && (0, (0, parcelRequire("gkT9B")).SortableColumns).includes(sortKey) ? sortKey : (0, (0, parcelRequire("gkT9B")).filterInitialState)[(0, (0, parcelRequire("gkT9B")).FilterFields).SortKey];
            variables.sortBy = {
                order: [
                    'ASC',
                    'DESC'
                ].includes(sortOrder) ? sortOrder : (0, (0, parcelRequire("gkT9B")).filterInitialState)[(0, (0, parcelRequire("gkT9B")).FilterFields).SortOrder],
                sortBy: sortByValue.toUpperCase()
            };
        }
        if (types && typeof types === 'string') variables.types = types.split(',').filter((type)=>(0, (0, parcelRequire("2vSU6")).PROJECT_TYPES).includes(type)).map((type)=>type.toUpperCase());
        return variables;
    };
});
parcelRegister("dZhZb", function(module, exports) {
    $parcel$export(module.exports, "matchAliases", ()=>$e41b5d91b7cfd8ce$export$55f686d7a3507dbe);
    $parcel$export(module.exports, "serializeSelectOptions", ()=>$e41b5d91b7cfd8ce$export$74a705e0bee1565b);
    $parcel$export(module.exports, "serializeSelectOptionsLabel", ()=>$e41b5d91b7cfd8ce$export$eed751fcc55ddadd);
    $parcel$export(module.exports, "matchValueToSelectOptions", ()=>$e41b5d91b7cfd8ce$export$17e142fa55464467);
    var $ggSx2 = parcelRequire("ggSx2");
    var $cuHs1 = parcelRequire("cuHs1");
    const $e41b5d91b7cfd8ce$export$55f686d7a3507dbe = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
            const alias = aliases[key];
            const queryValue = query[key];
            const hasInitialValue = filter[key] !== undefined;
            if (hasInitialValue && queryValue) {
                filter[key] = queryValue;
                return filter;
            }
            if (!alias || !queryValue) return filter;
            filter[alias] = queryValue;
            return filter;
        }, {
            ...filterState
        });
    const $e41b5d91b7cfd8ce$export$40bf1812f0f07002 = (data, aliases)=>{
        const invertedAliases = (0, ($parcel$interopDefault($ggSx2)))(aliases);
        return (0, ($parcel$interopDefault($cuHs1)))(data, (_, key)=>invertedAliases[key] || key);
    };
    const $e41b5d91b7cfd8ce$export$74a705e0bee1565b = (options)=>options.map((v)=>v.value).join(',');
    const $e41b5d91b7cfd8ce$export$eed751fcc55ddadd = (options)=>options.map((v)=>v.label).join(',');
    const $e41b5d91b7cfd8ce$export$17e142fa55464467 = (value, options)=>value ? value.split(',').map((val)=>options.find((option)=>option.value === val)).filter(Boolean) : [];
});
parcelRegister("ggSx2", function(module, exports) {
    var $cxSdl = parcelRequire("cxSdl");
    var $fxKlj = parcelRequire("fxKlj");
    var $etyzk = parcelRequire("etyzk");
    var $bd8870e21c3833a0$var$objectProto = Object.prototype;
    var $bd8870e21c3833a0$var$nativeObjectToString = $bd8870e21c3833a0$var$objectProto.toString;
    var $bd8870e21c3833a0$var$invert = $fxKlj(function(result, value, key) {
        if (value != null && typeof value.toString != 'function') value = $bd8870e21c3833a0$var$nativeObjectToString.call(value);
        result[value] = key;
    }, $cxSdl($etyzk));
    module.exports = $bd8870e21c3833a0$var$invert;
});
parcelRegister("fxKlj", function(module, exports) {
    var $d1nCg = parcelRequire("d1nCg");
    function $b50de2cb57eb155c$var$createInverter(setter, toIteratee) {
        return function(object, iteratee) {
            return $d1nCg(object, setter, toIteratee(iteratee), {});
        };
    }
    module.exports = $b50de2cb57eb155c$var$createInverter;
});
parcelRegister("d1nCg", function(module, exports) {
    var $hDnyx = parcelRequire("hDnyx");
    function $97adb007e27dc709$var$baseInverter(object, setter, iteratee, accumulator) {
        $hDnyx(object, function(value, key, object) {
            setter(accumulator, iteratee(value), key, object);
        });
        return accumulator;
    }
    module.exports = $97adb007e27dc709$var$baseInverter;
});
parcelRegister("lVQ0r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0264f0fee7e7a1be$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    const $0264f0fee7e7a1be$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAdminSettingsContext"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "last"
        }, v6 = [
            {
                "kind": "Variable",
                "name": "isAnonymous",
                "variableName": "isAnonymous"
            }
        ], v7 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v8 = {
            "alias": "canBrowseProjects",
            "args": [
                v7,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "BROWSE_PROJECTS"
                }
            ],
            "concreteType": "JiraPermission",
            "kind": "LinkedField",
            "name": "permission",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasPermission"
                }
            ]
        }, v9 = [
            v7
        ], v10 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v11 = {
            "kind": "ScalarField",
            "name": "id"
        }, v12 = {
            "kind": "ScalarField",
            "name": "name"
        }, v13 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v14 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v15 = {
            "kind": "ScalarField",
            "name": "key"
        }, v16 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v17 = {
            "kind": "ScalarField",
            "name": "totalCount"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5
                ],
                "kind": "Fragment",
                "name": "pageLayout_projectsDirectoryLayout_RootQuery",
                "selections": [
                    {
                        "args": v6,
                        "kind": "FragmentSpread",
                        "name": "header_projectsDirectoryV3"
                    },
                    {
                        "args": v6,
                        "kind": "FragmentSpread",
                        "name": "refinementBar_projectsDirectoryV3_Filters"
                    },
                    {
                        "args": v6,
                        "kind": "FragmentSpread",
                        "name": "projectsList_projectsDirectoryV3_rootQueryRef"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isAdminSettingsContext",
                                "variableName": "isAdminSettingsContext"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "pageLayout_projectsDirectoryV3_ProjectDirectoryLayout"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "emptyView_projectsDirectoryV3"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "noPermissionViews_projectsDirectoryV3"
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v8
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v5,
                    v3,
                    v4
                ],
                "kind": "Operation",
                "name": "pageLayout_projectsDirectoryLayout_RootQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "canCreateProject",
                                "args": [
                                    v7,
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "CREATE_PROJECT"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "canPerform"
                            },
                            {
                                "args": v9,
                                "concreteType": "JiraWorkManagementLicensing",
                                "kind": "LinkedField",
                                "name": "jwmLicensing",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "currentUserSeatEdition"
                                    }
                                ]
                            },
                            {
                                "args": [
                                    v7,
                                    {
                                        "kind": "Variable",
                                        "name": "filter",
                                        "variableName": "filter"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "first",
                                        "variableName": "first"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "last",
                                        "variableName": "last"
                                    }
                                ],
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "allJiraProjects",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": "canViewIssue",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "type",
                                                                "value": "VIEW_ISSUES"
                                                            }
                                                        ],
                                                        "concreteType": "JiraProjectAction",
                                                        "kind": "LinkedField",
                                                        "name": "action",
                                                        "plural": false,
                                                        "selections": v10,
                                                        "storageKey": "action(type:\"VIEW_ISSUES\")"
                                                    },
                                                    v11,
                                                    v12,
                                                    v13,
                                                    {
                                                        "concreteType": "JiraFavouriteValue",
                                                        "kind": "LinkedField",
                                                        "name": "favouriteValue",
                                                        "plural": false,
                                                        "selections": [
                                                            v13,
                                                            v14,
                                                            v11
                                                        ]
                                                    },
                                                    v15,
                                                    {
                                                        "concreteType": "JiraAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "medium"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectStyle"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "navigationMetadata",
                                                        "plural": false,
                                                        "selections": [
                                                            v16,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "boardId"
                                                                    },
                                                                    v11
                                                                ],
                                                                "type": "JiraSoftwareProjectNavigationMetadata"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "queueId"
                                                                    }
                                                                ],
                                                                "type": "JiraServiceManagementProjectNavigationMetadata"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectType"
                                                    },
                                                    {
                                                        "concreteType": "JiraProjectCategory",
                                                        "kind": "LinkedField",
                                                        "name": "category",
                                                        "plural": false,
                                                        "selections": [
                                                            v12,
                                                            v11
                                                        ]
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "lead",
                                                        "plural": false,
                                                        "selections": [
                                                            v16,
                                                            {
                                                                "kind": "TypeDiscriminator",
                                                                "abstractKey": "__isUser"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "accountId"
                                                            },
                                                            v12,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "picture"
                                                            },
                                                            v11
                                                        ]
                                                    },
                                                    {
                                                        "condition": "isAdminSettingsContext",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "alias": "lastUpdatedToolTipDate",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "format",
                                                                        "value": "COMPLETE_DATETIME_FORMAT"
                                                                    }
                                                                ],
                                                                "kind": "ScalarField",
                                                                "name": "lastUpdatedFormatted",
                                                                "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                                                            },
                                                            {
                                                                "alias": "lastUpdatedDisplayDate",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "format",
                                                                        "value": "RELATIVE"
                                                                    }
                                                                ],
                                                                "kind": "ScalarField",
                                                                "name": "lastUpdatedFormatted",
                                                                "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectUrl"
                                                    },
                                                    {
                                                        "alias": "canEdit",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "type",
                                                                "value": "EDIT_PROJECT_CONFIG"
                                                            }
                                                        ],
                                                        "concreteType": "JiraProjectAction",
                                                        "kind": "LinkedField",
                                                        "name": "action",
                                                        "plural": false,
                                                        "selections": v10,
                                                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                    },
                                                    {
                                                        "alias": "canViewProjectConfig",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "type",
                                                                "value": "VIEW_PROJECT_CONFIG"
                                                            }
                                                        ],
                                                        "concreteType": "JiraProjectAction",
                                                        "kind": "LinkedField",
                                                        "name": "action",
                                                        "plural": false,
                                                        "selections": v10,
                                                        "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                                                    },
                                                    {
                                                        "alias": "jiraProjectType",
                                                        "kind": "ScalarField",
                                                        "name": "projectType"
                                                    },
                                                    {
                                                        "alias": "jiraProjectName",
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v17,
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isHasTotal"
                                    }
                                ]
                            },
                            {
                                "alias": "canContactAdmin",
                                "args": [
                                    v7,
                                    {
                                        "kind": "Literal",
                                        "name": "keys",
                                        "value": "jira.show.contact.administrators.form"
                                    }
                                ],
                                "concreteType": "JiraApplicationProperty",
                                "kind": "LinkedField",
                                "name": "applicationPropertiesByKey",
                                "plural": true,
                                "selections": [
                                    v15,
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    v11
                                ]
                            },
                            v8,
                            {
                                "condition": "isAnonymous",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": v9,
                                        "concreteType": "JiraUserPreferences",
                                        "kind": "LinkedField",
                                        "name": "userPreferences",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "projectListRightPanelState"
                                            },
                                            v14
                                        ]
                                    },
                                    {
                                        "alias": "sidebarExperimentTemplates",
                                        "args": [
                                            v7,
                                            {
                                                "kind": "Literal",
                                                "name": "experimentKey",
                                                "value": "sidebarExperiment"
                                            }
                                        ],
                                        "concreteType": "JiraProjectListViewTemplateConnection",
                                        "kind": "LinkedField",
                                        "name": "projectListViewTemplates",
                                        "plural": false,
                                        "selections": [
                                            v17
                                        ]
                                    },
                                    {
                                        "args": v9,
                                        "concreteType": "JiraProjectCategoryConnection",
                                        "kind": "LinkedField",
                                        "name": "allJiraProjectCategories",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectCategoryEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v16
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "isAnonymous",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": v9,
                                        "concreteType": "JiraProjectCategoryConnection",
                                        "kind": "LinkedField",
                                        "name": "allJiraProjectCategories",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectCategoryEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v16,
                                                    {
                                                        "concreteType": "JiraProjectCategory",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11,
                                                            v12
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v9,
                                "concreteType": "JiraProjectTypeDetailsConnection",
                                "kind": "LinkedField",
                                "name": "allJiraProjectTypes",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectTypeDetailsEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectTypeDetails",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v15,
                                                    v11
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "af9ae1db2f285065c82807efe7982bd15a72bebc7c10b3ab0526c030f540c5ad",
                "metadata": {},
                "name": "pageLayout_projectsDirectoryLayout_RootQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $0264f0fee7e7a1be$var$node.hash = "79e5d8b7d31b85f08887cf9e30d9953a";
    (0, $eiowN.PreloadableQueryRegistry).set($0264f0fee7e7a1be$var$node.params.id, $0264f0fee7e7a1be$var$node);
    var $0264f0fee7e7a1be$export$2e2bcd8739ae039 = $0264f0fee7e7a1be$var$node;
});
const $ce818d5819645fe8$export$2150caade62dc875 = 'PROJECTS_DIRECTORY_RELAY';
parcelRegister("3OnPz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fFisX")
    ]).then(()=>parcelRequire('eBOH6'));
});
parcelRegister("6xeDr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("5lud9")
    ]).then(()=>parcelRequire('1ExYN'));
});
parcelRegister("aljyN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5jhjf")
    ]).then(()=>parcelRequire('j3Lmi'));
});
parcelRegister("8jQu6", function(module, exports) {
    $parcel$export(module.exports, "plansDirectoryRoute", ()=>$f8b07af15c3bb184$export$143b4a1ef2ffc051);
    var $65Ltd;
    const $f8b07af15c3bb184$export$143b4a1ef2ffc051 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLANS_DIRECTORY),
        path: '/jira/plans'
    };
});
parcelRegister("lBR19", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5XLCy")
    ]).then(()=>parcelRequire('flZBd'));
});
parcelRegister("foR3E", function(module, exports) {
    $parcel$export(module.exports, "projectsDirectoryRoute", ()=>$00577c595d2649c4$export$74114064f06cd71b);
    var $65Ltd;
    const $00577c595d2649c4$export$74114064f06cd71b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY),
        path: '/jira/projects',
        exact: true
    };
});
parcelRegister("6YWw1", function(module, exports) {
    $parcel$export(module.exports, "resources", ()=>$89b6fb9884e4755e$export$bc99aaabaf7b70a7);
    var $7fV7n;
    var $1YfAT;
    var $7J53H;
    var $eyLtQ;
    const $89b6fb9884e4755e$export$bc99aaabaf7b70a7 = {
        configuredSyncsResource: (0, parcelRequire("7fV7n")).configuredSyncsResource,
        userAccessRightsResource: (0, parcelRequire("eyLtQ")).userAccessRightsResource,
        getTeamResource: (0, parcelRequire("7J53H")).getTeamResource,
        isCurrentSiteSyncEnabledResource: (0, parcelRequire("1YfAT")).isCurrentSiteSyncEnabledResource
    };
});
parcelRegister("7fV7n", function(module, exports) {
    $parcel$export(module.exports, "configuredSyncsResource", ()=>$780664dfd818f1ba$export$333c290f4a1ec41c);
    var $2M1hQ;
    var $l116g;
    var $fCcRT;
    const $780664dfd818f1ba$export$333c290f4a1ec41c = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'configuredSyncsResource',
        getKey: ({ query: query, match: match })=>{
            const teamId = match.params.teamId ?? query['teamId'];
            const keyword = query['keyword'];
            const type = query['type'];
            const page = query['page'] || '1';
            const status = query['status'];
            return (0, (0, parcelRequire("l116g")).UrlHelper)('configuredSyncsResource', {
                page: page,
                keyword: keyword,
                type: type,
                status: status,
                teamId: teamId
            });
        },
        getData: (routerContext)=>(0, (0, parcelRequire("fCcRT")).default).getSyncs(routerContext.query, routerContext.match.params.teamId),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("l116g", function(module, exports) {
    $parcel$export(module.exports, "UrlHelper", ()=>$2539490b962657de$export$bacbc496e850c0a4);
    const $2539490b962657de$export$bacbc496e850c0a4 = (path, params = {})=>{
        const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
                k,
                v.toString()
            ] : undefined).filter((v)=>!!v);
        const qs = new URLSearchParams(q).toString();
        return `${path}${qs ? `?${qs}` : ''}`;
    };
});
parcelRegister("fCcRT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4cc94b3364931bb$export$2e2bcd8739ae039);
    var $j74qU;
    var $l116g;
    const $a4cc94b3364931bb$var$getSyncs = async (query, pathParamTeamId)=>{
        const page = parseInt(query['page']) || 1;
        const offset = (page - 1) * (0, $85d01ad7b2541e2c$export$31ecae7225aecec6);
        const queryParams = query ? {
            teamId: pathParamTeamId ?? query.teamId,
            type: query.type,
            keyword: query.keyword,
            status: query.status
        } : {};
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("l116g")).UrlHelper)('/v1/entity-sync/unified', {
            ...queryParams,
            offset: offset.toString(),
            limit: (0, $85d01ad7b2541e2c$export$31ecae7225aecec6)
        })).then((response)=>({
                data: response.data.integrations,
                pageCount: Math.ceil(response.data.count / (0, $85d01ad7b2541e2c$export$31ecae7225aecec6)),
                itemCount: response.data.count
            }));
    };
    const $a4cc94b3364931bb$var$patchSync = async (syncId, syncType, body, teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("l116g")).UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
            type: syncType,
            teamId: teamId
        }), {
            method: 'PATCH',
            body: body
        }).then((response)=>response.data);
    const $a4cc94b3364931bb$var$deleteSync = async (syncId, syncType, teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("l116g")).UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
            type: syncType,
            teamId: teamId
        }), {
            method: 'DELETE',
            responseType: 'headers'
        });
    var $a4cc94b3364931bb$export$2e2bcd8739ae039 = {
        getSyncs: $a4cc94b3364931bb$var$getSyncs,
        patchSync: $a4cc94b3364931bb$var$patchSync,
        deleteSync: $a4cc94b3364931bb$var$deleteSync
    };
});
const $85d01ad7b2541e2c$export$31ecae7225aecec6 = 20;
parcelRegister("1YfAT", function(module, exports) {
    $parcel$export(module.exports, "isCurrentSiteSyncEnabledResource", ()=>$53dacb41f1b977c2$export$94465df791bf80);
    var $2M1hQ;
    var $9d6Ve;
    const $53dacb41f1b977c2$export$94465df791bf80 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'isCurrentSiteSyncEnabledResource',
        getKey: ()=>`isCurrentSiteSyncEnabledResource`,
        getData: (0, (0, parcelRequire("9d6Ve")).getIsCurrentSiteSyncEnabled),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("9d6Ve", function(module, exports) {
    $parcel$export(module.exports, "getIsCurrentSiteSyncEnabled", ()=>$84b302591901e719$export$93fc09e39edf63d0);
    var $j74qU;
    const $84b302591901e719$export$93fc09e39edf63d0 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/entity-sync/is-current-site-enabled`).then((response)=>response.data.enabled);
});
parcelRegister("7J53H", function(module, exports) {
    $parcel$export(module.exports, "getTeamResource", ()=>$3559e86ca19d1712$export$50271c9e7f21f10e);
    var $2M1hQ;
    var $hmVmJ;
    var $dH6Pi;
    var $7n8Dv;
    const $3559e86ca19d1712$export$50271c9e7f21f10e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'getSyncTeamResource',
        getKey: (routerContext)=>`getSyncTeamResource#${routerContext.match.params?.teamId}`,
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('getTeamResource', 'teamId should be set to fetch the team'));
            const result = await (0, (0, parcelRequire("7n8Dv")).getTeam)(teamId);
            return result ?? null;
        },
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("hmVmJ", function(module, exports) {
    $parcel$export(module.exports, "assert", ()=>$e903ea4af1073086$export$a7a9523472993e97);
    var $dH6Pi;
    const $e903ea4af1073086$export$a7a9523472993e97 = function(condition, err) {
        if (!condition) throw err;
    };
});
parcelRegister("dH6Pi", function(module, exports) {
    $parcel$export(module.exports, "AssertionError", ()=>$51d685c1b4e62326$export$7750cdfb4db2c3d);
    class $51d685c1b4e62326$export$7750cdfb4db2c3d extends Error {
        constructor(id, message){
            super(`[${id}] ${message}`), this.id = id;
        }
    }
});
parcelRegister("7n8Dv", function(module, exports) {
    $parcel$export(module.exports, "getTeam", ()=>$5f911005aed87c97$export$491fe77f22ab2b51);
    var $j74qU;
    const $5f911005aed87c97$export$491fe77f22ab2b51 = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/responders/names`, {
            method: 'POST',
            body: {
                responders: [
                    {
                        id: teamId,
                        type: 'team'
                    }
                ]
            }
        }).then((response)=>response.values.filter((responder)=>!responder.deleted).at(0));
});
parcelRegister("eyLtQ", function(module, exports) {
    $parcel$export(module.exports, "userAccessRightsResource", ()=>$85ca4565e2692c52$export$69ddc7cc64ae9a02);
    var $2M1hQ;
    var $3mt67;
    const $85ca4565e2692c52$export$69ddc7cc64ae9a02 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'userAccessRightsResource',
        getKey: ()=>'userAccessRightsResource',
        getData: (routerContext)=>(0, (0, parcelRequire("3mt67")).getUserRights)(routerContext.match.params.teamId),
        maxAge: 600000,
        isBrowserOnly: true
    });
});
parcelRegister("3mt67", function(module, exports) {
    $parcel$export(module.exports, "getUserRights", ()=>$565f7a833d907135$export$84e2ed279bc4e64e);
    var $j74qU;
    var $l116g;
    const $565f7a833d907135$export$84e2ed279bc4e64e = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("l116g")).UrlHelper)(`/v1/entity-sync/unified/rights`, {
            teamId: teamId
        })).then((response)=>response.data.userAccessRights);
    };
});
parcelRegister("kXCTu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2AP6O").then(()=>parcelRequire('fBQfD'));
});
parcelRegister("5dO1t", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fBjqh")
    ]).then(()=>parcelRequire('gAySz'));
});
parcelRegister("2r8fH", function(module, exports) {
    $parcel$export(module.exports, "teamResource", ()=>$77662e91dfb33ae6$export$87453d709b90ccdf);
    $parcel$export(module.exports, "sidebarRightsResource", ()=>$77662e91dfb33ae6$export$3b3b9a5b0eddde66);
    $parcel$export(module.exports, "resources", ()=>$77662e91dfb33ae6$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $hmVmJ;
    var $dH6Pi;
    var $5iPTg;
    const $77662e91dfb33ae6$export$87453d709b90ccdf = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'teamResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `team-dashboard/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('teamSidebarResource', 'teamId should be set to fetch team-dashboard'));
            return (0, (0, parcelRequire("5iPTg")).getTeamByIdEndpoint)(teamId);
        },
        maxAge: 300000,
        isBrowserOnly: true
    });
    const $77662e91dfb33ae6$export$3b3b9a5b0eddde66 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'sidebarRightsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `team-dashboard/${teamId ?? ''}/sidebar-rights`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('teamSidebarResource', 'teamId should be set to fetch sidebar rights'));
            return (0, (0, parcelRequire("5iPTg")).getSidebarRightsEndpoint)(teamId);
        },
        isBrowserOnly: true,
        maxAge: Infinity
    });
    const $77662e91dfb33ae6$export$bc99aaabaf7b70a7 = [
        $77662e91dfb33ae6$export$87453d709b90ccdf,
        $77662e91dfb33ae6$export$3b3b9a5b0eddde66
    ];
});
parcelRegister("5iPTg", function(module, exports) {
    $parcel$export(module.exports, "getTeamByIdEndpoint", ()=>$03a26ab2fa346c2e$export$bcb25b347f39b3f3);
    $parcel$export(module.exports, "getSidebarRightsEndpoint", ()=>$03a26ab2fa346c2e$export$6f1f62156c62eb91);
    var $j74qU;
    const $03a26ab2fa346c2e$export$bcb25b347f39b3f3 = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}?includeImageUrls=true`);
    const $03a26ab2fa346c2e$export$6f1f62156c62eb91 = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/menu-rights`);
    };
});
parcelRegister("15g3q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dXWqK")
    ]).then(()=>parcelRequire('hMnGK'));
});
parcelRegister("jmq4o", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("69byx")
    ]).then(()=>parcelRequire('10YpK'));
});
parcelRegister("cQXYd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iRSLc").then(()=>parcelRequire('c3FF8'));
});
parcelRegister("8cAy7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g3ZhW").then(()=>parcelRequire('dSHkM'));
});
parcelRegister("2T8SP", function(module, exports) {
    $parcel$export(module.exports, "apiKeysResource", ()=>$78235b6a5aa26e7e$export$a98d5421eda11f29);
    $parcel$export(module.exports, "resources", ()=>$78235b6a5aa26e7e$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    parcelRequire("jxRF2");
    var $ldKOT;
    var $3do1I;
    const $78235b6a5aa26e7e$export$a98d5421eda11f29 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'api-key-management',
        getKey: ()=>'api-key-management',
        getData: async ({ dependencies: dependencies })=>{
            const data = await dependencies[(0, (0, parcelRequire("ldKOT")).eocUserResource).type]?.promise;
            return (0, (0, parcelRequire("3do1I")).fetchKeys)(data.accountId);
        },
        isBrowserOnly: true,
        maxCache: 0,
        maxAge: 0,
        depends: [
            (0, (0, parcelRequire("ldKOT")).eocUserResource).type
        ]
    });
    const $78235b6a5aa26e7e$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("ldKOT")).eocUserResource),
        $78235b6a5aa26e7e$export$a98d5421eda11f29
    ];
});
parcelRegister("jxRF2", function(module, exports) {
    $parcel$export(module.exports, "eocCommonResources", ()=>$9675469e92ce170a$export$8977bbbf2f7167d2);
    $parcel$export(module.exports, "eocUserResource", ()=>(parcelRequire("ldKOT")).eocUserResource);
    var $ldKOT;
    const $9675469e92ce170a$export$8977bbbf2f7167d2 = ()=>[
            (0, (0, parcelRequire("ldKOT")).eocUserResource)
        ];
});
parcelRegister("ldKOT", function(module, exports) {
    $parcel$export(module.exports, "eocUserResource", ()=>$0e22e6fd8475b5e0$export$3a08a0bdeef86956);
    var $2M1hQ;
    var $jonVZ;
    const $0e22e6fd8475b5e0$export$3a08a0bdeef86956 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'create-user-resource',
        getKey: ()=>'create-user-resource',
        getData: async ()=>(0, (0, parcelRequire("jonVZ")).fetchJsmUserInfo)(),
        maxAge: Infinity,
        isBrowserOnly: true
    });
});
parcelRegister("jonVZ", function(module, exports) {
    $parcel$export(module.exports, "fetchJsmUserInfo", ()=>$189024051479d227$export$7d750310098b5a7);
    var $j74qU;
    var $030R0;
    const $189024051479d227$var$JSM_BASE_URL = '/rest/api/3/myself';
    const $189024051479d227$export$7d750310098b5a7 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)($189024051479d227$var$JSM_BASE_URL, {
            exactUrl: true,
            errorTransformer: (0, (0, parcelRequire("030R0")).jsmErrorTransformer)
        });
    };
});
parcelRegister("3do1I", function(module, exports) {
    $parcel$export(module.exports, "fetchKeys", ()=>$064b2b209b19aeee$export$a0d93e1b78b8e70b);
    $parcel$export(module.exports, "deleteApiKey", ()=>$064b2b209b19aeee$export$d2f8649a375a4113);
    var $j74qU;
    const $064b2b209b19aeee$export$a0d93e1b78b8e70b = async (accountId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/api-keys/web?accountId=' + accountId);
    };
    const $064b2b209b19aeee$export$d2f8649a375a4113 = async (key, accountId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/api-keys/web?apiKey=${key}&accountId=${accountId}`, {
            method: 'DELETE'
        });
    };
});
parcelRegister("lPEDD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("e41T5")
    ]).then(()=>parcelRequire('95iLR'));
});
parcelRegister("jqlWU", function(module, exports) {
    $parcel$export(module.exports, "rolesResource", ()=>$662177b4cdfd6303$export$52e29d5915d5f674);
    $parcel$export(module.exports, "resources", ()=>$662177b4cdfd6303$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $c4XwU;
    const $662177b4cdfd6303$export$52e29d5915d5f674 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'rolesResource',
        getKey: ()=>'rolesResource',
        getData: (0, (0, parcelRequire("c4XwU")).getRolesEndpoint),
        isBrowserOnly: true
    });
    const $662177b4cdfd6303$export$bc99aaabaf7b70a7 = [
        $662177b4cdfd6303$export$52e29d5915d5f674
    ];
});
parcelRegister("c4XwU", function(module, exports) {
    $parcel$export(module.exports, "getUsersEndpoint", ()=>$3d7f15d2403fdf59$export$d372f7d69e481dba);
    $parcel$export(module.exports, "getFilteredUsersEndpoint", ()=>$3d7f15d2403fdf59$export$d8f86d9603f031c0);
    $parcel$export(module.exports, "getRolesEndpoint", ()=>$3d7f15d2403fdf59$export$7d0bc1a3c689fc74);
    $parcel$export(module.exports, "updateRoleOfUserEndpoint", ()=>$3d7f15d2403fdf59$export$a0b296dc0259976f);
    var $j74qU;
    var $3m952;
    const $3d7f15d2403fdf59$export$d372f7d69e481dba = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
        const [_, query] = queryKey;
        let url = new (0, (0, parcelRequire("3m952")).URLBuilder)(`/v1/users/search`).withQueryParam('limit', limit).withQueryParam('query', query).withQueryParam('cursor', lastEvaluatedToken).build();
        return (0, (0, parcelRequire("j74qU")).eocFetch)(url);
    };
    const $3d7f15d2403fdf59$export$d8f86d9603f031c0 = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
        const [_, ...filters] = queryKey;
        if (filters.length === 0) return Promise.resolve({
            lastEvaluatedToken: '',
            values: []
        });
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/users/roles/filter', {
            method: 'POST',
            body: {
                limit: limit,
                roles: filters,
                offset: lastEvaluatedToken || 0
            }
        });
    };
    const $3d7f15d2403fdf59$export$7d0bc1a3c689fc74 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/users/roles');
    };
    const $3d7f15d2403fdf59$export$a0b296dc0259976f = ({ roleId: roleId, accountId: accountId })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/roles/assign`, {
            method: 'PATCH',
            body: {
                accountId: accountId,
                roleId: roleId
            }
        });
    };
});
parcelRegister("3m952", function(module, exports) {
    $parcel$export(module.exports, "URLBuilder", ()=>$3c9748f3251c69d7$export$61d2e8db329a11f8);
    class $3c9748f3251c69d7$export$61d2e8db329a11f8 {
        constructor(url){
            this.url = url;
            this.params = {};
        }
        withQueryParam(key, value) {
            this.params[key] = value;
            return this;
        }
        build() {
            const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '').map(([key, value])=>[
                    key,
                    value && value.toString()
                ]);
            const queryInstance = new URLSearchParams(filteredParams);
            const queryParams = queryInstance.toString();
            if (queryParams === '') return `${this.url}`;
            if (queryParams) return `${this.url}?${queryParams}`;
            return this.url;
        }
    }
});
parcelRegister("fXO8u", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ligT4")
    ]).then(()=>parcelRequire('i3AK8'));
});
parcelRegister("ejRCG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9mAAJ").then(()=>parcelRequire('j6Qxa'));
});
parcelRegister("7ygGB", function(module, exports) {
    $parcel$export(module.exports, "customRolesResource", ()=>$010682625a4b0c54$export$7140716a1b1b8e7a);
    $parcel$export(module.exports, "resources", ()=>$010682625a4b0c54$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $hnjQD;
    const $010682625a4b0c54$export$7140716a1b1b8e7a = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'rolesResource',
        getKey: ()=>'rolesResource',
        getData: (0, (0, parcelRequire("hnjQD")).getCustomRolesListEndpoint),
        isBrowserOnly: true
    });
    const $010682625a4b0c54$export$bc99aaabaf7b70a7 = [
        $010682625a4b0c54$export$7140716a1b1b8e7a
    ];
});
parcelRegister("hnjQD", function(module, exports) {
    $parcel$export(module.exports, "getPermissionsEndpoint", ()=>$32ca3dc706b725ff$export$f97b589720c51ce1);
    $parcel$export(module.exports, "createCustomRoleEndpoint", ()=>$32ca3dc706b725ff$export$5a7187e04c844900);
    $parcel$export(module.exports, "editCustomRoleEndpoint", ()=>$32ca3dc706b725ff$export$304735a80b86192e);
    $parcel$export(module.exports, "deleteCustomRoleEndpoint", ()=>$32ca3dc706b725ff$export$e12995ccad013f65);
    $parcel$export(module.exports, "getCustomRolesListEndpoint", ()=>$32ca3dc706b725ff$export$3619edac53aa59fd);
    var $j74qU;
    const $32ca3dc706b725ff$export$f97b589720c51ce1 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/permissions`);
    const $32ca3dc706b725ff$export$5a7187e04c844900 = (newCustomRole)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/roles`, {
            method: 'POST',
            body: newCustomRole
        });
    const $32ca3dc706b725ff$export$304735a80b86192e = (updatedCustomRole)=>{
        const { id: id } = updatedCustomRole;
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/roles/${id}`, {
            method: 'PATCH',
            body: updatedCustomRole
        });
    };
    const $32ca3dc706b725ff$export$e12995ccad013f65 = (id)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/roles/${id}`, {
            method: 'DELETE'
        });
    };
    const $32ca3dc706b725ff$export$3619edac53aa59fd = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/roles`);
});
parcelRegister("6hhHS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("47IHZ").then(()=>parcelRequire('WACar'));
});
parcelRegister("6hGfG", function(module, exports) {
    $parcel$export(module.exports, "alertGroupingStateResource", ()=>$9de427fa65011ef0$export$722cc8285202ce44);
    var $2M1hQ;
    var $3dV2P;
    const $9de427fa65011ef0$var$emptyAlertGroupingState = {
        isEnabled: false,
        reason: null
    };
    const $9de427fa65011ef0$export$722cc8285202ce44 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'alertGroupingStateResource',
        getKey: ()=>'alertGroupingStateResource',
        getData: async ()=>{
            try {
                const response = await (0, (0, parcelRequire("3dV2P")).getGroupFeatureStatus)();
                return response;
            } catch (e) {
                return $9de427fa65011ef0$var$emptyAlertGroupingState;
            }
        },
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("3dV2P", function(module, exports) {
    $parcel$export(module.exports, "getGroupFeatureStatus", ()=>$c990dc5854960610$export$48deee62d9dfb365);
    var $1Dhlz;
    var $j74qU;
    var $1Z10l;
    const $c990dc5854960610$export$48deee62d9dfb365 = ()=>{
        const url = new (0, (0, parcelRequire("1Dhlz")).URLBuilder)((0, (0, parcelRequire("1Z10l")).withAIOpsDomainPrefix)('/v1/aiops/feature-state')).withQueryParam('featureName', 'alert-grouping').build();
        return (0, (0, parcelRequire("j74qU")).eocFetch)(url, {
            exactUrl: true
        });
    };
});
parcelRegister("1Dhlz", function(module, exports) {
    $parcel$export(module.exports, "URLBuilder", ()=>$3d24b3de45ba1bce$export$61d2e8db329a11f8);
    class $3d24b3de45ba1bce$export$61d2e8db329a11f8 {
        constructor(url){
            this.url = url;
            this.params = {};
        }
        withQueryParam(key, value) {
            this.params[key] = value;
            return this;
        }
        build() {
            const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '');
            const queryInstance = new URLSearchParams(filteredParams);
            const queryParams = queryInstance.toString();
            if (queryParams) return `${this.url}?${queryParams}`;
            return this.url;
        }
    }
});
parcelRegister("1Z10l", function(module, exports) {
    $parcel$export(module.exports, "validateTimeInput", ()=>$63876a0dc22d7edb$export$8880da3ae4274888);
    $parcel$export(module.exports, "validateBetweenInput", ()=>$63876a0dc22d7edb$export$57c3e855fbf300fa);
    $parcel$export(module.exports, "isInvalidDateValue", ()=>$63876a0dc22d7edb$export$f18cd4bc58b99a27);
    $parcel$export(module.exports, "removeQuotes", ()=>$63876a0dc22d7edb$export$dd2bdf5049bf0915);
    $parcel$export(module.exports, "withQuote", ()=>$63876a0dc22d7edb$export$8708814d32e406db);
    $parcel$export(module.exports, "calculateTimes", ()=>$63876a0dc22d7edb$export$b362bc6892126b7a);
    $parcel$export(module.exports, "getDefaultFilterQuery", ()=>$63876a0dc22d7edb$export$16cce822d8159876);
    $parcel$export(module.exports, "isResponderAlert", ()=>$63876a0dc22d7edb$export$78656db4ffc3ccd8);
    $parcel$export(module.exports, "isGroupAlert", ()=>$63876a0dc22d7edb$export$be2243d4df51c704);
    $parcel$export(module.exports, "withAIOpsDomainPrefix", ()=>$63876a0dc22d7edb$export$81c70e0016508593);
    $parcel$export(module.exports, "getCloudIdForDevEnvironment", ()=>$63876a0dc22d7edb$export$fc6ce7ac2248d7f5);
    var $jovBr;
    var $eZDAP;
    var $gn1v9;
    var $VSDnB;
    var $030R0;
    var $j6OA2;
    var $39KIs;
    var $5F4Xi;
    var $6cAn5 = parcelRequire("6cAn5");
    const $63876a0dc22d7edb$export$8880da3ae4274888 = (intl, timeDigits, timeUnit)=>{
        if (!timeDigits) return;
        const timeDigitsNumber = parseInt(timeDigits);
        if (isNaN(timeDigitsNumber)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).validNumber);
        if (timeUnit === 'hours' && (timeDigitsNumber < 1 || timeDigitsNumber > 99999)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).hoursNotInRange);
        if (timeUnit === 'days' && (timeDigitsNumber < 1 || timeDigitsNumber > 9999)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).daysNotInRange);
        if (timeUnit === 'weeks' && (timeDigitsNumber < 1 || timeDigitsNumber > 999)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).weeksNotInRange);
        if (timeUnit === 'months' && (timeDigitsNumber < 1 || timeDigitsNumber > 99)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).monthsNotInRange);
        if (timeUnit === 'years' && (timeDigitsNumber < 1 || timeDigitsNumber > 9)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).yearsNotInRange);
    };
    const $63876a0dc22d7edb$export$57c3e855fbf300fa = (intl, value)=>{
        if (value) {
            const { startDate: startDate, endDate: endDate } = value;
            if (!startDate && !endDate) return;
            if (startDate && endDate && new Date(startDate) > new Date(endDate)) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).validationMessageBeforeGreaterThanAfter);
            if (value && (startDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(startDate)) || endDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(endDate)))) return intl.formatMessage((0, (0, parcelRequire("5F4Xi")).default).validationMessageInvalidDateFormat);
        }
        return;
    };
    const $63876a0dc22d7edb$export$f18cd4bc58b99a27 = (value)=>{
        return !(0, (0, parcelRequire("jovBr")).default)((0, (0, parcelRequire("eZDAP")).default)(value)) && value !== '';
    };
    const $63876a0dc22d7edb$export$dd2bdf5049bf0915 = (value)=>{
        return value.replace(/^"(.*)"$/, '$1');
    };
    const $63876a0dc22d7edb$export$d4aae9ad13afd6c = (data)=>{
        return {
            ...data,
            label: data.name,
            value: data.id
        };
    };
    const $63876a0dc22d7edb$export$8708814d32e406db = (value)=>{
        if ((0, (0, parcelRequire("j6OA2")).hasSpaceRegEx).test(value) || (0, (0, parcelRequire("j6OA2")).hasColonRegex).test(value)) return `${0, (0, parcelRequire("39KIs")).STRING_LITERAL_DOUBLE_QUOTE}${value}${0, (0, parcelRequire("39KIs")).STRING_LITERAL_DOUBLE_QUOTE}`;
        else return value;
    };
    const $63876a0dc22d7edb$export$b362bc6892126b7a = (time)=>{
        if (!time) return {
            from: undefined,
            to: undefined
        };
        if (time.range === 'all') return {
            from: undefined,
            to: undefined
        };
        if (time.range === 'custom') return {
            from: time.from,
            to: time.to
        };
        const now = new Date();
        const subAmount = {
            [time.range]: time.value
        };
        return {
            from: (0, (0, parcelRequire("gn1v9")).default)(now, subAmount).getTime(),
            to: now.getTime()
        };
    };
    const $63876a0dc22d7edb$export$16cce822d8159876 = (query, teamId)=>{
        if (teamId) {
            if (query) return `${0, (0, parcelRequire("39KIs")).IDENTIFIER_RESPONDERS}: ${teamId} ${0, (0, parcelRequire("39KIs")).LOGICAL_OPERATOR_AND} ${query}`;
            return `${0, (0, parcelRequire("39KIs")).IDENTIFIER_RESPONDERS}: ${teamId}`;
        }
        return query;
    };
    const $63876a0dc22d7edb$export$78656db4ffc3ccd8 = (alert)=>alert && alert.alertType === 'responder';
    const $63876a0dc22d7edb$export$be2243d4df51c704 = (alert)=>alert.entityType === 'group';
    const $63876a0dc22d7edb$export$81c70e0016508593 = (input)=>{
        const cloudId = (0, (0, parcelRequire("030R0")).getMeta)('ajs-cloud-id');
        if (cloudId) return (0, (0, parcelRequire("VSDnB")).fg)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
        return input;
    };
    const $63876a0dc22d7edb$var$isDevEnvironment = ()=>{
        return typeof $6cAn5 !== 'undefined' && ($6cAn5?.env?.STORYBOOK === 'true' || $6cAn5?.env?.NODE_ENV === 'development') || window.location.hostname === 'localhost';
    };
    const $63876a0dc22d7edb$export$fc6ce7ac2248d7f5 = ()=>{
        if ($63876a0dc22d7edb$var$isDevEnvironment()) return 'abc-def-ghi-jkl';
        return undefined;
    };
});
parcelRegister("j6OA2", function(module, exports) {
    $parcel$export(module.exports, "TAB_KEY", ()=>$2bdcdc7877436b61$export$da8c7facc28740b1);
    $parcel$export(module.exports, "ENTER_KEY", ()=>$2bdcdc7877436b61$export$4162dbd8c730437);
    $parcel$export(module.exports, "ESCAPE_KEY", ()=>$2bdcdc7877436b61$export$728705b4513abbb5);
    $parcel$export(module.exports, "SPACE_KEY", ()=>$2bdcdc7877436b61$export$a47625ee19580f99);
    $parcel$export(module.exports, "LEFT_KEY", ()=>$2bdcdc7877436b61$export$ba950c21a0561bed);
    $parcel$export(module.exports, "UP_KEY", ()=>$2bdcdc7877436b61$export$16859d5882a95fea);
    $parcel$export(module.exports, "RIGHT_KEY", ()=>$2bdcdc7877436b61$export$4b96cad863d88376);
    $parcel$export(module.exports, "DOWN_KEY", ()=>$2bdcdc7877436b61$export$fc0cf2556509233e);
    $parcel$export(module.exports, "SUGGESTION_CARD_Y_POS", ()=>$2bdcdc7877436b61$export$87b2b08fc4c97f78);
    $parcel$export(module.exports, "hasSpaceRegEx", ()=>$2bdcdc7877436b61$export$a07ca273fbeffcb8);
    $parcel$export(module.exports, "hasStartingQuotesRegex", ()=>$2bdcdc7877436b61$export$a3aaedcec21ac282);
    $parcel$export(module.exports, "hasEndingQuotesRegex", ()=>$2bdcdc7877436b61$export$e5ad519d04ef012a);
    $parcel$export(module.exports, "hasNewLinesRegex", ()=>$2bdcdc7877436b61$export$7645e556e9948ecd);
    $parcel$export(module.exports, "EMAIL_REGEX", ()=>$2bdcdc7877436b61$export$7b7637218245c8a);
    $parcel$export(module.exports, "hasColonRegex", ()=>$2bdcdc7877436b61$export$65a2b373cb60e599);
    const $2bdcdc7877436b61$export$da8c7facc28740b1 = 'Tab';
    const $2bdcdc7877436b61$export$4162dbd8c730437 = 'Enter';
    const $2bdcdc7877436b61$export$728705b4513abbb5 = 'Escape';
    const $2bdcdc7877436b61$export$a47625ee19580f99 = ' ';
    const $2bdcdc7877436b61$export$ba950c21a0561bed = 'ArrowLeft';
    const $2bdcdc7877436b61$export$16859d5882a95fea = 'ArrowUp';
    const $2bdcdc7877436b61$export$4b96cad863d88376 = 'ArrowRight';
    const $2bdcdc7877436b61$export$fc0cf2556509233e = 'ArrowDown';
    const $2bdcdc7877436b61$export$87b2b08fc4c97f78 = 28;
    const $2bdcdc7877436b61$export$a07ca273fbeffcb8 = /\s/;
    const $2bdcdc7877436b61$export$8866d083cd03ffd7 = /^\s|\s$/;
    const $2bdcdc7877436b61$export$a3aaedcec21ac282 = /^('|")/;
    const $2bdcdc7877436b61$export$e5ad519d04ef012a = /('|")$/;
    const $2bdcdc7877436b61$export$7645e556e9948ecd = /(\r\n|\n|\r)/gm;
    const $2bdcdc7877436b61$export$7b7637218245c8a = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const $2bdcdc7877436b61$export$65a2b373cb60e599 = /:/;
});
parcelRegister("39KIs", function(module, exports) {
    $parcel$export(module.exports, "TOKEN_TYPES", ()=>$8a97fa493a4d7e02$export$e92b897d610f2aba);
    $parcel$export(module.exports, "LEFT_PARENTHESIS", ()=>$8a97fa493a4d7e02$export$9ce7f372949a1546);
    $parcel$export(module.exports, "RIGHT_PARENTHESIS", ()=>$8a97fa493a4d7e02$export$bbbb3f477a9839e0);
    $parcel$export(module.exports, "OPERATOR_EQUAL_TO", ()=>$8a97fa493a4d7e02$export$ea7497008076d6d2);
    $parcel$export(module.exports, "OPERATOR_GROUP_FOR_ASSISTANT", ()=>$8a97fa493a4d7e02$export$e75c84803c67e1f4);
    $parcel$export(module.exports, "LOGICAL_OPERATOR_AND", ()=>$8a97fa493a4d7e02$export$61308b2610174a70);
    $parcel$export(module.exports, "LOGICAL_OPERATOR_OR", ()=>$8a97fa493a4d7e02$export$1de654320eb3e523);
    $parcel$export(module.exports, "BOOLEAN_LITERAL_TRUE", ()=>$8a97fa493a4d7e02$export$ff7eed6ac2251302);
    $parcel$export(module.exports, "BOOLEAN_LITERAL_FALSE", ()=>$8a97fa493a4d7e02$export$4b436fec6f13b741);
    $parcel$export(module.exports, "BOOLEAN_LITERAL_GROUP", ()=>$8a97fa493a4d7e02$export$8cbc171ac4843075);
    $parcel$export(module.exports, "STRING_LITERAL_DOUBLE_QUOTE", ()=>$8a97fa493a4d7e02$export$347c7cb6285a1d61);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_OPEN", ()=>$8a97fa493a4d7e02$export$910131ff5cd3d496);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_CLOSED", ()=>$8a97fa493a4d7e02$export$2aa0d26cb4549272);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_ACKED", ()=>$8a97fa493a4d7e02$export$572cec90aa166025);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_SNOOZED", ()=>$8a97fa493a4d7e02$export$f94109650ec67751);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_GROUP", ()=>$8a97fa493a4d7e02$export$3a3a37e9da45a2a4);
    $parcel$export(module.exports, "STRING_LITERAL_PRIORITY_GROUP", ()=>$8a97fa493a4d7e02$export$9ef3f42fa10fce44);
    $parcel$export(module.exports, "NULL_LITERAL", ()=>$8a97fa493a4d7e02$export$c2b6d31a7a2d40ba);
    $parcel$export(module.exports, "IDENTIFIER_ALIAS", ()=>$8a97fa493a4d7e02$export$21c480ed86e9d13);
    $parcel$export(module.exports, "IDENTIFIER_CLOSED_BY", ()=>$8a97fa493a4d7e02$export$534c195089710c34);
    $parcel$export(module.exports, "IDENTIFIER_DEDUPLICATION", ()=>$8a97fa493a4d7e02$export$4699ad3805947d4d);
    $parcel$export(module.exports, "IDENTIFIER_ENTITY", ()=>$8a97fa493a4d7e02$export$2a30b5099ba66c99);
    $parcel$export(module.exports, "IDENTIFIER_IS_SEEN", ()=>$8a97fa493a4d7e02$export$7926b4c2836db847);
    $parcel$export(module.exports, "IDENTIFIER_MESSAGE", ()=>$8a97fa493a4d7e02$export$5a8895646b1d5248);
    $parcel$export(module.exports, "IDENTIFIER_ASSIGNEE", ()=>$8a97fa493a4d7e02$export$4047502bdab1e205);
    $parcel$export(module.exports, "IDENTIFIER_PRIORITY", ()=>$8a97fa493a4d7e02$export$5922c06b76ebb57d);
    $parcel$export(module.exports, "IDENTIFIER_COMPONENTS", ()=>$8a97fa493a4d7e02$export$1122634b5d555f05);
    $parcel$export(module.exports, "IDENTIFIER_SERVICES", ()=>$8a97fa493a4d7e02$export$ec912454cd7d858a);
    $parcel$export(module.exports, "IDENTIFIER_RESPONDERS", ()=>$8a97fa493a4d7e02$export$44673ddac1790242);
    $parcel$export(module.exports, "IDENTIFIER_SOURCE", ()=>$8a97fa493a4d7e02$export$f250d53474e801dc);
    $parcel$export(module.exports, "IDENTIFIER_STATUS", ()=>$8a97fa493a4d7e02$export$43181828ba8680e4);
    $parcel$export(module.exports, "IDENTIFIER_TAG", ()=>$8a97fa493a4d7e02$export$8242733866920892);
    $parcel$export(module.exports, "IDENTIFIER_TINY_ID", ()=>$8a97fa493a4d7e02$export$c833829cf31052f0);
    $parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED", ()=>$8a97fa493a4d7e02$export$5f1e5c89a704810f);
    $parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED_BY", ()=>$8a97fa493a4d7e02$export$89d93eb7117999c0);
    $parcel$export(module.exports, "IDENTIFIER_TEAMS", ()=>$8a97fa493a4d7e02$export$a79eb1864dd7b745);
    $parcel$export(module.exports, "IDENTIFIER_GROUP_ALERT", ()=>$8a97fa493a4d7e02$export$888a9cda49b5e18c);
    $parcel$export(module.exports, "IDENTIFIER_BOOLEAN_GROUP", ()=>$8a97fa493a4d7e02$export$60745b712d37edf9);
    $parcel$export(module.exports, "IDENTIFIER_GROUP_ALL", ()=>$8a97fa493a4d7e02$export$b38df7dc61d42293);
    $parcel$export(module.exports, "splitToTokensRegex", ()=>$8a97fa493a4d7e02$export$28041d1d2a85f002);
    $parcel$export(module.exports, "isKeywordRegex", ()=>$8a97fa493a4d7e02$export$290f3472231a2ca1);
    $parcel$export(module.exports, "isModifierRegex", ()=>$8a97fa493a4d7e02$export$56079d3966b6b26c);
    $parcel$export(module.exports, "isComplexOperatorRegex", ()=>$8a97fa493a4d7e02$export$3f6ac43c2355116b);
    $parcel$export(module.exports, "isWSRegex", ()=>$8a97fa493a4d7e02$export$b1b0fc0dc5c83a12);
    $parcel$export(module.exports, "isIdentifierRegex", ()=>$8a97fa493a4d7e02$export$218cf3eb73c65394);
    $parcel$export(module.exports, "isLogicalOperatorRegex", ()=>$8a97fa493a4d7e02$export$a46484930d6fa80f);
    $parcel$export(module.exports, "isOperatorRegex", ()=>$8a97fa493a4d7e02$export$d48805fc5b137dc9);
    const $8a97fa493a4d7e02$export$e92b897d610f2aba = [
        'WHITE_SPACE',
        'SEPARATOR',
        'IDENTIFIER',
        'MODIFIER',
        'KEYWORD',
        'LOGICAL_OPERATOR',
        'STRING_LITERAL',
        'NUMBER_LITERAL',
        'BOOLEAN_LITERAL',
        'NULL_LITERAL',
        'OPERATOR'
    ];
    const $8a97fa493a4d7e02$export$9ce7f372949a1546 = '(';
    const $8a97fa493a4d7e02$export$bbbb3f477a9839e0 = ')';
    const $8a97fa493a4d7e02$export$adbc66edc544fda9 = '=';
    const $8a97fa493a4d7e02$export$fbd271ef020db0c = '!=';
    const $8a97fa493a4d7e02$export$ea7497008076d6d2 = ':';
    const $8a97fa493a4d7e02$export$6d44219c9e0c2567 = '!:';
    const $8a97fa493a4d7e02$export$f8636d23c210043c = '<';
    const $8a97fa493a4d7e02$export$1892bd0c818db570 = '<=';
    const $8a97fa493a4d7e02$export$386b1ae18a32d690 = '>';
    const $8a97fa493a4d7e02$export$44a62afa61d82568 = '>=';
    const $8a97fa493a4d7e02$export$e75c84803c67e1f4 = [
        $8a97fa493a4d7e02$export$adbc66edc544fda9,
        $8a97fa493a4d7e02$export$f8636d23c210043c,
        $8a97fa493a4d7e02$export$1892bd0c818db570,
        $8a97fa493a4d7e02$export$386b1ae18a32d690,
        $8a97fa493a4d7e02$export$44a62afa61d82568
    ];
    const $8a97fa493a4d7e02$export$61308b2610174a70 = 'AND';
    const $8a97fa493a4d7e02$export$1de654320eb3e523 = 'OR';
    const $8a97fa493a4d7e02$export$184522872a5410fc = 'not';
    const $8a97fa493a4d7e02$export$ff7eed6ac2251302 = 'true';
    const $8a97fa493a4d7e02$export$4b436fec6f13b741 = 'false';
    const $8a97fa493a4d7e02$export$8cbc171ac4843075 = [
        $8a97fa493a4d7e02$export$ff7eed6ac2251302,
        $8a97fa493a4d7e02$export$4b436fec6f13b741
    ];
    const $8a97fa493a4d7e02$export$347c7cb6285a1d61 = '"';
    const $8a97fa493a4d7e02$export$d84ab70dc909b702 = "'";
    const $8a97fa493a4d7e02$export$910131ff5cd3d496 = `${$8a97fa493a4d7e02$export$347c7cb6285a1d61}open${$8a97fa493a4d7e02$export$347c7cb6285a1d61}`;
    const $8a97fa493a4d7e02$export$2aa0d26cb4549272 = `${$8a97fa493a4d7e02$export$347c7cb6285a1d61}closed${$8a97fa493a4d7e02$export$347c7cb6285a1d61}`;
    const $8a97fa493a4d7e02$export$572cec90aa166025 = `${$8a97fa493a4d7e02$export$347c7cb6285a1d61}acknowledged${$8a97fa493a4d7e02$export$347c7cb6285a1d61}`;
    const $8a97fa493a4d7e02$export$f94109650ec67751 = `${$8a97fa493a4d7e02$export$347c7cb6285a1d61}snoozed${$8a97fa493a4d7e02$export$347c7cb6285a1d61}`;
    const $8a97fa493a4d7e02$export$3a3a37e9da45a2a4 = [
        $8a97fa493a4d7e02$export$910131ff5cd3d496,
        $8a97fa493a4d7e02$export$2aa0d26cb4549272,
        $8a97fa493a4d7e02$export$572cec90aa166025,
        $8a97fa493a4d7e02$export$f94109650ec67751
    ];
    const $8a97fa493a4d7e02$export$928c1edd572e94f0 = 'P1';
    const $8a97fa493a4d7e02$export$22202070e5f64c55 = 'P2';
    const $8a97fa493a4d7e02$export$537865d58d2072a3 = 'P3';
    const $8a97fa493a4d7e02$export$3d5cfea3feefee83 = 'P4';
    const $8a97fa493a4d7e02$export$fe945cac89cd21a5 = 'P5';
    const $8a97fa493a4d7e02$export$9ef3f42fa10fce44 = [
        $8a97fa493a4d7e02$export$928c1edd572e94f0,
        $8a97fa493a4d7e02$export$22202070e5f64c55,
        $8a97fa493a4d7e02$export$537865d58d2072a3,
        $8a97fa493a4d7e02$export$3d5cfea3feefee83,
        $8a97fa493a4d7e02$export$fe945cac89cd21a5
    ];
    const $8a97fa493a4d7e02$export$c2b6d31a7a2d40ba = 'null';
    const $8a97fa493a4d7e02$export$5a484b762b542c13 = 'actions';
    const $8a97fa493a4d7e02$export$21c480ed86e9d13 = 'alias';
    const $8a97fa493a4d7e02$export$534c195089710c34 = 'closedBy';
    const $8a97fa493a4d7e02$export$4699ad3805947d4d = 'count';
    const $8a97fa493a4d7e02$export$7c3401d7874d69f5 = 'createdAt';
    const $8a97fa493a4d7e02$export$afffcbd5b444e040 = 'description';
    const $8a97fa493a4d7e02$export$e1e61c3bf43fff11 = 'details.key';
    const $8a97fa493a4d7e02$export$aa35da9746edbfe2 = 'details.value';
    const $8a97fa493a4d7e02$export$b620b7163533b409 = 'detailsPair';
    const $8a97fa493a4d7e02$export$2a30b5099ba66c99 = 'entity';
    const $8a97fa493a4d7e02$export$2bfb49435a331d16 = 'integration.name';
    const $8a97fa493a4d7e02$export$feced558810f4b3e = 'integration.type';
    const $8a97fa493a4d7e02$export$7926b4c2836db847 = 'isSeen';
    const $8a97fa493a4d7e02$export$5a8895646b1d5248 = 'message';
    const $8a97fa493a4d7e02$export$4047502bdab1e205 = 'owner';
    const $8a97fa493a4d7e02$export$5922c06b76ebb57d = 'priority';
    const $8a97fa493a4d7e02$export$1122634b5d555f05 = 'components';
    const $8a97fa493a4d7e02$export$ec912454cd7d858a = 'services';
    const $8a97fa493a4d7e02$export$44673ddac1790242 = 'responders';
    const $8a97fa493a4d7e02$export$f250d53474e801dc = 'source';
    const $8a97fa493a4d7e02$export$43181828ba8680e4 = 'status';
    const $8a97fa493a4d7e02$export$a1959e1b76e880dd = 'sync.name';
    const $8a97fa493a4d7e02$export$8417ff61f7a57db6 = 'sync.type';
    const $8a97fa493a4d7e02$export$8242733866920892 = 'tags';
    const $8a97fa493a4d7e02$export$c833829cf31052f0 = 'tinyId';
    const $8a97fa493a4d7e02$export$78d4faf48faf13c2 = 'updatedAt';
    const $8a97fa493a4d7e02$export$5f1e5c89a704810f = 'acknowledged';
    const $8a97fa493a4d7e02$export$89d93eb7117999c0 = 'acknowledgedBy';
    const $8a97fa493a4d7e02$export$1ee0ad656333fc23 = 'aggregatorIds';
    const $8a97fa493a4d7e02$export$d42da2034504d6de = 'alertId';
    const $8a97fa493a4d7e02$export$8464a15b62fb09bb = 'alertType';
    const $8a97fa493a4d7e02$export$2f7ba2848fc019c6 = 'encrypted';
    const $8a97fa493a4d7e02$export$86e4b68c61c8cca5 = 'encryptionId';
    const $8a97fa493a4d7e02$export$cd9dc7ab4d04d11c = 'lastOccurredAt';
    const $8a97fa493a4d7e02$export$8508b76d4c14d7e = 'notify';
    const $8a97fa493a4d7e02$export$e73ddf8d219f28b7 = 'snoozedUntil';
    const $8a97fa493a4d7e02$export$a79eb1864dd7b745 = 'teams';
    const $8a97fa493a4d7e02$export$888a9cda49b5e18c = [
        $8a97fa493a4d7e02$export$5f1e5c89a704810f,
        $8a97fa493a4d7e02$export$89d93eb7117999c0,
        $8a97fa493a4d7e02$export$1ee0ad656333fc23,
        $8a97fa493a4d7e02$export$d42da2034504d6de,
        $8a97fa493a4d7e02$export$8464a15b62fb09bb,
        $8a97fa493a4d7e02$export$2f7ba2848fc019c6,
        $8a97fa493a4d7e02$export$86e4b68c61c8cca5,
        $8a97fa493a4d7e02$export$cd9dc7ab4d04d11c,
        $8a97fa493a4d7e02$export$8508b76d4c14d7e,
        $8a97fa493a4d7e02$export$e73ddf8d219f28b7,
        $8a97fa493a4d7e02$export$a79eb1864dd7b745,
        $8a97fa493a4d7e02$export$5a484b762b542c13,
        $8a97fa493a4d7e02$export$21c480ed86e9d13,
        $8a97fa493a4d7e02$export$534c195089710c34,
        $8a97fa493a4d7e02$export$4699ad3805947d4d,
        $8a97fa493a4d7e02$export$7c3401d7874d69f5,
        $8a97fa493a4d7e02$export$afffcbd5b444e040,
        $8a97fa493a4d7e02$export$e1e61c3bf43fff11,
        $8a97fa493a4d7e02$export$aa35da9746edbfe2,
        $8a97fa493a4d7e02$export$b620b7163533b409,
        $8a97fa493a4d7e02$export$2a30b5099ba66c99,
        $8a97fa493a4d7e02$export$2bfb49435a331d16,
        $8a97fa493a4d7e02$export$feced558810f4b3e,
        $8a97fa493a4d7e02$export$7926b4c2836db847,
        $8a97fa493a4d7e02$export$5a8895646b1d5248,
        $8a97fa493a4d7e02$export$4047502bdab1e205,
        $8a97fa493a4d7e02$export$5922c06b76ebb57d,
        $8a97fa493a4d7e02$export$44673ddac1790242,
        $8a97fa493a4d7e02$export$1122634b5d555f05,
        $8a97fa493a4d7e02$export$ec912454cd7d858a,
        $8a97fa493a4d7e02$export$f250d53474e801dc,
        $8a97fa493a4d7e02$export$43181828ba8680e4,
        $8a97fa493a4d7e02$export$a1959e1b76e880dd,
        $8a97fa493a4d7e02$export$8417ff61f7a57db6,
        $8a97fa493a4d7e02$export$8242733866920892,
        $8a97fa493a4d7e02$export$c833829cf31052f0,
        $8a97fa493a4d7e02$export$78d4faf48faf13c2
    ];
    const $8a97fa493a4d7e02$export$60745b712d37edf9 = [
        $8a97fa493a4d7e02$export$5f1e5c89a704810f,
        $8a97fa493a4d7e02$export$7926b4c2836db847
    ];
    const $8a97fa493a4d7e02$export$b38df7dc61d42293 = [
        ...$8a97fa493a4d7e02$export$888a9cda49b5e18c
    ];
    const $8a97fa493a4d7e02$var$splitToTokensCases = [
        ...[
            $8a97fa493a4d7e02$export$d84ab70dc909b702,
            $8a97fa493a4d7e02$export$347c7cb6285a1d61
        ].map((i)=>`(${i}.*?${i})`),
        ...[
            $8a97fa493a4d7e02$export$d84ab70dc909b702,
            $8a97fa493a4d7e02$export$347c7cb6285a1d61
        ].map((i)=>`(${i}.*)`),
        ...[
            $8a97fa493a4d7e02$export$9ce7f372949a1546,
            $8a97fa493a4d7e02$export$bbbb3f477a9839e0,
            $8a97fa493a4d7e02$export$adbc66edc544fda9,
            $8a97fa493a4d7e02$export$fbd271ef020db0c,
            $8a97fa493a4d7e02$export$ea7497008076d6d2,
            $8a97fa493a4d7e02$export$6d44219c9e0c2567,
            $8a97fa493a4d7e02$export$44a62afa61d82568,
            $8a97fa493a4d7e02$export$386b1ae18a32d690,
            $8a97fa493a4d7e02$export$1892bd0c818db570,
            $8a97fa493a4d7e02$export$f8636d23c210043c
        ].map((i)=>`(\\${i})`),
        ...[
            $8a97fa493a4d7e02$export$61308b2610174a70,
            $8a97fa493a4d7e02$export$1de654320eb3e523,
            $8a97fa493a4d7e02$export$ff7eed6ac2251302,
            $8a97fa493a4d7e02$export$4b436fec6f13b741,
            $8a97fa493a4d7e02$export$184522872a5410fc,
            `is\\s*null`,
            `is\\s*not\\s*null`
        ].map((i)=>`(\\b${i}(?=\\s|$))`),
        '(\\s+)'
    ];
    const $8a97fa493a4d7e02$export$28041d1d2a85f002 = new RegExp($8a97fa493a4d7e02$var$splitToTokensCases.join('|'), 'gi');
    const $8a97fa493a4d7e02$export$290f3472231a2ca1 = /^(is(  *)not(  *)null)$|^(is(  *)null)$/i;
    const $8a97fa493a4d7e02$export$56079d3966b6b26c = /^not$/i;
    const $8a97fa493a4d7e02$export$3f6ac43c2355116b = /^<=$|^>=$|^!=$|^!:$/;
    const $8a97fa493a4d7e02$export$b1b0fc0dc5c83a12 = /^\s+$/;
    const $8a97fa493a4d7e02$export$218cf3eb73c65394 = new RegExp($8a97fa493a4d7e02$export$b38df7dc61d42293.map((i)=>`^${i}$`).join('|'));
    const $8a97fa493a4d7e02$export$a46484930d6fa80f = /^and$|^or$/i;
    const $8a97fa493a4d7e02$export$d48805fc5b137dc9 = /^[=:<>]$/;
});
parcelRegister("5F4Xi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e43ae1f84d6f7300$export$2e2bcd8739ae039);
    var $7VHMR;
    const $e43ae1f84d6f7300$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        validationMessageBeforeGreaterThanAfter: {
            id: `eoc.alert-list.common.utils.validation-message-before-greater-than-after.no-translate`,
            defaultMessage: "'Before' field cannot be later than 'After' field.",
            description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
        },
        validationMessageInvalidDateFormat: {
            id: `eoc.alert-list.common.utils.validation-message-invalid-date-format.no-translate`,
            defaultMessage: 'Invalid date format.',
            description: 'Invalid date format.'
        },
        validNumber: {
            id: `eoc.alert-list.common.utils.validation-not-number.no-translate`,
            defaultMessage: 'Enter a valid number.',
            description: 'The error message that shown when user write different chars other than numeric chars.'
        },
        hoursNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-hours-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-99999.',
            description: 'Message displayed to the user when hours value is not in range'
        },
        daysNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-days-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-9999.',
            description: 'Message displayed to the user when days value is not in range'
        },
        weeksNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-weeks-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-999.',
            description: 'Message displayed to the user when weeks value is not in range'
        },
        monthsNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-months-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-99.',
            description: 'Message displayed to the user when months value is not in range'
        },
        yearsNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-years-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-9.',
            description: 'Message displayed to the user when years value is not in range'
        }
    });
    var $e43ae1f84d6f7300$export$2e2bcd8739ae039 = $e43ae1f84d6f7300$var$messages;
});
parcelRegister("gQ8M0", function(module, exports) {
    $parcel$export(module.exports, "compressionRatioResource", ()=>$e8d6c20659375806$export$8c912e73f758af2);
    var $2M1hQ;
    var $5AHJS;
    const $e8d6c20659375806$var$emptyCompressionBanner = {
        compressionRatio: 0,
        uniqueGroupCount: 0,
        rollingWindow: 0
    };
    const $e8d6c20659375806$export$8c912e73f758af2 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'compressionRatioResource',
        getKey: ()=>'compressionRatioResource',
        getData: async ()=>{
            try {
                const response = await (0, (0, parcelRequire("5AHJS")).getCompressionRatio)();
                return response;
            } catch (e) {
                return $e8d6c20659375806$var$emptyCompressionBanner;
            }
        },
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("5AHJS", function(module, exports) {
    $parcel$export(module.exports, "getCompressionRatio", ()=>$c815f27666ee738a$export$4991457f359db4f7);
    var $j74qU;
    var $1Z10l;
    const $c815f27666ee738a$export$4991457f359db4f7 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("1Z10l")).withAIOpsDomainPrefix)('/v1/alert-insights/compression-ratio'), {
            exactUrl: true
        });
    };
});
parcelRegister("oacWJ", function(module, exports) {
    $parcel$export(module.exports, "savedSearchesResource", ()=>$2aab5bfe07b93543$export$d915b849e6dd786b);
    var $2M1hQ;
    var $6IJKZ;
    const $2aab5bfe07b93543$export$d915b849e6dd786b = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'savedSearchesResource',
        getKey: ()=>'savedSearchesResource',
        getData: ()=>(0, (0, parcelRequire("6IJKZ")).getSavedSearchesEndpoint)(),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("6IJKZ", function(module, exports) {
    $parcel$export(module.exports, "getSavedSearchesEndpoint", ()=>$2b3a64f0a6563850$export$3b7b44889eb94cd0);
    $parcel$export(module.exports, "createSavedSearchEndpoint", ()=>$2b3a64f0a6563850$export$4976332c0ec66407);
    $parcel$export(module.exports, "deleteSearchEndpoint", ()=>$2b3a64f0a6563850$export$401da4a793944201);
    var $j74qU;
    const $2b3a64f0a6563850$export$3b7b44889eb94cd0 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/alerts/saved-searches');
    };
    const $2b3a64f0a6563850$export$4976332c0ec66407 = (data)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/alerts/saved-searches', {
            method: 'POST',
            body: data
        });
    };
    const $2b3a64f0a6563850$export$401da4a793944201 = (id)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/saved-searches/${id}`, {
            method: 'DELETE',
            responseType: 'headers'
        });
    };
});
parcelRegister("dqLIo", function(module, exports) {
    $parcel$export(module.exports, "uiPreferencesResource", ()=>$f86ed58750791981$export$4e143f0fe4b2e025);
    var $2M1hQ;
    var $fY9nC;
    const $f86ed58750791981$export$4e143f0fe4b2e025 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'uiPreferencesResource',
        getKey: ()=>'uiPreferencesResource',
        getData: ()=>(0, (0, parcelRequire("fY9nC")).getUiPreferencesEndpoint)(),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("fY9nC", function(module, exports) {
    $parcel$export(module.exports, "getUiPreferencesEndpoint", ()=>$838fb476cee34593$export$afa4854419ed2fc8);
    $parcel$export(module.exports, "updateUiPreferencesEndpoint", ()=>$838fb476cee34593$export$4990793476d8f783);
    var $j74qU;
    const $838fb476cee34593$export$afa4854419ed2fc8 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/alerts/ui-preferences');
    };
    const $838fb476cee34593$export$4990793476d8f783 = (data)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/alerts/ui-preferences', {
            method: 'PATCH',
            body: data
        });
    };
});
parcelRegister("j88uz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("39Zx1").then(()=>parcelRequire('2kjD7'));
});
parcelRegister("lUaB2", function(module, exports) {
    $parcel$export(module.exports, "eocGlobalAlertListRoute", ()=>$ea0b3602049f5b80$export$29721341dde2ed3d);
    var $65Ltd;
    const $ea0b3602049f5b80$export$29721341dde2ed3d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERTS),
        path: '/jira/ops/alerts',
        exact: true
    };
});
parcelRegister("d8hKi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1Z4yj")
    ]).then(()=>parcelRequire('cHlJB'));
});
parcelRegister("en1L8", function(module, exports) {
    $parcel$export(module.exports, "alertDetailResource", ()=>$0fd209d54dcee973$export$f918335771807ac4);
    $parcel$export(module.exports, "logTypesResource", ()=>$0fd209d54dcee973$export$f9c57ab4d5f63686);
    $parcel$export(module.exports, "entityRelationTypesResource", ()=>$0fd209d54dcee973$export$a5515392cb45b9f8);
    $parcel$export(module.exports, "responderStatesResource", ()=>$0fd209d54dcee973$export$c3b70747662e5932);
    $parcel$export(module.exports, "resources", ()=>$0fd209d54dcee973$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $4EUyI;
    var $hmVmJ;
    var $dH6Pi;
    var $jxRF2;
    var $4sBoT;
    const $0fd209d54dcee973$export$f918335771807ac4 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'alertDetailResource',
        getKey: (routerContext)=>`alertDetailResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const alertId = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!alertId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('alertDetailResource', 'alertId should be set to fetch alert-detail'));
            return (0, (0, parcelRequire("4sBoT")).getAlertDetail)(alertId);
        },
        isBrowserOnly: true
    });
    const $0fd209d54dcee973$export$f9c57ab4d5f63686 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'logTypesResource',
        getKey: (routerContext)=>`logTypesResource#${routerContext.match.params.id}`,
        getData: async ()=>{
            return (0, (0, parcelRequire("4sBoT")).getAlertLogTypesEndpoint)();
        },
        isBrowserOnly: true
    });
    const $0fd209d54dcee973$export$a5515392cb45b9f8 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'entityRelationTypesResource',
        getKey: (routerContext)=>`entityRelationTypesResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const alertId = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!alertId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
            return (0, (0, parcelRequire("4sBoT")).getEntityRelationTypesEndpoint)(alertId);
        },
        isBrowserOnly: true
    });
    const $0fd209d54dcee973$export$c3b70747662e5932 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'responderStatesResource',
        getKey: (routerContext)=>`responderStatesResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const alertId = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!alertId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('responderStatesResource', 'alertId should be set to fetch responder states'));
            return (0, (0, parcelRequire("4sBoT")).getResponderStatesEndpoint)(alertId);
        },
        isBrowserOnly: true
    });
    const $0fd209d54dcee973$export$bc99aaabaf7b70a7 = [
        $0fd209d54dcee973$export$f918335771807ac4,
        $0fd209d54dcee973$export$f9c57ab4d5f63686,
        $0fd209d54dcee973$export$c3b70747662e5932,
        $0fd209d54dcee973$export$a5515392cb45b9f8,
        (0, (0, parcelRequire("4EUyI")).relatedAlertGroupResource),
        ...(0, (0, parcelRequire("jxRF2")).eocCommonResources)()
    ];
});
parcelRegister("4EUyI", function(module, exports) {
    $parcel$export(module.exports, "relatedAlertGroupResource", ()=>$ba8a2335e3265c9e$export$35df14c9f0cfb113);
    var $2M1hQ;
    var $VSDnB;
    var $hmVmJ;
    var $dH6Pi;
    var $3jET5;
    const $ba8a2335e3265c9e$export$35df14c9f0cfb113 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'relatedAlertGroupResource',
        getKey: (routerContext)=>`relatedAlertGroupResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            if (!(0, (0, parcelRequire("VSDnB")).fg)('aiops-related-alert-group')) return null;
            const alertId = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!alertId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('relatedAlertGroupResource', 'alertId should be set to fetch related alert-groups'));
            return (0, (0, parcelRequire("3jET5")).getRelatedAlertGroup)(alertId);
        },
        isBrowserOnly: true
    });
});
parcelRegister("3jET5", function(module, exports) {
    $parcel$export(module.exports, "getRelatedAlertGroup", ()=>$0f60bd06765f80ba$export$665e34f20aad273a);
    var $j74qU;
    var $4ttsA;
    const $0f60bd06765f80ba$export$665e34f20aad273a = (alertId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("4ttsA")).withAIOpsDomainPrefix)(`/v1/group-insights/get-group-of-alert?alertId=${alertId}`), {
            exactUrl: true
        });
});
parcelRegister("4ttsA", function(module, exports) {
    $parcel$export(module.exports, "withAIOpsDomainPrefix", ()=>$8fd10dbbabf74295$export$81c70e0016508593);
    var $VSDnB;
    var $030R0;
    const $8fd10dbbabf74295$export$81c70e0016508593 = (input)=>{
        const cloudId = (0, (0, parcelRequire("030R0")).getMeta)('ajs-cloud-id');
        if (cloudId) return (0, (0, parcelRequire("VSDnB")).fg)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
        return input;
    };
});
parcelRegister("4sBoT", function(module, exports) {
    $parcel$export(module.exports, "getAlertDetail", ()=>$440b6c9ebfdc99cb$export$436b6d88c1865c54);
    $parcel$export(module.exports, "getAlertLogTypesEndpoint", ()=>$440b6c9ebfdc99cb$export$97200f7e7a7d1479);
    $parcel$export(module.exports, "getResponderStatesEndpoint", ()=>$440b6c9ebfdc99cb$export$498d1a9ea659d430);
    $parcel$export(module.exports, "getEntityRelationTypesEndpoint", ()=>$440b6c9ebfdc99cb$export$8f96130abdd7549d);
    var $j74qU;
    const $440b6c9ebfdc99cb$export$436b6d88c1865c54 = (alertId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/${alertId}`);
    const $440b6c9ebfdc99cb$export$97200f7e7a7d1479 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/logs/types`);
    const $440b6c9ebfdc99cb$export$498d1a9ea659d430 = (alertId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/${alertId}/responder-states`);
    const $440b6c9ebfdc99cb$export$8f96130abdd7549d = (alertId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/${alertId}/entity-relations/relation-types`).then((res)=>({
                relationTypes: res.relationTypes.sort((a, b)=>a.label.localeCompare(b.label))
            }));
});
parcelRegister("cM724", function(module, exports) {
    $parcel$export(module.exports, "globalEscalationsListInfoResource", ()=>$a2d6726b104ac899$export$bffddc002dadaf3a);
    var $2M1hQ;
    var $2dbE7;
    const $a2d6726b104ac899$export$bffddc002dadaf3a = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'globalEscalationsListInfoResource',
        getKey: ()=>'globalEscalationsListInfoResource',
        getData: (0, (0, parcelRequire("2dbE7")).getListInfo),
        isBrowserOnly: true
    });
});
parcelRegister("2dbE7", function(module, exports) {
    $parcel$export(module.exports, "getEscalations", ()=>$9fcebef6d9f6d876$export$300727380b60aeb4);
    $parcel$export(module.exports, "getListInfo", ()=>$9fcebef6d9f6d876$export$bdc8fe7d9cd263b);
    var $j74qU;
    const $9fcebef6d9f6d876$export$300727380b60aeb4 = ({ lastEvaluatedToken: lastEvaluatedToken, queryKey: queryKey })=>{
        const [, filtersString] = queryKey;
        const filters = JSON.parse(filtersString);
        const params = new URLSearchParams({
            ...filters,
            lastEvaluatedToken: lastEvaluatedToken
        });
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/escalations/search?${params.toString()}`);
    };
    const $9fcebef6d9f6d876$export$bdc8fe7d9cd263b = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/escalations/list-info');
    };
});
parcelRegister("boPOw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fUucv")
    ]).then(()=>parcelRequire('dLkuj'));
});
parcelRegister("eYyoJ", function(module, exports) {
    $parcel$export(module.exports, "groupHeaderResource", ()=>$3cd6727337445c45$export$e6ba56f6b67069c8);
    $parcel$export(module.exports, "aiSuggestionsResource", ()=>$3cd6727337445c45$export$94675faef1d4568b);
    $parcel$export(module.exports, "resources", ()=>$3cd6727337445c45$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $hmVmJ;
    var $dH6Pi;
    var $2LFOe;
    const $3cd6727337445c45$export$e6ba56f6b67069c8 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'groupHeaderResource',
        getKey: (routerContext)=>`groupHeaderResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const groupId = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!groupId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('groupHeaderResource', 'groupId should be set to fetch group-detail-header'));
            return (0, (0, parcelRequire("2LFOe")).getHeaderDetails)(groupId);
        },
        isBrowserOnly: true
    });
    const $3cd6727337445c45$export$94675faef1d4568b = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'aiSuggestionsResource',
        getKey: (routerContext)=>`aiSuggestionsResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const groupId = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!groupId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('aiSuggestionsResource', 'groupId should be set to fetch ai-suggestions for any group'));
            return (0, (0, parcelRequire("2LFOe")).getAISuggestions)(groupId);
        },
        isBrowserOnly: true
    });
    const $3cd6727337445c45$export$bc99aaabaf7b70a7 = [
        $3cd6727337445c45$export$e6ba56f6b67069c8,
        $3cd6727337445c45$export$94675faef1d4568b
    ];
});
parcelRegister("2LFOe", function(module, exports) {
    $parcel$export(module.exports, "getHeaderDetails", ()=>$1301a416506333ce$export$c0f2e4bfcbff05d1);
    $parcel$export(module.exports, "getAISuggestions", ()=>$1301a416506333ce$export$34bb7a15a54039a5);
    $parcel$export(module.exports, "addGroupAssignee", ()=>$1301a416506333ce$export$bd5bdebdb6d9abb);
    $parcel$export(module.exports, "actionOnGroup", ()=>$1301a416506333ce$export$5353a5d2604523c0);
    $parcel$export(module.exports, "getAlertCountForGroupAction", ()=>$1301a416506333ce$export$b47efb0a9602f0c8);
    var $j74qU;
    var $iZjKh;
    const $1301a416506333ce$export$c0f2e4bfcbff05d1 = (groupId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("iZjKh")).withAIOpsPrefix)(`/v1/group-insights/${groupId}`), {
            exactUrl: true
        });
    const $1301a416506333ce$export$34bb7a15a54039a5 = (groupId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("iZjKh")).withAIOpsPrefix)(`/v1/group-insights/getSimilar/${groupId}`), {
            exactUrl: true
        });
    const $1301a416506333ce$export$bd5bdebdb6d9abb = (groupId, assigneeId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("iZjKh")).withAIOpsPrefix)(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
            method: 'PUT',
            exactUrl: true
        });
    const $1301a416506333ce$export$5353a5d2604523c0 = (groupId, action, payload = {})=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("iZjKh")).withAIOpsPrefix)(`/v1/alert-insights/bulk-action`), {
            method: 'PUT',
            exactUrl: true,
            body: {
                groupId: groupId,
                actionType: action,
                ...payload
            }
        });
    };
    const $1301a416506333ce$export$b47efb0a9602f0c8 = (groupId, action)=>{
        const urlSearchParams = new URLSearchParams();
        urlSearchParams.set('actionType', action);
        urlSearchParams.set('groupId', groupId);
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("iZjKh")).withAIOpsPrefix)(`/v1/alert-insights/check-all-action?${urlSearchParams}`), {
            exactUrl: true
        });
    };
});
parcelRegister("iZjKh", function(module, exports) {
    $parcel$export(module.exports, "withAIOpsPrefix", ()=>$1bb9bc334d3aa5dc$export$5ad74397753c99a2);
    var $VSDnB;
    var $030R0;
    const $1bb9bc334d3aa5dc$export$5ad74397753c99a2 = (input)=>{
        const cloudId = (0, (0, parcelRequire("030R0")).getMeta)('ajs-cloud-id');
        if (cloudId) return (0, (0, parcelRequire("VSDnB")).getBooleanFF)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
        return input;
    };
});
parcelRegister("c8NZy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dTpji")
    ]).then(()=>parcelRequire('9kpiP'));
});
parcelRegister("90XDC", function(module, exports) {
    $parcel$export(module.exports, "heartbeatsResource", ()=>$ba57cdfcb9409883$export$dd38e2aa5cfda9c9);
    $parcel$export(module.exports, "heartbeatsUserRightsResource", ()=>$ba57cdfcb9409883$export$b5d9a0bcdfa848ce);
    $parcel$export(module.exports, "resources", ()=>$ba57cdfcb9409883$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $6dFjI;
    const $ba57cdfcb9409883$export$dd38e2aa5cfda9c9 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'heartbeatsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `heartbeats/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            if (!teamId) return;
            return (0, (0, parcelRequire("6dFjI")).getHeartbeatsEndpoint)(teamId);
        },
        isBrowserOnly: true
    });
    const $ba57cdfcb9409883$export$b5d9a0bcdfa848ce = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'heartbeatsUserRightsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `heartbeats-user-rights/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return (0, (0, parcelRequire("6dFjI")).getHeartbeatsUserRights)(teamId);
        },
        isBrowserOnly: true
    });
    const $ba57cdfcb9409883$export$bc99aaabaf7b70a7 = [
        $ba57cdfcb9409883$export$dd38e2aa5cfda9c9,
        $ba57cdfcb9409883$export$b5d9a0bcdfa848ce
    ];
});
parcelRegister("6dFjI", function(module, exports) {
    $parcel$export(module.exports, "getHeartbeatsEndpoint", ()=>$9fd5e861ed04ddb5$export$c322dad372dcb08b);
    $parcel$export(module.exports, "validateHeartbeatNameEndpoint", ()=>$9fd5e861ed04ddb5$export$676f6aee59f124b0);
    $parcel$export(module.exports, "createHeartbeatEndpoint", ()=>$9fd5e861ed04ddb5$export$891ea85cc6973b32);
    $parcel$export(module.exports, "updateHeartbeatEndpoint", ()=>$9fd5e861ed04ddb5$export$7311481b59e02e06);
    $parcel$export(module.exports, "switchHeartbeatEndpoint", ()=>$9fd5e861ed04ddb5$export$5df993f1c74d7e8e);
    $parcel$export(module.exports, "deleteHeartbeatEndpoint", ()=>$9fd5e861ed04ddb5$export$716e365975fc2cd1);
    $parcel$export(module.exports, "getHeartbeatsUserRights", ()=>$9fd5e861ed04ddb5$export$26eaca11f3b4e506);
    $parcel$export(module.exports, "updateAutoCreationEndpoint", ()=>$9fd5e861ed04ddb5$export$38097aade6a3b234);
    var $j74qU;
    const $9fd5e861ed04ddb5$export$c322dad372dcb08b = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
            method: 'GET'
        });
    const $9fd5e861ed04ddb5$export$676f6aee59f124b0 = (teamId, heartbeatName)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/heartbeats/validateEmail?heartbeatName=${encodeURIComponent(heartbeatName)}`, {
            method: 'GET',
            responseType: 'headers'
        });
    const $9fd5e861ed04ddb5$export$891ea85cc6973b32 = (teamId, heartbeat)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
            method: 'POST',
            body: heartbeat
        });
    const $9fd5e861ed04ddb5$export$7311481b59e02e06 = (teamId, heartbeat)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
            method: 'PUT',
            body: heartbeat
        });
    const $9fd5e861ed04ddb5$export$5df993f1c74d7e8e = (teamId, enable, name)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/heartbeats/enable?enabled=${enable}&name=${encodeURIComponent(name)}`, {
            method: 'PATCH'
        });
    const $9fd5e861ed04ddb5$export$716e365975fc2cd1 = (teamId, name)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/heartbeats?name=${encodeURIComponent(name)}`, {
            method: 'DELETE',
            responseType: 'headers'
        });
    const $9fd5e861ed04ddb5$export$26eaca11f3b4e506 = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}heartbeats/rights`);
    };
    const $9fd5e861ed04ddb5$export$38097aade6a3b234 = (teamId, autoCreateEnabled)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}heartbeats/updateHeartbeatAutoCreation?autoCreateEnabled=${autoCreateEnabled}`, {
            method: 'POST',
            responseType: 'headers'
        });
});
parcelRegister("2we79", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5jEdq").then(()=>parcelRequire('4uAlQ'));
});
parcelRegister("ffEPd", function(module, exports) {
    $parcel$export(module.exports, "detailResource", ()=>$d2ad11d314356b50$export$13d78d45f8054f1e);
    var $2M1hQ;
    var $hmVmJ;
    var $dH6Pi;
    var $bKopM;
    const $d2ad11d314356b50$export$13d78d45f8054f1e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'getDetailResource',
        getKey: ()=>'getDetailResource',
        getData: async (routerContext)=>{
            const id = routerContext.match.params?.id;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!id, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('detailResource', 'id should be set to fetch incoming call detail'));
            return (0, (0, parcelRequire("bKopM")).getDetail)(id);
        },
        isBrowserOnly: true
    });
});
parcelRegister("bKopM", function(module, exports) {
    $parcel$export(module.exports, "getDetail", ()=>$3e9eec2aa2136224$export$d6c3faeb2ce9d297);
    var $j74qU;
    var $7PepW;
    const $3e9eec2aa2136224$export$d6c3faeb2ce9d297 = (id)=>{
        const endpoint = `${(0, (0, parcelRequire("7PepW")).urls).incomingCall.detail.url(id)}`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)(endpoint);
    };
});
parcelRegister("7PepW", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$5edaa37a3b09374b$export$bcae9ba627f604b6);
    const $5edaa37a3b09374b$export$bcae9ba627f604b6 = Object.freeze({
        incomingCall: {
            url: ()=>`/v1/incoming-call`,
            detail: {
                url: (incomingCallId = ':incomingCallId')=>`${$5edaa37a3b09374b$export$bcae9ba627f604b6.incomingCall.url()}/${incomingCallId}`
            }
        }
    });
});
parcelRegister("3zzQS", function(module, exports) {
    $parcel$export(module.exports, "listResource", ()=>$c316e599070576e5$export$5ee018e9baf9d633);
    var $eURsm;
    var $9FZzU;
    const $c316e599070576e5$export$5ee018e9baf9d633 = (0, (0, parcelRequire("eURsm")).createPaginatedResource)({
        type: 'getListResource',
        getKey: ()=>'getListResource',
        getData: ()=>(0, (0, parcelRequire("9FZzU")).getList),
        isBrowserOnly: true
    });
});
parcelRegister("eURsm", function(module, exports) {
    $parcel$export(module.exports, "createPaginatedResource", ()=>$9723334731b55493$export$561b032e4d26d1e8);
    var $2M1hQ;
    const $9723334731b55493$export$561b032e4d26d1e8 = ({ getData: getData, getKey: getKey, ...arg })=>{
        return (0, (0, parcelRequire("2M1hQ")).createResource)({
            ...arg,
            getKey: (routerContext, customContext)=>{
                const { query: query } = routerContext;
                const page = query['page'] || '1';
                const key = `${getKey(routerContext, customContext)}#${page}`;
                return key;
            },
            getData: (routerContext, customContext)=>{
                const { query: query } = routerContext;
                const page = parseInt(query['page']) || 1;
                return getData(routerContext, customContext)({
                    page: page
                });
            }
        });
    };
});
parcelRegister("9FZzU", function(module, exports) {
    $parcel$export(module.exports, "getList", ()=>$3bbdbabf459bda32$export$73fffd6dda5144e);
    $parcel$export(module.exports, "addIncomingCall", ()=>$3bbdbabf459bda32$export$cdae09ff00c893b2);
    var $j74qU;
    var $7PepW;
    const $3bbdbabf459bda32$export$73fffd6dda5144e = ({ page: page })=>{
        const limit = 20;
        const offset = (page - 1) * limit;
        const params = new URLSearchParams({
            offset: `${offset}`,
            limit: `${limit}`,
            sortBy: 'name',
            sort: 'asc'
        });
        const endpoint = `${(0, (0, parcelRequire("7PepW")).urls).incomingCall.url()}?${params.toString()}`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)(endpoint).then(({ data: data, count: count })=>{
            return {
                data: data,
                count: Math.ceil(count / limit)
            };
        });
    };
    const $3bbdbabf459bda32$export$cdae09ff00c893b2 = (params)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("7PepW")).urls).incomingCall.url(), {
            method: 'POST',
            body: params
        });
    };
});
parcelRegister("ivQDT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dXV8c")
    ]).then(()=>parcelRequire('8oycJ'));
});
parcelRegister("g9g6m", function(module, exports) {
    $parcel$export(module.exports, "resources", ()=>$97e7bbf09fde8a26$export$bc99aaabaf7b70a7);
    var $5WVG8;
    var $hVeqx;
    var $h4DSB;
    const $97e7bbf09fde8a26$export$bc99aaabaf7b70a7 = {
        configuredIntegrationsResource: (0, parcelRequire("5WVG8")).configuredIntegrationsResource,
        integrationListResource: (0, parcelRequire("hVeqx")).integrationListResource,
        userAccessRightsResource: (0, parcelRequire("h4DSB")).userAccessRightsResource
    };
});
parcelRegister("5WVG8", function(module, exports) {
    $parcel$export(module.exports, "configuredIntegrationsResource", ()=>$83d54f0caf3b9996$export$4136019b80be5917);
    var $2M1hQ;
    var $6nRK2;
    var $7suNB;
    const $83d54f0caf3b9996$export$4136019b80be5917 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'configuredIntegrationsResource',
        getKey: ({ query: query, match: match })=>{
            const teamId = match.params.teamId ?? query['teamId'];
            const group = query['group'];
            const keyword = query['keyword'];
            const status = query['status'];
            const page = query['page'] || '1';
            return (0, (0, parcelRequire("6nRK2")).UrlHelper)((0, $cf8709d20bdba1b1$export$bc7daa294a7c75e4), {
                [(0, $cf8709d20bdba1b1$export$d26137cf824a9e53)]: page,
                [(0, $cf8709d20bdba1b1$export$299579ccbdd63cbc)]: keyword,
                [(0, $cf8709d20bdba1b1$export$d7415cfdee4bffc8)]: group,
                [(0, $cf8709d20bdba1b1$export$ce2c93e90dda8613)]: status,
                [(0, $cf8709d20bdba1b1$export$4e0ddb4dc97eb573)]: teamId
            });
        },
        getData: (routerContext)=>(0, (0, parcelRequire("7suNB")).default).getIntegrations(routerContext.query, routerContext.match.params.teamId),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("6nRK2", function(module, exports) {
    $parcel$export(module.exports, "UrlHelper", ()=>$15b449f9b21b0a2a$export$bacbc496e850c0a4);
    const $15b449f9b21b0a2a$export$bacbc496e850c0a4 = (path, params = {})=>{
        const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
                k,
                v.toString()
            ] : undefined).filter((v)=>!!v);
        const qs = new URLSearchParams(q).toString().replace(/%2C/g, ',');
        return `${path}${qs ? `?${qs}` : ''}`;
    };
});
parcelRegister("7suNB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6c9b0fd99b09a25$export$2e2bcd8739ae039);
    var $j74qU;
    var $6nRK2;
    const $f6c9b0fd99b09a25$var$getIntegrations = async (query, pathParamTeamId)=>{
        const page = parseInt(query['page']) || 1;
        const offset = (page - 1) * (0, $38fc251fc66fc98a$export$31ecae7225aecec6);
        const queryParams = query ? {
            teamId: pathParamTeamId ?? query.teamId,
            group: query.group,
            keyword: query.keyword,
            status: query.status
        } : {};
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("6nRK2")).UrlHelper)('/v3/integrations/unified', {
            ...queryParams,
            offset: offset.toString(),
            limit: (0, $38fc251fc66fc98a$export$31ecae7225aecec6)
        })).then((response)=>({
                data: response.data.integrations,
                pageCount: Math.ceil(response.data.count / (0, $38fc251fc66fc98a$export$31ecae7225aecec6)),
                itemCount: response.data.count,
                platformTeamId: response.data.platformTeamId
            }));
    };
    const $f6c9b0fd99b09a25$var$patchIntegration = async (integrationId, integrationType, body, teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("6nRK2")).UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
            type: integrationType,
            teamId: teamId
        }), {
            method: 'PATCH',
            body: body
        }).then((response)=>response.data);
    const $f6c9b0fd99b09a25$var$deleteIntegration = async (integrationId, integrationType, teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("6nRK2")).UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
            type: integrationType,
            teamId: teamId
        }), {
            method: 'DELETE',
            responseType: 'headers'
        });
    var $f6c9b0fd99b09a25$export$2e2bcd8739ae039 = {
        getIntegrations: $f6c9b0fd99b09a25$var$getIntegrations,
        patchIntegration: $f6c9b0fd99b09a25$var$patchIntegration,
        deleteIntegration: $f6c9b0fd99b09a25$var$deleteIntegration
    };
});
const $38fc251fc66fc98a$export$31ecae7225aecec6 = 20;
const $cf8709d20bdba1b1$export$bc7daa294a7c75e4 = 'configuredIntegrationsResource';
const $cf8709d20bdba1b1$export$d26137cf824a9e53 = 'page';
const $cf8709d20bdba1b1$export$299579ccbdd63cbc = 'keyword';
const $cf8709d20bdba1b1$export$d7415cfdee4bffc8 = 'group';
const $cf8709d20bdba1b1$export$ce2c93e90dda8613 = 'status';
const $cf8709d20bdba1b1$export$4e0ddb4dc97eb573 = 'teamId';
parcelRegister("hVeqx", function(module, exports) {
    $parcel$export(module.exports, "integrationListResource", ()=>$d497f8a5feefb0d5$export$f60a40a11a6e0ee4);
    var $2M1hQ;
    var $jYQAI;
    const $d497f8a5feefb0d5$export$f60a40a11a6e0ee4 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'integrationListResource',
        getKey: ({ query: query })=>{
            const group = query['group'];
            const keyword = query['keyword'];
            return `integrationListResource?group=${group}&keyword=${keyword}`;
        },
        getData: async (routerContext)=>await (0, (0, parcelRequire("jYQAI")).default).getIntegrationList(routerContext.query, routerContext.match.params.teamId),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("jYQAI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e286a884592e027$export$2e2bcd8739ae039);
    var $j74qU;
    var $6nRK2;
    const $1e286a884592e027$var$getIntegrationList = (query, teamId)=>{
        const { keyword: keyword, group: group } = query ?? {};
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("6nRK2")).UrlHelper)(`/v3/integrations/unified/supported-integrations`, {
            keyword: keyword,
            group: group,
            teamId: teamId
        })).then((response)=>{
            const { labels: labels, availableGroups: availableGroups, allTypes: allTypes, platformTeamId: platformTeamId } = response.data;
            return {
                labels: labels,
                availableGroups: availableGroups,
                allTypes: allTypes,
                platformTeamId: platformTeamId
            };
        });
    };
    const $1e286a884592e027$var$getIntegrationTypes = (integrationType, teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("6nRK2")).UrlHelper)(`/v3/integrations/unified/${integrationType}/types`, {
            teamId: teamId
        })).then((response)=>response.data.map((integrationType)=>({
                    ...integrationType,
                    value: integrationType.type,
                    label: integrationType.displayName
                })));
    var $1e286a884592e027$export$2e2bcd8739ae039 = {
        getIntegrationList: $1e286a884592e027$var$getIntegrationList,
        getIntegrationTypes: $1e286a884592e027$var$getIntegrationTypes
    };
});
parcelRegister("h4DSB", function(module, exports) {
    $parcel$export(module.exports, "userAccessRightsResource", ()=>$955f19580ff30efa$export$69ddc7cc64ae9a02);
    var $2M1hQ;
    var $ifvD2;
    const $955f19580ff30efa$export$69ddc7cc64ae9a02 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'userAccessRightsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params.teamId;
            return `userAccessRightsResource#${!!teamId ? teamId : ''}`;
        },
        getData: (routerContext)=>(0, (0, parcelRequire("ifvD2")).getUserRights)(routerContext.match.params.teamId),
        maxAge: 3600000,
        isBrowserOnly: true
    });
});
parcelRegister("ifvD2", function(module, exports) {
    $parcel$export(module.exports, "getUserRights", ()=>$82efdac2c3d222dc$export$84e2ed279bc4e64e);
    var $j74qU;
    var $6nRK2;
    const $82efdac2c3d222dc$export$84e2ed279bc4e64e = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("6nRK2")).UrlHelper)(`/v3/integrations/unified/rights`, {
            teamId: teamId
        })).then((response)=>response.data);
    };
});
parcelRegister("elNBZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4EsQl")
    ]).then(()=>parcelRequire('5QWfc'));
});
parcelRegister("cekVR", function(module, exports) {
    $parcel$export(module.exports, "byokInformationResource", ()=>$3c6fb796f140225d$export$c6b84cb74d1ed3b9);
    var $2M1hQ;
    var $kymuO;
    const $3c6fb796f140225d$export$c6b84cb74d1ed3b9 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'byok-information-resource',
        getKey: ()=>'byok-information-resource',
        getData: async ()=>(0, (0, parcelRequire("kymuO")).fetchByokInformation)(),
        maxAge: Infinity,
        isBrowserOnly: true
    });
});
parcelRegister("kymuO", function(module, exports) {
    $parcel$export(module.exports, "fetchByokInformation", ()=>$bccedcaa672f11fe$export$5244b5a582b643da);
    var $j74qU;
    const $bccedcaa672f11fe$export$5244b5a582b643da = async ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/customers/byok-setting');
    };
});
parcelRegister("k5TFj", function(module, exports) {
    $parcel$export(module.exports, "downloadAuditLogsResource", ()=>$62049603e7f7b61b$export$304da75014b88b78);
    var $2M1hQ;
    var $hmVmJ;
    var $dH6Pi;
    var $kg5A9;
    const $62049603e7f7b61b$export$304da75014b88b78 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'download-audit-logs-resource',
        getKey: ()=>'download-audit-logs-resource',
        getData: async (routerContext)=>{
            const uniqueKey = routerContext.match.params.exportUniqueKey;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!uniqueKey, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('downloadAuditLogs resource', 'uniqueKey must be defined'));
            return (0, (0, parcelRequire("kg5A9")).fetchDownloadLinkEndpoint)(uniqueKey);
        },
        maxAge: 0,
        isBrowserOnly: true
    });
});
parcelRegister("kg5A9", function(module, exports) {
    $parcel$export(module.exports, "fetchDownloadLinkEndpoint", ()=>$7bc9ff634e8ba041$export$c8df7e5942ba1d96);
    var $j74qU;
    const $7bc9ff634e8ba041$export$c8df7e5942ba1d96 = async (exportUniqueKey)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/logs/export/${exportUniqueKey}/download`, {
            responseType: 'text'
        });
    };
});
parcelRegister("8qZNT", function(module, exports) {
    $parcel$export(module.exports, "logsResource", ()=>$37d900392ed354d4$export$fd88b4310d3f52ff);
    var $2M1hQ;
    var $kWKaa;
    const $37d900392ed354d4$export$fd88b4310d3f52ff = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ui-get-logs',
        getKey: (routerContext)=>{
            const integrationId = routerContext.match.params.integrationId;
            const urlParam = new URLSearchParams();
            Object.entries(routerContext.query).forEach(([key, value])=>{
                if (value) urlParam.set(key, value);
            });
            return !!integrationId ? `integration-${integrationId}-logs#${urlParam.toString()}` : `ui-get-logs#${urlParam.toString()}`;
        },
        getData: async (routerContext)=>{
            return (0, (0, parcelRequire("kWKaa")).fetchLogs)({
                fromUnit: routerContext.query?.fromUnit,
                fromValue: routerContext.query?.fromValue,
                startTimestamp: routerContext.query?.startTimestamp,
                endTimestamp: routerContext.query?.endTimestamp,
                eventCategories: routerContext.query?.eventCategories,
                levels: routerContext.query?.levels,
                size: routerContext.query?.size ?? 30,
                insertedAt: routerContext.query?.insertedAt,
                searchString: routerContext.query?.searchString,
                pageDirection: routerContext.query?.pageDirection ?? 'NEXT',
                integrationId: routerContext.match.params.integrationId
            });
        },
        maxAge: 60000,
        isBrowserOnly: true
    });
});
parcelRegister("kWKaa", function(module, exports) {
    $parcel$export(module.exports, "fetchLogs", ()=>$ccc9d84c3a4ba264$export$b9fcc8145a518db4);
    var $j74qU;
    var $7sija;
    const $ccc9d84c3a4ba264$export$b9fcc8145a518db4 = async (params)=>{
        const urlParams = (0, (0, parcelRequire("7sija")).generateLogParams)(params);
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/logs/search?' + urlParams.toString()).then((response)=>(0, (0, parcelRequire("7sija")).postProcessLogsSearch)(urlParams, response));
    };
});
parcelRegister("7sija", function(module, exports) {
    $parcel$export(module.exports, "isValidTimePeriodFormat", ()=>$102956f839e5f725$export$2214112898027187);
    $parcel$export(module.exports, "getBetweenErrorMessage", ()=>$102956f839e5f725$export$b29a6f1d6d345720);
    $parcel$export(module.exports, "isValidBetweenInput", ()=>$102956f839e5f725$export$7b619dd534dac336);
    $parcel$export(module.exports, "isInvalidDateValue", ()=>$102956f839e5f725$export$f18cd4bc58b99a27);
    $parcel$export(module.exports, "checkQueryIncludesValue", ()=>$102956f839e5f725$export$792d5c0a6d15a15e);
    $parcel$export(module.exports, "parseGroupOptionQuery", ()=>$102956f839e5f725$export$f344cca10df5ca13);
    $parcel$export(module.exports, "parseOptionQuery", ()=>$102956f839e5f725$export$100c2d7fc380fbfa);
    $parcel$export(module.exports, "collectQueryParamsFromOptions", ()=>$102956f839e5f725$export$4db9080fab1bce85);
    $parcel$export(module.exports, "calculateTimeBetween", ()=>$102956f839e5f725$export$42dac873831f0e2);
    $parcel$export(module.exports, "generateLogParams", ()=>$102956f839e5f725$export$85293a2f3995ddcc);
    $parcel$export(module.exports, "fromUnitConverter", ()=>$102956f839e5f725$export$ae02811946c03a4b);
    $parcel$export(module.exports, "createBaseQuery", ()=>$102956f839e5f725$export$9a8301702bf003c4);
    $parcel$export(module.exports, "calculateNewStartAndEndTimestamp", ()=>$102956f839e5f725$export$b06db0f8b326b929);
    $parcel$export(module.exports, "isDetailsSectionEmpty", ()=>$102956f839e5f725$export$74cb10c4b9924e49);
    $parcel$export(module.exports, "generateParamsForOneMonthInterval", ()=>$102956f839e5f725$export$130612b33e678a37);
    $parcel$export(module.exports, "calculateWidthAccordingToLevel", ()=>$102956f839e5f725$export$e083dc64e00e053b);
    $parcel$export(module.exports, "getSourceStringFromUrl", ()=>$102956f839e5f725$export$c6631e198cf7c0f4);
    $parcel$export(module.exports, "makeMarkup", ()=>$102956f839e5f725$export$59302306c6f78677);
    $parcel$export(module.exports, "postProcessLogsSearch", ()=>$102956f839e5f725$export$9a858fe3837c0be0);
    var $5uXOq = parcelRequire("5uXOq");
    var $grR0x;
    var $jj52j;
    var $jovBr;
    var $eZDAP;
    var $gn1v9;
    var $gccSB = parcelRequire("gccSB");
    var $hGgHi = parcelRequire("hGgHi");
    var $cgL5K;
    var $hmVmJ;
    var $dH6Pi;
    var $2VsTe;
    var $0yCO3;
    var $hu2ZI;
    var $9Pdtb;
    const $102956f839e5f725$var$isNumeric = (value)=>/^\d+$/.test(value);
    const $102956f839e5f725$export$2214112898027187 = (timeDigits, timeUnit)=>{
        return timeDigits === '' || timeDigits !== undefined && $102956f839e5f725$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && (0, (0, parcelRequire("0yCO3")).RANGE_OPTIONS).includes(timeUnit);
    };
    const $102956f839e5f725$export$b29a6f1d6d345720 = (intl, value)=>{
        if (!value?.startDate && !value?.endDate) return intl.formatMessage((0, (0, parcelRequire("9Pdtb")).default).validationMessageAtLeastOneValue);
        if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return intl.formatMessage((0, (0, parcelRequire("9Pdtb")).default).validationMessageBeforeGreaterThanAfter);
        if (value && (value?.startDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(value?.endDate)))) return intl.formatMessage((0, (0, parcelRequire("9Pdtb")).default).validationMessageInvalidDateFormat);
        return undefined;
    };
    const $102956f839e5f725$export$7b619dd534dac336 = (value)=>{
        if (!value?.startDate && !value?.endDate) return false;
        if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return false;
        if (value && (value?.startDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(value?.endDate)))) return false;
        return true;
    };
    const $102956f839e5f725$export$f18cd4bc58b99a27 = (value)=>{
        return !(0, (0, parcelRequire("jovBr")).default)((0, (0, parcelRequire("eZDAP")).default)(value)) && value !== '';
    };
    const $102956f839e5f725$export$760bb1b75585fb94 = (value)=>{
        return value.map((event)=>event.value).join(',');
    };
    const $102956f839e5f725$export$792d5c0a6d15a15e = (query, value)=>{
        return query?.includes(value.toString()) ?? false;
    };
    const $102956f839e5f725$export$f344cca10df5ca13 = (query, options)=>{
        if (!query) return [];
        const labels = [];
        options.map((option)=>{
            option.options.map((item)=>labels.push(item));
        });
        return labels.filter(({ value: value })=>$102956f839e5f725$export$792d5c0a6d15a15e(query, value));
    };
    const $102956f839e5f725$export$100c2d7fc380fbfa = (query, options)=>{
        if (!query) return [];
        return options.filter((label)=>query.includes(label.value.toString()));
    };
    const $102956f839e5f725$export$422789958d8174dd = (unit)=>(0, (0, parcelRequire("0yCO3")).RANGE_OPTIONS).includes(unit);
    const $102956f839e5f725$export$4db9080fab1bce85 = (options)=>{
        return options.map((option)=>option.value).join(',');
    };
    const $102956f839e5f725$var$isTimeQueryParamsValid = (params)=>{
        if (params.has('startTimestamp') && params.has('endTimestamp')) return true;
        else if (params.has('fromUnit') && params.has('fromValue')) return true;
        return false;
    };
    const $102956f839e5f725$export$42dac873831f0e2 = (params)=>{
        const now = new Date();
        if (!params.get('startTimestamp') && !params.get('endTimestamp') && params.get('fromUnit') && params.get('fromValue')) {
            const parsedFromValue = parseInt(params.get('fromValue') ?? '1');
            switch(params.get('fromUnit')){
                case 'HOUR':
                    params.set('endTimestamp', (now.getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    params.set('startTimestamp', ((0, (0, parcelRequire("gn1v9")).default)(now, {
                        hours: parsedFromValue
                    }).getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    break;
                case 'DAY':
                    params.set('endTimestamp', (now.getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    params.set('startTimestamp', ((0, (0, parcelRequire("gn1v9")).default)(now, {
                        days: parsedFromValue
                    }).getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    break;
                case 'WEEK':
                    params.set('endTimestamp', (now.getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    params.set('startTimestamp', ((0, (0, parcelRequire("gn1v9")).default)(now, {
                        weeks: parsedFromValue
                    }).getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    break;
                case 'MONTH':
                    params.set('endTimestamp', (now.getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    params.set('startTimestamp', ((0, (0, parcelRequire("gn1v9")).default)(now, {
                        months: parsedFromValue
                    }).getTime() * (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND)).toString());
                    break;
            }
            params.delete('fromUnit');
            params.delete('fromValue');
        }
        return params;
    };
    const $102956f839e5f725$export$85293a2f3995ddcc = (params)=>{
        const urlParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value])=>{
            if (value) urlParams.append(key, decodeURI(value));
        });
        if (!$102956f839e5f725$var$isTimeQueryParamsValid(urlParams)) {
            urlParams.delete('fromUnit');
            urlParams.delete('fromValue');
            urlParams.delete('startTimestamp');
            urlParams.delete('endTimestamp');
            urlParams.append('fromUnit', 'DAY');
            urlParams.append('fromValue', '1');
        }
        return $102956f839e5f725$export$42dac873831f0e2(urlParams);
    };
    const $102956f839e5f725$var$calculateTimeDifference = (startDate, endDate)=>{
        const minutesDiff = (0, (0, parcelRequire("grR0x")).default)(endDate, startDate);
        if (minutesDiff < 60) return {
            hours: 1,
            days: 0,
            weeks: 0,
            months: 0,
            years: 0
        };
        const hoursDiff = minutesDiff / 60;
        const daysDiff = minutesDiff / 60 / 24;
        const weeksDiff = minutesDiff / 60 / 24 / 7;
        const monthsDiff = minutesDiff / 60 / 24 / 7 / 4;
        return {
            hours: hoursDiff > 0 ? Math.floor(hoursDiff) : 0,
            days: daysDiff > 0 ? Math.floor(daysDiff) : 0,
            weeks: weeksDiff > 0 ? Math.floor(weeksDiff) : 0,
            months: monthsDiff > 0 ? Math.floor(monthsDiff) : 0
        };
    };
    const $102956f839e5f725$export$ae02811946c03a4b = (startDate, endDate)=>{
        const parsedStartDate = (0, (0, parcelRequire("eZDAP")).default)(startDate);
        const parsedEndDate = (0, (0, parcelRequire("eZDAP")).default)(endDate);
        const timeDifference = $102956f839e5f725$var$calculateTimeDifference(parsedStartDate, parsedEndDate);
        if (timeDifference.months > 0) return {
            timeUnit: 'MONTH',
            timeDigits: timeDifference.months.toString()
        };
        else if (timeDifference.weeks > 0) return {
            timeUnit: 'WEEK',
            timeDigits: timeDifference.weeks.toString()
        };
        else if (timeDifference.days > 0) return {
            timeUnit: 'DAY',
            timeDigits: timeDifference.days.toString()
        };
        else return {
            timeUnit: 'HOUR',
            timeDigits: timeDifference.hours.toString()
        };
    };
    const $102956f839e5f725$export$9a8301702bf003c4 = (query)=>{
        let searchQuery = {};
        if (query.searchString) searchQuery = {
            ...searchQuery,
            searchString: query.searchString
        };
        if (query.startTimestamp && query.endTimestamp) searchQuery = {
            ...searchQuery,
            startTimestamp: query.startTimestamp,
            endTimestamp: query.endTimestamp
        };
        if (query.timeType) searchQuery = {
            ...searchQuery,
            timeType: query.timeType
        };
        if (query.eventCategories) searchQuery = {
            ...searchQuery,
            eventCategories: query.eventCategories
        };
        if (query.levels) searchQuery = {
            ...searchQuery,
            levels: query.levels
        };
        if (query.size) searchQuery = {
            ...searchQuery,
            size: query.size
        };
        return searchQuery;
    };
    function $102956f839e5f725$export$b06db0f8b326b929(startTimestamp, endTimestamp) {
        const startDateIntValue = parseInt(startTimestamp) / (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND);
        const endDateIntValue = parseInt(endTimestamp) / (0, (0, parcelRequire("hu2ZI")).NANOSECONDS_IN_MILLISECOND);
        const { timeDigits: fromValue, timeUnit: fromUnit } = $102956f839e5f725$export$ae02811946c03a4b((0, (0, parcelRequire("jj52j")).default)(startDateIntValue), (0, (0, parcelRequire("jj52j")).default)(endDateIntValue));
        const params = $102956f839e5f725$export$42dac873831f0e2(new URLSearchParams({
            fromValue: fromValue,
            fromUnit: fromUnit
        }));
        const startTimestampParams = params.get('startTimestamp');
        const endTimestampParams = params.get('endTimestamp');
        (0, (0, parcelRequire("hmVmJ")).assert)(!(0, ($parcel$interopDefault($hGgHi)))(startTimestampParams) && !(0, ($parcel$interopDefault($hGgHi)))(endTimestampParams), new (0, (0, parcelRequire("dH6Pi")).AssertionError)('calculateNewStartAndEndTimestamp', 'startTimestamp and endTimestamp should not be null'));
        return {
            startTimestamp: startTimestampParams,
            endTimestamp: endTimestampParams
        };
    }
    const $102956f839e5f725$export$74cb10c4b9924e49 = (importantField, raw, isImportantFieldEmpty)=>{
        if (!importantField || !raw) return true;
        const parsedImportantField = JSON.parse(importantField);
        const parsedRaw = JSON.parse(raw);
        return ((0, ($parcel$interopDefault($gccSB)))(parsedImportantField) || isImportantFieldEmpty === true) && (0, ($parcel$interopDefault($gccSB)))(parsedRaw);
    };
    const $102956f839e5f725$export$130612b33e678a37 = ()=>{
        const params = $102956f839e5f725$export$42dac873831f0e2(new URLSearchParams({
            fromUnit: 'MONTH',
            fromValue: '1'
        }));
        const startDate = params.get('startTimestamp');
        const endDate = params.get('endTimestamp');
        (0, (0, parcelRequire("hmVmJ")).assert)(!!startDate && !!endDate, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('generateParamsForOneMonthInterval', 'startTimestamp and endDate should not be null'));
        return {
            dateTimeValue: {
                startDate: startDate,
                endDate: endDate
            },
            timeType: (0, (0, parcelRequire("2VsTe")).TimeRadioOptions).WITHIN_THE_LAST
        };
    };
    const $102956f839e5f725$export$e083dc64e00e053b = (level)=>{
        const BASE_OFFSET = 18;
        return `${(0, (0, parcelRequire("hu2ZI")).DETAIL_ITEM_BASE_WIDTH) - level * BASE_OFFSET}px`;
    };
    const $102956f839e5f725$export$c6631e198cf7c0f4 = (search)=>{
        const splittedSearch = search.split(/source=/i);
        if (splittedSearch.length > 1) return decodeURIComponent(splittedSearch[1]);
        return '';
    };
    function $102956f839e5f725$export$59302306c6f78677(fragment, key) {
        const { nodeName: nodeName, nodeType: nodeType, childNodes: childNodes, textContent: textContent } = fragment;
        if (nodeType === Node.TEXT_NODE) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: key
        }, textContent);
        const children = [];
        childNodes.forEach((childNode, i)=>{
            const markup = $102956f839e5f725$export$59302306c6f78677(childNode, String(i));
            if (markup) children.push(markup);
        });
        switch(nodeName){
            case 'B':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("b", {
                    key: key
                }, children);
            case 'I':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("i", {
                    key: key
                }, children);
            case 'STRONG':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    weight: "bold",
                    key: key
                }, children);
            case 'EM':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "em",
                    key: key
                }, children);
            case 'CODE':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("code", {
                    key: key
                }, children);
        }
        if (children.length === 1) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: key
        }, children[0]);
        if (children.length) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            key: key
        }, children);
        return null;
    }
    const $102956f839e5f725$export$9a858fe3837c0be0 = (urlParams, response)=>{
        if (urlParams.get('startTimestamp') && urlParams.get('endTimestamp')) return {
            ...response,
            data: {
                ...response.data,
                pagination: {
                    ...response.data.pagination,
                    calcStartDate: urlParams.get('startTimestamp'),
                    calcEndDate: urlParams.get('endTimestamp')
                }
            }
        };
        return response;
    };
});
parcelRegister("2VsTe", function(module, exports) {
    $parcel$export(module.exports, "TimeRadioOptions", ()=>$4e8f12ca8572dc61$export$ff1338756af30600);
    var $4e8f12ca8572dc61$export$ff1338756af30600;
    (function(TimeRadioOptions) {
        TimeRadioOptions["WITHIN_THE_LAST"] = "withinTheLast";
        TimeRadioOptions["BETWEEN"] = "between";
    })($4e8f12ca8572dc61$export$ff1338756af30600 || ($4e8f12ca8572dc61$export$ff1338756af30600 = {}));
});
parcelRegister("0yCO3", function(module, exports) {
    $parcel$export(module.exports, "RANGE_OPTIONS", ()=>$928210b867587e62$export$a0f3448347834e6b);
    const $928210b867587e62$export$a0f3448347834e6b = [
        'HOUR',
        'DAY',
        'WEEK',
        'MONTH'
    ];
});
parcelRegister("hu2ZI", function(module, exports) {
    $parcel$export(module.exports, "PAGE_SIZE_QUERY_PARAM", ()=>$96911fb41d45d626$export$4b254bc84a71033a);
    $parcel$export(module.exports, "NANOSECONDS_IN_MILLISECOND", ()=>$96911fb41d45d626$export$753f41e31eccb6d7);
    $parcel$export(module.exports, "getHeaderWidths", ()=>$96911fb41d45d626$export$8aa6dbdb947f7df1);
    $parcel$export(module.exports, "DETAIL_ITEM_BASE_WIDTH", ()=>$96911fb41d45d626$export$1220f90483bde21);
    var $VSDnB;
    const $96911fb41d45d626$export$4b254bc84a71033a = 'size';
    const $96911fb41d45d626$export$753f41e31eccb6d7 = 1000000;
    const $96911fb41d45d626$export$8aa6dbdb947f7df1 = (params)=>{
        const { DATE_HEADER_WIDTH: DATE_HEADER_WIDTH, CATEGORY_HEADER_WIDTH: CATEGORY_HEADER_WIDTH, TYPE_HEADER_WIDTH: TYPE_HEADER_WIDTH, ACTOR_HEADER_WIDTH: ACTOR_HEADER_WIDTH } = params.showEventCategoryField ? {
            DATE_HEADER_WIDTH: 16,
            CATEGORY_HEADER_WIDTH: 16,
            TYPE_HEADER_WIDTH: 10,
            ACTOR_HEADER_WIDTH: 16
        } : {
            DATE_HEADER_WIDTH: 14,
            CATEGORY_HEADER_WIDTH: 0,
            TYPE_HEADER_WIDTH: 12,
            ACTOR_HEADER_WIDTH: 22
        };
        const columnsToShow = [
            DATE_HEADER_WIDTH,
            CATEGORY_HEADER_WIDTH,
            TYPE_HEADER_WIDTH,
            ...(0, (0, parcelRequire("VSDnB")).getBooleanFF)('platform.pun.audit-logs-actor-column_sxmw6') ? [
                ACTOR_HEADER_WIDTH
            ] : []
        ];
        let sum = 0;
        columnsToShow.forEach((width)=>{
            sum += width;
        });
        return {
            DATE_HEADER_WIDTH: `${DATE_HEADER_WIDTH}%`,
            CATEGORY_HEADER_WIDTH: `${CATEGORY_HEADER_WIDTH}%`,
            TYPE_HEADER_WIDTH: `${TYPE_HEADER_WIDTH}%`,
            ACTOR_HEADER_WIDTH: `${ACTOR_HEADER_WIDTH}%`,
            CHANGE_SUMMARY_HEADER_WIDTH: `${100 - sum}%`
        };
    };
    const $96911fb41d45d626$export$1220f90483bde21 = 250;
});
parcelRegister("9Pdtb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8183616acbf6d3e8$export$2e2bcd8739ae039);
    var $7VHMR;
    const $8183616acbf6d3e8$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        validationMessageBeforeGreaterThanAfter: {
            id: `eoc.customer-logs.common.utils.validation-message-before-greater-than-after.no-translate`,
            defaultMessage: 'Specify a valid time range.',
            description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
        },
        validationMessageInvalidDateFormat: {
            id: `eoc.customer-logs.common.utils.validation-message-invalid-date-format.no-translate`,
            defaultMessage: 'Invalid date format.',
            description: 'Invalid date format.'
        },
        validationMessageAtLeastOneValue: {
            id: `eoc.customer-logs.common.utils.validation-message-at-least-one-value.no-translate`,
            defaultMessage: 'Select at least one value.',
            description: 'Message displayed to the user when there is no selected before and end date together'
        }
    });
    var $8183616acbf6d3e8$export$2e2bcd8739ae039 = $8183616acbf6d3e8$var$messages;
});
parcelRegister("lCbSp", function(module, exports) {
    $parcel$export(module.exports, "uiSettingsResource", ()=>$efebb20f6ad5236b$export$f2b33518cf31cd40);
    var $2M1hQ;
    var $7xYVv;
    const $efebb20f6ad5236b$export$f2b33518cf31cd40 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ui-settings-resource',
        getKey: ()=>'ui-settings-resource',
        getData: async ()=>(0, (0, parcelRequire("7xYVv")).fetchUiSettingsEndpoint)(),
        maxAge: Infinity,
        isBrowserOnly: true
    });
});
parcelRegister("7xYVv", function(module, exports) {
    $parcel$export(module.exports, "fetchUiSettingsEndpoint", ()=>$7bc4e87c807af8e2$export$ea2f12bcbdce2020);
    var $j74qU;
    const $7bc4e87c807af8e2$export$ea2f12bcbdce2020 = async ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/logs');
    };
});
parcelRegister("iBsI0", function(module, exports) {
    $parcel$export(module.exports, "maintenanceResource", ()=>$b472cee8aa78ea18$export$5486c78261efb2c3);
    $parcel$export(module.exports, "maintenanceUserRightsResource", ()=>$b472cee8aa78ea18$export$e4c92d8948e3625);
    $parcel$export(module.exports, "resources", ()=>$b472cee8aa78ea18$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $jxRF2;
    var $czDcW;
    const $b472cee8aa78ea18$export$5486c78261efb2c3 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'maintenanceResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `maintenance/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return (0, (0, parcelRequire("czDcW")).getMaintenance)(teamId);
        },
        isBrowserOnly: true
    });
    const $b472cee8aa78ea18$export$e4c92d8948e3625 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'maintenanceUserRightsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `maintenance-user-rights/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return (0, (0, parcelRequire("czDcW")).getMaintenanceUserRights)(teamId);
        },
        isBrowserOnly: true
    });
    const $b472cee8aa78ea18$export$bc99aaabaf7b70a7 = [
        ...(0, (0, parcelRequire("jxRF2")).eocCommonResources)(),
        $b472cee8aa78ea18$export$5486c78261efb2c3,
        $b472cee8aa78ea18$export$e4c92d8948e3625
    ];
});
parcelRegister("czDcW", function(module, exports) {
    $parcel$export(module.exports, "getMaintenance", ()=>$b4a2c16b626eeb32$export$9cc878e1852c5ee1);
    $parcel$export(module.exports, "deleteMaintenance", ()=>$b4a2c16b626eeb32$export$f64242288df38e86);
    $parcel$export(module.exports, "cancelMaintenance", ()=>$b4a2c16b626eeb32$export$2d4a5362bda1b3c1);
    $parcel$export(module.exports, "changeDateAndTime", ()=>$b4a2c16b626eeb32$export$2162fcbd04e23a3d);
    $parcel$export(module.exports, "getMaintenanceUserRights", ()=>$b4a2c16b626eeb32$export$60048f3b7e7bf9b9);
    $parcel$export(module.exports, "createMaintenance", ()=>$b4a2c16b626eeb32$export$602dd976bd963418);
    $parcel$export(module.exports, "updateMaintenance", ()=>$b4a2c16b626eeb32$export$fa55cd063e1b15c2);
    var $j74qU;
    const $b4a2c16b626eeb32$export$9cc878e1852c5ee1 = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances`);
    };
    const $b4a2c16b626eeb32$export$f64242288df38e86 = (teamId, id)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}`, {
            method: 'DELETE',
            responseType: 'headers'
        });
    };
    const $b4a2c16b626eeb32$export$2d4a5362bda1b3c1 = (teamId, id)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/cancel`, {
            method: 'PATCH'
        });
    };
    const $b4a2c16b626eeb32$export$2162fcbd04e23a3d = (teamId, id, endDate)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/updateEndDate`, {
            method: 'PATCH',
            body: {
                endDate: endDate
            }
        });
    };
    const $b4a2c16b626eeb32$export$60048f3b7e7bf9b9 = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/rights`);
    };
    const $b4a2c16b626eeb32$export$602dd976bd963418 = (payload, teamId)=>{
        const url = teamId ? `/v1/teams/${teamId}/maintenances` : '/v1/maintenances';
        return (0, (0, parcelRequire("j74qU")).eocFetch)(url, {
            method: 'POST',
            body: payload
        });
    };
    const $b4a2c16b626eeb32$export$fa55cd063e1b15c2 = (payload, id, teamId)=>{
        const url = teamId ? `/v1/teams/${teamId}/maintenances/${id}` : `/v1/maintenances/${id}`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)(url, {
            method: 'PUT',
            body: payload
        });
    };
});
parcelRegister("4D5wk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9feTp")
    ]).then(()=>parcelRequire('iqyJK'));
});
parcelRegister("iufIe", function(module, exports) {
    $parcel$export(module.exports, "getTeamResource", ()=>$e31238735315794c$export$50271c9e7f21f10e);
    $parcel$export(module.exports, "resources", ()=>$e31238735315794c$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $hmVmJ;
    var $dH6Pi;
    var $8SpRt;
    var $6RRyp;
    var $4Igwk;
    const $e31238735315794c$export$50271c9e7f21f10e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'getTeamResource',
        getKey: ()=>'getTeamResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('getTeamResource', 'teamId should be set to fetch on-call'));
            return (0, (0, parcelRequire("4Igwk")).getTeam)(teamId);
        },
        isBrowserOnly: true
    });
    const $e31238735315794c$export$bc99aaabaf7b70a7 = [
        ...(0, (0, parcelRequire("6RRyp")).resources),
        (0, (0, parcelRequire("8SpRt")).routingRulesResource),
        $e31238735315794c$export$50271c9e7f21f10e
    ];
});
parcelRegister("8SpRt", function(module, exports) {
    $parcel$export(module.exports, "routingRulesResource", ()=>$8308d404e93181e1$export$7f38c73dca88500e);
    var $2M1hQ;
    var $hmVmJ;
    var $dH6Pi;
    var $eQugF;
    const $8308d404e93181e1$export$7f38c73dca88500e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'routingRulesResource',
        getKey: ()=>'routingRulesResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('routingRulesResource', 'teamId should be set to fetch routing-rules'));
            return (0, (0, parcelRequire("eQugF")).getRoutingRules)(teamId);
        },
        isBrowserOnly: true
    });
});
parcelRegister("eQugF", function(module, exports) {
    $parcel$export(module.exports, "getRoutingRules", ()=>$2cc350f95d05e13d$export$425c24c86196521);
    var $j74qU;
    const $2cc350f95d05e13d$export$425c24c86196521 = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/routing-rules`);
});
parcelRegister("6RRyp", function(module, exports) {
    $parcel$export(module.exports, "getSchedulesResource", ()=>$00ff222f7fbbe6c1$export$6b2b3e2a53cc13e2);
    $parcel$export(module.exports, "getUiPreferencesResource", ()=>$00ff222f7fbbe6c1$export$5c6454d866055bdd);
    $parcel$export(module.exports, "getScheduleRightsResource", ()=>$00ff222f7fbbe6c1$export$9d9ecb8586783931);
    $parcel$export(module.exports, "getScheduleTimeTemplatesResource", ()=>$00ff222f7fbbe6c1$export$90251855f07c54b4);
    $parcel$export(module.exports, "resources", ()=>$00ff222f7fbbe6c1$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $jxRF2;
    var $dmLt8;
    var $1IQ7I;
    var $6CGrT;
    var $6bC8A;
    var $6FjDf;
    var $c0fyU;
    const $00ff222f7fbbe6c1$export$6b2b3e2a53cc13e2 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'getSchedulesResource',
        getKey: ()=>'getSchedulesResource',
        isBrowserOnly: true,
        getData: async (routerExtendedContext)=>(0, (0, parcelRequire("6bC8A")).endpoints).getScheduleList((0, (0, parcelRequire("1IQ7I")).getTeamIdFromContext)(routerExtendedContext))
    });
    const $00ff222f7fbbe6c1$export$5c6454d866055bdd = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'getSchedulePreferencesResource',
        getKey: ()=>'getSchedulePreferencesResource',
        isBrowserOnly: true,
        getData: async (routerExtendedContext)=>(0, (0, parcelRequire("6FjDf")).endpoints).getUiPreferences((0, (0, parcelRequire("1IQ7I")).getTeamIdFromContext)(routerExtendedContext))
    });
    const $00ff222f7fbbe6c1$export$9d9ecb8586783931 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'getScheduleRightsResource',
        getKey: ()=>'getScheduleRightsResource',
        isBrowserOnly: true,
        getData: async (routerExtendedContext)=>(0, (0, parcelRequire("c0fyU")).endpoints).getScheduleRights((0, (0, parcelRequire("1IQ7I")).getTeamIdFromContext)(routerExtendedContext))
    });
    const $00ff222f7fbbe6c1$export$90251855f07c54b4 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'getScheduleTimeTemplatesResource',
        getKey: ()=>'getScheduleTimeTemplatesResourceurce',
        isBrowserOnly: true,
        getData: async ()=>(0, (0, parcelRequire("6CGrT")).endpoints).getScheduleTimeTemplates()
    });
    const $00ff222f7fbbe6c1$export$bc99aaabaf7b70a7 = [
        $00ff222f7fbbe6c1$export$6b2b3e2a53cc13e2,
        $00ff222f7fbbe6c1$export$5c6454d866055bdd,
        $00ff222f7fbbe6c1$export$9d9ecb8586783931,
        $00ff222f7fbbe6c1$export$90251855f07c54b4,
        ...(0, (0, parcelRequire("dmLt8")).resources),
        ...(0, (0, parcelRequire("jxRF2")).eocCommonResources)()
    ];
});
parcelRegister("dmLt8", function(module, exports) {
    $parcel$export(module.exports, "getTimezonesResource", ()=>$6776e3cf1d2006c9$export$7524ea9fda8149c6);
    $parcel$export(module.exports, "getTimeTemplatesResource", ()=>$6776e3cf1d2006c9$export$f045bbf39b81240d);
    $parcel$export(module.exports, "resources", ()=>$6776e3cf1d2006c9$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $8EQhZ;
    const $6776e3cf1d2006c9$export$7524ea9fda8149c6 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'getEocTimezonesResource',
        getKey: ()=>'getEocTimezonesResource',
        isBrowserOnly: true,
        getData: async ()=>(0, (0, parcelRequire("8EQhZ")).endpoints).getTimezones()
    });
    const $6776e3cf1d2006c9$export$f045bbf39b81240d = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'getEocTimeTemplatesResource',
        getKey: ()=>'getEocTimeTemplatesResource',
        isBrowserOnly: true,
        getData: async ()=>(0, (0, parcelRequire("8EQhZ")).endpoints).getTimeTemplates()
    });
    const $6776e3cf1d2006c9$export$bc99aaabaf7b70a7 = [
        $6776e3cf1d2006c9$export$7524ea9fda8149c6
    ];
});
parcelRegister("8EQhZ", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$6f3fefc2f4704aa0$export$3a2536d80ecc00e7);
    var $j74qU;
    var $lVRaA;
    const $6f3fefc2f4704aa0$var$getTimezones = async ()=>{
        const response = await (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("lVRaA")).urls).customers.timezones.url(), {
            method: 'GET'
        });
        const adjusted = response.timezones.map((timezone)=>({
                ...timezone,
                offset: timezone.offset * 60000,
                currentOffset: timezone.currentOffset * 60000
            }));
        return {
            ...response,
            timezones: adjusted
        };
    };
    const $6f3fefc2f4704aa0$var$getTimeTemplates = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("lVRaA")).urls).schedules.timeTemplates.rotation.url(), {
            method: 'GET'
        });
    };
    const $6f3fefc2f4704aa0$export$3a2536d80ecc00e7 = {
        getTimezones: $6f3fefc2f4704aa0$var$getTimezones,
        getTimeTemplates: $6f3fefc2f4704aa0$var$getTimeTemplates
    };
});
parcelRegister("lVRaA", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$e7a5202f26785602$export$bcae9ba627f604b6);
    const $e7a5202f26785602$export$bcae9ba627f604b6 = Object.freeze({
        alerts: {
            responders: {
                names: {
                    url: ()=>'/v1/alerts/responders/names'
                },
                autoComplete: {
                    url: ()=>'/v1/alerts/responders/auto-complete'
                },
                suggested: {
                    url: ()=>'/v1/alerts/responders/suggested'
                }
            }
        },
        schedules: {
            url: ()=>`/v1/schedules`,
            scheduleId: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}`,
                clone: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/clone`
                },
                name: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/name`
                },
                timezone: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/timezone`
                },
                enable: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/enable`
                },
                disable: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/disable`
                },
                webCalendarUrl: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/web-calendar-url`
                },
                timeline: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/timeline`
                },
                overrides: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides`,
                    alias: {
                        url: ({ scheduleId: scheduleId, alias: alias } = {
                            scheduleId: ':scheduleId',
                            alias: ':alias'
                        })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                    },
                    bulk: {
                        url: ({ scheduleId: scheduleId } = {
                            scheduleId: ':scheduleId'
                        })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                    }
                },
                rotations: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/rotations`,
                    rotationId: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                        order: {
                            url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                                scheduleId: ':scheduleId',
                                rotationId: ':rotationId'
                            })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                        },
                        name: {
                            url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                                scheduleId: ':scheduleId',
                                rotationId: ':rotationId'
                            })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                        }
                    }
                }
            },
            timeTemplates: {
                rotation: {
                    url: ()=>'/v1/schedules/time-templates/rotation'
                }
            }
        },
        customers: {
            timezones: {
                url: ()=>'/v1/customers/timezones'
            }
        }
    });
});
parcelRegister("1IQ7I", function(module, exports) {
    $parcel$export(module.exports, "getTeamIdFromContext", ()=>$0269d115dae63a78$export$3ea727bebc3792bb);
    var $hmVmJ;
    var $dH6Pi;
    var $lCzwW;
    const $0269d115dae63a78$export$3ea727bebc3792bb = (routerContext)=>{
        const teamId = (0, (0, parcelRequire("lCzwW")).getSafe)(()=>routerContext.match.params.teamId, null);
        (0, (0, parcelRequire("hmVmJ")).assert)(!(0, (0, parcelRequire("lCzwW")).isEmpty)(teamId), new (0, (0, parcelRequire("dH6Pi")).AssertionError)('eoc-schedule', 'teamId in routerContext is not defined'));
        return teamId;
    };
});
parcelRegister("lCzwW", function(module, exports) {
    $parcel$export(module.exports, "getSafe", ()=>$cb4f511f313ca560$export$fedb900c0ea4e699);
    $parcel$export(module.exports, "isEmpty", ()=>$cb4f511f313ca560$export$dd1bc94b04021eeb);
    $parcel$export(module.exports, "isNullOrUndefined", ()=>$cb4f511f313ca560$export$bedb7023a7733221);
    $parcel$export(module.exports, "noLeadingOrTrailingSpaces", ()=>$cb4f511f313ca560$export$5fc068d42db64a99);
    var $jkGAf;
    const $cb4f511f313ca560$export$fedb900c0ea4e699 = (fn, defaultValue)=>{
        try {
            return fn();
        } catch  {
            return defaultValue;
        }
    };
    const $cb4f511f313ca560$export$dd1bc94b04021eeb = (input)=>{
        if (input !== 0 && input !== false && !input) return true;
        if (!(input instanceof Date) && typeof input === 'object' && Object.keys(input).length === 0) return true;
        return false;
    };
    const $cb4f511f313ca560$export$bedb7023a7733221 = (input)=>{
        return input === null || input === undefined;
    };
    const $cb4f511f313ca560$export$5fc068d42db64a99 = (message)=>({ formatMessage: formatMessage })=>(value)=>{
                if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) return message ?? formatMessage((0, (0, parcelRequire("jkGAf")).messages).nameSpaceValidationError);
            };
});
parcelRegister("jkGAf", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1ca05faf5e97d101$export$defe85febe8b728c);
    var $7VHMR;
    const $1ca05faf5e97d101$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOne: {
            id: 'eoc-schedule.common.no-one',
            defaultMessage: 'No one',
            description: 'Name of the user whose type is no-one.'
        },
        error: {
            id: 'eoc-schedule.common.error',
            defaultMessage: 'Error',
            description: 'Just simple error message.'
        },
        tryAgain: {
            id: 'eoc-schedule.common.try-again',
            defaultMessage: 'Try again',
            description: 'Try again message when an error occurs.'
        },
        cancel: {
            id: 'eoc-schedule.common.cancel',
            defaultMessage: 'Cancel',
            description: 'A cancel button.'
        },
        confirm: {
            id: 'eoc-schedule.common.confirm',
            defaultMessage: 'Confirm',
            description: 'A confirm button.'
        },
        addOverride: {
            id: 'eoc-schedule.common.add-override',
            defaultMessage: 'Add override',
            description: 'Adding override for a period item.'
        },
        overrideButton: {
            id: 'eoc-schedule.common.override',
            defaultMessage: 'Override',
            description: 'A override button.'
        },
        saveButton: {
            id: 'eoc-schedule.common.save',
            defaultMessage: 'Save',
            description: 'A save button.'
        },
        edit: {
            id: 'eoc-schedule.common.edit',
            defaultMessage: 'Edit',
            description: 'Button for editing schedule.'
        },
        turnOff: {
            id: 'eoc-schedule.common.turn-off',
            defaultMessage: 'Turn off',
            description: 'Button for turn-offing schedule.'
        },
        turnOn: {
            id: 'eoc-schedule.common.turn-on',
            defaultMessage: 'Turn on',
            description: 'Button for turn-on schedule.'
        },
        delete: {
            id: 'eoc-schedule.common.delete',
            defaultMessage: 'Delete',
            description: 'Button for deleting schedule or rotation.'
        },
        duplicate: {
            id: 'eoc-schedule.common.duplicate',
            defaultMessage: 'Duplicate',
            description: 'Button for duplicating schedule or rotation.'
        },
        remove: {
            id: 'eoc-schedule.common.remove',
            defaultMessage: 'Remove',
            description: 'Button for removing participant.'
        },
        start: {
            id: 'eoc-schedule.common.start',
            defaultMessage: 'Start',
            description: 'Label for start time and date.'
        },
        end: {
            id: 'eoc-schedule.common.end',
            defaultMessage: 'End',
            description: 'Label for end time and date.'
        },
        startTime: {
            id: 'eoc-schedule.common.start-time',
            defaultMessage: 'Start time',
            description: 'Label for start time and date.'
        },
        endTime: {
            id: 'eoc-schedule.common.end-time',
            defaultMessage: 'End time',
            description: 'Label for end time and date.'
        },
        startDate: {
            id: 'eoc-schedule.common.start-date',
            defaultMessage: 'Start date',
            description: 'Label for start time and date.'
        },
        endDate: {
            id: 'eoc-schedule.common.end-date',
            defaultMessage: 'End date',
            description: 'Label for end time and date.'
        },
        team: {
            id: 'eoc-schedule.common.team',
            defaultMessage: 'Team',
            description: 'Label that indicates responder is of type: Team'
        },
        escalation: {
            id: 'eoc-schedule.common.escalation',
            defaultMessage: 'Escalation',
            description: 'Label that indicates responder is of type: Escalation'
        },
        schedule: {
            id: 'eoc-schedule.common.schedule',
            defaultMessage: 'Schedule',
            description: 'Label that indicates responder is of type: Schedule'
        },
        selectionCount: {
            id: 'eoc-schedule.common.selection-count',
            defaultMessage: '{count} shifts selected',
            description: 'Indicates how many shifts are selected for override.'
        },
        quickOverrideTitle: {
            id: 'eoc-schedule.common.quick-override-title',
            defaultMessage: 'OVERRIDE',
            description: 'Title for quick override card.'
        },
        search: {
            id: 'eoc-schedule.common.search',
            defaultMessage: 'Search',
            description: 'Label of search icon that shown inside search participant field'
        },
        replaceWith: {
            id: 'eoc-schedule.common.replace-with',
            defaultMessage: 'Replace with',
            description: 'A button for opening popup for replacing a participant.'
        },
        participants: {
            id: 'eoc-schedule.common.participants',
            defaultMessage: 'Participants',
            description: 'Label for participants.'
        },
        addParticipants: {
            id: 'eoc-schedule.common.add-participants',
            defaultMessage: 'Add people, teams, and escalation policies',
            description: 'Placeholder text for auto complete field for participants (responders).'
        },
        select: {
            id: 'eoc-schedule.common.select',
            defaultMessage: 'Select',
            description: 'Label that indicates selecting.'
        },
        teamDeleted: {
            id: 'eoc-schedule.common.team-deleted',
            defaultMessage: 'Team deleted',
            description: 'Fallback responder name that suggest team is deleted.'
        },
        deletedSchedule: {
            id: 'eoc-schedule.common.deleted-schedule',
            defaultMessage: 'Deleted schedule',
            description: 'Fallback responder name that suggest schedule is deleted.'
        },
        deletedEscalation: {
            id: 'eoc-schedule.common.deleted-escalation',
            defaultMessage: 'Deleted escalation',
            description: 'Fallback responder name that suggest escalation is deleted.'
        },
        formerUser: {
            id: 'eoc-schedule.common.former-user',
            defaultMessage: 'Former user',
            description: 'Fallback responder name that suggest user is deactivated or deleted.'
        },
        discard: {
            id: 'eoc-schedule.common.discard',
            defaultMessage: 'Discard',
            description: 'Button for discarding.'
        },
        confirmProceed: {
            id: 'eoc-schedule.common.confirm-proceed',
            defaultMessage: 'Are you sure to proceed?',
            description: 'A confirmation for proceeding.'
        },
        required: {
            id: 'eoc-schedule.common.required',
            defaultMessage: 'This field is required.',
            description: 'A text that informs users that field should be filled.'
        },
        noSpaceAtEndOrStart: {
            id: 'eoc-schedule.common.no-space-at-end-or-start',
            defaultMessage: 'Field cannot contain spaces at start or end.',
            description: 'A text that informs users that field cannot start or end with spaces.'
        },
        maxLength: {
            id: 'eoc-schedule.common.max-length',
            defaultMessage: 'Field cannot be longer than {max} characters.',
            description: 'A text that informs users that field should be shorter than certain length.'
        },
        maxValue: {
            id: 'eoc-schedule.common.max-value',
            defaultMessage: 'Field should be less than {max}.',
            description: 'A text that informs users that field should be less than certain value.'
        },
        minValue: {
            id: 'eoc-schedule.common.min-value',
            defaultMessage: 'Enter digit 1 or more.',
            description: 'This sentence instructs the user to input a numeric value of at least 1 digit or greater.'
        },
        timePast: {
            id: 'eoc-schedule.common.time-past',
            defaultMessage: 'Time should be later than current time.',
            description: 'Validation error that indicates time values is in past.'
        },
        startLaterEnd: {
            id: 'eoc-schedule.common.start-later-end',
            defaultMessage: 'Start time should be earlier than the end time.',
            description: 'Validation error that indicates start time is later than the end time.'
        },
        endEarlierStart: {
            id: 'eoc-schedule.common.end-earlier-start',
            defaultMessage: 'End time should be later than the start time.',
            description: 'Validation error that indicates end time is earlier than the start time.'
        },
        startEndSame: {
            id: 'eoc-schedule.common.start-end-same',
            defaultMessage: 'Start and end time cannot be same.',
            description: 'Validation error that indicates start and end time should be different.'
        },
        thirtyMinuteInterval: {
            id: 'eoc-schedule.common.thirty-minute-intervals',
            defaultMessage: 'Time should be defined as 30 minute intervals.',
            description: 'Validation error that indicates time can be in 30 minutes intervals.'
        },
        nameSpaceValidationError: {
            id: 'eoc-schedule.common.name-space-validation-error',
            defaultMessage: 'The name cannot start or end with a space.',
            description: 'Error message for name validation when it starts or ends with a space'
        }
    });
});
parcelRegister("6CGrT", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$fe0104c8713239aa$export$3a2536d80ecc00e7);
    var $j74qU;
    var $cB5Mt;
    const $fe0104c8713239aa$var$orderRotation = ({ scheduleId: scheduleId, after: after, rotationId: rotationId })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.rotations.rotationId.order.url({
            rotationId: rotationId,
            scheduleId: scheduleId
        }), {
            method: 'PATCH',
            body: {
                after: after
            }
        });
    };
    const $fe0104c8713239aa$var$getRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.rotations.rotationId.url({
            scheduleId: scheduleId,
            rotationId: rotationId
        }), {
            method: 'GET'
        });
    };
    const $fe0104c8713239aa$var$deleteRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.rotations.rotationId.url({
            scheduleId: scheduleId,
            rotationId: rotationId
        }), {
            method: 'DELETE'
        });
    };
    const $fe0104c8713239aa$var$addRotation = ({ name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, hasEndTime: hasEndTime, rotationPeriod: rotationPeriod, scheduleId: scheduleId, timeTemplateId: timeTemplateId, timingType: timingType, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.rotations.url({
            scheduleId: scheduleId
        }), {
            method: 'POST',
            body: {
                name: name,
                responders: responders,
                restrictions: restrictions,
                rotationType: rotationType,
                timeTemplateId: timeTemplateId,
                timingType: timingType,
                rotationPeriod: rotationPeriod,
                startTimeRaw: startTimeRaw,
                endTimeRaw: endTimeRaw,
                hasEndTime: hasEndTime
            }
        });
    };
    const $fe0104c8713239aa$var$editRotation = ({ id: id, name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, rotationPeriod: rotationPeriod, hasEndTime: hasEndTime, timingType: timingType, scheduleId: scheduleId, timeTemplateId: timeTemplateId, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.rotations.rotationId.url({
            scheduleId: scheduleId,
            rotationId: id
        }), {
            method: 'PUT',
            body: {
                id: id,
                name: name,
                responders: responders,
                restrictions: restrictions,
                rotationType: rotationType,
                rotationPeriod: rotationPeriod,
                timeTemplateId: timeTemplateId,
                timingType: timingType,
                startTimeRaw: startTimeRaw,
                endTimeRaw: endTimeRaw,
                hasEndTime: hasEndTime
            }
        });
    };
    const $fe0104c8713239aa$var$getScheduleTimeTemplates = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.timeTemplates.rotation.url(), {
            method: 'GET'
        });
    };
    const $fe0104c8713239aa$export$3a2536d80ecc00e7 = {
        deleteRotation: $fe0104c8713239aa$var$deleteRotation,
        getRotation: $fe0104c8713239aa$var$getRotation,
        orderRotation: $fe0104c8713239aa$var$orderRotation,
        addRotation: $fe0104c8713239aa$var$addRotation,
        editRotation: $fe0104c8713239aa$var$editRotation,
        getScheduleTimeTemplates: $fe0104c8713239aa$var$getScheduleTimeTemplates
    };
});
parcelRegister("cB5Mt", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$09cb24bcb900cd8c$export$bcae9ba627f604b6);
    const $09cb24bcb900cd8c$export$bcae9ba627f604b6 = Object.freeze({
        alerts: {
            responders: {
                names: {
                    url: ()=>'/v1/alerts/responders/names'
                },
                autoComplete: {
                    url: ()=>'/v1/alerts/responders/auto-complete'
                }
            }
        },
        schedules: {
            url: ()=>`/v1/schedules`,
            teams: {
                teamId: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/schedules/teams/${teamId}`,
                    rights: {
                        url: ({ teamId: teamId } = {
                            teamId: ':teamId'
                        })=>`/v1/schedules/teams/${teamId}/rights`
                    }
                }
            },
            scheduleId: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}`,
                clone: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/clone`
                },
                name: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/name`
                },
                timezone: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/timezone`
                },
                enable: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/enable`
                },
                disable: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/disable`
                },
                webCalendarUrl: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/web-calendar-url`
                },
                timeline: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/timeline`
                },
                overrides: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides`,
                    alias: {
                        url: ({ scheduleId: scheduleId, alias: alias } = {
                            scheduleId: ':scheduleId',
                            alias: ':alias'
                        })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                    },
                    bulk: {
                        url: ({ scheduleId: scheduleId } = {
                            scheduleId: ':scheduleId'
                        })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                    }
                },
                rotations: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/rotations`,
                    rotationId: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                        order: {
                            url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                                scheduleId: ':scheduleId',
                                rotationId: ':rotationId'
                            })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                        },
                        name: {
                            url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                                scheduleId: ':scheduleId',
                                rotationId: ':rotationId'
                            })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                        }
                    }
                }
            },
            timeTemplates: {
                rotation: {
                    url: ()=>'/v1/schedules/time-templates/rotation'
                }
            }
        },
        customers: {
            timezones: {
                url: ()=>'/v1/customers/timezones'
            }
        },
        uiPreference: {
            schedule: {
                team: {
                    teamId: {
                        url: ({ teamId: teamId } = {
                            teamId: ':teamId'
                        })=>`/v1/users/ui-preference/schedule/team/${teamId}`
                    }
                }
            }
        },
        onboarding: {
            completeTask: {
                url: ()=>'/v1/onboarding/complete-task'
            }
        }
    });
});
parcelRegister("6bC8A", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$94e539ffc0ded8a5$export$3a2536d80ecc00e7);
    var $j74qU;
    var $cB5Mt;
    const $94e539ffc0ded8a5$var$getScheduleList = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.teams.teamId.url({
            teamId: teamId
        }));
    };
    const $94e539ffc0ded8a5$var$updateSchedule = ({ scheduleId: scheduleId, description: description, name: name, enabled: enabled, timezone: timezone })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.url({
            scheduleId: scheduleId
        }), {
            method: 'PATCH',
            body: {
                description: description,
                name: name,
                enabled: enabled,
                timezone: timezone
            }
        });
    };
    const $94e539ffc0ded8a5$var$deleteSchedule = ({ scheduleId: scheduleId })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.url({
            scheduleId: scheduleId
        }), {
            method: 'DELETE'
        });
    };
    const $94e539ffc0ded8a5$export$3a2536d80ecc00e7 = {
        deleteSchedule: $94e539ffc0ded8a5$var$deleteSchedule,
        getScheduleList: $94e539ffc0ded8a5$var$getScheduleList,
        updateSchedule: $94e539ffc0ded8a5$var$updateSchedule
    };
});
parcelRegister("6FjDf", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$4c5802ac60e7f752$export$3a2536d80ecc00e7);
    var $j74qU;
    var $cB5Mt;
    const $4c5802ac60e7f752$var$getUiPreferences = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).uiPreference.schedule.team.teamId.url({
            teamId: teamId
        }));
    };
    const $4c5802ac60e7f752$var$updateUiPreferences = ({ teamId: teamId, key: key, value: value })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).uiPreference.schedule.team.teamId.url({
            teamId: teamId
        }), {
            method: 'PATCH',
            body: {
                [key]: value
            }
        });
    };
    const $4c5802ac60e7f752$export$3a2536d80ecc00e7 = {
        getUiPreferences: $4c5802ac60e7f752$var$getUiPreferences,
        updateUiPreferences: $4c5802ac60e7f752$var$updateUiPreferences
    };
});
parcelRegister("c0fyU", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$7066040345150142$export$3a2536d80ecc00e7);
    var $j74qU;
    var $cB5Mt;
    const $7066040345150142$var$getScheduleRights = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.teams.teamId.rights.url({
            teamId: teamId
        }));
    };
    const $7066040345150142$var$createSchedule = ({ description: description, name: name, teamId: teamId, timezone: timezone })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.url(), {
            method: 'POST',
            body: {
                description: description,
                name: name,
                teamId: teamId,
                timezone: timezone,
                enabled: true
            }
        });
    };
    const $7066040345150142$var$cloneSchedule = ({ description: description, name: name, enabled: enabled, timezone: timezone, teamId: teamId, scheduleId: scheduleId })=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("cB5Mt")).urls).schedules.scheduleId.clone.url({
            scheduleId: scheduleId
        }), {
            method: 'POST',
            body: {
                description: description,
                name: name,
                enabled: enabled,
                timezone: timezone,
                teamId: teamId
            }
        });
    };
    const $7066040345150142$export$3a2536d80ecc00e7 = {
        createSchedule: $7066040345150142$var$createSchedule,
        getScheduleRights: $7066040345150142$var$getScheduleRights,
        cloneSchedule: $7066040345150142$var$cloneSchedule
    };
});
parcelRegister("4Igwk", function(module, exports) {
    $parcel$export(module.exports, "getTeam", ()=>$54c26d3a47aeeed9$export$491fe77f22ab2b51);
    var $j74qU;
    const $54c26d3a47aeeed9$export$491fe77f22ab2b51 = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/responders/names`, {
            method: 'POST',
            body: {
                responders: [
                    {
                        id: teamId,
                        type: 'team'
                    }
                ]
            }
        });
});
parcelRegister("4uLc4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b0ycI")
    ]).then(()=>parcelRequire('38rnw'));
});
parcelRegister("5OcAv", function(module, exports) {
    $parcel$export(module.exports, "getTeamsResource", ()=>$221e2d1c864e815a$export$27d854bd39923fc7);
    var $9qm0o;
    var $8NtOA;
    var $2M1hQ;
    const $221e2d1c864e815a$export$27d854bd39923fc7 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("8NtOA")).getTeamsResource).type,
        getKey: (0, (0, parcelRequire("8NtOA")).getTeamsResource).getKey,
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } })=>{
            if (!atlassianAccountId) return null;
            const shouldSeeAllTeams = isSiteAdmin || isAdmin;
            return (0, (0, parcelRequire("9qm0o")).getTeams)({
                queryParams: {
                    accountId: !shouldSeeAllTeams ? atlassianAccountId : undefined,
                    showAvatar: true
                }
            });
        },
        isBrowserOnly: true,
        maxAge: 0
    });
});
parcelRegister("9qm0o", function(module, exports) {
    $parcel$export(module.exports, "getTeams", ()=>$66ba5008bb81f78a$export$5a622455e94bac3);
    var $j74qU;
    const $66ba5008bb81f78a$export$5a622455e94bac3 = ({ url: url, queryParams: queryParams })=>{
        const params = new URLSearchParams();
        if (queryParams.keyword) params.append('keyword', queryParams.keyword);
        if (queryParams.size) params.append('size', queryParams.size.toString());
        if (queryParams.offset) params.append('offset', queryParams.offset.toString());
        if (queryParams.accountId) params.append('memberId', queryParams.accountId);
        if (queryParams.showAvatar) params.append('showAvatar', String(queryParams.showAvatar));
        if (url) return (0, (0, parcelRequire("j74qU")).eocFetch)(`${url}${params.toString() ? `?${params.toString()}` : ''}`, {
            exactUrl: true
        });
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams${params.toString() ? `?${params.toString()}` : ''}`);
    };
});
parcelRegister("8NtOA", function(module, exports) {
    $parcel$export(module.exports, "getTeamsResource", ()=>$61e1720e70cf825e$export$27d854bd39923fc7);
    var $2M1hQ;
    var $9qm0o;
    const $61e1720e70cf825e$export$27d854bd39923fc7 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'getTeamsResource',
        getKey: ()=>'overview',
        getData: async ()=>{
            throw new Error('getData of getTeamsResource is not implemented in platform package, you should do it in your product');
        },
        isBrowserOnly: true
    });
});
parcelRegister("gN3Xa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("92gV4")
    ]).then(()=>parcelRequire('hTI3Y'));
});
parcelRegister("veU39", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hbHCQ")
    ]).then(()=>parcelRequire('jMqXq'));
});
parcelRegister("j4Jjv", function(module, exports) {
    $parcel$export(module.exports, "pageAccessResource", ()=>$0ef99385700ea410$export$b0d36f8262140e35);
    $parcel$export(module.exports, "memberRolesResource", ()=>$0ef99385700ea410$export$5c4885c1f1a535b);
    $parcel$export(module.exports, "getTeamResource", ()=>$0ef99385700ea410$export$50271c9e7f21f10e);
    $parcel$export(module.exports, "customTeamRolesResource", ()=>$0ef99385700ea410$export$ed1eb48699cf7893);
    $parcel$export(module.exports, "resources", ()=>$0ef99385700ea410$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $hmVmJ;
    var $dH6Pi;
    var $cN8Qq;
    const $0ef99385700ea410$var$mapStatus = (status, userAccessLevel)=>{
        if (userAccessLevel === 'INTERNAL_INACTIVE') return 'suspended';
        if (status === 'REQUEST_ACCESS' || status === 'DENIED_REQUEST_EXISTS' || status === 'FORBIDDEN' || status === 'DIRECT_ACCESS') return 'invite';
        if (status === 'ACCESS_EXISTS') return 'member';
        if (status === 'PENDING_REQUEST_EXISTS') return 'pending';
        if (status === '' || status === undefined) return 'member';
        return 'invite';
    };
    const $0ef99385700ea410$var$checkPageAccessRightsOnRouteDependency = async (dependencies)=>{
        let isAuthorizedToSeeMemberRolesPage = false;
        if (dependencies[$0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE]) {
            const data = await dependencies[$0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE].promise;
            isAuthorizedToSeeMemberRolesPage = data?.productOrTeamAdmin;
        }
        return isAuthorizedToSeeMemberRolesPage;
    };
    const $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE = 'pageAccessResource';
    const $0ef99385700ea410$export$b0d36f8262140e35 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE,
        getKey: ()=>'pageAccessResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('pageAccessResource', 'teamId should be set to fetch page access'));
            return (0, (0, parcelRequire("cN8Qq")).getMemberRolesPageAccess)(teamId);
        },
        isBrowserOnly: true
    });
    const $0ef99385700ea410$export$5c4885c1f1a535b = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'memberRolesResource',
        getKey: ()=>'memberRolesResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            const dependencies = routerContext.dependencies;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('memberRolesResource', 'teamId should be set to fetch member-roles'));
            const isAuthorizedToSeeMemberRolesPage = await $0ef99385700ea410$var$checkPageAccessRightsOnRouteDependency(dependencies);
            if (!isAuthorizedToSeeMemberRolesPage) return null;
            const gqlResponse = await (0, (0, parcelRequire("cN8Qq")).getMembers)(teamId);
            let members = [];
            members = gqlResponse?.data.team.teamV2.members.edges.map((edge)=>edge.node.member);
            const teamMembers = await (0, (0, parcelRequire("cN8Qq")).getRoleAndJSMLicenseInfoEndpoint)({
                platformTeamId: teamId,
                accountIds: members.map((member)=>member.accountId)
            }).then((res)=>{
                const users = members.map((user)=>{
                    const userWithRole = res.teamMembers.find((userWithRole)=>userWithRole.accountId === user.accountId);
                    return {
                        ...user,
                        role: userWithRole?.roleId || 'user',
                        jsmLicense: userWithRole?.jsmLicense || false,
                        jiraAdmin: userWithRole?.jiraAdmin || false,
                        invitationStatus: 'member'
                    };
                });
                return users;
            });
            const membersWithoutJSMLicense = teamMembers.filter((teamMembers)=>!teamMembers.jsmLicense);
            if (membersWithoutJSMLicense.length > 0) {
                const accountIds = membersWithoutJSMLicense.map((member)=>member.accountId).join(',');
                const membersWithFullInfo = await (0, (0, parcelRequire("cN8Qq")).getJSMInvitationStatusInfoEndpoint)({
                    accountIds: accountIds
                }).then((res)=>{
                    const users = teamMembers.map((user)=>{
                        const userWithInvitationStatus = res.embeddedValue.find((userWithInvitationStatus)=>userWithInvitationStatus.accountId === user.accountId);
                        return {
                            ...user,
                            invitationStatus: $0ef99385700ea410$var$mapStatus(userWithInvitationStatus?.accessMode, userWithInvitationStatus?.userAccessLevel)
                        };
                    });
                    return users;
                }).catch((err)=>{
                    return teamMembers;
                });
                return membersWithFullInfo;
            }
            return teamMembers;
        },
        isBrowserOnly: true,
        depends: [
            $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE
        ]
    });
    const $0ef99385700ea410$export$50271c9e7f21f10e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'getTeamResource',
        getKey: ()=>'getTeamResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('getTeamResource', 'teamId should be set to fetch team info on member roles'));
            return (0, (0, parcelRequire("cN8Qq")).getTeam)(teamId);
        },
        isBrowserOnly: true
    });
    const $0ef99385700ea410$export$ed1eb48699cf7893 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'customTeamRolesResource',
        getKey: ()=>'customRolesResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            const dependencies = routerContext.dependencies;
            (0, (0, parcelRequire("hmVmJ")).assert)(!!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('customTeamRolesResource', 'teamId should be set to fetch custom-team-roles'));
            const isAuthorizedToSeeMemberRolesPage = await $0ef99385700ea410$var$checkPageAccessRightsOnRouteDependency(dependencies);
            if (!isAuthorizedToSeeMemberRolesPage) return null;
            return (0, (0, parcelRequire("cN8Qq")).getCustomTeamRolesEndpoint)(teamId);
        },
        isBrowserOnly: true,
        depends: [
            $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE
        ]
    });
    const $0ef99385700ea410$export$bc99aaabaf7b70a7 = [
        $0ef99385700ea410$export$5c4885c1f1a535b,
        $0ef99385700ea410$export$50271c9e7f21f10e,
        $0ef99385700ea410$export$ed1eb48699cf7893
    ];
});
parcelRegister("cN8Qq", function(module, exports) {
    $parcel$export(module.exports, "getMembers", ()=>$33127c313f2bb6a1$export$f4931e6f9feb30c5);
    $parcel$export(module.exports, "getMemberRolesPageAccess", ()=>$33127c313f2bb6a1$export$95d4c4e762437fdd);
    $parcel$export(module.exports, "getRoleAndJSMLicenseInfoEndpoint", ()=>$33127c313f2bb6a1$export$38ab389cb64a5000);
    $parcel$export(module.exports, "getJSMInvitationStatusInfoEndpoint", ()=>$33127c313f2bb6a1$export$fd43007da8683026);
    $parcel$export(module.exports, "getTeam", ()=>$33127c313f2bb6a1$export$491fe77f22ab2b51);
    $parcel$export(module.exports, "getCustomTeamRolesEndpoint", ()=>$33127c313f2bb6a1$export$ebfa293eb1ef42f5);
    var $VSDnB;
    var $j74qU;
    var $030R0;
    const $33127c313f2bb6a1$var$operationName = 'memberRolesTeamMembersQuery';
    const $33127c313f2bb6a1$export$f4931e6f9feb30c5 = (teamId)=>{
        const queryUrl = '/gateway/api/graphql';
        const teamAri = `ari:cloud:identity::team/${teamId}`;
        const siteId = (0, (0, parcelRequire("030R0")).getMeta)('ajs-cloud-id');
        const membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
		team {
			teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
				id
				members ${(0, (0, parcelRequire("VSDnB")).fg)('platform_increase_limit_of_members_query') ? '(first: 300)' : ''}{
					edges {
						cursor
						node {
							member  {
								... on AtlassianAccountUser {
									email
								}
								name
								picture
								accountId
								accountStatus
							}
							state
							role
						}
					}
				}
			}
		}
	}
	`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)(queryUrl, {
            method: 'POST',
            body: JSON.stringify({
                operationName: $33127c313f2bb6a1$var$operationName,
                query: membersQueryV2,
                variables: {
                    teamId: teamAri,
                    siteId: siteId
                }
            }),
            headers: {
                'Content-Type': 'application/json',
                'X-ExperimentalApi': 'teams-beta, team-members-beta'
            },
            exactUrl: true
        });
    };
    const $33127c313f2bb6a1$export$95d4c4e762437fdd = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/members/member-roles-page-access?platformTeamId=${teamId}`);
    const $33127c313f2bb6a1$export$38ab389cb64a5000 = ({ platformTeamId: platformTeamId, accountIds: accountIds })=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/members`, {
            method: 'POST',
            body: {
                platformTeamId: platformTeamId,
                accountIds: accountIds
            }
        });
    const $33127c313f2bb6a1$export$fd43007da8683026 = ({ accountIds: accountIds })=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/access-request-capabilities?accountIds=${accountIds}`, {
            method: 'GET'
        });
    const $33127c313f2bb6a1$export$491fe77f22ab2b51 = (teamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/responders/names`, {
            method: 'POST',
            body: {
                responders: [
                    {
                        id: teamId,
                        type: 'team'
                    }
                ]
            }
        });
    const $33127c313f2bb6a1$export$ebfa293eb1ef42f5 = (platformTeamId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${platformTeamId}/roles`);
});
parcelRegister("hrn9o", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gZDDu")
    ]).then(()=>parcelRequire('6Zxu7'));
});
parcelRegister("f4VN0", function(module, exports) {
    $parcel$export(module.exports, "teamPolicyResource", ()=>$f22ff5b7b8e8fefe$export$10d7fa513f08ef83);
    $parcel$export(module.exports, "notificationPolicyResource", ()=>$f22ff5b7b8e8fefe$export$6d5f23d9118ad678);
    $parcel$export(module.exports, "globalPolicyResource", ()=>$f22ff5b7b8e8fefe$export$7aed80da979a5112);
    $parcel$export(module.exports, "resources", ()=>$f22ff5b7b8e8fefe$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $11dmp;
    const $f22ff5b7b8e8fefe$export$10d7fa513f08ef83 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'teamPolicyResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `team-policy/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            if (!teamId) return null;
            return (0, (0, parcelRequire("11dmp")).getTeamPolicies)(teamId);
        },
        isBrowserOnly: true
    });
    const $f22ff5b7b8e8fefe$export$6d5f23d9118ad678 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'notificationPolicyResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `notification-policy/${teamId}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            if (!teamId) return;
            return (0, (0, parcelRequire("11dmp")).getNotificationPolicies)(teamId);
        },
        isBrowserOnly: true
    });
    const $f22ff5b7b8e8fefe$export$7aed80da979a5112 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'globalPolicyResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            if (teamId) return `global-policy/${teamId}`;
            return 'global-policy';
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return (0, (0, parcelRequire("11dmp")).getGlobalPolicies)(teamId);
        },
        isBrowserOnly: true
    });
    const $f22ff5b7b8e8fefe$export$4cb385c2db8b1e99 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'policyMaintenanceRightsResource',
        getKey: ()=>'policy-maintenance-rights-resource',
        getData: async ()=>{
            return (0, (0, parcelRequire("11dmp")).getPolicyMaintenanceRights)();
        },
        isBrowserOnly: true
    });
    const $f22ff5b7b8e8fefe$export$bc99aaabaf7b70a7 = [
        $f22ff5b7b8e8fefe$export$10d7fa513f08ef83,
        $f22ff5b7b8e8fefe$export$7aed80da979a5112,
        $f22ff5b7b8e8fefe$export$4cb385c2db8b1e99,
        $f22ff5b7b8e8fefe$export$6d5f23d9118ad678
    ];
});
parcelRegister("11dmp", function(module, exports) {
    $parcel$export(module.exports, "getTeamPolicies", ()=>$970bb189ad752795$export$fead0944caa1c797);
    $parcel$export(module.exports, "getGlobalPolicies", ()=>$970bb189ad752795$export$17fc7fbef061a8c3);
    $parcel$export(module.exports, "getNotificationPolicies", ()=>$970bb189ad752795$export$342525d9423e55ad);
    $parcel$export(module.exports, "getPolicyMaintenanceRights", ()=>$970bb189ad752795$export$f630cbf5586dce0a);
    $parcel$export(module.exports, "updateUIPreferenceEndpoint", ()=>$970bb189ad752795$export$6a437b43ab11275d);
    $parcel$export(module.exports, "changePolicyOrderEndpoint", ()=>$970bb189ad752795$export$57186d786c96b52a);
    $parcel$export(module.exports, "enablePolicyEndpoint", ()=>$970bb189ad752795$export$6fecd226d8e55346);
    $parcel$export(module.exports, "disablePolicyEndpoint", ()=>$970bb189ad752795$export$8c0cd218e00b7d9b);
    $parcel$export(module.exports, "deletePolicyEndpoint", ()=>$970bb189ad752795$export$f9feac6c1dcc516f);
    $parcel$export(module.exports, "createPolicyEndpoint", ()=>$970bb189ad752795$export$b0108c51b962e788);
    $parcel$export(module.exports, "updatePolicyEndpoint", ()=>$970bb189ad752795$export$8eabce250a2dd205);
    var $j74qU;
    const $970bb189ad752795$export$fead0944caa1c797 = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/policies?type=alert`);
    };
    const $970bb189ad752795$export$17fc7fbef061a8c3 = (teamId)=>{
        if (teamId) return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/policies?preferredUITeamId=${teamId}`);
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/policies`);
    };
    const $970bb189ad752795$export$342525d9423e55ad = (teamId)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${teamId}/policies?type=notification`);
    };
    const $970bb189ad752795$export$f630cbf5586dce0a = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/ui-preferences/policy-maintenance-rights`);
    };
    const $970bb189ad752795$export$6a437b43ab11275d = ({ teamId: teamId, ...payload })=>{
        let url = `/v1/alerts/ui-preferences/policies`;
        if (teamId) url = `${url}?teamId=${teamId}`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)(url, {
            method: 'PATCH',
            body: payload,
            responseType: 'headers'
        });
    };
    const $970bb189ad752795$export$57186d786c96b52a = (payload)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
            method: 'PATCH',
            body: {
                after: payload.after
            },
            responseType: 'headers'
        });
    };
    const $970bb189ad752795$export$6fecd226d8e55346 = (payload)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
            method: 'POST',
            responseType: 'headers'
        });
    };
    const $970bb189ad752795$export$8c0cd218e00b7d9b = (payload)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
            method: 'POST',
            responseType: 'headers'
        });
    };
    const $970bb189ad752795$export$f9feac6c1dcc516f = (payload)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
            method: 'DELETE',
            responseType: 'headers'
        });
    };
    const $970bb189ad752795$export$b0108c51b962e788 = (payload)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${payload.teamId}/policies`, {
            method: 'POST',
            body: payload
        });
    };
    const $970bb189ad752795$export$8eabce250a2dd205 = (payload)=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
            method: 'PUT',
            body: payload
        });
    };
});
parcelRegister("kJNlJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("d7ZnT")
    ]).then(()=>parcelRequire('3IgJn'));
});
parcelRegister("dY89w", function(module, exports) {
    $parcel$export(module.exports, "opsReportsResource", ()=>$adcf91cb99206588$export$8498311fc7a4ab48);
    $parcel$export(module.exports, "opsReportsPermissionResource", ()=>$adcf91cb99206588$export$c432f280d76e2acf);
    $parcel$export(module.exports, "resources", ()=>$adcf91cb99206588$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $hmVmJ;
    var $dH6Pi;
    var $5oSMF;
    var $QF2yk;
    const $adcf91cb99206588$export$8498311fc7a4ab48 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'opsReportsResource',
        getKey: ()=>'opsReportsResource',
        getData: async ()=>{
            const settings = await (0, (0, parcelRequire("QF2yk")).getReportSettings)();
            const api = (0, (0, parcelRequire("QF2yk")).getDashboards);
            return {
                settings: settings,
                dashboards: settings.showReportingMaintenance ? null : await api()
            };
        },
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $adcf91cb99206588$export$c432f280d76e2acf = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'opsReportsPermissionResource',
        getKey: ({ match: match })=>{
            return `opsReportsPermissionResource-${match.params?.teamId}`;
        },
        getData: async (routerContext)=>{
            const isTeamDashboard = (0, (0, parcelRequire("5oSMF")).isTeamReportsUrl)(routerContext.match.url);
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("hmVmJ")).assert)(!isTeamDashboard || !!teamId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('opsReportsPermissionResource', 'teamId should be set to fetch reports permissions on TeamDashboard page'));
            return (0, (0, parcelRequire("QF2yk")).getReportRights)(teamId);
        },
        isBrowserOnly: true,
        maxAge: Infinity
    });
    const $adcf91cb99206588$export$bc99aaabaf7b70a7 = [
        $adcf91cb99206588$export$8498311fc7a4ab48,
        $adcf91cb99206588$export$c432f280d76e2acf
    ];
});
parcelRegister("5oSMF", function(module, exports) {
    $parcel$export(module.exports, "withReportingPrefix", ()=>$8aa539155af4c630$export$c0f073d636267c44);
    $parcel$export(module.exports, "isTeamReportsUrl", ()=>$8aa539155af4c630$export$f923ac475871fcad);
    var $030R0;
    function $8aa539155af4c630$export$c0f073d636267c44(input) {
        if (window.__OG__) return '/webapi' + input;
        const cloudId = (0, (0, parcelRequire("030R0")).getMeta)('ajs-cloud-id');
        if (cloudId) return `/gateway/api/jsm/ops/reporting/cloudId/${cloudId}/api` + input;
        return input;
    }
    const $8aa539155af4c630$export$f923ac475871fcad = (pathName)=>pathName.startsWith('/jira/ops/teams/');
});
parcelRegister("QF2yk", function(module, exports) {
    $parcel$export(module.exports, "getDashboards", ()=>$de64900aae3821f4$export$8e4b6d6c4fec08f3);
    $parcel$export(module.exports, "getReportSettings", ()=>$de64900aae3821f4$export$9114b8a872caf5d8);
    $parcel$export(module.exports, "getSsoEmbedUrlEndpoint", ()=>$de64900aae3821f4$export$8384a95746267bd8);
    $parcel$export(module.exports, "getReportRights", ()=>$de64900aae3821f4$export$f4a61c3c8c619f12);
    $parcel$export(module.exports, "getAVPEmbedTokens", ()=>$de64900aae3821f4$export$fb46892f83504a42);
    var $j74qU;
    var $5oSMF;
    var $7IcT2;
    const $de64900aae3821f4$export$8e4b6d6c4fec08f3 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("5oSMF")).withReportingPrefix)('/v5/reports/dashboards'), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("7IcT2")).opsReportsErrorTransformer
        });
    const $de64900aae3821f4$export$e69121e90ce0231b = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("5oSMF")).withReportingPrefix)('/v3/reports/dashboards'), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("7IcT2")).opsReportsErrorTransformer
        });
    const $de64900aae3821f4$export$9114b8a872caf5d8 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("5oSMF")).withReportingPrefix)('/v3/reports/index'), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("7IcT2")).opsReportsErrorTransformer
        });
    const $de64900aae3821f4$export$8384a95746267bd8 = (isDarkMode, dashboardId, teamId)=>{
        const queryParam = teamId ? {
            theme: isDarkMode ? 'DarkMode' : '',
            dashboardId: dashboardId,
            teamId: teamId,
            _: Date.now().toString()
        } : {
            theme: isDarkMode ? 'DarkMode' : '',
            dashboardId: dashboardId,
            _: Date.now().toString()
        };
        const url = `/v3/reports/dashboard?${new URLSearchParams(queryParam).toString()}`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("5oSMF")).withReportingPrefix)(url), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("7IcT2")).opsReportsErrorTransformer
        });
    };
    const $de64900aae3821f4$export$f4a61c3c8c619f12 = (teamId)=>{
        let url = '/v3/reports/rights';
        if (teamId) url += `?teamId=${teamId}`;
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("5oSMF")).withReportingPrefix)(url), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("7IcT2")).opsReportsErrorTransformer
        });
    };
    const $de64900aae3821f4$export$fb46892f83504a42 = (dashboardId, teamId)=>{
        let url = '/v3/reports/embed-token';
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("5oSMF")).withReportingPrefix)(url), {
            exactUrl: true,
            method: 'POST',
            body: {
                dashboardId: dashboardId,
                teamId: teamId
            },
            errorTransformer: (0, parcelRequire("7IcT2")).opsReportsErrorTransformer
        });
    };
});
parcelRegister("7IcT2", function(module, exports) {
    $parcel$export(module.exports, "opsReportsErrorTransformer", ()=>$726849c36404771c$export$b170750bd4489531);
    var $aI12f;
    const $726849c36404771c$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8)|("ISO-8859-1")|(ISO-8859-1))))/i;
    const $726849c36404771c$export$b170750bd4489531 = (e)=>{
        if ((0, (0, parcelRequire("aI12f")).isHTTPError)(e)) {
            const contentType = e.response.headers.get('Content-Type');
            if (contentType && $726849c36404771c$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(e, data, data.message));
            return e.response.text().then((message)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(e, message, message));
        }
        return e;
    };
});
parcelRegister("5m16R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("1I1Wy")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4Hqzh")
    ]).then(()=>parcelRequire('eHCOd'));
});
parcelRegister("hZVks", function(module, exports) {
    $parcel$export(module.exports, "roleBasedNotificationsResource", ()=>$a9efe5455286a2a7$export$9a716bf20d804ec3);
    $parcel$export(module.exports, "notificationDetailResource", ()=>$a9efe5455286a2a7$export$8ad8a0a20fd0ed5a);
    $parcel$export(module.exports, "resources", ()=>$a9efe5455286a2a7$export$bc99aaabaf7b70a7);
    var $2M1hQ;
    var $hmVmJ;
    var $dH6Pi;
    var $5V1Ip;
    const $a9efe5455286a2a7$export$9a716bf20d804ec3 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'roleBasedNotificationsResource',
        getKey: ()=>'roleBasedNotificationsResource',
        getData: (0, (0, parcelRequire("5V1Ip")).getRoleBasedNotificationsEndpoint),
        isBrowserOnly: true,
        maxAge: 300000
    });
    const $a9efe5455286a2a7$export$8ad8a0a20fd0ed5a = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'notificationDetailResource',
        getKey: ({ match: match })=>{
            const settingId = match.params['id'];
            return `notificationDetailResource-id=${settingId}`;
        },
        getData: ({ match: match })=>{
            const settingId = match.params['id'];
            (0, (0, parcelRequire("hmVmJ")).assert)(!!settingId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('notificationDetailResource', 'settingId is required'));
            return (0, (0, parcelRequire("5V1Ip")).getRoleBasedNotificationDetailEndpoint)(settingId);
        },
        isBrowserOnly: true
    });
    const $a9efe5455286a2a7$export$bc99aaabaf7b70a7 = [
        $a9efe5455286a2a7$export$9a716bf20d804ec3,
        $a9efe5455286a2a7$export$8ad8a0a20fd0ed5a
    ];
});
parcelRegister("5V1Ip", function(module, exports) {
    $parcel$export(module.exports, "getRoleBasedNotificationsEndpoint", ()=>$c1906554d85d7a30$export$db67dfe9fe98cd49);
    $parcel$export(module.exports, "getRoleBasedNotificationDetailEndpoint", ()=>$c1906554d85d7a30$export$5522446e6d3ee73);
    var $j74qU;
    const $c1906554d85d7a30$export$db67dfe9fe98cd49 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/role-based-notifications`);
    const $c1906554d85d7a30$export$5522446e6d3ee73 = (settingId)=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/role-based-notifications/${settingId}`);
});
parcelRegister("g8w4o", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3aNwp")
    ]).then(()=>parcelRequire('2ddPE'));
});
parcelRegister("e62bV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("9nnOd")
    ]).then(()=>parcelRequire('94AYi'));
});
parcelRegister("5RvQj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cVwzB").then(()=>parcelRequire('ecO2s'));
});
parcelRegister("ieJ0b", function(module, exports) {
    $parcel$export(module.exports, "transitioningDetailsResource", ()=>$86a5b96e0cefda11$export$850d76e0c9ffbdeb);
    var $jcw0u;
    var $eusud;
    var $2M1hQ;
    const $86a5b96e0cefda11$export$7985153d37586c9a = (cloudId)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/transitioning-details`).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getTransitioningDetails',
                    packageName: 'jiraRouterResourcesEocUnlockOperations',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    const $86a5b96e0cefda11$export$850d76e0c9ffbdeb = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'EOC_UNLOCK_OPERATIONS',
        getKey: ()=>'eoc-unlock-operations',
        getData: async (_, { tenantContext: { cloudId: cloudId } })=>$86a5b96e0cefda11$export$7985153d37586c9a(cloudId),
        maxAge: 0,
        isBrowserOnly: true
    });
});
parcelRegister("gxsQH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("laeSv")
    ]).then(()=>parcelRequire('1lA3p'));
});
parcelRegister("vla3y", function(module, exports) {
    $parcel$export(module.exports, "resources", ()=>$21f951fdce1763c0$export$bc99aaabaf7b70a7);
    $parcel$export(module.exports, "widgetResources", ()=>$21f951fdce1763c0$export$bce3244764eac6e6);
    $parcel$export(module.exports, "createMyTeamsResource", ()=>(parcelRequire("kCVY8")).createMyTeamsResource);
    $parcel$export(module.exports, "createStatusResource", ()=>(parcelRequire("5IZS8")).createStatusResource);
    $parcel$export(module.exports, "createUserTimelineResource", ()=>(parcelRequire("izTEw")).createUserTimelineResource);
    $parcel$export(module.exports, "createSchedulesResource", ()=>(parcelRequire("dlTDC")).createSchedulesResource);
    parcelRequire("jxRF2");
    var $ldKOT;
    var $kCVY8;
    var $jfpRV;
    var $dlTDC;
    var $5IZS8;
    var $izTEw;
    const $21f951fdce1763c0$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("ldKOT")).eocUserResource),
        (0, (0, parcelRequire("kCVY8")).createMyTeamsResource)(),
        (0, (0, parcelRequire("5IZS8")).createStatusResource)(),
        (0, (0, parcelRequire("jfpRV")).createOpsTeamsResource)()
    ];
    const $21f951fdce1763c0$export$bce3244764eac6e6 = [
        ()=>(0, (0, parcelRequire("ldKOT")).eocUserResource),
        (callback, depends)=>(0, (0, parcelRequire("kCVY8")).createMyTeamsResource)(callback, depends),
        (callback, depends)=>(0, (0, parcelRequire("5IZS8")).createStatusResource)(callback, depends),
        (callback, depends)=>(0, (0, parcelRequire("izTEw")).createUserTimelineResource)(callback, depends),
        (callback, depends)=>(0, (0, parcelRequire("dlTDC")).createSchedulesResource)(callback, depends)
    ];
});
parcelRegister("kCVY8", function(module, exports) {
    $parcel$export(module.exports, "createMyTeamsResource", ()=>$cad624fc2ff7cfd6$export$bf86fb90d0661bcb);
    var $2M1hQ;
    var $6OdRW;
    const $cad624fc2ff7cfd6$export$bf86fb90d0661bcb = (checkConsolidationOnRouteDependency, depends)=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: 'myTeamsResource',
            getKey: ()=>'myTeamsResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("6OdRW")).getMyTeamsEndpoint)();
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("6OdRW", function(module, exports) {
    $parcel$export(module.exports, "getMyTeamsEndpoint", ()=>$8d7771bc195a7eba$export$abe46da7d1f191a7);
    var $j74qU;
    const $8d7771bc195a7eba$export$abe46da7d1f191a7 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/responders/suggested`);
    };
});
parcelRegister("jfpRV", function(module, exports) {
    $parcel$export(module.exports, "createOpsTeamsResource", ()=>$8fdf339b714e66ed$export$99505a9d792f516c);
    var $2M1hQ;
    var $6LUYW;
    const $8fdf339b714e66ed$export$99505a9d792f516c = (checkConsolidationOnRouteDependency, depends)=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: 'opsTeamsResource',
            getKey: ()=>'opsTeamsResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("6LUYW")).getOpsTeamsEndpoint)().then((response)=>{
                    return response.values;
                });
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("6LUYW", function(module, exports) {
    $parcel$export(module.exports, "getOpsTeamsEndpoint", ()=>$da0ecde7fda1bab3$export$7498ba30158c16cd);
    var $j74qU;
    var $68pYM;
    const $da0ecde7fda1bab3$export$7498ba30158c16cd = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("68pYM")).urls).teams.url());
    };
});
parcelRegister("68pYM", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$d4c8bf52c3691263$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "SPOTLIGHT_NAMES", ()=>$d4c8bf52c3691263$export$a7c923252528b255);
    $parcel$export(module.exports, "SPOTLIGHT_TOURS", ()=>$d4c8bf52c3691263$export$38c46ed7a5bc80a0);
    $parcel$export(module.exports, "WhoIsOnCallHandler", ()=>$d4c8bf52c3691263$export$1e7191618d5d4548);
    $parcel$export(module.exports, "WhoIsOnCallWidgetHandler", ()=>$d4c8bf52c3691263$export$d05bbb1ada0e07c4);
    const $d4c8bf52c3691263$export$bcae9ba627f604b6 = Object.freeze({
        schedules: {
            url: ()=>`/v1/schedules`,
            user: {
                url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/user`,
                timeline: {
                    url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.user.url()}/timeline`,
                    export: {
                        url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.user.timeline.url()}/export`
                    }
                },
                userId: {
                    url: ({ userId: userId } = {
                        userId: ':userId'
                    })=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.user.url()}/${userId}`
                }
            },
            onCalls: {
                url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/on-calls`
            },
            scheduleId: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/${scheduleId}`,
                timeline: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.scheduleId.url({
                            scheduleId: scheduleId
                        })}/timeline`
                }
            }
        },
        wioc: {
            status: {
                url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/user/on-calls`
            }
        },
        teams: {
            url: ()=>`/v1/teams`
        }
    });
    const $d4c8bf52c3691263$export$a7c923252528b255 = {
        firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period'
    };
    const $d4c8bf52c3691263$export$38c46ed7a5bc80a0 = {
        overlappingPeriod: 'eoc-who-is-on-call-overlapping-period'
    };
    class $d4c8bf52c3691263$export$1e7191618d5d4548 {
        handler(message, context) {
            throw new Error('Not implemented');
        }
    }
    class $d4c8bf52c3691263$export$d05bbb1ada0e07c4 {
        handler(message, context) {
            throw new Error('Not implemented');
        }
    }
});
parcelRegister("dlTDC", function(module, exports) {
    $parcel$export(module.exports, "createSchedulesResource", ()=>$10cde28570610d7a$export$b5e65ca3f82b01c5);
    var $2M1hQ;
    var $ajrLe;
    const $10cde28570610d7a$export$b5e65ca3f82b01c5 = (checkConsolidationOnRouteDependency, depends)=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: 'schedulesResource',
            getKey: ()=>'schedulesResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("ajrLe")).getSchedulesEndpoint)();
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("ajrLe", function(module, exports) {
    $parcel$export(module.exports, "getSchedulesEndpoint", ()=>$1a931852d60ab07d$export$e8e940098db1b988);
    var $j74qU;
    var $68pYM;
    const $1a931852d60ab07d$export$e8e940098db1b988 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`${(0, (0, parcelRequire("68pYM")).urls).schedules.onCalls.url()}`);
    };
});
parcelRegister("5IZS8", function(module, exports) {
    $parcel$export(module.exports, "createStatusResource", ()=>$c6e09a482698443b$export$3d1c353e2693418c);
    var $2M1hQ;
    var $iyzC0;
    var $41Gqg;
    const $c6e09a482698443b$export$3d1c353e2693418c = (checkConsolidationOnRouteDependency, depends)=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: 'statusResource',
            getKey: ()=>'statusResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("iyzC0")).getStatus)().then((0, (0, parcelRequire("41Gqg")).transformStatusResponse));
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("iyzC0", function(module, exports) {
    $parcel$export(module.exports, "getStatus", ()=>$d83203ae0be7e9b4$export$b70265791d2079d4);
    var $j74qU;
    var $68pYM;
    const $d83203ae0be7e9b4$export$b70265791d2079d4 = ()=>{
        return (0, (0, parcelRequire("j74qU")).eocFetch)((0, (0, parcelRequire("68pYM")).urls).wioc.status.url(), {
            method: 'GET'
        });
    };
});
parcelRegister("41Gqg", function(module, exports) {
    $parcel$export(module.exports, "transformStatusResponse", ()=>$8a21b756a892d7eb$export$44a749c89534e42c);
    const $8a21b756a892d7eb$export$44a749c89534e42c = ({ currentTimeUtcMillis: currentTimeUtcMillis, onCallUntilUtcMillis: onCallUntilUtcMillis, onCallUntilOffsetMillis: onCallUntilOffsetMillis, isCurrentOnCall: isCurrentOnCall, isParticipantOfAnyRotation: isParticipantOfAnyRotation, nextOnCallEndUtcMillis: nextOnCallEndUtcMillis, nextOnCallEndOffsetMillis: nextOnCallEndOffsetMillis, nextOnCallStartUtcMillis: nextOnCallStartUtcMillis, nextOnCallStartOffsetMillis: nextOnCallStartOffsetMillis })=>{
        return {
            currentDate: currentTimeUtcMillis,
            currentShiftEnd: onCallUntilUtcMillis,
            currentShiftEndOffset: onCallUntilOffsetMillis,
            isOnCall: isCurrentOnCall,
            isParticipantOfAnyRotation: isParticipantOfAnyRotation,
            nextEndDate: nextOnCallEndUtcMillis,
            nextEndOffset: nextOnCallEndOffsetMillis,
            nextStartDate: nextOnCallStartUtcMillis,
            nextStartOffset: nextOnCallStartOffsetMillis
        };
    };
});
parcelRegister("izTEw", function(module, exports) {
    $parcel$export(module.exports, "createUserTimelineResource", ()=>$3f4c51b6b015af14$export$a479dcc35c33def1);
    var $2M1hQ;
    parcelRequire("jxRF2");
    var $ldKOT;
    var $5rGi1;
    const $3f4c51b6b015af14$export$a479dcc35c33def1 = (checkConsolidationOnRouteDependency, depends)=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: 'userTimelineResource',
            getKey: ()=>'userTimelineResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                const data = await dependencies[(0, (0, parcelRequire("ldKOT")).eocUserResource).type]?.promise;
                const accountId = data?.accountId;
                const timezone = data?.timeZone;
                if (!accountId || !timezone) return null;
                return (0, (0, parcelRequire("5rGi1")).getWidgetTimeline)(accountId);
            },
            isBrowserOnly: true,
            depends: [
                ...depends ? depends : [],
                (0, (0, parcelRequire("ldKOT")).eocUserResource).type
            ]
        });
});
parcelRegister("5rGi1", function(module, exports) {
    $parcel$export(module.exports, "getWidgetTimeline", ()=>$2c4955dde7aaf4da$export$bd80cae08a85b1f0);
    var $eYLkf;
    var $j74qU;
    var $68pYM;
    var $8PqA1;
    const $2c4955dde7aaf4da$export$bd80cae08a85b1f0 = (accountId)=>{
        const formattedCurrent = (0, (0, parcelRequire("eYLkf")).default)(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSSXX");
        const urlParams = new URLSearchParams({
            currentDate: formattedCurrent,
            accountId: accountId,
            mode: 'timeline',
            timelineType: '6'
        });
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`${(0, (0, parcelRequire("68pYM")).urls).schedules.user.timeline.url()}?${urlParams.toString()}`, {
            method: 'GET'
        }).then((0, (0, parcelRequire("8PqA1")).transformUserTimelineResponse));
    };
});
parcelRegister("eYLkf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ae7b6125506491b3$export$2e2bcd8739ae039);
    var $fwbX5;
    var $iwG2X;
    var $jAT0D;
    function $ae7b6125506491b3$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
        var extendedOptions = (0, ($parcel$interopDefault((0, parcelRequire("fwbX5")))))(options);
        extendedOptions.timeZone = timeZone;
        extendedOptions.originalDate = date;
        return (0, (0, parcelRequire("iwG2X")).default)((0, (0, parcelRequire("jAT0D")).default)(date, timeZone), formatStr, extendedOptions);
    }
});
parcelRegister("fwbX5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $b4c31d9870379ac2$var$cloneObject;
    var $b4c31d9870379ac2$var$_index = $b4c31d9870379ac2$var$_interopRequireDefault((parcelRequire("cpl5v")));
    function $b4c31d9870379ac2$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $b4c31d9870379ac2$var$cloneObject(dirtyObject) {
        return (0, $b4c31d9870379ac2$var$_index.default)({}, dirtyObject);
    }
    module.exports = module.exports.default;
});
parcelRegister("cpl5v", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $90882d6ff669df4d$var$assign;
    function $90882d6ff669df4d$var$assign(target, dirtyObject) {
        if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
        dirtyObject = dirtyObject || {};
        for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
        return target;
    }
    module.exports = module.exports.default;
});
parcelRegister("iwG2X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d7cbd4ba80af9369$export$2e2bcd8739ae039);
    var $aR9Qf;
    var $dBimx;
    var $gUUmE;
    var $d7cbd4ba80af9369$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
    function $d7cbd4ba80af9369$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var matches = formatStr.match($d7cbd4ba80af9369$var$tzFormattingTokensRegExp);
        if (matches) {
            var date = (0, (0, parcelRequire("gUUmE")).default)(options.originalDate || dirtyDate, options);
            formatStr = matches.reduce(function(result, token) {
                if (token[0] === "'") return result;
                var pos = result.indexOf(token);
                var precededByQuotedSection = result[pos - 1] === "'";
                var replaced = result.replace(token, "'" + (0, (0, parcelRequire("dBimx")).default)[token[0]](date, token, null, options) + "'");
                return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
            }, formatStr);
        }
        return (0, ($parcel$interopDefault((0, parcelRequire("aR9Qf")))))(dirtyDate, formatStr, options);
    }
});
parcelRegister("aR9Qf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $7e767cfeba790ebe$var$format;
    var $7e767cfeba790ebe$var$_index = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("ck8JK")));
    var $7e767cfeba790ebe$var$_index2 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("kvNR5")));
    var $7e767cfeba790ebe$var$_index3 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("bQkcE")));
    var $7e767cfeba790ebe$var$_index4 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $7e767cfeba790ebe$var$_index5 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("3ckvK")));
    var $7e767cfeba790ebe$var$_index6 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("awKAW")));
    var $7e767cfeba790ebe$var$_index7 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("jGQTC")));
    var $5qguX;
    var $7e767cfeba790ebe$var$_index9 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $7e767cfeba790ebe$var$_index10 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $7e767cfeba790ebe$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $7e767cfeba790ebe$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
    var $7e767cfeba790ebe$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    var $7e767cfeba790ebe$var$escapedStringRegExp = /^'([^]*?)'?$/;
    var $7e767cfeba790ebe$var$doubleQuoteRegExp = /''/g;
    var $7e767cfeba790ebe$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
    function $7e767cfeba790ebe$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
        (0, $7e767cfeba790ebe$var$_index10.default)(2, arguments);
        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var locale = options.locale || $7e767cfeba790ebe$var$_index2.default;
        var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $7e767cfeba790ebe$var$_index9.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $7e767cfeba790ebe$var$_index9.default)(options.firstWeekContainsDate);
        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $7e767cfeba790ebe$var$_index9.default)(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $7e767cfeba790ebe$var$_index9.default)(options.weekStartsOn);
        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        if (!locale.localize) throw new RangeError('locale must contain localize property');
        if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
        var originalDate = (0, $7e767cfeba790ebe$var$_index4.default)(dirtyDate);
        if (!(0, $7e767cfeba790ebe$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
        var timezoneOffset = (0, $7e767cfeba790ebe$var$_index7.default)(originalDate);
        var utcDate = (0, $7e767cfeba790ebe$var$_index3.default)(originalDate, timezoneOffset);
        var formatterOptions = {
            firstWeekContainsDate: firstWeekContainsDate,
            weekStartsOn: weekStartsOn,
            locale: locale,
            _originalDate: originalDate
        };
        var result = formatStr.match($7e767cfeba790ebe$var$longFormattingTokensRegExp).map(function(substring) {
            var firstCharacter = substring[0];
            if (firstCharacter === 'p' || firstCharacter === 'P') {
                var longFormatter = $7e767cfeba790ebe$var$_index6.default[firstCharacter];
                return longFormatter(substring, locale.formatLong, formatterOptions);
            }
            return substring;
        }).join('').match($7e767cfeba790ebe$var$formattingTokensRegExp).map(function(substring) {
            if (substring === "''") return "'";
            var firstCharacter = substring[0];
            if (firstCharacter === "'") return $7e767cfeba790ebe$var$cleanEscapedString(substring);
            var formatter = $7e767cfeba790ebe$var$_index5.default[firstCharacter];
            if (formatter) {
                if (!options.useAdditionalWeekYearTokens && (0, (0, parcelRequire("5qguX")).isProtectedWeekYearToken)(substring)) (0, (0, parcelRequire("5qguX")).throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
                if (!options.useAdditionalDayOfYearTokens && (0, (0, parcelRequire("5qguX")).isProtectedDayOfYearToken)(substring)) (0, (0, parcelRequire("5qguX")).throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
                return formatter(utcDate, substring, locale.localize, formatterOptions);
            }
            if (firstCharacter.match($7e767cfeba790ebe$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
            return substring;
        }).join('');
        return result;
    }
    function $7e767cfeba790ebe$var$cleanEscapedString(input) {
        return input.match($7e767cfeba790ebe$var$escapedStringRegExp)[1].replace($7e767cfeba790ebe$var$doubleQuoteRegExp, "'");
    }
    module.exports = module.exports.default;
});
parcelRegister("ck8JK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8f8e2146dfa1d727$var$isValid;
    var $8f8e2146dfa1d727$var$_index = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $8f8e2146dfa1d727$var$_index2 = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8f8e2146dfa1d727$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8f8e2146dfa1d727$var$isValid(dirtyDate) {
        (0, $8f8e2146dfa1d727$var$_index2.default)(1, arguments);
        var date = (0, $8f8e2146dfa1d727$var$_index.default)(dirtyDate);
        return !isNaN(date);
    }
    module.exports = module.exports.default;
});
parcelRegister("2pWQP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $1c2b912e6615b0b5$var$toDate;
    var $1c2b912e6615b0b5$var$_index = $1c2b912e6615b0b5$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $1c2b912e6615b0b5$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $1c2b912e6615b0b5$var$toDate(argument) {
        (0, $1c2b912e6615b0b5$var$_index.default)(1, arguments);
        var argStr = Object.prototype.toString.call(argument);
        if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') return new Date(argument.getTime());
        else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
        else {
            if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
                console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
                console.warn(new Error().stack);
            }
            return new Date(NaN);
        }
    }
    module.exports = module.exports.default;
});
parcelRegister("6eBfj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $48a0f126c2293ab3$var$requiredArgs;
    function $48a0f126c2293ab3$var$requiredArgs(required, args) {
        if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
    }
    module.exports = module.exports.default;
});
parcelRegister("kvNR5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eeed6020e120f946$var$_index = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("5u9TK")));
    var $eeed6020e120f946$var$_index2 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("e7AgV")));
    var $eeed6020e120f946$var$_index3 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("8U2eY")));
    var $eeed6020e120f946$var$_index4 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("b9d75")));
    var $eeed6020e120f946$var$_index5 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("hHwuU")));
    function $eeed6020e120f946$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $eeed6020e120f946$var$locale = {
        code: 'en-US',
        formatDistance: $eeed6020e120f946$var$_index.default,
        formatLong: $eeed6020e120f946$var$_index2.default,
        formatRelative: $eeed6020e120f946$var$_index3.default,
        localize: $eeed6020e120f946$var$_index4.default,
        match: $eeed6020e120f946$var$_index5.default,
        options: {
            weekStartsOn: 0,
            firstWeekContainsDate: 1
        }
    };
    var $eeed6020e120f946$var$_default = $eeed6020e120f946$var$locale;
    module.exports.default = $eeed6020e120f946$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("5u9TK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $3fe76ea3cd34e32f$var$formatDistance;
    var $3fe76ea3cd34e32f$var$formatDistanceLocale = {
        lessThanXSeconds: {
            one: 'less than a second',
            other: 'less than {{count}} seconds'
        },
        xSeconds: {
            one: '1 second',
            other: '{{count}} seconds'
        },
        halfAMinute: 'half a minute',
        lessThanXMinutes: {
            one: 'less than a minute',
            other: 'less than {{count}} minutes'
        },
        xMinutes: {
            one: '1 minute',
            other: '{{count}} minutes'
        },
        aboutXHours: {
            one: 'about 1 hour',
            other: 'about {{count}} hours'
        },
        xHours: {
            one: '1 hour',
            other: '{{count}} hours'
        },
        xDays: {
            one: '1 day',
            other: '{{count}} days'
        },
        aboutXWeeks: {
            one: 'about 1 week',
            other: 'about {{count}} weeks'
        },
        xWeeks: {
            one: '1 week',
            other: '{{count}} weeks'
        },
        aboutXMonths: {
            one: 'about 1 month',
            other: 'about {{count}} months'
        },
        xMonths: {
            one: '1 month',
            other: '{{count}} months'
        },
        aboutXYears: {
            one: 'about 1 year',
            other: 'about {{count}} years'
        },
        xYears: {
            one: '1 year',
            other: '{{count}} years'
        },
        overXYears: {
            one: 'over 1 year',
            other: 'over {{count}} years'
        },
        almostXYears: {
            one: 'almost 1 year',
            other: 'almost {{count}} years'
        }
    };
    function $3fe76ea3cd34e32f$var$formatDistance(token, count, options) {
        options = options || {};
        var result;
        if (typeof $3fe76ea3cd34e32f$var$formatDistanceLocale[token] === 'string') result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token];
        else if (count === 1) result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].one;
        else result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].other.replace('{{count}}', count);
        if (options.addSuffix) {
            if (options.comparison > 0) return 'in ' + result;
            else return result + ' ago';
        }
        return result;
    }
    module.exports = module.exports.default;
});
parcelRegister("e7AgV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a47ddb0366100c31$var$_index = $a47ddb0366100c31$var$_interopRequireDefault((parcelRequire("4raqC")));
    function $a47ddb0366100c31$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $a47ddb0366100c31$var$dateFormats = {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy'
    };
    var $a47ddb0366100c31$var$timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
    };
    var $a47ddb0366100c31$var$dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
    };
    var $a47ddb0366100c31$var$formatLong = {
        date: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$dateFormats,
            defaultWidth: 'full'
        }),
        time: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$timeFormats,
            defaultWidth: 'full'
        }),
        dateTime: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$dateTimeFormats,
            defaultWidth: 'full'
        })
    };
    var $a47ddb0366100c31$var$_default = $a47ddb0366100c31$var$formatLong;
    module.exports.default = $a47ddb0366100c31$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("4raqC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $33b1c5e9f7814c0e$var$buildFormatLongFn;
    function $33b1c5e9f7814c0e$var$buildFormatLongFn(args) {
        return function() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var width = options.width ? String(options.width) : args.defaultWidth;
            var format = args.formats[width] || args.formats[args.defaultWidth];
            return format;
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("8U2eY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $67b54aa1e07b4b42$var$formatRelative;
    var $67b54aa1e07b4b42$var$formatRelativeLocale = {
        lastWeek: "'last' eeee 'at' p",
        yesterday: "'yesterday at' p",
        today: "'today at' p",
        tomorrow: "'tomorrow at' p",
        nextWeek: "eeee 'at' p",
        other: 'P'
    };
    function $67b54aa1e07b4b42$var$formatRelative(token, _date, _baseDate, _options) {
        return $67b54aa1e07b4b42$var$formatRelativeLocale[token];
    }
    module.exports = module.exports.default;
});
parcelRegister("b9d75", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $81dab50370972ecd$var$_index = $81dab50370972ecd$var$_interopRequireDefault((parcelRequire("llBmH")));
    function $81dab50370972ecd$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $81dab50370972ecd$var$eraValues = {
        narrow: [
            'B',
            'A'
        ],
        abbreviated: [
            'BC',
            'AD'
        ],
        wide: [
            'Before Christ',
            'Anno Domini'
        ]
    };
    var $81dab50370972ecd$var$quarterValues = {
        narrow: [
            '1',
            '2',
            '3',
            '4'
        ],
        abbreviated: [
            'Q1',
            'Q2',
            'Q3',
            'Q4'
        ],
        wide: [
            '1st quarter',
            '2nd quarter',
            '3rd quarter',
            '4th quarter'
        ]
    };
    var $81dab50370972ecd$var$monthValues = {
        narrow: [
            'J',
            'F',
            'M',
            'A',
            'M',
            'J',
            'J',
            'A',
            'S',
            'O',
            'N',
            'D'
        ],
        abbreviated: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        wide: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]
    };
    var $81dab50370972ecd$var$dayValues = {
        narrow: [
            'S',
            'M',
            'T',
            'W',
            'T',
            'F',
            'S'
        ],
        short: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        abbreviated: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ],
        wide: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ]
    };
    var $81dab50370972ecd$var$dayPeriodValues = {
        narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        },
        abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        },
        wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        }
    };
    var $81dab50370972ecd$var$formattingDayPeriodValues = {
        narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        },
        abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        },
        wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        }
    };
    function $81dab50370972ecd$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        var rem100 = number % 100;
        if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
            case 1:
                return number + 'st';
            case 2:
                return number + 'nd';
            case 3:
                return number + 'rd';
        }
        return number + 'th';
    }
    var $81dab50370972ecd$var$localize = {
        ordinalNumber: $81dab50370972ecd$var$ordinalNumber,
        era: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$eraValues,
            defaultWidth: 'wide'
        }),
        quarter: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$quarterValues,
            defaultWidth: 'wide',
            argumentCallback: function(quarter) {
                return Number(quarter) - 1;
            }
        }),
        month: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$monthValues,
            defaultWidth: 'wide'
        }),
        day: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$dayValues,
            defaultWidth: 'wide'
        }),
        dayPeriod: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$dayPeriodValues,
            defaultWidth: 'wide',
            formattingValues: $81dab50370972ecd$var$formattingDayPeriodValues,
            defaultFormattingWidth: 'wide'
        })
    };
    var $81dab50370972ecd$var$_default = $81dab50370972ecd$var$localize;
    module.exports.default = $81dab50370972ecd$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("llBmH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $f8a88b0d5d631bc1$var$buildLocalizeFn;
    function $f8a88b0d5d631bc1$var$buildLocalizeFn(args) {
        return function(dirtyIndex, dirtyOptions) {
            var options = dirtyOptions || {};
            var context = options.context ? String(options.context) : 'standalone';
            var valuesArray;
            if (context === 'formatting' && args.formattingValues) {
                var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
                var width = options.width ? String(options.width) : defaultWidth;
                valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
            } else {
                var _defaultWidth = args.defaultWidth;
                var _width = options.width ? String(options.width) : args.defaultWidth;
                valuesArray = args.values[_width] || args.values[_defaultWidth];
            }
            var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
            return valuesArray[index];
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("hHwuU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce2fa922bf4a591b$var$_index = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("1IY7t")));
    var $ce2fa922bf4a591b$var$_index2 = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("liduU")));
    function $ce2fa922bf4a591b$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $ce2fa922bf4a591b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
    var $ce2fa922bf4a591b$var$parseOrdinalNumberPattern = /\d+/i;
    var $ce2fa922bf4a591b$var$matchEraPatterns = {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
    };
    var $ce2fa922bf4a591b$var$parseEraPatterns = {
        any: [
            /^b/i,
            /^(a|c)/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
    };
    var $ce2fa922bf4a591b$var$parseQuarterPatterns = {
        any: [
            /1/i,
            /2/i,
            /3/i,
            /4/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
    };
    var $ce2fa922bf4a591b$var$parseMonthPatterns = {
        narrow: [
            /^j/i,
            /^f/i,
            /^m/i,
            /^a/i,
            /^m/i,
            /^j/i,
            /^j/i,
            /^a/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i
        ],
        any: [
            /^ja/i,
            /^f/i,
            /^mar/i,
            /^ap/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^au/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchDayPatterns = {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
    };
    var $ce2fa922bf4a591b$var$parseDayPatterns = {
        narrow: [
            /^s/i,
            /^m/i,
            /^t/i,
            /^w/i,
            /^t/i,
            /^f/i,
            /^s/i
        ],
        any: [
            /^su/i,
            /^m/i,
            /^tu/i,
            /^w/i,
            /^th/i,
            /^f/i,
            /^sa/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    };
    var $ce2fa922bf4a591b$var$parseDayPeriodPatterns = {
        any: {
            am: /^a/i,
            pm: /^p/i,
            midnight: /^mi/i,
            noon: /^no/i,
            morning: /morning/i,
            afternoon: /afternoon/i,
            evening: /evening/i,
            night: /night/i
        }
    };
    var $ce2fa922bf4a591b$var$match = {
        ordinalNumber: (0, $ce2fa922bf4a591b$var$_index.default)({
            matchPattern: $ce2fa922bf4a591b$var$matchOrdinalNumberPattern,
            parsePattern: $ce2fa922bf4a591b$var$parseOrdinalNumberPattern,
            valueCallback: function(value) {
                return parseInt(value, 10);
            }
        }),
        era: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchEraPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseEraPatterns,
            defaultParseWidth: 'any'
        }),
        quarter: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchQuarterPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseQuarterPatterns,
            defaultParseWidth: 'any',
            valueCallback: function(index) {
                return index + 1;
            }
        }),
        month: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchMonthPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseMonthPatterns,
            defaultParseWidth: 'any'
        }),
        day: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchDayPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseDayPatterns,
            defaultParseWidth: 'any'
        }),
        dayPeriod: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchDayPeriodPatterns,
            defaultMatchWidth: 'any',
            parsePatterns: $ce2fa922bf4a591b$var$parseDayPeriodPatterns,
            defaultParseWidth: 'any'
        })
    };
    var $ce2fa922bf4a591b$var$_default = $ce2fa922bf4a591b$var$match;
    module.exports.default = $ce2fa922bf4a591b$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("1IY7t", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $141888fa04c95812$var$buildMatchPatternFn;
    function $141888fa04c95812$var$buildMatchPatternFn(args) {
        return function(string) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var matchResult = string.match(args.matchPattern);
            if (!matchResult) return null;
            var matchedString = matchResult[0];
            var parseResult = string.match(args.parsePattern);
            if (!parseResult) return null;
            var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
            value = options.valueCallback ? options.valueCallback(value) : value;
            var rest = string.slice(matchedString.length);
            return {
                value: value,
                rest: rest
            };
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("liduU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $f805bfb7f96f3bcc$var$buildMatchFn;
    function $f805bfb7f96f3bcc$var$buildMatchFn(args) {
        return function(string) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var width = options.width;
            var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
            var matchResult = string.match(matchPattern);
            if (!matchResult) return null;
            var matchedString = matchResult[0];
            var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
            var key = Array.isArray(parsePatterns) ? $f805bfb7f96f3bcc$var$findIndex(parsePatterns, function(pattern) {
                return pattern.test(matchedString);
            }) : $f805bfb7f96f3bcc$var$findKey(parsePatterns, function(pattern) {
                return pattern.test(matchedString);
            });
            var value;
            value = args.valueCallback ? args.valueCallback(key) : key;
            value = options.valueCallback ? options.valueCallback(value) : value;
            var rest = string.slice(matchedString.length);
            return {
                value: value,
                rest: rest
            };
        };
    }
    function $f805bfb7f96f3bcc$var$findKey(object, predicate) {
        for(var key in object){
            if (object.hasOwnProperty(key) && predicate(object[key])) return key;
        }
        return undefined;
    }
    function $f805bfb7f96f3bcc$var$findIndex(array, predicate) {
        for(var key = 0; key < array.length; key++){
            if (predicate(array[key])) return key;
        }
        return undefined;
    }
    module.exports = module.exports.default;
});
parcelRegister("bQkcE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $89f438ee982b4fb2$var$subMilliseconds;
    var $89f438ee982b4fb2$var$_index = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $89f438ee982b4fb2$var$_index2 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("7f9OM")));
    var $89f438ee982b4fb2$var$_index3 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $89f438ee982b4fb2$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $89f438ee982b4fb2$var$subMilliseconds(dirtyDate, dirtyAmount) {
        (0, $89f438ee982b4fb2$var$_index3.default)(2, arguments);
        var amount = (0, $89f438ee982b4fb2$var$_index.default)(dirtyAmount);
        return (0, $89f438ee982b4fb2$var$_index2.default)(dirtyDate, -amount);
    }
    module.exports = module.exports.default;
});
parcelRegister("aSksP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $7eaed23c7cdcf6c0$var$toInteger;
    function $7eaed23c7cdcf6c0$var$toInteger(dirtyNumber) {
        if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
        var number = Number(dirtyNumber);
        if (isNaN(number)) return number;
        return number < 0 ? Math.ceil(number) : Math.floor(number);
    }
    module.exports = module.exports.default;
});
parcelRegister("7f9OM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $54618cc00c3fb8fc$var$addMilliseconds;
    var $54618cc00c3fb8fc$var$_index = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $54618cc00c3fb8fc$var$_index2 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $54618cc00c3fb8fc$var$_index3 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $54618cc00c3fb8fc$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $54618cc00c3fb8fc$var$addMilliseconds(dirtyDate, dirtyAmount) {
        (0, $54618cc00c3fb8fc$var$_index3.default)(2, arguments);
        var timestamp = (0, $54618cc00c3fb8fc$var$_index2.default)(dirtyDate).getTime();
        var amount = (0, $54618cc00c3fb8fc$var$_index.default)(dirtyAmount);
        return new Date(timestamp + amount);
    }
    module.exports = module.exports.default;
});
parcelRegister("3ckvK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2542672a600cd2b8$var$_index = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("kFGp1")));
    var $2542672a600cd2b8$var$_index2 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3xdEO")));
    var $2542672a600cd2b8$var$_index3 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("6Falt")));
    var $2542672a600cd2b8$var$_index4 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("gUvh1")));
    var $2542672a600cd2b8$var$_index5 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("46m4m")));
    var $2542672a600cd2b8$var$_index6 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3ihh3")));
    var $2542672a600cd2b8$var$_index7 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("bQ2eo")));
    function $2542672a600cd2b8$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $2542672a600cd2b8$var$dayPeriodEnum = {
        am: 'am',
        pm: 'pm',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    };
    var $2542672a600cd2b8$var$formatters = {
        G: function(date, token, localize) {
            var era = date.getUTCFullYear() > 0 ? 1 : 0;
            switch(token){
                case 'G':
                case 'GG':
                case 'GGG':
                    return localize.era(era, {
                        width: 'abbreviated'
                    });
                case 'GGGGG':
                    return localize.era(era, {
                        width: 'narrow'
                    });
                case 'GGGG':
                default:
                    return localize.era(era, {
                        width: 'wide'
                    });
            }
        },
        y: function(date, token, localize) {
            if (token === 'yo') {
                var signedYear = date.getUTCFullYear();
                var year = signedYear > 0 ? signedYear : 1 - signedYear;
                return localize.ordinalNumber(year, {
                    unit: 'year'
                });
            }
            return $2542672a600cd2b8$var$_index.default.y(date, token);
        },
        Y: function(date, token, localize, options) {
            var signedWeekYear = (0, $2542672a600cd2b8$var$_index6.default)(date, options);
            var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
            if (token === 'YY') {
                var twoDigitYear = weekYear % 100;
                return (0, $2542672a600cd2b8$var$_index7.default)(twoDigitYear, 2);
            }
            if (token === 'Yo') return localize.ordinalNumber(weekYear, {
                unit: 'year'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(weekYear, token.length);
        },
        R: function(date, token) {
            var isoWeekYear = (0, $2542672a600cd2b8$var$_index4.default)(date);
            return (0, $2542672a600cd2b8$var$_index7.default)(isoWeekYear, token.length);
        },
        u: function(date, token) {
            var year = date.getUTCFullYear();
            return (0, $2542672a600cd2b8$var$_index7.default)(year, token.length);
        },
        Q: function(date, token, localize) {
            var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
            switch(token){
                case 'Q':
                    return String(quarter);
                case 'QQ':
                    return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
                case 'Qo':
                    return localize.ordinalNumber(quarter, {
                        unit: 'quarter'
                    });
                case 'QQQ':
                    return localize.quarter(quarter, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'QQQQQ':
                    return localize.quarter(quarter, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'QQQQ':
                default:
                    return localize.quarter(quarter, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        q: function(date, token, localize) {
            var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
            switch(token){
                case 'q':
                    return String(quarter);
                case 'qq':
                    return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
                case 'qo':
                    return localize.ordinalNumber(quarter, {
                        unit: 'quarter'
                    });
                case 'qqq':
                    return localize.quarter(quarter, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'qqqqq':
                    return localize.quarter(quarter, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'qqqq':
                default:
                    return localize.quarter(quarter, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        M: function(date, token, localize) {
            var month = date.getUTCMonth();
            switch(token){
                case 'M':
                case 'MM':
                    return $2542672a600cd2b8$var$_index.default.M(date, token);
                case 'Mo':
                    return localize.ordinalNumber(month + 1, {
                        unit: 'month'
                    });
                case 'MMM':
                    return localize.month(month, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'MMMMM':
                    return localize.month(month, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'MMMM':
                default:
                    return localize.month(month, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        L: function(date, token, localize) {
            var month = date.getUTCMonth();
            switch(token){
                case 'L':
                    return String(month + 1);
                case 'LL':
                    return (0, $2542672a600cd2b8$var$_index7.default)(month + 1, 2);
                case 'Lo':
                    return localize.ordinalNumber(month + 1, {
                        unit: 'month'
                    });
                case 'LLL':
                    return localize.month(month, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'LLLLL':
                    return localize.month(month, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'LLLL':
                default:
                    return localize.month(month, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        w: function(date, token, localize, options) {
            var week = (0, $2542672a600cd2b8$var$_index5.default)(date, options);
            if (token === 'wo') return localize.ordinalNumber(week, {
                unit: 'week'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(week, token.length);
        },
        I: function(date, token, localize) {
            var isoWeek = (0, $2542672a600cd2b8$var$_index3.default)(date);
            if (token === 'Io') return localize.ordinalNumber(isoWeek, {
                unit: 'week'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(isoWeek, token.length);
        },
        d: function(date, token, localize) {
            if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
                unit: 'date'
            });
            return $2542672a600cd2b8$var$_index.default.d(date, token);
        },
        D: function(date, token, localize) {
            var dayOfYear = (0, $2542672a600cd2b8$var$_index2.default)(date);
            if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
                unit: 'dayOfYear'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(dayOfYear, token.length);
        },
        E: function(date, token, localize) {
            var dayOfWeek = date.getUTCDay();
            switch(token){
                case 'E':
                case 'EE':
                case 'EEE':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'EEEEE':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'EEEEEE':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'EEEE':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        e: function(date, token, localize, options) {
            var dayOfWeek = date.getUTCDay();
            var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
            switch(token){
                case 'e':
                    return String(localDayOfWeek);
                case 'ee':
                    return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, 2);
                case 'eo':
                    return localize.ordinalNumber(localDayOfWeek, {
                        unit: 'day'
                    });
                case 'eee':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'eeeee':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'eeeeee':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'eeee':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        c: function(date, token, localize, options) {
            var dayOfWeek = date.getUTCDay();
            var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
            switch(token){
                case 'c':
                    return String(localDayOfWeek);
                case 'cc':
                    return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, token.length);
                case 'co':
                    return localize.ordinalNumber(localDayOfWeek, {
                        unit: 'day'
                    });
                case 'ccc':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'ccccc':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'cccccc':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'standalone'
                    });
                case 'cccc':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        i: function(date, token, localize) {
            var dayOfWeek = date.getUTCDay();
            var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
            switch(token){
                case 'i':
                    return String(isoDayOfWeek);
                case 'ii':
                    return (0, $2542672a600cd2b8$var$_index7.default)(isoDayOfWeek, token.length);
                case 'io':
                    return localize.ordinalNumber(isoDayOfWeek, {
                        unit: 'day'
                    });
                case 'iii':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'iiiii':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'iiiiii':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'iiii':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        a: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'a':
                case 'aa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'aaa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }).toLowerCase();
                case 'aaaaa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaa':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        b: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue;
            if (hours === 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.noon;
            else if (hours === 0) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.midnight;
            else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'b':
                case 'bb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'bbb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }).toLowerCase();
                case 'bbbbb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbb':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        B: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue;
            if (hours >= 17) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.evening;
            else if (hours >= 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.afternoon;
            else if (hours >= 4) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.morning;
            else dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.night;
            switch(token){
                case 'B':
                case 'BB':
                case 'BBB':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'BBBBB':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBB':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        h: function(date, token, localize) {
            if (token === 'ho') {
                var hours = date.getUTCHours() % 12;
                if (hours === 0) hours = 12;
                return localize.ordinalNumber(hours, {
                    unit: 'hour'
                });
            }
            return $2542672a600cd2b8$var$_index.default.h(date, token);
        },
        H: function(date, token, localize) {
            if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
                unit: 'hour'
            });
            return $2542672a600cd2b8$var$_index.default.H(date, token);
        },
        K: function(date, token, localize) {
            var hours = date.getUTCHours() % 12;
            if (token === 'Ko') return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
        },
        k: function(date, token, localize) {
            var hours = date.getUTCHours();
            if (hours === 0) hours = 24;
            if (token === 'ko') return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
        },
        m: function(date, token, localize) {
            if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
                unit: 'minute'
            });
            return $2542672a600cd2b8$var$_index.default.m(date, token);
        },
        s: function(date, token, localize) {
            if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
                unit: 'second'
            });
            return $2542672a600cd2b8$var$_index.default.s(date, token);
        },
        S: function(date, token) {
            return $2542672a600cd2b8$var$_index.default.S(date, token);
        },
        X: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            if (timezoneOffset === 0) return 'Z';
            switch(token){
                case 'X':
                    return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'XXXX':
                case 'XX':
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
                case 'XXXXX':
                case 'XXX':
                default:
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        x: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'x':
                    return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'xxxx':
                case 'xx':
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
                case 'xxxxx':
                case 'xxx':
                default:
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        O: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'O':
                case 'OO':
                case 'OOO':
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
                case 'OOOO':
                default:
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        z: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'z':
                case 'zz':
                case 'zzz':
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
                case 'zzzz':
                default:
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        t: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timestamp = Math.floor(originalDate.getTime() / 1000);
            return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
        },
        T: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timestamp = originalDate.getTime();
            return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
        }
    };
    function $2542672a600cd2b8$var$formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;
        if (minutes === 0) return sign + String(hours);
        var delimiter = dirtyDelimiter || '';
        return sign + String(hours) + delimiter + (0, $2542672a600cd2b8$var$_index7.default)(minutes, 2);
    }
    function $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
        if (offset % 60 === 0) {
            var sign = offset > 0 ? '-' : '+';
            return sign + (0, $2542672a600cd2b8$var$_index7.default)(Math.abs(offset) / 60, 2);
        }
        return $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter);
    }
    function $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter) {
        var delimiter = dirtyDelimiter || '';
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = (0, $2542672a600cd2b8$var$_index7.default)(Math.floor(absOffset / 60), 2);
        var minutes = (0, $2542672a600cd2b8$var$_index7.default)(absOffset % 60, 2);
        return sign + hours + delimiter + minutes;
    }
    var $2542672a600cd2b8$var$_default = $2542672a600cd2b8$var$formatters;
    module.exports.default = $2542672a600cd2b8$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("kFGp1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f0c88744bd108133$var$_index = $f0c88744bd108133$var$_interopRequireDefault((parcelRequire("bQ2eo")));
    function $f0c88744bd108133$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $f0c88744bd108133$var$formatters = {
        y: function(date, token) {
            var signedYear = date.getUTCFullYear();
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return (0, $f0c88744bd108133$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
        },
        M: function(date, token) {
            var month = date.getUTCMonth();
            return token === 'M' ? String(month + 1) : (0, $f0c88744bd108133$var$_index.default)(month + 1, 2);
        },
        d: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCDate(), token.length);
        },
        a: function(date, token) {
            var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'a':
                case 'aa':
                    return dayPeriodEnumValue.toUpperCase();
                case 'aaa':
                    return dayPeriodEnumValue;
                case 'aaaaa':
                    return dayPeriodEnumValue[0];
                case 'aaaa':
                default:
                    return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
            }
        },
        h: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
        },
        H: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours(), token.length);
        },
        m: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCMinutes(), token.length);
        },
        s: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCSeconds(), token.length);
        },
        S: function(date, token) {
            var numberOfDigits = token.length;
            var milliseconds = date.getUTCMilliseconds();
            var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
            return (0, $f0c88744bd108133$var$_index.default)(fractionalSeconds, token.length);
        }
    };
    var $f0c88744bd108133$var$_default = $f0c88744bd108133$var$formatters;
    module.exports.default = $f0c88744bd108133$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("bQ2eo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $89e6481d20123ee2$var$addLeadingZeros;
    function $89e6481d20123ee2$var$addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? '-' : '';
        var output = Math.abs(number).toString();
        while(output.length < targetLength)output = '0' + output;
        return sign + output;
    }
    module.exports = module.exports.default;
});
parcelRegister("3xdEO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $292f0c3a5495486a$var$getUTCDayOfYear;
    var $292f0c3a5495486a$var$_index = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $292f0c3a5495486a$var$_index2 = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $292f0c3a5495486a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $292f0c3a5495486a$var$MILLISECONDS_IN_DAY = 86400000;
    function $292f0c3a5495486a$var$getUTCDayOfYear(dirtyDate) {
        (0, $292f0c3a5495486a$var$_index2.default)(1, arguments);
        var date = (0, $292f0c3a5495486a$var$_index.default)(dirtyDate);
        var timestamp = date.getTime();
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
        var startOfYearTimestamp = date.getTime();
        var difference = timestamp - startOfYearTimestamp;
        return Math.floor(difference / $292f0c3a5495486a$var$MILLISECONDS_IN_DAY) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("6Falt", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $4d9e98caba6dac2d$var$getUTCISOWeek;
    var $4d9e98caba6dac2d$var$_index = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $4d9e98caba6dac2d$var$_index2 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $4d9e98caba6dac2d$var$_index3 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("hI2kM")));
    var $4d9e98caba6dac2d$var$_index4 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $4d9e98caba6dac2d$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK = 604800000;
    function $4d9e98caba6dac2d$var$getUTCISOWeek(dirtyDate) {
        (0, $4d9e98caba6dac2d$var$_index4.default)(1, arguments);
        var date = (0, $4d9e98caba6dac2d$var$_index.default)(dirtyDate);
        var diff = (0, $4d9e98caba6dac2d$var$_index2.default)(date).getTime() - (0, $4d9e98caba6dac2d$var$_index3.default)(date).getTime();
        return Math.round(diff / $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("6nDqw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $4a53796a96b58804$var$startOfUTCISOWeek;
    var $4a53796a96b58804$var$_index = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $4a53796a96b58804$var$_index2 = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $4a53796a96b58804$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $4a53796a96b58804$var$startOfUTCISOWeek(dirtyDate) {
        (0, $4a53796a96b58804$var$_index2.default)(1, arguments);
        var weekStartsOn = 1;
        var date = (0, $4a53796a96b58804$var$_index.default)(dirtyDate);
        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("hI2kM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $ce485b424b643216$var$startOfUTCISOWeekYear;
    var $ce485b424b643216$var$_index = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("gUvh1")));
    var $ce485b424b643216$var$_index2 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $ce485b424b643216$var$_index3 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $ce485b424b643216$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $ce485b424b643216$var$startOfUTCISOWeekYear(dirtyDate) {
        (0, $ce485b424b643216$var$_index3.default)(1, arguments);
        var year = (0, $ce485b424b643216$var$_index.default)(dirtyDate);
        var fourthOfJanuary = new Date(0);
        fourthOfJanuary.setUTCFullYear(year, 0, 4);
        fourthOfJanuary.setUTCHours(0, 0, 0, 0);
        var date = (0, $ce485b424b643216$var$_index2.default)(fourthOfJanuary);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("gUvh1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $c4fa22996f39566a$var$getUTCISOWeekYear;
    var $c4fa22996f39566a$var$_index = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $c4fa22996f39566a$var$_index2 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $c4fa22996f39566a$var$_index3 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $c4fa22996f39566a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $c4fa22996f39566a$var$getUTCISOWeekYear(dirtyDate) {
        (0, $c4fa22996f39566a$var$_index3.default)(1, arguments);
        var date = (0, $c4fa22996f39566a$var$_index.default)(dirtyDate);
        var year = date.getUTCFullYear();
        var fourthOfJanuaryOfNextYear = new Date(0);
        fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
        fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
        var startOfNextYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfNextYear);
        var fourthOfJanuaryOfThisYear = new Date(0);
        fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
        fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
        var startOfThisYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfThisYear);
        if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
        else if (date.getTime() >= startOfThisYear.getTime()) return year;
        else return year - 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("46m4m", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $2fc8d772b38d0976$var$getUTCWeek;
    var $2fc8d772b38d0976$var$_index = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $2fc8d772b38d0976$var$_index2 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $2fc8d772b38d0976$var$_index3 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("cbqvD")));
    var $2fc8d772b38d0976$var$_index4 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $2fc8d772b38d0976$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK = 604800000;
    function $2fc8d772b38d0976$var$getUTCWeek(dirtyDate, options) {
        (0, $2fc8d772b38d0976$var$_index4.default)(1, arguments);
        var date = (0, $2fc8d772b38d0976$var$_index.default)(dirtyDate);
        var diff = (0, $2fc8d772b38d0976$var$_index2.default)(date, options).getTime() - (0, $2fc8d772b38d0976$var$_index3.default)(date, options).getTime();
        return Math.round(diff / $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("clhRK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8fc54dfcfb604fc4$var$startOfUTCWeek;
    var $8fc54dfcfb604fc4$var$_index = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $8fc54dfcfb604fc4$var$_index2 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $8fc54dfcfb604fc4$var$_index3 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8fc54dfcfb604fc4$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8fc54dfcfb604fc4$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
        (0, $8fc54dfcfb604fc4$var$_index3.default)(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $8fc54dfcfb604fc4$var$_index.default)(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $8fc54dfcfb604fc4$var$_index.default)(options.weekStartsOn);
        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        var date = (0, $8fc54dfcfb604fc4$var$_index2.default)(dirtyDate);
        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("cbqvD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8deb134e55cb5294$var$startOfUTCWeekYear;
    var $8deb134e55cb5294$var$_index = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $8deb134e55cb5294$var$_index2 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("3ihh3")));
    var $8deb134e55cb5294$var$_index3 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $8deb134e55cb5294$var$_index4 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8deb134e55cb5294$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8deb134e55cb5294$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
        (0, $8deb134e55cb5294$var$_index4.default)(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $8deb134e55cb5294$var$_index.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $8deb134e55cb5294$var$_index.default)(options.firstWeekContainsDate);
        var year = (0, $8deb134e55cb5294$var$_index2.default)(dirtyDate, dirtyOptions);
        var firstWeek = new Date(0);
        firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeek.setUTCHours(0, 0, 0, 0);
        var date = (0, $8deb134e55cb5294$var$_index3.default)(firstWeek, dirtyOptions);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("3ihh3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $266073c9a73c0f7b$var$getUTCWeekYear;
    var $266073c9a73c0f7b$var$_index = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $266073c9a73c0f7b$var$_index2 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $266073c9a73c0f7b$var$_index3 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $266073c9a73c0f7b$var$_index4 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $266073c9a73c0f7b$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $266073c9a73c0f7b$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
        (0, $266073c9a73c0f7b$var$_index4.default)(1, arguments);
        var date = (0, $266073c9a73c0f7b$var$_index2.default)(dirtyDate, dirtyOptions);
        var year = date.getUTCFullYear();
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $266073c9a73c0f7b$var$_index.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $266073c9a73c0f7b$var$_index.default)(options.firstWeekContainsDate);
        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        var firstWeekOfNextYear = new Date(0);
        firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
        firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
        var startOfNextYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
        var firstWeekOfThisYear = new Date(0);
        firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
        var startOfThisYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
        if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
        else if (date.getTime() >= startOfThisYear.getTime()) return year;
        else return year - 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("awKAW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    function $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong) {
        switch(pattern){
            case 'P':
                return formatLong.date({
                    width: 'short'
                });
            case 'PP':
                return formatLong.date({
                    width: 'medium'
                });
            case 'PPP':
                return formatLong.date({
                    width: 'long'
                });
            case 'PPPP':
            default:
                return formatLong.date({
                    width: 'full'
                });
        }
    }
    function $7aa109506ceedd4b$var$timeLongFormatter(pattern, formatLong) {
        switch(pattern){
            case 'p':
                return formatLong.time({
                    width: 'short'
                });
            case 'pp':
                return formatLong.time({
                    width: 'medium'
                });
            case 'ppp':
                return formatLong.time({
                    width: 'long'
                });
            case 'pppp':
            default:
                return formatLong.time({
                    width: 'full'
                });
        }
    }
    function $7aa109506ceedd4b$var$dateTimeLongFormatter(pattern, formatLong) {
        var matchResult = pattern.match(/(P+)(p+)?/);
        var datePattern = matchResult[1];
        var timePattern = matchResult[2];
        if (!timePattern) return $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong);
        var dateTimeFormat;
        switch(datePattern){
            case 'P':
                dateTimeFormat = formatLong.dateTime({
                    width: 'short'
                });
                break;
            case 'PP':
                dateTimeFormat = formatLong.dateTime({
                    width: 'medium'
                });
                break;
            case 'PPP':
                dateTimeFormat = formatLong.dateTime({
                    width: 'long'
                });
                break;
            case 'PPPP':
            default:
                dateTimeFormat = formatLong.dateTime({
                    width: 'full'
                });
                break;
        }
        return dateTimeFormat.replace('{{date}}', $7aa109506ceedd4b$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $7aa109506ceedd4b$var$timeLongFormatter(timePattern, formatLong));
    }
    var $7aa109506ceedd4b$var$longFormatters = {
        p: $7aa109506ceedd4b$var$timeLongFormatter,
        P: $7aa109506ceedd4b$var$dateTimeLongFormatter
    };
    var $7aa109506ceedd4b$var$_default = $7aa109506ceedd4b$var$longFormatters;
    module.exports.default = $7aa109506ceedd4b$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("jGQTC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds;
    function $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds(date) {
        var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
        utcDate.setUTCFullYear(date.getFullYear());
        return date.getTime() - utcDate.getTime();
    }
    module.exports = module.exports.default;
});
parcelRegister("5qguX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isProtectedDayOfYearToken = $3f2c2dab40599caa$var$isProtectedDayOfYearToken;
    module.exports.isProtectedWeekYearToken = $3f2c2dab40599caa$var$isProtectedWeekYearToken;
    module.exports.throwProtectedError = $3f2c2dab40599caa$var$throwProtectedError;
    var $3f2c2dab40599caa$var$protectedDayOfYearTokens = [
        'D',
        'DD'
    ];
    var $3f2c2dab40599caa$var$protectedWeekYearTokens = [
        'YY',
        'YYYY'
    ];
    function $3f2c2dab40599caa$var$isProtectedDayOfYearToken(token) {
        return $3f2c2dab40599caa$var$protectedDayOfYearTokens.indexOf(token) !== -1;
    }
    function $3f2c2dab40599caa$var$isProtectedWeekYearToken(token) {
        return $3f2c2dab40599caa$var$protectedWeekYearTokens.indexOf(token) !== -1;
    }
    function $3f2c2dab40599caa$var$throwProtectedError(token, format, input) {
        if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    }
});
parcelRegister("dBimx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e6cf97ea11d4595$export$2e2bcd8739ae039);
    var $kbEJb = parcelRequire("kbEJb");
    var $i6fIb = parcelRequire("i6fIb");
    var $9e6cf97ea11d4595$var$MILLISECONDS_IN_MINUTE = 60000;
    var $9e6cf97ea11d4595$var$formatters = {
        X: function(date, token, localize, options) {
            var timezoneOffset = $9e6cf97ea11d4595$var$getTimeZoneOffset(options.timeZone, date);
            if (timezoneOffset === 0) return 'Z';
            switch(token){
                case 'X':
                    return $9e6cf97ea11d4595$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'XXXX':
                case 'XX':
                    return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset);
                case 'XXXXX':
                case 'XXX':
                default:
                    return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset, ':');
            }
        },
        x: function(date, token, localize, options) {
            var timezoneOffset = $9e6cf97ea11d4595$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'x':
                    return $9e6cf97ea11d4595$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'xxxx':
                case 'xx':
                    return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset);
                case 'xxxxx':
                case 'xxx':
                default:
                    return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset, ':');
            }
        },
        O: function(date, token, localize, options) {
            var timezoneOffset = $9e6cf97ea11d4595$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'O':
                case 'OO':
                case 'OOO':
                    return 'GMT' + $9e6cf97ea11d4595$var$formatTimezoneShort(timezoneOffset, ':');
                case 'OOOO':
                default:
                    return 'GMT' + $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset, ':');
            }
        },
        z: function(date, token, localize, options) {
            switch(token){
                case 'z':
                case 'zz':
                case 'zzz':
                    return (0, $kbEJb.default)('short', date, options);
                case 'zzzz':
                default:
                    return (0, $kbEJb.default)('long', date, options);
            }
        }
    };
    function $9e6cf97ea11d4595$var$getTimeZoneOffset(timeZone, originalDate) {
        var timeZoneOffset = timeZone ? (0, $i6fIb.default)(timeZone, originalDate, true) / $9e6cf97ea11d4595$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
        if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
        return timeZoneOffset;
    }
    function $9e6cf97ea11d4595$var$addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? '-' : '';
        var output = Math.abs(number).toString();
        while(output.length < targetLength)output = '0' + output;
        return sign + output;
    }
    function $9e6cf97ea11d4595$var$formatTimezone(offset, dirtyDelimeter) {
        var delimeter = dirtyDelimeter || '';
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = $9e6cf97ea11d4595$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
        var minutes = $9e6cf97ea11d4595$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
        return sign + hours + delimeter + minutes;
    }
    function $9e6cf97ea11d4595$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
        if (offset % 60 === 0) {
            var sign = offset > 0 ? '-' : '+';
            return sign + $9e6cf97ea11d4595$var$addLeadingZeros(Math.abs(offset) / 60, 2);
        }
        return $9e6cf97ea11d4595$var$formatTimezone(offset, dirtyDelimeter);
    }
    function $9e6cf97ea11d4595$var$formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;
        if (minutes === 0) return sign + String(hours);
        var delimiter = dirtyDelimiter || '';
        return sign + String(hours) + delimiter + $9e6cf97ea11d4595$var$addLeadingZeros(minutes, 2);
    }
    var $9e6cf97ea11d4595$export$2e2bcd8739ae039 = $9e6cf97ea11d4595$var$formatters;
});
parcelRegister("kbEJb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb246d6cdcaaeca4$export$2e2bcd8739ae039);
    function $eb246d6cdcaaeca4$export$2e2bcd8739ae039(length, date, options) {
        var dtf = $eb246d6cdcaaeca4$var$getDTF(length, options.timeZone, options.locale);
        return dtf.formatToParts ? $eb246d6cdcaaeca4$var$partsTimeZone(dtf, date) : $eb246d6cdcaaeca4$var$hackyTimeZone(dtf, date);
    }
    function $eb246d6cdcaaeca4$var$partsTimeZone(dtf, date) {
        var formatted = dtf.formatToParts(date);
        for(var i = formatted.length - 1; i >= 0; --i){
            if (formatted[i].type === 'timeZoneName') return formatted[i].value;
        }
    }
    function $eb246d6cdcaaeca4$var$hackyTimeZone(dtf, date) {
        var formatted = dtf.format(date).replace(/\u200E/g, '');
        var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
        return tzNameMatch ? tzNameMatch[0].substr(1) : '';
    }
    function $eb246d6cdcaaeca4$var$getDTF(length, timeZone, locale) {
        if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
        return new Intl.DateTimeFormat(locale ? [
            locale.code,
            'en-US'
        ] : undefined, {
            timeZone: timeZone,
            timeZoneName: length
        });
    }
});
parcelRegister("i6fIb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2d4f98f2ab6c303$export$2e2bcd8739ae039);
    var $hb3mZ = parcelRequire("hb3mZ");
    var $e86X7 = parcelRequire("e86X7");
    var $d2d4f98f2ab6c303$var$MILLISECONDS_IN_HOUR = 3600000;
    var $d2d4f98f2ab6c303$var$MILLISECONDS_IN_MINUTE = 60000;
    var $d2d4f98f2ab6c303$var$patterns = {
        timezone: /([Z+-].*)$/,
        timezoneZ: /^(Z)$/,
        timezoneHH: /^([+-]\d{2})$/,
        timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
    };
    function $d2d4f98f2ab6c303$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
        var token;
        var absoluteOffset;
        if (!timezoneString) return 0;
        token = $d2d4f98f2ab6c303$var$patterns.timezoneZ.exec(timezoneString);
        if (token) return 0;
        var hours;
        token = $d2d4f98f2ab6c303$var$patterns.timezoneHH.exec(timezoneString);
        if (token) {
            hours = parseInt(token[1], 10);
            if (!$d2d4f98f2ab6c303$var$validateTimezone(hours)) return NaN;
            return -(hours * $d2d4f98f2ab6c303$var$MILLISECONDS_IN_HOUR);
        }
        token = $d2d4f98f2ab6c303$var$patterns.timezoneHHMM.exec(timezoneString);
        if (token) {
            hours = parseInt(token[2], 10);
            var minutes = parseInt(token[3], 10);
            if (!$d2d4f98f2ab6c303$var$validateTimezone(hours, minutes)) return NaN;
            absoluteOffset = Math.abs(hours) * $d2d4f98f2ab6c303$var$MILLISECONDS_IN_HOUR + minutes * $d2d4f98f2ab6c303$var$MILLISECONDS_IN_MINUTE;
            return token[1] === '+' ? -absoluteOffset : absoluteOffset;
        }
        if ($d2d4f98f2ab6c303$var$isValidTimezoneIANAString(timezoneString)) {
            date = new Date(date || Date.now());
            var utcDate = isUtcDate ? date : $d2d4f98f2ab6c303$var$toUtcDate(date);
            var offset = $d2d4f98f2ab6c303$var$calcOffset(utcDate, timezoneString);
            var fixedOffset = isUtcDate ? offset : $d2d4f98f2ab6c303$var$fixOffset(date, offset, timezoneString);
            return -fixedOffset;
        }
        return NaN;
    }
    function $d2d4f98f2ab6c303$var$toUtcDate(date) {
        return (0, $e86X7.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    }
    function $d2d4f98f2ab6c303$var$calcOffset(date, timezoneString) {
        var tokens = (0, $hb3mZ.default)(date, timezoneString);
        var asUTC = (0, $e86X7.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
        var asTS = date.getTime();
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return asUTC - asTS;
    }
    function $d2d4f98f2ab6c303$var$fixOffset(date, offset, timezoneString) {
        var localTS = date.getTime();
        var utcGuess = localTS - offset;
        var o2 = $d2d4f98f2ab6c303$var$calcOffset(new Date(utcGuess), timezoneString);
        if (offset === o2) return offset;
        utcGuess -= o2 - offset;
        var o3 = $d2d4f98f2ab6c303$var$calcOffset(new Date(utcGuess), timezoneString);
        if (o2 === o3) return o2;
        return Math.max(o2, o3);
    }
    function $d2d4f98f2ab6c303$var$validateTimezone(hours, minutes) {
        return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
    }
    var $d2d4f98f2ab6c303$var$validIANATimezoneCache = {};
    function $d2d4f98f2ab6c303$var$isValidTimezoneIANAString(timeZoneString) {
        if ($d2d4f98f2ab6c303$var$validIANATimezoneCache[timeZoneString]) return true;
        try {
            new Intl.DateTimeFormat(undefined, {
                timeZone: timeZoneString
            });
            $d2d4f98f2ab6c303$var$validIANATimezoneCache[timeZoneString] = true;
            return true;
        } catch (error) {
            return false;
        }
    }
});
parcelRegister("hb3mZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c81613eb8d87ac5c$export$2e2bcd8739ae039);
    function $c81613eb8d87ac5c$export$2e2bcd8739ae039(date, timeZone) {
        var dtf = $c81613eb8d87ac5c$var$getDateTimeFormat(timeZone);
        return dtf.formatToParts ? $c81613eb8d87ac5c$var$partsOffset(dtf, date) : $c81613eb8d87ac5c$var$hackyOffset(dtf, date);
    }
    var $c81613eb8d87ac5c$var$typeToPos = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    };
    function $c81613eb8d87ac5c$var$partsOffset(dtf, date) {
        try {
            var formatted = dtf.formatToParts(date);
            var filled = [];
            for(var i = 0; i < formatted.length; i++){
                var pos = $c81613eb8d87ac5c$var$typeToPos[formatted[i].type];
                if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
            }
            return filled;
        } catch (error) {
            if (error instanceof RangeError) return [
                NaN
            ];
            throw error;
        }
    }
    function $c81613eb8d87ac5c$var$hackyOffset(dtf, date) {
        var formatted = dtf.format(date);
        var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
        return [
            parsed[3],
            parsed[1],
            parsed[2],
            parsed[4],
            parsed[5],
            parsed[6]
        ];
    }
    var $c81613eb8d87ac5c$var$dtfCache = {};
    function $c81613eb8d87ac5c$var$getDateTimeFormat(timeZone) {
        if (!$c81613eb8d87ac5c$var$dtfCache[timeZone]) {
            var testDateFormatted = new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: 'America/New_York',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }).format(new Date('2014-06-25T04:00:00.123Z'));
            var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
            $c81613eb8d87ac5c$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }) : new Intl.DateTimeFormat('en-US', {
                hour12: false,
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
        return $c81613eb8d87ac5c$var$dtfCache[timeZone];
    }
});
parcelRegister("e86X7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a49734b25d97733d$export$2e2bcd8739ae039);
    function $a49734b25d97733d$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
        var utcDate = new Date(0);
        utcDate.setUTCFullYear(fullYear, month, day);
        utcDate.setUTCHours(hour, minute, second, millisecond);
        return utcDate;
    }
});
parcelRegister("gUUmE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c50d991cbda2c596$export$2e2bcd8739ae039);
    var $aSksP;
    var $jGQTC;
    var $i6fIb = parcelRequire("i6fIb");
    var $crHgC = parcelRequire("crHgC");
    var $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR = 3600000;
    var $c50d991cbda2c596$var$MILLISECONDS_IN_MINUTE = 60000;
    var $c50d991cbda2c596$var$DEFAULT_ADDITIONAL_DIGITS = 2;
    var $c50d991cbda2c596$var$patterns = {
        dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
        datePattern: /^([0-9W+-]+)(.*)/,
        plainTime: /:/,
        YY: /^(\d{2})$/,
        YYY: [
            /^([+-]\d{2})$/,
            /^([+-]\d{3})$/,
            /^([+-]\d{4})$/
        ],
        YYYY: /^(\d{4})/,
        YYYYY: [
            /^([+-]\d{4})/,
            /^([+-]\d{5})/,
            /^([+-]\d{6})/
        ],
        MM: /^-(\d{2})$/,
        DDD: /^-?(\d{3})$/,
        MMDD: /^-?(\d{2})-?(\d{2})$/,
        Www: /^-?W(\d{2})$/,
        WwwD: /^-?W(\d{2})-?(\d{1})$/,
        HH: /^(\d{2}([.,]\d*)?)$/,
        HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
        HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
        timeZone: (0, $crHgC.default)
    };
    function $c50d991cbda2c596$export$2e2bcd8739ae039(argument, dirtyOptions) {
        if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
        if (argument === null) return new Date(NaN);
        var options = dirtyOptions || {};
        var additionalDigits = options.additionalDigits == null ? $c50d991cbda2c596$var$DEFAULT_ADDITIONAL_DIGITS : (0, ($parcel$interopDefault((0, parcelRequire("aSksP")))))(options.additionalDigits);
        if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
        if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') return new Date(argument.getTime());
        else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
        else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
        var dateStrings = $c50d991cbda2c596$var$splitDateString(argument);
        var parseYearResult = $c50d991cbda2c596$var$parseYear(dateStrings.date, additionalDigits);
        var year = parseYearResult.year;
        var restDateString = parseYearResult.restDateString;
        var date = $c50d991cbda2c596$var$parseDate(restDateString, year);
        if (isNaN(date)) return new Date(NaN);
        if (date) {
            var timestamp = date.getTime();
            var time = 0;
            var offset;
            if (dateStrings.time) {
                time = $c50d991cbda2c596$var$parseTime(dateStrings.time);
                if (isNaN(time)) return new Date(NaN);
            }
            if (dateStrings.timeZone || options.timeZone) {
                offset = (0, $i6fIb.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
                if (isNaN(offset)) return new Date(NaN);
            } else {
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time));
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time + offset));
            }
            return new Date(timestamp + time + offset);
        } else return new Date(NaN);
    }
    function $c50d991cbda2c596$var$splitDateString(dateString) {
        var dateStrings = {};
        var parts = $c50d991cbda2c596$var$patterns.dateTimePattern.exec(dateString);
        var timeString;
        if (!parts) {
            parts = $c50d991cbda2c596$var$patterns.datePattern.exec(dateString);
            if (parts) {
                dateStrings.date = parts[1];
                timeString = parts[2];
            } else {
                dateStrings.date = null;
                timeString = dateString;
            }
        } else {
            dateStrings.date = parts[1];
            timeString = parts[3];
        }
        if (timeString) {
            var token = $c50d991cbda2c596$var$patterns.timeZone.exec(timeString);
            if (token) {
                dateStrings.time = timeString.replace(token[1], '');
                dateStrings.timeZone = token[1].trim();
            } else dateStrings.time = timeString;
        }
        return dateStrings;
    }
    function $c50d991cbda2c596$var$parseYear(dateString, additionalDigits) {
        var patternYYY = $c50d991cbda2c596$var$patterns.YYY[additionalDigits];
        var patternYYYYY = $c50d991cbda2c596$var$patterns.YYYYY[additionalDigits];
        var token;
        token = $c50d991cbda2c596$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
        if (token) {
            var yearString = token[1];
            return {
                year: parseInt(yearString, 10),
                restDateString: dateString.slice(yearString.length)
            };
        }
        token = $c50d991cbda2c596$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
        if (token) {
            var centuryString = token[1];
            return {
                year: parseInt(centuryString, 10) * 100,
                restDateString: dateString.slice(centuryString.length)
            };
        }
        return {
            year: null
        };
    }
    function $c50d991cbda2c596$var$parseDate(dateString, year) {
        if (year === null) return null;
        var token;
        var date;
        var month;
        var week;
        if (dateString.length === 0) {
            date = new Date(0);
            date.setUTCFullYear(year);
            return date;
        }
        token = $c50d991cbda2c596$var$patterns.MM.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            if (!$c50d991cbda2c596$var$validateDate(year, month)) return new Date(NaN);
            date.setUTCFullYear(year, month);
            return date;
        }
        token = $c50d991cbda2c596$var$patterns.DDD.exec(dateString);
        if (token) {
            date = new Date(0);
            var dayOfYear = parseInt(token[1], 10);
            if (!$c50d991cbda2c596$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
            date.setUTCFullYear(year, 0, dayOfYear);
            return date;
        }
        token = $c50d991cbda2c596$var$patterns.MMDD.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            var day = parseInt(token[2], 10);
            if (!$c50d991cbda2c596$var$validateDate(year, month, day)) return new Date(NaN);
            date.setUTCFullYear(year, month, day);
            return date;
        }
        token = $c50d991cbda2c596$var$patterns.Www.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            if (!$c50d991cbda2c596$var$validateWeekDate(year, week)) return new Date(NaN);
            return $c50d991cbda2c596$var$dayOfISOWeekYear(year, week);
        }
        token = $c50d991cbda2c596$var$patterns.WwwD.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            var dayOfWeek = parseInt(token[2], 10) - 1;
            if (!$c50d991cbda2c596$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
            return $c50d991cbda2c596$var$dayOfISOWeekYear(year, week, dayOfWeek);
        }
        return null;
    }
    function $c50d991cbda2c596$var$parseTime(timeString) {
        var token;
        var hours;
        var minutes;
        token = $c50d991cbda2c596$var$patterns.HH.exec(timeString);
        if (token) {
            hours = parseFloat(token[1].replace(',', '.'));
            if (!$c50d991cbda2c596$var$validateTime(hours)) return NaN;
            return hours % 24 * $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR;
        }
        token = $c50d991cbda2c596$var$patterns.HHMM.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseFloat(token[2].replace(',', '.'));
            if (!$c50d991cbda2c596$var$validateTime(hours, minutes)) return NaN;
            return hours % 24 * $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR + minutes * $c50d991cbda2c596$var$MILLISECONDS_IN_MINUTE;
        }
        token = $c50d991cbda2c596$var$patterns.HHMMSS.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseInt(token[2], 10);
            var seconds = parseFloat(token[3].replace(',', '.'));
            if (!$c50d991cbda2c596$var$validateTime(hours, minutes, seconds)) return NaN;
            return hours % 24 * $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR + minutes * $c50d991cbda2c596$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
        }
        return null;
    }
    function $c50d991cbda2c596$var$dayOfISOWeekYear(isoWeekYear, week, day) {
        week = week || 0;
        day = day || 0;
        var date = new Date(0);
        date.setUTCFullYear(isoWeekYear, 0, 4);
        var fourthOfJanuaryDay = date.getUTCDay() || 7;
        var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
        date.setUTCDate(date.getUTCDate() + diff);
        return date;
    }
    var $c50d991cbda2c596$var$DAYS_IN_MONTH = [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    var $c50d991cbda2c596$var$DAYS_IN_MONTH_LEAP_YEAR = [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    function $c50d991cbda2c596$var$isLeapYearIndex(year) {
        return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
    }
    function $c50d991cbda2c596$var$validateDate(year, month, date) {
        if (month < 0 || month > 11) return false;
        if (date != null) {
            if (date < 1) return false;
            var isLeapYear = $c50d991cbda2c596$var$isLeapYearIndex(year);
            if (isLeapYear && date > $c50d991cbda2c596$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
            if (!isLeapYear && date > $c50d991cbda2c596$var$DAYS_IN_MONTH[month]) return false;
        }
        return true;
    }
    function $c50d991cbda2c596$var$validateDayOfYearDate(year, dayOfYear) {
        if (dayOfYear < 1) return false;
        var isLeapYear = $c50d991cbda2c596$var$isLeapYearIndex(year);
        if (isLeapYear && dayOfYear > 366) return false;
        if (!isLeapYear && dayOfYear > 365) return false;
        return true;
    }
    function $c50d991cbda2c596$var$validateWeekDate(year, week, day) {
        if (week < 0 || week > 52) return false;
        if (day != null && (day < 0 || day > 6)) return false;
        return true;
    }
    function $c50d991cbda2c596$var$validateTime(hours, minutes, seconds) {
        if (hours != null && (hours < 0 || hours >= 25)) return false;
        if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
        if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
        return true;
    }
});
parcelRegister("crHgC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90f991911d90bed8$export$2e2bcd8739ae039);
    var $90f991911d90bed8$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
    var $90f991911d90bed8$export$2e2bcd8739ae039 = $90f991911d90bed8$var$tzPattern;
});
parcelRegister("jAT0D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e43c0cd241603813$export$2e2bcd8739ae039);
    var $i6fIb = parcelRequire("i6fIb");
    var $gUUmE;
    function $e43c0cd241603813$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
        var date = (0, (0, parcelRequire("gUUmE")).default)(dirtyDate, options);
        var offsetMilliseconds = (0, $i6fIb.default)(timeZone, date, true);
        var d = new Date(date.getTime() - offsetMilliseconds);
        var resultDate = new Date(0);
        resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
        return resultDate;
    }
});
parcelRegister("8PqA1", function(module, exports) {
    $parcel$export(module.exports, "transformUserTimelineResponse", ()=>$8a23480b7911491d$export$78049913b79774a2);
    var $hz3Fg;
    const $8a23480b7911491d$export$78049913b79774a2 = ({ startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, startOffsetMillis: startOffsetMillis, endOffsetMillis: endOffsetMillis, utcTimeOffsetMillis: utcTimeOffsetMillis, currentTime: currentTime, periods: periods, ...data })=>{
        return {
            startEpoch: startTimeUtcMillis,
            endEpoch: endTimeUtcMillis,
            nowEpoch: currentTime,
            startOffset: startOffsetMillis,
            endOffset: endOffsetMillis,
            nowOffset: utcTimeOffsetMillis,
            data: {
                ...data,
                periods: periods.map((0, (0, parcelRequire("hz3Fg")).fromMergedPeriodResponseToClusterPeriod))
            }
        };
    };
});
parcelRegister("hz3Fg", function(module, exports) {
    $parcel$export(module.exports, "fromMergedPeriodResponseToClusterPeriod", ()=>$0fe8fc9a353d2f1e$export$9b0bac75f135bd57);
    const $0fe8fc9a353d2f1e$export$9b0bac75f135bd57 = (mergedPeriodResponse)=>{
        const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingPeriods: overlappingPeriods } = mergedPeriodResponse;
        const clusterPeriod = {
            id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
            startEpoch: startTimeUtcMillis,
            endEpoch: endTimeUtcMillis,
            isTrueStartTime: isTrueStartTime,
            isTrueEndTime: isTrueEndTime,
            startOffset: periodStartOffsetMillis,
            endOffset: periodEndOffsetMillis,
            overlaps: overlappingPeriods.map($0fe8fc9a353d2f1e$var$fromOverlappingPeriodResponseToOverlappingPeriod)
        };
        return clusterPeriod;
    };
    const $0fe8fc9a353d2f1e$var$fromOverlappingPeriodResponseToOverlappingPeriod = (overlappingPeriodResponse)=>{
        const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingRotations: overlappingRotations, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime } = overlappingPeriodResponse;
        const overlappingPeriod = {
            id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
            startEpoch: startTimeUtcMillis,
            endEpoch: endTimeUtcMillis,
            startOffset: periodStartOffsetMillis,
            endOffset: periodEndOffsetMillis,
            overlaps: overlappingRotations,
            isTrueStartTime: isTrueStartTime,
            isTrueEndTime: isTrueEndTime
        };
        return overlappingPeriod;
    };
});
parcelRegister("9Nrj8", function(module, exports) {
    $parcel$export(module.exports, "whoIsOnCallRoute", ()=>$44bb0c0960b12c42$export$26b06efd7311586b);
    var $65Ltd;
    const $44bb0c0960b12c42$export$26b06efd7311586b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_WHO_IS_ON_CALL),
        path: '/jira/ops/who-is-on-call',
        exact: true
    };
});
parcelRegister("ipi8d", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("g1eRw")
    ]).then(()=>parcelRequire('eV5T9'));
});
parcelRegister("iFaFr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b86720f4c83cfbb5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $b86720f4c83cfbb5$var$LazyForPaintForgeGlobalPageSidebar = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("l65XP")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/forge-global-page/src/index.tsx"
    });
    const $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "forgeGlobalPage"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b86720f4c83cfbb5$var$LazyForPaintForgeGlobalPageSidebar, null)));
    $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar.displayName = 'ForgeGlobalPageSidebar';
    var $b86720f4c83cfbb5$export$2e2bcd8739ae039 = $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar;
});
parcelRegister("l65XP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6eoVI")
    ]).then(()=>parcelRequire('4opkK'));
});
parcelRegister("78U7j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f593a4193eb44f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("jCoeB")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
    });
    const $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalIssuesSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar, null)));
    var $4f593a4193eb44f7$export$2e2bcd8739ae039 = $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar;
});
parcelRegister("jCoeB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jkFzD").then(()=>parcelRequire('dZptX'));
});
parcelRegister("2zQ5k", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gMZ9X").then(()=>parcelRequire('6re9h'));
});
parcelRegister("2YqLE", function(module, exports) {
    $parcel$export(module.exports, "fieldContextConfigPageResource", ()=>$2520f99c62492240$export$686a607053a18611);
    var $2M1hQ;
    const $2520f99c62492240$export$686a607053a18611 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $714c31c1c770eaf3$export$4b80522d38222ad),
        getKey: ()=>'data',
        getDataLoader: ()=>(parcelRequire("gAT5i")),
        maxAge: 5000
    });
});
const $714c31c1c770eaf3$export$4b80522d38222ad = 'FORGE_FIELD_CONTEXTUAL_CONFIG';
parcelRegister("gAT5i", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ftzT3").then(()=>parcelRequire('ei6Pl'));
});
parcelRegister("5bXwS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f8cIm").then(()=>parcelRequire('bqE5a'));
});
parcelRegister("32VdM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5CiUy").then(()=>parcelRequire('jBnrF'));
});
parcelRegister("98CQn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("erHCa").then(()=>parcelRequire('eZUti'));
});
parcelRegister("65N9E", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lFdZ5").then(()=>parcelRequire('arSLF'));
});
parcelRegister("9ORLZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cBmhJ").then(()=>parcelRequire('kGkpN'));
});
parcelRegister("74XPL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2GKln").then(()=>parcelRequire('6Ue2s'));
});
parcelRegister("dMnMc", function(module, exports) {
    $parcel$export(module.exports, "getBoardId", ()=>$fe24052863a91d57$export$557c2f222778cea6);
    $parcel$export(module.exports, "default", ()=>$fe24052863a91d57$export$2e2bcd8739ae039);
    var $aZsz6 = parcelRequire("aZsz6");
    var $95bh0;
    var $556I0;
    var $5PyNy;
    var $79s9E;
    const $fe24052863a91d57$var$projectScopeDataMap = {
        routes: [
            /[&?]projectKey=(\w+)/i,
            /\/projects\/(\w+)/i,
            /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
            /\/plugins\/servlet\/project-config\/(\w+)/i,
            /\/servicedesk\/admin\/(\w+)/i,
            /\/browse\/(\w+)\/?(\?.*)?$/i
        ],
        meta: [
            'ghx-project-key',
            'projectKey',
            'ajs-project-key'
        ]
    };
    const $fe24052863a91d57$var$getProjectId = (url)=>{
        const projectIdRoutes = [
            /[&?]selectedProjectId=(\w+)/i,
            /[&?]pid=(\w+)/i,
            /[&?]projectId=(\w+)/i,
            /[&?]project\.id=(\w+)/i
        ];
        return projectIdRoutes.reduce((foundId, route)=>{
            if (foundId) return foundId;
            const match = url.match(route);
            if (match != null) {
                const [, projectId] = match;
                if (projectId) return projectId;
            }
            return null;
        }, null);
    };
    const $fe24052863a91d57$var$getProjectKey = (url, getMeta)=>{
        let projectKey = null;
        $fe24052863a91d57$var$projectScopeDataMap.meta.forEach((tagName)=>{
            const value = getMeta(tagName);
            if (value && projectKey == null) projectKey = value;
        });
        $fe24052863a91d57$var$projectScopeDataMap.routes.forEach((route)=>{
            const match = url.match(route);
            if (match != null && projectKey == null) [, projectKey] = match;
        });
        return projectKey || undefined;
    };
    const $fe24052863a91d57$export$557c2f222778cea6 = (url)=>{
        try {
            const parsed = (0, ($parcel$interopDefault($aZsz6)))(url, true);
            let boardId = parsed.query ? parsed.query.rapidView : null;
            if (boardId == null) {
                const match = url.match(/\/boards\/(\d+)/i);
                boardId = match ? match[1] : null;
            }
            return boardId;
        } catch (err) {
            return null;
        }
    };
    const $fe24052863a91d57$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, (0, parcelRequire("556I0")).default).some((regex)=>regex.test(url)) || (0, (0, parcelRequire("5PyNy")).default).some((regex)=>regex.test(url));
    const $fe24052863a91d57$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
        const isProject = ()=>{
            const routes = [
                /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
                /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
                /\/secure\/ReleaseNote.jspa.+projectId/i,
                /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
            ];
            return $fe24052863a91d57$var$isProjectSettingsConnectRoute({
                getMeta: getMeta,
                url: url
            }) || routes.some((regex)=>regex.test(url));
        };
        return projectKey || projectId && isProject();
    };
    const $fe24052863a91d57$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, (0, parcelRequire("79s9E")).default).some((route)=>url.match(route)) || $fe24052863a91d57$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        });
    const $fe24052863a91d57$var$getProjectPageType = (getMeta, url)=>{
        if ($fe24052863a91d57$var$isProjectSettingsPage({
            getMeta: getMeta,
            url: url
        })) return 'settings';
        const decorator = getMeta('decorator');
        const isSettings = getMeta('is-settings-page') === 'true';
        return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
    };
    var $fe24052863a91d57$export$2e2bcd8739ae039 = (url, getMeta)=>{
        const extractedData = {};
        const boardId = $fe24052863a91d57$export$557c2f222778cea6(url);
        if (boardId) extractedData.boardId = boardId;
        const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $fe24052863a91d57$var$getProjectKey(url, getMeta);
        if (projectKey) extractedData.projectKey = projectKey;
        const projectId = $fe24052863a91d57$var$getProjectId(url);
        if (projectId) extractedData.projectId = projectId;
        const isProject = $fe24052863a91d57$var$isProjectPage({
            getMeta: getMeta,
            projectId: projectId,
            projectKey: projectKey,
            url: url
        });
        extractedData.pageType = isProject ? $fe24052863a91d57$var$getProjectPageType(getMeta, url) : undefined;
        const identifier = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            boardId: boardId,
            projectKey: projectKey,
            projectId: isProject ? projectId : null
        });
        return {
            ...extractedData,
            ...identifier
        };
    };
});
parcelRegister("556I0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2aff61bbf8b5a2cf$export$2e2bcd8739ae039);
    var $2aff61bbf8b5a2cf$export$2e2bcd8739ae039 = [
        /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
    ];
});
parcelRegister("5PyNy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d489e15712c5e17$export$2e2bcd8739ae039);
    var $5d489e15712c5e17$export$2e2bcd8739ae039 = [
        /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
        /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
    ];
});
parcelRegister("79s9E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efe7a2022eaf0f59$export$2e2bcd8739ae039);
    var $5PyNy;
    const $efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes = [
        /\/plugins\/servlet\/project-config/i,
        /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
        /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
        /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
        /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
        /\/plugins\/servlet\/project-config\/.+\/fields/i,
        /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
        /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
        /\/plugins\/servlet\/project-config\/.+\/notifications/i,
        /\/plugins\/servlet\/project-config\/.+\/permissions/i,
        /\/plugins\/servlet\/project-config\/.+\/screens/i,
        /\/plugins\/servlet\/project-config\/.+\/workflows/i,
        /\/project\/DeleteProject!default\.jspa/i,
        /\/secure\/project\/EditProject!default\.jspa/i,
        /\/secure\/AddCollector/i,
        /\/secure\/InsertCollectorHelp/i,
        /\/ViewCollector!default\.jspa\?projectKey=/i,
        /\/ViewCollectors!default\.jspa\?projectKey=/i,
        /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
        /\/InstallHipChat\.jspa\?projectKey=/i,
        /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
        /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
    ];
    var $efe7a2022eaf0f59$export$2e2bcd8739ae039 = [
        ...$efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes,
        /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
        ...(0, (0, parcelRequire("5PyNy")).default),
        /\/servicedesk\/admin\/(\w+)/i,
        /\/projects\/\w+\/settings(\/\w+)*/i
    ];
});
parcelRegister("34Vv8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$827c4d80e4d41b48$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    const $827c4d80e4d41b48$var$withFlagService = (WrappedComponent)=>{
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                flagService: (0, (0, parcelRequire("pa9q9")).flagService)
            });
    };
    var $827c4d80e4d41b48$export$2e2bcd8739ae039 = $827c4d80e4d41b48$var$withFlagService;
});
parcelRegister("leonD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8yfIj").then(()=>parcelRequire('7ROZZ'));
});
parcelRegister("cpdjw", function(module, exports) {
    $parcel$export(module.exports, "customFieldsDirectoryResource", ()=>$dcd1379dc352c4e2$export$3d783f106e15b01a);
    var $2M1hQ;
    const $dcd1379dc352c4e2$export$3d783f106e15b01a = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $d558514bbbbc39cd$export$f237bae095c310e7),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("2qCzi"))
    });
});
const $d558514bbbbc39cd$export$f237bae095c310e7 = 'CUSTOM_FIELDS_DIRECTORY';
parcelRegister("2qCzi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8mAnw").then(()=>parcelRequire('fFz2g'));
});
parcelRegister("kI1WL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2lIOR")
    ]).then(()=>parcelRequire('4ZT30'));
});
parcelRegister("427L2", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", ()=>$654498d18bc8ccd3$export$5519b86c9ea602e1);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $gB79g;
    var $aYyVm;
    const $654498d18bc8ccd3$export$5519b86c9ea602e1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gB79g")).globalSettingsIssuesExplicitFieldAssociationRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            component: (0, (0, parcelRequire("aYyVm")).LazyExplicitFieldsProjectListPage),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("aYyVm")).LazyExplicitFieldsProjectListPromise)
            ]
        }));
});
parcelRegister("gB79g", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", ()=>$7a11591dcb8250ae$export$4f2c2d125c2b811a);
    var $65Ltd;
    const $7a11591dcb8250ae$export$4f2c2d125c2b811a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST),
        path: '/jira/settings/issues/explicit-field-association'
    };
});
parcelRegister("aYyVm", function(module, exports) {
    $parcel$export(module.exports, "LazyExplicitFieldsProjectListPromise", ()=>$95736e1c9d4aba6e$export$7b11685155ada84d);
    $parcel$export(module.exports, "LazyExplicitFieldsProjectListPage", ()=>$95736e1c9d4aba6e$export$e81c180c4f4833e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $95736e1c9d4aba6e$export$7b11685155ada84d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        return (0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7wmre")).then((bundle)=>bundle.ExplicitFieldAssociationProjectListApp));
    }, {
        moduleId: "./src/packages/admin-pages/explicit-field-association/project-list/src/index.tsx"
    });
    const $95736e1c9d4aba6e$export$e81c180c4f4833e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $95736e1c9d4aba6e$export$7b11685155ada84d,
            pageId: "jira-admin-pages-explicit-field-association-project-list",
            shouldShowSpinner: true
        });
});
parcelRegister("7wmre", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3r4bl")
    ]).then(()=>parcelRequire('61Yus'));
});
parcelRegister("5oFIy", function(module, exports) {
    $parcel$export(module.exports, "FireUiAnalytics", ()=>$3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
    $parcel$export(module.exports, "FireTrackAnalytics", ()=>$3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
    $parcel$export(module.exports, "FireOperationalAnalytics", ()=>$3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
    $parcel$export(module.exports, "FireScreenAnalytics", ()=>$3ea3e1dfbcd8cda6$export$2ccf161b817b43b);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $8zOmE;
    class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
            if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
            if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
            const eventNameSplit = eventName ? eventName.split(' ') : [];
            const action = actionProps || eventNameSplit[1];
            const actionSubject = actionSubjectProps || eventNameSplit[0];
            if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
            const actionSubjectId = actionSubjectIdProps || componentName;
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: action
            });
            (0, (0, parcelRequire("8zOmE")).fireAnalytics)(analyticsEvent, type, {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                attributes: attributes
            });
        }
        render() {
            return null;
        }
    }
    const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, (0, parcelRequire("cb25w")).default)()($3ea3e1dfbcd8cda6$var$FireComponent);
    const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
        });
    const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
        });
    const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$12346a674644c156)
        });
    const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
            eventName: "screen viewed"
        });
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("9NiTW", function(module, exports) {
    $parcel$export(module.exports, "checkAuthentication", ()=>$ad297a7f2ce81084$export$b8dbb7d6029c5413);
    $parcel$export(module.exports, "AuthenticationCheck", ()=>$ad297a7f2ce81084$export$e9b9096e887386fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $9OXo1;
    var $38Y30;
    const $ad297a7f2ce81084$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
    const $ad297a7f2ce81084$export$e9b9096e887386fe = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            if ($ad297a7f2ce81084$export$b8dbb7d6029c5413(tenantContext)) return children;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38Y30")).RedirectToLoginPage), null);
        });
});
parcelRegister("jacYd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kWrFZ"),
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4KqZA")
    ]).then(()=>parcelRequire('5tdjr'));
});
parcelRegister("1FeCu", function(module, exports) {
    $parcel$export(module.exports, "smartRepliesOptInStatusResources", ()=>$420bb98aaad6bbf4$export$d9a3116994d66cfc);
    $parcel$export(module.exports, "useSmartRepliesPreferencesResources", ()=>$420bb98aaad6bbf4$export$8d607fdbd07ed6ca);
    var $dJl1T;
    var $jcw0u;
    var $aHuqL;
    var $2M1hQ;
    var $2YP9W;
    const $420bb98aaad6bbf4$export$d9a3116994d66cfc = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $258f696a148ea88e$export$ea895d05049da93c),
        getKey: ()=>(0, $258f696a148ea88e$export$92a8ee31fa2d5df3),
        getData: async ()=>{
            let smartRepliesOptInStatus = null;
            try {
                smartRepliesOptInStatus = await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, $258f696a148ea88e$export$92a8ee31fa2d5df3));
            } catch (error) {
                if (error.statusCode !== 404) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $258f696a148ea88e$export$92a8ee31fa2d5df3), (0, $258f696a148ea88e$export$b8b9d90f9e5bd72b), error);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'smartRepliesOptInStatusResources',
                        packageName: (0, $258f696a148ea88e$export$b8b9d90f9e5bd72b),
                        teamName: 'jira-warepil'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                smartRepliesOptInStatus: smartRepliesOptInStatus
            };
        },
        maxAge: Number.MAX_VALUE
    });
    const $420bb98aaad6bbf4$export$8d607fdbd07ed6ca = ()=>{
        const { data: data, refresh: refresh, loading: loading } = (0, (0, parcelRequire("2YP9W")).useResource)($420bb98aaad6bbf4$export$d9a3116994d66cfc);
        return {
            isSmartRepliesPreferenceEnabled: data?.smartRepliesOptInStatus?.isEnabled ?? true,
            loading: loading,
            refreshData: refresh
        };
    };
});
const $258f696a148ea88e$export$92a8ee31fa2d5df3 = 'jira.user.smart_replies_feature.status';
const $258f696a148ea88e$export$ea895d05049da93c = 'RESOURCE_TYPE_ISSUE_SMART_REPLIES_STATUS';
const $258f696a148ea88e$export$b8b9d90f9e5bd72b = 'jiraIssueSmartRepliesPreferences';
parcelRegister("7DqiA", function(module, exports) {
    $parcel$export(module.exports, "EmbedModeContext", ()=>$208612f70b1dde3d$export$5eb07b3c7c0b0771);
    $parcel$export(module.exports, "EmbedModeProvider", ()=>$208612f70b1dde3d$export$9daaf42d62e1c430);
    var $5uXOq = parcelRequire("5uXOq");
    const $208612f70b1dde3d$export$5eb07b3c7c0b0771 = (0, $5uXOq.createContext)(false);
    const { Provider: $208612f70b1dde3d$var$Provider } = $208612f70b1dde3d$export$5eb07b3c7c0b0771;
    const $208612f70b1dde3d$var$handleEmbedLinkClick = (e)=>{
        const eventTarget = e.target;
        if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') eventTarget.target = '_blank';
    };
    const $208612f70b1dde3d$var$DarkModeMonolithStyleOverride = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `
                    #jira-frontend {
                        background: ${"var(--ds-surface-overlay, white)"};
                    }
                `
            }
        });
    const $208612f70b1dde3d$export$9daaf42d62e1c430 = ({ children: children })=>{
        (0, $5uXOq.useEffect)(()=>{
            window.addEventListener('click', $208612f70b1dde3d$var$handleEmbedLinkClick, true);
            return ()=>{
                window.removeEventListener('click', $208612f70b1dde3d$var$handleEmbedLinkClick);
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($208612f70b1dde3d$var$DarkModeMonolithStyleOverride, null), (0, ($parcel$interopDefault($5uXOq))).createElement($208612f70b1dde3d$var$Provider, {
            value: true
        }, children));
    };
});
parcelRegister("93Yeu", function(module, exports) {
    $parcel$export(module.exports, "useProjectKey", ()=>$5f0f9360597cdbd8$export$f87be37f8e8be65);
    $parcel$export(module.exports, "useProjectContextActions", ()=>$5f0f9360597cdbd8$export$bd73624ca941f105);
    $parcel$export(module.exports, "useProjectType", ()=>$5f0f9360597cdbd8$export$6de29d851c914935);
    $parcel$export(module.exports, "useProjectContext", ()=>$5f0f9360597cdbd8$export$8f31c2503e1efa93);
    $parcel$export(module.exports, "useApplication", ()=>$5f0f9360597cdbd8$export$aaf75bb403fe1fb5);
    $parcel$export(module.exports, "useEdition", ()=>$5f0f9360597cdbd8$export$d56c02945cf5a9e5);
    $parcel$export(module.exports, "useIsSimplifiedProject", ()=>$5f0f9360597cdbd8$export$524ef4f6102ed540);
    $parcel$export(module.exports, "useIsClassicProject", ()=>$5f0f9360597cdbd8$export$e2cf96f40a8867ce);
    $parcel$export(module.exports, "useProjectId", ()=>$5f0f9360597cdbd8$export$16d1475ed6c26568);
    $parcel$export(module.exports, "useProjectStatus", ()=>$5f0f9360597cdbd8$export$30f16f2782a4113b);
    $parcel$export(module.exports, "useProjectConfiguration", ()=>$5f0f9360597cdbd8$export$af19ad68b52fa1a6);
    $parcel$export(module.exports, "useProjectIssueTypes", ()=>$5f0f9360597cdbd8$export$80bef597b440cf71);
    var $5uXOq = parcelRequire("5uXOq");
    var $efvDm;
    var $ldyPw;
    var $g5X3G;
    var $9OXo1;
    var $buby4;
    var $1daUm;
    const $5f0f9360597cdbd8$export$f87be37f8e8be65 = (issueKey)=>(0, (0, parcelRequire("g5X3G")).toProjectKey)(issueKey.split('-')[0]);
    const $5f0f9360597cdbd8$export$bd73624ca941f105 = ()=>{
        const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, (0, parcelRequire("buby4")).useProjectContextActionStore)();
        const actions = (0, $5uXOq.useMemo)(()=>({
                setProjectContext: setProjectContext,
                mergeProjectProperty: mergeProjectProperty
            }), [
            setProjectContext,
            mergeProjectProperty
        ]);
        return [
            null,
            actions
        ];
    };
    const $5f0f9360597cdbd8$export$6de29d851c914935 = (projectKey)=>{
        const [projectType] = (0, (0, parcelRequire("buby4")).useProjectContextProjectTypeStore)({
            projectKey: projectKey
        });
        return projectType;
    };
    const $5f0f9360597cdbd8$export$8f31c2503e1efa93 = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext;
    };
    const $5f0f9360597cdbd8$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
        const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
        if (projectType === undefined) {
            if (failSafely) return undefined;
            throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
        }
        return (0, (0, parcelRequire("efvDm")).getApplicationForProject)(projectType);
    };
    const $5f0f9360597cdbd8$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
        const { appEditions: appEditions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const application = $5f0f9360597cdbd8$export$aaf75bb403fe1fb5(projectKey, failSafely);
        if (!application) return undefined;
        return (0, (0, parcelRequire("ldyPw")).getEdition)(application, appEditions);
    };
    const $5f0f9360597cdbd8$export$524ef4f6102ed540 = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.isSimplified || false;
    };
    const $5f0f9360597cdbd8$export$e2cf96f40a8867ce = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return !projectContext?.isSimplified;
    };
    const $5f0f9360597cdbd8$export$16d1475ed6c26568 = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.projectId;
    };
    const $5f0f9360597cdbd8$export$30f16f2782a4113b = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.projectStatus;
    };
    const $5f0f9360597cdbd8$export$af19ad68b52fa1a6 = (projectKey)=>{
        const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
        const isSimplified = $5f0f9360597cdbd8$export$524ef4f6102ed540(projectKey);
        return (0, (0, parcelRequire("1daUm")).getIssueConfiguration)({
            isSimplified: isSimplified,
            projectType: projectType
        });
    };
    const $5f0f9360597cdbd8$export$654dd2c557853fbe = (projectKey)=>{
        const [projectName] = (0, (0, parcelRequire("buby4")).useProjectContextProjectNameStore)({
            projectKey: projectKey
        });
        return projectName;
    };
    const $5f0f9360597cdbd8$export$80bef597b440cf71 = (projectKey)=>{
        const [issueTypes] = (0, (0, parcelRequire("buby4")).useProjectContextIssueTypesStore)({
            projectKey: projectKey
        });
        return issueTypes;
    };
});
parcelRegister("buby4", function(module, exports) {
    $parcel$export(module.exports, "useProjectContextActionStore", ()=>$42c27dedc1310bb2$export$9afb89c1fe103bbe);
    $parcel$export(module.exports, "useProjectContextStore", ()=>$42c27dedc1310bb2$export$8b09478b33186ec);
    $parcel$export(module.exports, "useProjectContextProjectTypeStore", ()=>$42c27dedc1310bb2$export$f2e1ed3b2b4707cb);
    $parcel$export(module.exports, "useProjectContextProjectNameStore", ()=>$42c27dedc1310bb2$export$9469fde70658518);
    $parcel$export(module.exports, "useProjectContextIssueTypesStore", ()=>$42c27dedc1310bb2$export$f73e9904779f6be5);
    var $3sQ5x;
    var $iXqE5;
    var $aDpiK;
    const $42c27dedc1310bb2$var$initialState = {};
    const $42c27dedc1310bb2$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'project-context',
        initialState: $42c27dedc1310bb2$var$initialState,
        actions: (0, parcelRequire("aDpiK"))
    });
    const $42c27dedc1310bb2$export$9afb89c1fe103bbe = (0, (0, parcelRequire("3sQ5x")).createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: null
    });
    const $42c27dedc1310bb2$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
    const $42c27dedc1310bb2$export$8b09478b33186ec = (0, (0, parcelRequire("3sQ5x")).createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getProjectContext
    });
    const $42c27dedc1310bb2$var$getProjectType = (state, { projectKey: projectKey })=>{
        const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.projectType;
    };
    const $42c27dedc1310bb2$export$f2e1ed3b2b4707cb = (0, (0, parcelRequire("3sQ5x")).createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getProjectType
    });
    const $42c27dedc1310bb2$var$getProjectName = (state, { projectKey: projectKey })=>{
        const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.projectName;
    };
    const $42c27dedc1310bb2$export$9469fde70658518 = (0, (0, parcelRequire("3sQ5x")).createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getProjectName
    });
    const $42c27dedc1310bb2$var$getIssueTypes = (state, { projectKey: projectKey })=>{
        const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.issueTypes;
    };
    const $42c27dedc1310bb2$export$f73e9904779f6be5 = (0, (0, parcelRequire("3sQ5x")).createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getIssueTypes
    });
});
parcelRegister("aDpiK", function(module, exports) {
    $parcel$export(module.exports, "setProjectContext", ()=>$ad16c28ce51d4ccf$export$d64151aab9ae5f09);
    $parcel$export(module.exports, "mergeProjectProperty", ()=>$ad16c28ce51d4ccf$export$78f1c6052937615f);
    const $ad16c28ce51d4ccf$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
            setState({
                [key]: projectContext
            });
        };
    const $ad16c28ce51d4ccf$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const currentProjectContext = currentState[key];
            const newProjectContext = {
                ...currentProjectContext,
                ...projectContext
            };
            setState({
                [key]: newProjectContext
            });
        };
});
parcelRegister("1daUm", function(module, exports) {
    $parcel$export(module.exports, "getIssueConfiguration", ()=>$7afb7a15cd46bd62$export$902f6c5cc939598a);
    var $65mz3;
    var $2vSU6;
    const $7afb7a15cd46bd62$export$cdbd1eb3b05729e0 = 'flagActions';
    const $7afb7a15cd46bd62$export$c161a774ec2e7e56 = 'cardCoverActions';
    const $7afb7a15cd46bd62$export$a52507e68e7aeeb = ()=>({
            issueActions: []
        });
    const $7afb7a15cd46bd62$export$381ce08838c53afa = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).CORE_ISSUE,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$27e0678365e5dcff = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SOFTWARE_ISSUE,
            issueActions: [
                $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$aebf676dfa727a1c = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SIMPLE_SOFTWARE_BOARD,
            issueActions: [
                $7afb7a15cd46bd62$export$cdbd1eb3b05729e0,
                $7afb7a15cd46bd62$export$c161a774ec2e7e56
            ],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$1afca4d3eb6b218b = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).STANDARD_ROADMAP_ISSUE,
            issueActions: [
                $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$8a060ed6f66c43b0 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).BITBUCKET_ISSUE,
            issueActions: []
        });
    const $7afb7a15cd46bd62$export$78a2cb921e46f5eb = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).MOBILE_ISSUE,
            issueActions: []
        });
    const $7afb7a15cd46bd62$export$db1115186532f6d5 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SERVICE_DESK,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$902f6c5cc939598a = (config)=>{
        if (config) switch(config.projectType){
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if (config.isSimplified) return $7afb7a15cd46bd62$export$aebf676dfa727a1c();
                return $7afb7a15cd46bd62$export$27e0678365e5dcff();
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return $7afb7a15cd46bd62$export$381ce08838c53afa();
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return $7afb7a15cd46bd62$export$db1115186532f6d5();
            default:
                return $7afb7a15cd46bd62$export$27e0678365e5dcff();
        }
        return $7afb7a15cd46bd62$export$27e0678365e5dcff();
    };
});
parcelRegister("65mz3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7178ba5d31d0f054$export$2e2bcd8739ae039);
    const $7178ba5d31d0f054$var$keys = {
        CONNECT_ISSUE: 'connect-issue',
        BITBUCKET_ISSUE: 'bitbucket-issue',
        CORE_ISSUE: 'core-issue',
        MOBILE_ISSUE: 'mobile-issue',
        SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
        SOFTWARE_ISSUE: 'software-issue',
        STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
        SERVICE_DESK: 'service-desk',
        EMPTY_APPLICATION_KEY: ''
    };
    var $7178ba5d31d0f054$export$2e2bcd8739ae039 = $7178ba5d31d0f054$var$keys;
});
parcelRegister("dAfqg", function(module, exports) {
    $parcel$export(module.exports, "useProjectContext", ()=>$0baaa0dcf730951a$export$8f31c2503e1efa93);
    $parcel$export(module.exports, "useIsSimplifiedProject", ()=>$0baaa0dcf730951a$export$524ef4f6102ed540);
    $parcel$export(module.exports, "ProjectContextProvider", ()=>$0baaa0dcf730951a$export$a85f6b5857d2176);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $dxCvy;
    const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
        const { data: data, error: error, loading: loading, update: update, key: key } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache), customContext);
        const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
            update
        ]);
        return {
            data: data,
            error: error,
            loading: loading,
            updateCache: updateCache,
            key: key
        };
    };
    const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
        const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
        return data?.simplified || false;
    };
    const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
        const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
        return children(projectContext);
    };
});
parcelRegister("8ZUng", function(module, exports) {
    $parcel$export(module.exports, "issueViewRelayResource", ()=>$e05b8d0e5bf08042$export$55131006e6699c0a);
    $parcel$export(module.exports, "useIssueViewRelayRouteResource", ()=>$e05b8d0e5bf08042$export$252bdba8c8e5f066);
    var $3Mzpf;
    var $k3PbQ;
    var $6yLM4;
    var $ao2h1;
    var $la3vp;
    var $2Yhep;
    var $2M1hQ;
    var $5XgeZ;
    const $e05b8d0e5bf08042$var$getDataLoader = ()=>(parcelRequire("3fjvV"));
    const $e05b8d0e5bf08042$export$5ce473a762cc813e = (0, (0, parcelRequire("2M1hQ")).createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_AGG_DATA',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getDataLoader: $e05b8d0e5bf08042$var$getDataLoader,
        maxAge: (0, (0, parcelRequire("5XgeZ")).MIN_MAX_AGE),
        isBrowserOnly: true
    }));
    const $e05b8d0e5bf08042$export$55131006e6699c0a = (0, (0, parcelRequire("5XgeZ")).createRelayResourceDeprecated)({
        type: 'ISSUE_RELAY_DATA',
        isBrowserOnly: true,
        captureErrors: true,
        captureTraceIds: !false,
        getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
            const { match: match } = routerContext;
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            const siteAri = (0, (0, parcelRequire("3Mzpf")).JiraSiteAri).create({
                siteId: cloudId
            }).toString();
            const projectKey = issueKey ? (0, (0, parcelRequire("k3PbQ")).extractProjectKey)(issueKey) : '';
            const queryVariables = {
                cloudId: cloudId,
                issueKey: issueKey || '',
                projectKey: projectKey,
                siteAri: siteAri
            };
            return {
                parameters: (0, (0, parcelRequire("la3vp")).default),
                variables: {
                    ...queryVariables,
                    ...(0, (0, parcelRequire("6yLM4")).getMainIssueViewAggQueryVariables)()
                },
                keyVariables: {
                    ...queryVariables,
                    ...(0, (0, parcelRequire("6yLM4")).getMainIssueViewAggQueryFeatureFlagVariables)()
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
    const $e05b8d0e5bf08042$export$252bdba8c8e5f066 = (options)=>(0, (0, parcelRequire("ao2h1")).useRelayResource)($e05b8d0e5bf08042$export$55131006e6699c0a, options);
});
parcelRegister("3Mzpf", function(module, exports) {
    $parcel$export(module.exports, "JiraSiteAri", ()=>$2c1151bb17cb172c$export$6c0f81f222d09301);
    var $gQC3n;
    var $9KGzW;
    var $1C2Ux;
    var $2c1151bb17cb172c$var$jiraSiteAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^$"),
        resourceOwner: (0, (0, parcelRequire("gQC3n")).JiraSiteAriResourceOwner),
        resourceType: (0, (0, parcelRequire("gQC3n")).JiraSiteAriResourceType),
        resourceIdSlug: "{siteId}",
        resourceIdSegmentFormats: {
            siteId: /[a-zA-Z0-9_\-.]{1,255}/
        }
    };
    var $2c1151bb17cb172c$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.resourceIdSegmentValues.siteId;
        }
        get siteId() {
            return this._siteId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.qualifier,
                platformQualifier: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.platformQualifier,
                cloudId: void 0,
                resourceOwner: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.resourceOwner,
                resourceType: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.resourceType,
                resourceId: `${opts.siteId}`,
                resourceIdSegmentValues: {
                    siteId: opts.siteId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $2c1151bb17cb172c$var$jiraSiteAriStaticOpts);
            return new _JiraSiteAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $2c1151bb17cb172c$var$jiraSiteAriStaticOpts);
            return new _JiraSiteAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId
            };
        }
    };
});
parcelRegister("gQC3n", function(module, exports) {
    $parcel$export(module.exports, "JiraSiteAriResourceOwner", ()=>$032a4e897fcecef5$export$b7d590981b504412);
    $parcel$export(module.exports, "JiraSiteAriResourceType", ()=>$032a4e897fcecef5$export$886165a991f21644);
    var $032a4e897fcecef5$export$b7d590981b504412 = "jira", $032a4e897fcecef5$export$886165a991f21644 = "site";
});
parcelRegister("k3PbQ", function(module, exports) {
    $parcel$export(module.exports, "extractProjectKey", ()=>$bfdd97e245e93328$export$f1a2e4721b127828);
    var $g5X3G;
    const $bfdd97e245e93328$export$f1a2e4721b127828 = (issueKey)=>(0, (0, parcelRequire("g5X3G")).toProjectKey)(issueKey.split('-')[0]);
});
parcelRegister("6yLM4", function(module, exports) {
    $parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", ()=>$bbb83ac7c9853fc8$export$3dd406718c5846c6);
    $parcel$export(module.exports, "getMainIssueViewAggQueryVariables", ()=>$bbb83ac7c9853fc8$export$5896c8dc13246fe2);
    var $f9Owr;
    var $4R6GH;
    var $6tI1D;
    const $bbb83ac7c9853fc8$var$_unused = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jiv-19486-allow-fg-usage-in-early-scripts');
    const $bbb83ac7c9853fc8$export$3dd406718c5846c6 = ()=>({
            isCompassComponentsEnabled: (0, (0, parcelRequire("f9Owr")).ff)('compass-components-in-jira-components_xw42u', false),
            giraAGGMigrationCommentsFlag: (0, (0, parcelRequire("4R6GH")).fg)('jiv-14067-issue-details-agg-migration-comments') || (0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-14530-comments-consistency-check'),
            jsmSentimentCustomFieldFlag: true,
            isJPDPanelEnabled: (0, (0, parcelRequire("f9Owr")).ff)('polaris.jpd-panel-in-issue-view', false),
            issueViewRelayPriorityFieldFlag: (0, (0, parcelRequire("4R6GH")).fg)('relay-migration-issue-fields-priority'),
            issueViewRelayAssigneeFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-assignee-ld', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-reporter_jfzs2', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-user', false),
            issueViewRelayNumberFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-number_q0em4', false),
            issueViewRelaySprintFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-sprint_jozpu', false),
            issueViewRelayAttachmentsFlag: (0, (0, parcelRequire("4R6GH")).fg)('relay-migration-issue-view-attachments-'),
            issueViewRelaySingleLineTextFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-single-line-text_in6w6', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-single-line-text-message', false),
            issueViewRelayDateFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-date_ptj72', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsparent: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-parent_5p1ac', false),
            issueViewRelayParentFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-parent_5p1ac', false),
            issueViewRelayProjectFieldFlag: (0, (0, parcelRequire("4R6GH")).fg)('relay-migration-issue-fields-project-select'),
            issueViewRelayDateTimeFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-date-time_eaqd2', false),
            issueViewRelayMetadataFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-metadata_d42b0', false),
            issueViewDesignsPanelFlag: (0, (0, parcelRequire("4R6GH")).fg)('make_designs_panel_in_issue_view_synchronous'),
            isJPDDeliveryLinkTypeFilteringEnabled: (0, (0, parcelRequire("f9Owr")).ff)('polaris.jpd-panel-in-issue-view', false),
            issueViewImproveIssueDropdownFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('issue-view.enable-search-by-email-in-multiselect-user-picker-field', false) && (0, (0, parcelRequire("f9Owr")).getMultivariateFeatureFlag)('issue.details.gira-agg-consistency-check-master-flag', 'OLD', [
                'OLD',
                'NEW',
                'CHECK',
                'CHECK_RETURN_NEW'
            ]) !== 'NEW',
            issueViewIsAiEnabledOnProject: (0, (0, parcelRequire("f9Owr")).getMultivariateFeatureFlag)('issue.details.gira-agg-consistency-check-master-flag', 'OLD', [
                'OLD',
                'NEW',
                'CHECK',
                'CHECK_RETURN_NEW'
            ]) === 'NEW',
            issueViewRelayUrlFieldFlag: (0, (0, parcelRequire("4R6GH")).fg)('relay-migration-issue-fields-url'),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-assignee-ld', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsreporterrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-reporter_jfzs2', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsuserrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-user', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssecuritylevelrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-security-level_7y5uv', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscheckboxselectrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-checkbox-select_ytl5n', false),
            issueViewRelaySummaryFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-summary_eog1v', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsoriginalestimaterelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-original-estimate_eb4wv', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssinglelinetextmessagerelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-single-line-text-message', false),
            issueViewRelayColorFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-color_wrbay', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-time-tracking_eefh0', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldspeoplerelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-people', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsapproversrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-approvers', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldswatchersrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-watchers_iqhn4', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsheaderactionsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-watchers_iqhn4', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-security-level_7y5uv', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsvotesrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-votes_nsbqd', false),
            issueViewRelayHeaders: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-watchers_iqhn4', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-parent_5p1ac', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-security-level_7y5uv', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-votes_nsbqd'),
            issueViewRelayPeopleAndApproversFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-people', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-approvers', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscomponentsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-components-select_prpz1', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsteamrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-team-field-next_nctbt', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-multi-user', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-participants', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrequestparticipantsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-multi-user', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-participants', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-request-participants_itocm', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrequestparticipantsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-request-participants_itocm', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuetypeswitcherrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-issue-type-switcher_l0lrt', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsresolutionrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-resolution_86iya', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrichtextrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-issue-multi-line-text_w69oo', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultigrouppickerrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-multi-group-picker', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsgrouppickerrelayprovider: (0, (0, parcelRequire("4R6GH")).fg)('relay-migration-issue-fields-group-picker-sg'),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-status_qg82c', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatuspanelrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-resolution_86iya', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-status_qg82c', false),
            issueViewRelayTimeTrackingFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-time-tracking_eefh0', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsradioselectrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-radio_6gqb3', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuerestrictionsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-issue-restrictions_yudid', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider: (0, (0, parcelRequire("4R6GH")).fg)('issue_view_field_config_edit'),
            customFieldConfigurationFlag: (0, (0, parcelRequire("4R6GH")).fg)('issue_view_field_config_edit'),
            __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone1experimentrelayprovider: (0, (0, parcelRequire("4R6GH")).fg)('thor_colourful_single_select_milestone1_gate'),
            isPinFieldConfigurabilityEnabled: (0, (0, parcelRequire("4R6GH")).fg)('pin_fields_ga') || (0, (0, parcelRequire("f9Owr")).ff)('pin_field_exp_launch_darkly_flag_ef4mc'),
            jcsIssueLayoutEapFlag: (0, (0, parcelRequire("4R6GH")).fg)('jcs_issue_layout_eap'),
            issueViewSmartRepliesSettingsFlag: (0, (0, parcelRequire("4R6GH")).fg)('smart-replies-system-setting') ?? false
        });
    const $bbb83ac7c9853fc8$export$5896c8dc13246fe2 = ()=>({
            ...$bbb83ac7c9853fc8$export$3dd406718c5846c6(),
            ...$bbb83ac7c9853fc8$export$afa6e4ae995b8926()
        });
    const $bbb83ac7c9853fc8$export$afa6e4ae995b8926 = ()=>({
            commentTargetId: (0, (0, parcelRequire("4R6GH")).fg)('jiv-14067-issue-details-agg-migration-comments') || (0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-14530-comments-consistency-check') ? (0, (0, parcelRequire("6tI1D")).getPermalinkId)((0, (0, parcelRequire("6tI1D")).COMMENTS)) || null : null
        });
});
parcelRegister("6tI1D", function(module, exports) {
    $parcel$export(module.exports, "COMMENTS", ()=>$ac458c74e4b12b29$export$4cab9dfa8fc858f4);
    $parcel$export(module.exports, "WORKLOG", ()=>$ac458c74e4b12b29$export$df36fc05622c402);
    $parcel$export(module.exports, "getAllUrlParams", ()=>$ac458c74e4b12b29$export$dca91ad250f6b082);
    $parcel$export(module.exports, "getPermalinkId", ()=>$ac458c74e4b12b29$export$bf42dbba4c31080e);
    var $gKZoD;
    var $dJl1T;
    const $ac458c74e4b12b29$export$b18d061fc042df1a = {
        COMMENTS: 'focusedCommentId',
        WORKLOG: 'focusedWorklogId'
    };
    const $ac458c74e4b12b29$export$4cab9dfa8fc858f4 = 'COMMENTS';
    const $ac458c74e4b12b29$export$df36fc05622c402 = 'WORKLOG';
    const $ac458c74e4b12b29$export$dca91ad250f6b082 = ()=>{
        (0, (0, parcelRequire("gKZoD")).di)(window);
        let queryString = window.location.search.slice(1);
        const obj = {};
        if (queryString) {
            queryString = queryString.split('#')[0];
            const arr = queryString.split('&');
            for(let i = 0; i < arr.length; i += 1){
                const a = arr[i].split('=');
                const paramName = a[0];
                try {
                    const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                    obj[paramName] = paramValue;
                } catch (error) {
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
                }
            }
        }
        return obj;
    };
    const $ac458c74e4b12b29$export$bf42dbba4c31080e = (targetPermalinkType)=>{
        if (!$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]) return null;
        const urlParams = $ac458c74e4b12b29$export$dca91ad250f6b082();
        return urlParams[$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]];
    };
});
parcelRegister("la3vp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d1e3365ed212162$export$2e2bcd8739ae039);
    var $asT4T;
    var $hBTVA;
    var $9OzGv;
    var $33qJ8;
    var $h6nNu;
    var $5pSyb;
    var $cKVMM;
    var $5mEVc;
    var $ef20f;
    var $84KW9;
    var $3wM25;
    var $ipyFC;
    var $kT0rw;
    var $d6bux;
    var $bdIYk;
    var $hjJTo;
    var $jDqgH;
    var $iwPkC;
    var $krohK;
    var $6NR1m;
    var $3E2yq;
    var $6sYK2;
    var $fmbEw;
    var $hSNvs;
    var $qPPmw;
    var $8Y9hN;
    var $4yni1;
    var $ejqaS;
    var $eXeEx;
    var $lWBBz;
    const $7d1e3365ed212162$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "c181d7b7ccd19edd1c7b84b1fa61ceed2dffc08b1673f72f118b06a0031af2b3",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "issueByKey",
                            "attachments"
                        ]
                    }
                ]
            },
            "name": "mainIssueAggQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsparent": (0, (0, parcelRequire("d6bux")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingrelayprovider": (0, (0, parcelRequire("8Y9hN")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscheckboxselectrelayprovider": (0, (0, parcelRequire("9OzGv")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscomponentsrelayprovider": (0, (0, parcelRequire("33qJ8")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsoriginalestimaterelayprovider": (0, (0, parcelRequire("kT0rw")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrequestparticipantsrelayprovider": (0, (0, parcelRequire("3wM25")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsgrouppickerrelayprovider": (0, (0, parcelRequire("5pSyb")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultigrouppickerrelayprovider": (0, (0, parcelRequire("84KW9")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsteamrelayprovider": (0, (0, parcelRequire("qPPmw")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsradioselectrelayprovider": (0, (0, parcelRequire("hjJTo")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrichtextrelayprovider": (0, (0, parcelRequire("6NR1m")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrelayprovider": (0, (0, parcelRequire("ipyFC")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrequestparticipantsrelayprovider": (0, (0, parcelRequire("iwPkC")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldspeoplerelayprovider": (0, (0, parcelRequire("bdIYk")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsapproversrelayprovider": (0, (0, parcelRequire("asT4T")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, (0, parcelRequire("h6nNu")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssinglelinetextmessagerelayprovider": (0, (0, parcelRequire("6sYK2")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider": (0, (0, parcelRequire("hBTVA")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsreporterrelayprovider": (0, (0, parcelRequire("jDqgH")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsuserrelayprovider": (0, (0, parcelRequire("4yni1")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone1experimentrelayprovider": (0, (0, parcelRequire("lWBBz")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsheaderactionsrelayprovider": (0, (0, parcelRequire("cKVMM")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldswatchersrelayprovider": (0, (0, parcelRequire("eXeEx")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssecuritylevelrelayprovider": (0, (0, parcelRequire("3E2yq")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsvotesrelayprovider": (0, (0, parcelRequire("ejqaS")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuerestrictionsrelayprovider": (0, (0, parcelRequire("5mEVc")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuetypeswitcherrelayprovider": (0, (0, parcelRequire("ef20f")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsresolutionrelayprovider": (0, (0, parcelRequire("krohK")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider": (0, (0, parcelRequire("hSNvs")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatuspanelrelayprovider": (0, (0, parcelRequire("fmbEw")).default)
            }
        }
    };
    var $7d1e3365ed212162$export$2e2bcd8739ae039 = $7d1e3365ed212162$var$node;
});
parcelRegister("asT4T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$587bfe0115b03c48$export$2e2bcd8739ae039);
    var $co1wz;
    var $587bfe0115b03c48$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-approvers');
        }
    };
});
parcelRegister("hBTVA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$317518afb86d429d$export$2e2bcd8739ae039);
    var $co1wz;
    var $317518afb86d429d$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-assignee-ld');
        }
    };
});
parcelRegister("9OzGv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68a7d680b4f7aa31$export$2e2bcd8739ae039);
    var $co1wz;
    var $68a7d680b4f7aa31$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-checkbox-select_ytl5n');
        }
    };
});
parcelRegister("33qJ8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a066af595fad6e31$export$2e2bcd8739ae039);
    var $co1wz;
    var $a066af595fad6e31$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-components-select_prpz1');
        }
    };
});
parcelRegister("h6nNu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ea05c28112074d6$export$2e2bcd8739ae039);
    var $4R6GH;
    const $4ea05c28112074d6$var$isIssueViewFieldConfigEditEnabled = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('issue_view_field_config_edit');
        }
    };
    var $4ea05c28112074d6$export$2e2bcd8739ae039 = $4ea05c28112074d6$var$isIssueViewFieldConfigEditEnabled;
});
parcelRegister("5pSyb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46b71e3be8dfea7a$export$2e2bcd8739ae039);
    var $4R6GH;
    var $46b71e3be8dfea7a$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('relay-migration-issue-fields-group-picker-sg');
        }
    };
});
parcelRegister("cKVMM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7153ac791d0f4b40$export$2e2bcd8739ae039);
    var $co1wz;
    var $7153ac791d0f4b40$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-security-level_7y5uv') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-watchers_iqhn4') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-votes_nsbqd');
        }
    };
});
parcelRegister("5mEVc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dba981d8b012adb8$export$2e2bcd8739ae039);
    var $co1wz;
    var $dba981d8b012adb8$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-issue-restrictions_yudid');
        }
    };
});
parcelRegister("ef20f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5dac75eea754d44b$export$2e2bcd8739ae039);
    var $co1wz;
    var $5dac75eea754d44b$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-issue-type-switcher_l0lrt');
        }
    };
});
parcelRegister("84KW9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78c1aa824cd21c11$export$2e2bcd8739ae039);
    var $co1wz;
    var $78c1aa824cd21c11$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-multi-group-picker');
        }
    };
});
parcelRegister("3wM25", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b4f763f7ab8915ff$export$2e2bcd8739ae039);
    var $co1wz;
    var $b4f763f7ab8915ff$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-multi-user') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-participants') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-request-participants_itocm');
        }
    };
});
parcelRegister("ipyFC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de9ca17802c9cba7$export$2e2bcd8739ae039);
    var $co1wz;
    var $de9ca17802c9cba7$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-multi-user') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-participants');
        }
    };
});
parcelRegister("kT0rw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4cdff8c37120a188$export$2e2bcd8739ae039);
    var $co1wz;
    var $4cdff8c37120a188$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-original-estimate_eb4wv');
        }
    };
});
parcelRegister("d6bux", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d9e6f2a33f8172f$export$2e2bcd8739ae039);
    var $co1wz;
    var $4d9e6f2a33f8172f$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-parent_5p1ac');
        }
    };
});
parcelRegister("bdIYk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3216c683ee81b04$export$2e2bcd8739ae039);
    var $co1wz;
    var $d3216c683ee81b04$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-people');
        }
    };
});
parcelRegister("hjJTo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8a929bbaac9d588$export$2e2bcd8739ae039);
    var $co1wz;
    var $c8a929bbaac9d588$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-radio_6gqb3');
        }
    };
});
parcelRegister("jDqgH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$144d769a6379ff4e$export$2e2bcd8739ae039);
    var $co1wz;
    var $144d769a6379ff4e$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-reporter_jfzs2');
        }
    };
});
parcelRegister("iwPkC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb870d58c524b581$export$2e2bcd8739ae039);
    var $co1wz;
    var $cb870d58c524b581$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-request-participants_itocm');
        }
    };
});
parcelRegister("krohK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ee92d752c596813$export$2e2bcd8739ae039);
    var $co1wz;
    var $7ee92d752c596813$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-resolution_86iya');
        }
    };
});
parcelRegister("6NR1m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$851058f7192cd7ee$export$2e2bcd8739ae039);
    var $co1wz;
    var $851058f7192cd7ee$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-issue-multi-line-text_w69oo');
        }
    };
});
parcelRegister("3E2yq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$847675c0acc8db9e$export$2e2bcd8739ae039);
    var $co1wz;
    var $847675c0acc8db9e$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-security-level_7y5uv');
        }
    };
});
parcelRegister("6sYK2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab91eec7ddbe8f3e$export$2e2bcd8739ae039);
    var $co1wz;
    var $ab91eec7ddbe8f3e$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-single-line-text-message');
        }
    };
});
parcelRegister("fmbEw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afb9a48dda30cc33$export$2e2bcd8739ae039);
    var $co1wz;
    var $afb9a48dda30cc33$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-resolution_86iya', false) || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-status_qg82c', false);
        }
    };
});
parcelRegister("hSNvs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efddcea96d8714d0$export$2e2bcd8739ae039);
    var $co1wz;
    var $efddcea96d8714d0$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-status_qg82c');
        }
    };
});
parcelRegister("qPPmw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0786657423f5409$export$2e2bcd8739ae039);
    var $co1wz;
    var $e0786657423f5409$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-team-field-next_nctbt');
        }
    };
});
parcelRegister("8Y9hN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb6d2edf34e99bba$export$2e2bcd8739ae039);
    var $co1wz;
    var $eb6d2edf34e99bba$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-time-tracking_eefh0');
        }
    };
});
parcelRegister("4yni1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5243bedb3fa46125$export$2e2bcd8739ae039);
    var $co1wz;
    var $5243bedb3fa46125$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-user');
        }
    };
});
parcelRegister("ejqaS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7323747132cbc58$export$2e2bcd8739ae039);
    var $co1wz;
    var $c7323747132cbc58$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-votes_nsbqd');
        }
    };
});
parcelRegister("eXeEx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$acfad9d58e7d968c$export$2e2bcd8739ae039);
    var $co1wz;
    var $acfad9d58e7d968c$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-watchers_iqhn4');
        }
    };
});
parcelRegister("lWBBz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$545f86f6cc4b6952$export$2e2bcd8739ae039);
    var $4R6GH;
    var $545f86f6cc4b6952$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('thor_colourful_single_select_milestone1_gate');
        }
    };
});
parcelRegister("2Yhep", function(module, exports) {
    $parcel$export(module.exports, "getIssueKey", ()=>$05d1e79edcc0dc56$export$4a030f6192bebe03);
    const $05d1e79edcc0dc56$export$4a030f6192bebe03 = (match)=>{
        const fromMatch = match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : null;
        return fromMatch;
    };
});
parcelRegister("5XgeZ", function(module, exports) {
    $parcel$export(module.exports, "MIN_MAX_AGE", ()=>$36d3fb93786ec5e2$export$5664a170ac5a9781);
    $parcel$export(module.exports, "withResourceEarlyData", ()=>$36d3fb93786ec5e2$export$22da5fb8c8200986);
    $parcel$export(module.exports, "createRelayResourceDeprecated", ()=>$36d3fb93786ec5e2$export$2e279339bedcd427);
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $x9xyg;
    var $4R6GH;
    var $5yJb9;
    var $5a0Nh;
    var $kipqU;
    var $2M1hQ;
    var $5Wobd;
    const $36d3fb93786ec5e2$export$5664a170ac5a9781 = 5000;
    const $36d3fb93786ec5e2$export$22da5fb8c8200986 = ({ type: type, getData: next, getDataLoader: getDataLoader, ...rest })=>{
        const getData = (...args)=>{
            performance.mark(`issueViewEarlyScripts:${type}:withResourceEarlyData:called`);
            if (!false && type in window) {
                const promise = window[type];
                delete window[type];
                getDataLoader && promise.then(getDataLoader);
                return promise;
            }
            if (getDataLoader) return getDataLoader().then(({ default: getDataPromise })=>getDataPromise(...args));
            return next && next(...args);
        };
        return {
            ...rest,
            type: type,
            getData: getData
        };
    };
    const $36d3fb93786ec5e2$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
    const $36d3fb93786ec5e2$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: `${$36d3fb93786ec5e2$export$c6c8c12c0f1d8e54}_${type}`,
            getKey: (routerContext, customContext)=>{
                const { parameters: preloadableRequest, variables: queryVariables, keyVariables: keyVariables } = getQuery(routerContext, customContext);
                const variables = (0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-14530-comments-consistency-check') || (0, (0, parcelRequire("4R6GH")).fg)('jiv-14067-issue-details-agg-migration-comments') ? keyVariables || queryVariables : queryVariables;
                if (!preloadableRequest) return JSON.stringify(variables || {});
                let queryId;
                let params;
                if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                    const preloadableConcreteRequest = preloadableRequest;
                    ({ params: params } = preloadableConcreteRequest);
                    ({ id: queryId } = params);
                } else {
                    const graphQlTaggedNode = preloadableRequest;
                    const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                    params = request.params;
                    queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
                }
                return `${String(queryId)}${JSON.stringify(variables || {})}`;
            },
            getData: async (routerContext, customContext)=>{
                const measureName = `relay_resource_get_data:${type}`;
                const startMark = `relay_resource_get_data:${type}:start`;
                const endMark = `relay_resource_get_data:${type}:end`;
                (0, (0, parcelRequire("x9xyg")).setMark)(startMark);
                const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
                const query = parameters ?? await loadParameters?.();
                const queryReference = (0, (0, parcelRequire("x9xyg")).measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), query, variables || {}, options));
                if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
                if (queryReference.id != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id)?.then(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
                    (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
                });
                if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
                if (captureTraceIds) (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(queryReference.name);
                return queryReference;
            },
            maxAge: 0,
            isBrowserOnly: isBrowserOnly
        });
    const $36d3fb93786ec5e2$export$2e279339bedcd427 = $36d3fb93786ec5e2$var$createRelayResourceImpl;
});
parcelRegister("3fjvV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aT8lA").then(()=>parcelRequire('jj7my'));
});
parcelRegister("5CPDv", function(module, exports) {
    $parcel$export(module.exports, "issueForgeDataResource", ()=>$82acf7aa3865e452$export$e28b79684fb81535);
    var $2Yhep;
    var $2M1hQ;
    var $jj8CY;
    const $82acf7aa3865e452$export$e28b79684fb81535 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ISSUE_FORGE_DATA',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: (...args)=>(0, (0, parcelRequire("jj8CY")).default)(...args),
        isBrowserOnly: true
    });
});
parcelRegister("jj8CY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a39eb6eca9b1263$export$2e2bcd8739ae039);
    var $4R6GH;
    var $hpuF5;
    var $iR3GG;
    var $2Yhep;
    var $3a39eb6eca9b1263$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
        const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
        if (!issueKey) return null;
        try {
            const { cloudId: cloudId, activationId: activationId, isAnonymous: isAnonymous, locale: locale } = tenantContext;
            const data = (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') ? await (0, (0, parcelRequire("hpuF5")).fetchIssueForgeDataV2)(cloudId, issueKey, isAnonymous) : await (0, (0, parcelRequire("hpuF5")).fetchIssueForgeDataV1)(cloudId, issueKey, activationId, locale);
            return data;
        } catch (error) {
            throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.issue-view.forge.getData',
                message: 'An error was thrown while prefetching issue Forge data',
                name: 'ResourceError'
            }, error);
        }
    };
});
parcelRegister("hpuF5", function(module, exports) {
    $parcel$export(module.exports, "fetchIssueForgeDataV1", ()=>$b0a1cdd28321d25a$export$e286ab7be9b90b73);
    $parcel$export(module.exports, "fetchIssueForgeDataV2", ()=>$b0a1cdd28321d25a$export$2a07b9ab3de7be30);
    var $k2DRb;
    var $5cmSg;
    var $5vSAE;
    var $iVaKa;
    var $7kNct;
    const $b0a1cdd28321d25a$export$7c6ea4184129ef74 = (result, type)=>result.find((extensions)=>extensions.some((extension)=>extension.type === type)) || [];
    const $b0a1cdd28321d25a$export$e286ab7be9b90b73 = async (cloudId, issueKey, activationId, locale)=>{
        const modulesToFetch = [
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTION_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_GLANCE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_CONTEXT_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTIVITY_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
            (0, (0, parcelRequire("k2DRb")).UI_MODIFICATIONS_MODULE)
        ];
        const contextIds = [
            `ari:cloud:jira:${cloudId}:workspace/${activationId}`
        ];
        const result = await (0, (0, parcelRequire("iVaKa")).default)(cloudId, modulesToFetch, {
            issueKey: issueKey
        }, {
            include: {
                scopes: true
            }
        }, (0, (0, parcelRequire("k2DRb")).SOURCE_ISSUE_VIEW), contextIds, locale);
        const { extensions: extensions, accessNarrowedExtensions: accessNarrowedExtensions } = result;
        const mappedResult = {
            issueAction: extensions.jiraIssueAction || [],
            issueGlance: extensions.jiraIssueGlance || [],
            issueContext: extensions.jiraIssueContext || [],
            issuePanel: extensions.jiraIssuePanel || [],
            issueActivity: extensions.jiraIssueActivity || [],
            customField: extensions.jiraCustomField || [],
            customFieldType: extensions.jiraCustomFieldType || [],
            issueViewBackgroundScript: extensions.jiraIssueViewBackgroundScript || [],
            uiModifications: extensions.jiraUiModifications || [],
            blockedExtensions: {
                issueAction: accessNarrowedExtensions.jiraIssueAction || [],
                issueGlance: accessNarrowedExtensions.jiraIssueGlance || [],
                issueContext: accessNarrowedExtensions.jiraIssueContext || [],
                issuePanel: accessNarrowedExtensions.jiraIssuePanel || [],
                issueActivity: accessNarrowedExtensions.jiraIssueActivity || [],
                customField: accessNarrowedExtensions.jiraCustomField || [],
                customFieldType: accessNarrowedExtensions.jiraCustomFieldType || [],
                issueViewBackgroundScript: accessNarrowedExtensions.jiraIssueViewBackgroundScript || [],
                uiModifications: accessNarrowedExtensions.jiraUiModifications || []
            }
        };
        return (0, (0, parcelRequire("7kNct")).dedupeContextAndGlance)(mappedResult);
    };
    const $b0a1cdd28321d25a$export$2a07b9ab3de7be30 = async (cloudId, issueKey, isAnonymous)=>{
        const extensions = await (0, (0, parcelRequire("5vSAE")).fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, (0, parcelRequire("k2DRb")).ISSUE_ACTION_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_GLANCE_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_CONTEXT_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_ACTIVITY_MODULE),
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
                (0, (0, parcelRequire("k2DRb")).UI_MODIFICATIONS_MODULE)
            ],
            context: {
                issueKey: issueKey
            },
            includeHidden: true,
            includeScopes: true,
            source: (0, (0, parcelRequire("k2DRb")).SOURCE_ISSUE_VIEW)
        });
        const getFilteredExtensions = (filterFn)=>({
                issueAction: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_ACTION_MODULE].filter(filterFn),
                issueGlance: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_GLANCE_MODULE].filter(filterFn),
                issueContext: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_CONTEXT_MODULE].filter(filterFn),
                issuePanel: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE].filter(filterFn),
                issueActivity: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_ACTIVITY_MODULE].filter(filterFn),
                customField: extensions[0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE].filter(filterFn),
                customFieldType: extensions[0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE].filter(filterFn),
                issueViewBackgroundScript: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE].filter(filterFn),
                uiModifications: extensions[0, (0, parcelRequire("k2DRb")).UI_MODIFICATIONS_MODULE].filter(filterFn)
            });
        const mappedResult = {
            ...getFilteredExtensions((extension)=>!(0, (0, parcelRequire("5cmSg")).isExtensionHiddenByAppAccessRules)(extension)),
            blockedExtensions: {
                ...getFilteredExtensions((extension)=>(0, (0, parcelRequire("5cmSg")).isExtensionHiddenByAppAccessRules)(extension))
            }
        };
        return (0, (0, parcelRequire("7kNct")).dedupeContextAndGlance)(mappedResult);
    };
});
parcelRegister("5cmSg", function(module, exports) {
    $parcel$export(module.exports, "isExtensionVisible", ()=>$30771269db74e480$export$41e48b53c2cc2013);
    $parcel$export(module.exports, "isExtensionHidden", ()=>$30771269db74e480$export$3f5b3e61d567ef3);
    $parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", ()=>$30771269db74e480$export$5c38dfa9d1f96e61);
    $parcel$export(module.exports, "isExtensionHiddenByDisplayConditions", ()=>$30771269db74e480$export$3cc53b8cca25d64);
    const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
    const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
    const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
    const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';
});
parcelRegister("7kNct", function(module, exports) {
    $parcel$export(module.exports, "dedupeContextAndGlance", ()=>$4e352c29f229bbb8$export$17503ba1adfac304);
    const $4e352c29f229bbb8$export$17503ba1adfac304 = (forgeData)=>{
        const contextInstallationIds = new Set(forgeData.issueContext?.map(({ installationId: installationId })=>installationId));
        const newGlanceItems = forgeData.issueGlance.filter(({ installationId: installationId })=>!contextInstallationIds.has(installationId));
        return {
            ...forgeData,
            issueGlance: newGlanceItems
        };
    };
});
parcelRegister("9XjL6", function(module, exports) {
    $parcel$export(module.exports, "issueGiraDataResource", ()=>$94d751405759debc$export$37badecd288c49f4);
    var $2Yhep;
    var $2M1hQ;
    var $5XgeZ;
    var $1UEZY;
    const $94d751405759debc$export$37badecd288c49f4 = (0, (0, parcelRequire("2M1hQ")).createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_GIRA_DATA',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: (...args)=>(0, (0, parcelRequire("1UEZY")).default)(...args),
        isBrowserOnly: true
    }));
});
parcelRegister("1UEZY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48e4146cd1317713$export$2e2bcd8739ae039);
    var $ePyEO;
    var $iR3GG;
    var $2Yhep;
    var $48e4146cd1317713$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
        const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
        if (!issueKey) return null;
        try {
            const { baseUrl: baseUrl } = tenantContext;
            const data = await (0, (0, parcelRequire("ePyEO")).default)(baseUrl, issueKey);
            return data;
        } catch (error) {
            throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.issue-view.gira.getData',
                message: 'An error was thrown while prefetching issue gira data',
                name: 'ResourceError'
            }, error);
        }
    };
});
parcelRegister("ePyEO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef212fbaef309294$export$2e2bcd8739ae039);
    var $dGrdR;
    var $k3PbQ;
    var $fqpdr;
    var $9kbEN;
    var $iBOrg;
    const $ef212fbaef309294$var$ISSUE_GIRA_DATA = 'issue-gira-data';
    const $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric = (0, (0, parcelRequire("dGrdR")).metrics).custom({
        key: $ef212fbaef309294$var$ISSUE_GIRA_DATA
    });
    var $ef212fbaef309294$export$2e2bcd8739ae039 = async (baseUrl, issueKey)=>{
        const projectKey = (0, (0, parcelRequire("k3PbQ")).extractProjectKey)(issueKey);
        const variables = {
            issueKey: issueKey,
            projectKey: projectKey
        };
        const payload = {
            query: (0, (0, parcelRequire("fqpdr")).buildIssueQuery)(),
            variables: variables,
            operationName: (0, (0, parcelRequire("fqpdr")).ISSUE_VIEW_INTERACTIVE_QUERY)
        };
        if ((0, (0, parcelRequire("9kbEN")).isInSample)()) $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.start();
        try {
            const response = await (0, (0, parcelRequire("iBOrg")).getClient)(baseUrl).query(payload);
            const issueId = response.data?.viewIssue?.issueId;
            $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.stop({
                customData: issueId ? {
                    issueId: issueId
                } : null
            });
            return response;
        } catch (error) {
            $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.cancel();
            throw error;
        }
    };
});
parcelRegister("fqpdr", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", ()=>$3789cf83eed10ddd$export$1780a132c0453fee);
    $parcel$export(module.exports, "getGiraUrl", ()=>$3789cf83eed10ddd$export$aefb19023b2eda55);
    $parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", ()=>$3789cf83eed10ddd$export$79eba9bf6dc9960d);
    $parcel$export(module.exports, "buildIssueQuery", ()=>$3789cf83eed10ddd$export$222ae9aca08830f0);
    $parcel$export(module.exports, "getGiraRequestOptions", ()=>$3789cf83eed10ddd$export$e1542dc7ff749de8);
    var $96nmc;
    var $EJMEI;
    var $8TkIN;
    var $e2Vt6;
    var $92ECu;
    var $6QL4r;
    var $5Pqa3;
    var $b1RJj;
    var $1HCMp;
    var $8JI9I;
    var $kNriQ;
    var $cRP2d;
    const $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING = '-created';
    const $3789cf83eed10ddd$export$1780a132c0453fee = 'issueViewInteractiveQuery';
    const $3789cf83eed10ddd$export$aefb19023b2eda55 = (_baseUrl, operation)=>`/rest/gira/1/${(0, (0, parcelRequire("96nmc")).appendOperationQuery)(operation)}`;
    const $3789cf83eed10ddd$var$viewIssueQuery = ()=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${(0, (0, parcelRequire("EJMEI")).default)({
            maxResults: (0, (0, parcelRequire("92ECu")).NUM_INITIAL_COMMENTS_TO_LOAD),
            startAt: 0,
            orderBy: $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING,
            commentAmount: Math.floor((0, (0, parcelRequire("92ECu")).NUM_INITIAL_COMMENTS_TO_LOAD)),
            hydrateData: false
        })}
        ${(0, (0, parcelRequire("cRP2d")).default)({
            startAt: 0,
            worklogAmount: Math.floor((0, (0, parcelRequire("92ECu")).NUM_INITIAL_WORKLOGS_TO_LOAD))
        })}
        ${(0, (0, parcelRequire("e2Vt6")).getEcosystemQuery)()}
        ${(0, (0, parcelRequire("8TkIN")).getContentPanelsQuery)()}
        ${(0, (0, parcelRequire("e2Vt6")).getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, (0, parcelRequire("5Pqa3")).getContainersByTypeQuery)()}
        ${(0, (0, parcelRequire("kNriQ")).getRemoteLinksQuery)()}
    }
`;
    const $3789cf83eed10ddd$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
    const $3789cf83eed10ddd$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
    const $3789cf83eed10ddd$export$222ae9aca08830f0 = ()=>`
query ${$3789cf83eed10ddd$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$3789cf83eed10ddd$export$58eaa2ae4a5a410a()}
        ${(0, (0, parcelRequire("b1RJj")).default)()}
        ${$3789cf83eed10ddd$var$viewIssueQuery()}
        ${(0, (0, parcelRequire("6QL4r")).getJiraSettingsQuery)()}
        ${(0, (0, parcelRequire("1HCMp")).default)()}
        ${(0, (0, parcelRequire("8JI9I")).default)()}
    }

`;
    const $3789cf83eed10ddd$export$e1542dc7ff749de8 = (issueKey, projectKey)=>{
        const payload = {
            operationName: $3789cf83eed10ddd$export$1780a132c0453fee,
            query: $3789cf83eed10ddd$export$222ae9aca08830f0(),
            variables: {
                issueKey: issueKey,
                projectKey: projectKey
            }
        };
        return {
            method: 'POST',
            body: JSON.stringify(payload)
        };
    };
});
parcelRegister("96nmc", function(module, exports) {
    $parcel$export(module.exports, "appendOperationQuery", ()=>$8119dcf59ebfcad5$export$69694c3add0f6058);
    const $8119dcf59ebfcad5$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';
});
parcelRegister("EJMEI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01ae9b8d951a6992$export$2e2bcd8739ae039);
    var $4R6GH;
    var $6tI1D;
    var $9F91P;
    var $01ae9b8d951a6992$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, hydrateData: hydrateData = true })=>{
        const commentPermalinkId = (0, (0, parcelRequire("6tI1D")).getPermalinkId)((0, (0, parcelRequire("6tI1D")).COMMENTS));
        const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
        const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
        const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
        const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
        const jiraCommentVisibility = ` jiraCommentVisibility {
    __typename
    ...on JiraRoleVisibility {
      name
    }
    ...on JiraGroupVisibility {
      group {
        groupId
        name
      }
    }
  }`;
        if ((0, (0, parcelRequire("4R6GH")).fg)('jiv-14067-issue-details-agg-migration-comments') && !(0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-14530-comments-consistency-check') && !hydrateData) return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
            startIndex
        }
    `;
        return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                ${jiraCommentVisibility}
                created
                updated
                jsdPublic
                bodyAdf
                jsdAuthorCanSeeRequest
                ${(0, (0, parcelRequire("9F91P")).isJsmTimelineEnabled)() ? 'eventOccurredAt' : ''}
                ${(0, (0, parcelRequire("9F91P")).isJsmTimelineEnabled)() ? 'jsdIncidentActivityViewHidden' : ''}
            }
            totalCount
            startIndex
        }
    `;
    };
});
parcelRegister("9F91P", function(module, exports) {
    $parcel$export(module.exports, "isJsmTimelineEnabled", ()=>$38d603c6864a4cb1$export$575e1bf822db15b5);
    var $f9Owr;
    const $38d603c6864a4cb1$export$575e1bf822db15b5 = ()=>(0, (0, parcelRequire("f9Owr")).ff)('jsm-timelines-phase-2_70gja', false);
});
parcelRegister("8TkIN", function(module, exports) {
    $parcel$export(module.exports, "getContentPanelsQuery", ()=>$09fdc8c72c341092$export$e6f14eac549b679d);
    const $09fdc8c72c341092$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
    const $09fdc8c72c341092$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
    const $09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
    const $09fdc8c72c341092$export$e6f14eac549b679d = ()=>`
    ${$09fdc8c72c341092$var$getContentPanelsConnectionQuery()}
    ${$09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;
});
parcelRegister("e2Vt6", function(module, exports) {
    $parcel$export(module.exports, "getEcosystemQuery", ()=>$1771eed42c62eeca$export$edefef8c65e08bd2);
    $parcel$export(module.exports, "getLegacyRightWebPanelsQuery", ()=>$1771eed42c62eeca$export$92c9a3dc7076af51);
    const $1771eed42c62eeca$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
    const $1771eed42c62eeca$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$1771eed42c62eeca$var$getForgeQuery()}
    }
`;
    const $1771eed42c62eeca$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;
});
parcelRegister("92ECu", function(module, exports) {
    $parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", ()=>$9387aa2a419a55f9$export$c46d621c29194aa4);
    $parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", ()=>$9387aa2a419a55f9$export$b2e398ce246f55b3);
    $parcel$export(module.exports, "gqlTagGira", ()=>$9387aa2a419a55f9$export$aeae6fc40846cf9f);
    const $9387aa2a419a55f9$export$c46d621c29194aa4 = 5;
    const $9387aa2a419a55f9$export$304a6c004edb30d8 = '-created';
    const $9387aa2a419a55f9$export$b2e398ce246f55b3 = 5;
    const $9387aa2a419a55f9$export$1c36ecc9afd61c73 = '-started';
    const $9387aa2a419a55f9$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
        let result = '';
        substitutions.forEach((key, i)=>{
            result += literals[i];
            result += key.toString();
        });
        result += literals[literals.length - 1];
        return result;
    };
});
parcelRegister("6QL4r", function(module, exports) {
    $parcel$export(module.exports, "getJiraSettingsQuery", ()=>$10470e592ba8e782$export$191f50c0f86b85ec);
    const $10470e592ba8e782$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
    const $10470e592ba8e782$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
    const $10470e592ba8e782$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;
});
parcelRegister("5Pqa3", function(module, exports) {
    $parcel$export(module.exports, "getContainersByTypeQuery", ()=>$85e2f5a62f1697d1$export$63131b2831854cc);
    const $85e2f5a62f1697d1$export$63131b2831854cc = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
});
parcelRegister("b1RJj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42429f0fa15c54ae$export$2e2bcd8739ae039);
    var $9wuCE;
    var $42429f0fa15c54ae$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, (0, parcelRequire("9wuCE")).getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;
});
parcelRegister("9wuCE", function(module, exports) {
    $parcel$export(module.exports, "getMaxTokenLength", ()=>$ebb491dcc11e8362$export$e40f2acaf1a50b00);
    const $ebb491dcc11e8362$var$nonIE11MaxTokenLength = 2 ** 16;
    const $ebb491dcc11e8362$export$e40f2acaf1a50b00 = ()=>$ebb491dcc11e8362$var$nonIE11MaxTokenLength;
});
parcelRegister("1HCMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ea17df757c74c46$export$2e2bcd8739ae039);
    var $co1wz;
    const $0ea17df757c74c46$export$9fc40cb6f3529ef = ()=>[
            'ADMINISTER_PROJECTS',
            'ASSIGN_ISSUES',
            'EDIT_ISSUES',
            'SCHEDULE_ISSUES',
            'ADD_COMMENTS',
            'DELETE_ALL_COMMENTS',
            'DELETE_OWN_COMMENTS',
            'EDIT_ALL_COMMENTS',
            'EDIT_OWN_COMMENTS',
            'CREATE_ISSUES',
            'DELETE_ISSUES',
            'MOVE_ISSUES',
            'MODIFY_REPORTER',
            'CREATE_ATTACHMENTS',
            'DELETE_ALL_ATTACHMENTS',
            'DELETE_OWN_ATTACHMENTS',
            'WORK_ON_ISSUES',
            'ASSIGNABLE_USER',
            'LINK_ISSUES',
            'VIEW_VOTERS_AND_WATCHERS',
            'MANAGE_WATCHERS',
            'EDIT_ALL_WORKLOGS',
            'EDIT_OWN_WORKLOGS',
            'DELETE_ALL_WORKLOGS',
            'DELETE_OWN_WORKLOGS',
            'VIEW_DEV_TOOLS',
            'SERVICEDESK_AGENT',
            'RESOLVE_ISSUES',
            'CLONE_ISSUE'
        ];
    const $0ea17df757c74c46$export$f5ff20e9116b53bc = ()=>{
        const permissionKeysForArchival = [
            'ARCHIVE_ISSUES',
            'UNARCHIVE_ISSUES'
        ];
        const permissionKeys = $0ea17df757c74c46$export$9fc40cb6f3529ef();
        if (!(0, (0, parcelRequire("co1wz")).ff)('issue-unarchival_wdpb9')) return permissionKeys;
        return [
            ...permissionKeys,
            ...permissionKeysForArchival
        ];
    };
    var $0ea17df757c74c46$export$2e2bcd8739ae039 = ()=>`

    permissions(issueKey:$issueKey, keys:["${$0ea17df757c74c46$export$f5ff20e9116b53bc().join('","')}"]) {
        key
        havePermission
    }
`;
});
parcelRegister("8JI9I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2232e63ddd04bbb1$export$2e2bcd8739ae039);
    var $2232e63ddd04bbb1$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;
});
parcelRegister("kNriQ", function(module, exports) {
    $parcel$export(module.exports, "getRemoteLinksQuery", ()=>$e19ca26272d1dd4d$export$6bbc6b72b0b57f25);
    var $4R6GH;
    const $e19ca26272d1dd4d$var$getUserQueryFragment = ()=>`
    user {
        key
        accountId
        emailAddress
        avatarUrl
        displayName
        active
    }
`;
    const $e19ca26272d1dd4d$var$getConfluencePagesQueryFragment = ()=>`
    pages {
        ... on ConfluencePage {
            id
            globalId
            href
            title
            type
            lastUpdatedContext {
                ${$e19ca26272d1dd4d$var$getUserQueryFragment()}
            }
        }
        ... on FailedRemoteLink {
            id
            error
            link {
                id
                globalId
                href
            }
            repairLink { href }
        }
    }
`;
    const $e19ca26272d1dd4d$var$getConfluencePageGroupQueryFragment = ()=>`
    pageCount
    ${$e19ca26272d1dd4d$var$getConfluencePagesQueryFragment()}
`;
    const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
    const $e19ca26272d1dd4d$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
    const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$e19ca26272d1dd4d$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
    const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
    const $e19ca26272d1dd4d$var$getWebLinksFragment = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
    const $e19ca26272d1dd4d$var$getRemoteLinksQueryNew = ()=>`
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
                ${$e19ca26272d1dd4d$var$getConfluencePageGroupQueryFragment()}
            }
            mentionedPages {
                ${$e19ca26272d1dd4d$var$getConfluencePageGroupQueryFragment()}
            }
        }
        ${$e19ca26272d1dd4d$var$getWebLinksFragment()}
        ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment()}
    }
`;
    const $e19ca26272d1dd4d$var$getRemoteLinksQueryOld = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
    const $e19ca26272d1dd4d$export$6bbc6b72b0b57f25 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jiv-19125-fetch-remote-links-in-interactive-query') ? $e19ca26272d1dd4d$var$getRemoteLinksQueryNew() : $e19ca26272d1dd4d$var$getRemoteLinksQueryOld();
});
parcelRegister("cRP2d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$354b7c85b873ab44$export$2e2bcd8739ae039);
    var $6tI1D;
    var $354b7c85b873ab44$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount })=>{
        const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
        const worklogPermalinkId = (0, (0, parcelRequire("6tI1D")).getPermalinkId)((0, (0, parcelRequire("6tI1D")).WORKLOG));
        if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
        const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
        const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
        return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
    };
});
parcelRegister("9kbEN", function(module, exports) {
    $parcel$export(module.exports, "isInSample", ()=>$b9c2013a86366ec0$export$a994c91d08ead5ff);
    const $b9c2013a86366ec0$export$a994c91d08ead5ff = (sampleRate = (0, $670519621927ccc4$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;
});
const $670519621927ccc4$export$9fc1f2d681a9e609 = 100;
parcelRegister("iBOrg", function(module, exports) {
    $parcel$export(module.exports, "getClient", ()=>$3d6ab2890da8f9df$export$6bb76d6eba7e258c);
    var $7f4tk;
    var $fqpdr;
    const $3d6ab2890da8f9df$var$makeFetchClient = (baseUrl)=>({
            query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, (0, parcelRequire("7f4tk")).default)((0, (0, parcelRequire("fqpdr")).getGiraUrl)(baseUrl, operationName), {
                    method: 'POST',
                    body: JSON.stringify({
                        query: query,
                        variables: variables,
                        operationName: operationName
                    }),
                    signal: signal
                })
        });
    let $3d6ab2890da8f9df$var$client;
    const $3d6ab2890da8f9df$export$6bb76d6eba7e258c = (baseUrl)=>{
        if (!$3d6ab2890da8f9df$var$client) $3d6ab2890da8f9df$var$client = $3d6ab2890da8f9df$var$makeFetchClient(baseUrl);
        return $3d6ab2890da8f9df$var$client;
    };
});
parcelRegister("lCj8l", function(module, exports) {
    $parcel$export(module.exports, "issueGiraNonCriticalDataResource", ()=>$74422abbcf73f635$export$2d81f7bddf10f49e);
    var $2Yhep;
    var $2M1hQ;
    var $5XgeZ;
    var $cvOMs;
    const $74422abbcf73f635$export$2d81f7bddf10f49e = (0, (0, parcelRequire("2M1hQ")).createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_GIRA_NON_CRITICAL_DATA',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: (...args)=>(0, (0, parcelRequire("cvOMs")).default)(...args),
        isBrowserOnly: true
    }));
});
parcelRegister("cvOMs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07364a38d1410c3f$export$2e2bcd8739ae039);
    var $1O6Hj;
    var $iR3GG;
    var $2Yhep;
    var $07364a38d1410c3f$export$2e2bcd8739ae039 = async ({ match: match }, _)=>{
        const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
        if (!issueKey) return null;
        try {
            const data = await (0, (0, parcelRequire("1O6Hj")).fetchIssueGiraNonCriticalData)(issueKey);
            return data;
        } catch (error) {
            throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.issue-view.gira-non-critical.getData',
                message: 'An error was thrown while prefetching issue gira non critical data',
                name: 'ResourceError'
            }, error);
        }
    };
});
parcelRegister("1O6Hj", function(module, exports) {
    $parcel$export(module.exports, "nonCriticalGiraQueryExperienceTracking", ()=>$6bf108f87308d37b$export$f382deefb24f95ae);
    $parcel$export(module.exports, "fetchIssueGiraNonCriticalData", ()=>$6bf108f87308d37b$export$58a9221a6c5306db);
    var $jJZqs;
    var $c6dax;
    var $gXz4p;
    var $iBOrg;
    const $6bf108f87308d37b$var$nonCriticalGiraQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId, isEarlyFetch: isEarlyFetch })=>{
        const errorMessageItem = errorMessage != null ? {
            errorMessage: errorMessage
        } : {};
        const traceIdItem = traceId != null ? {
            traceId: traceId
        } : {};
        return {
            experience: isEarlyFetch ? 'issueEarlyFetchNonCriticalGiraQuery' : 'issueNonCriticalGiraQuery',
            wasExperienceSuccesful: wasExperienceSuccessful,
            analyticsSource: `Issue View ${isEarlyFetch ? 'Early Fetch ' : ''}Non Critical Gira Query`,
            additionalAttributes: {
                method: 'GET',
                ...errorMessageItem,
                ...traceIdItem
            },
            application: null,
            edition: null
        };
    };
    const $6bf108f87308d37b$export$f382deefb24f95ae = ({ wasExperienceSuccessful: wasExperienceSuccessful, isEarlyFetch: isEarlyFetch, error: error })=>{
        (0, (0, parcelRequire("gXz4p")).sendExperienceAnalytics)($6bf108f87308d37b$var$nonCriticalGiraQueryExperienceDescription({
            wasExperienceSuccessful: wasExperienceSuccessful,
            ...error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.message != null ? {
                errorMessage: error.message
            } : {},
            ...error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.traceId != null ? {
                traceId: error.traceId
            } : {},
            isEarlyFetch: isEarlyFetch
        }));
    };
    const $6bf108f87308d37b$export$58a9221a6c5306db = async (issueKey)=>{
        const variables = {
            issueKey: issueKey
        };
        const payload = {
            query: (0, (0, parcelRequire("c6dax")).buildNonCriticalGiraQuery)(),
            variables: variables,
            operationName: (0, (0, parcelRequire("c6dax")).ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY)
        };
        try {
            const response = await (0, (0, parcelRequire("iBOrg")).getClient)('').query(payload);
            $6bf108f87308d37b$export$f382deefb24f95ae({
                wasExperienceSuccessful: true,
                isEarlyFetch: false
            });
            return response;
        } catch (error) {
            $6bf108f87308d37b$export$f382deefb24f95ae({
                wasExperienceSuccessful: false,
                isEarlyFetch: false,
                error: error instanceof (0, (0, parcelRequire("jJZqs")).default) ? error : undefined
            });
            throw error;
        }
    };
});
parcelRegister("c6dax", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY", ()=>$b74efd74d6a135cc$export$857f1602ca5b9d99);
    $parcel$export(module.exports, "buildNonCriticalGiraQuery", ()=>$b74efd74d6a135cc$export$df3c3aa9d6d3f431);
    $parcel$export(module.exports, "getNonCriticalGiraQueryRequestOptions", ()=>$b74efd74d6a135cc$export$555194bfc9159fa3);
    var $jzVvW;
    const $b74efd74d6a135cc$export$857f1602ca5b9d99 = 'issueViewNonCriticalGiraQuery';
    const $b74efd74d6a135cc$export$df3c3aa9d6d3f431 = ()=>`
query ${$b74efd74d6a135cc$export$857f1602ca5b9d99}($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        ${(0, (0, parcelRequire("jzVvW")).getEcosystemQuery)()}
        deletableAttachmentsCount
    }
}`;
    const $b74efd74d6a135cc$export$555194bfc9159fa3 = (issueKey)=>({
            method: 'POST',
            body: JSON.stringify({
                operationName: $b74efd74d6a135cc$export$857f1602ca5b9d99,
                query: $b74efd74d6a135cc$export$df3c3aa9d6d3f431(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
});
parcelRegister("jzVvW", function(module, exports) {
    $parcel$export(module.exports, "getEcosystemQuery", ()=>$8b485783ca3ced28$export$edefef8c65e08bd2);
    const $8b485783ca3ced28$export$edefef8c65e08bd2 = ()=>`
  ecosystem {
    operations {
      name
      url: href
      tooltip
      styleClass
    }
    backgroundScripts {
      iframe {
        addonKey
        moduleKey
        options
      }
      shouldReloadOnRefresh
    }
  }
`;
});
parcelRegister("gXz4p", function(module, exports) {
    $parcel$export(module.exports, "sendExperienceAnalytics", ()=>$b28eb6b892a8c2f7$export$4a95ada1b8228562);
    var $1UikQ = parcelRequire("1UikQ");
    var $gSA3s;
    var $hh0bW;
    var $j8DrX;
    const $b28eb6b892a8c2f7$var$isSynthetic = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true';
    function $b28eb6b892a8c2f7$export$4a95ada1b8228562(experienceDescription) {
        const additionalContext = {};
        const shard = (0, (0, parcelRequire("j8DrX")).default)('ajs-shard');
        const region = (0, (0, parcelRequire("j8DrX")).default)('ajs-region');
        Object.assign(additionalContext, {
            shard: shard,
            region: region
        });
        const enabledFeatureFlags = Object.fromEntries([
            ...(0, (0, parcelRequire("gSA3s")).allFeatureFlagsAccessed)
        ].filter(([, value])=>value));
        Object.assign(additionalContext, {
            enabledFeatureFlags: enabledFeatureFlags
        });
        const synthetics = {
            additionalAttributes: {
                synthetic: $b28eb6b892a8c2f7$var$isSynthetic(),
                ...additionalContext
            }
        };
        (0, ($parcel$interopDefault($1UikQ)))(experienceDescription, synthetics);
        (0, (0, parcelRequire("hh0bW")).default)(experienceDescription);
    }
});
parcelRegister("hh0bW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c8a1e19e7613048$export$2e2bcd8739ae039);
    var $fjcgS;
    var $efvDm;
    var $ldyPw;
    const $6c8a1e19e7613048$var$transformApplication = (application)=>{
        switch(application){
            case 0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE:
                return 'jira-software';
            case 0, (0, parcelRequire("efvDm")).JIRA_PRODUCT_DISCOVERY:
                return 'jira-product-discovery';
            case 0, (0, parcelRequire("efvDm")).JIRA_CORE:
                return 'jira-core';
            case 0, (0, parcelRequire("efvDm")).JIRA_SERVICE_DESK:
                return 'jira-servicedesk';
            case 0, (0, parcelRequire("efvDm")).JIRA_PORTFOLIO:
                return 'jira-portfolio';
            default:
                return 'unknown';
        }
    };
    const $6c8a1e19e7613048$var$transformEdition = (edition)=>{
        switch(edition){
            case 0, (0, parcelRequire("ldyPw")).FREE_EDITION:
                return 'jedi';
            case 0, (0, parcelRequire("ldyPw")).STANDARD_EDITION:
                return 'standard';
            case 0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION:
                return 'premium';
            case 0, (0, parcelRequire("ldyPw")).UNLICENSED:
                return 'unlicensed';
            default:
                return 'unknown';
        }
    };
    const $6c8a1e19e7613048$var$transformAction = (action, wasExperienceSuccesful)=>{
        if (action !== undefined) return action;
        return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
    };
    const $6c8a1e19e7613048$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
            source: 'ui',
            action: $6c8a1e19e7613048$var$transformAction(action, wasExperienceSuccesful),
            actionSubject: 'ui',
            attributes: {
                ...additionalAttributes,
                task: experience,
                ...location ? {
                    reason: location
                } : {},
                ...field ? {
                    field: field
                } : {},
                ...typeof hasEdit === 'boolean' ? {
                    hasEdit: hasEdit
                } : {},
                analyticsSource: analyticsSource,
                application: $6c8a1e19e7613048$var$transformApplication(application),
                edition: $6c8a1e19e7613048$var$transformEdition(edition)
            }
        });
    var $6c8a1e19e7613048$export$2e2bcd8739ae039 = (experienceDescription)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const event = $6c8a1e19e7613048$var$createAnalyticsEvent(experienceDescription);
            const clientInstance = client.getInstance();
            clientInstance.sendOperationalEvent(event);
        });
    };
});
parcelRegister("hPMz6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fsHbN").then(()=>parcelRequire('8OVUQ'));
});
parcelRegister("fw7Rx", function(module, exports) {
    $parcel$export(module.exports, "browseIssueRoute", ()=>$b546ef0893c1765d$export$2c9c7e50a88e588b);
    var $65Ltd;
    const $b546ef0893c1765d$export$2c9c7e50a88e588b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE),
        path: '/browse/:issueKey(\\w+-\\d+)(.*)?',
        query: [
            'filter?!=(.*)',
            'jql?!=(.*)'
        ]
    };
});
parcelRegister("lb0Dk", function(module, exports) {
    $parcel$export(module.exports, "IssueViewSkeleton", ()=>$bf9ca492e3d15685$export$49addbcdecb6e6ff);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iMqhh;
    var $hCy6k;
    var $gERis = parcelRequire("gERis");
    const $bf9ca492e3d15685$var$fullpageStyles = null;
    const $bf9ca492e3d15685$var$modalStyles = null;
    const $bf9ca492e3d15685$var$customSpacingStyles = null;
    const $bf9ca492e3d15685$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
        const customCss = [
            $bf9ca492e3d15685$var$customSpacingStyles,
            isEmbedView !== true && isModalView !== true ? $bf9ca492e3d15685$var$fullpageStyles : null,
            isModalView === true ? $bf9ca492e3d15685$var$modalStyles : null
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iMqhh")).CompactModeProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($gERis))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1ypn _18s85ogf _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
                isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
                isModalView === true && "_19pk10j7"
            ])
        }));
    };
});
parcelRegister("iMqhh", function(module, exports) {
    $parcel$export(module.exports, "CompactModeContext", ()=>$db79d17d45755de5$export$37eeac5cc5245b18);
    $parcel$export(module.exports, "CompactModeProvider", ()=>$db79d17d45755de5$export$10cf42790e523b8e);
    $parcel$export(module.exports, "CompactModeConsumer", ()=>$db79d17d45755de5$export$20feb77b5b617e44);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8kj45;
    var $doZTA;
    var $hhMVP;
    const $db79d17d45755de5$export$37eeac5cc5245b18 = (0, $5uXOq.createContext)(false);
    const { Provider: $db79d17d45755de5$var$Provider, Consumer: $db79d17d45755de5$var$Consumer } = $db79d17d45755de5$export$37eeac5cc5245b18;
    const $db79d17d45755de5$export$55a90a8e865a39b5 = 700;
    const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$db79d17d45755de5$export$55a90a8e865a39b5}px)`;
    function $db79d17d45755de5$var$useRouteKey() {
        const [routeState] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { match: { path: path, params: params } } = routeState;
        const hasIssueKey = params?.issueKey !== undefined;
        return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
    }
    const $db79d17d45755de5$export$10cf42790e523b8e = ({ children: children })=>{
        const key = $db79d17d45755de5$var$useRouteKey();
        (0, (0, parcelRequire("hhMVP")).invalidateCacheIfRouteChanged)(key);
        let defaultState = (0, (0, parcelRequire("hhMVP")).getCachedIsCompactValue)(key);
        if (defaultState === undefined) {
            defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4);
            (0, (0, parcelRequire("hhMVP")).setCachedIsCompactValue)(defaultState, key);
        }
        const [isCompact, setIsCompact] = (0, $5uXOq.useState)(defaultState);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$StyledWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8kj45")).ContainerQueryObserver), {
            query: $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY,
            onChange: (state)=>{
                (0, (0, parcelRequire("hhMVP")).setCachedIsCompactValue)(state, key);
                setIsCompact(state);
            },
            defaultState: defaultState
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$Provider, {
            value: isCompact
        }, children));
    };
    const $db79d17d45755de5$export$20feb77b5b617e44 = $db79d17d45755de5$var$Consumer;
    const $db79d17d45755de5$var$StyledWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
});
const $7093eea63dce9286$export$ee15e0cd1efafcb4 = false;
parcelRegister("8kj45", function(module, exports) {
    $parcel$export(module.exports, "ContainerQueryObserver", ()=>$ed10e3c030ea0408$export$e9574287678b8467);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $ed10e3c030ea0408$var$QueryContext = (0, $5uXOq.createContext)(undefined);
    let $ed10e3c030ea0408$var$currentIdSeed = 0;
    function $ed10e3c030ea0408$var$generateAttributeValue() {
        return `indicator-span-${$ed10e3c030ea0408$var$currentIdSeed++}`;
    }
    function $ed10e3c030ea0408$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4) }) {
        const [active, setActive] = (0, $5uXOq.useState)(defaultState);
        const handleQueryStatusChange = (0, $5uXOq.useCallback)((isContainerQueryActive)=>{
            onChange?.(isContainerQueryActive);
            setActive(isContainerQueryActive);
        }, [
            onChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$QueryContext.Provider, {
            value: active
        }, !false && (0, ($parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$IntersectionIndicator, {
            query: query,
            notifyIntersectionStatusChanged: handleQueryStatusChange
        }), children);
    }
    function $ed10e3c030ea0408$export$b66a67697973e01() {
        const currentState = (0, $5uXOq.useContext)($ed10e3c030ea0408$var$QueryContext);
        if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
        return currentState;
    }
    function $ed10e3c030ea0408$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
        const attributeValue = (0, $5uXOq.useMemo)(()=>$ed10e3c030ea0408$var$generateAttributeValue(), []);
        const spanRef = (0, $5uXOq.useRef)(null);
        const containerRef = (0, $5uXOq.useRef)(null);
        const currentState = $ed10e3c030ea0408$export$b66a67697973e01();
        (0, $5uXOq.useLayoutEffect)(()=>{
            const queryStatusChangedCallback = (entries)=>{
                if (!containerRef.current || containerRef.current.clientWidth === 0) return;
                if (entries.length > 0) {
                    const isContainerQueryActive = entries[0].isIntersecting;
                    if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
                }
            };
            const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
            const spanElement = spanRef.current;
            spanElement && intersectionObserver.observe(spanElement);
            return ()=>{
                spanElement && intersectionObserver.unobserve(spanElement);
                intersectionObserver.disconnect();
            };
        }, [
            currentState,
            handleChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$ContainerToBeQueried, {
            ref: containerRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            type: "text/css"
        }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh; 
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ref: spanRef,
            "data-container-query-indicator-id": attributeValue
        }));
    }
    const $ed10e3c030ea0408$var$ContainerToBeQueried = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hhMVP", function(module, exports) {
    $parcel$export(module.exports, "getCachedIsCompactValue", ()=>$cd61c7d28b4f2500$export$c47621d55d10906c);
    $parcel$export(module.exports, "setCachedIsCompactValue", ()=>$cd61c7d28b4f2500$export$568b2dd75c2027b4);
    $parcel$export(module.exports, "invalidateCacheIfRouteChanged", ()=>$cd61c7d28b4f2500$export$a81477a3594bcaab);
    const $cd61c7d28b4f2500$var$cachedIsCompactValues = {};
    let $cd61c7d28b4f2500$var$previousRouteKey;
    function $cd61c7d28b4f2500$export$c47621d55d10906c(key) {
        return $cd61c7d28b4f2500$var$cachedIsCompactValues[key];
    }
    function $cd61c7d28b4f2500$export$568b2dd75c2027b4(isCompactValue, key) {
        $cd61c7d28b4f2500$var$cachedIsCompactValues[key] = isCompactValue;
    }
    function $cd61c7d28b4f2500$export$a81477a3594bcaab(currentRouteKey) {
        if (currentRouteKey !== $cd61c7d28b4f2500$var$previousRouteKey) {
            $cd61c7d28b4f2500$var$previousRouteKey = currentRouteKey;
            delete $cd61c7d28b4f2500$var$cachedIsCompactValues[$cd61c7d28b4f2500$var$previousRouteKey];
        }
    }
});
parcelRegister("gERis", function(module, exports) {
    module.exports = new URL("issue-app-skeleton.tpl.31d538db.svg", import.meta.url).toString();
});
parcelRegister("1gXMV", function(module, exports) {
    $parcel$export(module.exports, "GlobalIssueNavigatorSkeleton", ()=>$c87e28c0f4513050$export$51681996374b2585);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $3hk93 = parcelRequire("3hk93");
    const $c87e28c0f4513050$var$customCssStyles = null;
    const $c87e28c0f4513050$export$51681996374b2585 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($3hk93))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1zwfg _slt8zwfg _1od57vkz"
            ])
        });
});
parcelRegister("3hk93", function(module, exports) {
    module.exports = new URL("global-issue-navigator-skeleton.tpl.b1bf4b99.svg", import.meta.url).toString();
});
parcelRegister("lHYIV", function(module, exports) {
    $parcel$export(module.exports, "ProjectIssueNavigatorSkeleton", ()=>$8afa09f5da2bc6b1$export$112138f5f732a994);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $hDeVo = parcelRequire("hDeVo");
    const $8afa09f5da2bc6b1$var$customCssStyles = null;
    const $8afa09f5da2bc6b1$export$112138f5f732a994 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($hDeVo))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1zwfg _slt8zwfg _1od57vkz"
            ])
        });
});
parcelRegister("hDeVo", function(module, exports) {
    module.exports = new URL("project-issue-navigator-skeleton.tpl.2a1718d8.svg", import.meta.url).toString();
});
parcelRegister("96w9D", function(module, exports) {
    $parcel$export(module.exports, "sidebarFiltersGlobalResource", ()=>$4afb52221e3a3f09$export$7e0b804085f0470d);
    var $ao2h1;
    var $gBXKh;
    var $6YG83;
    const $4afb52221e3a3f09$export$7e0b804085f0470d = (0, (0, parcelRequire("6YG83")).withGiraAggAnonSsrFix)((0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'NAVIGATION_SIDEBAR_FILTERS_GLOBAL',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("gBXKh")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    }));
});
parcelRegister("gBXKh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0f1ab872360a786$export$2e2bcd8739ae039);
    const $a0f1ab872360a786$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = [
            v1
        ], v3 = {
            "kind": "ScalarField",
            "name": "filterId"
        }, v4 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v5 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v6 = {
            "kind": "ScalarField",
            "name": "name"
        }, v7 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ],
            "type": "JiraCustomFilter"
        }, v8 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2,
                                    "kind": "FragmentSpread",
                                    "name": "starredFiltersList_navigationAppsSidebarCommon"
                                },
                                {
                                    "args": v2,
                                    "kind": "FragmentSpread",
                                    "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "JiraFilterConnection",
                                "kind": "LinkedField",
                                "name": "favouriteFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v3,
                                                    {
                                                        "kind": "TypeDiscriminator",
                                                        "abstractKey": "__isJiraFilter"
                                                    },
                                                    v4,
                                                    v5,
                                                    v6,
                                                    v7,
                                                    v8
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "isFavourite",
                                        "value": false
                                    }
                                ],
                                "concreteType": "JiraSystemFilterConnection",
                                "kind": "LinkedField",
                                "name": "systemFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSystemFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSystemFilter",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    v8,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v4,
                                                            v5,
                                                            v6,
                                                            v7
                                                        ],
                                                        "type": "JiraFilter",
                                                        "abstractKey": "__isJiraFilter"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "0fc7dfdbeee4792faa92449e364dd4b9b51f2ed2fc3bd618160e27885c980a88",
                "metadata": {},
                "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $a0f1ab872360a786$var$node.hash = "b5467e25277d67ce676aa25dd3a16377";
    var $a0f1ab872360a786$export$2e2bcd8739ae039 = $a0f1ab872360a786$var$node;
});
parcelRegister("6YG83", function(module, exports) {
    $parcel$export(module.exports, "withGiraAggAnonSsrFix", ()=>$895edd6ed19f0aa8$export$f4b29e78f4c0a526);
    const $895edd6ed19f0aa8$export$f4b29e78f4c0a526 = (resource)=>{
        if (!resource || !resource.getData) return resource;
        const originalGetData = resource.getData;
        resource.getData = (routerContext, customContext)=>{
            if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
            return originalGetData(routerContext, customContext);
        };
        return resource;
    };
});
parcelRegister("8Wi6S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c9fa7b304f828b3$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "AsyncSidebarFiltersGlobal", ()=>$7c9fa7b304f828b3$export$1af88ebe65f50e73);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $7c9fa7b304f828b3$var$LazySidebarFiltersLegacy = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("d3UTn")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
    });
    const $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "filters"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazySidebarFiltersLegacy, null)));
    var $7c9fa7b304f828b3$export$2e2bcd8739ae039 = $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy;
    const $7c9fa7b304f828b3$var$LazySidebarFiltersGlobal = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("8GB8S")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle.SidebarFiltersGlobal;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
    });
    const $7c9fa7b304f828b3$export$1af88ebe65f50e73 = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "filters-global"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazySidebarFiltersGlobal, null)));
});
parcelRegister("d3UTn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("iTs3w")
    ]).then(()=>parcelRequire('7T8w9'));
});
parcelRegister("8GB8S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("2dpYI")
    ]).then(()=>parcelRequire('hcPI1'));
});
parcelRegister("8CVvd", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav3", ()=>$5acda4891dbe9afe$export$23a7d978e17f1720);
    var $3HwlS;
    const $5acda4891dbe9afe$export$23a7d978e17f1720 = ()=>!(0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
});
parcelRegister("bATyw", function(module, exports) {
    $parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", ()=>$a818348721ae6866$export$3f6390b4131d761b);
    var $2M1hQ;
    const $a818348721ae6866$var$getDataLoader = ()=>(parcelRequire("b9fyS"));
    const $a818348721ae6866$export$3f6390b4131d761b = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
        getKey: ()=>'ninGlobalScopeEnrolment',
        getDataLoader: $a818348721ae6866$var$getDataLoader
    });
});
parcelRegister("b9fyS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f9qz1").then(()=>parcelRequire('dIecw'));
});
parcelRegister("89kiv", function(module, exports) {
    $parcel$export(module.exports, "issueNavigatorRelayResource", ()=>$93f22f98fd07bff0$export$b4096f516fb93159);
    $parcel$export(module.exports, "issueNavigatorFilterRelayResource", ()=>$93f22f98fd07bff0$export$44ca3a0b25f38d83);
    $parcel$export(module.exports, "issueNavigatorHydrationRelayResource", ()=>$93f22f98fd07bff0$export$967ef0cfbd1cc946);
    var $8Uumt = parcelRequire("8Uumt");
    var $gbLWS;
    var $6s1PB;
    var $4R6GH;
    var $9Nvh7;
    var $6UAdF;
    var $dXq4S;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $16Yit;
    var $kvekU;
    var $hTvlq;
    var $2M1hQ;
    var $5bSAg;
    var $aBKbA;
    const $93f22f98fd07bff0$export$b4096f516fb93159 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, (0, parcelRequire("5bSAg")).RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY)}`,
        getKey: ()=>'issue-navigator-relay',
        getData: async (routerContext, { tenantContext: tenantContext })=>{
            if (false && tenantContext.isAnonymous) return null;
            const { projectKey: projectKey, issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, (0, parcelRequire("aBKbA")).getParams)(routerContext);
            const jqlOrFilterId = (0, (0, parcelRequire("aBKbA")).getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
            const maxIssuesPerPage = (0, (0, parcelRequire("6UAdF")).getMaxIssuesPerPage)();
            const viewConfigInput = projectKey !== undefined && projectKey !== null ? {
                viewInput: {
                    namespace: (0, (0, parcelRequire("6UAdF")).ISSUE_SEARCH_NAMESPACE)
                }
            } : {
                staticViewInput: {
                    isHierarchyEnabled: false
                }
            };
            const variables = {
                cloudId: tenantContext.cloudId,
                first: issueKey == null ? maxIssuesPerPage : null,
                issueSearchInput: jqlOrFilterId,
                namespace: (0, (0, parcelRequire("6UAdF")).ISSUE_SEARCH_NAMESPACE),
                fieldSetsInput: (0, (0, parcelRequire("6s1PB")).expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? {
                    viewInput: {
                        namespace: (0, (0, parcelRequire("6UAdF")).ISSUE_SEARCH_NAMESPACE)
                    }
                } : null,
                after: null,
                options: {
                    issueKey: issueKey
                },
                fieldSetIds: [],
                shouldQueryFieldSetsById: false,
                filterId: Boolean(filter) && (0, (0, parcelRequire("9Nvh7")).isCustomFilter)(filter) ? filter : null,
                amountOfColumns: (0, (0, parcelRequire("6UAdF")).MAX_AMOUNT_OF_COLUMNS),
                ...(0, (0, parcelRequire("6s1PB")).expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, (0, parcelRequire("4R6GH")).fg)('jsc_m2_hierarchy_fe_changes') && {
                    viewConfigInput: viewConfigInput
                },
                atlassianIntelligenceProductFeature: (0, (0, parcelRequire("6UAdF")).NATURAL_LANGUAGE_TO_JQL),
                projectKey: projectKey ?? '',
                shouldQueryProject: Boolean(projectKey) && ((0, (0, parcelRequire("4R6GH")).fg)('jsc_add_realtime_updates') || (0, (0, parcelRequire("6s1PB")).expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, (0, parcelRequire("4R6GH")).fg)('jsc_m2_hierarchy_fe_changes'))
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("hTvlq")).default), variables, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
    const $93f22f98fd07bff0$export$44ca3a0b25f38d83 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, (0, parcelRequire("5bSAg")).RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY)}`,
        getKey: ()=>'issue-navigator-filter-relay',
        getData: async (routerContext, { tenantContext: tenantContext })=>{
            if (false && tenantContext.isAnonymous) return null;
            const { filter: filter } = (0, (0, parcelRequire("aBKbA")).getParams)(routerContext);
            const includeFilter = Boolean(filter) && (0, (0, parcelRequire("9Nvh7")).isFilterId)(filter);
            const variables = {
                includeFilter: includeFilter,
                filterAri: includeFilter ? (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'filter',
                    resourceId: filter,
                    activationId: tenantContext.activationId
                }) : ''
            };
            const options = {
                fetchPolicy: includeFilter ? 'network-only' : 'store-only'
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("kvekU")).default), variables, options);
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
    const $93f22f98fd07bff0$export$967ef0cfbd1cc946 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, (0, parcelRequire("5bSAg")).RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}`,
        getKey: ()=>'issue-navigator-hydration-relay',
        getData: async (routerContext, { tenantContext: tenantContext })=>{
            if (false && tenantContext.isAnonymous) return null;
            const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, (0, parcelRequire("aBKbA")).getParams)(routerContext);
            const jqlOrFilterId = (0, (0, parcelRequire("aBKbA")).getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
            const variables = {
                accountId: tenantContext.atlassianAccountId ?? '',
                cloudId: tenantContext.cloudId,
                includeUser: true,
                includeJira: true,
                isFilter: 'filterId' in jqlOrFilterId,
                jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
                filterAri: 'filterId' in jqlOrFilterId && (0, (0, parcelRequire("gbLWS")).JiraFilterAri).create({
                    siteId: tenantContext.cloudId,
                    filterId: filter,
                    activationId: tenantContext.activationId
                }).toString() || '',
                viewContext: null
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("16Yit")).default), variables, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0,
        isBrowserOnly: true
    });
});
parcelRegister("9Nvh7", function(module, exports) {
    $parcel$export(module.exports, "isCustomFilter", ()=>$08e78f523b28c02b$export$31180e7f1db565e5);
    $parcel$export(module.exports, "isFilterId", ()=>$08e78f523b28c02b$export$23be85030bd58047);
    const $08e78f523b28c02b$export$31180e7f1db565e5 = (filterId)=>/^\d+$/.test(filterId);
    const $08e78f523b28c02b$export$887fa95a5a5cf197 = (filterId)=>/^-\d+$/.test(filterId);
    const $08e78f523b28c02b$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);
});
parcelRegister("6UAdF", function(module, exports) {
    $parcel$export(module.exports, "sortDirections", ()=>$8e65b6d66c73d810$export$73034536b9adc928);
    $parcel$export(module.exports, "FilterTypes", ()=>$8e65b6d66c73d810$export$ad2e3f13451a5d44);
    $parcel$export(module.exports, "SearchInputTypes", ()=>$8e65b6d66c73d810$export$75a31bc7c097ba4b);
    $parcel$export(module.exports, "views", ()=>$8e65b6d66c73d810$export$d0079916fe6800ac);
    $parcel$export(module.exports, "defaultOrderFields", ()=>$8e65b6d66c73d810$export$2bd49f8f262d7cbb);
    $parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", ()=>$8e65b6d66c73d810$export$de2495608df10495);
    $parcel$export(module.exports, "DEFAULT_ORDER_FIELD", ()=>$8e65b6d66c73d810$export$393cb330f31d305c);
    $parcel$export(module.exports, "DEFAULT_SORT_DIRECTION", ()=>$8e65b6d66c73d810$export$8ea18fa9e35fdf25);
    $parcel$export(module.exports, "DEFAULT_VIEW_ID", ()=>$8e65b6d66c73d810$export$500b5c379b5c7f2e);
    $parcel$export(module.exports, "MAX_ISSUES_PER_PAGE", ()=>$8e65b6d66c73d810$export$f88f58d1a4b2078b);
    $parcel$export(module.exports, "getMaxIssuesPerPage", ()=>$8e65b6d66c73d810$export$8c67ad1f64ab5a9c);
    $parcel$export(module.exports, "ANALYTICS_SOURCE", ()=>$8e65b6d66c73d810$export$f7109619a5e9e0d6);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$8e65b6d66c73d810$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$8e65b6d66c73d810$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "EXPERIENCE_NAME", ()=>$8e65b6d66c73d810$export$52919046b94109dc);
    $parcel$export(module.exports, "ANALYTICS_LIST_VIEW_SOURCE_NAME", ()=>$8e65b6d66c73d810$export$81d9767bc5c1549e);
    $parcel$export(module.exports, "ANALYTICS_DETAIL_VIEW_SOURCE_NAME", ()=>$8e65b6d66c73d810$export$524ae4278a57eea2);
    $parcel$export(module.exports, "MAX_AMOUNT_OF_COLUMNS", ()=>$8e65b6d66c73d810$export$608eeb3a32afef02);
    $parcel$export(module.exports, "COLUMN_TYPE_EPIC_LINK", ()=>$8e65b6d66c73d810$export$ce9e2d7c178a9557);
    $parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", ()=>$8e65b6d66c73d810$export$1adf7afff96bbf16);
    $parcel$export(module.exports, "NATURAL_LANGUAGE_TO_JQL", ()=>$8e65b6d66c73d810$export$55628b4c44d1522a);
    $parcel$export(module.exports, "supportedOrderFields", ()=>$8e65b6d66c73d810$export$3630aa1c4c69277f);
    $parcel$export(module.exports, "getSupportedFieldForAlias", ()=>$8e65b6d66c73d810$export$eaadab3243bf458);
    var $032ey;
    var $czfFt;
    const $8e65b6d66c73d810$export$73034536b9adc928 = {
        ASC: 'ASC',
        DESC: 'DESC',
        NONE: 'NONE'
    };
    const $8e65b6d66c73d810$export$3f42f49c284d5b58 = {
        TODO: 2,
        COMPLETE: 3,
        IN_PROGRESS: 4
    };
    const $8e65b6d66c73d810$export$ad2e3f13451a5d44 = {
        ID: 'filterId',
        JQL: 'filterJql'
    };
    const $8e65b6d66c73d810$export$75a31bc7c097ba4b = {
        JQL: 'jql',
        FILTER: 'filter',
        FILTER_AND_JQL: 'filterAndJql'
    };
    const $8e65b6d66c73d810$export$d0079916fe6800ac = {
        list: 'list-view',
        detail: 'split-view'
    };
    const $8e65b6d66c73d810$export$2bd49f8f262d7cbb = {
        created: 'created',
        lastviewed: 'lastviewed',
        updated: 'updated'
    };
    const $8e65b6d66c73d810$export$92a576f896a9bf72 = {
        myopenissues: Symbol('myopenissues'),
        reportedbyme: Symbol('reportedbyme'),
        allopenissues: Symbol('allopenissues'),
        doneissues: Symbol('doneissues'),
        recentlyviewed: Symbol('recentlyviewed'),
        resolvedrecently: Symbol('resolvedrecently'),
        updatedrecently: Symbol('updatedrecently'),
        allissues: Symbol('allissues')
    };
    const $8e65b6d66c73d810$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
    const $8e65b6d66c73d810$export$66816805c55e43b7 = 'jira.issues.preferred.layout.key';
    const $8e65b6d66c73d810$export$393cb330f31d305c = $8e65b6d66c73d810$export$2bd49f8f262d7cbb.created;
    const $8e65b6d66c73d810$export$8ea18fa9e35fdf25 = $8e65b6d66c73d810$export$73034536b9adc928.DESC;
    const $8e65b6d66c73d810$export$500b5c379b5c7f2e = 'list_default';
    const $8e65b6d66c73d810$export$f88f58d1a4b2078b = 50;
    const $8e65b6d66c73d810$export$8c67ad1f64ab5a9c = ()=>$8e65b6d66c73d810$export$f88f58d1a4b2078b;
    const $8e65b6d66c73d810$export$9d7b852b1c962aa3 = 1000;
    const $8e65b6d66c73d810$export$f7109619a5e9e0d6 = 'issue-navigator-next';
    const $8e65b6d66c73d810$export$b8b9d90f9e5bd72b = 'jiraIssueNavigator';
    const $8e65b6d66c73d810$export$d57b6b390e78d90f = 'empanada';
    const $8e65b6d66c73d810$export$52919046b94109dc = 'showPinIssueList';
    const $8e65b6d66c73d810$export$81d9767bc5c1549e = 'issueNavigatorListView';
    const $8e65b6d66c73d810$export$524ae4278a57eea2 = 'issueNavigatorDetailView';
    const $8e65b6d66c73d810$export$af478702fa9b9a17 = 'user.search.mode';
    const $8e65b6d66c73d810$export$84f45d3374492a7c = 'BLANK';
    const $8e65b6d66c73d810$export$e1eb2ddab803c5ec = (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC);
    const $8e65b6d66c73d810$export$af225181779390f4 = 'list_default';
    const $8e65b6d66c73d810$export$608eeb3a32afef02 = (0, (0, parcelRequire("czfFt")).MAX_COLUMNS);
    const $8e65b6d66c73d810$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
    const $8e65b6d66c73d810$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
    const $8e65b6d66c73d810$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
    const $8e65b6d66c73d810$export$3630aa1c4c69277f = {
        created: {
            jqlTerm: 'created',
            fieldType: 'created',
            aliases: []
        },
        key: {
            jqlTerm: 'key',
            fieldType: 'issuekey',
            aliases: [
                'issuekey'
            ]
        },
        lastviewed: {
            jqlTerm: 'lastviewed',
            fieldType: 'lastviewed',
            aliases: []
        },
        priority: {
            jqlTerm: 'priority',
            fieldType: 'priority',
            aliases: []
        },
        resolved: {
            jqlTerm: 'resolved',
            fieldType: 'resolutiondate',
            aliases: []
        },
        status: {
            jqlTerm: 'status',
            fieldType: 'status',
            aliases: []
        },
        updated: {
            jqlTerm: 'updated',
            fieldType: 'updated',
            aliases: []
        },
        issuetype: {
            jqlTerm: 'issuetype',
            fieldType: 'issuetype',
            aliases: [
                'type'
            ]
        },
        assignee: {
            jqlTerm: 'assignee',
            fieldType: 'assignee',
            aliases: []
        },
        duedate: {
            jqlTerm: 'duedate',
            fieldType: 'duedate',
            aliases: []
        },
        reporter: {
            jqlTerm: 'reporter',
            fieldType: 'reporter',
            aliases: []
        },
        summary: {
            jqlTerm: 'summary',
            fieldType: 'summary',
            aliases: []
        }
    };
    const $8e65b6d66c73d810$export$eaadab3243bf458 = (alias)=>Object.keys($8e65b6d66c73d810$export$3630aa1c4c69277f).find((key)=>$8e65b6d66c73d810$export$3630aa1c4c69277f[key]?.aliases.includes(alias));
});
parcelRegister("032ey", function(module, exports) {
    $parcel$export(module.exports, "SEARCH_MODE_BASIC", ()=>$e090bb7ab54db3ef$export$f963d14b266e4d2e);
    $parcel$export(module.exports, "SEARCH_MODE_ADVANCED", ()=>$e090bb7ab54db3ef$export$aad1d9eb9b751555);
    $parcel$export(module.exports, "SERVER_SEARCH_MODE_BASIC", ()=>$e090bb7ab54db3ef$export$87c41a6b3123c00f);
    $parcel$export(module.exports, "SERVER_SEARCH_MODE_ADVANCED", ()=>$e090bb7ab54db3ef$export$a7a000706ebc3ba8);
    $parcel$export(module.exports, "DEFAULT_SEARCH_MODE", ()=>$e090bb7ab54db3ef$export$e1eb2ddab803c5ec);
    $parcel$export(module.exports, "mapSearchModeToAnalyticAtribute", ()=>$e090bb7ab54db3ef$export$70c8f980e4a50682);
    $parcel$export(module.exports, "SEARCH_MODE_SWITCHER_LEFT_LOCATION", ()=>$e090bb7ab54db3ef$export$4dab29e715a4e6fb);
    $parcel$export(module.exports, "SEARCH_MODE_SWITCHER_RIGHT_LOCATION", ()=>$e090bb7ab54db3ef$export$59848395da0b4bcb);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$e090bb7ab54db3ef$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$e090bb7ab54db3ef$export$d57b6b390e78d90f);
    const $e090bb7ab54db3ef$export$f963d14b266e4d2e = 'basic';
    const $e090bb7ab54db3ef$export$aad1d9eb9b751555 = 'advanced';
    const $e090bb7ab54db3ef$export$87c41a6b3123c00f = 'BASIC';
    const $e090bb7ab54db3ef$export$a7a000706ebc3ba8 = 'ADVANCED';
    const $e090bb7ab54db3ef$export$e1eb2ddab803c5ec = $e090bb7ab54db3ef$export$f963d14b266e4d2e;
    const $e090bb7ab54db3ef$export$70c8f980e4a50682 = {
        [$e090bb7ab54db3ef$export$f963d14b266e4d2e]: $e090bb7ab54db3ef$export$f963d14b266e4d2e,
        [$e090bb7ab54db3ef$export$aad1d9eb9b751555]: 'JQL'
    };
    const $e090bb7ab54db3ef$export$4dab29e715a4e6fb = 'Left';
    const $e090bb7ab54db3ef$export$59848395da0b4bcb = 'Right';
    const $e090bb7ab54db3ef$export$b8b9d90f9e5bd72b = 'jiraJqlBuilder';
    const $e090bb7ab54db3ef$export$d57b6b390e78d90f = 'empanada';
});
parcelRegister("16Yit", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$296a6f030570708c$export$2e2bcd8739ae039);
    const $296a6f030570708c$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeJira"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeUser"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isFilter"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewContext"
        }, v8 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v9 = {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }, v10 = [
            {
                "kind": "Variable",
                "name": "query",
                "variableName": "jql"
            },
            v9
        ], v11 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v12 = [
            v11
        ], v13 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "filterAri"
            },
            v9
        ], v14 = {
            "kind": "ScalarField",
            "name": "id"
        }, v15 = [
            v11,
            {
                "kind": "ScalarField",
                "name": "picture"
            },
            v14
        ], v16 = {
            "kind": "ScalarField",
            "name": "jqlTerm"
        }, v17 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v18 = {
            "kind": "ScalarField",
            "name": "key"
        }, v19 = [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "colorName"
                    },
                    v14
                ]
            }
        ], v20 = {
            "kind": "ScalarField",
            "name": "optionId"
        }, v21 = [
            v11,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jql"
                    },
                    {
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                            v11,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v16,
                                    {
                                        "concreteType": "JiraJqlField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            {
                                                "concreteType": "JiraJqlSearchTemplate",
                                                "kind": "LinkedField",
                                                "name": "searchTemplate",
                                                "plural": false,
                                                "selections": [
                                                    v18
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "shouldShowInContext"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "type"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "description"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "operators"
                                            },
                                            {
                                                "concreteType": "JiraFieldType",
                                                "kind": "LinkedField",
                                                "name": "fieldType",
                                                "plural": false,
                                                "selections": [
                                                    v17
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": true,
                                        "selections": [
                                            v11,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v16,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "values",
                                                        "plural": true,
                                                        "selections": [
                                                            v11,
                                                            v16,
                                                            v17,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v18,
                                                                            {
                                                                                "concreteType": "JiraAvatar",
                                                                                "kind": "LinkedField",
                                                                                "name": "avatar",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "small"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v14
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlProjectFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v19,
                                                                "type": "JiraJqlStatusFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v19,
                                                                "type": "JiraJqlStatusCategoryFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraAvatar",
                                                                                "kind": "LinkedField",
                                                                                "name": "avatar",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "xsmall"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v14
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueTypeFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": v15
                                                                    }
                                                                ],
                                                                "type": "JiraJqlUserFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "iconUrl"
                                                                            },
                                                                            v14
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlPriorityFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "issue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "fields",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v11,
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "text"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraSingleLineTextField"
                                                                                                    },
                                                                                                    v14
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v14
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprint",
                                                                        "kind": "LinkedField",
                                                                        "name": "sprint",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "state"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "boardName"
                                                                            },
                                                                            v14
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlSprintFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v20,
                                                                    {
                                                                        "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "parentOption",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v17,
                                                                            v16,
                                                                            v20
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlCascadingOptionFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraJqlQueryHydratedValue"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v16,
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "error",
                                                        "plural": false,
                                                        "selections": v12
                                                    }
                                                ],
                                                "type": "JiraJqlQueryHydratedError"
                                            }
                                        ]
                                    }
                                ],
                                "type": "JiraJqlQueryHydratedField"
                            }
                        ]
                    }
                ],
                "type": "JiraJqlHydratedQuery"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "message"
                    }
                ],
                "type": "QueryError"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7
                ],
                "kind": "Fragment",
                "name": "hydrateJqlBuilderQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "useHydratedValues"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "useQuery"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "useHydratedValues_cascadeSelectPicker"
                    },
                    {
                        "condition": "includeJira",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8,
                                        "concreteType": "JiraJqlBuilder",
                                        "kind": "LinkedField",
                                        "name": "jqlBuilder",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "args": v10,
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQuery",
                                                        "plural": false,
                                                        "selections": v12
                                                    }
                                                ]
                                            },
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "args": v13,
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQueryForFilter",
                                                        "plural": false,
                                                        "selections": v12
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v4,
                    v3,
                    v6,
                    v7,
                    v5,
                    v2
                ],
                "kind": "Operation",
                "name": "hydrateJqlBuilderQuery",
                "selections": [
                    {
                        "condition": "includeUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "accountId",
                                        "variableName": "accountId"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": v15
                            }
                        ]
                    },
                    {
                        "condition": "includeJira",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8,
                                        "concreteType": "JiraJqlBuilder",
                                        "kind": "LinkedField",
                                        "name": "jqlBuilder",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "args": v10,
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQuery",
                                                        "plural": false,
                                                        "selections": v21
                                                    }
                                                ]
                                            },
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "args": v13,
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQueryForFilter",
                                                        "plural": false,
                                                        "selections": v21
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "9602274b79312da6d4fce360793e0d6dc55d0815c5a161700d98a107e8d8ab11",
                "metadata": {},
                "name": "hydrateJqlBuilderQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $296a6f030570708c$var$node.hash = "ef4d25dee5032fff501c9296551e458d";
    var $296a6f030570708c$export$2e2bcd8739ae039 = $296a6f030570708c$var$node;
});
parcelRegister("kvekU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d76682723f87707c$export$2e2bcd8739ae039);
    const $d76682723f87707c$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filterAri"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "includeFilter"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "main_FilterQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigator_filterQuery"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "main_FilterQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "includeFilter",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "id",
                                                "variableName": "filterAri"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "filter",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isJiraFilter"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "jql"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isEditable"
                                                    }
                                                ],
                                                "type": "JiraCustomFilter"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "filterId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isFavourite"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5",
                "metadata": {},
                "name": "main_FilterQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $d76682723f87707c$var$node.hash = "181bb07a6bafd05a2033750384a06766";
    var $d76682723f87707c$export$2e2bcd8739ae039 = $d76682723f87707c$var$node;
});
parcelRegister("hTvlq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff9dfb30fc1873c4$export$2e2bcd8739ae039);
    var $hLeia;
    var $bqIzm;
    var $5oQtH;
    var $1q6lK;
    var $1ZvTA;
    var $G39h7;
    var $6vKPN;
    var $dttgK;
    var $1kHcz;
    const $ff9dfb30fc1873c4$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "amountOfColumns"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "atlassianIntelligenceProductFeature"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "before"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fieldSetIds"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fieldSetsInput"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterId"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v9 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "groupBy"
        }, v10 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        }, v11 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueTypeId"
        }, v12 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "last"
        }, v13 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "namespace"
        }, v14 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "options"
        }, v15 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }, v16 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v17 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryFieldSetsById"
        }, v18 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryProject"
        }, v19 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "staticViewInput"
        }, v20 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewConfigInput"
        }, v21 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewId"
        }, v22 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v23 = [
            v22
        ], v24 = [
            v22,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v25 = {
            "kind": "ScalarField",
            "name": "__id"
        }, v26 = {
            "kind": "ClientExtension",
            "selections": [
                v25
            ]
        }, v27 = [
            {
                "fields": [
                    {
                        "kind": "Variable",
                        "name": "feature",
                        "variableName": "atlassianIntelligenceProductFeature"
                    }
                ],
                "kind": "ObjectValue",
                "name": "atlassianIntelligenceProductFeatureInput"
            },
            v22
        ], v28 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v29 = {
            "kind": "ScalarField",
            "name": "id"
        }, v30 = [
            {
                "concreteType": "JiraIssueTypeHierarchyLevel",
                "kind": "LinkedField",
                "name": "hierarchy",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "level"
                    }
                ]
            },
            v29
        ], v31 = {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        }, v32 = {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        }, v33 = {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        }, v34 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }, v35 = {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }, v36 = {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        }, v37 = {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        }, v38 = {
            "kind": "ScalarField",
            "name": "key"
        }, v39 = {
            "kind": "ScalarField",
            "name": "issueId"
        }, v40 = {
            "kind": "ScalarField",
            "name": "isResolved"
        }, v41 = {
            "kind": "ScalarField",
            "name": "fieldId"
        }, v42 = {
            "kind": "ScalarField",
            "name": "statusCategoryId"
        }, v43 = {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                v42,
                v29
            ]
        }, v44 = {
            "args": [
                {
                    "kind": "Literal",
                    "name": "ids",
                    "value": [
                        "status"
                    ]
                }
            ],
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fieldsById",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v28,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v41,
                                        {
                                            "concreteType": "JiraStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                                v43,
                                                v29
                                            ]
                                        }
                                    ],
                                    "type": "JiraStatusField"
                                },
                                v29
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "fieldsById(ids:[\"status\"])"
        }, v45 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasChildren"
                },
                {
                    "concreteType": "JiraIssueTypeField",
                    "kind": "LinkedField",
                    "name": "issueTypeField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": v30
                        },
                        v29
                    ]
                }
            ]
        }, v46 = {
            "kind": "Variable",
            "name": "filterId",
            "variableName": "filterId"
        }, v47 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }, v48 = {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
        }, v49 = {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }, v50 = [
            {
                "fields": [
                    {
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "issueType",
                                "variableName": "issueTypeId"
                            },
                            {
                                "kind": "Variable",
                                "name": "project",
                                "variableName": "projectId"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "projectContext"
                    }
                ],
                "kind": "ObjectValue",
                "name": "context"
            },
            v46,
            v47,
            v48,
            v49
        ], v51 = {
            "kind": "ScalarField",
            "name": "text"
        }, v52 = {
            "kind": "ScalarField",
            "name": "name"
        }, v53 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v54 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "small"
                }
            ]
        }, v55 = {
            "kind": "ScalarField",
            "name": "type"
        }, v56 = {
            "kind": "ScalarField",
            "name": "fieldSetId"
        }, v57 = {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isJiraIssueField"
        }, v58 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraAffectedServiceConnection",
                    "kind": "LinkedField",
                    "name": "selectedAffectedServicesConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraAffectedServiceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraAffectedService",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "serviceId"
                                        },
                                        v52,
                                        v29
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraAffectedServicesField"
        }, v59 = {
            "kind": "ScalarField",
            "name": "message"
        }, v60 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraCmdbObjectConnection",
                    "kind": "LinkedField",
                    "name": "selectedCmdbObjectsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraCmdbObjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraCmdbObject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "objectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        },
                                        {
                                            "concreteType": "JiraCmdbAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrccmdbmediaavatarfgrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                            "kind": "LinkedField",
                                                            "name": "mediaClientConfig",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "clientId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fileId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaBaseUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaJwtToken"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url48"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v59
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraCMDBField"
        }, v61 = [
            v52,
            v29
        ], v62 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraComponentConnection",
                    "kind": "LinkedField",
                    "name": "selectedComponentsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraComponentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraComponent",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": v61
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraComponentsField"
        }, v63 = {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        }, v64 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lazyIsEditableInIssueView"
                }
            ]
        }, v65 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "date"
                },
                v52,
                v63,
                v64
            ],
            "type": "JiraDatePickerField"
        }, v66 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "dateTime"
                }
            ],
            "type": "JiraDateTimePickerField"
        }, v67 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraEpic",
                    "kind": "LinkedField",
                    "name": "epic",
                    "plural": false,
                    "selections": [
                        v38,
                        {
                            "kind": "ScalarField",
                            "name": "summary"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        v29
                    ]
                }
            ],
            "type": "JiraEpicLinkField"
        }, v68 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "renderedFieldHtml"
                }
            ],
            "type": "JiraFallbackField"
        }, v69 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                        v52,
                        {
                            "kind": "ScalarField",
                            "name": "statusId"
                        },
                        v43,
                        v29
                    ]
                }
            ],
            "type": "JiraStatusField"
        }, v70 = [
            v52
        ], v71 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v72 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1000
                        }
                    ],
                    "concreteType": "JiraLabelConnection",
                    "kind": "LinkedField",
                    "name": "selectedLabelsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraLabelEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraLabel",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": v70
                                }
                            ]
                        },
                        v71
                    ],
                    "storageKey": "selectedLabelsConnection(first:1000)"
                },
                v52,
                v64
            ],
            "type": "JiraLabelsField"
        }, v73 = {
            "concreteType": "JiraColor",
            "kind": "LinkedField",
            "name": "color",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorKey"
                },
                v29
            ]
        }, v74 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }, v75 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "parentIssue",
                    "plural": false,
                    "selections": [
                        v38,
                        {
                            "concreteType": "JiraSingleLineTextField",
                            "kind": "LinkedField",
                            "name": "summaryField",
                            "plural": false,
                            "selections": [
                                v51,
                                v29
                            ]
                        },
                        v29,
                        {
                            "concreteType": "JiraColorField",
                            "kind": "LinkedField",
                            "name": "issueColorField",
                            "plural": false,
                            "selections": [
                                v73,
                                v29
                            ]
                        },
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        v74,
                                        v52,
                                        v29
                                    ]
                                },
                                v29
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraParentIssueField"
        }, v76 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v77 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraPriority",
                    "kind": "LinkedField",
                    "name": "priority",
                    "plural": false,
                    "selections": [
                        v52,
                        v76,
                        v29
                    ]
                },
                v52,
                v64
            ],
            "type": "JiraPriorityField"
        }, v78 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        v52,
                        v38,
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        },
                        v29
                    ]
                }
            ],
            "type": "JiraProjectField"
        }, v79 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraResolution",
                    "kind": "LinkedField",
                    "name": "resolution",
                    "plural": false,
                    "selections": v61
                }
            ],
            "type": "JiraResolutionField"
        }, v80 = {
            "kind": "ScalarField",
            "name": "state"
        }, v81 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraSprintConnection",
                    "kind": "LinkedField",
                    "name": "selectedSprintsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraSprintEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraSprint",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v29,
                                        {
                                            "kind": "ScalarField",
                                            "name": "sprintId"
                                        },
                                        v52,
                                        v80,
                                        {
                                            "kind": "ScalarField",
                                            "name": "endDate"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v52,
                v64
            ],
            "type": "JiraSprintField"
        }, v82 = {
            "kind": "ScalarField",
            "name": "accountId"
        }, v83 = {
            "kind": "ScalarField",
            "name": "accountStatus"
        }, v84 = {
            "kind": "InlineFragment",
            "selections": [
                v52,
                {
                    "concreteType": "JiraVersionConnection",
                    "kind": "LinkedField",
                    "name": "selectedVersionsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraVersionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": v61
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraMultipleVersionPickerField"
        }, v85 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraRichText",
                    "kind": "LinkedField",
                    "name": "richText",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraADF",
                            "kind": "LinkedField",
                            "name": "adfValue",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAdfToConvertedPlainText",
                                    "kind": "LinkedField",
                                    "name": "convertedPlainText",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "plainText"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraRichTextField"
        }, v86 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraServiceManagementRequestType",
                    "kind": "LinkedField",
                    "name": "requestType",
                    "plural": false,
                    "selections": [
                        v52,
                        v74,
                        v29
                    ]
                }
            ],
            "type": "JiraServiceManagementRequestTypeField"
        }, v87 = {
            "kind": "ScalarField",
            "name": "hasNextPage"
        }, v88 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                        }
                    ],
                    "concreteType": "JiraIssueLinkConnection",
                    "kind": "LinkedField",
                    "name": "issueLinkConnection",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v87
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v71
                            ]
                        },
                        {
                            "concreteType": "JiraIssueLinkEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLink",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                v38,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "statusCategory"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v28,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v43
                                                                            ],
                                                                            "type": "JiraStatusCategoryField"
                                                                        },
                                                                        v29
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                },
                                                v29
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "relationName"
                                        },
                                        v29
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraIssueLinkField"
        }, v89 = {
            "kind": "ScalarField",
            "name": "number"
        }, v90 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isStoryPointField"
                        },
                        v89,
                        v52,
                        v64
                    ],
                    "type": "JiraNumberField"
                }
            ]
        }, v91 = [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v55,
                            v56,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v28,
                                                    v41,
                                                    v55,
                                                    v57,
                                                    v29,
                                                    v58,
                                                    v60,
                                                    v62,
                                                    v65,
                                                    v66,
                                                    v67,
                                                    v68,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v51,
                                                            v52,
                                                            v64
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    v52,
                                                                    v42,
                                                                    v29
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusCategoryField"
                                                    },
                                                    v69,
                                                    v72,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v54,
                                                                    v52,
                                                                    v29
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v75,
                                                    v77,
                                                    v78,
                                                    v79,
                                                    v81,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v28,
                                                                    v82,
                                                                    v53,
                                                                    v52,
                                                                    v29,
                                                                    v83
                                                                ]
                                                            },
                                                            v52,
                                                            v63,
                                                            v64
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    v84,
                                                    v85,
                                                    v86,
                                                    v88,
                                                    v90
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ], v92 = {
            "condition": "shouldQueryFieldSetsById",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "fieldSetIds",
                            "variableName": "fieldSetIds"
                        },
                        v47
                    ],
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsById",
                    "plural": false,
                    "selections": v91
                }
            ]
        }, v93 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": v50,
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsForIssueSearchView",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fields",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v28,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v41,
                                                                        v51,
                                                                        v52
                                                                    ],
                                                                    "type": "JiraSingleLineTextField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v41,
                                                                        v52,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v28,
                                                                                v52,
                                                                                v53,
                                                                                v29
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v41,
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v52,
                                                                                v54,
                                                                                v29
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraIssueTypeField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v41,
                                                                        v43
                                                                    ],
                                                                    "type": "JiraStatusCategoryField"
                                                                },
                                                                v29
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v92,
                {
                    "condition": "shouldQueryFieldSetsById",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v50,
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsForIssueSearchView",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v55,
                                                v56,
                                                {
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v41,
                                                                        v55,
                                                                        v57,
                                                                        v58,
                                                                        v60,
                                                                        v62,
                                                                        v65,
                                                                        v66,
                                                                        v67,
                                                                        v68,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v55,
                                                                                v64
                                                                            ],
                                                                            "type": "JiraSingleLineTextField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraStatusCategory",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "statusCategory",
                                                                                    "plural": false,
                                                                                    "selections": v70
                                                                                }
                                                                            ],
                                                                            "type": "JiraStatusCategoryField"
                                                                        },
                                                                        v69,
                                                                        v72,
                                                                        v75,
                                                                        v77,
                                                                        v78,
                                                                        v79,
                                                                        v81,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v55,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v82,
                                                                                        v83
                                                                                    ]
                                                                                },
                                                                                v63,
                                                                                v64
                                                                            ],
                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                        },
                                                                        v84,
                                                                        v85,
                                                                        v86,
                                                                        v88,
                                                                        v90
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v94 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isHighlightedIssueRow"
                },
                v25
            ]
        }, v95 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 500
                        }
                    ],
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": v91,
                    "storageKey": "fieldSets(first:500)"
                }
            ]
        }, v96 = {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        }, v97 = [
            {
                "kind": "Literal",
                "name": "maxCursors",
                "value": 7
            }
        ], v98 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v99 = {
            "kind": "ScalarField",
            "name": "isCurrent"
        }, v100 = {
            "kind": "ScalarField",
            "name": "pageNumber"
        }, v101 = [
            v100,
            v98,
            v99
        ], v102 = {
            "concreteType": "JiraPageCursor",
            "kind": "LinkedField",
            "name": "last",
            "plural": false,
            "selections": v101
        }, v103 = {
            "concreteType": "JiraPageCursor",
            "kind": "LinkedField",
            "name": "first",
            "plural": false,
            "selections": [
                v98,
                v100,
                v99
            ]
        }, v104 = {
            "kind": "ScalarField",
            "name": "firstIssuePosition"
        }, v105 = {
            "kind": "ScalarField",
            "name": "lastIssuePosition"
        }, v106 = {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                v28,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "messages"
                        }
                    ],
                    "type": "JiraInvalidJqlError"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v59,
                        {
                            "kind": "ScalarField",
                            "name": "errorType"
                        }
                    ],
                    "type": "JiraInvalidSyntaxError"
                }
            ]
        }, v107 = {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }, v108 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v109 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v50,
                                    "concreteType": "JiraIssueFieldSetConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldSetsForIssueSearchView",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSet",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fields",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v28,
                                                                                v57,
                                                                                v41,
                                                                                v29
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v110 = [
            v22,
            v46,
            v35,
            v48,
            v49
        ], v111 = {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isJiraIssueSearchViewResult"
        }, v112 = {
            "kind": "ScalarField",
            "name": "viewId"
        }, v113 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": {
                    "fieldSetSelectedState": "SELECTED"
                }
            },
            v47
        ], v114 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v115 = {
            "concreteType": "JiraIssueSearchFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v56,
                        v55,
                        v114,
                        {
                            "kind": "ScalarField",
                            "name": "jqlTerm"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isSortable"
                        },
                        {
                            "concreteType": "JiraFieldSetPreferences",
                            "kind": "LinkedField",
                            "name": "fieldSetPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraFieldType",
                            "kind": "LinkedField",
                            "name": "fieldType",
                            "plural": false,
                            "selections": [
                                v114
                            ]
                        }
                    ]
                }
            ]
        }, v116 = {
            "kind": "ScalarField",
            "name": "hasDefaultFieldSets"
        }, v117 = {
            "kind": "ScalarField",
            "name": "isGroupingEnabled"
        }, v118 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewConfigSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableHierarchy"
                        },
                        v117,
                        v26
                    ]
                }
            ]
        }, v119 = {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v28,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }, v120 = {
            "kind": "InlineFragment",
            "selections": [
                v59,
                v119
            ],
            "type": "QueryError"
        }, v121 = [
            v29
        ], v122 = {
            "kind": "InlineFragment",
            "selections": v121,
            "type": "Node",
            "abstractKey": "__isNode"
        }, v123 = [
            v31,
            v32,
            v22,
            v33,
            v34,
            v35,
            v36,
            v37,
            {
                "kind": "Variable",
                "name": "viewConfigInput",
                "variableName": "viewConfigInput"
            }
        ], v124 = {
            "kind": "ScalarField",
            "name": "endCursor"
        }, v125 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v124,
                v87,
                {
                    "kind": "ScalarField",
                    "name": "hasPreviousPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "startCursor"
                }
            ]
        }, v126 = [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    v98,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v28,
                            v29,
                            v38,
                            v39,
                            v40,
                            v44,
                            v45,
                            v93,
                            v94
                        ]
                    },
                    v28,
                    v95
                ]
            },
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    v104,
                    v105
                ]
            },
            {
                "args": v97,
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v101
                    },
                    v102,
                    v103
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            v96,
            v106,
            v107,
            v108,
            v125,
            v26,
            v109
        ], v127 = [
            "issueSearchInput"
        ], v128 = [
            v31,
            v32,
            v34,
            v35,
            v36
        ], v129 = [
            v31,
            v32,
            v34,
            {
                "kind": "Variable",
                "name": "groupBy",
                "variableName": "groupBy"
            },
            v35,
            v36
        ], v130 = {
            "kind": "LinkedField",
            "name": "fieldValue",
            "plural": false,
            "selections": [
                v28,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "JiraPriority",
                            "kind": "LinkedField",
                            "name": "priority",
                            "plural": false,
                            "selections": [
                                v29,
                                v76
                            ]
                        },
                        v114
                    ],
                    "type": "JiraJqlPriorityFieldValue"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v28,
                                v29,
                                v53
                            ]
                        },
                        v114
                    ],
                    "type": "JiraJqlUserFieldValue"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "JiraStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": v121
                        },
                        v114,
                        v43
                    ],
                    "type": "JiraJqlStatusFieldValue"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v89
                    ],
                    "type": "JiraJqlNumberFieldValue"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "option",
                            "plural": false,
                            "selections": [
                                v29,
                                v73
                            ]
                        },
                        v114
                    ],
                    "type": "JiraJqlOptionFieldValue"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": [
                                v29,
                                v80
                            ]
                        },
                        v114
                    ],
                    "type": "JiraJqlSprintFieldValue"
                }
            ]
        }, v131 = {
            "kind": "ScalarField",
            "name": "fieldType"
        }, v132 = {
            "kind": "ScalarField",
            "name": "issueCount"
        }, v133 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 50
            }
        ], v134 = [
            v31,
            v32,
            v33,
            v34,
            v35,
            v36
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    v16,
                    v17,
                    v18,
                    v19,
                    v20,
                    v21
                ],
                "kind": "Fragment",
                "name": "main_IssueNavigatorQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigator_issueQuery"
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v23,
                                "concreteType": "JiraUserPreferences",
                                "kind": "LinkedField",
                                "name": "userPreferences",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigator_userPreferences"
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "main_issueNavigator_IssueNavigator_jira"
                            },
                            {
                                "condition": "shouldQueryProject",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": v24,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "main_issueNavigator_IssueNavigatorUI_project"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v4,
                    v10,
                    v8,
                    v12,
                    v3,
                    v0,
                    v13,
                    v21,
                    v14,
                    v6,
                    v7,
                    v5,
                    v17,
                    v1,
                    v2,
                    v11,
                    v15,
                    v16,
                    v18,
                    v19,
                    v20,
                    v9,
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrccmdbmediaavatarfgrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider"
                    }
                ],
                "kind": "Operation",
                "name": "main_IssueNavigatorQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v23,
                                "concreteType": "JiraUserPreferences",
                                "kind": "LinkedField",
                                "name": "userPreferences",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "jqlBuilderSearchMode"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isNaturalLanguageSpotlightTourEnabled"
                                    },
                                    v26
                                ]
                            },
                            {
                                "args": v27,
                                "kind": "ScalarField",
                                "name": "shouldShowAtlassianIntelligence"
                            },
                            {
                                "args": v27,
                                "kind": "LinkedField",
                                "name": "atlassianIntelligenceAction",
                                "plural": false,
                                "selections": [
                                    v28,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "isAccessible"
                                            }
                                        ],
                                        "type": "JiraAccessAtlassianIntelligenceFeature"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "link"
                                            }
                                        ],
                                        "type": "JiraEnableAtlassianIntelligenceDeepLink"
                                    }
                                ]
                            },
                            {
                                "condition": "shouldQueryProject",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": v24,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueTypeEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": v30
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "projectId"
                                            },
                                            v29
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            v31,
                                            v32,
                                            v22,
                                            v33,
                                            v34,
                                            v35,
                                            v36,
                                            v37
                                        ],
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issueSearchStable",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v38,
                                                            v29,
                                                            v39,
                                                            v40,
                                                            v44,
                                                            v45,
                                                            v93,
                                                            v94
                                                        ]
                                                    },
                                                    v28,
                                                    v26,
                                                    v95
                                                ]
                                            },
                                            v96,
                                            {
                                                "args": v97,
                                                "concreteType": "JiraPageCursors",
                                                "kind": "LinkedField",
                                                "name": "pageCursors",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraPageCursor",
                                                        "kind": "LinkedField",
                                                        "name": "around",
                                                        "plural": true,
                                                        "selections": [
                                                            v98,
                                                            v99,
                                                            v100
                                                        ]
                                                    },
                                                    v102,
                                                    v103
                                                ],
                                                "storageKey": "pageCursors(maxCursors:7)"
                                            },
                                            {
                                                "concreteType": "JiraIssueNavigatorPageInfo",
                                                "kind": "LinkedField",
                                                "name": "issueNavigatorPageInfo",
                                                "plural": false,
                                                "selections": [
                                                    v104,
                                                    v105,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "firstIssueKeyFromNextPage"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "lastIssueKeyFromPreviousPage"
                                                    }
                                                ]
                                            },
                                            v106,
                                            v107,
                                            v108,
                                            v26,
                                            v109
                                        ]
                                    },
                                    {
                                        "args": v110,
                                        "kind": "LinkedField",
                                        "name": "issueSearchViewResult",
                                        "plural": false,
                                        "selections": [
                                            v28,
                                            v111,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v112,
                                                    {
                                                        "args": v113,
                                                        "concreteType": "JiraIssueSearchFieldSetConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSets",
                                                        "plural": false,
                                                        "selections": [
                                                            v115,
                                                            v71,
                                                            v26
                                                        ]
                                                    },
                                                    v29,
                                                    v116,
                                                    v118
                                                ],
                                                "type": "JiraIssueSearchView"
                                            },
                                            v120,
                                            v122
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v110,
                                        "kind": "LinkedField",
                                        "name": "issueSearchViewResult",
                                        "plural": false,
                                        "selections": [
                                            v28,
                                            v111,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v112,
                                                    v29,
                                                    v116,
                                                    {
                                                        "args": v113,
                                                        "concreteType": "JiraIssueSearchFieldSetConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSets",
                                                        "plural": false,
                                                        "selections": [
                                                            v71,
                                                            v115,
                                                            v26
                                                        ]
                                                    },
                                                    v118
                                                ],
                                                "type": "JiraIssueSearchView"
                                            },
                                            v120,
                                            v122
                                        ]
                                    },
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": v123,
                                                "concreteType": "JiraIssueConnection",
                                                "kind": "LinkedField",
                                                "name": "issueSearch",
                                                "plural": false,
                                                "selections": v126
                                            },
                                            {
                                                "args": v123,
                                                "filters": v127,
                                                "handle": "connection",
                                                "key": "IssueNavigatorIssueSearchPagination__issueSearch",
                                                "kind": "LinkedHandle",
                                                "name": "issueSearch"
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    v22,
                                                    v35,
                                                    v48,
                                                    v49
                                                ],
                                                "kind": "LinkedField",
                                                "name": "jiraIssueSearchView",
                                                "plural": false,
                                                "selections": [
                                                    v28,
                                                    v29,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v128,
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v126
                                                            },
                                                            {
                                                                "args": v128,
                                                                "filters": v127,
                                                                "handle": "connection",
                                                                "key": "IssueNavigatorDetailedViewPagination__issues",
                                                                "kind": "LinkedHandle",
                                                                "name": "issues"
                                                            }
                                                        ],
                                                        "type": "JiraDetailedView"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v129,
                                                                "concreteType": "JiraSpreadsheetGroupConnection",
                                                                "kind": "LinkedField",
                                                                "name": "groups",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSpreadsheetGroupEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v98,
                                                                            {
                                                                                "concreteType": "JiraSpreadsheetGroup",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v28,
                                                                                    v29,
                                                                                    v130,
                                                                                    v131,
                                                                                    v132,
                                                                                    v108
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraSpreadsheetGroup",
                                                                        "kind": "LinkedField",
                                                                        "name": "firstGroup",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v29,
                                                                            {
                                                                                "args": v133,
                                                                                "concreteType": "JiraIssueConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "issues",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssue",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v39,
                                                                                                    v29,
                                                                                                    v28,
                                                                                                    v38,
                                                                                                    v40,
                                                                                                    v44,
                                                                                                    v45,
                                                                                                    {
                                                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                                                                        "kind": "Condition",
                                                                                                        "passingValue": false,
                                                                                                        "selections": [
                                                                                                            v92,
                                                                                                            {
                                                                                                                "condition": "shouldQueryFieldSetsById",
                                                                                                                "kind": "Condition",
                                                                                                                "passingValue": false,
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "args": v50,
                                                                                                                        "concreteType": "JiraIssueFieldSetConnection",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "fieldSetsForIssueSearchView",
                                                                                                                        "plural": false,
                                                                                                                        "selections": v91
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    v94
                                                                                                ]
                                                                                            },
                                                                                            v28,
                                                                                            v98,
                                                                                            v95
                                                                                        ]
                                                                                    },
                                                                                    v108,
                                                                                    {
                                                                                        "concreteType": "PageInfo",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "pageInfo",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v124,
                                                                                            v87
                                                                                        ]
                                                                                    },
                                                                                    v26
                                                                                ],
                                                                                "storageKey": "issues(first:50)"
                                                                            },
                                                                            {
                                                                                "args": v133,
                                                                                "handle": "connection",
                                                                                "key": "firstGroupSection_nativeIssueTable__issues",
                                                                                "kind": "LinkedHandle",
                                                                                "name": "issues"
                                                                            },
                                                                            v108,
                                                                            v130,
                                                                            v131,
                                                                            v132
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "QueryError",
                                                                        "kind": "LinkedField",
                                                                        "name": "errors",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v119,
                                                                            v59
                                                                        ]
                                                                    },
                                                                    v125,
                                                                    v26
                                                                ]
                                                            },
                                                            {
                                                                "args": v129,
                                                                "filters": v127,
                                                                "handle": "connection",
                                                                "key": "IssueNavigatorGroupedListViewPagination__groups",
                                                                "kind": "LinkedHandle",
                                                                "name": "groups"
                                                            }
                                                        ],
                                                        "type": "JiraGroupedListView"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v134,
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v126
                                                            },
                                                            {
                                                                "args": v134,
                                                                "filters": v127,
                                                                "handle": "connection",
                                                                "key": "IssueNavigatorListViewPagination__issues",
                                                                "kind": "LinkedHandle",
                                                                "name": "issues"
                                                            }
                                                        ],
                                                        "type": "JiraListView"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                "kind": "LinkedField",
                                                                "name": "viewSettings",
                                                                "plural": false,
                                                                "selections": [
                                                                    v117,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "canEnableGrouping"
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraSpreadsheetGroupByConfig",
                                                                        "kind": "LinkedField",
                                                                        "name": "groupByConfig",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraField",
                                                                                "kind": "LinkedField",
                                                                                "name": "groupByField",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v52,
                                                                                    v29,
                                                                                    v41
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSpreadsheetView",
                                                        "abstractKey": "__isJiraSpreadsheetView"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "9724dd023909fbebd2db71a60afcd1d438323554ae86d501d0f56001b3766f0a",
                "metadata": {},
                "name": "main_IssueNavigatorQuery",
                "operationKind": "query",
                "text": null,
                "providedVariables": {
                    "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, (0, parcelRequire("5oQtH")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, (0, parcelRequire("bqIzm")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, (0, parcelRequire("dttgK")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider": (0, (0, parcelRequire("1kHcz")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrccmdbmediaavatarfgrelayprovider": (0, (0, parcelRequire("hLeia")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider": (0, (0, parcelRequire("G39h7")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider": (0, (0, parcelRequire("1ZvTA")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider": (0, (0, parcelRequire("6vKPN")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider": (0, (0, parcelRequire("1q6lK")).default)
                }
            }
        };
    }();
    $ff9dfb30fc1873c4$var$node.hash = "a26d96051f2d1390d4bbf743be89ce1b";
    var $ff9dfb30fc1873c4$export$2e2bcd8739ae039 = $ff9dfb30fc1873c4$var$node;
});
parcelRegister("bqIzm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d9218d128e87a96$export$2e2bcd8739ae039);
    var $4R6GH;
    const $9d9218d128e87a96$export$8777089b74f8b497 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('bulk_operations_in_nin');
        }
    };
    var $9d9218d128e87a96$export$2e2bcd8739ae039 = $9d9218d128e87a96$export$8777089b74f8b497;
});
parcelRegister("1q6lK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$181eac5504cd1c95$export$2e2bcd8739ae039);
    var $4R6GH;
    var $181eac5504cd1c95$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('refactor_nin_to_jira_view_schema');
        }
    };
});
parcelRegister("5bSAg", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY", ()=>$2134dee38b024167$export$c300d3b7f3dc697d);
    $parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY", ()=>$2134dee38b024167$export$b99d8b4e19091835);
    $parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY", ()=>$2134dee38b024167$export$1b65799bbeba8a33);
    $parcel$export(module.exports, "defaultOrderFields", ()=>$2134dee38b024167$export$2bd49f8f262d7cbb);
    $parcel$export(module.exports, "sortDirections", ()=>$2134dee38b024167$export$73034536b9adc928);
    const $2134dee38b024167$export$c300d3b7f3dc697d = 'ISSUE_NAVIGATOR_RELAY';
    const $2134dee38b024167$export$b99d8b4e19091835 = 'ISSUE_NAVIGATOR_FILTER_RELAY';
    const $2134dee38b024167$export$1b65799bbeba8a33 = 'ISSUE_NAVIGATOR_HYDRATION_RELAY';
    const $2134dee38b024167$export$2bd49f8f262d7cbb = {
        created: 'created',
        lastviewed: 'lastviewed',
        updated: 'updated'
    };
    const $2134dee38b024167$export$73034536b9adc928 = {
        ASC: 'ASC',
        DESC: 'DESC',
        NONE: 'NONE'
    };
});
parcelRegister("aBKbA", function(module, exports) {
    $parcel$export(module.exports, "getDefaultJqlGin", ()=>$b87185164056f069$export$8780b1523384f42d);
    $parcel$export(module.exports, "getParams", ()=>$b87185164056f069$export$ec161d740909e39d);
    $parcel$export(module.exports, "getJqlOrFilterId", ()=>$b87185164056f069$export$b968a035fc2aa57b);
    var $9Nvh7;
    var $g5X3G;
    var $8zzKy;
    var $5bSAg;
    const $b87185164056f069$export$8780b1523384f42d = ()=>`ORDER BY ${(0, (0, parcelRequire("5bSAg")).defaultOrderFields).created} ${(0, (0, parcelRequire("5bSAg")).sortDirections).DESC}`;
    const $b87185164056f069$export$ec161d740909e39d = ({ match: { params: params }, query: query })=>{
        const { projectKey: projectKey, issueKey: issueKey } = params;
        const { filter: filter, jql: jql } = query;
        const defaultJql = projectKey !== null && projectKey !== undefined ? (0, (0, parcelRequire("8zzKy")).getDefaultJql)((0, (0, parcelRequire("g5X3G")).toProjectKey)(projectKey)) : $b87185164056f069$export$8780b1523384f42d();
        return {
            page: 1,
            jql: jql,
            issueKey: issueKey,
            projectKey: projectKey,
            filter: filter,
            defaultJql: defaultJql
        };
    };
    const $b87185164056f069$export$b968a035fc2aa57b = (defaultJql, jqlParam, filter, projectKey)=>{
        if (typeof jqlParam === 'string') return {
            jql: jqlParam
        };
        if (typeof filter === 'string' && filter !== '') {
            if ((0, (0, parcelRequire("9Nvh7")).isFilterId)(filter)) return {
                filterId: filter
            };
            const filterJql = projectKey !== null && projectKey !== undefined ? (0, (0, parcelRequire("8zzKy")).mapFilterToJql)(projectKey, filter) : undefined;
            if (filterJql !== undefined) return {
                jql: filterJql
            };
        }
        return {
            jql: defaultJql
        };
    };
});
parcelRegister("8zzKy", function(module, exports) {
    $parcel$export(module.exports, "isFilterKey", ()=>$f8caace292c4edec$export$2cad587bb603edda);
    $parcel$export(module.exports, "mapFilterToJql", ()=>$f8caace292c4edec$export$1d71dda738f608f);
    $parcel$export(module.exports, "getDefaultJql", ()=>$f8caace292c4edec$export$346d50fe8350b1d0);
    $parcel$export(module.exports, "getUrlPrefix", ()=>$f8caace292c4edec$export$821d4141d135e0d0);
    var $ebyGx = parcelRequire("ebyGx");
    var $6UAdF;
    var $2s5Ei;
    const $f8caace292c4edec$export$2cad587bb603edda = (filter)=>typeof filter === 'string' && filter in (0, (0, parcelRequire("2s5Ei")).Filters);
    const $f8caace292c4edec$export$1d71dda738f608f = (projectKey, filter)=>{
        if (!$f8caace292c4edec$export$2cad587bb603edda(filter)) return undefined;
        const clauses = [
            `project = "${projectKey}"`
        ];
        let order = (0, (0, parcelRequire("6UAdF")).DEFAULT_ORDER_FIELD);
        const direction = (0, (0, parcelRequire("6UAdF")).DEFAULT_SORT_DIRECTION);
        switch((0, (0, parcelRequire("2s5Ei")).Filters)[filter]){
            case (0, (0, parcelRequire("2s5Ei")).Filters).myopenissues:
                clauses.push('assignee IN (currentUser())');
                clauses.push(`statusCategory IN (${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).TO_DO}, ${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).IN_PROGRESS})`);
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).reportedbyme:
                clauses.push('reporter IN (currentUser())');
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).allopenissues:
                clauses.push(`statusCategory IN (${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).TO_DO}, ${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).IN_PROGRESS})`);
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).updated;
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).doneissues:
                clauses.push(`statusCategory = ${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).DONE}`);
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).recentlyviewed:
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).lastviewed;
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).resolvedrecently:
                clauses.push('resolved >= -1w');
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).updated;
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).updatedrecently:
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).updated;
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).allissues:
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).created;
                break;
            default:
        }
        return `${clauses.join(' AND ')} ORDER BY ${order} ${direction}`.trim();
    };
    const $f8caace292c4edec$export$346d50fe8350b1d0 = (projectKey)=>`project = "${projectKey}" ORDER BY ${0, (0, parcelRequire("6UAdF")).DEFAULT_ORDER_FIELD} ${0, (0, parcelRequire("6UAdF")).DEFAULT_SORT_DIRECTION}`;
    const $f8caace292c4edec$export$e5b4f9d05e643346 = (search, match)=>({
            ...(0, $ebyGx.parse)(search),
            ...match && match.params
        });
    const $f8caace292c4edec$export$821d4141d135e0d0 = (url)=>{
        const match = url.match(/^(.*)\/projects.*$/);
        return (match && match[1]) ?? '';
    };
});
parcelRegister("2s5Ei", function(module, exports) {
    $parcel$export(module.exports, "Filters", ()=>$ff462caa91749c6a$export$92a576f896a9bf72);
    $parcel$export(module.exports, "StatusCategoryValues", ()=>$ff462caa91749c6a$export$72d6e2acce8f36fd);
    const $ff462caa91749c6a$export$92a576f896a9bf72 = {
        myopenissues: Symbol('myopenissues'),
        reportedbyme: Symbol('reportedbyme'),
        allopenissues: Symbol('allopenissues'),
        doneissues: Symbol('doneissues'),
        recentlyviewed: Symbol('recentlyviewed'),
        resolvedrecently: Symbol('resolvedrecently'),
        updatedrecently: Symbol('updatedrecently'),
        allissues: Symbol('allissues')
    };
    const $ff462caa91749c6a$export$72d6e2acce8f36fd = {
        TO_DO: '"To Do"',
        DONE: '"Done"',
        IN_PROGRESS: '"In Progress"'
    };
});
parcelRegister("1b36n", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", ()=>$f0c33588b62c7651$export$d3efe54a881807bf);
    var $1nb22;
    var $2M1hQ;
    var $elyZV;
    const $f0c33588b62c7651$export$d3efe54a881807bf = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
        getKey: ({ match: match, query: query })=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return projectKey || 'none';
        },
        getData: async ({ match: match, query: query })=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            if (projectKey == null) return null;
            return (0, (0, parcelRequire("elyZV")).fetchDefaultPINFiltersNavData)(projectKey);
        },
        maxAge: 300000
    });
});
parcelRegister("elyZV", function(module, exports) {
    $parcel$export(module.exports, "fetchDefaultPINFiltersNavData", ()=>$88433d457c0f5220$export$268c1bcb44a0ddd3);
    var $eusud;
    const $88433d457c0f5220$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
    const $88433d457c0f5220$export$268c1bcb44a0ddd3 = async (projectKey)=>{
        if (projectKey == null) throw new Error('invalid project id or key');
        const result = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
        const filterNavIds = $88433d457c0f5220$var$extractNavIds(result);
        return {
            hasMyOpenIssues: filterNavIds.has('myopenissues'),
            hasReportedByMe: filterNavIds.has('reportedbyme'),
            hasAllIssues: filterNavIds.has('allissues'),
            hasAllOpenIssues: filterNavIds.has('allopenissues'),
            hasDoneIssues: filterNavIds.has('doneissues'),
            hasViewedRecently: filterNavIds.has('recentlyviewed'),
            hasCreatedRecently: filterNavIds.has('addedrecently'),
            hasResolvedRecently: filterNavIds.has('resolvedrecently'),
            hasUpdatedRecently: filterNavIds.has('updatedrecently')
        };
    };
});
parcelRegister("a3OKn", function(module, exports) {
    $parcel$export(module.exports, "sidebarProjectIssuesResource", ()=>$b491cf2963738bcf$export$be31dd7adcfd2297);
    var $ao2h1;
    var $59JDz;
    var $6YG83;
    const $b491cf2963738bcf$export$be31dd7adcfd2297 = (0, (0, parcelRequire("6YG83")).withGiraAggAnonSsrFix)((0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("59JDz")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    }));
});
parcelRegister("59JDz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6bc7247f574fad09$export$2e2bcd8739ae039);
    const $6bc7247f574fad09$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1,
                                    "kind": "FragmentSpread",
                                    "name": "starredFiltersList_navigationAppsSidebarCommon"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraFilterConnection",
                                "kind": "LinkedField",
                                "name": "favouriteFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "filterId"
                                                    },
                                                    {
                                                        "kind": "TypeDiscriminator",
                                                        "abstractKey": "__isJiraFilter"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isFavourite"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "jql"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "isEditable"
                                                            }
                                                        ],
                                                        "type": "JiraCustomFilter"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e",
                "metadata": {},
                "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $6bc7247f574fad09$var$node.hash = "86a313b9769c9a6a731e02bed044f4d2";
    var $6bc7247f574fad09$export$2e2bcd8739ae039 = $6bc7247f574fad09$var$node;
});
parcelRegister("1kQCU", function(module, exports) {
    $parcel$export(module.exports, "useGlobalScopeOptOutFlow", ()=>$d96a4352cc61ecaf$export$f39dd0211cb78bcf);
    $parcel$export(module.exports, "useGlobalScopeEnrolmentEnable", ()=>$d96a4352cc61ecaf$export$f45d1a4e873cac44);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $6s1PB;
    var $pa9q9;
    var $VILOn;
    var $7SHTM;
    var $bATyw;
    var $bVDE5;
    var $cZpsT;
    var $2YP9W;
    var $aK1ba;
    var $cnynt;
    const $d96a4352cc61ecaf$export$f39dd0211cb78bcf = (href)=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        const redirectToGin = (0, $5uXOq.useCallback)(()=>{
            if (href) window.location.assign(href);
            else window.location.reload();
        }, [
            href
        ]);
        const { renderFeedbackDialog: renderFeedbackDialog } = (0, (0, parcelRequire("aK1ba")).default)({
            onClose: redirectToGin,
            isAdminSettingsModal: false
        });
        return (0, $5uXOq.useCallback)(async (preventDefault)=>{
            if (!(0, (0, parcelRequire("VILOn")).getIsGlobalScopeEnrolmentEnabledFromLocalStorage)()) return;
            preventDefault && preventDefault();
            try {
                !isAnonymous && await (0, (0, parcelRequire("7SHTM")).setIsGlobalScopeEnrolmentEnabledUserPreference)(false);
                (0, (0, parcelRequire("VILOn")).setIsGlobalScopeEnrolmentEnabledInLocalStorage)(false);
                renderFeedbackDialog();
                sessionStorage.setItem('showGinOptOutFlag', 'true');
            } catch (error) {
                showFlag({
                    type: 'error',
                    title: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("cnynt")).default).errorOptOutTitleIssueTermRefresh : (0, (0, parcelRequire("cnynt")).default).errorOptOutTitle,
                    description: (0, (0, parcelRequire("cnynt")).default).errorOptOutDesc,
                    testId: 'issue-navigator-action-meatball-menu.ui.error-flag'
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'optOutOfNin',
                        packageName: 'jiraIssueNavigatorChangeboarding',
                        teamName: 'empanada'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    error: error
                });
            }
        }, [
            isAnonymous,
            renderFeedbackDialog,
            showFlag
        ]);
    };
    const $d96a4352cc61ecaf$export$f45d1a4e873cac44 = ()=>{
        const [localStorageData] = (0, $5uXOq.useState)((0, (0, parcelRequire("VILOn")).getIsGlobalScopeEnrolmentEnabledFromLocalStorage));
        const { data: resourceData } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource));
        const [{ isInitialRender: isInitialRender }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        let isNinGlobalScopeEnrolmentEnabled;
        if (isInitialRender) isNinGlobalScopeEnrolmentEnabled = true;
        else if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = localStorageData;
        else isNinGlobalScopeEnrolmentEnabled = resourceData;
        return [
            isNinGlobalScopeEnrolmentEnabled,
            resourceData
        ];
    };
});
parcelRegister("VILOn", function(module, exports) {
    $parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", ()=>$5dc42c779a970b72$export$55632339cd4dae9c);
    $parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", ()=>$5dc42c779a970b72$export$7b78bfe0a111cecf);
    $parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", ()=>$5dc42c779a970b72$export$82b2633cf7498c5e);
    $parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", ()=>$5dc42c779a970b72$export$458eda2352a1e223);
    var $bSSG7;
    var $dJl1T;
    const $5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
    const $5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
    const $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('nin-changeboarding');
    const $5dc42c779a970b72$export$34434fbbe40a8047 = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.remove($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
    const $5dc42c779a970b72$export$55632339cd4dae9c = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
    const $5dc42c779a970b72$export$7b78bfe0a111cecf = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
    const $5dc42c779a970b72$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
        try {
            $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
            $5dc42c779a970b72$export$34434fbbe40a8047();
        }
    };
    const $5dc42c779a970b72$export$458eda2352a1e223 = ()=>{
        try {
            $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
        }
    };
});
parcelRegister("bSSG7", function(module, exports) {
    $parcel$export(module.exports, "createLocalStorageProvider", ()=>$63804f80e89e547d$export$697e65b1658f821b);
    $parcel$export(module.exports, "createLocalExpirableStorageProvider", ()=>$63804f80e89e547d$export$59acef2b3ab1df90);
    var $gJBT6 = parcelRequire("gJBT6");
    var $fNVZf;
    var $dEJQ9;
    const $63804f80e89e547d$export$697e65b1658f821b = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>(0, (0, parcelRequire("fNVZf")).createStorageProvider)(appPrefix, (0, (0, parcelRequire("dEJQ9")).makeLocalStore)()));
    const $63804f80e89e547d$export$59acef2b3ab1df90 = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const store = (0, (0, parcelRequire("dEJQ9")).makeLocalExpirableStore)();
        return store.namespace(appPrefix);
    });
});
parcelRegister("fNVZf", function(module, exports) {
    $parcel$export(module.exports, "plugins", ()=>$04caddce42518619$export$8b3ca321c77fdea6);
    $parcel$export(module.exports, "createStorageProvider", ()=>$04caddce42518619$export$8441605555fbd60c);
    var $fKgem = parcelRequire("fKgem");
    var $c7J1U;
    const $04caddce42518619$export$8b3ca321c77fdea6 = [
        (0, ($parcel$interopDefault($fKgem))),
        (0, (0, parcelRequire("c7J1U")).default)
    ];
    const $04caddce42518619$export$8441605555fbd60c = (appPrefix, store)=>store.namespace(appPrefix);
});
parcelRegister("c7J1U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99d922a6a243a194$export$2e2bcd8739ae039);
    var $jcw0u;
    var $cuNKJ;
    function $99d922a6a243a194$var$cleanUpPlugin() {
        const self = this;
        const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, (0, parcelRequire("cuNKJ")).NAMESPACE));
        function set(superFn, key, val) {
            try {
                if (!self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE))) timestamps.set(key, Date.now());
                superFn();
            } catch (e) {
                if (e.code === (0, (0, parcelRequire("cuNKJ")).LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, (0, parcelRequire("cuNKJ")).LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'browserLocalStorageFullError',
                            packageName: 'jiraBrowserStorageProviders',
                            teamName: 'magma'
                        },
                        attributes: {
                            namespace: self._namespacePrefix
                        },
                        error: e,
                        skipSentry: true
                    });
                    if (self.cleanWhenFull()) self.set(superFn, key, val);
                } else {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'storageCleanupPluginError',
                            packageName: 'jiraBrowserStorageProviders',
                            teamName: 'magma'
                        },
                        attributes: {
                            isLegacyFunction: false
                        },
                        error: e
                    });
                    throw e;
                }
            }
        }
        function remove(superFn, key) {
            if (!self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE))) timestamps.remove(key);
            return superFn();
        }
        function getTotalCount() {
            let count = 0;
            self.each(()=>{
                count += 1;
            });
            return count;
        }
        function cleanWhenFull(superFn, minAge = (0, (0, parcelRequire("cuNKJ")).FOUR_WEEKS)) {
            const currTime = Date.now();
            const numKeysBefore = self.getTotalCount();
            self.each((_value, key)=>{
                const created = !self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE)) ? timestamps.get(key) : null;
                if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
            });
            const itemsRemovedCount = numKeysBefore - self.getTotalCount();
            if (!itemsRemovedCount && minAge - (0, (0, parcelRequire("cuNKJ")).ONE_WEEK) >= (0, (0, parcelRequire("cuNKJ")).ONE_WEEK)) return self.cleanWhenFull(minAge - (0, (0, parcelRequire("cuNKJ")).ONE_WEEK));
            return itemsRemovedCount === 0;
        }
        return {
            set: set,
            remove: remove,
            cleanWhenFull: cleanWhenFull,
            getTotalCount: getTotalCount
        };
    }
    var $99d922a6a243a194$export$2e2bcd8739ae039 = $99d922a6a243a194$var$cleanUpPlugin;
});
parcelRegister("cuNKJ", function(module, exports) {
    $parcel$export(module.exports, "NAMESPACE", ()=>$d21613ddd27d5bbf$export$6aad947bda0f3f46);
    $parcel$export(module.exports, "ONE_WEEK", ()=>$d21613ddd27d5bbf$export$8187f416f1cc43d8);
    $parcel$export(module.exports, "FOUR_WEEKS", ()=>$d21613ddd27d5bbf$export$6e952fa7d47190cf);
    $parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", ()=>$d21613ddd27d5bbf$export$da99ebca8f453abd);
    $parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", ()=>$d21613ddd27d5bbf$export$ea28dfd9333cda2d);
    const $d21613ddd27d5bbf$export$6aad947bda0f3f46 = 'timestamps';
    const $d21613ddd27d5bbf$export$8187f416f1cc43d8 = 604800000;
    const $d21613ddd27d5bbf$export$6e952fa7d47190cf = 4 * $d21613ddd27d5bbf$export$8187f416f1cc43d8;
    const $d21613ddd27d5bbf$export$da99ebca8f453abd = 22;
    const $d21613ddd27d5bbf$export$ea28dfd9333cda2d = 1014;
});
parcelRegister("dEJQ9", function(module, exports) {
    $parcel$export(module.exports, "makeLocalStore", ()=>$dcae70c06981fc99$export$b2631085fe8db7af);
    $parcel$export(module.exports, "makeLocalExpirableStore", ()=>$dcae70c06981fc99$export$cf816b43e73de947);
    var $fKgem = parcelRequire("fKgem");
    var $kzObv = parcelRequire("kzObv");
    var $c4CII = parcelRequire("c4CII");
    var $4Zgux = parcelRequire("4Zgux");
    var $2NjNT = parcelRequire("2NjNT");
    var $fNVZf;
    const $dcae70c06981fc99$export$b2631085fe8db7af = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($4Zgux))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], (0, (0, parcelRequire("fNVZf")).plugins));
    const $dcae70c06981fc99$export$cf816b43e73de947 = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($4Zgux))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], [
            (0, ($parcel$interopDefault($fKgem))),
            (0, ($parcel$interopDefault($kzObv)))
        ]);
});
parcelRegister("7SHTM", function(module, exports) {
    $parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledUserPreference", ()=>$a1fa570fc83fd392$export$2fc59b10f256dbee);
    $parcel$export(module.exports, "resetGlobalScopeForcedOptOutGinFlag", ()=>$a1fa570fc83fd392$export$89f09c81b642e3c7);
    var $jcw0u;
    var $eusud;
    const $a1fa570fc83fd392$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
    const $a1fa570fc83fd392$var$setGlobalScopeUserPreference = async (input)=>{
        const result = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/', {
            body: JSON.stringify({
                query: $a1fa570fc83fd392$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
                variables: {
                    input: input
                }
            })
        });
        if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${input.key}`, {
            cause: result.errors?.[0]
        });
    };
    const $a1fa570fc83fd392$export$2fc59b10f256dbee = async (value)=>$a1fa570fc83fd392$var$setGlobalScopeUserPreference({
            key: 'jira.user.nin.global.scope.enrolment',
            value: value ? 'nin' : 'gin'
        });
    const $a1fa570fc83fd392$export$89f09c81b642e3c7 = async ()=>$a1fa570fc83fd392$var$setGlobalScopeUserPreference({
            key: 'jira.user.nin.global.scope.enrolment.flag.disabled',
            value: false
        }).catch((error)=>(0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'resetGlobalScopeGinFlag',
                    packageName: 'jiraIssueNavigatorGlobalScopeEnrolment',
                    teamName: 'empanada'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            }));
});
parcelRegister("cZpsT", function(module, exports) {
    $parcel$export(module.exports, "useIsAnonymous", ()=>$5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);
    var $9OXo1;
    const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.isAnonymous;
    };
});
parcelRegister("aK1ba", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$106d1fc5065910b3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $6s1PB;
    var $4R6GH;
    var $7iULw;
    var $dseDh;
    var $koVbs;
    var $6jY6G;
    var $bw7Gm;
    var $4DPZY;
    var $9OXo1;
    var $g7SDw;
    const $106d1fc5065910b3$export$3fe286306fb8ddfb = 'global-scope-issue-navigator-opt-out';
    const $106d1fc5065910b3$var$unknownAttributeValue = 'unknown';
    const $106d1fc5065910b3$export$b028e515f8f652e0 = ({ isSiteAdmin: isSiteAdmin, routeName: routeName, routeGroup: routeGroup, projectType: projectType, isProjectSimplified: isProjectSimplified, cloudId: cloudId })=>[
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).LOCATION,
                value: (0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-undefined-navigator') ? (0, (0, parcelRequire("bw7Gm")).default)(globalThis.location?.href) : (0, (0, parcelRequire("bw7Gm")).default)(window.location.href)
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).REFERER,
                value: document.referrer ? (0, (0, parcelRequire("bw7Gm")).default)(document.referrer) : ''
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).USER_AGENT,
                value: (0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-undefined-navigator') ? globalThis.navigator?.userAgent : navigator.userAgent
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).SCREEN_RESOLUTION,
                value: (0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-undefined-navigator') ? `${globalThis.window?.screen.width} x ${globalThis.window?.screen.height}` : `${window.screen.width} x ${window.screen.height}`
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).ROUTE_NAME,
                value: routeName
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).ROUTE_GROUP,
                value: routeGroup
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_SIMPLIFIED_PROJECT,
                value: isProjectSimplified.toString()
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_ADMIN,
                value: isSiteAdmin.toString()
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).PROJECT_TYPE,
                value: projectType
            },
            {
                id: 'cloud-id',
                value: cloudId
            }
        ];
    const $106d1fc5065910b3$export$3a73a4e2115ebf73 = ({ isAdminSettingsModal: isAdminSettingsModal = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const titleDetails = isAdminSettingsModal ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("g7SDw")).default).titleDetailsAdminIssueTermRefresh : (0, (0, parcelRequire("g7SDw")).default).titleDetailsAdmin) : formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("g7SDw")).default).titleDetailsUserIssueTermRefresh : (0, (0, parcelRequire("g7SDw")).default).titleDetailsUser);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $106d1fc5065910b3$var$feedbackTitleDetailsContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, titleDetails));
    };
    const $106d1fc5065910b3$var$useFeedbackDialog = ({ isAdminSettingsModal: isAdminSettingsModal = false, onClose: onClose = ()=>undefined })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { openFeedbackCollector: openFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const [{ data: projectData }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const routeGroup = route.group ?? $106d1fc5065910b3$var$unknownAttributeValue;
        const routeName = route.name ?? $106d1fc5065910b3$var$unknownAttributeValue;
        let projectType = $106d1fc5065910b3$var$unknownAttributeValue;
        let isProjectSimplified = false;
        if (projectData && 'project' in projectData && projectData.project) {
            projectType = projectData.project.type;
            isProjectSimplified = projectData.project.isSimplified;
        }
        const renderFeedbackDialog = (0, $5uXOq.useCallback)(()=>{
            openFeedbackCollector({
                feedbackGroupId: $106d1fc5065910b3$export$3fe286306fb8ddfb,
                entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR),
                onClose: onClose,
                feedbackContext: $106d1fc5065910b3$export$b028e515f8f652e0({
                    isSiteAdmin: isSiteAdmin,
                    cloudId: cloudId,
                    routeGroup: routeGroup,
                    routeName: routeName,
                    projectType: projectType,
                    isProjectSimplified: isProjectSimplified
                }),
                feedbackTitle: formatMessage((0, (0, parcelRequire("g7SDw")).default).title),
                feedbackTitleDetails: (0, ($parcel$interopDefault($5uXOq))).createElement($106d1fc5065910b3$export$3a73a4e2115ebf73, {
                    isAdminSettingsModal: isAdminSettingsModal
                }),
                selectLabel: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("g7SDw")).default).reasonTitleIssueTermRefresh : (0, (0, parcelRequire("g7SDw")).default).reasonTitle),
                summaryPlaceholder: ' ',
                submitButtonLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).submitCaption),
                cancelButtonLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).cancelCaption),
                feedbackGroupLabels: {
                    empty: {
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonPlaceholder)
                    },
                    bug: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonQuestion),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonBug)
                    },
                    comment: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonQuestion),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonSpeed)
                    },
                    suggestion: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonQuestion),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonOthers)
                    },
                    question: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonQuestion),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonParity)
                    }
                }
            });
        }, [
            openFeedbackCollector,
            onClose,
            isSiteAdmin,
            cloudId,
            routeGroup,
            routeName,
            projectType,
            isProjectSimplified,
            formatMessage,
            isAdminSettingsModal
        ]);
        return {
            renderFeedbackDialog: renderFeedbackDialog
        };
    };
    var $106d1fc5065910b3$export$2e2bcd8739ae039 = $106d1fc5065910b3$var$useFeedbackDialog;
    const $106d1fc5065910b3$var$feedbackTitleDetailsContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.050'
    });
});
parcelRegister("7iULw", function(module, exports) {
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", ()=>$384a8a865c8f714d$export$baea5c8192e79adc);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", ()=>$384a8a865c8f714d$export$4eda1e3a4a311d13);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", ()=>$384a8a865c8f714d$export$5fb38521eb7ad63c);
    $parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", ()=>$384a8a865c8f714d$export$345c45dd28f28a32);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", ()=>$384a8a865c8f714d$export$8962f2e618411469);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", ()=>$384a8a865c8f714d$export$7d7f2319141db3c5);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", ()=>$384a8a865c8f714d$export$4725635e6fe1907a);
    $parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", ()=>$384a8a865c8f714d$export$3a50f2efd6cfd6f3);
    $parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", ()=>$384a8a865c8f714d$export$5bd148c13bb23f7a);
    $parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", ()=>$384a8a865c8f714d$export$b4de0744c1fd450d);
    $parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", ()=>$384a8a865c8f714d$export$1a7c42187130faf9);
    $parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", ()=>$384a8a865c8f714d$export$e84c34a7e1dbcf78);
    $parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", ()=>$384a8a865c8f714d$export$23f6d7b16d2210c1);
    $parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", ()=>$384a8a865c8f714d$export$1b65c2053cba0686);
    $parcel$export(module.exports, "EntryKeys", ()=>$384a8a865c8f714d$export$12d01b6c311a909a);
    const $384a8a865c8f714d$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
    const $384a8a865c8f714d$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
    const $384a8a865c8f714d$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
    const $384a8a865c8f714d$export$4a288e389131b3de = 'b6176efc-e703-426b-b4f8-3e43ce4aa0db';
    const $384a8a865c8f714d$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
    const $384a8a865c8f714d$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
    const $384a8a865c8f714d$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
    const $384a8a865c8f714d$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
    const $384a8a865c8f714d$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
    const $384a8a865c8f714d$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
    const $384a8a865c8f714d$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
    const $384a8a865c8f714d$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
    const $384a8a865c8f714d$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
    const $384a8a865c8f714d$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
    const $384a8a865c8f714d$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
    const $384a8a865c8f714d$export$12d01b6c311a909a = Object.freeze({
        CLOUD_ID: 'cloud-id',
        OPT_OUT: 'Opt-out',
        REASON: 'reason',
        FEELING: 'feeling',
        IS_ADMIN: 'is-admin',
        IS_SITE_ADMIN: 'is-site-admin',
        IS_PROJECT_SETTINGS: 'is-project-settings',
        INLINE_FEEDBACK_ID: 'inlineFeedbackId',
        IS_JSD_EVALUATOR: 'is-jsd-evaluator',
        IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
        SUPPORTED_PROJECT_TYPES: 'supported-project-types',
        FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
        FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
        FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
        LOCATION: 'Location',
        PROJECT_TYPE: 'project-type',
        BOARD_TYPE: 'board-type',
        REFERER: 'Referer',
        ROUTE_GROUP: 'route-group',
        ROUTE_NAME: 'route-name',
        USER_AGENT: 'User-Agent',
        SCREEN_RESOLUTION: 'Screen Resolution',
        SOURCE: 'Source',
        SUB_PRODUCT: 'Sub-product',
        JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
        JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
        DEPLOYMENT_PROVIDERS: 'deployment-providers',
        JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
        VERSION_CONTROL_PROVIDERS: 'version-control-providers',
        DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
        CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
        SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
        INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
        IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
        FEEDBACK_GROUP_ID: 'feedback-group-id',
        EDITION: 'edition',
        ENV: 'environment',
        SMART_REPLIES: 'smart-replies'
    });
});
parcelRegister("dseDh", function(module, exports) {
    $parcel$export(module.exports, "useFeedbackCollector", ()=>$c996142feb877ddb$export$4be696be8a3bff13);
    $parcel$export(module.exports, "useFeedbackCollectorActions", ()=>$c996142feb877ddb$export$dfb2ee2d9e73fa48);
    $parcel$export(module.exports, "FeedbackActionsSubscriber", ()=>$c996142feb877ddb$export$c35dbf16ebe9df04);
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $c996142feb877ddb$export$d4c72bab9d6cc13a = {
        isFeedbackCollectorOpen: false,
        entrypointId: undefined,
        email: undefined,
        additionalFields: undefined,
        feedbackTitle: undefined,
        feedbackContext: undefined,
        feedbackCollectorId: undefined,
        showTypeField: true,
        submitButtonLabel: undefined,
        canBeContactedLabel: undefined,
        summaryPlaceholder: undefined,
        feedbackGroupLabels: undefined,
        onClose: undefined,
        feedbackTitleDetails: undefined,
        triggerRef: undefined,
        renderCustomContent: undefined,
        customFeedbackOptions: []
    };
    const $c996142feb877ddb$export$e324594224ef24da = {
        openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
                dispatch($c996142feb877ddb$export$e324594224ef24da.resetFeedbackCollectorState());
                setState({
                    ...feedbackCollectorProps,
                    isFeedbackCollectorOpen: true
                });
            },
        closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
                const { triggerRef: triggerRef } = getState();
                if (triggerRef) setTimeout(()=>triggerRef.current?.focus(), 50);
                setState({
                    isFeedbackCollectorOpen: false,
                    triggerRef: undefined
                });
            },
        resetFeedbackCollectorState: ()=>({ setState: setState })=>{
                setState({
                    ...$c996142feb877ddb$export$d4c72bab9d6cc13a
                });
            },
        updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
                setState({
                    renderCustomContent: updatedCustomRenderContent
                });
            },
        updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
                setState({
                    additionalFields: updatedAdditionalFields
                });
            }
    };
    const $c996142feb877ddb$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'feedback-collector',
        initialState: $c996142feb877ddb$export$d4c72bab9d6cc13a,
        actions: $c996142feb877ddb$export$e324594224ef24da
    });
    const $c996142feb877ddb$export$4be696be8a3bff13 = (0, (0, parcelRequire("3sQ5x")).createHook)($c996142feb877ddb$var$Store);
    const $c996142feb877ddb$export$dfb2ee2d9e73fa48 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($c996142feb877ddb$var$Store);
    const $c996142feb877ddb$export$c35dbf16ebe9df04 = (0, (0, parcelRequire("51nlc")).createSubscriber)($c996142feb877ddb$var$Store, {
        selector: null
    });
});
parcelRegister("4DPZY", function(module, exports) {
    $parcel$export(module.exports, "useContainerContext", ()=>$a65e0c39573f7437$export$c7066c2d215990cf);
    $parcel$export(module.exports, "ContainerContextSubscriber", ()=>$a65e0c39573f7437$export$5b87a78c45d5dd17);
    var $5uXOq = parcelRequire("5uXOq");
    var $7xTO3;
    var $ggg5j;
    var $2YP9W;
    var $6SkQo;
    const $a65e0c39573f7437$var$useProjectContext = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource));
        const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("6SkQo")).getProjectContext)(data), [
            data
        ]);
        return [
            {
                data: projectContext,
                error: error,
                loading: loading
            },
            {
                fetch: refresh,
                refetch: refresh
            }
        ];
    };
    const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("7xTO3")).staticJSWUserBoardSidebarNavigationResource));
        const userContext = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("6SkQo")).getUserContext)(data), [
            data
        ]);
        return [
            {
                data: userContext,
                error: error,
                loading: loading
            },
            {
                fetch: refresh,
                refetch: refresh
            }
        ];
    };
    const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
        const projectContext = $a65e0c39573f7437$var$useProjectContext();
        const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
        if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
        return projectContext;
    };
    const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
        const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
        return props.children(data, actions);
    };
    $a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';
});
parcelRegister("6SkQo", function(module, exports) {
    $parcel$export(module.exports, "getUserContext", ()=>$84cf60e2c9c0e289$export$114c35c2c23732ab);
    $parcel$export(module.exports, "getProjectContext", ()=>$84cf60e2c9c0e289$export$d17fffd59c7b3c60);
    var $2vSU6;
    var $bsuuc;
    const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
        const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
        return {
            contextType: 'user',
            user: {
                id: owner.id,
                name: owner.name,
                avatarUrl: owner.avatarUrl,
                profileUrl: owner.profileUrl,
                accountId: owner.accountId
            },
            scope: {
                id: boardInfo.id,
                type: boardInfo.type,
                name: boardInfo.name
            }
        };
    };
    const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
        if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
            const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
            return {
                id: boardInfo.id,
                type: boardInfo.type,
                name: boardInfo.name
            };
        }
        return undefined;
    };
    const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
        switch(projectType){
            case 'business':
                return 0, (0, parcelRequire("2vSU6")).CORE_PROJECT;
            case 'software':
                return 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT;
            case 'service_desk':
                return 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT;
            case 'product_discovery':
                return 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT;
            default:
                return null;
        }
    };
    const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
        const project = (0, (0, parcelRequire("bsuuc")).extractData)(projectNavInfo);
        const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
        if (project) {
            const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
            if (projectType) return {
                contextType: 'project',
                project: {
                    key: project.key,
                    id: project.id,
                    name: project.name,
                    type: projectType,
                    isSimplified: project.isSimplified,
                    avatarUrl: project.avatarUrl,
                    style: (0, (0, parcelRequire("bsuuc")).getStyle)(project.isSimplified)
                },
                scope: scope
            };
        }
        return null;
    };
});
parcelRegister("g7SDw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5fa18157d389278a$export$2e2bcd8739ae039);
    var $7VHMR;
    const $5fa18157d389278a$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title",
            "defaultMessage": "Let us know why you're moving"
        },
        titleDetailsAdmin: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin",
            "defaultMessage": "You and your users will be able to use the old issue search temporarily."
        },
        titleDetailsUser: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user",
            "defaultMessage": "You'll be able to use the old issue search temporarily."
        },
        submitCaption: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.submit-caption",
            "defaultMessage": "Send feedback"
        },
        cancelCaption: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.cancel-caption",
            "defaultMessage": "Skip"
        },
        reasonTitle: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title",
            "defaultMessage": "What is your reason to go back to the old issue search?"
        },
        reasonPlaceholder: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-placeholder",
            "defaultMessage": "Select an option"
        },
        reasonParity: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-parity",
            "defaultMessage": "Features are missing"
        },
        reasonSpeed: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-speed",
            "defaultMessage": "It's slow"
        },
        reasonBug: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-bug",
            "defaultMessage": "There's a bug"
        },
        reasonOthers: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-others",
            "defaultMessage": "Others"
        },
        reasonQuestion: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-question",
            "defaultMessage": "Can you provide more details? It'll help make search better for everyone."
        },
        titleDetailsAdminIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin-issue-term-refresh",
            "defaultMessage": "You'll be able to use the old way to search for work items temporarily."
        },
        titleDetailsUserIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user-issue-term-refresh",
            "defaultMessage": "You'll be able to use the old way to search for work items temporarily."
        },
        reasonTitleIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title-issue-term-refresh",
            "defaultMessage": "What's the reason you're going back to the old way to searching for work items?"
        }
    });
    var $5fa18157d389278a$export$2e2bcd8739ae039 = $5fa18157d389278a$var$messages;
});
parcelRegister("cnynt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c37d0c1deb4d01ea$export$2e2bcd8739ae039);
    var $7VHMR;
    const $c37d0c1deb4d01ea$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorOptOutTitle: {
            "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title",
            "defaultMessage": "We couldn't switch to the old issue search"
        },
        errorOptOutDesc: {
            "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-desc",
            "defaultMessage": "Refresh and try again."
        },
        errorOptOutTitleIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title-issue-term-refresh",
            "defaultMessage": "We couldn't switch to the old search"
        }
    });
    var $c37d0c1deb4d01ea$export$2e2bcd8739ae039 = $c37d0c1deb4d01ea$var$messages;
});
parcelRegister("1UnUc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iIfyN")
    ]).then(()=>parcelRequire('jABZI'));
});
parcelRegister("90rvf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("azMOH")
    ]).then(()=>parcelRequire('iUdxh'));
});
parcelRegister("QbgwQ", function(module, exports) {
    $parcel$export(module.exports, "servicedeskIssuesRoute", ()=>$b85637273df18b5c$export$4be84a96ac761ab0);
    var $65Ltd;
    const $b85637273df18b5c$export$4be84a96ac761ab0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES),
        path: '/jira/servicedesk/projects/:projectKey/issues/:issueKey?'
    };
});
parcelRegister("l9RBL", function(module, exports) {
    $parcel$export(module.exports, "jiraHomePageRightSidePanelResource", ()=>$eed57b2562d325e4$export$9cba342d9ec5384d);
    var $ao2h1;
    var $a4BhB;
    var $jKXj9;
    const $eed57b2562d325e4$var$isBroadcastWidgetEnabled = ()=>false;
    const $eed57b2562d325e4$export$9cba342d9ec5384d = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, (0, parcelRequire("jKXj9")).JIRA_HOME_PAGE_RIGHT_SIDE_PANEL),
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("a4BhB")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    broadcastWidgetEnabled: $eed57b2562d325e4$var$isBroadcastWidgetEnabled()
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("a4BhB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$616ef8e6ff77d43c$export$2e2bcd8739ae039);
    const $616ef8e6ff77d43c$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "broadcastWidgetEnabled"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "main_rightSidePanel_RootQuery",
                "selections": [
                    {
                        "condition": "broadcastWidgetEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "main_homeBroadcastWidget_Widget"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "main_rightSidePanel_RootQuery",
                "selections": [
                    {
                        "condition": "broadcastWidgetEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "cloudId",
                                                "variableName": "cloudId"
                                            }
                                        ],
                                        "concreteType": "JiraUserBroadcastMessageConnection",
                                        "kind": "LinkedField",
                                        "name": "allJiraUserBroadcastMessages",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraUserBroadcastMessageEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraUserBroadcastMessage",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "shouldDisplay"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1",
                "metadata": {},
                "name": "main_rightSidePanel_RootQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $616ef8e6ff77d43c$var$node.hash = "174d1e9e3edb60b5684e0806b3d7342e";
    var $616ef8e6ff77d43c$export$2e2bcd8739ae039 = $616ef8e6ff77d43c$var$node;
});
parcelRegister("jKXj9", function(module, exports) {
    $parcel$export(module.exports, "RIGHT_PANEL_WIDTH", ()=>$64d3bec226f7ff92$export$750459958906793);
    $parcel$export(module.exports, "RIGHT_SIDE_PANEL_EXPERIENCE", ()=>$64d3bec226f7ff92$export$2eb41e47cfa429b7);
    $parcel$export(module.exports, "JIRA_HOME_PAGE_RIGHT_SIDE_PANEL", ()=>$64d3bec226f7ff92$export$6c783d91630ece21);
    var $gwIPs;
    const $64d3bec226f7ff92$export$750459958906793 = (0, (0, parcelRequire("gwIPs")).gridSize) * 49;
    const $64d3bec226f7ff92$export$2eb41e47cfa429b7 = {
        experience: 'jiraHomeRightSidePanel',
        experienceId: undefined,
        analyticsSource: 'jira-home'
    };
    const $64d3bec226f7ff92$export$6c783d91630ece21 = 'JIRA_HOME_PAGE_RIGHT_SIDE_PANEL';
});
parcelRegister("aILzD", function(module, exports) {
    $parcel$export(module.exports, "jiraHomeResourceWithCache", ()=>$9f71890db935ba06$export$1da15dc2d924240c);
    var $2M1hQ;
    const $9f71890db935ba06$export$1da15dc2d924240c = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $dac9c443ac5dd9ad$export$e79da7e0d9d1c1f2),
        getKey: ()=>'jira-home',
        getDataLoader: ()=>(parcelRequire("klVCQ")),
        maxAge: Infinity
    });
});
const $dac9c443ac5dd9ad$export$e79da7e0d9d1c1f2 = 'JIRA_HOME';
parcelRegister("klVCQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("7kTIJ")
    ]).then(()=>parcelRequire('fvAUD'));
});
parcelRegister("dIHnK", function(module, exports) {
    $parcel$export(module.exports, "jiraHomeRoute", ()=>$90d9eefc14df7b5b$export$11ebbd6d4e57759c);
    var $65Ltd;
    const $90d9eefc14df7b5b$export$11ebbd6d4e57759c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK),
        path: '/jira/your-work'
    };
});
parcelRegister("7mjY3", function(module, exports) {
    $parcel$export(module.exports, "YourWorkSkeleton", ()=>$305c0c711ea600ba$export$62cf62fa23284b71);
    $parcel$export(module.exports, "YourWorkItemListSkeleton", ()=>$305c0c711ea600ba$export$31cebe1052db844);
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $6L7Ws = parcelRequire("6L7Ws");
    var $aN3q5 = parcelRequire("aN3q5");
    const $305c0c711ea600ba$export$62cf62fa23284b71 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($6L7Ws)))
        });
    const $305c0c711ea600ba$export$31cebe1052db844 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($aN3q5))),
            containerStyles: {
                maxHeight: '30em'
            }
        });
});
parcelRegister("6L7Ws", function(module, exports) {
    module.exports = new URL("your-work-app-skeleton.tpl.14d150b5.svg", import.meta.url).toString();
});
parcelRegister("aN3q5", function(module, exports) {
    module.exports = new URL("your-work-itemlist-skeleton.tpl.e9027f83.svg", import.meta.url).toString();
});
parcelRegister("pC8Oc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eLhUl")
    ]).then(()=>parcelRequire('jyj7M'));
});
parcelRegister("35DJb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bt202").then(()=>parcelRequire('8LbPV'));
});
parcelRegister("k7i8h", function(module, exports) {
    $parcel$export(module.exports, "appRequestRoute", ()=>$c59c562861b45f37$export$e5429b8cad3b4991);
    var $65Ltd;
    const $c59c562861b45f37$export$e5429b8cad3b4991 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_APP_REQUESTS),
        path: '/jira/marketplace/manage/app-requests'
    };
});
parcelRegister("AsrYC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jfNVT")
    ]).then(()=>parcelRequire('lA7ML'));
});
parcelRegister("jcvAd", function(module, exports) {
    $parcel$export(module.exports, "promotionsRoute", ()=>$bc8d892f5d9c1f9e$export$45df65bfacbf9a2a);
    var $65Ltd;
    const $bc8d892f5d9c1f9e$export$45df65bfacbf9a2a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_PROMOTIONS),
        path: '/jira/marketplace/manage/promotions'
    };
});
parcelRegister("bAB30", function(module, exports) {
    $parcel$export(module.exports, "backlogResource", ()=>$d3029439c7d3b0b0$export$31d171ba71468137);
    var $gNStA;
    var $2M1hQ;
    const $d3029439c7d3b0b0$export$31d171ba71468137 = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $fe839261f35d1611$export$a0ef589381533a7c),
        getKey: ({ match: match })=>match.params.boardId || '',
        getDataLoader: ()=>(parcelRequire("h0LF7")),
        maxAge: 3600000
    }));
});
const $fe839261f35d1611$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $fe839261f35d1611$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';
const $fe839261f35d1611$export$463905a04a9a75ce = 'NEXTGEN_BACKLOG_RELAY';
parcelRegister("h0LF7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("k5lf7").then(()=>parcelRequire('lq5RB'));
});
parcelRegister("9SRRO", function(module, exports) {
    $parcel$export(module.exports, "customFiltersResource", ()=>$87093d7252240507$export$3e390340716755de);
    var $dXq4S;
    var $ao2h1;
    var $aYacW;
    var $gNStA;
    const $87093d7252240507$export$3e390340716755de = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $fe839261f35d1611$export$faa68b3df5415bcb),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("aYacW")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            }),
        captureErrors: true
    }));
});
parcelRegister("aYacW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16318ecaa49178e6$export$2e2bcd8739ae039);
    const $16318ecaa49178e6$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "boardId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "viewBacklogCustomFiltersQuery",
                "selections": [
                    {
                        "args": v1,
                        "kind": "FragmentSpread",
                        "name": "customFilter_softwareFilters_CustomFilterRelay"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "viewBacklogCustomFiltersQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "CustomFilter",
                                "kind": "LinkedField",
                                "name": "customFilters",
                                "plural": true,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            },
                            v2
                        ]
                    }
                ]
            },
            "params": {
                "id": "494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082",
                "metadata": {},
                "name": "viewBacklogCustomFiltersQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $16318ecaa49178e6$var$node.hash = "071c255f9696fe84a9c3982d42cfa5c0";
    var $16318ecaa49178e6$export$2e2bcd8739ae039 = $16318ecaa49178e6$var$node;
});
parcelRegister("78yv1", function(module, exports) {
    $parcel$export(module.exports, "softwareBacklogEmbedRoute", ()=>$58a7d1c6d58c26bf$export$bc022a39c42aba2f);
    var $65Ltd;
    const $58a7d1c6d58c26bf$export$bc022a39c42aba2f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG_EMBED),
        path: '/jira/software/projects/:projectKey/boards/:boardId/backlog/embed',
        exact: true
    };
});
parcelRegister("5qQ9I", function(module, exports) {
    $parcel$export(module.exports, "boardResource", ()=>$21d99b29ea940c83$export$286b76e0f2661cfb);
    $parcel$export(module.exports, "customFiltersResource", ()=>$21d99b29ea940c83$export$3e390340716755de);
    $parcel$export(module.exports, "boardRelayResource", ()=>$21d99b29ea940c83$export$81ac23db76b1f935);
    var $dXq4S;
    var $ao2h1;
    var $6mTNg;
    var $9fgCw;
    var $gNStA;
    var $2M1hQ;
    const $21d99b29ea940c83$export$286b76e0f2661cfb = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $a00fc8fb83f2948a$export$a38ac7339e3f31db),
        getKey: ({ match: match })=>match.params.boardId || '',
        getDataLoader: ()=>(parcelRequire("aUNUe")),
        maxAge: 3600000
    }));
    const $21d99b29ea940c83$export$3e390340716755de = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $a00fc8fb83f2948a$export$b48bcc76a0105016),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("9fgCw")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    }));
    const $21d99b29ea940c83$export$81ac23db76b1f935 = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $a00fc8fb83f2948a$export$5cef388780439aec),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("6mTNg")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    }));
});
parcelRegister("6mTNg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ddc6b6eeb5cc2255$export$2e2bcd8739ae039);
    const $ddc6b6eeb5cc2255$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
            "metadata": {},
            "name": "boardWithRouterRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $ddc6b6eeb5cc2255$export$2e2bcd8739ae039 = $ddc6b6eeb5cc2255$var$node;
});
parcelRegister("9fgCw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59a4f75157ae0306$export$2e2bcd8739ae039);
    const $59a4f75157ae0306$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
            "metadata": {},
            "name": "viewBoardCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $59a4f75157ae0306$export$2e2bcd8739ae039 = $59a4f75157ae0306$var$node;
});
const $a00fc8fb83f2948a$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $a00fc8fb83f2948a$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $a00fc8fb83f2948a$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';
parcelRegister("aUNUe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("jxTcV")
    ]).then(()=>parcelRequire('11pNz'));
});
parcelRegister("eeXsz", function(module, exports) {
    $parcel$export(module.exports, "softwareBoardEmbedRoute", ()=>$f06c20d996c477e6$export$f55626b64e3fcb4f);
    var $65Ltd;
    const $f06c20d996c477e6$export$f55626b64e3fcb4f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS_EMBED),
        exact: true,
        path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
    };
});
parcelRegister("7wTzh", function(module, exports) {
    $parcel$export(module.exports, "softwareBoardRoute", ()=>$4f781bb234c1132b$export$9ae2c0a566d4e0f6);
    var $65Ltd;
    const $4f781bb234c1132b$export$9ae2c0a566d4e0f6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS),
        exact: true,
        path: '/jira/software/projects/:projectKey/boards/:boardId'
    };
});
parcelRegister("11dfA", function(module, exports) {
    $parcel$export(module.exports, "NextGenBoardSkeleton", ()=>$b1638a290dc4da1e$export$25a9d0fbcb127c90);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $d69qo = parcelRequire("d69qo");
    const $b1638a290dc4da1e$var$customCssStyles = null;
    const $b1638a290dc4da1e$export$25a9d0fbcb127c90 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($d69qo))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1idpf"
            ])
        });
});
parcelRegister("d69qo", function(module, exports) {
    module.exports = new URL("next-gen-board-app-skeleton.tpl.d10f8ca5.svg", import.meta.url).toString();
});
parcelRegister("jsFU4", function(module, exports) {
    $parcel$export(module.exports, "nextGenRoadmapResource", ()=>$0b5ed5206b5a609e$export$2750f87d68dfb02a);
    var $2M1hQ;
    const $0b5ed5206b5a609e$export$2750f87d68dfb02a = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $87d7efe6336d8b83$export$75dfa03544a19422),
        getKey: ({ match: match })=>match.params.boardId || '',
        getDataLoader: ()=>(parcelRequire("91Qwv")),
        maxAge: 3600000,
        isBrowserOnly: true
    });
});
parcelRegister("91Qwv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("8Fxs8")
    ]).then(()=>parcelRequire('d0ZST'));
});
parcelRegister("21w0Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7pA40")
    ]).then(()=>parcelRequire('9ImcE'));
});
parcelRegister("kt0pG", function(module, exports) {
    $parcel$export(module.exports, "versionDetailsRelayResourceCustom", ()=>$57dfad429d4f47cb$export$c56c5b19da4d0fd1);
    var $8Uumt = parcelRequire("8Uumt");
    var $4R6GH;
    var $dXq4S;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $dvgjB;
    var $kfztd;
    var $20fNh;
    var $9NiTW;
    var $2M1hQ;
    const $57dfad429d4f47cb$export$c56c5b19da4d0fd1 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, $afc34106ac722f11$export$9fe575a15a87a796)}`,
        getKey: ({ match: match })=>{
            const { versionId: versionId } = match.params;
            const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
            return `jsw-releases-version-details-main-query-relay-${parsedVersionId}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { versionId: versionId } = match.params;
            const { filters: filters, sortBy: sortBy } = (0, (0, parcelRequire("20fNh")).toVersionIssuesGraphQLVariables)(query);
            const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
            const variables = {
                cloudAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: tenantContext.cloudId
                }),
                versionAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'version/activation',
                    resourceId: String(`${tenantContext.activationId}/${parsedVersionId}`)
                }),
                sortBy: sortBy,
                filters: filters,
                skip: !(0, (0, parcelRequire("9NiTW")).checkAuthentication)(tenantContext) || parsedVersionId.length === 0,
                isDevopsFeatureDisabledInFedRamp: (0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)(),
                isIssueSummarisedDeploymentsMigratedToAgs: (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re'),
                shouldIncludeDevOpsFieldsViaAgs: !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re')
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("dvgjB")).default), variables, {
                fetchPolicy: 'store-or-network'
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
});
parcelRegister("dvgjB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ecc7304dc73fa0e$export$2e2bcd8739ae039);
    const $8ecc7304dc73fa0e$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "82741647e71f2cf9a8f9e0329b8b9192cd671f81a20c453bd333c79575469f60",
            "metadata": {},
            "name": "uiVersionDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $8ecc7304dc73fa0e$export$2e2bcd8739ae039 = $8ecc7304dc73fa0e$var$node;
});
parcelRegister("20fNh", function(module, exports) {
    $parcel$export(module.exports, "toVersionIssuesGraphQLVariables", ()=>$3e331943907e0f7c$export$72df1c7780b3e8e2);
    $parcel$export(module.exports, "useVersionIssuesGraphQLVariables", ()=>$3e331943907e0f7c$export$3d12d3ffbce57135);
    var $3hGWp;
    var $jPgXx;
    var $3dG8c;
    const $3e331943907e0f7c$var$accountIdToAriStr = (accountIds)=>{
        if (accountIds == null) return null;
        return accountIds.map((accountId)=>accountId === 'UNASSIGNED' ? null : `ari:cloud:identity::user/${accountId}`);
    };
    const $3e331943907e0f7c$export$72df1c7780b3e8e2 = (queryParams)=>{
        const parsedQueryParams = (0, (0, parcelRequire("3dG8c")).parseQueryParams)(queryParams);
        return {
            filters: {
                searchStr: parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b] ?? null,
                epicIds: parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac] ?? null,
                statusCategories: parsedQueryParams[0, $5d187be87424268f$export$c307007520232013] != null ? parsedQueryParams[0, $5d187be87424268f$export$c307007520232013].filter((0, (0, parcelRequire("jPgXx")).isVersionStatusCategory)) : null,
                warningCategories: parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] ?? null,
                assigneeAccountIds: $3e331943907e0f7c$var$accountIdToAriStr(parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2])
            },
            sortBy: {
                sortByField: parsedQueryParams[0, $5d187be87424268f$export$13d5b2891ca65cd6] ?? 'CREATED',
                order: parsedQueryParams[0, $5d187be87424268f$export$810a1f7ed2facfcb] ?? 'ASC'
            }
        };
    };
    const $3e331943907e0f7c$export$3d12d3ffbce57135 = ()=>{
        const [queryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)((0, $5d187be87424268f$export$e39925d10cebc0b), (0, $5d187be87424268f$export$b98a7875ddbefaac), (0, $5d187be87424268f$export$c307007520232013), (0, $5d187be87424268f$export$2552faed9df6a2cd), (0, $5d187be87424268f$export$f78d8c81fcad32a2), (0, $5d187be87424268f$export$13d5b2891ca65cd6), (0, $5d187be87424268f$export$810a1f7ed2facfcb));
        return $3e331943907e0f7c$export$72df1c7780b3e8e2(queryParams);
    };
});
parcelRegister("3hGWp", function(module, exports) {
    $parcel$export(module.exports, "useQueryParams", ()=>$afd0e0a12e1f2496$export$b37ee0d76c6d2fbc);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $hGgHi = parcelRequire("hGgHi");
    var $9xWGk = parcelRequire("9xWGk");
    var $ebyGx = parcelRequire("ebyGx");
    var $doZTA;
    const $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc = (...queryParamsToWatch)=>{
        const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const queryParamsRef = (0, $5uXOq.useRef)({});
        const parsedQueryParams = (0, $5uXOq.useMemo)(()=>{
            const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
                accumulator[currentValue] = query[currentValue] || undefined;
                return accumulator;
            }, {});
            if (!(0, ($parcel$interopDefault($ajpes)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
            return queryParamsRef.current;
        }, [
            query,
            queryParamsToWatch
        ]);
        const setQueryParams = (0, $5uXOq.useCallback)((newQueryParams, options)=>{
            const parsedSearch = (0, ($parcel$interopDefault($9xWGk)))({
                ...query,
                ...newQueryParams
            }, (value)=>(0, ($parcel$interopDefault($hGgHi)))(value));
            const { updateType: updateType, ...stringifyOptions } = options ?? {};
            const strSearch = (0, ($parcel$interopDefault($ebyGx))).stringify(parsedSearch, stringifyOptions);
            const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
            updateType === 'replace' ? replace(url) : push(url);
        }, [
            pathname,
            push,
            replace,
            query
        ]);
        return [
            parsedQueryParams,
            setQueryParams
        ];
    };
});
const $5d187be87424268f$export$e39925d10cebc0b = 'text';
const $5d187be87424268f$export$b98a7875ddbefaac = 'epics';
const $5d187be87424268f$export$c307007520232013 = 'statusCategory';
const $5d187be87424268f$export$2552faed9df6a2cd = 'warnings';
const $5d187be87424268f$export$f78d8c81fcad32a2 = 'assignee';
const $5d187be87424268f$export$13d5b2891ca65cd6 = 'sortBy';
const $5d187be87424268f$export$810a1f7ed2facfcb = 'sortOrder';
parcelRegister("jPgXx", function(module, exports) {
    $parcel$export(module.exports, "isWarningsFilterValue", ()=>$1bd9df170beee33d$export$5c25bcf27380084);
    $parcel$export(module.exports, "toWarningsFilterValue", ()=>$1bd9df170beee33d$export$ac3017cd78edb8a1);
    $parcel$export(module.exports, "isVersionStatusCategory", ()=>$1bd9df170beee33d$export$3af93bbba0d4241a);
    $parcel$export(module.exports, "isSortBy", ()=>$1bd9df170beee33d$export$472650e4cbd40b70);
    $parcel$export(module.exports, "isSortOrder", ()=>$1bd9df170beee33d$export$dfece8cb679d32a3);
    var $gULOk;
    const $1bd9df170beee33d$export$5c25bcf27380084 = (val)=>val === 'OPEN_PULL_REQUEST' || val === 'UNREVIEWED_CODE' || val === 'FAILING_BUILD' || val === 'OPEN_REVIEW';
    const $1bd9df170beee33d$export$ac3017cd78edb8a1 = (statusCategoryFromQueryParam)=>statusCategoryFromQueryParam.filter($1bd9df170beee33d$export$5c25bcf27380084);
    const $1bd9df170beee33d$export$3af93bbba0d4241a = (val)=>val === (0, (0, parcelRequire("gULOk")).TODO) || val === (0, (0, parcelRequire("gULOk")).IN_PROGRESS) || val === (0, (0, parcelRequire("gULOk")).DONE);
    const $1bd9df170beee33d$export$472650e4cbd40b70 = (val)=>val === 'ASSIGNEE' || val === 'CREATED' || val === 'KEY' || val === 'PRIORITY' || val === 'STATUS' || val === 'TYPE';
    const $1bd9df170beee33d$export$dfece8cb679d32a3 = (val)=>val === 'ASC' || val === 'DESC';
});
parcelRegister("gULOk", function(module, exports) {
    $parcel$export(module.exports, "UNDEFINED", ()=>$e77315bf13f8b83b$export$6db089fe7b26f5b6);
    $parcel$export(module.exports, "TODO", ()=>$e77315bf13f8b83b$export$aa456a5030160740);
    $parcel$export(module.exports, "IN_PROGRESS", ()=>$e77315bf13f8b83b$export$5a9ac66c2785cc13);
    $parcel$export(module.exports, "DONE", ()=>$e77315bf13f8b83b$export$71efb3495f6084f2);
    $parcel$export(module.exports, "STATUS_CATEGORIES", ()=>$e77315bf13f8b83b$export$d9119300f9d9a815);
    $parcel$export(module.exports, "StatusCategoryTypes", ()=>$e77315bf13f8b83b$export$5d42a08d46cffe7);
    $parcel$export(module.exports, "StatusCategoryIds", ()=>$e77315bf13f8b83b$export$3f42f49c284d5b58);
    $parcel$export(module.exports, "statusCategoryKeys", ()=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb);
    $parcel$export(module.exports, "statusCategoryForId", ()=>$e77315bf13f8b83b$export$3e9e3002956ff4fb);
    $parcel$export(module.exports, "categoryIdForStatusCategory", ()=>$e77315bf13f8b83b$export$7b16b0022aac2d46);
    $parcel$export(module.exports, "isValidStatusCategoryKey", ()=>$e77315bf13f8b83b$export$d928f247c903643a);
    const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
    const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
    const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
    const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
    const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
        $e77315bf13f8b83b$export$6db089fe7b26f5b6,
        $e77315bf13f8b83b$export$aa456a5030160740,
        $e77315bf13f8b83b$export$5a9ac66c2785cc13,
        $e77315bf13f8b83b$export$71efb3495f6084f2
    ];
    const $e77315bf13f8b83b$var$statusCategories = [
        {
            id: '1',
            statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
        },
        {
            id: '2',
            statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
        },
        {
            id: '4',
            statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
        },
        {
            id: '3',
            statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
        }
    ];
    const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
        NEW: 'new',
        INDETERMINATE: 'indeterminate',
        DONE: 'done',
        UNDEFINED: 'undefined'
    });
    const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
    });
    const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
    const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
        const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
        return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
    };
    const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
        const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
        return Number(value ? value.id : '1');
    };
    const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);
});
parcelRegister("3dG8c", function(module, exports) {
    $parcel$export(module.exports, "isAnyFilterApplied", ()=>$89761db99e7e0304$export$e6b3ec1d09429da8);
    $parcel$export(module.exports, "parseQueryParams", ()=>$89761db99e7e0304$export$67c4cee80a3410cd);
    var $g5X3G;
    var $jPgXx;
    const $89761db99e7e0304$export$e6b3ec1d09429da8 = (parsedQueryParams)=>parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b] != null && parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac] != null && parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$c307007520232013] != null && parsedQueryParams[0, $5d187be87424268f$export$c307007520232013].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] != null && parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2] != null && parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2].length > 0;
    const $89761db99e7e0304$export$2a2e94972ab280d4 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).map((0, (0, parcelRequire("g5X3G")).toIssueId));
    const $89761db99e7e0304$export$fb136b568c6d78b5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).filter((0, (0, parcelRequire("jPgXx")).isVersionStatusCategory));
    const $89761db99e7e0304$export$5cb324c621ca24e8 = (paramValue)=>paramValue == null ? undefined : (0, (0, parcelRequire("jPgXx")).toWarningsFilterValue)(paramValue.split(',').map((str)=>str.trim()));
    const $89761db99e7e0304$export$6c8eda0352c7cf5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>(0, (0, parcelRequire("g5X3G")).toAccountId)(str.trim()));
    const $89761db99e7e0304$export$67c4cee80a3410cd = (paramsRaw)=>{
        const result = {};
        result[0, $5d187be87424268f$export$e39925d10cebc0b] = paramsRaw[0, $5d187be87424268f$export$e39925d10cebc0b];
        result[0, $5d187be87424268f$export$b98a7875ddbefaac] = $89761db99e7e0304$export$2a2e94972ab280d4(paramsRaw[0, $5d187be87424268f$export$b98a7875ddbefaac]);
        result[0, $5d187be87424268f$export$c307007520232013] = $89761db99e7e0304$export$fb136b568c6d78b5(paramsRaw[0, $5d187be87424268f$export$c307007520232013]);
        result[0, $5d187be87424268f$export$2552faed9df6a2cd] = $89761db99e7e0304$export$5cb324c621ca24e8(paramsRaw[0, $5d187be87424268f$export$2552faed9df6a2cd]);
        result[0, $5d187be87424268f$export$f78d8c81fcad32a2] = $89761db99e7e0304$export$6c8eda0352c7cf5(paramsRaw[0, $5d187be87424268f$export$f78d8c81fcad32a2]);
        result[0, $5d187be87424268f$export$13d5b2891ca65cd6] = paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6] && (0, (0, parcelRequire("jPgXx")).isSortBy)(paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6]) ? paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6] : 'CREATED';
        result[0, $5d187be87424268f$export$810a1f7ed2facfcb] = paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb] && (0, (0, parcelRequire("jPgXx")).isSortOrder)(paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb]) ? paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb] : 'ASC';
        return result;
    };
});
const $afc34106ac722f11$export$9fe575a15a87a796 = 'PROJECTS_VERSION_DETAILS';
parcelRegister("12flw", function(module, exports) {
    $parcel$export(module.exports, "softwareVersionDetailRoute", ()=>$da1ceb4f01a49a44$export$eb3633614d0521b0);
    var $65Ltd;
    const $da1ceb4f01a49a44$export$eb3633614d0521b0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
        path: '/projects/:projectKey/versions/:versionId/tab/:tab'
    };
});
parcelRegister("2Y5QL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cnMnO")
    ]).then(()=>parcelRequire('2WNCY'));
});
parcelRegister("2sCk8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("72D8w").then(()=>parcelRequire('68CUZ'));
});
parcelRegister("7hZC2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7R4iz").then(()=>parcelRequire('e2Cll'));
});
parcelRegister("6xd2T", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("jdpLP")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gTfme")
    ]).then(()=>parcelRequire('gcELT'));
});
parcelRegister("9tL3Y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8KQmP").then(()=>parcelRequire('ejLY3'));
});
parcelRegister("eQoM0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6EDMQ").then(()=>parcelRequire('iZwfI'));
});
parcelRegister("57GTs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iTOtj").then(()=>parcelRequire('59dUe'));
});
parcelRegister("aphxY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("bVWcI")
    ]).then(()=>parcelRequire('dz9Sq'));
});
parcelRegister("fDWVs", function(module, exports) {
    $parcel$export(module.exports, "peopleProfilesRoute", ()=>$44b234ae71647fd2$export$1338132568be849);
    var $65Ltd;
    const $44b234ae71647fd2$export$1338132568be849 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PEOPLE_INDEX),
        path: '/jira/people/:subPath?'
    };
});
parcelRegister("84kXR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2vt1O")
    ]).then(()=>parcelRequire('3sora'));
});
parcelRegister("1Xcuw", function(module, exports) {
    $parcel$export(module.exports, "createNotificationPreferencesResource", ()=>$adb36d8860d29889$export$731980bd233a4797);
    $parcel$export(module.exports, "createContactsResource", ()=>$adb36d8860d29889$export$b9ca444b0be3df97);
    $parcel$export(module.exports, "createMuteResource", ()=>$adb36d8860d29889$export$c849cfac68bc6e80);
    $parcel$export(module.exports, "createQuietHoursResource", ()=>$adb36d8860d29889$export$efc5e8690061f9cc);
    $parcel$export(module.exports, "createForwardingRulesResource", ()=>$adb36d8860d29889$export$5314dca65b4e5888);
    var $2M1hQ;
    parcelRequire("jxRF2");
    var $ldKOT;
    var $4wOw1;
    const $adb36d8860d29889$export$731980bd233a4797 = (checkConsolidationOnRouteDependency, depends)=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: 'notificationPreferencesResource',
            getKey: ()=>'notificationPreferencesResource',
            getData: ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("4wOw1")).getNotificationPreferences)();
            },
            isBrowserOnly: true,
            depends: depends
        });
    const $adb36d8860d29889$export$b9ca444b0be3df97 = (checkConsolidationOnRouteDependency, depends)=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: 'contactsResource',
            getKey: ()=>'contactsResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                const data = await (0, (0, parcelRequire("4wOw1")).getContact)();
                return data.contacts;
            },
            isBrowserOnly: true,
            depends: depends
        });
    const $adb36d8860d29889$export$c849cfac68bc6e80 = (checkConsolidationOnRouteDependency, depends)=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: 'muteResource',
            getKey: ()=>'muteResource',
            getData: ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("4wOw1")).getMuteDetail)();
            },
            isBrowserOnly: true,
            depends: depends
        });
    const $adb36d8860d29889$export$efc5e8690061f9cc = (checkConsolidationOnRouteDependency, depends)=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: 'quietHoursResource',
            getKey: ()=>'quietHoursResource',
            getData: ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("4wOw1")).getQuietHoursDetail)();
            },
            isBrowserOnly: true,
            depends: depends
        });
    const $adb36d8860d29889$export$5314dca65b4e5888 = (checkConsolidationOnRouteDependency, depends)=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: 'forwardingRulesResource',
            getKey: ()=>'forwardingRulesResource',
            getData: ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("4wOw1")).getForwardingRules)().then(({ values: values })=>values);
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("4wOw1", function(module, exports) {
    $parcel$export(module.exports, "getNotificationPreferences", ()=>$05fff912cf0441ba$export$60e139c3026f21bc);
    $parcel$export(module.exports, "getContact", ()=>$05fff912cf0441ba$export$52411745da118fc8);
    $parcel$export(module.exports, "getMuteDetail", ()=>$05fff912cf0441ba$export$80a4e62998a806a6);
    $parcel$export(module.exports, "getQuietHoursDetail", ()=>$05fff912cf0441ba$export$44a94c74f358d02f);
    $parcel$export(module.exports, "getForwardingRules", ()=>$05fff912cf0441ba$export$2161af98e3d645a5);
    var $j74qU;
    const $05fff912cf0441ba$export$60e139c3026f21bc = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/notification-preferences`);
    const $05fff912cf0441ba$export$52411745da118fc8 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/contact`);
    const $05fff912cf0441ba$export$80a4e62998a806a6 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/notifications/mute`);
    const $05fff912cf0441ba$export$44a94c74f358d02f = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/users/quiet-hours/details`);
    const $05fff912cf0441ba$export$2161af98e3d645a5 = ()=>(0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/notifications/forwarding-rules`);
});
parcelRegister("1C2yb", function(module, exports) {
    $parcel$export(module.exports, "LEGACY_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$b468ccdb67523656);
    $parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$693b70d1bcef8627);
    $parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$21946ea4c58fd4c9);
    $parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$2321c59d517801c8);
    $parcel$export(module.exports, "getGeneralPersonalSettingsPath", ()=>$63706130a90445cd$export$db9e3ccc1e5e3317);
    $parcel$export(module.exports, "getNotificationsPersonalSettingsPath", ()=>$63706130a90445cd$export$64a672523a583594);
    $parcel$export(module.exports, "getAppsPersonalSettingsPath", ()=>$63706130a90445cd$export$1a7321c4210a3049);
    const $63706130a90445cd$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
    const $63706130a90445cd$export$a974f4af282a75ba = '/jira/settings/personal';
    const $63706130a90445cd$export$693b70d1bcef8627 = `${$63706130a90445cd$export$a974f4af282a75ba}/general`;
    const $63706130a90445cd$export$21946ea4c58fd4c9 = `${$63706130a90445cd$export$a974f4af282a75ba}/notifications`;
    const $63706130a90445cd$export$1fffbb6055aa320a = `${$63706130a90445cd$export$a974f4af282a75ba}/apps`;
    const $63706130a90445cd$export$2321c59d517801c8 = `${$63706130a90445cd$export$a974f4af282a75ba}/alert-notifications`;
    function $63706130a90445cd$export$db9e3ccc1e5e3317() {
        return $63706130a90445cd$export$693b70d1bcef8627;
    }
    function $63706130a90445cd$export$88a45ae8c4b1c664() {
        return $63706130a90445cd$export$2321c59d517801c8;
    }
    function $63706130a90445cd$export$64a672523a583594() {
        return $63706130a90445cd$export$21946ea4c58fd4c9;
    }
    function $63706130a90445cd$export$1a7321c4210a3049() {
        return $63706130a90445cd$export$1fffbb6055aa320a;
    }
});
parcelRegister("7ziML", function(module, exports) {
    $parcel$export(module.exports, "generalPersonalSettingsRoute", ()=>$bac161cf2450c76e$export$7a6c9715a86f906b);
    var $65Ltd;
    var $1C2yb;
    const $bac161cf2450c76e$export$7a6c9715a86f906b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL),
        path: (0, (0, parcelRequire("1C2yb")).GENERAL_PERSONAL_SETTINGS_PATH)
    };
});
parcelRegister("d1xZH", function(module, exports) {
    $parcel$export(module.exports, "notificationsPersonalSettingsRoute", ()=>$de84b22e790c56d0$export$55ab09b9d6beb8be);
    var $65Ltd;
    var $1C2yb;
    const $de84b22e790c56d0$export$55ab09b9d6beb8be = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS),
        path: (0, (0, parcelRequire("1C2yb")).NOTIFICATIONS_PERSONAL_SETTINGS_PATH)
    };
});
parcelRegister("a94gn", function(module, exports) {
    $parcel$export(module.exports, "PersonalSettingsNotificationsAppSkeleton", ()=>$e165273754ebea11$export$b542eb2d3193b983);
    $parcel$export(module.exports, "PersonalSettingsNotificationsGlobalTableSkeleton", ()=>$e165273754ebea11$export$d58f6bbbc1838cb2);
    $parcel$export(module.exports, "ProjectNotificationAccordionSkeleton", ()=>$e165273754ebea11$export$8cb773cb6fc17338);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $hCy6k;
    var $bSzQR = parcelRequire("bSzQR");
    var $D73Nc = parcelRequire("D73Nc");
    var $eVLyC = parcelRequire("eVLyC");
    var $8z1qR = parcelRequire("8z1qR");
    const $e165273754ebea11$var$maxWidthCssStyles = null;
    const $e165273754ebea11$var$customCssStyles = null;
    const $e165273754ebea11$export$b542eb2d3193b983 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($eVLyC))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f8stt _19pkidpf _2hwx1wug _otyridpf _18u01wug"
            ])
        });
    const $e165273754ebea11$export$d58f6bbbc1838cb2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($e165273754ebea11$var$SkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($bSzQR))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        }));
    const $e165273754ebea11$export$46fc11a564484c9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($e165273754ebea11$var$SkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($D73Nc))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        }));
    const $e165273754ebea11$export$8cb773cb6fc17338 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($e165273754ebea11$var$SkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($8z1qR))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        }));
    const $e165273754ebea11$var$SkeletonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_c71ldgin _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bSzQR", function(module, exports) {
    module.exports = new URL("global-table-skeleton-with-projects.tpl.5a5d24b9.svg", import.meta.url).toString();
});
parcelRegister("D73Nc", function(module, exports) {
    module.exports = new URL("mimetype-skeleton.tpl.8b750352.svg", import.meta.url).toString();
});
parcelRegister("eVLyC", function(module, exports) {
    module.exports = new URL("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg", import.meta.url).toString();
});
parcelRegister("8z1qR", function(module, exports) {
    module.exports = new URL("project-accordion-skeleton.tpl.cee2df62.svg", import.meta.url).toString();
});
parcelRegister("7P45F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49af4b582b9c7470$export$2e2bcd8739ae039);
    var $jA1kf;
    const $49af4b582b9c7470$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = [
            v1
        ], v3 = [
            v1,
            {
                "kind": "Literal",
                "name": "first",
                "value": 50
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "id"
        }, v5 = [
            v4,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "xsmall"
                    }
                ]
            }
        ], v6 = [
            {
                "kind": "ScalarField",
                "name": "channel"
            },
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ], v7 = [
            v4,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "concreteType": "JiraNotificationChannel",
                "kind": "LinkedField",
                "name": "emailChannel",
                "plural": false,
                "selections": v6
            },
            {
                "concreteType": "JiraNotificationChannel",
                "kind": "LinkedField",
                "name": "inProductChannel",
                "plural": false,
                "selections": v6
            },
            {
                "kind": "ScalarField",
                "name": "category"
            }
        ], v8 = {
            "concreteType": "JiraNotificationPreferences",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueAssigned",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueUpdated",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueDeleted",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentEdited",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueCreated",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueMoved",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "mentionsCombined",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "worklogCombined",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "miscellaneousIssueEventCombined",
                    "plural": false,
                    "selections": v7
                }
            ]
        }, v9 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0
                ],
                "kind": "Fragment",
                "name": "ui_NotificationsPageAndProjectQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "concreteType": "JiraNotificationGlobalPreference",
                                        "kind": "LinkedField",
                                        "name": "notificationGlobalPreference",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTableNew"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraNotificationOptions",
                                                    "kind": "LinkedField",
                                                    "name": "options",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.notificationGlobalPreference.options"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.notificationGlobalPreference"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                    }
                ],
                "kind": "Operation",
                "name": "ui_NotificationsPageAndProjectQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "JiraNotificationProjectPreferenceConnection",
                                "kind": "LinkedField",
                                "name": "allNotificationProjectPreferences",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectNotificationPreferenceEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraNotificationProjectPreferences",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": v5
                                                    },
                                                    v8,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v9
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "totalCount"
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    v9
                                ]
                            },
                            {
                                "args": v3,
                                "filters": [
                                    "cloudId"
                                ],
                                "handle": "connection",
                                "key": "projects_allNotificationProjectPreferences",
                                "kind": "LinkedHandle",
                                "name": "allNotificationProjectPreferences"
                            },
                            {
                                "args": v2,
                                "concreteType": "JiraNotificationGlobalPreference",
                                "kind": "LinkedField",
                                "name": "notificationGlobalPreference",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraNotificationOptions",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "isEmailNotificationEnabled"
                                            },
                                            v4,
                                            {
                                                "kind": "ScalarField",
                                                "name": "notifyWhenRoleAssigneeEnabled"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "notifyWhenRoleReporterEnabled"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "notifyOwnChangesEnabled"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "batchWindow"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "dailyBatchLocalTime"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "emailMimeType"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isEmailMimeTypeEditable"
                                            }
                                        ]
                                    },
                                    v8
                                ]
                            },
                            {
                                "alias": "allJiraProjectsForModal",
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "notificationConfigurationState": "DEFAULT",
                                            "sortBy": {
                                                "sortBy": "NAME"
                                            }
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 5
                                    }
                                ],
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "allJiraProjects",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": v5
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b7fd514c01c704c310af24b4bec2490f86683eb6f578c5e61833c2151685f3ba",
                "metadata": {},
                "name": "ui_NotificationsPageAndProjectQuery",
                "operationKind": "query",
                "text": null,
                "providedVariables": {
                    "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, (0, parcelRequire("jA1kf")).default)
                }
            }
        };
    }();
    $49af4b582b9c7470$var$node.hash = "b001322577b49b90b0c0e44082f4b2b8";
    var $49af4b582b9c7470$export$2e2bcd8739ae039 = $49af4b582b9c7470$var$node;
});
parcelRegister("jA1kf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$349f2b9cab96c314$export$2e2bcd8739ae039);
    var $349f2b9cab96c314$export$2e2bcd8739ae039 = {
        get () {
            return true;
        }
    };
});
parcelRegister("9RvnT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5d5n9")
    ]).then(()=>parcelRequire('4DJNq'));
});
parcelRegister("bzgPz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("64osF")
    ]).then(()=>parcelRequire('3hooO'));
});
parcelRegister("juaG8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dsU72").then(()=>parcelRequire('6keru'));
});
parcelRegister("eV2qE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3dsjz")
    ]).then(()=>parcelRequire('aV66n'));
});
parcelRegister("dWQF5", function(module, exports) {
    $parcel$export(module.exports, "useIsViewPermissionsEnabled", ()=>$901349e77566565e$export$a94405ffcb20c356);
    $parcel$export(module.exports, "useIsCrossProjectViewsEnabled", ()=>$901349e77566565e$export$34d097b1cd6f89c1);
    var $4R6GH;
    var $efvDm;
    var $ldyPw;
    var $k9JTq;
    const $901349e77566565e$export$8aa8a7878fd61770 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        if ((0, (0, parcelRequire("4R6GH")).fg)('polaris_force-premium')) return true;
        const jpdEdition = (0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_PRODUCT_DISCOVERY), appEditions);
        return jpdEdition === (0, (0, parcelRequire("ldyPw")).toEdition)((0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION));
    };
    const $901349e77566565e$export$a94405ffcb20c356 = ()=>{
        const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
        return isPremium;
    };
    const $901349e77566565e$export$34d097b1cd6f89c1 = ()=>{
        const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
        return isPremium;
    };
});
parcelRegister("k9JTq", function(module, exports) {
    $parcel$export(module.exports, "useAppEditions", ()=>$dde261c9da85268a$export$92ed15881fc090d7);
    var $9OXo1;
    const $dde261c9da85268a$export$92ed15881fc090d7 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.appEditions;
    };
});
parcelRegister("1feyJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4iOXD")
    ]).then(()=>parcelRequire('jaSwr'));
});
parcelRegister("g2CVx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2ZyA4")
    ]).then(()=>parcelRequire('glCkY'));
});
parcelRegister("h9Vsi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5kvjN")
    ]).then(()=>parcelRequire('2PQGe'));
});
parcelRegister("2se5U", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6iZL1")
    ]).then(()=>parcelRequire('ab4oe'));
});
parcelRegister("dICLE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jhjZS")
    ]).then(()=>parcelRequire('b26tT'));
});
parcelRegister("itokL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("c1qtf")
    ]).then(()=>parcelRequire('5KpQH'));
});
parcelRegister("i7K01", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("g6LyJ")
    ]).then(()=>parcelRequire('1H43T'));
});
parcelRegister("1Uh9p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cbWbk").then(()=>parcelRequire('dxuco'));
});
parcelRegister("aXNfQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("76E7u").then(()=>parcelRequire('14xmF'));
});
parcelRegister("exMfY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("245Fj").then(()=>parcelRequire('c81zX'));
});
parcelRegister("793wN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4vv1Q")
    ]).then(()=>parcelRequire('g4KKw'));
});
parcelRegister("3EZ2Y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("Z8lzP")
    ]).then(()=>parcelRequire('joBQW'));
});
parcelRegister("lNXgd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2dsVz").then(()=>parcelRequire('glk23'));
});
parcelRegister("38BXB", function(module, exports) {
    $parcel$export(module.exports, "jsmEmailDomainsListResource", ()=>$02fee81a891a3dc1$export$8e956348e5d47a3c);
    var $2M1hQ;
    const $02fee81a891a3dc1$export$8e956348e5d47a3c = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $fb7ceb315fdf5327$export$2bde433b962efbdd),
        getKey: ()=>'email-domains-list',
        isBrowserOnly: true,
        getDataLoader: ()=>(parcelRequire("kAcB4"))
    });
});
const $fb7ceb315fdf5327$export$2bde433b962efbdd = 'JSM_EMAIL_DOMAINS_LIST';
parcelRegister("kAcB4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bY8Ab").then(()=>parcelRequire('bHzRo'));
});
parcelRegister("7CBZS", function(module, exports) {
    $parcel$export(module.exports, "productsJsmOrganizationDetailsResource", ()=>$d8ebe0a210bfc926$export$ccda79811a15bf5);
    var $2M1hQ;
    const $d8ebe0a210bfc926$export$ccda79811a15bf5 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $1b34d67fee3735c4$export$52408f1a0f23569a),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("7ouAH"))
    });
});
const $1b34d67fee3735c4$export$52408f1a0f23569a = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS';
parcelRegister("7ouAH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2PPIk").then(()=>parcelRequire('dXKCD'));
});
parcelRegister("6nu63", function(module, exports) {
    $parcel$export(module.exports, "productsJsmOrganizationMembersResource", ()=>$36d00fa173b898da$export$65c7941bd3e14d00);
    var $2M1hQ;
    const $36d00fa173b898da$var$TEN_SECONDS_IN_MILLIS = 10000;
    const $36d00fa173b898da$export$65c7941bd3e14d00 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $b3f9f4e37cbce264$export$d3eec3e4b4eac6ac),
        getKey: (routerContext)=>`OrganizationMembers-${routerContext.match.params.organizationId}-${routerContext.query.page}-${routerContext.query.query}`,
        getDataLoader: ()=>(parcelRequire("hMnTg")),
        maxAge: $36d00fa173b898da$var$TEN_SECONDS_IN_MILLIS
    });
});
const $b3f9f4e37cbce264$export$d3eec3e4b4eac6ac = 'PRODUCT_JSM_ORGANIZATION_MEMBERS';
parcelRegister("hMnTg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9Veo5").then(()=>parcelRequire('kx7O4'));
});
parcelRegister("esddG", function(module, exports) {
    $parcel$export(module.exports, "productsJsmOrganizationListResource", ()=>$ad899c035903db82$export$3e38a27ad406d7f7);
    var $2M1hQ;
    const $ad899c035903db82$var$TEN_SECONDS_IN_MILLIS = 10000;
    const $ad899c035903db82$export$3e38a27ad406d7f7 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $5073c414a8292ea0$export$50de2841b08b875f),
        getKey: (routerContext)=>routerContext.query.page,
        getDataLoader: ()=>(parcelRequire("eX5Nx")),
        maxAge: $ad899c035903db82$var$TEN_SECONDS_IN_MILLIS
    });
});
const $5073c414a8292ea0$export$27676104f3192a88 = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST_LEGACY';
const $5073c414a8292ea0$export$50de2841b08b875f = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST';
parcelRegister("eX5Nx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hlkXx").then(()=>parcelRequire('v9BTs'));
});
parcelRegister("dunr3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eZECP").then(()=>parcelRequire('dgpeW'));
});
parcelRegister("eUhw3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1t34o").then(()=>parcelRequire('hfcIv'));
});
parcelRegister("hwXlc", function(module, exports) {
    $parcel$export(module.exports, "productsJswConfigurationResource", ()=>$3248841597f2b624$export$b6a5741c2b47fb17);
    var $2M1hQ;
    const $3248841597f2b624$export$b6a5741c2b47fb17 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $8b1aa0975152cf4f$export$73be8e1edd21e2d),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("kr4uP"))
    });
});
const $8b1aa0975152cf4f$export$73be8e1edd21e2d = 'RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION';
parcelRegister("kr4uP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2WYZL").then(()=>parcelRequire('bX4Lv'));
});
parcelRegister("8dDE8", function(module, exports) {
    $parcel$export(module.exports, "productsJswConfigurationRoute", ()=>$ac36f76001e1c678$export$decdad53ba9b97af);
    var $65Ltd;
    const $ac36f76001e1c678$export$decdad53ba9b97af = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION),
        path: '/jira/settings/products/jira-software-configuration',
        exact: true
    };
});
parcelRegister("2BgIE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1Xl7E").then(()=>parcelRequire('1eYnA'));
});
parcelRegister("1vQWT", function(module, exports) {
    $parcel$export(module.exports, "productsJswStorageManagementResource", ()=>$20cc0f4a1ad53cba$export$2cd668845b3478bd);
    var $2M1hQ;
    const $20cc0f4a1ad53cba$export$2cd668845b3478bd = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $593b84e85768ae60$export$1ac222647be3baf8),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("u9ZMa"))
    });
});
const $593b84e85768ae60$export$1ac222647be3baf8 = 'RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT';
parcelRegister("u9ZMa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jkZvt").then(()=>parcelRequire('a5z0r'));
});
parcelRegister("fqiq7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gWzc8")
    ]).then(()=>parcelRequire('2i4Yq'));
});
parcelRegister("kQwOl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dw3QA").then(()=>parcelRequire('dtDoN'));
});
parcelRegister("jISyc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4lyh8")
    ]).then(()=>parcelRequire('28Pju'));
});
parcelRegister("xNRJ9", function(module, exports) {
    $parcel$export(module.exports, "projectsComponentsResource", ()=>$e6f1f6e8951a4819$export$557cc3eff8939b3);
    var $kbVA4;
    var $2M1hQ;
    const $e6f1f6e8951a4819$export$557cc3eff8939b3 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $7f7620b307267b7d$export$ae1b86a8daeb387d),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("5qUfp")),
        maxAge: (0, (0, parcelRequire("kbVA4")).MIN_MAX_AGE)
    });
});
const $7f7620b307267b7d$export$ae1b86a8daeb387d = 'PROJECTS_COMPONENTS';
parcelRegister("5qUfp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bUZ7U").then(()=>parcelRequire('77Eyd'));
});
parcelRegister("eVMKF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dRI4W")
    ]).then(()=>parcelRequire('2NjcZ'));
});
parcelRegister("kI4TI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d3O83").then(()=>parcelRequire('L9JRT'));
});
parcelRegister("VGEuh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3dqRu")
    ]).then(()=>parcelRequire('8nMC7'));
});
parcelRegister("cQsSp", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsComponentsRoute", ()=>$d6034f5b9e9794c0$export$79cbce13eeecd53);
    var $65Ltd;
    const $d6034f5b9e9794c0$export$79cbce13eeecd53 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS),
        path: '/plugins/servlet/project-config/:projectKey/administer-components'
    };
});
parcelRegister("bC7QJ", function(module, exports) {
    $parcel$export(module.exports, "projectVersionsRelayResource", ()=>$d194483d3a062e97$export$7e8aa1360f86345c);
    var $8Uumt = parcelRequire("8Uumt");
    var $e8T8A;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $lqMPx;
    var $2M1hQ;
    const $d194483d3a062e97$export$7e8aa1360f86345c = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, $92b865e141ed2a4f$export$59aa73792ad9507a)}`,
        getKey: ({ match: match })=>{
            const { projectKey: projectKey } = match.params;
            return `project-version-query-relay-${projectKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const variables = {
                initialLoadCount: 20,
                cloudId: tenantContext.cloudId,
                projectKey: match.params.projectKey,
                filter: (0, (0, parcelRequire("e8T8A")).transformStatusFromParam)(query[0, $6868fc0fce0c2912$export$3e8168848b996f7]),
                searchString: query[0, $6868fc0fce0c2912$export$a181206198b7f50c] || '',
                sortBy: {
                    sortByField: (0, (0, parcelRequire("e8T8A")).transformSortFieldFromParam)(query[0, $6868fc0fce0c2912$export$a3482d3a8df0e725]),
                    order: (0, (0, parcelRequire("e8T8A")).transformSortOrderFromParam)(query[0, $6868fc0fce0c2912$export$71089821f361e881])
                }
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("lqMPx")).default), variables, {
                fetchPolicy: 'store-or-network'
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
});
const $6868fc0fce0c2912$export$a181206198b7f50c = 'contains';
const $6868fc0fce0c2912$export$3e8168848b996f7 = 'status';
const $6868fc0fce0c2912$export$71089821f361e881 = 'orderDirection';
const $6868fc0fce0c2912$export$a3482d3a8df0e725 = 'orderField';
const $6868fc0fce0c2912$export$3c5e605ca7ade9f2 = 'NAME';
const $6868fc0fce0c2912$export$50241fe906e4f94e = 'RELEASE_DATE';
const $6868fc0fce0c2912$export$99a467bcc22b8df9 = 'START_DATE';
const $6868fc0fce0c2912$export$d44826c816b5619b = 'DESCRIPTION';
const $6868fc0fce0c2912$export$34694f8d8b23ee2a = 'SEQUENCE';
const $6868fc0fce0c2912$export$cb638d1fae624fbf = 20;
const $6868fc0fce0c2912$export$bbcbc202f2dfa28c = 3;
const $6868fc0fce0c2912$export$b983f2cb1f658a55 = 'RELEASED';
const $6868fc0fce0c2912$export$cb459d726a8530a5 = 'UNRELEASED';
const $6868fc0fce0c2912$export$c936349447a77fe0 = 'ARCHIVED';
const $6868fc0fce0c2912$export$c5ed97509d0e2aaf = 'projectVersions';
parcelRegister("e8T8A", function(module, exports) {
    $parcel$export(module.exports, "transformStatusFromParam", ()=>$b959dd84148d7436$export$5760f9690301cdb);
    $parcel$export(module.exports, "transformStatusToParam", ()=>$b959dd84148d7436$export$46595832dd863016);
    $parcel$export(module.exports, "transformSortOrderFromParam", ()=>$b959dd84148d7436$export$1945e6d2f31e09e6);
    $parcel$export(module.exports, "transformSortFieldFromParam", ()=>$b959dd84148d7436$export$f842a0d1846d319d);
    $parcel$export(module.exports, "transformStatusToDropdownSelection", ()=>$b959dd84148d7436$export$7dad705635760cfe);
    $parcel$export(module.exports, "getUpdatedDisplayedStatuses", ()=>$b959dd84148d7436$export$ce4c948ba1d53df4);
    $parcel$export(module.exports, "getFormattedVersionDate", ()=>$b959dd84148d7436$export$5a6eeb16be7dd21d);
    var $1O7Kb;
    var $brjCS;
    const $b959dd84148d7436$export$5760f9690301cdb = (input)=>{
        switch(input){
            case 'no-filter':
                return [
                    (0, (0, parcelRequire("brjCS")).RELEASED),
                    (0, (0, parcelRequire("brjCS")).UNRELEASED),
                    (0, (0, parcelRequire("brjCS")).ARCHIVED)
                ];
            case 'all':
                return [
                    (0, (0, parcelRequire("brjCS")).RELEASED),
                    (0, (0, parcelRequire("brjCS")).UNRELEASED),
                    (0, (0, parcelRequire("brjCS")).ARCHIVED)
                ];
            default:
                {
                    const params = (input || '').split('-');
                    const result = [
                        ...params.includes('released') ? [
                            (0, (0, parcelRequire("brjCS")).RELEASED)
                        ] : [],
                        ...params.includes('unreleased') ? [
                            (0, (0, parcelRequire("brjCS")).UNRELEASED)
                        ] : [],
                        ...params.includes('archived') ? [
                            (0, (0, parcelRequire("brjCS")).ARCHIVED)
                        ] : []
                    ];
                    return result.length ? result : [
                        (0, (0, parcelRequire("brjCS")).UNRELEASED)
                    ];
                }
        }
    };
    const $b959dd84148d7436$export$46595832dd863016 = (input)=>{
        if (input) {
            if (input.length === 0) return 'no-filter';
            if (input.length > 2) return 'all';
            return [
                input.includes((0, (0, parcelRequire("brjCS")).RELEASED)) && [
                    'released'
                ],
                input.includes((0, (0, parcelRequire("brjCS")).UNRELEASED)) && [
                    'unreleased'
                ],
                input.includes((0, (0, parcelRequire("brjCS")).ARCHIVED)) && [
                    'archived'
                ]
            ].filter(Boolean).join('-');
        }
        return undefined;
    };
    const $b959dd84148d7436$export$1945e6d2f31e09e6 = (input)=>{
        switch(input){
            case 'ASC':
                return 0, $2a9e000a443b1a95$export$1dee026a19752d6b;
            case 'DESC':
                return 0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65;
            default:
                return 0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65;
        }
    };
    const $b959dd84148d7436$export$f842a0d1846d319d = (input)=>{
        switch(input){
            case 'NAME':
                return 0, $6868fc0fce0c2912$export$3c5e605ca7ade9f2;
            case 'RELEASEDATE':
                return 0, $6868fc0fce0c2912$export$50241fe906e4f94e;
            case 'STARTDATE':
                return 0, $6868fc0fce0c2912$export$99a467bcc22b8df9;
            case 'DESCRIPTION':
                return 0, $6868fc0fce0c2912$export$d44826c816b5619b;
            case 'SEQUENCE':
                return 0, $6868fc0fce0c2912$export$34694f8d8b23ee2a;
            default:
                return 0, $6868fc0fce0c2912$export$34694f8d8b23ee2a;
        }
    };
    const $b959dd84148d7436$export$7dad705635760cfe = (input)=>{
        switch(input){
            case 'no-filter':
                return [];
            case 'all':
                return [
                    (0, (0, parcelRequire("brjCS")).RELEASED),
                    (0, (0, parcelRequire("brjCS")).UNRELEASED),
                    (0, (0, parcelRequire("brjCS")).ARCHIVED)
                ];
            default:
                {
                    const params = (input || '').split('-');
                    const result = [
                        ...params.includes('released') ? [
                            (0, (0, parcelRequire("brjCS")).RELEASED)
                        ] : [],
                        ...params.includes('unreleased') ? [
                            (0, (0, parcelRequire("brjCS")).UNRELEASED)
                        ] : [],
                        ...params.includes('archived') ? [
                            (0, (0, parcelRequire("brjCS")).ARCHIVED)
                        ] : []
                    ];
                    return result.length ? result : [
                        (0, (0, parcelRequire("brjCS")).UNRELEASED)
                    ];
                }
        }
    };
    const $b959dd84148d7436$export$ce4c948ba1d53df4 = (displayedStatuses, selectedStatuses, newStatus)=>{
        if (displayedStatuses.length === (0, $6868fc0fce0c2912$export$bbcbc202f2dfa28c)) {
            if (!selectedStatuses.length) return [
                newStatus
            ];
            return displayedStatuses.filter((status)=>status !== newStatus);
        }
        return displayedStatuses.includes(newStatus) ? displayedStatuses.filter((item)=>item !== newStatus) : [
            ...displayedStatuses,
            newStatus
        ];
    };
    const $b959dd84148d7436$export$5a6eeb16be7dd21d = (versionDate, formatDate)=>versionDate != null ? formatDate(new Date(versionDate), {
            timeZone: (0, (0, parcelRequire("1O7Kb")).VERSION_DATE_FORMAT_OPTION).timeZone,
            dateStyle: 'long'
        }) : '';
});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';
parcelRegister("1O7Kb", function(module, exports) {
    $parcel$export(module.exports, "VERSION_DATE_FORMAT_OPTION", ()=>$db4b27c65287280e$export$d54c0d576c2caef5);
    const $db4b27c65287280e$export$d54c0d576c2caef5 = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    };
});
parcelRegister("brjCS", function(module, exports) {
    $parcel$export(module.exports, "RELEASED", ()=>$96a1491cb0f9d4eb$export$b983f2cb1f658a55);
    $parcel$export(module.exports, "UNRELEASED", ()=>$96a1491cb0f9d4eb$export$cb459d726a8530a5);
    $parcel$export(module.exports, "ARCHIVED", ()=>$96a1491cb0f9d4eb$export$c936349447a77fe0);
    const $96a1491cb0f9d4eb$export$b983f2cb1f658a55 = 'RELEASED';
    const $96a1491cb0f9d4eb$export$cb459d726a8530a5 = 'UNRELEASED';
    const $96a1491cb0f9d4eb$export$c936349447a77fe0 = 'ARCHIVED';
    var $96a1491cb0f9d4eb$export$2e2bcd8739ae039 = [
        $96a1491cb0f9d4eb$export$b983f2cb1f658a55,
        $96a1491cb0f9d4eb$export$cb459d726a8530a5,
        $96a1491cb0f9d4eb$export$c936349447a77fe0
    ];
});
parcelRegister("lqMPx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08cc25b93689af36$export$2e2bcd8739ae039);
    const $08cc25b93689af36$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "initialLoadCount"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchString"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sortBy"
        }, v6 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v7 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v8 = {
            "kind": "ScalarField",
            "name": "name"
        }, v9 = {
            "kind": "ScalarField",
            "name": "key"
        }, v10 = {
            "alias": "jiraProjectType",
            "kind": "ScalarField",
            "name": "projectType"
        }, v11 = {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }, v12 = {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        }, v13 = {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }, v14 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v15 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v16 = {
            "kind": "ScalarField",
            "name": "statusCode"
        }, v17 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v18 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v19 = [
            v11,
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "initialLoadCount"
            },
            v12,
            v13
        ], v20 = {
            "kind": "ScalarField",
            "name": "id"
        }, v21 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v22 = [
            v21
        ], v23 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": "DONE"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5
                ],
                "kind": "Fragment",
                "name": "uiProjectVersionsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v6,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v7,
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.projectId"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v8,
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.name"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v9,
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.key"
                                            },
                                            v10,
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "alias": "versions",
                                                    "args": [
                                                        v11,
                                                        v12,
                                                        v13
                                                    ],
                                                    "concreteType": "JiraVersionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "__uiProject__versions_connection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v14,
                                                                v15,
                                                                {
                                                                    "concreteType": "JiraVersion",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "extensions",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v16
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v17,
                                                        v18
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.versions"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraProjectByKey"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    },
                    {
                        "args": v19,
                        "kind": "FragmentSpread",
                        "name": "table_projectVersions"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v1,
                    v4,
                    v5,
                    v0,
                    v3
                ],
                "kind": "Operation",
                "name": "uiProjectVersionsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v6,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v7,
                                    v8,
                                    v9,
                                    v10,
                                    {
                                        "args": v19,
                                        "concreteType": "JiraVersionConnection",
                                        "kind": "LinkedField",
                                        "name": "versions",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v14,
                                                    v15,
                                                    {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v14,
                                                            v20,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "status"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "description"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "startDate"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "releaseDate"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "overdue"
                                                            },
                                                            {
                                                                "alias": "allIssues",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "filter",
                                                                        "value": "ALL"
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"ALL\")"
                                                            },
                                                            {
                                                                "alias": "doneIssues",
                                                                "args": v23,
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"DONE\")"
                                                            },
                                                            {
                                                                "alias": "done",
                                                                "args": v23,
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"DONE\")"
                                                            },
                                                            {
                                                                "alias": "inProgress",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "filter",
                                                                        "value": "IN_PROGRESS"
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                            },
                                                            {
                                                                "alias": "toDo",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "filter",
                                                                        "value": "TODO"
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"TODO\")"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "versionId"
                                                            },
                                                            v8,
                                                            v18
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "QueryError",
                                                "kind": "LinkedField",
                                                "name": "errors",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "extensions",
                                                        "plural": true,
                                                        "selections": [
                                                            v14,
                                                            v16
                                                        ]
                                                    }
                                                ]
                                            },
                                            v17,
                                            v18,
                                            v21
                                        ]
                                    },
                                    {
                                        "args": v19,
                                        "filters": [
                                            "filter",
                                            "searchString",
                                            "sortBy"
                                        ],
                                        "handle": "connection",
                                        "key": "uiProject__versions",
                                        "kind": "LinkedHandle",
                                        "name": "versions"
                                    },
                                    v20,
                                    {
                                        "kind": "ScalarField",
                                        "name": "projectType"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "a6e359ecda35492174250b1c105fa73cbd222dbbdae576ab9b3b84813585a559",
                "metadata": {
                    "connection": [
                        {
                            "count": "initialLoadCount",
                            "cursor": null,
                            "direction": "forward",
                            "path": [
                                "jira",
                                "jiraProjectByKey",
                                "versions"
                            ]
                        }
                    ]
                },
                "name": "uiProjectVersionsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $08cc25b93689af36$var$node.hash = "3bed4070fd244faac23cfc6a62e64f6c";
    var $08cc25b93689af36$export$2e2bcd8739ae039 = $08cc25b93689af36$var$node;
});
const $92b865e141ed2a4f$export$59aa73792ad9507a = 'PROJECT_VERSIONS';
parcelRegister("cXVqt", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsVersionsRoute", ()=>$b9ce459589c7232c$export$cc9450e5d7579b99);
    var $65Ltd;
    const $b9ce459589c7232c$export$cc9450e5d7579b99 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS),
        path: '/plugins/servlet/project-config/:projectKey/administer-versions'
    };
});
parcelRegister("8gvY1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("guRgf")
    ]).then(()=>parcelRequire('5E2pR'));
});
parcelRegister("2iuKi", function(module, exports) {
    $parcel$export(module.exports, "projectsRedirectRoute", ()=>$3aa0370b36d3207d$export$e6bc3ea427ddafb8);
    var $65Ltd;
    const $3aa0370b36d3207d$export$e6bc3ea427ddafb8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_REDIRECT),
        path: '/projects/:projectKey',
        query: [
            'selectedItem!=(.+)'
        ],
        exact: true
    };
});
parcelRegister("4OVrg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2Nk6X").then(()=>parcelRequire('8ImNC'));
});
parcelRegister("cMc6T", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lUQNB").then(()=>parcelRequire('jsr3R'));
});
parcelRegister("e4B7v", function(module, exports) {
    $parcel$export(module.exports, "componentFilterResource", ()=>$ff0131666c555211$export$306e389909032632);
    $parcel$export(module.exports, "useComponentFilterResource", ()=>$ff0131666c555211$export$e13868d6ab2288af);
    var $dK8AG;
    var $2M1hQ;
    var $2YP9W;
    const $ff0131666c555211$var$getDataLoader = ()=>(parcelRequire("6JIaQ"));
    const $ff0131666c555211$export$306e389909032632 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ESCALATIONS_COMPONENT_FILTER_RESOURCE',
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $ff0131666c555211$var$getDataLoader
    });
    const $ff0131666c555211$export$e13868d6ab2288af = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($ff0131666c555211$export$306e389909032632);
});
parcelRegister("6JIaQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2IGml").then(()=>parcelRequire('hXg9m'));
});
parcelRegister("7fRd9", function(module, exports) {
    $parcel$export(module.exports, "priorityFilterResource", ()=>$1ec7e880e057744a$export$ca03c5f9fc44703e);
    $parcel$export(module.exports, "usePriorityFilterResource", ()=>$1ec7e880e057744a$export$3654f46b6bb12558);
    var $4R6GH;
    var $dK8AG;
    var $2M1hQ;
    var $2YP9W;
    const $1ec7e880e057744a$var$getDataLoader = ()=>(parcelRequire("j4Bjz"));
    const $1ec7e880e057744a$export$ca03c5f9fc44703e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $1ec7e880e057744a$var$getDataLoader
    });
    const $1ec7e880e057744a$export$3654f46b6bb12558 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? $1ec7e880e057744a$export$ca03c5f9fc44703e : (0, (0, parcelRequire("2M1hQ")).createResource)({
            type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
            getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
            getDataLoader: $1ec7e880e057744a$var$getDataLoader
        }));
});
parcelRegister("j4Bjz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cfFsf").then(()=>parcelRequire('ejgJG'));
});
parcelRegister("aitbf", function(module, exports) {
    $parcel$export(module.exports, "escalationsRoute", ()=>$9284d8a10ef1ae73$export$3d91b36833b7ddb9);
    var $65Ltd;
    const $9284d8a10ef1ae73$export$3d91b36833b7ddb9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS),
        path: '/jira/servicedesk/projects/:projectKey/escalations',
        exact: true
    };
});
parcelRegister("e9YVH", function(module, exports) {
    $parcel$export(module.exports, "APP_NAMES", ()=>$26ff993b947c317f$export$4116f3d0d9d6bed7);
    $parcel$export(module.exports, "toPackageName", ()=>$26ff993b947c317f$export$f31a652635bd75fe);
    const $26ff993b947c317f$export$4116f3d0d9d6bed7 = {
        ACCOUNTS: 'servicedesk.accounts',
        APP_DISCOVERY: 'servicedesk.app-discovery',
        ATLASSIAN_ANALYTICS: 'servicedesk.atlassian-analytics',
        AUTOMATION_EDIT_RULE: 'servicedesk.automation.edit-rule',
        AUTOMATION_SUMMARY: 'servicedesk.automation.summary',
        AUTOMATION_VIEW_LOG: 'servicedesk.automation.view-log',
        BOARD: 'servicedesk.board',
        BOARD_SETTINGS: 'servicedesk.board-settings',
        CALENDAR: 'servicedesk.calendar',
        PROJECT_SUMMARY: 'servicedesk.project-summary',
        CHANGE_CALENDAR: 'servicedesk.change-calendar',
        CHANGE_MANAGEMENT_SETTINGS: 'servicedesk.change-management.settings',
        CREATE_PROJECT: 'servicedesk.create-project',
        CSAT_CONFIG: 'servicedesk.csat-configuration',
        CUSTOMER_PERMISSIONS: 'servicedesk.customer-permissions',
        CONTACTS: 'servicedesk.contacts',
        CUSTOMERS: 'servicedesk.customers',
        CUSTOMER_DETAILS: 'servicedesk.customer-details',
        CUSTOMER_SERVICE_ESCALATIONS: 'servicedesk.customer-service-escalations',
        CUSTOMER_SERVICE_PRODUCTS: 'servicedesk.customer-service-products',
        CUSTOMER_SERVICE_HELP_CENTER: 'servicedesk.customer-service-help-center',
        INVITE_TEAM_DIALOG: 'servicedesk.invite-team-dialog',
        ISSUE_SCHEDULE_CHANGE: 'servicedesk.issue.schedule-change',
        ITSM_FEATURES_SETTINGS: 'servicedesk.itsm-features.settings',
        ITSM_SAMPLE_SPACE: 'servicedesk.itsm-sample-space',
        JOURNEYS: 'servicedesk.journeys',
        JOURNEY_CONFIG: 'servicedesk.journey-config',
        GETTING_STARTED_PAGE: 'servicedesk.getting-started-page',
        KB_BROWSE_ARTICLES: 'servicedesk.knowledge-base.browse-articles',
        KB_CATEGORY: 'servicedesk.knowledge-base.category',
        KB_DRAFTS: 'servicedesk.knowledge-base.drafts',
        KB_BROWSE_CATEGORIES: 'servicedesk.knowledge-base.browse-categories',
        KB_SUGGESTED_ARTICLES: 'servicedesk.knowledge-base.suggested-articles',
        KB_EMBED_EDITOR: 'servicedesk.knowledge-article.embed-editor',
        KB_LANDING: 'servicedesk.knowledge-base.landing',
        KB_REPORTS_REQUESTS: 'servicedesk.kb-requests.reports',
        KB_SEARCH: 'servicedesk.knowledge-base.search',
        KB_SETTINGS: 'servicedesk.knowledge.settings',
        KB_SETUP: 'servicedesk.knowledge-base.setup',
        KB_VIEW_ARTICLE: 'servicedesk.knowledge-base.view-article',
        ORGANIZATION: 'servicedesk.organization',
        ORGANIZATIONS: 'servicedesk.organizations',
        ORGANIZATION_DETAILS: 'servicedesk.organization-details',
        PORTAL_SETTINGS: 'servicedesk.portal-settings',
        QUEUES_AGENT_VIEW: 'servicedesk.queues.agent-view',
        QUEUES_EDIT_VIEW: 'servicedesk.queues.edit-view',
        QUEUES_MAIN: 'servicedesk.queues.main',
        REPORTS_CUSTOM: 'servicedesk.reports.custom',
        REPORTS_CUSTOM_CREATE: 'servicedesk.reports.custom-create',
        REPORTS_CUSTOM_EDIT: 'servicedesk.reports.custom-edit',
        REPORTS_HOME_PAGE: 'servicedesk.reports.home-page',
        REPORTS_SATISFACTION: 'servicedesk.reports.satisfaction',
        REPORTS_WORKLOAD: 'servicedesk.reports.workload',
        REQUEST_TYPES_CONFIG: 'servicedesk.request-types-config',
        REQUEST_TYPE_FIELDS: 'servicedesk.request-type-fields',
        SLA_SETTINGS: 'servicedesk.sla-settings',
        VIRTUAL_AGENT_BROWSE_CONVERSATIONS: 'servicedesk.virtual-agent.browse-conversations',
        VIRTUAL_AGENT_BROWSE_INTENTS: 'servicedesk.virtual-agent.browse-intents',
        VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS: 'servicedesk.virtual-agent.browse-standard-flows',
        VIRTUAL_AGENT_LANDING: 'servicedesk.virtual-agent.landing',
        VIRTUAL_AGENT_SETTINGS: 'servicedesk.virtual-agent.settings',
        VIRTUAL_AGENT_VIEW_INTENT: 'servicedesk.virtual-agent.view-intent',
        VIRTUAL_AGENT_VIEW_STANDARD_FLOW: 'servicedesk.virtual-agent.view-standard-flow',
        VIRTUAL_AGENT_AI_ANSWERS: 'servicedesk.virtual-agent.ai-answers',
        VIRTUAL_AGENT_PERFORMANCE: 'servicedesk.virtual-agent.performance',
        PRACTICE_CONFIG_MODULE: 'servicedesk.practice-config-module',
        CREATE_SERVICE_MODAL: 'servicedesk.create-service-modal',
        UPDATE_SERVICE_MODAL: 'servicedesk.update-service-modal',
        LANGUAGE_SETTINGS: 'servicedesk.language-settings',
        LINKED_ALERTS_MODAL: 'servicedesk.link-alerts-modal',
        INSIGHT_ASSETS_REPORTS: 'servicedesk.insight-cmdb-assets_reports',
        INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT: 'servicedesk.insight-cmdb-assets_reports_default_redirect',
        INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE: 'servicedesk.insight-cmdb-assets_reports_unsubscribe',
        INSIGHT_OBJECT_VIEW: 'servicedesk.insight-cmdb-object',
        INSIGHT_OBJECT_SCHEMA: 'servicedesk.insight-cmdb-object-schema',
        INSIGHT_OBJECT_SCHEMA_CONFIGURATION: 'servicedesk.insight-cmdb-object-schema-configuration',
        INSIGHT_OBJECT_TYPE_CONFIGURATION: 'servicedesk.insight-object-type-configuration',
        INSIGHT_GLOBAL_CONFIGURATION: 'servicedesk.insight-cmdb-global-configuration',
        INSIGHT_LANDING_PAGE: 'servicedesk.insight-cmdb-landing-page',
        CUSTOMER_NOTIFICATIONS_MAIN_VIEW: 'servicedesk.customer-notifications-settings.main-view',
        CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW: 'servicedesk.customer-notifications-settings.invite-customer-view',
        CUSTOMER_NOTIFICATIONS_RULE_VIEW: 'servicedesk.customer-notifications-settings.rule-view',
        CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW: 'servicedesk.customer-notifications-settings.template-view',
        CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW: 'servicedesk.customer-notifications-settings.unknown-view',
        SERVICES_WITHOUT_PROJECT_VIEW: 'servicedesk.services-without-project-view',
        SERVICE_DETAIL_WITHOUT_PROJECT_VIEW: 'servicedesk.service-detail-without-project-view',
        WIDGET_SETTINGS: 'servicedesk.widget-settings'
    };
    const $26ff993b947c317f$var$ANALYTICS_PACKAGE_NAMES = {
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ACCOUNTS]: 'servicedeskAccounts',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.APP_DISCOVERY]: 'serviceDeskAppDiscovery',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ATLASSIAN_ANALYTICS]: 'serviceDeskAtlassianAnalytics',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_EDIT_RULE]: 'servicedeskAutomationEditView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_SUMMARY]: 'servicedeskAutomationEditRule',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_VIEW_LOG]: 'servicedeskAutomationViewLog',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.BOARD]: 'servicedeskBoard',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.BOARD_SETTINGS]: 'servicedeskBoardSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CALENDAR]: 'servicedeskCalendar',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.PROJECT_SUMMARY]: 'servicedeskProjectSummary',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CHANGE_CALENDAR]: 'servicedeskChangeCalendar',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CHANGE_MANAGEMENT_SETTINGS]: 'servicedeskChangeManagementSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CREATE_PROJECT]: 'servicedeskCreateProject',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CSAT_CONFIG]: 'servicedeskCsatConfig',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CONTACTS]: 'servicedeskContacts',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_PERMISSIONS]: 'servicedeskCustomerPermissions',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMERS]: 'servicedeskCustomers',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_DETAILS]: 'servicedeskCustomerDetails',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_ESCALATIONS]: 'servicedeskCustomerServiceEscalations',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_PRODUCTS]: 'servicedeskCustomerServiceProducts',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_HELP_CENTER]: 'servicedeskCustomerServiceHelpCenter',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INVITE_TEAM_DIALOG]: 'servicedeskInviteTeamDialog',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ISSUE_SCHEDULE_CHANGE]: 'servicedeskIssueScheduleChange',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_FEATURES_SETTINGS]: 'servicedeskItsmFeaturesSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_SAMPLE_SPACE]: 'servicedeskItsmSampleSpace',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.JOURNEYS]: 'servicedeskJourneys',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.JOURNEY_CONFIG]: 'servicedeskJourneyConfig',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_BROWSE_ARTICLES]: 'servicedeskKnowledgeBaseBrowseArticles',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_BROWSE_CATEGORIES]: 'servicedeskKnowledgeBaseBrowseCategories',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_CATEGORY]: 'servicedeskKnowledgeBaseCategory',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_DRAFTS]: 'servicedeskKnowledgeBaseDrafts',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SUGGESTED_ARTICLES]: 'servicedeskKnowledgeBaseSuggestedArticles',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_EMBED_EDITOR]: 'servicedeskKnowledgeBaseEmbedEditor',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_LANDING]: 'servicedeskKnowledgeBaseLanding',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_REPORTS_REQUESTS]: 'servicedeskKbRequestsReports',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SEARCH]: 'servicedeskKnowledgeBaseSearch',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SETTINGS]: 'servicedeskKnowledgeSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SETUP]: 'servicedeskKnowledgeBaseSetup',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_VIEW_ARTICLE]: 'servicedeskKnowledgeBaseViewArticle',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.LANGUAGE_SETTINGS]: 'servicedeskLanguageSettingsTranslations',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATION]: 'servicedeskOrganization',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATIONS]: 'servicedeskOrganizations',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATION_DETAILS]: 'servicedeskOrganizationDetails',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.PORTAL_SETTINGS]: 'servicedeskPortalSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_AGENT_VIEW]: 'servicedeskQueuesAgentView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_EDIT_VIEW]: 'servicedeskQueuesEditView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_MAIN]: 'servicedeskQueuesMain',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM]: 'servicedeskReportsCustom',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_CREATE]: 'servicedeskReportsCustomCreate',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_EDIT]: 'servicedeskReportsCustomEdit',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_HOME_PAGE]: 'servicedeskReportsHomePage',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_SATISFACTION]: 'servicedeskReportsSatisfaction',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_WORKLOAD]: 'servicedeskReportsWorkload',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REQUEST_TYPES_CONFIG]: 'servicedeskRequestTypesConfig',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REQUEST_TYPE_FIELDS]: 'servicedeskRequestTypeFields',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.SLA_SETTINGS]: 'servicedeskSlaSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_CONVERSATIONS]: 'servicedeskVirtualAgentBrowseConversations',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_INTENTS]: 'servicedeskVirtualAgentBrowseIntents',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS]: 'servicedeskVirtualAgentBrowseStandardFlows',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_LANDING]: 'servicedeskVirtualAgentLanding',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_SETTINGS]: 'servicedeskVirtualAgentSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_INTENT]: 'servicedeskVirtualAgentViewIntent',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_STANDARD_FLOW]: 'servicedeskVirtualAgentViewStandardFlow',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_AI_ANSWERS]: 'servicedeskVirtualAgentAiAnswers',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_PERFORMANCE]: 'servicedeskVirtualAgentPerformance',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.PRACTICE_CONFIG_MODULE]: 'servicedeskPracticeConfigModule',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CREATE_SERVICE_MODAL]: 'servicedeskCreateServiceModal',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.UPDATE_SERVICE_MODAL]: 'servicedeskUpdateServiceModal',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.LINKED_ALERTS_MODAL]: 'servicedeskLinkAlertsModal',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS]: 'servicedeskAssetsReports',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT]: 'servicedeskAssetsReportsDefaultRedirect',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE]: 'servicedeskAssetsReportsUnsubscribe',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_VIEW]: 'servicedeskObjectView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA]: 'servicedeskObjectSchema',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA_CONFIGURATION]: 'servicedeskObjectSchemaConfiguration',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_TYPE_CONFIGURATION]: 'servicedeskObjectTypeConfiguration',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_GLOBAL_CONFIGURATION]: 'servicedeskInsightGlobalConfiguration',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_LANDING_PAGE]: 'servicedeskInsightLandingPage',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_MAIN_VIEW]: 'servicedeskCustomerNotificationsMainView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW]: 'servicedeskCustomerNotificationsInviteCustomerView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_RULE_VIEW]: 'servicedeskCustomerNotificationsRuleView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW]: 'servicedeskCustomerNotificationsTemplateView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW]: 'servicedeskCustomerNotificationsUnknownView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.GETTING_STARTED_PAGE]: 'servicedeskGettingStartedPage',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.SERVICES_WITHOUT_PROJECT_VIEW]: 'servicedeskServicesWithoutProjectView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.SERVICE_DETAIL_WITHOUT_PROJECT_VIEW]: 'servicedeskServiceDetailWithoutProjectView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.WIDGET_SETTINGS]: 'servicedeskWidgetSettings'
    };
    const $26ff993b947c317f$export$f31a652635bd75fe = (appName)=>$26ff993b947c317f$var$ANALYTICS_PACKAGE_NAMES[appName];
});
parcelRegister("dEz0W", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("74akO")
    ]).then(()=>parcelRequire('81cgT'));
});
parcelRegister("4P2oj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gpMCn").then(()=>parcelRequire('emSF0'));
});
parcelRegister("7yABM", function(module, exports) {
    $parcel$export(module.exports, "PRODUCTS_PAGE_SIZE", ()=>$cbdcceb1886ba86d$export$9e59a0b3e9d74a99);
    $parcel$export(module.exports, "customerServiceProductsQueryResource", ()=>$cbdcceb1886ba86d$export$f9257217f5333b1a);
    var $ao2h1;
    var $aPLvO;
    const $cbdcceb1886ba86d$export$9e59a0b3e9d74a99 = 50;
    const $cbdcceb1886ba86d$export$f9257217f5333b1a = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'CUSTOMER_SERVICE_PRODUCTS_QUERY',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("aPLvO")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    first: $cbdcceb1886ba86d$export$9e59a0b3e9d74a99
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("aPLvO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06c174000e8c134e$export$2e2bcd8739ae039);
    const $06c174000e8c134e$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "first"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }, v3 = [
            v2
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "srcCustomerServiceProductsQuery",
                "selections": [
                    {
                        "args": [
                            v1,
                            v2
                        ],
                        "kind": "FragmentSpread",
                        "name": "productsPage_servicedeskCustomerServiceProducts"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "srcCustomerServiceProductsQuery",
                "selections": [
                    {
                        "args": [
                            v1
                        ],
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "CustomerServiceProductConnection",
                                "kind": "LinkedField",
                                "name": "productConnections",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CustomerServiceProductEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "CustomerServiceProduct",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "entitlementsCount"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__id"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v3,
                                "handle": "connection",
                                "key": "customerServiceProducts_productConnections",
                                "kind": "LinkedHandle",
                                "name": "productConnections"
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16",
                "metadata": {},
                "name": "srcCustomerServiceProductsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $06c174000e8c134e$var$node.hash = "3c49696a6cdc337af280ec80f957ea89";
    var $06c174000e8c134e$export$2e2bcd8739ae039 = $06c174000e8c134e$var$node;
});
parcelRegister("9foRn", function(module, exports) {
    $parcel$export(module.exports, "productsRoute", ()=>$028fa89e01c0df8c$export$7d9d0206a326c6b5);
    var $65Ltd;
    const $028fa89e01c0df8c$export$7d9d0206a326c6b5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS),
        path: '/jira/servicedesk/projects/:projectKey/products',
        exact: true
    };
});
parcelRegister("aBVSx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("itg0z")
    ]).then(()=>parcelRequire('fSKfx'));
});
parcelRegister("9P7lL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bCJgs").then(()=>parcelRequire('b0ztm'));
});
parcelRegister("613vm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("HYkbB").then(()=>parcelRequire('gXCe1'));
});
parcelRegister("ldGiq", function(module, exports) {
    $parcel$export(module.exports, "adminOauthCredentialsResource", ()=>$b7e65fd0b40325af$export$870d7919c1ca4482);
    var $2M1hQ;
    const $b7e65fd0b40325af$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS = 'ADMIN_OAUTH_CREDENTIALS';
    const $b7e65fd0b40325af$export$870d7919c1ca4482 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $b7e65fd0b40325af$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS,
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("6bf0E"))
    });
});
parcelRegister("6bf0E", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gaQPp").then(()=>parcelRequire('8EYbC'));
});
parcelRegister("bPOLu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1cBTL")
    ]).then(()=>parcelRequire('imW3j'));
});
parcelRegister("2AeNp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("epspQ")
    ]).then(()=>parcelRequire('iCmWy'));
});
parcelRegister("3YmAs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lRXx5")
    ]).then(()=>parcelRequire('dN3qt'));
});
parcelRegister("c4yut", function(module, exports) {
    $parcel$export(module.exports, "jswOnboardingResource", ()=>$1ebe6dd05980f4f8$export$be21a2d8a350a80);
    $parcel$export(module.exports, "useJswOnboardingResource", ()=>$1ebe6dd05980f4f8$export$83f546a45ad58d0a);
    var $2M1hQ;
    var $2YP9W;
    const $1ebe6dd05980f4f8$export$be21a2d8a350a80 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $156934826e437e4d$export$692203fca66f4d77),
        getKey: ()=>'jsw_onboarding',
        getDataLoader: ()=>(parcelRequire("528PX"))
    });
    const $1ebe6dd05980f4f8$export$83f546a45ad58d0a = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($1ebe6dd05980f4f8$export$be21a2d8a350a80);
});
const $156934826e437e4d$export$692203fca66f4d77 = 'RESOURCE_TYPE_SOFTWARE_ONBOARDING';
parcelRegister("528PX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("knzjr").then(()=>parcelRequire('4W57j'));
});
parcelRegister("k31qI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("4t5t3")
    ]).then(()=>parcelRequire('lYlbz'));
});
parcelRegister("Y1IrA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eCiAS").then(()=>parcelRequire('jL0w0'));
});
parcelRegister("esQGb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9xZgu").then(()=>parcelRequire('dnrkU'));
});
parcelRegister("dmx0y", function(module, exports) {
    $parcel$export(module.exports, "systemConfigurationGeneralResource", ()=>$3e822b05b84662f2$export$b622f7400bfafd0d);
    var $2M1hQ;
    const $3e822b05b84662f2$export$b622f7400bfafd0d = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $3d90c62269ed88a0$export$e780b172f774b673),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("u6D6H"))
    });
});
const $3d90c62269ed88a0$export$e780b172f774b673 = 'RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL';
parcelRegister("u6D6H", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6L998").then(()=>parcelRequire('khTCh'));
});
parcelRegister("6Zdot", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3HpMo").then(()=>parcelRequire('ktpmL'));
});
parcelRegister("hlGoR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jH0q0")
    ]).then(()=>parcelRequire('lBo8Z'));
});
parcelRegister("kiD5R", function(module, exports) {
    $parcel$export(module.exports, "globalPermissionsResource", ()=>$896d1d986bb0ea74$export$9a5d1bc1ff678482);
    var $ao2h1;
    var $5Uo2r;
    const $896d1d986bb0ea74$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS = 'GLOBAL_PERMISSIONS';
    const $896d1d986bb0ea74$export$9a5d1bc1ff678482 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $896d1d986bb0ea74$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS,
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("5Uo2r")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("5Uo2r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed1cca93794a5156$export$2e2bcd8739ae039);
    const $ed1cca93794a5156$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "name"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "main_globalPermissionsAndGrantsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": "globalPermissionsAndGrants",
                                        "args": v1,
                                        "kind": "LinkedField",
                                        "name": "getGlobalPermissionsAndGrants",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "globalPermissionsTable_globalPermissions"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "grantPermissionDialog_globalPermissions"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.globalPermissionsAndGrants"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "main_globalPermissionsAndGrantsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "globalPermissionsAndGrants",
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "getGlobalPermissionsAndGrants",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "JiraGlobalPermissionGrants",
                                                "kind": "LinkedField",
                                                "name": "globalPermissionGrants",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraGlobalPermission",
                                                        "kind": "LinkedField",
                                                        "name": "permission",
                                                        "plural": false,
                                                        "selections": [
                                                            v2,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "description"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "key"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isManagedByJira"
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__id"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraGroup",
                                                        "kind": "LinkedField",
                                                        "name": "groups",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "groupId"
                                                            },
                                                            v2,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraGlobalPermissionGrantsList"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6",
                "metadata": {},
                "name": "main_globalPermissionsAndGrantsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $ed1cca93794a5156$var$node.hash = "9f1b7eb98b606c41655e4fa1f200a351";
    var $ed1cca93794a5156$export$2e2bcd8739ae039 = $ed1cca93794a5156$var$node;
});
parcelRegister("fYSiW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("asO3X")
    ]).then(()=>parcelRequire('csGky'));
});
parcelRegister("aTXuq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6rF46")
    ]).then(()=>parcelRequire('7PW51'));
});
parcelRegister("hjmEZ", function(module, exports) {
    $parcel$export(module.exports, "issueTypesResource", ()=>$0c72c798ed369d5b$export$614e9d897c1ef917);
    var $ebyGx = parcelRequire("ebyGx");
    var $2M1hQ;
    var $kXy4X;
    const $0c72c798ed369d5b$export$614e9d897c1ef917 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'GLOBAL_ADMIN_ISSUE_TYPES_DIRECTORY',
        getKey: ()=>'issue types',
        getData: async ({ query: query })=>(0, (0, parcelRequire("kXy4X")).getIssueTypes)((0, ($parcel$interopDefault($ebyGx))).stringify(query))
    });
});
parcelRegister("kXy4X", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypes", ()=>$8b29c26e18cf4514$export$4cf4b24b88599615);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $7f4tk;
    var $6tPCs;
    const $8b29c26e18cf4514$export$4cf4b24b88599615 = async (qs)=>{
        const filter = (0, (0, parcelRequire("6tPCs")).fromUrlTransformer)((0, ($parcel$interopDefault($ebyGx))).parse(qs));
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify((0, (0, parcelRequire("6tPCs")).toApiUrlTransformer)(filter));
        try {
            return await (0, (0, parcelRequire("7f4tk")).default)(`/rest/internal/3/issuetype/search?${query}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getIssueTypesRequest',
                    packageName: (0, $f4edca700b2e0273$export$4adfbb237b083187),
                    teamName: 'morphinecake'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
const $f4edca700b2e0273$export$4adfbb237b083187 = 'jiraAdminPagesIssueTypesResources';
parcelRegister("6tPCs", function(module, exports) {
    $parcel$export(module.exports, "toUrlTransformer", ()=>$ddf87573da5ca99a$export$5b9f8ed2c34be88a);
    $parcel$export(module.exports, "fromUrlTransformer", ()=>$ddf87573da5ca99a$export$bec67ef860c0d0e1);
    $parcel$export(module.exports, "toSearchFilterQsTransformer", ()=>$ddf87573da5ca99a$export$bcd1ab210547e2f5);
    $parcel$export(module.exports, "toSortFieldFilterQsTransformer", ()=>$ddf87573da5ca99a$export$c114848fa733e5c4);
    $parcel$export(module.exports, "toSortDirectionFilterQsTransformer", ()=>$ddf87573da5ca99a$export$c5d2609f8b4048d3);
    $parcel$export(module.exports, "toApiUrlTransformer", ()=>$ddf87573da5ca99a$export$fb15afa686993f11);
    var $dfl35 = parcelRequire("dfl35");
    var $ebyGx = parcelRequire("ebyGx");
    var $aud83;
    var $eou7E;
    var $iPfOK;
    const $ddf87573da5ca99a$var$sortDirectionMap = {
        [(0, $2a9e000a443b1a95$export$1dee026a19752d6b).toLowerCase()]: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
        [(0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65).toLowerCase()]: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
    };
    const $ddf87573da5ca99a$var$sortFieldMap = {
        [(0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2).toLowerCase()]: (0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2),
        [(0, $b140ee73c9ccd026$export$7673664bdc3ae979).toLowerCase()]: (0, $b140ee73c9ccd026$export$7673664bdc3ae979)
    };
    const $ddf87573da5ca99a$export$5b9f8ed2c34be88a = (filter)=>filter ? {
            page: filter.page !== undefined && filter.page >= 1 ? String(filter.page) : undefined,
            sortDirection: (0, (0, parcelRequire("eou7E")).fieldToParam)(filter.sortDirection),
            sortField: (0, (0, parcelRequire("eou7E")).fieldToParam)(filter.sortField),
            searchFilter: (0, (0, parcelRequire("eou7E")).trimSearchFilter)(filter.searchFilter)
        } : {};
    const $ddf87573da5ca99a$export$bec67ef860c0d0e1 = (params)=>({
            page: Math.floor(Number((0, (0, parcelRequire("aud83")).number).parse(params.page))) || undefined,
            searchFilter: (0, (0, parcelRequire("eou7E")).trimSearchFilter)(params.searchFilter),
            sortDirection: (0, (0, parcelRequire("eou7E")).fieldFromParam)($ddf87573da5ca99a$var$sortDirectionMap, params.sortDirection),
            sortField: (0, (0, parcelRequire("eou7E")).fieldFromParam)($ddf87573da5ca99a$var$sortFieldMap, params.sortField)
        });
    const $ddf87573da5ca99a$export$bcd1ab210547e2f5 = (qs)=>{
        const parsed = (0, ($parcel$interopDefault($ebyGx))).parse(qs);
        return parsed.searchFilter ? parsed.searchFilter : '';
    };
    const $ddf87573da5ca99a$export$c114848fa733e5c4 = (qs)=>{
        const parsed = (0, ($parcel$interopDefault($ebyGx))).parse(qs);
        return parsed.sortField && parsed.sortField === 'name' ? (0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2) : (0, $b140ee73c9ccd026$export$7673664bdc3ae979);
    };
    const $ddf87573da5ca99a$export$c5d2609f8b4048d3 = (qs)=>{
        const parsed = (0, ($parcel$interopDefault($ebyGx))).parse(qs);
        return parsed.sortDirection && parsed.sortDirection === 'asc' ? (0, $2a9e000a443b1a95$export$1dee026a19752d6b) : (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65);
    };
    const $ddf87573da5ca99a$var$apiSortByMap = {
        [(0, $2a9e000a443b1a95$export$1dee026a19752d6b)]: '',
        [(0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)]: '-'
    };
    const $ddf87573da5ca99a$export$fb15afa686993f11 = (filter)=>{
        const fullFilter = (0, ($parcel$interopDefault($dfl35)))({}, filter, (0, (0, parcelRequire("iPfOK")).DEFAULT_FILTER));
        const sortFieldMapping = fullFilter.sortField === 'hierarchy-level' ? 'type' : fullFilter.sortField;
        return {
            maxResults: (0, (0, parcelRequire("iPfOK")).MAX_RESULTS),
            startAt: (fullFilter.page - 1) * (0, (0, parcelRequire("iPfOK")).MAX_RESULTS),
            query: (0, (0, parcelRequire("eou7E")).trimSearchFilter)(fullFilter.searchFilter),
            orderBy: `${$ddf87573da5ca99a$var$apiSortByMap[fullFilter.sortDirection]}${sortFieldMapping}`
        };
    };
});
parcelRegister("dfl35", function(module, exports) {
    var $g7i7g = parcelRequire("g7i7g");
    var $dGT4U = parcelRequire("dGT4U");
    var $4rDUz = parcelRequire("4rDUz");
    var $lbyKY = parcelRequire("lbyKY");
    var $9a4d00e997b9e158$var$objectProto = Object.prototype;
    var $9a4d00e997b9e158$var$hasOwnProperty = $9a4d00e997b9e158$var$objectProto.hasOwnProperty;
    var $9a4d00e997b9e158$var$defaults = $g7i7g(function(object, sources) {
        object = Object(object);
        var index = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined;
        if (guard && $4rDUz(sources[0], sources[1], guard)) length = 1;
        while(++index < length){
            var source = sources[index];
            var props = $lbyKY(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while(++propsIndex < propsLength){
                var key = props[propsIndex];
                var value = object[key];
                if (value === undefined || $dGT4U(value, $9a4d00e997b9e158$var$objectProto[key]) && !$9a4d00e997b9e158$var$hasOwnProperty.call(object, key)) object[key] = source[key];
            }
        }
        return object;
    });
    module.exports = $9a4d00e997b9e158$var$defaults;
});
const $b140ee73c9ccd026$export$3c5e605ca7ade9f2 = 'name';
const $b140ee73c9ccd026$export$d44826c816b5619b = 'description';
const $b140ee73c9ccd026$export$b87f371cbc396fcf = 'type';
const $b140ee73c9ccd026$export$7673664bdc3ae979 = 'hierarchy-level';
const $b140ee73c9ccd026$export$68e97ee499f7c743 = 'related-schemes';
const $b140ee73c9ccd026$export$92a1a3b7554e9387 = 'actions';
const $b140ee73c9ccd026$export$23ba45d5f8d54fed = 'level-number';
const $b140ee73c9ccd026$export$1dc71bc9f1a3749a = 'arrow';
const $b140ee73c9ccd026$export$8be5a31a21d0c723 = 'level-name';
const $b140ee73c9ccd026$export$6ad51af4785d6548 = 'jira-issue-types';
const $b140ee73c9ccd026$export$20068afc6f8c1737 = 'label-space';
parcelRegister("aud83", function(module, exports) {
    $parcel$export(module.exports, "string", ()=>$b7c0843f761cef5f$export$22b082955e083ec3);
    $parcel$export(module.exports, "bool", ()=>$b7c0843f761cef5f$export$87b259aa03e3d267);
    $parcel$export(module.exports, "array", ()=>$b7c0843f761cef5f$export$2f23118c22fb2630);
    $parcel$export(module.exports, "multiple", ()=>$b7c0843f761cef5f$export$939ddaa3205df08e);
    $parcel$export(module.exports, "number", ()=>$b7c0843f761cef5f$export$98e628dec113755e);
    var $etyzk = parcelRequire("etyzk");
    const $b7c0843f761cef5f$export$22b082955e083ec3 = {
        stringify: (0, ($parcel$interopDefault($etyzk))),
        parse: (0, ($parcel$interopDefault($etyzk)))
    };
    const $b7c0843f761cef5f$export$87b259aa03e3d267 = {
        stringify: (value)=>String(value),
        parse: (value)=>{
            if (value === 'true') return true;
            if (value === 'false') return false;
            return undefined;
        }
    };
    const $b7c0843f761cef5f$export$2f23118c22fb2630 = {
        stringify: (value)=>value && Array.isArray(value) ? value.join(',') : undefined,
        parse: (value)=>typeof value === 'string' ? value?.split(',') : undefined
    };
    const $b7c0843f761cef5f$export$939ddaa3205df08e = {
        stringify: (value)=>{
            if (!value || !Array.isArray(value)) return undefined;
            return value.length === 1 ? value[0] : value;
        },
        parse: (value)=>value && Array.isArray(value) ? value : [
                String(value)
            ]
    };
    const $b7c0843f761cef5f$export$98e628dec113755e = {
        stringify: (value)=>`${value}`,
        parse: (value)=>Number(value)
    };
});
parcelRegister("eou7E", function(module, exports) {
    $parcel$export(module.exports, "fieldToParam", ()=>$56517d5895d07b39$export$7341f299e7b93e87);
    $parcel$export(module.exports, "fieldFromParam", ()=>$56517d5895d07b39$export$c876451e094c0060);
    $parcel$export(module.exports, "trimSearchFilter", ()=>$56517d5895d07b39$export$ed1722f41c23aaaf);
    const $56517d5895d07b39$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
    const $56517d5895d07b39$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
    const $56517d5895d07b39$export$ed1722f41c23aaaf = (searchFilter)=>{
        if (searchFilter === undefined) return undefined;
        return searchFilter.trim() || undefined;
    };
});
parcelRegister("iPfOK", function(module, exports) {
    $parcel$export(module.exports, "MAX_RESULTS", ()=>$68af332912f0171f$export$f6b2881bc1090cea);
    $parcel$export(module.exports, "DEFAULT_FILTER", ()=>$68af332912f0171f$export$6deee0e4f2fb784e);
    const $68af332912f0171f$export$f6b2881bc1090cea = 15;
    const $68af332912f0171f$export$6deee0e4f2fb784e = {
        page: 1,
        sortDirection: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65),
        sortField: (0, $b140ee73c9ccd026$export$7673664bdc3ae979)
    };
});
parcelRegister("doDFU", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssueTypesRoute", ()=>$eae4c8452b1a9d87$export$7358263a3bbb38b1);
    var $65Ltd;
    const $eae4c8452b1a9d87$export$7358263a3bbb38b1 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES),
        path: '/jira/settings/issues/issue-types'
    };
});
parcelRegister("4EN0d", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bg3Kg").then(()=>parcelRequire('g8Lpc'));
});
parcelRegister("6oOqs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b64e685bc951c633$export$2e2bcd8739ae039);
    var $ebyGx = parcelRequire("ebyGx");
    var $2M1hQ;
    var $8yNp1;
    const $b64e685bc951c633$var$issueTypeSchemeResource = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $e899d40884b470a8$export$1d678052bb5ae54d),
        getKey: ({ query: query })=>`${0, $e899d40884b470a8$export$41cf50ee50d5da20}-${(0, ($parcel$interopDefault($ebyGx))).stringify(query)}`,
        maxAge: 0,
        getData: async ({ query: query })=>(0, (0, parcelRequire("8yNp1")).getIssueTypeSchemes)((0, ($parcel$interopDefault($ebyGx))).stringify(query))
    });
    var $b64e685bc951c633$export$2e2bcd8739ae039 = $b64e685bc951c633$var$issueTypeSchemeResource;
});
parcelRegister("8yNp1", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypeSchemes", ()=>$b3d43746aaf616dc$export$2844cac611eecaa7);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $eusud;
    var $7vF3l;
    var $bLpq9;
    const $b3d43746aaf616dc$export$2844cac611eecaa7 = async (qs)=>{
        const filter = (0, (0, parcelRequire("bLpq9")).fromUrlTransformer)((0, ($parcel$interopDefault($ebyGx))).parse(qs));
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify((0, (0, parcelRequire("bLpq9")).toApiUrlTransformer)(filter));
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/issuetypescheme?${query}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getIssueTypesRequest',
                    packageName: (0, (0, parcelRequire("7vF3l")).PACKAGE_NAME),
                    teamName: 'morphinecake'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("7vF3l", function(module, exports) {
    $parcel$export(module.exports, "SOURCE_NAME", ()=>$72a1bf464873d379$export$a3821bc63538b210);
    $parcel$export(module.exports, "ISSUE_TYPE_SCHEMES_TABLE", ()=>$72a1bf464873d379$export$91570d508c93485d);
    $parcel$export(module.exports, "ORDER", ()=>$72a1bf464873d379$export$11e75bce9f7ea886);
    $parcel$export(module.exports, "MAX_RESULTS", ()=>$72a1bf464873d379$export$f6b2881bc1090cea);
    $parcel$export(module.exports, "defaultIssueTypeSchemesFilter", ()=>$72a1bf464873d379$export$625de46796f967ae);
    $parcel$export(module.exports, "EMPTY_PROJECTS_PAGE", ()=>$72a1bf464873d379$export$81a0343467d0e9a9);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$72a1bf464873d379$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", ()=>$72a1bf464873d379$export$9ac56b2484c2d4e9);
    const $72a1bf464873d379$export$a3821bc63538b210 = 'issueTypeSchemeDirectory';
    const $72a1bf464873d379$export$91570d508c93485d = 'issueTypeSchemesTable';
    const $72a1bf464873d379$export$11e75bce9f7ea886 = Object.freeze({
        ASC: 'asc',
        DESC: 'desc'
    });
    const $72a1bf464873d379$export$f6b2881bc1090cea = 10;
    const $72a1bf464873d379$export$625de46796f967ae = {
        pageNumber: 1,
        pageSize: $72a1bf464873d379$export$f6b2881bc1090cea,
        expand: [
            'projects',
            'issueTypes'
        ],
        orderBy: 'name',
        sortDirection: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
    };
    const $72a1bf464873d379$export$81a0343467d0e9a9 = {
        startAt: 0,
        maxResults: 10,
        values: [],
        total: 0,
        isLast: true
    };
    const $72a1bf464873d379$export$b8b9d90f9e5bd72b = 'jiraAdminPagesIssueTypeSchemesDirectory';
    const $72a1bf464873d379$export$9ac56b2484c2d4e9 = Object.freeze({
        ACTION: 'changed',
        ACTION_SUBJECT: 'filterSearch'
    });
});
parcelRegister("bLpq9", function(module, exports) {
    $parcel$export(module.exports, "toUrlTransformer", ()=>$90d499beb7e9cb88$export$5b9f8ed2c34be88a);
    $parcel$export(module.exports, "fromUrlTransformer", ()=>$90d499beb7e9cb88$export$bec67ef860c0d0e1);
    $parcel$export(module.exports, "toApiUrlTransformer", ()=>$90d499beb7e9cb88$export$fb15afa686993f11);
    var $dfl35 = parcelRequire("dfl35");
    var $aud83;
    var $7vF3l;
    var $lL6pH;
    const $90d499beb7e9cb88$export$5b9f8ed2c34be88a = (filter)=>{
        const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = filter || {};
        return {
            pageNumber: pageNumber,
            searchFilter: searchFilter,
            orderBy: orderBy
        };
    };
    const $90d499beb7e9cb88$export$bec67ef860c0d0e1 = (params)=>{
        const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = params;
        const parsedNumber = Number.isNaN((0, (0, parcelRequire("aud83")).number).parse(pageNumber)) ? (0, (0, parcelRequire("7vF3l")).defaultIssueTypeSchemesFilter).pageNumber : (0, (0, parcelRequire("aud83")).number).parse(pageNumber);
        const parsedOrderBy = orderBy === 'name' || orderBy === '-name' ? orderBy : undefined;
        return {
            ...(0, (0, parcelRequire("7vF3l")).defaultIssueTypeSchemesFilter),
            pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
            searchFilter: searchFilter,
            orderBy: parsedOrderBy
        };
    };
    const $90d499beb7e9cb88$export$fb15afa686993f11 = (filter)=>{
        const fullFilter = (0, ($parcel$interopDefault($dfl35)))({}, filter, (0, (0, parcelRequire("7vF3l")).defaultIssueTypeSchemesFilter));
        let requestParams = {
            maxResults: (0, (0, parcelRequire("7vF3l")).MAX_RESULTS),
            startAt: (fullFilter.pageNumber - 1) * (0, (0, parcelRequire("7vF3l")).MAX_RESULTS),
            orderBy: fullFilter.orderBy,
            queryString: (0, (0, parcelRequire("lL6pH")).trimSearchFilter)(fullFilter.searchFilter)
        };
        if (fullFilter.expand != null) requestParams = {
            ...requestParams,
            expand: fullFilter.expand.join(',')
        };
        return requestParams;
    };
});
parcelRegister("lL6pH", function(module, exports) {
    $parcel$export(module.exports, "trimSearchFilter", ()=>$8bfdbd5ef20cefa5$export$ed1722f41c23aaaf);
    const $8bfdbd5ef20cefa5$export$ed1722f41c23aaaf = (searchFilter)=>{
        if (searchFilter === undefined) return undefined;
        return searchFilter.trim() || undefined;
    };
});
const $e899d40884b470a8$export$1d678052bb5ae54d = 'ISSUE_TYPE_SCHEME_TABLE';
const $e899d40884b470a8$export$41cf50ee50d5da20 = 'ISSUE_TYPE_SCHEME_TABLE_KEY';
parcelRegister("j6iNi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cfCwZ").then(()=>parcelRequire('1dsYb'));
});
parcelRegister("jKASa", function(module, exports) {
    $parcel$export(module.exports, "jsmCustomerAuthenticationSettingsResource", ()=>$3f20045f00d71d00$export$73134c05a3c27bd);
    var $2M1hQ;
    var $8Pbm3;
    const $3f20045f00d71d00$export$73134c05a3c27bd = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("8Pbm3")).RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS),
        getKey: ()=>'settings',
        getDataLoader: ()=>(parcelRequire("hmSnU")),
        maxAge: (0, (0, parcelRequire("8Pbm3")).ONE_DAY_IN_MILLIS)
    });
});
parcelRegister("8Pbm3", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS", ()=>$bbe3b013803e2d85$export$6a2799d78d98b915);
    $parcel$export(module.exports, "ONE_DAY_IN_MILLIS", ()=>$bbe3b013803e2d85$export$5a00268156ea5027);
    const $bbe3b013803e2d85$export$6a2799d78d98b915 = 'JSM_CUSTOMER_AUTHENTICATION_SETTINGS';
    const $bbe3b013803e2d85$export$5a00268156ea5027 = 86400000;
});
parcelRegister("hmSnU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hLF9k").then(()=>parcelRequire('7xEnC'));
});
parcelRegister("fTwAe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("atQhk")
    ]).then(()=>parcelRequire('8YmLU'));
});
parcelRegister("6IgbX", function(module, exports) {
    $parcel$export(module.exports, "jsmGlobalCustomerAccessAffectedProjectsResource", ()=>$da9f8bab48dab68f$export$f27acbd4701f5dfe);
    var $2M1hQ;
    const $da9f8bab48dab68f$var$ONE_DAY_IN_MILLIS = 86400000;
    const $da9f8bab48dab68f$export$f27acbd4701f5dfe = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $700dba149c7972be$export$341f26dde034af5b),
        getKey: ()=>'affected-projects',
        getDataLoader: ()=>(parcelRequire("kaxeY")),
        maxAge: $da9f8bab48dab68f$var$ONE_DAY_IN_MILLIS
    });
});
const $700dba149c7972be$export$341f26dde034af5b = 'JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS';
const $700dba149c7972be$export$eb7818fb178a80b4 = 'JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';
parcelRegister("kaxeY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3iYiJ").then(()=>parcelRequire('8QdIc'));
});
parcelRegister("cuwqc", function(module, exports) {
    $parcel$export(module.exports, "jsmGlobalCustomerAccessSettingsResource", ()=>$ab848c99e9d2daf7$export$b1a50ad717b4ca61);
    var $2M1hQ;
    const $ab848c99e9d2daf7$var$ONE_DAY_IN_MILLIS = 86400000;
    const $ab848c99e9d2daf7$export$b1a50ad717b4ca61 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $700dba149c7972be$export$eb7818fb178a80b4),
        getKey: ()=>'settings',
        getDataLoader: ()=>(parcelRequire("ikGcK")),
        maxAge: $ab848c99e9d2daf7$var$ONE_DAY_IN_MILLIS
    });
});
parcelRegister("ikGcK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jTKK6").then(()=>parcelRequire('4pG8m'));
});
parcelRegister("cIGKY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("iTi1A")
    ]).then(()=>parcelRequire('faXQs'));
});
parcelRegister("gmNWX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9iFSf").then(()=>parcelRequire('7sYTD'));
});
parcelRegister("d8FBC", function(module, exports) {
    $parcel$export(module.exports, "SidebarGlobalSettingsSystem", ()=>$6ea6596802956a9d$export$52af3150b9f64726);
    var $5uXOq = parcelRequire("5uXOq");
    var $fobme;
    var $acDan;
    var $hcbSm;
    const $6ea6596802956a9d$export$52af3150b9f64726 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarRenderStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hcbSm")).Menu), null), !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarReady), {
            id: (0, (0, parcelRequire("fobme")).SIDEBAR_ID).GLOBAL_SETTINGS_SYSTEM
        }));
});
parcelRegister("fobme", function(module, exports) {
    $parcel$export(module.exports, "SIDEBAR_ID", ()=>$4b9be639c0c7f77b$export$adf978edbdfaf080);
    const $4b9be639c0c7f77b$export$adf978edbdfaf080 = {
        CONNECT: 'CONNECT',
        CORE: 'CORE',
        FILTERS: 'FILTERS',
        FILTERS_GLOBAL: 'FILTERS_GLOBAL',
        FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
        GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
        GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
        GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
        GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
        GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
        JSM: 'JSM',
        JSW_CLASSIC: 'JSW_CLASSIC',
        JSW_NEXT_GEN: 'JSW_NEXT_GEN',
        PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
        EOC_OPERATIONS: 'EOC_OPERATIONS',
        POLARIS: 'POLARIS',
        USER: 'USER',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
    };
});
parcelRegister("hcbSm", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$e261d6c9e28d2ed4$export$d9b273488cd8ce6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $g2EiV;
    var $9btdk;
    var $gZEU1;
    var $bWqXX;
    var $65Ltd;
    var $koVbs;
    var $k0ZZ2;
    var $3OGaE;
    var $juTur;
    var $17bH5;
    var $4OCke;
    var $3tHFY;
    var $6jY6G;
    var $eaZ4X;
    var $jMBA3;
    var $aVTmi;
    var $cip1u;
    var $8wyB3;
    var $230Wm;
    var $je2KE;
    var $iAlf2;
    var $fwlYA;
    var $9O5DC;
    var $1y2CG;
    var $71ORT;
    var $3jrxv;
    const $e261d6c9e28d2ed4$var$calculateStack = (route)=>{
        const routeName = route && route.name || '';
        if ([
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE)
        ].includes(routeName)) return [
            (0, (0, parcelRequire("eaZ4X")).SECTION_ID).MIGRATE_TO_CLOUD_SITE
        ];
        if ([
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE)
        ].includes(routeName)) return [
            (0, (0, parcelRequire("eaZ4X")).SECTION_ID).PERFORMANCE_AND_SCALE
        ];
        return [];
    };
    const $e261d6c9e28d2ed4$export$d9b273488cd8ce6f = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: connectItems } = (0, (0, parcelRequire("jMBA3")).useGlobalSettingsSystemConnectItems)();
        const [stack, setStack] = (0, $5uXOq.useState)($e261d6c9e28d2ed4$var$calculateStack(route));
        (0, $5uXOq.useEffect)(()=>{
            setStack($e261d6c9e28d2ed4$var$calculateStack(route));
        }, [
            route
        ]);
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        const generalConfigurationPath = navigationPath.generalConfiguration;
        if (features == null || connectItems == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        const navigationContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, features.hasGeneralConfiguration && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'general-configuration'
            },
            href: generalConfigurationPath,
            selectedOn: (0, (0, parcelRequire("3jrxv")).isGeneralConfigurationSelected)
        }, formatMessage((0, (0, parcelRequire("iAlf2")).default).generalConfiguration)), features.hasDarkFeatures && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'dark-features'
            },
            href: navigationPath.darkFeatures,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("iAlf2")).default).darkFeatures)), features.hasTroubleshootingAndSupportSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1y2CG")).TroubleshootingAndSupportSection), null), features.hasSecuritySection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fwlYA")).SecuritySection), null), features.hasCollectors && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'collectors'
            },
            href: navigationPath.issueCollectors,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("iAlf2")).default).issueCollectors)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8wyB3")).AutomationSection), null), features.hasUserInterfaceSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71ORT")).UserInterfaceSection), null), features.hasImportExportSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("230Wm")).ImportExportSection), null), features.hasMailSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("je2KE")).MailSection), null), features.hasAdminHelperSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVTmi")).AdminHelperSection), null), features.hasSharedSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9O5DC")).SharedSection), null), features.hasAdvancedSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cip1u")).AdvancedSection), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3tHFY")).ConnectMenu), {
            items: connectItems,
            overrides: {
                BackMenuItem: {
                    href: '/jira/settings/system/general-configuration',
                    title: formatMessage((0, (0, parcelRequire("iAlf2")).default).systemGroup)
                }
            }
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).ContextualAnalyticsData), {
            menuId: "global-settings/system",
            stack: stack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZEU1")).default), {
            label: formatMessage((0, (0, parcelRequire("iAlf2")).default).globalSettingsSystemSidebarLabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g2EiV")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("iAlf2")).default).systemGroup))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9btdk")).default), {
            stack: stack,
            onChange: setStack
        }, navigationContent)));
    };
});
parcelRegister("g2EiV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f8d4c6f37fa43791$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $dC5iT;
    var $8CUq3;
    const $f8d4c6f37fa43791$var$navigationFooterStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'block',
        padding: 'space.100',
        paddingBlockStart: 'space.300'
    });
    const $f8d4c6f37fa43791$var$NavigationHeader = (props)=>{
        const { children: children } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f8d4c6f37fa43791$var$navigationFooterStyles,
            "data-navheader": true
        }, children);
    };
    var $f8d4c6f37fa43791$export$2e2bcd8739ae039 = $f8d4c6f37fa43791$var$NavigationHeader;
});
parcelRegister("9btdk", function(module, exports) {
    $parcel$export(module.exports, "ROOT_ID", ()=>$1598986e4d07c239$export$ec71a3379b43ae5c);
    $parcel$export(module.exports, "default", ()=>$1598986e4d07c239$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $35XSW;
    var $VSDnB;
    var $6XySk;
    var $8UO8z;
    var $9zCCP;
    var $j9VTE;
    var $cfT4M;
    function $1598986e4d07c239$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1598986e4d07c239$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
    const $1598986e4d07c239$var$nestableNavigationContentStyles = {
        name: "hxjswn",
        styles: "height:100%;position:relative;outline:none"
    };
    const $1598986e4d07c239$var$nestingRootStyles = {
        name: "1klp5xc",
        styles: "display:flex;width:100%;height:100%;position:absolute;flex-direction:column"
    };
    const $1598986e4d07c239$var$NestableNavigationContent = (props)=>{
        const containerRef = (0, $5uXOq.useRef)(null);
        const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator, isDefaultFocusControl: isDefaultFocusControl = true } = props;
        const goBackButtonRef = (0, $5uXOq.useRef)(null);
        const [committedStack, setCommittedStack] = (0, $5uXOq.useState)(stack || initialStack || []);
        const controlledStack = stack || undefined;
        const currentStackId = committedStack[committedStack.length - 1] || $1598986e4d07c239$export$ec71a3379b43ae5c;
        const [transition, setTransition] = (0, $5uXOq.useState)('nesting');
        const backTestId = testId && `${testId}--go-back-item`;
        const [activeParentId, setActiveParentId] = (0, $5uXOq.useState)('');
        const [focusGoBackButton, setFocusGoBackButton] = (0, $5uXOq.useState)(false);
        const shouldFocus = isDefaultFocusControl && (0, (0, parcelRequire("VSDnB")).fg)('platform-side-navigation-keyboard-focus');
        const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6XySk")).default), props, "Go back");
        const { childIdsRef: childIdsRef } = (0, (0, parcelRequire("9zCCP")).useChildIds)(currentStackId, committedStack, onUnknownNest);
        const onNestHandler = (0, $5uXOq.useCallback)((layerId)=>{
            onChange && onChange(committedStack.concat(layerId));
            setFocusGoBackButton(true);
            if (controlledStack) return;
            setTransition('nesting');
            requestAnimationFrame(()=>{
                setCommittedStack((prev)=>{
                    const newStack = prev.concat(layerId);
                    return newStack;
                });
            });
        }, [
            controlledStack,
            onChange,
            committedStack
        ]);
        const onUnNestHandler = (0, $5uXOq.useCallback)(()=>{
            onChange && onChange(committedStack.slice(0, committedStack.length - 1));
            setActiveParentId(currentStackId);
            setFocusGoBackButton(false);
            if (controlledStack) return;
            setTransition('unnesting');
            requestAnimationFrame(()=>{
                setCommittedStack((prev)=>{
                    const newStack = prev.slice(0, prev.length - 1);
                    return newStack;
                });
            });
        }, [
            controlledStack,
            onChange,
            committedStack,
            setActiveParentId,
            currentStackId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!controlledStack) return;
            if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) return;
            if (controlledStack.length < committedStack.length) setTransition('unnesting');
            else setTransition('nesting');
            requestAnimationFrame(()=>{
                setCommittedStack(controlledStack);
            });
        }, [
            committedStack,
            controlledStack
        ]);
        const backButton = renderGoBackItem({
            onClick: onUnNestHandler,
            testId: backTestId,
            ref: shouldFocus ? goBackButtonRef : null
        });
        const context = (0, $5uXOq.useMemo)(()=>({
                currentStackId: currentStackId,
                backButton: backButton,
                stack: committedStack,
                onNest: onNestHandler,
                onUnNest: onUnNestHandler,
                parentId: $1598986e4d07c239$export$ec71a3379b43ae5c,
                childIds: childIdsRef,
                forceShowTopScrollIndicator: showTopScrollIndicator,
                activeParentId: activeParentId,
                goBackButtonRef: goBackButtonRef,
                isDefaultFocusControl: isDefaultFocusControl,
                focusGoBackButton: focusGoBackButton
            }), [
            currentStackId,
            backButton,
            committedStack,
            onNestHandler,
            onUnNestHandler,
            childIdsRef,
            showTopScrollIndicator,
            activeParentId,
            goBackButtonRef,
            isDefaultFocusControl,
            focusGoBackButton
        ]);
        const manageFocus = (event)=>{
            const triggeredByKeyboard = event.nativeEvent.detail === 0;
            if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: $1598986e4d07c239$var$nestableNavigationContentStyles,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("35XSW")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cfT4M")).NestingMotion), {
            key: currentStackId,
            enterFrom: transition === 'nesting' ? 'right' : 'left',
            exitTo: transition === 'nesting' ? 'left' : 'right',
            testId: testId && `${testId}-anim`
        }, (motion)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $1598986e4d07c239$var$nestingRootStyles,
                ...motion
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j9VTE")).NestedContext).Provider, {
                value: context
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8UO8z")).default), {
                title: "",
                id: $1598986e4d07c239$export$ec71a3379b43ae5c
            }, children)))))));
    };
    var $1598986e4d07c239$export$2e2bcd8739ae039 = $1598986e4d07c239$var$NestableNavigationContent;
});
parcelRegister("6XySk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$acf862f964b3fe45$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $d2gYe;
    var $ayWDM;
    const $acf862f964b3fe45$var$GoBackItem = (0, $5uXOq.forwardRef)(({ cssFn: cssFn, iconBefore: iconBefore = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("d2gYe"))))), {
        color: "currentColor",
        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        label: ""
    }), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
        const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
        const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
            if (isInteracted) return;
            setIsInteracted(true);
            onClick && onClick(e);
        }, [
            onClick,
            isInteracted
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ayWDM")).default), {
            isSelected: isSelected,
            cssFn: cssFn,
            iconBefore: iconBefore,
            onClick: onClickHandler,
            ref: ref,
            ...rest
        });
    });
    var $acf862f964b3fe45$export$2e2bcd8739ae039 = $acf862f964b3fe45$var$GoBackItem;
});
parcelRegister("d2gYe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $97d8a03a9ac2bd8e$var$_react = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $97d8a03a9ac2bd8e$var$_arrowLeft = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("ctqwA")));
    var $97d8a03a9ac2bd8e$var$_arrowLeftCircle = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("g9uZe")));
    function $97d8a03a9ac2bd8e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $97d8a03a9ac2bd8e$var$ArrowLeftIcon = (props)=>$97d8a03a9ac2bd8e$var$_react.default.createElement($97d8a03a9ac2bd8e$var$_arrowLeft.default, Object.assign({
            LEGACY_fallbackIcon: $97d8a03a9ac2bd8e$var$_arrowLeftCircle.default
        }, props));
    $97d8a03a9ac2bd8e$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
    var $97d8a03a9ac2bd8e$var$_default = module.exports.default = $97d8a03a9ac2bd8e$var$ArrowLeftIcon;
});
parcelRegister("g9uZe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bc2585eb44f99538$var$_react = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $bc2585eb44f99538$var$_arrowLeft = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("ctqwA")));
    function $bc2585eb44f99538$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bc2585eb44f99538$var$ArrowLeftCircleIcon = (props)=>$bc2585eb44f99538$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
        }, props, {
            newIcon: $bc2585eb44f99538$var$_arrowLeft.default
        }));
    $bc2585eb44f99538$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
    var $bc2585eb44f99538$var$_default = module.exports.default = $bc2585eb44f99538$var$ArrowLeftCircleIcon;
});
parcelRegister("ayWDM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$860cc941614c9e62$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kJpBP;
    var $jsTfk;
    var $j9VTE;
    const $860cc941614c9e62$var$ButtonItem = (0, $5uXOq.forwardRef)(({ cssFn: cssFn, ...rest }, ref)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        if (!shouldRender) return null;
        const cssOverride = (0, (0, parcelRequire("jsTfk")).overrideStyleFunction)((0, (0, parcelRequire("jsTfk")).baseSideNavItemStyle), cssFn);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            ref: ref,
            cssFn: cssOverride,
            ...rest
        });
    });
    var $860cc941614c9e62$export$2e2bcd8739ae039 = $860cc941614c9e62$var$ButtonItem;
});
parcelRegister("8UO8z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0599b2a9b08db47e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $bh9nY;
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    var $jsTfk;
    var $ayWDM;
    var $jSfqD;
    var $kzjuk;
    var $9btdk;
    var $j9VTE;
    var $9zCCP;
    var $5n9uX;
    const $0599b2a9b08db47e$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline'
    });
    const $0599b2a9b08db47e$var$NestingItem = (props)=>{
        const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, cssFn: cssFn, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
        const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator, activeParentId: activeParentId, goBackButtonRef: goBackButtonRef, isDefaultFocusControl: isDefaultFocusControl, focusGoBackButton: focusGoBackButton } = (0, (0, parcelRequire("j9VTE")).useNestedContext)();
        const mergedStyles = (0, (0, parcelRequire("jsTfk")).overrideStyleFunction)((0, (0, parcelRequire("5n9uX")).nestingItemStyle), cssFn);
        const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
        const parentItemRef = (0, $5uXOq.useRef)(null);
        const isForwardRefCheck = (component)=>{
            if (component?.prototype?.isReactComponent) return false;
            return component?.$$typeof === Symbol.for('react.forward_ref');
        };
        const shouldFocus = isDefaultFocusControl && (0, (0, parcelRequire("VSDnB")).fg)('platform-side-navigation-keyboard-focus');
        const backButtonRef = shouldFocus ? goBackButtonRef : null;
        const activeParentRef = shouldFocus ? parentItemRef : null;
        (0, $5uXOq.useEffect)(()=>{
            if (shouldFocus) {
                if (activeParentId === id) parentItemRef?.current?.focus();
                if (focusGoBackButton) goBackButtonRef?.current?.focus();
            }
        }, [
            activeParentId,
            id,
            goBackButtonRef,
            focusGoBackButton,
            isDefaultFocusControl,
            shouldFocus
        ]);
        const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
            onClick: onUnNest,
            testId: testId && `${testId}--go-back-item`,
            ref: backButtonRef
        }) || contextualBackButton;
        const context = (0, $5uXOq.useMemo)(()=>({
                stack: stack,
                currentStackId: currentStackId,
                onNest: onNest,
                onUnNest: onUnNest,
                backButton: backButton,
                parentId: id,
                childIds: childIds,
                forceShowTopScrollIndicator: forceShowTopScrollIndicator,
                activeParentId: activeParentId,
                goBackButtonRef: goBackButtonRef,
                isDefaultFocusControl: isDefaultFocusControl,
                focusGoBackButton: focusGoBackButton
            }), [
            stack,
            currentStackId,
            onNest,
            onUnNest,
            backButton,
            id,
            childIds,
            forceShowTopScrollIndicator,
            activeParentId,
            goBackButtonRef,
            isDefaultFocusControl,
            focusGoBackButton
        ]);
        (0, (0, parcelRequire("9zCCP")).useChildIdsEffect)(childIds, id);
        const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
        const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
            if (isInteracted) return;
            if (isNormalClick(e)) {
                setIsInteracted(true);
                onNest(id);
            }
            onClick && onClick(e);
        }, [
            isInteracted,
            onClick,
            onNest,
            id
        ]);
        if (currentStackId === id) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j9VTE")).NestedContext).Provider, {
            value: context
        }, stack.length >= 1 && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlock: "space.075",
            paddingInline: "space.100"
        }, backButton), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kzjuk")).default), {
            testId: testId,
            showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1
        }, children));
        if ([
            (0, (0, parcelRequire("9btdk")).ROOT_ID),
            ...stack
        ].includes(id)) return children;
        const componentProps = {
            iconAfter: (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, iconAfter ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $0599b2a9b08db47e$var$iconContainerStyles,
                "data-custom-icon": true,
                as: "span"
            }, iconAfter) : null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                "data-right-arrow": true,
                xcss: $0599b2a9b08db47e$var$iconContainerStyles,
                as: "span"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bh9nY"))))), {
                testId: testId && `${testId}--item--right-arrow`,
                color: "currentColor",
                LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
                label: ""
            }))),
            onClick: onClickHandler,
            isSelected: isSelected,
            testId: testId && `${testId}--item`,
            ...rest,
            children: title,
            cssFn: mergedStyles
        };
        if (component) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSfqD")).default), {
            ref: isForwardRefCheck(component) ? parentItemRef : null,
            ...componentProps,
            component: component
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ayWDM")).default), {
            ref: activeParentRef,
            ...componentProps
        });
    };
    var $0599b2a9b08db47e$export$2e2bcd8739ae039 = $0599b2a9b08db47e$var$NestingItem;
});
parcelRegister("bh9nY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $835890081946c47e$var$_react = $835890081946c47e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $835890081946c47e$var$_arrowRight = $835890081946c47e$var$_interopRequireDefault((parcelRequire("h1TKi")));
    var $835890081946c47e$var$_arrowRightCircle = $835890081946c47e$var$_interopRequireDefault((parcelRequire("1zw66")));
    function $835890081946c47e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $835890081946c47e$var$ArrowRightIcon = (props)=>$835890081946c47e$var$_react.default.createElement($835890081946c47e$var$_arrowRight.default, Object.assign({
            LEGACY_fallbackIcon: $835890081946c47e$var$_arrowRightCircle.default
        }, props));
    $835890081946c47e$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
    var $835890081946c47e$var$_default = module.exports.default = $835890081946c47e$var$ArrowRightIcon;
});
parcelRegister("h1TKi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>$c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;
});
parcelRegister("1zw66", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1251f532550be707$var$_react = $1251f532550be707$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1251f532550be707$var$_arrowRight = $1251f532550be707$var$_interopRequireDefault((parcelRequire("h1TKi")));
    function $1251f532550be707$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1251f532550be707$var$ArrowRightCircleIcon = (props)=>$1251f532550be707$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
        }, props, {
            newIcon: $1251f532550be707$var$_arrowRight.default
        }));
    $1251f532550be707$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
    var $1251f532550be707$var$_default = module.exports.default = $1251f532550be707$var$ArrowRightCircleIcon;
});
parcelRegister("jSfqD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e63733262ea805c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1aogK;
    var $jsTfk;
    var $j9VTE;
    const $0e63733262ea805c$var$CustomItem = (0, $5uXOq.forwardRef)(({ cssFn: cssFn, ...rest }, ref)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        if (!shouldRender) return null;
        const cssOverride = (0, (0, parcelRequire("jsTfk")).overrideStyleFunction)((0, (0, parcelRequire("jsTfk")).baseSideNavItemStyle), cssFn);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            ref: ref,
            cssFn: cssOverride,
            ...rest
        });
    });
    var $0e63733262ea805c$export$2e2bcd8739ae039 = $0e63733262ea805c$var$CustomItem;
});
parcelRegister("kzjuk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfdf97ddffeccb81$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cw1vL;
    var $j9VTE;
    var $dwoqU;
    const $dfdf97ddffeccb81$var$NavigationContent = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        const scrollbar = (0, (0, parcelRequire("cw1vL")).default)();
        if (!shouldRender) return children;
        const typedRef = ref;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: typedRef,
            css: (0, (0, parcelRequire("dwoqU")).outerContainerCSS)({
                showTopScrollIndicator: showTopScrollIndicator,
                scrollbarWidth: scrollbar.width
            }),
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: scrollbar.ref,
            css: (0, (0, parcelRequire("dwoqU")).innerContainerCSS)({
                showTopScrollIndicator: showTopScrollIndicator
            })
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("dwoqU")).containerCSS)({
                showTopScrollIndicator: showTopScrollIndicator
            })
        }, children)));
    });
    var $dfdf97ddffeccb81$export$2e2bcd8739ae039 = $dfdf97ddffeccb81$var$NavigationContent;
});
parcelRegister("cw1vL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a03f8a420074f68d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $a03f8a420074f68d$export$2e2bcd8739ae039() {
        const [scrollbarWidth, setScrollbarWidth] = (0, $5uXOq.useState)(0);
        const elementRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!elementRef.current) return;
            const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
            if (width === scrollbarWidth) return;
            setScrollbarWidth(width);
        });
        return {
            width: scrollbarWidth,
            ref: elementRef
        };
    }
});
parcelRegister("dwoqU", function(module, exports) {
    $parcel$export(module.exports, "outerContainerCSS", ()=>$f51a063900e7895a$export$3ff462c0176a504f);
    $parcel$export(module.exports, "innerContainerCSS", ()=>$f51a063900e7895a$export$4d1aec15cfcfc2a4);
    $parcel$export(module.exports, "containerCSS", ()=>$f51a063900e7895a$export$949392aeaf7d2e3a);
    const $f51a063900e7895a$var$scrollIndicatorMaskZIndex = 2;
    const $f51a063900e7895a$var$scrollIndicatorZIndex = 1;
    const $f51a063900e7895a$var$scrollIndicatorHeight = 2;
    const $f51a063900e7895a$var$scrollIndicatorBorderRadius = '1px';
    const $f51a063900e7895a$var$containerPadding = 8;
    const $f51a063900e7895a$var$itemHeadingContentHeight = 16;
    const $f51a063900e7895a$var$skeletonHeadingHeight = $f51a063900e7895a$var$containerPadding;
    const $f51a063900e7895a$var$skeletonHeadingMarginOffset = 3;
    const $f51a063900e7895a$var$skeletonHeadingTopMargin = $f51a063900e7895a$var$containerPadding * 2.5 + ($f51a063900e7895a$var$itemHeadingContentHeight - $f51a063900e7895a$var$skeletonHeadingHeight) - $f51a063900e7895a$var$skeletonHeadingMarginOffset;
    const $f51a063900e7895a$var$skeletonHeadingBottomMargin = $f51a063900e7895a$var$containerPadding * 0.75 + $f51a063900e7895a$var$skeletonHeadingMarginOffset;
    const $f51a063900e7895a$export$3ff462c0176a504f = (opts)=>({
            display: 'flex',
            height: '100%',
            overflow: 'hidden',
            position: 'relative',
            '&::before': {
                content: "''",
                display: 'block',
                left: "var(--ds-space-100, 8px)",
                right: $f51a063900e7895a$var$containerPadding + opts.scrollbarWidth,
                height: $f51a063900e7895a$var$scrollIndicatorHeight,
                borderRadius: `var(--ds-border-radius-050, ${$f51a063900e7895a$var$scrollIndicatorBorderRadius})`,
                backgroundColor: `var(${0, $9521c0a2bf229f61$export$e8e7f51e033d4cb2}, ${`var(--ds-border, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`})`,
                position: 'absolute',
                zIndex: $f51a063900e7895a$var$scrollIndicatorZIndex
            },
            '&::after': {
                content: "''",
                position: 'absolute',
                display: 'block',
                borderRadius: `var(--ds-border-radius-050, ${$f51a063900e7895a$var$scrollIndicatorBorderRadius})`,
                flexShrink: 0,
                height: $f51a063900e7895a$var$scrollIndicatorHeight,
                left: "var(--ds-space-100, 8px)",
                right: $f51a063900e7895a$var$containerPadding + opts.scrollbarWidth,
                bottom: 0,
                zIndex: $f51a063900e7895a$var$scrollIndicatorZIndex,
                backgroundColor: `var(${0, $9521c0a2bf229f61$export$e8e7f51e033d4cb2}, ${`var(--ds-border, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`})`
            }
        });
    const $f51a063900e7895a$export$4d1aec15cfcfc2a4 = (opts)=>({
            display: 'flex',
            overflow: 'auto',
            width: '100%',
            position: 'relative',
            boxSizing: 'border-box',
            flexDirection: 'column',
            ...!opts.showTopScrollIndicator && {
                '&::before': {
                    borderRadius: `var(--ds-border-radius-050, ${$f51a063900e7895a$var$scrollIndicatorBorderRadius})`,
                    content: "''",
                    left: 0,
                    right: 0,
                    height: $f51a063900e7895a$var$scrollIndicatorHeight,
                    backgroundColor: `var(${0, $9521c0a2bf229f61$export$49e4dd5760b312e0}, ${`var(--ds-surface, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`})`,
                    position: 'absolute',
                    display: 'block',
                    zIndex: $f51a063900e7895a$var$scrollIndicatorMaskZIndex
                }
            },
            '&::after': {
                borderRadius: `var(--ds-border-radius-050, ${$f51a063900e7895a$var$scrollIndicatorBorderRadius})`,
                content: "''",
                display: 'block',
                flexShrink: 0,
                height: $f51a063900e7895a$var$scrollIndicatorHeight,
                marginTop: 'auto',
                position: 'relative',
                zIndex: $f51a063900e7895a$var$scrollIndicatorMaskZIndex,
                backgroundColor: `var(${0, $9521c0a2bf229f61$export$49e4dd5760b312e0}, ${`var(--ds-surface, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`})`
            }
        });
    const $f51a063900e7895a$export$949392aeaf7d2e3a = (opts)=>({
            marginTop: opts.showTopScrollIndicator ? $f51a063900e7895a$var$scrollIndicatorHeight : 0,
            marginLeft: "var(--ds-space-100, 8px)",
            marginRight: "var(--ds-space-100, 8px)",
            position: 'relative',
            '& [data-ds--menu--heading-item]': {
                marginBottom: "var(--ds-space-075, 6px)",
                marginTop: "var(--ds-space-200, 16px)"
            },
            '& [data-ds--menu--skeleton-heading-item]': {
                marginTop: $f51a063900e7895a$var$skeletonHeadingTopMargin,
                marginBottom: $f51a063900e7895a$var$skeletonHeadingBottomMargin
            }
        });
});
const $9521c0a2bf229f61$export$e8e7f51e033d4cb2 = '--ds-menu-seperator-color';
const $9521c0a2bf229f61$export$49e4dd5760b312e0 = '--ds-menu-scroll-indicator-color';
parcelRegister("9zCCP", function(module, exports) {
    $parcel$export(module.exports, "useChildIds", ()=>$edc749a9b64f215e$export$61b3ef4f009a9474);
    $parcel$export(module.exports, "useChildIdsEffect", ()=>$edc749a9b64f215e$export$ea18c2b5f0e24612);
    var $5uXOq = parcelRequire("5uXOq");
    var $9btdk;
    const $edc749a9b64f215e$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
        const childIdsRef = (0, $5uXOq.useRef)(new Set());
        (0, $5uXOq.useEffect)(()=>{
            if (currentStackId === (0, (0, parcelRequire("9btdk")).ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
            onUnknownNest(committedStack || [
                currentStackId
            ]);
        }, [
            currentStackId,
            committedStack,
            onUnknownNest
        ]);
        return {
            childIdsRef: childIdsRef
        };
    };
    const $edc749a9b64f215e$export$ea18c2b5f0e24612 = (childIds, id)=>{
        (0, $5uXOq.useEffect)(()=>{
            if (!childIds || !childIds.current) return;
            if (!childIds.current.has(id)) childIds.current.add(id);
            return ()=>{
                childIds.current.delete(id);
            };
        }, [
            id
        ]);
    };
});
parcelRegister("5n9uX", function(module, exports) {
    $parcel$export(module.exports, "nestingItemStyle", ()=>$1433420fe651ac2a$export$38e770f85519b259);
    const $1433420fe651ac2a$export$4c36b5b1b67ee1e8 = {
        ['&:hover [data-custom-icon]']: {
            display: 'none'
        },
        ['&:active [data-custom-icon]']: {
            display: 'none'
        },
        ['&:focus [data-custom-icon]']: {
            display: 'none'
        },
        ['& [data-custom-icon]']: {
            display: 'inherit'
        },
        ['&:hover [data-right-arrow]']: {
            display: 'inherit'
        },
        ['&:active [data-right-arrow]']: {
            display: 'inherit'
        },
        ['&:focus [data-right-arrow]']: {
            display: 'inherit'
        },
        ['& [data-right-arrow]']: {
            display: 'none'
        }
    };
    const $1433420fe651ac2a$var$disabledCSS = {
        ['[data-item-elem-after]']: {
            opacity: 0
        },
        ['& [data-right-arrow]']: {
            display: 'none'
        }
    };
    const $1433420fe651ac2a$export$38e770f85519b259 = (state)=>{
        return {
            ...state.isDisabled ? $1433420fe651ac2a$var$disabledCSS : $1433420fe651ac2a$export$4c36b5b1b67ee1e8
        };
    };
});
parcelRegister("cfT4M", function(module, exports) {
    $parcel$export(module.exports, "NestingMotion", ()=>$0051a7791f96d83a$export$9e743a8c2a6b450e);
    var $f8Sb3;
    var $8Sbj3;
    const $0051a7791f96d83a$export$9e743a8c2a6b450e = (props)=>{
        const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8Sbj3")).default), {
            exitTo: exitTo,
            enterFrom: enterFrom,
            animationTimingFunction: (_)=>(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)
        }, (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            }));
    };
});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
parcelRegister("gZEU1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb2dd47d2fa741f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $j7LBE;
    var $VSDnB;
    const $eb2dd47d2fa741f7$var$sidebarMinWidth = '240px';
    const $eb2dd47d2fa741f7$var$sideNavStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: '100%',
        minWidth: $eb2dd47d2fa741f7$var$sidebarMinWidth,
        height: '100%',
        position: 'relative',
        flexDirection: 'column',
        backgroundColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        overflow: 'hidden'
    });
    const $eb2dd47d2fa741f7$var$SideNavigation = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, label: label, isServer: isServer = false } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("nav", {
            ref: ref,
            "data-testid": testId,
            "aria-label": label,
            css: $eb2dd47d2fa741f7$var$sideNavStyles,
            "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
            ...isServer && (0, (0, parcelRequire("VSDnB")).fg)('add_ssr_placeholder_replacements_to_nin_and_nav') && {
                'data-ssr-placeholder': 'side-navigation-placeholder'
            },
            ...!isServer && (0, (0, parcelRequire("VSDnB")).fg)('add_ssr_placeholder_replacements_to_nin_and_nav') && {
                'data-ssr-placeholder-replace': 'side-navigation-placeholder'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j7LBE")).SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch"
        }, children));
    });
    var $eb2dd47d2fa741f7$export$2e2bcd8739ae039 = $eb2dd47d2fa741f7$var$SideNavigation;
});
parcelRegister("k0ZZ2", function(module, exports) {
    $parcel$export(module.exports, "MenuItem", ()=>$5e6269ab5deb76fb$export$2ce376c2cc3355c8);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $jSfqD;
    var $hDzhb;
    var $doZTA;
    var $fpoBX;
    var $4UcF0;
    var $jvqf4;
    const $5e6269ab5deb76fb$var$WrapperComponent = (0, $5uXOq.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: useButtonLink, ...props }, ref)=>{
        const commonProps = {
            ...props,
            children: children,
            className: `${className ?? ''} ${legacyClassName ?? ''}`
        };
        return href != null || to != null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
            ...commonProps,
            href: href,
            to: to,
            target: target,
            ref: ref,
            type: useButtonLink ? 'button' : 'a'
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($5e6269ab5deb76fb$var$ButtonItem, {
            ...commonProps,
            type: "button",
            ref: ref
        });
    });
    const $5e6269ab5deb76fb$var$customCssFn = (currentState = {})=>({
            '[data-item-title]': {
                lineHeight: 1.2
            },
            ...currentState.isSelected && {
                '& [data-item-title]': {
                    color: "var(--ds-text-selected, rgb(12, 102, 228))"
                }
            },
            '&:focus, &:visited, &:active': {
                textDecoration: 'inherit',
                outline: 0
            },
            '&:active': {
                backgroundColor: "var(--ds-background-selected-pressed, #85B8FF)",
                boxShadow: "var(--ds-shadow-overlay, transparent)",
                '& [data-item-title]': {
                    color: "var(--ds-text, rgb(66, 82, 110))"
                }
            },
            '&:focus': {
                boxShadow: `${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`} 0 0 0 2px inset`
            },
            '&[data-rbd-draggable-id]': {
                cursor: 'pointer'
            }
        });
    const $5e6269ab5deb76fb$export$2ce376c2cc3355c8 = (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, cssFn: outsideCssFn, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
        const onClickHandler = (0, (0, parcelRequire("jvqf4")).useOnClick)({
            onClick: onClick,
            analytics: analytics
        });
        const [{ route: route, query: query, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        let isSelected;
        (0, $5uXOq.useEffect)(()=>{
            if (isSelected && ref?.current != null) setTimeout(()=>{
                ref && ref.current != null && ref.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            });
        }, [
            selectedOn,
            ref,
            isSelected
        ]);
        if (typeof selectedOn === 'function') isSelected = route != null && selectedOn({
            ...location,
            query: query
        }, (0, ($parcel$interopDefault($aZsz6)))(href || '/', true));
        else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const cssFn = (0, $5uXOq.useCallback)((currentState)=>({
                ...outsideCssFn && outsideCssFn(currentState),
                ...$5e6269ab5deb76fb$var$customCssFn(currentState),
                ...(0, (0, parcelRequire("4UcF0")).getCustomThemeCss)(theme)
            }), [
            theme,
            outsideCssFn
        ]);
        const customProps = {
            ...rest,
            component: $5e6269ab5deb76fb$var$WrapperComponent,
            cssFn: cssFn,
            href: href,
            isSelected: isSelected,
            onClick: onClickHandler,
            overrides: overrides,
            ref: ref,
            useButtonLink: useButtonLink,
            'aria-current': isSelected ? 'page' : undefined
        };
        return overrides?.CustomItem?.render(customProps) || (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jSfqD")).default), customProps);
    });
    const $5e6269ab5deb76fb$var$ButtonItem = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk18uv _19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fpoBX", function(module, exports) {
    $parcel$export(module.exports, "SidebarThemeProvider", ()=>$c9116269ddc1accc$export$92cd68117b68bf5f);
    $parcel$export(module.exports, "useSidebarTheme", ()=>$c9116269ddc1accc$export$b1a81b4626bc52c3);
    var $5uXOq = parcelRequire("5uXOq");
    const $c9116269ddc1accc$var$ThemeContext = (0, $5uXOq.createContext)(null);
    const $c9116269ddc1accc$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($c9116269ddc1accc$var$ThemeContext.Provider, {
            value: theme
        }, children);
    const $c9116269ddc1accc$export$b1a81b4626bc52c3 = ()=>(0, $5uXOq.useContext)($c9116269ddc1accc$var$ThemeContext);
});
parcelRegister("4UcF0", function(module, exports) {
    $parcel$export(module.exports, "getCustomThemeCss", ()=>$2dc9c92255b2fb1d$export$cc5a98b66b3e9306);
    const $2dc9c92255b2fb1d$export$cc5a98b66b3e9306 = (theme)=>{
        if (theme?.navigation) {
            const { navigation: { item: item, icon: icon } } = theme;
            return {
                backgroundColor: item?.background?.default ?? undefined,
                color: item?.color?.default ?? undefined,
                '& [data-item-title]': {
                    color: item?.color?.default ?? undefined
                },
                '&:hover': {
                    color: item?.color?.hover ?? undefined,
                    backgroundColor: item?.background?.hover ?? undefined
                },
                '&:focus, &:visited': {
                    color: item?.color?.default
                },
                '&:active': {
                    color: item?.color?.active ?? undefined,
                    backgroundColor: item?.background?.active ?? undefined
                },
                '&:active [data-item-title]': {
                    color: item?.color?.active ?? undefined
                },
                '&:active [data-item-elem-before]': {
                    color: item?.color?.active ?? undefined
                },
                '&:focus': {
                    boxShadow: item?.color?.active != null ? `${item?.color?.active} 0 0 0 2px inset` : undefined
                },
                '&[aria-current="page"]': {
                    position: 'relative',
                    backgroundColor: item?.background?.active ?? undefined,
                    color: item?.color?.active ?? undefined
                },
                '&[aria-current="page"]:before': {
                    background: item?.color?.active ?? undefined
                },
                '& [data-item-elem-after]': {
                    color: icon?.secondary?.color?.hover ?? undefined
                }
            };
        }
        return {};
    };
});
parcelRegister("jvqf4", function(module, exports) {
    $parcel$export(module.exports, "useOnClick", ()=>$568e03d72b926f2a$export$a81c45382e7253ac);
    var $8zOmE;
    var $2NMNM;
    const $568e03d72b926f2a$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (event)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'navigationItem'
            });
            if (analytics) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
            else (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'sidebar');
            onClick && onClick(event);
        };
    };
});
parcelRegister("3OGaE", function(module, exports) {
    $parcel$export(module.exports, "TitleHeader", ()=>$09f1bcc415909488$export$de3705f3d2162955);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $juVrZ;
    var $fpoBX;
    var $7ic3S;
    const $09f1bcc415909488$var$overrideStyles = (currentStyles)=>({
            ...currentStyles,
            '[data-item-title]': {
                ...currentStyles['[data-item-title]'],
                whiteSpace: 'normal',
                lineHeight: 'initial'
            }
        });
    const $09f1bcc415909488$export$de3705f3d2162955 = ({ children: children })=>{
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const cssFn = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($basmW)))([
                (0, (0, parcelRequire("7ic3S")).generateCustomThemeCssFn)(theme),
                $09f1bcc415909488$var$overrideStyles
            ]), [
            theme
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juVrZ")).default), {
            cssFn: cssFn
        }, children);
    };
});
parcelRegister("juVrZ", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$c46eefd51badc16b$export$42a852a2b6b56249);
    $parcel$export(module.exports, "default", ()=>$c46eefd51badc16b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jsTfk;
    var $jSfqD;
    function $c46eefd51badc16b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c46eefd51badc16b$var$containerStyles = {
        name: "4bgdod",
        styles: "display:block;position:relative"
    };
    const $c46eefd51badc16b$export$42a852a2b6b56249 = ({ children: children, 'data-testid': testId, ...props })=>{
        const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
                className: className,
                onClick: onClick,
                onMouseDown: onMouseDown,
                onDragStart: onDragStart,
                draggable: draggable,
                ref: ref,
                tabIndex: tabIndex,
                disabled: disabled
            }))(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: $c46eefd51badc16b$var$containerStyles,
            ...safeProps
        }, children);
    };
    const $c46eefd51badc16b$var$Header = (0, $5uXOq.forwardRef)((props, ref)=>{
        const cssFn = (0, (0, parcelRequire("jsTfk")).overrideStyleFunction)(()=>({
                userSelect: 'auto',
                ['[data-item-title]']: {
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                },
                'div&:hover': {
                    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                    cursor: 'default'
                },
                'div&:active': {
                    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                    color: `var(--ds-text, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                }
            }), props.cssFn);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSfqD")).default), {
            ...props,
            ref: ref,
            component: props.component || $c46eefd51badc16b$export$42a852a2b6b56249,
            cssFn: cssFn,
            overrides: {
                Title: {
                    render: (_, { children: children, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("h2", props, children)
                }
            }
        });
    });
    var $c46eefd51badc16b$export$2e2bcd8739ae039 = $c46eefd51badc16b$var$Header;
});
parcelRegister("7ic3S", function(module, exports) {
    $parcel$export(module.exports, "generateCustomThemeCssFn", ()=>$6cb72e96c74982ff$export$5ae7d20da3003de);
    var $1UikQ = parcelRequire("1UikQ");
    var $ai0LF;
    const $6cb72e96c74982ff$export$5ae7d20da3003de = (theme)=>(0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
            if (theme?.navigation) {
                const { navigation: { item: item } } = theme;
                const themeStyles = {
                    backgroundColor: item?.background?.default ?? undefined,
                    color: item?.color?.default ?? undefined,
                    '&:hover': {
                        color: item?.color?.hover ?? undefined,
                        backgroundColor: item?.background?.hover ?? undefined
                    },
                    '[data-item-title]': {
                        color: item?.color?.default ?? undefined
                    }
                };
                return (0, ($parcel$interopDefault($1UikQ)))(currentStyles, themeStyles);
            }
            return currentStyles;
        });
});
parcelRegister("ai0LF", function(module, exports) {
    $parcel$export(module.exports, "castRealCSSFnToWronglyTypedCSSFn", ()=>$2bb346e8dcf8bbae$export$3f662b014fa1806e);
    function $2bb346e8dcf8bbae$export$3f662b014fa1806e(fn) {
        return fn;
    }
    function $2bb346e8dcf8bbae$export$17f32e2573d62daa(fn) {
        return fn;
    }
    const $2bb346e8dcf8bbae$export$91011a0a572ef910 = {
        CONNECTED: 'CONNECTED',
        INCOMPLETE: 'INCOMPLETE',
        INITIAL: 'INITIAL',
        SEEN: 'SEEN',
        UNCONNECTED: 'UNCONNECTED'
    };
});
parcelRegister("juTur", function(module, exports) {
    $parcel$export(module.exports, "ContextualAnalyticsData", ()=>$ffb2d49dc0e79e64$export$198470770171c65);
    $parcel$export(module.exports, "IssuesContextualAnalyticsData", ()=>$ffb2d49dc0e79e64$export$bc7f6eebc16e6127);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $iXVV6;
    var $lpwtK;
    var $3d1up;
    const $ffb2d49dc0e79e64$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            ...rest,
            attributes: {
                navVersion: '3',
                viewId: (0, (0, parcelRequire("3d1up")).generateViewId)(menuId, ...stack),
                navigationLayer: 'container',
                ...attributes
            }
        });
    const $ffb2d49dc0e79e64$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, (0, parcelRequire("lpwtK")).useProject), ...rest })=>{
        const { data: project } = useProject();
        const projectConfig = (project?.isSimplified ? (0, (0, parcelRequire("2vSU6")).ProjectStyle).NEXT_GEN : (0, (0, parcelRequire("2vSU6")).ProjectStyle).CLASSIC) || undefined;
        const projectType = project?.type || undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            ...rest,
            attributes: {
                ...attributes,
                projectConfig: projectConfig,
                projectType: projectType,
                navigatorScope: navigatorScope
            }
        });
    };
});
parcelRegister("3d1up", function(module, exports) {
    $parcel$export(module.exports, "generateViewId", ()=>$2f6f53381b1f04e0$export$5b5545ed894dc47a);
    const $2f6f53381b1f04e0$export$5b5545ed894dc47a = (...ids)=>ids.join('/');
});
parcelRegister("17bH5", function(module, exports) {
    $parcel$export(module.exports, "getSystemNavigationPaths", ()=>$0ac95c37050f315f$export$76c5f80c8d9bdb0e);
    var $4R6GH;
    const $0ac95c37050f315f$export$76c5f80c8d9bdb0e = ()=>({
            generalConfiguration: '/jira/settings/system/general-configuration',
            darkFeatures: '/secure/admin/SiteDarkFeatures!default.jspa',
            issueCollectors: '/secure/admin/ViewGlobalCollectors!default.jspa',
            globalAutomation: '/jira/settings/automation',
            troubleshootingAuditLog: '/auditing/view',
            troubleshootingPluginViewer: '/plugins/servlet/depview/plugins',
            troubleshootingModulesViewer: '/plugins/servlet/depview/modules',
            troubleshootingSystemInfo: '/secure/admin/ViewSystemInfo.jspa',
            troubleshootingIntegrityChecker: '/secure/admin/IntegrityChecker!default.jspa',
            troubleshootingLoggingProfiling: '/secure/admin/ViewLogging.jspa',
            troubleshootingSchedulerDetails: '/secure/admin/SchedulerAdmin.jspa',
            troubleshootingPerformanceAndScale: '/jira/settings/system/performance/overview',
            securityProjectRoles: '/secure/project/ViewProjectRoles.jspa',
            securityGlobalPermissions: (0, (0, parcelRequire("4R6GH")).fg)('olympus-global-permissions-fe-modernisation') ? '/secure/admin/global-permissions' : '/secure/admin/GlobalPermissions!default.jspa',
            userInterfacesUserDefaults: '/secure/admin/ViewUserDefaultSettings.jspa',
            userInterfacesEditDefaultDashboard: '/secure/admin/EditDefaultDashboard!default.jspa',
            userInterfacesLookAndFeel: '/secure/admin/LookAndFeel!default.jspa',
            userInterfacesPasAdmin: '/plugins/servlet/pas/admin',
            userInterfacesSiteAdmin: '/jira/settings/system/ui/announcement-banner',
            importSectionBackupManager: '/secure/admin/CloudExport.jspa',
            importSectionExternalImport: '/secure/admin/ExternalImport1.jspa',
            importSectionExternalImportNew: '/jira/settings/system/external-import',
            importSectionCloudImport: '/secure/admin/CloudImport!start.jspa?source=import_cloud',
            importSectionServerImport: '/secure/admin/CloudImport!start.jspa?source=import_server',
            mailSectionGlobalMailSettings: '/secure/admin/GlobalMailSettings.jspa',
            mailSectionOutgoingMail: '/secure/admin/OutgoingMailServers.jspa',
            mailSectionIncomingMail: '/secure/admin/IncomingMailServers.jspa',
            mailSectionSendMail: '/secure/admin/SendBulkMail!default.jspa',
            adminHelperPermissionHelper: '/secure/admin/PermissionHelperAdmin.jspa',
            adminHelperEmailNotificationsLogHelper: '/jira/settings/system/notification-logs',
            sharedSectionManageFilters: '/secure/admin/filters/ViewSharedFilters.jspa',
            sharedManageDashboards: '/secure/admin/dashboards/ViewSharedDashboards.jspa',
            advancedSectionAttachments: '/secure/admin/ViewAttachmentSettings.jspa',
            advancedSectionEvents: '/secure/admin/ListEventTypes.jspa',
            advancedSectionWebHooks: '/plugins/servlet/webhooks',
            advancedSectionServices: '/secure/admin/ViewServices!default.jspa',
            advancedLexoRankManagement: '/secure/GHLexoRankManage.jspa?decorator=admin'
        });
});
parcelRegister("4OCke", function(module, exports) {
    $parcel$export(module.exports, "matchPathname", ()=>$cf3ce1d2a79b8e17$export$b71b01274a8bb9ec);
    $parcel$export(module.exports, "matchUrlPathname", ()=>$cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c);
    $parcel$export(module.exports, "matchPartialUrlPathname", ()=>$cf3ce1d2a79b8e17$export$9870a2fa97808ed7);
    $parcel$export(module.exports, "matchUrlExact", ()=>$cf3ce1d2a79b8e17$export$422d2a799c6e30b8);
    $parcel$export(module.exports, "matchUrlParams", ()=>$cf3ce1d2a79b8e17$export$63fdecce99465869);
    var $f8l56 = parcelRequire("f8l56");
    const $cf3ce1d2a79b8e17$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
    const $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$cf3ce1d2a79b8e17$var$cleanPath(currentUrlPath) === $cf3ce1d2a79b8e17$var$cleanPath(itemUrlPath);
    const $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
    const $cf3ce1d2a79b8e17$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
    const $cf3ce1d2a79b8e17$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, ($parcel$interopDefault($f8l56)))(currentLocation.query, itemLocation.query);
    const $cf3ce1d2a79b8e17$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);
});
parcelRegister("3tHFY", function(module, exports) {
    $parcel$export(module.exports, "ConnectMenu", ()=>$1b0be5b9936240ae$export$19d0925d424b864a);
    var $5uXOq = parcelRequire("5uXOq");
    var $au6nA;
    var $fh2pW;
    const $1b0be5b9936240ae$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
        const filteredItems = (0, (0, parcelRequire("au6nA")).useFilteredItems)(items || null, shouldFilter);
        if (filteredItems == null || !filteredItems.length) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, filteredItems.map((item, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fh2pW")).ConnectItem), {
                item: item,
                key: item.id,
                index: index,
                overrides: overrides,
                showIcons: showIcons,
                submenuId: submenuId
            })));
    };
});
parcelRegister("au6nA", function(module, exports) {
    $parcel$export(module.exports, "useFilteredItems", ()=>$cb371d7d8e582719$export$79762159776e61da);
    var $5uXOq = parcelRequire("5uXOq");
    var $kvHKs;
    const $cb371d7d8e582719$export$79762159776e61da = (items, shouldFilter = true)=>(0, $5uXOq.useMemo)(()=>{
            if (!shouldFilter) return items || [];
            return items?.filter((item)=>!(0, (0, parcelRequire("kvHKs")).staticLegacyIds).includes(item.id)) || [];
        }, [
            items,
            shouldFilter
        ]);
});
parcelRegister("fh2pW", function(module, exports) {
    $parcel$export(module.exports, "ConnectItem", ()=>$f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $apKqz;
    var $gjTBi;
    var $3TzYp;
    var $iUo88;
    var $jjUR3;
    var $hrlU6;
    var $4R6GH;
    var $k0ZZ2;
    var $eYDk7;
    var $3OGaE;
    var $kZj7F;
    var $4OCke;
    const $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
        const { addNew: addNew } = (0, (0, parcelRequire("jjUR3")).useConnectItemClickHistory)();
        const isDialog = item.styleClass && (0, (0, parcelRequire("hrlU6")).isConnectDialogWebItem)(item.styleClass) && (0, (0, parcelRequire("4R6GH")).fg)('blu-4941-connect-webitem-imperative-api');
        const webItemRef = (0, $5uXOq.useRef)(null);
        const BackMenuItem = {
            ...overrides.BackMenuItem,
            onClick: (ev)=>{
                if (submenuId != null) {
                    const cookieData = (0, (0, parcelRequire("3TzYp")).getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                    let parsedCookieData = null;
                    try {
                        parsedCookieData = JSON.parse(cookieData);
                    } catch  {
                        parsedCookieData = {
                            submenuActive: false,
                            expanded: false
                        };
                    }
                    const newCookieData = {
                        ...parsedCookieData,
                        submenuActive: false
                    };
                    (0, (0, parcelRequire("iUo88")).setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
                }
                if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
                overrides.BackMenuItem?.onClick?.(ev);
            }
        };
        const icon = (0, $5uXOq.useMemo)(()=>{
            if (showIcons !== true) return null;
            return item.iconUrl != null && item.iconUrl.trim().length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$var$ConnectIcon, {
                src: item.iconUrl,
                alt: ""
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("apKqz"))))), {
                label: ""
            });
        }, [
            showIcons,
            item.iconUrl
        ]);
        const onItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (overrides?.ParentMenuItem?.onClick && isNested) overrides.ParentMenuItem.onClick(event);
            if (isDialog) (0, (0, parcelRequire("hrlU6")).withConnectHost)((connectHost)=>{
                if (webItemRef.current && item.styleClass && item.url) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
            });
            else item.url != null && addNew(item.url);
        }, [
            addNew,
            isDialog,
            isNested,
            item.styleClass,
            item.url,
            overrides
        ]);
        const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (submenuId != null) {
                const cookieData = (0, (0, parcelRequire("3TzYp")).getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                if (cookieData != null) (0, (0, parcelRequire("iUo88")).setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                    ...JSON.parse(cookieData),
                    submenuActive: true
                }));
            }
            if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(event);
            return ()=>null;
        }, [
            overrides,
            submenuId
        ]);
        if (item.section === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: item.name,
            hasSeparator: Boolean(index)
        }, (item.items || []).map((si, idx)=>(0, ($parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
                key: si.id,
                item: si,
                overrides: {
                    ...overrides,
                    BackMenuItem: BackMenuItem
                },
                index: idx,
                isNested: isNested
            })));
        if (item.items) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            id: item.id,
            analytics: {
                itemId: item.id
            },
            iconBefore: icon,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            title: item.name,
            onClick: onNestedMenuItemClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eYDk7")).NavigationContentWrapper), {
            submenuActive: true,
            nestedMenuOpen: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
                key: si.id,
                item: si,
                index: nestIndex,
                overrides: {
                    ...overrides,
                    BackMenuItem: {
                        href: item.url,
                        title: si.name,
                        onClick: (ev)=>ev.preventDefault()
                    }
                },
                isNested: true
            })))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: item.id
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlExact)(),
            iconBefore: icon,
            href: isDialog ? undefined : item.url,
            legacyClassName: (0, (0, parcelRequire("4R6GH")).fg)('blu-4941-connect-webitem-imperative-api') ? undefined : item.styleClass,
            onClick: onItemClick,
            ref: (0, (0, parcelRequire("4R6GH")).fg)('blu-4941-connect-webitem-imperative-api') ? webItemRef : (0, $5uXOq.createRef)()
        }, item.name);
    };
    const $f2bd062d7c8c5e44$var$ConnectIcon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbgktf _4t3igktf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iUo88", function(module, exports) {
    $parcel$export(module.exports, "setStrictlyNecessaryCookie", ()=>$89b5b8a4b358ad27$export$93509ff9a62ee022);
    var $7RRGT;
    const $89b5b8a4b358ad27$export$93509ff9a62ee022 = (key, value, attributes)=>{
        (0, (0, parcelRequire("7RRGT")).setStrictlyNecessaryCookie)(key, value, attributes);
    };
});
parcelRegister("7RRGT", function(module, exports) {
    $parcel$export(module.exports, "setStrictlyNecessaryCookie", ()=>$e697b6ca6ca66a2d$export$93509ff9a62ee022);
    var $eYli8 = parcelRequire("eYli8");
    var $VSDnB;
    var $3MsQ9;
    var $Dyz2r;
    const $e697b6ca6ca66a2d$export$93509ff9a62ee022 = (key, value, attributes)=>{
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_moonjelly_bsc_master_killswitch')) (0, ($parcel$interopDefault($eYli8))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
        else try {
            (0, (0, parcelRequire("3MsQ9")).sendPackageOperationalEvent)({
                action: 'usedSetStrictlyNecessaryCookie',
                attributes: {
                    cookieKey: key
                }
            });
            (0, ($parcel$interopDefault($eYli8))).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
        } catch (e) {
            (0, (0, parcelRequire("Dyz2r")).Logger).errorWithOperationalEvent({
                action: 'usedSetStrictlyNecessaryCookieError',
                attributes: {
                    cookieKey: key
                },
                message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
            });
        }
    };
});
parcelRegister("jjUR3", function(module, exports) {
    $parcel$export(module.exports, "useConnectItemClickHistory", ()=>$c499ec49965fe6fe$export$c251e3fda1cce4a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    const $c499ec49965fe6fe$var$history = {
        unique: []
    };
    const $c499ec49965fe6fe$export$c251e3fda1cce4a3 = ()=>{
        (0, (0, parcelRequire("gKZoD")).di)(window);
        const addNew = (0, $5uXOq.useCallback)((historyItem)=>{
            if (window.location.href.endsWith(historyItem) === false) $c499ec49965fe6fe$var$history.unique.push(historyItem);
        }, []);
        return (0, $5uXOq.useMemo)(()=>({
                history: $c499ec49965fe6fe$var$history,
                addNew: addNew
            }), [
            addNew
        ]);
    };
    const $c499ec49965fe6fe$export$ef04cd58bebb0345 = ()=>{
        $c499ec49965fe6fe$var$history.unique.length = 0;
    };
});
parcelRegister("hrlU6", function(module, exports) {
    $parcel$export(module.exports, "withConnectHost", ()=>$9316db67541b8a94$export$970e2411dd8601c8);
    $parcel$export(module.exports, "getConnectHost", ()=>$9316db67541b8a94$export$186d423c00af146c);
    $parcel$export(module.exports, "isConnectDialogWebItem", ()=>$9316db67541b8a94$export$920fb4b46d4f2eec);
    var $dJZWD;
    const $9316db67541b8a94$export$970e2411dd8601c8 = async (action)=>{
        const connectHost = await (0, (0, parcelRequire("dJZWD")).setupConnectJs)();
        action(connectHost);
    };
    const $9316db67541b8a94$export$186d423c00af146c = ()=>window.connectHost;
    const $9316db67541b8a94$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');
});
parcelRegister("dJZWD", function(module, exports) {
    $parcel$export(module.exports, "setupConnectJs", ()=>$762ba9fa524ea8e6$export$891414b605e5f038);
    var $6BZYo;
    var $cQZXC;
    var $4R6GH;
    var $dH9DT;
    const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('bifrost-gateway-tmp-no-wrm-via-ssr')) await (0, (0, parcelRequire("cQZXC")).waitForHeritage)();
        await (0, (0, parcelRequire("dH9DT")).waitForJQuery)();
        const loader = await (parcelRequire("gRUhY"));
        await loader.performSideEffects();
        return window.connectHost;
    };
    let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
    const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
        if (window.__SPA__) {
            if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
            return $762ba9fa524ea8e6$var$installConnectJsPromise;
        }
        await (0, (0, parcelRequire("6BZYo")).loadBridge)({
            name: 'ac/create',
            wrmKeys: [
                'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
                'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
            ]
        });
        return window.connectHost;
    };
});
parcelRegister("6BZYo", function(module, exports) {
    $parcel$export(module.exports, "loadBridge", ()=>$ce95ee3fd66207c7$export$df8409da353bde5a);
    var $fqWWz;
    var $3GASE;
    var $ig88W;
    var $7T84i;
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $8JNtu;
    var $5Ik5Y;
    const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, (0, parcelRequire("fqWWz")).MAX_RETRIES), timeout: timeout = (0, (0, parcelRequire("fqWWz")).DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        if (wrmKeys != null) return (0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
            name: name,
            wrmKeys: [].concat(wrmKeys),
            shouldLogError: shouldLogError
        });
        if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
        if (tentatives <= 1) return (0, (0, parcelRequire("3GASE")).loadBridgeBail)({
            name: name,
            shouldLogError: shouldLogError
        });
        return (0, (0, parcelRequire("ig88W")).loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError,
            timeout: (tentatives - 1) * timeout
        });
    };
});
parcelRegister("3GASE", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeBail", ()=>$e512b6cc4a8702e5$export$a036f92c2465504e);
    var $wRU6t;
    var $fqWWz;
    const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        try {
            return window.require(name);
        } catch (error) {
            if (shouldLogError) (0, (0, parcelRequire("fqWWz")).safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, (0, parcelRequire("wRU6t")).safeStringify)(error) ?? ''}`, {
                isSpa: __SPA__,
                name: name,
                error: (0, (0, parcelRequire("wRU6t")).safeStringify)(error)
            });
            throw new Error(`Unable to load bridge "${name}"`, {
                cause: error
            });
        }
    };
});
parcelRegister("ig88W", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeRace", ()=>$64f1dbae1ea314ee$export$20c32b4579d78b92);
    var $3GASE;
    var $9B86Q;
    var $fqWWz;
    const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, (0, parcelRequire("fqWWz")).DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>Promise.race([
            (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: name
            }),
            new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, (0, parcelRequire("3GASE")).loadBridgeBail)({
                    name: name,
                    shouldLogError: shouldLogError
                }))
        ]);
});
parcelRegister("7T84i", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeStrict", ()=>$89a95eb8b151782d$export$eba600d28decc4ac);
    var $c56lL;
    var $ig88W;
    var $fVOHM;
    var $fqWWz;
    const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        (0, (0, parcelRequire("c56lL")).saveStats)(name, wrmKeys);
        try {
            return window.require(name);
        } catch (error) {
            await (0, (0, parcelRequire("fVOHM")).loadWrmResources)({
                wrmKeys: wrmKeys,
                shouldLogError: shouldLogError
            });
            return (0, (0, parcelRequire("ig88W")).loadBridgeRace)({
                name: name,
                shouldLogError: shouldLogError
            });
        }
    };
});
parcelRegister("c56lL", function(module, exports) {
    $parcel$export(module.exports, "saveStats", ()=>$6c875a5034ae8433$export$9ea3ff7978093559);
    const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
        if (stats[resource] == null) stats[resource] = 1;
        else stats[resource] += 1;
    };
    const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
            requests: 0,
            amdModules: {},
            wrmKeys: {}
        });
    const $6c875a5034ae8433$var$initStats = ()=>{
        if (window.__WRM_INTERNAL_STATS__ == null) window.__WRM_INTERNAL_STATS__ = {
            loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
        };
        else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
        return window.__WRM_INTERNAL_STATS__.loadBridge;
    };
    const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
    const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
        try {
            const stats = $6c875a5034ae8433$var$initStats();
            if ($6c875a5034ae8433$var$isPageInteractive()) return;
            stats.requests += 1;
            $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
            if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
            else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
        } catch (e) {}
    };
});
parcelRegister("cQZXC", function(module, exports) {
    $parcel$export(module.exports, "waitForHeritage", ()=>$90def0f7a7aa11d6$export$c61060338d026f78);
    var $4R6GH;
    var $7aBP4;
    var $aePFs;
    const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
        if (false) return null;
        if (!__SPA__) return Promise.resolve();
        if (!window.__WAIT_FOR_HERITAGE__) {
            window.__WAIT_FOR_HERITAGE__ = new (0, (0, parcelRequire("aePFs")).default)();
            if ((0, (0, parcelRequire("4R6GH")).fg)('bifrost-gateway-tmp-no-wrm-via-ssr')) (0, (0, parcelRequire("7aBP4")).bootstrapWrmClient)().then(()=>{
                window.__WAIT_FOR_HERITAGE__.resolve();
            });
        }
        return window.__WAIT_FOR_HERITAGE__;
    };
});
parcelRegister("7aBP4", function(module, exports) {
    $parcel$export(module.exports, "bootstrapWrmClient", ()=>$f93199c7ae9c59d8$export$d001f71dd306cb0c);
    var $7f4tk;
    const $f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
    const $f93199c7ae9c59d8$var$fetchSpaWrmContext = async ()=>{
        return (0, (0, parcelRequire("7f4tk")).default)($f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT);
    };
    const $f93199c7ae9c59d8$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
        let element;
        if (resourceType === 'JAVASCRIPT') {
            element = globalThis.document?.createElement('script');
            element.setAttribute('crossorigin', '');
            element.setAttribute('src', url);
            element.setAttribute('data-client-bootstrapped', '');
            element.setAttribute('data-wrm-key', key);
            element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
        } else {
            element = globalThis.document?.createElement('link');
            element.setAttribute('crossorigin', '');
            element.setAttribute('href', url);
            element.setAttribute('rel', 'stylesheet');
            element.setAttribute('media', 'all');
            element.setAttribute('data-client-bootstrapped', '');
            element.setAttribute('data-wrm-key', key);
            element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
        }
        return element;
    };
    let $f93199c7ae9c59d8$var$hasWrmInitialised;
    const $f93199c7ae9c59d8$var$runBootstrap = ()=>{
        const spaWrmContext = $f93199c7ae9c59d8$var$fetchSpaWrmContext();
        return new Promise((resolve)=>{
            spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
                const WRM = globalThis.WRM = globalThis.WRM || {};
                WRM._unparsedData = data;
                WRM._unparsedErrors = errors;
                if (WRM._dataArrived) WRM._dataArrived();
                resources.map($f93199c7ae9c59d8$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
                resolve();
            });
        });
    };
    const $f93199c7ae9c59d8$export$d001f71dd306cb0c = ()=>{
        if (false) return Promise.resolve();
        if ($f93199c7ae9c59d8$var$hasWrmInitialised) return $f93199c7ae9c59d8$var$hasWrmInitialised;
        if (typeof globalThis.WRM !== 'undefined') $f93199c7ae9c59d8$var$hasWrmInitialised = Promise.resolve();
        else $f93199c7ae9c59d8$var$hasWrmInitialised = $f93199c7ae9c59d8$var$runBootstrap();
        return $f93199c7ae9c59d8$var$hasWrmInitialised;
    };
});
parcelRegister("dH9DT", function(module, exports) {
    $parcel$export(module.exports, "getMeta", ()=>$a78c52ec7ed5d025$export$c47913ca32a5c6f7);
    $parcel$export(module.exports, "getJQuery", ()=>$a78c52ec7ed5d025$export$7232a6dc780f9887);
    $parcel$export(module.exports, "getGlobalAP", ()=>$a78c52ec7ed5d025$export$fbc82125a6bd8012);
    $parcel$export(module.exports, "isObject", ()=>$a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
    $parcel$export(module.exports, "escapeSelector", ()=>$a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
    $parcel$export(module.exports, "waitForJQuery", ()=>$a78c52ec7ed5d025$export$97214de9c546981c);
    $parcel$export(module.exports, "ErrorDebugAddonKeys", ()=>$a78c52ec7ed5d025$export$d690da9bc8146677);
    var $jcw0u;
    const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
        const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
        return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
    };
    const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
    const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>window._AP;
    const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
    const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
        if (!s) throw new Error('No selector to escape');
        return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
    };
    const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
    const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
            const interval = setInterval(()=>{
                if (window.AJS?.$) {
                    clearInterval(interval);
                    resolve();
                }
            }, 10);
            setTimeout(()=>{
                clearInterval(interval);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'connect-jquery-timeout',
                        packageName: 'jiraConnect'
                    },
                    error: new Error('Timeout when waiting for jQuery to be available on the page'),
                    skipSentry: true
                });
                reject();
            }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
        });
    const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
    const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
    const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
        $a78c52ec7ed5d025$export$cb954c21735b28e4,
        $a78c52ec7ed5d025$export$7315c38dc71bd41f
    ];
});
parcelRegister("gRUhY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aVR4N").then(()=>parcelRequire('8vJyT'));
});
parcelRegister("eYDk7", function(module, exports) {
    $parcel$export(module.exports, "NavigationHeaderWrapper", ()=>$eea5dc8ebf00d36e$export$bae9b35e967353d5);
    $parcel$export(module.exports, "NavigationExpandableContentWrapper", ()=>$eea5dc8ebf00d36e$export$4e88508e6904469e);
    $parcel$export(module.exports, "NavigationContentWrapper", ()=>$eea5dc8ebf00d36e$export$e7d691a5a9258e1b);
    $parcel$export(module.exports, "NextGenIssueTypesWrapper", ()=>$eea5dc8ebf00d36e$export$f094f7aad76e4268);
    $parcel$export(module.exports, "ExpandableProjectSettingsWrapper", ()=>$eea5dc8ebf00d36e$export$e38bb288d890ec2f);
    $parcel$export(module.exports, "ShortCutsAndAppsWrapper", ()=>$eea5dc8ebf00d36e$export$337add4342ee7986);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gwIPs;
    const $eea5dc8ebf00d36e$export$bae9b35e967353d5 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer, null, props.children);
    const $eea5dc8ebf00d36e$export$4e88508e6904469e = (props)=>{
        const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer, {
            nestedAppOpen: nestedAppOpen,
            submenuActive: submenuActive
        }, children);
    };
    const $eea5dc8ebf00d36e$export$e7d691a5a9258e1b = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationContentWrapperContainer, {
            navModuleLabelsHidden: props.navModuleLabelsHidden,
            nestedAppOpen: props.nestedAppOpen,
            context: props.context,
            submenuActive: props.submenuActive,
            nestedMenuOpen: props.nestedMenuOpen,
            "data-component-selector": "NavigationContentWrapperContainer"
        }, props.children);
    const $eea5dc8ebf00d36e$export$f094f7aad76e4268 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer, null, props.children);
    const $eea5dc8ebf00d36e$export$e38bb288d890ec2f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ExpandableProjectContainer, null, props.children);
    const $eea5dc8ebf00d36e$export$337add4342ee7986 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer, null, props.children);
    const $eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _1s541012 _1lfu1012",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_ykp9lh": (0, (0, parcelRequire("lD23V")).default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
                "--_1qrlsbv": (0, (0, parcelRequire("lD23V")).default)(Math.round((0, (0, parcelRequire("gwIPs")).borderRadius) * 1.333), "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
                __cmplp.submenuActive && "_4t3i1qw7",
                __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$NavigationContentWrapperContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_6w8gix": (0, (0, parcelRequire("lD23V")).default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, (0, parcelRequire("gwIPs")).gridSize), "px"),
                "--_1qrlsbv": (0, (0, parcelRequire("lD23V")).default)(Math.round((0, (0, parcelRequire("gwIPs")).borderRadius) * 1.333), "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
                __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
                __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
                __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$ExpandableProjectContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wtppxbi _df5vpxbi",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _14tk72c6 _t3zc183y _1so4jjyb _1thc1skh _a6avqslr _dnyv1skh",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kZj7F", function(module, exports) {
    $parcel$export(module.exports, "NestingMenuItem", ()=>$2fbfde7c900477f4$export$4c594f24f8e4128a);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $1UikQ = parcelRequire("1UikQ");
    var $g9uZe;
    var $8UO8z;
    var $5Hj3V;
    var $k0ZZ2;
    var $hg4VT;
    var $kZ5sr;
    var $fpoBX;
    var $ai0LF;
    var $kavsL;
    const $2fbfde7c900477f4$var$customCssFn = (0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStateAndStyles)=>{
        const activeColor = typeof currentStateAndStyles['&:active'] === 'object' ? `${currentStateAndStyles['&:active'].color} !important` : 'inherit';
        const baseColor = typeof currentStateAndStyles['&:hover'] === 'object' ? currentStateAndStyles['&:hover'].color : 'inherit';
        const newStyle = {
            ...(0, (0, parcelRequire("kZ5sr")).cssFn)(currentStateAndStyles),
            '&:visited, &:focus, &:active': {
                textDecoration: 'inherit',
                outline: 0
            },
            '&:active': {
                color: activeColor
            },
            '&:visited, &:focus': {
                color: baseColor
            },
            '& [data-item-title]': {
                color: baseColor
            }
        };
        return (0, ($parcel$interopDefault($1UikQ)))(currentStateAndStyles, newStyle);
    });
    const $2fbfde7c900477f4$var$WrappingLinkComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", props, props.children);
    const $2fbfde7c900477f4$export$4c594f24f8e4128a = (0, $5uXOq.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const backButtonCssFn = (0, (0, parcelRequire("hg4VT")).generateBackButtonCssFn)(theme);
        const { BackMenuItem: BackMenuItem = {} } = overrides;
        const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $5uXOq.Fragment), ...backItemProps } = BackMenuItem;
        const renderBackItem = (0, $5uXOq.useCallback)(({ onClick: onClick })=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrapperComponent, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                ...backItemProps,
                analytics: {
                    itemId: 'back'
                },
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("g9uZe"))))), {
                    label: ""
                }),
                onClick: (ev)=>{
                    if ((0, (0, parcelRequire("kavsL")).isNormalClick)(ev)) {
                        onClick();
                        backItemProps.onClick?.(ev);
                    }
                },
                cssFn: backButtonCssFn
            }, backTitle)), [
            WrapperComponent,
            backItemProps,
            backButtonCssFn,
            backTitle
        ]);
        const renderCustomItem = (0, $5uXOq.useCallback)(({ children: itemTitle, onClick: onClick, cssFn: customItemCssFn, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8UO8z")).default), {
                ...props,
                id: id,
                component: reloadOnNavigationToNesting ? $2fbfde7c900477f4$var$WrappingLinkComponent : props.component,
                onClick: (ev)=>{
                    if (props.isSelected === true) ev.preventDefault();
                    onClick && onClick(ev);
                },
                overrides: {
                    GoBackItem: {
                        render: renderBackItem
                    }
                },
                title: itemTitle,
                cssFn: customItemCssFn ? (0, ($parcel$interopDefault($basmW)))([
                    customItemCssFn,
                    $2fbfde7c900477f4$var$customCssFn
                ]) : $2fbfde7c900477f4$var$customCssFn
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Hj3V")).SidebarErrorBoundary), {
                id: `${id}Nesting`,
                packageName: "jiraSpaAppsSidebarCommon"
            }, children)), [
            children,
            id,
            reloadOnNavigationToNesting,
            renderBackItem
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            ...rest,
            ref: ref,
            overrides: {
                CustomItem: {
                    render: renderCustomItem
                }
            }
        }, title);
    });
});
parcelRegister("hg4VT", function(module, exports) {
    $parcel$export(module.exports, "generateBackButtonCssFn", ()=>$1e5fb9a53caeb1aa$export$56644251c3f2ea82);
    const $1e5fb9a53caeb1aa$export$56644251c3f2ea82 = (theme)=>()=>{
            if (theme?.navigation) {
                const { icon: icon } = theme.navigation;
                return {
                    '& [data-item-elem-before], &:active span[data-item-elem-before]': {
                        color: icon?.secondary?.color?.active ?? undefined
                    }
                };
            }
            return {};
        };
});
parcelRegister("kZ5sr", function(module, exports) {
    $parcel$export(module.exports, "cssFn", ()=>$399c9dca906145c0$export$d722961e96b459c5);
    var $1UikQ = parcelRequire("1UikQ");
    var $gwIPs;
    var $ai0LF;
    const $399c9dca906145c0$export$d722961e96b459c5 = (0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
        const newStyle = {
            '[data-item-elem-after] [data-right-arrow]': {
                display: 'none'
            },
            '&:hover [data-item-elem-after]': {
                '& > :not([data-right-arrow])': {
                    display: 'none'
                },
                '& [data-right-arrow]': {
                    display: 'flex'
                }
            },
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 5.5}px`
        };
        return (0, ($parcel$interopDefault($1UikQ)))(currentStyles, newStyle);
    });
});
parcelRegister("kavsL", function(module, exports) {
    $parcel$export(module.exports, "isNormalClick", ()=>$e059487e30c8155a$export$729f3684d5c2b9b9);
    const $e059487e30c8155a$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
});
parcelRegister("eaZ4X", function(module, exports) {
    $parcel$export(module.exports, "SECTION_ID", ()=>$b36275c07d465a0e$export$501955bd67991a25);
    const $b36275c07d465a0e$export$501955bd67991a25 = {
        MIGRATE_TO_CLOUD_SITE: 'migrate-to-cloud-site',
        PERFORMANCE_AND_SCALE: 'performance-and-scale'
    };
});
parcelRegister("jMBA3", function(module, exports) {
    $parcel$export(module.exports, "useFeatures", ()=>$4023bf6b28a8dc58$export$4a39035bacc4ed76);
    $parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", ()=>$4023bf6b28a8dc58$export$f601efaceb0636f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $aUDLa;
    var $7OqB4;
    var $awp39;
    var $9OXo1;
    var $gJkov;
    const $4023bf6b28a8dc58$export$4a39035bacc4ed76 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)(()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("aUDLa")).useNavigationGlobalResource)();
        const { isDevMode: isDevMode, isAdmin: isAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("gJkov")).extractData)(data, isDevMode, isAdmin), [
            data,
            isDevMode,
            isAdmin
        ]);
        return {
            data: extractedData,
            loading: loading,
            error: error
        };
    });
    const $4023bf6b28a8dc58$export$f601efaceb0636f4 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("awp39")).useGlobalSettingsSystemConnectItems));
});
parcelRegister("aUDLa", function(module, exports) {
    $parcel$export(module.exports, "useNavigationGlobalResource", ()=>$dbad5a19b82e4911$export$1e1c317ed5b99faa);
    var $5uXOq = parcelRequire("5uXOq");
    var $atU1t;
    var $2YP9W;
    const $dbad5a19b82e4911$export$1e1c317ed5b99faa = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource));
        const response = (0, $5uXOq.useMemo)(()=>data && data.response, [
            data
        ]);
        return {
            data: response,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("7OqB4", function(module, exports) {
    $parcel$export(module.exports, "withThrowOnError", ()=>$f0eadb98e9fdd0d1$export$a018832f2ec4dc91);
    var $gKZoD;
    const $f0eadb98e9fdd0d1$var$isDataEmpty = (data)=>data == null;
    function $f0eadb98e9fdd0d1$export$a018832f2ec4dc91(theHook) {
        return (...args)=>{
            (0, (0, parcelRequire("gKZoD")).di)(theHook);
            const result = theHook(...args);
            if (!false && $f0eadb98e9fdd0d1$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
            return result;
        };
    }
});
parcelRegister("awp39", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", ()=>$6ac80db07eab2a1e$export$f601efaceb0636f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $aUDLa;
    var $doZTA;
    var $7tsV0;
    var $4gymV;
    var $5W6pd;
    const $6ac80db07eab2a1e$var$getItemsMemo = (0, (0, parcelRequire("8QpSo")).default)((d)=>(0, (0, parcelRequire("4gymV")).getLinks)(d, [
            'admin_system_menu'
        ], {
            skipFilter: true
        }).map((0, (0, parcelRequire("5W6pd")).transformLink)).filter(Boolean));
    const $6ac80db07eab2a1e$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $6ac80db07eab2a1e$export$f601efaceb0636f4 = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("aUDLa")).useNavigationGlobalResource)();
        const items = (0, $5uXOq.useMemo)(()=>data && $6ac80db07eab2a1e$var$getItemsMemo(data), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $6ac80db07eab2a1e$var$findItemAndStackMemo(items, route.name, location), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("7tsV0", function(module, exports) {
    $parcel$export(module.exports, "findItemAndStack", ()=>$93fa8c16baad19b1$export$751e2e6237002565);
    var $ajpes = parcelRequire("ajpes");
    var $k0iPT;
    const $93fa8c16baad19b1$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
    const $93fa8c16baad19b1$var$isSameQuery = (locationQuery, itemQuery)=>(0, ($parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, ($parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
    const $93fa8c16baad19b1$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
        let found = null;
        if (!(0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(routeName)) return found;
        const locationQuery = $93fa8c16baad19b1$var$splitRelevantQs(location.search);
        items.some((item)=>{
            const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
            const itemQuery = $93fa8c16baad19b1$var$splitRelevantQs(itemQs);
            const sameQuery = $93fa8c16baad19b1$var$isSameQuery(locationQuery, itemQuery);
            if (item.section !== true && itemPath === location.pathname && sameQuery) {
                found = {
                    stack: parentStack,
                    selected: item
                };
                return true;
            }
            if (item.items) {
                const stack = item.section === true ? parentStack : parentStack.concat(item.id);
                found = $93fa8c16baad19b1$export$751e2e6237002565(item.items, routeName, location, stack);
            }
            return Boolean(found);
        });
        return found;
    };
});
parcelRegister("k0iPT", function(module, exports) {
    $parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", ()=>$c82776b15970ab04$export$a8aac2ba4dc1f57);
    $parcel$export(module.exports, "CONNECT_ROUTES_SET", ()=>$c82776b15970ab04$export$c47bf667d3008c53);
    var $65Ltd;
    const $c82776b15970ab04$export$a8aac2ba4dc1f57 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT)
    ]);
    const $c82776b15970ab04$export$c47bf667d3008c53 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL)
    ]);
});
parcelRegister("4gymV", function(module, exports) {
    $parcel$export(module.exports, "getLinks", ()=>$6dc7ee8ba2a1371f$export$8054dcb2b42da45c);
    var $83mn0;
    var $7NH5Y;
    const $6dc7ee8ba2a1371f$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
        const acc = [];
        locations.forEach((location)=>{
            const links = (0, (0, parcelRequire("83mn0")).getLinksFromSidebar)(sidebarConfig, location);
            if (omitSections === true) {
                Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
                return;
            }
            Array.prototype.push.apply(acc, links);
        });
        return acc.filter((item)=>{
            if (!item) return false;
            if (skipFilter === true) return true;
            const hasConnectPrefix = item.id && item.id.includes((0, (0, parcelRequire("7NH5Y")).connectPrefix));
            if (hasConnectPrefix) return true;
            const isConnectSection = (0, (0, parcelRequire("7NH5Y")).connectSections).includes(item.id);
            if (isConnectSection) return true;
            const isJsdConnectSection = item.id && item.id.includes((0, (0, parcelRequire("7NH5Y")).jsdConnectPrefix));
            if (isJsdConnectSection) return true;
            return false;
        });
    };
});
parcelRegister("83mn0", function(module, exports) {
    $parcel$export(module.exports, "hasItemInSidebar", ()=>$90215f5482fce08d$export$57dd40eec4c64521);
    $parcel$export(module.exports, "getLinksFromSidebar", ()=>$90215f5482fce08d$export$9b7e0e4dd8bfade8);
    const $90215f5482fce08d$var$findLink = (arrayOfLinks, legacyId, partialMatch = false)=>{
        if (!Array.isArray(arrayOfLinks)) return undefined;
        for(let i = 0; i < arrayOfLinks.length; i += 1){
            const link = arrayOfLinks[i];
            if (partialMatch && link.id.indexOf(legacyId) === 0) return link;
            if (link.id === legacyId) return link;
            if (link.links) {
                const linkFound = $90215f5482fce08d$var$findLink(link.links, legacyId, partialMatch);
                if (linkFound) return linkFound;
            }
        }
        return undefined;
    };
    const $90215f5482fce08d$export$f62346e9b1894488 = (sidebarConfig, legacyId, partialMatch = false)=>sidebarConfig && sidebarConfig.product && $90215f5482fce08d$var$findLink(sidebarConfig.product.links, legacyId, partialMatch) || undefined;
    const $90215f5482fce08d$export$57dd40eec4c64521 = (sidebarConfig, legacyId, partialMatch)=>Boolean($90215f5482fce08d$export$f62346e9b1894488(sidebarConfig, legacyId, partialMatch));
    const $90215f5482fce08d$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
            if (item.id === legacyId) return item.links;
            return item.links && $90215f5482fce08d$var$findChildLinks(item.links, legacyId);
        }).find(Boolean);
    const $90215f5482fce08d$export$9b7e0e4dd8bfade8 = (sidebarConfig, legacyId)=>{
        const links = legacyId != null ? $90215f5482fce08d$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
        return links || [];
    };
});
parcelRegister("7NH5Y", function(module, exports) {
    $parcel$export(module.exports, "connectPrefix", ()=>$a36a125359bfc961$export$196d83ebd873fb40);
    $parcel$export(module.exports, "jsdConnectPrefix", ()=>$a36a125359bfc961$export$7fac8f726f52d70);
    $parcel$export(module.exports, "connectSections", ()=>$a36a125359bfc961$export$b1c2c1fc5d10280);
    var $kvHKs;
    const $a36a125359bfc961$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
    const $a36a125359bfc961$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
    const $a36a125359bfc961$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
    const $a36a125359bfc961$var$jsdQueuesConnectSection = 'sd-queues-addons';
    const $a36a125359bfc961$export$b1c2c1fc5d10280 = [
        $a36a125359bfc961$var$legacyAddonPanelLinkId,
        (0, (0, parcelRequire("kvHKs")).REPORTS_IDS).REPORTS_ADDONS,
        $a36a125359bfc961$var$jsdQueuesConnectSection
    ];
});
parcelRegister("5W6pd", function(module, exports) {
    $parcel$export(module.exports, "transformLink", ()=>$1efacbf40a7b73c8$export$5a32dc366b1d641f);
    $parcel$export(module.exports, "transformLinkV4", ()=>$1efacbf40a7b73c8$export$27267b6b6650eaa5);
    const $1efacbf40a7b73c8$export$5a32dc366b1d641f = (link)=>{
        const items = link.links && link.links.length ? link.links.map($1efacbf40a7b73c8$export$5a32dc366b1d641f).filter(Boolean) : undefined;
        if (link.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(link.name)
            };
            return {
                id: link.id,
                name: String(link.name),
                section: !!link.section,
                items: items
            };
        }
        return {
            id: link.id,
            name: String(link.name),
            url: link.url,
            iconUrl: link.iconUrl || '',
            styleClass: link.styleClass || '',
            items: items
        };
    };
    const $1efacbf40a7b73c8$export$27267b6b6650eaa5 = (data)=>{
        const items = data.links && data.links.length ? data.links.map($1efacbf40a7b73c8$export$27267b6b6650eaa5).filter(Boolean) : undefined;
        if (data.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(data.name)
            };
            return {
                id: data.id,
                name: String(data.name),
                section: !!data.section,
                items: items
            };
        }
        return {
            id: data.id,
            name: String(data.name),
            url: data.url,
            iconUrl: data.iconUrl || '',
            styleClass: data.styleClass || '',
            items: items
        };
    };
});
parcelRegister("gJkov", function(module, exports) {
    $parcel$export(module.exports, "extractData", ()=>$63e1d07edc3ef769$export$9df5fa0a366163d2);
    var $83mn0;
    const $63e1d07edc3ef769$export$9df5fa0a366163d2 = (data, isDevMode, isAdmin)=>({
            hasGeneralConfiguration: isAdmin,
            hasDarkFeatures: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'dark_features'),
            hasTroubleshootingAndSupportSection: isAdmin,
            hasViewAuditing: isAdmin,
            hasPluginViewer: isDevMode && isAdmin,
            hasModulesViewer: isDevMode && isAdmin,
            hasSystemInfo: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'system_info'),
            hasIntegrityChecker: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'integrity_checker'),
            hasLoggingProfiling: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'logging_profiling'),
            hasSchedulerDetails: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'scheduler_details'),
            hasSecuritySection: isAdmin,
            hasProjectRoles: isAdmin,
            hasGlobalPermissions: isAdmin,
            hasCollectors: isAdmin,
            hasUserInterfaceSection: isAdmin,
            hasUserDefaults: isAdmin,
            hasEditDefaultDashboard: isAdmin,
            hasLookAndFeel: isAdmin,
            hasPasAdmin: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'com.atlassian.pas:pas-admin-link-jira'),
            hasImportExportSection: isAdmin,
            hasBackupManager: isAdmin,
            hasExternalImport: isAdmin,
            hasRestoreSystem: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'vertigo_import'),
            hasCloudImport: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'vertigo_import_jira_cloud'),
            hasServerImport: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'vertigo_import_jira_server'),
            hasMailSection: isAdmin,
            hasGlobalMailSettings: isAdmin,
            hasOutgoingMail: isAdmin,
            hasIncomingMail: isAdmin,
            hasSendMail: isAdmin,
            hasAdminHelperSection: isAdmin,
            hasPermissionHelper: isAdmin,
            hasSharedSection: isAdmin,
            hasManageDashboards: isAdmin,
            hasManageFilters: isAdmin,
            hasAdvancedSection: isAdmin,
            hasAttachments: isAdmin,
            hasEvents: isAdmin,
            hasWebHooks: isAdmin,
            hasServices: isAdmin,
            hasLexoRankManagement: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'greenhopper-lexorank-manage')
        });
});
parcelRegister("aVTmi", function(module, exports) {
    $parcel$export(module.exports, "AdminHelperSection", ()=>$f6a1ba8c0486741e$export$4855b2d78f0d666a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jZ4fr;
    var $5Fk4Z;
    var $dC5iT;
    var $8CUq3;
    var $gjTBi;
    var $bWqXX;
    var $co1wz;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $3B8mV;
    const $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY = 'blocking-invitations-log-spotlight';
    const $f6a1ba8c0486741e$export$4855b2d78f0d666a = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("3B8mV")).default).adminHelper)
        }, features.hasPermissionHelper && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'permission-helper'
            },
            href: navigationPath.adminHelperPermissionHelper,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("3B8mV")).default).permissionHelper)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'email-notifications-log'
            },
            href: navigationPath.adminHelperEmailNotificationsLogHelper,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f6a1ba8c0486741e$var$emailNotificationsLogContainerStyles
        }, (0, (0, parcelRequire("co1wz")).ff)('platform.jlove-pulsar.jlovep-1538-notification-email-log-filters_4p0s1') ? formatMessage((0, (0, parcelRequire("3B8mV")).default).adminEmailAuditNotificationsLog) : formatMessage((0, (0, parcelRequire("3B8mV")).default).emailNotificationsLog))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jZ4fr")).EngagementSpotlight), {
            engagementId: $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
        })));
    };
    const $f6a1ba8c0486741e$var$emailNotificationsLogContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'space-between'
    });
});
parcelRegister("3B8mV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82b0a510e0e13823$export$2e2bcd8739ae039);
    var $7VHMR;
    var $82b0a510e0e13823$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        adminHelper: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-helper",
            "defaultMessage": "Admin helper"
        },
        permissionHelper: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.permission-helper",
            "defaultMessage": "Permission helper"
        },
        emailNotificationsLog: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.email-notifications-log",
            "defaultMessage": "Unblock user invites"
        },
        adminEmailAuditNotificationsLog: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-email-audit-notifications-log",
            "defaultMessage": "Admin email audit"
        }
    });
});
parcelRegister("cip1u", function(module, exports) {
    $parcel$export(module.exports, "AdvancedSection", ()=>$55fa8f6cf375a533$export$32bea920eaad7efb);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $68MUk;
    const $55fa8f6cf375a533$export$32bea920eaad7efb = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("68MUk")).default).advanced)
        }, features.hasAttachments && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'attachments'
            },
            href: navigationPath.advancedSectionAttachments,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("68MUk")).default).attachments)), features.hasEvents && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'events'
            },
            href: navigationPath.advancedSectionEvents,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("68MUk")).default).events)), features.hasWebHooks && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'webhooks'
            },
            href: navigationPath.advancedSectionWebHooks,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("68MUk")).default).webhooks)), features.hasLexoRankManagement && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'lexorank-management'
            },
            href: navigationPath.advancedLexoRankManagement,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("68MUk")).default).lexorankManagement)));
    };
});
parcelRegister("68MUk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$24a7ac619834e463$export$2e2bcd8739ae039);
    var $7VHMR;
    var $24a7ac619834e463$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        advanced: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.advanced",
            "defaultMessage": "Advanced"
        },
        attachments: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.attachments",
            "defaultMessage": "Attachments"
        },
        events: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.events",
            "defaultMessage": "Events"
        },
        webhooks: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.webhooks",
            "defaultMessage": "WebHooks"
        },
        lexorankManagement: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.lexorank-management",
            "defaultMessage": "LexoRank management"
        }
    });
});
parcelRegister("8wyB3", function(module, exports) {
    $parcel$export(module.exports, "AutomationSection", ()=>$ae233f5e809ec072$export$5fa01e4d25d8e6ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $65Ltd;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $6tKa8;
    const $ae233f5e809ec072$export$5fa01e4d25d8e6ec = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("6tKa8")).default).automationGroup)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'automation'
            },
            href: navigationPath.globalAutomation,
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SETTINGS_AUTOMATION)
            ]
        }, formatMessage((0, (0, parcelRequire("6tKa8")).default).globalAutomation)));
    };
});
parcelRegister("6tKa8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1b0e49ecb7c48dd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b1b0e49ecb7c48dd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        automationGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.automation.automation-group",
            "defaultMessage": "Automation"
        },
        globalAutomation: {
            "id": "spa-apps-sidebar-global-settings-system.menu.automation.global-automation",
            "defaultMessage": "Global automation"
        }
    });
});
parcelRegister("230Wm", function(module, exports) {
    $parcel$export(module.exports, "ImportExportSection", ()=>$45f1c30d97953942$export$2e4cb1dc5b398447);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $2vSU6;
    var $co1wz;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $9OXo1;
    var $jMBA3;
    var $8136S;
    const $45f1c30d97953942$export$2e4cb1dc5b398447 = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { isSiteAdmin: isSiteAdmin, isAdmin: isAdmin, licensedProducts: licensedProducts } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        const hasSupportedLicense = licensedProducts[(0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)((0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT))] || licensedProducts[(0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)((0, (0, parcelRequire("2vSU6")).CORE_PROJECT))];
        const showNewExternalImport = hasSupportedLicense && (isSiteAdmin || !isAdmin || (0, (0, parcelRequire("co1wz")).ff)('enable-product-admin-for-x2c-migration_zmlsv'));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("8136S")).default).importExportGroup)
        }, features.hasBackupManager && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'cloud-export'
            },
            href: navigationPath.importSectionBackupManager,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("8136S")).default).backupManager)), features.hasExternalImport && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'external-import'
            },
            href: showNewExternalImport ? navigationPath.importSectionExternalImportNew : navigationPath.importSectionExternalImport,
            selectedOn: (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || showNewExternalImport && currentLocation.pathname.includes(navigationPath.importSectionExternalImport)
        }, formatMessage((0, (0, parcelRequire("8136S")).default).externalImport)), features.hasCloudImport && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'cloud-import'
            },
            href: navigationPath.importSectionCloudImport,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlExact)()
        }, formatMessage((0, (0, parcelRequire("8136S")).default).importJiraCloud)), features.hasServerImport && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'server-import'
            },
            href: navigationPath.importSectionServerImport,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlExact)()
        }, formatMessage((0, (0, parcelRequire("8136S")).default).importJiraServer)));
    };
});
parcelRegister("8136S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e31be53e6f399aac$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e31be53e6f399aac$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        importExportGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-export-group",
            "defaultMessage": "Import and export"
        },
        backupManager: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.backup-manager",
            "defaultMessage": "Backup manager"
        },
        externalImport: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.external-import",
            "defaultMessage": "External System Import"
        },
        restoreSystem: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.restore-system",
            "defaultMessage": "Restore system"
        },
        importJiraCloud: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-cloud",
            "defaultMessage": "Import Jira Cloud"
        },
        importJiraServer: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-server",
            "defaultMessage": "Import Jira Server"
        }
    });
});
parcelRegister("je2KE", function(module, exports) {
    $parcel$export(module.exports, "MailSection", ()=>$6a76fa07c85a01a9$export$6e0cda39522c0aa7);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $1c6JR;
    var $gb7H7;
    const $6a76fa07c85a01a9$export$6e0cda39522c0aa7 = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("1c6JR")).default).mailGroup)
        }, features.hasGlobalMailSettings && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'global-mail-settings'
            },
            href: navigationPath.mailSectionGlobalMailSettings,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("1c6JR")).default).globalMailSettings)), features.hasOutgoingMail && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'outgoing-mail'
            },
            href: navigationPath.mailSectionOutgoingMail,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("1c6JR")).default).outgoingMail)), features.hasIncomingMail && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'incoming-mail'
            },
            href: navigationPath.mailSectionIncomingMail,
            selectedOn: (0, (0, parcelRequire("gb7H7")).isIncomingMailSelected)
        }, formatMessage((0, (0, parcelRequire("1c6JR")).default).incomingMail)), features.hasSendMail && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'send-email'
            },
            href: navigationPath.mailSectionSendMail,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("1c6JR")).default).sendEmail)));
    };
});
parcelRegister("1c6JR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa5900167b5101d6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fa5900167b5101d6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        mailGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.mail-group",
            "defaultMessage": "Mail"
        },
        globalMailSettings: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.global-mail-settings",
            "defaultMessage": "Global Mail Settings"
        },
        outgoingMail: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.outgoing-mail",
            "defaultMessage": "Outgoing Mail"
        },
        incomingMail: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.incoming-mail",
            "defaultMessage": "Incoming Mail"
        },
        sendEmail: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.send-email",
            "defaultMessage": "Send email"
        }
    });
});
parcelRegister("gb7H7", function(module, exports) {
    $parcel$export(module.exports, "isIncomingMailSelected", ()=>$d695081436bd6a1d$export$3f53f72603975cb0);
    var $4OCke;
    const $d695081436bd6a1d$var$INCOMING_MAIL_PATH_REGEXP = /\/admin\/(\w+)Pop(Mail)?Server/i;
    const $d695081436bd6a1d$export$3f53f72603975cb0 = (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || $d695081436bd6a1d$var$INCOMING_MAIL_PATH_REGEXP.test(currentLocation.pathname);
});
parcelRegister("iAlf2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$979d16a4bf22949b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $979d16a4bf22949b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        systemGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.system-group",
            "defaultMessage": "System"
        },
        generalConfiguration: {
            "id": "spa-apps-sidebar-global-settings-system.menu.general-configuration",
            "defaultMessage": "General configuration"
        },
        darkFeatures: {
            "id": "spa-apps-sidebar-global-settings-system.menu.dark-features",
            "defaultMessage": "Dark features"
        },
        issueCollectors: {
            "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors",
            "defaultMessage": "Issue collectors"
        },
        globalSettingsSystemSidebarLabel: {
            "id": "spa-apps-sidebar-global-settings-system.menu.global-settings-system-sidebar-label",
            "defaultMessage": "Side"
        }
    });
});
parcelRegister("fwlYA", function(module, exports) {
    $parcel$export(module.exports, "SecuritySection", ()=>$76b3d515542acad4$export$4f16aec1633bed7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $eTPZ8;
    var $icmgW;
    const $76b3d515542acad4$export$4f16aec1633bed7d = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        const globalPermissionsPath = navigationPath.securityGlobalPermissions;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("eTPZ8")).default).securityGroup)
        }, features.hasProjectRoles && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'project-roles'
            },
            href: navigationPath.securityProjectRoles,
            selectedOn: (0, (0, parcelRequire("icmgW")).isProjectRolesSelected)
        }, formatMessage((0, (0, parcelRequire("eTPZ8")).default).projectRoles)), features.hasGlobalPermissions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'global-permissions'
            },
            href: globalPermissionsPath,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("eTPZ8")).default).globalPermissions)));
    };
});
parcelRegister("eTPZ8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db51b59205472bbf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $db51b59205472bbf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        securityGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.security.security-group",
            "defaultMessage": "Security"
        },
        projectRoles: {
            "id": "spa-apps-sidebar-global-settings-system.menu.security.project-roles",
            "defaultMessage": "Project roles"
        },
        globalPermissions: {
            "id": "spa-apps-sidebar-global-settings-system.menu.security.global-permissions",
            "defaultMessage": "Global permissions"
        }
    });
});
parcelRegister("icmgW", function(module, exports) {
    $parcel$export(module.exports, "isProjectRolesSelected", ()=>$f6a84fa88243c239$export$ca9501e7fedfce90);
    var $4OCke;
    const $f6a84fa88243c239$var$PROJECT_ROLES_PATH_REGEXP = /\/project\/(\w+)ProjectRole/i;
    const $f6a84fa88243c239$export$ca9501e7fedfce90 = (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || $f6a84fa88243c239$var$PROJECT_ROLES_PATH_REGEXP.test(currentLocation.pathname);
});
parcelRegister("9O5DC", function(module, exports) {
    $parcel$export(module.exports, "SharedSection", ()=>$440640fab2704f98$export$230e518497f06fdc);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $hw0ew;
    const $440640fab2704f98$export$230e518497f06fdc = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("hw0ew")).default).sharedItems)
        }, features.hasManageFilters && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'manage-filters'
            },
            href: navigationPath.sharedSectionManageFilters,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("hw0ew")).default).filters)), features.hasManageDashboards && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'manage-dashboards'
            },
            href: navigationPath.sharedManageDashboards,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("hw0ew")).default).dashboards)));
    };
});
parcelRegister("hw0ew", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a51482729945d2e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4a51482729945d2e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sharedItems: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-items",
            "defaultMessage": "Shared Items"
        },
        sharedFilters: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-filters",
            "defaultMessage": "Shared filters"
        },
        sharedDashboards: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-dashboards",
            "defaultMessage": "Shared dashboards"
        },
        filters: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.filters",
            "defaultMessage": "Filters"
        },
        dashboards: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.dashboards",
            "defaultMessage": "Dashboards"
        }
    });
});
parcelRegister("1y2CG", function(module, exports) {
    $parcel$export(module.exports, "TroubleshootingAndSupportSection", ()=>$5fd448f06aadda25$export$dad01649916e6a2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $koVbs;
    var $k0ZZ2;
    var $fRwoF;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $4oL80;
    var $81Iv5;
    var $ie4oV;
    const $5fd448f06aadda25$export$dad01649916e6a2d = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { hasSiteOptimizerEntitlement: hasSiteOptimizerEntitlement } = (0, (0, parcelRequire("fRwoF")).useSiteOptimizerCheck)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("4oL80")).default).troubleshootingGroup)
        }, features.hasViewAuditing && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'view-auditing'
            },
            href: navigationPath.troubleshootingAuditLog,
            selectedOn: (0, (0, parcelRequire("ie4oV")).isViewAuditingSelected)
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).auditLog)), features.hasPluginViewer && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'plugin-viewer'
            },
            href: navigationPath.troubleshootingPluginViewer,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).pluginViewer)), features.hasModulesViewer && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'modules-viewer'
            },
            href: navigationPath.troubleshootingModulesViewer,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).modulesViewer)), features.hasSystemInfo && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'system-info'
            },
            href: navigationPath.troubleshootingSystemInfo,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).systemInfo)), features.hasIntegrityChecker && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'integrity-checker'
            },
            href: navigationPath.troubleshootingIntegrityChecker,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).integrityChecker)), features.hasLoggingProfiling && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'logging-profiling'
            },
            href: navigationPath.troubleshootingLoggingProfiling,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).loggingProfiling)), features.hasSchedulerDetails && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'scheduler-details'
            },
            href: navigationPath.troubleshootingSchedulerDetails,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).schedulerDetails)), hasSiteOptimizerEntitlement && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81Iv5")).PerformanceMenuItem), null));
    };
});
parcelRegister("fRwoF", function(module, exports) {
    $parcel$export(module.exports, "useSiteOptimizerCheck", ()=>$31e8f2ad3b3f051f$export$7df80afc329cd61);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $eusud;
    const $31e8f2ad3b3f051f$export$e9921a980669184 = ()=>(0, (0, parcelRequire("eusud")).performGetRequest)('/rest/internal/psi/latest/licence/check');
    const $31e8f2ad3b3f051f$export$7df80afc329cd61 = ()=>{
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const [hasEntitlement, setHasEntitlement] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)();
        const fetch = async ()=>{
            try {
                setLoading(true);
                setError(undefined);
                if ((0, (0, parcelRequire("co1wz")).ff)('override-enable-performance-and-scale-admin-menu')) setHasEntitlement(true);
                else {
                    const data = await $31e8f2ad3b3f051f$export$e9921a980669184();
                    setHasEntitlement(data?.isVisible ?? false);
                }
                setLoading(false);
            } catch (apiError) {
                setLoading(false);
                setError(apiError);
            }
        };
        (0, $5uXOq.useEffect)(()=>{
            fetch();
        }, []);
        return {
            loading: loading,
            hasSiteOptimizerEntitlement: hasEntitlement,
            error: error
        };
    };
});
parcelRegister("4oL80", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ca98bc392d099f0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9ca98bc392d099f0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        troubleshootingGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.troubleshooting-group",
            "defaultMessage": "Troubleshooting and Support"
        },
        auditLog: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.audit-log",
            "defaultMessage": "Audit Log"
        },
        pluginViewer: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.plugin-viewer",
            "defaultMessage": "Plugin Viewer"
        },
        modulesViewer: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.modules-viewer",
            "defaultMessage": "Modules Viewer"
        },
        systemInfo: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.system-info",
            "defaultMessage": "System info"
        },
        integrityChecker: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.integrity-checker",
            "defaultMessage": "Integrity checker"
        },
        loggingProfiling: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.logging-profiling",
            "defaultMessage": "Logging profiling"
        },
        schedulerDetails: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.scheduler-details",
            "defaultMessage": "Scheduler details"
        }
    });
});
parcelRegister("81Iv5", function(module, exports) {
    $parcel$export(module.exports, "PerformanceMenuItem", ()=>$ca611bfc0be59ae0$export$b4e98631ff0b3fb5);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $imZsD;
    var $5Fk4Z;
    var $1QiBP;
    var $dC5iT;
    var $kgoHi;
    var $koVbs;
    var $kZj7F;
    var $17bH5;
    var $8zOmE;
    var $ehdJY;
    var $90yGq;
    var $eaZ4X;
    var $1ssva;
    var $iWjQg;
    var $fM231;
    const $ca611bfc0be59ae0$export$b4e98631ff0b3fb5 = ()=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOptimiserSpotlightActive, setIsOptimiserSpotlightActive] = (0, $5uXOq.useState)(false);
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        const BackMenuItem = {
            href: '/jira/settings/system/general-configuration',
            title: formatMessage((0, (0, parcelRequire("1ssva")).default).itemBack)
        };
        const fetchSpotlightState = (0, $5uXOq.useCallback)(async ()=>{
            if (accountId != null) {
                const response = await (0, (0, parcelRequire("fM231")).hasSeenSiteOptimiserSpotlight)(accountId);
                setIsOptimiserSpotlightActive(!response);
            }
        }, [
            accountId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            fetchSpotlightState();
        }, [
            fetchSpotlightState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: "site-optimiser-spotlight"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            analytics: {
                itemId: 'performance-and-scale'
            },
            href: navigationPath.troubleshootingPerformanceAndScale,
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                gap: "space.050",
                justifyContent: "start",
                alignItems: "center"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, formatMessage((0, (0, parcelRequire("1ssva")).default).performanceAndScale)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                appearance: "new"
            }, formatMessage((0, (0, parcelRequire("1ssva")).default).beta))),
            overrides: {
                BackMenuItem: BackMenuItem
            },
            id: (0, (0, parcelRequire("eaZ4X")).SECTION_ID).PERFORMANCE_AND_SCALE
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iWjQg")).PerformanceAndScaleMenu), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1QiBP")).default), null, isOptimiserSpotlightActive && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            actions: [
                {
                    onClick: (_, analyticsEvent)=>{
                        setIsOptimiserSpotlightActive(false);
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'performanceMenuItemSpotlightComplete');
                    },
                    text: formatMessage((0, (0, parcelRequire("1ssva")).default).spotlightAction)
                }
            ],
            heading: formatMessage((0, (0, parcelRequire("1ssva")).default).spotlightHeading),
            target: "site-optimiser-spotlight",
            key: "site-optimiser-spotlight",
            targetRadius: 3,
            targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            dialogPlacement: "right top",
            messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.jira-spotlight.site-optimiser-spotlight",
            messageType: "engagement"
        }, formatMessage((0, (0, parcelRequire("1ssva")).default).spotlightBody))));
    };
});
parcelRegister("ehdJY", function(module, exports) {
    $parcel$export(module.exports, "JiraSpotlight", ()=>$61a8dc1ff1116911$export$e209c6be9ab8c4f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $7gs1W;
    var $10xFf;
    var $5NHqU;
    const $61a8dc1ff1116911$export$e209c6be9ab8c4f4 = (props)=>{
        if ((0, (0, parcelRequire("10xFf")).shouldBeChoreographed)(props)) {
            const { messageType: messageType, ...rest } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5NHqU")).ChoreographerSpotlight), rest);
        }
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7gs1W")).default), rest);
    };
});
parcelRegister("10xFf", function(module, exports) {
    $parcel$export(module.exports, "shouldBeChoreographed", ()=>$36201c75b4df20a7$export$a8ba9111c7eec9ac);
    $parcel$export(module.exports, "environmentToEnvType", ()=>$36201c75b4df20a7$export$e2cf19200849be9e);
    var $iZhen;
    var $t6tX9;
    function $36201c75b4df20a7$export$a8ba9111c7eec9ac(props) {
        return !!props?.messageType && (0, (0, parcelRequire("t6tX9")).IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
    }
    function $36201c75b4df20a7$export$e2cf19200849be9e(environment) {
        switch(environment){
            case 'dev':
                return (0, (0, parcelRequire("iZhen")).envType).DEV;
            case 'staging':
                return (0, (0, parcelRequire("iZhen")).envType).STAGING;
            case 'prod':
                return (0, (0, parcelRequire("iZhen")).envType).PROD;
            default:
                return (0, (0, parcelRequire("iZhen")).envType).LOCAL;
        }
    }
});
parcelRegister("t6tX9", function(module, exports) {
    $parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", ()=>$b5642a17fa90b00d$export$dbe9e38c9d6f26d0);
    const $b5642a17fa90b00d$export$94e85cf3348f045a = {
        ENGAGEMENT: 'engagement',
        MARKETING: 'marketing',
        TRANSACTIONAL: 'transactional'
    };
    const $b5642a17fa90b00d$export$dbe9e38c9d6f26d0 = [
        $b5642a17fa90b00d$export$94e85cf3348f045a.ENGAGEMENT,
        $b5642a17fa90b00d$export$94e85cf3348f045a.MARKETING
    ];
});
parcelRegister("5NHqU", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerSpotlight", ()=>$b7d2a49fe3b12822$export$e01943d134357d00);
    var $7gs1W;
    var $cSWNW;
    const $b7d2a49fe3b12822$export$e01943d134357d00 = (0, (0, parcelRequire("cSWNW")).withChoreographedRender)((0, (0, parcelRequire("7gs1W")).default));
});
parcelRegister("cSWNW", function(module, exports) {
    $parcel$export(module.exports, "withChoreographedRender", ()=>$620c1a9f3fec1a68$export$c1160fdac17030e);
    var $5uXOq = parcelRequire("5uXOq");
    var $fG5AJ;
    function $620c1a9f3fec1a68$export$c1160fdac17030e(Component, options) {
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
            const shouldRender = (0, (0, parcelRequire("fG5AJ")).useChoreographedRender)({
                messageId: messageId,
                onMessageDisposition: onMessageDisposition
            });
            if (shouldRender) return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props);
            if (options && options.toggleableProp) {
                const toggleableComponentProps = {
                    ...props,
                    [options.toggleableProp]: false
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, toggleableComponentProps);
            }
            return null;
        }
        ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
        return ChoreographedComponent;
    }
});
parcelRegister("fG5AJ", function(module, exports) {
    $parcel$export(module.exports, "getPendoPlugin", ()=>$596f0fde3f3a2d5a$export$3d3a86b2d636214b);
    $parcel$export(module.exports, "useChoreographer", ()=>$596f0fde3f3a2d5a$export$9f0e2488ffd90f11);
    $parcel$export(module.exports, "ChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    $parcel$export(module.exports, "useChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$2eb1efa814fe4a);
    $parcel$export(module.exports, "useChoreographedRender", ()=>$596f0fde3f3a2d5a$export$2cfd68294be82811);
    var $5uXOq = parcelRequire("5uXOq");
    var $4zICj;
    var $8r6xd;
    var $TTRxY;
    var $j8DrX;
    var $7qPn9;
    const $596f0fde3f3a2d5a$var$environment = (0, (0, parcelRequire("7qPn9")).toEnvironment)((0, (0, parcelRequire("j8DrX")).default)('ajs-environment')) ?? 'prod';
    const $596f0fde3f3a2d5a$var$createChoreographerFactory = ()=>{
        if (false) return {
            useChoreographer: (..._)=>({
                    startMessage: ()=>Promise.resolve(''),
                    stopMessage: ()=>{}
                })
        };
        return (0, (0, parcelRequire("4zICj")).choreographerFactory)((0, (0, parcelRequire("TTRxY")).ProductIds).JIRA, $596f0fde3f3a2d5a$var$environment);
    };
    let $596f0fde3f3a2d5a$var$pendoPlugin;
    function $596f0fde3f3a2d5a$export$3d3a86b2d636214b(env) {
        if (!$596f0fde3f3a2d5a$var$pendoPlugin) $596f0fde3f3a2d5a$var$pendoPlugin = new (0, (0, parcelRequire("8r6xd")).PendoChoreographerPlugin)(env, {
            sourceProductId: (0, (0, parcelRequire("TTRxY")).ProductIds).JIRA
        });
        return $596f0fde3f3a2d5a$var$pendoPlugin;
    }
    const { useChoreographer: $596f0fde3f3a2d5a$export$9f0e2488ffd90f11 } = $596f0fde3f3a2d5a$var$createChoreographerFactory();
    const $596f0fde3f3a2d5a$export$3ff96dbefca6b00d = (0, $5uXOq.createContext)({
        isAlreadyChoreographedAtAncestor: false
    });
    const $596f0fde3f3a2d5a$export$2eb1efa814fe4a = ()=>(0, $5uXOq.useContext)($596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    const $596f0fde3f3a2d5a$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $596f0fde3f3a2d5a$export$2eb1efa814fe4a();
        const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = $596f0fde3f3a2d5a$export$9f0e2488ffd90f11(messageId, {
            start: ()=>setShouldRender(true)
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!isAlreadyChoreographedAtAncestor) {
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                startMessageAsync();
                return ()=>{
                    stopMessage();
                };
            }
        }, [
            onMessageDisposition,
            startMessage,
            stopMessage,
            isAlreadyChoreographedAtAncestor
        ]);
        return shouldRender || isAlreadyChoreographedAtAncestor;
    };
});
parcelRegister("90yGq", function(module, exports) {
    $parcel$export(module.exports, "useAccountId", ()=>$903db0de2618ef6c$export$e72033e0f5baa3e);
    var $9OXo1;
    const $903db0de2618ef6c$export$e72033e0f5baa3e = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.atlassianAccountId || null;
    };
});
parcelRegister("1ssva", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46da0b37092f9f6a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $46da0b37092f9f6a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        performanceAndScale: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale",
            "defaultMessage": "Site optimizer"
        },
        itemBack: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.item-back",
            "defaultMessage": "Back to system"
        },
        spotlightHeading: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-heading",
            "defaultMessage": "Clean up your site"
        },
        spotlightBody: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-body",
            "defaultMessage": "Remove old data that might be slowing down your site in a few clicks."
        },
        spotlightAction: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-action",
            "defaultMessage": "Ok"
        },
        beta: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.beta",
            "defaultMessage": "Beta"
        }
    });
});
parcelRegister("iWjQg", function(module, exports) {
    $parcel$export(module.exports, "PerformanceAndScaleMenu", ()=>$4bb22b80a7726eba$export$442d4ccb0d25fc50);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Fk4Z;
    var $gjTBi;
    var $lzUDm;
    var $fgWYz;
    var $koVbs;
    var $k0ZZ2;
    var $3OGaE;
    var $4OCke;
    var $etuUp;
    var $jWIOc;
    const $4bb22b80a7726eba$export$442d4ccb0d25fc50 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const basePerformanceUrl = '/jira/settings/system/performance';
        const allVisibleMetrics = (0, (0, parcelRequire("fgWYz")).getAllVisibleMetrics)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("etuUp")).default).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'performance-overview'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${basePerformanceUrl}/overview`
        }, formatMessage((0, (0, parcelRequire("etuUp")).default).overview))), allVisibleMetrics.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("etuUp")).default).allReports)
        }, allVisibleMetrics.map((metric)=>{
            if (metric.key === (0, (0, parcelRequire("lzUDm")).PROJECT_CLEANUP_KEY)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: "project-cleanup-item"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
                name: (0, (0, parcelRequire("jWIOc")).PROJECT_CLEANUP_SPOTLIGHT_NAME)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                analytics: {
                    itemId: `performance-metric-${metric.key}`
                },
                href: `${basePerformanceUrl}/metrics/${metric.key}`,
                selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
                key: metric.key
            }, formatMessage(metric.name))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jWIOc")).ProjectCleanupSpotlight), null));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                analytics: {
                    itemId: `performance-metric-${metric.key}`
                },
                href: `${basePerformanceUrl}/metrics/${metric.key}`,
                selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
                key: metric.key
            }, formatMessage(metric.name));
        })));
    };
});
parcelRegister("lzUDm", function(module, exports) {
    $parcel$export(module.exports, "PROJECT_CLEANUP_KEY", ()=>$3bfe695ee69b7be4$export$4e9bf1d386c2f0c);
    $parcel$export(module.exports, "PROJECT_CLEANUP", ()=>$3bfe695ee69b7be4$export$761acf34bef3a717);
    var $iHO6d;
    const $3bfe695ee69b7be4$export$4e9bf1d386c2f0c = 'projectcleanup';
    const $3bfe695ee69b7be4$export$761acf34bef3a717 = {
        key: $3bfe695ee69b7be4$export$4e9bf1d386c2f0c,
        visible: true,
        name: (0, (0, parcelRequire("iHO6d")).default).nameNonFinal,
        description: (0, (0, parcelRequire("iHO6d")).default).descriptionNonFinal,
        tabLabels: [
            (0, (0, parcelRequire("iHO6d")).default).analysisNonFinal,
            (0, (0, parcelRequire("iHO6d")).default).activityLogNonFinal
        ],
        warningMessage: (0, (0, parcelRequire("iHO6d")).default).warningNonFinal,
        exceededMessage: (0, (0, parcelRequire("iHO6d")).default).exceededNonFinal,
        risks: [],
        mitigations: [],
        currentValueLabel: (0, (0, parcelRequire("iHO6d")).default).currentValueLabel,
        cleanupValueLabel: (0, (0, parcelRequire("iHO6d")).default).cleanupValueLabel,
        graphHeader: (0, (0, parcelRequire("iHO6d")).default).graphHeader,
        recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-the-number-of-projects-in-your-site/',
        recommendationUrlText: (0, (0, parcelRequire("iHO6d")).default).recommendationUrlText
    };
});
parcelRegister("iHO6d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$622f291bdb5f6890$export$2e2bcd8739ae039);
    var $7VHMR;
    const $622f291bdb5f6890$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
    const $622f291bdb5f6890$var$DESCRIPTION_DESC = 'Description of the site optimizer metric.';
    const $622f291bdb5f6890$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
    const $622f291bdb5f6890$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
    const $622f291bdb5f6890$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
    const $622f291bdb5f6890$var$CLEANUP_VALUE_LABEL_DESC = 'Label to be shown next to the cleanup value of the metric.';
    const $622f291bdb5f6890$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
    const $622f291bdb5f6890$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
    var $622f291bdb5f6890$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        nameNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.name-non-final",
            "defaultMessage": "Projects"
        },
        descriptionNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.description-non-final",
            "defaultMessage": "Below, we\u2019ve identified company-managed and team-managed projects in your site that can be archived or trashed because they contain no issues. Removing these projects can improve site performance and stability."
        },
        recommendationUrlText: {
            "id": "admin-pages-performance.common.assets.project-cleanup.recommendation-url-text",
            "defaultMessage": "See how we identify these projects."
        },
        analysisNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.analysis-non-final",
            "defaultMessage": "Analysis"
        },
        activityLogNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.activity-log-non-final",
            "defaultMessage": "Activity log"
        },
        graphHeader: {
            "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
            "defaultMessage": "Projects over time"
        },
        warningNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.warning-non-final",
            "defaultMessage": "The number of projects is nearing our recommended threshold."
        },
        exceededNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.exceeded-non-final",
            "defaultMessage": "There are some project..."
        },
        currentValueLabel: {
            "id": "admin-pages-performance.common.assets.project-cleanup.current-value-label",
            "defaultMessage": "Projects in your site"
        },
        cleanupValueLabel: {
            "id": "admin-pages-performance.common.assets.project-cleanup.cleanup-value-label",
            "defaultMessage": "Recommended for cleanup"
        }
    });
});
parcelRegister("fgWYz", function(module, exports) {
    $parcel$export(module.exports, "getAllVisibleMetrics", ()=>$2cc6642f29a0adee$export$e6140fda06493d18);
    $parcel$export(module.exports, "getMetric", ()=>$2cc6642f29a0adee$export$ed0dc1178a679c67);
    $parcel$export(module.exports, "getAllVisibleMetricKeys", ()=>$2cc6642f29a0adee$export$1f2abf3e170d35d2);
    $parcel$export(module.exports, "assertNever", ()=>$2cc6642f29a0adee$export$cbadc5a7223772a8);
    var $4R6GH;
    var $8MHQY;
    var $cOrKR;
    var $lzUDm;
    var $3AEMX;
    var $gtb9f;
    class $2cc6642f29a0adee$export$9419457073a1750 {
        constructor(metrics){
            this.metrics = metrics;
        }
        getMetric(key) {
            return this.metrics.find((m)=>m.key === key);
        }
        getAllVisibleMetrics() {
            return this.metrics.filter((metric)=>metric.visible && $2cc6642f29a0adee$var$mitigationEnabled(metric.key));
        }
        getAllVisibleMetricsKeys() {
            return $2cc6642f29a0adee$export$e6140fda06493d18().map((m)=>m.key);
        }
    }
    const $2cc6642f29a0adee$var$REGISTRY = new $2cc6642f29a0adee$export$9419457073a1750((0, (0, parcelRequire("gtb9f")).METRICS));
    const $2cc6642f29a0adee$export$ed0dc1178a679c67 = $2cc6642f29a0adee$var$REGISTRY.getMetric.bind($2cc6642f29a0adee$var$REGISTRY);
    const $2cc6642f29a0adee$export$e6140fda06493d18 = $2cc6642f29a0adee$var$REGISTRY.getAllVisibleMetrics.bind($2cc6642f29a0adee$var$REGISTRY);
    const $2cc6642f29a0adee$export$1f2abf3e170d35d2 = $2cc6642f29a0adee$var$REGISTRY.getAllVisibleMetricsKeys.bind($2cc6642f29a0adee$var$REGISTRY);
    const $2cc6642f29a0adee$var$mitigationEnabled = (metricKey)=>{
        switch(metricKey){
            case 0, (0, parcelRequire("lzUDm")).PROJECT_CLEANUP_KEY:
                return (0, (0, parcelRequire("4R6GH")).fg)('site-optimizer-project-cleanup');
            case 0, (0, parcelRequire("3AEMX")).PROJECT_ROLE_ACTOR_KEY:
            case 0, (0, parcelRequire("8MHQY")).CUSTOM_FIELDS_KEY:
            case 0, (0, parcelRequire("cOrKR")).ISSUE_KEY:
                return true;
            default:
                return false;
        }
    };
    const $2cc6642f29a0adee$export$cbadc5a7223772a8 = (_, message)=>{
        throw new Error(message);
    };
});
parcelRegister("8MHQY", function(module, exports) {
    $parcel$export(module.exports, "CUSTOM_FIELDS_KEY", ()=>$1dd393ebccb36050$export$d214286a7039b004);
    $parcel$export(module.exports, "CUSTOM_FIELDS", ()=>$1dd393ebccb36050$export$459112111ad5b136);
    var $9TSwz;
    const $1dd393ebccb36050$export$d214286a7039b004 = 'customField';
    const $1dd393ebccb36050$export$459112111ad5b136 = {
        key: $1dd393ebccb36050$export$d214286a7039b004,
        visible: true,
        name: (0, (0, parcelRequire("9TSwz")).default).name,
        description: (0, (0, parcelRequire("9TSwz")).default).description,
        tabLabels: [
            (0, (0, parcelRequire("9TSwz")).default).chart,
            (0, (0, parcelRequire("9TSwz")).default).reviewAndAnalyze
        ],
        warningMessage: (0, (0, parcelRequire("9TSwz")).default).warning,
        exceededMessage: (0, (0, parcelRequire("9TSwz")).default).exceeded,
        risks: [
            (0, (0, parcelRequire("9TSwz")).default).risk1
        ],
        mitigations: [],
        currentValueLabel: (0, (0, parcelRequire("9TSwz")).default).currentValueLabel,
        currentValueAriaLabel: (0, (0, parcelRequire("9TSwz")).default).currentValueAriaLabel,
        thresholdValueLabel: (0, (0, parcelRequire("9TSwz")).default).thresholdValueLabel,
        thresholdValueAriaLabel: (0, (0, parcelRequire("9TSwz")).default).thresholdValueAriaLabel,
        recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-custom-fields/',
        recommendationUrlText: (0, (0, parcelRequire("9TSwz")).default).recommendationUrlText,
        graphHeader: (0, (0, parcelRequire("9TSwz")).default).graphHeader
    };
});
parcelRegister("9TSwz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb4cda92a9b67081$export$2e2bcd8739ae039);
    var $7VHMR;
    const $eb4cda92a9b67081$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
    const $eb4cda92a9b67081$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
    const $eb4cda92a9b67081$var$CHART_DESC = 'A tab label of Custom Field Tabs, to show custom fields chart';
    const $eb4cda92a9b67081$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Custom Field Tabs, to show custom fields review and analyze';
    const $eb4cda92a9b67081$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
    const $eb4cda92a9b67081$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
    const $eb4cda92a9b67081$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
    const $eb4cda92a9b67081$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
    const $eb4cda92a9b67081$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
    const $eb4cda92a9b67081$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
    const $eb4cda92a9b67081$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
    const $eb4cda92a9b67081$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
    var $eb4cda92a9b67081$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        name: {
            "id": "admin-pages-performance.common.assets.custom-fields.name",
            "defaultMessage": "Custom fields"
        },
        description: {
            "id": "admin-pages-performance.common.assets.custom-fields.description",
            "defaultMessage": "Here are the custom fields in your site, including ones we think can be removed because they\u2019re not used. Removing unused fields could improve site performance and stability."
        },
        chart: {
            "id": "admin-pages-performance.common.assets.custom-fields.chart",
            "defaultMessage": "Overview"
        },
        reviewAndAnalyze: {
            "id": "admin-pages-performance.common.assets.custom-fields.review-and-analyze",
            "defaultMessage": "Analysis"
        },
        warning: {
            "id": "admin-pages-performance.common.assets.custom-fields.warning",
            "defaultMessage": "The number of custom fields is nearing our recommended threshold."
        },
        exceeded: {
            "id": "admin-pages-performance.common.assets.custom-fields.exceeded",
            "defaultMessage": "There are more custom fields than our recommended threshold."
        },
        risk1: {
            "id": "admin-pages-performance.common.assets.custom-fields.risk-1",
            "defaultMessage": "Custom fields can make searching for issues (JQL and boards) and creating issues slow."
        },
        mitigation1: {
            "id": "admin-pages-performance.common.assets.custom-fields.mitigation-1",
            "defaultMessage": "Edit the context for the custom field to make it visible only for specific projects."
        },
        mitigation2: {
            "id": "admin-pages-performance.common.assets.custom-fields.mitigation-2",
            "defaultMessage": "Limit the number of custom fields across all projects and use the same custom field in multiple projects."
        },
        currentValueLabel: {
            "id": "admin-pages-performance.common.assets.custom-fields.current-value-label",
            "defaultMessage": "Custom fields in your site"
        },
        thresholdValueLabel: {
            "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-label",
            "defaultMessage": "Recommended maximum number of custom fields"
        },
        currentValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.custom-fields.current-value-aria-label",
            "defaultMessage": "{number} custom fields in your site"
        },
        thresholdValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-aria-label",
            "defaultMessage": "{number} recommended maximum number of custom fields"
        },
        recommendationUrlText: {
            "id": "admin-pages-performance.common.assets.custom-fields.recommendation-url-text",
            "defaultMessage": "See how we identify these fields."
        },
        graphHeader: {
            "id": "admin-pages-performance.common.assets.custom-fields.graph-header",
            "defaultMessage": "Custom fields over time"
        }
    });
});
parcelRegister("cOrKR", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_KEY", ()=>$a0748d951ae09b9b$export$5daa28d10e23592);
    $parcel$export(module.exports, "ISSUE", ()=>$a0748d951ae09b9b$export$76a449e52fa0e1e8);
    var $jWT6h;
    const $a0748d951ae09b9b$export$5daa28d10e23592 = 'issue';
    const $a0748d951ae09b9b$export$76a449e52fa0e1e8 = {
        key: $a0748d951ae09b9b$export$5daa28d10e23592,
        visible: true,
        name: (0, (0, parcelRequire("jWT6h")).default).name,
        description: (0, (0, parcelRequire("jWT6h")).default).description,
        tabLabels: [
            (0, (0, parcelRequire("jWT6h")).default).reviewAndAnalyze,
            (0, (0, parcelRequire("jWT6h")).default).activityLog
        ],
        warningMessage: (0, (0, parcelRequire("jWT6h")).default).warning,
        exceededMessage: (0, (0, parcelRequire("jWT6h")).default).exceeded,
        risks: [
            (0, (0, parcelRequire("jWT6h")).default).risk1
        ],
        mitigations: [
            (0, (0, parcelRequire("jWT6h")).default).mitigation1,
            (0, (0, parcelRequire("jWT6h")).default).mitigation2,
            (0, (0, parcelRequire("jWT6h")).default).mitigation3
        ],
        currentValueLabel: (0, (0, parcelRequire("jWT6h")).default).currentValueLabel,
        currentValueAriaLabel: (0, (0, parcelRequire("jWT6h")).default).currentValueAriaLabel,
        thresholdValueLabel: (0, (0, parcelRequire("jWT6h")).default).thresholdValueLabel,
        thresholdValueAriaLabel: (0, (0, parcelRequire("jWT6h")).default).thresholdValueAriaLabel,
        graphHeader: (0, (0, parcelRequire("jWT6h")).default).graphHeader
    };
});
parcelRegister("jWT6h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5991724b8695ea5$export$2e2bcd8739ae039);
    var $7VHMR;
    const $a5991724b8695ea5$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
    const $a5991724b8695ea5$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
    const $a5991724b8695ea5$var$CHART_DESC = 'A tab label of Issue Tabs, to show Issue chart';
    const $a5991724b8695ea5$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Issue Tabs, to show issue review and analyze';
    const $a5991724b8695ea5$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
    const $a5991724b8695ea5$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
    const $a5991724b8695ea5$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
    const $a5991724b8695ea5$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
    const $a5991724b8695ea5$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
    const $a5991724b8695ea5$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
    const $a5991724b8695ea5$var$ACTIVITY_LOG_DESC = 'A tab label of Activity Log Tabs, to show Issue Archival past operations';
    const $a5991724b8695ea5$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
    var $a5991724b8695ea5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        name: {
            "id": "admin-pages-performance.common.assets.issue.name",
            "defaultMessage": "Issues"
        },
        description: {
            "id": "admin-pages-performance.common.assets.issue.description",
            "defaultMessage": "Here\u2019s a quick snapshot of the total number of issues in your site, including some that we think can be archived. Archiving unused issues can improve performance and stability of your site."
        },
        chart: {
            "id": "admin-pages-performance.common.assets.issue.chart",
            "defaultMessage": "Overview"
        },
        reviewAndAnalyze: {
            "id": "admin-pages-performance.common.assets.issue.review-and-analyze",
            "defaultMessage": "Analysis"
        },
        activityLog: {
            "id": "admin-pages-performance.common.assets.issue.activity-log",
            "defaultMessage": "Activity log"
        },
        warning: {
            "id": "admin-pages-performance.common.assets.issue.warning",
            "defaultMessage": "The number of issues in the system is nearing our recommended threshold."
        },
        exceeded: {
            "id": "admin-pages-performance.common.assets.issue.exceeded",
            "defaultMessage": "There are more issues in the system than our recommended threshold."
        },
        risk1: {
            "id": "admin-pages-performance.common.assets.issue.risk-1",
            "defaultMessage": "If you have too many issues you may find searches, automations, and workflow rules are slower than usual."
        },
        mitigation1: {
            "id": "admin-pages-performance.common.assets.issue.mitigation-1",
            "defaultMessage": "Delete any projects that are no longer required."
        },
        mitigation2: {
            "id": "admin-pages-performance.common.assets.issue.mitigation-2",
            "defaultMessage": "Disable Jira integrations that create issues you don't need."
        },
        mitigation3: {
            "id": "admin-pages-performance.common.assets.issue.mitigation-3",
            "defaultMessage": "Delete old issues that are no longer required. Use a JQL query to find issues older than a year (\u201Ccreated < -365d order by created DESC\u201C)."
        },
        currentValueLabel: {
            "id": "admin-pages-performance.common.assets.issue.current-value-label",
            "defaultMessage": "Total current issues in your site"
        },
        thresholdValueLabel: {
            "id": "admin-pages-performance.common.assets.issue.threshold-value-label",
            "defaultMessage": "Recommended maximum number of issues"
        },
        currentValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.issue.current-value-aria-label",
            "defaultMessage": "{number} total current issues in your site"
        },
        thresholdValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.issue.threshold-value-aria-label",
            "defaultMessage": "{number} recommended maximum number of issues"
        },
        graphHeader: {
            "id": "admin-pages-performance.common.assets.issue.graph-header",
            "defaultMessage": "Issues over time"
        }
    });
});
parcelRegister("3AEMX", function(module, exports) {
    $parcel$export(module.exports, "PROJECT_ROLE_ACTOR_KEY", ()=>$c7627c0e6530f4b1$export$a570ca3f6cc5e280);
    $parcel$export(module.exports, "PROJECT_ROLE_ACTOR", ()=>$c7627c0e6530f4b1$export$fc3d2ee6c3fb3908);
    var $j0D55;
    const $c7627c0e6530f4b1$export$a570ca3f6cc5e280 = 'projectroleactor';
    const $c7627c0e6530f4b1$export$fc3d2ee6c3fb3908 = {
        key: $c7627c0e6530f4b1$export$a570ca3f6cc5e280,
        visible: true,
        name: (0, (0, parcelRequire("j0D55")).default).name,
        description: (0, (0, parcelRequire("j0D55")).default).description,
        tabLabels: [
            (0, (0, parcelRequire("j0D55")).default).analysis,
            (0, (0, parcelRequire("j0D55")).default).activityLog
        ],
        warningMessage: (0, (0, parcelRequire("j0D55")).default).warning,
        exceededMessage: (0, (0, parcelRequire("j0D55")).default).exceeded,
        risks: [
            (0, (0, parcelRequire("j0D55")).default).risk1
        ],
        mitigations: [
            (0, (0, parcelRequire("j0D55")).default).mitigation1,
            (0, (0, parcelRequire("j0D55")).default).mitigation2,
            (0, (0, parcelRequire("j0D55")).default).mitigation3
        ],
        currentValueLabel: (0, (0, parcelRequire("j0D55")).default).currentValueLabel,
        currentValueAriaLabel: (0, (0, parcelRequire("j0D55")).default).currentValueAriaLabel,
        thresholdValueLabel: (0, (0, parcelRequire("j0D55")).default).thresholdValueLabel,
        thresholdValueAriaLabel: (0, (0, parcelRequire("j0D55")).default).thresholdValueAriaLabel,
        recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-number-of-project-role-memberships/',
        recommendationUrlText: (0, (0, parcelRequire("j0D55")).default).recommendationUrlText,
        graphHeader: (0, (0, parcelRequire("j0D55")).default).graphHeader
    };
});
parcelRegister("j0D55", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6549fa32a8352dcb$export$2e2bcd8739ae039);
    var $7VHMR;
    const $6549fa32a8352dcb$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
    const $6549fa32a8352dcb$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
    const $6549fa32a8352dcb$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
    const $6549fa32a8352dcb$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
    const $6549fa32a8352dcb$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
    const $6549fa32a8352dcb$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
    const $6549fa32a8352dcb$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
    const $6549fa32a8352dcb$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
    const $6549fa32a8352dcb$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
    const $6549fa32a8352dcb$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
    var $6549fa32a8352dcb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        name: {
            "id": "admin-pages-performance.common.assets.project-role-actor.name",
            "defaultMessage": "Project role permissions"
        },
        description: {
            "id": "admin-pages-performance.common.assets.project-role-actor.description",
            "defaultMessage": "Here's a quick snapshot of the total number of project role permissions across your site."
        },
        analysis: {
            "id": "admin-pages-performance.common.assets.project-role-actor.analysis",
            "defaultMessage": "Analysis"
        },
        activityLog: {
            "id": "admin-pages-performance.common.assets.project-role-actor.activity-log",
            "defaultMessage": "Activity log"
        },
        warning: {
            "id": "admin-pages-performance.common.assets.project-role-actor.warning",
            "defaultMessage": "Your number of project role memberships is nearing the recommended threshold."
        },
        exceeded: {
            "id": "admin-pages-performance.common.assets.project-role-actor.exceeded",
            "defaultMessage": "Your number of project role memberships is over the recommended threshold."
        },
        risk1: {
            "id": "admin-pages-performance.common.assets.project-role-actor.risk-1",
            "defaultMessage": "When the number of project role memberships (users or groups) increases, viewing, searching, and creating issues becomes slower."
        },
        mitigation1: {
            "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-1",
            "defaultMessage": "Remove users who no longer need access to your site rather than only suspending them. Suspending users removes their permission but not their project role membership."
        },
        mitigation2: {
            "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-2",
            "defaultMessage": "Give memberships to groups of users instead of individual users. Granting membership to a group of 50 users count as 1 membership whereas granting memberships to 50 single users counts as 50 memberships."
        },
        mitigation3: {
            "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-3",
            "defaultMessage": "Use the default project role members in your permission scheme."
        },
        currentValueLabel: {
            "id": "admin-pages-performance.common.assets.project-role-actor.current-value-label",
            "defaultMessage": "Current project role permissions in your site"
        },
        thresholdValueLabel: {
            "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-label",
            "defaultMessage": "Recommended maximum number of permissions"
        },
        currentValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.project-role-actor.current-value-aria-label",
            "defaultMessage": "{number} current project role permissions in your site"
        },
        thresholdValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-aria-label",
            "defaultMessage": "{number} recommended maximum number of permissions"
        },
        recommendationUrlText: {
            "id": "admin-pages-performance.common.assets.project-role-actor.recommendation-url-text",
            "defaultMessage": "Learn more about optimizing your project role memberships."
        },
        graphHeader: {
            "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
            "defaultMessage": "Project role permissions over time"
        }
    });
});
parcelRegister("gtb9f", function(module, exports) {
    $parcel$export(module.exports, "METRICS", ()=>$713364f722667f6e$export$3f0e99ae6e0ec541);
    $parcel$export(module.exports, "RUN_ANALYSIS", ()=>$713364f722667f6e$export$769b1a9477352cf9);
    $parcel$export(module.exports, "DELETE_RECOMMENDATIONS", ()=>$713364f722667f6e$export$e7e31b14c32e055a);
    $parcel$export(module.exports, "DELETE_RECOMMENDATIONS_DROPDOWN", ()=>$713364f722667f6e$export$d96fe00ff2b38bae);
    $parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CONFIRM", ()=>$713364f722667f6e$export$3d4bb5f187c6844e);
    $parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CANCEL", ()=>$713364f722667f6e$export$5c1079e323f5d5bd);
    $parcel$export(module.exports, "TAB_CLICKED", ()=>$713364f722667f6e$export$d358fc12daa9f606);
    $parcel$export(module.exports, "RECOMMENDATIONS_LOADED", ()=>$713364f722667f6e$export$60cc0c61c99a5b81);
    $parcel$export(module.exports, "METRIC_CARD_CLICKED", ()=>$713364f722667f6e$export$71794f4d197278dc);
    $parcel$export(module.exports, "PROJECT_ROLE_ACTOR_FILTER_BY_PROJECT", ()=>$713364f722667f6e$export$9e34afbf86922b4a);
    $parcel$export(module.exports, "projectRoleActorAttributes", ()=>$713364f722667f6e$export$d6761557c91eea50);
    $parcel$export(module.exports, "ARCHIVE_ISSUES_CONFIRM", ()=>$713364f722667f6e$export$4e4b9391f7936ba2);
    $parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES", ()=>$713364f722667f6e$export$70525d18051240f4);
    $parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_CANCEL", ()=>$713364f722667f6e$export$4951e0e034b50b9c);
    $parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_TRY_AGAIN", ()=>$713364f722667f6e$export$108288df7758f60c);
    $parcel$export(module.exports, "VIEW_ISSUES", ()=>$713364f722667f6e$export$972d5a8da0d9f4c3);
    $parcel$export(module.exports, "STOP_ISSUE_ARCHIVAL", ()=>$713364f722667f6e$export$b920363d50bcf753);
    $parcel$export(module.exports, "ISSUE_UNARCHIVAL_COMPLETED", ()=>$713364f722667f6e$export$a84a5210fbad774);
    $parcel$export(module.exports, "JQL_SEARCH", ()=>$713364f722667f6e$export$5c2df36fdd8476f7);
    $parcel$export(module.exports, "DEFAULT_QUERY_SELECTED", ()=>$713364f722667f6e$export$77f23f1b921d5321);
    $parcel$export(module.exports, "issueAnalyticsAttributes", ()=>$713364f722667f6e$export$c62a52f3f7d80ec3);
    $parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH", ()=>$713364f722667f6e$export$8daffc99348bf555);
    $parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CONFIRM", ()=>$713364f722667f6e$export$20f13a04bc3e5d74);
    $parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CANCEL", ()=>$713364f722667f6e$export$ed285e0e924b673c);
    $parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_SUCCEEDED", ()=>$713364f722667f6e$export$26f5d7eae10db511);
    $parcel$export(module.exports, "customFieldAttributes", ()=>$713364f722667f6e$export$33989f74b6ba0674);
    $parcel$export(module.exports, "METRICS_SPOTLIGHT_STARTED", ()=>$713364f722667f6e$export$d39b24a650c6c79d);
    $parcel$export(module.exports, "METRICS_SPOTLIGHT_DISMISSED", ()=>$713364f722667f6e$export$eca4028936acf763);
    $parcel$export(module.exports, "METRICS_SPOTLIGHT_COMPLETED", ()=>$713364f722667f6e$export$9ba0a5caedb0ff37);
    $parcel$export(module.exports, "RESTORE_ACTIVITY_LOG", ()=>$713364f722667f6e$export$7b6bf63452d40db8);
    $parcel$export(module.exports, "DOWNLOAD_CSV", ()=>$713364f722667f6e$export$efdb93c7210090d1);
    $parcel$export(module.exports, "PROJECT_CLEANUP_FILTERS_CLEARED", ()=>$713364f722667f6e$export$6c650be5c2b4774f);
    $parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_PROJECT", ()=>$713364f722667f6e$export$6493dd0e190d3f58);
    $parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_STALE", ()=>$713364f722667f6e$export$422673ba1cec4aed);
    $parcel$export(module.exports, "PROJECT_CLEAN_UP", ()=>$713364f722667f6e$export$3a7186fc63c9e188);
    $parcel$export(module.exports, "PROJECT_CLEANUP_COMPLETED", ()=>$713364f722667f6e$export$8e0b8859a3cbd9e6);
    $parcel$export(module.exports, "ACTION_TRASH", ()=>$713364f722667f6e$export$342d8b9804e407c7);
    $parcel$export(module.exports, "ACTION_ARCHIVE", ()=>$713364f722667f6e$export$b685f2109baf2b4f);
    $parcel$export(module.exports, "ACTION_UNARCHIVE", ()=>$713364f722667f6e$export$3ac60b381ed426ca);
    var $8MHQY;
    var $cOrKR;
    var $lzUDm;
    var $3AEMX;
    const $713364f722667f6e$export$3f0e99ae6e0ec541 = [
        (0, (0, parcelRequire("8MHQY")).CUSTOM_FIELDS),
        (0, (0, parcelRequire("cOrKR")).ISSUE),
        (0, (0, parcelRequire("3AEMX")).PROJECT_ROLE_ACTOR),
        (0, (0, parcelRequire("lzUDm")).PROJECT_CLEANUP)
    ];
    const $713364f722667f6e$export$769b1a9477352cf9 = 'runAnalysis';
    const $713364f722667f6e$export$e7e31b14c32e055a = 'deleteRecommendations';
    const $713364f722667f6e$export$d96fe00ff2b38bae = 'deleteRecommendationsDropdown';
    const $713364f722667f6e$export$3d4bb5f187c6844e = 'deleteRecommendationsConfirm';
    const $713364f722667f6e$export$5c1079e323f5d5bd = 'deleteRecommendationsCancel';
    const $713364f722667f6e$export$d358fc12daa9f606 = 'psiTab';
    const $713364f722667f6e$export$60cc0c61c99a5b81 = 'recommendations loaded';
    const $713364f722667f6e$export$71794f4d197278dc = 'mitigationMetricCard';
    const $713364f722667f6e$export$9e34afbf86922b4a = 'projectRoleActorFilterByProject';
    const $713364f722667f6e$export$d6761557c91eea50 = {
        metric: (0, (0, parcelRequire("3AEMX")).PROJECT_ROLE_ACTOR_KEY)
    };
    const $713364f722667f6e$export$4e4b9391f7936ba2 = 'archiveIssuesConfirm';
    const $713364f722667f6e$export$70525d18051240f4 = 'restoreIssueArchival';
    const $713364f722667f6e$export$4951e0e034b50b9c = 'restoreIssueCancel';
    const $713364f722667f6e$export$108288df7758f60c = 'restoreIssueTryAgain';
    const $713364f722667f6e$export$972d5a8da0d9f4c3 = 'viewIssues';
    const $713364f722667f6e$export$b920363d50bcf753 = 'stopIssueArchival';
    const $713364f722667f6e$export$a84a5210fbad774 = 'restoreIssueArchival completed';
    const $713364f722667f6e$export$5c2df36fdd8476f7 = 'jqlSearch';
    const $713364f722667f6e$export$77f23f1b921d5321 = 'defaultQuerySelected';
    const $713364f722667f6e$export$c62a52f3f7d80ec3 = {
        metric: (0, (0, parcelRequire("cOrKR")).ISSUE_KEY)
    };
    const $713364f722667f6e$export$8daffc99348bf555 = 'customFieldMoveToTrash';
    const $713364f722667f6e$export$20f13a04bc3e5d74 = 'customFieldMoveToTrashConfirm';
    const $713364f722667f6e$export$ed285e0e924b673c = 'customFieldMoveToTrashCancel';
    const $713364f722667f6e$export$26f5d7eae10db511 = 'customFieldMoveToTrash succeeded';
    const $713364f722667f6e$export$33989f74b6ba0674 = {
        metric: (0, (0, parcelRequire("8MHQY")).CUSTOM_FIELDS).key
    };
    const $713364f722667f6e$export$d39b24a650c6c79d = 'metricPerformanceSpotlight started';
    const $713364f722667f6e$export$eca4028936acf763 = 'metricPerformanceSpotlightDismissed';
    const $713364f722667f6e$export$9ba0a5caedb0ff37 = 'metricPerformanceSpotlight completed';
    const $713364f722667f6e$export$7b6bf63452d40db8 = 'restoreActivityLog';
    const $713364f722667f6e$export$efdb93c7210090d1 = 'downloadActivityLogCsv';
    const $713364f722667f6e$export$6c650be5c2b4774f = 'projectCleanupFiltersCleared';
    const $713364f722667f6e$export$6493dd0e190d3f58 = 'projectCleanupFilterByProjectState';
    const $713364f722667f6e$export$422673ba1cec4aed = 'projectCleanupFilterByStale';
    const $713364f722667f6e$export$3a7186fc63c9e188 = 'projectCleanUp';
    const $713364f722667f6e$export$8e0b8859a3cbd9e6 = 'projectCleanup completed';
    const $713364f722667f6e$export$342d8b9804e407c7 = 'TRASH';
    const $713364f722667f6e$export$b685f2109baf2b4f = 'ARCHIVE';
    const $713364f722667f6e$export$3ac60b381ed426ca = 'UNARCHIVE';
});
parcelRegister("etuUp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df7d950b94f108ee$export$2e2bcd8739ae039);
    var $7VHMR;
    var $df7d950b94f108ee$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.title",
            "defaultMessage": "Site optimizer"
        },
        overview: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.overview",
            "defaultMessage": "Overview"
        },
        allReports: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.all-reports",
            "defaultMessage": "All reports"
        }
    });
});
parcelRegister("jWIOc", function(module, exports) {
    $parcel$export(module.exports, "PROJECT_CLEANUP_SPOTLIGHT_NAME", ()=>$fa0cf627da3f1f38$export$4150c6a7c9be0102);
    $parcel$export(module.exports, "ProjectCleanupSpotlight", ()=>$fa0cf627da3f1f38$export$6dc8afd0c00f9525);
    var $5uXOq = parcelRequire("5uXOq");
    var $1QiBP;
    var $koVbs;
    var $ehdJY;
    var $k43Y2;
    var $8881D;
    const $fa0cf627da3f1f38$export$4150c6a7c9be0102 = 'site-optimiser-project-cleanup-spotlight-nav';
    const $fa0cf627da3f1f38$export$6dc8afd0c00f9525 = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, (0, parcelRequire("k43Y2")).useProjectCleanupSpotlight)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1QiBP")).default), null, isProjectCleanupSpotlightActive && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            actions: [
                {
                    onClick: ()=>setIsProjectCleanupSpotlightActive(false),
                    text: formatMessage((0, (0, parcelRequire("8881D")).default).spotlightAction)
                }
            ],
            heading: formatMessage((0, (0, parcelRequire("8881D")).default).spotlightHeading),
            target: $fa0cf627da3f1f38$export$4150c6a7c9be0102,
            key: $fa0cf627da3f1f38$export$4150c6a7c9be0102,
            targetRadius: 3,
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            dialogPlacement: "right top",
            messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.jira-spotlight",
            messageType: "engagement"
        }, formatMessage((0, (0, parcelRequire("8881D")).default).spotlightDescription)));
    });
});
parcelRegister("k43Y2", function(module, exports) {
    $parcel$export(module.exports, "useProjectCleanupSpotlight", ()=>$249ebdaf0c0fc22c$export$780bcf6e3ebf2d12);
    var $5uXOq = parcelRequire("5uXOq");
    var $iyJxC;
    var $90yGq;
    const $249ebdaf0c0fc22c$var$PROPERTY_KEY = 'jira.user.settings.system.project-cleanup-onboarding-spotlight';
    const $249ebdaf0c0fc22c$export$780bcf6e3ebf2d12 = ()=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $5uXOq.useState)(false);
        const getHasSeenProjectCleanupSpotlight = async (id)=>{
            const response = await (0, (0, parcelRequire("iyJxC")).getUserProperty)({
                accountId: id,
                propertyKey: $249ebdaf0c0fc22c$var$PROPERTY_KEY,
                defaultValue: false
            });
            if (!response.value) {
                await (0, (0, parcelRequire("iyJxC")).setUserProperty)({
                    accountId: id,
                    propertyKey: $249ebdaf0c0fc22c$var$PROPERTY_KEY,
                    propertyValue: true
                });
                return false;
            }
            return true;
        };
        const fetchSpotlightState = (0, $5uXOq.useCallback)(async ()=>{
            if (accountId !== null) {
                const response = await getHasSeenProjectCleanupSpotlight(accountId);
                setIsProjectCleanupSpotlightActive(!response);
            }
        }, [
            accountId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            fetchSpotlightState();
        }, [
            fetchSpotlightState
        ]);
        return [
            isProjectCleanupSpotlightActive,
            setIsProjectCleanupSpotlightActive
        ];
    };
});
parcelRegister("iyJxC", function(module, exports) {
    $parcel$export(module.exports, "getUserProperty", ()=>$5455121d227e33bb$export$b3126db2ef6e34ed);
    $parcel$export(module.exports, "setUserProperty", ()=>$5455121d227e33bb$export$ba821ce5e177c7ef);
    var $jcw0u;
    var $eusud;
    const $5455121d227e33bb$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
    const $5455121d227e33bb$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
        const url = $5455121d227e33bb$var$getUserUrl(accountId, propertyKey);
        try {
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 404) return {
                key: propertyKey,
                value: defaultValue
            };
            if (response.ok) return await response.json();
            throw new Error(`Fetching ${propertyKey} user property failed.`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraAdminPagesPerformance',
                    teamName: 'cherenkov'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                key: propertyKey,
                value: defaultValue
            };
        }
    };
    const $5455121d227e33bb$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
        const url = $5455121d227e33bb$var$getUserUrl(accountId, propertyKey);
        try {
            await (0, (0, parcelRequire("eusud")).performPutRequest)(url, {
                body: JSON.stringify(propertyValue)
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'setUserProperty',
                    packageName: 'jiraAdminPagesPerformance',
                    teamName: 'cherenkov'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
});
parcelRegister("8881D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86d0877c08ff02be$export$2e2bcd8739ae039);
    var $7VHMR;
    var $86d0877c08ff02be$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        spotlightHeading: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-heading",
            "defaultMessage": "Clean out unused projects"
        },
        spotlightDescription: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-description",
            "defaultMessage": "Quickly remove inactive or empty projects to improve your site\u2019s performance. "
        },
        spotlightAction: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-action",
            "defaultMessage": "Ok"
        }
    });
});
parcelRegister("fM231", function(module, exports) {
    $parcel$export(module.exports, "hasSeenSiteOptimiserSpotlight", ()=>$879944d685aae4de$export$3ed4e8541d8ba40);
    var $iyJxC;
    const $879944d685aae4de$var$PROPERTY_KEY = 'jira.user.settings.system.site-optimizer-spotlight';
    const $879944d685aae4de$export$3ed4e8541d8ba40 = async (accountId)=>{
        const response = await (0, (0, parcelRequire("iyJxC")).getUserProperty)({
            accountId: accountId,
            propertyKey: $879944d685aae4de$var$PROPERTY_KEY,
            defaultValue: false
        });
        if (!response.value) {
            await (0, (0, parcelRequire("iyJxC")).setUserProperty)({
                accountId: accountId,
                propertyKey: $879944d685aae4de$var$PROPERTY_KEY,
                propertyValue: true
            });
            return false;
        }
        return true;
    };
});
parcelRegister("ie4oV", function(module, exports) {
    $parcel$export(module.exports, "isViewAuditingSelected", ()=>$84aa4044b145a05a$export$6da8ca04904513f9);
    var $4OCke;
    const $84aa4044b145a05a$var$VIEW_AUDITING_PATH_REGEXP = /\/auditing\/(\w+)/i;
    const $84aa4044b145a05a$export$6da8ca04904513f9 = (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || $84aa4044b145a05a$var$VIEW_AUDITING_PATH_REGEXP.test(currentLocation.pathname);
});
parcelRegister("71ORT", function(module, exports) {
    $parcel$export(module.exports, "UserInterfaceSection", ()=>$4dae17d9419cb38f$export$c4128359313d3f58);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $65Ltd;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $itmJb;
    var $jMBA3;
    var $jDUf4;
    const $4dae17d9419cb38f$export$c4128359313d3f58 = ()=>{
        const isJiraAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: formatMessage((0, (0, parcelRequire("jDUf4")).default).userInterface)
        }, features.hasUserDefaults && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'user-defaults'
            },
            href: navigationPath.userInterfacesUserDefaults,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).userDefaults)), features.hasEditDefaultDashboard && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'edit-default-dashboard'
            },
            href: navigationPath.userInterfacesEditDefaultDashboard,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).systemDashboard)), features.hasLookAndFeel && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'look-and-feel'
            },
            href: navigationPath.userInterfacesLookAndFeel,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).lookAndFeel)), features.hasPasAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'pas-admin-link-jira'
            },
            href: navigationPath.userInterfacesPasAdmin,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).pasAdmin)), isJiraAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'announcement-banner'
            },
            href: navigationPath.userInterfacesSiteAdmin,
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER)
            ]
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).announcementBanner)));
    };
});
parcelRegister("jDUf4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f12d9a643fcf4ed$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6f12d9a643fcf4ed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        userInterface: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-interface",
            "defaultMessage": "User Interface"
        },
        userDefaults: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-defaults",
            "defaultMessage": "Default user preferences"
        },
        systemDashboard: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.system-dashboard",
            "defaultMessage": "Default dashboard"
        },
        lookAndFeel: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.look-and-feel",
            "defaultMessage": "Look and feel"
        },
        pasAdmin: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.pas-admin",
            "defaultMessage": "Public Announcement Service"
        },
        announcementBanner: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.announcement-banner",
            "defaultMessage": "Announcement banner"
        }
    });
});
parcelRegister("3jrxv", function(module, exports) {
    $parcel$export(module.exports, "isGeneralConfigurationSelected", ()=>$e6139421bb00cae6$export$ba31cfa97c56eefd);
    var $4OCke;
    const $e6139421bb00cae6$var$APPLICATION_PROPERTIES_PATH_REGEXP = /\/admin\/(\w+)ApplicationProperties/i;
    const $e6139421bb00cae6$export$ba31cfa97c56eefd = (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || $e6139421bb00cae6$var$APPLICATION_PROPERTIES_PATH_REGEXP.test(currentLocation.pathname);
});
parcelRegister("fg3s6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("h9UUp").then(()=>parcelRequire('8Z6uP'));
});
parcelRegister("4P6Jd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kZEdw")
    ]).then(()=>parcelRequire('PZuxA'));
});
parcelRegister("cVwq6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kbq0s")
    ]).then(()=>parcelRequire('9HctW'));
});
parcelRegister("clE6J", function(module, exports) {
    $parcel$export(module.exports, "metricsOverviewPageResource", ()=>$624fad9c7a7951b4$export$ac0b4ef4ec4987ae);
    var $ao2h1;
    var $hOOQr;
    const $624fad9c7a7951b4$export$ac0b4ef4ec4987ae = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("hOOQr")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("hOOQr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69a9f121a9ac63a8$export$2e2bcd8739ae039);
    const $69a9f121a9ac63a8$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "main_adminPagesPerformance_Overview_Query",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v1,
                                        "concreteType": "JiraResourceUsageMetricConnection",
                                        "kind": "LinkedField",
                                        "name": "resourceUsageMetrics",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "main_adminPagesPerformance_OverviewPage"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.resourceUsageMetrics"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "main_adminPagesPerformance_Overview_Query",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraResourceUsageMetricConnection",
                                "kind": "LinkedField",
                                "name": "resourceUsageMetrics",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraResourceUsageMetric",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "currentValue"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "warningValue"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "thresholdValue"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cleanupValue"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "d2fe73ca0b47245563666951f775b77a3a261da2aeb574c289b15d04a8a13008",
                "metadata": {},
                "name": "main_adminPagesPerformance_Overview_Query",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $69a9f121a9ac63a8$var$node.hash = "65285ab59e67a0f62edb54671f986ddd";
    var $69a9f121a9ac63a8$export$2e2bcd8739ae039 = $69a9f121a9ac63a8$var$node;
});
parcelRegister("4Vh5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8auDC")
    ]).then(()=>parcelRequire('aJlr3'));
});
parcelRegister("5CzbD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7gdHv")
    ]).then(()=>parcelRequire('fJoHG'));
});
parcelRegister("dF55I", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7u0xh")
    ]).then(()=>parcelRequire('eQgAh'));
});
parcelRegister("1Sn7L", function(module, exports) {
    $parcel$export(module.exports, "editPermissionSchemePageResource", ()=>$c133ac01577799ff$export$2b6bb2f543863b53);
    var $ao2h1;
    var $eZzoq;
    const $c133ac01577799ff$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE = 'EDIT_PERMISSION_SCHEME_PAGE';
    const $c133ac01577799ff$export$2b6bb2f543863b53 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $c133ac01577799ff$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE,
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("eZzoq")).default),
                variables: {
                    schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`,
                    first: 50
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("eZzoq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95d709337e778f61$export$2e2bcd8739ae039);
    const $95d709337e778f61$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemeId"
        }, v2 = {
            "kind": "Variable",
            "name": "schemeId",
            "variableName": "schemeId"
        }, v3 = [
            v2
        ], v4 = {
            "kind": "ScalarField",
            "name": "isEditable"
        }, v5 = {
            "concreteType": "JiraPermissionSchemeConfiguration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
                v4
            ]
        }, v6 = [
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
            },
            v2
        ], v7 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v8 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v9 = {
            "kind": "ScalarField",
            "name": "name"
        }, v10 = {
            "kind": "ScalarField",
            "name": "key"
        }, v11 = {
            "kind": "ScalarField",
            "name": "description"
        }, v12 = {
            "kind": "ScalarField",
            "name": "text"
        }, v13 = {
            "kind": "ScalarField",
            "name": "id"
        }, v14 = [
            v8,
            v9,
            v13
        ], v15 = [
            v9,
            v13
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3,
                                    "kind": "LinkedField",
                                    "name": "viewPermissionScheme",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "PermissionCategories"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "header_editPermissionScheme"
                                                },
                                                v5
                                            ],
                                            "type": "JiraPermissionSchemeView"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.viewPermissionScheme"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v6,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "getProjectsByPermissionScheme",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v7,
                                                                    "action": "LOG",
                                                                    "path": "jira.getProjectsByPermissionScheme.edges.node.projectId"
                                                                }
                                                            ]
                                                        },
                                                        "action": "LOG",
                                                        "path": "jira.getProjectsByPermissionScheme.edges.node"
                                                    }
                                                ]
                                            },
                                            "action": "LOG",
                                            "path": "jira.getProjectsByPermissionScheme.edges"
                                        }
                                    ]
                                },
                                "action": "LOG",
                                "path": "jira.getProjectsByPermissionScheme"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    v8,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "JiraPermissionSchemeGrantGroup",
                                                "kind": "LinkedField",
                                                "name": "grantGroups",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraProjectPermissionCategory",
                                                        "kind": "LinkedField",
                                                        "name": "category",
                                                        "plural": false,
                                                        "selections": [
                                                            v9,
                                                            v10
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraPermissionGrantHolder",
                                                        "kind": "LinkedField",
                                                        "name": "grantHolders",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProjectPermission",
                                                                "kind": "LinkedField",
                                                                "name": "permission",
                                                                "plural": false,
                                                                "selections": [
                                                                    v9,
                                                                    v11,
                                                                    v10
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraPermissionConfiguration",
                                                                "kind": "LinkedField",
                                                                "name": "configuration",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "tag"
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraPermissionMessageExtension",
                                                                        "kind": "LinkedField",
                                                                        "name": "message",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "type"
                                                                            },
                                                                            v12
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraPermissionDocumentationExtension",
                                                                        "kind": "LinkedField",
                                                                        "name": "documentation",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v12,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "url"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v4
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraPermissionGrants",
                                                                "kind": "LinkedField",
                                                                "name": "grants",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraGrantTypeKey",
                                                                        "kind": "LinkedField",
                                                                        "name": "grantType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v10,
                                                                            v9
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraPermissionGrantValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "grantValues",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "value",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v8,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v9
                                                                                        ],
                                                                                        "type": "JiraDefaultGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "user",
                                                                                                "plural": false,
                                                                                                "selections": v14
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraUserGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraGroup",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "group",
                                                                                                "plural": false,
                                                                                                "selections": v15
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraGroupGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraRole",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "role",
                                                                                                "plural": false,
                                                                                                "selections": v15
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraProjectRoleGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "field",
                                                                                                "plural": false,
                                                                                                "selections": v14
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraIssueFieldGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v13
                                                                                        ],
                                                                                        "type": "Node",
                                                                                        "abstractKey": "__isNode"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v13
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "totalCount"
                                                                    },
                                                                    v8
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ClientExtension",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "__id"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraPermissionScheme",
                                                "kind": "LinkedField",
                                                "name": "scheme",
                                                "plural": false,
                                                "selections": [
                                                    v9,
                                                    v11,
                                                    v13
                                                ]
                                            },
                                            v5
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            {
                                "args": v6,
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "getProjectsByPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v7,
                                                    v13
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "8c97cc5e281ea579c44e87ac7f80e5f399b27b3ac304b7267d4210b282a7a4b1",
                "metadata": {},
                "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $95d709337e778f61$var$node.hash = "9e1e7326d79aae057f4943753d3cd309";
    var $95d709337e778f61$export$2e2bcd8739ae039 = $95d709337e778f61$var$node;
});
parcelRegister("dHMas", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2s3c1").then(()=>parcelRequire('hZT3b'));
});
parcelRegister("bFrLw", function(module, exports) {
    $parcel$export(module.exports, "permissionSchemePageResource", ()=>$b39d37deff00f918$export$58d9013f694fc9d0);
    var $ao2h1;
    var $kf7Zr;
    const $b39d37deff00f918$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE = 'PERMISSION_SCHEME_PAGE';
    const $b39d37deff00f918$export$58d9013f694fc9d0 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $b39d37deff00f918$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE,
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("kf7Zr")).default),
                variables: {
                    schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("kf7Zr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$667e2dd268ebb83a$export$2e2bcd8739ae039);
    const $667e2dd268ebb83a$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "schemeId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "schemeId",
                "variableName": "schemeId"
            }
        ], v2 = {
            "concreteType": "JiraPermissionSchemeConfiguration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }, v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = {
            "kind": "ScalarField",
            "name": "name"
        }, v5 = {
            "kind": "ScalarField",
            "name": "description"
        }, v6 = {
            "kind": "ScalarField",
            "name": "id"
        }, v7 = {
            "kind": "ScalarField",
            "name": "key"
        }, v8 = [
            v3,
            v4,
            v6
        ], v9 = [
            v4,
            v6
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1,
                                    "kind": "LinkedField",
                                    "name": "viewPermissionScheme",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "header_permissionScheme"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "PermissionsTable"
                                                },
                                                v2
                                            ],
                                            "type": "JiraPermissionSchemeView"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.viewPermissionScheme"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "JiraPermissionScheme",
                                                "kind": "LinkedField",
                                                "name": "scheme",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    v5,
                                                    v6
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraPermissionSchemeGrantGroup",
                                                "kind": "LinkedField",
                                                "name": "grantGroups",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraProjectPermissionCategory",
                                                        "kind": "LinkedField",
                                                        "name": "category",
                                                        "plural": false,
                                                        "selections": [
                                                            v4
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraPermissionGrantHolder",
                                                        "kind": "LinkedField",
                                                        "name": "grantHolders",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProjectPermission",
                                                                "kind": "LinkedField",
                                                                "name": "permission",
                                                                "plural": false,
                                                                "selections": [
                                                                    v7,
                                                                    v4,
                                                                    v5
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraPermissionGrants",
                                                                "kind": "LinkedField",
                                                                "name": "grants",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraGrantTypeKey",
                                                                        "kind": "LinkedField",
                                                                        "name": "grantType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v7,
                                                                            v4
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraPermissionGrantValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "grantValues",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "value",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v3,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            v4
                                                                                        ],
                                                                                        "type": "JiraDefaultGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "user",
                                                                                                "plural": false,
                                                                                                "selections": v8
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraUserGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            {
                                                                                                "concreteType": "JiraGroup",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "group",
                                                                                                "plural": false,
                                                                                                "selections": v9
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraGroupGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "field",
                                                                                                "plural": false,
                                                                                                "selections": v8
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraIssueFieldGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            {
                                                                                                "concreteType": "JiraRole",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "role",
                                                                                                "plural": false,
                                                                                                "selections": v9
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraProjectRoleGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6
                                                                                        ],
                                                                                        "type": "Node",
                                                                                        "abstractKey": "__isNode"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v6
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            v2
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb",
                "metadata": {},
                "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $667e2dd268ebb83a$var$node.hash = "41dd09a71a35c8ed416631b02fa73316";
    var $667e2dd268ebb83a$export$2e2bcd8739ae039 = $667e2dd268ebb83a$var$node;
});
parcelRegister("i4rUQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ibJV0")
    ]).then(()=>parcelRequire('cHxvv'));
});
parcelRegister("8Xps6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dRzJO").then(()=>parcelRequire('7oC7C'));
});
parcelRegister("fZEim", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRoute", ()=>$9dde78a6f0fc7878$export$185af30f53271c10);
    var $65Ltd;
    const $9dde78a6f0fc7878$export$185af30f53271c10 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES),
        path: '/jira/settings/issues/priority-schemes'
    };
});
parcelRegister("2LTGD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7MbJW").then(()=>parcelRequire('4bg9b'));
});
parcelRegister("7SoLF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jKdTq").then(()=>parcelRequire('jSKfU'));
});
parcelRegister("beIyx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("FB5JX").then(()=>parcelRequire('bwE6o'));
});
parcelRegister("hD3Wt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8WK9x").then(()=>parcelRequire('lgmh3'));
});
parcelRegister("79U3p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jTAHY").then(()=>parcelRequire('5K98P'));
});
parcelRegister("99CoR", function(module, exports) {
    $parcel$export(module.exports, "systemConfigurationRoute", ()=>$6c77a2c05982af00$export$6823cb5626e61bc7);
    var $65Ltd;
    const $6c77a2c05982af00$export$6823cb5626e61bc7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_CONFIGURATION),
        path: '/jira/settings/system/general-configuration',
        exact: true
    };
});
parcelRegister("54Qvs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aUVUi").then(()=>parcelRequire('7S4i0'));
});
parcelRegister("kNqq3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1eCvc")
    ]).then(()=>parcelRequire('e7RG2'));
});
parcelRegister("3aIZg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9146315a1662307e$export$2e2bcd8739ae039);
    var $ebyGx = parcelRequire("ebyGx");
    var $2M1hQ;
    var $AdkCT;
    const $9146315a1662307e$var$workFlowsResource = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $5c95bdf76715894f$export$b11854972ecaecc7),
        getKey: ({ query: query })=>`${0, $5c95bdf76715894f$export$6602c5404301813f}-${(0, ($parcel$interopDefault($ebyGx))).stringify(query)}`,
        maxAge: 0,
        getData: async ({ query: query })=>(0, (0, parcelRequire("AdkCT")).getListWorkFlows)((0, ($parcel$interopDefault($ebyGx))).stringify(query))
    });
    var $9146315a1662307e$export$2e2bcd8739ae039 = $9146315a1662307e$var$workFlowsResource;
});
parcelRegister("AdkCT", function(module, exports) {
    $parcel$export(module.exports, "getListWorkFlows", ()=>$bd8703d90d89a06c$export$952f5d693c3c0d4e);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $eusud;
    var $lNKJm;
    var $9KDge;
    const $bd8703d90d89a06c$export$952f5d693c3c0d4e = async (qs)=>{
        const filter = (0, (0, parcelRequire("9KDge")).fromUrlTransformer)((0, ($parcel$interopDefault($ebyGx))).parse(qs));
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify((0, (0, parcelRequire("9KDge")).toApiUrlTransformer)(filter));
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/workflow/search?${query}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getWorkflowsSearchAPI',
                    packageName: (0, (0, parcelRequire("lNKJm")).PACKAGE_NAME),
                    teamName: 'helix'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("lNKJm", function(module, exports) {
    $parcel$export(module.exports, "SOURCE_NAME", ()=>$51adf94ab22e1863$export$a3821bc63538b210);
    $parcel$export(module.exports, "WORKFLOW_NAME", ()=>$51adf94ab22e1863$export$a69699c3acbd94ca);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$51adf94ab22e1863$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "WORKFLOWS_ACTIONS", ()=>$51adf94ab22e1863$export$f3ab46ae5f3c01ad);
    $parcel$export(module.exports, "WORKFLOWS_SCHEME", ()=>$51adf94ab22e1863$export$81c9aaf617cb2f01);
    $parcel$export(module.exports, "SYSTEM_WORKFLOW_JIRA_NAME", ()=>$51adf94ab22e1863$export$615f1d8b29794ae);
    $parcel$export(module.exports, "SYSTEM_WORKFLOW_BUILDS_WORKFLOWS_NAME", ()=>$51adf94ab22e1863$export$fccd4c1ce5f0896f);
    $parcel$export(module.exports, "DEFAULT_PAGE_SIZE", ()=>$51adf94ab22e1863$export$5716e8bcb003888d);
    $parcel$export(module.exports, "defaultListWorkFlowsFilter", ()=>$51adf94ab22e1863$export$dc5aae53031515c);
    $parcel$export(module.exports, "ORDER", ()=>$51adf94ab22e1863$export$11e75bce9f7ea886);
    $parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", ()=>$51adf94ab22e1863$export$9ac56b2484c2d4e9);
    $parcel$export(module.exports, "PAGE_SIZE_CHANGE_ANALYTICS", ()=>$51adf94ab22e1863$export$e6613a3c77896936);
    $parcel$export(module.exports, "API_PREFIX", ()=>$51adf94ab22e1863$export$a3f6840410eb0571);
    const $51adf94ab22e1863$export$a3821bc63538b210 = 'listWorkflows';
    const $51adf94ab22e1863$export$a69699c3acbd94ca = 'workflowName';
    const $51adf94ab22e1863$export$b8b9d90f9e5bd72b = 'jira-admin-pages-list-workflows';
    const $51adf94ab22e1863$export$f3ab46ae5f3c01ad = 'workflowsActions';
    const $51adf94ab22e1863$export$81c9aaf617cb2f01 = 'workflowScheme';
    const $51adf94ab22e1863$export$615f1d8b29794ae = 'jira';
    const $51adf94ab22e1863$export$fccd4c1ce5f0896f = 'Builds Workflow';
    const $51adf94ab22e1863$export$5716e8bcb003888d = 10;
    const $51adf94ab22e1863$export$f6e7f4d903fd7165 = 'ADD_WORKFLOWS';
    const $51adf94ab22e1863$export$dc5aae53031515c = {
        pageNumber: 1,
        pageSize: $51adf94ab22e1863$export$5716e8bcb003888d,
        expand: [
            'default',
            'hasDraftWorkflow',
            'schemes',
            'operations',
            'projects'
        ],
        orderBy: 'name',
        sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
        isActive: true
    };
    const $51adf94ab22e1863$export$11e75bce9f7ea886 = Object.freeze({
        ASC: 'asc',
        DESC: 'desc'
    });
    const $51adf94ab22e1863$export$3c5e605ca7ade9f2 = 'NAME';
    const $51adf94ab22e1863$export$b87f371cbc396fcf = 'TYPE';
    const $51adf94ab22e1863$export$9ac56b2484c2d4e9 = Object.freeze({
        ACTION: 'changed',
        ACTION_SUBJECT: 'filterSearch'
    });
    const $51adf94ab22e1863$export$e6613a3c77896936 = Object.freeze({
        ACTION: 'changed',
        ACTION_SUBJECT: 'pageSize'
    });
    const $51adf94ab22e1863$export$a3f6840410eb0571 = 'gateway/api/jira/project-configuration';
});
parcelRegister("9KDge", function(module, exports) {
    $parcel$export(module.exports, "toUrlTransformer", ()=>$f0642d0f1e447d39$export$5b9f8ed2c34be88a);
    $parcel$export(module.exports, "fromUrlTransformer", ()=>$f0642d0f1e447d39$export$bec67ef860c0d0e1);
    $parcel$export(module.exports, "toApiUrlTransformer", ()=>$f0642d0f1e447d39$export$fb15afa686993f11);
    var $aud83;
    var $lNKJm;
    var $lgmUP;
    const $f0642d0f1e447d39$export$5b9f8ed2c34be88a = (filter)=>{
        const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = filter || {};
        return {
            pageNumber: pageNumber,
            searchFilter: searchFilter,
            orderBy: orderBy,
            isActive: isActive,
            pageSize: pageSize
        };
    };
    const $f0642d0f1e447d39$export$bec67ef860c0d0e1 = (params)=>{
        const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = params;
        const parsedNumber = Number.isNaN((0, (0, parcelRequire("aud83")).number).parse(pageNumber)) ? (0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter).pageNumber : (0, (0, parcelRequire("aud83")).number).parse(pageNumber);
        const parsedSize = Number.isNaN((0, (0, parcelRequire("aud83")).number).parse(pageSize)) ? (0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter).pageSize : (0, (0, parcelRequire("aud83")).number).parse(pageSize);
        const parsedOrderBy = orderBy === 'name' || orderBy === '-name' || orderBy === 'updated' || orderBy === '-updated' ? orderBy : undefined;
        const isActiveFinal = isActive != null ? isActive === 'true' : (0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter).isActive;
        return {
            ...(0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter),
            pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
            pageSize: parsedSize != null ? Number(parsedSize) : undefined,
            searchFilter: searchFilter,
            orderBy: parsedOrderBy,
            isActive: isActiveFinal
        };
    };
    const $f0642d0f1e447d39$export$fb15afa686993f11 = (filter)=>{
        const fullFilter = {
            ...(0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter),
            ...filter
        };
        const { pageNumber: pageNumber = 1, pageSize: pageSize = (0, (0, parcelRequire("lNKJm")).DEFAULT_PAGE_SIZE) } = fullFilter;
        let requestParams = {
            maxResults: pageSize,
            startAt: (pageNumber - 1) * pageSize,
            orderBy: fullFilter.orderBy,
            queryString: (0, (0, parcelRequire("lgmUP")).trimSearchFilter)(fullFilter.searchFilter),
            isActive: fullFilter.isActive
        };
        if (fullFilter.expand != null) requestParams = {
            ...requestParams,
            expand: fullFilter.expand.join(',')
        };
        return requestParams;
    };
});
parcelRegister("lgmUP", function(module, exports) {
    $parcel$export(module.exports, "trimSearchFilter", ()=>$d92ccc09aa62d68e$export$ed1722f41c23aaaf);
    const $d92ccc09aa62d68e$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
    const $d92ccc09aa62d68e$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
    const $d92ccc09aa62d68e$export$ed1722f41c23aaaf = (searchFilter)=>{
        if (searchFilter === undefined) return undefined;
        return searchFilter.trim() || undefined;
    };
});
const $5c95bdf76715894f$export$b11854972ecaecc7 = 'WORKFLOWS_TABLE';
const $5c95bdf76715894f$export$6602c5404301813f = 'WORKFLOWS_TABLE_KEY';
parcelRegister("9VrFM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9Lhq3").then(()=>parcelRequire('b9R9h'));
});
parcelRegister("czpuT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1hdHP")
    ]).then(()=>parcelRequire('c8ahc'));
});
parcelRegister("dbmHR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fQbJ3").then(()=>parcelRequire('5NHpB'));
});
parcelRegister("fCXWg", function(module, exports) {
    $parcel$export(module.exports, "formEditJirafieldsResource", ()=>$0b2fb9f25d526504$export$ca58e1498fd1ff3e);
    $parcel$export(module.exports, "useFormEditJirafields", ()=>$0b2fb9f25d526504$export$8a76fadb956ce203);
    var $dK8AG;
    var $2M1hQ;
    var $2YP9W;
    const $0b2fb9f25d526504$var$getDataLoader = ()=>(parcelRequire("eixu1"));
    const $0b2fb9f25d526504$export$ca58e1498fd1ff3e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'HELP_CENTER_FORM_EDIT_JIRAFIELDS_RESOURCE',
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $0b2fb9f25d526504$var$getDataLoader
    });
    const $0b2fb9f25d526504$export$8a76fadb956ce203 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($0b2fb9f25d526504$export$ca58e1498fd1ff3e);
});
parcelRegister("eixu1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dICga").then(()=>parcelRequire('5Kre9'));
});
parcelRegister("7D8h0", function(module, exports) {
    $parcel$export(module.exports, "formsResource", ()=>$8beb5bc3f227e13c$export$dbd8dbd978e7427);
    $parcel$export(module.exports, "useFormsResource", ()=>$8beb5bc3f227e13c$export$efd3ca9d66f19a97);
    var $dK8AG;
    var $2M1hQ;
    var $2YP9W;
    const $8beb5bc3f227e13c$var$getDataLoader = ()=>(parcelRequire("4ewnA"));
    const $8beb5bc3f227e13c$export$dbd8dbd978e7427 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'HELP_CENTER_FORMS_RESOURCE',
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $8beb5bc3f227e13c$var$getDataLoader
    });
    const $8beb5bc3f227e13c$export$efd3ca9d66f19a97 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($8beb5bc3f227e13c$export$dbd8dbd978e7427);
});
parcelRegister("4ewnA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gphZc").then(()=>parcelRequire('bEbHX'));
});
parcelRegister("k8jl5", function(module, exports) {
    $parcel$export(module.exports, "servicedeskIssueTypesResource", ()=>$8b723afc89fdf36c$export$191ce50629f40dbe);
    var $2M1hQ;
    const $8b723afc89fdf36c$var$getDataLoader = ()=>(parcelRequire("eLlwX"));
    const $8b723afc89fdf36c$export$191ce50629f40dbe = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $30e9f90f7be7696a$export$1ed713fe52212251),
        getKey: ({ match: { params: params } })=>params.projectKey || '',
        getDataLoader: $8b723afc89fdf36c$var$getDataLoader
    });
});
const $30e9f90f7be7696a$export$1ed713fe52212251 = 'SERVICEDESK_ISSUE_TYPES';
parcelRegister("eLlwX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("lJYdj")
    ]).then(()=>parcelRequire('lWPKX'));
});
parcelRegister("1cpsA", function(module, exports) {
    $parcel$export(module.exports, "servicedeskPortalGroupsResource", ()=>$2ddee7630453f9bc$export$c7fb28234b909b2f);
    var $2M1hQ;
    const $2ddee7630453f9bc$var$getDataLoader = ()=>(parcelRequire("jGVaw"));
    const $2ddee7630453f9bc$var$ONE_DAY_IN_MILLIS = 86400000;
    const $2ddee7630453f9bc$export$c7fb28234b909b2f = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $1e9c4adda1725c92$export$4160f2c498fcd32e),
        getKey: ({ match: { params: params } })=>params.projectKey || '',
        getDataLoader: $2ddee7630453f9bc$var$getDataLoader,
        maxAge: $2ddee7630453f9bc$var$ONE_DAY_IN_MILLIS
    });
});
const $1e9c4adda1725c92$export$4160f2c498fcd32e = 'SERVICEDESK_PORTAL_GROUPS';
parcelRegister("jGVaw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("4lrTa")
    ]).then(()=>parcelRequire('7sMSo'));
});
parcelRegister("lseYA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("dadpa")
    ]).then(()=>parcelRequire('lQS7P'));
});
parcelRegister("gBexg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1Aiz0").then(()=>parcelRequire('7QYfj'));
});
parcelRegister("ddhnG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aUqEr").then(()=>parcelRequire('7r8zn'));
});
parcelRegister("99koq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("f3edP")
    ]).then(()=>parcelRequire('3XNgZ'));
});
parcelRegister("4r0EN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gZjef").then(()=>parcelRequire('a6kDH'));
});
parcelRegister("ktRUb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("7gB9a")
    ]).then(()=>parcelRequire('5bGBK'));
});
parcelRegister("9xCIo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9pmDz").then(()=>parcelRequire('c7EOd'));
});
parcelRegister("3Jfji", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("axOrz")
    ]).then(()=>parcelRequire('gAjzk'));
});
parcelRegister("4eTbq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hrtuU")
    ]).then(()=>parcelRequire('4uQ2s'));
});
parcelRegister("8rIQt", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$17427f16dde00e98$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fobme;
    var $acDan;
    var $8snXd;
    var $hFFWh;
    const $17427f16dde00e98$var$MultiProjectSidebarCore = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarRenderStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8snXd")).PerformanceMark), {
            id: (0, (0, parcelRequire("8snXd")).RENDER_START_MARK)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hFFWh")).default), null), !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarReady), {
            id: (0, (0, parcelRequire("fobme")).SIDEBAR_ID).CORE
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8snXd")).PerformanceMark), {
            id: (0, (0, parcelRequire("8snXd")).RENDER_END_MARK)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8snXd")).PerformanceReport), null)));
    var $17427f16dde00e98$export$2e2bcd8739ae039 = $17427f16dde00e98$var$MultiProjectSidebarCore;
});
parcelRegister("8snXd", function(module, exports) {
    $parcel$export(module.exports, "RENDER_START_MARK", ()=>$5e4f397416a402e4$export$8f8203e04f80aed);
    $parcel$export(module.exports, "RENDER_END_MARK", ()=>$5e4f397416a402e4$export$dc795f9b21e2778a);
    $parcel$export(module.exports, "PerformanceMark", ()=>$5e4f397416a402e4$export$b8228db3a01d9a76);
    $parcel$export(module.exports, "PerformanceReport", ()=>$5e4f397416a402e4$export$c97ab321326d29f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $dGrdR;
    const $5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME = 'jwm.sidebar';
    const $5e4f397416a402e4$export$8f8203e04f80aed = `${$5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME}.render.start`;
    const $5e4f397416a402e4$export$dc795f9b21e2778a = `${$5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME}.render.end`;
    const $5e4f397416a402e4$var$segment = (0, (0, parcelRequire("dGrdR")).metrics).pageSegmentLoad({
        key: $5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME,
        timings: [
            {
                key: 'tti',
                endMark: $5e4f397416a402e4$export$dc795f9b21e2778a
            }
        ]
    });
    const $5e4f397416a402e4$export$b8228db3a01d9a76 = ({ id: id })=>{
        const startedRef = (0, $5uXOq.useRef)(false);
        if (!false && !startedRef.current) {
            $5e4f397416a402e4$var$segment.startFromPageLoad();
            startedRef.current = true;
        }
        (0, $5uXOq.useEffect)(()=>$5e4f397416a402e4$var$segment.mark(id), [
            id
        ]);
        return null;
    };
    const $5e4f397416a402e4$export$c97ab321326d29f7 = ()=>{
        (0, $5uXOq.useEffect)(()=>{
            $5e4f397416a402e4$var$segment.stop();
        }, []);
        return null;
    };
});
parcelRegister("hFFWh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af0c023251a98909$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8e8QT;
    var $4R6GH;
    var $koVbs;
    var $cE2Qr;
    var $8zOmE;
    var $2NMNM;
    var $iNzEe;
    var $cZpsT;
    var $doZTA;
    var $6tzEU;
    var $aueMW;
    var $iZNik;
    var $NCdt4;
    var $dCGEg;
    var $6KeQr;
    var $k5gug;
    const $af0c023251a98909$var$MultiProjectMenu = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { currentProject: currentProject, recents: recents, favorites: favorites, hasMoreFavorite: hasMoreFavorite, onFavoriteToggle: onFavoriteToggle, overviews: overviews, overviewsError: overviewsError, shouldHideOverviews: shouldHideOverviews, loading: loading } = (0, (0, parcelRequire("6tzEU")).useSidebarData)();
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        const isPremiumUserSeat = (0, (0, parcelRequire("iNzEe")).useIsPremiumUserSeat)();
        const [projectState] = (0, (0, parcelRequire("cE2Qr")).useProjectState)();
        const [{ match: { params: { projectKey: projectKey } } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebar viewed', {
                starredProjectsCount: favorites.length,
                recentProjectsCount: recents.length,
                overviewsCount: overviews.length
            });
        }, []);
        const currentProjectKey = projectKey ?? currentProject?.key;
        const shouldDisplayOverviews = isPremiumUserSeat && !isAnonymous && !shouldHideOverviews;
        const projectsContent = (0, ($parcel$interopDefault($5uXOq))).createElement("section", null, favorites.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6KeQr")).default), {
            sectionId: "starred",
            projects: favorites,
            onFavoriteToggle: onFavoriteToggle,
            currentProjectKey: currentProjectKey,
            showViewAllProjects: hasMoreFavorite,
            viewAllProjectsLabel: formatMessage((0, (0, parcelRequire("NCdt4")).default).viewAllStarred)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6KeQr")).default), {
            sectionId: "recent",
            projects: recents,
            onFavoriteToggle: onFavoriteToggle,
            currentProjectKey: currentProjectKey,
            showViewAllProjects: true
        }));
        const isShowingCTA = projectState?.isSampleProject === true;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SidebarWrapper, {
            "aria-label": formatMessage((0, (0, parcelRequire("NCdt4")).default).navigationLabel),
            isCrossProjectView: true
        }, shouldDisplayOverviews && (loading ? (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$OverviewsSkeleton, null) : (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dCGEg")).default), {
            overviews: overviews,
            hasError: Boolean(overviewsError)
        }))), loading ? (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ProjectsSkeleton, null) : (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k5gug")).default), null), projectsContent), !loading && isShowingCTA && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aueMW")).CreateProjectCta), null)), (0, (0, parcelRequire("4R6GH")).fg)('jwm_mobile_discovery') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8e8QT")).AsyncMobileDownloadPrompt), null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$Footer, {
            hasMargin: true
        }, currentProject != null && (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$Type, {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-type"
        }, currentProject.isSimplified ? formatMessage((0, (0, parcelRequire("NCdt4")).default).teamManagedProject) : formatMessage((0, (0, parcelRequire("NCdt4")).default).companyManagedProject)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iZNik")).default), null)));
    };
    const $af0c023251a98909$var$ItemSkeleton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemAvatarSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SkeletonBase, null));
    const $af0c023251a98909$var$OverviewsSkeleton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SkeletonSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SectionHeaderSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null));
    const $af0c023251a98909$var$ProjectsSkeleton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SkeletonSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SectionHeaderSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$CollapsibleHeaderSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$CollapsibleHeaderSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null));
    const $af0c023251a98909$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _11q7vuon",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$SidebarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "nav", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isCrossProjectView: isCrossProjectView, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n3tdpxbi _19bvpxbi _u5f3pxbi _19pkr5cr _otyridpf _18u0idpf _2hwxidpf _1reo1wug _18m91wug _16jlkb7n _1o9zkb7n _i0dlf1ug _11q71mi8 _12vemgnk _1lrwy1fe _qmxj4ebz _qjkj6grs _azbnu2gc",
                __cmplp.isCrossProjectView ? "_ca0qpxbi" : "_ca0q1b66",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$SkeletonBase = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q7iw92 _4t3i1crf _1bsbqkoa _2rko1y44 _otyrutpp",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$SkeletonSection = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1ejb",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$SectionHeaderSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $af0c023251a98909$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb68cl _4t3i7vkz",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$ItemSkeletonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$ItemAvatarSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $af0c023251a98909$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1tcg _4t3i1tcg _18u0utpp _2hwxutpp",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$CollapsibleHeaderSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $af0c023251a98909$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbys9h _18u0u2gc _19pkutpp",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$Footer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { hasMargin: hasMargin, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o",
                __cmplp.hasMargin && "_18s8u2gc",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$Type = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81vlj _y3gn1h6o _18s8swc3 _1tke7vkz _syaz1rc1",
                __cmplp.className
            ])
        });
    });
    var $af0c023251a98909$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($af0c023251a98909$var$MultiProjectMenu);
});
parcelRegister("8e8QT", function(module, exports) {
    $parcel$export(module.exports, "AsyncMobileDownloadPrompt", ()=>$7f26c5865794a560$export$64ca7d64bb703770);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $12nJ9;
    const $7f26c5865794a560$var$runtimeProps = {};
    const $7f26c5865794a560$var$entryPointParams = {};
    const $7f26c5865794a560$export$64ca7d64bb703770 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("12nJ9")).downloadMobilePromptEntryPoint), $7f26c5865794a560$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jiraBusinessDownloadMobilePrompt",
            packageName: (0, $244834d5fcf707c7$export$b8b9d90f9e5bd72b),
            teamName: "frontier",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $7f26c5865794a560$var$runtimeProps,
            errorFallback: "unmount"
        });
    };
});
parcelRegister("7XluA", function(module, exports) {
    $parcel$export(module.exports, "JiraEntryPointContainer", ()=>$f4c300dcb0cbacff$export$ee1e46af8fa2fb93);
    $parcel$export(module.exports, "NestedEntryPointContainer", ()=>$f4c300dcb0cbacff$export$54db9e88249c9162);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Bm0k;
    var $c5vfY;
    const $f4c300dcb0cbacff$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
        const entryPointReference = (0, (0, parcelRequire("8Bm0k")).useEntryPointSubscription)(entryPointReferenceSubject);
        return entryPointReference ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer), {
            ...containerProps,
            entryPointReference: entryPointReference,
            placeholderName: "jira-entry-point-container"
        }) : null;
    };
    const $f4c300dcb0cbacff$export$54db9e88249c9162 = (0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer);
});
parcelRegister("8Bm0k", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointSubscription", ()=>$0458c70c3d6616bf$export$3cd1c81e13390c49);
    var $5uXOq = parcelRequire("5uXOq");
    const $0458c70c3d6616bf$export$3cd1c81e13390c49 = (subject)=>{
        const [entryPointReference, setEntryPointReference] = (0, $5uXOq.useState)(subject.getValue);
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = subject.subscribe(setEntryPointReference);
            setEntryPointReference(subject.getValue());
            return unsubscribe;
        }, [
            subject
        ]);
        return entryPointReference;
    };
});
parcelRegister("c5vfY", function(module, exports) {
    $parcel$export(module.exports, "InternalEntryPointContainer", ()=>$df42b2d5b5551f77$export$5d4dc37edd8a3adb);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $7CMCs;
    var $lfTZh;
    var $l8ruj;
    const $df42b2d5b5551f77$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: id,
            packageName: packageName,
            teamName: teamName,
            attributes: errorAttributes,
            fallback: errorFallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: placeholderName ?? packageName ?? 'internal-entry-point-container',
            fallback: fallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: entryPointReference,
            props: runtimeProps
        }))));
});
parcelRegister("l8ruj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6056b4460d0127e0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $1tcYS;
    var $bFU4G;
    var $8Ec39;
    var $cEm1b;
    function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
        const interactionContext = (0, (0, parcelRequire("1tcYS")).useInteractionContext)();
        const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
                getInteractionContext: ()=>interactionContext,
                wrapPrepareQueryResource (cb) {
                    return cb();
                },
                retainQuery (info) {
                    this.getInteractionContext().retainQuery(info);
                }
            }), [
            interactionContext
        ]);
        const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
            const moduleLoadingRequests = {};
            return {
                current: {
                    getInteractionContext () {
                        return interactionContext;
                    },
                    onPreload (moduleId, _priority) {
                        this.getInteractionContext().addPreload((0, (0, parcelRequire("bFU4G")).extractModuleName)(moduleId), performance.now());
                    },
                    onLoadStart (info) {
                        const timeoutId = setTimeout(()=>{
                            delete moduleLoadingRequests[info.identifier];
                        }, 30000);
                        const request = {
                            start: performance.now(),
                            timeoutId: timeoutId
                        };
                        moduleLoadingRequests[info.identifier] = request;
                    },
                    onLoadComplete (info) {
                        const request = moduleLoadingRequests[info.identifier];
                        if (request) {
                            clearTimeout(request.timeoutId);
                            delete moduleLoadingRequests[info.identifier];
                            this.getInteractionContext()?.addLoad((0, (0, parcelRequire("bFU4G")).extractModuleName)(info.identifier), request.start, performance.now());
                        }
                    },
                    placeholderFallBackMounted (id, name, lazyWait) {
                        if (lazyWait) return;
                        this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                    },
                    placeholderFallBackUnmounted (id, name, lazyWait) {
                        if (lazyWait) return;
                        this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                    }
                }
            };
        }, [
            interactionContext
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
            value: relayProfilerContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cEm1b")).ProfilerContext).Provider, {
            value: reactLooselyLazyContext
        }, children));
    }
    function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Ec39")).default), {
            name: segmentName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
    }
});
parcelRegister("4mO32", function(module, exports) {
    $parcel$export(module.exports, "useEntryPoint", ()=>$f8987436643ccece$export$338256068bc140fb);
    var $5uXOq = parcelRequire("5uXOq");
    var $c8WsS;
    var $9CqsK;
    var $j1gA4;
    var $bzXq1;
    const $f8987436643ccece$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, (0, parcelRequire("c8WsS")).DEFAULT_OPTIONS))=>{
        const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, (0, parcelRequire("j1gA4")).useEntryPointLoadManager)(entryPoint, entryPointParams);
        const { startMetric: startMetric, stopMetric: stopMetric } = (0, (0, parcelRequire("bzXq1")).useMetricLogger)(metric);
        const entryPointActions = (0, (0, parcelRequire("9CqsK")).useEntryPointActions)(loadActions, options, startMetric);
        return (0, $5uXOq.useMemo)(()=>({
                entryPointActions: entryPointActions,
                entryPointReferenceSubject: entryPointReferenceSubject,
                stopMetric: stopMetric
            }), [
            entryPointActions,
            entryPointReferenceSubject,
            stopMetric
        ]);
    };
});
parcelRegister("c8WsS", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_OPTIONS", ()=>$34664e57314d5c26$export$93ca5d3f8675ae4c);
    const $34664e57314d5c26$export$93ca5d3f8675ae4c = {
        preloadMaxAge: 2000,
        timeToIntent: 200
    };
});
parcelRegister("9CqsK", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointActions", ()=>$7bc2afeacf23b901$export$90681c8c3a56f09a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jQsty;
    var $c8WsS;
    const $7bc2afeacf23b901$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
    const $7bc2afeacf23b901$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, (0, parcelRequire("c8WsS")).DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, (0, parcelRequire("c8WsS")).DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
        const preloadIntentTimeout = (0, $5uXOq.useRef)();
        const preloadMaxAgeTimeout = (0, $5uXOq.useRef)();
        const preloadLastRequested = (0, $5uXOq.useRef)(0);
        const cancelPreload = (0, $5uXOq.useCallback)(()=>{
            if (!(0, (0, parcelRequire("jQsty")).default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) {
                clearTimeout(preloadIntentTimeout.current);
                clearTimeout(preloadMaxAgeTimeout.current);
            }
        }, []);
        const load = (0, $5uXOq.useCallback)(()=>{
            cancelPreload();
            startMetric(preloadLastRequested.current);
            if (preloadLastRequested.current > 0) commitPreload();
            else loadEntryPoint();
            preloadLastRequested.current = 0;
        }, [
            cancelPreload,
            commitPreload,
            loadEntryPoint,
            startMetric
        ]);
        const preload = (0, $5uXOq.useCallback)(()=>{
            if ((0, (0, parcelRequire("jQsty")).default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) return;
            cancelPreload();
            preloadIntentTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = Date.now();
                loadEntryPoint({
                    isPreload: true
                });
                preloadMaxAgeTimeout.current = setTimeout(()=>{
                    preloadLastRequested.current = 0;
                }, preloadMaxAge);
            }, timeToIntent);
        }, [
            cancelPreload,
            loadEntryPoint,
            preloadMaxAge,
            timeToIntent
        ]);
        (0, $5uXOq.useEffect)(()=>cancelPreload, [
            cancelPreload
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                cancelPreload: cancelPreload,
                load: load,
                preload: preload,
                unload: unloadEntryPoint
            }), [
            cancelPreload,
            load,
            preload,
            unloadEntryPoint
        ]);
    };
});
parcelRegister("j1gA4", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointLoadManager", ()=>$d6e83c6db8fa388b$export$bfae318f9651db2f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $fiv1r;
    var $iU8T2;
    const $d6e83c6db8fa388b$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
        const environmentProvider = (0, (0, parcelRequire("fiv1r")).useJiraRelayEnvironmentProvider)();
        const canLoad = (0, $5uXOq.useRef)(true);
        const timer = (0, $5uXOq.useRef)();
        const entryPointReferenceQueue = (0, $5uXOq.useRef)([]);
        const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, (0, parcelRequire("iU8T2")).useEntryPointReferenceSubject)();
        const setNextUpdate = (0, $5uXOq.useCallback)((nextEntryPointReference)=>{
            setEntryPointReference(nextEntryPointReference);
            timer.current = setTimeout(()=>{
                const { current: currentQueue } = entryPointReferenceQueue;
                entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, (0, parcelRequire("iU8T2")).removeAll)(currentQueue) : (0, (0, parcelRequire("iU8T2")).removeInactiveLoads)(currentQueue);
            }, 0);
        }, [
            setEntryPointReference
        ]);
        const load = (0, $5uXOq.useCallback)(({ isPreload: isPreload } = {
            isPreload: false
        })=>{
            if (canLoad.current) {
                const reference = (0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
                entryPointReferenceQueue.current.unshift({
                    value: reference,
                    isPreload: isPreload
                });
                if (isPreload) entryPointReferenceQueue.current = (0, (0, parcelRequire("iU8T2")).removeRedundantPreloads)(entryPointReferenceQueue.current);
                else setNextUpdate(reference);
            }
        }, [
            entryPoint,
            entryPointParams,
            environmentProvider,
            setNextUpdate
        ]);
        const unload = (0, $5uXOq.useCallback)(()=>{
            setNextUpdate(null);
        }, [
            setNextUpdate
        ]);
        const commitPreload = (0, $5uXOq.useCallback)(()=>{
            const [firstItem] = entryPointReferenceQueue.current;
            if (firstItem?.isPreload) {
                firstItem.isPreload = false;
                setNextUpdate(firstItem.value);
            }
        }, [
            setNextUpdate
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                clearTimeout(timer.current);
                canLoad.current = false;
                entryPointReferenceQueue.current = (0, (0, parcelRequire("iU8T2")).removeAll)(entryPointReferenceQueue.current);
            }, []);
        return {
            entryPointReferenceSubject: (0, $5uXOq.useMemo)(()=>({
                    getValue: getValue,
                    subscribe: subscribe
                }), [
                getValue,
                subscribe
            ]),
            loadEntryPoint: load,
            unloadEntryPoint: unload,
            commitPreload: commitPreload
        };
    };
});
parcelRegister("fiv1r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41dee5a929ec50c3$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useJiraRelayEnvironmentProvider", ()=>$41dee5a929ec50c3$export$83fb48644dee72f0);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $5yJb9;
    function $41dee5a929ec50c3$export$2e2bcd8739ae039({ children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.RelayEnvironmentProvider), {
            environment: (0, (0, parcelRequire("5yJb9")).default)()
        }, children);
    }
    function $41dee5a929ec50c3$export$83fb48644dee72f0() {
        const environment = (0, $8Uumt.useRelayEnvironment)();
        return (0, $5uXOq.useMemo)(()=>({
                getEnvironment () {
                    return environment;
                }
            }), [
            environment
        ]);
    }
});
parcelRegister("iU8T2", function(module, exports) {
    $parcel$export(module.exports, "removeRedundantPreloads", ()=>$011b3d8d407c2901$export$a5b3b808f05fede2);
    $parcel$export(module.exports, "removeInactiveLoads", ()=>$011b3d8d407c2901$export$ae329fe3ea179cb4);
    $parcel$export(module.exports, "removeAll", ()=>$011b3d8d407c2901$export$1cfc7aad5cb1833b);
    $parcel$export(module.exports, "useEntryPointReferenceSubject", ()=>$011b3d8d407c2901$export$322c8997d351da6a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    const $011b3d8d407c2901$export$a5b3b808f05fede2 = (queue)=>{
        const [, ...potentialRedundantItems] = queue;
        potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
            if (isPreload) value.dispose();
        });
        return queue.filter(({ value: value })=>!value.isDisposed);
    };
    const $011b3d8d407c2901$export$ae329fe3ea179cb4 = (queue)=>{
        if (queue.length === 0) return [];
        const [activeItem, ...redundantItems] = queue;
        redundantItems.forEach(({ value: value })=>{
            value.dispose();
        });
        return [
            activeItem
        ];
    };
    const $011b3d8d407c2901$export$1cfc7aad5cb1833b = (queue)=>{
        queue.forEach(({ value: value })=>{
            value.dispose();
        });
        return [];
    };
    const $011b3d8d407c2901$export$322c8997d351da6a = ()=>{
        const value = (0, $5uXOq.useRef)(null);
        const subscribers = (0, $5uXOq.useRef)();
        const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
            if (!subscribers.current) subscribers.current = new Set();
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current?.delete(subscriber);
            };
        }, []);
        const setEntryPointReference = (0, $5uXOq.useCallback)((entryPointReference)=>{
            value.current = entryPointReference;
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        }, []);
        const getValue = (0, $5uXOq.useCallback)(()=>value.current, []);
        (0, $5uXOq.useEffect)(()=>()=>{
                subscribers.current?.clear();
            }, []);
        return {
            getValue: getValue,
            setEntryPointReference: setEntryPointReference,
            subscribe: subscribe
        };
    };
});
parcelRegister("bzXq1", function(module, exports) {
    $parcel$export(module.exports, "useMetricLogger", ()=>$25198ca8fad8a13c$export$f291ec7cea728e1);
    var $5uXOq = parcelRequire("5uXOq");
    const $25198ca8fad8a13c$export$f291ec7cea728e1 = (metric)=>{
        const preloadStartTime = (0, $5uXOq.useRef)(0);
        const loadStartTime = (0, $5uXOq.useRef)(0);
        const startMetric = (0, $5uXOq.useCallback)((preloadTime = 0)=>{
            if (metric) {
                metric.start();
                preloadStartTime.current = preloadTime;
                loadStartTime.current = Date.now();
            }
        }, [
            metric
        ]);
        const stopMetric = (0, $5uXOq.useCallback)((additionalCustomData)=>{
            if (metric) {
                const preloadData = preloadStartTime.current > 0 ? {
                    preloadToStartDuration: loadStartTime.current - preloadStartTime.current
                } : undefined;
                const metricData = preloadData || additionalCustomData ? {
                    customData: {
                        ...preloadData,
                        ...additionalCustomData
                    }
                } : undefined;
                metric.stop(metricData);
            }
        }, [
            metric
        ]);
        return {
            startMetric: startMetric,
            stopMetric: stopMetric
        };
    };
});
const $244834d5fcf707c7$export$b8b9d90f9e5bd72b = 'jiraBusinessMobileDownloadPrompt';
parcelRegister("12nJ9", function(module, exports) {
    $parcel$export(module.exports, "downloadMobilePromptEntryPoint", ()=>$15bca80131d9ba79$export$66f4c5613c7e964);
    var $eufEc;
    var $fEDBv;
    const $15bca80131d9ba79$export$66f4c5613c7e964 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("jyTpt")), {
            moduleId: "c94481ab"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("jyTpt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kpbiP").then(()=>parcelRequire('2ea9U'));
});
parcelRegister("cE2Qr", function(module, exports) {
    $parcel$export(module.exports, "useJswOnboarding", ()=>$796be817ff5bbbfa$export$7d91c0af4772787a);
    $parcel$export(module.exports, "useOpenTask", ()=>$796be817ff5bbbfa$export$594f006fa6a1b2e5);
    $parcel$export(module.exports, "useNudgeStep", ()=>$796be817ff5bbbfa$export$c5e63e44ad178ae8);
    $parcel$export(module.exports, "useQuickstartActions", ()=>$796be817ff5bbbfa$export$2c3cd14fff9d6e43);
    $parcel$export(module.exports, "useShouldShowNudge", ()=>$796be817ff5bbbfa$export$b0db7e46e369e1d9);
    $parcel$export(module.exports, "useInviteToProject", ()=>$796be817ff5bbbfa$export$71de79653346a1ea);
    $parcel$export(module.exports, "useShowVideoCards", ()=>$796be817ff5bbbfa$export$61185a9266f1f57a);
    $parcel$export(module.exports, "useProjectState", ()=>$796be817ff5bbbfa$export$ef4747ba36826d6a);
    $parcel$export(module.exports, "useQuickstartUiStatus", ()=>$796be817ff5bbbfa$export$522993b46d9f8266);
    $parcel$export(module.exports, "useIsLoaded", ()=>$796be817ff5bbbfa$export$aa4ba29241532382);
    $parcel$export(module.exports, "useIsFocusedOn", ()=>$796be817ff5bbbfa$export$ed5c755b733bf2b1);
    $parcel$export(module.exports, "useIsDismissed", ()=>$796be817ff5bbbfa$export$35fe0366802512dd);
    $parcel$export(module.exports, "useCompletedTaskList", ()=>$796be817ff5bbbfa$export$a41ee0d3b6938099);
    $parcel$export(module.exports, "useAllTasksCompleted", ()=>$796be817ff5bbbfa$export$4ae7b465b076be9);
    $parcel$export(module.exports, "useMountedNudges", ()=>$796be817ff5bbbfa$export$bf6e646c0476acad);
    $parcel$export(module.exports, "useHasEverSeen", ()=>$796be817ff5bbbfa$export$6b706bff94798d11);
    $parcel$export(module.exports, "useRoadmapState", ()=>$796be817ff5bbbfa$export$c98db656edc5b3e1);
    $parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", ()=>$796be817ff5bbbfa$export$a823278ac9d1112b);
    $parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", ()=>$796be817ff5bbbfa$export$cb9e0e8fe4df8490);
    $parcel$export(module.exports, "useHasNudgeActive", ()=>$796be817ff5bbbfa$export$521909e3dc7ab811);
    $parcel$export(module.exports, "QUICKSTART_UI_STATUS", ()=>(parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS);
    var $58GFP;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $8Bc5A;
    var $6RAg1;
    var $ieqoN;
    var $cGE52;
    var $3B5jO;
    var $4ji4w;
    const $796be817ff5bbbfa$export$390f32400eaf98c9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'jsw-onboarding-quickstart',
        initialState: (0, parcelRequire("cGE52")).initialState,
        actions: (0, parcelRequire("6RAg1"))
    });
    const $796be817ff5bbbfa$export$1cbc60d8dd921852 = (0, (0, parcelRequire("51nlc")).createSubscriber)($796be817ff5bbbfa$export$390f32400eaf98c9);
    const $796be817ff5bbbfa$export$7d91c0af4772787a = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9);
    const $796be817ff5bbbfa$export$638bfcfce1254bb8 = (0, (0, parcelRequire("gg7kZ")).createContainer)($796be817ff5bbbfa$export$390f32400eaf98c9, {});
    const $796be817ff5bbbfa$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
        const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state)] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN && itemNames.includes(state.openTask);
        return commonConditionsToShowNudge && state.hasNudgeActive;
    };
    const $796be817ff5bbbfa$export$ea14030920a5d8e6 = (state)=>state.openTask;
    const $796be817ff5bbbfa$export$594f006fa6a1b2e5 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: $796be817ff5bbbfa$export$ea14030920a5d8e6
    });
    const $796be817ff5bbbfa$export$a943afa434e9487a = (state)=>state.nudgeStep;
    const $796be817ff5bbbfa$export$c5e63e44ad178ae8 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: $796be817ff5bbbfa$export$a943afa434e9487a
    });
    const $796be817ff5bbbfa$export$2c3cd14fff9d6e43 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: null
    });
    const $796be817ff5bbbfa$export$b0db7e46e369e1d9 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: $796be817ff5bbbfa$export$9d731f44f82af09f
    });
    const $796be817ff5bbbfa$export$71de79653346a1ea = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
    });
    const $796be817ff5bbbfa$export$61185a9266f1f57a = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>{
            if (!state.projectState) return false;
            const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
            return Boolean(isNextGen && (userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).JIRA_ADMIN || userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN || isProjectAdmin));
        }
    });
    const $796be817ff5bbbfa$export$ef4747ba36826d6a = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.projectState
    });
    const $796be817ff5bbbfa$export$522993b46d9f8266 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>{
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            if (state.shouldRenderComponent === false) return (0, (0, parcelRequire("4ji4w")).getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED;
            return state.visibility[quickstartType];
        }
    });
    const $796be817ff5bbbfa$export$aa4ba29241532382 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.isQuickstartLoaded
    });
    const $796be817ff5bbbfa$export$ed5c755b733bf2b1 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.isFocusedOn
    });
    const $796be817ff5bbbfa$export$35fe0366802512dd = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>{
            const visibility = state.visibility[(0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state)];
            return visibility === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED;
        }
    });
    const $796be817ff5bbbfa$export$a41ee0d3b6938099 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.completedTaskList
    });
    const $796be817ff5bbbfa$export$4ae7b465b076be9 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>{
            if (!state.tasks) return null;
            return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
        }
    });
    const $796be817ff5bbbfa$export$bf6e646c0476acad = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.mountedNudges
    });
    const $796be817ff5bbbfa$export$6b706bff94798d11 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.hasEverSeenRoute
    });
    const $796be817ff5bbbfa$export$c98db656edc5b3e1 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>({
                roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
                roadmapIsListEmpty: state.roadmapIsListEmpty
            })
    });
    const $796be817ff5bbbfa$export$a823278ac9d1112b = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, (0, parcelRequire("58GFP")).SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN)
    });
    const $796be817ff5bbbfa$export$cb9e0e8fe4df8490 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, (0, parcelRequire("58GFP")).KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN && !state.completedTaskList.includes((0, (0, parcelRequire("8Bc5A")).KANBAN_ONBOARDING_TASK)))
    });
    const $796be817ff5bbbfa$export$521909e3dc7ab811 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.hasNudgeActive
    });
    const $796be817ff5bbbfa$export$f4a2be940259bf95 = (0, (0, parcelRequire("3sQ5x")).createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
    });
});
parcelRegister("58GFP", function(module, exports) {
    $parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$f40a08fc76eb112d);
    $parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$e3844688f2693533);
    $parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$e3cec071fcb2fbd3);
    $parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$21783d461e3ef6d);
    $parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$6cd1c1b2ba0f6e2d);
    $parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$57d877f2e01e0029);
    $parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$6f4213a3addc3fdb);
    $parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", ()=>$c364c398187f9175$export$7492b6cc3ef89883);
    $parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$7d9a4e0ef5194fe1);
    $parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$477ca3550da12e43);
    $parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$b5ab111fb8825075);
    $parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$14139f0ec41d437e);
    $parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$ebf7af45376deb8b);
    $parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$7b6945581ccdab4a);
    $parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$310a9ac5c28d65f6);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$4d29ee0c00eb5df4);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$6278b41164dbde6c);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$17a2f771efabf02f);
    $parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$bd14946bcde77195);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", ()=>$c364c398187f9175$export$e8df553a3f519284);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", ()=>$c364c398187f9175$export$97fc32bd703bb4d1);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", ()=>$c364c398187f9175$export$8eecdf6acea9494);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", ()=>$c364c398187f9175$export$ff16be7794ed4222);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$9917830b560a2f4);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$b0928b02ffab3875);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$fd75f6abc7861439);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$fb658bddae7f81bb);
    $parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$2bc7db2da3df8313);
    $parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", ()=>$c364c398187f9175$export$87a8fff98b5bc81);
    $parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$7c567eb725bd36f);
    $parcel$export(module.exports, "getIsJsmBlankProjectTemplate", ()=>$c364c398187f9175$export$73fd025e86012868);
    $parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", ()=>$c364c398187f9175$export$a062badd78c9993);
    const $c364c398187f9175$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
    const $c364c398187f9175$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
    const $c364c398187f9175$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
    const $c364c398187f9175$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
    const $c364c398187f9175$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
    const $c364c398187f9175$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
    const $c364c398187f9175$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
    const $c364c398187f9175$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
    const $c364c398187f9175$export$7d9a4e0ef5194fe1 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
    const $c364c398187f9175$export$477ca3550da12e43 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
    const $c364c398187f9175$export$7c0307155b744916 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
    const $c364c398187f9175$export$b5ab111fb8825075 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
    const $c364c398187f9175$export$14139f0ec41d437e = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
    const $c364c398187f9175$export$ebf7af45376deb8b = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
    const $c364c398187f9175$export$7b6945581ccdab4a = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
    const $c364c398187f9175$export$310a9ac5c28d65f6 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
    const $c364c398187f9175$export$136d17feb2f4285d = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
    const $c364c398187f9175$export$e288f4758e94a8cc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
    const $c364c398187f9175$export$4e9ac1417ba54bba = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
    const $c364c398187f9175$export$560c9f6765bf9af4 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
    const $c364c398187f9175$export$14d4c6dbbb62a127 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
    const $c364c398187f9175$export$1367ee12532c525f = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
    const $c364c398187f9175$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
    const $c364c398187f9175$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
    const $c364c398187f9175$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
    const $c364c398187f9175$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
    const $c364c398187f9175$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
    const $c364c398187f9175$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
    const $c364c398187f9175$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
    const $c364c398187f9175$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
    const $c364c398187f9175$export$9e38ad41d19608ee = 'jsm.blank-service-management';
    const $c364c398187f9175$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
    const $c364c398187f9175$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
    const $c364c398187f9175$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
    const $c364c398187f9175$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
    const $c364c398187f9175$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
    const $c364c398187f9175$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
    const $c364c398187f9175$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
    const $c364c398187f9175$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
    const $c364c398187f9175$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
    const $c364c398187f9175$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
    const $c364c398187f9175$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
    const $c364c398187f9175$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
    const $c364c398187f9175$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
    const $c364c398187f9175$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
    const $c364c398187f9175$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
    const $c364c398187f9175$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
    const $c364c398187f9175$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
    const $c364c398187f9175$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
    const $c364c398187f9175$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
    const $c364c398187f9175$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
    const $c364c398187f9175$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
    const $c364c398187f9175$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
    const $c364c398187f9175$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
    const $c364c398187f9175$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
    const $c364c398187f9175$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
    const $c364c398187f9175$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
    const $c364c398187f9175$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
    const $c364c398187f9175$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
    const $c364c398187f9175$export$87a8fff98b5bc81 = 'initial.project.template.name';
    const $c364c398187f9175$export$7c567eb725bd36f = 'jira.polaris:discovery';
    const $c364c398187f9175$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
    const $c364c398187f9175$export$f9776303073903dd = 'jira.polaris:roadmap';
    const $c364c398187f9175$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
    const $c364c398187f9175$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $c364c398187f9175$export$e8df553a3f519284 || T4JTemplateKey === $c364c398187f9175$export$8eecdf6acea9494 || T4JTemplateKey === $c364c398187f9175$export$9e38ad41d19608ee;
    const $c364c398187f9175$export$a062badd78c9993 = {
        [$c364c398187f9175$export$e82092c4fb277f9b]: $c364c398187f9175$export$b0928b02ffab3875,
        [$c364c398187f9175$export$fd75f6abc7861439]: $c364c398187f9175$export$b0928b02ffab3875,
        [$c364c398187f9175$export$5eddf3b31dd1858f]: $c364c398187f9175$export$50478ee5ecbf7a4d,
        [$c364c398187f9175$export$fb658bddae7f81bb]: $c364c398187f9175$export$50478ee5ecbf7a4d
    };
});
parcelRegister("8Bc5A", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$5f07ce956337ba8b$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "PACKAGE_TEAM_NAME", ()=>$5f07ce956337ba8b$export$2b3151a089bc8780);
    $parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", ()=>$5f07ce956337ba8b$export$6826d33e9a2c0119);
    $parcel$export(module.exports, "ROOT_TASK", ()=>$5f07ce956337ba8b$export$b580da85daad7757);
    $parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", ()=>$5f07ce956337ba8b$export$5eef19b26a4bbe70);
    $parcel$export(module.exports, "QUICKSTART_TYPE", ()=>$5f07ce956337ba8b$export$c57d251ae83aff51);
    $parcel$export(module.exports, "getBackendVisibilityKey", ()=>$5f07ce956337ba8b$export$d9df7fd23ab00c49);
    $parcel$export(module.exports, "KEY_OPEN", ()=>$5f07ce956337ba8b$export$93a67c1026e8cb7c);
    $parcel$export(module.exports, "KEY_DISMISSED", ()=>$5f07ce956337ba8b$export$a7dcb0b5013e932b);
    $parcel$export(module.exports, "KEY_TASK_GROUP", ()=>$5f07ce956337ba8b$export$f962b14e410d598f);
    $parcel$export(module.exports, "KEY_OPEN_TASK", ()=>$5f07ce956337ba8b$export$21e8355b28449456);
    $parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", ()=>$5f07ce956337ba8b$export$536a90031123e004);
    $parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", ()=>$5f07ce956337ba8b$export$3ccd291a1a3a4f6d);
    $parcel$export(module.exports, "KEY_IS_DEVOPS_PROJECT", ()=>$5f07ce956337ba8b$export$e5b557e3bbb7ec52);
    $parcel$export(module.exports, "ACTION_SUBJECT_ID", ()=>$5f07ce956337ba8b$export$9957974f8b4d8f74);
    $parcel$export(module.exports, "SOURCE", ()=>$5f07ce956337ba8b$export$83c8d7110915321e);
    $parcel$export(module.exports, "KEY_JSW_ONBOARDING", ()=>$5f07ce956337ba8b$export$8b9bd2a9275b0187);
    $parcel$export(module.exports, "convertToHaveSeenItTask", ()=>$5f07ce956337ba8b$export$ec43e7bf5973b10f);
    $parcel$export(module.exports, "ADD_COLUMNS_TASK", ()=>$5f07ce956337ba8b$export$cbeb719208f32c8a);
    $parcel$export(module.exports, "CREATE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$88c918f2cfaff86);
    $parcel$export(module.exports, "CREATE_ISSUE_TASK", ()=>$5f07ce956337ba8b$export$abbbea7c37c93cb5);
    $parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", ()=>$5f07ce956337ba8b$export$2a0253cb20f48a8);
    $parcel$export(module.exports, "INVITE_TEAMMATES_TASK", ()=>$5f07ce956337ba8b$export$f97428bb4b1991ec);
    $parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", ()=>$5f07ce956337ba8b$export$45eaf4204fcc7);
    $parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", ()=>$5f07ce956337ba8b$export$af57685e201438e8);
    $parcel$export(module.exports, "FIND_HELP_TASK", ()=>$5f07ce956337ba8b$export$d6c67e9aab4e2b26);
    $parcel$export(module.exports, "SET_UP_BOARD_TASK", ()=>$5f07ce956337ba8b$export$3de8c242d2b82f26);
    $parcel$export(module.exports, "GET_MOBILE_APP_TASK", ()=>$5f07ce956337ba8b$export$a01fa44f793dbfac);
    $parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", ()=>$5f07ce956337ba8b$export$6a4507e462fd41da);
    $parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", ()=>$5f07ce956337ba8b$export$e64c1dced6ac4458);
    $parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", ()=>$5f07ce956337ba8b$export$63b0e55f9c6454ac);
    $parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", ()=>$5f07ce956337ba8b$export$c1effb1c8979fe22);
    $parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", ()=>$5f07ce956337ba8b$export$d97d31d934dbb194);
    $parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", ()=>$5f07ce956337ba8b$export$cafb5bd13b02056b);
    $parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", ()=>$5f07ce956337ba8b$export$e55c18b809946e72);
    $parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", ()=>$5f07ce956337ba8b$export$de5640b9ae8140a7);
    $parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", ()=>$5f07ce956337ba8b$export$540b5c3c4b6ce459);
    $parcel$export(module.exports, "CHANGE_CONTROL_TASK", ()=>$5f07ce956337ba8b$export$6f71dff531ff592);
    $parcel$export(module.exports, "AUTOMATIONS_TASK", ()=>$5f07ce956337ba8b$export$83255ab79e45f34f);
    $parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", ()=>$5f07ce956337ba8b$export$b57d172af9ad7647);
    $parcel$export(module.exports, "USER_MANAGEMENT_TASK", ()=>$5f07ce956337ba8b$export$ff4c933c1fe90b68);
    $parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", ()=>$5f07ce956337ba8b$export$3e2776d61f3662dc);
    $parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", ()=>$5f07ce956337ba8b$export$9048315f2c03fd9d);
    $parcel$export(module.exports, "GET_TO_KNOW_YOUR_TEMPLATE_TASK", ()=>$5f07ce956337ba8b$export$a333714599f14a6);
    $parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", ()=>$5f07ce956337ba8b$export$4145c2cec2da6f9b);
    $parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", ()=>$5f07ce956337ba8b$export$4957a1ad203cf6dd);
    $parcel$export(module.exports, "CALENDAR_VIEW_TASK", ()=>$5f07ce956337ba8b$export$190b5dd0a1322552);
    $parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", ()=>$5f07ce956337ba8b$export$501166b25f254aab);
    $parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$94ad6507a703f4eb);
    $parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", ()=>$5f07ce956337ba8b$export$be1c522400a1bd7c);
    $parcel$export(module.exports, "JWM_CALENDAR_TASK", ()=>$5f07ce956337ba8b$export$2aa6e7b6e24a04f5);
    $parcel$export(module.exports, "JWM_TIMELINE_TASK", ()=>$5f07ce956337ba8b$export$f3b53199b07af2a1);
    $parcel$export(module.exports, "JWM_BUILD_FORM_TASK", ()=>$5f07ce956337ba8b$export$d37415ffddcf2142);
    $parcel$export(module.exports, "JWM_FEEDBACK_TASK", ()=>$5f07ce956337ba8b$export$2ae00586da7cb606);
    $parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$b86266e6594a97bb);
    $parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$20bc3dc137ac1c38);
    $parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$77071b77e2801b18);
    $parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$9c89f946f05d884a);
    $parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", ()=>$5f07ce956337ba8b$export$b52a7c936684cfc5);
    $parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", ()=>$5f07ce956337ba8b$export$b5555f24061f9fb);
    $parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", ()=>$5f07ce956337ba8b$export$ff25449f34b8abf);
    $parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", ()=>$5f07ce956337ba8b$export$3380e677209260fe);
    $parcel$export(module.exports, "GET_STARTED_LIST_TASK", ()=>$5f07ce956337ba8b$export$7a2fcaad1564e6b7);
    $parcel$export(module.exports, "OPS_JTBD_1_LIST", ()=>$5f07ce956337ba8b$export$da23b72d32bfad9e);
    $parcel$export(module.exports, "OPS_JTBD_2_BOARD", ()=>$5f07ce956337ba8b$export$4b064659282e0238);
    $parcel$export(module.exports, "OPS_JTBD_2_FORMS", ()=>$5f07ce956337ba8b$export$3ab51851f6d823e);
    $parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", ()=>$5f07ce956337ba8b$export$e4a1a37a9a1350ad);
    $parcel$export(module.exports, "OPS_JTBD_3_LIST", ()=>$5f07ce956337ba8b$export$b7f7da5e795f0327);
    $parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", ()=>$5f07ce956337ba8b$export$80a401c1aa47a377);
    $parcel$export(module.exports, "OPS_JTBD_3_PAGES", ()=>$5f07ce956337ba8b$export$934ac7a251b26dc7);
    $parcel$export(module.exports, "OPS_JTBD_4_LIST", ()=>$5f07ce956337ba8b$export$4634f6395df3ebbe);
    $parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", ()=>$5f07ce956337ba8b$export$768fb41107a1e8d7);
    $parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", ()=>$5f07ce956337ba8b$export$d797a81bace17184);
    $parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", ()=>$5f07ce956337ba8b$export$746102c94db9df1f);
    $parcel$export(module.exports, "OPS_JTBD_5_LIST", ()=>$5f07ce956337ba8b$export$5f1efd797d65e349);
    $parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", ()=>$5f07ce956337ba8b$export$cccc812ccafbf11f);
    $parcel$export(module.exports, "OPS_JTBD_5_PAGES", ()=>$5f07ce956337ba8b$export$64822db87abd8a47);
    $parcel$export(module.exports, "OPS_JTBD_6_PAGES", ()=>$5f07ce956337ba8b$export$64f764d8be495c82);
    $parcel$export(module.exports, "OPS_JTBD_7_LIST", ()=>$5f07ce956337ba8b$export$24eae23dc1c68bbd);
    $parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", ()=>$5f07ce956337ba8b$export$50fa92eba6f82feb);
    $parcel$export(module.exports, "OPS_JTBD_0_LIST", ()=>$5f07ce956337ba8b$export$4155d22fe3f14cd6);
    $parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", ()=>$5f07ce956337ba8b$export$76813cbead887191);
    $parcel$export(module.exports, "OPS_JTBD_0_PAGES", ()=>$5f07ce956337ba8b$export$90aab2ff89daf770);
    $parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", ()=>$5f07ce956337ba8b$export$a2bc0cbad2e6e605);
    $parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", ()=>$5f07ce956337ba8b$export$f90872a1280728bb);
    $parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", ()=>$5f07ce956337ba8b$export$bce644e96518cbd2);
    $parcel$export(module.exports, "MKT_JTBD_1_LIST", ()=>$5f07ce956337ba8b$export$241aaebffac0a3e5);
    $parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", ()=>$5f07ce956337ba8b$export$f9dfc43b5b31c4b7);
    $parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", ()=>$5f07ce956337ba8b$export$79759e9e62fb9312);
    $parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", ()=>$5f07ce956337ba8b$export$992d1e0dce255d19);
    $parcel$export(module.exports, "MKT_JTBD_2_PAGES", ()=>$5f07ce956337ba8b$export$d28c1b0e5b3e768);
    $parcel$export(module.exports, "MKT_JTBD_3_PAGES", ()=>$5f07ce956337ba8b$export$ca714ee197bed4ec);
    $parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", ()=>$5f07ce956337ba8b$export$faae55ceea4b6073);
    $parcel$export(module.exports, "MKT_JTBD_4_LIST", ()=>$5f07ce956337ba8b$export$200bc24cd120667e);
    $parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", ()=>$5f07ce956337ba8b$export$a0d784a48b4e886c);
    $parcel$export(module.exports, "MKT_JTBD_4_PAGES", ()=>$5f07ce956337ba8b$export$baf5bd09b4b33b8a);
    $parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", ()=>$5f07ce956337ba8b$export$4702007eedbca8ab);
    $parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", ()=>$5f07ce956337ba8b$export$aa9d2d635ea63898);
    $parcel$export(module.exports, "MKT_JTBD_6_FORMS", ()=>$5f07ce956337ba8b$export$2ea449225c1f6cac);
    $parcel$export(module.exports, "MKT_JTBD_0_LIST", ()=>$5f07ce956337ba8b$export$deb8b557e735e26a);
    $parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", ()=>$5f07ce956337ba8b$export$d45754df44e4c309);
    $parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", ()=>$5f07ce956337ba8b$export$78b2913b550edbb);
    $parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", ()=>$5f07ce956337ba8b$export$71243272608c58ab);
    $parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", ()=>$5f07ce956337ba8b$export$39a08f215c33bc39);
    $parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", ()=>$5f07ce956337ba8b$export$d2377f6a6fa3b49c);
    $parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", ()=>$5f07ce956337ba8b$export$befa8f6533309779);
    $parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", ()=>$5f07ce956337ba8b$export$736b40db8701ba6c);
    $parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", ()=>$5f07ce956337ba8b$export$99b0e09ff6f00490);
    $parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", ()=>$5f07ce956337ba8b$export$2a82344eb273eeff);
    $parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", ()=>$5f07ce956337ba8b$export$1de5766b7e640d6b);
    $parcel$export(module.exports, "DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$8ab0859f5b30b013);
    $parcel$export(module.exports, "DEVOPS_GET_TO_KNOW_JIRA_TASK", ()=>$5f07ce956337ba8b$export$d1f6d18c6698104c);
    $parcel$export(module.exports, "DEVOPS_NAVIGATE_YOUR_TOOLS_TASK", ()=>$5f07ce956337ba8b$export$e6ee159eee7adc1c);
    $parcel$export(module.exports, "DEVOPS_CAPTURE_INTEGRATIONS_TASK", ()=>$5f07ce956337ba8b$export$dd267ca1e3cd3bad);
    $parcel$export(module.exports, "DEVOPS_CREATE_AUTOMATION_RULES_TASK", ()=>$5f07ce956337ba8b$export$f14c8bffc35200d3);
    $parcel$export(module.exports, "DEVOPS_INVITE_TEAMMATES_TASK", ()=>$5f07ce956337ba8b$export$36cc22c9997d92a);
    $parcel$export(module.exports, "DEVOPS_FIND_HELP_TASK", ()=>$5f07ce956337ba8b$export$d651cc94a46ff383);
    $parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", ()=>$5f07ce956337ba8b$export$11c0696d49e68c93);
    $parcel$export(module.exports, "ACCOUNT_ID", ()=>$5f07ce956337ba8b$export$c8ab6996f562d0db);
    $parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", ()=>$5f07ce956337ba8b$export$2b5f951ad8e70cfe);
    $parcel$export(module.exports, "QUICKSTART_UI_STATUS", ()=>$5f07ce956337ba8b$export$5703447487aaccdf);
    $parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", ()=>$5f07ce956337ba8b$export$e0197e09cccd4e50);
    $parcel$export(module.exports, "PROJECT_SETTING_PAGES", ()=>$5f07ce956337ba8b$export$f779bbfe667acddc);
    $parcel$export(module.exports, "JSM_BUSINESS_TASKS", ()=>$5f07ce956337ba8b$export$38fbac7a5bf4aa33);
    $parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", ()=>$5f07ce956337ba8b$export$7578902c7f420a3);
    var $65Ltd;
    var $g5X3G;
    const $5f07ce956337ba8b$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
    const $5f07ce956337ba8b$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
    const $5f07ce956337ba8b$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
    const $5f07ce956337ba8b$var$completeDevopsTaskName = (taskId)=>`devops-onboarding-checklist.${taskId}`;
    const $5f07ce956337ba8b$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
    const $5f07ce956337ba8b$export$2b3151a089bc8780 = 'jlove-makkuro';
    const $5f07ce956337ba8b$export$6826d33e9a2c0119 = 320;
    const $5f07ce956337ba8b$export$b580da85daad7757 = 'root';
    const $5f07ce956337ba8b$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
    const $5f07ce956337ba8b$export$c57d251ae83aff51 = {
        JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
        OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
    };
    const $5f07ce956337ba8b$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
    const $5f07ce956337ba8b$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
    const $5f07ce956337ba8b$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
    const $5f07ce956337ba8b$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
    const $5f07ce956337ba8b$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
    const $5f07ce956337ba8b$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
    const $5f07ce956337ba8b$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
    const $5f07ce956337ba8b$export$e5b557e3bbb7ec52 = 'isDevopsProject';
    const $5f07ce956337ba8b$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
    const $5f07ce956337ba8b$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
    const $5f07ce956337ba8b$export$8b9bd2a9275b0187 = 'jsw.onboarding';
    const $5f07ce956337ba8b$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
    const $5f07ce956337ba8b$export$cbeb719208f32c8a = $5f07ce956337ba8b$var$completeJswTaskName('add-columns-task');
    const $5f07ce956337ba8b$export$88c918f2cfaff86 = $5f07ce956337ba8b$var$completeJswTaskName('create-project-task');
    const $5f07ce956337ba8b$export$abbbea7c37c93cb5 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task');
    const $5f07ce956337ba8b$export$2a0253cb20f48a8 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task-simplified');
    const $5f07ce956337ba8b$export$f97428bb4b1991ec = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-task');
    const $5f07ce956337ba8b$export$45eaf4204fcc7 = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-video-task');
    const $5f07ce956337ba8b$export$af57685e201438e8 = $5f07ce956337ba8b$var$completeJswTaskName('capture-integrations-task');
    const $5f07ce956337ba8b$export$d6c67e9aab4e2b26 = $5f07ce956337ba8b$var$completeJswTaskName('find-help-task');
    const $5f07ce956337ba8b$export$3de8c242d2b82f26 = $5f07ce956337ba8b$var$completeJswTaskName('set-up-board-task');
    const $5f07ce956337ba8b$export$a01fa44f793dbfac = $5f07ce956337ba8b$var$completeJswTaskName('get-mobile-app-task');
    const $5f07ce956337ba8b$export$6a4507e462fd41da = $5f07ce956337ba8b$var$completeJswTaskName('map-out-your-project-goals');
    const $5f07ce956337ba8b$export$e64c1dced6ac4458 = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work');
    const $5f07ce956337ba8b$export$63b0e55f9c6454ac = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
    const $5f07ce956337ba8b$export$c1effb1c8979fe22 = $5f07ce956337ba8b$var$completeJswTaskName('monitor-manage-risk');
    const $5f07ce956337ba8b$export$d97d31d934dbb194 = $5f07ce956337ba8b$var$completeJswTaskName('premium-reverse-trial-task');
    const $5f07ce956337ba8b$export$cafb5bd13b02056b = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task');
    const $5f07ce956337ba8b$export$e55c18b809946e72 = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task-non-admin');
    const $5f07ce956337ba8b$export$de5640b9ae8140a7 = $5f07ce956337ba8b$var$completeJswTaskName('standard-edition-overview-task');
    const $5f07ce956337ba8b$export$540b5c3c4b6ce459 = $5f07ce956337ba8b$var$completeJswTaskName('advanced-roadmaps-task');
    const $5f07ce956337ba8b$export$6f71dff531ff592 = $5f07ce956337ba8b$var$completeJswTaskName('change-control-task');
    const $5f07ce956337ba8b$export$83255ab79e45f34f = $5f07ce956337ba8b$var$completeJswTaskName('automations-task');
    const $5f07ce956337ba8b$export$b57d172af9ad7647 = $5f07ce956337ba8b$var$completeJswTaskName('site-administrations-task');
    const $5f07ce956337ba8b$export$ff4c933c1fe90b68 = $5f07ce956337ba8b$var$completeJswTaskName('user-management-task');
    const $5f07ce956337ba8b$export$3e2776d61f3662dc = $5f07ce956337ba8b$var$completeJswTaskName('scrum-onboarding-task');
    const $5f07ce956337ba8b$export$9048315f2c03fd9d = $5f07ce956337ba8b$var$completeJswTaskName('customize-site-name-task');
    const $5f07ce956337ba8b$export$a333714599f14a6 = $5f07ce956337ba8b$var$completeJswTaskName('get-to-know-your-template-task');
    const $5f07ce956337ba8b$export$4145c2cec2da6f9b = $5f07ce956337ba8b$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
    const $5f07ce956337ba8b$export$4957a1ad203cf6dd = $5f07ce956337ba8b$var$completeJswTaskName('try-atlassian-university-task');
    const $5f07ce956337ba8b$export$190b5dd0a1322552 = $5f07ce956337ba8b$var$completeJswTaskName('calendar-view-task');
    const $5f07ce956337ba8b$export$501166b25f254aab = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-project-summary-task');
    const $5f07ce956337ba8b$export$94ad6507a703f4eb = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-sample-project-task');
    const $5f07ce956337ba8b$export$be1c522400a1bd7c = $5f07ce956337ba8b$var$completeJwmTaskName('background-color-task');
    const $5f07ce956337ba8b$export$2aa6e7b6e24a04f5 = $5f07ce956337ba8b$var$completeJwmTaskName('calendar-task');
    const $5f07ce956337ba8b$export$f3b53199b07af2a1 = $5f07ce956337ba8b$var$completeJwmTaskName('timeline-task');
    const $5f07ce956337ba8b$export$d37415ffddcf2142 = $5f07ce956337ba8b$var$completeJwmTaskName('build-form-task');
    const $5f07ce956337ba8b$export$2ae00586da7cb606 = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-task');
    const $5f07ce956337ba8b$export$b86266e6594a97bb = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-sample-project-task');
    const $5f07ce956337ba8b$export$20bc3dc137ac1c38 = $5f07ce956337ba8b$var$completeJwmTaskName('create-your-own-project-task');
    const $5f07ce956337ba8b$export$77071b77e2801b18 = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-project-task');
    const $5f07ce956337ba8b$export$9c89f946f05d884a = $5f07ce956337ba8b$var$completeJwmTaskName('share-project-task');
    const $5f07ce956337ba8b$export$ce8b25442735839a = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-boards');
    const $5f07ce956337ba8b$export$31015cf4e430c94d = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-cards');
    const $5f07ce956337ba8b$export$b52a7c936684cfc5 = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-import');
    const $5f07ce956337ba8b$export$b5555f24061f9fb = $5f07ce956337ba8b$var$completeJwmTaskName('summary-and-reports-task');
    const $5f07ce956337ba8b$export$ff25449f34b8abf = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
    const $5f07ce956337ba8b$export$3380e677209260fe = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-key-differences');
    const $5f07ce956337ba8b$export$7a2fcaad1564e6b7 = $5f07ce956337ba8b$var$completeJwmTaskName('get-started-list-task');
    const $5f07ce956337ba8b$export$da23b72d32bfad9e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_1_LIST');
    const $5f07ce956337ba8b$export$4b064659282e0238 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
    const $5f07ce956337ba8b$export$3ab51851f6d823e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
    const $5f07ce956337ba8b$export$e4a1a37a9a1350ad = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
    const $5f07ce956337ba8b$export$b7f7da5e795f0327 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_LIST');
    const $5f07ce956337ba8b$export$80a401c1aa47a377 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
    const $5f07ce956337ba8b$export$934ac7a251b26dc7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
    const $5f07ce956337ba8b$export$4634f6395df3ebbe = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_LIST');
    const $5f07ce956337ba8b$export$768fb41107a1e8d7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
    const $5f07ce956337ba8b$export$d797a81bace17184 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
    const $5f07ce956337ba8b$export$746102c94db9df1f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
    const $5f07ce956337ba8b$export$5f1efd797d65e349 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_LIST');
    const $5f07ce956337ba8b$export$cccc812ccafbf11f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
    const $5f07ce956337ba8b$export$64822db87abd8a47 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
    const $5f07ce956337ba8b$export$64f764d8be495c82 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
    const $5f07ce956337ba8b$export$24eae23dc1c68bbd = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_LIST');
    const $5f07ce956337ba8b$export$50fa92eba6f82feb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
    const $5f07ce956337ba8b$export$4155d22fe3f14cd6 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_LIST');
    const $5f07ce956337ba8b$export$76813cbead887191 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
    const $5f07ce956337ba8b$export$90aab2ff89daf770 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
    const $5f07ce956337ba8b$export$a2bc0cbad2e6e605 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
    const $5f07ce956337ba8b$export$f90872a1280728bb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
    const $5f07ce956337ba8b$export$bce644e96518cbd2 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
    const $5f07ce956337ba8b$export$241aaebffac0a3e5 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_LIST');
    const $5f07ce956337ba8b$export$f9dfc43b5b31c4b7 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
    const $5f07ce956337ba8b$export$79759e9e62fb9312 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
    const $5f07ce956337ba8b$export$992d1e0dce255d19 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
    const $5f07ce956337ba8b$export$d28c1b0e5b3e768 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
    const $5f07ce956337ba8b$export$ca714ee197bed4ec = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
    const $5f07ce956337ba8b$export$faae55ceea4b6073 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
    const $5f07ce956337ba8b$export$200bc24cd120667e = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_LIST');
    const $5f07ce956337ba8b$export$a0d784a48b4e886c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
    const $5f07ce956337ba8b$export$baf5bd09b4b33b8a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
    const $5f07ce956337ba8b$export$4702007eedbca8ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
    const $5f07ce956337ba8b$export$aa9d2d635ea63898 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
    const $5f07ce956337ba8b$export$2ea449225c1f6cac = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
    const $5f07ce956337ba8b$export$deb8b557e735e26a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_LIST');
    const $5f07ce956337ba8b$export$d45754df44e4c309 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
    const $5f07ce956337ba8b$export$78b2913b550edbb = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
    const $5f07ce956337ba8b$export$71243272608c58ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
    const $5f07ce956337ba8b$export$39a08f215c33bc39 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
    const $5f07ce956337ba8b$export$d2377f6a6fa3b49c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
    const $5f07ce956337ba8b$export$befa8f6533309779 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
    const $5f07ce956337ba8b$export$736b40db8701ba6c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
    const $5f07ce956337ba8b$export$99b0e09ff6f00490 = $5f07ce956337ba8b$var$completeJsmTaskName('customize-your-request-types-task');
    const $5f07ce956337ba8b$export$2a82344eb273eeff = $5f07ce956337ba8b$var$completeJsmTaskName('review-your-channels-task');
    const $5f07ce956337ba8b$export$1de5766b7e640d6b = $5f07ce956337ba8b$var$completeJsmTaskName('invite-your-team-task');
    const $5f07ce956337ba8b$export$8ab0859f5b30b013 = $5f07ce956337ba8b$var$completeDevopsTaskName('welcome-to-your-project-task');
    const $5f07ce956337ba8b$export$d1f6d18c6698104c = $5f07ce956337ba8b$var$completeDevopsTaskName('get-to-know-jira-task');
    const $5f07ce956337ba8b$export$e6ee159eee7adc1c = $5f07ce956337ba8b$var$completeDevopsTaskName('navigate-your-tools-task');
    const $5f07ce956337ba8b$export$dd267ca1e3cd3bad = $5f07ce956337ba8b$var$completeDevopsTaskName('capture-integrations-task');
    const $5f07ce956337ba8b$export$f14c8bffc35200d3 = $5f07ce956337ba8b$var$completeDevopsTaskName('create-automation-rules-task');
    const $5f07ce956337ba8b$export$36cc22c9997d92a = $5f07ce956337ba8b$var$completeDevopsTaskName('invite-teammates-task');
    const $5f07ce956337ba8b$export$d651cc94a46ff383 = $5f07ce956337ba8b$var$completeDevopsTaskName('find-help-task');
    const $5f07ce956337ba8b$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
    const $5f07ce956337ba8b$export$c8ab6996f562d0db = (0, (0, parcelRequire("g5X3G")).toAccountId)('accountId');
    const $5f07ce956337ba8b$export$2b5f951ad8e70cfe = $5f07ce956337ba8b$var$completeJswTaskName('kanban-onboarding-task');
    const $5f07ce956337ba8b$export$5703447487aaccdf = {
        NOT_LOADED: 'NOT_LOADED',
        OPEN: 'OPEN',
        MINIMIZED: 'MINIMIZED',
        DISMISSED: 'DISMISSED'
    };
    const $5f07ce956337ba8b$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
    const $5f07ce956337ba8b$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
    const $5f07ce956337ba8b$export$f779bbfe667acddc = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS)
    ];
    const $5f07ce956337ba8b$export$38fbac7a5bf4aa33 = [
        $5f07ce956337ba8b$export$2a82344eb273eeff,
        $5f07ce956337ba8b$export$99b0e09ff6f00490,
        $5f07ce956337ba8b$export$1de5766b7e640d6b
    ];
    const $5f07ce956337ba8b$export$7578902c7f420a3 = [
        $5f07ce956337ba8b$export$88c918f2cfaff86,
        $5f07ce956337ba8b$export$6a4507e462fd41da,
        $5f07ce956337ba8b$export$e64c1dced6ac4458,
        $5f07ce956337ba8b$export$63b0e55f9c6454ac,
        $5f07ce956337ba8b$export$c1effb1c8979fe22,
        $5f07ce956337ba8b$export$cbeb719208f32c8a,
        $5f07ce956337ba8b$export$abbbea7c37c93cb5,
        $5f07ce956337ba8b$export$2a0253cb20f48a8,
        $5f07ce956337ba8b$export$f97428bb4b1991ec,
        $5f07ce956337ba8b$export$d6c67e9aab4e2b26,
        $5f07ce956337ba8b$export$3de8c242d2b82f26,
        $5f07ce956337ba8b$export$a01fa44f793dbfac,
        $5f07ce956337ba8b$export$45eaf4204fcc7,
        $5f07ce956337ba8b$export$af57685e201438e8,
        $5f07ce956337ba8b$export$d97d31d934dbb194,
        $5f07ce956337ba8b$export$cafb5bd13b02056b,
        $5f07ce956337ba8b$export$e55c18b809946e72,
        $5f07ce956337ba8b$export$de5640b9ae8140a7,
        $5f07ce956337ba8b$export$540b5c3c4b6ce459,
        $5f07ce956337ba8b$export$6f71dff531ff592,
        $5f07ce956337ba8b$export$83255ab79e45f34f,
        $5f07ce956337ba8b$export$b57d172af9ad7647,
        $5f07ce956337ba8b$export$ff4c933c1fe90b68,
        $5f07ce956337ba8b$export$77071b77e2801b18,
        $5f07ce956337ba8b$export$94ad6507a703f4eb,
        $5f07ce956337ba8b$export$501166b25f254aab,
        $5f07ce956337ba8b$export$be1c522400a1bd7c,
        $5f07ce956337ba8b$export$2aa6e7b6e24a04f5,
        $5f07ce956337ba8b$export$f3b53199b07af2a1,
        $5f07ce956337ba8b$export$d37415ffddcf2142,
        $5f07ce956337ba8b$export$2ae00586da7cb606,
        $5f07ce956337ba8b$export$9c89f946f05d884a,
        $5f07ce956337ba8b$export$20bc3dc137ac1c38,
        $5f07ce956337ba8b$export$b52a7c936684cfc5,
        $5f07ce956337ba8b$export$b5555f24061f9fb,
        $5f07ce956337ba8b$export$ff25449f34b8abf,
        $5f07ce956337ba8b$export$3380e677209260fe,
        $5f07ce956337ba8b$export$b86266e6594a97bb,
        $5f07ce956337ba8b$export$8ab0859f5b30b013,
        $5f07ce956337ba8b$export$d1f6d18c6698104c,
        $5f07ce956337ba8b$export$e6ee159eee7adc1c,
        $5f07ce956337ba8b$export$dd267ca1e3cd3bad,
        $5f07ce956337ba8b$export$f14c8bffc35200d3,
        $5f07ce956337ba8b$export$36cc22c9997d92a,
        $5f07ce956337ba8b$export$d651cc94a46ff383,
        $5f07ce956337ba8b$export$3e2776d61f3662dc,
        $5f07ce956337ba8b$export$2b5f951ad8e70cfe,
        $5f07ce956337ba8b$export$9048315f2c03fd9d,
        $5f07ce956337ba8b$export$a333714599f14a6,
        $5f07ce956337ba8b$export$4145c2cec2da6f9b,
        $5f07ce956337ba8b$export$4957a1ad203cf6dd,
        $5f07ce956337ba8b$export$7a2fcaad1564e6b7,
        $5f07ce956337ba8b$export$190b5dd0a1322552,
        $5f07ce956337ba8b$export$da23b72d32bfad9e,
        $5f07ce956337ba8b$export$4b064659282e0238,
        $5f07ce956337ba8b$export$3ab51851f6d823e,
        $5f07ce956337ba8b$export$e4a1a37a9a1350ad,
        $5f07ce956337ba8b$export$b7f7da5e795f0327,
        $5f07ce956337ba8b$export$80a401c1aa47a377,
        $5f07ce956337ba8b$export$934ac7a251b26dc7,
        $5f07ce956337ba8b$export$4634f6395df3ebbe,
        $5f07ce956337ba8b$export$768fb41107a1e8d7,
        $5f07ce956337ba8b$export$d797a81bace17184,
        $5f07ce956337ba8b$export$746102c94db9df1f,
        $5f07ce956337ba8b$export$5f1efd797d65e349,
        $5f07ce956337ba8b$export$cccc812ccafbf11f,
        $5f07ce956337ba8b$export$64822db87abd8a47,
        $5f07ce956337ba8b$export$64f764d8be495c82,
        $5f07ce956337ba8b$export$24eae23dc1c68bbd,
        $5f07ce956337ba8b$export$50fa92eba6f82feb,
        $5f07ce956337ba8b$export$4155d22fe3f14cd6,
        $5f07ce956337ba8b$export$76813cbead887191,
        $5f07ce956337ba8b$export$90aab2ff89daf770,
        $5f07ce956337ba8b$export$a2bc0cbad2e6e605,
        $5f07ce956337ba8b$export$f90872a1280728bb,
        $5f07ce956337ba8b$export$bce644e96518cbd2,
        $5f07ce956337ba8b$export$241aaebffac0a3e5,
        $5f07ce956337ba8b$export$f9dfc43b5b31c4b7,
        $5f07ce956337ba8b$export$79759e9e62fb9312,
        $5f07ce956337ba8b$export$992d1e0dce255d19,
        $5f07ce956337ba8b$export$d28c1b0e5b3e768,
        $5f07ce956337ba8b$export$ca714ee197bed4ec,
        $5f07ce956337ba8b$export$faae55ceea4b6073,
        $5f07ce956337ba8b$export$200bc24cd120667e,
        $5f07ce956337ba8b$export$a0d784a48b4e886c,
        $5f07ce956337ba8b$export$baf5bd09b4b33b8a,
        $5f07ce956337ba8b$export$4702007eedbca8ab,
        $5f07ce956337ba8b$export$aa9d2d635ea63898,
        $5f07ce956337ba8b$export$2ea449225c1f6cac,
        $5f07ce956337ba8b$export$deb8b557e735e26a,
        $5f07ce956337ba8b$export$d45754df44e4c309,
        $5f07ce956337ba8b$export$78b2913b550edbb,
        $5f07ce956337ba8b$export$71243272608c58ab,
        $5f07ce956337ba8b$export$39a08f215c33bc39,
        $5f07ce956337ba8b$export$d2377f6a6fa3b49c,
        $5f07ce956337ba8b$export$befa8f6533309779,
        $5f07ce956337ba8b$export$736b40db8701ba6c
    ];
});
parcelRegister("6RAg1", function(module, exports) {
    $parcel$export(module.exports, "changeTaskGroupParent", ()=>(parcelRequire("6fSBR")).nextChangeTaskGroupParent);
    $parcel$export(module.exports, "goBackToPreviousTaskGroup", ()=>(parcelRequire("6fSBR")).nextGoBackToPreviousTaskGroup);
    $parcel$export(module.exports, "setIsOpen", ()=>(parcelRequire("j6wxT")).setIsOpen);
    $parcel$export(module.exports, "refreshAppState", ()=>(parcelRequire("7mZ3t")).refreshAppState);
    $parcel$export(module.exports, "setNudgeStep", ()=>(parcelRequire("8UXiA")).setNudgeStep);
    $parcel$export(module.exports, "addMountedNudge", ()=>(parcelRequire("3iEb4")).addMountedNudge);
    $parcel$export(module.exports, "removeMountedNudge", ()=>(parcelRequire("3iEb4")).removeMountedNudge);
    $parcel$export(module.exports, "setShouldRenderComponent", ()=>(parcelRequire("7yDu9")).setShouldRenderComponent);
    $parcel$export(module.exports, "setProjectState", ()=>(parcelRequire("5UBG2")).setProjectState);
    $parcel$export(module.exports, "setHasNudgeActive", ()=>(parcelRequire("lHcRB")).setHasNudgeActive);
    $parcel$export(module.exports, "forceHideNudge", ()=>(parcelRequire("eiyXc")).forceHideNudge);
    $parcel$export(module.exports, "setHasEverSeenRoute", ()=>(parcelRequire("jZvbN")).setHasEverSeenRoute);
    $parcel$export(module.exports, "setRoadmapIsCreateEnabled", ()=>(parcelRequire("azcAL")).setRoadmapIsCreateEnabled);
    $parcel$export(module.exports, "setRoadmapIsListEmpty", ()=>(parcelRequire("azcAL")).setRoadmapIsListEmpty);
    $parcel$export(module.exports, "openNextTask", ()=>(parcelRequire("gbXQ5")).openNextTask);
    $parcel$export(module.exports, "resetIsQuickstartLoaded", ()=>(parcelRequire("iZuFy")).resetIsQuickstartLoaded);
    $parcel$export(module.exports, "refreshAppStateUiStatusOnly", ()=>(parcelRequire("70Fss")).refreshAppStateUiStatusOnly);
    $parcel$export(module.exports, "nextMarkAsCompletedTask", ()=>(parcelRequire("erLQY")).nextMarkAsCompletedTask);
    $parcel$export(module.exports, "nextSetChecklistItemSeen", ()=>(parcelRequire("dQPsy")).nextSetChecklistItemSeen);
    $parcel$export(module.exports, "nextSetChecklistIsDismissed", ()=>(parcelRequire("abQXL")).nextSetChecklistIsDismissed);
    $parcel$export(module.exports, "nextSetChecklistIsOpen", ()=>(parcelRequire("4VXxO")).nextSetChecklistIsOpen);
    $parcel$export(module.exports, "nextOpenTask", ()=>(parcelRequire("cUGWT")).nextOpenTask);
    $parcel$export(module.exports, "nextAutoExpand", ()=>(parcelRequire("boV1S")).nextAutoExpand);
    $parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", ()=>(parcelRequire("4Viq4")).nextShouldShowNudgeAfterNavigation);
    $parcel$export(module.exports, "nextGetTasks", ()=>(parcelRequire("jIoq4")).nextGetTasks);
    $parcel$export(module.exports, "syncVisibilityWithLocal", ()=>(parcelRequire("75A1x")).syncVisibilityWithLocal);
    var $6fSBR;
    var $j6wxT;
    var $7mZ3t;
    var $8UXiA;
    var $3iEb4;
    var $7yDu9;
    var $5UBG2;
    var $lHcRB;
    var $eiyXc;
    var $jZvbN;
    var $azcAL;
    var $gbXQ5;
    var $iZuFy;
    var $70Fss;
    var $erLQY;
    var $dQPsy;
    var $abQXL;
    var $4VXxO;
    var $cUGWT;
    var $boV1S;
    var $4Viq4;
    var $jIoq4;
    var $75A1x;
});
parcelRegister("6fSBR", function(module, exports) {
    $parcel$export(module.exports, "nextChangeTaskGroupParent", ()=>$0f1566e1d3fc2987$export$76708cce5888039a);
    $parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", ()=>$0f1566e1d3fc2987$export$57534cbc400a434c);
    var $8Bc5A;
    var $1ftPQ;
    const $0f1566e1d3fc2987$var$setTaskGroup = (taskGroup)=>({ setState: setState })=>{
            setState({
                ...taskGroup,
                openTask: ''
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP),
                value: {
                    taskGroup: taskGroup
                }
            });
        };
    const $0f1566e1d3fc2987$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
            const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
            if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) return;
            previousTaskGroupParents.push(currentTaskGroupParent);
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newCurrentTaskGroupParent
            };
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
        };
    const $0f1566e1d3fc2987$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
            const { previousTaskGroupParents: previousTaskGroupParents } = getState();
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, (0, parcelRequire("8Bc5A")).ROOT_TASK) : previousTaskGroupParents.pop();
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
        };
});
parcelRegister("1ftPQ", function(module, exports) {
    $parcel$export(module.exports, "pushToBackend", ()=>$d3dd40bf54ad27bf$export$583b2d2422a6757f);
    var $89SaW;
    var $4Pf62;
    var $jcw0u;
    var $jJZqs;
    const $d3dd40bf54ad27bf$var$getAccountId = ()=>{
        const { atlassianAccountId: atlassianAccountId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
        return atlassianAccountId;
    };
    const $d3dd40bf54ad27bf$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, (0, parcelRequire("89SaW")).setUserProperties)($d3dd40bf54ad27bf$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
            if (!response.ok) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, response.statusText);
        });
    const $d3dd40bf54ad27bf$var$trySetUserProperties = async (props, attemptCount)=>{
        try {
            await $d3dd40bf54ad27bf$var$setRemoteUserProperties(props);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'pushToBackend',
                    packageName: 'jiraOnboardingQuickstartCore',
                    teamName: 'jlove-makkuro'
                },
                attributes: {
                    action: 'pushToBackend',
                    actionSubject: 'jiraOnboardingChecklistCore',
                    attemptCount: attemptCount,
                    key: props.key,
                    reason: error && error.message
                },
                error: error
            });
            return false;
        }
        return true;
    };
    const $d3dd40bf54ad27bf$export$583b2d2422a6757f = async (props)=>{
        const success = await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 1);
        if (!success) await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 2);
    };
});
parcelRegister("j6wxT", function(module, exports) {
    $parcel$export(module.exports, "setIsOpen", ()=>$eefde484654068e9$export$dcf23146e0a40195);
    var $8Bc5A;
    var $1ftPQ;
    var $3B5jO;
    const $eefde484654068e9$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            const currentIsOpen = state.visibility[quickstartType] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
            if (isOpen === currentIsOpen) return;
            const quickstartStatus = isOpen ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                }
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                value: isOpen
            });
        };
    var $eefde484654068e9$export$2e2bcd8739ae039 = $eefde484654068e9$export$dcf23146e0a40195;
});
parcelRegister("3B5jO", function(module, exports) {
    $parcel$export(module.exports, "getQuickstartTypeSelector", ()=>$47424244d57f6abc$export$eae834ce0286017a);
    var $2vSU6;
    var $8Bc5A;
    const $47424244d57f6abc$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
    const $47424244d57f6abc$export$eae834ce0286017a = (state)=>{
        if ($47424244d57f6abc$export$6f17f2cb816105eb(state)) return (0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
        return (0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
    };
});
parcelRegister("7mZ3t", function(module, exports) {
    $parcel$export(module.exports, "refreshAppState", ()=>$ecf6e94ad9c4f8d6$export$797c35e2e1d0d014);
    var $4R6GH;
    var $8fqy8;
    var $8zOmE;
    var $bfWlw;
    var $ldyPw;
    var $8Bc5A;
    var $6yhDy;
    var $1ftPQ;
    var $52Vcw;
    var $ljzlb;
    var $3ORcf;
    var $6ypzr;
    var $4ji4w;
    var $abQXL;
    var $4VXxO;
    var $erLQY;
    var $6fSBR;
    const $ecf6e94ad9c4f8d6$var$allTasks = [
        ...(0, (0, parcelRequire("8Bc5A")).allTasksExcludingJSMBusinessTasks),
        ...(0, (0, parcelRequire("8Bc5A")).JSM_BUSINESS_TASKS)
    ];
    const $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const updatedState = {};
            const hasSeenTasks = [
                (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)((0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK)),
                (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)((0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
                (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)((0, (0, parcelRequire("8Bc5A")).STANDARD_EDITION_OVERVIEW_TASK))
            ];
            const { projectState: projectState = null } = getState();
            updatedState.isOpen = true;
            updatedState.isDismissed = false;
            updatedState.quickstartStateProjectType = projectType;
            let backendVisibilityKeys = [];
            let jsmTaskProjectKeys = [];
            updatedState.visibility = Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).reduce((acc, type)=>{
                acc[type] = (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
                return acc;
            }, {});
            backendVisibilityKeys = Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).map((type)=>(0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type));
            if (projectState?.projectId) jsmTaskProjectKeys = (0, (0, parcelRequire("8Bc5A")).JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
            const backendState = await (0, (0, parcelRequire("6yhDy")).pollBackend)({
                keys: [
                    (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                    (0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED),
                    (0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK),
                    (0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP),
                    (0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE),
                    (0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING),
                    (0, (0, parcelRequire("8Bc5A")).KEY_PREMIUM_TRIAL_REOPENED),
                    ...$ecf6e94ad9c4f8d6$var$allTasks,
                    ...hasSeenTasks,
                    ...backendVisibilityKeys,
                    ...jsmTaskProjectKeys
                ]
            });
            if (projectState && projectState.projectKey) updatedState.isDevOpsProject = await (0, (0, parcelRequire("3ORcf")).getIsDevOpsProject)(projectState.projectKey);
            const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
            if (backendStateExists) {
                updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                        ...(0, (0, parcelRequire("8Bc5A")).allTasksExcludingJSMBusinessTasks),
                        ...jsmTaskProjectKeys
                    ].includes(key) && backendState[key] === true);
                updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
                Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).forEach((type)=>{
                    if ((0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type)];
                    else if ((0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED) in backendState && backendState[0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED]) updatedState.visibility[type] = (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED;
                    else if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN] ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
                    (0, (0, parcelRequire("4ji4w")).setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
                });
                if ((0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP) in backendState) {
                    updatedState.currentTaskGroupParent = backendState[0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                    updatedState.previousTaskGroupParents = backendState[0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
                }
                if ((0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING) in backendState) {
                    if (typeof backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING] === 'object' && backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
                }
            }
            setState(updatedState);
            if ((updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION)) {
                dispatch((0, (0, parcelRequire("6fSBR")).nextGoBackToPreviousTaskGroup)());
                const analyticsEvent = createAnalyticsEvent({});
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
            }
            if (!(backendStateExists && (0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState)) try {
                const skipApplicationProperty = await (0, (0, parcelRequire("6ypzr")).getOnboardingSkipApplicationProperty)();
                if (skipApplicationProperty.quickstart) dispatch((0, (0, parcelRequire("abQXL")).nextSetChecklistIsDismissed)(true));
            } catch (error) {
                (0, (0, parcelRequire("52Vcw")).fireAPIErrorAnalytics)(error, 'skipOnboarding');
            }
            const jswTrackDeferSitenameSiteTrait = await (0, (0, parcelRequire("8fqy8")).getJswTrackDeferSitenameSiteTrait)(cloudId, {
                packageName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_NAME),
                teamName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_TEAM_NAME)
            });
            setState({
                isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
            });
            const setPremiumCardAudienceTrait = async (accountId)=>{
                if (accountId === null) return;
                const trait = await (0, (0, parcelRequire("ljzlb")).getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
                setState({
                    isCrossProjectBoardToPlanUpsell: trait?.value === true || false
                });
            };
            if (appEditions.software === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
            const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
            let isReverseTrialForJSW;
            if (isTargetedForReverseTrials && (0, (0, parcelRequire("4R6GH")).fg)('jsw_reverse_trials_feature_gate')) {
                const isOnboardingPremiumTrial = await (0, (0, parcelRequire("bfWlw")).getOnboardingPremiumTrial)();
                isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
            }
            if (!isReverseTrialForJSW && appEditions.software === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, (0, parcelRequire("8Bc5A")).KEY_PREMIUM_TRIAL_REOPENED]) {
                dispatch((0, (0, parcelRequire("4VXxO")).nextSetChecklistIsOpen)(true));
                dispatch((0, (0, parcelRequire("abQXL")).nextSetChecklistIsDismissed)(false));
                const taskToDispatch = isAdmin ? (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK) : (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
                dispatch((0, (0, parcelRequire("erLQY")).nextMarkAsCompletedTask)(taskToDispatch));
                dispatch((0, (0, parcelRequire("6fSBR")).nextChangeTaskGroupParent)(taskToDispatch));
                await (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                    key: (0, (0, parcelRequire("8Bc5A")).KEY_PREMIUM_TRIAL_REOPENED),
                    value: true
                });
                const analyticsEvent = createAnalyticsEvent({});
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                    isAdmin: isAdmin
                });
            }
            setState({
                canEditPlans: canEditPlans
            });
            setState({
                isQuickstartLoaded: true
            });
        };
});
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$22c4b4094038180c = 'team-type';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
parcelRegister("8fqy8", function(module, exports) {
    $parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", ()=>$77364531dfabe700$export$686752df505238be);
    $parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", ()=>$77364531dfabe700$export$6da79f996c267010);
    var $jcw0u;
    var $eusud;
    const $77364531dfabe700$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
    const $77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/site/`;
    const $77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/user/`;
    const $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
    const $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
    const $77364531dfabe700$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
            try {
                const url = endpoint + id;
                return await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'onboarding',
                        teamName: 'jlove-makkuro',
                        ...meta
                    },
                    attributes: {
                        subject: subject
                    },
                    error: error
                });
                return undefined;
            }
        };
    const $77364531dfabe700$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
            const personalization = await fetch(id, meta);
            return personalization?.attributes?.find((att)=>att.name === traitName);
        };
    const $77364531dfabe700$export$686752df505238be = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
    const $77364531dfabe700$export$6da79f996c267010 = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT);
});
parcelRegister("bfWlw", function(module, exports) {
    $parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", ()=>$a55f3307b43c0521$export$d9a9dd6206da5bef);
    $parcel$export(module.exports, "getOnboardingPremiumTrial", ()=>$a55f3307b43c0521$export$ef676f7f369f74fe);
    var $jcw0u;
    var $eusud;
    var $6c7t9;
    const $a55f3307b43c0521$var$endpoint = '/rest/onboarding/1.0/premium-trial';
    const $a55f3307b43c0521$export$d9a9dd6206da5bef = async ()=>{
        try {
            const localStorageOnboardingPremiumTrial = (0, (0, parcelRequire("6c7t9")).localStorageGetOnboardingPremiumTrial)();
            const localStorageOnboardingPremiumTrialCohort = (0, (0, parcelRequire("6c7t9")).localStorageGetOnboardingPremiumTrialCohort)();
            if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
                premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
                reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
            };
            const response = await (0, (0, parcelRequire("eusud")).performGetRequestWithRetry)($a55f3307b43c0521$var$endpoint);
            const premiumTrialOnSignup = response?.premiumTrialOnSignup;
            const reverseTrialCohort = response?.reverseTrialCohort;
            if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
                (0, (0, parcelRequire("6c7t9")).localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
                (0, (0, parcelRequire("6c7t9")).localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
                return {
                    premiumTrialOnSignup: premiumTrialOnSignup,
                    reverseTrialCohort: reverseTrialCohort
                };
            }
            throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getOnboardingPremiumTrialWithRethrow',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $a55f3307b43c0521$export$ef676f7f369f74fe = async ()=>{
        try {
            return await $a55f3307b43c0521$export$d9a9dd6206da5bef();
        } catch (e) {}
    };
});
parcelRegister("6c7t9", function(module, exports) {
    $parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", ()=>$fab9df2877e9db77$export$782df5489e5cfd1e);
    $parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", ()=>$fab9df2877e9db77$export$c3378895d06b5528);
    $parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", ()=>$fab9df2877e9db77$export$f83a7a49524e74ad);
    $parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", ()=>$fab9df2877e9db77$export$f389f8ca168b4a3a);
    var $bSSG7;
    var $jcw0u;
    const $fab9df2877e9db77$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
    const $fab9df2877e9db77$export$2f93fdc3330233dc = 'reverseTrialCohort';
    const $fab9df2877e9db77$var$localStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
    const $fab9df2877e9db77$export$782df5489e5cfd1e = ()=>{
        try {
            const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$3538ee3f5c6c8b5c);
            return value;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageGetOnboardingPremiumTrial',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return undefined;
        }
    };
    const $fab9df2877e9db77$export$c3378895d06b5528 = ()=>{
        try {
            const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$2f93fdc3330233dc);
            return value;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageGetOnboardingPremiumTrial',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return undefined;
        }
    };
    const $fab9df2877e9db77$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
        try {
            $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageSetOnboardingPremiumTrial',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
    const $fab9df2877e9db77$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
        try {
            $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$2f93fdc3330233dc, reverseTrialCohort);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageSetOnboardingPremiumTrial',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
});
parcelRegister("6yhDy", function(module, exports) {
    $parcel$export(module.exports, "pollBackend", ()=>$760653e5a4f27459$export$8420ef0cee98de);
    var $1sYcL;
    var $g5X3G;
    var $8Bc5A;
    const $760653e5a4f27459$export$8420ef0cee98de = async ({ keys: keys })=>{
        const { user: user } = await (0, (0, parcelRequire("1sYcL")).get)((0, (0, parcelRequire("g5X3G")).toBaseUrl)(''), {
            userProperties: keys,
            consumerMeta: {
                id: 'fetchUserProperties',
                packageName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_NAME),
                teamName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_TEAM_NAME)
            }
        });
        return user;
    };
});
parcelRegister("1sYcL", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$7fc92c544211ac93$export$3988ae62b71be9a3);
    var $lbWm4 = parcelRequire("lbWm4");
    var $3T6Xo = parcelRequire("3T6Xo");
    var $jcw0u;
    var $4R6GH;
    var $fZneA;
    var $eusud;
    var $fjcgS;
    var $atdLB;
    var $duUGa;
    let $7fc92c544211ac93$var$ufoExperiencesMap = {};
    const $7fc92c544211ac93$var$getUfoExperience = (key)=>{
        if (!$7fc92c544211ac93$var$ufoExperiencesMap[key]) $7fc92c544211ac93$var$ufoExperiencesMap[key] = new (0, (0, parcelRequire("duUGa")).UFOExperience)(key, {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Operation,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom
        });
        return $7fc92c544211ac93$var$ufoExperiencesMap[key];
    };
    const $7fc92c544211ac93$export$c907f169d33b2e25 = ()=>{
        $7fc92c544211ac93$var$ufoExperiencesMap = {};
    };
    const $7fc92c544211ac93$export$a5b7a8c3b1c6e775 = (baseUrl, { userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
        const params = new URLSearchParams();
        userProperties && params.append('user', userProperties.join(','));
        projectId !== undefined && params.append('projectId', projectId);
        projectProperties && params.append('project', projectProperties.join(','));
        instanceProperties && params.append('instance', instanceProperties.join(','));
        return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
    };
    const $7fc92c544211ac93$var$patchProperties = (response, propertiesPath)=>((0, (0, parcelRequire("4R6GH")).fg)('handle_null_response_for_fe_config_properties_call') ? response : true) && (0, ($parcel$interopDefault($lbWm4)))(response[propertiesPath], (value, prop)=>{
            try {
                response[propertiesPath][prop] = JSON.parse(value);
            } catch (error) {
                if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
                else throw error;
            }
        });
    const $7fc92c544211ac93$export$3988ae62b71be9a3 = async (baseUrl, options)=>{
        const ufoExperience = $7fc92c544211ac93$var$getUfoExperience(`${(0, ($parcel$interopDefault($3T6Xo)))(options.consumerMeta.packageName)}.${(0, ($parcel$interopDefault($3T6Xo)))(options.consumerMeta.id)}`);
        try {
            ufoExperience?.start();
            const url = $7fc92c544211ac93$export$a5b7a8c3b1c6e775(baseUrl, options);
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            if (response === null) (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                const payload = {
                    action: 'succeeded',
                    actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                    source: 'frontendConfigProperties',
                    attributes: {
                        package: consumerMeta.packageName,
                        id: consumerMeta.id,
                        isNullResponse: true
                    }
                };
                client.getInstance().sendOperationalEvent(payload);
            });
            $7fc92c544211ac93$var$patchProperties(response, 'user');
            $7fc92c544211ac93$var$patchProperties(response, 'instance');
            $7fc92c544211ac93$var$patchProperties(response, 'project');
            const { consumerMeta: consumerMeta } = options;
            (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                const payload = {
                    source: 'frontendConfigProperties',
                    action: 'success',
                    actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
                };
                client.getInstance().sendOperationalEvent(payload);
            });
            ufoExperience?.success();
            return (0, (0, parcelRequire("4R6GH")).fg)('handle_null_response_for_fe_config_properties_call') ? response || {
                user: {},
                instance: {},
                project: {}
            } : response;
        } catch (error) {
            const { consumerMeta: consumerMeta } = options;
            !(0, (0, parcelRequire("fZneA")).isClientFetchError)(error) && (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: consumerMeta.id,
                    packageName: consumerMeta.packageName,
                    teamName: consumerMeta.teamName
                },
                sendToPrivacyUnsafeSplunk: true
            });
            ufoExperience?.failure();
            throw error;
        }
    };
});
parcelRegister("52Vcw", function(module, exports) {
    $parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", ()=>$5dab66e6da9554ae$export$c98a6ee6aadb8055);
    $parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", ()=>$5dab66e6da9554ae$export$45d8c76e0490b3ec);
    $parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", ()=>$5dab66e6da9554ae$export$b1be4ae35a43115d);
    $parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", ()=>$5dab66e6da9554ae$export$fa4f266bd2444d14);
    $parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", ()=>$5dab66e6da9554ae$export$a68a2e5a69c8cd74);
    $parcel$export(module.exports, "fireAPIErrorAnalytics", ()=>$5dab66e6da9554ae$export$a4d7f1a52677d339);
    $parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", ()=>$5dab66e6da9554ae$export$160bb78a3b11a5a9);
    $parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", ()=>$5dab66e6da9554ae$export$6ccbe54cd3a5a12);
    $parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", ()=>$5dab66e6da9554ae$export$6c39ca65ca354e59);
    var $jcw0u;
    var $8zOmE;
    var $8Bc5A;
    var $izv86;
    const $5dab66e6da9554ae$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
        analyticsEvent.update({
            action: 'closed',
            actionSubject: 'button'
        });
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button closed', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), attributes);
    };
    const $5dab66e6da9554ae$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
        if (source === 'button') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
        else if (source === 'checklist') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
    };
    const $5dab66e6da9554ae$export$b1be4ae35a43115d = (analyticsEvent)=>{
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
    };
    const $5dab66e6da9554ae$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), {
            ...attributes
        });
    };
    const $5dab66e6da9554ae$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, (0, parcelRequire("izv86")).convertTaskIdToActionSubjectId)(completedTaskId), {
            taskId: completedTaskId
        });
    };
    const $5dab66e6da9554ae$export$a4d7f1a52677d339 = (error, endpointSource)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                error: error.message,
                endpointSource: endpointSource
            }
        });
    };
    const $5dab66e6da9554ae$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), {
            ...attributes
        });
    };
    const $5dab66e6da9554ae$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), {
            ...attributes
        });
    };
    const $5dab66e6da9554ae$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), {
            ...attributes
        });
    };
});
parcelRegister("izv86", function(module, exports) {
    $parcel$export(module.exports, "getProductType", ()=>$4725f5ccfabd2231$export$27e53caf66bae1d);
    $parcel$export(module.exports, "convertTaskIdToActionSubjectId", ()=>$4725f5ccfabd2231$export$3b914201960fa7a6);
    var $e4eHl = parcelRequire("e4eHl");
    var $2vSU6;
    const $4725f5ccfabd2231$export$d64a7dd8c7cd80e0 = {
        [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'workManagement',
        [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software',
        [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'serviceManagement'
    };
    const $4725f5ccfabd2231$export$27e53caf66bae1d = (projectType)=>{
        if (projectType) return $4725f5ccfabd2231$export$d64a7dd8c7cd80e0[projectType] || (0, ($parcel$interopDefault($e4eHl)))(projectType);
        return null;
    };
    const $4725f5ccfabd2231$export$3b914201960fa7a6 = (taskId)=>{
        if (!taskId) return '';
        return (0, ($parcel$interopDefault($e4eHl)))(taskId.split('.').pop());
    };
});
parcelRegister("ljzlb", function(module, exports) {
    $parcel$export(module.exports, "getCrossProjectBoardTrait", ()=>$9217b5bb53dd29c2$export$7f2186c37a3d095d);
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    var $8zOmE;
    var $8Bc5A;
    var $k9OK8;
    const $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
    const $9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
    const $9217b5bb53dd29c2$var$ONE_DAY = 86400000;
    const $9217b5bb53dd29c2$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
        try {
            const url = `${$9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
            const result = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
                synthetic: (0, (0, parcelRequire("4R6GH")).fg)('is_synthetic_tenant')
            });
            return result;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'quickstartApiError',
                    packageName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_NAME),
                    teamName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_TEAM_NAME)
                },
                attributes: {
                    error: error.message,
                    endpointSource: 'getJSWCrossProjectBoardTrait',
                    synthetic: (0, (0, parcelRequire("4R6GH")).fg)('is_synthetic_tenant')
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                attributes: []
            };
        }
    };
    const $9217b5bb53dd29c2$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
        const { get: get, persist: persist } = (0, (0, parcelRequire("k9OK8")).crossProjectBoardTraitSessionStorageProvider)();
        const sessionStorage = get();
        if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $9217b5bb53dd29c2$var$ONE_DAY) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
                synthetic: (0, (0, parcelRequire("4R6GH")).fg)('is_synthetic_tenant')
            });
            return sessionStorage.attribute;
        }
        const personalization = await $9217b5bb53dd29c2$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
        const attribute = personalization.attributes.find((att)=>att.name === $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
        if (attribute !== undefined) persist({
            attribute: attribute,
            date: Date.now(),
            userId: userId,
            siteId: siteId
        });
        return attribute;
    };
});
parcelRegister("k9OK8", function(module, exports) {
    $parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", ()=>$ee27e8acf854e0ab$export$99f3e48748c2a8c3);
    var $eNf8a;
    const $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider = (0, (0, parcelRequire("eNf8a")).createSessionExpirableStorageProvider)((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
    const $ee27e8acf854e0ab$export$99f3e48748c2a8c3 = ()=>{
        const persist = (toPersist)=>{
            $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.set((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a), toPersist);
        };
        const get = ()=>$ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.get((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
        return {
            get: get,
            persist: persist
        };
    };
});
parcelRegister("eNf8a", function(module, exports) {
    $parcel$export(module.exports, "createSessionStorageProvider", ()=>$b98f887ad675a269$export$a922b987e648d2fa);
    $parcel$export(module.exports, "createSessionExpirableStorageProvider", ()=>$b98f887ad675a269$export$e0a2e9a062c6a695);
    var $gJBT6 = parcelRequire("gJBT6");
    var $fNVZf;
    var $j9Vq5;
    const $b98f887ad675a269$export$a922b987e648d2fa = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>(0, (0, parcelRequire("fNVZf")).createStorageProvider)(appPrefix, (0, (0, parcelRequire("j9Vq5")).makeSessionStore)()));
    const $b98f887ad675a269$export$e0a2e9a062c6a695 = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const store = (0, (0, parcelRequire("j9Vq5")).makeSessionExpirableStore)();
        return store.namespace(appPrefix);
    });
});
parcelRegister("j9Vq5", function(module, exports) {
    $parcel$export(module.exports, "makeSessionStore", ()=>$93ac2abe604287b3$export$fb690882d627b3b5);
    $parcel$export(module.exports, "makeSessionExpirableStore", ()=>$93ac2abe604287b3$export$a8f626c8ded9a06c);
    var $fKgem = parcelRequire("fKgem");
    var $kzObv = parcelRequire("kzObv");
    var $c4CII = parcelRequire("c4CII");
    var $2NjNT = parcelRequire("2NjNT");
    var $c74za = parcelRequire("c74za");
    var $fNVZf;
    const $93ac2abe604287b3$export$fb690882d627b3b5 = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($c74za))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], (0, (0, parcelRequire("fNVZf")).plugins));
    const $93ac2abe604287b3$export$a8f626c8ded9a06c = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($c74za))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], [
            (0, ($parcel$interopDefault($fKgem))),
            (0, ($parcel$interopDefault($kzObv)))
        ]);
});
const $111ca51573c84ae8$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';
parcelRegister("3ORcf", function(module, exports) {
    $parcel$export(module.exports, "getIsDevOpsProject", ()=>$d5d39abfab8df073$export$88ee873472aa9bb7);
    var $8Bc5A;
    const $d5d39abfab8df073$var$projectPropertyUrl = (projectKey)=>`/rest/api/2/project/${projectKey}/properties/${0, (0, parcelRequire("8Bc5A")).KEY_IS_DEVOPS_PROJECT}`;
    const $d5d39abfab8df073$export$88ee873472aa9bb7 = async (projectKey)=>{
        const url = $d5d39abfab8df073$var$projectPropertyUrl(projectKey);
        const response = await fetch(url);
        if (response.ok) {
            const result = await response.json();
            return result.value;
        }
        return false;
    };
});
parcelRegister("6ypzr", function(module, exports) {
    $parcel$export(module.exports, "getOnboardingSkipApplicationProperty", ()=>$98fe78eb4dc2e758$export$980c26b6f100081d);
    var $eusud;
    const $98fe78eb4dc2e758$export$980c26b6f100081d = ()=>(0, (0, parcelRequire("eusud")).performGetRequest)('/rest/onboarding/1.0/skip');
});
parcelRegister("4ji4w", function(module, exports) {
    $parcel$export(module.exports, "getNextNonCompleteTask", ()=>$af696889329ec63a$export$b61dc70e2ed3fae3);
    $parcel$export(module.exports, "getNextTask", ()=>$af696889329ec63a$export$404421ce8f3cbf9a);
    $parcel$export(module.exports, "setLocalStorageItem", ()=>$af696889329ec63a$export$5aa524d86254b4f);
    $parcel$export(module.exports, "getLocalStorageItem", ()=>$af696889329ec63a$export$93d719890ad66653);
    var $bSSG7;
    var $aFsRe;
    const $af696889329ec63a$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
        const taskPosition = (0, (0, parcelRequire("aFsRe")).getTaskIndex)(tasks, openTask);
        const start = taskPosition === -1 ? 0 : taskPosition;
        const len = tasks.length;
        for(let i = start; i < start + len; i += 1){
            const ind = i % len;
            if (!completed.includes(tasks[ind])) return tasks[ind];
        }
        return null;
    };
    const $af696889329ec63a$export$404421ce8f3cbf9a = (tasks, openTask)=>{
        const taskPosition = (0, (0, parcelRequire("aFsRe")).getTaskIndex)(tasks, openTask);
        const ind = taskPosition === -1 ? 0 : taskPosition;
        return tasks[ind] ? tasks[ind] : null;
    };
    const $af696889329ec63a$var$store = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('quickstart');
    const $af696889329ec63a$export$5aa524d86254b4f = (key, value)=>{
        $af696889329ec63a$var$store.set(key, value);
    };
    const $af696889329ec63a$export$93d719890ad66653 = (key)=>$af696889329ec63a$var$store.get(key);
});
parcelRegister("aFsRe", function(module, exports) {
    $parcel$export(module.exports, "getTaskIndex", ()=>$856e0575daef172f$export$9ba3adcb1954c00);
    $parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", ()=>$856e0575daef172f$export$9711f11998d5795c);
    $parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", ()=>$856e0575daef172f$export$995248f3b43d8505);
    $parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", ()=>$856e0575daef172f$export$293f6b2affa6ea5a);
    var $izv86;
    const $856e0575daef172f$export$9ba3adcb1954c00 = (taskList, taskId)=>{
        if (!taskList || taskId === null) return -1;
        return taskList.indexOf(taskId) + 1;
    };
    const $856e0575daef172f$export$9711f11998d5795c = (taskId)=>`${(0, (0, parcelRequire("izv86")).convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
    const $856e0575daef172f$export$995248f3b43d8505 = (taskId)=>`${(0, (0, parcelRequire("izv86")).convertTaskIdToActionSubjectId)(taskId)}Link`;
    const $856e0575daef172f$export$293f6b2affa6ea5a = (taskId)=>`${(0, (0, parcelRequire("izv86")).convertTaskIdToActionSubjectId)(taskId)}Cta`;
});
parcelRegister("abQXL", function(module, exports) {
    $parcel$export(module.exports, "nextSetChecklistIsDismissed", ()=>$dc09dffee9419aae$export$f24c05f83b880547);
    var $8Bc5A;
    var $1ftPQ;
    var $3B5jO;
    var $4ji4w;
    const $dc09dffee9419aae$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            const currentIsDismissed = state.visibility[quickstartType] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED;
            if (isDismissed === currentIsDismissed) return;
            const quickstartStatus = isDismissed ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                },
                isFocusedOn: !isDismissed
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            (0, (0, parcelRequire("4ji4w")).setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
            if (isDismissed === false) (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                value: true
            });
            else (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                value: false
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED),
                value: isDismissed
            });
        };
});
parcelRegister("4VXxO", function(module, exports) {
    $parcel$export(module.exports, "nextSetChecklistIsOpen", ()=>$7815e3bf96163d46$export$4249eabbb34e2e69);
    var $8Bc5A;
    var $1ftPQ;
    var $3B5jO;
    var $4ji4w;
    const $7815e3bf96163d46$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            const currentIsOpen = state.visibility[quickstartType] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
            const currentIsMinimised = state.visibility[quickstartType] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
            if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) return;
            const quickstartStatus = isOpen ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                },
                hasNudgeActive: false,
                isFocusedOn: isOpen
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            (0, (0, parcelRequire("4ji4w")).setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                value: isOpen
            });
        };
});
parcelRegister("erLQY", function(module, exports) {
    $parcel$export(module.exports, "nextMarkAsCompletedTask", ()=>$f082da41253fd664$export$d6628d41a3bec42d);
    var $1ftPQ;
    const $f082da41253fd664$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
            const { completedTaskList: completedTaskList } = getState();
            if (completedTaskList.includes(taskId)) return;
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: taskId,
                value: true
            });
            setState({
                completedTaskList: [
                    ...completedTaskList,
                    taskId
                ]
            });
        };
});
parcelRegister("8UXiA", function(module, exports) {
    $parcel$export(module.exports, "setNudgeStep", ()=>$2d15900fae273e3c$export$4debc323813b6997);
    const $2d15900fae273e3c$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
            const { nudgeStep: nudgeStep } = getState();
            if (nudge === nudgeStep) return;
            setState({
                nudgeStep: nudge
            });
        };
    var $2d15900fae273e3c$export$2e2bcd8739ae039 = $2d15900fae273e3c$export$4debc323813b6997;
});
parcelRegister("3iEb4", function(module, exports) {
    $parcel$export(module.exports, "addMountedNudge", ()=>$d23aba2b0749d2be$export$92a89c32d0ea3943);
    $parcel$export(module.exports, "removeMountedNudge", ()=>$d23aba2b0749d2be$export$748f4cda8ab98c91);
    const $d23aba2b0749d2be$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
            const { mountedNudges: mountedNudges } = getState();
            if (mountedNudges.includes(nudge)) return;
            setState({
                mountedNudges: [
                    ...mountedNudges,
                    nudge
                ]
            });
        };
    const $d23aba2b0749d2be$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
            const { mountedNudges: mountedNudges } = getState();
            if (!mountedNudges.includes(nudge)) return;
            setState({
                mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
            });
        };
});
parcelRegister("7yDu9", function(module, exports) {
    $parcel$export(module.exports, "setShouldRenderComponent", ()=>$e7988e1b8f7782bd$export$1f9c6770ed938b6e);
    const $e7988e1b8f7782bd$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
            const { shouldRenderComponent: currentShouldRenderComponent } = getState();
            if (shouldRenderComponent === currentShouldRenderComponent) return;
            setState({
                shouldRenderComponent: shouldRenderComponent
            });
        };
    var $e7988e1b8f7782bd$export$2e2bcd8739ae039 = $e7988e1b8f7782bd$export$1f9c6770ed938b6e;
});
parcelRegister("5UBG2", function(module, exports) {
    $parcel$export(module.exports, "setProjectState", ()=>$72dc29ca0b198f0e$export$1ba498e440c0a1e4);
    const $72dc29ca0b198f0e$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
            setState({
                projectState: projectState
            });
        };
    var $72dc29ca0b198f0e$export$2e2bcd8739ae039 = $72dc29ca0b198f0e$export$1ba498e440c0a1e4;
});
parcelRegister("lHcRB", function(module, exports) {
    $parcel$export(module.exports, "setHasNudgeActive", ()=>$4ecbca1b06d3bc5e$export$497c281e6eb0786e);
    const $4ecbca1b06d3bc5e$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
            const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
            if (hasNudgeActive === currentHasNudgeActive) return;
            if (hasNudgeActive === false && itemName !== openTask) return;
            setState({
                hasNudgeActive: hasNudgeActive
            });
        };
    var $4ecbca1b06d3bc5e$export$2e2bcd8739ae039 = $4ecbca1b06d3bc5e$export$497c281e6eb0786e;
});
parcelRegister("eiyXc", function(module, exports) {
    $parcel$export(module.exports, "forceHideNudge", ()=>$7ab5d12e3e83c16f$export$6d1ed97b83a62e8e);
    const $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
            setState({
                hasNudgeActive: false
            });
        };
});
parcelRegister("jZvbN", function(module, exports) {
    $parcel$export(module.exports, "setHasEverSeenRoute", ()=>$bde38543b00c29f3$export$28e0a4314a1ce52f);
    var $8Bc5A;
    var $1ftPQ;
    const $bde38543b00c29f3$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
            const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
            const somethingHasBeenUpdated = Object.keys(update).some((key)=>update[key] !== currentHasEverSeenRoute[key]);
            if (!somethingHasBeenUpdated) return;
            const newHasEverSeenRoute = {
                ...currentHasEverSeenRoute,
                ...update
            };
            setState({
                hasEverSeenRoute: newHasEverSeenRoute
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE),
                value: newHasEverSeenRoute
            });
        };
    var $bde38543b00c29f3$export$2e2bcd8739ae039 = $bde38543b00c29f3$export$28e0a4314a1ce52f;
});
parcelRegister("azcAL", function(module, exports) {
    $parcel$export(module.exports, "setRoadmapIsCreateEnabled", ()=>$f19987e3027503ab$export$35ea35d1a8e07307);
    $parcel$export(module.exports, "setRoadmapIsListEmpty", ()=>$f19987e3027503ab$export$932967764e7a0b31);
    const $f19987e3027503ab$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
            const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
            if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
            setState({
                roadmapIsCreateEnabled: roadmapIsCreateEnabled
            });
        };
    const $f19987e3027503ab$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
            const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
            if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
            setState({
                roadmapIsListEmpty: roadmapIsListEmpty
            });
        };
});
parcelRegister("gbXQ5", function(module, exports) {
    $parcel$export(module.exports, "openNextTask", ()=>$460159056a360dfc$export$867dbb6d61569ae9);
    var $4ji4w;
    var $cUGWT;
    const $460159056a360dfc$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
            const { openTask: openTask, tasks: tasks } = getState();
            if (!tasks) return;
            const { items: items } = tasks;
            const taskIdToExpand = (0, (0, parcelRequire("4ji4w")).getNextTask)(items, openTask);
            if (taskIdToExpand === null) return;
            dispatch((0, (0, parcelRequire("cUGWT")).nextOpenTask)(taskIdToExpand));
        };
});
parcelRegister("cUGWT", function(module, exports) {
    $parcel$export(module.exports, "nextOpenTask", ()=>$f8b3135a172025f8$export$5deb889489d2f989);
    $parcel$export(module.exports, "nextAutoOpenTask", ()=>$f8b3135a172025f8$export$cc5f3544a6cb2922);
    var $8Bc5A;
    var $1ftPQ;
    var $8UXiA;
    var $lHcRB;
    const $f8b3135a172025f8$var$openTask = (taskId)=>({ setState: setState })=>{
            setState({
                openTask: taskId
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK),
                value: taskId
            });
        };
    const $f8b3135a172025f8$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
            dispatch($f8b3135a172025f8$var$openTask(taskId));
            const { completedTaskList: completedTaskList } = getState();
            const taskIsCompleted = completedTaskList.includes(taskId);
            const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
            if (closeNudge) dispatch((0, (0, parcelRequire("lHcRB")).setHasNudgeActive)(false, taskId));
            else dispatch((0, (0, parcelRequire("lHcRB")).setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
            if (taskIdExistsAndIsNotCompleted && taskId === (0, (0, parcelRequire("8Bc5A")).SCRUM_ONBOARDING_TASK)) dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)((0, $6784cbc7d62e5d7c$export$b1a6ab17737f33e)));
            else if (taskIdExistsAndIsNotCompleted && taskId === (0, (0, parcelRequire("8Bc5A")).KANBAN_ONBOARDING_TASK)) dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
            else if (taskIdExistsAndIsNotCompleted && taskId === (0, (0, parcelRequire("8Bc5A")).ADD_COLUMNS_TASK)) dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
            else dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)(''));
        };
    const $f8b3135a172025f8$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
            dispatch($f8b3135a172025f8$var$openTask(taskId));
            dispatch((0, (0, parcelRequire("lHcRB")).setHasNudgeActive)(false, taskId));
            dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)(''));
        };
});
parcelRegister("iZuFy", function(module, exports) {
    $parcel$export(module.exports, "resetIsQuickstartLoaded", ()=>$b50ce46f86d3e3d7$export$bda085a823763e5a);
    var $8Bc5A;
    var $3B5jO;
    const $b50ce46f86d3e3d7$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED
                },
                hasNudgeActive: false,
                isQuickstartLoaded: false
            });
        };
});
parcelRegister("70Fss", function(module, exports) {
    $parcel$export(module.exports, "refreshAppStateUiStatusOnly", ()=>$f0fdda8951af3bde$export$87fe8079a4ed9766);
    var $8Bc5A;
    var $6yhDy;
    var $52Vcw;
    var $6ypzr;
    var $abQXL;
    const $f0fdda8951af3bde$export$87fe8079a4ed9766 = ({ taskList: taskList })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const updatedState = {};
            const { projectState: projectState } = getState();
            if (!projectState) return;
            updatedState.isOpen = true;
            updatedState.isDismissed = false;
            updatedState.quickstartStateProjectType = projectState.projectType;
            let backendVisibilityKeys = [];
            updatedState.visibility = Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).reduce((acc, type)=>{
                acc[type] = (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
                return acc;
            }, {});
            backendVisibilityKeys = Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).map((type)=>(0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type));
            const backendState = await (0, (0, parcelRequire("6yhDy")).pollBackend)({
                keys: [
                    (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                    (0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED),
                    (0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK),
                    (0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE),
                    (0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING),
                    ...(0, (0, parcelRequire("8Bc5A")).allTasksExcludingJSMBusinessTasks),
                    ...backendVisibilityKeys
                ]
            });
            const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
            if (backendStateExists) {
                updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                        ...(0, (0, parcelRequire("8Bc5A")).allTasksExcludingJSMBusinessTasks)
                    ].includes(key) && backendState[key] === true);
                Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).forEach((type)=>{
                    if ((0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type)];
                    else if ((0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED) in backendState && backendState[0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED]) updatedState.visibility[type] = (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED;
                    else if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN] ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
                });
                if ((0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP) in backendState) {
                    updatedState.currentTaskGroupParent = backendState[0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                    updatedState.previousTaskGroupParents = backendState[0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
                }
                if ((0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING) in backendState) {
                    if (typeof backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING] === 'object' && backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
                }
            }
            setState(updatedState);
            if (!(backendStateExists && (0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState)) try {
                const skipApplicationProperty = await (0, (0, parcelRequire("6ypzr")).getOnboardingSkipApplicationProperty)();
                if (skipApplicationProperty.quickstart) dispatch((0, (0, parcelRequire("abQXL")).nextSetChecklistIsDismissed)(true));
            } catch (error) {
                (0, (0, parcelRequire("52Vcw")).fireAPIErrorAnalytics)(error, 'skipOnboarding');
            }
            setState({
                taskList: taskList
            });
            setState({
                isQuickstartLoaded: true
            });
        };
});
parcelRegister("dQPsy", function(module, exports) {
    $parcel$export(module.exports, "nextSetChecklistItemSeen", ()=>$82a74350685dcd25$export$4eac017dcde0be8f);
    var $8Bc5A;
    var $1ftPQ;
    const $82a74350685dcd25$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
            const hasSeenTaskId = (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)(taskId);
            const { hasSeenTasks: hasSeenTasks } = getState();
            if (hasSeenTasks.includes(hasSeenTaskId)) return;
            setState({
                hasSeenTasks: [
                    ...hasSeenTasks,
                    hasSeenTaskId
                ]
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)(taskId),
                value: true
            });
        };
});
parcelRegister("boV1S", function(module, exports) {
    $parcel$export(module.exports, "nextAutoExpand", ()=>$35a410a5fb89f79b$export$3d24e97d30cfd09e);
    var $8Bc5A;
    var $984bX;
    var $4ji4w;
    var $cUGWT;
    const $35a410a5fb89f79b$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
            const hasNudgeToShowAfterNavigation = (0, (0, parcelRequire("984bX")).localStorageProvider)().get({
                accountId: (0, (0, parcelRequire("8Bc5A")).ACCOUNT_ID),
                key: (0, (0, parcelRequire("8Bc5A")).KEY_HAS_NAVIGATED_FROM_LINK)
            });
            if (hasNudgeToShowAfterNavigation) return;
            const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks } = getState();
            if (!tasks) return;
            const { items: items } = tasks;
            if (items.includes(openTask) && !completedTaskList.includes(openTask)) return;
            const taskIdToExpand = (0, (0, parcelRequire("4ji4w")).getNextNonCompleteTask)(items, completedTaskList, openTask);
            if (taskIdToExpand === null) return;
            dispatch((0, (0, parcelRequire("cUGWT")).nextAutoOpenTask)(taskIdToExpand));
        };
});
parcelRegister("984bX", function(module, exports) {
    $parcel$export(module.exports, "localStorageProvider", ()=>$a6d0a6873aa6f7aa$export$aa821bfb3308a1f5);
    $parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", ()=>$a6d0a6873aa6f7aa$export$f2666fae743fa5f);
    var $eNf8a;
    var $jcw0u;
    var $8Bc5A;
    const $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY = 1;
    const $a6d0a6873aa6f7aa$var$DAY = 86400000;
    const $a6d0a6873aa6f7aa$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
    const $a6d0a6873aa6f7aa$var$getExpiryTime = ()=>{
        const now = Date.now();
        return now + $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY * $a6d0a6873aa6f7aa$var$DAY;
    };
    let $a6d0a6873aa6f7aa$var$localStorage;
    const $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5 = ()=>{
        if ($a6d0a6873aa6f7aa$var$localStorage) return $a6d0a6873aa6f7aa$var$localStorage;
        const provider = (0, (0, parcelRequire("eNf8a")).createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
        try {
            provider.removeExpiredKeys();
        } catch (e) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'localStorageProviderKeyRemoval',
                    packageName: 'jiraOnboardingQuickstartCore'
                },
                error: e
            });
        }
        const get = ({ accountId: accountId, key: key })=>provider.get($a6d0a6873aa6f7aa$var$getKey({
                accountId: accountId,
                key: key
            }));
        const set = ({ accountId: accountId, key: key, value: value })=>provider.set($a6d0a6873aa6f7aa$var$getKey({
                accountId: accountId,
                key: key
            }), value, $a6d0a6873aa6f7aa$var$getExpiryTime());
        const remove = ({ accountId: accountId, key: key })=>provider.remove($a6d0a6873aa6f7aa$var$getKey({
                accountId: accountId,
                key: key
            }));
        $a6d0a6873aa6f7aa$var$localStorage = {
            provider: provider,
            remove: remove,
            get: get,
            set: set
        };
        return $a6d0a6873aa6f7aa$var$localStorage;
    };
    const $a6d0a6873aa6f7aa$export$f2666fae743fa5f = (value)=>{
        $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5().set({
            accountId: (0, (0, parcelRequire("8Bc5A")).ACCOUNT_ID),
            key: (0, (0, parcelRequire("8Bc5A")).KEY_HAS_NAVIGATED_FROM_LINK),
            value: value
        });
    };
});
parcelRegister("4Viq4", function(module, exports) {
    $parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", ()=>$0d74d0b8a43d2c5f$export$6f336ccb6432fcd0);
    var $8Bc5A;
    var $984bX;
    var $lHcRB;
    const $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
            const nudgeToShowAfterNavigationKeyPair = {
                accountId: (0, (0, parcelRequire("8Bc5A")).ACCOUNT_ID),
                key: (0, (0, parcelRequire("8Bc5A")).KEY_HAS_NAVIGATED_FROM_LINK)
            };
            const shouldShowNudge = (0, (0, parcelRequire("984bX")).localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
            if (shouldShowNudge) {
                dispatch((0, (0, parcelRequire("lHcRB")).setHasNudgeActive)(true));
                (0, (0, parcelRequire("984bX")).localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
            }
        };
});
parcelRegister("jIoq4", function(module, exports) {
    $parcel$export(module.exports, "nextGetTasks", ()=>$034f263b888956c9$export$15d877e1f3abf489);
    var $ikZFc;
    const $034f263b888956c9$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState })=>{
            const { taskList: taskList } = getState();
            const tasks = (0, (0, parcelRequire("ikZFc")).getAllTasks)({
                ...props,
                taskList: taskList
            });
            setState({
                tasks: tasks
            });
        };
});
parcelRegister("ikZFc", function(module, exports) {
    $parcel$export(module.exports, "getAllTasks", ()=>$cb6c1b1dc7b1b225$export$d1f442602a91e7cc);
    var $aIZdc;
    var $65Ltd;
    var $4R6GH;
    var $ldyPw;
    var $8Bc5A;
    var $1ffS1;
    var $ieqoN;
    var $h3PyW;
    var $3Iaiu;
    var $aHo1U;
    var $5yUqp;
    var $5zzQl;
    var $jJca1;
    const $cb6c1b1dc7b1b225$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
        if (variants.includes((0, (0, parcelRequire("aHo1U")).JSW).experiment.jswReverseTrial)) {
            const { title: title, items: items } = taskList[taskGroupParent === (0, (0, parcelRequire("8Bc5A")).ROOT_TASK) ? (0, (0, parcelRequire("8Bc5A")).REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, (0, parcelRequire("8Bc5A")).REVERSE_TRIAL_ROOT_TASK];
            return {
                title: title,
                items: (0, (0, parcelRequire("5zzQl")).getTasks)(variants, taskVariants, items)
            };
        }
        const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, (0, parcelRequire("8Bc5A")).ROOT_TASK];
        return {
            title: title,
            items: (0, (0, parcelRequire("5zzQl")).getTasks)(variants, taskVariants, items)
        };
    };
    const $cb6c1b1dc7b1b225$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup)=>{
        const variants = new Set();
        const isTmpScrumWithSprintPermission = mountedNudges.includes((0, (0, parcelRequire("8Bc5A")).BACKLOG_CREATE_SPRINT_NUDGE_ID));
        const isEligibleForKanbanTour = mountedNudges.includes((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112));
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experience.fedRamp);
        if (premiumTrialOnSignup && (0, (0, parcelRequire("4R6GH")).fg)('jsw_reverse_trials_feature_gate')) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experiment.jswReverseTrial);
        if (isCustomerTemplateProject) variants.add((0, (0, parcelRequire("aHo1U")).JSW).projectProperties.isCreatedFromCustomerTemplate);
        if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experiment.scrumOnboarding);
        if (isCrossProjectBoardToPlanUpsell) variants.add((0, (0, parcelRequire("aHo1U")).JSW).trait.crossProjectBoardToPlanUpsell);
        if (canEditPlans) variants.add((0, (0, parcelRequire("aHo1U")).JSW).permissions.hasPlanEditPermissions);
        if (isEligibleForKanbanTour || routeName !== (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experience.kanbanOnboarding);
        if (canCreateProject === false) variants.add((0, (0, parcelRequire("aHo1U")).JSW).permissions.notCanCreateProject);
        if (projectState?.isNextGen) variants.add((0, (0, parcelRequire("aHo1U")).JSW).projectStyle.teamManaged);
        else variants.add((0, (0, parcelRequire("aHo1U")).JSW).projectStyle.companyManaged);
        if (projectState?.isProjectAdmin) variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.projectAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).JIRA_ADMIN) {
            variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.jiraAdmin);
            variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.admin);
        }
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN) {
            variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.siteAdmin);
            variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.admin);
        }
        if (projectState?.edition === (0, (0, parcelRequire("ldyPw")).FREE_EDITION)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).edition.free);
        else if (projectState?.edition === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).edition.standard);
        else if (projectState?.edition === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).edition.premium);
        if ((0, (0, parcelRequire("1ffS1")).isRoadmapRoute)(routeName)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareRoadmap);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareBacklog);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareBoard);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareList);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.projectSettingsSoftwareAccess);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.issue);
        else if ((routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC)) && (0, (0, parcelRequire("4R6GH")).fg)('software_calendar_quickstart_onboarding')) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareCalendar);
        if (isEligibleToUpdateSitename) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experiment.customizeSiteName);
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: Array.from(variants.values()),
            taskVariants: (0, (0, parcelRequire("aHo1U")).JSW).taskVariants,
            taskList: (0, (0, parcelRequire("aHo1U")).JSW).taskList,
            taskGroupParent: taskGroupParent
        });
    };
    const $cb6c1b1dc7b1b225$var$createJwmTasks = (projectState, taskGroupParent, taskList = (0, (0, parcelRequire("5yUqp")).JWM).taskList)=>{
        const variants = [];
        variants.push((0, (0, parcelRequire("5yUqp")).JWM).experiments.projectTheming);
        if (projectState?.isProjectAdmin) variants.push((0, (0, parcelRequire("5yUqp")).JWM).userRole.projectAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).JIRA_ADMIN) variants.push((0, (0, parcelRequire("5yUqp")).JWM).userRole.jiraAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN) variants.push((0, (0, parcelRequire("5yUqp")).JWM).userRole.siteAdmin);
        if (projectState?.isSampleProject) variants.push((0, (0, parcelRequire("5yUqp")).JWM).experiments.isSampleProject);
        else variants.push((0, (0, parcelRequire("5yUqp")).JWM).experiments.isNotSampleProject);
        if (projectState?.isTrelloCrossflow) variants.push((0, (0, parcelRequire("5yUqp")).JWM).experiments.trelloCrossflow);
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: variants,
            taskVariants: (0, (0, parcelRequire("5yUqp")).JWM).taskVariants,
            taskList: taskList,
            taskGroupParent: taskGroupParent
        });
    };
    const $cb6c1b1dc7b1b225$var$createJsmTasks = (projectState, taskGroupParent)=>{
        const variants = [];
        variants.push((0, (0, parcelRequire("3Iaiu")).JSM).experiments.projectTheming);
        if (projectState?.isProjectAdmin) variants.push((0, (0, parcelRequire("3Iaiu")).JSM).userRole.projectAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).JIRA_ADMIN) variants.push((0, (0, parcelRequire("3Iaiu")).JSM).userRole.jiraAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN) variants.push((0, (0, parcelRequire("3Iaiu")).JSM).userRole.siteAdmin);
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: variants,
            taskVariants: (0, (0, parcelRequire("3Iaiu")).JSM).taskVariants,
            taskList: (0, (0, parcelRequire("3Iaiu")).JSM).taskList,
            taskGroupParent: taskGroupParent
        });
    };
    const $cb6c1b1dc7b1b225$var$createDevopsTasks = (taskGroupParent)=>{
        const variants = [];
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: variants,
            taskVariants: (0, (0, parcelRequire("h3PyW")).DEVOPS).taskVariants,
            taskList: (0, (0, parcelRequire("h3PyW")).DEVOPS).taskList,
            taskGroupParent: taskGroupParent
        });
    };
    const $cb6c1b1dc7b1b225$export$d1f442602a91e7cc = ({ projectState: projectState, isDevOpsProject: isDevOpsProject, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCustomerTemplateProject: isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, taskList: taskList })=>{
        if ((0, (0, parcelRequire("jJca1")).isJwmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJwmTasks(projectState, taskGroupParent, taskList);
        if ((0, (0, parcelRequire("jJca1")).isJsmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJsmTasks(projectState, taskGroupParent);
        if (isDevOpsProject) return $cb6c1b1dc7b1b225$var$createDevopsTasks(taskGroupParent);
        return $cb6c1b1dc7b1b225$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup);
    };
});
parcelRegister("1ffS1", function(module, exports) {
    $parcel$export(module.exports, "isRoadmapRoute", ()=>$ee93e5dd18635f6d$export$d1fa67c1ffb68871);
    var $65Ltd;
    const $ee93e5dd18635f6d$export$d1fa67c1ffb68871 = (routeName)=>{
        if (routeName === undefined) return false;
        return routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC);
    };
});
parcelRegister("ieqoN", function(module, exports) {
    $parcel$export(module.exports, "USER_ROLE", ()=>$353950c3dd35bbc6$export$8eeb199b23203523);
    const $353950c3dd35bbc6$export$8eeb199b23203523 = {
        END_USER: 'end-user',
        SITE_ADMIN: 'site-admin',
        JIRA_ADMIN: 'jira-admin'
    };
});
parcelRegister("h3PyW", function(module, exports) {
    $parcel$export(module.exports, "DEVOPS", ()=>$866b9189a2842e55$export$bb75b6064c92010c);
    var $j6cCw;
    const $866b9189a2842e55$export$bb75b6064c92010c = {
        taskList: (0, (0, parcelRequire("j6cCw")).TASK_LIST),
        taskVariants: (0, (0, parcelRequire("j6cCw")).TASK_VARIANTS),
        experiment: (0, (0, parcelRequire("j6cCw")).Experiment)
    };
});
parcelRegister("j6cCw", function(module, exports) {
    $parcel$export(module.exports, "Experiment", ()=>$7149b1f98b73c1fd$export$4e0ab25c8a7e4009);
    $parcel$export(module.exports, "TASK_LIST", ()=>$7149b1f98b73c1fd$export$601c8c0f45aeb0a0);
    $parcel$export(module.exports, "TASK_VARIANTS", ()=>$7149b1f98b73c1fd$export$36f4d47dfe11b613);
    var $8Bc5A;
    var $1AiUr;
    const $7149b1f98b73c1fd$export$4e0ab25c8a7e4009 = {};
    const $7149b1f98b73c1fd$export$601c8c0f45aeb0a0 = Object.freeze({
        root: {
            title: (0, (0, parcelRequire("1AiUr")).messages).rootTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_GET_TO_KNOW_JIRA_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_NAVIGATE_YOUR_TOOLS_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_CAPTURE_INTEGRATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_CREATE_AUTOMATION_RULES_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_INVITE_TEAMMATES_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_FIND_HELP_TASK)
            ]
        }
    });
    const $7149b1f98b73c1fd$export$36f4d47dfe11b613 = {
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_GET_TO_KNOW_JIRA_TASK)]: {
            position: {
                default: 100
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_NAVIGATE_YOUR_TOOLS_TASK)]: {
            position: {
                default: 200
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_CAPTURE_INTEGRATIONS_TASK)]: {
            position: {
                default: 300
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_CREATE_AUTOMATION_RULES_TASK)]: {
            position: {
                default: 400
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_INVITE_TEAMMATES_TASK)]: {
            position: {
                default: 500
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_FIND_HELP_TASK)]: {
            position: {
                default: 600
            },
            visibility: {
                default: true
            }
        }
    };
});
parcelRegister("1AiUr", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$6eae5132e152d792$export$defe85febe8b728c);
    var $7VHMR;
    const $6eae5132e152d792$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rootTitle: {
            "id": "software-onboarding-quickstart.services.tasks.config.devops.root-title.no-translate",
            "defaultMessage": "Quickstart"
        }
    });
});
parcelRegister("3Iaiu", function(module, exports) {
    $parcel$export(module.exports, "JSM", ()=>$56a077523ddf70fb$export$63f289f2da861d35);
    var $58IQc;
    const $56a077523ddf70fb$export$63f289f2da861d35 = {
        taskList: (0, (0, parcelRequire("58IQc")).JSM_TASK_LIST),
        taskVariants: (0, (0, parcelRequire("58IQc")).JSM_TASK_VARIANTS),
        userRole: (0, (0, parcelRequire("58IQc")).UserRole),
        experiments: (0, (0, parcelRequire("58IQc")).Experiments)
    };
});
parcelRegister("58IQc", function(module, exports) {
    $parcel$export(module.exports, "JSM_TASK_LIST", ()=>$3c13225c81ad4b5c$export$6c6c561944d49bcb);
    $parcel$export(module.exports, "Experiments", ()=>$3c13225c81ad4b5c$export$c8d6ffd15214553a);
    $parcel$export(module.exports, "UserRole", ()=>$3c13225c81ad4b5c$export$eb3485a690c2f0b8);
    $parcel$export(module.exports, "JSM_TASK_VARIANTS", ()=>$3c13225c81ad4b5c$export$5b68aef408c932d9);
    var $8Bc5A;
    var $kTSRm;
    const $3c13225c81ad4b5c$export$6c6c561944d49bcb = Object.freeze({
        root: {
            title: (0, (0, parcelRequire("kTSRm")).messages).rootTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).JSM_REVIEW_YOUR_CHANNELS_TASK),
                (0, (0, parcelRequire("8Bc5A")).JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
                (0, (0, parcelRequire("8Bc5A")).JSM_INVITE_YOUR_TEAM_TASK)
            ]
        }
    });
    const $3c13225c81ad4b5c$export$c8d6ffd15214553a = {
        projectTheming: 'projectTheming'
    };
    const $3c13225c81ad4b5c$export$eb3485a690c2f0b8 = {
        projectAdmin: 'projectAdmin',
        jiraAdmin: 'jiraAdmin',
        siteAdmin: 'siteAdmin'
    };
    const $3c13225c81ad4b5c$export$5b68aef408c932d9 = {
        [(0, (0, parcelRequire("8Bc5A")).JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
            position: {
                default: 1
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JSM_INVITE_YOUR_TEAM_TASK)]: {
            position: {
                default: 2
            },
            visibility: {
                default: true
            }
        }
    };
});
parcelRegister("kTSRm", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f1f6142c4170f38e$export$defe85febe8b728c);
    var $7VHMR;
    const $f1f6142c4170f38e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rootTitle: {
            "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
            "defaultMessage": "Quickstart"
        }
    });
});
parcelRegister("aHo1U", function(module, exports) {
    $parcel$export(module.exports, "JSW", ()=>$563027753d017a60$export$4cfe6e52f2e72a54);
    var $8VfDj;
    const $563027753d017a60$export$4cfe6e52f2e72a54 = {
        taskList: (0, (0, parcelRequire("8VfDj")).TASK_LIST),
        taskVariants: (0, (0, parcelRequire("8VfDj")).TASK_VARIANTS),
        experiment: (0, (0, parcelRequire("8VfDj")).Experiment),
        experience: (0, (0, parcelRequire("8VfDj")).Experience),
        projectStyle: (0, (0, parcelRequire("8VfDj")).ProjectStyle),
        projectProperties: (0, (0, parcelRequire("8VfDj")).ProjectProperties),
        userRole: (0, (0, parcelRequire("8VfDj")).UserRole),
        edition: (0, (0, parcelRequire("8VfDj")).Edition),
        route: (0, (0, parcelRequire("8VfDj")).Route),
        permissions: (0, (0, parcelRequire("8VfDj")).Permissions),
        trait: (0, (0, parcelRequire("8VfDj")).Trait)
    };
});
parcelRegister("8VfDj", function(module, exports) {
    $parcel$export(module.exports, "Experiment", ()=>$ea3903bb15047c3b$export$4e0ab25c8a7e4009);
    $parcel$export(module.exports, "Experience", ()=>$ea3903bb15047c3b$export$c90b54e658fc4d7c);
    $parcel$export(module.exports, "ProjectStyle", ()=>$ea3903bb15047c3b$export$1f66f9f05afa05a8);
    $parcel$export(module.exports, "ProjectProperties", ()=>$ea3903bb15047c3b$export$543c19ee8dba9252);
    $parcel$export(module.exports, "UserRole", ()=>$ea3903bb15047c3b$export$eb3485a690c2f0b8);
    $parcel$export(module.exports, "Edition", ()=>$ea3903bb15047c3b$export$6f4a0f769e61929);
    $parcel$export(module.exports, "Route", ()=>$ea3903bb15047c3b$export$e7b0ac011bb776c6);
    $parcel$export(module.exports, "Permissions", ()=>$ea3903bb15047c3b$export$2d41982586bbb6be);
    $parcel$export(module.exports, "Trait", ()=>$ea3903bb15047c3b$export$2d08cfa40d69142e);
    $parcel$export(module.exports, "TASK_LIST", ()=>$ea3903bb15047c3b$export$601c8c0f45aeb0a0);
    $parcel$export(module.exports, "TASK_VARIANTS", ()=>$ea3903bb15047c3b$export$36f4d47dfe11b613);
    var $8Bc5A;
    var $ciLFO;
    const $ea3903bb15047c3b$export$4e0ab25c8a7e4009 = {
        scrumOnboarding: 'experiment.scrumOnboarding',
        customizeSiteName: 'experiment.customizeSiteName',
        jswReverseTrial: 'experiment.jswReverseTrial'
    };
    const $ea3903bb15047c3b$export$c90b54e658fc4d7c = {
        kanbanOnboarding: 'experience.kanbanOnboarding',
        fedRamp: 'experience.fedRamp'
    };
    const $ea3903bb15047c3b$export$1f66f9f05afa05a8 = {
        teamManaged: 'projectStyle.teamManaged',
        companyManaged: 'projectStyle.companyManaged'
    };
    const $ea3903bb15047c3b$export$543c19ee8dba9252 = {
        isCreatedFromCustomerTemplate: 'projectProperties.isCreatedFromCustomerTemplate'
    };
    const $ea3903bb15047c3b$export$eb3485a690c2f0b8 = {
        siteAdmin: 'userRole.siteAdmin',
        jiraAdmin: 'userRole.jiraAdmin',
        admin: 'userRole.admin',
        projectAdmin: 'userRole.projectAdmin'
    };
    const $ea3903bb15047c3b$export$6f4a0f769e61929 = {
        free: 'productEdition.free',
        standard: 'productEdition.standard',
        premium: 'productEdition.premium'
    };
    const $ea3903bb15047c3b$export$e7b0ac011bb776c6 = {
        softwareRoadmap: 'route.softwareRoadmap',
        softwareBacklog: 'route.softwareBacklog',
        softwareBoard: 'route.softwareBoard',
        softwareList: 'route.softwareList',
        projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
        issue: 'route.issue',
        softwareCalendar: 'route.softwareCalendar'
    };
    const $ea3903bb15047c3b$export$2d41982586bbb6be = {
        notCanCreateProject: 'permissions.notCanCreateProject',
        hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
    };
    const $ea3903bb15047c3b$export$2d08cfa40d69142e = {
        crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
    };
    const $ea3903bb15047c3b$var$DEFAULT_TASK_LIST = [
        (0, (0, parcelRequire("8Bc5A")).ADD_COLUMNS_TASK),
        (0, (0, parcelRequire("8Bc5A")).CREATE_PROJECT_TASK),
        (0, (0, parcelRequire("8Bc5A")).CREATE_ISSUE_TASK),
        (0, (0, parcelRequire("8Bc5A")).CREATE_ISSUE_TASK_SIMPLIFIED),
        (0, (0, parcelRequire("8Bc5A")).TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
        (0, (0, parcelRequire("8Bc5A")).INVITE_TEAMMATES_TASK),
        (0, (0, parcelRequire("8Bc5A")).INVITE_TEAMMATES_VIDEO_TASK),
        (0, (0, parcelRequire("8Bc5A")).CAPTURE_INTEGRATIONS_TASK),
        (0, (0, parcelRequire("8Bc5A")).FIND_HELP_TASK),
        (0, (0, parcelRequire("8Bc5A")).SET_UP_BOARD_TASK),
        (0, (0, parcelRequire("8Bc5A")).GET_MOBILE_APP_TASK),
        (0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK),
        (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK),
        (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
        (0, (0, parcelRequire("8Bc5A")).STANDARD_EDITION_OVERVIEW_TASK),
        (0, (0, parcelRequire("8Bc5A")).MAP_OUT_YOUR_PROJECT_GOALS_TASK),
        (0, (0, parcelRequire("8Bc5A")).IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
        (0, (0, parcelRequire("8Bc5A")).MONITOR_MANAGE_RISK_TASK),
        (0, (0, parcelRequire("8Bc5A")).SCRUM_ONBOARDING_TASK),
        (0, (0, parcelRequire("8Bc5A")).CUSTOMIZE_SITE_NAME_TASK),
        (0, (0, parcelRequire("8Bc5A")).GET_TO_KNOW_YOUR_TEMPLATE_TASK),
        (0, (0, parcelRequire("8Bc5A")).CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
        (0, (0, parcelRequire("8Bc5A")).GET_STARTED_LIST_TASK),
        (0, (0, parcelRequire("8Bc5A")).CALENDAR_VIEW_TASK)
    ];
    const $ea3903bb15047c3b$export$601c8c0f45aeb0a0 = Object.freeze({
        root: {
            title: (0, (0, parcelRequire("ciLFO")).messages).rootTitle,
            items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
        },
        reverseTrialRoot: {
            title: (0, (0, parcelRequire("ciLFO")).messages).reverseTrialRootTitle,
            items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK)]: {
            title: (0, (0, parcelRequire("ciLFO")).messages).reverseTrialCardTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).ADVANCED_ROADMAPS_TASK),
                (0, (0, parcelRequire("8Bc5A")).CHANGE_CONTROL_TASK),
                (0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).SITE_ADMINISTRATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).USER_MANAGEMENT_TASK)
            ]
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK)]: {
            title: (0, (0, parcelRequire("ciLFO")).messages).premiumPlanTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).ADVANCED_ROADMAPS_TASK),
                (0, (0, parcelRequire("8Bc5A")).CHANGE_CONTROL_TASK),
                (0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).SITE_ADMINISTRATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).USER_MANAGEMENT_TASK)
            ]
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
            title: (0, (0, parcelRequire("ciLFO")).messages).premiumPlanTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).ADVANCED_ROADMAPS_TASK),
                (0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK)
            ]
        },
        [(0, (0, parcelRequire("8Bc5A")).STANDARD_EDITION_OVERVIEW_TASK)]: {
            title: (0, (0, parcelRequire("ciLFO")).messages).standardPlanTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).USER_MANAGEMENT_TASK),
                (0, (0, parcelRequire("8Bc5A")).SITE_ADMINISTRATIONS_TASK)
            ]
        }
    });
    const $ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS = {
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK)]: {
            position: {
                default: 900
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK)]: {
            position: {
                default: 900
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
            position: {
                default: 900
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                            $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).STANDARD_EDITION_OVERVIEW_TASK)]: {
            position: {
                default: 900
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).ADVANCED_ROADMAPS_TASK)]: {
            position: {
                default: 105
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                            $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK)]: {
            position: {
                default: 110
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                            $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).USER_MANAGEMENT_TASK)]: {
            position: {
                default: 115
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CHANGE_CONTROL_TASK)]: {
            position: {
                default: 120
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).SITE_ADMINISTRATIONS_TASK)]: {
            position: {
                default: 125
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                        ],
                        value: true
                    }
                ]
            }
        }
    };
    const $ea3903bb15047c3b$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS = {
        [(0, (0, parcelRequire("8Bc5A")).GET_TO_KNOW_YOUR_TEMPLATE_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$543c19ee8dba9252.isCreatedFromCustomerTemplate,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                        ],
                        value: true
                    }
                ]
            }
        }
    };
    const $ea3903bb15047c3b$export$36f4d47dfe11b613 = {
        ...$ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS,
        ...$ea3903bb15047c3b$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS,
        [(0, (0, parcelRequire("8Bc5A")).CREATE_PROJECT_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$543c19ee8dba9252.isCreatedFromCustomerTemplate
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CUSTOMIZE_SITE_NAME_TASK)]: {
            position: {
                default: 50
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.customizeSiteName
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CALENDAR_VIEW_TASK)]: {
            position: {
                default: 100
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        value: true,
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareCalendar
                        ]
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).SCRUM_ONBOARDING_TASK)]: {
            position: {
                default: 150
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.scrumOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBacklog
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
            position: {
                default: 150
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
            position: {
                default: 151
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MONITOR_MANAGE_RISK_TASK)]: {
            position: {
                default: 152
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).SET_UP_BOARD_TASK)]: {
            position: {
                default: 200
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CREATE_ISSUE_TASK)]: {
            position: {
                default: 300
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CREATE_ISSUE_TASK_SIMPLIFIED)]: {
            position: {
                default: 300
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).ADD_COLUMNS_TASK)]: {
            position: {
                default: 310
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).GET_STARTED_LIST_TASK)]: {
            position: {
                default: 320
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
            position: {
                default: 350
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).INVITE_TEAMMATES_TASK)]: {
            position: {
                default: 400
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).INVITE_TEAMMATES_VIDEO_TASK)]: {
            position: {
                default: 400,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: 600
                    }
                ]
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CAPTURE_INTEGRATIONS_TASK)]: {
            position: {
                default: 500
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).GET_MOBILE_APP_TASK)]: {
            position: {
                default: 600
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).FIND_HELP_TASK)]: {
            position: {
                default: 700
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
            position: {
                default: 800
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        }
    };
});
parcelRegister("ciLFO", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$609e253829546460$export$defe85febe8b728c);
    var $7VHMR;
    const $609e253829546460$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rootTitle: {
            "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
            "defaultMessage": "Quickstart"
        },
        premiumPlanTitle: {
            "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
            "defaultMessage": "Included in your Premium plan"
        },
        standardPlanTitle: {
            "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
            "defaultMessage": "Your Standard plan"
        },
        reverseTrialRootTitle: {
            "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
            "defaultMessage": "Your 30-day Premium trial"
        },
        reverseTrialCardTitle: {
            "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
            "defaultMessage": "Included in your Premium trial"
        }
    });
});
parcelRegister("5yUqp", function(module, exports) {
    $parcel$export(module.exports, "JWM", ()=>$80382801c7786de6$export$3ff26c80cb588e12);
    var $82B5j;
    var $8jC8d;
    var $5PFhq;
    const $80382801c7786de6$export$3ff26c80cb588e12 = {
        taskList: (0, (0, parcelRequire("82B5j")).TASK_LIST),
        taskVariants: (0, (0, parcelRequire("82B5j")).TASK_VARIANTS),
        userRole: (0, (0, parcelRequire("5PFhq")).UserRole),
        experiments: (0, (0, parcelRequire("8jC8d")).Experiments)
    };
});
parcelRegister("82B5j", function(module, exports) {
    $parcel$export(module.exports, "TASK_LIST", ()=>$3b1179694682c8c8$export$601c8c0f45aeb0a0);
    $parcel$export(module.exports, "TASK_VARIANTS", ()=>$3b1179694682c8c8$export$36f4d47dfe11b613);
    var $8Bc5A;
    var $8jC8d;
    var $aQMWP;
    var $5PFhq;
    const $3b1179694682c8c8$export$601c8c0f45aeb0a0 = Object.freeze({
        root: {
            title: (0, (0, parcelRequire("aQMWP")).messages).rootTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).JWM_CREATE_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
                (0, (0, parcelRequire("8Bc5A")).JWM_SUMMARY_AND_REPORTS_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
                (0, (0, parcelRequire("8Bc5A")).JWM_CREATE_SAMPLE_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_PROJECT_SUMMARY_TASK),
                (0, (0, parcelRequire("8Bc5A")).GET_STARTED_LIST_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_CALENDAR_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_TIMELINE_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_BUILD_FORM_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_BACKGROUND_COLOR_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_SHARE_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_CREATE_YOUR_OWN_PROJECT_TASK)
            ]
        }
    });
    const $3b1179694682c8c8$export$db06b8e338ba9c65 = {
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_3_LIST)]: {
            position: {
                default: 100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_3_CALENDAR)]: {
            position: {
                default: 200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_3_PAGES)]: {
            position: {
                default: 300
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_4_LIST)]: {
            position: {
                default: 400
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_4_CALENDAR)]: {
            position: {
                default: 500
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_4_TIMELINE)]: {
            position: {
                default: 600
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_4_SUMMARY)]: {
            position: {
                default: 700
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_5_LIST)]: {
            position: {
                default: 800
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_5_TIMELINE)]: {
            position: {
                default: 900
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_5_PAGES)]: {
            position: {
                default: 1000
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_7_LIST)]: {
            position: {
                default: 1100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_7_CALENDAR)]: {
            position: {
                default: 1200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_2_BOARD)]: {
            position: {
                default: 1300
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_2_FORMS)]: {
            position: {
                default: 1400
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_2_SUMMARY)]: {
            position: {
                default: 1500
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_1_LIST)]: {
            position: {
                default: 1600
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_6_PAGES)]: {
            position: {
                default: 1700
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_0_LIST)]: {
            position: {
                default: 1800
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_0_TIMELINE)]: {
            position: {
                default: 1900
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_0_PAGES)]: {
            position: {
                default: 2000
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_DEFAULT_LIST)]: {
            position: {
                default: 2100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_DEFAULT_BOARD)]: {
            position: {
                default: 2200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_DEFAULT_INVITES)]: {
            position: {
                default: 2300
            }
        }
    };
    const $3b1179694682c8c8$export$bda7075f98246874 = {
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_1_LIST)]: {
            position: {
                default: 100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_1_CALENDAR)]: {
            position: {
                default: 200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_1_TIMELINE)]: {
            position: {
                default: 300
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_2_CALENDAR)]: {
            position: {
                default: 400
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_2_PAGES)]: {
            position: {
                default: 500
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_3_PAGES)]: {
            position: {
                default: 600
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_3_TIMELINE)]: {
            position: {
                default: 700
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_4_LIST)]: {
            position: {
                default: 800
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_4_SUMMARY)]: {
            position: {
                default: 900
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_4_PAGES)]: {
            position: {
                default: 1000
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_5_TIMELINE)]: {
            position: {
                default: 1100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_5_SUMMARY)]: {
            position: {
                default: 1200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_6_FORMS)]: {
            position: {
                default: 1300
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_0_LIST)]: {
            position: {
                default: 1400
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_0_CALENDAR)]: {
            position: {
                default: 1500
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_0_TIMELINE)]: {
            position: {
                default: 1600
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_0_SUMMARY)]: {
            position: {
                default: 1700
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_DEFAULT_LIST)]: {
            position: {
                default: 1800
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_DEFAULT_BOARD)]: {
            position: {
                default: 1900
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_DEFAULT_PROJECT)]: {
            position: {
                default: 2000
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_DEFAULT_INVITES)]: {
            position: {
                default: 2100
            }
        }
    };
    const $3b1179694682c8c8$export$36f4d47dfe11b613 = {
        ...$3b1179694682c8c8$export$db06b8e338ba9c65,
        ...$3b1179694682c8c8$export$bda7075f98246874,
        [(0, (0, parcelRequire("8Bc5A")).JWM_CREATE_PROJECT_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
            position: {
                default: 15
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isNotSampleProject,
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
            position: {
                default: 40
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_PROJECT_SUMMARY_TASK)]: {
            position: {
                default: 50
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).GET_STARTED_LIST_TASK)]: {
            position: {
                default: 100
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_CALENDAR_TASK)]: {
            position: {
                default: 200
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_TIMELINE_TASK)]: {
            position: {
                default: 300
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_BUILD_FORM_TASK)]: {
            position: {
                default: 400
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
            position: {
                default: 425
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isNotSampleProject,
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_SUMMARY_AND_REPORTS_TASK)]: {
            position: {
                default: 450
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isNotSampleProject,
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_BACKGROUND_COLOR_TASK)]: {
            position: {
                default: 500
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).projectTheming,
                            (0, (0, parcelRequire("5PFhq")).UserRole).jiraAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).projectTheming,
                            (0, (0, parcelRequire("5PFhq")).UserRole).siteAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).projectTheming,
                            (0, (0, parcelRequire("5PFhq")).UserRole).projectAdmin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_SHARE_PROJECT_TASK)]: {
            position: {
                default: 600
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
            position: {
                default: 650
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isNotSampleProject,
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow,
                            (0, (0, parcelRequire("5PFhq")).UserRole).siteAdmin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_TASK)]: {
            position: {
                default: 700
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: false
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
            position: {
                default: 700
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
            position: {
                default: 800
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject,
                            (0, (0, parcelRequire("5PFhq")).UserRole).jiraAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject,
                            (0, (0, parcelRequire("5PFhq")).UserRole).siteAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject,
                            (0, (0, parcelRequire("5PFhq")).UserRole).projectAdmin
                        ],
                        value: true
                    }
                ]
            }
        }
    };
});
parcelRegister("8jC8d", function(module, exports) {
    $parcel$export(module.exports, "Experiments", ()=>$6cd173da51fb2ca8$export$c8d6ffd15214553a);
    const $6cd173da51fb2ca8$export$c8d6ffd15214553a = {
        projectTheming: 'projectTheming',
        isSampleProject: 'isSampleProject',
        isNotSampleProject: 'isNotSampleProject',
        trelloCrossflow: 'trelloCrossflow'
    };
});
parcelRegister("aQMWP", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$40755a70921f89dd$export$defe85febe8b728c);
    var $7VHMR;
    const $40755a70921f89dd$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rootTitle: {
            "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
            "defaultMessage": "Quickstart"
        }
    });
});
parcelRegister("5PFhq", function(module, exports) {
    $parcel$export(module.exports, "UserRole", ()=>$637dacd99a3a1727$export$eb3485a690c2f0b8);
    const $637dacd99a3a1727$export$eb3485a690c2f0b8 = {
        projectAdmin: 'projectAdmin',
        jiraAdmin: 'jiraAdmin',
        siteAdmin: 'siteAdmin'
    };
});
parcelRegister("5zzQl", function(module, exports) {
    $parcel$export(module.exports, "getTasks", ()=>$f17c108f7b3045ad$export$20b82b4a32771893);
    var $fNtu3;
    const $f17c108f7b3045ad$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, (0, parcelRequire("fNtu3")).getConditional)(visibility, variants) : true;
    const $f17c108f7b3045ad$var$getTaskPosition = (variants, position)=>(0, (0, parcelRequire("fNtu3")).getConditional)(position, variants);
    const $f17c108f7b3045ad$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$f17c108f7b3045ad$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskA].position) - $f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskB].position));
});
parcelRegister("fNtu3", function(module, exports) {
    $parcel$export(module.exports, "getConditional", ()=>$8978a3b25f57d9ac$export$fe3161cde0106bba);
    const $8978a3b25f57d9ac$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
        if (conditions === undefined) return defaultValue;
        const variantsIncludesCondition = (c)=>variants.includes(c);
        const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
        return conditionObj ? conditionObj.value : defaultValue;
    };
});
parcelRegister("jJca1", function(module, exports) {
    $parcel$export(module.exports, "isJwmProject", ()=>$6249819f9bc2846f$export$ea2e5a5c1a1a6748);
    $parcel$export(module.exports, "isJsmProject", ()=>$6249819f9bc2846f$export$a972ed853ed1d469);
    var $2vSU6;
    const $6249819f9bc2846f$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT);
    const $6249819f9bc2846f$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
});
parcelRegister("75A1x", function(module, exports) {
    $parcel$export(module.exports, "syncVisibilityWithLocal", ()=>$f9427b1514e1931c$export$4aab9a98fc53b894);
    var $3B5jO;
    var $4ji4w;
    const $f9427b1514e1931c$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            const visibilityLocal = (0, (0, parcelRequire("4ji4w")).getLocalStorageItem)(`${quickstartType}.visibility`);
            if (visibilityLocal === state.visibility[quickstartType]) return;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: visibilityLocal
                }
            });
        };
});
parcelRegister("cGE52", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$d175a7a443e10f6d$export$d4c72bab9d6cc13a);
    var $8Bc5A;
    const $d175a7a443e10f6d$export$d4c72bab9d6cc13a = {
        shouldRenderComponent: false,
        completedTaskList: [],
        hasSeenTasks: [],
        isDismissed: true,
        isOpen: false,
        isFocusedOn: false,
        openTask: '',
        projectState: null,
        hasNudgeActive: false,
        isQuickstartLoaded: false,
        isDevOpsProject: false,
        nudgeStep: '',
        mountedNudges: [],
        hasEverSeenRoute: {
            'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
        },
        roadmapIsCreateEnabled: false,
        roadmapIsListEmpty: true,
        previousTaskGroupParents: [],
        currentTaskGroupParent: (0, (0, parcelRequire("8Bc5A")).ROOT_TASK),
        selectedProjectTemplateKeyFromOnboarding: undefined,
        isEligibleToUpdateSitename: false,
        isCrossProjectBoardToPlanUpsell: false,
        canEditPlans: false,
        visibility: {
            [(0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED,
            [(0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED
        }
    };
});
parcelRegister("6tzEU", function(module, exports) {
    $parcel$export(module.exports, "useSidebarData", ()=>$530d739908e5dec3$export$f9257874e114985c);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $hecDf;
    var $4041n;
    var $iNzEe;
    var $4fCE7;
    const $530d739908e5dec3$export$f9257874e114985c = ()=>{
        const { project: currentProject } = (0, (0, parcelRequire("hecDf")).useNavigationProject)();
        const { data: data, update: update, refresh: refresh, loading: loading } = (0, (0, parcelRequire("iNzEe")).useNavigationResource)();
        const { changeFavorite: changeFavorite, items: { projects: changedItems } } = (0, (0, parcelRequire("4041n")).useChangeFavorite)();
        const isRefreshingFavorites = (0, $5uXOq.useRef)(false);
        const hasRefreshedOnce = (0, $5uXOq.useRef)(false);
        const onFavoriteToggle = (0, $5uXOq.useCallback)((project)=>{
            changeFavorite({
                id: String(project.id),
                type: 'projects',
                value: !project.isFavorite
            });
        }, [
            changeFavorite
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, ($parcel$interopDefault($gccSB)))(changedItems) && !Object.values(changedItems).some(({ pending: pending })=>pending)) {
                isRefreshingFavorites.current = true;
                refresh();
            }
        }, [
            changedItems,
            refresh
        ]);
        (0, $5uXOq.useEffect)(()=>{
            isRefreshingFavorites.current = false;
        }, [
            data
        ]);
        let recents;
        let favorites;
        let hasMoreFavorite;
        let overviews;
        let overviewsError;
        let isPremiumUserSeat;
        let showPlansOnboarding;
        let shouldHideOverviews;
        if (data == null || data === (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71)) {
            if (data === (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71) && !hasRefreshedOnce.current) {
                hasRefreshedOnce.current = true;
                refresh();
            }
            recents = [];
            favorites = [];
            hasMoreFavorite = false;
            overviews = [];
            overviewsError = null;
            isPremiumUserSeat = false;
            showPlansOnboarding = false;
            shouldHideOverviews = false;
        } else {
            recents = data.recents;
            favorites = data.favorites;
            hasMoreFavorite = data.hasMoreFavorite;
            overviews = data.overviews;
            overviewsError = data.overviewsError;
            isPremiumUserSeat = data.isPremiumUserSeat;
            showPlansOnboarding = data.showPlansOnboarding;
            shouldHideOverviews = data.shouldHideOverviews;
        }
        if (currentProject != null && !recents.some((project)=>project.id === currentProject.id) && !favorites.some((project)=>project.id === currentProject.id)) {
            recents = (0, (0, parcelRequire("4fCE7")).prependProject)(currentProject, recents);
            const newRecents = recents;
            update(()=>({
                    recents: newRecents,
                    favorites: favorites,
                    hasMoreFavorite: hasMoreFavorite,
                    overviews: overviews,
                    overviewsError: overviewsError,
                    isPremiumUserSeat: isPremiumUserSeat,
                    showPlansOnboarding: showPlansOnboarding,
                    shouldHideOverviews: shouldHideOverviews
                }));
        }
        if (!(0, ($parcel$interopDefault($gccSB)))(changedItems)) {
            recents = recents.map((project)=>(0, (0, parcelRequire("4fCE7")).mapProjectChanges)(project, changedItems));
            favorites = favorites.map((project)=>(0, (0, parcelRequire("4fCE7")).mapProjectChanges)(project, changedItems));
        }
        return {
            currentProject: currentProject,
            recents: recents,
            favorites: favorites,
            hasMoreFavorite: hasMoreFavorite,
            onFavoriteToggle: onFavoriteToggle,
            overviews: overviews,
            overviewsError: overviewsError,
            shouldHideOverviews: shouldHideOverviews,
            loading: loading && !isRefreshingFavorites.current
        };
    };
});
parcelRegister("hecDf", function(module, exports) {
    $parcel$export(module.exports, "useNavigationProject", ()=>$46378552d09cbbed$export$befd5d7ebc77f264);
    var $iNzEe;
    var $l2N2a;
    var $doZTA;
    const $46378552d09cbbed$export$befd5d7ebc77f264 = ()=>{
        const { data: currentProject, loading: currentProjectLoading } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const { data: navigationData, loading: navigationDataLoading } = (0, (0, parcelRequire("iNzEe")).useNavigationResource)();
        const [{ match: { params: { projectKey: projectKey } } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        if (currentProject != null) return {
            project: currentProject,
            loading: currentProjectLoading
        };
        if (projectKey != null && navigationData != null && navigationData !== (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71)) {
            const project = navigationData.favorites.find((proj)=>proj.key === projectKey) ?? navigationData.recents.find((proj)=>proj.key === projectKey) ?? null;
            return {
                project: project,
                loading: navigationDataLoading
            };
        }
        return {
            project: null,
            loading: currentProjectLoading || navigationDataLoading
        };
    };
});
parcelRegister("4041n", function(module, exports) {
    $parcel$export(module.exports, "FavoriteChangeContext", ()=>$e574e5c3227b76f4$export$a5d258b9665ce94b);
    $parcel$export(module.exports, "FavoriteChangeProvider", ()=>$e574e5c3227b76f4$export$b06b5ce59fd5e408);
    $parcel$export(module.exports, "FavoriteChangeConsumer", ()=>$e574e5c3227b76f4$export$f227cdfbb355444a);
    $parcel$export(module.exports, "useChangeFavorite", ()=>$e574e5c3227b76f4$export$cfa169f3278459e8);
    var $kZupY;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $jcw0u;
    var $dXq4S;
    var $8zOmE;
    var $koeKL;
    var $iJZ8l;
    var $j6ttF;
    var $7lK06;
    var $eXQym;
    var $5c9oS;
    var $7SIuT;
    const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
                ...state,
                [item.type]: {
                    ...state[item.type],
                    [item.id]: item
                }
            });
    const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
                ...state,
                items: {
                    ...state.items,
                    [item.type]: {
                        ...state.items[item.type],
                        [item.id]: item
                    }
                }
            });
    const $e574e5c3227b76f4$export$b212ddc707077772 = {
        items: {
            boards: {},
            filters: {},
            issues: {},
            dashboards: {},
            projects: {},
            queues: {},
            plans: {}
        },
        changeFavorite: ()=>new Promise((0, ($parcel$interopDefault($8Rkzz)))),
        changeFavoriteMutation: (0, ($parcel$interopDefault($8Rkzz))),
        emitChangedFavorite: (0, ($parcel$interopDefault($8Rkzz))),
        emitChangedFavoriteMutation: (0, ($parcel$interopDefault($8Rkzz))),
        updateFavoriteState: (0, ($parcel$interopDefault($8Rkzz)))
    };
    const $e574e5c3227b76f4$export$a5d258b9665ce94b = (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
    const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
            if (type === (0, (0, parcelRequire("eXQym")).PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
                const ari = (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'project',
                    resourceId: id,
                    cloudId: cloudId
                });
                const projectRecordId = (0, (0, parcelRequire("iJZ8l")).default)({
                    id: ari
                }, 'JiraProject');
                if (projectRecordId) {
                    const projectRecord = store.get(projectRecordId);
                    const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(value, 'isFavourite');
                }
            });
        }, [
            cloudId,
            environment
        ]);
        return {
            commitUpdate: commitUpdate
        };
    };
    const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
        const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
        const [items, setItems] = (0, $5uXOq.useState)({
            boards: {},
            filters: {},
            dashboards: {},
            issues: {},
            projects: {},
            queues: {},
            plans: {}
        });
        const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                pending: true
            }));
        }, []);
        const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                pending: false
            }));
            if (analyticsEvent) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
        }, []);
        const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                value: !item.value,
                pending: false
            }));
            if (onShowFlag) onShowFlag((0, (0, parcelRequire("7SIuT")).errorFlag)());
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: analyticsId,
                    packageName: 'jiraFavouriteChangeProvider',
                    teamName: 'empanada'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            onShowFlag
        ]);
        const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
            const performChange = async ()=>{
                onChangeStart(item);
                try {
                    commitUpdate({
                        type: item.type,
                        id: item.id,
                        value: item.value
                    });
                    await (0, (0, parcelRequire("5c9oS")).default)(item);
                    const typename = (0, (0, parcelRequire("j6ttF")).favoriteTypeToTypename)(item.type, item.id);
                    if (typename) (0, (0, parcelRequire("7lK06")).publishFavorite)(typename, {
                        type: 'REST',
                        entityId: item.id,
                        isFavourite: item.value
                    });
                    onChangeSuccess(item, analyticsEvent);
                } catch (error) {
                    commitUpdate({
                        type: item.type,
                        id: item.id,
                        value: !item.value
                    });
                    onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
                }
            };
            return performChange();
        }, [
            commitUpdate,
            onChangeStart,
            onChangeSuccess,
            onChangeFail
        ]);
        const [commitMutation] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("kZupY")).default));
        const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
            const dataId = (0, (0, parcelRequire("iJZ8l")).default)({
                id: payload.id
            }, payload.typename);
            const restItem = (0, (0, parcelRequire("j6ttF")).favoriteMutationToRestPayload)(payload);
            const onUpdate = (store, isOptimistic)=>{
                if (!dataId) return;
                (0, (0, parcelRequire("7lK06")).publishFavorite)(payload.typename, {
                    type: 'MUTATION',
                    store: store,
                    dataId: dataId,
                    entityId: payload.id,
                    isFavourite: payload.value,
                    isOptimistic: isOptimistic
                });
                const record = store.get(dataId);
                if (record) {
                    if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                    if (isOptimistic) {
                        const favoriteRecord = record.getLinkedRecord('favouriteValue');
                        favoriteRecord?.setValue(payload.value, 'isFavourite');
                    }
                }
            };
            onChangeStart(restItem);
            commitMutation({
                variables: {
                    input: {
                        entityId: payload.id,
                        isFavourite: payload.value,
                        beforeEntityId: payload.beforeEntity?.id ?? null
                    }
                },
                optimisticUpdater: (store)=>{
                    onUpdate(store, true);
                },
                updater: (store, response)=>{
                    if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
                },
                onCompleted: (response)=>{
                    if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                    else onChangeFail(restItem, 'changeFavoriteMutation');
                },
                onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
            });
        }, [
            commitMutation,
            onChangeStart,
            onChangeSuccess,
            onChangeFail
        ]);
        const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                pending: false
            }));
        }, []);
        const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
            onChangeSuccess(payload, analyticsEvent);
            const typeName = (0, (0, parcelRequire("j6ttF")).favoriteTypeToTypename)(payload.type, payload.id);
            if (typeName) (0, (0, parcelRequire("7lK06")).publishFavorite)(typeName, {
                type: 'REST',
                entityId: payload.id,
                isFavourite: payload.value
            });
        }, [
            onChangeSuccess
        ]);
        const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)((payload, store, analyticsEvent)=>{
            const dataId = (0, (0, parcelRequire("iJZ8l")).default)({
                id: payload.id
            }, payload.typename) ?? '';
            const restItem = (0, (0, parcelRequire("j6ttF")).favoriteMutationToRestPayload)(payload);
            onChangeSuccess(restItem, analyticsEvent);
            (0, (0, parcelRequire("7lK06")).publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: false
            });
        }, [
            onChangeSuccess
        ]);
        const providerValue = (0, $5uXOq.useMemo)(()=>({
                items: items,
                changeFavorite: changeFavorite,
                changeFavoriteMutation: changeFavoriteMutation,
                emitChangedFavorite: emitChangedFavorite,
                emitChangedFavoriteMutation: emitChangedFavoriteMutation,
                updateFavoriteState: updateFavoriteState
            }), [
            items,
            changeFavorite,
            changeFavoriteMutation,
            emitChangedFavorite,
            emitChangedFavoriteMutation,
            updateFavoriteState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
            value: providerValue
        }, children);
    };
    const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
    const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
        const WithFavoriteChangeConsumer = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...props,
                    favoriteChangeContext: favoriteChangeContext
                }));
        const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
        return WithFavoriteChangeConsumer;
    };
    const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);
});
parcelRegister("kZupY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d64781493fbfe6b0$export$2e2bcd8739ae039);
    const $d64781493fbfe6b0$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "concreteType": "JiraMutation",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "input",
                                "variableName": "input"
                            }
                        ],
                        "concreteType": "JiraSetIsFavouritePayload",
                        "kind": "LinkedField",
                        "name": "setEntityIsFavourite",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "success"
                            },
                            {
                                "concreteType": "JiraFavouriteValue",
                                "kind": "LinkedField",
                                "name": "favouriteValue",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isFavourite"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "viewSetFavouriteMutation",
                "selections": v1,
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "viewSetFavouriteMutation",
                "selections": v1
            },
            "params": {
                "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
                "metadata": {},
                "name": "viewSetFavouriteMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
    var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;
});
parcelRegister("koeKL", function(module, exports) {
    $parcel$export(module.exports, "useCloudId", ()=>$559e3c14e9652b55$export$9da0f7c65f28ed16);
    var $9OXo1;
    const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.cloudId;
    };
});
parcelRegister("j6ttF", function(module, exports) {
    $parcel$export(module.exports, "favoriteTypeToTypename", ()=>$b9c3378eb0d73712$export$b98f76d96728a853);
    $parcel$export(module.exports, "favoriteMutationToRestPayload", ()=>$b9c3378eb0d73712$export$717886a1047f1287);
    var $1Y49U;
    var $1WQct;
    var $k0goX;
    var $gbLWS;
    var $89DrR;
    var $j5YhT;
    function $b9c3378eb0d73712$var$assertUnreachable(_) {
        throw new Error('Unexpected entity type');
    }
    const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
    const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
        switch(type){
            case 'projects':
                return 'JiraProject';
            case 'filters':
                return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
            case 'dashboards':
                return 'JiraDashboard';
            case 'plans':
                return 'JiraPlan';
            case 'boards':
                return 'JiraBoard';
            case 'queues':
                return 'JiraServiceManagementQueue';
            default:
                return undefined;
        }
    };
    const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
        switch(typename){
            case 'JiraProject':
                return (0, (0, parcelRequire("j5YhT")).JiraProjectAri).parse(ari).projectId;
            case 'JiraCustomFilter':
            case 'JiraSystemFilter':
                return (0, (0, parcelRequire("gbLWS")).JiraFilterAri).parse(ari).filterId;
            case 'JiraDashboard':
                return (0, (0, parcelRequire("k0goX")).JiraDashboardAri).parse(ari).dashboardId;
            case 'JiraPlan':
                return (0, (0, parcelRequire("89DrR")).JiraPlanAri).parse(ari).planId;
            case 'JiraBoard':
                return (0, (0, parcelRequire("1WQct")).JiraSoftwareBoardAri).parse(ari).boardId;
            case 'JiraServiceManagementQueue':
                return (0, (0, parcelRequire("1Y49U")).JiraServicedeskQueueAri).parse(ari).queueId;
            default:
                $b9c3378eb0d73712$var$assertUnreachable(typename);
        }
    };
    const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
        switch(typename){
            case 'JiraProject':
                return 'projects';
            case 'JiraCustomFilter':
            case 'JiraSystemFilter':
                return 'filters';
            case 'JiraDashboard':
                return 'dashboards';
            case 'JiraPlan':
                return 'plans';
            case 'JiraBoard':
                return 'boards';
            case 'JiraServiceManagementQueue':
                return 'queues';
            default:
                $b9c3378eb0d73712$var$assertUnreachable(typename);
        }
    };
    const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
            id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
            value: value,
            beforeEntity: beforeEntity ? {
                id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
                type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
            } : undefined
        });
});
parcelRegister("7lK06", function(module, exports) {
    $parcel$export(module.exports, "publishFavorite", ()=>$703ce7b9c2eadfdd$export$229a24253fb568e1);
    $parcel$export(module.exports, "useSubscribeToFavorite", ()=>$703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);
    var $5uXOq = parcelRequire("5uXOq");
    class $703ce7b9c2eadfdd$var$FavoritePubSub {
        constructor(){
            this.subscribers = {};
            this.subscribe = (typename, subscriber)=>{
                this.subscribers[typename] = [
                    ...this.subscribers[typename] ?? [],
                    subscriber
                ];
                return ()=>{
                    this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
                };
            };
            this.publish = (typename, payload)=>{
                this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
            };
        }
    }
    const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
    const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
    const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
        (0, $5uXOq.useEffect)(()=>{
            const typenames = Array.isArray(typename) ? typename : [
                typename
            ];
            const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
            return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
        }, [
            typename,
            subscriber
        ]);
    };
});
parcelRegister("eXQym", function(module, exports) {
    $parcel$export(module.exports, "BOARDS_ITEM_TYPE", ()=>$6c76a5a290814989$export$aade82542e73ffc8);
    $parcel$export(module.exports, "FILTERS_ITEM_TYPE", ()=>$6c76a5a290814989$export$a448ebfa10cebc74);
    $parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", ()=>$6c76a5a290814989$export$f8099f229527572c);
    $parcel$export(module.exports, "ISSUES_ITEM_TYPE", ()=>$6c76a5a290814989$export$8e58083dcbb878d);
    $parcel$export(module.exports, "PLANS_ITEM_TYPE", ()=>$6c76a5a290814989$export$2fd44a6cb58b66cb);
    $parcel$export(module.exports, "PROJECTS_ITEM_TYPE", ()=>$6c76a5a290814989$export$8e2cd98172988d7e);
    $parcel$export(module.exports, "QUEUES_ITEM_TYPE", ()=>$6c76a5a290814989$export$6b0c8e47d2c7f1d9);
    $parcel$export(module.exports, "VALID_ITEM_TYPES", ()=>$6c76a5a290814989$export$9c8cfad65800ddfb);
    $parcel$export(module.exports, "VALID_ITEM_TYPENAMES", ()=>$6c76a5a290814989$export$2d63a9c2e78633c8);
    const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
    const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
    const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
    const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
    const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
    const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
    const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
    const $6c76a5a290814989$export$9c8cfad65800ddfb = [
        $6c76a5a290814989$export$aade82542e73ffc8,
        $6c76a5a290814989$export$f8099f229527572c,
        $6c76a5a290814989$export$a448ebfa10cebc74,
        $6c76a5a290814989$export$8e58083dcbb878d,
        $6c76a5a290814989$export$2fd44a6cb58b66cb,
        $6c76a5a290814989$export$8e2cd98172988d7e,
        $6c76a5a290814989$export$6b0c8e47d2c7f1d9
    ];
    const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
        'JiraProject',
        'JiraCustomFilter',
        'JiraSystemFilter',
        'JiraDashboard',
        'JiraPlan',
        'JiraBoard',
        'JiraServiceManagementQueue'
    ];
});
parcelRegister("5c9oS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9559749111f2eca$export$2e2bcd8739ae039);
    var $7eYK2;
    var $f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, (0, parcelRequire("7eYK2")).updateFavorite)(request);
});
parcelRegister("7eYK2", function(module, exports) {
    $parcel$export(module.exports, "updateFavorite", ()=>$16085bb5bdb7219b$export$8c2f00130cc945dc);
    var $eusud;
    const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
        if (request.value) return (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/internal/2/favourites', {
            body: JSON.stringify({
                entity: {
                    id: request.id,
                    type: request.type
                },
                beforeEntityPosition: request.beforeEntity || null
            })
        });
        return (0, (0, parcelRequire("eusud")).performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
    };
});
parcelRegister("7SIuT", function(module, exports) {
    $parcel$export(module.exports, "errorFlag", ()=>$7252fdcfc0e15292$export$b9a7f1ebeaa76953);
    var $0YlRJ;
    const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
            type: 'error',
            ...(0, (0, parcelRequire("0YlRJ")).default)
        });
});
parcelRegister("0YlRJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87ad72b3da53041c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
            "defaultMessage": "Something\u2019s gone wrong"
        },
        description: {
            "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
            "defaultMessage": "You cannot star items right now due to an error."
        }
    });
});
parcelRegister("4fCE7", function(module, exports) {
    $parcel$export(module.exports, "prependProject", ()=>$5da6154530b9fc4e$export$9e33a1a4f95ad56f);
    $parcel$export(module.exports, "mapProjectChanges", ()=>$5da6154530b9fc4e$export$6cb16ed8ac180dfc);
    const $5da6154530b9fc4e$export$9e33a1a4f95ad56f = (project, projects)=>[
            project,
            ...projects
        ].slice(0, (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd));
    const $5da6154530b9fc4e$export$6cb16ed8ac180dfc = (project, changedItems)=>project.id in changedItems ? {
            ...project,
            isFavorite: changedItems[project.id].value
        } : project;
});
parcelRegister("aueMW", function(module, exports) {
    $parcel$export(module.exports, "CreateProjectCta", ()=>$a1b8ae763ebf57fa$export$f49a4235d24dbad0);
    var $5uXOq = parcelRequire("5uXOq");
    var $4RjZC;
    var $7XluA;
    var $4mO32;
    const $a1b8ae763ebf57fa$var$runtimeProps = {};
    const $a1b8ae763ebf57fa$var$entryPointParams = {};
    const $a1b8ae763ebf57fa$export$f49a4235d24dbad0 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("4RjZC")).createProjectCtaEntryPoint), $a1b8ae763ebf57fa$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jira-business-create-project-cta-entrypoint",
            packageName: "@atlassian/jira-business-create-project-cta",
            teamName: "jira-werewolves",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $a1b8ae763ebf57fa$var$runtimeProps,
            errorFallback: "unmount"
        });
    };
});
parcelRegister("4RjZC", function(module, exports) {
    $parcel$export(module.exports, "createProjectCtaEntryPoint", ()=>$877fbe84ca72e3fe$export$7dadecc7d161da03);
    var $eufEc;
    var $fEDBv;
    const $877fbe84ca72e3fe$export$7dadecc7d161da03 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("lEuJq")), {
            moduleId: "0c73c6d1"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("lEuJq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hlxM5")
    ]).then(()=>parcelRequire('3u5Rs'));
});
parcelRegister("iZNik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$17c51fb57bea1a65$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $2mVws;
    var $cgL5K;
    var $jPxJ7;
    var $koVbs;
    var $g8I5C;
    var $ajOhG;
    var $Fmgai;
    const $17c51fb57bea1a65$var$FEEDBACK_GROUP_ID = 'jbus-feedback';
    const $17c51fb57bea1a65$var$FeedbackButton = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const openFeedbackModal = (0, (0, parcelRequire("jPxJ7")).useFeedbackCollector)();
        const buttonRef = (0, $5uXOq.useRef)(null);
        const renderNudgeWrapper = (0, $5uXOq.useCallback)((children)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ajOhG")).FeedbackNudgeAsync), null, children), []);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            openFeedbackModal($17c51fb57bea1a65$var$FEEDBACK_GROUP_ID, (0, ($parcel$interopDefault($8Rkzz))), buttonRef);
        }, [
            openFeedbackModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g8I5C")).QuickstartNudge), {
            renderWrapper: renderNudgeWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ref: buttonRef,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2mVws"))))), {
                label: "",
                size: "small"
            }),
            appearance: "subtle-link",
            onClick: onClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "span",
            size: "UNSAFE_small",
            weight: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, (0, parcelRequire("Fmgai")).default).feedback))));
    };
    var $17c51fb57bea1a65$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($17c51fb57bea1a65$var$FeedbackButton);
});
parcelRegister("2mVws", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1b9a41a3ba9d94ab$var$_react = $1b9a41a3ba9d94ab$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1b9a41a3ba9d94ab$var$_feedback = $1b9a41a3ba9d94ab$var$_interopRequireDefault((parcelRequire("5dqGX")));
    function $1b9a41a3ba9d94ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1b9a41a3ba9d94ab$var$EditorFeedbackIcon = (props)=>$1b9a41a3ba9d94ab$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M10.922 14.517 5.87 12.68l-.932-.339C4.418 12.151 4 11.552 4 11c0-.556.42-1.153.938-1.341l9.124-3.318c.52-.19.938.105.938.654v8.01c0 .54-.42.842-.938.654zM6 14.227l2 .728V17c0 .552-.405 1.202-.895 1.447l-.21.106C6.4 18.8 6 18.549 6 18.009zm11.224-4.78a.5.5 0 1 1-.448-.894l2-1a.5.5 0 1 1 .448.894zm-.448 4a.5.5 0 0 1 .448-.894l2 1a.5.5 0 0 1-.448.894zM17 11.5a.5.5 0 1 1 0-1h3a.5.5 0 1 1 0 1z"/></svg>`
        }, props, {
            newIcon: $1b9a41a3ba9d94ab$var$_feedback.default
        }));
    $1b9a41a3ba9d94ab$var$EditorFeedbackIcon.displayName = 'EditorFeedbackIcon';
    var $1b9a41a3ba9d94ab$var$_default = module.exports.default = $1b9a41a3ba9d94ab$var$EditorFeedbackIcon;
});
parcelRegister("5dqGX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3cc2df171aca9493$var$_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3cc2df171aca9493$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3cc2df171aca9493$var$FeedbackIcon = (props)=>$3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
        }, props));
    $3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;
});
parcelRegister("jPxJ7", function(module, exports) {
    $parcel$export(module.exports, "useFeedbackCollector", ()=>$11c0bec8448c2614$export$4be696be8a3bff13);
    var $5uXOq = parcelRequire("5uXOq");
    var $7iULw;
    var $dseDh;
    var $koVbs;
    var $6jY6G;
    var $dAfqg;
    var $itmJb;
    var $9OXo1;
    var $5XRYo;
    var $5Dn32;
    const $11c0bec8448c2614$export$698ff856156a88fe = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("5XRYo")).default).canContactPrompt), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: "https://www.atlassian.com/legal/privacy-policy",
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage((0, (0, parcelRequire("5XRYo")).default).canContactPromptLink)));
    });
    const $11c0bec8448c2614$export$4f77effad9540593 = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("5XRYo")).default).enrollInResearchPrompt, {
            link: (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                href: "https://www.atlassian.com/research-group",
                target: "_blank",
                rel: "noopener noreferrer"
            }, formatMessage((0, (0, parcelRequire("5XRYo")).default).enrollInResearchLink))
        }));
    });
    const $11c0bec8448c2614$export$4be696be8a3bff13 = ({ projectType: projectType = 'business' } = {})=>{
        const { openFeedbackCollector: openFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const { licensedProducts: licensedProducts } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: project } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const getFeedbackContext = (0, $5uXOq.useCallback)((feedbackGroupId)=>{
            const baseFeedbackContext = [
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).INLINE_FEEDBACK_ID,
                    value: feedbackGroupId
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).ROUTE_NAME,
                    value: route.name ?? 'unknown'
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).ROUTE_GROUP,
                    value: route.group ?? 'unknown'
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_ADMIN,
                    value: isAdmin
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).PROJECT_TYPE,
                    value: project?.projectType || projectType
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).SUPPORTED_PROJECT_TYPES,
                    value: (0, (0, parcelRequire("5Dn32")).licensedProductsToString)(licensedProducts)
                }
            ];
            if (project) baseFeedbackContext.push({
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_SIMPLIFIED_PROJECT,
                value: project.simplified
            });
            return baseFeedbackContext;
        }, [
            isAdmin,
            licensedProducts,
            project,
            projectType,
            route.group,
            route.name
        ]);
        return (0, $5uXOq.useCallback)((feedbackGroupId, onClose, triggerRef)=>{
            const feedbackContext = getFeedbackContext(feedbackGroupId);
            openFeedbackCollector({
                entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_JIRA_PLATFORM),
                feedbackGroupId: feedbackGroupId,
                canBeContactedLabel: (0, ($parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$698ff856156a88fe, null),
                enrolInResearchLabel: (0, ($parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$4f77effad9540593, null),
                feedbackContext: feedbackContext,
                onClose: onClose,
                ...triggerRef != null ? {
                    triggerRef: triggerRef
                } : {}
            });
        }, [
            getFeedbackContext,
            openFeedbackCollector
        ]);
    };
});
parcelRegister("5XRYo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c924dc8de5075ae$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6c924dc8de5075ae$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        canContactPrompt: {
            "id": "business-feedback-collector.can-contact-prompt",
            "defaultMessage": "Atlassian may contact me about this feedback."
        },
        canContactPromptLink: {
            "id": "business-feedback-collector.can-contact-prompt-link",
            "defaultMessage": "Privacy policy"
        },
        enrollInResearchPrompt: {
            "id": "business-feedback-collector.enroll-in-research-prompt",
            "defaultMessage": "I'd like to help improve Atlassian products by joining the {link}"
        },
        enrollInResearchLink: {
            "id": "business-feedback-collector.enroll-in-research-link",
            "defaultMessage": "Atlassian Research Group"
        }
    });
});
parcelRegister("5Dn32", function(module, exports) {
    $parcel$export(module.exports, "licensedProductsToString", ()=>$0dd3b476597799f0$export$f57a7f1d32485807);
    const $0dd3b476597799f0$export$f57a7f1d32485807 = (licensedProducts)=>Object.keys(licensedProducts).map((productKey)=>licensedProducts[productKey] ? productKey : '').join(', ');
});
parcelRegister("g8I5C", function(module, exports) {
    $parcel$export(module.exports, "QuickstartNudge", ()=>$0174d522ba9dfb06$export$bd61ee610c74db6c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6OJ73;
    var $axUP7;
    const $0174d522ba9dfb06$export$bd61ee610c74db6c = (0, (0, parcelRequire("axUP7")).withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
        const isFullyExpanded = (0, (0, parcelRequire("6OJ73")).useIsFullyExpanded)();
        return isFullyExpanded ? renderWrapper(children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    });
});
parcelRegister("6OJ73", function(module, exports) {
    $parcel$export(module.exports, "useIsFullyExpanded", ()=>$c20291d4f7970c77$export$7212b6b01271f5d1);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPQRI;
    const $c20291d4f7970c77$var$TIMEOUT = 500;
    const $c20291d4f7970c77$export$7212b6b01271f5d1 = ()=>{
        const [ready, setReady] = (0, $5uXOq.useState)(false);
        const { isCollapsed: isCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            const timeoutId = setTimeout(()=>{
                setReady(!isCollapsed);
            }, $c20291d4f7970c77$var$TIMEOUT);
            return ()=>clearTimeout(timeoutId);
        }, [
            isCollapsed
        ]);
        return ready && !isCollapsed;
    };
});
parcelRegister("gPQRI", function(module, exports) {
    $parcel$export(module.exports, "useLeftSidebarState", ()=>$b19712b3cdd78134$export$610d81e163a897b3);
    $parcel$export(module.exports, "useLeftSidebarController", ()=>$b19712b3cdd78134$export$900f29014a48fb23);
    var $5uXOq = parcelRequire("5uXOq");
    var $iqLcb;
    var $3sQ5x;
    var $5e5zm;
    const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>({
                ...state.content.leftSidebar,
                shouldRender: !state.isChromeless
            })
    });
    const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
        const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
        return leftSidebar;
    };
    const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
        const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, (0, parcelRequire("iqLcb")).usePageLayoutResize)();
        return (0, $5uXOq.useMemo)(()=>({
                collapseLeftSidebar: collapseLeftSidebar,
                expandLeftSidebar: expandLeftSidebar
            }), [
            collapseLeftSidebar,
            expandLeftSidebar
        ]);
    };
});
parcelRegister("iqLcb", function(module, exports) {
    $parcel$export(module.exports, "PageLayout", ()=>$3d7d84f3bc65155e$export$6d1402fb58384e4f);
    $parcel$export(module.exports, "Banner", ()=>$3d7d84f3bc65155e$export$3b4e64e77073e307);
    $parcel$export(module.exports, "TopNavigation", ()=>$3d7d84f3bc65155e$export$8a421bddecb2bf5b);
    $parcel$export(module.exports, "LeftPanel", ()=>$3d7d84f3bc65155e$export$110709f040143804);
    $parcel$export(module.exports, "LeftSidebarWithoutResize", ()=>$3d7d84f3bc65155e$export$43ae342508cf8cc9);
    $parcel$export(module.exports, "LeftSidebar", ()=>$3d7d84f3bc65155e$export$3cabf771c4f2de);
    $parcel$export(module.exports, "Main", ()=>$3d7d84f3bc65155e$export$861edd1ccea2f746);
    $parcel$export(module.exports, "Content", ()=>$3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
    $parcel$export(module.exports, "RightSidebar", ()=>$3d7d84f3bc65155e$export$84d58c19c21f637f);
    $parcel$export(module.exports, "RightPanel", ()=>$3d7d84f3bc65155e$export$364a989a35814102);
    $parcel$export(module.exports, "useCustomSkipLink", ()=>$3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
    $parcel$export(module.exports, "useLeftSidebarFlyoutLock", ()=>$3d7d84f3bc65155e$export$94561f6055639ef7);
    $parcel$export(module.exports, "usePageLayoutResize", ()=>$3d7d84f3bc65155e$export$10c7104037a7af62);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", ()=>$3d7d84f3bc65155e$export$991ef8098f87814a);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", ()=>$3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", ()=>$3d7d84f3bc65155e$export$e95b388ca8c92019);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", ()=>$3d7d84f3bc65155e$export$2ab8b83eed76656c);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", ()=>$3d7d84f3bc65155e$export$ac017575d43f5da);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", ()=>$3d7d84f3bc65155e$export$d697087c06fd5e25);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $4ZIaA;
    var $22jFS;
    var $c8E4X;
    var $eX4XX;
    var $aKz2G;
    var $aj7M6;
    var $kUAkd;
    var $3WK4F;
    var $4CWca;
    var $9xmqY;
    var $31ERv;
    var $cIcFn;
    var $j3yGs;
    var $4R6GH;
    var $3HwlS;
    var $2MLVq;
    var $jjRN8;
    var $hOWCC;
    var $ZlCus;
    var $1EWMr;
    var $kTus1;
    var $fod7Z;
    function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1EWMr")).Root), {
            UNSAFE_dangerouslyHoistSlotSizes: true,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3WK4F")).default), props);
    }
    function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jjRN8")).Banner), {
            UNSAFE_height: props.height,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ZIaA")).default), props);
    }
    function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fod7Z")).TopBar), {
            UNSAFE_height: props.height,
            testId: props.testId,
            UNSAFE_theme: (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_theming') ? props.theme : undefined
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("31ERv")).default), props);
    }
    function $3d7d84f3bc65155e$export$110709f040143804(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eX4XX")).default), props);
    }
    function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kTus1")).SideNav), {
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aj7M6")).default), props);
    }
    function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kTus1")).SideNav), {
            defaultCollapsed: props.collapsedState === 'collapsed',
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aKz2G")).default), props);
    }
    function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hOWCC")).Main), {
            isFixed: props.isFixed,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kUAkd")).default), props);
    }
    function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? props.children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c8E4X")).default), props);
    }
    function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2MLVq")).Aside), {
            isFixed: props.isFixed,
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9xmqY")).default), props);
    }
    function $3d7d84f3bc65155e$export$364a989a35814102(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZlCus")).Panel), {
            xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4CWca")).default), props);
    }
    const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? {} : (0, (0, parcelRequire("cIcFn")).useCustomSkipLink)(id, title, index);
    const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? {} : (0, (0, parcelRequire("j3yGs")).useLeftSidebarFlyoutLock)();
    const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
        isLeftSidebarCollapsed: false,
        expandLeftSidebar: (0, ($parcel$interopDefault($8Rkzz))),
        collapseLeftSidebar: (0, ($parcel$interopDefault($8Rkzz))),
        leftSidebarState: {
            isFlyoutOpen: false,
            isResizing: false,
            isLeftSidebarCollapsed: false,
            leftSidebarWidth: 0,
            lastLeftSidebarWidth: 0,
            flyoutLockCount: 0,
            isFixed: true
        },
        setLeftSidebarState: (0, ($parcel$interopDefault($8Rkzz))),
        toggleLeftSidebar: (0, ($parcel$interopDefault($8Rkzz)))
    };
    const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : (0, (0, parcelRequire("j3yGs")).usePageLayoutResize)();
    const $3d7d84f3bc65155e$var$rightPanelStyles = {
        root: "_bfhk1bhr"
    };
    const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, (0, parcelRequire("22jFS")).BANNER_HEIGHT);
    const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH);
    const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH);
    const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH);
    const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH);
    const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT);
});
parcelRegister("5e5zm", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", ()=>$0c99a19d69d506cf$export$539e68c09584883a);
    $parcel$export(module.exports, "layoutStore", ()=>$0c99a19d69d506cf$export$b8cdfd44cddaf07);
    $parcel$export(module.exports, "useLayoutStoreActions", ()=>$0c99a19d69d506cf$export$6136bc3b9858cff4);
    $parcel$export(module.exports, "useDetailPanelWidth", ()=>$0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
    $parcel$export(module.exports, "useDetailPanelActions", ()=>$0c99a19d69d506cf$export$99e05a60cac05e86);
    var $3sQ5x;
    var $iXqE5;
    var $8CM3x;
    const $0c99a19d69d506cf$export$539e68c09584883a = 240;
    const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
    const $0c99a19d69d506cf$var$initialState = {
        isChromeless: false,
        isFullscreen: false,
        banner: {
            height: 0,
            activeBanner: null
        },
        topNavigation: {
            isVisible: true
        },
        leftPanel: {
            isVisible: true,
            width: 0
        },
        rightPanel: {
            isVisible: true,
            width: 0
        },
        bottomRightCorner: {
            container: undefined,
            portals: []
        },
        content: {
            leftSidebar: {
                width: $0c99a19d69d506cf$export$539e68c09584883a,
                isCollapsed: true,
                isVisible: true,
                isFlyoutOpen: false
            },
            rightSidebar: {
                stackState: []
            }
        }
    };
    const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $0c99a19d69d506cf$var$initialState,
        actions: (0, parcelRequire("8CM3x")).actions,
        name: 'JiraLayoutStore'
    });
    const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, (0, parcelRequire("3sQ5x")).createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
        selector: null
    });
    const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'detailPanelWidth',
        initialState: {
            width: 0
        },
        actions: {
            setWidth: (value)=>({ setState: setState })=>{
                    setState({
                        width: value
                    });
                }
        }
    });
    const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, (0, parcelRequire("3sQ5x")).createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
    const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
});
parcelRegister("8CM3x", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$939ad82f8ddcb8d9$export$e324594224ef24da);
    var $4oU0I;
    var $flhve;
    var $f5TQt;
    var $hPsAX;
    var $gqQUV;
    var $byk51;
    const $939ad82f8ddcb8d9$export$e324594224ef24da = {
        setIsChromeless: (0, parcelRequire("f5TQt")).setIsChromeless,
        setIsFullscreen: (0, parcelRequire("hPsAX")).setIsFullscreen,
        showBanner: (0, parcelRequire("4oU0I")).showBanner,
        dismissCurrentBanner: (0, parcelRequire("4oU0I")).dismissCurrentBanner,
        setLeftSidebarState: (0, parcelRequire("gqQUV")).setLeftSidebarState,
        setRightSidebarState: (0, parcelRequire("byk51")).setRightSidebarState,
        openRightSidebar: (0, parcelRequire("byk51")).openRightSidebar,
        closeRightSidebar: (0, parcelRequire("byk51")).closeRightSidebar,
        closeAllRightSidebar: (0, parcelRequire("byk51")).closeAllRightSidebar,
        closeCurrentRightSidebar: (0, parcelRequire("byk51")).closeCurrentRightSidebar,
        minimiseRightSidebar: (0, parcelRequire("byk51")).minimiseRightSidebar,
        registerBottomRightCornerContainer: (0, parcelRequire("flhve")).registerBottomRightCornerContainer,
        insertBottomRightCornerPortal: (0, parcelRequire("flhve")).insertBottomRightCornerPortal,
        removeBottomRightCornerPortal: (0, parcelRequire("flhve")).removeBottomRightCornerPortal
    };
});
parcelRegister("4oU0I", function(module, exports) {
    $parcel$export(module.exports, "showBanner", ()=>$820929f36789bf81$export$f5c0eb035ef26e87);
    $parcel$export(module.exports, "dismissCurrentBanner", ()=>$820929f36789bf81$export$a45bccc0cc9ac424);
    const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
            setState({
                banner: newState
            });
        };
    const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
            dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
                height: 0,
                activeBanner: null
            }));
        };
});
parcelRegister("flhve", function(module, exports) {
    $parcel$export(module.exports, "registerBottomRightCornerContainer", ()=>$560ff4740e75fa9e$export$2992ecf780497763);
    $parcel$export(module.exports, "insertBottomRightCornerPortal", ()=>$560ff4740e75fa9e$export$3ed25a6bee272520);
    $parcel$export(module.exports, "removeBottomRightCornerPortal", ()=>$560ff4740e75fa9e$export$928bf7e228ce06d2);
    const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    container: ref ?? undefined
                }
            });
        };
    const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            const { portals: portals } = bottomRightCorner;
            const sorted = [
                item,
                ...portals
            ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
            const index = sorted.findIndex((portal)=>portal.id === item.id);
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    portals: sorted
                }
            });
            return index;
        };
    const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            const { portals: portals } = bottomRightCorner;
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    portals: portals.filter((portal)=>portal.id !== id)
                }
            });
        };
});
parcelRegister("f5TQt", function(module, exports) {
    $parcel$export(module.exports, "setIsChromeless", ()=>$0389a2d5715d1f25$export$1998c4816ad37edb);
    const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
            setState({
                isChromeless: isChromeless
            });
        };
});
parcelRegister("hPsAX", function(module, exports) {
    $parcel$export(module.exports, "setIsFullscreen", ()=>$e3c9e6899dc6b3f0$export$9c73b2f282069160);
    const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
            setState({
                isFullscreen: isFullscreen
            });
        };
});
parcelRegister("gqQUV", function(module, exports) {
    $parcel$export(module.exports, "setLeftSidebarState", ()=>$54ca906cbb882b25$export$3e0fd2d894ef83c8);
    const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    leftSidebar: {
                        ...content.leftSidebar,
                        ...newState
                    }
                }
            });
        };
});
parcelRegister("byk51", function(module, exports) {
    $parcel$export(module.exports, "selectCurrentRightSidebar", ()=>$4dabd377b098e1a2$export$57758d0cfaeec2c);
    $parcel$export(module.exports, "setRightSidebarState", ()=>$4dabd377b098e1a2$export$f5584170a8c1db02);
    $parcel$export(module.exports, "closeAllRightSidebar", ()=>$4dabd377b098e1a2$export$d91a6e55d52aa3e9);
    $parcel$export(module.exports, "closeCurrentRightSidebar", ()=>$4dabd377b098e1a2$export$a9a5075d3d1b2165);
    $parcel$export(module.exports, "closeRightSidebar", ()=>$4dabd377b098e1a2$export$d7149233c76efb32);
    $parcel$export(module.exports, "minimiseRightSidebar", ()=>$4dabd377b098e1a2$export$4eedf7fa26a2749a);
    $parcel$export(module.exports, "openRightSidebar", ()=>$4dabd377b098e1a2$export$c8dafe074328c4ca);
    var $ajpes = parcelRequire("ajpes");
    const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
        const arrayCopy = [
            ...array
        ];
        const f = arrayCopy.splice(oldIndex, 1)[0];
        arrayCopy.splice(newIndex, 0, f);
        return arrayCopy;
    };
    const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
        const visited = {};
        return stackState.filter((item)=>{
            if (visited[item.panelId]) return false;
            visited[item.panelId] = true;
            return true;
        });
    };
    const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
        if (state.stackState.length === 1) return state.stackState[0];
        return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
    };
    const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: []
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            if (!currentStack.length) return;
            const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
            if (!currentRightSidebar) return;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: currentStack.filter((item)=>item.panelId !== panelId)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: currentStack.map((item)=>{
                            if (item.panelId !== panelId) return item;
                            return {
                                ...item,
                                isMinimised: true
                            };
                        })
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
                ...content.rightSidebar.stackState.map((item)=>{
                    if (item.panelId === panelId) return {
                        ...item,
                        isMinimised: isMinimised,
                        width: width
                    };
                    return item;
                })
            ] : [];
            const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
            if (matchedPanelIndex >= 0) {
                const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
                tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
                tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
                const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
                newRightSidebarStackStateValue[nextIdx].width = width;
                setState({
                    content: {
                        ...content,
                        rightSidebar: {
                            stackState: newRightSidebarStackStateValue
                        }
                    }
                });
                return;
            }
            const newRightSidebarStackStateValue = toTop ? [
                {
                    panelId: panelId,
                    width: width,
                    isCollapsed: false,
                    isMinimised: isMinimised
                },
                ...tempRightSidebarStackStateValue
            ] : [
                ...tempRightSidebarStackStateValue,
                {
                    panelId: panelId,
                    width: width,
                    isCollapsed: false,
                    isMinimised: isMinimised
                }
            ];
            if ((0, ($parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
        };
});
parcelRegister("axUP7", function(module, exports) {
    $parcel$export(module.exports, "withNestingOptimisation", ()=>$c861ce2b697701b9$export$ee1cb2a8280d8710);
    var $5uXOq = parcelRequire("5uXOq");
    var $j9VTE;
    var $9sGI6;
    const $c861ce2b697701b9$export$ee1cb2a8280d8710 = (Component)=>{
        const WithNestingOptimisation = (0, $5uXOq.forwardRef)((props, ref)=>{
            const children = typeof props === 'object' && props != null ? props.children : null;
            return (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)().shouldRender && !false ? (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                ref: ref
            }) : children;
        });
        WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, (0, parcelRequire("9sGI6")).getDisplayName)(Component)})`;
        return WithNestingOptimisation;
    };
});
parcelRegister("9sGI6", function(module, exports) {
    $parcel$export(module.exports, "getDisplayName", ()=>$0d4ebae82d1d47ab$export$be63e0664592e141);
    $parcel$export(module.exports, "default", ()=>$0d4ebae82d1d47ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
        if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
        if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
        return 'Component';
    };
    const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
        const WithInjectedProps = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...injectedProps,
                ...props
            });
        WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
        return WithInjectedProps;
    };
    var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;
});
parcelRegister("ajOhG", function(module, exports) {
    $parcel$export(module.exports, "FeedbackNudgeAsync", ()=>$9b3ebbbcc2dff472$export$be3f2958452e7be9);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $kxZPA;
    const $9b3ebbbcc2dff472$var$FeedbackNudgeLazy = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("7u4Dj")).then((exportedModule)=>exportedModule.FeedbackNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-feedback/index.tsx"
    });
    const $9b3ebbbcc2dff472$export$be3f2958452e7be9 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5),
            fallback: children,
            attributes: {
                nudgeId: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "feedback-onboarding-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9b3ebbbcc2dff472$var$FeedbackNudgeLazy, null, children)));
    $9b3ebbbcc2dff472$export$be3f2958452e7be9.displayName = 'FeedbackNudgeAsync';
});
parcelRegister("bBbEG", function(module, exports) {
    $parcel$export(module.exports, "OnboardingNudgeErrorBoundary", ()=>$383be1d115a6551b$export$3915a8814b99f0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkem5;
    var $8Bc5A;
    const $383be1d115a6551b$export$3915a8814b99f0b = (props)=>{
        const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkem5")).ErrorBoundaryWithChunkErrorLogging), {
            id: id,
            packageName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_NAME),
            render: ()=>fallback,
            attributes: attributes
        }, children);
    };
});
parcelRegister("lkem5", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", ()=>$3df8b034ebbd68e5$export$9171acf2e93b7d4d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $30rnQ;
    const $3df8b034ebbd68e5$export$9171acf2e93b7d4d = (props)=>{
        const { attributes: attributes, children: children, ...rest } = props;
        const addErrorBoundaryAnalyticsAttributes = (0, (0, parcelRequire("30rnQ")).useAddErrorBoundaryAnalyticsAttributes)(attributes);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            ...rest,
            attributes: addErrorBoundaryAnalyticsAttributes
        }, children);
    };
});
parcelRegister("30rnQ", function(module, exports) {
    $parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", ()=>$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2);
    $parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", ()=>$53c68ff9a9edd0fe$export$807be5f3f1ea996);
    var $5uXOq = parcelRequire("5uXOq");
    var $bCf8q;
    const $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2 = (error)=>({
            chunkLoadError: (0, (0, parcelRequire("bCf8q")).isLoaderError)(error)
        });
    const $53c68ff9a9edd0fe$export$807be5f3f1ea996 = (attributes = {})=>(0, $5uXOq.useCallback)((error)=>({
                ...attributes,
                ...$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2(error)
            }), [
            attributes
        ]);
});
const $dbbf68c32d8c4308$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
parcelRegister("7u4Dj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eSNL6").then(()=>parcelRequire('5YJ1A'));
});
parcelRegister("Fmgai", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c642b7880215349a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c642b7880215349a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        feedback: {
            "id": "spa-apps-sidebar-core.multi-project-menu.feedback-button.feedback",
            "defaultMessage": "Give feedback"
        }
    });
});
parcelRegister("NCdt4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b005747d8914d3b0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b005747d8914d3b0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        companyManagedProject: {
            "id": "spa-apps-sidebar-core.multi-project-menu.company-managed-project",
            "defaultMessage": "You're in a company-managed project"
        },
        navigationLabel: {
            "id": "spa-apps-sidebar-core.multi-project-menu.navigation-label",
            "defaultMessage": "Side"
        },
        teamManagedProject: {
            "id": "spa-apps-sidebar-core.multi-project-menu.team-managed-project",
            "defaultMessage": "You're in a team-managed project"
        },
        viewAllStarred: {
            "id": "spa-apps-sidebar-core.multi-project-menu.view-all-starred",
            "defaultMessage": "View all starred projects"
        }
    });
});
parcelRegister("dCGEg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$230ddc65e16732f3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gKZoD;
    var $fVnbM;
    var $i8Qvm;
    var $i5shE;
    var $7yUJn;
    var $N0aCi;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $iNzEe;
    var $doZTA;
    var $gb5lQ;
    var $iuAuR;
    var $6hYaZ;
    var $2kAEg;
    var $imgTm;
    const $230ddc65e16732f3$var$Overviews = ({ overviews: overviews, hasError: hasError })=>{
        (0, (0, parcelRequire("gKZoD")).di)(window);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const refresh = (0, $5uXOq.useCallback)(()=>typeof window !== 'undefined' && window.location.reload(), []);
        const [{ match: match, route: route }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const routeOverviewId = match.params?.overviewId;
        const [isCreateModalOpen, setIsCreateModalOpen] = (0, $5uXOq.useState)(false);
        const openCreateModal = (0, $5uXOq.useCallback)(()=>{
            setIsCreateModalOpen(true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createOverview');
        }, [
            createAnalyticsEvent
        ]);
        const closeCreateModal = (0, $5uXOq.useCallback)(()=>setIsCreateModalOpen(false), []);
        const showOverviewChangeboarding = (0, (0, parcelRequire("iNzEe")).useTriggerOverviewChangeboarding)();
        if (showOverviewChangeboarding) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuAuR")).default), {
            title: formatMessage((0, (0, parcelRequire("2kAEg")).default).overviewsHeader)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("N0aCi")).AsyncMigrationMessage), null));
        let content;
        if (hasError) content = (0, ($parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$ErrorWrapper, {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-error"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$ErrorMessage, null, formatMessage((0, (0, parcelRequire("2kAEg")).default).errorMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            onClick: refresh
        }, formatMessage((0, (0, parcelRequire("2kAEg")).default).refreshPage)));
        else if (overviews.length === 0) content = (0, ($parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$EmptyState, {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.empty-state"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            onClick: openCreateModal
        }, formatMessage((0, (0, parcelRequire("2kAEg")).default).createOverview)));
        else content = (0, ($parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$List, {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-list"
        }, overviews.map((overview)=>(0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: overview.id
            }, routeOverviewId === overview.id ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imgTm")).default), {
                overview: overview,
                to: (0, (0, parcelRequire("i5shE")).getOverviewUrl)(overview),
                isActive: true
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imgTm")).default), {
                overview: overview,
                to: (0, (0, parcelRequire("i5shE")).getOverviewUrl)(overview, route)
            }))));
        const hasReachedLimit = overviews?.length >= (0, (0, parcelRequire("gb5lQ")).OVERVIEW_MAX_LIMIT);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuAuR")).default), {
            title: formatMessage((0, (0, parcelRequire("2kAEg")).default).overviewsHeader)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6hYaZ")).default), {
            onClick: openCreateModal,
            hasReachedLimit: hasReachedLimit
        })), content, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isCreateModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7yUJn")).default), {
            onClose: closeCreateModal
        })));
    };
    var $230ddc65e16732f3$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($230ddc65e16732f3$var$Overviews);
    const $230ddc65e16732f3$var$EmptyState = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $230ddc65e16732f3$var$List = (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw",
                __cmplp.className
            ])
        });
    });
    const $230ddc65e16732f3$var$ErrorWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $230ddc65e16732f3$var$ErrorMessage = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s85axq _y3gn1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("i5shE", function(module, exports) {
    $parcel$export(module.exports, "getOverviewUrl", ()=>$b5027b2ddff99a4d$export$e314405e3f098e61);
    var $65Ltd;
    const $b5027b2ddff99a4d$export$e314405e3f098e61 = (overview, currentRoute)=>{
        switch(currentRoute?.name){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY:
                return `/jira/core/overviews/${overview.id}/summary`;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR:
                return `/jira/core/overviews/${overview.id}/calendar`;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE:
                return `/jira/core/overviews/${overview.id}/timeline`;
            default:
                return `/jira/core/overviews/${overview.id}`;
        }
    };
});
parcelRegister("7yUJn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2eb121a7f5478dbf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cm8b5;
    var $lfTZh;
    var $kxZPA;
    var $bTIks;
    const $2eb121a7f5478dbf$var$LazyCreateOverviewModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("15KQw")), {
        ssr: false,
        moduleId: "./src/packages/business/entity/overview/src/ui/create-overview-modal/main.tsx"
    });
    var $2eb121a7f5478dbf$export$2e2bcd8739ae039 = ({ onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceErrorBoundary), {
            experience: (0, (0, parcelRequire("bTIks")).CREATE_OVERVIEW_EXPERIENCE),
            fallback: "unmount",
            shouldStartExperience: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "overview-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2eb121a7f5478dbf$var$LazyCreateOverviewModal, {
            onClose: onClose
        })));
});
parcelRegister("cm8b5", function(module, exports) {
    $parcel$export(module.exports, "useExperienceStart", ()=>$aca94fc714dddc77$export$675e0d25df38d426);
    $parcel$export(module.exports, "useExperienceAbort", ()=>$aca94fc714dddc77$export$cc92b7ce453f4403);
    $parcel$export(module.exports, "useExperienceSuccess", ()=>$aca94fc714dddc77$export$e94f0da4fc0603c6);
    $parcel$export(module.exports, "useExperienceFail", ()=>$aca94fc714dddc77$export$606da7704d8eaf06);
    $parcel$export(module.exports, "useQueryBasedViewAutomaticTracking", ()=>$aca94fc714dddc77$export$8ca25d6ff1437be3);
    $parcel$export(module.exports, "ExperienceStart", ()=>$aca94fc714dddc77$export$f20b867e738a222c);
    $parcel$export(module.exports, "ExperienceFailed", ()=>$aca94fc714dddc77$export$ae65a9e09c4516b3);
    $parcel$export(module.exports, "ExperienceErrorBoundary", ()=>$aca94fc714dddc77$export$139c4a4ad101c3c5);
    $parcel$export(module.exports, "ExperienceSuccess", ()=>$aca94fc714dddc77$export$4962f3898bd5c829);
    $parcel$export(module.exports, "ExperienceAbort", ()=>$aca94fc714dddc77$export$c9b6bcd70239a39c);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Wswo;
    var $8UpTw;
    var $7CMCs;
    var $jcw0u;
    var $8dXDG;
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $jJZqs;
    const $aca94fc714dddc77$export$675e0d25df38d426 = ({ experience: experience, experienceId: experienceId, packageName: packageName })=>(0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: experience,
            experienceId: experienceId,
            analyticsSource: packageName
        });
    const $aca94fc714dddc77$export$cc92b7ce453f4403 = ({ experience: experience }, attributes)=>(0, (0, parcelRequire("8dXDG")).useExperienceAbort)({
            experience: experience,
            attributes: attributes
        });
    const $aca94fc714dddc77$export$e94f0da4fc0603c6 = ({ experience: experience })=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: experience
        });
    const $aca94fc714dddc77$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, packageName: packageName, teamName: teamName })=>{
        const onExperienceFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: experience
        });
        const onFail = (0, $5uXOq.useCallback)((location, error, extraAttributes)=>{
            const relevantError = error?.networkError ?? error;
            if (relevantError instanceof (0, (0, parcelRequire("jJZqs")).ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
            extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: `experience-tracker-${experienceId ?? experience}`,
                    packageName: packageName,
                    teamName: teamName
                },
                attributes: {
                    location: location
                },
                error: relevantError,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            onExperienceFail,
            experienceId,
            experience,
            packageName,
            teamName
        ]);
        return onFail;
    };
    const $aca94fc714dddc77$export$8ca25d6ff1437be3 = (experience, { loading: loading, error: error, shouldStartExperience: shouldStartExperience })=>{
        const [hasStarted, setHasStarted] = (0, $5uXOq.useState)(loading);
        const [hasCompleted, setHasCompleted] = (0, $5uXOq.useState)(false);
        const [hasExperienceBeenTracked, setHasExperienceBeenTracked] = (0, $5uXOq.useState)(false);
        const startExperience = $aca94fc714dddc77$export$675e0d25df38d426(experience);
        const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
        const onSuccess = $aca94fc714dddc77$export$e94f0da4fc0603c6(experience);
        (0, $5uXOq.useEffect)(()=>{
            if (shouldStartExperience === true) startExperience();
        }, [
            shouldStartExperience
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasStarted === false && loading === true) setHasStarted(true);
            if (hasStarted === true && loading === false) {
                setHasCompleted(true);
                setHasExperienceBeenTracked(false);
            }
        }, [
            hasStarted,
            loading
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasCompleted && !hasExperienceBeenTracked) {
                setHasExperienceBeenTracked(true);
                if (typeof error !== 'undefined') {
                    onFail(`${experience.experience} ${experience.experienceId || ''} useEffect error handling`, error, (0, (0, parcelRequire("8Wswo")).getGraphqlErrorAttributes)(error));
                    return;
                }
                onSuccess({
                    loaded: true
                });
            }
        }, [
            error,
            experience,
            hasCompleted,
            hasExperienceBeenTracked,
            onFail,
            onSuccess
        ]);
    };
    const $aca94fc714dddc77$export$f20b867e738a222c = (0, $5uXOq.memo)(({ experience: experience })=>{
        const start = $aca94fc714dddc77$export$675e0d25df38d426(experience);
        (0, $5uXOq.useEffect)(()=>{
            start();
        }, [
            start
        ]);
        return null;
    });
    const $aca94fc714dddc77$export$ae65a9e09c4516b3 = (0, $5uXOq.memo)(({ experience: experience, error: error, attributes: attributes })=>{
        const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
        (0, $5uXOq.useEffect)(()=>{
            onFail(experience.experience, error, attributes);
        }, [
            attributes,
            error,
            experience,
            onFail
        ]);
        return null;
    });
    const $aca94fc714dddc77$export$139c4a4ad101c3c5 = ({ experience: experience, shouldStartExperience: shouldStartExperience, fallback: fallback = (0, (0, parcelRequire("8UpTw")).ErrorPage), children: children })=>{
        const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            packageName: experience.packageName,
            teamName: experience.teamName,
            id: experience.experience,
            onError: onFail,
            fallback: fallback
        }, shouldStartExperience === true && (0, ($parcel$interopDefault($5uXOq))).createElement($aca94fc714dddc77$export$f20b867e738a222c, {
            experience: experience
        }), children);
    };
    const $aca94fc714dddc77$export$4962f3898bd5c829 = (0, $5uXOq.memo)(({ experience: experience, attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: experience.experience,
            attributes: {
                ...experience.experienceId == null ? undefined : {
                    experienceId: experience.experienceId
                },
                ...attributes
            }
        }));
    const $aca94fc714dddc77$export$c9b6bcd70239a39c = (0, $5uXOq.memo)(({ experience: experience, error: error })=>{
        const onAbort = $aca94fc714dddc77$export$cc92b7ce453f4403(experience);
        (0, $5uXOq.useEffect)(()=>{
            onAbort(experience.experience, {
                error: error.message
            });
        }, [
            error,
            experience,
            onAbort
        ]);
        return null;
    });
});
parcelRegister("8Wswo", function(module, exports) {
    $parcel$export(module.exports, "shouldHandleTheError", ()=>$6f94bc39289ec711$export$47770c8b6d645cdb);
    $parcel$export(module.exports, "getGraphqlErrorAttributes", ()=>$6f94bc39289ec711$export$b19e649eafc62480);
    var $e3a3O;
    const $6f94bc39289ec711$var$errorWhitelist = [
        'EXPERIENCE_UNAVAILABLE',
        'FIELD_UNAVAILABLE'
    ];
    const $6f94bc39289ec711$export$47770c8b6d645cdb = (error)=>{
        if (error?.networkError) return true;
        const filterIssueLinksDisabledErrors = (graphQLError)=>{
            const isWhitelisted = $6f94bc39289ec711$var$errorWhitelist.includes(graphQLError?.extensions?.errorType);
            return !isWhitelisted;
        };
        const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueLinksDisabledErrors);
        return errorsToShow.length > 0;
    };
    const $6f94bc39289ec711$export$b19e649eafc62480 = (error)=>{
        const isApolloError = error instanceof (0, (0, parcelRequire("e3a3O")).ApolloError);
        if (!isApolloError) return {};
        const getErrorAttribute = (graphQLErrors, errorAttribute)=>{
            const errors = graphQLErrors.map((graphQLError)=>graphQLError?.extensions?.[errorAttribute]).filter(Boolean);
            return JSON.stringify(errors);
        };
        return {
            statusCodes: getErrorAttribute(error?.graphQLErrors || [], 'statusCode'),
            errorTypes: getErrorAttribute(error?.graphQLErrors || [], 'errorType')
        };
    };
});
parcelRegister("e3a3O", function(module, exports) {
    $parcel$export(module.exports, "NetworkStatus", ()=>$02a3c2aebc919401$export$bd096ddbd246c79c);
    $parcel$export(module.exports, "ApolloError", ()=>$02a3c2aebc919401$export$26a337512320b8c6);
    $parcel$export(module.exports, "ApolloClient", ()=>$02a3c2aebc919401$export$13f5a5f0f1dbab88);
    $parcel$export(module.exports, "default", ()=>$02a3c2aebc919401$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jojW6;
    var $bqMzA = parcelRequire("bqMzA");
    var $clSzL;
    var $aS6b9;
    var $ebaCz = parcelRequire("ebaCz");
    var $1DiV8 = parcelRequire("1DiV8");
    var $12QNw;
    var $02a3c2aebc919401$export$bd096ddbd246c79c;
    (function(NetworkStatus) {
        NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
        NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
        NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
        NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
        NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
        NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
        NetworkStatus[NetworkStatus["error"] = 8] = "error";
    })($02a3c2aebc919401$export$bd096ddbd246c79c || ($02a3c2aebc919401$export$bd096ddbd246c79c = {}));
    function $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus) {
        return networkStatus < 7;
    }
    var $02a3c2aebc919401$var$Observable = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Observable, _super);
        function Observable() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Observable.prototype[0, $ebaCz.default] = function() {
            return this;
        };
        Observable.prototype['@@observable'] = function() {
            return this;
        };
        return Observable;
    }((0, (0, parcelRequire("aS6b9")).default));
    function $02a3c2aebc919401$var$isNonEmptyArray(value) {
        return Array.isArray(value) && value.length > 0;
    }
    function $02a3c2aebc919401$export$17f5e6bd290bb15d(err) {
        return err.hasOwnProperty('graphQLErrors');
    }
    var $02a3c2aebc919401$var$generateErrorMessage = function(err) {
        var message = '';
        if ($02a3c2aebc919401$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
            var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
        });
        if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
        message = message.replace(/\n$/, '');
        return message;
    };
    var $02a3c2aebc919401$export$26a337512320b8c6 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ApolloError, _super);
        function ApolloError(_a) {
            var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
            var _this = _super.call(this, errorMessage) || this;
            _this.graphQLErrors = graphQLErrors || [];
            _this.networkError = networkError || null;
            if (!errorMessage) _this.message = $02a3c2aebc919401$var$generateErrorMessage(_this);
            else _this.message = errorMessage;
            _this.extraInfo = extraInfo;
            _this.__proto__ = ApolloError.prototype;
            return _this;
        }
        return ApolloError;
    }(Error);
    var $02a3c2aebc919401$export$160bafb6ac1e0641;
    (function(FetchType) {
        FetchType[FetchType["normal"] = 1] = "normal";
        FetchType[FetchType["refetch"] = 2] = "refetch";
        FetchType[FetchType["poll"] = 3] = "poll";
    })($02a3c2aebc919401$export$160bafb6ac1e0641 || ($02a3c2aebc919401$export$160bafb6ac1e0641 = {}));
    var $02a3c2aebc919401$var$hasError = function(storeValue, policy) {
        if (policy === void 0) policy = 'none';
        return storeValue && (storeValue.networkError || policy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(storeValue.graphQLErrors));
    };
    var $02a3c2aebc919401$export$6c1b56eac59c9584 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ObservableQuery, _super);
        function ObservableQuery(_a) {
            var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
            var _this = _super.call(this, function(observer) {
                return _this.onSubscribe(observer);
            }) || this;
            _this.observers = new Set();
            _this.subscriptions = new Set();
            _this.isTornDown = false;
            _this.options = options;
            _this.variables = options.variables || {};
            _this.queryId = queryManager.generateQueryId();
            _this.shouldSubscribe = shouldSubscribe;
            var opDef = (0, (0, parcelRequire("jojW6")).getOperationDefinition)(options.query);
            _this.queryName = opDef && opDef.name && opDef.name.value;
            _this.queryManager = queryManager;
            return _this;
        }
        ObservableQuery.prototype.result = function() {
            var _this = this;
            return new Promise(function(resolve, reject) {
                var observer = {
                    next: function(result) {
                        resolve(result);
                        _this.observers.delete(observer);
                        if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                        setTimeout(function() {
                            subscription.unsubscribe();
                        }, 0);
                    },
                    error: reject
                };
                var subscription = _this.subscribe(observer);
            });
        };
        ObservableQuery.prototype.currentResult = function() {
            var result = this.getCurrentResult();
            if (result.data === undefined) result.data = {};
            return result;
        };
        ObservableQuery.prototype.getCurrentResult = function() {
            if (this.isTornDown) {
                var lastResult = this.lastResult;
                return {
                    data: !this.lastError && lastResult && lastResult.data || void 0,
                    error: this.lastError,
                    loading: false,
                    networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error
                };
            }
            var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
            var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
            var result;
            var fetchPolicy = this.options.fetchPolicy;
            var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
            if (queryStoreValue) {
                var networkStatus = queryStoreValue.networkStatus;
                if ($02a3c2aebc919401$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                    data: void 0,
                    loading: false,
                    networkStatus: networkStatus,
                    error: new $02a3c2aebc919401$export$26a337512320b8c6({
                        graphQLErrors: queryStoreValue.graphQLErrors,
                        networkError: queryStoreValue.networkError
                    })
                };
                if (queryStoreValue.variables) {
                    this.options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options.variables), queryStoreValue.variables);
                    this.variables = this.options.variables;
                }
                result = {
                    data: data,
                    loading: $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus),
                    networkStatus: networkStatus
                };
                if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
            } else {
                var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
                result = {
                    data: data,
                    loading: loading,
                    networkStatus: loading ? $02a3c2aebc919401$export$bd096ddbd246c79c.loading : $02a3c2aebc919401$export$bd096ddbd246c79c.ready
                };
            }
            if (!partial) this.updateLastResult((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                stale: false
            }));
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                partial: partial
            });
        };
        ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
            var snapshot = this.lastResultSnapshot;
            return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $bqMzA.equal)(snapshot.data, newResult.data));
        };
        ObservableQuery.prototype.getLastResult = function() {
            return this.lastResult;
        };
        ObservableQuery.prototype.getLastError = function() {
            return this.lastError;
        };
        ObservableQuery.prototype.resetLastResults = function() {
            delete this.lastResult;
            delete this.lastResultSnapshot;
            delete this.lastError;
            this.isTornDown = false;
        };
        ObservableQuery.prototype.resetQueryStoreErrors = function() {
            var queryStore = this.queryManager.queryStore.get(this.queryId);
            if (queryStore) {
                queryStore.networkError = null;
                queryStore.graphQLErrors = [];
            }
        };
        ObservableQuery.prototype.refetch = function(variables) {
            var fetchPolicy = this.options.fetchPolicy;
            if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $1DiV8.InvariantError)(1));
            if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
            if (!(0, $bqMzA.equal)(this.variables, variables)) this.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.variables), variables);
            if (!(0, $bqMzA.equal)(this.options.variables, this.variables)) this.options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options.variables), this.variables);
            return this.queryManager.fetchQuery(this.queryId, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options), {
                fetchPolicy: fetchPolicy
            }), $02a3c2aebc919401$export$160bafb6ac1e0641.refetch);
        };
        ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
            var _this = this;
            (0, $1DiV8.invariant)(fetchMoreOptions.updateQuery, 2);
            var combinedOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options), fetchMoreOptions), {
                variables: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.variables), fetchMoreOptions.variables)
            })), {
                fetchPolicy: 'network-only'
            });
            var qid = this.queryManager.generateQueryId();
            return this.queryManager.fetchQuery(qid, combinedOptions, $02a3c2aebc919401$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
                _this.updateQuery(function(previousResult) {
                    return fetchMoreOptions.updateQuery(previousResult, {
                        fetchMoreResult: fetchMoreResult.data,
                        variables: combinedOptions.variables
                    });
                });
                _this.queryManager.stopQuery(qid);
                return fetchMoreResult;
            }, function(error) {
                _this.queryManager.stopQuery(qid);
                throw error;
            });
        };
        ObservableQuery.prototype.subscribeToMore = function(options) {
            var _this = this;
            var subscription = this.queryManager.startGraphQLSubscription({
                query: options.document,
                variables: options.variables
            }).subscribe({
                next: function(subscriptionData) {
                    var updateQuery = options.updateQuery;
                    if (updateQuery) _this.updateQuery(function(previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables
                        });
                    });
                },
                error: function(err) {
                    if (options.onError) {
                        options.onError(err);
                        return;
                    }
                }
            });
            this.subscriptions.add(subscription);
            return function() {
                if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
            };
        };
        ObservableQuery.prototype.setOptions = function(opts) {
            var oldFetchPolicy = this.options.fetchPolicy;
            this.options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options), opts);
            if (opts.pollInterval) this.startPolling(opts.pollInterval);
            else if (opts.pollInterval === 0) this.stopPolling();
            var fetchPolicy = opts.fetchPolicy;
            return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
        };
        ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
            if (tryFetch === void 0) tryFetch = false;
            if (fetchResults === void 0) fetchResults = true;
            this.isTornDown = false;
            variables = variables || this.variables;
            if (!tryFetch && (0, $bqMzA.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
            this.variables = this.options.variables = variables;
            if (!this.observers.size) return Promise.resolve();
            return this.queryManager.fetchQuery(this.queryId, this.options);
        };
        ObservableQuery.prototype.updateQuery = function(mapFn) {
            var queryManager = this.queryManager;
            var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
            var newResult = (0, (0, parcelRequire("jojW6")).tryFunctionOrLogError)(function() {
                return mapFn(previousResult, {
                    variables: variables
                });
            });
            if (newResult) {
                queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
                queryManager.broadcastQueries();
            }
        };
        ObservableQuery.prototype.stopPolling = function() {
            this.queryManager.stopPollingQuery(this.queryId);
            this.options.pollInterval = undefined;
        };
        ObservableQuery.prototype.startPolling = function(pollInterval) {
            $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
            this.options.pollInterval = pollInterval;
            this.queryManager.startPollingQuery(this.options, this.queryId);
        };
        ObservableQuery.prototype.updateLastResult = function(newResult) {
            var previousResult = this.lastResult;
            this.lastResult = newResult;
            this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, (0, parcelRequire("jojW6")).cloneDeep)(newResult);
            return previousResult;
        };
        ObservableQuery.prototype.onSubscribe = function(observer) {
            var _this = this;
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !this.observers.size;
            this.observers.add(observer);
            if (observer.next && this.lastResult) observer.next(this.lastResult);
            if (observer.error && this.lastError) observer.error(this.lastError);
            if (first) this.setUpQuery();
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        };
        ObservableQuery.prototype.setUpQuery = function() {
            var _this = this;
            var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
            if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
            if (this.options.pollInterval) {
                $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
                queryManager.startPollingQuery(this.options, queryId);
            }
            var onError = function(error) {
                _this.updateLastResult((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, _this.lastResult), {
                    errors: error.graphQLErrors,
                    networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error,
                    loading: false
                }));
                $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
            };
            queryManager.observeQuery(queryId, this.options, {
                next: function(result) {
                    if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                        var previousResult_1 = _this.updateLastResult(result);
                        var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                        if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                            var previousVariables = _this.variables;
                            _this.variables = _this.options.variables = variables;
                            if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $bqMzA.equal)(previousVariables, variables)) _this.refetch();
                            else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                        });
                        else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                    }
                },
                error: onError
            }).catch(onError);
        };
        ObservableQuery.prototype.tearDownQuery = function() {
            var queryManager = this.queryManager;
            this.isTornDown = true;
            queryManager.stopPollingQuery(this.queryId);
            this.subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this.subscriptions.clear();
            queryManager.removeObservableQuery(this.queryId);
            queryManager.stopQuery(this.queryId);
            this.observers.clear();
        };
        return ObservableQuery;
    }($02a3c2aebc919401$var$Observable);
    function $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback(error) {}
    function $02a3c2aebc919401$var$iterateObserversSafely(observers, method, argument) {
        var observersWithMethod = [];
        observers.forEach(function(obs) {
            return obs[method] && observersWithMethod.push(obs);
        });
        observersWithMethod.forEach(function(obs) {
            return obs[method](argument);
        });
    }
    function $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(obsQuery) {
        var fetchPolicy = obsQuery.options.fetchPolicy;
        (0, $1DiV8.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
    }
    var $02a3c2aebc919401$var$MutationStore = function() {
        function MutationStore() {
            this.store = {};
        }
        MutationStore.prototype.getStore = function() {
            return this.store;
        };
        MutationStore.prototype.get = function(mutationId) {
            return this.store[mutationId];
        };
        MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
            this.store[mutationId] = {
                mutation: mutation,
                variables: variables || {},
                loading: true,
                error: null
            };
        };
        MutationStore.prototype.markMutationError = function(mutationId, error) {
            var mutation = this.store[mutationId];
            if (mutation) {
                mutation.loading = false;
                mutation.error = error;
            }
        };
        MutationStore.prototype.markMutationResult = function(mutationId) {
            var mutation = this.store[mutationId];
            if (mutation) {
                mutation.loading = false;
                mutation.error = null;
            }
        };
        MutationStore.prototype.reset = function() {
            this.store = {};
        };
        return MutationStore;
    }();
    var $02a3c2aebc919401$var$QueryStore = function() {
        function QueryStore() {
            this.store = {};
        }
        QueryStore.prototype.getStore = function() {
            return this.store;
        };
        QueryStore.prototype.get = function(queryId) {
            return this.store[queryId];
        };
        QueryStore.prototype.initQuery = function(query) {
            var previousQuery = this.store[query.queryId];
            (0, $1DiV8.invariant)(!previousQuery || previousQuery.document === query.document || (0, $bqMzA.equal)(previousQuery.document, query.document), 19);
            var isSetVariables = false;
            var previousVariables = null;
            if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.loading) {
                if (!(0, $bqMzA.equal)(previousQuery.variables, query.variables)) {
                    isSetVariables = true;
                    previousVariables = previousQuery.variables;
                }
            }
            var networkStatus;
            if (isSetVariables) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.setVariables;
            else if (query.isPoll) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.poll;
            else if (query.isRefetch) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.refetch;
            else networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
            var graphQLErrors = [];
            if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
            this.store[query.queryId] = {
                document: query.document,
                variables: query.variables,
                previousVariables: previousVariables,
                networkError: null,
                graphQLErrors: graphQLErrors,
                networkStatus: networkStatus,
                metadata: query.metadata
            };
            if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.fetchMore;
        };
        QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
            if (!this.store || !this.store[queryId]) return;
            this.store[queryId].networkError = null;
            this.store[queryId].graphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(result.errors) ? result.errors : [];
            this.store[queryId].previousVariables = null;
            this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
            if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        };
        QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
            if (!this.store || !this.store[queryId]) return;
            this.store[queryId].networkError = error;
            this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.error;
            if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
        };
        QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
            var storeValue = this.store && this.store[queryId];
            if (storeValue) {
                storeValue.networkError = null;
                storeValue.previousVariables = null;
                if (complete) storeValue.networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
            }
        };
        QueryStore.prototype.stopQuery = function(queryId) {
            delete this.store[queryId];
        };
        QueryStore.prototype.reset = function(observableQueryIds) {
            var _this = this;
            Object.keys(this.store).forEach(function(queryId) {
                if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
                else _this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
            });
        };
        return QueryStore;
    }();
    function $02a3c2aebc919401$var$capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    var $02a3c2aebc919401$var$LocalState = function() {
        function LocalState(_a) {
            var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
            this.cache = cache;
            if (client) this.client = client;
            if (resolvers) this.addResolvers(resolvers);
            if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
        }
        LocalState.prototype.addResolvers = function(resolvers) {
            var _this = this;
            this.resolvers = this.resolvers || {};
            if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
                _this.resolvers = (0, (0, parcelRequire("jojW6")).mergeDeep)(_this.resolvers, resolverGroup);
            });
            else this.resolvers = (0, (0, parcelRequire("jojW6")).mergeDeep)(this.resolvers, resolvers);
        };
        LocalState.prototype.setResolvers = function(resolvers) {
            this.resolvers = {};
            this.addResolvers(resolvers);
        };
        LocalState.prototype.getResolvers = function() {
            return this.resolvers || {};
        };
        LocalState.prototype.runResolvers = function(_a) {
            var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_c) {
                    if (document) return [
                        2,
                        this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, remoteResult), {
                                data: localResult.result
                            });
                        })
                    ];
                    return [
                        2,
                        remoteResult
                    ];
                });
            });
        };
        LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
            this.fragmentMatcher = fragmentMatcher;
        };
        LocalState.prototype.getFragmentMatcher = function() {
            return this.fragmentMatcher;
        };
        LocalState.prototype.clientQuery = function(document) {
            if ((0, (0, parcelRequire("jojW6")).hasDirectives)([
                'client'
            ], document)) {
                if (this.resolvers) return document;
            }
            return null;
        };
        LocalState.prototype.serverQuery = function(document) {
            return this.resolvers ? (0, (0, parcelRequire("jojW6")).removeClientSetsFromDocument)(document) : document;
        };
        LocalState.prototype.prepareContext = function(context) {
            if (context === void 0) context = {};
            var cache = this.cache;
            var newContext = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                cache: cache,
                getCacheKey: function(obj) {
                    if (cache.config) return cache.config.dataIdFromObject(obj);
                    else (0, $1DiV8.invariant)(false, 6);
                }
            });
            return newContext;
        };
        LocalState.prototype.addExportedVariables = function(document, variables, context) {
            if (variables === void 0) variables = {};
            if (context === void 0) context = {};
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                    if (document) return [
                        2,
                        this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, variables), data.exportedVariables);
                        })
                    ];
                    return [
                        2,
                        (0, (0, parcelRequire("3VFsf")).__assign)({}, variables)
                    ];
                });
            });
        };
        LocalState.prototype.shouldForceResolvers = function(document) {
            var forceResolvers = false;
            (0, (0, parcelRequire("12QNw")).visit)(document, {
                Directive: {
                    enter: function(node) {
                        if (node.name.value === 'client' && node.arguments) {
                            forceResolvers = node.arguments.some(function(arg) {
                                return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                            });
                            if (forceResolvers) return 0, (0, parcelRequire("12QNw")).BREAK;
                        }
                    }
                }
            });
            return forceResolvers;
        };
        LocalState.prototype.buildRootValueFromCache = function(document, variables) {
            return this.cache.diff({
                query: (0, (0, parcelRequire("jojW6")).buildQueryFromSelectionSet)(document),
                variables: variables,
                returnPartialData: true,
                optimistic: false
            }).result;
        };
        LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            if (context === void 0) context = {};
            if (variables === void 0) variables = {};
            if (fragmentMatcher === void 0) fragmentMatcher = function() {
                return true;
            };
            if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_b) {
                    mainDefinition = (0, (0, parcelRequire("jojW6")).getMainDefinition)(document);
                    fragments = (0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(document);
                    fragmentMap = (0, (0, parcelRequire("jojW6")).createFragmentMap)(fragments);
                    definitionOperation = mainDefinition.operation;
                    defaultOperationType = definitionOperation ? $02a3c2aebc919401$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                    _a = this, cache = _a.cache, client = _a.client;
                    execContext = {
                        fragmentMap: fragmentMap,
                        context: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                            cache: cache,
                            client: client
                        }),
                        variables: variables,
                        fragmentMatcher: fragmentMatcher,
                        defaultOperationType: defaultOperationType,
                        exportedVariables: {},
                        onlyRunForcedResolvers: onlyRunForcedResolvers
                    };
                    return [
                        2,
                        this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                            return {
                                result: result,
                                exportedVariables: execContext.exportedVariables
                            };
                        })
                    ];
                });
            });
        };
        LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var fragmentMap, context, variables, resultsToMerge, execute;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                    fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                    resultsToMerge = [
                        rootValue
                    ];
                    execute = function(selection) {
                        return (0, (0, parcelRequire("3VFsf")).__awaiter)(_this, void 0, void 0, function() {
                            var fragment, typeCondition;
                            return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return [
                                    2
                                ];
                                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) return [
                                    2,
                                    this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                        var _a;
                                        if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection)] = fieldResult, _a));
                                    })
                                ];
                                if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                                else {
                                    fragment = fragmentMap[selection.name.value];
                                    (0, $1DiV8.invariant)(fragment, 7);
                                }
                                if (fragment && fragment.typeCondition) {
                                    typeCondition = fragment.typeCondition.name.value;
                                    if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                        2,
                                        this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                            resultsToMerge.push(fragmentResult);
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                            });
                        });
                    };
                    return [
                        2,
                        Promise.all(selectionSet.selections.map(execute)).then(function() {
                            return (0, (0, parcelRequire("jojW6")).mergeDeepArray)(resultsToMerge);
                        })
                    ];
                });
            });
        };
        LocalState.prototype.resolveField = function(field, rootValue, execContext) {
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                    variables = execContext.variables;
                    fieldName = field.name.value;
                    aliasedFieldName = (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(field);
                    aliasUsed = fieldName !== aliasedFieldName;
                    defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                    resultPromise = Promise.resolve(defaultResult);
                    if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                        resolverType = rootValue.__typename || execContext.defaultOperationType;
                        resolverMap = this.resolvers && this.resolvers[resolverType];
                        if (resolverMap) {
                            resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                            if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, (0, parcelRequire("jojW6")).argumentsObjectFromField)(field, variables), execContext.context, {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }));
                        }
                    }
                    return [
                        2,
                        resultPromise.then(function(result) {
                            if (result === void 0) result = defaultResult;
                            if (field.directives) field.directives.forEach(function(directive) {
                                if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                    if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                                });
                            });
                            if (!field.selectionSet) return result;
                            if (result == null) return result;
                            if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        })
                    ];
                });
            });
        };
        LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
            var _this = this;
            return Promise.all(result.map(function(item) {
                if (item === null) return null;
                if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
                if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }));
        };
        return LocalState;
    }();
    function $02a3c2aebc919401$var$multiplex(inner) {
        var observers = new Set();
        var sub = null;
        return new $02a3c2aebc919401$var$Observable(function(observer) {
            observers.add(observer);
            sub = sub || inner.subscribe({
                next: function(value) {
                    observers.forEach(function(obs) {
                        return obs.next && obs.next(value);
                    });
                },
                error: function(error) {
                    observers.forEach(function(obs) {
                        return obs.error && obs.error(error);
                    });
                },
                complete: function() {
                    observers.forEach(function(obs) {
                        return obs.complete && obs.complete();
                    });
                }
            });
            return function() {
                if (observers.delete(observer) && !observers.size && sub) {
                    sub.unsubscribe();
                    sub = null;
                }
            };
        });
    }
    function $02a3c2aebc919401$var$asyncMap(observable, mapFn) {
        return new $02a3c2aebc919401$var$Observable(function(observer) {
            var next = observer.next, error = observer.error, complete = observer.complete;
            var activeNextCount = 0;
            var completed = false;
            var handler = {
                next: function(value) {
                    ++activeNextCount;
                    new Promise(function(resolve) {
                        resolve(mapFn(value));
                    }).then(function(result) {
                        --activeNextCount;
                        next && next.call(observer, result);
                        completed && handler.complete();
                    }, function(e) {
                        --activeNextCount;
                        error && error.call(observer, e);
                    });
                },
                error: function(e) {
                    error && error.call(observer, e);
                },
                complete: function() {
                    completed = true;
                    if (!activeNextCount) complete && complete.call(observer);
                }
            };
            var sub = observable.subscribe(handler);
            return function() {
                return sub.unsubscribe();
            };
        });
    }
    var $02a3c2aebc919401$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    var $02a3c2aebc919401$var$QueryManager = function() {
        function QueryManager(_a) {
            var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
                return undefined;
            } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
            this.mutationStore = new $02a3c2aebc919401$var$MutationStore();
            this.queryStore = new $02a3c2aebc919401$var$QueryStore();
            this.clientAwareness = {};
            this.idCounter = 1;
            this.queries = new Map();
            this.fetchQueryRejectFns = new Map();
            this.transformCache = new ((0, (0, parcelRequire("jojW6")).canUseWeakMap) ? WeakMap : Map)();
            this.inFlightLinkObservables = new Map();
            this.pollingInfoByQueryId = new Map();
            this.link = link;
            this.queryDeduplication = queryDeduplication;
            this.dataStore = store;
            this.onBroadcast = onBroadcast;
            this.clientAwareness = clientAwareness;
            this.localState = localState || new $02a3c2aebc919401$var$LocalState({
                cache: store.getCache()
            });
            this.ssrMode = ssrMode;
            this.assumeImmutableResults = !!assumeImmutableResults;
        }
        QueryManager.prototype.stop = function() {
            var _this = this;
            this.queries.forEach(function(_info, queryId) {
                _this.stopQueryNoBroadcast(queryId);
            });
            this.fetchQueryRejectFns.forEach(function(reject) {
                reject(new (0, $1DiV8.InvariantError)(8));
            });
        };
        QueryManager.prototype.mutate = function(_a) {
            var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var mutationId, generateUpdateQueriesInfo, self;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            (0, $1DiV8.invariant)(mutation, 9);
                            (0, $1DiV8.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                            mutationId = this.generateQueryId();
                            mutation = this.transform(mutation).document;
                            this.setQuery(mutationId, function() {
                                return {
                                    document: mutation
                                };
                            });
                            variables = this.getVariables(mutation, variables);
                            if (!this.transform(mutation).hasClientExports) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.localState.addExportedVariables(mutation, variables, context)
                            ];
                        case 1:
                            variables = _f.sent();
                            _f.label = 2;
                        case 2:
                            generateUpdateQueriesInfo = function() {
                                var ret = {};
                                if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                    var observableQuery = _a.observableQuery;
                                    if (observableQuery) {
                                        var queryName = observableQuery.queryName;
                                        if (queryName && $02a3c2aebc919401$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                            updater: updateQueriesByName[queryName],
                                            query: _this.queryStore.get(queryId)
                                        };
                                    }
                                });
                                return ret;
                            };
                            this.mutationStore.initMutation(mutationId, mutation, variables);
                            this.dataStore.markMutationInit({
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                updateQueries: generateUpdateQueriesInfo(),
                                update: updateWithProxyFn,
                                optimisticResponse: optimisticResponse
                            });
                            this.broadcastQueries();
                            self = this;
                            return [
                                2,
                                new Promise(function(resolve, reject) {
                                    var storeResult;
                                    var error;
                                    self.getObservableFromLink(mutation, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                                        optimisticResponse: optimisticResponse
                                    }), variables, false).subscribe({
                                        next: function(result) {
                                            if ((0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result) && errorPolicy === 'none') {
                                                error = new $02a3c2aebc919401$export$26a337512320b8c6({
                                                    graphQLErrors: result.errors
                                                });
                                                return;
                                            }
                                            self.mutationStore.markMutationResult(mutationId);
                                            if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                                mutationId: mutationId,
                                                result: result,
                                                document: mutation,
                                                variables: variables,
                                                updateQueries: generateUpdateQueriesInfo(),
                                                update: updateWithProxyFn
                                            });
                                            storeResult = result;
                                        },
                                        error: function(err) {
                                            self.mutationStore.markMutationError(mutationId, err);
                                            self.dataStore.markMutationComplete({
                                                mutationId: mutationId,
                                                optimisticResponse: optimisticResponse
                                            });
                                            self.broadcastQueries();
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                                                networkError: err
                                            }));
                                        },
                                        complete: function() {
                                            if (error) self.mutationStore.markMutationError(mutationId, error);
                                            self.dataStore.markMutationComplete({
                                                mutationId: mutationId,
                                                optimisticResponse: optimisticResponse
                                            });
                                            self.broadcastQueries();
                                            if (error) {
                                                reject(error);
                                                return;
                                            }
                                            if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                            var refetchQueryPromises = [];
                                            if ($02a3c2aebc919401$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                                if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                    var observableQuery = _a.observableQuery;
                                                    if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                                });
                                                else {
                                                    var queryOptions = {
                                                        query: refetchQuery.query,
                                                        variables: refetchQuery.variables,
                                                        fetchPolicy: 'network-only'
                                                    };
                                                    if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                    refetchQueryPromises.push(self.query(queryOptions));
                                                }
                                            });
                                            Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                                self.setQuery(mutationId, function() {
                                                    return {
                                                        document: null
                                                    };
                                                });
                                                if (errorPolicy === 'ignore' && storeResult && (0, (0, parcelRequire("jojW6")).graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                                resolve(storeResult);
                                            });
                                        }
                                    });
                                })
                            ];
                    }
                });
            });
        };
        QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                            query = this.transform(options.query).document;
                            variables = this.getVariables(query, options.variables);
                            if (!this.transform(query).hasClientExports) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.localState.addExportedVariables(query, variables, context)
                            ];
                        case 1:
                            variables = _e.sent();
                            _e.label = 2;
                        case 2:
                            options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                                variables: variables
                            });
                            isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                            needToFetch = isNetworkOnly;
                            if (!isNetworkOnly) {
                                _d = this.dataStore.getCache().diff({
                                    query: query,
                                    variables: variables,
                                    returnPartialData: true,
                                    optimistic: false
                                }), complete = _d.complete, result = _d.result;
                                needToFetch = !complete || fetchPolicy === 'cache-and-network';
                                storeResult = result;
                            }
                            shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                            if ((0, (0, parcelRequire("jojW6")).hasDirectives)([
                                'live'
                            ], query)) shouldFetch = true;
                            requestId = this.idCounter++;
                            cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                            this.setQuery(queryId, function() {
                                return {
                                    document: query,
                                    lastRequestId: requestId,
                                    invalidated: true,
                                    cancel: cancel
                                };
                            });
                            this.invalidate(fetchMoreForQueryId);
                            this.queryStore.initQuery({
                                queryId: queryId,
                                document: query,
                                storePreviousVariables: shouldFetch,
                                variables: variables,
                                isPoll: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.poll,
                                isRefetch: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.refetch,
                                metadata: metadata,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            });
                            this.broadcastQueries();
                            if (shouldFetch) {
                                networkResult = this.fetchRequest({
                                    requestId: requestId,
                                    queryId: queryId,
                                    document: query,
                                    options: options,
                                    fetchMoreForQueryId: fetchMoreForQueryId
                                }).catch(function(error) {
                                    if ($02a3c2aebc919401$export$17f5e6bd290bb15d(error)) throw error;
                                    else {
                                        if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                            _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                            _this.invalidate(queryId);
                                            _this.invalidate(fetchMoreForQueryId);
                                            _this.broadcastQueries();
                                        }
                                        throw new $02a3c2aebc919401$export$26a337512320b8c6({
                                            networkError: error
                                        });
                                    }
                                });
                                if (fetchPolicy !== 'cache-and-network') return [
                                    2,
                                    networkResult
                                ];
                                networkResult.catch(function() {});
                            }
                            this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                            this.invalidate(queryId);
                            this.invalidate(fetchMoreForQueryId);
                            if (this.transform(query).hasForcedResolvers) return [
                                2,
                                this.localState.runResolvers({
                                    document: query,
                                    remoteResult: {
                                        data: storeResult
                                    },
                                    context: context,
                                    variables: variables,
                                    onlyRunForcedResolvers: true
                                }).then(function(result) {
                                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                    _this.broadcastQueries();
                                    return result;
                                })
                            ];
                            this.broadcastQueries();
                            return [
                                2,
                                {
                                    data: storeResult
                                }
                            ];
                    }
                });
            });
        };
        QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
            var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
            if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
                return {
                    newData: {
                        result: result.data,
                        complete: true
                    }
                };
            });
            else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
        };
        QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
            var _this = this;
            function invoke(method, argument) {
                if (observer[method]) try {
                    observer[method](argument);
                } catch (e) {}
                else method;
            }
            return function(queryStoreValue, newData) {
                _this.invalidate(queryId, false);
                if (!queryStoreValue) return;
                var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
                var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
                if (fetchPolicy === 'standby') return;
                var loading = $02a3c2aebc919401$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
                var lastResult = observableQuery && observableQuery.getLastResult();
                var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
                var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
                if (loading && !shouldNotifyIfLoading) return;
                var hasGraphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
                var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
                if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                }));
                try {
                    var data = void 0;
                    var isMissing = void 0;
                    if (newData) {
                        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                            return {
                                newData: null
                            };
                        });
                        data = newData.result;
                        isMissing = !newData.complete;
                    } else {
                        var lastError = observableQuery && observableQuery.getLastError();
                        var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                        if (lastResult && lastResult.data && !errorStatusChanged) {
                            data = lastResult.data;
                            isMissing = false;
                        } else {
                            var diffResult = _this.dataStore.getCache().diff({
                                query: document,
                                variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                                returnPartialData: true,
                                optimistic: true
                            });
                            data = diffResult.result;
                            isMissing = !diffResult.complete;
                        }
                    }
                    var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                    var resultFromStore = {
                        data: stale ? lastResult && lastResult.data : data,
                        loading: loading,
                        networkStatus: queryStoreValue.networkStatus,
                        stale: stale
                    };
                    if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                    invoke('next', resultFromStore);
                } catch (networkError) {
                    invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                        networkError: networkError
                    }));
                }
            };
        };
        QueryManager.prototype.transform = function(document) {
            var transformCache = this.transformCache;
            if (!transformCache.has(document)) {
                var cache = this.dataStore.getCache();
                var transformed = cache.transformDocument(document);
                var forLink = (0, (0, parcelRequire("jojW6")).removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
                var clientQuery = this.localState.clientQuery(transformed);
                var serverQuery = this.localState.serverQuery(forLink);
                var cacheEntry_1 = {
                    document: transformed,
                    hasClientExports: (0, (0, parcelRequire("jojW6")).hasClientExports)(transformed),
                    hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                    clientQuery: clientQuery,
                    serverQuery: serverQuery,
                    defaultVars: (0, (0, parcelRequire("jojW6")).getDefaultValues)((0, (0, parcelRequire("jojW6")).getOperationDefinition)(transformed))
                };
                var add = function(doc) {
                    if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
                };
                add(document);
                add(transformed);
                add(clientQuery);
                add(serverQuery);
            }
            return transformCache.get(document);
        };
        QueryManager.prototype.getVariables = function(document, variables) {
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.transform(document).defaultVars), variables);
        };
        QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
            if (shouldSubscribe === void 0) shouldSubscribe = true;
            (0, $1DiV8.invariant)(options.fetchPolicy !== 'standby', 11);
            options.variables = this.getVariables(options.query, options.variables);
            if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
            var transformedOptions = (0, (0, parcelRequire("3VFsf")).__assign)({}, options);
            return new $02a3c2aebc919401$export$6c1b56eac59c9584({
                queryManager: this,
                options: transformedOptions,
                shouldSubscribe: shouldSubscribe
            });
        };
        QueryManager.prototype.query = function(options) {
            var _this = this;
            (0, $1DiV8.invariant)(options.query, 12);
            (0, $1DiV8.invariant)(options.query.kind === 'Document', 13);
            (0, $1DiV8.invariant)(!options.returnPartialData, 14);
            (0, $1DiV8.invariant)(!options.pollInterval, 15);
            return new Promise(function(resolve, reject) {
                var watchedQuery = _this.watchQuery(options, false);
                _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
                watchedQuery.result().then(resolve, reject).then(function() {
                    return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
                });
            });
        };
        QueryManager.prototype.generateQueryId = function() {
            return String(this.idCounter++);
        };
        QueryManager.prototype.stopQueryInStore = function(queryId) {
            this.stopQueryInStoreNoBroadcast(queryId);
            this.broadcastQueries();
        };
        QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
            this.stopPollingQuery(queryId);
            this.queryStore.stopQuery(queryId);
            this.invalidate(queryId);
        };
        QueryManager.prototype.addQueryListener = function(queryId, listener) {
            this.setQuery(queryId, function(_a) {
                var listeners = _a.listeners;
                listeners.add(listener);
                return {
                    invalidated: false
                };
            });
        };
        QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
            var _this = this;
            var cancel = this.getQuery(queryId).cancel;
            if (cancel) cancel();
            var previousResult = function() {
                var previousResult = null;
                var observableQuery = _this.getQuery(queryId).observableQuery;
                if (observableQuery) {
                    var lastResult = observableQuery.getLastResult();
                    if (lastResult) previousResult = lastResult.data;
                }
                return previousResult;
            };
            return this.dataStore.getCache().watch({
                query: document,
                variables: options.variables,
                optimistic: true,
                previousResult: previousResult,
                callback: function(newData) {
                    _this.setQuery(queryId, function() {
                        return {
                            invalidated: true,
                            newData: newData
                        };
                    });
                }
            });
        };
        QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
            this.setQuery(queryId, function() {
                return {
                    observableQuery: observableQuery
                };
            });
        };
        QueryManager.prototype.removeObservableQuery = function(queryId) {
            var cancel = this.getQuery(queryId).cancel;
            this.setQuery(queryId, function() {
                return {
                    observableQuery: null
                };
            });
            if (cancel) cancel();
        };
        QueryManager.prototype.clearStore = function() {
            this.fetchQueryRejectFns.forEach(function(reject) {
                reject(new (0, $1DiV8.InvariantError)(16));
            });
            var resetIds = [];
            this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                if (observableQuery) resetIds.push(queryId);
            });
            this.queryStore.reset(resetIds);
            this.mutationStore.reset();
            return this.dataStore.reset();
        };
        QueryManager.prototype.resetStore = function() {
            var _this = this;
            return this.clearStore().then(function() {
                return _this.reFetchObservableQueries();
            });
        };
        QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
            var _this = this;
            if (includeStandby === void 0) includeStandby = false;
            var observableQueryPromises = [];
            this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                if (observableQuery) {
                    var fetchPolicy = observableQuery.options.fetchPolicy;
                    observableQuery.resetLastResults();
                    if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                    _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    _this.invalidate(queryId);
                }
            });
            this.broadcastQueries();
            return Promise.all(observableQueryPromises);
        };
        QueryManager.prototype.observeQuery = function(queryId, options, observer) {
            this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
            return this.fetchQuery(queryId, options);
        };
        QueryManager.prototype.startQuery = function(queryId, options, listener) {
            this.addQueryListener(queryId, listener);
            this.fetchQuery(queryId, options).catch(function() {
                return undefined;
            });
            return queryId;
        };
        QueryManager.prototype.startGraphQLSubscription = function(_a) {
            var _this = this;
            var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
            query = this.transform(query).document;
            variables = this.getVariables(query, variables);
            var makeObservable = function(variables) {
                return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                    if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                        _this.dataStore.markSubscriptionResult(result, query, variables);
                        _this.broadcastQueries();
                    }
                    if ((0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result)) throw new $02a3c2aebc919401$export$26a337512320b8c6({
                        graphQLErrors: result.errors
                    });
                    return result;
                });
            };
            if (this.transform(query).hasClientExports) {
                var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
                return new $02a3c2aebc919401$var$Observable(function(observer) {
                    var sub = null;
                    observablePromise_1.then(function(observable) {
                        return sub = observable.subscribe(observer);
                    }, observer.error);
                    return function() {
                        return sub && sub.unsubscribe();
                    };
                });
            }
            return makeObservable(variables);
        };
        QueryManager.prototype.stopQuery = function(queryId) {
            this.stopQueryNoBroadcast(queryId);
            this.broadcastQueries();
        };
        QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
            this.stopQueryInStoreNoBroadcast(queryId);
            this.removeQuery(queryId);
        };
        QueryManager.prototype.removeQuery = function(queryId) {
            this.fetchQueryRejectFns.delete("query:" + queryId);
            this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
            this.getQuery(queryId).subscriptions.forEach(function(x) {
                return x.unsubscribe();
            });
            this.queries.delete(queryId);
        };
        QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
            if (optimistic === void 0) optimistic = true;
            var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
            var lastResult = observableQuery.getLastResult();
            var newData = this.getQuery(observableQuery.queryId).newData;
            if (newData && newData.complete) return {
                data: newData.result,
                partial: false
            };
            if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
                data: undefined,
                partial: false
            };
            var _b = this.dataStore.getCache().diff({
                query: query,
                variables: variables,
                previousResult: lastResult ? lastResult.data : undefined,
                returnPartialData: true,
                optimistic: optimistic
            }), result = _b.result, complete = _b.complete;
            return {
                data: complete || returnPartialData ? result : void 0,
                partial: !complete
            };
        };
        QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
            var observableQuery;
            if (typeof queryIdOrObservable === 'string') {
                var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
                (0, $1DiV8.invariant)(foundObserveableQuery, 17);
                observableQuery = foundObserveableQuery;
            } else observableQuery = queryIdOrObservable;
            var _a = observableQuery.options, variables = _a.variables, query = _a.query;
            return {
                previousResult: this.getCurrentQueryResult(observableQuery, false).data,
                variables: variables,
                document: query
            };
        };
        QueryManager.prototype.broadcastQueries = function() {
            var _this = this;
            this.onBroadcast();
            this.queries.forEach(function(info, id) {
                if (info.invalidated) info.listeners.forEach(function(listener) {
                    if (listener) listener(_this.queryStore.get(id), info.newData);
                });
            });
        };
        QueryManager.prototype.getLocalState = function() {
            return this.localState;
        };
        QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
            var _this = this;
            if (deduplication === void 0) deduplication = this.queryDeduplication;
            var observable;
            var serverQuery = this.transform(query).serverQuery;
            if (serverQuery) {
                var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
                var operation = {
                    query: serverQuery,
                    variables: variables,
                    operationName: (0, (0, parcelRequire("jojW6")).getOperationName)(serverQuery) || void 0,
                    context: this.prepareContext((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                        forceFetch: !deduplication
                    }))
                };
                context = operation.context;
                if (deduplication) {
                    var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                    inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                    var varJson_1 = JSON.stringify(variables);
                    observable = byVariables_1.get(varJson_1);
                    if (!observable) {
                        byVariables_1.set(varJson_1, observable = $02a3c2aebc919401$var$multiplex((0, (0, parcelRequire("clSzL")).execute)(link, operation)));
                        var cleanup = function() {
                            byVariables_1.delete(varJson_1);
                            if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                            cleanupSub_1.unsubscribe();
                        };
                        var cleanupSub_1 = observable.subscribe({
                            next: cleanup,
                            error: cleanup,
                            complete: cleanup
                        });
                    }
                } else observable = $02a3c2aebc919401$var$multiplex((0, (0, parcelRequire("clSzL")).execute)(link, operation));
            } else {
                observable = $02a3c2aebc919401$var$Observable.of({
                    data: {}
                });
                context = this.prepareContext(context);
            }
            var clientQuery = this.transform(query).clientQuery;
            if (clientQuery) observable = $02a3c2aebc919401$var$asyncMap(observable, function(result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables
                });
            });
            return observable;
        };
        QueryManager.prototype.fetchRequest = function(_a) {
            var _this = this;
            var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
            var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
            var resultFromStore;
            var errorsFromStore;
            return new Promise(function(resolve, reject) {
                var observable = _this.getObservableFromLink(document, options.context, variables);
                var fqrfId = "fetchRequest:" + queryId;
                _this.fetchQueryRejectFns.set(fqrfId, reject);
                var cleanup = function() {
                    _this.fetchQueryRejectFns.delete(fqrfId);
                    _this.setQuery(queryId, function(_a) {
                        var subscriptions = _a.subscriptions;
                        subscriptions.delete(subscription);
                    });
                };
                var subscription = observable.map(function(result) {
                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                        _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                        _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                        _this.invalidate(queryId);
                        _this.invalidate(fetchMoreForQueryId);
                        _this.broadcastQueries();
                    }
                    if (errorPolicy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(result.errors)) return reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                        graphQLErrors: result.errors
                    }));
                    if (errorPolicy === 'all') errorsFromStore = result.errors;
                    if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                    else {
                        var _a = _this.dataStore.getCache().diff({
                            variables: variables,
                            query: document,
                            optimistic: false,
                            returnPartialData: true
                        }), result_1 = _a.result, complete = _a.complete;
                        if (complete || options.returnPartialData) resultFromStore = result_1;
                    }
                }).subscribe({
                    error: function(error) {
                        cleanup();
                        reject(error);
                    },
                    complete: function() {
                        cleanup();
                        resolve({
                            data: resultFromStore,
                            errors: errorsFromStore,
                            loading: false,
                            networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.ready,
                            stale: false
                        });
                    }
                });
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.add(subscription);
                });
            });
        };
        QueryManager.prototype.getQuery = function(queryId) {
            return this.queries.get(queryId) || {
                listeners: new Set(),
                invalidated: false,
                document: null,
                newData: null,
                lastRequestId: 1,
                observableQuery: null,
                subscriptions: new Set()
            };
        };
        QueryManager.prototype.setQuery = function(queryId, updater) {
            var prev = this.getQuery(queryId);
            var newInfo = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, prev), updater(prev));
            this.queries.set(queryId, newInfo);
        };
        QueryManager.prototype.invalidate = function(queryId, invalidated) {
            if (invalidated === void 0) invalidated = true;
            if (queryId) this.setQuery(queryId, function() {
                return {
                    invalidated: invalidated
                };
            });
        };
        QueryManager.prototype.prepareContext = function(context) {
            if (context === void 0) context = {};
            var newContext = this.localState.prepareContext(context);
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, newContext), {
                clientAwareness: this.clientAwareness
            });
        };
        QueryManager.prototype.checkInFlight = function(queryId) {
            var query = this.queryStore.get(queryId);
            return query && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.ready && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.error;
        };
        QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
            var _this = this;
            var pollInterval = options.pollInterval;
            (0, $1DiV8.invariant)(pollInterval, 18);
            if (!this.ssrMode) {
                var info = this.pollingInfoByQueryId.get(queryId);
                if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
                info.interval = pollInterval;
                info.options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                    fetchPolicy: 'network-only'
                });
                var maybeFetch_1 = function() {
                    var info = _this.pollingInfoByQueryId.get(queryId);
                    if (info) {
                        if (_this.checkInFlight(queryId)) poll_1();
                        else _this.fetchQuery(queryId, info.options, $02a3c2aebc919401$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                    }
                };
                var poll_1 = function() {
                    var info = _this.pollingInfoByQueryId.get(queryId);
                    if (info) {
                        clearTimeout(info.timeout);
                        info.timeout = setTimeout(maybeFetch_1, info.interval);
                    }
                };
                if (listener) this.addQueryListener(queryId, listener);
                poll_1();
            }
            return queryId;
        };
        QueryManager.prototype.stopPollingQuery = function(queryId) {
            this.pollingInfoByQueryId.delete(queryId);
        };
        return QueryManager;
    }();
    var $02a3c2aebc919401$var$DataStore = function() {
        function DataStore(initialCache) {
            this.cache = initialCache;
        }
        DataStore.prototype.getCache = function() {
            return this.cache;
        };
        DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
            if (ignoreErrors === void 0) ignoreErrors = false;
            var writeWithErrors = !(0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result);
            if (ignoreErrors && (0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result) && result.data) writeWithErrors = true;
            if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
                result: result.data,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables
            });
        };
        DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
            if (!(0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result)) this.cache.write({
                result: result.data,
                dataId: 'ROOT_SUBSCRIPTION',
                query: document,
                variables: variables
            });
        };
        DataStore.prototype.markMutationInit = function(mutation) {
            var _this = this;
            if (mutation.optimisticResponse) {
                var optimistic_1;
                if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
                else optimistic_1 = mutation.optimisticResponse;
                this.cache.recordOptimisticTransaction(function(c) {
                    var orig = _this.cache;
                    _this.cache = c;
                    try {
                        _this.markMutationResult({
                            mutationId: mutation.mutationId,
                            result: {
                                data: optimistic_1
                            },
                            document: mutation.document,
                            variables: mutation.variables,
                            updateQueries: mutation.updateQueries,
                            update: mutation.update
                        });
                    } finally{
                        _this.cache = orig;
                    }
                }, mutation.mutationId);
            }
        };
        DataStore.prototype.markMutationResult = function(mutation) {
            var _this = this;
            if (!(0, (0, parcelRequire("jojW6")).graphQLResultHasError)(mutation.result)) {
                var cacheWrites_1 = [
                    {
                        result: mutation.result.data,
                        dataId: 'ROOT_MUTATION',
                        query: mutation.document,
                        variables: mutation.variables
                    }
                ];
                var updateQueries_1 = mutation.updateQueries;
                if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                    var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                    var _b = _this.cache.diff({
                        query: query.document,
                        variables: query.variables,
                        returnPartialData: true,
                        optimistic: false
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (complete) {
                        var nextQueryResult = (0, (0, parcelRequire("jojW6")).tryFunctionOrLogError)(function() {
                            return updater(currentQueryResult, {
                                mutationResult: mutation.result,
                                queryName: (0, (0, parcelRequire("jojW6")).getOperationName)(query.document) || undefined,
                                queryVariables: query.variables
                            });
                        });
                        if (nextQueryResult) cacheWrites_1.push({
                            result: nextQueryResult,
                            dataId: 'ROOT_QUERY',
                            query: query.document,
                            variables: query.variables
                        });
                    }
                });
                this.cache.performTransaction(function(c) {
                    cacheWrites_1.forEach(function(write) {
                        return c.write(write);
                    });
                    var update = mutation.update;
                    if (update) (0, (0, parcelRequire("jojW6")).tryFunctionOrLogError)(function() {
                        return update(c, mutation.result);
                    });
                });
            }
        };
        DataStore.prototype.markMutationComplete = function(_a) {
            var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
            if (optimisticResponse) this.cache.removeOptimistic(mutationId);
        };
        DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
            this.cache.write({
                result: newResult,
                dataId: 'ROOT_QUERY',
                variables: variables,
                query: document
            });
        };
        DataStore.prototype.reset = function() {
            return this.cache.reset();
        };
        return DataStore;
    }();
    var $02a3c2aebc919401$var$version = "2.6.10";
    var $02a3c2aebc919401$var$hasSuggestedDevtools = false;
    var $02a3c2aebc919401$export$13f5a5f0f1dbab88 = function() {
        function ApolloClient(options) {
            var _this = this;
            this.defaultOptions = {};
            this.resetStoreCallbacks = [];
            this.clearStoreCallbacks = [];
            var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
            var link = options.link;
            if (!link && resolvers) link = (0, (0, parcelRequire("clSzL")).ApolloLink).empty();
            if (!link || !cache) throw new (0, $1DiV8.InvariantError)(4);
            this.link = link;
            this.cache = cache;
            this.store = new $02a3c2aebc919401$var$DataStore(cache);
            this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
            this.queryDeduplication = queryDeduplication;
            this.defaultOptions = defaultOptions || {};
            this.typeDefs = typeDefs;
            if (ssrForceFetchDelay) setTimeout(function() {
                return _this.disableNetworkFetches = false;
            }, ssrForceFetchDelay);
            this.watchQuery = this.watchQuery.bind(this);
            this.query = this.query.bind(this);
            this.mutate = this.mutate.bind(this);
            this.resetStore = this.resetStore.bind(this);
            this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
            var defaultConnectToDevTools = false;
            if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
            this.version = $02a3c2aebc919401$var$version;
            this.localState = new $02a3c2aebc919401$var$LocalState({
                cache: cache,
                client: this,
                resolvers: resolvers,
                fragmentMatcher: fragmentMatcher
            });
            this.queryManager = new $02a3c2aebc919401$var$QueryManager({
                link: this.link,
                store: this.store,
                queryDeduplication: queryDeduplication,
                ssrMode: ssrMode,
                clientAwareness: {
                    name: clientAwarenessName,
                    version: clientAwarenessVersion
                },
                localState: this.localState,
                assumeImmutableResults: assumeImmutableResults,
                onBroadcast: function() {
                    if (_this.devToolsHookCb) _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.queryStore.getStore(),
                            mutations: _this.queryManager.mutationStore.getStore()
                        },
                        dataWithOptimisticResults: _this.cache.extract(true)
                    });
                }
            });
        }
        ApolloClient.prototype.stop = function() {
            this.queryManager.stop();
        };
        ApolloClient.prototype.watchQuery = function(options) {
            if (this.defaultOptions.watchQuery) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.defaultOptions.watchQuery), options);
            if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                fetchPolicy: 'cache-first'
            });
            return this.queryManager.watchQuery(options);
        };
        ApolloClient.prototype.query = function(options) {
            if (this.defaultOptions.query) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.defaultOptions.query), options);
            (0, $1DiV8.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
            if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                fetchPolicy: 'cache-first'
            });
            return this.queryManager.query(options);
        };
        ApolloClient.prototype.mutate = function(options) {
            if (this.defaultOptions.mutate) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.defaultOptions.mutate), options);
            return this.queryManager.mutate(options);
        };
        ApolloClient.prototype.subscribe = function(options) {
            return this.queryManager.startGraphQLSubscription(options);
        };
        ApolloClient.prototype.readQuery = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.cache.readQuery(options, optimistic);
        };
        ApolloClient.prototype.readFragment = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.cache.readFragment(options, optimistic);
        };
        ApolloClient.prototype.writeQuery = function(options) {
            var result = this.cache.writeQuery(options);
            this.queryManager.broadcastQueries();
            return result;
        };
        ApolloClient.prototype.writeFragment = function(options) {
            var result = this.cache.writeFragment(options);
            this.queryManager.broadcastQueries();
            return result;
        };
        ApolloClient.prototype.writeData = function(options) {
            var result = this.cache.writeData(options);
            this.queryManager.broadcastQueries();
            return result;
        };
        ApolloClient.prototype.__actionHookForDevTools = function(cb) {
            this.devToolsHookCb = cb;
        };
        ApolloClient.prototype.__requestRaw = function(payload) {
            return (0, (0, parcelRequire("clSzL")).execute)(this.link, payload);
        };
        ApolloClient.prototype.initQueryManager = function() {
            return this.queryManager;
        };
        ApolloClient.prototype.resetStore = function() {
            var _this = this;
            return Promise.resolve().then(function() {
                return _this.queryManager.clearStore();
            }).then(function() {
                return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                    return fn();
                }));
            }).then(function() {
                return _this.reFetchObservableQueries();
            });
        };
        ApolloClient.prototype.clearStore = function() {
            var _this = this;
            return Promise.resolve().then(function() {
                return _this.queryManager.clearStore();
            }).then(function() {
                return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                    return fn();
                }));
            });
        };
        ApolloClient.prototype.onResetStore = function(cb) {
            var _this = this;
            this.resetStoreCallbacks.push(cb);
            return function() {
                _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                    return c !== cb;
                });
            };
        };
        ApolloClient.prototype.onClearStore = function(cb) {
            var _this = this;
            this.clearStoreCallbacks.push(cb);
            return function() {
                _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                    return c !== cb;
                });
            };
        };
        ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
            return this.queryManager.reFetchObservableQueries(includeStandby);
        };
        ApolloClient.prototype.extract = function(optimistic) {
            return this.cache.extract(optimistic);
        };
        ApolloClient.prototype.restore = function(serializedState) {
            return this.cache.restore(serializedState);
        };
        ApolloClient.prototype.addResolvers = function(resolvers) {
            this.localState.addResolvers(resolvers);
        };
        ApolloClient.prototype.setResolvers = function(resolvers) {
            this.localState.setResolvers(resolvers);
        };
        ApolloClient.prototype.getResolvers = function() {
            return this.localState.getResolvers();
        };
        ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
            this.localState.setFragmentMatcher(fragmentMatcher);
        };
        return ApolloClient;
    }();
    var $02a3c2aebc919401$export$2e2bcd8739ae039 = $02a3c2aebc919401$export$13f5a5f0f1dbab88;
});
parcelRegister("jojW6", function(module, exports) {
    $parcel$export(module.exports, "storeKeyNameFromField", ()=>$e1dfb923a27ca793$export$54be8689c65f3b56);
    $parcel$export(module.exports, "getStoreKeyName", ()=>$e1dfb923a27ca793$export$3cdb6c178b88cabe);
    $parcel$export(module.exports, "argumentsObjectFromField", ()=>$e1dfb923a27ca793$export$3f5a60fb6a781b4f);
    $parcel$export(module.exports, "resultKeyNameFromField", ()=>$e1dfb923a27ca793$export$7d1ad22471852218);
    $parcel$export(module.exports, "isField", ()=>$e1dfb923a27ca793$export$fb56ad75dd311c12);
    $parcel$export(module.exports, "isInlineFragment", ()=>$e1dfb923a27ca793$export$22a1cdafaf27bcff);
    $parcel$export(module.exports, "isIdValue", ()=>$e1dfb923a27ca793$export$e33b89a9aa87695);
    $parcel$export(module.exports, "toIdValue", ()=>$e1dfb923a27ca793$export$b124f125e34d720a);
    $parcel$export(module.exports, "isJsonValue", ()=>$e1dfb923a27ca793$export$226c1c6d1a5b660a);
    $parcel$export(module.exports, "getDirectiveInfoFromField", ()=>$e1dfb923a27ca793$export$2a7f471142984a91);
    $parcel$export(module.exports, "shouldInclude", ()=>$e1dfb923a27ca793$export$3dc388a5f013b4a5);
    $parcel$export(module.exports, "hasDirectives", ()=>$e1dfb923a27ca793$export$2dafb573e282fe8d);
    $parcel$export(module.exports, "hasClientExports", ()=>$e1dfb923a27ca793$export$8d1e9e5bbfa5d09a);
    $parcel$export(module.exports, "getFragmentQueryDocument", ()=>$e1dfb923a27ca793$export$abbf37c7cf644e41);
    $parcel$export(module.exports, "assign", ()=>$e1dfb923a27ca793$export$e6e34fd1f2686227);
    $parcel$export(module.exports, "checkDocument", ()=>$e1dfb923a27ca793$export$a7d0d8111d2386df);
    $parcel$export(module.exports, "getOperationDefinition", ()=>$e1dfb923a27ca793$export$7a5b1fa979d2c158);
    $parcel$export(module.exports, "getOperationName", ()=>$e1dfb923a27ca793$export$41bca9dc6871dd4e);
    $parcel$export(module.exports, "getFragmentDefinitions", ()=>$e1dfb923a27ca793$export$5320a7ba9466a3df);
    $parcel$export(module.exports, "getQueryDefinition", ()=>$e1dfb923a27ca793$export$d96b2213c1b9d3a9);
    $parcel$export(module.exports, "getMainDefinition", ()=>$e1dfb923a27ca793$export$f431198736b7f96d);
    $parcel$export(module.exports, "createFragmentMap", ()=>$e1dfb923a27ca793$export$193789b4c8246dd4);
    $parcel$export(module.exports, "getDefaultValues", ()=>$e1dfb923a27ca793$export$84c19026e616569e);
    $parcel$export(module.exports, "removeDirectivesFromDocument", ()=>$e1dfb923a27ca793$export$e5ae0530da5fe96c);
    $parcel$export(module.exports, "addTypenameToDocument", ()=>$e1dfb923a27ca793$export$43b332f87950a467);
    $parcel$export(module.exports, "removeConnectionDirectiveFromDocument", ()=>$e1dfb923a27ca793$export$74985f3324559867);
    $parcel$export(module.exports, "buildQueryFromSelectionSet", ()=>$e1dfb923a27ca793$export$57c368c23873f32b);
    $parcel$export(module.exports, "removeClientSetsFromDocument", ()=>$e1dfb923a27ca793$export$8eae69e876ee321e);
    $parcel$export(module.exports, "canUseWeakMap", ()=>$e1dfb923a27ca793$export$772fbc04a0ad4ce9);
    $parcel$export(module.exports, "cloneDeep", ()=>$e1dfb923a27ca793$export$629a2bd3f5a49ecc);
    $parcel$export(module.exports, "isProduction", ()=>$e1dfb923a27ca793$export$f15d00aa73aafac4);
    $parcel$export(module.exports, "isTest", ()=>$e1dfb923a27ca793$export$410cbc2864fa25b5);
    $parcel$export(module.exports, "tryFunctionOrLogError", ()=>$e1dfb923a27ca793$export$50a91acae4904909);
    $parcel$export(module.exports, "graphQLResultHasError", ()=>$e1dfb923a27ca793$export$b4df399e879e53ab);
    $parcel$export(module.exports, "mergeDeep", ()=>$e1dfb923a27ca793$export$dd702b3c8240390c);
    $parcel$export(module.exports, "mergeDeepArray", ()=>$e1dfb923a27ca793$export$160070228be94b08);
    var $12QNw;
    var $1DiV8 = parcelRequire("1DiV8");
    var $3VFsf;
    var $fkrBp = parcelRequire("fkrBp");
    var $bqMzA = parcelRequire("bqMzA");
    var $6cAn5 = parcelRequire("6cAn5");
    function $e1dfb923a27ca793$export$dc071f102752d0eb(value) {
        return [
            'StringValue',
            'BooleanValue',
            'EnumValue'
        ].indexOf(value.kind) > -1;
    }
    function $e1dfb923a27ca793$export$3ff5e9927c3257c6(value) {
        return [
            'IntValue',
            'FloatValue'
        ].indexOf(value.kind) > -1;
    }
    function $e1dfb923a27ca793$var$isStringValue(value) {
        return value.kind === 'StringValue';
    }
    function $e1dfb923a27ca793$var$isBooleanValue(value) {
        return value.kind === 'BooleanValue';
    }
    function $e1dfb923a27ca793$var$isIntValue(value) {
        return value.kind === 'IntValue';
    }
    function $e1dfb923a27ca793$var$isFloatValue(value) {
        return value.kind === 'FloatValue';
    }
    function $e1dfb923a27ca793$var$isVariable(value) {
        return value.kind === 'Variable';
    }
    function $e1dfb923a27ca793$var$isObjectValue(value) {
        return value.kind === 'ObjectValue';
    }
    function $e1dfb923a27ca793$var$isListValue(value) {
        return value.kind === 'ListValue';
    }
    function $e1dfb923a27ca793$var$isEnumValue(value) {
        return value.kind === 'EnumValue';
    }
    function $e1dfb923a27ca793$var$isNullValue(value) {
        return value.kind === 'NullValue';
    }
    function $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables) {
        if ($e1dfb923a27ca793$var$isIntValue(value) || $e1dfb923a27ca793$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
        else if ($e1dfb923a27ca793$var$isBooleanValue(value) || $e1dfb923a27ca793$var$isStringValue(value)) argObj[name.value] = value.value;
        else if ($e1dfb923a27ca793$var$isObjectValue(value)) {
            var nestedArgObj_1 = {};
            value.fields.map(function(obj) {
                return $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
            });
            argObj[name.value] = nestedArgObj_1;
        } else if ($e1dfb923a27ca793$var$isVariable(value)) {
            var variableValue = (variables || {})[value.name.value];
            argObj[name.value] = variableValue;
        } else if ($e1dfb923a27ca793$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
            var nestedArgArrayObj = {};
            $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
        else if ($e1dfb923a27ca793$var$isEnumValue(value)) argObj[name.value] = value.value;
        else if ($e1dfb923a27ca793$var$isNullValue(value)) argObj[name.value] = null;
        else throw new (0, $1DiV8.InvariantError)(17);
    }
    function $e1dfb923a27ca793$export$54be8689c65f3b56(field, variables) {
        var directivesObj = null;
        if (field.directives) {
            directivesObj = {};
            field.directives.forEach(function(directive) {
                directivesObj[directive.name.value] = {};
                if (directive.arguments) directive.arguments.forEach(function(_a) {
                    var name = _a.name, value = _a.value;
                    return $e1dfb923a27ca793$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
                });
            });
        }
        var argObj = null;
        if (field.arguments && field.arguments.length) {
            argObj = {};
            field.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables);
            });
        }
        return $e1dfb923a27ca793$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
    }
    var $e1dfb923a27ca793$var$KNOWN_DIRECTIVES = [
        'connection',
        'include',
        'skip',
        'client',
        'rest',
        'export'
    ];
    function $e1dfb923a27ca793$export$3cdb6c178b88cabe(fieldName, args, directives) {
        if (directives && directives['connection'] && directives['connection']['key']) {
            if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
                var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
                filterKeys.sort();
                var queryArgs_1 = args;
                var filteredArgs_1 = {};
                filterKeys.forEach(function(key) {
                    filteredArgs_1[key] = queryArgs_1[key];
                });
                return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
            } else return directives['connection']['key'];
        }
        var completeFieldName = fieldName;
        if (args) {
            var stringifiedArgs = (0, ($parcel$interopDefault($fkrBp)))(args);
            completeFieldName += "(" + stringifiedArgs + ")";
        }
        if (directives) Object.keys(directives).forEach(function(key) {
            if ($e1dfb923a27ca793$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
            if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            else completeFieldName += "@" + key;
        });
        return completeFieldName;
    }
    function $e1dfb923a27ca793$export$3f5a60fb6a781b4f(field, variables) {
        if (field.arguments && field.arguments.length) {
            var argObj_1 = {};
            field.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj_1, name, value, variables);
            });
            return argObj_1;
        }
        return null;
    }
    function $e1dfb923a27ca793$export$7d1ad22471852218(field) {
        return field.alias ? field.alias.value : field.name.value;
    }
    function $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) {
        return selection.kind === 'Field';
    }
    function $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection) {
        return selection.kind === 'InlineFragment';
    }
    function $e1dfb923a27ca793$export$e33b89a9aa87695(idObject) {
        return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
    }
    function $e1dfb923a27ca793$export$b124f125e34d720a(idConfig, generated) {
        if (generated === void 0) generated = false;
        return (0, (0, parcelRequire("3VFsf")).__assign)({
            type: 'id',
            generated: generated
        }, typeof idConfig === 'string' ? {
            id: idConfig,
            typename: undefined
        } : idConfig);
    }
    function $e1dfb923a27ca793$export$226c1c6d1a5b660a(jsonObject) {
        return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
    }
    function $e1dfb923a27ca793$var$defaultValueFromVariable(node) {
        throw new (0, $1DiV8.InvariantError)(18);
    }
    function $e1dfb923a27ca793$export$b3db129ed867b445(node, onVariable) {
        if (onVariable === void 0) onVariable = $e1dfb923a27ca793$var$defaultValueFromVariable;
        switch(node.kind){
            case 'Variable':
                return onVariable(node);
            case 'NullValue':
                return null;
            case 'IntValue':
                return parseInt(node.value, 10);
            case 'FloatValue':
                return parseFloat(node.value);
            case 'ListValue':
                return node.values.map(function(v) {
                    return $e1dfb923a27ca793$export$b3db129ed867b445(v, onVariable);
                });
            case 'ObjectValue':
                var value = {};
                for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                    var field = _a[_i];
                    value[field.name.value] = $e1dfb923a27ca793$export$b3db129ed867b445(field.value, onVariable);
                }
                return value;
            default:
                return node.value;
        }
    }
    function $e1dfb923a27ca793$export$2a7f471142984a91(field, variables) {
        if (field.directives && field.directives.length) {
            var directiveObj_1 = {};
            field.directives.forEach(function(directive) {
                directiveObj_1[directive.name.value] = $e1dfb923a27ca793$export$3f5a60fb6a781b4f(directive, variables);
            });
            return directiveObj_1;
        }
        return null;
    }
    function $e1dfb923a27ca793$export$3dc388a5f013b4a5(selection, variables) {
        if (variables === void 0) variables = {};
        return $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
            var directive = _a.directive, ifArgument = _a.ifArgument;
            var evaledValue = false;
            if (ifArgument.value.kind === 'Variable') {
                evaledValue = variables[ifArgument.value.name.value];
                (0, $1DiV8.invariant)(evaledValue !== void 0, 13);
            } else evaledValue = ifArgument.value.value;
            return directive.name.value === 'skip' ? !evaledValue : evaledValue;
        });
    }
    function $e1dfb923a27ca793$export$1b217de6ce18b9a(doc) {
        var names = [];
        (0, (0, parcelRequire("12QNw")).visit)(doc, {
            Directive: function(node) {
                names.push(node.name.value);
            }
        });
        return names;
    }
    function $e1dfb923a27ca793$export$2dafb573e282fe8d(names, doc) {
        return $e1dfb923a27ca793$export$1b217de6ce18b9a(doc).some(function(name) {
            return names.indexOf(name) > -1;
        });
    }
    function $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a(document) {
        return document && $e1dfb923a27ca793$export$2dafb573e282fe8d([
            'client'
        ], document) && $e1dfb923a27ca793$export$2dafb573e282fe8d([
            'export'
        ], document);
    }
    function $e1dfb923a27ca793$var$isInclusionDirective(_a) {
        var value = _a.name.value;
        return value === 'skip' || value === 'include';
    }
    function $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(directives) {
        return directives ? directives.filter($e1dfb923a27ca793$var$isInclusionDirective).map(function(directive) {
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            (0, $1DiV8.invariant)(directiveArguments && directiveArguments.length === 1, 14);
            var ifArgument = directiveArguments[0];
            (0, $1DiV8.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
            var ifValue = ifArgument.value;
            (0, $1DiV8.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
            return {
                directive: directive,
                ifArgument: ifArgument
            };
        }) : [];
    }
    function $e1dfb923a27ca793$export$abbf37c7cf644e41(document, fragmentName) {
        var actualFragmentName = fragmentName;
        var fragments = [];
        document.definitions.forEach(function(definition) {
            if (definition.kind === 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(11);
            if (definition.kind === 'FragmentDefinition') fragments.push(definition);
        });
        if (typeof actualFragmentName === 'undefined') {
            (0, $1DiV8.invariant)(fragments.length === 1, 12);
            actualFragmentName = fragments[0].name.value;
        }
        var query = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, document), {
            definitions: (0, (0, parcelRequire("3VFsf")).__spreadArrays)([
                {
                    kind: 'OperationDefinition',
                    operation: 'query',
                    selectionSet: {
                        kind: 'SelectionSet',
                        selections: [
                            {
                                kind: 'FragmentSpread',
                                name: {
                                    kind: 'Name',
                                    value: actualFragmentName
                                }
                            }
                        ]
                    }
                }
            ], document.definitions)
        });
        return query;
    }
    function $e1dfb923a27ca793$export$e6e34fd1f2686227(target) {
        var sources = [];
        for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
        sources.forEach(function(source) {
            if (typeof source === 'undefined' || source === null) return;
            Object.keys(source).forEach(function(key) {
                target[key] = source[key];
            });
        });
        return target;
    }
    function $e1dfb923a27ca793$export$a92e7a440b22bdf0(doc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
        var mutationDef = doc.definitions.filter(function(definition) {
            return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
        })[0];
        (0, $1DiV8.invariant)(mutationDef, 1);
        return mutationDef;
    }
    function $e1dfb923a27ca793$export$a7d0d8111d2386df(doc) {
        (0, $1DiV8.invariant)(doc && doc.kind === 'Document', 2);
        var operations = doc.definitions.filter(function(d) {
            return d.kind !== 'FragmentDefinition';
        }).map(function(definition) {
            if (definition.kind !== 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(3);
            return definition;
        });
        (0, $1DiV8.invariant)(operations.length <= 1, 4);
        return doc;
    }
    function $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
        return doc.definitions.filter(function(definition) {
            return definition.kind === 'OperationDefinition';
        })[0];
    }
    function $e1dfb923a27ca793$export$78a8e95d8d43ad7f(document) {
        var def = $e1dfb923a27ca793$export$7a5b1fa979d2c158(document);
        (0, $1DiV8.invariant)(def, 5);
        return def;
    }
    function $e1dfb923a27ca793$export$41bca9dc6871dd4e(doc) {
        return doc.definitions.filter(function(definition) {
            return definition.kind === 'OperationDefinition' && definition.name;
        }).map(function(x) {
            return x.name.value;
        })[0] || null;
    }
    function $e1dfb923a27ca793$export$5320a7ba9466a3df(doc) {
        return doc.definitions.filter(function(definition) {
            return definition.kind === 'FragmentDefinition';
        });
    }
    function $e1dfb923a27ca793$export$d96b2213c1b9d3a9(doc) {
        var queryDef = $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc);
        (0, $1DiV8.invariant)(queryDef && queryDef.operation === 'query', 6);
        return queryDef;
    }
    function $e1dfb923a27ca793$export$772111caef41b3f5(doc) {
        (0, $1DiV8.invariant)(doc.kind === 'Document', 7);
        (0, $1DiV8.invariant)(doc.definitions.length <= 1, 8);
        var fragmentDef = doc.definitions[0];
        (0, $1DiV8.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
        return fragmentDef;
    }
    function $e1dfb923a27ca793$export$f431198736b7f96d(queryDoc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(queryDoc);
        var fragmentDefinition;
        for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
            var definition = _a[_i];
            if (definition.kind === 'OperationDefinition') {
                var operation = definition.operation;
                if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
            }
            if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
        }
        if (fragmentDefinition) return fragmentDefinition;
        throw new (0, $1DiV8.InvariantError)(10);
    }
    function $e1dfb923a27ca793$export$193789b4c8246dd4(fragments) {
        if (fragments === void 0) fragments = [];
        var symTable = {};
        fragments.forEach(function(fragment) {
            symTable[fragment.name.value] = fragment;
        });
        return symTable;
    }
    function $e1dfb923a27ca793$export$84c19026e616569e(definition) {
        if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
            var defaultValues = definition.variableDefinitions.filter(function(_a) {
                var defaultValue = _a.defaultValue;
                return defaultValue;
            }).map(function(_a) {
                var variable = _a.variable, defaultValue = _a.defaultValue;
                var defaultValueObj = {};
                $e1dfb923a27ca793$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
                return defaultValueObj;
            });
            return $e1dfb923a27ca793$export$e6e34fd1f2686227.apply(void 0, (0, (0, parcelRequire("3VFsf")).__spreadArrays)([
                {}
            ], defaultValues));
        }
        return {};
    }
    function $e1dfb923a27ca793$export$55ead6c9e4eac970(operation) {
        var names = new Set();
        if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
        return names;
    }
    function $e1dfb923a27ca793$var$filterInPlace(array, test, context) {
        var target = 0;
        array.forEach(function(elem, i) {
            if (test.call(this, elem, i, array)) array[target++] = elem;
        }, context);
        array.length = target;
        return array;
    }
    var $e1dfb923a27ca793$var$TYPENAME_FIELD = {
        kind: 'Field',
        name: {
            kind: 'Name',
            value: '__typename'
        }
    };
    function $e1dfb923a27ca793$var$isEmpty(op, fragments) {
        return op.selectionSet.selections.every(function(selection) {
            return selection.kind === 'FragmentSpread' && $e1dfb923a27ca793$var$isEmpty(fragments[selection.name.value], fragments);
        });
    }
    function $e1dfb923a27ca793$var$nullIfDocIsEmpty(doc) {
        return $e1dfb923a27ca793$var$isEmpty($e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) || $e1dfb923a27ca793$export$772111caef41b3f5(doc), $e1dfb923a27ca793$export$193789b4c8246dd4($e1dfb923a27ca793$export$5320a7ba9466a3df(doc))) ? null : doc;
    }
    function $e1dfb923a27ca793$var$getDirectiveMatcher(directives) {
        return function directiveMatcher(directive) {
            return directives.some(function(dir) {
                return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
            });
        };
    }
    function $e1dfb923a27ca793$export$e5ae0530da5fe96c(directives, doc) {
        var variablesInUse = Object.create(null);
        var variablesToRemove = [];
        var fragmentSpreadsInUse = Object.create(null);
        var fragmentSpreadsToRemove = [];
        var modifiedDoc = $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            Variable: {
                enter: function(node, _key, parent) {
                    if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
                }
            },
            Field: {
                enter: function(node) {
                    if (directives && node.directives) {
                        var shouldRemoveField = directives.some(function(directive) {
                            return directive.remove;
                        });
                        if (shouldRemoveField && node.directives && node.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives))) {
                            if (node.arguments) node.arguments.forEach(function(arg) {
                                if (arg.value.kind === 'Variable') variablesToRemove.push({
                                    name: arg.value.name.value
                                });
                            });
                            if (node.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value
                                });
                            });
                            return null;
                        }
                    }
                }
            },
            FragmentSpread: {
                enter: function(node) {
                    fragmentSpreadsInUse[node.name.value] = true;
                }
            },
            Directive: {
                enter: function(node) {
                    if ($e1dfb923a27ca793$var$getDirectiveMatcher(directives)(node)) return null;
                }
            }
        }));
        if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(variablesToRemove, function(v) {
            return !variablesInUse[v.name];
        }).length) modifiedDoc = $e1dfb923a27ca793$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
        if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
            return !fragmentSpreadsInUse[fs.name];
        }).length) modifiedDoc = $e1dfb923a27ca793$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
        return modifiedDoc;
    }
    function $e1dfb923a27ca793$export$43b332f87950a467(doc) {
        return (0, (0, parcelRequire("12QNw")).visit)($e1dfb923a27ca793$export$a7d0d8111d2386df(doc), {
            SelectionSet: {
                enter: function(node, _key, parent) {
                    if (parent && parent.kind === 'OperationDefinition') return;
                    var selections = node.selections;
                    if (!selections) return;
                    var skip = selections.some(function(selection) {
                        return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                    });
                    if (skip) return;
                    var field = parent;
                    if ($e1dfb923a27ca793$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                        return d.name.value === 'export';
                    })) return;
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                        selections: (0, (0, parcelRequire("3VFsf")).__spreadArrays)(selections, [
                            $e1dfb923a27ca793$var$TYPENAME_FIELD
                        ])
                    });
                }
            }
        });
    }
    var $e1dfb923a27ca793$var$connectionRemoveConfig = {
        test: function(directive) {
            var willRemove = directive.name.value === 'connection';
            if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
                return arg.name.value === 'key';
            });
            return willRemove;
        }
    };
    function $e1dfb923a27ca793$export$74985f3324559867(doc) {
        return $e1dfb923a27ca793$export$e5ae0530da5fe96c([
            $e1dfb923a27ca793$var$connectionRemoveConfig
        ], $e1dfb923a27ca793$export$a7d0d8111d2386df(doc));
    }
    function $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
        if (nestedCheck === void 0) nestedCheck = true;
        return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
            return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck);
        });
    }
    function $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
        if (nestedCheck === void 0) nestedCheck = true;
        if (!$e1dfb923a27ca793$export$fb56ad75dd311c12(selection)) return true;
        if (!selection.directives) return false;
        return selection.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives)) || nestedCheck && $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
    }
    function $e1dfb923a27ca793$export$deed3420cb5d2e1d(directives, doc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
        var parentPath;
        return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            SelectionSet: {
                enter: function(node, _key, _parent, path) {
                    var currentPath = path.join('-');
                    if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                        if (node.selections) {
                            var selectionsWithDirectives = node.selections.filter(function(selection) {
                                return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection);
                            });
                            if ($e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                                selections: selectionsWithDirectives
                            });
                        } else return null;
                    }
                }
            }
        }));
    }
    function $e1dfb923a27ca793$var$getArgumentMatcher(config) {
        return function argumentMatcher(argument) {
            return config.some(function(aConfig) {
                return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
            });
        };
    }
    function $e1dfb923a27ca793$export$ecd5bb739c4a8b38(config, doc) {
        var argMatcher = $e1dfb923a27ca793$var$getArgumentMatcher(config);
        return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            OperationDefinition: {
                enter: function(node) {
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return !config.some(function(arg) {
                                return arg.name === varDef.variable.name.value;
                            });
                        })
                    });
                }
            },
            Field: {
                enter: function(node) {
                    var shouldRemoveField = config.some(function(argConfig) {
                        return argConfig.remove;
                    });
                    if (shouldRemoveField) {
                        var argMatchCount_1 = 0;
                        node.arguments.forEach(function(arg) {
                            if (argMatcher(arg)) argMatchCount_1 += 1;
                        });
                        if (argMatchCount_1 === 1) return null;
                    }
                }
            },
            Argument: {
                enter: function(node) {
                    if (argMatcher(node)) return null;
                }
            }
        }));
    }
    function $e1dfb923a27ca793$export$7c9d17c333033c13(config, doc) {
        function enter(node) {
            if (config.some(function(def) {
                return def.name === node.name.value;
            })) return null;
        }
        return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            FragmentSpread: {
                enter: enter
            },
            FragmentDefinition: {
                enter: enter
            }
        }));
    }
    function $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
        var allFragments = [];
        selectionSet.selections.forEach(function(selection) {
            if (($e1dfb923a27ca793$export$fb56ad75dd311c12(selection) || $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
                return allFragments.push(frag);
            });
            else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
        });
        return allFragments;
    }
    function $e1dfb923a27ca793$export$57c368c23873f32b(document) {
        var definition = $e1dfb923a27ca793$export$f431198736b7f96d(document);
        var definitionOperation = definition.operation;
        if (definitionOperation === 'query') return document;
        var modifiedDoc = (0, (0, parcelRequire("12QNw")).visit)(document, {
            OperationDefinition: {
                enter: function(node) {
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                        operation: 'query'
                    });
                }
            }
        });
        return modifiedDoc;
    }
    function $e1dfb923a27ca793$export$8eae69e876ee321e(document) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(document);
        var modifiedDoc = $e1dfb923a27ca793$export$e5ae0530da5fe96c([
            {
                test: function(directive) {
                    return directive.name.value === 'client';
                },
                remove: true
            }
        ], document);
        if (modifiedDoc) modifiedDoc = (0, (0, parcelRequire("12QNw")).visit)(modifiedDoc, {
            FragmentDefinition: {
                enter: function(node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                            return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) return null;
                    }
                }
            }
        });
        return modifiedDoc;
    }
    var $e1dfb923a27ca793$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
    var $e1dfb923a27ca793$var$toString = Object.prototype.toString;
    function $e1dfb923a27ca793$export$629a2bd3f5a49ecc(value) {
        return $e1dfb923a27ca793$var$cloneDeepHelper(value, new Map());
    }
    function $e1dfb923a27ca793$var$cloneDeepHelper(val, seen) {
        switch($e1dfb923a27ca793$var$toString.call(val)){
            case "[object Array]":
                if (seen.has(val)) return seen.get(val);
                var copy_1 = val.slice(0);
                seen.set(val, copy_1);
                copy_1.forEach(function(child, i) {
                    copy_1[i] = $e1dfb923a27ca793$var$cloneDeepHelper(child, seen);
                });
                return copy_1;
            case "[object Object]":
                if (seen.has(val)) return seen.get(val);
                var copy_2 = Object.create(Object.getPrototypeOf(val));
                seen.set(val, copy_2);
                Object.keys(val).forEach(function(key) {
                    copy_2[key] = $e1dfb923a27ca793$var$cloneDeepHelper(val[key], seen);
                });
                return copy_2;
            default:
                return val;
        }
    }
    function $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() {
        if (typeof $6cAn5 !== 'undefined' && "production") return "production";
        return 'development';
    }
    function $e1dfb923a27ca793$export$f0cb0fda19c18b37(env) {
        return $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() === env;
    }
    function $e1dfb923a27ca793$export$f15d00aa73aafac4() {
        return $e1dfb923a27ca793$export$f0cb0fda19c18b37('production') === true;
    }
    function $e1dfb923a27ca793$export$df77466336fe5355() {
        return $e1dfb923a27ca793$export$f0cb0fda19c18b37('development') === true;
    }
    function $e1dfb923a27ca793$export$410cbc2864fa25b5() {
        return $e1dfb923a27ca793$export$f0cb0fda19c18b37('test') === true;
    }
    function $e1dfb923a27ca793$export$50a91acae4904909(f) {
        try {
            return f();
        } catch (e) {
            if (console.error) console.error(e);
        }
    }
    function $e1dfb923a27ca793$export$b4df399e879e53ab(result) {
        return result.errors && result.errors.length;
    }
    function $e1dfb923a27ca793$var$deepFreeze(o) {
        Object.freeze(o);
        Object.getOwnPropertyNames(o).forEach(function(prop) {
            if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e1dfb923a27ca793$var$deepFreeze(o[prop]);
        });
        return o;
    }
    function $e1dfb923a27ca793$export$7f9c177735b71f18(obj) {
        if ($e1dfb923a27ca793$export$df77466336fe5355() || $e1dfb923a27ca793$export$410cbc2864fa25b5()) {
            var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
            if (!symbolIsPolyfilled) return $e1dfb923a27ca793$var$deepFreeze(obj);
        }
        return obj;
    }
    var $e1dfb923a27ca793$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    function $e1dfb923a27ca793$export$dd702b3c8240390c() {
        var sources = [];
        for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
        return $e1dfb923a27ca793$export$160070228be94b08(sources);
    }
    function $e1dfb923a27ca793$export$160070228be94b08(sources) {
        var target = sources[0] || {};
        var count = sources.length;
        if (count > 1) {
            var pastCopies = [];
            target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
            for(var i = 1; i < count; ++i)target = $e1dfb923a27ca793$var$mergeHelper(target, sources[i], pastCopies);
        }
        return target;
    }
    function $e1dfb923a27ca793$var$isObject(obj) {
        return obj !== null && typeof obj === 'object';
    }
    function $e1dfb923a27ca793$var$mergeHelper(target, source, pastCopies) {
        if ($e1dfb923a27ca793$var$isObject(source) && $e1dfb923a27ca793$var$isObject(target)) {
            if (Object.isExtensible && !Object.isExtensible(target)) target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
            Object.keys(source).forEach(function(sourceKey) {
                var sourceValue = source[sourceKey];
                if ($e1dfb923a27ca793$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (sourceValue !== targetValue) target[sourceKey] = $e1dfb923a27ca793$var$mergeHelper($e1dfb923a27ca793$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
                } else target[sourceKey] = sourceValue;
            });
            return target;
        }
        return source;
    }
    function $e1dfb923a27ca793$var$shallowCopyForMerge(value, pastCopies) {
        if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
            if (Array.isArray(value)) value = value.slice(0);
            else value = (0, (0, parcelRequire("3VFsf")).__assign)({
                __proto__: Object.getPrototypeOf(value)
            }, value);
            pastCopies.push(value);
        }
        return value;
    }
    var $e1dfb923a27ca793$var$haveWarned = Object.create({});
    function $e1dfb923a27ca793$export$49d47c8e549bfaf9(msg, type) {
        if (type === void 0) type = 'warn';
        if (!$e1dfb923a27ca793$export$f15d00aa73aafac4() && !$e1dfb923a27ca793$var$haveWarned[msg]) {
            if (!$e1dfb923a27ca793$export$410cbc2864fa25b5()) $e1dfb923a27ca793$var$haveWarned[msg] = true;
            if (type === 'error') console.error(msg);
            else console.warn(msg);
        }
    }
    function $e1dfb923a27ca793$export$c54efeba029d4fe8(data) {
        return JSON.parse(JSON.stringify(data));
    }
});
parcelRegister("1DiV8", function(module, exports) {
    $parcel$export(module.exports, "InvariantError", ()=>$13081c324be1f9ab$export$cea12affaee22fe8);
    $parcel$export(module.exports, "invariant", ()=>$13081c324be1f9ab$export$f5708dca728d7177);
    var $3VFsf;
    var $6cAn5 = parcelRequire("6cAn5");
    var $13081c324be1f9ab$var$genericMessage = "Invariant Violation";
    var $13081c324be1f9ab$var$_a = Object.setPrototypeOf, $13081c324be1f9ab$var$setPrototypeOf = $13081c324be1f9ab$var$_a === void 0 ? function(obj, proto) {
        obj.__proto__ = proto;
        return obj;
    } : $13081c324be1f9ab$var$_a;
    var $13081c324be1f9ab$export$cea12affaee22fe8 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(InvariantError, _super);
        function InvariantError(message) {
            if (message === void 0) message = $13081c324be1f9ab$var$genericMessage;
            var _this = _super.call(this, typeof message === "number" ? $13081c324be1f9ab$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
            _this.framesToPop = 1;
            _this.name = $13081c324be1f9ab$var$genericMessage;
            $13081c324be1f9ab$var$setPrototypeOf(_this, InvariantError.prototype);
            return _this;
        }
        return InvariantError;
    }(Error);
    function $13081c324be1f9ab$export$f5708dca728d7177(condition, message) {
        if (!condition) throw new $13081c324be1f9ab$export$cea12affaee22fe8(message);
    }
    function $13081c324be1f9ab$var$wrapConsoleMethod(method) {
        return function() {
            return console[method].apply(console, arguments);
        };
    }
    (function(invariant) {
        invariant.warn = $13081c324be1f9ab$var$wrapConsoleMethod("warn");
        invariant.error = $13081c324be1f9ab$var$wrapConsoleMethod("error");
    })($13081c324be1f9ab$export$f5708dca728d7177 || ($13081c324be1f9ab$export$f5708dca728d7177 = {}));
    var $13081c324be1f9ab$export$e54fe5b0f43758f7 = {
        env: {}
    };
    if (typeof $6cAn5 === "object") $13081c324be1f9ab$export$e54fe5b0f43758f7 = $6cAn5;
    else try {
        Function("stub", "process = stub")($13081c324be1f9ab$export$e54fe5b0f43758f7);
    } catch (atLeastWeTried) {}
    var $13081c324be1f9ab$var$invariant$1 = $13081c324be1f9ab$export$f5708dca728d7177;
    var $13081c324be1f9ab$export$2e2bcd8739ae039 = $13081c324be1f9ab$var$invariant$1;
});
parcelRegister("fkrBp", function(module, exports) {
    'use strict';
    module.exports = function(data, opts) {
        if (!opts) opts = {};
        if (typeof opts === 'function') opts = {
            cmp: opts
        };
        var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
        var cmp = opts.cmp && function(f) {
            return function(node) {
                return function(a, b) {
                    var aobj = {
                        key: a,
                        value: node[a]
                    };
                    var bobj = {
                        key: b,
                        value: node[b]
                    };
                    return f(aobj, bobj);
                };
            };
        }(opts.cmp);
        var seen = [];
        return function stringify(node) {
            if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
            if (node === undefined) return;
            if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
            if (typeof node !== 'object') return JSON.stringify(node);
            var i, out;
            if (Array.isArray(node)) {
                out = '[';
                for(i = 0; i < node.length; i++){
                    if (i) out += ',';
                    out += stringify(node[i]) || 'null';
                }
                return out + ']';
            }
            if (node === null) return 'null';
            if (seen.indexOf(node) !== -1) {
                if (cycles) return JSON.stringify('__cycle__');
                throw new TypeError('Converting circular structure to JSON');
            }
            var seenIndex = seen.push(node) - 1;
            var keys = Object.keys(node).sort(cmp && cmp(node));
            out = '';
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                var value = stringify(node[key]);
                if (!value) continue;
                if (out) out += ',';
                out += JSON.stringify(key) + ':' + value;
            }
            seen.splice(seenIndex, 1);
            return '{' + out + '}';
        }(data);
    };
});
parcelRegister("bqMzA", function(module, exports) {
    $parcel$export(module.exports, "equal", ()=>$8527cd05038b1b96$export$411ce8e5a71e3069);
    var $8527cd05038b1b96$var$_a = Object.prototype, $8527cd05038b1b96$var$toString = $8527cd05038b1b96$var$_a.toString, $8527cd05038b1b96$var$hasOwnProperty = $8527cd05038b1b96$var$_a.hasOwnProperty;
    var $8527cd05038b1b96$var$previousComparisons = new Map();
    function $8527cd05038b1b96$export$411ce8e5a71e3069(a, b) {
        try {
            return $8527cd05038b1b96$var$check(a, b);
        } finally{
            $8527cd05038b1b96$var$previousComparisons.clear();
        }
    }
    function $8527cd05038b1b96$var$check(a, b) {
        if (a === b) return true;
        var aTag = $8527cd05038b1b96$var$toString.call(a);
        var bTag = $8527cd05038b1b96$var$toString.call(b);
        if (aTag !== bTag) return false;
        switch(aTag){
            case '[object Array]':
                if (a.length !== b.length) return false;
            case '[object Object]':
                if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
                var aKeys = Object.keys(a);
                var bKeys = Object.keys(b);
                var keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                for(var k = 0; k < keyCount; ++k){
                    if (!$8527cd05038b1b96$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                for(var k = 0; k < keyCount; ++k){
                    var key = aKeys[k];
                    if (!$8527cd05038b1b96$var$check(a[key], b[key])) return false;
                }
                return true;
            case '[object Error]':
                return a.name === b.name && a.message === b.message;
            case '[object Number]':
                if (a !== a) return b !== b;
            case '[object Boolean]':
            case '[object Date]':
                return +a === +b;
            case '[object RegExp]':
            case '[object String]':
                return a == "" + b;
            case '[object Map]':
            case '[object Set]':
                if (a.size !== b.size) return false;
                if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
                var aIterator = a.entries();
                var isMap = aTag === '[object Map]';
                while(true){
                    var info = aIterator.next();
                    if (info.done) break;
                    var _a = info.value, aKey = _a[0], aValue = _a[1];
                    if (!b.has(aKey)) return false;
                    if (isMap && !$8527cd05038b1b96$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
        }
        return false;
    }
    function $8527cd05038b1b96$var$previouslyCompared(a, b) {
        var bSet = $8527cd05038b1b96$var$previousComparisons.get(a);
        if (bSet) {
            if (bSet.has(b)) return true;
        } else $8527cd05038b1b96$var$previousComparisons.set(a, bSet = new Set);
        bSet.add(b);
        return false;
    }
    var $8527cd05038b1b96$export$2e2bcd8739ae039 = $8527cd05038b1b96$export$411ce8e5a71e3069;
});
parcelRegister("clSzL", function(module, exports) {
    $parcel$export(module.exports, "makePromise", ()=>makePromise);
    $parcel$export(module.exports, "fromError", ()=>fromError);
    $parcel$export(module.exports, "ApolloLink", ()=>ApolloLink);
    $parcel$export(module.exports, "from", ()=>from);
    $parcel$export(module.exports, "split", ()=>split);
    $parcel$export(module.exports, "execute", ()=>execute);
    $parcel$export(module.exports, "Observable", ()=>(parcelRequire("aS6b9")).default);
    var $aS6b9;
    var $1DiV8 = parcelRequire("1DiV8");
    var $3VFsf;
    var $jojW6;
    function validateOperation(operation) {
        var OPERATION_FIELDS = [
            'query',
            'operationName',
            'variables',
            'extensions',
            'context'
        ];
        for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
            var key = _a[_i];
            if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $1DiV8.InvariantError)(2);
        }
        return operation;
    }
    var LinkError = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LinkError, _super);
        function LinkError(message, link) {
            var _this = _super.call(this, message) || this;
            _this.link = link;
            return _this;
        }
        return LinkError;
    }(Error);
    function isTerminating(link) {
        return link.request.length <= 1;
    }
    function toPromise(observable) {
        var completed = false;
        return new Promise(function(resolve, reject) {
            observable.subscribe({
                next: function(data) {
                    if (completed) ;
                    else {
                        completed = true;
                        resolve(data);
                    }
                },
                error: reject
            });
        });
    }
    var makePromise = toPromise;
    function fromPromise(promise) {
        return new (0, (0, parcelRequire("aS6b9")).default)(function(observer) {
            promise.then(function(value) {
                observer.next(value);
                observer.complete();
            }).catch(observer.error.bind(observer));
        });
    }
    function fromError(errorValue) {
        return new (0, (0, parcelRequire("aS6b9")).default)(function(observer) {
            observer.error(errorValue);
        });
    }
    function transformOperation(operation) {
        var transformedOperation = {
            variables: operation.variables || {},
            extensions: operation.extensions || {},
            operationName: operation.operationName,
            query: operation.query
        };
        if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, (0, parcelRequire("jojW6")).getOperationName)(transformedOperation.query) : '';
        return transformedOperation;
    }
    function createOperation(starting, operation) {
        var context = (0, (0, parcelRequire("3VFsf")).__assign)({}, starting);
        var setContext = function(next) {
            if (typeof next === 'function') context = (0, (0, parcelRequire("3VFsf")).__assign)({}, context, next(context));
            else context = (0, (0, parcelRequire("3VFsf")).__assign)({}, context, next);
        };
        var getContext = function() {
            return (0, (0, parcelRequire("3VFsf")).__assign)({}, context);
        };
        Object.defineProperty(operation, 'setContext', {
            enumerable: false,
            value: setContext
        });
        Object.defineProperty(operation, 'getContext', {
            enumerable: false,
            value: getContext
        });
        Object.defineProperty(operation, 'toKey', {
            enumerable: false,
            value: function() {
                return getKey(operation);
            }
        });
        return operation;
    }
    function getKey(operation) {
        var query = operation.query, variables = operation.variables, operationName = operation.operationName;
        return JSON.stringify([
            operationName,
            query,
            variables
        ]);
    }
    function passthrough(op, forward) {
        return forward ? forward(op) : (0, (0, parcelRequire("aS6b9")).default).of();
    }
    function toLink(handler) {
        return typeof handler === 'function' ? new ApolloLink(handler) : handler;
    }
    function empty() {
        return new ApolloLink(function() {
            return (0, (0, parcelRequire("aS6b9")).default).of();
        });
    }
    function from(links) {
        if (links.length === 0) return empty();
        return links.map(toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    }
    function split(test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, (0, parcelRequire("aS6b9")).default).of() : rightLink.request(operation) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, (0, parcelRequire("aS6b9")).default).of() : rightLink.request(operation, forward) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
    }
    var concat = function(first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) return firstLink;
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, (0, parcelRequire("aS6b9")).default).of();
            }) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, (0, parcelRequire("aS6b9")).default).of();
            }) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
    };
    var ApolloLink = function() {
        function ApolloLink(request) {
            if (request) this.request = request;
        }
        ApolloLink.prototype.split = function(test, left, right) {
            return this.concat(split(test, left, right || new ApolloLink(passthrough)));
        };
        ApolloLink.prototype.concat = function(next) {
            return concat(this, next);
        };
        ApolloLink.prototype.request = function(operation, forward) {
            throw new (0, $1DiV8.InvariantError)(1);
        };
        ApolloLink.empty = empty;
        ApolloLink.from = from;
        ApolloLink.split = split;
        ApolloLink.execute = execute;
        return ApolloLink;
    }();
    function execute(link, operation) {
        return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, (0, parcelRequire("aS6b9")).default).of();
    }
});
parcelRegister("aS6b9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ea3bd7f736c1eb4$export$2e2bcd8739ae039);
    var $4osjv = parcelRequire("4osjv");
    var $7ea3bd7f736c1eb4$export$77cea355fa80b5f4 = (0, ($parcel$interopDefault($4osjv)));
    var $7ea3bd7f736c1eb4$export$2e2bcd8739ae039 = $7ea3bd7f736c1eb4$export$77cea355fa80b5f4;
});
parcelRegister("4osjv", function(module, exports) {
    module.exports = (parcelRequire("k0hXK")).Observable;
});
parcelRegister("k0hXK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Observable = void 0;
    function $e901bdc1c9a5edd7$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $e901bdc1c9a5edd7$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function $e901bdc1c9a5edd7$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor, staticProps);
        return Constructor;
    }
    var $e901bdc1c9a5edd7$var$hasSymbols = function() {
        return typeof Symbol === 'function';
    };
    var $e901bdc1c9a5edd7$var$hasSymbol = function(name) {
        return $e901bdc1c9a5edd7$var$hasSymbols() && Boolean(Symbol[name]);
    };
    var $e901bdc1c9a5edd7$var$getSymbol = function(name) {
        return $e901bdc1c9a5edd7$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
    };
    if ($e901bdc1c9a5edd7$var$hasSymbols() && !$e901bdc1c9a5edd7$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
    var $e901bdc1c9a5edd7$var$SymbolIterator = $e901bdc1c9a5edd7$var$getSymbol('iterator');
    var $e901bdc1c9a5edd7$var$SymbolObservable = $e901bdc1c9a5edd7$var$getSymbol('observable');
    var $e901bdc1c9a5edd7$var$SymbolSpecies = $e901bdc1c9a5edd7$var$getSymbol('species');
    function $e901bdc1c9a5edd7$var$getMethod(obj, key) {
        var value = obj[key];
        if (value == null) return undefined;
        if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
        return value;
    }
    function $e901bdc1c9a5edd7$var$getSpecies(obj) {
        var ctor = obj.constructor;
        if (ctor !== undefined) {
            ctor = ctor[$e901bdc1c9a5edd7$var$SymbolSpecies];
            if (ctor === null) ctor = undefined;
        }
        return ctor !== undefined ? ctor : $e901bdc1c9a5edd7$var$Observable;
    }
    function $e901bdc1c9a5edd7$var$isObservable(x) {
        return x instanceof $e901bdc1c9a5edd7$var$Observable;
    }
    function $e901bdc1c9a5edd7$var$hostReportError(e) {
        if ($e901bdc1c9a5edd7$var$hostReportError.log) $e901bdc1c9a5edd7$var$hostReportError.log(e);
        else setTimeout(function() {
            throw e;
        });
    }
    function $e901bdc1c9a5edd7$var$enqueue(fn) {
        Promise.resolve().then(function() {
            try {
                fn();
            } catch (e) {
                $e901bdc1c9a5edd7$var$hostReportError(e);
            }
        });
    }
    function $e901bdc1c9a5edd7$var$cleanupSubscription(subscription) {
        var cleanup = subscription._cleanup;
        if (cleanup === undefined) return;
        subscription._cleanup = undefined;
        if (!cleanup) return;
        try {
            if (typeof cleanup === 'function') cleanup();
            else {
                var unsubscribe = $e901bdc1c9a5edd7$var$getMethod(cleanup, 'unsubscribe');
                if (unsubscribe) unsubscribe.call(cleanup);
            }
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
    }
    function $e901bdc1c9a5edd7$var$closeSubscription(subscription) {
        subscription._observer = undefined;
        subscription._queue = undefined;
        subscription._state = 'closed';
    }
    function $e901bdc1c9a5edd7$var$flushSubscription(subscription) {
        var queue = subscription._queue;
        if (!queue) return;
        subscription._queue = undefined;
        subscription._state = 'ready';
        for(var i = 0; i < queue.length; ++i){
            $e901bdc1c9a5edd7$var$notifySubscription(subscription, queue[i].type, queue[i].value);
            if (subscription._state === 'closed') break;
        }
    }
    function $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value) {
        subscription._state = 'running';
        var observer = subscription._observer;
        try {
            var m = $e901bdc1c9a5edd7$var$getMethod(observer, type);
            switch(type){
                case 'next':
                    if (m) m.call(observer, value);
                    break;
                case 'error':
                    $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                    if (m) m.call(observer, value);
                    else throw value;
                    break;
                case 'complete':
                    $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                    if (m) m.call(observer);
                    break;
            }
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
        if (subscription._state === 'closed') $e901bdc1c9a5edd7$var$cleanupSubscription(subscription);
        else if (subscription._state === 'running') subscription._state = 'ready';
    }
    function $e901bdc1c9a5edd7$var$onNotify(subscription, type, value) {
        if (subscription._state === 'closed') return;
        if (subscription._state === 'buffering') {
            subscription._queue.push({
                type: type,
                value: value
            });
            return;
        }
        if (subscription._state !== 'ready') {
            subscription._state = 'buffering';
            subscription._queue = [
                {
                    type: type,
                    value: value
                }
            ];
            $e901bdc1c9a5edd7$var$enqueue(function() {
                return $e901bdc1c9a5edd7$var$flushSubscription(subscription);
            });
            return;
        }
        $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value);
    }
    var $e901bdc1c9a5edd7$var$Subscription = function() {
        function Subscription(observer, subscriber) {
            $e901bdc1c9a5edd7$var$_classCallCheck(this, Subscription);
            this._cleanup = undefined;
            this._observer = observer;
            this._queue = undefined;
            this._state = 'initializing';
            var subscriptionObserver = new $e901bdc1c9a5edd7$var$SubscriptionObserver(this);
            try {
                this._cleanup = subscriber.call(undefined, subscriptionObserver);
            } catch (e) {
                subscriptionObserver.error(e);
            }
            if (this._state === 'initializing') this._state = 'ready';
        }
        $e901bdc1c9a5edd7$var$_createClass(Subscription, [
            {
                key: "unsubscribe",
                value: function unsubscribe() {
                    if (this._state !== 'closed') {
                        $e901bdc1c9a5edd7$var$closeSubscription(this);
                        $e901bdc1c9a5edd7$var$cleanupSubscription(this);
                    }
                }
            },
            {
                key: "closed",
                get: function() {
                    return this._state === 'closed';
                }
            }
        ]);
        return Subscription;
    }();
    var $e901bdc1c9a5edd7$var$SubscriptionObserver = function() {
        function SubscriptionObserver(subscription) {
            $e901bdc1c9a5edd7$var$_classCallCheck(this, SubscriptionObserver);
            this._subscription = subscription;
        }
        $e901bdc1c9a5edd7$var$_createClass(SubscriptionObserver, [
            {
                key: "next",
                value: function next(value) {
                    $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'next', value);
                }
            },
            {
                key: "error",
                value: function error(value) {
                    $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'error', value);
                }
            },
            {
                key: "complete",
                value: function complete() {
                    $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'complete');
                }
            },
            {
                key: "closed",
                get: function() {
                    return this._subscription._state === 'closed';
                }
            }
        ]);
        return SubscriptionObserver;
    }();
    var $e901bdc1c9a5edd7$var$Observable = function() {
        function Observable(subscriber) {
            $e901bdc1c9a5edd7$var$_classCallCheck(this, Observable);
            if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
            if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
            this._subscriber = subscriber;
        }
        $e901bdc1c9a5edd7$var$_createClass(Observable, [
            {
                key: "subscribe",
                value: function subscribe(observer) {
                    if (typeof observer !== 'object' || observer === null) observer = {
                        next: observer,
                        error: arguments[1],
                        complete: arguments[2]
                    };
                    return new $e901bdc1c9a5edd7$var$Subscription(observer, this._subscriber);
                }
            },
            {
                key: "forEach",
                value: function forEach(fn) {
                    var _this = this;
                    return new Promise(function(resolve, reject) {
                        if (typeof fn !== 'function') {
                            reject(new TypeError(fn + ' is not a function'));
                            return;
                        }
                        function done() {
                            subscription.unsubscribe();
                            resolve();
                        }
                        var subscription = _this.subscribe({
                            next: function(value) {
                                try {
                                    fn(value, done);
                                } catch (e) {
                                    reject(e);
                                    subscription.unsubscribe();
                                }
                            },
                            error: reject,
                            complete: resolve
                        });
                    });
                }
            },
            {
                key: "map",
                value: function map(fn) {
                    var _this2 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        return _this2.subscribe({
                            next: function(value) {
                                try {
                                    value = fn(value);
                                } catch (e) {
                                    return observer.error(e);
                                }
                                observer.next(value);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                observer.complete();
                            }
                        });
                    });
                }
            },
            {
                key: "filter",
                value: function filter(fn) {
                    var _this3 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        return _this3.subscribe({
                            next: function(value) {
                                try {
                                    if (!fn(value)) return;
                                } catch (e) {
                                    return observer.error(e);
                                }
                                observer.next(value);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                observer.complete();
                            }
                        });
                    });
                }
            },
            {
                key: "reduce",
                value: function reduce(fn) {
                    var _this4 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    var hasSeed = arguments.length > 1;
                    var hasValue = false;
                    var seed = arguments[1];
                    var acc = seed;
                    return new C(function(observer) {
                        return _this4.subscribe({
                            next: function(value) {
                                var first = !hasValue;
                                hasValue = true;
                                if (!first || hasSeed) try {
                                    acc = fn(acc, value);
                                } catch (e) {
                                    return observer.error(e);
                                }
                                else acc = value;
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                                observer.next(acc);
                                observer.complete();
                            }
                        });
                    });
                }
            },
            {
                key: "concat",
                value: function concat() {
                    var _this5 = this;
                    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        var subscription;
                        var index = 0;
                        function startNext(next) {
                            subscription = next.subscribe({
                                next: function(v) {
                                    observer.next(v);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    if (index === sources.length) {
                                        subscription = undefined;
                                        observer.complete();
                                    } else startNext(C.from(sources[index++]));
                                }
                            });
                        }
                        startNext(_this5);
                        return function() {
                            if (subscription) {
                                subscription.unsubscribe();
                                subscription = undefined;
                            }
                        };
                    });
                }
            },
            {
                key: "flatMap",
                value: function flatMap(fn) {
                    var _this6 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        var subscriptions = [];
                        var outer = _this6.subscribe({
                            next: function(value) {
                                if (fn) try {
                                    value = fn(value);
                                } catch (e) {
                                    return observer.error(e);
                                }
                                var inner = C.from(value).subscribe({
                                    next: function(value) {
                                        observer.next(value);
                                    },
                                    error: function(e) {
                                        observer.error(e);
                                    },
                                    complete: function() {
                                        var i = subscriptions.indexOf(inner);
                                        if (i >= 0) subscriptions.splice(i, 1);
                                        completeIfDone();
                                    }
                                });
                                subscriptions.push(inner);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                completeIfDone();
                            }
                        });
                        function completeIfDone() {
                            if (outer.closed && subscriptions.length === 0) observer.complete();
                        }
                        return function() {
                            subscriptions.forEach(function(s) {
                                return s.unsubscribe();
                            });
                            outer.unsubscribe();
                        };
                    });
                }
            },
            {
                key: $e901bdc1c9a5edd7$var$SymbolObservable,
                value: function() {
                    return this;
                }
            }
        ], [
            {
                key: "from",
                value: function from(x) {
                    var C = typeof this === 'function' ? this : Observable;
                    if (x == null) throw new TypeError(x + ' is not an object');
                    var method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolObservable);
                    if (method) {
                        var observable = method.call(x);
                        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                        if ($e901bdc1c9a5edd7$var$isObservable(observable) && observable.constructor === C) return observable;
                        return new C(function(observer) {
                            return observable.subscribe(observer);
                        });
                    }
                    if ($e901bdc1c9a5edd7$var$hasSymbol('iterator')) {
                        method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolIterator);
                        if (method) return new C(function(observer) {
                            $e901bdc1c9a5edd7$var$enqueue(function() {
                                if (observer.closed) return;
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;
                                try {
                                    for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _item = _step.value;
                                        observer.next(_item);
                                        if (observer.closed) return;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                    } finally{
                                        if (_didIteratorError) throw _iteratorError;
                                    }
                                }
                                observer.complete();
                            });
                        });
                    }
                    if (Array.isArray(x)) return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            for(var i = 0; i < x.length; ++i){
                                observer.next(x[i]);
                                if (observer.closed) return;
                            }
                            observer.complete();
                        });
                    });
                    throw new TypeError(x + ' is not observable');
                }
            },
            {
                key: "of",
                value: function of() {
                    for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                    var C = typeof this === 'function' ? this : Observable;
                    return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            for(var i = 0; i < items.length; ++i){
                                observer.next(items[i]);
                                if (observer.closed) return;
                            }
                            observer.complete();
                        });
                    });
                }
            },
            {
                key: $e901bdc1c9a5edd7$var$SymbolSpecies,
                get: function() {
                    return this;
                }
            }
        ]);
        return Observable;
    }();
    module.exports.Observable = $e901bdc1c9a5edd7$var$Observable;
    if ($e901bdc1c9a5edd7$var$hasSymbols()) Object.defineProperty($e901bdc1c9a5edd7$var$Observable, Symbol('extensions'), {
        value: {
            symbol: $e901bdc1c9a5edd7$var$SymbolObservable,
            hostReportError: $e901bdc1c9a5edd7$var$hostReportError
        },
        configurable: true
    });
});
parcelRegister("8UpTw", function(module, exports) {
    $parcel$export(module.exports, "ErrorPage", ()=>$5a72c35b5a5b98e9$export$c120a0e80fd44ca6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $beRD7;
    const $5a72c35b5a5b98e9$export$c120a0e80fd44ca6 = ({ error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement($5a72c35b5a5b98e9$var$ErrorWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).JSErrorPageAsync), {
            error: error
        }));
    const $5a72c35b5a5b98e9$var$ErrorWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkvuon _syaz1fxt",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8dXDG", function(module, exports) {
    $parcel$export(module.exports, "useExperienceAbort", ()=>$2df1decadd95b490$export$cc92b7ce453f4403);
    var $5uXOq = parcelRequire("5uXOq");
    var $l9g16;
    const $2df1decadd95b490$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const self = (0, $5uXOq.useRef)({
            name: experience,
            attributes: attributes,
            experienceTracker: experienceTracker
        });
        self.current.name = experience;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        return (0, $5uXOq.useCallback)((reason, extraAttributes = {})=>{
            const { current: current } = self;
            current.experienceTracker.abort({
                name: current.name,
                reason: reason,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes
                }
            });
        }, [
            self
        ]);
    };
});
parcelRegister("bTIks", function(module, exports) {
    $parcel$export(module.exports, "CREATE_OVERVIEW_EXPERIENCE", ()=>$43e56627abfe9003$export$9b5e8e07ff330ef2);
    $parcel$export(module.exports, "EDIT_OVERVIEW_EXPERIENCE", ()=>$43e56627abfe9003$export$a58227116ceb8b81);
    $parcel$export(module.exports, "DELETE_OVERVIEW_EXPERIENCE", ()=>$43e56627abfe9003$export$e17a11e4247a14f7);
    $parcel$export(module.exports, "MODAL_WIDTH", ()=>$43e56627abfe9003$export$3d931b64f46140b3);
    var $gwIPs;
    const $43e56627abfe9003$export$b8b9d90f9e5bd72b = 'jiraBusinessEntityOverview';
    const $43e56627abfe9003$export$9b5e8e07ff330ef2 = {
        experience: 'create-overview',
        packageName: $43e56627abfe9003$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $43e56627abfe9003$export$a58227116ceb8b81 = {
        experience: 'edit-overview',
        packageName: $43e56627abfe9003$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $43e56627abfe9003$export$e17a11e4247a14f7 = {
        experience: 'delete-overview',
        packageName: $43e56627abfe9003$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $43e56627abfe9003$export$d03d4e78ea5b909a = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $43e56627abfe9003$export$57ee5df6bad94642 = 400;
    const $43e56627abfe9003$export$5785b84269e3e763 = 340;
    const $43e56627abfe9003$export$7c9c92ba6b198ac4 = (0, (0, parcelRequire("gwIPs")).gridSize) * 3;
    const $43e56627abfe9003$export$c4232794452dc6e3 = 480;
    const $43e56627abfe9003$export$3d931b64f46140b3 = $43e56627abfe9003$export$c4232794452dc6e3 + $43e56627abfe9003$export$57ee5df6bad94642 + $43e56627abfe9003$export$7c9c92ba6b198ac4 * 2 + $43e56627abfe9003$export$d03d4e78ea5b909a * 2;
    const $43e56627abfe9003$var$MODAL_DIALOG_MARGIN = 120;
    const $43e56627abfe9003$export$68bc124b0fa13de0 = $43e56627abfe9003$export$3d931b64f46140b3 + $43e56627abfe9003$var$MODAL_DIALOG_MARGIN;
});
parcelRegister("15KQw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7Thkj")
    ]).then(()=>parcelRequire('6gB2z'));
});
parcelRegister("N0aCi", function(module, exports) {
    $parcel$export(module.exports, "AsyncMigrationMessage", ()=>$5d4d7ee59ef3aa52$export$93794b6cb00009c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $7EVVm;
    const $5d4d7ee59ef3aa52$var$runtimeProps = {};
    const $5d4d7ee59ef3aa52$var$entryPointParams = {};
    const $5d4d7ee59ef3aa52$export$93794b6cb00009c5 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("7EVVm")).migrationMessageEntrypoint), $5d4d7ee59ef3aa52$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "overviews-plans-onboarding-migration-message",
            packageName: "jiraBusinessOnboarding",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $5d4d7ee59ef3aa52$var$runtimeProps
        });
    };
});
parcelRegister("7EVVm", function(module, exports) {
    $parcel$export(module.exports, "migrationMessageEntrypoint", ()=>$7918607ddc510d1a$export$2dea5f3fdc0ae86);
    var $eufEc;
    var $fEDBv;
    const $7918607ddc510d1a$export$2dea5f3fdc0ae86 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("iOOFc")).then((module)=>module.MigrationMessage), {
            moduleId: "cb473cb0"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("iOOFc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8GMFE")
    ]).then(()=>parcelRequire('h5qXI'));
});
parcelRegister("gb5lQ", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$3a1993d4527e7f44$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "MENU_ID", ()=>$3a1993d4527e7f44$export$d4cd258d01c03112);
    $parcel$export(module.exports, "SECTION_ID", ()=>$3a1993d4527e7f44$export$501955bd67991a25);
    $parcel$export(module.exports, "REPORTS_ROUTES_SET", ()=>$3a1993d4527e7f44$export$f746f9acd7a66bdb);
    $parcel$export(module.exports, "SETTINGS_ROUTES_SET", ()=>$3a1993d4527e7f44$export$e8d6319ab0eb2a27);
    $parcel$export(module.exports, "ISSUES_ROUTES_SET", ()=>$3a1993d4527e7f44$export$6ca9a18cdf1b5a79);
    $parcel$export(module.exports, "FORGE_ROUTES_SET", ()=>$3a1993d4527e7f44$export$6ad6f0faae6ab404);
    $parcel$export(module.exports, "JIRA_AUTOMATION_ADDON_KEY", ()=>$3a1993d4527e7f44$export$75d31ae45b00712c);
    $parcel$export(module.exports, "LOCATION", ()=>$3a1993d4527e7f44$export$87d0ca22edb7493a);
    $parcel$export(module.exports, "OVERVIEW_MAX_LIMIT", ()=>$3a1993d4527e7f44$export$96f465f51836d3a2);
    var $65Ltd;
    var $gwIPs;
    const $3a1993d4527e7f44$export$b8b9d90f9e5bd72b = 'jira.navigation.sidebar.core';
    const $3a1993d4527e7f44$export$d4cd258d01c03112 = 'project/core';
    const $3a1993d4527e7f44$export$501955bd67991a25 = {
        ISSUES: 'issues',
        REPORTS: 'reports',
        SETTINGS: 'settings',
        ISSUE_TYPES: 'issuetypes'
    };
    const $3a1993d4527e7f44$export$f746f9acd7a66bdb = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_ALL_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_CONFIG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_PIE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE)
    ]);
    const $3a1993d4527e7f44$export$e8d6319ab0eb2a27 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV)
    ]);
    const $3a1993d4527e7f44$export$6ca9a18cdf1b5a79 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PIN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE)
    ]);
    const $3a1993d4527e7f44$export$6ad6f0faae6ab404 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS)
    ]);
    const $3a1993d4527e7f44$export$75d31ae45b00712c = 'com.codebarrel.addons.automation';
    const $3a1993d4527e7f44$export$33abecf3eb4ba30b = (0, (0, parcelRequire("gwIPs")).gridSize) * 5;
    const $3a1993d4527e7f44$export$76ca6e18b275dcad = 24;
    const $3a1993d4527e7f44$export$87d0ca22edb7493a = 'jwmNavigationCreateProject';
    const $3a1993d4527e7f44$export$96f465f51836d3a2 = 10;
});
parcelRegister("iuAuR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eeba495724dfd3ed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $eeba495724dfd3ed$var$SectionHeader = ({ children: children, title: title })=>(0, ($parcel$interopDefault($5uXOq))).createElement($eeba495724dfd3ed$export$960a49cc3d27a090, null, (0, ($parcel$interopDefault($5uXOq))).createElement($eeba495724dfd3ed$export$8b251419efc915eb, null, title), children);
    var $eeba495724dfd3ed$export$2e2bcd8739ae039 = $eeba495724dfd3ed$var$SectionHeader;
    const $eeba495724dfd3ed$export$960a49cc3d27a090 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4zamj _1e0c1txw _1bah1yb4 _zulpu2gc _4cvr1h6o _1tke1tcg _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $eeba495724dfd3ed$export$8b251419efc915eb = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1kw7 _19pkidpf _11c81bk4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6hYaZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c7b20fc56e6a13a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $jgJNO;
    var $3MXKI;
    var $8ltGH;
    var $9rljV;
    const $5c7b20fc56e6a13a$var$CREATE_BUTTON_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.overviews.create-overview';
    const $5c7b20fc56e6a13a$var$CreateOverview = ({ onClick: onClick, hasReachedLimit: hasReachedLimit })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isWarningOpen, setIsWarningOpen] = (0, $5uXOq.useState)(false);
        if (hasReachedLimit) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgJNO")).JiraPopup), {
            messageType: "transactional",
            placement: "bottom-start",
            isOpen: isWarningOpen,
            onClose: ()=>setIsWarningOpen(false),
            trigger: ({ ref: ref, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3MXKI")).default), {
                    ...triggerProps,
                    onClick: ()=>setIsWarningOpen((isOpen)=>!isOpen),
                    label: formatMessage((0, (0, parcelRequire("8ltGH")).default).createOverviewLabel),
                    testId: $5c7b20fc56e6a13a$var$CREATE_BUTTON_TEST_ID,
                    ref: ref
                }),
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9rljV")).default), null)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3MXKI")).default), {
            onClick: onClick,
            label: formatMessage((0, (0, parcelRequire("8ltGH")).default).createOverviewLabel),
            testId: $5c7b20fc56e6a13a$var$CREATE_BUTTON_TEST_ID
        });
    };
    var $5c7b20fc56e6a13a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5c7b20fc56e6a13a$var$CreateOverview);
});
parcelRegister("jgJNO", function(module, exports) {
    $parcel$export(module.exports, "JiraPopup", ()=>$93ebfe5964b2617d$export$2da4be1e3f9adef3);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $10xFf;
    var $egZ8z;
    const $93ebfe5964b2617d$export$2da4be1e3f9adef3 = (props)=>{
        if ((0, (0, parcelRequire("10xFf")).shouldBeChoreographed)(props)) {
            const { messageType: messageType, ...rest } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("egZ8z")).ChoreographerPopup), rest);
        }
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), rest);
    };
});
parcelRegister("egZ8z", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerPopup", ()=>$985c2abc03675c6b$export$8ecc19d18d3df807);
    var $1I7E8;
    var $cSWNW;
    const $985c2abc03675c6b$export$8ecc19d18d3df807 = (0, (0, parcelRequire("cSWNW")).withChoreographedRender)((0, (0, parcelRequire("1I7E8")).Popup), {
        toggleableProp: 'isOpen'
    });
});
parcelRegister("3MXKI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cdc099922ed453c2$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $42CjB;
    var $9lMrf;
    var $dIWbq;
    var $3bDjY;
    var $dCm1o;
    const $cdc099922ed453c2$var$StyledButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1njd _1pbykb7n",
                __cmplp.className
            ])
        });
    });
    const $cdc099922ed453c2$var$RoundCreateButton = (0, $5uXOq.forwardRef)(({ label: label, onClick: onClick, testId: testId, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label,
            hideTooltipOnClick: true
        }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            testId: testId,
            onClick: onClick,
            spacing: "compact",
            appearance: "default",
            shape: "circle",
            label: label,
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dIWbq"))))), {
                    label: "",
                    color: "var(--ds-text, #172B4D)"
                })
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($cdc099922ed453c2$var$StyledButton, {
            ...props,
            ref: ref,
            testId: testId,
            spacing: "compact",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                label: label,
                primaryColor: "var(--ds-text, #172B4D)",
                size: "small"
            }),
            onClick: onClick
        })));
    var $cdc099922ed453c2$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($cdc099922ed453c2$var$RoundCreateButton);
});
parcelRegister("dIWbq", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9fdc846ce7ffa27e$var$_react = $9fdc846ce7ffa27e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9fdc846ce7ffa27e$var$_baseNew = $9fdc846ce7ffa27e$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $9fdc846ce7ffa27e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9fdc846ce7ffa27e$var$AddIcon = (props)=>$9fdc846ce7ffa27e$var$_react.default.createElement($9fdc846ce7ffa27e$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M6 6h5M6 6H1m5 0V1m0 5v5"/>`,
            type: 'utility'
        }, props));
    $9fdc846ce7ffa27e$var$AddIcon.displayName = 'AddIcon';
    var $9fdc846ce7ffa27e$var$_default = module.exports.default = $9fdc846ce7ffa27e$var$AddIcon;
});
parcelRegister("8ltGH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5eb84096f9d3de7a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5eb84096f9d3de7a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createOverviewLabel: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.create-overview-label",
            "defaultMessage": "Create overview"
        }
    });
});
parcelRegister("9rljV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$724e26e8635dbe63$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bU3PY;
    var $cgL5K;
    var $koVbs;
    var $gb5lQ;
    var $6h1VX;
    const $724e26e8635dbe63$var$OverviewLimitPopup = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($724e26e8635dbe63$export$e6dfd72ab29f8598, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))), {
            label: "",
            color: "var(--ds-icon-warning, #ffab00)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("6h1VX")).default).overviewLimitReached, {
            overviewMaxLimit: (0, (0, parcelRequire("gb5lQ")).OVERVIEW_MAX_LIMIT)
        })));
    };
    var $724e26e8635dbe63$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($724e26e8635dbe63$var$OverviewLimitPopup);
    const $724e26e8635dbe63$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _zulpu2gc _1yt44ar7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6h1VX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a804cbdeb9da3577$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a804cbdeb9da3577$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        overviewLimitReached: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.overview-limit-popup.overview-limit-reached",
            "defaultMessage": "You've reached the limit of {overviewMaxLimit, plural, one {# overview} other {# overviews}}"
        }
    });
});
parcelRegister("2kAEg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$882af03f312c51f3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $882af03f312c51f3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createOverview: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview",
            "defaultMessage": "Create an overview"
        },
        overviewsHeader: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.overviews-header",
            "defaultMessage": "Overviews"
        },
        errorMessage: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.error-message",
            "defaultMessage": "We couldn't load overviews"
        },
        refreshPage: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.refresh-page",
            "defaultMessage": "Refresh page"
        }
    });
});
parcelRegister("imgTm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a3e3fe210dbf9b0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $5TTho;
    var $8zOmE;
    var $2NMNM;
    var $eEqSc;
    var $e1jn1;
    var $jzhSN;
    const $5a3e3fe210dbf9b0$var$OverviewLink = ({ overview: overview, to: to, isActive: isActive = false })=>{
        const { name: name, theme: theme } = overview;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jzhSN")).default), {
            to: to,
            isActive: isActive,
            prefetch: "hover",
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'overviewLink')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5a3e3fe210dbf9b0$export$399e54fcdf2a48ec, {
            size: "small",
            themeName: theme
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e1jn1")).default), null, name));
        return isActive ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eEqSc")).default), null, content) : content;
    };
    var $5a3e3fe210dbf9b0$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5a3e3fe210dbf9b0$var$OverviewLink);
    const $5a3e3fe210dbf9b0$export$399e54fcdf2a48ec = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("5TTho")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwx1crf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5TTho", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ece6799ec0a6037$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $guOIy;
    var $6cG4N;
    var $52Mvi;
    const $3ece6799ec0a6037$var$OverviewIcon = ({ size: size = 'medium', className: className, themeName: themeName })=>{
        const theme = themeName ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name;
        const Wrapper = (0, (0, parcelRequire("52Mvi")).WRAPPER)[size][theme];
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, {
            className: className,
            "data-testid": "business-entity-overview.common.ui.overview-icon"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("guOIy"))))), {
            label: "",
            LEGACY_size: size,
            color: "currentColor"
        }));
    };
    var $3ece6799ec0a6037$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($3ece6799ec0a6037$var$OverviewIcon);
});
parcelRegister("guOIy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c026ca20e9e43a09$var$_react = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c026ca20e9e43a09$var$_globe = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("9x5pH")));
    var $c026ca20e9e43a09$var$_world = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("4GsX0")));
    function $c026ca20e9e43a09$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c026ca20e9e43a09$var$GlobeIcon = (props)=>$c026ca20e9e43a09$var$_react.default.createElement($c026ca20e9e43a09$var$_globe.default, Object.assign({
            LEGACY_fallbackIcon: $c026ca20e9e43a09$var$_world.default
        }, props));
    $c026ca20e9e43a09$var$GlobeIcon.Name = 'GlobeIconMigration';
    var $c026ca20e9e43a09$var$_default = module.exports.default = $c026ca20e9e43a09$var$GlobeIcon;
});
parcelRegister("4GsX0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36918aadf9f6e08c$var$_react = $36918aadf9f6e08c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $36918aadf9f6e08c$var$_globe = $36918aadf9f6e08c$var$_interopRequireDefault((parcelRequire("9x5pH")));
    function $36918aadf9f6e08c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36918aadf9f6e08c$var$WorldIcon = (props)=>$36918aadf9f6e08c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-.9-1.863A7.19 7.19 0 0 1 4.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8zm6.21-2.286A1.79 1.79 0 0 0 15.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851"/></svg>`
        }, props, {
            newIcon: $36918aadf9f6e08c$var$_globe.default
        }));
    $36918aadf9f6e08c$var$WorldIcon.displayName = 'WorldIcon';
    var $36918aadf9f6e08c$var$_default = module.exports.default = $36918aadf9f6e08c$var$WorldIcon;
});
parcelRegister("52Mvi", function(module, exports) {
    $parcel$export(module.exports, "WRAPPER", ()=>$02db9db1e823edfb$export$20b8431be300f03e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gwIPs;
    const $02db9db1e823edfb$var$iconWrapperStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        borderRadius: `${(0, (0, parcelRequire("gwIPs")).borderRadius)}px`,
        border: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N20A})`}`
    };
    const $02db9db1e823edfb$var$smallIconWrapperStyles = {
        ...$02db9db1e823edfb$var$iconWrapperStyles,
        width: '24px',
        height: '24px'
    };
    const $02db9db1e823edfb$var$mediumIconWrapperStyles = {
        ...$02db9db1e823edfb$var$iconWrapperStyles,
        width: '32px',
        height: '32px'
    };
    const $02db9db1e823edfb$var$WhiteSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1d6j _bfhk4zhb",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightPurpleSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazhbpo _bfhk63rr",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightBlueSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazynhg _bfhk1mdm",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightTealSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazig9t _bfhk16io",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightGreenSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz15qz _bfhkuuj7",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightLimeSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazz2ec _bfhktde4",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightYellowSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz13jf _bfhk1v42",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightRedSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz58wa _bfhkr8k0",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightMagentaSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz5ct2 _bfhku2x1",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightOrangeSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazmfbj _bfhkdpo0",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$DarkSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1d6j _bfhk4zhb",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$PurpleSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz63rr _bfhkhbpo",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$BlueSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1mdm _bfhkynhg",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$TealSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz16io _bfhkig9t",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$GreenSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazuuj7 _bfhk15qz",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LimeSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaztde4 _bfhkz2ec",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$YellowSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1v42 _bfhk13jf",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$RedSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazr8k0 _bfhk58wa",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$MagentaSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazu2x1 _bfhk5ct2",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$OrangeSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazdpo0 _bfhkmfbj",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$WhiteMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1d6j _bfhk4zhb",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightPurpleMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazhbpo _bfhk63rr",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightBlueMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazynhg _bfhk1mdm",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightTealMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazig9t _bfhk16io",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightGreenMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz15qz _bfhkuuj7",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightLimeMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazz2ec _bfhktde4",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightYellowMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz13jf _bfhk1v42",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightRedMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz58wa _bfhkr8k0",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightMagentaMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz5ct2 _bfhku2x1",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightOrangeMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazmfbj _bfhkdpo0",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$DarkMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1d6j _bfhk4zhb",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$PurpleMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz63rr _bfhkhbpo",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$BlueMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1mdm _bfhkynhg",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$TealMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz16io _bfhkig9t",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$GreenMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazuuj7 _bfhk15qz",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LimeMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaztde4 _bfhkz2ec",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$YellowMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1v42 _bfhk13jf",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$RedMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazr8k0 _bfhk58wa",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$MagentaMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazu2x1 _bfhk5ct2",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$OrangeMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazdpo0 _bfhkmfbj",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$export$20b8431be300f03e = {
        small: {
            white: $02db9db1e823edfb$var$WhiteSmallIconWrapper,
            'light-purple': $02db9db1e823edfb$var$LightPurpleSmallIconWrapper,
            'light-blue': $02db9db1e823edfb$var$LightBlueSmallIconWrapper,
            'light-teal': $02db9db1e823edfb$var$LightTealSmallIconWrapper,
            'light-green': $02db9db1e823edfb$var$LightGreenSmallIconWrapper,
            'light-yellow': $02db9db1e823edfb$var$LightYellowSmallIconWrapper,
            'light-red': $02db9db1e823edfb$var$LightRedSmallIconWrapper,
            'light-magenta': $02db9db1e823edfb$var$LightMagentaSmallIconWrapper,
            'light-orange': $02db9db1e823edfb$var$LightOrangeSmallIconWrapper,
            dark: $02db9db1e823edfb$var$DarkSmallIconWrapper,
            purple: $02db9db1e823edfb$var$PurpleSmallIconWrapper,
            blue: $02db9db1e823edfb$var$BlueSmallIconWrapper,
            teal: $02db9db1e823edfb$var$TealSmallIconWrapper,
            green: $02db9db1e823edfb$var$GreenSmallIconWrapper,
            yellow: $02db9db1e823edfb$var$YellowSmallIconWrapper,
            red: $02db9db1e823edfb$var$RedSmallIconWrapper,
            magenta: $02db9db1e823edfb$var$MagentaSmallIconWrapper,
            orange: $02db9db1e823edfb$var$OrangeSmallIconWrapper,
            'lightest-gray': $02db9db1e823edfb$var$WhiteSmallIconWrapper,
            'lightest-purple': $02db9db1e823edfb$var$LightPurpleSmallIconWrapper,
            'lightest-blue': $02db9db1e823edfb$var$LightBlueSmallIconWrapper,
            'lightest-teal': $02db9db1e823edfb$var$LightTealSmallIconWrapper,
            'lightest-green': $02db9db1e823edfb$var$LightGreenSmallIconWrapper,
            'lightest-lime': $02db9db1e823edfb$var$LightLimeSmallIconWrapper,
            'lightest-yellow': $02db9db1e823edfb$var$LightYellowSmallIconWrapper,
            'lightest-orange': $02db9db1e823edfb$var$LightOrangeSmallIconWrapper,
            'lightest-red': $02db9db1e823edfb$var$LightRedSmallIconWrapper,
            'lightest-magenta': $02db9db1e823edfb$var$LightMagentaSmallIconWrapper,
            'lighter-gray': $02db9db1e823edfb$var$WhiteSmallIconWrapper,
            'lighter-purple': $02db9db1e823edfb$var$LightPurpleSmallIconWrapper,
            'lighter-blue': $02db9db1e823edfb$var$LightBlueSmallIconWrapper,
            'lighter-teal': $02db9db1e823edfb$var$LightTealSmallIconWrapper,
            'lighter-green': $02db9db1e823edfb$var$LightGreenSmallIconWrapper,
            'lighter-lime': $02db9db1e823edfb$var$LightLimeSmallIconWrapper,
            'lighter-yellow': $02db9db1e823edfb$var$LightYellowSmallIconWrapper,
            'lighter-orange': $02db9db1e823edfb$var$LightOrangeSmallIconWrapper,
            'lighter-red': $02db9db1e823edfb$var$LightRedSmallIconWrapper,
            'lighter-magenta': $02db9db1e823edfb$var$LightMagentaSmallIconWrapper,
            'darker-gray': $02db9db1e823edfb$var$DarkSmallIconWrapper,
            'darker-purple': $02db9db1e823edfb$var$PurpleSmallIconWrapper,
            'darker-blue': $02db9db1e823edfb$var$BlueSmallIconWrapper,
            'darker-teal': $02db9db1e823edfb$var$TealSmallIconWrapper,
            'darker-green': $02db9db1e823edfb$var$GreenSmallIconWrapper,
            'darker-lime': $02db9db1e823edfb$var$LimeSmallIconWrapper,
            'darker-yellow': $02db9db1e823edfb$var$YellowSmallIconWrapper,
            'darker-orange': $02db9db1e823edfb$var$OrangeSmallIconWrapper,
            'darker-red': $02db9db1e823edfb$var$RedSmallIconWrapper,
            'darker-magenta': $02db9db1e823edfb$var$MagentaSmallIconWrapper,
            'darkest-gray': $02db9db1e823edfb$var$DarkSmallIconWrapper,
            'darkest-purple': $02db9db1e823edfb$var$PurpleSmallIconWrapper,
            'darkest-blue': $02db9db1e823edfb$var$BlueSmallIconWrapper,
            'darkest-teal': $02db9db1e823edfb$var$TealSmallIconWrapper,
            'darkest-green': $02db9db1e823edfb$var$GreenSmallIconWrapper,
            'darkest-lime': $02db9db1e823edfb$var$LimeSmallIconWrapper,
            'darkest-yellow': $02db9db1e823edfb$var$YellowSmallIconWrapper,
            'darkest-orange': $02db9db1e823edfb$var$OrangeSmallIconWrapper,
            'darkest-red': $02db9db1e823edfb$var$RedSmallIconWrapper,
            'darkest-magenta': $02db9db1e823edfb$var$MagentaSmallIconWrapper,
            'no-background': $02db9db1e823edfb$var$WhiteSmallIconWrapper
        },
        medium: {
            white: $02db9db1e823edfb$var$WhiteMediumIconWrapper,
            'light-purple': $02db9db1e823edfb$var$LightPurpleMediumIconWrapper,
            'light-blue': $02db9db1e823edfb$var$LightBlueMediumIconWrapper,
            'light-teal': $02db9db1e823edfb$var$LightTealMediumIconWrapper,
            'light-green': $02db9db1e823edfb$var$LightGreenMediumIconWrapper,
            'light-yellow': $02db9db1e823edfb$var$LightYellowMediumIconWrapper,
            'light-red': $02db9db1e823edfb$var$LightRedMediumIconWrapper,
            'light-magenta': $02db9db1e823edfb$var$LightMagentaMediumIconWrapper,
            'light-orange': $02db9db1e823edfb$var$LightOrangeMediumIconWrapper,
            dark: $02db9db1e823edfb$var$DarkMediumIconWrapper,
            purple: $02db9db1e823edfb$var$PurpleMediumIconWrapper,
            blue: $02db9db1e823edfb$var$BlueMediumIconWrapper,
            teal: $02db9db1e823edfb$var$TealMediumIconWrapper,
            green: $02db9db1e823edfb$var$GreenMediumIconWrapper,
            yellow: $02db9db1e823edfb$var$YellowMediumIconWrapper,
            red: $02db9db1e823edfb$var$RedMediumIconWrapper,
            magenta: $02db9db1e823edfb$var$MagentaMediumIconWrapper,
            orange: $02db9db1e823edfb$var$OrangeMediumIconWrapper,
            'lightest-gray': $02db9db1e823edfb$var$WhiteMediumIconWrapper,
            'lightest-purple': $02db9db1e823edfb$var$LightPurpleMediumIconWrapper,
            'lightest-blue': $02db9db1e823edfb$var$LightBlueMediumIconWrapper,
            'lightest-teal': $02db9db1e823edfb$var$LightTealMediumIconWrapper,
            'lightest-green': $02db9db1e823edfb$var$LightGreenMediumIconWrapper,
            'lightest-lime': $02db9db1e823edfb$var$LightLimeMediumIconWrapper,
            'lightest-yellow': $02db9db1e823edfb$var$LightYellowMediumIconWrapper,
            'lightest-orange': $02db9db1e823edfb$var$LightOrangeMediumIconWrapper,
            'lightest-red': $02db9db1e823edfb$var$LightRedMediumIconWrapper,
            'lightest-magenta': $02db9db1e823edfb$var$LightMagentaMediumIconWrapper,
            'lighter-gray': $02db9db1e823edfb$var$WhiteMediumIconWrapper,
            'lighter-purple': $02db9db1e823edfb$var$LightPurpleMediumIconWrapper,
            'lighter-blue': $02db9db1e823edfb$var$LightBlueMediumIconWrapper,
            'lighter-teal': $02db9db1e823edfb$var$LightTealMediumIconWrapper,
            'lighter-green': $02db9db1e823edfb$var$LightGreenMediumIconWrapper,
            'lighter-lime': $02db9db1e823edfb$var$LightLimeMediumIconWrapper,
            'lighter-yellow': $02db9db1e823edfb$var$LightYellowMediumIconWrapper,
            'lighter-orange': $02db9db1e823edfb$var$LightOrangeMediumIconWrapper,
            'lighter-red': $02db9db1e823edfb$var$LightRedMediumIconWrapper,
            'lighter-magenta': $02db9db1e823edfb$var$LightMagentaMediumIconWrapper,
            'darker-gray': $02db9db1e823edfb$var$DarkMediumIconWrapper,
            'darker-purple': $02db9db1e823edfb$var$PurpleMediumIconWrapper,
            'darker-blue': $02db9db1e823edfb$var$BlueMediumIconWrapper,
            'darker-teal': $02db9db1e823edfb$var$TealMediumIconWrapper,
            'darker-green': $02db9db1e823edfb$var$GreenMediumIconWrapper,
            'darker-lime': $02db9db1e823edfb$var$LimeMediumIconWrapper,
            'darker-yellow': $02db9db1e823edfb$var$YellowMediumIconWrapper,
            'darker-orange': $02db9db1e823edfb$var$OrangeMediumIconWrapper,
            'darker-red': $02db9db1e823edfb$var$RedMediumIconWrapper,
            'darker-magenta': $02db9db1e823edfb$var$MagentaMediumIconWrapper,
            'darkest-gray': $02db9db1e823edfb$var$DarkMediumIconWrapper,
            'darkest-purple': $02db9db1e823edfb$var$PurpleMediumIconWrapper,
            'darkest-blue': $02db9db1e823edfb$var$BlueMediumIconWrapper,
            'darkest-teal': $02db9db1e823edfb$var$TealMediumIconWrapper,
            'darkest-green': $02db9db1e823edfb$var$GreenMediumIconWrapper,
            'darkest-lime': $02db9db1e823edfb$var$LimeMediumIconWrapper,
            'darkest-yellow': $02db9db1e823edfb$var$YellowMediumIconWrapper,
            'darkest-orange': $02db9db1e823edfb$var$OrangeMediumIconWrapper,
            'darkest-red': $02db9db1e823edfb$var$RedMediumIconWrapper,
            'darkest-magenta': $02db9db1e823edfb$var$MagentaMediumIconWrapper,
            'no-background': $02db9db1e823edfb$var$WhiteMediumIconWrapper
        }
    };
});
parcelRegister("eEqSc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eade14dd496994be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $eade14dd496994be$var$ActiveItem = ({ children: children, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement($eade14dd496994be$var$ActiveItemWrapper, {
            "data-testid": testId
        }, children);
    const $eade14dd496994be$var$ActiveItemWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1sit _bfhkiw92",
                __cmplp.className
            ])
        });
    });
    var $eade14dd496994be$export$2e2bcd8739ae039 = $eade14dd496994be$var$ActiveItem;
});
parcelRegister("e1jn1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1030b7620e8fb1d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $a1030b7620e8fb1d$var$LinkLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h _1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s _k48p1wq8 _16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    var $a1030b7620e8fb1d$export$2e2bcd8739ae039 = $a1030b7620e8fb1d$var$LinkLabel;
});
parcelRegister("jzhSN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90049e6de285b9de$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $hDzhb;
    const $90049e6de285b9de$var$SidebarLink = ({ children: children, elemAfter: elemAfter, className: className, testId: testId, isActive: isActive = false, ...other })=>(0, ($parcel$interopDefault($5uXOq))).createElement($90049e6de285b9de$var$Wrapper, {
            isActive: isActive,
            className: className,
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($90049e6de285b9de$var$StyledLink, {
            "aria-current": isActive ? 'page' : undefined,
            ...other
        }, children), elemAfter && (0, ($parcel$interopDefault($5uXOq))).createElement($90049e6de285b9de$var$ElementAfterWrapper, {
            "data-component-selector": "sidebar-link-elem-after"
        }, elemAfter));
    const $90049e6de285b9de$var$showElementAfter = {
        width: 'inherit !important',
        opacity: 1
    };
    const $90049e6de285b9de$var$ElementAfterWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _1bsbgrf3 _tzy4idpf _2hwxu2gc _195pjdj5 _1mygkb7n",
                __cmplp.className
            ])
        });
    });
    const $90049e6de285b9de$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isActive: isActive, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1b30gsy": (0, (0, parcelRequire("lD23V")).default)(!__cmplp.isActive && `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N20A})`),
                "--_dpi1qg": (0, (0, parcelRequire("lD23V")).default)(!__cmplp.isActive && `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N20A})`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _2rko1sit _4t3i1ylp _v5649dqc _1bqoyh40 _rhjqnqa1 _boy0v77o _i9oi194a _ylp5tjc1 _irr3tjc1 _7gg8jdj5 _7ih6kb7n _gnguyh40 _1bv6nqa1 _ygb3v77o _1qtp194a _sbojjewh",
                __cmplp.className
            ])
        });
    });
    const $90049e6de285b9de$var$StyledLink = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _1yt4u2gc _1e0c1txw _4cvr1h6o _syazjjyb _1q5t1r31 _nt751r31 _mizu1r31 _1dit1r31 _1ohyglyw _49pcglyw _ra3xglyw _ksodglyw _1r9x1o36 _1hvw1o36 _128m1o36 _4hz81o36 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _9h8h1fxt _f8pj1fxt _v0vw1fxt _30l31fxt",
                __cmplp.className
            ])
        });
    });
    var $90049e6de285b9de$export$2e2bcd8739ae039 = $90049e6de285b9de$var$SidebarLink;
});
parcelRegister("6KeQr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7979212ccba7a92c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $c8Oei;
    var $dWvae;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $1zqLm;
    var $hVL5W;
    var $1tFZj;
    var $cUsQ8;
    const $7979212ccba7a92c$var$PROJECT_LINK_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.project-link';
    const $7979212ccba7a92c$var$getDefaultProjectUrl = (project)=>project.defaultView ? `/jira/core/projects/${project.key}/${project.defaultView}` : `/jira/core/projects/${project.key}`;
    const $7979212ccba7a92c$var$ProjectGroup = ({ sectionId: sectionId, projects: projects, onFavoriteToggle: onFavoriteToggle, currentProjectKey: currentProjectKey, showViewAllProjects: showViewAllProjects = false, viewAllProjectsLabel: viewAllProjectsLabel })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const title = sectionId === 'starred' ? formatMessage((0, (0, parcelRequire("1tFZj")).default).favorites) : formatMessage((0, (0, parcelRequire("1tFZj")).default).recents);
        const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(true);
        const onToggleExpand = (0, $5uXOq.useCallback)(()=>{
            setIsExpanded(!isExpanded);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'section toggled', 'sidebar', {
                sectionId: sectionId,
                collapse: isExpanded
            });
        }, [
            createAnalyticsEvent,
            isExpanded,
            sectionId
        ]);
        const chevronIcon = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$var$IconWrapper, {
                isExpanded: isExpanded,
                visualRefresh: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
                label: formatMessage(isExpanded ? (0, (0, parcelRequire("1tFZj")).default).collapseSection : (0, (0, parcelRequire("1tFZj")).default).expandSection, {
                    section: title
                }),
                color: "var(--ds-text-subtlest, #626F86)"
            })), [
            formatMessage,
            isExpanded,
            title
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$export$7d436a88869873b5, {
            "data-testid": `navigation-apps-sidebar-core.ui.multi-project-menu.project-group.${sectionId}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$export$dca3dbf057c88c5f, {
            "aria-expanded": isExpanded,
            "aria-controls": `multi-project-menu-project-group-${sectionId}`,
            onClick: onToggleExpand,
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-group.toggle"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            spacing: "none",
            iconBefore: chevronIcon
        }), title), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dWvae")).Collapsible), {
            id: `multi-project-menu-project-group-${sectionId}`,
            isExpanded: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$export$99bffacbdbcb5195, null, projects.map((project)=>project.key === currentProjectKey ? (0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: project.key
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hVL5W")).default), {
                project: project,
                to: $7979212ccba7a92c$var$getDefaultProjectUrl(project),
                onFavoriteToggle: ()=>onFavoriteToggle(project)
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: project.key
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1zqLm")).default), {
                project: project,
                to: $7979212ccba7a92c$var$getDefaultProjectUrl(project),
                onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
                        projectId: project.id,
                        starred: project.isFavorite,
                        current: false
                    }),
                onFavoriteToggle: ()=>onFavoriteToggle(project),
                prefetch: "hover",
                testId: $7979212ccba7a92c$var$PROJECT_LINK_TEST_ID
            }))), showViewAllProjects && (0, ($parcel$interopDefault($5uXOq))).createElement("li", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cUsQ8")).default), {
            label: viewAllProjectsLabel
        })))));
    };
    var $7979212ccba7a92c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($7979212ccba7a92c$var$ProjectGroup);
    const $7979212ccba7a92c$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isExpanded: isExpanded, visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_v5641b1u _k8m01e03",
                __cmplp.isExpanded ? "_t9ec1ul7" : "_t9ec2i46",
                __cmplp.visualRefresh && "_1yt412x7",
                __cmplp.className
            ])
        });
    });
    const $7979212ccba7a92c$export$7d436a88869873b5 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _18s83l1n _onzypxbi",
                __cmplp.className
            ])
        });
    });
    const $7979212ccba7a92c$export$dca3dbf057c88c5f = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1rc1 _1e0c1txw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4otz2 _4cvr1h6o _80omtlke _1p1dangw _11c816g6 _zulptij8",
                __cmplp.className
            ])
        });
    });
    const $7979212ccba7a92c$export$99bffacbdbcb5195 = (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41b66 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dWvae", function(module, exports) {
    $parcel$export(module.exports, "Collapsible", ()=>$fa509c31ea2f76e0$export$6eb0f7ddcda6131f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $fa509c31ea2f76e0$export$6eb0f7ddcda6131f = ({ children: children, id: id, isExpanded: isExpanded, animationDuration: animationDuration = 250 })=>{
        const didMountRef = (0, $5uXOq.useRef)(false);
        const [containerHeight, setContainerHeight] = (0, $5uXOq.useState)(isExpanded ? null : 0);
        const [isRendered, setIsRendered] = (0, $5uXOq.useState)(isExpanded);
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const contentRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!didMountRef.current) {
                didMountRef.current = true;
                return;
            }
            if (isExpanded) {
                setIsRendered(true);
                requestAnimationFrame(()=>{
                    setContainerHeight(contentRef.current?.offsetHeight ?? null);
                    Promise.all(wrapperRef.current?.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                        setContainerHeight(null);
                    });
                });
            } else {
                setContainerHeight(contentRef.current?.offsetHeight ?? null);
                requestAnimationFrame(()=>{
                    setContainerHeight(0);
                    Promise.all(wrapperRef.current?.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                        setIsRendered(false);
                    });
                });
            }
        }, [
            contentRef,
            isExpanded
        ]);
        if (!isRendered) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fa509c31ea2f76e0$var$CollapsibleWrapper, {
            animationDuration: animationDuration,
            containerHeight: containerHeight,
            id: id,
            ref: wrapperRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: contentRef
        }, children));
    };
    const $fa509c31ea2f76e0$var$CollapsibleWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { animationDuration: animationDuration, containerHeight: containerHeight, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_3opy9g": (0, (0, parcelRequire("lD23V")).default)(`max-height ${__cmplp.animationDuration}ms ease-in-out`),
                "--_3k6n1g": (0, (0, parcelRequire("lD23V")).default)(__cmplp.containerHeight, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _v564plo1",
                __cmplp.containerHeight != null ? "_c71ld5na" : "_c71ln7od",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1zqLm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47f581e43f4f1b3b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bVfxn;
    var $jzhSN;
    const $47f581e43f4f1b3b$var$ProjectItem = ({ project: project, onClick: onClick, onFavoriteToggle: onFavoriteToggle, to: to, isActive: isActive, className: className, testId: testId, prefetch: prefetch })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jzhSN")).default), {
            to: to,
            onClick: onClick,
            isActive: isActive,
            elemAfter: project.permissions.viewIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bVfxn")).default), {
                project: project,
                onToggle: onFavoriteToggle
            }),
            className: className,
            testId: testId,
            prefetch: prefetch
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($47f581e43f4f1b3b$var$Avatar, {
            src: project.avatarUrl,
            alt: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($47f581e43f4f1b3b$var$ProjectName, null, project.name));
    var $47f581e43f4f1b3b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($47f581e43f4f1b3b$var$ProjectItem);
    const $47f581e43f4f1b3b$var$ProjectName = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _y3gn1e5h _1e0c1ule _o5721q9c _1bto1l2s _k48p1wq8",
                __cmplp.className
            ])
        });
    });
    const $47f581e43f4f1b3b$var$Avatar = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _4t3i1tcg _1bsb1tcg _2hwxutpp _2rko1l7b",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bVfxn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5957c6a2c0f9f04$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $5IcUR;
    var $7piTm;
    var $dC5iT;
    var $3bDjY;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $79Jog;
    const $b5957c6a2c0f9f04$var$FavoriteButton = ({ project: project, onToggle: onToggle })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const label = project.isFavorite ? formatMessage((0, (0, parcelRequire("79Jog")).default).unstar) : formatMessage((0, (0, parcelRequire("79Jog")).default).star);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            const star = !project.isFavorite;
            onToggle(star);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'project starred', 'sidebar', {
                projectId: project.id,
                star: star
            });
        }, [
            project,
            onToggle,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            padding: "space.025"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label,
            hideTooltipOnClick: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b5957c6a2c0f9f04$var$Button, {
            isFavorite: project.isFavorite ?? false,
            onClick: onClick,
            "data-testid": "navigation-apps-sidebar-core.common.ui.favorite-button"
        }, project.isFavorite ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5IcUR"))))), {
            color: "currentColor",
            label: label
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7piTm"))))), {
            color: "currentColor",
            label: label
        }))));
    };
    var $b5957c6a2c0f9f04$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b5957c6a2c0f9f04$var$FavoriteButton);
    const $b5957c6a2c0f9f04$var$Button = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isFavorite: isFavorite, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _11q7glyw _80omtlke _2rko1sit _1spjglyw _157zglyw",
                __cmplp.isFavorite ? "_syazkizl" : "_syazjjyb",
                __cmplp.isFavorite ? "_f8pj1ov0 _30l31ov0 _17051ov0" : "_f8pj1wmz _30l31wmz _17051wmz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5IcUR", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $428b14ab8e8af837$var$_react = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $428b14ab8e8af837$var$_starStarred = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("dm1qi")));
    var $428b14ab8e8af837$var$_starFilled = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("bH1hf")));
    function $428b14ab8e8af837$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $428b14ab8e8af837$var$StarStarredIcon = (props)=>$428b14ab8e8af837$var$_react.default.createElement($428b14ab8e8af837$var$_starStarred.default, Object.assign({
            LEGACY_fallbackIcon: $428b14ab8e8af837$var$_starFilled.default
        }, props));
    $428b14ab8e8af837$var$StarStarredIcon.Name = 'StarStarredIconMigration';
    var $428b14ab8e8af837$var$_default = module.exports.default = $428b14ab8e8af837$var$StarStarredIcon;
});
parcelRegister("7piTm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $564985c3728d4aa2$var$_react = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $564985c3728d4aa2$var$_starUnstarred = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("dAf5R")));
    var $564985c3728d4aa2$var$_star = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5oTeF")));
    function $564985c3728d4aa2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $564985c3728d4aa2$var$StarUnstarredIcon = (props)=>$564985c3728d4aa2$var$_react.default.createElement($564985c3728d4aa2$var$_starUnstarred.default, Object.assign({
            LEGACY_fallbackIcon: $564985c3728d4aa2$var$_star.default
        }, props));
    $564985c3728d4aa2$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
    var $564985c3728d4aa2$var$_default = module.exports.default = $564985c3728d4aa2$var$StarUnstarredIcon;
});
parcelRegister("79Jog", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2dbb204157c9a073$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2dbb204157c9a073$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        star: {
            "id": "spa-apps-sidebar-core.common.favorite-button.star",
            "defaultMessage": "Add to Starred"
        },
        unstar: {
            "id": "spa-apps-sidebar-core.common.favorite-button.unstar",
            "defaultMessage": "Remove from Starred"
        }
    });
});
parcelRegister("hVL5W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4b65956d11fea1d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $eEqSc;
    var $1zqLm;
    var $fqbZF;
    const $e4b65956d11fea1d$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.current-project';
    const $e4b65956d11fea1d$var$ActiveProject = ({ project: project, to: to, onFavoriteToggle: onFavoriteToggle })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClick = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
                projectId: project.id,
                starred: project.isFavorite,
                current: true
            });
        }, [
            createAnalyticsEvent,
            project
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eEqSc")).default), {
            testId: $e4b65956d11fea1d$var$TEST_ID
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1zqLm")).default), {
            project: project,
            to: to,
            isActive: true,
            onClick: onClick,
            onFavoriteToggle: onFavoriteToggle
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fqbZF")).default), null));
    };
    var $e4b65956d11fea1d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($e4b65956d11fea1d$var$ActiveProject);
});
parcelRegister("fqbZF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44c9fe648224cdc5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $k0iPT;
    var $65Ltd;
    var $juTur;
    var $231OU;
    var $6jY6G;
    var $gb5lQ;
    var $lPApw;
    var $74Yye;
    var $iCrgB;
    var $2U3dG;
    var $boE05;
    var $chejP;
    var $9nNLl;
    const $44c9fe648224cdc5$var$calculateStack = (route, connectStack, forgeStack)=>{
        const routeName = route && route.name || '';
        if ((0, (0, parcelRequire("gb5lQ")).FORGE_ROUTES_SET).has(routeName) && forgeStack) return forgeStack;
        if ((0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(routeName) && connectStack) return connectStack;
        return [];
    };
    const $44c9fe648224cdc5$var$ProjectMenu = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: project } = (0, (0, parcelRequire("74Yye")).default)();
        const { data: features, loading: isFeaturesLoading } = (0, (0, parcelRequire("lPApw")).useFeatures)();
        const { stack: connectProjectStack } = (0, (0, parcelRequire("lPApw")).useProjectConnectItems)();
        const { stack: connectReportsStack } = (0, (0, parcelRequire("lPApw")).useProjectReportsConnectItems)();
        const { stack: connectSettingsStack } = (0, (0, parcelRequire("lPApw")).useProjectSettingsConnectItems)();
        const connectStack = connectProjectStack || connectReportsStack || connectSettingsStack;
        const { loading: projectForgeAppsLoading, stack: forgeStack } = (0, (0, parcelRequire("231OU")).useProjectForgeApps)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT));
        const [stack, setStack] = (0, $5uXOq.useState)(()=>$44c9fe648224cdc5$var$calculateStack(route, connectStack, forgeStack));
        (0, $5uXOq.useEffect)(()=>{
            setStack($44c9fe648224cdc5$var$calculateStack(route, connectStack, forgeStack));
        }, [
            route,
            connectStack,
            forgeStack
        ]);
        if (project == null || isFeaturesLoading || features == null || projectForgeAppsLoading) return null;
        let content = null;
        if ((0, (0, parcelRequire("gb5lQ")).ISSUES_ROUTES_SET).has(route.name)) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("boE05")).default), {
            project: project
        });
        else if ((0, (0, parcelRequire("gb5lQ")).REPORTS_ROUTES_SET).has(route.name) || connectReportsStack) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("chejP")).default), null);
        else if ((0, (0, parcelRequire("gb5lQ")).SETTINGS_ROUTES_SET).has(route.name) || route?.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE) || connectSettingsStack) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9nNLl")).default), {
            project: project
        });
        else if ((0, (0, parcelRequire("gb5lQ")).FORGE_ROUTES_SET).has(route.name) || forgeStack) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2U3dG")).default), null);
        else if ((0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(route.name) || connectProjectStack) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iCrgB")).default), {
            stack: stack,
            onStackChange: setStack,
            project: project
        });
        else return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).ContextualAnalyticsData), {
            menuId: (0, (0, parcelRequire("gb5lQ")).MENU_ID),
            stack: stack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($44c9fe648224cdc5$export$42a852a2b6b56249, null, content));
    };
    const $44c9fe648224cdc5$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1e0c1txw _2lx21bp4 _fshqh2mm _10p2glyw",
                __cmplp.className
            ])
        });
    });
    var $44c9fe648224cdc5$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($44c9fe648224cdc5$var$ProjectMenu);
});
parcelRegister("231OU", function(module, exports) {
    $parcel$export(module.exports, "useProjectForgeApps", ()=>$1a247d2d1d6e7cdf$export$338edd25edcf3648);
    $parcel$export(module.exports, "useProjectForgeAppsNav4", ()=>$1a247d2d1d6e7cdf$export$80e84933a3e2f677);
    var $5uXOq = parcelRequire("5uXOq");
    var $e5wyW;
    var $4R6GH;
    var $awp3q;
    var $dvdr4;
    var $5cmSg;
    var $5bkvv;
    var $dAfqg;
    var $324W5;
    var $kKdpt;
    const $1a247d2d1d6e7cdf$var$useProjectForgeAppsV1 = (routeName, projectKey)=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)(projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined);
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("5bkvv")).forgeProjectModuleV1Resource), projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined);
        const projectData = (0, $5uXOq.useMemo)(()=>data?.extensions || null, [
            data
        ]);
        const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.accessNarrowedExtensions || null, [
            data
        ]);
        const stack = (0, (0, parcelRequire("kKdpt")).useForgeItemStack)(projectData, routeName);
        const context = (0, $5uXOq.useMemo)(()=>projectContext ? {
                projectKey: projectContext.projectKey,
                projectId: projectContext.projectId,
                projectName: projectContext.projectName,
                projectType: projectContext.projectType,
                isProjectAdmin: projectContext.isProjectAdmin,
                isProjectArchived: projectContext.isProjectArchived
            } : {}, [
            projectContext
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: projectData ? projectData.filter((extension)=>(0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, context)) : null,
                accessNarrowedData: accessNarrowedData,
                loading: loading,
                error: error,
                stack: stack
            }), [
            projectData,
            accessNarrowedData,
            loading,
            error,
            stack,
            context
        ]);
    };
    const $1a247d2d1d6e7cdf$var$useProjectForgeAppsV2 = (routeName, projectKey)=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("5bkvv")).forgeProjectModuleV2Resource), projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined);
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)(projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined);
        const context = (0, $5uXOq.useMemo)(()=>projectContext ? {
                projectKey: projectContext.projectKey,
                projectId: projectContext.projectId,
                projectName: projectContext.projectName,
                projectType: projectContext.projectType,
                isProjectAdmin: projectContext.isProjectAdmin,
                isProjectArchived: projectContext.isProjectArchived
            } : {}, [
            projectContext
        ]);
        (0, (0, parcelRequire("dvdr4")).useDisplayConditionsConsistencyCheck)(data, context, 'project-forge-apps-hook');
        const projectData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionVisible)) || null, [
            data
        ]);
        const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionHiddenByAppAccessRules)) || null, [
            data
        ]);
        const stack = (0, (0, parcelRequire("kKdpt")).useForgeItemStack)(projectData, routeName);
        return (0, $5uXOq.useMemo)(()=>({
                data: projectData,
                accessNarrowedData: accessNarrowedData,
                loading: loading,
                error: error,
                stack: stack
            }), [
            projectData,
            accessNarrowedData,
            loading,
            error,
            stack
        ]);
    };
    const $1a247d2d1d6e7cdf$export$338edd25edcf3648 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $1a247d2d1d6e7cdf$var$useProjectForgeAppsV2, $1a247d2d1d6e7cdf$var$useProjectForgeAppsV1);
    const $1a247d2d1d6e7cdf$export$80e84933a3e2f677 = (projectKey)=>$1a247d2d1d6e7cdf$export$338edd25edcf3648(undefined, projectKey);
});
parcelRegister("e5wyW", function(module, exports) {
    $parcel$export(module.exports, "functionWithCondition", ()=>$12199147dc0ae1fa$export$af3c0e82a18fc057);
    $parcel$export(module.exports, "functionUnionWithCondition", ()=>$12199147dc0ae1fa$export$c41c28c1d883fcd5);
    function $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
        const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
        return fnWithCondition;
    }
    function $12199147dc0ae1fa$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
        return $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
    }
});
parcelRegister("awp3q", function(module, exports) {
    $parcel$export(module.exports, "useDoesExtensionMeetConditions", ()=>$bd52741229b769de$export$642911220fb6609f);
    $parcel$export(module.exports, "doesExtensionMeetConditions", ()=>$bd52741229b769de$export$b1e4ed7044e85aa3);
    var $5uXOq = parcelRequire("5uXOq");
    var $kvQVg = parcelRequire("kvQVg");
    var $4Pf62;
    var $daoB1;
    var $9OXo1;
    const $bd52741229b769de$export$642911220fb6609f = ()=>{
        const { isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { hasCoreAccess: hasCoreAccess, hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceManagementAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        return (0, $5uXOq.useCallback)((extension, extraContext)=>{
            const { displayConditions: displayConditions } = extension.properties;
            if (displayConditions == null) return true;
            const context = {
                ...extraContext,
                isAdmin: isAdmin,
                isLoggedIn: !isAnonymous,
                isSiteAdmin: isSiteAdmin,
                hasCoreAccess: hasCoreAccess,
                hasServiceManagementAccess: hasServiceManagementAccess,
                hasSoftwareAccess: hasSoftwareAccess
            };
            return (0, $kvQVg.doesMeetConditions)(displayConditions, context);
        }, [
            hasCoreAccess,
            hasServiceManagementAccess,
            hasSoftwareAccess,
            isAdmin,
            isAnonymous,
            isSiteAdmin
        ]);
    };
    const $bd52741229b769de$export$b1e4ed7044e85aa3 = (extension, extraContext)=>{
        const { displayConditions: displayConditions } = extension.properties;
        const { appPermissions: { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess }, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const context = {
            ...extraContext,
            isAdmin: isAdmin,
            isLoggedIn: !isAnonymous,
            isSiteAdmin: isSiteAdmin,
            hasSoftwareAccess: hasSoftwareAccess,
            hasServiceManagementAccess: hasServiceDeskAccess,
            hasCoreAccess: hasCoreAccess
        };
        return displayConditions ? (0, $kvQVg.doesMeetConditions)(displayConditions, context) : true;
    };
});
parcelRegister("daoB1", function(module, exports) {
    $parcel$export(module.exports, "ApplicationPermissionsSubscriber", ()=>$77add4b5420e5058$export$d8c76f7e52d0a856);
    $parcel$export(module.exports, "useApplicationPermissions", ()=>$77add4b5420e5058$export$4d9cadb4042acc1b);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $51nlc;
    var $2gywT;
    var $9OXo1;
    const $77add4b5420e5058$var$selector = (0, $dGvGJ.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
            data: {
                applicationPermissions: applicationPermissions
            }
        }));
    const $77add4b5420e5058$export$d8c76f7e52d0a856 = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("2gywT")).default), {
        displayName: 'ApplicationPermissionsSubscriber',
        selector: $77add4b5420e5058$var$selector
    });
    const $77add4b5420e5058$export$4d9cadb4042acc1b = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.appPermissions;
    };
});
parcelRegister("dvdr4", function(module, exports) {
    $parcel$export(module.exports, "useDisplayConditionsConsistencyCheck", ()=>$79a96011350576c4$export$cd62caf01a15f56b);
    $parcel$export(module.exports, "checkDisplayConditionsConsistency", ()=>$79a96011350576c4$export$4169695e1a68bda7);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $dJl1T;
    var $4R6GH;
    var $awp3q;
    var $5cmSg;
    const $79a96011350576c4$export$cd62caf01a15f56b = (data, context = {}, consumer)=>{
        const memoizedContext = $79a96011350576c4$var$useMemoizedStateObject(context);
        const memoizedData = $79a96011350576c4$var$useMemoizedStateObject(data);
        (0, $5uXOq.useEffect)(()=>{
            $79a96011350576c4$export$4169695e1a68bda7(memoizedData, memoizedContext, consumer);
        }, [
            memoizedContext,
            memoizedData,
            consumer
        ]);
    };
    const $79a96011350576c4$export$4169695e1a68bda7 = (data, context = {}, consumer)=>{
        if (data == null) return;
        if ((0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')) {
            if ('extensions' in data) {
                (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'checkDisplayConditionsConsistency is called with a data from the old query', {
                    consumer: consumer
                });
                return;
            }
        } else {
            (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'checkDisplayConditionsConsistency is called while the FG is being turned off', {
                consumer: consumer
            });
            return;
        }
        const falsePositives = new Set();
        const falseNegatives = new Set();
        data.forEach((extension)=>{
            const perClient = (0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, context);
            const perServer = !(0, (0, parcelRequire("5cmSg")).isExtensionHiddenByDisplayConditions)(extension);
            if (perClient !== perServer) {
                if (perServer) falsePositives.add(extension);
                else falseNegatives.add(extension);
            }
        });
        if (falsePositives.size || falseNegatives.size) (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'Display conditions evaluation is not consistent', {
            consumer: consumer,
            context: JSON.stringify(context),
            falsePositives_count: falsePositives.size,
            falsePositives_data: falsePositives.size ? JSON.stringify(Array.from(falsePositives).map((ext)=>({
                    id: ext.id,
                    type: ext.type,
                    displayConditions: ext.properties.displayConditions
                }))) : null,
            falseNegatives_count: falseNegatives.size,
            falseNegatives_data: falseNegatives.size ? JSON.stringify(Array.from(falseNegatives).map((ext)=>({
                    id: ext.id,
                    type: ext.type,
                    displayConditions: ext.properties.displayConditions
                }))) : null
        });
    };
    const $79a96011350576c4$var$useMemoizedStateObject = (data, equalityCheck = (0, ($parcel$interopDefault($ajpes))))=>{
        const memoizedData = (0, $5uXOq.useRef)(data);
        return (0, $5uXOq.useMemo)(()=>{
            if (!equalityCheck(data, memoizedData.current)) {
                memoizedData.current = data;
                return data;
            }
            return memoizedData.current;
        }, [
            data,
            equalityCheck
        ]);
    };
});
parcelRegister("kKdpt", function(module, exports) {
    $parcel$export(module.exports, "useForgeItemStack", ()=>$dac9c7c54c5ccbb1$export$462f82a278743d46);
    var $5uXOq = parcelRequire("5uXOq");
    var $c70gQ;
    var $doZTA;
    var $7Tlti;
    const $dac9c7c54c5ccbb1$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
        const [{ match: match, route: route }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const matchedExtension = (0, (0, parcelRequire("c70gQ")).useMatchedExtension)({
            modules: modules,
            match: match
        });
        return (0, $5uXOq.useMemo)(()=>{
            if (route.name !== routeName) return null;
            if (matchedExtension && (0, (0, parcelRequire("7Tlti")).toSections)(matchedExtension).length) {
                const stackId = `${matchedExtension.id}-subpages`;
                return parentStack ? [
                    ...parentStack,
                    stackId
                ] : [
                    stackId
                ];
            }
            if (matchedExtension && parentStack) return parentStack;
            return null;
        }, [
            matchedExtension,
            parentStack,
            route.name,
            routeName
        ]);
    };
});
parcelRegister("c70gQ", function(module, exports) {
    $parcel$export(module.exports, "useMatchedExtension", ()=>$b661f1f04cec9385$export$13375c0abccaf6f6);
    $parcel$export(module.exports, "useExtensionBasePath", ()=>$b661f1f04cec9385$export$25abed85383f0fbb);
    var $5uXOq = parcelRequire("5uXOq");
    var $e0AC8;
    const $b661f1f04cec9385$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $5uXOq.useMemo)(()=>(modules || []).find((app)=>{
                const parsedExtensionId = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(app.id);
                return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
            }), [
            modules,
            match.params.appId,
            match.params.envId
        ]);
    const $b661f1f04cec9385$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');
});
parcelRegister("7Tlti", function(module, exports) {
    $parcel$export(module.exports, "toSections", ()=>$25b31557e9750c03$export$29678d1e04c0e8c4);
    var $8QpSo;
    const $25b31557e9750c03$var$normalizeSection = (section)=>({
            header: section?.header,
            pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                    icon: page?.icon,
                    route: page?.route,
                    title: page?.title
                })) : []
        });
    const $25b31557e9750c03$export$29678d1e04c0e8c4 = (0, (0, parcelRequire("8QpSo")).default)((extension)=>{
        const { properties: properties } = extension;
        if (typeof properties.resource !== 'string') return [];
        if (typeof properties.pages !== 'undefined' && properties.pages?.length) return [
            {
                pages: properties.pages
            }
        ].map($25b31557e9750c03$var$normalizeSection);
        if (typeof properties.sections !== 'undefined' && properties.sections?.length) return properties.sections.map($25b31557e9750c03$var$normalizeSection);
        return [];
    });
});
parcelRegister("lPApw", function(module, exports) {
    $parcel$export(module.exports, "useFeatures", ()=>$fd44cc0bd2bece63$export$4a39035bacc4ed76);
    $parcel$export(module.exports, "useProjectConnectItems", ()=>$fd44cc0bd2bece63$export$f23d0c24c77d7608);
    $parcel$export(module.exports, "useProjectReportsConnectItems", ()=>$fd44cc0bd2bece63$export$a1c75c386c088992);
    $parcel$export(module.exports, "useProjectSettingsConnectItems", ()=>$fd44cc0bd2bece63$export$41a50100db18b578);
    $parcel$export(module.exports, "useProjectSettingsForgeItems", ()=>$fd44cc0bd2bece63$export$84761bbf25a4f51f);
    var $18FbX;
    var $7OqB4;
    var $hWtQt;
    var $jfqNX;
    var $gZbSF;
    var $6hMYg;
    var $bkw8F;
    const $fd44cc0bd2bece63$export$4a39035bacc4ed76 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("bkw8F")).useFeatures));
    const $fd44cc0bd2bece63$export$f23d0c24c77d7608 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("gZbSF")).useProjectConnectItems));
    const $fd44cc0bd2bece63$export$a1c75c386c088992 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("hWtQt")).useProjectReportsConnectItems));
    const $fd44cc0bd2bece63$export$41a50100db18b578 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("jfqNX")).useProjectSettingsConnectItems));
    const $fd44cc0bd2bece63$export$84761bbf25a4f51f = (0, (0, parcelRequire("6hMYg")).useProjectSettingsForgeAppsForMenu);
    const $fd44cc0bd2bece63$export$96e8a0c1f4717705 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("18FbX")).useJiraWorkManagementProjectPagesLink));
});
parcelRegister("18FbX", function(module, exports) {
    $parcel$export(module.exports, "useJiraSoftwareProjectPagesLink", ()=>$066b0551287c1b35$export$50628ae0ad1a35f2);
    $parcel$export(module.exports, "useJiraWorkManagementProjectPagesLink", ()=>$066b0551287c1b35$export$96e8a0c1f4717705);
    var $5uXOq = parcelRequire("5uXOq");
    var $eusud;
    var $1J3t1;
    const $066b0551287c1b35$var$pagesLinkBaseUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/projects/1.0/pageslink/${projectKey}`;
    const $066b0551287c1b35$var$enablePagesLinkUrl = (baseUrl, projectKey)=>`${$066b0551287c1b35$var$pagesLinkBaseUrl(baseUrl, projectKey)}/enable`;
    const $066b0551287c1b35$var$disablePagesLinkUrl = (baseUrl, projectKey)=>`${$066b0551287c1b35$var$pagesLinkBaseUrl(baseUrl, projectKey)}/disable`;
    const $066b0551287c1b35$var$setPagesLinkService = ({ baseUrl: baseUrl, projectKey: projectKey, enable: enable })=>enable ? (0, (0, parcelRequire("eusud")).performPutRequest)($066b0551287c1b35$var$enablePagesLinkUrl(baseUrl, projectKey)) : (0, (0, parcelRequire("eusud")).performPutRequest)($066b0551287c1b35$var$disablePagesLinkUrl(baseUrl, projectKey));
    const $066b0551287c1b35$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const $066b0551287c1b35$export$50628ae0ad1a35f2 = ()=>{
        const { data: data, loading: loading, refresh: refresh, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraSoftwareProjectNavigation)();
        const setPagesLink = (0, $5uXOq.useCallback)(async (...args)=>{
            await $066b0551287c1b35$var$setPagesLinkService(...args);
            await refresh();
        }, [
            refresh
        ]);
        return {
            data: {
                isEnabled: data?.hasPages === true,
                canEdit: data?.permissionInfo != null && $066b0551287c1b35$var$isProjectOrJiraAdmin(data.permissionInfo),
                pending: loading,
                setPagesLink: setPagesLink
            },
            loading: loading,
            error: error
        };
    };
    const $066b0551287c1b35$export$96e8a0c1f4717705 = ()=>{
        const { loading: loading, refresh: refresh, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const setPagesLink = (0, $5uXOq.useCallback)(async (...args)=>{
            await $066b0551287c1b35$var$setPagesLinkService(...args);
            await refresh();
        }, [
            refresh
        ]);
        return {
            data: {
                isEnabled: true,
                canEdit: false,
                pending: loading,
                setPagesLink: setPagesLink
            },
            loading: loading,
            error: error
        };
    };
});
parcelRegister("hWtQt", function(module, exports) {
    $parcel$export(module.exports, "useProjectReportsConnectItems", ()=>$a740427f233367ba$export$a1c75c386c088992);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $1J3t1;
    var $doZTA;
    var $7tsV0;
    var $5W6pd;
    const $a740427f233367ba$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $a740427f233367ba$export$a1c75c386c088992 = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectReportsSidebarConnectNavigation)();
        const items = (0, $5uXOq.useMemo)(()=>data != null ? data.map((0, (0, parcelRequire("5W6pd")).transformLinkV4)).filter(Boolean) : [], [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $a740427f233367ba$var$findItemAndStackMemo(items, route.name, location, [
                'reports'
            ]), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            error: error,
            loading: loading,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("jfqNX", function(module, exports) {
    $parcel$export(module.exports, "useProjectSettingsConnectItems", ()=>$662340ab1e9d2787$export$41a50100db18b578);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $1J3t1;
    var $doZTA;
    var $7tsV0;
    var $5W6pd;
    const $662340ab1e9d2787$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $662340ab1e9d2787$export$41a50100db18b578 = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectSettingsSidebarConnectNavigation)();
        const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, (0, parcelRequire("5W6pd")).transformLinkV4)).filter(Boolean), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $662340ab1e9d2787$var$findItemAndStackMemo(items, route.name, location, [
                'settings'
            ]), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("gZbSF", function(module, exports) {
    $parcel$export(module.exports, "useProjectConnectItems", ()=>$fcf7bc53994ae8f3$export$f23d0c24c77d7608);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $1J3t1;
    var $doZTA;
    var $7tsV0;
    var $5W6pd;
    const $fcf7bc53994ae8f3$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $fcf7bc53994ae8f3$export$f23d0c24c77d7608 = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectSidebarConnectNavigation)();
        const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, (0, parcelRequire("5W6pd")).transformLinkV4)).filter(Boolean), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $fcf7bc53994ae8f3$var$findItemAndStackMemo(items, route.name, location), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("6hMYg", function(module, exports) {
    $parcel$export(module.exports, "useProjectSettingsForgeApps", ()=>$2106846b1818d2e6$export$bef2e514007d2f07);
    $parcel$export(module.exports, "useProjectSettingsForgeAppsForMenu", ()=>$2106846b1818d2e6$export$b741e3e3cfb39b82);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $e5wyW;
    var $4R6GH;
    var $k2DRb;
    var $e0AC8;
    var $awp3q;
    var $dvdr4;
    var $5cmSg;
    var $5bkvv;
    var $dAfqg;
    var $itmJb;
    var $cNd4s;
    var $9OXo1;
    var $2YP9W;
    var $kKdpt;
    var $7Tlti;
    const $2106846b1818d2e6$export$3c509d6dc1f63bbe = ()=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleV1Resource));
        const projectSettingsData = (0, $5uXOq.useMemo)(()=>data?.extensions || null, [
            data
        ]);
        const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.accessNarrowedExtensions || null, [
            data
        ]);
        const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const hasPermissions = (0, $5uXOq.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
            isAdmin,
            isSiteAdmin,
            projectContext?.isProjectAdmin
        ]);
        const context = (0, $5uXOq.useMemo)(()=>projectContext ? {
                projectKey: projectContext.projectKey,
                projectId: projectContext.projectId,
                projectName: projectContext.projectName,
                projectType: projectContext.projectType
            } : {}, [
            projectContext
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: projectSettingsData ? projectSettingsData.filter((extension)=>hasPermissions && (0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, context)) : null,
                accessNarrowedData: accessNarrowedData,
                loading: loading,
                error: error
            }), [
            projectSettingsData,
            accessNarrowedData,
            loading,
            error,
            hasPermissions,
            context
        ]);
    };
    const $2106846b1818d2e6$export$5aac3b333ac18e0d = ()=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleV2Resource));
        const projectSettingsData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionVisible)) || null, [
            data
        ]);
        const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionHiddenByAppAccessRules)) || null, [
            data
        ]);
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const hasPermissions = (0, $5uXOq.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
            isAdmin,
            isSiteAdmin,
            projectContext?.isProjectAdmin
        ]);
        const context = (0, $5uXOq.useMemo)(()=>projectContext ? {
                projectKey: projectContext.projectKey,
                projectId: projectContext.projectId,
                projectName: projectContext.projectName,
                projectType: projectContext.projectType
            } : {}, [
            projectContext
        ]);
        (0, (0, parcelRequire("dvdr4")).useDisplayConditionsConsistencyCheck)(data, context, 'project-settings-forge-apps-hook');
        return (0, $5uXOq.useMemo)(()=>({
                data: projectSettingsData ? hasPermissions && projectSettingsData || [] : null,
                accessNarrowedData: accessNarrowedData,
                loading: loading,
                error: error
            }), [
            projectSettingsData,
            accessNarrowedData,
            loading,
            error,
            hasPermissions
        ]);
    };
    const $2106846b1818d2e6$export$bef2e514007d2f07 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $2106846b1818d2e6$export$5aac3b333ac18e0d, $2106846b1818d2e6$export$3c509d6dc1f63bbe);
    const $2106846b1818d2e6$var$appsProjectTypeRouteMap = {
        tmp: {
            [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'core',
            [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software',
            [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'servicedesk',
            [(0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)]: undefined,
            [(0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT)]: undefined
        },
        cmp: {
            [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'core',
            [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software/c',
            [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'servicedesk',
            [(0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)]: undefined,
            [(0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT)]: undefined
        }
    };
    const $2106846b1818d2e6$export$ed6342e0e28465a6 = (extension, projectType, projectKey, isSimplified)=>{
        const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
        return `/jira/${$2106846b1818d2e6$var$appsProjectTypeRouteMap[isSimplified ? 'tmp' : 'cmp'][projectType]}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
    };
    const $2106846b1818d2e6$export$b741e3e3cfb39b82 = (routeName, parentStack)=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { data: data, loading: loading, error: error } = $2106846b1818d2e6$export$bef2e514007d2f07();
        const stack = (0, (0, parcelRequire("kKdpt")).useForgeItemStack)(data, routeName, parentStack);
        const { projectType: projectType, projectKey: projectKey, simplified: isSimplified } = projectContext || {};
        return (0, $5uXOq.useMemo)(()=>({
                data: data ? data.map((extension)=>({
                        id: extension.id,
                        url: $2106846b1818d2e6$export$ed6342e0e28465a6(extension, projectType, projectKey, isSimplified),
                        name: extension.properties.title,
                        iconUrl: extension.properties.icon,
                        environmentType: extension.environmentType,
                        environmentKey: extension.environmentKey,
                        moduleName: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
                        sections: (0, (0, parcelRequire("7Tlti")).toSections)(extension)
                    })) : null,
                loading: loading,
                error: error,
                stack: stack
            }), [
            data,
            loading,
            error,
            stack,
            projectType,
            projectKey,
            isSimplified
        ]);
    };
});
parcelRegister("cNd4s", function(module, exports) {
    $parcel$export(module.exports, "useIsSiteAdmin", ()=>$3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);
    var $9OXo1;
    const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.isSiteAdmin || false;
    };
});
parcelRegister("bkw8F", function(module, exports) {
    $parcel$export(module.exports, "useFeatures", ()=>$7fc2f0545f0a83ac$export$4a39035bacc4ed76);
    $parcel$export(module.exports, "useSettingFeatures", ()=>$7fc2f0545f0a83ac$export$56022a3b83c8ed6a);
    $parcel$export(module.exports, "useReportFeatures", ()=>$7fc2f0545f0a83ac$export$4adaea9828b7ff13);
    var $5uXOq = parcelRequire("5uXOq");
    var $1J3t1;
    var $jIwth;
    var $iNzEe;
    var $daoB1;
    var $d4FZj;
    const $7fc2f0545f0a83ac$export$4a39035bacc4ed76 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const isPremiumUserSeat = (0, (0, parcelRequire("iNzEe")).useIsPremiumUserSeat)();
        const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("d4FZj")).getExtraData)(data, isPremiumUserSeat), [
            data,
            isPremiumUserSeat
        ]);
        return {
            data: transformedData,
            loading: loading,
            error: error
        };
    };
    const $7fc2f0545f0a83ac$export$56022a3b83c8ed6a = ()=>{
        const hasActiveSoftwareAccess = (0, (0, parcelRequire("jIwth")).useHasActiveSoftwareAccess)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("d4FZj")).getExtraSettingsData)(data, hasActiveSoftwareAccess), [
            data,
            hasActiveSoftwareAccess
        ]);
        return {
            data: transformedData,
            loading: loading,
            error: error
        };
    };
    const $7fc2f0545f0a83ac$export$4adaea9828b7ff13 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const { hasSoftwareAccess: hasSoftwareAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("d4FZj")).getExtraReportData)(hasSoftwareAccess), [
            data,
            hasSoftwareAccess
        ]);
        return {
            data: transformedData,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("jIwth", function(module, exports) {
    $parcel$export(module.exports, "useHasActiveSoftwareAccess", ()=>$c3adde43a433f1b5$export$895f9b38ce00671e);
    var $k9JTq;
    var $daoB1;
    const $c3adde43a433f1b5$export$895f9b38ce00671e = ()=>{
        const { software: software } = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const { hasSoftwareAccess: hasSoftwareAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        return software !== 'UNLICENSED' && hasSoftwareAccess === true;
    };
});
parcelRegister("d4FZj", function(module, exports) {
    $parcel$export(module.exports, "getExtraData", ()=>$acf9418ce967848e$export$6c55c6c980ed2046);
    $parcel$export(module.exports, "getExtraSettingsData", ()=>$acf9418ce967848e$export$b77a5597b7177cfb);
    $parcel$export(module.exports, "getExtraReportData", ()=>$acf9418ce967848e$export$be58a1e7b06d1d3);
    var $co1wz;
    var $4R6GH;
    const $acf9418ce967848e$export$6c55c6c980ed2046 = (data, isPremium)=>{
        const { permissionInfo: permissionInfo, hasComponents: hasComponents = false, project: project } = data;
        const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
        const isProjectOrJiraAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true || isAdmin;
        const isSimplifiedProject = project.simplified;
        const hasSettings = isAdmin || projectPermissionsQueried.ADMINISTER_PROJECTS || projectPermissionsQueried.EDIT_ISSUE_LAYOUT || projectPermissionsQueried.EDIT_WORKFLOW;
        return {
            hasVersions: true,
            hasSettings: (0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5') ? hasSettings : isProjectOrJiraAdmin,
            hasBoard: true,
            hasReports: true,
            hasAddItem: isProjectOrJiraAdmin,
            hasComponents: hasComponents,
            hasIssues: true,
            hasSummary: true,
            hasPages: true,
            hasChangeTheme: isProjectOrJiraAdmin,
            hasApprovals: isSimplifiedProject && (isPremium || isProjectOrJiraAdmin)
        };
    };
    const $acf9418ce967848e$export$b77a5597b7177cfb = (data, hasActiveSoftwareAccess)=>{
        const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = data.permissionInfo;
        const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
        const isProjectOrJiraAdmin = isProjectAdmin || isAdmin;
        const isCMPProject = !data.project.simplified;
        const hasEditWorkflowPermissions = projectPermissionsQueried.EDIT_WORKFLOW === true;
        const hasIssueLayoutPermissions = projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
        const hasDetails = isProjectOrJiraAdmin;
        const hasPeople = isProjectOrJiraAdmin;
        const hasIssueTypes = isAdmin;
        let hasAutomation = true;
        let hasSummary = true;
        let hasWorkflows = true;
        let hasScreens = true;
        let hasSystemFieldsConfiguration = true;
        let hasProjectEfaFields = false;
        let hasVersions = true;
        let hasComponents = true;
        let hasPermissions = true;
        let hasIssueSecurity = true;
        let hasNotifications = true;
        let hasIssueCollectors = true;
        let hasIssueLayout = true;
        const hasDevtools = isProjectAdmin && hasActiveSoftwareAccess;
        if ((0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) {
            hasAutomation = isProjectOrJiraAdmin;
            hasSummary = isProjectOrJiraAdmin;
            hasWorkflows = hasEditWorkflowPermissions || isProjectOrJiraAdmin;
            hasScreens = isProjectOrJiraAdmin;
            hasSystemFieldsConfiguration = isCMPProject && isProjectOrJiraAdmin;
            hasVersions = isProjectOrJiraAdmin;
            hasComponents = isProjectOrJiraAdmin;
            hasPermissions = isProjectOrJiraAdmin;
            hasIssueSecurity = isProjectOrJiraAdmin;
            hasNotifications = isProjectOrJiraAdmin;
            hasIssueCollectors = isProjectOrJiraAdmin;
            hasIssueLayout = hasIssueLayoutPermissions || isProjectOrJiraAdmin;
        }
        if ((0, (0, parcelRequire("4R6GH")).fg)('project_fields_page_for_tmp_-_mvp')) hasProjectEfaFields = !isCMPProject && isProjectOrJiraAdmin && !!data.hasExplicitFieldAssociationsEnabled;
        return {
            hasAutomation: hasAutomation,
            hasProjectGroupOneSection: hasDetails || hasPeople || hasSummary,
            hasIssueConfigSection: hasIssueTypes,
            hasProjectGroupTwoSection: hasWorkflows || hasScreens || hasSystemFieldsConfiguration,
            hasProjectGroupThreeSection: hasVersions || hasComponents,
            hasProjectGroupFourSection: hasPermissions || hasIssueSecurity || hasNotifications,
            hasgetIssueCollectorSection: hasIssueCollectors,
            hasComponents: hasComponents,
            hasDetails: hasDetails,
            hasSystemFieldsConfiguration: hasSystemFieldsConfiguration,
            hasProjectEfaFields: hasProjectEfaFields,
            hasIssueCollectors: hasIssueCollectors,
            hasIssueSecurity: hasIssueSecurity,
            hasIssueTypes: hasIssueTypes,
            hasNotifications: hasNotifications,
            hasPeople: hasPeople,
            hasPermissions: hasPermissions,
            hasScreens: hasScreens,
            hasSummary: hasSummary,
            hasVersions: hasVersions,
            hasWorkflows: hasWorkflows,
            hasDevtools: hasDevtools,
            hasIssueLayout: hasIssueLayout
        };
    };
    const $acf9418ce967848e$export$be58a1e7b06d1d3 = (hasSoftwareAccess)=>({
            hasDeveloperWorkload: true,
            hasForcastSection: true,
            hasTimeTracking: true,
            hasVersionWorkloadReport: hasSoftwareAccess
        });
});
parcelRegister("74Yye", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d2a068828302038$export$2e2bcd8739ae039);
    var $lpwtK;
    var $7OqB4;
    const $3d2a068828302038$var$useProject = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    var $3d2a068828302038$export$2e2bcd8739ae039 = $3d2a068828302038$var$useProject;
});
parcelRegister("iCrgB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$116dde1e3871ac6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9btdk;
    var $gjTBi;
    var $koVbs;
    var $3tHFY;
    var $gZbSF;
    var $8yg0C;
    var $cqRWX;
    const $116dde1e3871ac6a$var$ConnectAppMenu = ({ stack: stack, project: project, onStackChange: onStackChange })=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const { data: connectItems, stack: connectStack, selected: selectedConnectApp } = (0, (0, parcelRequire("gZbSF")).useProjectConnectItems)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectKey = String(project?.key);
        const getBackMenuItem = (0, $5uXOq.useCallback)(()=>({
                href: `/jira/core/projects/${projectKey}`,
                title: formatMessage((0, (0, parcelRequire("cqRWX")).messages).itemBack)
            }), [
            formatMessage,
            projectKey
        ]);
        if (connectStack != null && connectStack.length > 0 && selectedConnectApp != null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9btdk")).default), {
            stack: stack,
            onChange: onStackChange
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3tHFY")).ConnectMenu), {
            items: connectItems,
            showIcons: true,
            overrides: {
                BackMenuItem: getBackMenuItem(),
                navigateOnBackMenuItemClick: true
            }
        })));
        return null;
    };
    var $116dde1e3871ac6a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($116dde1e3871ac6a$var$ConnectAppMenu);
});
parcelRegister("8yg0C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$389170a5379f53c2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPQRI;
    const $389170a5379f53c2$var$useAutoExpandSidebar = ()=>{
        const { expandLeftSidebar: expandLeftSidebar } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarController)();
        const { isCollapsed: isCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const sidebarExpandedRef = (0, $5uXOq.useRef)(!isCollapsed);
        (0, $5uXOq.useEffect)(()=>{
            if (!sidebarExpandedRef.current && isCollapsed) {
                expandLeftSidebar();
                sidebarExpandedRef.current = true;
            }
        }, [
            expandLeftSidebar,
            isCollapsed
        ]);
    };
    var $389170a5379f53c2$export$2e2bcd8739ae039 = $389170a5379f53c2$var$useAutoExpandSidebar;
});
parcelRegister("cqRWX", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$dd966ae40fe1732a$export$defe85febe8b728c);
    var $7VHMR;
    const $dd966ae40fe1732a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        itemBack: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.connect-app-menu.item-back",
            "defaultMessage": "Back to project"
        }
    });
});
parcelRegister("2U3dG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46153d687d6c578f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $7XYc4;
    var $4R6GH;
    var $5cmSg;
    var $5bkvv;
    var $ih1Yr;
    var $231OU;
    var $8zgGo;
    var $6jY6G;
    var $2YP9W;
    var $8yg0C;
    const $46153d687d6c578f$var$ForgeMenuV1 = ()=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: forgeResourceData } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("5bkvv")).forgeProjectModuleV1Resource));
        const projectData = (0, $5uXOq.useMemo)(()=>forgeResourceData?.extensions || null, [
            forgeResourceData
        ]);
        const selectedForgeApp = (0, (0, parcelRequire("ih1Yr")).useForgeSelectedApp)(projectData, route.name);
        const { stack: forgeStack } = (0, (0, parcelRequire("231OU")).useProjectForgeApps)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT));
        if (selectedForgeApp != null && forgeStack != null && forgeStack.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8zgGo")).ForgeProjectSection), {
            overrides: {
                showSelectedAppMenuOnly: true,
                selectedApp: selectedForgeApp
            }
        });
        return null;
    };
    const $46153d687d6c578f$var$ForgeMenuV2 = ()=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: forgeResourceData } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("5bkvv")).forgeProjectModuleV2Resource));
        const projectData = (0, $5uXOq.useMemo)(()=>forgeResourceData?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionVisible)) || null, [
            forgeResourceData
        ]);
        const selectedForgeApp = (0, (0, parcelRequire("ih1Yr")).useForgeSelectedApp)(projectData, route.name);
        const { stack: forgeStack } = (0, (0, parcelRequire("231OU")).useProjectForgeApps)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT));
        if (selectedForgeApp != null && forgeStack != null && forgeStack.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8zgGo")).ForgeProjectSection), {
            overrides: {
                showSelectedAppMenuOnly: true,
                selectedApp: selectedForgeApp
            }
        });
        return null;
    };
    const $46153d687d6c578f$var$ForgeMenu = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $46153d687d6c578f$var$ForgeMenuV2, $46153d687d6c578f$var$ForgeMenuV1);
    var $46153d687d6c578f$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($46153d687d6c578f$var$ForgeMenu);
});
parcelRegister("ih1Yr", function(module, exports) {
    $parcel$export(module.exports, "useForgeSelectedApp", ()=>$b1393ffdd951bcc8$export$e6dee8b777476118);
    var $c70gQ;
    var $doZTA;
    const $b1393ffdd951bcc8$export$e6dee8b777476118 = (modules, routeName)=>{
        const [{ match: match, route: route }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const matchedExtension = (0, (0, parcelRequire("c70gQ")).useMatchedExtension)({
            modules: modules,
            match: match
        });
        if (route.name !== routeName || matchedExtension == null) return null;
        return matchedExtension;
    };
});
parcelRegister("8zgGo", function(module, exports) {
    $parcel$export(module.exports, "ForgeProjectSection", ()=>$4cec53abbd9c3c33$export$fb7da191295a7e22);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $2vSU6;
    var $1rTGO;
    var $bXK4r;
    var $k2DRb;
    var $e0AC8;
    var $koVbs;
    var $dAfqg;
    var $k51JQ;
    var $7Tlti;
    var $231OU;
    var $kBPYs;
    const $4cec53abbd9c3c33$var$projectTypeRouteMap = {
        [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'core',
        [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software',
        [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'servicedesk'
    };
    const $4cec53abbd9c3c33$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
        const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
        return `/jira/${$4cec53abbd9c3c33$var$projectTypeRouteMap[projectType]}/projects/${projectKey}/apps/${appId}/${envId}`;
    };
    const $4cec53abbd9c3c33$export$fb7da191295a7e22 = ({ nestedMenuActive: nestedMenuActive, overrides: overrides })=>{
        const { data: data } = (0, (0, parcelRequire("231OU")).useProjectForgeApps)();
        const { data: projectContextData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const filteredForgeAppsData = (0, $5uXOq.useMemo)(()=>overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
                overrides.selectedApp
            ] : data || [], [
            data,
            overrides
        ]);
        if (!data?.length || !projectContextData) return null;
        const { projectKey: projectKey, projectType: projectType } = projectContextData;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bXK4r")).TriggerAnalyticsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: overrides?.showSelectedAppMenuOnly ? undefined : formatMessage((0, (0, parcelRequire("kBPYs")).messages).forgeSectionTitle)
        }, filteredForgeAppsData.map((extension)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k51JQ")).ForgeItem), {
                key: extension.id,
                id: extension.id,
                environmentType: extension.environmentType,
                environmentKey: extension.environmentKey,
                url: $4cec53abbd9c3c33$export$ed6342e0e28465a6(extension, projectType, projectKey),
                name: extension.properties.title,
                sections: (0, (0, parcelRequire("7Tlti")).toSections)(extension),
                moduleName: (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
                iconUrl: extension.properties.icon,
                showIcon: true,
                nestedMenuActive: nestedMenuActive,
                overrides: overrides
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeScreenEvent), {
            attributes: {
                moduleType: (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE)
            }
        })));
    };
});
parcelRegister("1rTGO", function(module, exports) {
    $parcel$export(module.exports, "ForgeScreenEvent", ()=>$abbdb580491d9d09$export$92d758d83665314b);
    $parcel$export(module.exports, "ForgeOperationaFailedEvent", ()=>$abbdb580491d9d09$export$a238c3c13f29c134);
    $parcel$export(module.exports, "ForgeErrorBoundary", ()=>$abbdb580491d9d09$export$ac7e7464cefab440);
    $parcel$export(module.exports, "ForgeAnalyticsWrapper", ()=>$abbdb580491d9d09$export$ad2a5d9127152fb8);
    $parcel$export(module.exports, "withMetrics", ()=>$abbdb580491d9d09$export$14e56d7f5d3f917c);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $k2DRb;
    var $3mOWa;
    var $eOGyv;
    var $iXVV6;
    var $8zOmE;
    var $5oFIy;
    var $isuse;
    var $hBuqR;
    var $6MtPV;
    var $dd7Uh;
    var $2RhPB;
    var $9BrHy;
    var $8kVg1;
    const $abbdb580491d9d09$export$92d758d83665314b = ({ attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: (0, (0, parcelRequire("6MtPV")).createAttributes)(attributes)
        });
    const $abbdb580491d9d09$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
        (0, (0, parcelRequire("dd7Uh")).fireOperationalFailedEvent)({
            eventId: eventId,
            attributes: attributes
        });
        return null;
    };
    const $abbdb580491d9d09$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
        const hasForgeAccess = (0, (0, parcelRequire("eOGyv")).useHasForgeAccess)();
        const analyticsAttributes = (0, (0, parcelRequire("6MtPV")).createAttributes)({
            ...attributes,
            hasForgeAccess: hasForgeAccess
        });
        const fireEvent = (0, $5uXOq.useCallback)((analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, (0, (0, parcelRequire("9BrHy")).getEventActionName)(eventId, action), analyticsAttributes);
        }, [
            eventId,
            action,
            analyticsAttributes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: fireEvent
        });
    };
    const $abbdb580491d9d09$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.${eventId}`
        }, children);
    const $abbdb580491d9d09$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
        const fallback = (0, $5uXOq.useMemo)(()=>errorFallback || 'unmount', [
            errorFallback
        ]);
        const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, (0, parcelRequire("6MtPV")).createAttributes)({
                ...attributes,
                error: error
            }), [
            attributes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: eventId,
            packageName: (0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3),
            teamName: "smite",
            fallback: fallback,
            attributes: getAttributes,
            onError: onError,
            resetCaughtError: resetCaughtError
        }, children);
    };
    const $abbdb580491d9d09$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
        const eventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
            module: module,
            moduleType: moduleType,
            entryPoint: entryPoint
        });
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("6MtPV")).createAttributes)(attributes), [
            attributes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
            eventId: eventId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$ac7e7464cefab440, {
            eventId: eventId,
            attributes: analyticsAttributes,
            errorFallback: errorFallback,
            resetCaughtError: resetCaughtError
        }, shouldFireInitializedEvent && (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$4c46624a93517c10, {
            eventId: eventId,
            action: "initialized",
            attributes: analyticsAttributes
        }), children));
    };
    function $abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
        if ((extensionModule === (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE) || extensionModule === (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
        if (extensionModule === (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
        return [
            (0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTION_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTIVITY_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_CONTEXT_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_GLANCE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_NAVIGATOR_ACTION_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).BACKLOG_ACTION_MODULE)
        ].includes(extensionModule);
    }
    const $abbdb580491d9d09$export$14e56d7f5d3f917c = (Component)=>(props)=>{
            const startTime = (0, $5uXOq.useRef)(performance.now());
            const isCustomUI = (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(props.extension, props.entryPoint);
            const [isExtensionRendered, setExtensionRendered] = (0, $5uXOq.useState)(false);
            const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
            const extensionId = props.extension?.id;
            const eventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
                module: module,
                entryPoint: entryPoint
            });
            const browserMetricsEventId = (0, (0, parcelRequire("9BrHy")).getBrowserMetricsEventId)({
                module: module,
                entryPoint: entryPoint,
                forgeUiType: (0, (0, parcelRequire("3mOWa")).getForgeUIType)(extension, entryPoint)
            });
            const attributes = (0, $5uXOq.useMemo)(()=>({
                    ...analyticsAttributes,
                    ...(0, (0, parcelRequire("2RhPB")).getAnalyticsAttributesFromExtension)(extension, entryPoint)
                }), [
                analyticsAttributes,
                entryPoint,
                extension.id,
                isCustomUI
            ]);
            (0, $5uXOq.useEffect)(()=>{
                if (!$abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).start({
                    startTime: startTime.current
                });
            }, []);
            const onError = (0, $5uXOq.useCallback)(()=>{
                extensionId && (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).cancel();
            }, [
                extensionId
            ]);
            const onInitialRenderUiKitWithMetrics = (0, $5uXOq.useCallback)((payload)=>{
                onInitialRender && onInitialRender(payload);
                if (payload?.error == null) {
                    const stopTimeDeduction = payload?.appTime || 0;
                    setExtensionRendered(true);
                    extensionId && (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).stop({
                        stopTime: performance.now() - stopTimeDeduction,
                        customData: {
                            eventId: browserMetricsEventId
                        }
                    });
                } else {
                    onError();
                    (0, (0, parcelRequire("dd7Uh")).fireOperationalFailedEvent)({
                        eventId: eventId,
                        attributes: {
                            error: new Error(payload.error),
                            ...attributes
                        }
                    });
                }
            }, [
                onInitialRender,
                extensionId,
                browserMetricsEventId,
                onError,
                eventId,
                attributes
            ]);
            const onLoadCustomUiWithMetrics = (0, $5uXOq.useCallback)(()=>{
                onLoad && onLoad();
                setExtensionRendered(true);
                extensionId && (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now(),
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            }, [
                analyticsAttributes,
                extensionId,
                localId,
                onLoad
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
                eventId: eventId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                ...isCustomUI ? {
                    onLoad: onLoadCustomUiWithMetrics
                } : {
                    onInitialRender: onInitialRenderUiKitWithMetrics
                }
            }), isExtensionRendered && (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$92d758d83665314b, {
                attributes: attributes
            }));
        };
});
parcelRegister("3mOWa", function(module, exports) {
    $parcel$export(module.exports, "getForgeUIType", ()=>$e79bbc527e600bd1$export$aed4d8a86badbf61);
    $parcel$export(module.exports, "isCustomUIExtension", ()=>$e79bbc527e600bd1$export$edb00cfe4962b026);
    $parcel$export(module.exports, "isNativeUiExtension", ()=>$e79bbc527e600bd1$export$2ecba06e617fea0a);
    $parcel$export(module.exports, "overrideExtension", ()=>$e79bbc527e600bd1$export$42b85bc9b386c977);
    var $gccSB = parcelRequire("gccSB");
    var $e5wyW;
    var $4R6GH;
    const $e79bbc527e600bd1$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
        const { render: render, resource: resource } = extension.properties;
        if (entryPoint && extension.properties[entryPoint]) {
            const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
            if (entryPointResource == null) return 'ui-kit';
            if (entryPointRender === 'native') return 'native-ui';
            return 'custom-ui';
        }
        if (resource == null) return 'ui-kit';
        if (render === 'native') return 'native-ui';
        return 'custom-ui';
    };
    const $e79bbc527e600bd1$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
    const $e79bbc527e600bd1$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
    const $e79bbc527e600bd1$var$overrideExtensionV2 = (extension, propsToOverride)=>{
        if (extension == null) return extension;
        if ((0, ($parcel$interopDefault($gccSB)))(propsToOverride)) return extension;
        const { resource: resource } = propsToOverride;
        const extensionCopy = {
            ...extension,
            properties: {
                ...extension.properties
            }
        };
        if (resource != null) extensionCopy.properties.resource = resource;
        return extensionCopy;
    };
    const $e79bbc527e600bd1$var$overrideExtensionV1 = (extension, propsToOverride)=>{
        if (extension == null) return extension;
        if ((0, ($parcel$interopDefault($gccSB)))(propsToOverride)) return extension;
        const { resource: resource, requiresUserConsent: requiresUserConsent } = propsToOverride;
        const extensionCopy = {
            ...extension,
            properties: {
                ...extension.properties
            },
            requiresUserConsent: requiresUserConsent
        };
        if (resource != null) extensionCopy.properties.resource = resource;
        return extensionCopy;
    };
    const $e79bbc527e600bd1$export$42b85bc9b386c977 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $e79bbc527e600bd1$var$overrideExtensionV2, $e79bbc527e600bd1$var$overrideExtensionV1);
});
parcelRegister("eOGyv", function(module, exports) {
    $parcel$export(module.exports, "useHasForgeAccess", ()=>$5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2);
    var $cZpsT;
    const $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2 = ()=>{
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        return !isAnonymous;
    };
});
parcelRegister("isuse", function(module, exports) {
    $parcel$export(module.exports, "MountEvent", ()=>$1df0619a43ad69d9$export$2c6963927dbc68f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    class $1df0619a43ad69d9$var$MountEventComponent extends (0, $5uXOq.Component) {
        componentDidMount() {
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: 'mounted'
            });
            if (this.props.onMount) this.props.onMount(analyticsEvent);
        }
        render() {
            return null;
        }
    }
    const $1df0619a43ad69d9$export$2c6963927dbc68f1 = (0, (0, parcelRequire("cb25w")).default)()($1df0619a43ad69d9$var$MountEventComponent);
});
parcelRegister("dd7Uh", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalFailedEvent", ()=>$7d829a81d29f9e72$export$add44f896fb31ba3);
    var $hBuqR;
    var $8uOa6;
    const $7d829a81d29f9e72$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
        (0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).FAILED, {
            id: eventId,
            attributes: attributes
        });
    };
});
parcelRegister("2RhPB", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsAttributesFromExtension", ()=>$3fba0b567cec1fe0$export$5d3b06ab08af139e);
    var $3mOWa;
    var $e0AC8;
    const $3fba0b567cec1fe0$export$5d3b06ab08af139e = (extension, entryPoint)=>{
        const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
        return {
            appId: appId,
            envId: envId,
            forgeType: (0, (0, parcelRequire("3mOWa")).getForgeUIType)(extension, entryPoint),
            envType: extension?.environmentType
        };
    };
});
parcelRegister("9BrHy", function(module, exports) {
    $parcel$export(module.exports, "getEventId", ()=>$10bc2a9e37d5a5bb$export$5639f6a927500d9);
    $parcel$export(module.exports, "getBrowserMetricsEventId", ()=>$10bc2a9e37d5a5bb$export$25830fc7d037f0f2);
    $parcel$export(module.exports, "getEventActionName", ()=>$10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1);
    var $k2DRb;
    var $6yg2S;
    var $hBuqR;
    const $10bc2a9e37d5a5bb$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
    const $10bc2a9e37d5a5bb$var$prepareModuleMode = (entryPoint)=>`${$10bc2a9e37d5a5bb$var$capitalizeFirstLetter(entryPoint)}`;
    const $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
    const $10bc2a9e37d5a5bb$var$prepareModuleName = (moduleName)=>(0, (0, parcelRequire("k2DRb")).SUPPORTED_MODULES).includes(moduleName) ? $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
    const $10bc2a9e37d5a5bb$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
        const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
        return (0, (0, parcelRequire("6yg2S")).toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
    };
    const $10bc2a9e37d5a5bb$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, (0, parcelRequire("6yg2S")).toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
    const $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3}.${eventId} ${action}`;
});
parcelRegister("bXK4r", function(module, exports) {
    $parcel$export(module.exports, "ViewAnalyticsWrapper", ()=>$488beba58e0bb189$export$c794eb4124961145);
    $parcel$export(module.exports, "TriggerAnalyticsWrapper", ()=>$488beba58e0bb189$export$e1a79e3d472c925a);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2DRb;
    var $1rTGO;
    var $hBuqR;
    const $488beba58e0bb189$export$c794eb4124961145 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            shouldFireInitializedEvent: true,
            ...props
        });
    const $488beba58e0bb189$export$e1a79e3d472c925a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER),
            ...props
        });
});
parcelRegister("k51JQ", function(module, exports) {
    $parcel$export(module.exports, "ForgeSubpagesView", ()=>$b3f0da209e047dcf$export$9711365f685f75c0);
    $parcel$export(module.exports, "ForgeItem", ()=>$b3f0da209e047dcf$export$26a5287439a1d287);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $apKqz;
    var $gjTBi;
    var $gwIPs;
    var $8kVg1;
    var $fl3Yy;
    var $k0ZZ2;
    var $jv9Yy;
    var $8iQMc;
    var $kZj7F;
    var $4OCke;
    const $b3f0da209e047dcf$export$9ffb311b483a1e2b = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
    const $b3f0da209e047dcf$export$f04a61298a47a40f = ({ url: url })=>url != null && String(url).trim().length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$var$ForgeIcon, {
            alt: "",
            src: url
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("apKqz"))))), {
            label: ""
        });
    const $b3f0da209e047dcf$export$df3259e43d89ee7b = (props)=>{
        const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, moduleName: moduleName, overrides: overrides } = props;
        if (overrides?.showSelectedAppMenuOnly) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            iconBefore: showIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
                url: iconUrl
            }) : null,
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fl3Yy")).EnvironmentLozenge), {
                environmentType: environmentType
            }),
            href: url,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchPartialUrlPathname)(),
            analytics: {
                itemId: itemId,
                itemType: 'forge',
                module: moduleName
            },
            onClick: ()=>{
                (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(itemId).start({
                    startTime: performance.now()
                });
            }
        }, (0, (0, parcelRequire("fl3Yy")).nameWithCustomEnvironment)(name, environmentType, environmentKey));
    };
    const $b3f0da209e047dcf$var$nestedHeaderAlignmentFix = ()=>({
            paddingLeft: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2.625}px`
        });
    const $b3f0da209e047dcf$export$961eebe0deda9ad3 = ({ ForgePageHeader: ForgePageHeader = (0, (0, parcelRequire("8iQMc")).ForgePageHeader), iconUrl: iconUrl, name: name, environmentType: environmentType, environmentKey: environmentKey, nestedMenuActive: nestedMenuActive })=>(0, ($parcel$interopDefault($5uXOq))).createElement(ForgePageHeader, {
            avatarUrl: iconUrl || '',
            name: name,
            environmentType: environmentType,
            environmentKey: environmentKey,
            cssFn: typeof nestedMenuActive === 'boolean' && Boolean(nestedMenuActive) ? $b3f0da209e047dcf$var$nestedHeaderAlignmentFix : undefined
        });
    const $b3f0da209e047dcf$export$9711365f685f75c0 = (props)=>{
        const { showIcon: showIcon, id: itemId, url: url, sections: sections, moduleName: moduleName } = props;
        const selectedOn = (0, $5uXOq.useCallback)((route)=>[
                '',
                '/'
            ].includes(String(route || '').trim()) ? (currentLocation, itemLocation)=>currentLocation.pathname.replace(/\/$/, '') === itemLocation.pathname.replace(/\/$/, '') : (0, (0, parcelRequire("4OCke")).matchPartialUrlPathname)(), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$var$ForgeSubpagesContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$961eebe0deda9ad3, props), sections?.map((section, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
                key: index
            }, typeof section.header === 'string' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jv9Yy")).SectionHeader), null, section.header) : null, section.pages.map((page)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                    key: page.route,
                    iconBefore: showIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
                        url: page.icon
                    }) : null,
                    href: $b3f0da209e047dcf$export$9ffb311b483a1e2b(url, page.route),
                    selectedOn: selectedOn(page.route),
                    analytics: {
                        itemId: itemId,
                        itemType: 'forge',
                        module: moduleName
                    },
                    onClick: ()=>{
                        (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(itemId).start({
                            startTime: performance.now()
                        });
                    }
                }, page.title)))));
    };
    const $b3f0da209e047dcf$export$26a5287439a1d287 = (props)=>{
        const { showIcon: showIcon, id: itemId, url: url, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides } = props;
        const selectedOn = (0, $5uXOq.useCallback)((currentLocation)=>currentLocation.pathname.includes(url), [
            url
        ]);
        const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(event);
        }, [
            overrides
        ]);
        if (!sections?.length) return (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$df3259e43d89ee7b, props);
        if (overrides?.showSelectedAppMenuOnly) return (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            analytics: {
                itemId: 'subpages'
            },
            id: `${itemId}-subpages`,
            iconBefore: showIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
                url: iconUrl
            }) : null,
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fl3Yy")).EnvironmentLozenge), {
                environmentType: environmentType
            }),
            title: (0, (0, parcelRequire("fl3Yy")).nameWithCustomEnvironment)(name, environmentType, environmentKey),
            selectedOn: selectedOn,
            onClick: onNestedMenuItemClick,
            overrides: overrides
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props));
    };
    const $b3f0da209e047dcf$var$ForgeSubpagesContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_14tkpxbi _t3zcv47k _1so4jjyb",
                __cmplp.className
            ])
        });
    });
    const $b3f0da209e047dcf$var$ForgeIcon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbgktf _4t3igktf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fl3Yy", function(module, exports) {
    $parcel$export(module.exports, "EnvironmentLozenge", ()=>$730173a4987fa3e4$export$278f8e01799d0418);
    $parcel$export(module.exports, "nameWithCustomEnvironment", ()=>$730173a4987fa3e4$export$f9338c21ba7c7334);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $k2DRb;
    var $ousew;
    var $8Je4V;
    const $730173a4987fa3e4$export$50589a87e4fb3dae = (environmentType)=>{
        switch(environmentType){
            case 0, (0, parcelRequire("k2DRb")).DEVELOPMENT_ENVIRONMENT:
                return (0, (0, parcelRequire("8Je4V")).messages).developmentEnvironmentLozenge;
            case 0, (0, parcelRequire("k2DRb")).STAGING_ENVIRONMENT:
                return (0, (0, parcelRequire("8Je4V")).messages).stagingEnvironmentLozenge;
            default:
                return null;
        }
    };
    const $730173a4987fa3e4$export$278f8e01799d0418 = (props)=>{
        const { environmentType: environmentType } = props;
        const labelKey = $730173a4987fa3e4$export$50589a87e4fb3dae(environmentType);
        return labelKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
            appearance: environmentType === (0, (0, parcelRequire("k2DRb")).DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), labelKey)) : null;
    };
    const $730173a4987fa3e4$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
        if (environmentType === (0, (0, parcelRequire("k2DRb")).DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, (0, parcelRequire("k2DRb")).DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
        return name;
    };
});
parcelRegister("8Je4V", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$838ac71f7259b5ef$export$defe85febe8b728c);
    var $7VHMR;
    const $838ac71f7259b5ef$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        developmentEnvironmentLozenge: {
            "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
            "defaultMessage": "DEV"
        },
        stagingEnvironmentLozenge: {
            "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
            "defaultMessage": "STG"
        }
    });
});
parcelRegister("jv9Yy", function(module, exports) {
    $parcel$export(module.exports, "SectionHeader", ()=>$c634a42deba697de$export$8adb256d999cd5a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2V4l;
    var $fpoBX;
    var $2WgzA;
    const $c634a42deba697de$export$8adb256d999cd5a0 = ({ children: children })=>{
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const cssFn = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("2WgzA")).generateCustomThemeCssFn)(theme), [
            theme
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2V4l")).default), {
            cssFn: cssFn
        }, children);
    };
});
parcelRegister("c2V4l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6289355db2eea81d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4mNf3;
    var $jsTfk;
    var $j9VTE;
    const $6289355db2eea81d$var$HeadingItem = (props)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        if (!shouldRender) return null;
        const cssFn = (0, (0, parcelRequire("jsTfk")).overrideStyleFunction)((0, (0, parcelRequire("jsTfk")).sectionHeaderSpacingStyles), props.cssFn);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4mNf3")).default), {
            ...props,
            cssFn: cssFn
        });
    };
    var $6289355db2eea81d$export$2e2bcd8739ae039 = $6289355db2eea81d$var$HeadingItem;
});
parcelRegister("2WgzA", function(module, exports) {
    $parcel$export(module.exports, "generateCustomThemeCssFn", ()=>$e23e3f934bc5813e$export$5ae7d20da3003de);
    var $1UikQ = parcelRequire("1UikQ");
    var $ai0LF;
    const $e23e3f934bc5813e$export$5ae7d20da3003de = (theme)=>(0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
            if (theme?.navigation) {
                const { navigation: { item: item } } = theme;
                const themeStyles = {
                    color: item?.color?.default,
                    opacity: item?.opacity
                };
                return (0, ($parcel$interopDefault($1UikQ)))(currentStyles, themeStyles);
            }
            return currentStyles;
        });
});
parcelRegister("8iQMc", function(module, exports) {
    $parcel$export(module.exports, "ForgePageHeader", ()=>$5bbfd34eb4e2a6d6$export$a4f83f6df17decd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $ujWmd;
    var $apKqz;
    var $juVrZ;
    var $fl3Yy;
    var $fpoBX;
    var $2gYaQ;
    var $146Nh;
    const $5bbfd34eb4e2a6d6$export$a4f83f6df17decd4 = ({ Avatar: Avatar = (0, (0, parcelRequire("ujWmd")).default), AddonIcon: AddonIcon = (0, ($parcel$interopDefault((0, parcelRequire("apKqz"))))), CssFixContainer: CssFixContainer = (0, (0, parcelRequire("146Nh")).CssFixContainerDI), Header: Header = (0, (0, parcelRequire("juVrZ")).default), cssFn: cssFn, EnvironmentLozenge: EnvironmentLozenge = (0, (0, parcelRequire("fl3Yy")).EnvironmentLozenge), avatarUrl: avatarUrl, environmentType: environmentType, environmentKey: environmentKey, name: name })=>{
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const headerCssFn = (0, $5uXOq.useMemo)(()=>cssFn ? (0, ($parcel$interopDefault($basmW)))([
                cssFn,
                (0, (0, parcelRequire("2gYaQ")).generateCustomThemeCssFn)(theme)
            ]) : (0, (0, parcelRequire("2gYaQ")).generateCustomThemeCssFn)(theme), [
            cssFn,
            theme
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(CssFixContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Header, {
            cssFn: headerCssFn,
            iconBefore: avatarUrl?.length ? (0, ($parcel$interopDefault($5uXOq))).createElement(Avatar, {
                appearance: "square",
                borderColor: "transparent",
                size: "small",
                src: `${avatarUrl}?size=xxlarge`
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(AddonIcon, {
                label: "",
                size: "medium"
            }),
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement(EnvironmentLozenge, {
                environmentType: environmentType
            })
        }, (0, (0, parcelRequire("fl3Yy")).nameWithCustomEnvironment)(name, environmentType, environmentKey)));
    };
});
parcelRegister("2gYaQ", function(module, exports) {
    $parcel$export(module.exports, "generateCustomThemeCssFn", ()=>$8e94d1e3a18b3b00$export$5ae7d20da3003de);
    var $1UikQ = parcelRequire("1UikQ");
    var $ai0LF;
    const $8e94d1e3a18b3b00$export$5ae7d20da3003de = (theme)=>(0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
            if (theme?.navigation) {
                const { navigation: { item: item } } = theme;
                const themeStyles = {
                    backgroundColor: item?.background?.default ?? undefined,
                    color: item?.color?.default ?? undefined,
                    '[data-item-title]': {
                        color: item?.color?.default ?? undefined
                    },
                    '[data-item-description]': {
                        color: item?.color?.default ?? undefined
                    }
                };
                return (0, ($parcel$interopDefault($1UikQ)))(currentStyles, themeStyles);
            }
            return currentStyles;
        });
});
parcelRegister("146Nh", function(module, exports) {
    $parcel$export(module.exports, "CssFixContainerDI", ()=>$839ef628ec3ac6e5$export$eee12c3955319ddc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $839ef628ec3ac6e5$export$eee12c3955319ddc = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1lfu1kw7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kBPYs", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$3e1e8355c24b18f2$export$defe85febe8b728c);
    var $7VHMR;
    const $3e1e8355c24b18f2$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        forgeSectionTitle: {
            "id": "navigation-apps-sidebar-forge.project-section.forge-section-title",
            "defaultMessage": "Apps"
        }
    });
});
parcelRegister("boE05", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8fbdf556ad4d3a9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9btdk;
    var $gjTBi;
    var $6s1PB;
    var $koVbs;
    var $juTur;
    var $jsI7v;
    var $8yg0C;
    var $k6yFu;
    const $e8fbdf556ad4d3a9$var$EMPTY_STACK = [];
    const $e8fbdf556ad4d3a9$var$IssuesMenu = ({ project: project })=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9btdk")).default), {
            initialStack: $e8fbdf556ad4d3a9$var$EMPTY_STACK
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).IssuesContextualAnalyticsData), {
            navigatorScope: "project"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jsI7v")).Issues), {
            projectKey: project.key,
            pinUrl: `/jira/core/projects/${project.key}/issues/?filter=`,
            titleHeaderText: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("k6yFu")).default).issuesIssueTermRefresh : (0, (0, parcelRequire("k6yFu")).default).issues)
        }))));
    };
    var $e8fbdf556ad4d3a9$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($e8fbdf556ad4d3a9$var$IssuesMenu);
});
parcelRegister("jsI7v", function(module, exports) {
    $parcel$export(module.exports, "Issues", ()=>$e89a82dba74cf1ac$export$1cb51167b20548a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bWqXX;
    var $7CMCs;
    var $iL2Ly;
    var $6KxGW;
    var $8kM72;
    var $5w5Kh;
    var $hnmuM;
    const $e89a82dba74cf1ac$export$1cb51167b20548a0 = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
        const { data: features } = (0, (0, parcelRequire("8kM72")).useDefaultPinFilters)();
        if (features === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        const hasFilters = features.hasAllIssues || features.hasMyOpenIssues;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($e89a82dba74cf1ac$var$CompiledWrapper, {
            renderDividerBefore: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5w5Kh")).DefaultFilters), {
            pinUrl: pinUrl,
            projectKey: projectKey,
            features: features,
            titleHeaderText: titleHeaderText
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            packageName: "jira-navigation-apps-sidebar-common",
            id: "issues.starred-filters-section",
            fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6KxGW")).StarredFiltersErrorFallback), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e89a82dba74cf1ac$var$CompiledWrapper, {
            renderDividerAfter: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iL2Ly")).StarredFiltersContainer), {
            pinUrl: pinUrl,
            projectKey: projectKey
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement($e89a82dba74cf1ac$var$CompiledWrapper, {
            renderDividerBefore: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hnmuM")).FiltersFooter), {
            hasFilters: hasFilters
        })));
    };
    const $e89a82dba74cf1ac$var$CompiledWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { renderDividerBefore: renderDividerBefore, renderDividerAfter: renderDividerAfter, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1xlv12x7 _1rqn1fxt",
                __cmplp.renderDividerBefore && "_175u1crf",
                __cmplp.renderDividerAfter && "_1we51crf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iL2Ly", function(module, exports) {
    $parcel$export(module.exports, "StarredFiltersContainer", ()=>$1ec2742e0426c5a8$export$f5b4503a4a7ca418);
    var $59JDz;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $bWqXX;
    var $VILOn;
    var $a3OKn;
    var $lfTZh;
    var $ao2h1;
    var $59JDz;
    var $bATyw;
    var $koeKL;
    var $2YP9W;
    var $aV2yn;
    var $8Jljs;
    const $1ec2742e0426c5a8$export$3be6ba2fb4838e7e = ({ onFavouritesChanged: onFavouritesChanged, queryReference: queryReference, projectKey: projectKey, pinUrl: pinUrl })=>{
        const [localStorageData] = (0, $5uXOq.useState)((0, (0, parcelRequire("VILOn")).getIsGlobalScopeEnrolmentEnabledFromLocalStorage)());
        const { data: resourceData } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource));
        let isNinGlobalScopeEnrolmentEnabled;
        if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = !!localStorageData;
        else isNinGlobalScopeEnrolmentEnabled = !!resourceData;
        const baseHref = (0, (0, parcelRequire("aV2yn")).getStarredFilterLink)({
            projectKey: projectKey,
            pinUrl: pinUrl,
            shouldStayProjectScope: isNinGlobalScopeEnrolmentEnabled
        });
        const data = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("59JDz")).default), queryReference);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Jljs")).StarredFiltersList), {
            baseHref: baseHref,
            jiraQuery: data.jira,
            onFavouritesChanged: onFavouritesChanged
        });
    };
    const $1ec2742e0426c5a8$export$f5b4503a4a7ca418 = ({ projectKey: projectKey, pinUrl: pinUrl })=>{
        const { queryReference: resourceQueryRef } = (0, (0, parcelRequire("ao2h1")).useRelayResource)((0, (0, parcelRequire("a3OKn")).sidebarProjectIssuesResource));
        const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("59JDz")).default), resourceQueryRef);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const loadSidebarData = (0, $5uXOq.useCallback)(()=>{
            loadQuery({
                cloudId: cloudId
            }, {
                fetchPolicy: 'store-and-network'
            });
        }, [
            cloudId,
            loadQuery
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!queryReference) loadSidebarData();
        }, [
            loadSidebarData,
            queryReference
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "starred-filters",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null)
        }, queryReference ? (0, ($parcel$interopDefault($5uXOq))).createElement($1ec2742e0426c5a8$export$3be6ba2fb4838e7e, {
            queryReference: queryReference,
            onFavouritesChanged: loadSidebarData,
            pinUrl: pinUrl,
            projectKey: projectKey
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null));
    };
});
parcelRegister("aV2yn", function(module, exports) {
    $parcel$export(module.exports, "getStarredFilterLink", ()=>$a754d4f1af7bcc7d$export$7082c02465d0ecd4);
    const $a754d4f1af7bcc7d$export$7082c02465d0ecd4 = ({ projectKey: projectKey, pinUrl: pinUrl, shouldStayProjectScope: shouldStayProjectScope })=>{
        if (!projectKey) throw new Error(`Expected projectKey to be a valid string, got: ${projectKey}`);
        const craftedPinUrl = !pinUrl ? `/projects/${projectKey}/issues` : pinUrl.replace(/\?.*$/, '');
        return shouldStayProjectScope ? craftedPinUrl : '/issues/';
    };
});
parcelRegister("8Jljs", function(module, exports) {
    $parcel$export(module.exports, "StarredFiltersList", ()=>$0208f837fc89d8ec$export$b7f4b26a8737eee0);
    var $47bDC = parcelRequire("47bDC");
    var $jUReQ;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $gjTBi;
    var $koVbs;
    var $b2GBS;
    var $kZDjT;
    var $4ABV3;
    var $0208f837fc89d8ec$var$_StyledSection = (0, $47bDC.default)((0, (0, parcelRequire("gjTBi")).default)).withConfig({
        componentId: "sc-8ugvpc-0"
    })`${(p)=>p._css}`;
    const $0208f837fc89d8ec$export$b7f4b26a8737eee0 = ({ baseHref: baseHref, jiraQuery: jiraQuery, onFavouritesChanged: onFavouritesChanged, sectionCustomCss: sectionCustomCss })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("jUReQ")).default), jiraQuery);
        (0, (0, parcelRequire("b2GBS")).useFavoritesChangeEffect)('filters', (hasPendingChanges, previousHasPendingChanges)=>{
            if (previousHasPendingChanges && !hasPendingChanges) onFavouritesChanged();
        });
        const starredFilterEdges = data.favouriteFilters?.edges || [];
        if (!starredFilterEdges.length) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0208f837fc89d8ec$var$_StyledSection, {
            title: formatMessage((0, (0, parcelRequire("4ABV3")).messages).newStarredFiltersHeader),
            _css: sectionCustomCss
        }, starredFilterEdges.map((edge)=>edge?.node ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZDjT")).FilterItem), {
                key: edge.node.filterId,
                baseHref: baseHref,
                filter: edge.node,
                customAnalytics: {
                    isStarred: true
                }
            }) : null));
    };
});
parcelRegister("jUReQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9363fe5268fd6910$export$2e2bcd8739ae039);
    const $9363fe5268fd6910$var$node = {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "starredFiltersList_navigationAppsSidebarCommon",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "JiraFilterConnection",
                "kind": "LinkedField",
                "name": "favouriteFilters",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFilterEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "filterId"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "filterItem_navigationAppsSidebarCommon"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
    $9363fe5268fd6910$var$node.hash = "a0c4e11d2fa2d823ad4cac3d7e350cb3";
    var $9363fe5268fd6910$export$2e2bcd8739ae039 = $9363fe5268fd6910$var$node;
});
parcelRegister("b2GBS", function(module, exports) {
    $parcel$export(module.exports, "useFavoritesChangeEffect", ()=>$0fca8b6d7b43f931$export$659f59218fc5dd14);
    var $5uXOq = parcelRequire("5uXOq");
    var $4f8Oj = parcelRequire("4f8Oj");
    var $4041n;
    var $1XJ20;
    const $0fca8b6d7b43f931$export$659f59218fc5dd14 = (type, effect)=>{
        const { items: items } = (0, $5uXOq.useContext)((0, (0, parcelRequire("4041n")).FavoriteChangeContext));
        const typeItems = items[type];
        const pendingChanges = (0, ($parcel$interopDefault($4f8Oj)))(typeItems, (item)=>item.pending);
        const hasPendingChanges = Boolean(Object.keys(pendingChanges).length);
        const previousHasPendingChanges = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(hasPendingChanges);
        (0, $5uXOq.useEffect)(()=>{
            effect(hasPendingChanges, previousHasPendingChanges);
        }, [
            effect,
            hasPendingChanges,
            previousHasPendingChanges
        ]);
    };
});
parcelRegister("1XJ20", function(module, exports) {
    $parcel$export(module.exports, "usePrevious", ()=>$011794d66b906d20$export$5cae361ad82dce8b);
    $parcel$export(module.exports, "usePreviousWithInitial", ()=>$011794d66b906d20$export$23fbbb2e62c4a911);
    var $5uXOq = parcelRequire("5uXOq");
    const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
        const ref = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
        const ref = (0, $5uXOq.useRef)(value);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
});
parcelRegister("kZDjT", function(module, exports) {
    $parcel$export(module.exports, "FilterItem", ()=>$f981c975abc56594$export$3cf161fcd24b6b4f);
    var $lE53e;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $k0ZZ2;
    const $f981c975abc56594$var$selectedOn = (currentLocation, itemLocation)=>itemLocation.query.filter === (currentLocation.query.filterId || currentLocation.query.filter);
    const $f981c975abc56594$export$3cf161fcd24b6b4f = ({ baseHref: baseHref, filter: filter, customAnalytics: customAnalytics })=>{
        const { filterId: filterId, name: name } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("lE53e")).default), filter);
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                ...customAnalytics || {},
                itemId: `filter-${filterId}`
            }), [
            customAnalytics,
            filterId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            key: filterId,
            analytics: analyticsAttributes,
            selectedOn: $f981c975abc56594$var$selectedOn,
            href: `${baseHref}?filter=${filterId}`
        }, name);
    };
});
parcelRegister("lE53e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$251d70d9349441ea$export$2e2bcd8739ae039);
    const $251d70d9349441ea$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "filterItem_navigationAppsSidebarCommon",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "filterId"
            },
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            {
                "kind": "ScalarField",
                "name": "jql"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    }
                ],
                "type": "JiraCustomFilter"
            }
        ],
        "type": "JiraFilter",
        "abstractKey": "__isJiraFilter"
    };
    $251d70d9349441ea$var$node.hash = "31464d108113d7084e471c226c3fe0aa";
    var $251d70d9349441ea$export$2e2bcd8739ae039 = $251d70d9349441ea$var$node;
});
parcelRegister("4ABV3", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f94c0f775539d45d$export$defe85febe8b728c);
    var $7VHMR;
    const $f94c0f775539d45d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        newStarredFiltersHeader: {
            "id": "spa-apps-sidebar-common.common.starred-filters-list.new-starred-filters-header",
            "defaultMessage": "Starred filters"
        }
    });
});
parcelRegister("6KxGW", function(module, exports) {
    $parcel$export(module.exports, "StarredFiltersErrorFallback", ()=>$48c59f757828f109$export$70765d6359132b82);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $92Z2l;
    var $gjTBi;
    var $koVbs;
    var $b1xML;
    const $48c59f757828f109$export$70765d6359132b82 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($48c59f757828f109$var$SectionWrapper, {
            title: formatMessage((0, (0, parcelRequire("b1xML")).default).starredFiltersHeader)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "warning"
        }, formatMessage((0, (0, parcelRequire("b1xML")).default).errorMessage, {
            link: (linkText)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "link",
                    spacing: "none",
                    onClick: ()=>window.location.reload()
                }, linkText)
        })));
    };
    const $48c59f757828f109$var$SectionWrapper = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("gjTBi")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt3i2wt _euf41fxt _1qdg1crf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("92Z2l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a97355a0cc6aeb06$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $l1N8i;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $3HeRx;
    const $a97355a0cc6aeb06$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordBreak: 'break-word',
        borderRadius: 'border.radius'
    });
    const $a97355a0cc6aeb06$var$bleedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginBlock: 'space.negative.025'
    });
    const $a97355a0cc6aeb06$var$contentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        font: 'font.body'
    });
    const $a97355a0cc6aeb06$var$SectionMessage = (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
        const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, (0, parcelRequire("3HeRx")).getAppearanceIconStyles)(appearance, icon);
        const actionElements = actions && actions.type === (0, ($parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
        const actionsArray = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "section",
            backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
            padding: "space.200",
            testId: testId,
            ref: ref,
            xcss: $a97355a0cc6aeb06$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.200",
            alignBlock: "stretch"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $a97355a0cc6aeb06$var$bleedStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
            size: "medium",
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            LEGACY_size: "medium",
            color: primaryColor,
            spacing: "spacious"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            testId: testId && `${testId}--content`
        }, !!title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            as: "h2",
            size: "small"
        }, title), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $a97355a0cc6aeb06$var$contentStyles
        }, children), actionsArray.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            shouldWrap: true,
            testId: testId && `${testId}--actions`,
            separator: "\xb7",
            space: "space.100",
            rowSpace: "space.0",
            role: "list"
        }, actionsArray.map((action, id)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                role: "listitem",
                key: id
            }, action))))));
    });
    const $a97355a0cc6aeb06$var$appearanceMap = {
        information: 'color.background.information',
        warning: 'color.background.warning',
        error: 'color.background.danger',
        success: 'color.background.success',
        discovery: 'color.background.discovery'
    };
    $a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
    var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;
});
parcelRegister("3HeRx", function(module, exports) {
    $parcel$export(module.exports, "getAppearanceIconStyles", ()=>$d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);
    var $5uXOq = parcelRequire("5uXOq");
    var $btivG;
    var $7nnPp;
    var $2hXfb;
    var $eJS47;
    var $gtreQ;
    const $d1d7dced94bb00f5$export$faa35441caff5bb6 = {
        information: {
            backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("2hXfb"))))),
            primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
        },
        warning: {
            backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))),
            primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
        },
        error: {
            backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))),
            primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
        },
        success: {
            backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("btivG"))))),
            primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
        },
        discovery: {
            backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))),
            primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
        }
    };
    function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
        const appearanceIconStyles = $d1d7dced94bb00f5$export$faa35441caff5bb6[appearance] || $d1d7dced94bb00f5$export$faa35441caff5bb6.information;
        const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>(0, ($parcel$interopDefault($5uXOq))).createElement(appearanceIconStyles.Icon, {
                size: size,
                primaryColor: primaryColor,
                secondaryColor: secondaryColor,
                label: appearance
            });
        const Icon = icon || AppearanceIcon;
        return {
            ...appearanceIconStyles,
            Icon: Icon
        };
    }
});
parcelRegister("btivG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $85a0c2d39fdb2976$var$_react = $85a0c2d39fdb2976$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $85a0c2d39fdb2976$var$_success = $85a0c2d39fdb2976$var$_interopRequireDefault((parcelRequire("b0JGA")));
    function $85a0c2d39fdb2976$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $85a0c2d39fdb2976$var$CheckCircleIcon = (props)=>$85a0c2d39fdb2976$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $85a0c2d39fdb2976$var$_success.default
        }));
    $85a0c2d39fdb2976$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
    var $85a0c2d39fdb2976$var$_default = module.exports.default = $85a0c2d39fdb2976$var$CheckCircleIcon;
});
parcelRegister("b0JGA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8043220a46fa3485$var$_react = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8043220a46fa3485$var$_baseNew = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8043220a46fa3485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8043220a46fa3485$var$SuccessIcon = (props)=>$8043220a46fa3485$var$_react.default.createElement($8043220a46fa3485$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $8043220a46fa3485$var$SuccessIcon.displayName = 'SuccessIcon';
    var $8043220a46fa3485$var$_default = module.exports.default = $8043220a46fa3485$var$SuccessIcon;
});
parcelRegister("b1xML", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc624d55e9cb181d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dc624d55e9cb181d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorMessage: {
            "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.error-message",
            "defaultMessage": "We couldn't load your starred filters. <link>Refresh the page</link> to try again."
        },
        starredFiltersHeader: {
            "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.starred-filters-header",
            "defaultMessage": "Starred filters"
        }
    });
});
parcelRegister("8kM72", function(module, exports) {
    $parcel$export(module.exports, "useDefaultPinFilters", ()=>$42363ac07745a31e$export$3c69152f8409a017);
    var $5uXOq = parcelRequire("5uXOq");
    var $1b36n;
    var $2YP9W;
    const $42363ac07745a31e$export$3c69152f8409a017 = ()=>{
        const { data: data, loading: loading, refresh: refresh, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("1b36n")).staticSidebarDefaultPINFiltersResource));
        (0, $5uXOq.useEffect)(()=>{
            if (data == null && error == null && loading === false) refresh();
        }, [
            data,
            error,
            loading,
            refresh
        ]);
        return {
            data: data,
            loading: loading
        };
    };
});
parcelRegister("5w5Kh", function(module, exports) {
    $parcel$export(module.exports, "DefaultFilters", ()=>$68067cb39e642d05$export$5df36bcfaa4d1f9d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $gjTBi;
    var $6s1PB;
    var $koVbs;
    var $doZTA;
    var $k0ZZ2;
    var $4OCke;
    var $irHAa;
    var $2q4IS;
    const $68067cb39e642d05$export$5df36bcfaa4d1f9d = ({ features: features, projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ match: match, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { jql: jql } = (0, $ebyGx.parse)(location.search, {
            arrayFormat: 'comma'
        });
        const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
        const shouldUseNinLayout = !isOnLegacyPinRoute;
        const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
        const title = isOnLegacyPinRoute || titleHeaderText == null ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).issuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).issues) : titleHeaderText;
        const allOpenIssuesSelector = !shouldUseNinLayout ? (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, (0, parcelRequire("4OCke")).matchUrlParams)([
            'filter'
        ], false);
        const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            title: title
        }, shouldUseNinLayout && features.hasAllIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).ninLayoutAllIssues.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).ninLayoutAllIssues.selectedOn(jql),
            href: `${pinUrlPrefix}allissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).allIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).allIssues)), features.hasMyOpenIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).myOpenIssues.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).myOpenIssues.selectedOn(jql),
            href: `${pinUrlPrefix}myopenissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).myOpenIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).myOpenIssues)), features.hasReportedByMe && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).reportedByMe.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).reportedByMe.selectedOn(jql),
            href: `${pinUrlPrefix}reportedbyme`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).notNinLayoutAllIssues.analytics,
            selectedOn: (0, (0, parcelRequire("2q4IS")).itemMap).notNinLayoutAllIssues.selectedOn(jql),
            href: `${pinUrlPrefix}allissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).allIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).allIssues)), features.hasAllOpenIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).allOpenIssues.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).allOpenIssues.selectedOn(jql, allOpenIssuesSelector),
            href: `${pinUrlPrefix}allopenissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).allOpenIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).allOpenIssues)), features.hasDoneIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).doneIssues.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).doneIssues.selectedOn(jql),
            href: `${pinUrlPrefix}doneissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).doneIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).doneIssues)), features.hasViewedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).viewedRecently.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).viewedRecently.selectedOn(jql),
            href: `${pinUrlPrefix}recentlyviewed`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).createdRecently.analytics,
            selectedOn: (0, (0, parcelRequire("2q4IS")).itemMap).createdRecently.selectedOn(jql),
            href: `${pinUrlPrefix}addedrecently`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).createdRecently)), features.hasResolvedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).resolvedRecently.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).resolvedRecently.selectedOn(jql),
            href: `${pinUrlPrefix}resolvedrecently`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).resolvedRecently)), features.hasUpdatedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).updatedRecently.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).updatedRecently.selectedOn(jql),
            href: `${pinUrlPrefix}updatedrecently`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).updatedRecently)));
    };
});
parcelRegister("irHAa", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$87feacba5b057fbf$export$defe85febe8b728c);
    var $7VHMR;
    const $87feacba5b057fbf$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.issues",
            "defaultMessage": "Issues and filters"
        },
        issuesFilters: {
            "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters",
            "defaultMessage": "Issues and Filters"
        },
        myOpenIssues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues",
            "defaultMessage": "My open issues"
        },
        reportedByMe: {
            "id": "spa-apps-sidebar-common.issues.default-filters.reported-by-me",
            "defaultMessage": "Reported by me"
        },
        allIssues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.all-issues",
            "defaultMessage": "All issues"
        },
        allOpenIssues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues",
            "defaultMessage": "Open issues"
        },
        doneIssues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.done-issues",
            "defaultMessage": "Done issues"
        },
        viewedRecently: {
            "id": "spa-apps-sidebar-common.issues.default-filters.viewed-recently",
            "defaultMessage": "Viewed recently"
        },
        createdRecently: {
            "id": "spa-apps-sidebar-common.issues.default-filters.created-recently",
            "defaultMessage": "Created recently"
        },
        resolvedRecently: {
            "id": "spa-apps-sidebar-common.issues.default-filters.resolved-recently",
            "defaultMessage": "Resolved recently"
        },
        updatedRecently: {
            "id": "spa-apps-sidebar-common.issues.default-filters.updated-recently",
            "defaultMessage": "Updated recently"
        },
        issuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.issues-issue-term-refresh",
            "defaultMessage": "Work items and filters"
        },
        issuesFiltersIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters-issue-term-refresh",
            "defaultMessage": "Work items and filters"
        },
        myOpenIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues-issue-term-refresh",
            "defaultMessage": "My open work items"
        },
        allIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.all-issues-issue-term-refresh",
            "defaultMessage": "All work items"
        },
        allOpenIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues-issue-term-refresh",
            "defaultMessage": "Open work items"
        },
        doneIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.done-issues-issue-term-refresh",
            "defaultMessage": "Done work items"
        }
    });
});
parcelRegister("2q4IS", function(module, exports) {
    $parcel$export(module.exports, "itemMap", ()=>$414ee2dbecb9ba58$export$1072457701b9918d);
    var $kvHKs;
    var $4OCke;
    const $414ee2dbecb9ba58$export$1596c397510d46b1 = (filter, jql)=>{
        if ((typeof filter === 'undefined' || !filter.length) && typeof jql === 'undefined') return true;
        if (filter != null && filter !== 'allissues') return false;
        if (typeof jql === 'string' && jql.match(/^project = ".*" ORDER BY created (?:DESC|ASC)$/)) return true;
        return false;
    };
    const $414ee2dbecb9ba58$export$1072457701b9918d = {
        ninLayoutAllIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
            },
            selectedOn: (jql)=>(...args)=>$414ee2dbecb9ba58$export$1596c397510d46b1(undefined, '') || (!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                        'filter'
                    ], false)(...args) : false)
        },
        myOpenIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        reportedByMe: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        notNinLayoutAllIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        allOpenIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
            },
            selectedOn: (jql, allOpenIssuesSelector)=>!jql && allOpenIssuesSelector ? allOpenIssuesSelector : ()=>false
        },
        doneIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        viewedRecently: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        createdRecently: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        resolvedRecently: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        updatedRecently: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        }
    };
});
parcelRegister("hnmuM", function(module, exports) {
    $parcel$export(module.exports, "FiltersFooter", ()=>$ca4a87e5b79a11b5$export$c131ccfc44bcd85c);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $koVbs;
    var $k0ZZ2;
    var $fcEY2;
    const $ca4a87e5b79a11b5$var$analyticsPayload = {
        itemId: 'pin-manage-filters'
    };
    const $ca4a87e5b79a11b5$export$c131ccfc44bcd85c = ({ hasFilters: hasFilters })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: hasFilters
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: $ca4a87e5b79a11b5$var$analyticsPayload,
            href: "/jira/filters"
        }, formatMessage((0, (0, parcelRequire("fcEY2")).messages).viewAllFilters)));
    };
});
parcelRegister("fcEY2", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$905189d98c72b841$export$defe85febe8b728c);
    var $7VHMR;
    const $905189d98c72b841$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewAllFilters: {
            "id": "spa-apps-sidebar-common.issues.filters-footer.view-all-filters",
            "defaultMessage": "View all filters"
        }
    });
});
parcelRegister("k6yFu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$073d14daf21d9ee8$export$2e2bcd8739ae039);
    var $7VHMR;
    const $073d14daf21d9ee8$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issues: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.issues-menu.issues",
            "defaultMessage": "Issues"
        },
        issuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.issues-menu.issues-issue-term-refresh",
            "defaultMessage": "Work items"
        }
    });
    var $073d14daf21d9ee8$export$2e2bcd8739ae039 = $073d14daf21d9ee8$var$messages;
});
parcelRegister("chejP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5de49251f2394688$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9btdk;
    var $gjTBi;
    var $k0iPT;
    var $6jY6G;
    var $gb5lQ;
    var $8yg0C;
    var $lPApw;
    var $jxrFe;
    const $5de49251f2394688$var$calculateStack = (route, connectStack)=>{
        if ((0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(route.name) && connectStack) {
            const [first, ...other] = connectStack;
            if ((0, (0, parcelRequire("gb5lQ")).SECTION_ID).REPORTS === first) return other;
            return connectStack;
        }
        return [];
    };
    const $5de49251f2394688$var$ReportsMenu = ()=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: connectItems, stack: connectStack } = (0, (0, parcelRequire("lPApw")).useProjectReportsConnectItems)();
        const [stack, setStack] = (0, $5uXOq.useState)(()=>$5de49251f2394688$var$calculateStack(route, connectStack));
        (0, $5uXOq.useEffect)(()=>{
            setStack($5de49251f2394688$var$calculateStack(route, connectStack));
        }, [
            route,
            connectStack
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9btdk")).default), {
            stack: stack,
            onChange: setStack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jxrFe")).Reports), {
            connectItems: connectItems
        })));
    };
    var $5de49251f2394688$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5de49251f2394688$var$ReportsMenu);
});
parcelRegister("jxrFe", function(module, exports) {
    $parcel$export(module.exports, "Reports", ()=>$345de988b64525a0$export$883262dc952d8f59);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $6s1PB;
    var $koVbs;
    var $k0ZZ2;
    var $jv9Yy;
    var $lpwtK;
    var $7OqB4;
    var $4OCke;
    var $3tHFY;
    var $9h6Pc;
    var $eA5Jb;
    var $cnn8W;
    var $bkw8F;
    var $9GoDt;
    const $345de988b64525a0$var$useThrowDefaultReportItemsDI = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("eA5Jb")).useDefaultReportItems));
    const $345de988b64525a0$var$useThrowProjectDI = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $345de988b64525a0$var$useThrowReportFeaturesDI = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("bkw8F")).useReportFeatures));
    const $345de988b64525a0$export$883262dc952d8f59 = ({ ConnectMenu: ConnectMenu = (0, (0, parcelRequire("3tHFY")).ConnectMenu), MenuItem: MenuItem = (0, (0, parcelRequire("k0ZZ2")).MenuItem), Section: Section = (0, (0, parcelRequire("gjTBi")).default), SkeletonItem: SkeletonItem = (0, (0, parcelRequire("bWqXX")).default), connectItems: connectItems, SectionHeader: SectionHeader = (0, (0, parcelRequire("jv9Yy")).SectionHeader), matchUrlParams: matchUrlParams = (0, (0, parcelRequire("4OCke")).matchUrlParams), useDefaultReportItems: useDefaultReportItems = $345de988b64525a0$var$useThrowDefaultReportItemsDI, useIntl: useIntl = (0, (0, parcelRequire("koVbs")).default), useProject: useProject = $345de988b64525a0$var$useThrowProjectDI, useReportFeatures: useReportFeatures = $345de988b64525a0$var$useThrowReportFeaturesDI })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("6s1PB")).expVal)('jira-reports-terminology-refresh-experiment', 'isEnabled', false) ? (0, ($parcel$interopDefault($5uXOq))).createElement($345de988b64525a0$var$ReportsTerminologyRefreshExperimentSidebar, {
            ConnectMenu: ConnectMenu,
            MenuItem: MenuItem,
            Section: Section,
            SkeletonItem: SkeletonItem,
            connectItems: connectItems,
            SectionHeader: SectionHeader,
            matchUrlParams: matchUrlParams,
            useDefaultReportItems: useDefaultReportItems,
            useIntl: useIntl,
            useProject: useProject,
            useReportFeatures: useReportFeatures
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($345de988b64525a0$var$ReportsSidebar, {
            ConnectMenu: ConnectMenu,
            MenuItem: MenuItem,
            Section: Section,
            SkeletonItem: SkeletonItem,
            connectItems: connectItems,
            SectionHeader: SectionHeader,
            matchUrlParams: matchUrlParams,
            useDefaultReportItems: useDefaultReportItems,
            useIntl: useIntl,
            useProject: useProject,
            useReportFeatures: useReportFeatures
        }));
    };
    const $345de988b64525a0$var$ReportsSidebar = ({ ConnectMenu: ConnectMenu = (0, (0, parcelRequire("3tHFY")).ConnectMenu), MenuItem: MenuItem = (0, (0, parcelRequire("k0ZZ2")).MenuItem), Section: Section = (0, (0, parcelRequire("gjTBi")).default), SkeletonItem: SkeletonItem = (0, (0, parcelRequire("bWqXX")).default), connectItems: connectItems, SectionHeader: SectionHeader = (0, (0, parcelRequire("jv9Yy")).SectionHeader), matchUrlParams: matchUrlParams = (0, (0, parcelRequire("4OCke")).matchUrlParams), useDefaultReportItems: useDefaultReportItems = $345de988b64525a0$var$useThrowDefaultReportItemsDI, useIntl: useIntl = (0, (0, parcelRequire("koVbs")).default), useProject: useProject = $345de988b64525a0$var$useThrowProjectDI, useReportFeatures: useReportFeatures = $345de988b64525a0$var$useThrowReportFeaturesDI })=>{
        const baseUrl = '';
        const { data: defaultItems } = useDefaultReportItems();
        const { data: features } = useReportFeatures();
        const { formatMessage: formatMessage } = useIntl();
        const { data: project } = useProject();
        if (project == null || features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
        const createReportUrl = (0, (0, parcelRequire("9h6Pc")).createReportUrlFunc)({
            baseUrl: baseUrl,
            project: project
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, defaultItems && defaultItems.items.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement(Section, {
            id: defaultItems.id,
            key: defaultItems.id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, defaultItems.name), defaultItems.items && defaultItems.items.map((item)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
                key: item.id,
                analytics: {
                    itemId: item.id
                },
                selectedOn: matchUrlParams([
                    'reportKey'
                ]),
                href: item.url
            }, item.name != null ? item.name : null))), features && features.hasForcastSection && (0, ($parcel$interopDefault($5uXOq))).createElement(Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, (0, parcelRequire("9GoDt")).default).forecastAndManagement)), features.hasTimeTracking && (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'time-tracking'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:time-tracking'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).timeTracking)), features.hasDeveloperWorkload && (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'developer-workload'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:developer-workload'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).userWorkload)), features.hasVersionWorkloadReport && (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'version-workload'
            },
            href: createReportUrl('com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).versionWorkload))), (0, ($parcel$interopDefault($5uXOq))).createElement(Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, (0, parcelRequire("9GoDt")).default).other)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'workloadpie'
            },
            href: createReportUrl('com.atlassian.jira.ext.charting:workloadpie-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).workloadPieChart)), (0, ($parcel$interopDefault($5uXOq))).createElement(ConnectMenu, {
            items: connectItems,
            overrides: {
                BackMenuItem: {
                    href: `/projects/${project.key}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`,
                    title: formatMessage((0, (0, parcelRequire("9GoDt")).default).itemBack)
                }
            }
        })));
    };
    const $345de988b64525a0$var$ReportsTerminologyRefreshExperimentSidebar = ({ ConnectMenu: ConnectMenu = (0, (0, parcelRequire("3tHFY")).ConnectMenu), MenuItem: MenuItem = (0, (0, parcelRequire("k0ZZ2")).MenuItem), Section: Section = (0, (0, parcelRequire("gjTBi")).default), SkeletonItem: SkeletonItem = (0, (0, parcelRequire("bWqXX")).default), connectItems: connectItems, SectionHeader: SectionHeader = (0, (0, parcelRequire("jv9Yy")).SectionHeader), matchUrlParams: matchUrlParams = (0, (0, parcelRequire("4OCke")).matchUrlParams), useIntl: useIntl = (0, (0, parcelRequire("koVbs")).default), useProject: useProject = $345de988b64525a0$var$useThrowProjectDI, useReportFeatures: useReportFeatures = $345de988b64525a0$var$useThrowReportFeaturesDI })=>{
        const baseUrl = '';
        const { data: features } = useReportFeatures();
        const { formatMessage: formatMessage } = useIntl();
        const { data: project } = useProject();
        if (project == null || features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
        const createReportUrl = (0, (0, parcelRequire("9h6Pc")).createReportUrlFunc)({
            baseUrl: baseUrl,
            project: project
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, (0, parcelRequire("9GoDt")).default).workProgress)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'createdvsresolved-report'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:createdvsresolved-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("cnn8W")).default).createdResolvedIssuesReport)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'time-tracking'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:time-tracking'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).timeTracking))), (0, ($parcel$interopDefault($5uXOq))).createElement(Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, (0, parcelRequire("9GoDt")).default).teamHealth)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'recentlycreated-report'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:recentlycreated-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("cnn8W")).default).recentlyCreatedIssues)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'resolutiontime-report'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:resolutiontime-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("cnn8W")).default).resolutionTime))), (0, ($parcel$interopDefault($5uXOq))).createElement(Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, (0, parcelRequire("9GoDt")).default).resourcing)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'averageage-report'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:averageage-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("cnn8W")).default).averageAgeReport)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'timesince-report'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:timesince-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("cnn8W")).default).timeSinceIssues)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'developer-workload'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:developer-workload'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).userWorkload)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'workloadpie'
            },
            href: createReportUrl('com.atlassian.jira.ext.charting:workloadpie-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).workloadPieChart))), (0, ($parcel$interopDefault($5uXOq))).createElement(Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, (0, parcelRequire("9GoDt")).default).forecasting)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'version-workload'
            },
            href: createReportUrl('com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).versionWorkload))), (0, ($parcel$interopDefault($5uXOq))).createElement(Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, (0, parcelRequire("9GoDt")).default).general)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'pie-report'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:pie-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("cnn8W")).default).pieChart)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'singlelevelgroupby'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:singlelevelgroupby'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("cnn8W")).default).singleLevelGroup))), connectItems !== null && connectItems.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement(Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, (0, parcelRequire("9GoDt")).default).other)), (0, ($parcel$interopDefault($5uXOq))).createElement(ConnectMenu, {
            items: connectItems,
            overrides: {
                BackMenuItem: {
                    href: `/projects/${project.key}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`,
                    title: formatMessage((0, (0, parcelRequire("9GoDt")).default).itemBack)
                }
            }
        })));
    };
});
parcelRegister("9h6Pc", function(module, exports) {
    $parcel$export(module.exports, "createReportUrlFunc", ()=>$14ad3153b403c86e$export$fe91ad5e718e4335);
    const $14ad3153b403c86e$export$fe91ad5e718e4335 = ({ baseUrl: baseUrl, project: project })=>(reportKey)=>`${baseUrl}/secure/ConfigureReport!default.jspa?selectedProjectId=${project.id}&projectOrFilterId=project-${project.id}&projectOrFilterName=${project.name}&reportKey=${reportKey}`;
});
parcelRegister("eA5Jb", function(module, exports) {
    $parcel$export(module.exports, "useDefaultReportItems", ()=>$b47a0bfc5b0d2f58$export$ab2e8832e8916e83);
    var $4R6GH;
    var $koVbs;
    var $lpwtK;
    var $9h6Pc;
    var $cnn8W;
    const $b47a0bfc5b0d2f58$export$ab2e8832e8916e83 = ()=>{
        const baseUrl = '';
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("lpwtK")).useProject)();
        let defaultIssueAnalysisSection = null;
        if (project) {
            const createReportUrl = (0, (0, parcelRequire("9h6Pc")).createReportUrlFunc)({
                baseUrl: baseUrl,
                project: project
            });
            defaultIssueAnalysisSection = {
                name: formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("cnn8W")).default).issueAnalysisIssueTermRefresh : (0, (0, parcelRequire("cnn8W")).default).issueAnalysis),
                id: 'issue-analysis-sidebar-links',
                items: [
                    {
                        id: 'averageage-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:averageage-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).averageAgeReport)
                    },
                    {
                        id: 'createdvsresolved-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:createdvsresolved-report'),
                        name: formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("cnn8W")).default).createdResolvedIssuesReportIssueTermRefresh : (0, (0, parcelRequire("cnn8W")).default).createdResolvedIssuesReport)
                    },
                    {
                        id: 'pie-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:pie-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).pieChart)
                    },
                    {
                        id: 'recentlycreated-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:recentlycreated-report'),
                        name: formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("cnn8W")).default).recentlyCreatedIssuesIssueTermRefresh : (0, (0, parcelRequire("cnn8W")).default).recentlyCreatedIssues)
                    },
                    {
                        id: 'resolutiontime-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:resolutiontime-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).resolutionTime)
                    },
                    {
                        id: 'singlelevelgroupby',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:singlelevelgroupby'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).singleLevelGroup)
                    },
                    {
                        id: 'timesince-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:timesince-report'),
                        name: formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("cnn8W")).default).timeSinceIssuesIssueTermRefresh : (0, (0, parcelRequire("cnn8W")).default).timeSinceIssues)
                    }
                ]
            };
        }
        return {
            data: defaultIssueAnalysisSection,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("cnn8W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f93c3dbd2e4c3a6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7f93c3dbd2e4c3a6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueAnalysis: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.issue-analysis",
            "defaultMessage": "Issue analysis"
        },
        averageAgeReport: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.average-age-report",
            "defaultMessage": "Average Age Report"
        },
        createdResolvedIssuesReport: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.created-resolved-issues-report",
            "defaultMessage": "Created vs Resolved Issues Report"
        },
        pieChart: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.pie-chart",
            "defaultMessage": "Pie Chart Report"
        },
        recentlyCreatedIssues: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.recently-created-issues",
            "defaultMessage": "Recently Created Issues Report"
        },
        resolutionTime: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.resolution-time",
            "defaultMessage": "Resolution Time Report"
        },
        singleLevelGroup: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.single-level-group",
            "defaultMessage": "Single Level Group By Report"
        },
        timeSinceIssues: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.time-since-issues",
            "defaultMessage": "Time Since Issues Report"
        },
        issueAnalysisIssueTermRefresh: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.issue-analysis-issue-term-refresh",
            "defaultMessage": "Issue analysis"
        },
        createdResolvedIssuesReportIssueTermRefresh: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.created-resolved-issues-report-issue-term-refresh",
            "defaultMessage": "Created vs Resolved Issues Report"
        },
        recentlyCreatedIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.recently-created-issues-issue-term-refresh",
            "defaultMessage": "Recently Created Issues Report"
        },
        timeSinceIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.time-since-issues-issue-term-refresh",
            "defaultMessage": "Time Since Issues Report"
        }
    });
});
parcelRegister("9GoDt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98779022895d106f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $98779022895d106f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        forecastAndManagement: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.forecast-and-management",
            "defaultMessage": "Forecast & management"
        },
        timeTracking: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.time-tracking",
            "defaultMessage": "Time Tracking Report"
        },
        userWorkload: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.user-workload",
            "defaultMessage": "User Workload Report"
        },
        versionWorkload: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.version-workload",
            "defaultMessage": "Version Workload Report"
        },
        workloadPieChart: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.workload-pie-chart",
            "defaultMessage": "Workload Pie Chart Report"
        },
        other: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.other",
            "defaultMessage": "Other"
        },
        itemBack: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.item-back",
            "defaultMessage": "Back to reports"
        },
        workProgress: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.work-progress",
            "defaultMessage": "Work progress"
        },
        teamHealth: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.team-health",
            "defaultMessage": "Team health"
        },
        resourcing: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.resourcing",
            "defaultMessage": "Resourcing"
        },
        forecasting: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.forecasting",
            "defaultMessage": "Forecasting"
        },
        general: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.general",
            "defaultMessage": "General"
        }
    });
});
parcelRegister("9nNLl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90a0ff13f8a11c35$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9btdk;
    var $gjTBi;
    var $k0iPT;
    var $65Ltd;
    var $6jY6G;
    var $gb5lQ;
    var $8yg0C;
    var $lPApw;
    var $3wt3Q;
    var $4rn3K;
    const $90a0ff13f8a11c35$var$EMPTY_STACK = [];
    const $90a0ff13f8a11c35$var$adjustAppStack = (appStack)=>{
        const [first, ...other] = appStack;
        if ((0, (0, parcelRequire("gb5lQ")).SECTION_ID).SETTINGS === first) return other;
        return appStack;
    };
    const $90a0ff13f8a11c35$var$calculateStack = (route, connectStack, forgeStack)=>{
        if ((0, (0, parcelRequire("gb5lQ")).FORGE_ROUTES_SET).has(route.name) && forgeStack) return $90a0ff13f8a11c35$var$adjustAppStack(forgeStack);
        if (route.name.includes((0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE))) {
            const [view] = route.name.replace(`${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE)}-`, '').split('-');
            return view === 'issuetypes' ? [
                view
            ] : $90a0ff13f8a11c35$var$EMPTY_STACK;
        }
        if ((0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(route.name) && connectStack) return $90a0ff13f8a11c35$var$adjustAppStack(connectStack);
        return $90a0ff13f8a11c35$var$EMPTY_STACK;
    };
    const $90a0ff13f8a11c35$var$SettingsMenu = ({ project: project })=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: connectItems, stack: connectStack } = (0, (0, parcelRequire("lPApw")).useProjectSettingsConnectItems)();
        const { data: forgeItems, stack: forgeStack } = (0, (0, parcelRequire("lPApw")).useProjectSettingsForgeItems)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS), $90a0ff13f8a11c35$var$EMPTY_STACK);
        const ecosystemItems = (0, $5uXOq.useMemo)(()=>({
                forge: forgeItems,
                connect: connectItems
            }), [
            forgeItems,
            connectItems
        ]);
        const [stack, setStack] = (0, $5uXOq.useState)(()=>$90a0ff13f8a11c35$var$calculateStack(route, connectStack, forgeStack));
        (0, $5uXOq.useEffect)(()=>{
            setStack($90a0ff13f8a11c35$var$calculateStack(route, connectStack, forgeStack));
        }, [
            route,
            connectStack,
            forgeStack
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9btdk")).default), {
            stack: stack,
            onChange: setStack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, project.isSimplified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wt3Q")).SettingsMenu), {
            stack: stack
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4rn3K")).Settings), {
            ecosystemItems: ecosystemItems
        }))));
    };
    var $90a0ff13f8a11c35$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($90a0ff13f8a11c35$var$SettingsMenu);
});
parcelRegister("3wt3Q", function(module, exports) {
    $parcel$export(module.exports, "SettingsMenu", ()=>$26eff467887b13fc$export$1d7840d5cdc861d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $2vSU6;
    var $4R6GH;
    var $koVbs;
    var $xc3fY;
    var $k0ZZ2;
    var $3OGaE;
    var $lpwtK;
    var $kZj7F;
    var $71bFU;
    var $3SzZi;
    var $7OqB4;
    var $4OCke;
    var $02Psx;
    var $j9iVo;
    var $iNzEe;
    var $daoB1;
    var $6EZeH;
    var $gb5lQ;
    var $bkw8F;
    var $9DEd8;
    var $7OvX8;
    var $1tmBf;
    var $17zko;
    const $26eff467887b13fc$export$a4007dc4843ca7f6 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $26eff467887b13fc$var$DisplayNotificationsOptions = ({ hasCoreAccess: hasCoreAccess, formatMessage: formatMessage, baseSettingsUrl: baseSettingsUrl, projectId: projectId })=>{
        if (!hasCoreAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xc3fY")).ExpandableSubmenuItem), {
            analytics: {
                itemId: 'notifications'
            },
            menuItemLabel: formatMessage((0, (0, parcelRequire("17zko")).messages).itemNotifications),
            forceExpand: true,
            submenuId: "core-notifications-settings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71bFU")).NotificationsSubMenu), {
            settingsUrl: `${baseSettingsUrl}/notifications`,
            issueLogsUrl: `${baseSettingsUrl}/notifications/issue-logs?projectId=${projectId}`
        }));
    };
    const $26eff467887b13fc$export$c72f6eaae7b9adff = ({ stack: stack })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: project } = $26eff467887b13fc$export$a4007dc4843ca7f6();
        const { hasCoreAccess: hasCoreAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        const hasDlpEnabled = (0, (0, parcelRequire("6EZeH")).useDlpEntitlement)();
        const isPremiumUserSeat = (0, (0, parcelRequire("iNzEe")).useIsPremiumUserSeat)();
        const { data: settingFeatures } = (0, (0, parcelRequire("bkw8F")).useSettingFeatures)();
        const [{ data: connectAppsData }, { fetch: fetchConnectApps }] = (0, (0, parcelRequire("j9iVo")).useConnectApps)();
        (0, $5uXOq.useEffect)(()=>{
            if (project && !connectAppsData) fetchConnectApps(project.key);
        }, [
            connectAppsData,
            fetchConnectApps,
            project
        ]);
        if (project == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        const baseSettingsUrl = (0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).CORE_PROJECT), project.key);
        const showCoreForms = (0, (0, parcelRequire("4R6GH")).fg)('proforma_mvp_jwm_project_settings') && hasCoreAccess;
        const BackMenuItem = {
            href: baseSettingsUrl,
            title: formatMessage((0, (0, parcelRequire("17zko")).messages).title)
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("17zko")).messages).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'details'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseSettingsUrl}/details`
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemDetails)), hasCoreAccess && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'access'
            },
            href: `${baseSettingsUrl}/access`,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemAccess)), (0, ($parcel$interopDefault($5uXOq))).createElement($26eff467887b13fc$var$DisplayNotificationsOptions, {
            hasCoreAccess: hasCoreAccess,
            formatMessage: formatMessage,
            baseSettingsUrl: baseSettingsUrl,
            projectId: project.id
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'automation'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseSettingsUrl}/automation`
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).automation)), hasCoreAccess && settingFeatures?.hasProjectEfaFields && (0, (0, parcelRequire("4R6GH")).fg)('project_fields_page_for_tmp_-_mvp') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'fields'
            },
            href: `${baseSettingsUrl}/fields`,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemFieldsNonFinal)), (0, (0, parcelRequire("3SzZi")).shouldRenderNesting)(hasCoreAccess, stack, (0, (0, parcelRequire("gb5lQ")).SECTION_ID).ISSUE_TYPES) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            analytics: {
                itemId: 'issuetypes'
            },
            href: `${baseSettingsUrl}/issuetypes`,
            id: (0, (0, parcelRequire("gb5lQ")).SECTION_ID).ISSUE_TYPES,
            overrides: {
                BackMenuItem: BackMenuItem
            },
            title: formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("17zko")).messages).itemIssueTypesIssueTermRefresh : (0, (0, parcelRequire("17zko")).messages).itemIssueTypes)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1tmBf")).IssueTypes), null)), isPremiumUserSeat && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'approvals'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseSettingsUrl}/approvals`
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemApprovals)), showCoreForms && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'proforma-forms'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseSettingsUrl}/forms`
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemAdvancedForms)), (0, (0, parcelRequire("3SzZi")).shouldRenderNesting)(hasCoreAccess, stack, 'apps') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xc3fY")).ExpandableSubmenuItem), {
            analytics: {
                itemId: 'apps'
            },
            menuItemLabel: formatMessage((0, (0, parcelRequire("7OvX8")).messages).apps),
            forceExpand: true,
            submenuId: "nextgen-apps-settings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9DEd8")).EcosystemAppsMenu), null)), hasDlpEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'data-classification'
            },
            href: `${baseSettingsUrl}/data-classifications`,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).dataClassificationNonFinal))));
    };
    const $26eff467887b13fc$export$1d7840d5cdc861d5 = (props)=>{
        const { data: project } = $26eff467887b13fc$export$a4007dc4843ca7f6();
        if (project == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j9iVo")).ConnectAppsContainer), {
            onError: undefined,
            scope: project.key
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($26eff467887b13fc$export$c72f6eaae7b9adff, props)));
    };
});
parcelRegister("xc3fY", function(module, exports) {
    $parcel$export(module.exports, "ExpandableSubmenuItem", ()=>$dec8d2ea50472f86$export$16ba9a3b96f3ac6d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3TzYp;
    var $iUo88;
    var $4R6GH;
    var $8zOmE;
    var $2NMNM;
    var $fXJBp;
    var $k0ZZ2;
    const $dec8d2ea50472f86$var$defaultExpandMenuState = {
        submenuActive: false,
        expanded: false
    };
    const $dec8d2ea50472f86$export$e5a6b8291f2460bc = ()=>{
        const getExpandableState = (submenuId)=>{
            const cookieData = (0, (0, parcelRequire("3TzYp")).getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            let parsedCookieData = null;
            try {
                parsedCookieData = JSON.parse(cookieData);
            } catch  {
                parsedCookieData = $dec8d2ea50472f86$var$defaultExpandMenuState;
            }
            return parsedCookieData;
        };
        const setExpandedState = (submenuId, newExpandedState)=>{
            if (submenuId != null) (0, (0, parcelRequire("iUo88")).setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newExpandedState));
        };
        return {
            getExpandableState: getExpandableState,
            setExpandedState: setExpandedState
        };
    };
    const $dec8d2ea50472f86$export$16ba9a3b96f3ac6d = ({ children: children, analytics: analytics, iconBefore: iconBefore = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null), menuItemLabel: menuItemLabel, expandButtonLabel: expandButtonLabel = 'expand', href: href, useButtonLink: useButtonLink = false, forceExpand: forceExpand = false, noListStyle: noListStyle = false, submenuId: submenuId = '', testId: testId = '' })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { getExpandableState: getExpandableState, setExpandedState: setExpandedState } = $dec8d2ea50472f86$export$e5a6b8291f2460bc();
        const [subMenuActive, setSubMenuActive] = (0, $5uXOq.useState)(false);
        const [currentCookieData] = (0, $5uXOq.useState)(getExpandableState(submenuId));
        const expandButtonId = menuItemLabel.replace(/ /g, '-').toLowerCase();
        const [expanded, setExpanded] = (0, $5uXOq.useState)(currentCookieData?.expanded || (0, (0, parcelRequire("4R6GH")).fg)('jsm_simplified_project_settings_navigation') ? forceExpand : false);
        const expandableMenuItemRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jsm_simplified_project_settings_navigation') && forceExpand) setExpanded(true);
        }, [
            forceExpand
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (currentCookieData?.expanded) {
                setExpanded(currentCookieData.expanded);
                setSubMenuActive(currentCookieData.submenuActive);
            }
        }, [
            currentCookieData
        ]);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (submenuId != null) setExpandedState(submenuId, {
                submenuActive: false,
                expanded: !expanded
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'expandButton changed', 'projectSettings', {
                expandMenuId: analytics?.itemId,
                expanded: !expanded
            });
            setExpanded(!expanded);
            requestAnimationFrame(()=>{
                expandableMenuItemRef?.current?.focus();
            });
        }, [
            analytics,
            createAnalyticsEvent,
            expanded,
            setExpandedState,
            submenuId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($dec8d2ea50472f86$var$ExpandableSubmenuWrapper, {
            isExpanded: subMenuActive
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: analytics,
            href: href,
            useButtonLink: useButtonLink,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fXJBp")).ExpandButton), {
                id: expandButtonId,
                label: expandButtonLabel,
                isActive: true,
                isExpanded: expanded,
                size: "medium"
            }), iconBefore),
            onClick: onClick,
            "data-test-id": testId,
            ref: expandableMenuItemRef,
            tabIndex: -1
        }, menuItemLabel), expanded && (0, ($parcel$interopDefault($5uXOq))).createElement($dec8d2ea50472f86$var$ExpandableSubmenuItemWrapper, {
            noListStyle: noListStyle
        }, children));
    };
    const $dec8d2ea50472f86$var$ExpandableSubmenuWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_hstcidpf _11lvidpf _44p6idpf _l7mvidpf _1gid5cnj _1t1q5cnj _qmbb5cnj _130y5cnj _cyds5cnj _wpy85cnj _da5j5cnj _14p45cnj _r3xj5cnj _1p1m5cnj _12kz5cnj _67om5cnj _1gw75cnj _1rnb5cnj _vxqc5cnj _1ve95cnj _1qslpxbi _16khpxbi _ek7jpxbi _1mdfpxbi _1mp8pxbi _40k9pxbi _15e4pxbi _3hrxpxbi _erbmpxbi _5vm1pxbi _1e43pxbi _f4s1pxbi _1fabpxbi _da52pxbi _1aolpxbi _qdxopxbi _zyjmqslr _4rtsqslr _1bb1qslr _gis0qslr _19ixqslr _qbnnqslr _ii9vqslr _176zqslr _qylaqslr _1xqvqslr _uzbcqslr _1ifwqslr _i6ubqslr _1u1wqslr _1ks5qslr _329dqslr _fe5pidpf _kywyt94y",
                __cmplp.isExpanded && "_4t3i1osq",
                __cmplp.className
            ])
        });
    });
    const $dec8d2ea50472f86$var$ExpandableSubmenuItemWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _18u0r5cr _ujmh1osq _1nx0u2gc _hstcidpf _fgl3wgn3 _fl8b12x7 _9b588aae _14tk72c6 _1u1didpf _1thcforw _19as19el _kk3x126e _14o4107n",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fXJBp", function(module, exports) {
    $parcel$export(module.exports, "ExpandButton", ()=>$a3120c1c485e5e18$export$5663c8f5aeb8c1c4);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $6Ingq;
    var $ebd3R;
    var $hORKG;
    var $3dGN0;
    var $dC5iT;
    var $dCm1o;
    const $a3120c1c485e5e18$export$5663c8f5aeb8c1c4 = ({ id: id, label: label, isActive: isActive, isExpanded: isExpanded, onClick: onClick = ()=>null, size: size, isVisible: isVisible = true, removeCaret: removeCaret = false, tabIndex: tabIndex = null })=>{
        const ChevronOld = isExpanded ? (0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))) : (0, ($parcel$interopDefault((0, parcelRequire("ebd3R")))));
        const ChevronIcon = isExpanded ? (0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))) : (0, ($parcel$interopDefault((0, parcelRequire("3dGN0")))));
        const onKeydown = (0, $5uXOq.useCallback)((event)=>{
            if ([
                13,
                32
            ].includes(event.keyCode)) {
                event.preventDefault();
                onClick();
            }
        }, [
            onClick
        ]);
        const chevronElement = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            padding: "space.075",
            paddingBlockStart: "space.025"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(ChevronIcon, {
            testId: `sidebar.expand-button.container-${id}`,
            color: "var(--ds-icon, #44546F)",
            label: label
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement(ChevronOld, {
            testId: `sidebar.expand-button.container-${id}`,
            primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            label: label,
            size: size
        });
        if (!isActive) return chevronElement;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a3120c1c485e5e18$var$Container, {
            role: "button",
            "aria-expanded": isExpanded,
            onClick: onClick,
            onKeyDown: onKeydown,
            isVisible: isVisible,
            removeCaret: removeCaret,
            size: size,
            tabIndex: tabIndex
        }, chevronElement);
    };
    const $a3120c1c485e5e18$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isVisible: isVisible, removeCaret: removeCaret, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _bfhk18uv _80omtlke _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _1spjglyw _1ejj12vo _19lvkb7n",
                __cmplp.size === 'medium' ? "_154imyb0" : "_154iidpf",
                __cmplp.isVisible ? "_tzy4kb7n" : "_tzy4idpf",
                __cmplp.removeCaret ? "_1e0cglyw" : "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("71bFU", function(module, exports) {
    $parcel$export(module.exports, "NotificationsSubMenu", ()=>$4606ea7b05b7e72d$export$f80567459a5e304a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jZ4fr;
    var $lj8SI;
    var $5Fk4Z;
    var $dC5iT;
    var $8CUq3;
    var $bWqXX;
    var $aWse0;
    var $k0ZZ2;
    var $lpwtK;
    var $7OqB4;
    var $4OCke;
    var $icKiA;
    const $4606ea7b05b7e72d$export$51b1383ef8844a7 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY = 'issue-email-log-spotlight';
    const $4606ea7b05b7e72d$export$f80567459a5e304a = ({ settingsUrl: settingsUrl, issueLogsUrl: issueLogsUrl, displayLozenge: displayLozenge = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const { data: project, loading: projectLoading } = $4606ea7b05b7e72d$export$51b1383ef8844a7();
        if (projectLoading || !project) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'notifications-settings'
            },
            href: settingsUrl,
            ref: (0, $5uXOq.createRef)(),
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("icKiA")).messages).itemSettings)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'notifications-issue-logs'
            },
            href: issueLogsUrl,
            ref: (0, $5uXOq.createRef)(),
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4606ea7b05b7e72d$var$issueLogsContainerStyles
        }, formatMessage((0, (0, parcelRequire("icKiA")).messages).itemProjectEmailAuditLogs), displayLozenge && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "new"
        }, formatMessage((0, (0, parcelRequire("icKiA")).messages).newLozenge)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jZ4fr")).EngagementSpotlight), {
            engagementId: $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, content);
    };
    const $4606ea7b05b7e72d$var$issueLogsContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'space-between'
    });
});
parcelRegister("aWse0", function(module, exports) {
    $parcel$export(module.exports, "useIntlV2", ()=>$6b28e3c9e1c89fbd$export$d82607073b68786);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    const $6b28e3c9e1c89fbd$export$d82607073b68786 = ()=>{
        const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, (0, parcelRequire("koVbs")).default)();
        const memoisedIntl = (0, $5uXOq.useMemo)(()=>{
            const modifiedIntl = {
                messages: messages,
                locale: locale,
                formats: formats,
                formatDate: formatDate,
                formatMessage: formatMessage,
                formatNumber: formatNumber,
                formatPlural: formatPlural,
                formatTime: formatTime
            };
            return modifiedIntl;
        }, [
            formatDate,
            formatMessage,
            formatPlural,
            formatTime,
            formatNumber,
            formats,
            locale,
            messages
        ]);
        return memoisedIntl;
    };
});
parcelRegister("icKiA", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$0ac4b8c96850fb1d$export$defe85febe8b728c);
    var $7VHMR;
    const $0ac4b8c96850fb1d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        itemSettings: {
            "id": "spa-apps-sidebar-common.notifications-sub-menu.item-settings",
            "defaultMessage": "Settings"
        },
        itemProjectEmailAuditLogs: {
            "id": "spa-apps-sidebar-common.notifications-sub-menu.item-project-email-audit-logs",
            "defaultMessage": "Project email audit"
        },
        newLozenge: {
            "id": "spa-apps-sidebar-common.notifications-sub-menu.new-lozenge",
            "defaultMessage": "New"
        }
    });
});
parcelRegister("3SzZi", function(module, exports) {
    $parcel$export(module.exports, "shouldRenderNesting", ()=>$956cef61e43b05f1$export$a35baff1c4efd3da);
    const $956cef61e43b05f1$export$a35baff1c4efd3da = (condition, stack, nestingId)=>condition === true || Boolean(stack && stack.includes(nestingId));
});
parcelRegister("02Psx", function(module, exports) {
    $parcel$export(module.exports, "getNextgenSettingsUrl", ()=>$a59737cd16881573$export$26432406821aa7bf);
    $parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", ()=>$a59737cd16881573$export$defee92e506aa306);
    $parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", ()=>$a59737cd16881573$export$9133e09a98a043dc);
    $parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", ()=>$a59737cd16881573$export$b0d20d18e0230e83);
    $parcel$export(module.exports, "getClassicJSWSettingsUrl", ()=>$a59737cd16881573$export$ff0a17aa36a000df);
    $parcel$export(module.exports, "getProjectSettingsDetailsUrl", ()=>$a59737cd16881573$export$16d52b9357bb73ab);
    $parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", ()=>$a59737cd16881573$export$d531a9788343348f);
    $parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", ()=>$a59737cd16881573$export$dad567762dae162e);
    $parcel$export(module.exports, "getJcsRequestTypeLayoutSettingsUrl", ()=>$a59737cd16881573$export$8b304050f4836b59);
    var $2vSU6;
    var $3XO6n;
    var $gl0PU;
    var $1RLjE;
    const $a59737cd16881573$export$26432406821aa7bf = (projectType, projectKey)=>{
        const products = {
            [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'core',
            [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'servicedesk',
            [(0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT)]: 'customerservice',
            [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software',
            [(0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
        };
        const product = products[projectType];
        if (!product) {
            (0, (0, parcelRequire("1RLjE")).logError)((0, (0, parcelRequire("3XO6n")).PACKAGE_NAME), (0, (0, parcelRequire("gl0PU")).toErrorId)('urls'), (0, (0, parcelRequire("gl0PU")).toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
            return `/projects/${projectKey}/settings`;
        }
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
        return `/jira/${product}/projects/${projectKey}/settings`;
    };
    const $a59737cd16881573$var$serializeBackLink = (backLink)=>{
        if (backLink == null) return '';
        const { url: url, title: title } = backLink;
        return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
    };
    const $a59737cd16881573$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}`;
        return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
    };
    const $a59737cd16881573$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
        return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
    };
    const $a59737cd16881573$export$b0d20d18e0230e83 = (projectKey)=>`${$a59737cd16881573$export$26432406821aa7bf((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), projectKey)}/automation`;
    const $a59737cd16881573$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
    const $a59737cd16881573$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
        const urlBase = projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) && !isSimplified ? $a59737cd16881573$export$ff0a17aa36a000df(projectKey) : $a59737cd16881573$export$26432406821aa7bf(projectType, projectKey);
        return `${urlBase}/details`;
    };
    const $a59737cd16881573$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
    const $a59737cd16881573$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
    const $a59737cd16881573$export$8b304050f4836b59 = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/helpcenter/projects/${projectKey}/settings/request-types/unassigned/request-type/${requestTypeId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
});
parcelRegister("3XO6n", function(module, exports) {
    $parcel$export(module.exports, "TASK", ()=>$594ec5369f29a734$export$9355e489ad16f98e);
    $parcel$export(module.exports, "BUG", ()=>$594ec5369f29a734$export$bcf558c186108044);
    $parcel$export(module.exports, "STORY", ()=>$594ec5369f29a734$export$1ea39a3ae330045);
    $parcel$export(module.exports, "EPIC", ()=>$594ec5369f29a734$export$3cb4a99a332e4186);
    $parcel$export(module.exports, "SUB_TASK", ()=>$594ec5369f29a734$export$a06f889861f6537d);
    $parcel$export(module.exports, "CUSTOM", ()=>$594ec5369f29a734$export$952581bc40160893);
    $parcel$export(module.exports, "TEMPLATES_WHITELIST", ()=>$594ec5369f29a734$export$dff1da4a9bab6d3e);
    $parcel$export(module.exports, "TEXT_AREA_CF_TYPE", ()=>$594ec5369f29a734$export$39cd48613b53ce2f);
    $parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", ()=>$594ec5369f29a734$export$56eae1056efd4899);
    $parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", ()=>$594ec5369f29a734$export$ca61f05d869b2ea3);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", ()=>$594ec5369f29a734$export$2ec42920a0df6b9a);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", ()=>$594ec5369f29a734$export$40c10ba35ceb5c6b);
    $parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", ()=>$594ec5369f29a734$export$a11dccbf88784c62);
    $parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", ()=>$594ec5369f29a734$export$f35dc2e6deb1692e);
    $parcel$export(module.exports, "JIRA_APP_NAME", ()=>$594ec5369f29a734$export$ec5d0e43836cb3c7);
    $parcel$export(module.exports, "toPackageName", ()=>$594ec5369f29a734$export$f31a652635bd75fe);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$594ec5369f29a734$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", ()=>$594ec5369f29a734$export$a2231d79966e0ccc);
    $parcel$export(module.exports, "RADIO_FIELD_TYPE", ()=>$594ec5369f29a734$export$28a4bdf7d9b6f9);
    $parcel$export(module.exports, "USERPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$9d758b3e8c6e0ed1);
    $parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$b0e37d421e006913);
    $parcel$export(module.exports, "SELECT_FIELD_TYPE", ()=>$594ec5369f29a734$export$d77765147749db6b);
    $parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", ()=>$594ec5369f29a734$export$42ef68d6bd555a8d);
    $parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", ()=>$594ec5369f29a734$export$4db6eb15b3c529cf);
    $parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", ()=>$594ec5369f29a734$export$ee975373b7797e8a);
    $parcel$export(module.exports, "TEXT_FIELD_TYPE", ()=>$594ec5369f29a734$export$aa99342cc6a8ced5);
    $parcel$export(module.exports, "NUMBER_FIELD_TYPE", ()=>$594ec5369f29a734$export$6f327bf99e20320);
    $parcel$export(module.exports, "DATETIME_FIELD_TYPE", ()=>$594ec5369f29a734$export$dc64bdfdf9660a05);
    $parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$e6d73ed745b9a04);
    $parcel$export(module.exports, "DATE_FIELD_TYPE", ()=>$594ec5369f29a734$export$d8b50f59220c7580);
    $parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$3a6f0a44478f1d2);
    $parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$68b76ef93df5a880);
    $parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$e7773fccbeec45e6);
    $parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$b45487b145c52a37);
    $parcel$export(module.exports, "VERSION_FIELD_TYPE", ()=>$594ec5369f29a734$export$48548129a6d117f5);
    $parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", ()=>$594ec5369f29a734$export$722c271a9e11cb94);
    $parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", ()=>$594ec5369f29a734$export$33dbe2a903610aa1);
    $parcel$export(module.exports, "emptyTenantContext", ()=>$594ec5369f29a734$export$ac655f5b3ff7b929);
    var $lzeFL;
    var $5fc53;
    var $ldyPw;
    var $g5X3G;
    var $ef5Xn;
    var $7qPn9;
    var $5fc53;
    const $594ec5369f29a734$export$9355e489ad16f98e = 'task';
    const $594ec5369f29a734$export$bcf558c186108044 = 'bug';
    const $594ec5369f29a734$export$1ea39a3ae330045 = 'story';
    const $594ec5369f29a734$export$3cb4a99a332e4186 = 'epic';
    const $594ec5369f29a734$export$a06f889861f6537d = 'subtask';
    const $594ec5369f29a734$export$952581bc40160893 = 'custom';
    const $594ec5369f29a734$export$dff1da4a9bab6d3e = [
        $594ec5369f29a734$export$9355e489ad16f98e,
        $594ec5369f29a734$export$bcf558c186108044,
        $594ec5369f29a734$export$1ea39a3ae330045,
        $594ec5369f29a734$export$3cb4a99a332e4186
    ];
    const $594ec5369f29a734$export$39cd48613b53ce2f = (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE);
    const $594ec5369f29a734$export$56eae1056efd4899 = (0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE);
    const $594ec5369f29a734$export$ca61f05d869b2ea3 = (0, (0, parcelRequire("5fc53")).ENVIRONMENT_TYPE);
    const $594ec5369f29a734$export$2ec42920a0df6b9a = 'Story point estimate';
    const $594ec5369f29a734$export$40c10ba35ceb5c6b = 'storyPointEstimate';
    const $594ec5369f29a734$export$a4d3702d4c7481d6 = 44;
    const $594ec5369f29a734$export$8a6a961f6caf7a8b = [
        $594ec5369f29a734$export$56eae1056efd4899,
        $594ec5369f29a734$export$39cd48613b53ce2f,
        $594ec5369f29a734$export$ca61f05d869b2ea3
    ];
    const $594ec5369f29a734$export$e27914436cc13e3c = 'Jira Software';
    const $594ec5369f29a734$export$a11dccbf88784c62 = 'Jira Service Management';
    const $594ec5369f29a734$export$9f4aa232cbb6be46 = 'Jira Work Management';
    const $594ec5369f29a734$export$b3c4739240716eb6 = 'Jira Ops';
    const $594ec5369f29a734$export$f35dc2e6deb1692e = 'Jira Product Discovery';
    const $594ec5369f29a734$export$ec5d0e43836cb3c7 = 'Jira';
    const $594ec5369f29a734$export$f31a652635bd75fe = (packageName)=>packageName;
    const $594ec5369f29a734$export$b8b9d90f9e5bd72b = $594ec5369f29a734$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
    const $594ec5369f29a734$export$a2231d79966e0ccc = 'NEW_';
    const $594ec5369f29a734$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
    const $594ec5369f29a734$export$28a4bdf7d9b6f9 = 'radio';
    const $594ec5369f29a734$export$9d758b3e8c6e0ed1 = 'userpicker';
    const $594ec5369f29a734$export$b0e37d421e006913 = 'multiuserpicker';
    const $594ec5369f29a734$export$d77765147749db6b = 'select';
    const $594ec5369f29a734$export$42ef68d6bd555a8d = 'cascadingselect';
    const $594ec5369f29a734$export$4db6eb15b3c529cf = 'multiselect';
    const $594ec5369f29a734$export$ee975373b7797e8a = 'checkbox';
    const $594ec5369f29a734$export$aa99342cc6a8ced5 = 'text';
    const $594ec5369f29a734$export$6f327bf99e20320 = 'number';
    const $594ec5369f29a734$export$dc64bdfdf9660a05 = 'datetime';
    const $594ec5369f29a734$export$e6d73ed745b9a04 = 'projectpicker';
    const $594ec5369f29a734$export$d8b50f59220c7580 = 'date';
    const $594ec5369f29a734$export$3a6f0a44478f1d2 = 'assetspicker';
    const $594ec5369f29a734$export$68b76ef93df5a880 = 'labelpicker';
    const $594ec5369f29a734$export$e7773fccbeec45e6 = 'grouppicker';
    const $594ec5369f29a734$export$b45487b145c52a37 = 'multigrouppicker';
    const $594ec5369f29a734$export$48548129a6d117f5 = 'version';
    const $594ec5369f29a734$export$722c271a9e11cb94 = 'multiversion';
    const $594ec5369f29a734$export$33dbe2a903610aa1 = 'textarea';
    const $594ec5369f29a734$export$ac655f5b3ff7b929 = ()=>({
            appEditions: (0, (0, parcelRequire("ldyPw")).populateApplicationEditions)(),
            appPermissions: (0, (0, parcelRequire("7qPn9")).populateApplicationPermissions)(),
            applicationKey: null,
            areProductSuggestionsEnabled: false,
            appUpdatesAvailable: null,
            atlassianAccountId: null,
            baseUrl: (0, (0, parcelRequire("g5X3G")).toBaseUrl)(''),
            cloudId: (0, (0, parcelRequire("g5X3G")).toCloudId)(''),
            activationId: (0, (0, parcelRequire("g5X3G")).toActivationId)(''),
            cloudName: (0, (0, parcelRequire("g5X3G")).toCloudName)(''),
            devopsProjectSignupSource: (0, (0, parcelRequire("g5X3G")).toDevopsProjectSignupSource)(''),
            environment: null,
            fabricActivityUrl: null,
            fabricNotificationLogUrl: null,
            fabricPfDirUrl: null,
            firstActivationDateMs: null,
            isAdmin: false,
            isAnonymous: false,
            isDevMode: false,
            isDevopsProjectCreationScenario: false,
            isMarketingOptOut: false,
            isSiteAdmin: false,
            languageTag: null,
            licenseStates: (0, (0, parcelRequire("ef5Xn")).populateApplicationLicenseStates)(),
            licensedProducts: {},
            locale: (0, (0, parcelRequire("lzeFL")).defaultLocale),
            loggedInUser: null,
            productCrossSellConfig: 'unknown',
            productEntitlementDetails: null,
            productPermissionGated: {
                core: false,
                software: false,
                serviceDesk: false,
                productDiscovery: false
            },
            siteAdminStatus: 'unknown',
            userFullname: null,
            xsrfToken: null,
            hasDlpEnabled: false,
            avpWorkspaceId: null
        });
});
parcelRegister("5fc53", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_LINK_SEARCH", ()=>$81f079589240b9b7$export$b144116dae474c88);
    $parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", ()=>$81f079589240b9b7$export$bc917bc699b25f75);
    $parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", ()=>$81f079589240b9b7$export$5f26ca419fdffbe7);
    $parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", ()=>$81f079589240b9b7$export$ce9bfd823c7e1a6d);
    $parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$346b72b1f7cd6d5a);
    $parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$b20fbcacd7942c2a);
    $parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", ()=>$81f079589240b9b7$export$a2e8554bffc61ece);
    $parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$f25cd4907cbb25b9);
    $parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", ()=>$81f079589240b9b7$export$5600354b43577e17);
    $parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$5dbc9917f72d0d2a);
    $parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", ()=>$81f079589240b9b7$export$253649f07fb55948);
    $parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", ()=>$81f079589240b9b7$export$eb39592ba5247ee7);
    $parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", ()=>$81f079589240b9b7$export$f48a9be226105736);
    $parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$42e2e93fc721df5d);
    $parcel$export(module.exports, "APPROVALS_PANEL_TYPE", ()=>$81f079589240b9b7$export$7773375e72c953ed);
    $parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", ()=>$81f079589240b9b7$export$80ad0037098f3919);
    $parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", ()=>$81f079589240b9b7$export$6875c7efa3a5e380);
    $parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", ()=>$81f079589240b9b7$export$7c1a5c7d37b8f968);
    $parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", ()=>$81f079589240b9b7$export$c5931a5d7dbfb40b);
    $parcel$export(module.exports, "BOOLEAN_GQL_FIELD", ()=>$81f079589240b9b7$export$c979d9c548c05133);
    $parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$ff25e7412c4ae9c7);
    $parcel$export(module.exports, "CHECKBOX_GQL_FIELD", ()=>$81f079589240b9b7$export$16dbdf57e34e8d63);
    $parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", ()=>$81f079589240b9b7$export$1bf8bec92e6e84df);
    $parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", ()=>$81f079589240b9b7$export$c32f5d822fe5ea95);
    $parcel$export(module.exports, "CMDB_GQL_FIELD", ()=>$81f079589240b9b7$export$b0deb225eed90fbd);
    $parcel$export(module.exports, "COLOR_GQL_FIELD", ()=>$81f079589240b9b7$export$add3775cfea8fde3);
    $parcel$export(module.exports, "COMPONENTS_GQL_FIELD", ()=>$81f079589240b9b7$export$9631d4098abab3eb);
    $parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", ()=>$81f079589240b9b7$export$ee42bc16c09ee564);
    $parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$fbcebbdce821f712);
    $parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$41dd2eb1f33d3042);
    $parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$f4e3e72a3be84e5b);
    $parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$d6738c8a6d1a735d);
    $parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$79a75502a3f0c4c4);
    $parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$ed2eabcf0931df31);
    $parcel$export(module.exports, "DATE_TIME_GQL_FIELD", ()=>$81f079589240b9b7$export$1f17904e959f2f0b);
    $parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", ()=>$81f079589240b9b7$export$6d8da4497234455);
    $parcel$export(module.exports, "FLAG_GQL_FIELD", ()=>$81f079589240b9b7$export$9bcfac568e4fa59c);
    $parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", ()=>$81f079589240b9b7$export$dd84cd6c957c6f5e);
    $parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", ()=>$81f079589240b9b7$export$5cc7c39d7d1cf6d5);
    $parcel$export(module.exports, "LABEL_GQL_FIELD", ()=>$81f079589240b9b7$export$810709f0c5c2e9db);
    $parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$82cb6735134c23a2);
    $parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$85e04e9a3a81ee1);
    $parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", ()=>$81f079589240b9b7$export$24c916a8a33ed20c);
    $parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$c049920d930c3b8a);
    $parcel$export(module.exports, "NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$3b6d7fc1833bf7da);
    $parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", ()=>$81f079589240b9b7$export$bd3e2fe853319c13);
    $parcel$export(module.exports, "PARENT_GQL_FIELD", ()=>$81f079589240b9b7$export$6dfd3fc78bc751a0);
    $parcel$export(module.exports, "PEOPLE_GQL_FIELD", ()=>$81f079589240b9b7$export$31aea7548807c6b5);
    $parcel$export(module.exports, "PRIORITY_GQL_FIELD", ()=>$81f079589240b9b7$export$e89fbbf3983c0219);
    $parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", ()=>$81f079589240b9b7$export$f5e2fb1022ff7912);
    $parcel$export(module.exports, "PROJECT_GQL_FIELD", ()=>$81f079589240b9b7$export$12f54499c6252188);
    $parcel$export(module.exports, "RADIO_GQL_FIELD", ()=>$81f079589240b9b7$export$8e4293d806f435e0);
    $parcel$export(module.exports, "REPORTER_GQL_FIELD", ()=>$81f079589240b9b7$export$c69486dd643dfb69);
    $parcel$export(module.exports, "RESOLUTION_GQL_FIELD", ()=>$81f079589240b9b7$export$1e4faa0d6dc58a81);
    $parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$37f4daaa7b409554);
    $parcel$export(module.exports, "SECURITY_GQL_FIELD", ()=>$81f079589240b9b7$export$ca57cccd6d7bf97c);
    $parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$bea889616fd5bdab);
    $parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$ab5cecc580898d1c);
    $parcel$export(module.exports, "SPRINT_GQL_FIELD", ()=>$81f079589240b9b7$export$bb63813d13e8eaf7);
    $parcel$export(module.exports, "STATUS_GQL_FIELD", ()=>$81f079589240b9b7$export$e40f819979b3881d);
    $parcel$export(module.exports, "TEAM_GQL_FIELD", ()=>$81f079589240b9b7$export$6c243704a22baffe);
    $parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", ()=>$81f079589240b9b7$export$6c32429bac235203);
    $parcel$export(module.exports, "TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$61b514b470cbbf07);
    $parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", ()=>$81f079589240b9b7$export$e4bcb1729da5683);
    $parcel$export(module.exports, "URL_GQL_FIELD", ()=>$81f079589240b9b7$export$37ccd11f08a93ccb);
    $parcel$export(module.exports, "USER_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$abf1bf8c1106ba7d);
    $parcel$export(module.exports, "VERSION_GQL_FIELD", ()=>$81f079589240b9b7$export$b55604041ae7179e);
    $parcel$export(module.exports, "VOTES_GQL_FIELD", ()=>$81f079589240b9b7$export$c8bf66d62e74cdd2);
    $parcel$export(module.exports, "WATCHES_GQL_FIELD", ()=>$81f079589240b9b7$export$aa815aaa741ae18);
    $parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", ()=>$81f079589240b9b7$export$e805f89b15d2abf4);
    $parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", ()=>$81f079589240b9b7$export$5bfd36acd96f04c2);
    $parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", ()=>$81f079589240b9b7$export$695423a2bc8a9ac4);
    $parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", ()=>$81f079589240b9b7$export$d29b0ba0d80bc129);
    $parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", ()=>$81f079589240b9b7$export$ac6c7b30703608d6);
    $parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$478b546dccd33e1e);
    $parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", ()=>$81f079589240b9b7$export$f90c042e9eb983e7);
    $parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", ()=>$81f079589240b9b7$export$753ca4fb34ff3f2b);
    $parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", ()=>$81f079589240b9b7$export$b7aed9efb4a9154b);
    $parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", ()=>$81f079589240b9b7$export$1763713d718f7ef0);
    $parcel$export(module.exports, "FORGE_USER_GQL_FIELD", ()=>$81f079589240b9b7$export$ebb0caa2a98dcf9e);
    $parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", ()=>$81f079589240b9b7$export$671131ba12d94144);
    $parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", ()=>$81f079589240b9b7$export$c48132adab502d6b);
    $parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", ()=>$81f079589240b9b7$export$6cd83226f31c7072);
    $parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", ()=>$81f079589240b9b7$export$7de726bd6d97a9a7);
    $parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", ()=>$81f079589240b9b7$export$8e4b538f77340a05);
    $parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", ()=>$81f079589240b9b7$export$10ba8c0d74470907);
    $parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", ()=>$81f079589240b9b7$export$1756bb4eff1cc3c6);
    $parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", ()=>$81f079589240b9b7$export$5876b4be3c4407b);
    $parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", ()=>$81f079589240b9b7$export$e7fe49e6f36c7154);
    $parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", ()=>$81f079589240b9b7$export$aeed3395a6bca18b);
    $parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", ()=>$81f079589240b9b7$export$9b725a1eafd02e4f);
    $parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", ()=>$81f079589240b9b7$export$699805cbca2c41d);
    $parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", ()=>$81f079589240b9b7$export$f658d5c0f0b5dbc2);
    $parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", ()=>$81f079589240b9b7$export$e469bcb2060000af);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", ()=>$81f079589240b9b7$export$f10e53e8928b61bd);
    $parcel$export(module.exports, "GOALS_GQL_FIELD", ()=>$81f079589240b9b7$export$bfcb1a91094f113a);
    $parcel$export(module.exports, "DURATION_GQL_FIELD", ()=>$81f079589240b9b7$export$db0bd6c04eb7d04a);
    $parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", ()=>$81f079589240b9b7$export$798d2f5814884447);
    $parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", ()=>$81f079589240b9b7$export$269d70c1b1c9fb80);
    $parcel$export(module.exports, "APPROVALS_CF_TYPE", ()=>$81f079589240b9b7$export$f0f17ef462331df4);
    $parcel$export(module.exports, "CATEGORY_TYPE", ()=>$81f079589240b9b7$export$3c7d8923295a5199);
    $parcel$export(module.exports, "PEOPLE_CF_TYPE", ()=>$81f079589240b9b7$export$fb431e758c9252df);
    $parcel$export(module.exports, "NUMBER_CF_TYPE", ()=>$81f079589240b9b7$export$c7faa96db185cfc6);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", ()=>$81f079589240b9b7$export$492b0fa4fe201a22);
    $parcel$export(module.exports, "URL_CF_TYPE", ()=>$81f079589240b9b7$export$60f0bd6e4b582fe6);
    $parcel$export(module.exports, "TEXT_CF_TYPE", ()=>$81f079589240b9b7$export$68c7e01d5460d298);
    $parcel$export(module.exports, "TEXT_AREA_CF_TYPE", ()=>$81f079589240b9b7$export$39cd48613b53ce2f);
    $parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", ()=>$81f079589240b9b7$export$977db5973ce73e44);
    $parcel$export(module.exports, "LABELS_CF_TYPE", ()=>$81f079589240b9b7$export$ad4eb83f78528e13);
    $parcel$export(module.exports, "DATE_CF_TYPE", ()=>$81f079589240b9b7$export$ff745f432984005d);
    $parcel$export(module.exports, "DATETIME_CF_TYPE", ()=>$81f079589240b9b7$export$42d097f7b1622ef1);
    $parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", ()=>$81f079589240b9b7$export$65524be5675e57e6);
    $parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", ()=>$81f079589240b9b7$export$5280e5501a801dc0);
    $parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$c5d13ea26562d57a);
    $parcel$export(module.exports, "SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$22ac48a51c014e4b);
    $parcel$export(module.exports, "EPIC_STATUS_TYPE", ()=>$81f079589240b9b7$export$6769c2c97b828e11);
    $parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$39866626496bbfc8);
    $parcel$export(module.exports, "VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$24382b4e8c58336b);
    $parcel$export(module.exports, "GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$b075907882e80160);
    $parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$b600addfa3355c57);
    $parcel$export(module.exports, "USER_CF_TYPE", ()=>$81f079589240b9b7$export$c491a4b98394028e);
    $parcel$export(module.exports, "MULTI_USER_CF_TYPE", ()=>$81f079589240b9b7$export$5365f2d3fac5261a);
    $parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", ()=>$81f079589240b9b7$export$cc8ffff49170b0f4);
    $parcel$export(module.exports, "FLAGGED_CF_TYPE", ()=>$81f079589240b9b7$export$b7178f601d7373f9);
    $parcel$export(module.exports, "TEAM_CF_TYPE", ()=>$81f079589240b9b7$export$eb1f1dca13a0f02d);
    $parcel$export(module.exports, "PARENT_CF_TYPE", ()=>$81f079589240b9b7$export$3e71e11f80203acb);
    $parcel$export(module.exports, "BASELINE_START_CF_TYPE", ()=>$81f079589240b9b7$export$d10d66823a65e688);
    $parcel$export(module.exports, "BASELINE_END_CF_TYPE", ()=>$81f079589240b9b7$export$dfc6da4a9963d5dc);
    $parcel$export(module.exports, "COLOR_CF_TYPE", ()=>$81f079589240b9b7$export$b4a1fbc1cf0059cf);
    $parcel$export(module.exports, "EPIC_COLOR_TYPE", ()=>$81f079589240b9b7$export$4838a8a8d62a64fd);
    $parcel$export(module.exports, "ASSETS_CF_TYPE", ()=>$81f079589240b9b7$export$ed2de20ab8b7ad3d);
    $parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", ()=>$81f079589240b9b7$export$b755e97dbfa92610);
    $parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", ()=>$81f079589240b9b7$export$1be1ecd4dfc06fab);
    $parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", ()=>$81f079589240b9b7$export$34317c2d84a93553);
    $parcel$export(module.exports, "ORGANIZATION_CF_TYPE", ()=>$81f079589240b9b7$export$c1e26582406f77ec);
    $parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", ()=>$81f079589240b9b7$export$555b4f35f98a3210);
    $parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", ()=>$81f079589240b9b7$export$1f2859a3ef701a14);
    $parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$68f62eb762e4157f);
    $parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", ()=>$81f079589240b9b7$export$6da975fce1fbd38e);
    $parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", ()=>$81f079589240b9b7$export$c6dd874aae21e51f);
    $parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$c3c9f8a8a8dc0b30);
    $parcel$export(module.exports, "RANK_CF_TYPE", ()=>$81f079589240b9b7$export$af89c0396aaf23e3);
    $parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", ()=>$81f079589240b9b7$export$3b5a62bb34372404);
    $parcel$export(module.exports, "READ_ONLY_CF_TYPE", ()=>$81f079589240b9b7$export$247829aef464243f);
    $parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", ()=>$81f079589240b9b7$export$65a6076c0927d413);
    $parcel$export(module.exports, "RESPONDERS_CF_TYPE", ()=>$81f079589240b9b7$export$bcf83e1d934501c9);
    $parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", ()=>$81f079589240b9b7$export$ae0eeec12e90a01e);
    $parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", ()=>$81f079589240b9b7$export$c23f6b40da18371a);
    $parcel$export(module.exports, "SENTIMENT_CF_TYPE", ()=>$81f079589240b9b7$export$c23cfbdf83daa90d);
    $parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", ()=>$81f079589240b9b7$export$21dda64db57e4883);
    $parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", ()=>$81f079589240b9b7$export$45700f3bf92a003a);
    $parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", ()=>$81f079589240b9b7$export$2d75b47d12efc812);
    $parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", ()=>$81f079589240b9b7$export$7b79405842547ccb);
    $parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", ()=>$81f079589240b9b7$export$96201d0ae03ca323);
    $parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$fc276d6ccf118a14);
    $parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", ()=>$81f079589240b9b7$export$8b0718167d092603);
    $parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", ()=>$81f079589240b9b7$export$904b40dd2afd17a2);
    $parcel$export(module.exports, "GOALS_CF_TYPE", ()=>$81f079589240b9b7$export$2bbb7f69c97ea279);
    $parcel$export(module.exports, "ASSIGNEE_TYPE", ()=>$81f079589240b9b7$export$fba8634fd401ba8b);
    $parcel$export(module.exports, "REPORTER_TYPE", ()=>$81f079589240b9b7$export$a91aea2438afcce8);
    $parcel$export(module.exports, "DUE_DATE_TYPE", ()=>$81f079589240b9b7$export$b159f8b8f27aae4c);
    $parcel$export(module.exports, "PRIORITY_TYPE", ()=>$81f079589240b9b7$export$34740f8d07d23ac0);
    $parcel$export(module.exports, "LABELS_TYPE", ()=>$81f079589240b9b7$export$43b6e33ec70f2272);
    $parcel$export(module.exports, "CREATED", ()=>$81f079589240b9b7$export$ff39ebd4bb12b718);
    $parcel$export(module.exports, "UPDATED", ()=>$81f079589240b9b7$export$cd8e68094cb5c3cb);
    $parcel$export(module.exports, "RESOLUTION_DATE", ()=>$81f079589240b9b7$export$6a052efb0b4ec5d2);
    $parcel$export(module.exports, "COMPONENTS_TYPE", ()=>$81f079589240b9b7$export$37abf56f13f61ec5);
    $parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", ()=>$81f079589240b9b7$export$aef0c22aecd16996);
    $parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", ()=>$81f079589240b9b7$export$cff5b6d1e7135679);
    $parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", ()=>$81f079589240b9b7$export$791007408faf42f4);
    $parcel$export(module.exports, "DEV_SUMMARY_TYPE", ()=>$81f079589240b9b7$export$827a1c600bac12a3);
    $parcel$export(module.exports, "RELEASES_TYPE", ()=>$81f079589240b9b7$export$e9ba671d077969f8);
    $parcel$export(module.exports, "SPRINT_TYPE", ()=>$81f079589240b9b7$export$3d37701ba6fb68ec);
    $parcel$export(module.exports, "STORY_POINTS_TYPE", ()=>$81f079589240b9b7$export$36fd22f47020f37b);
    $parcel$export(module.exports, "EPIC_TYPE", ()=>$81f079589240b9b7$export$9f2fedcd916d2a79);
    $parcel$export(module.exports, "EPIC_NAME_TYPE", ()=>$81f079589240b9b7$export$dfc63737b8c0150d);
    $parcel$export(module.exports, "FIX_VERSIONS_TYPE", ()=>$81f079589240b9b7$export$a5c9f63aadcb220);
    $parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", ()=>$81f079589240b9b7$export$94009605902e4fe5);
    $parcel$export(module.exports, "DESCRIPTION_TYPE", ()=>$81f079589240b9b7$export$5e7324042f1d6b31);
    $parcel$export(module.exports, "ENVIRONMENT_TYPE", ()=>$81f079589240b9b7$export$113281d03e6830ef);
    $parcel$export(module.exports, "WATCHES_TYPE", ()=>$81f079589240b9b7$export$5ff798870a3dffbf);
    $parcel$export(module.exports, "SUMMARY_TYPE", ()=>$81f079589240b9b7$export$907219511d14ba3d);
    $parcel$export(module.exports, "PROFORMA_FORMS", ()=>$81f079589240b9b7$export$d09aa6a4f3538063);
    $parcel$export(module.exports, "RESOLUTION_TYPE", ()=>$81f079589240b9b7$export$3aca8c91b58a42e2);
    $parcel$export(module.exports, "TIME_TRACKING_TYPE", ()=>$81f079589240b9b7$export$ccb5ffefbf8b987c);
    $parcel$export(module.exports, "TIME_ESTIMATE_TYPE", ()=>$81f079589240b9b7$export$c8bedad98a5e7f5f);
    $parcel$export(module.exports, "STATUS_TYPE", ()=>$81f079589240b9b7$export$358267065be1e);
    $parcel$export(module.exports, "STATUS_CATEGORY_TYPE", ()=>$81f079589240b9b7$export$dcaa788c7ada56de);
    $parcel$export(module.exports, "ISSUE_TYPE", ()=>$81f079589240b9b7$export$ebb48b08205007c5);
    $parcel$export(module.exports, "ISSUE_KEY_TYPE", ()=>$81f079589240b9b7$export$5e91047fe9955d0e);
    $parcel$export(module.exports, "CHILDREN_ISSUES", ()=>$81f079589240b9b7$export$3b3d0889022c85b3);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", ()=>$81f079589240b9b7$export$335851d83a79891);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", ()=>$81f079589240b9b7$export$7b76bbcb87d41695);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", ()=>$81f079589240b9b7$export$297b67ac63f09f72);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", ()=>$81f079589240b9b7$export$ae87161126086be);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", ()=>$81f079589240b9b7$export$6a88420fc2f6901d);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", ()=>$81f079589240b9b7$export$ef1a0421bd42c0e4);
    $parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", ()=>$81f079589240b9b7$export$dd695c8c5ab62f9d);
    $parcel$export(module.exports, "SLA_PANEL_TYPE", ()=>$81f079589240b9b7$export$7b3d247435a784fa);
    $parcel$export(module.exports, "LINKED_ALERTS_TYPE", ()=>$81f079589240b9b7$export$17b7080ed1fe8cfd);
    $parcel$export(module.exports, "CHAT_CHANNEL_TYPE", ()=>$81f079589240b9b7$export$29fe745131dad7ba);
    $parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", ()=>$81f079589240b9b7$export$9c245100c3091ec3);
    $parcel$export(module.exports, "ZOOM_MEETING_TYPE", ()=>$81f079589240b9b7$export$51eb15cea47a37ba);
    $parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", ()=>$81f079589240b9b7$export$c7ae0622b0bd5d56);
    $parcel$export(module.exports, "CONFERENCE_CALL_TYPE", ()=>$81f079589240b9b7$export$f7dcde9e9e88aff2);
    $parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", ()=>$81f079589240b9b7$export$b5358afda8ff335e);
    $parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", ()=>$81f079589240b9b7$export$63cf6f392da16c25);
    $parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", ()=>$81f079589240b9b7$export$22f61ccc2730431f);
    $parcel$export(module.exports, "SUBTASKS_TYPE", ()=>$81f079589240b9b7$export$8bbb446f57294715);
    $parcel$export(module.exports, "VOTES_TYPE", ()=>$81f079589240b9b7$export$34fcd7cb291a1e4d);
    $parcel$export(module.exports, "PARENT_TYPE", ()=>$81f079589240b9b7$export$5e93f2a57cc4ca3a);
    $parcel$export(module.exports, "PROJECT_TYPE", ()=>$81f079589240b9b7$export$91a9dba2d38d9a6f);
    $parcel$export(module.exports, "TIME_SPENT_TYPE", ()=>$81f079589240b9b7$export$ede0a4c20124ec85);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", ()=>$81f079589240b9b7$export$3eeb79d48fb5f667);
    $parcel$export(module.exports, "SENTIMENT_TYPE", ()=>$81f079589240b9b7$export$45e72c9a63ab61ab);
    $parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", ()=>$81f079589240b9b7$export$99ad62164189f781);
    $parcel$export(module.exports, "FORGE_GLANCE_TYPE", ()=>$81f079589240b9b7$export$7719ef6e9283671);
    $parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", ()=>$81f079589240b9b7$export$bfebea5ce2e1887a);
    $parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", ()=>$81f079589240b9b7$export$84e5674890d55030);
    $parcel$export(module.exports, "SECURITY_LEVEL_TYPE", ()=>$81f079589240b9b7$export$326a5522a485e43d);
    $parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", ()=>$81f079589240b9b7$export$c9f3f01e2c535302);
    $parcel$export(module.exports, "TEAM_TYPE", ()=>$81f079589240b9b7$export$66519f3bbff1796a);
    $parcel$export(module.exports, "ESTIMATE_TYPE", ()=>$81f079589240b9b7$export$a4ee0bca77cc8463);
    $parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", ()=>$81f079589240b9b7$export$fed53408e89e0497);
    $parcel$export(module.exports, "TARGET_START_TYPE", ()=>$81f079589240b9b7$export$d53c26f9ce31f56b);
    $parcel$export(module.exports, "TARGET_END_TYPE", ()=>$81f079589240b9b7$export$48f82d653f85e459);
    $parcel$export(module.exports, "START_DATE_TYPE", ()=>$81f079589240b9b7$export$ea5a888f39f722c7);
    $parcel$export(module.exports, "COLOR_TYPE", ()=>$81f079589240b9b7$export$f245bbec12cc0e40);
    $parcel$export(module.exports, "ATTACHMENT_TYPE", ()=>$81f079589240b9b7$export$aed630b4b7114a59);
    $parcel$export(module.exports, "ISSUE_LINKS_TYPE", ()=>$81f079589240b9b7$export$b50c1a8fef07104);
    $parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", ()=>$81f079589240b9b7$export$ea3d72f4bb7738ba);
    $parcel$export(module.exports, "COMMENT_TYPE", ()=>$81f079589240b9b7$export$a4cab0124760d860);
    $parcel$export(module.exports, "WORK_LOG_TYPE", ()=>$81f079589240b9b7$export$734929aef118d7e2);
    $parcel$export(module.exports, "PARENT_FIELD_TYPE", ()=>$81f079589240b9b7$export$ffbacacb07c1d46d);
    $parcel$export(module.exports, "getLayoutFieldTypes", ()=>$81f079589240b9b7$export$3c3e26aadbfa2c32);
    var $8QpSo;
    var $4R6GH;
    const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
    const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
    const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
    const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
    const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
    const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
    const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option';
    const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
    const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
    const $81f079589240b9b7$export$5600354b43577e17 = 'user';
    const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
    const $81f079589240b9b7$export$253649f07fb55948 = 'object';
    const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
    const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
    const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
    const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues';
    const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
    const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
    const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
    const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
    const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
    const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
    const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
    const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
    const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
    const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
    const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
    const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
    const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
    const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
    const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
    const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
    const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
    const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
    const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
    const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
    const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
    const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
    const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
    const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
    const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
    const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
    const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
    const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
    const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
    const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
    const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
    const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
    const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
    const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
    const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
    const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
    const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
    const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
    const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
    const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
    const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
    const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
    const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
    const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
    const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
    const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
    const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
    const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
    const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
    const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
    const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
    const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
    const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
    const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
    const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
    const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
    const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
    const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
    const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
    const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
    const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
    const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
    const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
    const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
    const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
    const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
    const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
    const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
    const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
    const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
    const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
    const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
    const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
    const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
    const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
    const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
    const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
    const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
    const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
    const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
    const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
    const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
    const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
    const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
    const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
    const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
    const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
    const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
    const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
    const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
    const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
    const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
    const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
    const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
    const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
    const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
    const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
    const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
    const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
    const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
    const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
    const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
    const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
    const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
    const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
    const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
    const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
    const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
    const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
    const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
    const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
    const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
    const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
    const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
    const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
    const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
    const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
    const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
    const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
    const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
    const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
    const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
    const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
    const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
    const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
    const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
    const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
    const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
    const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
    const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
    const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
    const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
    const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
    const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
    const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
    const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
    const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
    const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
    const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
    const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
    const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
    const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
    const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
    const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
    const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
    const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
    const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
    const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
    const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
    const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
    const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
    const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
    const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
    const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
    const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
    const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
    const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
    const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
    const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
    const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
    const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
    const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
    const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
    const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
    const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
    const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
    const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
    const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
    const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
    const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
    const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
    const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
    const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
    const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
    const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
    const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
    const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
    const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
    const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
    const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
    const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
    const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
    const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
    const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
    const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
    const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
    const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
    const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
    const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
    const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
    const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
    const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
    const $81f079589240b9b7$export$358267065be1e = 'status';
    const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
    const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
    const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
    const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
    const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
    const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
    const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
    const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
    const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
    const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
    const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
    const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
    const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
    const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
    const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
    const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
    const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
    const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
    const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
    const $81f079589240b9b7$export$f7dcde9e9e88aff2 = 'CONFERENCE_CALL';
    const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
    const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
    const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
    const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
    const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
    const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
    const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue';
    const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
    const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
    const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
    const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
    const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
    const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
    const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
    const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
    const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
    const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
    const $81f079589240b9b7$export$326a5522a485e43d = 'security';
    const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
    const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
    const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
    const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
    const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
    const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
    const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
    const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
    const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
    const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
    const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
    const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
    const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
    const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
    const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
    const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
    const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
    const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
    const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
    const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
    const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
    const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
        const types = {
            ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
            DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
            PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
            REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
            DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
            LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
            COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
            SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
            STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
            TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
            FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
            AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
            TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
            TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
            ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
            DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
            APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
            KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
            SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
            LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
            CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
            MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
            ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
            MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
            CONFERENCE_CALL_TYPE: $81f079589240b9b7$export$f7dcde9e9e88aff2,
            ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
            RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
            MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
            COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
            EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
            RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
            BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
            BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
            LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
            TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
            MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
            PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
            URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
            NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
            STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
            SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
            EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
            MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
            ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
            FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
            ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
            ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
            ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
            FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
            TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
            MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
            VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
            DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
            GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
            MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
            USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
            DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
            MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
            RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
            TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
            ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
            ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
            ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
            ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
            ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
            REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
            SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
            REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
            ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
            REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
            PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
            REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
            ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
            APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
            CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
            PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
            CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
            READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
            MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
            MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
            EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
            ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
            CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
            ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
            GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
            PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a
        };
        Object.assign(types, {
            FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e
        });
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsm-sentiment-analysis')) Object.assign(types, {
            SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
        });
        Object.assign(types, {
            SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
        });
        if (!(0, (0, parcelRequire("4R6GH")).fg)('remove_epic_link_and_parent_link_from_issue_view')) {
            Object.assign(types, {
                EPIC_TYPE: $81f079589240b9b7$export$9f2fedcd916d2a79
            });
            Object.assign(types, {
                PARENT_CF_TYPE: $81f079589240b9b7$export$3e71e11f80203acb
            });
        }
        if ((0, (0, parcelRequire("4R6GH")).fg)('jcs_issue_layout_eap')) Object.assign(types, {
            ORGANIZATION_CF_TYPE: $81f079589240b9b7$export$c1e26582406f77ec
        });
        return types;
    };
    const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, (0, parcelRequire("8QpSo")).default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);
});
parcelRegister("gl0PU", function(module, exports) {
    $parcel$export(module.exports, "toErrorId", ()=>$b5e194c6e2cc34cd$export$706bbe4209d93dfe);
    $parcel$export(module.exports, "toErrorMessage", ()=>$b5e194c6e2cc34cd$export$95506c204c060a3);
    const $b5e194c6e2cc34cd$export$706bbe4209d93dfe = (id)=>id;
    const $b5e194c6e2cc34cd$export$95506c204c060a3 = (message)=>message;
});
parcelRegister("1RLjE", function(module, exports) {
    $parcel$export(module.exports, "logError", ()=>$b0fc9ceb76f86c8e$export$58da9968c3170cb1);
    var $dJl1T;
    var $jcw0u;
    const $b0fc9ceb76f86c8e$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                packageName: packageName,
                id: errorId,
                teamName: 'morphinecake'
            },
            attributes: {
                ...attributes,
                message: message
            },
            error: error
        });
        const location = `${packageName}.${errorId}`;
        (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData(location, message, error);
    };
});
parcelRegister("j9iVo", function(module, exports) {
    $parcel$export(module.exports, "ConnectAppsSubscriber", ()=>$1d2a37fb0b2cedf7$export$2646f920b0e2e4de);
    $parcel$export(module.exports, "useConnectApps", ()=>$1d2a37fb0b2cedf7$export$4864478dcab77643);
    $parcel$export(module.exports, "ConnectAppsContainer", ()=>$1d2a37fb0b2cedf7$export$ac845603c8c91acd);
    var $gg7kZ;
    var $3sQ5x;
    var $51nlc;
    var $7YSUx;
    const $1d2a37fb0b2cedf7$export$2646f920b0e2e4de = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("7YSUx")).default), {
        displayName: 'ConnectAppsSubscriber'
    });
    const $1d2a37fb0b2cedf7$export$4864478dcab77643 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7YSUx")).default));
    const $1d2a37fb0b2cedf7$export$ac845603c8c91acd = (0, (0, parcelRequire("gg7kZ")).createContainer)((0, (0, parcelRequire("7YSUx")).default));
});
parcelRegister("7YSUx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3bdb3f5fb2a260df$export$2e2bcd8739ae039);
    var $iXqE5;
    var $76t3Y;
    const $3bdb3f5fb2a260df$export$d4c72bab9d6cc13a = {
        data: null,
        loading: false,
        error: null,
        hasFirstError: false
    };
    var $3bdb3f5fb2a260df$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'connect-apps',
        initialState: $3bdb3f5fb2a260df$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("76t3Y")).actions
    });
});
parcelRegister("76t3Y", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$183a508abf4e51e7$export$e324594224ef24da);
    var $8VvCU;
    const $183a508abf4e51e7$export$e324594224ef24da = {
        fetch: (0, parcelRequire("8VvCU")).default
    };
});
parcelRegister("8VvCU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b005bb27151e101$export$2e2bcd8739ae039);
    var $2FYaA;
    var $3b005bb27151e101$export$2e2bcd8739ae039 = (projectKey)=>async ({ setState: setState, getState: getState }, { onError: onError })=>{
            const currentState = getState();
            if (!projectKey || currentState.loading) return;
            setState({
                loading: true,
                error: null
            });
            try {
                const data = await (0, (0, parcelRequire("2FYaA")).default)(projectKey);
                setState({
                    data: data,
                    loading: false,
                    error: null
                });
            } catch (err) {
                const { hasFirstError: hasFirstError, data: data } = getState();
                const isFirstError = !hasFirstError && data === null;
                setState({
                    error: err,
                    loading: false,
                    hasFirstError: hasFirstError || isFirstError
                });
                if (onError) onError(isFirstError);
            }
        };
});
parcelRegister("2FYaA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27cd0e7e45645bce$export$2e2bcd8739ae039);
    var $7f4tk;
    var $gl0PU;
    var $koFzm;
    var $lVlV8;
    const $27cd0e7e45645bce$export$43bc37ac3360968f = (projectKey)=>`/rest/internal/2/connectprojectconfig/${projectKey}`;
    var $27cd0e7e45645bce$export$2e2bcd8739ae039 = (projectKey)=>{
        const fetchPromise = (0, (0, parcelRequire("koFzm")).famaCatchAndLogFetchError)((0, (0, parcelRequire("7f4tk")).default)($27cd0e7e45645bce$export$43bc37ac3360968f(projectKey)), (0, (0, parcelRequire("lVlV8")).PACKAGE_NAME), (0, (0, parcelRequire("gl0PU")).toErrorId)('getConnectApps'), (0, (0, parcelRequire("gl0PU")).toErrorMessage)('Failed to fetch connect apps for a project'));
        return fetchPromise.then((response)=>response.map((app)=>{
                const options = JSON.parse(app.iframe.options);
                const myApp = {
                    title: app.title,
                    id: options.uniqueKey,
                    connectIframeProps: {
                        addon_key: app.iframe.addonKey,
                        key: app.iframe.moduleKey,
                        url: options.url,
                        options: {
                            ...options,
                            productContext: JSON.parse(options.productCtx),
                            structuredContext: JSON.parse(options.structuredContext),
                            user: {
                                uid: options.uid,
                                ukey: options.ukey,
                                timeZone: options.timeZone
                            }
                        }
                    }
                };
                return myApp;
            }));
    };
});
parcelRegister("koFzm", function(module, exports) {
    $parcel$export(module.exports, "famaCatchAndLogFetchError", ()=>$eb8b95f475174133$export$c3948fffb56ff7bb);
    $parcel$export(module.exports, "default", ()=>$eb8b95f475174133$export$2e2bcd8739ae039);
    var $dJl1T;
    var $jJZqs;
    var $1RLjE;
    const $eb8b95f475174133$var$HTTP_LOCATION = 'project-settings-apps.http.catch-and-log-fetch-error';
    const $eb8b95f475174133$var$getStatusCodeGroup = (error)=>{
        if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) {
            const { statusCode: statusCode } = error;
            if (statusCode >= 100 && statusCode <= 199) return '1xx';
            if (statusCode >= 300 && statusCode <= 399) return '3xx';
            if (statusCode >= 400 && statusCode <= 499) return '4xx';
            if (statusCode >= 500 && statusCode <= 599) return '5xx';
        }
        if (error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError)) return '4xx';
        return 'unknown';
    };
    const $eb8b95f475174133$var$catchAndLogFetchError = (promise, message)=>promise.catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($eb8b95f475174133$var$HTTP_LOCATION, message, error);
            throw error;
        });
    const $eb8b95f475174133$export$c3948fffb56ff7bb = (promise, packageName, errorId, message)=>promise.catch((error)=>{
            const statusCodeGroup = $eb8b95f475174133$var$getStatusCodeGroup(error);
            (0, (0, parcelRequire("1RLjE")).logError)(packageName, errorId, message, error, {
                http: true,
                statusCodeGroup: statusCodeGroup
            });
            throw error;
        });
    var $eb8b95f475174133$export$2e2bcd8739ae039 = $eb8b95f475174133$var$catchAndLogFetchError;
});
parcelRegister("lVlV8", function(module, exports) {
    $parcel$export(module.exports, "APP_ID", ()=>$418c76e16c63cf92$export$d76071d5de2774fc);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$418c76e16c63cf92$export$b8b9d90f9e5bd72b);
    var $3XO6n;
    const $418c76e16c63cf92$export$d76071d5de2774fc = 'project-settings/connect-apps';
    const $418c76e16c63cf92$export$b8b9d90f9e5bd72b = (0, (0, parcelRequire("3XO6n")).toPackageName)('jiraProjectSettingsAppsConnectApps');
});
parcelRegister("6EZeH", function(module, exports) {
    $parcel$export(module.exports, "useDlpEntitlement", ()=>$c4c8661954b324b0$export$4472465702535e7);
    var $9OXo1;
    const $c4c8661954b324b0$export$4472465702535e7 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.hasDlpEnabled || false;
    };
});
parcelRegister("9DEd8", function(module, exports) {
    $parcel$export(module.exports, "EcosystemAppsMenu", ()=>$865dc24bed436cec$export$e583660e6ee09caf);
    var $5uXOq = parcelRequire("5uXOq");
    var $bWqXX;
    var $2vSU6;
    var $1rTGO;
    var $aHv3X;
    var $k2DRb;
    var $koVbs;
    var $k0ZZ2;
    var $lpwtK;
    var $4OCke;
    var $k51JQ;
    var $6hMYg;
    var $02Psx;
    var $j9iVo;
    var $gb5lQ;
    var $7OvX8;
    const $865dc24bed436cec$export$c62cfdba33f43c7e = ({ baseSettingsUrl: baseSettingsUrl = '', projectKey: projectKey })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ data: connectAppsData, loading: connectLoading }] = (0, (0, parcelRequire("j9iVo")).useConnectApps)();
        const { data: forgeApps, loading: forgeLoading } = (0, (0, parcelRequire("6hMYg")).useProjectSettingsForgeAppsForMenu)();
        const filteredConnectAppsData = (0, $5uXOq.useMemo)(()=>connectAppsData?.filter((app)=>app?.connectIframeProps?.addon_key !== (0, (0, parcelRequire("gb5lQ")).JIRA_AUTOMATION_ADDON_KEY)), [
            connectAppsData
        ]);
        const sortedApps = (0, $5uXOq.useMemo)(()=>[
                ...(forgeApps || []).map((app)=>({
                        type: 'forge',
                        name: app.name,
                        app: app
                    })),
                ...(filteredConnectAppsData || []).map((app)=>({
                        type: 'connect',
                        name: app.title,
                        app: app
                    }))
            ].sort((a, b)=>a.name.localeCompare(b.name)), [
            forgeApps,
            filteredConnectAppsData
        ]);
        const overrides = (0, $5uXOq.useMemo)(()=>({
                BackMenuItem: {
                    href: `/jira/core/projects/${projectKey}/settings`,
                    title: formatMessage((0, (0, parcelRequire("7OvX8")).messages).backItem),
                    onClick: (ev)=>ev.preventDefault()
                }
            }), [
            projectKey,
            formatMessage
        ]);
        if (connectLoading || forgeLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'app-fields'
            },
            href: `${baseSettingsUrl}/apps/app-fields`,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("7OvX8")).messages).appFields)), sortedApps.map((ecosystemItem)=>{
            const { type: type, app: app } = ecosystemItem;
            if (type === 'forge') {
                const item = app;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k51JQ")).ForgeItem), {
                    key: item.id,
                    ...item,
                    showIcon: false,
                    overrides: overrides
                });
            }
            const connectApp = app;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                analytics: {
                    itemId: connectApp.id
                },
                key: connectApp.id,
                href: `${baseSettingsUrl}/apps/${connectApp.id}`,
                selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
            }, connectApp.title);
        }), forgeApps?.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeScreenEvent), {
            attributes: {
                moduleType: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE)
            }
        }) : null);
    };
    const $865dc24bed436cec$export$e583660e6ee09caf = (props)=>{
        const { children: children } = props;
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const projectKey = project && project.key || '';
        const baseSettingsUrl = (0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).CORE_PROJECT), projectKey);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aHv3X")).TriggerAnalyticsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j9iVo")).ConnectAppsContainer), {
            onError: undefined,
            scope: projectKey
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($865dc24bed436cec$export$c62cfdba33f43c7e, {
            baseSettingsUrl: baseSettingsUrl,
            projectKey: projectKey
        }), children != null && children));
    };
});
parcelRegister("aHv3X", function(module, exports) {
    $parcel$export(module.exports, "ViewAnalyticsWrapper", ()=>$de4af379e202f62d$export$c794eb4124961145);
    $parcel$export(module.exports, "TriggerAnalyticsWrapper", ()=>$de4af379e202f62d$export$e1a79e3d472c925a);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2DRb;
    var $1rTGO;
    var $hBuqR;
    const $de4af379e202f62d$export$c794eb4124961145 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
            shouldFireInitializedEvent: true,
            ...props
        });
    const $de4af379e202f62d$export$e1a79e3d472c925a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
            moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER),
            ...props
        });
});
parcelRegister("7OvX8", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$43a11d7b95b850bb$export$defe85febe8b728c);
    var $7VHMR;
    const $43a11d7b95b850bb$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        apps: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.apps",
            "defaultMessage": "Apps"
        },
        appFields: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.app-fields",
            "defaultMessage": "App fields"
        },
        backItem: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.back-item",
            "defaultMessage": "Back"
        }
    });
});
parcelRegister("1tmBf", function(module, exports) {
    $parcel$export(module.exports, "IssueTypes", ()=>$b746059f9b32cf5c$export$15fef796fc6acc30);
    var $5uXOq = parcelRequire("5uXOq");
    var $7ymNM;
    var $gjTBi;
    var $3bDjY;
    var $2vSU6;
    var $4R6GH;
    var $koVbs;
    var $k0ZZ2;
    var $3OGaE;
    var $lpwtK;
    var $h9XlT;
    var $lGo7j;
    var $7OqB4;
    var $4ya5m;
    var $02Psx;
    var $kIafm;
    var $afIXj;
    const $b746059f9b32cf5c$export$a4007dc4843ca7f6 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $b746059f9b32cf5c$export$15fef796fc6acc30 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ asyncState: asyncState, topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel, addIssueTypeTooltip: addIssueTypeTooltip, isAddIssueTypeDisabled: isAddIssueTypeDisabled }] = (0, (0, parcelRequire("kIafm")).useIssueTypesNavigationItems)();
        const [, addIssueTypesContextActions] = (0, (0, parcelRequire("4ya5m")).useAddIssueTypeContext)();
        const { data: project } = $b746059f9b32cf5c$export$a4007dc4843ca7f6();
        let baseSettingsUrl = '';
        if (project !== null) baseSettingsUrl = (0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).CORE_PROJECT), project.key);
        const hasAnyIssueTypes = topLevel.length > 0 || baseLevel.length > 0 || bottomLevel.length > 0;
        const isReady = asyncState === 'SUCCESS' || hasAnyIssueTypes;
        if (!project || !isReady) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("afIXj")).default).issueTypesIssueTermRefresh : (0, (0, parcelRequire("afIXj")).default).issueTypes)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h9XlT")).IssueTypesGroup), {
            baseSettingsUrl: baseSettingsUrl,
            hasSeparator: false,
            navigationItems: topLevel
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h9XlT")).IssueTypesGroup), {
            baseSettingsUrl: baseSettingsUrl,
            hasSeparator: true,
            navigationItems: baseLevel
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h9XlT")).IssueTypesGroup), {
            baseSettingsUrl: baseSettingsUrl,
            hasSeparator: true,
            navigationItems: bottomLevel
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (()=>{
            const addItem = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                analytics: {
                    itemId: 'add-issue-type'
                },
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7ymNM"))))), {
                    label: formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("afIXj")).default).addIssueTypeIssueTermRefresh : (0, (0, parcelRequire("afIXj")).default).addIssueType)
                }),
                isDisabled: isAddIssueTypeDisabled,
                onClick: isAddIssueTypeDisabled ? undefined : addIssueTypesContextActions.openAddIssueTypeModal
            }, formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("afIXj")).default).addIssueTypeIssueTermRefresh : (0, (0, parcelRequire("afIXj")).default).addIssueType));
            return addIssueTypeTooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: addIssueTypeTooltip
            }, addItem) : addItem;
        })()));
    };
});
parcelRegister("7ymNM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $57fd655943aa23fe$var$_react = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $57fd655943aa23fe$var$_add = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("dZbEw")));
    function $57fd655943aa23fe$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $57fd655943aa23fe$var$AddIcon = (props)=>$57fd655943aa23fe$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
        }, props, {
            newIcon: $57fd655943aa23fe$var$_add.default
        }));
    $57fd655943aa23fe$var$AddIcon.displayName = 'AddIcon';
    var $57fd655943aa23fe$var$_default = module.exports.default = $57fd655943aa23fe$var$AddIcon;
});
parcelRegister("h9XlT", function(module, exports) {
    $parcel$export(module.exports, "IssueTypesGroup", ()=>$f4e999d453ca906b$export$5bc39a07c26525ad);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $gjTBi;
    var $k0ZZ2;
    var $4OCke;
    const $f4e999d453ca906b$export$5bc39a07c26525ad = ({ MenuItem: MenuItem = (0, (0, parcelRequire("k0ZZ2")).MenuItem), Section: Section = (0, (0, parcelRequire("gjTBi")).default), baseSettingsUrl: baseSettingsUrl, hasSeparator: hasSeparator, navigationItems: navigationItems })=>{
        if (!navigationItems.length) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Section, {
            hasSeparator: hasSeparator
        }, navigationItems.map((issueType)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
                key: String(issueType.id),
                analytics: {
                    itemId: String(issueType.id)
                },
                selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
                href: `${baseSettingsUrl}/issuetypes/${issueType.id}`,
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                    appearance: "square",
                    size: "small",
                    src: issueType.icon,
                    borderColor: "transparent"
                })
            }, issueType.name)));
    };
});
parcelRegister("4ya5m", function(module, exports) {
    $parcel$export(module.exports, "useAddIssueTypeContext", ()=>$018a92cfc5e17302$export$40493c3e9059110a);
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $018a92cfc5e17302$var$initialState = {
        isActive: false
    };
    const $018a92cfc5e17302$var$openAddIssueTypeModal = ()=>({ setState: setState })=>{
            setState({
                isActive: true
            });
        };
    const $018a92cfc5e17302$var$closeAddIssueTypeModal = ()=>({ setState: setState })=>{
            setState({
                isActive: false
            });
        };
    const $018a92cfc5e17302$var$actions = {
        openAddIssueTypeModal: $018a92cfc5e17302$var$openAddIssueTypeModal,
        closeAddIssueTypeModal: $018a92cfc5e17302$var$closeAddIssueTypeModal
    };
    const $018a92cfc5e17302$var$STORE_NAME = 'jira-project-settings-apps-add-issue-type-context';
    const $018a92cfc5e17302$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: $018a92cfc5e17302$var$STORE_NAME,
        initialState: $018a92cfc5e17302$var$initialState,
        actions: $018a92cfc5e17302$var$actions
    });
    const $018a92cfc5e17302$export$40493c3e9059110a = (0, (0, parcelRequire("3sQ5x")).createHook)($018a92cfc5e17302$var$Store);
    const $018a92cfc5e17302$export$a0f296f941567e3d = (0, (0, parcelRequire("51nlc")).createSubscriber)($018a92cfc5e17302$var$Store);
    const $018a92cfc5e17302$var$storeInstance = {
        state: $018a92cfc5e17302$var$initialState,
        actions: null
    };
    const $018a92cfc5e17302$export$f1a20ca23c90093e = ()=>{
        const [issueTypeContextState, issueTypeContextActions] = $018a92cfc5e17302$export$40493c3e9059110a();
        $018a92cfc5e17302$var$storeInstance.state = issueTypeContextState;
        $018a92cfc5e17302$var$storeInstance.actions = issueTypeContextActions;
        return null;
    };
    const $018a92cfc5e17302$export$605f542240ea8e19 = ()=>$018a92cfc5e17302$var$storeInstance.actions;
});
parcelRegister("kIafm", function(module, exports) {
    $parcel$export(module.exports, "useIssueTypesNavigationItems", ()=>$117ff49c1fb0e68b$export$8facf5695da03580);
    $parcel$export(module.exports, "useIssueTypesNavigationItemsActions", ()=>$117ff49c1fb0e68b$export$502d4d04702890ce);
    var $6wesA;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $kXBJP;
    var $bI4Ju;
    const $117ff49c1fb0e68b$export$d4c72bab9d6cc13a = {
        projectId: null,
        asyncState: (0, (0, parcelRequire("6wesA")).INIT),
        data: {
            limitPerProject: null,
            issueTypes: []
        },
        addIssueTypeTooltipMessage: ''
    };
    const $117ff49c1fb0e68b$var$load = (projectId, productFeatures, intl)=>async ({ setState: setState, getState: getState })=>{
            try {
                const currentState = getState();
                if (currentState.asyncState === (0, (0, parcelRequire("6wesA")).LOADING) && projectId === currentState.projectId) return;
                setState({
                    ...projectId === currentState.projectId ? currentState : $117ff49c1fb0e68b$export$d4c72bab9d6cc13a,
                    projectId: projectId,
                    asyncState: (0, (0, parcelRequire("6wesA")).LOADING)
                });
                const result = await (0, (0, parcelRequire("kXBJP")).queryIssueTypesNavigationItems)(projectId, productFeatures);
                if (getState().projectId !== projectId) return;
                const { limitPerProject: limitPerProject, data: data } = result.data.simplifiedProject.issueTypeCollection;
                setState({
                    projectId: projectId,
                    asyncState: (0, (0, parcelRequire("6wesA")).SUCCESS),
                    data: {
                        limitPerProject: limitPerProject,
                        issueTypes: data
                    },
                    addIssueTypeTooltipMessage: intl.formatMessage(productFeatures.navigationMessages.addIssueTypeDisabledTooltip, {
                        limit: limitPerProject
                    })
                });
            } catch (error) {
                setState({
                    asyncState: (0, (0, parcelRequire("6wesA")).FAILURE)
                });
            }
        };
    const $117ff49c1fb0e68b$var$remove = (issueTypeId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.asyncState !== (0, (0, parcelRequire("6wesA")).SUCCESS)) return;
            setState({
                ...state,
                data: {
                    ...state.data,
                    issueTypes: state.data.issueTypes.filter(({ id: id })=>id !== issueTypeId)
                }
            });
        };
    const $117ff49c1fb0e68b$var$update = (layoutOwners)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.asyncState !== (0, (0, parcelRequire("6wesA")).SUCCESS)) return;
            const newDataById = {};
            for(let i = 0; i < layoutOwners.length; i += 1){
                const { data: data } = layoutOwners[i];
                newDataById[data.id] = {
                    name: data.name,
                    avatarId: data.avatarId,
                    icon: data.iconUrl
                };
            }
            const issueTypes = state.data.issueTypes.map((issueType)=>{
                if (!newDataById[issueType.id]) return issueType;
                const { name: name, avatarId: avatarId } = newDataById[issueType.id];
                return {
                    ...issueType,
                    name: name,
                    avatarId: avatarId || issueType.avatarId
                };
            });
            setState({
                ...state,
                data: {
                    ...state.data,
                    issueTypes: issueTypes
                }
            });
        };
    const $117ff49c1fb0e68b$export$e324594224ef24da = {
        load: $117ff49c1fb0e68b$var$load,
        remove: $117ff49c1fb0e68b$var$remove,
        update: $117ff49c1fb0e68b$var$update
    };
    const $117ff49c1fb0e68b$export$94d3eea6047656ad = ({ projectId: projectId, asyncState: asyncState, data: data, addIssueTypeTooltipMessage: addIssueTypeTooltipMessage })=>{
        const { issueTypes: issueTypes, limitPerProject: limitPerProject } = data;
        const { topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel } = (0, (0, parcelRequire("bI4Ju")).getIssueTypeNavigationItemsLevels)(issueTypes);
        const isIssueTypeLimitReached = (0, (0, parcelRequire("bI4Ju")).getIsIssueTypeLimitReached)(limitPerProject, issueTypes.length);
        const addIssueTypeTooltip = isIssueTypeLimitReached ? addIssueTypeTooltipMessage : '';
        return {
            asyncState: asyncState,
            projectId: projectId,
            isAddIssueTypeDisabled: asyncState !== (0, (0, parcelRequire("6wesA")).SUCCESS) || isIssueTypeLimitReached,
            addIssueTypeTooltip: addIssueTypeTooltip,
            topLevel: topLevel,
            baseLevel: baseLevel,
            bottomLevel: bottomLevel
        };
    };
    const $117ff49c1fb0e68b$var$STORE_NAME = 'issue-type-page-navigation-items-new';
    const $117ff49c1fb0e68b$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: $117ff49c1fb0e68b$var$STORE_NAME,
        initialState: $117ff49c1fb0e68b$export$d4c72bab9d6cc13a,
        actions: $117ff49c1fb0e68b$export$e324594224ef24da
    });
    const $117ff49c1fb0e68b$export$8facf5695da03580 = (0, (0, parcelRequire("3sQ5x")).createHook)($117ff49c1fb0e68b$var$Store, {
        selector: $117ff49c1fb0e68b$export$94d3eea6047656ad
    });
    const $117ff49c1fb0e68b$export$502d4d04702890ce = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($117ff49c1fb0e68b$var$Store);
    const $117ff49c1fb0e68b$export$313f907c8e339d1b = (0, (0, parcelRequire("51nlc")).createSubscriber)($117ff49c1fb0e68b$var$Store, {
        selector: $117ff49c1fb0e68b$export$94d3eea6047656ad
    });
});
parcelRegister("6wesA", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$a553a914b9b6f7c9$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "INACTIVE_LIST", ()=>$a553a914b9b6f7c9$export$d7fec05af6b928f7);
    $parcel$export(module.exports, "FIELD_TYPE_LIST", ()=>$a553a914b9b6f7c9$export$de26d0d1ef96d0ed);
    $parcel$export(module.exports, "DELETE_DROPPABLE_ID", ()=>$a553a914b9b6f7c9$export$a155cb9d82798d65);
    $parcel$export(module.exports, "IGNORE_CLICK_OUTSIDE_CLASS_NAME", ()=>$a553a914b9b6f7c9$export$8191ccc97ff9885c);
    $parcel$export(module.exports, "DO_NOT_ANIMATE_WIDTH", ()=>$a553a914b9b6f7c9$export$c77ecc59e9e91e60);
    $parcel$export(module.exports, "JSD_FIELD_HELPTEXT", ()=>$a553a914b9b6f7c9$export$663476c4863d5014);
    $parcel$export(module.exports, "ID_REQUEST_OWNER_PROPERTY_KEY", ()=>$a553a914b9b6f7c9$export$9be9f574874c9a2f);
    $parcel$export(module.exports, "NAME_REQUEST_OWNER_PROPERTY_KEY", ()=>$a553a914b9b6f7c9$export$b320c6b352dcb101);
    $parcel$export(module.exports, "SUGGESTED_GROUP", ()=>$a553a914b9b6f7c9$export$e66b34cc29932bbf);
    $parcel$export(module.exports, "ASSETS_GROUP", ()=>$a553a914b9b6f7c9$export$c87c7df18254969e);
    $parcel$export(module.exports, "DATES_GROUP", ()=>$a553a914b9b6f7c9$export$fa8c310a8ac47d47);
    $parcel$export(module.exports, "LABELS_GROUP", ()=>$a553a914b9b6f7c9$export$5b2dd1b457037e13);
    $parcel$export(module.exports, "NUMBER_GROUP", ()=>$a553a914b9b6f7c9$export$2c2f344ca2ba1c03);
    $parcel$export(module.exports, "PEOPLE_GROUP", ()=>$a553a914b9b6f7c9$export$1441c9d524a8c0f2);
    $parcel$export(module.exports, "SELECT_GROUP", ()=>$a553a914b9b6f7c9$export$d3e4788fc90e5f8f);
    $parcel$export(module.exports, "SYSTEM_GROUP", ()=>$a553a914b9b6f7c9$export$724e0d23ac7e9b03);
    $parcel$export(module.exports, "TEXT_GROUP", ()=>$a553a914b9b6f7c9$export$bd76d204d15f4c6a);
    $parcel$export(module.exports, "VERSION_GROUP", ()=>$a553a914b9b6f7c9$export$33d3fa5e989ba460);
    $parcel$export(module.exports, "ADVANCED_GROUP", ()=>$a553a914b9b6f7c9$export$c58a10f3e3456974);
    $parcel$export(module.exports, "OTHER_GROUP", ()=>$a553a914b9b6f7c9$export$591e195d295fd27e);
    $parcel$export(module.exports, "RESTRICTED_GROUP", ()=>$a553a914b9b6f7c9$export$14785d7afcf55619);
    $parcel$export(module.exports, "AI_SUGGESTED_GROUP", ()=>$a553a914b9b6f7c9$export$df593ebd3e7c9c2d);
    $parcel$export(module.exports, "INIT", ()=>$a553a914b9b6f7c9$export$d788bc089976c004);
    $parcel$export(module.exports, "LOADING", ()=>$a553a914b9b6f7c9$export$26d55645375ca9a);
    $parcel$export(module.exports, "SUCCESS", ()=>$a553a914b9b6f7c9$export$638cc6e36b2a737a);
    $parcel$export(module.exports, "FAILURE", ()=>$a553a914b9b6f7c9$export$5b1e245d5eac107);
    $parcel$export(module.exports, "classicFieldTypesMap", ()=>$a553a914b9b6f7c9$export$369c1f8ac37104ce);
    $parcel$export(module.exports, "ngFieldTypesMap", ()=>$a553a914b9b6f7c9$export$b361664c16c2ea91);
    $parcel$export(module.exports, "SWIFT_VERSION_M2", ()=>$a553a914b9b6f7c9$export$527472231e0f6045);
    var $5fc53;
    var $3XO6n;
    const $a553a914b9b6f7c9$export$b8b9d90f9e5bd72b = (0, (0, parcelRequire("3XO6n")).toPackageName)('jiraProjectSettingsAppsIssueTypePageProductFeatures');
    const $a553a914b9b6f7c9$export$d7fec05af6b928f7 = 'inactive-list';
    const $a553a914b9b6f7c9$export$de26d0d1ef96d0ed = 'field-type-list';
    const $a553a914b9b6f7c9$export$a155cb9d82798d65 = 'delete-droppable-id';
    const $a553a914b9b6f7c9$export$8191ccc97ff9885c = '9|.^=*D(riA_=lUv787iQ7hwW5HIz=}t/OdJy%q';
    const $a553a914b9b6f7c9$export$c77ecc59e9e91e60 = 'DO_NOT_ANIMATE_WIDTH';
    const $a553a914b9b6f7c9$export$88ecd73c50643906 = 'swift_searchPreviouslyCreatedFields';
    const $a553a914b9b6f7c9$export$663476c4863d5014 = 'jsd.field.helpText';
    const $a553a914b9b6f7c9$export$aefba859678f04a = 'jsm.issue.type.associated.screen.id';
    const $a553a914b9b6f7c9$export$9be9f574874c9a2f = 'jsm.issue.type.id';
    const $a553a914b9b6f7c9$export$b320c6b352dcb101 = 'jsm.issue.type.name';
    const $a553a914b9b6f7c9$export$97bca9c51480133e = 'jsm.issue.type.icon.id';
    const $a553a914b9b6f7c9$export$b540ee71bad36b8b = 'jsm.issue.type.icon.url';
    const $a553a914b9b6f7c9$export$27366eb417850f7c = [
        $a553a914b9b6f7c9$export$aefba859678f04a,
        $a553a914b9b6f7c9$export$b320c6b352dcb101,
        $a553a914b9b6f7c9$export$97bca9c51480133e,
        $a553a914b9b6f7c9$export$b540ee71bad36b8b
    ];
    const $a553a914b9b6f7c9$export$e66b34cc29932bbf = 'suggestedGroup';
    const $a553a914b9b6f7c9$export$c87c7df18254969e = 'assetsGroup';
    const $a553a914b9b6f7c9$export$fa8c310a8ac47d47 = 'datesGroup';
    const $a553a914b9b6f7c9$export$5b2dd1b457037e13 = 'labelsGroup';
    const $a553a914b9b6f7c9$export$2c2f344ca2ba1c03 = 'numberGroup';
    const $a553a914b9b6f7c9$export$1441c9d524a8c0f2 = 'peopleGroup';
    const $a553a914b9b6f7c9$export$d3e4788fc90e5f8f = 'selectGroup';
    const $a553a914b9b6f7c9$export$724e0d23ac7e9b03 = 'systemGroup';
    const $a553a914b9b6f7c9$export$bd76d204d15f4c6a = 'textGroup';
    const $a553a914b9b6f7c9$export$33d3fa5e989ba460 = 'versionGroup';
    const $a553a914b9b6f7c9$export$c58a10f3e3456974 = 'advancedGroup';
    const $a553a914b9b6f7c9$export$591e195d295fd27e = 'otherGroup';
    const $a553a914b9b6f7c9$export$14785d7afcf55619 = 'restrictedGroup';
    const $a553a914b9b6f7c9$export$df593ebd3e7c9c2d = 'aiSuggestedGroup';
    const $a553a914b9b6f7c9$export$d788bc089976c004 = 'INIT';
    const $a553a914b9b6f7c9$export$26d55645375ca9a = 'LOADING';
    const $a553a914b9b6f7c9$export$638cc6e36b2a737a = 'SUCCESS';
    const $a553a914b9b6f7c9$export$5b1e245d5eac107 = 'FAILURE';
    const $a553a914b9b6f7c9$export$369c1f8ac37104ce = {
        assetspicker: $a553a914b9b6f7c9$export$c58a10f3e3456974,
        date: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
        datetime: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
        labelpicker: $a553a914b9b6f7c9$export$5b2dd1b457037e13,
        number: $a553a914b9b6f7c9$export$2c2f344ca2ba1c03,
        multiuserpicker: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
        userpicker: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
        checkbox: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        radio: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        cascadingselect: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        multiselect: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        select: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        attachment: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        text: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
        textarea: $a553a914b9b6f7c9$export$bd76d204d15f4c6a
    };
    const $a553a914b9b6f7c9$export$b361664c16c2ea91 = {
        [(0, (0, parcelRequire("5fc53")).ASSETS_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
        [(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)]: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
        [(0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)]: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
        [(0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE)]: $a553a914b9b6f7c9$export$5b2dd1b457037e13,
        [(0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE)]: $a553a914b9b6f7c9$export$2c2f344ca2ba1c03,
        people: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
        [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        [(0, (0, parcelRequire("5fc53")).ATTACHMENT_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
        [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
        text: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
        [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03
    };
    const $a553a914b9b6f7c9$export$8e333612d4b83b0e = 'M1';
    const $a553a914b9b6f7c9$export$527472231e0f6045 = 'M2';
});
parcelRegister("kXBJP", function(module, exports) {
    $parcel$export(module.exports, "queryIssueTypesNavigationItems", ()=>$e8107a8cce63320f$export$d7f9b965a8cdf6ce);
    var $7f4tk;
    var $1JUEq;
    const $e8107a8cce63320f$var$getIssueTypesNavigationItemsQuery = (projectId)=>`query IssueTypesNavigationItems {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }
            }
        }
    }
  }`;
    const $e8107a8cce63320f$var$getIssueTypesNavigationItemsWithPropertiesQuery = (projectId, keys)=>`query IssueTypesNavigationItemsWithProperties {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }
                properties(keys: ${JSON.stringify(keys)})
            }
        }
    }
  }`;
    const $e8107a8cce63320f$export$d7f9b965a8cdf6ce = (projectId, productFeatures)=>{
        const propertyKeys = (0, (0, parcelRequire("1JUEq")).getAllPropertiesKeys)(productFeatures);
        const query = propertyKeys.length ? $e8107a8cce63320f$var$getIssueTypesNavigationItemsWithPropertiesQuery(projectId, propertyKeys) : $e8107a8cce63320f$var$getIssueTypesNavigationItemsQuery(projectId);
        return (0, (0, parcelRequire("7f4tk")).default)('/rest/gira/latest/?issue-type-page-navigation', {
            method: 'POST',
            body: JSON.stringify({
                query: query
            })
        });
    };
});
parcelRegister("1JUEq", function(module, exports) {
    $parcel$export(module.exports, "getAllPropertiesKeys", ()=>$fec81b5fddfaba4b$export$481a21941383de83);
    const $fec81b5fddfaba4b$export$481a21941383de83 = (features)=>{
        const { issueTypeHelpText: issueTypeHelpText } = features;
        const allPropertiesKeys = [
            (0, $052efe0fea3c4d67$export$97806a3c861a8076),
            (0, $052efe0fea3c4d67$export$5a53542e76b69730)
        ];
        return issueTypeHelpText ? allPropertiesKeys : [];
    };
});
const $052efe0fea3c4d67$export$5a53542e76b69730 = 'jsd.simplified.issue.type.helpText';
const $052efe0fea3c4d67$export$97806a3c861a8076 = 'jsd.simplified.issue.type.isEmail';
const $052efe0fea3c4d67$export$ffd77ce47de6d72c = 'jsd.field.displayName';
const $052efe0fea3c4d67$export$663476c4863d5014 = 'jsd.field.helpText';
const $052efe0fea3c4d67$export$dc7a7283bd7cd216 = 'jsd.field.approval.config';
const $052efe0fea3c4d67$export$79bc253bc6964b1 = 'jsd.field.approval.all.configs';
parcelRegister("bI4Ju", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypeNavigationItemsLevels", ()=>$a611b4a47ee97f87$export$fcf99cb11372431f);
    $parcel$export(module.exports, "getIsIssueTypeLimitReached", ()=>$a611b4a47ee97f87$export$f9ef03d331bca3e6);
    var $g4tDr;
    var $4cS2K;
    const $a611b4a47ee97f87$var$JSD_IS_EMAIL_REQUEST_TYPE = 'jsd.simplified.issue.type.isEmail';
    const $a611b4a47ee97f87$export$fcf99cb11372431f = (issueTypes)=>issueTypes.reduce((acc, issueType)=>{
            const { id: id, avatarId: avatarId, name: name, hierarchyLevel: hierarchyLevel, properties: properties, operations: operations } = issueType;
            const issueTypeNavigationItem = {
                id: id,
                name: name,
                avatarId: avatarId,
                operations: operations,
                icon: (0, (0, parcelRequire("4cS2K")).getProjectAvatarUrl)(avatarId)
            };
            if ((0, (0, parcelRequire("g4tDr")).isEpicHierarchyLevel)(hierarchyLevel) || properties && properties[$a611b4a47ee97f87$var$JSD_IS_EMAIL_REQUEST_TYPE]) acc.topLevel.push(issueTypeNavigationItem);
            else if ((0, (0, parcelRequire("g4tDr")).isBaseHierarchyLevel)(hierarchyLevel)) acc.baseLevel.push(issueTypeNavigationItem);
            else if ((0, (0, parcelRequire("g4tDr")).isSubtaskHierarchyLevel)(hierarchyLevel)) acc.bottomLevel.push(issueTypeNavigationItem);
            return acc;
        }, {
            topLevel: [],
            baseLevel: [],
            bottomLevel: []
        });
    const $a611b4a47ee97f87$export$f9ef03d331bca3e6 = (limitPerProject, numberOfIssueTypes)=>limitPerProject !== null && limitPerProject > 0 && numberOfIssueTypes >= limitPerProject;
});
parcelRegister("g4tDr", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", ()=>$03dd5f7faa501890$export$2294cfc7730248df);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", ()=>$03dd5f7faa501890$export$961a1d6da881600c);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", ()=>$03dd5f7faa501890$export$e11dea67b88ee556);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", ()=>$03dd5f7faa501890$export$9ad20e435294162a);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", ()=>$03dd5f7faa501890$export$a454b3474c5ee5f5);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", ()=>$03dd5f7faa501890$export$b69c1b48ce8f83de);
    $parcel$export(module.exports, "BASE_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$ba7c785763a2a58f);
    $parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$e09d07f2dcff2603);
    $parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$1165245f61159842);
    $parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$8a96a83b3f957e58);
    $parcel$export(module.exports, "toHierarchyLevel", ()=>$03dd5f7faa501890$export$c0c893ca5ccae9dd);
    $parcel$export(module.exports, "isBaseHierarchyLevel", ()=>$03dd5f7faa501890$export$bcf91a9d8c5b0f58);
    $parcel$export(module.exports, "isEpicHierarchyLevel", ()=>$03dd5f7faa501890$export$e415cf60723c7aae);
    $parcel$export(module.exports, "isSubtaskHierarchyLevel", ()=>$03dd5f7faa501890$export$41f00a40e2ebd6e8);
    $parcel$export(module.exports, "getHierarchyLevelType", ()=>$03dd5f7faa501890$export$556b686fea6fb229);
    $parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", ()=>$03dd5f7faa501890$export$638ac52227e67c8);
    const $03dd5f7faa501890$export$2294cfc7730248df = 4;
    const $03dd5f7faa501890$export$961a1d6da881600c = 3;
    const $03dd5f7faa501890$export$e11dea67b88ee556 = 2;
    const $03dd5f7faa501890$export$9ad20e435294162a = 1;
    const $03dd5f7faa501890$export$a454b3474c5ee5f5 = 0;
    const $03dd5f7faa501890$export$b69c1b48ce8f83de = -1;
    const $03dd5f7faa501890$export$ba7c785763a2a58f = 'BASE';
    const $03dd5f7faa501890$export$e09d07f2dcff2603 = 'CHILD';
    const $03dd5f7faa501890$export$1165245f61159842 = 'PARENT';
    const $03dd5f7faa501890$export$8a96a83b3f957e58 = 'EPIC';
    const $03dd5f7faa501890$export$c0c893ca5ccae9dd = (level)=>level;
    const $03dd5f7faa501890$export$bcf91a9d8c5b0f58 = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return true;
        return numericLevel === $03dd5f7faa501890$export$a454b3474c5ee5f5;
    };
    const $03dd5f7faa501890$export$e415cf60723c7aae = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return false;
        return numericLevel === $03dd5f7faa501890$export$9ad20e435294162a;
    };
    const $03dd5f7faa501890$export$41f00a40e2ebd6e8 = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return false;
        return numericLevel === $03dd5f7faa501890$export$b69c1b48ce8f83de;
    };
    const $03dd5f7faa501890$export$556b686fea6fb229 = (hierarchyLevel)=>{
        if (Number(hierarchyLevel) > 0) return $03dd5f7faa501890$export$1165245f61159842;
        if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
        return $03dd5f7faa501890$export$ba7c785763a2a58f;
    };
    const $03dd5f7faa501890$export$638ac52227e67c8 = (hierarchyLevel)=>{
        if (Number(hierarchyLevel) === 1) return $03dd5f7faa501890$export$8a96a83b3f957e58;
        if (Number(hierarchyLevel) > 1) return $03dd5f7faa501890$export$1165245f61159842;
        if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
        return $03dd5f7faa501890$export$ba7c785763a2a58f;
    };
});
parcelRegister("4cS2K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a2a115a4d046ac6$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "getProjectAvatarUrl", ()=>$9a2a115a4d046ac6$export$65a50dd1fe88e116);
    $parcel$export(module.exports, "normaliseSavedAvatar", ()=>$9a2a115a4d046ac6$export$b11f6166803b3fff);
    var $9a2a115a4d046ac6$export$2e2bcd8739ae039 = (rawAvatars)=>rawAvatars.system.concat(rawAvatars.custom).map((raw)=>({
                id: Number(raw.id),
                uri: raw.urls['48x48'],
                fileName: raw.fileName
            }));
    const $9a2a115a4d046ac6$export$65a50dd1fe88e116 = (avatarId)=>`/secure/viewavatar?avatarId=${avatarId}&avatarType=issuetype`;
    const $9a2a115a4d046ac6$export$b11f6166803b3fff = (avatar)=>({
            id: parseInt(avatar.id, 10),
            uri: $9a2a115a4d046ac6$export$65a50dd1fe88e116(parseInt(avatar.id, 10)),
            fileName: avatar.fileName
        });
});
parcelRegister("afIXj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b52c5d7d436e6cd4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b52c5d7d436e6cd4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueTypes: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.issue-types",
            "defaultMessage": "Issue types"
        },
        addIssueType: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.add-issue-type",
            "defaultMessage": "Add issue type"
        },
        issueTypesIssueTermRefresh: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.issue-types-issue-term-refresh",
            "defaultMessage": "Issue types"
        },
        addIssueTypeIssueTermRefresh: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.add-issue-type-issue-term-refresh",
            "defaultMessage": "Add issue type"
        }
    });
});
parcelRegister("17zko", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$333939f1c0a6953d$export$defe85febe8b728c);
    var $7VHMR;
    const $333939f1c0a6953d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.title",
            "defaultMessage": "Project settings"
        },
        itemDetails: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-details",
            "defaultMessage": "Details"
        },
        itemAccess: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-access",
            "defaultMessage": "Access"
        },
        itemFieldsNonFinal: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-fields-non-final",
            "defaultMessage": "Fields"
        },
        itemIssueTypes: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-issue-types",
            "defaultMessage": "Issue types"
        },
        itemAdvancedForms: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-advanced-forms",
            "defaultMessage": "Advanced Forms"
        },
        newLozenge: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.new-lozenge",
            "defaultMessage": "New"
        },
        automation: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.automation",
            "defaultMessage": "Automation"
        },
        itemNotifications: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-notifications",
            "defaultMessage": "Notifications"
        },
        itemApprovals: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-approvals",
            "defaultMessage": "Approvals"
        },
        dataClassificationNonFinal: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.data-classification-non-final",
            "defaultMessage": "Data classification"
        },
        itemIssueTypesIssueTermRefresh: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-issue-types-issue-term-refresh",
            "defaultMessage": "Issue types"
        }
    });
});
parcelRegister("4rn3K", function(module, exports) {
    $parcel$export(module.exports, "Settings", ()=>$d5d4618f8b440044$export$c72f6eaae7b9adff);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjTBi;
    var $bWqXX;
    var $gOS29;
    var $2vSU6;
    var $65Ltd;
    var $co1wz;
    var $4R6GH;
    var $k2DRb;
    var $koVbs;
    var $2MtwW;
    var $xc3fY;
    var $2Uv55;
    var $k0ZZ2;
    var $2gP8z;
    var $3OGaE;
    var $lpwtK;
    var $71bFU;
    var $7OqB4;
    var $4OCke;
    var $5xslo;
    var $eOlBz;
    var $g5X3G;
    var $6EZeH;
    var $bkw8F;
    var $69lKq;
    const $d5d4618f8b440044$export$a4007dc4843ca7f6 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $d5d4618f8b440044$export$154ecbb867fd48f0 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("bkw8F")).useSettingFeatures));
    const $d5d4618f8b440044$export$17eaab3b8c213998 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("eOlBz")).useNewIssueViewLockedInStatus));
    const $d5d4618f8b440044$var$DisplayNotificationsOptions = ({ hasNotifications: hasNotifications, formatMessage: formatMessage, project: project })=>{
        if (!hasNotifications) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xc3fY")).ExpandableSubmenuItem), {
            analytics: {
                itemId: 'notifications'
            },
            menuItemLabel: formatMessage((0, (0, parcelRequire("69lKq")).default).notifications),
            forceExpand: true,
            submenuId: "core-notifications-settings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71bFU")).NotificationsSubMenu), {
            settingsUrl: `/plugins/servlet/project-config/${project.key}/notifications`,
            issueLogsUrl: `/jira/core/projects/${project.key}/settings/notifications/issue-logs?projectId=${project.id}`
        }));
    };
    const $d5d4618f8b440044$var$IssueLayoutOption = ({ isNewIssueViewLockedIn: isNewIssueViewLockedIn, hasIssueLayout: hasIssueLayout, formatMessage: formatMessage, project: project })=>{
        if ((0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) return hasIssueLayout && isNewIssueViewLockedIn && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'issue-layout'
            },
            href: `/plugins/servlet/project-config/${project.key}/issuelayout`
        }, formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("69lKq")).default).issueLayoutIssueTermRefresh : (0, (0, parcelRequire("69lKq")).default).issueLayout));
        return isNewIssueViewLockedIn && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'issue-layout'
            },
            href: `/plugins/servlet/project-config/${project.key}/issuelayout`
        }, formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("69lKq")).default).issueLayoutIssueTermRefresh : (0, (0, parcelRequire("69lKq")).default).issueLayout));
    };
    const $d5d4618f8b440044$export$c72f6eaae7b9adff = ({ ecosystemItems: ecosystemItems })=>{
        const { data: features } = $d5d4618f8b440044$export$154ecbb867fd48f0();
        const { data: status } = $d5d4618f8b440044$export$17eaab3b8c213998();
        const isNewIssueViewLockedIn = status?.newIssueViewTransitionLockingStatus !== (0, (0, parcelRequire("eOlBz")).DEFAULT_TO_OLD_ISSUE_VIEW);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: project } = $d5d4618f8b440044$export$a4007dc4843ca7f6();
        const hasDlpEnabled = (0, (0, parcelRequire("6EZeH")).useDlpEntitlement)();
        if (features == null || project == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("69lKq")).default).projectSettings)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, features.hasDetails && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'details'
            },
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS)
            ],
            href: `/jira/core/projects/${project.key}/settings/details`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).details)), features.hasPeople && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'people'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `/plugins/servlet/project-config/${project.key}/people`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).people)), features.hasAutomation && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2gP8z")).SpotlightTarget), {
            name: "spotlight-sidebar-project-automation"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'automation'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: (0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)({
                isSimplified: project.isSimplified,
                projectKey: (0, (0, parcelRequire("g5X3G")).toProjectKey)(project.key),
                projectType: (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
            })
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).automation))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2MtwW")).EngagementSpotlight), {
            engagementId: "spotlight-sidebar-project-automation"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Uv55")).FireUiAnalytics), {
            actionSubject: "automationNavigationItem",
            action: "viewed"
        })), features.hasSummary && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'summary'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `/plugins/servlet/project-config/${project.key}/summary`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).summary))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: features.hasIssueConfigSection || isNewIssueViewLockedIn || (0, (0, parcelRequire("4R6GH")).fg)('proforma_mvp_jwm_project_settings')
        }, features.hasIssueTypes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'issue-types'
            },
            href: `/plugins/servlet/project-config/${project.key}/issuetypes`
        }, formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("69lKq")).default).issueTypesIssueTermRefresh : (0, (0, parcelRequire("69lKq")).default).issueTypes)), (0, ($parcel$interopDefault($5uXOq))).createElement($d5d4618f8b440044$var$IssueLayoutOption, {
            isNewIssueViewLockedIn: isNewIssueViewLockedIn,
            hasIssueLayout: features.hasIssueLayout,
            formatMessage: formatMessage,
            project: project
        }), (0, (0, parcelRequire("4R6GH")).fg)('proforma_mvp_jwm_project_settings') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'proforma-forms'
            },
            href: `/jira/core/projects/${project.key}/settings/forms`,
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS)
            ]
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).forms))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: features.hasProjectGroupTwoSection
        }, features.hasWorkflows && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'workflows'
            },
            href: `/plugins/servlet/project-config/${project.key}/workflows`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).workflows)), features.hasScreens && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'screens'
            },
            href: `/plugins/servlet/project-config/${project.key}/screens`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).screens)), features.hasSystemFieldsConfiguration && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'fields'
            },
            href: `/plugins/servlet/project-config/${project.key}/fields`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).fields))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: features.hasProjectGroupThreeSection
        }, features.hasVersions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS)
            ],
            analytics: {
                itemId: 'versions'
            },
            href: `/plugins/servlet/project-config/${project.key}/administer-versions`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).versions)), features.hasComponents && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS)
            ],
            analytics: {
                itemId: 'components'
            },
            href: `/plugins/servlet/project-config/${project.key}/administer-components`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).components))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: features.hasProjectGroupFourSection
        }, features.hasPermissions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'permissions'
            },
            href: `/plugins/servlet/project-config/${project.key}/permissions`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).permissions)), features.hasIssueSecurity && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'issue-security'
            },
            href: `/plugins/servlet/project-config/${project.key}/issuesecurity`
        }, formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("69lKq")).default).issueSecurityIssueTermRefresh : (0, (0, parcelRequire("69lKq")).default).issueSecurity)), (0, ($parcel$interopDefault($5uXOq))).createElement($d5d4618f8b440044$var$DisplayNotificationsOptions, {
            hasNotifications: features.hasNotifications,
            formatMessage: formatMessage,
            project: project
        }), features.hasDevtools && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'devtools'
            },
            href: `/secure/ConfigureDevStatus.jspa?projectKey=${project.key}`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).devtools))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: features.hasgetIssueCollectorSection
        }, features.hasIssueCollectors && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS)
            ],
            analytics: {
                itemId: 'issue-collectors'
            },
            href: `/secure/ViewCollectors!default.jspa?projectKey=${project.key}`
        }, formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("69lKq")).default).issueCollectorsIssueTermRefresh : (0, (0, parcelRequire("69lKq")).default).issueCollectors))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5xslo")).default), {
            hasSeparator: true,
            items: ecosystemItems,
            forgeModule: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
            overrides: {
                BackMenuItem: {
                    href: `/plugins/servlet/project-config/${project.key}`,
                    title: formatMessage((0, (0, parcelRequire("69lKq")).default).itemBack)
                }
            }
        }), hasDlpEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), {
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'data-classifications'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `/plugins/servlet/project-config/${project.key}/data-classifications`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).dataClassificationsNonFinal))));
    };
});
parcelRegister("gOS29", function(module, exports) {
    $parcel$export(module.exports, "getBaseAutomationUrl", ()=>$b61a7afc01657dc2$export$8e479e490e1e69bc);
    const $b61a7afc01657dc2$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
        if (projectType === 'service_desk') return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        if (projectType === 'business') return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    };
});
parcelRegister("2MtwW", function(module, exports) {
    $parcel$export(module.exports, "EngagementSpotlight", ()=>$0e9acf1f50def63d$export$f14689466e4eca7a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jZ4fr;
    var $6OJ73;
    var $axUP7;
    const $0e9acf1f50def63d$export$f14689466e4eca7a = (0, (0, parcelRequire("axUP7")).withNestingOptimisation)(({ engagementId: engagementId })=>{
        const isFullyExpanded = (0, (0, parcelRequire("6OJ73")).useIsFullyExpanded)();
        return isFullyExpanded && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jZ4fr")).EngagementSpotlight), {
            engagementId: engagementId
        });
    });
});
parcelRegister("2Uv55", function(module, exports) {
    $parcel$export(module.exports, "FireUiAnalytics", ()=>$c81bbbeeb609506c$export$5a67e7291fd4569e);
    var $5oFIy;
    var $axUP7;
    const $c81bbbeeb609506c$export$5a67e7291fd4569e = (0, (0, parcelRequire("axUP7")).withNestingOptimisation)((0, (0, parcelRequire("5oFIy")).FireUiAnalytics));
});
parcelRegister("2gP8z", function(module, exports) {
    $parcel$export(module.exports, "SpotlightTarget", ()=>$bac5b90628bba66f$export$e29577842f211e22);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Fk4Z;
    var $axUP7;
    const $bac5b90628bba66f$var$SpotlightTargetWrapper = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), props, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-test-id": `ak-spotlight-target-${props.name}`
        }, children));
    const $bac5b90628bba66f$export$e29577842f211e22 = (0, (0, parcelRequire("axUP7")).withNestingOptimisation)($bac5b90628bba66f$var$SpotlightTargetWrapper);
});
parcelRegister("5xslo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f574dcd99762a8d6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1rTGO;
    var $hBuqR;
    var $au6nA;
    var $fh2pW;
    var $k51JQ;
    const $f574dcd99762a8d6$export$66569e9b4a285b16 = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '', nestedMenuActive: nestedMenuActive = true })=>{
        const forgeItems = (0, $5uXOq.useMemo)(()=>items.forge || [], [
            items.forge
        ]);
        const connectItems = (0, (0, parcelRequire("au6nA")).useFilteredItems)(items.connect, shouldFilter);
        const sortedItems = (0, $5uXOq.useMemo)(()=>[
                ...forgeItems.map((item)=>({
                        type: 'forge',
                        item: item
                    })),
                ...connectItems.map((item)=>({
                        type: 'connect',
                        item: item
                    }))
            ].sort((a, b)=>a.item.name.localeCompare(b.item.name)), [
            connectItems,
            forgeItems
        ]);
        if (!sortedItems.length) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, sortedItems.map(({ type: type, item: item }, index)=>{
            if (type === 'forge') {
                const forgeItem = item;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k51JQ")).ForgeItem), {
                    key: forgeItem.id,
                    ...forgeItem,
                    overrides: overrides,
                    showIcon: showIcons,
                    nestedMenuActive: nestedMenuActive
                });
            }
            const connectItem = item;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fh2pW")).ConnectItem), {
                item: connectItem,
                key: connectItem.id,
                index: index,
                overrides: overrides,
                showIcons: showIcons,
                submenuId: submenuId
            });
        }), forgeItems.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeScreenEvent), null) : null);
    };
    var $f574dcd99762a8d6$export$2e2bcd8739ae039 = ({ forgeModule: forgeModule, ...restProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: forgeModule,
            moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f574dcd99762a8d6$export$66569e9b4a285b16, restProps));
});
parcelRegister("69lKq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$40a05b6299fc545f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $40a05b6299fc545f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectSettings: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.project-settings",
            "defaultMessage": "Project settings"
        },
        details: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.details",
            "defaultMessage": "Details"
        },
        people: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.people",
            "defaultMessage": "People"
        },
        summary: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.summary",
            "defaultMessage": "Summary"
        },
        deleteProject: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.delete-project",
            "defaultMessage": "Delete project"
        },
        issueTypes: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-types",
            "defaultMessage": "Issue types"
        },
        issueLayout: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-layout",
            "defaultMessage": "Issue layout"
        },
        workflows: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.workflows",
            "defaultMessage": "Workflows"
        },
        screens: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.screens",
            "defaultMessage": "Screens"
        },
        fields: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.fields",
            "defaultMessage": "Fields"
        },
        versions: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.versions",
            "defaultMessage": "Versions"
        },
        components: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.components",
            "defaultMessage": "Components"
        },
        permissions: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.permissions",
            "defaultMessage": "Permissions"
        },
        issueSecurity: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-security",
            "defaultMessage": "Issue security"
        },
        notifications: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications",
            "defaultMessage": "Notifications"
        },
        notificationsEmail: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications-email",
            "defaultMessage": "Notification email"
        },
        hipChat: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.hip-chat",
            "defaultMessage": "HipChat integration"
        },
        issueCollectors: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-collectors",
            "defaultMessage": "Issue collectors"
        },
        new: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.new",
            "defaultMessage": "New"
        },
        itemBack: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.item-back",
            "defaultMessage": "Back to project settings"
        },
        automation: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.automation",
            "defaultMessage": "Automation"
        },
        devtools: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.devtools",
            "defaultMessage": "Development tools"
        },
        forms: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.forms",
            "defaultMessage": "Advanced Forms"
        },
        dataClassificationsNonFinal: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.data-classifications-non-final",
            "defaultMessage": "Data classification"
        },
        issueTypesIssueTermRefresh: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-types-issue-term-refresh",
            "defaultMessage": "Issue types"
        },
        issueLayoutIssueTermRefresh: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-layout-issue-term-refresh",
            "defaultMessage": "Issue layout"
        },
        issueSecurityIssueTermRefresh: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-security-issue-term-refresh",
            "defaultMessage": "Issue security"
        },
        issueCollectorsIssueTermRefresh: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-collectors-issue-term-refresh",
            "defaultMessage": "Issue collectors"
        }
    });
});
parcelRegister("1tFZj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bdfaa99512e485c7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bdfaa99512e485c7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        favorites: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.favorites",
            "defaultMessage": "Starred"
        },
        recents: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.recents",
            "defaultMessage": "Recent"
        },
        expandSection: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.expand-section",
            "defaultMessage": "Expand {section} projects"
        },
        collapseSection: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.collapse-section",
            "defaultMessage": "Collapse {section} projects"
        }
    });
});
parcelRegister("cUsQ8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$898e57801e4e297c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $jzhSN;
    var $dPLwL;
    const $898e57801e4e297c$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.view-all-projects';
    const $898e57801e4e297c$var$ViewAllProjects = ({ label: label })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jzhSN")).default), {
            href: "/jira/projects?selectedProjectType=business",
            testId: $898e57801e4e297c$var$TEST_ID,
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmViewAllProjectsLink')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $898e57801e4e297c$var$textStyle
        }, label ?? formatMessage((0, (0, parcelRequire("dPLwL")).messages).viewAllProjectsLabel)));
    };
    var $898e57801e4e297c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($898e57801e4e297c$var$ViewAllProjects);
    const $898e57801e4e297c$var$textStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: "var(--ds-font-weight-regular, 400)"
    });
});
parcelRegister("dPLwL", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2a9ab6de28c59d3b$export$defe85febe8b728c);
    var $7VHMR;
    const $2a9ab6de28c59d3b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewAllProjectsLabel: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.view-all-projects.view-all-projects-label",
            "defaultMessage": "View all projects"
        }
    });
});
parcelRegister("k5gug", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a74810dab45a4db8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $bKCrm;
    var $aFVvc;
    var $iuAuR;
    var $ekH8d;
    var $dcvwL;
    const $a74810dab45a4db8$var$ProjectsHeader = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: data } = (0, (0, parcelRequire("aFVvc")).useProjectCreatePermissionsResource)();
        const canCreateProject = Boolean(data?.canCreateProject);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuAuR")).default), {
            title: formatMessage((0, (0, parcelRequire("ekH8d")).messages).projectsHeader)
        }, canCreateProject && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKCrm")).ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dcvwL")).default), {
                openProjectCreateDrawer: open
            })));
    };
    var $a74810dab45a4db8$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($a74810dab45a4db8$var$ProjectsHeader);
});
parcelRegister("bKCrm", function(module, exports) {
    $parcel$export(module.exports, "ProjectCreateDrawerProvider", ()=>$645a52f2fa143509$export$9a1c5dbd93c42bca);
    $parcel$export(module.exports, "ProjectCreateDrawerConsumer", ()=>$645a52f2fa143509$export$9a8662cd60931de1);
    $parcel$export(module.exports, "useProjectCreateDrawer", ()=>$645a52f2fa143509$export$8172ff4ed0f75a1e);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $58GFP;
    var $8YEE2;
    var $lVJAU;
    var $gL2cg;
    const $645a52f2fa143509$var$Context = (0, $5uXOq.createContext)({
        data: {
            shouldRenderDrawer: false,
            isOpen: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined
        },
        methods: {
            open: (0, ($parcel$interopDefault($8Rkzz))),
            close: (0, ($parcel$interopDefault($8Rkzz))),
            onSuccess: (0, ($parcel$interopDefault($8Rkzz))),
            onCreateStarted: (0, ($parcel$interopDefault($8Rkzz))),
            setOnCloseCallback: (0, ($parcel$interopDefault($8Rkzz))),
            clearOnCloseCallback: (0, ($parcel$interopDefault($8Rkzz)))
        }
    });
    const $645a52f2fa143509$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $5uXOq.Component) {
        render() {
            const { children: children } = this.props;
            const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$var$Context.Provider, {
                value: {
                    data: {
                        isOpen: isOpen,
                        isNextGen: isNextGen,
                        source: source,
                        showExperienceSelection: showExperienceSelection,
                        shouldRenderDrawer: shouldRenderDrawer,
                        recommendedTemplate: recommendedTemplate,
                        defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                        isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                        isImportProjectOpenInitially: isImportProjectOpenInitially,
                        selectedProjectType: selectedProjectType,
                        recommendationSessionId: recommendationSessionId
                    },
                    methods: {
                        open: this.open,
                        close: this.close,
                        onSuccess: this.onSuccess,
                        onCreateStarted: this.onCreateStarted,
                        setOnCloseCallback: this.setOnCloseCallback,
                        clearOnCloseCallback: this.clearOnCloseCallback
                    }
                }
            }, children);
        }
        constructor(...args){
            super(...args), this.state = {
                isOpen: false,
                shouldRenderDrawer: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined,
                onCloseCallback: (0, ($parcel$interopDefault($8Rkzz)))
            }, this.onSuccess = (projectKey)=>{
                if (projectKey) {
                    this.props.setLocation(projectKey.returnUrl);
                    this.close(true);
                } else this.close(false);
            }, this.setOnCloseCallback = (callback)=>{
                this.setState({
                    onCloseCallback: callback
                });
            }, this.clearOnCloseCallback = ()=>{
                this.setState({
                    onCloseCallback: (0, ($parcel$interopDefault($8Rkzz)))
                });
            }, this.open = (attributes = {})=>{
                this.setState({
                    isOpen: true,
                    shouldRenderDrawer: true,
                    ...attributes
                });
            }, this.close = (projectCreated)=>{
                const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
                this.setState({
                    isOpen: false,
                    isNextGen: false,
                    showExperienceSelection: true,
                    recommendedTemplate: undefined,
                    defaultSelectedTemplateKey: '',
                    source: '',
                    isTemplatePickerOpenInitially: false,
                    isImportProjectOpenInitially: false,
                    selectedProjectType: null,
                    recommendationSessionId: undefined
                });
                if (callOnCloseCallBack) this.state.onCloseCallback();
            }, this.closeOld = ()=>{
                this.setState({
                    isOpen: false,
                    isNextGen: false,
                    showExperienceSelection: true,
                    recommendedTemplate: undefined,
                    defaultSelectedTemplateKey: '',
                    source: '',
                    isTemplatePickerOpenInitially: false,
                    selectedProjectType: null,
                    recommendationSessionId: undefined
                });
                this.state.onCloseCallback();
            }, this.onCreateStarted = (projectKey, templateKey)=>{
                if ((0, (0, parcelRequire("58GFP")).getIsJsmBlankProjectTemplate)(templateKey)) (0, (0, parcelRequire("8YEE2")).LazyComponent).preload();
                (0, (0, parcelRequire("gL2cg")).clearResourcesAssociatedWithProjectKey)(projectKey);
            };
        }
    };
    const $645a52f2fa143509$export$9a1c5dbd93c42bca = (props)=>{
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$export$839a70d8fbc9d356, {
            ...props,
            setLocation: push
        });
    };
    const { Consumer: $645a52f2fa143509$export$9a8662cd60931de1 } = $645a52f2fa143509$var$Context;
    $645a52f2fa143509$var$Context.displayName = 'ProjectCreateDrawerConsumer';
    const $645a52f2fa143509$export$8172ff4ed0f75a1e = ()=>{
        const projectCreateDrawer = (0, $5uXOq.useContext)($645a52f2fa143509$var$Context);
        if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
        return projectCreateDrawer;
    };
});
parcelRegister("8YEE2", function(module, exports) {
    $parcel$export(module.exports, "LazyComponent", ()=>$300188a98a9fded7$export$31f1740ae531af94);
    $parcel$export(module.exports, "AsyncProjectBuilderDrawer", ()=>$300188a98a9fded7$export$54a4eade9eae9473);
    $parcel$export(module.exports, "canUseProjectBuilder", ()=>$300188a98a9fded7$export$ff317c5d87147a19);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $9noxX;
    var $kxZPA;
    const $300188a98a9fded7$export$31f1740ae531af94 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("dQEVq")), {
        ssr: false,
        moduleId: "./src/packages/servicedesk/project-builder/src/ui/index.tsx"
    });
    const $300188a98a9fded7$export$54a4eade9eae9473 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "bundle-async-project-builder",
            packageName: "jira-servicedesk-project-builder",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            fallback: null,
            name: "jsm-project-builder"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9noxX")).ServiceDeskAnalyticsContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement($300188a98a9fded7$export$31f1740ae531af94, {
            isOpenInitial: !!props.isOpenInitial,
            ...props
        }))));
    const $300188a98a9fded7$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;
});
parcelRegister("9noxX", function(module, exports) {
    $parcel$export(module.exports, "ServiceDeskAnalyticsContext", ()=>$12b9024f66e7ef57$export$ac31f8f3368d6881);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $4DPZY;
    var $8H3A4;
    const $12b9024f66e7ef57$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
        const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
        const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
        if ((0, $5uXOq.Children).count(children) > 0) {
            const loading = containerContextLoading || analyticsContextLoading;
            const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
            if (!shouldRenderChildren) return null;
            const context = {};
            if (containerContextData && containerContextData.project) {
                const { id: id, type: type } = containerContextData.project;
                context.containerType = 'project';
                context.containerId = `${id}`;
                context.containers = {
                    project: {
                        id: `${id}`,
                        type: type
                    }
                };
                if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), context, children);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    $12b9024f66e7ef57$export$ac31f8f3368d6881.defaultProps = {
        forceRenderWhileLoading: false,
        useServiceDeskAnalyticsContext: (0, (0, parcelRequire("8H3A4")).useServiceDeskAnalyticsContext),
        useContainerContext: (0, (0, parcelRequire("4DPZY")).useContainerContext)
    };
});
parcelRegister("dQEVq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("kWrFZ"),
        $6fhBS("i5RRW"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("c8LNs")
    ]).then(()=>parcelRequire('c9lEE'));
});
parcelRegister("gL2cg", function(module, exports) {
    $parcel$export(module.exports, "clearResourcesAssociatedWithProjectKey", ()=>$e1d0138bae1db723$export$c0c81c1828c7638c);
    var $jcw0u;
    var $8fYaK;
    const $e1d0138bae1db723$export$c0c81c1828c7638c = (projectKey)=>{
        try {
            const { storeState: storeState } = (0, (0, parcelRequire("8fYaK")).getResourceStore)();
            const prevState = storeState.getState();
            storeState.setState({
                ...prevState,
                data: Object.fromEntries(Object.entries(prevState?.data).map(([resourceType, value])=>{
                    const { [projectKey]: _, ...rest } = value;
                    return [
                        resourceType,
                        rest
                    ];
                }))
            });
        } catch (e) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'clearResourcesAssociatedWithProjectKey',
                    packageName: 'jiraProjectCreateDrawerContext',
                    teamName: 'helix'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: e instanceof Error ? e : new Error('Error occured in clearResourcesAssociatedWithProjectKey')
            });
        }
    };
});
parcelRegister("ekH8d", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$de5b805401f88067$export$defe85febe8b728c);
    var $7VHMR;
    const $de5b805401f88067$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectsHeader: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.projects-header",
            "defaultMessage": "Projects"
        }
    });
});
parcelRegister("dcvwL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38d1fe81a75f8a8e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    var $5jbF3;
    var $hJE3l;
    const $38d1fe81a75f8a8e$export$ef99f99721eacc0f = (0, (0, parcelRequire("kxZPA")).lazy)(()=>Promise.resolve((parcelRequire("hJE3l"))), {
        ssr: false,
        moduleId: "./src/packages/business/navigation/sidebar/src/ui/multi-project-menu/projects-header/one-click-project/template-picker/index.tsx"
    });
    const $38d1fe81a75f8a8e$var$OneClickProject = ({ openProjectCreateDrawer: openProjectCreateDrawer })=>{
        const renderContent = (0, $5uXOq.useCallback)((data, loading)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: "sidebar-template-picker",
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJE3l")).TemplatePickerFallback), null)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($38d1fe81a75f8a8e$export$ef99f99721eacc0f, {
                data: data,
                loading: loading,
                openProjectCreateDrawer: openProjectCreateDrawer
            })), [
            openProjectCreateDrawer
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5jbF3")).default), {
            renderContent: renderContent,
            openProjectCreateDrawer: openProjectCreateDrawer
        });
    };
    var $38d1fe81a75f8a8e$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($38d1fe81a75f8a8e$var$OneClickProject);
});
parcelRegister("5jbF3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c00fe391b3045d6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $172CC;
    var $gPQRI;
    var $jgJNO;
    var $gb5lQ;
    var $3BbwT;
    var $8MKpg;
    const $5c00fe391b3045d6$var$OneClickProjectButton = ({ renderContent: renderContent, openProjectCreateDrawer: openProjectCreateDrawer })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { data: data, loading: loading, error: error, fetch: fetchJwmTemplates } = (0, (0, parcelRequire("3BbwT")).useProjectTemplates)();
        const { isCollapsed: isLeftSidebarCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const { templates: templates, recommendationSessionId: recommendationSessionId } = data;
        const wasFetched = templates != null || loading || error != null;
        const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen && !wasFetched) fetchJwmTemplates();
        }, [
            isOpen,
            wasFetched,
            fetchJwmTemplates
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isLeftSidebarCollapsed && isOpen) onClose();
        }, [
            isLeftSidebarCollapsed,
            isOpen,
            onClose
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (error && isOpen) {
                openProjectCreateDrawer((0, (0, parcelRequire("172CC")).getJwmCreateProjectDrawerOptions)((0, (0, parcelRequire("gb5lQ")).LOCATION), recommendationSessionId));
                setIsOpen(false);
            }
        }, [
            error,
            isOpen,
            openProjectCreateDrawer,
            recommendationSessionId
        ]);
        const content = (0, $5uXOq.useCallback)(()=>renderContent(data, loading), [
            renderContent,
            data,
            loading
        ]);
        const trigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", triggerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8MKpg")).default), {
                onClick: ()=>setIsOpen(!isOpen)
            })), [
            isOpen
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgJNO")).JiraPopup), {
            messageType: "transactional",
            isOpen: isOpen,
            placement: "right-start",
            onClose: onClose,
            content: content,
            trigger: trigger
        });
    };
    var $5c00fe391b3045d6$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5c00fe391b3045d6$var$OneClickProjectButton);
});
parcelRegister("172CC", function(module, exports) {
    $parcel$export(module.exports, "getJwmCreateProjectDrawerOptions", ()=>$30b27d3ea79ff2d5$export$c1785414279ee192);
    var $2vSU6;
    const $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED = 'com.atlassian.jira-core-project-templates:jira-work-management-blank-project-team-managed';
    const $30b27d3ea79ff2d5$export$c1785414279ee192 = (source, recommendationSessionId)=>({
            isNextGen: true,
            selectedProjectType: (0, (0, parcelRequire("2vSU6")).CORE_PROJECT),
            showExperienceSelection: false,
            defaultSelectedTemplateKey: $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
            recommendedTemplate: {
                templateKey: $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
                isSimplified: false
            },
            source: source,
            recommendationSessionId: recommendationSessionId
        });
});
parcelRegister("3BbwT", function(module, exports) {
    $parcel$export(module.exports, "useProjectTemplates", ()=>$f58c037e2d918746$export$45e810e42086790f);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $6s1PB;
    var $4R6GH;
    var $7f4tk;
    var $gb5lQ;
    var $annwf;
    const $f58c037e2d918746$var$initialState = {
        data: {
            templates: null
        },
        loading: false,
        error: null
    };
    const $f58c037e2d918746$export$45e810e42086790f = ()=>{
        const [{ loading: loading, data: data, error: error }, setState] = (0, $5uXOq.useState)($f58c037e2d918746$var$initialState);
        const fetch = (0, $5uXOq.useCallback)(async ()=>{
            setState({
                data: {
                    templates: null
                },
                loading: true,
                error: null
            });
            try {
                const url = (0, (0, parcelRequire("4R6GH")).fg)('grw-529_srtpmfy_experiment_kill_switch') ? '/rest/simplified/2.0/project-templates?recommendations&templateGallery' : '/rest/simplified/2.0/project-templates?recommendations';
                const response = await (0, (0, parcelRequire("7f4tk")).default)(url);
                const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('add_jpd_product_roadmap_template_reco_with_new_cb');
                const shouldUseNewRecommendations = expConfig.get('useNewRecommendations', false);
                const jwmTemplates = shouldUseNewRecommendations ? (0, (0, parcelRequire("annwf")).getFilteredTemplatesNew)(response) : (0, (0, parcelRequire("annwf")).getFilteredTemplates)(response);
                setState({
                    data: {
                        templates: jwmTemplates,
                        recommendationSessionId: response.recommendationSessionId
                    },
                    loading: false,
                    error: null
                });
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useProjectTemplates',
                        packageName: (0, (0, parcelRequire("gb5lQ")).PACKAGE_NAME),
                        teamName: 'jira-warepil'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    data: {
                        templates: null
                    },
                    loading: false,
                    error: err
                });
            }
        }, []);
        return {
            data: data,
            loading: loading,
            error: error,
            fetch: fetch
        };
    };
});
parcelRegister("annwf", function(module, exports) {
    $parcel$export(module.exports, "getFilteredTemplates", ()=>$1ee17a992e26086f$export$e9643d22c03c3a30);
    $parcel$export(module.exports, "getFilteredTemplatesNew", ()=>$1ee17a992e26086f$export$126495c59883efa);
    const $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY = 4;
    const $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY_NEW = 5;
    const $1ee17a992e26086f$var$MADE_FOR_YOU_CATEGORY = 'made-for-you-category';
    const $1ee17a992e26086f$var$TEMPLATE_KEYS = new Set([
        'jwm.blank-project',
        'jwm.project-management',
        'jwm.personal-task-planner',
        'jwm.task-tracking'
    ]);
    const $1ee17a992e26086f$export$e9643d22c03c3a30 = (response)=>{
        const { templates: templates, lastUsedTemplate: lastUsedTemplateKey, recommendedTemplate: recommendedTemplateKey } = response;
        const lastUsedTemplates = [];
        const recommendedTemplates = [];
        const additionalTemplates = [];
        templates.forEach((template)=>{
            const { projectTypeTemplates: projectTypeTemplates, key: key, categoryTypes: categoryTypes } = template;
            if (lastUsedTemplateKey != null && (projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey || projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey)) lastUsedTemplates.push({
                ...template,
                isLastUsed: true
            });
            else if (recommendedTemplateKey != null && (projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey || projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey || categoryTypes.includes($1ee17a992e26086f$var$MADE_FOR_YOU_CATEGORY))) recommendedTemplates.push({
                ...template,
                isRecommended: true
            });
            else if ($1ee17a992e26086f$var$TEMPLATE_KEYS.has(key)) additionalTemplates.push(template);
        });
        const filteredTemplates = [
            ...lastUsedTemplates,
            ...recommendedTemplates,
            ...additionalTemplates
        ].slice(0, $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY);
        return filteredTemplates;
    };
    const $1ee17a992e26086f$export$126495c59883efa = (response)=>{
        const { templates: templates, lastUsedTemplate: lastUsedTemplateKey, recommendedTemplate: recommendedTemplateKey, recommendedTemplates: recommendedTemplateKeys } = response;
        const lastUsedTemplates = [];
        const recommendedTemplates = [];
        const additionalTemplates = [];
        recommendedTemplateKeys?.forEach((key, index)=>{
            const template = templates.find((t)=>t.key === key);
            if (template) {
                const { projectTypeTemplates: projectTypeTemplates } = template;
                if (index === 0 && lastUsedTemplateKey) {
                    const isLastUsed = lastUsedTemplateKey && (projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey || projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey);
                    lastUsedTemplates.push({
                        ...template,
                        ...isLastUsed && {
                            isLastUsed: isLastUsed
                        }
                    });
                    return;
                }
                const isRecommended = recommendedTemplateKey && (projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey || projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey);
                recommendedTemplates.push({
                    ...template,
                    ...isRecommended && {
                        isRecommended: isRecommended
                    }
                });
            }
        });
        if (lastUsedTemplates.length + recommendedTemplates.length < $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY) {
            const placeholderTemplateKeys = Array.from($1ee17a992e26086f$var$TEMPLATE_KEYS).filter((key)=>!lastUsedTemplates.some((t)=>t.key === key) && !recommendedTemplates.some((t)=>t.key === key));
            templates.forEach((template)=>{
                if (placeholderTemplateKeys.includes(template.key)) additionalTemplates.push(template);
            });
        }
        const filteredTemplates = [
            ...lastUsedTemplates,
            ...recommendedTemplates,
            ...additionalTemplates
        ].slice(0, $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY_NEW);
        return filteredTemplates;
    };
});
parcelRegister("8MKpg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f7880bbb09ab94b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $8zOmE;
    var $gb5lQ;
    var $3MXKI;
    var $acCqn;
    const $1f7880bbb09ab94b$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.create-project-button';
    const $1f7880bbb09ab94b$var$CreateProjectButton = ({ onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3MXKI")).default), {
            label: formatMessage((0, (0, parcelRequire("acCqn")).default).createProjectLabel),
            testId: $1f7880bbb09ab94b$var$TEST_ID,
            onClick: (_, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, (0, (0, parcelRequire("gb5lQ")).LOCATION));
                onClick();
            }
        });
    };
    var $1f7880bbb09ab94b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1f7880bbb09ab94b$var$CreateProjectButton);
});
parcelRegister("acCqn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f0808b9a7f055d1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9f0808b9a7f055d1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createProjectLabel: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.create-project-button.create-project-label",
            "defaultMessage": "Create project"
        }
    });
});
parcelRegister("hJE3l", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "TemplatePickerFallback", ()=>$47229cd857e246da$export$675ac63e0637d34d);
    $parcel$export(module.exports, "default", ()=>$47229cd857e246da$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lj8SI;
    var $kJpBP;
    var $h5xhD;
    var $9UCCQ;
    var $eZJjh;
    var $aIZdc;
    var $6s1PB;
    var $co1wz;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $itmJb;
    var $cNd4s;
    var $gb5lQ;
    var $2H5YM;
    const $47229cd857e246da$var$POPUP_WIDTH = 272;
    const $47229cd857e246da$export$675ac63e0637d34d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$var$SpinnerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "medium"
        }));
    const $47229cd857e246da$var$TemplatePicker = ({ data: { templates: templates, recommendationSessionId: recommendationSessionId }, loading: loading, openProjectCreateDrawer: openProjectCreateDrawer })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('add_jpd_product_roadmap_template_reco_with_new_cb');
        const shouldUseNewRecommendations = expConfig.get('useNewRecommendations', false);
        const handleTemplateClick = (0, $5uXOq.useCallback)((projectTypeTemplates, isLastUsed, isRecommended, templateType)=>()=>{
                openProjectCreateDrawer({
                    isNextGen: true,
                    selectedProjectType: 'business',
                    showExperienceSelection: false,
                    defaultSelectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                    source: (0, (0, parcelRequire("gb5lQ")).LOCATION),
                    ...shouldUseNewRecommendations && {
                        recommendationSessionId: recommendationSessionId
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateTemplate', {
                    selectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                    isLastUsed: isLastUsed,
                    isRecommended: isRecommended,
                    templateType: templateType,
                    recommendationSessionId: recommendationSessionId
                });
            }, [
            createAnalyticsEvent,
            openProjectCreateDrawer,
            recommendationSessionId,
            shouldUseNewRecommendations
        ]);
        const handleMoreTemplatesClick = (0, $5uXOq.useCallback)(()=>{
            openProjectCreateDrawer({
                isNextGen: true,
                showExperienceSelection: false,
                source: (0, (0, parcelRequire("gb5lQ")).LOCATION)
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateMoreTemplates');
        }, [
            createAnalyticsEvent,
            openProjectCreateDrawer
        ]);
        const handleImportButtonClick = (0, $5uXOq.useCallback)(()=>{
            openProjectCreateDrawer({
                isNextGen: true,
                showExperienceSelection: false,
                source: (0, (0, parcelRequire("gb5lQ")).LOCATION),
                isImportProjectOpenInitially: true
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateImport');
        }, [
            createAnalyticsEvent,
            openProjectCreateDrawer
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h5xhD")).default), {
            minWidth: $47229cd857e246da$var$POPUP_WIDTH,
            testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.popup-menu-group"
        }, loading ? (0, ($parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$export$675ac63e0637d34d, null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            title: formatMessage((0, (0, parcelRequire("2H5YM")).default).sectionTitle)
        }, Array.isArray(templates) && templates.map(({ iconUrl: iconUrl, key: key, projectTypeTemplates: projectTypeTemplates, title: title, isLastUsed: isLastUsed = false, isRecommended: isRecommended = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.button-item",
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$var$StyledImage, {
                    src: iconUrl,
                    alt: `${title.label} icon`
                }),
                key: key,
                onClick: handleTemplateClick(projectTypeTemplates, isLastUsed, isRecommended, key)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$var$ButtonText, null, title.label), isLastUsed && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, formatMessage((0, (0, parcelRequire("2H5YM")).default).lastCreated))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button",
            onClick: handleMoreTemplatesClick
        }, formatMessage((0, (0, parcelRequire("2H5YM")).default).moreTemplatesButtonText)), (isSiteAdmin || isAdmin && (0, (0, parcelRequire("co1wz")).ff)('enable-product-admin-for-x2c-migration_zmlsv') || !isAdmin) && !(0, (0, parcelRequire("aIZdc")).isFedRamp)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.import-button",
            onClick: handleImportButtonClick
        }, formatMessage((0, (0, parcelRequire("2H5YM")).default).importButtonText)))));
    };
    var $47229cd857e246da$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($47229cd857e246da$var$TemplatePicker);
    const $47229cd857e246da$var$StyledImage = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _1bsbzwfg _5ral1dfr",
                __cmplp.className
            ])
        });
    });
    const $47229cd857e246da$var$SpinnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbclpc _1e0c1txw _4cvr1h6o _1bah1h6o _1yt4zu5n",
                __cmplp.className
            ])
        });
    });
    const $47229cd857e246da$var$ButtonText = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxutpp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("h5xhD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92a58bdbbfac4ce9$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eZUJu;
    const $92a58bdbbfac4ce9$var$PopupMenuGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZUJu")).default), {
            maxWidth: maxWidth,
            minWidth: minWidth,
            ...rest
        });
    var $92a58bdbbfac4ce9$export$2e2bcd8739ae039 = $92a58bdbbfac4ce9$var$PopupMenuGroup;
});
parcelRegister("2H5YM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ad55b7f9c6c06ab$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6ad55b7f9c6c06ab$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sectionTitle: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.section-title",
            "defaultMessage": "Start a new project"
        },
        moreTemplatesButtonText: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button-text",
            "defaultMessage": "More templates"
        },
        importButtonText: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.import-button-text",
            "defaultMessage": "Import"
        },
        lastCreated: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.last-created",
            "defaultMessage": "Last created"
        }
    });
});
parcelRegister("e7C7O", function(module, exports) {
    $parcel$export(module.exports, "fieldSettingsRelayResource", ()=>$424e18beff0a1aec$export$68b4e700e00bad7a);
    var $ao2h1;
    var $gF6UW;
    var $1nb22;
    const $424e18beff0a1aec$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS = 'PROJECT_SETTINGS_FIELDS';
    const $424e18beff0a1aec$export$68b4e700e00bad7a = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $424e18beff0a1aec$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS,
        getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return {
                parameters: (0, (0, parcelRequire("gF6UW")).default),
                variables: {
                    projectKey: projectKey ?? '',
                    cloudId: tenantContext.cloudId ?? ''
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            };
        }
    });
});
parcelRegister("gF6UW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e41b4fca86430f4d$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    const $e41b4fca86430f4d$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v2 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v3 = [
            v2,
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ], v4 = [
            v2,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "isExplicitFieldAssociationsEnabled"
        }, v6 = {
            "kind": "ScalarField",
            "name": "name"
        }, v7 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }, v8 = {
            "kind": "ScalarField",
            "name": "issueTypeId"
        }, v9 = {
            "kind": "ScalarField",
            "name": "id"
        }, v10 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 30
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "uiFieldsPageQuery",
                "selections": [
                    {
                        "args": v3,
                        "kind": "FragmentSpread",
                        "name": "fieldsTable_projectFields"
                    },
                    {
                        "args": v3,
                        "kind": "FragmentSpread",
                        "name": "pageHeader_projectFields_Header"
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v4,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v5
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "uiFieldsPageQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v4,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v6,
                                    v7,
                                    {
                                        "concreteType": "JiraIssueTypeConnection",
                                        "kind": "LinkedField",
                                        "name": "issueTypes",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueTypeEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            v6,
                                                            v7,
                                                            v9
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "projectId"
                                    },
                                    {
                                        "concreteType": "JiraProjectWithIssueTypeIds",
                                        "kind": "LinkedField",
                                        "name": "projectWithVisibleIssueTypeIds",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": v10,
                                                "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldAssociationWithIssueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraFieldAssociationWithIssueTypes",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraField",
                                                                        "kind": "LinkedField",
                                                                        "name": "field",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "fieldId"
                                                                            },
                                                                            v9,
                                                                            v6,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "scope"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "typeKey"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "typeName"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "description"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "hasMissingConfiguration"
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraIssueTypeConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypes",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueTypeEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueType",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v6,
                                                                                            v7,
                                                                                            v9,
                                                                                            v8
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v9,
                                                                    {
                                                                        "concreteType": "JiraFieldOperation",
                                                                        "kind": "LinkedField",
                                                                        "name": "fieldOperation",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "canRemove"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "canAssociateInSettings"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "isFieldLocked"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "__typename"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "cursor"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "PageInfo",
                                                        "kind": "LinkedField",
                                                        "name": "pageInfo",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "hasNextPage"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "endCursor"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__id"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                                            },
                                            {
                                                "args": v10,
                                                "handle": "connection",
                                                "key": "fieldsTable_fieldAssociationWithIssueTypes",
                                                "kind": "LinkedHandle",
                                                "name": "fieldAssociationWithIssueTypes"
                                            }
                                        ]
                                    },
                                    v9,
                                    v5
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "290cad67e5783981d6d341be35586585f716aa1a725de651aa2338d90128ca5c",
                "metadata": {},
                "name": "uiFieldsPageQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $e41b4fca86430f4d$var$node.hash = "72c7746a41a19b203b9890c0bf92671f";
    (0, $eiowN.PreloadableQueryRegistry).set($e41b4fca86430f4d$var$node.params.id, $e41b4fca86430f4d$var$node);
    var $e41b4fca86430f4d$export$2e2bcd8739ae039 = $e41b4fca86430f4d$var$node;
});
parcelRegister("jaAyo", function(module, exports) {
    $parcel$export(module.exports, "ProjectSettingsAccessSkeleton", ()=>$e950186edd3e49fd$export$e6cc5ccd52c7fd63);
    $parcel$export(module.exports, "ProjectSettingsDetailsSkeleton", ()=>$e950186edd3e49fd$export$bd7fd4005b84aec9);
    $parcel$export(module.exports, "ProjectSettingsFeaturesSkeleton", ()=>$e950186edd3e49fd$export$ec1cdd0c8335373c);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $7TlNQ = parcelRequire("7TlNQ");
    var $jTu83 = parcelRequire("jTu83");
    var $l6s4f = parcelRequire("l6s4f");
    const $e950186edd3e49fd$var$customCssStyles = null;
    const $e950186edd3e49fd$var$listOnlyStyles = null;
    const $e950186edd3e49fd$export$e6cc5ccd52c7fd63 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($7TlNQ))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s85ogf _p12f1qe4 _11y7oza4"
            ])
        });
    const $e950186edd3e49fd$export$bd7fd4005b84aec9 = ({ isListOnly: isListOnly = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($jTu83))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                isListOnly ? "_1wgmglyw _rcuj1bdq" : "_18s85ogf _p12f1qe4 _11y7oza4"
            ])
        });
    const $e950186edd3e49fd$export$ec1cdd0c8335373c = ({ isListOnly: isListOnly = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($l6s4f))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                isListOnly ? "_1wgmglyw _rcuj1bdq" : "_18s85ogf _p12f1qe4 _11y7oza4"
            ])
        });
});
parcelRegister("7TlNQ", function(module, exports) {
    module.exports = new URL("project-settings-access-app-skeleton.tpl.21bb94b1.svg", import.meta.url).toString();
});
parcelRegister("jTu83", function(module, exports) {
    module.exports = new URL("project-settings-details-app-skeleton.tpl.c4ebc2fd.svg", import.meta.url).toString();
});
parcelRegister("l6s4f", function(module, exports) {
    module.exports = new URL("project-settings-features-app-skeleton.tpl.b8e7f249.svg", import.meta.url).toString();
});
parcelRegister("aIXb8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1lXo2")
    ]).then(()=>parcelRequire('8gPdF'));
});
parcelRegister("dGsmU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("k7BTo").then(()=>parcelRequire('6ZR0a'));
});
parcelRegister("2RcTH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eNxsN")
    ]).then(()=>parcelRequire('aRrWI'));
});
parcelRegister("fYshJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4a74D")
    ]).then(()=>parcelRequire('fEx2J'));
});
parcelRegister("RJn1w", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cYKQ3").then(()=>parcelRequire('79qwo'));
});
parcelRegister("6JK34", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7gKdX").then(()=>parcelRequire('kO3mB'));
});
parcelRegister("fU2jM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7Jjzg")
    ]).then(()=>parcelRequire('9vEjY'));
});
parcelRegister("6Eu7X", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gP6jR").then(()=>parcelRequire('7N8D9'));
});
parcelRegister("dju2Q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dWKlO")
    ]).then(()=>parcelRequire('ciDU2'));
});
parcelRegister("6luCE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iwPab")
    ]).then(()=>parcelRequire('1XLXC'));
});
parcelRegister("c32Mm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("e61bl").then(()=>parcelRequire('ieTY5'));
});
parcelRegister("lvyS5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1gaf4").then(()=>parcelRequire('giI7i'));
});
parcelRegister("hM6gT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kn4Lg").then(()=>parcelRequire('d6iMp'));
});
parcelRegister("3kJhU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("414RV").then(()=>parcelRequire('ln9R3'));
});
parcelRegister("gmE3I", function(module, exports) {
    $parcel$export(module.exports, "jsmChangeManagementSettingsGitLabGatingResource", ()=>$ff8ead4f49d1e745$export$315b6278d34861b4);
    $parcel$export(module.exports, "useGitLabGatingResource", ()=>$ff8ead4f49d1e745$export$dd3715dce02ee460);
    var $5uXOq = parcelRequire("5uXOq");
    var $2M1hQ;
    var $2YP9W;
    const $ff8ead4f49d1e745$var$getDataLoader = ()=>(parcelRequire("7Hzl8"));
    const $ff8ead4f49d1e745$export$315b6278d34861b4 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
        getKey: ()=>'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
        getDataLoader: $ff8ead4f49d1e745$var$getDataLoader,
        maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
    const $ff8ead4f49d1e745$export$dd3715dce02ee460 = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, (0, parcelRequire("2YP9W")).useResource)($ff8ead4f49d1e745$export$315b6278d34861b4);
        (0, $5uXOq.useEffect)(()=>{
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            error,
            refresh
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: data?.data,
                pending: loading,
                error: data?.error || error
            }), [
            data,
            loading,
            error
        ]);
    };
});
parcelRegister("7Hzl8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hzh3H").then(()=>parcelRequire('4y3Yq'));
});
parcelRegister("2pT4g", function(module, exports) {
    $parcel$export(module.exports, "jsmRepackagingBannerResource", ()=>$f325ae4fdb8711ab$export$760ca885f96dacb6);
    $parcel$export(module.exports, "useJsmRepackagingBannerResource", ()=>$f325ae4fdb8711ab$export$f1444ccc5653a5cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $2M1hQ;
    var $2YP9W;
    var $daiqe;
    const $f325ae4fdb8711ab$var$getDataLoader = ()=>(parcelRequire("bjdPq"));
    const $f325ae4fdb8711ab$export$760ca885f96dacb6 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'JSM_REPACKAGING_BANNER',
        getKey: ()=>'JSM_REPACKAGING_BANNER',
        getDataLoader: $f325ae4fdb8711ab$var$getDataLoader,
        maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
    const $f325ae4fdb8711ab$export$f1444ccc5653a5cb = (workCategory, accountId)=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, (0, parcelRequire("2YP9W")).useResource)($f325ae4fdb8711ab$export$760ca885f96dacb6);
        (0, $5uXOq.useEffect)(()=>{
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            refresh,
            error
        ]);
        return (0, $5uXOq.useMemo)(()=>{
            if (error || loading || !data || !accountId) return {
                show: false
            };
            const { bannerMeta: bannerMeta, bannerDismissState: bannerDismissState } = data;
            const workCategoryDismissState = bannerDismissState?.[workCategory];
            if (!bannerMeta.show || !(bannerMeta.type === 'info' || bannerMeta.type === 'warning')) return {
                show: false
            };
            if (!workCategoryDismissState) return {
                ...bannerDismissState,
                ...bannerMeta,
                refresh: refresh
            };
            if (workCategoryDismissState.packagingChangeDate !== bannerMeta.data.packagingChangeDate) {
                (0, (0, parcelRequire("daiqe")).deleteBannerDismissState)({
                    accountId: accountId
                });
                return {
                    ...bannerMeta,
                    refresh: refresh
                };
            }
            if (workCategoryDismissState.bannerHiddenUntil > Date.now()) return {
                show: false
            };
            return {
                ...bannerMeta,
                ...bannerDismissState,
                refresh: refresh
            };
        }, [
            data,
            loading,
            error,
            workCategory,
            accountId,
            refresh
        ]);
    };
});
parcelRegister("daiqe", function(module, exports) {
    $parcel$export(module.exports, "deleteBannerDismissState", ()=>$00907b0f6d0c25ed$export$e21bb99d98e8c8b4);
    var $jcw0u;
    var $eusud;
    async function $00907b0f6d0c25ed$export$e21bb99d98e8c8b4({ accountId: accountId }) {
        try {
            await (0, (0, parcelRequire("eusud")).performDeleteRequest)(`/rest/api/3/user/properties/jsm-repackaging-banners-dismiss-state?accountId=${accountId}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'deleteBannerDismissState',
                    packageName: 'jiraRouterResourcesJsmRepackagingBanner',
                    teamName: 'jenga'
                },
                error: error
            });
        }
    }
});
parcelRegister("bjdPq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cVV3d").then(()=>parcelRequire('iKQCz'));
});
parcelRegister("10cgn", function(module, exports) {
    $parcel$export(module.exports, "customerPermissionsPageDataResource", ()=>$35508436fc3abfb3$export$ae3446385906310c);
    var $2M1hQ;
    const $35508436fc3abfb3$export$ae3446385906310c = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $9cf87aec7862b8b9$export$34a89f9aaa677bb5),
        getKey: ({ match: match })=>match.params.projectKey || '',
        getDataLoader: ()=>(parcelRequire("6gDxz")),
        maxAge: Infinity
    });
});
const $9cf87aec7862b8b9$export$34a89f9aaa677bb5 = 'CUSTOMER_PERMISSIONS';
parcelRegister("6gDxz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3ygSW").then(()=>parcelRequire('i9zBn'));
});
parcelRegister("8CwPO", function(module, exports) {
    $parcel$export(module.exports, "portalSettingsContextResource", ()=>$9dfc351c3ebf85b6$export$4a3e29f235f3320c);
    var $2M1hQ;
    const $9dfc351c3ebf85b6$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT = 'PORTAL_SETTINGS_CONTEXT';
    const $9dfc351c3ebf85b6$export$4a3e29f235f3320c = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $9dfc351c3ebf85b6$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT,
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("iwaKU"))
    });
});
parcelRegister("iwaKU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kQRxS").then(()=>parcelRequire('7wy1U'));
});
parcelRegister("1eBsr", function(module, exports) {
    $parcel$export(module.exports, "getProjectSettingsUrl", ()=>$ca1b89b4eaa32595$export$a497c8f8c3782075);
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$ca1b89b4eaa32595$export$5575497f0592ee94);
    const $ca1b89b4eaa32595$export$a497c8f8c3782075 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $ca1b89b4eaa32595$export$5575497f0592ee94 = 'servicedesk';
});
parcelRegister("8YZBz", function(module, exports) {
    $parcel$export(module.exports, "servicedeskPlaybooksListRoute", ()=>$39cfce4bc27a2e92$export$cbed08b5b0671f5f);
    var $65Ltd;
    var $1eBsr;
    const $39cfce4bc27a2e92$export$cbed08b5b0671f5f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLAYBOOKS_LIST),
        path: `${(0, (0, parcelRequire("1eBsr")).getProjectSettingsUrl)((0, (0, parcelRequire("1eBsr")).SERVICE_DESK_PRODUCT))}/playbooks`,
        exact: true
    };
});
parcelRegister("3JBxD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9YF2g")
    ]).then(()=>parcelRequire('79e1o'));
});
parcelRegister("8fDOc", function(module, exports) {
    $parcel$export(module.exports, "playbookListEntryPoint", ()=>$d77fb854f7f8e8b8$export$d7be5d3b24f1d526);
    var $eufEc;
    var $fEDBv;
    const $d77fb854f7f8e8b8$export$d7be5d3b24f1d526 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("jCfPa")), {
            moduleId: "97555e42"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                extraProps: {
                    cloudId: cloudId
                }
            })
    });
});
parcelRegister("jCfPa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lVFAL").then(()=>parcelRequire('iT2g5'));
});
parcelRegister("6YEEX", function(module, exports) {
    $parcel$export(module.exports, "playbookLogsEntryPoint", ()=>$60633bec6dffe3a8$export$7ebe0f850472ea07);
    var $eufEc;
    var $fEDBv;
    const $60633bec6dffe3a8$export$7ebe0f850472ea07 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("dOnuK")), {
            moduleId: "1ddad45d"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                extraProps: {
                    cloudId: cloudId
                }
            })
    });
});
parcelRegister("dOnuK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9ctOi").then(()=>parcelRequire('arpva'));
});
parcelRegister("8RxBf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("la2ji").then(()=>parcelRequire('6o22p'));
});
parcelRegister("h1R4C", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsEmailNextGenRoute", ()=>$2cd6daab9a52615c$export$b03f0a1a580a902f);
    var $65Ltd;
    var $fFv0O;
    const $2cd6daab9a52615c$export$b03f0a1a580a902f = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-email-next-gen`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/channels/email`,
        exact: true
    };
});
parcelRegister("dD71x", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDataClassificationsRoute", ()=>$8633b140bc357883$export$1596046a0b047934);
    var $65Ltd;
    var $fFv0O;
    const $8633b140bc357883$export$1596046a0b047934 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-data-classifications`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/data-classifications`,
        exact: true
    };
});
parcelRegister("7dxyN", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDetailsRoute", ()=>$861c2e896d5db081$export$b237f4f6820b26e9);
    var $65Ltd;
    var $fFv0O;
    const $861c2e896d5db081$export$b237f4f6820b26e9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/details`,
        exact: true
    };
});
parcelRegister("4dsIk", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskItsmFeaturesRoute", ()=>$c2e902b46a626991$export$324e5a618f1ac5a1);
    var $65Ltd;
    var $fFv0O;
    const $c2e902b46a626991$export$324e5a618f1ac5a1 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-features`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/itsm-features`,
        exact: true
    };
});
parcelRegister("d3Aot", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguage1Route", ()=>$9049738f6078be8b$export$8152b460f5961d94);
    var $65Ltd;
    var $fFv0O;
    const $9049738f6078be8b$export$8152b460f5961d94 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-language`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/language`,
        exact: true
    };
});
parcelRegister("6Y0Zp", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguageKeyRoute", ()=>$4fc67dd2939f4f44$export$d195c572a6155c05);
    var $65Ltd;
    var $fFv0O;
    const $4fc67dd2939f4f44$export$d195c572a6155c05 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-language-key`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/language/:languageKey/:sidebarItemKey?`
    };
});
parcelRegister("f4piI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kkgDQ").then(()=>parcelRequire('9Qg7T'));
});
parcelRegister("gCMPW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7C5bc").then(()=>parcelRequire('7uVkM'));
});
parcelRegister("bSsDz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1PFOk").then(()=>parcelRequire('44UJy'));
});
parcelRegister("aP8ev", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9udti").then(()=>parcelRequire('6kXBX'));
});
parcelRegister("l7KAf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hKaWl").then(()=>parcelRequire('5jbPW'));
});
parcelRegister("8WSu7", function(module, exports) {
    $parcel$export(module.exports, "getSettingsPath", ()=>$b4b4e7a1fd793539$export$67417cd3aaee582d);
    const $b4b4e7a1fd793539$export$67417cd3aaee582d = (path, isJCS)=>isJCS ? path.replace('/jira/servicedesk/', '/jira/helpcenter/') : path;
});
parcelRegister("aTz47", function(module, exports) {
    $parcel$export(module.exports, "isHelpCenterSettingsPath", ()=>$1e0d45f36b27f85a$export$bf8b98b87d485657);
    var $gKZoD;
    var $4R6GH;
    const $1e0d45f36b27f85a$export$bf8b98b87d485657 = ()=>{
        (0, (0, parcelRequire("gKZoD")).di)(window);
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag')) return false;
        if (!false) return window.location.pathname.includes('jira/helpcenter/');
        return false;
    };
});
parcelRegister("jEJ7g", function(module, exports) {
    $parcel$export(module.exports, "useIsJCS", ()=>$db67bf04078e8532$export$927b5354181b3adf);
    $parcel$export(module.exports, "useAsyncIsJCS", ()=>$db67bf04078e8532$export$3894a8f24b665478);
    $parcel$export(module.exports, "isJCSTemplate", ()=>$db67bf04078e8532$export$afee907b7a66ef2b);
    var $e5wyW;
    var $4R6GH;
    var $O4MMs;
    const $db67bf04078e8532$var$useIsJCSUnderFF = ()=>{
        const { 'initial.project.template.name': initialProjectTemplate } = (0, (0, parcelRequire("O4MMs")).useProjectProperties)([
            'initial.project.template.name'
        ]);
        return initialProjectTemplate === 'com.atlassian.jcs:customer-service-management';
    };
    const $db67bf04078e8532$export$927b5354181b3adf = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag'), $db67bf04078e8532$var$useIsJCSUnderFF, ()=>false);
    const $db67bf04078e8532$var$useAsyncIsJCSUnderFF = ()=>{
        const { 'initial.project.template.name': initialProjectTemplate } = (0, (0, parcelRequire("O4MMs")).useProjectProperties)([
            'initial.project.template.name'
        ]);
        return initialProjectTemplate ? initialProjectTemplate === 'com.atlassian.jcs:customer-service-management' : undefined;
    };
    const $db67bf04078e8532$export$3894a8f24b665478 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag'), $db67bf04078e8532$var$useAsyncIsJCSUnderFF, ()=>false);
    const $db67bf04078e8532$var$isJCSTemplateUnderFF = (template)=>template === 'com.atlassian.jcs:customer-service-management';
    const $db67bf04078e8532$var$isJCSTemplateFallback = (template)=>false;
    const $db67bf04078e8532$export$afee907b7a66ef2b = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag'), $db67bf04078e8532$var$isJCSTemplateUnderFF, $db67bf04078e8532$var$isJCSTemplateFallback);
});
parcelRegister("O4MMs", function(module, exports) {
    $parcel$export(module.exports, "useProjectProperties", ()=>$eccdf8f1b49d4032$export$58be98885c2d686a);
    var $5uXOq = parcelRequire("5uXOq");
    var $74ySO = parcelRequire("74ySO");
    var $ajpes = parcelRequire("ajpes");
    var $4f8Oj = parcelRequire("4f8Oj");
    var $lpwtK;
    var $1XJ20;
    var $8zOmE;
    var $2NMNM;
    var $3sQ5x;
    var $iXqE5;
    var $dYZ0w;
    const $eccdf8f1b49d4032$export$d4c72bab9d6cc13a = {};
    const $eccdf8f1b49d4032$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'project-properties',
        initialState: $eccdf8f1b49d4032$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("dYZ0w")).actions
    });
    const $eccdf8f1b49d4032$export$eebf791068e870dd = (0, (0, parcelRequire("3sQ5x")).createHook)($eccdf8f1b49d4032$var$Store);
    const $eccdf8f1b49d4032$export$58be98885c2d686a = (propertyKeys, projectIdOverride)=>{
        const { data: data } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const projectId = projectIdOverride !== undefined ? projectIdOverride : data?.id && `${data.id}`;
        const [state, { get: get }] = $eccdf8f1b49d4032$export$eebf791068e870dd();
        const prevPropertyKeys = (0, (0, parcelRequire("1XJ20")).usePrevious)(propertyKeys);
        (0, $5uXOq.useEffect)(()=>{
            if (projectId === undefined) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraProjectPropertiesServices undefinedProjectId');
            if ((0, ($parcel$interopDefault($ajpes)))(propertyKeys, prevPropertyKeys) && !projectIdOverride) return;
            if (projectId) get(projectId, propertyKeys);
        }, [
            projectId,
            propertyKeys,
            prevPropertyKeys,
            get,
            createAnalyticsEvent,
            projectIdOverride
        ]);
        return projectId !== undefined ? (0, ($parcel$interopDefault($4f8Oj)))(state[projectId], (_, key)=>(0, ($parcel$interopDefault($74ySO)))(propertyKeys, key)) : {};
    };
});
parcelRegister("74ySO", function(module, exports) {
    var $2wwA6 = parcelRequire("2wwA6");
    var $hTJwX = parcelRequire("hTJwX");
    var $agVdz = parcelRequire("agVdz");
    var $kPZpS = parcelRequire("kPZpS");
    var $dMEgP = parcelRequire("dMEgP");
    var $5263f72d78aeaf9c$var$nativeMax = Math.max;
    function $5263f72d78aeaf9c$var$includes(collection, value, fromIndex, guard) {
        collection = $hTJwX(collection) ? collection : $dMEgP(collection);
        fromIndex = fromIndex && !guard ? $kPZpS(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) fromIndex = $5263f72d78aeaf9c$var$nativeMax(length + fromIndex, 0);
        return $agVdz(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $2wwA6(collection, value, fromIndex) > -1;
    }
    module.exports = $5263f72d78aeaf9c$var$includes;
});
parcelRegister("agVdz", function(module, exports) {
    var $beQoo = parcelRequire("beQoo");
    var $8LQ84 = parcelRequire("8LQ84");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $77a7c84c5ee0b808$var$stringTag = '[object String]';
    function $77a7c84c5ee0b808$var$isString(value) {
        return typeof value == 'string' || !$8LQ84(value) && $fC1Kz(value) && $beQoo(value) == $77a7c84c5ee0b808$var$stringTag;
    }
    module.exports = $77a7c84c5ee0b808$var$isString;
});
parcelRegister("dYZ0w", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$d36e01b4b5883936$export$e324594224ef24da);
    var $9Tr6m;
    const $d36e01b4b5883936$export$e324594224ef24da = {
        get: (0, parcelRequire("9Tr6m")).get
    };
});
parcelRegister("9Tr6m", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$52dc90cc0afc52f4$export$3988ae62b71be9a3);
    var $k8IPx = parcelRequire("k8IPx");
    var $cjFoH = parcelRequire("cjFoH");
    var $66FNL = parcelRequire("66FNL");
    var $fUPWG;
    const $52dc90cc0afc52f4$export$3988ae62b71be9a3 = (projectId, properties)=>({ getState: getState, setState: setState })=>{
            const currentProperties = getState()[projectId] || {};
            const missingProperties = (0, ($parcel$interopDefault($k8IPx)))(properties, (0, ($parcel$interopDefault($66FNL)))(currentProperties));
            missingProperties.length && (0, (0, parcelRequire("fUPWG")).default)({
                baseUrl: '',
                projectId: projectId,
                properties: missingProperties
            }).then((fetchedProperties)=>{
                const latestProperties = getState()[projectId] || {};
                setState({
                    [projectId]: {
                        ...latestProperties,
                        ...missingProperties.reduce((result, name)=>{
                            const reducedResult = result;
                            const fetchedProperty = fetchedProperties[name];
                            reducedResult[name] = (0, ($parcel$interopDefault($cjFoH)))(fetchedProperty) ? null : fetchedProperty;
                            return reducedResult;
                        }, {})
                    }
                });
            });
        };
});
parcelRegister("k8IPx", function(module, exports) {
    var $55pzo = parcelRequire("55pzo");
    var $ekcP3 = parcelRequire("ekcP3");
    var $g7i7g = parcelRequire("g7i7g");
    var $f3SOL = parcelRequire("f3SOL");
    var $ea975459f1938a58$var$difference = $g7i7g(function(array, values) {
        return $f3SOL(array) ? $55pzo(array, $ekcP3(values, 1, $f3SOL, true)) : [];
    });
    module.exports = $ea975459f1938a58$var$difference;
});
parcelRegister("55pzo", function(module, exports) {
    var $ijRUK = parcelRequire("ijRUK");
    var $fUP98 = parcelRequire("fUP98");
    var $dA3tP = parcelRequire("dA3tP");
    var $1nIHN = parcelRequire("1nIHN");
    var $cW28x = parcelRequire("cW28x");
    var $40I25 = parcelRequire("40I25");
    var $3b41410a547f22d2$var$LARGE_ARRAY_SIZE = 200;
    function $3b41410a547f22d2$var$baseDifference(array, values, iteratee, comparator) {
        var index = -1, includes = $fUP98, isCommon = true, length = array.length, result = [], valuesLength = values.length;
        if (!length) return result;
        if (iteratee) values = $1nIHN(values, $cW28x(iteratee));
        if (comparator) {
            includes = $dA3tP;
            isCommon = false;
        } else if (values.length >= $3b41410a547f22d2$var$LARGE_ARRAY_SIZE) {
            includes = $40I25;
            isCommon = false;
            values = new $ijRUK(values);
        }
        outer: while(++index < length){
            var value = array[index], computed = iteratee == null ? value : iteratee(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while(valuesIndex--){
                    if (values[valuesIndex] === computed) continue outer;
                }
                result.push(value);
            } else if (!includes(values, computed, comparator)) result.push(value);
        }
        return result;
    }
    module.exports = $3b41410a547f22d2$var$baseDifference;
});
parcelRegister("fUPWG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$573d8b462e0e2ec6$export$2e2bcd8739ae039);
    var $1sYcL;
    var $573d8b462e0e2ec6$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, projectId: projectId, properties: properties })=>{
        const { project: project } = await (0, (0, parcelRequire("1sYcL")).get)(baseUrl, {
            projectId: projectId,
            projectProperties: properties,
            consumerMeta: {
                id: 'remoteGet',
                packageName: 'jiraProjectPropertiesServices',
                teamName: 'jsd-shield'
            }
        });
        return project;
    };
});
parcelRegister("eDXxK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lxzGu").then(()=>parcelRequire('jp5Rx'));
});
parcelRegister("8u8s7", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskJourneyConfigurationRoute", ()=>$c2c8c35cb52e32ae$export$c0d493d5e7c848d0);
    var $65Ltd;
    const $c2c8c35cb52e32ae$export$c0d493d5e7c848d0 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-journey-configuration`,
        path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId',
        exact: true
    };
});
parcelRegister("7ptuV", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskJourneysRoute", ()=>$96dc27eb8bb78c72$export$94adf8e91b84b806);
    var $65Ltd;
    const $96dc27eb8bb78c72$export$94adf8e91b84b806 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-journeys`,
        path: '/jira/servicedesk/projects/:projectKey/settings/journeys',
        exact: true
    };
});
parcelRegister("dnPrO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iUjK0")
    ]).then(()=>parcelRequire('aG5pa'));
});
parcelRegister("ec5aY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g2xfa").then(()=>parcelRequire('iSwlg'));
});
parcelRegister("8G8Xo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("84U6s").then(()=>parcelRequire('2fak7'));
});
parcelRegister("jpppj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("2IJUz")
    ]).then(()=>parcelRequire('gCbsh'));
});
parcelRegister("4wBwP", function(module, exports) {
    $parcel$export(module.exports, "slaMetricsDataResource", ()=>$5bd842d236781a2e$export$6cdfca3e816e9661);
    var $2M1hQ;
    const $5bd842d236781a2e$export$c5fa03c9ad8df0e2 = 'SLA_METRICS';
    const $5bd842d236781a2e$export$6cdfca3e816e9661 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $5bd842d236781a2e$export$c5fa03c9ad8df0e2,
        getKey: ({ match: match })=>match.params.projectKey || '',
        getDataLoader: ()=>(parcelRequire("c7Qcd")),
        maxAge: Infinity
    });
});
parcelRegister("c7Qcd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g759n").then(()=>parcelRequire('dxWU3'));
});
parcelRegister("g4dfU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gUg0Z").then(()=>parcelRequire('1rjw0'));
});
parcelRegister("k4XYc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9pCQy")
    ]).then(()=>parcelRequire('73hU9'));
});
parcelRegister("a7j22", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b1kaE")
    ]).then(()=>parcelRequire('7wKb0'));
});
parcelRegister("e9zsZ", function(module, exports) {
    $parcel$export(module.exports, "servicedeskVirtualAgentAiAnswersKbResource", ()=>$adb9f25d3efd6c0f$export$6aecd43ca01da0d9);
    var $2M1hQ;
    const $adb9f25d3efd6c0f$var$getDataLoader = ()=>(parcelRequire("lsDqC"));
    const $adb9f25d3efd6c0f$export$6aecd43ca01da0d9 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'SERVICEDESK_VIRTUAL_AGENT_AI_ANSWERS_KB_RESOURCE',
        getKey: ({ match: { params: params } })=>params.projectKey || '',
        getDataLoader: $adb9f25d3efd6c0f$var$getDataLoader,
        isBrowserOnly: true
    });
});
parcelRegister("lsDqC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("c3CmY").then(()=>parcelRequire('cJzMU'));
});
parcelRegister("hsmeR", function(module, exports) {
    $parcel$export(module.exports, "useActiveRightSidebarState", ()=>$39a48ee662f10943$export$ba763ab7661c3103);
    $parcel$export(module.exports, "useRightSidebarState", ()=>$39a48ee662f10943$export$d1828e7f46a4960b);
    $parcel$export(module.exports, "useRightSidebarController", ()=>$39a48ee662f10943$export$ebe5e907fb0bb63a);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $byk51;
    var $5e5zm;
    const $39a48ee662f10943$var$useActiveRightSidebar = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>{
            const rightSidebarState = (0, (0, parcelRequire("byk51")).selectCurrentRightSidebar)(state.content.rightSidebar);
            if (!rightSidebarState) return null;
            return {
                ...rightSidebarState,
                shouldRender: !state.isChromeless
            };
        }
    });
    const $39a48ee662f10943$export$ba763ab7661c3103 = ()=>{
        const [rightSidebar] = $39a48ee662f10943$var$useActiveRightSidebar();
        return rightSidebar;
    };
    const $39a48ee662f10943$var$useRightSidebar = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>state.content.rightSidebar
    });
    const $39a48ee662f10943$export$d1828e7f46a4960b = ()=>{
        const [rightSidebarState] = $39a48ee662f10943$var$useRightSidebar();
        return rightSidebarState;
    };
    const $39a48ee662f10943$export$ebe5e907fb0bb63a = ()=>{
        const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, (0, parcelRequire("5e5zm")).useLayoutStoreActions)();
        return (0, $5uXOq.useMemo)(()=>({
                setRightSidebarState: setRightSidebarState,
                closeRightSidebar: closeRightSidebar,
                openRightSidebar: openRightSidebar,
                closeCurrentRightSidebar: closeCurrentRightSidebar,
                closeAllRightSidebar: closeAllRightSidebar,
                minimiseRightSidebar: minimiseRightSidebar
            }), [
            closeAllRightSidebar,
            closeCurrentRightSidebar,
            closeRightSidebar,
            openRightSidebar,
            setRightSidebarState,
            minimiseRightSidebar
        ]);
    };
});
parcelRegister("lRe5k", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("bTdk8")
    ]).then(()=>parcelRequire('dMvBS'));
});
parcelRegister("av9sZ", function(module, exports) {
    $parcel$export(module.exports, "ErrorDisplay", ()=>$09828373404eee09$export$d56b0569bceb92ae);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $hTEpF;
    var $7q5TP;
    var $iVgQf;
    var $koVbs;
    var $2zwTA;
    const $09828373404eee09$export$d56b0569bceb92ae = ({ refetch: refetch })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            header: formatMessage((0, (0, parcelRequire("2zwTA")).default).errorDisplayHeading),
            description: formatMessage((0, (0, parcelRequire("2zwTA")).default).errorDisplayDescription),
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("7q5TP")).default)),
            imageWidth: 160,
            maxImageHeight: 220,
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                onClick: refetch,
                appearance: "link"
            }, formatMessage((0, (0, parcelRequire("2zwTA")).default).reloadNowButtonText))
        });
    };
});
parcelRegister("7q5TP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc8d7b09135bd30b$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("8ODZY")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("b2nX8")))));
    var $dCLgq;
    var $b2nX8 = parcelRequire("b2nX8");
    var $8ODZY = parcelRequire("8ODZY");
    const $dc8d7b09135bd30b$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($8ODZY)),
        srcDark: ($parcel$interopDefault($b2nX8))
    });
    var $dc8d7b09135bd30b$export$2e2bcd8739ae039 = $dc8d7b09135bd30b$var$Illustration;
    const $dc8d7b09135bd30b$export$a179c88182cb9d56 = [
        0,
        0,
        164,
        212
    ];
});
parcelRegister("dCLgq", function(module, exports) {
    $parcel$export(module.exports, "Illustration", ()=>$191b30bb5e9fa934$export$d43c2e2ca9b2c105);
    $parcel$export(module.exports, "createIllustration", ()=>$191b30bb5e9fa934$export$4d00e7be716a0093);
    var $5uXOq = parcelRequire("5uXOq");
    var $10ozQ;
    function $191b30bb5e9fa934$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("10ozQ")).AsImg), props);
    }
    function $191b30bb5e9fa934$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($191b30bb5e9fa934$export$d43c2e2ca9b2c105, {
                srcLight: srcLight,
                srcDark: srcDark,
                autoDark: autoDark,
                ...props
            });
    }
});
parcelRegister("10ozQ", function(module, exports) {
    $parcel$export(module.exports, "AsImg", ()=>$b5af8835f639f069$export$75e378065cb7d6c0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    const $b5af8835f639f069$var$defaultStyles = null;
    const $b5af8835f639f069$var$fillStyles = null;
    const $b5af8835f639f069$var$autoDarkModeStyles = null;
    function $b5af8835f639f069$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: colorMode === 'dark' ? srcDark : srcLight,
            alt: alt,
            "data-testid": testId,
            ...imgProps,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
                fill && "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq",
                colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
            ])
        });
    }
});
parcelRegister("b2nX8", function(module, exports) {
    module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();
});
parcelRegister("8ODZY", function(module, exports) {
    module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();
});
parcelRegister("iVgQf", function(module, exports) {
    $parcel$export(module.exports, "getAkEmptyStateRenderImageFn", ()=>$7affac5c7e698fc8$export$ebf64b9217c1b2a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $4Bpvs;
    function $7affac5c7e698fc8$export$ebf64b9217c1b2a3(JiraIllustration = (0, (0, parcelRequire("4Bpvs")).default)) {
        return ({ maxImageWidth: maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
            const Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
                return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
                    ...__cmplp,
                    style: {
                        ...__cmpls,
                        "--_yv3y2x": (0, (0, parcelRequire("lD23V")).default)(maxImageWidth, "px"),
                        "--_nq7wev": (0, (0, parcelRequire("lD23V")).default)(maxImageHeight, "px")
                    },
                    ref: __cmplr,
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        "_1e0c1ule _p12f1x6a _c71lc3ce _18s81ixx",
                        __cmplp.className
                    ])
                });
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement(JiraIllustration, {
                alt: "",
                role: "presentation",
                width: imageWidth || 'auto',
                height: imageHeight || 'auto'
            }));
        };
    }
});
parcelRegister("4Bpvs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$029e22a35a3f42f7$export$2e2bcd8739ae039);
    var $dCLgq;
    var $kbo4z = parcelRequire("kbo4z");
    var $3uP2Y = parcelRequire("3uP2Y");
    const $029e22a35a3f42f7$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($3uP2Y)),
        srcDark: ($parcel$interopDefault($kbo4z))
    });
    var $029e22a35a3f42f7$export$2e2bcd8739ae039 = $029e22a35a3f42f7$var$Illustration;
    const $029e22a35a3f42f7$export$a179c88182cb9d56 = [
        0,
        0,
        235,
        210
    ];
});
parcelRegister("kbo4z", function(module, exports) {
    module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();
});
parcelRegister("3uP2Y", function(module, exports) {
    module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();
});
parcelRegister("2zwTA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2ecc7c5e37557c1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b2ecc7c5e37557c1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorDisplayHeading: {
            "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-heading",
            "defaultMessage": "We couldn\u2019t load intent templates"
        },
        errorDisplayDescription: {
            "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-description",
            "defaultMessage": "Wait a moment and then try reloading."
        },
        reloadNowButtonText: {
            "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.reload-now-button-text",
            "defaultMessage": "Reload"
        }
    });
});
parcelRegister("aAhML", function(module, exports) {
    $parcel$export(module.exports, "VirtualAgentBrowseIntentsSkeleton", ()=>$47ee42028be217a3$export$444026e4d4f156e4);
    $parcel$export(module.exports, "VirtualAgentIntentsTableSkeleton", ()=>$47ee42028be217a3$export$9dca41144a6398d2);
    $parcel$export(module.exports, "VirtualAgentStatisticsSkeleton", ()=>$47ee42028be217a3$export$538762e63d6466fe);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $eTe4L = parcelRequire("eTe4L");
    var $5IeeQ = parcelRequire("5IeeQ");
    var $8v6ku = parcelRequire("8v6ku");
    const $47ee42028be217a3$var$customCssStyles = null;
    const $47ee42028be217a3$export$444026e4d4f156e4 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($eTe4L))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    const $47ee42028be217a3$export$9dca41144a6398d2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($5IeeQ))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    const $47ee42028be217a3$export$538762e63d6466fe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($8v6ku))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
});
parcelRegister("eTe4L", function(module, exports) {
    module.exports = new URL("virtual-agent-browse-intents-app-skeleton.tpl.1eeb33c1.svg", import.meta.url).toString();
});
parcelRegister("5IeeQ", function(module, exports) {
    module.exports = new URL("virtual-agent-intents-table-app-skeleton.tpl.e28c55f7.svg", import.meta.url).toString();
});
parcelRegister("8v6ku", function(module, exports) {
    module.exports = new URL("virtual-agent-virtual-agent-statistics-app-skeleton.tpl.19ee5056.svg", import.meta.url).toString();
});
parcelRegister("dBV63", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b39bedd89e67c64$export$2e2bcd8739ae039);
    var $7oHmH;
    var $eiowN = parcelRequire("eiowN");
    const $8b39bedd89e67c64$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v2 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v3 = [
            v2,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "name"
        }, v5 = {
            "kind": "ScalarField",
            "name": "key"
        }, v6 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v7 = [
            v2
        ], v8 = {
            "kind": "ScalarField",
            "name": "id"
        }, v9 = [
            v8
        ], v10 = [
            {
                "kind": "ScalarField",
                "name": "isAiEnabledInAdminHub"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "srcVirtualAgentAiAnswersQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v3,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef"
                                            },
                                            v4,
                                            v5,
                                            {
                                                "kind": "LinkedField",
                                                "name": "virtualAgentConfiguration",
                                                "plural": false,
                                                "selections": [
                                                    v6,
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_virtualAgentConfiguration"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_jiraProjectRef"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraProjectByKey"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "VirtualAgentQueryApi",
                            "kind": "LinkedField",
                            "name": "virtualAgent",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v7,
                                        "concreteType": "VirtualAgentFeatures",
                                        "kind": "LinkedField",
                                        "name": "virtualAgentEntitlements",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_virtualAgentFeatures"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "virtualAgent.virtualAgentEntitlements"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "virtualAgent"
                    },
                    {
                        "args": v7,
                        "kind": "FragmentSpread",
                        "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider"
                    }
                ],
                "kind": "Operation",
                "name": "srcVirtualAgentAiAnswersQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v5,
                                    {
                                        "kind": "LinkedField",
                                        "name": "virtualAgentConfiguration",
                                        "plural": false,
                                        "selections": [
                                            v6,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v8,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isAiResponsesEnabled"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "defaultJiraRequestTypeId"
                                                    }
                                                ],
                                                "type": "VirtualAgentConfiguration"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v9,
                                                "type": "VirtualAgentQueryError"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v9,
                                                "type": "Node",
                                                "abstractKey": "__isNode"
                                            }
                                        ]
                                    },
                                    v4,
                                    {
                                        "kind": "ScalarField",
                                        "name": "projectId"
                                    },
                                    {
                                        "args": v7,
                                        "kind": "LinkedField",
                                        "name": "knowledgeBaseArticlesCount",
                                        "plural": false,
                                        "selections": [
                                            v6,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "count"
                                                    }
                                                ],
                                                "type": "KnowledgeBaseArticleCountSource"
                                            }
                                        ]
                                    },
                                    v8,
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "VirtualAgentQueryApi",
                        "kind": "LinkedField",
                        "name": "virtualAgent",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7,
                                "concreteType": "VirtualAgentFeatures",
                                "kind": "LinkedField",
                                "name": "virtualAgentEntitlements",
                                "plural": false,
                                "selections": v10
                            }
                        ]
                    },
                    {
                        "concreteType": "VirtualAgentQueryApi",
                        "kind": "LinkedField",
                        "name": "virtualAgent",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7,
                                "concreteType": "VirtualAgentFeatures",
                                "kind": "LinkedField",
                                "name": "virtualAgentEntitlements",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isVirtualAgentAvailable"
                                    },
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": v10
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "64eccb993845370681d83ad8268dd88c213b1c5680e2dd35e850b0c407c2f482",
                "metadata": {},
                "name": "srcVirtualAgentAiAnswersQuery",
                "operationKind": "query",
                "text": null,
                "providedVariables": {
                    "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
                }
            }
        };
    }();
    $8b39bedd89e67c64$var$node.hash = "19529bb28005c693e530427ab6ca9cc6";
    (0, $eiowN.PreloadableQueryRegistry).set($8b39bedd89e67c64$var$node.params.id, $8b39bedd89e67c64$var$node);
    var $8b39bedd89e67c64$export$2e2bcd8739ae039 = $8b39bedd89e67c64$var$node;
});
parcelRegister("bUyP8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("Nd8Dq")
    ]).then(()=>parcelRequire('64AA8'));
});
parcelRegister("d4rfp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b78ba3d71d6b015$export$2e2bcd8739ae039);
    var $4R6GH;
    var $2b78ba3d71d6b015$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('expose_channels_on_va_conversation_history');
        }
    };
});
parcelRegister("dcMPP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7F9PY").then(()=>parcelRequire('azR8x'));
});
parcelRegister("2LxWa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5892cca023449b49$export$2e2bcd8739ae039);
    var $4R6GH;
    var $5892cca023449b49$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('jsm_va_enable_performance_page');
        }
    };
});
parcelRegister("lIh1i", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dt4qH")
    ]).then(()=>parcelRequire('9r2hQ'));
});
parcelRegister("eODEk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kiA0q").then(()=>parcelRequire('exMWS'));
});
parcelRegister("ie9EN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$17aeaf68a5cf1454$export$2e2bcd8739ae039);
    var $4R6GH;
    var $17aeaf68a5cf1454$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('jsm-va-roi-teaser-m1');
        }
    };
});
parcelRegister("j25Gx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("atp96").then(()=>parcelRequire('52WYW'));
});
parcelRegister("b5QrI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2MoaQ").then(()=>parcelRequire('6G1GD'));
});
parcelRegister("y2RTb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$610656e9d6041bd2$export$2e2bcd8739ae039);
    var $4R6GH;
    var $610656e9d6041bd2$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('jsm_va_enable_ai_answers_page');
        }
    };
});
parcelRegister("ifumN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7SEHL")
    ]).then(()=>parcelRequire('byLJY'));
});
parcelRegister("7BEbO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jVj7l")
    ]).then(()=>parcelRequire('01RYz'));
});
parcelRegister("2vO2D", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8avJm").then(()=>parcelRequire('16gIP'));
});
parcelRegister("jA964", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("c6xj7").then(()=>parcelRequire('3STzC'));
});
parcelRegister("ejiWA", function(module, exports) {
    $parcel$export(module.exports, "changeManagementSettingsProjectConfigurationResource", ()=>$53ebb72294d46a1c$export$2413ba18ec38282d);
    var $2M1hQ;
    const $53ebb72294d46a1c$export$c0636b6062501e0b = 'CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG';
    const $53ebb72294d46a1c$var$getDataLoader = ()=>(parcelRequire("kWcpx"));
    const $53ebb72294d46a1c$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';
    const $53ebb72294d46a1c$export$2413ba18ec38282d = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $53ebb72294d46a1c$export$c0636b6062501e0b,
        getKey: $53ebb72294d46a1c$var$getKey,
        getDataLoader: $53ebb72294d46a1c$var$getDataLoader,
        maxAge: Infinity
    });
});
parcelRegister("kWcpx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fIejC").then(()=>parcelRequire('k9qTQ'));
});
parcelRegister("7Txnp", function(module, exports) {
    $parcel$export(module.exports, "LoadingComponent", ()=>$42f73bbf4237dc1b$export$7db30d367db7d20a);
    $parcel$export(module.exports, "LazyCsatSettingsPage", ()=>$42f73bbf4237dc1b$export$32eb62914bae0e84);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    var $kxZPA;
    const $42f73bbf4237dc1b$export$7db30d367db7d20a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($42f73bbf4237dc1b$var$SpinnerContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large"
        }));
    const $42f73bbf4237dc1b$export$32eb62914bae0e84 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hFEiH")), {
        moduleId: "./src/packages/servicedesk/csat/src/index.tsx"
    });
    const $42f73bbf4237dc1b$var$SpinnerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i68cl",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hFEiH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jT1Vf").then(()=>parcelRequire('hX8BJ'));
});
parcelRegister("k7tsS", function(module, exports) {
    $parcel$export(module.exports, "languageTranslationsResource", ()=>$ffad7a39054feef3$export$f51887e33895eab9);
    $parcel$export(module.exports, "outgoingEmailStateModelResource", ()=>$ffad7a39054feef3$export$c460156a7e6b85b2);
    var $2M1hQ;
    const $ffad7a39054feef3$export$9f529be3aeae01ea = 'JSM Language Translations';
    const $ffad7a39054feef3$export$ecd381e388e8c56f = "Language Support Customer Notification's Outgoing Email State";
    const $ffad7a39054feef3$export$f51887e33895eab9 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'Language Translations',
        getKey: ({ match: { params: { projectKey: projectKey, languageKey: languageKey } } })=>`${$ffad7a39054feef3$export$9f529be3aeae01ea}-${projectKey}-${languageKey}`,
        getDataLoader: ()=>(parcelRequire("1gRMI")),
        maxAge: Infinity
    });
    const $ffad7a39054feef3$export$c460156a7e6b85b2 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'Outgoing Email State Model',
        getKey: ()=>`${$ffad7a39054feef3$export$ecd381e388e8c56f}`,
        getDataLoader: ()=>(parcelRequire("aL9AA")),
        maxAge: Infinity
    });
});
parcelRegister("1gRMI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4BYvo").then(()=>parcelRequire('3m5cp'));
});
parcelRegister("aL9AA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hn2iP").then(()=>parcelRequire('49aS0'));
});
parcelRegister("f8FqB", function(module, exports) {
    $parcel$export(module.exports, "LazyInternalNotificationSettingsPage", ()=>$c99d86239fe70688$export$501979bd6d492c43);
    var $kxZPA;
    const $c99d86239fe70688$export$501979bd6d492c43 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("kWVGP")), {
        moduleId: "./src/packages/servicedesk/notification-internal/src/ui/index.tsx"
    });
});
parcelRegister("kWVGP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dBkhA").then(()=>parcelRequire('ZHF20'));
});
parcelRegister("aLHab", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7mkmU")
    ]).then(()=>parcelRequire('jgXd4'));
});
parcelRegister("lFHMB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("d1IdH")
    ]).then(()=>parcelRequire('eh7Vf'));
});
parcelRegister("kXpVf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cYnLU").then(()=>parcelRequire('k9vj7'));
});
parcelRegister("a5r6X", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("35rMy").then(()=>parcelRequire('giHe4'));
});
parcelRegister("41qL8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gNC9e")
    ]).then(()=>parcelRequire('3eQYY'));
});
parcelRegister("7ESLO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7XRy3").then(()=>parcelRequire('gu2ky'));
});
parcelRegister("274y5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kEacZ").then(()=>parcelRequire('7iBoV'));
});
parcelRegister("1824v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("k8jhA").then(()=>parcelRequire('d3uR0'));
});
parcelRegister("lVUtH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("d8OHn")
    ]).then(()=>parcelRequire('gZiIg'));
});
parcelRegister("5WlEn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cYiLE").then(()=>parcelRequire('apjAt'));
});
parcelRegister("iT1h2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ay8u5").then(()=>parcelRequire('dWAhE'));
});
parcelRegister("5UxQx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3JNwJ").then(()=>parcelRequire('4yiYq'));
});
parcelRegister("9Moyk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7tltX")
    ]).then(()=>parcelRequire('kG5x5'));
});
parcelRegister("5vpTt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6XeFg").then(()=>parcelRequire('jQFbr'));
});
parcelRegister("jzhnL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7Qhcd").then(()=>parcelRequire('dO6p9'));
});
parcelRegister("1xZqw", function(module, exports) {
    $parcel$export(module.exports, "cardCoverImageResource", ()=>$0fcabd2255a2311c$export$f37f52e28126ce75);
    var $dXq4S;
    var $ao2h1;
    var $eQDse;
    const $0fcabd2255a2311c$export$f37f52e28126ce75 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $b9b0da783aed9042$export$d9d248919fbd0611),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("eQDse")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("eQDse", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19be575ffa3b6370$export$2e2bcd8739ae039);
    const $19be575ffa3b6370$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "boardId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "cardCoverSettingsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "BoardScope",
                            "kind": "LinkedField",
                            "name": "boardScope",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "SoftwareBoard",
                                        "kind": "LinkedField",
                                        "name": "board",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "toggle_boardSettingsCard_CardCoverToggle"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "cardPreview_boardSettingsCard"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.board"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "boardScope"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "cardCoverSettingsQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "SoftwareBoard",
                                "kind": "LinkedField",
                                "name": "board",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CardMediaConfig",
                                        "kind": "LinkedField",
                                        "name": "cardMedia",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "enabled"
                                            }
                                        ]
                                    },
                                    v2
                                ]
                            },
                            v2
                        ]
                    }
                ]
            },
            "params": {
                "id": "4216a4fc24eb7ed0390f1effcdb5558af09a70f95660a0c572ae4b531ddc98fc",
                "metadata": {},
                "name": "cardCoverSettingsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $19be575ffa3b6370$var$node.hash = "eb3068eeffbe9ec2fb99186c54005ea6";
    var $19be575ffa3b6370$export$2e2bcd8739ae039 = $19be575ffa3b6370$var$node;
});
const $b9b0da783aed9042$export$d9d248919fbd0611 = 'BOARD_CONTEXT_CARD_COVER_SETTINGS';
parcelRegister("cD3jo", function(module, exports) {
    $parcel$export(module.exports, "customFiltersResource", ()=>$ca950ad823e84673$export$3e390340716755de);
    var $dXq4S;
    var $ao2h1;
    var $WcCM5;
    const $ca950ad823e84673$export$3e390340716755de = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $ad903674eb868bde$export$5917fd27c14066cd),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("WcCM5")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("WcCM5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5edc411e6b038299$export$2e2bcd8739ae039);
    const $5edc411e6b038299$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "boardId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        }, v3 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "customFiltersQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "BoardScope",
                            "kind": "LinkedField",
                            "name": "boardScope",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "CustomFilter",
                                        "kind": "LinkedField",
                                        "name": "customFilters",
                                        "plural": true,
                                        "selections": [
                                            v2,
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "card_projectSettingsCustomFilters_customFilterFragmentRef"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.customFilters"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "card_projectSettingsCustomFilters_boardScopeFragmentRef"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "expandedCard_projectSettingsCustomFilters_boardScopeFragmentRef"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "boardScope"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "customFiltersQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "CustomFilter",
                                "kind": "LinkedField",
                                "name": "customFilters",
                                "plural": true,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "description"
                                    },
                                    {
                                        "concreteType": "FilterQuery",
                                        "kind": "LinkedField",
                                        "name": "filterQuery",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "sanitisedJql"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "errors"
                                            }
                                        ]
                                    },
                                    v3,
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            },
                            v3,
                            v2
                        ]
                    }
                ]
            },
            "params": {
                "id": "c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686",
                "metadata": {},
                "name": "customFiltersQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $5edc411e6b038299$var$node.hash = "2c5c0d030a87f3820766a2a896d71275";
    var $5edc411e6b038299$export$2e2bcd8739ae039 = $5edc411e6b038299$var$node;
});
const $ad903674eb868bde$export$5917fd27c14066cd = 'NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS';
parcelRegister("35Wvp", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsToolchainResource", ()=>$ed037648996bd812$export$182dfe2bc7c28567);
    var $ao2h1;
    var $avVgl;
    const $ed037648996bd812$export$b8927fea69d9f414 = 'PROJECT_SETTINGS_TOOLCHAIN';
    const $ed037648996bd812$export$182dfe2bc7c28567 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $ed037648996bd812$export$b8927fea69d9f414,
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("avVgl")).default),
                variables: {
                    cloudId: tenantContext?.cloudId || ''
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("avVgl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5afd24d8f370d3e2$export$2e2bcd8739ae039);
    const $5afd24d8f370d3e2$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "concreteType": "DvcsQuery",
                "kind": "LinkedField",
                "name": "dvcs",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                            }
                        ],
                        "concreteType": "DvcsBitbucketWorkspaceConnection",
                        "kind": "LinkedField",
                        "name": "bitbucketWorkspacesLinkedToSite",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "DvcsBitbucketWorkspaceEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "ui_projectSettingsToolchainQuery",
                "selections": v1,
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "ui_projectSettingsToolchainQuery",
                "selections": v1
            },
            "params": {
                "id": "2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409",
                "metadata": {},
                "name": "ui_projectSettingsToolchainQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $5afd24d8f370d3e2$var$node.hash = "190735208b3c7baafbfc3c1808fa801b";
    var $5afd24d8f370d3e2$export$2e2bcd8739ae039 = $5afd24d8f370d3e2$var$node;
});
parcelRegister("2FXLN", function(module, exports) {
    $parcel$export(module.exports, "roadmapSettingsResource", ()=>$265fc06fbb6443a3$export$7901a008bd73bf46);
    var $dXq4S;
    var $ao2h1;
    var $6VnEZ;
    const $265fc06fbb6443a3$export$7901a008bd73bf46 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $87d7efe6336d8b83$export$e905b9170ecbb599),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>{
            const { cloudId: cloudId } = tenantContext;
            return {
                parameters: (0, (0, parcelRequire("6VnEZ")).default),
                variables: {
                    sourceAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    }),
                    locationAri: undefined
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
});
parcelRegister("6VnEZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a28994bc59c1b6c$export$2e2bcd8739ae039);
    const $4a28994bc59c1b6c$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locationAri"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceAri"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "locationARI",
                "variableName": "locationAri"
            },
            {
                "kind": "Variable",
                "name": "sourceARI",
                "variableName": "sourceAri"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "isSprintsFeatureEnabled"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "roadmapSettingsQuery",
                "selections": [
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapDetails",
                                "kind": "LinkedField",
                                "name": "roadmapForSource",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "RoadmapConfiguration",
                                            "kind": "LinkedField",
                                            "name": "roadmapConfiguration",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "RoadmapBoardConfiguration",
                                                        "kind": "LinkedField",
                                                        "name": "boardConfiguration",
                                                        "plural": false,
                                                        "selections": [
                                                            v3,
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "childIssuesSchedulingToggle_boardSettingsRoadmap"
                                                            },
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "childIssuesSchedulingPreview_boardSettingsRoadmap"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "roadmaps.roadmapForSource.roadmapConfiguration.boardConfiguration"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapForSource.roadmapConfiguration"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "roadmapSettingsQuery",
                "selections": [
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapDetails",
                                "kind": "LinkedField",
                                "name": "roadmapForSource",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "RoadmapConfiguration",
                                        "kind": "LinkedField",
                                        "name": "roadmapConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "RoadmapBoardConfiguration",
                                                "kind": "LinkedField",
                                                "name": "boardConfiguration",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isChildIssuePlanningEnabled"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "childIssuePlanningMode"
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__id"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80",
                "metadata": {},
                "name": "roadmapSettingsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $4a28994bc59c1b6c$var$node.hash = "31c20159daaa03716587a1ccbe27ab14";
    var $4a28994bc59c1b6c$export$2e2bcd8739ae039 = $4a28994bc59c1b6c$var$node;
});
parcelRegister("fJiVO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jwlH1")
    ]).then(()=>parcelRequire('a0GzC'));
});
parcelRegister("bv9IQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("fg4hm")),
        $6fhBS("kPUyC")
    ]).then(()=>parcelRequire('jFUmz'));
});
parcelRegister("i46eT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3R5lB").then(()=>parcelRequire('keIpy'));
});
parcelRegister("jM7hL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2h1uc")
    ]).then(()=>parcelRequire('7AMRE'));
});
parcelRegister("5iypu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6IfzY").then(()=>parcelRequire('2MwfB'));
});
parcelRegister("fxHpr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("20nf9")),
        $6fhBS("gldEF")
    ]).then(()=>parcelRequire('dgQTq'));
});
parcelRegister("hR0vX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kO7MH").then(()=>parcelRequire('5d39M'));
});
parcelRegister("6eBop", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("57yIp").then(()=>parcelRequire('hX1AL'));
});
parcelRegister("kt1Sq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("boaHK")
    ]).then(()=>parcelRequire('l1Z7j'));
});
parcelRegister("kk6FJ", function(module, exports) {
    $parcel$export(module.exports, "jsmBoardRoute", ()=>$f1ec4cbb5ae8c6af$export$a192088aab559fa1);
    var $65Ltd;
    const $f1ec4cbb5ae8c6af$export$a192088aab559fa1 = {
        path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS),
        exact: true
    };
});
parcelRegister("5xmYT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("341YM")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6Yvcg")
    ]).then(()=>parcelRequire('fnC5S'));
});
parcelRegister("743Kh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iK5gX")
    ]).then(()=>parcelRequire('lWiJj'));
});
parcelRegister("jYeNO", function(module, exports) {
    $parcel$export(module.exports, "getCalendarFilterFieldsResource", ()=>$4dc70aab7904ddfa$export$5f02bf5f04197ed7);
    $parcel$export(module.exports, "useCalendarFilterResource", ()=>$4dc70aab7904ddfa$export$70361b748d216408);
    var $fZneA;
    var $eusud;
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    var $3ezTL;
    var $30Hlr;
    const $4dc70aab7904ddfa$var$fetchFilterFields = async (cloudId, jqlContext)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $8c2713286c62bdd7$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId,
                        contextFieldsFilter: {
                            searchString: (0, (0, parcelRequire("3ezTL")).REQUEST_TYPE_FILTER)
                        },
                        jqlContext: jqlContext
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'JiraJqlBuilder'
                }
            });
            return (0, (0, parcelRequire("30Hlr")).transformAndReport)(response);
        } catch (error) {
            if (!(0, (0, parcelRequire("fZneA")).isHttpClientErrorResponse)(error)) (0, (0, parcelRequire("30Hlr")).reportError)(error);
            return 0, (0, parcelRequire("3ezTL")).DEFAULT_CALENDAR_FILTER_FIELDS;
        }
    };
    const $4dc70aab7904ddfa$var$filterFieldsResource = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("3ezTL")).RESOURCE_TYPE_FILTER_FIELD),
        getKey: ()=>(0, (0, parcelRequire("3ezTL")).RESOURCE_TYPE_FILTER_FIELD),
        getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            const jqlContext = `project = '${projectIdOrKey}'`;
            return $4dc70aab7904ddfa$var$fetchFilterFields(cloudId, jqlContext);
        },
        maxAge: Infinity
    });
    const $4dc70aab7904ddfa$export$5f02bf5f04197ed7 = ()=>$4dc70aab7904ddfa$var$filterFieldsResource;
    const $4dc70aab7904ddfa$export$70361b748d216408 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($4dc70aab7904ddfa$var$filterFieldsResource);
});
parcelRegister("3ezTL", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_NAME", ()=>$2fdfca9bb2287268$export$186e93e8ef3f9358);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$2fdfca9bb2287268$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$2fdfca9bb2287268$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "REQUEST_TYPE_FILTER", ()=>$2fdfca9bb2287268$export$2c388650eabddf5e);
    $parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", ()=>$2fdfca9bb2287268$export$2019de80301f1da);
    $parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", ()=>$2fdfca9bb2287268$export$2912f30d4328fc00);
    const $2fdfca9bb2287268$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
    const $2fdfca9bb2287268$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
    const $2fdfca9bb2287268$export$d57b6b390e78d90f = 'jsd-shield';
    const $2fdfca9bb2287268$export$2c388650eabddf5e = 'request type';
    const $2fdfca9bb2287268$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
    const $2fdfca9bb2287268$export$2912f30d4328fc00 = [
        'status',
        'assignee'
    ];
});
const $8c2713286c62bdd7$export$2b91517d6d5b4365 = `
query findRequestTypeCustomFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;
parcelRegister("30Hlr", function(module, exports) {
    $parcel$export(module.exports, "TARGET_FILTER_TYPE", ()=>$f86becf4a18b4f1f$export$64f54b13b7aea793);
    $parcel$export(module.exports, "reportError", ()=>$f86becf4a18b4f1f$export$b33b857ad1d9900e);
    $parcel$export(module.exports, "transformAndReport", ()=>$f86becf4a18b4f1f$export$af2aa11c88c551af);
    var $jcw0u;
    var $3ezTL;
    const $f86becf4a18b4f1f$export$64f54b13b7aea793 = 'com.atlassian.servicedesk:vp-origin';
    const $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
    const $f86becf4a18b4f1f$export$b33b857ad1d9900e = (error)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            meta: {
                id: (0, (0, parcelRequire("3ezTL")).RESOURCE_TYPE_NAME),
                packageName: (0, (0, parcelRequire("3ezTL")).PACKAGE_NAME),
                teamName: (0, (0, parcelRequire("3ezTL")).TEAM_NAME)
            }
        });
    };
    const $f86becf4a18b4f1f$export$af2aa11c88c551af = (response)=>{
        const edges = response.data?.jira?.jqlBuilder?.fields?.edges;
        const requestType = edges?.find((edge)=>edge?.node?.type === $f86becf4a18b4f1f$export$64f54b13b7aea793 && edge?.node?.searchTemplate?.key === $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE)?.node;
        if (!requestType) $f86becf4a18b4f1f$export$b33b857ad1d9900e(new Error('Unable to prefetch request type'));
        return requestType ? [
            {
                ...requestType,
                searchTemplate: requestType.searchTemplate.key,
                fieldType: requestType.type
            },
            ...(0, (0, parcelRequire("3ezTL")).DEFAULT_CALENDAR_FILTER_FIELDS)
        ] : (0, (0, parcelRequire("3ezTL")).DEFAULT_CALENDAR_FILTER_FIELDS);
    };
});
parcelRegister("hoyWd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1QoV7")
    ]).then(()=>parcelRequire('2hdB5'));
});
parcelRegister("8cdhY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ii98U")
    ]).then(()=>parcelRequire('6vvjk'));
});
parcelRegister("J5M3r", function(module, exports) {
    $parcel$export(module.exports, "servicedeskChangeCalendarRoute", ()=>$927ba64566bdbc92$export$3dbc16ae422c469);
    var $65Ltd;
    const $927ba64566bdbc92$export$3dbc16ae422c469 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR),
        path: '/jira/servicedesk/projects/:projectKey/change-calendar',
        exact: true
    };
});
parcelRegister("l6XXN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("41TKw")
    ]).then(()=>parcelRequire('4cmmO'));
});
parcelRegister("xpgfY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aHtXH")
    ]).then(()=>parcelRequire('cB0p5'));
});
parcelRegister("8naTI", function(module, exports) {
    $parcel$export(module.exports, "insightObjectResource", ()=>$2ad42c3dacc09c9e$export$215464c8085c5e35);
    var $2M1hQ;
    var $7JHOP;
    const $2ad42c3dacc09c9e$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT = 'SERVICEDESK_INSIGHT_OBJECT';
    const $2ad42c3dacc09c9e$export$215464c8085c5e35 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $2ad42c3dacc09c9e$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT,
        getKey: ({ match: match })=>match.params.objectId || '',
        getData: (0, parcelRequire("7JHOP")).default,
        isBrowserOnly: true
    });
});
parcelRegister("7JHOP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07f064c629fd32ba$export$2e2bcd8739ae039);
    var $x9xyg;
    var $dJl1T;
    var $jcw0u;
    var $4R6GH;
    var $7f4tk;
    var $8PRuf;
    var $iR3GG;
    var $eJOOa;
    var $ahEft;
    var $9NiTW;
    const $07f064c629fd32ba$var$fetchInsightObjectDetails = async (routeDataContext, routerContext)=>{
        try {
            const { match: { params: params } } = routeDataContext;
            const { objectId: objectId } = params;
            if (objectId == null) return null;
            const workspaceId = await (0, (0, parcelRequire("ahEft")).default)(routeDataContext, routerContext);
            if (workspaceId == null) return null;
            const data = await (0, (0, parcelRequire("7f4tk")).default)((0, (0, parcelRequire("eJOOa")).getCmdbObjectByIdUrl)(workspaceId, objectId));
            (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("8PRuf")).prefetchApiReadyMark));
            return data;
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraServicedeskInsightObjectResource', error);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'jiraServicedeskInsightObjectResource',
                    packageName: 'jiraSpa'
                },
                error: error
            });
            throw error;
        }
    };
    var $07f064c629fd32ba$export$2e2bcd8739ae039 = async (routeDataContext, routerContext)=>{
        const { tenantContext: tenantContext } = routerContext;
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsm_throw_error_on_resource_auth_pre-check_failed')) {
            if (!(0, (0, parcelRequire("9NiTW")).checkAuthentication)(tenantContext)) throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.servicedesk.cmdb-object.getData',
                message: 'Current user is not authenticated',
                name: 'AuthenticationError',
                skipSentry: true
            });
        } else if (!(0, (0, parcelRequire("9NiTW")).checkAuthentication)(tenantContext)) return null;
        return $07f064c629fd32ba$var$fetchInsightObjectDetails(routeDataContext, routerContext);
    };
});
parcelRegister("eJOOa", function(module, exports) {
    $parcel$export(module.exports, "getCmdbObjectByIdUrl", ()=>$bba7f62e646e53a7$export$d33c3e25476d091d);
    $parcel$export(module.exports, "getCmdbObjectByIdUrlWithoutQueryParams", ()=>$bba7f62e646e53a7$export$6ef8997552257871);
    $parcel$export(module.exports, "getCmdbObjectByIdActivityUrl", ()=>$bba7f62e646e53a7$export$20c207abffb62450);
    $parcel$export(module.exports, "getCmdbObjectByIdAvatarUrl", ()=>$bba7f62e646e53a7$export$31df868d16d545f8);
    $parcel$export(module.exports, "getCmdbObjectByIdReferenceInfoUrl", ()=>$bba7f62e646e53a7$export$5044a1e9fc201773);
    $parcel$export(module.exports, "getCmdbObjectCloneByIdUrl", ()=>$bba7f62e646e53a7$export$d7f6dc1d4f622458);
    $parcel$export(module.exports, "getCmdbObjectCreateUrl", ()=>$bba7f62e646e53a7$export$9cdc19e8944d38cf);
    $parcel$export(module.exports, "getCmdbObjectNavlistUrl", ()=>$bba7f62e646e53a7$export$bf9c534c2cd21829);
    $parcel$export(module.exports, "getCmdbObjectNavlistQueryLanguageUrl", ()=>$bba7f62e646e53a7$export$b35334340ee827fa);
    $parcel$export(module.exports, "getCmdbObjectRecentUrl", ()=>$bba7f62e646e53a7$export$a0a7c6f22bebdef0);
    $parcel$export(module.exports, "getCmdbObjectQueryLanguageTotalCountUrl", ()=>$bba7f62e646e53a7$export$ee74f95a469c4433);
    $parcel$export(module.exports, "getCmdbObjectQueryLanguageUrl", ()=>$bba7f62e646e53a7$export$84a34ee3f18e226);
    $parcel$export(module.exports, "getCmdbAsyncObjectExportUrl", ()=>$bba7f62e646e53a7$export$878b627ac685384e);
    $parcel$export(module.exports, "getCmdbAsyncBulkQrCodeUrl", ()=>$bba7f62e646e53a7$export$8eb3a6b36886db0);
    $parcel$export(module.exports, "getCmdbAsyncBulkDeleteUrl", ()=>$bba7f62e646e53a7$export$b02201bcaeb75291);
    $parcel$export(module.exports, "getCmdbAsyncBulkEditUrl", ()=>$bba7f62e646e53a7$export$f4d68a6f0e3217b5);
    var $ebyGx = parcelRequire("ebyGx");
    var $klJ8b;
    const $bba7f62e646e53a7$var$getCmdbObjectUrl = (workspaceId)=>`${(0, (0, parcelRequire("klJ8b")).getCmdbRestBaseUrl)(workspaceId)}/object`;
    const $bba7f62e646e53a7$export$d33c3e25476d091d = (workspaceId, objectId, includeExtendedInfo = false)=>{
        const path = $bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId);
        if (!includeExtendedInfo) return `${path}?${(0, $ebyGx.stringify)({
            includeExtendedInfo: includeExtendedInfo
        })}`;
        return path;
    };
    const $bba7f62e646e53a7$export$6ef8997552257871 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/${objectId}`;
    const $bba7f62e646e53a7$export$20c207abffb62450 = (workspaceId, objectId, queryParams)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/activity?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$31df868d16d545f8 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/avatar`;
    const $bba7f62e646e53a7$export$5044a1e9fc201773 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/referenceinfo`;
    const $bba7f62e646e53a7$export$d7f6dc1d4f622458 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/clone/${objectId}`;
    const $bba7f62e646e53a7$export$9cdc19e8944d38cf = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/create`;
    const $bba7f62e646e53a7$export$bf9c534c2cd21829 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/navlist`;
    const $bba7f62e646e53a7$export$b35334340ee827fa = (workspaceId)=>`${$bba7f62e646e53a7$export$bf9c534c2cd21829(workspaceId)}/aql`;
    const $bba7f62e646e53a7$export$a0a7c6f22bebdef0 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/recent?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$ee74f95a469c4433 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/aql/totalcount`;
    const $bba7f62e646e53a7$export$1016ae73c04d9079 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/search?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$cb41514f2508b033 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/searchbyattributes?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$84a34ee3f18e226 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/aql?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$878b627ac685384e = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkexport`;
    const $bba7f62e646e53a7$export$8eb3a6b36886db0 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkqrcode?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$b02201bcaeb75291 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkdelete`;
    const $bba7f62e646e53a7$export$f4d68a6f0e3217b5 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkedit`;
});
parcelRegister("klJ8b", function(module, exports) {
    $parcel$export(module.exports, "getCmdbRestBaseUrl", ()=>$a22cc15ea8014e15$export$28b6c003daedf1c2);
    const $a22cc15ea8014e15$export$28b6c003daedf1c2 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;
});
parcelRegister("8oQUA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8VYTt")
    ]).then(()=>parcelRequire('8V2Yz'));
});
parcelRegister("6j0IA", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskAssetsImportTypeForgeDataResource", ()=>$f0c74bdf86d6b898$export$58d2462746e91c7d);
    var $2M1hQ;
    const $f0c74bdf86d6b898$var$getDataLoader = ()=>(parcelRequire("aFxik"));
    const $f0c74bdf86d6b898$export$58d2462746e91c7d = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ASSETS_IMPORT_TYPE_FORGE_DATA',
        getKey: ()=>'extensions',
        getDataLoader: $f0c74bdf86d6b898$var$getDataLoader,
        maxAge: Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
});
parcelRegister("aFxik", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("29sLe").then(()=>parcelRequire('jwVSb'));
});
parcelRegister("75ZPm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jCYvk").then(()=>parcelRequire('hEchH'));
});
parcelRegister("4jFTA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6kkfK")
    ]).then(()=>parcelRequire('ciybC'));
});
parcelRegister("bNaZl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hloRW")
    ]).then(()=>parcelRequire('2lY4S'));
});
parcelRegister("4jhAF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("i8SQL")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jluSR")
    ]).then(()=>parcelRequire('7Jr0E'));
});
parcelRegister("h5ZL2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("838D9")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hWDKD")
    ]).then(()=>parcelRequire('imnQf'));
});
parcelRegister("8ym2X", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fApFb").then(()=>parcelRequire('ejeJy'));
});
parcelRegister("cFBuN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cTSd1")
    ]).then(()=>parcelRequire('9imjS'));
});
parcelRegister("5Bl21", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("95JPD").then(()=>parcelRequire('cKWhs'));
});
parcelRegister("3pzt9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("740y2").then(()=>parcelRequire('3hX8x'));
});
parcelRegister("fcMlY", function(module, exports) {
    $parcel$export(module.exports, "entitlementsCustomerQueryResource", ()=>$b3b86d13796012d4$export$78737979422d6907);
    var $ao2h1;
    var $3KdBC;
    const $b3b86d13796012d4$export$78737979422d6907 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'ENTITLEMENTS_CUSTOMER_QUERY',
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("3KdBC")).default),
                variables: {
                    accountId: String(match.params.customerId),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("3KdBC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$234ef4e6f5c8b134$export$2e2bcd8739ae039);
    const $234ef4e6f5c8b134$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v3 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v5 = [
            {
                "kind": "Variable",
                "name": "accountId",
                "variableName": "accountId"
            }
        ], v6 = {
            "kind": "ScalarField",
            "name": "name"
        }, v7 = {
            "kind": "ScalarField",
            "name": "id"
        }, v8 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v9 = [
            v7,
            v6
        ], v10 = {
            "kind": "InlineFragment",
            "selections": [
                v7
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "entitlementsCustomerQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v2,
                            "concreteType": "CustomerServiceQueryApi",
                            "kind": "LinkedField",
                            "name": "customerService",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v3,
                                        "concreteType": "CustomerServiceProductConnection",
                                        "kind": "LinkedField",
                                        "name": "productConnections",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "CustomerServiceProductEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceProduct",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4
                                                            ]
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "customerService.productConnections.edges"
                                            }
                                        ],
                                        "storageKey": "productConnections(first:1)"
                                    },
                                    "action": "THROW",
                                    "path": "customerService.productConnections"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v5,
                                        "kind": "LinkedField",
                                        "name": "individualByAccountId",
                                        "plural": false,
                                        "selections": [
                                            v4,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v6,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v7,
                                                        "action": "THROW",
                                                        "path": "customerService.individualByAccountId.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CustomerServiceEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlementList",
                                                            "plural": true,
                                                            "selections": [
                                                                v7,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "includeEntityTypeName",
                                                                            "value": true
                                                                        }
                                                                    ],
                                                                    "kind": "FragmentSpread",
                                                                    "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "customerService.individualByAccountId.entitlementList"
                                                    },
                                                    v8
                                                ],
                                                "type": "CustomerServiceIndividual"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                    }
                                                ],
                                                "type": "QueryError"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "customerService.individualByAccountId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "customerService"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "entitlementsCustomerQuery",
                "selections": [
                    {
                        "args": v2,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "CustomerServiceProductConnection",
                                "kind": "LinkedField",
                                "name": "productConnections",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CustomerServiceProductEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "CustomerServiceProduct",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    v7
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "productConnections(first:1)"
                            },
                            {
                                "args": v5,
                                "kind": "LinkedField",
                                "name": "individualByAccountId",
                                "plural": false,
                                "selections": [
                                    v4,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v6,
                                            v7,
                                            {
                                                "concreteType": "CustomerServiceEntitlement",
                                                "kind": "LinkedField",
                                                "name": "entitlementList",
                                                "plural": true,
                                                "selections": [
                                                    v7,
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "product",
                                                        "plural": false,
                                                        "selections": v9
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "entity",
                                                        "plural": false,
                                                        "selections": [
                                                            v4,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9,
                                                                "type": "CustomerServiceOrganization"
                                                            },
                                                            v10
                                                        ]
                                                    }
                                                ]
                                            },
                                            v8
                                        ],
                                        "type": "CustomerServiceIndividual"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "identifier"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "message"
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v4,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "statusCode"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "errorType"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "QueryError"
                                    },
                                    v10
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38",
                "metadata": {},
                "name": "entitlementsCustomerQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $234ef4e6f5c8b134$var$node.hash = "52b18fa6e520ef1142f20ddded30f5ba";
    var $234ef4e6f5c8b134$export$2e2bcd8739ae039 = $234ef4e6f5c8b134$var$node;
});
parcelRegister("4lqmX", function(module, exports) {
    $parcel$export(module.exports, "uiCustomerDetailsPageQueryResource", ()=>$bb7f2c1b84275683$export$d766b4bd7ad23814);
    var $ao2h1;
    var $bvCOc;
    const $bb7f2c1b84275683$export$d766b4bd7ad23814 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("bvCOc")).default),
                variables: {
                    accountId: String(match.params.customerId),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("bvCOc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb866aea27d5a9be$export$2e2bcd8739ae039);
    const $eb866aea27d5a9be$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "4c922c068178abaa255d12a88a8254e5b236724d396e47df3f3461e152127536",
            "metadata": {},
            "name": "uiCustomerDetailsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $eb866aea27d5a9be$export$2e2bcd8739ae039 = $eb866aea27d5a9be$var$node;
});
parcelRegister("kBMOn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iWLC2").then(()=>parcelRequire('dKNUD'));
});
parcelRegister("iviTi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9m8WM")
    ]).then(()=>parcelRequire('eRp4S'));
});
parcelRegister("eAdnc", function(module, exports) {
    $parcel$export(module.exports, "servicedeskCustomersV2Route", ()=>$3bc65f8e809f9f4e$export$89e9e350610ee31e);
    var $65Ltd;
    const $3bc65f8e809f9f4e$export$89e9e350610ee31e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2),
        path: '/jira/servicedesk/projects/:projectKey/customers',
        exact: true
    };
});
parcelRegister("ludxj", function(module, exports) {
    $parcel$export(module.exports, "projectServiceDeskRoute", ()=>$be54e9dad71bd630$export$1cfc858068dd8718);
    var $65Ltd;
    const $be54e9dad71bd630$export$1cfc858068dd8718 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REDIRECT),
        path: '/jira/servicedesk/projects/:projectKey',
        exact: true
    };
});
parcelRegister("3Xbwz", function(module, exports) {
    $parcel$export(module.exports, "gspPageRoute", ()=>$01c5edc0b2b9a369$export$23f42abb017854bb);
    var $65Ltd;
    const $01c5edc0b2b9a369$export$23f42abb017854bb = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE),
        path: '/jira/servicedesk/projects/:projectKey/getting-started',
        exact: true
    };
});
parcelRegister("5gAHG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("i3L0u")
    ]).then(()=>parcelRequire('8Xvm1'));
});
parcelRegister("6xxAH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1hp0c").then(()=>parcelRequire('5eXru'));
});
parcelRegister("jIAHH", function(module, exports) {
    $parcel$export(module.exports, "AsyncKbNav", ()=>$22359123c06ce2f3$export$223f755b7799fe02);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $22359123c06ce2f3$var$LazyKbNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aRGUb")).then(({ KnowledgeBaseNav: KnowledgeBaseNav })=>KnowledgeBaseNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/knowledge-base/src/ui/index.tsx"
    });
    const $22359123c06ce2f3$export$223f755b7799fe02 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-jsm-kb-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($22359123c06ce2f3$var$LazyKbNav, null));
});
parcelRegister("aRGUb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dqfnF").then(()=>parcelRequire('gaKUF'));
});
parcelRegister("heMv1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4ePds")
    ]).then(()=>parcelRequire('4uyp4'));
});
parcelRegister("bEyY0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("03OxI").then(()=>parcelRequire('l54tv'));
});
parcelRegister("kYjOy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6afNs")
    ]).then(()=>parcelRequire('MNfxH'));
});
parcelRegister("coVHe", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentKnowledgebaseTouchpointResource", ()=>$b5eb4da6bb86684f$export$1b798e6122168cca);
    var $4R6GH;
    var $ao2h1;
    var $eCMpj;
    const $b5eb4da6bb86684f$export$1b798e6122168cca = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'SERVICEDESK_VIRTUAL_AGENT_KNOWLEDGE_BASE_TOUCHPOINT',
        isBrowserOnly: true,
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("eCMpj")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    key: match.params.projectKey || '',
                    checkForAiEnabledFF: (0, (0, parcelRequire("4R6GH")).fg)('require_ai_enabled_for_jsm_virtual_agent')
                }
            })
    });
});
parcelRegister("eCMpj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0111b96d105a115c$export$2e2bcd8739ae039);
    const $0111b96d105a115c$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "dd6752d7ca61f340baeb3c609b862f187f8cf5af8c22d46be5786ce68d776813",
            "metadata": {},
            "name": "mainVirtualServiceAgentCtaCardQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $0111b96d105a115c$export$2e2bcd8739ae039 = $0111b96d105a115c$var$node;
});
parcelRegister("faCrc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aiUKx").then(()=>parcelRequire('dseQM'));
});
parcelRegister("axq9y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aly08").then(()=>parcelRequire('lE3ki'));
});
parcelRegister("8wHId", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7Lxlr")
    ]).then(()=>parcelRequire('kl4T5'));
});
parcelRegister("bMJcR", function(module, exports) {
    $parcel$export(module.exports, "knowledgeHubLandingRoute", ()=>$5a3037062b8f539c$export$239eaf6a202e0f54);
    var $65Ltd;
    const $5a3037062b8f539c$export$239eaf6a202e0f54 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_LANDING),
        path: '/jira/servicedesk/projects/:projectKey/knowledge',
        exact: true
    };
});
parcelRegister("aJqiu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lq9Le").then(()=>parcelRequire('baJ3W'));
});
parcelRegister("dMkfh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1phgE")
    ]).then(()=>parcelRequire('gBJGI'));
});
parcelRegister("2WqFA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$18bf020f3f366501$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $8zOmE;
    var $2NMNM;
    var $29jfS;
    const $18bf020f3f366501$var$useIsAdminHubAIEnabled = (jiraProduct, version)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isAdminHubAiToggleEnabled, setIsAdminHubAiToggleEnabled] = (0, $5uXOq.useState)(null);
        const [loading, setLoading] = (0, $5uXOq.useState)(true);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const fetchData = (0, $5uXOq.useCallback)(async ()=>{
            setLoading(true);
            setError(null);
            try {
                const response = await (0, (0, parcelRequire("29jfS")).fetchAiEnablement)(jiraProduct, version);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiEnablementStatus succeeded');
                setIsAdminHubAiToggleEnabled(response.isEnabled);
            } catch (err) {
                setError(err);
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: err,
                    meta: {
                        id: 'fetchAiEnablementStatus failed'
                    }
                });
            } finally{
                setLoading(false);
            }
        }, [
            createAnalyticsEvent,
            jiraProduct,
            version
        ]);
        return {
            data: isAdminHubAiToggleEnabled,
            loading: loading,
            error: error,
            fetchAIEnablement: fetchData
        };
    };
    var $18bf020f3f366501$export$2e2bcd8739ae039 = $18bf020f3f366501$var$useIsAdminHubAIEnabled;
});
parcelRegister("29jfS", function(module, exports) {
    $parcel$export(module.exports, "fetchAiEnablement", ()=>$f8e2a461a4c2e420$export$ad4105850d0ce824);
    var $7f4tk;
    const $f8e2a461a4c2e420$export$2171a423b572256a = (jiraProduct, version = '1')=>`/rest/api/${version}/aiconfig/ai-enabled/${jiraProduct}`;
    const $f8e2a461a4c2e420$export$ad4105850d0ce824 = (jiraProduct, version = '1')=>{
        const url = $f8e2a461a4c2e420$export$2171a423b572256a(jiraProduct, version);
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'GET'
        });
    };
});
parcelRegister("3BoXf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iFZBi").then(()=>parcelRequire('hY7nq'));
});
parcelRegister("joRT8", function(module, exports) {
    $parcel$export(module.exports, "notificationLogsRoute", ()=>$7c61830ec505ffc9$export$c947c80f138bc137);
    var $65Ltd;
    const $7c61830ec505ffc9$export$c947c80f138bc137 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_NOTIFICATION_LOGS),
        path: '/jira/servicedesk/projects/:projectKey/notification-logs',
        exact: true
    };
});
parcelRegister("bm2td", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("43uod").then(()=>parcelRequire('9feT0'));
});
parcelRegister("9kQCa", function(module, exports) {
    $parcel$export(module.exports, "servicedeskOncallScheduleRoute", ()=>$993b636c10d5f63c$export$740e6e5e982b48a9);
    var $65Ltd;
    const $993b636c10d5f63c$export$740e6e5e982b48a9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE),
        path: '/jira/servicedesk/projects/:projectKey/on-call-schedule',
        exact: true
    };
});
parcelRegister("dt8J6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aVjGW").then(()=>parcelRequire('gjKCT'));
});
parcelRegister("6x0wo", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskOrganizationPanelForgeDataResource", ()=>$8bc812ed070bb2a3$export$f3c46a19f3594363);
    var $2M1hQ;
    const $8bc812ed070bb2a3$var$getDataLoader = ()=>(parcelRequire("6TA4Z"));
    const $8bc812ed070bb2a3$export$f3c46a19f3594363 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $b6a87c89b0762905$export$66d6e1e05866ee2f),
        getKey: ({ match: match })=>{
            const { projectKey: projectKey } = match.params;
            return `extension-${projectKey}`;
        },
        getDataLoader: $8bc812ed070bb2a3$var$getDataLoader,
        maxAge: Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
});
const $b6a87c89b0762905$export$66d6e1e05866ee2f = 'ORGANIZATION_PANEL_FORGE_DATA';
parcelRegister("6TA4Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6fToZ").then(()=>parcelRequire('emXcY'));
});
parcelRegister("dSzzF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4SjA9").then(()=>parcelRequire('3BhTj'));
});
parcelRegister("8XgXN", function(module, exports) {
    $parcel$export(module.exports, "entitlementsOrganizationQueryResource", ()=>$275795ce1e7f33fe$export$fead08d66d56688e);
    var $ao2h1;
    var $9NGHY;
    const $275795ce1e7f33fe$export$fead08d66d56688e = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("9NGHY")).default),
                variables: {
                    organizationId: String(match.params.organizationId),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("9NGHY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42e659babe89c8d5$export$2e2bcd8739ae039);
    const $42e659babe89c8d5$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "organizationId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = [
            {
                "kind": "Variable",
                "name": "organizationId",
                "variableName": "organizationId"
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "name"
        }, v6 = {
            "kind": "ScalarField",
            "name": "id"
        }, v7 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "entitlementsOrganizationQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "CustomerServiceQueryApi",
                            "kind": "LinkedField",
                            "name": "customerService",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "concreteType": "CustomerServiceProductConnection",
                                        "kind": "LinkedField",
                                        "name": "productConnections",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "CustomerServiceProductEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceProduct",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3
                                                            ]
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "customerService.productConnections.edges"
                                            }
                                        ],
                                        "storageKey": "productConnections(first:1)"
                                    },
                                    "action": "THROW",
                                    "path": "customerService.productConnections"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v4,
                                        "kind": "LinkedField",
                                        "name": "organizationByOrganizationId",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v5,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v6,
                                                        "action": "THROW",
                                                        "path": "customerService.organizationByOrganizationId.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CustomerServiceEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlementList",
                                                            "plural": true,
                                                            "selections": [
                                                                v6,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "includeEntityTypeName",
                                                                            "value": false
                                                                        }
                                                                    ],
                                                                    "kind": "FragmentSpread",
                                                                    "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "customerService.organizationByOrganizationId.entitlementList"
                                                    },
                                                    v7
                                                ],
                                                "type": "CustomerServiceOrganization"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                    }
                                                ],
                                                "type": "QueryError"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "customerService.organizationByOrganizationId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "customerService"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "entitlementsOrganizationQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "CustomerServiceProductConnection",
                                "kind": "LinkedField",
                                "name": "productConnections",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CustomerServiceProductEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "CustomerServiceProduct",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    v6
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "productConnections(first:1)"
                            },
                            {
                                "args": v4,
                                "kind": "LinkedField",
                                "name": "organizationByOrganizationId",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v5,
                                            v6,
                                            {
                                                "concreteType": "CustomerServiceEntitlement",
                                                "kind": "LinkedField",
                                                "name": "entitlementList",
                                                "plural": true,
                                                "selections": [
                                                    v6,
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "product",
                                                        "plural": false,
                                                        "selections": [
                                                            v6,
                                                            v5
                                                        ]
                                                    }
                                                ]
                                            },
                                            v7
                                        ],
                                        "type": "CustomerServiceOrganization"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "identifier"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "message"
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v3,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "statusCode"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "errorType"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "QueryError"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v6
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f",
                "metadata": {},
                "name": "entitlementsOrganizationQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $42e659babe89c8d5$var$node.hash = "c2dbf2a99cb38657b66de75f23707712";
    var $42e659babe89c8d5$export$2e2bcd8739ae039 = $42e659babe89c8d5$var$node;
});
parcelRegister("iTeMQ", function(module, exports) {
    $parcel$export(module.exports, "uiOrganizationDetailsPageQueryResource", ()=>$6f42d74340bbf820$export$ab65064827d1831d);
    var $ao2h1;
    var $hpIsM;
    const $6f42d74340bbf820$export$ab65064827d1831d = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("hpIsM")).default),
                variables: {
                    organizationId: String(match.params.organizationId),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("hpIsM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc8caf12ab702db6$export$2e2bcd8739ae039);
    const $bc8caf12ab702db6$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "organizationId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = [
            {
                "kind": "Variable",
                "name": "organizationId",
                "variableName": "organizationId"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = {
            "kind": "ScalarField",
            "name": "statusCode"
        }, v5 = {
            "kind": "ScalarField",
            "name": "id"
        }, v6 = {
            "kind": "ScalarField",
            "name": "name"
        }, v7 = {
            "kind": "ScalarField",
            "name": "identifier"
        }, v8 = {
            "kind": "ScalarField",
            "name": "message"
        }, v9 = {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v3,
                v4,
                {
                    "kind": "ScalarField",
                    "name": "errorType"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "uiOrganizationDetailsPageQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "CustomerServiceQueryApi",
                            "kind": "LinkedField",
                            "name": "customerService",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "kind": "LinkedField",
                                        "name": "organizationByOrganizationId",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "details",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "customDetailsSidebar_servicedeskCustomerServiceCustomDetailsSidebar_Inner"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "CustomerServiceOrganization"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "extensions",
                                                        "plural": true,
                                                        "selections": [
                                                            v4
                                                        ]
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                    }
                                                ],
                                                "type": "QueryError"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "customerService.organizationByOrganizationId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "customerService"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "uiOrganizationDetailsPageQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "kind": "LinkedField",
                                "name": "organizationByOrganizationId",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "details",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    {
                                                        "kind": "TypeDiscriminator",
                                                        "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "CustomerServiceCustomDetailValue",
                                                                "kind": "LinkedField",
                                                                "name": "results",
                                                                "plural": true,
                                                                "selections": [
                                                                    v5,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "canEdit"
                                                                    },
                                                                    v6,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "value"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "values"
                                                                    },
                                                                    {
                                                                        "concreteType": "CustomerServiceCustomDetailType",
                                                                        "kind": "LinkedField",
                                                                        "name": "type",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v6,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "options"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                        "kind": "LinkedField",
                                                                        "name": "config",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                                "kind": "LinkedField",
                                                                                "name": "styleConfiguration",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "options",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "optionValue"
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "style",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "backgroundColour"
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "CustomerServiceCustomDetailValues"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v7,
                                                            v8,
                                                            v9
                                                        ],
                                                        "type": "QueryError"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "CustomerServiceOrganization"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v9,
                                            v7,
                                            v8
                                        ],
                                        "type": "QueryError"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v5
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "8425025856dcdb524ab8c9068e976910d1b94e9aab4d880ce4e0939990c08edf",
                "metadata": {},
                "name": "uiOrganizationDetailsPageQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $bc8caf12ab702db6$var$node.hash = "8781f4b4eca174196d95ee737ccdc3aa";
    var $bc8caf12ab702db6$export$2e2bcd8739ae039 = $bc8caf12ab702db6$var$node;
});
parcelRegister("lpf7H", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("h7cjl")
    ]).then(()=>parcelRequire('e2tYQ'));
});
parcelRegister("aod5A", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3OcWv")
    ]).then(()=>parcelRequire('9LQpe'));
});
parcelRegister("bkElt", function(module, exports) {
    $parcel$export(module.exports, "servicedeskOrganizationsRoute", ()=>$3df03e0958f7e9c7$export$d4a712c5bc3c3434);
    var $65Ltd;
    const $3df03e0958f7e9c7$export$d4a712c5bc3c3434 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS),
        path: '/jira/servicedesk/projects/:projectKey/organizations',
        exact: true
    };
});
parcelRegister("5wuQF", function(module, exports) {
    $parcel$export(module.exports, "servicedeskProjectSummaryRoute", ()=>$4ba559112e9c0332$export$a23b752ff24027ae);
    var $65Ltd;
    const $4ba559112e9c0332$export$a23b752ff24027ae = {
        path: '/jira/servicedesk/projects/:projectKey/summary',
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY)
    };
});
parcelRegister("dHAzH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("gJl2n")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("nwI1a")
    ]).then(()=>parcelRequire('i6ZtS'));
});
parcelRegister("jlOGG", function(module, exports) {
    $parcel$export(module.exports, "newIssueViewLockInStatusResource", ()=>$951713022fad9069$export$647de7516d081bd8);
    $parcel$export(module.exports, "useNewIssueViewLockInStatus", ()=>$951713022fad9069$export$d8ba398930f2f5f);
    var $2M1hQ;
    var $2YP9W;
    var $1odlY;
    const $951713022fad9069$export$647de7516d081bd8 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS),
        getKey: ({ match: match })=>match.params.projectKey || '',
        getDataLoader: ()=>(parcelRequire("c6e4J")),
        maxAge: Number.MAX_VALUE
    });
    const $951713022fad9069$export$d8ba398930f2f5f = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($951713022fad9069$export$647de7516d081bd8);
        return {
            loading: loading,
            error: error,
            newIssueViewLockedIn: data && data.newIssueViewLockedIn
        };
    };
});
parcelRegister("c6e4J", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("83I2X").then(()=>parcelRequire('7JV09'));
});
parcelRegister("urQ6o", function(module, exports) {
    $parcel$export(module.exports, "customPracticeQueueRoute", ()=>$41bd265d7c0f4884$export$59d0bd42aa07faad);
    var $65Ltd;
    const $41bd265d7c0f4884$export$59d0bd42aa07faad = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
});
parcelRegister("36xAX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b8Jun")
    ]).then(()=>parcelRequire('6o1Xn'));
});
parcelRegister("aNLeB", function(module, exports) {
    $parcel$export(module.exports, "servicedeskIsItsmProjectResource", ()=>$31e43d0718118496$export$920308cef4e291b1);
    $parcel$export(module.exports, "useIsItsmTemplateProject", ()=>$31e43d0718118496$export$7bb46948fb84f164);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $dK8AG;
    var $2M1hQ;
    const $31e43d0718118496$var$getDataLoader = ()=>(parcelRequire("jag87"));
    const $31e43d0718118496$var$ONE_DAY_IN_MILLIS = 86400000;
    const $31e43d0718118496$export$920308cef4e291b1 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $6249ccfa4eeeb82a$export$543a8644640f4092),
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $31e43d0718118496$var$getDataLoader,
        maxAge: $31e43d0718118496$var$ONE_DAY_IN_MILLIS
    });
    const $31e43d0718118496$export$7bb46948fb84f164 = (projectKey)=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($31e43d0718118496$export$920308cef4e291b1, projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined, {
            shouldPrefetch: true
        });
        return (0, $5uXOq.useMemo)(()=>({
                data: data,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    };
});
const $6249ccfa4eeeb82a$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';
parcelRegister("jag87", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("4CXUh")
    ]).then(()=>parcelRequire('k9PUn'));
});
parcelRegister("7M8Tn", function(module, exports) {
    $parcel$export(module.exports, "customQueueRoute", ()=>$c0c93413dba087be$export$e1fac82ca0b0d637);
    var $65Ltd;
    const $c0c93413dba087be$export$e1fac82ca0b0d637 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey?',
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
});
parcelRegister("gcllV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8QnWZ").then(()=>parcelRequire('blyWx'));
});
parcelRegister("coJTW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("K7eQv")
    ]).then(()=>parcelRequire('3r23L'));
});
parcelRegister("1y2nu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3vo2B")
    ]).then(()=>parcelRequire('6qBzG'));
});
parcelRegister("6d9hm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eRCFp")
    ]).then(()=>parcelRequire('5ou2F'));
});
parcelRegister("eEcjl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cFmpd").then(()=>parcelRequire('htw0K'));
});
parcelRegister("a8afX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jX3BJ")
    ]).then(()=>parcelRequire('aQuyJ'));
});
parcelRegister("3Z2MRq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("j8CYW").then(()=>parcelRequire('jFMLI'));
});
parcelRegister("hejqw", function(module, exports) {
    $parcel$export(module.exports, "servicedeskAtlassianAnalyticsResource", ()=>$ccd9a1a485573887$export$eb2deca89cf3fb61);
    var $2M1hQ;
    const $ccd9a1a485573887$var$getDataLoader = ()=>(parcelRequire("jfmG6"));
    const $ccd9a1a485573887$export$eb2deca89cf3fb61 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $125270e59037c004$export$73cf43fb073ce577),
        getKey: ()=>'atlassian analytics',
        getDataLoader: $ccd9a1a485573887$var$getDataLoader,
        isBrowserOnly: true
    });
});
const $125270e59037c004$export$73cf43fb073ce577 = 'SERVICEDESK_ATLASSIAN_ANALYTICS';
parcelRegister("jfmG6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1fLqt").then(()=>parcelRequire('ghpmF'));
});
parcelRegister("gPETo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ahZ5Q")
    ]).then(()=>parcelRequire('hUapH'));
});
parcelRegister("ZGuam", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ktADJ").then(()=>parcelRequire('exkzN'));
});
parcelRegister("lROrJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8831k")
    ]).then(()=>parcelRequire('kXHaM'));
});
parcelRegister("cJTRV", function(module, exports) {
    $parcel$export(module.exports, "servicedeskReports1Route", ()=>$ddba74d9a05765e5$export$f5adfd681a4e85ad);
    var $65Ltd;
    const $ddba74d9a05765e5$export$f5adfd681a4e85ad = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}/reports`,
        exact: true
    };
});
const $2a2c96c36181bec8$export$e05c5e9dacfbd89d = '/jira/servicedesk/projects/:projectKey';
const $2a2c96c36181bec8$export$ddc580d759168f88 = '/reports/workload';
const $2a2c96c36181bec8$export$7bcca34e1e3ee9d4 = '/reports/atlassian-analytics';
const $2a2c96c36181bec8$export$5527975ed7975b27 = '/reports/custom/:reportId';
const $2a2c96c36181bec8$export$95e4474302b2231c = '/reports/:reportId(kb-requests-resolved|kb-requests-deflected)';
const $2a2c96c36181bec8$export$59a54976da551a4d = '/timescale/:timescaleId';
const $2a2c96c36181bec8$export$e4c007d05145b8c2 = '/reports/all-rating';
const $2a2c96c36181bec8$export$5daa28d10e23592 = '/:issueKey';
parcelRegister("7gVww", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("atEkV")
    ]).then(()=>parcelRequire('i1BaA'));
});
parcelRegister("3Nt4q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6sXwS").then(()=>parcelRequire('gIY6j'));
});
parcelRegister("lKpoc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1v184").then(()=>parcelRequire('bYkUJ'));
});
parcelRegister("hnzof", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hrAxT").then(()=>parcelRequire('cOaoL'));
});
parcelRegister("4su99", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ijyfm").then(()=>parcelRequire('hLsyG'));
});
parcelRegister("j8Qf3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lssra").then(()=>parcelRequire('dp6PR'));
});
parcelRegister("hKSst", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gZXlE").then(()=>parcelRequire('bQ0Tt'));
});
parcelRegister("aNOBo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gwvLC")
    ]).then(()=>parcelRequire('cIaZn'));
});
parcelRegister("9eS30", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kRkzv")
    ]).then(()=>parcelRequire('bWPI8'));
});
parcelRegister("lGL4F", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6Zzbw").then(()=>parcelRequire('9LJAj'));
});
parcelRegister("eBC57", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("biuin").then(()=>parcelRequire('jBLt3'));
});
parcelRegister("dePjO", function(module, exports) {
    $parcel$export(module.exports, "servicedeskServicesRoute", ()=>$93e32423b61f9abd$export$4a800381bda6d53c);
    var $65Ltd;
    const $93e32423b61f9abd$export$4a800381bda6d53c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES),
        path: `${(0, $37ca4af52bd8808a$export$e05c5e9dacfbd89d)}${(0, $37ca4af52bd8808a$export$a00b470f6b2accee)}`,
        exact: true
    };
});
const $37ca4af52bd8808a$export$e05c5e9dacfbd89d = '/jira/servicedesk/projects/:projectKey';
const $37ca4af52bd8808a$export$8478788f248b5217 = '/jira/servicedesk';
const $37ca4af52bd8808a$export$e45f794606940226 = '/:serviceAri';
const $37ca4af52bd8808a$export$a00b470f6b2accee = '/services';
const $37ca4af52bd8808a$export$9aab114cbf0ce5e = '/service-modal';
parcelRegister("6VeJW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2tGNS").then(()=>parcelRequire('6MNnt'));
});
parcelRegister("9kUwX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hAezd").then(()=>parcelRequire('1QgiZ'));
});
parcelRegister("fr1K2", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $7MmCC = parcelRequire("7MmCC");
    var $ftdKz = parcelRequire("ftdKz");
    var $etAYC = parcelRequire("etAYC");
    var $4NkAS = parcelRequire("4NkAS");
    var $b2dLE = parcelRequire("b2dLE");
    var $9SRAA = parcelRequire("9SRAA");
    var $7GWAt = parcelRequire("7GWAt");
    var $b3caba7e25e0a917$var$CLONE_DEEP_FLAG = 1, $b3caba7e25e0a917$var$CLONE_FLAT_FLAG = 2, $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG = 4;
    var $b3caba7e25e0a917$var$omit = $9SRAA(function(object, paths) {
        var result = {};
        if (object == null) return result;
        var isDeep = false;
        paths = $1nIHN(paths, function(path) {
            path = $etAYC(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
        });
        $4NkAS(object, $7GWAt(object), result);
        if (isDeep) result = $7MmCC(result, $b3caba7e25e0a917$var$CLONE_DEEP_FLAG | $b3caba7e25e0a917$var$CLONE_FLAT_FLAG | $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG, $b2dLE);
        var length = paths.length;
        while(length--)$ftdKz(result, paths[length]);
        return result;
    });
    module.exports = $b3caba7e25e0a917$var$omit;
});
parcelRegister("ftdKz", function(module, exports) {
    var $etAYC = parcelRequire("etAYC");
    var $hYfgW = parcelRequire("hYfgW");
    var $8lSJl = parcelRequire("8lSJl");
    var $gzebZ = parcelRequire("gzebZ");
    function $b4343aeaece186b7$var$baseUnset(object, path) {
        path = $etAYC(path, object);
        object = $8lSJl(object, path);
        return object == null || delete object[$gzebZ($hYfgW(path))];
    }
    module.exports = $b4343aeaece186b7$var$baseUnset;
});
parcelRegister("8lSJl", function(module, exports) {
    var $fTwLR = parcelRequire("fTwLR");
    var $dM3Z8 = parcelRequire("dM3Z8");
    function $614abd39878e1d90$var$parent(object, path) {
        return path.length < 2 ? object : $fTwLR(object, $dM3Z8(path, 0, -1));
    }
    module.exports = $614abd39878e1d90$var$parent;
});
parcelRegister("b2dLE", function(module, exports) {
    var $1QOns = parcelRequire("1QOns");
    function $808a8f8fca7f9ff7$var$customOmitClone(value) {
        return $1QOns(value) ? undefined : value;
    }
    module.exports = $808a8f8fca7f9ff7$var$customOmitClone;
});
parcelRegister("3NMrl", function(module, exports) {
    var $i2e26 = parcelRequire("i2e26");
    var $9SRAA = parcelRequire("9SRAA");
    var $2c4b85df1af41471$var$pick = $9SRAA(function(object, paths) {
        return object == null ? {} : $i2e26(object, paths);
    });
    module.exports = $2c4b85df1af41471$var$pick;
});
parcelRegister("i2e26", function(module, exports) {
    var $4gaCO = parcelRequire("4gaCO");
    var $fh9gH = parcelRequire("fh9gH");
    function $d2134c8f0f8064b1$var$basePick(object, paths) {
        return $4gaCO(object, paths, function(value, path) {
            return $fh9gH(object, path);
        });
    }
    module.exports = $d2134c8f0f8064b1$var$basePick;
});
parcelRegister("kUr4d", function(module, exports) {
    $parcel$export(module.exports, "createRoot", ()=>$f38e08888af96a1f$export$882461b6382ed46c, (v)=>$f38e08888af96a1f$export$882461b6382ed46c = v);
    $parcel$export(module.exports, "hydrateRoot", ()=>$f38e08888af96a1f$export$757ceba2d55c277e, (v)=>$f38e08888af96a1f$export$757ceba2d55c277e = v);
    var $f38e08888af96a1f$export$882461b6382ed46c;
    var $f38e08888af96a1f$export$757ceba2d55c277e;
    'use strict';
    var $7nsd3 = parcelRequire("7nsd3");
    var $f38e08888af96a1f$var$i;
    $f38e08888af96a1f$export$882461b6382ed46c = $7nsd3.createRoot;
    $f38e08888af96a1f$export$757ceba2d55c277e = $7nsd3.hydrateRoot;
});
parcelRegister("0z6W8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af450dab6fb30b5f$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "updatePageloadName", ()=>$af450dab6fb30b5f$export$d0f99433cd4f4028);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $5gx4p;
    var $fe1wc;
    var $tcn7E;
    var $1u4q7;
    var $bFU4G;
    var $9AgLs;
    const $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
    function $af450dab6fb30b5f$export$2e2bcd8739ae039(ufoName, routeName = ufoName) {
        const activeInteraction = (0, (0, parcelRequire("bFU4G")).getActiveInteraction)();
        if (activeInteraction && !ufoName) return;
        (0, (0, parcelRequire("9AgLs")).default).current = routeName || null;
        const rate = ufoName ? (0, (0, parcelRequire("fe1wc")).getInteractionRate)(ufoName, 'page_load') : 1;
        const enabledBySamplingRate = (0, (0, parcelRequire("5gx4p")).default)(rate);
        if (enabledBySamplingRate && !activeInteraction) {
            const newId = (0, $7Jxgt.v4)();
            (0, (0, parcelRequire("1u4q7")).DefaultInteractionID).current = newId;
            (0, (0, parcelRequire("bFU4G")).addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, (0, parcelRequire("tcn7E")).getActiveTrace)());
            if (!ufoName) (0, (0, parcelRequire("bFU4G")).addHoldByID)(newId, [], $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME, $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME, true);
        } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') (0, (0, parcelRequire("bFU4G")).abort)(activeInteraction.id, 'excluded_by_sampling');
        else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
            (0, (0, parcelRequire("bFU4G")).updatePageLoadInteractionName)(ufoName, routeName);
            (0, (0, parcelRequire("bFU4G")).removeHoldByID)(activeInteraction.id, $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME);
        }
    }
    function $af450dab6fb30b5f$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
        const interaction = (0, (0, parcelRequire("bFU4G")).getActiveInteraction)();
        if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
        if (ufoName) {
            const rate = (0, (0, parcelRequire("fe1wc")).getInteractionRate)(ufoName, 'page_load');
            (0, (0, parcelRequire("bFU4G")).updatePageLoadInteractionName)(ufoName, routeName);
            if ((0, (0, parcelRequire("5gx4p")).default)(rate)) (0, (0, parcelRequire("9AgLs")).default).current = ufoName;
            else (0, (0, parcelRequire("bFU4G")).abort)(interaction.id, 'excluded_by_sampling');
        }
        (0, (0, parcelRequire("bFU4G")).removeHoldByID)(interaction.id, $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME);
    }
});
parcelRegister("8ApFP", function(module, exports) {
    $parcel$export(module.exports, "routeAnalyticsAttributes", ()=>$a83c9e8eeb3d40c2$export$c71778b3a4356b04);
    var $cfDZ3;
    var $hVf1M;
    const $a83c9e8eeb3d40c2$export$c71778b3a4356b04 = Object.defineProperties({}, {
        routeName: {
            enumerable: true,
            get: (0, (0, parcelRequire("cfDZ3")).getRouteName)
        },
        userLocation: {
            enumerable: true,
            get: (0, (0, parcelRequire("cfDZ3")).getUserLocation)
        },
        previousSubProduct: {
            enumerable: true,
            get: (0, (0, parcelRequire("cfDZ3")).getPreviousSubProduct)
        },
        isProjectAdmin: {
            enumerable: true,
            get: (0, (0, parcelRequire("hVf1M")).getIsProjectAdmin)
        }
    });
});
parcelRegister("2YzDH", function(module, exports) {
    var $jOqMN;
    if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
        (parcelRequire("2Geeh"));
        const isDevMode = false;
        (0, (0, parcelRequire("jOqMN")).default).devtools = isDevMode && (()=>({
                serialize: {
                    replacer: (key, value)=>value instanceof HTMLElement ? {
                            data: {
                                tagName: value.tagName,
                                className: value.className,
                                id: value.id,
                                __SANITIZED__: true
                            },
                            __serializedType__: 'HTMLElement'
                        } : value
                }
            }));
        (0, (0, parcelRequire("jOqMN")).default).batchUpdates = !false;
        Object.freeze((0, (0, parcelRequire("jOqMN")).default));
        $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
    }
});
parcelRegister("2Geeh", function(module, exports) {
    const $1f3a8aadd86b4cc5$var$style = document.createElement('style');
    $1f3a8aadd86b4cc5$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;-webkit-text-decoration-skip-ink:auto;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.006em;color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.003em;color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ol ul:not(:first-child),ul ol:not(:first-child),ol ol:not(:first-child){margin-top:var(--ds-space-050,4px)}p:first-child,ul:first-child,ol:first-child,dl:first-child,h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child,h6:first-child,blockquote:first-child,pre:first-child,form:first-child,table:first-child{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,"SFMono-Medium","SF Mono","Segoe UI Mono","Roboto Mono","Ubuntu Mono",Menlo,Consolas,Courier,monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{--lightningcss-light:initial;--lightningcss-dark: ;color-scheme:light}[data-color-mode=dark]{--lightningcss-light: ;--lightningcss-dark:initial;color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,th:first-child{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
    document.querySelector('head').appendChild($1f3a8aadd86b4cc5$var$style);
});
parcelRegister("frBVt", function(module, exports) {
    $parcel$export(module.exports, "getPlaceholdersFromHTML", ()=>$126443352ff757de$export$9e9f35acc3af3a9a);
    $parcel$export(module.exports, "EntryPointPlaceholderContext", ()=>$126443352ff757de$export$b5b377bb81310c48);
    $parcel$export(module.exports, "EntryPointPlaceholder", ()=>$126443352ff757de$export$db2828f683d11042);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    function $126443352ff757de$export$9e9f35acc3af3a9a() {
        const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
        return new Map(Array.from(placeholders, (el)=>[
                el.dataset.epPlaceholderId,
                el.innerHTML
            ]));
    }
    const $126443352ff757de$export$b5b377bb81310c48 = (0, $5uXOq.createContext)(new Map());
    function $126443352ff757de$export$db2828f683d11042({ children: children, entryPoint: entryPoint, fallback: originalFallback, name: name, ...placeholderProps }) {
        const { root: root } = entryPoint;
        const hasMounted = (0, $5uXOq.useRef)(false);
        const placeholders = (0, $5uXOq.useContext)($126443352ff757de$export$b5b377bb81310c48);
        const ssrFallback = placeholders.get(name);
        const [fallback, setFallback] = (0, $5uXOq.useState)(!ssrFallback || root.getModuleIfRequired() ? originalFallback : (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            dangerouslySetInnerHTML: {
                __html: ssrFallback
            },
            "data-ep-placeholder-id": name
        }));
        const lastOriginalFallback = (0, $5uXOq.useRef)(originalFallback);
        lastOriginalFallback.current = originalFallback;
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (hasMounted.current && placeholders.has(name)) {
                placeholders.delete(name);
                setFallback(lastOriginalFallback.current);
            }
        }, [
            entryPoint,
            name,
            placeholders,
            setFallback
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const onComplete = ()=>{
                if (placeholders.has(name)) placeholders.delete(name);
                setFallback(lastOriginalFallback.current);
            };
            const unsubscribe = root.onComplete(onComplete, onComplete);
            return ()=>{
                unsubscribe();
                onComplete();
            };
        }, [
            name,
            placeholders,
            root
        ]);
        (0, $5uXOq.useEffect)(()=>{
            hasMounted.current = true;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            fallback: fallback,
            name: name,
            ...placeholderProps
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-ep-placeholder-id": name
        }, children));
    }
});
parcelRegister("7bkFJ", function(module, exports) {
    $parcel$export(module.exports, "initPlatformFeatureFlags", ()=>$fef4d3d4b4c51b47$export$2d291317456ada16);
    var $VSDnB;
    var $4R6GH;
    var $co1wz;
    const $fef4d3d4b4c51b47$export$2d291317456ada16 = ([isOverride, resolver])=>{
        if ((0, (0, parcelRequire("co1wz")).ff)('fix_jira_ssr_platform_ff_oxim4')) (0, (0, parcelRequire("VSDnB")).setBooleanFeatureFlagResolver)((flagKey)=>isOverride(flagKey) ? resolver(flagKey) : (0, (0, parcelRequire("4R6GH")).fg)(flagKey) || (0, (0, parcelRequire("co1wz")).ff)(flagKey));
    };
});
parcelRegister("fz3fB", function(module, exports) {
    $parcel$export(module.exports, "NonCritical", ()=>$a1827329dcbac5c8$export$20fd89b1bf707b1a);
    $parcel$export(module.exports, "default", ()=>$a1827329dcbac5c8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $6yXtV;
    const $a1827329dcbac5c8$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
        const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (timerThreshold != null) setTimeout(()=>{
                setHasThresholdTimerExpired(true);
            }, timerThreshold);
        }, [
            timerThreshold
        ]);
        if (!isFirstRun || isReady || hasThresholdTimerExpired) {
            isFirstRun && setFirstRun(false);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        }
        return null;
    };
    const $a1827329dcbac5c8$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: id,
            teamName: teamName,
            packageName: "jiraPlatformNonCritical",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a1827329dcbac5c8$export$83d969795398ec56, props));
    const $a1827329dcbac5c8$var$NonCriticalComponent = (props)=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
        if (!isFirstRun || isReady) {
            isFirstRun && setFirstRun(false);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        }
        return null;
    };
    const $a1827329dcbac5c8$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: id,
            teamName: teamName,
            packageName: "jiraPlatformNonCritical",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a1827329dcbac5c8$var$NonCriticalComponent, props));
    var $a1827329dcbac5c8$export$2e2bcd8739ae039 = $a1827329dcbac5c8$var$NonCriticalComponent;
});
parcelRegister("6yXtV", function(module, exports) {
    $parcel$export(module.exports, "useSpaStatePageReady", ()=>$44de65c7edb80809$export$ea2491906b753456);
    $parcel$export(module.exports, "SpaStatePageReady", ()=>$44de65c7edb80809$export$c34439f945fccbdf);
    $parcel$export(module.exports, "SpaStatePageReadyOnUpdate", ()=>$44de65c7edb80809$export$41e70078eeddaddc);
    var $5uXOq = parcelRequire("5uXOq");
    var $5h5Fg;
    var $3sQ5x;
    var $4oDnX;
    var $7w9eZ;
    const $44de65c7edb80809$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
        const { apps: apps } = currentPage;
        const appIds = Object.keys(apps);
        return {
            isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
        };
    };
    const $44de65c7edb80809$export$ea2491906b753456 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: $44de65c7edb80809$export$e6897aa59ee7aee5
    });
    const $44de65c7edb80809$export$c34439f945fccbdf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5h5Fg")).default), {
                op: setAppReady
            }));
    const $44de65c7edb80809$export$41e70078eeddaddc = ({ comparer: comparer })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5h5Fg")).default), {
                op: setAppReady,
                args: comparer
            }));
});
parcelRegister("gAeCk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5368db3a32c0eb20$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $x9xyg;
    const $5368db3a32c0eb20$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
        const renderRef = (0, $5uXOq.useRef)(false);
        if (!renderRef.current) {
            renderRef.current = true;
            (0, (0, parcelRequire("x9xyg")).setMark)(metricKey);
            onSet && onSet();
        }
        return null;
    };
    var $5368db3a32c0eb20$export$2e2bcd8739ae039 = $5368db3a32c0eb20$var$PerformanceMark;
});
parcelRegister("erCTW", function(module, exports) {
    $parcel$export(module.exports, "PageContainer", ()=>$a81b2dc7c8e9cabb$export$5f86df0ee0a255b5);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $gAeCk;
    var $7CMCs;
    var $7XYc4;
    var $14V0U;
    var $g7crU;
    var $jHXUj;
    var $aKiiD;
    var $cPiXk;
    var $3HwlS;
    var $iqLcb;
    var $16YKp;
    var $cOwuh;
    var $iXVV6;
    var $3Uek9;
    var $gAaIa;
    var $2SVPM;
    var $gmCnE;
    var $kc9FZ;
    var $6DLIs;
    var $62C9r;
    var $4s15Z;
    var $eF0qp;
    var $gxCm0;
    var $lvpKt;
    var $8Ceqd;
    const $a81b2dc7c8e9cabb$var$mainWrapperStyles = {
        root: "_4t3i1osq _1e0c1txw _2lx21bp4 _9beo1bgi",
        themed: "_11q7mmei _11q31r52"
    };
    const $a81b2dc7c8e9cabb$var$ROOT_TEST_ID = 'page-layout.root';
    const $a81b2dc7c8e9cabb$var$MAIN_TEST_ID = 'page-layout.main';
    const $a81b2dc7c8e9cabb$var$PageContainerNew = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
        const [isChromeless] = (0, (0, parcelRequire("14V0U")).useIsChromeless)();
        const [isFullscreen] = (0, (0, parcelRequire("g7crU")).useIsFullscreen)();
        const { hasTheming: hasTheming } = (0, (0, parcelRequire("3Uek9")).useProjectTheme)();
        const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, (0, parcelRequire("16YKp")).useBannerJsmPackagingUpdates)();
        const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$898b6208220685b0), (0, $9ccbd88c704da1ef$export$e2bc63118050de32), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), true, false);
        }, []);
        const mainWrapper = (content)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Main), {
                isFixed: true,
                testId: $a81b2dc7c8e9cabb$var$MAIN_TEST_ID
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    $a81b2dc7c8e9cabb$var$mainWrapperStyles.root,
                    hasTheming && $a81b2dc7c8e9cabb$var$mainWrapperStyles.themed
                ])
            }, isJsmPackagingUpdatesEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOwuh")).BannerJsmPackagingUpdateAsync), null), content));
        const showBanner = !isChromeless && !isFullscreen;
        const showTopNav = !isChromeless && !isFullscreen;
        const showSidebar = !isChromeless && !isFullscreen;
        const showHorizontalNav = !isChromeless;
        const showRightSidebar = !isChromeless && !isFullscreen;
        const showLayoutRemoteStateUpdater = !isChromeless && !isFullscreen;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$e2bc63118050de32)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Ceqd")).ThemeSetter), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6DLIs")).GlobalContainers), {
            id: id,
            locale: locale,
            baseUrl: baseUrl,
            messages: messages,
            Router: Router,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$59f83d43fe209319),
            onSet: pageContainerPerformanceTiming
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "navigationNext"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).PageLayout), {
            skipLinksLabel: "",
            testId: $a81b2dc7c8e9cabb$var$ROOT_TEST_ID
        }, showBanner && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "banner",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gmCnE")).Banner), null)), showTopNav && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "top-nav",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxCm0")).TopNav), null)), showSidebar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "sidebar",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eF0qp")).Sidebar), null)), mainWrapper((0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, showHorizontalNav && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("62C9r")).HorizontalNav), null), children)), showRightSidebar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "right-sidebar",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4s15Z")).RightSidebar), null)), showLayoutRemoteStateUpdater && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            packageName: "jiraPageContainerV2",
            id: "layout-remote-state-updater",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHXUj")).LayoutRemoteStateUpdater), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kc9FZ")).GlobalComponents), {
            sharedGlobalComponents: (0, (0, parcelRequire("gAaIa")).sharedLayout).globalComponents
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aKiiD")).GlobalBottomRightCornerContainer), null))));
    };
    const $a81b2dc7c8e9cabb$var$PageContainerOld = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
        const HorizontalNavComponent = (0, (0, parcelRequire("cPiXk")).useHorizontalNavComponent)();
        const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, (0, parcelRequire("16YKp")).useBannerJsmPackagingUpdates)();
        const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$898b6208220685b0), (0, $9ccbd88c704da1ef$export$e2bc63118050de32), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), true, false);
        }, []);
        let contentChildren = isJsmPackagingUpdatesEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOwuh")).BannerJsmPackagingUpdateAsync), null), children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        if (HorizontalNavComponent != null) contentChildren = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("62C9r")).HorizontalNavWrapper), {
            navComponent: HorizontalNavComponent
        }, isJsmPackagingUpdatesEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOwuh")).BannerJsmPackagingUpdateAsync), null), children);
        const panelContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lvpKt")).FullHeight), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).PageLayout), {
            skipLinksLabel: ""
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "banner",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gmCnE")).Banner), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "top-nav",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxCm0")).TopNav), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).LeftPanel), {
            width: 0
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Content), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "sidebar",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eF0qp")).Sidebar), null)), contentChildren, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "right-sidebar",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4s15Z")).RightSidebar), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            packageName: "page-container",
            id: "layout-remote-state-updater",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHXUj")).LayoutRemoteStateUpdater), null)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kc9FZ")).GlobalComponents), {
            sharedGlobalComponents: (0, (0, parcelRequire("gAaIa")).sharedLayout).globalComponents
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aKiiD")).GlobalBottomRightCornerContainer), null));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$e2bc63118050de32)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Ceqd")).ThemeSetter), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6DLIs")).GlobalContainers), {
            id: id,
            locale: locale,
            baseUrl: baseUrl,
            messages: messages,
            Router: Router,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$59f83d43fe209319),
            onSet: pageContainerPerformanceTiming
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "navigationNext"
        }, panelContent)));
    };
    const $a81b2dc7c8e9cabb$export$5f86df0ee0a255b5 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $a81b2dc7c8e9cabb$var$PageContainerNew, $a81b2dc7c8e9cabb$var$PageContainerOld);
});
parcelRegister("14V0U", function(module, exports) {
    $parcel$export(module.exports, "useIsChromeless", ()=>$96950c90e73fdad9$export$c88b74884f5222ba);
    var $3sQ5x;
    var $5e5zm;
    const $96950c90e73fdad9$export$c88b74884f5222ba = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>state.isChromeless
    });
});
parcelRegister("g7crU", function(module, exports) {
    $parcel$export(module.exports, "useIsFullscreen", ()=>$aa937e51388f56fd$export$d397eccea5f37b0a);
    var $3sQ5x;
    var $5e5zm;
    const $aa937e51388f56fd$export$d397eccea5f37b0a = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>state.isFullscreen
    });
});
parcelRegister("jHXUj", function(module, exports) {
    $parcel$export(module.exports, "LayoutRemoteStateUpdater", ()=>$89937a782c6cb988$export$b9f3a70460995c32);
    var $5uXOq = parcelRequire("5uXOq");
    var $89SaW;
    var $jcw0u;
    var $7XYc4;
    var $3HwlS;
    var $iqLcb;
    var $c34Wf;
    var $90yGq;
    var $2YP9W;
    var $5e5zm;
    var $gPQRI;
    var $hsmeR;
    var $2TwSO;
    const $89937a782c6cb988$var$LayoutRemoteStateUpdaterOld = ()=>{
        const { leftSidebarState: leftSidebarState } = (0, (0, parcelRequire("iqLcb")).usePageLayoutResize)();
        const { isFlyoutOpen: isFlyoutOpen, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
        const resolvedLeftSidebarWidth = Math.max(leftSidebarWidth, (0, (0, parcelRequire("5e5zm")).DEFAULT_LEFT_SIDEBAR_WIDTH));
        const [, { setLeftSidebarState: setLeftSidebarState }] = (0, (0, parcelRequire("5e5zm")).useLayoutStoreActions)();
        const isCollapsed = leftSidebarState.isLeftSidebarCollapsed;
        const rightSidebarState = (0, (0, parcelRequire("hsmeR")).useRightSidebarState)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("c34Wf")).navigationUiStateResource));
        const isLayoutStateReady = leftSidebarWidth !== 0 && leftSidebarState.lastLeftSidebarWidth !== 0;
        (0, $5uXOq.useEffect)(()=>{
            if (!isLayoutStateReady) return;
            if (error) return;
            setLeftSidebarState({
                width: resolvedLeftSidebarWidth,
                isCollapsed: isCollapsed,
                isFlyoutOpen: isFlyoutOpen,
                isVisible: true
            });
        }, [
            error,
            isCollapsed,
            isFlyoutOpen,
            isLayoutStateReady,
            resolvedLeftSidebarWidth,
            setLeftSidebarState
        ]);
        const updateData = (0, $5uXOq.useCallback)(async ()=>{
            if (loading) return;
            if (error) return;
            if (!isLayoutStateReady) return;
            const remoteData = {
                ...data,
                leftSidebar: {
                    width: resolvedLeftSidebarWidth,
                    isCollapsed: isLeftSidebarCollapsed
                },
                rightSidebar: rightSidebarState
            };
            if (accountId) try {
                await (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(remoteData));
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e,
                    meta: {
                        id: 'updateServerLayoutState',
                        packageName: 'jiraLayoutController',
                        teamName: 'magma'
                    }
                });
            }
        }, [
            accountId,
            data,
            error,
            isLayoutStateReady,
            isLeftSidebarCollapsed,
            loading,
            resolvedLeftSidebarWidth,
            rightSidebarState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            updateData();
        }, [
            isLeftSidebarCollapsed,
            resolvedLeftSidebarWidth,
            updateData
        ]);
        return null;
    };
    const $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew = ()=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const leftSidebar = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const rightSidebar = (0, (0, parcelRequire("hsmeR")).useRightSidebarState)();
        const isLeftSidebarCollapsed = leftSidebar.isCollapsed;
        const leftSidebarWidth = leftSidebar.width;
        (0, $5uXOq.useEffect)(()=>{
            if (!accountId) return;
            (0, (0, parcelRequire("2TwSO")).setRemoteLayoutState)({
                accountId: accountId,
                state: {
                    rightSidebar: rightSidebar,
                    leftSidebar: {
                        isCollapsed: isLeftSidebarCollapsed,
                        width: leftSidebarWidth
                    }
                }
            });
        }, [
            accountId,
            isLeftSidebarCollapsed,
            leftSidebarWidth,
            rightSidebar
        ]);
        return null;
    };
    const $89937a782c6cb988$export$b9f3a70460995c32 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew, $89937a782c6cb988$var$LayoutRemoteStateUpdaterOld);
});
parcelRegister("2TwSO", function(module, exports) {
    $parcel$export(module.exports, "setRemoteLayoutState", ()=>$9d3e8b8a199ea341$export$ad53b565e6cd4261);
    var $89SaW;
    var $jcw0u;
    async function $9d3e8b8a199ea341$export$ad53b565e6cd4261({ accountId: accountId, state: state }) {
        try {
            await (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(state));
        } catch (e) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: e,
                meta: {
                    id: 'updateServerLayoutState',
                    packageName: 'jiraLayoutController',
                    teamName: 'jfp-team'
                }
            });
        }
    }
});
parcelRegister("aKiiD", function(module, exports) {
    $parcel$export(module.exports, "GlobalBottomRightCornerContainer", ()=>$1ca472b9239dbdd7$export$715c8d5890c054bb);
    $parcel$export(module.exports, "GlobalBottomRightCornerContainerProvider", ()=>$1ca472b9239dbdd7$export$1e86e3484191597c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $b71gk;
    var $l8ruj;
    var $hvrWv;
    var $hsmeR;
    var $5e5zm;
    function $1ca472b9239dbdd7$export$e112b78171de7a6({ bottomOffset: bottomOffset, rightOffset: rightOffset }) {
        const [{ width: width }] = (0, (0, parcelRequire("5e5zm")).useDetailPanelWidth)();
        const rightSidebar = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const { registerBottomRightCornerContainer: registerBottomRightCornerContainer } = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerActions)();
        const isSidebarOpen = rightSidebar && !rightSidebar.isCollapsed && !rightSidebar.isMinimised;
        const rightSidebarWidth = isSidebarOpen ? rightSidebar.width : 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$var$StyledContainer, {
            ref: registerBottomRightCornerContainer,
            "data-testid": "layout-controller.ui.bottom-right-corner.container.styled-container",
            style: {
                right: `calc(${width + rightOffset + rightSidebarWidth}px + ${"var(--ds-space-300, 24px)"})`,
                bottom: `calc(${"var(--ds-space-300, 24px)"} + ${bottomOffset}px)`
            }
        });
    }
    const $1ca472b9239dbdd7$export$715c8d5890c054bb = ({ bottomOffset: bottomOffset = 0, rightOffset: rightOffset = 0 })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b71gk")).default), {
            id: "bottom-right-corner-container",
            packageName: "jira-bottom-right-corner-controller"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$export$e112b78171de7a6, {
            bottomOffset: bottomOffset,
            rightOffset: rightOffset
        }));
    const $1ca472b9239dbdd7$export$1e86e3484191597c = ({ children: children })=>{
        const container = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerContainer)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "global-bottom-right-corner"
        }, container && children, (0, ($parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$export$715c8d5890c054bb, null));
    };
    const $1ca472b9239dbdd7$var$StyledContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1n9t _1e0c1txw _1pbyfjpv _1reoewfl _18m9ewfl _4cvresu3 _lcxvglyw",
                __cmplp.className
            ])
        });
    });
    $1ca472b9239dbdd7$var$StyledContainer.displayName = 'StyledContainer';
});
parcelRegister("hvrWv", function(module, exports) {
    $parcel$export(module.exports, "useBottomRightCornerContainer", ()=>$4dcd4c0b25ba3fd4$export$84542488b6b6c309);
    $parcel$export(module.exports, "useBottomRightCornerActions", ()=>$4dcd4c0b25ba3fd4$export$de496fd0e0151c81);
    var $3sQ5x;
    var $5e5zm;
    const $4dcd4c0b25ba3fd4$export$84542488b6b6c309 = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>state.bottomRightCorner.container
    });
    const $4dcd4c0b25ba3fd4$export$de496fd0e0151c81 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)((0, (0, parcelRequire("5e5zm")).layoutStore));
});
parcelRegister("cPiXk", function(module, exports) {
    $parcel$export(module.exports, "useHorizontalNavComponent", ()=>$2edc33969f533189$export$205771a0e64e4c7c);
    var $l71WK;
    var $2vSU6;
    var $65Ltd;
    var $4R6GH;
    var $14V0U;
    var $3HwlS;
    var $6jY6G;
    var $dAfqg;
    var $c1mlA;
    var $5PD5h;
    var $lODMY;
    const $2edc33969f533189$export$965942f8308cd740 = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>(0, (0, parcelRequire("c1mlA")).BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(state.query.config));
    const $2edc33969f533189$export$205771a0e64e4c7c = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: projectData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const hasBoardSettingsPageQueryParam = $2edc33969f533189$export$965942f8308cd740();
        if (!(0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) {
            const [isChromeless] = (0, (0, parcelRequire("14V0U")).useIsChromeless)();
            if (isChromeless) return null;
        }
        if (route.navigation?.horizontal == null) return null;
        if (route.navigation.horizontal === (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)) {
            if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return null;
            switch(projectData?.projectType){
                case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                    return 0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav;
                default:
                    return null;
            }
        }
        if (route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE) && hasBoardSettingsPageQueryParam && (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('simplified-boards-milestone-2_07hbk')) return null;
        if (route.navigation.horizontal === (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)) switch(projectData?.projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return 0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return 0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav;
                return null;
            default:
                return null;
        }
        if ('onlyShowHorizontalOnNav4' in route.navigation && route.navigation.onlyShowHorizontalOnNav4) return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? route.navigation.horizontal : null;
        if ('horizontalFeatureFlag' in route.navigation) switch(route.navigation.horizontalFeatureFlag){
            case 'jsm_views_of_work_phase_1':
                return (0, (0, parcelRequire("4R6GH")).fg)('jsm_views_of_work_phase_1') ? route.navigation.horizontal : null;
            default:
                {
                    const exhaustiveCheck = route.navigation.horizontalFeatureFlag;
                    return exhaustiveCheck;
                }
        }
        return route.navigation.horizontal;
    };
});
parcelRegister("c1mlA", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_METRICS_HISTOGRAM", ()=>$4c8f71f257051803$export$128e24da52662cdd);
    $parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION", ()=>$4c8f71f257051803$export$efdecbe4c9f1cd2c);
    $parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_SAC_URL_CONFIG_DISABLE_SECTION", ()=>$4c8f71f257051803$export$1154ed64d0d99951);
    $parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID", ()=>$4c8f71f257051803$export$7cadd2a48a9ff918);
    $parcel$export(module.exports, "DEFAULT_LEVEL_ONE_NAME", ()=>$4c8f71f257051803$export$a546b6d48878ce6f);
    $parcel$export(module.exports, "BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES", ()=>$4c8f71f257051803$export$8cc83ae2b6885e0);
    $parcel$export(module.exports, "boardSettingsQueryConfigParamValues", ()=>$4c8f71f257051803$export$a9ebdab56bd9c0c3);
    $parcel$export(module.exports, "SETTINGS_CONFIG", ()=>$4c8f71f257051803$export$2a56ee2f9c41b5a7);
    $parcel$export(module.exports, "EDIT_BOARD_CONFIG", ()=>$4c8f71f257051803$export$b893894941c14e43);
    $parcel$export(module.exports, "ADMINISTER_PARENT_PROJECT", ()=>$4c8f71f257051803$export$d14d5a7c294329c5);
    $parcel$export(module.exports, "USER_PICKER_PROJECT_PERMISSION_KEY", ()=>$4c8f71f257051803$export$1e63b013f0e45de0);
    $parcel$export(module.exports, "ADMINISTER_PROJECT_PERMISSION_KEY", ()=>$4c8f71f257051803$export$68030ac1ea4abd4c);
    $parcel$export(module.exports, "BACKLOG_FEATURE_KEY", ()=>$4c8f71f257051803$export$e1671d3447ddd5ad);
    $parcel$export(module.exports, "SPRINTS_FEATURE_KEY", ()=>$4c8f71f257051803$export$46efc2c8d8106cff);
    $parcel$export(module.exports, "FEATURE_ENABLED_STATUS", ()=>$4c8f71f257051803$export$a1046f102eae498);
    const $4c8f71f257051803$export$128e24da52662cdd = '1000_1500_2000_2500_3000_4000';
    const $4c8f71f257051803$export$efdecbe4c9f1cd2c = '2QE2xWf0TpDbYpk4oY9aQr';
    const $4c8f71f257051803$export$1154ed64d0d99951 = 'https://support.atlassian.com/jira-software-cloud/docs/how-do-jira-permissions-work/';
    const $4c8f71f257051803$export$7cadd2a48a9ff918 = `${$4c8f71f257051803$export$efdecbe4c9f1cd2c}.config-disabled-section.article.analytics`;
    const $4c8f71f257051803$export$a546b6d48878ce6f = 'Epic';
    const $4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES = [
        'cardColors',
        'cardLayout',
        'columns',
        'default',
        'estimation',
        'filter',
        'swimlanes',
        'time',
        'timelineConfig',
        'quickFilters',
        'dateFields'
    ];
    const $4c8f71f257051803$export$8cc83ae2b6885e0 = new Set($4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES);
    const $4c8f71f257051803$export$a9ebdab56bd9c0c3 = Object.fromEntries($4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.map((key)=>[
            key,
            key
        ]));
    const $4c8f71f257051803$export$2a56ee2f9c41b5a7 = {
        default: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.filter,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        filter: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.filter,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        columns: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.columns,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        swimlanes: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.swimlanes,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        quickFilters: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.quickFilters,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        cardColors: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.cardColors,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        cardLayout: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.cardLayout,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        estimation: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.estimation,
            jsmAllowed: false,
            userLocatedBoardAllowed: true,
            kanbanAllowed: false
        },
        time: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.time,
            jsmAllowed: false,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        timelineConfig: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.timelineConfig,
            jsmAllowed: false,
            userLocatedBoardAllowed: false,
            kanbanAllowed: true
        },
        dateFields: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.dateFields,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        }
    };
    const $4c8f71f257051803$export$773ca4f5fb67778b = 60000;
    const $4c8f71f257051803$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
    const $4c8f71f257051803$export$d14d5a7c294329c5 = 'ADMINISTER_PARENT_PROJECT';
    const $4c8f71f257051803$export$1e63b013f0e45de0 = 'USER_PICKER';
    const $4c8f71f257051803$export$68030ac1ea4abd4c = 'ADMINISTER';
    const $4c8f71f257051803$export$e1671d3447ddd5ad = 'BACKLOG';
    const $4c8f71f257051803$export$46efc2c8d8106cff = 'SPRINTS';
    const $4c8f71f257051803$export$a1046f102eae498 = 'ENABLED';
    const $4c8f71f257051803$export$450e5ddc9f1ff901 = 'DISABLED';
});
const $0c2b5b2aa81ed54b$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $0c2b5b2aa81ed54b$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';
const $9ccbd88c704da1ef$export$c9e16a15d65437 = 'navigationNext';
const $9ccbd88c704da1ef$export$b1534bc11f201efd = 'jiraPageContainer';
const $9ccbd88c704da1ef$export$fa4bbc89fd1f1a7 = null;
const $9ccbd88c704da1ef$export$aa6008fe0169b864 = null;
const $9ccbd88c704da1ef$export$39418a21fbb51487 = null;
const $9ccbd88c704da1ef$export$7dfef0177e883b05 = 'entry.jira-spa';
const $9ccbd88c704da1ef$var$PAGE_CONTAINER_MARK = 'jira-spa/spa-shell/page-container';
const $9ccbd88c704da1ef$export$7114284ca03133ee = `_${$9ccbd88c704da1ef$var$PAGE_CONTAINER_MARK}.end`;
const $9ccbd88c704da1ef$export$21473105c510aacc = 'jira-spa/spa-shell/page-layout';
const $9ccbd88c704da1ef$export$898b6208220685b0 = 'jira-spa/spa-shell/global-containers';
const $9ccbd88c704da1ef$export$e2bc63118050de32 = `_${$9ccbd88c704da1ef$export$898b6208220685b0}.start`;
const $9ccbd88c704da1ef$export$59f83d43fe209319 = `_${$9ccbd88c704da1ef$export$898b6208220685b0}.end`;
const $9ccbd88c704da1ef$export$fb9876ab4228d985 = 'jira-spa/spa-shell/global-components';
const $9ccbd88c704da1ef$export$c20831be6f780cb5 = `_${$9ccbd88c704da1ef$export$fb9876ab4228d985}.start`;
const $9ccbd88c704da1ef$export$398df1bca49f9884 = `_${$9ccbd88c704da1ef$export$fb9876ab4228d985}.end`;
const $9ccbd88c704da1ef$export$7048c99f32c60b34 = 'jira-spa/spa-shell/global-containers/app-base';
const $9ccbd88c704da1ef$export$3c2d8af5c7577fe7 = `_${$9ccbd88c704da1ef$export$7048c99f32c60b34}.start`;
const $9ccbd88c704da1ef$export$aac77afee74c49d0 = `_${$9ccbd88c704da1ef$export$7048c99f32c60b34}.end`;
const $9ccbd88c704da1ef$export$4f341d86a3c214 = 'jira-spa/spa-shell/global-containers/router';
const $9ccbd88c704da1ef$export$16e7ead3a8b5c366 = `_${$9ccbd88c704da1ef$export$4f341d86a3c214}.start`;
const $9ccbd88c704da1ef$export$c389f0b50840d5ca = `_${$9ccbd88c704da1ef$export$4f341d86a3c214}.end`;
parcelRegister("16YKp", function(module, exports) {
    $parcel$export(module.exports, "useBannerJsmPackagingUpdates", ()=>$32df9c26e8c82916$export$a0dde3f151a99607);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $4R6GH;
    var $6jY6G;
    var $dAfqg;
    var $gzrJT;
    var $90yGq;
    var $l2Uy7;
    const $32df9c26e8c82916$export$a0dde3f151a99607 = ()=>{
        const currentRoute = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: project } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const isServiceProject = project?.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
        const isInJsmBoundary = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("l2Uy7")).isInJsmGlobalSettingsBoundary)(currentRoute.path) || isServiceProject, [
            isServiceProject,
            currentRoute.path
        ]);
        const { shouldShow: shouldShow, dismissAnnouncement: dismissAnnouncement } = (0, (0, parcelRequire("gzrJT")).useJsmRepackagingAnnouncementResource)(accountId);
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: isInJsmBoundary && shouldShow && (0, (0, parcelRequire("4R6GH")).fg)('jsm-packaging-pricing-changes-announcement'),
                dismissAnnouncement: dismissAnnouncement
            }), [
            dismissAnnouncement,
            isInJsmBoundary,
            shouldShow
        ]);
    };
});
parcelRegister("gzrJT", function(module, exports) {
    $parcel$export(module.exports, "useJsmRepackagingAnnouncementResource", ()=>$e073f4ec0b653e88$export$47d5fef12f2d184b);
    var $5uXOq = parcelRequire("5uXOq");
    var $89SaW;
    var $jcw0u;
    var $2M1hQ;
    var $2YP9W;
    var $hj0lE;
    const $e073f4ec0b653e88$var$getDataLoader = ()=>(parcelRequire("fjlZb"));
    const $e073f4ec0b653e88$export$750cb6ed3dfc6a3 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'JSM_REPACKAGING_ANNOUNCEMENT',
        getKey: ()=>'JSM_REPACKAGING_ANNOUNCEMENT',
        getDataLoader: $e073f4ec0b653e88$var$getDataLoader,
        maxAge: Infinity
    });
    const $e073f4ec0b653e88$export$47d5fef12f2d184b = (accountId)=>{
        const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, (0, parcelRequire("2YP9W")).useResource)($e073f4ec0b653e88$export$750cb6ed3dfc6a3);
        const loadingRef = (0, $5uXOq.useRef)(false);
        const errorRef = (0, $5uXOq.useRef)();
        const [userPropertiesError, setUserPropertiesError] = (0, $5uXOq.useState)();
        errorRef.current = userPropertiesError || error;
        const dismissAnnouncement = (0, $5uXOq.useCallback)(()=>{
            const announcementDismissState = {
                shouldShow: false
            };
            update(()=>({
                    announcementDismissState: announcementDismissState
                }));
            if (accountId) {
                if (loadingRef.current) {
                    const err = new Error('User properties is loading');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                            teamName: '50cent'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setUserPropertiesError(err);
                    return Promise.reject(err);
                }
                loadingRef.current = true;
                return (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, (0, parcelRequire("hj0lE")).JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify(announcementDismissState)).catch((err)=>{
                    setUserPropertiesError(new Error('Error occured while setting user properties'));
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                            teamName: '50cent'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }).finally(()=>{
                    loadingRef.current = false;
                });
            }
        }, [
            accountId,
            update
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            refresh,
            error
        ]);
        return (0, $5uXOq.useMemo)(()=>{
            if (errorRef.current || loading || !data || !accountId) return {
                shouldShow: false,
                dismissAnnouncement: dismissAnnouncement
            };
            const { announcementDismissState: announcementDismissState } = data;
            if (!announcementDismissState) return {
                shouldShow: false,
                dismissAnnouncement: dismissAnnouncement
            };
            return {
                ...announcementDismissState,
                dismissAnnouncement: dismissAnnouncement
            };
        }, [
            loading,
            data,
            accountId,
            dismissAnnouncement
        ]);
    };
});
parcelRegister("hj0lE", function(module, exports) {
    $parcel$export(module.exports, "JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", ()=>$4bad9f9efc7d29c0$export$d2137827dc00e559);
    $parcel$export(module.exports, "DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE", ()=>$4bad9f9efc7d29c0$export$341176bfdf8c92);
    const $4bad9f9efc7d29c0$export$d2137827dc00e559 = 'jsm-repackaging-announcement-dismiss-state';
    const $4bad9f9efc7d29c0$export$341176bfdf8c92 = {
        shouldShow: true
    };
});
parcelRegister("fjlZb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("37oAo").then(()=>parcelRequire('lGYvJ'));
});
parcelRegister("l2Uy7", function(module, exports) {
    $parcel$export(module.exports, "isInJsmGlobalSettingsBoundary", ()=>$257d172b6cc842a0$export$c28a66ae6d31a34b);
    const $257d172b6cc842a0$var$jsmGlobalSettingsPages = [
        '/jira/settings/products/jira-service-management-configuration',
        '/jira/settings/products/jira-service-management-email-requests',
        '/jira/settings/products/servicedesk/customer-access',
        '/jira/settings/products/servicedesk/authentication',
        '/jira/settings/products/servicedesk/organizations',
        '/jira/settings/products/jira-service-management-incident-management-tools',
        '/jira/settings/products/jira-service-management-compliance',
        '/jira/settings/products/servicedesk/feature-usage'
    ];
    const $257d172b6cc842a0$var$eocGlobalSettingsPages = [
        '/jira/settings/products/ops/roles',
        '/jira/settings/products/ops/role-assignment',
        '/jira/settings/products/ops/role-based-notifications',
        '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
        '/jira/settings/products/ops/integrations',
        '/jira/settings/products/ops/syncs',
        '/jira/settings/products/ops/policies',
        '/jira/settings/products/ops/maintenance',
        '/jira/settings/products/ops/escalation-policies',
        '/jira/settings/products/ops/incoming-call',
        '/jira/settings/products/ops/jira-service-management-audit-logs',
        '/jira/settings/products/ops/reports'
    ];
    const $257d172b6cc842a0$var$isJsmGlobalSettingsPage = (route)=>$257d172b6cc842a0$var$jsmGlobalSettingsPages.includes(route);
    const $257d172b6cc842a0$var$isEocGlobalSettingsPage = (route)=>$257d172b6cc842a0$var$eocGlobalSettingsPages.includes(route);
    const $257d172b6cc842a0$export$c28a66ae6d31a34b = (route)=>$257d172b6cc842a0$var$isJsmGlobalSettingsPage(route) || $257d172b6cc842a0$var$isEocGlobalSettingsPage(route);
});
parcelRegister("cOwuh", function(module, exports) {
    $parcel$export(module.exports, "BannerJsmPackagingUpdateAsync", ()=>$5589b5a823eb55d2$export$76c6ab35aee49900);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $5589b5a823eb55d2$var$BannerTransition = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("boNJG")).then((module)=>module.BannerJsmPackagingUpdate), {
        moduleId: "./src/packages/platform/ui/banners/jsm-packaging-updates/src/ui/banner/index.tsx"
    });
    const $5589b5a823eb55d2$export$76c6ab35aee49900 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-banner-jsm-packaging-updates",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5589b5a823eb55d2$var$BannerTransition, null));
});
parcelRegister("boNJG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3lSYe").then(()=>parcelRequire('kuFA7'));
});
parcelRegister("3Uek9", function(module, exports) {
    $parcel$export(module.exports, "useProjectTheme", ()=>$241dc29db19bb69f$export$18084206b9430153);
    var $l71WK;
    var $65Ltd;
    var $8iyFV;
    var $cPiXk;
    var $3HwlS;
    var $6jY6G;
    var $5PD5h;
    const $241dc29db19bb69f$export$18084206b9430153 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const HorizontalNavComponent = (0, (0, parcelRequire("cPiXk")).useHorizontalNavComponent)();
        const isBusinessRouteGroup = route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS);
        const hasProjectViewNavigation = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? HorizontalNavComponent != null : HorizontalNavComponent === (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav) || HorizontalNavComponent === (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav) || HorizontalNavComponent === (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav) || HorizontalNavComponent === (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans);
        const hasTheming = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? HorizontalNavComponent === (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav) || HorizontalNavComponent === (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav) || route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE) : hasProjectViewNavigation;
        const isInset = hasTheming && !isBusinessRouteGroup;
        return {
            isInset: isInset,
            hasTheming: hasTheming,
            hasProjectViewNavigation: hasProjectViewNavigation
        };
    };
});
parcelRegister("gAaIa", function(module, exports) {
    $parcel$export(module.exports, "sharedLayout", ()=>$5a2bfe6dfc486be5$export$5f4dc7c98070d93e);
    var $5uXOq = parcelRequire("5uXOq");
    var $doxsH;
    var $2vSU6;
    var $8JIza;
    var $gmGW3;
    var $8NA5p;
    var $7kqCT;
    var $7jo2g;
    var $7XluA;
    var $4mO32;
    var $7N30e;
    var $6s1PB;
    var $7XYc4;
    var $cSD7y;
    var $4R6GH;
    var $3lMZZ;
    var $7Lkcv;
    var $9YvQF;
    var $km1Z8;
    var $aqDVH;
    var $lpwtK;
    var $jElqQ;
    var $kKa8l;
    var $bmetd;
    var $izgL1;
    var $lyCmi;
    var $aPfsS;
    var $kgLzl;
    var $dYRe6;
    var $koeKL;
    var $9yehD;
    var $dz0Q5;
    var $kXv2J;
    var $4p6rw;
    var $kxZPA;
    var $38EzX;
    var $lDu2T;
    var $jnXgM;
    const $5a2bfe6dfc486be5$var$isPendoIntegrationEnabled = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira-frontend-pendo-analytics_s6sj5');
    const $5a2bfe6dfc486be5$var$Global = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("2by6O")), {
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/global/index.tsx"
    });
    const $5a2bfe6dfc486be5$var$Navigation = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("aQHAS")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/navigation/index.tsx"
    });
    const $5a2bfe6dfc486be5$var$Trackers = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("i1RfD")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/trackers/index.tsx"
    });
    const $5a2bfe6dfc486be5$var$RemoteActions = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("iRWz9")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/remote-actions/index.tsx"
    });
    const $5a2bfe6dfc486be5$var$AfterPaintIssuePreEval = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("eiE7i")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/after-paint-issue-preeval/AfterPaintIssuePreEval.tsx"
    });
    const $5a2bfe6dfc486be5$var$AsyncBrowserStorageControlsInit = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("lGCVr")).then(({ BrowserStorageControlsInit: BrowserStorageControlsInit })=>BrowserStorageControlsInit), {
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/browser-storage-controls-init/index.tsx"
    });
    const $5a2bfe6dfc486be5$var$runtimeProps = {};
    const $5a2bfe6dfc486be5$var$entryPointParams = {};
    const $5a2bfe6dfc486be5$export$70b554b486395223 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("kXv2J")).upgradeOnboardingExperimentEntryPoint), $5a2bfe6dfc486be5$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "growth.upgradeOnboardingExperiment",
            packageName: "issue-view",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $5a2bfe6dfc486be5$var$runtimeProps
        });
    };
    const $5a2bfe6dfc486be5$export$3859d35c5447350b = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("kgLzl")).rovoVideoModalEntryPoint), $5a2bfe6dfc486be5$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "growth.rovoVideoPlayer",
            packageName: "rovo-video-modal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $5a2bfe6dfc486be5$var$runtimeProps
        });
    };
    const $5a2bfe6dfc486be5$export$3211958f96133af8 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("aqDVH")).jiraLossAversionModalEntryPoint), $5a2bfe6dfc486be5$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "growth.jiraLossAversion",
            packageName: "jira-loss-aversion-modal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $5a2bfe6dfc486be5$var$runtimeProps
        });
    };
    const $5a2bfe6dfc486be5$export$39abefd31dfea2bd = ()=>{
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const projectId = String(project?.id);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yehD")).AsyncTrialSprintBoardModalEntryPoint), {
            currentProjectId: projectId
        });
    };
    const $5a2bfe6dfc486be5$export$bb0d8fff645668ce = ()=>{
        const cloudID = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const projectType = (0, (0, parcelRequire("2vSU6")).toProjectType)(project?.type) || null;
        const productKey = (0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)(projectType);
        const deferEditionModalEntryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudID,
                productKey: productKey
            }), [
            cloudID,
            productKey
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("7kqCT")).jiraDeferEditionModalEntryPoint), deferEditionModalEntryPointParams);
        const onComplete = (0, $5uXOq.useCallback)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8NA5p")).AsyncDeferEditionEPCheckWrapper), {
            onComplete: onComplete
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "growth.jiraDeferEditionModal",
            packageName: "jira-defer-edition-modal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $5a2bfe6dfc486be5$var$runtimeProps
        }));
    };
    const $5a2bfe6dfc486be5$var$DeferEditionModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('cross-flow-defer-edition-communication-gate', $5a2bfe6dfc486be5$export$bb0d8fff645668ce, ()=>null);
    const $5a2bfe6dfc486be5$var$DeferRovoVideoModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('rovo_video_player_gate', $5a2bfe6dfc486be5$export$3859d35c5447350b, ()=>null);
    const $5a2bfe6dfc486be5$var$DeferJiraLossAversionModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_loss_aversion_standard_shared_layout_gate', $5a2bfe6dfc486be5$export$3211958f96133af8, ()=>null);
    const $5a2bfe6dfc486be5$var$DeferTrialSprintBoardModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw-trial-sprint-board-modal-gate', $5a2bfe6dfc486be5$export$39abefd31dfea2bd, ()=>null);
    const $5a2bfe6dfc486be5$var$AsyncRecommendPremiumToStandardModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('recommend_standard_in_jira_eot_shared_layout_', (0, (0, parcelRequire("lyCmi")).AsyncRecommendPremiumToStandardModalWrapper), ()=>null);
    $5a2bfe6dfc486be5$var$DeferEditionModal.displayName = 'DeferEditionModal';
    $5a2bfe6dfc486be5$var$DeferRovoVideoModal.displayName = 'DeferRovoVideoModal';
    $5a2bfe6dfc486be5$var$DeferJiraLossAversionModal.displayName = 'DeferJiraLossAversionModal';
    $5a2bfe6dfc486be5$var$DeferTrialSprintBoardModal.displayName = 'DeferTrialSprintBoardModal';
    $5a2bfe6dfc486be5$var$AsyncRecommendPremiumToStandardModal.displayName = 'AsyncRecommendPremiumToStandardModal';
    const $5a2bfe6dfc486be5$var$sharedGlobalComponents = [
        ...false ? [] : [
            (0, (0, parcelRequire("kKa8l")).MatchedRouteListener),
            (0, (0, parcelRequire("bmetd")).PreviousRouterStateListener),
            (0, (0, parcelRequire("lDu2T")).LoadingPhaseManager),
            (0, (0, parcelRequire("3lMZZ")).LoadingBarUIController),
            (0, (0, parcelRequire("doxsH")).default),
            (0, (0, parcelRequire("38EzX")).BreadcrumbAdapter),
            (0, (0, parcelRequire("izgL1")).default),
            (0, (0, parcelRequire("jElqQ")).PageDwellAnalyticsListener),
            (0, (0, parcelRequire("km1Z8")).ImperativeAPI),
            (0, (0, parcelRequire("jnXgM")).TrackClicksBeforeTTI),
            (0, (0, parcelRequire("dYRe6")).default),
            (0, (0, parcelRequire("dz0Q5")).AsyncUpflowIframeComponent),
            (0, (0, parcelRequire("4p6rw")).JiraHeritageLoader),
            $5a2bfe6dfc486be5$var$AsyncBrowserStorageControlsInit,
            ...$5a2bfe6dfc486be5$var$isPendoIntegrationEnabled() ? [
                (0, (0, parcelRequire("8JIza")).AsyncPendoAnalyticsWrapper)
            ] : [],
            (0, (0, parcelRequire("7N30e")).default),
            $5a2bfe6dfc486be5$var$RemoteActions,
            (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_upgrade_onboarding'), $5a2bfe6dfc486be5$export$70b554b486395223, ()=>null),
            $5a2bfe6dfc486be5$var$DeferEditionModal,
            $5a2bfe6dfc486be5$var$DeferRovoVideoModal,
            $5a2bfe6dfc486be5$var$DeferJiraLossAversionModal,
            $5a2bfe6dfc486be5$var$DeferTrialSprintBoardModal,
            (0, (0, parcelRequire("7jo2g")).AsyncEndOfTrialMessageSharedWrapper),
            $5a2bfe6dfc486be5$var$AsyncRecommendPremiumToStandardModal
        ],
        $5a2bfe6dfc486be5$var$Global,
        $5a2bfe6dfc486be5$var$Navigation,
        $5a2bfe6dfc486be5$var$Trackers,
        $5a2bfe6dfc486be5$var$AfterPaintIssuePreEval
    ];
    const $5a2bfe6dfc486be5$var$SafeEmbeddedConfluencePanelWithExperiments = ()=>{
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
        return expConfig.get('cohort', 'not-enrolled') === 'experiment' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9YvQF")).SafeEmbeddedConfluencePanel), null) : null;
    };
    const $5a2bfe6dfc486be5$export$5f4dc7c98070d93e = (0, (0, parcelRequire("aPfsS")).createLayout)({
        rightSidebars: [
            (0, (0, parcelRequire("7Lkcv")).SafeHelpPanel),
            (0, (0, parcelRequire("gmGW3")).SafeConversationAssistantPanel),
            $5a2bfe6dfc486be5$var$SafeEmbeddedConfluencePanelWithExperiments
        ],
        globalComponents: $5a2bfe6dfc486be5$var$sharedGlobalComponents
    });
});
parcelRegister("doxsH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$899e926f09852ef7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $90yGq;
    var $1NZBJ;
    const $899e926f09852ef7$var$CacheRegistry = ()=>{
        const accountIdLoggedInUser = (0, (0, parcelRequire("90yGq")).useAccountId)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("1NZBJ")).default).set(accountIdLoggedInUser ?? 'anonymous');
        }, [
            accountIdLoggedInUser
        ]);
        return null;
    };
    var $899e926f09852ef7$export$2e2bcd8739ae039 = $899e926f09852ef7$var$CacheRegistry;
});
parcelRegister("1NZBJ", function(module, exports) {
    $parcel$export(module.exports, "CACHE_PREFIX", ()=>$e0fd77b45718946f$export$69ca515e4489d790);
    $parcel$export(module.exports, "scopeGuard", ()=>$e0fd77b45718946f$export$653cd03438bb0386);
    $parcel$export(module.exports, "default", ()=>$e0fd77b45718946f$export$2e2bcd8739ae039);
    var $bSSG7;
    let $e0fd77b45718946f$var$resolveCachePromise;
    const $e0fd77b45718946f$var$cachePromise = new Promise((resolve)=>{
        $e0fd77b45718946f$var$resolveCachePromise = resolve;
    });
    const $e0fd77b45718946f$export$27be962d708928a = '__scope_key__';
    const $e0fd77b45718946f$export$69ca515e4489d790 = 'cache_prefix';
    const $e0fd77b45718946f$var$TIMEOUT = 10000;
    const $e0fd77b45718946f$var$promiseWithMaxExecutionTime = (ms, promise)=>{
        let id;
        const timeout = new Promise((resolve, reject)=>{
            id = setTimeout(()=>{
                const storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
                storage.clearAll();
                reject(new Error(`Cache scope was not set within ${$e0fd77b45718946f$var$TIMEOUT}ms`));
            }, ms);
        });
        return Promise.race([
            promise,
            timeout
        ]).then((result)=>{
            clearTimeout(id);
            return result;
        });
    };
    const $e0fd77b45718946f$export$653cd03438bb0386 = ()=>$e0fd77b45718946f$var$promiseWithMaxExecutionTime($e0fd77b45718946f$var$TIMEOUT, $e0fd77b45718946f$var$cachePromise);
    const $e0fd77b45718946f$var$config = {
        devTools: false,
        scopes: {
            prev: null,
            current: null
        },
        set (scopeKey) {
            const storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
            const scopeKeyInStorage = storage.get($e0fd77b45718946f$export$27be962d708928a);
            if (this.scopes.prev === null && this.scopes.current === null) {
                if (scopeKeyInStorage) {
                    this.scopes.prev = scopeKeyInStorage;
                    this.scopes.current = scopeKeyInStorage;
                }
            }
            if (this.scopes.current !== scopeKey) {
                if (this.scopes.current !== null) storage.clearAll();
                this.scopes.prev = this.scopes.current;
                this.scopes.current = scopeKey;
                storage.set($e0fd77b45718946f$export$27be962d708928a, scopeKey);
            }
            $e0fd77b45718946f$var$resolveCachePromise();
        },
        get () {
            return this.scopes.current;
        }
    };
    var $e0fd77b45718946f$export$2e2bcd8739ae039 = $e0fd77b45718946f$var$config;
});
parcelRegister("8JIza", function(module, exports) {
    $parcel$export(module.exports, "AsyncPendoAnalyticsWrapper", ()=>$5adeefc5ea77d534$export$1c388e7c464f3699);
    var $5uXOq = parcelRequire("5uXOq");
    var $b71gk;
    var $7iJwP;
    var $kxZPA;
    const $5adeefc5ea77d534$var$AsyncPendoAnalytics = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("hd4ok")).then(({ PendoAnalytics: PendoAnalytics })=>PendoAnalytics), {
        moduleId: "./src/packages/platform/services/pendo-analytics/src/index.tsx"
    });
    const $5adeefc5ea77d534$export$1c388e7c464f3699 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b71gk")).default), {
            id: "jiraCommonPendoAnalyticsReportErrors",
            packageName: "jiraCommonPendoAnalytics"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: "martech",
            id: "jiraCommonPendoAnalyticsReportErrors",
            packageName: "jiraCommonPendoAnalytics"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5adeefc5ea77d534$var$AsyncPendoAnalytics, null)));
});
parcelRegister("hd4ok", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4sJqf").then(()=>parcelRequire('8bI7u'));
});
parcelRegister("gmGW3", function(module, exports) {
    $parcel$export(module.exports, "SafeConversationAssistantPanel", ()=>$836bcaaba692e6c5$export$453401d0b697d2db);
    var $5uXOq = parcelRequire("5uXOq");
    var $e8KHW = parcelRequire("e8KHW");
    var $7CMCs;
    var $hsmeR;
    var $2NMNM;
    var $2vgok;
    const $836bcaaba692e6c5$var$PanelInLayout = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
        const prevPanelIdRef = (0, $5uXOq.useRef)();
        const delayRef = (0, $5uXOq.useRef)(null);
        const { closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const panelId = rightSidebarCurrentState?.panelId;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, $1cb976721581e2e6$export$dffb4ed44e20ea9a)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                    createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'aiMatePanel',
                        source: 'AIMate',
                        tags: [
                            'atlaskit',
                            'aiMate'
                        ]
                    }).fire((0, $e8KHW.FabricChannel).aiMate);
                }, 310);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            createAnalyticsEvent,
            panelId,
            rightSidebarCurrentState
        ]);
        if (localPanelId !== (0, $1cb976721581e2e6$export$dffb4ed44e20ea9a)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2vgok")).JiraConversationAssistant), {
            onClosePanel: closeCurrentRightSidebar
        });
    };
    const $836bcaaba692e6c5$export$453401d0b697d2db = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-conversation-assistant-panel",
            packageName: "jiraConversationAssistant"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($836bcaaba692e6c5$var$PanelInLayout, null));
});
const $1cb976721581e2e6$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $1cb976721581e2e6$export$64aee74ba59709e5 = 439;
const $1cb976721581e2e6$export$1c07393c5bb1bc27 = 439;
const $1cb976721581e2e6$export$aa3478deee7adbeb = 350;
const $1cb976721581e2e6$export$21e515a86cd1733b = 'Chat';
parcelRegister("2vgok", function(module, exports) {
    $parcel$export(module.exports, "JiraConversationAssistant", ()=>$2321abcc17b38bef$export$da8473714271a41d);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    var $lIWNb;
    var $8Y08s;
    var $co1wz;
    var $4R6GH;
    var $j8DrX;
    var $hsmeR;
    var $8zOmE;
    var $2NMNM;
    var $14XJw;
    var $fY39E;
    var $koeKL;
    const $2321abcc17b38bef$var$SYNTHETIC_HEADER = 'x-issynthetic-traffic';
    const $2321abcc17b38bef$export$da8473714271a41d = ({ onClosePanel: onClosePanel })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const activationId = (0, (0, parcelRequire("fY39E")).useActivationId)();
        const { openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const isSyntheticTenant = (0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true' || (0, (0, parcelRequire("4R6GH")).fg)('is_synthetic_tenant');
        let baseUrl = '/gateway/api/assist';
        if ((0, (0, parcelRequire("co1wz")).ff)('jira.frontend.ai.mate.route.stargate.to.convo.ai')) baseUrl = '/gateway/api/assist-kotlin';
        else if ((0, (0, parcelRequire("VSDnB")).getBooleanFF)('platform.jira.frontend.ai.mate_route_stargate_to_stg_west')) baseUrl = '/gateway/api/assist-tester';
        const config = (0, $5uXOq.useMemo)(()=>({
                displaySubmitFlag: true,
                siteId: cloudId,
                activationId: activationId,
                product: 'jira',
                orgId: orgId,
                experienceId: 'ai-mate',
                assistanceServiceConfig: {
                    headers: isSyntheticTenant ? {
                        [$2321abcc17b38bef$var$SYNTHETIC_HEADER]: String(isSyntheticTenant)
                    } : {},
                    baseUrl: baseUrl
                }
            }), [
            cloudId,
            activationId,
            orgId,
            isSyntheticTenant,
            baseUrl
        ]);
        const handleResizeComplete = (0, $5uXOq.useCallback)((width)=>{
            openRightSidebar((0, $1cb976721581e2e6$export$dffb4ed44e20ea9a), width);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'resized',
                actionSubject: 'aiMatePanel'
            }));
        }, [
            openRightSidebar,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Y08s")).ResizeWrapper), {
            onResizeComplete: handleResizeComplete
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $2321abcc17b38bef$var$conversationAssistantWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lIWNb")).default), {
            testId: "conversation-assistant.ui.conversation-assistant",
            onCloseChat: onClosePanel,
            config: config
        })));
    };
    const $2321abcc17b38bef$var$conversationAssistantWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
});
parcelRegister("lIWNb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2511a7ad08348805$export$2e2bcd8739ae039);
    var $4qBtX = parcelRequire("4qBtX");
    var $2511a7ad08348805$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("tIpup")),
        loading: ()=>null
    });
});
parcelRegister("4qBtX", function(module, exports) {
    "use strict";
    var $3396aa4dae68f4b9$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    function $3396aa4dae68f4b9$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $3396aa4dae68f4b9$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $3396aa4dae68f4b9$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $3396aa4dae68f4b9$var$ALL_INITIALIZERS = [];
    var $3396aa4dae68f4b9$var$READY_INITIALIZERS = [];
    function $3396aa4dae68f4b9$var$isWebpackReady(getModuleIds) {
        if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $3396aa4dae68f4b9$var$_typeof(__webpack_modules__)) !== "object") return false;
        return getModuleIds().every(function(moduleId) {
            return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
        });
    }
    function $3396aa4dae68f4b9$var$load(loader) {
        var promise = loader();
        var state = {
            loading: true,
            loaded: null,
            error: null
        };
        state.promise = promise.then(function(loaded) {
            state.loading = false;
            state.loaded = loaded;
            return loaded;
        }).catch(function(err) {
            state.loading = false;
            state.error = err;
            throw err;
        });
        return state;
    }
    function $3396aa4dae68f4b9$var$loadMap(obj) {
        var state = {
            loading: false,
            loaded: {},
            error: null
        };
        var promises = [];
        try {
            Object.keys(obj).forEach(function(key) {
                var result = $3396aa4dae68f4b9$var$load(obj[key]);
                if (!result.loading) {
                    state.loaded[key] = result.loaded;
                    state.error = result.error;
                } else state.loading = true;
                promises.push(result.promise);
                result.promise.then(function(res) {
                    state.loaded[key] = res;
                }).catch(function(err) {
                    state.error = err;
                });
            });
        } catch (err) {
            state.error = err;
        }
        state.promise = Promise.all(promises).then(function(res) {
            state.loading = false;
            return res;
        }).catch(function(err) {
            state.loading = false;
            throw err;
        });
        return state;
    }
    function $3396aa4dae68f4b9$var$resolve(obj) {
        return obj && obj.__esModule ? obj.default : obj;
    }
    function $3396aa4dae68f4b9$var$render(loaded, props) {
        return $5uXOq.createElement($3396aa4dae68f4b9$var$resolve(loaded), props);
    }
    function $3396aa4dae68f4b9$var$createLoadableComponent(loadFn, options) {
        var _class, _temp;
        if (!options.loading) throw new Error("react-loadable requires a `loading` component");
        var opts = Object.assign({
            loader: null,
            loading: null,
            delay: 200,
            timeout: null,
            render: $3396aa4dae68f4b9$var$render,
            webpack: null,
            modules: null
        }, options);
        var res = null;
        function init() {
            if (!res) res = loadFn(opts.loader);
            return res.promise;
        }
        $3396aa4dae68f4b9$var$ALL_INITIALIZERS.push(init);
        if (typeof opts.webpack === "function") $3396aa4dae68f4b9$var$READY_INITIALIZERS.push(function() {
            if ($3396aa4dae68f4b9$var$isWebpackReady(opts.webpack)) return init();
        });
        return _temp = _class = function(_React$Component) {
            $3396aa4dae68f4b9$var$_inherits(LoadableComponent, _React$Component);
            function LoadableComponent(props) {
                $3396aa4dae68f4b9$var$_classCallCheck(this, LoadableComponent);
                var _this = $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
                _this.retry = function() {
                    _this.setState({
                        error: null,
                        loading: true,
                        timedOut: false
                    });
                    res = loadFn(opts.loader);
                    _this._loadModule();
                };
                init();
                _this.state = {
                    error: res.error,
                    pastDelay: false,
                    timedOut: false,
                    loading: res.loading,
                    loaded: res.loaded
                };
                return _this;
            }
            LoadableComponent.preload = function preload() {
                return init();
            };
            LoadableComponent.prototype.componentWillMount = function componentWillMount() {
                this._mounted = true;
                this._loadModule();
            };
            LoadableComponent.prototype._loadModule = function _loadModule() {
                var _this2 = this;
                if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                    _this2.context.loadable.report(moduleName);
                });
                if (!res.loading) return;
                if (typeof opts.delay === "number") {
                    if (opts.delay === 0) this.setState({
                        pastDelay: true
                    });
                    else this._delay = setTimeout(function() {
                        _this2.setState({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
                if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                    _this2.setState({
                        timedOut: true
                    });
                }, opts.timeout);
                var update = function update() {
                    if (!_this2._mounted) return;
                    _this2.setState({
                        error: res.error,
                        loaded: res.loaded,
                        loading: res.loading
                    });
                    _this2._clearTimeouts();
                };
                res.promise.then(function() {
                    update();
                }).catch(function(err) {
                    update();
                });
            };
            LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
                this._mounted = false;
                this._clearTimeouts();
            };
            LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            };
            LoadableComponent.prototype.render = function render() {
                if (this.state.loading || this.state.error) return $5uXOq.createElement(opts.loading, {
                    isLoading: this.state.loading,
                    pastDelay: this.state.pastDelay,
                    timedOut: this.state.timedOut,
                    error: this.state.error,
                    retry: this.retry
                });
                else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
                else return null;
            };
            return LoadableComponent;
        }($5uXOq.Component), _class.contextTypes = {
            loadable: (0, parcelRequire("8rCP3")).shape({
                report: (0, parcelRequire("8rCP3")).func.isRequired
            })
        }, _temp;
    }
    function $3396aa4dae68f4b9$var$Loadable(opts) {
        return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$load, opts);
    }
    function $3396aa4dae68f4b9$var$LoadableMap(opts) {
        if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
        return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$loadMap, opts);
    }
    $3396aa4dae68f4b9$var$Loadable.Map = $3396aa4dae68f4b9$var$LoadableMap;
    var $3396aa4dae68f4b9$var$Capture = function(_React$Component2) {
        $3396aa4dae68f4b9$var$_inherits(Capture, _React$Component2);
        function Capture() {
            $3396aa4dae68f4b9$var$_classCallCheck(this, Capture);
            return $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
        }
        Capture.prototype.getChildContext = function getChildContext() {
            return {
                loadable: {
                    report: this.props.report
                }
            };
        };
        Capture.prototype.render = function render() {
            return $5uXOq.Children.only(this.props.children);
        };
        return Capture;
    }($5uXOq.Component);
    $3396aa4dae68f4b9$var$Capture.propTypes = {
        report: (0, parcelRequire("8rCP3")).func.isRequired
    };
    $3396aa4dae68f4b9$var$Capture.childContextTypes = {
        loadable: (0, parcelRequire("8rCP3")).shape({
            report: (0, parcelRequire("8rCP3")).func.isRequired
        }).isRequired
    };
    $3396aa4dae68f4b9$var$Loadable.Capture = $3396aa4dae68f4b9$var$Capture;
    function $3396aa4dae68f4b9$var$flushInitializers(initializers) {
        var promises = [];
        while(initializers.length){
            var init = initializers.pop();
            promises.push(init());
        }
        return Promise.all(promises).then(function() {
            if (initializers.length) return $3396aa4dae68f4b9$var$flushInitializers(initializers);
        });
    }
    $3396aa4dae68f4b9$var$Loadable.preloadAll = function() {
        return new Promise(function(resolve, reject) {
            $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$ALL_INITIALIZERS).then(resolve, reject);
        });
    };
    $3396aa4dae68f4b9$var$Loadable.preloadReady = function() {
        return new Promise(function(resolve, reject) {
            $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$READY_INITIALIZERS).then(resolve, resolve);
        });
    };
    module.exports = $3396aa4dae68f4b9$var$Loadable;
});
parcelRegister("tIpup", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fls1N")
    ]).then(()=>parcelRequire('k2v4d'));
});
parcelRegister("8Y08s", function(module, exports) {
    $parcel$export(module.exports, "ResizeWrapper", ()=>$6bea494971fb78d2$export$c7990a6594835e51);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $22jFS;
    var $dC5iT;
    var $8CUq3;
    const $6bea494971fb78d2$var$rootStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        right: 'space.0',
        display: 'flex',
        position: 'fixed',
        height: `calc(100vh - ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT)} - ${(0, (0, parcelRequire("22jFS")).BANNER_HEIGHT)})`
    });
    const $6bea494971fb78d2$var$handleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'ew-resize',
        userSelect: 'none',
        position: 'absolute',
        top: 'space.200',
        bottom: 'space.0',
        left: 'space.0',
        width: '24px',
        borderTopLeftRadius: 'border.radius.200',
        transition: 'border 0.2s ease-in-out',
        borderLeft: '2px solid transparent',
        ':hover': {
            borderLeft: `2px solid ${"var(--ds-background-information-bold-hovered, #0055CC)"}`
        }
    });
    const $6bea494971fb78d2$var$handleSpacerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '24px',
        position: 'absolute',
        display: 'block',
        left: '-24px',
        top: 'space.0',
        bottom: 'space.0'
    });
    const $6bea494971fb78d2$export$c7990a6594835e51 = ({ children: children, onResizeComplete: onResizeComplete, initialWidth: initialWidth = (0, $1cb976721581e2e6$export$64aee74ba59709e5), minWidth: minWidth = (0, $1cb976721581e2e6$export$64aee74ba59709e5), maxWidth: maxWidth = '50vw' })=>{
        const [width, setWidth] = (0, $5uXOq.useState)(initialWidth);
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const isDraggingRef = (0, $5uXOq.useRef)(false);
        const initialMousePositionRef = (0, $5uXOq.useRef)(0);
        const prevDistanceMovedRef = (0, $5uXOq.useRef)(0);
        const rafRef = (0, $5uXOq.useRef)(null);
        const getWrapperWidth = ()=>{
            return wrapperRef.current?.getBoundingClientRect()?.width || 0;
        };
        const handleMouseMove = (0, $5uXOq.useCallback)((event)=>{
            if (!isDraggingRef.current) return;
            const distanceMoved = event.clientX - initialMousePositionRef.current;
            let updatedWidth;
            const currentWidth = getWrapperWidth();
            if (distanceMoved === prevDistanceMovedRef.current || distanceMoved === 0) return;
            prevDistanceMovedRef.current = distanceMoved;
            if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
            rafRef.current = requestAnimationFrame(()=>{
                if (distanceMoved < 0) {
                    updatedWidth = currentWidth + Math.abs(distanceMoved);
                    if (typeof maxWidth === 'number' && !isNaN(maxWidth)) updatedWidth = Math.min(updatedWidth, maxWidth);
                } else {
                    updatedWidth = currentWidth - distanceMoved;
                    if (typeof minWidth === 'number' && !isNaN(minWidth)) updatedWidth = Math.max(updatedWidth, minWidth);
                }
                setWidth(updatedWidth);
                initialMousePositionRef.current = event.clientX;
            });
        }, [
            maxWidth,
            minWidth
        ]);
        const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
            isDraggingRef.current = true;
            initialMousePositionRef.current = event.clientX;
        }, []);
        const handleMouseUp = (0, $5uXOq.useCallback)(()=>{
            if (isDraggingRef.current && onResizeComplete) onResizeComplete(wrapperRef.current?.getBoundingClientRect().width || width);
            isDraggingRef.current = false;
        }, [
            onResizeComplete,
            width
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const mouseMoveHandler = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'mousemove',
                listener: handleMouseMove
            });
            const mouseUpHandler = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'mouseup',
                listener: handleMouseUp
            });
            return ()=>{
                mouseMoveHandler();
                mouseUpHandler();
                if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
            };
        }, [
            handleMouseMove,
            handleMouseUp
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6bea494971fb78d2$var$rootStyles,
            ref: wrapperRef,
            role: "presentation",
            testId: "panel-resize-wrapper",
            style: {
                width: width,
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: "panel-resize-handle",
            onMouseDown: handleMouseDown,
            xcss: $6bea494971fb78d2$var$handleStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6bea494971fb78d2$var$handleSpacerStyles
        })), children);
    };
});
parcelRegister("fY39E", function(module, exports) {
    $parcel$export(module.exports, "useActivationId", ()=>$d72c67677898c114$export$43686faa787c943);
    var $9OXo1;
    const $d72c67677898c114$export$43686faa787c943 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.activationId;
    };
});
parcelRegister("8NA5p", function(module, exports) {
    $parcel$export(module.exports, "AsyncDeferEditionEPCheckWrapper", ()=>$2684c9c6a6fb887b$export$4fa5b26bccc7e3df);
    var $5uXOq = parcelRequire("5uXOq");
    var $b71gk;
    var $7iJwP;
    var $kxZPA;
    const $2684c9c6a6fb887b$var$AsyncDeferEditionEPCheck = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("9wiVM")).then(({ EPCheck: EPCheck })=>EPCheck), {
        ssr: false,
        moduleId: "./src/packages/growth/defer-edition-modal/src/async.tsx"
    });
    const $2684c9c6a6fb887b$export$4fa5b26bccc7e3df = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b71gk")).default), {
            id: "defer-edition-ep-check-async",
            packageName: (0, $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: (0, $ac4f2a72f86d65c9$export$d57b6b390e78d90f),
            id: "defer-edition-ep-check-async",
            packageName: (0, $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2684c9c6a6fb887b$var$AsyncDeferEditionEPCheck, props)));
});
const $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $ac4f2a72f86d65c9$export$d57b6b390e78d90f = 'transmuters-growth';
const $ac4f2a72f86d65c9$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $ac4f2a72f86d65c9$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';
parcelRegister("9wiVM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bVgxH").then(()=>parcelRequire('1DysC'));
});
parcelRegister("7kqCT", function(module, exports) {
    $parcel$export(module.exports, "jiraDeferEditionModalEntryPoint", ()=>$110a94ef04661997$export$51f384a783f47807);
    var $fiH7W;
    var $eufEc;
    var $fEDBv;
    const $110a94ef04661997$var$Fallback = ()=>null;
    const $110a94ef04661997$export$51f384a783f47807 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(async ()=>{
            if (!false) return (parcelRequire("bg8yu")).then(({ DeferEditionModalComponent: DeferEditionModalComponent })=>DeferEditionModalComponent);
            return $110a94ef04661997$var$Fallback;
        }, {
            moduleId: "fe342c6b"
        }),
        getPreloadProps: ({ cloudId: cloudId, productKey: productKey })=>({
                queries: {
                    deferEditionModal: {
                        parameters: (0, (0, parcelRequire("fiH7W")).default),
                        variables: {
                            cloudId: cloudId,
                            productKey: productKey
                        }
                    }
                }
            })
    });
});
parcelRegister("fiH7W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d18804309a0f9ffd$export$2e2bcd8739ae039);
    const $d18804309a0f9ffd$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "5b10c1496eb58e67afa6cdffdf558adb655a89e468a81592e6c039cccddb07ac",
            "metadata": {},
            "name": "src_DeferEditionModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $d18804309a0f9ffd$export$2e2bcd8739ae039 = $d18804309a0f9ffd$var$node;
});
parcelRegister("bg8yu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hmyGT")
    ]).then(()=>parcelRequire('8IIKL'));
});
parcelRegister("7jo2g", function(module, exports) {
    $parcel$export(module.exports, "AsyncEndOfTrialMessageSharedWrapper", ()=>$b603c0291b5c0134$export$ae154a7bf883999f);
    var $5uXOq = parcelRequire("5uXOq");
    var $b71gk;
    var $7iJwP;
    var $kxZPA;
    var $bZB1h;
    const $b603c0291b5c0134$var$AsyncEndOfTrialMessageSharedGlobalComponent = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("121sR")).then(({ EndOfTrialMessageSharedGlobalComponent: EndOfTrialMessageSharedGlobalComponent })=>EndOfTrialMessageSharedGlobalComponent), {
        moduleId: "./src/packages/growth/end-of-trial/end-of-trial-message-shared-global-component/src/index.tsx"
    });
    const $b603c0291b5c0134$export$ae154a7bf883999f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b71gk")).default), {
            id: "end-of-trial-message-shared-async",
            packageName: (0, (0, parcelRequire("bZB1h")).PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: (0, (0, parcelRequire("bZB1h")).TEAM_NAME),
            id: "end-of-trial-message-shared-async",
            packageName: (0, (0, parcelRequire("bZB1h")).PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b603c0291b5c0134$var$AsyncEndOfTrialMessageSharedGlobalComponent, null)));
});
parcelRegister("bZB1h", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$25fa48d758254005$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$25fa48d758254005$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "STARGATE_URL", ()=>$25fa48d758254005$export$c7e6a6b283196232);
    $parcel$export(module.exports, "END_OF_TRIAL_MESSAGE_AUDIENCES", ()=>$25fa48d758254005$export$1986890201f1a80);
    var $2vSU6;
    const $25fa48d758254005$export$b8b9d90f9e5bd72b = '@atlassian/jira-end-of-trial-message-shared-global-component';
    const $25fa48d758254005$export$d57b6b390e78d90f = 'transmuters-growth';
    const $25fa48d758254005$export$c7e6a6b283196232 = '/gateway/api';
    const $25fa48d758254005$export$1986890201f1a80 = {
        [(0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)]: [
            'jpd_standard_end_of_trial_message_day_14',
            'jpd_standard_end_of_trial_message_day_13',
            'jpd_standard_end_of_trial_message_day_12',
            'jpd_standard_end_of_trial_message_day_11',
            'jpd_standard_end_of_trial_message_day_10',
            'jpd_standard_end_of_trial_message_day_9',
            'jpd_standard_end_of_trial_message_day_8',
            'jpd_standard_end_of_trial_message_day_7',
            'jpd_standard_end_of_trial_message_day_6',
            'jpd_standard_end_of_trial_message_day_5',
            'jpd_standard_end_of_trial_message_day_4',
            'jpd_standard_end_of_trial_message_day_3',
            'jpd_standard_end_of_trial_message_day_2',
            'jpd_standard_end_of_trial_message_day_1'
        ],
        [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: [
            'jsm_standard_end_of_trial_message_day_14',
            'jsm_standard_end_of_trial_message_day_13',
            'jsm_standard_end_of_trial_message_day_12',
            'jsm_standard_end_of_trial_message_day_11',
            'jsm_standard_end_of_trial_message_day_10',
            'jsm_standard_end_of_trial_message_day_9',
            'jsm_standard_end_of_trial_message_day_8',
            'jsm_standard_end_of_trial_message_day_7',
            'jsm_standard_end_of_trial_message_day_6',
            'jsm_standard_end_of_trial_message_day_5',
            'jsm_standard_end_of_trial_message_day_4',
            'jsm_standard_end_of_trial_message_day_3',
            'jsm_standard_end_of_trial_message_day_2',
            'jsm_standard_end_of_trial_message_day_1'
        ]
    };
});
parcelRegister("121sR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eXdJ6").then(()=>parcelRequire('bOc3m'));
});
parcelRegister("3lMZZ", function(module, exports) {
    $parcel$export(module.exports, "LoadingBarUIController", ()=>$ade6fcbf7908cda7$export$39bdf67fc71ce8c8);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $d46Cs = parcelRequire("d46Cs");
    var $lsa9q;
    var $bVDE5;
    var $doZTA;
    var $04unK;
    var $cYUbO;
    const $ade6fcbf7908cda7$export$54128ad8de32b897 = ({ startLoading: startLoading, resetLoading: resetLoading, finishLoading: finishLoading })=>{
        const [loadedState] = (0, (0, parcelRequire("lsa9q")).default)();
        (0, $5uXOq.useEffect)(()=>{
            startLoading();
            return ()=>{
                resetLoading();
            };
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (loadedState.hasLoaded) finishLoading();
        }, [
            loadedState.hasLoaded
        ]);
        return null;
    };
    const $ade6fcbf7908cda7$var$LoadingBarUI = ({ shouldRender: shouldRender, routeIdentifier: routeIdentifier })=>{
        const [actions, setActions] = (0, $5uXOq.useState)({});
        const sheetRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            const loadingBarActions = (0, $d46Cs.createLoadingBarActionController)(sheetRef.current);
            setActions(loadingBarActions || {});
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            ref: sheetRef,
            dangerouslySetInnerHTML: {
                __html: `
                    ${(0, (0, parcelRequire("04unK")).LOADER_STYLES_CSS_SELECTOR)} {
                        ${(0, (0, parcelRequire("cYUbO")).generateLoadingBarStyles)(0, (0, (0, parcelRequire("04unK")).getLoadingBarColor)())}
                    }
                `
            }
        }), shouldRender && actions.START && (0, ($parcel$interopDefault($5uXOq))).createElement($ade6fcbf7908cda7$export$54128ad8de32b897, {
            key: routeIdentifier,
            startLoading: actions.START,
            resetLoading: actions.RESET,
            finishLoading: actions.FINISH
        }));
    };
    const $ade6fcbf7908cda7$export$e068deb20d61b035 = ()=>{
        let currentTransitionsCount = 0;
        let currentRouteIdentifier = '';
        let currentRouteMatch = '';
        let hasTransitioned = false;
        let key = 0;
        return (transitionsCount, routeIdentifier, routeMatch)=>{
            if (transitionsCount !== currentTransitionsCount) {
                currentTransitionsCount = transitionsCount;
                hasTransitioned = true;
            }
            if (routeIdentifier !== null && routeIdentifier !== currentRouteIdentifier || routeIdentifier === currentRouteIdentifier && routeMatch !== currentRouteMatch) {
                currentRouteIdentifier = routeIdentifier;
                currentRouteMatch = routeMatch;
                if (hasTransitioned) {
                    hasTransitioned = false;
                    key = currentTransitionsCount;
                }
            }
            return key;
        };
    };
    const $ade6fcbf7908cda7$var$getUniqueTransitionKey = $ade6fcbf7908cda7$export$e068deb20d61b035();
    const $ade6fcbf7908cda7$export$39bdf67fc71ce8c8 = ()=>{
        const [routerState] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const [{ transitionsCount: transitionsCount }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const currentRoute = routerState.route && routerState.route.name;
        const loaderFailedInSSR = !window.JIRA_LOADING_BAR;
        const shouldRender = (0, (0, parcelRequire("04unK")).getAllowedRoutes)().includes(currentRoute);
        const routeIdentifier = (0, $5uXOq.useMemo)(()=>$ade6fcbf7908cda7$var$getUniqueTransitionKey(transitionsCount, currentRoute, JSON.stringify(routerState.match)), [
            transitionsCount,
            currentRoute,
            routerState.match
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (shouldRender && loaderFailedInSSR) (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('global-loading-bar', 'Loading bar failed to initialise in SSR. This may be because SSR failed or a bug in the loading bar code.');
        }, [
            loaderFailedInSSR
        ]);
        if (loaderFailedInSSR) return (0, ($parcel$interopDefault($5uXOq))).createElement($ade6fcbf7908cda7$var$LoadingBarUI, {
            shouldRender: shouldRender,
            routeIdentifier: routeIdentifier
        });
        if (shouldRender && window.JIRA_LOADING_BAR) return (0, ($parcel$interopDefault($5uXOq))).createElement($ade6fcbf7908cda7$export$54128ad8de32b897, {
            key: routeIdentifier,
            startLoading: window.JIRA_LOADING_BAR.START,
            resetLoading: window.JIRA_LOADING_BAR.RESET,
            finishLoading: window.JIRA_LOADING_BAR.FINISH
        });
        return null;
    };
});
parcelRegister("d46Cs", function(module, exports) {
    $parcel$export(module.exports, "createLoadingBarActionController", ()=>$65545b2eb3978204$export$55d67d61d9d2ad3b);
    var $61WP1;
    const $65545b2eb3978204$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
    const $65545b2eb3978204$export$899393f3e23f724b = 15000;
    const $65545b2eb3978204$export$7868b416d8929c55 = 40000;
    const $65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR = 'body::before';
    const $65545b2eb3978204$var$EXIT_ANIMATION_SPEED = 300;
    const $65545b2eb3978204$export$99d4e8974a739853 = ()=>(0, (0, parcelRequire("61WP1")).getMeta)('ajs-lf-navigation-highlightcolour') || $65545b2eb3978204$export$53d51cc6d57e44da;
    const $65545b2eb3978204$export$4fb8742b05de9693 = (duration)=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0.99);
        transition-duration: ${duration}ms;
        transition-timing-function: cubic-bezier(0,1,0.5,1);
    }
`;
    const $65545b2eb3978204$export$5a43e0f09174e553 = ()=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(1);
        transition-duration: ${$65545b2eb3978204$var$EXIT_ANIMATION_SPEED}ms;
        animation: none;
        background-image: none;
    }
`;
    const $65545b2eb3978204$export$6beef8c645a63156 = ()=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0);
        transition-duration: 0ms;
        animation: none;
        background-image: none;
    }
`;
    const $65545b2eb3978204$export$610cb442736abf53 = ()=>`
    @keyframes shimmer {
        from {
            left: -80%;
            width: 80%;
        }

        to {
            left: 110%;
            width: 10%;
        }
    }
`;
    const $65545b2eb3978204$export$959e9e99fba397f1 = (loadingBarColor)=>`
        ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
            transform: scaleX(1);
            transition-duration: 0ms;
            background: ${loadingBarColor};
            animation: shimmer 2s infinite;
        }
    `;
    const $65545b2eb3978204$var$browserFocusCheck = (action)=>{
        if (document && document.hidden) action();
        else requestAnimationFrame(()=>{
            action();
        });
    };
    const $65545b2eb3978204$export$55d67d61d9d2ad3b = (stylesheet)=>{
        const { sheet: sheet } = stylesheet || {};
        if (!sheet) return undefined;
        let isRunning = false;
        let isDelayed = false;
        let exitAnimationTimer;
        let delayedAnimationTimer;
        let timeoutTimer;
        return {
            START: (duration = $65545b2eb3978204$export$899393f3e23f724b)=>{
                if (isRunning) return;
                isRunning = true;
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$4fb8742b05de9693(duration), sheet.cssRules.length);
                });
                delayedAnimationTimer = setTimeout(()=>{
                    if (!isRunning) return;
                    isDelayed = true;
                    $65545b2eb3978204$var$browserFocusCheck(()=>{
                        sheet.insertRule($65545b2eb3978204$export$610cb442736abf53(), sheet.cssRules.length);
                        sheet.insertRule($65545b2eb3978204$export$959e9e99fba397f1($65545b2eb3978204$export$99d4e8974a739853()), sheet.cssRules.length);
                    });
                }, $65545b2eb3978204$export$899393f3e23f724b);
                timeoutTimer = setTimeout(()=>{
                    if (!isRunning) return;
                    isRunning = false;
                    isDelayed = false;
                    $65545b2eb3978204$var$browserFocusCheck(()=>{
                        sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                    });
                    clearTimeout(exitAnimationTimer);
                    clearTimeout(delayedAnimationTimer);
                    clearTimeout(timeoutTimer);
                }, $65545b2eb3978204$export$7868b416d8929c55);
            },
            FINISH: ()=>{
                if (!isRunning) return;
                isRunning = false;
                if (isDelayed) {
                    isDelayed = false;
                    clearTimeout(exitAnimationTimer);
                    clearTimeout(timeoutTimer);
                    clearTimeout(delayedAnimationTimer);
                    $65545b2eb3978204$var$browserFocusCheck(()=>{
                        sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                    });
                    return;
                }
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$5a43e0f09174e553(), sheet.cssRules.length);
                });
                exitAnimationTimer = setTimeout(()=>{
                    clearTimeout(exitAnimationTimer);
                    clearTimeout(timeoutTimer);
                    clearTimeout(delayedAnimationTimer);
                    $65545b2eb3978204$var$browserFocusCheck(()=>{
                        sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                    });
                }, $65545b2eb3978204$var$EXIT_ANIMATION_SPEED + 500);
            },
            RESET: ()=>{
                isRunning = false;
                isDelayed = false;
                clearTimeout(exitAnimationTimer);
                clearTimeout(delayedAnimationTimer);
                clearTimeout(timeoutTimer);
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                });
            }
        };
    };
    const $65545b2eb3978204$var$setupLoadingBarActionController = ()=>{
        const LOADER_STYLESHEET_ID = 'loaderStylesheet';
        const styleSheet = document.getElementById(LOADER_STYLESHEET_ID);
        if (!styleSheet || !styleSheet.sheet) return;
        window.JIRA_LOADING_BAR = $65545b2eb3978204$export$55d67d61d9d2ad3b(styleSheet);
        if (window.JIRA_LOADING_BAR && window.JIRA_LOADING_BAR.START) window.JIRA_LOADING_BAR.START();
    };
    $65545b2eb3978204$var$setupLoadingBarActionController();
});
parcelRegister("61WP1", function(module, exports) {
    $parcel$export(module.exports, "getMeta", ()=>$22b3d998cd498e5f$export$c47913ca32a5c6f7);
    const $22b3d998cd498e5f$export$c47913ca32a5c6f7 = (name)=>{
        const node = document.querySelector(`meta[name="${name}"]`);
        const metaValue = node && node.getAttribute('content');
        return metaValue !== undefined ? metaValue : null;
    };
});
parcelRegister("04unK", function(module, exports) {
    $parcel$export(module.exports, "LOADER_STYLES_CSS_SELECTOR", ()=>$ac75ec265428b4c8$export$2a3dd4ccb7b0a764);
    $parcel$export(module.exports, "LOADER_STYLESHEET_ID", ()=>$ac75ec265428b4c8$export$79456f717d4431da);
    $parcel$export(module.exports, "getAllowedRoutes", ()=>$ac75ec265428b4c8$export$c82eb262b97a76f1);
    $parcel$export(module.exports, "getLoadingBarColor", ()=>$ac75ec265428b4c8$export$cf3a5ed89e041425);
    var $8QpSo;
    var $65Ltd;
    var $j8DrX;
    const $ac75ec265428b4c8$var$FIRST_RELEASE_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE_EMBED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BOARDS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY_SECURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_COMPONENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_VERSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT)
    ];
    const $ac75ec265428b4c8$export$2a3dd4ccb7b0a764 = 'body::before';
    const $ac75ec265428b4c8$export$79456f717d4431da = 'loaderStylesheet';
    const $ac75ec265428b4c8$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
    const $ac75ec265428b4c8$export$c82eb262b97a76f1 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        const ALLOWED_ROUTES = $ac75ec265428b4c8$var$FIRST_RELEASE_ROUTES;
        return ALLOWED_ROUTES;
    });
    const $ac75ec265428b4c8$export$cf3a5ed89e041425 = (0, (0, parcelRequire("8QpSo")).default)(()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-lf-navigation-highlightcolour') || $ac75ec265428b4c8$export$53d51cc6d57e44da);
});
parcelRegister("cYUbO", function(module, exports) {
    $parcel$export(module.exports, "generateLoadingBarStyles", ()=>$e5278a73a699aa95$export$3036104bc81246b1);
    var $gwIPs;
    var $04unK;
    const $e5278a73a699aa95$export$3036104bc81246b1 = (initalProgressValue, loadingBarColor)=>`
    content: '';
    display: block;
    background: ${loadingBarColor};
    height: 3px;
    z-index: ${(0, (0, parcelRequire("gwIPs")).layers).navigation + 10};
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    transform: scaleX(${initalProgressValue});
    transform-origin: 0 0;
    will-change: transform;
`;
    const $e5278a73a699aa95$export$85e33a4b3d661500 = (initialProgressValue = 0.3)=>`
        <style id=${0, (0, parcelRequire("04unK")).LOADER_STYLESHEET_ID}>
            ${0, (0, parcelRequire("04unK")).LOADER_STYLES_CSS_SELECTOR} {${$e5278a73a699aa95$export$3036104bc81246b1(initialProgressValue, (0, (0, parcelRequire("04unK")).getLoadingBarColor)())}}
        </style>`;
});
parcelRegister("7Lkcv", function(module, exports) {
    $parcel$export(module.exports, "SafeHelpPanel", ()=>$70a8cef9c47c5a71$export$cd2ada2fb14048fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $89SaW;
    var $7CMCs;
    var $6BNJk;
    var $kspz4;
    var $7dTw7;
    var $1SVH7;
    var $hsmeR;
    var $90yGq;
    const $70a8cef9c47c5a71$var$HelpPanel = ()=>{
        const [{ navigationData: navigationData, releaseNotesNotifications: releaseNotesNotifications }, { setNavigationData: setNavigationData, setReleaseNotesNotifications: setReleaseNotesNotifications }] = (0, (0, parcelRequire("kspz4")).useHelpPanel)();
        const { closeRightSidebar: closeRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        (0, $5uXOq.useEffect)(()=>{
            const restoreReleaseNotesNotifications = async ()=>{
                if (accountId) try {
                    const { helpPanel: userPropertiesHelpPanelValue } = await (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, (0, $0971f751295a2324$export$783d7c02e3a0cbf));
                    setReleaseNotesNotifications(userPropertiesHelpPanelValue.releaseNotesNotifications);
                } catch (err) {
                    setReleaseNotesNotifications(0);
                }
                else setReleaseNotesNotifications(0);
            };
            restoreReleaseNotesNotifications();
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7dTw7")).RemoteStateUpdater), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1SVH7")).LazyHelpPanel), {
            isOpen: !rightSidebarCurrentState?.isCollapsed,
            navigationData: navigationData,
            releaseNotesNotifications: releaseNotesNotifications,
            setNavigationData: setNavigationData,
            releaseNotesNotificationsSetter: setReleaseNotesNotifications,
            hasBeenRendered: !rightSidebarCurrentState?.isCollapsed,
            onCloseHelpPanel: closeRightSidebar
        }));
    };
    const $70a8cef9c47c5a71$var$HelpPanelInLayout = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
        const prevPanelIdRef = (0, $5uXOq.useRef)();
        const delayRef = (0, $5uXOq.useRef)(null);
        const panelId = rightSidebarCurrentState?.panelId;
        (0, $5uXOq.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                }, 310);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            panelId,
            rightSidebarCurrentState
        ]);
        if (localPanelId !== (0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($70a8cef9c47c5a71$var$HelpPanel, null);
    };
    const $70a8cef9c47c5a71$export$cd2ada2fb14048fc = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-help-panel",
            packageName: "@atlassian/jira-help-panel-right-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($70a8cef9c47c5a71$var$HelpPanelInLayout, null));
});
parcelRegister("6BNJk", function(module, exports) {
    $parcel$export(module.exports, "HELP_PANEL_VERSION", ()=>$20386d7da4313ff0$export$c43c7444da662fa1);
    $parcel$export(module.exports, "HELP_PANEL_ID", ()=>$20386d7da4313ff0$export$e99efa3985fa3c26);
    $parcel$export(module.exports, "HELP_PANEL_WIDTH", ()=>$20386d7da4313ff0$export$23aa6670f346c214);
    var $gwIPs;
    const $20386d7da4313ff0$export$c43c7444da662fa1 = '1';
    const $20386d7da4313ff0$export$e99efa3985fa3c26 = 'helpPanel';
    const $20386d7da4313ff0$export$23aa6670f346c214 = (0, (0, parcelRequire("gwIPs")).gridSize) * 46;
});
parcelRegister("kspz4", function(module, exports) {
    $parcel$export(module.exports, "useHelpPanel", ()=>$aee6103177ce0723$export$3fe94d66377a53b8);
    $parcel$export(module.exports, "useHelpPanelActions", ()=>$aee6103177ce0723$export$c61f56f4797e22db);
    var $3sQ5x;
    var $51nlc;
    var $jgGDm;
    const $aee6103177ce0723$export$3fe94d66377a53b8 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("jgGDm")).default));
    const $aee6103177ce0723$export$c61f56f4797e22db = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("jgGDm")).default), {
        selector: null
    });
    const $aee6103177ce0723$export$513717a84f55db1a = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("jgGDm")).default), {
        displayName: 'HelpPanelSubscriber'
    });
    const $aee6103177ce0723$export$5f4de38bd79f4446 = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("jgGDm")).default), {
        displayName: 'HelpPanelActionsSubscriber',
        selector: null
    });
});
parcelRegister("jgGDm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$465615692863cce9$export$2e2bcd8739ae039);
    var $eNf8a;
    var $iXqE5;
    var $958ua;
    const $465615692863cce9$var$iphStorage = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)('iph');
    const $465615692863cce9$var$initialState = {
        navigationData: {
            articleId: {
                id: '',
                type: 'HELP_ARTICLE'
            },
            history: $465615692863cce9$var$iphStorage.get('history') || []
        },
        releaseNotesNotifications: 100
    };
    var $465615692863cce9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'help-panel',
        initialState: $465615692863cce9$var$initialState,
        actions: (0, parcelRequire("958ua"))
    });
});
parcelRegister("958ua", function(module, exports) {
    $parcel$export(module.exports, "setNavigationData", ()=>$177ac56c5a5bf49e$export$ab1b80f40ca898ed);
    $parcel$export(module.exports, "setReleaseNotesNotifications", ()=>$177ac56c5a5bf49e$export$cdabe01d01a8da1e);
    var $eNf8a;
    const $177ac56c5a5bf49e$var$iphStorage = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)('iph');
    const $177ac56c5a5bf49e$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                navigationData: {
                    articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                    history: navigationData.history ? navigationData.history : currentState.navigationData.history
                }
            });
            $177ac56c5a5bf49e$var$iphStorage.set('history', []);
        };
    const $177ac56c5a5bf49e$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
            setState({
                releaseNotesNotifications: releaseNotesNotifications
            });
        };
});
const $0971f751295a2324$export$783d7c02e3a0cbf = 'help_panel_ui_state';
parcelRegister("7dTw7", function(module, exports) {
    $parcel$export(module.exports, "RemoteStateUpdater", ()=>$52205ad66fbf5dd9$export$3db011870dd4330f);
    var $5uXOq = parcelRequire("5uXOq");
    var $laWvb;
    var $89SaW;
    var $jcw0u;
    var $90yGq;
    var $kspz4;
    const $52205ad66fbf5dd9$var$DEBOUNCE_TIME = 1000;
    const $52205ad66fbf5dd9$export$3db011870dd4330f = ()=>{
        const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, (0, parcelRequire("kspz4")).useHelpPanel)();
        const [releaseNotesNotificationsTemp, setReleaseNotesNotificationsTemp] = (0, $5uXOq.useState)(releaseNotesNotifications);
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const [debouncedUpdateData] = (0, (0, parcelRequire("laWvb")).default)(async (newReleaseNotesNotifications)=>{
            const remoteData = {
                helpPanel: {
                    releaseNotesNotifications: newReleaseNotesNotifications
                }
            };
            if (accountId) try {
                await (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, $0971f751295a2324$export$783d7c02e3a0cbf), JSON.stringify(remoteData));
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e,
                    meta: {
                        id: 'updateServerHelpPanelState',
                        packageName: 'jiraHelpPanelServices',
                        teamName: 'self-help-experiences'
                    }
                });
            }
        }, $52205ad66fbf5dd9$var$DEBOUNCE_TIME);
        (0, $5uXOq.useEffect)(()=>{
            if (releaseNotesNotificationsTemp !== releaseNotesNotifications) {
                setReleaseNotesNotificationsTemp(releaseNotesNotifications);
                debouncedUpdateData(releaseNotesNotifications);
            }
        }, [
            debouncedUpdateData,
            releaseNotesNotifications,
            releaseNotesNotificationsTemp
        ]);
        return null;
    };
});
parcelRegister("laWvb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6a7e96a5e9b4bd2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $f6a7e96a5e9b4bd2$export$2e2bcd8739ae039(callback, delay, options) {
        if (options === void 0) options = {};
        var maxWait = options.maxWait;
        var maxWaitHandler = (0, $5uXOq.useRef)(null);
        var maxWaitArgs = (0, $5uXOq.useRef)([]);
        var leading = options.leading;
        var trailing = options.trailing === undefined ? true : options.trailing;
        var leadingCall = (0, $5uXOq.useRef)(false);
        var functionTimeoutHandler = (0, $5uXOq.useRef)(null);
        var isComponentUnmounted = (0, $5uXOq.useRef)(false);
        var debouncedFunction = (0, $5uXOq.useRef)(callback);
        debouncedFunction.current = callback;
        var cancelDebouncedCallback = (0, $5uXOq.useCallback)(function() {
            clearTimeout(functionTimeoutHandler.current);
            clearTimeout(maxWaitHandler.current);
            maxWaitHandler.current = null;
            maxWaitArgs.current = [];
            functionTimeoutHandler.current = null;
            leadingCall.current = false;
        }, []);
        (0, $5uXOq.useEffect)(function() {
            return function() {
                isComponentUnmounted.current = true;
            };
        }, []);
        var debouncedCallback = (0, $5uXOq.useCallback)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            maxWaitArgs.current = args;
            clearTimeout(functionTimeoutHandler.current);
            if (leadingCall.current) leadingCall.current = false;
            if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
                debouncedFunction.current.apply(debouncedFunction, args);
                leadingCall.current = true;
            }
            functionTimeoutHandler.current = setTimeout(function() {
                var shouldCallFunction = true;
                if (leading && leadingCall.current) shouldCallFunction = false;
                cancelDebouncedCallback();
                if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
            }, delay);
            if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
                var args = maxWaitArgs.current;
                cancelDebouncedCallback();
                if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
            }, maxWait);
        }, [
            maxWait,
            delay,
            cancelDebouncedCallback,
            leading,
            trailing
        ]);
        var callPending = (0, $5uXOq.useCallback)(function() {
            if (!functionTimeoutHandler.current) return;
            debouncedFunction.current.apply(null, maxWaitArgs.current);
            cancelDebouncedCallback();
        }, [
            cancelDebouncedCallback
        ]);
        return [
            debouncedCallback,
            cancelDebouncedCallback,
            callPending
        ];
    }
});
parcelRegister("1SVH7", function(module, exports) {
    $parcel$export(module.exports, "LazyHelpPanel", ()=>$311d1a0e95633292$export$51c79455aef7d178);
    var $5uXOq = parcelRequire("5uXOq");
    var $b71gk;
    var $7iJwP;
    var $6s1PB;
    var $lfTZh;
    var $cYlk7;
    var $iXVV6;
    var $6Lg6A;
    var $jVpMq;
    var $7rrMi;
    var $4RupH;
    const $311d1a0e95633292$export$51c79455aef7d178 = ({ navigationData: { articleId: articleId, history: history }, setNavigationData: setNavigationData, releaseNotesNotifications: releaseNotesNotifications, releaseNotesNotificationsSetter: releaseNotesNotificationsSetter, isOpen: isOpen, onCloseHelpPanel: onCloseHelpPanel, hasBeenRendered: hasBeenRendered, routeGroup: routeGroup, routeName: routeName })=>{
        const user = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b71gk")).default), {
            id: "help-panel",
            packageName: "jiraHelpPanel",
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jVpMq")).default), {
                    loadingArticle: articleId.id !== ''
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: "root",
            packageName: "jiraHelpPanel",
            teamName: "self-help-experiences"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7rrMi")).SearchContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            tags: [
                'iph'
            ],
            sourceName: "jiraHelpPanel",
            sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
            attributes: {
                searchService: (0, (0, parcelRequire("6s1PB")).expVal)('20240422_self_help_iph_ms3_expt', 'iph_ms3_experience_display_flag', false) ? 'help-aggregator' : 'algolia',
                routeGroup: routeGroup,
                routeName: routeName,
                userId: user?.data?.user?.accountId
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Lg6A")).LazyWait), {
            until: hasBeenRendered
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-lazy-help-panel",
            fallback: isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jVpMq")).default), {
                loadingArticle: articleId.id !== ''
            }) : null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4RupH")).AsyncLazyHelpPanel), {
            navigationData: {
                articleId: articleId,
                history: history
            },
            releaseNotesNotificationsSetter: releaseNotesNotificationsSetter,
            releaseNotesNotifications: releaseNotesNotifications,
            setNavigationData: setNavigationData,
            isOpen: isOpen,
            onCloseHelpPanel: onCloseHelpPanel,
            routeGroup: routeGroup,
            routeName: routeName
        })))))));
    };
});
parcelRegister("cYlk7", function(module, exports) {
    $parcel$export(module.exports, "useCurrentUser", ()=>$cdd4ab536fcf9459$export$3901076af3749fa9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzeFL;
    var $9OXo1;
    var $leRCk;
    const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return (0, $5uXOq.useMemo)(()=>({
                data: {
                    user: {
                        accountId: tenantContext.atlassianAccountId,
                        isAdmin: tenantContext.isAdmin,
                        isAnonymous: tenantContext.isAnonymous,
                        isSiteAdmin: tenantContext.isSiteAdmin,
                        locale: tenantContext.locale || (0, (0, parcelRequire("lzeFL")).defaultLocale),
                        siteAdminStatus: tenantContext.siteAdminStatus,
                        userFullname: tenantContext.userFullname || ''
                    }
                },
                loading: false,
                error: null
            }), [
            tenantContext.atlassianAccountId,
            tenantContext.isAdmin,
            tenantContext.isAnonymous,
            tenantContext.isSiteAdmin,
            tenantContext.locale,
            tenantContext.siteAdminStatus,
            tenantContext.userFullname
        ]);
    };
    const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
        const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, (0, parcelRequire("leRCk")).useUserSubscriber)();
        (0, $5uXOq.useEffect)(()=>{
            tenantContext.atlassianAccountId && fetch({
                params: {
                    accountId: tenantContext.atlassianAccountId
                }
            }, false);
        }, [
            fetch,
            tenantContext.atlassianAccountId
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: {
                    ...dataBasic,
                    user: {
                        ...dataBasic.user,
                        ...data
                    }
                },
                loading: loading,
                error: error
            }), [
            data,
            dataBasic,
            error,
            loading
        ]);
    };
    const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>(0, (0, parcelRequire("9OXo1")).useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull();
    const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
        const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
        return children(result);
    };
});
parcelRegister("leRCk", function(module, exports) {
    $parcel$export(module.exports, "UserContainer", ()=>$46a581f1f6efe569$export$7ff085589970ee0a);
    $parcel$export(module.exports, "useUserSubscriber", ()=>$46a581f1f6efe569$export$4e61bbf568682a96);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $314C6;
    const $46a581f1f6efe569$var$initialState = {
        data: null,
        loading: false,
        error: null
    };
    const $46a581f1f6efe569$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'user',
        initialState: $46a581f1f6efe569$var$initialState,
        actions: (0, parcelRequire("314C6"))
    });
    const $46a581f1f6efe569$export$7ff085589970ee0a = (0, (0, parcelRequire("gg7kZ")).createContainer)($46a581f1f6efe569$var$Store);
    const $46a581f1f6efe569$export$4e61bbf568682a96 = (0, (0, parcelRequire("3sQ5x")).createHook)($46a581f1f6efe569$var$Store);
});
parcelRegister("314C6", function(module, exports) {
    $parcel$export(module.exports, "fetch", ()=>$acdfee9161693eca$export$e7aa7bc5c1b3cfb3);
    var $iF3m5;
    const $acdfee9161693eca$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (!params || currentState.loading || currentState.data && !forceRefetch) return;
            setState({
                loading: true
            });
            try {
                const data = await (0, (0, parcelRequire("iF3m5")).fetchData)({
                    params: params,
                    header: header
                });
                setState({
                    data: data,
                    loading: false,
                    error: null
                });
            } catch (err) {
                setState({
                    error: err,
                    loading: false
                });
            }
        };
});
parcelRegister("iF3m5", function(module, exports) {
    $parcel$export(module.exports, "fetchData", ()=>$d22d4c6d892f61f1$export$8134c072fddab6a5);
    var $ebyGx = parcelRequire("ebyGx");
    var $eusud;
    const $d22d4c6d892f61f1$export$8134c072fddab6a5 = ({ params: params, header: header })=>{
        const queryParams = {
            ...params,
            expand: Object.keys(params.expand || {}).filter((key)=>params.expand && params.expand[key])
        };
        const query = (0, $ebyGx.stringify)(queryParams, {
            arrayFormat: 'none'
        });
        const queryString = query ? `?${query}` : '';
        const requestUrl = `/rest/api/2/user${queryString}`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(requestUrl, header ? {
            headers: header
        } : {});
    };
});
parcelRegister("jVpMq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8bb188482996cb7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $5CrlE;
    const $b8bb188482996cb7$var$HelpPanelLoading = ({ loadingArticle: loadingArticle = false })=>loadingArticle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5CrlE")).HelpPanelContainerV2), null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$HeaderLoading, null), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingContent, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "img",
            "aria-label": "help panel loading"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-250, 20px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "90%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "70%"
        })))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5CrlE")).HelpPanelContainerV2), null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$HeaderLoading, null), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingContent, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-500, 40px)",
            marginTop: "var(--ds-space-100, 8px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleList, {
            role: "img"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-150, 12px)",
            contentWidth: "var(--ds-space-800, 64px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-150, 12px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-150, 12px)",
            contentWidth: "var(--ds-space-800, 64px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-150, 12px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-150, 12px)",
            contentWidth: "var(--ds-space-800, 64px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-150, 12px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        })))));
    var $b8bb188482996cb7$export$2e2bcd8739ae039 = $b8bb188482996cb7$var$HelpPanelLoading;
    const $b8bb188482996cb7$var$LoadingContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4pxbi _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $b8bb188482996cb7$var$HeaderLoading = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ixncg _bfhk10nm _n7zlxs90 _1bah1yb4 _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $b8bb188482996cb7$var$shimmer = null;
    const $b8bb188482996cb7$var$LoadingRectangle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { contentHeight: contentHeight, marginTop: marginTop, contentWidth: contentWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_l7mdyr": (0, (0, parcelRequire("lD23V")).default)(__cmplp.contentHeight),
                "--_1fj4wta": (0, (0, parcelRequire("lD23V")).default)(__cmplp.marginTop),
                "--_7n1eiw": (0, (0, parcelRequire("lD23V")).default)(__cmplp.contentWidth)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _2rkov77o _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk134c _1itk15g1 _12vemgnk",
                __cmplp.contentHeight != null ? "_4t3i6c59" : "_4t3ipxbi",
                __cmplp.marginTop != null ? "_19pkmye1" : "_19pku2gc",
                __cmplp.contentWidth != null ? "_1bsbwd3v" : "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $b8bb188482996cb7$var$LoadignArticleList = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _18s8v0yc _1yt4ze3t _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $b8bb188482996cb7$var$LoadignArticleListItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _1bsb1osq _1yt4u2gc _vchhusvi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5CrlE", function(module, exports) {
    $parcel$export(module.exports, "HelpPanelContainer", ()=>$2dbd0534194918a8$export$37cd645d7678f7d4);
    $parcel$export(module.exports, "HelpPanelContainerV2", ()=>$2dbd0534194918a8$export$1df7e3ebfc4c9b06);
    $parcel$export(module.exports, "HelpPanelSectionMessageContainer", ()=>$2dbd0534194918a8$export$9f6251c714594f23);
    $parcel$export(module.exports, "HelpPanelContentContainer", ()=>$2dbd0534194918a8$export$1cdb922eed7271d1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $2dbd0534194918a8$export$37cd645d7678f7d4 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vchhusvi _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1kl71osx _2lx21bp4 _1bsb1feq _4t3i1osq _kqsw1n9t",
                __cmplp.className
            ])
        });
    });
    const $2dbd0534194918a8$export$1df7e3ebfc4c9b06 = (0, $5uXOq.forwardRef)(({ as: C = $2dbd0534194918a8$export$37cd645d7678f7d4, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1i8v _11q71bhr",
                __cmplp.className
            ])
        });
    });
    const $2dbd0534194918a8$export$9f6251c714594f23 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1yt41rfa _1bsb1osq _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $2dbd0534194918a8$export$1cdb922eed7271d1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1tkeidpf _kqswh2mm _18m91wug _1reo15vq _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ae4v1fhb _4cvr1y6m",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7rrMi", function(module, exports) {
    $parcel$export(module.exports, "useSearchContext", ()=>$c0047fc735c61769$export$67b98b1b880a048b);
    $parcel$export(module.exports, "SearchContextProvider", ()=>$c0047fc735c61769$export$6bd70292443463a4);
    var $5uXOq = parcelRequire("5uXOq");
    var $jFLAi;
    const [$c0047fc735c61769$export$67b98b1b880a048b, $c0047fc735c61769$export$70af50e847ce290a] = (0, (0, parcelRequire("jFLAi")).createCtx)();
    const $c0047fc735c61769$export$6bd70292443463a4 = ({ children: children })=>{
        const [searchContext, setSearchContext] = (0, $5uXOq.useState)({});
        const addClickedArticleIds = (0, $5uXOq.useCallback)((query, clickedArticleId)=>{
            setSearchContext((prev)=>({
                    ...prev,
                    [query]: {
                        ...prev[query],
                        clickedArticleIds: prev[query]?.clickedArticleIds ? [
                            ...prev[query].clickedArticleIds,
                            clickedArticleId
                        ] : [
                            clickedArticleId
                        ]
                    }
                }));
        }, []);
        const addFetchedArticleIds = (0, $5uXOq.useCallback)((query, fetchedArticles)=>{
            setSearchContext((prev)=>({
                    ...prev,
                    [query]: {
                        ...prev[query],
                        fetchedArticleIds: fetchedArticles
                    }
                }));
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c0047fc735c61769$export$70af50e847ce290a, {
            value: {
                searchContext: searchContext,
                addClickedArticleIds: addClickedArticleIds,
                addFetchedArticleIds: addFetchedArticleIds
            }
        }, children);
    };
});
parcelRegister("jFLAi", function(module, exports) {
    $parcel$export(module.exports, "createCtx", ()=>$b612e461f4fc901f$export$d653a1a643c9a98c);
    var $5uXOq = parcelRequire("5uXOq");
    function $b612e461f4fc901f$export$d653a1a643c9a98c() {
        const ctx = (0, $5uXOq.createContext)(undefined);
        function useCtx() {
            const c = (0, $5uXOq.useContext)(ctx);
            if (!c) throw new Error('useCtx must be inside a Provider with a value');
            return c;
        }
        return [
            useCtx,
            ctx.Provider
        ];
    }
});
parcelRegister("4RupH", function(module, exports) {
    $parcel$export(module.exports, "AsyncLazyHelpPanel", ()=>$4ce54108d7c5ac07$export$7ff46d33d0f13518);
    var $kxZPA;
    const $4ce54108d7c5ac07$export$7ff46d33d0f13518 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("f5yYn")).then(({ HelpPanel: HelpPanel })=>HelpPanel), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/help-panel/src/ui/index.tsx"
    });
});
parcelRegister("f5yYn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cBrFc")
    ]).then(()=>parcelRequire('jj3on'));
});
parcelRegister("9YvQF", function(module, exports) {
    $parcel$export(module.exports, "SafeEmbeddedConfluencePanel", ()=>$3e89344d89118823$export$2d901a489872dd0d);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $9KYrx;
    var $gXSrH;
    var $7CMCs;
    var $hsmeR;
    var $9V9QO;
    const $3e89344d89118823$var$DELAY = 310;
    const $3e89344d89118823$export$2db0a2e0275af8b8 = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const [{ panel: isOpen }] = (0, (0, parcelRequire("gXSrH")).useEmbeddedConfluenceSidePanel)();
        const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
        const prevPanelIdRef = (0, $5uXOq.useRef)();
        const delayRef = (0, $5uXOq.useRef)(null);
        const panelId = rightSidebarCurrentState?.panelId;
        const { entryPointActions: entryPointActions, entryPoint: entryPoint } = (0, (0, parcelRequire("9V9QO")).useEmbeddedPanelEntryPoint)();
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen) entryPointActions?.load();
        }, [
            isOpen,
            entryPointActions,
            localPanelId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                }, $3e89344d89118823$var$DELAY);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            panelId,
            rightSidebarCurrentState
        ]);
        if (localPanelId !== (0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $3e89344d89118823$var$panelStyles
        }, entryPoint);
    };
    const $3e89344d89118823$export$2d901a489872dd0d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-embedded-confluence-panel",
            packageName: "jiraIssueCreateConfluenceContent"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gXSrH")).EmbeddedConfluenceSidepanelContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($3e89344d89118823$export$2db0a2e0275af8b8, null)));
    const $3e89344d89118823$var$panelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.100',
        height: 'calc(100vh - (var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px)))'
    });
});
parcelRegister("9KYrx", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceFeatureKeys", ()=>$e486b17128606747$export$746d4746bf07dd70);
    $parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_KEY", ()=>$e486b17128606747$export$6247c7e19b71f4e);
    $parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_KEY", ()=>$e486b17128606747$export$e34c4c923d934e7a);
    $parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY", ()=>$e486b17128606747$export$ffe60197eb59ca73);
    $parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY", ()=>$e486b17128606747$export$8d0c4a26241944b8);
    $parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID", ()=>$e486b17128606747$export$a497288e64e9a343);
    const $e486b17128606747$export$746d4746bf07dd70 = {
        ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
        SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
        CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
        CREATE_MENU_CONFLUENCE_CONTENT: 'jira.admin.confluence.enable-content-creation-issue-confluence-content'
    };
    const $e486b17128606747$export$6247c7e19b71f4e = 'confluence-integration-controls';
    const $e486b17128606747$export$e34c4c923d934e7a = 'user-confluence-access';
    const $e486b17128606747$export$ffe60197eb59ca73 = 'confluence-integration-controls-session-storage';
    const $e486b17128606747$export$8d0c4a26241944b8 = 'confluence-permissions-session-storage';
    const $e486b17128606747$export$a497288e64e9a343 = 'embedded-confluence-panel-container';
});
parcelRegister("gXSrH", function(module, exports) {
    $parcel$export(module.exports, "EmbeddedConfluenceSidepanelContainer", ()=>$27a5db923b3bcebb$export$a5c1c168018f0f16);
    $parcel$export(module.exports, "useEmbeddedConfluenceSidePanel", ()=>$27a5db923b3bcebb$export$518aeea31a00450e);
    var $5uXOq = parcelRequire("5uXOq");
    var $6s1PB;
    var $2gCtH;
    var $hsmeR;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $9KYrx;
    var $aQLD7;
    var $bvqNo;
    var $5labn;
    const $27a5db923b3bcebb$var$Container = (0, (0, parcelRequire("gg7kZ")).createContainer)();
    const $27a5db923b3bcebb$var$DefaultStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        actions: (0, parcelRequire("aQLD7")).actions,
        containedBy: $27a5db923b3bcebb$var$Container,
        initialState: (0, parcelRequire("aQLD7")).initialState,
        name: (0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
    });
    const $27a5db923b3bcebb$var$NonContainerStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        actions: (0, parcelRequire("aQLD7")).actions,
        initialState: (0, parcelRequire("aQLD7")).initialState,
        name: (0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
    });
    const $27a5db923b3bcebb$export$a5c1c168018f0f16 = ({ children: children })=>{
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($27a5db923b3bcebb$var$Container, {
            scope: `embedded-confluence-sidepanel-${issueKey}`
        }, children);
    };
    const $27a5db923b3bcebb$var$defaultStoreHook = (0, (0, parcelRequire("3sQ5x")).createHook)($27a5db923b3bcebb$var$DefaultStore);
    const $27a5db923b3bcebb$var$nonContainerStoreHook = (0, (0, parcelRequire("3sQ5x")).createHook)($27a5db923b3bcebb$var$NonContainerStore);
    const $27a5db923b3bcebb$export$518aeea31a00450e = (embeddedConfluenceSource)=>{
        const [embedConfluenceSidepanelConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
        const isInExperiment = embedConfluenceSidepanelConfig.get('cohort', 'not-enrolled') === 'experiment';
        const [state, { closeSidePanel: closeSidePanelAction, openSidePanel: openSidePanelAction, setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection, setDeferredSpaceData: setDeferredSpaceData, toggleExpandedState: toggleExpandedState, setIsDraftState: setIsDraftState, setConfluenceData: setConfluenceData }] = isInExperiment ? $27a5db923b3bcebb$var$defaultStoreHook() : $27a5db923b3bcebb$var$nonContainerStoreHook();
        const { closeRightSidebar: closeRightSidebar, openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const openSidePanel = (0, $5uXOq.useCallback)(({ contentId: contentId, contentType: contentType, data: data, hostname: hostname, isDraft: isDraft, isLive: isLive, onLinkPage: onLinkPage, onPublish: onPublish, openInModal: openInModal, mode: mode, url: url, title: title })=>{
            const { initialWidth: initialWidth, displayType: displayType } = (0, (0, parcelRequire("5labn")).getDisplayInformation)();
            const shouldOpenPanel = displayType === (0, (0, parcelRequire("bvqNo")).DisplayTypes).PANEL;
            if (shouldOpenPanel) {
                openSidePanelAction({
                    contentId: contentId,
                    contentType: contentType,
                    embeddedConfluenceSource: embeddedConfluenceSource,
                    data: data,
                    displayType: displayType,
                    initialWidth: initialWidth,
                    hostname: hostname,
                    isDraft: isDraft,
                    isLive: isLive,
                    mode: mode,
                    onLinkPage: onLinkPage,
                    onPublish: onPublish,
                    shouldOpenModal: !shouldOpenPanel,
                    url: url,
                    title: title
                });
                openRightSidebar((0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID), initialWidth, false, true);
            } else openInModal();
        }, [
            embeddedConfluenceSource,
            openRightSidebar,
            openSidePanelAction
        ]);
        const closeSidePanel = (0, $5uXOq.useCallback)(()=>{
            closeRightSidebar((0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID));
            closeSidePanelAction();
        }, [
            closeRightSidebar,
            closeSidePanelAction
        ]);
        return [
            state,
            {
                openSidePanel: openSidePanel,
                closeSidePanel: closeSidePanel,
                setDeferredSpaceData: setDeferredSpaceData,
                setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection,
                toggleExpandedState: toggleExpandedState,
                setIsDraftState: setIsDraftState,
                setConfluenceData: setConfluenceData
            }
        ];
    };
});
parcelRegister("2gCtH", function(module, exports) {
    $parcel$export(module.exports, "useChildIssuesLimit", ()=>$9e67f38435565e11$export$8d75f312eaa63aec);
    $parcel$export(module.exports, "useChildIssuesIssueLimitUrl", ()=>$9e67f38435565e11$export$65a59acd1ffc5bba);
    $parcel$export(module.exports, "useIsModal", ()=>$9e67f38435565e11$export$9ce8428ff198804a);
    $parcel$export(module.exports, "useIssueKey", ()=>$9e67f38435565e11$export$22108eca27445997);
    $parcel$export(module.exports, "useIssueId", ()=>$9e67f38435565e11$export$9df8176b5ffce5ab);
    $parcel$export(module.exports, "useIsArchived", ()=>$9e67f38435565e11$export$7cd1821433aafaee);
    $parcel$export(module.exports, "useIsClassifyEditEnabled", ()=>$9e67f38435565e11$export$b23b36ed5c42e920);
    $parcel$export(module.exports, "useProjectKey", ()=>$9e67f38435565e11$export$f87be37f8e8be65);
    $parcel$export(module.exports, "useAnalyticsSource", ()=>$9e67f38435565e11$export$aad3917152559b87);
    $parcel$export(module.exports, "useIssueContextActions", ()=>$9e67f38435565e11$export$d6ec1293313f49ac);
    $parcel$export(module.exports, "useRapidViewMap", ()=>$9e67f38435565e11$export$4d204e800e4e0be7);
    $parcel$export(module.exports, "useEstimationStatistic", ()=>$9e67f38435565e11$export$5b20e30ee6db56e9);
    $parcel$export(module.exports, "useViewMode", ()=>$9e67f38435565e11$export$3a7c3e259b6adb93);
    $parcel$export(module.exports, "useBackButtonUrl", ()=>$9e67f38435565e11$export$cfe64a334903927c);
    $parcel$export(module.exports, "useIssueNavigatorData", ()=>$9e67f38435565e11$export$aa008a00bae7e7ab);
    $parcel$export(module.exports, "useOnIssueKeyChange", ()=>$9e67f38435565e11$export$52c975cf0b623556);
    $parcel$export(module.exports, "useRapidViewId", ()=>$9e67f38435565e11$export$b34d0ea0bf41fee);
    $parcel$export(module.exports, "useViewScreenId", ()=>$9e67f38435565e11$export$7c142b5701b4c3f9);
    $parcel$export(module.exports, "useHasSoftwareAccess", ()=>$9e67f38435565e11$export$dcc0d1c3cd4bd9fb);
    $parcel$export(module.exports, "useIsFullPageIssueView", ()=>$9e67f38435565e11$export$2e131fc4108f9106);
    $parcel$export(module.exports, "useIsEmbedPageIssueView", ()=>$9e67f38435565e11$export$4596c26005fbb859);
    $parcel$export(module.exports, "useIsAiEnabledForIssue", ()=>$9e67f38435565e11$export$db5174c7538abe4b);
    $parcel$export(module.exports, "useIsJiraIssue", ()=>$9e67f38435565e11$export$cf5fc815f761fb4b);
    $parcel$export(module.exports, "useIsAiOptInEnabled", ()=>$9e67f38435565e11$export$b131d9f6da853161);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $4Pf62;
    var $co1wz;
    var $e5wyW;
    var $93Yeu;
    var $g5X3G;
    var $ef5Xn;
    var $7trqb;
    var $hqBSi;
    var $koiRX;
    const $9e67f38435565e11$export$8d75f312eaa63aec = ()=>{
        const [childIssuesLimit] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreChildIssuesLimit)();
        return childIssuesLimit;
    };
    const $9e67f38435565e11$export$cc6e0a43a2a9b17a = ()=>{
        const [childIssuesIssueLimitUrls] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreChildIssuesIssueLimitUrls)();
        return childIssuesIssueLimitUrls;
    };
    const $9e67f38435565e11$export$65a59acd1ffc5bba = (fieldId)=>{
        const childIssuesIssueLimitUrls = $9e67f38435565e11$export$cc6e0a43a2a9b17a();
        return childIssuesIssueLimitUrls?.[fieldId];
    };
    const $9e67f38435565e11$export$9ce8428ff198804a = ()=>{
        const [isModal] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsModal)();
        return isModal;
    };
    const $9e67f38435565e11$export$22108eca27445997 = ()=>{
        const [issueKey] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueKey)();
        return issueKey;
    };
    const $9e67f38435565e11$export$9df8176b5ffce5ab = ()=>{
        const [issueId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueId)();
        return issueId;
    };
    const $9e67f38435565e11$export$7cd1821433aafaee = ()=>{
        const [isArchived] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsArchived)();
        return isArchived;
    };
    const $9e67f38435565e11$export$b23b36ed5c42e920 = ()=>{
        const [isClassifyEditEnabled] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsClassifyEditEnabled)();
        return isClassifyEditEnabled;
    };
    const $9e67f38435565e11$export$f87be37f8e8be65 = ()=>{
        const [issueKey] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueKey)();
        return (0, (0, parcelRequire("g5X3G")).toProjectKey)(issueKey.split('-')[0]);
    };
    const $9e67f38435565e11$export$aad3917152559b87 = ()=>{
        const [analyticsSource] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreAnalyticsSource)();
        return analyticsSource;
    };
    const $9e67f38435565e11$export$d6ec1293313f49ac = ()=>{
        const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreActions)();
        const actions = (0, $5uXOq.useMemo)(()=>({
                setIssueContext: setIssueContext,
                mergeIssueContext: mergeIssueContext,
                getChildIssuesLimit: getChildIssuesLimit,
                getMaxTokenLength: getMaxTokenLength,
                getIsLoadedWithPage: getIsLoadedWithPage,
                getBackButtonUrl: getBackButtonUrl,
                getIsSpaEnabled: getIsSpaEnabled,
                getIssueKey: getIssueKey,
                setDetailViewAsModal: setDetailViewAsModal,
                setDetailViewAsSidebar: setDetailViewAsSidebar,
                resetDetailView: resetDetailView
            }), [
            setIssueContext,
            mergeIssueContext,
            getChildIssuesLimit,
            getMaxTokenLength,
            getIsLoadedWithPage,
            getBackButtonUrl,
            getIsSpaEnabled,
            getIssueKey,
            setDetailViewAsModal,
            setDetailViewAsSidebar,
            resetDetailView
        ]);
        return [
            undefined,
            actions
        ];
    };
    const $9e67f38435565e11$export$4d204e800e4e0be7 = ()=>{
        const [rapidViewMap] = (0, (0, parcelRequire("koiRX")).useIssueContextRapidViewMap)();
        return rapidViewMap;
    };
    const $9e67f38435565e11$export$e0d7666ae716c88a = ()=>{
        const [maxTokenLength] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreMaxTokenLength)();
        return maxTokenLength;
    };
    const $9e67f38435565e11$export$b4199f923267161e = ()=>{
        const [isLoadedWithPage] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsLoadedWithPage)();
        return isLoadedWithPage;
    };
    const $9e67f38435565e11$export$5b20e30ee6db56e9 = ()=>{
        const [estimationStatistic] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreEstimationStatistic)();
        return estimationStatistic;
    };
    const $9e67f38435565e11$export$4dface15d86304a4 = ()=>{
        const [isLoading] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsLoading)();
        return isLoading;
    };
    const $9e67f38435565e11$export$3a7c3e259b6adb93 = ()=>{
        const [viewMode] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreViewMode)();
        return viewMode;
    };
    const $9e67f38435565e11$export$cfe64a334903927c = ()=>{
        const [backButtonUrl] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreBackButtonUrl)();
        return backButtonUrl;
    };
    const $9e67f38435565e11$export$aa008a00bae7e7ab = ()=>{
        const [issueNavigatorData] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueNavigatorData)();
        return issueNavigatorData;
    };
    const $9e67f38435565e11$export$b49754504c41149f = ()=>{
        const [boardId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreBoardId)();
        return boardId;
    };
    const $9e67f38435565e11$export$91aab984882a2a2c = ()=>{
        const [boardType] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreBoardType)();
        return boardType;
    };
    const $9e67f38435565e11$export$dbad9dbd4871f2e9 = ()=>{
        const [isSpaEnabled] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsSpaEnabled)();
        return isSpaEnabled;
    };
    const $9e67f38435565e11$export$7be495880d433ab9 = ()=>{
        const [loginRedirectUrl] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreLoginRedirctUrl)();
        return loginRedirectUrl;
    };
    const $9e67f38435565e11$export$52c975cf0b623556 = ()=>{
        const [onIssueKeyChange] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreOnIssueKeyChange)();
        return onIssueKeyChange;
    };
    const $9e67f38435565e11$export$b34d0ea0bf41fee = ()=>{
        const [rapidViewId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreRapidViewId)();
        return rapidViewId;
    };
    const $9e67f38435565e11$export$7c142b5701b4c3f9 = ()=>{
        const [viewScreenId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreViewScreenId)();
        return viewScreenId;
    };
    const $9e67f38435565e11$export$dcc0d1c3cd4bd9fb = ()=>{
        const licensedProducts = (0, (0, parcelRequire("hqBSi")).useLicensedProducts)();
        const licenseStates = (0, (0, parcelRequire("7trqb")).useLicenseStates)();
        const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, (0, parcelRequire("ef5Xn")).LICENSE_STATE_ACTIVE);
        return licensedProducts[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
    };
    const $9e67f38435565e11$export$2e131fc4108f9106 = ()=>{
        const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
        return analyticsSource === (0, $fcf97b7a09088940$export$b19f949fb9713614);
    };
    const $9e67f38435565e11$export$4596c26005fbb859 = ()=>{
        const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
        return analyticsSource === (0, $fcf97b7a09088940$export$a5132300c5214280);
    };
    const $9e67f38435565e11$export$db5174c7538abe4b = ()=>{
        const [isAiEnabledForIssue] = (0, (0, parcelRequire("koiRX")).useIssueContextIsAiEnabledForIssue)();
        return isAiEnabledForIssue;
    };
    const $9e67f38435565e11$export$cf5fc815f761fb4b = ()=>{
        const issueKey = $9e67f38435565e11$export$22108eca27445997();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        return [
            (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT),
            (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
        ].some((type)=>type === projectType);
    };
    const $9e67f38435565e11$var$useIsAiOptInEnabledOld = ()=>{
        const [isAiOptInEnabled] = (0, (0, parcelRequire("koiRX")).useIssueContextIsAiOptInEnabled)();
        return isAiOptInEnabled;
    };
    const $9e67f38435565e11$export$b131d9f6da853161 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>{
        return (0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('issue.details.gira-agg-consistency-check-master-flag', 'OLD', [
            'OLD',
            'NEW',
            'CHECK',
            'CHECK_RETURN_NEW'
        ]) === 'NEW';
    }, $9e67f38435565e11$export$db5174c7538abe4b, $9e67f38435565e11$var$useIsAiOptInEnabledOld);
});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
parcelRegister("7trqb", function(module, exports) {
    $parcel$export(module.exports, "useLicenseStates", ()=>$5fcaa3f734e9c444$export$268651a63abe408a);
    var $9OXo1;
    const $5fcaa3f734e9c444$export$268651a63abe408a = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.licenseStates;
    };
});
parcelRegister("hqBSi", function(module, exports) {
    $parcel$export(module.exports, "useLicensedProducts", ()=>$7564850c0894983d$export$54d534cc91e54850);
    var $9OXo1;
    const $7564850c0894983d$export$54d534cc91e54850 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.licensedProducts || {};
    };
});
parcelRegister("koiRX", function(module, exports) {
    $parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", ()=>$35da250daae5206d$export$abdbea56d86b4aac);
    $parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", ()=>$35da250daae5206d$export$326ff2b963d51c5c);
    $parcel$export(module.exports, "useIssueContextStoreIssueKey", ()=>$35da250daae5206d$export$44bcaaabb74e402b);
    $parcel$export(module.exports, "useIssueContextStoreIssueId", ()=>$35da250daae5206d$export$332dcee0cf9f4e45);
    $parcel$export(module.exports, "useIssueContextStoreIsArchived", ()=>$35da250daae5206d$export$c940355b1fc6e1c4);
    $parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", ()=>$35da250daae5206d$export$b9eebaa1da421997);
    $parcel$export(module.exports, "useIssueContextStoreIsModal", ()=>$35da250daae5206d$export$daa47fd600e43a32);
    $parcel$export(module.exports, "useIssueContextStoreViewScreenId", ()=>$35da250daae5206d$export$ba2e9546ab5ba6f);
    $parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", ()=>$35da250daae5206d$export$74d38d6c437efc1b);
    $parcel$export(module.exports, "useIssueContextRapidViewMap", ()=>$35da250daae5206d$export$2092528ee170d9e7);
    $parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", ()=>$35da250daae5206d$export$57898374e6239a5a);
    $parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", ()=>$35da250daae5206d$export$ff0264ec4c015dc1);
    $parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", ()=>$35da250daae5206d$export$6c8b81f6dca8c23d);
    $parcel$export(module.exports, "useIssueContextStoreIsLoading", ()=>$35da250daae5206d$export$fe7085456138f0fc);
    $parcel$export(module.exports, "useIssueContextStoreViewMode", ()=>$35da250daae5206d$export$c339e36468c12443);
    $parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", ()=>$35da250daae5206d$export$ef3bfa2642bb98cd);
    $parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", ()=>$35da250daae5206d$export$8accd063c74cd455);
    $parcel$export(module.exports, "useIssueContextStoreBoardId", ()=>$35da250daae5206d$export$e7edffc2a20027e7);
    $parcel$export(module.exports, "useIssueContextStoreBoardType", ()=>$35da250daae5206d$export$48aaa3a6bc2085d7);
    $parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", ()=>$35da250daae5206d$export$4a4b96bcf5166327);
    $parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", ()=>$35da250daae5206d$export$bbd8ba0180545556);
    $parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", ()=>$35da250daae5206d$export$aaa89627762c7d00);
    $parcel$export(module.exports, "useIssueContextStoreRapidViewId", ()=>$35da250daae5206d$export$796589b0ec52848a);
    $parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", ()=>$35da250daae5206d$export$7e70ee570119a0a7);
    $parcel$export(module.exports, "useIssueContextIsAiEnabledForIssue", ()=>$35da250daae5206d$export$455ae7fd9d68b157);
    $parcel$export(module.exports, "IssueContextContainer", ()=>$35da250daae5206d$export$93db6a8f3342dddf);
    $parcel$export(module.exports, "useIssueContextStoreActions", ()=>$35da250daae5206d$export$965360ae27fcae98);
    var $g5X3G;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $fMAcJ;
    var $iElCl;
    var $edJtc;
    const $35da250daae5206d$export$d4c72bab9d6cc13a = {
        childIssuesLimit: undefined,
        childIssuesIssueLimitUrls: undefined,
        issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(''),
        isArchived: false,
        isClassifyEditEnabled: false,
        isModal: false,
        maxTokenLength: 0,
        isLoadedWithPage: false,
        rapidViewMap: undefined,
        estimationStatistic: undefined,
        isLoading: false,
        viewMode: (0, (0, parcelRequire("edJtc")).getViewModeFromLocalStorage)(),
        analyticsSource: undefined,
        backButtonUrl: undefined,
        issueNavigatorData: undefined,
        boardId: undefined,
        boardType: undefined,
        isSpaEnabled: false,
        loginRedirectUrl: undefined,
        onIssueKeyChange: undefined,
        rapidViewId: undefined,
        viewScreenId: undefined,
        isAiOptInEnabled: false,
        isAiEnabledForIssue: false
    };
    const $35da250daae5206d$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-context',
        initialState: $35da250daae5206d$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("fMAcJ")).actions
    });
    const $35da250daae5206d$var$getIssueContext = (state)=>state;
    const $35da250daae5206d$var$getIsModal = (state)=>state.isModal;
    const $35da250daae5206d$var$getIssueKey = (state)=>state.issueKey;
    const $35da250daae5206d$var$getIsArchived = (state)=>state.isArchived;
    const $35da250daae5206d$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
    const $35da250daae5206d$var$getIssueId = (state)=>state.issueId;
    const $35da250daae5206d$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
    const $35da250daae5206d$var$getRapidViewMap = (state)=>state.rapidViewMap;
    const $35da250daae5206d$var$getMaxTokenLength = (state)=>state.maxTokenLength;
    const $35da250daae5206d$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
    const $35da250daae5206d$var$getEstimationStatistic = (state)=>state.estimationStatistic;
    const $35da250daae5206d$var$getIsLoading = (state)=>state.isLoading;
    const $35da250daae5206d$var$getViewMode = (state)=>state.viewMode;
    const $35da250daae5206d$var$getBackButtonUrl = (state)=>state.backButtonUrl;
    const $35da250daae5206d$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
    const $35da250daae5206d$var$getBoardId = (state)=>state.boardId;
    const $35da250daae5206d$var$getBoardType = (state)=>state.boardType;
    const $35da250daae5206d$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
    const $35da250daae5206d$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
    const $35da250daae5206d$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
    const $35da250daae5206d$var$getRapidViewId = (state)=>state.rapidViewId;
    const $35da250daae5206d$var$getViewScreenId = (state)=>state.viewScreenId;
    const $35da250daae5206d$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
    const $35da250daae5206d$var$getisAiEnabledForIssue = (state)=>Boolean(state.isAiEnabledForIssue);
    const $35da250daae5206d$export$f6e0a3ee03299fbc = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueContext
    });
    const $35da250daae5206d$export$abdbea56d86b4aac = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("iElCl")).getChildIssuesLimit)
    });
    const $35da250daae5206d$export$326ff2b963d51c5c = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("iElCl")).getChildIssuesIssueLimitUrls)
    });
    const $35da250daae5206d$export$44bcaaabb74e402b = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueKey
    });
    const $35da250daae5206d$export$332dcee0cf9f4e45 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueId
    });
    const $35da250daae5206d$export$c940355b1fc6e1c4 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsArchived
    });
    const $35da250daae5206d$export$b9eebaa1da421997 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsClassifyEditEnabled
    });
    const $35da250daae5206d$export$daa47fd600e43a32 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsModal
    });
    const $35da250daae5206d$export$ba2e9546ab5ba6f = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getViewScreenId
    });
    const $35da250daae5206d$export$74d38d6c437efc1b = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getAnalyticsSource
    });
    const $35da250daae5206d$export$2092528ee170d9e7 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getRapidViewMap
    });
    const $35da250daae5206d$export$57898374e6239a5a = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getMaxTokenLength
    });
    const $35da250daae5206d$export$ff0264ec4c015dc1 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsLoadedWithPage
    });
    const $35da250daae5206d$export$6c8b81f6dca8c23d = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getEstimationStatistic
    });
    const $35da250daae5206d$export$fe7085456138f0fc = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsLoading
    });
    const $35da250daae5206d$export$c339e36468c12443 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getViewMode
    });
    const $35da250daae5206d$export$ef3bfa2642bb98cd = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getBackButtonUrl
    });
    const $35da250daae5206d$export$8accd063c74cd455 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueNavigatorData
    });
    const $35da250daae5206d$export$e7edffc2a20027e7 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getBoardId
    });
    const $35da250daae5206d$export$48aaa3a6bc2085d7 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getBoardType
    });
    const $35da250daae5206d$export$4a4b96bcf5166327 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsSpaEnabled
    });
    const $35da250daae5206d$export$bbd8ba0180545556 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getLoginRedirectUrl
    });
    const $35da250daae5206d$export$aaa89627762c7d00 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getOnIssueKeyChange
    });
    const $35da250daae5206d$export$796589b0ec52848a = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getRapidViewId
    });
    const $35da250daae5206d$export$7e70ee570119a0a7 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsAiOptInEnabled
    });
    const $35da250daae5206d$export$455ae7fd9d68b157 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getisAiEnabledForIssue
    });
    const $35da250daae5206d$export$93db6a8f3342dddf = (0, (0, parcelRequire("gg7kZ")).createContainer)($35da250daae5206d$export$6f57813fe9f31bf9);
    const $35da250daae5206d$export$965360ae27fcae98 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: null
    });
});
parcelRegister("fMAcJ", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$043cabfbcc6107f0$export$e324594224ef24da);
    var $7l48d;
    var $iElCl;
    var $edJtc;
    const $043cabfbcc6107f0$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
            const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
            if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
                ...issueContext,
                issueId: undefined,
                viewMode: issueContext.viewMode || getState().viewMode
            });
            else setState({
                ...issueContext,
                viewMode: issueContext.viewMode || getState().viewMode
            });
        };
    const $043cabfbcc6107f0$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
            const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
            if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
                ...getState(),
                ...partialIssueContext,
                issueId: undefined
            });
            else setState({
                ...getState(),
                ...partialIssueContext
            });
        };
    const $043cabfbcc6107f0$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, (0, parcelRequire("iElCl")).getChildIssuesLimit)(getState());
    const $043cabfbcc6107f0$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
    const $043cabfbcc6107f0$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
    const $043cabfbcc6107f0$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
    const $043cabfbcc6107f0$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
    const $043cabfbcc6107f0$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
    const $043cabfbcc6107f0$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
    const $043cabfbcc6107f0$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
            if (willSave) (0, (0, parcelRequire("7l48d")).localStorage).set((0, (0, parcelRequire("7l48d")).VIEW_MODE_STORAGE_KEY), 'MODAL');
            setState({
                viewMode: 'MODAL'
            });
        };
    const $043cabfbcc6107f0$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
            if (willSave) (0, (0, parcelRequire("7l48d")).localStorage).set((0, (0, parcelRequire("7l48d")).VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
            setState({
                viewMode: 'SIDEBAR'
            });
        };
    const $043cabfbcc6107f0$export$75007d125f198b78 = ()=>({ setState: setState })=>{
            setState({
                viewMode: (0, (0, parcelRequire("edJtc")).getViewModeFromLocalStorage)()
            });
        };
    const $043cabfbcc6107f0$export$e324594224ef24da = {
        setIssueContext: $043cabfbcc6107f0$export$784a03c4b74da53e,
        mergeIssueContext: $043cabfbcc6107f0$export$666ee48e0eaf4f13,
        getChildIssuesLimit: $043cabfbcc6107f0$export$89b6937a83edcaa6,
        getMaxTokenLength: $043cabfbcc6107f0$export$e40f2acaf1a50b00,
        getIsLoadedWithPage: $043cabfbcc6107f0$export$2fe981b90be13483,
        getBackButtonUrl: $043cabfbcc6107f0$export$afce556782490aae,
        getIsSpaEnabled: $043cabfbcc6107f0$export$711dfa096bf81f2d,
        getIssueKey: $043cabfbcc6107f0$export$4a030f6192bebe03,
        getIsArchived: $043cabfbcc6107f0$export$b41341ac6c74ca6,
        setDetailViewAsModal: $043cabfbcc6107f0$export$77ec0de2f63f10c4,
        setDetailViewAsSidebar: $043cabfbcc6107f0$export$b303af51de56a0e,
        resetDetailView: $043cabfbcc6107f0$export$75007d125f198b78
    };
});
parcelRegister("7l48d", function(module, exports) {
    $parcel$export(module.exports, "LOG_LOCATION", ()=>$e736233a6ed098e3$export$25a759e49d5049db);
    $parcel$export(module.exports, "localStorage", ()=>$e736233a6ed098e3$export$c2ed3351cac403d1);
    $parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", ()=>$e736233a6ed098e3$export$a13f7f627010bccd);
    var $bSSG7;
    const $e736233a6ed098e3$export$25a759e49d5049db = 'issue.issue-context-service';
    const $e736233a6ed098e3$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira_issue_view');
    const $e736233a6ed098e3$export$a13f7f627010bccd = 'view-mode';
});
parcelRegister("iElCl", function(module, exports) {
    $parcel$export(module.exports, "getChildIssuesLimit", ()=>$fde75c94a28741e3$export$89b6937a83edcaa6);
    $parcel$export(module.exports, "getChildIssuesIssueLimitUrls", ()=>$fde75c94a28741e3$export$8f43520910e8128c);
    var $dJl1T;
    var $7l48d;
    const $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
    const $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(`${(0, (0, parcelRequire("7l48d")).LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
        return $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT;
    };
    const $fde75c94a28741e3$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
    const $fde75c94a28741e3$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;
});
parcelRegister("edJtc", function(module, exports) {
    $parcel$export(module.exports, "getViewModeFromLocalStorage", ()=>$75ce4ce78f606e67$export$cae7c4c591dcc261);
    var $7l48d;
    const $75ce4ce78f606e67$export$cae7c4c591dcc261 = ()=>(0, (0, parcelRequire("7l48d")).localStorage).get((0, (0, parcelRequire("7l48d")).VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
});
parcelRegister("aQLD7", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$0ebe24e18a9cec5a$export$d4c72bab9d6cc13a);
    $parcel$export(module.exports, "actions", ()=>$0ebe24e18a9cec5a$export$e324594224ef24da);
    var $gVnoy;
    var $idTx8;
    var $bvqNo;
    const $0ebe24e18a9cec5a$export$d4c72bab9d6cc13a = {
        confluenceData: {
            contentId: '',
            contentUrl: '',
            contentData: null,
            mode: (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            isDraft: false,
            isLive: false
        },
        contentActions: {},
        contentType: (0, (0, parcelRequire("bvqNo")).ConfluenceContentTypes).PAGE,
        embeddedConfluenceSource: '',
        displayType: (0, (0, parcelRequire("bvqNo")).DisplayTypes).PANEL,
        panel: {
            initialWidth: 0,
            isOpen: false,
            isLoading: false,
            isExpanded: false
        },
        modal: {
            isOpen: false
        }
    };
    const $0ebe24e18a9cec5a$export$aa5d06fef96639ba = ({ contentId: contentId, contentType: contentType, embeddedConfluenceSource: embeddedConfluenceSource, data: data, displayType: displayType, initialWidth: initialWidth, hostname: hostname, isDraft: isDraft, isLive: isLive, isExpanded: isExpanded, mode: mode, onLinkPage: onLinkPage, onPublish: onPublish, shouldOpenModal: shouldOpenModal, url: url, title: title })=>({ setState: setState })=>{
            setState({
                confluenceData: {
                    contentId: contentId,
                    contentUrl: url,
                    contentData: data,
                    hostname: hostname,
                    mode: mode,
                    isDraft: isDraft,
                    isLive: isLive,
                    title: title,
                    spaceKey: (0, (0, parcelRequire("idTx8")).parseUrl)(url)?.spaceKey
                },
                contentActions: {
                    onLinkPage: onLinkPage,
                    onPublish: onPublish
                },
                embeddedConfluenceSource: embeddedConfluenceSource,
                contentType: contentType,
                displayType: displayType,
                panel: {
                    initialWidth: initialWidth,
                    isOpen: !shouldOpenModal,
                    isExpanded: isExpanded
                },
                modal: {
                    isOpen: shouldOpenModal
                }
            });
        };
    const $0ebe24e18a9cec5a$export$e81b26ab493ca52a = ()=>({ setState: setState })=>{
            setState($0ebe24e18a9cec5a$export$d4c72bab9d6cc13a);
        };
    const $0ebe24e18a9cec5a$export$473e6cac57a0d506 = (deferredSpaceName, deferredSpaceKey)=>({ setState: setState, getState: getState })=>{
            const { confluenceData: confluenceData, ...prevState } = getState();
            setState({
                confluenceData: {
                    ...confluenceData,
                    deferredSpaceName: deferredSpaceName,
                    spaceKey: deferredSpaceKey || confluenceData.spaceKey
                },
                ...prevState
            });
        };
    const $0ebe24e18a9cec5a$export$db9852cd4946540a = ({ isLoading: isLoading, isDeferSpaceSelection: isDeferSpaceSelection })=>({ setState: setState, getState: getState })=>{
            const { panel: panel, ...prevState } = getState();
            setState({
                ...prevState,
                isDeferSpaceSelection: isDeferSpaceSelection,
                panel: {
                    ...panel,
                    isLoading: isLoading
                }
            });
        };
    const $0ebe24e18a9cec5a$export$b29d56f843007f2b = ()=>({ setState: setState, getState: getState })=>{
            const { panel: panel, ...prevState } = getState();
            const isCurrentlyExpanded = panel.isExpanded;
            setState({
                panel: {
                    ...panel,
                    isExpanded: !isCurrentlyExpanded
                },
                ...prevState
            });
        };
    const $0ebe24e18a9cec5a$export$5d0561abb73760f = ({ newIsDraftState: newIsDraftState })=>({ setState: setState, getState: getState })=>{
            const { confluenceData: confluenceData, ...prevState } = getState();
            setState({
                confluenceData: {
                    ...confluenceData,
                    isDraft: newIsDraftState
                },
                ...prevState
            });
        };
    const $0ebe24e18a9cec5a$export$1a8782a287467f35 = (newData)=>({ setState: setState, getState: getState })=>{
            const { confluenceData: confluenceData, ...prevState } = getState();
            setState({
                confluenceData: {
                    ...confluenceData,
                    ...newData
                },
                ...prevState
            });
        };
    const $0ebe24e18a9cec5a$export$e324594224ef24da = {
        closeSidePanel: $0ebe24e18a9cec5a$export$e81b26ab493ca52a,
        openSidePanel: $0ebe24e18a9cec5a$export$aa5d06fef96639ba,
        setDeferredSpaceData: $0ebe24e18a9cec5a$export$473e6cac57a0d506,
        setIsDraftState: $0ebe24e18a9cec5a$export$5d0561abb73760f,
        setIsLoadingForDeferSpaceSelection: $0ebe24e18a9cec5a$export$db9852cd4946540a,
        toggleExpandedState: $0ebe24e18a9cec5a$export$b29d56f843007f2b,
        setConfluenceData: $0ebe24e18a9cec5a$export$1a8782a287467f35
    };
});
parcelRegister("gVnoy", function(module, exports) {
    $parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", ()=>$7526d97b8e22777b$export$816ef638e478449a);
    var $7526d97b8e22777b$export$816ef638e478449a;
    (function(EMBEDDED_CONFLUENCE_MODE) {
        EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
        EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    })($7526d97b8e22777b$export$816ef638e478449a || ($7526d97b8e22777b$export$816ef638e478449a = {}));
});
parcelRegister("idTx8", function(module, exports) {
    $parcel$export(module.exports, "parsePageProps", ()=>$0293942286a77e0f$export$41eb0a358b69a9df);
    $parcel$export(module.exports, "parseUrl", ()=>$0293942286a77e0f$export$7a5253c0f62e0150);
    var $6vAaw = parcelRequire("6vAaw");
    var $70VoX;
    var $imVhc;
    var $39itI;
    var $gVnoy;
    var $jFSxp;
    function $0293942286a77e0f$export$41eb0a358b69a9df(props) {
        let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, ...passThroughProps } = props;
        const parsedAllowedFeatures = $0293942286a77e0f$export$350c411f568eceb9(allowedFeatures);
        if (!url) return {
            contentId: contentId,
            hostname: hostname,
            parentProduct: parentProduct,
            spaceKey: spaceKey,
            protocol: 'https:',
            mode: mode ?? (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            allowedFeatures: parsedAllowedFeatures,
            draftShareId: draftShareId,
            hash: hash,
            themeState: themeState,
            ...passThroughProps
        };
        const parsedProps = $0293942286a77e0f$export$7a5253c0f62e0150(url);
        if (!parsedProps) return {
            hostname: hostname,
            contentId: contentId,
            spaceKey: spaceKey,
            parentProduct: parentProduct,
            mode: mode,
            protocol: 'https:',
            allowedFeatures: parsedAllowedFeatures,
            draftShareId: draftShareId,
            hash: hash,
            themeState: themeState,
            ...passThroughProps
        };
        const themeStateParsedObject = parsedProps.themeState ? (0, (0, parcelRequire("imVhc")).themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
        contentId = contentId || parsedProps.contentId;
        parentProduct = parentProduct || parsedProps.parentProduct;
        hostname = hostname || parsedProps.hostname || window.location.hostname;
        spaceKey = spaceKey || parsedProps.spaceKey;
        draftShareId = draftShareId || parsedProps.draftShareId;
        hash = hash || parsedProps.hash;
        themeState = themeState || themeStateParsedObject;
        let modeFromUrl;
        switch(parsedProps.route){
            case (0, (0, parcelRequire("jFSxp")).VIEW_PAGE).name:
            case (0, (0, parcelRequire("jFSxp")).VIEW_BLOG).name:
            case (0, (0, parcelRequire("jFSxp")).VIEW_BLOG_DATE_LEGACY).name:
                modeFromUrl = (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
                break;
            case (0, (0, parcelRequire("jFSxp")).EDIT_PAGE_EMBED).name:
            case (0, (0, parcelRequire("jFSxp")).EDIT_PAGE_V2).name:
                modeFromUrl = (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
        }
        return {
            allowedFeatures: $0293942286a77e0f$export$350c411f568eceb9(allowedFeatures),
            contentId: contentId,
            draftShareId: draftShareId,
            hash: hash,
            hostname: hostname,
            mode: mode || modeFromUrl,
            parentProduct: parentProduct,
            protocol: parsedProps.protocol,
            spaceKey: spaceKey,
            themeState: themeState,
            ...passThroughProps
        };
    }
    function $0293942286a77e0f$export$7a5253c0f62e0150(url) {
        if (!url) return null;
        const matchedRoute = $0293942286a77e0f$var$findAndMatchRoute((0, (0, parcelRequire("jFSxp")).namedRoutes), url);
        if (!matchedRoute) return null;
        const { routeName: routeName, ...match } = matchedRoute;
        return {
            route: routeName,
            hostname: match.host,
            protocol: match.protocol,
            contentId: match.params.contentId || '',
            spaceKey: match.params.spaceKey || '',
            hash: match.hash,
            parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
            draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
            themeState: match.query.themeState
        };
    }
    function $0293942286a77e0f$var$findAndMatchRoute(routes, url) {
        for (const routeName of Object.keys(routes)){
            const pattern = routes[routeName].pattern;
            const match = $0293942286a77e0f$var$matchUrl(pattern, url);
            if (match) return {
                routeName: routeName,
                ...match
            };
        }
    }
    function $0293942286a77e0f$var$matchUrl(pattern, url) {
        const parsed = (0, ($parcel$interopDefault($6vAaw))).parse(url, true);
        const pathname = parsed.pathname || '';
        let match = (0, (0, parcelRequire("70VoX")).default)(pathname, {
            path: pattern,
            exact: true
        });
        if (!match) match = (0, (0, parcelRequire("70VoX")).default)(`${pathname}${parsed.search}`, {
            path: pattern,
            exact: true
        });
        if (!match) return null;
        const decodedParams = {};
        if (match && match.params) for (const [key, value] of Object.entries(match.params))decodedParams[key] = value;
        return {
            url: url,
            protocol: parsed?.protocol || 'https:',
            host: parsed?.host || '',
            pathname: pathname,
            search: parsed.search || '',
            hash: parsed.hash || '',
            pattern: pattern,
            params: decodedParams,
            query: parsed.query || ''
        };
    }
    function $0293942286a77e0f$export$350c411f568eceb9(allowedFeatures) {
        let parsedAllowedFeatures = {
            view: allowedFeatures?.view,
            edit: allowedFeatures?.edit
        };
        if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
            ...(0, (0, parcelRequire("39itI")).DEFAULT_ALLOWED_FEATURES).view,
            'edit'
        ];
        else if (Array.isArray(allowedFeatures?.view)) parsedAllowedFeatures.view = [
            ...allowedFeatures?.view,
            'edit'
        ];
        return parsedAllowedFeatures;
    }
});
parcelRegister("70VoX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51b50f39010f1f0a$export$2e2bcd8739ae039);
    var $d4Ora = parcelRequire("d4Ora");
    var $51b50f39010f1f0a$var$patternCache = {};
    var $51b50f39010f1f0a$var$cacheLimit = 10000;
    var $51b50f39010f1f0a$var$cacheCount = 0;
    var $51b50f39010f1f0a$var$compilePath = function compilePath(pattern, options) {
        var cacheKey = "" + options.end + options.strict + options.sensitive;
        var cache = $51b50f39010f1f0a$var$patternCache[cacheKey] || ($51b50f39010f1f0a$var$patternCache[cacheKey] = {});
        if (cache[pattern]) return cache[pattern];
        var keys = [];
        var re = (0, ($parcel$interopDefault($d4Ora)))(pattern, keys, options);
        var compiledPattern = {
            re: re,
            keys: keys
        };
        if ($51b50f39010f1f0a$var$cacheCount < $51b50f39010f1f0a$var$cacheLimit) {
            cache[pattern] = compiledPattern;
            $51b50f39010f1f0a$var$cacheCount++;
        }
        return compiledPattern;
    };
    var $51b50f39010f1f0a$var$matchPath = function matchPath(pathname) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var parent = arguments[2];
        if (typeof options === "string") options = {
            path: options
        };
        var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
        if (path == null) return parent;
        var _compilePath = $51b50f39010f1f0a$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), re = _compilePath.re, keys = _compilePath.keys;
        var match = re.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            url: path === "/" && url === "" ? "/" : url,
            isExact: isExact,
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    };
    var $51b50f39010f1f0a$export$2e2bcd8739ae039 = $51b50f39010f1f0a$var$matchPath;
});
parcelRegister("d4Ora", function(module, exports) {
    var $oJ7gO = parcelRequire("oJ7gO");
    module.exports = $9852c5da38ba91d1$var$pathToRegexp;
    module.exports.parse = $9852c5da38ba91d1$var$parse;
    module.exports.compile = $9852c5da38ba91d1$var$compile;
    module.exports.tokensToFunction = $9852c5da38ba91d1$var$tokensToFunction;
    module.exports.tokensToRegExp = $9852c5da38ba91d1$var$tokensToRegExp;
    var $9852c5da38ba91d1$var$PATH_REGEXP = new RegExp([
        '(\\\\.)',
        '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
    ].join('|'), 'g');
    function $9852c5da38ba91d1$var$parse(str, options) {
        var tokens = [];
        var key = 0;
        var index = 0;
        var path = '';
        var defaultDelimiter = options && options.delimiter || '/';
        var res;
        while((res = $9852c5da38ba91d1$var$PATH_REGEXP.exec(str)) != null){
            var m = res[0];
            var escaped = res[1];
            var offset = res.index;
            path += str.slice(index, offset);
            index = offset + m.length;
            if (escaped) {
                path += escaped[1];
                continue;
            }
            var next = str[index];
            var prefix = res[2];
            var name = res[3];
            var capture = res[4];
            var group = res[5];
            var modifier = res[6];
            var asterisk = res[7];
            if (path) {
                tokens.push(path);
                path = '';
            }
            var partial = prefix != null && next != null && next !== prefix;
            var repeat = modifier === '+' || modifier === '*';
            var optional = modifier === '?' || modifier === '*';
            var delimiter = prefix || defaultDelimiter;
            var pattern = capture || group;
            var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
            tokens.push({
                name: name || key++,
                prefix: prefix || '',
                delimiter: delimiter,
                optional: optional,
                repeat: repeat,
                partial: partial,
                asterisk: !!asterisk,
                pattern: pattern ? $9852c5da38ba91d1$var$escapeGroup(pattern) : asterisk ? '.*' : $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText)
            });
        }
        if (index < str.length) path += str.substr(index);
        if (path) tokens.push(path);
        return tokens;
    }
    function $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText) {
        if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + ']+?';
        return $9852c5da38ba91d1$var$escapeString(prevText) + '|(?:(?!' + $9852c5da38ba91d1$var$escapeString(prevText) + ')[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + '])+?';
    }
    function $9852c5da38ba91d1$var$compile(str, options) {
        return $9852c5da38ba91d1$var$tokensToFunction($9852c5da38ba91d1$var$parse(str, options), options);
    }
    function $9852c5da38ba91d1$var$encodeURIComponentPretty(str) {
        return encodeURI(str).replace(/[\/?#]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
    }
    function $9852c5da38ba91d1$var$encodeAsterisk(str) {
        return encodeURI(str).replace(/[?#]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
    }
    function $9852c5da38ba91d1$var$tokensToFunction(tokens, options) {
        var matches = new Array(tokens.length);
        for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $9852c5da38ba91d1$var$flags(options));
        return function(obj, opts) {
            var path = '';
            var data = obj || {};
            var options = opts || {};
            var encode = options.pretty ? $9852c5da38ba91d1$var$encodeURIComponentPretty : encodeURIComponent;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                if (typeof token === 'string') {
                    path += token;
                    continue;
                }
                var value = data[token.name];
                var segment;
                if (value == null) {
                    if (token.optional) {
                        if (token.partial) path += token.prefix;
                        continue;
                    } else throw new TypeError('Expected "' + token.name + '" to be defined');
                }
                if ($oJ7gO(value)) {
                    if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                    if (value.length === 0) {
                        if (token.optional) continue;
                        else throw new TypeError('Expected "' + token.name + '" to not be empty');
                    }
                    for(var j = 0; j < value.length; j++){
                        segment = encode(value[j]);
                        if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                        path += (j === 0 ? token.prefix : token.delimiter) + segment;
                    }
                    continue;
                }
                segment = token.asterisk ? $9852c5da38ba91d1$var$encodeAsterisk(value) : encode(value);
                if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
                path += token.prefix + segment;
            }
            return path;
        };
    }
    function $9852c5da38ba91d1$var$escapeString(str) {
        return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
    }
    function $9852c5da38ba91d1$var$escapeGroup(group) {
        return group.replace(/([=!:$\/()])/g, '\\$1');
    }
    function $9852c5da38ba91d1$var$attachKeys(re, keys) {
        re.keys = keys;
        return re;
    }
    function $9852c5da38ba91d1$var$flags(options) {
        return options && options.sensitive ? '' : 'i';
    }
    function $9852c5da38ba91d1$var$regexpToRegexp(path, keys) {
        var groups = path.source.match(/\((?!\?)/g);
        if (groups) for(var i = 0; i < groups.length; i++)keys.push({
            name: i,
            prefix: null,
            delimiter: null,
            optional: false,
            repeat: false,
            partial: false,
            asterisk: false,
            pattern: null
        });
        return $9852c5da38ba91d1$var$attachKeys(path, keys);
    }
    function $9852c5da38ba91d1$var$arrayToRegexp(path, keys, options) {
        var parts = [];
        for(var i = 0; i < path.length; i++)parts.push($9852c5da38ba91d1$var$pathToRegexp(path[i], keys, options).source);
        var regexp = new RegExp('(?:' + parts.join('|') + ')', $9852c5da38ba91d1$var$flags(options));
        return $9852c5da38ba91d1$var$attachKeys(regexp, keys);
    }
    function $9852c5da38ba91d1$var$stringToRegexp(path, keys, options) {
        return $9852c5da38ba91d1$var$tokensToRegExp($9852c5da38ba91d1$var$parse(path, options), keys, options);
    }
    function $9852c5da38ba91d1$var$tokensToRegExp(tokens, keys, options) {
        if (!$oJ7gO(keys)) {
            options = keys || options;
            keys = [];
        }
        options = options || {};
        var strict = options.strict;
        var end = options.end !== false;
        var route = '';
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') route += $9852c5da38ba91d1$var$escapeString(token);
            else {
                var prefix = $9852c5da38ba91d1$var$escapeString(token.prefix);
                var capture = '(?:' + token.pattern + ')';
                keys.push(token);
                if (token.repeat) capture += '(?:' + prefix + capture + ')*';
                if (token.optional) {
                    if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                    else capture = prefix + '(' + capture + ')?';
                } else capture = prefix + '(' + capture + ')';
                route += capture;
            }
        }
        var delimiter = $9852c5da38ba91d1$var$escapeString(options.delimiter || '/');
        var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
        if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
        if (end) route += '$';
        else route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
        return $9852c5da38ba91d1$var$attachKeys(new RegExp('^' + route, $9852c5da38ba91d1$var$flags(options)), keys);
    }
    function $9852c5da38ba91d1$var$pathToRegexp(path, keys, options) {
        if (!$oJ7gO(keys)) {
            options = keys || options;
            keys = [];
        }
        options = options || {};
        if (path instanceof RegExp) return $9852c5da38ba91d1$var$regexpToRegexp(path, keys);
        if ($oJ7gO(path)) return $9852c5da38ba91d1$var$arrayToRegexp(path, keys, options);
        return $9852c5da38ba91d1$var$stringToRegexp(path, keys, options);
    }
});
parcelRegister("oJ7gO", function(module, exports) {
    module.exports = Array.isArray || function(arr) {
        return Object.prototype.toString.call(arr) == '[object Array]';
    };
});
parcelRegister("39itI", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", ()=>$1f1e6a2159ff566d$export$a33327ada3a6ee4a);
    $parcel$export(module.exports, "getAllowedFeatures", ()=>$1f1e6a2159ff566d$export$3207c60940c4a9b0);
    var $6BeA7;
    var $gVnoy;
    var $1f1e6a2159ff566d$export$241b9888a4d565c9;
    (function(ALLOWED_FEATURES_TYPE) {
        ALLOWED_FEATURES_TYPE["VIEW"] = "view";
        ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
        ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    })($1f1e6a2159ff566d$export$241b9888a4d565c9 || ($1f1e6a2159ff566d$export$241b9888a4d565c9 = {}));
    const $1f1e6a2159ff566d$export$a3fda3dcee62e1cc = {
        view: [
            'byline-contributors',
            'byline-extensions',
            'delete',
            'edit',
            'inline-comments',
            'page-comments',
            'page-reactions',
            'sticky-header',
            'disable-login-flow',
            'disable-share',
            'non-licensed-share'
        ],
        edit: [
            'delete-draft',
            'disable-login-flow',
            'template-browser',
            'inline-comments'
        ],
        whiteboard: [
            'disable-login-flow',
            'copy',
            'favorite',
            'restrictions',
            'more-actions'
        ]
    };
    const $1f1e6a2159ff566d$export$a33327ada3a6ee4a = {
        view: [
            'byline-contributors',
            'byline-extensions',
            'page-comments',
            'page-reactions',
            'inline-comments'
        ],
        edit: [
            'inline-comments'
        ],
        whiteboard: [
            'copy',
            'favorite',
            'restrictions',
            'more-actions'
        ]
    };
    const $1f1e6a2159ff566d$var$pageAllowedFeatures = {
        [(0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.edit,
        [(0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.view
    };
    const $1f1e6a2159ff566d$var$blogPostAllowedFeatures = {
        [(0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.edit,
        [(0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.view
    };
    const $1f1e6a2159ff566d$var$whiteboardAllowedFeatures = {
        [(0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.whiteboard,
        [(0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.whiteboard
    };
    const $1f1e6a2159ff566d$var$contentTypeAllowedFeatures = {
        [(0, (0, parcelRequire("6BeA7")).EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $1f1e6a2159ff566d$var$pageAllowedFeatures,
        [(0, (0, parcelRequire("6BeA7")).EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $1f1e6a2159ff566d$var$blogPostAllowedFeatures,
        [(0, (0, parcelRequire("6BeA7")).EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $1f1e6a2159ff566d$var$whiteboardAllowedFeatures
    };
    const $1f1e6a2159ff566d$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$1f1e6a2159ff566d$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
});
parcelRegister("6BeA7", function(module, exports) {
    $parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", ()=>$c56abe420938ba9a$export$942a5fac9b8c9dc2);
    var $c56abe420938ba9a$export$942a5fac9b8c9dc2;
    (function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
        EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
        EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
        EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    })($c56abe420938ba9a$export$942a5fac9b8c9dc2 || ($c56abe420938ba9a$export$942a5fac9b8c9dc2 = {}));
});
parcelRegister("jFSxp", function(module, exports) {
    $parcel$export(module.exports, "EDIT_PAGE_EMBED", ()=>$6edcdb1ec5605c32$export$e63a462ee45b57cf);
    $parcel$export(module.exports, "EDIT_PAGE_V2", ()=>$6edcdb1ec5605c32$export$7b1285e36c635f1f);
    $parcel$export(module.exports, "VIEW_PAGE", ()=>$6edcdb1ec5605c32$export$9257b5b55c8e2555);
    $parcel$export(module.exports, "VIEW_BLOG", ()=>$6edcdb1ec5605c32$export$91f49e7b30a9d34);
    $parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", ()=>$6edcdb1ec5605c32$export$bd2c9bb170b3681d);
    $parcel$export(module.exports, "namedRoutes", ()=>$6edcdb1ec5605c32$export$d4971375353d0454);
    $parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", ()=>$6edcdb1ec5605c32$export$5c59aa0922e65f1a);
    const $6edcdb1ec5605c32$export$e63a462ee45b57cf = {
        name: 'EDIT_PAGE_EMBED',
        pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-embed/:contentId(\\d+)/:contentSlug?'
    };
    const $6edcdb1ec5605c32$export$7b1285e36c635f1f = {
        name: 'EDIT_PAGE_V2',
        pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-v2/:contentId(\\d+)/:contentSlug?'
    };
    const $6edcdb1ec5605c32$export$65b723bb995d4fb6 = {
        name: 'SPACE_OVERVIEW',
        pattern: '/wiki/spaces/:spaceKey/overview'
    };
    const $6edcdb1ec5605c32$export$9257b5b55c8e2555 = {
        name: 'VIEW_PAGE',
        pattern: '/wiki/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?'
    };
    const $6edcdb1ec5605c32$export$91f49e7b30a9d34 = {
        name: 'VIEW_BLOG',
        pattern: '/wiki/spaces/:spaceKey/blog/:contentId(\\d+)/:contentSlug?'
    };
    const $6edcdb1ec5605c32$export$bd2c9bb170b3681d = {
        name: 'VIEW_BLOG_DATE_LEGACY',
        pattern: '/wiki/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?'
    };
    const $6edcdb1ec5605c32$export$d4971375353d0454 = {
        EDIT_PAGE_EMBED: $6edcdb1ec5605c32$export$e63a462ee45b57cf,
        EDIT_PAGE_V2: $6edcdb1ec5605c32$export$7b1285e36c635f1f,
        SPACE_OVERVIEW: $6edcdb1ec5605c32$export$65b723bb995d4fb6,
        VIEW_PAGE: $6edcdb1ec5605c32$export$9257b5b55c8e2555,
        VIEW_BLOG: $6edcdb1ec5605c32$export$91f49e7b30a9d34,
        VIEW_BLOG_DATE_LEGACY: $6edcdb1ec5605c32$export$bd2c9bb170b3681d
    };
    const $6edcdb1ec5605c32$export$5c59aa0922e65f1a = {
        JSM_PORTAL: 'JSM-Portal',
        JSM: 'JSM',
        JSW: 'JSW',
        JWM: 'JWM'
    };
});
parcelRegister("bvqNo", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceContentTypes", ()=>$ea031aa9e3d5ef89$export$b39616d00ee96d40);
    $parcel$export(module.exports, "DisplayTypes", ()=>$ea031aa9e3d5ef89$export$c294d3f3727c1a0);
    const $ea031aa9e3d5ef89$export$b39616d00ee96d40 = {
        WHITEBOARD: 'whiteboard',
        PAGE: 'page'
    };
    const $ea031aa9e3d5ef89$export$c294d3f3727c1a0 = {
        MODAL: 'modal',
        PANEL: 'panel'
    };
});
parcelRegister("5labn", function(module, exports) {
    $parcel$export(module.exports, "getDisplayInformation", ()=>$e7deee7a3cbc4953$export$ee79869f97207574);
    var $gVnoy;
    var $bvqNo;
    const $e7deee7a3cbc4953$export$37e31995727dc8d7 = 0.5;
    const $e7deee7a3cbc4953$export$ee79869f97207574 = ()=>{
        const screenWidth = window.innerWidth;
        if (screenWidth >= 1024) return {
            initialWidth: screenWidth * $e7deee7a3cbc4953$export$37e31995727dc8d7,
            displayType: (0, (0, parcelRequire("bvqNo")).DisplayTypes).PANEL
        };
        return {
            initialWidth: 0,
            displayType: (0, (0, parcelRequire("bvqNo")).DisplayTypes).MODAL
        };
    };
    const $e7deee7a3cbc4953$export$d41c9cdfa202e9a7 = ({ mode: mode, isDraft: isDraft, contentUrl: contentUrl, spaceKey: spaceKey })=>{
        if (mode === (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) return contentUrl.replace('/pages/', '/pages/edit-embed/');
        if (isDraft) {
            let viewUrl = contentUrl.replace(/draftShareId=[^&]*[&]*/, '');
            const spaceName = viewUrl.match(/\/spaces\/(.*?)\/pages\//);
            if (spaceName) {
                viewUrl = viewUrl.replace('/pages/edit-embed/', '/pages/');
                viewUrl = viewUrl.replace(spaceName[1], spaceKey);
                if (viewUrl.endsWith('&')) viewUrl = viewUrl.slice(0, -1);
                if (viewUrl.endsWith('?')) viewUrl = viewUrl.slice(0, -1);
                return viewUrl;
            }
        }
        return contentUrl.replace('/pages/edit-embed/', '/pages/');
    };
});
parcelRegister("9V9QO", function(module, exports) {
    $parcel$export(module.exports, "useEmbeddedPanelEntryPoint", ()=>$a6b6d10e82ec149e$export$75ef2f025ecbf1de);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $gVnoy;
    var $idTx8;
    var $gXSrH;
    var $7XluA;
    var $4mO32;
    var $4R6GH;
    var $koVbs;
    var $2POIy;
    var $iwjqc;
    var $4TSh0;
    var $fvjUj;
    const $a6b6d10e82ec149e$var$entryPointParams = {};
    const $a6b6d10e82ec149e$export$75ef2f025ecbf1de = ()=>{
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const [state, actions] = (0, (0, parcelRequire("gXSrH")).useEmbeddedConfluenceSidePanel)();
        const { contentType: contentType, confluenceData: { contentId: contentId, contentUrl: contentUrl, hostname: hostname, isLive: isLive, isDraft: isDraft, title: title, mode: mode }, isDeferSpaceSelection: isDeferSpaceSelection, contentActions: { onLinkPage: onLinkPage }, panel: { isOpen: isOpen }, embeddedConfluenceSource: embeddedConfluenceSource } = state;
        const parentProduct = (0, (0, parcelRequire("fvjUj")).useParentProduct)();
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("2POIy")).embeddedPanelEntrypoint), $a6b6d10e82ec149e$var$entryPointParams);
        const embeddedConfluenceSourceForPanel = `${embeddedConfluenceSource}Panel`;
        const fireAnalyticsEvent = (0, (0, parcelRequire("4TSh0")).useEmbeddedPageTracking)();
        const themeState = (0, (0, parcelRequire("hxoiH")).default)();
        const contentHostname = (0, (0, parcelRequire("iwjqc")).setHostnameForContent)(contentUrl, hostname);
        const onContentAction = (0, $5uXOq.useCallback)((action, eventName)=>{
            fireAnalyticsEvent({
                action: action,
                eventName: eventName,
                embeddedConfluenceSource: embeddedConfluenceSourceForPanel
            });
            if (isOpen && (0, (0, parcelRequire("4R6GH")).fg)('jira_issue_view_expand_modeless_ep')) {
                if (eventName === 'edit-page/close') actions.setConfluenceData({
                    contentUrl: contentUrl,
                    mode: (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
                });
                if (eventName === 'edit-page/load' && action === 'taskSuccess') {
                    if (mode === (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) actions.setConfluenceData({
                        contentUrl: contentUrl,
                        mode: (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).EDIT_MODE
                    });
                }
            }
        }, [
            actions,
            contentUrl,
            fireAnalyticsEvent,
            embeddedConfluenceSourceForPanel,
            isOpen,
            mode
        ]);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            fireAnalyticsEvent({
                action: 'clicked',
                eventName: 'closeEmbeddedConfluencePanel',
                embeddedConfluenceSource: embeddedConfluenceSourceForPanel
            });
            entryPointActions.unload();
            actions.closeSidePanel();
        }, [
            actions,
            fireAnalyticsEvent,
            entryPointActions,
            embeddedConfluenceSourceForPanel
        ]);
        const editAllowedFeatures = (0, $5uXOq.useMemo)(()=>[
                ...isDeferSpaceSelection ? [
                    'publish-modal'
                ] : [],
                'template-browser'
            ], [
            isDeferSpaceSelection
        ]);
        const shouldApplyEditFeatures = editAllowedFeatures.length > 0 && isDraft;
        const shouldOpenPanel = isOpen && contentUrl;
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                locale: locale,
                hasFooterLogo: false,
                isDraft: isDraft,
                isLive: isLive,
                hostname: contentHostname,
                panelTitle: title,
                navigationPolicy: undefined,
                onClose: onClose,
                onContentAction: onContentAction,
                parentProduct: parentProduct,
                spaceKey: (0, (0, parcelRequire("idTx8")).parseUrl)(contentUrl)?.spaceKey,
                themeState: themeState,
                url: contentUrl,
                mode: mode,
                embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
                contentId: contentId,
                contentType: contentType,
                onPublish: actions.setDeferredSpaceData,
                allowedFeatures: {
                    view: [
                        'byline-contributors',
                        'byline-extensions',
                        'page-comments',
                        'page-reactions',
                        'inline-comments',
                        'non-licensed-share'
                    ],
                    ...shouldApplyEditFeatures && {
                        edit: editAllowedFeatures
                    }
                },
                linkConfluencePage: onLinkPage
            }), [
            actions.setDeferredSpaceData,
            contentId,
            contentType,
            contentUrl,
            editAllowedFeatures,
            embeddedConfluenceSourceForPanel,
            contentHostname,
            isDraft,
            isLive,
            locale,
            title,
            mode,
            onClose,
            onContentAction,
            onLinkPage,
            parentProduct,
            themeState,
            shouldApplyEditFeatures
        ]);
        return shouldOpenPanel ? {
            entryPointActions: entryPointActions,
            entryPoint: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "epPanelEntrypointContainer",
                packageName: "@atlassian/jira-issue-create-confluence-content",
                teamName: "confluence-better-together",
                runtimeProps: runtimeProps
            })
        } : {
            ref: undefined,
            entryPoint: null
        };
    };
});
parcelRegister("2POIy", function(module, exports) {
    $parcel$export(module.exports, "embeddedPanelEntrypoint", ()=>$ae604dc9c27c8401$export$32561f984de7bece);
    var $eufEc;
    var $fEDBv;
    const $ae604dc9c27c8401$export$32561f984de7bece = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("kCXAG")), {
            moduleId: "293c24d0"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("kCXAG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("joESl").then(()=>parcelRequire('k1Lui'));
});
parcelRegister("iwjqc", function(module, exports) {
    $parcel$export(module.exports, "createActivePageUrl", ()=>$5538d20fe7287eae$export$83c6318baef117fe);
    $parcel$export(module.exports, "getURLFromConfluencePageResponse", ()=>$5538d20fe7287eae$export$e87b28852220b5cd);
    $parcel$export(module.exports, "setHostnameForContent", ()=>$5538d20fe7287eae$export$8ccd4cc378896990);
    $parcel$export(module.exports, "constructUrlIfCustomDomain", ()=>$5538d20fe7287eae$export$a63ef4c6a1286e2a);
    $parcel$export(module.exports, "createLinkCreatePayload", ()=>$5538d20fe7287eae$export$af98278c506da0f4);
    var $gKZoD;
    var $Geeam;
    var $jg9TU;
    const $5538d20fe7287eae$export$f31b9480a5e4fdcf = (uri)=>{
        if (!uri || uri === '') return '';
        const matches = uri.match(/draftShareId=([^&])*/g);
        return matches ? matches[0].split('=')[1] : '';
    };
    const $5538d20fe7287eae$export$be3b1ed3560ef0e6 = ({ url: url, spaceId: spaceId, spaceKey: spaceKey })=>{
        if (!(url && spaceId && spaceKey)) return '';
        return url.replace(`spaces/${spaceId}`, `spaces/${spaceKey}`);
    };
    const $5538d20fe7287eae$export$83c6318baef117fe = (createPayload)=>{
        const { data: data, url: url } = createPayload;
        const links = data?.links;
        const spaceKey = data?.spaceKey;
        const spaceId = data?.spaceId;
        const linkableUrl = $5538d20fe7287eae$export$be3b1ed3560ef0e6({
            url: url,
            spaceId: spaceId,
            spaceKey: spaceKey
        });
        if (data?.subType === 'live') return `${linkableUrl}`;
        return `${linkableUrl}?draftShareId=${$5538d20fe7287eae$export$f31b9480a5e4fdcf(links?.editui)}`;
    };
    const $5538d20fe7287eae$export$e87b28852220b5cd = ({ id: id, spaceKey: spaceKey, hostname: hostname })=>`${hostname}/wiki/spaces/${spaceKey}/pages/edit-v2/${id}/`;
    const $5538d20fe7287eae$var$isUrlCustomDomain = (parentHost, url)=>{
        const hostname = (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(url);
        return (0, (0, parcelRequire("jg9TU")).isCustomDomain)(parentHost) || hostname && (0, (0, parcelRequire("jg9TU")).isCustomDomain)(hostname);
    };
    const $5538d20fe7287eae$export$8ccd4cc378896990 = (url, hostname)=>{
        (0, (0, parcelRequire("gKZoD")).di)(window);
        const parentHost = window?.location?.origin || '';
        const contentHost = hostname ?? (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(url);
        return $5538d20fe7287eae$var$isUrlCustomDomain(parentHost, url) ? (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(parentHost) : contentHost;
    };
    const $5538d20fe7287eae$export$a63ef4c6a1286e2a = ({ id: id, originalDomain: originalDomain, originalUrl: originalUrl, spaceKey: spaceKey, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl })=>{
        (0, (0, parcelRequire("gKZoD")).di)(window);
        const currentHostname = window?.location?.origin || '';
        const hostnameFromUrl = (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(originalDomain);
        const systemHostName = (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(systemConfluenceAppLinkUrl);
        if (systemHostName !== hostnameFromUrl && $5538d20fe7287eae$var$isUrlCustomDomain(currentHostname, originalDomain)) return $5538d20fe7287eae$export$e87b28852220b5cd({
            id: id,
            spaceKey: spaceKey,
            hostname: currentHostname
        });
        return originalUrl;
    };
    const $5538d20fe7287eae$export$af98278c506da0f4 = (createResponse, url, space, cloudId)=>({
            url: url,
            ari: `ari:cloud:confluence:${cloudId}:page/${createResponse.id}`,
            objectId: createResponse.id,
            objectType: 'page',
            data: {
                spaceId: space.spaceId,
                spaceKey: space.spaceKey,
                spaceName: space.spaceName,
                status: createResponse.status,
                subType: createResponse.subType,
                links: createResponse._links
            }
        });
});
parcelRegister("Geeam", function(module, exports) {
    $parcel$export(module.exports, "getHostnameFromUrl", ()=>$43eec760bfcb2d7e$export$280e79c794cf814e);
    var $cN3DC;
    const $43eec760bfcb2d7e$export$280e79c794cf814e = (url)=>(0, (0, parcelRequire("cN3DC")).isValidUrl)(url) ? new URL(url)?.hostname : '';
});
parcelRegister("cN3DC", function(module, exports) {
    $parcel$export(module.exports, "isValidUrl", ()=>$8759602a30c2f837$export$bef94a5618bf18bf);
    const $8759602a30c2f837$export$bef94a5618bf18bf = (urlString)=>{
        if (typeof urlString !== 'string') return false;
        try {
            return Boolean(new URL(urlString));
        } catch (e) {
            return false;
        }
    };
});
parcelRegister("jg9TU", function(module, exports) {
    $parcel$export(module.exports, "isCustomDomain", ()=>$cbdd6bc245553e48$export$97f4c254b641e719);
    const $cbdd6bc245553e48$var$atlassianDomains = [
        '.atlassian.com',
        '.atlassian.net',
        '.jira-dev.com',
        '.jira.com',
        '.atlassian-stg-fedm.net',
        '.atlassian-us-gov-mod.net',
        '.atlassian-us-gov-mod.com'
    ];
    const $cbdd6bc245553e48$export$97f4c254b641e719 = (hostname)=>!$cbdd6bc245553e48$var$atlassianDomains.some((domain)=>hostname.endsWith(domain));
});
parcelRegister("4TSh0", function(module, exports) {
    $parcel$export(module.exports, "useEmbeddedPageTracking", ()=>$391c3839ff18e3b3$export$9fcd107e4ed1de75);
    var $5uXOq = parcelRequire("5uXOq");
    var $2gCtH;
    var $2NMNM;
    var $9OXo1;
    var $kEkg3;
    var $gFmVN;
    const $391c3839ff18e3b3$export$9fcd107e4ed1de75 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const source = (0, (0, parcelRequire("2gCtH")).useAnalyticsSource)();
        const trackEmbeddedConfluence = (0, $5uXOq.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct, linkObjectType: linkObjectType, confluenceContentId: confluenceContentId })=>{
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject ?? `${eventName}`
            });
            const attributes = {
                parentProduct: (0, (0, parcelRequire("gFmVN")).getParentProduct)(projectType),
                tenantEditions: tenantContext?.appEditions,
                productEntitlementDetails: tenantContext?.productEntitlementDetails,
                embeddedConfluenceSource: embeddedConfluenceSource,
                jiraIssueSurfaceArea: source,
                userHasConfluenceAccess: userHasConfluenceAccess,
                tenantHasConfluence: tenantHasConfluence,
                crossJoinStatus: crossJoinStatus,
                originProduct: originProduct,
                requestedProduct: requestedProduct,
                isSiteAdmin: tenantContext?.isSiteAdmin,
                linkObjectType: linkObjectType,
                confluenceContentId: confluenceContentId
            };
            (0, (0, parcelRequire("kEkg3")).fireEmbeddedConfluenceAnalytics)({
                analyticsEvent: analyticsEvent,
                attributes: attributes,
                eventType: eventType,
                eventName: `${actionSubject ?? eventName} ${action}`
            });
        }, [
            source,
            tenantContext,
            createAnalyticsEvent
        ]);
        return trackEmbeddedConfluence;
    };
});
parcelRegister("kEkg3", function(module, exports) {
    $parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", ()=>$502082c06cc8bb17$export$864bc2da9014e8e9);
    var $8zOmE;
    const $502082c06cc8bb17$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
        switch(eventType){
            case 'ui':
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, attributes);
                break;
            case 'operational':
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
                break;
            case 'track':
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
                break;
            default:
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, attributes);
                break;
        }
    };
});
parcelRegister("gFmVN", function(module, exports) {
    $parcel$export(module.exports, "ACCESS_REQUEST_CAPABILITIES", ()=>$e40b1af8ddf646ed$export$b4e6d6efc113ca5);
    $parcel$export(module.exports, "VALID_DIRECT_ACCESS_STATUS", ()=>$e40b1af8ddf646ed$export$bf1e31028b579014);
    $parcel$export(module.exports, "ACCESS_DENIED_STATUSES", ()=>$e40b1af8ddf646ed$export$2fe5bb2d968b01fc);
    $parcel$export(module.exports, "LICENCE_EXCEEDED_STATUS", ()=>$e40b1af8ddf646ed$export$56360b096b4b4439);
    $parcel$export(module.exports, "getParentProduct", ()=>$e40b1af8ddf646ed$export$e873edb2560a07ef);
    var $2vSU6;
    const $e40b1af8ddf646ed$export$b4e6d6efc113ca5 = {
        ACCESS_GRANTED: 'ACCESS_GRANTED',
        ACCESS_EXISTS: 'ACCESS_EXISTS',
        DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
        DIRECT_ACCESS: 'DIRECT_ACCESS',
        FORBIDDEN: 'FORBIDDEN',
        PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
        REQUEST_ACCESS: 'REQUEST_ACCESS'
    };
    const $e40b1af8ddf646ed$export$bf1e31028b579014 = [
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.ACCESS_EXISTS,
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.ACCESS_GRANTED,
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.PENDING_REQUEST_EXISTS
    ];
    const $e40b1af8ddf646ed$export$2fe5bb2d968b01fc = [
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.FORBIDDEN,
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.DENIED_REQUEST_EXISTS
    ];
    const $e40b1af8ddf646ed$export$56360b096b4b4439 = 'licence-exceeded';
    const $e40b1af8ddf646ed$export$e873edb2560a07ef = (projectType)=>{
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return 'JSM';
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return 'JSW';
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return 'JWM';
            default:
                return 'JSW';
        }
    };
});
parcelRegister("fvjUj", function(module, exports) {
    $parcel$export(module.exports, "useParentProduct", ()=>$af9df26010027d57$export$1b09c6e3737c8eb7);
    var $dAfqg;
    var $gFmVN;
    const $af9df26010027d57$export$1b09c6e3737c8eb7 = ()=>{
        const { data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const projectType = data?.projectType;
        return (0, (0, parcelRequire("gFmVN")).getParentProduct)(projectType);
    };
});
parcelRegister("km1Z8", function(module, exports) {
    $parcel$export(module.exports, "ImperativeAPI", ()=>$b3ed488811f6683d$export$e2ad0ff52e7f8c84);
    var $5uXOq = parcelRequire("5uXOq");
    var $axSKo;
    var $jH6yN;
    const $b3ed488811f6683d$export$e2ad0ff52e7f8c84 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("axSKo")).Consumer), null, ({ getManager: getManager })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jH6yN")).ImperativeAPI), {
                getItemManager: getManager
            }));
});
parcelRegister("axSKo", function(module, exports) {
    $parcel$export(module.exports, "Provider", ()=>$da7a6c3542bd9710$export$2881499e37b75b9a);
    $parcel$export(module.exports, "Consumer", ()=>$da7a6c3542bd9710$export$b3bffd4bb7da6b8f);
    var $5uXOq = parcelRequire("5uXOq");
    var $fr1K2 = parcelRequire("fr1K2");
    var $itvk3;
    var $7KTvf;
    const $da7a6c3542bd9710$var$Context = (0, (0, parcelRequire("itvk3")).default)('ItemManagers');
    const $da7a6c3542bd9710$export$275138de3066e8b3 = 30000;
    class $da7a6c3542bd9710$export$2881499e37b75b9a extends (0, $5uXOq.Component) {
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($da7a6c3542bd9710$var$Context.Provider, {
                value: this.manager
            }, this.props.children);
        }
        constructor(...args){
            super(...args), this.state = {
                managers: {}
            }, this.getManager = (managerKey)=>{
                const { managers: managers } = this.state;
                const manager = managers[managerKey];
                if (manager) return manager;
                return new Promise((resolve, reject)=>{
                    const message = `Timeout. "${(0, (0, parcelRequire("7KTvf")).fromManagerKey)(managerKey)}" wasn't registered after ${$da7a6c3542bd9710$export$275138de3066e8b3}ms`;
                    const rejectTimeoutId = setTimeout(()=>reject(new Error(message)), $da7a6c3542bd9710$export$275138de3066e8b3);
                    const { pendingManagers: pendingManagers } = this;
                    pendingManagers[managerKey] || (pendingManagers[managerKey] = []);
                    pendingManagers[managerKey].push((methods)=>{
                        clearTimeout(rejectTimeoutId);
                        resolve(methods);
                    });
                });
            }, this.registerManager = (managerKey, methods)=>{
                this.setState((previousState)=>{
                    if (methods == null) return {
                        managers: (0, ($parcel$interopDefault($fr1K2)))(previousState.managers, managerKey)
                    };
                    const managerResolvers = this.pendingManagers[managerKey];
                    if (managerResolvers && managerResolvers.length) {
                        managerResolvers.forEach((resolve)=>resolve(methods));
                        managerResolvers.length = 0;
                    }
                    return {
                        managers: {
                            ...previousState.managers,
                            [managerKey]: Promise.resolve(methods)
                        }
                    };
                });
            }, this.pendingManagers = {}, this.manager = {
                getManager: this.getManager,
                registerManager: this.registerManager
            };
        }
    }
    const { Consumer: $da7a6c3542bd9710$export$b3bffd4bb7da6b8f } = $da7a6c3542bd9710$var$Context;
});
parcelRegister("itvk3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00b840b80ca03789$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $00b840b80ca03789$export$2e2bcd8739ae039 = (name)=>{
        const contextObjName = name || '';
        const defaultGetter = ()=>{
            throw new Error(`The Consumer for ${contextObjName} Context Object does not have a correct value. Maybe, it needs to be wrapped in its corresponding Provider`);
        };
        const Context = (0, $5uXOq.createContext)(defaultGetter);
        const ContextConsumer = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Context.Consumer, null, (getValue)=>{
                const value = getValue();
                return props.children(value);
            });
        const ContextProvider = ({ value: value, children: children })=>{
            const getValue = ()=>value;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
                value: getValue
            }, children);
        };
        ContextProvider.displayName = `${contextObjName}SafeProvider`;
        ContextConsumer.displayName = `${contextObjName}SafeConsumer`;
        return {
            Provider: ContextProvider,
            Consumer: ContextConsumer
        };
    };
});
parcelRegister("7KTvf", function(module, exports) {
    $parcel$export(module.exports, "fromManagerKey", ()=>$067bae373d6cebdd$export$fef172a673b3ef47);
    const $067bae373d6cebdd$export$e6ee4c5f89b06a38 = (managerKey)=>managerKey;
    const $067bae373d6cebdd$export$fef172a673b3ef47 = (managerKey)=>String(managerKey);
});
parcelRegister("jH6yN", function(module, exports) {
    $parcel$export(module.exports, "ImperativeAPI", ()=>$5d8d26c2e79a214b$export$e2ad0ff52e7f8c84);
    var $5uXOq = parcelRequire("5uXOq");
    var $9B86Q;
    var $dJl1T;
    var $7oGEb;
    var $1ADgn;
    var $gPQRI;
    var $1J3t1;
    var $jRCeJ;
    var $7KTvf;
    var $lVJAU;
    var $fTkzd;
    const $5d8d26c2e79a214b$var$ERROR_LOCATION = 'legacy.imperative-api';
    const $5d8d26c2e79a214b$export$e2ad0ff52e7f8c84 = ({ getItemManager: getItemManager })=>{
        const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarController)();
        const { refresh: refresh } = (0, (0, parcelRequire("1J3t1")).useProjectSidebarNavigation)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const sidebarState = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const sidebarRef = (0, $5uXOq.useRef)(sidebarState);
        const refreshSidebarRef = (0, $5uXOq.useRef)(refresh);
        const imperativeAPIRef = (0, $5uXOq.useRef)({
            viewIds: (0, parcelRequire("fTkzd")).viewIds,
            itemIds: (0, parcelRequire("fTkzd")).itemIds,
            expand: expandLeftSidebar,
            collapse: collapseLeftSidebar,
            isCollapsed: ()=>sidebarRef.current.isCollapsed,
            onCollapse: ()=>undefined,
            onCollapseStart: ()=>undefined,
            onCollapseEnd: ()=>undefined,
            onExpand: ()=>undefined,
            onExpandStart: ()=>undefined,
            onExpandEnd: ()=>undefined,
            onItemClick: ()=>undefined,
            setView: ()=>undefined,
            updateActiveView: ()=>undefined,
            setProjectRootView: ()=>undefined,
            getActiveViewItems: ()=>[],
            isInProjectContext: ()=>false,
            updateContext: ()=>undefined,
            updateData: ()=>{
                refreshSidebarRef.current();
            },
            getItemManager: (itemManagerKey)=>getItemManager(itemManagerKey).catch((e)=>{
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($5d8d26c2e79a214b$var$ERROR_LOCATION, `There was a problem getting "${(0, (0, parcelRequire("7KTvf")).fromManagerKey)(itemManagerKey)}" item manager`, e);
                    throw e;
                }),
            createBoard: ()=>{
                (0, (0, parcelRequire("1ADgn")).default)();
            },
            modalOpen: ()=>undefined,
            modalClose: ()=>undefined,
            navigate: (url)=>push(url)
        });
        sidebarRef.current = sidebarState;
        refreshSidebarRef.current = refresh;
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/navigation/bridge'
            }).then((bridge)=>{
                bridge(imperativeAPIRef.current);
            });
            (0, (0, parcelRequire("7oGEb")).provideNavigationApi)({
                navigate: push
            });
        }, [
            push
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jRCeJ")).NavigationUIContainer), {
            isGlobal: true
        });
    };
});
parcelRegister("7oGEb", function(module, exports) {
    $parcel$export(module.exports, "provideNavigationApi", ()=>$6e1dad164f29ee43$export$26d28e8849b2805f);
    $parcel$export(module.exports, "isInIframe", ()=>$6e1dad164f29ee43$export$9f140ed41af5108c);
    $parcel$export(module.exports, "canSpaTransition", ()=>$6e1dad164f29ee43$export$59e771495885068f);
    $parcel$export(module.exports, "getContainerApi", ()=>$6e1dad164f29ee43$export$91ed870fd8df2bcb);
    $parcel$export(module.exports, "getNavigationApi", ()=>$6e1dad164f29ee43$export$da4e5a44286a0dd0);
    let $6e1dad164f29ee43$var$containerApi = null;
    let $6e1dad164f29ee43$var$navigationApi = null;
    const $6e1dad164f29ee43$export$3927fb5df700a968 = (api)=>{
        $6e1dad164f29ee43$var$containerApi = api;
    };
    const $6e1dad164f29ee43$export$26d28e8849b2805f = (api)=>{
        $6e1dad164f29ee43$var$navigationApi = api;
    };
    const $6e1dad164f29ee43$export$9f140ed41af5108c = ()=>$6e1dad164f29ee43$var$containerApi !== null;
    const $6e1dad164f29ee43$export$59e771495885068f = ()=>$6e1dad164f29ee43$var$navigationApi !== null;
    const $6e1dad164f29ee43$export$91ed870fd8df2bcb = ()=>$6e1dad164f29ee43$var$containerApi;
    const $6e1dad164f29ee43$export$da4e5a44286a0dd0 = ()=>$6e1dad164f29ee43$var$navigationApi;
    const $6e1dad164f29ee43$export$6ba42130b045ede1 = ()=>{
        $6e1dad164f29ee43$var$containerApi = null;
        $6e1dad164f29ee43$var$navigationApi = null;
    };
});
parcelRegister("1ADgn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a5ce13af6407cab$export$2e2bcd8739ae039);
    var $7T84i;
    const $7a5ce13af6407cab$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
    var $7a5ce13af6407cab$export$2e2bcd8739ae039 = async ()=>{
        const module = await (0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
            name: $7a5ce13af6407cab$var$amdModuleName,
            wrmKeys: [
                'wrc!com.pyxis.greenhopper.jira:gh-create-board'
            ]
        });
        return module.openCreateBoardModal();
    };
});
parcelRegister("jRCeJ", function(module, exports) {
    $parcel$export(module.exports, "NavigationUISubscriber", ()=>$54656242ba3a5025$export$d3dc1c18cfde5ddd);
    $parcel$export(module.exports, "NavigationUIContainer", ()=>$54656242ba3a5025$export$339ec9ca159ad81f);
    var $gg7kZ;
    var $51nlc;
    var $3h4uJ;
    const $54656242ba3a5025$export$d3dc1c18cfde5ddd = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("3h4uJ")).default), {
        displayName: 'NavigationUISubscriber',
        selector: null
    });
    const $54656242ba3a5025$export$339ec9ca159ad81f = (0, (0, parcelRequire("gg7kZ")).createContainer)((0, (0, parcelRequire("3h4uJ")).default));
});
parcelRegister("3h4uJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ca73b0c81372577$export$2e2bcd8739ae039);
    var $iXqE5;
    var $8pFbi;
    const $8ca73b0c81372577$var$initialState = {
        collapseStart: new Set(),
        collapseEnd: new Set(),
        expandStart: new Set(),
        expandEnd: new Set()
    };
    var $8ca73b0c81372577$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'navigation-ui',
        initialState: $8ca73b0c81372577$var$initialState,
        actions: (0, parcelRequire("8pFbi")).default
    });
});
parcelRegister("8pFbi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c96738f03994c2c6$export$2e2bcd8739ae039);
    var $cIPJW;
    var $aUW0i;
    var $44KUn;
    var $5UAf7;
    const $c96738f03994c2c6$var$actions = {
        collapseStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("cIPJW")).default('collapseStart', cb)),
        collapseStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("44KUn")).default('collapseStart', cb)),
        collapseStartClear: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("aUW0i")).default('collapseStart')),
        collapseStartRun: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("5UAf7")).default('collapseStart')),
        collapseEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("cIPJW")).default('collapseEnd', cb)),
        collapseEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("44KUn")).default('collapseEnd', cb)),
        collapseEndClear: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("aUW0i")).default('collapseEnd')),
        collapseEndRun: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("5UAf7")).default('collapseEnd', cb)),
        expandStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("cIPJW")).default('expandStart', cb)),
        expandStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("44KUn")).default('expandStart', cb)),
        expandStartClear: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("aUW0i")).default('expandStart')),
        expandStartRun: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("5UAf7")).default('expandStart', cb)),
        expandEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("cIPJW")).default('expandEnd', cb)),
        expandEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("44KUn")).default('expandEnd', cb)),
        expandEndClear: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("aUW0i")).default('expandEnd')),
        expandEndRun: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("5UAf7")).default('expandEnd', cb)),
        clearAll: ()=>({ dispatch: dispatch })=>{
                dispatch($c96738f03994c2c6$var$actions.collapseStartClear());
                dispatch($c96738f03994c2c6$var$actions.collapseEndClear());
                dispatch($c96738f03994c2c6$var$actions.expandStartClear());
                dispatch($c96738f03994c2c6$var$actions.expandEndClear());
            }
    };
    var $c96738f03994c2c6$export$2e2bcd8739ae039 = $c96738f03994c2c6$var$actions;
});
parcelRegister("cIPJW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98a193bdf9026fb7$export$2e2bcd8739ae039);
    var $44KUn;
    var $98a193bdf9026fb7$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: new Set(getState()[key]).add(callback)
            });
            return ()=>dispatch((0, (0, parcelRequire("44KUn")).default)(key, callback));
        };
});
parcelRegister("44KUn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4cd1dd9b883bc2d4$export$2e2bcd8739ae039);
    var $4cd1dd9b883bc2d4$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState })=>{
            if (!getState()[key]) return;
            const slice = new Set(getState()[key]);
            slice.delete(callback);
            setState({
                [key]: slice
            });
        };
});
parcelRegister("aUW0i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0765ad08a31511d2$export$2e2bcd8739ae039);
    var $0765ad08a31511d2$export$2e2bcd8739ae039 = (key)=>({ setState: setState })=>setState({
                [key]: new Set()
            });
});
parcelRegister("5UAf7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc474c9b594a3d77$export$2e2bcd8739ae039);
    var $dc474c9b594a3d77$export$2e2bcd8739ae039 = (key, ...args)=>({ getState: getState })=>(getState()[key] || new Set()).forEach((cb)=>cb(...args));
});
parcelRegister("fTkzd", function(module, exports) {
    $parcel$export(module.exports, "itemIds", ()=>$e0d97c8d376b70de$export$443ec49e59de3663);
    $parcel$export(module.exports, "viewIds", ()=>$e0d97c8d376b70de$export$8ee2fd038785d9dc);
    var $16J3A;
    const $e0d97c8d376b70de$var$ROOT = 'root/index';
    const $e0d97c8d376b70de$var$ISSUES = 'root/issues';
    const $e0d97c8d376b70de$var$DASHBOARDS = 'root/dashboards';
    const $e0d97c8d376b70de$var$PORTFOLIO = 'root/portfolio';
    const $e0d97c8d376b70de$var$WORK_SCRUM = 'work-scrum';
    const $e0d97c8d376b70de$var$PLAN_SCRUM = 'plan-scrum';
    const $e0d97c8d376b70de$var$WORK_KANBAN = 'work-kanban';
    const $e0d97c8d376b70de$var$PLAN_KANBAN = 'plan-kanban';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES = 'pin-filter-myopenissues';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES = 'pin-filter-reportedbyme';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES = 'pin-filter-allissues';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES = 'pin-filter-allopenissues';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES = 'pin-filter-doneissues';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES = 'pin-filter-recentlyviewed';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES = 'pin-filter-addedrecently';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES = 'pin-filter-resolvedrecently';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES = 'pin-filter-updatedrecently';
    const $e0d97c8d376b70de$var$AGILITY = 'project/agility/index';
    const $e0d97c8d376b70de$var$BUSINESS = 'project/business/index';
    const $e0d97c8d376b70de$var$OPS = 'project/ops/index';
    const $e0d97c8d376b70de$var$SOFTWARE = 'project/software/index';
    const $e0d97c8d376b70de$var$SOFTWARE_ISSUES = 'project/software/issues';
    const $e0d97c8d376b70de$var$SOFTWARE_REPORTS = 'project/software/reports';
    const $e0d97c8d376b70de$var$USER = 'user/index';
    const $e0d97c8d376b70de$var$USER_REPORTS = 'user/reports';
    const $e0d97c8d376b70de$var$rootProjectViewIds = {
        AGILITY: $e0d97c8d376b70de$var$AGILITY,
        SERVICE_DESK: (0, parcelRequire("16J3A")).SERVICE_DESK,
        OPS: $e0d97c8d376b70de$var$OPS,
        BUSINESS: $e0d97c8d376b70de$var$BUSINESS,
        SOFTWARE: $e0d97c8d376b70de$var$SOFTWARE
    };
    const $e0d97c8d376b70de$var$rootViewIds = {
        ROOT: $e0d97c8d376b70de$var$ROOT,
        ISSUES: $e0d97c8d376b70de$var$ISSUES,
        DASHBOARDS: $e0d97c8d376b70de$var$DASHBOARDS,
        PORTFOLIO: $e0d97c8d376b70de$var$PORTFOLIO
    };
    const $e0d97c8d376b70de$export$443ec49e59de3663 = {
        WORK_SCRUM: $e0d97c8d376b70de$var$WORK_SCRUM,
        PLAN_SCRUM: $e0d97c8d376b70de$var$PLAN_SCRUM,
        WORK_KANBAN: $e0d97c8d376b70de$var$WORK_KANBAN,
        PLAN_KANBAN: $e0d97c8d376b70de$var$PLAN_KANBAN,
        PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES,
        ...(0, (0, parcelRequire("16J3A")).SERVICE_DESK_ITEMS)
    };
    const $e0d97c8d376b70de$export$8ee2fd038785d9dc = {
        ...$e0d97c8d376b70de$var$rootViewIds,
        ...$e0d97c8d376b70de$var$rootProjectViewIds,
        SOFTWARE_ISSUES: $e0d97c8d376b70de$var$SOFTWARE_ISSUES,
        SOFTWARE_REPORTS: $e0d97c8d376b70de$var$SOFTWARE_REPORTS,
        SERVICE_DESK_ISSUES: (0, parcelRequire("16J3A")).SERVICE_DESK_ISSUES,
        SERVICE_DESK_QUEUES: (0, parcelRequire("16J3A")).SERVICE_DESK_QUEUES,
        SERVICE_DESK_REPORTS: (0, parcelRequire("16J3A")).SERVICE_DESK_REPORTS,
        SERVICE_DESK_SETTINGS: (0, parcelRequire("16J3A")).SERVICE_DESK_SETTINGS,
        SERVICE_DESK_LANGUAGES: (0, parcelRequire("16J3A")).SERVICE_DESK_LANGUAGES,
        SERVICE_DESK_LEGACY_TICKET_TYPES: (0, parcelRequire("16J3A")).SERVICE_DESK_LEGACY_TICKET_TYPES,
        SERVICE_DESK_TRANSLATIONS: (0, parcelRequire("16J3A")).SERVICE_DESK_TRANSLATIONS,
        SERVICE_DESK_AUTOMATION_SUB_NAV: (0, parcelRequire("16J3A")).SERVICE_DESK_AUTOMATION_SUB_NAV,
        SERVICE_DESK_KNOWLEDGE_HUB: (0, parcelRequire("16J3A")).SERVICE_DESK_KNOWLEDGE_HUB,
        USER: $e0d97c8d376b70de$var$USER,
        USER_REPORTS: $e0d97c8d376b70de$var$USER_REPORTS
    };
});
parcelRegister("16J3A", function(module, exports) {
    $parcel$export(module.exports, "REPORTS_IDS", ()=>$6fb2b1c825061655$export$1f70a76cb421b107);
    $parcel$export(module.exports, "HOME_ITEMS_IDS", ()=>$6fb2b1c825061655$export$9afbea2cbd37e16d);
    $parcel$export(module.exports, "PRACTICES_IDS", ()=>$6fb2b1c825061655$export$a37f4f7add086a3);
    $parcel$export(module.exports, "SERVICE_DESK_ITEMS", ()=>$6fb2b1c825061655$export$2108a7f32cd0bb12);
    $parcel$export(module.exports, "REQUEST_TYPE_PRACTICE_NAV_ONBOARDING", ()=>$6fb2b1c825061655$export$712b4b205a2bcf1e);
    $parcel$export(module.exports, "STARRED_QUEUE_SPOTLIGHT", ()=>$6fb2b1c825061655$export$e2d46b728fe0a15a);
    $parcel$export(module.exports, "SERVICE_DESK", ()=>$6fb2b1c825061655$export$c8c1c8c3f8ddba61);
    $parcel$export(module.exports, "SERVICE_DESK_ISSUES", ()=>$6fb2b1c825061655$export$51fa1147c138a6ed);
    $parcel$export(module.exports, "SERVICE_DESK_QUEUES", ()=>$6fb2b1c825061655$export$456b3cfbf5e37bd8);
    $parcel$export(module.exports, "SERVICE_DESK_KNOWLEDGE_HUB", ()=>$6fb2b1c825061655$export$9ccc8d85b210b219);
    $parcel$export(module.exports, "SERVICE_DESK_REPORTS", ()=>$6fb2b1c825061655$export$707771f2f7e60575);
    $parcel$export(module.exports, "SERVICE_DESK_SETTINGS", ()=>$6fb2b1c825061655$export$a87fc635598d2d50);
    $parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", ()=>$6fb2b1c825061655$export$b6bda26b77269209);
    $parcel$export(module.exports, "SERVICE_DESK_LANGUAGES", ()=>$6fb2b1c825061655$export$776199f9e99c88e2);
    $parcel$export(module.exports, "SERVICE_DESK_TRANSLATIONS", ()=>$6fb2b1c825061655$export$d70ba5c124463035);
    $parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", ()=>$6fb2b1c825061655$export$9a6deaa9c1af559f);
    const $6fb2b1c825061655$var$HOME_QUEUES = 'queues';
    const $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight';
    const $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight';
    const $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight';
    const $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS = 'service-requests';
    const $6fb2b1c825061655$var$HOME_INCIDENTS = 'incidents';
    const $6fb2b1c825061655$var$HOME_CHANGES = 'changes';
    const $6fb2b1c825061655$var$HOME_PROBLEMS = 'problems';
    const $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews';
    const $6fb2b1c825061655$var$HOME_CUSTOMERS = 'customers';
    const $6fb2b1c825061655$var$HOME_REPORTS = 'reports';
    const $6fb2b1c825061655$var$HOME_RAISE_REQUEST = 'raise-request';
    const $6fb2b1c825061655$var$HOME_ISSUES = 'issues';
    const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS = 'customer-channels';
    const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight';
    const $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog';
    const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE = 'knowledge-base';
    const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub';
    const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested';
    const $6fb2b1c825061655$var$HOME_INVITE_TEAM = 'invite-team';
    const $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK = 'give-feedback';
    const $6fb2b1c825061655$var$HOME_SERVICES = 'services';
    const $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT = 'services-spotlight';
    const $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight';
    const $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight';
    const $6fb2b1c825061655$export$1f70a76cb421b107 = {
        REPORTS_CUSTOM: 'sd-reports-custom',
        REPORTS_ADDONS: 'sd-reports-addons',
        REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
        REPORTS_NAV_TEAM: 'sd-reports-nav-team',
        REPORTS_NAV_KB: 'sd-reports-nav-kb'
    };
    const $6fb2b1c825061655$export$9afbea2cbd37e16d = {
        QUEUES: $6fb2b1c825061655$var$HOME_QUEUES,
        ALL_ITSM_QUEUES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
        ALL_TICKETS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT,
        TICKET_CATEGORIES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT,
        SERVICE_REQUEST: $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS,
        INCIDENTS: $6fb2b1c825061655$var$HOME_INCIDENTS,
        CHANGES: $6fb2b1c825061655$var$HOME_CHANGES,
        PROBLEMS: $6fb2b1c825061655$var$HOME_PROBLEMS,
        CUSTOMERS: $6fb2b1c825061655$var$HOME_CUSTOMERS,
        POST_INCIDENT_REVIEWS: $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS,
        REPORTS: $6fb2b1c825061655$var$HOME_REPORTS,
        RAISE_REQUEST: $6fb2b1c825061655$var$HOME_RAISE_REQUEST,
        ISSUES: $6fb2b1c825061655$var$HOME_ISSUES,
        CUSTOMER_CHANNELS: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS,
        CUSTOMER_CHANNELS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
        JSD_CHANNELS_DIALOG: $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG,
        KNOWLEDGE_BASE: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE,
        KNOWLEDGE_BASE_HUB: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB,
        KNOWLEDGE_BASE_HUB_NESTED: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED,
        INVITE_TEAM: $6fb2b1c825061655$var$HOME_INVITE_TEAM,
        GIVE_FEEDBACK: $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK,
        SERVICES: $6fb2b1c825061655$var$HOME_SERVICES,
        SERVICES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT,
        ALERTS_AND_ON_CALL_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
        CHANGE_CALENDAR_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT
    };
    const $6fb2b1c825061655$export$304aefafb7155b23 = {
        TOP_ACTIONS: 'knowledge-hub-top-actions',
        ALL_ARTICLES: 'knowledge-hub-all-articles',
        CATEGORIES: 'knowledge-hub-categories',
        CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
        BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
        ADD_CATEGORY: 'knowledge-hub-new-category',
        LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback'
    };
    const $6fb2b1c825061655$export$5fd6685a693e1064 = {
        DETAILS: 'details',
        PEOPLE: 'people',
        ITSM_FEATURES: 'itsm-features',
        SUMMARY: 'summary',
        DELETE_PROJECT: 'delete-project',
        ISSUE_TYPES: 'issue-types',
        FEATURES: 'features',
        REQUEST_TYPES: 'sd-request-types',
        TICKET_TYPES: 'sd-ticket-types',
        CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
        LANGUAGE_SUPPORT: 'sd-language-support',
        PORTAL_SETTINGS: 'sd-portal-settings',
        EMAIL_REQUESTS: 'sd-email-requests',
        CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
        PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
        PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
        PROJECT_ASSETS_AD: 'sd-project-assets-ad',
        SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
        KNOWLEDGE_BASE: 'sd-knowledge-base',
        SLAS: 'sd-slas',
        AUTOMATION: 'sd-automation',
        PLAYBOOKS: 'playbooks',
        JIRA_AUTOMATION: 'jira-automation',
        AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
        JSD_APP_DISCOVERY: 'sd-app-discovery',
        JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
        JSD_CHANGE_MANAGEMENT: 'sd-change-management',
        WORKFLOWS: 'workflows',
        SCREENS: 'screens',
        FIELDS: 'fields',
        VERSIONS: 'versions',
        COMPONENTS: 'components',
        PERMISSIONS: 'permissions',
        ISSUE_SECURITY: 'issue-security',
        NOTIFICATIONS: 'notifications',
        HIPCHAT: 'hipchat',
        ISSUE_COLLECTORS: 'issue-collectors'
    };
    const $6fb2b1c825061655$export$50b1b8fc419aca98 = {
        QUEUE_NEW: 'queue-new',
        QUEUE_MANAGE: 'queue-manage',
        QUEUES_ADDONS: 'sd-queues-addons',
        QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
        SD_QUEUES_CUSTOM: 'sd-queues-custom'
    };
    const $6fb2b1c825061655$export$a37f4f7add086a3 = {
        ADDITIONAL_ITEMS: 'sd-practices-additional-items',
        CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
        CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
        INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
        INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight'
    };
    const $6fb2b1c825061655$export$2108a7f32cd0bb12 = {
        SERVICE_DESK: {
            HOME: $6fb2b1c825061655$export$9afbea2cbd37e16d,
            KNOWLEDGE_BASE: $6fb2b1c825061655$export$304aefafb7155b23,
            SETTINGS: $6fb2b1c825061655$export$5fd6685a693e1064,
            QUEUES: $6fb2b1c825061655$export$50b1b8fc419aca98,
            REPORTS: $6fb2b1c825061655$export$1f70a76cb421b107
        }
    };
    const $6fb2b1c825061655$export$712b4b205a2bcf1e = {
        PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
        UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight'
    };
    const $6fb2b1c825061655$export$aaffd3035e9d6c2d = 'jsm-team-priority-queue-admin-onboarding';
    const $6fb2b1c825061655$export$e2d46b728fe0a15a = 'jsm-team-starred-onboarding';
    const $6fb2b1c825061655$export$c8c1c8c3f8ddba61 = 'project/service-desk/index';
    const $6fb2b1c825061655$export$51fa1147c138a6ed = 'project/service-desk/issues';
    const $6fb2b1c825061655$export$456b3cfbf5e37bd8 = 'project/service-desk/queues';
    const $6fb2b1c825061655$export$9ccc8d85b210b219 = 'project/service-desk/knowledge-hub';
    const $6fb2b1c825061655$export$707771f2f7e60575 = 'project/service-desk/reports';
    const $6fb2b1c825061655$export$a87fc635598d2d50 = 'project/service-desk/settings';
    const $6fb2b1c825061655$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
    const $6fb2b1c825061655$export$776199f9e99c88e2 = 'project/service-desk/languages';
    const $6fb2b1c825061655$export$d70ba5c124463035 = 'project/service-desk/translations';
    const $6fb2b1c825061655$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';
});
parcelRegister("aqDVH", function(module, exports) {
    $parcel$export(module.exports, "jiraLossAversionModalEntryPoint", ()=>$5bb417d947b6f1f3$export$e224c255d72cf9b5);
    var $eufEc;
    var $fEDBv;
    const $5bb417d947b6f1f3$export$e224c255d72cf9b5 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(async ()=>(parcelRequire("hZJM8")).then(({ JiraLossAversionExperiment: JiraLossAversionExperiment })=>JiraLossAversionExperiment), {
            moduleId: "35d17363"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("hZJM8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eU8LY")
    ]).then(()=>parcelRequire('4VIPJ'));
});
parcelRegister("jElqQ", function(module, exports) {
    $parcel$export(module.exports, "PageDwellAnalyticsListener", ()=>$e847f78ebf17acd8$export$6cf89f098b551dad);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPQRI;
    var $6jY6G;
    var $8zOmE;
    var $2NMNM;
    var $dAfqg;
    var $6yXtV;
    var $hMvRp;
    const $e847f78ebf17acd8$var$WAIT_DURATION = 5000;
    const $e847f78ebf17acd8$export$6cf89f098b551dad = ()=>{
        const [hasFired, setHasFired] = (0, $5uXOq.useState)(false);
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const routeName = route.name;
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const isVisible = (0, (0, parcelRequire("hMvRp")).usePageVisibility)();
        const interval = (0, $5uXOq.useRef)(null);
        const { data: projectData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { isCollapsed: isLeftSidebarCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        (0, $5uXOq.useEffect)(()=>{
            setHasFired(false);
        }, [
            routeName
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isReady) {
                interval.current = null;
                return;
            }
            if (isVisible && !hasFired) interval.current = setTimeout(()=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'page dwelled', routeName, {
                    containerId: projectData?.projectId,
                    containerType: projectData?.projectType,
                    isLeftSidebarCollapsed: isLeftSidebarCollapsed
                });
                setHasFired(true);
            }, $e847f78ebf17acd8$var$WAIT_DURATION);
            return ()=>{
                interval.current = clearTimeout(interval.current);
            };
        }, [
            createAnalyticsEvent,
            hasFired,
            isReady,
            isVisible,
            routeName,
            projectData?.projectId,
            projectData?.projectType,
            isLeftSidebarCollapsed
        ]);
        return null;
    };
});
parcelRegister("hMvRp", function(module, exports) {
    $parcel$export(module.exports, "usePageVisibility", ()=>$124c6a08c4f63b4e$export$6c98eb2f12f4ec61);
    var $5uXOq = parcelRequire("5uXOq");
    var $laTox;
    const $124c6a08c4f63b4e$export$6c98eb2f12f4ec61 = ()=>{
        const [isVisible, setIsVisible] = (0, $5uXOq.useState)((0, (0, parcelRequire("laTox")).isPageVisible)());
        (0, $5uXOq.useEffect)(()=>{
            const onVisibilityChange = ()=>setIsVisible((0, (0, parcelRequire("laTox")).isPageVisible)());
            document.addEventListener('visibilitychange', onVisibilityChange);
            return ()=>{
                document.removeEventListener('visibilitychange', onVisibilityChange);
            };
        }, []);
        return isVisible;
    };
});
parcelRegister("laTox", function(module, exports) {
    $parcel$export(module.exports, "supportedVisiblityEvent", ()=>$845c75a1dcb2afb9$export$f7132cb36c80dad);
    $parcel$export(module.exports, "isPageVisible", ()=>$845c75a1dcb2afb9$export$ae4f9b990bc70f70);
    const $845c75a1dcb2afb9$var$visibilityMap = {
        hidden: 'visibilitychange',
        mozHidden: 'mozvisibilitychange',
        msHidden: 'msvisibilitychange',
        webkitHidden: 'webkitvisibilitychange'
    };
    const $845c75a1dcb2afb9$var$supportedHiddenKey = Object.keys($845c75a1dcb2afb9$var$visibilityMap).find((key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
    const $845c75a1dcb2afb9$export$f7132cb36c80dad = $845c75a1dcb2afb9$var$visibilityMap[$845c75a1dcb2afb9$var$supportedHiddenKey];
    const $845c75a1dcb2afb9$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$845c75a1dcb2afb9$var$supportedHiddenKey];
});
parcelRegister("kKa8l", function(module, exports) {
    $parcel$export(module.exports, "MatchedRouteListener", ()=>$6e59b41cd017c405$export$c6d9204abc182c3b);
    var $5uXOq = parcelRequire("5uXOq");
    var $cfDZ3;
    var $doZTA;
    const $6e59b41cd017c405$export$c6d9204abc182c3b = ()=>{
        const [{ route: route, match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("cfDZ3")).setMatchedRoute)(route, match), [
            route,
            match
        ]);
        return null;
    };
});
parcelRegister("bmetd", function(module, exports) {
    $parcel$export(module.exports, "PreviousRouterStateListener", ()=>$0b73f894404a9cc2$export$49e28489f2124002);
    var $5uXOq = parcelRequire("5uXOq");
    var $1XJ20;
    var $cfDZ3;
    var $jDDFr;
    const $0b73f894404a9cc2$export$3fd5ddd6b8e9a200 = ({ routerState: routerState })=>{
        const previousRouterState = (0, (0, parcelRequire("1XJ20")).usePrevious)(routerState);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("cfDZ3")).setPreviousRouterState)(previousRouterState ?? null);
        }, [
            previousRouterState
        ]);
        return null;
    };
    const $0b73f894404a9cc2$export$49e28489f2124002 = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDDFr")).RouterSubscriber), null, (routerState)=>(0, ($parcel$interopDefault($5uXOq))).createElement($0b73f894404a9cc2$export$3fd5ddd6b8e9a200, {
                routerState: routerState
            })));
    $0b73f894404a9cc2$export$49e28489f2124002.displayName = 'PreviousRouterStateListener';
});
parcelRegister("izgL1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33c092f8fb0732f9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $01Rn4;
    var $7nE2n;
    var $iXVV6;
    var $5oFIy;
    var $5y0F0;
    var $jDDFr;
    var $gKKyW;
    const $33c092f8fb0732f9$var$QueryStringNotifier = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            sourceName: "querystringNotifications"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7nE2n")).default), null, (flagService)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDDFr")).RouterSubscriber), null, ({ location: { search: search } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5y0F0")).RouterActions), null, ({ replace: replace })=>{
                    const { showFlag: showFlag, ...query } = (0, ($parcel$interopDefault($ebyGx))).parse(search);
                    if (!showFlag) return null;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("gKKyW")).default)[showFlag] ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
                        eventName: "querystringNotification shown",
                        componentName: "flag",
                        attributes: {
                            showFlag: showFlag
                        }
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
                        eventName: "querystringNotification notFound",
                        componentName: "flag",
                        attributes: {
                            showFlag: showFlag
                        }
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("01Rn4")).default), {
                        op: ()=>{
                            if ((0, (0, parcelRequire("gKKyW")).default)[showFlag]) flagService.showFlag((0, (0, parcelRequire("gKKyW")).default)[showFlag]);
                            replace(`?${(0, ($parcel$interopDefault($ebyGx))).stringify(query)}`);
                        }
                    }));
                }))));
    var $33c092f8fb0732f9$export$2e2bcd8739ae039 = $33c092f8fb0732f9$var$QueryStringNotifier;
});
parcelRegister("01Rn4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32b7c410527eddaf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $32b7c410527eddaf$var$OpTrigger extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                args: []
            };
        }
        componentDidMount() {
            this.props.op(...this.props.args);
        }
        render() {
            return null;
        }
    }
    var $32b7c410527eddaf$export$2e2bcd8739ae039 = $32b7c410527eddaf$var$OpTrigger;
});
parcelRegister("7nE2n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4855eee5a10070a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    const $4855eee5a10070a5$var$FlagServiceSubscriber = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children((0, (0, parcelRequire("pa9q9")).flagService)));
    var $4855eee5a10070a5$export$2e2bcd8739ae039 = $4855eee5a10070a5$var$FlagServiceSubscriber;
});
parcelRegister("gKKyW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fdf0672c10209bc$export$2e2bcd8739ae039);
    var $7HGHK;
    var $lVqGY;
    const $2fdf0672c10209bc$var$notificationMessages = {
        'jsw.board-not-found': {
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)('jsw.board-not-found'),
            type: 'error',
            title: (0, (0, parcelRequire("lVqGY")).default).boardNotFound,
            description: (0, (0, parcelRequire("lVqGY")).default).boardNotFoundDescription
        },
        'jsw.project-not-found': {
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)('jsw.project-not-found'),
            type: 'error',
            title: (0, (0, parcelRequire("lVqGY")).default).projectNotFound,
            description: (0, (0, parcelRequire("lVqGY")).default).projectNotFoundDescription
        }
    };
    var $2fdf0672c10209bc$export$2e2bcd8739ae039 = $2fdf0672c10209bc$var$notificationMessages;
});
parcelRegister("lVqGY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a629f5c887c4955a$export$2e2bcd8739ae039);
    var $7VHMR;
    const $a629f5c887c4955a$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        boardNotFound: {
            "id": "query-string-notifier.common.board-not-found",
            "defaultMessage": "Board not found"
        },
        boardNotFoundDescription: {
            "id": "query-string-notifier.common.board-not-found-description",
            "defaultMessage": "You tried to access a board that doesn't exist or that you don't have permission to see."
        },
        projectNotFound: {
            "id": "query-string-notifier.common.project-not-found",
            "defaultMessage": "Project not found"
        },
        projectNotFoundDescription: {
            "id": "query-string-notifier.common.project-not-found-description",
            "defaultMessage": "You tried to access a project that doesn't exist or that you don't have permission to see."
        }
    });
    var $a629f5c887c4955a$export$2e2bcd8739ae039 = $a629f5c887c4955a$var$messages;
});
parcelRegister("lyCmi", function(module, exports) {
    $parcel$export(module.exports, "AsyncRecommendPremiumToStandardModalWrapper", ()=>$881dabfa53ffbc01$export$2a43717c77dd3a56);
    var $5uXOq = parcelRequire("5uXOq");
    var $b71gk;
    var $7iJwP;
    var $kxZPA;
    var $gnleF;
    const $881dabfa53ffbc01$var$AsyncRecommendPremiumToStandardModalComponent = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("191Yr")).then(({ RecommendPremiumToStandardModalComponent: RecommendPremiumToStandardModalComponent })=>RecommendPremiumToStandardModalComponent), {
        moduleId: "./src/packages/growth/recommend-premium-to-standard-modal/src/index.tsx"
    });
    const $881dabfa53ffbc01$export$2a43717c77dd3a56 = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b71gk")).default), {
            id: "recommend-premium-to-standard-modal-async",
            packageName: (0, (0, parcelRequire("gnleF")).PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: (0, (0, parcelRequire("gnleF")).TEAM_NAME),
            id: "recommend-premium-to-standard-modal-async",
            packageName: (0, (0, parcelRequire("gnleF")).PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($881dabfa53ffbc01$var$AsyncRecommendPremiumToStandardModalComponent, null)));
    };
});
parcelRegister("gnleF", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$3413b320036771c2$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$3413b320036771c2$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "ANALYTICS_SOURCE_NAME", ()=>$3413b320036771c2$export$48e1d3fa57b0a2d5);
    $parcel$export(module.exports, "STARGATE_URL", ()=>$3413b320036771c2$export$c7e6a6b283196232);
    $parcel$export(module.exports, "RECC_STANDARD_MESSAGE_ID", ()=>$3413b320036771c2$export$de9f5b160db96e26);
    const $3413b320036771c2$export$b8b9d90f9e5bd72b = '@atlassian/jira-recommend-premium-to-standard-modal';
    const $3413b320036771c2$export$d57b6b390e78d90f = 'growth-tako';
    const $3413b320036771c2$export$48e1d3fa57b0a2d5 = 'recommendPremiumToStandard';
    const $3413b320036771c2$export$c7e6a6b283196232 = '/gateway/api';
    const $3413b320036771c2$export$de9f5b160db96e26 = new Map([
        [
            5,
            'prj-grace-period-recc-standard-msg-1'
        ],
        [
            3,
            'prj-grace-period-recc-standard-msg-2'
        ],
        [
            1,
            'prj-grace-period-recc-standard-msg-3'
        ]
    ]);
});
parcelRegister("191Yr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aIcwu").then(()=>parcelRequire('hxssF'));
});
parcelRegister("kgLzl", function(module, exports) {
    $parcel$export(module.exports, "rovoVideoModalEntryPoint", ()=>$1c7272db9b45cdb2$export$2f67fedc6d5555a5);
    var $eufEc;
    var $fEDBv;
    const $1c7272db9b45cdb2$export$2f67fedc6d5555a5 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(async ()=>(parcelRequire("d43GA")).then(({ RovoVideoModal: RovoVideoModal })=>RovoVideoModal), {
            moduleId: "3a307b00"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("d43GA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("l4e09").then(()=>parcelRequire('14875'));
});
parcelRegister("dYRe6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05aa88b82a329166$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $5oFIy;
    var $dxCvy;
    var $7tQej;
    var $2YP9W;
    var $doZTA;
    const $05aa88b82a329166$var$ProjectKeyRedirect = ({ FireOperationalAnalytics: FireOperationalAnalytics = (0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), Redirect: Redirect = (0, (0, parcelRequire("7tQej")).Redirect), useResource: useResource = (0, (0, parcelRequire("2YP9W")).useResource), useRouter: useRouter = (0, (0, parcelRequire("doZTA")).useRouter) })=>{
        const [{ location: location, match: { params: params, url: url }, query: query }] = useRouter();
        const projectKey = params.projectKey ?? query.projectKey;
        const { data: projectContext } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        if (!projectKey || !projectContext?.projectKey) return null;
        if (projectKey === projectContext.projectKey) return null;
        const search = {
            ...query,
            ...query.projectKey ? {
                projectKey: projectContext.projectKey
            } : {}
        };
        const queryString = (0, $aZsz6.qs).stringify(search, Object.entries(search).length > 0);
        const path = params.projectKey != null ? url.replace(projectKey, projectContext.projectKey) : url;
        const to = `${path}${queryString}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(FireOperationalAnalytics, {
            eventName: "ProjectKeyRedirect loaded",
            componentName: "ProjectKeyRedirect",
            attributes: {
                location: location,
                projectContext: projectContext
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: to
        }));
    };
    var $05aa88b82a329166$export$2e2bcd8739ae039 = $05aa88b82a329166$var$ProjectKeyRedirect;
});
parcelRegister("9yehD", function(module, exports) {
    $parcel$export(module.exports, "AsyncTrialSprintBoardModalEntryPoint", ()=>$03eb281d6ff9bb59$export$ba04f28d78ea7267);
    var $5uXOq = parcelRequire("5uXOq");
    var $ioD1B;
    var $eGLgs;
    var $ivDCs;
    var $4mO32;
    var $b71gk;
    var $7iJwP;
    var $koeKL;
    var $60gvu;
    var $j9wkq;
    const $03eb281d6ff9bb59$export$f1c59ccb370d6712 = ({ currentProjectId: currentProjectId })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const isNotTrialSprintBoardProject = (0, (0, parcelRequire("60gvu")).useIsNotTrialSprintBoardProject)(currentProjectId);
        const ctaLink = (0, (0, parcelRequire("60gvu")).useTrialSprintBoardCtaLink)();
        const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("eGLgs")).CoordinationClient)(cloudId, (0, $90b4560f34ff7aba$export$c7e6a6b283196232)), [
            cloudId
        ]);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            coordinationClient.stop((0, $90b4560f34ff7aba$export$af60a7ae4202be66));
        }, [
            coordinationClient
        ]);
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                ctaLink: ctaLink,
                onClose: onClose,
                coordinationClient: coordinationClient
            }), [
            ctaLink,
            coordinationClient,
            onClose
        ]);
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("j9wkq")).trialSprintBoardModalEntryPoint), entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            if (isNotTrialSprintBoardProject && ctaLink) {
                const conditionallyLoadEntryPoint = async ()=>{
                    const started = await coordinationClient.start((0, $90b4560f34ff7aba$export$af60a7ae4202be66));
                    if (started) entryPointActions.load();
                };
                conditionallyLoadEntryPoint();
            }
        }, [
            ctaLink,
            isNotTrialSprintBoardProject,
            coordinationClient,
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioD1B")).ChoreographerContextProvider), {
            isChoreographed: coordinationClient.enableChoreographer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivDCs")).ModalEntryPointContainer), {
            id: (0, $90b4560f34ff7aba$export$48e1d3fa57b0a2d5),
            packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
            teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f),
            errorFallback: "unmount",
            runtimeProps: runtimeProps,
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject
        }));
    };
    const $03eb281d6ff9bb59$export$ba04f28d78ea7267 = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b71gk")).default), {
            id: `async-${(0, $90b4560f34ff7aba$export$48e1d3fa57b0a2d5)}`,
            packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f),
            id: `async-${(0, $90b4560f34ff7aba$export$48e1d3fa57b0a2d5)}`,
            packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($03eb281d6ff9bb59$export$f1c59ccb370d6712, props)));
    };
});
parcelRegister("ioD1B", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerContextProvider", ()=>$c141e5ba3428702a$export$c3226151caaf2fbf);
    var $5uXOq = parcelRequire("5uXOq");
    var $fG5AJ;
    const $c141e5ba3428702a$var$choreographedStatusContextValue = {
        isAlreadyChoreographedAtAncestor: true
    };
    const $c141e5ba3428702a$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, (0, parcelRequire("fG5AJ")).useChoreographedStatusContext)();
        const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
        return shouldUseChoreographerContextProvider ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fG5AJ")).ChoreographedStatusContext).Provider, {
            value: $c141e5ba3428702a$var$choreographedStatusContextValue
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("eGLgs", function(module, exports) {
    $parcel$export(module.exports, "CoordinationClient", ()=>$754c27d37ccd1133$export$580a2294c917898c);
    $parcel$export(module.exports, "default", ()=>$754c27d37ccd1133$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iZhen;
    var $jcYbC;
    var $8Mq6c;
    var $TTRxY;
    var $ioD1B;
    var $fG5AJ;
    var $10xFf;
    var $4Pf62;
    var $4R6GH;
    var $j8DrX;
    var $14XJw;
    var $7qPn9;
    const $754c27d37ccd1133$var$isSyntheticTenant = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true';
    class $754c27d37ccd1133$export$580a2294c917898c extends (0, (0, parcelRequire("8Mq6c")).default) {
        constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
            const environment = (0, (0, parcelRequire("7qPn9")).toEnvironment)((0, (0, parcelRequire("j8DrX")).default)('ajs-environment'));
            const getEnvironmentType = (env)=>{
                if (env === 'prod') return (0, (0, parcelRequire("iZhen")).envType).PROD;
                if (env === 'staging') return (0, (0, parcelRequire("iZhen")).envType).STAGING;
                return (0, (0, parcelRequire("iZhen")).envType).DEV;
            };
            const enableChoreographer = (0, (0, parcelRequire("10xFf")).shouldBeChoreographed)({
                messageType: messageType
            }) && !isAlreadyChoreographedAtAncestor;
            const coordinationOptions = {
                enableChoreographer: enableChoreographer,
                envType: getEnvironmentType(environment),
                additionalData: {
                    sourceProductId: (0, (0, parcelRequire("TTRxY")).ProductIds).JIRA
                }
            };
            super({
                cloudId: cloudId,
                stargateUrl: stargateUrl,
                orgId: orgId,
                isFedRAMPEnvironment: false,
                coordinationOptions: coordinationOptions
            });
            this.shouldUseMockClient = $754c27d37ccd1133$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
            this.enableChoreographer = enableChoreographer;
            this.onMessageDisposition = onMessageDisposition;
            this.isDebugModeEnabled = (0, (0, parcelRequire("4R6GH")).fg)('ep-external-message-debug-mode');
        }
        async start(messageId) {
            if (this.isDebugModeEnabled) {
                const serverResponse = await super.start(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STARTED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
                if (!shouldShowMessage) {
                    const didStop = await super.stop(messageId);
                    if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STOPPED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                }
                return shouldShowMessage;
            }
            return this.shouldUseMockClient ? false : super.start(messageId).then((didStart)=>{
                if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STARTED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                return didStart;
            });
        }
        async stop(messageId) {
            return this.shouldUseMockClient ? true : super.stop(messageId).then((didStop)=>{
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STOPPED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                return didStop;
            });
        }
    }
    function $754c27d37ccd1133$export$2e2bcd8739ae039(props) {
        const { cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const stargateUrl = '/gateway/api';
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, (0, parcelRequire("fG5AJ")).useChoreographedStatusContext)();
        const client = new $754c27d37ccd1133$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
        const { fallback: fallback, messageId: messageId } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioD1B")).ChoreographerContextProvider), {
            isChoreographed: client.enableChoreographer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jcYbC")).default), {
            client: client,
            fallback: fallback,
            messageId: messageId
        }, props.children));
    }
});
parcelRegister("ivDCs", function(module, exports) {
    $parcel$export(module.exports, "ModalEntryPointContainer", ()=>$832a9e21b9f9d7ff$export$4d67c6ee49f3d14d);
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Qvm;
    var $8Bm0k;
    var $c5vfY;
    const $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
        const entryPointReference = (0, (0, parcelRequire("8Bm0k")).useEntryPointSubscription)(entryPointReferenceSubject);
        const props = (0, $5uXOq.useMemo)(()=>({
                ...runtimeProps,
                onClose () {
                    runtimeProps.onClose?.();
                    unload();
                }
            }), [
            runtimeProps,
            unload
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, entryPointReference && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer), {
            ...containerProps,
            entryPointReference: entryPointReference,
            errorFallback: errorFallback || 'flag',
            placeholderName: "modal-entry-point-container",
            runtimeProps: props
        }));
    };
});
const $90b4560f34ff7aba$export$b8b9d90f9e5bd72b = '@atlassian/jira-trial-sprint-board';
const $90b4560f34ff7aba$export$d57b6b390e78d90f = 'growth-tako';
const $90b4560f34ff7aba$export$48e1d3fa57b0a2d5 = 'trialSprintBoard';
const $90b4560f34ff7aba$export$cf8de4fabae858f0 = 'jira_premium_sample_project_id';
const $90b4560f34ff7aba$export$af60a7ae4202be66 = 'prj-trial-sprint-board_message';
const $90b4560f34ff7aba$export$c7e6a6b283196232 = '/gateway/api';
parcelRegister("60gvu", function(module, exports) {
    $parcel$export(module.exports, "useCreateTrialSprintBoard", ()=>$bdbe1b0b24b673c2$export$22329068885bcc27);
    $parcel$export(module.exports, "useIsNotTrialSprintBoardProject", ()=>$bdbe1b0b24b673c2$export$8b329ff03fe43c53);
    $parcel$export(module.exports, "useTrialSprintBoardCtaLink", ()=>$bdbe1b0b24b673c2$export$a731bac57ab8049d);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $j5YhT;
    var $jX0pr;
    var $koeKL;
    var $giJBv;
    var $9mxBe;
    function $bdbe1b0b24b673c2$export$22329068885bcc27() {
        const isEligibleForExperiment = (0, (0, parcelRequire("giJBv")).useIsEligibleForTrialSprintBoard)();
        return ()=>{
            if (isEligibleForExperiment) (0, (0, parcelRequire("9mxBe")).createTrialSprintBoard)();
        };
    }
    const $bdbe1b0b24b673c2$export$dca4afd9682f517e = async (cloudId)=>{
        const siteTraits = await (0, (0, parcelRequire("jX0pr")).memoizedFetchSitePersonalization)({
            cloudId: cloudId
        });
        const trialSprintBoardTrait = siteTraits.find((traits)=>traits.name === (0, $90b4560f34ff7aba$export$cf8de4fabae858f0));
        if (typeof trialSprintBoardTrait?.value !== 'string') return undefined;
        return trialSprintBoardTrait.value;
    };
    const $bdbe1b0b24b673c2$export$5efe839f0f2e520e = async (cloudId, projectId)=>{
        const trialSprintBoardId = await $bdbe1b0b24b673c2$export$dca4afd9682f517e(cloudId);
        return trialSprintBoardId === projectId;
    };
    const $bdbe1b0b24b673c2$export$3b897619e437256e = async (cloudId, relayEnvironment)=>{
        const trialSprintBoardId = await $bdbe1b0b24b673c2$export$dca4afd9682f517e(cloudId);
        if (trialSprintBoardId === undefined) return false;
        const projectAri = (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
            siteId: cloudId,
            projectId: trialSprintBoardId
        }).toString();
        const { isProjectActive: isProjectActive } = await (0, (0, parcelRequire("9mxBe")).getTrialSprintBoardProjectData)(projectAri, relayEnvironment);
        return isProjectActive;
    };
    const $bdbe1b0b24b673c2$export$8220560e582c78bb = async (cloudId, relayEnvironment)=>{
        const trialSprintBoardId = await $bdbe1b0b24b673c2$export$dca4afd9682f517e(cloudId);
        if (trialSprintBoardId === undefined) return undefined;
        const projectAri = (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
            siteId: cloudId,
            projectId: trialSprintBoardId
        }).toString();
        const { projectKey: projectKey, boardId: boardId } = await (0, (0, parcelRequire("9mxBe")).getTrialSprintBoardProjectData)(projectAri, relayEnvironment);
        if (projectKey === null || boardId === null) return undefined;
        const firstIssueKey = `${projectKey}-1`;
        const projectBoardWithIssueSelectedPath = `/jira/software/projects/${projectKey}/boards/${boardId}?selectedIssue=${firstIssueKey}`;
        return projectBoardWithIssueSelectedPath;
    };
    const $bdbe1b0b24b673c2$export$8b329ff03fe43c53 = (currentProjectId)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [isNotTsbProject, setIsNotTsbProject] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            $bdbe1b0b24b673c2$export$5efe839f0f2e520e(cloudId, currentProjectId).then((isTsbProject)=>setIsNotTsbProject(!isTsbProject));
        }, [
            cloudId,
            currentProjectId
        ]);
        return isNotTsbProject;
    };
    const $bdbe1b0b24b673c2$export$a731bac57ab8049d = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const relayEnvironment = (0, $8Uumt.useRelayEnvironment)();
        const [ctaLink, setCtaLink] = (0, $5uXOq.useState)('');
        (0, $5uXOq.useEffect)(()=>{
            const getCtaLink = async ()=>{
                const isProjectAvailable = await $bdbe1b0b24b673c2$export$3b897619e437256e(cloudId, relayEnvironment);
                if (isProjectAvailable) {
                    const tsbIssuePath = await $bdbe1b0b24b673c2$export$8220560e582c78bb(cloudId, relayEnvironment);
                    if (tsbIssuePath !== undefined) setCtaLink(tsbIssuePath);
                }
            };
            getCtaLink();
        }, [
            cloudId,
            relayEnvironment
        ]);
        return ctaLink;
    };
});
parcelRegister("jX0pr", function(module, exports) {
    $parcel$export(module.exports, "memoizedFetchSitePersonalization", ()=>$7b32fa3ce5d65e32$export$671fb03be30194c3);
    $parcel$export(module.exports, "useSitePersonalization", ()=>$7b32fa3ce5d65e32$export$58982988039b926f);
    var $8QpSo;
    var $ld2hZ;
    var $7f4tk;
    const $7b32fa3ce5d65e32$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
    const $7b32fa3ce5d65e32$export$ddf4964d2a406b6a = async ({ cloudId: cloudId })=>{
        if (!cloudId) throw new Error('empty cloudId');
        const { attributes: attributes } = await (0, (0, parcelRequire("7f4tk")).default)($7b32fa3ce5d65e32$var$getPersonalizationSiteTraitsUrl(cloudId), {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-atlassian-mau-ignore': 'true'
            }
        });
        return attributes;
    };
    const $7b32fa3ce5d65e32$export$671fb03be30194c3 = (0, (0, parcelRequire("8QpSo")).default)($7b32fa3ce5d65e32$export$ddf4964d2a406b6a, ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>newCloudId === lastCloudId);
    const $7b32fa3ce5d65e32$export$58982988039b926f = ()=>(0, (0, parcelRequire("ld2hZ")).useService)($7b32fa3ce5d65e32$export$671fb03be30194c3);
});
parcelRegister("ld2hZ", function(module, exports) {
    $parcel$export(module.exports, "useService", ()=>$b3ad55f76ff82cb6$export$6de4685a6c88b4e9);
    $parcel$export(module.exports, "useLoadingStatusService", ()=>$b3ad55f76ff82cb6$export$c963713a27525aaf);
    var $5uXOq = parcelRequire("5uXOq");
    const $b3ad55f76ff82cb6$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
        const [state, setState] = (0, $5uXOq.useState)({
            loading: false,
            data: undefined,
            error: undefined,
            ...initialState
        });
        const fetch = (0, $5uXOq.useCallback)(async (requestData)=>{
            setState({
                loading: true,
                error: undefined,
                data: undefined
            });
            try {
                const data = await request(requestData);
                setState({
                    loading: false,
                    error: undefined,
                    data: data
                });
                return data;
            } catch (error) {
                setState({
                    loading: false,
                    error: error,
                    data: undefined
                });
                return undefined;
            }
        }, [
            request
        ]);
        return {
            ...state,
            fetch: fetch
        };
    };
    const $b3ad55f76ff82cb6$export$c963713a27525aaf = (request, initialState = {})=>{
        const [loadingStatus, setLoadingStatus] = (0, $5uXOq.useState)('idle');
        const { data: data, loading: loading, error: error, fetch: fetch } = $b3ad55f76ff82cb6$export$6de4685a6c88b4e9(request, initialState);
        (0, $5uXOq.useEffect)(()=>{
            if (loading) setLoadingStatus('started');
            else if (error) setLoadingStatus('error');
            else if (data) setLoadingStatus('success');
        }, [
            data,
            loading,
            error
        ]);
        return {
            data: data,
            loadingStatus: loadingStatus,
            error: error,
            fetch: fetch
        };
    };
});
parcelRegister("giJBv", function(module, exports) {
    $parcel$export(module.exports, "useIsEligibleForTrialSprintBoard", ()=>$47804f028d4aa8cc$export$e6f5647df30a55f2);
    var $5uXOq = parcelRequire("5uXOq");
    var $dRVix;
    var $ldyPw;
    var $ef5Xn;
    var $k9JTq;
    var $7trqb;
    var $hqBSi;
    var $5oBMG;
    function $47804f028d4aa8cc$export$e6f5647df30a55f2() {
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const licensedProducts = (0, (0, parcelRequire("hqBSi")).useLicensedProducts)();
        const licenseStates = (0, (0, parcelRequire("7trqb")).useLicenseStates)();
        const productEntitlementDetails = (0, (0, parcelRequire("5oBMG")).useProductEntitlementDetails)();
        const jswAppEdition = appEditions.software;
        const hasActiveJswLicense = licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] && licenseStates.software === (0, (0, parcelRequire("ef5Xn")).LICENSE_STATE_ACTIVE) && Object.keys(licensedProducts).length === 1;
        const isOnPremiumJsw = jswAppEdition === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
        const entitlementDetails = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
        const currentDate = (0, $5uXOq.useMemo)(()=>Date.now(), []);
        const trialDaysLeft = (0, (0, parcelRequire("dRVix")).getTrialDaysLeft)(currentDate, entitlementDetails?.trialEndTime) ?? 0;
        const isOnTrial = trialDaysLeft >= 0;
        return hasActiveJswLicense && isOnPremiumJsw && isOnTrial;
    }
});
parcelRegister("dRVix", function(module, exports) {
    $parcel$export(module.exports, "useIsJswUsingCcp", ()=>$9ce9420d6adb67d7$export$f8e1c288fefa6e7d);
    $parcel$export(module.exports, "useIsProductUsingCcp", ()=>$9ce9420d6adb67d7$export$b367e04990bbb76d);
    $parcel$export(module.exports, "useLoggedInPage", ()=>$9ce9420d6adb67d7$export$a7ca0608784708a1);
    $parcel$export(module.exports, "getTrialDaysLeft", ()=>$9ce9420d6adb67d7$export$954628993bf3188e);
    $parcel$export(module.exports, "isInGracePeriod", ()=>$9ce9420d6adb67d7$export$271517afaa0c15eb);
    var $kTK0a;
    var $2vSU6;
    var $cYlk7;
    var $9OXo1;
    function $9ce9420d6adb67d7$export$f8e1c288fefa6e7d() {
        const { productEntitlementDetails: productEntitlementDetails } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const jswEntitlement = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
        return jswEntitlement?.billingSourceSystem === 'CCP';
    }
    function $9ce9420d6adb67d7$export$b367e04990bbb76d(projectType) {
        const { productEntitlementDetails: productEntitlementDetails } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const productKey = (0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)(projectType);
        const productEntitlement = productEntitlementDetails?.[productKey];
        return productEntitlement?.billingSourceSystem === 'CCP';
    }
    function $9ce9420d6adb67d7$export$a7ca0608784708a1({ pageUrl: pageUrl }) {
        const { data: currentUserData } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const encodedPageUrl = encodeURIComponent(pageUrl);
        const encodedUserEmail = encodeURIComponent(currentUserData.user.emailAddress ?? '');
        return `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id')}/login?continue=${encodedPageUrl}&login_hint=${encodedUserEmail}&prompt=none`;
    }
    const $9ce9420d6adb67d7$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
    const $9ce9420d6adb67d7$export$954628993bf3188e = (currentDate, trialEndTime)=>trialEndTime ? Math.ceil(($9ce9420d6adb67d7$export$9dbbf537dffaafc7(trialEndTime) - currentDate) / 86400000) : undefined;
    const $9ce9420d6adb67d7$export$271517afaa0c15eb = (currentDate, trialEndTime)=>{
        const trialDaysLeft = $9ce9420d6adb67d7$export$954628993bf3188e(currentDate, trialEndTime);
        return !trialDaysLeft || trialDaysLeft < 0;
    };
});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';
parcelRegister("5oBMG", function(module, exports) {
    $parcel$export(module.exports, "useProductEntitlementDetails", ()=>$3295ae4955475ae4$export$e02d6385b5d47f5d);
    var $9OXo1;
    const $3295ae4955475ae4$export$e02d6385b5d47f5d = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.productEntitlementDetails || null;
    };
});
parcelRegister("9mxBe", function(module, exports) {
    $parcel$export(module.exports, "createTrialSprintBoard", ()=>$a543aaf7c0a4dacb$export$37cea344fdf9b6ed);
    $parcel$export(module.exports, "getTrialSprintBoardProjectData", ()=>$a543aaf7c0a4dacb$export$83e8cdb22fb8892d);
    var $530x5;
    var $eiowN = parcelRequire("eiowN");
    var $2vSU6;
    var $jcw0u;
    var $eusud;
    function $a543aaf7c0a4dacb$export$37cea344fdf9b6ed() {
        (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/trial-project/v1/create').catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'createTrialSprintBoard',
                    packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
                    teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f)
                }
            });
        });
    }
    const $a543aaf7c0a4dacb$export$83e8cdb22fb8892d = async (projectAri, relayEnvironment)=>{
        const data = await (0, $eiowN.fetchQuery)(relayEnvironment, (0, (0, parcelRequire("530x5")).default), {
            projectAri: projectAri
        }, {
            fetchPolicy: 'store-or-network'
        }).toPromise();
        const project = data?.jira?.jiraProject;
        const isProjectActive = project?.status === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_STATUS_ACTIVE);
        const projectKey = project?.key;
        const boardId = project?.boards?.edges?.[0]?.node?.boardId;
        if (!project || !projectKey || !boardId) (0, (0, parcelRequire("jcw0u")).default)({
            error: new Error('Could not retrieve all trial sprint board project data'),
            meta: {
                id: 'getTrialSprintBoardProjectData',
                packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
                teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f)
            },
            attributes: {
                activeStatusIsPresent: !!project?.status,
                projectKeyIsPresent: !!projectKey,
                boardId: boardId || null
            }
        });
        return {
            isProjectActive: isProjectActive,
            projectKey: projectKey ?? null,
            boardId: boardId ?? null
        };
    };
});
parcelRegister("530x5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56400afcfc79b920$export$2e2bcd8739ae039);
    const $56400afcfc79b920$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectAri"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectAri"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "status"
        }, v3 = {
            "kind": "ScalarField",
            "name": "key"
        }, v4 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "boardId"
        }, v6 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "servicesTrialSprintBoardProjectDataQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProject",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "args": v4,
                                        "concreteType": "JiraBoardConnection",
                                        "kind": "LinkedField",
                                        "name": "boards",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraBoardEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraBoard",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v5
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "boards(first:1)"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "servicesTrialSprintBoardProjectDataQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProject",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "args": v4,
                                        "concreteType": "JiraBoardConnection",
                                        "kind": "LinkedField",
                                        "name": "boards",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraBoardEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraBoard",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v5,
                                                            v6
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "boards(first:1)"
                                    },
                                    v6
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "1932382d2760a8f56b95470d5e7a694260755e9bfbffef22dc7eb910d386cabd",
                "metadata": {},
                "name": "servicesTrialSprintBoardProjectDataQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $56400afcfc79b920$var$node.hash = "2793f4acb36ace35bec2c93ab6ac60ef";
    var $56400afcfc79b920$export$2e2bcd8739ae039 = $56400afcfc79b920$var$node;
});
parcelRegister("j9wkq", function(module, exports) {
    $parcel$export(module.exports, "trialSprintBoardModalEntryPoint", ()=>$3261cdbb80ebb186$export$ee8e5ecce2602f9);
    var $eufEc;
    var $fEDBv;
    const $3261cdbb80ebb186$export$ee8e5ecce2602f9 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("73KYl")).then(({ TrialSprintBoardModalEntryPoint: TrialSprintBoardModalEntryPoint })=>TrialSprintBoardModalEntryPoint), {
            moduleId: "d60f0bc1"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("73KYl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cOnF4").then(()=>parcelRequire('ejP4E'));
});
parcelRegister("dz0Q5", function(module, exports) {
    $parcel$export(module.exports, "AsyncUpflowIframeComponent", ()=>$aab5ccb109290e76$export$7f34679273a30171);
    var $kxZPA;
    const $aab5ccb109290e76$export$7f34679273a30171 = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("it3EE")).then((exportedModule)=>exportedModule.UpflowIframeComponent), {
        ssr: false,
        moduleId: "./src/packages/growth/up-flow/upflow-iframe-plugin/src/main.tsx"
    });
});
parcelRegister("it3EE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1umXM").then(()=>parcelRequire('f7aUi'));
});
parcelRegister("kXv2J", function(module, exports) {
    $parcel$export(module.exports, "upgradeOnboardingExperimentEntryPoint", ()=>$49f1088be59356e0$export$94ad1b5fd850909f);
    var $eufEc;
    var $fEDBv;
    const $49f1088be59356e0$export$94ad1b5fd850909f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(async ()=>(parcelRequire("eFKv8")).then(({ UpgradeOnboardingExperiment: UpgradeOnboardingExperiment })=>UpgradeOnboardingExperiment), {
            moduleId: "86e9ce71"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("eFKv8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8f5Ah")
    ]).then(()=>parcelRequire('a48Ze'));
});
parcelRegister("4p6rw", function(module, exports) {
    $parcel$export(module.exports, "JiraHeritageLoader", ()=>$da151c89e6acf066$export$9499deca9933db5b);
    var $5uXOq = parcelRequire("5uXOq");
    var $cQZXC;
    var $1r4rO;
    var $7XYc4;
    var $4R6GH;
    var $6jY6G;
    var $6yXtV;
    var $4su49;
    var $kiABc;
    var $8Z3n8;
    const $da151c89e6acf066$var$JiraHeritageLoaderOld = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [hasHeritageDownloaded, setHasHeritageDownloaded] = (0, $5uXOq.useState)(false);
        (0, (0, parcelRequire("8Z3n8")).useWrmStatsEffects)();
        const loadJiraHeritageDependencies = (0, $5uXOq.useCallback)(()=>{
            setHasHeritageDownloaded(true);
            (0, (0, parcelRequire("4su49")).asyncWrmRequire)([
                ...(0, (0, parcelRequire("1r4rO")).jiraSuperBatchDependencies),
                ...(0, (0, parcelRequire("kiABc")).getJiraHeritageDependencies)()
            ]).then(()=>(0, (0, parcelRequire("cQZXC")).waitForHeritage)()?.resolve?.());
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (isReady && !hasHeritageDownloaded) loadJiraHeritageDependencies();
        }, [
            hasHeritageDownloaded,
            isReady,
            loadJiraHeritageDependencies,
            route
        ]);
        return null;
    };
    const $da151c89e6acf066$var$JiraHeritageLoaderNew = (0, $5uXOq.Fragment);
    const $da151c89e6acf066$export$9499deca9933db5b = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('no-wrm-heritage-loader'), $da151c89e6acf066$var$JiraHeritageLoaderNew, $da151c89e6acf066$var$JiraHeritageLoaderOld);
    $da151c89e6acf066$export$9499deca9933db5b.displayName = 'JiraHeritageLoader';
});
parcelRegister("kiABc", function(module, exports) {
    $parcel$export(module.exports, "getJiraHeritageDependencies", ()=>$0d81a9889d6c3d74$export$e8f6d7acd5817fa2);
    const $0d81a9889d6c3d74$export$e8f6d7acd5817fa2 = ()=>[
            'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
            'wrc!jira.webresources:key-commands',
            'wrc!jira.webresources:header',
            'wrc!com.atlassian.administration.atlassian-admin-quicksearch-jira:admin-quicksearch-webresources',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
            'wrc!jira.webresources:global-static',
            'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
            'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
            'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources-init',
            'wrc!com.pyxis.greenhopper.jira:gh-create-board-adg3-no-condition',
            'wrc!com.atlassian.analytics.analytics-client:js-events',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:global-cache',
            'wrc!com.atlassian.crowd.user-provisioning-vertigo-plugin:impersonation-resources',
            'wrc!jira.webresources:spam-protection-flags',
            'wrc!com.atlassian.pas:pas-everypage-static',
            'wrc!com.atlassian.jira.jira-fileviewer-plugin:fileviewer',
            'wrc!com.atlassian.auiplugin:dialog2',
            'wrc!com.atlassian.jira.jira-fileviewer-plugin:atlassian-fileviewer',
            'wrc!com.atlassian.jira.jira-issue-nav-plugin:stylesheets'
        ];
});
parcelRegister("8Z3n8", function(module, exports) {
    $parcel$export(module.exports, "useWrmStatsEffects", ()=>$b2fe1e724cbc12ec$export$7ff53723d9d2886d);
    var $5uXOq = parcelRequire("5uXOq");
    var $6yXtV;
    var $bVDE5;
    const $b2fe1e724cbc12ec$export$7ff53723d9d2886d = ()=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [{ transitionsCount: transitionsCount }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        (0, $5uXOq.useEffect)(()=>{
            if (isReady && window.__WRM_INTERNAL_STATS__ && !window.__WRM_INTERNAL_STATS__.isPageInteractive) window.__WRM_INTERNAL_STATS__.isPageInteractive = true;
        }, [
            isReady
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (transitionsCount > 0) window.__WRM_INTERNAL_STATS__ = {};
        }, [
            transitionsCount
        ]);
    };
});
parcelRegister("38EzX", function(module, exports) {
    $parcel$export(module.exports, "BreadcrumbAdapter", ()=>$3ee15d0681681178$export$2255367d5c9162b3);
    var $5uXOq = parcelRequire("5uXOq");
    var $67Adx;
    const $3ee15d0681681178$export$2255367d5c9162b3 = ()=>{
        const baseUrl = '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("67Adx")).default), {
            baseUrl: baseUrl
        });
    };
});
parcelRegister("67Adx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fce4053be7c0ea3f$export$2e2bcd8739ae039);
    var $9sGI6;
    var $aYHuU;
    var $7GR7x;
    var $bQtVL;
    var $3XHss;
    var $1DFxi;
    var $fce4053be7c0ea3f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("aYHuU")).default), {
        LegacyApiBridge: (0, parcelRequire("7GR7x")).default,
        LegacyBreadcrumbConnector: (0, parcelRequire("bQtVL")).default,
        LegacyBreadcrumbState: (0, parcelRequire("1DFxi")).default,
        LegacyBreadcrumbRenderer: (0, parcelRequire("3XHss")).default
    });
});
parcelRegister("aYHuU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2640273d477c5ef9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jzjy1;
    var $b71gk;
    const $2640273d477c5ef9$var$LegacyBreadcrumbAdapter = ({ LegacyBreadcrumbRenderer: LegacyBreadcrumbRenderer, LegacyBreadcrumbState: LegacyBreadcrumbState, LegacyApiBridge: LegacyApiBridge, LegacyBreadcrumbConnector: LegacyBreadcrumbConnector })=>(0, ($parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbState, null, ({ api: api, state: state })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(LegacyApiBridge, {
                onInsertItem: api.insertItem,
                onRemoveItem: api.removeItem,
                onSetRenderTarget: api.setTargetElement
            }), state.targetElement && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b71gk")).default), {
                id: "legacy-breadcrumb-adapter"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbConnector, {
                legacyTrail: state.trail
            }), (0, ($parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbRenderer, {
                targetElement: state.targetElement
            }))));
    var $2640273d477c5ef9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('legacyBreadcrumbs', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($2640273d477c5ef9$var$LegacyBreadcrumbAdapter);
});
parcelRegister("jzjy1", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsSource", ()=>$578c443a5ba38dde$export$6890652a1aff7d1c);
    $parcel$export(module.exports, "AnalyticsSubject", ()=>$578c443a5ba38dde$export$ec9f54bd4341ceb);
    var $994MI;
    const $578c443a5ba38dde$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, (0, parcelRequire("994MI")).default)({
                source: `${name}${type}`
            })(WrappedComponent);
    const $578c443a5ba38dde$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, (0, parcelRequire("994MI")).default)({
                actionSubject: name,
                attributes: attributes
            })(WrappedComponent);
});
parcelRegister("7GR7x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1c2002ff619891e$export$2e2bcd8739ae039);
    var $1bJTy;
    var $9sGI6;
    var $hciGg;
    const $e1c2002ff619891e$var$analyticsEvents = {
        onInsertItemFired: (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'insertItem'
                }
            }),
        onRemoveItemFired: (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'removeItem'
                }
            }),
        onSetRenderTargetFired: (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'render'
                }
            }),
        onOnBreadCrumbsUpdateFired: (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'onBreadCrumbsUpdate'
                }
            })
    };
    var $e1c2002ff619891e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("hciGg")).default), $e1c2002ff619891e$var$analyticsEvents);
});
parcelRegister("1bJTy", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalAnalytics", ()=>$065c8ba87a790756$export$79f423cc3fd39762);
    var $4f8Oj = parcelRequire("4f8Oj");
    var $jcw0u;
    var $gvRPW;
    var $i4iBk;
    const $065c8ba87a790756$var$isNotUndefined = (a)=>a !== undefined;
    const $065c8ba87a790756$var$mapPayload = (payload)=>{
        const context = (0, (0, parcelRequire("i4iBk")).default)(payload);
        const { name: name } = payload;
        return (0, ($parcel$interopDefault($4f8Oj)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            name: name
        }, $065c8ba87a790756$var$isNotUndefined);
    };
    const $065c8ba87a790756$export$79f423cc3fd39762 = (event, payload)=>{
        try {
            event.update({
                ...$065c8ba87a790756$var$mapPayload(payload),
                analyticsType: (0, (0, parcelRequire("gvRPW")).OPERATIONAL_EVENT_TYPE)
            }).fire();
        } catch (e) {
            (0, (0, parcelRequire("jcw0u")).default)({
                event: event,
                error: e,
                meta: {
                    id: 'fireOperationalAnalytics',
                    packageName: 'jiraAnalyticsWebReact',
                    teamName: 'legacy-jfp-team-do-not-use'
                }
            });
        }
    };
});
parcelRegister("i4iBk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a364fe632bf506b$export$2e2bcd8739ae039);
    var $cjFoH = parcelRequire("cjFoH");
    var $9xWGk = parcelRequire("9xWGk");
    var $8a364fe632bf506b$export$2e2bcd8739ae039 = (payload)=>{
        const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
        return (0, ($parcel$interopDefault($9xWGk)))({
            tags: tags,
            containerId: containerId,
            containers: containers,
            containerType: containerType,
            objectId: objectId,
            objectType: objectType,
            attributes: attributes
        }, (0, ($parcel$interopDefault($cjFoH))));
    };
});
parcelRegister("hciGg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$060d1d7061b6e3c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("6hSeW");
    var $8oe80;
    var $c1YJb;
    class $060d1d7061b6e3c1$var$LegacyApiBridge extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { onInsertItem: onInsertItem, onRemoveItem: onRemoveItem, onSetRenderTarget: onSetRenderTarget, onBreadCrumbsUpdate: onBreadCrumbsUpdate } = this;
            (0, (0, parcelRequire("c1YJb")).default)({
                insertItem: onInsertItem,
                removeItem: onRemoveItem,
                render: onSetRenderTarget,
                onBreadCrumbsUpdate: onBreadCrumbsUpdate
            });
        }
        render() {
            return null;
        }
        constructor(...args){
            super(...args), this.onInsertItem = (item)=>{
                const { onInsertItem: onInsertItem, onInsertItemFired: onInsertItemFired } = this.props;
                onInsertItemFired();
                onInsertItem(item);
            }, this.onRemoveItem = (itemId)=>{
                const { onRemoveItem: onRemoveItem, onRemoveItemFired: onRemoveItemFired } = this.props;
                onRemoveItemFired();
                onRemoveItem(itemId);
            }, this.onSetRenderTarget = (element)=>{
                const { onSetRenderTarget: onSetRenderTarget, onSetRenderTargetFired: onSetRenderTargetFired } = this.props;
                onSetRenderTargetFired();
                onSetRenderTarget(element);
            }, this.onBreadCrumbsUpdate = ()=>{
                const { onOnBreadCrumbsUpdateFired: onOnBreadCrumbsUpdateFired } = this.props;
                onOnBreadCrumbsUpdateFired();
                return (0, $kVLXA.Observable).empty();
            };
        }
    }
    var $060d1d7061b6e3c1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('legacyApiBridge', {
        onInsertItemFired: 'apiMethodCalled',
        onRemoveItemFired: 'apiMethodCalled',
        onSetRenderTargetFired: 'apiMethodCalled',
        onOnBreadCrumbsUpdateFired: 'apiMethodCalled'
    })($060d1d7061b6e3c1$var$LegacyApiBridge);
});
parcelRegister("8oe80", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd6b229cbb45328e$export$2e2bcd8739ae039);
    var $994MI;
    var $cb25w;
    const $cd6b229cbb45328e$export$871de8747c9eaa88 = (props)=>Object.keys(props).reduce((result, key)=>({
                ...result,
                [key]: {
                    action: props[key]
                }
            }), {});
    function $cd6b229cbb45328e$var$componentWithAnalytics(componentName, eventActions) {
        return function(WrappedComponent) {
            return (0, (0, parcelRequire("994MI")).default)({
                componentName: componentName
            })((0, (0, parcelRequire("cb25w")).default)($cd6b229cbb45328e$export$871de8747c9eaa88(eventActions))(WrappedComponent));
        };
    }
    var $cd6b229cbb45328e$export$2e2bcd8739ae039 = $cd6b229cbb45328e$var$componentWithAnalytics;
});
parcelRegister("c1YJb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8c3f644565eaafc$export$2e2bcd8739ae039);
    var $9B86Q;
    var $dJl1T;
    var $a8c3f644565eaafc$export$2e2bcd8739ae039 = (legacyAPI)=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
            name: 'jira/globalnavigator/breadcrumbs/bridge'
        }).then((bridge)=>{
            bridge(legacyAPI);
        }).catch((err)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString()));
});
parcelRegister("bQtVL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c34ce41a7e16e82$export$2e2bcd8739ae039);
    var $9sGI6;
    var $c2D8L;
    var $btYLD;
    var $gEFwt;
    var $75PvK;
    var $7OPFF;
    var $5fGpW;
    var $2c34ce41a7e16e82$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("7OPFF")).default), {
        Breadcrumb: (0, parcelRequire("c2D8L")).default,
        ProjectBreadcrumb: (0, parcelRequire("gEFwt")).default,
        BoardBreadcrumb: (0, parcelRequire("btYLD")).default,
        UserBreadcrumb: (0, parcelRequire("75PvK")).default,
        ContextProvider: (0, parcelRequire("5fGpW")).default
    });
});
parcelRegister("c2D8L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$904f5413e35195e5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $aIVNN;
    class $904f5413e35195e5$var$BreadcrumbOps extends (0, $5uXOq.Component) {
        constructor(props){
            super(props), this.id = '';
            this.id = (0, ($parcel$interopDefault($7Jxgt))).v4();
            if (false) this.onPushBreadcrumb();
        }
        componentDidMount() {
            this.onPushBreadcrumb();
        }
        componentDidUpdate(prevProps) {
            const { breadcrumb: prevBreadcrumb } = prevProps;
            const { api: api, breadcrumb: breadcrumb } = this.props;
            if (!(0, ($parcel$interopDefault($ajpes)))(prevBreadcrumb, breadcrumb)) api.updateBreadcrumb({
                id: this.id,
                ...breadcrumb
            });
        }
        componentWillUnmount() {
            const { api: api } = this.props;
            api.popBreadcrumb();
        }
        onPushBreadcrumb() {
            const { api: api, breadcrumb: breadcrumb } = this.props;
            api.pushBreadcrumb({
                id: this.id,
                ...breadcrumb
            });
        }
        render() {
            return null;
        }
    }
    const $904f5413e35195e5$var$Breadcrumb = ({ breadcrumb: breadcrumb, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aIVNN")).BreadcrumbActions), null, (__, actions)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($904f5413e35195e5$var$BreadcrumbOps, {
                api: actions,
                breadcrumb: breadcrumb
            }), children));
    $904f5413e35195e5$var$Breadcrumb.defaultProps = {
        children: null
    };
    var $904f5413e35195e5$export$2e2bcd8739ae039 = $904f5413e35195e5$var$Breadcrumb;
});
parcelRegister("aIVNN", function(module, exports) {
    $parcel$export(module.exports, "useBreadcrumbs", ()=>$446946e3e8bfa528$export$8cefe241bd876ca0);
    $parcel$export(module.exports, "BreadcrumbActions", ()=>$446946e3e8bfa528$export$9862c338ec0a6884);
    $parcel$export(module.exports, "BreadcrumbContainer", ()=>$446946e3e8bfa528$export$c7432936d9c50db7);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $446946e3e8bfa528$var$initialState = {
        trail: []
    };
    const $446946e3e8bfa528$export$e324594224ef24da = {
        pushBreadcrumb: (breadcrumb)=>({ setState: setState, getState: getState })=>{
                setState({
                    trail: [
                        ...getState().trail,
                        breadcrumb
                    ]
                });
            },
        popBreadcrumb: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    trail: getState().trail.slice(0, -1)
                });
            },
        updateBreadcrumb: (breadcrumb)=>({ setState: setState, getState: getState })=>{
                const newTrail = getState().trail.map((item)=>item.id === breadcrumb.id ? breadcrumb : item);
                setState({
                    trail: newTrail
                });
            }
    };
    const $446946e3e8bfa528$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $446946e3e8bfa528$var$initialState,
        actions: $446946e3e8bfa528$export$e324594224ef24da,
        name: 'BreadcrumbSweetState'
    });
    const $446946e3e8bfa528$var$_BreadcrumbSubscriber = (0, (0, parcelRequire("51nlc")).createSubscriber)($446946e3e8bfa528$var$Store);
    const $446946e3e8bfa528$export$8cefe241bd876ca0 = (0, (0, parcelRequire("3sQ5x")).createHook)($446946e3e8bfa528$var$Store);
    const $446946e3e8bfa528$export$9862c338ec0a6884 = (0, (0, parcelRequire("51nlc")).createSubscriber)($446946e3e8bfa528$var$Store, {
        selector: null
    });
    const $446946e3e8bfa528$export$c7432936d9c50db7 = (0, (0, parcelRequire("gg7kZ")).createContainer)($446946e3e8bfa528$var$Store);
});
parcelRegister("btYLD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97548d5fa76ccc5f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $81ps3;
    const $97548d5fa76ccc5f$var$BoardBreadcrumb = ({ children: children, boardId: boardId, boardName: boardName, isSimplifiedProject: isSimplifiedProject, projectId: projectId })=>{
        const breadcrumb = {
            href: (0, (0, parcelRequire("81ps3")).createBoardUrl)(boardId),
            text: boardName,
            type: 'boardName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToSubProject',
                containerId: projectId,
                containerType: 'project'
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: breadcrumb
        }, children);
    };
    $97548d5fa76ccc5f$var$BoardBreadcrumb.defaultProps = {
        children: null,
        isSimplifiedProject: false,
        projectId: undefined
    };
    var $97548d5fa76ccc5f$export$2e2bcd8739ae039 = $97548d5fa76ccc5f$var$BoardBreadcrumb;
});
parcelRegister("81ps3", function(module, exports) {
    $parcel$export(module.exports, "createProjectUrl", ()=>$e04610b9d6540e69$export$1bdb1f038c5a2a90);
    $parcel$export(module.exports, "createProjectSettingsUrl", ()=>$e04610b9d6540e69$export$c435fcb42a65af32);
    $parcel$export(module.exports, "createBoardUrl", ()=>$e04610b9d6540e69$export$7037e05c8c7af6dc);
    var $02Psx;
    const $e04610b9d6540e69$export$1bdb1f038c5a2a90 = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
    const $e04610b9d6540e69$export$c435fcb42a65af32 = (projectKey, projectType, isSimplified)=>{
        if (isSimplified) return (0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)(projectType, projectKey);
        return `/projects/${projectKey}/settings`;
    };
    const $e04610b9d6540e69$export$7037e05c8c7af6dc = (boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}`;
});
parcelRegister("gEFwt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b024406020849893$export$2e2bcd8739ae039);
    var $az4zD;
    var $4V6Dv;
    var $b024406020849893$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)((0, (0, parcelRequire("4V6Dv")).default));
});
parcelRegister("az4zD", function(module, exports) {
    $parcel$export(module.exports, "injectIntlV2", ()=>$90dc1bd887533804$export$440265f0ca78e98e);
    var $5uXOq = parcelRequire("5uXOq");
    var $dY8Js = parcelRequire("dY8Js");
    var $koVbs;
    const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
    function $90dc1bd887533804$var$getDisplayName(Component) {
        if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) return Component.displayName;
        if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
        return 'Component';
    }
    const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
        const { withRef: withRef = false } = options || {};
        const WithIntl = (props)=>{
            const intl = (0, (0, parcelRequire("koVbs")).default)();
            const intlRef = (0, $5uXOq.useRef)(null);
            if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
            if (!intlRef.current) intlRef.current = {
                messages: intl.messages,
                locale: intl.locale,
                formats: intl.formats,
                formatDate: intl.formatDate,
                formatMessage: intl.formatMessage,
                formatNumber: intl.formatNumber,
                formatPlural: intl.formatPlural,
                formatTime: intl.formatTime
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                intl: intlRef.current,
                ref: withRef ? props.forwardedRef : null
            });
        };
        WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
        WithIntl.WrappedComponent = WrappedComponent;
        if (withRef) return (0, ($parcel$interopDefault($dY8Js)))((0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WithIntl, {
                ...props,
                forwardedRef: ref
            })), WrappedComponent);
        return (0, ($parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
    };
});
parcelRegister("4V6Dv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83ca195db24613ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $81ps3;
    var $bnbo9;
    const $83ca195db24613ad$var$ProjectBreadcrumb = ({ isSimplifiedProject: isSimplifiedProject, children: children, projectKey: projectKey, projectName: projectName, projectId: projectId, intl: { formatMessage: formatMessage } })=>{
        const ProjectsBreadcrumb = {
            href: '/jira/projects',
            text: formatMessage((0, (0, parcelRequire("bnbo9")).default).projectsTitle),
            type: 'projectsDirectory',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToProjectsList'
            }
        };
        if (projectKey != null && projectName != null) {
            const breadcrumb = {
                href: (0, (0, parcelRequire("81ps3")).createProjectUrl)(projectKey),
                text: projectName,
                type: 'projectName',
                analyticsAttributes: {
                    nextGenProject: isSimplifiedProject,
                    projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
                },
                analyticsFields: {
                    name: 'navigateToProject',
                    containerId: projectId,
                    containerType: 'project'
                }
            };
            const ProjectNameBreadcrumb = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
                breadcrumb: breadcrumb
            }, children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
                breadcrumb: ProjectsBreadcrumb
            }, ProjectNameBreadcrumb);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: ProjectsBreadcrumb
        }, children);
    };
    $83ca195db24613ad$var$ProjectBreadcrumb.defaultProps = {
        children: null,
        isSimplifiedProject: false,
        projectId: undefined,
        projectKey: undefined,
        projectName: undefined
    };
    var $83ca195db24613ad$export$2e2bcd8739ae039 = $83ca195db24613ad$var$ProjectBreadcrumb;
});
parcelRegister("bnbo9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b60cdda05341e39$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1b60cdda05341e39$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectsTitle: {
            "id": "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title",
            "defaultMessage": "Projects"
        }
    });
});
parcelRegister("75PvK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc6b338da4258947$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    const $fc6b338da4258947$var$UserBreadcrumb = ({ children: children, name: name, profileUrl: profileUrl })=>{
        const breadcrumb = {
            href: profileUrl,
            text: name,
            type: 'userName'
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: breadcrumb
        }, children);
    };
    var $fc6b338da4258947$export$2e2bcd8739ae039 = $fc6b338da4258947$var$UserBreadcrumb;
});
parcelRegister("7OPFF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$760c31310830da08$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $760c31310830da08$var$toBreadcrumbData = ({ id: id, index: index, ...legacyCrumb })=>({
            ...legacyCrumb,
            legacyId: id,
            type: 'legacy'
        });
    const $760c31310830da08$var$ContextBreadcrumbs = ({ ContextProvider: ContextProvider, ProjectBreadcrumb: ProjectBreadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement(ContextProvider, null, ({ data: data })=>{
            if (!data) return children;
            const boardBreadcrumb = data.scope ? (0, ($parcel$interopDefault($5uXOq))).createElement(BoardBreadcrumb, {
                boardId: data.scope.id,
                boardName: data.scope.name || 'Board'
            }, children) : children;
            return data.contextType === 'user' ? (0, ($parcel$interopDefault($5uXOq))).createElement(UserBreadcrumb, {
                profileUrl: data.user.profileUrl,
                name: data.user.name
            }, boardBreadcrumb) : (0, ($parcel$interopDefault($5uXOq))).createElement(ProjectBreadcrumb, {
                projectKey: data.project.key,
                projectName: data.project.name,
                projectId: data.project.id,
                isSimplifiedProject: data.project.isSimplified
            }, boardBreadcrumb);
        });
    const $760c31310830da08$var$LegacyBreadcrumbConnector = ({ legacyTrail: legacyTrail, Breadcrumb: Breadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, ProjectBreadcrumb: ProjectBreadcrumb, ContextProvider: ContextProvider })=>{
        const accumulateBreadcrumb = (accumulatedCrumbs, currentCrumb)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Breadcrumb, {
                breadcrumb: currentCrumb
            }, accumulatedCrumbs);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($760c31310830da08$var$ContextBreadcrumbs, {
            BoardBreadcrumb: BoardBreadcrumb,
            ProjectBreadcrumb: ProjectBreadcrumb,
            UserBreadcrumb: UserBreadcrumb,
            ContextProvider: ContextProvider
        }, legacyTrail.map($760c31310830da08$var$toBreadcrumbData).reverse().reduce(accumulateBreadcrumb, null));
    };
    var $760c31310830da08$export$2e2bcd8739ae039 = $760c31310830da08$var$LegacyBreadcrumbConnector;
});
parcelRegister("5fGpW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2cc7aa08354ae9ed$export$2e2bcd8739ae039);
    var $fr1K2 = parcelRequire("fr1K2");
    var $4DPZY;
    var $bmKPg;
    var $ieDtd;
    const $2cc7aa08354ae9ed$export$9f27bc3417b4524d = ({ children: children })=>{
        const [boardId] = (0, (0, parcelRequire("bmKPg")).usePathParam)('boardId');
        const [rapidView] = (0, (0, parcelRequire("ieDtd")).useQueryParam)('rapidView');
        const [{ data: ctxData, loading: loading, error: error }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        const data = ctxData == null || boardId != null || rapidView != null ? ctxData : (0, ($parcel$interopDefault($fr1K2)))(ctxData, 'scope');
        return children({
            data: data,
            loading: loading,
            error: error
        });
    };
    var $2cc7aa08354ae9ed$export$2e2bcd8739ae039 = $2cc7aa08354ae9ed$export$9f27bc3417b4524d;
});
parcelRegister("3XHss", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65b3956e27a1612f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $dJl1T;
    var $jS4lj;
    const $65b3956e27a1612f$var$LOCATION = 'breadcrumbs.legacy-adapter.legacy-renderer';
    class $65b3956e27a1612f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidCatch(error) {
            const { targetElement: targetElement } = this.props;
            const targetId = targetElement ? targetElement.id : 'not-found';
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($65b3956e27a1612f$var$LOCATION, `Failed to createPortal on ${targetId}`, error);
        }
        render() {
            const { targetElement: targetElement } = this.props;
            return (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null), targetElement);
        }
    }
});
parcelRegister("jS4lj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c6eafb2b612d104$export$2e2bcd8739ae039);
    var $1bJTy;
    var $9sGI6;
    var $9OXo1;
    var $0SW74;
    const $8c6eafb2b612d104$var$fireAnalytics = (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
            name: 'breadcrumbRendererMounted'
        });
    var $8c6eafb2b612d104$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("0SW74")).default), {
        onMount: $8c6eafb2b612d104$var$fireAnalytics,
        TenantContextSubscriber: (0, parcelRequire("9OXo1")).TenantContextSubscriber
    });
});
parcelRegister("0SW74", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa2b8169c8c69f79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8oe80;
    var $4R6GH;
    var $6lcpk;
    var $3HwlS;
    var $aIVNN;
    const $fa2b8169c8c69f79$var$mapTrailToBreadcrumbItems = (trail)=>trail.map((crumb)=>({
                ...crumb,
                target: crumb.target || '_self'
            }));
    const $fa2b8169c8c69f79$var$BreadcrumbRenderer = ({ onMount: onMount })=>{
        const [{ trail: trail }] = (0, (0, parcelRequire("aIVNN")).useBreadcrumbs)();
        const items = (0, $5uXOq.useMemo)(()=>$fa2b8169c8c69f79$var$mapTrailToBreadcrumbItems(trail), [
            trail
        ]);
        (0, $5uXOq.useEffect)(onMount, []);
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_1')) return (0, ($parcel$interopDefault($5uXOq))).createElement($fa2b8169c8c69f79$var$BreadcrumbsWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lcpk")).default), {
            isVisible: true,
            items: items
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fa2b8169c8c69f79$var$BreadcrumbsWrapperOld, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lcpk")).default), {
            isVisible: true,
            items: items
        }));
    };
    var $fa2b8169c8c69f79$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('breadcrumbsRenderer', {
        onMount: 'mounted'
    })($fa2b8169c8c69f79$var$BreadcrumbRenderer);
    const $fa2b8169c8c69f79$var$BreadcrumbsWrapperOld = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1tke1tcg",
                __cmplp.className
            ])
        });
    });
    const $fa2b8169c8c69f79$var$BreadcrumbsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1tke1tcg _nwukvy9e _1o8h13fh",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6lcpk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$741d99934750459a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jD5no;
    var $j6iTu;
    function $741d99934750459a$export$2e2bcd8739ae039(props) {
        const { isVisible: isVisible, items: items } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j6iTu")).default), {
            isVisible: isVisible,
            items: items
        }));
    }
});
parcelRegister("j6iTu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5be1ac78992edda2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fuUnn;
    var $jbeEq;
    var $koVbs;
    var $hDzhb;
    var $92r9l;
    var $2UzOj;
    const $5be1ac78992edda2$export$67abef37aa2929b0 = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
            ...props,
            ref: ref,
            type: "a"
        }));
    function $5be1ac78992edda2$export$2e2bcd8739ae039(props) {
        const { isVisible: isVisible, items: items } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return isVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jbeEq")).default), {
            onExpand: (0, ($parcel$interopDefault($8Rkzz)))
        }, (0, ($parcel$interopDefault($gccSB)))(items) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fuUnn")).default), {
            text: "",
            "aria-label": formatMessage((0, (0, parcelRequire("2UzOj")).default).breadcrumbsLabel)
        }) : items.map((breadcrumb, index)=>{
            const breadcrumbItem = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92r9l")).default), {
                key: index,
                index: index,
                hasSeparator: true,
                text: breadcrumb.text,
                target: __SPA__ ? undefined : breadcrumb.target,
                href: breadcrumb.href,
                component: __SPA__ ? $5be1ac78992edda2$export$67abef37aa2929b0 : undefined,
                legacyId: breadcrumb.legacyId,
                type: breadcrumb.type,
                analyticsAttributes: breadcrumb.analyticsAttributes,
                analyticsFields: breadcrumb.analyticsFields
            });
            return breadcrumbItem;
        }))) : null;
    }
});
parcelRegister("fuUnn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8fa85d0f49630632$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3bDjY;
    var $hVWqN;
    var $6hWJD;
    const $8fa85d0f49630632$var$itemWrapperStyles = null;
    const $8fa85d0f49630632$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
    const $8fa85d0f49630632$var$ICON_WIDTH_ESTIMATE = 24;
    const $8fa85d0f49630632$var$staticItemStyles = null;
    const $8fa85d0f49630632$var$staticItemWithTruncationStyles = null;
    const $8fa85d0f49630632$var$staticItemWithoutTruncationStyles = null;
    const $8fa85d0f49630632$var$BreadcrumbsItem = (0, $5uXOq.memo)(({ analyticsContext: analyticsContext, component: component, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, ref: ref, target: target, testId: testId, text: text, truncationWidth: truncationWidth, ...rest })=>{
        const buttonRef = (0, $5uXOq.useRef)(null);
        let iconWidthAllowance = 0;
        if (iconBefore) iconWidthAllowance += $8fa85d0f49630632$var$ICON_WIDTH_ESTIMATE;
        if (iconAfter) iconWidthAllowance += $8fa85d0f49630632$var$ICON_WIDTH_ESTIMATE;
        const [hasOverflow, showTooltip] = (0, (0, parcelRequire("6hWJD")).default)(truncationWidth, buttonRef.current, iconWidthAllowance);
        const dynamicItemStyles = {
            [$8fa85d0f49630632$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
        };
        const step = $5uXOq.createElement((0, (0, parcelRequire("hVWqN")).default), {
            ...rest,
            analyticsContext: analyticsContext,
            component: component,
            hasOverflow: hasOverflow,
            href: href,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            onClick: onClick,
            ref: buttonRef,
            target: target,
            testId: testId,
            style: truncationWidth ? dynamicItemStyles : undefined,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p1hhk _vwz41txs _1rjc1tvq",
                truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
            ])
        }, text);
        return $5uXOq.createElement("li", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _18s8ze3t _1yt4ze3t _2lx2vrvc _1dsoftgi _toskidpf _15621n76 _5nddv77o _1j1pu2gc _191d1h6o"
            ])
        }, showTooltip ? $5uXOq.createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown
        }, step) : step);
    });
    var $8fa85d0f49630632$export$2e2bcd8739ae039 = $8fa85d0f49630632$var$BreadcrumbsItem;
});
parcelRegister("hVWqN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a95af0809bc014a8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $fVnbM;
    var $eGmKJ;
    const $a95af0809bc014a8$var$analyticsAttributes = {
        componentName: 'breadcrumbsItem',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $a95af0809bc014a8$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $a95af0809bc014a8$var$Step = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $a95af0809bc014a8$var$noop, target: target, testId: testId, ...props }, ref)=>{
        const handleClicked = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onClickProvided,
            action: 'clicked',
            analyticsData: analyticsContext,
            ...$a95af0809bc014a8$var$analyticsAttributes
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            appearance: "subtle-link",
            component: component,
            href: href,
            iconAfter: hasOverflow ? undefined : iconAfter,
            iconBefore: hasOverflow ? undefined : iconBefore,
            onClick: handleClicked,
            ref: ref,
            spacing: "none",
            target: target,
            testId: testId
        });
    });
    var $a95af0809bc014a8$export$2e2bcd8739ae039 = $a95af0809bc014a8$var$Step;
});
parcelRegister("6hWJD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$39e9e81e9bc6c25a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $39e9e81e9bc6c25a$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
        const [hasOverflow, setOverflow] = (0, $5uXOq.useState)(true);
        const [showTooltip, setShowTooltip] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (truncationWidth && buttonRefCurrent) {
                const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
                const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
                setOverflow(shouldOverflow);
                setShowTooltip(shouldShowTooltip);
            } else {
                setOverflow(false);
                setShowTooltip(false);
            }
        }, [
            truncationWidth,
            buttonRefCurrent,
            iconWidthAllowance
        ]);
        return [
            hasOverflow,
            showTooltip
        ];
    }
});
parcelRegister("jbeEq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f33b456747f6edef$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $5JjdN;
    var $eGmKJ;
    var $iidvu;
    var $5djWe;
    const $f33b456747f6edef$var$defaultMaxItems = 8;
    const $f33b456747f6edef$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
    const $f33b456747f6edef$var$defaultEllipsisLabel = 'Show more breadcrumbs';
    const { toArray: $f33b456747f6edef$var$toArray } = (0, ($parcel$interopDefault($5uXOq))).Children;
    const $f33b456747f6edef$var$analyticsAttributes = {
        componentName: 'breadcrumbs',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $f33b456747f6edef$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $f33b456747f6edef$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
    const $f33b456747f6edef$var$breadcrumbStyles = null;
    const $f33b456747f6edef$var$InnerBreadcrumbs = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $f33b456747f6edef$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $f33b456747f6edef$var$noop, analyticsContext: analyticsContext, label: label = $f33b456747f6edef$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $f33b456747f6edef$var$defaultEllipsisLabel } = props;
        const [expanded, setExpanse] = (0, $5uXOq.useState)(defaultExpanded);
        const [isClickedBySpace, setExpansionTrigger] = (0, $5uXOq.useState)(false);
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const isControlled = typeof isExpanded !== 'undefined';
        const isExpansionHandled = providedExpanse !== $f33b456747f6edef$var$noop;
        const shouldExpand = isControlled ? isExpanded : expanded;
        const focusFirstRevealed = ()=>{
            if (wrapperRef.current) {
                const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
                const interactiveElements = listItems.map((li)=>li.querySelector($f33b456747f6edef$var$interactiveElementSelector));
                const elementToFocus = interactiveElements[itemsBeforeCollapse];
                const firstInteractiveElement = interactiveElements[0];
                if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
                else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
                else wrapperRef.current.focus();
            }
            setExpansionTrigger(false);
        };
        (0, (0, parcelRequire("5djWe")).useOnRevealed)(focusFirstRevealed, {
            isExpanded: shouldExpand,
            isDisabled: !isClickedBySpace
        });
        const handleExpansion = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event, analyticsEvent)=>{
                if (!isControlled) setExpanse((expanded)=>!expanded);
                if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
                return providedExpanse(event, analyticsEvent);
            },
            action: 'expanded',
            analyticsData: analyticsContext,
            ...$f33b456747f6edef$var$analyticsAttributes
        });
        const childrenArray = $f33b456747f6edef$var$toArray(children);
        const breadcrumbsArray = (0, ($parcel$interopDefault($5uXOq))).Children.map(childrenArray, (child, index)=>{
            if (typeof child === 'string') return child;
            return childrenArray.length - 1 === index ? (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                'aria-current': 'page'
            }) : child;
        });
        const renderItemsWithEllipsis = ()=>{
            const allItems = breadcrumbsArray;
            if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
            const beforeItems = allItems.slice(0, itemsBeforeCollapse);
            const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
            return [
                ...beforeItems,
                (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iidvu")).default), {
                    key: "ellipsis",
                    testId: testId && `${testId}--breadcrumb-ellipsis`,
                    onClick: handleExpansion,
                    label: ellipsisLabel
                }),
                ...afterItems
            ];
        };
        const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
        const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("nav", {
            "aria-label": label,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                wrapperRef
            ]),
            tabIndex: -1
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("ol", {
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _18s8ze3t _1yt4ze3t _1n261g80 _syaz1wmz"
            ])
        }, breadcrumbsItems));
    });
    const $f33b456747f6edef$var$Breadcrumbs = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($f33b456747f6edef$var$InnerBreadcrumbs, {
            ...props,
            analyticsContext: analyticsContext,
            children: children,
            createAnalyticsEvent: createAnalyticsEvent,
            defaultExpanded: defaultExpanded,
            ellipsisLabel: ellipsisLabel,
            isExpanded: isExpanded,
            itemsAfterCollapse: itemsAfterCollapse,
            itemsBeforeCollapse: itemsBeforeCollapse,
            label: label,
            maxItems: maxItems,
            onExpand: onExpand,
            ref: ref,
            testId: testId
        })));
    var $f33b456747f6edef$export$2e2bcd8739ae039 = $f33b456747f6edef$var$Breadcrumbs;
});
parcelRegister("iidvu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3f2526167b8235c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $eGmKJ;
    const $b3f2526167b8235c$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $b3f2526167b8235c$var$itemWrapperStyles = null;
    const $b3f2526167b8235c$var$staticItemStyles = null;
    const $b3f2526167b8235c$var$EllipsisItem = (0, $5uXOq.memo)(({ label: label, onClick: onClick = $b3f2526167b8235c$var$noop, testId: testId })=>$5uXOq.createElement("li", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _18s8ze3t _1yt4ze3t _2lx2vrvc _1dsou2gc _toskidpf _15621n76 _5nddv77o _1j1pu2gc _191d1h6o"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            "aria-label": label,
            onClick: onClick,
            spacing: "none",
            testId: testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p1hhk _vwz41txs _1rjc1tvq"
            ])
        }, "\u2026")));
    var $b3f2526167b8235c$export$2e2bcd8739ae039 = $b3f2526167b8235c$var$EllipsisItem;
});
parcelRegister("5djWe", function(module, exports) {
    $parcel$export(module.exports, "useOnRevealed", ()=>$16bf9036c9802d42$export$e9c4922b2ecf808a);
    var $5uXOq = parcelRequire("5uXOq");
    var $lp9re;
    function $16bf9036c9802d42$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
        const prevExtended = (0, (0, parcelRequire("lp9re")).default)(isExpanded);
        (0, $5uXOq.useEffect)(()=>{
            const hasBeenRevealed = !prevExtended && isExpanded;
            if (!isDisabled && hasBeenRevealed) callback();
        }, [
            isExpanded,
            isDisabled,
            callback,
            prevExtended
        ]);
    }
});
parcelRegister("92r9l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$77e0cddbf99d95bf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fuUnn;
    var $dOvpK;
    class $77e0cddbf99d95bf$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                href: undefined,
                legacyId: undefined,
                type: 'unspecified',
                analyticsAttributes: {},
                analyticsFields: {}
            };
        }
        render() {
            const { index: index, text: text, target: target, href: href, component: component } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fuUnn")).default), {
                key: index,
                text: text,
                onClick: this.onBreadCrumbClick,
                target: target,
                href: href,
                component: component
            });
        }
        constructor(...args){
            super(...args), this.onBreadCrumbClick = (event, analyticsEvent)=>{
                const { legacyId: legacyId, index: index, type: type, analyticsAttributes: analyticsAttributes, analyticsFields: analyticsFields } = this.props;
                (0, (0, parcelRequire("dOvpK")).fireUiAnalytics)(analyticsEvent, {
                    name: '',
                    attributes: {
                        legacyId: legacyId,
                        depth: index + 1,
                        type: type,
                        ...analyticsAttributes
                    },
                    ...analyticsFields
                });
            };
        }
    }
});
parcelRegister("dOvpK", function(module, exports) {
    $parcel$export(module.exports, "fireUiAnalytics", ()=>$8c2abcc805e894f7$export$4909253b5bf1eed7);
    var $4f8Oj = parcelRequire("4f8Oj");
    var $gvRPW;
    var $i4iBk;
    const $8c2abcc805e894f7$var$isNotUndefined = (a)=>a !== undefined;
    const $8c2abcc805e894f7$var$mapPayload = (payload)=>{
        const context = (0, (0, parcelRequire("i4iBk")).default)(payload);
        const { name: name } = payload;
        return (0, ($parcel$interopDefault($4f8Oj)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            name: name
        }, $8c2abcc805e894f7$var$isNotUndefined);
    };
    const $8c2abcc805e894f7$export$4909253b5bf1eed7 = (event, payload)=>{
        event.update({
            ...$8c2abcc805e894f7$var$mapPayload(payload),
            analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
        }).fire();
    };
});
parcelRegister("2UzOj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e3ad53695e8cbba$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8e3ad53695e8cbba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        breadcrumbsLabel: {
            "id": "navigation-apps.breadcrumbs.aria-label",
            "defaultMessage": "Empty Breadcrumbs item"
        }
    });
});
parcelRegister("1DFxi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b3b01c7b039743c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $9b3b01c7b039743c$var$compareBreadcrumbs = (a, b)=>a.index - b.index;
    const $9b3b01c7b039743c$var$defaultInitialState = {
        trail: [],
        targetElement: null
    };
    class $9b3b01c7b039743c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                initialState: $9b3b01c7b039743c$var$defaultInitialState
            };
        }
        constructor(props){
            super(props), this.onInsertItem = (item)=>{
                this.setState((state)=>({
                        trail: [
                            ...state.trail,
                            item
                        ].sort($9b3b01c7b039743c$var$compareBreadcrumbs)
                    }));
            }, this.onRemoveItem = (id)=>{
                this.setState((state)=>({
                        trail: state.trail.filter((b)=>b.id !== id)
                    }));
            }, this.onTargetSet = (targetElement)=>{
                this.setState({
                    targetElement: targetElement
                });
            }, this.api = {
                setTargetElement: this.onTargetSet,
                insertItem: this.onInsertItem,
                removeItem: this.onRemoveItem
            };
            this.state = props.initialState;
        }
        render() {
            const { children: children } = this.props;
            return children({
                state: this.state,
                api: this.api
            });
        }
    }
});
parcelRegister("lDu2T", function(module, exports) {
    $parcel$export(module.exports, "LoadingPhaseManager", ()=>$c284a07391432f3b$export$6e4bfef9e80c7eb0);
    var $5uXOq = parcelRequire("5uXOq");
    var $lsa9q;
    var $j7rCb;
    const $c284a07391432f3b$export$6e4bfef9e80c7eb0 = ()=>{
        const [{ hasLoaded: hasLoaded }] = (0, (0, parcelRequire("lsa9q")).default)();
        const { resetPhase: resetPhase, startNextPhase: startNextPhase } = (0, (0, parcelRequire("j7rCb")).useLazyPhase)();
        (0, $5uXOq.useEffect)(()=>{
            if (hasLoaded) {
                performance.mark('rll-after-paint-phase');
                startNextPhase();
            } else resetPhase();
        }, [
            hasLoaded,
            resetPhase,
            startNextPhase
        ]);
        return null;
    };
});
parcelRegister("jnXgM", function(module, exports) {
    $parcel$export(module.exports, "TrackClicksBeforeTTI", ()=>$0e1519f86dabd57c$export$2846c12b8c092470);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $6yXtV;
    const $0e1519f86dabd57c$var$cleanUrl = (pathname)=>{
        let url = pathname.replace(/\/$/, '');
        if (/\/browse\/\w+$/.test(url)) url = 'browse';
        if (/[A-Z][A-Z0-9]+(-[\d]+)*/g.test(url)) url = url.replace(/[A-Z][A-Z0-9]+(-[\d]+)*/g, 'XX');
        return url;
    };
    const $0e1519f86dabd57c$export$2846c12b8c092470 = ()=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isReady) return;
            try {
                const sessionStorageItems = sessionStorage.getItem('clicks-before-tti');
                if (sessionStorageItems == null || sessionStorageItems === '') return;
                const items = JSON.parse(sessionStorageItems);
                items.forEach((item)=>{
                    let extras = {
                        elementId: item.dataId,
                        currentUrl: $0e1519f86dabd57c$var$cleanUrl(item.currentUrl),
                        bundleId: item.bundleId,
                        time: item.time
                    };
                    if (item.redirectUrl !== '') extras = {
                        ...extras,
                        redirectUrl: $0e1519f86dabd57c$var$cleanUrl(item.redirectUrl)
                    };
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
                        action: 'clicked'
                    }), 'nonInteractiveElement clicked', '', extras);
                });
                sessionStorage.removeItem('clicks-before-tti');
            } catch (error) {
                console.error(error);
            }
        }, [
            createAnalyticsEvent,
            isReady
        ]);
        return null;
    };
});
parcelRegister("2by6O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bnKSn")
    ]).then(()=>parcelRequire('6kz4R'));
});
parcelRegister("aQHAS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kpDDc").then(()=>parcelRequire('a8CW2'));
});
parcelRegister("i1RfD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("humN1").then(()=>parcelRequire('7l6f4'));
});
parcelRegister("iRWz9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("pGAVo").then(()=>parcelRequire('hfEgP'));
});
parcelRegister("eiE7i", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7H2mF").then(()=>parcelRequire('1GckT'));
});
parcelRegister("lGCVr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3TwVo").then(()=>parcelRequire('aUZKu'));
});
parcelRegister("gmCnE", function(module, exports) {
    $parcel$export(module.exports, "Banner", ()=>$08223c6bc94e2fa4$export$3b4e64e77073e307);
    var $5uXOq = parcelRequire("5uXOq");
    var $gwIPs;
    var $2Upgn;
    var $co1wz;
    var $7XYc4;
    var $4R6GH;
    var $asgRx;
    var $6ohPr;
    var $3HwlS;
    var $iqLcb;
    var $9L6Zg;
    var $gk4cG;
    var $adRnT;
    var $iaN8D;
    var $14pJv;
    var $921us;
    var $9Cdg4;
    var $aAExw;
    var $9ylrc;
    var $l8ruj;
    var $dm0Uk;
    const $08223c6bc94e2fa4$var$TEST_ID = 'page-layout.banner';
    const $08223c6bc94e2fa4$export$496ffd8dda3bf451 = ()=>{
        const banner = (0, (0, parcelRequire("9L6Zg")).useBanner)();
        return banner.isEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "banner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Banner), {
            height: banner.height,
            testId: $08223c6bc94e2fa4$var$TEST_ID
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($08223c6bc94e2fa4$var$BannerContent, {
            bannerName: banner.name
        }))) : null;
    };
    const $08223c6bc94e2fa4$export$b5cfff585ada92ce = ()=>{
        const banner = (0, (0, parcelRequire("9L6Zg")).useBanner)();
        return banner.isEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "banner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dm0Uk")).ZIndexWrapper), {
            zIndex: (0, (0, parcelRequire("gwIPs")).layers).banner
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Banner), {
            height: banner.height
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($08223c6bc94e2fa4$var$BannerContent, {
            bannerName: banner.name
        })))) : null;
    };
    const $08223c6bc94e2fa4$var$BannerContent = ({ bannerName: bannerName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, bannerName === (0, (0, parcelRequire("gk4cG")).NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adRnT")).BannerAnnouncementAsync), null), bannerName === (0, (0, parcelRequire("asgRx")).BANNER_NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ohPr")).IPBlocklistingBannerAsync), null), bannerName === (0, (0, parcelRequire("aAExw")).BANNER_NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ylrc")).ReturnToMobileBanner), null), bannerName === (0, $91be75e714d10b24$export$41956b146268af93) && (0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-cookie-controls-banner-show') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Upgn")).CookieConsentBannerAsync), null), (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && bannerName === (0, (0, parcelRequire("iaN8D")).BANNER_NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("14pJv")).BannerTransitionAsync), null), bannerName === (0, (0, parcelRequire("921us")).BANNER_NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Cdg4")).MailExpiryBannerAsync), null));
    const $08223c6bc94e2fa4$export$3b4e64e77073e307 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $08223c6bc94e2fa4$export$496ffd8dda3bf451, $08223c6bc94e2fa4$export$b5cfff585ada92ce);
});
const $91be75e714d10b24$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $91be75e714d10b24$export$ed7cc0d417ee89e = 74;
const $91be75e714d10b24$export$ff6e18f7d82b549c = 320;
parcelRegister("2Upgn", function(module, exports) {
    $parcel$export(module.exports, "CookieConsentBannerAsync", ()=>$8357736d9e1344aa$export$f110a9cbbbd3fa3a);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $8357736d9e1344aa$var$LazyCookieConsentBanner = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("1h3FB")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
        moduleId: "./src/packages/platform/ui/banners/cookie-consent/src/ui/banner/CookieConsentBanner.tsx"
    });
    const $8357736d9e1344aa$export$f110a9cbbbd3fa3a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8357736d9e1344aa$var$boxStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "async-cookie-consent-banner",
            packageName: "jiraCookieConsentBanner",
            teamName: "Magma"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-cookie-consent-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8357736d9e1344aa$var$LazyCookieConsentBanner, null))));
    const $8357736d9e1344aa$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'elevation.surface.sunken',
        height: '100%'
    });
});
parcelRegister("1h3FB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lK1GY")
    ]).then(()=>parcelRequire('vtgYF'));
});
parcelRegister("asgRx", function(module, exports) {
    $parcel$export(module.exports, "bannerHeight", ()=>$692526aac37c19f2$export$86047f02632f9f5b);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$692526aac37c19f2$export$41956b146268af93);
    var $gwIPs;
    const $692526aac37c19f2$export$86047f02632f9f5b = (0, (0, parcelRequire("gwIPs")).gridSize) * 7;
    const $692526aac37c19f2$export$41956b146268af93 = 'IP_BLOCK_LISTING_BANNER';
});
parcelRegister("6ohPr", function(module, exports) {
    $parcel$export(module.exports, "IPBlocklistingBannerAsync", ()=>$f9467d6df1e451da$export$fafc306b802ab39d);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $f9467d6df1e451da$var$IPBlocklistingBannerComp = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fzsPN")).then((m)=>m.IPBlocklistingBanner), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/ip-block-listing-banner/src/main.tsx"
    });
    const $f9467d6df1e451da$export$fafc306b802ab39d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-ip-block-listing-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f9467d6df1e451da$var$IPBlocklistingBannerComp, null));
});
parcelRegister("fzsPN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("12K5T").then(()=>parcelRequire('h9o9V'));
});
parcelRegister("9L6Zg", function(module, exports) {
    $parcel$export(module.exports, "useBanner", ()=>$83eb9a3cdcaec997$export$de40f69ba30f2376);
    var $5uXOq = parcelRequire("5uXOq");
    var $iPh5B;
    var $co1wz;
    var $4R6GH;
    var $iMzQW;
    var $14V0U;
    var $6RMJw;
    var $hESBP;
    var $2jAre;
    var $lrZro;
    const $83eb9a3cdcaec997$var$noBanner = {
        name: null,
        height: 0,
        isEnabled: false
    };
    const $83eb9a3cdcaec997$export$de40f69ba30f2376 = ()=>{
        const [isChromeless] = (0, (0, parcelRequire("14V0U")).useIsChromeless)();
        const announcement = (0, (0, parcelRequire("6RMJw")).useBannerAnnouncement)();
        const transition = (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') ? (0, (0, parcelRequire("hESBP")).useBannerEocTransition)() : undefined;
        const returnToMobile = (0, (0, parcelRequire("lrZro")).useBannerReturnToMobile)();
        const IPBlocklisting = (0, (0, parcelRequire("iMzQW")).useBannerIPBlocklisting)();
        const cookieConsent = (0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-cookie-controls-banner-show') ? (0, (0, parcelRequire("iPh5B")).useBannerCookieConsent)() : undefined;
        const mailExpiry = (0, (0, parcelRequire("2jAre")).useBannerMailExpiry)();
        return (0, $5uXOq.useMemo)(()=>{
            if (cookieConsent?.isEnabled) return cookieConsent;
            if (isChromeless) return $83eb9a3cdcaec997$var$noBanner;
            if (IPBlocklisting.isEnabled) return IPBlocklisting;
            if (returnToMobile.isEnabled) return returnToMobile;
            if (announcement.isEnabled) return announcement;
            if (transition?.isEnabled) return transition;
            if (mailExpiry?.isEnabled) return mailExpiry;
            return $83eb9a3cdcaec997$var$noBanner;
        }, [
            cookieConsent,
            isChromeless,
            IPBlocklisting,
            returnToMobile,
            announcement,
            transition,
            mailExpiry
        ]);
    };
});
parcelRegister("iPh5B", function(module, exports) {
    $parcel$export(module.exports, "useBannerCookieConsent", ()=>$e552544bdd302edb$export$c7a51b5ee06f5794);
    var $5uXOq = parcelRequire("5uXOq");
    var $21KEY;
    var $aqpLW;
    var $3TzYp;
    var $co1wz;
    var $e5wyW;
    var $2eyDn;
    var $gubdC;
    const $e552544bdd302edb$export$5503c67b1001ec45 = (data)=>{
        try {
            const shouldShowBannerBit = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("21KEY")).ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
            const shouldShowBannerBitState = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
            return data && (0, (0, parcelRequire("aqpLW")).shouldRenderBannerPrefetched)(data) || shouldShowBannerBitState;
        } catch (e) {
            return true;
        }
    };
    const $e552544bdd302edb$var$useBannerCookieConsentV2 = ()=>{
        const [{ isDismissed: isDismissed, height: height }, { onShow: onShow }] = (0, (0, parcelRequire("gubdC")).useCookieConsentBannerSettings)();
        const { data: data } = (0, (0, parcelRequire("2eyDn")).useConsentBannerUserPreferencesResource)();
        (0, $5uXOq.useEffect)(()=>{
            const shouldRender = $e552544bdd302edb$export$5503c67b1001ec45(data);
            if (shouldRender && !(0, (0, parcelRequire("gubdC")).isInIframe)()) onShow();
        }, [
            data,
            onShow
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: !isDismissed,
                name: (0, $91be75e714d10b24$export$41956b146268af93),
                height: height
            }), [
            isDismissed,
            height
        ]);
    };
    const $e552544bdd302edb$var$useBannerCookieConsentV1 = ()=>{
        const [{ isDismissed: isDismissed, height: height }] = (0, (0, parcelRequire("gubdC")).useCookieConsentBannerSettings)();
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: !isDismissed,
                name: (0, $91be75e714d10b24$export$41956b146268af93),
                height: height
            }), [
            isDismissed,
            height
        ]);
    };
    const $e552544bdd302edb$export$c7a51b5ee06f5794 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('platform.moonjelly.browser-storage-controls-v2'), $e552544bdd302edb$var$useBannerCookieConsentV2, $e552544bdd302edb$var$useBannerCookieConsentV1);
});
parcelRegister("aqpLW", function(module, exports) {
    $parcel$export(module.exports, "shouldRenderBannerPrefetched", ()=>$a183f8f7d6fe637a$export$6406464aa126433e);
    var $VSDnB;
    var $jhSue;
    var $gHrGQ;
    var $bKAlw;
    const $a183f8f7d6fe637a$export$6406464aa126433e = (prefetchedPreferencesData)=>{
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_moonjelly_bsc_ssr_killswitch')) return false;
        if (!prefetchedPreferencesData) return true;
        if ('consentToken' in prefetchedPreferencesData) {
            const { isValid: isValid } = (0, (0, parcelRequire("gHrGQ")).checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
            return isValid ? (0, (0, parcelRequire("bKAlw")).getBannerVisibility)(prefetchedPreferencesData) : true;
        }
        const consentPrefsData = (0, (0, parcelRequire("jhSue")).buildConsentPreferences)(prefetchedPreferencesData);
        return (0, (0, parcelRequire("bKAlw")).getBannerVisibility)(consentPrefsData);
    };
});
parcelRegister("jhSue", function(module, exports) {
    $parcel$export(module.exports, "buildConsentPreferences", ()=>$356623899ad2d63f$export$bd9f5bcbf9cd947c);
    $parcel$export(module.exports, "fetchConsentPreferences", ()=>$356623899ad2d63f$export$86467566615ab85e);
    $parcel$export(module.exports, "saveConsentPreferences", ()=>$356623899ad2d63f$export$f8422650c3dec8b2);
    var $Dyz2r;
    var $bF6aU;
    const $356623899ad2d63f$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
    const $356623899ad2d63f$var$POST_CONSENTS_URL = `${$356623899ad2d63f$var$BASE_CONSENTS_URL}/user`;
    const $356623899ad2d63f$var$GET_CONSENTS_URL = `${$356623899ad2d63f$var$POST_CONSENTS_URL}/consents/cookies`;
    const $356623899ad2d63f$export$bd9f5bcbf9cd947c = (consentData)=>{
        if (consentData) {
            const serializedConsents = (0, (0, parcelRequire("bF6aU")).serializeConsents)(consentData);
            const consentTimestamp = (0, (0, parcelRequire("bF6aU")).getConsentTimestamp)(consentData);
            return {
                consentToken: serializedConsents,
                consentTimestamp: consentTimestamp
            };
        }
        return {
            consentToken: (0, (0, parcelRequire("bF6aU")).serializeConsents)({}),
            consentHubInaccessible: true
        };
    };
    const $356623899ad2d63f$export$86467566615ab85e = async ()=>{
        const { origin: origin } = window.location;
        const getFromConsentHubURL = `${origin}${$356623899ad2d63f$var$GET_CONSENTS_URL}`;
        try {
            const response = await fetch(getFromConsentHubURL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
            const consentData = await response.json();
            return $356623899ad2d63f$export$bd9f5bcbf9cd947c(consentData);
        } catch (err) {
            (0, (0, parcelRequire("Dyz2r")).Logger).errorWithOperationalEvent({
                action: 'fetchConsentPreferencesError',
                message: err.message || ''
            });
            return $356623899ad2d63f$export$bd9f5bcbf9cd947c();
        }
    };
    const $356623899ad2d63f$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
        const { origin: origin, pathname: pathname } = window.location;
        const deserializedConsents = (0, (0, parcelRequire("bF6aU")).deserializeConsents)(unpackedUserPreferences, displayedTextMap);
        const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
        const consentRequestBody = {
            action: action,
            consents: deserializedConsents,
            formUrl: `${origin}${pathname}`,
            locale: 'UNKNOWN',
            site: 'atlassian',
            source: 'COOKIE_PREFERENCES'
        };
        return JSON.stringify(consentRequestBody);
    };
    const $356623899ad2d63f$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
        const saveToConsentHubURL = `${window.location.origin}${$356623899ad2d63f$var$POST_CONSENTS_URL}`;
        try {
            const response = await fetch(saveToConsentHubURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: $356623899ad2d63f$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
            });
            if (!response.ok || response.status !== 202 && response.status !== 200) {
                const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
                const errWithStatusCode = new (0, (0, parcelRequire("bF6aU")).StatusCodeError)(errMsg, response.status);
                throw errWithStatusCode;
            }
        } catch (err) {
            (0, (0, parcelRequire("Dyz2r")).Logger).errorWithOperationalEvent({
                action: 'saveConsentPreferencesError',
                message: err.message || ''
            });
            throw err;
        }
    };
});
parcelRegister("bF6aU", function(module, exports) {
    $parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", ()=>$abdac33f3c79bf2f$export$42b0ca8aba2631e4);
    $parcel$export(module.exports, "checkIfTokenIsDefault", ()=>$abdac33f3c79bf2f$export$497a647f0eb30ef4);
    $parcel$export(module.exports, "serializeConsents", ()=>$abdac33f3c79bf2f$export$92ba0b2fe50f90df);
    $parcel$export(module.exports, "deserializeConsents", ()=>$abdac33f3c79bf2f$export$bfa0c91662787fb0);
    $parcel$export(module.exports, "getConsentTimestamp", ()=>$abdac33f3c79bf2f$export$13e4cff933f26b03);
    $parcel$export(module.exports, "checkIfConsentsAreStale", ()=>$abdac33f3c79bf2f$export$3387347b75450ae1);
    $parcel$export(module.exports, "StatusCodeError", ()=>$abdac33f3c79bf2f$export$a79c0ea3d7c2444a);
    var $fp1RH;
    var $21KEY;
    var $4uHy1;
    var $8FFpF;
    var $hqc2A;
    const $abdac33f3c79bf2f$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
        const version = consentToken[0] + consentToken[1] + consentToken[2];
        const isV2Schema = version === (0, (0, parcelRequire("21KEY")).V002_SCHEMA_KEY);
        return isV2Schema;
    };
    const $abdac33f3c79bf2f$var$isLegacyV1Token = (consentToken)=>{
        const version = consentToken[0] + consentToken[1] + consentToken[2];
        const isV1Schema = version === (0, (0, parcelRequire("21KEY")).V001_SCHEMA_KEY);
        return isV1Schema;
    };
    const $abdac33f3c79bf2f$export$42b0ca8aba2631e4 = (consentToken)=>{
        if ($abdac33f3c79bf2f$var$isLegacyGeoTargetingV2Token(consentToken)) {
            const consentedUnderGDPR = consentToken[8] === '1';
            const consentedUnderCPRA = consentToken[9] === '1';
            const consentedUnderLGPD = consentToken[10] === '1';
            const consentedUnderFADP = consentToken[11] === '1';
            const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
            return hasConsentedPreviously;
        }
        return false;
    };
    const $abdac33f3c79bf2f$export$497a647f0eb30ef4 = (consentToken)=>{
        const isLegacyV2ConsentToken = $abdac33f3c79bf2f$var$isLegacyGeoTargetingV2Token(consentToken);
        const isLegacyV1ConsentToken = $abdac33f3c79bf2f$var$isLegacyV1Token(consentToken);
        if (isLegacyV2ConsentToken) {
            const legacyTokenHasConsents = $abdac33f3c79bf2f$export$42b0ca8aba2631e4(consentToken);
            return !legacyTokenHasConsents;
        }
        if (isLegacyV1ConsentToken) return false;
        const isDefaultToken = (0, (0, parcelRequire("fp1RH")).getBoolFromBitValue)(consentToken[7]);
        return isDefaultToken;
    };
    const $abdac33f3c79bf2f$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
        const version = (0, (0, parcelRequire("21KEY")).V003_SCHEMA_KEY);
        const serializedBits = Object.entries((0, (0, parcelRequire("21KEY")).DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
            if (key === (0, (0, parcelRequire("8FFpF")).PreferenceCategory).StrictlyNecessary) return acc;
            if (key === (0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).UserIsAuthenticated) {
                const userIsAuthed = !consentsUnavailable;
                return acc + (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userIsAuthed);
            }
            if (key === (0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).ConsentDataUnavailable) return acc + (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(!!consentsUnavailable);
            return acc + (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(val);
        }, '');
        return `${version}${serializedBits}`;
    };
    const $abdac33f3c79bf2f$export$42a0b3fb1e53e7b9 = (consents)=>{
        const version = (0, (0, parcelRequire("21KEY")).V003_SCHEMA_KEY);
        const functionalConsent = (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(!!consents.find((key)=>key.key === (0, (0, parcelRequire("hqc2A")).ConsentHubKey).Functional)?.granted);
        const analyticsConsent = (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(!!consents.find((key)=>key.key === (0, (0, parcelRequire("hqc2A")).ConsentHubKey).Analytics)?.granted);
        const marketingConsent = (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(!!consents.find((key)=>key.key === (0, (0, parcelRequire("hqc2A")).ConsentHubKey).Marketing)?.granted);
        const unknownConsent = (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(!!consents.find((key)=>key.key === (0, (0, parcelRequire("hqc2A")).ConsentHubKey).Unknown)?.granted);
        const isDefaultToken = 0;
        const userIsAuthenticated = 1;
        const consentHubDataUnavailable = 0;
        return [
            version,
            functionalConsent,
            analyticsConsent,
            marketingConsent,
            unknownConsent,
            isDefaultToken,
            userIsAuthenticated,
            consentHubDataUnavailable
        ].join('');
    };
    const $abdac33f3c79bf2f$export$92ba0b2fe50f90df = ({ consents: consents })=>{
        if (!consents) {
            const existingFallbackToken = (0, (0, parcelRequire("4uHy1")).getCookie)((0, (0, parcelRequire("21KEY")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
            if (existingFallbackToken) return existingFallbackToken;
            return $abdac33f3c79bf2f$export$c42e1a74e60f4d73(true);
        } else if (consents.length === 0) return $abdac33f3c79bf2f$export$c42e1a74e60f4d73();
        else return $abdac33f3c79bf2f$export$42a0b3fb1e53e7b9(consents);
    };
    const $abdac33f3c79bf2f$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
        const validConsentHubCookieConsents = [
            (0, (0, parcelRequire("8FFpF")).PreferenceCategory).StrictlyNecessary,
            (0, (0, parcelRequire("8FFpF")).PreferenceCategory).Functional,
            (0, (0, parcelRequire("8FFpF")).PreferenceCategory).Analytics,
            (0, (0, parcelRequire("8FFpF")).PreferenceCategory).Marketing,
            (0, (0, parcelRequire("8FFpF")).PreferenceCategory).Unknown
        ];
        const consentKeyMap = {
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).StrictlyNecessary]: (0, (0, parcelRequire("hqc2A")).ConsentHubKey).StrictlyNecessary,
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Functional]: (0, (0, parcelRequire("hqc2A")).ConsentHubKey).Functional,
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Analytics]: (0, (0, parcelRequire("hqc2A")).ConsentHubKey).Analytics,
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Marketing]: (0, (0, parcelRequire("hqc2A")).ConsentHubKey).Marketing,
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Unknown]: (0, (0, parcelRequire("hqc2A")).ConsentHubKey).Unknown
        };
        const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
            const key = consentKeyMap[consentKey];
            return {
                key: key,
                granted: !!unpackedUserPreferences[consentKey],
                gatheredTs: new Date().toISOString(),
                displayedText: displayedTextMap[consentKey]
            };
        });
        return consentRecords;
    };
    const $abdac33f3c79bf2f$export$13e4cff933f26b03 = ({ consents: consents })=>{
        if (consents && consents.length) {
            const timestamps = consents.map((consent)=>{
                return new Date(consent.updatedTs).getTime();
            });
            const maxTimestamp = Math.max(...timestamps);
            const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
            return mostRecentConsentTimestamp;
        }
    };
    const $abdac33f3c79bf2f$export$3387347b75450ae1 = (consentTimestamp)=>{
        let consentedOverAYearAgo = false;
        if (consentTimestamp) {
            const oneYearAgo = new Date();
            oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
            consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
        }
        return consentedOverAYearAgo;
    };
    class $abdac33f3c79bf2f$export$a79c0ea3d7c2444a extends Error {
        constructor(message, status){
            super(message);
            this.status = status;
            Object.setPrototypeOf(this, $abdac33f3c79bf2f$export$a79c0ea3d7c2444a.prototype);
            if (Error.captureStackTrace) Error.captureStackTrace(this, $abdac33f3c79bf2f$export$a79c0ea3d7c2444a);
            this.name = 'StatusCodeError';
        }
    }
});
parcelRegister("fp1RH", function(module, exports) {
    $parcel$export(module.exports, "getBitValueFromBool", ()=>$ef15319bdc068a40$export$929f1500428a1fc8);
    $parcel$export(module.exports, "getBoolFromBitValue", ()=>$ef15319bdc068a40$export$27647458f3cf29d2);
    const $ef15319bdc068a40$export$929f1500428a1fc8 = (value)=>{
        return Number(value).toString();
    };
    const $ef15319bdc068a40$export$27647458f3cf29d2 = (bitValue)=>{
        if (bitValue) return !!Number(bitValue);
    };
});
parcelRegister("hqc2A", function(module, exports) {
    $parcel$export(module.exports, "ConsentHubKey", ()=>$2d8cccb1496bcaa8$export$31140359b1e505cf);
    var $2d8cccb1496bcaa8$export$31140359b1e505cf;
    (function(ConsentHubKey) {
        ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
        ConsentHubKey["Functional"] = "functionalCookies";
        ConsentHubKey["Analytics"] = "performanceCookies";
        ConsentHubKey["Marketing"] = "targetingCookies";
        ConsentHubKey["Unknown"] = "unknownCookies";
    })($2d8cccb1496bcaa8$export$31140359b1e505cf || ($2d8cccb1496bcaa8$export$31140359b1e505cf = {}));
});
parcelRegister("gHrGQ", function(module, exports) {
    $parcel$export(module.exports, "checkTokenVersionValidity", ()=>$f95b7e0a4ae57e4e$export$64b31470e8522819);
    $parcel$export(module.exports, "packUserPreferences", ()=>$f95b7e0a4ae57e4e$export$3199823fec979bd1);
    $parcel$export(module.exports, "unpackUserPreferencesCookie", ()=>$f95b7e0a4ae57e4e$export$8d213cb390bab4fa);
    $parcel$export(module.exports, "initialPreferencesAreMissing", ()=>$f95b7e0a4ae57e4e$export$67f70eb55341bd29);
    $parcel$export(module.exports, "initializePreferencesData", ()=>$f95b7e0a4ae57e4e$export$7962405c3ca274b1);
    var $gMWuT;
    var $fp1RH;
    var $21KEY;
    var $bF6aU;
    var $8FFpF;
    const $f95b7e0a4ae57e4e$export$64b31470e8522819 = (consentToken)=>{
        if (consentToken.length < 3) return {
            isValid: false,
            isV001: false,
            isV002: false,
            isV003: false
        };
        const version = consentToken[0] + consentToken[1] + consentToken[2];
        const isV001 = version === (0, (0, parcelRequire("21KEY")).V001_SCHEMA_KEY) && consentToken.length === 7;
        const isV002 = version === (0, (0, parcelRequire("21KEY")).V002_SCHEMA_KEY) && consentToken.length === 12;
        const isV003 = version === (0, (0, parcelRequire("21KEY")).V003_SCHEMA_KEY) && consentToken.length === 10;
        const isSupportedVersion = [
            (0, (0, parcelRequire("21KEY")).V001_SCHEMA_KEY),
            (0, (0, parcelRequire("21KEY")).V002_SCHEMA_KEY),
            (0, (0, parcelRequire("21KEY")).V003_SCHEMA_KEY)
        ].includes(version);
        const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
        return {
            isValid: isValid,
            isV001: isV001,
            isV002: isV002,
            isV003: isV003
        };
    };
    const $f95b7e0a4ae57e4e$var$packPrefsVersion001 = (userPreferences)=>{
        const version = (0, (0, parcelRequire("21KEY")).V001_SCHEMA_KEY);
        return [
            version,
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences.FUNCTIONAL),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences.ANALYTICS),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences.MARKETING),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences.UNKNOWN)
        ].join('');
    };
    const $f95b7e0a4ae57e4e$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
        if (userPreferencesCookie.length !== 7) return;
        return {
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).StrictlyNecessary]: true,
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
        };
    };
    const $f95b7e0a4ae57e4e$var$packPrefsVersion002 = (userPreferences)=>{
        const version = (0, (0, parcelRequire("21KEY")).V003_SCHEMA_KEY);
        const hasConsentedPreviously = userPreferences[(0, (0, parcelRequire("8FFpF")).ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, (0, parcelRequire("8FFpF")).ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, (0, parcelRequire("8FFpF")).ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, (0, parcelRequire("8FFpF")).ConsentPreferenceV2).ConsentedUnderFADP];
        const isDefaultConsentBit = !hasConsentedPreviously;
        const existingConsentDataUnavailableBit = userPreferences[(0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).ConsentDataUnavailable];
        const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
        return [
            version,
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Functional]),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Analytics]),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Marketing]),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Unknown]),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(isDefaultConsentBit),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userIsAuthenticatedBit),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(existingConsentDataUnavailableBit)
        ].join('');
    };
    const $f95b7e0a4ae57e4e$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
        const isADefaultConsentToken = (0, (0, parcelRequire("bF6aU")).checkIfTokenIsDefault)(userPreferencesCookie);
        const consentDataUnavailable = userPreferencesCookie[7] === '1';
        const userIsDeemedAuthenticated = !consentDataUnavailable;
        return {
            ...$f95b7e0a4ae57e4e$var$unpackPrefsVersion003(userPreferencesCookie),
            [(0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
            [(0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
            [(0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
        };
    };
    const $f95b7e0a4ae57e4e$var$packPrefsVersion003 = (userPreferences)=>{
        const version = (0, (0, parcelRequire("21KEY")).V003_SCHEMA_KEY);
        return [
            version,
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Functional]),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Analytics]),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Marketing]),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Unknown]),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).ConsentsAreDefault]),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).UserIsAuthenticated]),
            (0, (0, parcelRequire("fp1RH")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).ConsentDataUnavailable])
        ].join('');
    };
    const $f95b7e0a4ae57e4e$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
        return {
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).StrictlyNecessary]: true,
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
            [(0, (0, parcelRequire("8FFpF")).PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
            [(0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
            [(0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
            [(0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
        };
    };
    const $f95b7e0a4ae57e4e$var$V002SpecificBitKeys = [
        (0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).ConsentDataUnavailable,
        (0, (0, parcelRequire("8FFpF")).ConsentPreferenceV2).ConsentedUnderGDPR,
        (0, (0, parcelRequire("8FFpF")).ConsentPreferenceV2).ConsentedUnderCPRA,
        (0, (0, parcelRequire("8FFpF")).ConsentPreferenceV2).ConsentedUnderLGPD,
        (0, (0, parcelRequire("8FFpF")).ConsentPreferenceV2).ConsentedUnderFADP
    ];
    const $f95b7e0a4ae57e4e$var$V003SpecificBitKeys = [
        (0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).ConsentsAreDefault,
        (0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).UserIsAuthenticated,
        (0, (0, parcelRequire("8FFpF")).ContextualConsentProperty).ConsentDataUnavailable
    ];
    function $f95b7e0a4ae57e4e$export$3199823fec979bd1(userPreferences) {
        if ((0, (0, parcelRequire("gMWuT")).getBscGlobalState)().localConsentMode) return $f95b7e0a4ae57e4e$var$packPrefsVersion001(userPreferences);
        const isV002 = $f95b7e0a4ae57e4e$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
        if (isV002) return $f95b7e0a4ae57e4e$var$packPrefsVersion002(userPreferences);
        const isV003 = $f95b7e0a4ae57e4e$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
        if (isV003) return $f95b7e0a4ae57e4e$var$packPrefsVersion003(userPreferences);
        return $f95b7e0a4ae57e4e$var$packPrefsVersion001(userPreferences);
    }
    function $f95b7e0a4ae57e4e$export$8d213cb390bab4fa(userPreferencesCookie) {
        if ((0, (0, parcelRequire("gMWuT")).getBscGlobalState)().localConsentMode) {
            if (userPreferencesCookie.length < 3) return;
            const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
            if (version === (0, (0, parcelRequire("21KEY")).V001_SCHEMA_KEY)) return $f95b7e0a4ae57e4e$var$unpackPrefsVersion001(userPreferencesCookie);
            return;
        }
        const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $f95b7e0a4ae57e4e$export$64b31470e8522819(userPreferencesCookie);
        if (!isValid) return;
        if (isV001) return $f95b7e0a4ae57e4e$var$unpackPrefsVersion001(userPreferencesCookie);
        if (isV002) return $f95b7e0a4ae57e4e$var$unpackPrefsVersion002(userPreferencesCookie);
        if (isV003) return $f95b7e0a4ae57e4e$var$unpackPrefsVersion003(userPreferencesCookie);
    }
    const $f95b7e0a4ae57e4e$export$67f70eb55341bd29 = (initialPreferences)=>{
        if (!initialPreferences) return true;
        const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
        return prefExistButAreEmpty;
    };
    const $f95b7e0a4ae57e4e$export$7962405c3ca274b1 = (initialPreferences)=>{
        if (initialPreferences !== (0, (0, parcelRequire("8FFpF")).PrefetchedPreferenceState).INTERNAL) {
            if ($f95b7e0a4ae57e4e$export$67f70eb55341bd29(initialPreferences)) return {
                prefs: undefined,
                isPrefetchedPrefsInternalState: true
            };
            const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
            if (consentToken) {
                const unpackedExistingPrefs = $f95b7e0a4ae57e4e$export$8d213cb390bab4fa(consentToken);
                return {
                    prefs: unpackedExistingPrefs,
                    isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
                };
            }
            if (initialPreferences && 'consents' in initialPreferences) {
                const serializedPrefetchedConsentToken = (0, (0, parcelRequire("bF6aU")).serializeConsents)(initialPreferences);
                const unpackedPrefetchedPrefs = $f95b7e0a4ae57e4e$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
                return {
                    prefs: unpackedPrefetchedPrefs,
                    isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
                };
            }
        }
        if (initialPreferences === (0, (0, parcelRequire("8FFpF")).PrefetchedPreferenceState).INTERNAL) return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: false
        };
    };
});
parcelRegister("bKAlw", function(module, exports) {
    $parcel$export(module.exports, "getBannerVisibility", ()=>$1263eb185d4160b0$export$bfdb9f82a9194c1e);
    var $ljmYJ;
    var $fp1RH;
    var $21KEY;
    var $bF6aU;
    var $4uHy1;
    var $gHrGQ;
    const $1263eb185d4160b0$var$getUserIsAuthenticatedBit = (consentToken)=>{
        const { isV002: isV002 } = (0, (0, parcelRequire("gHrGQ")).checkTokenVersionValidity)(consentToken);
        let userIsAuthenticatedBit = consentToken[8];
        if (isV002) {
            const legacyV2ConsentDataUnavailableBit = consentToken[7];
            userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
        }
        return userIsAuthenticatedBit;
    };
    const $1263eb185d4160b0$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
        if (fallbackConsentToken) {
            const fallbackUserIsAuthenticatedBit = $1263eb185d4160b0$var$getUserIsAuthenticatedBit(fallbackConsentToken);
            const isLoggedOutFallbackConsents = !(0, (0, parcelRequire("fp1RH")).getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
            const fallbackTokenHasGenuineConsents = !(0, (0, parcelRequire("bF6aU")).checkIfTokenIsDefault)(fallbackConsentToken);
            const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
            if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
            const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
            if (loggedOutUserPreviouslyConsentedWhileLoggedIn) return false;
        }
        return true;
    };
    const $1263eb185d4160b0$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
        const tokenIsADefaultConsent = !!(0, (0, parcelRequire("bF6aU")).checkIfTokenIsDefault)(consentToken);
        if (tokenIsADefaultConsent) return $1263eb185d4160b0$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
        const localOnlyUserHasConsented = (0, (0, parcelRequire("bF6aU")).hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
        if (localOnlyUserHasConsented) return fallbackConsentToken ? false : true;
        return true;
    };
    const $1263eb185d4160b0$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
        if (fallbackConsentToken) {
            const fallbackUserIsAuthenticatedBit = $1263eb185d4160b0$var$getUserIsAuthenticatedBit(fallbackConsentToken);
            const isLoggedOutFallbackConsents = !(0, (0, parcelRequire("fp1RH")).getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
            const fallbackTokenHasGenuineConsents = !(0, (0, parcelRequire("bF6aU")).checkIfTokenIsDefault)(fallbackConsentToken);
            if (fallbackTokenHasGenuineConsents) {
                if (isLoggedOutFallbackConsents) return true;
                return false;
            }
            return true;
        }
        return true;
    };
    const $1263eb185d4160b0$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
        const tokenIsADefaultConsent = !!(0, (0, parcelRequire("bF6aU")).checkIfTokenIsDefault)(consentToken);
        if (tokenIsADefaultConsent) return $1263eb185d4160b0$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
        if (consentTimestamp) {
            const showBannerIfStale = (0, (0, parcelRequire("bF6aU")).checkIfConsentsAreStale)(consentTimestamp);
            return showBannerIfStale;
        }
        return fallbackConsentToken ? false : true;
    };
    const $1263eb185d4160b0$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
        const fallbackConsentToken = (0, (0, parcelRequire("ljmYJ")).isSSR)() ? fallbackConsents : fallbackConsents || (0, (0, parcelRequire("4uHy1")).getCookie)((0, (0, parcelRequire("21KEY")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        let userIsAuthenticatedBit = $1263eb185d4160b0$var$getUserIsAuthenticatedBit(consentToken);
        const isLoggedOutConsentToken = !(0, (0, parcelRequire("fp1RH")).getBoolFromBitValue)(userIsAuthenticatedBit);
        let isBannerVisible = true;
        if (isLoggedOutConsentToken) isBannerVisible = $1263eb185d4160b0$var$shouldShowBannerForLoggedOutUser({
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken
        });
        else isBannerVisible = $1263eb185d4160b0$var$shouldShowBannerForLoggedInUser({
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken,
            consentTimestamp: consentTimestamp
        });
        return isBannerVisible;
    };
});
parcelRegister("gubdC", function(module, exports) {
    $parcel$export(module.exports, "isInIframe", ()=>$53f6acf0285fde21$export$9f140ed41af5108c);
    $parcel$export(module.exports, "useCookieConsentBannerSettings", ()=>$53f6acf0285fde21$export$ae97931560f092a4);
    $parcel$export(module.exports, "useCookieConsentBannerSettingsActions", ()=>$53f6acf0285fde21$export$ecbab4dc5f9ad844);
    var $gKZoD;
    var $4uHy1;
    var $21KEY;
    var $co1wz;
    var $3sQ5x;
    var $iXqE5;
    function $53f6acf0285fde21$export$8d213cb390bab4fa(userPreferencesCookie) {
        if (userPreferencesCookie.length < 3) return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version !== '001') return;
        if (userPreferencesCookie.length !== 7) return;
        return {
            STRICTLY_NECESSARY: true,
            FUNCTIONAL: userPreferencesCookie[3] === '1',
            ANALYTICS: userPreferencesCookie[4] === '1',
            MARKETING: userPreferencesCookie[5] === '1',
            UNKNOWN: userPreferencesCookie[6] === '1'
        };
    }
    const $53f6acf0285fde21$export$1de6a888ae076ff8 = ()=>{
        if (false) return undefined;
        const packedPrefs = (0, (0, parcelRequire("4uHy1")).getCookie)((0, (0, parcelRequire("21KEY")).LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return $53f6acf0285fde21$export$8d213cb390bab4fa(packedPrefs);
    };
    const $53f6acf0285fde21$export$9f140ed41af5108c = ()=>{
        (0, (0, parcelRequire("gKZoD")).di)(window);
        if (false) return false;
        return window !== window.top;
    };
    const $53f6acf0285fde21$export$aa1483cc2e197f6e = ()=>{
        if (false) return false;
        if ((0, (0, parcelRequire("co1wz")).ff)('platform.moonjelly.browser-storage-controls-v2')) return true;
        return $53f6acf0285fde21$export$1de6a888ae076ff8() !== undefined || $53f6acf0285fde21$export$9f140ed41af5108c();
    };
    const $53f6acf0285fde21$export$d4c72bab9d6cc13a = {
        isDismissed: $53f6acf0285fde21$export$aa1483cc2e197f6e(),
        height: 0
    };
    const $53f6acf0285fde21$export$e324594224ef24da = {
        onShow: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isDismissed: false
                });
            },
        onDismiss: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isDismissed: true
                });
            },
        setHeight: (height)=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    height: height
                });
            }
    };
    const $53f6acf0285fde21$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'cookie-consent-banner',
        initialState: $53f6acf0285fde21$export$d4c72bab9d6cc13a,
        actions: $53f6acf0285fde21$export$e324594224ef24da
    });
    const $53f6acf0285fde21$export$ae97931560f092a4 = (0, (0, parcelRequire("3sQ5x")).createHook)($53f6acf0285fde21$var$Store);
    const $53f6acf0285fde21$export$ecbab4dc5f9ad844 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($53f6acf0285fde21$var$Store);
});
parcelRegister("iMzQW", function(module, exports) {
    $parcel$export(module.exports, "useBannerIPBlocklisting", ()=>$014906e38669dbae$export$564412c1d9cd4ccc);
    var $5uXOq = parcelRequire("5uXOq");
    var $9B86Q;
    var $asgRx;
    const $014906e38669dbae$export$564412c1d9cd4ccc = ()=>{
        const [shouldShowBanner, setBannerState] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/global-components/ipblocklisting/bridge'
            }).then((bridge)=>{
                bridge({
                    showIPBlocklistBanner: ()=>setBannerState(true),
                    hideIPBlocklistBanner: ()=>setBannerState(false)
                });
            });
        }, []);
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: shouldShowBanner,
                name: (0, (0, parcelRequire("asgRx")).BANNER_NAME),
                height: (0, (0, parcelRequire("asgRx")).bannerHeight)
            }), [
            shouldShowBanner
        ]);
    };
});
parcelRegister("6RMJw", function(module, exports) {
    $parcel$export(module.exports, "useBannerAnnouncement", ()=>$6710252c02f204b2$export$1e775b1ab04f2888);
    var $5uXOq = parcelRequire("5uXOq");
    var $5kYzp;
    var $cZpsT;
    var $gk4cG;
    const $6710252c02f204b2$export$1e775b1ab04f2888 = ()=>{
        const { data: data } = (0, (0, parcelRequire("5kYzp")).useAnnouncementBannerSettingsV4Resource)();
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: Boolean(data?.isEnabled) && !data?.isDismissed && (data?.visibility === 'private' && !isAnonymous || data?.visibility === 'public'),
                name: (0, (0, parcelRequire("gk4cG")).NAME),
                height: (0, (0, parcelRequire("gk4cG")).HEIGHT)
            }), [
            data?.isDismissed,
            data?.isEnabled,
            data?.visibility,
            isAnonymous
        ]);
    };
});
parcelRegister("gk4cG", function(module, exports) {
    $parcel$export(module.exports, "HEIGHT", ()=>$8ea828cd42179fda$export$809d2b099693a9a8);
    $parcel$export(module.exports, "NAME", ()=>$8ea828cd42179fda$export$3c5e605ca7ade9f2);
    var $gwIPs;
    const $8ea828cd42179fda$export$809d2b099693a9a8 = (0, (0, parcelRequire("gwIPs")).gridSize) * 8;
    const $8ea828cd42179fda$export$3c5e605ca7ade9f2 = 'ANNOUNCEMENT';
});
parcelRegister("hESBP", function(module, exports) {
    $parcel$export(module.exports, "useBannerEocTransition", ()=>$304370119e420b48$export$b6539a8209f95b48);
    var $5uXOq = parcelRequire("5uXOq");
    var $ez5GD;
    var $201IG;
    var $8J6rn;
    var $itmJb;
    var $cNd4s;
    var $iaN8D;
    const $304370119e420b48$export$b6539a8209f95b48 = ()=>{
        const { data: data, error: error } = (0, (0, parcelRequire("ez5GD")).useOgConsolidationUserState)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, (0, parcelRequire("8J6rn")).useOgTenantInfo)();
        const isEnabled = Boolean((isAdmin || isSiteAdmin) && !tenantInfoError && isTransitionEligible && !error && data && (!data.isTransitionBannerDismissed || (0, (0, parcelRequire("201IG")).shouldRenderBenefitModal)({
            bannerDismissedAt: data.transitionBannerDismissedAt,
            isDismissed: data.isBenefitModalDismissed
        })));
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: isEnabled,
                name: (0, (0, parcelRequire("iaN8D")).BANNER_NAME),
                height: data && (0, (0, parcelRequire("201IG")).shouldRenderBenefitModal)({
                    bannerDismissedAt: data.transitionBannerDismissedAt
                }) ? 0 : (0, (0, parcelRequire("iaN8D")).HEIGHT)
            }), [
            data,
            isEnabled
        ]);
    };
});
parcelRegister("ez5GD", function(module, exports) {
    $parcel$export(module.exports, "useOgConsolidationUserState", ()=>$e71f39314801737b$export$c35632c02599163f);
    var $5uXOq = parcelRequire("5uXOq");
    var $89SaW;
    var $jcw0u;
    var $pa9q9;
    var $koVbs;
    var $iXaZ3;
    var $kMiZJ;
    var $9OXo1;
    var $2YP9W;
    var $fLIp1;
    const $e71f39314801737b$export$c35632c02599163f = ()=>{
        const errorRef = (0, $5uXOq.useRef)();
        const loadingRef = (0, $5uXOq.useRef)(false);
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { data: data, update: updateTransitionResource, error: transitionResourceError } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("kMiZJ")).consolidationUserStateResource));
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [userPropertiesError, setUserPropertiesError] = (0, $5uXOq.useState)();
        errorRef.current = userPropertiesError || transitionResourceError;
        const { atlassianAccountId: accountId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const update = (0, $5uXOq.useCallback)((newState)=>{
            if (errorRef.current) return Promise.reject(errorRef.current);
            let updatedData = {};
            updateTransitionResource((oldState)=>{
                updatedData = {
                    ...oldState,
                    ...newState
                };
                return updatedData;
            });
            if (accountId) {
                if (loadingRef.current) {
                    const err = new Error('User properties is loading');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraEocChangeboarding',
                            teamName: 'alexstrasza'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setUserPropertiesError(err);
                    return Promise.reject(err);
                }
                loadingRef.current = true;
                return (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, (0, parcelRequire("iXaZ3")).OG_CONSOLIDATION_USER_STATE_STORAGE_KEY), JSON.stringify(updatedData)).catch((err)=>{
                    setUserPropertiesError(new Error('Error occured while setting user properties'));
                    showFlag({
                        type: 'error',
                        isAutoDismiss: true,
                        title: formatMessage((0, (0, parcelRequire("fLIp1")).default).errorFlagTitle)
                    });
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraEocChangeboarding',
                            teamName: 'alexstrasza'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }).finally(()=>{
                    loadingRef.current = false;
                });
            }
            return Promise.resolve();
        }, [
            updateTransitionResource,
            accountId,
            formatMessage,
            showFlag
        ]);
        const reopenTransitionLozenge = (0, $5uXOq.useCallback)(()=>{
            update({
                isTransitionHomeHidden: false
            });
        }, [
            update
        ]);
        return {
            data: data,
            update: update,
            error: errorRef.current,
            reopenTransitionLozenge: reopenTransitionLozenge
        };
    };
});
parcelRegister("fLIp1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19c9811268c2fa85$export$2e2bcd8739ae039);
    var $7VHMR;
    var $19c9811268c2fa85$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title",
            "defaultMessage": "Something went wrong while updating user properties."
        }
    });
});
parcelRegister("201IG", function(module, exports) {
    $parcel$export(module.exports, "shouldRenderBenefitModal", ()=>$f068b5042603902f$export$25a52eb2dc74e2f9);
    const $f068b5042603902f$export$25a52eb2dc74e2f9 = ({ isDismissed: isDismissed, bannerDismissedAt: bannerDismissedAt })=>{
        if (!bannerDismissedAt || isDismissed) return false;
        return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
    };
});
parcelRegister("8J6rn", function(module, exports) {
    $parcel$export(module.exports, "useOgTenantInfo", ()=>$31f27587daf0b28f$export$990ea9ff15ca04f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $4R6GH;
    var $bHhiy;
    var $daoB1;
    var $2YP9W;
    var $3H5ry;
    const $31f27587daf0b28f$var$useConsolidationStateResourceRefresh = (tenantInfoResource)=>{
        const { data: data, loading: loading, refresh: refresh } = tenantInfoResource;
        const isRefreshed = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('refresh_tenant_info_on_client_for_ssr_error') && data === null && loading === false && isRefreshed.current === false) {
                refresh();
                isRefreshed.current = true;
            }
        }, [
            data,
            loading,
            refresh
        ]);
    };
    const $31f27587daf0b28f$export$990ea9ff15ca04f7 = ()=>{
        const tenantInfoResource = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)());
        const applicationPermissions = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        $31f27587daf0b28f$var$useConsolidationStateResourceRefresh(tenantInfoResource);
        if (!(0, (0, parcelRequire("4R6GH")).fg)('refresh_tenant_info_on_client_for_ssr_error') && tenantInfoResource.data === null && tenantInfoResource.loading === false && tenantInfoResource.error === null) tenantInfoResource.refresh();
        return {
            loading: tenantInfoResource.loading,
            error: tenantInfoResource.error,
            shouldUseJSM: (0, (0, parcelRequire("3H5ry")).checkShouldUseJSM)(tenantInfoResource.data),
            isConsolidated: (0, (0, parcelRequire("3H5ry")).checkIsConsolidated)(tenantInfoResource.data),
            isOpsAdmin: (0, (0, parcelRequire("4R6GH")).fg)('operations-tenant-info-endpoint-update') && (0, (0, parcelRequire("3H5ry")).checkIsOpsAdmin)(tenantInfoResource.data),
            isTransitioning: (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, (0, parcelRequire("3H5ry")).checkIsTransitioning)(tenantInfoResource.data),
            isTransitioned: (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, (0, parcelRequire("3H5ry")).checkIsTransitioned)(tenantInfoResource.data),
            isTransitionEligible: (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, (0, parcelRequire("3H5ry")).checkIsTransitionEligible)(tenantInfoResource.data),
            shouldAccessUnlockOperations: (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, (0, parcelRequire("3H5ry")).checkShouldAccessUnlockOperations)(tenantInfoResource.data),
            cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
        };
    };
});
parcelRegister("iaN8D", function(module, exports) {
    $parcel$export(module.exports, "HEIGHT", ()=>$d45809d2691157ce$export$809d2b099693a9a8);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$d45809d2691157ce$export$41956b146268af93);
    var $gwIPs;
    const $d45809d2691157ce$export$809d2b099693a9a8 = (0, (0, parcelRequire("gwIPs")).gridSize) * 6;
    const $d45809d2691157ce$export$41956b146268af93 = 'EOC_TRANSITION';
});
parcelRegister("2jAre", function(module, exports) {
    $parcel$export(module.exports, "useBannerMailExpiry", ()=>$85ae441f6f576caa$export$3906461ac9b87d2);
    var $5uXOq = parcelRequire("5uXOq");
    var $hZhhj;
    var $921us;
    var $1cxlJ;
    const $85ae441f6f576caa$export$3906461ac9b87d2 = ()=>{
        const { responseStatus: responseStatus, state: state } = (0, (0, parcelRequire("hZhhj")).useIncomingMailExpiryStatus)();
        const { onStateFetch: onStateFetch } = (0, (0, parcelRequire("1cxlJ")).useBannerActions)();
        const { isBannerShown: isBannerShown } = (0, (0, parcelRequire("1cxlJ")).useBannerState)();
        (0, $5uXOq.useEffect)(()=>{
            if (responseStatus === 'error') {
                onStateFetch((0, (0, parcelRequire("hZhhj")).DEFAULT_RESPONSE));
                return;
            }
            if (responseStatus === 'success') onStateFetch(state);
        }, [
            onStateFetch,
            responseStatus,
            state
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: isBannerShown,
                name: (0, (0, parcelRequire("921us")).BANNER_NAME),
                height: (0, (0, parcelRequire("921us")).HEIGHT)
            }), [
            isBannerShown
        ]);
    };
});
parcelRegister("921us", function(module, exports) {
    $parcel$export(module.exports, "HEIGHT", ()=>$c8abb4ba3ebc926f$export$809d2b099693a9a8);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$c8abb4ba3ebc926f$export$41956b146268af93);
    var $gwIPs;
    const $c8abb4ba3ebc926f$export$809d2b099693a9a8 = (0, (0, parcelRequire("gwIPs")).gridSize) * 6;
    const $c8abb4ba3ebc926f$export$41956b146268af93 = 'MAIL_EXPIRY_REMINDER';
});
parcelRegister("1cxlJ", function(module, exports) {
    $parcel$export(module.exports, "useBannerActions", ()=>$b47a5e6c2ea18541$export$664f3e2467f0f5af);
    $parcel$export(module.exports, "useBannerState", ()=>$b47a5e6c2ea18541$export$fa4ffa872ee90bd0);
    var $3sQ5x;
    var $iXqE5;
    const $b47a5e6c2ea18541$export$d4c72bab9d6cc13a = {
        isBannerShown: false,
        isAdmin: false,
        OauthTypes: [
            'GMAIL_OAUTH'
        ]
    };
    const $b47a5e6c2ea18541$export$e324594224ef24da = {
        onDismiss: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isBannerShown: false
                });
            },
        onStateFetch: ({ showBanner: showBanner, isAdmin: isAdmin, OauthTypes: OauthTypes = [
            'GMAIL_OAUTH'
        ] })=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isBannerShown: showBanner && isAdmin,
                    isAdmin: isAdmin,
                    OauthTypes: OauthTypes
                });
            }
    };
    const $b47a5e6c2ea18541$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'mail-expiry-banner',
        initialState: $b47a5e6c2ea18541$export$d4c72bab9d6cc13a,
        actions: $b47a5e6c2ea18541$export$e324594224ef24da
    });
    const $b47a5e6c2ea18541$export$664f3e2467f0f5af = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($b47a5e6c2ea18541$var$Store);
    const $b47a5e6c2ea18541$export$fa4ffa872ee90bd0 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($b47a5e6c2ea18541$var$Store);
});
parcelRegister("lrZro", function(module, exports) {
    $parcel$export(module.exports, "useBannerReturnToMobileState", ()=>$2d8151e19ddaa4d5$export$571311559507e90);
    $parcel$export(module.exports, "useBannerReturnToMobile", ()=>$2d8151e19ddaa4d5$export$a898dd7b7ec9917a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bCdIp;
    var $c0dQj;
    var $3sQ5x;
    var $iXqE5;
    var $aAExw;
    const $2d8151e19ddaa4d5$var$initialState = {
        isEnabled: (0, (0, parcelRequire("bCdIp")).shouldShowReturnToMobileBanner)()
    };
    const $2d8151e19ddaa4d5$var$actions = {
        disable: ()=>({ setState: setState })=>{
                setState({
                    isEnabled: false
                });
            }
    };
    const $2d8151e19ddaa4d5$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $2d8151e19ddaa4d5$var$initialState,
        actions: $2d8151e19ddaa4d5$var$actions
    });
    const $2d8151e19ddaa4d5$export$571311559507e90 = (0, (0, parcelRequire("3sQ5x")).createHook)($2d8151e19ddaa4d5$var$store);
    const $2d8151e19ddaa4d5$export$a898dd7b7ec9917a = ()=>{
        const [{ isEnabled: isEnabledOriginal }] = $2d8151e19ddaa4d5$export$571311559507e90();
        const isEnabled = (0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)() ? isEnabledOriginal && (0, (0, parcelRequire("bCdIp")).shouldShowReturnToMobileBannerMobileMvp)() : isEnabledOriginal;
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: isEnabled,
                name: (0, (0, parcelRequire("aAExw")).BANNER_NAME),
                height: (0, (0, parcelRequire("aAExw")).mobileBannerHeight)
            }), [
            isEnabled
        ]);
    };
});
parcelRegister("aAExw", function(module, exports) {
    $parcel$export(module.exports, "mobileBannerHeight", ()=>$61da032f64bef3a5$export$aa875602f5712b77);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$61da032f64bef3a5$export$41956b146268af93);
    $parcel$export(module.exports, "ENCODED_APPLE_APP_STORE_URL", ()=>$61da032f64bef3a5$export$698c82a2c8445300);
    var $gwIPs;
    const $61da032f64bef3a5$export$aa875602f5712b77 = (0, (0, parcelRequire("gwIPs")).gridSize) * 6;
    const $61da032f64bef3a5$export$41956b146268af93 = 'RETURN_TO_MOBILE_BANNER';
    const $61da032f64bef3a5$export$698c82a2c8445300 = encodeURIComponent('https://itunes.apple.com/app/apple-store/id1006972087');
});
parcelRegister("adRnT", function(module, exports) {
    $parcel$export(module.exports, "BannerAnnouncementAsync", ()=>$30e1d77986915234$export$aa03f7909e0828ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $30e1d77986915234$var$BannerAnnouncement = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fHoed")).then((module)=>module.BannerAnnouncement), {
        ssr: true,
        moduleId: "./src/packages/platform/ui/banners/announcement/src/ui/banner-v2/BannerAnnouncement.tsx"
    });
    const $30e1d77986915234$export$aa03f7909e0828ec = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-platform-ui-banners-announcement",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($30e1d77986915234$var$BannerAnnouncement, null));
});
parcelRegister("fHoed", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bxnv2")
    ]).then(()=>parcelRequire('dqid6'));
});
parcelRegister("14pJv", function(module, exports) {
    $parcel$export(module.exports, "BannerTransitionAsync", ()=>$710b388646922007$export$8bf182764b9d2eb8);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $710b388646922007$var$BannerTransition = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("kUqkC")).then((module)=>module.BannerTransition), {
        moduleId: "./src/packages/platform/ui/banners/eoc-transition/src/ui/banner/index.tsx"
    });
    const $710b388646922007$export$8bf182764b9d2eb8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-banner-eoc-transition",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($710b388646922007$var$BannerTransition, null));
});
parcelRegister("kUqkC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1OPKz").then(()=>parcelRequire('iGIQS'));
});
parcelRegister("9Cdg4", function(module, exports) {
    $parcel$export(module.exports, "MailExpiryBannerAsync", ()=>$9a323272de0aa4c0$export$11a26ffa2d1b48ed);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $9a323272de0aa4c0$var$LazyMailExpiryBanner = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("5S9xE")).then(({ MailExpiryReminder: MailExpiryReminder })=>MailExpiryReminder), {
        moduleId: "./src/packages/platform/ui/banners/mail-expiry-reminder/src/ui/view.tsx"
    });
    const $9a323272de0aa4c0$export$11a26ffa2d1b48ed = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "async-mail-expiry-banner",
            packageName: "jiraPlatformUiMailExpiryReminder",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-mail-expiry-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9a323272de0aa4c0$var$LazyMailExpiryBanner, null)));
});
parcelRegister("5S9xE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hjh1F").then(()=>parcelRequire('4tHNi'));
});
parcelRegister("9ylrc", function(module, exports) {
    $parcel$export(module.exports, "ReturnToMobileBanner", ()=>$369ea7a3ed2830c2$export$81c4f1e869d5a87);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $369ea7a3ed2830c2$var$LazyReturnToMobileBanner = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("l4mHu")).then(({ ReturnToMobileBanner: ReturnToMobileBanner })=>ReturnToMobileBanner), {
        moduleId: "./src/packages/platform/ui/return-to-mobile-banner/src/ReturnToMobileBanner.tsx"
    });
    const $369ea7a3ed2830c2$export$81c4f1e869d5a87 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-return-to-mobile-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($369ea7a3ed2830c2$var$LazyReturnToMobileBanner, null));
});
parcelRegister("l4mHu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6z7Lu").then(()=>parcelRequire('cqWnC'));
});
parcelRegister("dm0Uk", function(module, exports) {
    $parcel$export(module.exports, "ZIndexWrapper", ()=>$1be350c372161cad$export$6bdda512681a5774);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $1be350c372161cad$export$6bdda512681a5774 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { zIndex: zIndex, top: top, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_w6mvmh": (0, (0, parcelRequire("lD23V")).default)(__cmplp.zIndex),
                "--_1vj9tq": (0, (0, parcelRequire("lD23V")).default)(__cmplp.top)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pby1fcb _kqswh2mm _154i1ter",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kc9FZ", function(module, exports) {
    $parcel$export(module.exports, "GlobalComponents", ()=>$87d424e5b411dd1e$export$461c2ed3163c74ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $7CMCs;
    var $6jY6G;
    var $aPfsS;
    var $2SVPM;
    var $imS60;
    const $87d424e5b411dd1e$var$routeComponents = [];
    const $87d424e5b411dd1e$var$RouteGlobalComponents = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("aPfsS")).renderGlobalComponents)(route.layout?.globalComponents || $87d424e5b411dd1e$var$routeComponents));
    };
    const $87d424e5b411dd1e$var$SharedGlobalComponents = ({ sharedGlobalComponents: sharedGlobalComponents })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("aPfsS")).renderGlobalComponents)(sharedGlobalComponents));
    const $87d424e5b411dd1e$export$461c2ed3163c74ff = ({ sharedGlobalComponents: sharedGlobalComponents })=>{
        const globalComponentsPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$fb9876ab4228d985), (0, $9ccbd88c704da1ef$export$c20831be6f780cb5), (0, $9ccbd88c704da1ef$export$398df1bca49f9884), true, true);
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$c20831be6f780cb5)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "shared-global-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
            name: "shared-global-components"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($87d424e5b411dd1e$var$SharedGlobalComponents, {
            sharedGlobalComponents: sharedGlobalComponents
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "route-global-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
            name: "route-global-components"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($87d424e5b411dd1e$var$RouteGlobalComponents, null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$398df1bca49f9884),
            onSet: globalComponentsPerformanceTiming
        }));
    };
});
parcelRegister("imS60", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6b7686623a2955e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $1tcYS;
    var $3aXpE;
    var $cEm1b;
    const $b6b7686623a2955e$var$newContextWithUfoContext = (context, interactionContext)=>context && interactionContext && {
            ...context,
            getInteractionContext: ()=>interactionContext
        };
    const $b6b7686623a2955e$var$flowRight = (functionList)=>(arg)=>functionList.reduceRight((acc, fn)=>fn(acc), arg);
    const $b6b7686623a2955e$var$renderContextProviderIfNonNull = (Context, contextValue)=>(node)=>contextValue ? (0, ($parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
                value: contextValue
            }, node) : node;
    function $b6b7686623a2955e$var$JiraUFOLabelWrapper({ children: children }) {
        const context = (0, (0, parcelRequire("1tcYS")).useInteractionContext)();
        const rllProfilerContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("cEm1b")).ProfilerContext));
        const relayProfilerContext = (0, $5uXOq.useContext)((0, $8Uumt.ProfilerContext));
        const newRllProfilerContext = (0, $5uXOq.useMemo)(()=>({
                current: $b6b7686623a2955e$var$newContextWithUfoContext(rllProfilerContext?.current, context)
            }), [
            context,
            rllProfilerContext
        ]);
        const newRelayProfilerContext = (0, $5uXOq.useMemo)(()=>$b6b7686623a2955e$var$newContextWithUfoContext(relayProfilerContext, context), [
            context,
            relayProfilerContext
        ]);
        return $b6b7686623a2955e$var$flowRight([
            $b6b7686623a2955e$var$renderContextProviderIfNonNull((0, $8Uumt.ProfilerContext), newRelayProfilerContext),
            $b6b7686623a2955e$var$renderContextProviderIfNonNull((0, (0, parcelRequire("cEm1b")).ProfilerContext), newRllProfilerContext)
        ])((0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children));
    }
    function $b6b7686623a2955e$export$2e2bcd8739ae039({ name: name, children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3aXpE")).default), {
            name: name
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b6b7686623a2955e$var$JiraUFOLabelWrapper, null, children));
    }
});
parcelRegister("3aXpE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa69217d65efc8ae$export$2e2bcd8739ae039);
    var $jnjS3;
    var $fa69217d65efc8ae$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jnjS3")).default);
});
parcelRegister("jnjS3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$095a4d1378115b65$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    function $095a4d1378115b65$export$2e2bcd8739ae039({ name: name, children: children }) {
        const context = (0, (0, parcelRequire("1tcYS")).useInteractionContext)();
        const newContext = (0, $5uXOq.useMemo)(()=>{
            if (context) return {
                ...context,
                labelStack: context.labelStack == null ? [
                    {
                        name: name
                    }
                ] : [
                    ...context.labelStack,
                    {
                        name: name
                    }
                ]
            };
            else return context;
        }, [
            context,
            name
        ]);
        return context ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1tcYS")).default).Provider, {
            value: newContext
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    }
});
parcelRegister("6DLIs", function(module, exports) {
    $parcel$export(module.exports, "GlobalContainers", ()=>$1f7483f6f5b15b02$export$3b677a7048d7ae0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bKfXN;
    var $lRFpu;
    var $jD5no;
    var $2i4sA;
    var $gAeCk;
    var $5tsrJ;
    var $j8DrX;
    var $lJ5jf;
    var $3HwlS;
    var $8ApFP;
    var $4yEIl;
    var $iPMn1;
    var $fiv1r;
    var $14XJw;
    var $2SVPM;
    var $9OXo1;
    var $eKtC8;
    var $bAjl9;
    var $lvG9V;
    var $gPTB6;
    var $9kep9;
    var $eSznd;
    var $ivvwC;
    const $1f7483f6f5b15b02$export$3b677a7048d7ae0 = ({ id: id, children: children, baseUrl: baseUrl, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
        const globalContainersPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$4f341d86a3c214), (0, $9ccbd88c704da1ef$export$16e7ead3a8b5c366), (0, $9ccbd88c704da1ef$export$c389f0b50840d5ca), true, true);
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$7048c99f32c60b34), (0, $9ccbd88c704da1ef$export$3c2d8af5c7577fe7), (0, $9ccbd88c704da1ef$export$aac77afee74c49d0), true, true);
        }, []);
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const MonolithStyleOverride = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
                dangerouslySetInnerHTML: {
                    __html: `
                        body#jira {
                            overflow-x: hidden;
                            overflow-y: auto;
                        }

                        #jira-frontend {
                            background: ${"var(--ds-surface, white)"};
                        }

                        #jira_request_timing_info {
                            margin: 0;
                        }
                    `
                }
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bAjl9")).IntlProviders), {
            messages: messages,
            locale: locale
        }, __SPA__ && (0, ($parcel$interopDefault($5uXOq))).createElement(MonolithStyleOverride, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextContainer), {
            isGlobal: true,
            getMeta: (0, (0, parcelRequire("j8DrX")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lRFpu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tsrJ")).default), {
            orgId: orgId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2i4sA")).ViewExperienceTrackingProvider), {
            analyticsSource: (0, $9ccbd88c704da1ef$export$c9e16a15d65437),
            experience: (0, $9ccbd88c704da1ef$export$b1534bc11f201efd),
            experienceId: (0, $9ccbd88c704da1ef$export$fa4bbc89fd1f1a7),
            application: (0, $9ccbd88c704da1ef$export$aa6008fe0169b864),
            edition: (0, $9ccbd88c704da1ef$export$39418a21fbb51487),
            additionalAttributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eKtC8")).ErrorBoundary), {
            id: id,
            withExperienceTracker: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$16e7ead3a8b5c366)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(Router, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKfXN")).default), {
            UNSAFE_isThemingDisabled: true,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$c389f0b50840d5ca)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9kep9")).PageConfigContainers), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lvG9V")).MetricsContainers), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fiv1r")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gPTB6")).NavigationContainers), {
            baseUrl: baseUrl
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivvwC")).UserContainers), {
            baseUrl: baseUrl
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eSznd")).UiManagers), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$3c2d8af5c7577fe7)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4yEIl")).PostOfficeRouterListener), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            id: "page-container-v2.nav-v3.app-base",
            hasErrorBoundary: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$aac77afee74c49d0),
            onSet: globalContainersPerformanceTiming
        }), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJ5jf")).SidebarNav4ControllerProvider), null, children) : children)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iPMn1")).ScreenSpaceFlagsPlacement), null)))))))))))))));
    };
});
parcelRegister("bKfXN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c63904d4fd249f91$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $grjRA;
    var $4NS88;
    const $c63904d4fd249f91$var$InsideAppProviderContext = (0, $5uXOq.createContext)(false);
    function $c63904d4fd249f91$export$c7dacf3845253dcf({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
        const isInsideAppProvider = (0, $5uXOq.useContext)($c63904d4fd249f91$var$InsideAppProviderContext);
        if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
        const routerLinkProvider = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("grjRA")).default), {
            routerLinkComponent: routerLinkComponent
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c63904d4fd249f91$var$InsideAppProviderContext.Provider, {
            value: true
        }, UNSAFE_isThemingDisabled ? routerLinkProvider : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4NS88")).default), {
            defaultColorMode: defaultColorMode,
            defaultTheme: defaultTheme
        }, routerLinkProvider));
    }
    var $c63904d4fd249f91$export$2e2bcd8739ae039 = $c63904d4fd249f91$export$c7dacf3845253dcf;
});
parcelRegister("2i4sA", function(module, exports) {
    $parcel$export(module.exports, "ViewExperienceTrackingProvider", ()=>$c08cc6207a190361$export$a5efa46877be148f);
    $parcel$export(module.exports, "SubExperienceTrackingProvider", ()=>$c08cc6207a190361$export$e0241c84ce5db240);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $jNwWT;
    var $aD4Nm;
    var $ehKaJ;
    const $c08cc6207a190361$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady, experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes, children: children })=>false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehKaJ")).default), {
            isExperienceReady: isExperienceReady,
            experience: experience,
            experienceId: experienceId,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            additionalAttributes: additionalAttributes
        }, children);
    $c08cc6207a190361$export$a5efa46877be148f.defaultProps = {
        isExperienceReady: true,
        experienceId: null,
        additionalAttributes: {}
    };
    var $c08cc6207a190361$export$2e2bcd8739ae039 = $c08cc6207a190361$export$a5efa46877be148f;
    const $c08cc6207a190361$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders })=>false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNwWT")).default).Consumer, null, (context)=>{
            if (context == null) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
                return children;
            }
            const { experienceId: experienceId } = context;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aD4Nm")).ExperienceTracker), {
                location: location,
                parentProviders: parentProviders
            }, (trackerCallbacks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehKaJ")).default), {
                    parentTrackerCallbacks: trackerCallbacks,
                    experience: location,
                    experienceId: experienceId,
                    analyticsSource: null,
                    application: null,
                    edition: null,
                    isExperienceReady: true
                }, children));
        });
    $c08cc6207a190361$export$e0241c84ce5db240.defaultProps = {
        parentProviders: null
    };
});
parcelRegister("ehKaJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a267f2f54170b1c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hh0bW;
    var $jNwWT;
    class $a267f2f54170b1c1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                parentTrackerCallbacks: null,
                additionalAttributes: {}
            };
        }
        constructor(props){
            super(props), this.onPending = ()=>{
                this.pendingCount += 1;
                this.shouldTrackExperience = true;
                this.checkAndStartTimer();
            }, this.onSuccess = ()=>{
                this.pendingCount -= 1;
                this.checkAndStartTimer();
            }, this.onFailure = (location, additionalAttributes)=>{
                this.trackExperience({
                    wasExperienceSuccesful: false,
                    location: location,
                    additionalAttributes: additionalAttributes
                });
            }, this.onAbort = (location, additionalAttributes)=>{
                this.trackExperience({
                    wasExperienceSuccesful: false,
                    action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                    location: location,
                    additionalAttributes: additionalAttributes
                });
            };
            this.resetExperience();
        }
        componentDidMount() {
            this.checkAndStartTimer();
        }
        componentDidUpdate(prevProps) {
            if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
        }
        componentDidCatch(error) {
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: 'error-reached-provider',
                additionalAttributes: {
                    errorMessage: error.message,
                    errorName: error.name,
                    ...this.props?.additionalAttributes
                }
            });
            throw error;
        }
        componentWillUnmount() {
            clearTimeout(this.timerId);
        }
        checkAndStartTimer() {
            if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
        }
        startTimer() {
            clearTimeout(this.timerId);
            this.timerId = setTimeout(()=>{
                if (this.pendingCount === 0) this.trackExperience({
                    wasExperienceSuccesful: true
                });
            }, 1000);
        }
        resetExperience() {
            clearTimeout(this.timerId);
            this.timerId = undefined;
            this.shouldTrackExperience = false;
            this.hasTrackedExperience = false;
            this.pendingCount = 0;
            this.memoizedContext = {
                consumerCallbacks: {
                    onPending: this.onPending,
                    onSuccess: this.onSuccess,
                    onFailure: this.onFailure,
                    onAbort: this.onAbort
                },
                experienceId: this.props.experienceId,
                experience: this.props.experience
            };
        }
        trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
            if (this.hasTrackedExperience) return;
            this.hasTrackedExperience = true;
            const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
            if (parentTrackerCallbacks) {
                if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
                else parentTrackerCallbacks.onExperienceFailure(location, {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                });
            } else {
                const { experience: experience } = this.memoizedContext;
                const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
                analyticsSource && (0, (0, parcelRequire("hh0bW")).default)({
                    experience: experience,
                    action: action,
                    wasExperienceSuccesful: wasExperienceSuccesful,
                    location: location,
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    additionalAttributes: {
                        ...additionalAttributesFromProps,
                        ...additionalAttributes
                    }
                });
            }
        }
        checkExperienceIdForExperienceReset() {
            if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
        }
        render() {
            this.checkExperienceIdForExperienceReset();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNwWT")).default).Provider, {
                value: this.memoizedContext
            }, this.props.children);
        }
    }
});
const $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $c0ec49ac5a1e4009$export$b48b3d1872522384 = 'taskFail';
const $c0ec49ac5a1e4009$export$aeeb00d0845d24d8 = 'taskAbort';
parcelRegister("lJ5jf", function(module, exports) {
    $parcel$export(module.exports, "SidebarNav4ControllerProvider", ()=>$ba2af518cd3fa886$export$ec25d268893d889d);
    $parcel$export(module.exports, "useSidebarNav4Controller", ()=>$ba2af518cd3fa886$export$641950c86d73374);
    var $5uXOq = parcelRequire("5uXOq");
    var $fMcVX;
    const $ba2af518cd3fa886$var$SidebarNav4ControllerContext = (0, $5uXOq.createContext)(null);
    function $ba2af518cd3fa886$export$ec25d268893d889d(props) {
        const { children: children, controlledPath: initialControlledPath = null } = props;
        const [controlledPath, setControlledPath] = (0, $5uXOq.useState)(initialControlledPath);
        const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
                isControlledNav: controlledPath !== null,
                isControlledPath: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(controlledPath ?? []),
                setControlledPath: setControlledPath
            }), [
            controlledPath
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ba2af518cd3fa886$var$SidebarNav4ControllerContext.Provider, {
            value: sidebarNav4Controller
        }, children);
    }
    function $ba2af518cd3fa886$export$641950c86d73374() {
        const context = (0, $5uXOq.useContext)($ba2af518cd3fa886$var$SidebarNav4ControllerContext);
        if (context == null) throw new Error('useSidebarNav4Controller must be used inside a SidebarNav4ControllerContext');
        return context;
    }
});
parcelRegister("4yEIl", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeProvider", ()=>$21214568f856c41e$export$fb465b6e855c1e85);
    $parcel$export(module.exports, "PostOfficeRouterListener", ()=>$21214568f856c41e$export$9f8d3084fd3d5fc0);
    var $5uXOq = parcelRequire("5uXOq");
    var $b71gk;
    var $4R6GH;
    var $jQsty;
    var $lpwtK;
    var $14XJw;
    var $fY39E;
    var $k9JTq;
    var $koeKL;
    var $2tT7R;
    var $cNd4s;
    var $DVljb;
    var $kyUrs;
    var $gsnWm;
    var $doZTA;
    var $adncp;
    const $21214568f856c41e$var$JiraPostOfficeProvider = ({ children: children })=>{
        const { data: data } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const activationId = (0, (0, parcelRequire("fY39E")).useActivationId)();
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const environment = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const editions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const subproduct = data?.type;
        const context = (0, $5uXOq.useMemo)(()=>{
            const edition = (0, (0, parcelRequire("adncp")).subproductToEdition)(subproduct, editions);
            return {
                current: {
                    ...(0, (0, parcelRequire("adncp")).tenantToPostOfficeContext)({
                        activationId: activationId,
                        cloudId: cloudId,
                        isSiteAdmin: isSiteAdmin,
                        locale: locale
                    }),
                    orgId: orgId,
                    productEdition: edition || undefined,
                    subproduct: subproduct
                }
            };
        }, [
            cloudId,
            orgId,
            activationId,
            subproduct,
            isSiteAdmin,
            locale,
            editions
        ]);
        const env = (0, $5uXOq.useMemo)(()=>({
                env: (0, (0, parcelRequire("adncp")).transformJiraEnvToPostOfficeEnvironment)(environment)
            }), [
            environment
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kyUrs")).PostOfficeProvider), {
            context: context,
            environment: env
        }, children);
    };
    const $21214568f856c41e$export$fb465b6e855c1e85 = ({ children: children })=>{
        const isPostOfficeEnabled = !(0, (0, parcelRequire("jQsty")).default)('killswitch_post_office_in_jira');
        return isPostOfficeEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b71gk")).default), {
            id: "postOfficeJiraProvider",
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$JiraPostOfficeProvider, null, children)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $21214568f856c41e$var$ReactResourceRouterListener = ({ children: children })=>{
        const [route] = (0, (0, parcelRequire("doZTA")).useRouter)();
        (0, (0, parcelRequire("gsnWm")).usePostOfficeRouteUpdate)([
            route.basePath,
            route.location.pathname
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $21214568f856c41e$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
        const isPostOfficeEnabled = !(0, (0, parcelRequire("jQsty")).default)('killswitch_post_office_in_jira');
        return isPostOfficeEnabled && (0, (0, parcelRequire("4R6GH")).fg)('post-office-screen-space-overlay-jfe') ? (0, ($parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$ReactResourceRouterListener, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("2tT7R", function(module, exports) {
    $parcel$export(module.exports, "useEnvironment", ()=>$6bd66e47d4948917$export$ea7ed2425832167d);
    $parcel$export(module.exports, "useIsStagingOrDevOrLocal", ()=>$6bd66e47d4948917$export$b0d8f74f433a09c9);
    var $9OXo1;
    const $6bd66e47d4948917$var$ENVIRONMENT = {
        STAGING: 'staging',
        DEV: 'dev',
        LOCAL: 'local',
        PROD: 'prod'
    };
    const $6bd66e47d4948917$export$ea7ed2425832167d = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext?.environment || $6bd66e47d4948917$var$ENVIRONMENT.PROD;
    };
    const $6bd66e47d4948917$export$b0d8f74f433a09c9 = ()=>{
        const env = $6bd66e47d4948917$export$ea7ed2425832167d();
        return env === $6bd66e47d4948917$var$ENVIRONMENT.STAGING || env === $6bd66e47d4948917$var$ENVIRONMENT.DEV || env === $6bd66e47d4948917$var$ENVIRONMENT.LOCAL;
    };
});
parcelRegister("DVljb", function(module, exports) {
    $parcel$export(module.exports, "useLocale", ()=>$7c760643dc748494$export$43bb16f9c6d9e3f7);
    $parcel$export(module.exports, "useNativeLocale", ()=>$7c760643dc748494$export$31652d9c30d7d3f3);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzeFL;
    var $9OXo1;
    const $7c760643dc748494$export$43bb16f9c6d9e3f7 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.locale || (0, (0, parcelRequire("lzeFL")).defaultLocale);
    };
    const $7c760643dc748494$export$31652d9c30d7d3f3 = ()=>{
        const locale = $7c760643dc748494$export$43bb16f9c6d9e3f7();
        const standardizedLocale = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("lzeFL")).standardizeLocale)(locale), [
            locale
        ]);
        return standardizedLocale;
    };
});
parcelRegister("kyUrs", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeProvider", ()=>$55d824ce17788461$export$fb465b6e855c1e85);
    var $5uXOq = parcelRequire("5uXOq");
    var $gHZ4O;
    var $5MYiV;
    var $gsnWm;
    var $iTZyv;
    var $8uFbT;
    var $dmvPD;
    var $hWRix;
    var $6I1Fy;
    const $55d824ce17788461$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children })=>{
        const stableEnvironment = (0, (0, parcelRequire("dmvPD")).useStableObject)((0, (0, parcelRequire("6I1Fy")).generateEnvironmentConfigWithOverrides)((0, (0, parcelRequire("5MYiV")).defaultEnvironmentValues), envWithOverrides));
        const stableContext = (0, (0, parcelRequire("dmvPD")).useStableObject)($55d824ce17788461$var$composeConfig((0, (0, parcelRequire("gHZ4O")).defaultPostOfficeContextValue), context.current));
        const memoizedMessagePlacementValues = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hWRix")).createMessagePlacementValues)(), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5MYiV")).PostOfficeEnvironmentProvider), {
            value: stableEnvironment
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gHZ4O")).InternalPostOfficeContextProvider), {
            value: stableContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iTZyv")).PostOfficeScreenContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWRix")).MessagePlacementProvider), {
            value: memoizedMessagePlacementValues
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gsnWm")).RouteListenerProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8uFbT")).TriggerContextProvider), null, children))))));
    };
    const $55d824ce17788461$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
            for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
            return {
                ...acc,
                ...v
            };
        }, {
            ...base
        });
});
parcelRegister("gHZ4O", function(module, exports) {
    $parcel$export(module.exports, "defaultPostOfficeContextValue", ()=>$5998490173f4f5b3$export$da5dc9062cba6715);
    $parcel$export(module.exports, "InternalPostOfficeContextProvider", ()=>$5998490173f4f5b3$export$3a10495c2cd2db0c);
    $parcel$export(module.exports, "PostOfficeContextProvider", ()=>$5998490173f4f5b3$export$b77983be89bb0a4e);
    $parcel$export(module.exports, "usePostOfficeContext", ()=>$5998490173f4f5b3$export$5bd9099e0ae94a43);
    var $5uXOq = parcelRequire("5uXOq");
    const $5998490173f4f5b3$export$da5dc9062cba6715 = {
        product: undefined,
        subproduct: undefined,
        locale: undefined,
        isSiteAdmin: undefined,
        tenantId: undefined,
        workspaceAri: 'no-workspace-ari-available',
        workspaceId: undefined,
        orgId: undefined,
        productEdition: undefined
    };
    const $5998490173f4f5b3$export$a228be81fcb77b42 = (0, $5uXOq.createContext)($5998490173f4f5b3$export$da5dc9062cba6715);
    const $5998490173f4f5b3$export$3a10495c2cd2db0c = $5998490173f4f5b3$export$a228be81fcb77b42.Provider;
    const $5998490173f4f5b3$export$b77983be89bb0a4e = $5998490173f4f5b3$export$3a10495c2cd2db0c;
    const $5998490173f4f5b3$export$5bd9099e0ae94a43 = ()=>(0, $5uXOq.useContext)($5998490173f4f5b3$export$a228be81fcb77b42);
});
parcelRegister("5MYiV", function(module, exports) {
    $parcel$export(module.exports, "defaultEnvironmentValues", ()=>$d283dbd21f6fbc74$export$b4ede87479bfcf09);
    $parcel$export(module.exports, "PostOfficeEnvironmentProvider", ()=>$d283dbd21f6fbc74$export$604607f913ef367c);
    $parcel$export(module.exports, "usePostOfficeEnvironment", ()=>$d283dbd21f6fbc74$export$877b97169cc75e8b);
    var $5uXOq = parcelRequire("5uXOq");
    const $d283dbd21f6fbc74$export$b4ede87479bfcf09 = {
        currentEnv: 'local',
        envConfigs: {
            test: {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $154d3acab0ca1f4d$export$1e9fed4c0197724c),
                    pathname: (0, $154d3acab0ca1f4d$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            local: {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $154d3acab0ca1f4d$export$1e9fed4c0197724c),
                    pathname: (0, $154d3acab0ca1f4d$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            dev: {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $154d3acab0ca1f4d$export$1e9fed4c0197724c),
                    pathname: (0, $154d3acab0ca1f4d$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            staging: {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$b49738b89db261cd),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            'stg-fedm-east': {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$b49738b89db261cd),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            production: {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$bbd96cd490b0df63),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            'prod-fedm-east': {
                remoteModule: {
                    origin: (0, $154d3acab0ca1f4d$export$bbd96cd490b0df63),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            }
        }
    };
    const $d283dbd21f6fbc74$export$fceca2c399b32565 = (0, $5uXOq.createContext)($d283dbd21f6fbc74$export$b4ede87479bfcf09);
    const $d283dbd21f6fbc74$export$604607f913ef367c = $d283dbd21f6fbc74$export$fceca2c399b32565.Provider;
    const $d283dbd21f6fbc74$export$877b97169cc75e8b = ()=>(0, $5uXOq.useContext)($d283dbd21f6fbc74$export$fceca2c399b32565);
});
var $154d3acab0ca1f4d$exports = {};
$parcel$export($154d3acab0ca1f4d$exports, "API_ORIGIN_LOCAL", ()=>$154d3acab0ca1f4d$export$1e9fed4c0197724c);
$parcel$export($154d3acab0ca1f4d$exports, "API_PATHNAME_LOCAL", ()=>$154d3acab0ca1f4d$export$919a9569bce66f17);
$parcel$export($154d3acab0ca1f4d$exports, "API_PATHNAME_STG_PROD", ()=>$154d3acab0ca1f4d$export$d4fe3482c88e73a8);
$parcel$export($154d3acab0ca1f4d$exports, "REMOTE_MODULE_URI_LOCAL", ()=>$154d3acab0ca1f4d$export$67be2569ef5d7666);
$parcel$export($154d3acab0ca1f4d$exports, "REMOTE_MODULE_URI_STG", ()=>$154d3acab0ca1f4d$export$b49738b89db261cd);
$parcel$export($154d3acab0ca1f4d$exports, "REMOTE_MODULE_URI_PROD", ()=>$154d3acab0ca1f4d$export$bbd96cd490b0df63);
const $154d3acab0ca1f4d$export$1e9fed4c0197724c = 'http://localhost:8081';
const $154d3acab0ca1f4d$export$919a9569bce66f17 = '/api/v1/placements/';
const $154d3acab0ca1f4d$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $154d3acab0ca1f4d$export$67be2569ef5d7666 = 'http://localhost:9009';
const $154d3acab0ca1f4d$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $154d3acab0ca1f4d$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';
parcelRegister("gsnWm", function(module, exports) {
    $parcel$export(module.exports, "usePostOfficeRouteUpdate", ()=>$05165220c9da3f7b$export$bb606326acdd1a64);
    $parcel$export(module.exports, "RouteListenerProvider", ()=>$05165220c9da3f7b$export$31986273b686f5ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $dM8xS;
    var $lwdce;
    const $05165220c9da3f7b$var$noop = ()=>{};
    const $05165220c9da3f7b$var$RouteListenerContext = (0, $5uXOq.createContext)({
        update: $05165220c9da3f7b$var$noop
    });
    const $05165220c9da3f7b$export$7a2084f4baac29a7 = ()=>(0, (0, parcelRequire("dM8xS")).createSimplePubSub)();
    const $05165220c9da3f7b$export$72fd8977abf03d60 = ()=>(0, $5uXOq.useContext)($05165220c9da3f7b$var$RouteListenerContext);
    const $05165220c9da3f7b$export$755edb1665399d41 = ()=>{
        const ref = (0, $5uXOq.useRef)();
        if (!ref.current) ref.current = $05165220c9da3f7b$export$7a2084f4baac29a7();
        const [routeSubscriber, updateRoute] = ref.current;
        const routeConfig = (0, $5uXOq.useMemo)(()=>({
                initialUrl: new URL(window.location.href),
                routeSubscriber: routeSubscriber
            }), [
            routeSubscriber
        ]);
        const routeUpdater = (0, $5uXOq.useMemo)(()=>({
                update: updateRoute
            }), [
            updateRoute
        ]);
        return [
            routeConfig,
            routeUpdater
        ];
    };
    const $05165220c9da3f7b$export$bb606326acdd1a64 = (deps)=>{
        const { update: update } = $05165220c9da3f7b$export$72fd8977abf03d60();
        (0, $5uXOq.useEffect)(()=>{
            if (typeof window === 'undefined') return;
            update({
                next: new URL(window.location.href)
            });
        }, deps);
    };
    const $05165220c9da3f7b$export$31986273b686f5ea = ({ children: children })=>{
        const [route, routeUpdater] = $05165220c9da3f7b$export$755edb1665399d41();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($05165220c9da3f7b$var$RouteListenerContext.Provider, {
            value: routeUpdater
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lwdce")).PostOfficeRouteProvider), route, children));
    };
});
parcelRegister("dM8xS", function(module, exports) {
    $parcel$export(module.exports, "createSimplePubSub", ()=>$8de249bc8411112f$export$92469b55607f005b);
    const $8de249bc8411112f$export$92469b55607f005b = ()=>{
        const subscribers = new Map();
        const subscribe = (subscriber)=>{
            subscribers.set(subscriber, subscriber);
            return ()=>{
                subscribers.delete(subscriber);
            };
        };
        const publish = (payload)=>{
            subscribers.forEach((callback)=>callback(payload));
        };
        return [
            subscribe,
            publish
        ];
    };
});
parcelRegister("lwdce", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeRouteContext", ()=>$de7edbbcb1faf7cf$export$f7f47a74e8b47b1f);
    $parcel$export(module.exports, "PostOfficeRouteProvider", ()=>$de7edbbcb1faf7cf$export$89eadc6b3e5f4e9e);
    $parcel$export(module.exports, "usePostOfficeRoute", ()=>$de7edbbcb1faf7cf$export$79301b66f7808cd8);
    var $5uXOq = parcelRequire("5uXOq");
    var $8tyNL = parcelRequire("8tyNL");
    var $dmvPD;
    const $de7edbbcb1faf7cf$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
        let state = $de7edbbcb1faf7cf$var$initializeState({
            initialUrl: initialUrl
        });
        const handleUpdate = (routeChange)=>{
            const next = routeChange.next?.toString();
            if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
            state = {
                previous: state.current,
                current: next,
                searchParams: routeChange.next?.searchParams
            };
        };
        const subscribe = (next)=>routeSubscriber((routeChange)=>{
                handleUpdate(routeChange);
                next();
            });
        const getSnapshot = ()=>{
            return state;
        };
        return {
            subscribe: subscribe,
            getSnapshot: getSnapshot
        };
    };
    const $de7edbbcb1faf7cf$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
        const route = (0, $8tyNL.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
        return (0, (0, parcelRequire("dmvPD")).useStableObject)(route);
    };
    const $de7edbbcb1faf7cf$var$initialState = {
        previous: undefined,
        current: undefined,
        searchParams: undefined
    };
    const $de7edbbcb1faf7cf$var$initializeState = ({ initialUrl: initialUrl })=>({
            ...$de7edbbcb1faf7cf$var$initialState,
            current: initialUrl ? initialUrl?.toString() : undefined,
            searchParams: initialUrl?.searchParams
        });
    const $de7edbbcb1faf7cf$export$f7f47a74e8b47b1f = (0, $5uXOq.createContext)($de7edbbcb1faf7cf$var$initialState);
    const $de7edbbcb1faf7cf$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
        const ref = (0, $5uXOq.useRef)();
        if (!ref.current) ref.current = $de7edbbcb1faf7cf$export$98c77e1bd702ed15(props);
        const route = $de7edbbcb1faf7cf$var$usePostOfficeRouteStore(ref.current);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($de7edbbcb1faf7cf$export$f7f47a74e8b47b1f.Provider, {
            value: route
        }, children);
    };
    const $de7edbbcb1faf7cf$export$79301b66f7808cd8 = ()=>(0, $5uXOq.useContext)($de7edbbcb1faf7cf$export$f7f47a74e8b47b1f);
});
parcelRegister("dmvPD", function(module, exports) {
    $parcel$export(module.exports, "useStableObject", ()=>$2b1cba80f5ba3788$export$ed02d4adf2068b08);
    var $5uXOq = parcelRequire("5uXOq");
    function $2b1cba80f5ba3788$export$cdf98ded28406f69(obj) {
        return Object.entries(obj).sort().flatMap((v)=>v);
    }
    function $2b1cba80f5ba3788$export$ed02d4adf2068b08(obj) {
        return (0, $5uXOq.useMemo)(()=>obj, $2b1cba80f5ba3788$export$cdf98ded28406f69(obj));
    }
});
parcelRegister("iTZyv", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeScreenContextProvider", ()=>$83b0ce9f1ffe475b$export$ca77a8cbe94108fe);
    $parcel$export(module.exports, "usePostOfficeScreenPlacement", ()=>$83b0ce9f1ffe475b$export$f51d04a086368016);
    var $5uXOq = parcelRequire("5uXOq");
    var $1HWkH;
    const $83b0ce9f1ffe475b$var$initialPlacementState = {
        currentlyMounted: [],
        hasMounted: []
    };
    const $83b0ce9f1ffe475b$var$PostOfficeScreenContext = (0, $5uXOq.createContext)({
        placements: $83b0ce9f1ffe475b$var$initialPlacementState
    });
    const $83b0ce9f1ffe475b$export$70e19226ddeaf957 = ()=>(0, $5uXOq.useContext)($83b0ce9f1ffe475b$var$PostOfficeScreenContext);
    const $83b0ce9f1ffe475b$var$PostOfficeScreenUpdateContext = (0, $5uXOq.createContext)({
        placementMount: ()=>{},
        placementUnmount: ()=>{}
    });
    const $83b0ce9f1ffe475b$export$5d27c0ee02be2a23 = ()=>(0, $5uXOq.useContext)($83b0ce9f1ffe475b$var$PostOfficeScreenUpdateContext);
    const $83b0ce9f1ffe475b$export$ca77a8cbe94108fe = ({ children: children })=>{
        const [placements, setPlacements] = (0, $5uXOq.useState)($83b0ce9f1ffe475b$var$initialPlacementState);
        const placementMount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                    ...state,
                    currentlyMounted: (0, (0, parcelRequire("1HWkH")).uniqueArray)([
                        ...state.currentlyMounted,
                        placementId
                    ]),
                    hasMounted: (0, (0, parcelRequire("1HWkH")).uniqueArray)([
                        ...state.hasMounted,
                        placementId
                    ])
                }), []);
        const placementUnmount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                    ...state,
                    currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
                }), []);
        const postOfficeScreenUpdateContext = (0, $5uXOq.useMemo)(()=>({
                placementMount: placementMount,
                placementUnmount: placementUnmount
            }), [
            placementMount,
            placementUnmount
        ]);
        const postOfficeScreenContext = (0, $5uXOq.useMemo)(()=>({
                placements: placements
            }), [
            placements
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($83b0ce9f1ffe475b$var$PostOfficeScreenUpdateContext.Provider, {
            value: postOfficeScreenUpdateContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($83b0ce9f1ffe475b$var$PostOfficeScreenContext.Provider, {
            value: postOfficeScreenContext
        }, children));
    };
    const $83b0ce9f1ffe475b$export$f51d04a086368016 = ({ placementId: placementId })=>{
        const { placementMount: placementMount, placementUnmount: placementUnmount } = $83b0ce9f1ffe475b$export$5d27c0ee02be2a23();
        (0, $5uXOq.useEffect)(()=>{
            if (!placementId) return;
            placementMount({
                placementId: placementId
            });
            return ()=>{
                placementUnmount({
                    placementId: placementId
                });
            };
        }, [
            placementId,
            placementMount,
            placementUnmount
        ]);
    };
});
parcelRegister("1HWkH", function(module, exports) {
    $parcel$export(module.exports, "uniqueArray", ()=>$1e088c20e501b022$export$bbd17ecb0679edd7);
    const $1e088c20e501b022$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());
});
parcelRegister("8uFbT", function(module, exports) {
    $parcel$export(module.exports, "TriggerContextProvider", ()=>$30c451df5a2e0ecd$export$e80a5720bb4c8fe3);
    $parcel$export(module.exports, "useTrigger", ()=>$30c451df5a2e0ecd$export$3b196fe93a948c18);
    $parcel$export(module.exports, "useFirePostOfficeTrigger", ()=>$30c451df5a2e0ecd$export$83b33e5fe4cce64);
    var $5uXOq = parcelRequire("5uXOq");
    const $30c451df5a2e0ecd$var$initialActiveTriggerState = {
        activeTriggerState: {
            activeTriggerId: undefined
        }
    };
    const $30c451df5a2e0ecd$var$initialTriggerDispatchState = {
        setTriggerState: ()=>{
            console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
        }
    };
    const $30c451df5a2e0ecd$var$TriggerContext = (0, ($parcel$interopDefault($5uXOq))).createContext($30c451df5a2e0ecd$var$initialActiveTriggerState);
    const $30c451df5a2e0ecd$var$TriggerDispatchContext = (0, ($parcel$interopDefault($5uXOq))).createContext($30c451df5a2e0ecd$var$initialTriggerDispatchState);
    const $30c451df5a2e0ecd$export$e80a5720bb4c8fe3 = ({ children: children })=>{
        const [activeTriggerState, setActiveTriggerState] = (0, $5uXOq.useState)($30c451df5a2e0ecd$var$initialActiveTriggerState.activeTriggerState);
        const setTriggerState = (0, $5uXOq.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
            setActiveTriggerState((current)=>{
                const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
                if (!hasStateChanged) return current;
                if (isActive) return {
                    activeTriggerId: triggerId
                };
                return {
                    activeTriggerId: undefined
                };
            });
        }, []);
        const triggerContextValue = (0, $5uXOq.useMemo)(()=>({
                activeTriggerState: activeTriggerState
            }), [
            activeTriggerState
        ]);
        const triggerContexDispatchValue = (0, $5uXOq.useMemo)(()=>({
                setTriggerState: setTriggerState
            }), [
            setTriggerState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($30c451df5a2e0ecd$var$TriggerContext.Provider, {
            value: triggerContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($30c451df5a2e0ecd$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue
        }, children));
    };
    const $30c451df5a2e0ecd$export$454c1d7c35958f5e = ()=>(0, $5uXOq.useContext)($30c451df5a2e0ecd$var$TriggerContext);
    const $30c451df5a2e0ecd$export$23cbf084e08bdb93 = ()=>(0, $5uXOq.useContext)($30c451df5a2e0ecd$var$TriggerDispatchContext);
    const $30c451df5a2e0ecd$export$3b196fe93a948c18 = (triggerId)=>{
        const { activeTriggerState: activeTriggerState } = $30c451df5a2e0ecd$export$454c1d7c35958f5e();
        return triggerId ? {
            isActive: activeTriggerState.activeTriggerId === triggerId
        } : {
            isActive: undefined
        };
    };
    const $30c451df5a2e0ecd$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
        const { setTriggerState: setContextTriggerState } = $30c451df5a2e0ecd$export$23cbf084e08bdb93();
        const fireTrigger = (0, $5uXOq.useCallback)(({ isActive: isActive })=>{
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        }, [
            setContextTriggerState,
            triggerId
        ]);
        return {
            fireTrigger: fireTrigger
        };
    };
});
parcelRegister("hWRix", function(module, exports) {
    $parcel$export(module.exports, "createMessagePlacementValues", ()=>$bb15f099f95e68b6$export$a28a0c048b24fc5a);
    $parcel$export(module.exports, "MessagePlacementProvider", ()=>$bb15f099f95e68b6$export$c7535f8ebc5b75a9);
    $parcel$export(module.exports, "useMessagePlacementHooks", ()=>$bb15f099f95e68b6$export$89f8e1f623d8f5ac);
    var $5uXOq = parcelRequire("5uXOq");
    const $bb15f099f95e68b6$var$createPubSub = ()=>{
        const subscribers = new Map();
        const subscribe = (subscriber)=>{
            subscribers.set(subscriber, subscriber);
            return ()=>{
                subscribers.delete(subscriber);
            };
        };
        const publish = (payload)=>{
            subscribers.forEach((cb)=>cb(payload));
        };
        return [
            subscribe,
            publish
        ];
    };
    const $bb15f099f95e68b6$export$a28a0c048b24fc5a = ()=>{
        const [onMessageSnooze, snoozeMessageFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
        const [onMessageDismiss, dismissMessageFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
        const [onMessageRead, markReadFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
        const [onMessageViewed, markViewedFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
        const [onMessageClicked, markClickedFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
        return {
            onMessageSnooze: onMessageSnooze,
            snoozeMessageFromPlacement: snoozeMessageFromPlacement,
            onMessageDismiss: onMessageDismiss,
            dismissMessageFromPlacement: dismissMessageFromPlacement,
            onMessageRead: onMessageRead,
            markReadFromPlacement: markReadFromPlacement,
            onMessageViewed: onMessageViewed,
            markViewedFromPlacement: markViewedFromPlacement,
            onMessageClicked: onMessageClicked,
            markClickedFromPlacement: markClickedFromPlacement
        };
    };
    const $bb15f099f95e68b6$export$ea58328f3ceee4d4 = (0, $5uXOq.createContext)($bb15f099f95e68b6$export$a28a0c048b24fc5a());
    const $bb15f099f95e68b6$export$c7535f8ebc5b75a9 = $bb15f099f95e68b6$export$ea58328f3ceee4d4.Provider;
    const $bb15f099f95e68b6$export$c4b5cec0911af177 = ()=>({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($bb15f099f95e68b6$export$c7535f8ebc5b75a9, {
                value: $bb15f099f95e68b6$export$a28a0c048b24fc5a()
            }, children);
    const $bb15f099f95e68b6$export$89f8e1f623d8f5ac = ()=>(0, $5uXOq.useContext)($bb15f099f95e68b6$export$ea58328f3ceee4d4);
});
parcelRegister("6I1Fy", function(module, exports) {
    $parcel$export(module.exports, "generateEnvironmentConfigWithOverrides", ()=>$f0574f278f9639f1$export$ae3dab16eb1fc2cc);
    const $f0574f278f9639f1$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
        const { env: env, overrides: overrides } = environmentWithOverrides;
        return {
            currentEnv: env,
            envConfigs: {
                ...defaultEnvironmentValues.envConfigs,
                [env]: {
                    remoteModule: {
                        origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                        pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                        searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                    },
                    api: {
                        origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                        pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                        searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                    }
                }
            }
        };
    };
});
parcelRegister("adncp", function(module, exports) {
    $parcel$export(module.exports, "tenantToPostOfficeContext", ()=>$8d0bdd2f51e19696$export$d8f2c334a0924146);
    $parcel$export(module.exports, "subproductToEdition", ()=>$8d0bdd2f51e19696$export$2d690d13b91ea44f);
    $parcel$export(module.exports, "transformJiraEnvToPostOfficeEnvironment", ()=>$8d0bdd2f51e19696$export$cfacfecb20987ff1);
    var $8dYib;
    const $8d0bdd2f51e19696$var$JIRA_PRODUCT = 'jira';
    const $8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT = {
        product: $8d0bdd2f51e19696$var$JIRA_PRODUCT,
        locale: 'en'
    };
    const $8d0bdd2f51e19696$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
        return (0, (0, parcelRequire("8dYib")).JiraWorkspaceAri).create({
            activationId: activationId,
            siteId: cloudId
        }).toString();
    };
    const $8d0bdd2f51e19696$export$d8f2c334a0924146 = (tenantData)=>{
        const { activationId: activationId, cloudId: cloudId, isSiteAdmin: isSiteAdmin, locale: locale } = tenantData;
        const workspaceAri = $8d0bdd2f51e19696$var$getWorkspaceARI({
            activationId: activationId,
            cloudId: cloudId
        });
        return {
            ...$8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT,
            locale: locale,
            isSiteAdmin: isSiteAdmin,
            tenantId: cloudId,
            workspaceAri: workspaceAri,
            workspaceId: activationId,
            orgId: undefined,
            subproduct: undefined,
            productEdition: undefined
        };
    };
    const $8d0bdd2f51e19696$export$2d690d13b91ea44f = (subproduct, editions)=>{
        switch(subproduct){
            case 'core':
                return editions.core;
            case 'software':
                return editions.software;
            case 'customerService':
                return editions.customerService;
            case 'serviceDesk':
                return editions.serviceDesk;
            default:
                undefined;
        }
    };
    const $8d0bdd2f51e19696$export$cfacfecb20987ff1 = (environment)=>{
        switch(environment){
            case 'dev':
            case 'staging':
                return 'staging';
            case 'prod':
                return 'production';
            case 'local':
                return 'local';
            default:
                return 'local';
        }
    };
});
parcelRegister("8dYib", function(module, exports) {
    $parcel$export(module.exports, "JiraWorkspaceAri", ()=>$5fce4e6fa5e3542e$export$d4d0794234e3fd53);
    var $b1EkX;
    var $9KGzW;
    var $1C2Ux;
    var $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("b1EkX")).JiraWorkspaceAriResourceOwner),
        resourceType: (0, (0, parcelRequire("b1EkX")).JiraWorkspaceAriResourceType),
        resourceIdSlug: "{activationId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/
        }
    };
    var $5fce4e6fa5e3542e$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.qualifier,
                platformQualifier: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.resourceOwner,
                resourceType: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.resourceType,
                resourceId: `${opts.activationId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts);
            return new _JiraWorkspaceAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts);
            return new _JiraWorkspaceAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId
            };
        }
    };
});
parcelRegister("b1EkX", function(module, exports) {
    $parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", ()=>$806f13cc47cff352$export$e52ccdf6abac8896);
    $parcel$export(module.exports, "JiraWorkspaceAriResourceType", ()=>$806f13cc47cff352$export$669cd5f7b3746bb);
    var $806f13cc47cff352$export$e52ccdf6abac8896 = "jira", $806f13cc47cff352$export$669cd5f7b3746bb = "workspace";
});
parcelRegister("iPMn1", function(module, exports) {
    $parcel$export(module.exports, "ScreenSpaceFlagsPlacement", ()=>$3ba8955bb8ac2826$export$f6564e60882bdf90);
    var $5uXOq = parcelRequire("5uXOq");
    var $jgefF;
    var $4R6GH;
    var $jQsty;
    var $SfWIb;
    var $7sr84;
    const $3ba8955bb8ac2826$var$PLACEMENT_ID = 'screen-space-flags';
    const $3ba8955bb8ac2826$export$f6564e60882bdf90 = ()=>{
        return !false && !(0, (0, parcelRequire("jQsty")).default)((0, $d0ca21152325de6b$export$37d4bb5bc0e315db)) && (0, (0, parcelRequire("4R6GH")).fg)('post-office-screen-space-overlay-jfe') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7sr84")).ScreenSpaceFlagPlacementPreviewSwitcher), {
            isEnabled: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("SfWIb")).default), {
            placementId: $3ba8955bb8ac2826$var$PLACEMENT_ID,
            PlacementComponent: (0, (0, parcelRequire("jgefF")).default),
            disableInitialData: true
        })) : null;
    };
});
parcelRegister("jgefF", function(module, exports) {
    $parcel$export(module.exports, "ScreenSpaceFlagsPlacementComponent", ()=>$bde3999cf210ffea$export$c60b43809441c5b0);
    $parcel$export(module.exports, "default", ()=>$bde3999cf210ffea$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $5uXOq = parcelRequire("5uXOq");
    var $5IPCv;
    var $eFjrB;
    var $hWRix;
    var $h3mjV;
    var $iXSVm;
    var $1mc52;
    var $7PgHB;
    var $92Slv;
    var $4rq6q;
    var $3p8Nq;
    const $bde3999cf210ffea$export$c60b43809441c5b0 = (0, (0, parcelRequire("3p8Nq")).withScreenSpaceFlagsIntlProvider)((0, (0, parcelRequire("iXSVm")).createPlacementComponent)((0, $f6721478b0b83c9a$export$a5cfae247d8360ef), ({ initialData: initialData })=>{
        const [localMessageState, setLocalMessageState] = (0, $5uXOq.useState)();
        (0, (0, parcelRequire("1mc52")).useInitialData)(initialData);
        const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, (0, parcelRequire("hWRix")).useMessagePlacementHooks)();
        const handleDismiss = ({ messageInstanceId: messageInstanceId })=>{
            setLocalMessageState((current)=>current ? current.filter((e)=>e.messageInstanceId !== messageInstanceId) : undefined);
        };
        (0, $5uXOq.useEffect)(()=>onMessageDismiss(handleDismiss), [
            onMessageDismiss
        ]);
        (0, $5uXOq.useEffect)(()=>onMessageClicked(handleDismiss), [
            onMessageClicked
        ]);
        (0, $5uXOq.useEffect)(()=>onMessageSnooze(handleDismiss), [
            onMessageSnooze
        ]);
        const activeScopes = (0, (0, parcelRequire("eFjrB")).usePostOfficeContextScope)({
            scopes: (0, parcelRequire("92Slv")).scopes
        });
        const messagesState = (0, (0, parcelRequire("7PgHB")).usePlacementApi)('/update-messages', {
            requestOptions: {
                method: 'POST',
                body: JSON.stringify(activeScopes)
            },
            throttleTime: 100,
            autoRefetch: {
                isEnabled: !!activeScopes.updateKey && typeof localMessageState === 'undefined',
                updateKey: activeScopes.updateKey ?? ''
            }
        });
        (0, $5uXOq.useEffect)(()=>{
            if (messagesState?.data?.messages?.length) setLocalMessageState(messagesState.data.messages);
        }, [
            messagesState.data
        ]);
        return (0, (0, parcelRequire("5IPCv")).default).checkGate('post-office-screen-space-flags-shadow') ? (0, $2OMIu.jsx)($bde3999cf210ffea$var$SuppressIfModalIsPresent, {
            children: localMessageState?.slice(0, 1).map(({ messageInstanceId: messageInstanceId, ...props })=>(0, $5uXOq.createElement)((0, (0, parcelRequire("4rq6q")).MessageRenderer), {
                    ...props,
                    key: messageInstanceId,
                    id: messageInstanceId,
                    messageInstanceId: messageInstanceId,
                    onDismissed: ()=>setLocalMessageState([])
                }))
        }) : null;
    }));
    var $bde3999cf210ffea$export$2e2bcd8739ae039 = $bde3999cf210ffea$export$c60b43809441c5b0;
    const $bde3999cf210ffea$var$SuppressIfModalIsPresent = ({ children: children })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("h3mjV")).useFirePostOfficeAnalyticsEvents)();
        const [isVisible, setIsVisible] = (0, $5uXOq.useState)(true);
        const handleVisibilityChange = (0, $5uXOq.useCallback)((modalOnScreen)=>{
            const shouldShow = !modalOnScreen;
            if (!shouldShow) fireAnalyticsEvent({
                eventType: 'operational',
                action: 'suppressed',
                actionSubject: 'screenSpaceFlags'
            });
            setIsVisible(shouldShow);
        }, [
            fireAnalyticsEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const modalOnScreen = !!document.querySelector('.atlaskit-portal-container .atlaskit-portal [role=dialog]');
            handleVisibilityChange(modalOnScreen);
        }, [
            handleVisibilityChange
        ]);
        return (0, (0, parcelRequire("5IPCv")).default).checkGate('post-office-screen-space-flags-modal-detector') ? (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: isVisible && children
        }) : (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("2OMIu", function(module, exports) {
    'use strict';
    module.exports = (parcelRequire("iIkmJ"));
});
parcelRegister("iIkmJ", function(module, exports) {
    $parcel$export(module.exports, "Fragment", ()=>$d9fc223fda04f9ed$export$ffb0004e005737fa, (v)=>$d9fc223fda04f9ed$export$ffb0004e005737fa = v);
    $parcel$export(module.exports, "jsx", ()=>$d9fc223fda04f9ed$export$34b9dba7ce09269b, (v)=>$d9fc223fda04f9ed$export$34b9dba7ce09269b = v);
    $parcel$export(module.exports, "jsxs", ()=>$d9fc223fda04f9ed$export$25062201e9e25d76, (v)=>$d9fc223fda04f9ed$export$25062201e9e25d76 = v);
    var $d9fc223fda04f9ed$export$ffb0004e005737fa;
    var $d9fc223fda04f9ed$export$34b9dba7ce09269b;
    var $d9fc223fda04f9ed$export$25062201e9e25d76;
    'use strict';
    var $5uXOq = parcelRequire("5uXOq");
    var $d9fc223fda04f9ed$var$k = Symbol.for("react.element"), $d9fc223fda04f9ed$var$l = Symbol.for("react.fragment"), $d9fc223fda04f9ed$var$m = Object.prototype.hasOwnProperty, $d9fc223fda04f9ed$var$n = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d9fc223fda04f9ed$var$p = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
    };
    function $d9fc223fda04f9ed$var$q(c, a, g) {
        var b, d = {}, e = null, h = null;
        void 0 !== g && (e = "" + g);
        void 0 !== a.key && (e = "" + a.key);
        void 0 !== a.ref && (h = a.ref);
        for(b in a)$d9fc223fda04f9ed$var$m.call(a, b) && !$d9fc223fda04f9ed$var$p.hasOwnProperty(b) && (d[b] = a[b]);
        if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
        return {
            $$typeof: $d9fc223fda04f9ed$var$k,
            type: c,
            key: e,
            ref: h,
            props: d,
            _owner: $d9fc223fda04f9ed$var$n.current
        };
    }
    $d9fc223fda04f9ed$export$ffb0004e005737fa = $d9fc223fda04f9ed$var$l;
    $d9fc223fda04f9ed$export$34b9dba7ce09269b = $d9fc223fda04f9ed$var$q;
    $d9fc223fda04f9ed$export$25062201e9e25d76 = $d9fc223fda04f9ed$var$q;
});
parcelRegister("eFjrB", function(module, exports) {
    $parcel$export(module.exports, "usePostOfficeContextScope", ()=>$3fdf392448c70ebb$export$daf66a67c26dc848);
    var $5uXOq = parcelRequire("5uXOq");
    var $kye0Q = parcelRequire("kye0Q");
    var $gHZ4O;
    var $lwdce;
    var $dM8xS;
    const $3fdf392448c70ebb$export$daf66a67c26dc848 = (config)=>{
        const scopeNames = $3fdf392448c70ebb$var$scopesNamesAsString(config.scopes);
        const matchScopes = (0, $5uXOq.useCallback)((input)=>$3fdf392448c70ebb$export$ec890b48cae4cc1c(config)(input), [
            scopeNames
        ]);
        const [state, setState] = (0, $5uXOq.useState)($3fdf392448c70ebb$var$initialState);
        const route = (0, (0, parcelRequire("lwdce")).usePostOfficeRoute)();
        const context = (0, (0, parcelRequire("gHZ4O")).usePostOfficeContext)();
        const next = matchScopes({
            route: route,
            context: context
        });
        $3fdf392448c70ebb$var$usePostOfficeScopeSpy(state, config);
        (0, $5uXOq.useEffect)(()=>{
            if ($3fdf392448c70ebb$export$fcc046cb16c47539({
                next: next,
                state: state
            })) setState(({ current: current })=>({
                    updateKey: Math.random().toString(36).substring(2),
                    current: next,
                    previous: current
                }));
        }, [
            $3fdf392448c70ebb$var$scopesNamesAsString(next)
        ]);
        return state;
    };
    const $3fdf392448c70ebb$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
    const $3fdf392448c70ebb$var$initialState = {
        updateKey: undefined,
        current: [],
        previous: []
    };
    const $3fdf392448c70ebb$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
            const contextMatch = route?.current ? {
                route: $3fdf392448c70ebb$var$extractRelevantUrlFields(route.current),
                context: context
            } : {
                route: undefined,
                context: context
            };
            const inputMatch = input.when;
            return $3fdf392448c70ebb$var$matchScope({
                contextMatch: contextMatch,
                inputMatch: inputMatch
            });
        };
    const $3fdf392448c70ebb$var$extractRelevantUrlFields = (route)=>{
        const { hostname: hostname, pathname: pathname } = new URL(route);
        return {
            hostname: hostname,
            pathname: pathname
        };
    };
    const $3fdf392448c70ebb$var$matchScope = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, ($parcel$interopDefault($kye0Q)))(contextMatch, inputMatch, (contextValue, inputValue)=>$3fdf392448c70ebb$var$isValueMatchDeep({
                contextValue: contextValue,
                inputValue: inputValue
            }));
    const $3fdf392448c70ebb$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
        if (!contextValue || !inputValue) return false;
        if (typeof inputValue === 'string') return contextValue === inputValue;
        if (inputValue?.equals) return contextValue === inputValue.equals;
        if (!inputValue?.matches) return false;
        if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
        return new RegExp(inputValue.matches).test(contextValue);
    };
    const $3fdf392448c70ebb$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $3fdf392448c70ebb$var$matchScope({
            contextMatch: contextValue,
            inputMatch: inputValue
        }) : $3fdf392448c70ebb$var$isValueMatch({
            contextValue: contextValue,
            inputValue: inputValue
        });
    const $3fdf392448c70ebb$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($3fdf392448c70ebb$var$createMatchScope(input)).map((scope)=>({
                    name: scope.name
                }));
    const $3fdf392448c70ebb$export$fcc046cb16c47539 = ({ next: next, state: state })=>{
        const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
        const nextSet = Array.from(new Set(next.map((e)=>e.name)));
        if (nextSet.length !== currentSet.length) return true;
        return !nextSet.every((e)=>currentSet.includes(e));
    };
    const $3fdf392448c70ebb$var$usePostOfficeScopeSpy = (state, config)=>{
        if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
            const [listen, update] = (0, (0, parcelRequire("dM8xS")).createSimplePubSub)();
            window.postOffice = {
                ...window.postOffice,
                scopes: {
                    [config?.consoleSpy.name]: {
                        listen: listen,
                        update: update,
                        list: config.scopes
                    }
                }
            };
        }
        (0, $5uXOq.useEffect)(()=>{
            if (!config?.consoleSpy) return;
            if (!window.postOffice?.scopes) return;
            window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
        }, [
            $3fdf392448c70ebb$var$scopesNamesAsString(state.current)
        ]);
    };
});
parcelRegister("kye0Q", function(module, exports) {
    var $b1bUS = parcelRequire("b1bUS");
    var $2TGin = parcelRequire("2TGin");
    function $ef61da41fa345164$var$isMatchWith(object, source, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined;
        return $b1bUS(object, source, $2TGin(source), customizer);
    }
    module.exports = $ef61da41fa345164$var$isMatchWith;
});
parcelRegister("h3mjV", function(module, exports) {
    $parcel$export(module.exports, "useFirePostOfficeAnalyticsEvents", ()=>$5bc838ac8c037623$export$57d19d18d6e255a5);
    var $2NMNM;
    var $5uXOq = parcelRequire("5uXOq");
    const $5bc838ac8c037623$export$85183a312807388d = 'postOffice';
    const $5bc838ac8c037623$export$57d19d18d6e255a5 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireAnalyticsEvent = (0, $5uXOq.useCallback)((event, attributes)=>{
            createAnalyticsEvent({
                ...event,
                side: 'client',
                attributes: {
                    ...event.attributes,
                    ...attributes
                }
            }).fire($5bc838ac8c037623$export$85183a312807388d);
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireAnalyticsEvent: fireAnalyticsEvent
        };
    };
});
parcelRegister("iXSVm", function(module, exports) {
    $parcel$export(module.exports, "createPlacementComponent", ()=>$6b6a90a3d180f695$export$8a57effc6307f916);
    var $2OMIu = parcelRequire("2OMIu");
    var $dmvPD;
    var $7ncVP;
    var $6WlcH;
    var $91kAg;
    var $7wONK;
    var $cMrkQ;
    const $6b6a90a3d180f695$export$eaeb39efb2b24b52 = (placementId, Component)=>(0, (0, parcelRequire("cMrkQ")).withErrorBoundary)((props)=>{
            const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
            const { postOfficeRoute: route, ...context } = contextWithRoute;
            const stableContext = (0, (0, parcelRequire("dmvPD")).useStableObject)(context);
            return (0, $2OMIu.jsx)((0, (0, parcelRequire("91kAg")).PerformanceTracking), {
                initialData: initialData,
                onEvent: onEvent,
                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("7wONK")).StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    children: (0, $2OMIu.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            });
        });
    const $6b6a90a3d180f695$export$8a57effc6307f916 = (placementId, Component)=>{
        const placement = $6b6a90a3d180f695$export$eaeb39efb2b24b52(placementId, Component);
        return (props)=>{
            const { onError: onError, fallbackRender: fallbackRender } = (0, (0, parcelRequire("6WlcH")).useComponentErrorHandling)(props);
            return placement({
                ...props,
                errorBoundaryLocation: (0, (0, parcelRequire("7ncVP")).ERROR_BOUNDARY_LOCATION),
                onError: onError,
                fallbackRender: fallbackRender
            });
        };
    };
});
parcelRegister("7ncVP", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_CONTEXT", ()=>$565ab85685242653$export$9c542858adf7dcd0);
    $parcel$export(module.exports, "ERROR_BOUNDARY_LOCATION", ()=>$565ab85685242653$export$71ff7382870ef1b0);
    const $565ab85685242653$export$9c542858adf7dcd0 = {
        isSiteAdmin: undefined,
        locale: undefined,
        product: undefined,
        subproduct: undefined,
        tenantId: undefined,
        workspaceAri: 'no-workspace-ari-available',
        workspaceId: undefined,
        orgId: undefined,
        productEdition: undefined
    };
    const $565ab85685242653$export$71ff7382870ef1b0 = 'create-placement-component';
});
parcelRegister("6WlcH", function(module, exports) {
    $parcel$export(module.exports, "useComponentErrorHandling", ()=>$1540e801d3c88295$export$3d127465d22fe4e5);
    var $5uXOq = parcelRequire("5uXOq");
    const $1540e801d3c88295$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
        const internalOnError = (0, $5uXOq.useCallback)((error, info)=>{
            onEvent?.({
                type: 'component-error',
                error: error
            });
            onError?.(error, info);
        }, [
            onEvent,
            onError
        ]);
        const internalFallbackRender = fallbackRender ?? errorFallback;
        return {
            onError: internalOnError,
            fallbackRender: internalFallbackRender
        };
    };
});
parcelRegister("91kAg", function(module, exports) {
    $parcel$export(module.exports, "PerformanceTracking", ()=>$aca6e70a98eb13dc$export$9a335a42ce02bdb8);
    var $2OMIu = parcelRequire("2OMIu");
    var $5IPCv;
    var $5H0An;
    var $k42Hu;
    var $6ywV7;
    const $aca6e70a98eb13dc$export$9a335a42ce02bdb8 = ({ children: children, ...props })=>{
        const isUFOEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate('enable_ufo_tracking_in_post_office');
        const { isLoading: isLoading, onMount: onMount } = (0, (0, parcelRequire("6ywV7")).usePerformanceTracking)(props);
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("5H0An")).UFOv2).UFOSegment, {
            name: (0, (0, parcelRequire("5H0An")).UFOv2).SegmentNames.PLACEMENT,
            children: [
                isUFOEnabled && isLoading && (0, $2OMIu.jsx)((0, (0, parcelRequire("5H0An")).UFOv2).UFOLoadHold, {
                    name: (0, (0, parcelRequire("5H0An")).UFOv2).HoldNames.PLACEMENT
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("k42Hu")).TrackMount), {
                    onMount: onMount,
                    children: children
                })
            ]
        });
    };
});
parcelRegister("5H0An", function(module, exports) {
    $parcel$export(module.exports, "UFOv2", ()=>$cbdc98b350424372$export$c91b09caa8ecbab1);
    var $fNobW;
    var $8Ec39;
    const $cbdc98b350424372$export$c91b09caa8ecbab1 = {
        SegmentNames: {
            REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
            PLACEMENT: 'post-office-placement',
            MESSAGE: 'post-office-message'
        },
        HoldNames: {
            REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
            PLACEMENT: 'post-office-placement-loading',
            MESSAGE: 'post-office-message-loading'
        },
        UFOLoadHold: (0, parcelRequire("fNobW")).default,
        UFOSegment: (0, parcelRequire("8Ec39")).default
    };
});
parcelRegister("k42Hu", function(module, exports) {
    $parcel$export(module.exports, "TrackMount", ()=>$50a67969103c2bfd$export$21b400a8c8ebc91a);
    var $2OMIu = parcelRequire("2OMIu");
    var $5uXOq = parcelRequire("5uXOq");
    const $50a67969103c2bfd$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
        (0, $5uXOq.useEffect)(()=>{
            const onUnmount = onMount();
            return onUnmount;
        }, []);
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("6ywV7", function(module, exports) {
    $parcel$export(module.exports, "usePerformanceTracking", ()=>$60c56bf5d2afa73f$export$317d52099614f316);
    var $5uXOq = parcelRequire("5uXOq");
    const $60c56bf5d2afa73f$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
        const onMount = (0, $5uXOq.useCallback)(()=>{
            return ()=>onEvent?.({
                    type: 'unmount'
                });
        }, [
            onEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (initialData) initialData.then(()=>{
                onEvent?.({
                    type: 'initial-data-complete'
                });
            }).catch((error)=>{
                onEvent?.({
                    type: 'initial-data-error',
                    error: error
                });
            }).finally(()=>{
                setIsLoading(false);
            });
            else setIsLoading(false);
        }, [
            initialData,
            onEvent
        ]);
        const onComponentError = (0, $5uXOq.useCallback)((error)=>{
            onEvent?.({
                type: 'component-error',
                error: error
            });
        }, [
            onEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isLoading === false) onEvent?.({
                type: 'component-ready'
            });
        }, [
            isLoading
        ]);
        return {
            onMount: onMount,
            isLoading: isLoading,
            onComponentError: onComponentError
        };
    };
});
parcelRegister("7wONK", function(module, exports) {
    $parcel$export(module.exports, "StableProviders", ()=>$55e436d1a4674431$export$2b6596bcb1383a71);
    var $2OMIu = parcelRequire("2OMIu");
    var $1Sj4e;
    var $04jsn;
    var $8IVWW;
    var $9P3TE;
    var $ggJMp;
    var $bDGqG;
    var $91kAg;
    const $55e436d1a4674431$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route })=>(0, $2OMIu.jsx)((0, (0, parcelRequire("9P3TE")).StableContextProvider), {
            context: context,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("ggJMp")).StablePlacementProvider), {
                placement: placement,
                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("bDGqG")).StableRouteProvider), {
                    route: route,
                    children: (0, $2OMIu.jsx)((0, (0, parcelRequire("04jsn")).StableAnaltyicsProvider), {
                        children: (0, $2OMIu.jsx)((0, (0, parcelRequire("8IVWW")).StableChoreographerProvider), {
                            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("1Sj4e")).RenderTrackerProvider), {
                                placementId: placement.placementId,
                                children: children
                            })
                        })
                    })
                })
            })
        });
});
parcelRegister("1Sj4e", function(module, exports) {
    $parcel$export(module.exports, "RenderTrackerProvider", ()=>$8c48e8a04bfa2a64$export$2d84fd9af6c9e378);
    var $2OMIu = parcelRequire("2OMIu");
    var $h3mjV;
    var $5uXOq = parcelRequire("5uXOq");
    const $8c48e8a04bfa2a64$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
        'screen-space-flags'
    ];
    const $8c48e8a04bfa2a64$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("h3mjV")).useFirePostOfficeAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if ($8c48e8a04bfa2a64$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
            fireAnalyticsEvent({
                eventType: 'track',
                action: 'rendered',
                actionSubject: 'placement'
            });
        }, [
            fireAnalyticsEvent,
            placementId
        ]);
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("04jsn", function(module, exports) {
    $parcel$export(module.exports, "StableAnaltyicsProvider", ()=>$710055c5ee12714f$export$5a66cdc9893b43e);
    var $2OMIu = parcelRequire("2OMIu");
    var $1PVpv = parcelRequire("1PVpv");
    const $710055c5ee12714f$var$postOfficeAnalyticsContextData = {
        attributes: {
            build: {
                c: undefined,
                b: undefined,
                t: undefined
            }
        }
    };
    const $710055c5ee12714f$export$5a66cdc9893b43e = ({ children: children })=>{
        return (0, $2OMIu.jsx)((0, $1PVpv.PostOfficeAnalyticsContext), {
            data: $710055c5ee12714f$var$postOfficeAnalyticsContextData,
            children: children
        });
    };
});
parcelRegister("8IVWW", function(module, exports) {
    $parcel$export(module.exports, "StableChoreographerProvider", ()=>$5cbaf6c43da97ba7$export$e68b2c75bfb5682a);
    $parcel$export(module.exports, "useChoreographerContext", ()=>$5cbaf6c43da97ba7$export$cab5a8adbabcee23);
    var $2OMIu = parcelRequire("2OMIu");
    var $gHZ4O;
    var $5MYiV;
    var $5uXOq = parcelRequire("5uXOq");
    var $8rxdt;
    const $5cbaf6c43da97ba7$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
    const $5cbaf6c43da97ba7$var$defaultContext = {
        choreographerEnabled: $5cbaf6c43da97ba7$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
        setChoreographerEnabled: ()=>{},
        factory: undefined
    };
    const $5cbaf6c43da97ba7$var$ChoreographerContext = (0, $5uXOq.createContext)($5cbaf6c43da97ba7$var$defaultContext);
    const $5cbaf6c43da97ba7$export$e68b2c75bfb5682a = ({ children: children })=>{
        const [choreographerEnabled, setChoreographerEnabled] = (0, $5uXOq.useState)($5cbaf6c43da97ba7$var$defaultContext.choreographerEnabled);
        const environmentContext = (0, (0, parcelRequire("5MYiV")).usePostOfficeEnvironment)();
        const context = (0, (0, parcelRequire("gHZ4O")).usePostOfficeContext)();
        const choreographerFactory = new (0, (0, parcelRequire("8rxdt")).default)(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory();
        const stableChoreographerContext = (0, $5uXOq.useMemo)(()=>({
                factory: choreographerFactory,
                choreographerEnabled: choreographerEnabled,
                setChoreographerEnabled: setChoreographerEnabled
            }), [
            choreographerFactory,
            choreographerEnabled,
            setChoreographerEnabled
        ]);
        return (0, $2OMIu.jsx)($5cbaf6c43da97ba7$var$ChoreographerContext.Provider, {
            value: stableChoreographerContext,
            children: children
        });
    };
    const $5cbaf6c43da97ba7$export$cab5a8adbabcee23 = ()=>(0, $5uXOq.useContext)($5cbaf6c43da97ba7$var$ChoreographerContext);
});
parcelRegister("8rxdt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f823a5e69a4bdde1$export$2e2bcd8739ae039);
    var $4zICj;
    var $TTRxY;
    var $iZhen;
    const $f823a5e69a4bdde1$var$mapEnvToAnalyticsEnv = (env)=>{
        switch(env){
            case 'test':
            case 'local':
                return (0, (0, parcelRequire("iZhen")).envType).LOCAL;
            case 'dev':
                return (0, (0, parcelRequire("iZhen")).envType).DEV;
            case 'staging':
            case 'stg-fedm-east':
                return (0, (0, parcelRequire("iZhen")).envType).STAGING;
            case 'production':
            case 'prod-fedm-east':
                return (0, (0, parcelRequire("iZhen")).envType).PROD;
            default:
                return (0, (0, parcelRequire("iZhen")).envType).DEV;
        }
    };
    class $f823a5e69a4bdde1$var$ChoreographerRegistry {
        constructor(product, environment){
            this.product = product;
            this.environment = environment;
        }
        getPostOfficeChoreographerFactory() {
            if (window.choreographerRegistry === undefined) window.choreographerRegistry = new Map();
            const maybeChoreographerFactory = window.choreographerRegistry.get((0, (0, parcelRequire("TTRxY")).ProductIds).POST_OFFICE);
            if (maybeChoreographerFactory) return maybeChoreographerFactory;
            const factory = (0, (0, parcelRequire("4zICj")).choreographerFactory)((0, (0, parcelRequire("TTRxY")).ProductIds).POST_OFFICE, $f823a5e69a4bdde1$var$mapEnvToAnalyticsEnv(this.environment), {
                sourceProductId: this.product
            });
            window.choreographerRegistry.set((0, (0, parcelRequire("TTRxY")).ProductIds).POST_OFFICE, factory);
            return factory;
        }
    }
    var $f823a5e69a4bdde1$export$2e2bcd8739ae039 = $f823a5e69a4bdde1$var$ChoreographerRegistry;
});
parcelRegister("9P3TE", function(module, exports) {
    $parcel$export(module.exports, "StableContextProvider", ()=>$6767a9a09c3fcd53$export$d4982c0a28b18f63);
    var $2OMIu = parcelRequire("2OMIu");
    var $gHZ4O;
    var $dmvPD;
    var $7ncVP;
    const $6767a9a09c3fcd53$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
        const stableContext = (0, (0, parcelRequire("dmvPD")).useStableObject)({
            ...(0, (0, parcelRequire("7ncVP")).DEFAULT_CONTEXT),
            ...context
        });
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("gHZ4O")).PostOfficeContextProvider), {
            value: stableContext,
            children: children
        });
    };
});
parcelRegister("ggJMp", function(module, exports) {
    $parcel$export(module.exports, "StablePlacementProvider", ()=>$272ba963095674d4$export$e9fd288527498af6);
    var $2OMIu = parcelRequire("2OMIu");
    var $dmvPD;
    var $9uYQQ;
    const $272ba963095674d4$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
        const stableValue = (0, (0, parcelRequire("dmvPD")).useStableObject)(placement);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("9uYQQ")).PlacementProvider), {
            value: stableValue,
            children: children
        });
    };
});
parcelRegister("9uYQQ", function(module, exports) {
    $parcel$export(module.exports, "PlacementProvider", ()=>$9a7fffcf8781b15b$export$6272e220478c7f1d);
    $parcel$export(module.exports, "usePlacementContext", ()=>$9a7fffcf8781b15b$export$4fc0446ee742ad80);
    var $2OMIu = parcelRequire("2OMIu");
    var $1PVpv = parcelRequire("1PVpv");
    var $iTZyv;
    var $5uXOq = parcelRequire("5uXOq");
    const $9a7fffcf8781b15b$export$6394bf86db095a8 = (0, $5uXOq.createContext)({
        placementId: undefined
    });
    const $9a7fffcf8781b15b$export$6272e220478c7f1d = ({ value: value, children: children })=>{
        const memoizedValue = (0, $5uXOq.useMemo)(()=>({
                placementId: value.placementId
            }), [
            value.placementId
        ]);
        (0, (0, parcelRequire("iTZyv")).usePostOfficeScreenPlacement)(memoizedValue);
        return (0, $2OMIu.jsx)($9a7fffcf8781b15b$export$6394bf86db095a8.Provider, {
            value: memoizedValue,
            children: (0, $2OMIu.jsx)((0, $1PVpv.PostOfficeAnalyticsContext), {
                data: memoizedValue,
                children: children
            })
        });
    };
    const $9a7fffcf8781b15b$export$4fc0446ee742ad80 = ()=>(0, $5uXOq.useContext)($9a7fffcf8781b15b$export$6394bf86db095a8);
});
parcelRegister("bDGqG", function(module, exports) {
    $parcel$export(module.exports, "StableRouteProvider", ()=>$0c781d2417991e36$export$ce13d00e696dfc96);
    var $2OMIu = parcelRequire("2OMIu");
    var $lwdce;
    var $dmvPD;
    var $21kSR;
    const $0c781d2417991e36$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
        const href = (0, (0, parcelRequire("21kSR")).useLocationHref)();
        const stableRoute = (0, (0, parcelRequire("dmvPD")).useStableObject)(route ?? {
            previous: href,
            current: href
        });
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("lwdce")).PostOfficeRouteContext).Provider, {
            value: stableRoute,
            children: children
        });
    };
});
parcelRegister("21kSR", function(module, exports) {
    $parcel$export(module.exports, "useLocationHref", ()=>$119e036a70bf0d4f$export$49fc3f3d8c7f99);
    const $119e036a70bf0d4f$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
    const $119e036a70bf0d4f$export$49fc3f3d8c7f99 = ()=>{
        return $119e036a70bf0d4f$var$isLocationAvailable() ? globalThis.location.href : undefined;
    };
});
parcelRegister("cMrkQ", function(module, exports) {
    $parcel$export(module.exports, "withErrorBoundary", ()=>$e8809641acc51790$export$f0c7a449e0cfaec7);
    var $2OMIu = parcelRequire("2OMIu");
    var $h3mjV;
    var $lilOZ;
    const $e8809641acc51790$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, fallbackRender: fallbackRender, onError: onError, ...data })=>{
            const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("h3mjV")).useFirePostOfficeAnalyticsEvents)();
            const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                    if (onError) onError(error, info);
                    fireAnalyticsEvent({
                        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                        action: 'caughtError',
                        actionSubject: 'PostOfficeErrorBoundary',
                        actionSubjectId: additionalAnalytics.errorBoundaryLocation
                    }, {
                        error: error,
                        info: info
                    });
                };
            const internalFallbackRender = (FallbackRender)=>(props)=>{
                    if (FallbackRender) return (0, $2OMIu.jsx)(FallbackRender, {
                        ...props
                    });
                    return null;
                };
            return (0, $2OMIu.jsx)((0, (0, parcelRequire("lilOZ")).ErrorBoundary), {
                fallbackRender: internalFallbackRender(fallbackRender),
                onError: internalOnError({
                    errorBoundaryLocation: errorBoundaryLocation
                }, onError),
                children: (0, $2OMIu.jsx)(Component, {
                    ...data
                })
            });
        };
});
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';
parcelRegister("lilOZ", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$f80c34b0760a7119$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    'use client';
    const $f80c34b0760a7119$export$b16d9fb1a22de840 = (0, $5uXOq.createContext)(null);
    const $f80c34b0760a7119$var$initialState = {
        didCatch: false,
        error: null
    };
    class $f80c34b0760a7119$export$e926676385687eaf extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
            this.state = $f80c34b0760a7119$var$initialState;
        }
        static getDerivedStateFromError(error) {
            return {
                didCatch: true,
                error: error
            };
        }
        resetErrorBoundary() {
            const { error: error } = this.state;
            if (error !== null) {
                var _this$props$onReset, _this$props;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                    args: args,
                    reason: "imperative-api"
                });
                this.setState($f80c34b0760a7119$var$initialState);
            }
        }
        componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
        }
        componentDidUpdate(prevProps, prevState) {
            const { didCatch: didCatch } = this.state;
            const { resetKeys: resetKeys } = this.props;
            if (didCatch && prevState.error !== null && $f80c34b0760a7119$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
                var _this$props$onReset2, _this$props3;
                (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                    next: resetKeys,
                    prev: prevProps.resetKeys,
                    reason: "keys"
                });
                this.setState($f80c34b0760a7119$var$initialState);
            }
        }
        render() {
            const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
            const { didCatch: didCatch, error: error } = this.state;
            let childToRender = children;
            if (didCatch) {
                const props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
                else if (FallbackComponent) childToRender = (0, $5uXOq.createElement)(FallbackComponent, props);
                else if (fallback === null || (0, $5uXOq.isValidElement)(fallback)) childToRender = fallback;
                else throw error;
            }
            return (0, $5uXOq.createElement)($f80c34b0760a7119$export$b16d9fb1a22de840.Provider, {
                value: {
                    didCatch: didCatch,
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                }
            }, childToRender);
        }
    }
    function $f80c34b0760a7119$var$hasArrayChanged() {
        let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
    }
    function $f80c34b0760a7119$var$assertErrorBoundaryContext(value) {
        if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
    }
    function $f80c34b0760a7119$export$c052f6604b7d51fe() {
        const context = (0, $5uXOq.useContext)($f80c34b0760a7119$export$b16d9fb1a22de840);
        $f80c34b0760a7119$var$assertErrorBoundaryContext(context);
        const [state, setState] = (0, $5uXOq.useState)({
            error: null,
            hasError: false
        });
        const memoized = (0, $5uXOq.useMemo)(()=>({
                resetBoundary: ()=>{
                    context.resetErrorBoundary();
                    setState({
                        error: null,
                        hasError: false
                    });
                },
                showBoundary: (error)=>setState({
                        error: error,
                        hasError: true
                    })
            }), [
            context.resetErrorBoundary
        ]);
        if (state.hasError) throw state.error;
        return memoized;
    }
    function $f80c34b0760a7119$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
        const Wrapped = (0, $5uXOq.forwardRef)((props, ref)=>(0, $5uXOq.createElement)($f80c34b0760a7119$export$e926676385687eaf, errorBoundaryProps, (0, $5uXOq.createElement)(component, {
                ...props,
                ref: ref
            })));
        const name = component.displayName || component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
        return Wrapped;
    }
});
parcelRegister("1mc52", function(module, exports) {
    $parcel$export(module.exports, "useInitialData", ()=>$40d2fd940b9d1c6e$export$5523c5f3222291d0);
    var $5uXOq = parcelRequire("5uXOq");
    var $5NGOu;
    const $40d2fd940b9d1c6e$export$5523c5f3222291d0 = (initialData)=>{
        const initialDataCallback = (0, $5uXOq.useMemo)(()=>{
            if (typeof initialData === 'undefined') return undefined;
            return ()=>initialData;
        }, [
            initialData
        ]);
        return (0, (0, parcelRequire("5NGOu")).useData)(initialDataCallback, {
            analytics: {
                name: 'initialData'
            }
        });
    };
});
parcelRegister("5NGOu", function(module, exports) {
    $parcel$export(module.exports, "AlreadyRunningError", ()=>$6f73ba24b9c26bf5$export$8c5224d3af2f3c8b);
    $parcel$export(module.exports, "useData", ()=>$6f73ba24b9c26bf5$export$c1cf1cf4c5d51937);
    var $h3mjV;
    var $lzG7s = parcelRequire("lzG7s");
    var $5uXOq = parcelRequire("5uXOq");
    var $azprR;
    class $6f73ba24b9c26bf5$export$8c5224d3af2f3c8b extends Error {
        constructor(){
            super('Request is already running.');
            this.name = 'AlreadyRunningError';
        }
    }
    const $6f73ba24b9c26bf5$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
        const [state, setState] = (0, $5uXOq.useState)((0, (0, parcelRequire("azprR")).toLoading)());
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("h3mjV")).useFirePostOfficeAnalyticsEvents)();
        const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
            name: 'unknown'
        };
        (0, $5uXOq.useEffect)(()=>{
            if (typeof promiseToResolve !== 'function') return;
            const abortController = new AbortController();
            const { signal: signal } = abortController;
            promiseToResolve({
                signal: signal
            }).then((0, (0, parcelRequire("azprR")).assertResponseIsOk)).then((res)=>res.json()).then((data)=>{
                setState((0, (0, parcelRequire("azprR")).toData)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }).catch((err)=>{
                if (err instanceof $6f73ba24b9c26bf5$export$8c5224d3af2f3c8b || signal.aborted) return;
                const errorState = (0, (0, parcelRequire("azprR")).toError)(err);
                fireAnalyticsEvent({
                    action: 'rejected',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes,
                        errorName: errorState.error.name ?? 'unknown',
                        errorMessage: errorState.error.message ?? 'unknown'
                    }
                });
                setState(errorState);
            });
            return ()=>{
                abortController.abort();
            };
        }, [
            promiseToResolve
        ]);
        return state;
    };
});
parcelRegister("lzG7s", function(module, exports) {
    (function() {
        var undefined;
        var VERSION = '4.17.21';
        var LARGE_ARRAY_SIZE = 200;
        var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
        var HASH_UNDEFINED = '__lodash_hash_undefined__';
        var MAX_MEMOIZE_SIZE = 500;
        var PLACEHOLDER = '__lodash_placeholder__';
        var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
        var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
        var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
        var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
        var HOT_COUNT = 800, HOT_SPAN = 16;
        var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
        var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
        var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
        var wrapFlags = [
            [
                'ary',
                WRAP_ARY_FLAG
            ],
            [
                'bind',
                WRAP_BIND_FLAG
            ],
            [
                'bindKey',
                WRAP_BIND_KEY_FLAG
            ],
            [
                'curry',
                WRAP_CURRY_FLAG
            ],
            [
                'curryRight',
                WRAP_CURRY_RIGHT_FLAG
            ],
            [
                'flip',
                WRAP_FLIP_FLAG
            ],
            [
                'partial',
                WRAP_PARTIAL_FLAG
            ],
            [
                'partialRight',
                WRAP_PARTIAL_RIGHT_FLAG
            ],
            [
                'rearg',
                WRAP_REARG_FLAG
            ]
        ];
        var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
        var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
        var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
        var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
        var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
        var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
        var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
        var reTrimStart = /^\s+/;
        var reWhitespace = /\s/;
        var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
        var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
        var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
        var reEscapeChar = /\\(\\)?/g;
        var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
        var reFlags = /\w*$/;
        var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
        var reIsBinary = /^0b[01]+$/i;
        var reIsHostCtor = /^\[object .+?Constructor\]$/;
        var reIsOctal = /^0o[0-7]+$/i;
        var reIsUint = /^(?:0|[1-9]\d*)$/;
        var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
        var reNoMatch = /($^)/;
        var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
        var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
        var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
        var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
            rsNonAstral,
            rsRegional,
            rsSurrPair
        ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
            rsDingbat,
            rsRegional,
            rsSurrPair
        ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
            rsNonAstral + rsCombo + '?',
            rsCombo,
            rsRegional,
            rsSurrPair,
            rsAstral
        ].join('|') + ')';
        var reApos = RegExp(rsApos, 'g');
        var reComboMark = RegExp(rsCombo, 'g');
        var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
        var reUnicodeWord = RegExp([
            rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
                rsBreak,
                rsUpper,
                '$'
            ].join('|') + ')',
            rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
                rsBreak,
                rsUpper + rsMiscLower,
                '$'
            ].join('|') + ')',
            rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
            rsUpper + '+' + rsOptContrUpper,
            rsOrdUpper,
            rsOrdLower,
            rsDigits,
            rsEmoji
        ].join('|'), 'g');
        var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
        var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
        var contextProps = [
            'Array',
            'Buffer',
            'DataView',
            'Date',
            'Error',
            'Float32Array',
            'Float64Array',
            'Function',
            'Int8Array',
            'Int16Array',
            'Int32Array',
            'Map',
            'Math',
            'Object',
            'Promise',
            'RegExp',
            'Set',
            'String',
            'Symbol',
            'TypeError',
            'Uint8Array',
            'Uint8ClampedArray',
            'Uint16Array',
            'Uint32Array',
            'WeakMap',
            '_',
            'clearTimeout',
            'isFinite',
            'parseInt',
            'setTimeout'
        ];
        var templateCounter = -1;
        var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
        var cloneableTags = {};
        cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
        cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
        var deburredLetters = {
            '\xc0': 'A',
            '\xc1': 'A',
            '\xc2': 'A',
            '\xc3': 'A',
            '\xc4': 'A',
            '\xc5': 'A',
            '\xe0': 'a',
            '\xe1': 'a',
            '\xe2': 'a',
            '\xe3': 'a',
            '\xe4': 'a',
            '\xe5': 'a',
            '\xc7': 'C',
            '\xe7': 'c',
            '\xd0': 'D',
            '\xf0': 'd',
            '\xc8': 'E',
            '\xc9': 'E',
            '\xca': 'E',
            '\xcb': 'E',
            '\xe8': 'e',
            '\xe9': 'e',
            '\xea': 'e',
            '\xeb': 'e',
            '\xcc': 'I',
            '\xcd': 'I',
            '\xce': 'I',
            '\xcf': 'I',
            '\xec': 'i',
            '\xed': 'i',
            '\xee': 'i',
            '\xef': 'i',
            '\xd1': 'N',
            '\xf1': 'n',
            '\xd2': 'O',
            '\xd3': 'O',
            '\xd4': 'O',
            '\xd5': 'O',
            '\xd6': 'O',
            '\xd8': 'O',
            '\xf2': 'o',
            '\xf3': 'o',
            '\xf4': 'o',
            '\xf5': 'o',
            '\xf6': 'o',
            '\xf8': 'o',
            '\xd9': 'U',
            '\xda': 'U',
            '\xdb': 'U',
            '\xdc': 'U',
            '\xf9': 'u',
            '\xfa': 'u',
            '\xfb': 'u',
            '\xfc': 'u',
            '\xdd': 'Y',
            '\xfd': 'y',
            '\xff': 'y',
            '\xc6': 'Ae',
            '\xe6': 'ae',
            '\xde': 'Th',
            '\xfe': 'th',
            '\xdf': 'ss',
            '\u0100': 'A',
            '\u0102': 'A',
            '\u0104': 'A',
            '\u0101': 'a',
            '\u0103': 'a',
            '\u0105': 'a',
            '\u0106': 'C',
            '\u0108': 'C',
            '\u010a': 'C',
            '\u010c': 'C',
            '\u0107': 'c',
            '\u0109': 'c',
            '\u010b': 'c',
            '\u010d': 'c',
            '\u010e': 'D',
            '\u0110': 'D',
            '\u010f': 'd',
            '\u0111': 'd',
            '\u0112': 'E',
            '\u0114': 'E',
            '\u0116': 'E',
            '\u0118': 'E',
            '\u011a': 'E',
            '\u0113': 'e',
            '\u0115': 'e',
            '\u0117': 'e',
            '\u0119': 'e',
            '\u011b': 'e',
            '\u011c': 'G',
            '\u011e': 'G',
            '\u0120': 'G',
            '\u0122': 'G',
            '\u011d': 'g',
            '\u011f': 'g',
            '\u0121': 'g',
            '\u0123': 'g',
            '\u0124': 'H',
            '\u0126': 'H',
            '\u0125': 'h',
            '\u0127': 'h',
            '\u0128': 'I',
            '\u012a': 'I',
            '\u012c': 'I',
            '\u012e': 'I',
            '\u0130': 'I',
            '\u0129': 'i',
            '\u012b': 'i',
            '\u012d': 'i',
            '\u012f': 'i',
            '\u0131': 'i',
            '\u0134': 'J',
            '\u0135': 'j',
            '\u0136': 'K',
            '\u0137': 'k',
            '\u0138': 'k',
            '\u0139': 'L',
            '\u013b': 'L',
            '\u013d': 'L',
            '\u013f': 'L',
            '\u0141': 'L',
            '\u013a': 'l',
            '\u013c': 'l',
            '\u013e': 'l',
            '\u0140': 'l',
            '\u0142': 'l',
            '\u0143': 'N',
            '\u0145': 'N',
            '\u0147': 'N',
            '\u014a': 'N',
            '\u0144': 'n',
            '\u0146': 'n',
            '\u0148': 'n',
            '\u014b': 'n',
            '\u014c': 'O',
            '\u014e': 'O',
            '\u0150': 'O',
            '\u014d': 'o',
            '\u014f': 'o',
            '\u0151': 'o',
            '\u0154': 'R',
            '\u0156': 'R',
            '\u0158': 'R',
            '\u0155': 'r',
            '\u0157': 'r',
            '\u0159': 'r',
            '\u015a': 'S',
            '\u015c': 'S',
            '\u015e': 'S',
            '\u0160': 'S',
            '\u015b': 's',
            '\u015d': 's',
            '\u015f': 's',
            '\u0161': 's',
            '\u0162': 'T',
            '\u0164': 'T',
            '\u0166': 'T',
            '\u0163': 't',
            '\u0165': 't',
            '\u0167': 't',
            '\u0168': 'U',
            '\u016a': 'U',
            '\u016c': 'U',
            '\u016e': 'U',
            '\u0170': 'U',
            '\u0172': 'U',
            '\u0169': 'u',
            '\u016b': 'u',
            '\u016d': 'u',
            '\u016f': 'u',
            '\u0171': 'u',
            '\u0173': 'u',
            '\u0174': 'W',
            '\u0175': 'w',
            '\u0176': 'Y',
            '\u0177': 'y',
            '\u0178': 'Y',
            '\u0179': 'Z',
            '\u017b': 'Z',
            '\u017d': 'Z',
            '\u017a': 'z',
            '\u017c': 'z',
            '\u017e': 'z',
            '\u0132': 'IJ',
            '\u0133': 'ij',
            '\u0152': 'Oe',
            '\u0153': 'oe',
            '\u0149': "'n",
            '\u017f': 's'
        };
        var htmlEscapes = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        };
        var htmlUnescapes = {
            '&amp;': '&',
            '&lt;': '<',
            '&gt;': '>',
            '&quot;': '"',
            '&#39;': "'"
        };
        var stringEscapes = {
            '\\': '\\',
            "'": "'",
            '\n': 'n',
            '\r': 'r',
            '\u2028': 'u2028',
            '\u2029': 'u2029'
        };
        var freeParseFloat = parseFloat, freeParseInt = parseInt;
        var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
        var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
        var root = freeGlobal || freeSelf || Function('return this')();
        var freeExports = exports && !exports.nodeType && exports;
        var freeModule = freeExports && true && module && !module.nodeType && module;
        var moduleExports = freeModule && freeModule.exports === freeExports;
        var freeProcess = moduleExports && freeGlobal.process;
        var nodeUtil = function() {
            try {
                var types = freeModule && freeModule.require && freeModule.require('util').types;
                if (types) return types;
                return freeProcess && freeProcess.binding && freeProcess.binding('util');
            } catch (e) {}
        }();
        var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
        function apply(func, thisArg, args) {
            switch(args.length){
                case 0:
                    return func.call(thisArg);
                case 1:
                    return func.call(thisArg, args[0]);
                case 2:
                    return func.call(thisArg, args[0], args[1]);
                case 3:
                    return func.call(thisArg, args[0], args[1], args[2]);
            }
            return func.apply(thisArg, args);
        }
        function arrayAggregator(array, setter, iteratee, accumulator) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                var value = array[index];
                setter(accumulator, value, iteratee(value), array);
            }
            return accumulator;
        }
        function arrayEach(array, iteratee) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (iteratee(array[index], index, array) === false) break;
            }
            return array;
        }
        function arrayEachRight(array, iteratee) {
            var length = array == null ? 0 : array.length;
            while(length--){
                if (iteratee(array[length], length, array) === false) break;
            }
            return array;
        }
        function arrayEvery(array, predicate) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (!predicate(array[index], index, array)) return false;
            }
            return true;
        }
        function arrayFilter(array, predicate) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) result[resIndex++] = value;
            }
            return result;
        }
        function arrayIncludes(array, value) {
            var length = array == null ? 0 : array.length;
            return !!length && baseIndexOf(array, value, 0) > -1;
        }
        function arrayIncludesWith(array, value, comparator) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (comparator(value, array[index])) return true;
            }
            return false;
        }
        function arrayMap(array, iteratee) {
            var index = -1, length = array == null ? 0 : array.length, result = Array(length);
            while(++index < length)result[index] = iteratee(array[index], index, array);
            return result;
        }
        function arrayPush(array, values) {
            var index = -1, length = values.length, offset = array.length;
            while(++index < length)array[offset + index] = values[index];
            return array;
        }
        function arrayReduce(array, iteratee, accumulator, initAccum) {
            var index = -1, length = array == null ? 0 : array.length;
            if (initAccum && length) accumulator = array[++index];
            while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
            return accumulator;
        }
        function arrayReduceRight(array, iteratee, accumulator, initAccum) {
            var length = array == null ? 0 : array.length;
            if (initAccum && length) accumulator = array[--length];
            while(length--)accumulator = iteratee(accumulator, array[length], length, array);
            return accumulator;
        }
        function arraySome(array, predicate) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (predicate(array[index], index, array)) return true;
            }
            return false;
        }
        var asciiSize = baseProperty('length');
        function asciiToArray(string) {
            return string.split('');
        }
        function asciiWords(string) {
            return string.match(reAsciiWord) || [];
        }
        function baseFindKey(collection, predicate, eachFunc) {
            var result;
            eachFunc(collection, function(value, key, collection) {
                if (predicate(value, key, collection)) {
                    result = key;
                    return false;
                }
            });
            return result;
        }
        function baseFindIndex(array, predicate, fromIndex, fromRight) {
            var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
            while(fromRight ? index-- : ++index < length){
                if (predicate(array[index], index, array)) return index;
            }
            return -1;
        }
        function baseIndexOf(array, value, fromIndex) {
            return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
        }
        function baseIndexOfWith(array, value, fromIndex, comparator) {
            var index = fromIndex - 1, length = array.length;
            while(++index < length){
                if (comparator(array[index], value)) return index;
            }
            return -1;
        }
        function baseIsNaN(value) {
            return value !== value;
        }
        function baseMean(array, iteratee) {
            var length = array == null ? 0 : array.length;
            return length ? baseSum(array, iteratee) / length : NAN;
        }
        function baseProperty(key) {
            return function(object) {
                return object == null ? undefined : object[key];
            };
        }
        function basePropertyOf(object) {
            return function(key) {
                return object == null ? undefined : object[key];
            };
        }
        function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
            eachFunc(collection, function(value, index, collection) {
                accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
            });
            return accumulator;
        }
        function baseSortBy(array, comparer) {
            var length = array.length;
            array.sort(comparer);
            while(length--)array[length] = array[length].value;
            return array;
        }
        function baseSum(array, iteratee) {
            var result, index = -1, length = array.length;
            while(++index < length){
                var current = iteratee(array[index]);
                if (current !== undefined) result = result === undefined ? current : result + current;
            }
            return result;
        }
        function baseTimes(n, iteratee) {
            var index = -1, result = Array(n);
            while(++index < n)result[index] = iteratee(index);
            return result;
        }
        function baseToPairs(object, props) {
            return arrayMap(props, function(key) {
                return [
                    key,
                    object[key]
                ];
            });
        }
        function baseTrim(string) {
            return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
        }
        function baseUnary(func) {
            return function(value) {
                return func(value);
            };
        }
        function baseValues(object, props) {
            return arrayMap(props, function(key) {
                return object[key];
            });
        }
        function cacheHas(cache, key) {
            return cache.has(key);
        }
        function charsStartIndex(strSymbols, chrSymbols) {
            var index = -1, length = strSymbols.length;
            while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
            return index;
        }
        function charsEndIndex(strSymbols, chrSymbols) {
            var index = strSymbols.length;
            while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
            return index;
        }
        function countHolders(array, placeholder) {
            var length = array.length, result = 0;
            while(length--)if (array[length] === placeholder) ++result;
            return result;
        }
        var deburrLetter = basePropertyOf(deburredLetters);
        var escapeHtmlChar = basePropertyOf(htmlEscapes);
        function escapeStringChar(chr) {
            return '\\' + stringEscapes[chr];
        }
        function getValue(object, key) {
            return object == null ? undefined : object[key];
        }
        function hasUnicode(string) {
            return reHasUnicode.test(string);
        }
        function hasUnicodeWord(string) {
            return reHasUnicodeWord.test(string);
        }
        function iteratorToArray(iterator) {
            var data, result = [];
            while(!(data = iterator.next()).done)result.push(data.value);
            return result;
        }
        function mapToArray(map) {
            var index = -1, result = Array(map.size);
            map.forEach(function(value, key) {
                result[++index] = [
                    key,
                    value
                ];
            });
            return result;
        }
        function overArg(func, transform) {
            return function(arg) {
                return func(transform(arg));
            };
        }
        function replaceHolders(array, placeholder) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value === placeholder || value === PLACEHOLDER) {
                    array[index] = PLACEHOLDER;
                    result[resIndex++] = index;
                }
            }
            return result;
        }
        function setToArray(set) {
            var index = -1, result = Array(set.size);
            set.forEach(function(value) {
                result[++index] = value;
            });
            return result;
        }
        function setToPairs(set) {
            var index = -1, result = Array(set.size);
            set.forEach(function(value) {
                result[++index] = [
                    value,
                    value
                ];
            });
            return result;
        }
        function strictIndexOf(array, value, fromIndex) {
            var index = fromIndex - 1, length = array.length;
            while(++index < length){
                if (array[index] === value) return index;
            }
            return -1;
        }
        function strictLastIndexOf(array, value, fromIndex) {
            var index = fromIndex + 1;
            while(index--){
                if (array[index] === value) return index;
            }
            return index;
        }
        function stringSize(string) {
            return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
        }
        function stringToArray(string) {
            return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
        }
        function trimmedEndIndex(string) {
            var index = string.length;
            while(index-- && reWhitespace.test(string.charAt(index)));
            return index;
        }
        var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
        function unicodeSize(string) {
            var result = reUnicode.lastIndex = 0;
            while(reUnicode.test(string))++result;
            return result;
        }
        function unicodeToArray(string) {
            return string.match(reUnicode) || [];
        }
        function unicodeWords(string) {
            return string.match(reUnicodeWord) || [];
        }
        var runInContext = function runInContext(context) {
            context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
            var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
            var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
            var coreJsData = context['__core-js_shared__'];
            var funcToString = funcProto.toString;
            var hasOwnProperty = objectProto.hasOwnProperty;
            var idCounter = 0;
            var maskSrcKey = function() {
                var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
                return uid ? 'Symbol(src)_1.' + uid : '';
            }();
            var nativeObjectToString = objectProto.toString;
            var objectCtorString = funcToString.call(Object1);
            var oldDash = root._;
            var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
            var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
            var defineProperty = function() {
                try {
                    var func = getNative(Object1, 'defineProperty');
                    func({}, '', {});
                    return func;
                } catch (e) {}
            }();
            var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
            var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
            var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
            var metaMap = WeakMap && new WeakMap;
            var realNames = {};
            var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
            var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
            function lodash(value) {
                if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                    if (value instanceof LodashWrapper) return value;
                    if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
                }
                return new LodashWrapper(value);
            }
            var baseCreate = function() {
                function object() {}
                return function(proto) {
                    if (!isObject(proto)) return {};
                    if (objectCreate) return objectCreate(proto);
                    object.prototype = proto;
                    var result = new object;
                    object.prototype = undefined;
                    return result;
                };
            }();
            function baseLodash() {}
            function LodashWrapper(value, chainAll) {
                this.__wrapped__ = value;
                this.__actions__ = [];
                this.__chain__ = !!chainAll;
                this.__index__ = 0;
                this.__values__ = undefined;
            }
            lodash.templateSettings = {
                'escape': reEscape,
                'evaluate': reEvaluate,
                'interpolate': reInterpolate,
                'variable': '',
                'imports': {
                    '_': lodash
                }
            };
            lodash.prototype = baseLodash.prototype;
            lodash.prototype.constructor = lodash;
            LodashWrapper.prototype = baseCreate(baseLodash.prototype);
            LodashWrapper.prototype.constructor = LodashWrapper;
            function LazyWrapper(value) {
                this.__wrapped__ = value;
                this.__actions__ = [];
                this.__dir__ = 1;
                this.__filtered__ = false;
                this.__iteratees__ = [];
                this.__takeCount__ = MAX_ARRAY_LENGTH;
                this.__views__ = [];
            }
            function lazyClone() {
                var result = new LazyWrapper(this.__wrapped__);
                result.__actions__ = copyArray(this.__actions__);
                result.__dir__ = this.__dir__;
                result.__filtered__ = this.__filtered__;
                result.__iteratees__ = copyArray(this.__iteratees__);
                result.__takeCount__ = this.__takeCount__;
                result.__views__ = copyArray(this.__views__);
                return result;
            }
            function lazyReverse() {
                if (this.__filtered__) {
                    var result = new LazyWrapper(this);
                    result.__dir__ = -1;
                    result.__filtered__ = true;
                } else {
                    result = this.clone();
                    result.__dir__ *= -1;
                }
                return result;
            }
            function lazyValue() {
                var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
                if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
                var result = [];
                outer: while(length-- && resIndex < takeCount){
                    index += dir;
                    var iterIndex = -1, value = array[index];
                    while(++iterIndex < iterLength){
                        var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                        if (type == LAZY_MAP_FLAG) value = computed;
                        else if (!computed) {
                            if (type == LAZY_FILTER_FLAG) continue outer;
                            else break outer;
                        }
                    }
                    result[resIndex++] = value;
                }
                return result;
            }
            LazyWrapper.prototype = baseCreate(baseLodash.prototype);
            LazyWrapper.prototype.constructor = LazyWrapper;
            function Hash(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function hashClear() {
                this.__data__ = nativeCreate ? nativeCreate(null) : {};
                this.size = 0;
            }
            function hashDelete(key) {
                var result = this.has(key) && delete this.__data__[key];
                this.size -= result ? 1 : 0;
                return result;
            }
            function hashGet(key) {
                var data = this.__data__;
                if (nativeCreate) {
                    var result = data[key];
                    return result === HASH_UNDEFINED ? undefined : result;
                }
                return hasOwnProperty.call(data, key) ? data[key] : undefined;
            }
            function hashHas(key) {
                var data = this.__data__;
                return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
            }
            function hashSet(key, value) {
                var data = this.__data__;
                this.size += this.has(key) ? 0 : 1;
                data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
                return this;
            }
            Hash.prototype.clear = hashClear;
            Hash.prototype['delete'] = hashDelete;
            Hash.prototype.get = hashGet;
            Hash.prototype.has = hashHas;
            Hash.prototype.set = hashSet;
            function ListCache(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function listCacheClear() {
                this.__data__ = [];
                this.size = 0;
            }
            function listCacheDelete(key) {
                var data = this.__data__, index = assocIndexOf(data, key);
                if (index < 0) return false;
                var lastIndex = data.length - 1;
                if (index == lastIndex) data.pop();
                else splice.call(data, index, 1);
                --this.size;
                return true;
            }
            function listCacheGet(key) {
                var data = this.__data__, index = assocIndexOf(data, key);
                return index < 0 ? undefined : data[index][1];
            }
            function listCacheHas(key) {
                return assocIndexOf(this.__data__, key) > -1;
            }
            function listCacheSet(key, value) {
                var data = this.__data__, index = assocIndexOf(data, key);
                if (index < 0) {
                    ++this.size;
                    data.push([
                        key,
                        value
                    ]);
                } else data[index][1] = value;
                return this;
            }
            ListCache.prototype.clear = listCacheClear;
            ListCache.prototype['delete'] = listCacheDelete;
            ListCache.prototype.get = listCacheGet;
            ListCache.prototype.has = listCacheHas;
            ListCache.prototype.set = listCacheSet;
            function MapCache(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function mapCacheClear() {
                this.size = 0;
                this.__data__ = {
                    'hash': new Hash,
                    'map': new (Map || ListCache),
                    'string': new Hash
                };
            }
            function mapCacheDelete(key) {
                var result = getMapData(this, key)['delete'](key);
                this.size -= result ? 1 : 0;
                return result;
            }
            function mapCacheGet(key) {
                return getMapData(this, key).get(key);
            }
            function mapCacheHas(key) {
                return getMapData(this, key).has(key);
            }
            function mapCacheSet(key, value) {
                var data = getMapData(this, key), size = data.size;
                data.set(key, value);
                this.size += data.size == size ? 0 : 1;
                return this;
            }
            MapCache.prototype.clear = mapCacheClear;
            MapCache.prototype['delete'] = mapCacheDelete;
            MapCache.prototype.get = mapCacheGet;
            MapCache.prototype.has = mapCacheHas;
            MapCache.prototype.set = mapCacheSet;
            function SetCache(values) {
                var index = -1, length = values == null ? 0 : values.length;
                this.__data__ = new MapCache;
                while(++index < length)this.add(values[index]);
            }
            function setCacheAdd(value) {
                this.__data__.set(value, HASH_UNDEFINED);
                return this;
            }
            function setCacheHas(value) {
                return this.__data__.has(value);
            }
            SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
            SetCache.prototype.has = setCacheHas;
            function Stack(entries) {
                var data = this.__data__ = new ListCache(entries);
                this.size = data.size;
            }
            function stackClear() {
                this.__data__ = new ListCache;
                this.size = 0;
            }
            function stackDelete(key) {
                var data = this.__data__, result = data['delete'](key);
                this.size = data.size;
                return result;
            }
            function stackGet(key) {
                return this.__data__.get(key);
            }
            function stackHas(key) {
                return this.__data__.has(key);
            }
            function stackSet(key, value) {
                var data = this.__data__;
                if (data instanceof ListCache) {
                    var pairs = data.__data__;
                    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                        pairs.push([
                            key,
                            value
                        ]);
                        this.size = ++data.size;
                        return this;
                    }
                    data = this.__data__ = new MapCache(pairs);
                }
                data.set(key, value);
                this.size = data.size;
                return this;
            }
            Stack.prototype.clear = stackClear;
            Stack.prototype['delete'] = stackDelete;
            Stack.prototype.get = stackGet;
            Stack.prototype.has = stackHas;
            Stack.prototype.set = stackSet;
            function arrayLikeKeys(value, inherited) {
                var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
                for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || isIndex(key, length)))) result.push(key);
                return result;
            }
            function arraySample(array) {
                var length = array.length;
                return length ? array[baseRandom(0, length - 1)] : undefined;
            }
            function arraySampleSize(array, n) {
                return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
            }
            function arrayShuffle(array) {
                return shuffleSelf(copyArray(array));
            }
            function assignMergeValue(object, key, value) {
                if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
            }
            function assignValue(object, key, value) {
                var objValue = object[key];
                if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
            }
            function assocIndexOf(array, key) {
                var length = array.length;
                while(length--){
                    if (eq(array[length][0], key)) return length;
                }
                return -1;
            }
            function baseAggregator(collection, setter, iteratee, accumulator) {
                baseEach(collection, function(value, key, collection) {
                    setter(accumulator, value, iteratee(value), collection);
                });
                return accumulator;
            }
            function baseAssign(object, source) {
                return object && copyObject(source, keys(source), object);
            }
            function baseAssignIn(object, source) {
                return object && copyObject(source, keysIn(source), object);
            }
            function baseAssignValue(object, key, value) {
                if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                    'configurable': true,
                    'enumerable': true,
                    'value': value,
                    'writable': true
                });
                else object[key] = value;
            }
            function baseAt(object, paths) {
                var index = -1, length = paths.length, result = Array1(length), skip = object == null;
                while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
                return result;
            }
            function baseClamp(number, lower, upper) {
                if (number === number) {
                    if (upper !== undefined) number = number <= upper ? number : upper;
                    if (lower !== undefined) number = number >= lower ? number : lower;
                }
                return number;
            }
            function baseClone(value, bitmask, customizer, key, object, stack) {
                var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
                if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
                if (result !== undefined) return result;
                if (!isObject(value)) return value;
                var isArr = isArray(value);
                if (isArr) {
                    result = initCloneArray(value);
                    if (!isDeep) return copyArray(value, result);
                } else {
                    var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                    if (isBuffer(value)) return cloneBuffer(value, isDeep);
                    if (tag == objectTag || tag == argsTag || isFunc && !object) {
                        result = isFlat || isFunc ? {} : initCloneObject(value);
                        if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                    } else {
                        if (!cloneableTags[tag]) return object ? value : {};
                        result = initCloneByTag(value, tag, isDeep);
                    }
                }
                stack || (stack = new Stack);
                var stacked = stack.get(value);
                if (stacked) return stacked;
                stack.set(value, result);
                if (isSet(value)) value.forEach(function(subValue) {
                    result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
                });
                else if (isMap(value)) value.forEach(function(subValue, key) {
                    result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
                });
                var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
                var props = isArr ? undefined : keysFunc(value);
                arrayEach(props || value, function(subValue, key) {
                    if (props) {
                        key = subValue;
                        subValue = value[key];
                    }
                    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
                });
                return result;
            }
            function baseConforms(source) {
                var props = keys(source);
                return function(object) {
                    return baseConformsTo(object, source, props);
                };
            }
            function baseConformsTo(object, source, props) {
                var length = props.length;
                if (object == null) return !length;
                object = Object1(object);
                while(length--){
                    var key = props[length], predicate = source[key], value = object[key];
                    if (value === undefined && !(key in object) || !predicate(value)) return false;
                }
                return true;
            }
            function baseDelay(func, wait, args) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return setTimeout(function() {
                    func.apply(undefined, args);
                }, wait);
            }
            function baseDifference(array, values, iteratee, comparator) {
                var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
                if (!length) return result;
                if (iteratee) values = arrayMap(values, baseUnary(iteratee));
                if (comparator) {
                    includes = arrayIncludesWith;
                    isCommon = false;
                } else if (values.length >= LARGE_ARRAY_SIZE) {
                    includes = cacheHas;
                    isCommon = false;
                    values = new SetCache(values);
                }
                outer: while(++index < length){
                    var value = array[index], computed = iteratee == null ? value : iteratee(value);
                    value = comparator || value !== 0 ? value : 0;
                    if (isCommon && computed === computed) {
                        var valuesIndex = valuesLength;
                        while(valuesIndex--){
                            if (values[valuesIndex] === computed) continue outer;
                        }
                        result.push(value);
                    } else if (!includes(values, computed, comparator)) result.push(value);
                }
                return result;
            }
            var baseEach = createBaseEach(baseForOwn);
            var baseEachRight = createBaseEach(baseForOwnRight, true);
            function baseEvery(collection, predicate) {
                var result = true;
                baseEach(collection, function(value, index, collection) {
                    result = !!predicate(value, index, collection);
                    return result;
                });
                return result;
            }
            function baseExtremum(array, iteratee, comparator) {
                var index = -1, length = array.length;
                while(++index < length){
                    var value = array[index], current = iteratee(value);
                    if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
                }
                return result;
            }
            function baseFill(array, value, start, end) {
                var length = array.length;
                start = toInteger(start);
                if (start < 0) start = -start > length ? 0 : length + start;
                end = end === undefined || end > length ? length : toInteger(end);
                if (end < 0) end += length;
                end = start > end ? 0 : toLength(end);
                while(start < end)array[start++] = value;
                return array;
            }
            function baseFilter(collection, predicate) {
                var result = [];
                baseEach(collection, function(value, index, collection) {
                    if (predicate(value, index, collection)) result.push(value);
                });
                return result;
            }
            function baseFlatten(array, depth, predicate, isStrict, result) {
                var index = -1, length = array.length;
                predicate || (predicate = isFlattenable);
                result || (result = []);
                while(++index < length){
                    var value = array[index];
                    if (depth > 0 && predicate(value)) {
                        if (depth > 1) baseFlatten(value, depth - 1, predicate, isStrict, result);
                        else arrayPush(result, value);
                    } else if (!isStrict) result[result.length] = value;
                }
                return result;
            }
            var baseFor = createBaseFor();
            var baseForRight = createBaseFor(true);
            function baseForOwn(object, iteratee) {
                return object && baseFor(object, iteratee, keys);
            }
            function baseForOwnRight(object, iteratee) {
                return object && baseForRight(object, iteratee, keys);
            }
            function baseFunctions(object, props) {
                return arrayFilter(props, function(key) {
                    return isFunction(object[key]);
                });
            }
            function baseGet(object, path) {
                path = castPath(path, object);
                var index = 0, length = path.length;
                while(object != null && index < length)object = object[toKey(path[index++])];
                return index && index == length ? object : undefined;
            }
            function baseGetAllKeys(object, keysFunc, symbolsFunc) {
                var result = keysFunc(object);
                return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
            }
            function baseGetTag(value) {
                if (value == null) return value === undefined ? undefinedTag : nullTag;
                return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
            }
            function baseGt(value, other) {
                return value > other;
            }
            function baseHas(object, key) {
                return object != null && hasOwnProperty.call(object, key);
            }
            function baseHasIn(object, key) {
                return object != null && key in Object1(object);
            }
            function baseInRange(number, start, end) {
                return number >= nativeMin(start, end) && number < nativeMax(start, end);
            }
            function baseIntersection(arrays, iteratee, comparator) {
                var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
                while(othIndex--){
                    var array = arrays[othIndex];
                    if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                    maxLength = nativeMin(array.length, maxLength);
                    caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
                }
                array = arrays[0];
                var index = -1, seen = caches[0];
                outer: while(++index < length && result.length < maxLength){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    value = comparator || value !== 0 ? value : 0;
                    if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                        othIndex = othLength;
                        while(--othIndex){
                            var cache = caches[othIndex];
                            if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                        }
                        if (seen) seen.push(computed);
                        result.push(value);
                    }
                }
                return result;
            }
            function baseInverter(object, setter, iteratee, accumulator) {
                baseForOwn(object, function(value, key, object) {
                    setter(accumulator, iteratee(value), key, object);
                });
                return accumulator;
            }
            function baseInvoke(object, path, args) {
                path = castPath(path, object);
                object = parent(object, path);
                var func = object == null ? object : object[toKey(last(path))];
                return func == null ? undefined : apply(func, object, args);
            }
            function baseIsArguments(value) {
                return isObjectLike(value) && baseGetTag(value) == argsTag;
            }
            function baseIsArrayBuffer(value) {
                return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
            }
            function baseIsDate(value) {
                return isObjectLike(value) && baseGetTag(value) == dateTag;
            }
            function baseIsEqual(value, other, bitmask, customizer, stack) {
                if (value === other) return true;
                if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
                return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
            }
            function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
                var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
                objTag = objTag == argsTag ? objectTag : objTag;
                othTag = othTag == argsTag ? objectTag : othTag;
                var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
                if (isSameTag && isBuffer(object)) {
                    if (!isBuffer(other)) return false;
                    objIsArr = true;
                    objIsObj = false;
                }
                if (isSameTag && !objIsObj) {
                    stack || (stack = new Stack);
                    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
                }
                if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                    if (objIsWrapped || othIsWrapped) {
                        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                        stack || (stack = new Stack);
                        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                    }
                }
                if (!isSameTag) return false;
                stack || (stack = new Stack);
                return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
            }
            function baseIsMap(value) {
                return isObjectLike(value) && getTag(value) == mapTag;
            }
            function baseIsMatch(object, source, matchData, customizer) {
                var index = matchData.length, length = index, noCustomizer = !customizer;
                if (object == null) return !length;
                object = Object1(object);
                while(index--){
                    var data = matchData[index];
                    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
                }
                while(++index < length){
                    data = matchData[index];
                    var key = data[0], objValue = object[key], srcValue = data[1];
                    if (noCustomizer && data[2]) {
                        if (objValue === undefined && !(key in object)) return false;
                    } else {
                        var stack = new Stack;
                        if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                        if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                    }
                }
                return true;
            }
            function baseIsNative(value) {
                if (!isObject(value) || isMasked(value)) return false;
                var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
                return pattern.test(toSource(value));
            }
            function baseIsRegExp(value) {
                return isObjectLike(value) && baseGetTag(value) == regexpTag;
            }
            function baseIsSet(value) {
                return isObjectLike(value) && getTag(value) == setTag;
            }
            function baseIsTypedArray(value) {
                return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
            }
            function baseIteratee(value) {
                if (typeof value == 'function') return value;
                if (value == null) return identity;
                if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
                return property(value);
            }
            function baseKeys(object) {
                if (!isPrototype(object)) return nativeKeys(object);
                var result = [];
                for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
                return result;
            }
            function baseKeysIn(object) {
                if (!isObject(object)) return nativeKeysIn(object);
                var isProto = isPrototype(object), result = [];
                for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
                return result;
            }
            function baseLt(value, other) {
                return value < other;
            }
            function baseMap(collection, iteratee) {
                var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
                baseEach(collection, function(value, key, collection) {
                    result[++index] = iteratee(value, key, collection);
                });
                return result;
            }
            function baseMatches(source) {
                var matchData = getMatchData(source);
                if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
                return function(object) {
                    return object === source || baseIsMatch(object, source, matchData);
                };
            }
            function baseMatchesProperty(path, srcValue) {
                if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
                return function(object) {
                    var objValue = get(object, path);
                    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
                };
            }
            function baseMerge(object, source, srcIndex, customizer, stack) {
                if (object === source) return;
                baseFor(source, function(srcValue, key) {
                    stack || (stack = new Stack);
                    if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                    else {
                        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                        if (newValue === undefined) newValue = srcValue;
                        assignMergeValue(object, key, newValue);
                    }
                }, keysIn);
            }
            function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
                var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
                if (stacked) {
                    assignMergeValue(object, key, stacked);
                    return;
                }
                var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
                var isCommon = newValue === undefined;
                if (isCommon) {
                    var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                    newValue = srcValue;
                    if (isArr || isBuff || isTyped) {
                        if (isArray(objValue)) newValue = objValue;
                        else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                        else if (isBuff) {
                            isCommon = false;
                            newValue = cloneBuffer(srcValue, true);
                        } else if (isTyped) {
                            isCommon = false;
                            newValue = cloneTypedArray(srcValue, true);
                        } else newValue = [];
                    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                        newValue = objValue;
                        if (isArguments(objValue)) newValue = toPlainObject(objValue);
                        else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                    } else isCommon = false;
                }
                if (isCommon) {
                    stack.set(srcValue, newValue);
                    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                    stack['delete'](srcValue);
                }
                assignMergeValue(object, key, newValue);
            }
            function baseNth(array, n) {
                var length = array.length;
                if (!length) return;
                n += n < 0 ? length : 0;
                return isIndex(n, length) ? array[n] : undefined;
            }
            function baseOrderBy(collection, iteratees, orders) {
                if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                    if (isArray(iteratee)) return function(value) {
                        return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                    };
                    return iteratee;
                });
                else iteratees = [
                    identity
                ];
                var index = -1;
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                var result = baseMap(collection, function(value, key, collection) {
                    var criteria = arrayMap(iteratees, function(iteratee) {
                        return iteratee(value);
                    });
                    return {
                        'criteria': criteria,
                        'index': ++index,
                        'value': value
                    };
                });
                return baseSortBy(result, function(object, other) {
                    return compareMultiple(object, other, orders);
                });
            }
            function basePick(object, paths) {
                return basePickBy(object, paths, function(value, path) {
                    return hasIn(object, path);
                });
            }
            function basePickBy(object, paths, predicate) {
                var index = -1, length = paths.length, result = {};
                while(++index < length){
                    var path = paths[index], value = baseGet(object, path);
                    if (predicate(value, path)) baseSet(result, castPath(path, object), value);
                }
                return result;
            }
            function basePropertyDeep(path) {
                return function(object) {
                    return baseGet(object, path);
                };
            }
            function basePullAll(array, values, iteratee, comparator) {
                var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
                if (array === values) values = copyArray(values);
                if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
                while(++index < length){
                    var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                    while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                        if (seen !== array) splice.call(seen, fromIndex, 1);
                        splice.call(array, fromIndex, 1);
                    }
                }
                return array;
            }
            function basePullAt(array, indexes) {
                var length = array ? indexes.length : 0, lastIndex = length - 1;
                while(length--){
                    var index = indexes[length];
                    if (length == lastIndex || index !== previous) {
                        var previous = index;
                        if (isIndex(index)) splice.call(array, index, 1);
                        else baseUnset(array, index);
                    }
                }
                return array;
            }
            function baseRandom(lower, upper) {
                return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
            }
            function baseRange(start, end, step, fromRight) {
                var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
                while(length--){
                    result[fromRight ? length : ++index] = start;
                    start += step;
                }
                return result;
            }
            function baseRepeat(string, n) {
                var result = '';
                if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
                do {
                    if (n % 2) result += string;
                    n = nativeFloor(n / 2);
                    if (n) string += string;
                }while (n)
                return result;
            }
            function baseRest(func, start) {
                return setToString(overRest(func, start, identity), func + '');
            }
            function baseSample(collection) {
                return arraySample(values(collection));
            }
            function baseSampleSize(collection, n) {
                var array = values(collection);
                return shuffleSelf(array, baseClamp(n, 0, array.length));
            }
            function baseSet(object, path, value, customizer) {
                if (!isObject(object)) return object;
                path = castPath(path, object);
                var index = -1, length = path.length, lastIndex = length - 1, nested = object;
                while(nested != null && ++index < length){
                    var key = toKey(path[index]), newValue = value;
                    if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                    if (index != lastIndex) {
                        var objValue = nested[key];
                        newValue = customizer ? customizer(objValue, key, nested) : undefined;
                        if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                    }
                    assignValue(nested, key, newValue);
                    nested = nested[key];
                }
                return object;
            }
            var baseSetData = !metaMap ? identity : function(func, data) {
                metaMap.set(func, data);
                return func;
            };
            var baseSetToString = !defineProperty ? identity : function(func, string) {
                return defineProperty(func, 'toString', {
                    'configurable': true,
                    'enumerable': false,
                    'value': constant(string),
                    'writable': true
                });
            };
            function baseShuffle(collection) {
                return shuffleSelf(values(collection));
            }
            function baseSlice(array, start, end) {
                var index = -1, length = array.length;
                if (start < 0) start = -start > length ? 0 : length + start;
                end = end > length ? length : end;
                if (end < 0) end += length;
                length = start > end ? 0 : end - start >>> 0;
                start >>>= 0;
                var result = Array1(length);
                while(++index < length)result[index] = array[index + start];
                return result;
            }
            function baseSome(collection, predicate) {
                var result;
                baseEach(collection, function(value, index, collection) {
                    result = predicate(value, index, collection);
                    return !result;
                });
                return !!result;
            }
            function baseSortedIndex(array, value, retHighest) {
                var low = 0, high = array == null ? low : array.length;
                if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                    while(low < high){
                        var mid = low + high >>> 1, computed = array[mid];
                        if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                        else high = mid;
                    }
                    return high;
                }
                return baseSortedIndexBy(array, value, identity, retHighest);
            }
            function baseSortedIndexBy(array, value, iteratee, retHighest) {
                var low = 0, high = array == null ? 0 : array.length;
                if (high === 0) return 0;
                value = iteratee(value);
                var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
                while(low < high){
                    var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                    if (valIsNaN) var setLow = retHighest || othIsReflexive;
                    else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                    else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                    else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                    else if (othIsNull || othIsSymbol) setLow = false;
                    else setLow = retHighest ? computed <= value : computed < value;
                    if (setLow) low = mid + 1;
                    else high = mid;
                }
                return nativeMin(high, MAX_ARRAY_INDEX);
            }
            function baseSortedUniq(array, iteratee) {
                var index = -1, length = array.length, resIndex = 0, result = [];
                while(++index < length){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    if (!index || !eq(computed, seen)) {
                        var seen = computed;
                        result[resIndex++] = value === 0 ? 0 : value;
                    }
                }
                return result;
            }
            function baseToNumber(value) {
                if (typeof value == 'number') return value;
                if (isSymbol(value)) return NAN;
                return +value;
            }
            function baseToString(value) {
                if (typeof value == 'string') return value;
                if (isArray(value)) return arrayMap(value, baseToString) + '';
                if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
                var result = value + '';
                return result == '0' && 1 / value == -INFINITY ? '-0' : result;
            }
            function baseUniq(array, iteratee, comparator) {
                var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
                if (comparator) {
                    isCommon = false;
                    includes = arrayIncludesWith;
                } else if (length >= LARGE_ARRAY_SIZE) {
                    var set = iteratee ? null : createSet(array);
                    if (set) return setToArray(set);
                    isCommon = false;
                    includes = cacheHas;
                    seen = new SetCache;
                } else seen = iteratee ? [] : result;
                outer: while(++index < length){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    value = comparator || value !== 0 ? value : 0;
                    if (isCommon && computed === computed) {
                        var seenIndex = seen.length;
                        while(seenIndex--){
                            if (seen[seenIndex] === computed) continue outer;
                        }
                        if (iteratee) seen.push(computed);
                        result.push(value);
                    } else if (!includes(seen, computed, comparator)) {
                        if (seen !== result) seen.push(computed);
                        result.push(value);
                    }
                }
                return result;
            }
            function baseUnset(object, path) {
                path = castPath(path, object);
                object = parent(object, path);
                return object == null || delete object[toKey(last(path))];
            }
            function baseUpdate(object, path, updater, customizer) {
                return baseSet(object, path, updater(baseGet(object, path)), customizer);
            }
            function baseWhile(array, predicate, isDrop, fromRight) {
                var length = array.length, index = fromRight ? length : -1;
                while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
                return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
            }
            function baseWrapperValue(value, actions) {
                var result = value;
                if (result instanceof LazyWrapper) result = result.value();
                return arrayReduce(actions, function(result, action) {
                    return action.func.apply(action.thisArg, arrayPush([
                        result
                    ], action.args));
                }, result);
            }
            function baseXor(arrays, iteratee, comparator) {
                var length = arrays.length;
                if (length < 2) return length ? baseUniq(arrays[0]) : [];
                var index = -1, result = Array1(length);
                while(++index < length){
                    var array = arrays[index], othIndex = -1;
                    while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
                }
                return baseUniq(baseFlatten(result, 1), iteratee, comparator);
            }
            function baseZipObject(props, values, assignFunc) {
                var index = -1, length = props.length, valsLength = values.length, result = {};
                while(++index < length){
                    var value = index < valsLength ? values[index] : undefined;
                    assignFunc(result, props[index], value);
                }
                return result;
            }
            function castArrayLikeObject(value) {
                return isArrayLikeObject(value) ? value : [];
            }
            function castFunction(value) {
                return typeof value == 'function' ? value : identity;
            }
            function castPath(value, object) {
                if (isArray(value)) return value;
                return isKey(value, object) ? [
                    value
                ] : stringToPath(toString(value));
            }
            var castRest = baseRest;
            function castSlice(array, start, end) {
                var length = array.length;
                end = end === undefined ? length : end;
                return !start && end >= length ? array : baseSlice(array, start, end);
            }
            var clearTimeout = ctxClearTimeout || function(id) {
                return root.clearTimeout(id);
            };
            function cloneBuffer(buffer, isDeep) {
                if (isDeep) return buffer.slice();
                var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
                buffer.copy(result);
                return result;
            }
            function cloneArrayBuffer(arrayBuffer) {
                var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
                new Uint8Array(result).set(new Uint8Array(arrayBuffer));
                return result;
            }
            function cloneDataView(dataView, isDeep) {
                var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
                return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
            }
            function cloneRegExp(regexp) {
                var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
                result.lastIndex = regexp.lastIndex;
                return result;
            }
            function cloneSymbol(symbol) {
                return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
            }
            function cloneTypedArray(typedArray, isDeep) {
                var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
                return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
            }
            function compareAscending(value, other) {
                if (value !== other) {
                    var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                    var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
                }
                return 0;
            }
            function compareMultiple(object, other, orders) {
                var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
                while(++index < length){
                    var result = compareAscending(objCriteria[index], othCriteria[index]);
                    if (result) {
                        if (index >= ordersLength) return result;
                        var order = orders[index];
                        return result * (order == 'desc' ? -1 : 1);
                    }
                }
                return object.index - other.index;
            }
            function composeArgs(args, partials, holders, isCurried) {
                var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
                while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
                while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
                while(rangeLength--)result[leftIndex++] = args[argsIndex++];
                return result;
            }
            function composeArgsRight(args, partials, holders, isCurried) {
                var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
                while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
                var offset = argsIndex;
                while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
                while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
                return result;
            }
            function copyArray(source, array) {
                var index = -1, length = source.length;
                array || (array = Array1(length));
                while(++index < length)array[index] = source[index];
                return array;
            }
            function copyObject(source, props, object, customizer) {
                var isNew = !object;
                object || (object = {});
                var index = -1, length = props.length;
                while(++index < length){
                    var key = props[index];
                    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                    if (newValue === undefined) newValue = source[key];
                    if (isNew) baseAssignValue(object, key, newValue);
                    else assignValue(object, key, newValue);
                }
                return object;
            }
            function copySymbols(source, object) {
                return copyObject(source, getSymbols(source), object);
            }
            function copySymbolsIn(source, object) {
                return copyObject(source, getSymbolsIn(source), object);
            }
            function createAggregator(setter, initializer) {
                return function(collection, iteratee) {
                    var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                    return func(collection, setter, getIteratee(iteratee, 2), accumulator);
                };
            }
            function createAssigner(assigner) {
                return baseRest(function(object, sources) {
                    var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                        customizer = length < 3 ? undefined : customizer;
                        length = 1;
                    }
                    object = Object1(object);
                    while(++index < length){
                        var source = sources[index];
                        if (source) assigner(object, source, index, customizer);
                    }
                    return object;
                });
            }
            function createBaseEach(eachFunc, fromRight) {
                return function(collection, iteratee) {
                    if (collection == null) return collection;
                    if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                    var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                    while(fromRight ? index-- : ++index < length){
                        if (iteratee(iterable[index], index, iterable) === false) break;
                    }
                    return collection;
                };
            }
            function createBaseFor(fromRight) {
                return function(object, iteratee, keysFunc) {
                    var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                    while(length--){
                        var key = props[fromRight ? length : ++index];
                        if (iteratee(iterable[key], key, iterable) === false) break;
                    }
                    return object;
                };
            }
            function createBind(func, bitmask, thisArg) {
                var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
                function wrapper() {
                    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    return fn.apply(isBind ? thisArg : this, arguments);
                }
                return wrapper;
            }
            function createCaseFirst(methodName) {
                return function(string) {
                    string = toString(string);
                    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                    return chr[methodName]() + trailing;
                };
            }
            function createCompounder(callback) {
                return function(string) {
                    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
                };
            }
            function createCtor(Ctor) {
                return function() {
                    var args = arguments;
                    switch(args.length){
                        case 0:
                            return new Ctor;
                        case 1:
                            return new Ctor(args[0]);
                        case 2:
                            return new Ctor(args[0], args[1]);
                        case 3:
                            return new Ctor(args[0], args[1], args[2]);
                        case 4:
                            return new Ctor(args[0], args[1], args[2], args[3]);
                        case 5:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                        case 6:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                        case 7:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                    }
                    var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                    return isObject(result) ? result : thisBinding;
                };
            }
            function createCurry(func, bitmask, arity) {
                var Ctor = createCtor(func);
                function wrapper() {
                    var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                    while(index--)args[index] = arguments[index];
                    var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                    length -= holders.length;
                    if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    return apply(fn, this, args);
                }
                return wrapper;
            }
            function createFind(findIndexFunc) {
                return function(collection, predicate, fromIndex) {
                    var iterable = Object1(collection);
                    if (!isArrayLike(collection)) {
                        var iteratee = getIteratee(predicate, 3);
                        collection = keys(collection);
                        predicate = function(key) {
                            return iteratee(iterable[key], key, iterable);
                        };
                    }
                    var index = findIndexFunc(collection, predicate, fromIndex);
                    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
                };
            }
            function createFlow(fromRight) {
                return flatRest(function(funcs) {
                    var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                    if (fromRight) funcs.reverse();
                    while(index--){
                        var func = funcs[index];
                        if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                        if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                    }
                    index = wrapper ? index : length;
                    while(++index < length){
                        func = funcs[index];
                        var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                        if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                        else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                    }
                    return function() {
                        var args = arguments, value = args[0];
                        if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                        var index = 0, result = length ? funcs[index].apply(this, args) : value;
                        while(++index < length)result = funcs[index].call(this, result);
                        return result;
                    };
                });
            }
            function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
                var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
                function wrapper() {
                    var length = arguments.length, args = Array1(length), index = length;
                    while(index--)args[index] = arguments[index];
                    if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                    if (partials) args = composeArgs(args, partials, holders, isCurried);
                    if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                    length -= holdersCount;
                    if (isCurried && length < arity) {
                        var newHolders = replaceHolders(args, placeholder);
                        return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                    }
                    var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                    length = args.length;
                    if (argPos) args = reorder(args, argPos);
                    else if (isFlip && length > 1) args.reverse();
                    if (isAry && ary < length) args.length = ary;
                    if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                    return fn.apply(thisBinding, args);
                }
                return wrapper;
            }
            function createInverter(setter, toIteratee) {
                return function(object, iteratee) {
                    return baseInverter(object, setter, toIteratee(iteratee), {});
                };
            }
            function createMathOperation(operator, defaultValue) {
                return function(value, other) {
                    var result;
                    if (value === undefined && other === undefined) return defaultValue;
                    if (value !== undefined) result = value;
                    if (other !== undefined) {
                        if (result === undefined) return other;
                        if (typeof value == 'string' || typeof other == 'string') {
                            value = baseToString(value);
                            other = baseToString(other);
                        } else {
                            value = baseToNumber(value);
                            other = baseToNumber(other);
                        }
                        result = operator(value, other);
                    }
                    return result;
                };
            }
            function createOver(arrayFunc) {
                return flatRest(function(iteratees) {
                    iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                    return baseRest(function(args) {
                        var thisArg = this;
                        return arrayFunc(iteratees, function(iteratee) {
                            return apply(iteratee, thisArg, args);
                        });
                    });
                });
            }
            function createPadding(length, chars) {
                chars = chars === undefined ? ' ' : baseToString(chars);
                var charsLength = chars.length;
                if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
                var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
                return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
            }
            function createPartial(func, bitmask, thisArg, partials) {
                var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
                function wrapper() {
                    var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                    while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                    return apply(fn, isBind ? thisArg : this, args);
                }
                return wrapper;
            }
            function createRange(fromRight) {
                return function(start, end, step) {
                    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                    start = toFinite(start);
                    if (end === undefined) {
                        end = start;
                        start = 0;
                    } else end = toFinite(end);
                    step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                    return baseRange(start, end, step, fromRight);
                };
            }
            function createRelationalOperation(operator) {
                return function(value, other) {
                    if (!(typeof value == 'string' && typeof other == 'string')) {
                        value = toNumber(value);
                        other = toNumber(other);
                    }
                    return operator(value, other);
                };
            }
            function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
                var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
                bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
                bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
                if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
                var newData = [
                    func,
                    bitmask,
                    thisArg,
                    newPartials,
                    newHolders,
                    newPartialsRight,
                    newHoldersRight,
                    argPos,
                    ary,
                    arity
                ];
                var result = wrapFunc.apply(undefined, newData);
                if (isLaziable(func)) setData(result, newData);
                result.placeholder = placeholder;
                return setWrapToString(result, func, bitmask);
            }
            function createRound(methodName) {
                var func = Math[methodName];
                return function(number, precision) {
                    number = toNumber(number);
                    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                    if (precision && nativeIsFinite(number)) {
                        var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                        pair = (toString(value) + 'e').split('e');
                        return +(pair[0] + 'e' + (+pair[1] - precision));
                    }
                    return func(number);
                };
            }
            var createSet = !(Set && 1 / setToArray(new Set([
                ,
                -0
            ]))[1] == INFINITY) ? noop : function(values) {
                return new Set(values);
            };
            function createToPairs(keysFunc) {
                return function(object) {
                    var tag = getTag(object);
                    if (tag == mapTag) return mapToArray(object);
                    if (tag == setTag) return setToPairs(object);
                    return baseToPairs(object, keysFunc(object));
                };
            }
            function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
                var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
                if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                var length = partials ? partials.length : 0;
                if (!length) {
                    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                    partials = holders = undefined;
                }
                ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
                arity = arity === undefined ? arity : toInteger(arity);
                length -= holders ? holders.length : 0;
                if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                    var partialsRight = partials, holdersRight = holders;
                    partials = holders = undefined;
                }
                var data = isBindKey ? undefined : getData(func);
                var newData = [
                    func,
                    bitmask,
                    thisArg,
                    partials,
                    holders,
                    partialsRight,
                    holdersRight,
                    argPos,
                    ary,
                    arity
                ];
                if (data) mergeData(newData, data);
                func = newData[0];
                bitmask = newData[1];
                thisArg = newData[2];
                partials = newData[3];
                holders = newData[4];
                arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
                if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
                if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
                else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
                else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
                else result = createHybrid.apply(undefined, newData);
                var setter = data ? baseSetData : setData;
                return setWrapToString(setter(result, newData), func, bitmask);
            }
            function customDefaultsAssignIn(objValue, srcValue, key, object) {
                if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
                return objValue;
            }
            function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
                if (isObject(objValue) && isObject(srcValue)) {
                    stack.set(srcValue, objValue);
                    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                    stack['delete'](srcValue);
                }
                return objValue;
            }
            function customOmitClone(value) {
                return isPlainObject(value) ? undefined : value;
            }
            function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
                if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
                var arrStacked = stack.get(array);
                var othStacked = stack.get(other);
                if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
                var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
                stack.set(array, other);
                stack.set(other, array);
                while(++index < arrLength){
                    var arrValue = array[index], othValue = other[index];
                    if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                    if (compared !== undefined) {
                        if (compared) continue;
                        result = false;
                        break;
                    }
                    if (seen) {
                        if (!arraySome(other, function(othValue, othIndex) {
                            if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                        })) {
                            result = false;
                            break;
                        }
                    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                        result = false;
                        break;
                    }
                }
                stack['delete'](array);
                stack['delete'](other);
                return result;
            }
            function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
                switch(tag){
                    case dataViewTag:
                        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                        object = object.buffer;
                        other = other.buffer;
                    case arrayBufferTag:
                        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                        return true;
                    case boolTag:
                    case dateTag:
                    case numberTag:
                        return eq(+object, +other);
                    case errorTag:
                        return object.name == other.name && object.message == other.message;
                    case regexpTag:
                    case stringTag:
                        return object == other + '';
                    case mapTag:
                        var convert = mapToArray;
                    case setTag:
                        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                        convert || (convert = setToArray);
                        if (object.size != other.size && !isPartial) return false;
                        var stacked = stack.get(object);
                        if (stacked) return stacked == other;
                        bitmask |= COMPARE_UNORDERED_FLAG;
                        stack.set(object, other);
                        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                        stack['delete'](object);
                        return result;
                    case symbolTag:
                        if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
                }
                return false;
            }
            function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
                if (objLength != othLength && !isPartial) return false;
                var index = objLength;
                while(index--){
                    var key = objProps[index];
                    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
                }
                var objStacked = stack.get(object);
                var othStacked = stack.get(other);
                if (objStacked && othStacked) return objStacked == other && othStacked == object;
                var result = true;
                stack.set(object, other);
                stack.set(other, object);
                var skipCtor = isPartial;
                while(++index < objLength){
                    key = objProps[index];
                    var objValue = object[key], othValue = other[key];
                    if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                        result = false;
                        break;
                    }
                    skipCtor || (skipCtor = key == 'constructor');
                }
                if (result && !skipCtor) {
                    var objCtor = object.constructor, othCtor = other.constructor;
                    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
                }
                stack['delete'](object);
                stack['delete'](other);
                return result;
            }
            function flatRest(func) {
                return setToString(overRest(func, undefined, flatten), func + '');
            }
            function getAllKeys(object) {
                return baseGetAllKeys(object, keys, getSymbols);
            }
            function getAllKeysIn(object) {
                return baseGetAllKeys(object, keysIn, getSymbolsIn);
            }
            var getData = !metaMap ? noop : function(func) {
                return metaMap.get(func);
            };
            function getFuncName(func) {
                var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
                while(length--){
                    var data = array[length], otherFunc = data.func;
                    if (otherFunc == null || otherFunc == func) return data.name;
                }
                return result;
            }
            function getHolder(func) {
                var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
                return object.placeholder;
            }
            function getIteratee() {
                var result = lodash.iteratee || iteratee;
                result = result === iteratee ? baseIteratee : result;
                return arguments.length ? result(arguments[0], arguments[1]) : result;
            }
            function getMapData(map, key) {
                var data = map.__data__;
                return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
            }
            function getMatchData(object) {
                var result = keys(object), length = result.length;
                while(length--){
                    var key = result[length], value = object[key];
                    result[length] = [
                        key,
                        value,
                        isStrictComparable(value)
                    ];
                }
                return result;
            }
            function getNative(object, key) {
                var value = getValue(object, key);
                return baseIsNative(value) ? value : undefined;
            }
            function getRawTag(value) {
                var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
                try {
                    value[symToStringTag] = undefined;
                    var unmasked = true;
                } catch (e) {}
                var result = nativeObjectToString.call(value);
                if (unmasked) {
                    if (isOwn) value[symToStringTag] = tag;
                    else delete value[symToStringTag];
                }
                return result;
            }
            var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
                if (object == null) return [];
                object = Object1(object);
                return arrayFilter(nativeGetSymbols(object), function(symbol) {
                    return propertyIsEnumerable.call(object, symbol);
                });
            };
            var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
                var result = [];
                while(object){
                    arrayPush(result, getSymbols(object));
                    object = getPrototype(object);
                }
                return result;
            };
            var getTag = baseGetTag;
            if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
                var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
                if (ctorString) switch(ctorString){
                    case dataViewCtorString:
                        return dataViewTag;
                    case mapCtorString:
                        return mapTag;
                    case promiseCtorString:
                        return promiseTag;
                    case setCtorString:
                        return setTag;
                    case weakMapCtorString:
                        return weakMapTag;
                }
                return result;
            };
            function getView(start, end, transforms) {
                var index = -1, length = transforms.length;
                while(++index < length){
                    var data = transforms[index], size = data.size;
                    switch(data.type){
                        case 'drop':
                            start += size;
                            break;
                        case 'dropRight':
                            end -= size;
                            break;
                        case 'take':
                            end = nativeMin(end, start + size);
                            break;
                        case 'takeRight':
                            start = nativeMax(start, end - size);
                            break;
                    }
                }
                return {
                    'start': start,
                    'end': end
                };
            }
            function getWrapDetails(source) {
                var match = source.match(reWrapDetails);
                return match ? match[1].split(reSplitDetails) : [];
            }
            function hasPath(object, path, hasFunc) {
                path = castPath(path, object);
                var index = -1, length = path.length, result = false;
                while(++index < length){
                    var key = toKey(path[index]);
                    if (!(result = object != null && hasFunc(object, key))) break;
                    object = object[key];
                }
                if (result || ++index != length) return result;
                length = object == null ? 0 : object.length;
                return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
            }
            function initCloneArray(array) {
                var length = array.length, result = new array.constructor(length);
                if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                    result.index = array.index;
                    result.input = array.input;
                }
                return result;
            }
            function initCloneObject(object) {
                return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
            }
            function initCloneByTag(object, tag, isDeep) {
                var Ctor = object.constructor;
                switch(tag){
                    case arrayBufferTag:
                        return cloneArrayBuffer(object);
                    case boolTag:
                    case dateTag:
                        return new Ctor(+object);
                    case dataViewTag:
                        return cloneDataView(object, isDeep);
                    case float32Tag:
                    case float64Tag:
                    case int8Tag:
                    case int16Tag:
                    case int32Tag:
                    case uint8Tag:
                    case uint8ClampedTag:
                    case uint16Tag:
                    case uint32Tag:
                        return cloneTypedArray(object, isDeep);
                    case mapTag:
                        return new Ctor;
                    case numberTag:
                    case stringTag:
                        return new Ctor(object);
                    case regexpTag:
                        return cloneRegExp(object);
                    case setTag:
                        return new Ctor;
                    case symbolTag:
                        return cloneSymbol(object);
                }
            }
            function insertWrapDetails(source, details) {
                var length = details.length;
                if (!length) return source;
                var lastIndex = length - 1;
                details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
                details = details.join(length > 2 ? ', ' : ' ');
                return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
            }
            function isFlattenable(value) {
                return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
            }
            function isIndex(value, length) {
                var type = typeof value;
                length = length == null ? MAX_SAFE_INTEGER : length;
                return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
            }
            function isIterateeCall(value, index, object) {
                if (!isObject(object)) return false;
                var type = typeof index;
                if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
                return false;
            }
            function isKey(value, object) {
                if (isArray(value)) return false;
                var type = typeof value;
                if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
                return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
            }
            function isKeyable(value) {
                var type = typeof value;
                return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
            }
            function isLaziable(func) {
                var funcName = getFuncName(func), other = lodash[funcName];
                if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
                if (func === other) return true;
                var data = getData(other);
                return !!data && func === data[0];
            }
            function isMasked(func) {
                return !!maskSrcKey && maskSrcKey in func;
            }
            var isMaskable = coreJsData ? isFunction : stubFalse;
            function isPrototype(value) {
                var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
                return value === proto;
            }
            function isStrictComparable(value) {
                return value === value && !isObject(value);
            }
            function matchesStrictComparable(key, srcValue) {
                return function(object) {
                    if (object == null) return false;
                    return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
                };
            }
            function memoizeCapped(func) {
                var result = memoize(func, function(key) {
                    if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                    return key;
                });
                var cache = result.cache;
                return result;
            }
            function mergeData(data, source) {
                var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
                var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
                if (!(isCommon || isCombo)) return data;
                if (srcBitmask & WRAP_BIND_FLAG) {
                    data[2] = source[2];
                    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
                }
                var value = source[3];
                if (value) {
                    var partials = data[3];
                    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
                }
                value = source[5];
                if (value) {
                    partials = data[5];
                    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
                }
                value = source[7];
                if (value) data[7] = value;
                if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
                if (data[9] == null) data[9] = source[9];
                data[0] = source[0];
                data[1] = newBitmask;
                return data;
            }
            function nativeKeysIn(object) {
                var result = [];
                if (object != null) for(var key in Object1(object))result.push(key);
                return result;
            }
            function objectToString(value) {
                return nativeObjectToString.call(value);
            }
            function overRest(func, start, transform) {
                start = nativeMax(start === undefined ? func.length - 1 : start, 0);
                return function() {
                    var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                    while(++index < length)array[index] = args[start + index];
                    index = -1;
                    var otherArgs = Array1(start + 1);
                    while(++index < start)otherArgs[index] = args[index];
                    otherArgs[start] = transform(array);
                    return apply(func, this, otherArgs);
                };
            }
            function parent(object, path) {
                return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
            }
            function reorder(array, indexes) {
                var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
                while(length--){
                    var index = indexes[length];
                    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
                }
                return array;
            }
            function safeGet(object, key) {
                if (key === 'constructor' && typeof object[key] === 'function') return;
                if (key == '__proto__') return;
                return object[key];
            }
            var setData = shortOut(baseSetData);
            var setTimeout = ctxSetTimeout || function(func, wait) {
                return root.setTimeout(func, wait);
            };
            var setToString = shortOut(baseSetToString);
            function setWrapToString(wrapper, reference, bitmask) {
                var source = reference + '';
                return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
            }
            function shortOut(func) {
                var count = 0, lastCalled = 0;
                return function() {
                    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                    lastCalled = stamp;
                    if (remaining > 0) {
                        if (++count >= HOT_COUNT) return arguments[0];
                    } else count = 0;
                    return func.apply(undefined, arguments);
                };
            }
            function shuffleSelf(array, size) {
                var index = -1, length = array.length, lastIndex = length - 1;
                size = size === undefined ? length : size;
                while(++index < size){
                    var rand = baseRandom(index, lastIndex), value = array[rand];
                    array[rand] = array[index];
                    array[index] = value;
                }
                array.length = size;
                return array;
            }
            var stringToPath = memoizeCapped(function(string) {
                var result = [];
                if (string.charCodeAt(0) === 46) result.push('');
                string.replace(rePropName, function(match, number, quote, subString) {
                    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
                });
                return result;
            });
            function toKey(value) {
                if (typeof value == 'string' || isSymbol(value)) return value;
                var result = value + '';
                return result == '0' && 1 / value == -INFINITY ? '-0' : result;
            }
            function toSource(func) {
                if (func != null) {
                    try {
                        return funcToString.call(func);
                    } catch (e) {}
                    try {
                        return func + '';
                    } catch (e) {}
                }
                return '';
            }
            function updateWrapDetails(details, bitmask) {
                arrayEach(wrapFlags, function(pair) {
                    var value = '_.' + pair[0];
                    if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
                });
                return details.sort();
            }
            function wrapperClone(wrapper) {
                if (wrapper instanceof LazyWrapper) return wrapper.clone();
                var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
                result.__actions__ = copyArray(wrapper.__actions__);
                result.__index__ = wrapper.__index__;
                result.__values__ = wrapper.__values__;
                return result;
            }
            function chunk(array, size, guard) {
                if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
                else size = nativeMax(toInteger(size), 0);
                var length = array == null ? 0 : array.length;
                if (!length || size < 1) return [];
                var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
                while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
                return result;
            }
            function compact(array) {
                var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
                while(++index < length){
                    var value = array[index];
                    if (value) result[resIndex++] = value;
                }
                return result;
            }
            function concat() {
                var length = arguments.length;
                if (!length) return [];
                var args = Array1(length - 1), array = arguments[0], index = length;
                while(index--)args[index - 1] = arguments[index];
                return arrayPush(isArray(array) ? copyArray(array) : [
                    array
                ], baseFlatten(args, 1));
            }
            var difference = baseRest(function(array, values) {
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
            });
            var differenceBy = baseRest(function(array, values) {
                var iteratee = last(values);
                if (isArrayLikeObject(iteratee)) iteratee = undefined;
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
            });
            var differenceWith = baseRest(function(array, values) {
                var comparator = last(values);
                if (isArrayLikeObject(comparator)) comparator = undefined;
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
            });
            function drop(array, n, guard) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                return baseSlice(array, n < 0 ? 0 : n, length);
            }
            function dropRight(array, n, guard) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                n = length - n;
                return baseSlice(array, 0, n < 0 ? 0 : n);
            }
            function dropRightWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
            }
            function dropWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
            }
            function fill(array, value, start, end) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                    start = 0;
                    end = length;
                }
                return baseFill(array, value, start, end);
            }
            function findIndex(array, predicate, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = fromIndex == null ? 0 : toInteger(fromIndex);
                if (index < 0) index = nativeMax(length + index, 0);
                return baseFindIndex(array, getIteratee(predicate, 3), index);
            }
            function findLastIndex(array, predicate, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = length - 1;
                if (fromIndex !== undefined) {
                    index = toInteger(fromIndex);
                    index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                }
                return baseFindIndex(array, getIteratee(predicate, 3), index, true);
            }
            function flatten(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseFlatten(array, 1) : [];
            }
            function flattenDeep(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseFlatten(array, INFINITY) : [];
            }
            function flattenDepth(array, depth) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                depth = depth === undefined ? 1 : toInteger(depth);
                return baseFlatten(array, depth);
            }
            function fromPairs(pairs) {
                var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
                while(++index < length){
                    var pair = pairs[index];
                    result[pair[0]] = pair[1];
                }
                return result;
            }
            function head(array) {
                return array && array.length ? array[0] : undefined;
            }
            function indexOf(array, value, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = fromIndex == null ? 0 : toInteger(fromIndex);
                if (index < 0) index = nativeMax(length + index, 0);
                return baseIndexOf(array, value, index);
            }
            function initial(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseSlice(array, 0, -1) : [];
            }
            var intersection = baseRest(function(arrays) {
                var mapped = arrayMap(arrays, castArrayLikeObject);
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
            });
            var intersectionBy = baseRest(function(arrays) {
                var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
                if (iteratee === last(mapped)) iteratee = undefined;
                else mapped.pop();
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
            });
            var intersectionWith = baseRest(function(arrays) {
                var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                if (comparator) mapped.pop();
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
            });
            function join(array, separator) {
                return array == null ? '' : nativeJoin.call(array, separator);
            }
            function last(array) {
                var length = array == null ? 0 : array.length;
                return length ? array[length - 1] : undefined;
            }
            function lastIndexOf(array, value, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = length;
                if (fromIndex !== undefined) {
                    index = toInteger(fromIndex);
                    index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                }
                return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
            }
            function nth(array, n) {
                return array && array.length ? baseNth(array, toInteger(n)) : undefined;
            }
            var pull = baseRest(pullAll);
            function pullAll(array, values) {
                return array && array.length && values && values.length ? basePullAll(array, values) : array;
            }
            function pullAllBy(array, values, iteratee) {
                return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
            }
            function pullAllWith(array, values, comparator) {
                return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
            }
            var pullAt = flatRest(function(array, indexes) {
                var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
                basePullAt(array, arrayMap(indexes, function(index) {
                    return isIndex(index, length) ? +index : index;
                }).sort(compareAscending));
                return result;
            });
            function remove(array, predicate) {
                var result = [];
                if (!(array && array.length)) return result;
                var index = -1, indexes = [], length = array.length;
                predicate = getIteratee(predicate, 3);
                while(++index < length){
                    var value = array[index];
                    if (predicate(value, index, array)) {
                        result.push(value);
                        indexes.push(index);
                    }
                }
                basePullAt(array, indexes);
                return result;
            }
            function reverse(array) {
                return array == null ? array : nativeReverse.call(array);
            }
            function slice(array, start, end) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                    start = 0;
                    end = length;
                } else {
                    start = start == null ? 0 : toInteger(start);
                    end = end === undefined ? length : toInteger(end);
                }
                return baseSlice(array, start, end);
            }
            function sortedIndex(array, value) {
                return baseSortedIndex(array, value);
            }
            function sortedIndexBy(array, value, iteratee) {
                return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
            }
            function sortedIndexOf(array, value) {
                var length = array == null ? 0 : array.length;
                if (length) {
                    var index = baseSortedIndex(array, value);
                    if (index < length && eq(array[index], value)) return index;
                }
                return -1;
            }
            function sortedLastIndex(array, value) {
                return baseSortedIndex(array, value, true);
            }
            function sortedLastIndexBy(array, value, iteratee) {
                return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
            }
            function sortedLastIndexOf(array, value) {
                var length = array == null ? 0 : array.length;
                if (length) {
                    var index = baseSortedIndex(array, value, true) - 1;
                    if (eq(array[index], value)) return index;
                }
                return -1;
            }
            function sortedUniq(array) {
                return array && array.length ? baseSortedUniq(array) : [];
            }
            function sortedUniqBy(array, iteratee) {
                return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
            }
            function tail(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseSlice(array, 1, length) : [];
            }
            function take(array, n, guard) {
                if (!(array && array.length)) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                return baseSlice(array, 0, n < 0 ? 0 : n);
            }
            function takeRight(array, n, guard) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                n = length - n;
                return baseSlice(array, n < 0 ? 0 : n, length);
            }
            function takeRightWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
            }
            function takeWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
            }
            var union = baseRest(function(arrays) {
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
            });
            var unionBy = baseRest(function(arrays) {
                var iteratee = last(arrays);
                if (isArrayLikeObject(iteratee)) iteratee = undefined;
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
            });
            var unionWith = baseRest(function(arrays) {
                var comparator = last(arrays);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
            });
            function uniq(array) {
                return array && array.length ? baseUniq(array) : [];
            }
            function uniqBy(array, iteratee) {
                return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
            }
            function uniqWith(array, comparator) {
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return array && array.length ? baseUniq(array, undefined, comparator) : [];
            }
            function unzip(array) {
                if (!(array && array.length)) return [];
                var length = 0;
                array = arrayFilter(array, function(group) {
                    if (isArrayLikeObject(group)) {
                        length = nativeMax(group.length, length);
                        return true;
                    }
                });
                return baseTimes(length, function(index) {
                    return arrayMap(array, baseProperty(index));
                });
            }
            function unzipWith(array, iteratee) {
                if (!(array && array.length)) return [];
                var result = unzip(array);
                if (iteratee == null) return result;
                return arrayMap(result, function(group) {
                    return apply(iteratee, undefined, group);
                });
            }
            var without = baseRest(function(array, values) {
                return isArrayLikeObject(array) ? baseDifference(array, values) : [];
            });
            var xor = baseRest(function(arrays) {
                return baseXor(arrayFilter(arrays, isArrayLikeObject));
            });
            var xorBy = baseRest(function(arrays) {
                var iteratee = last(arrays);
                if (isArrayLikeObject(iteratee)) iteratee = undefined;
                return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
            });
            var xorWith = baseRest(function(arrays) {
                var comparator = last(arrays);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
            });
            var zip = baseRest(unzip);
            function zipObject(props, values) {
                return baseZipObject(props || [], values || [], assignValue);
            }
            function zipObjectDeep(props, values) {
                return baseZipObject(props || [], values || [], baseSet);
            }
            var zipWith = baseRest(function(arrays) {
                var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
                iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
                return unzipWith(arrays, iteratee);
            });
            function chain(value) {
                var result = lodash(value);
                result.__chain__ = true;
                return result;
            }
            function tap(value, interceptor) {
                interceptor(value);
                return value;
            }
            function thru(value, interceptor) {
                return interceptor(value);
            }
            var wrapperAt = flatRest(function(paths) {
                var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                    return baseAt(object, paths);
                };
                if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
                value = value.slice(start, +start + (length ? 1 : 0));
                value.__actions__.push({
                    'func': thru,
                    'args': [
                        interceptor
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(value, this.__chain__).thru(function(array) {
                    if (length && !array.length) array.push(undefined);
                    return array;
                });
            });
            function wrapperChain() {
                return chain(this);
            }
            function wrapperCommit() {
                return new LodashWrapper(this.value(), this.__chain__);
            }
            function wrapperNext() {
                if (this.__values__ === undefined) this.__values__ = toArray(this.value());
                var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
                return {
                    'done': done,
                    'value': value
                };
            }
            function wrapperToIterator() {
                return this;
            }
            function wrapperPlant(value) {
                var result, parent = this;
                while(parent instanceof baseLodash){
                    var clone = wrapperClone(parent);
                    clone.__index__ = 0;
                    clone.__values__ = undefined;
                    if (result) previous.__wrapped__ = clone;
                    else result = clone;
                    var previous = clone;
                    parent = parent.__wrapped__;
                }
                previous.__wrapped__ = value;
                return result;
            }
            function wrapperReverse() {
                var value = this.__wrapped__;
                if (value instanceof LazyWrapper) {
                    var wrapped = value;
                    if (this.__actions__.length) wrapped = new LazyWrapper(this);
                    wrapped = wrapped.reverse();
                    wrapped.__actions__.push({
                        'func': thru,
                        'args': [
                            reverse
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(wrapped, this.__chain__);
                }
                return this.thru(reverse);
            }
            function wrapperValue() {
                return baseWrapperValue(this.__wrapped__, this.__actions__);
            }
            var countBy = createAggregator(function(result, value, key) {
                if (hasOwnProperty.call(result, key)) ++result[key];
                else baseAssignValue(result, key, 1);
            });
            function every(collection, predicate, guard) {
                var func = isArray(collection) ? arrayEvery : baseEvery;
                if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
                return func(collection, getIteratee(predicate, 3));
            }
            function filter(collection, predicate) {
                var func = isArray(collection) ? arrayFilter : baseFilter;
                return func(collection, getIteratee(predicate, 3));
            }
            var find = createFind(findIndex);
            var findLast = createFind(findLastIndex);
            function flatMap(collection, iteratee) {
                return baseFlatten(map(collection, iteratee), 1);
            }
            function flatMapDeep(collection, iteratee) {
                return baseFlatten(map(collection, iteratee), INFINITY);
            }
            function flatMapDepth(collection, iteratee, depth) {
                depth = depth === undefined ? 1 : toInteger(depth);
                return baseFlatten(map(collection, iteratee), depth);
            }
            function forEach(collection, iteratee) {
                var func = isArray(collection) ? arrayEach : baseEach;
                return func(collection, getIteratee(iteratee, 3));
            }
            function forEachRight(collection, iteratee) {
                var func = isArray(collection) ? arrayEachRight : baseEachRight;
                return func(collection, getIteratee(iteratee, 3));
            }
            var groupBy = createAggregator(function(result, value, key) {
                if (hasOwnProperty.call(result, key)) result[key].push(value);
                else baseAssignValue(result, key, [
                    value
                ]);
            });
            function includes(collection, value, fromIndex, guard) {
                collection = isArrayLike(collection) ? collection : values(collection);
                fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
                var length = collection.length;
                if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
                return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
            }
            var invokeMap = baseRest(function(collection, path, args) {
                var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
                baseEach(collection, function(value) {
                    result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
                });
                return result;
            });
            var keyBy = createAggregator(function(result, value, key) {
                baseAssignValue(result, key, value);
            });
            function map(collection, iteratee) {
                var func = isArray(collection) ? arrayMap : baseMap;
                return func(collection, getIteratee(iteratee, 3));
            }
            function orderBy(collection, iteratees, orders, guard) {
                if (collection == null) return [];
                if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                    iteratees
                ];
                orders = guard ? undefined : orders;
                if (!isArray(orders)) orders = orders == null ? [] : [
                    orders
                ];
                return baseOrderBy(collection, iteratees, orders);
            }
            var partition = createAggregator(function(result, value, key) {
                result[key ? 0 : 1].push(value);
            }, function() {
                return [
                    [],
                    []
                ];
            });
            function reduce(collection, iteratee, accumulator) {
                var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
                return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
            }
            function reduceRight(collection, iteratee, accumulator) {
                var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
                return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
            }
            function reject(collection, predicate) {
                var func = isArray(collection) ? arrayFilter : baseFilter;
                return func(collection, negate(getIteratee(predicate, 3)));
            }
            function sample(collection) {
                var func = isArray(collection) ? arraySample : baseSample;
                return func(collection);
            }
            function sampleSize(collection, n, guard) {
                if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
                else n = toInteger(n);
                var func = isArray(collection) ? arraySampleSize : baseSampleSize;
                return func(collection, n);
            }
            function shuffle(collection) {
                var func = isArray(collection) ? arrayShuffle : baseShuffle;
                return func(collection);
            }
            function size(collection) {
                if (collection == null) return 0;
                if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
                var tag = getTag(collection);
                if (tag == mapTag || tag == setTag) return collection.size;
                return baseKeys(collection).length;
            }
            function some(collection, predicate, guard) {
                var func = isArray(collection) ? arraySome : baseSome;
                if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
                return func(collection, getIteratee(predicate, 3));
            }
            var sortBy = baseRest(function(collection, iteratees) {
                if (collection == null) return [];
                var length = iteratees.length;
                if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
                else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                    iteratees[0]
                ];
                return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
            });
            var now = ctxNow || function() {
                return root.Date.now();
            };
            function after(n, func) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                n = toInteger(n);
                return function() {
                    if (--n < 1) return func.apply(this, arguments);
                };
            }
            function ary(func, n, guard) {
                n = guard ? undefined : n;
                n = func && n == null ? func.length : n;
                return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
            }
            function before(n, func) {
                var result;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                n = toInteger(n);
                return function() {
                    if (--n > 0) result = func.apply(this, arguments);
                    if (n <= 1) func = undefined;
                    return result;
                };
            }
            var bind = baseRest(function(func, thisArg, partials) {
                var bitmask = WRAP_BIND_FLAG;
                if (partials.length) {
                    var holders = replaceHolders(partials, getHolder(bind));
                    bitmask |= WRAP_PARTIAL_FLAG;
                }
                return createWrap(func, bitmask, thisArg, partials, holders);
            });
            var bindKey = baseRest(function(object, key, partials) {
                var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
                if (partials.length) {
                    var holders = replaceHolders(partials, getHolder(bindKey));
                    bitmask |= WRAP_PARTIAL_FLAG;
                }
                return createWrap(key, bitmask, object, partials, holders);
            });
            function curry(func, arity, guard) {
                arity = guard ? undefined : arity;
                var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
                result.placeholder = curry.placeholder;
                return result;
            }
            function curryRight(func, arity, guard) {
                arity = guard ? undefined : arity;
                var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
                result.placeholder = curryRight.placeholder;
                return result;
            }
            function debounce(func, wait, options) {
                var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                wait = toNumber(wait) || 0;
                if (isObject(options)) {
                    leading = !!options.leading;
                    maxing = 'maxWait' in options;
                    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                    trailing = 'trailing' in options ? !!options.trailing : trailing;
                }
                function invokeFunc(time) {
                    var args = lastArgs, thisArg = lastThis;
                    lastArgs = lastThis = undefined;
                    lastInvokeTime = time;
                    result = func.apply(thisArg, args);
                    return result;
                }
                function leadingEdge(time) {
                    lastInvokeTime = time;
                    timerId = setTimeout(timerExpired, wait);
                    return leading ? invokeFunc(time) : result;
                }
                function remainingWait(time) {
                    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
                }
                function shouldInvoke(time) {
                    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
                }
                function timerExpired() {
                    var time = now();
                    if (shouldInvoke(time)) return trailingEdge(time);
                    timerId = setTimeout(timerExpired, remainingWait(time));
                }
                function trailingEdge(time) {
                    timerId = undefined;
                    if (trailing && lastArgs) return invokeFunc(time);
                    lastArgs = lastThis = undefined;
                    return result;
                }
                function cancel() {
                    if (timerId !== undefined) clearTimeout(timerId);
                    lastInvokeTime = 0;
                    lastArgs = lastCallTime = lastThis = timerId = undefined;
                }
                function flush() {
                    return timerId === undefined ? result : trailingEdge(now());
                }
                function debounced() {
                    var time = now(), isInvoking = shouldInvoke(time);
                    lastArgs = arguments;
                    lastThis = this;
                    lastCallTime = time;
                    if (isInvoking) {
                        if (timerId === undefined) return leadingEdge(lastCallTime);
                        if (maxing) {
                            clearTimeout(timerId);
                            timerId = setTimeout(timerExpired, wait);
                            return invokeFunc(lastCallTime);
                        }
                    }
                    if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                    return result;
                }
                debounced.cancel = cancel;
                debounced.flush = flush;
                return debounced;
            }
            var defer = baseRest(function(func, args) {
                return baseDelay(func, 1, args);
            });
            var delay = baseRest(function(func, wait, args) {
                return baseDelay(func, toNumber(wait) || 0, args);
            });
            function flip(func) {
                return createWrap(func, WRAP_FLIP_FLAG);
            }
            function memoize(func, resolver) {
                if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                var memoized = function() {
                    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                    if (cache.has(key)) return cache.get(key);
                    var result = func.apply(this, args);
                    memoized.cache = cache.set(key, result) || cache;
                    return result;
                };
                memoized.cache = new (memoize.Cache || MapCache);
                return memoized;
            }
            memoize.Cache = MapCache;
            function negate(predicate) {
                if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return function() {
                    var args = arguments;
                    switch(args.length){
                        case 0:
                            return !predicate.call(this);
                        case 1:
                            return !predicate.call(this, args[0]);
                        case 2:
                            return !predicate.call(this, args[0], args[1]);
                        case 3:
                            return !predicate.call(this, args[0], args[1], args[2]);
                    }
                    return !predicate.apply(this, args);
                };
            }
            function once(func) {
                return before(2, func);
            }
            var overArgs = castRest(function(func, transforms) {
                transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
                var funcsLength = transforms.length;
                return baseRest(function(args) {
                    var index = -1, length = nativeMin(args.length, funcsLength);
                    while(++index < length)args[index] = transforms[index].call(this, args[index]);
                    return apply(func, this, args);
                });
            });
            var partial = baseRest(function(func, partials) {
                var holders = replaceHolders(partials, getHolder(partial));
                return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
            });
            var partialRight = baseRest(function(func, partials) {
                var holders = replaceHolders(partials, getHolder(partialRight));
                return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
            });
            var rearg = flatRest(function(func, indexes) {
                return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
            });
            function rest(func, start) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                start = start === undefined ? start : toInteger(start);
                return baseRest(func, start);
            }
            function spread(func, start) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                start = start == null ? 0 : nativeMax(toInteger(start), 0);
                return baseRest(function(args) {
                    var array = args[start], otherArgs = castSlice(args, 0, start);
                    if (array) arrayPush(otherArgs, array);
                    return apply(func, this, otherArgs);
                });
            }
            function throttle(func, wait, options) {
                var leading = true, trailing = true;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                if (isObject(options)) {
                    leading = 'leading' in options ? !!options.leading : leading;
                    trailing = 'trailing' in options ? !!options.trailing : trailing;
                }
                return debounce(func, wait, {
                    'leading': leading,
                    'maxWait': wait,
                    'trailing': trailing
                });
            }
            function unary(func) {
                return ary(func, 1);
            }
            function wrap(value, wrapper) {
                return partial(castFunction(wrapper), value);
            }
            function castArray() {
                if (!arguments.length) return [];
                var value = arguments[0];
                return isArray(value) ? value : [
                    value
                ];
            }
            function clone(value) {
                return baseClone(value, CLONE_SYMBOLS_FLAG);
            }
            function cloneWith(value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
            }
            function cloneDeep(value) {
                return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
            }
            function cloneDeepWith(value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
            }
            function conformsTo(object, source) {
                return source == null || baseConformsTo(object, source, keys(source));
            }
            function eq(value, other) {
                return value === other || value !== value && other !== other;
            }
            var gt = createRelationalOperation(baseGt);
            var gte = createRelationalOperation(function(value, other) {
                return value >= other;
            });
            var isArguments = baseIsArguments(function() {
                return arguments;
            }()) ? baseIsArguments : function(value) {
                return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
            };
            var isArray = Array1.isArray;
            var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
            function isArrayLike(value) {
                return value != null && isLength(value.length) && !isFunction(value);
            }
            function isArrayLikeObject(value) {
                return isObjectLike(value) && isArrayLike(value);
            }
            function isBoolean(value) {
                return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
            }
            var isBuffer = nativeIsBuffer || stubFalse;
            var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
            function isElement(value) {
                return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
            }
            function isEmpty(value) {
                if (value == null) return true;
                if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
                var tag = getTag(value);
                if (tag == mapTag || tag == setTag) return !value.size;
                if (isPrototype(value)) return !baseKeys(value).length;
                for(var key in value){
                    if (hasOwnProperty.call(value, key)) return false;
                }
                return true;
            }
            function isEqual(value, other) {
                return baseIsEqual(value, other);
            }
            function isEqualWith(value, other, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                var result = customizer ? customizer(value, other) : undefined;
                return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
            }
            function isError(value) {
                if (!isObjectLike(value)) return false;
                var tag = baseGetTag(value);
                return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
            }
            function isFinite(value) {
                return typeof value == 'number' && nativeIsFinite(value);
            }
            function isFunction(value) {
                if (!isObject(value)) return false;
                var tag = baseGetTag(value);
                return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
            }
            function isInteger(value) {
                return typeof value == 'number' && value == toInteger(value);
            }
            function isLength(value) {
                return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
            }
            function isObject(value) {
                var type = typeof value;
                return value != null && (type == 'object' || type == 'function');
            }
            function isObjectLike(value) {
                return value != null && typeof value == 'object';
            }
            var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
            function isMatch(object, source) {
                return object === source || baseIsMatch(object, source, getMatchData(source));
            }
            function isMatchWith(object, source, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseIsMatch(object, source, getMatchData(source), customizer);
            }
            function isNaN(value) {
                return isNumber(value) && value != +value;
            }
            function isNative(value) {
                if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
                return baseIsNative(value);
            }
            function isNull(value) {
                return value === null;
            }
            function isNil(value) {
                return value == null;
            }
            function isNumber(value) {
                return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
            }
            function isPlainObject(value) {
                if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
                var proto = getPrototype(value);
                if (proto === null) return true;
                var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
                return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
            }
            var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
            function isSafeInteger(value) {
                return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
            }
            var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
            function isString(value) {
                return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
            }
            function isSymbol(value) {
                return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
            }
            var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
            function isUndefined(value) {
                return value === undefined;
            }
            function isWeakMap(value) {
                return isObjectLike(value) && getTag(value) == weakMapTag;
            }
            function isWeakSet(value) {
                return isObjectLike(value) && baseGetTag(value) == weakSetTag;
            }
            var lt = createRelationalOperation(baseLt);
            var lte = createRelationalOperation(function(value, other) {
                return value <= other;
            });
            function toArray(value) {
                if (!value) return [];
                if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
                if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
                var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
                return func(value);
            }
            function toFinite(value) {
                if (!value) return value === 0 ? value : 0;
                value = toNumber(value);
                if (value === INFINITY || value === -INFINITY) {
                    var sign = value < 0 ? -1 : 1;
                    return sign * MAX_INTEGER;
                }
                return value === value ? value : 0;
            }
            function toInteger(value) {
                var result = toFinite(value), remainder = result % 1;
                return result === result ? remainder ? result - remainder : result : 0;
            }
            function toLength(value) {
                return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
            }
            function toNumber(value) {
                if (typeof value == 'number') return value;
                if (isSymbol(value)) return NAN;
                if (isObject(value)) {
                    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                    value = isObject(other) ? other + '' : other;
                }
                if (typeof value != 'string') return value === 0 ? value : +value;
                value = baseTrim(value);
                var isBinary = reIsBinary.test(value);
                return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
            }
            function toPlainObject(value) {
                return copyObject(value, keysIn(value));
            }
            function toSafeInteger(value) {
                return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
            }
            function toString(value) {
                return value == null ? '' : baseToString(value);
            }
            var assign = createAssigner(function(object, source) {
                if (isPrototype(source) || isArrayLike(source)) {
                    copyObject(source, keys(source), object);
                    return;
                }
                for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
            });
            var assignIn = createAssigner(function(object, source) {
                copyObject(source, keysIn(source), object);
            });
            var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
                copyObject(source, keysIn(source), object, customizer);
            });
            var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
                copyObject(source, keys(source), object, customizer);
            });
            var at = flatRest(baseAt);
            function create(prototype, properties) {
                var result = baseCreate(prototype);
                return properties == null ? result : baseAssign(result, properties);
            }
            var defaults = baseRest(function(object, sources) {
                object = Object1(object);
                var index = -1;
                var length = sources.length;
                var guard = length > 2 ? sources[2] : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
                while(++index < length){
                    var source = sources[index];
                    var props = keysIn(source);
                    var propsIndex = -1;
                    var propsLength = props.length;
                    while(++propsIndex < propsLength){
                        var key = props[propsIndex];
                        var value = object[key];
                        if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                    }
                }
                return object;
            });
            var defaultsDeep = baseRest(function(args) {
                args.push(undefined, customDefaultsMerge);
                return apply(mergeWith, undefined, args);
            });
            function findKey(object, predicate) {
                return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
            }
            function findLastKey(object, predicate) {
                return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
            }
            function forIn(object, iteratee) {
                return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
            }
            function forInRight(object, iteratee) {
                return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
            }
            function forOwn(object, iteratee) {
                return object && baseForOwn(object, getIteratee(iteratee, 3));
            }
            function forOwnRight(object, iteratee) {
                return object && baseForOwnRight(object, getIteratee(iteratee, 3));
            }
            function functions(object) {
                return object == null ? [] : baseFunctions(object, keys(object));
            }
            function functionsIn(object) {
                return object == null ? [] : baseFunctions(object, keysIn(object));
            }
            function get(object, path, defaultValue) {
                var result = object == null ? undefined : baseGet(object, path);
                return result === undefined ? defaultValue : result;
            }
            function has(object, path) {
                return object != null && hasPath(object, path, baseHas);
            }
            function hasIn(object, path) {
                return object != null && hasPath(object, path, baseHasIn);
            }
            var invert = createInverter(function(result, value, key) {
                if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
                result[value] = key;
            }, constant(identity));
            var invertBy = createInverter(function(result, value, key) {
                if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
                if (hasOwnProperty.call(result, value)) result[value].push(key);
                else result[value] = [
                    key
                ];
            }, getIteratee);
            var invoke = baseRest(baseInvoke);
            function keys(object) {
                return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
            }
            function keysIn(object) {
                return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
            }
            function mapKeys(object, iteratee) {
                var result = {};
                iteratee = getIteratee(iteratee, 3);
                baseForOwn(object, function(value, key, object) {
                    baseAssignValue(result, iteratee(value, key, object), value);
                });
                return result;
            }
            function mapValues(object, iteratee) {
                var result = {};
                iteratee = getIteratee(iteratee, 3);
                baseForOwn(object, function(value, key, object) {
                    baseAssignValue(result, key, iteratee(value, key, object));
                });
                return result;
            }
            var merge = createAssigner(function(object, source, srcIndex) {
                baseMerge(object, source, srcIndex);
            });
            var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
                baseMerge(object, source, srcIndex, customizer);
            });
            var omit = flatRest(function(object, paths) {
                var result = {};
                if (object == null) return result;
                var isDeep = false;
                paths = arrayMap(paths, function(path) {
                    path = castPath(path, object);
                    isDeep || (isDeep = path.length > 1);
                    return path;
                });
                copyObject(object, getAllKeysIn(object), result);
                if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
                var length = paths.length;
                while(length--)baseUnset(result, paths[length]);
                return result;
            });
            function omitBy(object, predicate) {
                return pickBy(object, negate(getIteratee(predicate)));
            }
            var pick = flatRest(function(object, paths) {
                return object == null ? {} : basePick(object, paths);
            });
            function pickBy(object, predicate) {
                if (object == null) return {};
                var props = arrayMap(getAllKeysIn(object), function(prop) {
                    return [
                        prop
                    ];
                });
                predicate = getIteratee(predicate);
                return basePickBy(object, props, function(value, path) {
                    return predicate(value, path[0]);
                });
            }
            function result(object, path, defaultValue) {
                path = castPath(path, object);
                var index = -1, length = path.length;
                if (!length) {
                    length = 1;
                    object = undefined;
                }
                while(++index < length){
                    var value = object == null ? undefined : object[toKey(path[index])];
                    if (value === undefined) {
                        index = length;
                        value = defaultValue;
                    }
                    object = isFunction(value) ? value.call(object) : value;
                }
                return object;
            }
            function set(object, path, value) {
                return object == null ? object : baseSet(object, path, value);
            }
            function setWith(object, path, value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return object == null ? object : baseSet(object, path, value, customizer);
            }
            var toPairs = createToPairs(keys);
            var toPairsIn = createToPairs(keysIn);
            function transform(object, iteratee, accumulator) {
                var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
                iteratee = getIteratee(iteratee, 4);
                if (accumulator == null) {
                    var Ctor = object && object.constructor;
                    if (isArrLike) accumulator = isArr ? new Ctor : [];
                    else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                    else accumulator = {};
                }
                (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                    return iteratee(accumulator, value, index, object);
                });
                return accumulator;
            }
            function unset(object, path) {
                return object == null ? true : baseUnset(object, path);
            }
            function update(object, path, updater) {
                return object == null ? object : baseUpdate(object, path, castFunction(updater));
            }
            function updateWith(object, path, updater, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
            }
            function values(object) {
                return object == null ? [] : baseValues(object, keys(object));
            }
            function valuesIn(object) {
                return object == null ? [] : baseValues(object, keysIn(object));
            }
            function clamp(number, lower, upper) {
                if (upper === undefined) {
                    upper = lower;
                    lower = undefined;
                }
                if (upper !== undefined) {
                    upper = toNumber(upper);
                    upper = upper === upper ? upper : 0;
                }
                if (lower !== undefined) {
                    lower = toNumber(lower);
                    lower = lower === lower ? lower : 0;
                }
                return baseClamp(toNumber(number), lower, upper);
            }
            function inRange(number, start, end) {
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                number = toNumber(number);
                return baseInRange(number, start, end);
            }
            function random(lower, upper, floating) {
                if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
                if (floating === undefined) {
                    if (typeof upper == 'boolean') {
                        floating = upper;
                        upper = undefined;
                    } else if (typeof lower == 'boolean') {
                        floating = lower;
                        lower = undefined;
                    }
                }
                if (lower === undefined && upper === undefined) {
                    lower = 0;
                    upper = 1;
                } else {
                    lower = toFinite(lower);
                    if (upper === undefined) {
                        upper = lower;
                        lower = 0;
                    } else upper = toFinite(upper);
                }
                if (lower > upper) {
                    var temp = lower;
                    lower = upper;
                    upper = temp;
                }
                if (floating || lower % 1 || upper % 1) {
                    var rand = nativeRandom();
                    return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
                }
                return baseRandom(lower, upper);
            }
            var camelCase = createCompounder(function(result, word, index) {
                word = word.toLowerCase();
                return result + (index ? capitalize(word) : word);
            });
            function capitalize(string) {
                return upperFirst(toString(string).toLowerCase());
            }
            function deburr(string) {
                string = toString(string);
                return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
            }
            function endsWith(string, target, position) {
                string = toString(string);
                target = baseToString(target);
                var length = string.length;
                position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
                var end = position;
                position -= target.length;
                return position >= 0 && string.slice(position, end) == target;
            }
            function escape(string) {
                string = toString(string);
                return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
            }
            function escapeRegExp(string) {
                string = toString(string);
                return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
            }
            var kebabCase = createCompounder(function(result, word, index) {
                return result + (index ? '-' : '') + word.toLowerCase();
            });
            var lowerCase = createCompounder(function(result, word, index) {
                return result + (index ? ' ' : '') + word.toLowerCase();
            });
            var lowerFirst = createCaseFirst('toLowerCase');
            function pad(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                if (!length || strLength >= length) return string;
                var mid = (length - strLength) / 2;
                return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
            }
            function padEnd(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
            }
            function padStart(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
            }
            function parseInt1(string, radix, guard) {
                if (guard || radix == null) radix = 0;
                else if (radix) radix = +radix;
                return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
            }
            function repeat(string, n, guard) {
                if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
                else n = toInteger(n);
                return baseRepeat(toString(string), n);
            }
            function replace() {
                var args = arguments, string = toString(args[0]);
                return args.length < 3 ? string : string.replace(args[1], args[2]);
            }
            var snakeCase = createCompounder(function(result, word, index) {
                return result + (index ? '_' : '') + word.toLowerCase();
            });
            function split(string, separator, limit) {
                if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
                limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
                if (!limit) return [];
                string = toString(string);
                if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                    separator = baseToString(separator);
                    if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
                }
                return string.split(separator, limit);
            }
            var startCase = createCompounder(function(result, word, index) {
                return result + (index ? ' ' : '') + upperFirst(word);
            });
            function startsWith(string, target, position) {
                string = toString(string);
                position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
                target = baseToString(target);
                return string.slice(position, position + target.length) == target;
            }
            function template(string, options, guard) {
                var settings = lodash.templateSettings;
                if (guard && isIterateeCall(string, options, guard)) options = undefined;
                string = toString(string);
                options = assignInWith({}, options, settings, customDefaultsAssignIn);
                var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
                var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
                var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
                var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
                string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                    interpolateValue || (interpolateValue = esTemplateValue);
                    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                    if (escapeValue) {
                        isEscaping = true;
                        source += "' +\n__e(" + escapeValue + ") +\n'";
                    }
                    if (evaluateValue) {
                        isEvaluating = true;
                        source += "';\n" + evaluateValue + ";\n__p += '";
                    }
                    if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                    index = offset + match.length;
                    return match;
                });
                source += "';\n";
                var variable = hasOwnProperty.call(options, 'variable') && options.variable;
                if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
                else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
                source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
                source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
                var result = attempt(function() {
                    return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
                });
                result.source = source;
                if (isError(result)) throw result;
                return result;
            }
            function toLower(value) {
                return toString(value).toLowerCase();
            }
            function toUpper(value) {
                return toString(value).toUpperCase();
            }
            function trim(string, chars, guard) {
                string = toString(string);
                if (string && (guard || chars === undefined)) return baseTrim(string);
                if (!string || !(chars = baseToString(chars))) return string;
                var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
                return castSlice(strSymbols, start, end).join('');
            }
            function trimEnd(string, chars, guard) {
                string = toString(string);
                if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
                if (!string || !(chars = baseToString(chars))) return string;
                var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
                return castSlice(strSymbols, 0, end).join('');
            }
            function trimStart(string, chars, guard) {
                string = toString(string);
                if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
                if (!string || !(chars = baseToString(chars))) return string;
                var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
                return castSlice(strSymbols, start).join('');
            }
            function truncate(string, options) {
                var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
                if (isObject(options)) {
                    var separator = 'separator' in options ? options.separator : separator;
                    length = 'length' in options ? toInteger(options.length) : length;
                    omission = 'omission' in options ? baseToString(options.omission) : omission;
                }
                string = toString(string);
                var strLength = string.length;
                if (hasUnicode(string)) {
                    var strSymbols = stringToArray(string);
                    strLength = strSymbols.length;
                }
                if (length >= strLength) return string;
                var end = length - stringSize(omission);
                if (end < 1) return omission;
                var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
                if (separator === undefined) return result + omission;
                if (strSymbols) end += result.length - end;
                if (isRegExp(separator)) {
                    if (string.slice(end).search(separator)) {
                        var match, substring = result;
                        if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                        separator.lastIndex = 0;
                        while(match = separator.exec(substring))var newEnd = match.index;
                        result = result.slice(0, newEnd === undefined ? end : newEnd);
                    }
                } else if (string.indexOf(baseToString(separator), end) != end) {
                    var index = result.lastIndexOf(separator);
                    if (index > -1) result = result.slice(0, index);
                }
                return result + omission;
            }
            function unescape(string) {
                string = toString(string);
                return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
            }
            var upperCase = createCompounder(function(result, word, index) {
                return result + (index ? ' ' : '') + word.toUpperCase();
            });
            var upperFirst = createCaseFirst('toUpperCase');
            function words(string, pattern, guard) {
                string = toString(string);
                pattern = guard ? undefined : pattern;
                if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
                return string.match(pattern) || [];
            }
            var attempt = baseRest(function(func, args) {
                try {
                    return apply(func, undefined, args);
                } catch (e) {
                    return isError(e) ? e : new Error(e);
                }
            });
            var bindAll = flatRest(function(object, methodNames) {
                arrayEach(methodNames, function(key) {
                    key = toKey(key);
                    baseAssignValue(object, key, bind(object[key], object));
                });
                return object;
            });
            function cond(pairs) {
                var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
                pairs = !length ? [] : arrayMap(pairs, function(pair) {
                    if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    return [
                        toIteratee(pair[0]),
                        pair[1]
                    ];
                });
                return baseRest(function(args) {
                    var index = -1;
                    while(++index < length){
                        var pair = pairs[index];
                        if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                    }
                });
            }
            function conforms(source) {
                return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
            }
            function constant(value) {
                return function() {
                    return value;
                };
            }
            function defaultTo(value, defaultValue) {
                return value == null || value !== value ? defaultValue : value;
            }
            var flow = createFlow();
            var flowRight = createFlow(true);
            function identity(value) {
                return value;
            }
            function iteratee(func) {
                return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
            }
            function matches(source) {
                return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
            }
            function matchesProperty(path, srcValue) {
                return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
            }
            var method = baseRest(function(path, args) {
                return function(object) {
                    return baseInvoke(object, path, args);
                };
            });
            var methodOf = baseRest(function(object, args) {
                return function(path) {
                    return baseInvoke(object, path, args);
                };
            });
            function mixin(object, source, options) {
                var props = keys(source), methodNames = baseFunctions(source, props);
                if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                    options = source;
                    source = object;
                    object = this;
                    methodNames = baseFunctions(source, keys(source));
                }
                var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
                arrayEach(methodNames, function(methodName) {
                    var func = source[methodName];
                    object[methodName] = func;
                    if (isFunc) object.prototype[methodName] = function() {
                        var chainAll = this.__chain__;
                        if (chain || chainAll) {
                            var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                            actions.push({
                                'func': func,
                                'args': arguments,
                                'thisArg': object
                            });
                            result.__chain__ = chainAll;
                            return result;
                        }
                        return func.apply(object, arrayPush([
                            this.value()
                        ], arguments));
                    };
                });
                return object;
            }
            function noConflict() {
                if (root._ === this) root._ = oldDash;
                return this;
            }
            function noop() {}
            function nthArg(n) {
                n = toInteger(n);
                return baseRest(function(args) {
                    return baseNth(args, n);
                });
            }
            var over = createOver(arrayMap);
            var overEvery = createOver(arrayEvery);
            var overSome = createOver(arraySome);
            function property(path) {
                return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
            }
            function propertyOf(object) {
                return function(path) {
                    return object == null ? undefined : baseGet(object, path);
                };
            }
            var range = createRange();
            var rangeRight = createRange(true);
            function stubArray() {
                return [];
            }
            function stubFalse() {
                return false;
            }
            function stubObject() {
                return {};
            }
            function stubString() {
                return '';
            }
            function stubTrue() {
                return true;
            }
            function times(n, iteratee) {
                n = toInteger(n);
                if (n < 1 || n > MAX_SAFE_INTEGER) return [];
                var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
                iteratee = getIteratee(iteratee);
                n -= MAX_ARRAY_LENGTH;
                var result = baseTimes(length, iteratee);
                while(++index < n)iteratee(index);
                return result;
            }
            function toPath(value) {
                if (isArray(value)) return arrayMap(value, toKey);
                return isSymbol(value) ? [
                    value
                ] : copyArray(stringToPath(toString(value)));
            }
            function uniqueId(prefix) {
                var id = ++idCounter;
                return toString(prefix) + id;
            }
            var add = createMathOperation(function(augend, addend) {
                return augend + addend;
            }, 0);
            var ceil = createRound('ceil');
            var divide = createMathOperation(function(dividend, divisor) {
                return dividend / divisor;
            }, 1);
            var floor = createRound('floor');
            function max(array) {
                return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
            }
            function maxBy(array, iteratee) {
                return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
            }
            function mean(array) {
                return baseMean(array, identity);
            }
            function meanBy(array, iteratee) {
                return baseMean(array, getIteratee(iteratee, 2));
            }
            function min(array) {
                return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
            }
            function minBy(array, iteratee) {
                return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
            }
            var multiply = createMathOperation(function(multiplier, multiplicand) {
                return multiplier * multiplicand;
            }, 1);
            var round = createRound('round');
            var subtract = createMathOperation(function(minuend, subtrahend) {
                return minuend - subtrahend;
            }, 0);
            function sum(array) {
                return array && array.length ? baseSum(array, identity) : 0;
            }
            function sumBy(array, iteratee) {
                return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
            }
            lodash.after = after;
            lodash.ary = ary;
            lodash.assign = assign;
            lodash.assignIn = assignIn;
            lodash.assignInWith = assignInWith;
            lodash.assignWith = assignWith;
            lodash.at = at;
            lodash.before = before;
            lodash.bind = bind;
            lodash.bindAll = bindAll;
            lodash.bindKey = bindKey;
            lodash.castArray = castArray;
            lodash.chain = chain;
            lodash.chunk = chunk;
            lodash.compact = compact;
            lodash.concat = concat;
            lodash.cond = cond;
            lodash.conforms = conforms;
            lodash.constant = constant;
            lodash.countBy = countBy;
            lodash.create = create;
            lodash.curry = curry;
            lodash.curryRight = curryRight;
            lodash.debounce = debounce;
            lodash.defaults = defaults;
            lodash.defaultsDeep = defaultsDeep;
            lodash.defer = defer;
            lodash.delay = delay;
            lodash.difference = difference;
            lodash.differenceBy = differenceBy;
            lodash.differenceWith = differenceWith;
            lodash.drop = drop;
            lodash.dropRight = dropRight;
            lodash.dropRightWhile = dropRightWhile;
            lodash.dropWhile = dropWhile;
            lodash.fill = fill;
            lodash.filter = filter;
            lodash.flatMap = flatMap;
            lodash.flatMapDeep = flatMapDeep;
            lodash.flatMapDepth = flatMapDepth;
            lodash.flatten = flatten;
            lodash.flattenDeep = flattenDeep;
            lodash.flattenDepth = flattenDepth;
            lodash.flip = flip;
            lodash.flow = flow;
            lodash.flowRight = flowRight;
            lodash.fromPairs = fromPairs;
            lodash.functions = functions;
            lodash.functionsIn = functionsIn;
            lodash.groupBy = groupBy;
            lodash.initial = initial;
            lodash.intersection = intersection;
            lodash.intersectionBy = intersectionBy;
            lodash.intersectionWith = intersectionWith;
            lodash.invert = invert;
            lodash.invertBy = invertBy;
            lodash.invokeMap = invokeMap;
            lodash.iteratee = iteratee;
            lodash.keyBy = keyBy;
            lodash.keys = keys;
            lodash.keysIn = keysIn;
            lodash.map = map;
            lodash.mapKeys = mapKeys;
            lodash.mapValues = mapValues;
            lodash.matches = matches;
            lodash.matchesProperty = matchesProperty;
            lodash.memoize = memoize;
            lodash.merge = merge;
            lodash.mergeWith = mergeWith;
            lodash.method = method;
            lodash.methodOf = methodOf;
            lodash.mixin = mixin;
            lodash.negate = negate;
            lodash.nthArg = nthArg;
            lodash.omit = omit;
            lodash.omitBy = omitBy;
            lodash.once = once;
            lodash.orderBy = orderBy;
            lodash.over = over;
            lodash.overArgs = overArgs;
            lodash.overEvery = overEvery;
            lodash.overSome = overSome;
            lodash.partial = partial;
            lodash.partialRight = partialRight;
            lodash.partition = partition;
            lodash.pick = pick;
            lodash.pickBy = pickBy;
            lodash.property = property;
            lodash.propertyOf = propertyOf;
            lodash.pull = pull;
            lodash.pullAll = pullAll;
            lodash.pullAllBy = pullAllBy;
            lodash.pullAllWith = pullAllWith;
            lodash.pullAt = pullAt;
            lodash.range = range;
            lodash.rangeRight = rangeRight;
            lodash.rearg = rearg;
            lodash.reject = reject;
            lodash.remove = remove;
            lodash.rest = rest;
            lodash.reverse = reverse;
            lodash.sampleSize = sampleSize;
            lodash.set = set;
            lodash.setWith = setWith;
            lodash.shuffle = shuffle;
            lodash.slice = slice;
            lodash.sortBy = sortBy;
            lodash.sortedUniq = sortedUniq;
            lodash.sortedUniqBy = sortedUniqBy;
            lodash.split = split;
            lodash.spread = spread;
            lodash.tail = tail;
            lodash.take = take;
            lodash.takeRight = takeRight;
            lodash.takeRightWhile = takeRightWhile;
            lodash.takeWhile = takeWhile;
            lodash.tap = tap;
            lodash.throttle = throttle;
            lodash.thru = thru;
            lodash.toArray = toArray;
            lodash.toPairs = toPairs;
            lodash.toPairsIn = toPairsIn;
            lodash.toPath = toPath;
            lodash.toPlainObject = toPlainObject;
            lodash.transform = transform;
            lodash.unary = unary;
            lodash.union = union;
            lodash.unionBy = unionBy;
            lodash.unionWith = unionWith;
            lodash.uniq = uniq;
            lodash.uniqBy = uniqBy;
            lodash.uniqWith = uniqWith;
            lodash.unset = unset;
            lodash.unzip = unzip;
            lodash.unzipWith = unzipWith;
            lodash.update = update;
            lodash.updateWith = updateWith;
            lodash.values = values;
            lodash.valuesIn = valuesIn;
            lodash.without = without;
            lodash.words = words;
            lodash.wrap = wrap;
            lodash.xor = xor;
            lodash.xorBy = xorBy;
            lodash.xorWith = xorWith;
            lodash.zip = zip;
            lodash.zipObject = zipObject;
            lodash.zipObjectDeep = zipObjectDeep;
            lodash.zipWith = zipWith;
            lodash.entries = toPairs;
            lodash.entriesIn = toPairsIn;
            lodash.extend = assignIn;
            lodash.extendWith = assignInWith;
            mixin(lodash, lodash);
            lodash.add = add;
            lodash.attempt = attempt;
            lodash.camelCase = camelCase;
            lodash.capitalize = capitalize;
            lodash.ceil = ceil;
            lodash.clamp = clamp;
            lodash.clone = clone;
            lodash.cloneDeep = cloneDeep;
            lodash.cloneDeepWith = cloneDeepWith;
            lodash.cloneWith = cloneWith;
            lodash.conformsTo = conformsTo;
            lodash.deburr = deburr;
            lodash.defaultTo = defaultTo;
            lodash.divide = divide;
            lodash.endsWith = endsWith;
            lodash.eq = eq;
            lodash.escape = escape;
            lodash.escapeRegExp = escapeRegExp;
            lodash.every = every;
            lodash.find = find;
            lodash.findIndex = findIndex;
            lodash.findKey = findKey;
            lodash.findLast = findLast;
            lodash.findLastIndex = findLastIndex;
            lodash.findLastKey = findLastKey;
            lodash.floor = floor;
            lodash.forEach = forEach;
            lodash.forEachRight = forEachRight;
            lodash.forIn = forIn;
            lodash.forInRight = forInRight;
            lodash.forOwn = forOwn;
            lodash.forOwnRight = forOwnRight;
            lodash.get = get;
            lodash.gt = gt;
            lodash.gte = gte;
            lodash.has = has;
            lodash.hasIn = hasIn;
            lodash.head = head;
            lodash.identity = identity;
            lodash.includes = includes;
            lodash.indexOf = indexOf;
            lodash.inRange = inRange;
            lodash.invoke = invoke;
            lodash.isArguments = isArguments;
            lodash.isArray = isArray;
            lodash.isArrayBuffer = isArrayBuffer;
            lodash.isArrayLike = isArrayLike;
            lodash.isArrayLikeObject = isArrayLikeObject;
            lodash.isBoolean = isBoolean;
            lodash.isBuffer = isBuffer;
            lodash.isDate = isDate;
            lodash.isElement = isElement;
            lodash.isEmpty = isEmpty;
            lodash.isEqual = isEqual;
            lodash.isEqualWith = isEqualWith;
            lodash.isError = isError;
            lodash.isFinite = isFinite;
            lodash.isFunction = isFunction;
            lodash.isInteger = isInteger;
            lodash.isLength = isLength;
            lodash.isMap = isMap;
            lodash.isMatch = isMatch;
            lodash.isMatchWith = isMatchWith;
            lodash.isNaN = isNaN;
            lodash.isNative = isNative;
            lodash.isNil = isNil;
            lodash.isNull = isNull;
            lodash.isNumber = isNumber;
            lodash.isObject = isObject;
            lodash.isObjectLike = isObjectLike;
            lodash.isPlainObject = isPlainObject;
            lodash.isRegExp = isRegExp;
            lodash.isSafeInteger = isSafeInteger;
            lodash.isSet = isSet;
            lodash.isString = isString;
            lodash.isSymbol = isSymbol;
            lodash.isTypedArray = isTypedArray;
            lodash.isUndefined = isUndefined;
            lodash.isWeakMap = isWeakMap;
            lodash.isWeakSet = isWeakSet;
            lodash.join = join;
            lodash.kebabCase = kebabCase;
            lodash.last = last;
            lodash.lastIndexOf = lastIndexOf;
            lodash.lowerCase = lowerCase;
            lodash.lowerFirst = lowerFirst;
            lodash.lt = lt;
            lodash.lte = lte;
            lodash.max = max;
            lodash.maxBy = maxBy;
            lodash.mean = mean;
            lodash.meanBy = meanBy;
            lodash.min = min;
            lodash.minBy = minBy;
            lodash.stubArray = stubArray;
            lodash.stubFalse = stubFalse;
            lodash.stubObject = stubObject;
            lodash.stubString = stubString;
            lodash.stubTrue = stubTrue;
            lodash.multiply = multiply;
            lodash.nth = nth;
            lodash.noConflict = noConflict;
            lodash.noop = noop;
            lodash.now = now;
            lodash.pad = pad;
            lodash.padEnd = padEnd;
            lodash.padStart = padStart;
            lodash.parseInt = parseInt1;
            lodash.random = random;
            lodash.reduce = reduce;
            lodash.reduceRight = reduceRight;
            lodash.repeat = repeat;
            lodash.replace = replace;
            lodash.result = result;
            lodash.round = round;
            lodash.runInContext = runInContext;
            lodash.sample = sample;
            lodash.size = size;
            lodash.snakeCase = snakeCase;
            lodash.some = some;
            lodash.sortedIndex = sortedIndex;
            lodash.sortedIndexBy = sortedIndexBy;
            lodash.sortedIndexOf = sortedIndexOf;
            lodash.sortedLastIndex = sortedLastIndex;
            lodash.sortedLastIndexBy = sortedLastIndexBy;
            lodash.sortedLastIndexOf = sortedLastIndexOf;
            lodash.startCase = startCase;
            lodash.startsWith = startsWith;
            lodash.subtract = subtract;
            lodash.sum = sum;
            lodash.sumBy = sumBy;
            lodash.template = template;
            lodash.times = times;
            lodash.toFinite = toFinite;
            lodash.toInteger = toInteger;
            lodash.toLength = toLength;
            lodash.toLower = toLower;
            lodash.toNumber = toNumber;
            lodash.toSafeInteger = toSafeInteger;
            lodash.toString = toString;
            lodash.toUpper = toUpper;
            lodash.trim = trim;
            lodash.trimEnd = trimEnd;
            lodash.trimStart = trimStart;
            lodash.truncate = truncate;
            lodash.unescape = unescape;
            lodash.uniqueId = uniqueId;
            lodash.upperCase = upperCase;
            lodash.upperFirst = upperFirst;
            lodash.each = forEach;
            lodash.eachRight = forEachRight;
            lodash.first = head;
            mixin(lodash, function() {
                var source = {};
                baseForOwn(lodash, function(func, methodName) {
                    if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
                });
                return source;
            }(), {
                'chain': false
            });
            lodash.VERSION = VERSION;
            arrayEach([
                'bind',
                'bindKey',
                'curry',
                'curryRight',
                'partial',
                'partialRight'
            ], function(methodName) {
                lodash[methodName].placeholder = lodash;
            });
            arrayEach([
                'drop',
                'take'
            ], function(methodName, index) {
                LazyWrapper.prototype[methodName] = function(n) {
                    n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                    var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                    if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                    else result.__views__.push({
                        'size': nativeMin(n, MAX_ARRAY_LENGTH),
                        'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                    });
                    return result;
                };
                LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                    return this.reverse()[methodName](n).reverse();
                };
            });
            arrayEach([
                'filter',
                'map',
                'takeWhile'
            ], function(methodName, index) {
                var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
                LazyWrapper.prototype[methodName] = function(iteratee) {
                    var result = this.clone();
                    result.__iteratees__.push({
                        'iteratee': getIteratee(iteratee, 3),
                        'type': type
                    });
                    result.__filtered__ = result.__filtered__ || isFilter;
                    return result;
                };
            });
            arrayEach([
                'head',
                'last'
            ], function(methodName, index) {
                var takeName = 'take' + (index ? 'Right' : '');
                LazyWrapper.prototype[methodName] = function() {
                    return this[takeName](1).value()[0];
                };
            });
            arrayEach([
                'initial',
                'tail'
            ], function(methodName, index) {
                var dropName = 'drop' + (index ? '' : 'Right');
                LazyWrapper.prototype[methodName] = function() {
                    return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
                };
            });
            LazyWrapper.prototype.compact = function() {
                return this.filter(identity);
            };
            LazyWrapper.prototype.find = function(predicate) {
                return this.filter(predicate).head();
            };
            LazyWrapper.prototype.findLast = function(predicate) {
                return this.reverse().find(predicate);
            };
            LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
                if (typeof path == 'function') return new LazyWrapper(this);
                return this.map(function(value) {
                    return baseInvoke(value, path, args);
                });
            });
            LazyWrapper.prototype.reject = function(predicate) {
                return this.filter(negate(getIteratee(predicate)));
            };
            LazyWrapper.prototype.slice = function(start, end) {
                start = toInteger(start);
                var result = this;
                if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
                if (start < 0) result = result.takeRight(-start);
                else if (start) result = result.drop(start);
                if (end !== undefined) {
                    end = toInteger(end);
                    result = end < 0 ? result.dropRight(-end) : result.take(end - start);
                }
                return result;
            };
            LazyWrapper.prototype.takeRightWhile = function(predicate) {
                return this.reverse().takeWhile(predicate).reverse();
            };
            LazyWrapper.prototype.toArray = function() {
                return this.take(MAX_ARRAY_LENGTH);
            };
            baseForOwn(LazyWrapper.prototype, function(func, methodName) {
                var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
                if (!lodashFunc) return;
                lodash.prototype[methodName] = function() {
                    var value = this.__wrapped__, args = isTaker ? [
                        1
                    ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                    var interceptor = function(value) {
                        var result = lodashFunc.apply(lodash, arrayPush([
                            value
                        ], args));
                        return isTaker && chainAll ? result[0] : result;
                    };
                    if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) isLazy = useLazy = false;
                    var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                    if (!retUnwrapped && useLazy) {
                        value = onlyLazy ? value : new LazyWrapper(this);
                        var result = func.apply(value, args);
                        result.__actions__.push({
                            'func': thru,
                            'args': [
                                interceptor
                            ],
                            'thisArg': undefined
                        });
                        return new LodashWrapper(result, chainAll);
                    }
                    if (isUnwrapped && onlyLazy) return func.apply(this, args);
                    result = this.thru(interceptor);
                    return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
                };
            });
            arrayEach([
                'pop',
                'push',
                'shift',
                'sort',
                'splice',
                'unshift'
            ], function(methodName) {
                var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
                lodash.prototype[methodName] = function() {
                    var args = arguments;
                    if (retUnwrapped && !this.__chain__) {
                        var value = this.value();
                        return func.apply(isArray(value) ? value : [], args);
                    }
                    return this[chainName](function(value) {
                        return func.apply(isArray(value) ? value : [], args);
                    });
                };
            });
            baseForOwn(LazyWrapper.prototype, function(func, methodName) {
                var lodashFunc = lodash[methodName];
                if (lodashFunc) {
                    var key = lodashFunc.name + '';
                    if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                    realNames[key].push({
                        'name': methodName,
                        'func': lodashFunc
                    });
                }
            });
            realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
                {
                    'name': 'wrapper',
                    'func': undefined
                }
            ];
            LazyWrapper.prototype.clone = lazyClone;
            LazyWrapper.prototype.reverse = lazyReverse;
            LazyWrapper.prototype.value = lazyValue;
            lodash.prototype.at = wrapperAt;
            lodash.prototype.chain = wrapperChain;
            lodash.prototype.commit = wrapperCommit;
            lodash.prototype.next = wrapperNext;
            lodash.prototype.plant = wrapperPlant;
            lodash.prototype.reverse = wrapperReverse;
            lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
            lodash.prototype.first = lodash.prototype.head;
            if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
            return lodash;
        };
        var _ = runInContext();
        if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
            root._ = _;
            define(function() {
                return _;
            });
        } else if (freeModule) {
            (freeModule.exports = _)._ = _;
            freeExports._ = _;
        } else root._ = _;
    }).call(this);
});
parcelRegister("azprR", function(module, exports) {
    $parcel$export(module.exports, "assertResponseIsOk", ()=>$cdf471401ddfc746$export$b3732c8ff6f9c463);
    $parcel$export(module.exports, "toLoading", ()=>$cdf471401ddfc746$export$f9a5bd0ffba29ffc);
    $parcel$export(module.exports, "toError", ()=>$cdf471401ddfc746$export$cc3b967c039ed3e7);
    $parcel$export(module.exports, "toData", ()=>$cdf471401ddfc746$export$24a6b176bdc41ce5);
    const $cdf471401ddfc746$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
            status: status,
            statusText: statusText
        });
    const $cdf471401ddfc746$export$b3732c8ff6f9c463 = (res)=>{
        if (res.ok) return res;
        throw new Error($cdf471401ddfc746$export$18a0019e5439b209(res));
    };
    const $cdf471401ddfc746$export$f9a5bd0ffba29ffc = ()=>({
            isLoading: true,
            data: undefined,
            error: undefined
        });
    const $cdf471401ddfc746$export$cc3b967c039ed3e7 = (error)=>({
            isLoading: false,
            error: error instanceof Error ? error : Error(String(error)),
            data: undefined
        });
    const $cdf471401ddfc746$export$24a6b176bdc41ce5 = (data)=>({
            isLoading: false,
            error: undefined,
            data: data
        });
});
parcelRegister("7PgHB", function(module, exports) {
    $parcel$export(module.exports, "usePlacementApi", ()=>$5453278665841f55$export$201bbce8187a6e3c);
    var $gHZ4O;
    var $aFtXM;
    var $03pZ8;
    var $9uYQQ;
    var $5uXOq = parcelRequire("5uXOq");
    const $5453278665841f55$export$201bbce8187a6e3c = (path, config)=>{
        const { placementId: placementId } = (0, (0, parcelRequire("9uYQQ")).usePlacementContext)();
        const context = (0, (0, parcelRequire("gHZ4O")).usePostOfficeContext)();
        const fetcher = (0, (0, parcelRequire("aFtXM")).usePlacementFetchingContext)();
        const placementApi = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            if (!placementId) return ()=>({
                    isLoading: false,
                    data: undefined,
                    error: new Error('No placementId found, make this is used as a child of PlacementProvider')
                });
            return (0, (0, parcelRequire("03pZ8")).createUsePlacement)(placementId, fetcher);
        }, [
            placementId,
            fetcher
        ]);
        return placementApi(path, context, config?.requestOptions, {
            throttleTime: config?.throttleTime,
            isEnabled: config?.autoRefetch?.isEnabled,
            deps: [
                config?.autoRefetch?.updateKey
            ]
        });
    };
});
parcelRegister("aFtXM", function(module, exports) {
    $parcel$export(module.exports, "usePlacementFetchingContext", ()=>$38d25e0ed05a083e$export$e1e2cdb0425a9fa8);
    $parcel$export(module.exports, "PlacementFetchingProvider", ()=>$38d25e0ed05a083e$export$5f25a6ddf0324fa8);
    var $2OMIu = parcelRequire("2OMIu");
    var $5uXOq = parcelRequire("5uXOq");
    const $38d25e0ed05a083e$export$afec669dc416ee7e = (0, $5uXOq.createContext)({
        fetch: (...args)=>globalThis.fetch(...args)
    });
    const $38d25e0ed05a083e$export$e1e2cdb0425a9fa8 = ()=>(0, $5uXOq.useContext)($38d25e0ed05a083e$export$afec669dc416ee7e);
    const $38d25e0ed05a083e$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
        const value = (0, $5uXOq.useMemo)(()=>({
                fetch: fetch
            }), [
            fetch
        ]);
        return (0, $2OMIu.jsx)($38d25e0ed05a083e$export$afec669dc416ee7e.Provider, {
            value: value,
            children: children
        });
    };
});
parcelRegister("03pZ8", function(module, exports) {
    $parcel$export(module.exports, "createUsePlacement", ()=>$2f9421ba9832c4c5$export$ee1d67e435d25cb5);
    var $iLtrW;
    var $5uXOq = parcelRequire("5uXOq");
    var $5NGOu;
    const $2f9421ba9832c4c5$var$depsIsValid = (deps)=>Array.isArray(deps);
    const $2f9421ba9832c4c5$export$ee1d67e435d25cb5 = (placementId, fetcher = {
        fetch: (...args)=>globalThis.fetch(...args)
    })=>{
        if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
        return (path, context, requestOptions, config)=>{
            const dependencyList = $2f9421ba9832c4c5$var$depsIsValid(config?.deps) ? [
                ...config.deps,
                config?.isEnabled
            ] : [
                path,
                config?.isEnabled
            ];
            const timerRef = (0, $5uXOq.useRef)();
            const isRunningPromise = (0, $5uXOq.useRef)(false);
            (0, $5uXOq.useEffect)(()=>{
                return ()=>{
                    if (timerRef.current) clearTimeout(timerRef.current);
                };
            }, []);
            const promiseToResolve = (0, $5uXOq.useMemo)(()=>{
                if (config?.isEnabled === false) return undefined;
                return ({ signal: signal })=>{
                    if (isRunningPromise.current) return Promise.reject(new (0, (0, parcelRequire("5NGOu")).AlreadyRunningError)());
                    isRunningPromise.current = true;
                    timerRef.current = setTimeout(()=>{
                        isRunningPromise.current = false;
                    }, config?.throttleTime ?? 0);
                    return (0, (0, parcelRequire("iLtrW")).fetchPlacementData)(placementId, path, context, fetcher, {
                        ...requestOptions,
                        signal: signal
                    });
                };
            }, dependencyList);
            return (0, (0, parcelRequire("5NGOu")).useData)(promiseToResolve, {
                analytics: {
                    name: placementId,
                    path: path
                }
            });
        };
    };
});
parcelRegister("iLtrW", function(module, exports) {
    $parcel$export(module.exports, "fetchPlacementData", ()=>$a836ac7667602164$export$ce743d02f83ee521);
    const $a836ac7667602164$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
    const $a836ac7667602164$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
    const $a836ac7667602164$var$stringifyObjectValues = (input)=>{
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, value])=>$a836ac7667602164$var$isNotEmpty(value)).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    };
    const $a836ac7667602164$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
        const defaultHeaders = {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json'
        };
        const normalizedPath = `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
        const contextAsSearchParams = new URLSearchParams($a836ac7667602164$var$stringifyObjectValues(context)).toString();
        const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
        const url = encodeURI(`${$a836ac7667602164$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
        return fetcher.fetch(url, {
            ...requestOptions,
            headers: {
                ...defaultHeaders,
                ...requestOptions?.headers
            }
        });
    };
});
parcelRegister("92Slv", function(module, exports) {
    $parcel$export(module.exports, "scopes", ()=>$55067e880e752544$export$54a06e3f4a159ad8);
    const $55067e880e752544$export$54a06e3f4a159ad8 = [
        {
            name: 'all',
            when: {
                route: {
                    pathname: {
                        matches: '.*'
                    }
                }
            }
        },
        {
            name: 'jira/all',
            when: {
                context: {
                    product: 'jira'
                }
            }
        },
        {
            name: 'jira/kanban',
            when: {
                context: {
                    product: 'jira'
                },
                route: {
                    pathname: {
                        matches: 'boards'
                    }
                }
            }
        },
        {
            name: 'confluence/all',
            when: {
                context: {
                    product: 'confluence'
                }
            }
        },
        {
            name: 'pop3/all',
            when: {
                context: {
                    product: 'pop3'
                }
            }
        },
        {
            name: 'admin/all',
            when: {
                context: {
                    product: 'admin'
                }
            }
        },
        {
            name: 'pop3/send-it',
            when: {
                context: {
                    product: 'pop3'
                },
                route: {
                    pathname: {
                        matches: 'send-it'
                    }
                }
            }
        },
        {
            name: 'admin/products',
            when: {
                context: {
                    product: 'admin'
                },
                route: {
                    pathname: {
                        matches: 'products'
                    }
                }
            }
        },
        {
            name: 'trello/all',
            when: {
                context: {
                    product: 'trello'
                }
            }
        }
    ];
});
parcelRegister("4rq6q", function(module, exports) {
    $parcel$export(module.exports, "MessageRenderer", ()=>$41d16ae43af486d7$export$2df1250b8f917a59);
    var $jOeT9;
    var $dEv4p;
    var $6N5v8;
    var $afxIx;
    var $5o9nW;
    const $41d16ae43af486d7$export$e30378e28ad3e6ab = {
        ...(0, (0, parcelRequire("dEv4p")).default),
        ...(0, (0, parcelRequire("6N5v8")).default),
        ...(0, (0, parcelRequire("afxIx")).default),
        ...(0, (0, parcelRequire("5o9nW")).default)
    };
    const { initializeMessageRenderer: $41d16ae43af486d7$export$bce4e5106d86e473, MessageRenderer: $41d16ae43af486d7$export$2df1250b8f917a59 } = (0, (0, parcelRequire("jOeT9")).asMessageRenderer)($41d16ae43af486d7$export$e30378e28ad3e6ab);
});
parcelRegister("jOeT9", function(module, exports) {
    $parcel$export(module.exports, "asMessageRenderer", ()=>$aac06bc7b75bd846$export$7b7e5a348ef9a7c1);
    var $2OMIu = parcelRequire("2OMIu");
    var $5IPCv;
    var $e8o2I;
    var $5H0An;
    var $7ldM3;
    var $11KUO;
    var $eyw2y;
    var $5uXOq = parcelRequire("5uXOq");
    var $g0Qxc;
    var $emlqA;
    var $k42Hu;
    var $cMrkQ;
    const $aac06bc7b75bd846$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
        const initializeMessageRenderer = ()=>{
            return ({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, ...data })=>{
                const isUFOEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate('enable_ufo_tracking_in_post_office');
                const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $5uXOq.useMemo)(()=>{
                    const messagePerformanceTracker = isUFOEnabled ? new (0, (0, parcelRequire("e8o2I")).UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                    const onMessageSuccess = ()=>{
                        messagePerformanceTracker?.markSuccess();
                    };
                    const markMessageFailed = (onError)=>(error, info)=>{
                            messagePerformanceTracker?.markFailure(error);
                            onError && onError(error, info);
                        };
                    return {
                        markMessageUnmounted: messagePerformanceTracker?.abort,
                        markMessageFailed: markMessageFailed,
                        messageSuccessComponent: (0, $2OMIu.jsx)((0, (0, parcelRequire("k42Hu")).TrackMount), {
                            onMount: onMessageSuccess
                        })
                    };
                }, [
                    messageTemplateId
                ]);
                (0, $5uXOq.useEffect)(()=>{
                    return ()=>{
                        markMessageUnmounted?.();
                    };
                }, [
                    markMessageUnmounted
                ]);
                const Core = ()=>{
                    const Component = messageComponents?.[messageTemplateId];
                    if (!Component) throw new (0, (0, parcelRequire("7ldM3")).InvalidMessageTemplateIdError)(JSON.stringify({
                        messageTemplateId: messageTemplateId,
                        messageInstanceId: messageInstanceId
                    }));
                    let validatedMessage;
                    if (messageValidator) {
                        validatedMessage = messageValidator(data);
                        if (!validatedMessage) throw new (0, (0, parcelRequire("7ldM3")).MessageRendererEmptyValidationResponseError)();
                    }
                    const loadingComponent = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? (0, $2OMIu.jsx)((0, (0, parcelRequire("5H0An")).UFOv2).UFOLoadHold, {
                            name: (0, (0, parcelRequire("5H0An")).UFOv2).HoldNames.MESSAGE,
                            children: loadingFallback ?? null
                        }) : (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                            children: loadingFallback ?? null
                        }), [
                        loadingFallback,
                        isUFOEnabled
                    ]);
                    const componentProps = messageValidator ? validatedMessage : data;
                    if (!Component) return null;
                    return (0, $2OMIu.jsx)((0, (0, parcelRequire("g0Qxc")).ChoreographerWrapper), {
                        messageId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        messageCategory: messageCategory,
                        children: (0, $2OMIu.jsx)($aac06bc7b75bd846$var$FeatureFlaggedUfoWrapper, {
                            messageTemplateId: messageTemplateId,
                            isEnabled: isUFOEnabled,
                            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("11KUO")).MessageContextProvider), {
                                value: {
                                    messageInstanceId: messageInstanceId,
                                    messageTemplateId: messageTemplateId,
                                    triggerId: triggerId,
                                    messageCreationType: messageCreationType,
                                    transactionAccountId: componentProps.transactionAccountId,
                                    analyticsDetails: postOffice?.analyticsDetails
                                },
                                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("eyw2y")).RecommendationProvider), {
                                    value: recommendationSession ?? {},
                                    children: (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                                        fallback: loadingComponent,
                                        children: (0, $2OMIu.jsxs)((0, (0, parcelRequire("emlqA")).MessageAnalyticsContextProvider), {
                                            children: [
                                                messageSuccessComponent,
                                                (0, $2OMIu.jsx)(Component, {
                                                    ...componentProps
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    });
                };
                return (0, (0, parcelRequire("cMrkQ")).withErrorBoundary)(Core)({
                    errorBoundaryLocation: 'placement-message-renderer-component',
                    fallbackRender: fallbackRender,
                    onError: markMessageFailed(onError)
                });
            };
        };
        return {
            initializeMessageRenderer: initializeMessageRenderer,
            MessageRenderer: initializeMessageRenderer()
        };
    };
    const $aac06bc7b75bd846$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
        if (isEnabled) return (0, $2OMIu.jsx)((0, (0, parcelRequire("5H0An")).UFOv2).UFOSegment, {
            name: (0, (0, parcelRequire("5H0An")).UFOv2).SegmentNames.MESSAGE,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("5H0An")).UFOv2).UFOSegment, {
                name: `${(0, (0, parcelRequire("5H0An")).UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
                children: children
            })
        });
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("e8o2I", function(module, exports) {
    $parcel$export(module.exports, "UFOv1", ()=>$a466d65029d54037$export$96236906ebaa7f87);
    var $l3Xnu;
    var $54QtS;
    const $a466d65029d54037$export$96236906ebaa7f87 = {
        MessagePerformanceTracker: (0, parcelRequire("l3Xnu")).MessagePerformanceTracker,
        PlacementPerformanceTracker: (0, parcelRequire("54QtS")).PlacementPerformanceTracker
    };
});
parcelRegister("l3Xnu", function(module, exports) {
    $parcel$export(module.exports, "MessagePerformanceTracker", ()=>$a3763ad05a43d408$export$ae5c73c7c4f454e6);
    var $atdLB;
    var $duUGa;
    var $eAOqW;
    class $a3763ad05a43d408$export$ae5c73c7c4f454e6 {
        constructor(messageTemplateId){
            this.metadata = {};
            this.markSuccess = ()=>{
                for (const experience of this.experiences)experience.success({
                    metadata: this.metadata
                });
            };
            this.markFailure = (error)=>{
                for (const experience of this.experiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.abort = ()=>{
                for (const experience of this.experiences)experience.abort({
                    metadata: this.metadata
                });
            };
            this.aggregatedExperience = new (0, (0, parcelRequire("duUGa")).UFOExperience)((0, (0, parcelRequire("eAOqW")).UFOExperienceNames).MESSAGE, {
                performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad,
                type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
                platform: {
                    component: (0, (0, parcelRequire("eAOqW")).POST_OFFICE_PLATFORM_NAME)
                }
            });
            this.messageSpecificExperience = new (0, (0, parcelRequire("duUGa")).UFOExperience)(`${(0, (0, parcelRequire("eAOqW")).UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
                performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad,
                type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
                platform: {
                    component: (0, (0, parcelRequire("eAOqW")).POST_OFFICE_PLATFORM_NAME)
                }
            });
            this.experiences = [
                this.aggregatedExperience,
                this.messageSpecificExperience
            ];
            this.experiences.forEach((experience)=>experience.start());
            this.metadata = {
                messageTemplateId: messageTemplateId
            };
        }
    }
});
parcelRegister("eAOqW", function(module, exports) {
    $parcel$export(module.exports, "UFOExperienceNames", ()=>$bb03824d593f40fc$export$cc7ddf8ca628f6f1);
    $parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", ()=>$bb03824d593f40fc$export$6d482cfa20c9d220);
    const $bb03824d593f40fc$export$cc7ddf8ca628f6f1 = {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    };
    const $bb03824d593f40fc$export$6d482cfa20c9d220 = 'post-office';
});
parcelRegister("54QtS", function(module, exports) {
    $parcel$export(module.exports, "PlacementPerformanceTracker", ()=>$7a667d0616a9ade0$export$8b48c2105ba0b35a);
    var $atdLB;
    var $duUGa;
    var $eAOqW;
    const $7a667d0616a9ade0$var$STEPS = {
        RML_FETCH: 'rml-fetch',
        RML_RENDER: 'rml-render',
        INITIAL_DATA: 'initial-data-load',
        COMPONENT_READY: 'component-ready'
    };
    const $7a667d0616a9ade0$var$UFO_EXPERIENCE_CONFIG = {
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad,
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        platform: {
            component: (0, (0, parcelRequire("eAOqW")).POST_OFFICE_PLATFORM_NAME)
        },
        timings: [
            {
                key: `${$7a667d0616a9ade0$var$STEPS.RML_FETCH}-complete`,
                endMark: `${$7a667d0616a9ade0$var$STEPS.RML_FETCH}-complete`
            },
            {
                key: `${$7a667d0616a9ade0$var$STEPS.RML_RENDER}-complete`,
                endMark: `${$7a667d0616a9ade0$var$STEPS.RML_RENDER}-complete`
            },
            {
                key: `${$7a667d0616a9ade0$var$STEPS.INITIAL_DATA}-complete`,
                endMark: `${$7a667d0616a9ade0$var$STEPS.INITIAL_DATA}-complete`
            },
            {
                key: `${$7a667d0616a9ade0$var$STEPS.INITIAL_DATA}-error`,
                endMark: `${$7a667d0616a9ade0$var$STEPS.INITIAL_DATA}-error`
            }
        ]
    };
    class $7a667d0616a9ade0$export$8b48c2105ba0b35a {
        constructor(placementId, consumptionType = 'remote'){
            this.placementExperiences = [];
            this.metadata = {};
            this.markFetchComplete = ()=>{
                for (const experience of this.placementExperiences)experience.mark(`${$7a667d0616a9ade0$var$STEPS.RML_FETCH}-complete`);
            };
            this.markRenderComplete = ()=>{
                for (const experience of this.placementExperiences)experience.mark(`${$7a667d0616a9ade0$var$STEPS.RML_RENDER}-complete`);
            };
            this.markInitialDataComplete = ()=>{
                for (const experience of this.placementExperiences)experience.mark(`${$7a667d0616a9ade0$var$STEPS.INITIAL_DATA}-complete`);
            };
            this.markComponentReady = ()=>{
                for (const experience of this.placementExperiences)experience.success({
                    metadata: this.metadata
                });
            };
            this.markFetchFailure = (error)=>{
                for (const experience of this.placementExperiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        failedDuring: $7a667d0616a9ade0$var$STEPS.RML_FETCH,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.markRenderFailure = (error)=>{
                for (const experience of this.placementExperiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        failedDuring: $7a667d0616a9ade0$var$STEPS.RML_RENDER,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.markInitialDataFailure = (_)=>{
                for (const experience of this.placementExperiences)experience.mark(`${$7a667d0616a9ade0$var$STEPS.INITIAL_DATA}-error`);
            };
            this.markComponentFailure = (error)=>{
                for (const experience of this.placementExperiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        failedDuring: $7a667d0616a9ade0$var$STEPS.COMPONENT_READY,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.markComponentAborted = ()=>{
                for (const experience of this.placementExperiences)experience.abort({
                    metadata: this.metadata
                });
            };
            this.aggregatedExperience = new (0, (0, parcelRequire("duUGa")).UFOExperience)((0, (0, parcelRequire("eAOqW")).UFOExperienceNames).PLACEMENT, $7a667d0616a9ade0$var$UFO_EXPERIENCE_CONFIG);
            this.placementSpecificExperience = new (0, (0, parcelRequire("duUGa")).UFOExperience)(`${(0, (0, parcelRequire("eAOqW")).UFOExperienceNames).PLACEMENT}.${placementId}`, $7a667d0616a9ade0$var$UFO_EXPERIENCE_CONFIG);
            this.placementExperiences = [
                this.aggregatedExperience,
                this.placementSpecificExperience
            ];
            for (const experience of this.placementExperiences)experience.start();
            this.metadata = {
                placementId: placementId,
                consumptionType: consumptionType
            };
        }
    }
});
parcelRegister("7ldM3", function(module, exports) {
    $parcel$export(module.exports, "InvalidMessageTemplateIdError", ()=>$f5a4f751215d8970$export$19cb89dd679394cb);
    $parcel$export(module.exports, "MessageRendererEmptyValidationResponseError", ()=>$f5a4f751215d8970$export$3dfc27a8d3942f4d);
    var $f5a4f751215d8970$export$b9722560029694e7;
    (function(PostOfficeErrorCodes) {
        PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
        PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
        PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
        PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
        PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
        PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
        PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
        PostOfficeErrorCodes["HandlerValidationError"] = "HandlerValidationError";
        PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
        PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
        PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
        PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
        PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
        PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
        PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
        PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
        PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
        PostOfficeErrorCodes["UnsupportedEmailError"] = "UnsupportedEmailError";
        PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
        PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
        PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
        PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
        PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
        PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
        PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
        PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
        PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
        PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
        PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
        PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
        PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
        PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
        PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
        PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    })($f5a4f751215d8970$export$b9722560029694e7 || ($f5a4f751215d8970$export$b9722560029694e7 = {}));
    class $f5a4f751215d8970$export$46f86d28cd0a5d38 extends Error {
    }
    class $f5a4f751215d8970$export$627bc00a5ef5f6ae extends Error {
    }
    class $f5a4f751215d8970$export$d145ea5319863172 extends Error {
        constructor(message, code){
            super(message), this.code = code;
        }
    }
    class $f5a4f751215d8970$export$f649da38897d27f7 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$c2852c1c4d9aba3e extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "RecipientExpansionProcessingError"), this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$4b7b4e09547e4bb3 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "RecipientExpansionMethodInvocationError"), this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$360a094a97597d87 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message){
            super(message, "RecipientExpansionManagerError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$4d068b43eb55165b extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$ac007ee150add337 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message){
            super(message, "ReceiverInputValidationError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$b79ba63f8ae791e0 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message){
            super(message, "HandlerValidationError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$19cb89dd679394cb extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message){
            super(message, "InvalidMessageTemplateIdError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$78651662ad470cc5 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Message Template not found', "MessageTemplateNotFoundError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$913b8e68dc7ae8fe extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Placement not found', "PlacementNotFoundError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$3dfc27a8d3942f4d extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$e5ccdf8bbfead7a2 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Failed to send some events', "IngestionHandlerFailedSendError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$823733742d803ae6 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Failed to send some events', "OrchestrationHandlerFailedSendError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$a6f2aad8fa094b39 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(accountId){
            super('Unable to get user details for the given account ID', "UnableToGetUserDetailsError"), this.accountId = accountId;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$2f1e27130c2bf271 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, payloadSize){
            super(message, "InvalidPayloadError");
            this.name = this.constructor.name;
            this.payloadSize = payloadSize;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$d0dc094613469f2b extends $f5a4f751215d8970$export$46f86d28cd0a5d38 {
        constructor(message, workspaceId){
            super(message);
            this.name = this.constructor.name;
            this.workspaceId = workspaceId;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$5603eab37ce562f5 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(fileType){
            super('The attachment file is not supported', "UnsupportedAttachmentType");
            this.name = this.constructor.name;
            this.fileType = fileType;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$b35ca1cf49054efc extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, email){
            super(message, "UnsupportedEmailError");
            this.name = this.constructor.name;
            this.email = email;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$e0e9aa0e9c6b37ff extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, error){
            super(message, "InvalidEmailRequestHeader");
            this.name = this.constructor.name;
            this.error = error;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$3ad818f64601e141 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message){
            super(message, "NonProdEmailDomainError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$25470bb6cba4fba0 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
            super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
            this.name = this.constructor.name;
            this.messageTemplateId = messageTemplateId;
            this.placementId = placementId;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$ce14d445679448b6 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
            super(error?.message ?? 'unknown error', "HydrationFailureAtPlacementError");
            this.name = this.constructor.name;
            this.messageTemplateId = messageTemplateId;
            this.messageInstanceId = messageInstanceId;
            this.placementId = placementId;
            this.stack = error?.stack;
        }
    }
    class $f5a4f751215d8970$export$c9a26a17db1045c8 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor({ placementId: placementId }){
            super('All messages failed at placement', "AllMessagesFailureHydrationAtPlacementError");
            this.name = this.constructor.name;
            this.placementId = placementId;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$8ab4fb362168b928 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$2afd69f57fe5285f extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(){
            super('Recipient expander not found for mapper', "UnusedValidateError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$7635d2b1a281d626 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, errors){
            super(message, "GrowthRecRecommendationsError");
            this.errors = errors;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$9e1c6d00e675bc86 extends $f5a4f751215d8970$export$d145ea5319863172 {
        constructor(message, recipient){
            super(message, "RichRecipientError");
            this.name = this.constructor.name;
            this.recipient = recipient;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$90bef7fa95eca3fa extends Error {
        constructor(status){
            super('Posting Mobile Notifications message failed'), this.status = status;
            this.status = status;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$6d1a4929f6ff1a32 extends $f5a4f751215d8970$export$46f86d28cd0a5d38 {
        constructor(message){
            super(message);
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$89bf5f64fbf0698 extends $f5a4f751215d8970$export$46f86d28cd0a5d38 {
        constructor(message, error){
            super(message, {
                ...error ? {
                    cause: error
                } : {}
            }), this.error = error;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$c19fc5e8aa4e064d extends Error {
        constructor(){
            super('Ingestion source is required when custom profile is specified');
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$2d3a68dab93b8cc4 extends Error {
        constructor(){
            super('A renderRedacted function is required when redactionLevel is set to a non-null value');
            this.name = this.constructor.name;
        }
    }
    class $f5a4f751215d8970$export$175c1dbb0d7c238a extends Error {
        constructor(status){
            super('Enqueueing email failed'), this.status = status;
            this.status = status;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$23fab744b3076342 extends Error {
        constructor(message, status){
            super(message), this.message = message, this.status = status;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f5a4f751215d8970$export$194adecfa0265ea1 extends Error {
        constructor(msg, messageInstanceId, error){
            super(msg);
            this.msg = msg;
            this.messageInstanceId = messageInstanceId;
            if (error instanceof Error) this.stack = error.stack;
            else Error.captureStackTrace(this, this.constructor);
            this.name = this.constructor.name;
        }
    }
});
parcelRegister("11KUO", function(module, exports) {
    $parcel$export(module.exports, "MessageContextProvider", ()=>$2682dcdca1a24b7e$export$42de33f7652dc3de);
    $parcel$export(module.exports, "useMessageContext", ()=>$2682dcdca1a24b7e$export$a5b6d14a2e25725a);
    var $5uXOq = parcelRequire("5uXOq");
    const $2682dcdca1a24b7e$var$initialValue = {};
    const $2682dcdca1a24b7e$export$b060d577040138d8 = (0, $5uXOq.createContext)($2682dcdca1a24b7e$var$initialValue);
    const $2682dcdca1a24b7e$export$42de33f7652dc3de = $2682dcdca1a24b7e$export$b060d577040138d8.Provider;
    const $2682dcdca1a24b7e$export$a5b6d14a2e25725a = ()=>(0, $5uXOq.useContext)($2682dcdca1a24b7e$export$b060d577040138d8);
});
parcelRegister("eyw2y", function(module, exports) {
    $parcel$export(module.exports, "RecommendationProvider", ()=>$52375d85c83d9b1b$export$f60e87d7b5f59562);
    $parcel$export(module.exports, "useRecommendationContext", ()=>$52375d85c83d9b1b$export$3321c0b02f750bcc);
    var $2OMIu = parcelRequire("2OMIu");
    var $daJ0i;
    var $5uXOq = parcelRequire("5uXOq");
    const $52375d85c83d9b1b$export$ba2f44035effd9c1 = (0, $5uXOq.createContext)({
        sessionId: undefined,
        entityId: undefined
    });
    const $52375d85c83d9b1b$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
        return (0, $2OMIu.jsx)($52375d85c83d9b1b$export$ba2f44035effd9c1.Provider, {
            value: value,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("daJ0i")).default), {
                data: value,
                children: children
            })
        });
    };
    const $52375d85c83d9b1b$export$3321c0b02f750bcc = ()=>(0, $5uXOq.useContext)($52375d85c83d9b1b$export$ba2f44035effd9c1);
});
parcelRegister("g0Qxc", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerWrapper", ()=>$cfeb2bccb040087b$export$8db7ba034addcd65);
    var $2OMIu = parcelRequire("2OMIu");
    var $5IPCv;
    var $h3mjV;
    var $5uXOq = parcelRequire("5uXOq");
    var $8IVWW;
    const $cfeb2bccb040087b$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
        const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
        const shouldRender = useChoreographedRender({
            messageId: messageId
        });
        if (shouldRender) return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
        return null;
    };
    const $cfeb2bccb040087b$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
        const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, (0, parcelRequire("8IVWW")).useChoreographerContext)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("h3mjV")).useFirePostOfficeAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            const isTrackingChoreographedPostOfficeMessagesEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate('enable_tracking_choreographed_post_office_messages');
            if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
                eventType: 'operational',
                action: 'maybeChoreographed',
                actionSubject: 'postOfficeMessage'
            }, {
                messageTemplateId: messageTemplateId,
                messageCategory: messageCategory
            });
        }, [
            fireAnalyticsEvent
        ]);
        const isChoreographedPostOfficeMessagesEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate('enable_choreographed_post_office_messages');
        if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled && factory) {
            const { shouldBeChoreographed: shouldBeChoreographed } = factory;
            const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
            if (shouldBeChoreographed({
                messageType: messageType
            })) return (0, $2OMIu.jsx)($cfeb2bccb040087b$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: messageId,
                children: children
            });
        }
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("emlqA", function(module, exports) {
    $parcel$export(module.exports, "MessageAnalyticsContextProvider", ()=>$26dd6a326ae10221$export$1737ab199e83455e);
    $parcel$export(module.exports, "useMessageAnalyticsContext", ()=>$26dd6a326ae10221$export$bb426ba114b64992);
    var $2OMIu = parcelRequire("2OMIu");
    var $5uXOq = parcelRequire("5uXOq");
    const $26dd6a326ae10221$var$defaultMessageAnalyticsContextValue = {
        fireMessageViewedInMessageComponent: null,
        setFireMessageViewedInMessageComponent: ()=>{}
    };
    const $26dd6a326ae10221$export$c81717973c6c4a90 = (0, $5uXOq.createContext)($26dd6a326ae10221$var$defaultMessageAnalyticsContextValue);
    const $26dd6a326ae10221$export$1737ab199e83455e = ({ children: children })=>{
        const fireMessageViewedInMessageComponent = (0, $5uXOq.useRef)(false);
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
                setFireMessageViewedInMessageComponent: (value)=>{
                    fireMessageViewedInMessageComponent.current = value;
                }
            }), [
            fireMessageViewedInMessageComponent
        ]);
        return (0, $2OMIu.jsx)($26dd6a326ae10221$export$c81717973c6c4a90.Provider, {
            value: contextValue,
            children: children
        });
    };
    const $26dd6a326ae10221$export$bb426ba114b64992 = ()=>(0, $5uXOq.useContext)($26dd6a326ae10221$export$c81717973c6c4a90);
});
parcelRegister("dEv4p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1928860e82ae4db6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1928860e82ae4db6$export$2e2bcd8739ae039 = {
        'marketing-screen-space-flag-contentful-usecase': (0, $5uXOq.lazy)(()=>(parcelRequire("hzf0p")))
    };
});
parcelRegister("hzf0p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("55CDW")
    ]).then(()=>parcelRequire('e8Z1Y'));
});
parcelRegister("6N5v8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$506ff5bfe8eed3eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $506ff5bfe8eed3eb$export$2e2bcd8739ae039 = {
        'end-of-trial-extension': (0, $5uXOq.lazy)(()=>(parcelRequire("8Z5Ht")))
    };
});
parcelRegister("8Z5Ht", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cNoSs").then(()=>parcelRequire('bTxkC'));
});
parcelRegister("afxIx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa7dbabece5cd8be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aa7dbabece5cd8be$export$2e2bcd8739ae039 = {
        'message-template-template': (0, $5uXOq.lazy)(()=>(parcelRequire("3gaC1")))
    };
});
parcelRegister("3gaC1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ehn1n").then(()=>parcelRequire('ilWOk'));
});
parcelRegister("5o9nW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$919ec0634b70ec5a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $919ec0634b70ec5a$export$2e2bcd8739ae039 = {
        'test-message-inapp': (0, $5uXOq.lazy)(()=>(parcelRequire("95qcr"))),
        'test-message-inapp-implicit-pendo': (0, $5uXOq.lazy)(()=>(parcelRequire("2MtFK")))
    };
});
parcelRegister("95qcr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("93IDB").then(()=>parcelRequire('kM8wR'));
});
parcelRegister("2MtFK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("717m6").then(()=>parcelRequire('chIH8'));
});
const $f6721478b0b83c9a$export$a5cfae247d8360ef = 'screen-space-flags';
parcelRegister("3p8Nq", function(module, exports) {
    $parcel$export(module.exports, "withScreenSpaceFlagsIntlProvider", ()=>$12221ebf84dcb54e$export$b0eee5de066b2bf5);
    var $9AXHJ;
    var $a0X9c;
    var $ccMmr;
    var $gWg7c;
    var $cENg4;
    const $12221ebf84dcb54e$var$loadMessagesByTeam = async (locale)=>{
        return Promise.allSettled([
            (0, (0, parcelRequire("a0X9c")).messagesLoader)(locale),
            (0, (0, parcelRequire("ccMmr")).messagesLoader)(locale),
            (0, (0, parcelRequire("gWg7c")).messagesLoader)(locale),
            (0, (0, parcelRequire("cENg4")).messagesLoader)(locale)
        ]).then((results)=>{
            return results.reduce((acc, result)=>{
                if (result.status === 'fulfilled') return {
                    messages: {
                        ...acc.messages,
                        ...result.value
                    },
                    errors: [
                        ...acc.errors
                    ]
                };
                else if (result.status === 'rejected') return {
                    messages: {
                        ...acc.messages
                    },
                    errors: [
                        ...acc.errors,
                        `Failed to load translations with ${result.reason}`
                    ]
                };
                return acc;
            }, {
                messages: {},
                errors: []
            });
        });
    };
    const $12221ebf84dcb54e$export$b0eee5de066b2bf5 = (Component)=>{
        return (0, (0, parcelRequire("9AXHJ")).withIntlProvider)({
            messagesLoader: $12221ebf84dcb54e$var$loadMessagesByTeam
        }, Component);
    };
});
parcelRegister("9AXHJ", function(module, exports) {
    $parcel$export(module.exports, "withIntlProvider", ()=>$e955fa14362f80b1$export$a5d940130f33be3f);
    var $2OMIu = parcelRequire("2OMIu");
    var $jeRgx;
    const $e955fa14362f80b1$export$a5d940130f33be3f = (intlProviderProps, Component)=>(props)=>(0, $2OMIu.jsx)((0, (0, parcelRequire("jeRgx")).default), {
                ...intlProviderProps,
                children: (0, $2OMIu.jsx)(Component, {
                    ...props
                })
            });
});
parcelRegister("jeRgx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8801040350808fa1$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $h3mjV;
    var $i5FdW;
    var $koVbs;
    var $94Wuv;
    function $8801040350808fa1$var$useFetchLocale() {
        let locale = 'en';
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("h3mjV")).useFirePostOfficeAnalyticsEvents)();
        try {
            const { locale: intlLocale } = (0, (0, parcelRequire("koVbs")).default)();
            locale = intlLocale;
        } catch (err) {
            fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlProvider',
                eventType: 'operational',
                attributes: {
                    errorMessage: err
                }
            });
        }
        return {
            locale: locale
        };
    }
    function $8801040350808fa1$export$2e2bcd8739ae039(props) {
        const { locale: locale } = $8801040350808fa1$var$useFetchLocale();
        const messages = (0, (0, parcelRequire("94Wuv")).useIntlMessages)(locale, props.messagesLoader);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("i5FdW")).default), {
            locale: locale,
            messages: messages,
            children: props.children
        });
    }
});
parcelRegister("94Wuv", function(module, exports) {
    $parcel$export(module.exports, "useIntlMessages", ()=>$7ff04099e58be4b7$export$2641ec9a2025a81f);
    var $h3mjV;
    var $5uXOq = parcelRequire("5uXOq");
    const $7ff04099e58be4b7$export$2641ec9a2025a81f = (locale, messageLoader)=>{
        const [messages, setMessages] = (0, $5uXOq.useState)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("h3mjV")).useFirePostOfficeAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            messageLoader(locale).then((loadedMessages)=>{
                if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
                if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                    action: 'errored',
                    actionSubject: 'intlMessagesLoader',
                    eventType: 'operational',
                    attributes: {
                        locale: locale,
                        errorMessage: loadedMessages.errors
                    }
                });
            }).catch(console.error);
        }, [
            locale
        ]);
        return messages;
    };
});
parcelRegister("a0X9c", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$6a9ce369e7a17aa9$export$720676d8cac8fbb);
    var $bVbzx;
    var $euiLX;
    const $6a9ce369e7a17aa9$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;
    const $6a9ce369e7a17aa9$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("euiLX")).default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("8b0IF")));
            case 'da':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("5Y75d")));
            case 'de':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("dDxcV")));
            case 'en-GB':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("61jFB")));
            case 'en-US':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("3EkH2")));
            case 'en-XA':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("e6Skz")));
            case 'en-XB':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("eXG31")));
            case 'en-ZZ':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("3jJ8e")));
            case 'en':
                return $6a9ce369e7a17aa9$var$importHelper(await Promise.resolve((parcelRequire("bVbzx"))));
            case 'es':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("598Uj")));
            case 'et':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("ds8cm")));
            case 'fi':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("1whY3")));
            case 'fr':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("fDmLN")));
            case 'hu':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("2B4F5")));
            case 'it':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("4BSvs")));
            case 'ja':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("9Elub")));
            case 'ko':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("mdX0k")));
            case 'nb':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("jaO95")));
            case 'nl':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("dMOYG")));
            case 'pl':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("6Gsvm")));
            case 'pt-BR':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("eCkkK")));
            case 'ro':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("W6EyM")));
            case 'ru':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("2snL7")));
            case 'sv':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("8dzkr")));
            case 'th':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("jdB93")));
            case 'tr':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("47O3M")));
            case 'uk':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("cdQVu")));
            case 'vi':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("4jWs9")));
            case 'zh-CN':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("jheo3")));
            case 'zh-TW':
                return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("27r8n")));
            default:
                return 0, ($parcel$interopDefault((0, parcelRequire("bVbzx"))));
        }
    };
});
parcelRegister("bVbzx", function(module, exports) {
    module.exports = JSON.parse("{}");
});
parcelRegister("8b0IF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hc5RF").then(()=>parcelRequire('8mqjG'));
});
parcelRegister("5Y75d", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1OzF3").then(()=>parcelRequire('jMhDj'));
});
parcelRegister("dDxcV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fhoZv").then(()=>parcelRequire('37saP'));
});
parcelRegister("61jFB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("k8Maf").then(()=>parcelRequire('ih0Zd'));
});
parcelRegister("3EkH2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ka4Zj").then(()=>parcelRequire('7glfV'));
});
parcelRegister("e6Skz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fKDnI").then(()=>parcelRequire('7vTP9'));
});
parcelRegister("eXG31", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ebvcb").then(()=>parcelRequire('6TjtY'));
});
parcelRegister("3jJ8e", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("abSwS").then(()=>parcelRequire('4oNEQ'));
});
parcelRegister("598Uj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5JmDT").then(()=>parcelRequire('kyM33'));
});
parcelRegister("ds8cm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2Sm5d").then(()=>parcelRequire('6bkWH'));
});
parcelRegister("1whY3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ilfnk").then(()=>parcelRequire('aoAHS'));
});
parcelRegister("fDmLN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("71uxM").then(()=>parcelRequire('3MBkB'));
});
parcelRegister("2B4F5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eyrUE").then(()=>parcelRequire('5pE8G'));
});
parcelRegister("4BSvs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d0Pdj").then(()=>parcelRequire('as6ve'));
});
parcelRegister("9Elub", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jKeM3").then(()=>parcelRequire('fPj8Q'));
});
parcelRegister("mdX0k", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1aIVe").then(()=>parcelRequire('3wJyD'));
});
parcelRegister("jaO95", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hXjSJ").then(()=>parcelRequire('ephQP'));
});
parcelRegister("dMOYG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2mCCL").then(()=>parcelRequire('lsvvG'));
});
parcelRegister("6Gsvm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3yZih").then(()=>parcelRequire('eX12q'));
});
parcelRegister("eCkkK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("enFnZ").then(()=>parcelRequire('dFIAI'));
});
parcelRegister("W6EyM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("anuNI").then(()=>parcelRequire('jZfiR'));
});
parcelRegister("2snL7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gUMZN").then(()=>parcelRequire('9afPo'));
});
parcelRegister("8dzkr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9wWtx").then(()=>parcelRequire('daUsC'));
});
parcelRegister("jdB93", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("h2kXR").then(()=>parcelRequire('ei7L7'));
});
parcelRegister("47O3M", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eyhw3").then(()=>parcelRequire('ahyTy'));
});
parcelRegister("cdQVu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("caAge").then(()=>parcelRequire('c14L5'));
});
parcelRegister("4jWs9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8ZIAm").then(()=>parcelRequire('7zIUv'));
});
parcelRegister("jheo3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f9GdA").then(()=>parcelRequire('aw2dk'));
});
parcelRegister("27r8n", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("O040l").then(()=>parcelRequire('iy5Tj'));
});
parcelRegister("ccMmr", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$0e1b7175a65b8346$export$720676d8cac8fbb);
    var $btrK6;
    var $euiLX;
    const $0e1b7175a65b8346$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;
    const $0e1b7175a65b8346$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("euiLX")).default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("31p1p")));
            case 'da':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("kFGiF")));
            case 'de':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("8yvk4")));
            case 'en-GB':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("60JCr")));
            case 'en-US':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("iC9PV")));
            case 'en-XA':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("dFXwq")));
            case 'en-XB':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("ayIY0")));
            case 'en-ZZ':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("ga7ut")));
            case 'en':
                return $0e1b7175a65b8346$var$importHelper(await Promise.resolve((parcelRequire("btrK6"))));
            case 'es':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("5XqOC")));
            case 'et':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("cCDLX")));
            case 'fi':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("7CWJy")));
            case 'fr':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("dTOe8")));
            case 'hu':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("hARwa")));
            case 'it':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("jRMMF")));
            case 'ja':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("6XdTA")));
            case 'ko':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("jJLpa")));
            case 'nb':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("1eLd5")));
            case 'nl':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("hMflp")));
            case 'pl':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("6Qsx1")));
            case 'pt-BR':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("dRbYW")));
            case 'ro':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("7JFr6")));
            case 'ru':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("iyJG2")));
            case 'sv':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("IJFKr")));
            case 'th':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("6lmFO")));
            case 'tr':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("bDnE3")));
            case 'uk':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("2eaO0")));
            case 'vi':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("k45Zp")));
            case 'zh-CN':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("9q3Te")));
            case 'zh-TW':
                return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("gAZbu")));
            default:
                return 0, ($parcel$interopDefault((0, parcelRequire("btrK6"))));
        }
    };
});
parcelRegister("btrK6", function(module, exports) {
    module.exports = JSON.parse("{\"playground.playground-local-execution-message.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"playground.playground-local-execution-message.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"playground.playground-local-execution-message.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hello, fellow child \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"playground.playground-local-execution-message.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"We are currently trying to locally execute this message!\"}],\"playground.playground-local-execution-message.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Playground Team\"}],\"playground.playground-local-execution-message.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"playground.playground-local-execution-message.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.playground.go-faster-techops-rollup-notifier.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.playground.test-playground-message.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");
});
parcelRegister("31p1p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2ivje").then(()=>parcelRequire('jSybN'));
});
parcelRegister("kFGiF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4brur").then(()=>parcelRequire('iRglU'));
});
parcelRegister("8yvk4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hSdiH").then(()=>parcelRequire('4DMt9'));
});
parcelRegister("60JCr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ekFSs").then(()=>parcelRequire('4Ntcv'));
});
parcelRegister("iC9PV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dYXyc").then(()=>parcelRequire('liA2E'));
});
parcelRegister("dFXwq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aSeUm").then(()=>parcelRequire('cJsXX'));
});
parcelRegister("ayIY0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gEUgW").then(()=>parcelRequire('1pDJK'));
});
parcelRegister("ga7ut", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7g90v").then(()=>parcelRequire('tSzJa'));
});
parcelRegister("5XqOC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5c7we").then(()=>parcelRequire('8Nmv9'));
});
parcelRegister("cCDLX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2yWLa").then(()=>parcelRequire('jffUe'));
});
parcelRegister("7CWJy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lBdH7").then(()=>parcelRequire('lxOjW'));
});
parcelRegister("dTOe8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3y5RX").then(()=>parcelRequire('83SWF'));
});
parcelRegister("hARwa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2lusW").then(()=>parcelRequire('feXvC'));
});
parcelRegister("jRMMF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ehlxk").then(()=>parcelRequire('43hwo'));
});
parcelRegister("6XdTA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lefNR").then(()=>parcelRequire('1sa5w'));
});
parcelRegister("jJLpa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("RJRuz").then(()=>parcelRequire('5vxzP'));
});
parcelRegister("1eLd5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9E7wF").then(()=>parcelRequire('9NngE'));
});
parcelRegister("hMflp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("035vU").then(()=>parcelRequire('lR9rA'));
});
parcelRegister("6Qsx1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jYwBi").then(()=>parcelRequire('2iXPf'));
});
parcelRegister("dRbYW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cnQw3").then(()=>parcelRequire('7VK3g'));
});
parcelRegister("7JFr6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3Ai66").then(()=>parcelRequire('dacr9'));
});
parcelRegister("iyJG2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1n4Rb").then(()=>parcelRequire('2PKid'));
});
parcelRegister("IJFKr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4nmdC").then(()=>parcelRequire('g30Fn'));
});
parcelRegister("6lmFO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2i2tB").then(()=>parcelRequire('2kNNC'));
});
parcelRegister("bDnE3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6SgKE").then(()=>parcelRequire('jI51z'));
});
parcelRegister("2eaO0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("56ZOb").then(()=>parcelRequire('kaBqe'));
});
parcelRegister("k45Zp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("duUtE").then(()=>parcelRequire('8bn0J'));
});
parcelRegister("9q3Te", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dfu17").then(()=>parcelRequire('5vCyS'));
});
parcelRegister("gAZbu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1PfGC").then(()=>parcelRequire('iRkAG'));
});
parcelRegister("gWg7c", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$d13eb097e99fa984$export$720676d8cac8fbb);
    var $jTlyZ;
    var $euiLX;
    const $d13eb097e99fa984$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;
    const $d13eb097e99fa984$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("euiLX")).default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("f4WGN")));
            case 'da':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("jhduq")));
            case 'de':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("1rwEg")));
            case 'en-GB':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("lU8xk")));
            case 'en-US':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("9izs0")));
            case 'en-XA':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("cAfjU")));
            case 'en-XB':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("k2MDt")));
            case 'en-ZZ':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("fXn9W")));
            case 'en':
                return $d13eb097e99fa984$var$importHelper(await Promise.resolve((parcelRequire("jTlyZ"))));
            case 'es':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("21YPk")));
            case 'et':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("7yDHc")));
            case 'fi':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("7wOOy")));
            case 'fr':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("9NJ6f")));
            case 'hu':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("ijzxt")));
            case 'it':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("2VWKN")));
            case 'ja':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("eKy1p")));
            case 'ko':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("AT3FS")));
            case 'nb':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("3HZZI")));
            case 'nl':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("602Ah")));
            case 'pl':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("4uXmI")));
            case 'pt-BR':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("782rV")));
            case 'ro':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("2V8A9")));
            case 'ru':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("locCn")));
            case 'sv':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("e8E1Y")));
            case 'th':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("d9Za6")));
            case 'tr':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("lUeKF")));
            case 'uk':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("lwbGC")));
            case 'vi':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("1Mti3")));
            case 'zh-CN':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("8Rz5d")));
            case 'zh-TW':
                return $d13eb097e99fa984$var$importHelper(await (parcelRequire("414mc")));
            default:
                return 0, ($parcel$interopDefault((0, parcelRequire("jTlyZ"))));
        }
    };
});
parcelRegister("jTlyZ", function(module, exports) {
    module.exports = JSON.parse("{\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");
});
parcelRegister("f4WGN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lHVL5").then(()=>parcelRequire('cOdtX'));
});
parcelRegister("jhduq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gmFsu").then(()=>parcelRequire('ehn1w'));
});
parcelRegister("1rwEg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4heQj").then(()=>parcelRequire('gUTAT'));
});
parcelRegister("lU8xk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1gRT0").then(()=>parcelRequire('j51AU'));
});
parcelRegister("9izs0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kkDB9").then(()=>parcelRequire('gAvT5'));
});
parcelRegister("cAfjU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1uZSJ").then(()=>parcelRequire('3UXio'));
});
parcelRegister("k2MDt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9Y6zx").then(()=>parcelRequire('7swxR'));
});
parcelRegister("fXn9W", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1GqWE").then(()=>parcelRequire('530uH'));
});
parcelRegister("21YPk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1RQcp").then(()=>parcelRequire('lHvSd'));
});
parcelRegister("7yDHc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8MNlN").then(()=>parcelRequire('jF3vn'));
});
parcelRegister("7wOOy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eDmn9").then(()=>parcelRequire('5RTMG'));
});
parcelRegister("9NJ6f", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3bISh").then(()=>parcelRequire('lFs8E'));
});
parcelRegister("ijzxt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jrCqD").then(()=>parcelRequire('229rK'));
});
parcelRegister("2VWKN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kxYfx").then(()=>parcelRequire('dQCwG'));
});
parcelRegister("eKy1p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jmIq9").then(()=>parcelRequire('glbrO'));
});
parcelRegister("AT3FS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a4UUJ").then(()=>parcelRequire('4Z6cs'));
});
parcelRegister("3HZZI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cG5Yc").then(()=>parcelRequire('2KZY1'));
});
parcelRegister("602Ah", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("i5XGe").then(()=>parcelRequire('6ZLBK'));
});
parcelRegister("4uXmI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("22Dpk").then(()=>parcelRequire('etrJu'));
});
parcelRegister("782rV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("edLMb").then(()=>parcelRequire('6QWjO'));
});
parcelRegister("2V8A9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9TiZ0").then(()=>parcelRequire('4uHll'));
});
parcelRegister("locCn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3a5et").then(()=>parcelRequire('2S1ZA'));
});
parcelRegister("e8E1Y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bb4hU").then(()=>parcelRequire('1mvAC'));
});
parcelRegister("d9Za6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hF6jM").then(()=>parcelRequire('4oHMI'));
});
parcelRegister("lUeKF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5JRPO").then(()=>parcelRequire('2KsIL'));
});
parcelRegister("lwbGC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("629Lo").then(()=>parcelRequire('gNWij'));
});
parcelRegister("1Mti3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("955SR").then(()=>parcelRequire('5MBk8'));
});
parcelRegister("8Rz5d", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("62Vsv").then(()=>parcelRequire('5jMKL'));
});
parcelRegister("414mc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bwU6c").then(()=>parcelRequire('4Kji8'));
});
parcelRegister("cENg4", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$177b5a84586da530$export$720676d8cac8fbb);
    var $cGnQ2;
    var $euiLX;
    const $177b5a84586da530$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;
    const $177b5a84586da530$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("euiLX")).default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("5auBH")));
            case 'da':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("6pKdb")));
            case 'de':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("j7zSY")));
            case 'en-GB':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("RXLpr")));
            case 'en-US':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("lcczF")));
            case 'en-XA':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("lR3kc")));
            case 'en-XB':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("2V8i0")));
            case 'en-ZZ':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("bMfdq")));
            case 'en':
                return $177b5a84586da530$var$importHelper(await Promise.resolve((parcelRequire("cGnQ2"))));
            case 'es':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("fgL2p")));
            case 'et':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("bxmvz")));
            case 'fi':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("30eqR")));
            case 'fr':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("72KWh")));
            case 'hu':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("gYJqW")));
            case 'it':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("dFTxP")));
            case 'ja':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("3K1VL")));
            case 'ko':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("fz41S")));
            case 'nb':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("66deW")));
            case 'nl':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("1gzyP")));
            case 'pl':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("6Fuvc")));
            case 'pt-BR':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("42L7s")));
            case 'ro':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("at9BV")));
            case 'ru':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("gE5sv")));
            case 'sv':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("7OUjU")));
            case 'th':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("cvMBB")));
            case 'tr':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("kaqjm")));
            case 'uk':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("GpvzN")));
            case 'vi':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("99JlG")));
            case 'zh-CN':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("iVMqV")));
            case 'zh-TW':
                return $177b5a84586da530$var$importHelper(await (parcelRequire("5DASo")));
            default:
                return 0, ($parcel$interopDefault((0, parcelRequire("cGnQ2"))));
        }
    };
});
parcelRegister("cGnQ2", function(module, exports) {
    module.exports = JSON.parse("{\"admin-hub.ci-test.message-template-template-hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"ci-generation.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"ci-generation.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"ci-generation.email.body.img.alt\":[{\"type\":0,\"value\":\"This is the alt text for the image\"}],\"ci-generation.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"ci-generation.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"ci-generation.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"ci-generation.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.test-message-digest-email-template.test-message.email.body.digest-title\":[{\"type\":0,\"value\":\"You have \"},{\"type\":1,\"value\":\"numberOfMsg\"},{\"type\":0,\"value\":\" new messages!\"}],\"post-office.test-message-digest-email-template.test-message.email.body.message-body\":[{\"type\":1,\"value\":\"defaultMessage\"}],\"post-office.test-message.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"post-office.test-messages.test-message-mobile-push.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-slack-notification.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"product-store-personal-use-case.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}],\"test-messages.app-switcher-discovery-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-discovery-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.app-switcher-upgrade-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-upgrade-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.in-app-example.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.jira-navigation-topbar-edition-awareness.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.redacted-email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-digest-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hey \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-digest-email.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. Here is your daily digest (rick) rollup for the \"},{\"type\":1,\"value\":\"site\"},{\"type\":0,\"value\":\" workspace\"}],\"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-cdn.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-cdn.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-cdn.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-cdn.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-mfc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-mfc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-grouped-recipients.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hello\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-marketing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-marketing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-marketing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-marketing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-persona-email.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-persona-email.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-persona-email.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-persona-email.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-persona-email.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-persona-email.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi,\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.app.img.alt.large\":[{\"type\":0,\"value\":\"test image 2\"}],\"test-messages.test-message.app.img.alt.plant\":[{\"type\":0,\"value\":\"test image 1\"}],\"test-messages.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.redacted-email.body\":[{\"type\":0,\"value\":\"This is the redacted version of the test email message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.redacted-email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.redacted-email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.redacted-email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.redacted-email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"wac-global-nav-product-recommendation.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}]}");
});
parcelRegister("5auBH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1hE5w").then(()=>parcelRequire('k8z39'));
});
parcelRegister("6pKdb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("627oz").then(()=>parcelRequire('6UrsO'));
});
parcelRegister("j7zSY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6jCV8").then(()=>parcelRequire('8bqsn'));
});
parcelRegister("RXLpr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5O5cU").then(()=>parcelRequire('hJmwv'));
});
parcelRegister("lcczF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6JTH9").then(()=>parcelRequire('2uiq7'));
});
parcelRegister("lR3kc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2v2Nk").then(()=>parcelRequire('iHpg4'));
});
parcelRegister("2V8i0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hDbq3").then(()=>parcelRequire('fI8tg'));
});
parcelRegister("bMfdq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8eljG").then(()=>parcelRequire('kozgB'));
});
parcelRegister("fgL2p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7Ch5S").then(()=>parcelRequire('4wp5m'));
});
parcelRegister("bxmvz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lSnfb").then(()=>parcelRequire('lExpK'));
});
parcelRegister("30eqR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fHtYn").then(()=>parcelRequire('i0vin'));
});
parcelRegister("72KWh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hBRyE").then(()=>parcelRequire('hAKNc'));
});
parcelRegister("gYJqW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jqccl").then(()=>parcelRequire('6RGe9'));
});
parcelRegister("dFTxP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("khPZv").then(()=>parcelRequire('eUDxL'));
});
parcelRegister("3K1VL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5cbMq").then(()=>parcelRequire('5Tyyo'));
});
parcelRegister("fz41S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7Ms5V").then(()=>parcelRequire('gEKqD'));
});
parcelRegister("66deW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fbxh4").then(()=>parcelRequire('8h3N4'));
});
parcelRegister("1gzyP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7pABd").then(()=>parcelRequire('baBoX'));
});
parcelRegister("6Fuvc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("781xq").then(()=>parcelRequire('kuE02'));
});
parcelRegister("42L7s", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5svak").then(()=>parcelRequire('gSSyD'));
});
parcelRegister("at9BV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dICtH").then(()=>parcelRequire('8PFu0'));
});
parcelRegister("gE5sv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2jnDS").then(()=>parcelRequire('f9UJM'));
});
parcelRegister("7OUjU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("htpfI").then(()=>parcelRequire('l5ru8'));
});
parcelRegister("cvMBB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dbrcM").then(()=>parcelRequire('36syK'));
});
parcelRegister("kaqjm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8pczK").then(()=>parcelRequire('hO7cZ'));
});
parcelRegister("GpvzN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hSwzA").then(()=>parcelRequire('9DvXk'));
});
parcelRegister("99JlG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dhLwH").then(()=>parcelRequire('lRZWr'));
});
parcelRegister("iVMqV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aH2IS").then(()=>parcelRequire('3Qt72'));
});
parcelRegister("5DASo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eXLRF").then(()=>parcelRequire('2LYB4'));
});
parcelRegister("SfWIb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb8d031c7e1e7737$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $dmvPD;
    var $7LDqC;
    var $iXSVm;
    var $5uXOq = parcelRequire("5uXOq");
    var $cPceA;
    const $fb8d031c7e1e7737$var$STABLE_OBJECT = {};
    const $fb8d031c7e1e7737$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, Fallback: Fallback = null, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
        const MemoizedPlacement = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("iXSVm")).createPlacementComponent)(placementId, PlacementComponent), [
            placementId,
            PlacementComponent
        ]);
        const stableLocalPlacementProps = (0, (0, parcelRequire("dmvPD")).useStableObject)(placementProps ?? $fb8d031c7e1e7737$var$STABLE_OBJECT);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("7LDqC")).default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>(0, $2OMIu.jsx)((0, (0, parcelRequire("cPceA")).default), {
                    analyticsChannel: (0, $78e0a2ec69f009c2$export$85183a312807388d),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                        fallback: Fallback,
                        children: (0, $2OMIu.jsx)(MemoizedPlacement, {
                            initialData: initialData,
                            context: context,
                            errorFallback: ErrorFallback,
                            ...stableLocalPlacementProps,
                            children: children
                        })
                    })
                })
        });
    };
    var $fb8d031c7e1e7737$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($fb8d031c7e1e7737$var$Placement);
});
parcelRegister("7LDqC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c34cc6cf58be8aa$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $1PVpv = parcelRequire("1PVpv");
    var $5IPCv;
    var $gHZ4O;
    var $lwdce;
    var $dmvPD;
    var $e8o2I;
    var $5H0An;
    var $aFtXM;
    var $5uXOq = parcelRequire("5uXOq");
    var $3tkt7;
    var $fqlGT;
    var $ABMmQ;
    const $7c34cc6cf58be8aa$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
        const fetcher = (0, (0, parcelRequire("aFtXM")).usePlacementFetchingContext)();
        return (0, $5uXOq.useMemo)(()=>disableInitialData ? undefined : (0, (0, parcelRequire("3tkt7")).requestInitialData)(placementId, context, fetcher.fetch, {
                baseUrl: baseUrl,
                path: path
            }), [
            disableInitialData,
            baseUrl,
            path,
            placementId,
            context,
            fetcher.fetch
        ]);
    };
    const $7c34cc6cf58be8aa$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
        const isUFOEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate('enable_ufo_tracking_in_post_office');
        const postOfficeRoute = (0, (0, parcelRequire("lwdce")).usePostOfficeRoute)();
        const context = (0, (0, parcelRequire("gHZ4O")).usePostOfficeContext)();
        const { baseUrl: baseUrl, path: path } = (0, (0, parcelRequire("fqlGT")).useBuildBasePath)();
        const stableContextWithRoute = (0, (0, parcelRequire("dmvPD")).useStableObject)({
            ...context,
            postOfficeRoute: postOfficeRoute
        });
        const ufoV1PlacementTracker = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? new (0, (0, parcelRequire("e8o2I")).UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
            isUFOEnabled,
            placementId,
            consumptionType
        ]);
        const remoteComponentOnEvent = (0, $5uXOq.useCallback)(({ type: type, error: error })=>{
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure(error);
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure(error);
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure(error);
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure(error);
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }, [
            placementOnEvent,
            ufoV1PlacementTracker
        ]);
        const initialData = $7c34cc6cf58be8aa$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
        const placementAnalyticsContext = (0, $5uXOq.useMemo)(()=>({
                source: (0, $9608316309c5ec9e$export$f7109619a5e9e0d6),
                componentName: `Placement`,
                attributes: {
                    placementId: placementId,
                    channel: 'in-app',
                    postOfficeFrontendVersion: (0, parcelRequire("ABMmQ")).version
                }
            }), [
            placementId
        ]);
        return (0, $2OMIu.jsx)($7c34cc6cf58be8aa$var$FeatureFlaggedUfoWrapper, {
            placementId: placementId,
            isEnabled: isUFOEnabled,
            children: (0, $2OMIu.jsx)((0, $1PVpv.PostOfficeAnalyticsContext), {
                data: placementAnalyticsContext,
                children: children({
                    initialData: initialData,
                    context: stableContextWithRoute,
                    onEvent: remoteComponentOnEvent
                })
            })
        });
    };
    var $7c34cc6cf58be8aa$export$2e2bcd8739ae039 = $7c34cc6cf58be8aa$var$Placement;
    const $7c34cc6cf58be8aa$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, placementId: placementId, children: children })=>{
        if (isEnabled) return (0, $2OMIu.jsx)((0, (0, parcelRequire("5H0An")).UFOv2).UFOSegment, {
            name: (0, (0, parcelRequire("5H0An")).UFOv2).SegmentNames.PLACEMENT,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("5H0An")).UFOv2).UFOSegment, {
                name: `${(0, (0, parcelRequire("5H0An")).UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
                children: children
            })
        });
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
const $9608316309c5ec9e$export$85183a312807388d = 'postOffice';
const $9608316309c5ec9e$export$f7109619a5e9e0d6 = 'post-office-frontend';
parcelRegister("3tkt7", function(module, exports) {
    $parcel$export(module.exports, "requestInitialData", ()=>$10a72e21f18f1ff1$export$c4c39037cc4b06ab);
    const $10a72e21f18f1ff1$var$defaultFetcher = (url)=>fetch(url, {
            headers: {
                credentials: 'include',
                mode: 'cors',
                'Content-Type': 'application/json'
            }
        });
    const $10a72e21f18f1ff1$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $10a72e21f18f1ff1$var$defaultFetcher, options)=>{
        const baseUrl = options.baseUrl;
        const path = options.path;
        const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
        function stringifyObjectValues(input) {
            const entries = Object.entries(input);
            const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                    key,
                    String(value)
                ]);
            return Object.fromEntries(stringifiedEntries);
        }
        const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
        contextAsSearchParams.sort();
        const url = encodeURI(`${requestUrl}${placementId}?${contextAsSearchParams.toString()}`);
        return fetcher(url);
    };
});
parcelRegister("fqlGT", function(module, exports) {
    $parcel$export(module.exports, "useBuildBasePath", ()=>$fe4b211ec6dd7c80$export$83d6c58b7ab7ae67);
    var $87o4H;
    var $5MYiV;
    var $5uXOq = parcelRequire("5uXOq");
    const $fe4b211ec6dd7c80$export$83d6c58b7ab7ae67 = ()=>{
        const postOfficeEnvironment = (0, (0, parcelRequire("5MYiV")).usePostOfficeEnvironment)();
        return (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("87o4H")).buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
            postOfficeEnvironment.currentEnv,
            postOfficeEnvironment.envConfigs
        ]);
    };
});
parcelRegister("87o4H", function(module, exports) {
    $parcel$export(module.exports, "buildBasePath", ()=>$e673525439adf1a3$export$e8b30f9c4a80230f);
    var $5MYiV;
    const $e673525439adf1a3$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, (0, parcelRequire("5MYiV")).defaultEnvironmentValues).envConfigs)=>{
        const baseUrl = envConfigs[currentEnv].api.origin;
        const path = envConfigs[currentEnv].api.pathname ?? (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8);
        return {
            baseUrl: baseUrl,
            path: path
        };
    };
});
parcelRegister("ABMmQ", function(module, exports) {
    module.exports = JSON.parse("{\"name\":\"@atlassian/post-office-placement-shared\",\"version\":\"0.4.1\",\"packageManager\":\"yarn@4.2.2\",\"sideEffects\":false,\"source\":\"./src/index.ts\",\"main\":\"./dist/cjs/index.js\",\"module\":\"./dist/esm/index.js\",\"types\":\"./dist/types/index.d.ts\",\"exports\":{\".\":\"./src/index.ts\",\"./request-initial-data\":\"./src/initialDataClient.ts\"},\"publishConfig\":{\"exports\":{\"import\":\"./dist/esm/index.js\",\"require\":\"./dist/cjs/index.js\",\"types\":\"./dist/types/index.d.ts\"}},\"repository\":{\"type\":\"git\",\"url\":\"git+https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/post-office.git\",\"directory\":\"packages/post-office-clients/post-office-placement-shared\"},\"files\":[\"README.md\",\"dist\"],\"scripts\":{\"prepack\":\"atlas packages permission grant && yarn exec parcel build\",\"publish:patch\":\"yarn version patch && yarn npm publish\",\"publish:minor\":\"yarn version minor && yarn npm publish\"},\"peerDependencies\":{\"react\":\"^16.8.0 || ^17.0.0 || ^18.2.0\",\"react-dom\":\"^16.8.0 || ^17.0.0 || ^18.2.0\"},\"dependencies\":{\"@atlaskit/analytics-namespaced-context\":\"workspace:^\",\"@atlaskit/feature-gate-js-client\":\"workspace:^\",\"@atlassian/post-office-context\":\"workspace:^\",\"@atlassian/post-office-frontend-performance-tracking\":\"workspace:^\",\"@atlassian/post-office-placement-data\":\"workspace:^\",\"@compiled/react\":\"^0.17.3\"},\"devDependencies\":{\"@testing-library/jest-dom\":\"^6.4.2\",\"@testing-library/react\":\"14.2.1\",\"@testing-library/react-hooks\":\"^8.0.1\",\"@types/node\":\"^20.11.27\",\"@types/react\":\"^18.2.33\",\"@types/react-dom\":\"^18.2.14\",\"eslint\":\"^8.57.0\",\"jest\":\"^29.7.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"npm-run-all2\":\"^5.0.0\",\"parcel\":\"^2.6.0\",\"react\":\"^18.2.0\",\"typescript\":\"~5.4.2\"},\"targets\":{\"main\":{\"optimize\":true},\"module\":{\"optimize\":true}}}");
});
parcelRegister("cPceA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53bcb23f511c4129$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $cb25w;
    var $5uXOq = parcelRequire("5uXOq");
    class $53bcb23f511c4129$var$ErrorBoundary extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        componentDidCatch(error, errorInfo) {
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: 'handled',
                actionSubject: 'error',
                actionSubjectId: 'postOfficePlacementErrorBoundary',
                attributes: {
                    error: error?.message,
                    errorInfo: errorInfo,
                    placementId: this.props.placementId
                }
            });
            analyticsEvent.fire(this.props.analyticsChannel);
            this.props.onError({
                error: error,
                type: 'render-error'
            });
            this.setState({
                hasError: true
            });
        }
        render() {
            if (this.state.hasError) return this.props.fallback ? (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                children: this.props.fallback
            }) : null;
            return this.props.children;
        }
    }
    var $53bcb23f511c4129$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($53bcb23f511c4129$var$ErrorBoundary);
});
const $78e0a2ec69f009c2$export$85183a312807388d = 'postOffice';
parcelRegister("7sr84", function(module, exports) {
    $parcel$export(module.exports, "ScreenSpaceFlagPlacementPreviewSwitcher", ()=>$f67b989a93e4f4dd$export$46db7cd62b063064);
    var $2OMIu = parcelRequire("2OMIu");
    var $lwdce;
    var $5vZ80;
    var $jgefF;
    var $8igoP;
    var $SfWIb;
    const $f67b989a93e4f4dd$export$16e97e6603eadea = ({ PlacementComponent: PlacementComponent, placementId: placementId, eligibleMessages: eligibleMessages, errorFallback: errorFallback = null, onError: onError, returnOverride: returnOverride })=>(0, $2OMIu.jsx)((0, (0, parcelRequire("8igoP")).ErrorBoundary), {
            fallback: errorFallback,
            onError: onError,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("5vZ80")).PlacementPreviewProvider), {
                eligibleMessages: eligibleMessages,
                returnOverride: returnOverride,
                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("SfWIb")).default), {
                    PlacementComponent: PlacementComponent,
                    placementId: placementId
                })
            })
        });
    const $f67b989a93e4f4dd$export$46db7cd62b063064 = ({ isEnabled: isEnabled, children: children })=>{
        const { searchParams: searchParams } = (0, (0, parcelRequire("lwdce")).usePostOfficeRoute)();
        const previewId = searchParams?.get('contentfulPreviewId');
        const hasPreviewType = Boolean(searchParams?.get('contentfulPreviewId'));
        const eligibleMessage = [
            {
                messageInstanceId: 'messageInstanceId',
                messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
                messageCategory: 'Engagement',
                context: {
                    id: previewId
                },
                createdAt: new Date().toString(),
                eventTime: new Date().toString(),
                triggerId: 'triggerId',
                messageCreationType: 'explicit'
            }
        ];
        if (isEnabled && hasPreviewType) return (0, $2OMIu.jsx)($f67b989a93e4f4dd$export$16e97e6603eadea, {
            placementId: "screen-space-flags",
            PlacementComponent: (0, (0, parcelRequire("jgefF")).ScreenSpaceFlagsPlacementComponent),
            eligibleMessages: eligibleMessage
        });
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("5vZ80", function(module, exports) {
    $parcel$export(module.exports, "PlacementPreviewProvider", ()=>$a6dbbce22e4d11ac$export$52e362b70e115c68);
    var $aFtXM;
    var $5uXOq = parcelRequire("5uXOq");
    const $a6dbbce22e4d11ac$export$e5ffd38dcf6e5c53 = `/gateway/api/post-office/api/v1/placements/`;
    const $a6dbbce22e4d11ac$export$85c4756977e87c75 = `/gateway/api/post-office/api/v1/placement-preview/`;
    const $a6dbbce22e4d11ac$export$52e362b70e115c68 = ({ returnOverride: returnOverride, eligibleMessages: eligibleMessages, children: children })=>{
        const fetch = (0, $5uXOq.useMemo)(()=>{
            if (returnOverride) return $a6dbbce22e4d11ac$export$fb5156757134712c({
                returnOverride: returnOverride
            });
            return $a6dbbce22e4d11ac$export$c05392ff95b4319d({
                eligibleMessages: eligibleMessages
            });
        }, [
            eligibleMessages,
            returnOverride
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aFtXM")).PlacementFetchingProvider), {
            fetch: fetch
        }, children);
    };
    const $a6dbbce22e4d11ac$export$fb5156757134712c = ({ returnOverride: returnOverride })=>async ()=>{
            return new Response(JSON.stringify(returnOverride), {
                status: 200,
                statusText: 'ok'
            });
        };
    const $a6dbbce22e4d11ac$export$c05392ff95b4319d = ({ eligibleMessages: eligibleMessages })=>(url, options)=>{
            const finalUrl = url.replace($a6dbbce22e4d11ac$export$e5ffd38dcf6e5c53, $a6dbbce22e4d11ac$export$85c4756977e87c75);
            const payload = {
                originalMethod: options?.method || 'GET',
                originalBody: $a6dbbce22e4d11ac$var$parseBody(options?.body),
                eligibleMessages: eligibleMessages
            };
            return globalThis.fetch(finalUrl, {
                ...options,
                method: 'POST',
                headers: {
                    ...options?.headers || {}
                },
                body: $a6dbbce22e4d11ac$var$stringifyPayload(payload)
            });
        };
    const $a6dbbce22e4d11ac$var$objectHasKeys = (input)=>!!Object.keys(input).length;
    const $a6dbbce22e4d11ac$var$parseBody = (body)=>{
        if (typeof body === 'undefined' || body === null) return undefined;
        try {
            const parsedBody = JSON.parse(body);
            if ($a6dbbce22e4d11ac$var$objectHasKeys(parsedBody)) return parsedBody;
            throw new Error();
        } catch  {
            throw new Error('Unable to parse preview body. Is it a valid object?');
        }
    };
    const $a6dbbce22e4d11ac$var$stringifyPayload = (payload)=>{
        try {
            return JSON.stringify(payload);
        } catch  {
            throw new Error('Unable to parse preview body. Is it a valid object?');
        }
    };
});
parcelRegister("8igoP", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$609cb9bed692cc37$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    'use client';
    const $609cb9bed692cc37$export$b16d9fb1a22de840 = (0, $5uXOq.createContext)(null);
    const $609cb9bed692cc37$var$initialState = {
        didCatch: false,
        error: null
    };
    class $609cb9bed692cc37$export$e926676385687eaf extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
            this.state = $609cb9bed692cc37$var$initialState;
        }
        static getDerivedStateFromError(error) {
            return {
                didCatch: true,
                error: error
            };
        }
        resetErrorBoundary() {
            const { error: error } = this.state;
            if (error !== null) {
                var _this$props$onReset, _this$props;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                    args: args,
                    reason: "imperative-api"
                });
                this.setState($609cb9bed692cc37$var$initialState);
            }
        }
        componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
        }
        componentDidUpdate(prevProps, prevState) {
            const { didCatch: didCatch } = this.state;
            const { resetKeys: resetKeys } = this.props;
            if (didCatch && prevState.error !== null && $609cb9bed692cc37$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
                var _this$props$onReset2, _this$props3;
                (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                    next: resetKeys,
                    prev: prevProps.resetKeys,
                    reason: "keys"
                });
                this.setState($609cb9bed692cc37$var$initialState);
            }
        }
        render() {
            const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
            const { didCatch: didCatch, error: error } = this.state;
            let childToRender = children;
            if (didCatch) {
                const props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
                else if (FallbackComponent) childToRender = (0, $5uXOq.createElement)(FallbackComponent, props);
                else if (fallback === null || (0, $5uXOq.isValidElement)(fallback)) childToRender = fallback;
                else throw error;
            }
            return (0, $5uXOq.createElement)($609cb9bed692cc37$export$b16d9fb1a22de840.Provider, {
                value: {
                    didCatch: didCatch,
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                }
            }, childToRender);
        }
    }
    function $609cb9bed692cc37$var$hasArrayChanged() {
        let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
    }
    function $609cb9bed692cc37$var$assertErrorBoundaryContext(value) {
        if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
    }
    function $609cb9bed692cc37$export$c052f6604b7d51fe() {
        const context = (0, $5uXOq.useContext)($609cb9bed692cc37$export$b16d9fb1a22de840);
        $609cb9bed692cc37$var$assertErrorBoundaryContext(context);
        const [state, setState] = (0, $5uXOq.useState)({
            error: null,
            hasError: false
        });
        const memoized = (0, $5uXOq.useMemo)(()=>({
                resetBoundary: ()=>{
                    context.resetErrorBoundary();
                    setState({
                        error: null,
                        hasError: false
                    });
                },
                showBoundary: (error)=>setState({
                        error: error,
                        hasError: true
                    })
            }), [
            context.resetErrorBoundary
        ]);
        if (state.hasError) throw state.error;
        return memoized;
    }
    function $609cb9bed692cc37$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
        const Wrapped = (0, $5uXOq.forwardRef)((props, ref)=>(0, $5uXOq.createElement)($609cb9bed692cc37$export$e926676385687eaf, errorBoundaryProps, (0, $5uXOq.createElement)(component, {
                ...props,
                ref: ref
            })));
        const name = component.displayName || component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
        return Wrapped;
    }
});
const $d0ca21152325de6b$export$37d4bb5bc0e315db = 'killswitch_post_office_in_jira';
parcelRegister("eKtC8", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$31b7f947593face8$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $b71gk;
    const $31b7f947593face8$export$e926676385687eaf = ({ children: children, id: id, withExperienceTracker: withExperienceTracker })=>{
        if (false) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b71gk")).default), {
            id: id
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: id,
            packageName: "jiraEntry",
            fallback: "page",
            withExperienceTracker: withExperienceTracker
        }, children);
    };
});
parcelRegister("bAjl9", function(module, exports) {
    $parcel$export(module.exports, "IntlProviders", ()=>$fad1cef37914a278$export$c9d8cd4516cc55a8);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzeFL;
    var $1nUas;
    const $fad1cef37914a278$export$c9d8cd4516cc55a8 = ({ children: children, locale: locale, messages: messages })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1nUas")).IntlProvider), {
            messages: messages,
            locale: (0, (0, parcelRequire("lzeFL")).standardizeLocale)(locale)
        }, children);
});
parcelRegister("1nUas", function(module, exports) {
    $parcel$export(module.exports, "IntlProvider", ()=>$0264700d4de7e638$export$480518999dfc4151);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    const $0264700d4de7e638$export$480518999dfc4151 = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            ...props,
            defaultLocale: props.locale
        }, children);
});
parcelRegister("lvG9V", function(module, exports) {
    $parcel$export(module.exports, "MetricsContainers", ()=>$2bc2dec1250f1cf8$export$2d1617bc0040e5d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $1OjhZ;
    var $8ApFP;
    var $iXVV6;
    var $kDdFQ;
    const $2bc2dec1250f1cf8$export$2d1617bc0040e5d9 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1OjhZ")).ExperienceTrackerProvider), null, !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "metrics-containers-subproduct-updater",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kDdFQ")).SubProductUpdater), null)), children));
});
parcelRegister("1OjhZ", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTrackerProvider", ()=>$5cef917adb45d092$export$6f49c95a810d59fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $ha42n;
    var $bSOOm;
    var $9sAyK;
    const $5cef917adb45d092$var$useUnmount = (callback)=>(0, $5uXOq.useEffect)(()=>callback, [
            callback
        ]);
    const $5cef917adb45d092$export$6f49c95a810d59fa = ({ children: children })=>{
        const [experienceTracker] = (0, $5uXOq.useState)(new (0, (0, parcelRequire("ha42n")).ExperienceTracker)());
        const [cleanupSliSub] = (0, $5uXOq.useState)(()=>experienceTracker.subscribe((0, (0, parcelRequire("9sAyK")).sliSubscriber)));
        const cleanup = (0, $5uXOq.useCallback)(()=>{
            cleanupSliSub();
        }, [
            cleanupSliSub
        ]);
        $5cef917adb45d092$var$useUnmount(cleanup);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bSOOm")).ExperienceTrackerContext).Provider, {
            value: experienceTracker
        }, children);
    };
});
parcelRegister("9sAyK", function(module, exports) {
    $parcel$export(module.exports, "sliSubscriber", ()=>$6b2f2360dd11edee$export$db0b99fe17114899);
    var $fjcgS;
    var $efvDm;
    var $ldyPw;
    const $6b2f2360dd11edee$var$transformApplication = (application)=>{
        switch(application){
            case 0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE:
                return 'jira-software';
            case 0, (0, parcelRequire("efvDm")).JIRA_PRODUCT_DISCOVERY:
                return 'jira-product-discovery';
            case 0, (0, parcelRequire("efvDm")).JIRA_CORE:
                return 'jira-core';
            case 0, (0, parcelRequire("efvDm")).JIRA_SERVICE_DESK:
                return 'jira-servicedesk';
            case 0, (0, parcelRequire("efvDm")).JIRA_PORTFOLIO:
                return 'jira-portfolio';
            default:
                return 'unknown';
        }
    };
    const $6b2f2360dd11edee$var$transformEdition = (edition)=>{
        switch(edition){
            case 0, (0, parcelRequire("ldyPw")).FREE_EDITION:
                return 'jedi';
            case 0, (0, parcelRequire("ldyPw")).STANDARD_EDITION:
                return 'standard';
            case 0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION:
                return 'premium';
            case 0, (0, parcelRequire("ldyPw")).UNLICENSED:
                return 'unlicensed';
            default:
                return 'unknown';
        }
    };
    const $6b2f2360dd11edee$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
            source: 'ui',
            action: action,
            actionSubject: 'ui',
            attributes: {
                ...additionalAttributes,
                task: experience,
                reason: location,
                analyticsSource: analyticsSource,
                application: $6b2f2360dd11edee$var$transformApplication(application),
                edition: $6b2f2360dd11edee$var$transformEdition(edition),
                ...errorMessage && {
                    errorMessage: errorMessage
                }
            }
        });
    const $6b2f2360dd11edee$var$reportSli = (experienceDescription)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const event = $6b2f2360dd11edee$var$createAnalyticsEvent(experienceDescription);
            const clientInstance = client.getInstance();
            clientInstance.sendOperationalEvent(event);
        });
    };
    const $6b2f2360dd11edee$export$db0b99fe17114899 = (event)=>{
        const { name: name, action: action } = event;
        const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
        if (disableSli) return;
        switch(action){
            case 0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a:
                $6b2f2360dd11edee$var$reportSli({
                    experience: name,
                    action: (0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    additionalAttributes: additionalAttributes
                });
                break;
            case 0, $c0ec49ac5a1e4009$export$b48b3d1872522384:
                $6b2f2360dd11edee$var$reportSli({
                    experience: name,
                    action: (0, $c0ec49ac5a1e4009$export$b48b3d1872522384),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    location: location,
                    ...event.error && {
                        errorMessage: String(event.error)
                    },
                    additionalAttributes: additionalAttributes
                });
                break;
            case 0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8:
                $6b2f2360dd11edee$var$reportSli({
                    experience: name,
                    action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    location: location,
                    additionalAttributes: additionalAttributes
                });
                break;
            default:
        }
    };
});
parcelRegister("kDdFQ", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5dc03f10b4b74566$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $cfDZ3;
    var $16v4H;
    const $5dc03f10b4b74566$export$eb40d3df56aa5c53 = ()=>{
        const subProduct = (0, (0, parcelRequire("16v4H")).useSubProduct)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("cfDZ3")).setSubProduct)(subProduct);
        }, [
            subProduct
        ]);
        return null;
    };
});
parcelRegister("16v4H", function(module, exports) {
    $parcel$export(module.exports, "subProductFromProjectType", ()=>$f7eda04ad2dc7e84$export$246e1e2a5c86a633);
    $parcel$export(module.exports, "useSubProduct", ()=>$f7eda04ad2dc7e84$export$16aa2ad52cd8992a);
    var $4DPZY;
    const $f7eda04ad2dc7e84$export$246e1e2a5c86a633 = (projectType)=>{
        switch(projectType){
            case 'business':
                return 'core';
            case 'product_discovery':
            case 'software':
                return 'software';
            case 'service_desk':
                return 'serviceDesk';
            default:
                projectType;
                return 'unknown';
        }
    };
    const $f7eda04ad2dc7e84$export$16aa2ad52cd8992a = ()=>{
        const [{ data: data }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        if (!data?.project) return null;
        return $f7eda04ad2dc7e84$export$246e1e2a5c86a633(data.project.type);
    };
});
parcelRegister("gPTB6", function(module, exports) {
    $parcel$export(module.exports, "NavigationContainers", ()=>$1720b620f5483501$export$36f9ed697cae18ae);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $8ploF;
    let $1720b620f5483501$var$Containers = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (!false) $1720b620f5483501$var$Containers = (0, (0, parcelRequire("8ploF")).ClientOnlyNavigationContainers);
    const $1720b620f5483501$export$36f9ed697cae18ae = ({ baseUrl: baseUrl, children: children })=>{
        (0, (0, parcelRequire("gKZoD")).di)($1720b620f5483501$var$Containers);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1720b620f5483501$var$Containers, {
            baseUrl: baseUrl
        }, children);
    };
});
parcelRegister("8ploF", function(module, exports) {
    $parcel$export(module.exports, "ClientOnlyNavigationContainers", ()=>$f5cf024286957bf6$export$68d7c1e44acfd599);
    var $5uXOq = parcelRequire("5uXOq");
    var $axSKo;
    const $f5cf024286957bf6$export$68d7c1e44acfd599 = ({ children: children })=>{
        if (!false) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("axSKo")).Provider), null, children);
        return null;
    };
});
parcelRegister("9kep9", function(module, exports) {
    $parcel$export(module.exports, "PageConfigContainers", ()=>$83e79f36d4d977db$export$9c661932489b4130);
    var $5uXOq = parcelRequire("5uXOq");
    var $9MAC1;
    var $j8DrX;
    var $6nkVm;
    var $aX7Cy;
    const $83e79f36d4d977db$export$9c661932489b4130 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MAC1")).ThemeContainer), {
            isGlobal: true,
            getMeta: (0, (0, parcelRequire("j8DrX")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleContainer), {
            titleSuffix: (0, (0, parcelRequire("aX7Cy")).ripTitleTemplateFromMeta)((0, (0, parcelRequire("j8DrX")).default))
        }, children));
});
parcelRegister("9MAC1", function(module, exports) {
    $parcel$export(module.exports, "useTheme", ()=>$a1f770a9d49220c1$export$93d4e7f90805808f);
    $parcel$export(module.exports, "ThemeContainer", ()=>$a1f770a9d49220c1$export$11eb671888ed6e7d);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $LtWMd;
    const $a1f770a9d49220c1$var$initialState = {
        navigationTheme: {
            shouldShowTitle: false,
            logoUrl: '',
            usesCustomColours: false,
            backgroundColor: '',
            highlightColor: ''
        }
    };
    const $a1f770a9d49220c1$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'theme',
        initialState: $a1f770a9d49220c1$var$initialState,
        actions: (0, parcelRequire("LtWMd"))
    });
    const $a1f770a9d49220c1$export$74e6aa5aeff5e82e = (0, (0, parcelRequire("51nlc")).createSubscriber)($a1f770a9d49220c1$var$Store);
    const $a1f770a9d49220c1$export$93d4e7f90805808f = (0, (0, parcelRequire("3sQ5x")).createHook)($a1f770a9d49220c1$var$Store);
    const $a1f770a9d49220c1$export$11eb671888ed6e7d = (0, (0, parcelRequire("gg7kZ")).createContainer)($a1f770a9d49220c1$var$Store, {
        onInit: (0, parcelRequire("LtWMd")).bootstrap
    });
});
parcelRegister("LtWMd", function(module, exports) {
    $parcel$export(module.exports, "bootstrap", ()=>$9594f0aa641d3463$export$36aff1fbb4f5dfc6);
    $parcel$export(module.exports, "update", ()=>$9594f0aa641d3463$export$722fbec263ad908a);
    const $9594f0aa641d3463$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
            const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
            const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
            const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $829f609a65d26a98$exports).N0 || ajsHighlightColor !== (0, $829f609a65d26a98$exports).B400);
            const navigationTheme = {
                shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
                logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
                usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
                backgroundColor: ajsBackgroundColor || `var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$exports).N0})`,
                highlightColor: ajsHighlightColor || `var(--ds-text-brand, ${(0, $829f609a65d26a98$exports).B400})`
            };
            if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
            setState({
                navigationTheme: navigationTheme
            });
        };
    const $9594f0aa641d3463$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
            const navigationTheme = {
                ...getState().navigationTheme,
                ...item
            };
            setState({
                navigationTheme: navigationTheme
            });
        };
});
parcelRegister("6nkVm", function(module, exports) {
    $parcel$export(module.exports, "useDocumentTitleActions", ()=>$301148c3154b34a4$export$57c0fda036e12d67);
    $parcel$export(module.exports, "DocumentTitleContainer", ()=>$301148c3154b34a4$export$1aad43993172f16f);
    $parcel$export(module.exports, "DocumentTitleSubscriber", ()=>$301148c3154b34a4$export$b88d5abf3e0bec8c);
    $parcel$export(module.exports, "DocumentTitleHelper", ()=>$301148c3154b34a4$export$573bf8d2ae7d60dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $51nlc;
    var $3Nww0;
    var $aX7Cy;
    const $301148c3154b34a4$var$initialState = {
        title: '',
        defaultTitle: '',
        contextArray: []
    };
    const $301148c3154b34a4$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'document-title',
        initialState: $301148c3154b34a4$var$initialState,
        actions: (0, parcelRequire("3Nww0"))
    });
    const $301148c3154b34a4$export$57c0fda036e12d67 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($301148c3154b34a4$var$Store);
    const $301148c3154b34a4$export$1aad43993172f16f = (0, (0, parcelRequire("gg7kZ")).createContainer)($301148c3154b34a4$var$Store, {
        displayName: 'DocumentTitleContainer'
    });
    const $301148c3154b34a4$export$b88d5abf3e0bec8c = (0, (0, parcelRequire("51nlc")).createSubscriber)($301148c3154b34a4$var$Store, {
        displayName: 'DocumentTitleSubscriber'
    });
    class $301148c3154b34a4$export$573bf8d2ae7d60dc extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.myself = Symbol('document title identifier');
            this.props.addDocumentTitle(this.myself);
        }
        componentDidMount() {
            this.updateTitle();
        }
        componentDidUpdate() {
            this.updateTitle();
        }
        componentWillUnmount() {
            this.props.removeDocumentTitle(this.myself);
            this.updateTitle();
        }
        updateTitle() {
            if ((0, (0, parcelRequire("aX7Cy")).checkDocumentTitle)(this.myself, this.props.contextArray)) this.props.setTitle(this.props.title);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("3Nww0", function(module, exports) {
    $parcel$export(module.exports, "setTitle", ()=>(parcelRequire("9vNeL")).default);
    $parcel$export(module.exports, "addDocumentTitle", ()=>(parcelRequire("5Oj7f")).addDocumentTitle);
    $parcel$export(module.exports, "removeDocumentTitle", ()=>(parcelRequire("gJBAO")).removeDocumentTitle);
    var $9vNeL;
    var $5Oj7f;
    var $gJBAO;
});
parcelRegister("9vNeL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa0c91bbbd212a23$export$2e2bcd8739ae039);
    var $aX7Cy;
    var $aa0c91bbbd212a23$export$2e2bcd8739ae039 = (title)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
            const state = getState();
            const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
            const newTitle = (0, (0, parcelRequire("aX7Cy")).createTitleFromTemplate)(title, titleTemplate);
            document.title = newTitle;
            setState({
                ...state,
                title: newTitle
            });
        };
});
parcelRegister("aX7Cy", function(module, exports) {
    $parcel$export(module.exports, "createTitleFromTemplate", ()=>$45855f8363268b1b$export$3795256dd54a9c9d);
    $parcel$export(module.exports, "ripTitleTemplateFromMeta", ()=>$45855f8363268b1b$export$b7d18105f80195c);
    $parcel$export(module.exports, "checkDocumentTitle", ()=>$45855f8363268b1b$export$7f8be70a0bed1bae);
    const $45855f8363268b1b$export$3795256dd54a9c9d = (title, template)=>template.replace(/%s/, title);
    const $45855f8363268b1b$export$b7d18105f80195c = (getMeta)=>getMeta('ajs-app-title');
    const $45855f8363268b1b$export$7f8be70a0bed1bae = (title, contextArray)=>{
        if (contextArray[contextArray.length - 1] === title) return true;
        return false;
    };
});
parcelRegister("5Oj7f", function(module, exports) {
    $parcel$export(module.exports, "addDocumentTitle", ()=>$53f35561ab86eb34$export$a0c188c0ea474bb8);
    const $53f35561ab86eb34$export$a0c188c0ea474bb8 = (title)=>({ setState: setState, getState: getState })=>{
            const { contextArray: contextArray } = getState();
            contextArray.push(title);
            setState({
                contextArray: contextArray
            });
        };
});
parcelRegister("gJBAO", function(module, exports) {
    $parcel$export(module.exports, "removeDocumentTitle", ()=>$bcdbd43154f62b45$export$e844009b77f80a72);
    const $bcdbd43154f62b45$export$e844009b77f80a72 = (title)=>({ setState: setState, getState: getState })=>{
            const { contextArray: contextArray } = getState();
            setState({
                contextArray: contextArray.filter((symbol)=>symbol !== title)
            });
        };
});
parcelRegister("eSznd", function(module, exports) {
    $parcel$export(module.exports, "UiManagers", ()=>$ca023ab667a452ba$export$41286c339a88ca24);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $e0Brz;
    var $5zgk6;
    var $9rAvm;
    let $ca023ab667a452ba$var$ClientUiManagers = (0, $5uXOq.Fragment);
    if (!false) $ca023ab667a452ba$var$ClientUiManagers = (0, (0, parcelRequire("9rAvm")).ClientUiManagers);
    const $ca023ab667a452ba$export$41286c339a88ca24 = ({ children: children })=>{
        (0, (0, parcelRequire("gKZoD")).di)($ca023ab667a452ba$var$ClientUiManagers);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5zgk6")).LayoutManager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0Brz")).BreadcrumbManager), null, (0, ($parcel$interopDefault($5uXOq))).createElement($ca023ab667a452ba$var$ClientUiManagers, null, children)));
    };
});
parcelRegister("e0Brz", function(module, exports) {
    $parcel$export(module.exports, "BreadcrumbManager", ()=>$e20dc5e8426041f9$export$cd5073909dd92c28);
    var $5uXOq = parcelRequire("5uXOq");
    var $aIVNN;
    const $e20dc5e8426041f9$export$cd5073909dd92c28 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aIVNN")).BreadcrumbContainer), null, children);
});
parcelRegister("5zgk6", function(module, exports) {
    $parcel$export(module.exports, "LayoutManager", ()=>$20f0b1159f4863ef$export$4a04ad01c410b415);
    var $5uXOq = parcelRequire("5uXOq");
    var $c34Wf;
    var $lODMY;
    var $2YP9W;
    var $gg7kZ;
    var $8CM3x;
    var $5e5zm;
    const $20f0b1159f4863ef$var$LayoutContainer = (0, (0, parcelRequire("gg7kZ")).createContainer)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        displayName: 'JiraLayoutContainer',
        onInit: ()=>({ dispatch: dispatch }, { leftSidebar: leftSidebar, rightSidebar: rightSidebar, isChromeless: isChromeless })=>{
                dispatch((0, (0, parcelRequire("8CM3x")).actions).setIsChromeless(isChromeless));
                dispatch((0, (0, parcelRequire("8CM3x")).actions).setLeftSidebarState(leftSidebar));
                dispatch((0, (0, parcelRequire("8CM3x")).actions).setRightSidebarState(rightSidebar));
            },
        onUpdate: ()=>({ dispatch: dispatch }, { isChromeless: isChromeless })=>{
                dispatch((0, (0, parcelRequire("8CM3x")).actions).setIsChromeless(isChromeless));
            }
    });
    const $20f0b1159f4863ef$var$DEFFAULT_RIGHT_SIDEBAR_STATE = {
        stackState: []
    };
    const $20f0b1159f4863ef$var$useIsChromeless = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.route.layout?.isChromeless === true || state.route.entryPoint?.()?.toString() === 'ChromelessEntryPoint');
    const $20f0b1159f4863ef$export$4a04ad01c410b415 = ({ children: children })=>{
        const { data: data } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("c34Wf")).navigationUiStateResource));
        const isChromeless = $20f0b1159f4863ef$var$useIsChromeless();
        const isLeftSidebarCollapsed = data?.leftSidebar?.isCollapsed ?? false;
        const leftSidebarWidth = data?.leftSidebar?.width ?? (0, (0, parcelRequire("5e5zm")).DEFAULT_LEFT_SIDEBAR_WIDTH);
        const leftSidebar = (0, $5uXOq.useMemo)(()=>({
                isVisible: true,
                isCollapsed: isLeftSidebarCollapsed,
                width: leftSidebarWidth,
                isFlyoutOpen: false
            }), [
            isLeftSidebarCollapsed,
            leftSidebarWidth
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($20f0b1159f4863ef$var$LayoutContainer, {
            isGlobal: true,
            isChromeless: isChromeless,
            leftSidebar: leftSidebar,
            rightSidebar: $20f0b1159f4863ef$var$DEFFAULT_RIGHT_SIDEBAR_STATE
        }, children);
    };
});
parcelRegister("9rAvm", function(module, exports) {
    $parcel$export(module.exports, "ClientUiManagers", ()=>$2b5f3846e82b020b$export$d1db6ae5bf84e489);
    var $5uXOq = parcelRequire("5uXOq");
    var $imZsD;
    var $6pvrS;
    var $4041n;
    var $pa9q9;
    var $2HbP2;
    var $4yEIl;
    var $bKCrm;
    const $2b5f3846e82b020b$export$d1db6ae5bf84e489 = ({ children: children })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6pvrS")).CrossFlowProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4yEIl")).PostOfficeProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKCrm")).ProjectCreateDrawerProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4041n")).FavoriteChangeProvider), {
            onShowFlag: showFlag
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2HbP2")).ModalContextProvider), null, children))))));
    };
});
parcelRegister("6pvrS", function(module, exports) {
    $parcel$export(module.exports, "CrossFlowProvider", ()=>$2cd77fddb456dca8$export$d900e4062895cd7c);
    var $5uXOq = parcelRequire("5uXOq");
    var $882vQ = parcelRequire("882vQ");
    var $fjcgS;
    var $9OXo1;
    var $g2XuF;
    var $5emZd;
    const $2cd77fddb456dca8$var$getAnalyticsInstance = ()=>false ? Promise.resolve({
            sendUIEvent: ()=>{},
            sendOperationalEvent: ()=>{},
            sendTrackEvent: ()=>{},
            sendScreenEvent: ()=>{}
        }) : (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
    const $2cd77fddb456dca8$export$d900e4062895cd7c = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: { cloudId: cloudId, locale: locale } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $882vQ.default), {
                cloudId: cloudId,
                analyticsClient: $2cd77fddb456dca8$var$getAnalyticsInstance(),
                locale: locale,
                plugins: [
                    (0, (0, parcelRequire("g2XuF")).getContainersPlugin),
                    (0, (0, parcelRequire("5emZd")).getUsersPlugin)
                ]
            }, children));
});
parcelRegister("882vQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25c23a8ec43eecca$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dao3I = parcelRequire("dao3I");
    var $941eD = parcelRequire("941eD");
    const $25c23a8ec43eecca$var$JiraProvider = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dao3I.CrossFlowProvider), {
            ...props,
            originProduct: "jira"
        });
    };
    var $25c23a8ec43eecca$export$2e2bcd8739ae039 = $25c23a8ec43eecca$var$JiraProvider;
});
parcelRegister("dao3I", function(module, exports) {
    $parcel$export(module.exports, "CrossFlowProvider", ()=>$1615837ea7cb5623$export$d900e4062895cd7c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bHpB9 = parcelRequire("bHpB9");
    var $cSyk1;
    var $5IPCv;
    var $82zEM = parcelRequire("82zEM");
    var $3lpON = parcelRequire("3lpON");
    var $3OuEq = parcelRequire("3OuEq");
    var $iVEiS = parcelRequire("iVEiS");
    var $5cLUX = parcelRequire("5cLUX");
    var $7TqdN = parcelRequire("7TqdN");
    var $h2lEj = parcelRequire("h2lEj");
    const $1615837ea7cb5623$var$IntegrationView = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("2PFSu")));
    const $1615837ea7cb5623$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
            const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
            const tblz852ExperimentCohort = (0, (0, parcelRequire("5IPCv")).default).getExperimentValue('product_store_personal_use_case', 'cohort', 'not-enrolled', {
                fireExperimentExposure: false
            });
            const isInTblz852ExperimentCohort = tblz852ExperimentCohort === 'variation';
            const onCloseResolver = (0, $5uXOq.useRef)();
            const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $5uXOq.useState)(false);
            const fireEvent = (0, $5uXOq.useMemo)(()=>(0, $82zEM.analyticsWrapper)(analyticsClient), [
                analyticsClient
            ]);
            const [requestOptions, setRequestOptions] = (0, $5uXOq.useState)();
            const onAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
                const gasV3Event = (0, $3lpON.transformEvent)(payload);
                if (gasV3Event) {
                    const enrichedEvent = (0, $7TqdN.enrichWithRequestOptions)((0, $5cLUX.enrichWithPackageDetails)(gasV3Event), requestOptions);
                    fireEvent(enrichedEvent);
                }
            }, [
                fireEvent,
                requestOptions
            ]);
            const onHandShake = (0, $5uXOq.useCallback)((appName)=>{
                if (!firstHandshakeReceived) {
                    onAnalyticsEvent({
                        payload: {
                            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                            action: (0, $h2lEj.uiInitialized),
                            actionSubject: (0, $h2lEj.crossFlowActionSubject),
                            attributes: {
                                appName: appName
                            }
                        },
                        context: [
                            {
                                source: $h2lEj.source
                            }
                        ]
                    });
                    setFirstHandshakeReceived(true);
                }
            }, [
                firstHandshakeReceived,
                onAnalyticsEvent
            ]);
            const onOpen = (0, $5uXOq.useCallback)((options)=>{
                setFirstHandshakeReceived(false);
                const analyticsEvent = {
                    payload: (0, $7TqdN.enrichWithRequestOptions)({
                        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                        action: (0, $h2lEj.openInvoked),
                        actionSubject: (0, $h2lEj.crossFlowActionSubject)
                    }, options),
                    context: [
                        {
                            source: $h2lEj.source
                        }
                    ]
                };
                onAnalyticsEvent(analyticsEvent);
                if (options.journey === (0, $bHpB9.Journeys).GET_STARTED && redirectToWac) {
                    (0, $3OuEq.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                    const completionStatus = {};
                    return Promise.resolve(completionStatus);
                }
                const updatedExperimentalOptions = {
                    ...globalExperimentalOptions || {},
                    ...options.experimentalOptions || {}
                };
                options.experimentalOptions = updatedExperimentalOptions;
                setRequestOptions(options);
                return new Promise((resolve)=>{
                    onCloseResolver.current = resolve;
                });
            }, [
                onAnalyticsEvent,
                env,
                redirectToWac,
                globalExperimentalOptions
            ]);
            const onClose = (0, $5uXOq.useCallback)((completionStatus)=>{
                setFirstHandshakeReceived(false);
                setRequestOptions(undefined);
                onCloseResolver.current && onCloseResolver.current(completionStatus);
            }, []);
            const { colorMode: colorMode } = (0, (0, parcelRequire("cSyk1")).default)();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bHpB9.BaseCrossFlowApiProvider), {
                onOpen: onOpen
            }, children, requestOptions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iVEiS.ErrorBoundary), {
                onAnalyticsEvent: onAnalyticsEvent,
                onError: onError
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                fallback: null
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(IntegrationView, {
                ...baseProviderProps,
                ...requestOptions,
                onAnalyticsEvent: onAnalyticsEvent,
                originProduct: originProduct,
                theme: colorMode,
                onClose: onClose,
                onHandShake: onHandShake,
                plugins: plugins,
                env: env,
                redirectToWac: redirectToWac,
                isInTblz852ExperimentCohort: isInTblz852ExperimentCohort,
                zIndex: requestOptions.zIndex ?? 1000
            }))));
        };
    const $1615837ea7cb5623$export$d900e4062895cd7c = $1615837ea7cb5623$export$79d79d8dd8574306($1615837ea7cb5623$var$IntegrationView);
});
parcelRegister("82zEM", function(module, exports) {
    $parcel$export(module.exports, "analyticsWrapper", ()=>$b24c5aab06626f3f$export$91b4dd3bfc301325);
    const $b24c5aab06626f3f$export$91b4dd3bfc301325 = (analyticsClient)=>{
        return (event)=>{
            return Promise.resolve(analyticsClient).then((client)=>{
                switch(event.eventType){
                    case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
                        client.sendUIEvent(event);
                        break;
                    case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
                        client.sendTrackEvent(event);
                        break;
                    case 0, $676c5e519aa5ba55$export$12346a674644c156:
                        client.sendOperationalEvent(event);
                        break;
                    case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
                        client.sendScreenEvent(event);
                        break;
                }
            });
        };
    };
});
parcelRegister("3lpON", function(module, exports) {
    $parcel$export(module.exports, "transformEvent", ()=>$3b1dc20af714f949$export$3f40e8c44448be30);
    const $3b1dc20af714f949$var$GROWTH_TAG = 'growth';
    const $3b1dc20af714f949$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
            propertyNames.forEach((propertyName)=>{
                const navContextProp = contextItem ? contextItem[propertyName] : null;
                acc.push(navContextProp || contextItem[propertyName]);
            });
            return acc;
        }, []).filter(Boolean);
    const $3b1dc20af714f949$var$getSources = (context)=>$3b1dc20af714f949$var$extractFromEventContext([
            'source'
        ], context);
    const $3b1dc20af714f949$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
            const newAttributes = {
                ...ans,
                ...contextProps
            };
            return attributes ? {
                ...newAttributes,
                ...attributes
            } : newAttributes;
        }, {});
    const $3b1dc20af714f949$var$getPackageInfo = (context)=>context.map((contextItem)=>({
                packageName: contextItem.packageName,
                packageVersion: contextItem.packageVersion
            })).filter((p)=>p.packageName);
    const $3b1dc20af714f949$var$last = (values)=>values[values.length - 1];
    const $3b1dc20af714f949$export$3f40e8c44448be30 = (event)=>{
        const { context: context, payload: payload } = event;
        if (!payload) return null;
        const sources = $3b1dc20af714f949$var$getSources(context);
        const source = $3b1dc20af714f949$var$last(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c);
        const extraAttributes = $3b1dc20af714f949$var$getExtraAttributes(context);
        const { packageName: packageName, packageVersion: packageVersion } = $3b1dc20af714f949$var$last($3b1dc20af714f949$var$getPackageInfo(context)) || {};
        const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
        const attributes = {
            packageName: packageName,
            packageVersion: packageVersion,
            ...extraAttributes,
            ...payloadAttributes
        };
        const tags = payload.tags || [];
        tags.push($3b1dc20af714f949$var$GROWTH_TAG);
        switch(eventType){
            case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
            case 0, $676c5e519aa5ba55$export$12346a674644c156:
            case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
                return {
                    eventType: eventType,
                    source: source,
                    actionSubject: actionSubject,
                    action: action,
                    actionSubjectId: actionSubjectId,
                    attributes: attributes,
                    tags: tags.slice(0)
                };
            case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
                return {
                    eventType: eventType,
                    name: name,
                    attributes: attributes,
                    source: source,
                    tags: tags.slice(0)
                };
            default:
                break;
        }
        return null;
    };
});
parcelRegister("3OuEq", function(module, exports) {
    $parcel$export(module.exports, "setProductSignUpLocation", ()=>$67a1e1e75aba157c$export$2827e2473cb9a346);
    var $jWY5k = parcelRequire("jWY5k");
    var $ADfeX = parcelRequire("ADfeX");
    const $67a1e1e75aba157c$var$utmCampaignMap = {
        'atlassian-switcher': (0, $ADfeX.UtmCampaign)['atlassian-switcher']
    };
    const $67a1e1e75aba157c$var$isBundledProduct = (productKey)=>{
        return [
            (0, $jWY5k.Targets).JIRA_SOFTWARE,
            (0, $jWY5k.Targets).JIRA_SERVICE_DESK,
            (0, $jWY5k.Targets).JIRA_CORE,
            (0, $jWY5k.Targets).CONFLUENCE
        ].includes(productKey);
    };
    const $67a1e1e75aba157c$var$getBundleSignUpParams = (productKey)=>{
        const bundles = {
            [(0, $jWY5k.Targets).JIRA_SOFTWARE]: 'jira-software',
            [(0, $jWY5k.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
            [(0, $jWY5k.Targets).JIRA_CORE]: 'jira-core',
            [(0, $jWY5k.Targets).CONFLUENCE]: 'confluence'
        };
        return `bundle=${bundles[productKey]}&edition=free`;
    };
    const $67a1e1e75aba157c$var$isProductWithCustomSignUpPath = (productKey)=>{
        return [
            (0, $jWY5k.Targets).OPSGENIE
        ].includes(productKey);
    };
    const $67a1e1e75aba157c$var$getProductCustomSignUpPath = (productKey)=>{
        const links = {
            [(0, $jWY5k.Targets).OPSGENIE]: (0, $e3b3c434f6296013$export$fb1e43fdafe12e9b)
        };
        return links[productKey];
    };
    const $67a1e1e75aba157c$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
        return Boolean($67a1e1e75aba157c$var$utmCampaignMap[sourceComponent]);
    };
    const $67a1e1e75aba157c$var$getUtmParams = (sourceComponent, sourceContext)=>{
        let utmParams = '';
        if (sourceComponent && $67a1e1e75aba157c$var$isSourceComponentWithUtmParams(sourceComponent)) {
            utmParams = utmParams + `utm_campaign=${$67a1e1e75aba157c$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
            if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
        }
        return utmParams;
    };
    const $67a1e1e75aba157c$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
        const wacUrl = env === 'staging' ? (0, $e3b3c434f6296013$export$c37558e5c67d2b01) : (0, $e3b3c434f6296013$export$f199baf8dfc7621e);
        const utmParams = $67a1e1e75aba157c$var$getUtmParams(sourceComponent, sourceContext);
        let queryParams = '';
        let bundleParams = '';
        let path = (0, $e3b3c434f6296013$export$2a45a00073911255);
        if ($67a1e1e75aba157c$var$isBundledProduct(productKey)) {
            path = (0, $e3b3c434f6296013$export$e6c04a1dd86d1c14);
            bundleParams = $67a1e1e75aba157c$var$getBundleSignUpParams(productKey);
        } else if ($67a1e1e75aba157c$var$isProductWithCustomSignUpPath(productKey)) path = $67a1e1e75aba157c$var$getProductCustomSignUpPath(productKey);
        if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
        if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
        return wacUrl + path + queryParams;
    };
    const $67a1e1e75aba157c$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
        const url = $67a1e1e75aba157c$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
        window.open(url, '_blank');
    };
});
const $e3b3c434f6296013$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $e3b3c434f6296013$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $e3b3c434f6296013$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $e3b3c434f6296013$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $e3b3c434f6296013$export$2a45a00073911255 = '/software';
parcelRegister("ADfeX", function(module, exports) {
    $parcel$export(module.exports, "UtmCampaign", ()=>$640d6f0c65fd4030$export$fc604aa353a97e10);
    var $640d6f0c65fd4030$export$fc604aa353a97e10;
    (function(UtmCampaign) {
        UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    })($640d6f0c65fd4030$export$fc604aa353a97e10 || ($640d6f0c65fd4030$export$fc604aa353a97e10 = {}));
});
parcelRegister("iVEiS", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$d3d63fce8596c929$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $h2lEj = parcelRequire("h2lEj");
    const $d3d63fce8596c929$var$name = "platform-pkg";
    const $d3d63fce8596c929$var$version = "0.0.0-use.local";
    const $d3d63fce8596c929$var$payload = {
        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
        action: (0, $h2lEj.errorBoundaryAction),
        actionSubject: (0, $h2lEj.errorBoundaryActionSubject)
    };
    const $d3d63fce8596c929$var$context = [
        {
            source: $h2lEj.source
        },
        {
            packageName: $d3d63fce8596c929$var$name,
            packageVersion: $d3d63fce8596c929$var$version
        }
    ];
    class $d3d63fce8596c929$export$e926676385687eaf extends (0, $5uXOq.Component) {
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        componentDidCatch(error) {
            this.props.onAnalyticsEvent({
                payload: $d3d63fce8596c929$var$payload,
                context: $d3d63fce8596c929$var$context
            });
            if (this.props.onError) this.props.onError(error);
        }
        render() {
            if (this.state.hasError) return null;
            return this.props.children;
        }
        constructor(...args){
            super(...args), this.state = {
                hasError: false
            };
        }
    }
});
parcelRegister("h2lEj", function(module, exports) {
    $parcel$export(module.exports, "source", ()=>$9517cbf005e80ab1$export$b4d5da5f34fb77ad);
    $parcel$export(module.exports, "errorBoundaryAction", ()=>$9517cbf005e80ab1$export$9d8252a268f4fa72);
    $parcel$export(module.exports, "errorBoundaryActionSubject", ()=>$9517cbf005e80ab1$export$1045419caf49b395);
    $parcel$export(module.exports, "crossFlowActionSubject", ()=>$9517cbf005e80ab1$export$d54c183f56e39aa5);
    $parcel$export(module.exports, "uiInitialized", ()=>$9517cbf005e80ab1$export$e5c2c058fa8068a6);
    $parcel$export(module.exports, "openInvoked", ()=>$9517cbf005e80ab1$export$e67cdcb8867a3bd0);
    $parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", ()=>$676c5e519aa5ba55$export$12346a674644c156);
    const $9517cbf005e80ab1$export$b4d5da5f34fb77ad = 'crossFlowProvider';
    const $9517cbf005e80ab1$export$9d8252a268f4fa72 = 'errorCaught';
    const $9517cbf005e80ab1$export$1045419caf49b395 = 'errorBoundary';
    const $9517cbf005e80ab1$export$d54c183f56e39aa5 = 'crossFlowSupport';
    const $9517cbf005e80ab1$export$e5c2c058fa8068a6 = 'uiInitialized';
    const $9517cbf005e80ab1$export$e67cdcb8867a3bd0 = 'openInvoked';
});
parcelRegister("5cLUX", function(module, exports) {
    $parcel$export(module.exports, "enrichWithPackageDetails", ()=>$20ff5e7e37c2b429$export$59518efab336a8b5);
    const $20ff5e7e37c2b429$var$version = "0.0.0-use.local";
    const $20ff5e7e37c2b429$export$84f9cf7ef89d4c26 = {
        version: $20ff5e7e37c2b429$var$version
    };
    const $20ff5e7e37c2b429$export$59518efab336a8b5 = (event)=>{
        const attributes = {
            ...event.attributes || {},
            crossFlowSupport: $20ff5e7e37c2b429$export$84f9cf7ef89d4c26
        };
        return {
            ...event,
            attributes: attributes
        };
    };
});
parcelRegister("7TqdN", function(module, exports) {
    $parcel$export(module.exports, "enrichWithRequestOptions", ()=>$f9ac334198e2c83e$export$a5a156dc5df42f0);
    const $f9ac334198e2c83e$export$a5a156dc5df42f0 = (event, requestOptions)=>{
        if (!requestOptions) return event;
        const attributes = {
            ...requestOptions.extraAnalyticsAttributes || {},
            ...event.attributes || {},
            sourceComponent: requestOptions.sourceComponent,
            sourceContext: requestOptions.sourceContext
        };
        return {
            ...event,
            attributes: attributes
        };
    };
});
parcelRegister("2PFSu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("biYHu")
    ]).then(()=>parcelRequire('an4UX'));
});
parcelRegister("g2XuF", function(module, exports) {
    $parcel$export(module.exports, "getContainersPlugin", ()=>$014cd965663d7125$export$81d1d40061d190bc);
    parcelRequire("eZVkU");
    var $3DVw8 = parcelRequire("3DVw8");
    var $eZVkU = parcelRequire("eZVkU");
    var $4Pf62;
    const $014cd965663d7125$var$getCloudId = async ()=>{
        const { cloudName: cloudName, cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const containers = [
            {
                id: cloudId,
                displayName: cloudName,
                type: (0, $3DVw8.ContainerTypes).ATLASSIAN_CLOUD_ID
            }
        ];
        return {
            type: (0, $3DVw8.ContainerTypes).ATLASSIAN_CLOUD_ID,
            containers: containers
        };
    };
    const $014cd965663d7125$export$81d1d40061d190bc = (0, $eZVkU.createGetContainersPlugin)($014cd965663d7125$var$getCloudId);
});
parcelRegister("eZVkU", function(module, exports) {
    $parcel$export(module.exports, "createGetContainersPlugin", ()=>$b5c1d3bea11e821b$export$76378b0f825c024c);
    $parcel$export(module.exports, "createGetUsersPlugin", ()=>$b5c1d3bea11e821b$export$8feb7eae83cf8cd5);
    $parcel$export(module.exports, "ContainerTypes", ()=>(parcelRequire("3DVw8")).ContainerTypes);
    $parcel$export(module.exports, "UserIdTypes", ()=>(parcelRequire("3DVw8")).UserIdTypes);
    var $3DVw8 = parcelRequire("3DVw8");
    const $b5c1d3bea11e821b$export$76378b0f825c024c = (fetch)=>{
        return [
            (0, $3DVw8.PluginTypes).GetContainers,
            fetch
        ];
    };
    const $b5c1d3bea11e821b$export$8feb7eae83cf8cd5 = (fetch)=>{
        return [
            (0, $3DVw8.PluginTypes).GetUsers,
            fetch
        ];
    };
    const $b5c1d3bea11e821b$export$21d120847be2aff4 = (fetch)=>{
        return [
            (0, $3DVw8.PluginTypes).GetSuggestedSiteNames,
            fetch
        ];
    };
    const $b5c1d3bea11e821b$export$d7c1699c6a2ca18a = (fetch)=>{
        return [
            (0, $3DVw8.PluginTypes).GetAvailableSites,
            fetch
        ];
    };
});
parcelRegister("3DVw8", function(module, exports) {
    $parcel$export(module.exports, "PluginTypes", ()=>$f763104318ce258c$export$a235a73f7b906dce);
    $parcel$export(module.exports, "ContainerTypes", ()=>$f763104318ce258c$export$6e383182a26455ff);
    $parcel$export(module.exports, "UserIdTypes", ()=>$f763104318ce258c$export$e391bab95adb8396);
    const $f763104318ce258c$export$a235a73f7b906dce = {
        GetContainers: 'GetContainers',
        GetUsers: 'GetUsers',
        GetSuggestedSiteNames: 'GetSuggestedSiteNames',
        GetAvailableSites: 'GetAvailableSites'
    };
    const $f763104318ce258c$export$6e383182a26455ff = {
        BITBUCKET_WORKSPACE: 'bitbucket-workspace',
        ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
        JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
    };
    const $f763104318ce258c$export$e391bab95adb8396 = {
        ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
        TRELLO_ID: 'TRELLO_ID'
    };
    const $f763104318ce258c$export$4f378ba35c571906 = {
        JIRA_BUSINESS: 'JIRA_BUSINESS',
        JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
        JIRA_SOFTWARE: 'JIRA_SOFTWARE',
        CONFLUENCE: 'CONFLUENCE',
        OPSGENIE: 'OPSGENIE',
        BITBUCKET: 'BITBUCKET',
        STATUSPAGE: 'STATUSPAGE',
        TRELLO: 'TRELLO',
        COMPASS: 'COMPASS'
    };
});
parcelRegister("5emZd", function(module, exports) {
    $parcel$export(module.exports, "getUsersPlugin", ()=>$83dd2c216cba0381$export$7c44908d2777db01);
    var $eZVkU = parcelRequire("eZVkU");
    var $3DVw8 = parcelRequire("3DVw8");
    const $83dd2c216cba0381$var$getUsers = async (containerId)=>{
        const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
        try {
            const response = await fetch(getUsersUrl, {
                credentials: 'same-origin'
            });
            if (response.ok) {
                const data = await response.json();
                return data.map((value)=>({
                        id: value.id,
                        idType: (0, $3DVw8.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                        displayName: value.displayName
                    }));
            }
            throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
        } catch (error) {
            throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
        }
    };
    const $83dd2c216cba0381$export$7c44908d2777db01 = (0, $eZVkU.createGetUsersPlugin)($83dd2c216cba0381$var$getUsers);
});
parcelRegister("2HbP2", function(module, exports) {
    $parcel$export(module.exports, "ModalContextProvider", ()=>$d012230882eb31a4$export$7c9538f5f3c365e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Qvm;
    var $gJdig;
    function $d012230882eb31a4$export$7c9538f5f3c365e9({ children: children }) {
        const id = (0, $5uXOq.useRef)(1);
        const [modals, setModals] = (0, $5uXOq.useState)([]);
        const modalContext = (0, $5uXOq.useMemo)(()=>({
                openModal: (component)=>{
                    const key = String(id.current++);
                    const close = ()=>{
                        setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                    };
                    setModals((mdls)=>[
                            ...mdls,
                            {
                                close: close,
                                component: component,
                                key: key
                            }
                        ]);
                }
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gJdig")).ModalContext).Provider, {
            value: modalContext
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, modals.map((modal)=>(0, ($parcel$interopDefault($5uXOq))).createElement(modal.component, {
                key: modal.key,
                onClose: modal.close
            }))));
    }
});
parcelRegister("gJdig", function(module, exports) {
    $parcel$export(module.exports, "ModalContext", ()=>$308ba6e6ba886f08$export$ab57792b9b6974a6);
    var $5uXOq = parcelRequire("5uXOq");
    const $308ba6e6ba886f08$export$ab57792b9b6974a6 = (0, $5uXOq.createContext)({
        openModal: ()=>{}
    });
});
parcelRegister("ivvwC", function(module, exports) {
    $parcel$export(module.exports, "UserContainers", ()=>$0fd080febb09e205$export$c1b371eec908681a);
    var $5uXOq = parcelRequire("5uXOq");
    var $d9VAQ;
    var $leRCk;
    const $0fd080febb09e205$export$c1b371eec908681a = ({ baseUrl: baseUrl, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("leRCk")).UserContainer), {
            isGlobal: true,
            baseUrl: baseUrl
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9VAQ")).UserPreferencesContainer), {
            isGlobal: true
        }, children));
});
parcelRegister("d9VAQ", function(module, exports) {
    $parcel$export(module.exports, "UserPreferencesContainer", ()=>$3038471ea054300f$export$aa278641ded1adf);
    var $gg7kZ;
    var $51nlc;
    var $eYegl;
    const $3038471ea054300f$export$be74e04eaea4530 = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("eYegl")).default), {
        displayName: 'UserPreferencesSubscriber'
    });
    const $3038471ea054300f$export$aa278641ded1adf = (0, (0, parcelRequire("gg7kZ")).createContainer)((0, (0, parcelRequire("eYegl")).default));
});
parcelRegister("eYegl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc414d73e667f785$export$2e2bcd8739ae039);
    var $iXqE5;
    var $7AJyg;
    const $bc414d73e667f785$var$initialState = {
        'issue-view-experiment': {
            data: {
                value: false
            },
            loading: false,
            error: null
        }
    };
    var $bc414d73e667f785$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'user-preference',
        initialState: $bc414d73e667f785$var$initialState,
        actions: (0, parcelRequire("7AJyg"))
    });
});
parcelRegister("7AJyg", function(module, exports) {
    $parcel$export(module.exports, "fetch", ()=>(parcelRequire("g6Vt5")).default);
    $parcel$export(module.exports, "fetchIssueCreate", ()=>(parcelRequire("ePV4l")).default);
    $parcel$export(module.exports, "updateExperiment", ()=>(parcelRequire("8Lrq8")).default);
    var $g6Vt5;
    var $ePV4l;
    var $8Lrq8;
});
parcelRegister("g6Vt5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a561c8a03710a3f2$export$2e2bcd8739ae039);
    var $goEOn;
    var $a561c8a03710a3f2$export$2e2bcd8739ae039 = (preferenceKey)=>async ({ setState: setState, getState: getState }, { baseUrl: baseUrl })=>{
            const currentState = getState();
            if (currentState[preferenceKey] && currentState[preferenceKey].loading) return;
            setState({
                [preferenceKey]: {
                    data: currentState.data,
                    loading: true,
                    error: null
                }
            });
            try {
                const data = await (0, (0, parcelRequire("goEOn")).default)({
                    baseUrl: baseUrl,
                    preferenceKey: preferenceKey
                });
                setState({
                    [preferenceKey]: {
                        data: data,
                        loading: false,
                        error: null
                    }
                });
            } catch (err) {
                setState({
                    [preferenceKey]: {
                        data: getState().data,
                        loading: false,
                        error: err
                    }
                });
            }
        };
});
parcelRegister("goEOn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0be3c96b3fac1b7f$export$2e2bcd8739ae039);
    var $4Lzq2;
    var $0be3c96b3fac1b7f$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, preferenceKey: preferenceKey })=>{
        try {
            const result = await (0, (0, parcelRequire("4Lzq2")).default)(baseUrl, preferenceKey);
            return {
                value: result
            };
        } catch (e) {
            if (e.statusCode === 404) return {
                value: undefined
            };
            throw e;
        }
    };
});
parcelRegister("4Lzq2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efdd8b3604a0d493$export$2e2bcd8739ae039);
    var $eusud;
    var $efdd8b3604a0d493$export$2e2bcd8739ae039 = (baseUrl, key)=>{
        const requestUrl = `${baseUrl}/rest/api/3/mypreferences?key=${key}`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(requestUrl);
    };
});
parcelRegister("ePV4l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01fcb0eb90bce4cf$export$2e2bcd8739ae039);
    var $g6Vt5;
    var $01fcb0eb90bce4cf$export$2e2bcd8739ae039 = ()=>(0, (0, parcelRequire("g6Vt5")).default)('issue-create');
});
parcelRegister("8Lrq8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aea442a302ef98b1$export$2e2bcd8739ae039);
    var $aea442a302ef98b1$export$2e2bcd8739ae039 = (experimentKey, value)=>({ setState: setState })=>{
            setState({
                [experimentKey]: {
                    data: {
                        value: value
                    },
                    loading: false,
                    error: null
                }
            });
        };
});
parcelRegister("62C9r", function(module, exports) {
    $parcel$export(module.exports, "HorizontalNav", ()=>$df8ca37c4f42ad24$export$3821fe730064297d);
    $parcel$export(module.exports, "HorizontalNavWrapper", ()=>$df8ca37c4f42ad24$export$8798384053a023ae);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cPiXk;
    var $cM67N;
    var $erBFB;
    const $df8ca37c4f42ad24$var$NavErrorBoundaryFallback = ()=>null;
    const $df8ca37c4f42ad24$export$3821fe730064297d = ()=>{
        const HorizontalNavComponent = (0, (0, parcelRequire("cPiXk")).useHorizontalNavComponent)();
        return HorizontalNavComponent && $5uXOq.createElement((0, (0, parcelRequire("cM67N")).NavErrorBoundary), {
            packageName: "page-container",
            id: "spa-horizontal-nav",
            fallback: $df8ca37c4f42ad24$var$NavErrorBoundaryFallback
        }, $5uXOq.createElement((0, (0, parcelRequire("cM67N")).NavErrorBoundary), {
            packageName: "page-container",
            id: "projectNavigationSkipLink",
            fallback: "unmount"
        }, $5uXOq.createElement((0, (0, parcelRequire("erBFB")).ProjectViewNavigationSkipLink), null)), $5uXOq.createElement(HorizontalNavComponent, null));
    };
    const $df8ca37c4f42ad24$export$8798384053a023ae = ({ children: children, navComponent: HorizontalNavComponent })=>{
        return $5uXOq.createElement($df8ca37c4f42ad24$var$ThemedContainer, null, $5uXOq.createElement((0, (0, parcelRequire("cM67N")).NavErrorBoundary), {
            packageName: "page-container",
            id: "spa-horizontal-nav",
            fallback: $df8ca37c4f42ad24$var$NavErrorBoundaryFallback
        }, $5uXOq.createElement((0, (0, parcelRequire("cM67N")).NavErrorBoundary), {
            packageName: "page-container",
            id: "projectNavigationSkipLink",
            fallback: "unmount"
        }, $5uXOq.createElement((0, (0, parcelRequire("erBFB")).ProjectViewNavigationSkipLink), null)), $5uXOq.createElement(HorizontalNavComponent, null)), children);
    };
    const $df8ca37c4f42ad24$var$ThemedContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q7mmei _11q31r52 _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cM67N", function(module, exports) {
    $parcel$export(module.exports, "NavErrorBoundary", ()=>$5ad940bec1d10db7$export$afc779e659fd533f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $jcw0u;
    var $7XYc4;
    var $4R6GH;
    var $3HwlS;
    var $dCm1o;
    function $5ad940bec1d10db7$var$getRelevantFFlagsForObservability20240814() {
        return [
            [
                'jira_nav4',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4')
            ],
            [
                'jira_nav4_dogfooding',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding')
            ],
            [
                'jira_nav4_dogfooding_phase-1',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-1')
            ],
            [
                'jira_nav4_dogfooding_phase-2',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-2')
            ]
        ];
    }
    function $5ad940bec1d10db7$var$getRelevantFFlagsForObservability20241025() {
        return [
            [
                'getWillShowNav4()',
                (0, (0, parcelRequire("3HwlS")).getWillShowNav4)()
            ],
            [
                'jira_nav4_dogfooding',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding')
            ],
            [
                'jira_nav4_eap',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap')
            ],
            [
                'jira_nav4_eap_drop_1',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_1')
            ],
            [
                'jira_nav4_eap_drop_2',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2')
            ],
            [
                'jira_nav4_beta_drop_1',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1')
            ],
            [
                'jira_nav4_beta_drop_2',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2')
            ],
            [
                'isVisualRefreshEnabled()',
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
            ]
        ];
    }
    const $5ad940bec1d10db7$export$1d1321d2b374d697 = ()=>{
        if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
        if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
        return false;
    };
    function $5ad940bec1d10db7$var$inferNavRevision() {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? 'v4' : 'v3';
    }
    function $5ad940bec1d10db7$var$getExtraAttributes(_error) {
        const relevantFFlags = (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? $5ad940bec1d10db7$var$getRelevantFFlagsForObservability20241025() : $5ad940bec1d10db7$var$getRelevantFFlagsForObservability20240814();
        const attributes = {
            ffs: relevantFFlags.filter(([, value])=>value).map(([key])=>key).join(),
            rev: $5ad940bec1d10db7$var$inferNavRevision()
        };
        return attributes;
    }
    function $5ad940bec1d10db7$var$getAnalyticsPayload(error, meta, navRevision) {
        const payload = {
            error: error,
            meta: {
                id: 'logic',
                packageName: 'JiraNav'
            },
            attributes: {
                ...$5ad940bec1d10db7$var$getExtraAttributes(error),
                pkg: meta.packageName,
                id: meta.id,
                ...navRevision && {
                    rev: navRevision
                }
            },
            skipSentry: true
        };
        return payload;
    }
    const $5ad940bec1d10db7$export$5ac21f1e947e70d6 = (props)=>{
        const { id: id, packageName: packageName, navRevision: navRevision } = props;
        const onError = (0, $5uXOq.useMemo)(()=>{
            const meta = {
                id: id,
                packageName: packageName
            };
            const _onError = (...args)=>{
                if ($5ad940bec1d10db7$export$1d1321d2b374d697()) return;
                const [_, error] = args;
                (0, (0, parcelRequire("jcw0u")).default)($5ad940bec1d10db7$var$getAnalyticsPayload(error, meta, navRevision));
            };
            return _onError;
        }, [
            id,
            packageName,
            navRevision
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            ...props,
            onError: onError
        });
    };
    const $5ad940bec1d10db7$export$afc779e659fd533f = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5ad940bec1d10db7$export$5ac21f1e947e70d6, props), (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), props));
});
parcelRegister("erBFB", function(module, exports) {
    $parcel$export(module.exports, "TopNavigationSkipLink", ()=>$cd61d83e2e343ff1$export$47de2191d46337b7);
    $parcel$export(module.exports, "LeftSidebarSkipLink", ()=>$cd61d83e2e343ff1$export$46697df0d7c5e8be);
    $parcel$export(module.exports, "ProjectViewNavigationSkipLink", ()=>$cd61d83e2e343ff1$export$2e2fc9c237996c06);
    $parcel$export(module.exports, "MainContentSkipLink", ()=>$cd61d83e2e343ff1$export$b1498dd122ea3284);
    var $koVbs;
    var $iqLcb;
    var $lOt1w;
    const $cd61d83e2e343ff1$export$47de2191d46337b7 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, (0, parcelRequire("iqLcb")).useCustomSkipLink)('ak-jira-navigation', formatMessage((0, (0, parcelRequire("lOt1w")).default).skipToJiraNavigation), 0);
        return null;
    };
    const $cd61d83e2e343ff1$export$46697df0d7c5e8be = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, (0, parcelRequire("iqLcb")).useCustomSkipLink)('ak-side-navigation', formatMessage((0, (0, parcelRequire("lOt1w")).default).skipToSideNavigation), 1);
        return null;
    };
    const $cd61d83e2e343ff1$export$2e2fc9c237996c06 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, (0, parcelRequire("iqLcb")).useCustomSkipLink)('ak-project-view-navigation', formatMessage((0, (0, parcelRequire("lOt1w")).default).skipToProjectViewNavigation), 2);
        return null;
    };
    const $cd61d83e2e343ff1$export$b1498dd122ea3284 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, (0, parcelRequire("iqLcb")).useCustomSkipLink)('ak-main-content', formatMessage((0, (0, parcelRequire("lOt1w")).default).skipToMainContent), 3);
        return null;
    };
});
parcelRegister("lOt1w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d368a0de790f751$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2d368a0de790f751$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        skipToJiraNavigation: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-jira-navigation",
            "defaultMessage": "Skip to Jira Navigation"
        },
        skipToSideNavigation: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-side-navigation",
            "defaultMessage": "Skip to Side Navigation"
        },
        skipToProjectViewNavigation: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-project-view-navigation",
            "defaultMessage": "Skip to View Navigation"
        },
        skipToMainContent: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-main-content",
            "defaultMessage": "Skip to Main Content"
        }
    });
});
parcelRegister("4s15Z", function(module, exports) {
    $parcel$export(module.exports, "RightSidebar", ()=>$ac6bd493ba1cffad$export$84d58c19c21f637f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $2Ioew;
    var $frBVt;
    var $7CMCs;
    var $7XYc4;
    var $hsmeR;
    var $3HwlS;
    var $iqLcb;
    var $6jY6G;
    var $8zOmE;
    var $2NMNM;
    var $aPfsS;
    var $gAaIa;
    var $6raju;
    var $l8ruj;
    const $ac6bd493ba1cffad$var$TEST_ID = 'page-layout.aside';
    const $ac6bd493ba1cffad$var$routeComponents = [];
    const $ac6bd493ba1cffad$var$SharedRightSidebars = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("aPfsS")).renderGlobalComponents)((0, (0, parcelRequire("gAaIa")).sharedLayout).rightSidebars));
    const $ac6bd493ba1cffad$var$RightSidebarRouteComponents = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("aPfsS")).renderGlobalComponents)(route.layout?.rightSidebars || $ac6bd493ba1cffad$var$routeComponents));
    };
    const $ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint = ()=>{
        const rightSideBarEntryPoint = (0, (0, parcelRequire("2Ioew")).usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb));
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const entrypoint = (0, $5uXOq.useMemo)(()=>route.entryPoint?.(), [
            route
        ]);
        if (!entrypoint || !rightSideBarEntryPoint) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "right-sidebar-through-entrypoint"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-through-entrypoint",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholder), {
            name: "right-sidebar-through-entrypoint",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6raju")).ProjectListSidebarSkeleton), null),
            entryPoint: entrypoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: rightSideBarEntryPoint,
            props: {}
        }))));
    };
    const $ac6bd493ba1cffad$var$NewRightSidebar = ()=>{
        const lastPanelIdRef = (0, $5uXOq.useRef)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
                panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
                isClosed: rightSidebarCurrentState?.panelId == null,
                isMinimised: !!rightSidebarCurrentState?.isMinimised,
                isCollapsed: !!rightSidebarCurrentState?.isCollapsed
            });
            lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
        }, [
            createAnalyticsEvent,
            rightSidebarCurrentState?.panelId,
            rightSidebarCurrentState?.isMinimised,
            rightSidebarCurrentState?.isCollapsed
        ]);
        if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "right-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).RightPanel), {
            width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0,
            testId: $ac6bd493ba1cffad$var$TEST_ID
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "shared-right-sidebars",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$SharedRightSidebars, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-route-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarRouteComponents, null)), (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint, null))));
    };
    const $ac6bd493ba1cffad$var$OldRightSidebar = ()=>{
        const lastPanelIdRef = (0, $5uXOq.useRef)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
                panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
                isClosed: rightSidebarCurrentState?.panelId == null,
                isMinimised: !!rightSidebarCurrentState?.isMinimised,
                isCollapsed: !!rightSidebarCurrentState?.isCollapsed
            });
            lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
        }, [
            createAnalyticsEvent,
            rightSidebarCurrentState?.panelId,
            rightSidebarCurrentState?.isMinimised,
            rightSidebarCurrentState?.isCollapsed
        ]);
        if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "right-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarPanelWrapper, {
            id: "right-sidebar-panel-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).RightSidebar), {
            width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "shared-right-sidebars",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$SharedRightSidebars, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-route-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarRouteComponents, null)), (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint, null)))));
    };
    const $ac6bd493ba1cffad$var$RightSidebarPanelWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1bgi _1ej2b4wl _iu1g1fl4",
                __cmplp.className
            ])
        });
    });
    const $ac6bd493ba1cffad$export$84d58c19c21f637f = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $ac6bd493ba1cffad$var$NewRightSidebar, $ac6bd493ba1cffad$var$OldRightSidebar);
});
const $6d6ccf8a2b2c5b3c$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $6d6ccf8a2b2c5b3c$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';
parcelRegister("2Ioew", function(module, exports) {
    $parcel$export(module.exports, "usePageLayoutEntryPoint", ()=>$dcf886ac39f7cfda$export$fe1c839e8baf4110);
    var $h22md;
    var $6jY6G;
    const $dcf886ac39f7cfda$export$fe1c839e8baf4110 = (layoutField)=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const entryPointReference = (0, (0, parcelRequire("h22md")).useRouteEntryPoint)({
            route: route
        });
        return entryPointReference?.entryPoints[layoutField];
    };
});
parcelRegister("h22md", function(module, exports) {
    $parcel$export(module.exports, "useRouteEntryPoint", ()=>$4e1bc9edc261b42d$export$c96377f800cdddb4);
    var $3I4nj;
    const $4e1bc9edc261b42d$export$c96377f800cdddb4 = ({ route: route })=>{
        const [lastLoadedRoute] = (0, (0, parcelRequire("3I4nj")).useLastLoadedRoute)();
        if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
        return null;
    };
});
parcelRegister("3I4nj", function(module, exports) {
    $parcel$export(module.exports, "useLastLoadedRoute", ()=>$f09634e8d32626d1$export$895238443fc3eae4);
    $parcel$export(module.exports, "getEntryPointsStore", ()=>$f09634e8d32626d1$export$fe654a734624d17f);
    $parcel$export(module.exports, "getLastLoadedRoute", ()=>$f09634e8d32626d1$export$5763b2305b3056df);
    $parcel$export(module.exports, "getPrefetchingRoute", ()=>$f09634e8d32626d1$export$7e18f3e3cbd04326);
    var $3sQ5x;
    var $iXqE5;
    var $bKpgX;
    const $f09634e8d32626d1$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
            setState({
                lastLoadedRoute: {
                    route: route,
                    entryPointReference: entryPointReference
                }
            });
        };
    const $f09634e8d32626d1$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
            setState({
                prefetchingRoute: {
                    routerContext: routerContext,
                    expiresAt: expiresAt,
                    entryPointReference: entryPointReference
                }
            });
        };
    const $f09634e8d32626d1$var$actions = {
        setLastLoadedRoute: $f09634e8d32626d1$export$1cec83a23d40a9fa,
        setPrefetchingRoute: $f09634e8d32626d1$export$bb3dc9c55f78173e
    };
    const $f09634e8d32626d1$var$EntryPointsStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            lastLoadedRoute: null,
            prefetchingRoute: null
        },
        actions: $f09634e8d32626d1$var$actions,
        name: 'react-resource-router/entry-points'
    });
    const $f09634e8d32626d1$export$895238443fc3eae4 = (0, (0, parcelRequire("3sQ5x")).createHook)($f09634e8d32626d1$var$EntryPointsStore, {
        selector: (state)=>state.lastLoadedRoute
    });
    const $f09634e8d32626d1$export$fe654a734624d17f = ()=>(0, (0, parcelRequire("bKpgX")).defaultRegistry).getStore($f09634e8d32626d1$var$EntryPointsStore);
    const $f09634e8d32626d1$export$b28ecd0e4705f6b7 = ()=>$f09634e8d32626d1$export$fe654a734624d17f().storeState.getState();
    const $f09634e8d32626d1$export$5763b2305b3056df = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().lastLoadedRoute;
    const $f09634e8d32626d1$export$7e18f3e3cbd04326 = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().prefetchingRoute;
});
parcelRegister("6raju", function(module, exports) {
    $parcel$export(module.exports, "ProjectListSidebarSkeleton", ()=>$be14de1be79b27e3$export$808c25bcc6102427);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $d8ped = parcelRequire("d8ped");
    const $be14de1be79b27e3$var$customCssStyles = null;
    const $be14de1be79b27e3$var$sidebarCssStyles = null;
    const $be14de1be79b27e3$export$808c25bcc6102427 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1bsb1gwv _1yt41ejb _t6vdt94y _1p3lnqa1 _5wramuej _bfhkvuon _vchhusvi"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($d8ped))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_t6vdidpf _hr4jidpf"
            ])
        }));
});
parcelRegister("d8ped", function(module, exports) {
    module.exports = new URL("project-list-sidebar-app-skeleton.tpl.35da4e26.svg", import.meta.url).toString();
});
parcelRegister("eF0qp", function(module, exports) {
    $parcel$export(module.exports, "Sidebar", ()=>$803f61b5dea1399f$export$1ba59dacbcbf90fe);
    var $fZBia;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $ajpes = parcelRequire("ajpes");
    var $8Uumt = parcelRequire("8Uumt");
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $5YdvQ;
    var $5e7oM;
    var $azzrO;
    var $gwIPs;
    var $7CMCs;
    var $7XYc4;
    var $4R6GH;
    var $pa9q9;
    var $aWse0;
    var $gPQRI;
    var $5e5zm;
    var $2fwuR;
    var $acDan;
    var $c6x3L;
    var $3HwlS;
    var $jHUgj;
    var $4DrQd;
    var $eGkew;
    var $iqLcb;
    var $ht71P;
    var $lfTZh;
    var $6jY6G;
    var $ao2h1;
    var $5M3R9;
    var $4V52L;
    var $16v4H;
    var $cZpsT;
    var $l8ruj;
    var $3AWiS;
    var $kTus1;
    var $lsO24;
    var $erBFB;
    var $gxq4u;
    var $7x18A;
    const $803f61b5dea1399f$var$footerStyles = {
        root: "_bfhkhp5a"
    };
    const $803f61b5dea1399f$var$SidebarNew = ()=>{
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        const { queryReference: queryReference } = (0, (0, parcelRequire("ao2h1")).useRelayResource)((0, (0, parcelRequire("2fwuR")).sidebarNav4UiStateResource));
        if (isAnonymous) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.sidebar.anonymous"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).PlaceholderNew), {
            name: "sidebar.anonymous"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternalAnonymous, null)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).PlaceholderNew), {
            name: "sidebar"
        }, queryReference ? (0, ($parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternal, {
            queryReference: queryReference
        }) : null));
    };
    const $803f61b5dea1399f$var$SidebarInternalAnonymous = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const defaultCollapsed = false;
        const defaultWidth = 340;
        const [, { setLeftSidebarState: setLeftSidebarState }] = (0, (0, parcelRequire("5e5zm")).useLayoutStoreActions)();
        const onExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: false
            });
        }, [
            setLeftSidebarState
        ]);
        const onCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: true
            });
        }, [
            setLeftSidebarState
        ]);
        const onResizeEnd = (0, $5uXOq.useCallback)(({ finalWidth: finalWidth })=>{
            setLeftSidebarState({
                width: finalWidth
            });
        }, [
            setLeftSidebarState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c6x3L")).SidebarNav4ContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kTus1")).SideNav), {
            testId: $803f61b5dea1399f$var$TEST_ID,
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            onExpand: onExpand,
            onCollapse: onCollapse
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHUgj")).SidebarSelector), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3AWiS")).PanelSplitter), {
            label: formatMessage((0, (0, parcelRequire("gxq4u")).messages).sideBarPanelSplitterLabel),
            onResizeEnd: onResizeEnd
        })));
    };
    const $803f61b5dea1399f$var$TEST_ID = 'page-layout.sidebar';
    const $803f61b5dea1399f$var$SidebarInternal = ({ queryReference: queryReference })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const subProduct = (0, (0, parcelRequire("16v4H")).useSubProduct)();
        const data = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("fZBia")).default), queryReference);
        const defaultCollapsed = data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, (0, parcelRequire("4DrQd")).IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
        const defaultWidth = data?.jira?.navigationUIState?.leftSidebarWidth ?? (0, (0, parcelRequire("4DrQd")).LEFT_SIDEBAR_EXPANDED_MIN_WIDTH);
        const [, { setLeftSidebarState: setLeftSidebarState }] = (0, (0, parcelRequire("5e5zm")).useLayoutStoreActions)();
        const onExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: false
            });
        }, [
            setLeftSidebarState
        ]);
        const onCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: true
            });
        }, [
            setLeftSidebarState
        ]);
        const onResizeEnd = (0, $5uXOq.useCallback)(({ finalWidth: finalWidth })=>{
            setLeftSidebarState({
                width: finalWidth
            });
        }, [
            setLeftSidebarState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c6x3L")).SidebarNav4ContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kTus1")).SideNav), {
            testId: $803f61b5dea1399f$var$TEST_ID,
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            onExpand: onExpand,
            onCollapse: onCollapse
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHUgj")).SidebarSelector), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lsO24")).SideNavFooter), {
            xcss: $803f61b5dea1399f$var$footerStyles.root
        }, (0, (0, parcelRequire("4R6GH")).fg)('jira_global_invite_nav4') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $803f61b5dea1399f$var$globalInviteButtonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5YdvQ")).GlobalInvite), {
            testId: "page-container-v2.common.ui.sidebar.global-invite",
            product: "jira",
            subProduct: subProduct ?? undefined,
            showFlag: showFlag
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4V52L")).SidebarFeedbackButton), null)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4V52L")).SidebarFeedbackButton), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3AWiS")).PanelSplitter), {
            label: formatMessage((0, (0, parcelRequire("gxq4u")).messages).sideBarPanelSplitterLabel),
            onResizeEnd: onResizeEnd
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ht71P")).AsyncNudgeBundledUsersFlagContainer), null)));
    };
    const $803f61b5dea1399f$var$SIDEBAR_TEST_ID = 'ContextualNavigation';
    const $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY = 'sidebar';
    const $803f61b5dea1399f$var$sidebarOverrides = {
        ResizeButton: {
            render: (Component, props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                    id: "sidebar-resize-tooltip",
                    packageName: "page-container",
                    fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, props)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                    name: "side_bar_button",
                    fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7x18A")).AsyncResizeButtonTooltip), {
                    isLeftSidebarCollapsed: props.isLeftSidebarCollapsed
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props))))
        }
    };
    const $803f61b5dea1399f$var$SidebarInternalOld = ({ sidebar: sidebar })=>{
        const { width: width, isCollapsed: isCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const intl = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const shouldNotRenderSidebarInServerSide = false && isCollapsed;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "left-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarStyleOverrides, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "leftSidebarSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).LeftSidebarSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).LeftSidebar), {
            isFixed: true,
            width: width,
            testId: $803f61b5dea1399f$var$SIDEBAR_TEST_ID,
            resizeButtonLabel: intl.formatMessage((0, (0, parcelRequire("gxq4u")).messages).sidebarNavigation),
            collapsedState: isCollapsed ? 'collapsed' : 'expanded',
            overrides: $803f61b5dea1399f$var$sidebarOverrides,
            id: "ak-side-navigation"
        }, !shouldNotRenderSidebarInServerSide && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, route !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "start",
            traceKey: $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY
        })), sidebar, route !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarSSRPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "end",
            traceKey: $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY
        }))))));
    };
    const $803f61b5dea1399f$var$SidebarInternalOldMemo = (0, $5uXOq.memo)($803f61b5dea1399f$var$SidebarInternalOld, (0, ($parcel$interopDefault($ajpes))));
    const $803f61b5dea1399f$var$renderChildren = (sidebar)=>sidebar !== null ? (0, ($parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternalOldMemo, {
            sidebar: sidebar
        }) : null;
    const $803f61b5dea1399f$var$SidebarOld = ()=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eGkew")).SidebarSelectorProvider), {
            sidebar: route.navigation?.sidebar ?? null
        }, $803f61b5dea1399f$var$renderChildren);
    };
    const $803f61b5dea1399f$export$1ba59dacbcbf90fe = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $803f61b5dea1399f$var$SidebarNew, $803f61b5dea1399f$var$SidebarOld);
    const $803f61b5dea1399f$var$SidebarStyleOverrides = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1d7w7yr": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("gwIPs")).layers).leftSidebar)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1pbyg9ti _14c1glyw",
                __cmplp.className
            ])
        });
    });
    const $803f61b5dea1399f$var$globalInviteButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexGrow: 1
    });
});
parcelRegister("5YdvQ", function(module, exports) {
    $parcel$export(module.exports, "GlobalInvite", ()=>$8db6209b69a4dd79$export$93cb436db3d27b7e);
    var $5uXOq = parcelRequire("5uXOq");
    var $f4cXA;
    var $4pmnu;
    var $g9BbE;
    var $d04El;
    const $8db6209b69a4dd79$var$LazyGlobalInviteModalDialogContent = (0, $5uXOq.lazy)(()=>(parcelRequire("ga8ZJ")).then((module)=>({
                default: module.ModalDialogContent
            })));
    function $8db6209b69a4dd79$var$AsyncGlobalInviteModalDialogContent(props) {
        return $5uXOq.createElement((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
            fallback: $5uXOq.createElement((0, (0, parcelRequire("4pmnu")).ErrorState), null)
        }, $5uXOq.createElement((0, $5uXOq.Suspense), {
            fallback: $5uXOq.createElement((0, (0, parcelRequire("g9BbE")).LoadingState), null)
        }, $5uXOq.createElement($8db6209b69a4dd79$var$LazyGlobalInviteModalDialogContent, props)));
    }
    const $8db6209b69a4dd79$export$93cb436db3d27b7e = (0, (0, parcelRequire("d04El")).withModalDialog)($8db6209b69a4dd79$var$AsyncGlobalInviteModalDialogContent);
});
parcelRegister("f4cXA", function(module, exports) {
    (function(global, factory) {
        factory(module.exports, (parcelRequire("5uXOq")));
    })(module.exports, function(exports1, React) {
        'use strict';
        function _interopNamespace(e) {
            if (e && e.__esModule) return e;
            var n = Object.create(null);
            if (e) Object.keys(e).forEach(function(k) {
                if (k !== 'default') {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function() {
                            return e[k];
                        }
                    });
                }
            });
            n["default"] = e;
            return Object.freeze(n);
        }
        var React__namespace = _interopNamespace(React);
        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return _setPrototypeOf(o, p);
        }
        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass);
        }
        var changedArray = function changedArray(a, b) {
            if (a === void 0) a = [];
            if (b === void 0) b = [];
            return a.length !== b.length || a.some(function(item, index) {
                return !Object.is(item, b[index]);
            });
        };
        var initialState = {
            error: null
        };
        var ErrorBoundary = function(_React$Component) {
            _inheritsLoose(ErrorBoundary, _React$Component);
            function ErrorBoundary() {
                var _this;
                for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(_args)) || this;
                _this.state = initialState;
                _this.resetErrorBoundary = function() {
                    var _this$props;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                    _this.reset();
                };
                return _this;
            }
            ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            };
            var _proto = ErrorBoundary.prototype;
            _proto.reset = function reset() {
                this.setState(initialState);
            };
            _proto.componentDidCatch = function componentDidCatch(error, info) {
                var _this$props$onError, _this$props2;
                (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
            };
            _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
                var error = this.state.error;
                var resetKeys = this.props.resetKeys;
                if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                    var _this$props$onResetKe, _this$props3;
                    (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                    this.reset();
                }
            };
            _proto.render = function render() {
                var error = this.state.error;
                var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
                if (error !== null) {
                    var _props = {
                        error: error,
                        resetErrorBoundary: this.resetErrorBoundary
                    };
                    if (React__namespace.isValidElement(fallback)) return fallback;
                    else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                    else if (FallbackComponent) return React__namespace.createElement(FallbackComponent, _props);
                    else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
                }
                return this.props.children;
            };
            return ErrorBoundary;
        }(React__namespace.Component);
        function withErrorBoundary(Component, errorBoundaryProps) {
            var Wrapped = function Wrapped(props) {
                return React__namespace.createElement(ErrorBoundary, errorBoundaryProps, React__namespace.createElement(Component, props));
            };
            var name = Component.displayName || Component.name || 'Unknown';
            Wrapped.displayName = "withErrorBoundary(" + name + ")";
            return Wrapped;
        }
        function useErrorHandler(givenError) {
            var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
            if (givenError != null) throw givenError;
            if (error != null) throw error;
            return setError;
        }
        exports1.ErrorBoundary = ErrorBoundary;
        exports1.useErrorHandler = useErrorHandler;
        exports1.withErrorBoundary = withErrorBoundary;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    });
});
parcelRegister("4pmnu", function(module, exports) {
    $parcel$export(module.exports, "ErrorState", ()=>$12ac31c3f5776fed$export$c1ed4f415b9e7023);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $l1N8i;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $cWIaC;
    const $12ac31c3f5776fed$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlock: 'space.1000',
        paddingInline: 'space.100',
        textAlign: 'center'
    });
    function $12ac31c3f5776fed$export$c1ed4f415b9e7023() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return $5uXOq.createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.050",
            testId: "global-invite--error-state",
            xcss: $12ac31c3f5776fed$var$styles
        }, $5uXOq.createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("cWIaC")).messages).errorStateHeading)), $5uXOq.createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            color: "color.text.subtle"
        }, formatMessage((0, (0, parcelRequire("cWIaC")).messages).errorStateDescription)));
    }
});
parcelRegister("cWIaC", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$ab5f16cf436290aa$export$defe85febe8b728c);
    var $7VHMR;
    const $ab5f16cf436290aa$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorStateHeading: {
            id: 'navigation.global-invite.error-state-heading',
            description: "Heading of the error state UI indicating we couldn't load the invite people widget.",
            defaultMessage: "We can't load the invite list right now"
        },
        errorStateDescription: {
            id: 'navigation.global-invite.error-state-description',
            description: "Description of the error state UI indicating we couldn't load the invite people widget.",
            defaultMessage: 'Try refreshing the page or contact us if the problem persists.'
        }
    });
});
parcelRegister("g9BbE", function(module, exports) {
    $parcel$export(module.exports, "LoadingState", ()=>$de01f18621face07$export$62aa48085237e36f);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $1DVhQ;
    var $jldZL;
    var $esr9c;
    const $de01f18621face07$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlock: 'space.500',
        paddingInline: 'space.300'
    });
    function $de01f18621face07$export$62aa48085237e36f() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const items = Array.from({
            length: 5
        }, (_, index)=>$5uXOq.createElement((0, (0, parcelRequire("1DVhQ")).default), {
                isShimmering: true,
                width: "100%",
                height: "var(--ds-space-200, 16px)",
                testId: "skeleton-shimmering",
                key: index
            }));
        return $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $de01f18621face07$var$styles,
            testId: "global-invite--loading-state"
        }, $5uXOq.createElement((0, (0, parcelRequire("jldZL")).default), null, formatMessage((0, (0, parcelRequire("esr9c")).messages).loadingLabel)), $5uXOq.createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            testId: "skeleton-group"
        }, items));
    }
});
parcelRegister("1DVhQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d4b6b583e25d0959$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $d4b6b583e25d0959$var$shimmerKeyframes = null;
    const $d4b6b583e25d0959$var$skeletonStyles = null;
    const $d4b6b583e25d0959$var$activeShimmerStyles = null;
    const $d4b6b583e25d0959$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
        const groupDataAttribute = groupName && `data-${groupName}`;
        return $5uXOq.createElement("div", {
            "data-testid": testId,
            style: {
                width: width,
                height: height,
                borderRadius: borderRadius,
                backgroundColor: color,
                '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
                '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
            },
            ...groupDataAttribute && {
                [groupDataAttribute]: 'true'
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
                isShimmering && "",
                isShimmering && "_j7hq1y0p"
            ])
        });
    };
    var $d4b6b583e25d0959$export$2e2bcd8739ae039 = $d4b6b583e25d0959$var$Skeleton;
});
parcelRegister("esr9c", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bf903bffddf301c6$export$defe85febe8b728c);
    var $7VHMR;
    const $bf903bffddf301c6$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        loadingLabel: {
            id: 'navigation.global-invite.loading-visually-hidden-label',
            description: 'Visually hidden text to indicate the invite people UI is loading.',
            defaultMessage: 'Loading'
        }
    });
});
parcelRegister("d04El", function(module, exports) {
    $parcel$export(module.exports, "withModalDialog", ()=>$961b14944ab8338e$export$2d7d84d397d9a585);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $eCeGD;
    var $1R1Ge;
    var $i8Qvm;
    var $kMruu;
    function $961b14944ab8338e$export$2d7d84d397d9a585(Content) {
        return function ModalDialog({ testId: testId = (0, $7d72a3ca9c13402e$export$bb76aeb9f599715c), triggerElement: TriggerElement, ...props }) {
            const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
            const [isModalDialogOpen, setIsModalDialogOpen] = (0, $5uXOq.useState)(false);
            const openModalDialog = (0, $5uXOq.useCallback)(()=>{
                setIsModalDialogOpen(true);
            }, []);
            const closeModalDialog = (0, $5uXOq.useCallback)(()=>{
                setIsModalDialogOpen(false);
            }, []);
            const focusDialog = (0, $5uXOq.useCallback)((node)=>{
                node.focus();
            }, []);
            return $5uXOq.createElement("div", {
                "data-testid": testId
            }, TriggerElement ? $5uXOq.createElement(TriggerElement, {
                onClick: openModalDialog
            }) : $5uXOq.createElement((0, (0, parcelRequire("eCeGD")).default), {
                shouldFitContainer: true,
                onClick: openModalDialog,
                testId: `${testId}--${(0, $7d72a3ca9c13402e$export$1dab7caa4b20a4cc)}`
            }, formatMessage((0, (0, parcelRequire("kMruu")).messages).triggerElementLabel)), $5uXOq.createElement((0, (0, parcelRequire("i8Qvm")).default), null, isModalDialogOpen ? $5uXOq.createElement((0, (0, parcelRequire("1R1Ge")).default), {
                width: "small",
                shouldScrollInViewport: true,
                shouldReturnFocus: true,
                onClose: closeModalDialog,
                autoFocus: false,
                onOpenComplete: focusDialog,
                testId: `${testId}--${(0, $7d72a3ca9c13402e$export$7622d28bacf170d1)}`
            }, $5uXOq.createElement(Content, {
                closeModalDialog: closeModalDialog,
                ...props
            })) : null));
        };
    }
});
const $7d72a3ca9c13402e$export$bb76aeb9f599715c = 'global-invite';
const $7d72a3ca9c13402e$export$7622d28bacf170d1 = 'modal-dialog';
const $7d72a3ca9c13402e$export$1dab7caa4b20a4cc = 'trigger-element';
parcelRegister("kMruu", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$58ea59d0f979843d$export$defe85febe8b728c);
    var $7VHMR;
    const $58ea59d0f979843d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        triggerElementLabel: {
            id: 'navigation.global-invite.trigger-element-label',
            description: 'Text content of the button that triggers the modal dialog.',
            defaultMessage: 'Invite people'
        }
    });
});
parcelRegister("ga8ZJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("78hhz")
    ]).then(()=>parcelRequire('iDk8M'));
});
parcelRegister("c6x3L", function(module, exports) {
    $parcel$export(module.exports, "SidebarNav4ContextProvider", ()=>$313dc1bbe6a8339e$export$ebf7cdfc2e83bcef);
    $parcel$export(module.exports, "useSidebarNav4", ()=>$313dc1bbe6a8339e$export$dc46c14934833db2);
    var $5uXOq = parcelRequire("5uXOq");
    var $doZTA;
    var $3Jbkp;
    var $fMcVX;
    var $7Ckoi;
    const $313dc1bbe6a8339e$var$SidebarNav4Context = (0, $5uXOq.createContext)(null);
    function $313dc1bbe6a8339e$export$ebf7cdfc2e83bcef(props) {
        const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
        const [routerContext] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const initialSelectedPath = (0, (0, parcelRequire("3Jbkp")).getInitialSelectedPath)(routerContext);
        const [selectedPath, setSelectedPath] = (0, $5uXOq.useState)(initialSelectedPath);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setSelectedPath((currentPath)=>{
                const newPath = (0, (0, parcelRequire("7Ckoi")).routeToSelectedPath)(routerContext);
                return currentPath.toString() === newPath.toString() ? currentPath : newPath;
            });
        }, [
            routerContext
        ]);
        const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
                isInitialSelectedPath: isInitialSelectedPath ?? (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath),
                isSelectedPath: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(selectedPath)
            }), [
            initialSelectedPath,
            isInitialSelectedPath,
            selectedPath
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($313dc1bbe6a8339e$var$SidebarNav4Context.Provider, {
            value: sidebarNav4Controller
        }, children);
    }
    function $313dc1bbe6a8339e$export$dc46c14934833db2() {
        const context = (0, $5uXOq.useContext)($313dc1bbe6a8339e$var$SidebarNav4Context);
        if (context == null) throw new Error('useSidebarNav4 must be used inside a SidebarNav4ContextProvider');
        return context;
    }
});
parcelRegister("jHUgj", function(module, exports) {
    $parcel$export(module.exports, "SidebarSelector", ()=>$727f611db6c21522$export$7937e2d32a777fcb);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $65Ltd;
    var $8J6rn;
    var $6s1PB;
    var $7XYc4;
    var $4R6GH;
    var $lmyls;
    var $3F9p6;
    var $jKa0E;
    var $3ed52;
    var $gyZtn;
    var $dOB7H;
    var $dEbXe;
    var $Tdcaw;
    var $fbami;
    var $bCaZu;
    var $gYSoA;
    var $ieEgo;
    var $kNJsg;
    var $aWnEG;
    var $2KXa8;
    var $hrRcW;
    var $lF3VU;
    var $bJJms;
    var $6ZLHo;
    var $7VBev;
    var $YiTdm;
    var $kqEpF;
    var $1G9rm;
    var $drQWa;
    var $2DtJE;
    var $cnyf1;
    var $iXVV6;
    var $dAfqg;
    var $c1mlA;
    var $doZTA;
    const $727f611db6c21522$export$aa65c2aacd155f7f = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('jira_nav4_hot_113350_changes', 'keys', []).includes('blu-5991-sync-load-nav4-sidebar'), (0, (0, parcelRequire("gyZtn")).SidebarContent), (0, (0, parcelRequire("3ed52")).default));
    const $727f611db6c21522$var$entitySettingsSidebarAnalyticsAttributes = {
        navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9)
    };
    const $727f611db6c21522$var$ProjectSettingsSidebarSelector = ()=>{
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        let sidebar = null;
        if (loading) sidebar = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null);
        if (error) throw error;
        if (project?.projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ZLHo")).default), {
            project: project
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bJJms")).default), {
            project: project
        });
        if (project?.projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnyf1")).default), {
            project: project
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2DtJE")).default), {
            project: project
        });
        if (project?.projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) sidebar = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kqEpF")).default), {
            project: project
        });
        if (project?.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT) || project?.projectType === (0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("drQWa")).AsyncJsmTmpProjectSettingsSidebar), {
            project: project
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1G9rm")).AsyncJsmCmpProjectSettingsSidebar), {
            project: project
        });
        if (!sidebar) throw new Error(`No project settings sidebar found for the project type: ${project?.projectType}`);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: project ? String(project.projectId) : undefined,
            containerType: "project",
            attributes: $727f611db6c21522$var$entitySettingsSidebarAnalyticsAttributes
        }, sidebar);
    };
    const $727f611db6c21522$var$BoardSettingsSidebar = ()=>{
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dEbXe")).Skeleton), null);
        if (error) throw error;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: project ? String(project.projectId) : undefined,
            containerType: "project",
            attributes: $727f611db6c21522$var$entitySettingsSidebarAnalyticsAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dOB7H")).default), null));
    };
    const $727f611db6c21522$var$REDIRECT_ROUTES_NAMES = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REDIRECT)
    ]);
    const $727f611db6c21522$var$InternalSidebarSelector = ()=>{
        const [{ match: { params: params }, route: route, location: location, query: query }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { saveCurrentRoute: saveCurrentRoute } = (0, (0, parcelRequire("jKa0E")).useNavigateBack)();
        const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, (0, parcelRequire("Tdcaw")).useGlobalAppsSettingsConnectItemActive)();
        const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, (0, parcelRequire("kNJsg")).useGlobalSystemSettingsConnectItemActive)();
        const { isActive: isProjectSettingsConnectAppActive } = (0, (0, parcelRequire("YiTdm")).useIsConnectAppActive)();
        const { shouldUseJSM: shouldUseJSM } = (0, (0, parcelRequire("8J6rn")).useOgTenantInfo)();
        switch(route.navigation?.sidebarId){
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lF3VU")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS:
                if (!location.pathname.includes('/discover')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fbami")).default), null);
                break;
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ieEgo")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bCaZu")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS:
                if (location.pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM && (0, (0, parcelRequire("4R6GH")).fg)('fix_chatops_new_nav_bug')) break;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYSoA")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aWnEG")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hrRcW")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).HELP_CENTER_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KXa8")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$ProjectSettingsSidebarSelector, null);
            default:
                break;
        }
        if (route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_IDEAS) && params.section === 'settings' || isProjectSettingsConnectAppActive) return (0, ($parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$ProjectSettingsSidebarSelector, null);
        if (route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE) && (0, (0, parcelRequire("c1mlA")).BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(query.config) && (0, (0, parcelRequire("4R6GH")).fg)('simplified-boards-milestone-2_07hbk')) return (0, ($parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$BoardSettingsSidebar, null);
        if (isGlobalAppsSettingsConnectItemActive) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fbami")).default), null);
        if (isGlobalSystemSettingsConnectItemActive) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aWnEG")).default), null);
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') || !$727f611db6c21522$var$REDIRECT_ROUTES_NAMES.has(route.name)) saveCurrentRoute();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$export$aa65c2aacd155f7f, null);
    };
    const $727f611db6c21522$export$7937e2d32a777fcb = ()=>{
        const attributes = (0, $5uXOq.useMemo)(()=>({
                navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
                navigationContainer: (0, $68cb678dc917978e$export$2ee9e5a3556c1e43),
                navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
                stage: (0, (0, parcelRequire("3F9p6")).getNav4Rollout)().stage
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jKa0E")).NavigateBackProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: attributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$InternalSidebarSelector, null)));
    };
});
const $1520d876660a71bd$export$d2aa6c54a5925f01 = 'v3';
const $1520d876660a71bd$export$2bd315ece9f68967 = 'v4';
const $68cb678dc917978e$export$2ee9e5a3556c1e43 = 'sidebar';
const $68cb678dc917978e$export$793ed84f5e13fedc = 'top';
const $68cb678dc917978e$export$f1c9dd0f5207dd5e = 'tab';
const $68cb678dc917978e$export$b83d0ee9325a2d0a = 'projectTitle';
const $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22 = 'global';
const $ce9c0831aed9ffb3$export$33d8c916a600c5e9 = 'container';
parcelRegister("3F9p6", function(module, exports) {
    $parcel$export(module.exports, "getNav4Rollout", ()=>$826ce4e4d6cfd68d$export$84a05d3b37ec5d2);
    var $9glig = parcelRequire("9glig");
    var $cxSdl = parcelRequire("cxSdl");
    var $hMlwW = parcelRequire("hMlwW");
    var $6s1PB;
    var $4R6GH;
    var $c0dQj;
    var $7qZOo;
    var $396KQ;
    var $8O1QZ;
    var $32Frn;
    const $826ce4e4d6cfd68d$export$84a05d3b37ec5d2 = (0, ($parcel$interopDefault($9glig)))([
        [
            ()=>!(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4'),
            (0, ($parcel$interopDefault($cxSdl)))((0, (0, parcelRequire("7qZOo")).NAV4_ROLLOUT_NONE))
        ],
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding'),
            (0, (0, parcelRequire("8O1QZ")).getNav4RolloutForDogfooding)
        ],
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap'),
            (0, (0, parcelRequire("32Frn")).getNav4RolloutForEap)
        ],
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_existing-customers'),
            (0, (0, parcelRequire("396KQ")).getNav4RolloutForBetaCohort)('existing-customers')
        ],
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_sandboxes'),
            (0, (0, parcelRequire("396KQ")).getNav4RolloutForBetaCohort)('sandboxes')
        ],
        [
            ()=>(0, (0, parcelRequire("6s1PB")).expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false),
            (0, (0, parcelRequire("396KQ")).getNav4RolloutForBetaCohort)('free-customers')
        ],
        [
            ()=>(0, (0, parcelRequire("6s1PB")).expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false),
            (0, (0, parcelRequire("396KQ")).getNav4RolloutForBetaCohort)('new-customers')
        ],
        [
            ()=>(0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)(),
            (0, ($parcel$interopDefault($cxSdl)))((0, (0, parcelRequire("7qZOo")).NAV4_ROLLOUT_MOBILE))
        ],
        [
            (0, ($parcel$interopDefault($hMlwW))),
            (0, ($parcel$interopDefault($cxSdl)))((0, (0, parcelRequire("7qZOo")).NAV4_ROLLOUT_NONE))
        ]
    ]);
});
parcelRegister("396KQ", function(module, exports) {
    $parcel$export(module.exports, "getNav4RolloutForBetaCohort", ()=>$61e8415b5cadda16$export$d0b7d7e3a8d0a0c9);
    var $1MhR0;
    const $61e8415b5cadda16$export$d0b7d7e3a8d0a0c9 = (cohort)=>()=>cohort !== 'existing-customers' ? {
                stage: 'beta',
                cohort: cohort
            } : {
                stage: 'beta',
                cohort: cohort,
                isUserOptOut: (0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)()
            };
});
parcelRegister("8O1QZ", function(module, exports) {
    $parcel$export(module.exports, "getNav4RolloutForDogfooding", ()=>$48ac6742e168ff29$export$f1e751a9a9d68fb5);
    var $9glig = parcelRequire("9glig");
    var $hMlwW = parcelRequire("hMlwW");
    var $4R6GH;
    var $1MhR0;
    const $48ac6742e168ff29$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
                stage: 'dogfooding',
                phase: phase,
                isUserOptOut: (0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)()
            } : {
                stage: 'dogfooding',
                phase: phase
            };
    const $48ac6742e168ff29$export$f1e751a9a9d68fb5 = (0, ($parcel$interopDefault($9glig)))([
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-2'),
            $48ac6742e168ff29$var$dogfoodingPhase(2)
        ],
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-1'),
            $48ac6742e168ff29$var$dogfoodingPhase(1)
        ],
        [
            (0, ($parcel$interopDefault($hMlwW))),
            $48ac6742e168ff29$var$dogfoodingPhase(3)
        ]
    ]);
});
parcelRegister("32Frn", function(module, exports) {
    $parcel$export(module.exports, "getNav4RolloutForEap", ()=>$d3197687d5551826$export$42dd8c002a342b8);
    var $1MhR0;
    const $d3197687d5551826$export$42dd8c002a342b8 = ()=>({
            stage: 'eap',
            isUserOptOut: (0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)()
        });
});
parcelRegister("jKa0E", function(module, exports) {
    $parcel$export(module.exports, "useNavigateBack", ()=>$e131d9d1fc634955$export$7ce1f551d78f9130);
    $parcel$export(module.exports, "NavigateBackProvider", ()=>$e131d9d1fc634955$export$e1e76f4ee7f8174d);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $dIHnK;
    var $lVJAU;
    var $bOr6i;
    const $e131d9d1fc634955$var$STORAGE_KEY = 'back-button-url';
    const $e131d9d1fc634955$var$NavigateBackContext = (0, $5uXOq.createContext)(undefined);
    const $e131d9d1fc634955$export$7ce1f551d78f9130 = ()=>{
        const context = (0, $5uXOq.useContext)($e131d9d1fc634955$var$NavigateBackContext);
        if (!context) throw new Error('useNavigateBack must be used within a NavigateBackProvider');
        return context;
    };
    const $e131d9d1fc634955$export$e1e76f4ee7f8174d = ({ children: children })=>{
        (0, (0, parcelRequire("gKZoD")).di)(window);
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const [previousUrl, setPreviousUrl] = (0, $5uXOq.useState)(()=>(0, (0, parcelRequire("bOr6i")).storageProvider).get($e131d9d1fc634955$var$STORAGE_KEY));
        const saveCurrentRoute = (0, $5uXOq.useCallback)(()=>{
            const url = `${window.location.pathname}${window.location.search}${window.location.hash}`;
            setPreviousUrl(url);
            (0, (0, parcelRequire("bOr6i")).storageProvider).set($e131d9d1fc634955$var$STORAGE_KEY, url);
        }, []);
        const goBack = (0, $5uXOq.useCallback)(()=>push(previousUrl ?? (0, (0, parcelRequire("dIHnK")).jiraHomeRoute).path), [
            previousUrl,
            push
        ]);
        const value = (0, $5uXOq.useMemo)(()=>({
                saveCurrentRoute: saveCurrentRoute,
                goBack: goBack
            }), [
            saveCurrentRoute,
            goBack
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e131d9d1fc634955$var$NavigateBackContext.Provider, {
            value: value
        }, children);
    };
});
parcelRegister("bOr6i", function(module, exports) {
    $parcel$export(module.exports, "storageProvider", ()=>$36fbcced1b17c587$export$ce7751641b93537d);
    var $eNf8a;
    const $36fbcced1b17c587$export$ce7751641b93537d = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)('sidebar-navigation');
});
parcelRegister("3ed52", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2e015ea5d0812b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $lfTZh;
    var $kxZPA;
    const $a2e015ea5d0812b1$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>Promise.resolve((parcelRequire("gyZtn"))).then(({ SidebarContent: SidebarContent })=>SidebarContent), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/core/src/index.tsx"
    });
    const $a2e015ea5d0812b1$var$AsyncSidebarContent = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "asyncSidebarContent",
            packageName: "jiraNavigationAppsSidebarNav4SidebarContent",
            teamName: "jira-cosmos"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "lazySidebarContent"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a2e015ea5d0812b1$var$LazySidebarContent, null))));
    $a2e015ea5d0812b1$var$AsyncSidebarContent.displayName = 'AsyncSidebarContent';
    var $a2e015ea5d0812b1$export$2e2bcd8739ae039 = $a2e015ea5d0812b1$var$AsyncSidebarContent;
});
parcelRegister("cljJ9", function(module, exports) {
    $parcel$export(module.exports, "SidebarBoundary", ()=>$f6d5489447b9aa6b$export$1edc778464f08256);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $8dXDG;
    var $93jKl;
    var $cfDZ3;
    var $cKjfv;
    var $6Jt8x;
    const $f6d5489447b9aa6b$export$1edc778464f08256 = ({ children: children, id: id, packageName: packageName, teamName: teamName })=>{
        const { experience: experience, attributes: attributes } = (0, (0, parcelRequire("cKjfv")).useSidebarExperience)();
        const onFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: experience,
            attributes: attributes
        });
        const onAbort = (0, (0, parcelRequire("8dXDG")).useExperienceAbort)({
            experience: experience,
            attributes: attributes
        });
        const userLocation = (0, (0, parcelRequire("cfDZ3")).getUserLocation)();
        const isNotSSR = !false;
        const extraEventData = (0, $5uXOq.useMemo)(()=>({
                userLocation: userLocation
            }), [
            userLocation
        ]);
        const fallback = (0, $5uXOq.useCallback)(({ error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Jt8x")).Fallback), {
                error: error
            }), []);
        const handleError = (0, $5uXOq.useCallback)((location, error)=>{
            const { statusCode: statusCode } = error;
            if (statusCode >= 400 && statusCode < 500) onAbort('Sidebar failed with validation error', {
                error: error
            });
            else onFail(location, error);
        }, [
            onAbort,
            onFail
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: id,
            packageName: packageName,
            extraEventData: extraEventData,
            fallback: fallback,
            teamName: teamName,
            onError: handleError
        }, isNotSSR && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cKjfv")).SidebarStart), null), children);
    };
});
parcelRegister("cKjfv", function(module, exports) {
    $parcel$export(module.exports, "useSidebarExperience", ()=>$c4243e40cbbf3b86$export$d4fa533dfe4d7583);
    $parcel$export(module.exports, "SidebarStart", ()=>$c4243e40cbbf3b86$export$6738d1299dc79710);
    $parcel$export(module.exports, "SidebarReady", ()=>$c4243e40cbbf3b86$export$a06ecbbe5820282);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $kaHBi;
    var $3bQtK;
    var $6jY6G;
    var $8zOmE;
    var $2NMNM;
    var $6IzHB;
    const $c4243e40cbbf3b86$export$d4fa533dfe4d7583 = ()=>{
        const pageId = (0, (0, parcelRequire("6IzHB")).usePageId)();
        return (0, $5uXOq.useMemo)(()=>({
                experience: 'viewSidebarNavigation',
                experienceId: pageId,
                analyticsSource: 'Sidebar',
                attributes: {
                    sidebar: 'v4'
                }
            }), [
            pageId
        ]);
    };
    const $c4243e40cbbf3b86$export$6738d1299dc79710 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { experience: experience, experienceId: experienceId, analyticsSource: analyticsSource } = $c4243e40cbbf3b86$export$d4fa533dfe4d7583();
        const onStartExperience = (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: experience,
            experienceId: experienceId,
            analyticsSource: analyticsSource
        });
        (0, $5uXOq.useEffect)(()=>{
            if (route.isRedirect) return;
            onStartExperience();
        }, [
            onStartExperience,
            route
        ]);
        return null;
    };
    const $c4243e40cbbf3b86$export$a06ecbbe5820282 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { experience: experience, attributes: attributes } = $c4243e40cbbf3b86$export$d4fa533dfe4d7583();
        const onSuccessfulExperience = (0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: experience,
            attributes: attributes
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const routeName = route.name ?? route.group ?? 'UNKNOWN';
        const doNotRunEffects = route.isRedirect || false;
        const sidebarId = route.navigation?.sidebarId ?? 'default';
        (0, $5uXOq.useEffect)(()=>{
            if (doNotRunEffects) return;
            const event = createAnalyticsEvent({
                action: 'ready',
                actionSubject: 'sidebar',
                meta: {
                    teamName: 'endeavour'
                }
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'Sidebar Ready', {
                route: routeName
            });
        }, [
            createAnalyticsEvent,
            doNotRunEffects,
            routeName
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (doNotRunEffects) return;
            onSuccessfulExperience();
        }, [
            doNotRunEffects,
            onSuccessfulExperience,
            route
        ]);
        const customData = (0, $5uXOq.useMemo)(()=>({
                sidebarType: sidebarId
            }), [
            sidebarId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
            data: customData
        });
    };
});
parcelRegister("99gkn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a18f2c0b045372b$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "addUFOCustomData", ()=>$7a18f2c0b045372b$export$d12f56a472cdbe6c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $7a18f2c0b045372b$export$2e2bcd8739ae039({ data: data }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        (0, $5uXOq.useMemo)(()=>{
            if (!interactionContext) return;
            interactionContext.addCustomData(data);
        }, [
            data,
            interactionContext
        ]);
        return null;
    }
    function $7a18f2c0b045372b$export$d12f56a472cdbe6c(data) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        (0, (0, parcelRequire("bFU4G")).addCustomData)(currentInteractionId, [], data);
    }
});
parcelRegister("6Jt8x", function(module, exports) {
    $parcel$export(module.exports, "Fallback", ()=>$d1b1aff7b337b0d4$export$fb8d7f40caaeea67);
    var $5uXOq = parcelRequire("5uXOq");
    var $l1N8i;
    var $dC5iT;
    var $luBm6;
    var $cgL5K;
    var $kobfu;
    var $7q5TP;
    var $koVbs;
    var $5Ntjt;
    const $d1b1aff7b337b0d4$var$styles = {
        wrapper: "_bfhkm7j4 _syaz1gjq _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc",
        error: "_2rkogqwt _bfhk1v33 _syaz131l _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66"
    };
    const $d1b1aff7b337b0d4$export$fb8d7f40caaeea67 = ({ error: error })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $d1b1aff7b337b0d4$var$styles.wrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7q5TP")).default), {
            width: "40px",
            alt: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("5Ntjt")).default).errorHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("5Ntjt")).default).errorBody)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d1b1aff7b337b0d4$var$styles.error
        }, "ERROR: ", (0, (0, parcelRequire("kobfu")).getErrorHash)(error)));
    };
});
parcelRegister("5Ntjt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ef9823ba7f6e404$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9ef9823ba7f6e404$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorHeading: {
            "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-heading",
            "defaultMessage": "Something went wrong"
        },
        errorBody: {
            "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-body",
            "defaultMessage": "Try refreshing or navigating to another page."
        }
    });
});
parcelRegister("gyZtn", function(module, exports) {
    $parcel$export(module.exports, "SidebarContent", ()=>$b739c7529929160b$export$49e8f7b58a4df4ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $7GXsr;
    var $7CMCs;
    var $4R6GH;
    var $2fwuR;
    var $46Cti;
    var $cKjfv;
    var $dUyqZ;
    var $lfTZh;
    var $ao2h1;
    var $cZpsT;
    var $l8ruj;
    var $3yxBH;
    var $eMAVw;
    var $gSZmd;
    var $doZTA;
    var $1zjdl;
    var $2TuwK;
    const $b739c7529929160b$export$49e8f7b58a4df4ea = ()=>{
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        const { queryReference: queryReference } = (0, (0, parcelRequire("ao2h1")).useRelayResource)((0, (0, parcelRequire("2fwuR")).sidebarNav4Resource));
        const queryReferenceRef = (0, $5uXOq.useRef)(null);
        if (isAnonymous) return (0, ($parcel$interopDefault($5uXOq))).createElement($b739c7529929160b$export$57e04c8c2365ae3b, null);
        if (queryReference) queryReferenceRef.current = queryReference;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b739c7529929160b$export$a18798f247d81ed3, {
            queryReference: queryReferenceRef.current
        });
    };
    function $b739c7529929160b$export$a18798f247d81ed3({ queryReference: queryReference }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "l1-nav-menu-items",
            packageName: (0, (0, parcelRequire("1zjdl")).PACKAGE_NAME),
            teamName: (0, (0, parcelRequire("1zjdl")).TEAM_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3yxBH")).SideNavContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "l1-nav-menu-items",
            fallback: null
        }, queryReference && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2TuwK")).L1MenuItems), {
            queryReference: queryReference
        })))), (0, (0, parcelRequire("4R6GH")).fg)('blu-2735_nav4_onboarding') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7GXsr")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cKjfv")).SidebarReady), null)));
    }
    function $b739c7529929160b$export$57e04c8c2365ae3b() {
        const { formattedMessage: projectsMessage, icon: projectsIcon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS);
        const { formattedMessage: dashboardsMessage, icon: dashboardsIcon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS);
        const { formattedMessage: filtersMessage, icon: filtersIcon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS);
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "l1-nav-menu-items",
            packageName: (0, (0, parcelRequire("1zjdl")).PACKAGE_NAME),
            teamName: (0, (0, parcelRequire("1zjdl")).TEAM_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3yxBH")).SideNavContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "l1-nav-menu-items",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMAVw")).MenuLinkItem), {
            elemBefore: projectsIcon,
            href: "/jira/projects",
            isSelected: match.path.startsWith('/jira/projects')
        }, projectsMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMAVw")).MenuLinkItem), {
            elemBefore: filtersIcon,
            href: "/jira/filters",
            isSelected: match.path === '/jira/filters' || match.path.startsWith('/issues/')
        }, filtersMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMAVw")).MenuLinkItem), {
            elemBefore: dashboardsIcon,
            href: "/jira/dashboards",
            isSelected: match.path.startsWith('/jira/dashboards')
        }, dashboardsMessage)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cKjfv")).SidebarReady), null));
    }
});
parcelRegister("7GXsr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$485ad0479413a47e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hYRTO;
    var $7CMCs;
    var $kxZPA;
    const $485ad0479413a47e$var$LazyAtlassianOnboardingNav4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9AMu8")).then(({ Nav4Onboarding: Nav4Onboarding })=>Nav4Onboarding), {
        moduleId: "./src/packages/navigation-apps/onboarding-nav4/src/index.tsx"
    });
    const $485ad0479413a47e$var$AsyncAtlassianOnboardingNav4 = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "asyncAtlassianOnboardingNav4",
            packageName: "jiraAtlassianOnboardingNav4",
            teamName: "jira-cosmos",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hYRTO")).default), {
            name: "lazyAtlassianOnboardingNav4"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($485ad0479413a47e$var$LazyAtlassianOnboardingNav4, null))));
    $485ad0479413a47e$var$AsyncAtlassianOnboardingNav4.displayName = 'AsyncAtlassianOnboardingNav4';
    var $485ad0479413a47e$export$2e2bcd8739ae039 = $485ad0479413a47e$var$AsyncAtlassianOnboardingNav4;
});
parcelRegister("9AMu8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gl0SS").then(()=>parcelRequire('1UJgx'));
});
parcelRegister("46Cti", function(module, exports) {
    $parcel$export(module.exports, "L1_MENU_ID", ()=>$2d5b83df0b5ff159$export$918aea3cf024d90b);
    var $jhS4y;
    const $2d5b83df0b5ff159$export$f263c05bb04cefc9 = {
        OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
        OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
    };
    const $2d5b83df0b5ff159$export$bb47524d7f3cb1f8 = {
        ...(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID),
        BOARDS: 'jira.sidebar.boards',
        QUEUES: 'jira.sidebar.queues',
        ALL: 'jira.sidebar.all'
    };
    const $2d5b83df0b5ff159$export$918aea3cf024d90b = {
        YOUR_WORK: 'jira.sidebar.yourWork',
        ...(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID),
        ...$2d5b83df0b5ff159$export$f263c05bb04cefc9
    };
});
parcelRegister("dUyqZ", function(module, exports) {
    $parcel$export(module.exports, "useConfigurableMessageAndIconMap", ()=>$5654470bb2a53aff$export$783a136280b37c09);
    var $4DrQd;
    var $24a2m;
    const $5654470bb2a53aff$export$783a136280b37c09 = (menuId)=>{
        const { message: message, Icon: Icon } = (0, (0, parcelRequire("4DrQd")).CONFIGURABLE_MESSAGE_AND_ICON_MAP)[menuId];
        return (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)(message, Icon);
    };
});
parcelRegister("4DrQd", function(module, exports) {
    $parcel$export(module.exports, "MENU_GROUP_MIN_WIDTH", ()=>$e2413e530566d4f6$export$47f3715a07cde7e8);
    $parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", ()=>$e2413e530566d4f6$export$f5a7bd7eb586e4e8);
    $parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP", ()=>$e2413e530566d4f6$export$6a976dc7193b8a18);
    $parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", ()=>$e2413e530566d4f6$export$9fcc53f3b36e0949);
    $parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", ()=>$e2413e530566d4f6$export$2eb8dda9e83d33ff);
    $parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", ()=>$e2413e530566d4f6$export$9cf873ba2e9a3ce0);
    $parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", ()=>$e2413e530566d4f6$export$a495ba70b16d4d90);
    $parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", ()=>$e2413e530566d4f6$export$89de709e88232646);
    var $5Trwl;
    var $1ZDWg;
    var $aUBhr;
    var $hyKRO;
    var $gsyzJ;
    var $jX361;
    var $9x5pH;
    var $4iV1e;
    var $ecqyi;
    var $dXQDI;
    var $ifnb0;
    var $dAf5R;
    var $c781K;
    var $jhS4y;
    var $6x874;
    var $ih7ba;
    var $46Cti;
    const $e2413e530566d4f6$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
    const $e2413e530566d4f6$export$d57b6b390e78d90f = 'jira-cosmos';
    const $e2413e530566d4f6$export$47f3715a07cde7e8 = 250;
    const $e2413e530566d4f6$export$421b92818c76ee2d = Object.values((0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID));
    const $e2413e530566d4f6$export$f5a7bd7eb586e4e8 = $e2413e530566d4f6$export$421b92818c76ee2d;
    const $e2413e530566d4f6$export$6a976dc7193b8a18 = {
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).apps,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("1ZDWg")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).GOALS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).goals,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("4iV1e")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).roadmaps,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("5Trwl")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).plans,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("ifnb0")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).projects,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("dXQDI")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).filters,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("jX361")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).dashboards,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("gsyzJ")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).overviews,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("9x5pH")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).OPERATIONS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).operations,
            Icon: (0, (0, parcelRequire("6x874")).default)
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).assets,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("aUBhr")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).teams,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("c781K")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).RECENT]: {
            message: (0, (0, parcelRequire("ih7ba")).default).recent,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("hyKRO")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).STARRED]: {
            message: (0, (0, parcelRequire("ih7ba")).default).starred,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("dAf5R")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).CUSTOMER_SERVICE]: {
            message: (0, (0, parcelRequire("ih7ba")).default).customerService,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("ecqyi")))))
        }
    };
    const $e2413e530566d4f6$export$9fcc53f3b36e0949 = 240;
    const $e2413e530566d4f6$export$6621cd553335536a = 320;
    const $e2413e530566d4f6$export$2eb8dda9e83d33ff = false;
    const $e2413e530566d4f6$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
    const $e2413e530566d4f6$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
    const $e2413e530566d4f6$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
    const $e2413e530566d4f6$export$a495ba70b16d4d90 = 'nav4-sidebar';
    const $e2413e530566d4f6$export$89de709e88232646 = 25;
});
parcelRegister("6x874", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$079d8146cc6d581f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fJMTr;
    var $llvRa;
    var $4R6GH;
    const $079d8146cc6d581f$var$OperationsIcon = ({ ...props })=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('nav4_operations_icon_update')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fJMTr"))))), props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("llvRa"))))), props);
    };
    var $079d8146cc6d581f$export$2e2bcd8739ae039 = $079d8146cc6d581f$var$OperationsIcon;
});
parcelRegister("ih7ba", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c16ecaa1449e546$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7c16ecaa1449e546$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projects: {
            "id": "navigation-apps-sidebar-nav4-common.common.projects",
            "defaultMessage": "Projects"
        },
        filters: {
            "id": "navigation-apps-sidebar-nav4-common.common.filters",
            "defaultMessage": "Filters"
        },
        dashboards: {
            "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
            "defaultMessage": "Dashboards"
        },
        overviews: {
            "id": "navigation-apps-sidebar-nav4-common.common.overviews",
            "defaultMessage": "Overviews"
        },
        teams: {
            "id": "navigation-apps-sidebar-nav4-common.common.teams",
            "defaultMessage": "Teams"
        },
        assets: {
            "id": "navigation-apps-sidebar-nav4-common.common.assets",
            "defaultMessage": "Assets"
        },
        plans: {
            "id": "navigation-apps-sidebar-nav4-common.common.plans",
            "defaultMessage": "Plans"
        },
        apps: {
            "id": "navigation-apps-sidebar-nav4-common.common.apps",
            "defaultMessage": "Apps"
        },
        operations: {
            "id": "navigation-apps-sidebar-nav4-common.common.operations",
            "defaultMessage": "Operations"
        },
        goals: {
            "id": "navigation-apps-sidebar-nav4-common.common.goals",
            "defaultMessage": "Goals"
        },
        recent: {
            "id": "navigation-apps-sidebar-nav4-common.common.recent",
            "defaultMessage": "Recent"
        },
        starred: {
            "id": "navigation-apps-sidebar-nav4-common.common.starred",
            "defaultMessage": "Starred"
        },
        roadmaps: {
            "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
            "defaultMessage": "Roadmaps"
        },
        customerService: {
            "id": "navigation-apps-sidebar-nav4-common.common.customer-service",
            "defaultMessage": "Customer service"
        }
    });
});
parcelRegister("24a2m", function(module, exports) {
    $parcel$export(module.exports, "useFormattedMessageAndIcon", ()=>$a546a39b12f7f59a$export$efa1c7d3cd2d4f5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    const $a546a39b12f7f59a$export$efa1c7d3cd2d4f5c = (message, Icon)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const formattedMessage = formatMessage(message);
        const icon = (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
            label: formattedMessage,
            spacing: "spacious",
            color: "currentColor"
        });
        return {
            formattedMessage: formattedMessage,
            icon: icon
        };
    };
});
parcelRegister("3yxBH", function(module, exports) {
    $parcel$export(module.exports, "SideNavContent", ()=>$0bf3573d8c099cfe$export$babe3c784778f3ba);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $0bf3573d8c099cfe$export$babe3c784778f3ba = (0, $5uXOq.forwardRef)($0bf3573d8c099cfe$var$_SideNavContent);
    const $0bf3573d8c099cfe$var$styles = {
        scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
        paddingContainer: "_1yt4utpp"
    };
    function $0bf3573d8c099cfe$var$_SideNavContent({ children: children, testId: testId }, ref) {
        return $5uXOq.createElement("div", {
            ref: ref,
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $0bf3573d8c099cfe$var$styles.scrollContainer
            ])
        }, $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $0bf3573d8c099cfe$var$styles.paddingContainer
            ])
        }, children));
    }
});
parcelRegister("eMAVw", function(module, exports) {
    $parcel$export(module.exports, "MenuLinkItem", ()=>$72e1fba5d6beed08$export$68ef190193a37bc2);
    var $5uXOq = parcelRequire("5uXOq");
    var $eUDGK;
    var $fdP8o;
    const $72e1fba5d6beed08$var$listItemStyles = {
        root: "_10m98stt"
    };
    const $72e1fba5d6beed08$var$MenuLinkItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled }, forwardedRef)=>{
        const itemRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (isSelected && itemRef.current?.scrollIntoView) itemRef.current.scrollIntoView({
                block: 'nearest'
            });
        }, []);
        return $5uXOq.createElement((0, (0, parcelRequire("eUDGK")).ListItem), {
            ref: itemRef,
            xcss: $72e1fba5d6beed08$var$listItemStyles.root
        }, $5uXOq.createElement((0, (0, parcelRequire("fdP8o")).MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled
        }, children));
    };
    const $72e1fba5d6beed08$export$68ef190193a37bc2 = (0, $5uXOq.forwardRef)($72e1fba5d6beed08$var$MenuLinkItemNoRef);
});
parcelRegister("fdP8o", function(module, exports) {
    $parcel$export(module.exports, "MenuItemBase", ()=>$453992fef59345a2$export$859b390bf71e044e);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $DEWI6;
    var $620nX;
    var $5JjdN;
    var $jhmo0;
    var $5ILhZ;
    var $cgL5K;
    var $3bDjY;
    var $btzsC;
    var $b2QiW;
    var $et13M;
    var $aV1jL;
    var $4qwFZ;
    const $453992fef59345a2$var$tooltipStyles = {
        root: "_1e0c1txw _2lx21bp4 _1bah1h6o _1tkezwfg _p12f1pna _vchhusvi _1yt41ppf _bfhkcdhy _2rkoglpi _syaz15cr _11c8qk37 _152tze3t _1e02ze3t _1i4q1hna _slp31hna"
    };
    const $453992fef59345a2$var$MenuItemTooltip = (0, $5uXOq.forwardRef)(function MenuItemTooltip({ children: children, className: className, ...rest }, ref) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("btzsC")).default), {
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $453992fef59345a2$var$tooltipStyles.root,
                className
            ]),
            ref: ref
        }, children);
    });
    function $453992fef59345a2$var$isTextClamped(element) {
        return element.scrollHeight > element.clientHeight;
    }
    const $453992fef59345a2$var$defaultAvatarValues = {
        size: 'small'
    };
    const $453992fef59345a2$var$elemAfterDisplayVar = '--elem-after-display';
    const $453992fef59345a2$var$notchColorVar = '--notch-color';
    const $453992fef59345a2$var$topLevelSiblingStyles = {
        root: "_kqswh2mm"
    };
    const $453992fef59345a2$var$onTopOfButtonOrAnchorStyles = {
        root: "_18ukglyw"
    };
    const $453992fef59345a2$var$nestedOpenPopupCSSSelector = '&:has([aria-expanded="true"][aria-haspopup="true"])';
    const $453992fef59345a2$var$containerStyles = {
        root: "_vchhusvi _1e0c11p5 _yv0eaa4y _1ul9t9kd _4t3izwfg _4cvr1h6o _uiztglyw _2rkoglpi _syaz1gjq _1yyu3acm _1swv108i _19w515ej _irr3108i _u31n15ej",
        removeElemAfter: "_91juglyw",
        removeElemAfterOnHover: "_91ju1txw _1mfcglyw _1sjuglyw",
        selected: "_bfhkfg4m _syazaqb7 _1yyu1fvw _1swvi1yw _19w51fvw _30l3aqb7 _irr3i1yw _u31n1fvw",
        pressed: "_bfhk1ji5 _1yyu15ej",
        hasDescription: "_4t3ickbl"
    };
    const $453992fef59345a2$var$buttonOrAnchorStyles = {
        root: "_1e0c11p5 _yyhyjvu9 _1ii7kb7n _yv0enbh3 _4t3i1osq _1yt41b66 _bfhk18uv _2rkoglpi _syaz1gjq _4cvr1h6o _y3gnv2br _1di61ji5",
        selected: "_syazaqb7 _1di619ru"
    };
    const $453992fef59345a2$var$extendButtonOrAnchorStyles = {
        root: "_kqswstnw _1r04ze3t"
    };
    const $453992fef59345a2$var$notchStyles = {
        root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
    };
    const $453992fef59345a2$var$actionStyles = {
        root: "_1e0c1txw _4cvr1h6o _zulp1b66 _1ii7kb7n _yyhyqfx8 _y4ti1b66 _1reo15vq _18m915vq _1guo18uv _12s918uv"
    };
    const $453992fef59345a2$var$actionOnHoverStyles = {
        root: "_1e0c1txw _4cvr1h6o _zulp1b66 _y4ti1b66 _1reo15vq _18m915vq _1guo18uv _12s918uv",
        gridPosition: "_1ii7kb7n _yyhy11wp"
    };
    const $453992fef59345a2$var$textStyles = {
        root: "_yyhycs5v _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _zulpv77o _1ul91c9m _1reo15vq _18m915vq _1guo18uv _12s918uv",
        noElemBeforeIndent: "_bozg12x7"
    };
    const $453992fef59345a2$var$elemBeforeStyles = {
        root: "_yyhykb7n _1ii7kb7n _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh18uv _1reo15vq _18m915vq _1guo18uv _12s918uv"
    };
    const $453992fef59345a2$var$elemAfterStyles = {
        root: "_1e0cgmyj _yyhyegat _1ii7kb7n _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1reo15vq _18m915vq _1guo18uv _12s918uv"
    };
    const $453992fef59345a2$export$859b390bf71e044e = (0, $5uXOq.forwardRef)(({ testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled }, forwardedRef)=>{
        const level = (0, (0, parcelRequire("et13M")).useLevel)();
        const setFlyoutMenuOpen = (0, (0, parcelRequire("aV1jL")).useSetFlyoutMenuOpen)();
        const isFlyoutMenuOpen = (0, (0, parcelRequire("aV1jL")).useFlyoutMenuOpen)();
        const isLink = typeof href !== 'undefined';
        const labelRef = (0, $5uXOq.useRef)(null);
        const descriptionRef = (0, $5uXOq.useRef)(null);
        const tooltipOnClick = (0, $5uXOq.useRef)(null);
        const handleClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            onClick?.(event, analyticsEvent);
            setFlyoutMenuOpen(!isFlyoutMenuOpen);
            tooltipOnClick.current?.(event);
        }, [
            onClick,
            setFlyoutMenuOpen,
            isFlyoutMenuOpen
        ]);
        const canTooltipAppear = (0, $5uXOq.useCallback)(()=>{
            if (isContentTooltipDisabled) return false;
            const label = labelRef.current;
            const description = descriptionRef.current;
            if (label && $453992fef59345a2$var$isTextClamped(label)) return true;
            return Boolean(description && $453992fef59345a2$var$isTextClamped(description));
        }, [
            isContentTooltipDisabled
        ]);
        const showElemBefore = elemBefore !== (0, (0, parcelRequire("4qwFZ")).COLLAPSE_ELEM_BEFORE);
        const interactiveElemContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                insetInlineStart: `calc(-1 * ${level} * ${(0, $64ba54a200a2d4aa$export$d492445a79a49b48)})`
            },
            "aria-hidden": "true",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $453992fef59345a2$var$extendButtonOrAnchorStyles.root
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $453992fef59345a2$var$textStyles.root,
                !showElemBefore && $453992fef59345a2$var$textStyles.noElemBeforeIndent
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            weight: "medium",
            maxLines: 1,
            color: isSelected ? 'color.text.selected' : 'color.text.subtle',
            ref: labelRef
        }, children), description && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle",
            size: "small",
            maxLines: 1,
            ref: descriptionRef
        }, description)));
        const showHoverActionsWhenNotHovered = Boolean(!ariaHasPopup && ariaExpanded && actionsOnHover);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b2QiW")).InteractionSurface), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("620nX")).AvatarContext).Provider, {
            value: $453992fef59345a2$var$defaultAvatarValues
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": testId ? `${testId}-container` : undefined,
            "data-selected": isSelected,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $453992fef59345a2$var$containerStyles.root,
                isSelected && $453992fef59345a2$var$containerStyles.selected,
                description && $453992fef59345a2$var$containerStyles.hasDescription,
                ariaHasPopup && ariaExpanded && $453992fef59345a2$var$containerStyles.pressed,
                actionsOnHover && elemAfter && $453992fef59345a2$var$containerStyles.removeElemAfterOnHover,
                showHoverActionsWhenNotHovered && $453992fef59345a2$var$containerStyles.removeElemAfter
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, children), description ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, description) : null),
            position: "right",
            component: $453992fef59345a2$var$MenuItemTooltip,
            ignoreTooltipPointerEvents: true,
            hideTooltipOnMouseDown: true,
            isScreenReaderAnnouncementDisabled: true,
            canAppear: canTooltipAppear
        }, (tooltipProps)=>{
            tooltipOnClick.current = tooltipProps.onClick;
            const sharedProps = {
                ...tooltipProps,
                'aria-controls': ariaControls,
                'aria-haspopup': ariaHasPopup,
                ref: (0, (0, parcelRequire("5JjdN")).default)([
                    forwardedRef,
                    tooltipProps.ref
                ]),
                testId: testId,
                interactionName: interactionName,
                onClick: handleClick
            };
            return isLink ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
                ...sharedProps,
                xcss: (0, (0, parcelRequire("DEWI6")).cx)($453992fef59345a2$var$buttonOrAnchorStyles.root, $453992fef59345a2$var$topLevelSiblingStyles.root, isSelected && $453992fef59345a2$var$buttonOrAnchorStyles.selected),
                style: {
                    textDecoration: 'none'
                },
                "aria-current": isSelected ? 'page' : undefined,
                href: href,
                target: target
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "aria-hidden": "true",
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    $453992fef59345a2$var$notchStyles.root
                ])
            }), interactiveElemContent) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                ...sharedProps,
                xcss: (0, (0, parcelRequire("DEWI6")).cx)($453992fef59345a2$var$buttonOrAnchorStyles.root, $453992fef59345a2$var$topLevelSiblingStyles.root, isSelected && $453992fef59345a2$var$buttonOrAnchorStyles.selected),
                "aria-expanded": ariaExpanded,
                isDisabled: isDisabled
            }, interactiveElemContent);
        }), showElemBefore && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $453992fef59345a2$var$elemBeforeStyles.root,
                $453992fef59345a2$var$topLevelSiblingStyles.root,
                $453992fef59345a2$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, elemBefore), actionsOnHover && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b2QiW")).InteractionConsumer), {
            xcss: $453992fef59345a2$var$actionOnHoverStyles.gridPosition,
            behavior: showHoverActionsWhenNotHovered ? 'alwaysShown' : 'removeOnLeave'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $453992fef59345a2$var$actionOnHoverStyles.root
            ])
        }, actionsOnHover)), elemAfter && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $453992fef59345a2$var$elemAfterStyles.root,
                $453992fef59345a2$var$topLevelSiblingStyles.root,
                $453992fef59345a2$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, elemAfter), actions && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $453992fef59345a2$var$actionStyles.root,
                $453992fef59345a2$var$topLevelSiblingStyles.root,
                $453992fef59345a2$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, actions))));
    });
});
parcelRegister("b2QiW", function(module, exports) {
    $parcel$export(module.exports, "InteractionSurface", ()=>$1de8726edad9c73e$export$b77883dd274d64b);
    $parcel$export(module.exports, "InteractionConsumer", ()=>$1de8726edad9c73e$export$65f09dabf608e4ae);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    const $1de8726edad9c73e$var$opacityCssVar = '--n_sfc_o';
    const $1de8726edad9c73e$var$displayCssVar = '--n_sfc_d';
    const $1de8726edad9c73e$var$surfaceStyles = {
        root: "_17lff1ug _2wlvglyw _1ebb1osq _1yth1osq _1s0b1ule _1dle1ule"
    };
    const $1de8726edad9c73e$export$b77883dd274d64b = ({ children: children, xcss: xcss })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $1de8726edad9c73e$var$surfaceStyles.root,
                xcss
            ])
        }, children);
    const $1de8726edad9c73e$var$behaviorStyles = {
        hideOnLeave: "_tzy41j9r",
        removeOnLeave: "_1e0c13fu"
    };
    const $1de8726edad9c73e$export$65f09dabf608e4ae = ({ children: children, testId: testId, xcss: xcss, behavior: behavior = 'hideOnLeave' })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                behavior === 'hideOnLeave' && $1de8726edad9c73e$var$behaviorStyles.hideOnLeave,
                behavior === 'removeOnLeave' && $1de8726edad9c73e$var$behaviorStyles.removeOnLeave,
                xcss
            ])
        }, children);
});
const $64ba54a200a2d4aa$export$d492445a79a49b48 = '12px';
parcelRegister("et13M", function(module, exports) {
    $parcel$export(module.exports, "IsExpandedContext", ()=>$a721eaa4679cbd17$export$c856e5885cc34d81);
    $parcel$export(module.exports, "SetIsExpandedContext", ()=>$a721eaa4679cbd17$export$48cb11cb8691f597);
    $parcel$export(module.exports, "IsChildSelectedContext", ()=>$a721eaa4679cbd17$export$afd5e66c4a050b2b);
    $parcel$export(module.exports, "OnExpansionToggleContext", ()=>$a721eaa4679cbd17$export$572ce188c913ceba);
    $parcel$export(module.exports, "LevelContext", ()=>$a721eaa4679cbd17$export$650d12d3c2ddb8fc);
    $parcel$export(module.exports, "useIsExpanded", ()=>$a721eaa4679cbd17$export$37e565a09598825e);
    $parcel$export(module.exports, "useSetIsExpanded", ()=>$a721eaa4679cbd17$export$c9a171ea8de5861b);
    $parcel$export(module.exports, "useIsChildSelected", ()=>$a721eaa4679cbd17$export$5e0ac78afeceab3c);
    $parcel$export(module.exports, "useOnExpansionToggle", ()=>$a721eaa4679cbd17$export$56c8438498b72c7a);
    $parcel$export(module.exports, "useLevel", ()=>$a721eaa4679cbd17$export$fdfe9e5e8183d4f2);
    var $5uXOq = parcelRequire("5uXOq");
    var $3joPi = parcelRequire("3joPi");
    const $a721eaa4679cbd17$export$c856e5885cc34d81 = (0, $5uXOq.createContext)(null);
    const $a721eaa4679cbd17$export$48cb11cb8691f597 = (0, $5uXOq.createContext)(null);
    const $a721eaa4679cbd17$export$afd5e66c4a050b2b = (0, $5uXOq.createContext)(null);
    const $a721eaa4679cbd17$export$572ce188c913ceba = (0, $5uXOq.createContext)(null);
    const $a721eaa4679cbd17$export$650d12d3c2ddb8fc = (0, $5uXOq.createContext)(0);
    const $a721eaa4679cbd17$export$37e565a09598825e = ()=>{
        const context = (0, $5uXOq.useContext)($a721eaa4679cbd17$export$c856e5885cc34d81);
        (0, $3joPi.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
        return context;
    };
    const $a721eaa4679cbd17$export$c9a171ea8de5861b = ()=>{
        const context = (0, $5uXOq.useContext)($a721eaa4679cbd17$export$48cb11cb8691f597);
        (0, $3joPi.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
        return context;
    };
    const $a721eaa4679cbd17$export$5e0ac78afeceab3c = ()=>{
        const context = (0, $5uXOq.useContext)($a721eaa4679cbd17$export$afd5e66c4a050b2b);
        (0, $3joPi.default)(context !== null, 'useIsChildSelected must be used within an ExpandableMenuItem');
        return context;
    };
    const $a721eaa4679cbd17$export$56c8438498b72c7a = ()=>(0, $5uXOq.useContext)($a721eaa4679cbd17$export$572ce188c913ceba);
    const $a721eaa4679cbd17$export$fdfe9e5e8183d4f2 = ()=>(0, $5uXOq.useContext)($a721eaa4679cbd17$export$650d12d3c2ddb8fc);
});
parcelRegister("aV1jL", function(module, exports) {
    $parcel$export(module.exports, "IsOpenContext", ()=>$f9ed7d1271d6aaec$export$efa4d9670e96ac31);
    $parcel$export(module.exports, "SetIsOpenContext", ()=>$f9ed7d1271d6aaec$export$4c55b1c61a116b42);
    $parcel$export(module.exports, "useFlyoutMenuOpen", ()=>$f9ed7d1271d6aaec$export$6927118f874a49aa);
    $parcel$export(module.exports, "useSetFlyoutMenuOpen", ()=>$f9ed7d1271d6aaec$export$538ac1aa421adb94);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $f9ed7d1271d6aaec$export$efa4d9670e96ac31 = (0, $5uXOq.createContext)(false);
    const $f9ed7d1271d6aaec$export$4c55b1c61a116b42 = (0, $5uXOq.createContext)((0, (0, parcelRequire("eGmKJ")).default));
    const $f9ed7d1271d6aaec$export$6927118f874a49aa = ()=>(0, $5uXOq.useContext)($f9ed7d1271d6aaec$export$efa4d9670e96ac31);
    const $f9ed7d1271d6aaec$export$538ac1aa421adb94 = ()=>(0, $5uXOq.useContext)($f9ed7d1271d6aaec$export$4c55b1c61a116b42);
});
parcelRegister("4qwFZ", function(module, exports) {
    $parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", ()=>$f540ea5c01f27028$export$f4b8e24fae579c6f);
    const $f540ea5c01f27028$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');
});
parcelRegister("gSZmd", function(module, exports) {
    $parcel$export(module.exports, "MenuList", ()=>$dfe52a3a6f12c8c9$export$d4c4e98c5044dc8);
    var $hEtBs;
    const $dfe52a3a6f12c8c9$export$d4c4e98c5044dc8 = (0, (0, parcelRequire("hEtBs")).List);
});
parcelRegister("1zjdl", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$5d2bb3999d13b3c1$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$5d2bb3999d13b3c1$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "USER_NAVIGATION_ITEM_LINKS", ()=>$5d2bb3999d13b3c1$export$d34001b14a9e6d48);
    $parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS", ()=>$5d2bb3999d13b3c1$export$c2614ebabc74446e);
    var $46Cti;
    var $dDmlh;
    const $5d2bb3999d13b3c1$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4SidebarContent';
    const $5d2bb3999d13b3c1$export$d57b6b390e78d90f = 'jira-cosmos';
    const $5d2bb3999d13b3c1$export$d34001b14a9e6d48 = {
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS]: '/jira/marketplace/discover?source=apps-menu',
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).GOALS]: '/jira/your-work?goals',
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS]: (0, (0, parcelRequire("dDmlh")).dashboardsDirectoryRoute).path,
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS]: '/jira/people/search',
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS]: '/jira/polaris/roadmaps'
    };
    const $5d2bb3999d13b3c1$export$6f21b70acbf71216 = {
        navKey: 'JIRA_SIDEBAR',
        navItems: [
            {
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).RECENT,
                isVisible: true
            },
            {
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).STARRED,
                isVisible: true
            },
            {
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS,
                isVisible: true
            },
            {
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS,
                isVisible: true
            },
            {
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS,
                isVisible: true
            },
            {
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS,
                isVisible: true
            },
            {
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS,
                isVisible: true
            },
            {
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS,
                isVisible: true
            },
            {
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS,
                isVisible: true
            },
            {
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OPERATIONS,
                isVisible: true
            },
            {
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS,
                isVisible: true
            },
            {
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS,
                isVisible: true
            },
            {
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).CUSTOMER_SERVICE,
                isVisible: true
            }
        ]
    };
    const $5d2bb3999d13b3c1$export$c2614ebabc74446e = $5d2bb3999d13b3c1$export$6f21b70acbf71216.navItems.map(({ menuId: menuId })=>menuId);
});
parcelRegister("2TuwK", function(module, exports) {
    $parcel$export(module.exports, "L1MenuItems", ()=>$acec8e7e455fe5dc$export$a1e3b15bccd7433c);
    var $2OeZv;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $6kIiE;
    var $60xWx;
    function $acec8e7e455fe5dc$export$a1e3b15bccd7433c({ queryReference: queryReference }) {
        const l1MenuData = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("2OeZv")).default), queryReference);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6kIiE")).YourWork), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("60xWx")).ConfigurableMenuItems), {
            menuData: l1MenuData
        }));
    }
});
parcelRegister("6kIiE", function(module, exports) {
    $parcel$export(module.exports, "YourWork", ()=>$62ee6641d8028b84$export$c7da207c25eb3776);
    var $5uXOq = parcelRequire("5uXOq");
    var $korlx;
    var $jecJ3;
    var $jhS4y;
    var $5FnJJ;
    var $24a2m;
    var $dIHnK;
    var $lCMI0;
    const $62ee6641d8028b84$var$JIRA_HOME_PATH = (0, (0, parcelRequire("dIHnK")).jiraHomeRoute).path;
    const $62ee6641d8028b84$var$analytics = {
        actionSubjectId: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_YOUR_WORK),
        itemId: 'yourWork',
        level: 1,
        isInMore: false
    };
    const $62ee6641d8028b84$export$c7da207c25eb3776 = ()=>{
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("lCMI0")).default).yourWork, (0, ($parcel$interopDefault((0, parcelRequire("korlx"))))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            analytics: $62ee6641d8028b84$var$analytics,
            elemBefore: icon,
            href: $62ee6641d8028b84$var$JIRA_HOME_PATH,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_YOUR_WORK)
        }, formattedMessage);
    };
});
parcelRegister("korlx", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ed8b42fa0c7772ef$var$_react = $ed8b42fa0c7772ef$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ed8b42fa0c7772ef$var$_baseNew = $ed8b42fa0c7772ef$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ed8b42fa0c7772ef$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ed8b42fa0c7772ef$var$InboxIcon = (props)=>$ed8b42fa0c7772ef$var$_react.default.createElement($ed8b42fa0c7772ef$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 8.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V8.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v5.75m-12.5 0H5.5a2.5 2.5 0 0 0 5 0h3.75M4 5.25h8"/>`
        }, props));
    $ed8b42fa0c7772ef$var$InboxIcon.displayName = 'InboxIcon';
    var $ed8b42fa0c7772ef$var$_default = module.exports.default = $ed8b42fa0c7772ef$var$InboxIcon;
});
parcelRegister("jecJ3", function(module, exports) {
    $parcel$export(module.exports, "SECTION_ITEM_RECENT", ()=>$06147718dc8a8493$export$ed5276b2863990a4);
    $parcel$export(module.exports, "SECTION_ITEM_STARRED", ()=>$06147718dc8a8493$export$73b9e2753c0313a);
    $parcel$export(module.exports, "SECTION_ITEM_YOUR_WORK", ()=>$06147718dc8a8493$export$a7cdcfc40ede2092);
    $parcel$export(module.exports, "SECTION_ITEM_APPS", ()=>$06147718dc8a8493$export$31b95a89c6fecef5);
    $parcel$export(module.exports, "SECTION_ITEM_PLANS", ()=>$06147718dc8a8493$export$b8d778ecbc8de386);
    $parcel$export(module.exports, "SECTION_ITEM_PROJECTS", ()=>$06147718dc8a8493$export$31111a67d393221);
    $parcel$export(module.exports, "SECTION_ITEM_FILTERS", ()=>$06147718dc8a8493$export$15cffe8e769011f4);
    $parcel$export(module.exports, "SECTION_ITEM_DASHBOARDS", ()=>$06147718dc8a8493$export$573d88e8f19dee53);
    $parcel$export(module.exports, "SECTION_ITEM_OPERATIONS", ()=>$06147718dc8a8493$export$4d8d544db40ea55b);
    $parcel$export(module.exports, "SECTION_ITEM_TEAMS", ()=>$06147718dc8a8493$export$ee4743a74ca6b2b4);
    $parcel$export(module.exports, "SECTION_ITEM_ASSETS", ()=>$06147718dc8a8493$export$935694b184853c59);
    $parcel$export(module.exports, "SECTION_ITEM_MORE", ()=>$06147718dc8a8493$export$b0aa6b1b7598bca0);
    $parcel$export(module.exports, "SECTION_ITEM_CUSTOMIZE_SIDEBAR", ()=>$06147718dc8a8493$export$60a8edfaff189e32);
    $parcel$export(module.exports, "SECTION_ITEM_OVERVIEW", ()=>$06147718dc8a8493$export$c15c267765b7c087);
    $parcel$export(module.exports, "SECTION_ITEM_ROADMAPS", ()=>$06147718dc8a8493$export$1e1623e43a47b758);
    $parcel$export(module.exports, "SECTION_ITEM_MAP", ()=>$06147718dc8a8493$export$1a73d7f5e6997c6d);
    var $jhS4y;
    const $06147718dc8a8493$export$ed5276b2863990a4 = 'recent';
    const $06147718dc8a8493$export$73b9e2753c0313a = 'starred';
    const $06147718dc8a8493$export$a01a58e0d3083eac = 'yourApps';
    const $06147718dc8a8493$export$a7cdcfc40ede2092 = 'yourWork';
    const $06147718dc8a8493$export$31b95a89c6fecef5 = 'apps';
    const $06147718dc8a8493$export$b8d778ecbc8de386 = 'plans';
    const $06147718dc8a8493$export$31111a67d393221 = 'projects';
    const $06147718dc8a8493$export$15cffe8e769011f4 = 'filters';
    const $06147718dc8a8493$export$573d88e8f19dee53 = 'dashboards';
    const $06147718dc8a8493$export$4d8d544db40ea55b = 'operations';
    const $06147718dc8a8493$export$ee4743a74ca6b2b4 = 'teams';
    const $06147718dc8a8493$export$935694b184853c59 = 'assets';
    const $06147718dc8a8493$export$b0aa6b1b7598bca0 = 'more';
    const $06147718dc8a8493$export$60a8edfaff189e32 = 'customiseSidebar';
    const $06147718dc8a8493$export$c15c267765b7c087 = 'overviews';
    const $06147718dc8a8493$export$61feca79c347b0c7 = 'goals';
    const $06147718dc8a8493$export$1e1623e43a47b758 = 'roadmaps';
    const $06147718dc8a8493$export$99cd56faa69bbbb6 = 'customerService';
    const $06147718dc8a8493$export$1a73d7f5e6997c6d = {
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).APPS]: $06147718dc8a8493$export$31b95a89c6fecef5,
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).ASSETS]: $06147718dc8a8493$export$935694b184853c59,
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).DASHBOARDS]: $06147718dc8a8493$export$573d88e8f19dee53,
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).FILTERS]: $06147718dc8a8493$export$15cffe8e769011f4,
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).OPERATIONS]: $06147718dc8a8493$export$4d8d544db40ea55b,
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).PLANS]: $06147718dc8a8493$export$b8d778ecbc8de386,
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).PROJECTS]: $06147718dc8a8493$export$31111a67d393221,
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).RECENT]: $06147718dc8a8493$export$ed5276b2863990a4,
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).STARRED]: $06147718dc8a8493$export$73b9e2753c0313a,
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).TEAMS]: $06147718dc8a8493$export$ee4743a74ca6b2b4,
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).GOALS]: $06147718dc8a8493$export$61feca79c347b0c7,
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).OVERVIEWS]: $06147718dc8a8493$export$c15c267765b7c087,
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).ROADMAPS]: $06147718dc8a8493$export$1e1623e43a47b758,
        [(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE]: $06147718dc8a8493$export$99cd56faa69bbbb6
    };
});
parcelRegister("5FnJJ", function(module, exports) {
    $parcel$export(module.exports, "Nav4MenuLinkItem", ()=>$0d86e9008b98ae27$export$3253d78f1560490f);
    var $5uXOq = parcelRequire("5uXOq");
    var $c6x3L;
    var $lJ5jf;
    var $bSYPZ;
    var $dQbFB;
    const $0d86e9008b98ae27$export$3253d78f1560490f = (0, $5uXOq.forwardRef)($0d86e9008b98ae27$var$_Nav4MenuLinkItem);
    function $0d86e9008b98ae27$var$_Nav4MenuLinkItem(props, ref) {
        const { menuId: menuId } = props;
        const { isSelectedPath: isSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const { isControlledPath: isControlledPath } = (0, (0, parcelRequire("lJ5jf")).useSidebarNav4Controller)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bSYPZ")).default), {
            ref: ref,
            ...props,
            isSelected: isSelectedPath(menuId) || isControlledPath(menuId),
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        });
    }
});
parcelRegister("bSYPZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec275bd8d21ab84a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $eMAVw;
    function $ec275bd8d21ab84a$var$MenuLinkItemWithAnalytics({ analytics: analytics, onClick: onClick, ...rest }, ref) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleClick = (event, analyticsEvent)=>{
            onClick?.(event, analyticsEvent);
            if (!analytics) return;
            const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            }), actionSubjectId, analyticsAttributes);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMAVw")).MenuLinkItem), {
            ref: ref,
            onClick: handleClick,
            ...rest
        });
    }
    var $ec275bd8d21ab84a$export$2e2bcd8739ae039 = (0, $5uXOq.forwardRef)($ec275bd8d21ab84a$var$MenuLinkItemWithAnalytics);
});
const $ce8062101363feb9$export$6dd9406e478a1fe2 = 'navigationItem';
const $ce8062101363feb9$export$b887e88d8d0739f6 = 'button';
const $ce8062101363feb9$export$64fed82162bd367 = 'dropdownItem';
parcelRegister("dQbFB", function(module, exports) {
    $parcel$export(module.exports, "getTestId", ()=>$f598f66a6b396d35$export$ec17b125bc42c229);
    function $f598f66a6b396d35$export$ec17b125bc42c229(suffix) {
        return `NAV4_${suffix}`;
    }
});
parcelRegister("lCMI0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f35f2103e05fea00$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f35f2103e05fea00$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        yourWork: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-your-work.your-work.your-work",
            "defaultMessage": "Your work"
        }
    });
});
parcelRegister("60xWx", function(module, exports) {
    $parcel$export(module.exports, "ConfigurableMenuItems", ()=>$b2e090acb983f40f$export$4aa1992a31b27e16);
    var $4yzqs;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $iszzG;
    var $fiYXQ;
    var $3muxY;
    var $cam2y;
    var $jM4TX;
    var $cscSc;
    var $i98eP;
    var $avJY5;
    var $8FnIk;
    function $b2e090acb983f40f$export$4aa1992a31b27e16({ menuData: menuData }) {
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("4yzqs")).default), menuData);
        const navItems = (0, (0, parcelRequire("cam2y")).useFilterL1MenuItemsByEditionAndLicense)((0, (0, parcelRequire("jM4TX")).useRefreshL1MenuItems)(data.jira?.userNavigationConfiguration?.navItems));
        const navItemsContext = (0, $5uXOq.useMemo)(()=>({
                navItems: navItems,
                visibleMenuIds: (0, (0, parcelRequire("fiYXQ")).getConfigurableMenuIds)(navItems, true),
                moreMenuIds: (0, (0, parcelRequire("fiYXQ")).getConfigurableMenuIds)(navItems, false)
            }), [
            navItems
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iszzG")).NavItemsContext).Provider, {
            value: navItemsContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8FnIk")).PeekMenuIdContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i98eP")).MoreMenuIsOpenContextProvider), null, navItemsContext.visibleMenuIds.map((menuId)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3muxY")).ConfigurableMenuItem), {
                key: menuId,
                menuData: data,
                menuId: menuId
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("avJY5")).MoreMenuItem), {
            customiseSidebar: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cscSc")).CustomiseSidebar), {
                navItems: navItems
            }),
            menuData: data
        }))));
    }
});
parcelRegister("4yzqs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$456c834cb9e35bf5$export$2e2bcd8739ae039);
    const $456c834cb9e35bf5$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "ConfigurableMenuItems",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudID",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Literal",
                                "name": "navKey",
                                "value": "NAV_SIDEBAR"
                            }
                        ],
                        "concreteType": "JiraUserNavigationConfiguration",
                        "kind": "LinkedField",
                        "name": "userNavigationConfiguration",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraConfigurableNavigationItem",
                                "kind": "LinkedField",
                                "name": "navItems",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "ScalarField",
                                            "name": "menuId"
                                        },
                                        "action": "THROW",
                                        "path": "jira.userNavigationConfiguration.navItems.menuId"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "ScalarField",
                                            "name": "isVisible"
                                        },
                                        "action": "THROW",
                                        "path": "jira.userNavigationConfiguration.navItems.isVisible"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "ConfigurableMenuItem"
            }
        ],
        "type": "Query"
    };
    $456c834cb9e35bf5$var$node.hash = "186fc107bcd2a8ade003841f3137d27b";
    var $456c834cb9e35bf5$export$2e2bcd8739ae039 = $456c834cb9e35bf5$var$node;
});
parcelRegister("iszzG", function(module, exports) {
    $parcel$export(module.exports, "NavItemsContext", ()=>$71af5d0260a148da$export$a2018da95558f5c);
    $parcel$export(module.exports, "PeekMenuIdContext", ()=>$71af5d0260a148da$export$390c771b9e3f4124);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    const $71af5d0260a148da$export$a2018da95558f5c = (0, $5uXOq.createContext)({
        navItems: [],
        visibleMenuIds: [],
        moreMenuIds: []
    });
    const $71af5d0260a148da$export$390c771b9e3f4124 = (0, $5uXOq.createContext)({
        peekMenuId: undefined,
        setPeekMenuId: (0, ($parcel$interopDefault($8Rkzz)))
    });
});
parcelRegister("fiYXQ", function(module, exports) {
    $parcel$export(module.exports, "getConfigurableMenuIds", ()=>$9312141792122626$export$6071c13fba14d7fa);
    var $5Yh04;
    const $9312141792122626$export$6071c13fba14d7fa = (navItems, isVisible)=>navItems.filter((navItem)=>navItem.isVisible === isVisible).map(({ menuId: menuId })=>menuId).filter((0, (0, parcelRequire("5Yh04")).isConfigurableMenuId));
});
parcelRegister("5Yh04", function(module, exports) {
    $parcel$export(module.exports, "isConfigurableMenuId", ()=>$a5f9a046dfa6b79b$export$454094eefbaf1797);
    var $4DrQd;
    const $a5f9a046dfa6b79b$export$454094eefbaf1797 = (value)=>(0, (0, parcelRequire("4DrQd")).CONFIGURABLE_MENU_IDS_AS_STRINGS).includes(value);
});
parcelRegister("3muxY", function(module, exports) {
    $parcel$export(module.exports, "ConfigurableMenuItem", ()=>$8be3eed13df9fa08$export$5de02966decf8405);
    var $59EX7;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $4R6GH;
    var $46Cti;
    var $3iY1w;
    var $67KAW;
    var $aXxBX;
    var $kcmzD;
    var $blbXb;
    var $VyuC0;
    var $iKHgp;
    var $lz3si;
    var $1YUDD;
    var $3nmOf;
    var $abrAF;
    var $3J4Wg;
    var $cq1bX;
    var $96poX;
    var $1zjdl;
    var $3cFRo;
    function $8be3eed13df9fa08$export$5de02966decf8405({ isDefaultOpen: isDefaultOpen = false, menuData: menuData, menuId: menuId }) {
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("59EX7")).default), menuData);
        const shouldRenderOverviews = (0, (0, parcelRequire("iKHgp")).useShouldRenderOverviews)();
        switch(menuId){
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iY1w")).Nav4Apps), {
                    isExpanded: isDefaultOpen,
                    queryRef: data
                });
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("67KAW")).Nav4Assets), {
                    isExpanded: isDefaultOpen
                });
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kcmzD")).Nav4Dashboards), {
                    isExpanded: isDefaultOpen,
                    queryRef: data
                });
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("blbXb")).Nav4Filters), {
                    isExpanded: isDefaultOpen,
                    queryRef: data
                });
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).GOALS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3cFRo")).Stub), {
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).GOALS,
                    href: (0, (0, parcelRequire("1zjdl")).USER_NAVIGATION_ITEM_LINKS)[(0, (0, parcelRequire("46Cti")).L1_MENU_ID).GOALS]
                });
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OPERATIONS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("VyuC0")).Nav4Operations), {
                    isExpanded: isDefaultOpen,
                    queryRef: data
                });
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1YUDD")).Nav4Plans), {
                    isExpanded: isDefaultOpen,
                    queryRef: data
                });
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS:
                return shouldRenderOverviews && (0, (0, parcelRequire("4R6GH")).fg)('blu-2858-sidebar-menu-overviews') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lz3si")).Nav4Overviews), {
                    isExpanded: isDefaultOpen,
                    queryRef: data
                }) : null;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3nmOf")).Nav4Projects), {
                    isExpanded: isDefaultOpen,
                    queryRef: data
                });
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).RECENT:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abrAF")).Recent), {
                    isDefaultOpen: isDefaultOpen
                });
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3J4Wg")).Nav4Roadmaps), {
                    isExpanded: isDefaultOpen
                });
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).STARRED:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cq1bX")).Starred), {
                    isDefaultOpen: isDefaultOpen
                });
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96poX")).Teams), null);
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).CUSTOMER_SERVICE:
                return (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aXxBX")).CustomerService), null) : null;
            default:
                return null;
        }
    }
});
parcelRegister("59EX7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$047ebaf8cd6dba5c$export$2e2bcd8739ae039);
    const $047ebaf8cd6dba5c$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ConfigurableMenuItem",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "Nav4Projects"
            },
            {
                "kind": "FragmentSpread",
                "name": "Nav4Filters"
            },
            {
                "kind": "FragmentSpread",
                "name": "Nav4Plans"
            },
            {
                "kind": "FragmentSpread",
                "name": "Nav4Apps"
            },
            {
                "kind": "FragmentSpread",
                "name": "Nav4Dashboards"
            },
            {
                "kind": "FragmentSpread",
                "name": "Nav4Operations"
            },
            {
                "kind": "FragmentSpread",
                "name": "Nav4Overviews"
            }
        ],
        "type": "Query"
    };
    $047ebaf8cd6dba5c$var$node.hash = "b29f7203e75d32305dac70f5397d151c";
    var $047ebaf8cd6dba5c$export$2e2bcd8739ae039 = $047ebaf8cd6dba5c$var$node;
});
parcelRegister("3iY1w", function(module, exports) {
    $parcel$export(module.exports, "Nav4Apps", ()=>$37401459bf6b58c5$export$8473036ee9e92881);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $ksJl5;
    var $l8ruj;
    var $6EHtA;
    const $37401459bf6b58c5$export$8473036ee9e92881 = (props)=>{
        const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, (0, parcelRequire("6EHtA")).createAttributes)({
                error: error,
                component: 'Nav4Apps'
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-apps"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "apps-section",
            attributes: getAttributes,
            packageName: (0, $13973d4cc5182a50$export$b8b9d90f9e5bd72b),
            teamName: (0, $13973d4cc5182a50$export$d57b6b390e78d90f)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ksJl5")).Nav4Apps), props)));
    };
});
parcelRegister("ksJl5", function(module, exports) {
    $parcel$export(module.exports, "Nav4Apps", ()=>$00f56297c031450d$export$8473036ee9e92881);
    var $c8TfS;
    var $gQbcG;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $cSD7y;
    var $jhS4y;
    var $c6x3L;
    var $9ETtY;
    var $jEa4c;
    var $cbY68;
    var $iJgtS;
    var $nX8wH;
    var $bhapp;
    const $00f56297c031450d$var$Wrapper = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_nav4_beta_drop_1', (0, (0, parcelRequire("bhapp")).Nav4AppsSpotlightWrapper), (0, $5uXOq.Fragment));
    function $00f56297c031450d$export$8473036ee9e92881(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement($00f56297c031450d$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($00f56297c031450d$var$Nav4AppsInner, props));
    }
    function $00f56297c031450d$var$Nav4AppsInner({ isExpanded: isExpanded, queryRef: queryRef }) {
        const { isInitialSelectedPath: isInitialSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("gQbcG")).default), queryRef);
        const globalAppNavigationItems = (0, $8Uumt.useFragment)((0, (0, parcelRequire("c8TfS")).default), data.jira);
        const isMaybeAppsSectionRoute = isInitialSelectedPath((0, (0, parcelRequire("jhS4y")).MENU_ID_APPS));
        const isGeneralConnectRoute = (0, (0, parcelRequire("9ETtY")).useIsGeneralConnectRoute)();
        const isGlobalConnectAppRoute = (0, (0, parcelRequire("nX8wH")).useIsGlobalConnectAppRoute)({
            data: globalAppNavigationItems
        });
        const isAppsSectionExpanded = isMaybeAppsSectionRoute && (isGeneralConnectRoute ? isGlobalConnectAppRoute : true);
        const sectionActions = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jEa4c")).SectionActions), null);
        return isAppsSectionExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iJgtS")).Nav4AppsForLanding), {
            actionsOnHover: sectionActions,
            isExpanded: isExpanded,
            queryRef: data.jira
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbY68")).Nav4AppsDefault), {
            actionsOnHover: sectionActions,
            isExpanded: isExpanded
        });
    }
});
parcelRegister("c8TfS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58cc3d53236e7f5f$export$2e2bcd8739ae039);
    const $58cc3d53236e7f5f$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "url"
        };
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "cloudId"
                },
                {
                    "kind": "RootArgument",
                    "name": "isAppsExpanded"
                }
            ],
            "kind": "Fragment",
            "name": "Nav4Apps_GlobalAppsFragment",
            "selections": [
                {
                    "condition": "isAppsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "globalAppNavigationItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appType"
                                                        },
                                                        v0,
                                                        {
                                                            "concreteType": "JiraAppSection",
                                                            "kind": "LinkedField",
                                                            "name": "sections",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v0
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAppNavigationItem"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraQuery"
        };
    }();
    $58cc3d53236e7f5f$var$node.hash = "cadf42461f2555d23492132472cd18b6";
    var $58cc3d53236e7f5f$export$2e2bcd8739ae039 = $58cc3d53236e7f5f$var$node;
});
parcelRegister("gQbcG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea6f03604759aa38$export$2e2bcd8739ae039);
    const $ea6f03604759aa38$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isAppsExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Apps",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "Nav4AppsForLanding"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "Nav4Apps_GlobalAppsFragment"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
    $ea6f03604759aa38$var$node.hash = "c3df504da3663fd99ebe67a0d32de67f";
    var $ea6f03604759aa38$export$2e2bcd8739ae039 = $ea6f03604759aa38$var$node;
});
parcelRegister("9ETtY", function(module, exports) {
    $parcel$export(module.exports, "useIsGeneralConnectRoute", ()=>$06f03c6d90d3978b$export$db179b21b0be87a1);
    var $65Ltd;
    var $doZTA;
    const $06f03c6d90d3978b$var$GENERAL_CONNECT_ROUTES = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_INVALID),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT)
    ]);
    const $06f03c6d90d3978b$var$UNCERTAIN_APPS_SECTION_ROUTES = $06f03c6d90d3978b$var$GENERAL_CONNECT_ROUTES;
    const $06f03c6d90d3978b$var$CERTAIN_APPS_SECTION_ROUTES = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_GLOBAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_INDEX)
    ]);
    const $06f03c6d90d3978b$export$22e210b2ba662e30 = new Set([
        ...$06f03c6d90d3978b$var$UNCERTAIN_APPS_SECTION_ROUTES,
        ...$06f03c6d90d3978b$var$CERTAIN_APPS_SECTION_ROUTES
    ]);
    function $06f03c6d90d3978b$export$db179b21b0be87a1() {
        const [routerContext] = (0, (0, parcelRequire("doZTA")).useRouter)();
        return $06f03c6d90d3978b$var$GENERAL_CONNECT_ROUTES.has(routerContext.route.name);
    }
});
parcelRegister("jEa4c", function(module, exports) {
    $parcel$export(module.exports, "SectionActions", ()=>$e6bcc3c836f7b03e$export$51f8029abf8c56ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $hRf4g;
    var $epOG5;
    var $3Z96c;
    var $9UCCQ;
    var $co1wz;
    var $4R6GH;
    var $koVbs;
    var $jecJ3;
    var $ivGSs;
    var $jhS4y;
    var $46Cti;
    var $9eeFp;
    var $eaKdt;
    var $aCS3f;
    var $6awYZ;
    var $8zOmE;
    var $2NMNM;
    var $9OXo1;
    var $iFqOo;
    function $e6bcc3c836f7b03e$export$51f8029abf8c56ce({ onClose: onClose }) {
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const showManageApps = isAdmin || isSiteAdmin;
        const showAppAuditLogs = (0, (0, parcelRequire("4R6GH")).fg)('upm_frontend_deprecation') && (isAdmin || isSiteAdmin);
        const showViewAppRequests = (0, (0, parcelRequire("co1wz")).ff)('enduser-emcee-discover') && isSiteAdmin;
        const fireOpenEvent = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_APPS],
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    itemId: 'meatballDropdown'
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            MenuItems: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($e6bcc3c836f7b03e$var$MoreMenuItems, {
                    showManageApps: showManageApps,
                    showViewAppRequests: showViewAppRequests,
                    showAppAuditLogs: showAppAuditLogs,
                    ...props
                }),
            onOpen: fireOpenEvent,
            onClose: onClose
        });
    }
    function $e6bcc3c836f7b03e$var$MoreMenuItems({ onClose: onClose, showManageApps: showManageApps, showViewAppRequests: showViewAppRequests, showAppAuditLogs: showAppAuditLogs }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const viewAppRequestsLink = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("6awYZ")).getAppRequestsLink)(), []);
        const onCloseWithStopPropagation = (0, (0, parcelRequire("9eeFp")).useStopPropagation)(onClose);
        const showTopSection = showManageApps || showViewAppRequests;
        const fireClickEvent = (0, $5uXOq.useCallback)((itemId)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_APPS],
                attributes: {
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    componentType: (0, $1e554a683893bd46$export$74712b62056d422e),
                    itemId: itemId,
                    parentItemId: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_APPS)
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, showTopSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), null, showManageApps && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("epOG5"))))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            href: "/plugins/servlet/upm",
            target: "_blank",
            onClick: (...args)=>{
                fireClickEvent('manageApps');
                onCloseWithStopPropagation(...args);
            }
        }, formatMessage((0, (0, parcelRequire("iFqOo")).default).manageApps)), showAppAuditLogs && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("epOG5"))))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            href: "/plugins/servlet/upm/log",
            onClick: (...args)=>{
                onCloseWithStopPropagation(...args);
            },
            target: "_blank"
        }, formatMessage((0, (0, parcelRequire("iFqOo")).default).appAuditLogs)), showViewAppRequests && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hRf4g"))))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            href: viewAppRequestsLink,
            target: "_blank",
            onClick: (...args)=>{
                fireClickEvent('viewAppRequests');
                onCloseWithStopPropagation(...args);
            }
        }, formatMessage((0, (0, parcelRequire("iFqOo")).default).viewAppRequests))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaKdt")).HideL1MenuItemSection), {
            menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS,
            hasSeparator: showTopSection
        }));
    }
});
const $1e554a683893bd46$export$4165a3d0da3bd147 = 'fixedItem';
const $1e554a683893bd46$export$95b0c331af13d819 = 'fixedItemButton';
const $1e554a683893bd46$export$74712b62056d422e = 'fixedItemAction';
const $1e554a683893bd46$export$3ac911b122986477 = 'customItem';
const $1e554a683893bd46$export$9bd6c21d500ae611 = 'customItemButton';
const $1e554a683893bd46$export$5374c2c2d3ece55e = 'customItemAction';
const $1e554a683893bd46$export$56981f28056f258e = 'customItemDropdownAction';
const $1e554a683893bd46$export$17bca95234dea43b = 'fixedItemDropdownAction';
const $951a0ed422513987$export$265c523d1a8f25cf = '1';
const $951a0ed422513987$export$fe3b012b0224e4e1 = '2';
const $951a0ed422513987$export$f9db6a58b4aabd18 = '3';
const $951a0ed422513987$export$35ac629b8b943d5a = '4';
parcelRegister("ivGSs", function(module, exports) {
    $parcel$export(module.exports, "getSideNavToggleButtonAnalyticEventPayload", ()=>$968dc7093f3ba590$export$7165a1ebf1926b86);
    $parcel$export(module.exports, "MENU_ID_ANALYTIC_EVENT_IDS", ()=>$968dc7093f3ba590$export$d70e7a5f39328991);
    var $jhS4y;
    const $968dc7093f3ba590$var$SIDEBAR_TOGGLE = 'sidebarToggle';
    const $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE = 'collapse';
    const $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_EXPAND = 'expand';
    const $968dc7093f3ba590$var$CLICKED = 'clicked';
    const $968dc7093f3ba590$export$7165a1ebf1926b86 = (isSideNavVisible, stage)=>{
        const toggleAction = isSideNavVisible ? $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE : $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_EXPAND;
        const payload = {
            action: $968dc7093f3ba590$var$CLICKED,
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
            actionSubjectId: $968dc7093f3ba590$var$SIDEBAR_TOGGLE,
            attributes: {
                navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
                navigationContainer: (0, $68cb678dc917978e$export$793ed84f5e13fedc),
                stage: stage,
                navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
                toggleAction: toggleAction
            }
        };
        return payload;
    };
    const $968dc7093f3ba590$export$d70e7a5f39328991 = {
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_APPS)]: 'appsNavigationMenuItem',
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS)]: 'assetsNavigationMenuItem',
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS)]: 'dashboardsNavigationMenuItem',
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS)]: 'filtersNavigationMenuItem',
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_GOALS)]: 'goalsNavigationMenuItem',
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS)]: 'operationsNavigationMenuItem',
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS)]: 'overviewsNavigationMenuItem',
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS)]: 'plansNavigationMenuItem',
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS)]: 'projectsNavigationMenuItem',
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_RECENT)]: 'recentNavigationMenuItem',
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_STARRED)]: 'starredNavigationMenuItem',
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_TEAMS)]: 'teamsNavigationMenuItem',
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS)]: 'roadmapsNavigationMenuItem',
        [(0, (0, parcelRequire("jhS4y")).MENU_ID_CUSTOMER_SERVICE)]: 'customerServiceMenuItem'
    };
});
parcelRegister("9eeFp", function(module, exports) {
    $parcel$export(module.exports, "useStopPropagation", ()=>$9838019739bca90d$export$f7bb512e68bcecd9);
    var $5uXOq = parcelRequire("5uXOq");
    const $9838019739bca90d$export$f7bb512e68bcecd9 = (onEvent)=>(0, $5uXOq.useCallback)((e, ...args)=>{
            try {
                onEvent?.(e, ...args);
            } finally{
                e.stopPropagation();
            }
        }, [
            onEvent
        ]);
});
parcelRegister("eaKdt", function(module, exports) {
    $parcel$export(module.exports, "HideL1MenuItemSection", ()=>$6a7321776d8332cb$export$a6246d2fccf72824);
    var $bcArA;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $kJpBP;
    var $9UCCQ;
    var $cgL5K;
    var $fraBZ;
    var $4R6GH;
    var $pa9q9;
    var $koVbs;
    var $jecJ3;
    var $ivGSs;
    var $iXVV6;
    var $8zOmE;
    var $2NMNM;
    var $8zOmE;
    var $koeKL;
    var $iszzG;
    var $fS0Tg;
    var $bMQWP;
    var $ji6RV;
    const $6a7321776d8332cb$var$HIDE_ROOT_MENU_ITEM_SUCCESS = 'HIDE_ROOT_MENU_ITEM_SUCCESS';
    const $6a7321776d8332cb$var$RESTORE_ROOT_MENU_ITEM_SUCCESS = 'RESTORE_ROOT_MENU_ITEM_SUCCESS';
    function $6a7321776d8332cb$export$a6246d2fccf72824(props) {
        const { menuId: menuId, hasSeparator: hasSeparator = true } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { navItems: navItems } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iszzG")).NavItemsContext));
        const { peekMenuId: peekMenuId } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iszzG")).PeekMenuIdContext));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const cloudID = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [isHidden, setIsHidden] = (0, $5uXOq.useState)(false);
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const [commit] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("bcArA")).default));
        const onSave = (0, $5uXOq.useCallback)((newNavItems)=>{
            commit({
                variables: {
                    input: {
                        cloudID: cloudID,
                        navKey: 'NAV_SIDEBAR',
                        navItems: newNavItems
                    }
                }
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebarNavItems changed', {
                originalNavItems: navItems,
                updatedNavItems: newNavItems,
                changedFrom: 'hideFromSidebarButton'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[menuId],
                attributes: {
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                    parentItemId: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_MAP)[menuId],
                    itemId: 'hideFromSidebar'
                }
            });
        }, [
            cloudID,
            commit,
            createAnalyticsEvent,
            menuId,
            navItems
        ]);
        const toggleNavItemVisibility = (0, $5uXOq.useCallback)(({ isVisible: isVisible })=>{
            const newNavItems = navItems.map((item)=>{
                if (item.menuId === menuId) return {
                    ...item,
                    isVisible: isVisible
                };
                return {
                    ...item
                };
            });
            return newNavItems;
        }, [
            menuId,
            navItems
        ]);
        const onRestoreRootMenuItem = ()=>{
            if (navItems !== undefined) {
                const newNavItems = toggleNavItemVisibility({
                    isVisible: true
                });
                onSave(newNavItems);
                setIsHidden(false);
                showFlag({
                    type: 'success',
                    id: $6a7321776d8332cb$var$RESTORE_ROOT_MENU_ITEM_SUCCESS,
                    title: (0, (0, parcelRequire("ji6RV")).getNavItemRestoredFromSideBarFlagTitle)(menuId),
                    isAutoDismiss: true
                });
            }
        };
        const onHideRootMenuItem = ()=>{
            if (navItems !== undefined) {
                const newNavItems = toggleNavItemVisibility({
                    isVisible: false
                });
                onSave(newNavItems);
                setIsHidden(true);
                if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1')) showFlag({
                    type: 'success',
                    id: $6a7321776d8332cb$var$HIDE_ROOT_MENU_ITEM_SUCCESS,
                    title: (0, (0, parcelRequire("ji6RV")).getNavItemHiddenFromSideBarFlagTitle)(menuId),
                    isAutoDismiss: true,
                    actions: [
                        {
                            content: (0, (0, parcelRequire("bMQWP")).default).moveBackToSidebar,
                            onClick: ()=>{
                                onRestoreRootMenuItem();
                                dismissFlag($6a7321776d8332cb$var$HIDE_ROOT_MENU_ITEM_SUCCESS);
                            }
                        }
                    ]
                });
            }
        };
        const isDisabled = peekMenuId === menuId;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: (0, $e0b5a9368b34b1c5$export$a3821bc63538b210),
            sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
            containerId: (0, $e0b5a9368b34b1c5$export$3c19576bd92ff564),
            containerType: (0, $e0b5a9368b34b1c5$export$fba7c3adda5094d9)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            hasSeparator: hasSeparator
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fraBZ")).AnnouncerV2), {
            message: formatMessage((0, (0, parcelRequire("ji6RV")).getA11YAlert)(menuId)),
            shouldAnnounce: isHidden
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fS0Tg")).HideIcon), {
                label: "",
                primaryColor: isDisabled ? 'color.icon.disabled' : 'color.icon'
            }),
            onClick: onHideRootMenuItem,
            isDisabled: isDisabled,
            "aria-label": formatMessage((0, (0, parcelRequire("ji6RV")).getA11YLabel)(menuId))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: isDisabled ? 'color.text.disabled' : 'color.text'
        }, formatMessage((0, (0, parcelRequire("bMQWP")).default).hideFromSidebar)))));
    }
});
parcelRegister("bcArA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6858b1c2ad9da191$export$2e2bcd8739ae039);
    const $6858b1c2ad9da191$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "concreteType": "JiraConfigurableNavigationItem",
            "kind": "LinkedField",
            "name": "navItems",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "menuId"
                },
                {
                    "kind": "ScalarField",
                    "name": "isVisible"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "hideL1MenuItemActionMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUserNavigationConfigurationPayload",
                                "kind": "LinkedField",
                                "name": "updateUserNavigationConfiguration",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraUserNavigationConfiguration",
                                        "kind": "LinkedField",
                                        "name": "userNavigationConfiguration",
                                        "plural": false,
                                        "selections": [
                                            v3
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "hideL1MenuItemActionMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUserNavigationConfigurationPayload",
                                "kind": "LinkedField",
                                "name": "updateUserNavigationConfiguration",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraUserNavigationConfiguration",
                                        "kind": "LinkedField",
                                        "name": "userNavigationConfiguration",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b23a1defc70b85ce697c0dc1d84377c11fe03c64d3dbd4d0cb309c2158ac9e77",
                "metadata": {},
                "name": "hideL1MenuItemActionMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $6858b1c2ad9da191$var$node.hash = "1b96ba09e281b673ec1bfa126587621b";
    var $6858b1c2ad9da191$export$2e2bcd8739ae039 = $6858b1c2ad9da191$var$node;
});
parcelRegister("fraBZ", function(module, exports) {
    $parcel$export(module.exports, "AnnouncerV2", ()=>$f73a83ae5cba96ea$export$a43c8a2f4981e0e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dqoiX;
    const $f73a83ae5cba96ea$var$NON_BREAKING_SPACE = '\u00A0';
    const $f73a83ae5cba96ea$export$a43c8a2f4981e0e = (0, $5uXOq.memo)(({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
        const previousMessage = (0, $5uXOq.useRef)('');
        const setAlternatePolite = (0, $5uXOq.useRef)(false);
        const addSuffix = (0, $5uXOq.useRef)(false);
        const [oldMessage, setOldMessage] = (0, $5uXOq.useState)('');
        const [newMessage, setNewMessage] = (0, $5uXOq.useState)('');
        (0, $5uXOq.useEffect)(()=>{
            let message = shouldAnnounce ? originalMessage : $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
            if (previousMessage.current === message) {
                addSuffix.current = !addSuffix.current;
                if (addSuffix.current) message += $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
            }
            setOldMessage(setAlternatePolite.current ? '' : message);
            setNewMessage(setAlternatePolite.current ? message : '');
            if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
            previousMessage.current = originalMessage;
        }, [
            originalMessage,
            shouldAnnounce
        ]);
        return $5uXOq.createElement("div", {
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            role: "status",
            "aria-live": liveMode,
            "aria-relevant": "additions text",
            "aria-atomic": "true"
        }, oldMessage), $5uXOq.createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            role: "status",
            "aria-live": liveMode,
            "aria-relevant": "additions text",
            "aria-atomic": "true"
        }, newMessage));
    });
    const $f73a83ae5cba96ea$var$positionRelative = null;
});
parcelRegister("dqoiX", function(module, exports) {
    $parcel$export(module.exports, "visuallyHiddenStyles", ()=>$11827e0613b04108$export$8dd524ceb40e3d16);
    $parcel$export(module.exports, "ScreenReaderText", ()=>$11827e0613b04108$export$88fad6aa294f111c);
    $parcel$export(module.exports, "ScreenReaderCaption", ()=>$11827e0613b04108$export$200c8e5d652aa9af);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $11827e0613b04108$export$8dd524ceb40e3d16 = {
        clip: 'rect(1px, 1px, 1px, 1px)',
        clipPath: 'inset(50%)',
        height: '1px',
        width: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute'
    };
    const $11827e0613b04108$export$88fad6aa294f111c = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
                __cmplp.className
            ])
        });
    });
    const $11827e0613b04108$export$200c8e5d652aa9af = (0, $5uXOq.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
                __cmplp.className
            ])
        });
    });
});
const $e0b5a9368b34b1c5$export$a3821bc63538b210 = 'customiseSidebar';
const $e0b5a9368b34b1c5$export$fba7c3adda5094d9 = 'sidebar-nav4';
const $e0b5a9368b34b1c5$export$3c19576bd92ff564 = 'sidebar-content';
parcelRegister("fS0Tg", function(module, exports) {
    $parcel$export(module.exports, "HideIcon", ()=>$a110cc98d6df0e48$export$3fa055d21925b0d3);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $a110cc98d6df0e48$var$CustomGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            id: "icon <icon>"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            id: "Vector",
            d: "M19.2405 10.6209L18.9347 11.3057C18.734 11.7553 18.3679 12.2877 17.8832 12.8226L18.5909 13.5303C18.8838 13.8232 18.8838 14.2981 18.5909 14.591C18.298 14.8839 17.8231 14.8839 17.5302 14.591L16.7926 13.8534C16.6895 13.9372 16.5839 14.0197 16.4761 14.1004C15.998 14.4583 15.4587 14.795 14.8732 15.0696L15.3415 16.0062C15.5267 16.3767 15.3766 16.8272 15.0061 17.0125C14.6356 17.1977 14.1851 17.0475 13.9999 16.677L13.4486 15.5744C12.9819 15.6864 12.4971 15.75 11.9999 15.75C11.5026 15.75 11.0179 15.6864 10.5512 15.5744L9.99986 16.677C9.81462 17.0475 9.36412 17.1977 8.99363 17.0125C8.62315 16.8272 8.47298 16.3767 8.65822 16.0062L9.12653 15.0696C8.54102 14.795 8.00173 14.4583 7.5236 14.1004C7.41582 14.0197 7.31026 13.9372 7.20713 13.8534L6.46955 14.591C6.17666 14.8839 5.70179 14.8839 5.40889 14.591C5.116 14.2981 5.116 13.8232 5.40889 13.5303L6.11656 12.8227C5.63186 12.2877 5.26571 11.7553 5.06502 11.3057L4.75928 10.6209L6.12898 10.0094L6.43472 10.6943C6.66455 11.2091 7.37568 12.1158 8.42257 12.8996C9.45878 13.6754 10.7174 14.25 11.9999 14.25C13.2823 14.25 14.541 13.6754 15.5772 12.8996C16.6241 12.1158 17.3352 11.2091 17.565 10.6943L17.8708 10.0094L19.2405 10.6209Z",
            fill: "currentColor"
        })));
    const $a110cc98d6df0e48$export$3fa055d21925b0d3 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $a110cc98d6df0e48$var$CustomGlyph,
            ...props
        });
});
parcelRegister("bMQWP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$101e40a24fd8093e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $101e40a24fd8093e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        hideFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.hide-from-sidebar",
            "defaultMessage": "Hide from sidebar"
        },
        a11YAlertHideDefaultFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-default-from-sidebar",
            "defaultMessage": "Menu Item have been hidden from the sidebar"
        },
        a11YHideAppsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-apps-from-sidebar",
            "defaultMessage": "Hide apps from sidebar"
        },
        a11YAlertHideAppsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-apps-from-sidebar",
            "defaultMessage": "Apps have been hidden from the sidebar"
        },
        a11YHideAssetsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-assets-from-sidebar",
            "defaultMessage": "Hide assets from sidebar"
        },
        a11YAlertHideAssetsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-assets-from-sidebar",
            "defaultMessage": "Assets have been hidden from the sidebar"
        },
        a11YHideDashboardsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-dashboards-from-sidebar",
            "defaultMessage": "Hide dashboards from sidebar"
        },
        a11YAlertHideDashboardsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-dashboards-from-sidebar",
            "defaultMessage": "Dashboards have been hidden from the sidebar"
        },
        a11YHideFiltersFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-filters-from-sidebar",
            "defaultMessage": "Hide filters from sidebar"
        },
        a11YAlertHideFiltersFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-filters-from-sidebar",
            "defaultMessage": "Filters have been hidden from the sidebar"
        },
        a11YHideGoalsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-goals-from-sidebar",
            "defaultMessage": "Hide goals from sidebar"
        },
        a11YAlertHideGoalsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-goals-from-sidebar",
            "defaultMessage": "Goals have been hidden from the sidebar"
        },
        a11YHideOperationsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-operations-from-sidebar",
            "defaultMessage": "Hide operations from sidebar"
        },
        a11YAlertHideOperationsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-operations-from-sidebar",
            "defaultMessage": "Operations have been hidden from the sidebar"
        },
        a11YHideOverviewsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-overviews-from-sidebar",
            "defaultMessage": "Hide overviews from sidebar"
        },
        a11YAlertHideOverviewsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-overviews-from-sidebar",
            "defaultMessage": "Overviews have been hidden from the sidebar"
        },
        a11YHidePlansFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-plans-from-sidebar",
            "defaultMessage": "Hide plans from sidebar"
        },
        a11YAlertHidePlansFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-plans-from-sidebar",
            "defaultMessage": "Plans have been hidden from the sidebar"
        },
        a11YHideProjectsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-projects-from-sidebar",
            "defaultMessage": "Hide projects from sidebar"
        },
        a11YAlertHideProjectsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-projects-from-sidebar",
            "defaultMessage": "Projects have been hidden from the sidebar"
        },
        a11YHideTeamsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-teams-from-sidebar",
            "defaultMessage": "Hide teams from sidebar"
        },
        a11YAlertHideTeamsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-teams-from-sidebar",
            "defaultMessage": "Teams have been hidden from the sidebar"
        },
        a11YHideRoadmapsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-roadmaps-from-sidebar",
            "defaultMessage": "Hide roadmaps from sidebar"
        },
        a11YAlertHideRoadmapsFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-roadmaps-from-sidebar",
            "defaultMessage": "Roadmaps have been hidden from the sidebar"
        },
        moveBackToSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.move-back-to-sidebar",
            "defaultMessage": "Move back to sidebar"
        },
        defaultHiddenFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-hidden-from-sidebar",
            "defaultMessage": "Hidden from sidebar"
        },
        appsHiddenFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-hidden-from-sidebar",
            "defaultMessage": "Apps hidden from sidebar"
        },
        assetsHiddenFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-hidden-from-sidebar",
            "defaultMessage": "Assets hidden from sidebar"
        },
        dashboardsHiddenFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-hidden-from-sidebar",
            "defaultMessage": "Dashboards hidden from sidebar"
        },
        filtersHiddenFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.filters-hidden-from-sidebar",
            "defaultMessage": "Filters hidden from sidebar"
        },
        goalsHiddenFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-hidden-from-sidebar",
            "defaultMessage": "Goals hidden from sidebar"
        },
        operationsHiddenFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-hidden-from-sidebar",
            "defaultMessage": "Operations hidden from sidebar"
        },
        overviewsHiddenFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.overviews-hidden-from-sidebar",
            "defaultMessage": "Overviews hidden from sidebar"
        },
        plansHiddenFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-hidden-from-sidebar",
            "defaultMessage": "Plans hidden from sidebar"
        },
        projectsHiddenFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-hidden-from-sidebar",
            "defaultMessage": "Projects hidden from sidebar"
        },
        teamsHiddenFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-hidden-from-sidebar",
            "defaultMessage": "Teams hidden from sidebar"
        },
        roadmapsHiddenFromSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-hidden-from-sidebar",
            "defaultMessage": "Roadmaps hidden from sidebar"
        },
        defaultMovedBackToSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-moved-back-to-sidebar",
            "defaultMessage": "Moved back to sidebar"
        },
        appsMovedBackToSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-moved-back-to-sidebar",
            "defaultMessage": "Apps moved back to sidebar"
        },
        assetsMovedBackToSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-moved-back-to-sidebar",
            "defaultMessage": "Assets moved back to sidebar"
        },
        dashboardsMovedBackToSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-moved-back-to-sidebar",
            "defaultMessage": "Dashboards moved back to sidebar"
        },
        filtersMovedBackToSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.filters-moved-back-to-sidebar",
            "defaultMessage": "Filters moved back to sidebar"
        },
        goalsMovedBackToSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-moved-back-to-sidebar",
            "defaultMessage": "Goals moved back to sidebar"
        },
        operationsMovedBackToSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-moved-back-to-sidebar",
            "defaultMessage": "Operations moved back to sidebar"
        },
        overviewsMovedBackToSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.overviews-moved-back-to-sidebar",
            "defaultMessage": "Overviews moved back to sidebar"
        },
        plansMovedBackToSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-moved-back-to-sidebar",
            "defaultMessage": "Plans moved back to sidebar"
        },
        projectsMovedBackToSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-moved-back-to-sidebar",
            "defaultMessage": "Projects moved back to sidebar"
        },
        teamsMovedBackToSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-moved-back-to-sidebar",
            "defaultMessage": "Teams moved back to sidebar"
        },
        roadmapsMovedBackToSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-moved-back-to-sidebar",
            "defaultMessage": "Roadmaps moved back to sidebar"
        }
    });
});
parcelRegister("ji6RV", function(module, exports) {
    $parcel$export(module.exports, "getA11YLabel", ()=>$88b27df430ca218e$export$fcb002b66b92bf50);
    $parcel$export(module.exports, "getA11YAlert", ()=>$88b27df430ca218e$export$45edd6abaa8989eb);
    $parcel$export(module.exports, "getNavItemHiddenFromSideBarFlagTitle", ()=>$88b27df430ca218e$export$95caae642a80ad);
    $parcel$export(module.exports, "getNavItemRestoredFromSideBarFlagTitle", ()=>$88b27df430ca218e$export$d4ad18508eb0e1ec);
    var $46Cti;
    var $bMQWP;
    const $88b27df430ca218e$export$fcb002b66b92bf50 = (menuId)=>{
        switch(menuId){
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YHideAppsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).GOALS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YHideGoalsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YHideRoadmapsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YHidePlansFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YHideProjectsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YHideFiltersFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YHideDashboardsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YHideOverviewsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OPERATIONS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YHideOperationsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YHideAssetsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YHideTeamsFromSidebar;
            default:
                return (0, (0, parcelRequire("bMQWP")).default).hideFromSidebar;
        }
    };
    const $88b27df430ca218e$export$45edd6abaa8989eb = (menuId)=>{
        switch(menuId){
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YAlertHideAppsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).GOALS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YAlertHideGoalsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YAlertHideRoadmapsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YAlertHidePlansFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YAlertHideProjectsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YAlertHideFiltersFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YAlertHideDashboardsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YAlertHideOverviewsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OPERATIONS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YAlertHideOperationsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YAlertHideAssetsFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS:
                return (0, (0, parcelRequire("bMQWP")).default).a11YAlertHideTeamsFromSidebar;
            default:
                return (0, (0, parcelRequire("bMQWP")).default).a11YAlertHideDefaultFromSidebar;
        }
    };
    const $88b27df430ca218e$export$95caae642a80ad = (menuId)=>{
        switch(menuId){
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS:
                return (0, (0, parcelRequire("bMQWP")).default).appsHiddenFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).GOALS:
                return (0, (0, parcelRequire("bMQWP")).default).goalsHiddenFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS:
                return (0, (0, parcelRequire("bMQWP")).default).roadmapsHiddenFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS:
                return (0, (0, parcelRequire("bMQWP")).default).plansHiddenFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS:
                return (0, (0, parcelRequire("bMQWP")).default).projectsHiddenFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS:
                return (0, (0, parcelRequire("bMQWP")).default).filtersMovedBackToSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS:
                return (0, (0, parcelRequire("bMQWP")).default).dashboardsHiddenFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS:
                return (0, (0, parcelRequire("bMQWP")).default).overviewsHiddenFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OPERATIONS:
                return (0, (0, parcelRequire("bMQWP")).default).operationsHiddenFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS:
                return (0, (0, parcelRequire("bMQWP")).default).assetsHiddenFromSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS:
                return (0, (0, parcelRequire("bMQWP")).default).teamsHiddenFromSidebar;
            default:
                return (0, (0, parcelRequire("bMQWP")).default).defaultHiddenFromSidebar;
        }
    };
    const $88b27df430ca218e$export$d4ad18508eb0e1ec = (menuId)=>{
        switch(menuId){
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS:
                return (0, (0, parcelRequire("bMQWP")).default).appsMovedBackToSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).GOALS:
                return (0, (0, parcelRequire("bMQWP")).default).goalsMovedBackToSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS:
                return (0, (0, parcelRequire("bMQWP")).default).roadmapsMovedBackToSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS:
                return (0, (0, parcelRequire("bMQWP")).default).plansMovedBackToSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS:
                return (0, (0, parcelRequire("bMQWP")).default).projectsMovedBackToSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS:
                return (0, (0, parcelRequire("bMQWP")).default).filtersMovedBackToSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS:
                return (0, (0, parcelRequire("bMQWP")).default).dashboardsMovedBackToSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS:
                return (0, (0, parcelRequire("bMQWP")).default).overviewsMovedBackToSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OPERATIONS:
                return (0, (0, parcelRequire("bMQWP")).default).operationsMovedBackToSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS:
                return (0, (0, parcelRequire("bMQWP")).default).assetsMovedBackToSidebar;
            case (0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS:
                return (0, (0, parcelRequire("bMQWP")).default).teamsMovedBackToSidebar;
            default:
                return (0, (0, parcelRequire("bMQWP")).default).defaultMovedBackToSidebar;
        }
    };
});
parcelRegister("aCS3f", function(module, exports) {
    $parcel$export(module.exports, "MoreNavMenuButton", ()=>$75aa993ce8b7228b$export$df3f5812ef8777cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $cDvOQ;
    var $fa1Fm;
    var $98dJo;
    const $75aa993ce8b7228b$export$df3f5812ef8777cb = ({ MenuItems: MenuItems, name: name, onOpen: onOpen, onClose: onCloseFlyout })=>{
        const { isOpen: isOpen, onClose: onCloseDropdown, onToggle: onToggle } = (0, (0, parcelRequire("cDvOQ")).useOpenable)();
        const content = (contentProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fa1Fm")).MoreNavMenuButtonSubmenu), {
                ...contentProps,
                MenuItems: MenuItems
            });
        const onClose = (0, $5uXOq.useCallback)((e)=>{
            try {
                onCloseFlyout?.(e);
            } finally{
                onCloseDropdown();
            }
        }, [
            onCloseFlyout,
            onCloseDropdown
        ]);
        const onTriggerClick = (0, $5uXOq.useCallback)(()=>{
            try {
                if (!isOpen) onOpen?.();
            } finally{
                onToggle();
            }
        }, [
            isOpen,
            onOpen,
            onToggle
        ]);
        const trigger = (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("98dJo")).MoreNavMenuButtonTrigger), {
                ...triggerProps,
                name: name,
                onClick: onTriggerClick
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            content: content,
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-start",
            trigger: trigger,
            shouldRenderToParent: true
        });
    };
});
parcelRegister("cDvOQ", function(module, exports) {
    $parcel$export(module.exports, "useOpenable", ()=>$89d72d59f9676a7b$export$e07f550759260fd7);
    var $5uXOq = parcelRequire("5uXOq");
    const $89d72d59f9676a7b$export$e07f550759260fd7 = (initialState = false)=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(initialState);
        const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
            setIsOpen
        ]);
        const onOpen = (0, $5uXOq.useCallback)(()=>setIsOpen(true), [
            setIsOpen
        ]);
        const onToggle = (0, $5uXOq.useCallback)(()=>setIsOpen((value)=>!value), [
            setIsOpen
        ]);
        return {
            isOpen: isOpen,
            onClose: onClose,
            onOpen: onOpen,
            onToggle: onToggle,
            setIsOpen: setIsOpen
        };
    };
});
parcelRegister("fa1Fm", function(module, exports) {
    $parcel$export(module.exports, "MoreNavMenuButtonSubmenu", ()=>$60df3cdd5682c247$export$ac88f3e136748c4a);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZUJu;
    var $dC5iT;
    var $4DrQd;
    const $60df3cdd5682c247$var$stopEventPropagation = (event)=>event.stopPropagation();
    const $60df3cdd5682c247$export$ac88f3e136748c4a = ({ MenuItems: MenuItems, onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            onMouseEnter: $60df3cdd5682c247$var$stopEventPropagation,
            onMouseLeave: $60df3cdd5682c247$var$stopEventPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), {
            minWidth: (0, (0, parcelRequire("4DrQd")).MENU_GROUP_MIN_WIDTH)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItems, {
            onClose: onClose
        })));
});
parcelRegister("98dJo", function(module, exports) {
    $parcel$export(module.exports, "MoreNavMenuButtonTrigger", ()=>$404df4ddac9bf885$export$c1fd214ac7085e79);
    var $5uXOq = parcelRequire("5uXOq");
    var $1wCbV;
    var $koVbs;
    var $1xonH;
    var $cwTmj;
    const $404df4ddac9bf885$export$c1fd214ac7085e79 = (0, $5uXOq.forwardRef)(({ name: name, ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xonH")).CommonNavMenuButton), {
            ...props,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("1wCbV"))))),
            label: name ? formatMessage((0, (0, parcelRequire("cwTmj")).default).moreActionsFor, {
                name: name
            }) : formatMessage((0, (0, parcelRequire("cwTmj")).default).moreActions),
            ref: ref
        });
    });
});
parcelRegister("1wCbV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $11c6679f8b16b181$var$_react = $11c6679f8b16b181$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $11c6679f8b16b181$var$_baseNew = $11c6679f8b16b181$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $11c6679f8b16b181$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $11c6679f8b16b181$var$ShowMoreHorizontalIcon = (props)=>$11c6679f8b16b181$var$_react.default.createElement($11c6679f8b16b181$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M6.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.75 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-9.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M6.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.75 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-9.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`,
            type: 'utility'
        }, props));
    $11c6679f8b16b181$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
    var $11c6679f8b16b181$var$_default = module.exports.default = $11c6679f8b16b181$var$ShowMoreHorizontalIcon;
});
parcelRegister("1xonH", function(module, exports) {
    $parcel$export(module.exports, "CommonNavMenuButton", ()=>$aa94212e0d70bb87$export$358f21998d56a71e);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    const $aa94212e0d70bb87$export$358f21998d56a71e = (0, $5uXOq.forwardRef)(({ onClick: onClick, icon: Icon, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            ...props,
            icon: (iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
                    ...iconProps,
                    size: "small"
                }),
            onClick: onClick,
            ref: ref,
            spacing: "compact",
            appearance: "subtle"
        }));
});
parcelRegister("cwTmj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83d1dc5b83237d0a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $83d1dc5b83237d0a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moreActions: {
            "id": "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions",
            "defaultMessage": "More actions"
        },
        moreActionsFor: {
            "id": "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions-for",
            "defaultMessage": "More actions for {name}"
        }
    });
});
parcelRegister("6awYZ", function(module, exports) {
    $parcel$export(module.exports, "getEmceeDiscoverLink", ()=>$3f6cbde73539e62b$export$f26dabf284aefb17);
    $parcel$export(module.exports, "getEmceeAppListingLink", ()=>$3f6cbde73539e62b$export$eb09695b9e9f6a3);
    $parcel$export(module.exports, "getAppRequestsLink", ()=>$3f6cbde73539e62b$export$7ab8c48f9081e976);
    $parcel$export(module.exports, "getManagePromotionsLink", ()=>$3f6cbde73539e62b$export$350ca33eed6a2742);
    var $co1wz;
    const $3f6cbde73539e62b$var$sanitiseParams = (params)=>params ? Object.entries(params).reduce((res, [key, value])=>{
            if (value) res[key] = params[key];
            return res;
        }, {}) : {};
    const $3f6cbde73539e62b$var$addQueryParamsToLink = (params, link)=>{
        const queryParams = $3f6cbde73539e62b$var$sanitiseParams(params);
        const queryString = new URLSearchParams(queryParams).toString();
        return queryString ? `${link}?${queryString}` : link;
    };
    const $3f6cbde73539e62b$var$resolveConnectDiscoverUrl = (connectUrlDiscoverVariant = 'ENDUSER_DISCOVER', jiraQueryParams)=>{
        let connectDiscoverUrl = `/plugins/servlet/ac/com.atlassian.jira.emcee/${connectUrlDiscoverVariant === 'DISCOVER' ? 'discover' : 'enduser-discover'}`;
        if (jiraQueryParams) connectDiscoverUrl = $3f6cbde73539e62b$var$addQueryParamsToLink(jiraQueryParams, connectDiscoverUrl);
        return connectDiscoverUrl;
    };
    const $3f6cbde73539e62b$export$f26dabf284aefb17 = (params, connectUrlDiscoverVariant = 'ENDUSER_DISCOVER')=>{
        const link = (0, (0, parcelRequire("co1wz")).ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/discover' : $3f6cbde73539e62b$var$resolveConnectDiscoverUrl(connectUrlDiscoverVariant);
        return $3f6cbde73539e62b$var$addQueryParamsToLink(params, link);
    };
    const $3f6cbde73539e62b$export$eb09695b9e9f6a3 = (appKey, params, jiraQueryParams, connectUrlDiscoverVariant = 'ENDUSER_DISCOVER')=>(0, (0, parcelRequire("co1wz")).ff)('marketplace.emcee.native.spa.enable') ? $3f6cbde73539e62b$var$addQueryParamsToLink({
            ...jiraQueryParams,
            ...params
        }, `/jira/marketplace/discover/app/${appKey}`) : $3f6cbde73539e62b$var$addQueryParamsToLink(params, `${$3f6cbde73539e62b$var$resolveConnectDiscoverUrl(connectUrlDiscoverVariant, jiraQueryParams)}#!/discover/app/${appKey}`);
    const $3f6cbde73539e62b$export$7ab8c48f9081e976 = (params)=>{
        const link = (0, (0, parcelRequire("co1wz")).ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/manage/app-requests' : '/plugins/servlet/ac/com.atlassian.jira.emcee/app-requests';
        return $3f6cbde73539e62b$var$addQueryParamsToLink(params, link);
    };
    const $3f6cbde73539e62b$export$350ca33eed6a2742 = (params)=>{
        const link = (0, (0, parcelRequire("co1wz")).ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/manage/promotions' : '/plugins/servlet/ac/com.atlassian.jira.emcee/promotions';
        return $3f6cbde73539e62b$var$addQueryParamsToLink(params, link);
    };
});
parcelRegister("iFqOo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$560cd06a0adfd8ce$export$2e2bcd8739ae039);
    var $7VHMR;
    var $560cd06a0adfd8ce$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        manageApps: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.manage-apps",
            "defaultMessage": "Manage apps"
        },
        appAuditLogs: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.app-audit-logs",
            "defaultMessage": "App audit logs"
        },
        viewAppRequests: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.view-app-requests",
            "defaultMessage": "View app requests"
        }
    });
});
parcelRegister("cbY68", function(module, exports) {
    $parcel$export(module.exports, "Nav4AppsDefault", ()=>$18bb1ac270cbc9bf$export$3732a771b6ecd66d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $jecJ3;
    var $jhS4y;
    var $iszzG;
    var $46Cti;
    var $c16H2;
    var $338xa;
    var $dQbFB;
    var $dUyqZ;
    var $4zcxJ;
    var $7Y7Js;
    var $8zOmE;
    var $2NMNM;
    var $koeKL;
    var $lnznH;
    var $cZa9B;
    var $6EHtA;
    var $g72iU;
    function $18bb1ac270cbc9bf$export$3732a771b6ecd66d(props) {
        const { actionsOnHover: actionsOnHover, simulateLoading: simulateLoading = false, isExpanded: isExpanded = simulateLoading } = props;
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId
            }), [
            cloudId
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("g72iU")).asyncNav4AppsContentViewQuery), entryPointParams);
        const triggerRef = (0, (0, parcelRequire("4zcxJ")).useExpandableEntryPointTrigger)(entryPointActions);
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iszzG")).NavItemsContext));
        const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, (0, parcelRequire("6EHtA")).createAttributes)({
                error: error,
                component: 'Nav4AppsDefault'
            }), []);
        (0, $5uXOq.useEffect)(()=>{
            if (isExpanded) entryPointActions.load();
        }, [
            entryPointActions,
            isExpanded
        ]);
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_APPS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: menuId,
            onSystemToggle: (hasExpanded)=>{
                if (hasExpanded) entryPointActions.load();
            },
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) {
                    entryPointActions.load();
                    const event = createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
                    });
                    const isInMore = moreMenuIds.includes((0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS);
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_APPS), {
                        isInMore: isInMore
                    });
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            interactionName: "nav4-sidebar-apps-default",
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            ref: triggerRef,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, simulateLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-apps-default",
            errorAttributes: getAttributes,
            packageName: (0, $13973d4cc5182a50$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $13973d4cc5182a50$export$d57b6b390e78d90f),
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null),
            runtimeProps: entryPointParams
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Y7Js")).ExploreMoreApps), null)));
    }
});
parcelRegister("c16H2", function(module, exports) {
    $parcel$export(module.exports, "Nav4ExpandableMenuItem", ()=>$ea944fd631b4ab3b$export$3c0db18b09c9af3e);
    var $5uXOq = parcelRequire("5uXOq");
    var $c6x3L;
    var $lJ5jf;
    var $mwgEH;
    const $ea944fd631b4ab3b$export$3c0db18b09c9af3e = (0, $5uXOq.forwardRef)($ea944fd631b4ab3b$var$_Nav4ExpandableMenuItem);
    function $ea944fd631b4ab3b$var$_Nav4ExpandableMenuItem(props, ref) {
        const { isSelectedPath: isSelectedPath, isInitialSelectedPath: isInitialSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const { isControlledNav: isControlledNav, isControlledPath: isControlledPath } = (0, (0, parcelRequire("lJ5jf")).useSidebarNav4Controller)();
        const { children: children, menuId: menuId, onExpansionToggle: onExpansionToggle, isExpanded: isExpanded = false, onSystemToggle: onSystemToggle } = props;
        const [isActuallyExpanded, setActuallyExpanded] = (0, $5uXOq.useState)(isInitialSelectedPath(menuId) || isExpanded);
        (0, $5uXOq.useEffect)(()=>{
            if (isActuallyExpanded === true && isExpanded === false) onSystemToggle?.(isActuallyExpanded);
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            const localIsExpanded = isSelectedPath(menuId) || isActuallyExpanded;
            if (localIsExpanded !== isActuallyExpanded) {
                setActuallyExpanded(localIsExpanded);
                onSystemToggle?.(localIsExpanded);
            }
        }, [
            isSelectedPath
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isControlledNav) return;
            const localIsExpanded = isControlledPath(menuId);
            if (localIsExpanded !== isActuallyExpanded) {
                setActuallyExpanded(localIsExpanded);
                onSystemToggle?.(localIsExpanded);
            }
        }, [
            isControlledPath
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("mwgEH")).ExpandableMenuItem), {
            ref: ref,
            isExpanded: isActuallyExpanded,
            onExpansionToggle: (hasExpanded)=>{
                setActuallyExpanded(hasExpanded);
                onExpansionToggle?.(hasExpanded);
            }
        }, children);
    }
});
parcelRegister("mwgEH", function(module, exports) {
    $parcel$export(module.exports, "ExpandableMenuItem", ()=>$c5233d2b5c8a7c4f$export$341dea48c30b36ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $33etG;
    var $1qQhw;
    var $et13M;
    const $c5233d2b5c8a7c4f$export$341dea48c30b36ff = (0, $5uXOq.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, isChildSelected: isChildSelected = false, onExpansionToggle: onExpansionToggle, children: children }, forwardedRef)=>{
        const [isExpanded, setIsExpanded] = (0, (0, parcelRequire("33etG")).default)(isExpandedControlled, ()=>isDefaultExpanded);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("et13M")).IsExpandedContext).Provider, {
            value: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("et13M")).SetIsExpandedContext).Provider, {
            value: setIsExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("et13M")).IsChildSelectedContext).Provider, {
            value: isChildSelected
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("et13M")).OnExpansionToggleContext).Provider, {
            value: onExpansionToggle ?? null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), {
            ref: forwardedRef
        }, children)))));
    });
});
parcelRegister("1qQhw", function(module, exports) {
    $parcel$export(module.exports, "MenuListItem", ()=>$352eeaf5cfbddcbe$export$6c2f3257abc4825b);
    var $eUDGK;
    const $352eeaf5cfbddcbe$export$6c2f3257abc4825b = (0, (0, parcelRequire("eUDGK")).ListItem);
});
parcelRegister("338xa", function(module, exports) {
    $parcel$export(module.exports, "SkeletonNavMenuItems", ()=>$32c488973b24b27b$export$c3a3a246584433d7);
    var $5uXOq = parcelRequire("5uXOq");
    var $9PCp5 = parcelRequire("9PCp5");
    var $iwwXK;
    var $1qQhw;
    const $32c488973b24b27b$export$c3a3a246584433d7 = ({ count: count = 5 })=>(0, ($parcel$interopDefault($9PCp5)))(0, count).map((index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
                isShimmering: true
            })));
});
parcelRegister("9PCp5", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $7286aa9f89a20bb7$var$func = $lVx1a('range', (parcelRequire("iASWI")));
    $7286aa9f89a20bb7$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $7286aa9f89a20bb7$var$func;
});
parcelRegister("lVx1a", function(module, exports) {
    var $iIayQ = parcelRequire("iIayQ");
    var $7sR67 = parcelRequire("7sR67");
    function $ff688881095ae098$var$convert(name, func, options) {
        return $iIayQ($7sR67, name, func, options);
    }
    module.exports = $ff688881095ae098$var$convert;
});
parcelRegister("iIayQ", function(module, exports) {
    var $lTdwm = parcelRequire("lTdwm");
    var $aPsMW = parcelRequire("aPsMW");
    var $d9f487426e0f9b59$var$push = Array.prototype.push;
    function $d9f487426e0f9b59$var$baseArity(func, n) {
        return n == 2 ? function(a, b) {
            return func.apply(undefined, arguments);
        } : function(a) {
            return func.apply(undefined, arguments);
        };
    }
    function $d9f487426e0f9b59$var$baseAry(func, n) {
        return n == 2 ? function(a, b) {
            return func(a, b);
        } : function(a) {
            return func(a);
        };
    }
    function $d9f487426e0f9b59$var$cloneArray(array) {
        var length = array ? array.length : 0, result = Array(length);
        while(length--)result[length] = array[length];
        return result;
    }
    function $d9f487426e0f9b59$var$createCloner(func) {
        return function(object) {
            return func({}, object);
        };
    }
    function $d9f487426e0f9b59$var$flatSpread(func, start) {
        return function() {
            var length = arguments.length, lastIndex = length - 1, args = Array(length);
            while(length--)args[length] = arguments[length];
            var array = args[start], otherArgs = args.slice(0, start);
            if (array) $d9f487426e0f9b59$var$push.apply(otherArgs, array);
            if (start != lastIndex) $d9f487426e0f9b59$var$push.apply(otherArgs, args.slice(start + 1));
            return func.apply(this, otherArgs);
        };
    }
    function $d9f487426e0f9b59$var$wrapImmutable(func, cloner) {
        return function() {
            var length = arguments.length;
            if (!length) return;
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var result = args[0] = cloner.apply(undefined, args);
            func.apply(undefined, args);
            return result;
        };
    }
    function $d9f487426e0f9b59$var$baseConvert(util, name, func, options) {
        var isLib = typeof name == 'function', isObj = name === Object(name);
        if (isObj) {
            options = func;
            func = name;
            name = undefined;
        }
        if (func == null) throw new TypeError;
        options || (options = {});
        var config = {
            'cap': 'cap' in options ? options.cap : true,
            'curry': 'curry' in options ? options.curry : true,
            'fixed': 'fixed' in options ? options.fixed : true,
            'immutable': 'immutable' in options ? options.immutable : true,
            'rearg': 'rearg' in options ? options.rearg : true
        };
        var defaultHolder = isLib ? func : $aPsMW, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
        var helpers = isLib ? func : {
            'ary': util.ary,
            'assign': util.assign,
            'clone': util.clone,
            'curry': util.curry,
            'forEach': util.forEach,
            'isArray': util.isArray,
            'isError': util.isError,
            'isFunction': util.isFunction,
            'isWeakMap': util.isWeakMap,
            'iteratee': util.iteratee,
            'keys': util.keys,
            'rearg': util.rearg,
            'toInteger': util.toInteger,
            'toPath': util.toPath
        };
        var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
        var aryMethodKeys = keys($lTdwm.aryMethod);
        var wrappers = {
            'castArray': function(castArray) {
                return function() {
                    var value = arguments[0];
                    return isArray(value) ? castArray($d9f487426e0f9b59$var$cloneArray(value)) : castArray.apply(undefined, arguments);
                };
            },
            'iteratee': function(iteratee) {
                return function() {
                    var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                    if (config.cap && typeof arity == 'number') {
                        arity = arity > 2 ? arity - 2 : 1;
                        return length && length <= arity ? result : $d9f487426e0f9b59$var$baseAry(result, arity);
                    }
                    return result;
                };
            },
            'mixin': function(mixin) {
                return function(source) {
                    var func = this;
                    if (!isFunction(func)) return mixin(func, Object(source));
                    var pairs = [];
                    each(keys(source), function(key) {
                        if (isFunction(source[key])) pairs.push([
                            key,
                            func.prototype[key]
                        ]);
                    });
                    mixin(func, Object(source));
                    each(pairs, function(pair) {
                        var value = pair[1];
                        if (isFunction(value)) func.prototype[pair[0]] = value;
                        else delete func.prototype[pair[0]];
                    });
                    return func;
                };
            },
            'nthArg': function(nthArg) {
                return function(n) {
                    var arity = n < 0 ? 1 : toInteger(n) + 1;
                    return curry(nthArg(n), arity);
                };
            },
            'rearg': function(rearg) {
                return function(func, indexes) {
                    var arity = indexes ? indexes.length : 0;
                    return curry(rearg(func, indexes), arity);
                };
            },
            'runInContext': function(runInContext) {
                return function(context) {
                    return $d9f487426e0f9b59$var$baseConvert(util, runInContext(context), options);
                };
            }
        };
        function castCap(name, func) {
            if (config.cap) {
                var indexes = $lTdwm.iterateeRearg[name];
                if (indexes) return iterateeRearg(func, indexes);
                var n = !isLib && $lTdwm.iterateeAry[name];
                if (n) return iterateeAry(func, n);
            }
            return func;
        }
        function castCurry(name, func, n) {
            return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
        }
        function castFixed(name, func, n) {
            if (config.fixed && (forceFixed || !$lTdwm.skipFixed[name])) {
                var data = $lTdwm.methodSpread[name], start = data && data.start;
                return start === undefined ? ary(func, n) : $d9f487426e0f9b59$var$flatSpread(func, start);
            }
            return func;
        }
        function castRearg(name, func, n) {
            return config.rearg && n > 1 && (forceRearg || !$lTdwm.skipRearg[name]) ? rearg(func, $lTdwm.methodRearg[name] || $lTdwm.aryRearg[n]) : func;
        }
        function cloneByPath(object, path) {
            path = toPath(path);
            var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
            while(nested != null && ++index < length){
                var key = path[index], value = nested[key];
                if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
                nested = nested[key];
            }
            return result;
        }
        function convertLib(options) {
            return _.runInContext.convert(options)(undefined);
        }
        function createConverter(name, func) {
            var realName = $lTdwm.aliasToReal[name] || name, methodName = $lTdwm.remap[realName] || realName, oldOptions = options;
            return function(options) {
                var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
                return $d9f487426e0f9b59$var$baseConvert(newUtil, realName, newFunc, newOptions);
            };
        }
        function iterateeAry(func, n) {
            return overArg(func, function(func) {
                return typeof func == 'function' ? $d9f487426e0f9b59$var$baseAry(func, n) : func;
            });
        }
        function iterateeRearg(func, indexes) {
            return overArg(func, function(func) {
                var n = indexes.length;
                return $d9f487426e0f9b59$var$baseArity(rearg($d9f487426e0f9b59$var$baseAry(func, n), indexes), n);
            });
        }
        function overArg(func, transform) {
            return function() {
                var length = arguments.length;
                if (!length) return func();
                var args = Array(length);
                while(length--)args[length] = arguments[length];
                var index = config.rearg ? 0 : length - 1;
                args[index] = transform(args[index]);
                return func.apply(undefined, args);
            };
        }
        function wrap(name, func, placeholder) {
            var result, realName = $lTdwm.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
            if (wrapper) wrapped = wrapper(func);
            else if (config.immutable) {
                if ($lTdwm.mutate.array[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$cloneArray);
                else if ($lTdwm.mutate.object[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$createCloner(func));
                else if ($lTdwm.mutate.set[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, cloneByPath);
            }
            each(aryMethodKeys, function(aryKey) {
                each($lTdwm.aryMethod[aryKey], function(otherName) {
                    if (realName == otherName) {
                        var data = $lTdwm.methodSpread[realName], afterRearg = data && data.afterRearg;
                        result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                        result = castCap(realName, result);
                        result = castCurry(realName, result, aryKey);
                        return false;
                    }
                });
                return !result;
            });
            result || (result = wrapped);
            if (result == func) result = forceCurry ? curry(result, 1) : function() {
                return func.apply(this, arguments);
            };
            result.convert = createConverter(realName, func);
            result.placeholder = func.placeholder = placeholder;
            return result;
        }
        if (!isObj) return wrap(name, func, defaultHolder);
        var _ = func;
        var pairs = [];
        each(aryMethodKeys, function(aryKey) {
            each($lTdwm.aryMethod[aryKey], function(key) {
                var func = _[$lTdwm.remap[key] || key];
                if (func) pairs.push([
                    key,
                    wrap(key, func, _)
                ]);
            });
        });
        each(keys(_), function(key) {
            var func = _[key];
            if (typeof func == 'function') {
                var length = pairs.length;
                while(length--){
                    if (pairs[length][0] == key) return;
                }
                func.convert = createConverter(key, func);
                pairs.push([
                    key,
                    func
                ]);
            }
        });
        each(pairs, function(pair) {
            _[pair[0]] = pair[1];
        });
        _.convert = convertLib;
        _.placeholder = _;
        each(keys(_), function(key) {
            each($lTdwm.realToAlias[key] || [], function(alias) {
                _[alias] = _[key];
            });
        });
        return _;
    }
    module.exports = $d9f487426e0f9b59$var$baseConvert;
});
parcelRegister("lTdwm", function(module, exports) {
    $parcel$export(module.exports, "aliasToReal", ()=>$fef938fb92c31507$export$bd0f5e6e44efa6b4, (v)=>$fef938fb92c31507$export$bd0f5e6e44efa6b4 = v);
    $parcel$export(module.exports, "aryMethod", ()=>$fef938fb92c31507$export$85c665b4d7da9cb4, (v)=>$fef938fb92c31507$export$85c665b4d7da9cb4 = v);
    $parcel$export(module.exports, "aryRearg", ()=>$fef938fb92c31507$export$42564e045b285e32, (v)=>$fef938fb92c31507$export$42564e045b285e32 = v);
    $parcel$export(module.exports, "iterateeAry", ()=>$fef938fb92c31507$export$81e17196e6a22b07, (v)=>$fef938fb92c31507$export$81e17196e6a22b07 = v);
    $parcel$export(module.exports, "iterateeRearg", ()=>$fef938fb92c31507$export$30975ceb42167ebd, (v)=>$fef938fb92c31507$export$30975ceb42167ebd = v);
    $parcel$export(module.exports, "methodRearg", ()=>$fef938fb92c31507$export$8ceb0ad7e94d3801, (v)=>$fef938fb92c31507$export$8ceb0ad7e94d3801 = v);
    $parcel$export(module.exports, "methodSpread", ()=>$fef938fb92c31507$export$fbaeb3f87df3cf26, (v)=>$fef938fb92c31507$export$fbaeb3f87df3cf26 = v);
    $parcel$export(module.exports, "mutate", ()=>$fef938fb92c31507$export$57e795267c26e600, (v)=>$fef938fb92c31507$export$57e795267c26e600 = v);
    $parcel$export(module.exports, "realToAlias", ()=>$fef938fb92c31507$export$1eb71a7e27943e71, (v)=>$fef938fb92c31507$export$1eb71a7e27943e71 = v);
    $parcel$export(module.exports, "remap", ()=>$fef938fb92c31507$export$aee1dbae5de2db9d, (v)=>$fef938fb92c31507$export$aee1dbae5de2db9d = v);
    $parcel$export(module.exports, "skipFixed", ()=>$fef938fb92c31507$export$87ffbe4821a5d5e0, (v)=>$fef938fb92c31507$export$87ffbe4821a5d5e0 = v);
    $parcel$export(module.exports, "skipRearg", ()=>$fef938fb92c31507$export$b4d07413ce528c90, (v)=>$fef938fb92c31507$export$b4d07413ce528c90 = v);
    var $fef938fb92c31507$export$bd0f5e6e44efa6b4;
    var $fef938fb92c31507$export$85c665b4d7da9cb4;
    var $fef938fb92c31507$export$42564e045b285e32;
    var $fef938fb92c31507$export$81e17196e6a22b07;
    var $fef938fb92c31507$export$30975ceb42167ebd;
    var $fef938fb92c31507$export$8ceb0ad7e94d3801;
    var $fef938fb92c31507$export$fbaeb3f87df3cf26;
    var $fef938fb92c31507$export$57e795267c26e600;
    var $fef938fb92c31507$export$1eb71a7e27943e71;
    var $fef938fb92c31507$export$aee1dbae5de2db9d;
    var $fef938fb92c31507$export$87ffbe4821a5d5e0;
    var $fef938fb92c31507$export$b4d07413ce528c90;
    $fef938fb92c31507$export$bd0f5e6e44efa6b4 = {
        'each': 'forEach',
        'eachRight': 'forEachRight',
        'entries': 'toPairs',
        'entriesIn': 'toPairsIn',
        'extend': 'assignIn',
        'extendAll': 'assignInAll',
        'extendAllWith': 'assignInAllWith',
        'extendWith': 'assignInWith',
        'first': 'head',
        'conforms': 'conformsTo',
        'matches': 'isMatch',
        'property': 'get',
        '__': 'placeholder',
        'F': 'stubFalse',
        'T': 'stubTrue',
        'all': 'every',
        'allPass': 'overEvery',
        'always': 'constant',
        'any': 'some',
        'anyPass': 'overSome',
        'apply': 'spread',
        'assoc': 'set',
        'assocPath': 'set',
        'complement': 'negate',
        'compose': 'flowRight',
        'contains': 'includes',
        'dissoc': 'unset',
        'dissocPath': 'unset',
        'dropLast': 'dropRight',
        'dropLastWhile': 'dropRightWhile',
        'equals': 'isEqual',
        'identical': 'eq',
        'indexBy': 'keyBy',
        'init': 'initial',
        'invertObj': 'invert',
        'juxt': 'over',
        'omitAll': 'omit',
        'nAry': 'ary',
        'path': 'get',
        'pathEq': 'matchesProperty',
        'pathOr': 'getOr',
        'paths': 'at',
        'pickAll': 'pick',
        'pipe': 'flow',
        'pluck': 'map',
        'prop': 'get',
        'propEq': 'matchesProperty',
        'propOr': 'getOr',
        'props': 'at',
        'symmetricDifference': 'xor',
        'symmetricDifferenceBy': 'xorBy',
        'symmetricDifferenceWith': 'xorWith',
        'takeLast': 'takeRight',
        'takeLastWhile': 'takeRightWhile',
        'unapply': 'rest',
        'unnest': 'flatten',
        'useWith': 'overArgs',
        'where': 'conformsTo',
        'whereEq': 'isMatch',
        'zipObj': 'zipObject'
    };
    $fef938fb92c31507$export$85c665b4d7da9cb4 = {
        '1': [
            'assignAll',
            'assignInAll',
            'attempt',
            'castArray',
            'ceil',
            'create',
            'curry',
            'curryRight',
            'defaultsAll',
            'defaultsDeepAll',
            'floor',
            'flow',
            'flowRight',
            'fromPairs',
            'invert',
            'iteratee',
            'memoize',
            'method',
            'mergeAll',
            'methodOf',
            'mixin',
            'nthArg',
            'over',
            'overEvery',
            'overSome',
            'rest',
            'reverse',
            'round',
            'runInContext',
            'spread',
            'template',
            'trim',
            'trimEnd',
            'trimStart',
            'uniqueId',
            'words',
            'zipAll'
        ],
        '2': [
            'add',
            'after',
            'ary',
            'assign',
            'assignAllWith',
            'assignIn',
            'assignInAllWith',
            'at',
            'before',
            'bind',
            'bindAll',
            'bindKey',
            'chunk',
            'cloneDeepWith',
            'cloneWith',
            'concat',
            'conformsTo',
            'countBy',
            'curryN',
            'curryRightN',
            'debounce',
            'defaults',
            'defaultsDeep',
            'defaultTo',
            'delay',
            'difference',
            'divide',
            'drop',
            'dropRight',
            'dropRightWhile',
            'dropWhile',
            'endsWith',
            'eq',
            'every',
            'filter',
            'find',
            'findIndex',
            'findKey',
            'findLast',
            'findLastIndex',
            'findLastKey',
            'flatMap',
            'flatMapDeep',
            'flattenDepth',
            'forEach',
            'forEachRight',
            'forIn',
            'forInRight',
            'forOwn',
            'forOwnRight',
            'get',
            'groupBy',
            'gt',
            'gte',
            'has',
            'hasIn',
            'includes',
            'indexOf',
            'intersection',
            'invertBy',
            'invoke',
            'invokeMap',
            'isEqual',
            'isMatch',
            'join',
            'keyBy',
            'lastIndexOf',
            'lt',
            'lte',
            'map',
            'mapKeys',
            'mapValues',
            'matchesProperty',
            'maxBy',
            'meanBy',
            'merge',
            'mergeAllWith',
            'minBy',
            'multiply',
            'nth',
            'omit',
            'omitBy',
            'overArgs',
            'pad',
            'padEnd',
            'padStart',
            'parseInt',
            'partial',
            'partialRight',
            'partition',
            'pick',
            'pickBy',
            'propertyOf',
            'pull',
            'pullAll',
            'pullAt',
            'random',
            'range',
            'rangeRight',
            'rearg',
            'reject',
            'remove',
            'repeat',
            'restFrom',
            'result',
            'sampleSize',
            'some',
            'sortBy',
            'sortedIndex',
            'sortedIndexOf',
            'sortedLastIndex',
            'sortedLastIndexOf',
            'sortedUniqBy',
            'split',
            'spreadFrom',
            'startsWith',
            'subtract',
            'sumBy',
            'take',
            'takeRight',
            'takeRightWhile',
            'takeWhile',
            'tap',
            'throttle',
            'thru',
            'times',
            'trimChars',
            'trimCharsEnd',
            'trimCharsStart',
            'truncate',
            'union',
            'uniqBy',
            'uniqWith',
            'unset',
            'unzipWith',
            'without',
            'wrap',
            'xor',
            'zip',
            'zipObject',
            'zipObjectDeep'
        ],
        '3': [
            'assignInWith',
            'assignWith',
            'clamp',
            'differenceBy',
            'differenceWith',
            'findFrom',
            'findIndexFrom',
            'findLastFrom',
            'findLastIndexFrom',
            'getOr',
            'includesFrom',
            'indexOfFrom',
            'inRange',
            'intersectionBy',
            'intersectionWith',
            'invokeArgs',
            'invokeArgsMap',
            'isEqualWith',
            'isMatchWith',
            'flatMapDepth',
            'lastIndexOfFrom',
            'mergeWith',
            'orderBy',
            'padChars',
            'padCharsEnd',
            'padCharsStart',
            'pullAllBy',
            'pullAllWith',
            'rangeStep',
            'rangeStepRight',
            'reduce',
            'reduceRight',
            'replace',
            'set',
            'slice',
            'sortedIndexBy',
            'sortedLastIndexBy',
            'transform',
            'unionBy',
            'unionWith',
            'update',
            'xorBy',
            'xorWith',
            'zipWith'
        ],
        '4': [
            'fill',
            'setWith',
            'updateWith'
        ]
    };
    $fef938fb92c31507$export$42564e045b285e32 = {
        '2': [
            1,
            0
        ],
        '3': [
            2,
            0,
            1
        ],
        '4': [
            3,
            2,
            0,
            1
        ]
    };
    $fef938fb92c31507$export$81e17196e6a22b07 = {
        'dropRightWhile': 1,
        'dropWhile': 1,
        'every': 1,
        'filter': 1,
        'find': 1,
        'findFrom': 1,
        'findIndex': 1,
        'findIndexFrom': 1,
        'findKey': 1,
        'findLast': 1,
        'findLastFrom': 1,
        'findLastIndex': 1,
        'findLastIndexFrom': 1,
        'findLastKey': 1,
        'flatMap': 1,
        'flatMapDeep': 1,
        'flatMapDepth': 1,
        'forEach': 1,
        'forEachRight': 1,
        'forIn': 1,
        'forInRight': 1,
        'forOwn': 1,
        'forOwnRight': 1,
        'map': 1,
        'mapKeys': 1,
        'mapValues': 1,
        'partition': 1,
        'reduce': 2,
        'reduceRight': 2,
        'reject': 1,
        'remove': 1,
        'some': 1,
        'takeRightWhile': 1,
        'takeWhile': 1,
        'times': 1,
        'transform': 2
    };
    $fef938fb92c31507$export$30975ceb42167ebd = {
        'mapKeys': [
            1
        ],
        'reduceRight': [
            1,
            0
        ]
    };
    $fef938fb92c31507$export$8ceb0ad7e94d3801 = {
        'assignInAllWith': [
            1,
            0
        ],
        'assignInWith': [
            1,
            2,
            0
        ],
        'assignAllWith': [
            1,
            0
        ],
        'assignWith': [
            1,
            2,
            0
        ],
        'differenceBy': [
            1,
            2,
            0
        ],
        'differenceWith': [
            1,
            2,
            0
        ],
        'getOr': [
            2,
            1,
            0
        ],
        'intersectionBy': [
            1,
            2,
            0
        ],
        'intersectionWith': [
            1,
            2,
            0
        ],
        'isEqualWith': [
            1,
            2,
            0
        ],
        'isMatchWith': [
            2,
            1,
            0
        ],
        'mergeAllWith': [
            1,
            0
        ],
        'mergeWith': [
            1,
            2,
            0
        ],
        'padChars': [
            2,
            1,
            0
        ],
        'padCharsEnd': [
            2,
            1,
            0
        ],
        'padCharsStart': [
            2,
            1,
            0
        ],
        'pullAllBy': [
            2,
            1,
            0
        ],
        'pullAllWith': [
            2,
            1,
            0
        ],
        'rangeStep': [
            1,
            2,
            0
        ],
        'rangeStepRight': [
            1,
            2,
            0
        ],
        'setWith': [
            3,
            1,
            2,
            0
        ],
        'sortedIndexBy': [
            2,
            1,
            0
        ],
        'sortedLastIndexBy': [
            2,
            1,
            0
        ],
        'unionBy': [
            1,
            2,
            0
        ],
        'unionWith': [
            1,
            2,
            0
        ],
        'updateWith': [
            3,
            1,
            2,
            0
        ],
        'xorBy': [
            1,
            2,
            0
        ],
        'xorWith': [
            1,
            2,
            0
        ],
        'zipWith': [
            1,
            2,
            0
        ]
    };
    $fef938fb92c31507$export$fbaeb3f87df3cf26 = {
        'assignAll': {
            'start': 0
        },
        'assignAllWith': {
            'start': 0
        },
        'assignInAll': {
            'start': 0
        },
        'assignInAllWith': {
            'start': 0
        },
        'defaultsAll': {
            'start': 0
        },
        'defaultsDeepAll': {
            'start': 0
        },
        'invokeArgs': {
            'start': 2
        },
        'invokeArgsMap': {
            'start': 2
        },
        'mergeAll': {
            'start': 0
        },
        'mergeAllWith': {
            'start': 0
        },
        'partial': {
            'start': 1
        },
        'partialRight': {
            'start': 1
        },
        'without': {
            'start': 1
        },
        'zipAll': {
            'start': 0
        }
    };
    $fef938fb92c31507$export$57e795267c26e600 = {
        'array': {
            'fill': true,
            'pull': true,
            'pullAll': true,
            'pullAllBy': true,
            'pullAllWith': true,
            'pullAt': true,
            'remove': true,
            'reverse': true
        },
        'object': {
            'assign': true,
            'assignAll': true,
            'assignAllWith': true,
            'assignIn': true,
            'assignInAll': true,
            'assignInAllWith': true,
            'assignInWith': true,
            'assignWith': true,
            'defaults': true,
            'defaultsAll': true,
            'defaultsDeep': true,
            'defaultsDeepAll': true,
            'merge': true,
            'mergeAll': true,
            'mergeAllWith': true,
            'mergeWith': true
        },
        'set': {
            'set': true,
            'setWith': true,
            'unset': true,
            'update': true,
            'updateWith': true
        }
    };
    $fef938fb92c31507$export$1eb71a7e27943e71 = function() {
        var hasOwnProperty = Object.prototype.hasOwnProperty, object = $fef938fb92c31507$export$bd0f5e6e44efa6b4, result = {};
        for(var key in object){
            var value = object[key];
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }
        return result;
    }();
    $fef938fb92c31507$export$aee1dbae5de2db9d = {
        'assignAll': 'assign',
        'assignAllWith': 'assignWith',
        'assignInAll': 'assignIn',
        'assignInAllWith': 'assignInWith',
        'curryN': 'curry',
        'curryRightN': 'curryRight',
        'defaultsAll': 'defaults',
        'defaultsDeepAll': 'defaultsDeep',
        'findFrom': 'find',
        'findIndexFrom': 'findIndex',
        'findLastFrom': 'findLast',
        'findLastIndexFrom': 'findLastIndex',
        'getOr': 'get',
        'includesFrom': 'includes',
        'indexOfFrom': 'indexOf',
        'invokeArgs': 'invoke',
        'invokeArgsMap': 'invokeMap',
        'lastIndexOfFrom': 'lastIndexOf',
        'mergeAll': 'merge',
        'mergeAllWith': 'mergeWith',
        'padChars': 'pad',
        'padCharsEnd': 'padEnd',
        'padCharsStart': 'padStart',
        'propertyOf': 'get',
        'rangeStep': 'range',
        'rangeStepRight': 'rangeRight',
        'restFrom': 'rest',
        'spreadFrom': 'spread',
        'trimChars': 'trim',
        'trimCharsEnd': 'trimEnd',
        'trimCharsStart': 'trimStart',
        'zipAll': 'zip'
    };
    $fef938fb92c31507$export$87ffbe4821a5d5e0 = {
        'castArray': true,
        'flow': true,
        'flowRight': true,
        'iteratee': true,
        'mixin': true,
        'rearg': true,
        'runInContext': true
    };
    $fef938fb92c31507$export$b4d07413ce528c90 = {
        'add': true,
        'assign': true,
        'assignIn': true,
        'bind': true,
        'bindKey': true,
        'concat': true,
        'difference': true,
        'divide': true,
        'eq': true,
        'gt': true,
        'gte': true,
        'isEqual': true,
        'lt': true,
        'lte': true,
        'matchesProperty': true,
        'merge': true,
        'multiply': true,
        'overArgs': true,
        'partial': true,
        'partialRight': true,
        'propertyOf': true,
        'random': true,
        'range': true,
        'rangeRight': true,
        'subtract': true,
        'zip': true,
        'zipObject': true,
        'zipObjectDeep': true
    };
});
parcelRegister("aPsMW", function(module, exports) {
    module.exports = {};
});
parcelRegister("7sR67", function(module, exports) {
    module.exports = {
        'ary': (parcelRequire("lEyvi")),
        'assign': (parcelRequire("bqJNK")),
        'clone': (parcelRequire("91VA7")),
        'curry': (parcelRequire("a7NzZ")),
        'forEach': (parcelRequire("fmP8r")),
        'isArray': (parcelRequire("8LQ84")),
        'isError': (parcelRequire("aZFhV")),
        'isFunction': (parcelRequire("5vD8v")),
        'isWeakMap': (parcelRequire("5UxIS")),
        'iteratee': (parcelRequire("5qDt4")),
        'keys': (parcelRequire("hR3Ue")),
        'rearg': (parcelRequire("iZlmO")),
        'toInteger': (parcelRequire("kPZpS")),
        'toPath': (parcelRequire("6TYHJ"))
    };
});
parcelRegister("lEyvi", function(module, exports) {
    var $5oTQF = parcelRequire("5oTQF");
    var $fc3819207d6eebc6$var$WRAP_ARY_FLAG = 128;
    function $fc3819207d6eebc6$var$ary(func, n, guard) {
        n = guard ? undefined : n;
        n = func && n == null ? func.length : n;
        return $5oTQF(func, $fc3819207d6eebc6$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }
    module.exports = $fc3819207d6eebc6$var$ary;
});
parcelRegister("5oTQF", function(module, exports) {
    var $g1o5k = parcelRequire("g1o5k");
    var $1BSxH = parcelRequire("1BSxH");
    var $gQoGK = parcelRequire("gQoGK");
    var $2pq1V = parcelRequire("2pq1V");
    var $cwXqG = parcelRequire("cwXqG");
    var $dzqxs = parcelRequire("dzqxs");
    var $c8pf3 = parcelRequire("c8pf3");
    var $4EzKU = parcelRequire("4EzKU");
    var $iKqmZ = parcelRequire("iKqmZ");
    var $kPZpS = parcelRequire("kPZpS");
    var $3eea84024a50d6cf$var$FUNC_ERROR_TEXT = 'Expected a function';
    var $3eea84024a50d6cf$var$WRAP_BIND_FLAG = 1, $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG = 2, $3eea84024a50d6cf$var$WRAP_CURRY_FLAG = 8, $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG = 16, $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG = 32, $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
    var $3eea84024a50d6cf$var$nativeMax = Math.max;
    function $3eea84024a50d6cf$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
        var isBindKey = bitmask & $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != 'function') throw new TypeError($3eea84024a50d6cf$var$FUNC_ERROR_TEXT);
        var length = partials ? partials.length : 0;
        if (!length) {
            bitmask &= ~($3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined;
        }
        ary = ary === undefined ? ary : $3eea84024a50d6cf$var$nativeMax($kPZpS(ary), 0);
        arity = arity === undefined ? arity : $kPZpS(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined;
        }
        var data = isBindKey ? undefined : $dzqxs(func);
        var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary,
            arity
        ];
        if (data) $c8pf3(newData, data);
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $3eea84024a50d6cf$var$nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & ($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG);
        if (!bitmask || bitmask == $3eea84024a50d6cf$var$WRAP_BIND_FLAG) var result = $1BSxH(func, bitmask, thisArg);
        else if (bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_FLAG || bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG) result = $gQoGK(func, bitmask, arity);
        else if ((bitmask == $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG || bitmask == ($3eea84024a50d6cf$var$WRAP_BIND_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $cwXqG(func, bitmask, thisArg, partials);
        else result = $2pq1V.apply(undefined, newData);
        var setter = data ? $g1o5k : $4EzKU;
        return $iKqmZ(setter(result, newData), func, bitmask);
    }
    module.exports = $3eea84024a50d6cf$var$createWrap;
});
parcelRegister("g1o5k", function(module, exports) {
    var $etyzk = parcelRequire("etyzk");
    var $hQCy5 = parcelRequire("hQCy5");
    var $ba9f6c1d52531584$var$baseSetData = !$hQCy5 ? $etyzk : function(func, data) {
        $hQCy5.set(func, data);
        return func;
    };
    module.exports = $ba9f6c1d52531584$var$baseSetData;
});
parcelRegister("1BSxH", function(module, exports) {
    var $iJkMv = parcelRequire("iJkMv");
    var $1V15E = parcelRequire("1V15E");
    var $12c38e2c5009183b$var$WRAP_BIND_FLAG = 1;
    function $12c38e2c5009183b$var$createBind(func, bitmask, thisArg) {
        var isBind = bitmask & $12c38e2c5009183b$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
        function wrapper() {
            var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
    }
    module.exports = $12c38e2c5009183b$var$createBind;
});
parcelRegister("iJkMv", function(module, exports) {
    var $ady43 = parcelRequire("ady43");
    var $k0qYG = parcelRequire("k0qYG");
    function $da2c8caf7ae3955a$var$createCtor(Ctor) {
        return function() {
            var args = arguments;
            switch(args.length){
                case 0:
                    return new Ctor;
                case 1:
                    return new Ctor(args[0]);
                case 2:
                    return new Ctor(args[0], args[1]);
                case 3:
                    return new Ctor(args[0], args[1], args[2]);
                case 4:
                    return new Ctor(args[0], args[1], args[2], args[3]);
                case 5:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                case 6:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                case 7:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = $ady43(Ctor.prototype), result = Ctor.apply(thisBinding, args);
            return $k0qYG(result) ? result : thisBinding;
        };
    }
    module.exports = $da2c8caf7ae3955a$var$createCtor;
});
parcelRegister("gQoGK", function(module, exports) {
    var $hlchF = parcelRequire("hlchF");
    var $iJkMv = parcelRequire("iJkMv");
    var $2pq1V = parcelRequire("2pq1V");
    var $6fuEo = parcelRequire("6fuEo");
    var $8ZIC5 = parcelRequire("8ZIC5");
    var $kBUUu = parcelRequire("kBUUu");
    var $1V15E = parcelRequire("1V15E");
    function $c434a7442e0e841e$var$createCurry(func, bitmask, arity) {
        var Ctor = $iJkMv(func);
        function wrapper() {
            var length = arguments.length, args = Array(length), index = length, placeholder = $8ZIC5(wrapper);
            while(index--)args[index] = arguments[index];
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBUUu(args, placeholder);
            length -= holders.length;
            if (length < arity) return $6fuEo(func, bitmask, $2pq1V, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
            var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
            return $hlchF(fn, this, args);
        }
        return wrapper;
    }
    module.exports = $c434a7442e0e841e$var$createCurry;
});
parcelRegister("2pq1V", function(module, exports) {
    var $k8MLc = parcelRequire("k8MLc");
    var $eqXBf = parcelRequire("eqXBf");
    var $khpbX = parcelRequire("khpbX");
    var $iJkMv = parcelRequire("iJkMv");
    var $6fuEo = parcelRequire("6fuEo");
    var $8ZIC5 = parcelRequire("8ZIC5");
    var $3Prcz = parcelRequire("3Prcz");
    var $kBUUu = parcelRequire("kBUUu");
    var $1V15E = parcelRequire("1V15E");
    var $1c121b92b9034c1f$var$WRAP_BIND_FLAG = 1, $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG = 2, $1c121b92b9034c1f$var$WRAP_CURRY_FLAG = 8, $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG = 16, $1c121b92b9034c1f$var$WRAP_ARY_FLAG = 128, $1c121b92b9034c1f$var$WRAP_FLIP_FLAG = 512;
    function $1c121b92b9034c1f$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
        var isAry = bitmask & $1c121b92b9034c1f$var$WRAP_ARY_FLAG, isBind = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_FLAG, isBindKey = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($1c121b92b9034c1f$var$WRAP_CURRY_FLAG | $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $1c121b92b9034c1f$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $iJkMv(func);
        function wrapper() {
            var length = arguments.length, args = Array(length), index = length;
            while(index--)args[index] = arguments[index];
            if (isCurried) var placeholder = $8ZIC5(wrapper), holdersCount = $khpbX(args, placeholder);
            if (partials) args = $k8MLc(args, partials, holders, isCurried);
            if (partialsRight) args = $eqXBf(args, partialsRight, holdersRight, isCurried);
            length -= holdersCount;
            if (isCurried && length < arity) {
                var newHolders = $kBUUu(args, placeholder);
                return $6fuEo(func, bitmask, $1c121b92b9034c1f$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) args = $3Prcz(args, argPos);
            else if (isFlip && length > 1) args.reverse();
            if (isAry && ary < length) args.length = ary;
            if (this && this !== $1V15E && this instanceof wrapper) fn = Ctor || $iJkMv(fn);
            return fn.apply(thisBinding, args);
        }
        return wrapper;
    }
    module.exports = $1c121b92b9034c1f$var$createHybrid;
});
parcelRegister("k8MLc", function(module, exports) {
    var $ea9a60ca966f8da9$var$nativeMax = Math.max;
    function $ea9a60ca966f8da9$var$composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $ea9a60ca966f8da9$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
        while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
        while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
        while(rangeLength--)result[leftIndex++] = args[argsIndex++];
        return result;
    }
    module.exports = $ea9a60ca966f8da9$var$composeArgs;
});
parcelRegister("eqXBf", function(module, exports) {
    var $a821b9ab167c5b82$var$nativeMax = Math.max;
    function $a821b9ab167c5b82$var$composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $a821b9ab167c5b82$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
        while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
        var offset = argsIndex;
        while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
        while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
        return result;
    }
    module.exports = $a821b9ab167c5b82$var$composeArgsRight;
});
parcelRegister("khpbX", function(module, exports) {
    function $ec38efbc1ab3f809$var$countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    module.exports = $ec38efbc1ab3f809$var$countHolders;
});
parcelRegister("6fuEo", function(module, exports) {
    var $2dCKt = parcelRequire("2dCKt");
    var $4EzKU = parcelRequire("4EzKU");
    var $iKqmZ = parcelRequire("iKqmZ");
    var $48cbeb57943323d5$var$WRAP_BIND_FLAG = 1, $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG = 2, $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG = 4, $48cbeb57943323d5$var$WRAP_CURRY_FLAG = 8, $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG = 32, $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
    function $48cbeb57943323d5$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
        var isCurry = bitmask & $48cbeb57943323d5$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
        bitmask |= isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG);
        if (!(bitmask & $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($48cbeb57943323d5$var$WRAP_BIND_FLAG | $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG);
        var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary,
            arity
        ];
        var result = wrapFunc.apply(undefined, newData);
        if ($2dCKt(func)) $4EzKU(result, newData);
        result.placeholder = placeholder;
        return $iKqmZ(result, func, bitmask);
    }
    module.exports = $48cbeb57943323d5$var$createRecurry;
});
parcelRegister("4EzKU", function(module, exports) {
    var $g1o5k = parcelRequire("g1o5k");
    var $eqv0t = parcelRequire("eqv0t");
    var $3636a22a88d50b78$var$setData = $eqv0t($g1o5k);
    module.exports = $3636a22a88d50b78$var$setData;
});
parcelRegister("iKqmZ", function(module, exports) {
    var $d25DY = parcelRequire("d25DY");
    var $iPKwQ = parcelRequire("iPKwQ");
    var $8pgNR = parcelRequire("8pgNR");
    var $1ZcUe = parcelRequire("1ZcUe");
    function $da60fa5a8c702882$var$setWrapToString(wrapper, reference, bitmask) {
        var source = reference + '';
        return $8pgNR(wrapper, $iPKwQ(source, $1ZcUe($d25DY(source), bitmask)));
    }
    module.exports = $da60fa5a8c702882$var$setWrapToString;
});
parcelRegister("d25DY", function(module, exports) {
    var $97cfd7023a392295$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $97cfd7023a392295$var$reSplitDetails = /,? & /;
    function $97cfd7023a392295$var$getWrapDetails(source) {
        var match = source.match($97cfd7023a392295$var$reWrapDetails);
        return match ? match[1].split($97cfd7023a392295$var$reSplitDetails) : [];
    }
    module.exports = $97cfd7023a392295$var$getWrapDetails;
});
parcelRegister("iPKwQ", function(module, exports) {
    var $db61150bcd231438$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
    function $db61150bcd231438$var$insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) return source;
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
        details = details.join(length > 2 ? ', ' : ' ');
        return source.replace($db61150bcd231438$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }
    module.exports = $db61150bcd231438$var$insertWrapDetails;
});
parcelRegister("1ZcUe", function(module, exports) {
    var $fmP8r = parcelRequire("fmP8r");
    var $fUP98 = parcelRequire("fUP98");
    var $17257fcfcc231370$var$WRAP_BIND_FLAG = 1, $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG = 2, $17257fcfcc231370$var$WRAP_CURRY_FLAG = 8, $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG = 16, $17257fcfcc231370$var$WRAP_PARTIAL_FLAG = 32, $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $17257fcfcc231370$var$WRAP_ARY_FLAG = 128, $17257fcfcc231370$var$WRAP_REARG_FLAG = 256, $17257fcfcc231370$var$WRAP_FLIP_FLAG = 512;
    var $17257fcfcc231370$var$wrapFlags = [
        [
            'ary',
            $17257fcfcc231370$var$WRAP_ARY_FLAG
        ],
        [
            'bind',
            $17257fcfcc231370$var$WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            $17257fcfcc231370$var$WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            $17257fcfcc231370$var$WRAP_FLIP_FLAG
        ],
        [
            'partial',
            $17257fcfcc231370$var$WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            $17257fcfcc231370$var$WRAP_REARG_FLAG
        ]
    ];
    function $17257fcfcc231370$var$updateWrapDetails(details, bitmask) {
        $fmP8r($17257fcfcc231370$var$wrapFlags, function(pair) {
            var value = '_.' + pair[0];
            if (bitmask & pair[1] && !$fUP98(details, value)) details.push(value);
        });
        return details.sort();
    }
    module.exports = $17257fcfcc231370$var$updateWrapDetails;
});
parcelRegister("8ZIC5", function(module, exports) {
    function $68c6a086039b9437$var$getHolder(func) {
        var object = func;
        return object.placeholder;
    }
    module.exports = $68c6a086039b9437$var$getHolder;
});
parcelRegister("3Prcz", function(module, exports) {
    var $jHlUS = parcelRequire("jHlUS");
    var $e8U1z = parcelRequire("e8U1z");
    var $2c9b3c36ffa24094$var$nativeMin = Math.min;
    function $2c9b3c36ffa24094$var$reorder(array, indexes) {
        var arrLength = array.length, length = $2c9b3c36ffa24094$var$nativeMin(indexes.length, arrLength), oldArray = $jHlUS(array);
        while(length--){
            var index = indexes[length];
            array[length] = $e8U1z(index, arrLength) ? oldArray[index] : undefined;
        }
        return array;
    }
    module.exports = $2c9b3c36ffa24094$var$reorder;
});
parcelRegister("kBUUu", function(module, exports) {
    var $f0136883d4267917$var$PLACEHOLDER = '__lodash_placeholder__';
    function $f0136883d4267917$var$replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === $f0136883d4267917$var$PLACEHOLDER) {
                array[index] = $f0136883d4267917$var$PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    module.exports = $f0136883d4267917$var$replaceHolders;
});
parcelRegister("cwXqG", function(module, exports) {
    var $hlchF = parcelRequire("hlchF");
    var $iJkMv = parcelRequire("iJkMv");
    var $1V15E = parcelRequire("1V15E");
    var $91f6929c17575724$var$WRAP_BIND_FLAG = 1;
    function $91f6929c17575724$var$createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & $91f6929c17575724$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
        function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
            while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
            while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
            return $hlchF(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
    }
    module.exports = $91f6929c17575724$var$createPartial;
});
parcelRegister("c8pf3", function(module, exports) {
    var $k8MLc = parcelRequire("k8MLc");
    var $eqXBf = parcelRequire("eqXBf");
    var $kBUUu = parcelRequire("kBUUu");
    var $8d59cfe3586d6695$var$PLACEHOLDER = '__lodash_placeholder__';
    var $8d59cfe3586d6695$var$WRAP_BIND_FLAG = 1, $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG = 2, $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG = 4, $8d59cfe3586d6695$var$WRAP_CURRY_FLAG = 8, $8d59cfe3586d6695$var$WRAP_ARY_FLAG = 128, $8d59cfe3586d6695$var$WRAP_REARG_FLAG = 256;
    var $8d59cfe3586d6695$var$nativeMin = Math.min;
    function $8d59cfe3586d6695$var$mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($8d59cfe3586d6695$var$WRAP_BIND_FLAG | $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG | $8d59cfe3586d6695$var$WRAP_ARY_FLAG);
        var isCombo = srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG || srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($8d59cfe3586d6695$var$WRAP_ARY_FLAG | $8d59cfe3586d6695$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) return data;
        if (srcBitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG ? 0 : $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
            var partials = data[3];
            data[3] = partials ? $k8MLc(partials, value, source[4]) : value;
            data[4] = partials ? $kBUUu(data[3], $8d59cfe3586d6695$var$PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
            partials = data[5];
            data[5] = partials ? $eqXBf(partials, value, source[6]) : value;
            data[6] = partials ? $kBUUu(data[5], $8d59cfe3586d6695$var$PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) data[7] = value;
        if (srcBitmask & $8d59cfe3586d6695$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $8d59cfe3586d6695$var$nativeMin(data[8], source[8]);
        if (data[9] == null) data[9] = source[9];
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
    }
    module.exports = $8d59cfe3586d6695$var$mergeData;
});
parcelRegister("91VA7", function(module, exports) {
    var $7MmCC = parcelRequire("7MmCC");
    var $6930df867851495d$var$CLONE_SYMBOLS_FLAG = 4;
    function $6930df867851495d$var$clone(value) {
        return $7MmCC(value, $6930df867851495d$var$CLONE_SYMBOLS_FLAG);
    }
    module.exports = $6930df867851495d$var$clone;
});
parcelRegister("a7NzZ", function(module, exports) {
    var $5oTQF = parcelRequire("5oTQF");
    var $75f10447dad5f8f2$var$WRAP_CURRY_FLAG = 8;
    function $75f10447dad5f8f2$var$curry(func, arity, guard) {
        arity = guard ? undefined : arity;
        var result = $5oTQF(func, $75f10447dad5f8f2$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = $75f10447dad5f8f2$var$curry.placeholder;
        return result;
    }
    $75f10447dad5f8f2$var$curry.placeholder = {};
    module.exports = $75f10447dad5f8f2$var$curry;
});
parcelRegister("aZFhV", function(module, exports) {
    var $beQoo = parcelRequire("beQoo");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $1QOns = parcelRequire("1QOns");
    var $800fa0dabdb52684$var$domExcTag = '[object DOMException]', $800fa0dabdb52684$var$errorTag = '[object Error]';
    function $800fa0dabdb52684$var$isError(value) {
        if (!$fC1Kz(value)) return false;
        var tag = $beQoo(value);
        return tag == $800fa0dabdb52684$var$errorTag || tag == $800fa0dabdb52684$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$1QOns(value);
    }
    module.exports = $800fa0dabdb52684$var$isError;
});
parcelRegister("5UxIS", function(module, exports) {
    var $jtBGw = parcelRequire("jtBGw");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $44dc5758474a5c9f$var$weakMapTag = '[object WeakMap]';
    function $44dc5758474a5c9f$var$isWeakMap(value) {
        return $fC1Kz(value) && $jtBGw(value) == $44dc5758474a5c9f$var$weakMapTag;
    }
    module.exports = $44dc5758474a5c9f$var$isWeakMap;
});
parcelRegister("5qDt4", function(module, exports) {
    var $7MmCC = parcelRequire("7MmCC");
    var $bxDef = parcelRequire("bxDef");
    var $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG = 1;
    function $3f3dfefad45dde4d$var$iteratee(func) {
        return $bxDef(typeof func == 'function' ? func : $7MmCC(func, $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG));
    }
    module.exports = $3f3dfefad45dde4d$var$iteratee;
});
parcelRegister("iZlmO", function(module, exports) {
    var $5oTQF = parcelRequire("5oTQF");
    var $9SRAA = parcelRequire("9SRAA");
    var $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG = 256;
    var $dd2e7f874e5ccea3$var$rearg = $9SRAA(function(func, indexes) {
        return $5oTQF(func, $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });
    module.exports = $dd2e7f874e5ccea3$var$rearg;
});
parcelRegister("6TYHJ", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $jHlUS = parcelRequire("jHlUS");
    var $8LQ84 = parcelRequire("8LQ84");
    var $4faK3 = parcelRequire("4faK3");
    var $h5JBK = parcelRequire("h5JBK");
    var $gzebZ = parcelRequire("gzebZ");
    var $jJVtR = parcelRequire("jJVtR");
    function $5066f7c1bc1a55ec$var$toPath(value) {
        if ($8LQ84(value)) return $1nIHN(value, $gzebZ);
        return $4faK3(value) ? [
            value
        ] : $jHlUS($h5JBK($jJVtR(value)));
    }
    module.exports = $5066f7c1bc1a55ec$var$toPath;
});
parcelRegister("iASWI", function(module, exports) {
    var $irTmi = parcelRequire("irTmi");
    var $d89635f071f7433a$var$range = $irTmi();
    module.exports = $d89635f071f7433a$var$range;
});
parcelRegister("irTmi", function(module, exports) {
    var $7DMj9 = parcelRequire("7DMj9");
    var $4rDUz = parcelRequire("4rDUz");
    var $kJ0Lf = parcelRequire("kJ0Lf");
    function $d6e5b0af0cc26ead$var$createRange(fromRight) {
        return function(start, end, step) {
            if (step && typeof step != 'number' && $4rDUz(start, end, step)) end = step = undefined;
            start = $kJ0Lf(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = $kJ0Lf(end);
            step = step === undefined ? start < end ? 1 : -1 : $kJ0Lf(step);
            return $7DMj9(start, end, step, fromRight);
        };
    }
    module.exports = $d6e5b0af0cc26ead$var$createRange;
});
parcelRegister("7DMj9", function(module, exports) {
    var $5901a5dd7694a169$var$nativeCeil = Math.ceil, $5901a5dd7694a169$var$nativeMax = Math.max;
    function $5901a5dd7694a169$var$baseRange(start, end, step, fromRight) {
        var index = -1, length = $5901a5dd7694a169$var$nativeMax($5901a5dd7694a169$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
        while(length--){
            result[fromRight ? length : ++index] = start;
            start += step;
        }
        return result;
    }
    module.exports = $5901a5dd7694a169$var$baseRange;
});
parcelRegister("4zcxJ", function(module, exports) {
    $parcel$export(module.exports, "useExpandableEntryPointTrigger", ()=>$a613456b7f090bbf$export$569294f6ae10bba9);
    var $5uXOq = parcelRequire("5uXOq");
    var $47gW9;
    const $a613456b7f090bbf$export$569294f6ae10bba9 = (actions, isActive = true)=>{
        const eventMap = (0, $5uXOq.useMemo)(()=>Object.fromEntries(Object.entries((0, (0, parcelRequire("47gW9")).getDefaultEntrypointActionEventMap)(actions)).filter(([key])=>key !== 'click')), [
            actions
        ]);
        return (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(actions, isActive, eventMap);
    };
});
parcelRegister("47gW9", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointButtonTrigger", ()=>$1be876415a945060$export$25d2524a63315ed);
    $parcel$export(module.exports, "getDefaultEntrypointActionEventMap", ()=>$1be876415a945060$export$5f13515bd3a35325);
    var $5uXOq = parcelRequire("5uXOq");
    var $iRKpN;
    const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap = $1be876415a945060$export$5f13515bd3a35325(actions))=>{
        const removePreviousListeners = (0, $5uXOq.useRef)(null);
        const isMounted = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>()=>{
                removePreviousListeners.current?.();
                removePreviousListeners.current = null;
                isMounted.current = false;
            }, []);
        return (0, $5uXOq.useCallback)((element)=>{
            if (!isMounted.current) return;
            removePreviousListeners.current?.();
            if (element && isActive) {
                (0, (0, parcelRequire("iRKpN")).modifyListeners)({
                    element: element,
                    operationName: 'add',
                    eventMap: eventMap
                });
                removePreviousListeners.current = ()=>{
                    (0, (0, parcelRequire("iRKpN")).modifyListeners)({
                        element: element,
                        operationName: 'remove',
                        eventMap: eventMap
                    });
                };
            } else removePreviousListeners.current = null;
        }, [
            eventMap,
            isActive
        ]);
    };
    const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
            click: actions.load,
            mouseenter: actions.preload,
            mouseleave: actions.cancelPreload,
            focusin: actions.preload,
            focusout: actions.cancelPreload
        });
});
parcelRegister("iRKpN", function(module, exports) {
    $parcel$export(module.exports, "modifyListeners", ()=>$62bae43418420b8a$export$15257a36a7e3f9d6);
    function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
        const { element: element, operationName: operationName, eventMap: eventMap } = params;
        const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
        if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
    }
});
parcelRegister("7Y7Js", function(module, exports) {
    $parcel$export(module.exports, "ExploreMoreApps", ()=>$f69daa56854375f6$export$e3e10d2adcb07330);
    var $5uXOq = parcelRequire("5uXOq");
    var $1ZDWg;
    var $ivGSs;
    var $jhS4y;
    var $5FnJJ;
    var $24a2m;
    var $8zOmE;
    var $2NMNM;
    var $jGx9e;
    const $f69daa56854375f6$var$pathToNavigate = '/jira/marketplace/discover';
    function $f69daa56854375f6$export$e3e10d2adcb07330() {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("jGx9e")).default).exploreMoreApps, (0, ($parcel$interopDefault((0, parcelRequire("1ZDWg"))))));
        const onClick = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_APPS],
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    itemId: 'exploreMoreApps'
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            elemBefore: icon,
            href: $f69daa56854375f6$var$pathToNavigate,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_APP_MARKETPLACE_DISCOVER),
            onClick: onClick
        }, formattedMessage);
    }
});
parcelRegister("jGx9e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1d28052ecc552f9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c1d28052ecc552f9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        exploreMoreApps: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.explore-more-apps.explore-more-apps",
            "defaultMessage": "Explore more apps"
        }
    });
});
parcelRegister("lnznH", function(module, exports) {
    $parcel$export(module.exports, "ExpandableMenuItemContent", ()=>$989ef304f4c01dfd$export$bd680a81504a92e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $DEWI6;
    var $hEtBs;
    var $et13M;
    const $989ef304f4c01dfd$var$styles = {
        content: "_bozg1crf",
        collapsedContent: "_1e0cglyw"
    };
    const $989ef304f4c01dfd$export$bd680a81504a92e9 = (0, $5uXOq.forwardRef)(({ children: children }, forwardedRef)=>{
        const isExpanded = (0, (0, parcelRequire("et13M")).useIsExpanded)();
        const level = (0, (0, parcelRequire("et13M")).useLevel)();
        const hasExpanded = (0, $5uXOq.useRef)(false);
        if (!isExpanded && !hasExpanded.current) return null;
        hasExpanded.current = true;
        return $5uXOq.createElement((0, (0, parcelRequire("et13M")).LevelContext).Provider, {
            value: level + 1
        }, $5uXOq.createElement((0, (0, parcelRequire("hEtBs")).List), {
            ref: forwardedRef,
            xcss: (0, (0, parcelRequire("DEWI6")).cx)($989ef304f4c01dfd$var$styles.content, !isExpanded && $989ef304f4c01dfd$var$styles.collapsedContent)
        }, children));
    });
});
parcelRegister("cZa9B", function(module, exports) {
    $parcel$export(module.exports, "ExpandableMenuItemTrigger", ()=>$299b2713b0d220a7$export$fe6fe51056867f4d);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $hORKG;
    var $3dGN0;
    var $dC5iT;
    var $fdP8o;
    var $et13M;
    const $299b2713b0d220a7$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isHovering: isHovering, isSelected: isSelected, defaultStateElem: defaultStateElem })=>{
        const isChildSelected = (0, (0, parcelRequire("et13M")).useIsChildSelected)();
        const ChevronIcon = isExpanded ? (0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))) : (0, ($parcel$interopDefault((0, parcelRequire("3dGN0")))));
        const chevronElem = (0, ($parcel$interopDefault($5uXOq))).createElement(ChevronIcon, {
            ...iconProps,
            label: "",
            color: isSelected || isChildSelected ? "var(--ds-icon-selected, #0C66E4)" : undefined
        });
        return isHovering ? chevronElem : defaultStateElem ?? chevronElem;
    };
    const $299b2713b0d220a7$export$fe6fe51056867f4d = (0, $5uXOq.forwardRef)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: elemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled }, forwardedRef)=>{
        const onExpansionToggle = (0, (0, parcelRequire("et13M")).useOnExpansionToggle)();
        const isExpanded = (0, (0, parcelRequire("et13M")).useIsExpanded)();
        const setIsExpanded = (0, (0, parcelRequire("et13M")).useSetIsExpanded)();
        const [isHovering, setIsHovering] = (0, $5uXOq.useState)(false);
        const handleMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), []);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovering(false), []);
        const handleIconClick = (0, $5uXOq.useCallback)(()=>{
            onExpansionToggle?.(!isExpanded);
            setIsExpanded(!isExpanded);
        }, [
            isExpanded,
            onExpansionToggle,
            setIsExpanded
        ]);
        const handleMenuContentClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            const newValue = !isExpanded;
            onClick?.(event, analyticsEvent, {
                isExpanded: newValue
            });
            onExpansionToggle?.(newValue);
            setIsExpanded(newValue);
        }, [
            onClick,
            onExpansionToggle,
            isExpanded,
            setIsExpanded
        ]);
        const isSelectable = typeof href !== 'undefined';
        const expandableElemBefore = isSelectable ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            icon: (iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement($299b2713b0d220a7$var$ExpandableMenuItemIcon, {
                    iconProps: iconProps,
                    isHovering: isHovering,
                    isExpanded: isExpanded,
                    isSelected: isSelected,
                    defaultStateElem: elemBefore
                }),
            "aria-expanded": isExpanded,
            label: isExpanded ? 'Collapse' : 'Expand',
            appearance: "subtle",
            spacing: "compact",
            onClick: handleIconClick,
            interactionName: interactionName
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($299b2713b0d220a7$var$ExpandableMenuItemIcon, {
            isHovering: isHovering,
            isExpanded: isExpanded,
            isSelected: isSelected,
            defaultStateElem: elemBefore
        });
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fdP8o")).MenuItemBase), {
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: expandableElemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled
        }, children)));
    });
});
const $13973d4cc5182a50$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Apps';
const $13973d4cc5182a50$export$d57b6b390e78d90f = 'smite';
parcelRegister("6EHtA", function(module, exports) {
    $parcel$export(module.exports, "createAttributes", ()=>$5df5d3b717f9866b$export$c7c9603a6b1fd815);
    var $4R6GH;
    var $fZneA;
    var $j8DrX;
    const $5df5d3b717f9866b$var$isSynthetic = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true' || (0, (0, parcelRequire("4R6GH")).fg)('forge_ui_synthetic_check');
    const $5df5d3b717f9866b$var$FAILED_TO_FETCH = 'FAILED_TO_FETCH';
    const $5df5d3b717f9866b$var$getErrorType = (_error)=>{
        if (_error == null) return 'NULL_OR_UNDEFINED';
        const error = _error;
        const message = String(error instanceof Error ? error.message : error).trim();
        const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
        if (aggGiraServerErrorRegex.test(message)) {
            const match = message.match(aggGiraServerErrorRegex);
            const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
            return `AGG_GIRA_ERROR_${statusCode}`;
        }
        const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
        if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
        if ((0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) return $5df5d3b717f9866b$var$FAILED_TO_FETCH;
        return 'OTHER';
    };
    const $5df5d3b717f9866b$export$78c6267359db7e73 = (error)=>({
            ...error,
            stack: error.stack,
            message: error?.message
        });
    const $5df5d3b717f9866b$export$c7c9603a6b1fd815 = (rawAttributes)=>{
        const attributes = {
            isSynthetic: $5df5d3b717f9866b$var$isSynthetic(),
            isSSR: false
        };
        if (rawAttributes) {
            const { error: error } = rawAttributes;
            if (error) {
                attributes.error = $5df5d3b717f9866b$export$78c6267359db7e73(error);
                attributes.errorType = $5df5d3b717f9866b$var$getErrorType(error);
            }
        }
        return {
            ...rawAttributes,
            ...attributes
        };
    };
});
parcelRegister("g72iU", function(module, exports) {
    $parcel$export(module.exports, "asyncNav4AppsContentViewQuery", ()=>$cda04b3061c529f3$export$3cc582e017e659a5);
    var $2W8ID;
    var $eufEc;
    var $fEDBv;
    const $cda04b3061c529f3$export$3cc582e017e659a5 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("8RkDI")).then(({ Nav4AppsContentViewQuery: Nav4AppsContentViewQuery })=>Nav4AppsContentViewQuery), {
            moduleId: "5e1e3d10",
            moduleName: "Nav4AppsContentViewQuery"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                queries: {
                    apps: {
                        parameters: (0, parcelRequire("2W8ID")).default,
                        variables: {
                            cloudId: cloudId
                        }
                    }
                }
            })
    });
});
parcelRegister("2W8ID", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$997a21b7e3836e4d$export$2e2bcd8739ae039);
    const $997a21b7e3836e4d$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = {
            "kind": "ScalarField",
            "name": "label"
        }, v2 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v3 = {
            "kind": "ScalarField",
            "name": "url"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "Nav4AppsContentViewQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "Nav4AppsContent"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "Nav4AppsContentViewQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraNavigationItemConnection",
                                "kind": "LinkedField",
                                "name": "globalAppNavigationItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraNavigationItemEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v1,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "appId"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "appType"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "envLabel"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "iconUrl"
                                                            },
                                                            v2,
                                                            {
                                                                "concreteType": "JiraAppSection",
                                                                "kind": "LinkedField",
                                                                "name": "sections",
                                                                "plural": true,
                                                                "selections": [
                                                                    v1,
                                                                    {
                                                                        "concreteType": "JiraAppNavigationItemNestedLink",
                                                                        "kind": "LinkedField",
                                                                        "name": "links",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v1,
                                                                            v3,
                                                                            v2
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "settingsUrl"
                                                            },
                                                            v3
                                                        ],
                                                        "type": "JiraAppNavigationItem"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b0598bd12791c820d9fd37010fdcfaa71a2efec5a91d1ad262f20eabce79217d",
                "metadata": {},
                "name": "Nav4AppsContentViewQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $997a21b7e3836e4d$var$node.hash = "157a8cfe104b1d671cc09c5f8aee481a";
    var $997a21b7e3836e4d$export$2e2bcd8739ae039 = $997a21b7e3836e4d$var$node;
});
parcelRegister("8RkDI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("F3QUg").then(()=>parcelRequire('30ibK'));
});
parcelRegister("iJgtS", function(module, exports) {
    $parcel$export(module.exports, "Nav4AppsForLanding", ()=>$e9ee9ccd4f89fb22$export$889c9c34c80104b2);
    var $3iyZg;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jecJ3;
    var $jhS4y;
    var $iszzG;
    var $46Cti;
    var $c16H2;
    var $dQbFB;
    var $dUyqZ;
    var $gpcgC;
    var $7Y7Js;
    var $8zOmE;
    var $2NMNM;
    var $l8ruj;
    var $lnznH;
    var $cZa9B;
    function $e9ee9ccd4f89fb22$export$889c9c34c80104b2(props) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iszzG")).NavItemsContext));
        const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS);
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("3iyZg")).default), queryRef);
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_APPS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: menuId,
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) {
                    const event = createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
                    });
                    const isInMore = moreMenuIds.includes((0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS);
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_APPS), {
                        isInMore: isInMore
                    });
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-apps-landing"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gpcgC")).Nav4AppsContent), {
            queryRef: data
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Y7Js")).ExploreMoreApps), null))));
    }
});
parcelRegister("3iyZg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf7940716f9101a5$export$2e2bcd8739ae039);
    const $bf7940716f9101a5$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4AppsForLanding",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "Nav4AppsContent"
            }
        ],
        "type": "JiraQuery"
    };
    $bf7940716f9101a5$var$node.hash = "9c28cb4a0c92a920a58010f91f4f4f0e";
    var $bf7940716f9101a5$export$2e2bcd8739ae039 = $bf7940716f9101a5$var$node;
});
parcelRegister("gpcgC", function(module, exports) {
    $parcel$export(module.exports, "Nav4AppsContent", ()=>$23e70e20d1d66b25$export$aaf45d195a81792d);
    var $67Dt2;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $1rTGO;
    var $3wOYX;
    var $k2DRb;
    var $koVbs;
    var $lmyls;
    var $i2fHy;
    var $8MAOw;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    var $2CQvU;
    var $hDULT;
    function $23e70e20d1d66b25$export$aaf45d195a81792d({ queryRef: queryRef }) {
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("67Dt2")).default), queryRef);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const menuItemNodes = (0, $5uXOq.useMemo)(()=>(data?.globalAppNavigationItems?.edges || []).filter((edge)=>{
                if (edge?.node?.appType !== 'CONNECT' && edge?.node?.appType !== 'FORGE') return false;
                return edge?.node?.appId !== (0, (0, parcelRequire("lmyls")).ADDON_ID).DISCOVER;
            }).map((edge)=>edge?.node).sort((a, b)=>(a?.label || '').localeCompare(b?.label || '')) || [], [
            data?.globalAppNavigationItems
        ]);
        const renderedMenuItems = (0, $5uXOq.useMemo)(()=>menuItemNodes.map((node)=>{
                switch(node?.appType){
                    case 'CONNECT':
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i2fHy")).Nav4ConnectMenuItem), {
                            key: node.id,
                            queryRef: node
                        });
                    case 'FORGE':
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8MAOw")).Nav4ForgeMenuItem), {
                            key: node.id,
                            queryRef: node
                        });
                    default:
                        return null;
                }
            }).filter(Boolean), [
            menuItemNodes
        ]);
        const hasForgeApps = (0, $5uXOq.useMemo)(()=>menuItemNodes.some((node)=>node?.appType === 'FORGE'), [
            menuItemNodes
        ]);
        return renderedMenuItems.length ? (0, ($parcel$interopDefault($5uXOq))).createElement($23e70e20d1d66b25$var$ForgeAnalyticsWrapper, {
            shouldReport: hasForgeApps
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CQvU")).MenuSectionHeading), null, formatMessage((0, (0, parcelRequire("hDULT")).default).yourApps)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, renderedMenuItems, hasForgeApps && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeScreenEvent), {
            attributes: {
                moduleType: (0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE)
            }
        }))))) : null;
    }
    function $23e70e20d1d66b25$var$ForgeAnalyticsWrapper({ shouldReport: shouldReport, children: children }) {
        return shouldReport ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wOYX")).TriggerAnalyticsWrapper), null, children) : children;
    }
});
parcelRegister("67Dt2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1c56b3bd1de4f5e$export$2e2bcd8739ae039);
    const $c1c56b3bd1de4f5e$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4AppsContent",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "JiraNavigationItemConnection",
                "kind": "LinkedField",
                "name": "globalAppNavigationItems",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraNavigationItemEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                "action": "THROW",
                                                "path": "globalAppNavigationItems.edges.node.id"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "label"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "appId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "appType"
                                                    }
                                                ],
                                                "type": "JiraAppNavigationItem"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "Nav4ConnectMenuItem"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "Nav4ForgeMenuItem"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "globalAppNavigationItems.edges.node"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "globalAppNavigationItems.edges"
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
    $c1c56b3bd1de4f5e$var$node.hash = "3c5415b490d1a4d80771e29fa9391a72";
    var $c1c56b3bd1de4f5e$export$2e2bcd8739ae039 = $c1c56b3bd1de4f5e$var$node;
});
parcelRegister("3wOYX", function(module, exports) {
    $parcel$export(module.exports, "ViewAnalyticsWrapper", ()=>$5b5e8901ec23bf19$export$c794eb4124961145);
    $parcel$export(module.exports, "TriggerAnalyticsWrapper", ()=>$5b5e8901ec23bf19$export$e1a79e3d472c925a);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2DRb;
    var $1rTGO;
    var $hBuqR;
    const $5b5e8901ec23bf19$export$c794eb4124961145 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE),
            shouldFireInitializedEvent: true,
            ...props
        });
    const $5b5e8901ec23bf19$export$e1a79e3d472c925a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE),
            moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER),
            ...props
        });
});
parcelRegister("i2fHy", function(module, exports) {
    $parcel$export(module.exports, "Nav4ConnectMenuItem", ()=>$ee90bbc4e1163598$export$d311b4cb0fdc0b92);
    var $4Oh0F;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jjUR3;
    var $hrlU6;
    var $46ae2;
    var $fmg3f;
    function $ee90bbc4e1163598$export$d311b4cb0fdc0b92({ queryRef: queryRef }) {
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("4Oh0F")).default), queryRef);
        const { addNew: addNew } = (0, (0, parcelRequire("jjUR3")).useConnectItemClickHistory)();
        const onClick = (0, $5uXOq.useCallback)((e, target, styleClass, url)=>{
            if (url == null) return;
            addNew(url);
            if (target == null) return;
            (0, (0, parcelRequire("hrlU6")).withConnectHost)((connectHost)=>{
                connectHost.triggerWebItem(target, styleClass, url);
            });
            if ((0, (0, parcelRequire("hrlU6")).isConnectDialogWebItem)(styleClass)) e.preventDefault();
        }, [
            addNew
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("46ae2")).Nav4AppMenuItem), {
            queryRef: data,
            onData: $ee90bbc4e1163598$var$transformData,
            onClick: onClick
        });
    }
    function $ee90bbc4e1163598$var$transformData(data) {
        return (0, (0, parcelRequire("fmg3f")).canHaveSubpages)(data) ? data : {
            ...data,
            sections: null
        };
    }
});
parcelRegister("4Oh0F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6486cfe515f60293$export$2e2bcd8739ae039);
    const $6486cfe515f60293$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4ConnectMenuItem",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "Nav4AppMenuItem"
            }
        ],
        "type": "JiraAppNavigationItem"
    };
    $6486cfe515f60293$var$node.hash = "76baf08d707245f4a5aadd384fd44056";
    var $6486cfe515f60293$export$2e2bcd8739ae039 = $6486cfe515f60293$var$node;
});
parcelRegister("46ae2", function(module, exports) {
    $parcel$export(module.exports, "Nav4AppMenuItem", ()=>$0602058127748c94$export$549160040f86c542);
    var $jX06n;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $ivGSs;
    var $jhS4y;
    var $lhMtU;
    var $c16H2;
    var $5FnJJ;
    var $dQbFB;
    var $fLtNy;
    var $5QCWL;
    var $9Ft6m;
    var $8zOmE;
    var $2NMNM;
    var $aAbfD;
    var $lnznH;
    var $cZa9B;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    function $0602058127748c94$export$549160040f86c542({ queryRef: queryRef, onData: onData, onClick: onClick }) {
        const rawData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("jX06n")).default), queryRef);
        const data = (0, $5uXOq.useMemo)(()=>onData ? onData($0602058127748c94$var$normalizeData(rawData)) : $0602058127748c94$var$normalizeData(rawData), [
            onData,
            rawData
        ]);
        const icon = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5QCWL")).AppIcon), {
                iconUrl: data.iconUrl || ''
            }), [
            data.iconUrl
        ]);
        const withSeparators = (0, $5uXOq.useMemo)(()=>$0602058127748c94$var$shouldUseSeparators(data), [
            data
        ]);
        const envLozenge = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ft6m")).EnvLozenge), {
                label: data.envLabel || ''
            }), [
            data.envLabel
        ]);
        const actionsOnHover = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fLtNy")).AppActions), {
                settingsUrl: data.settingsUrl || '',
                appId: data.appId || ''
            }), [
            data.settingsUrl,
            data.appId
        ]);
        const expandable = (0, $5uXOq.useMemo)(()=>{
            if ((data.sections || []).length === 0) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($0602058127748c94$var$MaybeExpandable, {
                actionsOnHover: actionsOnHover,
                appId: data.appId || '',
                envLozenge: envLozenge,
                icon: icon,
                label: data.label || 'Unknown app',
                menuIds: $0602058127748c94$var$toExpandableMenuId(data.sections),
                itemId: data.appId || '',
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf)
            }, (data.sections || []).map((section, sectionIndex)=>(section?.links || []).length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), {
                    key: `${sectionIndex}-${section?.label}`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, withSeparators && sectionIndex > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aAbfD")).Divider), null) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, (0, ($parcel$interopDefault($5uXOq))).createElement($0602058127748c94$var$MaybeExpandable, {
                    appId: data.appId || '',
                    label: section?.label || '',
                    menuIds: $0602058127748c94$var$toExpandableMenuId([
                        {
                            links: section?.links
                        }
                    ]),
                    itemId: `section/${sectionIndex}`,
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
                }, (section?.links || []).map((link, linkIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement($0602058127748c94$var$SimpleItem, {
                        appId: data.appId || '',
                        key: link?.url || '',
                        label: link?.label || '',
                        onClick: onClick,
                        styleClass: link?.styleClass || '',
                        url: link?.url == null ? null : $0602058127748c94$var$removeTrailingSlash(link?.url),
                        itemId: `section/${sectionIndex}/link/${linkIndex}`,
                        level: section?.label ? (0, $951a0ed422513987$export$f9db6a58b4aabd18) : (0, $951a0ed422513987$export$fe3b012b0224e4e1)
                    })))))) : null));
        }, [
            data.sections,
            data.label,
            data.appId,
            icon,
            envLozenge,
            actionsOnHover,
            withSeparators,
            onClick
        ]);
        if (expandable) return expandable;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0602058127748c94$var$SimpleItem, {
            actionsOnHover: actionsOnHover,
            appId: data.appId || '',
            envLozenge: envLozenge,
            icon: icon,
            label: data.label || 'Unknown app',
            onClick: onClick,
            styleClass: data.styleClass || '',
            url: data.url == null ? null : $0602058127748c94$var$removeTrailingSlash(data.url || ''),
            itemId: data.appId || '',
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf)
        });
    }
    function $0602058127748c94$var$SimpleItem({ actionsOnHover: actionsOnHover, appId: appId, envLozenge: envLozenge, icon: icon, label: label, onClick: onClick, styleClass: styleClass, url: url, itemId: itemId, level: level }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const anchorElement = (0, $5uXOq.useRef)(null);
        const onItemClick = (0, $5uXOq.useCallback)((e)=>{
            $0602058127748c94$var$fireAppClickEvent({
                event: createAnalyticsEvent({}),
                itemId: itemId,
                appId: appId,
                level: level
            });
            onClick?.(e, anchorElement.current, styleClass || '', url);
        }, [
            url,
            onClick,
            itemId,
            appId,
            level,
            styleClass,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            href: $0602058127748c94$var$removeTrailingSlash(url ?? ''),
            elemBefore: icon,
            elemAfter: envLozenge,
            actionsOnHover: actionsOnHover,
            menuId: $0602058127748c94$var$toMenuItemMenuId(url ?? ''),
            ref: anchorElement,
            onClick: onItemClick
        }, label);
    }
    function $0602058127748c94$var$MaybeExpandable(params) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { actionsOnHover: actionsOnHover, children: children, envLozenge: envLozenge, icon: icon, label: label, menuIds: menuIds, itemId: itemId, appId: appId, level: level } = params;
        const menuId = (0, (0, parcelRequire("lhMtU")).toMenuIdFromMenuIdList)(menuIds);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            $0602058127748c94$var$fireAppClickEvent({
                event: createAnalyticsEvent({}),
                itemId: itemId,
                appId: appId,
                level: level,
                isExpandable: true
            });
        }, [
            createAnalyticsEvent,
            itemId,
            appId,
            level
        ]);
        return label ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            menuId: menuId,
            isExpanded: level !== (0, $951a0ed422513987$export$265c523d1a8f25cf),
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) onClick();
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            actionsOnHover: actionsOnHover,
            elemBefore: icon,
            elemAfter: envLozenge,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, label), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, children)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    }
    function $0602058127748c94$var$fireAppClickEvent(params) {
        const { event: event, itemId: itemId, appId: appId, level: level, isExpandable: isExpandable } = params;
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_APPS],
            attributes: {
                level: level,
                componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                itemId: itemId,
                isExpandable: isExpandable,
                section: 'yourApps',
                ...level === (0, $951a0ed422513987$export$265c523d1a8f25cf) ? {
                    itemType: (0, $632bd8725b437a12$export$c3d83ca6855fa0d0)
                } : {
                    itemType: (0, $632bd8725b437a12$export$509e83d3c8d91279),
                    parentItemId: appId,
                    parentItemType: (0, $632bd8725b437a12$export$c3d83ca6855fa0d0)
                }
            }
        });
    }
    function $0602058127748c94$var$shouldUseSeparators(data) {
        for (const section of data.sections || []){
            if (section?.label) return false;
        }
        return true;
    }
    function $0602058127748c94$var$normalizeData(data) {
        return {
            ...data,
            sections: (data.sections || []).filter((section)=>(section?.links || []).length > 0)
        };
    }
    const $0602058127748c94$var$removeTrailingSlash = (url = '')=>url.replace(/\/$/, '');
    const $0602058127748c94$var$removeQueryParams = (url)=>url.split('?')[0];
    const $0602058127748c94$var$toMenuItemMenuId = (url = '')=>(0, (0, parcelRequire("jhS4y")).ENTITY_ID).APP($0602058127748c94$var$removeTrailingSlash($0602058127748c94$var$removeQueryParams(url)));
    const $0602058127748c94$var$toExpandableMenuId = (sections)=>(sections || []).flatMap(({ links: links })=>(links || []).map((link)=>$0602058127748c94$var$toMenuItemMenuId(link.url)));
});
parcelRegister("jX06n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af6546e449d47625$export$2e2bcd8739ae039);
    const $af6546e449d47625$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "label"
        }, v1 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v2 = {
            "kind": "ScalarField",
            "name": "url"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "Nav4AppMenuItem",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "envLabel"
                },
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                },
                v0,
                v1,
                {
                    "concreteType": "JiraAppSection",
                    "kind": "LinkedField",
                    "name": "sections",
                    "plural": true,
                    "selections": [
                        v0,
                        {
                            "concreteType": "JiraAppNavigationItemNestedLink",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": true,
                            "selections": [
                                v0,
                                v2,
                                v1
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "settingsUrl"
                },
                v2
            ],
            "type": "JiraAppNavigationItem"
        };
    }();
    $af6546e449d47625$var$node.hash = "fe622bd16e14b11ec5e3f21d8553bac3";
    var $af6546e449d47625$export$2e2bcd8739ae039 = $af6546e449d47625$var$node;
});
const $632bd8725b437a12$export$9b8283d5878d2491 = 'board';
const $632bd8725b437a12$export$c3d83ca6855fa0d0 = 'app';
const $632bd8725b437a12$export$c1c49903035a02df = 'filter';
const $632bd8725b437a12$export$6deee0e4f2fb784e = 'defaultFilter';
const $632bd8725b437a12$export$4695c1a423ffe431 = 'dashboard';
const $632bd8725b437a12$export$5828682c822c26e7 = 'queue';
const $632bd8725b437a12$export$fe791c4fa892e400 = 'project';
const $632bd8725b437a12$export$c303e491e026ebc6 = 'plan';
const $632bd8725b437a12$export$509e83d3c8d91279 = 'appSubpage';
const $632bd8725b437a12$export$a2e7d1d0a3d169f4 = 'asset';
const $632bd8725b437a12$export$b56168d831461ce2 = 'operation';
const $632bd8725b437a12$export$499a3e77858b7713 = 'translationGroup';
const $632bd8725b437a12$export$bb8a37ab8d9ba82b = 'roadmap';
const $632bd8725b437a12$export$9a778ca616c24a93 = 'projectRecommendation';
const $632bd8725b437a12$export$9cbb0f231a0ab7ea = 'overview';
parcelRegister("fLtNy", function(module, exports) {
    $parcel$export(module.exports, "AppActions", ()=>$c30e381fa79c5849$export$6b031ef628e5f9c2);
    var $5uXOq = parcelRequire("5uXOq");
    var $epOG5;
    var $3Z96c;
    var $9UCCQ;
    var $koVbs;
    var $ivGSs;
    var $jhS4y;
    var $aCS3f;
    var $8zOmE;
    var $2NMNM;
    var $cSaAc;
    function $c30e381fa79c5849$export$6b031ef628e5f9c2({ settingsUrl: settingsUrl, appId: appId, onClose: onClose }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireOpenEvent = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_APPS],
                attributes: {
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
                    itemId: 'meatballDropdown',
                    section: 'yourApps'
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        const fireClickEvent = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_APPS],
                attributes: {
                    level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                    componentType: (0, $1e554a683893bd46$export$5374c2c2d3ece55e),
                    parentItemId: appId,
                    parentItemType: (0, $632bd8725b437a12$export$c3d83ca6855fa0d0),
                    itemId: 'appSettings',
                    section: 'yourApps'
                }
            });
        }, [
            createAnalyticsEvent,
            appId
        ]);
        if (!settingsUrl) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            MenuItems: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("epOG5"))))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                    href: settingsUrl,
                    target: "_blank",
                    onClick: (...args)=>{
                        fireClickEvent();
                        props.onClose?.(...args);
                    }
                }, formatMessage((0, (0, parcelRequire("cSaAc")).default).appSettings))),
            onOpen: fireOpenEvent,
            onClose: onClose
        });
    }
});
parcelRegister("cSaAc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9feae85879e795be$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9feae85879e795be$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        appSettings: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.app-actions.app-settings",
            "defaultMessage": "App settings"
        }
    });
});
parcelRegister("5QCWL", function(module, exports) {
    $parcel$export(module.exports, "AppIcon", ()=>$1ef09001d2a6006a$export$5153830bdfb71453);
    var $5uXOq = parcelRequire("5uXOq");
    var $hRf4g;
    var $k4j3t;
    function $1ef09001d2a6006a$export$5153830bdfb71453({ iconUrl: iconUrl }) {
        return iconUrl.trim().length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k4j3t")).IconCustom), {
            url: iconUrl
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hRf4g"))))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        });
    }
});
parcelRegister("k4j3t", function(module, exports) {
    $parcel$export(module.exports, "IconCustom", ()=>$0744fb0e35ced980$export$5b6504ec6adf0047);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $ljMUk;
    const $0744fb0e35ced980$var$colorMatrixValues = '0.08, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 0, 0,0.2, 0, 0, 0, 0, 0, 1, 0';
    const $0744fb0e35ced980$export$5b6504ec6adf0047 = ({ url: url, shouldChangeFillColor: shouldChangeFillColor = true, ariaLabelledBy: ariaLabelledBy })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0744fb0e35ced980$var$styles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            viewBox: "0 0 20 20"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("filter", {
            id: "changeFillColor"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
            type: "matrix",
            values: $0744fb0e35ced980$var$colorMatrixValues
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("image", {
            xmlnsXlink: "http://www.w3.org/1999/xlink",
            xlinkHref: url,
            width: "20",
            height: "20",
            x: "0",
            y: "0",
            filter: shouldChangeFillColor && (0, (0, parcelRequire("ljMUk")).checkForSvg)(url) ? 'url(#changeFillColor)' : '',
            "aria-labelledby": ariaLabelledBy
        })));
    };
    const $0744fb0e35ced980$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-block',
        margin: 'space.025',
        height: "var(--ds-space-250, 20px)",
        width: "var(--ds-space-250, 20px)"
    });
});
parcelRegister("ljMUk", function(module, exports) {
    $parcel$export(module.exports, "checkForSvg", ()=>$c203648fb17df2d9$export$9a369805b0fabb72);
    const $c203648fb17df2d9$export$9a369805b0fabb72 = (url)=>{
        const fileType = url.split(/#|\?/)[0].split('.').pop();
        return fileType ? fileType.trim() === 'svg' : false;
    };
});
parcelRegister("9Ft6m", function(module, exports) {
    $parcel$export(module.exports, "EnvLozenge", ()=>$5f161ee51f6727e1$export$61c90f482f9775c6);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    function $5f161ee51f6727e1$export$61c90f482f9775c6({ label: label }) {
        return label ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: label === 'Dev' ? 'default' : 'moved'
        }, label) : null;
    }
});
parcelRegister("aAbfD", function(module, exports) {
    $parcel$export(module.exports, "Divider", ()=>$f1ca0f480f6cde16$export$2e0a83ec2e27ecbb);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $f1ca0f480f6cde16$var$styles = null;
    const $f1ca0f480f6cde16$export$2e0a83ec2e27ecbb = ()=>$5uXOq.createElement("hr", {
            role: "none",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _h7alglyw _179rglyw _mqm2zgxb"
            ])
        });
});
parcelRegister("1FdfO", function(module, exports) {
    $parcel$export(module.exports, "MenuSection", ()=>$7bc49b2ac035272f$export$4b1545b4f2016d26);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $1qQhw;
    var $bXf7n;
    const $7bc49b2ac035272f$export$4b1545b4f2016d26 = ({ children: children, isMenuListItem: isMenuListItem = false })=>{
        const id = (0, (0, parcelRequire("9KnKW")).useId)();
        const Wrapper = isMenuListItem ? (0, (0, parcelRequire("1qQhw")).MenuListItem) : (0, $5uXOq.Fragment);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bXf7n")).MenuSectionContext).Provider, {
            value: id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "group",
            "aria-labelledby": `${id}-heading`
        }, children)));
    };
});
parcelRegister("bXf7n", function(module, exports) {
    $parcel$export(module.exports, "MenuSectionContext", ()=>$1c4053efb9c0d283$export$728ac99b9c7eea8a);
    $parcel$export(module.exports, "useMenuSectionContext", ()=>$1c4053efb9c0d283$export$8100cda602411810);
    var $5uXOq = parcelRequire("5uXOq");
    var $3joPi = parcelRequire("3joPi");
    const $1c4053efb9c0d283$export$728ac99b9c7eea8a = (0, $5uXOq.createContext)(null);
    const $1c4053efb9c0d283$export$8100cda602411810 = ()=>{
        const context = (0, $5uXOq.useContext)($1c4053efb9c0d283$export$728ac99b9c7eea8a);
        (0, $3joPi.default)(context, 'useMenuSectionContext must be used within a MenuSection');
        return context;
    };
});
parcelRegister("fmg3f", function(module, exports) {
    $parcel$export(module.exports, "canHaveSubpages", ()=>$9085d7a7b2e046cd$export$352a285d5cb56873);
    var $ajpes = parcelRequire("ajpes");
    const $9085d7a7b2e046cd$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
    const $9085d7a7b2e046cd$var$isSameQuery = (locationQuery, itemQuery)=>(0, ($parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, ($parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
    const $9085d7a7b2e046cd$var$parseUrl = (url = '')=>{
        const [pathname, qs = ''] = url.split('#')[0].split('?');
        return {
            pathname: pathname,
            query: $9085d7a7b2e046cd$var$splitRelevantQs(qs)
        };
    };
    function $9085d7a7b2e046cd$export$352a285d5cb56873(data) {
        const sections = data.sections || [];
        const { pathname: rootPagePathname, query: rootPageQuery } = $9085d7a7b2e046cd$var$parseUrl(data.url || '');
        for (const section of sections){
            if ((section?.links || []).some((link)=>{
                const { pathname: pathname, query: query } = $9085d7a7b2e046cd$var$parseUrl(link?.url || '');
                return rootPagePathname === pathname && $9085d7a7b2e046cd$var$isSameQuery(rootPageQuery, query);
            })) return true;
        }
        return false;
    }
});
parcelRegister("8MAOw", function(module, exports) {
    $parcel$export(module.exports, "Nav4ForgeMenuItem", ()=>$a309e8f531726635$export$9d5c2149f38ae387);
    var $4QYEU;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $8kVg1;
    var $46ae2;
    function $a309e8f531726635$export$9d5c2149f38ae387({ queryRef: queryRef }) {
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("4QYEU")).default), queryRef);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(data.appId || '').start({
                startTime: performance.now()
            });
        }, [
            data.appId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("46ae2")).Nav4AppMenuItem), {
            queryRef: data,
            onClick: onClick
        });
    }
});
parcelRegister("4QYEU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c19f8830116fdeb$export$2e2bcd8739ae039);
    const $7c19f8830116fdeb$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4ForgeMenuItem",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "appId"
            },
            {
                "kind": "FragmentSpread",
                "name": "Nav4AppMenuItem"
            }
        ],
        "type": "JiraAppNavigationItem"
    };
    $7c19f8830116fdeb$var$node.hash = "44fc7efec94eb8a16f192074436bd021";
    var $7c19f8830116fdeb$export$2e2bcd8739ae039 = $7c19f8830116fdeb$var$node;
});
parcelRegister("2CQvU", function(module, exports) {
    $parcel$export(module.exports, "MenuSectionHeading", ()=>$2dcd93264b8e5f0d$export$5d3acdbf9237a364);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bXf7n;
    const $2dcd93264b8e5f0d$var$styles = {
        root: "_syaz131l _11c816g6 _1rjcu2gc _bozg12x7"
    };
    const $2dcd93264b8e5f0d$export$5d3acdbf9237a364 = ({ children: children })=>{
        const id = (0, (0, parcelRequire("bXf7n")).useMenuSectionContext)();
        return $5uXOq.createElement("h2", {
            id: `${id}-heading`,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $2dcd93264b8e5f0d$var$styles.root
            ])
        }, children);
    };
});
parcelRegister("hDULT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfa76cb9830908a5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cfa76cb9830908a5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        yourApps: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.content.your-apps",
            "defaultMessage": "Your apps"
        }
    });
});
parcelRegister("nX8wH", function(module, exports) {
    $parcel$export(module.exports, "useIsGlobalConnectAppRoute", ()=>$cf4b597ee7e1007d$export$32897ea1251cd6aa);
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $4OCke;
    var $doZTA;
    var $fmg3f;
    const $cf4b597ee7e1007d$export$32897ea1251cd6aa = ({ data: data })=>{
        const [{ location: location, query: query }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const locations = (0, $5uXOq.useMemo)(()=>(data?.globalAppNavigationItems?.edges || []).filter((edge)=>edge?.node?.appType === 'CONNECT').flatMap((edge)=>(edge?.node && (0, (0, parcelRequire("fmg3f")).canHaveSubpages)(edge?.node) && edge?.node?.sections || [
                    {
                        links: [
                            {
                                url: edge?.node?.url
                            }
                        ]
                    }
                ]).flatMap((section)=>(section?.links || []).map((link)=>(0, ($parcel$interopDefault($aZsz6)))(link?.url || '/', true)))), [
            data
        ]);
        return (0, $5uXOq.useMemo)(()=>{
            const matcher = (0, (0, parcelRequire("4OCke")).matchUrlExact)();
            const currentLocation = {
                ...location,
                query: query
            };
            return locations.some((loc)=>matcher(currentLocation, loc));
        }, [
            locations,
            location,
            query
        ]);
    };
});
parcelRegister("bhapp", function(module, exports) {
    $parcel$export(module.exports, "Nav4AppsSpotlightWrapper", ()=>$b4dbfb30b95b8dd8$export$d148eb6657a374a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Bc5A;
    var $cE2Qr;
    var $a4k7n;
    var $heI7y;
    var $fD6iO;
    function $b4dbfb30b95b8dd8$export$d148eb6657a374a({ children: children }) {
        const [{ hasOpened: shouldShowNudge }] = (0, (0, parcelRequire("heI7y")).useHasOpened)();
        const [isUnloaded] = (0, (0, parcelRequire("cE2Qr")).useIsDismissed)();
        const expandSideNav = (0, (0, parcelRequire("fD6iO")).useExpandSideNav)();
        const [openTask] = (0, (0, parcelRequire("cE2Qr")).useOpenTask)();
        const [, { setHasNudgeActive: setHasNudgeActive }] = (0, (0, parcelRequire("cE2Qr")).useQuickstartActions)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isUnloaded && openTask === (0, (0, parcelRequire("8Bc5A")).CAPTURE_INTEGRATIONS_TASK) && shouldShowNudge) {
                expandSideNav();
                setHasNudgeActive(true);
            }
        }, [
            isUnloaded,
            openTask,
            shouldShowNudge,
            setHasNudgeActive,
            expandSideNav
        ]);
        return !false && shouldShowNudge ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a4k7n")).NavigationAppsNavItemWrapperNudgeAsync), null, children) : children;
    }
});
parcelRegister("a4k7n", function(module, exports) {
    $parcel$export(module.exports, "NavigationAppsNavItemWrapperNudgeAsync", ()=>$86c9ba44b2aedf6e$export$c143067f544307f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $kxZPA;
    const $86c9ba44b2aedf6e$var$NavigationAppsNavItemLazy = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("8JMAa")).then((exportedModule)=>exportedModule.NavigationAppsNavItemWrapperNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-apps/index.tsx"
    });
    const $86c9ba44b2aedf6e$export$c143067f544307f = ({ children: children, isInsideMenu: isInsideMenu })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f),
            fallback: children,
            attributes: {
                nudgeId: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "navigation-apps-nav-item-lazy",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($86c9ba44b2aedf6e$var$NavigationAppsNavItemLazy, {
            nudgeId: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f),
            isInsideMenu: isInsideMenu
        }, children)));
});
parcelRegister("8JMAa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1whFq").then(()=>parcelRequire('3Hy6N'));
});
parcelRegister("heI7y", function(module, exports) {
    $parcel$export(module.exports, "useHasOpened", ()=>$c02ba9c4f48115f2$export$cbaabcded53b5c1f);
    var $3sQ5x;
    var $iXqE5;
    var $h97QA;
    const $c02ba9c4f48115f2$var$actions = {
        setHasOpened: (0, parcelRequire("h97QA")).setHasOpened
    };
    const $c02ba9c4f48115f2$var$initialState = {
        hasOpened: false
    };
    const $c02ba9c4f48115f2$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $c02ba9c4f48115f2$var$initialState,
        actions: $c02ba9c4f48115f2$var$actions,
        name: 'jsw-onboarding-quickstart-has-opened'
    });
    const $c02ba9c4f48115f2$export$cbaabcded53b5c1f = (0, (0, parcelRequire("3sQ5x")).createHook)($c02ba9c4f48115f2$var$Store);
});
parcelRegister("h97QA", function(module, exports) {
    $parcel$export(module.exports, "setHasOpened", ()=>$68011af9f70af395$export$c4743c64a7c42294);
    const $68011af9f70af395$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
            const { hasOpened: hasOpened } = getState();
            if (hasOpened === true) return;
            setState({
                hasOpened: true
            });
        };
    var $68011af9f70af395$export$2e2bcd8739ae039 = $68011af9f70af395$export$c4743c64a7c42294;
});
parcelRegister("fD6iO", function(module, exports) {
    $parcel$export(module.exports, "useExpandSideNav", ()=>$d44c9e93ca4d5bd6$export$e44b4744d8ff971a);
    var $5uXOq = parcelRequire("5uXOq");
    var $b0CFU;
    function $d44c9e93ca4d5bd6$export$e44b4744d8ff971a() {
        const setVisibleOnDesktop = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SetSideNavDesktopVisibility));
        const setVisibleOnMobile = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SetSideNavMobileVisibility));
        const expandSideNav = (0, $5uXOq.useCallback)(()=>{
            const { matches: matches } = window.matchMedia('(min-width: 64rem)');
            if (matches) setVisibleOnDesktop(true);
            else setVisibleOnMobile(true);
        }, [
            setVisibleOnDesktop,
            setVisibleOnMobile
        ]);
        return expandSideNav;
    }
});
parcelRegister("67KAW", function(module, exports) {
    $parcel$export(module.exports, "Nav4Assets", ()=>$ddf4be88098c0b0a$export$ae278c7655ee6005);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $7DxXA;
    var $ahEft;
    var $j8qoE;
    var $9OXo1;
    var $kT9FG;
    function $ddf4be88098c0b0a$export$ae278c7655ee6005({ isExpanded: isExpanded }) {
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const _ = (0, (0, parcelRequire("7DxXA")).useInsightVisibility)();
        const isPremiumUser = (0, (0, parcelRequire("ahEft")).isLicensedPremiumUser)(tenantContext);
        const { workspaceId: workspaceId } = (0, (0, parcelRequire("7DxXA")).useWorkspaceContext)();
        if (!isPremiumUser) {
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
                serviceDeskEdition: tenantContext.appEditions?.serviceDesk,
                isSiteAdmin: tenantContext.isSiteAdmin
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kT9FG")).AssetsSingleMenuItem), {
                showUpsellLozenge: true
            });
        }
        return workspaceId ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j8qoE")).InsightGlobalConfigContainer), {
            isGlobal: true,
            workspaceId: workspaceId,
            createAnalyticsEvent: createAnalyticsEvent,
            disableOnInit: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kT9FG")).AssetsMenu), {
            isExpanded: isExpanded
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kT9FG")).AssetsSingleMenuItem), {
            showUpsellLozenge: false
        });
    }
});
parcelRegister("7DxXA", function(module, exports) {
    $parcel$export(module.exports, "useWorkspaceContext", ()=>$5d7c6ac21f7af915$export$827d903316fc333c);
    $parcel$export(module.exports, "useInsightVisibility", ()=>$5d7c6ac21f7af915$export$74ebc9a49f60d38a);
    var $5uXOq = parcelRequire("5uXOq");
    var $ktP1V;
    var $9OXo1;
    var $2YP9W;
    var $ahEft;
    var $gRzZD;
    const $5d7c6ac21f7af915$export$a0002067fa97246a = '/rest/servicedesk/cmdb/latest/workspace';
    const $5d7c6ac21f7af915$export$122fccf0bbbc9acc = 30000;
    const $5d7c6ac21f7af915$export$827d903316fc333c = ()=>{
        const { data: data, loading: loading, error: error, refresh: fetchWorkspaceId } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("gRzZD")).workspaceResource));
        const workspaceId = data ?? undefined;
        return {
            loading: loading,
            error: error,
            workspaceId: workspaceId,
            fetchWorkspaceId: fetchWorkspaceId
        };
    };
    const $5d7c6ac21f7af915$var$useInterval = (callback, delay)=>{
        const savedCallback = (0, $5uXOq.useRef)(callback);
        (0, $5uXOq.useEffect)(()=>{
            savedCallback.current = callback;
        }, [
            callback
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const tick = ()=>{
                savedCallback.current();
            };
            if (delay !== null) {
                const id = setInterval(tick, delay);
                return ()=>clearInterval(id);
            }
            return undefined;
        }, [
            delay
        ]);
    };
    const $5d7c6ac21f7af915$export$74ebc9a49f60d38a = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId, loading: loading } = $5d7c6ac21f7af915$export$827d903316fc333c();
        const [isVisible, setIsVisible] = (0, $5uXOq.useState)((0, (0, parcelRequire("ktP1V")).isCMDBEnabledInEnvironment)() && (0, (0, parcelRequire("ahEft")).isLicensedPremiumUser)(tenantContext));
        const [shouldPollForWorkspaceId, setShouldPollForWorkspaceId] = (0, $5uXOq.useState)(false);
        const [hasFetchedWorkspaceId, setHasFetchedWorkspaceId] = (0, $5uXOq.useState)(false);
        const [, setPollCount] = (0, $5uXOq.useState)(0);
        (0, $5uXOq.useEffect)(()=>{
            if (!workspaceId && (0, (0, parcelRequire("ahEft")).isLicensedPremiumUser)(tenantContext) && (0, (0, parcelRequire("ktP1V")).isCMDBEnabledInEnvironment)()) {
                fetchWorkspaceId();
                setHasFetchedWorkspaceId(true);
            }
        }, [
            fetchWorkspaceId,
            tenantContext,
            workspaceId
        ]);
        $5d7c6ac21f7af915$var$useInterval(()=>{
            fetchWorkspaceId();
            setPollCount((a)=>a + 1);
        }, shouldPollForWorkspaceId ? $5d7c6ac21f7af915$export$122fccf0bbbc9acc : null);
        (0, $5uXOq.useEffect)(()=>{
            if (hasFetchedWorkspaceId && !loading) {
                if ((0, (0, parcelRequire("ahEft")).isLicensedPremiumUser)(tenantContext)) {
                    if (workspaceId !== undefined) {
                        setIsVisible(true);
                        setShouldPollForWorkspaceId(false);
                    } else {
                        setIsVisible(false);
                        setShouldPollForWorkspaceId(true);
                    }
                } else {
                    setIsVisible(false);
                    setShouldPollForWorkspaceId(false);
                }
            }
        }, [
            tenantContext,
            workspaceId,
            loading,
            hasFetchedWorkspaceId
        ]);
        return isVisible;
    };
});
parcelRegister("j8qoE", function(module, exports) {
    $parcel$export(module.exports, "useInsightGlobalConfig", ()=>$39a17ba3a31a7663$export$ee996472bb397b41);
    $parcel$export(module.exports, "useInsightReferenceTypes", ()=>$39a17ba3a31a7663$export$efb93af726a65b26);
    $parcel$export(module.exports, "useInsightStatusTypes", ()=>$39a17ba3a31a7663$export$7eefa9cea32e596a);
    $parcel$export(module.exports, "useInsightIcons", ()=>$39a17ba3a31a7663$export$8336b36336c9f3c8);
    $parcel$export(module.exports, "useDataManager", ()=>$39a17ba3a31a7663$export$143bcc72da01e561);
    $parcel$export(module.exports, "useNamedInsightIcons", ()=>$39a17ba3a31a7663$export$979b264266dab4ed);
    $parcel$export(module.exports, "useIsRestrictedSchema", ()=>$39a17ba3a31a7663$export$d07372ba961b2bc5);
    $parcel$export(module.exports, "InsightGlobalConfigContainer", ()=>$39a17ba3a31a7663$export$c4c69c73d422ea06);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $5Jzjf;
    var $3SYcN;
    const $39a17ba3a31a7663$export$d4c72bab9d6cc13a = {
        loading: false,
        error: undefined,
        config: undefined,
        referenceTypes: {
            data: undefined,
            createLoading: false,
            createError: undefined,
            deleteLoading: false,
            deleteError: undefined,
            updateLoading: false,
            updateError: undefined
        },
        statusTypes: {
            data: undefined,
            createLoading: false,
            createError: undefined,
            deleteLoading: false,
            deleteError: undefined,
            updateLoading: false,
            updateError: undefined
        },
        icons: {
            data: undefined,
            deleteLoading: false,
            deleteError: undefined,
            addLoading: false,
            addError: undefined,
            updateLoading: false,
            updateError: undefined
        },
        dataManager: {
            rolesData: undefined,
            rolesError: undefined,
            rolesLoading: false,
            rolesUpdateLoading: false,
            rolesUpdateError: undefined,
            tokensLoading: false,
            tokensData: undefined,
            tokensError: undefined,
            tokenRevokeLoading: false,
            tokenRevokeError: undefined,
            isProvisioned: undefined,
            provisioningLoading: false,
            provisioningError: undefined,
            provisioningUpdateLoading: false,
            provisioningUpdateError: undefined,
            myRoles: undefined,
            myRolesError: undefined,
            myRolesLoading: false
        }
    };
    const $39a17ba3a31a7663$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $39a17ba3a31a7663$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("5Jzjf")).actions
    });
    const $39a17ba3a31a7663$export$ee996472bb397b41 = (0, (0, parcelRequire("3sQ5x")).createHook)($39a17ba3a31a7663$var$Store, {
        selector: (state)=>state
    });
    const $39a17ba3a31a7663$export$efb93af726a65b26 = (0, (0, parcelRequire("3sQ5x")).createHook)($39a17ba3a31a7663$var$Store, {
        selector: ({ referenceTypes: referenceTypes })=>({
                ...referenceTypes,
                data: referenceTypes.data ? (0, (0, parcelRequire("3SYcN")).sortReferenceTypes)(referenceTypes.data) : undefined
            })
    });
    const $39a17ba3a31a7663$export$7eefa9cea32e596a = (0, (0, parcelRequire("3sQ5x")).createHook)($39a17ba3a31a7663$var$Store, {
        selector: ({ statusTypes: statusTypes })=>({
                ...statusTypes,
                data: statusTypes.data ? (0, (0, parcelRequire("3SYcN")).sortStatusTypes)(statusTypes.data) : undefined
            })
    });
    const $39a17ba3a31a7663$export$8336b36336c9f3c8 = (0, (0, parcelRequire("3sQ5x")).createHook)($39a17ba3a31a7663$var$Store, {
        selector: ({ icons: icons })=>icons
    });
    const $39a17ba3a31a7663$export$143bcc72da01e561 = (0, (0, parcelRequire("3sQ5x")).createHook)($39a17ba3a31a7663$var$Store, {
        selector: ({ dataManager: dataManager })=>dataManager
    });
    const $39a17ba3a31a7663$export$979b264266dab4ed = (0, (0, parcelRequire("3sQ5x")).createStateHook)($39a17ba3a31a7663$var$Store, {
        selector: ({ icons: icons })=>{
            const map = {};
            (icons.data ?? []).forEach((icon)=>{
                map[icon.name] = icon;
            });
            return map;
        }
    });
    const $39a17ba3a31a7663$export$9c8eee3abcaa634e = (state, schemaId)=>{
        const restrictedObjectSchemaIds = state.config?.restrictedObjectSchemaIds ?? [];
        return restrictedObjectSchemaIds.includes(parseInt(schemaId, 10));
    };
    const $39a17ba3a31a7663$export$d07372ba961b2bc5 = (0, (0, parcelRequire("3sQ5x")).createHook)($39a17ba3a31a7663$var$Store, {
        selector: $39a17ba3a31a7663$export$9c8eee3abcaa634e
    });
    const $39a17ba3a31a7663$var$autoFetchGlobalConfig = ()=>({ dispatch: dispatch, getState: getState }, { disableOnInit: disableOnInit })=>{
            const { loading: loading, error: error, config: config } = getState();
            if (!disableOnInit && !loading && !error && !config) dispatch((0, (0, parcelRequire("5Jzjf")).actions).fetchGlobalConfig());
        };
    const $39a17ba3a31a7663$export$c4c69c73d422ea06 = (0, (0, parcelRequire("gg7kZ")).createContainer)($39a17ba3a31a7663$var$Store, {
        onInit: $39a17ba3a31a7663$var$autoFetchGlobalConfig
    });
});
parcelRegister("5Jzjf", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$f2ab8bdfc51ba92b$export$e324594224ef24da);
    var $h3JSQ;
    var $afOgx;
    var $dLfth;
    var $irXYU;
    var $jz1my;
    var $3MY0W;
    var $3WfMh;
    var $eiTPs;
    var $8u5AZ;
    var $5VTnO;
    var $axmNY;
    var $j9kxm;
    var $yPoOn;
    var $akTZj;
    var $czU2t;
    var $lsHFw;
    const $f2ab8bdfc51ba92b$export$e324594224ef24da = {
        createReferenceType: (0, parcelRequire("afOgx")).createReferenceType,
        createStatusType: (0, parcelRequire("dLfth")).createStatusType,
        deleteIcon: (0, parcelRequire("irXYU")).deleteIcon,
        addIcon: (0, parcelRequire("h3JSQ")).addIcon,
        deleteReferenceType: (0, parcelRequire("jz1my")).deleteReferenceType,
        deleteStatusType: (0, parcelRequire("3MY0W")).deleteStatusType,
        fetchGlobalConfig: (0, parcelRequire("3WfMh")).fetchGlobalConfig,
        setIcon: (0, parcelRequire("yPoOn")).setIcon,
        updateIcon: (0, parcelRequire("yPoOn")).updateIcon,
        setReferenceType: (0, parcelRequire("czU2t")).setReferenceType,
        updateReferenceType: (0, parcelRequire("czU2t")).updateReferenceType,
        fetchPrincipalsForRoles: (0, parcelRequire("8u5AZ")).fetchPrincipalsForRoles,
        fetchMyDataManagerRoles: (0, parcelRequire("eiTPs")).fetchMyDataManagerRoles,
        updateDataManagerRole: (0, parcelRequire("j9kxm")).updateDataManagerRole,
        fetchProvisioningStatus: (0, parcelRequire("5VTnO")).fetchProvisioningStatus,
        updateProvisioningStatus: (0, parcelRequire("akTZj")).updateProvisioningStatus,
        fetchDataManagerTokens: (0, parcelRequire("axmNY")).fetchDataManagerTokens,
        setStatusType: (0, parcelRequire("lsHFw")).setStatusType,
        updateStatusType: (0, parcelRequire("lsHFw")).updateStatusType
    };
});
parcelRegister("h3JSQ", function(module, exports) {
    $parcel$export(module.exports, "addIcon", ()=>$8a6a0321f1a1ecf0$export$3488242433cbedb);
    var $jcw0u;
    var $8zOmE;
    var $5Ny9E;
    var $gm5wx;
    var $lbRfL;
    const $8a6a0321f1a1ecf0$export$3488242433cbedb = (newIcon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            const state = getState();
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: true
                }
            });
            try {
                const uploadCredentials = await (0, (0, parcelRequire("lbRfL")).mediaInfoForUpload)((0, (0, parcelRequire("5Ny9E")).toWorkspaceId)(workspaceId));
                const uploadMediaResult = await (0, (0, parcelRequire("lbRfL")).mediaUploadFile)({
                    mediaBaseUrl: (0, (0, parcelRequire("gm5wx")).toMediaBaseUrl)(uploadCredentials.mediaBaseUrl),
                    collectionId: (0, (0, parcelRequire("gm5wx")).toCollectionId)(uploadCredentials.collectionId),
                    fileName: (0, (0, parcelRequire("gm5wx")).toFileName)(newIcon.fileName),
                    issuer: (0, (0, parcelRequire("gm5wx")).toMediaIssuer)(uploadCredentials.issuer),
                    clientId: (0, (0, parcelRequire("gm5wx")).toMediaClientId)(uploadCredentials.clientId),
                    mediaJwtToken: (0, (0, parcelRequire("gm5wx")).toMediaJwt)(uploadCredentials.mediaJwtToken),
                    blob: newIcon.blob
                });
                const mediaInfoForPullingResult = await (0, (0, parcelRequire("lbRfL")).mediaInfoForPulling)((0, (0, parcelRequire("5Ny9E")).toWorkspaceId)(workspaceId), (0, (0, parcelRequire("gm5wx")).toMediaFileUuid)(uploadMediaResult.data.id));
                const pollMediaFileReady = ()=>{
                    const getMediaFileStatus = ()=>(0, (0, parcelRequire("lbRfL")).mediaGetFileInfo)({
                            mediaBaseUrl: (0, (0, parcelRequire("gm5wx")).toMediaBaseUrl)(mediaInfoForPullingResult.mediaBaseUrl),
                            mediaFileUuid: (0, (0, parcelRequire("gm5wx")).toMediaFileUuid)(uploadMediaResult.data.id),
                            issuer: (0, (0, parcelRequire("gm5wx")).toMediaIssuer)(mediaInfoForPullingResult.issuer),
                            clientId: (0, (0, parcelRequire("gm5wx")).toMediaClientId)(uploadCredentials.clientId),
                            mediaJwtToken: (0, (0, parcelRequire("gm5wx")).toMediaJwt)(mediaInfoForPullingResult.mediaJwtToken)
                        });
                    return new Promise((resolve, reject)=>{
                        const poll = (attempt = 0)=>{
                            const statusPromise = getMediaFileStatus();
                            statusPromise.then((response)=>{
                                const status = response.data.processingStatus;
                                switch(status){
                                    default:
                                    case (0, (0, parcelRequire("gm5wx")).MEDIA_PROCESS_STATUS).PENDING:
                                    case (0, (0, parcelRequire("gm5wx")).MEDIA_PROCESS_STATUS).RUNNING:
                                        return setTimeout(()=>{
                                            if (attempt > 20) return reject(new Error('Failed to add icon after 10 tries'));
                                            return poll(attempt + 1);
                                        }, 5000);
                                    case (0, (0, parcelRequire("gm5wx")).MEDIA_PROCESS_STATUS).SUCCEEDED:
                                        return resolve();
                                    case (0, (0, parcelRequire("gm5wx")).MEDIA_PROCESS_STATUS).FAILED:
                                        return reject(new Error('Media services failed to process file!'));
                                }
                            }).catch((error)=>reject(new Error(error)));
                        };
                        poll();
                    });
                };
                await pollMediaFileReady();
                const savedIconEntry = await (0, (0, parcelRequire("lbRfL")).publishNewIcon)((0, (0, parcelRequire("5Ny9E")).toWorkspaceId)(workspaceId), (0, (0, parcelRequire("gm5wx")).toIconName)(newIcon.iconName), (0, (0, parcelRequire("gm5wx")).toMediaFileUuid)(uploadMediaResult.data.id));
                if (!Array.isArray(state.icons.data)) throw new Error('Invalid state! Icons data is not array!');
                const newIconsData = state.icons.data.slice(0);
                newIconsData.unshift(savedIconEntry);
                const newState = {
                    ...state,
                    icons: {
                        ...state.icons,
                        addLoading: false,
                        data: newIconsData
                    }
                };
                setState(newState);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'addIcon succeeded');
            } catch (error) {
                setState({
                    ...state,
                    icons: {
                        ...state.icons,
                        addLoading: false,
                        addError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'addIcon',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("gm5wx", function(module, exports) {
    $parcel$export(module.exports, "MEDIA_PROCESS_STATUS", ()=>$1ed2f93c2402a594$export$a760cae7c12e7f51);
    $parcel$export(module.exports, "toMediaBaseUrl", ()=>$1ed2f93c2402a594$export$342e5c2fdd47297c);
    $parcel$export(module.exports, "toCollectionId", ()=>$1ed2f93c2402a594$export$59b8a2c37e183bf5);
    $parcel$export(module.exports, "toIconName", ()=>$1ed2f93c2402a594$export$41540e96af228b1a);
    $parcel$export(module.exports, "toFileName", ()=>$1ed2f93c2402a594$export$249aa0c12095aafd);
    $parcel$export(module.exports, "toMediaIssuer", ()=>$1ed2f93c2402a594$export$9dd52a3c923cba73);
    $parcel$export(module.exports, "toMediaJwt", ()=>$1ed2f93c2402a594$export$dce78fe68aa68f20);
    $parcel$export(module.exports, "toMediaFileUuid", ()=>$1ed2f93c2402a594$export$79083a8ab294d28e);
    $parcel$export(module.exports, "toMediaClientId", ()=>$1ed2f93c2402a594$export$b105972f97cb69fa);
    const $1ed2f93c2402a594$export$a760cae7c12e7f51 = {
        SUCCEEDED: 'succeeded',
        FAILED: 'failed',
        PENDING: 'pending',
        RUNNING: 'running'
    };
    const $1ed2f93c2402a594$export$342e5c2fdd47297c = (url)=>url;
    const $1ed2f93c2402a594$export$59b8a2c37e183bf5 = (uuid)=>uuid;
    const $1ed2f93c2402a594$export$41540e96af228b1a = (iconName)=>iconName;
    const $1ed2f93c2402a594$export$249aa0c12095aafd = (fileName)=>fileName;
    const $1ed2f93c2402a594$export$9dd52a3c923cba73 = (mediaIssuer)=>mediaIssuer;
    const $1ed2f93c2402a594$export$dce78fe68aa68f20 = (mediaIssuer)=>mediaIssuer;
    const $1ed2f93c2402a594$export$79083a8ab294d28e = (mediaFileUuid)=>mediaFileUuid;
    const $1ed2f93c2402a594$export$b105972f97cb69fa = (mediaClientId)=>mediaClientId;
});
parcelRegister("lbRfL", function(module, exports) {
    $parcel$export(module.exports, "mediaInfoForUpload", ()=>$4a8bb82a4fdfb7bb$export$c7944179dc1cb15d);
    $parcel$export(module.exports, "mediaUploadFile", ()=>$4a8bb82a4fdfb7bb$export$6fba374ded90c76b);
    $parcel$export(module.exports, "mediaInfoForPulling", ()=>$4a8bb82a4fdfb7bb$export$4138ca7fa1c5dcbc);
    $parcel$export(module.exports, "mediaGetFileInfo", ()=>$4a8bb82a4fdfb7bb$export$c607c6f99a3a53ca);
    $parcel$export(module.exports, "publishNewIcon", ()=>$4a8bb82a4fdfb7bb$export$a7fc7d8db8ccf9da);
    var $4R6GH;
    var $eusud;
    var $3jFL4;
    const $4a8bb82a4fdfb7bb$export$336c36f125eba39c = ({ issuer: issuer, clientId: clientId, mediaJwtToken: mediaJwtToken })=>(0, (0, parcelRequire("4R6GH")).fg)('assets_rearch_media_client_auth') ? {
            'X-Client-Id': clientId,
            Authorization: `Bearer ${mediaJwtToken}`
        } : {
            'X-Issuer': issuer,
            Authorization: `Bearer ${mediaJwtToken}`
        };
    const $4a8bb82a4fdfb7bb$export$c7944179dc1cb15d = (workspaceId)=>(0, (0, parcelRequire("eusud")).performGetRequest)((0, (0, parcelRequire("3jFL4")).getCmdbIconTokenUploadingUrl)(workspaceId));
    const $4a8bb82a4fdfb7bb$export$6fba374ded90c76b = ({ mediaBaseUrl: mediaBaseUrl, collectionId: collectionId, fileName: fileName, issuer: issuer, mediaJwtToken: mediaJwtToken, blob: blob, clientId: clientId })=>(0, (0, parcelRequire("eusud")).performPostRequest)(`${String(mediaBaseUrl)}/file/binary?collection=${String(collectionId)}&name=${String(fileName)}&deletable=true`, {
            headers: {
                ...$4a8bb82a4fdfb7bb$export$336c36f125eba39c({
                    issuer: issuer,
                    clientId: clientId,
                    mediaJwtToken: mediaJwtToken
                }),
                'Content-Type': blob.type
            },
            body: blob
        });
    const $4a8bb82a4fdfb7bb$export$4138ca7fa1c5dcbc = (workspaceId, fileUuid)=>(0, (0, parcelRequire("eusud")).performGetRequest)((0, (0, parcelRequire("3jFL4")).getCmdbIconTokenFetchingUrl)(workspaceId, fileUuid));
    const $4a8bb82a4fdfb7bb$export$c607c6f99a3a53ca = ({ mediaBaseUrl: mediaBaseUrl, mediaFileUuid: mediaFileUuid, issuer: issuer, mediaJwtToken: mediaJwtToken, clientId: clientId })=>(0, (0, parcelRequire("eusud")).performGetRequest)(`${String(mediaBaseUrl)}/file/${String(mediaFileUuid)}`, {
            headers: $4a8bb82a4fdfb7bb$export$336c36f125eba39c({
                issuer: issuer,
                clientId: clientId,
                mediaJwtToken: mediaJwtToken
            })
        });
    const $4a8bb82a4fdfb7bb$export$a7fc7d8db8ccf9da = (workspaceId, iconName, mediaFileUuid)=>(0, (0, parcelRequire("eusud")).performPostRequest)((0, (0, parcelRequire("3jFL4")).getCmdbIconCreateUrl)(workspaceId), {
            body: JSON.stringify({
                name: iconName,
                mediaFileUuid: mediaFileUuid
            })
        });
});
parcelRegister("3jFL4", function(module, exports) {
    $parcel$export(module.exports, "getCmdbIconCreateUrl", ()=>$af0daf8901be8d29$export$4c6ff27b48881aba);
    $parcel$export(module.exports, "getCmdbIconTokenFetchingUrl", ()=>$af0daf8901be8d29$export$39e83f10cc93fe99);
    $parcel$export(module.exports, "getCmdbIconTokenUploadingUrl", ()=>$af0daf8901be8d29$export$7fdc9cd59a492763);
    $parcel$export(module.exports, "getCmdbIconByIdUrl", ()=>$af0daf8901be8d29$export$b881a625e1bc4876);
    var $klJ8b;
    const $af0daf8901be8d29$var$getCmdbIconUrl = (workspaceId)=>`${(0, (0, parcelRequire("klJ8b")).getCmdbRestBaseUrl)(workspaceId)}/icon`;
    const $af0daf8901be8d29$export$4c6ff27b48881aba = (workspaceId)=>`${$af0daf8901be8d29$var$getCmdbIconUrl(workspaceId)}/create`;
    const $af0daf8901be8d29$export$39e83f10cc93fe99 = (workspaceId, fileUuid)=>`${$af0daf8901be8d29$var$getCmdbIconUrl(workspaceId)}/token-for-fetching-icon/${fileUuid}`;
    const $af0daf8901be8d29$export$7fdc9cd59a492763 = (workspaceId)=>`${$af0daf8901be8d29$var$getCmdbIconUrl(workspaceId)}/token-for-uploading-icon`;
    const $af0daf8901be8d29$export$b881a625e1bc4876 = (workspaceId, iconId)=>`${$af0daf8901be8d29$var$getCmdbIconUrl(workspaceId)}/${iconId}`;
});
parcelRegister("afOgx", function(module, exports) {
    $parcel$export(module.exports, "createReferenceType", ()=>$e882d4e4e4fabf3c$export$ac28770630794807);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $Zsxbh;
    const $e882d4e4e4fabf3c$export$ac28770630794807 = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            const state = getState();
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: true
                }
            });
            try {
                const response = await (0, (0, parcelRequire("eusud")).performPostRequest)((0, (0, parcelRequire("Zsxbh")).getCmdbConfigReferenceTypeUrl)(workspaceId), {
                    body: JSON.stringify({
                        ...data,
                        color: data.color.replace('#', '')
                    })
                });
                setState({
                    ...state,
                    referenceTypes: {
                        ...state.referenceTypes,
                        createLoading: false,
                        data: [
                            ...state.referenceTypes.data ?? [],
                            response
                        ]
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'createReferenceType succeeded');
            } catch (error) {
                setState({
                    ...state,
                    referenceTypes: {
                        ...state.referenceTypes,
                        createLoading: false,
                        createError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'createReferenceType',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("Zsxbh", function(module, exports) {
    $parcel$export(module.exports, "getCmdbConfigStatusTypeUrl", ()=>$72391202dbecf10a$export$3269d36b59c9d27f);
    $parcel$export(module.exports, "getCmdbConfigStatusTypeByIdUrl", ()=>$72391202dbecf10a$export$229964acb6a55e5);
    $parcel$export(module.exports, "getCmdbConfigStatusTypePickerUrl", ()=>$72391202dbecf10a$export$1991fb4d07b18469);
    $parcel$export(module.exports, "getCmdbConfigReferenceTypeUrl", ()=>$72391202dbecf10a$export$ad07341c88d2bbab);
    $parcel$export(module.exports, "getCmdbConfigReferenceTypeByIdUrl", ()=>$72391202dbecf10a$export$293e2bfa6752a2aa);
    $parcel$export(module.exports, "getCmdbConfigRoleByIdUrl", ()=>$72391202dbecf10a$export$225d5f547cc90d86);
    $parcel$export(module.exports, "getCmdbConfigRoleObjectSchemaByIdUrl", ()=>$72391202dbecf10a$export$9c1d73050da32aae);
    $parcel$export(module.exports, "getCmdbConfigRoleObjectTypeByIdUrl", ()=>$72391202dbecf10a$export$6583ed007df50d2b);
    $parcel$export(module.exports, "getCmdbPermsPrincipalUrl", ()=>$72391202dbecf10a$export$a635e2e9382b1621);
    $parcel$export(module.exports, "getCmdbPermsRoleAssignmentUrl", ()=>$72391202dbecf10a$export$b3cb4590859563b0);
    $parcel$export(module.exports, "getCmdbPermsTokenStatusUrl", ()=>$72391202dbecf10a$export$8ae00db5fd7218c5);
    $parcel$export(module.exports, "getMyDataManagerRolesUrl", ()=>$72391202dbecf10a$export$794aa3ae46133f30);
    var $ebyGx = parcelRequire("ebyGx");
    var $klJ8b;
    const $72391202dbecf10a$var$getCmdbConfigUrl = (workspaceId)=>`${(0, (0, parcelRequire("klJ8b")).getCmdbRestBaseUrl)(workspaceId)}/config`;
    const $72391202dbecf10a$export$3269d36b59c9d27f = (workspaceId, queryParams)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/statustype${queryParams ? `?${(0, $ebyGx.stringify)(queryParams)}` : ''}`;
    const $72391202dbecf10a$export$229964acb6a55e5 = (workspaceId, statusTypeId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/statustype/${statusTypeId}`;
    const $72391202dbecf10a$export$1991fb4d07b18469 = (workspaceId, queryParams)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/statustype/picker?${(0, $ebyGx.stringify)(queryParams)}`;
    const $72391202dbecf10a$export$ad07341c88d2bbab = (workspaceId, queryParams)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/referencetype${queryParams ? `?${(0, $ebyGx.stringify)(queryParams)}` : ''}`;
    const $72391202dbecf10a$export$293e2bfa6752a2aa = (workspaceId, referenceTypeId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/referencetype/${referenceTypeId}`;
    const $72391202dbecf10a$export$225d5f547cc90d86 = (workspaceId, roleId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/role/${roleId}`;
    const $72391202dbecf10a$export$9c1d73050da32aae = (workspaceId, objectSchemaId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/role/objectschema/${objectSchemaId}`;
    const $72391202dbecf10a$export$6583ed007df50d2b = (workspaceId, objectTypeId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/role/objecttype/${objectTypeId}`;
    const $72391202dbecf10a$export$a635e2e9382b1621 = (workspaceId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/perms/principal`;
    const $72391202dbecf10a$export$b3cb4590859563b0 = (workspaceId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/perms/role-assignment`;
    const $72391202dbecf10a$export$8ae00db5fd7218c5 = (workspaceId, token)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/perms/token-status?token=${token}`;
    const $72391202dbecf10a$export$794aa3ae46133f30 = (workspaceId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/perms/my-roles`;
});
parcelRegister("dLfth", function(module, exports) {
    $parcel$export(module.exports, "createStatusType", ()=>$98b79b2a12298162$export$8c874b16a69a1b9d);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $Zsxbh;
    const $98b79b2a12298162$export$8c874b16a69a1b9d = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            const state = getState();
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: true
                }
            });
            try {
                const response = await (0, (0, parcelRequire("eusud")).performPostRequest)((0, (0, parcelRequire("Zsxbh")).getCmdbConfigStatusTypeUrl)(workspaceId), {
                    body: JSON.stringify(data)
                });
                setState({
                    ...state,
                    statusTypes: {
                        ...state.statusTypes,
                        createLoading: false,
                        data: [
                            ...state.statusTypes.data ?? [],
                            response
                        ]
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({
                    source: 'insightGlobalConfigStatuses',
                    action: 'created',
                    actionSubject: 'insightGlobalConfigStatuses'
                }), 'insightGlobalConfigStatuses created');
            } catch (error) {
                setState({
                    ...state,
                    statusTypes: {
                        ...state.statusTypes,
                        createLoading: false,
                        createError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'createStatusType',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("irXYU", function(module, exports) {
    $parcel$export(module.exports, "deleteIcon", ()=>$2669ccdf98bb7ce7$export$12d45ee5c2161b75);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $3jFL4;
    const $2669ccdf98bb7ce7$export$12d45ee5c2161b75 = (icon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            const state = getState();
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: true
                }
            });
            try {
                await (0, (0, parcelRequire("eusud")).performDeleteRequest)((0, (0, parcelRequire("3jFL4")).getCmdbIconByIdUrl)(workspaceId, icon.id));
                setState({
                    ...state,
                    icons: {
                        ...state.icons,
                        deleteLoading: false,
                        data: state.icons.data ? state.icons.data.filter(({ id: id })=>id !== icon.id) : undefined
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteIcon succeeded');
            } catch (error) {
                setState({
                    ...state,
                    icons: {
                        ...state.icons,
                        deleteLoading: false,
                        deleteError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'deleteIcon',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("jz1my", function(module, exports) {
    $parcel$export(module.exports, "deleteReferenceType", ()=>$a2a9cfda90a52e02$export$432ee1f3819316e5);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $Zsxbh;
    const $a2a9cfda90a52e02$export$432ee1f3819316e5 = (referenceType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            const state = getState();
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: true
                }
            });
            try {
                await (0, (0, parcelRequire("eusud")).performDeleteRequest)((0, (0, parcelRequire("Zsxbh")).getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceType.id));
                setState({
                    ...state,
                    referenceTypes: {
                        ...state.referenceTypes,
                        deleteLoading: false,
                        data: state.referenceTypes.data ? state.referenceTypes.data.filter(({ id: id })=>id !== referenceType.id) : undefined
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteReferenceType succeeded');
            } catch (error) {
                setState({
                    ...state,
                    referenceTypes: {
                        ...state.referenceTypes,
                        deleteLoading: false,
                        deleteError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'deleteReferenceType',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("3MY0W", function(module, exports) {
    $parcel$export(module.exports, "deleteStatusType", ()=>$b29c0bec337815ce$export$812423dc05f0fc3d);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $Zsxbh;
    const $b29c0bec337815ce$export$812423dc05f0fc3d = (statusType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            const state = getState();
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: true
                }
            });
            try {
                await (0, (0, parcelRequire("eusud")).performDeleteRequest)((0, (0, parcelRequire("Zsxbh")).getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusType.id));
                setState({
                    ...state,
                    statusTypes: {
                        ...state.statusTypes,
                        deleteLoading: false,
                        data: state.statusTypes.data ? state.statusTypes.data.filter(({ id: id })=>id !== statusType.id) : undefined
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteStatusType succeeded');
            } catch (error) {
                setState({
                    ...state,
                    statusTypes: {
                        ...state.statusTypes,
                        deleteLoading: false,
                        deleteError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'deleteStatusType',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("3WfMh", function(module, exports) {
    $parcel$export(module.exports, "fetchGlobalConfig", ()=>$032f1f2dd067f8fc$export$14c75ba3f0e48e21);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $juXmc;
    const $032f1f2dd067f8fc$export$14c75ba3f0e48e21 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            if (getState().loading || !shouldRefetch && getState().config) return;
            setState({
                loading: true,
                error: undefined
            });
            try {
                const response = await (0, (0, parcelRequire("eusud")).performGetRequest)((0, (0, parcelRequire("juXmc")).getCmdbGlobalConfigUrl)(workspaceId));
                const iconListWithServiceOTEntriesRemoved = response ? response.icons.filter((item)=>item.name !== 'Applications' && item.name !== 'Business Services' && item.name !== 'Capabilities' && item.name !== 'Software Services') : undefined;
                setState({
                    loading: false,
                    config: {
                        ...response,
                        restrictedObjectSchemaIds: response?.restrictedObjectSchemaIds ?? [],
                        icons: iconListWithServiceOTEntriesRemoved || []
                    },
                    referenceTypes: {
                        ...getState().referenceTypes,
                        data: response ? response.referenceTypes : undefined
                    },
                    statusTypes: {
                        ...getState().statusTypes,
                        data: response ? response.statusTypes : undefined
                    },
                    icons: {
                        ...getState().icons,
                        data: iconListWithServiceOTEntriesRemoved
                    },
                    dataManager: {
                        ...getState().dataManager
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchInsightGlobalConfig succeeded');
            } catch (error) {
                setState({
                    loading: false,
                    error: error
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchInsightGlobalConfig',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("juXmc", function(module, exports) {
    $parcel$export(module.exports, "getCmdbGlobalConfigUrl", ()=>$d0e7aed8ea80c147$export$50437136a9a5e2d3);
    $parcel$export(module.exports, "getCmdbGlobalConfigObjectUrl", ()=>$d0e7aed8ea80c147$export$73e58b72a1074528);
    $parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdUrl", ()=>$d0e7aed8ea80c147$export$e2019224257efde3);
    $parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdPropertyUrl", ()=>$d0e7aed8ea80c147$export$d1b25f8feb06db8a);
    var $ebyGx = parcelRequire("ebyGx");
    var $klJ8b;
    const $d0e7aed8ea80c147$var$getCmdbGlobalUrl = (workspaceId)=>`${(0, (0, parcelRequire("klJ8b")).getCmdbRestBaseUrl)(workspaceId)}/global`;
    const $d0e7aed8ea80c147$export$50437136a9a5e2d3 = (workspaceId)=>`${$d0e7aed8ea80c147$var$getCmdbGlobalUrl(workspaceId)}/config`;
    const $d0e7aed8ea80c147$export$73e58b72a1074528 = (workspaceId, queryParams)=>`${$d0e7aed8ea80c147$var$getCmdbGlobalUrl(workspaceId)}/config/object?${(0, $ebyGx.stringify)(queryParams)}`;
    const $d0e7aed8ea80c147$export$e2019224257efde3 = (workspaceId, objectSchemaId)=>`${$d0e7aed8ea80c147$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}`;
    const $d0e7aed8ea80c147$export$d1b25f8feb06db8a = (workspaceId, objectSchemaId)=>`${$d0e7aed8ea80c147$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}/property`;
});
parcelRegister("eiTPs", function(module, exports) {
    $parcel$export(module.exports, "fetchMyDataManagerRoles", ()=>$716ec7c261a3e8b3$export$2211f294ebd95b92);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $Zsxbh;
    const $716ec7c261a3e8b3$export$2211f294ebd95b92 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            if (getState().dataManager.myRolesLoading || !shouldRefetch && getState().dataManager.myRoles) return;
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRolesLoading: true,
                    myRolesError: undefined
                }
            });
            try {
                const myRoles = await (0, (0, parcelRequire("eusud")).performGetRequest)((0, (0, parcelRequire("Zsxbh")).getMyDataManagerRolesUrl)(workspaceId));
                setState({
                    dataManager: {
                        ...getState().dataManager,
                        myRoles: myRoles.results,
                        myRolesLoading: false
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchMyDataManagerRoles succeeded');
            } catch (error) {
                setState({
                    dataManager: {
                        ...getState().dataManager,
                        myRolesLoading: false,
                        myRolesError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchMyDataManagerRoles',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("8u5AZ", function(module, exports) {
    $parcel$export(module.exports, "fetchPrincipalsForRoles", ()=>$3daa0c86c5959b28$export$9c5110cfdcb72b5);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $Zsxbh;
    const $3daa0c86c5959b28$export$9c5110cfdcb72b5 = (roleIds)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            const state = getState();
            if (state.dataManager.rolesLoading) return;
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesLoading: true
                }
            });
            try {
                const requestBody = {
                    roleIds: roleIds,
                    resourceId: `ari:cloud:cmdb::workspace/${workspaceId}`
                };
                const principalIdsForRoles = await (0, (0, parcelRequire("eusud")).performPostRequest)((0, (0, parcelRequire("Zsxbh")).getCmdbPermsPrincipalUrl)(workspaceId), {
                    body: JSON.stringify(requestBody)
                });
                setState({
                    dataManager: {
                        ...state.dataManager,
                        rolesData: principalIdsForRoles.results,
                        rolesLoading: false
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchPrincipalsForRoles succeeded');
            } catch (error) {
                setState({
                    ...state,
                    dataManager: {
                        ...state.dataManager,
                        rolesLoading: false,
                        rolesError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchPrincipalsForRoles',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("5VTnO", function(module, exports) {
    $parcel$export(module.exports, "fetchProvisioningStatus", ()=>$1d2259843f354494$export$aa3ea988cce42be1);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $8OEkP;
    const $1d2259843f354494$export$aa3ea988cce42be1 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            if (getState().dataManager.provisioningLoading || !shouldRefetch && getState().dataManager.isProvisioned !== undefined) return;
            setState({
                dataManager: {
                    ...getState().dataManager,
                    provisioningLoading: true,
                    provisioningError: undefined
                }
            });
            try {
                const result = await (0, (0, parcelRequire("eusud")).performGetRequest)((0, (0, parcelRequire("8OEkP")).getDataManagerProvisioningStatusUrl)(workspaceId));
                setState({
                    dataManager: {
                        ...getState().dataManager,
                        isProvisioned: $1d2259843f354494$var$isProvisioned(result.enabled),
                        provisioningLoading: false
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchProvisioningStatus succeeded');
            } catch (error) {
                setState({
                    dataManager: {
                        ...getState().dataManager,
                        provisioningLoading: false,
                        provisioningError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchProvisioningStatus',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                    },
                    error: error
                });
                throw error;
            }
        };
    const $1d2259843f354494$var$isProvisioned = (status)=>status === 'ON';
});
parcelRegister("8OEkP", function(module, exports) {
    $parcel$export(module.exports, "getDataManagerGenerateContainerTokenUrl", ()=>$5d534e44ee8c7958$export$5f42b4e80a66d7c);
    $parcel$export(module.exports, "delDataManagerContainerTokenUrl", ()=>$5d534e44ee8c7958$export$ddc5a4cb751fae27);
    $parcel$export(module.exports, "getDataManagerFetchContainerTokenUrl", ()=>$5d534e44ee8c7958$export$591d877d695dbd95);
    $parcel$export(module.exports, "getDataManagerProvisioningStatusUrl", ()=>$5d534e44ee8c7958$export$1dd01c50c7948938);
    var $klJ8b;
    const $5d534e44ee8c7958$export$5f42b4e80a66d7c = (workspaceId, label, type, duration)=>`${(0, (0, parcelRequire("klJ8b")).getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${type}?label=${label}&duration=${duration}`;
    const $5d534e44ee8c7958$export$ddc5a4cb751fae27 = (workspaceId, tokenID)=>`${(0, (0, parcelRequire("klJ8b")).getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${tokenID}`;
    const $5d534e44ee8c7958$export$591d877d695dbd95 = (workspaceId)=>`${(0, (0, parcelRequire("klJ8b")).getCmdbRestBaseUrl)(workspaceId)}/data-manager/token`;
    const $5d534e44ee8c7958$export$1dd01c50c7948938 = (workspaceId)=>`${$5d534e44ee8c7958$var$getAirtrackAppRestBaseUrl(workspaceId)}/config/sync/provisioningstatus`;
    const $5d534e44ee8c7958$var$getAirtrackAppRestBaseUrl = (workspaceId)=>`/gateway/api/jsm/data-manager/workspace/${workspaceId}/app`;
});
parcelRegister("axmNY", function(module, exports) {
    $parcel$export(module.exports, "fetchDataManagerTokens", ()=>$7c2d95880f7fa57e$export$c6b3de84befa4259);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $8OEkP;
    const $7c2d95880f7fa57e$export$c6b3de84befa4259 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            const state = getState();
            if (state.dataManager.tokensLoading) return;
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    tokensLoading: true
                }
            });
            try {
                const tokenDetails = await (0, (0, parcelRequire("eusud")).performGetRequest)((0, (0, parcelRequire("8OEkP")).getDataManagerFetchContainerTokenUrl)(workspaceId));
                setState({
                    dataManager: {
                        ...state.dataManager,
                        tokensData: tokenDetails.tokens,
                        tokensLoading: false
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchDataManagerTokens succeeded');
            } catch (error) {
                setState({
                    ...state,
                    dataManager: {
                        ...state.dataManager,
                        tokensLoading: false,
                        tokensError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchDataManagerTokens',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("j9kxm", function(module, exports) {
    $parcel$export(module.exports, "updateDataManagerRole", ()=>$4b933e04f7b1c1e3$export$314337b594e79a51);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $Zsxbh;
    const $4b933e04f7b1c1e3$export$93aad6482f82f57d = 5000;
    const $4b933e04f7b1c1e3$export$214f23982cabf5f8 = 1000;
    const $4b933e04f7b1c1e3$export$314337b594e79a51 = ({ principalIds: principalIds, roleId: roleId })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            const state = getState();
            if (state.dataManager.rolesUpdateLoading) return;
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesUpdateLoading: true
                }
            });
            try {
                const requestBody = {
                    principalIds: principalIds,
                    roleId: roleId,
                    resourceType: 'workspace'
                };
                const updateRolesResponse = await (0, (0, parcelRequire("eusud")).performPutRequest)((0, (0, parcelRequire("Zsxbh")).getCmdbPermsRoleAssignmentUrl)(workspaceId), {
                    body: JSON.stringify(requestBody)
                });
                const pollTimeoutTime = new Date(Date.now() + $4b933e04f7b1c1e3$export$93aad6482f82f57d).getTime();
                const tryPollTokenStatus = async (resolve, reject)=>{
                    if (Date.now() > pollTimeoutTime) {
                        reject(new Error('Some role assignments have failed or is still in progress'));
                        return;
                    }
                    try {
                        const url = (0, (0, parcelRequire("Zsxbh")).getCmdbPermsTokenStatusUrl)(workspaceId, updateRolesResponse.tokens[updateRolesResponse.tokens.length - 1]);
                        const updateRoleAssignmentToken = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
                        if (updateRoleAssignmentToken.isSuccessful) {
                            resolve();
                            return;
                        }
                        setTimeout(()=>{
                            tryPollTokenStatus(resolve, reject);
                        }, $4b933e04f7b1c1e3$export$214f23982cabf5f8);
                    } catch (e) {
                        setTimeout(()=>{
                            tryPollTokenStatus(resolve, reject);
                        }, $4b933e04f7b1c1e3$export$214f23982cabf5f8);
                    }
                };
                await new Promise((res, rej)=>tryPollTokenStatus(res, rej));
                setState({
                    ...state,
                    dataManager: {
                        ...state.dataManager,
                        rolesUpdateLoading: false
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'updateDataManagerRole succeeded');
            } catch (error) {
                setState({
                    ...state,
                    dataManager: {
                        ...state.dataManager,
                        rolesUpdateLoading: false,
                        rolesUpdateError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'updateDataManagerRole',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("yPoOn", function(module, exports) {
    $parcel$export(module.exports, "setIcon", ()=>$95e73dfa2b8a3d46$export$33914de34c28be6c);
    $parcel$export(module.exports, "updateIcon", ()=>$95e73dfa2b8a3d46$export$89ea7ff652eb14dd);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $3jFL4;
    const $95e73dfa2b8a3d46$export$33914de34c28be6c = (updatedIcon)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            const updatedData = state.icons.data?.map((icon)=>icon.id === updatedIcon.id ? updatedIcon : icon);
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    data: updatedData
                }
            });
        };
    const $95e73dfa2b8a3d46$export$89ea7ff652eb14dd = ({ iconId: iconId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            const state = getState();
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    updateLoading: true
                }
            });
            try {
                const response = await (0, (0, parcelRequire("eusud")).performPutRequest)((0, (0, parcelRequire("3jFL4")).getCmdbIconByIdUrl)(workspaceId, iconId), {
                    body: JSON.stringify(updatedProperties)
                });
                const updatedState = getState();
                const updatedData = updatedState.icons.data?.map((icon)=>icon.id === response.id ? response : icon);
                setState({
                    ...updatedState,
                    icons: {
                        ...updatedState.icons,
                        updateLoading: false,
                        data: updatedData
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'updateIcon succeeded');
            } catch (error) {
                const updatedState = getState();
                setState({
                    ...updatedState,
                    icons: {
                        ...updatedState.icons,
                        updateLoading: false,
                        updateError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'updateIcon',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("akTZj", function(module, exports) {
    $parcel$export(module.exports, "updateProvisioningStatus", ()=>$d823977f3c28c840$export$ae3c5292a85a06f4);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $8OEkP;
    const $d823977f3c28c840$export$ae3c5292a85a06f4 = ({ isEnabled: isEnabled })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            const state = getState();
            if (state.dataManager.provisioningUpdateLoading) return;
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    isProvisioned: isEnabled,
                    provisioningUpdateLoading: true
                }
            });
            try {
                const requestBody = {
                    enabled: isEnabled
                };
                await (0, (0, parcelRequire("eusud")).performPutRequest)((0, (0, parcelRequire("8OEkP")).getDataManagerProvisioningStatusUrl)(workspaceId), {
                    body: JSON.stringify(requestBody)
                });
                const result = await (0, (0, parcelRequire("eusud")).performGetRequest)((0, (0, parcelRequire("8OEkP")).getDataManagerProvisioningStatusUrl)(workspaceId));
                setState({
                    ...state,
                    dataManager: {
                        ...state.dataManager,
                        isProvisioned: result.enabled === 'ON',
                        provisioningUpdateLoading: false
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'updateProvisioningStatus succeeded');
            } catch (error) {
                setState({
                    ...state,
                    dataManager: {
                        ...state.dataManager,
                        provisioningUpdateLoading: false,
                        provisioningUpdateError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'updateProvisioningStatus',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("czU2t", function(module, exports) {
    $parcel$export(module.exports, "setReferenceType", ()=>$d89b12ad155fa4aa$export$7c6efce0302318d);
    $parcel$export(module.exports, "updateReferenceType", ()=>$d89b12ad155fa4aa$export$f9e29a0f21a33136);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $Zsxbh;
    const $d89b12ad155fa4aa$export$7c6efce0302318d = (updatedReferenceType)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            const updatedData = state.referenceTypes.data?.map((referenceType)=>referenceType.id === updatedReferenceType.id ? updatedReferenceType : referenceType);
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    data: updatedData
                }
            });
        };
    const $d89b12ad155fa4aa$export$f9e29a0f21a33136 = ({ referenceTypeId: referenceTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            const state = getState();
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    updateLoading: true
                }
            });
            try {
                const response = await (0, (0, parcelRequire("eusud")).performPutRequest)((0, (0, parcelRequire("Zsxbh")).getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceTypeId), {
                    body: JSON.stringify({
                        ...updatedProperties,
                        color: updatedProperties.color !== undefined ? updatedProperties.color.replace('#', '') : undefined
                    })
                });
                const updatedState = getState();
                const updatedData = updatedState.referenceTypes.data?.map((referenceType)=>referenceType.id === response.id ? response : referenceType);
                setState({
                    ...updatedState,
                    referenceTypes: {
                        ...updatedState.referenceTypes,
                        updateLoading: false,
                        data: updatedData || undefined
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'updateReferenceType succeeded');
            } catch (error) {
                const updatedState = getState();
                setState({
                    ...updatedState,
                    referenceTypes: {
                        ...updatedState.referenceTypes,
                        updateLoading: false,
                        updateError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'updateReferenceType',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("lsHFw", function(module, exports) {
    $parcel$export(module.exports, "setStatusType", ()=>$800507e86f7d8a8e$export$80a24939e43be67c);
    $parcel$export(module.exports, "updateStatusType", ()=>$800507e86f7d8a8e$export$2174575c3f57e8f8);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $Zsxbh;
    const $800507e86f7d8a8e$export$80a24939e43be67c = (updatedStatusType)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            const updatedData = state.statusTypes.data?.map((statusType)=>statusType.id === updatedStatusType.id ? updatedStatusType : statusType);
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    data: updatedData
                }
            });
        };
    const $800507e86f7d8a8e$export$2174575c3f57e8f8 = ({ statusTypeId: statusTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
            const state = getState();
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    updateLoading: true
                }
            });
            try {
                const response = await (0, (0, parcelRequire("eusud")).performPutRequest)((0, (0, parcelRequire("Zsxbh")).getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusTypeId), {
                    body: JSON.stringify(updatedProperties)
                });
                const updatedState = getState();
                const updatedData = updatedState.statusTypes.data?.map((statusType)=>statusType.id === response.id ? response : statusType);
                setState({
                    ...updatedState,
                    statusTypes: {
                        ...updatedState.statusTypes,
                        updateLoading: false,
                        data: updatedData || undefined
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'updateStatusType succeeded');
            } catch (error) {
                const updatedState = getState();
                setState({
                    ...updatedState,
                    statusTypes: {
                        ...updatedState.statusTypes,
                        updateLoading: false,
                        updateError: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'updateStatusType',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("3SYcN", function(module, exports) {
    $parcel$export(module.exports, "sortReferenceTypes", ()=>$52d2d568421769f9$export$7e55dd84e7cc0829);
    $parcel$export(module.exports, "sortStatusTypes", ()=>$52d2d568421769f9$export$5f25bb3183b5823d);
    const $52d2d568421769f9$export$7e55dd84e7cc0829 = (referenceTypes)=>referenceTypes.sort((a, b)=>a.name.localeCompare(b.name)).sort((a, b)=>{
            if (a.removable === b.removable) return 0;
            return a.removable ? 1 : -1;
        });
    const $52d2d568421769f9$export$5f25bb3183b5823d = (statusTypes)=>statusTypes.sort((a, b)=>a.name.localeCompare(b.name));
});
parcelRegister("kT9FG", function(module, exports) {
    $parcel$export(module.exports, "AssetsMenu", ()=>$68b59dd7ae4cb0b4$export$a578a9f5b9517a27);
    $parcel$export(module.exports, "AssetsSingleMenuItem", ()=>$68b59dd7ae4cb0b4$export$252d7ffe38b4e8ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $4R6GH;
    var $koVbs;
    var $jecJ3;
    var $jhS4y;
    var $46Cti;
    var $c16H2;
    var $5FnJJ;
    var $dQbFB;
    var $eQV8d;
    var $dUyqZ;
    var $eKq7N;
    var $j8qoE;
    var $blEB6;
    var $cNd4s;
    var $lnznH;
    var $cZa9B;
    var $iHwh4;
    var $tKTx3;
    var $2Wh2X;
    var $8Hhya;
    function $68b59dd7ae4cb0b4$export$a578a9f5b9517a27({ isExpanded: isExpanded }) {
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS);
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        const [{ config: config, dataManager: dataManager, loading: loading }, { fetchGlobalConfig: fetchGlobalConfig, fetchProvisioningStatus: fetchProvisioningStatus, fetchMyDataManagerRoles: fetchMyDataManagerRoles }] = (0, (0, parcelRequire("j8qoE")).useInsightGlobalConfig)();
        const fetchAssetsConfig = (0, $5uXOq.useCallback)(async ()=>{
            fetchGlobalConfig(false);
            fetchProvisioningStatus(false);
            fetchMyDataManagerRoles(false);
        }, [
            fetchGlobalConfig,
            fetchMyDataManagerRoles,
            fetchProvisioningStatus
        ]);
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: menuId,
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) sendSectionItemAnalyticsEvent({
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS,
                    sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_ASSETS)
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            elemBefore: icon,
            actionsOnHover: (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Hhya")).SectionActions), {
                isInsightAdministrator: config?.insightAdministrator
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Hhya")).SectionActionsOld), {
                isInsightAdministrator: config?.insightAdministrator
            }),
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId),
            onClick: (_e, _a, { isExpanded: hasExpanded })=>{
                if (hasExpanded) sendSectionItemAnalyticsEvent({
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS,
                    sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_ASSETS)
                });
            }
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Wh2X")).HeaderSchemasMenuItems), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eKq7N")).L1ExpandableMenuItemSubmenu), {
            fetch: fetchAssetsConfig,
            isFetching: loading || dataManager.provisioningLoading || dataManager.myRolesLoading,
            MenuItems: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHwh4")).AssetsMenuItems), {
                    dataManagerIsProvisioned: dataManager.isProvisioned,
                    dataManagerMyRoles: dataManager.myRoles,
                    isSiteAdmin: isSiteAdmin,
                    insightAdministrator: config?.insightAdministrator,
                    insightReporting: config?.insightReporting
                }),
            skeletonCount: 2
        })));
    }
    const $68b59dd7ae4cb0b4$export$252d7ffe38b4e8ef = ({ showUpsellLozenge: showUpsellLozenge = false })=>{
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            onClick: ()=>{
                sendSectionItemAnalyticsEvent({
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS,
                    sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_ASSETS)
                });
            },
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS),
            elemBefore: icon,
            href: (0, (0, parcelRequire("blEB6")).getLandingPageUrl)(),
            actionsOnHover: (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Hhya")).SectionActions), {
                isInsightAdministrator: false
            }) : null
        }, `${formattedMessage} `, showUpsellLozenge && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-menu.upsell-lozenge",
            appearance: "new"
        }, formatMessage((0, (0, parcelRequire("tKTx3")).default).upsellLozengeText)));
    };
});
parcelRegister("eQV8d", function(module, exports) {
    $parcel$export(module.exports, "useSectionItemAnalytics", ()=>$209417640a04fcbd$export$88869d054e1fb00a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jecJ3;
    var $8zOmE;
    var $2NMNM;
    var $iszzG;
    const $209417640a04fcbd$export$ee0f05907a733e87 = ({ sectionItem: sectionItem, menuId: menuId, moreMenuIds: moreMenuIds })=>{
        if (sectionItem === (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_CUSTOMIZE_SIDEBAR)) return moreMenuIds.length !== 0;
        if (menuId) return moreMenuIds.includes(menuId);
        return false;
    };
    function $209417640a04fcbd$export$88869d054e1fb00a() {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iszzG")).NavItemsContext));
        const sendSectionItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ menuId: menuId, sectionItem: sectionItem })=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            });
            const isInMore = $209417640a04fcbd$export$ee0f05907a733e87({
                sectionItem: sectionItem,
                menuId: menuId,
                moreMenuIds: moreMenuIds
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, sectionItem, {
                isInMore: isInMore
            });
        }, [
            createAnalyticsEvent,
            moreMenuIds
        ]);
        return sendSectionItemAnalyticsEvent;
    }
});
parcelRegister("eKq7N", function(module, exports) {
    $parcel$export(module.exports, "L1ExpandableMenuItemSubmenu", ()=>$791f4f5cc9cec4d6$export$a0d95f81c9ddf0e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5qw5u;
    const $791f4f5cc9cec4d6$export$a0d95f81c9ddf0e9 = (props)=>{
        const { fetch: fetch, Footer: Footer, isFetching: isFetching, MenuItems: MenuItems, skeletonCount: skeletonCount } = props;
        const expandableMenuItems = (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItems, null);
        const expandableFooter = Footer && (0, ($parcel$interopDefault($5uXOq))).createElement(Footer, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5qw5u")).ExpandableMenuItemSubmenu), {
            fetch: fetch,
            footer: expandableFooter,
            isFetching: isFetching,
            menuItems: expandableMenuItems,
            skeletonCount: skeletonCount
        });
    };
});
parcelRegister("5qw5u", function(module, exports) {
    $parcel$export(module.exports, "ExpandableMenuItemSubmenu", ()=>$71e5e00939216601$export$216998a85b3335a2);
    var $5uXOq = parcelRequire("5uXOq");
    var $et13M;
    var $1oZ5x;
    var $338xa;
    const $71e5e00939216601$export$216998a85b3335a2 = (props)=>{
        const { fetch: fetchMaybe, footer: footer, isFetching: isFetchingMaybe, menuItems: menuItems, skeletonCount: skeletonCount } = props;
        const { isFetching: isFetching, fetch: fetch } = (0, (0, parcelRequire("1oZ5x")).useFetchActual)(isFetchingMaybe, fetchMaybe);
        const isExpanded = (0, (0, parcelRequire("et13M")).useIsExpanded)();
        (0, $5uXOq.useEffect)(()=>{
            if (isExpanded && !isFetching) fetch();
        }, [
            isExpanded,
            fetch
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isFetching ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), {
            count: skeletonCount
        }) : menuItems, footer);
    };
});
parcelRegister("1oZ5x", function(module, exports) {
    $parcel$export(module.exports, "useFetchActual", ()=>$e36b0174fdde90f4$export$49f3bd519990bec7);
    var $5uXOq = parcelRequire("5uXOq");
    const $e36b0174fdde90f4$export$49f3bd519990bec7 = (isFetchingMaybe, fetchMaybe)=>{
        const [isFetching, setIsFetching] = (0, $5uXOq.useState)(false);
        const fetch = (0, $5uXOq.useCallback)(async ()=>{
            if (!fetchMaybe) return;
            setIsFetching(true);
            try {
                await fetchMaybe();
            } finally{
                setIsFetching(false);
            }
        }, [
            fetchMaybe,
            setIsFetching
        ]);
        return {
            isFetching: !!isFetchingMaybe || isFetching,
            fetch: fetch
        };
    };
});
parcelRegister("blEB6", function(module, exports) {
    $parcel$export(module.exports, "isInsightRoute", ()=>$587a2dd53fdae2e8$export$296d80f3ce129968);
    $parcel$export(module.exports, "getCreateServiceUrl", ()=>$587a2dd53fdae2e8$export$1f9b8b558a361aaf);
    $parcel$export(module.exports, "getRootPath", ()=>$587a2dd53fdae2e8$export$5413f45d031c7806);
    $parcel$export(module.exports, "getLandingPageUrl", ()=>$587a2dd53fdae2e8$export$9366da5a373815e5);
    $parcel$export(module.exports, "getGlobalConfigUrl", ()=>$587a2dd53fdae2e8$export$20fd4a0aec335970);
    $parcel$export(module.exports, "getDataManagerUrl", ()=>$587a2dd53fdae2e8$export$c9b27b0d2e19d52f);
    $parcel$export(module.exports, "getDataManagerAdaptersUrl", ()=>$587a2dd53fdae2e8$export$cd6b35373ba077a);
    $parcel$export(module.exports, "getAssetsReportsUrl", ()=>$587a2dd53fdae2e8$export$c1909404b7ea317f);
    $parcel$export(module.exports, "createObjectSchemasUrl", ()=>$587a2dd53fdae2e8$export$c48ea1282c74411e);
    $parcel$export(module.exports, "createObjectSchemaUrl", ()=>$587a2dd53fdae2e8$export$3a0332e980fe56cf);
    $parcel$export(module.exports, "createObjectTypeUrl", ()=>$587a2dd53fdae2e8$export$cfefb90cfb86b528);
    $parcel$export(module.exports, "createObjectSchemaConfigUrl", ()=>$587a2dd53fdae2e8$export$f02479149ce3cac7);
    $parcel$export(module.exports, "createObjectDetailUrl", ()=>$587a2dd53fdae2e8$export$51e4229f2c7d3866);
    $parcel$export(module.exports, "createObjectTypeSettingsUrl", ()=>$587a2dd53fdae2e8$export$4b4b7d2c3df4fa58);
    $parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", ()=>$587a2dd53fdae2e8$export$c1790fa8f0d8e89a);
    $parcel$export(module.exports, "getFeatureUsagePageUrl", ()=>$587a2dd53fdae2e8$export$5ba89eed0cf60033);
    $parcel$export(module.exports, "getFeatureUsageVirtualAgentPageUrl", ()=>$587a2dd53fdae2e8$export$415502b49e27270d);
    var $9PhlU;
    const $587a2dd53fdae2e8$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
    const $587a2dd53fdae2e8$export$c90f45511b7ccc85 = '/jira/servicedesk/assets';
    const $587a2dd53fdae2e8$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
    const $587a2dd53fdae2e8$export$296d80f3ce129968 = (pathname)=>pathname.includes($587a2dd53fdae2e8$export$6d7574dbda22cf7);
    const $587a2dd53fdae2e8$export$1f9b8b558a361aaf = ()=>$587a2dd53fdae2e8$export$ee637ecb2dfa4f6a;
    const $587a2dd53fdae2e8$export$5413f45d031c7806 = ()=>$587a2dd53fdae2e8$export$c90f45511b7ccc85;
    const $587a2dd53fdae2e8$export$9366da5a373815e5 = ()=>$587a2dd53fdae2e8$export$5413f45d031c7806();
    const $587a2dd53fdae2e8$export$20fd4a0aec335970 = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/global`;
    const $587a2dd53fdae2e8$export$c9b27b0d2e19d52f = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/data-manager/`;
    const $587a2dd53fdae2e8$export$cd6b35373ba077a = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/data-manager/adapters/`;
    const $587a2dd53fdae2e8$export$c1909404b7ea317f = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/reports`;
    const $587a2dd53fdae2e8$export$c48ea1282c74411e = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object-schemas`;
    const $587a2dd53fdae2e8$export$3a0332e980fe56cf = (objectSchemaId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
    const $587a2dd53fdae2e8$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$587a2dd53fdae2e8$export$3a0332e980fe56cf(objectSchemaId)}?${(0, (0, parcelRequire("9PhlU")).SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
    const $587a2dd53fdae2e8$export$f02479149ce3cac7 = (objectSchemaId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
    const $587a2dd53fdae2e8$export$51e4229f2c7d3866 = (objectId)=>`${$587a2dd53fdae2e8$export$c90f45511b7ccc85}/object/${objectId}`;
    const $587a2dd53fdae2e8$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
    const $587a2dd53fdae2e8$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$587a2dd53fdae2e8$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
    const $587a2dd53fdae2e8$export$5ba89eed0cf60033 = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=assets${showChangeLimitModal ? '&changeLimit=true' : ''}`;
    const $587a2dd53fdae2e8$export$415502b49e27270d = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=virtual-agent${showChangeLimitModal ? '&changeLimit=true' : ''}`;
});
parcelRegister("9PhlU", function(module, exports) {
    $parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", ()=>$dee65df3d835c7b2$export$a73deb42718b5c4);
    $parcel$export(module.exports, "TAB_QUERY_PARAM_REFERENCE_TYPES", ()=>$dee65df3d835c7b2$export$f7855185bab37329);
    $parcel$export(module.exports, "TAB_QUERY_PARAM_STATUSES", ()=>$dee65df3d835c7b2$export$3739ebbc7c6e87e8);
    $parcel$export(module.exports, "TAB_QUERY_PARAM_ICONS", ()=>$dee65df3d835c7b2$export$2c22dc6c729ae0bd);
    $parcel$export(module.exports, "TAB_QUERY_PARAM_DATA_MANAGER", ()=>$dee65df3d835c7b2$export$f37b3a97acf56eaf);
    $parcel$export(module.exports, "TAB_QUERY_PARAM_GENERAL", ()=>$dee65df3d835c7b2$export$12ebb1d5017e1d6d);
    $parcel$export(module.exports, "TAB_QUERY_PARAM_ROLES", ()=>$dee65df3d835c7b2$export$a77734d9ea30fe44);
    $parcel$export(module.exports, "TAB_QUERY_PARAM_IMPORT", ()=>$dee65df3d835c7b2$export$be37b820df30c947);
    $parcel$export(module.exports, "TAB_QUERY_PARAM_INHERITANCE", ()=>$dee65df3d835c7b2$export$670faa8ae93e0903);
    $parcel$export(module.exports, "useUpdateQueryParams", ()=>$dee65df3d835c7b2$export$e66acc5f4583ce1c);
    $parcel$export(module.exports, "useObjectTypeIdQueryParam", ()=>$dee65df3d835c7b2$export$f5a33d51dd6de08);
    $parcel$export(module.exports, "useObjectIdQueryParam", ()=>$dee65df3d835c7b2$export$a6e3187c87554a1e);
    $parcel$export(module.exports, "useSchemaViewModeQueryParam", ()=>$dee65df3d835c7b2$export$6abda0ad26022eff);
    $parcel$export(module.exports, "useObjectViewModeQueryParam", ()=>$dee65df3d835c7b2$export$1927b50f7d074492);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $5Ny9E;
    var $ieDtd;
    var $doZTA;
    var $lVJAU;
    const $dee65df3d835c7b2$export$a73deb42718b5c4 = {
        schemaMode: 'mode',
        objectViewMode: 'view',
        objectTypeId: 'typeId',
        fallbackObjectTypeId: 'objecttypeid',
        objectId: 'objectId'
    };
    const $dee65df3d835c7b2$export$f7855185bab37329 = 'reference-types';
    const $dee65df3d835c7b2$export$3739ebbc7c6e87e8 = 'statuses';
    const $dee65df3d835c7b2$export$2c22dc6c729ae0bd = 'icons';
    const $dee65df3d835c7b2$export$f37b3a97acf56eaf = 'data-manager';
    const $dee65df3d835c7b2$export$12ebb1d5017e1d6d = 'general';
    const $dee65df3d835c7b2$export$a77734d9ea30fe44 = 'roles';
    const $dee65df3d835c7b2$export$be37b820df30c947 = 'import';
    const $dee65df3d835c7b2$export$670faa8ae93e0903 = 'inheritance';
    const $dee65df3d835c7b2$export$e66acc5f4583ce1c = ()=>{
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const [{ location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const updateQueryParams = (0, $5uXOq.useCallback)((queryParams = {})=>{
            const { pathname: pathname, search: search } = location;
            const updatedQueryParams = {};
            Object.keys(queryParams).forEach((key)=>{
                updatedQueryParams[key] = queryParams[key] ?? undefined;
            });
            return `${pathname}?${(0, ($parcel$interopDefault($ebyGx))).stringify({
                ...(0, ($parcel$interopDefault($ebyGx))).parse(search),
                ...updatedQueryParams
            })}`;
        }, [
            location
        ]);
        const pushRouterAction = (0, $5uXOq.useCallback)((path)=>{
            push(path);
        }, [
            push
        ]);
        return [
            {
                updateQueryParams: updateQueryParams,
                pushRouterAction: pushRouterAction
            }
        ];
    };
    const $dee65df3d835c7b2$export$f5a33d51dd6de08 = ()=>{
        const [objectTypeId, setObjectTypeId] = (0, (0, parcelRequire("ieDtd")).useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectTypeId);
        const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, (0, parcelRequire("ieDtd")).useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.fallbackObjectTypeId);
        (0, $5uXOq.useEffect)(()=>{
            if (fallbackObjectTypeId !== undefined) {
                setObjectTypeId((0, (0, parcelRequire("5Ny9E")).toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
                setFallbackObjectTypeId(undefined, 'replace');
            }
        }, [
            fallbackObjectTypeId,
            setObjectTypeId,
            setFallbackObjectTypeId
        ]);
        const nullableMain = objectTypeId !== undefined ? (0, (0, parcelRequire("5Ny9E")).toCmdbObjectTypeId)(objectTypeId) : null;
        const nullableFallback = fallbackObjectTypeId !== undefined ? (0, (0, parcelRequire("5Ny9E")).toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
        const setter = (newObjectTypeId, updateType)=>{
            setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
        };
        return [
            nullableMain !== null ? nullableMain : nullableFallback,
            setter
        ];
    };
    const $dee65df3d835c7b2$export$a6e3187c87554a1e = ()=>{
        const [objectId, setObjectId] = (0, (0, parcelRequire("ieDtd")).useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectId);
        const nullableObjectId = objectId !== undefined ? (0, (0, parcelRequire("5Ny9E")).toCmdbObjectId)(objectId) : null;
        const setter = (newObjectId, updateType)=>{
            setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
        };
        return [
            nullableObjectId,
            setter
        ];
    };
    const $dee65df3d835c7b2$export$6abda0ad26022eff = ()=>{
        const [rawParamValue, setSchemaMode] = (0, (0, parcelRequire("ieDtd")).useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.schemaMode);
        const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
        return [
            schemaMode,
            setSchemaMode
        ];
    };
    const $dee65df3d835c7b2$export$1927b50f7d074492 = ()=>{
        const [rawParamValue, setObjectViewMode] = (0, (0, parcelRequire("ieDtd")).useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectViewMode);
        const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
        const setter = (newValue, updateMode)=>{
            setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
        };
        return [
            objectViewMode,
            setter
        ];
    };
});
parcelRegister("iHwh4", function(module, exports) {
    $parcel$export(module.exports, "AssetsMenuItems", ()=>$a72239a654789f48$export$eca9d73b7de13f6a);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $cfud7;
    var $jRK4a;
    var $3aBrO;
    var $cyPK0;
    const $a72239a654789f48$export$eca9d73b7de13f6a = ({ dataManagerIsProvisioned: dataManagerIsProvisioned, dataManagerMyRoles: dataManagerMyRoles, isSiteAdmin: isSiteAdmin, insightAdministrator: insightAdministrator, insightReporting: insightReporting })=>{
        const showDataManagerLink = (0, $5uXOq.useCallback)(()=>{
            if (dataManagerIsProvisioned && dataManagerMyRoles) {
                const hasDMRoles = dataManagerMyRoles.some((myRole)=>(0, (0, parcelRequire("cfud7")).DATA_MANAGER_ROLES).includes(myRole));
                const hasAdapterRoles = dataManagerMyRoles.some((myRole)=>(0, (0, parcelRequire("cfud7")).DATA_MANAGER_ADAPTERS_ROLES).includes(myRole));
                if (hasDMRoles) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3aBrO")).DataManagerMenuItems), null);
                if (hasAdapterRoles) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jRK4a")).DataManagerAdapterMenuItems), null);
            }
        }, [
            dataManagerIsProvisioned,
            dataManagerMyRoles
        ]);
        const isInsightReportsEnabled = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("co1wz")).ff)('jsm-assets-reporting_seqk0') && (isSiteAdmin || insightAdministrator) && insightReporting, [
            insightAdministrator,
            insightReporting,
            isSiteAdmin
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isInsightReportsEnabled() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cyPK0")).ReportsMenuItem), null), showDataManagerLink());
    };
});
parcelRegister("cfud7", function(module, exports) {
    $parcel$export(module.exports, "DATA_MANAGER_ADMIN", ()=>$b7b7b13be4edcaed$export$48abe9ccfdd98170);
    $parcel$export(module.exports, "DATA_MANAGER_REPORT_VIEWER", ()=>$b7b7b13be4edcaed$export$8939b849d295aa4c);
    $parcel$export(module.exports, "DATA_MANAGER_REPORT_EDITOR", ()=>$b7b7b13be4edcaed$export$4ca2081d195ddbdb);
    $parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ADMIN", ()=>$b7b7b13be4edcaed$export$4c3d5fe6bdc107f1);
    $parcel$export(module.exports, "DATA_MANAGER_ROLES", ()=>$b7b7b13be4edcaed$export$48703faa5030b273);
    $parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ROLES", ()=>$b7b7b13be4edcaed$export$8b2dfd13f5f35ee4);
    $parcel$export(module.exports, "ORDERED_ASSETS_DATA_MANAGER_ROLES", ()=>$b7b7b13be4edcaed$export$1d276f65230af2e);
    const $b7b7b13be4edcaed$export$48abe9ccfdd98170 = 'ari:cloud:cmdb::role/airtrack/admin';
    const $b7b7b13be4edcaed$export$8939b849d295aa4c = 'ari:cloud:cmdb::role/airtrack/report-viewer';
    const $b7b7b13be4edcaed$export$4ca2081d195ddbdb = 'ari:cloud:cmdb::role/airtrack/report-editor';
    const $b7b7b13be4edcaed$export$4c3d5fe6bdc107f1 = 'ari:cloud:cmdb::role/airtrack-buoy/admin';
    const $b7b7b13be4edcaed$export$48703faa5030b273 = [
        $b7b7b13be4edcaed$export$48abe9ccfdd98170,
        $b7b7b13be4edcaed$export$8939b849d295aa4c,
        $b7b7b13be4edcaed$export$4ca2081d195ddbdb
    ];
    const $b7b7b13be4edcaed$export$8b2dfd13f5f35ee4 = [
        $b7b7b13be4edcaed$export$4c3d5fe6bdc107f1
    ];
    const $b7b7b13be4edcaed$export$1d276f65230af2e = [
        $b7b7b13be4edcaed$export$48abe9ccfdd98170,
        $b7b7b13be4edcaed$export$4c3d5fe6bdc107f1,
        $b7b7b13be4edcaed$export$4ca2081d195ddbdb,
        $b7b7b13be4edcaed$export$8939b849d295aa4c
    ];
});
parcelRegister("jRK4a", function(module, exports) {
    $parcel$export(module.exports, "DataManagerAdapterMenuItems", ()=>$34fbfe3fa95e91ec$export$f74d67a8d693b664);
    var $5uXOq = parcelRequire("5uXOq");
    var $9Xmvg;
    var $koVbs;
    var $24a2m;
    var $c0oSL;
    var $blEB6;
    var $eMAVw;
    var $isEeX;
    var $i1on6;
    const $34fbfe3fa95e91ec$export$f74d67a8d693b664 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { icon: formattedAdapterIcon } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("i1on6")).default).jsmAssetsDataManagerAdapters, (0, (0, parcelRequire("c0oSL")).DataManagerAdaptersGlyph));
        const { icon: formattedOpenIcon } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("i1on6")).default).jsmAssetsOpenDataManager, (0, ($parcel$interopDefault((0, parcelRequire("9Xmvg"))))));
        const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, (0, parcelRequire("isEeX")).useAssetsUIAnalytics)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMAVw")).MenuLinkItem), {
            elemBefore: formattedAdapterIcon,
            elemAfter: formattedOpenIcon,
            href: (0, (0, parcelRequire("blEB6")).getDataManagerAdaptersUrl)(),
            target: "_blank",
            onClick: ()=>fireUINavigationItemAnalytics((0, $496585bee7985bb9$export$ee52916f9ebd8000))
        }, formatMessage((0, (0, parcelRequire("i1on6")).default).jsmAssetsDataManagerAdapters));
    };
});
parcelRegister("9Xmvg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $73fb14674561f421$var$_react = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $73fb14674561f421$var$_arrowUpRight = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("3sGLB")));
    var $73fb14674561f421$var$_open = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("1FouZ")));
    function $73fb14674561f421$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $73fb14674561f421$var$ArrowUpRightIcon = (props)=>$73fb14674561f421$var$_react.default.createElement($73fb14674561f421$var$_arrowUpRight.default, Object.assign({
            LEGACY_fallbackIcon: $73fb14674561f421$var$_open.default
        }, props));
    $73fb14674561f421$var$ArrowUpRightIcon.Name = 'ArrowUpRightIconMigration';
    var $73fb14674561f421$var$_default = module.exports.default = $73fb14674561f421$var$ArrowUpRightIcon;
});
const $496585bee7985bb9$export$f06dfcec5ff912e = 'meatballDropdown';
const $496585bee7985bb9$export$7ae7abcf2c19d3e5 = 'removeFromStarred';
const $496585bee7985bb9$export$78fd0bd637fe1684 = 'addToStarred';
const $496585bee7985bb9$export$c540230986f848f6 = 'addPeople';
const $496585bee7985bb9$export$3cc9ab700c406a19 = 'projectSettings';
const $496585bee7985bb9$export$dc23a793cf9e9de8 = 'archiveProject';
const $496585bee7985bb9$export$a68d619e7022f2c3 = 'deleteBoard';
const $496585bee7985bb9$export$22748439827110a4 = 'deleteProject';
const $496585bee7985bb9$export$192d610b0b7719f4 = 'boardSettings';
const $496585bee7985bb9$export$a65812b4aab631bb = 'alertSettings';
const $496585bee7985bb9$export$ca6db12118be69a1 = 'schemas';
const $496585bee7985bb9$export$f2eca6cf19c9a973 = 'reports';
const $496585bee7985bb9$export$147264622218a553 = 'dataManager';
const $496585bee7985bb9$export$ee52916f9ebd8000 = 'adapters';
const $496585bee7985bb9$export$83d40997eb7cc5b7 = 'assetsGlobalConfiguration';
const $496585bee7985bb9$export$5c09fa42f8d45ed8 = 'dismissRecommendation';
const $496585bee7985bb9$export$de9ad1ebeca97ec1 = 'newDiscoveryProject';
const $496585bee7985bb9$export$27e4092edca7bb97 = 'jwmSampleProject';
const $496585bee7985bb9$export$ce0bea1467165424 = 'whyAmISeeingThis';
parcelRegister("c0oSL", function(module, exports) {
    $parcel$export(module.exports, "DataManagerAdaptersGlyph", ()=>$1cdb3cd51030e227$export$cff497901afe8164);
    $parcel$export(module.exports, "DataManagerLink", ()=>$1cdb3cd51030e227$export$905e681c1cad3de);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $5LWLA;
    var $dC5iT;
    var $8CUq3;
    var $hDzhb;
    const $1cdb3cd51030e227$export$fb5ad6208dd8d5f1 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM7.5 17.5C7.5 18.0523 7.05228 18.5 6.5 18.5C5.94772 18.5 5.5 18.0523 5.5 17.5C5.5 16.9477 5.94772 16.5 6.5 16.5C7.05228 16.5 7.5 16.9477 7.5 17.5ZM18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11C18.0523 11 18.5 11.4477 18.5 12ZM8.88555 7.25C8.56698 8.26428 7.61941 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.61941 4 8.56698 4.73572 8.88555 5.75H10.5523C11.697 5.75 12.625 6.67797 12.625 7.82267V11.25H14.5H15.1145C15.433 10.2357 16.3806 9.5 17.5 9.5C18.8807 9.5 20 10.6193 20 12C20 13.3807 18.8807 14.5 17.5 14.5C16.3806 14.5 15.433 13.7643 15.1145 12.75H14.5H12.625V16.1773C12.625 17.322 11.697 18.25 10.5523 18.25H8.88555C8.56698 19.2643 7.61941 20 6.5 20C5.11929 20 4 18.8807 4 17.5C4 16.1193 5.11929 15 6.5 15C7.61941 15 8.56698 15.7357 8.88555 16.75H10.5523C10.8686 16.75 11.125 16.4936 11.125 16.1773V12.75V12V11.25V7.82267C11.125 7.50639 10.8686 7.25 10.5523 7.25H8.88555Z",
            fill: "#44546F"
        }));
    const $1cdb3cd51030e227$export$cff497901afe8164 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip0_2374_102539)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M10.5076 15.8019C10.8212 16.0862 11 16.4898 11 16.913V18.5H13V16.913C13 16.4898 13.1788 16.0862 13.4924 15.8019L16.5 13.0745V9.5H7.5V13.0745L10.5076 15.8019ZM6 13.7391V9C6 8.44771 6.44772 8 7 8H17C17.5523 8 18 8.44772 18 9V13.7391L14.5 16.913V19C14.5 19.5523 14.0523 20 13.5 20H10.5C9.94772 20 9.5 19.5523 9.5 19V16.913L6 13.7391Z",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M9 9L9 4L10.5 4V9H9Z",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M13.5 9V4L15 4V9H13.5Z",
            fill: "currentColor"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0_2374_102539"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "currentColor"
        }))));
    const $1cdb3cd51030e227$export$905e681c1cad3de = ({ children: children, onClick: onClick, testId: testId, to: to, app: app })=>{
        const getIcon = ()=>{
            if (app === 'data-manager') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                glyph: $1cdb3cd51030e227$export$fb5ad6208dd8d5f1,
                label: "Data manager icon",
                size: "medium"
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                glyph: $1cdb3cd51030e227$export$cff497901afe8164,
                label: "Adapters icon",
                size: "medium"
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1cdb3cd51030e227$var$wrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            href: to,
            component: (0, (0, parcelRequire("hDzhb")).default),
            appearance: "subtle",
            iconBefore: getIcon(),
            testId: testId,
            onClick: (event, analyticsEvent)=>{
                onClick?.(analyticsEvent);
            },
            target: "_blank"
        }, children));
    };
    const $1cdb3cd51030e227$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({});
});
parcelRegister("isEeX", function(module, exports) {
    $parcel$export(module.exports, "useAssetsUIAnalytics", ()=>$9e3bbdcdefd1cee6$export$2eb4a7a38c92c87f);
    var $5uXOq = parcelRequire("5uXOq");
    var $ivGSs;
    var $jhS4y;
    var $8zOmE;
    var $2NMNM;
    const $9e3bbdcdefd1cee6$export$2eb4a7a38c92c87f = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireUINavigationItemAnalytics = (0, $5uXOq.useCallback)((analyticsItemId)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            }), (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS], {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: analyticsItemId
            });
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireUINavigationItemAnalytics: fireUINavigationItemAnalytics
        };
    };
});
parcelRegister("i1on6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43eab5367bedc66d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $43eab5367bedc66d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        jsmAssetsDataManagerAdapters: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-data-manager-adapters",
            "defaultMessage": "Adapters"
        },
        jsmAssetsOpenDataManager: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-open-data-manager",
            "defaultMessage": "Open data manager"
        }
    });
});
parcelRegister("3aBrO", function(module, exports) {
    $parcel$export(module.exports, "DataManagerMenuItems", ()=>$be611fc140bff39d$export$34300598ca712097);
    var $5uXOq = parcelRequire("5uXOq");
    var $9Xmvg;
    var $la5Q6;
    var $koVbs;
    var $24a2m;
    var $blEB6;
    var $eMAVw;
    var $isEeX;
    var $drPTS;
    const $be611fc140bff39d$export$34300598ca712097 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { icon: formattedOpenIcon } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("drPTS")).default).jsmAssetsOpenDataManager, (0, ($parcel$interopDefault((0, parcelRequire("9Xmvg"))))));
        const { icon: formattedDataManagerIcon } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("drPTS")).default).jsmAssetsDataManager, (0, (0, parcelRequire("la5Q6")).default));
        const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, (0, parcelRequire("isEeX")).useAssetsUIAnalytics)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMAVw")).MenuLinkItem), {
            elemBefore: formattedDataManagerIcon,
            elemAfter: formattedOpenIcon,
            href: (0, (0, parcelRequire("blEB6")).getDataManagerUrl)(),
            target: "_blank",
            onClick: ()=>fireUINavigationItemAnalytics((0, $496585bee7985bb9$export$147264622218a553))
        }, formatMessage((0, (0, parcelRequire("drPTS")).default).jsmAssetsDataManager));
    };
});
parcelRegister("la5Q6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb221b5381fce3c6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $fb221b5381fce3c6$var$JSMAssetsDataManagerGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label']
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM8.88555 7.25C8.56698 8.26428 7.61941 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.61941 4 8.56698 4.73572 8.88555 5.75H10.5523C11.697 5.75 12.625 6.67797 12.625 7.82267V8.5V11.25H14.5H15.1145C15.433 10.2357 16.3806 9.5 17.5 9.5C18.8807 9.5 20 10.6193 20 12C20 13.3807 18.8807 14.5 17.5 14.5C16.3806 14.5 15.433 13.7643 15.1145 12.75H14.5H12.625V15.5V16.1773C12.625 17.322 11.697 18.25 10.5523 18.25H8.88555C8.56698 19.2643 7.61941 20 6.5 20C5.11929 20 4 18.8807 4 17.5C4 16.1193 5.11929 15 6.5 15C7.61941 15 8.56698 15.7357 8.88555 16.75H10.5523C10.8686 16.75 11.125 16.4936 11.125 16.1773V15.5V12.75V12V11.25V8.5V7.82267C11.125 7.50639 10.8686 7.25 10.5523 7.25H8.88555ZM6.5 18.5C7.05228 18.5 7.5 18.0523 7.5 17.5C7.5 16.9477 7.05228 16.5 6.5 16.5C5.94772 16.5 5.5 16.9477 5.5 17.5C5.5 18.0523 5.94772 18.5 6.5 18.5ZM18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11C18.0523 11 18.5 11.4477 18.5 12Z",
            fill: "currentColor"
        }));
    const $fb221b5381fce3c6$var$JSMAssetsDataManagerIcon = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            ...props,
            glyph: $fb221b5381fce3c6$var$JSMAssetsDataManagerGlyph
        });
    var $fb221b5381fce3c6$export$2e2bcd8739ae039 = $fb221b5381fce3c6$var$JSMAssetsDataManagerIcon;
});
parcelRegister("drPTS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0bef7773ffc3fd68$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0bef7773ffc3fd68$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        jsmAssetsDataManager: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.jsm-assets-data-manager",
            "defaultMessage": "Data manager"
        },
        jsmAssetsOpenDataManager: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.jsm-assets-open-data-manager",
            "defaultMessage": "Open data manager"
        }
    });
});
parcelRegister("cyPK0", function(module, exports) {
    $parcel$export(module.exports, "ReportsMenuItem", ()=>$ebc6899836d65f8e$export$156f96ce3bb16879);
    var $5uXOq = parcelRequire("5uXOq");
    var $fDskX;
    var $koVbs;
    var $jhS4y;
    var $5FnJJ;
    var $blEB6;
    var $isEeX;
    var $4UvDQ;
    const $ebc6899836d65f8e$export$156f96ce3bb16879 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const reportsLink = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("blEB6")).getAssetsReportsUrl)(), []);
        const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, (0, parcelRequire("isEeX")).useAssetsUIAnalytics)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fDskX"))))), {
                label: formatMessage((0, (0, parcelRequire("4UvDQ")).default).jsmAssetsReports),
                color: "currentColor",
                spacing: "spacious"
            }),
            href: reportsLink,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_REPORTS),
            onClick: ()=>fireUINavigationItemAnalytics((0, $496585bee7985bb9$export$f2eca6cf19c9a973))
        }, formatMessage((0, (0, parcelRequire("4UvDQ")).default).jsmAssetsReports));
    };
});
parcelRegister("fDskX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b6207aa8debd29f4$var$_react = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b6207aa8debd29f4$var$_baseNew = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $b6207aa8debd29f4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b6207aa8debd29f4$var$ChartBarIcon = (props)=>$b6207aa8debd29f4$var$_react.default.createElement($b6207aa8debd29f4$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.917 9.75H1.75V13c0 .69.56 1.25 1.25 1.25h2.917m0-4.5v4.5m0-4.5v-4h4.166m-4.166 8.5h4.166m0-8.5v-4h4.167V13c0 .69-.56 1.25-1.25 1.25h-2.917m0-8.5v8.5"/>`
        }, props));
    $b6207aa8debd29f4$var$ChartBarIcon.displayName = 'ChartBarIcon';
    var $b6207aa8debd29f4$var$_default = module.exports.default = $b6207aa8debd29f4$var$ChartBarIcon;
});
parcelRegister("4UvDQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$884cac664127c061$export$2e2bcd8739ae039);
    var $7VHMR;
    var $884cac664127c061$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        jsmAssetsReports: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.reports.jsm-assets-reports",
            "defaultMessage": "Reports"
        }
    });
});
parcelRegister("tKTx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aac539a54eaf043d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $aac539a54eaf043d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        upsellLozengeText: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.upsell-lozenge-text",
            "defaultMessage": "Premium"
        }
    });
});
parcelRegister("2Wh2X", function(module, exports) {
    $parcel$export(module.exports, "HeaderSchemasMenuItems", ()=>$77dfa228afe7bffb$export$7243359973253e5);
    var $5uXOq = parcelRequire("5uXOq");
    var $er8sA;
    var $koVbs;
    var $jhS4y;
    var $5FnJJ;
    var $24a2m;
    var $blEB6;
    var $isEeX;
    var $aGzpx;
    const $77dfa228afe7bffb$export$7243359973253e5 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const schemasLink = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("blEB6")).getLandingPageUrl)(), []);
        const { icon: formattedSchemasIcon } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("aGzpx")).default).jsmAssetsSchemas, (0, (0, parcelRequire("er8sA")).default));
        const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, (0, parcelRequire("isEeX")).useAssetsUIAnalytics)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_SCHEMAS),
            elemBefore: formattedSchemasIcon,
            href: schemasLink,
            onClick: ()=>fireUINavigationItemAnalytics((0, $496585bee7985bb9$export$ca6db12118be69a1))
        }, formatMessage((0, (0, parcelRequire("aGzpx")).default).jsmAssetsSchemas));
    };
});
parcelRegister("er8sA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53e65d8c0991a293$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $53e65d8c0991a293$var$JSMAssetsSchemasGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label']
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M7.5 7.5C8.05228 7.5 8.5 7.05228 8.5 6.5C8.5 5.94772 8.05228 5.5 7.5 5.5C6.94772 5.5 6.5 5.94772 6.5 6.5C6.5 7.05228 6.94772 7.5 7.5 7.5ZM10 6.5C10 7.61941 9.26428 8.56698 8.25 8.88555V10.5H14.1145C14.433 9.48572 15.3806 8.75 16.5 8.75C17.8807 8.75 19 9.86929 19 11.25C19 12.6307 17.8807 13.75 16.5 13.75C15.3806 13.75 14.433 13.0143 14.1145 12H8.25V16.25C8.25 16.6642 8.58579 17 9 17H14.05C14.2816 15.8589 15.2905 15 16.5 15C17.8807 15 19 16.1193 19 17.5C19 18.8807 17.8807 20 16.5 20C15.4748 20 14.5938 19.383 14.208 18.5H9C7.75736 18.5 6.75 17.4926 6.75 16.25V12V10.5V8.88555C5.73572 8.56698 5 7.61941 5 6.5C5 5.11929 6.11929 4 7.5 4C8.88071 4 10 5.11929 10 6.5ZM16.5 18.5C17.0523 18.5 17.5 18.0523 17.5 17.5C17.5 16.9477 17.0523 16.5 16.5 16.5C15.9477 16.5 15.5 16.9477 15.5 17.5C15.5 18.0523 15.9477 18.5 16.5 18.5ZM17.5 11.25C17.5 11.8023 17.0523 12.25 16.5 12.25C15.9477 12.25 15.5 11.8023 15.5 11.25C15.5 10.6977 15.9477 10.25 16.5 10.25C17.0523 10.25 17.5 10.6977 17.5 11.25Z",
            fill: "currentColor"
        }));
    const $53e65d8c0991a293$var$JSMAssetsSchemasIcon = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            ...props,
            glyph: $53e65d8c0991a293$var$JSMAssetsSchemasGlyph
        });
    var $53e65d8c0991a293$export$2e2bcd8739ae039 = $53e65d8c0991a293$var$JSMAssetsSchemasIcon;
});
parcelRegister("aGzpx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bfefc3311594219e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bfefc3311594219e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        jsmAssetsSchemas: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.schemas.jsm-assets-schemas",
            "defaultMessage": "Schemas"
        }
    });
});
parcelRegister("8Hhya", function(module, exports) {
    $parcel$export(module.exports, "SectionActionsOld", ()=>$cad83d2e8a58ef00$export$ec501e49f758b69);
    $parcel$export(module.exports, "SectionActions", ()=>$cad83d2e8a58ef00$export$51f8029abf8c56ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $epOG5;
    var $3Z96c;
    var $9UCCQ;
    var $f5TWP;
    var $koVbs;
    var $jecJ3;
    var $ivGSs;
    var $jhS4y;
    var $46Cti;
    var $9eeFp;
    var $eaKdt;
    var $aCS3f;
    var $8zOmE;
    var $2NMNM;
    var $blEB6;
    var $bwEvZ;
    function $cad83d2e8a58ef00$export$ec501e49f758b69({ onClose: onClose, isInsightAdministrator: isInsightAdministrator }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onOpen = ()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS], {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
            });
        };
        return isInsightAdministrator && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            MenuItems: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($cad83d2e8a58ef00$var$MoreMenuItemsOld, props),
            onClose: onClose,
            onOpen: ()=>onOpen()
        });
    }
    function $cad83d2e8a58ef00$var$MoreMenuItemsOld({ onClose: onClose }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const configLink = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("blEB6")).getGlobalConfigUrl)(), []);
        const onCloseWithStopPropagation = (0, (0, parcelRequire("9eeFp")).useStopPropagation)(onClose);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClick = (e)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'dropdownItem'
            }), (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS], {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$74712b62056d422e),
                parentItemId: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_ASSETS),
                itemId: (0, $496585bee7985bb9$export$83d40997eb7cc5b7)
            });
            onCloseWithStopPropagation(e);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            href: configLink,
            onClick: (e)=>onClick(e)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            space: "space.050"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("epOG5"))))), {
            label: formatMessage((0, (0, parcelRequire("bwEvZ")).default).jsmAssetsSettingsIcon),
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }), formatMessage((0, (0, parcelRequire("bwEvZ")).default).jsmAssetsGlobalConfiguration)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaKdt")).HideL1MenuItemSection), {
            menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS
        }));
    }
    function $cad83d2e8a58ef00$export$51f8029abf8c56ce({ onClose: onClose, isInsightAdministrator: isInsightAdministrator = false }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onOpen = ()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            }), (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS], {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            MenuItems: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($cad83d2e8a58ef00$var$MoreMenuItems, {
                    ...props,
                    isInsightAdministrator: isInsightAdministrator
                }),
            onClose: onClose,
            onOpen: ()=>onOpen()
        });
    }
    function $cad83d2e8a58ef00$var$MoreMenuItems({ onClose: onClose, isInsightAdministrator: isInsightAdministrator = false }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const configLink = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("blEB6")).getGlobalConfigUrl)(), []);
        const onCloseWithStopPropagation = (0, (0, parcelRequire("9eeFp")).useStopPropagation)(onClose);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClick = (e)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'dropdownItem'
            }), (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS], {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$74712b62056d422e),
                parentItemId: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_ASSETS),
                itemId: (0, $496585bee7985bb9$export$83d40997eb7cc5b7)
            });
            onCloseWithStopPropagation(e);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isInsightAdministrator ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            href: configLink,
            onClick: (e)=>onClick(e)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            space: "space.050"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("epOG5"))))), {
            label: formatMessage((0, (0, parcelRequire("bwEvZ")).default).jsmAssetsSettingsIcon),
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }), formatMessage((0, (0, parcelRequire("bwEvZ")).default).jsmAssetsGlobalConfiguration)))) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaKdt")).HideL1MenuItemSection), {
            menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS
        }));
    }
});
parcelRegister("bwEvZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41b3b3b94f3d9484$export$2e2bcd8739ae039);
    var $7VHMR;
    var $41b3b3b94f3d9484$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        jsmAssetsGlobalConfiguration: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.section-actions.jsm-assets-global-configuration",
            "defaultMessage": "General configuration"
        },
        jsmAssetsSettingsIcon: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.section-actions.jsm-assets-settings-icon",
            "defaultMessage": "Settings"
        }
    });
});
parcelRegister("aXxBX", function(module, exports) {
    $parcel$export(module.exports, "CustomerService", ()=>$a426b2d854204abe$export$5c26f0ffd7a4820d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $6oVYF;
    const $a426b2d854204abe$export$5c26f0ffd7a4820d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "assets",
            packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCustomerService",
            teamName: "Boysenberry"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6oVYF")).CustomerServiceMenuLinkItem), null));
});
parcelRegister("6oVYF", function(module, exports) {
    $parcel$export(module.exports, "CustomerServiceMenuLinkItem", ()=>$f06b8199f1c8d83f$export$276375fee74f0f11);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZUJu;
    var $jhS4y;
    var $46Cti;
    var $5FnJJ;
    var $dUyqZ;
    var $eaKdt;
    var $aCS3f;
    const $f06b8199f1c8d83f$export$208752a9164e5a6d = '/jira/helpcenter';
    const $f06b8199f1c8d83f$export$276375fee74f0f11 = ()=>{
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).CUSTOMER_SERVICE);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            testId: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.ui.sidenav-customer-service",
            href: $f06b8199f1c8d83f$export$208752a9164e5a6d,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_CUSTOMER_SERVICE),
            elemBefore: icon,
            actionsOnHover: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
                MenuItems: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaKdt")).HideL1MenuItemSection), {
                        menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_CUSTOMER_SERVICE),
                        hasSeparator: false
                    }))
            })
        }, formattedMessage);
    };
});
parcelRegister("kcmzD", function(module, exports) {
    $parcel$export(module.exports, "Nav4Dashboards", ()=>$66938623734b1b6f$export$14aa7c6c8f362b5b);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $ahfXZ;
    var $l8ruj;
    const $66938623734b1b6f$export$14aa7c6c8f362b5b = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-dashboards"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "dashboards-section",
            packageName: (0, $ddbe4b334e21c7a1$export$b8b9d90f9e5bd72b),
            teamName: (0, $ddbe4b334e21c7a1$export$d57b6b390e78d90f)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ahfXZ")).Nav4DashboardsContainer), props)));
});
parcelRegister("ahfXZ", function(module, exports) {
    $parcel$export(module.exports, "Nav4DashboardsContainer", ()=>$a67ed45d3a5ce5eb$export$c38d702ef7d1445a);
    var $6VGRt;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jhS4y;
    var $c6x3L;
    var $ayvjE;
    var $4T7De;
    var $6MFxN;
    var $8urqk;
    function $a67ed45d3a5ce5eb$export$c38d702ef7d1445a(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6MFxN")).AnalyticContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement($a67ed45d3a5ce5eb$export$14aa7c6c8f362b5b, props));
    }
    function $a67ed45d3a5ce5eb$export$14aa7c6c8f362b5b({ isExpanded: isExpanded, queryRef: queryRef }) {
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("6VGRt")).default), queryRef);
        const { isInitialSelectedPath: isInitialSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const actionButtons = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ayvjE")).ActionButtons), null), []);
        return isInitialSelectedPath((0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS)) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4T7De")).DashboardsForLanding), {
            actionsOnHover: actionButtons,
            isExpanded: isExpanded,
            queryRef: data
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8urqk")).DashboardsDefault), {
            actionsOnHover: actionButtons,
            isExpanded: isExpanded
        });
    }
});
parcelRegister("6VGRt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee3a2c33f1248058$export$2e2bcd8739ae039);
    const $ee3a2c33f1248058$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDashboardsExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Dashboards",
        "selections": [
            {
                "condition": "isDashboardsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "DashboardsForLanding"
                    }
                ]
            }
        ],
        "type": "Query"
    };
    $ee3a2c33f1248058$var$node.hash = "2e119493f66f19ce0159f3d471966250";
    var $ee3a2c33f1248058$export$2e2bcd8739ae039 = $ee3a2c33f1248058$var$node;
});
parcelRegister("ayvjE", function(module, exports) {
    $parcel$export(module.exports, "ActionButtons", ()=>$feeebb4436f3de85$export$88c65d2d98aab183);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIWbq;
    var $eZUJu;
    var $3bDjY;
    var $Mp6qH;
    var $65Ltd;
    var $jgE05;
    var $koVbs;
    var $46Cti;
    var $1xonH;
    var $eaKdt;
    var $aCS3f;
    var $6jY6G;
    var $e9QkH;
    var $9VXkC;
    var $lVJAU;
    var $6MFxN;
    var $kg2u4;
    function $feeebb4436f3de85$export$88c65d2d98aab183() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [, { off: modalClose }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("Mp6qH")).MODAL_ID).DASHBOARD_CREATE);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { path: path } = (0, (0, parcelRequire("6jY6G")).useRouteByName)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_EDIT)) ?? {};
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const onSuccess = (0, $5uXOq.useCallback)((_, { id: id })=>{
            path && push((0, (0, parcelRequire("9VXkC")).generatePath)(path, {
                dashboardId: id
            }));
            setIsOpen(false);
            modalClose();
        }, [
            modalClose,
            path,
            push
        ]);
        const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6MFxN")).AnalyticContext));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgE05")).default), {
            onSuccess: onSuccess,
            onCancel: ()=>{
                setIsOpen(false);
                modalClose();
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("kg2u4")).default).createDashboard)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xonH")).CommonNavMenuButton), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("dIWbq"))))),
            label: formatMessage((0, (0, parcelRequire("kg2u4")).default).createDashboard),
            onClick: ()=>{
                fireUIAnalyticForFixButton({
                    itemId: (0, $ddbe4b334e21c7a1$export$7be02fe416808d26)
                });
                setIsOpen(true);
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            onOpen: ()=>fireUIAnalyticForFixButton({
                    itemId: (0, $ddbe4b334e21c7a1$export$f06dfcec5ff912e)
                }),
            MenuItems: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaKdt")).HideL1MenuItemSection), {
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS,
                    hasSeparator: false
                }))
        }));
    }
});
parcelRegister("Mp6qH", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$d722fd8ef23adae6$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "DEFAULT_LOAD_COUNT_FAV", ()=>$d722fd8ef23adae6$export$ea341e6cc435ed40);
    $parcel$export(module.exports, "DEFAULT_LOAD_COUNT_VIEWED", ()=>$d722fd8ef23adae6$export$cb66c02d110b1531);
    $parcel$export(module.exports, "DEFAULT_LOAD_COUNT_RECENT", ()=>$d722fd8ef23adae6$export$22ea57e66775a6b2);
    $parcel$export(module.exports, "TOP_LEVEL_ERROR_BOUNDARY_ID", ()=>$d722fd8ef23adae6$export$4766f0c4b6fe35dc);
    $parcel$export(module.exports, "NAVIGATION_ITEM_ID", ()=>$d722fd8ef23adae6$export$1a9b265c626e9d44);
    $parcel$export(module.exports, "MODAL_ID", ()=>$d722fd8ef23adae6$export$ebdd5a8e5b1c2de5);
    $parcel$export(module.exports, "PROFILE_SPOTLIGHT_KEY", ()=>$d722fd8ef23adae6$export$6037915bf3452cf3);
    $parcel$export(module.exports, "HELP_SPOTLIGHT_KEY", ()=>$d722fd8ef23adae6$export$286c2faa2103eb9c);
    $parcel$export(module.exports, "SEARCH_SPOTLIGHT_KEY", ()=>$d722fd8ef23adae6$export$c0d6ac131d4391b9);
    $parcel$export(module.exports, "PROJECTS_SPOTLIGHT_KEY", ()=>$d722fd8ef23adae6$export$8d9442dfaec4086f);
    $parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MAIN", ()=>$d722fd8ef23adae6$export$3014c5ec440d8824);
    $parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MENU", ()=>$d722fd8ef23adae6$export$69cbedccc0df48);
    $parcel$export(module.exports, "YOUR_WORK_DROPDOWN_TAB_ID", ()=>$d722fd8ef23adae6$export$1935aad1d702494c);
    $parcel$export(module.exports, "JSW_TMP_BACKLOG_BOARD_REGEXP", ()=>$d722fd8ef23adae6$export$cc578bc72d7a7308);
    const $d722fd8ef23adae6$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
    const $d722fd8ef23adae6$export$ea341e6cc435ed40 = 15;
    const $d722fd8ef23adae6$export$8666f31c8873bff = 10;
    const $d722fd8ef23adae6$export$cb66c02d110b1531 = 10;
    const $d722fd8ef23adae6$export$22ea57e66775a6b2 = 5;
    const $d722fd8ef23adae6$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
    const $d722fd8ef23adae6$export$1a9b265c626e9d44 = {
        ADDONS: 'apps',
        CREATE: 'createIssue',
        APP_SWITCHER: 'atlassianSwitcher',
        DASHBOARDS: 'dashboards',
        FILTERS: 'filters',
        HELP: 'help',
        HELP_BADGE: 'helpBadge',
        HOME: 'home',
        INSIGHT: 'insight',
        LOGO: 'productLogo',
        NOTIFICATIONS: 'notifications',
        PEOPLE: 'people',
        PLANS: 'plans',
        PROFILE: 'profile',
        PROJECTS: 'projects',
        ROADMAPS: 'roadmaps',
        SEARCH: 'search',
        SERVICE_HUB: 'services',
        SETTINGS: 'settings',
        SIGN_IN: 'signIn',
        YOUR_WORK_DROPDOWN: 'yourWorkDropdown',
        CONVERSATION_ASSISTANT: 'conversationAssistant',
        ROVO_DEMAND_TESTS: 'rovoDemandTests'
    };
    const $d722fd8ef23adae6$export$ebdd5a8e5b1c2de5 = {
        DASHBOARD_CREATE: 'DASHBOARD_CREATE',
        KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
        PROJECT_CREATE: 'PROJECT_CREATE'
    };
    const $d722fd8ef23adae6$export$6037915bf3452cf3 = 'profile-spotlight';
    const $d722fd8ef23adae6$export$286c2faa2103eb9c = 'help-spotlight';
    const $d722fd8ef23adae6$export$c0d6ac131d4391b9 = 'search-spotlight';
    const $d722fd8ef23adae6$export$8d9442dfaec4086f = 'projects-spotlight';
    const $d722fd8ef23adae6$export$3014c5ec440d8824 = 'viewAtlassianNavigation';
    const $d722fd8ef23adae6$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
    const $d722fd8ef23adae6$export$1935aad1d702494c = {
        RECENT: 'RECENT',
        BOARDS: 'BOARDS',
        QUEUES: 'QUEUES',
        ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
        ADD_FILTER: 'ADD_FILTER',
        ALERTS: 'ALERTS'
    };
    const $d722fd8ef23adae6$export$bbaa49b5be375ff3 = 3;
    const $d722fd8ef23adae6$export$cc578bc72d7a7308 = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;
    const $d722fd8ef23adae6$export$9b8f5a607ecb9c5c = 'com.atlassian.jira.slack';
});
parcelRegister("jgE05", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$927aeb284ed7a228$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $927aeb284ed7a228$var$AsyncCreateDashboardModal = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("gxI7R")), {
        moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/create-dashboard-modal/src/index.tsx"
    });
    const $927aeb284ed7a228$var$AsyncCreateDashboardModalContainer = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "create-dashboard-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($927aeb284ed7a228$var$AsyncCreateDashboardModal, props));
    var $927aeb284ed7a228$export$2e2bcd8739ae039 = $927aeb284ed7a228$var$AsyncCreateDashboardModalContainer;
});
parcelRegister("gxI7R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("8bdSJ")
    ]).then(()=>parcelRequire('eTZZm'));
});
parcelRegister("e9QkH", function(module, exports) {
    $parcel$export(module.exports, "useSwitchModals", ()=>$bbe85969245206f0$export$5ed4b99cbad4ebd6);
    var $2qauD;
    const { useSwitch: $bbe85969245206f0$var$useSwitch } = (0, (0, parcelRequire("2qauD")).createSwitchController)('jira-switch-modals');
    const $bbe85969245206f0$export$5ed4b99cbad4ebd6 = $bbe85969245206f0$var$useSwitch;
});
parcelRegister("2qauD", function(module, exports) {
    $parcel$export(module.exports, "createSwitchController", ()=>$a539fc33301c42ee$export$1856548326159ec8);
    var $5uXOq = parcelRequire("5uXOq");
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $a539fc33301c42ee$export$1856548326159ec8 = (name, activeByDefault)=>{
        const actions = {
            on: (active)=>({ setState: setState })=>setState({
                        active: active
                    }),
            off: (active)=>({ setState: setState, getState: getState })=>{
                    if (getState().active === active || active === undefined) setState({
                        active: undefined
                    });
                },
            toggle: (active)=>({ getState: getState, dispatch: dispatch })=>{
                    if (getState().active === active) dispatch(actions.off(active));
                    else dispatch(actions.on(active));
                }
        };
        const initialState = {
            active: activeByDefault
        };
        const store = (0, (0, parcelRequire("iXqE5")).createStore)({
            name: name,
            initialState: initialState,
            actions: actions
        });
        const SwitchContainer = (0, (0, parcelRequire("gg7kZ")).createContainer)(store);
        const selector = (state, key)=>state.active === key;
        const useSwitchInternal = (0, (0, parcelRequire("3sQ5x")).createHook)(store, {
            selector: selector
        });
        const useSwitch = (active)=>{
            const [isActive, { on: onSwitch, off: offSwitch, toggle: toggleSwitch }] = useSwitchInternal(active);
            const on = (0, $5uXOq.useCallback)(()=>onSwitch(active), [
                onSwitch,
                active
            ]);
            const off = (0, $5uXOq.useCallback)(()=>offSwitch(active), [
                active,
                offSwitch
            ]);
            const toggle = (0, $5uXOq.useCallback)(()=>toggleSwitch(active), [
                toggleSwitch,
                active
            ]);
            return [
                isActive,
                {
                    on: on,
                    off: off,
                    toggle: toggle
                }
            ];
        };
        return {
            SwitchContainer: SwitchContainer,
            useSwitch: useSwitch
        };
    };
});
const $ddbe4b334e21c7a1$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Dashboards';
const $ddbe4b334e21c7a1$export$d57b6b390e78d90f = 'jira-cosmos';
const $ddbe4b334e21c7a1$export$65b778215f917c60 = 'viewAllDashboards';
const $ddbe4b334e21c7a1$export$7be02fe416808d26 = 'createDashboard';
const $ddbe4b334e21c7a1$export$f06dfcec5ff912e = 'meatballDropdown';
parcelRegister("6MFxN", function(module, exports) {
    $parcel$export(module.exports, "AnalyticContext", ()=>$12282e91517b56b8$export$da0556bf821b3494);
    $parcel$export(module.exports, "AnalyticContextProvider", ()=>$12282e91517b56b8$export$aea8e3edcdec81e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $ivGSs;
    var $jhS4y;
    var $8zOmE;
    var $2NMNM;
    const $12282e91517b56b8$export$da0556bf821b3494 = (0, $5uXOq.createContext)({
        fireUIAnalyticForFixMenuItem: (0, ($parcel$interopDefault($8Rkzz))),
        fireUIAnalyticForFixButton: (0, ($parcel$interopDefault($8Rkzz))),
        fireUIAnalyticForFavouriteToggle: (0, ($parcel$interopDefault($8Rkzz))),
        fireUIAnalyticForDashboardItems: (0, ($parcel$interopDefault($8Rkzz)))
    });
    const $12282e91517b56b8$export$aea8e3edcdec81e3 = ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireUIAnalyticForFixMenuItem = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS],
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    itemId: (0, $ddbe4b334e21c7a1$export$65b778215f917c60)
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        const fireUIAnalyticForFixButton = (0, $5uXOq.useCallback)(({ itemId: itemId })=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS],
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    itemId: itemId
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        const fireUIAnalyticForFavouriteToggle = (0, $5uXOq.useCallback)(({ starType: starType, parentItemId: parentItemId })=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS],
                attributes: {
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    componentType: (0, $1e554a683893bd46$export$74712b62056d422e),
                    parentItemId: parentItemId,
                    parentItemType: 'dashboard',
                    itemId: starType
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        const fireUIAnalyticForDashboardItems = (0, $5uXOq.useCallback)(({ itemId: itemId, section: section })=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS],
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                    itemType: (0, $632bd8725b437a12$export$4695c1a423ffe431).toLowerCase(),
                    itemId: itemId,
                    section: section
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($12282e91517b56b8$export$da0556bf821b3494.Provider, {
            value: {
                fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem,
                fireUIAnalyticForFixButton: fireUIAnalyticForFixButton,
                fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle,
                fireUIAnalyticForDashboardItems: fireUIAnalyticForDashboardItems
            }
        }, children);
    };
});
parcelRegister("kg2u4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0357cb1b75baecf6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0357cb1b75baecf6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createDashboard: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.action-buttons.create-dashboard",
            "defaultMessage": "Create dashboard"
        }
    });
});
parcelRegister("4T7De", function(module, exports) {
    $parcel$export(module.exports, "DashboardsForLanding", ()=>$2b77df430d27538f$export$9d244eb54dd88e31);
    var $bDntd;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $7CMCs;
    var $jecJ3;
    var $jhS4y;
    var $46Cti;
    var $c16H2;
    var $dQbFB;
    var $eQV8d;
    var $dUyqZ;
    var $2tacr;
    var $l8ruj;
    var $lnznH;
    var $cZa9B;
    var $ehnIE;
    function $2b77df430d27538f$export$9d244eb54dd88e31(props) {
        const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS);
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("bDntd")).default), queryRef);
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: menuId,
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) sendSectionItemAnalyticsEvent({
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS,
                    sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_DASHBOARDS)
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-dashboards-landing"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "nav4-sidebar-dashboards-landing",
            packageName: (0, $ddbe4b334e21c7a1$export$b8b9d90f9e5bd72b),
            teamName: (0, $ddbe4b334e21c7a1$export$d57b6b390e78d90f),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2tacr")).DashboardsContent), {
            queryRef: data
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehnIE")).Footer), null)));
    }
});
parcelRegister("bDntd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee6f11a49b583e6d$export$2e2bcd8739ae039);
    const $ee6f11a49b583e6d$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "DashboardsForLanding",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "DashboardsContent"
            }
        ],
        "type": "Query"
    };
    $ee6f11a49b583e6d$var$node.hash = "dd61fd6f70c88177a5fb6eaf5e8295b9";
    var $ee6f11a49b583e6d$export$2e2bcd8739ae039 = $ee6f11a49b583e6d$var$node;
});
parcelRegister("2tacr", function(module, exports) {
    $parcel$export(module.exports, "DashboardsContent", ()=>$980b1272be7fd89e$export$439bb78193b2b442);
    var $g1V1N;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $koVbs;
    var $jhS4y;
    var $c6x3L;
    var $9Gyp5;
    var $5FnJJ;
    var $gxbcq;
    var $1b6zA;
    var $hjTAj;
    var $afcwS;
    var $iE0sN;
    var $koeKL;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    var $2CQvU;
    var $1deEY;
    const $980b1272be7fd89e$var$MAX_RECENT_PROJECTS = 5;
    const $980b1272be7fd89e$var$MAX_FAVORITE_PROJECTS = 15;
    const $980b1272be7fd89e$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
    function $980b1272be7fd89e$export$439bb78193b2b442({ queryRef: queryRef }) {
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { isSelectedPath: isSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const { getStableItems: getStableItems } = (0, (0, parcelRequire("1b6zA")).useStableItems)();
        const [{ jira: { dashboardFavourites: dashboardFavourites, dashboardRecents: dashboardRecents } }, refetch] = (0, $8Uumt.useRefetchableFragment)((0, (0, parcelRequire("g1V1N")).default), queryRef);
        (0, (0, parcelRequire("9Gyp5")).useRefetchWhenIsSelected)({
            cloudId: cloudId,
            isSelectedPath: isSelectedPath,
            QUERY: (0, parcelRequire("iE0sN")).default,
            refetch: refetch,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS)
        });
        const refetchOnChange = (0, $5uXOq.useCallback)(({ onComplete: onComplete })=>{
            refetch({
                cloudId: cloudId
            }, {
                fetchPolicy: 'store-and-network',
                onComplete: onComplete
            });
        }, [
            cloudId,
            refetch
        ]);
        (0, (0, parcelRequire("gxbcq")).useSubscribeAndUpdateFavorites)({
            entityTypename: 'JiraDashboard',
            favouriteConnectionId: dashboardFavourites.__id,
            recentConnectionId: dashboardRecents.__id,
            refetch: refetchOnChange
        });
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const starred = formatMessage((0, (0, parcelRequire("1deEY")).default).starred);
        const recent = formatMessage((0, (0, parcelRequire("1deEY")).default).recent);
        const favorites = (0, $5uXOq.useMemo)(()=>{
            const ids = dashboardFavourites.edges?.map((edge)=>edge?.node.id).filter(Boolean) ?? [];
            const list = dashboardFavourites.edges?.filter(Boolean).map((edge)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hjTAj")).DashboardMenuItem), {
                    key: edge.node.dashboardId,
                    queryRef: edge.node
                })) ?? [];
            return {
                idSet: new Set(ids),
                list: list.slice(0, $980b1272be7fd89e$var$MAX_FAVORITE_PROJECTS),
                hasItems: Boolean(list.length),
                hasNextPage: dashboardFavourites?.pageInfo?.hasNextPage || list.length > $980b1272be7fd89e$var$MAX_FAVORITE_PROJECTS
            };
        }, [
            dashboardFavourites
        ]);
        const recentItems = (0, $5uXOq.useMemo)(()=>{
            const nodes = dashboardRecents.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, $980b1272be7fd89e$var$MAX_RECENT_PROJECTS) || [];
            const stableOrderedNodes = getStableItems({
                nodes: nodes,
                idKey: 'id'
            });
            const list = stableOrderedNodes.map((node)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hjTAj")).DashboardMenuItem), {
                    key: node.dashboardId,
                    queryRef: node
                }));
            return {
                list: list,
                hasItems: Boolean(list.length)
            };
        }, [
            dashboardRecents.edges,
            favorites.idSet,
            getStableItems
        ]);
        if (!favorites.hasItems && !recentItems.hasItems) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("afcwS")).DashboardsEmptyContent), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, favorites.hasItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CQvU")).MenuSectionHeading), null, starred), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, favorites.list))), favorites.hasNextPage && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            href: $980b1272be7fd89e$var$VIEW_ALL_STARRED_HREF,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS_VIEW_ALL_STARRED)
        }, formatMessage((0, (0, parcelRequire("1deEY")).default).viewAllStarred))), recentItems.hasItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CQvU")).MenuSectionHeading), null, recent), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, recentItems.list))));
    }
});
parcelRegister("g1V1N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c69b9c9d27d137b1$export$2e2bcd8739ae039);
    var $iE0sN;
    const $c69b9c9d27d137b1$var$node = function() {
        var v0 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v1 = {
            "kind": "ScalarField",
            "name": "id"
        }, v2 = {
            "kind": "ScalarField",
            "name": "dashboardId"
        }, v3 = {
            "kind": "FragmentSpread",
            "name": "DashboardMenuItem"
        }, v4 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "cloudId"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "currentURL"
                }
            ],
            "kind": "Fragment",
            "metadata": {
                "refetch": {
                    "fragmentPathInResult": [],
                    "operation": (0, (0, parcelRequire("iE0sN")).default)
                }
            },
            "name": "DashboardsContent",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "dashboardFavourites",
                                    "args": [
                                        v0,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "DASHBOARD"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v1,
                                                                        "action": "THROW",
                                                                        "path": "jira.dashboardFavourites.edges.node.id"
                                                                    },
                                                                    v2,
                                                                    v3
                                                                ],
                                                                "type": "JiraDashboard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.dashboardFavourites.edges.node"
                                                }
                                            ]
                                        },
                                        v4
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.dashboardFavourites"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "dashboardRecents",
                                    "args": [
                                        v0,
                                        {
                                            "kind": "Variable",
                                            "name": "currentURL",
                                            "variableName": "currentURL"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 20
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "DASHBOARD"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v1,
                                                                        "action": "THROW",
                                                                        "path": "jira.dashboardRecents.edges.node.id"
                                                                    },
                                                                    v2,
                                                                    v3
                                                                ],
                                                                "type": "JiraDashboard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.dashboardRecents.edges.node"
                                                }
                                            ]
                                        },
                                        v4
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.dashboardRecents"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        };
    }();
    $c69b9c9d27d137b1$var$node.hash = "cea841a5380802195bad106b93f97807";
    var $c69b9c9d27d137b1$export$2e2bcd8739ae039 = $c69b9c9d27d137b1$var$node;
});
parcelRegister("iE0sN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8cd54efc44d623a$export$2e2bcd8739ae039);
    const $d8cd54efc44d623a$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "currentURL",
            "variableName": "currentURL"
        }, v2 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v3 = {
            "kind": "ScalarField",
            "name": "id"
        }, v4 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3,
                            {
                                "kind": "ScalarField",
                                "name": "dashboardId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "concreteType": "JiraFavouriteValue",
                                "kind": "LinkedField",
                                "name": "favouriteValue",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isFavourite"
                                    },
                                    v3
                                ]
                            }
                        ],
                        "type": "JiraDashboard"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                    }
                ]
            }
        ], v5 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "Nav4DashboardsContentQuery",
                "selections": [
                    {
                        "args": [
                            v1
                        ],
                        "kind": "FragmentSpread",
                        "name": "DashboardsContent"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "Nav4DashboardsContentQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "dashboardFavourites",
                                "args": [
                                    v2,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "DASHBOARD"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v4
                                    },
                                    v5
                                ]
                            },
                            {
                                "alias": "dashboardRecents",
                                "args": [
                                    v2,
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "DASHBOARD"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v4
                                    },
                                    v5
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b4f2439e8eb732abcaba3f2482c0371099ef4252accb958037b0f49e685ae969",
                "metadata": {},
                "name": "Nav4DashboardsContentQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $d8cd54efc44d623a$var$node.hash = "cea841a5380802195bad106b93f97807";
    var $d8cd54efc44d623a$export$2e2bcd8739ae039 = $d8cd54efc44d623a$var$node;
});
parcelRegister("9Gyp5", function(module, exports) {
    $parcel$export(module.exports, "useRefetchWhenIsSelected", ()=>$b6947c490b25f582$export$ed209ae428704c56);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $4R6GH;
    var $aGONy;
    function $b6947c490b25f582$export$80c011bcc60416a3(params) {
        const { cloudId: cloudId, isSelectedPath: isSelectedPath, menuId: menuId, refetch: refetch, QUERY: QUERY } = params;
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const currentURL = (0, (0, parcelRequire("aGONy")).useGetCurrentUrl)();
        (0, $5uXOq.useEffect)(()=>{
            if (isSelectedPath(menuId)) (0, $8Uumt.fetchQuery)(environment, QUERY, {
                cloudId: cloudId,
                currentURL: currentURL
            }).subscribe({
                complete: ()=>{
                    refetch({
                        cloudId: cloudId,
                        currentURL: currentURL
                    }, {
                        fetchPolicy: 'store-only'
                    });
                }
            });
        }, [
            cloudId,
            isSelectedPath,
            menuId,
            refetch,
            currentURL,
            environment,
            QUERY
        ]);
    }
    function $b6947c490b25f582$export$68fa0cd6ae85b82a(params) {
        const { cloudId: cloudId, isSelectedPath: isSelectedPath, menuId: menuId, refetch: refetch, QUERY: QUERY } = params;
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const currentURL = (0, (0, parcelRequire("aGONy")).useGetCurrentUrl)();
        const currentURLPath = (0, (0, parcelRequire("aGONy")).useGetCurrentUrlPath)();
        (0, $5uXOq.useEffect)(()=>{
            if (isSelectedPath(menuId)) (0, $8Uumt.fetchQuery)(environment, QUERY, {
                cloudId: cloudId,
                currentURL: currentURL,
                currentURLPath: currentURLPath
            }).subscribe({
                complete: ()=>{
                    refetch({
                        cloudId: cloudId,
                        currentURL: currentURL
                    }, {
                        fetchPolicy: 'store-only'
                    });
                }
            });
        }, [
            cloudId,
            isSelectedPath,
            menuId,
            refetch,
            currentURL,
            currentURLPath,
            environment,
            QUERY
        ]);
    }
    const $b6947c490b25f582$export$ed209ae428704c56 = (params)=>(0, (0, parcelRequire("4R6GH")).fg)('plans_-_avoid_refetching_plans_nav_on_query_change') ? $b6947c490b25f582$export$68fa0cd6ae85b82a(params) : $b6947c490b25f582$export$80c011bcc60416a3(params);
});
parcelRegister("aGONy", function(module, exports) {
    $parcel$export(module.exports, "useGetCurrentUrl", ()=>$e40fd709c4a3ab1d$export$d758ec3f153761c1);
    $parcel$export(module.exports, "useGetCurrentUrlPath", ()=>$e40fd709c4a3ab1d$export$f61d14d754da11cc);
    var $lODMY;
    var $doZTA;
    function $e40fd709c4a3ab1d$export$d758ec3f153761c1() {
        const [routerContext] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const searchParams = new URLSearchParams(routerContext.query ?? {});
        const url = new URL(`http://example.com${routerContext.match.url}/?${searchParams.toString()}`);
        return url.toString();
    }
    const $e40fd709c4a3ab1d$export$f61d14d754da11cc = (0, (0, parcelRequire("lODMY")).createRouterSelector)((routerContext)=>{
        const url = new URL(`http://example.com${routerContext.match.url}`);
        return url.toString();
    });
});
parcelRegister("gxbcq", function(module, exports) {
    $parcel$export(module.exports, "useSubscribeAndUpdateFavorites", ()=>$7a04a668720dad88$export$1032774f8dab9cec);
    var $5uXOq = parcelRequire("5uXOq");
    var $eiowN = parcelRequire("eiowN");
    var $7lK06;
    const $7a04a668720dad88$export$923c488bb9fac2df = (favouriteConnectionId, recentConnectionId)=>(0, $5uXOq.useCallback)(({ store: store, dataId: dataId, isFavourite: isFavourite })=>{
            const node = store.get(dataId);
            const favorites = store.get(favouriteConnectionId);
            if (!node || !favorites) return false;
            if (isFavourite) {
                const recentEdges = store.get(recentConnectionId)?.getLinkedRecords('edges') ?? [];
                const existingEdge = recentEdges.find((edge)=>edge.getLinkedRecord('node')?.getDataID() === dataId);
                if (!existingEdge) return false;
                const edge = (0, $eiowN.ConnectionHandler).createEdge(store, favorites, node, 'JiraFavouriteEdge');
                (0, $eiowN.ConnectionHandler).insertEdgeBefore(favorites, edge);
            } else (0, $eiowN.ConnectionHandler).deleteNode(favorites, dataId);
            return true;
        }, [
            favouriteConnectionId,
            recentConnectionId
        ]);
    const $7a04a668720dad88$export$1032774f8dab9cec = ({ entityTypename: entityTypename, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId, refetch: refetch })=>{
        const updateFavoriteConnection = $7a04a668720dad88$export$923c488bb9fac2df(favouriteConnectionId, recentConnectionId);
        const pendingRefetch = (0, $5uXOq.useRef)(false);
        const trailingRefetch = (0, $5uXOq.useRef)(false);
        const onRefetch = (0, $5uXOq.useCallback)(()=>{
            if (pendingRefetch.current) {
                trailingRefetch.current = true;
                return;
            }
            pendingRefetch.current = true;
            trailingRefetch.current = false;
            refetch({
                onComplete: ()=>{
                    pendingRefetch.current = false;
                    if (trailingRefetch.current) setTimeout(onRefetch, 0);
                }
            });
        }, [
            refetch
        ]);
        const subscriber = (0, $5uXOq.useCallback)((payload)=>{
            if (payload.type === 'MUTATION') {
                const success = updateFavoriteConnection(payload);
                if (success || payload.isOptimistic) return;
            }
            onRefetch();
        }, [
            onRefetch,
            updateFavoriteConnection
        ]);
        (0, (0, parcelRequire("7lK06")).useSubscribeToFavorite)(entityTypename, subscriber);
    };
});
parcelRegister("1b6zA", function(module, exports) {
    $parcel$export(module.exports, "useStableItems", ()=>$5cc76236fb007e50$export$cb9e0e36b6d0277e);
    var $5uXOq = parcelRequire("5uXOq");
    const $5cc76236fb007e50$export$cb9e0e36b6d0277e = ()=>{
        const stableIdMapRef = (0, $5uXOq.useRef)(new Map());
        const getStableItems = (0, $5uXOq.useCallback)(({ nodes: nodes, idKey: idKey })=>{
            const getStringId = (node)=>`${node[idKey]}`;
            const intersectedNodes = nodes.filter((node)=>stableIdMapRef.current.has(getStringId(node))).sort((nodeA, nodeB)=>{
                const indexA = stableIdMapRef.current.get(getStringId(nodeA)) ?? 0;
                const indexB = stableIdMapRef.current.get(getStringId(nodeB)) ?? 0;
                return indexA - indexB;
            });
            const hasIntersectedNodes = Boolean(intersectedNodes.length);
            const stableOrderedNodes = hasIntersectedNodes ? nodes.reduceRight((acc, node, index, array)=>{
                if (!stableIdMapRef.current.has(getStringId(node))) {
                    const addToStart = index + 1 !== array.length;
                    addToStart ? acc.unshift(node) : acc.push(node);
                }
                return acc;
            }, intersectedNodes) : nodes;
            stableIdMapRef.current = new Map(stableOrderedNodes.map((node, index)=>[
                    getStringId(node),
                    index
                ]));
            return stableOrderedNodes;
        }, []);
        return {
            getStableItems: getStableItems
        };
    };
});
parcelRegister("hjTAj", function(module, exports) {
    $parcel$export(module.exports, "DashboardMenuItem", ()=>$06188daec5d0ea0c$export$5c7baf31dfb5503f);
    var $cRPrh;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $gsyzJ;
    var $jecJ3;
    var $jhS4y;
    var $5FnJJ;
    var $6MFxN;
    var $gxw5a;
    function $06188daec5d0ea0c$export$5c7baf31dfb5503f({ queryRef: queryRef }) {
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("cRPrh")).default), queryRef);
        const { fireUIAnalyticForDashboardItems: fireUIAnalyticForDashboardItems } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6MFxN")).AnalyticContext));
        if (!data) return null;
        const dashboardUrl = `/jira/dashboards/${data.dashboardId}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            href: dashboardUrl,
            menuId: (0, (0, parcelRequire("jhS4y")).ENTITY_ID).DASHBOARD(String(data.dashboardId)),
            actionsOnHover: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxw5a")).DashboardPopupMenu), {
                dashboardData: data
            }),
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gsyzJ"))))), {
                label: "",
                color: "currentColor"
            }),
            onClick: ()=>{
                fireUIAnalyticForDashboardItems({
                    itemId: String(data.dashboardId),
                    section: data?.favouriteValue?.isFavourite ? (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_STARRED) : (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_RECENT)
                });
            }
        }, data.title);
    }
});
parcelRegister("cRPrh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b406664bb6832059$export$2e2bcd8739ae039);
    const $b406664bb6832059$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "DashboardMenuItem",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "title"
                },
                "action": "THROW",
                "path": "title"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "dashboardId"
                },
                "action": "THROW",
                "path": "dashboardId"
            },
            {
                "concreteType": "JiraFavouriteValue",
                "kind": "LinkedField",
                "name": "favouriteValue",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "DashboardPopupMenu"
            }
        ],
        "type": "JiraDashboard"
    };
    $b406664bb6832059$var$node.hash = "e30b21c7949d8052bd6833da91711e25";
    var $b406664bb6832059$export$2e2bcd8739ae039 = $b406664bb6832059$var$node;
});
parcelRegister("gxw5a", function(module, exports) {
    $parcel$export(module.exports, "DashboardPopupMenu", ()=>$5f374019177db79e$export$4fdb1267041f7bae);
    var $1R0Yj;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $kgoHi;
    var $d62in;
    var $aCS3f;
    var $gSZmd;
    var $6MFxN;
    const $5f374019177db79e$export$4fdb1267041f7bae = ({ dashboardData: dashboardData })=>{
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("1R0Yj")).default), dashboardData);
        const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton, fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6MFxN")).AnalyticContext));
        const MenuItems = (0, $5uXOq.useCallback)(()=>{
            const { id: id, dashboardId: dashboardId } = data;
            const isFavourite = Boolean(data?.favouriteValue?.isFavourite);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d62in")).FavoriteToggleButton), {
                entityId: id,
                defaultIsStarred: isFavourite,
                entityTypeName: "JiraDashboard",
                onClick: ()=>{
                    fireUIAnalyticForFavouriteToggle({
                        starType: isFavourite ? (0, $ac13fa3c12e20c46$export$5fe513938f2c4081) : (0, $ac13fa3c12e20c46$export$54408be40394d82a),
                        parentItemId: String(dashboardId)
                    });
                }
            }));
        }, [
            data,
            fireUIAnalyticForFavouriteToggle
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.050",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            onOpen: ()=>fireUIAnalyticForFixButton({
                    itemId: (0, $ddbe4b334e21c7a1$export$f06dfcec5ff912e)
                }),
            MenuItems: MenuItems
        }));
    };
});
parcelRegister("1R0Yj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$685d08f08d398300$export$2e2bcd8739ae039);
    const $685d08f08d398300$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "DashboardPopupMenu",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "dashboardId"
                },
                "action": "THROW",
                "path": "dashboardId"
            },
            {
                "concreteType": "JiraFavouriteValue",
                "kind": "LinkedField",
                "name": "favouriteValue",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                    }
                ]
            }
        ],
        "type": "JiraDashboard"
    };
    $685d08f08d398300$var$node.hash = "a386558bb17b8fafc916eb203a4d28ee";
    var $685d08f08d398300$export$2e2bcd8739ae039 = $685d08f08d398300$var$node;
});
const $ac13fa3c12e20c46$export$54408be40394d82a = 'star';
const $ac13fa3c12e20c46$export$5fe513938f2c4081 = 'unstar';
parcelRegister("d62in", function(module, exports) {
    $parcel$export(module.exports, "FavoriteToggleButton", ()=>$177932fc5526585a$export$b01f3062fe4ad89b);
    var $5uXOq = parcelRequire("5uXOq");
    var $dm1qi;
    var $dAf5R;
    var $kJpBP;
    var $cgL5K;
    var $4041n;
    var $4R6GH;
    var $koVbs;
    var $9eeFp;
    var $9WLyc;
    const $177932fc5526585a$var$UnstarredIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dAf5R"))))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });
    const $177932fc5526585a$var$StarredIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dm1qi"))))), {
        label: "",
        color: "var(--ds-icon-accent-yellow, var(--ds-icon-accent-yellow))",
        spacing: "spacious"
    });
    const $177932fc5526585a$export$b01f3062fe4ad89b = ({ entityId: entityId, entityTypeName: entityTypeName, defaultIsStarred: defaultIsStarred = false, name: name, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isStarred, setIsStarred] = (0, $5uXOq.useState)(defaultIsStarred);
        const { changeFavoriteMutation: changeFavoriteMutation } = (0, (0, parcelRequire("4041n")).useChangeFavorite)();
        const handleOnClick = (0, $5uXOq.useCallback)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2')) {
                setIsStarred((prevIsStarred)=>!prevIsStarred);
                onClick?.();
            } else setIsStarred((prevIsStarred)=>{
                const shouldStarProject = !prevIsStarred;
                changeFavoriteMutation({
                    id: entityId,
                    typename: entityTypeName,
                    value: shouldStarProject
                });
                onClick?.();
                return shouldStarProject;
            });
        }, [
            changeFavoriteMutation,
            entityId,
            entityTypeName,
            onClick
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isStarred !== defaultIsStarred && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2')) changeFavoriteMutation({
                id: entityId,
                typename: entityTypeName,
                value: isStarred
            });
        }, [
            entityId,
            entityTypeName,
            isStarred,
            defaultIsStarred,
            changeFavoriteMutation
        ]);
        const handleOnClickWithStopPropagation = (0, (0, parcelRequire("9eeFp")).useStopPropagation)(handleOnClick);
        return isStarred ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            iconBefore: $177932fc5526585a$var$StarredIcon,
            onClick: handleOnClickWithStopPropagation,
            "aria-label": name ? formatMessage((0, (0, parcelRequire("9WLyc")).default).removeFromStarredWithName, {
                name: name
            }) : formatMessage((0, (0, parcelRequire("9WLyc")).default).removeFromStarred)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text"
        }, formatMessage((0, (0, parcelRequire("9WLyc")).default).removeFromStarred))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            iconBefore: $177932fc5526585a$var$UnstarredIcon,
            onClick: handleOnClickWithStopPropagation,
            "aria-label": name ? formatMessage((0, (0, parcelRequire("9WLyc")).default).addToStarredWithName, {
                name: name
            }) : formatMessage((0, (0, parcelRequire("9WLyc")).default).addToStarred)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text"
        }, formatMessage((0, (0, parcelRequire("9WLyc")).default).addToStarred)));
    };
});
parcelRegister("9WLyc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ff4f0ec548b713f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0ff4f0ec548b713f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addToStarred: {
            "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred",
            "defaultMessage": "Add to starred"
        },
        removeFromStarred: {
            "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred",
            "defaultMessage": "Remove from starred"
        },
        addToStarredWithName: {
            "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred-with-name",
            "defaultMessage": "Add \"{name}\" to starred"
        },
        removeFromStarredWithName: {
            "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred-with-name",
            "defaultMessage": "Remove \"{name}\" from starred"
        }
    });
});
parcelRegister("afcwS", function(module, exports) {
    $parcel$export(module.exports, "DashboardsEmptyContent", ()=>$d52cc5a7a03724c3$export$54678b9782e1c19b);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $koVbs;
    var $7lgBG;
    var $8Rqp2;
    function $d52cc5a7a03724c3$export$54678b9782e1c19b() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7lgBG")).EmptyContentMenuItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            color: "color.text.subtle"
        }, formatMessage((0, (0, parcelRequire("8Rqp2")).default).emptyDashboardsMessage)));
    }
});
parcelRegister("7lgBG", function(module, exports) {
    $parcel$export(module.exports, "EmptyContentMenuItem", ()=>$e3e887a0aac5853d$export$1d5b0e5e21ec7e84);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $1qQhw;
    const $e3e887a0aac5853d$var$styles = {
        box: "_18u01b66"
    };
    function $e3e887a0aac5853d$export$1d5b0e5e21ec7e84({ children: children }) {
        return $5uXOq.createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingInline: "space.050",
            xcss: $e3e887a0aac5853d$var$styles.box
        }, children));
    }
});
parcelRegister("8Rqp2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff6bfea929fd13b7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ff6bfea929fd13b7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyDashboardsMessage: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.empty-content.empty-dashboards-message",
            "defaultMessage": "Once you visit or create dashboards, they\u2019ll show up here."
        }
    });
});
parcelRegister("1deEY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8574efbecd63d724$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8574efbecd63d724$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        recent: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.recent",
            "defaultMessage": "Recent"
        },
        starred: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.starred",
            "defaultMessage": "Starred"
        },
        viewAllStarred: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.view-all-starred",
            "defaultMessage": "View all starred"
        }
    });
});
parcelRegister("ehnIE", function(module, exports) {
    $parcel$export(module.exports, "Footer", ()=>$efafdfdbad2ab24a$export$a06f1c675e846f6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $jhS4y;
    var $34PKs;
    var $dDmlh;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    var $6MFxN;
    var $djUjd;
    const $efafdfdbad2ab24a$var$VIEW_ALL_DASHBOARDS_HREF = (0, (0, parcelRequire("dDmlh")).dashboardsDirectoryRoute).path;
    const $efafdfdbad2ab24a$export$a06f1c675e846f6f = ({ onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6MFxN")).AnalyticContext));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("34PKs")).ViewAllEntityMenuItem), {
            href: $efafdfdbad2ab24a$var$VIEW_ALL_DASHBOARDS_HREF,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS_VIEW_ALL),
            onClick: (e)=>{
                fireUIAnalyticForFixMenuItem();
                onClose?.(e);
            }
        }, formatMessage((0, (0, parcelRequire("djUjd")).default).viewAllDashboards)))));
    };
});
parcelRegister("34PKs", function(module, exports) {
    $parcel$export(module.exports, "ViewAllEntityMenuItem", ()=>$5926a0296e1ab93a$export$505e81ff2081288b);
    var $5uXOq = parcelRequire("5uXOq");
    var $i6luQ;
    var $5FnJJ;
    function $5926a0296e1ab93a$export$505e81ff2081288b(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            ...props,
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("i6luQ"))))), {
                label: "",
                color: "currentColor"
            })
        });
    }
});
parcelRegister("i6luQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d2d976446b240c09$var$_react = $d2d976446b240c09$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d2d976446b240c09$var$_baseNew = $d2d976446b240c09$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $d2d976446b240c09$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d2d976446b240c09$var$AlignLeftIcon = (props)=>$d2d976446b240c09$var$_react.default.createElement($d2d976446b240c09$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 2.75h14M1 13.25h7M1 8h14"/>`
        }, props));
    $d2d976446b240c09$var$AlignLeftIcon.displayName = 'AlignLeftIcon';
    var $d2d976446b240c09$var$_default = module.exports.default = $d2d976446b240c09$var$AlignLeftIcon;
});
parcelRegister("djUjd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93087624b28395ab$export$2e2bcd8739ae039);
    var $7VHMR;
    var $93087624b28395ab$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewAllDashboards: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.footer.view-all-dashboards",
            "defaultMessage": "View all dashboards"
        }
    });
});
parcelRegister("8urqk", function(module, exports) {
    $parcel$export(module.exports, "DashboardsDefault", ()=>$ddb064d4de558bd2$export$bffc92c7e4f51e0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $jecJ3;
    var $jhS4y;
    var $aGONy;
    var $46Cti;
    var $c16H2;
    var $338xa;
    var $dQbFB;
    var $eQV8d;
    var $dUyqZ;
    var $4zcxJ;
    var $koeKL;
    var $lnznH;
    var $cZa9B;
    var $ehnIE;
    var $h4rc7;
    function $ddb064d4de558bd2$export$bffc92c7e4f51e0b(props) {
        const { actionsOnHover: actionsOnHover, isExpanded: isExpanded } = props;
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const currentURL = (0, (0, parcelRequire("aGONy")).useGetCurrentUrl)();
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                currentURL: currentURL
            }), [
            cloudId,
            currentURL
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("h4rc7")).asyncDashboardsContentViewQuery), entryPointParams);
        const triggerRef = (0, (0, parcelRequire("4zcxJ")).useExpandableEntryPointTrigger)(entryPointActions);
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS);
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        (0, $5uXOq.useEffect)(()=>{
            if (isExpanded) entryPointActions.load();
        }, [
            entryPointActions,
            isExpanded
        ]);
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: menuId,
            onSystemToggle: (hasExpanded)=>{
                if (hasExpanded) entryPointActions.load();
            },
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) {
                    entryPointActions.load();
                    sendSectionItemAnalyticsEvent({
                        menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS,
                        sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_DASHBOARDS)
                    });
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            interactionName: "nav4-sidebar-dashboards-default",
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            ref: triggerRef,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-dashboards-default",
            packageName: (0, $ddbe4b334e21c7a1$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $ddbe4b334e21c7a1$export$d57b6b390e78d90f),
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null),
            runtimeProps: entryPointParams
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehnIE")).Footer), null)));
    }
});
parcelRegister("h4rc7", function(module, exports) {
    $parcel$export(module.exports, "asyncDashboardsContentViewQuery", ()=>$3f7d81973c7cae41$export$680d30d6a57c47b8);
    var $azFkr;
    var $eufEc;
    var $fEDBv;
    const $3f7d81973c7cae41$export$680d30d6a57c47b8 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("9kEDt")).then(({ DashboardsContentViewQuery: DashboardsContentViewQuery })=>DashboardsContentViewQuery), {
            moduleId: "d524dcfe",
            moduleName: "DashboardsContentViewQuery"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                queries: {
                    queryRef: {
                        parameters: (0, parcelRequire("azFkr")).default,
                        variables: {
                            cloudId: cloudId
                        }
                    }
                }
            })
    });
});
parcelRegister("azFkr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc04cf6edfa8673b$export$2e2bcd8739ae039);
    const $bc04cf6edfa8673b$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = {
            "kind": "ScalarField",
            "name": "id"
        }, v3 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v2,
                            {
                                "kind": "ScalarField",
                                "name": "dashboardId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "concreteType": "JiraFavouriteValue",
                                "kind": "LinkedField",
                                "name": "favouriteValue",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isFavourite"
                                    },
                                    v2
                                ]
                            }
                        ],
                        "type": "JiraDashboard"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v2
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                    }
                ]
            }
        ], v4 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "DashboardsContentViewQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "DashboardsContent"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "DashboardsContentViewQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "dashboardFavourites",
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "DASHBOARD"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v3
                                    },
                                    v4
                                ]
                            },
                            {
                                "alias": "dashboardRecents",
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "DASHBOARD"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v3
                                    },
                                    v4
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "6de53027a8514a6f75fed2f4d178b267177cb50ff5cfbd7924d018d8a7f871ae",
                "metadata": {},
                "name": "DashboardsContentViewQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $bc04cf6edfa8673b$var$node.hash = "7ed95226ae03585ac6cc616adbd83544";
    var $bc04cf6edfa8673b$export$2e2bcd8739ae039 = $bc04cf6edfa8673b$var$node;
});
parcelRegister("9kEDt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1A69V").then(()=>parcelRequire('gSGR3'));
});
parcelRegister("blbXb", function(module, exports) {
    $parcel$export(module.exports, "Nav4Filters", ()=>$6d9491a946e77dbf$export$caf6e58bb8560bb2);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $iuhhQ;
    var $l8ruj;
    const $6d9491a946e77dbf$export$caf6e58bb8560bb2 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-filters"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "filters-section",
            packageName: (0, $095930ee3b140077$export$b8b9d90f9e5bd72b),
            teamName: (0, $095930ee3b140077$export$d57b6b390e78d90f)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuhhQ")).Nav4Filters), props)));
});
parcelRegister("iuhhQ", function(module, exports) {
    $parcel$export(module.exports, "Nav4Filters", ()=>$37c0282fd3f73bb5$export$caf6e58bb8560bb2);
    var $avYh4;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jhS4y;
    var $c6x3L;
    var $c0v8V;
    var $iaOwN;
    var $6jcf1;
    function $37c0282fd3f73bb5$export$caf6e58bb8560bb2({ isExpanded: isExpanded, queryRef: queryRef }) {
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("avYh4")).default), queryRef);
        const { isInitialSelectedPath: isInitialSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const actionButtons = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaOwN")).ActionButtons), null), []);
        return isInitialSelectedPath((0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS)) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c0v8V")).Nav4FiltersForLanding), {
            actionsOnHover: actionButtons,
            isExpanded: isExpanded,
            queryRef: data
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6jcf1")).Nav4FiltersDefault), {
            actionsOnHover: actionButtons,
            isExpanded: isExpanded
        });
    }
});
parcelRegister("avYh4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f2d98cdc206343c$export$2e2bcd8739ae039);
    const $4f2d98cdc206343c$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isFiltersExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Filters",
        "selections": [
            {
                "condition": "isFiltersExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4FiltersForLanding"
                    }
                ]
            }
        ],
        "type": "Query"
    };
    $4f2d98cdc206343c$var$node.hash = "bc99d6e3499fdf4ab0d2fdec5f064e1f";
    var $4f2d98cdc206343c$export$2e2bcd8739ae039 = $4f2d98cdc206343c$var$node;
});
parcelRegister("c0v8V", function(module, exports) {
    $parcel$export(module.exports, "Nav4FiltersForLanding", ()=>$c780ddd933f6ccc4$export$90658bd06cecabd4);
    var $f0kDR;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $7CMCs;
    var $jecJ3;
    var $jhS4y;
    var $46Cti;
    var $c16H2;
    var $dQbFB;
    var $eQV8d;
    var $dUyqZ;
    var $jNsky;
    var $l8ruj;
    var $lnznH;
    var $cZa9B;
    var $eYeHi;
    var $3XHNc;
    function $c780ddd933f6ccc4$export$90658bd06cecabd4(props) {
        const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS);
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("f0kDR")).default), queryRef);
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: menuId,
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) sendSectionItemAnalyticsEvent({
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS,
                    sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_FILTERS)
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3XHNc")).Header), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-filters-landing"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "nav4-sidebar-filters-landing",
            packageName: (0, $095930ee3b140077$export$b8b9d90f9e5bd72b),
            teamName: (0, $095930ee3b140077$export$d57b6b390e78d90f),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNsky")).Nav4FiltersContent), {
            queryRef: data
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eYeHi")).Footer), null)));
    }
});
parcelRegister("f0kDR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73859602a3769ede$export$2e2bcd8739ae039);
    const $73859602a3769ede$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4FiltersForLanding",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "Nav4FiltersContent"
            }
        ],
        "type": "Query"
    };
    $73859602a3769ede$var$node.hash = "6171665054b4de86e6a0c40316984aba";
    var $73859602a3769ede$export$2e2bcd8739ae039 = $73859602a3769ede$var$node;
});
parcelRegister("jNsky", function(module, exports) {
    $parcel$export(module.exports, "Nav4FiltersContent", ()=>$18f5885dbaabbc22$export$e0cd6afcf36dd0ac);
    var $7eMNW;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $7hmi2;
    var $koVbs;
    var $jecJ3;
    var $jhS4y;
    var $c6x3L;
    var $9Gyp5;
    var $5FnJJ;
    var $gxbcq;
    var $1b6zA;
    var $GgrBz;
    var $2SzoU;
    var $koeKL;
    var $cZpsT;
    var $mwgEH;
    var $lnznH;
    var $cZa9B;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    var $2CQvU;
    var $qBWno;
    var $jjTbl;
    const $18f5885dbaabbc22$var$MAX_RECENT_FILTERS = 5;
    const $18f5885dbaabbc22$export$1f869c99ead9db5f = 15;
    const $18f5885dbaabbc22$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
    const $18f5885dbaabbc22$var$defaultFiltersRequiringLogin = [
        {
            id: '-1'
        },
        {
            id: '-2'
        },
        {
            id: '-3'
        }
    ];
    const $18f5885dbaabbc22$var$entityTypenames = [
        'JiraCustomFilter',
        'JiraSystemFilter'
    ];
    function $18f5885dbaabbc22$export$e0cd6afcf36dd0ac({ queryRef: queryRef }) {
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { getStableItems: getStableItems } = (0, (0, parcelRequire("1b6zA")).useStableItems)();
        const { isSelectedPath: isSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const [fragmentData, refetch] = (0, $8Uumt.useRefetchableFragment)((0, (0, parcelRequire("7eMNW")).default), queryRef);
        const { jira: { favouriteFilters: favouriteFilters, recentFilters: recentFilters, systemFilters: systemFilters } } = fragmentData;
        (0, (0, parcelRequire("9Gyp5")).useRefetchWhenIsSelected)({
            cloudId: cloudId,
            isSelectedPath: isSelectedPath,
            QUERY: (0, parcelRequire("2SzoU")).default,
            refetch: refetch,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS)
        });
        const refetchOnChange = (0, $5uXOq.useCallback)(({ onComplete: onComplete })=>{
            refetch({
                cloudId: cloudId
            }, {
                fetchPolicy: 'store-and-network',
                onComplete: onComplete
            });
        }, [
            cloudId,
            refetch
        ]);
        (0, (0, parcelRequire("gxbcq")).useSubscribeAndUpdateFavorites)({
            entityTypename: $18f5885dbaabbc22$var$entityTypenames,
            favouriteConnectionId: favouriteFilters.__id,
            recentConnectionId: recentFilters.__id,
            refetch: refetchOnChange
        });
        const { subscribe: subscribe, unsubscribe: unsubscribe } = (0, (0, parcelRequire("7hmi2")).useDeleteChangeActions)();
        (0, $5uXOq.useEffect)(()=>{
            subscribe(refetchOnChange);
            return ()=>{
                unsubscribe(refetchOnChange);
            };
        }, [
            refetchOnChange,
            subscribe,
            unsubscribe
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const starred = formatMessage((0, (0, parcelRequire("jjTbl")).default).starred);
        const recent = formatMessage((0, (0, parcelRequire("jjTbl")).default).recent);
        const sendFilterAnalytics = (0, (0, parcelRequire("qBWno")).useFilterActionsAnalytics)();
        const favorites = (0, $5uXOq.useMemo)(()=>{
            const ids = favouriteFilters.edges?.map((edge)=>edge?.node.filterId).filter(Boolean) ?? [];
            const list = favouriteFilters.edges?.filter(Boolean).map((edge)=>{
                const isCustom = edge.node.__typename === 'JiraCustomFilter';
                const sendFavouriteFilterAnalytics = ()=>sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), (0, (0, parcelRequire("qBWno")).getRecentAndFavouriteFilterAttributes)({
                        isCustom: isCustom,
                        filterId: edge.node.filterId,
                        section: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_STARRED)
                    }));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("GgrBz")).Nav4FilterMenuItem), {
                    key: edge.node.filterId,
                    queryRef: edge.node,
                    onRefetch: refetchOnChange,
                    onClick: sendFavouriteFilterAnalytics
                });
            }) ?? [];
            return {
                idSet: new Set(ids),
                list: list.slice(0, $18f5885dbaabbc22$export$1f869c99ead9db5f),
                hasItems: Boolean(list.length),
                hasMore: favouriteFilters.pageInfo?.hasNextPage || list.length > $18f5885dbaabbc22$export$1f869c99ead9db5f
            };
        }, [
            favouriteFilters,
            refetchOnChange,
            sendFilterAnalytics
        ]);
        const recentItems = (0, $5uXOq.useMemo)(()=>{
            const nodes = recentFilters.edges?.filter(Boolean).filter((edge)=>edge.node.filterId && !favorites.idSet.has(edge.node.filterId)).map((edge)=>edge.node).slice(0, $18f5885dbaabbc22$var$MAX_RECENT_FILTERS) ?? [];
            const stableOrderedNodes = getStableItems({
                nodes: nodes,
                idKey: 'filterId'
            });
            const list = stableOrderedNodes.map((node)=>{
                const sendRecentFilterAnalytics = ()=>sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), (0, (0, parcelRequire("qBWno")).getRecentAndFavouriteFilterAttributes)({
                        isCustom: true,
                        filterId: node.filterId,
                        section: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_RECENT)
                    }));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("GgrBz")).Nav4FilterMenuItem), {
                    key: node.filterId,
                    queryRef: node,
                    onRefetch: refetchOnChange,
                    onClick: sendRecentFilterAnalytics
                });
            });
            return {
                list: list,
                hasItems: Boolean(list.length)
            };
        }, [
            recentFilters.edges,
            getStableItems,
            favorites.idSet,
            refetchOnChange,
            sendFilterAnalytics
        ]);
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        const defaultItems = (0, $5uXOq.useMemo)(()=>{
            const filterIds = [];
            const list = systemFilters.edges?.filter((edge)=>edge?.node?.filterId && !favorites.idSet.has(edge.node.filterId))?.filter((edge)=>edge?.node?.filterId && (!isAnonymous || !$18f5885dbaabbc22$var$defaultFiltersRequiringLogin.find((filter)=>filter.id === edge.node.filterId))).map((edge)=>{
                edge?.node && filterIds.push(edge?.node.filterId);
                return edge;
            }).map((edge)=>{
                if (!edge?.node) return null;
                const sendDefaultFilterAnalytics = ()=>sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), (0, (0, parcelRequire("qBWno")).getDefaulFilterAttributes)({
                        filterId: edge.node.filterId
                    }));
                return edge?.node ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("GgrBz")).Nav4FilterMenuItem), {
                    key: edge.node.filterId,
                    queryRef: edge.node,
                    onRefetch: refetchOnChange,
                    onClick: sendDefaultFilterAnalytics
                }) : null;
            }) || [];
            return {
                list: list,
                hasItems: Boolean(list.length),
                filterIds: filterIds
            };
        }, [
            systemFilters.edges,
            favorites.idSet,
            isAnonymous,
            refetchOnChange,
            sendFilterAnalytics
        ]);
        const isDefaultFilterSelected = (0, $5uXOq.useMemo)(()=>defaultItems.filterIds.some((id)=>isSelectedPath((0, (0, parcelRequire("jhS4y")).ENTITY_ID).FILTER(id))), [
            defaultItems.filterIds,
            isSelectedPath
        ]);
        const sendViewAllStarredAnalytics = (0, $5uXOq.useCallback)(()=>{
            sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: 'viewAllStarred'
            });
        }, [
            sendFilterAnalytics
        ]);
        const sendDefaultFilterDropdownAnalytics = (0, $5uXOq.useCallback)(()=>{
            sendFilterAnalytics((0, $ce8062101363feb9$export$b887e88d8d0739f6), {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: 'defaultFilters'
            });
        }, [
            sendFilterAnalytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, favorites.hasItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CQvU")).MenuSectionHeading), null, starred), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, favorites.list))), favouriteFilters.pageInfo?.hasNextPage && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            href: $18f5885dbaabbc22$var$VIEW_ALL_STARRED_HREF,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS_VIEW_ALL_STARRED),
            onClick: sendViewAllStarredAnalytics
        }, formatMessage((0, (0, parcelRequire("jjTbl")).default).viewAllStarred))), recentItems.hasItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CQvU")).MenuSectionHeading), null, recent), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, recentItems.list))), defaultItems.hasItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("mwgEH")).ExpandableMenuItem), {
            isDefaultExpanded: true,
            isChildSelected: isDefaultFilterSelected,
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) sendDefaultFilterDropdownAnalytics();
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), null, formatMessage((0, (0, parcelRequire("jjTbl")).default).defaultFilters)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, defaultItems.list)));
    }
});
parcelRegister("7eMNW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ecbe3a8ee266c1ca$export$2e2bcd8739ae039);
    var $2SzoU;
    const $ecbe3a8ee266c1ca$var$node = function() {
        var v0 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v1 = {
            "kind": "ScalarField",
            "name": "filterId"
        }, v2 = {
            "kind": "FragmentSpread",
            "name": "Nav4FilterMenuItem"
        }, v3 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v4 = [
            v1,
            v2
        ];
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "cloudId"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "currentURL"
                }
            ],
            "kind": "Fragment",
            "metadata": {
                "refetch": {
                    "fragmentPathInResult": [],
                    "operation": (0, (0, parcelRequire("2SzoU")).default)
                }
            },
            "name": "Nav4FiltersContent",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v0,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "FILTER"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "__typename"
                                                                    },
                                                                    v1,
                                                                    v2
                                                                ],
                                                                "type": "JiraFilter",
                                                                "abstractKey": "__isJiraFilter"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.favouriteFilters.edges.node"
                                                }
                                            ]
                                        },
                                        v3
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.favouriteFilters"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "recentFilters",
                                    "args": [
                                        v0,
                                        {
                                            "kind": "Variable",
                                            "name": "currentURL",
                                            "variableName": "currentURL"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 20
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "FILTER"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v4,
                                                                "type": "JiraCustomFilter"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.recentFilters.edges.node"
                                                }
                                            ]
                                        },
                                        v3
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.recentFilters"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": [
                                        v0
                                    ],
                                    "concreteType": "JiraSystemFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "systemFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraSystemFilter",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": v4
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.systemFilters.edges.node"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.systemFilters"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        };
    }();
    $ecbe3a8ee266c1ca$var$node.hash = "855858f36cb0de864abf601ce3c9d552";
    var $ecbe3a8ee266c1ca$export$2e2bcd8739ae039 = $ecbe3a8ee266c1ca$var$node;
});
parcelRegister("2SzoU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4b5e5aaa6a2bc38$export$2e2bcd8739ae039);
    const $c4b5e5aaa6a2bc38$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "currentURL",
            "variableName": "currentURL"
        }, v2 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = {
            "kind": "ScalarField",
            "name": "filterId"
        }, v5 = {
            "kind": "ScalarField",
            "name": "name"
        }, v6 = {
            "kind": "ScalarField",
            "name": "id"
        }, v7 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v8 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v9 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                        v3,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v6
                    ]
                }
            ],
            "type": "JiraCustomFilter"
        }, v10 = {
            "kind": "InlineFragment",
            "selections": [
                v6
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v11 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "Nav4FiltersContentQuery",
                "selections": [
                    {
                        "args": [
                            v1
                        ],
                        "kind": "FragmentSpread",
                        "name": "Nav4FiltersContent"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "Nav4FiltersContentQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "favouriteFilters",
                                "args": [
                                    v2,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "FILTER"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v4,
                                                            v5,
                                                            v6,
                                                            v7,
                                                            v8,
                                                            v9
                                                        ],
                                                        "type": "JiraFilter",
                                                        "abstractKey": "__isJiraFilter"
                                                    },
                                                    v10
                                                ]
                                            }
                                        ]
                                    },
                                    v11
                                ]
                            },
                            {
                                "alias": "recentFilters",
                                "args": [
                                    v2,
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "FILTER"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v4,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v5,
                                                                    v6,
                                                                    v7,
                                                                    v8,
                                                                    v9
                                                                ],
                                                                "type": "JiraFilter",
                                                                "abstractKey": "__isJiraFilter"
                                                            }
                                                        ],
                                                        "type": "JiraCustomFilter"
                                                    },
                                                    v10
                                                ]
                                            }
                                        ]
                                    },
                                    v11
                                ]
                            },
                            {
                                "args": [
                                    v2
                                ],
                                "concreteType": "JiraSystemFilterConnection",
                                "kind": "LinkedField",
                                "name": "systemFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSystemFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSystemFilter",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    v6,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v5,
                                                            v3,
                                                            v7,
                                                            v8,
                                                            v9
                                                        ],
                                                        "type": "JiraFilter",
                                                        "abstractKey": "__isJiraFilter"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "dbb6940801647478cda63c86a97d1636f190f8f60e142b56754cabc5eb925f6e",
                "metadata": {},
                "name": "Nav4FiltersContentQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $c4b5e5aaa6a2bc38$var$node.hash = "855858f36cb0de864abf601ce3c9d552";
    var $c4b5e5aaa6a2bc38$export$2e2bcd8739ae039 = $c4b5e5aaa6a2bc38$var$node;
});
parcelRegister("7hmi2", function(module, exports) {
    $parcel$export(module.exports, "useDeleteChangeActions", ()=>$4b1281a69eb8a7ab$export$ebbca0408972222d);
    var $3sQ5x;
    var $iXqE5;
    const $4b1281a69eb8a7ab$var$initialState = {
        callbacks: []
    };
    const $4b1281a69eb8a7ab$export$e324594224ef24da = {
        subscribe: (callback)=>({ getState: getState, setState: setState })=>{
                if (!getState().callbacks.includes(callback)) setState({
                    callbacks: [
                        ...getState().callbacks,
                        callback
                    ]
                });
            },
        unsubscribe: (callback)=>({ getState: getState, setState: setState })=>{
                if (getState().callbacks.includes(callback)) setState({
                    callbacks: getState().callbacks.filter((item)=>item !== callback)
                });
            },
        publish: ()=>({ getState: getState })=>{
                getState().callbacks.forEach((callback)=>callback({
                        onComplete: ()=>undefined
                    }));
            }
    };
    const $4b1281a69eb8a7ab$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $4b1281a69eb8a7ab$var$initialState,
        actions: $4b1281a69eb8a7ab$export$e324594224ef24da
    });
    const $4b1281a69eb8a7ab$export$440b46140bc86b64 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($4b1281a69eb8a7ab$var$Store);
    const $4b1281a69eb8a7ab$export$ebbca0408972222d = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($4b1281a69eb8a7ab$var$Store);
});
parcelRegister("GgrBz", function(module, exports) {
    $parcel$export(module.exports, "Nav4FilterMenuItem", ()=>$e1d0066c79c6dc07$export$6c93ee534b1d4d10);
    var $m231W;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $iyWGS;
    var $cZpsT;
    var $MaZbq;
    function $e1d0066c79c6dc07$export$6c93ee534b1d4d10({ queryRef: queryRef, onRefetch: onRefetch, onClick: onClick }) {
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("m231W")).default), queryRef);
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("MaZbq")).SimpleFilterMenuItem), {
            actionsOnHover: !isAnonymous && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iyWGS")).Nav4FilterActions), {
                queryRef: data,
                onRefetch: onRefetch
            }),
            filterId: data.filterId,
            name: data.name,
            onClick: onClick
        });
    }
});
parcelRegister("m231W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$11acb6858e14c1d4$export$2e2bcd8739ae039);
    const $11acb6858e14c1d4$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4FilterMenuItem",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "filterId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "FragmentSpread",
                "name": "Nav4FilterActions"
            }
        ],
        "type": "JiraFilter",
        "abstractKey": "__isJiraFilter"
    };
    $11acb6858e14c1d4$var$node.hash = "db4e5c3fb6fe1fa05a10eea572e428b4";
    var $11acb6858e14c1d4$export$2e2bcd8739ae039 = $11acb6858e14c1d4$var$node;
});
parcelRegister("iyWGS", function(module, exports) {
    $parcel$export(module.exports, "Nav4FilterActions", ()=>$013d853f5bcf1d51$export$7077dee41f8ad33d);
    var $jaCjz;
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $8Uumt = parcelRequire("8Uumt");
    var $8w53e;
    var $4IrpZ;
    var $5nRKm;
    var $eRB05;
    var $1bKdn;
    var $kJpBP;
    var $3Z96c;
    var $9UCCQ;
    var $cgL5K;
    var $7WnQL;
    var $koVbs;
    var $d62in;
    var $aCS3f;
    var $4tcSU;
    var $cKjus;
    var $6KXPO;
    var $90yGq;
    var $itmJb;
    var $lVJAU;
    var $qBWno;
    var $gDIE0;
    var $l3IPn;
    var $199zy;
    var $eKG0o;
    const $013d853f5bcf1d51$export$7077dee41f8ad33d = ({ queryRef: queryRef, onRefetch: onRefetch })=>{
        const { __typename: __typename, isEditable: isEditable, isFavourite: isFavourite, name: name, owner: owner, id: id, filterId: filterId, jql: jql } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("jaCjz")).default), queryRef);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const sendFilterAnalytics = (0, (0, parcelRequire("qBWno")).useFilterActionsAnalytics)();
        const { isOpen: isCopyFilterModalOpen, onOpen: openCopyFilterModal, onClose: closeCopyFilterModal } = (0, (0, parcelRequire("eKG0o")).useModalState)(false);
        const { isOpen: isEditFilterModalOpen, onOpen: openEditFilterModal, onClose: closeEditFilterModal } = (0, (0, parcelRequire("eKG0o")).useModalState)(false);
        const { isOpen: isChangeOwnerModalOpen, onOpen: openChangeOwnerModal, onClose: closeChangeOwnerModal } = (0, (0, parcelRequire("eKG0o")).useModalState)(false);
        const { isOpen: isDeleteFilterModalOpen, onOpen: openDeleteFilterModal, onClose: closeDeleteFilterModal } = (0, (0, parcelRequire("eKG0o")).useModalState)(false);
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const onFilterSave = (0, $5uXOq.useCallback)((copiedFilterId)=>{
            push(`/issues/?filter=${copiedFilterId}`);
        }, [
            push
        ]);
        const isCustom = __typename === 'JiraCustomFilter';
        const isOwner = owner?.accountId && owner.accountId === accountId;
        const sendFilterActionAnalytics = (0, $5uXOq.useCallback)((itemId)=>{
            sendFilterAnalytics((0, $ce8062101363feb9$export$64fed82162bd367), (0, (0, parcelRequire("qBWno")).getFilterActionAttributes)({
                itemId: itemId,
                isCustom: isCustom,
                isFavourite: isFavourite,
                filterId: filterId
            }));
        }, [
            filterId,
            isCustom,
            isFavourite,
            sendFilterAnalytics
        ]);
        const MenuItems = (0, $5uXOq.useCallback)(({ onClose: onClose })=>{
            const getManageSubscriptionsUrl = (actionType)=>{
                const parsed = (0, ($parcel$interopDefault($ebyGx))).stringify({
                    atl_token: (0, (0, parcelRequire("4tcSU")).default)(),
                    returnUrl: 'ManageFilters.jspa',
                    filterId: filterId
                });
                return `/${actionType}!default.jspa?${parsed}`;
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
                isList: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d62in")).FavoriteToggleButton), {
                entityId: id,
                defaultIsStarred: Boolean(isFavourite),
                entityTypeName: (0, (0, parcelRequire("7WnQL")).isFavoritableItemTypename)(__typename) ? __typename : 'JiraCustomFilter',
                onClick: ()=>sendFilterActionAnalytics(isFavourite ? (0, $496585bee7985bb9$export$7ae7abcf2c19d3e5) : (0, $496585bee7985bb9$export$78fd0bd637fe1684)),
                name: name
            }), isCustom && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eRB05"))))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                href: getManageSubscriptionsUrl('ViewSubscriptions'),
                "aria-label": formatMessage((0, (0, parcelRequire("199zy")).default).manageSubscriptionWithName, {
                    name: name
                }),
                onClick: ()=>sendFilterActionAnalytics('manageSubscription')
            }, formatMessage((0, (0, parcelRequire("199zy")).default).manageSubscription)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                onClick: (e)=>{
                    openCopyFilterModal();
                    sendFilterActionAnalytics('copyFilter');
                    onClose && onClose(e);
                },
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8w53e"))))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                "aria-label": formatMessage((0, (0, parcelRequire("199zy")).default).copyFilterWithName, {
                    name: name
                })
            }, formatMessage((0, (0, parcelRequire("199zy")).default).copyFilter)), isCustom && (isOwner || isEditable) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5nRKm"))))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                onClick: (e)=>{
                    openEditFilterModal();
                    sendFilterActionAnalytics('editFilter');
                    onClose && onClose(e);
                },
                "aria-label": formatMessage((0, (0, parcelRequire("199zy")).default).editWithName, {
                    name: name
                })
            }, formatMessage((0, (0, parcelRequire("199zy")).default).edit)), isCustom && (isOwner || isAdmin) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                onClick: (e)=>{
                    openChangeOwnerModal();
                    sendFilterActionAnalytics('changeOwner');
                    onClose && onClose(e);
                },
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1bKdn"))))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                "aria-label": formatMessage((0, (0, parcelRequire("199zy")).default).changeOwnerWithName, {
                    name: name
                })
            }, formatMessage((0, (0, parcelRequire("199zy")).default).changeOwner))), isCustom && (isOwner || isAdmin) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
                hasSeparator: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                onClick: (e)=>{
                    openDeleteFilterModal();
                    sendFilterActionAnalytics('deleteFilter');
                    onClose && onClose(e);
                },
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4IrpZ"))))), {
                    label: "",
                    color: "var(--ds-icon-danger, #C9372C)",
                    spacing: "spacious"
                }),
                "aria-label": formatMessage((0, (0, parcelRequire("199zy")).default).deleteWithName, {
                    name: name
                })
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                color: "color.text.danger"
            }, formatMessage((0, (0, parcelRequire("199zy")).default).delete)))));
        }, [
            id,
            isFavourite,
            __typename,
            name,
            isCustom,
            formatMessage,
            isOwner,
            isEditable,
            isAdmin,
            filterId,
            sendFilterActionAnalytics,
            openCopyFilterModal,
            openEditFilterModal,
            openChangeOwnerModal,
            openDeleteFilterModal
        ]);
        const sendMeatballAnalytics = (0, $5uXOq.useCallback)(()=>{
            sendFilterAnalytics((0, $ce8062101363feb9$export$b887e88d8d0739f6), (0, (0, parcelRequire("qBWno")).getFilterMeatBallAttributes)({
                isCustom: isCustom,
                isFavourite: isFavourite,
                filterId: filterId
            }));
        }, [
            filterId,
            isCustom,
            isFavourite,
            sendFilterAnalytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            onOpen: sendMeatballAnalytics,
            MenuItems: MenuItems,
            name: name
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cKjus")).AsyncSaveFilterDialogContent), {
            isOpen: isCopyFilterModalOpen,
            filterId: filterId,
            jql: jql,
            title: formatMessage((0, (0, parcelRequire("199zy")).default).copyFilterDialogTitle),
            onCloseModal: closeCopyFilterModal,
            onFilterSave: onFilterSave
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6KXPO")).AsyncUpdateFilterDialog), {
            isOpen: isEditFilterModalOpen,
            filterId: filterId ?? '',
            onCloseModal: closeEditFilterModal
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gDIE0")).ChangeOwnerModal), {
            isOpen: isChangeOwnerModalOpen,
            filterId: filterId,
            onRefetch: onRefetch,
            onClose: closeChangeOwnerModal
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l3IPn")).DeleteFilterModal), {
            isOpen: isDeleteFilterModalOpen,
            name: name,
            filterId: filterId,
            onRefetch: onRefetch,
            onClose: closeDeleteFilterModal
        }));
    };
});
parcelRegister("jaCjz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$349d0551267ba34b$export$2e2bcd8739ae039);
    const $349d0551267ba34b$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4FilterActions",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "filterId"
            },
            {
                "kind": "ScalarField",
                "name": "jql"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    },
                    {
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "accountId"
                            }
                        ]
                    }
                ],
                "type": "JiraCustomFilter"
            }
        ],
        "type": "JiraFilter",
        "abstractKey": "__isJiraFilter"
    };
    $349d0551267ba34b$var$node.hash = "ceac0ec9e5b4a025e25fe096d35c5d3b";
    var $349d0551267ba34b$export$2e2bcd8739ae039 = $349d0551267ba34b$var$node;
});
parcelRegister("8w53e", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $63353af41c1756be$var$_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $63353af41c1756be$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63353af41c1756be$var$CopyIcon = (props)=>$63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
    var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;
});
parcelRegister("4IrpZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36f08a2f957bd6ab$var$_react = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $36f08a2f957bd6ab$var$_baseNew = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $36f08a2f957bd6ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36f08a2f957bd6ab$var$DeleteIcon = (props)=>$36f08a2f957bd6ab$var$_react.default.createElement($36f08a2f957bd6ab$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.75 3.25V14c0 .69-.56 1.25-1.25 1.25h-7c-.69 0-1.25-.56-1.25-1.25V3.25m9.5 0h1.75m-1.75 0h-2.5m-7 0H1.5m1.75 0h2.5m0 0V.75h4.5v2.5m-4.5 0h4.5M6.5 5.5V13m3-7.5V13"/>`
        }, props));
    $36f08a2f957bd6ab$var$DeleteIcon.displayName = 'DeleteIcon';
    var $36f08a2f957bd6ab$var$_default = module.exports.default = $36f08a2f957bd6ab$var$DeleteIcon;
});
parcelRegister("5nRKm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3eb8cab3ab465b93$var$EditIcon = (props)=>$3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
        }, props));
    $3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
    var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;
});
parcelRegister("eRB05", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ad22b76beceec928$var$_react = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ad22b76beceec928$var$_baseNew = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ad22b76beceec928$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ad22b76beceec928$var$EmailIcon = (props)=>$ad22b76beceec928$var$_react.default.createElement($ad22b76beceec928$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 4.97V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v.97m14.5 0V12c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V4.97m14.5 0L8 8.986.75 4.971"/>`
        }, props));
    $ad22b76beceec928$var$EmailIcon.displayName = 'EmailIcon';
    var $ad22b76beceec928$var$_default = module.exports.default = $ad22b76beceec928$var$EmailIcon;
});
parcelRegister("7WnQL", function(module, exports) {
    $parcel$export(module.exports, "isFavoritableItemTypename", ()=>$28a998bf88e6dba6$export$2bcd2af12bfc25b5);
    var $eXQym;
    const $28a998bf88e6dba6$export$2bcd2af12bfc25b5 = (typename)=>(0, (0, parcelRequire("eXQym")).VALID_ITEM_TYPENAMES).some((itemTypename)=>itemTypename === typename);
});
parcelRegister("cKjus", function(module, exports) {
    $parcel$export(module.exports, "AsyncSaveFilterDialogContent", ()=>$c23de2261bd2f58d$export$e0d40cb0f88fa57d);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $c23de2261bd2f58d$var$SaveFilterDialogContent = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("jhgHE")), {
        ssr: false,
        moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/save-filter-dialog/save-filter-dialog-content/index.tsx"
    });
    const $c23de2261bd2f58d$export$e0d40cb0f88fa57d = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-save-filters-dialog-content",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c23de2261bd2f58d$var$SaveFilterDialogContent, props));
});
parcelRegister("jhgHE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3ChD0")
    ]).then(()=>parcelRequire('2lPrs'));
});
parcelRegister("6KXPO", function(module, exports) {
    $parcel$export(module.exports, "AsyncUpdateFilterDialog", ()=>$5522efbabcc83563$export$8692e2751472dade);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $5522efbabcc83563$var$UpdateFilterDialog = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("hF84P")), {
        ssr: false,
        moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/update-filter-dialog/index.tsx"
    });
    const $5522efbabcc83563$export$8692e2751472dade = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-update-filter-dialog",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5522efbabcc83563$var$UpdateFilterDialog, props));
});
parcelRegister("hF84P", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fBWcb")
    ]).then(()=>parcelRequire('36hTn'));
});
parcelRegister("qBWno", function(module, exports) {
    $parcel$export(module.exports, "useFilterActionsAnalytics", ()=>$e63dd990973b9127$export$97e99df7fbddf9f6);
    $parcel$export(module.exports, "getFilterActionAttributes", ()=>$e63dd990973b9127$export$b06742bfd24ebf9f);
    $parcel$export(module.exports, "getFilterMeatBallAttributes", ()=>$e63dd990973b9127$export$b8e6b9b84ba340a2);
    $parcel$export(module.exports, "getRecentAndFavouriteFilterAttributes", ()=>$e63dd990973b9127$export$2108e20c9691c7e4);
    $parcel$export(module.exports, "getDefaulFilterAttributes", ()=>$e63dd990973b9127$export$15e07b997aa6036a);
    var $jecJ3;
    var $ivGSs;
    var $jhS4y;
    var $8zOmE;
    var $2NMNM;
    const $e63dd990973b9127$export$97e99df7fbddf9f6 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireFilterActionAnalytics = (actionSubject, attributes)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: actionSubject
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS], attributes);
        };
        return fireFilterActionAnalytics;
    };
    const $e63dd990973b9127$var$systemFilterNameMap = [
        {
            name: 'myOpenIssues',
            id: '-1'
        },
        {
            name: 'reportedByMe',
            id: '-2'
        },
        {
            name: 'allIssues',
            id: '-4'
        },
        {
            name: 'openIssues',
            id: '-5'
        },
        {
            name: 'doneIssues',
            id: '-9'
        },
        {
            name: 'viewedRecently',
            id: '-3'
        },
        {
            name: 'resolvedRecently',
            id: '-7'
        },
        {
            name: 'updatedRecently',
            id: '-8'
        },
        {
            name: 'createdRecently',
            id: '-6'
        }
    ];
    const $e63dd990973b9127$export$c8c77a62dd73e040 = (id)=>{
        const systemFilter = $e63dd990973b9127$var$systemFilterNameMap.find((filter)=>filter.id === id);
        return systemFilter?.name || '';
    };
    const $e63dd990973b9127$var$getSection = (isCustom, isFavourite)=>{
        let section;
        if (!isCustom && !isFavourite) section = 'defaultFilters';
        else if (isFavourite) section = (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_STARRED);
        else section = (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_RECENT);
        return section;
    };
    const $e63dd990973b9127$var$getFilterId = (isCustom, filterId)=>{
        if (!filterId) return null;
        return (0, (0, parcelRequire("jhS4y")).ENTITY_ID).FILTER(isCustom ? filterId : $e63dd990973b9127$export$c8c77a62dd73e040(filterId));
    };
    const $e63dd990973b9127$export$b06742bfd24ebf9f = ({ itemId: itemId, isCustom: isCustom, isFavourite: isFavourite, filterId: filterId })=>{
        const section = $e63dd990973b9127$var$getSection(isCustom, Boolean(isFavourite));
        return {
            itemId: itemId,
            section: section,
            level: section === 'defaultFilters' ? (0, $951a0ed422513987$export$35ac629b8b943d5a) : (0, $951a0ed422513987$export$f9db6a58b4aabd18),
            componentType: isCustom ? (0, $1e554a683893bd46$export$5374c2c2d3ece55e) : (0, $1e554a683893bd46$export$74712b62056d422e),
            parentItemType: isCustom ? (0, $632bd8725b437a12$export$c1c49903035a02df) : (0, $632bd8725b437a12$export$6deee0e4f2fb784e),
            parentItemId: $e63dd990973b9127$var$getFilterId(isCustom, filterId)
        };
    };
    const $e63dd990973b9127$export$b8e6b9b84ba340a2 = ({ isCustom: isCustom, isFavourite: isFavourite, filterId: filterId })=>{
        const section = $e63dd990973b9127$var$getSection(isCustom, Boolean(isFavourite));
        return {
            section: section,
            level: section === 'defaultFilters' ? (0, $951a0ed422513987$export$f9db6a58b4aabd18) : (0, $951a0ed422513987$export$fe3b012b0224e4e1),
            componentType: isCustom ? (0, $1e554a683893bd46$export$9bd6c21d500ae611) : (0, $1e554a683893bd46$export$95b0c331af13d819),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e),
            parentItemType: isCustom ? (0, $632bd8725b437a12$export$c1c49903035a02df) : (0, $632bd8725b437a12$export$6deee0e4f2fb784e),
            parentItemId: $e63dd990973b9127$var$getFilterId(isCustom, filterId)
        };
    };
    const $e63dd990973b9127$export$2108e20c9691c7e4 = ({ isCustom: isCustom, filterId: filterId, section: section })=>{
        return {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            section: section,
            componentType: isCustom ? (0, $1e554a683893bd46$export$3ac911b122986477) : (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: $e63dd990973b9127$var$getFilterId(isCustom, filterId),
            itemType: isCustom ? (0, $632bd8725b437a12$export$c1c49903035a02df) : (0, $632bd8725b437a12$export$6deee0e4f2fb784e)
        };
    };
    const $e63dd990973b9127$export$15e07b997aa6036a = ({ filterId: filterId })=>{
        return {
            level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
            itemId: $e63dd990973b9127$var$getFilterId(false, filterId),
            section: 'defaultFilters',
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemType: (0, $632bd8725b437a12$export$6deee0e4f2fb784e)
        };
    };
});
parcelRegister("gDIE0", function(module, exports) {
    $parcel$export(module.exports, "ChangeOwnerModal", ()=>$af6a0238933bbda1$export$fe3f500d38bfe0df);
    var $5uXOq = parcelRequire("5uXOq");
    var $bSlMQ;
    const $af6a0238933bbda1$export$fe3f500d38bfe0df = ({ isOpen: isOpen, filterId: filterId, onRefetch: onRefetch, onClose: onClose })=>{
        const onSuccess = (0, $5uXOq.useCallback)(()=>{
            onRefetch({
                onComplete: ()=>undefined
            });
            onClose();
        }, [
            onRefetch,
            onClose
        ]);
        return isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bSlMQ")).default), {
            id: filterId,
            onInitiateSuccess: ()=>undefined,
            onSuccess: onSuccess,
            onCancel: onClose,
            onInitiateFailed: ()=>undefined
        });
    };
});
parcelRegister("bSlMQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b0e45c1a3e32250$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $j55bS;
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $5b0e45c1a3e32250$var$NoLazyAsyncChangeOwnerFilterModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("Jx7Th")), {
        moduleId: "./src/packages/global-pages/directories/filters-directory-v2/change-owner-filter-modal/src/index.tsx"
    });
    const $5b0e45c1a3e32250$var$AsyncChangeOwnerFilterModal = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "configure-owner-modal",
            packageName: "filter",
            fallback: "flag",
            teamName: "endeavour"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "change-owner-filter-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j55bS")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5b0e45c1a3e32250$var$NoLazyAsyncChangeOwnerFilterModal, props)));
    var $5b0e45c1a3e32250$export$2e2bcd8739ae039 = $5b0e45c1a3e32250$var$AsyncChangeOwnerFilterModal;
});
parcelRegister("Jx7Th", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8g8En").then(()=>parcelRequire('2gMly'));
});
parcelRegister("l3IPn", function(module, exports) {
    $parcel$export(module.exports, "DeleteFilterModal", ()=>$fae9ebce90c122ba$export$7eeb027d3dbb72df);
    var $5uXOq = parcelRequire("5uXOq");
    var $eM3no;
    var $pa9q9;
    var $ieDtd;
    var $lVJAU;
    var $ddrvO;
    const $fae9ebce90c122ba$export$7eeb027d3dbb72df = ({ isOpen: isOpen, name: name, filterId: filterId, onClose: onClose, onRefetch: onRefetch })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const [filterQueryParam] = (0, (0, parcelRequire("ieDtd")).useQueryParam)('filter');
        const onSuccess = (0, $5uXOq.useCallback)(()=>{
            onRefetch({
                onComplete: ()=>undefined
            });
            if (filterQueryParam === filterId) push('/jira/filters');
            onClose();
            showFlag({
                id: 'filter-deleted',
                title: [
                    (0, (0, parcelRequire("ddrvO")).default).filterDeletedModalTitleSuccessNonFinal,
                    {
                        name: name
                    }
                ],
                type: 'success'
            });
        }, [
            filterId,
            filterQueryParam,
            name,
            onClose,
            onRefetch,
            push,
            showFlag
        ]);
        const onFailure = (0, $5uXOq.useCallback)(()=>{
            onClose();
            showFlag({
                id: 'filter-delete-failed',
                title: (0, (0, parcelRequire("ddrvO")).default).filterDeletedModalTitleErrorNonFinal,
                description: (0, (0, parcelRequire("ddrvO")).default).filterDeletedModalDescriptionErrorNonFinal,
                type: 'error'
            });
        }, [
            onClose,
            showFlag
        ]);
        const filter = {
            name: name,
            id: filterId
        };
        return isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eM3no")).default), {
            baseUrl: "",
            filter: filter,
            onFilterDeleted: onSuccess,
            onFilterDeleteFailed: onFailure,
            onFilterInitiateFailed: onFailure,
            onCancel: onClose
        });
    };
});
parcelRegister("eM3no", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06cd5fbdfa743d8b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $jzjy1;
    var $jD5no;
    var $lf2Au;
    var $7iJwP;
    var $dZMvI;
    var $jemkP;
    var $aDeVF;
    var $9ekJG;
    class $06cd5fbdfa743d8b$var$DeleteModal extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onInitialised: (0, ($parcel$interopDefault($8Rkzz))),
                onFilterDeleted: (0, ($parcel$interopDefault($8Rkzz))),
                onCancel: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        constructor(props){
            super(props);
            this.store = (0, (0, parcelRequire("aDeVF")).default)((0, (0, parcelRequire("dZMvI")).default));
            this.store.dispatch((0, (0, parcelRequire("jemkP")).setAppProps)(this.props));
            this.store.dispatch((0, (0, parcelRequire("jemkP")).getAssociatedItems)());
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
                store: this.store,
                hasErrorBoundary: false
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
                id: "unhandled",
                packageName: "jiraDeleteFiltersModal",
                teamName: "jira-cosmos"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lf2Au")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ekJG")).default), null))));
        }
    }
    var $06cd5fbdfa743d8b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('deleteFilter', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))($06cd5fbdfa743d8b$var$DeleteModal);
});
parcelRegister("lf2Au", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9249f8c63b854f95$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $gwIPs;
    var $cSD7y;
    const $9249f8c63b854f95$var$AppStyle = ({ children: children })=>$5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ect41sbm _1wyb1oud _4t3i1kw7 _1dyz4jg8"
            ])
        }, children);
    const $9249f8c63b854f95$var$AppStyleOld = (0, $47bDC.default).div.withConfig({
        componentId: "h5xpn2-0"
    })({
        fontFamily: (0, parcelRequire("gwIPs")).fontFamily,
        fontSize: `${(0, (0, parcelRequire("gwIPs")).fontSize)}px`,
        height: 'inherit',
        letterSpacing: 'normal'
    });
    const $9249f8c63b854f95$var$appStyles = null;
    const $9249f8c63b854f95$var$AppStyleFinal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jfp-1020-use-compiled', $9249f8c63b854f95$var$AppStyle, $9249f8c63b854f95$var$AppStyleOld);
    var $9249f8c63b854f95$export$2e2bcd8739ae039 = $9249f8c63b854f95$var$AppStyleFinal;
});
parcelRegister("dZMvI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8e39f8e320e7804$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $kzfeq;
    var $b5iht;
    var $a8e39f8e320e7804$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("kzfeq")).default), (0, (0, parcelRequire("b5iht")).default));
});
parcelRegister("kzfeq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b20171187c0eaaf$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    parcelRequire("9o0uh");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $fsh9d;
    var $3HwlS;
    var $i2hR1;
    var $jemkP;
    var $iOraS;
    var $1b20171187c0eaaf$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("jemkP")).DELETE_FILTER)).mergeMap(({ onComplete: onComplete })=>{
            const state = store.getState();
            const baseUrl = (0, (0, parcelRequire("iOraS")).getBaseUrl)(state);
            const filter = (0, (0, parcelRequire("iOraS")).getFilter)(state);
            return (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("i2hR1")).default)(baseUrl, filter.id)).mergeMap(()=>{
                (0, (0, parcelRequire("iOraS")).getOnFilterDeleted)(state)(filter);
                (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && onComplete?.();
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("jemkP")).filterDeleted)());
            }).catch((error)=>{
                (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, 'directories.filters-v2.delete-modal.ops.delete-filter', (0, $c6c682f59adc6c63$export$9c2a9d62bcf944f8));
                (0, (0, parcelRequire("iOraS")).getOnFilterDeleteFailed)(state)(filter);
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("jemkP")).deleteFilterFailed)());
            });
        });
});
parcelRegister("fsh9d", function(module, exports) {
    $parcel$export(module.exports, "logSafeErrorWithoutCustomerData", ()=>$064efdbf2b7e743c$export$c77be5886e7f1d9e);
    var $dJl1T;
    const $064efdbf2b7e743c$export$b94ad046ae639a1c = (error, location, suffix, message)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, message || error.message, error);
    const $064efdbf2b7e743c$export$c77be5886e7f1d9e = (error, location, suffix, message)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, message || error.message, error);
});
const $c6c682f59adc6c63$export$9c2a9d62bcf944f8 = 'directories.filters.error';
parcelRegister("i2hR1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f063f6444575f430$export$2e2bcd8739ae039);
    var $lNsNP;
    var $f063f6444575f430$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, (0, parcelRequire("lNsNP")).default)(baseUrl, filterId);
});
parcelRegister("lNsNP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3cc82205e32ffce$export$2e2bcd8739ae039);
    var $eusud;
    const $d3cc82205e32ffce$export$7138c24907de3954 = (baseUrl, filterId)=>`/rest/api/3/filter/${filterId}`;
    var $d3cc82205e32ffce$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, (0, parcelRequire("eusud")).performDeleteRequest)($d3cc82205e32ffce$export$7138c24907de3954(baseUrl, filterId));
});
parcelRegister("jemkP", function(module, exports) {
    $parcel$export(module.exports, "SET_APP_PROPS", ()=>$62c4330949a1ef35$export$8aefe701a6f431e0);
    $parcel$export(module.exports, "setAppProps", ()=>$62c4330949a1ef35$export$cfda7627848a58cd);
    $parcel$export(module.exports, "GET_ASSOCIATED_ITEMS", ()=>$62c4330949a1ef35$export$30d51c320095bdf2);
    $parcel$export(module.exports, "getAssociatedItems", ()=>$62c4330949a1ef35$export$41e54fd4a1e5f9ba);
    $parcel$export(module.exports, "ASSOCIATED_ITEMS_RETRIEVED", ()=>$62c4330949a1ef35$export$ba1e7147572f059);
    $parcel$export(module.exports, "associatedItemsRetrieved", ()=>$62c4330949a1ef35$export$25e9475c64e5eda0);
    $parcel$export(module.exports, "GET_ASSOCIATED_ITEMS_FAILED", ()=>$62c4330949a1ef35$export$4c7da338bde02996);
    $parcel$export(module.exports, "getAssociatedItemsFailed", ()=>$62c4330949a1ef35$export$bc1efa3ceb08db7b);
    $parcel$export(module.exports, "DELETE_FILTER", ()=>$62c4330949a1ef35$export$c90b00f6f11adca7);
    $parcel$export(module.exports, "deleteFilter", ()=>$62c4330949a1ef35$export$d80cc0328fcc6685);
    $parcel$export(module.exports, "DELETE_FILTER_FAILED", ()=>$62c4330949a1ef35$export$d3f2a09b0efe5b07);
    $parcel$export(module.exports, "deleteFilterFailed", ()=>$62c4330949a1ef35$export$e303ddf5f6d63378);
    $parcel$export(module.exports, "FILTER_DELETED", ()=>$62c4330949a1ef35$export$c8cf94be5a7baff9);
    $parcel$export(module.exports, "filterDeleted", ()=>$62c4330949a1ef35$export$9411fafcb56b5a87);
    const $62c4330949a1ef35$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
    const $62c4330949a1ef35$export$cfda7627848a58cd = (payload)=>({
            type: $62c4330949a1ef35$export$8aefe701a6f431e0,
            payload: payload
        });
    const $62c4330949a1ef35$export$30d51c320095bdf2 = 'state.GET_ASSOCIATED_ITEMS';
    const $62c4330949a1ef35$export$41e54fd4a1e5f9ba = ()=>({
            type: $62c4330949a1ef35$export$30d51c320095bdf2
        });
    const $62c4330949a1ef35$export$ba1e7147572f059 = 'state.ASSOCIATED_ITEMS_RETRIEVED';
    const $62c4330949a1ef35$export$25e9475c64e5eda0 = (payload)=>({
            type: $62c4330949a1ef35$export$ba1e7147572f059,
            payload: payload
        });
    const $62c4330949a1ef35$export$4c7da338bde02996 = 'state.GET_ASSOCIATED_ITEMS_FAILED';
    const $62c4330949a1ef35$export$bc1efa3ceb08db7b = ()=>({
            type: $62c4330949a1ef35$export$4c7da338bde02996
        });
    const $62c4330949a1ef35$export$c90b00f6f11adca7 = 'state.DELETE_FILTER';
    const $62c4330949a1ef35$export$d80cc0328fcc6685 = (onComplete)=>({
            type: $62c4330949a1ef35$export$c90b00f6f11adca7,
            onComplete: onComplete
        });
    const $62c4330949a1ef35$export$d3f2a09b0efe5b07 = 'state.DELETE_FILTER_FAILED';
    const $62c4330949a1ef35$export$e303ddf5f6d63378 = ()=>({
            type: $62c4330949a1ef35$export$d3f2a09b0efe5b07
        });
    const $62c4330949a1ef35$export$c8cf94be5a7baff9 = 'state.FILTER_DELETED';
    const $62c4330949a1ef35$export$9411fafcb56b5a87 = ()=>({
            type: $62c4330949a1ef35$export$c8cf94be5a7baff9
        });
});
parcelRegister("iOraS", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$317d9690ead12f9d$export$f654b28f82155665);
    $parcel$export(module.exports, "getFilter", ()=>$317d9690ead12f9d$export$61ec8404f465cd36);
    $parcel$export(module.exports, "getFilterName", ()=>$317d9690ead12f9d$export$b055b0a980ec5c8b);
    $parcel$export(module.exports, "getOnInitialised", ()=>$317d9690ead12f9d$export$47263859bc15a8b8);
    $parcel$export(module.exports, "getOnFilterDeleted", ()=>$317d9690ead12f9d$export$f5f4c932a633fd32);
    $parcel$export(module.exports, "getOnFilterDeleteFailed", ()=>$317d9690ead12f9d$export$eb50a3cf06607a3c);
    $parcel$export(module.exports, "getOnFilterInitiateFailed", ()=>$317d9690ead12f9d$export$9ef18d2a82ac120);
    $parcel$export(module.exports, "getOnCancel", ()=>$317d9690ead12f9d$export$2c6267c00ffc9906);
    $parcel$export(module.exports, "isDeleteInProgress", ()=>$317d9690ead12f9d$export$906c0d65e4ece39d);
    $parcel$export(module.exports, "isDataRetrieved", ()=>$317d9690ead12f9d$export$a9211cdc0a6969f);
    $parcel$export(module.exports, "getAssociatedBoards", ()=>$317d9690ead12f9d$export$2de9e9ee805a66);
    $parcel$export(module.exports, "getAssociatedUsers", ()=>$317d9690ead12f9d$export$4004cc0feaedb1d1);
    $parcel$export(module.exports, "getAssociatedGroups", ()=>$317d9690ead12f9d$export$4f21761c9913ab49);
    $parcel$export(module.exports, "getCanDelete", ()=>$317d9690ead12f9d$export$e31d21defdc79bd5);
    const $317d9690ead12f9d$export$f654b28f82155665 = (state)=>state.appProps.baseUrl;
    const $317d9690ead12f9d$export$61ec8404f465cd36 = (state)=>state.appProps.filter;
    const $317d9690ead12f9d$export$b055b0a980ec5c8b = (state)=>state.appProps.filter.name;
    const $317d9690ead12f9d$export$47263859bc15a8b8 = (state)=>state.appProps.onInitialised;
    const $317d9690ead12f9d$export$f5f4c932a633fd32 = (state)=>state.appProps.onFilterDeleted;
    const $317d9690ead12f9d$export$eb50a3cf06607a3c = (state)=>state.appProps.onFilterDeleteFailed;
    const $317d9690ead12f9d$export$9ef18d2a82ac120 = (state)=>state.appProps.onFilterInitiateFailed;
    const $317d9690ead12f9d$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
    const $317d9690ead12f9d$export$906c0d65e4ece39d = (state)=>state.isDeleteInProgress;
    const $317d9690ead12f9d$export$a9211cdc0a6969f = (state)=>state.isDataRetrieved;
    const $317d9690ead12f9d$export$2de9e9ee805a66 = (state)=>state.boards;
    const $317d9690ead12f9d$export$4004cc0feaedb1d1 = (state)=>state.users;
    const $317d9690ead12f9d$export$4f21761c9913ab49 = (state)=>state.groups;
    const $317d9690ead12f9d$export$e31d21defdc79bd5 = (state)=>Array.isArray(state.boards) && state.boards.length === 0;
});
parcelRegister("b5iht", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b80972f9b3fefbb4$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    parcelRequire("9o0uh");
    parcelRequire("9IWoG");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $fsh9d;
    var $2idt2;
    var $7r08o;
    var $jemkP;
    var $iOraS;
    var $b80972f9b3fefbb4$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("jemkP")).GET_ASSOCIATED_ITEMS)).mergeMap(()=>{
            const state = store.getState();
            const baseUrl = (0, (0, parcelRequire("iOraS")).getBaseUrl)(state);
            const filter = (0, (0, parcelRequire("iOraS")).getFilter)(state);
            return (0, $kVLXA.Observable).forkJoin((0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("2idt2")).default)(baseUrl, filter.id)), (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("7r08o")).default)(baseUrl, filter.id))).map(([boards, subscriptions])=>{
                const { users: users, groups: groups } = subscriptions;
                (0, (0, parcelRequire("iOraS")).getOnInitialised)(state)();
                return (0, (0, parcelRequire("jemkP")).associatedItemsRetrieved)({
                    boards: boards,
                    users: users,
                    groups: groups
                });
            }).catch((error)=>{
                (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, 'directories.filters-v2.delete-modal.ops.get-associated-items', (0, $c6c682f59adc6c63$export$9c2a9d62bcf944f8));
                (0, (0, parcelRequire("iOraS")).getOnFilterInitiateFailed)(state)(filter);
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("jemkP")).getAssociatedItemsFailed)());
            });
        });
});
parcelRegister("2idt2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f9e6e4df190511d$export$2e2bcd8739ae039);
    var $fDRaW;
    var $1rV38;
    var $5f9e6e4df190511d$export$2e2bcd8739ae039 = async (baseUrl, filterId)=>{
        const response = await (0, (0, parcelRequire("fDRaW")).default)(baseUrl, filterId);
        return (0, (0, parcelRequire("1rV38")).default)(response, baseUrl);
    };
});
parcelRegister("fDRaW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57ef3264d1641307$export$2e2bcd8739ae039);
    var $7f4tk;
    const $57ef3264d1641307$export$7138c24907de3954 = (baseUrl, filterId)=>`/rest/agile/1.0/board/filter/${filterId}`;
    var $57ef3264d1641307$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, (0, parcelRequire("7f4tk")).default)($57ef3264d1641307$export$7138c24907de3954(baseUrl, filterId));
});
parcelRegister("1rV38", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af931ea4cf63d8b4$export$2e2bcd8739ae039);
    const $af931ea4cf63d8b4$export$b708cb7873d8352c = (baseUrl, id)=>`/secure/RapidBoard.jspa?rapidView=${id}&useStoredSettings=true`;
    var $af931ea4cf63d8b4$export$2e2bcd8739ae039 = (response, baseUrl)=>{
        const boards = response && response.values || [];
        return boards.map((board)=>{
            const { name: name, id: id } = board;
            const href = $af931ea4cf63d8b4$export$b708cb7873d8352c(baseUrl, id);
            return {
                name: name,
                id: id,
                href: href
            };
        });
    };
});
parcelRegister("7r08o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ddd004cba93b1adc$export$2e2bcd8739ae039);
    var $eAHx9;
    var $79DFK;
    var $ddd004cba93b1adc$export$2e2bcd8739ae039 = async (baseUrl, filterId)=>{
        const response = await (0, (0, parcelRequire("eAHx9")).default)(baseUrl, filterId);
        return (0, (0, parcelRequire("79DFK")).default)(response, baseUrl);
    };
});
parcelRegister("eAHx9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7443769520e58a35$export$2e2bcd8739ae039);
    var $7f4tk;
    const $7443769520e58a35$export$7138c24907de3954 = (baseUrl, filterId)=>`/rest/api/3/filter/${filterId}?expand=subscriptions`;
    var $7443769520e58a35$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, (0, parcelRequire("7f4tk")).default)($7443769520e58a35$export$7138c24907de3954(baseUrl, filterId));
});
parcelRegister("79DFK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$196e75ab8ca89e74$export$2e2bcd8739ae039);
    const $196e75ab8ca89e74$export$d62b55bf0ad74ba2 = (baseUrl, id)=>`/jira/people/${id}`;
    var $196e75ab8ca89e74$export$2e2bcd8739ae039 = (response, baseUrl)=>{
        const subscriptions = response && response.subscriptions && response.subscriptions.items || [];
        const users = [];
        const groups = [];
        subscriptions.forEach((subscription)=>{
            const { user: user, group: group } = subscription;
            if (group) return groups.push({
                name: group.name
            });
            const href = $196e75ab8ca89e74$export$d62b55bf0ad74ba2(baseUrl, user.accountId);
            return user && users.push({
                displayName: user.displayName,
                href: href
            });
        });
        return {
            users: users,
            groups: groups
        };
    };
});
parcelRegister("aDeVF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ce4dd7ecc996a54$export$2e2bcd8739ae039);
    var $F2Mxm;
    var $aXcJn;
    var $9ce4dd7ecc996a54$export$2e2bcd8739ae039 = (rootEpic)=>(0, (0, parcelRequire("F2Mxm")).default)({
            appName: 'directories/filters-v2/delete-modal',
            rootReducer: (0, parcelRequire("aXcJn")).default,
            rootEpic: rootEpic
        });
});
parcelRegister("aXcJn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3e77f8c76d4fb6d$export$2e2bcd8739ae039);
    var $jemkP;
    const $f3e77f8c76d4fb6d$export$49d5fc8cba920a0 = {
        appProps: undefined,
        boards: [],
        users: [],
        groups: [],
        isDataRetrieved: false,
        isDeleteInProgress: false
    };
    var $f3e77f8c76d4fb6d$export$2e2bcd8739ae039 = (state = $f3e77f8c76d4fb6d$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("jemkP")).SET_APP_PROPS:
                return {
                    ...state,
                    appProps: action.payload
                };
            case 0, (0, parcelRequire("jemkP")).DELETE_FILTER:
                return {
                    ...state,
                    isDeleteInProgress: true
                };
            case 0, (0, parcelRequire("jemkP")).FILTER_DELETED:
            case 0, (0, parcelRequire("jemkP")).DELETE_FILTER_FAILED:
                return {
                    ...state,
                    isDeleteInProgress: false
                };
            case 0, (0, parcelRequire("jemkP")).ASSOCIATED_ITEMS_RETRIEVED:
                {
                    const { boards: boards, users: users, groups: groups } = action.payload;
                    return {
                        ...state,
                        isDataRetrieved: true,
                        ...boards ? {
                            boards: boards
                        } : undefined,
                        ...users ? {
                            users: users
                        } : undefined,
                        ...groups ? {
                            groups: groups
                        } : undefined
                    };
                }
            case 0, (0, parcelRequire("jemkP")).GET_ASSOCIATED_ITEMS_FAILED:
            case 0, (0, parcelRequire("jemkP")).GET_ASSOCIATED_ITEMS:
                return state;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("9ekJG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffbff3d345f85465$export$2e2bcd8739ae039);
    var $bC2fB;
    var $iOraS;
    var $5d0Op;
    var $6EW7m;
    var $7rRaV;
    const $ffbff3d345f85465$var$mapStateToProps = (state)=>({
            Content: (0, parcelRequire("5d0Op")).default,
            Footer: (0, parcelRequire("6EW7m")).default,
            name: (0, (0, parcelRequire("iOraS")).getFilterName)(state),
            onCancel: (0, (0, parcelRequire("iOraS")).getOnCancel)(state),
            isOpen: (0, (0, parcelRequire("iOraS")).isDataRetrieved)(state)
        });
    var $ffbff3d345f85465$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($ffbff3d345f85465$var$mapStateToProps, {})((0, (0, parcelRequire("7rRaV")).default));
});
parcelRegister("5d0Op", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1dc72c582811a16$export$2e2bcd8739ae039);
    var $bC2fB;
    var $iOraS;
    var $8SnWj;
    const $d1dc72c582811a16$var$mapStateToProps = (state)=>({
            filter: (0, (0, parcelRequire("iOraS")).getFilter)(state),
            boards: (0, (0, parcelRequire("iOraS")).getAssociatedBoards)(state),
            users: (0, (0, parcelRequire("iOraS")).getAssociatedUsers)(state),
            groups: (0, (0, parcelRequire("iOraS")).getAssociatedGroups)(state)
        });
    var $d1dc72c582811a16$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($d1dc72c582811a16$var$mapStateToProps, {})((0, (0, parcelRequire("8SnWj")).default));
});
parcelRegister("8SnWj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62e1c0ece3b30ec8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e4yMr;
    var $koVbs;
    var $cRRmC;
    const $62e1c0ece3b30ec8$var$ContentWithoutBoardsAndSubscriptions = ({ formatMessage: formatMessage })=>(0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).noSubscriptionsAndBoards));
    const $62e1c0ece3b30ec8$var$ContentWithAssociatedSubscriptions = ({ formatMessage: formatMessage, groups: groups, users: users })=>users.length === 1 && groups.length === 0 || users.length === 0 && groups.length === 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).singleSubscription), users.length === 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
            href: users[0].href
        }, `${users[0].displayName}.`) : null, groups.length === 1 ? `${groups[0].name}.` : null), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).multipleBoardsWarning))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).multipleSubscriptions, {
            number: users.length + groups.length
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("ul", null, users.map(({ displayName: displayName, href: href }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                href: href
            }, displayName))), groups.map(({ name: name }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: index
            }, name))), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).multipleSubscriptionsWarning)));
    const $62e1c0ece3b30ec8$var$ContentWithAssociatedBoards = ({ boards: boards, formatMessage: formatMessage })=>boards.length === 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).singleBoard), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
            href: boards[0].href
        }, `${boards[0].name}.`)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).multipleBoardsWarning))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).multipleBoards, {
            number: boards.length
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("ul", null, boards.map(({ name: name, href: href }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                href: href
            }, name)))), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).multipleBoardsWarning)));
    const $62e1c0ece3b30ec8$export$7c6e2c02157bb7d2 = ({ boards: boards, groups: groups, users: users })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (users.length === 0 && groups.length === 0 && boards.length === 0) return (0, ($parcel$interopDefault($5uXOq))).createElement($62e1c0ece3b30ec8$var$ContentWithoutBoardsAndSubscriptions, {
            formatMessage: formatMessage
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).associatedItems)), boards.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement($62e1c0ece3b30ec8$var$ContentWithAssociatedBoards, {
            boards: boards,
            formatMessage: formatMessage
        }) : null, users.length > 0 || groups.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement($62e1c0ece3b30ec8$var$ContentWithAssociatedSubscriptions, {
            users: users,
            groups: groups,
            formatMessage: formatMessage
        }) : null);
    };
    var $62e1c0ece3b30ec8$export$2e2bcd8739ae039 = $62e1c0ece3b30ec8$export$7c6e2c02157bb7d2;
});
parcelRegister("cRRmC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3531ea37b151c3e0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3531ea37b151c3e0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noSubscriptionsAndBoards: {
            "id": "directories.filters-v2.delete-modal.content.no-subscriptions-and-boards",
            "defaultMessage": "Are you sure you want to delete this filter?"
        },
        associatedItems: {
            "id": "directories.filters-v2.delete-modal.content.associated-items",
            "defaultMessage": "This filter is used elsewhere. Deleting it may impact other people's work."
        },
        multipleSubscriptions: {
            "id": "directories.filters-v2.delete-modal.content.multiple-subscriptions",
            "defaultMessage": "This filter has currently {number} subscriptions:"
        },
        singleSubscription: {
            "id": "directories.filters-v2.delete-modal.content.single-subscription",
            "defaultMessage": "This filter has a subscription for "
        },
        multipleSubscriptionsWarning: {
            "id": "directories.filters-v2.delete-modal.content.multiple-subscriptions-warning",
            "defaultMessage": "Deleting this filter will cause subscription emails for these users and groups to no longer be delivered."
        },
        multipleBoards: {
            "id": "directories.filters-v2.delete-modal.content.multiple-boards",
            "defaultMessage": "This filter is currently being used by {number} boards:"
        },
        singleBoard: {
            "id": "directories.filters-v2.delete-modal.content.single-board",
            "defaultMessage": "This filter is currently being used by "
        },
        multipleBoardsWarning: {
            "id": "directories.filters-v2.delete-modal.content.multiple-boards-warning",
            "defaultMessage": "You'll need to remove this filters associations to the boards before it can be removed."
        }
    });
});
parcelRegister("6EW7m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$310670aed312a399$export$2e2bcd8739ae039);
    var $basmW = parcelRequire("basmW");
    var $iQv12;
    var $bC2fB;
    var $jemkP;
    var $iOraS;
    var $9pknF;
    const $310670aed312a399$var$mapStateToProps = (state)=>({
            filter: (0, (0, parcelRequire("iOraS")).getFilter)(state),
            canDelete: (0, (0, parcelRequire("iOraS")).getCanDelete)(state),
            deleteInProgress: (0, (0, parcelRequire("iOraS")).isDeleteInProgress)(state),
            onCancel: (0, (0, parcelRequire("iOraS")).getOnCancel)(state)
        });
    var $310670aed312a399$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("iQv12")).default)({
        onDelete: 'filterDeleted',
        onCancel: 'filterDeleteCanceled'
    }), (0, (0, parcelRequire("bC2fB")).connect)($310670aed312a399$var$mapStateToProps, {
        onDelete: (0, (0, parcelRequire("jemkP")).deleteFilter)
    }))((0, (0, parcelRequire("9pknF")).default));
});
parcelRegister("iQv12", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$945500a9598c3ac2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gvRPW;
    const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
        const providedKeys = Object.keys(ConnectedProps).sort();
        const cachedMappedProps = {};
        const cachedConnectedProps = {};
        const getStateFromMappedProps = (mapped)=>{
            providedKeys.forEach((key, index)=>{
                const prop = mapped[index];
                if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
                cachedMappedProps[key] = prop;
                cachedConnectedProps[key] = (...attrs)=>{
                    const analyticsEvent = attrs[attrs.length - 1].clone();
                    const connectedProp = ConnectedProps[key];
                    if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                        name: connectedProp,
                        analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                    }).fire();
                    else if (typeof connectedProp === 'function') {
                        const update = connectedProp(...attrs);
                        analyticsEvent.update({
                            ...update,
                            analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                        }).fire();
                    }
                    if (typeof prop === 'function') prop(...attrs);
                };
            });
            return cachedConnectedProps;
        };
        return (WrappedComponent)=>class WithAnalytics extends (0, $5uXOq.Component) {
                static{
                    this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
                }
                render() {
                    const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                        ...this.props,
                        ...newMappedProps
                    });
                }
            };
    };
    var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;
});
parcelRegister("9pknF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8841fecfbc7d37be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $ldJSL;
    var $juxqI;
    var $dC5iT;
    var $8CUq3;
    var $eZJjh;
    var $az4zD;
    var $3HwlS;
    var $7hmi2;
    var $7kS0u;
    const $8841fecfbc7d37be$var$Footer = ({ intl: { formatMessage: formatMessage }, canDelete: canDelete, deleteInProgress: deleteInProgress, onCancel: onCancel, onDelete: onDelete })=>{
        const { publish: publish } = (0, (0, parcelRequire("7hmi2")).useDeleteChangeActions)();
        const onDeleteWithEvent = (event, analyticsEvent)=>{
            onDelete(publish, event, analyticsEvent);
        };
        const onDeleteOld = (event, analyticsEvent)=>{
            onDelete(undefined, event, analyticsEvent);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($8841fecfbc7d37be$var$Container, null, deleteInProgress && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8841fecfbc7d37be$var$spinnerContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "danger",
            type: "submit",
            isDisabled: !canDelete,
            onClick: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? onDeleteWithEvent : onDeleteOld
        }, formatMessage((0, (0, parcelRequire("7kS0u")).default).delete)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            isDisabled: deleteInProgress,
            onClick: onCancel
        }, formatMessage((0, (0, parcelRequire("7kS0u")).default).cancelButtonCaption)))));
    };
    $8841fecfbc7d37be$var$Footer.defaultProps = {
        onDelete: (0, ($parcel$interopDefault($8Rkzz))),
        onCancel: (0, ($parcel$interopDefault($8Rkzz))),
        deleteInProgress: false,
        canDelete: true
    };
    var $8841fecfbc7d37be$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($8841fecfbc7d37be$var$Footer);
    const $8841fecfbc7d37be$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3 _4cvr1h6o _16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $8841fecfbc7d37be$var$spinnerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.200'
    });
});
parcelRegister("7kS0u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc97edda63b98d49$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bc97edda63b98d49$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        delete: {
            "id": "directories.filters-v2.delete-modal.footer.delete",
            "defaultMessage": "Delete"
        },
        cancelButtonCaption: {
            "id": "directories.filters-v2.delete-modal.footer.cancel-button-caption",
            "defaultMessage": "Cancel"
        }
    });
});
parcelRegister("7rRaV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3b1435469220d97$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $7QSqG;
    var $jgVsb;
    var $gofOI;
    var $i8Qvm;
    var $hZHze;
    var $9fuVs;
    var $az4zD;
    var $liKYS;
    const $d3b1435469220d97$var$DeleteModal = ({ intl: { formatMessage: formatMessage }, isOpen: isOpen, Content: Content, Footer: Footer, onCancel: onCancel, name: name })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "small",
            onClose: onCancel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: "danger"
        }, formatMessage((0, (0, parcelRequire("liKYS")).default).title, {
            name: name
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(Content, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement(Footer, {
            onClose: onCancel
        }))));
    var $d3b1435469220d97$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($d3b1435469220d97$var$DeleteModal);
});
parcelRegister("hZHze", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69dc4a27be9f367e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $994MI;
    var $cb25w;
    var $gvRPW;
    class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.props.onMount();
        }
        render() {
            return null;
        }
    }
    const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'view-tracker'
    })((0, (0, parcelRequire("cb25w")).default)({
        onMount: (createEvent)=>createEvent({
                action: (0, (0, parcelRequire("gvRPW")).PAGE_EVENT_ACTION)
            }).fire()
    })($69dc4a27be9f367e$var$ViewTracker));
    var $69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
            onMount: (0, ($parcel$interopDefault($8Rkzz)))
        });
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("liKYS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33404efbe1d974cc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $33404efbe1d974cc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "directories.filters-v2.delete-modal.title",
            "defaultMessage": "Delete {name}"
        }
    });
});
parcelRegister("ddrvO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d826b76ed7b00be0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d826b76ed7b00be0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filterDeletedModalTitleSuccessNonFinal: {
            "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-success-non-final",
            "defaultMessage": "{name} was deleted"
        },
        filterDeletedModalTitleErrorNonFinal: {
            "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-error-non-final",
            "defaultMessage": "We couldn't delete filter"
        },
        filterDeletedModalDescriptionErrorNonFinal: {
            "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-description-error-non-final",
            "defaultMessage": "There was an error, please try again."
        }
    });
});
parcelRegister("199zy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d773a1ee239d0f58$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d773a1ee239d0f58$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        manageSubscription: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription",
            "defaultMessage": "Manage subscriptions"
        },
        copyFilter: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter",
            "defaultMessage": "Copy filter"
        },
        copyFilterDialogTitle: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-dialog-title",
            "defaultMessage": "Copy filter"
        },
        edit: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit",
            "defaultMessage": "Edit filter"
        },
        changeOwner: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner",
            "defaultMessage": "Change owner"
        },
        delete: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete",
            "defaultMessage": "Delete filter"
        },
        manageSubscriptionWithName: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription-with-name",
            "defaultMessage": "Manage subscriptions for {name}"
        },
        copyFilterWithName: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-with-name",
            "defaultMessage": "Copy filter {name}"
        },
        editWithName: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit-with-name",
            "defaultMessage": "Edit filter {name}"
        },
        changeOwnerWithName: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner-with-name",
            "defaultMessage": "Change owner for {name}"
        },
        deleteWithName: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete-with-name",
            "defaultMessage": "Delete filter {name}"
        }
    });
});
parcelRegister("eKG0o", function(module, exports) {
    $parcel$export(module.exports, "useModalState", ()=>$d7462e2c0d74d90a$export$baa48889c42cc6cb);
    var $5uXOq = parcelRequire("5uXOq");
    const $d7462e2c0d74d90a$export$baa48889c42cc6cb = (defaultOpen = false)=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultOpen);
        const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
            setIsOpen
        ]);
        const onOpen = (0, $5uXOq.useCallback)(()=>setIsOpen(true), [
            setIsOpen
        ]);
        return {
            isOpen: isOpen,
            onClose: onClose,
            onOpen: onOpen
        };
    };
});
parcelRegister("MaZbq", function(module, exports) {
    $parcel$export(module.exports, "SimpleFilterMenuItem", ()=>$43f8c4d99214e245$export$608d42ceb4060968);
    var $5uXOq = parcelRequire("5uXOq");
    var $jX361;
    var $4zlUA;
    var $jhS4y;
    var $5FnJJ;
    function $43f8c4d99214e245$export$608d42ceb4060968({ actionsOnHover: actionsOnHover, filterId: filterId, name: name, onClick: onClick }) {
        const handlOnClick = (0, $5uXOq.useCallback)((e)=>{
            onClick?.();
            (0, (0, parcelRequire("4zlUA")).handleGinSPAClick)(e);
        }, [
            onClick
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            actionsOnHover: actionsOnHover,
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jX361"))))), {
                label: "",
                color: "currentColor"
            }),
            href: `/issues/?filter=${filterId}`,
            menuId: (0, (0, parcelRequire("jhS4y")).ENTITY_ID).FILTER(filterId),
            onClick: handlOnClick
        }, name);
    }
});
parcelRegister("4zlUA", function(module, exports) {
    $parcel$export(module.exports, "handleGinSPAClick", ()=>$7b30a009e09f47e3$export$f74673b086629362);
    const $7b30a009e09f47e3$export$f74673b086629362 = (e)=>{
        const href = typeof e.currentTarget.href === 'string' ? e.currentTarget.href : undefined;
        const openInNewTab = e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || e.button != null && e.button === 1;
        if (href == null || href === '' || e.defaultPrevented || openInNewTab) return;
        if (window.JIRA?.Issues?.Application) {
            e.preventDefault();
            window.JIRA.Issues.Application.execute('navigation:navigateToUrl', href, {
                forceRefresh: true,
                checkPermission: true,
                replace: false,
                reset: true,
                routerEvent: true
            });
        }
    };
});
parcelRegister("jjTbl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0092439b070ce89c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0092439b070ce89c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        recent: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.recent",
            "defaultMessage": "Recent"
        },
        starred: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.starred",
            "defaultMessage": "Starred"
        },
        viewAllStarred: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.view-all-starred",
            "defaultMessage": "View all starred items"
        },
        defaultFilters: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.default-filters",
            "defaultMessage": "Default filters"
        }
    });
});
const $095930ee3b140077$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Filters';
const $095930ee3b140077$export$d57b6b390e78d90f = 'empanada';
parcelRegister("eYeHi", function(module, exports) {
    $parcel$export(module.exports, "Footer", ()=>$36b3581ba956a97e$export$a06f1c675e846f6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $jhS4y;
    var $34PKs;
    var $b6S3k;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    var $qBWno;
    var $8sLEz;
    const $36b3581ba956a97e$var$VIEW_ALL_FILTERS_PATH = (0, (0, parcelRequire("b6S3k")).filtersDirectoryRoute).path;
    function $36b3581ba956a97e$export$a06f1c675e846f6f() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const sendFilterAnalytics = (0, (0, parcelRequire("qBWno")).useFilterActionsAnalytics)();
        const sendDefaultFilterDropdownAnalytics = (0, $5uXOq.useCallback)(()=>{
            sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: 'viewAllFilters'
            });
        }, [
            sendFilterAnalytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("34PKs")).ViewAllEntityMenuItem), {
            onClick: sendDefaultFilterDropdownAnalytics,
            href: $36b3581ba956a97e$var$VIEW_ALL_FILTERS_PATH,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS_VIEW_ALL)
        }, formatMessage((0, (0, parcelRequire("8sLEz")).default).viewAllFilters)))));
    }
});
parcelRegister("8sLEz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6fd2ed1497d7321$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b6fd2ed1497d7321$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewAllFilters: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.footer.view-all-filters",
            "defaultMessage": "View all filters"
        }
    });
});
parcelRegister("3XHNc", function(module, exports) {
    $parcel$export(module.exports, "Header", ()=>$7b1d5262779046c2$export$8b251419efc915eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $hyOJh;
    var $koVbs;
    var $jhS4y;
    var $5FnJJ;
    var $qBWno;
    var $bqhl5;
    const $7b1d5262779046c2$export$8b251419efc915eb = ({ onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const sendFilterAnalytics = (0, (0, parcelRequire("qBWno")).useFilterActionsAnalytics)();
        const handleOnClick = (0, $5uXOq.useCallback)((event)=>{
            sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: 'searchAllIssues'
            });
            onClose?.(event);
        }, [
            onClose,
            sendFilterAnalytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            href: "/issues/?jql=created%20%3E%3D%20-30d%20order%20by%20created%20DESC",
            onClick: handleOnClick,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS_SEARCH),
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyOJh"))))), {
                label: "",
                color: "currentColor"
            })
        }, formatMessage((0, (0, parcelRequire("bqhl5")).default).searchAllIssues));
    };
});
parcelRegister("bqhl5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2997cabf9dd4d5cf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2997cabf9dd4d5cf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchAllIssues: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.header.search-all-issues",
            "defaultMessage": "Search issues"
        }
    });
});
parcelRegister("iaOwN", function(module, exports) {
    $parcel$export(module.exports, "ActionButtons", ()=>$0188d5ec8b84466a$export$88c65d2d98aab183);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZUJu;
    var $46Cti;
    var $eaKdt;
    var $aCS3f;
    var $qBWno;
    function $0188d5ec8b84466a$export$88c65d2d98aab183({ onClose: onClose }) {
        const sendFilterAnalytics = (0, (0, parcelRequire("qBWno")).useFilterActionsAnalytics)();
        const sendMeatballAnalytics = (0, $5uXOq.useCallback)(()=>{
            sendFilterAnalytics((0, $ce8062101363feb9$export$b887e88d8d0739f6), {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
            });
        }, [
            sendFilterAnalytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            onOpen: sendMeatballAnalytics,
            MenuItems: $0188d5ec8b84466a$var$MoreMenuItems,
            onClose: onClose
        });
    }
    function $0188d5ec8b84466a$var$MoreMenuItems(_) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaKdt")).HideL1MenuItemSection), {
            menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS,
            hasSeparator: false
        }));
    }
});
parcelRegister("6jcf1", function(module, exports) {
    $parcel$export(module.exports, "Nav4FiltersDefault", ()=>$58a856783fb255e5$export$c9a2a24425c3fa5e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $jecJ3;
    var $jhS4y;
    var $aGONy;
    var $46Cti;
    var $c16H2;
    var $338xa;
    var $dQbFB;
    var $eQV8d;
    var $dUyqZ;
    var $4zcxJ;
    var $koeKL;
    var $lnznH;
    var $cZa9B;
    var $eYeHi;
    var $3XHNc;
    var $bq9gb;
    function $58a856783fb255e5$export$c9a2a24425c3fa5e(props) {
        const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, simulateLoading: simulateLoading = false } = props;
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const currentURL = (0, (0, parcelRequire("aGONy")).useGetCurrentUrl)();
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                currentURL: currentURL
            }), [
            cloudId,
            currentURL
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("bq9gb")).asyncFiltersContentViewQuery), entryPointParams);
        const triggerRef = (0, (0, parcelRequire("4zcxJ")).useExpandableEntryPointTrigger)(entryPointActions);
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS);
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        (0, $5uXOq.useEffect)(()=>{
            if (isExpanded) entryPointActions.load();
        }, [
            entryPointActions,
            isExpanded
        ]);
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: menuId,
            onSystemToggle: (hasExpanded)=>{
                if (hasExpanded) entryPointActions.load();
            },
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) {
                    entryPointActions.load();
                    sendSectionItemAnalyticsEvent({
                        menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS,
                        sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_FILTERS)
                    });
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            interactionName: "nav4-sidebar-filters-default",
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            ref: triggerRef,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3XHNc")).Header), null), simulateLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-filters-default",
            packageName: (0, $095930ee3b140077$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $095930ee3b140077$export$d57b6b390e78d90f),
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null),
            runtimeProps: entryPointParams
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eYeHi")).Footer), null)));
    }
});
parcelRegister("bq9gb", function(module, exports) {
    $parcel$export(module.exports, "asyncFiltersContentViewQuery", ()=>$54738359b90672c7$export$fae48e64221e5e6e);
    var $h5aHz;
    var $eufEc;
    var $fEDBv;
    const $54738359b90672c7$export$fae48e64221e5e6e = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("eFg3S")).then(({ Nav4FiltersContentViewQuery: Nav4FiltersContentViewQuery })=>Nav4FiltersContentViewQuery), {
            moduleId: "efb9eb25",
            moduleName: "Nav4FiltersContentViewQuery"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                queries: {
                    filters: {
                        parameters: (0, parcelRequire("h5aHz")).default,
                        variables: {
                            cloudId: cloudId
                        }
                    }
                }
            })
    });
});
parcelRegister("h5aHz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e23e452905350c49$export$2e2bcd8739ae039);
    const $e23e452905350c49$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v3 = {
            "kind": "ScalarField",
            "name": "filterId"
        }, v4 = {
            "kind": "ScalarField",
            "name": "name"
        }, v5 = {
            "kind": "ScalarField",
            "name": "id"
        }, v6 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v7 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v8 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                        v2,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v5
                    ]
                }
            ],
            "type": "JiraCustomFilter"
        }, v9 = {
            "kind": "InlineFragment",
            "selections": [
                v5
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v10 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "Nav4FiltersContentViewQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4FiltersContent"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "Nav4FiltersContentViewQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "favouriteFilters",
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "FILTER"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v2,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v3,
                                                            v4,
                                                            v5,
                                                            v6,
                                                            v7,
                                                            v8
                                                        ],
                                                        "type": "JiraFilter",
                                                        "abstractKey": "__isJiraFilter"
                                                    },
                                                    v9
                                                ]
                                            }
                                        ]
                                    },
                                    v10
                                ]
                            },
                            {
                                "alias": "recentFilters",
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "FILTER"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v2,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v3,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v4,
                                                                    v5,
                                                                    v6,
                                                                    v7,
                                                                    v8
                                                                ],
                                                                "type": "JiraFilter",
                                                                "abstractKey": "__isJiraFilter"
                                                            }
                                                        ],
                                                        "type": "JiraCustomFilter"
                                                    },
                                                    v9
                                                ]
                                            }
                                        ]
                                    },
                                    v10
                                ]
                            },
                            {
                                "args": [
                                    v1
                                ],
                                "concreteType": "JiraSystemFilterConnection",
                                "kind": "LinkedField",
                                "name": "systemFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSystemFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSystemFilter",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    v5,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v4,
                                                            v2,
                                                            v6,
                                                            v7,
                                                            v8
                                                        ],
                                                        "type": "JiraFilter",
                                                        "abstractKey": "__isJiraFilter"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "15f20295198d671c8f6fcbeffb998d2f0a1e56a1e57ac866258c898d50cb0c95",
                "metadata": {},
                "name": "Nav4FiltersContentViewQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $e23e452905350c49$var$node.hash = "9218fd54b0172bf14bf1082dd5032107";
    var $e23e452905350c49$export$2e2bcd8739ae039 = $e23e452905350c49$var$node;
});
parcelRegister("eFg3S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("akgtj").then(()=>parcelRequire('7EWLy'));
});
parcelRegister("VyuC0", function(module, exports) {
    $parcel$export(module.exports, "Nav4Operations", ()=>$7b6a2654543e51de$export$bc4d01c843cee95e);
    var $e2y3Y;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jhS4y;
    var $c6x3L;
    var $37Ssu;
    var $2CMcE;
    const $7b6a2654543e51de$export$bc4d01c843cee95e = ({ isExpanded: isExpanded, queryRef: queryRef })=>{
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("e2y3Y")).default), queryRef);
        const { isInitialSelectedPath: isInitialSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        return isInitialSelectedPath((0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS)) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CMcE")).OperationsMenuForLanding), {
            isExpanded: isExpanded,
            queryRef: data
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("37Ssu")).OperationsMenuDefault), {
            isExpanded: isExpanded
        });
    };
});
parcelRegister("e2y3Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8997765d9fbf503d$export$2e2bcd8739ae039);
    const $8997765d9fbf503d$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isOperationsExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Operations",
        "selections": [
            {
                "condition": "isOperationsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "OperationsMenuForLanding"
                    }
                ]
            }
        ],
        "type": "Query"
    };
    $8997765d9fbf503d$var$node.hash = "1d297012078c362907ac313c8068c25a";
    var $8997765d9fbf503d$export$2e2bcd8739ae039 = $8997765d9fbf503d$var$node;
});
parcelRegister("37Ssu", function(module, exports) {
    $parcel$export(module.exports, "OperationsMenuDefault", ()=>$82831b0d881f1209$export$ef19d9521d85a60a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $338xa;
    var $4zcxJ;
    var $koeKL;
    var $83AHd;
    var $gzxPn;
    function $82831b0d881f1209$export$ef19d9521d85a60a(props) {
        const { isExpanded: isExpanded } = props;
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId
            }), [
            cloudId
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("83AHd")).asyncAlertsContentViewQuery), entryPointParams);
        const triggerRef = (0, (0, parcelRequire("4zcxJ")).useExpandableEntryPointTrigger)(entryPointActions);
        (0, $5uXOq.useEffect)(()=>{
            if (isExpanded) entryPointActions.load();
        }, [
            entryPointActions,
            isExpanded
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gzxPn")).OperationsExpandableMenuItem), {
            isExpanded: props.isExpanded,
            onSystemToggle: (hasExpanded)=>{
                if (hasExpanded) entryPointActions.load();
            },
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) entryPointActions.load();
            },
            triggerRef: triggerRef,
            AlertsMenuItemContent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "operations-menu-default",
                packageName: "jiraNavigationAppsSidebarNav4Operations",
                errorFallback: "flag",
                teamName: "platform-united",
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null),
                runtimeProps: entryPointParams
            })
        });
    }
});
parcelRegister("83AHd", function(module, exports) {
    $parcel$export(module.exports, "asyncAlertsContentViewQuery", ()=>$f6fac0db87404723$export$182f7de76119e38a);
    var $8myYV;
    var $eufEc;
    var $fEDBv;
    const $f6fac0db87404723$export$182f7de76119e38a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("LWXwm")).then(({ AlertsContentViewQuery: AlertsContentViewQuery })=>AlertsContentViewQuery), {
            moduleId: "4fcb17ab",
            moduleName: "AlertsContentViewQuery"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                queries: {
                    queryRef: {
                        parameters: (0, parcelRequire("8myYV")).default,
                        variables: {
                            cloudId: cloudId
                        }
                    }
                }
            })
    });
});
parcelRegister("8myYV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ef6ab9035056fc1$export$2e2bcd8739ae039);
    const $4ef6ab9035056fc1$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "alertSearchQuery"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "AlertsContentViewQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "AlertsMenuItemContent"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "AlertsContentViewQuery",
                "selections": [
                    {
                        "concreteType": "OpsgenieQuery",
                        "kind": "LinkedField",
                        "name": "opsgenie",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "OpsgenieSavedSearches",
                                "kind": "LinkedField",
                                "name": "savedSearches",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "OpsgenieSavedSearch",
                                        "kind": "LinkedField",
                                        "name": "sharedWithMe",
                                        "plural": true,
                                        "selections": v1
                                    },
                                    {
                                        "concreteType": "OpsgenieSavedSearch",
                                        "kind": "LinkedField",
                                        "name": "createdByMe",
                                        "plural": true,
                                        "selections": v1
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "5dc14d9b45658d763ede1d20f6cacfc41b556c2ecf39a4ccda0838f765d1f529",
                "metadata": {},
                "name": "AlertsContentViewQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $4ef6ab9035056fc1$var$node.hash = "96a759ca18187799c882e6cb40f5d4a4";
    var $4ef6ab9035056fc1$export$2e2bcd8739ae039 = $4ef6ab9035056fc1$var$node;
});
parcelRegister("LWXwm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6gpSK").then(()=>parcelRequire('7GeK2'));
});
parcelRegister("gzxPn", function(module, exports) {
    $parcel$export(module.exports, "OperationsExpandableMenuItem", ()=>$13a888bc5715405b$export$a04d9e9cc5ec19d3);
    var $5uXOq = parcelRequire("5uXOq");
    var $boIsJ;
    var $i6luQ;
    var $fDskX;
    var $gitmU;
    var $jecJ3;
    var $ivGSs;
    var $jhS4y;
    var $46Cti;
    var $c16H2;
    var $5FnJJ;
    var $dQbFB;
    var $24a2m;
    var $eQV8d;
    var $dUyqZ;
    var $8zOmE;
    var $2NMNM;
    var $lnznH;
    var $cZa9B;
    var $9MLkJ;
    var $7Qdrb;
    var $7zFZv;
    var $87kQ4;
    function $13a888bc5715405b$export$a04d9e9cc5ec19d3(props) {
        const { AlertsMenuItemContent: AlertsMenuItemContent, isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, onSystemToggle: onSystemToggle, triggerRef: triggerRef } = props;
        const { hasReports: hasReports } = (0, (0, parcelRequire("7Qdrb")).useFeatures)();
        const { icon: alertsIcon, formattedMessage: alertsMessage } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("9MLkJ")).default).alerts, (0, ($parcel$interopDefault((0, parcelRequire("boIsJ"))))));
        const { icon: overviewIcon, formattedMessage: overviewMessage } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("7zFZv")).default).overview, (0, ($parcel$interopDefault((0, parcelRequire("i6luQ"))))));
        const { icon: oncallSchedulesIcon, formattedMessage: oncallSchedulesMessage } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("7zFZv")).default).onCallSchedules, (0, ($parcel$interopDefault((0, parcelRequire("gitmU"))))));
        const { icon: reportsIcon, formattedMessage: reportsMessage } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("7zFZv")).default).reports, (0, ($parcel$interopDefault((0, parcelRequire("fDskX"))))));
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).OPERATIONS);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS);
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: menuId,
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) sendSectionItemAnalyticsEvent({
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OPERATIONS,
                    sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_OPERATIONS)
                });
                onExpansionToggle?.(hasExpanded);
            },
            onSystemToggle: onSystemToggle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            actionsOnHover: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("87kQ4")).ActionButtons), null),
            elemBefore: icon,
            ref: triggerRef,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            elemBefore: overviewIcon,
            href: "/jira/ops/overview",
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_OVERVIEW),
            onClick: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                        level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                        itemId: 'overview'
                    }
                });
            }
        }, overviewMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_ALERTS)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            onClick: (_e, _a, { isExpanded: hasExpanded })=>{
                if (hasExpanded) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                        level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                        itemId: 'alerts'
                    }
                });
            },
            elemBefore: alertsIcon,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_ALERTS))
        }, alertsMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, AlertsMenuItemContent)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            elemBefore: oncallSchedulesIcon,
            href: "/jira/ops/who-is-on-call",
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_ON_CALL),
            onClick: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                        level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                        itemId: 'onCallSchedules'
                    }
                });
            }
        }, oncallSchedulesMessage), hasReports && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            elemBefore: reportsIcon,
            href: "/jira/ops/reports",
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_REPORTS),
            onClick: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                        level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                        itemId: 'reports'
                    }
                });
            }
        }, reportsMessage)));
    }
});
parcelRegister("boIsJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0224334e234c3d66$var$_react = $0224334e234c3d66$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0224334e234c3d66$var$_baseNew = $0224334e234c3d66$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0224334e234c3d66$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0224334e234c3d66$var$AlertIcon = (props)=>$0224334e234c3d66$var$_react.default.createElement($0224334e234c3d66$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M11.75 14.25h-7.5m7.5 0H14m-2.25 0-.693-8.312a.75.75 0 0 0-.747-.688H5.69a.75.75 0 0 0-.747.688L4.25 14.25m0 0H2M8 3V0M3.641 3.641 1.593 1.593M12.36 3.641l2.048-2.048"/>`
        }, props));
    $0224334e234c3d66$var$AlertIcon.displayName = 'AlertIcon';
    var $0224334e234c3d66$var$_default = module.exports.default = $0224334e234c3d66$var$AlertIcon;
});
parcelRegister("gitmU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bdd51bc1f2f099ea$var$_react = $bdd51bc1f2f099ea$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bdd51bc1f2f099ea$var$_baseNew = $bdd51bc1f2f099ea$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $bdd51bc1f2f099ea$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bdd51bc1f2f099ea$var$PhoneIcon = (props)=>$bdd51bc1f2f099ea$var$_react.default.createElement($bdd51bc1f2f099ea$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3.319 7.693 2.43-2.026a1 1 0 0 0 .322-1.043L5.25 1.75h-3.5c0 2.13.573 4.16 1.569 5.943Zm0 0a13 13 0 0 0 4.988 4.988m0 0a12.17 12.17 0 0 0 5.943 1.569v-3.5l-2.874-.821a1 1 0 0 0-1.043.321z"/>`
        }, props));
    $bdd51bc1f2f099ea$var$PhoneIcon.displayName = 'PhoneIcon';
    var $bdd51bc1f2f099ea$var$_default = module.exports.default = $bdd51bc1f2f099ea$var$PhoneIcon;
});
parcelRegister("9MLkJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0593e321a36ff6ce$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0593e321a36ff6ce$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        alerts: {
            "id": "navigation-apps-sidebar-nav4-operations.alerts",
            "defaultMessage": "Alerts"
        }
    });
});
parcelRegister("7Qdrb", function(module, exports) {
    $parcel$export(module.exports, "useFeatures", ()=>$9e533ca5776ffda5$export$4a39035bacc4ed76);
    var $8J6rn;
    var $4PFfc;
    var $ldyPw;
    var $k9JTq;
    var $itmJb;
    var $cNd4s;
    var $hqBSi;
    const $9e533ca5776ffda5$export$4a39035bacc4ed76 = ()=>{
        const { isByokCustomer: isByokCustomer } = (0, (0, parcelRequire("4PFfc")).useByokComplianceSettingWithInitialisation)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const licensedProducts = (0, (0, parcelRequire("hqBSi")).useLicensedProducts)();
        const { shouldUseJSM: shouldUseJSM, loading: ogTenantInfoLoading } = (0, (0, parcelRequire("8J6rn")).useOgTenantInfo)();
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const hasReports = !ogTenantInfoLoading && (isSiteAdmin || isAdmin) && !isByokCustomer && shouldUseJSM && !!licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, (0, parcelRequire("ldyPw")).FREE_EDITION);
        return {
            hasReports: hasReports
        };
    };
});
parcelRegister("4PFfc", function(module, exports) {
    $parcel$export(module.exports, "useByokComplianceSettingWithInitialisation", ()=>$4598a5eb88f036a1$export$fb68f4844474e7cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $eusud;
    var $7HGHK;
    var $pa9q9;
    var $9OXo1;
    var $3sQ5x;
    var $iXqE5;
    var $6rXpq;
    const $4598a5eb88f036a1$export$f907f15fb3e7d5a9 = (0, (0, parcelRequire("7HGHK")).toFlagId)('byok-settings-enabled-success-flag-key');
    const $4598a5eb88f036a1$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK = 'https://support.atlassian.com/security-and-access-policies/docs/data-managed-with-byok-encryption/24h';
    const $4598a5eb88f036a1$var$actions = {
        fetchByokComplianceSetting: (cloudId)=>async ({ setState: setState, getState: getState })=>{
                const state = getState();
                if (state.loading === true) return;
                setState({
                    ...state,
                    loading: true
                });
                try {
                    const { data: data } = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`);
                    setState({
                        ...state,
                        data: data,
                        loading: false,
                        error: undefined
                    });
                } catch (error) {
                    setState({
                        ...state,
                        loading: false,
                        error: error
                    });
                }
            },
        updateByokComplianceSetting: (option, cloudId)=>async ({ setState: setState, getState: getState })=>{
                const state = getState();
                if (state.loading === true) return;
                const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
                setState({
                    ...state,
                    loading: true
                });
                try {
                    await (0, (0, parcelRequire("eusud")).performPatchRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`, {
                        body: JSON.stringify({
                            ugcPrimaryLogEnabledForByok: option
                        })
                    });
                    if (option) showFlag({
                        id: $4598a5eb88f036a1$export$f907f15fb3e7d5a9,
                        title: (0, (0, parcelRequire("6rXpq")).default).byokComplianceSettingEnabledSuccessTitle,
                        type: 'success',
                        description: (0, (0, parcelRequire("6rXpq")).default).byokComplianceSettingEnabledSuccessDescription,
                        actions: [
                            {
                                content: (0, (0, parcelRequire("6rXpq")).default).flagOk,
                                onClick: ()=>{
                                    dismissFlag($4598a5eb88f036a1$export$f907f15fb3e7d5a9);
                                }
                            },
                            {
                                content: (0, (0, parcelRequire("6rXpq")).default).flagLearnMore,
                                href: $4598a5eb88f036a1$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK,
                                target: '_blank'
                            }
                        ]
                    });
                    setState({
                        ...state,
                        data: {
                            byokCustomer: state.data?.byokCustomer ?? false,
                            ugcPrimaryLogEnabledForByok: option
                        },
                        loading: false,
                        error: undefined
                    });
                } catch (error) {
                    setState({
                        ...state,
                        loading: false,
                        error: error
                    });
                }
            }
    };
    const $4598a5eb88f036a1$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            data: null,
            loading: false,
            error: undefined
        },
        actions: $4598a5eb88f036a1$var$actions,
        name: 'BYOKComplianceSetting'
    });
    const $4598a5eb88f036a1$var$useByokComplianceSettingData = (0, (0, parcelRequire("3sQ5x")).createHook)($4598a5eb88f036a1$var$Store);
    const $4598a5eb88f036a1$export$fb68f4844474e7cb = ()=>{
        const [ByokComplianceSettingState, { fetchByokComplianceSetting: fetchByokComplianceSetting, updateByokComplianceSetting: updateByokComplianceSetting }] = $4598a5eb88f036a1$var$useByokComplianceSettingData();
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        (0, $5uXOq.useEffect)(()=>{
            if (!ByokComplianceSettingState.data && (0, (0, parcelRequire("co1wz")).ff)('platform.50cent.audit-logs-byok-encrypted-data_49s7g')) fetchByokComplianceSetting(cloudId);
        }, [
            ByokComplianceSettingState.data,
            cloudId,
            fetchByokComplianceSetting
        ]);
        return {
            loading: ByokComplianceSettingState.loading,
            error: ByokComplianceSettingState.error,
            data: ByokComplianceSettingState.data,
            isByokComplianceSettingEnabled: ByokComplianceSettingState.data?.ugcPrimaryLogEnabledForByok ?? false,
            isByokCustomer: ByokComplianceSettingState.data?.byokCustomer ?? false,
            enableSetting: ()=>updateByokComplianceSetting(true, cloudId),
            disableSetting: ()=>updateByokComplianceSetting(false, cloudId)
        };
    };
});
parcelRegister("6rXpq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a126756b74ac450$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5a126756b74ac450$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        byokComplianceSettingEnabledSuccessTitle: {
            "id": "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-title",
            "defaultMessage": "HIPAA-compliant alert notifications turned on"
        },
        byokComplianceSettingEnabledSuccessDescription: {
            "id": "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-description",
            "defaultMessage": "Let your team admins know about the recommended actions they can take."
        },
        flagOk: {
            "id": "products-jsm-compliance-main.services.byok-compliance-setting.flag-ok",
            "defaultMessage": "Ok"
        },
        flagLearnMore: {
            "id": "products-jsm-compliance-main.services.byok-compliance-setting.flag-learn-more",
            "defaultMessage": "Learn more"
        }
    });
});
parcelRegister("7zFZv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$adc2a9b3f9b765e0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $adc2a9b3f9b765e0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        overview: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.overview",
            "defaultMessage": "Overview"
        },
        alerts: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts",
            "defaultMessage": "Alerts"
        },
        onCallSchedules: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.on-call-schedules",
            "defaultMessage": "On-call schedules"
        },
        generalConfiguration: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.general-configuration",
            "defaultMessage": "General configuration"
        },
        reports: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.reports",
            "defaultMessage": "Reports"
        },
        defaultFilters: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.default-filters",
            "defaultMessage": "Default filters"
        },
        sharedWithMe: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.shared-with-me",
            "defaultMessage": "Shared with me"
        },
        createdByMe: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.created-by-me",
            "defaultMessage": "Created by me"
        },
        starred: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.starred",
            "defaultMessage": "Starred"
        },
        allAlerts: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.all-alerts",
            "defaultMessage": "All alerts"
        },
        myAlerts: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.my-alerts",
            "defaultMessage": "My alerts"
        },
        allSearch: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.all-search",
            "defaultMessage": "All"
        },
        openSearch: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.open-search",
            "defaultMessage": "Open"
        },
        closedSearch: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.closed-search",
            "defaultMessage": "Closed"
        },
        unackedSearch: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.unacked-search",
            "defaultMessage": "Unacknowledged"
        },
        notSeenSearch: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.not-seen-search",
            "defaultMessage": "Not seen"
        },
        assignedToMeSearch: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.assigned-to-me-search",
            "defaultMessage": "Assigned to me"
        }
    });
});
parcelRegister("87kQ4", function(module, exports) {
    $parcel$export(module.exports, "ActionButtons", ()=>$cfb53a200327fce3$export$88c65d2d98aab183);
    var $5uXOq = parcelRequire("5uXOq");
    var $epOG5;
    var $3Z96c;
    var $9UCCQ;
    var $8J6rn;
    var $4R6GH;
    var $koVbs;
    var $jecJ3;
    var $ivGSs;
    var $jhS4y;
    var $46Cti;
    var $9eeFp;
    var $eaKdt;
    var $aCS3f;
    var $8zOmE;
    var $2NMNM;
    var $9OXo1;
    var $bLVOJ;
    function $cfb53a200327fce3$export$88c65d2d98aab183({ onClose: onClose }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            onOpen: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6),
                    actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                        level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                        itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
                    }
                });
            },
            MenuItems: $cfb53a200327fce3$var$MoreMenuItems,
            onClose: onClose
        });
    }
    function $cfb53a200327fce3$var$MoreMenuItems({ onClose: onClose }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onCloseWithStopPropagation = (0, (0, parcelRequire("9eeFp")).useStopPropagation)((event)=>{
            onClose?.(event);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    itemId: 'generalConfiguration',
                    parentItemId: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_OPERATIONS)
                }
            });
        });
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { isOpsAdmin: isOpsAdmin } = (0, (0, parcelRequire("8J6rn")).useOgTenantInfo)();
        const shouldShowGeneralConfiguration = (0, (0, parcelRequire("4R6GH")).fg)('operations-tenant-info-endpoint-update') ? (tenantContext.isAdmin || isOpsAdmin) && tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] : tenantContext.isAdmin && tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, shouldShowGeneralConfiguration ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("epOG5"))))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            href: "/jira/settings/products/ops/jira-service-management-audit-logs",
            onClick: onCloseWithStopPropagation
        }, formatMessage((0, (0, parcelRequire("bLVOJ")).default).generalConfiguration))) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaKdt")).HideL1MenuItemSection), {
            menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OPERATIONS,
            hasSeparator: shouldShowGeneralConfiguration
        }));
    }
});
parcelRegister("bLVOJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$305b1dd418fc2a25$export$2e2bcd8739ae039);
    var $7VHMR;
    var $305b1dd418fc2a25$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        generalConfiguration: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.general-configuration",
            "defaultMessage": "General configuration"
        }
    });
});
parcelRegister("2CMcE", function(module, exports) {
    $parcel$export(module.exports, "OperationsMenuForLanding", ()=>$4f2124831a167c55$export$b37dd5cf3b893940);
    var $df0z5;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $dGQgy;
    var $gzxPn;
    const $4f2124831a167c55$export$b37dd5cf3b893940 = ({ isExpanded: isExpanded, queryRef: queryRef })=>{
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("df0z5")).default), queryRef);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gzxPn")).OperationsExpandableMenuItem), {
            isExpanded: isExpanded,
            AlertsMenuItemContent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dGQgy")).AlertsMenuItemContent), {
                queryRef: data
            })
        });
    };
});
parcelRegister("df0z5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a039eea1ea338a10$export$2e2bcd8739ae039);
    const $a039eea1ea338a10$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "OperationsMenuForLanding",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "AlertsMenuItemContent"
            }
        ],
        "type": "Query"
    };
    $a039eea1ea338a10$var$node.hash = "00bc278faf903f3ef25d308d4771d2d6";
    var $a039eea1ea338a10$export$2e2bcd8739ae039 = $a039eea1ea338a10$var$node;
});
parcelRegister("dGQgy", function(module, exports) {
    $parcel$export(module.exports, "AlertsMenuItemContent", ()=>$ab6d77ca097b26bb$export$fcbb0679bb6c6da1);
    var $k3zlg;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $6a9Wp;
    var $39KIs;
    var $koVbs;
    var $ivGSs;
    var $jhS4y;
    var $lhMtU;
    var $c6x3L;
    var $c16H2;
    var $5FnJJ;
    var $dQbFB;
    var $24a2m;
    var $8zOmE;
    var $2NMNM;
    var $90yGq;
    var $l8ruj;
    var $lnznH;
    var $cZa9B;
    var $ieDtd;
    var $9MLkJ;
    var $7zFZv;
    var $gtYPY;
    function $ab6d77ca097b26bb$export$fcbb0679bb6c6da1({ queryRef: queryRef }) {
        const [selectedFilter, setSelectedFilter] = (0, $5uXOq.useState)('');
        const { isSelectedPath: isSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("k3zlg")).default), queryRef);
        const { sharedWithMe: sharedWithMe, createdByMe: createdByMe } = data.opsgenie.savedSearches;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const [viewType] = (0, (0, parcelRequire("ieDtd")).useQueryParam)('view');
        const { icon: pagesIcon } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("9MLkJ")).default).alerts, (0, ($parcel$interopDefault((0, parcelRequire("6a9Wp"))))));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const defaultFilters = [
            {
                id: 'all',
                name: formatMessage((0, (0, parcelRequire("7zFZv")).default).allSearch),
                alertSearchQuery: ''
            },
            {
                id: 'open',
                name: formatMessage((0, (0, parcelRequire("7zFZv")).default).openSearch),
                alertSearchQuery: `${(0, (0, parcelRequire("39KIs")).IDENTIFIER_STATUS)}${(0, (0, parcelRequire("39KIs")).OPERATOR_EQUAL_TO)} ${(0, (0, parcelRequire("39KIs")).STRING_LITERAL_STATUS_OPEN)}`
            },
            {
                id: 'closed',
                name: formatMessage((0, (0, parcelRequire("7zFZv")).default).closedSearch),
                alertSearchQuery: `${(0, (0, parcelRequire("39KIs")).IDENTIFIER_STATUS)}${(0, (0, parcelRequire("39KIs")).OPERATOR_EQUAL_TO)} ${(0, (0, parcelRequire("39KIs")).STRING_LITERAL_STATUS_CLOSED)}`
            },
            {
                id: 'unacked',
                name: formatMessage((0, (0, parcelRequire("7zFZv")).default).unackedSearch),
                alertSearchQuery: `${(0, (0, parcelRequire("39KIs")).IDENTIFIER_STATUS)}${(0, (0, parcelRequire("39KIs")).OPERATOR_EQUAL_TO)} ${(0, (0, parcelRequire("39KIs")).STRING_LITERAL_STATUS_OPEN)} ${(0, (0, parcelRequire("39KIs")).LOGICAL_OPERATOR_AND)} ${(0, (0, parcelRequire("39KIs")).IDENTIFIER_ACKNOWLEDGED)}${(0, (0, parcelRequire("39KIs")).OPERATOR_EQUAL_TO)} ${(0, (0, parcelRequire("39KIs")).BOOLEAN_LITERAL_FALSE)}`
            },
            {
                id: 'notSeen',
                name: formatMessage((0, (0, parcelRequire("7zFZv")).default).notSeenSearch),
                alertSearchQuery: `${(0, (0, parcelRequire("39KIs")).IDENTIFIER_IS_SEEN)}${(0, (0, parcelRequire("39KIs")).OPERATOR_EQUAL_TO)} ${(0, (0, parcelRequire("39KIs")).BOOLEAN_LITERAL_FALSE)}`
            },
            {
                id: 'assignedToMe',
                name: formatMessage((0, (0, parcelRequire("7zFZv")).default).assignedToMeSearch),
                alertSearchQuery: `${(0, (0, parcelRequire("39KIs")).IDENTIFIER_ASSIGNEE)}${(0, (0, parcelRequire("39KIs")).OPERATOR_EQUAL_TO)} "${accountId || 'me'}"`
            }
        ];
        (0, $5uXOq.useEffect)(()=>{
            if (!isSelectedPath((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_ALERTS)) && selectedFilter !== '') setSelectedFilter('');
        }, [
            isSelectedPath,
            selectedFilter
        ]);
        const defaultFilterMenuIds = $ab6d77ca097b26bb$var$getParentMenuId(defaultFilters);
        const sharedWithMeMenuIds = $ab6d77ca097b26bb$var$getParentMenuId(sharedWithMe);
        const createdByMeMenuIds = $ab6d77ca097b26bb$var$getParentMenuId(createdByMe);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.sidebar.operations.alerts"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            menuId: defaultFilterMenuIds,
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                        level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                        itemId: 'defaultFilters',
                        parentItemId: 'alerts'
                    }
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(defaultFilterMenuIds)
        }, formatMessage((0, (0, parcelRequire("7zFZv")).default).defaultFilters)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, defaultFilters.map((item)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
                elemBefore: pagesIcon,
                key: item.id,
                href: `/jira/ops/alerts?view=${viewType ?? 'list'}${item.alertSearchQuery ? `&query=${item.alertSearchQuery}` : ''}`,
                menuId: (0, (0, parcelRequire("jhS4y")).ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
                onClick: ()=>{
                    setSelectedFilter(item.id);
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                        action: 'clicked',
                        actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                        actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                        attributes: {
                            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                            itemId: item.id,
                            parentItemId: 'defaultFilters',
                            itemType: 'defaultFilter'
                        }
                    });
                }
            }, item.name)))), sharedWithMe && sharedWithMe.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            menuId: sharedWithMeMenuIds,
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                        level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                        itemId: 'sharedWithMe',
                        parentItemId: 'alerts'
                    }
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(sharedWithMeMenuIds)
        }, formatMessage((0, (0, parcelRequire("7zFZv")).default).sharedWithMe), sharedWithMe.some((filter)=>isSelectedPath(filter.alertSearchQuery))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, sharedWithMe.map((item)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
                elemBefore: pagesIcon,
                href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
                key: item.id,
                menuId: (0, (0, parcelRequire("jhS4y")).ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
                onClick: ()=>{
                    setSelectedFilter('');
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                        action: 'clicked',
                        actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                        actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                        attributes: {
                            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                            itemId: item.id,
                            itemType: 'savedSearch',
                            parentItemId: 'sharedWithMe'
                        }
                    });
                }
            }, item.name)))), createdByMe && createdByMe.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            menuId: createdByMeMenuIds,
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                        level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                        itemId: 'createdByMe',
                        parentItemId: 'alerts'
                    }
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(createdByMeMenuIds)
        }, formatMessage((0, (0, parcelRequire("7zFZv")).default).createdByMe)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, createdByMe.map((item)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
                elemBefore: pagesIcon,
                href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
                key: item.id,
                menuId: (0, (0, parcelRequire("jhS4y")).ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
                onClick: ()=>{
                    setSelectedFilter('');
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                        action: 'clicked',
                        actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                        actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                        attributes: {
                            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                            itemId: item.id,
                            itemType: 'savedSearch',
                            parentItemId: 'createdByMe'
                        }
                    });
                },
                actionsOnHover: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gtYPY")).SavedSearchActionButtons), {
                    savedSearch: item
                })
            }, item.name)))));
    }
    function $ab6d77ca097b26bb$var$getParentMenuId(arr) {
        return (0, (0, parcelRequire("lhMtU")).toMenuIdFromMenuIdList)((arr || []).map((i)=>(0, (0, parcelRequire("jhS4y")).ENTITY_ID).ALARM_QUEUE(i.alertSearchQuery)));
    }
});
parcelRegister("k3zlg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06087129a1b4fe18$export$2e2bcd8739ae039);
    const $06087129a1b4fe18$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "id"
        }, v1 = {
            "kind": "ScalarField",
            "name": "name"
        }, v2 = {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        };
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "cloudId"
                }
            ],
            "kind": "Fragment",
            "name": "AlertsMenuItemContent",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "OpsgenieQuery",
                        "kind": "LinkedField",
                        "name": "opsgenie",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "OpsgenieSavedSearches",
                                    "kind": "LinkedField",
                                    "name": "savedSearches",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "OpsgenieSavedSearch",
                                                "kind": "LinkedField",
                                                "name": "sharedWithMe",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v0,
                                                        "action": "THROW",
                                                        "path": "opsgenie.savedSearches.sharedWithMe.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v1,
                                                        "action": "THROW",
                                                        "path": "opsgenie.savedSearches.sharedWithMe.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v2,
                                                        "action": "THROW",
                                                        "path": "opsgenie.savedSearches.sharedWithMe.alertSearchQuery"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "opsgenie.savedSearches.sharedWithMe"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "OpsgenieSavedSearch",
                                                "kind": "LinkedField",
                                                "name": "createdByMe",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v0,
                                                        "action": "THROW",
                                                        "path": "opsgenie.savedSearches.createdByMe.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v1,
                                                        "action": "THROW",
                                                        "path": "opsgenie.savedSearches.createdByMe.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v2,
                                                        "action": "THROW",
                                                        "path": "opsgenie.savedSearches.createdByMe.alertSearchQuery"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "opsgenie.savedSearches.createdByMe"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "opsgenie.savedSearches"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "opsgenie"
                }
            ],
            "type": "Query"
        };
    }();
    $06087129a1b4fe18$var$node.hash = "a966b3b30f116da10c5f94a5f11eefaa";
    var $06087129a1b4fe18$export$2e2bcd8739ae039 = $06087129a1b4fe18$var$node;
});
parcelRegister("6a9Wp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $47cb635ccdf7d850$var$_react = $47cb635ccdf7d850$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $47cb635ccdf7d850$var$_baseNew = $47cb635ccdf7d850$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $47cb635ccdf7d850$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $47cb635ccdf7d850$var$PagesIcon = (props)=>$47cb635ccdf7d850$var$_react.default.createElement($47cb635ccdf7d850$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10 4.75H4m4.5 3H4m-1 4.5h8c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25Z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $47cb635ccdf7d850$var$PagesIcon.displayName = 'PagesIcon';
    var $47cb635ccdf7d850$var$_default = module.exports.default = $47cb635ccdf7d850$var$PagesIcon;
});
parcelRegister("gtYPY", function(module, exports) {
    $parcel$export(module.exports, "SavedSearchActionButtons", ()=>$aec190113be184ad$export$78ee2939aff842cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $3fOYK;
    var $kJpBP;
    var $9UCCQ;
    var $jlNRx;
    var $1a6oa;
    var $6IJKZ;
    var $aQd57;
    var $7HGHK;
    var $pa9q9;
    var $koVbs;
    var $ivGSs;
    var $jhS4y;
    var $9eeFp;
    var $aCS3f;
    var $8zOmE;
    var $2NMNM;
    var $dfzUf;
    const $aec190113be184ad$export$78ee2939aff842cb = ({ onClose: onClose, savedSearch: savedSearch })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            onOpen: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6),
                    actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                        level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                        itemId: (0, $496585bee7985bb9$export$a65812b4aab631bb),
                        parentItemType: 'savedSearch',
                        parentItemId: savedSearch.id
                    }
                });
            },
            MenuItems: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($aec190113be184ad$var$MoreMenuItems, {
                    ...props,
                    savedSearch: savedSearch
                }),
            onClose: onClose
        });
    };
    const $aec190113be184ad$var$MoreMenuItems = ({ onClose: onClose, savedSearch: savedSearch })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [modalType, setModalType] = (0, $5uXOq.useState)(undefined);
        const onCloseWithStopPropagation = (0, (0, parcelRequire("9eeFp")).useStopPropagation)(onClose);
        const { removeSavedSearchFromCreatedByMe: removeSavedSearchFromCreatedByMe } = (0, (0, parcelRequire("aQd57")).useSavedSearchRelayUtils)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const deleteSavedSearch = (0, $5uXOq.useCallback)((e)=>{
            setIsLoading(true);
            const savedSearchId = (0, (0, parcelRequire("jlNRx")).OpsgenieSavedSearchAri).parse(savedSearch.id).savedSearchId;
            (0, (0, parcelRequire("6IJKZ")).deleteSearchEndpoint)(savedSearchId).then(()=>{
                removeSavedSearchFromCreatedByMe(savedSearch.id);
            }).catch(()=>{
                showFlag({
                    key: (0, (0, parcelRequire("7HGHK")).toFlagId)((0, $f4d30246a2d1df81$export$337d30e19f17af0f)),
                    type: 'error',
                    title: (0, (0, parcelRequire("dfzUf")).default).errorTitle,
                    description: (0, (0, parcelRequire("dfzUf")).default).errorMessage
                });
            }).finally(()=>{
                setIsLoading(false);
                if (onClose) onClose(e);
            });
        }, [
            savedSearch,
            onClose,
            removeSavedSearchFromCreatedByMe,
            showFlag
        ]);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3fOYK"))))), {
                size: "small",
                primaryColor: "var(--ds-icon-danger, #C9372C)",
                label: ""
            }),
            onClick: (e)=>{
                e.preventDefault();
                setModalType('delete');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
                    actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
                        level: (0, $951a0ed422513987$export$35ac629b8b943d5a),
                        itemId: 'deleteSavedSearch',
                        parentItemType: 'savedSearch',
                        parentItemId: savedSearch.id
                    }
                });
            }
        }, formatMessage((0, (0, parcelRequire("dfzUf")).default).deleteSavedSearch))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1a6oa")).DeleteModal), {
            messageDescriptors: {
                title: (0, (0, parcelRequire("dfzUf")).default).confirmTrashHeading,
                description: (0, (0, parcelRequire("dfzUf")).default).confirmTrashMessage
            },
            isDeleteDialogOpen: modalType === 'delete',
            onDeleteAttemptCancel: onCloseWithStopPropagation,
            isLoading: isLoading,
            onDelete: (e)=>deleteSavedSearch(e)
        }));
    };
});
parcelRegister("3fOYK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25ea512a3c153cf8$var$_react = $25ea512a3c153cf8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $25ea512a3c153cf8$var$_delete = $25ea512a3c153cf8$var$_interopRequireDefault((parcelRequire("4IrpZ")));
    function $25ea512a3c153cf8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25ea512a3c153cf8$var$TrashIcon = (props)=>$25ea512a3c153cf8$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5a1 1 0 0 0-1 1v1h16V6a1 1 0 0 0-1-1zm11.15 15h-8.3a1 1 0 0 1-.99-.83L5 8h14l-1.86 11.17a1 1 0 0 1-.99.83M9 4.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5V5H9z"/></svg>`
        }, props, {
            newIcon: $25ea512a3c153cf8$var$_delete.default
        }));
    $25ea512a3c153cf8$var$TrashIcon.displayName = 'TrashIcon';
    var $25ea512a3c153cf8$var$_default = module.exports.default = $25ea512a3c153cf8$var$TrashIcon;
});
parcelRegister("jlNRx", function(module, exports) {
    $parcel$export(module.exports, "OpsgenieSavedSearchAri", ()=>$e166a829386cfc65$export$1dc7f741fb628a10);
    var $47ByP;
    var $9KGzW;
    var $1C2Ux;
    var $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^$"),
        resourceOwner: (0, (0, parcelRequire("47ByP")).OpsgenieSavedSearchAriResourceOwner),
        resourceType: (0, (0, parcelRequire("47ByP")).OpsgenieSavedSearchAriResourceType),
        resourceIdSlug: "{workspaceId}/{savedSearchId}",
        resourceIdSegmentFormats: {
            workspaceId: /[a-zA-Z0-9\-]+/,
            savedSearchId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
        }
    };
    var $e166a829386cfc65$export$1dc7f741fb628a10 = class _OpsgenieSavedSearchAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._workspaceId = opts.resourceIdSegmentValues.workspaceId, this._savedSearchId = opts.resourceIdSegmentValues.savedSearchId;
        }
        get workspaceId() {
            return this._workspaceId;
        }
        get savedSearchId() {
            return this._savedSearchId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts.qualifier,
                platformQualifier: $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts.platformQualifier,
                cloudId: void 0,
                resourceOwner: $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts.resourceOwner,
                resourceType: $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts.resourceType,
                resourceId: `${opts.workspaceId}/${opts.savedSearchId}`,
                resourceIdSegmentValues: {
                    workspaceId: opts.workspaceId,
                    savedSearchId: opts.savedSearchId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts);
            return new _OpsgenieSavedSearchAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts);
            return new _OpsgenieSavedSearchAri(opts);
        }
        getVariables() {
            return {
                workspaceId: this.workspaceId,
                savedSearchId: this.savedSearchId
            };
        }
    };
});
parcelRegister("47ByP", function(module, exports) {
    $parcel$export(module.exports, "OpsgenieSavedSearchAriResourceOwner", ()=>$3004f3ab9c3d798b$export$7416cc1df15f6b85);
    $parcel$export(module.exports, "OpsgenieSavedSearchAriResourceType", ()=>$3004f3ab9c3d798b$export$1db52fe39936618e);
    var $3004f3ab9c3d798b$export$7416cc1df15f6b85 = "opsgenie", $3004f3ab9c3d798b$export$1db52fe39936618e = "saved-search";
});
parcelRegister("1a6oa", function(module, exports) {
    $parcel$export(module.exports, "DeleteModal", ()=>$cced2403e06280a2$export$73392e09138fecd6);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $fVnbM;
    var $2rqOp;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $i8Qvm;
    var $kWK4V;
    const $cced2403e06280a2$export$73392e09138fecd6 = ({ isDeleteDialogOpen: isDeleteDialogOpen, onDeleteAttemptCancel: onDeleteAttemptCancel, onDelete: onDelete, isLoading: isLoading, messageDescriptors: messageDescriptors, returnFocusRef: returnFocusRef })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isDeleteDialogOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            shouldCloseOnOverlayClick: !isLoading,
            onClose: onDeleteAttemptCancel,
            shouldReturnFocus: returnFocusRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: "danger"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), messageDescriptors.title))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), messageDescriptors.description)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            isDisabled: isLoading,
            appearance: "subtle",
            onClick: onDeleteAttemptCancel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kWK4V")).messages).cancelButton)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            appearance: "danger",
            onClick: onDelete,
            autoFocus: true,
            isLoading: isLoading
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kWK4V")).messages).deleteButton)))));
    };
});
parcelRegister("kWK4V", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1a237904e75f23fb$export$defe85febe8b728c);
    var $7VHMR;
    const $1a237904e75f23fb$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        cancelButton: {
            id: 'eoc.alert-detail.delete-modal.cancel-button.no-translate',
            defaultMessage: 'Cancel',
            description: 'The text will be displayed in the delete modal footer for cancel button.'
        },
        deleteButton: {
            id: 'eoc.alert-detail.extra-property.delete-modal.delete-button.no-translate',
            defaultMessage: 'Delete',
            description: 'The text will be displayed in the delete modal footer for delete button.'
        }
    });
});
parcelRegister("aQd57", function(module, exports) {
    $parcel$export(module.exports, "useSavedSearchRelayUtils", ()=>$3d73dcd807f3f6b7$export$e07c40a7acca4305);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jlNRx;
    var $hmVmJ;
    var $dH6Pi;
    var $030R0;
    var $1Z10l;
    const $3d73dcd807f3f6b7$export$e07c40a7acca4305 = ()=>{
        const relayEnvironment = (0, $8Uumt.useRelayEnvironment)();
        const cloudId = (0, (0, parcelRequire("030R0")).getMeta)('ajs-cloud-id') ?? (0, (0, parcelRequire("1Z10l")).getCloudIdForDevEnvironment)();
        (0, (0, parcelRequire("hmVmJ")).assert)(!!cloudId, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('cloudId', 'useSavedSarchRelayUtils: cloudId is undefined'));
        const removeSavedSearch = (0, $5uXOq.useCallback)((savedSearchId, key)=>{
            (0, $8Uumt.commitLocalUpdate)(relayEnvironment, (store)=>{
                const root = store.getRoot();
                const opsgenieRecord = root.getLinkedRecord('opsgenie');
                if (opsgenieRecord) {
                    const savedSearches = opsgenieRecord.getLinkedRecord('savedSearches', {
                        cloudId: cloudId
                    });
                    if (savedSearches) {
                        const removeItem = savedSearches.getLinkedRecords(key);
                        if (removeItem) {
                            const filteredItems = removeItem.filter((record)=>record.getValue('id') !== savedSearchId);
                            savedSearches.setLinkedRecords(filteredItems, key);
                        }
                    }
                }
            });
        }, [
            cloudId,
            relayEnvironment
        ]);
        const addSavedSearch = (0, $5uXOq.useCallback)((savedSearch, key)=>{
            (0, $8Uumt.commitLocalUpdate)(relayEnvironment, (store)=>{
                const newSavedSearchId = (0, (0, parcelRequire("jlNRx")).OpsgenieSavedSearchAri).create({
                    workspaceId: cloudId,
                    savedSearchId: savedSearch.id
                }).toString();
                const newSavedSearch = store.create(newSavedSearchId, 'OpsgenieSavedSearch');
                newSavedSearch.setValue(newSavedSearchId, 'id');
                newSavedSearch.setValue(savedSearch.name, 'name');
                newSavedSearch.setValue(savedSearch.query, 'alertSearchQuery');
                const root = store.getRoot();
                const opsgenieRecord = root.getLinkedRecord('opsgenie');
                if (opsgenieRecord) {
                    const savedSearches = opsgenieRecord.getLinkedRecord('savedSearches', {
                        cloudId: cloudId
                    });
                    if (savedSearches) {
                        const savedSearchesList = savedSearches.getLinkedRecords(key) || [];
                        const updatedSavedSearches = [
                            ...savedSearchesList,
                            newSavedSearch
                        ];
                        savedSearches.setLinkedRecords(updatedSavedSearches, key);
                    }
                }
            });
        }, [
            cloudId,
            relayEnvironment
        ]);
        const addSavedSearchToCreatedByMe = (0, $5uXOq.useCallback)((savedSearch)=>{
            addSavedSearch(savedSearch, 'createdByMe');
        }, [
            addSavedSearch
        ]);
        const removeSavedSearchFromCreatedByMe = (0, $5uXOq.useCallback)((savedSearchId)=>{
            removeSavedSearch(savedSearchId, 'createdByMe');
        }, [
            removeSavedSearch
        ]);
        return {
            addSavedSearchToCreatedByMe: addSavedSearchToCreatedByMe,
            removeSavedSearchFromCreatedByMe: removeSavedSearchFromCreatedByMe
        };
    };
});
const $f4d30246a2d1df81$export$337d30e19f17af0f = 'fetchError';
parcelRegister("dfzUf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57b524cf9eff8335$export$2e2bcd8739ae039);
    var $7VHMR;
    var $57b524cf9eff8335$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        deleteSavedSearch: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.delete-saved-search",
            "defaultMessage": "Delete"
        },
        confirmTrashHeading: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.confirm-trash-heading",
            "defaultMessage": "Delete saved search"
        },
        confirmTrashMessage: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.confirm-trash-message",
            "defaultMessage": "Are you sure you want to delete this saved search?"
        },
        errorTitle: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.error-title",
            "defaultMessage": "Error"
        },
        errorMessage: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.error-message",
            "defaultMessage": "Something went wrong. Please try again."
        }
    });
});
parcelRegister("iKHgp", function(module, exports) {
    $parcel$export(module.exports, "useShouldRenderOverviews", ()=>$fb6128b9861df989$export$4ce95cd18a7f8574);
    var $4R6GH;
    var $ldyPw;
    var $k9JTq;
    const $fb6128b9861df989$export$4ce95cd18a7f8574 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        if (!(0, (0, parcelRequire("4R6GH")).fg)('blu-2858-sidebar-menu-overviews')) return false;
        if (appEditions.software === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION)) return false;
        if (appEditions.core === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION)) return true;
        if (appEditions.serviceDesk === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION) && (appEditions.core === (0, (0, parcelRequire("ldyPw")).FREE_EDITION) || appEditions.core === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION))) return true;
        return false;
    };
});
parcelRegister("lz3si", function(module, exports) {
    $parcel$export(module.exports, "Nav4Overviews", ()=>$dddda2f6dd48ba2b$export$2c62779314f9754a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $l8ruj;
    var $hWrpp;
    function $dddda2f6dd48ba2b$export$2c62779314f9754a(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-overviews"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "overviews-section",
            packageName: (0, $cdfe315557fc43d2$export$b8b9d90f9e5bd72b),
            teamName: (0, $cdfe315557fc43d2$export$d57b6b390e78d90f)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWrpp")).Nav4Overviews), props)));
    }
});
const $cdfe315557fc43d2$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Overviews';
const $cdfe315557fc43d2$export$d57b6b390e78d90f = 'jira-cosmos';
parcelRegister("hWrpp", function(module, exports) {
    $parcel$export(module.exports, "Nav4Overviews", ()=>$441eac7217d261af$export$2c62779314f9754a);
    var $8tKjq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jhS4y;
    var $c6x3L;
    var $gQORo;
    var $VgtWG;
    var $aKoWU;
    function $441eac7217d261af$export$2c62779314f9754a({ isExpanded: isExpanded, queryRef: queryRef }) {
        const { isInitialSelectedPath: isInitialSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("8tKjq")).default), queryRef);
        const actionButtons = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gQORo")).SectionActions), {
                totalCount: data?.jira?.jwmOverviews?.totalCount ?? 0
            }), [
            data?.jira?.jwmOverviews?.totalCount
        ]);
        return isInitialSelectedPath((0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS)) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aKoWU")).Nav4OverviewsForLanding), {
            isExpanded: isExpanded,
            queryRef: data,
            actionsOnHover: actionButtons
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("VgtWG")).Nav4OverviewsDefault), {
            isExpanded: isExpanded,
            actionsOnHover: actionButtons
        });
    }
});
parcelRegister("8tKjq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3fc06df8a8701f9c$export$2e2bcd8739ae039);
    const $3fc06df8a8701f9c$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "isOverviewsExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Overviews",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraWorkManagementGiraOverviewConnection",
                        "kind": "LinkedField",
                        "name": "jwmOverviews",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "totalCount"
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "isOverviewsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4OverviewsForLanding"
                    }
                ]
            }
        ],
        "type": "Query"
    };
    $3fc06df8a8701f9c$var$node.hash = "49456eee5b5999aee543e784e4db7323";
    var $3fc06df8a8701f9c$export$2e2bcd8739ae039 = $3fc06df8a8701f9c$var$node;
});
parcelRegister("gQORo", function(module, exports) {
    $parcel$export(module.exports, "SectionActions", ()=>$782e3beee288b950$export$51f8029abf8c56ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $34Rrn;
    var $dIWbq;
    var $i8Qvm;
    var $1I7E8;
    var $dC5iT;
    var $f5TWP;
    var $cgL5K;
    var $3bDjY;
    var $7yUJn;
    var $koVbs;
    var $ivGSs;
    var $i3a7M;
    var $jhS4y;
    var $46Cti;
    var $1xonH;
    var $cDvOQ;
    var $eaKdt;
    var $aCS3f;
    var $8zOmE;
    var $2NMNM;
    var $92djE;
    function $782e3beee288b950$export$51f8029abf8c56ce({ totalCount: totalCount }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { isOpen: isOpen, onClose: onClose, onOpen: onOpen, onToggle: onToggle } = (0, (0, parcelRequire("cDvOQ")).useOpenable)();
        const { sendCreateOverviewAnalyticsEvent: sendCreateOverviewAnalyticsEvent } = (0, (0, parcelRequire("i3a7M")).useOverviewsAnalyticsL1)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireOpenEvent = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS],
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    itemId: 'meatballDropdown'
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        const onCreateOverviewHandler = (0, $5uXOq.useCallback)(()=>{
            sendCreateOverviewAnalyticsEvent({
                overviewLimitReached: false
            });
            onOpen();
        }, [
            onOpen,
            sendCreateOverviewAnalyticsEvent
        ]);
        const onToggleOverviewHandler = (0, $5uXOq.useCallback)(()=>{
            sendCreateOverviewAnalyticsEvent({
                overviewLimitReached: true
            });
            onToggle();
        }, [
            onToggle,
            sendCreateOverviewAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, totalCount < 10 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7yUJn")).default), {
            onClose: onClose
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("92djE")).default).createOverview)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xonH")).CommonNavMenuButton), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("dIWbq"))))),
            label: formatMessage((0, (0, parcelRequire("92djE")).default).createOverview),
            onClick: onCreateOverviewHandler
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "right",
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    padding: "space.200"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                    space: "space.200",
                    alignBlock: "center"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("34Rrn"))))), {
                    spacing: "none",
                    label: "",
                    color: "var(--ds-icon-warning, #E56910)"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("92djE")).default).moreThanTenWarning)))),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: formatMessage((0, (0, parcelRequire("92djE")).default).createOverview)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xonH")).CommonNavMenuButton), {
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("dIWbq"))))),
                    label: formatMessage((0, (0, parcelRequire("92djE")).default).createOverview),
                    onClick: onToggleOverviewHandler,
                    ...triggerProps
                }))
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            MenuItems: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($782e3beee288b950$var$MoreMenuItems, null),
            onOpen: fireOpenEvent
        }));
    }
    function $782e3beee288b950$var$MoreMenuItems() {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaKdt")).HideL1MenuItemSection), {
            menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS
        });
    }
});
parcelRegister("i3a7M", function(module, exports) {
    $parcel$export(module.exports, "useOverviewsAnalyticsL1", ()=>$2236103400b31729$export$209953a8bcc0c02c);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    const $2236103400b31729$var$OVERVIEWS_NAVIGATION_MENU_ITEM = 'overviewsNavigationMenuItem';
    const $2236103400b31729$export$209953a8bcc0c02c = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const commonAttributes = (0, $5uXOq.useMemo)(()=>({
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22)
            }), []);
        const sendCreateOverviewAnalyticsEvent = (0, $5uXOq.useCallback)(({ overviewLimitReached: overviewLimitReached })=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
            });
            const attributes = {
                ...commonAttributes,
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: 'createOverview',
                overviewLimitReached: overviewLimitReached
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, $2236103400b31729$var$OVERVIEWS_NAVIGATION_MENU_ITEM, attributes);
        }, [
            commonAttributes,
            createAnalyticsEvent
        ]);
        const sendOverviewMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ overviewId: overviewId })=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            });
            const attributes = {
                ...commonAttributes,
                componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                itemType: (0, $632bd8725b437a12$export$9cbb0f231a0ab7ea),
                itemId: overviewId
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, $2236103400b31729$var$OVERVIEWS_NAVIGATION_MENU_ITEM, attributes);
        }, [
            commonAttributes,
            createAnalyticsEvent
        ]);
        return {
            sendOverviewMenuItemAnalyticsEvent: sendOverviewMenuItemAnalyticsEvent,
            sendCreateOverviewAnalyticsEvent: sendCreateOverviewAnalyticsEvent
        };
    };
});
parcelRegister("92djE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9921e9af9b1e8681$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9921e9af9b1e8681$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createOverview: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.section-actions.create-overview",
            "defaultMessage": "Create overview"
        },
        moreThanTenWarning: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.section-actions.more-than-ten-warning",
            "defaultMessage": "You\u2019ve reached the limit of 10 overviews."
        }
    });
});
parcelRegister("VgtWG", function(module, exports) {
    $parcel$export(module.exports, "Nav4OverviewsDefault", ()=>$2bb69cfcdc8635b0$export$b582325fc571fa20);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $jecJ3;
    var $jhS4y;
    var $46Cti;
    var $c16H2;
    var $338xa;
    var $dQbFB;
    var $eQV8d;
    var $dUyqZ;
    var $4zcxJ;
    var $koeKL;
    var $lnznH;
    var $cZa9B;
    var $cCqmP;
    function $2bb69cfcdc8635b0$export$b582325fc571fa20({ isExpanded: isExpanded, actionsOnHover: actionsOnHover }) {
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId
            }), [
            cloudId
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("cCqmP")).asyncOverviewsContentViewQuery), entryPointParams);
        const triggerRef = (0, (0, parcelRequire("4zcxJ")).useExpandableEntryPointTrigger)(entryPointActions);
        (0, $5uXOq.useEffect)(()=>{
            if (isExpanded) entryPointActions.load();
        }, [
            entryPointActions,
            isExpanded
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS),
            onSystemToggle: (hasExpanded)=>{
                if (hasExpanded) entryPointActions.load();
            },
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) {
                    entryPointActions.load();
                    sendSectionItemAnalyticsEvent({
                        menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS,
                        sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_OVERVIEW)
                    });
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            interactionName: "nav4-sidebar-overviews-default",
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            ref: triggerRef,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)((0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS))
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-overviews-default",
            packageName: (0, $cdfe315557fc43d2$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $cdfe315557fc43d2$export$d57b6b390e78d90f),
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null),
            runtimeProps: entryPointParams
        })));
    }
});
parcelRegister("cCqmP", function(module, exports) {
    $parcel$export(module.exports, "asyncOverviewsContentViewQuery", ()=>$68f93ca11a5596c0$export$355176fbb80f2347);
    var $i7pdK;
    var $eufEc;
    var $fEDBv;
    const $68f93ca11a5596c0$export$355176fbb80f2347 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("8fOl2")).then(({ OverviewsContentViewQuery: OverviewsContentViewQuery })=>OverviewsContentViewQuery), {
            moduleId: "6f0ac280",
            moduleName: "OverviewsContentViewQuery"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                queries: {
                    queryRef: {
                        parameters: (0, parcelRequire("i7pdK")).default,
                        variables: {
                            cloudId: cloudId
                        }
                    }
                }
            })
    });
});
parcelRegister("i7pdK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ae4c5ed97c4768f$export$2e2bcd8739ae039);
    const $5ae4c5ed97c4768f$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "OverviewsContentViewQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4OverviewsContent"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "OverviewsContentViewQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                "kind": "LinkedField",
                                "name": "jwmOverviews",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraWorkManagementGiraOverview",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "e61d234924072f4c43fcca2a72d097f86d33239be52bd1855eefa77b25c7cd4c",
                "metadata": {},
                "name": "OverviewsContentViewQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $5ae4c5ed97c4768f$var$node.hash = "5c526a403c104de05313b5b30d6f67e2";
    var $5ae4c5ed97c4768f$export$2e2bcd8739ae039 = $5ae4c5ed97c4768f$var$node;
});
parcelRegister("8fOl2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hNRRw").then(()=>parcelRequire('cG9Gr'));
});
parcelRegister("aKoWU", function(module, exports) {
    $parcel$export(module.exports, "Nav4OverviewsForLanding", ()=>$3fb52decc5a00e35$export$a2711da4a3d7eaa1);
    var $5O4cG;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $7CMCs;
    var $jecJ3;
    var $jhS4y;
    var $46Cti;
    var $c16H2;
    var $dQbFB;
    var $eQV8d;
    var $dUyqZ;
    var $l8ruj;
    var $lnznH;
    var $cZa9B;
    var $1M5y9;
    function $3fb52decc5a00e35$export$a2711da4a3d7eaa1({ isExpanded: isExpanded, queryRef: queryRef, actionsOnHover: actionsOnHover }) {
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS);
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("5O4cG")).default), queryRef);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) sendSectionItemAnalyticsEvent({
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS,
                    sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_OVERVIEW)
                });
            },
            isExpanded: isExpanded,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            interactionName: "nav4-sidebar-overviews-landing",
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)((0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS))
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-overviews-landing"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "nav4-sidebar-overviews-landing",
            packageName: (0, $cdfe315557fc43d2$export$b8b9d90f9e5bd72b),
            teamName: (0, $cdfe315557fc43d2$export$d57b6b390e78d90f),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1M5y9")).Nav4OverviewsContent), {
            queryRef: data
        })))));
    }
});
parcelRegister("5O4cG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$773b1024053c443b$export$2e2bcd8739ae039);
    const $773b1024053c443b$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4OverviewsForLanding",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "Nav4OverviewsContent"
            }
        ],
        "type": "Query"
    };
    $773b1024053c443b$var$node.hash = "dca06bec8549dba3e1ff2c708224de6f";
    var $773b1024053c443b$export$2e2bcd8739ae039 = $773b1024053c443b$var$node;
});
parcelRegister("1M5y9", function(module, exports) {
    $parcel$export(module.exports, "Nav4OverviewsContent", ()=>$fb2fd91a88d04b6c$export$50145651ea4a827);
    var $luy4t;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jhS4y;
    var $c6x3L;
    var $9Gyp5;
    var $lOwQh;
    var $koeKL;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    var $hkziz;
    var $bbRBT;
    function $fb2fd91a88d04b6c$export$50145651ea4a827({ queryRef: queryRef }) {
        const { isSelectedPath: isSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [{ jira: { jwmOverviews: jwmOverviews } }, refetch] = (0, $8Uumt.useRefetchableFragment)((0, (0, parcelRequire("luy4t")).default), queryRef);
        (0, (0, parcelRequire("9Gyp5")).useRefetchWhenIsSelected)({
            cloudId: cloudId,
            isSelectedPath: isSelectedPath,
            QUERY: (0, parcelRequire("lOwQh")).default,
            refetch: refetch,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS)
        });
        const items = (0, $5uXOq.useMemo)(()=>{
            const nodes = jwmOverviews?.edges?.filter(Boolean).map((edge)=>edge.node) || [];
            const list = nodes.filter(Boolean).map((node)=>node.name ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bbRBT")).OverviewsMenuItem), {
                    key: node.id,
                    id: node.id,
                    name: node.name
                }) : null).filter(Boolean) ?? [];
            return {
                list: list,
                hasItems: Boolean(list.length)
            };
        }, [
            jwmOverviews
        ]);
        if (!items.hasItems) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hkziz")).OverviewsEmptyState), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, items.hasItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, items.list))));
    }
});
parcelRegister("luy4t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12db70c4555ca789$export$2e2bcd8739ae039);
    var $lOwQh;
    const $12db70c4555ca789$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, (0, parcelRequire("lOwQh")).default)
            }
        },
        "name": "Nav4OverviewsContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverview",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
    $12db70c4555ca789$var$node.hash = "e24d9b35e956ee89177e09fcc3033bc6";
    var $12db70c4555ca789$export$2e2bcd8739ae039 = $12db70c4555ca789$var$node;
});
parcelRegister("lOwQh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$396f1fb6c862454c$export$2e2bcd8739ae039);
    const $396f1fb6c862454c$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "Nav4OverviewsContentQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4OverviewsContent"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "Nav4OverviewsContentQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                "kind": "LinkedField",
                                "name": "jwmOverviews",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraWorkManagementGiraOverview",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "3e49fb6b80c74d3109cdaeee9b0845e45ba88362a09ef2d27ffccd0095c0d334",
                "metadata": {},
                "name": "Nav4OverviewsContentQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $396f1fb6c862454c$var$node.hash = "e24d9b35e956ee89177e09fcc3033bc6";
    var $396f1fb6c862454c$export$2e2bcd8739ae039 = $396f1fb6c862454c$var$node;
});
parcelRegister("hkziz", function(module, exports) {
    $parcel$export(module.exports, "OverviewsEmptyState", ()=>$ff6bee69ca61a432$export$84d2991bdf490d9e);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $koVbs;
    var $7lgBG;
    var $80d0n;
    function $ff6bee69ca61a432$export$84d2991bdf490d9e() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7lgBG")).EmptyContentMenuItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            align: "center",
            color: "color.text.subtlest"
        }, formatMessage((0, (0, parcelRequire("80d0n")).messages).noOverviews)));
    }
});
parcelRegister("80d0n", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2efe397547e443b7$export$defe85febe8b728c);
    var $7VHMR;
    const $2efe397547e443b7$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOverviews: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.empty-state.no-overviews",
            "defaultMessage": "Once you create an overview, it'll show up here."
        }
    });
});
parcelRegister("bbRBT", function(module, exports) {
    $parcel$export(module.exports, "OverviewsMenuItem", ()=>$68e0e3e271034bfa$export$1110bfd7980f0ad5);
    var $5uXOq = parcelRequire("5uXOq");
    var $i3a7M;
    var $jhS4y;
    var $46Cti;
    var $5FnJJ;
    var $dUyqZ;
    function $68e0e3e271034bfa$export$1110bfd7980f0ad5({ id: id, name: name }) {
        const { icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS);
        const { sendOverviewMenuItemAnalyticsEvent: sendOverviewMenuItemAnalyticsEvent } = (0, (0, parcelRequire("i3a7M")).useOverviewsAnalyticsL1)();
        const overviewUrl = `/jira/core/overviews/${id}/summary`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            onClick: ()=>{
                sendOverviewMenuItemAnalyticsEvent({
                    overviewId: id
                });
            },
            href: overviewUrl,
            menuId: (0, (0, parcelRequire("jhS4y")).ENTITY_ID).OVERVIEW(String(id)),
            elemBefore: icon
        }, name);
    }
});
parcelRegister("1YUDD", function(module, exports) {
    $parcel$export(module.exports, "Nav4Plans", ()=>$c0a13e2d05128c7b$export$a9599e1720ee6c82);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Fvqy;
    var $7CMCs;
    var $l8ruj;
    var $d6uAw;
    var $iUfQY;
    function $c0a13e2d05128c7b$export$a9599e1720ee6c82(props) {
        const isStandardOrFree = (0, (0, parcelRequire("7Fvqy")).useIsStandardOrFreeJSW)();
        const isUnlicensedJsw = (0, (0, parcelRequire("7Fvqy")).useIsUnlicensedJSW)();
        if (isUnlicensedJsw) return null;
        if (isStandardOrFree) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iUfQY")).Nav4PlansPremiumUpsellFeatureGate), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.sidebar.plans"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "plans-section",
            packageName: (0, $b0ee4c2dffa12273$export$b8b9d90f9e5bd72b),
            teamName: (0, $b0ee4c2dffa12273$export$d57b6b390e78d90f)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d6uAw")).Nav4Plans), props)));
    }
});
parcelRegister("7Fvqy", function(module, exports) {
    $parcel$export(module.exports, "useIsStandardOrFreeJSW", ()=>$ac0a44b8f9a76c7a$export$5edaea31b41b30b);
    $parcel$export(module.exports, "useIsPremiumJSW", ()=>$ac0a44b8f9a76c7a$export$d245a3118a8b4004);
    $parcel$export(module.exports, "useIsUnlicensedJSW", ()=>$ac0a44b8f9a76c7a$export$47ec61465121ff53);
    var $efvDm;
    var $ldyPw;
    var $k9JTq;
    const $ac0a44b8f9a76c7a$export$a2bbf41e67157372 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const jswEdition = appEditions ? (0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE), appEditions) : undefined;
        return jswEdition === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION);
    };
    const $ac0a44b8f9a76c7a$export$a55cc88b2381611c = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const jswEdition = appEditions ? (0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE), appEditions) : undefined;
        return jswEdition === (0, (0, parcelRequire("ldyPw")).FREE_EDITION);
    };
    const $ac0a44b8f9a76c7a$export$5edaea31b41b30b = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const jswEdition = appEditions ? (0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE), appEditions) : undefined;
        return jswEdition === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION) || jswEdition === (0, (0, parcelRequire("ldyPw")).FREE_EDITION);
    };
    const $ac0a44b8f9a76c7a$export$d245a3118a8b4004 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const jswEdition = appEditions ? (0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE), appEditions) : undefined;
        return jswEdition === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
    };
    const $ac0a44b8f9a76c7a$export$47ec61465121ff53 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const jswEdition = appEditions ? (0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE), appEditions) : undefined;
        return !jswEdition || jswEdition === (0, (0, parcelRequire("ldyPw")).UNLICENSED);
    };
});
const $b0ee4c2dffa12273$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Plans';
const $b0ee4c2dffa12273$export$d57b6b390e78d90f = 'jet-chronos-team';
parcelRegister("d6uAw", function(module, exports) {
    $parcel$export(module.exports, "Nav4Plans", ()=>$985d33464497955f$export$a9599e1720ee6c82);
    var $gSE3m;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $7Fvqy;
    var $jhS4y;
    var $c6x3L;
    var $h9iZl;
    var $b9Pg6;
    var $kicJ4;
    var $iC65q;
    var $iUfQY;
    function $985d33464497955f$export$a9599e1720ee6c82({ isExpanded: isExpanded, queryRef: queryRef }) {
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("gSE3m")).default), queryRef);
        const { isInitialSelectedPath: isInitialSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const hasEditPermissions = data.jira?.advancedRoadmapsNavigation?.hasEditPermissions ?? false;
        const hasCreateSamplePlanPermissions = data.jira?.advancedRoadmapsNavigation?.hasCreateSamplePlanPermissions ?? false;
        const hasGlobalPlansAdminPermissions = data.jira?.advancedRoadmapsNavigation?.hasGlobalPlansAdminPermissions ?? false;
        const actionButtons = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9Pg6")).Nav4PlansActionButtons), {
                hasEditPermissions: hasEditPermissions,
                hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
                hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
            }), [
            hasEditPermissions,
            hasCreateSamplePlanPermissions,
            hasGlobalPlansAdminPermissions
        ]);
        const [shouldRender] = (0, (0, parcelRequire("h9iZl")).useNavigationPlansVisibility)();
        const isPremium = (0, (0, parcelRequire("7Fvqy")).useIsPremiumJSW)();
        if (!shouldRender) return null;
        if (!isPremium) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iUfQY")).Nav4PlansPremiumUpsellFeatureGate), null);
        return isInitialSelectedPath((0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS)) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iC65q")).Nav4PlansForLanding), {
            actionsOnHover: actionButtons,
            isExpanded: isExpanded,
            queryRef: data
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kicJ4")).Nav4PlansDefault), {
            actionsOnHover: actionButtons,
            isExpanded: isExpanded
        });
    }
});
parcelRegister("gSE3m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59ba99e1087de085$export$2e2bcd8739ae039);
    const $59ba99e1087de085$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "isPlansExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Plans",
        "selections": [
            {
                "condition": "isPlansExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4PlansForLanding"
                    }
                ]
            },
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraAdvancedRoadmapsNavigation",
                        "kind": "LinkedField",
                        "name": "advancedRoadmapsNavigation",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "hasEditPermissions"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasCreateSamplePlanPermissions"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasGlobalPlansAdminPermissions"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
    $59ba99e1087de085$var$node.hash = "3aadd0d82198a5c14ad1e7da7343031b";
    var $59ba99e1087de085$export$2e2bcd8739ae039 = $59ba99e1087de085$var$node;
});
parcelRegister("b9Pg6", function(module, exports) {
    $parcel$export(module.exports, "Nav4PlansActionButtons", ()=>$06dac252aee09a8f$export$a7d6536605f62394);
    var $5uXOq = parcelRequire("5uXOq");
    var $1MV6x;
    var $agyyr;
    const $06dac252aee09a8f$export$a7d6536605f62394 = ({ hasEditPermissions: hasEditPermissions, hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, hasEditPermissions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1MV6x")).CreatePlanMenuButton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("agyyr")).MoreMenuButton), {
            hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
            hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
        }));
    };
});
parcelRegister("1MV6x", function(module, exports) {
    $parcel$export(module.exports, "CreatePlanMenuButton", ()=>$672e78f60f326b1f$export$fd3582c8dd19f9f6);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIWbq;
    var $3bDjY;
    var $koVbs;
    var $ivGSs;
    var $jhS4y;
    var $1xonH;
    var $gD5Z0;
    var $2NMNM;
    var $8zOmE;
    var $ydGxv;
    const $672e78f60f326b1f$export$fd3582c8dd19f9f6 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, (0, parcelRequire("gD5Z0")).useCreateNewPlanWizardDrawer)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const clickHandler = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS],
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    itemId: 'createPlan'
                }
            });
            openCreateNewPlanWizardDrawer();
        }, [
            openCreateNewPlanWizardDrawer,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("ydGxv")).default).createPlan)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xonH")).CommonNavMenuButton), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("dIWbq"))))),
            label: formatMessage((0, (0, parcelRequire("ydGxv")).default).createPlan),
            onClick: clickHandler
        }));
    };
});
parcelRegister("gD5Z0", function(module, exports) {
    $parcel$export(module.exports, "useCreateNewPlanWizardDrawer", ()=>$13f82bb8cfc1f7f2$export$f3e7d3fc94eda89a);
    $parcel$export(module.exports, "useImportedMessagesForLocale", ()=>$13f82bb8cfc1f7f2$export$52303468eeac3ad0);
    var $5uXOq = parcelRequire("5uXOq");
    var $eTXmK;
    var $4R6GH;
    var $koVbs;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $13f82bb8cfc1f7f2$var$CONTROLLER_NAME = 'create-new-plan-wizard-drawer';
    const $13f82bb8cfc1f7f2$var$initialState = {
        isOpen: false,
        plan: undefined
    };
    const $13f82bb8cfc1f7f2$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: $13f82bb8cfc1f7f2$var$CONTROLLER_NAME,
        initialState: $13f82bb8cfc1f7f2$var$initialState,
        actions: {
            openDrawer: (plan)=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('add_analytic_to_create_plan')) (0, (0, parcelRequire("eTXmK")).default)('arj-create-plan-wizard-drawer');
                return ({ setState: setState })=>setState({
                        isOpen: true,
                        plan: plan
                    });
            },
            closeDrawer: ()=>({ setState: setState })=>setState({
                        isOpen: false,
                        plan: undefined
                    })
        }
    });
    const $13f82bb8cfc1f7f2$export$f3e7d3fc94eda89a = (0, (0, parcelRequire("3sQ5x")).createHook)($13f82bb8cfc1f7f2$var$Store);
    const $13f82bb8cfc1f7f2$export$9ec7b5762fb72de2 = (0, (0, parcelRequire("gg7kZ")).createContainer)($13f82bb8cfc1f7f2$var$Store, {
        onInit: ()=>({ setState: setState }, { isOpen: isOpen, plan: plan })=>{
                setState({
                    isOpen: isOpen,
                    plan: plan
                });
            }
    });
    const $13f82bb8cfc1f7f2$var$EXCLUDED_I18N_FILES = [
        'index',
        'languages',
        'en'
    ];
    const $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES = Object.freeze({});
    const $13f82bb8cfc1f7f2$export$19442c17ab279a67 = async (rawlocale = 'en')=>{
        const locale = rawlocale.split('-')[0];
        if (!locale || $13f82bb8cfc1f7f2$var$EXCLUDED_I18N_FILES.includes(locale)) return {
            default: $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES
        };
        try {
            {
                const i18nModule = await (parcelRequire("jUfDk"));
                const result = i18nModule[locale]();
                return result;
            }
            const result = await import(`@atlassian/jira-portfolio-plan-wizard/dist/cjs/i18n/${locale}`);
            return result;
        } catch  {
            return {
                default: $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES
            };
        }
    };
    const $13f82bb8cfc1f7f2$export$52303468eeac3ad0 = ()=>{
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const [state, setState] = (0, $5uXOq.useState)({
            locale: locale,
            loading: true,
            intlMessages: undefined
        });
        (0, $5uXOq.useEffect)(()=>{
            let mounted = true;
            const load = async ()=>{
                setState((state)=>({
                        ...state,
                        loading: true
                    }));
                const { default: intlMessages } = await $13f82bb8cfc1f7f2$export$19442c17ab279a67(locale);
                if (!mounted) return;
                setState((state)=>({
                        ...state,
                        loading: false,
                        intlMessages: intlMessages
                    }));
            };
            load();
            return ()=>{
                mounted = false;
            };
        }, [
            locale
        ]);
        return state;
    };
});
parcelRegister("jUfDk", function(module, exports) {
    module.exports = {};
});
parcelRegister("ydGxv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12c7f7332437bfb0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $12c7f7332437bfb0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createPlan: {
            "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.create-plan-menu-button.create-plan",
            "defaultMessage": "Create plan"
        }
    });
});
parcelRegister("agyyr", function(module, exports) {
    $parcel$export(module.exports, "MoreMenuButton", ()=>$070d86da22a28dce$export$b13d6ccdb9a8b0c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZbEw;
    var $epOG5;
    var $kJpBP;
    var $3Z96c;
    var $eZUJu;
    var $9UCCQ;
    var $koVbs;
    var $ivGSs;
    var $jhS4y;
    var $46Cti;
    var $eaKdt;
    var $aCS3f;
    var $4LAva;
    var $2NMNM;
    var $8zOmE;
    var $ivGXF;
    const $070d86da22a28dce$var$MoreMenuItems = ({ hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [, { open: openCreateSamplePlanModal }] = (0, (0, parcelRequire("4LAva")).useCreateSamplePlan)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const createDemoPlanClickHandler = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS],
                attributes: {
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    itemId: 'createDemoPlan'
                }
            });
            openCreateSamplePlanModal();
        }, [
            openCreateSamplePlanModal,
            createAnalyticsEvent
        ]);
        const adminSettingsClickHandler = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS],
                attributes: {
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    itemId: 'adminSettings'
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, (hasCreateSamplePlanPermissions || hasGlobalPlansAdminPermissions) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            isList: true
        }, hasCreateSamplePlanPermissions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dZbEw"))))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            onClick: createDemoPlanClickHandler
        }, formatMessage((0, (0, parcelRequire("ivGXF")).default).createDemoPlan)), hasGlobalPlansAdminPermissions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("epOG5"))))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            href: "/jira/plans/settings/permissions",
            onClick: adminSettingsClickHandler
        }, formatMessage((0, (0, parcelRequire("ivGXF")).default).adminSettings))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaKdt")).HideL1MenuItemSection), {
            menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS
        }));
    };
    const $070d86da22a28dce$export$b13d6ccdb9a8b0c5 = ({ hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const clickHandler = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS],
                attributes: {
                    level: '1',
                    componentType: 'fixedItemButton',
                    itemId: 'meatballDropdown'
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            MenuItems: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($070d86da22a28dce$var$MoreMenuItems, {
                    hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
                    hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
                }),
            name: formatMessage((0, (0, parcelRequire("ivGXF")).default).plansMoreMenu),
            onOpen: clickHandler
        });
    };
});
parcelRegister("4LAva", function(module, exports) {
    $parcel$export(module.exports, "useCreateSamplePlan", ()=>$8f6b3552bc4c872c$export$53d6fde96f096b86);
    $parcel$export(module.exports, "CreateSamplePlanProvider", ()=>$8f6b3552bc4c872c$export$88b99aa46c223622);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $e0K2C;
    var $hK1fQ;
    const $8f6b3552bc4c872c$var$CONTROLLER_NAME = 'create-sample-plan';
    const $8f6b3552bc4c872c$var$initialState = {
        isOpen: false,
        planId: null,
        taskId: null,
        progressPercentage: null,
        hasBeenInitialised: false
    };
    const $8f6b3552bc4c872c$var$actions = {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                const nextState = (({ hasBeenInitialised: hasBeenInitialised, ...rest })=>rest)($8f6b3552bc4c872c$var$initialState);
                setState(nextState);
            },
        setPlanId: (planId)=>({ setState: setState })=>{
                setState({
                    planId: planId
                });
            },
        setTaskId: (taskId)=>({ setState: setState })=>{
                setState({
                    taskId: taskId
                });
            },
        setProgressPercentage: (progressPercentage)=>({ setState: setState })=>{
                setState({
                    progressPercentage: progressPercentage
                });
            },
        submitSamplePlan: ({ planName: planName, flags: { success: SuccessFlag, error: ErrorFlag } })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { showFlag: showFlag, redirectToPlan: redirectToPlan, leadAccountId: leadAccountId })=>{
                try {
                    const taskId = await (0, (0, parcelRequire("hK1fQ")).createSamplePlanAsync)({
                        body: JSON.stringify({
                            title: planName,
                            leadAccountId: leadAccountId
                        })
                    });
                    setState({
                        taskId: taskId
                    });
                    const response = await (0, (0, parcelRequire("hK1fQ")).pollCreateSamplePlan)(taskId, (progressPercentage)=>{
                        const { taskId: latestTaskId } = getState();
                        if (taskId !== latestTaskId) return;
                        setState({
                            progressPercentage: progressPercentage
                        });
                    });
                    const { plan: plan } = response.samplePlan;
                    const currentState = getState();
                    if (currentState.isOpen && taskId === currentState.taskId) {
                        redirectToPlan(plan.id);
                        dispatch($8f6b3552bc4c872c$var$actions.close());
                    } else {
                        const flagId = (0, (0, parcelRequire("e0K2C")).CREATE_SUCCESS_FLAG_ID) + plan.id;
                        showFlag({
                            id: flagId,
                            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement(SuccessFlag, {
                                    id: flagId,
                                    planName: plan.name,
                                    planId: plan.id
                                })
                        });
                    }
                } catch (err) {
                    if (!(0, (0, parcelRequire("e0K2C")).USER_SETTINGS_ERRORS).includes(err.message)) (0, (0, parcelRequire("jcw0u")).default)({
                        error: err,
                        meta: {
                            id: `${(0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_PACKAGE)}SubmitFailed`,
                            packageName: (0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_PACKAGE),
                            teamName: (0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_TEAM)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    const props = {
                        id: (0, (0, parcelRequire("e0K2C")).CREATE_ERROR_FLAG_ID),
                        errorCode: err.message
                    };
                    showFlag({
                        id: (0, (0, parcelRequire("e0K2C")).CREATE_ERROR_FLAG_ID),
                        render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement(ErrorFlag, props)
                    });
                    dispatch($8f6b3552bc4c872c$var$actions.close());
                }
            }
    };
    const $8f6b3552bc4c872c$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: $8f6b3552bc4c872c$var$CONTROLLER_NAME,
        initialState: $8f6b3552bc4c872c$var$initialState,
        actions: $8f6b3552bc4c872c$var$actions
    });
    const $8f6b3552bc4c872c$export$53d6fde96f096b86 = (0, (0, parcelRequire("3sQ5x")).createHook)($8f6b3552bc4c872c$var$Store);
    const $8f6b3552bc4c872c$export$88b99aa46c223622 = (0, (0, parcelRequire("gg7kZ")).createContainer)($8f6b3552bc4c872c$var$Store, {
        onInit: ()=>({ setState: setState }, { isOpen: isOpen = false })=>{
                setState({
                    isOpen: isOpen,
                    hasBeenInitialised: true
                });
            }
    });
});
parcelRegister("e0K2C", function(module, exports) {
    $parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", ()=>$3613c4dc2e67ca96$export$f27a837467ec20e5);
    $parcel$export(module.exports, "ERROR_REPORTING_TEAM", ()=>$3613c4dc2e67ca96$export$cfeee2ee86ead336);
    $parcel$export(module.exports, "MAX_PLAN_NAME_LENGTH", ()=>$3613c4dc2e67ca96$export$62da4a2465b3b309);
    $parcel$export(module.exports, "CREATE_SUCCESS_FLAG_ID", ()=>$3613c4dc2e67ca96$export$d526356745046017);
    $parcel$export(module.exports, "CREATE_ERROR_FLAG_ID", ()=>$3613c4dc2e67ca96$export$abd17266df221a92);
    $parcel$export(module.exports, "UNKNOWN_EXCEPTION", ()=>$3613c4dc2e67ca96$export$cfba07bc71f884c1);
    $parcel$export(module.exports, "USER_SETTINGS_ERRORS", ()=>$3613c4dc2e67ca96$export$4a3e779cd3c10125);
    $parcel$export(module.exports, "ERROR_CODE_TITLE_MAPPING", ()=>$3613c4dc2e67ca96$export$91ec80863c2c2030);
    $parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING", ()=>$3613c4dc2e67ca96$export$c43e20911e13ca0);
    $parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING_ISSUE_TERM_REFRESH", ()=>$3613c4dc2e67ca96$export$525cba92c9b435f4);
    $parcel$export(module.exports, "ERROR_LINK_MAPPING", ()=>$3613c4dc2e67ca96$export$2c5a783ab3215ce1);
    var $2L5wO;
    const $3613c4dc2e67ca96$export$f27a837467ec20e5 = 'jiraPortfolio3CreateSamplePlan';
    const $3613c4dc2e67ca96$export$cfeee2ee86ead336 = 'advanced-roadmaps';
    const $3613c4dc2e67ca96$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact';
    const $3613c4dc2e67ca96$export$af6d68522cb370b8 = 'https://support.atlassian.com/jira-software-cloud/docs/view-a-sample-advanced-roadmaps-plan/';
    const $3613c4dc2e67ca96$export$62da4a2465b3b309 = 255;
    const $3613c4dc2e67ca96$export$d526356745046017 = 'samplePlanCreatedSuccessfully';
    const $3613c4dc2e67ca96$export$abd17266df221a92 = 'samplePlanError';
    const $3613c4dc2e67ca96$export$e6515d2009b1dba7 = 'REQUIRED_FIELDS_CONFIGURED_ON_ISSUE';
    const $3613c4dc2e67ca96$export$80ecb4d853a9f09b = 'EMPTY_ISSUE_LINKS';
    const $3613c4dc2e67ca96$export$f31def2c4daaefc0 = 'NO_BROWSE_PROJECTS_PERMISSION';
    const $3613c4dc2e67ca96$export$530d46555d7ccbb = 'NO_CREATE_ISSUES_PERMISSION';
    const $3613c4dc2e67ca96$export$8c852ea52ca9ebe = 'NO_TRANSITION_ISSUES_PERMISSION';
    const $3613c4dc2e67ca96$export$855d898b7009ad1c = 'NO_EDIT_ISSUES_PERMISSION';
    const $3613c4dc2e67ca96$export$5c8703f47a29c462 = 'WATCHING_DISABLED';
    const $3613c4dc2e67ca96$export$cfba07bc71f884c1 = 'UNKNOWN_EXCEPTION';
    const $3613c4dc2e67ca96$export$4a3e779cd3c10125 = [
        $3613c4dc2e67ca96$export$e6515d2009b1dba7,
        $3613c4dc2e67ca96$export$80ecb4d853a9f09b,
        $3613c4dc2e67ca96$export$f31def2c4daaefc0,
        $3613c4dc2e67ca96$export$530d46555d7ccbb,
        $3613c4dc2e67ca96$export$8c852ea52ca9ebe,
        $3613c4dc2e67ca96$export$855d898b7009ad1c,
        $3613c4dc2e67ca96$export$5c8703f47a29c462
    ];
    const $3613c4dc2e67ca96$export$91ec80863c2c2030 = {
        [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, (0, parcelRequire("2L5wO")).default).configurationErrorTitle,
        [$3613c4dc2e67ca96$export$80ecb4d853a9f09b]: (0, (0, parcelRequire("2L5wO")).default).configurationErrorTitle,
        [$3613c4dc2e67ca96$export$f31def2c4daaefc0]: (0, (0, parcelRequire("2L5wO")).default).permissionErrorTitle,
        [$3613c4dc2e67ca96$export$530d46555d7ccbb]: (0, (0, parcelRequire("2L5wO")).default).permissionErrorTitle,
        [$3613c4dc2e67ca96$export$8c852ea52ca9ebe]: (0, (0, parcelRequire("2L5wO")).default).permissionErrorTitle,
        [$3613c4dc2e67ca96$export$855d898b7009ad1c]: (0, (0, parcelRequire("2L5wO")).default).permissionErrorTitle,
        [$3613c4dc2e67ca96$export$5c8703f47a29c462]: (0, (0, parcelRequire("2L5wO")).default).configurationErrorTitle,
        [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, (0, parcelRequire("2L5wO")).default).tryAgainErrorTitle
    };
    const $3613c4dc2e67ca96$export$c43e20911e13ca0 = {
        [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, (0, parcelRequire("2L5wO")).default).requiredFieldsConfiguredOnIssueError,
        [$3613c4dc2e67ca96$export$80ecb4d853a9f09b]: (0, (0, parcelRequire("2L5wO")).default).emptyIssueLinksError,
        [$3613c4dc2e67ca96$export$f31def2c4daaefc0]: (0, (0, parcelRequire("2L5wO")).default).noBrowseProjectsPermissionError,
        [$3613c4dc2e67ca96$export$530d46555d7ccbb]: (0, (0, parcelRequire("2L5wO")).default).noCreateIssuesPermissionError,
        [$3613c4dc2e67ca96$export$8c852ea52ca9ebe]: (0, (0, parcelRequire("2L5wO")).default).noTransitionIssuesPermissionError,
        [$3613c4dc2e67ca96$export$855d898b7009ad1c]: (0, (0, parcelRequire("2L5wO")).default).noEditIssuesPermissionError,
        [$3613c4dc2e67ca96$export$5c8703f47a29c462]: (0, (0, parcelRequire("2L5wO")).default).watchingDisabledError,
        [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, (0, parcelRequire("2L5wO")).default).unknownExceptionError
    };
    const $3613c4dc2e67ca96$export$525cba92c9b435f4 = {
        [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, (0, parcelRequire("2L5wO")).default).requiredFieldsConfiguredOnIssueErrorIssueTermRefresh,
        [$3613c4dc2e67ca96$export$80ecb4d853a9f09b]: (0, (0, parcelRequire("2L5wO")).default).emptyIssueLinksErrorIssueTermRefresh,
        [$3613c4dc2e67ca96$export$f31def2c4daaefc0]: (0, (0, parcelRequire("2L5wO")).default).noBrowseProjectsPermissionError,
        [$3613c4dc2e67ca96$export$530d46555d7ccbb]: (0, (0, parcelRequire("2L5wO")).default).noCreateIssuesPermissionErrorIssueTermRefresh,
        [$3613c4dc2e67ca96$export$8c852ea52ca9ebe]: (0, (0, parcelRequire("2L5wO")).default).noTransitionIssuesPermissionErrorIssueTermRefresh,
        [$3613c4dc2e67ca96$export$855d898b7009ad1c]: (0, (0, parcelRequire("2L5wO")).default).noEditIssuesPermissionErrorIssueTermRefresh,
        [$3613c4dc2e67ca96$export$5c8703f47a29c462]: (0, (0, parcelRequire("2L5wO")).default).watchingDisabledErrorIssueTermRefresh,
        [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, (0, parcelRequire("2L5wO")).default).unknownExceptionError
    };
    const $3613c4dc2e67ca96$export$2c5a783ab3215ce1 = {
        [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$80ecb4d853a9f09b]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$f31def2c4daaefc0]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$530d46555d7ccbb]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$8c852ea52ca9ebe]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$855d898b7009ad1c]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$5c8703f47a29c462]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: {
            text: (0, (0, parcelRequire("2L5wO")).default).contactSupport,
            href: $3613c4dc2e67ca96$export$2c16bd1d8b68b11f
        }
    };
});
parcelRegister("2L5wO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4969e0d482b1a0a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e4969e0d482b1a0a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        configurationErrorTitle: {
            "id": "portfolio-3-create-sample-plan.common.configuration-error-title",
            "defaultMessage": "Your demo plan couldn't be created because of a configuration error"
        },
        permissionErrorTitle: {
            "id": "portfolio-3-create-sample-plan.common.permission-error-title",
            "defaultMessage": "Your demo plan couldn't be created because you\u2019re missing a required permission"
        },
        tryAgainErrorTitle: {
            "id": "portfolio-3-create-sample-plan.common.try-again-error-title",
            "defaultMessage": "Try to create your demo plan again"
        },
        requiredFieldsConfiguredOnIssueError: {
            "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error",
            "defaultMessage": "Your issues have required fields which blocked your demo plan from being created. {readMoreLink}"
        },
        emptyIssueLinksError: {
            "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error",
            "defaultMessage": "Your site doesn't have issue links configured, which are required to create a demo plan. {readMoreLink}"
        },
        noBrowseProjectsPermissionError: {
            "id": "portfolio-3-create-sample-plan.common.no-browse-projects-permission-error",
            "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Browse Projects</permission-type> permission. {readMoreLink}"
        },
        noCreateIssuesPermissionError: {
            "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error",
            "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create Issues</permission-type> permission. {readMoreLink}"
        },
        noTransitionIssuesPermissionError: {
            "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error",
            "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition Issues</permission-type> permission. {readMoreLink}"
        },
        noEditIssuesPermissionError: {
            "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error",
            "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit Issues</permission-type> permission. {readMoreLink}"
        },
        watchingDisabledError: {
            "id": "portfolio-3-create-sample-plan.common.watching-disabled-error",
            "defaultMessage": "Your demo plan couldn't be created because you have issue watching disabled. {readMoreLink}"
        },
        unknownExceptionError: {
            "id": "portfolio-3-create-sample-plan.common.unknown-exception-error",
            "defaultMessage": "Your demo plan couldn't be created, but we\u2019re not sure why. If the problem persists, contact Atlassian support. {readMoreLink}"
        },
        learnMore: {
            "id": "portfolio-3-create-sample-plan.common.learn-more",
            "defaultMessage": "Learn more"
        },
        contactSupport: {
            "id": "portfolio-3-create-sample-plan.common.contact-support",
            "defaultMessage": "Contact Atlassian support"
        },
        requiredFieldsConfiguredOnIssueErrorIssueTermRefresh: {
            "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error-issue-term-refresh",
            "defaultMessage": "Your issues have required fields which blocked your demo plan from being created. {readMoreLink}"
        },
        emptyIssueLinksErrorIssueTermRefresh: {
            "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error-issue-term-refresh",
            "defaultMessage": "Your site doesn't have issue links configured, which are required to create a demo plan. {readMoreLink}"
        },
        noCreateIssuesPermissionErrorIssueTermRefresh: {
            "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error-issue-term-refresh",
            "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create Issues</permission-type> permission. {readMoreLink}"
        },
        noTransitionIssuesPermissionErrorIssueTermRefresh: {
            "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error-issue-term-refresh",
            "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition Issues</permission-type> permission. {readMoreLink}"
        },
        noEditIssuesPermissionErrorIssueTermRefresh: {
            "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error-issue-term-refresh",
            "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit Issues</permission-type> permission. {readMoreLink}"
        },
        watchingDisabledErrorIssueTermRefresh: {
            "id": "portfolio-3-create-sample-plan.common.watching-disabled-error-issue-term-refresh",
            "defaultMessage": "Your demo plan couldn't be created because you have issue watching disabled. {readMoreLink}"
        }
    });
});
parcelRegister("hK1fQ", function(module, exports) {
    $parcel$export(module.exports, "createSamplePlanAsync", ()=>$4a753946a320d2b7$export$fed9130b90cf6213);
    $parcel$export(module.exports, "pollCreateSamplePlan", ()=>$4a753946a320d2b7$export$5d240a69af545c0d);
    var $jcw0u;
    var $fnyT4;
    var $jJZqs;
    var $eusud;
    var $e0K2C;
    const $4a753946a320d2b7$var$throwIfNotOk = async (response)=>{
        if (response.ok) return response;
        if (response.status === 500) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, (0, (0, parcelRequire("e0K2C")).UNKNOWN_EXCEPTION), response.headers.get((0, (0, parcelRequire("fnyT4")).TRACE_ID_HEADER)) ?? undefined, response);
    };
    const $4a753946a320d2b7$var$throwIfFailed = (result)=>{
        if (result.samplePlan && !result.samplePlan.success) throw new Error(result.samplePlan.error);
    };
    const $4a753946a320d2b7$var$delay = (ms = 3000)=>new Promise((res)=>setTimeout(res, ms));
    const $4a753946a320d2b7$export$fed9130b90cf6213 = async (data)=>{
        const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/jpo/1.0/plans/sampleplan/async', data);
        const { taskId: taskId } = response;
        if (!taskId) throw new Error('Invalid response from createSamplePlan');
        return taskId;
    };
    const $4a753946a320d2b7$export$5d240a69af545c0d = async (taskId, onUpdate)=>{
        const url = `/rest/jpo/1.0/plans/sampleplan/async/${taskId}`;
        try {
            const response = await fetch(url);
            await $4a753946a320d2b7$var$throwIfNotOk(response);
            const raw = await response.json();
            $4a753946a320d2b7$var$throwIfFailed(raw);
            onUpdate(raw.progressPercent);
            if (raw.done) return raw;
            await $4a753946a320d2b7$var$delay();
            return $4a753946a320d2b7$export$5d240a69af545c0d(taskId, onUpdate);
        } catch (error) {
            if (!(0, (0, parcelRequire("e0K2C")).USER_SETTINGS_ERRORS).includes(error.message)) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: `${(0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_PACKAGE)}PollingFailed`,
                    packageName: (0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_PACKAGE),
                    teamName: (0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_TEAM)
                },
                attributes: {
                    message: 'Polling create sample plan failed'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("ivGXF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97d8a8b002f64e68$export$2e2bcd8739ae039);
    var $7VHMR;
    var $97d8a8b002f64e68$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        adminSettings: {
            "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.admin-settings",
            "defaultMessage": "Admin configuration"
        },
        plansMoreMenu: {
            "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.plans-more-menu",
            "defaultMessage": "Plans"
        },
        createDemoPlan: {
            "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.create-demo-plan",
            "defaultMessage": "Create demo plan"
        }
    });
});
parcelRegister("kicJ4", function(module, exports) {
    $parcel$export(module.exports, "Nav4PlansDefault", ()=>$f508957e3c5a5c81$export$8edda76b63bd4bcb);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $cSD7y;
    var $jecJ3;
    var $jhS4y;
    var $aGONy;
    var $46Cti;
    var $c16H2;
    var $338xa;
    var $dQbFB;
    var $eQV8d;
    var $dUyqZ;
    var $4zcxJ;
    var $fb8Lj;
    var $koeKL;
    var $lnznH;
    var $cZa9B;
    var $5layf;
    const $f508957e3c5a5c81$var$Nav4PlansDefaultNew = ({ actionsOnHover: actionsOnHover, isExpanded: isExpanded })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const currentURLPath = (0, (0, parcelRequire("aGONy")).useGetCurrentUrlPath)();
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                currentURLPath: currentURLPath
            }), [
            cloudId,
            currentURLPath
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("5layf")).asyncPlansSectionPlanListViewQuery), entryPointParams);
        const triggerRef = (0, (0, parcelRequire("4zcxJ")).useExpandableEntryPointTrigger)(entryPointActions);
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS);
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            onSystemToggle: (hasExpanded)=>{
                if (hasExpanded) entryPointActions.load();
            },
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) {
                    entryPointActions.load();
                    sendSectionItemAnalyticsEvent({
                        menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS,
                        sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_PLANS)
                    });
                }
            },
            menuId: menuId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            ref: triggerRef,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-plans-default",
            packageName: (0, $b0ee4c2dffa12273$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $b0ee4c2dffa12273$export$d57b6b390e78d90f),
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null),
            runtimeProps: entryPointParams
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fb8Lj")).Nav4PlansFooter), null)));
    };
    const $f508957e3c5a5c81$var$Nav4PlansDefaultOld = ({ actionsOnHover: actionsOnHover, isExpanded: isExpanded })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const currentURL = (0, (0, parcelRequire("aGONy")).useGetCurrentUrl)();
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                currentURL: currentURL
            }), [
            cloudId,
            currentURL
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("5layf")).asyncPlansSectionPlanListViewQuery), entryPointParams);
        const triggerRef = (0, (0, parcelRequire("4zcxJ")).useExpandableEntryPointTrigger)(entryPointActions);
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS);
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            onSystemToggle: (hasExpanded)=>{
                if (hasExpanded) entryPointActions.load();
            },
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) {
                    entryPointActions.load();
                    sendSectionItemAnalyticsEvent({
                        menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS,
                        sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_PLANS)
                    });
                }
            },
            menuId: menuId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            ref: triggerRef,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-plans-default",
            packageName: (0, $b0ee4c2dffa12273$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $b0ee4c2dffa12273$export$d57b6b390e78d90f),
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null),
            runtimeProps: entryPointParams
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fb8Lj")).Nav4PlansFooter), null)));
    };
    const $f508957e3c5a5c81$export$8edda76b63bd4bcb = (0, (0, parcelRequire("cSD7y")).componentWithFG)('plans_-_avoid_refetching_plans_nav_on_query_change', $f508957e3c5a5c81$var$Nav4PlansDefaultNew, $f508957e3c5a5c81$var$Nav4PlansDefaultOld);
});
parcelRegister("fb8Lj", function(module, exports) {
    $parcel$export(module.exports, "Nav4PlansFooter", ()=>$42fbc7ad9b24b6aa$export$484b1d8ed55fea0a);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $ivGSs;
    var $jhS4y;
    var $34PKs;
    var $2NMNM;
    var $8zOmE;
    var $8jQu6;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    var $5WlKy;
    const $42fbc7ad9b24b6aa$var$VIEW_ALL_PLANS_HREF = (0, (0, parcelRequire("8jQu6")).plansDirectoryRoute).path;
    const $42fbc7ad9b24b6aa$export$484b1d8ed55fea0a = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const viewAllPlansClickHandler = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS],
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    itemId: 'viewAllPlans'
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("34PKs")).ViewAllEntityMenuItem), {
            href: $42fbc7ad9b24b6aa$var$VIEW_ALL_PLANS_HREF,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS_VIEW_ALL),
            onClick: viewAllPlansClickHandler
        }, formatMessage((0, (0, parcelRequire("5WlKy")).default).viewAllPlans)))));
    };
});
parcelRegister("5WlKy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f511387c8725975f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f511387c8725975f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewAllPlans: {
            "id": "navigation-apps-sidebar-nav4-plans.plans.common.footer.view-all-plans",
            "defaultMessage": "View all plans"
        }
    });
});
parcelRegister("5layf", function(module, exports) {
    $parcel$export(module.exports, "asyncPlansSectionPlanListViewQuery", ()=>$fd20310af43be2cc$export$c2f76ac2cce77bea);
    var $52dVj;
    var $eufEc;
    var $fEDBv;
    const $fd20310af43be2cc$export$c2f76ac2cce77bea = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("e6x4C")).then((module)=>module.Nav4PlansListViewQuery), {
            moduleId: "90d35cd1",
            moduleName: "Nav4PlansListViewQuery"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                queries: {
                    queryRef: {
                        parameters: (0, parcelRequire("52dVj")).default,
                        variables: {
                            cloudId: cloudId
                        }
                    }
                }
            })
    });
});
parcelRegister("52dVj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31e75d27297f8a2d$export$2e2bcd8739ae039);
    const $31e75d27297f8a2d$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = {
            "kind": "ScalarField",
            "name": "id"
        }, v3 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v2,
                            {
                                "kind": "ScalarField",
                                "name": "planId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isReadOnly"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "planStatus"
                            },
                            {
                                "concreteType": "JiraFavouriteValue",
                                "kind": "LinkedField",
                                "name": "favouriteValue",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isFavourite"
                                    },
                                    v2
                                ]
                            },
                            {
                                "concreteType": "JiraScenario",
                                "kind": "LinkedField",
                                "name": "scenario",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "scenarioId"
                                    },
                                    v2
                                ]
                            }
                        ],
                        "type": "JiraPlan"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v2
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                    }
                ]
            }
        ], v4 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "Nav4PlansListViewQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "PlansList"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "PlansListOld"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "Nav4PlansListViewQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "favouritePlans",
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "PLAN"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v3
                                    },
                                    v4
                                ]
                            },
                            {
                                "alias": "recentPlans",
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "PLAN"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v3
                                    },
                                    v4
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "1f5d61c067cee56435f4fff1baf4b6cfa3bfabf873b885dd241067b7a70acb88",
                "metadata": {},
                "name": "Nav4PlansListViewQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $31e75d27297f8a2d$var$node.hash = "32cab3facf0612ab0b04e3ca121fbe0f";
    var $31e75d27297f8a2d$export$2e2bcd8739ae039 = $31e75d27297f8a2d$var$node;
});
parcelRegister("e6x4C", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kqK1D").then(()=>parcelRequire('2N2w4'));
});
parcelRegister("iC65q", function(module, exports) {
    $parcel$export(module.exports, "Nav4PlansForLanding", ()=>$7e0bd176a951675e$export$5e6b364538aa2f20);
    var $lkgPQ;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $4R6GH;
    var $jecJ3;
    var $jhS4y;
    var $46Cti;
    var $c16H2;
    var $dQbFB;
    var $eQV8d;
    var $dUyqZ;
    var $fb8Lj;
    var $bQ7Ub;
    var $9tfnl;
    var $lnznH;
    var $cZa9B;
    function $7e0bd176a951675e$export$5e6b364538aa2f20(props) {
        const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS);
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("lkgPQ")).default), queryRef);
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: menuId,
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) sendSectionItemAnalyticsEvent({
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS,
                    sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_PLANS)
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            actionsOnHover: actionsOnHover,
            elemBefore: icon,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, (0, parcelRequire("4R6GH")).fg)('plans_-_avoid_refetching_plans_nav_on_query_change') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bQ7Ub")).PlansList), {
            fragmentRef: data
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9tfnl")).PlansListOld), {
            fragmentRef: data
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fb8Lj")).Nav4PlansFooter), null)));
    }
});
parcelRegister("lkgPQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df8c46c4fcd1f5f0$export$2e2bcd8739ae039);
    const $df8c46c4fcd1f5f0$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4PlansForLanding",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "PlansList"
            },
            {
                "kind": "FragmentSpread",
                "name": "PlansListOld"
            }
        ],
        "type": "Query"
    };
    $df8c46c4fcd1f5f0$var$node.hash = "9426d3d41c02ec5eb5bb5841e78402ae";
    var $df8c46c4fcd1f5f0$export$2e2bcd8739ae039 = $df8c46c4fcd1f5f0$var$node;
});
parcelRegister("bQ7Ub", function(module, exports) {
    $parcel$export(module.exports, "PlansList", ()=>$fd1fb502ced6933e$export$610289543b80d1e7);
    var $9Ye9m;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $koVbs;
    var $jhS4y;
    var $c6x3L;
    var $9Gyp5;
    var $gxbcq;
    var $1b6zA;
    var $92lvB;
    var $koeKL;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    var $2CQvU;
    var $aQcVR;
    var $gT8yh;
    var $a6aJc;
    const $fd1fb502ced6933e$var$MAX_RECENT_PLANS = 5;
    const $fd1fb502ced6933e$export$610289543b80d1e7 = ({ fragmentRef: fragmentRef })=>{
        const { isSelectedPath: isSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { getStableItems: getStableItems } = (0, (0, parcelRequire("1b6zA")).useStableItems)();
        const [data, refetch] = (0, $8Uumt.useRefetchableFragment)((0, (0, parcelRequire("9Ye9m")).default), fragmentRef);
        (0, (0, parcelRequire("9Gyp5")).useRefetchWhenIsSelected)({
            cloudId: cloudId,
            isSelectedPath: isSelectedPath,
            QUERY: (0, parcelRequire("92lvB")).default,
            refetch: refetch,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS)
        });
        const refetchOnChange = (0, $5uXOq.useCallback)(({ onComplete: onComplete })=>{
            refetch({
                cloudId: cloudId
            }, {
                fetchPolicy: 'store-and-network',
                onComplete: onComplete
            });
        }, [
            cloudId,
            refetch
        ]);
        (0, (0, parcelRequire("gxbcq")).useSubscribeAndUpdateFavorites)({
            entityTypename: 'JiraPlan',
            favouriteConnectionId: data.jira.favouritePlans.__id,
            recentConnectionId: data.jira.recentPlans.__id,
            refetch: refetchOnChange
        });
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const starred = formatMessage((0, (0, parcelRequire("gT8yh")).default).starred);
        const recent = formatMessage((0, (0, parcelRequire("gT8yh")).default).recent);
        const favorites = (0, $5uXOq.useMemo)(()=>{
            const ids = data.jira.favouritePlans.edges?.map((edge)=>edge?.node.id).filter(Boolean) ?? [];
            const list = data.jira.favouritePlans.edges?.filter(Boolean).map((edge)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a6aJc")).PlanMenuItem), {
                    key: edge.node.planId,
                    fragmentRef: edge.node,
                    favouriteConnectionId: data.jira.favouritePlans.__id
                })) ?? [];
            return {
                idSet: new Set(ids),
                list: list,
                hasItems: Boolean(list.length)
            };
        }, [
            data.jira.favouritePlans.__id,
            data.jira.favouritePlans.edges
        ]);
        const recentPlans = (0, $5uXOq.useMemo)(()=>{
            const nodes = data.jira.recentPlans.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, $fd1fb502ced6933e$var$MAX_RECENT_PLANS) ?? [];
            const stableOrderedNodes = getStableItems({
                nodes: nodes,
                idKey: 'id'
            });
            const list = stableOrderedNodes.map((node)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a6aJc")).PlanMenuItem), {
                    key: node.planId,
                    fragmentRef: node,
                    favouriteConnectionId: data.jira.favouritePlans.__id
                }));
            return {
                list: list,
                hasItems: Boolean(list.length)
            };
        }, [
            data.jira.favouritePlans.__id,
            data.jira.recentPlans.edges,
            favorites.idSet,
            getStableItems
        ]);
        if (!favorites.hasItems && !recentPlans.hasItems) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aQcVR")).PlansEmptyContent), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, favorites.hasItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CQvU")).MenuSectionHeading), null, starred), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, favorites.list))), recentPlans.hasItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CQvU")).MenuSectionHeading), null, recent), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, recentPlans.list))));
    };
});
parcelRegister("9Ye9m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$231987b90f34a9fa$export$2e2bcd8739ae039);
    var $92lvB;
    const $231987b90f34a9fa$var$node = function() {
        var v0 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v1 = {
            "kind": "ScalarField",
            "name": "id"
        }, v2 = {
            "kind": "ScalarField",
            "name": "planId"
        }, v3 = {
            "kind": "FragmentSpread",
            "name": "PlanMenuItem"
        }, v4 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "cloudId"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "currentURLPath"
                }
            ],
            "kind": "Fragment",
            "metadata": {
                "refetch": {
                    "fragmentPathInResult": [],
                    "operation": (0, (0, parcelRequire("92lvB")).default)
                }
            },
            "name": "PlansList",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v0,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "PLAN"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v1,
                                                                        "action": "THROW",
                                                                        "path": "jira.favouritePlans.edges.node.id"
                                                                    },
                                                                    v2,
                                                                    v3
                                                                ],
                                                                "type": "JiraPlan"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.favouritePlans.edges.node"
                                                }
                                            ]
                                        },
                                        v4
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.favouritePlans"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "recentPlans",
                                    "args": [
                                        v0,
                                        {
                                            "kind": "Variable",
                                            "name": "currentURL",
                                            "variableName": "currentURLPath"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 20
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v1,
                                                                        "action": "THROW",
                                                                        "path": "jira.recentPlans.edges.node.id"
                                                                    },
                                                                    v2,
                                                                    v3
                                                                ],
                                                                "type": "JiraPlan"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.recentPlans.edges.node"
                                                }
                                            ]
                                        },
                                        v4
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.recentPlans"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        };
    }();
    $231987b90f34a9fa$var$node.hash = "e8a7439c6548eef2e6912a6c79a00748";
    var $231987b90f34a9fa$export$2e2bcd8739ae039 = $231987b90f34a9fa$var$node;
});
parcelRegister("92lvB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1036deebd1a68627$export$2e2bcd8739ae039);
    const $1036deebd1a68627$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURLPath"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = {
            "kind": "ScalarField",
            "name": "id"
        }, v3 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v2,
                            {
                                "kind": "ScalarField",
                                "name": "planId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isReadOnly"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "planStatus"
                            },
                            {
                                "concreteType": "JiraFavouriteValue",
                                "kind": "LinkedField",
                                "name": "favouriteValue",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isFavourite"
                                    },
                                    v2
                                ]
                            },
                            {
                                "concreteType": "JiraScenario",
                                "kind": "LinkedField",
                                "name": "scenario",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "scenarioId"
                                    },
                                    v2
                                ]
                            }
                        ],
                        "type": "JiraPlan"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v2
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                    }
                ]
            }
        ], v4 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "PlanListQuery",
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "currentURLPath",
                                "variableName": "currentURLPath"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "PlansList"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "PlanListQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "favouritePlans",
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "PLAN"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v3
                                    },
                                    v4
                                ]
                            },
                            {
                                "alias": "recentPlans",
                                "args": [
                                    v1,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURLPath"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "PLAN"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v3
                                    },
                                    v4
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "f8e94959e632bb480448211ebff7e7297674d390a49b57416f101355cc93f334",
                "metadata": {},
                "name": "PlanListQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $1036deebd1a68627$var$node.hash = "e8a7439c6548eef2e6912a6c79a00748";
    var $1036deebd1a68627$export$2e2bcd8739ae039 = $1036deebd1a68627$var$node;
});
parcelRegister("aQcVR", function(module, exports) {
    $parcel$export(module.exports, "PlansEmptyContent", ()=>$eeca831f93fd0984$export$2b2efe96e6f14be5);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $koVbs;
    var $7lgBG;
    var $8Pg2W;
    function $eeca831f93fd0984$export$2b2efe96e6f14be5() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7lgBG")).EmptyContentMenuItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            color: "color.text.subtle"
        }, formatMessage((0, (0, parcelRequire("8Pg2W")).default).noPlans)));
    }
});
parcelRegister("8Pg2W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07cf8d171bf729c5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $07cf8d171bf729c5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noPlans: {
            "id": "navigation-apps-sidebar-nav4-plans.plans.common.empty-content.no-plans",
            "defaultMessage": "Once you open or create plans, they'll show up here."
        }
    });
});
parcelRegister("gT8yh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b67eb75de0b9f683$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b67eb75de0b9f683$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        recent: {
            "id": "navigation-apps-sidebar-nav4-plans.plans.common.plans-list.recent",
            "defaultMessage": "Recent"
        },
        starred: {
            "id": "navigation-apps-sidebar-nav4-plans.plans.common.plans-list.starred",
            "defaultMessage": "Starred"
        }
    });
});
parcelRegister("a6aJc", function(module, exports) {
    $parcel$export(module.exports, "PlanMenuItem", ()=>$73683d423a412055$export$5805f023607bba3d);
    var $1rvIC;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $ifnb0;
    var $1d5uQ;
    var $jecJ3;
    var $ivGSs;
    var $jhS4y;
    var $5FnJJ;
    var $2oTRI;
    var $8jQu6;
    var $9VXkC;
    const $73683d423a412055$var$VIEW_ALL_PLANS_HREF = (0, (0, parcelRequire("8jQu6")).plansDirectoryRoute).path;
    const $73683d423a412055$export$5805f023607bba3d = ({ fragmentRef: fragmentRef, favouriteConnectionId: favouriteConnectionId })=>{
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("1rvIC")).default), fragmentRef);
        const planId = data?.planId;
        const isStarred = data?.favouriteValue?.isFavourite ?? false;
        const analytics = (0, $5uXOq.useMemo)(()=>({
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS],
                level: 1,
                componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                itemId: (0, $632bd8725b437a12$export$c303e491e026ebc6),
                planId: planId ?? undefined,
                section: isStarred ? (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_STARRED) : (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_RECENT)
            }), [
            planId,
            isStarred
        ]);
        if (!data) return null;
        const scenarioId = data.scenario?.scenarioId;
        const planTitle = data.title || '';
        const planUrl = (0, (0, parcelRequire("9VXkC")).generatePath)((0, (0, parcelRequire("2oTRI")).softwarePlanTimelineRoute).path, {
            planId: planId,
            scenarioId: scenarioId
        });
        const isReadOnly = data.isReadOnly || false;
        const isArchived = data.planStatus === 'ARCHIVED';
        return planId && scenarioId && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            analytics: analytics,
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ifnb0"))))), {
                label: "",
                color: "currentColor"
            }),
            href: planUrl || $73683d423a412055$var$VIEW_ALL_PLANS_HREF,
            menuId: (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PLAN(String(planId)),
            actionsOnHover: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1d5uQ")).PlanActionMenu), {
                planId: planId,
                scenarioId: scenarioId,
                planTitle: planTitle,
                isReadOnly: isReadOnly,
                isArchived: isArchived,
                isStarred: isStarred,
                isUsedForSidebarNav: true,
                favouriteConnectionId: favouriteConnectionId
            })
        }, planTitle);
    };
});
parcelRegister("1rvIC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d8c7f66b9423475$export$2e2bcd8739ae039);
    const $7d8c7f66b9423475$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "PlanMenuItem",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "planId"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "isReadOnly"
            },
            {
                "kind": "ScalarField",
                "name": "planStatus"
            },
            {
                "concreteType": "JiraFavouriteValue",
                "kind": "LinkedField",
                "name": "favouriteValue",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                    }
                ]
            },
            {
                "concreteType": "JiraScenario",
                "kind": "LinkedField",
                "name": "scenario",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "scenarioId"
                    }
                ]
            }
        ],
        "type": "JiraPlan"
    };
    $7d8c7f66b9423475$var$node.hash = "18d103ddd016cfaaf7283f93556817eb";
    var $7d8c7f66b9423475$export$2e2bcd8739ae039 = $7d8c7f66b9423475$var$node;
});
parcelRegister("1d5uQ", function(module, exports) {
    $parcel$export(module.exports, "PlanActionMenu", ()=>$0ccf34db8111d9c6$export$318b39ffb145c221);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $l8ruj;
    var $4M7go;
    const $0ccf34db8111d9c6$export$318b39ffb145c221 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "jira-plans-plan-action-menu"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "plans-plan-action-menu",
            packageName: (0, $bb16664676a7b4ee$export$b8b9d90f9e5bd72b),
            teamName: (0, $bb16664676a7b4ee$export$d57b6b390e78d90f)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4M7go")).PlanActionMenu), props)));
});
const $bb16664676a7b4ee$export$b8b9d90f9e5bd72b = 'jiraJetPlanActionMenu';
const $bb16664676a7b4ee$export$d57b6b390e78d90f = 'jet-chronos-team';
const $bb16664676a7b4ee$export$257be95a51c84145 = 'DUPLICATE';
const $bb16664676a7b4ee$export$a7c1ec142e70d69d = 'ARCHIVE';
const $bb16664676a7b4ee$export$2b848a0670941e75 = 'TRASH';
const $bb16664676a7b4ee$export$baea05a041537207 = 'plansNavigationMenuItem';
parcelRegister("4M7go", function(module, exports) {
    $parcel$export(module.exports, "PlanActionMenu", ()=>$e0179333fb312a5a$export$318b39ffb145c221);
    var $5uXOq = parcelRequire("5uXOq");
    var $7aY9g;
    var $3Fq5M;
    var $hUqzg;
    var $2X3CJ;
    var $dg0Fl;
    var $k2tiP;
    var $5IcUR;
    var $7piTm;
    var $kJpBP;
    var $3Z96c;
    var $eZUJu;
    var $9UCCQ;
    var $cgL5K;
    var $89DrR;
    var $4R6GH;
    var $5Zxxp;
    var $koVbs;
    var $1UEDB;
    var $g295Q;
    var $8pynQ;
    var $dUk9j;
    var $4hkqI = parcelRequire("4hkqI");
    var $8zOmE;
    var $2NMNM;
    var $fY39E;
    var $koeKL;
    var $doZTA;
    var $aIQvD;
    var $6DQw3;
    var $1Vnxw;
    var $5Gcoq;
    var $gPwud;
    var $b6Up7;
    var $49Q1d;
    var $gPhGo;
    const $e0179333fb312a5a$export$318b39ffb145c221 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aIQvD")).PlanActionMenuStoreContainer), {
            scope: props.isUsedForSidebarNav ? `sidebar-plan-${props.planId}` : 'main-plan'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e0179333fb312a5a$var$PlanActionMenuInternal, props));
    const $e0179333fb312a5a$export$484cb592f6f633ea = ({ isStarred: isStarred, isArchived: isArchived, isReadOnly: isReadOnly, onChangeFavouriteClicked: onChangeFavouriteClicked, onDuplicateClicked: onDuplicateClicked, onSettingsMenuItemClicked: onSettingsMenuItemClicked, onArchiveRestoreClicked: onArchiveRestoreClicked, onDeleteClicked: onDeleteClicked, onHelpLinkClicked: onHelpLinkClicked, onTakeTourClicked: onTakeTourClicked })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), {
            testId: "jet-plan-action-menu.ui.menu-group"
        }, (0, (0, parcelRequire("4R6GH")).fg)('jet-fix-plan-action-menu') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            isList: true
        }, !isArchived && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: onChangeFavouriteClicked,
            iconBefore: isStarred ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5IcUR"))))), {
                label: "",
                color: "var(--ds-icon-accent-yellow, #B38600)"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7piTm"))))), {
                label: "",
                color: "currentColor"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text"
        }, isStarred ? formatMessage((0, (0, parcelRequire("gPwud")).default).unstarPlan) : formatMessage((0, (0, parcelRequire("gPwud")).default).starPlan))), !isReadOnly && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: onDuplicateClicked,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3Fq5M"))))), {
                label: "",
                color: "currentColor"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text"
        }, formatMessage((0, (0, parcelRequire("gPwud")).default).duplicate))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dUk9j")).SpotlightTarget), {
            name: (0, (0, parcelRequire("g295Q")).CttSpotlights).Settings,
            delayOn: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: onSettingsMenuItemClicked,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("k2tiP"))))), {
                label: "",
                color: "currentColor"
            }),
            testId: "jet-plan-action-menu.ui.button-item"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text"
        }, formatMessage((0, (0, parcelRequire("gPwud")).default).planSettings)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            isList: true,
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: onArchiveRestoreClicked,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7aY9g"))))), {
                label: "",
                color: "currentColor"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text"
        }, isArchived ? formatMessage((0, (0, parcelRequire("gPwud")).default).restore) : formatMessage((0, (0, parcelRequire("gPwud")).default).archive))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: onDeleteClicked,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hUqzg"))))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.danger"
        }, formatMessage((0, (0, parcelRequire("gPwud")).default).trash)))))) : !isReadOnly && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            isList: true
        }, !isArchived && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: onChangeFavouriteClicked,
            iconBefore: isStarred ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5IcUR"))))), {
                label: "",
                color: "var(--ds-icon-accent-yellow, #B38600)"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7piTm"))))), {
                label: "",
                color: "currentColor"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text"
        }, isStarred ? formatMessage((0, (0, parcelRequire("gPwud")).default).unstarPlan) : formatMessage((0, (0, parcelRequire("gPwud")).default).starPlan))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: onDuplicateClicked,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3Fq5M"))))), {
                label: "",
                color: "currentColor"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text"
        }, formatMessage((0, (0, parcelRequire("gPwud")).default).duplicate))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dUk9j")).SpotlightTarget), {
            name: (0, (0, parcelRequire("g295Q")).CttSpotlights).Settings,
            delayOn: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: onSettingsMenuItemClicked,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("k2tiP"))))), {
                label: "",
                color: "currentColor"
            }),
            testId: "jet-plan-action-menu.ui.button-item"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text"
        }, formatMessage((0, (0, parcelRequire("gPwud")).default).planSettings))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            isList: true,
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: onArchiveRestoreClicked,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7aY9g"))))), {
                label: "",
                color: "currentColor"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text"
        }, isArchived ? formatMessage((0, (0, parcelRequire("gPwud")).default).restore) : formatMessage((0, (0, parcelRequire("gPwud")).default).archive))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: onDeleteClicked,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hUqzg"))))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.danger"
        }, formatMessage((0, (0, parcelRequire("gPwud")).default).trash))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            isList: true,
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            onClick: onHelpLinkClicked,
            target: "_blank",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dg0Fl"))))), {
                label: "",
                color: "currentColor"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text"
        }, formatMessage((0, (0, parcelRequire("gPwud")).default).help))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: onTakeTourClicked,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2X3CJ"))))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text"
        }, formatMessage((0, (0, parcelRequire("gPwud")).default).takeTour)))));
    };
    const $e0179333fb312a5a$var$PlanActionMenuInternal = ({ planId: planId, scenarioId: scenarioId, planTitle: planTitle, isReadOnly: isReadOnly, isArchived: isArchived, isStarred: isStarred, isUsedForSidebarNav: isUsedForSidebarNav = false, favouriteConnectionId: favouriteConnectionId })=>{
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const [{ isOpen: isOpen }, { toggleMenu: toggleMenu, closeMenu: closeMenu }] = (0, (0, parcelRequire("aIQvD")).usePlanActionMenuStore)();
        const redirectToSpaPlanPage = (0, $4hkqI.useRedirectToSpaPlanPage)();
        const [modalState, setModalState] = (0, $5uXOq.useState)(undefined);
        const resetModalState = ()=>setModalState(undefined);
        const [onboarding, setOnboarding] = (0, $5uXOq.useState)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const activationId = (0, (0, parcelRequire("fY39E")).useActivationId)();
        const { loading: loading, data: data, update: updateResource } = (0, (0, parcelRequire("1UEDB")).usePlan)();
        const { setFavourite: setFavourite } = (0, (0, parcelRequire("6DQw3")).useSetFavourite)();
        const isThePlanAndScenarioSameAsInTheUrl = match.params ? (0, (0, parcelRequire("gPhGo")).isPlanAndScenarioMatchingUrl)({
            urlPlanId: match.params.planId,
            urlScenarioId: match.params.scenarioId,
            planId: planId,
            scenarioId: scenarioId
        }) : false;
        const updateUsePlanResource = (0, $5uXOq.useCallback)((newState)=>{
            if (isThePlanAndScenarioSameAsInTheUrl && data) updateResource((oldState)=>({
                    ...oldState || data,
                    ...newState
                }));
        }, [
            updateResource,
            isThePlanAndScenarioSameAsInTheUrl,
            data
        ]);
        const setPlanArchiveStatus = (0, $5uXOq.useCallback)(()=>{
            if (data) {
                const newStatus = data.planStatus === 'ARCHIVED' ? 'ACTIVE' : 'ARCHIVED';
                updateUsePlanResource({
                    planStatus: newStatus
                });
            }
        }, [
            updateUsePlanResource,
            data
        ]);
        const toggleFavourite = (0, $5uXOq.useCallback)(()=>{
            const entityId = (0, (0, parcelRequire("89DrR")).JiraPlanAri).create({
                siteId: cloudId,
                activationId: activationId,
                planId: String(planId)
            }).toString();
            const onErrorCallback = ()=>{
                updateUsePlanResource({
                    isFavourite: isStarred
                });
            };
            setFavourite({
                entityId: entityId,
                favouriteConnectionId: favouriteConnectionId,
                planTitle: data?.title || '',
                isFavourite: !isStarred,
                onErrorCallback: onErrorCallback
            });
            updateUsePlanResource({
                isFavourite: !isStarred
            });
        }, [
            data,
            planId,
            cloudId,
            activationId,
            isStarred,
            favouriteConnectionId,
            updateUsePlanResource,
            setFavourite
        ]);
        const openInProductHelp = (0, (0, parcelRequire("5Zxxp")).useHelpPanelLink)();
        const onPlanMenuButtonClicked = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
                attributes: {
                    itemId: 'meatballDropdown',
                    componentType: 'fixedItemButton',
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf)
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        const onHelpLinkClicked = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdown',
                actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
                attributes: {
                    itemId: 'openHelpPanel',
                    componentType: 'fixedItemDropdownAction',
                    parentItemId: 'plans',
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
                }
            });
            openInProductHelp('');
            closeMenu();
        }, [
            createAnalyticsEvent,
            closeMenu,
            openInProductHelp
        ]);
        const onTakeTourClicked = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdown',
                actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
                attributes: {
                    itemId: 'takePlanTour',
                    componentType: 'fixedItemDropdownAction',
                    parentItemId: 'plans'
                }
            });
            redirectToSpaPlanPage('/timeline', {
                planId: String(planId),
                scenarioId: String(scenarioId)
            });
            setOnboarding(Math.random().toString(36).substring(2));
            closeMenu();
        }, [
            createAnalyticsEvent,
            redirectToSpaPlanPage,
            closeMenu,
            planId,
            scenarioId
        ]);
        const onDuplicateClicked = (0, $5uXOq.useCallback)(()=>{
            setModalState((0, $bb16664676a7b4ee$export$257be95a51c84145));
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdown',
                actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
                attributes: {
                    itemId: 'duplicatePlan',
                    componentType: 'fixedItemDropdownAction',
                    parentItemId: 'plans',
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
                }
            });
            closeMenu();
        }, [
            createAnalyticsEvent,
            closeMenu
        ]);
        const onDeleteClicked = (0, $5uXOq.useCallback)(()=>{
            setModalState((0, $bb16664676a7b4ee$export$2b848a0670941e75));
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdown',
                actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
                attributes: {
                    itemId: 'movePlanToTrash',
                    componentType: 'fixedItemDropdownAction',
                    parentItemId: 'plans',
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
                }
            });
            closeMenu();
        }, [
            createAnalyticsEvent,
            closeMenu
        ]);
        const onArchiveRestoreClicked = (0, $5uXOq.useCallback)(()=>{
            setModalState((0, $bb16664676a7b4ee$export$a7c1ec142e70d69d));
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdown',
                actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
                attributes: {
                    itemId: isArchived ? 'restorePlan' : 'archivePlan',
                    componentType: 'fixedItemDropdownAction',
                    parentItemId: 'plans',
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
                }
            });
            closeMenu();
        }, [
            createAnalyticsEvent,
            isArchived,
            closeMenu
        ]);
        const onChangeFavouriteClicked = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdown',
                actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
                attributes: {
                    itemId: 'favoritePlan',
                    componentType: 'fixedItemDropdownAction',
                    parentItemId: 'plans',
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
                }
            });
            toggleFavourite();
            closeMenu();
        }, [
            createAnalyticsEvent,
            toggleFavourite,
            closeMenu
        ]);
        const onSettingsMenuItemClicked = (0, $5uXOq.useCallback)(()=>{
            redirectToSpaPlanPage('/settings/scheduling', {
                planId: String(planId),
                scenarioId: String(scenarioId)
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdown',
                actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
                attributes: {
                    itemId: 'openPlanSettings',
                    componentType: 'fixedItemDropdownAction',
                    parentItemId: 'plans',
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
                }
            });
            closeMenu();
        }, [
            createAnalyticsEvent,
            planId,
            redirectToSpaPlanPage,
            scenarioId,
            closeMenu
        ]);
        const closeOnboarding = (0, $5uXOq.useCallback)((options)=>!options?.silent && setOnboarding(undefined), []);
        const MenuItems = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($e0179333fb312a5a$export$484cb592f6f633ea, {
                isStarred: isStarred,
                isArchived: isArchived,
                isReadOnly: isReadOnly,
                onChangeFavouriteClicked: onChangeFavouriteClicked,
                onDuplicateClicked: onDuplicateClicked,
                onSettingsMenuItemClicked: onSettingsMenuItemClicked,
                onArchiveRestoreClicked: onArchiveRestoreClicked,
                onDeleteClicked: onDeleteClicked,
                onHelpLinkClicked: onHelpLinkClicked,
                onTakeTourClicked: onTakeTourClicked
            }), [
            isStarred,
            onChangeFavouriteClicked,
            onDuplicateClicked,
            onSettingsMenuItemClicked,
            onArchiveRestoreClicked,
            onDeleteClicked,
            onHelpLinkClicked,
            onTakeTourClicked,
            isArchived,
            isReadOnly
        ]);
        if (isThePlanAndScenarioSameAsInTheUrl && (loading || !data)) return;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b6Up7")).MoreNavMenuButton), {
            isOpen: isOpen,
            MenuItems: MenuItems,
            onClick: ()=>{
                if (!isOpen) onPlanMenuButtonClicked();
                toggleMenu();
            },
            onCloseMenu: closeMenu,
            isUsedForSidebarNav: isUsedForSidebarNav
        }), modalState === (0, $bb16664676a7b4ee$export$257be95a51c84145) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Gcoq")).DuplicatePlanModal), {
            planId: Number(planId),
            planTitle: planTitle,
            setClosed: resetModalState
        }), modalState === (0, $bb16664676a7b4ee$export$2b848a0670941e75) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("49Q1d")).TrashPlanModal), {
            planId: Number(planId),
            setClosed: resetModalState,
            planTitle: planTitle
        }), modalState === (0, $bb16664676a7b4ee$export$a7c1ec142e70d69d) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Vnxw")).ArchivePlanModal), {
            planId: Number(planId),
            scenarioId: Number(scenarioId),
            planTitle: planTitle,
            isArchived: isArchived,
            setClosed: resetModalState,
            setPlanArchiveStatus: setPlanArchiveStatus
        }), onboarding && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pynQ")).Onboarding), {
            visible: true,
            key: onboarding,
            onClose: closeOnboarding
        }));
    };
});
parcelRegister("7aY9g", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $53981fc6c9b6b165$var$_react = $53981fc6c9b6b165$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $53981fc6c9b6b165$var$_archiveBox = $53981fc6c9b6b165$var$_interopRequireDefault((parcelRequire("41CZr")));
    var $53981fc6c9b6b165$var$_archive = $53981fc6c9b6b165$var$_interopRequireDefault((parcelRequire("jFmxZ")));
    function $53981fc6c9b6b165$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $53981fc6c9b6b165$var$ArchiveBoxIcon = (props)=>$53981fc6c9b6b165$var$_react.default.createElement($53981fc6c9b6b165$var$_archiveBox.default, Object.assign({
            LEGACY_fallbackIcon: $53981fc6c9b6b165$var$_archive.default
        }, props));
    $53981fc6c9b6b165$var$ArchiveBoxIcon.Name = 'ArchiveBoxIconMigration';
    var $53981fc6c9b6b165$var$_default = module.exports.default = $53981fc6c9b6b165$var$ArchiveBoxIcon;
});
parcelRegister("41CZr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ee5800a86362bd2$var$_react = $2ee5800a86362bd2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ee5800a86362bd2$var$_baseNew = $2ee5800a86362bd2$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ee5800a86362bd2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ee5800a86362bd2$var$ArchiveBoxIcon = (props)=>$2ee5800a86362bd2$var$_react.default.createElement($2ee5800a86362bd2$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M2.75 5.25h-1v-3.5h12.5v3.5h-1m-10.5 0V13c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V5.25m-10.5 0h10.5m-7.75 3h5"/>`
        }, props));
    $2ee5800a86362bd2$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
    var $2ee5800a86362bd2$var$_default = module.exports.default = $2ee5800a86362bd2$var$ArchiveBoxIcon;
});
parcelRegister("jFmxZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e513560ae499789a$var$_react = $e513560ae499789a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $e513560ae499789a$var$_archiveBox = $e513560ae499789a$var$_interopRequireDefault((parcelRequire("41CZr")));
    function $e513560ae499789a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e513560ae499789a$var$ArchiveIcon = (props)=>$e513560ae499789a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 3H4.85A2 2 0 0 0 3 5v4h1v10.45A1.67 1.67 0 0 0 5.77 21h12.46A1.67 1.67 0 0 0 20 19.45V9h1V5a2 2 0 0 0-2-2m-1 16H6V9h12zm1-12H5V5h14zm-4 7H9v-2h6z" clip-rule="evenodd"/></svg>`
        }, props, {
            newIcon: $e513560ae499789a$var$_archiveBox.default
        }));
    $e513560ae499789a$var$ArchiveIcon.displayName = 'ArchiveIcon';
    var $e513560ae499789a$var$_default = module.exports.default = $e513560ae499789a$var$ArchiveIcon;
});
parcelRegister("3Fq5M", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));
    var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
    function $2ab970d264bef26f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ab970d264bef26f$var$CopyIcon = (props)=>$2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
            LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
        }, props));
    $2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
    var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;
});
parcelRegister("eE13R", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
    function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $aa959fe1f5a86e24$var$CopyIcon = (props)=>$aa959fe1f5a86e24$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
        }, props, {
            newIcon: $aa959fe1f5a86e24$var$_copy.default
        }));
    $aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
    var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;
});
parcelRegister("hUqzg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d09c4671709f5c19$var$_react = $d09c4671709f5c19$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d09c4671709f5c19$var$_delete = $d09c4671709f5c19$var$_interopRequireDefault((parcelRequire("4IrpZ")));
    var $d09c4671709f5c19$var$_trash = $d09c4671709f5c19$var$_interopRequireDefault((parcelRequire("3fOYK")));
    function $d09c4671709f5c19$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d09c4671709f5c19$var$DeleteIcon = (props)=>$d09c4671709f5c19$var$_react.default.createElement($d09c4671709f5c19$var$_delete.default, Object.assign({
            LEGACY_fallbackIcon: $d09c4671709f5c19$var$_trash.default
        }, props));
    $d09c4671709f5c19$var$DeleteIcon.Name = 'DeleteIconMigration';
    var $d09c4671709f5c19$var$_default = module.exports.default = $d09c4671709f5c19$var$DeleteIcon;
});
parcelRegister("2X3CJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2263e70ee324ad79$var$_react = $2263e70ee324ad79$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2263e70ee324ad79$var$_flag = $2263e70ee324ad79$var$_interopRequireDefault((parcelRequire("arE9H")));
    var $2263e70ee324ad79$var$_flags = $2263e70ee324ad79$var$_interopRequireDefault((parcelRequire("jQ66g")));
    function $2263e70ee324ad79$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2263e70ee324ad79$var$FlagIcon = (props)=>$2263e70ee324ad79$var$_react.default.createElement($2263e70ee324ad79$var$_flag.default, Object.assign({
            LEGACY_fallbackIcon: $2263e70ee324ad79$var$_flags.default
        }, props));
    $2263e70ee324ad79$var$FlagIcon.Name = 'FlagIconMigration';
    var $2263e70ee324ad79$var$_default = module.exports.default = $2263e70ee324ad79$var$FlagIcon;
});
parcelRegister("arE9H", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79ab9304c84464c1$var$_react = $79ab9304c84464c1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $79ab9304c84464c1$var$_baseNew = $79ab9304c84464c1$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $79ab9304c84464c1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79ab9304c84464c1$var$FlagIcon = (props)=>$79ab9304c84464c1$var$_react.default.createElement($79ab9304c84464c1$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 15V9.75m0 0v-8H14l-3 4 3 4z"/>`
        }, props));
    $79ab9304c84464c1$var$FlagIcon.displayName = 'FlagIcon';
    var $79ab9304c84464c1$var$_default = module.exports.default = $79ab9304c84464c1$var$FlagIcon;
});
parcelRegister("jQ66g", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e7179b016029ea03$var$_react = $e7179b016029ea03$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $e7179b016029ea03$var$_flag = $e7179b016029ea03$var$_interopRequireDefault((parcelRequire("arE9H")));
    function $e7179b016029ea03$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e7179b016029ea03$var$EmojiFlagsIcon = (props)=>$e7179b016029ea03$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.7 5.7 0 0 0 2.547-.567 1 1 0 0 0 .563-.9V5.466a.998.998 0 0 0-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 0 0 6 5.466zm3.111-1.48c1.094 0 2.148.256 3.129.495 1.381.335 2.6.63 3.768.289V6.836c-1.488.27-2.93-.08-4.24-.398-1.379-.335-2.598-.632-3.768-.29v4.704a6 6 0 0 1 1.111-.097"/></svg>`
        }, props, {
            newIcon: $e7179b016029ea03$var$_flag.default
        }));
    $e7179b016029ea03$var$EmojiFlagsIcon.displayName = 'EmojiFlagsIcon';
    var $e7179b016029ea03$var$_default = module.exports.default = $e7179b016029ea03$var$EmojiFlagsIcon;
});
parcelRegister("5Zxxp", function(module, exports) {
    $parcel$export(module.exports, "useHelpPanelLink", ()=>$b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
    $parcel$export(module.exports, "default", ()=>$b0d1b3c2fea05784$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $bHDKL;
    var $e4yMr;
    var $4R6GH;
    var $6BNJk;
    var $kspz4;
    var $hsmeR;
    const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
        const { openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const [, { setNavigationData: setNavigationData }] = (0, (0, parcelRequire("kspz4")).useHelpPanelActions)();
        const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
            openRightSidebar((0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID), (0, (0, parcelRequire("6BNJk")).HELP_PANEL_WIDTH), false, true);
            if (resetHistory) setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                },
                history: []
            });
            else setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                }
            });
        };
        return handleOnClick;
    };
    const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, ...props })=>{
        const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
        const handleOnClick = (event, analyticsEvent)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) event.preventDefault();
            onClick?.(event, analyticsEvent);
            onOpenInProductHelpArticle(articleId, (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]);
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
            ...props,
            onClick: handleOnClick,
            href: href ?? 'https://support.atlassian.com',
            appearance: "default",
            testId: props.testId
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            onClick: handleOnClick,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
            ])
        }, children);
    };
    var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
    const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
});
parcelRegister("1UEDB", function(module, exports) {
    $parcel$export(module.exports, "usePlan", ()=>$fe5ea6cf6b4cbe02$export$6734677f23034ac5);
    var $c1N9v;
    var $2YP9W;
    const $fe5ea6cf6b4cbe02$export$6734677f23034ac5 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("c1N9v")).staticPlanSidebarNavigationResource));
});
parcelRegister("g295Q", function(module, exports) {
    $parcel$export(module.exports, "CttSpotlights", ()=>$f81f0ad0752c64b1$export$d87db548b153c65d);
    const $f81f0ad0752c64b1$export$d87db548b153c65d = {
        Inactive: 'INACTIVE',
        CreateIssue: 'portfolio-3/ctt-onboarding/create-issue',
        TitleInput: 'portfolio-3/ctt-onboarding/title-input',
        Settings: 'portfolio-3/ctt-onboarding/settings',
        IssueSources: 'portfolio-3/ctt-onboarding/issue-source',
        BackToPlan: 'portfolio-3/ctt-onboarding/back-to-plan',
        EpicSection: 'portfolio-3/ctt-onboarding/epic-section',
        Scope: 'portfolio-3/ctt-onboarding/scope',
        ReviewChanges: 'portfolio-3/ctt-onboarding/review-changes'
    };
});
parcelRegister("8pynQ", function(module, exports) {
    $parcel$export(module.exports, "Onboarding", ()=>$ca8d1bbbb0038aee$export$70238cd3868b67c9);
    var $5uXOq = parcelRequire("5uXOq");
    var $84THj;
    var $evqT3;
    var $i8Qvm;
    var $1QiBP;
    var $5Zxxp;
    var $ePUEm;
    var $ousew;
    var $koVbs;
    var $3HwlS;
    var $iqLcb;
    var $1gQ7U;
    var $5oFIy;
    var $aPRoZ;
    var $aGkaA;
    var $9yfXJ;
    var $eld9u;
    var $taGZB;
    var $6IYrl;
    var $eNZ9d;
    var $kRDXu;
    var $bHAma;
    var $adqnA;
    const $ca8d1bbbb0038aee$var$IconButtonStyles = {
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    };
    const $ca8d1bbbb0038aee$export$70238cd3868b67c9 = (props)=>{
        const useCurrentSpotlight = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, (0, parcelRequire("aPRoZ")).useCurrentSpotlight) : (0, (0, parcelRequire("aPRoZ")).useCurrentSpotlightOld);
        const [{ visible: visible }, { init: init, close: close }] = (0, (0, parcelRequire("adqnA")).useController)(props);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [step, { next: next, start: start, finish: finish, skip: skip }] = (0, (0, parcelRequire("adqnA")).useStep)();
        const [{ spotlight: spotlight, currentStepCount: currentStepCount, totalStepCount: totalStepCount }, { reset: resetSpotlight, start: startSpotlight, next: nextSpotlight }] = useCurrentSpotlight();
        const { expandLeftSidebar: expandLeftSidebarChangingEveryRender } = (0, (0, parcelRequire("iqLcb")).usePageLayoutResize)();
        const [expandLeftSidebar] = (0, $5uXOq.useState)(()=>expandLeftSidebarChangingEveryRender);
        const openInProductHelp = (0, (0, parcelRequire("5Zxxp")).useHelpPanelLink)();
        (0, $5uXOq.useEffect)(()=>{
            init();
        }, [
            init
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (visible) start();
        }, [
            start,
            visible
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (step === 'spotlight') startSpotlight();
        }, [
            step,
            startSpotlight
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (spotlight === undefined) next();
        }, [
            next,
            spotlight
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (step === 'spotlight' && spotlight === (0, (0, parcelRequire("aPRoZ")).Spotlights).Views) expandLeftSidebar();
            if (step === 'flag') {
                resetSpotlight();
                close({
                    silent: true
                });
            }
            if (step === 'finished') {
                if ((0, (0, parcelRequire("adqnA")).isCrossTeamPlanningTemplateExperimentEnabled)()) close({
                    silent: false
                });
                else close();
            }
        }, [
            step,
            spotlight,
            resetSpotlight,
            expandLeftSidebar,
            close
        ]);
        const spotlightActions = ({ learnMoreURL: learnMoreURL })=>{
            const nextAction = {
                onClick: nextSpotlight,
                text: formatMessage((0, (0, parcelRequire("9yfXJ")).messages).spotlightNext)
            };
            return learnMoreURL ? [
                nextAction,
                {
                    text: formatMessage((0, (0, parcelRequire("9yfXJ")).messages).spotlightLearnMore),
                    appearance: 'subtle-link',
                    href: learnMoreURL,
                    target: '_blank'
                }
            ] : [
                nextAction
            ];
        };
        const spotlightHeadingAfterElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gQ7U")).IconButton), {
            onClick: skip,
            ariaLabel: formatMessage((0, (0, parcelRequire("9yfXJ")).messages).spotlightCloseLabel),
            style: $ca8d1bbbb0038aee$var$IconButtonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("84THj"))))), {
            LEGACY_size: "small",
            label: "",
            color: "currentColor"
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, step === 'modal' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("evqT3")).default), {
            heading: formatMessage((0, (0, parcelRequire("9yfXJ")).messages).modalHeadingPlansSpork),
            header: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ePUEm")).default), {
                    alt: ""
                }),
            actions: [
                {
                    onClick: finish,
                    appearance: 'subtle',
                    text: formatMessage((0, (0, parcelRequire("9yfXJ")).messages).modalSkip)
                },
                {
                    onClick: next,
                    appearance: 'primary',
                    text: formatMessage((0, (0, parcelRequire("9yfXJ")).messages).modalTakeTour)
                }
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireUiAnalytics), {
            actionSubject: "modal",
            action: "viewed",
            actionSubjectId: "advancedRoadmapsOnboarding"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("9yfXJ")).messages).modalContentParagraphPlansSpork))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1QiBP")).default), null, step === 'spotlight' && spotlight === (0, (0, parcelRequire("aPRoZ")).Spotlights).HeartOfPlan && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("taGZB")).HeartOfPlanSpotlight), {
            target: (0, (0, parcelRequire("aPRoZ")).Spotlights).HeartOfPlan,
            actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
            actions: spotlightActions,
            headingAfterElement: spotlightHeadingAfterElement
        }), step === 'spotlight' && spotlight === (0, (0, parcelRequire("aPRoZ")).Spotlights).ListMode && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6IYrl")).ListModeSpotlight), {
            target: (0, (0, parcelRequire("aPRoZ")).Spotlights).ListMode,
            actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
            actions: spotlightActions,
            headingAfterElement: spotlightHeadingAfterElement
        }), step === 'spotlight' && spotlight === (0, (0, parcelRequire("aPRoZ")).Spotlights).Views && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bHAma")).ViewsSpotlight), {
            target: (0, (0, parcelRequire("aPRoZ")).Spotlights).Views,
            actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
            actions: spotlightActions,
            headingAfterElement: spotlightHeadingAfterElement
        }), step === 'spotlight' && spotlight === (0, (0, parcelRequire("aPRoZ")).Spotlights).ShowAndTell && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kRDXu")).ShowAndTellSpotlight), {
            target: (0, (0, parcelRequire("aPRoZ")).Spotlights).ShowAndTell,
            actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
            actions: spotlightActions,
            headingAfterElement: spotlightHeadingAfterElement
        }), step === 'spotlight' && spotlight === (0, (0, parcelRequire("aPRoZ")).Spotlights).SaveYourChanges && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eNZ9d")).SaveYourChangesSpotlight), {
            target: (0, (0, parcelRequire("aPRoZ")).Spotlights).SaveYourChanges,
            actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
            actions: spotlightActions,
            headingAfterElement: spotlightHeadingAfterElement
        }), step === 'spotlight' && spotlight === (0, (0, parcelRequire("aPRoZ")).Spotlights).FindYourLook && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eld9u")).FindYourLookSpotlight), {
            target: (0, (0, parcelRequire("aPRoZ")).Spotlights).FindYourLook,
            actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
            actions: spotlightActions,
            headingAfterElement: spotlightHeadingAfterElement
        })), step === 'flag' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aGkaA")).FinishFlag), {
            onDismiss: next,
            openInProductHelp: openInProductHelp
        }));
    };
});
parcelRegister("evqT3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44afc303b109e730$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $9yOBd;
    var $dkK4L;
    var $1R1Ge;
    var $7QSqG;
    var $kdO7l;
    var $jSZUh;
    var $lPfex;
    class $44afc303b109e730$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { actions: actions, children: children, heading: heading, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight, footer: footer, header: header, image: image, ...rest } = this.props;
            const Header = this.headerComponent(this.props);
            const Footer = this.footerComponent(this.props);
            const CustomHeader = ()=>{
                const { titleId: titleId } = (0, (0, parcelRequire("kdO7l")).useModal)();
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalHeading), {
                    id: titleId
                }, heading);
            };
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1R1Ge")).default), {
                autoFocus: true,
                shouldCloseOnEscapePress: false,
                shouldCloseOnOverlayClick: false,
                shouldScrollInViewport: true,
                experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight,
                footer: footer,
                header: header,
                heading: heading,
                image: image,
                ...rest
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(Header, null), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7QSqG")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalBody), null, heading && (0, (0, parcelRequire("f8Sb3")).jsx)(CustomHeader, null), children)), (0, (0, parcelRequire("f8Sb3")).jsx)(Footer, null));
        }
        constructor(...args){
            super(...args), this.headerComponent = (props)=>{
                const { header: HeaderElement, image: src } = props;
                const ImageElement = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalImage), {
                        src: src,
                        alt: ""
                    });
                return HeaderElement || ImageElement;
            }, this.footerComponent = (props)=>{
                const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
                const ActionsElement = ()=>actionList ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dkK4L")).default).Provider, {
                        value: (0, (0, parcelRequire("lPfex")).modalButtonTheme)
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalActionContainer), {
                        shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight
                    }, actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                        const variant = idx ? 'subtle-link' : 'primary';
                        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalActionItem), {
                            key: key || (typeof text === 'string' ? text : `${idx}`)
                        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9yOBd")).default), {
                            appearance: variant,
                            autoFocus: !idx,
                            ...rest
                        }, text));
                    }))) : null;
                return FooterElement || ActionsElement;
            };
        }
    }
});
parcelRegister("jSZUh", function(module, exports) {
    $parcel$export(module.exports, "ModalBody", ()=>$1c1428422690040b$export$cb540d8b0ef7906c);
    $parcel$export(module.exports, "ModalHeading", ()=>$1c1428422690040b$export$9af27c346834c182);
    $parcel$export(module.exports, "ModalImage", ()=>$1c1428422690040b$export$1355685fd5f8d257);
    $parcel$export(module.exports, "ModalActionContainer", ()=>$1c1428422690040b$export$633dda6b40ac1ac3);
    $parcel$export(module.exports, "ModalActionItem", ()=>$1c1428422690040b$export$c245e9f76e3299b1);
    var $f8Sb3;
    var $3RZIb;
    function $1c1428422690040b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1c1428422690040b$var$modalBodyStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-500, 40px)"} ${"var(--ds-space-200, 16px)"}`,
        textAlign: 'center'
    });
    const $1c1428422690040b$var$modalHeadingStyles = (0, (0, parcelRequire("f8Sb3")).css)([
        (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("3RZIb")).h600)({
            theme: {
                mode: 'light'
            }
        })),
        {
            marginBottom: "var(--ds-space-100, 8px)",
            color: 'inherit'
        }
    ]);
    const $1c1428422690040b$var$modalImageStyles = {
        name: "1e6i37z",
        styles: "width:100%;height:auto;border-start-end-radius:var(--ds-border-radius, 3px);border-start-start-radius:var(--ds-border-radius, 3px);@media (min-width: 320px) and (max-width: 480px){border-radius:0;}"
    };
    const $1c1428422690040b$var$modalActionContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-500, 40px)"} 36px`,
        justifyContent: 'center',
        flexDirection: 'row',
        flexFlow: 'wrap'
    });
    const $1c1428422690040b$var$modalActionContainerReversedStyles = {
        name: "2b8jyz",
        styles: "flex-direction:row-reverse"
    };
    const $1c1428422690040b$var$modalActionItemStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $1c1428422690040b$export$cb540d8b0ef7906c = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $1c1428422690040b$var$modalBodyStyles
        }, children);
    const $1c1428422690040b$export$9af27c346834c182 = ({ children: children, id: id })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: $1c1428422690040b$var$modalHeadingStyles,
            id: id
        }, children);
    };
    const $1c1428422690040b$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>(0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            css: $1c1428422690040b$var$modalImageStyles,
            alt: alt,
            src: src
        });
    const $1c1428422690040b$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $1c1428422690040b$var$modalActionContainerStyles,
                shouldReverseButtonOrder && $1c1428422690040b$var$modalActionContainerReversedStyles
            ]
        }, children);
    const $1c1428422690040b$export$c245e9f76e3299b1 = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $1c1428422690040b$var$modalActionItemStyles
        }, children);
});
parcelRegister("ePUEm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$571a362f39767dc7$export$2e2bcd8739ae039);
    var $dCLgq;
    var $cfHe5 = parcelRequire("cfHe5");
    const $571a362f39767dc7$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($cfHe5)),
        srcDark: ($parcel$interopDefault($cfHe5))
    });
    var $571a362f39767dc7$export$2e2bcd8739ae039 = $571a362f39767dc7$var$Illustration;
    const $571a362f39767dc7$export$a179c88182cb9d56 = [
        0,
        0,
        600,
        371
    ];
});
parcelRegister("cfHe5", function(module, exports) {
    module.exports = new URL("plans-review-changes.d344422b.gif", import.meta.url).toString();
});
parcelRegister("1gQ7U", function(module, exports) {
    $parcel$export(module.exports, "IconButton", ()=>$fbf6cc8e79de0577$export$c25acd513dcc8062);
    var $5uXOq = parcelRequire("5uXOq");
    var $aA2jH = parcelRequire("aA2jH");
    const $fbf6cc8e79de0577$export$f173127635a15d2 = {
        small: 16,
        medium: 24,
        large: 32,
        xlarge: 48
    };
    const $fbf6cc8e79de0577$export$c25acd513dcc8062 = ({ children: children, onClick: onClick, ariaLabel: ariaLabel, style: style, tabIndex: tabIndex })=>(0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            onClick: onClick,
            className: $aA2jH.button,
            "aria-label": ariaLabel,
            style: style,
            tabIndex: tabIndex
        }, children);
    $fbf6cc8e79de0577$export$c25acd513dcc8062.displayName = 'IconButton';
});
parcelRegister("aA2jH", function(module, exports) {
    $parcel$export(module.exports, "button", ()=>$7b3f104004304d6c$export$2ba01fb71ed41cb6, (v)=>$7b3f104004304d6c$export$2ba01fb71ed41cb6 = v);
    var $7b3f104004304d6c$export$2ba01fb71ed41cb6;
    $7b3f104004304d6c$export$2ba01fb71ed41cb6 = `WWOkVG_button`;
});
parcelRegister("aPRoZ", function(module, exports) {
    $parcel$export(module.exports, "Spotlights", ()=>$ffac7af5fe45e020$export$c7b90ff96148d0e3);
    $parcel$export(module.exports, "useCurrentSpotlightOld", ()=>$ffac7af5fe45e020$export$28754d85fe333691);
    $parcel$export(module.exports, "useCurrentSpotlight", ()=>$ffac7af5fe45e020$export$26b0bb53036d8513);
    $parcel$export(module.exports, "OnboardingHeaderModeUpdater", ()=>$ffac7af5fe45e020$export$e9f9953833722cbb);
    var $5uXOq = parcelRequire("5uXOq");
    var $3HwlS;
    var $3sQ5x;
    var $iXqE5;
    const $ffac7af5fe45e020$export$c7b90ff96148d0e3 = {
        Inactive: 'INACTIVE',
        Views: 'portfolio-3/onboarding/views',
        HeartOfPlan: 'portfolio-3/onboarding/heart-of-plan',
        ShowAndTell: 'portfolio-3/onboarding/show-and-tell',
        ListMode: 'portfolio-3/onboarding/list-mode',
        FindYourLook: 'portfolio-3/onboarding/find-your-look',
        SaveYourChanges: 'portfolio-3/onboarding/save-your-changes'
    };
    const $ffac7af5fe45e020$var$SpotlightStepsOld = [
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.Inactive,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.Views,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.HeartOfPlan,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.ShowAndTell,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.ListMode,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.FindYourLook,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.SaveYourChanges
    ];
    const $ffac7af5fe45e020$var$SpotlightSteps = [
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.Inactive,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.Views,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.ShowAndTell,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.ListMode,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.FindYourLook,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.SaveYourChanges
    ];
    const $ffac7af5fe45e020$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            current: 0
        },
        actions: {
            reset: ()=>({ setState: setState })=>setState({
                        current: 0
                    }),
            start: ()=>({ setState: setState })=>{
                    setState({
                        current: 1
                    });
                },
            next: ()=>({ getState: getState, setState: setState })=>{
                    setState({
                        current: getState().current + 1
                    });
                }
        },
        name: 'portfolio-3/onboarding/spotlights'
    });
    const $ffac7af5fe45e020$export$28754d85fe333691 = ()=>(0, (0, parcelRequire("3sQ5x")).createHook)($ffac7af5fe45e020$var$store, {
            selector: ({ current: current })=>{
                const totalStepCount = $ffac7af5fe45e020$var$SpotlightStepsOld.length - 1;
                return {
                    spotlight: $ffac7af5fe45e020$var$SpotlightStepsOld[current],
                    currentStepCount: current,
                    totalStepCount: totalStepCount
                };
            }
        })();
    const $ffac7af5fe45e020$export$26b0bb53036d8513 = ()=>(0, (0, parcelRequire("3sQ5x")).createHook)($ffac7af5fe45e020$var$store, {
            selector: ({ current: current })=>{
                const totalStepCount = $ffac7af5fe45e020$var$SpotlightSteps.length - 1;
                return {
                    spotlight: $ffac7af5fe45e020$var$SpotlightSteps[current],
                    currentStepCount: current,
                    totalStepCount: totalStepCount
                };
            }
        })();
    const $ffac7af5fe45e020$export$d52beefead77af4c = (0, (0, parcelRequire("3sQ5x")).createHook)($ffac7af5fe45e020$var$store, {
        selector: null
    });
    const $ffac7af5fe45e020$export$e9f9953833722cbb = ({ headerMode: headerMode, setHeaderMode: setHeaderMode })=>{
        const [{ spotlight: spotlight }] = $ffac7af5fe45e020$export$28754d85fe333691();
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) {
                if (headerMode !== 'visible' && spotlight === $ffac7af5fe45e020$export$c7b90ff96148d0e3.HeartOfPlan) setHeaderMode('visible');
            }
        }, [
            spotlight,
            headerMode,
            setHeaderMode
        ]);
        return null;
    };
});
parcelRegister("aGkaA", function(module, exports) {
    $parcel$export(module.exports, "FinishFlag", ()=>$3f7aa109e30819d7$export$35e948d10c687c6d);
    var $5uXOq = parcelRequire("5uXOq");
    var $btivG;
    var $ousew;
    var $5oFIy;
    var $cRxyr;
    var $g9t2t;
    const $3f7aa109e30819d7$export$35e948d10c687c6d = ({ onDismiss: onDismiss, openInProductHelp: openInProductHelp })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireUiAnalytics), {
            actionSubject: "flag",
            action: "viewed",
            actionSubjectId: "finishedAdvancedRoadmapsOnboarding"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cRxyr")).Flag), {
            isAutoDismissed: true,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("btivG"))))), {
                label: "",
                primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G400})`
            }),
            onDismissed: onDismiss,
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("g9t2t")).messages).flagTitle),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("g9t2t")).messages).plansFlagContent),
            actions: [
                {
                    content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("g9t2t")).messages).flagClose),
                    onClick: onDismiss
                },
                {
                    content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("g9t2t")).messages).flagViewDocumentation),
                    onClick: ()=>openInProductHelp('')
                }
            ]
        }));
});
parcelRegister("cRxyr", function(module, exports) {
    $parcel$export(module.exports, "Flag", ()=>$b49d89a15d12a3ed$export$48ea269755562084);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7R4eB;
    var $d4xRU;
    var $pa9q9;
    const $b49d89a15d12a3ed$export$48ea269755562084 = ({ id: id, isAutoDismissed: isAutoDismissed, onDismissed: onDismissed, ...props })=>{
        const [uid] = (0, $5uXOq.useState)(()=>id ?? Math.random().toString(36).substring(2));
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const onDismissedWrapper = (0, $5uXOq.useCallback)((id, analyticsEvent)=>{
            dismissFlag(String(id));
            onDismissed && onDismissed(id, analyticsEvent);
        }, [
            dismissFlag,
            onDismissed
        ]);
        const [flagEl] = (0, $5uXOq.useState)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($b49d89a15d12a3ed$var$FlagWrapper, {
                key: uid
            }, isAutoDismissed ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7R4eB")).default), {
                id: uid,
                onDismissed: onDismissedWrapper,
                ...props
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
                id: uid,
                onDismissed: onDismissedWrapper,
                ...props
            })));
        (0, $5uXOq.useEffect)(()=>{
            setTimeout(()=>showFlag({
                    id: uid,
                    render: ()=>flagEl
                }), 0);
            return ()=>dismissFlag(uid);
        }, [
            flagEl,
            uid,
            showFlag,
            dismissFlag
        ]);
        return null;
    };
    const $b49d89a15d12a3ed$var$FlagWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_88dhagmp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7R4eB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$435170f9f2349b2e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iNWLk;
    var $3KRpp;
    const $435170f9f2349b2e$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).CommonFlag), {
            isAutoDismiss: true,
            ...props,
            flagType: "info"
        }));
    var $435170f9f2349b2e$export$2e2bcd8739ae039 = $435170f9f2349b2e$var$AkAutoDismissFlag;
});
parcelRegister("iNWLk", function(module, exports) {
    $parcel$export(module.exports, "FlagsBoundary", ()=>$6377b132f88aa82c$export$8b4a0fffcddd96f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $b71gk;
    var $lfTZh;
    const $6377b132f88aa82c$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b71gk")).default), {
            id: "flags",
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "flags-boundary",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, children));
});
parcelRegister("3KRpp", function(module, exports) {
    $parcel$export(module.exports, "CommonFlag", ()=>$ef767762d5402ccf$export$13d73238a031436b);
    $parcel$export(module.exports, "ErrorFlag", ()=>$ef767762d5402ccf$export$518ba8e0e60f145f);
    $parcel$export(module.exports, "ErrorAutoDismissFlag", ()=>$ef767762d5402ccf$export$3f75672bb90a4431);
    $parcel$export(module.exports, "InfoFlag", ()=>$ef767762d5402ccf$export$6a55b52e74c1e48e);
    $parcel$export(module.exports, "SuccessAutoDismissFlag", ()=>$ef767762d5402ccf$export$74a3c0748aa31355);
    $parcel$export(module.exports, "SuccessFlag", ()=>$ef767762d5402ccf$export$93bd4963a1d00fd5);
    $parcel$export(module.exports, "WarningFlag", ()=>$ef767762d5402ccf$export$23695d8281998f27);
    $parcel$export(module.exports, "FlagGroup", ()=>$ef767762d5402ccf$export$a2c3479950310d7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $iNWLk;
    var $kxZPA;
    const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);
    const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
    const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
    const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            ...props
        }));
    const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "info",
            ...props
        }));
    const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            ...props
        }));
    const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "warning",
            ...props
        }));
    const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));
});
parcelRegister("lKKug", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4yB9l")
    ]).then(()=>parcelRequire('8ZHDV'));
});
parcelRegister("fhw5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));
});
parcelRegister("d4xRU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61381db0e069bc03$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iNWLk;
    var $3KRpp;
    const $61381db0e069bc03$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).CommonFlag), {
            flagType: "info",
            ...props
        }));
    var $61381db0e069bc03$export$2e2bcd8739ae039 = $61381db0e069bc03$var$AkFlag;
});
parcelRegister("g9t2t", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$40985028cc21dd23$export$defe85febe8b728c);
    var $7VHMR;
    const $40985028cc21dd23$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        flagTitle: {
            "id": "portfolio-3-onboarding.onboarding.flag-finish.flag-title",
            "defaultMessage": "Happy planning!"
        },
        plansFlagContent: {
            "id": "portfolio-3-onboarding.onboarding.flag-finish.plans-flag-content",
            "defaultMessage": "For more information on how to get started with Plans, check out our latest documentation."
        },
        flagClose: {
            "id": "portfolio-3-onboarding.onboarding.flag-finish.flag-close",
            "defaultMessage": "Close"
        },
        flagViewDocumentation: {
            "id": "portfolio-3-onboarding.onboarding.flag-finish.flag-view-documentation",
            "defaultMessage": "View documentation"
        }
    });
});
parcelRegister("9yfXJ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$d44f9a86b0041aa3$export$defe85febe8b728c);
    var $7VHMR;
    const $d44f9a86b0041aa3$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        spotlightCloseLabel: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-close-label",
            "defaultMessage": "Close"
        },
        modalHeadingPlansSpork: {
            "id": "portfolio-3-onboarding.onboarding.modal-heading-plans-spork",
            "defaultMessage": "Welcome to Plans"
        },
        modalContentParagraphPlansSpork: {
            "id": "portfolio-3-onboarding.onboarding.modal-content-paragraph-plans-spork",
            "defaultMessage": "Track dependencies from multiple teams, monitor team's capacity, and view the status of work in real time so you can see everything happening across Jira."
        },
        modalTakeTour: {
            "id": "portfolio-3-onboarding.onboarding.modal-take-tour",
            "defaultMessage": "Take tour"
        },
        modalSkip: {
            "id": "portfolio-3-onboarding.onboarding.modal-skip",
            "defaultMessage": "Skip"
        },
        spotlightNext: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-next",
            "defaultMessage": "Next"
        },
        spotlightLearnMore: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-learn-more",
            "defaultMessage": "Learn more"
        }
    });
});
parcelRegister("eld9u", function(module, exports) {
    $parcel$export(module.exports, "FindYourLookSpotlight", ()=>$8ccbb0bbae14bf06$export$854c6a85659497df);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $ousew;
    var $koVbs;
    var $ehdJY;
    var $ltOVK;
    const $8ccbb0bbae14bf06$export$854c6a85659497df = ({ target: target, actionsBeforeElement: actionsBeforeElement, headingAfterElement: headingAfterElement, actions: actions })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            target: target,
            targetRadius: 0,
            targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
            heading: formatMessage((0, (0, parcelRequire("ltOVK")).messages).title),
            actionsBeforeElement: actionsBeforeElement,
            actions: actions({
                learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/change-how-advanced-roadmaps-displays-your-timeline-data/'
            }),
            headingAfterElement: headingAfterElement,
            messageId: "portfolio-3-onboarding.ui.onboarding.spotlight-find-your-look.jira-spotlight",
            messageType: "transactional"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("ltOVK")).messages).contentIssueTermRefresh : (0, (0, parcelRequire("ltOVK")).messages).content));
    };
});
parcelRegister("ltOVK", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$d200c51d356269e3$export$defe85febe8b728c);
    var $7VHMR;
    const $d200c51d356269e3$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-find-your-look.title",
            "defaultMessage": "Find your look"
        },
        content: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-find-your-look.content",
            "defaultMessage": "Add a personal touch to your plan by changing how your issues are grouped, sorted or displayed."
        },
        contentIssueTermRefresh: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-find-your-look.content-issue-term-refresh",
            "defaultMessage": "Add a personal touch to your plan by changing how your issues are grouped, sorted or displayed."
        }
    });
});
parcelRegister("taGZB", function(module, exports) {
    $parcel$export(module.exports, "HeartOfPlanSpotlight", ()=>$d8652916e0161872$export$859e382090c26be5);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $3HwlS;
    var $ehdJY;
    var $2pHvq;
    const $d8652916e0161872$export$859e382090c26be5 = ({ target: target, actionsBeforeElement: actionsBeforeElement, actions: actions, headingAfterElement: headingAfterElement })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            target: target,
            targetBgColor: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? undefined : "var(--ds-surface, white)",
            dialogPlacement: "top left",
            heading: formatMessage((0, (0, parcelRequire("2pHvq")).messages).title),
            actionsBeforeElement: actionsBeforeElement,
            actions: actions({
                learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/how-do-i-read-my-advanced-roadmaps-plan/#1.-Issue-column'
            }),
            headingAfterElement: headingAfterElement,
            messageId: "portfolio-3-onboarding.ui.onboarding.spotlight-heart-of-plan.jira-spotlight",
            messageType: "transactional"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2pHvq")).messages).content));
    };
});
parcelRegister("2pHvq", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$4ab20231f3500e31$export$defe85febe8b728c);
    var $7VHMR;
    const $4ab20231f3500e31$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-heart-of-plan.title",
            "defaultMessage": "The heart of your plan"
        },
        content: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-heart-of-plan.content",
            "defaultMessage": "View, create, and schedule tasks, then customize which data fields you want to see in context."
        }
    });
});
parcelRegister("6IYrl", function(module, exports) {
    $parcel$export(module.exports, "ListModeSpotlight", ()=>$9138092740ea1ef6$export$5c026a266f250837);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cgL5K;
    var $koVbs;
    var $ehdJY;
    var $fWyY6;
    const $9138092740ea1ef6$export$5c026a266f250837 = ({ target: target, actionsBeforeElement: actionsBeforeElement, headingAfterElement: headingAfterElement, actions: actions })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            target: target,
            targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
            dialogPlacement: "bottom right",
            actionsBeforeElement: actionsBeforeElement,
            actions: actions({
                learnMoreURL: ''
            }),
            headingAfterElement: headingAfterElement,
            heading: formatMessage((0, (0, parcelRequire("fWyY6")).messages).heading),
            messageId: "portfolio-3-onboarding.ui.onboarding.spotlight-list-mode.jira-spotlight",
            messageType: "transactional"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("fWyY6")).messages).description, {
            b: (...chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    weight: "bold"
                }, chunks)
        }))));
    };
});
parcelRegister("fWyY6", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$e66d5fb1b51efc17$export$defe85febe8b728c);
    var $7VHMR;
    const $e66d5fb1b51efc17$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-list-mode.heading",
            "defaultMessage": "More room for planning"
        },
        description: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-list-mode.description",
            "defaultMessage": "Select <b>Timeline</b> to view the timeline bars and capacity information, or choose <b>List</b> to hide them and add as many fields as you want."
        }
    });
});
parcelRegister("eNZ9d", function(module, exports) {
    $parcel$export(module.exports, "SaveYourChangesSpotlight", ()=>$5dc2e1ded0fb55fd$export$6558b61777516cff);
    var $5uXOq = parcelRequire("5uXOq");
    var $luBm6;
    var $cgL5K;
    var $4R6GH;
    var $koVbs;
    var $ehdJY;
    var $8M0Cn;
    const $5dc2e1ded0fb55fd$export$6558b61777516cff = ({ target: target, actionsBeforeElement: actionsBeforeElement, headingAfterElement: headingAfterElement, actions: actions })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            target: target,
            targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
            targetRadius: 3,
            heading: formatMessage((0, (0, parcelRequire("8M0Cn")).messages).heading),
            actionsBeforeElement: actionsBeforeElement,
            dialogPlacement: "bottom right",
            actions: actions({
                learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/save-changes-made-in-advanced-roadmaps/'
            }),
            headingAfterElement: headingAfterElement,
            messageId: "portfolio-3-onboarding.ui.onboarding.spotlight-save-your-changes.jira-spotlight",
            messageType: "transactional"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("8M0Cn")).messages).spotlightBodyIssueTermRefresh : (0, (0, parcelRequire("8M0Cn")).messages).spotlightBody, {
            b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    weight: "bold"
                }, chunks)
        }))));
    };
});
parcelRegister("8M0Cn", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$b930cca5b60bdb12$export$defe85febe8b728c);
    var $7VHMR;
    const $b930cca5b60bdb12$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-save-your-changes.heading",
            "defaultMessage": "A plan is a draft until you save changes"
        },
        spotlightBody: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-save-your-changes.spotlight-body",
            "defaultMessage": "Use <b>Unsaved changes</b> to save issues, teams or releases created or changed in your plan so they update in projects."
        },
        spotlightBodyIssueTermRefresh: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-save-your-changes.spotlight-body-issue-term-refresh",
            "defaultMessage": "Use <b>Unsaved changes</b> to save issues, teams or releases created or changed in your plan so they update in projects."
        }
    });
});
parcelRegister("kRDXu", function(module, exports) {
    $parcel$export(module.exports, "ShowAndTellSpotlight", ()=>$2bba1ae05d7717f4$export$1cbd09eb9384dd3b);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $ousew;
    var $koVbs;
    var $ehdJY;
    var $4nGXJ;
    const $2bba1ae05d7717f4$export$1cbd09eb9384dd3b = ({ target: target, actionsBeforeElement: actionsBeforeElement, headingAfterElement: headingAfterElement, actions: actions })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            target: target,
            targetRadius: 0,
            targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
            heading: formatMessage((0, (0, parcelRequire("4nGXJ")).messages).heading),
            actionsBeforeElement: actionsBeforeElement,
            actions: actions({
                learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/preconfigured-views-in-advanced-roadmaps/'
            }),
            headingAfterElement: headingAfterElement,
            messageId: "portfolio-3-onboarding.ui.onboarding.spotlight-show-and-tell.jira-spotlight",
            messageType: "transactional"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("4nGXJ")).messages).descriptionIssueTermRefresh : (0, (0, parcelRequire("4nGXJ")).messages).description));
    };
});
parcelRegister("4nGXJ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$4e47141a06dd9222$export$defe85febe8b728c);
    var $7VHMR;
    const $4e47141a06dd9222$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-show-and-tell.heading",
            "defaultMessage": "A view to remember"
        },
        description: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-show-and-tell.description",
            "defaultMessage": "Filter issues based on what's relevant to you, then save it to tell a unique story. Make multiple views to curate your plan for different audiences."
        },
        descriptionIssueTermRefresh: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-show-and-tell.description-issue-term-refresh",
            "defaultMessage": "Filter issues based on what's relevant to you, then save it to tell a unique story. Make multiple views to curate your plan for different audiences."
        }
    });
});
parcelRegister("bHAma", function(module, exports) {
    $parcel$export(module.exports, "ViewsSpotlight", ()=>$d0ca4d0cf0f6e816$export$9ea3305cd20bda43);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $ehdJY;
    var $5eomS;
    const $d0ca4d0cf0f6e816$export$9ea3305cd20bda43 = ({ target: target, actionsBeforeElement: actionsBeforeElement, actions: actions, headingAfterElement: headingAfterElement })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            target: target,
            targetRadius: 0,
            targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
            heading: formatMessage((0, (0, parcelRequire("5eomS")).messages).heading),
            actionsBeforeElement: actionsBeforeElement,
            actions: actions({
                learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/how-do-i-navigate-advanced-roadmaps/'
            }),
            headingAfterElement: headingAfterElement,
            messageId: "portfolio-3-onboarding.ui.onboarding.spotlight-views.jira-spotlight",
            messageType: "transactional"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("5eomS")).messages).description));
    };
});
parcelRegister("5eomS", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$5ea1485678dc96f8$export$defe85febe8b728c);
    var $7VHMR;
    const $5ea1485678dc96f8$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-views.heading",
            "defaultMessage": "Views for different needs"
        },
        description: {
            "id": "portfolio-3-onboarding.onboarding.spotlight-views.description",
            "defaultMessage": "Each page shows you a different aspect of your plan so you can quickly find the information you need."
        }
    });
});
parcelRegister("adqnA", function(module, exports) {
    $parcel$export(module.exports, "useStep", ()=>$c9798353b0407725$export$7896576cb7635832);
    $parcel$export(module.exports, "useController", ()=>$c9798353b0407725$export$e8c786024a2b0a79);
    $parcel$export(module.exports, "isCrossTeamPlanningTemplateExperimentEnabled", ()=>$c9798353b0407725$export$5d06510124eb14f8);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $6s1PB;
    var $83qPh;
    const $c9798353b0407725$export$7896576cb7635832 = ()=>{
        const [step, setStep] = (0, $5uXOq.useState)('inactive');
        const start = (0, $5uXOq.useCallback)(()=>setStep('modal'), []);
        const finish = (0, $5uXOq.useCallback)(()=>setStep('finished'), []);
        const skipToFlag = (0, $5uXOq.useCallback)(()=>setStep('flag'), []);
        const next = (0, $5uXOq.useCallback)(()=>setStep((current)=>{
                switch(current){
                    case 'modal':
                        return 'spotlight';
                    case 'spotlight':
                        return 'flag';
                    case 'flag':
                    default:
                        return 'finished';
                }
            }), []);
        return [
            step,
            {
                next: next,
                start: start,
                finish: finish,
                skip: skipToFlag
            }
        ];
    };
    const $c9798353b0407725$var$useStoreController = ()=>{
        const [{ visible: visible }, { initOnboarding: initOnboarding, closeOnboarding: closeOnboarding }] = (0, (0, parcelRequire("83qPh")).useOnboardingTour)();
        return [
            {
                visible: visible
            },
            {
                init: initOnboarding,
                close: closeOnboarding
            }
        ];
    };
    const $c9798353b0407725$var$usePropsController = (props)=>{
        if (!('visible' in props)) return undefined;
        const { visible: visible, onClose: onClose } = props;
        return [
            {
                visible: visible
            },
            {
                init: (0, ($parcel$interopDefault($8Rkzz))),
                close: onClose
            }
        ];
    };
    const $c9798353b0407725$export$e8c786024a2b0a79 = (props)=>{
        const storeController = $c9798353b0407725$var$useStoreController();
        const propsController = $c9798353b0407725$var$usePropsController(props);
        return propsController ?? storeController;
    };
    const $c9798353b0407725$export$5d06510124eb14f8 = ()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('second_premium_template_experiment', 'cohort', 'variation');
});
parcelRegister("83qPh", function(module, exports) {
    $parcel$export(module.exports, "useRehydrated", ()=>$54a3c2fc6e2e14ac$export$783184fef467e477);
    $parcel$export(module.exports, "useChangeboarding", ()=>$54a3c2fc6e2e14ac$export$4a515e2e15159bbe);
    $parcel$export(module.exports, "useOnboardingTour", ()=>$54a3c2fc6e2e14ac$export$c7824882d969afa7);
    $parcel$export(module.exports, "OnboardingProvider", ()=>$54a3c2fc6e2e14ac$export$54ba648a75d332de);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $frrR0;
    var $heO5n;
    var $7Y3eR;
    const $54a3c2fc6e2e14ac$var$initialState = {
        _rehydrated: false
    };
    const $54a3c2fc6e2e14ac$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $54a3c2fc6e2e14ac$var$initialState,
        actions: (0, parcelRequire("frrR0")).actions,
        name: 'portfolio-3/onboarding'
    });
    const $54a3c2fc6e2e14ac$export$783184fef467e477 = (0, (0, parcelRequire("3sQ5x")).createHook)($54a3c2fc6e2e14ac$var$store, {
        selector: (state)=>state._rehydrated
    });
    const $54a3c2fc6e2e14ac$export$4a515e2e15159bbe = (0, (0, parcelRequire("3sQ5x")).createHook)($54a3c2fc6e2e14ac$var$store, {
        selector: (0, (0, parcelRequire("heO5n")).selectChangeboarding)
    });
    const $54a3c2fc6e2e14ac$export$c7824882d969afa7 = (0, (0, parcelRequire("3sQ5x")).createHook)($54a3c2fc6e2e14ac$var$store, {
        selector: (0, (0, parcelRequire("heO5n")).selectOnboardingTour)
    });
    const $54a3c2fc6e2e14ac$export$54ba648a75d332de = (0, (0, parcelRequire("gg7kZ")).createContainer)($54a3c2fc6e2e14ac$var$store, {
        onInit: ()=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
                if (getState()._rehydratePromise === undefined) {
                    const promise = dispatch((0, (0, parcelRequire("7Y3eR")).rehydrate));
                    setState({
                        _rehydratePromise: promise
                    });
                    await promise;
                }
            }
    });
});
parcelRegister("frrR0", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$5aa18b8c8f01ed9e$export$e324594224ef24da);
    var $7Y3eR;
    const $5aa18b8c8f01ed9e$var$changeboardingActions = {
        initChangeboarding: ()=>async ({ getState: getState, setState: setState })=>{
                await getState()._rehydratePromise;
                if (getState().changeboarding?.stage === undefined) setState({
                    changeboarding: {
                        stage: 'READY'
                    }
                });
            },
        closeChangeboarding: ({ silent: silent } = {
            silent: true
        }, at = new Date())=>({ dispatch: dispatch })=>{
                dispatch((0, (0, parcelRequire("7Y3eR")).update)({
                    ui: !silent,
                    persist: true
                })({
                    changeboarding: {
                        stage: 'CLOSED',
                        closedAt: at
                    }
                }));
            }
    };
    const $5aa18b8c8f01ed9e$var$onboardingActions = {
        initOnboarding: ()=>async ({ getState: getState, setState: setState })=>{
                await getState()._rehydratePromise;
                if (getState().onboarding?.stage === undefined) setState({
                    onboarding: {
                        stage: 'READY'
                    }
                });
            },
        closeOnboarding: ({ silent: silent } = {
            silent: true
        })=>({ dispatch: dispatch })=>{
                dispatch((0, (0, parcelRequire("7Y3eR")).update)({
                    ui: !silent,
                    persist: true
                })({
                    onboarding: {
                        stage: 'CLOSED'
                    }
                }));
            }
    };
    const $5aa18b8c8f01ed9e$export$e324594224ef24da = {
        ...$5aa18b8c8f01ed9e$var$changeboardingActions,
        ...$5aa18b8c8f01ed9e$var$onboardingActions
    };
});
parcelRegister("7Y3eR", function(module, exports) {
    $parcel$export(module.exports, "rehydrate", ()=>$f45884e079f0c3e6$export$27af23fc693b4501);
    $parcel$export(module.exports, "update", ()=>$f45884e079f0c3e6$export$722fbec263ad908a);
    var $hjAWb = parcelRequire("hjAWb");
    var $aHuqL;
    const $f45884e079f0c3e6$var$PERSIST_KEY = 'jira.user.arj.onboarding';
    const $f45884e079f0c3e6$export$27af23fc693b4501 = async ({ getState: getState, setState: setState })=>{
        if (getState()._rehydrated) return;
        const assertUnreachable = (_)=>{
            throw new Error("Didn't expect to get here");
        };
        const parseDate = (raw)=>{
            const maybeDate = new Date(raw);
            return !Number.isNaN(maybeDate.getTime()) ? maybeDate : new Date();
        };
        const raw = await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get($f45884e079f0c3e6$var$PERSIST_KEY) ?? {};
        const changeboarding = (()=>{
            try {
                const stage = raw.changeboarding?.stage;
                switch(stage){
                    case 'READY':
                        return {
                            stage: stage
                        };
                    case 'CLOSED':
                        return {
                            stage: stage,
                            closedAt: parseDate(raw.changeboarding?.closedAt)
                        };
                    default:
                        assertUnreachable(stage);
                        return undefined;
                }
            } catch (err) {
                return undefined;
            }
        })();
        const onboarding = (()=>{
            try {
                const stage = raw.onboarding?.stage;
                switch(stage){
                    case 'READY':
                        return {
                            stage: stage
                        };
                    case 'CLOSED':
                        return {
                            stage: stage
                        };
                    default:
                        assertUnreachable(stage);
                        return undefined;
                }
            } catch (err) {
                return undefined;
            }
        })();
        setState({
            _rehydrated: true,
            changeboarding: changeboarding,
            onboarding: onboarding
        });
    };
    const $f45884e079f0c3e6$var$persist = (update)=>async ({ getState: getState })=>{
            const serialize = (0, ($parcel$interopDefault($hjAWb)))([
                'changeboarding',
                'onboarding'
            ]);
            (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).set($f45884e079f0c3e6$var$PERSIST_KEY, serialize({
                ...getState(),
                ...update
            }));
        };
    const $f45884e079f0c3e6$export$722fbec263ad908a = (options = {
        ui: true,
        persist: true
    })=>(partial)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
                const { _rehydrated: _rehydrated, _rehydratePromise: _rehydratePromise } = getState();
                if (!_rehydrated) await _rehydratePromise;
                if (options.ui) setState(partial);
                if (options.persist) dispatch($f45884e079f0c3e6$var$persist({
                    ...getState(),
                    ...partial
                }));
            };
});
parcelRegister("hjAWb", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $c9b0dcffc2009ee0$var$func = $lVx1a('pick', (parcelRequire("3NMrl")));
    $c9b0dcffc2009ee0$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $c9b0dcffc2009ee0$var$func;
});
parcelRegister("heO5n", function(module, exports) {
    $parcel$export(module.exports, "selectChangeboarding", ()=>$991c975959a83374$export$763e5c2849fd2595);
    $parcel$export(module.exports, "selectOnboardingTour", ()=>$991c975959a83374$export$66bbb450debbfc1b);
    const $991c975959a83374$export$763e5c2849fd2595 = ({ changeboarding: changeboarding })=>({
            visible: changeboarding?.stage === 'READY'
        });
    const $991c975959a83374$export$66bbb450debbfc1b = ({ onboarding: onboarding })=>({
            visible: onboarding?.stage === 'READY',
            closed: onboarding?.stage === 'CLOSED'
        });
});
parcelRegister("dUk9j", function(module, exports) {
    $parcel$export(module.exports, "SpotlightTarget", ()=>$0033ead13d224938$export$e29577842f211e22);
    $parcel$export(module.exports, "EpicLevelSpotlightTarget", ()=>$0033ead13d224938$export$27903a60ba199e9f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Fk4Z;
    var $c12LJ;
    var $g295Q;
    const $0033ead13d224938$export$e29577842f211e22 = ({ children: children, delayOn: delayOn, name: name })=>{
        const [withSpotlight, setWithSpotlight] = (0, $5uXOq.useState)(true);
        (0, $5uXOq.useEffect)(()=>{
            if (delayOn === undefined) return;
            setWithSpotlight(false);
            setTimeout(()=>setWithSpotlight(true), 1000);
        }, [
            delayOn
        ]);
        return withSpotlight ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: name
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $0033ead13d224938$export$27903a60ba199e9f = (children, isGroupByNone, level)=>level === (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL) && isGroupByNone ? (0, ($parcel$interopDefault($5uXOq))).createElement($0033ead13d224938$export$e29577842f211e22, {
            delayOn: true,
            name: (0, (0, parcelRequire("g295Q")).CttSpotlights).EpicSection,
            key: (0, (0, parcelRequire("g295Q")).CttSpotlights).EpicSection
        }, children) : children;
});
parcelRegister("c12LJ", function(module, exports) {
    $parcel$export(module.exports, "SUB_TASK_LEVEL", ()=>$3e10307c482ddd45$export$629eb88199636e31);
    $parcel$export(module.exports, "STORY_LEVEL", ()=>$3e10307c482ddd45$export$5851ccd68c79bc39);
    $parcel$export(module.exports, "EPIC_LEVEL", ()=>$3e10307c482ddd45$export$346285e0085a3842);
    $parcel$export(module.exports, "INITIATIVE_LEVEL", ()=>$3e10307c482ddd45$export$3dc28f07aa7629a3);
    var $g4tDr;
    const $3e10307c482ddd45$export$629eb88199636e31 = (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_SUBTASK);
    const $3e10307c482ddd45$export$5851ccd68c79bc39 = (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE);
    const $3e10307c482ddd45$export$346285e0085a3842 = (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_EPIC);
    const $3e10307c482ddd45$export$3dc28f07aa7629a3 = (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_INITIATIVE);
    const $3e10307c482ddd45$export$6b568e78303247cb = (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_STRATEGY);
    const $3e10307c482ddd45$export$8d7949e6fbe9c22a = (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_GOAL);
});
parcelRegister("4hkqI", function(module, exports) {
    $parcel$export(module.exports, "useRedirectToSpaPlanPage", ()=>$a636e5d36faab830$export$ca60ba613d31bd2a);
    $parcel$export(module.exports, "default", ()=>$a636e5d36faab830$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3HwlS;
    var $doZTA;
    const $a636e5d36faab830$export$ca60ba613d31bd2a = ()=>{
        const [{ match: match, location: location }, { replace: replace, push: push }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        return (page, plan)=>{
            if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && plan) {
                const newUrl = `/jira/plans/${plan.planId}/scenarios/${plan.scenarioId}${page}`;
                if (newUrl === location.pathname) return;
                push(newUrl);
            } else {
                if (!match.params?.planId || !match.params?.scenarioId) return;
                const newUrl = `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${page}`;
                if (newUrl === location.pathname) return;
                replace(newUrl);
            }
        };
    };
    const $a636e5d36faab830$var$withRedirectToSpaPlanPage = (WrappedComponent)=>(props)=>{
            const redirectToSpaPlanPage = $a636e5d36faab830$export$ca60ba613d31bd2a();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                redirectToSpaPlanPage: redirectToSpaPlanPage
            });
        };
    var $a636e5d36faab830$export$2e2bcd8739ae039 = $a636e5d36faab830$var$withRedirectToSpaPlanPage;
});
parcelRegister("aIQvD", function(module, exports) {
    $parcel$export(module.exports, "PlanActionMenuStoreContainer", ()=>$9067e37eff8fd2bd$export$841c6ae48f972846);
    $parcel$export(module.exports, "usePlanActionMenuStore", ()=>$9067e37eff8fd2bd$export$17c41990ccc1d1f5);
    $parcel$export(module.exports, "PlanActionMenuStoreSubscriber", ()=>$9067e37eff8fd2bd$export$472a04ea3fff8528);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $9067e37eff8fd2bd$var$actions = {
        toggleMenu: (open)=>({ setState: setState, getState: getState })=>{
                setState({
                    ...getState(),
                    isOpen: open ?? !getState().isOpen
                });
            },
        closeMenu: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    ...getState(),
                    isOpen: false
                });
            }
    };
    const $9067e37eff8fd2bd$export$841c6ae48f972846 = (0, (0, parcelRequire("gg7kZ")).createContainer)();
    const $9067e37eff8fd2bd$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            isOpen: false
        },
        actions: $9067e37eff8fd2bd$var$actions,
        containedBy: $9067e37eff8fd2bd$export$841c6ae48f972846,
        name: 'plan-action-menu-store'
    });
    const $9067e37eff8fd2bd$export$17c41990ccc1d1f5 = (0, (0, parcelRequire("3sQ5x")).createHook)($9067e37eff8fd2bd$var$Store);
    const $9067e37eff8fd2bd$export$472a04ea3fff8528 = (0, (0, parcelRequire("51nlc")).createSubscriber)($9067e37eff8fd2bd$var$Store);
});
parcelRegister("6DQw3", function(module, exports) {
    $parcel$export(module.exports, "useSetFavourite", ()=>$a44d05465d132d3b$export$28faf8ea68a6d1b8);
    var $lc0Q9;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $pa9q9;
    var $koVbs;
    var $koeKL;
    var $h3yCb;
    var $iHHEg;
    const $a44d05465d132d3b$export$28faf8ea68a6d1b8 = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const displayErrorFlag = (0, $5uXOq.useCallback)((planTitle, isFavourite)=>{
            const addFavouriteErrorFlag = ()=>({
                    id: 'set-favourite-error',
                    type: 'error',
                    title: (0, (0, parcelRequire("h3yCb")).default).errorFlagTitleNonFinal,
                    description: formatMessage((0, (0, parcelRequire("h3yCb")).default).errorFlagDescriptionFailedAddNonFinal, {
                        planTitle: planTitle
                    }),
                    isAutoDismiss: true
                });
            const removeFavouriteErrorFlag = ()=>({
                    id: 'remove-favourite-error',
                    type: 'error',
                    title: (0, (0, parcelRequire("h3yCb")).default).errorFlagTitleNonFinal,
                    description: formatMessage((0, (0, parcelRequire("h3yCb")).default).errorFlagDescriptionFailedRemoveNonFinal, {
                        planTitle: planTitle
                    }),
                    isAutoDismiss: true
                });
            showFlag(isFavourite ? addFavouriteErrorFlag() : removeFavouriteErrorFlag());
        }, [
            formatMessage,
            showFlag
        ]);
        const [commitMutation, isLoading] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("lc0Q9")).default));
        const setFavourite = (0, $5uXOq.useCallback)(({ entityId: entityId, planTitle: planTitle, isFavourite: isFavourite, favouriteConnectionId: favouriteConnectionId, beforeEntityId: beforeEntityId = null, onErrorCallback: onErrorCallback })=>{
            commitMutation({
                variables: {
                    input: {
                        entityId: entityId,
                        isFavourite: isFavourite,
                        beforeEntityId: beforeEntityId
                    }
                },
                optimisticUpdater: (store)=>(0, (0, parcelRequire("iHHEg")).updateRelayStore)({
                        cloudId: cloudId,
                        isFavourite: isFavourite,
                        entityId: entityId,
                        favouriteConnectionId: favouriteConnectionId,
                        store: store
                    }),
                updater: (store, response)=>{
                    if (response?.jira?.setEntityIsFavourite?.success && response.jira.setEntityIsFavourite.favouriteValue?.isFavourite != null) (0, (0, parcelRequire("iHHEg")).updateRelayStore)({
                        cloudId: cloudId,
                        isFavourite: response.jira.setEntityIsFavourite.favouriteValue.isFavourite,
                        entityId: entityId,
                        favouriteConnectionId: favouriteConnectionId,
                        store: store
                    });
                },
                onCompleted: (response)=>{
                    if (!response?.jira?.setEntityIsFavourite?.success) {
                        displayErrorFlag(planTitle, isFavourite);
                        onErrorCallback();
                    }
                },
                onError: ()=>{
                    displayErrorFlag(planTitle, isFavourite);
                    onErrorCallback();
                }
            });
        }, [
            commitMutation,
            cloudId,
            displayErrorFlag
        ]);
        return {
            setFavourite: setFavourite,
            isLoading: isLoading
        };
    };
});
parcelRegister("lc0Q9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad2e9fd1b6d85505$export$2e2bcd8739ae039);
    const $ad2e9fd1b6d85505$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "kind": "ScalarField",
            "name": "id"
        }, v4 = {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                v3,
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                }
            ]
        }, v5 = {
            "kind": "ScalarField",
            "name": "message"
        }, v6 = {
            "kind": "ScalarField",
            "name": "statusCode"
        }, v7 = {
            "kind": "ScalarField",
            "name": "errorType"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "setFavouritePlanMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraSetIsFavouritePayload",
                                "kind": "LinkedField",
                                "name": "setEntityIsFavourite",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v4,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v5,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    v6,
                                                    v7
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "setFavouritePlanMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraSetIsFavouritePayload",
                                "kind": "LinkedField",
                                "name": "setEntityIsFavourite",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v4,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v5,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v6,
                                                    v7,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v3
                                                        ],
                                                        "type": "BulkMutationErrorExtension"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "dd3d3c721753ed1a9509f36f8085ff3e2a22365f89ab238c3a4ab1851d20517c",
                "metadata": {},
                "name": "setFavouritePlanMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $ad2e9fd1b6d85505$var$node.hash = "3d9667a5509bfdf5d0b3cadff5c35398";
    var $ad2e9fd1b6d85505$export$2e2bcd8739ae039 = $ad2e9fd1b6d85505$var$node;
});
parcelRegister("h3yCb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b752d41397f42984$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b752d41397f42984$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitleNonFinal: {
            id: 'jet-plan-action-menu.services.set-favourite.error-flag-title-non-final',
            defaultMessage: "We couldn't save the changes",
            description: 'Title for the flag shown if the favourite update fails'
        },
        errorFlagDescriptionFailedAddNonFinal: {
            id: 'jet-plan-action-menu.services.set-favourite.error-flag-description-failed-add-non-final',
            defaultMessage: "We couldn't add {planTitle} to starred. Refresh and try again.",
            description: 'Description for the flag shown if adding plan to favourite fails'
        },
        errorFlagDescriptionFailedRemoveNonFinal: {
            id: 'jet-plan-action-menu.services.set-favourite.error-flag-description-failed-remove-non-final',
            defaultMessage: "We couldn't remove {planTitle} from starred. Refresh and try again.",
            description: 'Description for the flag shown if removing plan from favourite fails'
        }
    });
});
parcelRegister("iHHEg", function(module, exports) {
    $parcel$export(module.exports, "updateRelayStore", ()=>$69bff9eefbac6075$export$b75a687ab1368503);
    var $eiowN = parcelRequire("eiowN");
    var $iJZ8l;
    const $69bff9eefbac6075$export$b75a687ab1368503 = ({ cloudId: cloudId, isFavourite: isFavourite, store: store, favouriteConnectionId: favouriteConnectionId, entityId: entityId })=>{
        const entityTypeName = 'JiraPlan';
        const nodeId = (0, (0, parcelRequire("iJZ8l")).default)({
            id: entityId
        }, entityTypeName) ?? '';
        const node = store.get(nodeId);
        let favourites;
        if (favouriteConnectionId) favourites = store.get(favouriteConnectionId);
        else {
            const jiraRecord = store.getRoot().getLinkedRecord('jira');
            favourites = jiraRecord?.getLinkedRecord('favourites', {
                cloudId: cloudId,
                filter: {
                    type: 'PLAN'
                },
                first: 15
            });
        }
        if (!node || !favourites) return;
        node.getLinkedRecord('favouriteValue')?.setValue(isFavourite, 'isFavourite');
        if (isFavourite) {
            const edge = (0, $eiowN.ConnectionHandler).createEdge(store, favourites, node, 'JiraFavouriteEdge');
            (0, $eiowN.ConnectionHandler).insertEdgeBefore(favourites, edge);
        } else (0, $eiowN.ConnectionHandler).deleteNode(favourites, nodeId);
    };
});
parcelRegister("1Vnxw", function(module, exports) {
    $parcel$export(module.exports, "ArchivePlanModal", ()=>$63d6a0b93b4e0a74$export$18a8da6e12f1ef88);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $koVbs;
    var $9DMzk;
    var $lVJAU;
    var $eBvEd;
    const $63d6a0b93b4e0a74$export$18a8da6e12f1ef88 = ({ planId: planId, scenarioId: scenarioId, planTitle: planTitle, isArchived: isArchived, setClosed: setClosed, setPlanArchiveStatus: setPlanArchiveStatus })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onComplete = ()=>{
            setPlanArchiveStatus();
            const title = isArchived ? (0, (0, parcelRequire("eBvEd")).default).restored : (0, (0, parcelRequire("eBvEd")).default).archived;
            showFlag({
                title: title,
                type: 'success',
                isAutoDismiss: false
            });
            push(`/jira/plans/${planId}/scenarios/${scenarioId}`);
        };
        const onError = ()=>{
            setClosed();
            showFlag({
                id: isArchived ? 'restorePlanError' : 'archivePlanError',
                title: isArchived ? (0, (0, parcelRequire("eBvEd")).default).restoreErrorTitle : (0, (0, parcelRequire("eBvEd")).default).archiveErrorTitle,
                description: isArchived ? formatMessage((0, (0, parcelRequire("eBvEd")).default).restoreErrorDescription, {
                    planTitle: planTitle
                }) : formatMessage((0, (0, parcelRequire("eBvEd")).default).archiveErrorDescription, {
                    planTitle: planTitle
                }),
                type: 'error'
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9DMzk")).default), {
            planId: planId,
            planTitle: planTitle,
            isArchived: isArchived,
            onClose: setClosed,
            onComplete: onComplete,
            onError: onError,
            fallback: null
        });
    };
});
parcelRegister("9DMzk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f1fa3ce63a819423$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $f1fa3ce63a819423$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("eaODz")).then((module)=>module.ArchivePlanModal), {
        moduleId: "./src/packages/portfolio-3/plan-archiving/src/index.tsx"
    });
    const $f1fa3ce63a819423$var$AsyncComponent = ({ fallback: fallback, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "bundle-portfolio-3-plan-archiving",
            fallback: "flag",
            packageName: "jira-plan-archiving"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "plan-archiving",
            fallback: fallback !== undefined ? fallback : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: "small"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f1fa3ce63a819423$var$LazyComponent, props)));
    $f1fa3ce63a819423$var$AsyncComponent.defaultProps = {
        fallback: undefined
    };
    var $f1fa3ce63a819423$export$2e2bcd8739ae039 = $f1fa3ce63a819423$var$AsyncComponent;
});
parcelRegister("eaODz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jzMKv").then(()=>parcelRequire('9JT0Q'));
});
parcelRegister("eBvEd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8518b0fcff5c42fa$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8518b0fcff5c42fa$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        archived: {
            "id": "jet-plan-action-menu.archive-modal.archived",
            "defaultMessage": "Plan archived successfully"
        },
        restored: {
            "id": "jet-plan-action-menu.archive-modal.restored",
            "defaultMessage": "Plan restored successfully"
        },
        archiveErrorTitle: {
            "id": "jet-plan-action-menu.archive-modal.archive-error-title",
            "defaultMessage": "We couldn't archive your plan"
        },
        archiveErrorDescription: {
            "id": "jet-plan-action-menu.archive-modal.archive-error-description",
            "defaultMessage": "We couldn't archive {planTitle}.\nRefresh the page and try again."
        },
        restoreErrorTitle: {
            "id": "jet-plan-action-menu.archive-modal.restore-error-title",
            "defaultMessage": "We couldn't restore your plan"
        },
        restoreErrorDescription: {
            "id": "jet-plan-action-menu.archive-modal.restore-error-description",
            "defaultMessage": "We couldn't restore {planTitle}.\nRefresh the page and try again."
        }
    });
});
parcelRegister("5Gcoq", function(module, exports) {
    $parcel$export(module.exports, "DuplicatePlanModal", ()=>$9fd119bc95c27f66$export$d87287bf306868bb);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $koVbs;
    var $l5kCn;
    var $lVJAU;
    var $iFVf9;
    const $9fd119bc95c27f66$export$d87287bf306868bb = ({ planId: planId, planTitle: planTitle, setClosed: setClosed })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onComplete = (newPlanId, newScenarioId)=>{
            setClosed();
            push(`/jira/plans/${newPlanId}/scenarios/${newScenarioId}`);
        };
        const onError = ()=>{
            setClosed();
            showFlag({
                id: 'duplicatePlanError',
                type: 'error',
                title: (0, (0, parcelRequire("iFVf9")).default).errorTitle,
                description: formatMessage((0, (0, parcelRequire("iFVf9")).default).errorDescription, {
                    planTitle: planTitle
                })
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l5kCn")).default), {
            planId: planId,
            planTitle: planTitle,
            onClose: setClosed,
            onComplete: onComplete,
            onError: onError,
            fallback: null
        });
    };
});
parcelRegister("l5kCn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e86dc1bbc2087d03$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $e86dc1bbc2087d03$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("kg4X0")), {
        moduleId: "./src/packages/portfolio-3/plan-duplicating/src/index.tsx"
    });
    const $e86dc1bbc2087d03$var$AsyncComponent = ({ fallback: fallback, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "bundle-portfolio-3-plan-duplicating",
            fallback: "flag",
            packageName: "jira-plan-duplicating"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "plan-duplicating",
            fallback: fallback !== undefined ? fallback : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: "large"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e86dc1bbc2087d03$var$LazyComponent, props)));
    $e86dc1bbc2087d03$var$AsyncComponent.defaultProps = {
        fallback: undefined
    };
    var $e86dc1bbc2087d03$export$2e2bcd8739ae039 = $e86dc1bbc2087d03$var$AsyncComponent;
});
parcelRegister("kg4X0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3TK0k").then(()=>parcelRequire('ciROb'));
});
parcelRegister("iFVf9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0cf350efa14a61a8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0cf350efa14a61a8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "jet-plan-action-menu.duplicate-modal.error-title",
            "defaultMessage": "We couldn't duplicate your plan"
        },
        errorDescription: {
            "id": "jet-plan-action-menu.duplicate-modal.error-description",
            "defaultMessage": "We couldn't duplicate {planTitle}.\nRefresh the page and try again."
        }
    });
});
parcelRegister("gPwud", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e559f9b9c0f28c83$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e559f9b9c0f28c83$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        triggerLabel: {
            "id": "jet-plan-action-menu.trigger-label",
            "defaultMessage": "Plan settings"
        },
        help: {
            "id": "jet-plan-action-menu.help",
            "defaultMessage": "Get started with plans"
        },
        duplicate: {
            "id": "jet-plan-action-menu.duplicate",
            "defaultMessage": "Duplicate plan"
        },
        trash: {
            "id": "jet-plan-action-menu.trash",
            "defaultMessage": "Move to trash"
        },
        archive: {
            "id": "jet-plan-action-menu.archive",
            "defaultMessage": "Archive"
        },
        restore: {
            "id": "jet-plan-action-menu.restore",
            "defaultMessage": "Restore"
        },
        takeTour: {
            "id": "jet-plan-action-menu.take-tour",
            "defaultMessage": "Take tour"
        },
        starPlan: {
            "id": "jet-plan-action-menu.star-plan",
            "defaultMessage": "Add to starred"
        },
        unstarPlan: {
            "id": "jet-plan-action-menu.unstar-plan",
            "defaultMessage": "Remove from starred"
        },
        planSettings: {
            "id": "jet-plan-action-menu.plan-settings",
            "defaultMessage": "Plan settings"
        }
    });
});
parcelRegister("b6Up7", function(module, exports) {
    $parcel$export(module.exports, "MoreNavMenuButton", ()=>$03a56dc7de7d041b$export$df3f5812ef8777cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $3oUqw;
    var $1I7E8;
    var $koVbs;
    var $9bWB7;
    var $hgY6g;
    const $03a56dc7de7d041b$export$df3f5812ef8777cb = ({ MenuItems: MenuItems, onCloseMenu: onCloseMenu, isOpen: isOpen, onClick: onClick, isUsedForSidebarNav: isUsedForSidebarNav })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const content = (contentProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hgY6g")).MoreNavMenuButtonSubmenu), {
                ...contentProps,
                MenuItems: MenuItems
            });
        const onClose = (0, $5uXOq.useCallback)(()=>{
            onCloseMenu();
        }, [
            onCloseMenu
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            content: content,
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-start",
            trigger: ({ ref: ref, ...props })=>isUsedForSidebarNav ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...props,
                    onClick: onClick,
                    label: formatMessage((0, (0, parcelRequire("9bWB7")).default).triggerLabel),
                    ref: ref,
                    icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))), {
                            size: "small",
                            label: ""
                        }),
                    spacing: "compact",
                    isTooltipDisabled: true,
                    testId: "jet-plan-action-menu.ui.more-nav-menu-button.sidebar"
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...props,
                    isSelected: isOpen,
                    onClick: onClick,
                    label: formatMessage((0, (0, parcelRequire("9bWB7")).default).triggerLabel),
                    ref: ref,
                    appearance: "subtle",
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))),
                    isTooltipDisabled: false,
                    testId: "jet-plan-action-menu.ui.more-nav-menu-button.horizontal"
                }),
            shouldRenderToParent: true
        });
    };
});
parcelRegister("9bWB7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f6b8f8823cfc9b2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1f6b8f8823cfc9b2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        triggerLabel: {
            "id": "jet-plan-action-menu.more-nav-menu-button.trigger-label",
            "defaultMessage": "Plan settings"
        }
    });
});
parcelRegister("hgY6g", function(module, exports) {
    $parcel$export(module.exports, "MoreNavMenuButtonSubmenu", ()=>$760a228c1d0decc4$export$ac88f3e136748c4a);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZUJu;
    const $760a228c1d0decc4$export$ac88f3e136748c4a = ({ MenuItems: MenuItems, onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), {
            minWidth: 250
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItems, {
            onClose: onClose
        }));
});
parcelRegister("49Q1d", function(module, exports) {
    $parcel$export(module.exports, "TrashPlanModal", ()=>$8495ccc444a51798$export$904566914f982884);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $koVbs;
    var $1UdpC;
    var $lVJAU;
    var $8meBj;
    const $8495ccc444a51798$export$904566914f982884 = ({ planId: planId, setClosed: setClosed, planTitle: planTitle })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onComplete = ()=>{
            push('/jira/plans');
            setClosed();
        };
        const onError = ()=>{
            setClosed();
            showFlag({
                id: 'trashPlanError',
                type: 'error',
                title: (0, (0, parcelRequire("8meBj")).default).errorTitle,
                description: formatMessage((0, (0, parcelRequire("8meBj")).default).errorDescription, {
                    planTitle: planTitle
                })
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1UdpC")).default), {
            planId: planId,
            onCancel: setClosed,
            onComplete: onComplete,
            onError: onError,
            fallback: null
        });
    };
});
parcelRegister("1UdpC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac5576cc8d5796eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $ac5576cc8d5796eb$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5x8L9")).then((module)=>module.TrashPlanModal), {
        moduleId: "./src/packages/portfolio-3/plan-trash/src/index.tsx"
    });
    const $ac5576cc8d5796eb$var$AsyncComponent = ({ fallback: fallback, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "bundle-portfolio-3-plan-trash",
            fallback: "flag",
            packageName: "jira-plan-trash"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "plan-trash",
            fallback: fallback !== undefined ? fallback : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: "small"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac5576cc8d5796eb$var$LazyComponent, props)));
    $ac5576cc8d5796eb$var$AsyncComponent.defaultProps = {
        fallback: undefined
    };
    var $ac5576cc8d5796eb$export$2e2bcd8739ae039 = $ac5576cc8d5796eb$var$AsyncComponent;
});
parcelRegister("5x8L9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ex6pL").then(()=>parcelRequire('JXA9h'));
});
parcelRegister("8meBj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d0f94a0b459116de$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d0f94a0b459116de$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "jet-plan-action-menu.trash-modal.error-title",
            "defaultMessage": "We couldn't delete your plan"
        },
        errorDescription: {
            "id": "jet-plan-action-menu.trash-modal.error-description",
            "defaultMessage": "We couldn't move {planTitle} to the trash.\nRefresh the page and try again."
        }
    });
});
parcelRegister("gPhGo", function(module, exports) {
    $parcel$export(module.exports, "isPlanAndScenarioMatchingUrl", ()=>$86a26bb326292102$export$b28296022e253b2f);
    const $86a26bb326292102$export$b28296022e253b2f = ({ urlPlanId: urlPlanId, urlScenarioId: urlScenarioId, planId: planId, scenarioId: scenarioId })=>{
        if (!urlPlanId || !urlScenarioId) return false;
        return Number(urlPlanId) === planId && Number(urlScenarioId) === scenarioId;
    };
});
parcelRegister("9tfnl", function(module, exports) {
    $parcel$export(module.exports, "PlansListOld", ()=>$93cc7a559cea65a0$export$80503916f8ece946);
    var $b769z;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $koVbs;
    var $jhS4y;
    var $c6x3L;
    var $9Gyp5;
    var $gxbcq;
    var $1b6zA;
    var $itGTR;
    var $koeKL;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    var $2CQvU;
    var $aQcVR;
    var $gT8yh;
    var $a6aJc;
    const $93cc7a559cea65a0$var$MAX_RECENT_PLANS = 5;
    const $93cc7a559cea65a0$export$80503916f8ece946 = ({ fragmentRef: fragmentRef })=>{
        const { isSelectedPath: isSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { getStableItems: getStableItems } = (0, (0, parcelRequire("1b6zA")).useStableItems)();
        const [data, refetch] = (0, $8Uumt.useRefetchableFragment)((0, (0, parcelRequire("b769z")).default), fragmentRef);
        (0, (0, parcelRequire("9Gyp5")).useRefetchWhenIsSelected)({
            cloudId: cloudId,
            isSelectedPath: isSelectedPath,
            QUERY: (0, parcelRequire("itGTR")).default,
            refetch: refetch,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS)
        });
        const refetchOnChange = (0, $5uXOq.useCallback)(({ onComplete: onComplete })=>{
            refetch({
                cloudId: cloudId
            }, {
                fetchPolicy: 'store-and-network',
                onComplete: onComplete
            });
        }, [
            cloudId,
            refetch
        ]);
        (0, (0, parcelRequire("gxbcq")).useSubscribeAndUpdateFavorites)({
            entityTypename: 'JiraPlan',
            favouriteConnectionId: data.jira.favouritePlans.__id,
            recentConnectionId: data.jira.recentPlans.__id,
            refetch: refetchOnChange
        });
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const starred = formatMessage((0, (0, parcelRequire("gT8yh")).default).starred);
        const recent = formatMessage((0, (0, parcelRequire("gT8yh")).default).recent);
        const favorites = (0, $5uXOq.useMemo)(()=>{
            const ids = data.jira.favouritePlans.edges?.map((edge)=>edge?.node.id).filter(Boolean) ?? [];
            const list = data.jira.favouritePlans.edges?.filter(Boolean).map((edge)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a6aJc")).PlanMenuItem), {
                    key: edge.node.planId,
                    fragmentRef: edge.node,
                    favouriteConnectionId: data.jira.favouritePlans.__id
                })) ?? [];
            return {
                idSet: new Set(ids),
                list: list,
                hasItems: Boolean(list.length)
            };
        }, [
            data.jira.favouritePlans.__id,
            data.jira.favouritePlans.edges
        ]);
        const recentPlans = (0, $5uXOq.useMemo)(()=>{
            const nodes = data.jira.recentPlans.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, $93cc7a559cea65a0$var$MAX_RECENT_PLANS) ?? [];
            const stableOrderedNodes = getStableItems({
                nodes: nodes,
                idKey: 'id'
            });
            const list = stableOrderedNodes.map((node)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a6aJc")).PlanMenuItem), {
                    key: node.planId,
                    fragmentRef: node,
                    favouriteConnectionId: data.jira.favouritePlans.__id
                }));
            return {
                list: list,
                hasItems: Boolean(list.length)
            };
        }, [
            data.jira.favouritePlans.__id,
            data.jira.recentPlans.edges,
            favorites.idSet,
            getStableItems
        ]);
        if (!favorites.hasItems && !recentPlans.hasItems) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aQcVR")).PlansEmptyContent), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, favorites.hasItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CQvU")).MenuSectionHeading), null, starred), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, favorites.list))), recentPlans.hasItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CQvU")).MenuSectionHeading), null, recent), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, recentPlans.list))));
    };
});
parcelRegister("b769z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16d939649498f699$export$2e2bcd8739ae039);
    var $itGTR;
    const $16d939649498f699$var$node = function() {
        var v0 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v1 = {
            "kind": "ScalarField",
            "name": "id"
        }, v2 = {
            "kind": "ScalarField",
            "name": "planId"
        }, v3 = {
            "kind": "FragmentSpread",
            "name": "PlanMenuItem"
        }, v4 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "cloudId"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "currentURL"
                }
            ],
            "kind": "Fragment",
            "metadata": {
                "refetch": {
                    "fragmentPathInResult": [],
                    "operation": (0, (0, parcelRequire("itGTR")).default)
                }
            },
            "name": "PlansListOld",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v0,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "PLAN"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v1,
                                                                        "action": "THROW",
                                                                        "path": "jira.favouritePlans.edges.node.id"
                                                                    },
                                                                    v2,
                                                                    v3
                                                                ],
                                                                "type": "JiraPlan"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.favouritePlans.edges.node"
                                                }
                                            ]
                                        },
                                        v4
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.favouritePlans"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "recentPlans",
                                    "args": [
                                        v0,
                                        {
                                            "kind": "Variable",
                                            "name": "currentURL",
                                            "variableName": "currentURL"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 20
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v1,
                                                                        "action": "THROW",
                                                                        "path": "jira.recentPlans.edges.node.id"
                                                                    },
                                                                    v2,
                                                                    v3
                                                                ],
                                                                "type": "JiraPlan"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.recentPlans.edges.node"
                                                }
                                            ]
                                        },
                                        v4
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.recentPlans"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        };
    }();
    $16d939649498f699$var$node.hash = "1f37f7164f8dde2867b03aacef05d0ca";
    var $16d939649498f699$export$2e2bcd8739ae039 = $16d939649498f699$var$node;
});
parcelRegister("itGTR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ecee07788c60bbae$export$2e2bcd8739ae039);
    const $ecee07788c60bbae$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "currentURL",
            "variableName": "currentURL"
        }, v2 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v3 = {
            "kind": "ScalarField",
            "name": "id"
        }, v4 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3,
                            {
                                "kind": "ScalarField",
                                "name": "planId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isReadOnly"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "planStatus"
                            },
                            {
                                "concreteType": "JiraFavouriteValue",
                                "kind": "LinkedField",
                                "name": "favouriteValue",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isFavourite"
                                    },
                                    v3
                                ]
                            },
                            {
                                "concreteType": "JiraScenario",
                                "kind": "LinkedField",
                                "name": "scenario",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "scenarioId"
                                    },
                                    v3
                                ]
                            }
                        ],
                        "type": "JiraPlan"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                    }
                ]
            }
        ], v5 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "PlanListOldQuery",
                "selections": [
                    {
                        "args": [
                            v1
                        ],
                        "kind": "FragmentSpread",
                        "name": "PlansListOld"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "PlanListOldQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "favouritePlans",
                                "args": [
                                    v2,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "PLAN"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v4
                                    },
                                    v5
                                ]
                            },
                            {
                                "alias": "recentPlans",
                                "args": [
                                    v2,
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "PLAN"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v4
                                    },
                                    v5
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "f101825753e58130552cbe564f4719c8d9c24519df8b436381c10e3795a91169",
                "metadata": {},
                "name": "PlanListOldQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $ecee07788c60bbae$var$node.hash = "1f37f7164f8dde2867b03aacef05d0ca";
    var $ecee07788c60bbae$export$2e2bcd8739ae039 = $ecee07788c60bbae$var$node;
});
parcelRegister("iUfQY", function(module, exports) {
    $parcel$export(module.exports, "Nav4PlansPremiumUpsellFeatureGate", ()=>$dd47fda66af0f6fa$export$87c172423f26b2a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $aProA;
    var $46Cti;
    var $dUyqZ;
    var $jUDIz;
    var $17aWz;
    var $lBNLs;
    const $dd47fda66af0f6fa$export$87c172423f26b2a0 = ()=>{
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jUDIz")).FlyoutMenuItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lBNLs")).FlyoutMenuItemTrigger), {
            iconBefore: icon
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17aWz")).FlyoutMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aProA")).default), null)));
    };
});
parcelRegister("aProA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59ef1621dccedbfe$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $9yOBd;
    var $l1N8i;
    var $8EYBJ;
    var $dC5iT;
    var $8CUq3;
    var $hxoiH;
    var $iwnVa;
    var $6s1PB;
    var $koVbs;
    var $liGrj;
    var $8zOmE;
    var $dCm1o;
    var $Mp6qH;
    var $iIz7a;
    var $gblI8;
    const $59ef1621dccedbfe$var$LEARN_MORE_LINK = 'https://www.atlassian.com/software/jira/guides/advanced-roadmaps/overview#what-are-advanced-roadmaps';
    const $59ef1621dccedbfe$var$PremiumFeatureGate = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        const { data: { premiumTrialUpgradeLink: premiumTrialUpgradeLink } } = (0, (0, parcelRequire("6s1PB")).expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? {
            data: {
                premiumTrialUpgradeLink: undefined
            }
        } : (0, (0, parcelRequire("iwnVa")).useJswPremiumTrialUpgradeLink)({
            caller: (0, (0, parcelRequire("Mp6qH")).PACKAGE_NAME)
        });
        const onStartTrialClick = (_, analyticsEvent)=>{
            if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
                level: 2,
                componentType: 'fixedItemAction',
                parentItemId: 'plans',
                itemId: 'tryItFree'
            });
            else (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'navigationUpgradeToPremiumFromPlansMenu');
        };
        const onLearnMoreClick = (_, analyticsEvent)=>{
            if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
                level: 2,
                componentType: 'fixedItemAction',
                parentItemId: 'plans',
                itemId: 'readTheGuide'
            });
            else (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'navigationLearnMoreAboutPremiumFromPlansMenu');
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$MenuContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$MenuHeaderContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iIz7a")).FeatureGateLogo), {
            alt: "",
            colorMode: colorMode
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$ContentContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "small",
            as: "h2"
        }, formatMessage((0, (0, parcelRequire("gblI8")).default).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $59ef1621dccedbfe$var$contentDescriptionStyles
        }, formatMessage((0, (0, parcelRequire("gblI8")).default).description))), (0, ($parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$FooterContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$LearnMoreButton, {
            appearance: "link",
            href: $59ef1621dccedbfe$var$LEARN_MORE_LINK,
            target: "_blank",
            onClick: onLearnMoreClick
        }, formatMessage((0, (0, parcelRequire("gblI8")).default).learnMoreLink)), (0, (0, parcelRequire("6s1PB")).expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? (0, ($parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$TryPremiumButton, {
            onClick: onStartTrialClick,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8EYBJ"))))), {
                size: "small",
                label: formatMessage((0, (0, parcelRequire("gblI8")).default).imageAlt),
                primaryColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`
            })
        }, formatMessage((0, (0, parcelRequire("gblI8")).default).startTrialButton)) : (0, ($parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$TryPremiumButtonDirectLink, {
            href: premiumTrialUpgradeLink,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8EYBJ"))))), {
                size: "small",
                label: formatMessage((0, (0, parcelRequire("gblI8")).default).imageAlt),
                primaryColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`
            })
        }, formatMessage((0, (0, parcelRequire("gblI8")).default).startTrialButton))));
    };
    var $59ef1621dccedbfe$export$2e2bcd8739ae039 = $59ef1621dccedbfe$var$PremiumFeatureGate;
    const $59ef1621dccedbfe$var$TryPremiumButton = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("liGrj")).PremiumUpgradeModalEntryPointButton), {
            ...props,
            theme: (current, themeProps)=>({
                    buttonStyles: {
                        ...current(themeProps).buttonStyles,
                        display: 'flex',
                        alignItems: 'center',
                        background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                        outline: 'none',
                        boxSizing: 'border-box',
                        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                        borderRadius: "var(--ds-space-050, 4px)",
                        height: "var(--ds-space-400, 32px)",
                        border: 'none',
                        fontSize: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        gap: "var(--ds-space-025, 2px)"
                    },
                    spinnerStyles: current(themeProps).spinnerStyles
                })
        });
    const $59ef1621dccedbfe$var$TryPremiumButtonDirectLink = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            ...props,
            theme: (current, themeProps)=>({
                    buttonStyles: {
                        ...current(themeProps).buttonStyles,
                        display: 'flex',
                        alignItems: 'center',
                        background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                        outline: 'none',
                        boxSizing: 'border-box',
                        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                        borderRadius: "var(--ds-space-050, 4px)",
                        height: "var(--ds-space-400, 32px)",
                        border: 'none',
                        fontSize: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        gap: "var(--ds-space-025, 2px)"
                    },
                    spinnerStyles: current(themeProps).spinnerStyles
                })
        });
    const $59ef1621dccedbfe$var$LearnMoreButton = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            ...props,
            theme: (current, themeProps)=>({
                    buttonStyles: {
                        ...current(themeProps).buttonStyles,
                        maxWidth: '250px',
                        marginRight: "var(--ds-space-200, 16px)"
                    },
                    spinnerStyles: current(themeProps).spinnerStyles
                })
        });
    const $59ef1621dccedbfe$var$MenuContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vchhusvi _2rko1b66 _11q717kt _189et94y _1dqonqa1 _1h6d3acm _qjkjusvi _1y1m18uv _p12f1l5c",
                __cmplp.className
            ])
        });
    });
    const $59ef1621dccedbfe$var$MenuHeaderContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q7gup1 _4t3il1r9 _2rko1xsr _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $59ef1621dccedbfe$var$ContentContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41ejb _11q7vuon",
                __cmplp.className
            ])
        });
    });
    const $59ef1621dccedbfe$var$contentDescriptionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.100'
    });
    const $59ef1621dccedbfe$var$FooterContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4gqct _11q7vuon _2rko4dok _1e0c1txw _4cvr1h6o _1bahesu3",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iwnVa", function(module, exports) {
    $parcel$export(module.exports, "useJswPremiumTrialUpgradeLink", ()=>$fc84e0a2b7204935$export$645eda3f5f2163ec);
    var $2vSU6;
    var $ldyPw;
    var $9OXo1;
    var $7qMMP;
    const $fc84e0a2b7204935$export$645eda3f5f2163ec = ({ deepLink: deepLink = true, skip: skip = false, caller: caller })=>{
        const { productEntitlementDetails: productEntitlementDetails } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const jswEntitlement = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
        const isJswUsingCcp = jswEntitlement?.billingSourceSystem === 'CCP';
        const { data: data, ...rest } = (0, (0, parcelRequire("7qMMP")).useGetBillingPageUrl)({
            isUsingCcp: isJswUsingCcp,
            editionToUpgradeTo: deepLink ? (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION) : undefined,
            caller: caller,
            skip: skip,
            subProduct: (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)
        });
        return {
            data: {
                premiumTrialUpgradeLink: data.billingPageUrl
            },
            ...rest
        };
    };
});
parcelRegister("7qMMP", function(module, exports) {
    $parcel$export(module.exports, "useGetBillingPageUrl", ()=>$8899a5adc0f59798$export$7b1495b7581dcd01);
    var $5uXOq = parcelRequire("5uXOq");
    var $cVzoY;
    var $8zOmE;
    var $2NMNM;
    var $14XJw;
    var $ldyPw;
    var $16v4H;
    var $9OXo1;
    var $7j7Ij;
    var $5aye8;
    var $5Q4f1;
    var $iHAwr;
    const $8899a5adc0f59798$export$7b1495b7581dcd01 = ({ isUsingCcp: isUsingCcp, editionToUpgradeTo: editionToUpgradeTo, caller: caller, skip: skip = false, subProduct: subProduct, onError: onError })=>{
        const [billingPageUrl, setBillingPageUrl] = (0, $5uXOq.useState)();
        const [loading, setLoading] = (0, $5uXOq.useState)(true);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const contextSubProduct = (0, (0, parcelRequire("16v4H")).useSubProduct)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const subProductToUse = subProduct || contextSubProduct;
        (0, $5uXOq.useEffect)(()=>{
            if (skip) return;
            const loadBillingInfo = async ()=>{
                try {
                    const explicitlyLicensedProducts = (0, (0, parcelRequire("cVzoY")).default)(tenantContext);
                    const productKey = (0, (0, parcelRequire("iHAwr")).getProductKey)(subProductToUse, explicitlyLicensedProducts);
                    const referrerKey = (0, (0, parcelRequire("5aye8")).getProductReferrerKey)(productKey);
                    const commerceProductKey = productKey === (0, $c06e1abca7c13910$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
                    const entitlementId = productKey ? tenantContext.productEntitlementDetails?.[productKey]?.entitlementId : null;
                    if (isUsingCcp) {
                        if (!entitlementId) {
                            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'RetrieveEntitlementId failed', {
                                caller: caller,
                                productKey: productKey,
                                productEntitlementDetails: JSON.stringify(tenantContext.productEntitlementDetails),
                                subProduct: subProductToUse
                            });
                            throw new Error('Empty entitlement ID');
                        }
                        const ccpTransactionAccountId = await (0, (0, parcelRequire("5aye8")).getCcpTransactionAccountId)(entitlementId);
                        const ccpBaseUrl = `${(0, (0, parcelRequire("5Q4f1")).getAdminBaseUrl)()}/billing/o/${orgId}/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=${referrerKey}&enableMpucup=true`;
                        switch(editionToUpgradeTo){
                            case 0, (0, parcelRequire("ldyPw")).STANDARD_EDITION:
                            case 0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION:
                                setBillingPageUrl(`${ccpBaseUrl}&offeringName=${(0, (0, parcelRequire("7j7Ij")).EDITION_KEY)[editionToUpgradeTo]}`);
                                break;
                            default:
                                setBillingPageUrl(ccpBaseUrl);
                        }
                    } else switch(editionToUpgradeTo){
                        case 0, (0, parcelRequire("ldyPw")).STANDARD_EDITION:
                        case 0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION:
                            setBillingPageUrl(`${(0, (0, parcelRequire("5Q4f1")).getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}/${(0, (0, parcelRequire("7j7Ij")).EDITION_KEY)[editionToUpgradeTo]}`);
                            break;
                        default:
                            setBillingPageUrl(`${(0, (0, parcelRequire("5Q4f1")).getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}`);
                    }
                } catch (e) {
                    setError(e);
                    if (onError && e instanceof Error) onError(e);
                } finally{
                    setLoading(false);
                }
            };
            loadBillingInfo();
        }, [
            caller,
            createAnalyticsEvent,
            editionToUpgradeTo,
            isUsingCcp,
            onError,
            orgId,
            skip,
            subProduct,
            subProductToUse,
            tenantContext,
            tenantContext.cloudId
        ]);
        return {
            data: {
                billingPageUrl: billingPageUrl
            },
            loading: loading,
            error: error
        };
    };
});
parcelRegister("cVzoY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$386aacc800b616d8$export$2e2bcd8739ae039);
    var $386aacc800b616d8$export$2e2bcd8739ae039 = (tenantContext)=>{
        const { licensedProducts: licensedProducts } = tenantContext;
        const result = [];
        licensedProducts[0, $c06e1abca7c13910$export$db515c8cec1e6f79] && result.push((0, $c06e1abca7c13910$export$db515c8cec1e6f79));
        licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && result.push((0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61));
        licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] && result.push((0, $c06e1abca7c13910$export$1346c9aa3cbb477d));
        licensedProducts[0, $c06e1abca7c13910$export$202f50ee62667e32] && result.push((0, $c06e1abca7c13910$export$202f50ee62667e32));
        return result;
    };
});
parcelRegister("7j7Ij", function(module, exports) {
    $parcel$export(module.exports, "EDITION_KEY", ()=>$2797dd9db1687273$export$d73720c31c622c1f);
    var $ldyPw;
    const $2797dd9db1687273$export$d73720c31c622c1f = {
        STANDARD_EDITION: (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION_KEY),
        PREMIUM_EDITION: (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION_KEY)
    };
    const $2797dd9db1687273$export$5b7423264d48ab04 = 'not-enrolled';
    const $2797dd9db1687273$export$fa04ad826acc90da = 'variation';
});
parcelRegister("5aye8", function(module, exports) {
    $parcel$export(module.exports, "getProductReferrerKey", ()=>$c065e9df012feb0c$export$b4fb3304d5d8fc5f);
    $parcel$export(module.exports, "getCcpTransactionAccountId", ()=>$c065e9df012feb0c$export$5186b9d213f626fd);
    var $7f4tk;
    const $c065e9df012feb0c$export$b4fb3304d5d8fc5f = (productKey)=>{
        if (productKey === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)) return 'jsw';
        if (productKey === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)) return 'jsm';
        if (productKey === (0, $c06e1abca7c13910$export$202f50ee62667e32)) return 'jpd';
        if (productKey === (0, $c06e1abca7c13910$export$db515c8cec1e6f79)) return 'jwm';
        return null;
    };
    const $c065e9df012feb0c$export$5186b9d213f626fd = async (entitlementId)=>{
        const entitlementDetails = await (0, (0, parcelRequire("7f4tk")).default)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`);
        if (!entitlementDetails?.transactionAccountId) throw Error('Could not get transactionAccountId');
        return (entitlementDetails ?? {}).transactionAccountId;
    };
});
parcelRegister("5Q4f1", function(module, exports) {
    $parcel$export(module.exports, "getAdminBaseUrl", ()=>$2c9346932f4dad13$export$76bb37a926058cca);
    var $kTK0a;
    const $2c9346932f4dad13$export$76bb37a926058cca = ()=>`https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('admin')}`;
});
parcelRegister("iHAwr", function(module, exports) {
    $parcel$export(module.exports, "getProductKey", ()=>$a2785a755bdb8c08$export$d0b7f02493f85477);
    const $a2785a755bdb8c08$export$d0b7f02493f85477 = (subProduct, explicitlyLicensedProducts)=>{
        if (subProduct === 'software') return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
        if (subProduct === 'serviceDesk') return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
        if (subProduct === 'polaris') return 0, $c06e1abca7c13910$export$202f50ee62667e32;
        if (subProduct === 'core') return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
        if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
        return null;
    };
});
parcelRegister("liGrj", function(module, exports) {
    $parcel$export(module.exports, "PremiumUpgradeModalEntryPointButton", ()=>$c0d01fc7cb7615a5$export$9901be7804227da7);
    var $5uXOq = parcelRequire("5uXOq");
    var $9yOBd;
    var $47gW9;
    var $ivDCs;
    var $4mO32;
    var $b3Gth;
    const $c0d01fc7cb7615a5$var$entryPointParams = {};
    const $c0d01fc7cb7615a5$export$9901be7804227da7 = (buttonProps)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("b3Gth")).entryPointPremiumUpgradeModal), $c0d01fc7cb7615a5$var$entryPointParams);
        const buttonTrigger = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(entryPointActions);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            ...buttonProps,
            ref: buttonTrigger
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivDCs")).ModalEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jira-premium-upgrade-modal",
            packageName: "jiraPremiumUpgradeModal",
            errorFallback: "flag",
            runtimeProps: {
                onClose: entryPointActions.unload
            },
            entryPointActions: entryPointActions
        }));
    };
});
parcelRegister("b3Gth", function(module, exports) {
    $parcel$export(module.exports, "entryPointPremiumUpgradeModal", ()=>$a50fd4829307668f$export$7116d5b1a93db8d6);
    var $eufEc;
    var $fEDBv;
    const $a50fd4829307668f$export$7116d5b1a93db8d6 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("b2b81")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
            moduleId: "1102b440"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("b2b81", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("5azfZ")
    ]).then(()=>parcelRequire('5s8iH'));
});
parcelRegister("iIz7a", function(module, exports) {
    $parcel$export(module.exports, "FeatureGateLogo", ()=>$bde809f68e5981c8$export$83d4ce06fb8c3c0);
    var $5uXOq = parcelRequire("5uXOq");
    var $5qRwM;
    var $bsqOw = parcelRequire("bsqOw");
    var $4pbFL = parcelRequire("4pbFL");
    const $bde809f68e5981c8$export$83d4ce06fb8c3c0 = ({ colorMode: colorMode, alt: alt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5qRwM")).default), {
            src: colorMode === 'dark' ? (0, ($parcel$interopDefault($bsqOw))) : (0, ($parcel$interopDefault($4pbFL))),
            alt: alt
        });
});
parcelRegister("bsqOw", function(module, exports) {
    module.exports = new URL("plans-standard-dark.fce82c99.svg", import.meta.url).toString();
});
parcelRegister("4pbFL", function(module, exports) {
    module.exports = new URL("plans-standard-light.fde35b0d.svg", import.meta.url).toString();
});
parcelRegister("gblI8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ba9ec5dc8deac7d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9ba9ec5dc8deac7d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "atlassian-navigation.plans.menu.premium-feature-gate.title",
            "defaultMessage": "Unlock advanced planning tools"
        },
        imageAlt: {
            "id": "atlassian-navigation.plans.menu.premium-feature-gate.image-alt",
            "defaultMessage": "Upgrade to Jira Premium"
        },
        description: {
            "id": "atlassian-navigation.plans.menu.premium-feature-gate.description",
            "defaultMessage": "Boost agility with capacity planning, dependency mapping, and more. Try Jira Premium's high-level cross-team planning tools."
        },
        learnMoreLink: {
            "id": "atlassian-navigation.plans.menu.premium-feature-gate.learn-more-link",
            "defaultMessage": "Read the guide"
        },
        startTrialButton: {
            "id": "atlassian-navigation.plans.menu.premium-feature-gate.start-trial-button",
            "defaultMessage": "Try it free"
        }
    });
});
parcelRegister("jUDIz", function(module, exports) {
    $parcel$export(module.exports, "FlyoutMenuItem", ()=>$ffd758778f838162$export$34e3b4eaa687835);
    var $5uXOq = parcelRequire("5uXOq");
    var $33etG;
    var $iUFLC;
    var $aV1jL;
    const $ffd758778f838162$export$34e3b4eaa687835 = ({ children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: isDefaultOpen = false, onOpenChange: onOpenChange })=>{
        const [isOpen, setIsOpen] = (0, (0, parcelRequire("33etG")).default)(isOpenControlled, ()=>isDefaultOpen);
        (0, $5uXOq.useEffect)(()=>{
            onOpenChange?.(isOpen);
        }, [
            isOpen,
            onOpenChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aV1jL")).IsOpenContext).Provider, {
            value: isOpen
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aV1jL")).SetIsOpenContext).Provider, {
            value: setIsOpen
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iUFLC")).Popup), {
            id: id,
            isOpen: isOpen
        }, children)));
    };
});
parcelRegister("iUFLC", function(module, exports) {
    $parcel$export(module.exports, "Popup", ()=>$822df708b53543f9$export$129a32eedafa97c5);
    $parcel$export(module.exports, "PopupTrigger", ()=>$822df708b53543f9$export$95d4acdbab2fc6ef);
    $parcel$export(module.exports, "PopupContent", ()=>$822df708b53543f9$export$2a2c7ba12d3231e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $3joPi = parcelRequire("3joPi");
    var $eGmKJ;
    var $9KnKW;
    var $9MHPe;
    var $9Mkr0;
    var $gkD4s;
    var $1V7PR;
    var $k8nZq;
    var $k5uoT;
    var $jIMB4;
    var $hdHM8;
    var $jLapR;
    const $822df708b53543f9$var$IsOpenContext = (0, $5uXOq.createContext)(false);
    const $822df708b53543f9$var$IdContext = (0, $5uXOq.createContext)(undefined);
    const $822df708b53543f9$var$TriggerRefContext = (0, $5uXOq.createContext)(null);
    const $822df708b53543f9$var$SetTriggerRefContext = (0, $5uXOq.createContext)((0, (0, parcelRequire("eGmKJ")).default));
    const $822df708b53543f9$var$EnsureIsInsidePopupContext = (0, $5uXOq.createContext)(false);
    const $822df708b53543f9$var$useEnsureIsInsidePopup = ()=>{
        const context = (0, $5uXOq.useContext)($822df708b53543f9$var$EnsureIsInsidePopupContext);
        (0, $3joPi.default)(context, 'PopupTrigger and PopupContent components must be used within a Popup');
    };
    const $822df708b53543f9$export$129a32eedafa97c5 = ({ children: children, id: providedId, isOpen: isOpen = false })=>{
        const [triggerRef, setTriggerRef] = (0, $5uXOq.useState)(null);
        const generatedId = (0, (0, parcelRequire("9KnKW")).useId)();
        const id = providedId || generatedId;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($822df708b53543f9$var$EnsureIsInsidePopupContext.Provider, {
            value: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($822df708b53543f9$var$IdContext.Provider, {
            value: id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($822df708b53543f9$var$TriggerRefContext.Provider, {
            value: triggerRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($822df708b53543f9$var$SetTriggerRefContext.Provider, {
            value: setTriggerRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($822df708b53543f9$var$IsOpenContext.Provider, {
            value: isOpen
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gkD4s")).Manager), null, children))))));
    };
    const $822df708b53543f9$export$95d4acdbab2fc6ef = ({ children: children })=>{
        $822df708b53543f9$var$useEnsureIsInsidePopup();
        const isOpen = (0, $5uXOq.useContext)($822df708b53543f9$var$IsOpenContext);
        const id = (0, $5uXOq.useContext)($822df708b53543f9$var$IdContext);
        const setTriggerRef = (0, $5uXOq.useContext)($822df708b53543f9$var$SetTriggerRefContext);
        const getMergedTriggerRef = (0, (0, parcelRequire("jLapR")).useGetMemoizedMergedTriggerRef)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1V7PR")).Reference), null, ({ ref: ref })=>children({
                ref: getMergedTriggerRef(ref, setTriggerRef, isOpen),
                'aria-controls': id,
                'aria-expanded': isOpen,
                'aria-haspopup': true
            }));
    };
    const $822df708b53543f9$var$defaultLayer = (0, (0, parcelRequire("k5uoT")).layers).layer();
    const $822df708b53543f9$var$shouldDisableGpuAccelerationModifiers = [
        {
            name: 'computeStyles',
            options: {
                gpuAcceleration: false
            }
        }
    ];
    const $822df708b53543f9$export$2a2c7ba12d3231e3 = ({ xcss: xcss, appearance: inAppearance = 'default', children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: autoFocus = true, zIndex: zIndex = $822df708b53543f9$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, shouldDisableGpuAcceleration: shouldDisableGpuAcceleration = false })=>{
        $822df708b53543f9$var$useEnsureIsInsidePopup();
        const isOpen = (0, $5uXOq.useContext)($822df708b53543f9$var$IsOpenContext);
        const id = (0, $5uXOq.useContext)($822df708b53543f9$var$IdContext);
        const triggerRef = (0, $5uXOq.useContext)($822df708b53543f9$var$TriggerRefContext);
        const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, (0, parcelRequire("hdHM8")).usePopupAppearance)({
            appearance: inAppearance,
            shouldRenderToParent: inShouldRenderToParent
        });
        (0, (0, parcelRequire("9Mkr0")).useNotifyOpenLayerObserver)({
            isOpen: isOpen
        });
        if (!isOpen) return null;
        const popperWrapper = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MHPe")).Layering), {
            isDisabled: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jIMB4")).default), {
            xcss: xcss,
            appearance: appearance,
            content: children,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: popupComponent,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldFitContainer: shouldFitContainer,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent,
            shouldDisableFocusLock: shouldDisableFocusLock,
            triggerRef: triggerRef,
            strategy: strategy,
            shouldFitViewport: shouldFitViewport,
            modifiers: shouldDisableGpuAcceleration ? $822df708b53543f9$var$shouldDisableGpuAccelerationModifiers : undefined
        }));
        if (shouldRenderToParent) return popperWrapper;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k8nZq")).default), {
            zIndex: zIndex
        }, popperWrapper);
    };
});
parcelRegister("17aWz", function(module, exports) {
    $parcel$export(module.exports, "FlyoutMenuItemContent", ()=>$260a0085e2df9f2c$export$2ca9a13c57a8839a);
    var $5uXOq = parcelRequire("5uXOq");
    var $iUFLC;
    var $aV1jL;
    const $260a0085e2df9f2c$var$flyoutMenuItemContentStyles = {
        root: "_1yt4u2gc _14b51gwv"
    };
    const $260a0085e2df9f2c$export$2ca9a13c57a8839a = (0, $5uXOq.forwardRef)(({ children: children, containerTestId: containerTestId, onClose: onClose }, forwardedRef)=>{
        const setIsOpen = (0, $5uXOq.useContext)((0, (0, parcelRequire("aV1jL")).SetIsOpenContext));
        const handleClose = (0, $5uXOq.useCallback)(()=>{
            onClose?.();
            setIsOpen(false);
        }, [
            setIsOpen,
            onClose
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iUFLC")).PopupContent), {
            appearance: "UNSAFE_modal-below-sm",
            onClose: handleClose,
            placement: "right-start",
            shouldFitViewport: true,
            testId: containerTestId,
            xcss: $260a0085e2df9f2c$var$flyoutMenuItemContentStyles.root,
            shouldDisableGpuAcceleration: true
        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: forwardedRef
            }, children));
    });
});
parcelRegister("lBNLs", function(module, exports) {
    $parcel$export(module.exports, "FlyoutMenuItemTrigger", ()=>$d5ca4c545cb9ae15$export$9f59f399fe37b6ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $3dGN0;
    var $iUFLC;
    var $dC5iT;
    var $fdP8o;
    var $1qQhw;
    const $d5ca4c545cb9ae15$export$9f59f399fe37b6ca = (0, $5uXOq.forwardRef)(({ children: children, iconBefore: iconBefore, onClick: onClick, isDisabled: isDisabled, isSelected: isSelected, interactionName: interactionName, testId: testId, isContentTooltipDisabled: isContentTooltipDisabled }, forwardedRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iUFLC")).PopupTrigger), null, ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fdP8o")).MenuItemBase), {
                testId: testId,
                ref: (0, (0, parcelRequire("5JjdN")).default)([
                    ref,
                    forwardedRef
                ]),
                elemBefore: iconBefore,
                elemAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    paddingInline: "space.075"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3dGN0"))))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })),
                onClick: onClick,
                ariaControls: ariaControls,
                ariaExpanded: ariaExpanded,
                ariaHasPopup: ariaHasPopup,
                isDisabled: isDisabled,
                interactionName: interactionName,
                isContentTooltipDisabled: isContentTooltipDisabled,
                isSelected: isSelected
            }, children))));
});
parcelRegister("3nmOf", function(module, exports) {
    $parcel$export(module.exports, "Nav4Projects", ()=>$f8e01865477e7c50$export$5baf9fa0c4742f3f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lwsjn;
    var $l8ruj;
    const $f8e01865477e7c50$export$5baf9fa0c4742f3f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-projects"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "projects-section",
            packageName: (0, $4e61701b07fca41a$export$b8b9d90f9e5bd72b),
            teamName: (0, $4e61701b07fca41a$export$d57b6b390e78d90f)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lwsjn")).Nav4Projects), props)));
});
parcelRegister("lwsjn", function(module, exports) {
    $parcel$export(module.exports, "Nav4Projects", ()=>$68918da9ad272fce$export$5baf9fa0c4742f3f);
    var $1634p;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jhS4y;
    var $c6x3L;
    var $fzcoo;
    var $QXHTz;
    var $8syLG;
    function $68918da9ad272fce$export$5baf9fa0c4742f3f({ isExpanded: isExpanded, queryRef: queryRef }) {
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("1634p")).default), queryRef);
        const { isInitialSelectedPath: isInitialSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const canCreateProject = !!data?.jira?.canCreateProject;
        const actionButtons = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fzcoo")).ActionButtons), {
            canCreateProject: canCreateProject
        });
        return isInitialSelectedPath((0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS)) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8syLG")).Nav4ProjectsForLanding), {
            actionsOnHover: actionButtons,
            isExpanded: isExpanded,
            queryRef: data
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("QXHTz")).Nav4ProjectsDefault), {
            actionsOnHover: actionButtons,
            isExpanded: isExpanded
        });
    }
});
parcelRegister("1634p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cf369e5549cfa857$export$2e2bcd8739ae039);
    const $cf369e5549cfa857$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "isProjectsExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Projects",
        "selections": [
            {
                "condition": "isProjectsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4ProjectsForLanding"
                    }
                ]
            },
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "alias": "canCreateProject",
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "CREATE_PROJECT"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "canPerform"
                    }
                ]
            }
        ],
        "type": "Query"
    };
    $cf369e5549cfa857$var$node.hash = "82f2e75eda840a347e0f322cf6e2dade";
    var $cf369e5549cfa857$export$2e2bcd8739ae039 = $cf369e5549cfa857$var$node;
});
parcelRegister("fzcoo", function(module, exports) {
    $parcel$export(module.exports, "ActionButtons", ()=>$47193506b60deede$export$88c65d2d98aab183);
    var $5uXOq = parcelRequire("5uXOq");
    var $epOG5;
    var $dIWbq;
    var $3Z96c;
    var $eZUJu;
    var $9UCCQ;
    var $3bDjY;
    var $Mp6qH;
    var $koVbs;
    var $4OlXf;
    var $fNJRN;
    var $hUpXm;
    var $46Cti;
    var $1xonH;
    var $9eeFp;
    var $eaKdt;
    var $aCS3f;
    var $e9QkH;
    var $7uwUx;
    function $47193506b60deede$export$88c65d2d98aab183({ onClose: onClose, canCreateProject: canCreateProject }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [, { on: openProjectCreateDrawer }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("Mp6qH")).MODAL_ID).PROJECT_CREATE);
        const { sendMeatBallDropDownAnalyticsEvent: sendMeatBallDropDownAnalyticsEvent, sendCreateProjectAnalyticsEvent: sendCreateProjectAnalyticsEvent } = (0, (0, parcelRequire("fNJRN")).useProjectsAnalyticsL1)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, canCreateProject ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("7uwUx")).default).createProject)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xonH")).CommonNavMenuButton), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("dIWbq"))))),
            label: formatMessage((0, (0, parcelRequire("7uwUx")).default).createProject),
            onClick: ()=>{
                openProjectCreateDrawer();
                sendCreateProjectAnalyticsEvent();
            }
        })) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            onOpen: ()=>{
                sendMeatBallDropDownAnalyticsEvent();
            },
            MenuItems: $47193506b60deede$var$MoreMenuItems,
            onClose: onClose
        }));
    }
    function $47193506b60deede$var$MoreMenuItems({ onClose: onClose }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const href = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("4OlXf")).getProjectsNavigationPaths)().projectsViewProjects, []);
        const { sendMeatBallDropDownManageProjectsAnalyticsEvent: sendMeatBallDropDownManageProjectsAnalyticsEvent } = (0, (0, parcelRequire("hUpXm")).useProjectsAnalyticsL2)();
        const onCloseWithStopPropagation = (0, (0, parcelRequire("9eeFp")).useStopPropagation)((e)=>{
            sendMeatBallDropDownManageProjectsAnalyticsEvent();
            onClose?.(e);
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            isList: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("epOG5"))))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            href: href,
            onClick: onCloseWithStopPropagation
        }, formatMessage((0, (0, parcelRequire("7uwUx")).default).manageProjects))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaKdt")).HideL1MenuItemSection), {
            menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS
        }));
    }
});
parcelRegister("4OlXf", function(module, exports) {
    $parcel$export(module.exports, "getProjectsNavigationPaths", ()=>$318f62ba2cbc5bcb$export$5b37488a9fd89879);
    const $318f62ba2cbc5bcb$export$5b37488a9fd89879 = ()=>({
            projectsViewProjects: '/jira/settings/projects/manage',
            projectsViewCategories: '/secure/admin/projectcategories/ViewProjectCategories!default.jspa',
            projectsTrashedProjects: '/jira/settings/projects/trash',
            projectsArchivedProjects: '/jira/settings/projects/archive'
        });
});
parcelRegister("fNJRN", function(module, exports) {
    $parcel$export(module.exports, "useProjectsAnalyticsL1", ()=>$4b3d1af28d24ea21$export$7d9a1a79b1bd1338);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $aTtGi;
    const $4b3d1af28d24ea21$export$7d9a1a79b1bd1338 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const commonAttributes = (0, $5uXOq.useMemo)(()=>({
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22)
            }), []);
        const sendViewAllProjectsAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            });
            const attributes = {
                ...commonAttributes,
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: 'viewAllProjects'
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
        }, [
            commonAttributes,
            createAnalyticsEvent
        ]);
        const sendMeatBallDropDownAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
            });
            const attributes = {
                ...commonAttributes,
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
        }, [
            commonAttributes,
            createAnalyticsEvent
        ]);
        const sendCreateProjectAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
            });
            const attributes = {
                ...commonAttributes,
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: 'createProject'
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
        }, [
            commonAttributes,
            createAnalyticsEvent
        ]);
        const sendProjectMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ starred: starred, recent: recent, projectId: projectId, projectType: projectType })=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            });
            const attributes = {
                ...commonAttributes,
                componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                itemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
                itemId: projectId,
                projectType: projectType,
                section: (0, (0, parcelRequire("aTtGi")).getSectionByStarredOrRecent)({
                    starred: starred,
                    recent: recent
                })
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
        }, [
            commonAttributes,
            createAnalyticsEvent
        ]);
        return {
            sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent,
            sendMeatBallDropDownAnalyticsEvent: sendMeatBallDropDownAnalyticsEvent,
            sendCreateProjectAnalyticsEvent: sendCreateProjectAnalyticsEvent,
            sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent
        };
    };
});
parcelRegister("aTtGi", function(module, exports) {
    $parcel$export(module.exports, "getSectionByStarredOrRecent", ()=>$085f7c8df53a9d4d$export$542854f16c0127e7);
    var $jecJ3;
    const $085f7c8df53a9d4d$export$542854f16c0127e7 = ({ starred: starred, recent: recent })=>{
        if (starred) return 0, (0, parcelRequire("jecJ3")).SECTION_ITEM_STARRED;
        if (recent) return 0, (0, parcelRequire("jecJ3")).SECTION_ITEM_RECENT;
        return '';
    };
});
parcelRegister("hUpXm", function(module, exports) {
    $parcel$export(module.exports, "useProjectsAnalyticsL2", ()=>$d51064a0c3301a50$export$1e04fadc2cea284c);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $aTtGi;
    const $d51064a0c3301a50$export$1e04fadc2cea284c = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const commonAttributes = (0, $5uXOq.useMemo)(()=>({
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
            }), []);
        const sendMeatBallDropDownManageProjectsAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
            });
            const attributes = {
                ...commonAttributes,
                componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                itemId: 'manageProjects',
                parentItemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
        }, [
            commonAttributes,
            createAnalyticsEvent
        ]);
        const sendBoardNavigationItemInsideProjectsAnalyticsEvent = (0, $5uXOq.useCallback)(({ boardId: boardId, projectId: projectId, recent: recent, starred: starred, projectType: projectType })=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            });
            const attributes = {
                ...commonAttributes,
                componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                itemId: boardId,
                itemType: (0, $632bd8725b437a12$export$9b8283d5878d2491),
                parentItemId: projectId,
                parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
                projectType: projectType,
                section: (0, (0, parcelRequire("aTtGi")).getSectionByStarredOrRecent)({
                    starred: starred,
                    recent: recent
                })
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
        }, [
            commonAttributes,
            createAnalyticsEvent
        ]);
        const getMeatBallDropDownOnProjectsAnalytics = (0, $5uXOq.useCallback)(({ recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
            return {
                ...commonAttributes,
                actionSubjectId: (0, $d59b407ab907bf7b$export$8d155d2412839524),
                componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
                itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e),
                parentItemId: projectId,
                parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
                projectType: projectType,
                section: (0, (0, parcelRequire("aTtGi")).getSectionByStarredOrRecent)({
                    starred: starred,
                    recent: recent
                })
            };
        }, [
            commonAttributes
        ]);
        const sendMeatBallDropDownOnProjectsAnalyticsEvent = (0, $5uXOq.useCallback)((params)=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
            });
            const { actionSubjectId: actionSubjectId, ...attributes } = getMeatBallDropDownOnProjectsAnalytics(params);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, actionSubjectId, attributes);
        }, [
            createAnalyticsEvent,
            getMeatBallDropDownOnProjectsAnalytics
        ]);
        const sendCreateBoardOnBoardMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
            });
            const attributes = {
                ...commonAttributes,
                componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
                itemId: 'createBoard',
                parentItemId: projectId,
                parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
                projectType: projectType,
                section: (0, (0, parcelRequire("aTtGi")).getSectionByStarredOrRecent)({
                    starred: starred,
                    recent: recent
                })
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
        }, [
            commonAttributes,
            createAnalyticsEvent
        ]);
        const sendViewAllBoardsAnalyticsEvent = (0, $5uXOq.useCallback)(({ projectId: projectId, projectType: projectType })=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            });
            const attributes = {
                ...commonAttributes,
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: 'viewAllBoards',
                parentItemId: projectId,
                parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
                projectType: projectType
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
        }, [
            commonAttributes,
            createAnalyticsEvent
        ]);
        return {
            sendMeatBallDropDownManageProjectsAnalyticsEvent: sendMeatBallDropDownManageProjectsAnalyticsEvent,
            sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent,
            sendBoardNavigationItemInsideProjectsAnalyticsEvent: sendBoardNavigationItemInsideProjectsAnalyticsEvent,
            sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent,
            sendViewAllBoardsAnalyticsEvent: sendViewAllBoardsAnalyticsEvent
        };
    };
});
const $d59b407ab907bf7b$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $d59b407ab907bf7b$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';
parcelRegister("7uwUx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$865591b1f83edfae$export$2e2bcd8739ae039);
    var $7VHMR;
    var $865591b1f83edfae$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createProject: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.create-project",
            "defaultMessage": "Create project"
        },
        manageProjects: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.manage-projects",
            "defaultMessage": "Manage projects"
        }
    });
});
parcelRegister("QXHTz", function(module, exports) {
    $parcel$export(module.exports, "Nav4ProjectsDefault", ()=>$8547587d73014b07$export$373934ae259d74df);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $jecJ3;
    var $jhS4y;
    var $aGONy;
    var $46Cti;
    var $c16H2;
    var $338xa;
    var $dQbFB;
    var $eQV8d;
    var $dUyqZ;
    var $4zcxJ;
    var $koeKL;
    var $lnznH;
    var $cZa9B;
    var $bWLzw;
    var $krpZe;
    function $8547587d73014b07$export$373934ae259d74df(props) {
        const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, simulateLoading: simulateLoading = false } = props;
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const currentURL = (0, (0, parcelRequire("aGONy")).useGetCurrentUrl)();
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                currentURL: currentURL
            }), [
            cloudId,
            currentURL
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("krpZe")).asyncNav4ProjectsContentViewQuery), entryPointParams);
        const triggerRef = (0, (0, parcelRequire("4zcxJ")).useExpandableEntryPointTrigger)(entryPointActions);
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS);
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        (0, $5uXOq.useEffect)(()=>{
            if (isExpanded) entryPointActions.load();
        }, [
            entryPointActions,
            isExpanded
        ]);
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: menuId,
            onSystemToggle: (hasExpanded)=>{
                if (hasExpanded) entryPointActions.load();
            },
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) {
                    entryPointActions.load();
                    sendSectionItemAnalyticsEvent({
                        menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS,
                        sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_PROJECTS)
                    });
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            interactionName: "nav4-sidebar-projects-default",
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            ref: triggerRef,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, simulateLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-projects-default",
            packageName: (0, $4e61701b07fca41a$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $4e61701b07fca41a$export$d57b6b390e78d90f),
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null),
            runtimeProps: entryPointParams
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWLzw")).Footer), null)));
    }
});
const $4e61701b07fca41a$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Projects';
const $4e61701b07fca41a$export$d57b6b390e78d90f = 'jira-cosmos';
const $4e61701b07fca41a$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
parcelRegister("bWLzw", function(module, exports) {
    $parcel$export(module.exports, "Footer", ()=>$e368b38fa5e093fd$export$a06f1c675e846f6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $fNJRN;
    var $jhS4y;
    var $34PKs;
    var $foR3E;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    var $59fBA;
    const $e368b38fa5e093fd$var$VIEW_ALL_PROJECTS_HREF = (0, (0, parcelRequire("foR3E")).projectsDirectoryRoute).path;
    function $e368b38fa5e093fd$export$a06f1c675e846f6f() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent } = (0, (0, parcelRequire("fNJRN")).useProjectsAnalyticsL1)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("34PKs")).ViewAllEntityMenuItem), {
            onClick: ()=>{
                sendViewAllProjectsAnalyticsEvent();
            },
            href: $e368b38fa5e093fd$var$VIEW_ALL_PROJECTS_HREF,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS_VIEW_ALL)
        }, formatMessage((0, (0, parcelRequire("59fBA")).default).viewAllProjects)))));
    }
});
parcelRegister("59fBA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db103a2a10f2ba8d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $db103a2a10f2ba8d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewAllProjects: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.view-all-projects",
            "defaultMessage": "View all projects"
        }
    });
});
parcelRegister("krpZe", function(module, exports) {
    $parcel$export(module.exports, "asyncNav4ProjectsContentViewQuery", ()=>$2be41113a8ef5aa9$export$e22bacdc9273cba3);
    var $4Hv8l;
    var $eufEc;
    var $fEDBv;
    const $2be41113a8ef5aa9$export$e22bacdc9273cba3 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("2wAPa")).then(({ Nav4ProjectsContentViewQuery: Nav4ProjectsContentViewQuery })=>Nav4ProjectsContentViewQuery), {
            moduleId: "90670c8d",
            moduleName: "Nav4ProjectsContentViewQuery"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                queries: {
                    projects: {
                        parameters: (0, parcelRequire("4Hv8l")).default,
                        variables: {
                            cloudId: cloudId
                        }
                    }
                }
            })
    });
});
parcelRegister("4Hv8l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e314997e36328d05$export$2e2bcd8739ae039);
    const $e314997e36328d05$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v3 = {
            "kind": "ScalarField",
            "name": "id"
        }, v4 = {
            "kind": "InlineFragment",
            "selections": [
                v3
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v5 = [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ], v6 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v7 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v8 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v2,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3,
                            {
                                "alias": "projectKey",
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectType"
                            },
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "large"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            },
                            {
                                "kind": "LinkedField",
                                "name": "defaultNavigationItem",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "typeKey"
                                            }
                                        ],
                                        "type": "JiraNavigationItem",
                                        "abstractKey": "__isJiraNavigationItem"
                                    },
                                    v4
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "navigationMetadata",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "boardId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isSimpleBoard"
                                            },
                                            v3
                                        ],
                                        "type": "JiraSoftwareProjectNavigationMetadata"
                                    }
                                ]
                            },
                            {
                                "alias": "editProjectConfig",
                                "args": v5,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v6,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectStyle"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "webUrl"
                            },
                            {
                                "alias": "canEditProjectConfig",
                                "args": v5,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v6,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "alias": "canViewProjectConfig",
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "VIEW_PROJECT_CONFIG"
                                    }
                                ],
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v6,
                                "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                            },
                            v7,
                            {
                                "args": v5,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v6,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "softwareBoardCount"
                            }
                        ],
                        "type": "JiraProject"
                    },
                    v4
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "Nav4ProjectsContentViewQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4ProjectsContent"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "Nav4ProjectsContentViewQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "favouriteProjects",
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "includeArchivedProjects": false,
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "PROJECT"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v8
                                    },
                                    v7
                                ]
                            },
                            {
                                "alias": "recentProjects",
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "includeArchivedProjects": false
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "PROJECT"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v8
                                    },
                                    v7
                                ]
                            },
                            {
                                "args": [
                                    v1
                                ],
                                "concreteType": "JiraWorkManagementLicensing",
                                "kind": "LinkedField",
                                "name": "jwmLicensing",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "currentUserSeatEdition"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "GrowthRecQuery",
                        "kind": "LinkedField",
                        "name": "growthRecommendations",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "fields": [
                                            {
                                                "kind": "Literal",
                                                "name": "product",
                                                "value": "jira"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "tenantId",
                                                "variableName": "cloudId"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "useCase",
                                                "value": "jiraProjectMenuRecommendations"
                                            }
                                        ],
                                        "kind": "ObjectValue",
                                        "name": "context"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 2
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "recommendations",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "data",
                                                "plural": true,
                                                "selections": [
                                                    v2,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "entityId"
                                                            }
                                                        ],
                                                        "type": "GrowthRecJiraTemplateRecommendation"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "GrowthRecRecommendations"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "c54df03be7937304759ed2b6aca2d35df7f19656b82c0e604482d80c3097a29e",
                "metadata": {},
                "name": "Nav4ProjectsContentViewQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $e314997e36328d05$var$node.hash = "3d4f530c66b1607882e480a63bc3edc6";
    var $e314997e36328d05$export$2e2bcd8739ae039 = $e314997e36328d05$var$node;
});
parcelRegister("2wAPa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7RSYT").then(()=>parcelRequire('6Hnkk'));
});
parcelRegister("8syLG", function(module, exports) {
    $parcel$export(module.exports, "Nav4ProjectsForLanding", ()=>$34b8fcf67bf73580$export$8c948b59812f90e9);
    var $j4EOM;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $7CMCs;
    var $jecJ3;
    var $jhS4y;
    var $46Cti;
    var $c16H2;
    var $dQbFB;
    var $eQV8d;
    var $dUyqZ;
    var $jcSAX;
    var $l8ruj;
    var $lnznH;
    var $cZa9B;
    var $bWLzw;
    function $34b8fcf67bf73580$export$8c948b59812f90e9(props) {
        const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS);
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("j4EOM")).default), queryRef);
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: menuId,
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) sendSectionItemAnalyticsEvent({
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS,
                    sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_PROJECTS)
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-projects-landing"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "nav4-sidebar-projects-landing",
            packageName: (0, $4e61701b07fca41a$export$b8b9d90f9e5bd72b),
            teamName: (0, $4e61701b07fca41a$export$d57b6b390e78d90f),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jcSAX")).Nav4ProjectsContent), {
            queryRef: data
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWLzw")).Footer), null)));
    }
});
parcelRegister("j4EOM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea186c046425d9b2$export$2e2bcd8739ae039);
    const $ea186c046425d9b2$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4ProjectsForLanding",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "Nav4ProjectsContent"
            }
        ],
        "type": "Query"
    };
    $ea186c046425d9b2$var$node.hash = "4d3bdf6d5d5d912aac0901d592694d15";
    var $ea186c046425d9b2$export$2e2bcd8739ae039 = $ea186c046425d9b2$var$node;
});
parcelRegister("jcSAX", function(module, exports) {
    $parcel$export(module.exports, "Nav4ProjectsContent", ()=>$610b3e666862e79d$export$74ce18a8a4837259);
    var $73EMs;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $i8Qvm;
    var $5NM6P;
    var $6Lyip;
    var $4R6GH;
    var $koVbs;
    var $e4A2P;
    var $jhS4y;
    var $c6x3L;
    var $9Gyp5;
    var $5FnJJ;
    var $gxbcq;
    var $1b6zA;
    var $gKabe;
    var $aq8kS;
    var $4iaU1;
    var $hohDO;
    var $dWDWP;
    var $koeKL;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    var $2CQvU;
    var $7nWhn;
    const $610b3e666862e79d$var$MAX_RECENT_PROJECTS = 5;
    const $610b3e666862e79d$export$4319a8d1db123861 = 15;
    const $610b3e666862e79d$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
    function $610b3e666862e79d$export$74ce18a8a4837259({ queryRef: queryRef }) {
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { getStableItems: getStableItems } = (0, (0, parcelRequire("1b6zA")).useStableItems)();
        const { isSelectedPath: isSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const [projectToRestore, setProjectToRestore] = (0, $5uXOq.useState)(null);
        const [{ jira: { favouriteProjects: favouriteProjects, recentProjects: recentProjects, jwmLicensing: jwmLicensing }, growthRecommendations: growthRecommendations }, refetch] = (0, $8Uumt.useRefetchableFragment)((0, (0, parcelRequire("73EMs")).default), queryRef);
        (0, (0, parcelRequire("9Gyp5")).useRefetchWhenIsSelected)({
            cloudId: cloudId,
            isSelectedPath: isSelectedPath,
            QUERY: (0, parcelRequire("dWDWP")).default,
            refetch: refetch,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS)
        });
        const refetchOnChange = (0, $5uXOq.useCallback)(({ onComplete: onComplete })=>{
            refetch({
                cloudId: cloudId
            }, {
                fetchPolicy: 'store-and-network',
                onComplete: onComplete
            });
        }, [
            cloudId,
            refetch
        ]);
        (0, (0, parcelRequire("gxbcq")).useSubscribeAndUpdateFavorites)({
            entityTypename: 'JiraProject',
            favouriteConnectionId: favouriteProjects.__id,
            recentConnectionId: recentProjects.__id,
            refetch: refetchOnChange
        });
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const starred = formatMessage((0, (0, parcelRequire("7nWhn")).default).starred);
        const recent = formatMessage((0, (0, parcelRequire("7nWhn")).default).recent);
        const favorites = (0, $5uXOq.useMemo)(()=>{
            const ids = favouriteProjects.edges?.map((edge)=>edge?.node.id).filter(Boolean) ?? [];
            const list = favouriteProjects.edges?.filter(Boolean).map((edge)=>{
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4iaU1")).Nav4ProjectMenuItem), {
                    key: edge.node.projectKey,
                    queryRef: edge.node,
                    isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === 'PREMIUM',
                    setProjectToRestore: setProjectToRestore,
                    spotlight: edge.node.id === ids[0] ? (0, (0, parcelRequire("5NM6P")).Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT : undefined
                });
            }) ?? [];
            return {
                idSet: new Set(ids),
                list: list.slice(0, $610b3e666862e79d$export$4319a8d1db123861),
                hasItems: Boolean(list.length),
                hasNextPage: favouriteProjects.pageInfo?.hasNextPage || list.length > $610b3e666862e79d$export$4319a8d1db123861
            };
        }, [
            favouriteProjects,
            jwmLicensing
        ]);
        const recentItems = (0, $5uXOq.useMemo)(()=>{
            const nodes = recentProjects.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, $610b3e666862e79d$var$MAX_RECENT_PROJECTS) ?? [];
            const stableOrderedNodes = getStableItems({
                nodes: nodes,
                idKey: 'id'
            });
            const firstItemKey = stableOrderedNodes[0]?.projectKey;
            const list = stableOrderedNodes.map((node)=>{
                const showSpotlight = !favorites.hasItems && node.projectKey === firstItemKey;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4iaU1")).Nav4ProjectMenuItem), {
                    key: node.projectKey,
                    queryRef: node,
                    isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === 'PREMIUM',
                    setProjectToRestore: setProjectToRestore,
                    spotlight: showSpotlight ? (0, (0, parcelRequire("5NM6P")).Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT : undefined
                });
            });
            return {
                list: list,
                hasItems: Boolean(list.length)
            };
        }, [
            recentProjects.edges,
            getStableItems,
            favorites.idSet,
            jwmLicensing?.currentUserSeatEdition,
            favorites.hasItems
        ]);
        const recommendations = (0, $5uXOq.useMemo)(()=>{
            const appRecommendations = growthRecommendations?.recommendations?.data?.map((item)=>item.entityId).filter(Boolean) ?? [];
            return appRecommendations.length > 0 && (0, (0, parcelRequire("4R6GH")).fg)('blu-3929-sidebar-menu-recommended') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gKabe")).Recommendations), {
                appRecommendations: appRecommendations
            }) : null;
        }, [
            growthRecommendations?.recommendations?.data
        ]);
        const restoreProjectModal = (0, $5uXOq.useCallback)(()=>{
            if (projectToRestore) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hohDO")).default), {
                ...projectToRestore,
                onProjectRestoreSuccess: ()=>{
                    setProjectToRestore(null);
                    refetch({
                        cloudId: cloudId
                    }, {
                        fetchPolicy: 'store-and-network'
                    });
                },
                onProjectRestoreFailure: ()=>{
                    setProjectToRestore(null);
                },
                onClose: ()=>setProjectToRestore(null)
            }));
        }, [
            cloudId,
            projectToRestore,
            refetch
        ]);
        if (!favorites.hasItems && !recentItems.hasItems) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Lyip")).OnboardingSpotlightMaybe), {
            spotlight: (0, (0, parcelRequire("5NM6P")).Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aq8kS")).Nav4ProjectsEmptyContent), null), recommendations, restoreProjectModal());
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4A2P")).UpdateProjectsProvider), {
            favouriteConnectionId: favouriteProjects.__id,
            recentConnectionId: recentProjects.__id
        }, favorites.hasItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CQvU")).MenuSectionHeading), null, starred), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, favorites.list))), favorites.hasNextPage && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            href: $610b3e666862e79d$var$VIEW_ALL_STARRED_HREF,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS_VIEW_ALL_STARRED)
        }, formatMessage((0, (0, parcelRequire("7nWhn")).default).viewAllStarred))), recentItems.hasItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CQvU")).MenuSectionHeading), null, recent), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, recentItems.list))), recommendations, restoreProjectModal());
    }
});
parcelRegister("73EMs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0cd0ab2a500c3f5$export$2e2bcd8739ae039);
    var $dWDWP;
    const $c0cd0ab2a500c3f5$var$node = function() {
        var v0 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v1 = {
            "kind": "ScalarField",
            "name": "id"
        }, v2 = {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        }, v3 = {
            "kind": "FragmentSpread",
            "name": "Nav4ProjectMenuItem"
        }, v4 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "cloudId"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "currentURL"
                }
            ],
            "kind": "Fragment",
            "metadata": {
                "refetch": {
                    "fragmentPathInResult": [],
                    "operation": (0, (0, parcelRequire("dWDWP")).default)
                }
            },
            "name": "Nav4ProjectsContent",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v0,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "includeArchivedProjects": false,
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "PROJECT"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v1,
                                                                        "action": "THROW",
                                                                        "path": "jira.favouriteProjects.edges.node.id"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v2,
                                                                        "action": "THROW",
                                                                        "path": "jira.favouriteProjects.edges.node.projectKey"
                                                                    },
                                                                    v3
                                                                ],
                                                                "type": "JiraProject"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.favouriteProjects.edges.node"
                                                }
                                            ]
                                        },
                                        v4
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.favouriteProjects"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "recentProjects",
                                    "args": [
                                        v0,
                                        {
                                            "kind": "Variable",
                                            "name": "currentURL",
                                            "variableName": "currentURL"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "includeArchivedProjects": false
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 20
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PROJECT"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v1,
                                                                        "action": "THROW",
                                                                        "path": "jira.recentProjects.edges.node.id"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v2,
                                                                        "action": "THROW",
                                                                        "path": "jira.recentProjects.edges.node.projectKey"
                                                                    },
                                                                    v3
                                                                ],
                                                                "type": "JiraProject"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.recentProjects.edges.node"
                                                }
                                            ]
                                        },
                                        v4
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.recentProjects"
                            },
                            {
                                "args": [
                                    v0
                                ],
                                "concreteType": "JiraWorkManagementLicensing",
                                "kind": "LinkedField",
                                "name": "jwmLicensing",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "currentUserSeatEdition"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Literal",
                                            "name": "product",
                                            "value": "jira"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "tenantId",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "useCase",
                                            "value": "jiraProjectMenuRecommendations"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "context"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 2
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "entityId"
                                                        }
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        };
    }();
    $c0cd0ab2a500c3f5$var$node.hash = "8b2dedc24b16febccff422b581357d53";
    var $c0cd0ab2a500c3f5$export$2e2bcd8739ae039 = $c0cd0ab2a500c3f5$var$node;
});
parcelRegister("dWDWP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2cc98d32cef1447c$export$2e2bcd8739ae039);
    const $2cc98d32cef1447c$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "currentURL",
            "variableName": "currentURL"
        }, v2 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = {
            "kind": "ScalarField",
            "name": "id"
        }, v5 = {
            "kind": "InlineFragment",
            "selections": [
                v4
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v6 = [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ], v7 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v8 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v9 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v3,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v4,
                            {
                                "alias": "projectKey",
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectType"
                            },
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "large"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            },
                            {
                                "kind": "LinkedField",
                                "name": "defaultNavigationItem",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "typeKey"
                                            }
                                        ],
                                        "type": "JiraNavigationItem",
                                        "abstractKey": "__isJiraNavigationItem"
                                    },
                                    v5
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "navigationMetadata",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "boardId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isSimpleBoard"
                                            },
                                            v4
                                        ],
                                        "type": "JiraSoftwareProjectNavigationMetadata"
                                    }
                                ]
                            },
                            {
                                "alias": "editProjectConfig",
                                "args": v6,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v7,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectStyle"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "webUrl"
                            },
                            {
                                "alias": "canEditProjectConfig",
                                "args": v6,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v7,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "alias": "canViewProjectConfig",
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "VIEW_PROJECT_CONFIG"
                                    }
                                ],
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v7,
                                "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                            },
                            v8,
                            {
                                "args": v6,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v7,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "softwareBoardCount"
                            }
                        ],
                        "type": "JiraProject"
                    },
                    v5
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "Nav4ProjectsContentQuery",
                "selections": [
                    {
                        "args": [
                            v1
                        ],
                        "kind": "FragmentSpread",
                        "name": "Nav4ProjectsContent"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "Nav4ProjectsContentQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "favouriteProjects",
                                "args": [
                                    v2,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "includeArchivedProjects": false,
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "PROJECT"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v9
                                    },
                                    v8
                                ]
                            },
                            {
                                "alias": "recentProjects",
                                "args": [
                                    v2,
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "includeArchivedProjects": false
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "PROJECT"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v9
                                    },
                                    v8
                                ]
                            },
                            {
                                "args": [
                                    v2
                                ],
                                "concreteType": "JiraWorkManagementLicensing",
                                "kind": "LinkedField",
                                "name": "jwmLicensing",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "currentUserSeatEdition"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "GrowthRecQuery",
                        "kind": "LinkedField",
                        "name": "growthRecommendations",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "fields": [
                                            {
                                                "kind": "Literal",
                                                "name": "product",
                                                "value": "jira"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "tenantId",
                                                "variableName": "cloudId"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "useCase",
                                                "value": "jiraProjectMenuRecommendations"
                                            }
                                        ],
                                        "kind": "ObjectValue",
                                        "name": "context"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 2
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "recommendations",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "data",
                                                "plural": true,
                                                "selections": [
                                                    v3,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "entityId"
                                                            }
                                                        ],
                                                        "type": "GrowthRecJiraTemplateRecommendation"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "GrowthRecRecommendations"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "0e04e32d2f9a42daa1ef8f5bb8b484b703c72855ea44945d81c8ec1ebf7da983",
                "metadata": {},
                "name": "Nav4ProjectsContentQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $2cc98d32cef1447c$var$node.hash = "8b2dedc24b16febccff422b581357d53";
    var $2cc98d32cef1447c$export$2e2bcd8739ae039 = $2cc98d32cef1447c$var$node;
});
parcelRegister("5NM6P", function(module, exports) {
    $parcel$export(module.exports, "Nav4OnboardingComponentNames", ()=>$b94a87b237943b7f$export$f813aeb3fcf8b623);
    $parcel$export(module.exports, "COMPONENT_TAP_TRAIT_MAP", ()=>$b94a87b237943b7f$export$c1a4e03cc30032f5);
    const $b94a87b237943b7f$export$f813aeb3fcf8b623 = {
        GLOBAL_MODAL: 'nav4GlobalOnboardingModal',
        JIRA_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4SidebarToggleOnboardingSpotlight',
        SIDEBAR_PROJECT_SPOTLIGHT: 'nav4SidebarProjectsOnboardingSpotlight',
        TAB_NAV_SPOTLIGHT: 'nav4TabNavigationOnboardingSpotlight',
        ATLAS_GLOBAL_MODAL: 'nav4AtlasGlobalOnboardingModal',
        ATLAS_GLOBAL_MODAL2: 'nav4AtlasGlobalOnboardingModal2'
    };
    const $b94a87b237943b7f$export$c1a4e03cc30032f5 = {
        nav4GlobalOnboardingModal: 'jira-platform_ui_nav4globalonboardingmodal_dismissed_jiraatlassianonboardingnav4_changed',
        nav4SidebarToggleOnboardingSpotlight: 'jira-platform_ui_nav4sidebartoggleonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
        nav4SidebarProjectsOnboardingSpotlight: 'jira-platform_ui_nav4sidebarprojectsonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
        nav4TabNavigationOnboardingSpotlight: 'jira-platform_ui_nav4tabnavigationonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
        nav4AtlasGlobalOnboardingModal: 'townsquare_ui_atlassianhomeonboardingnav4_dismissed_teamcentral_changed'
    };
});
parcelRegister("6Lyip", function(module, exports) {
    $parcel$export(module.exports, "OnboardingSpotlightMaybe", ()=>$ea144642b34a7c1d$export$77e61d078c8501ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Fk4Z;
    var $4R6GH;
    function $ea144642b34a7c1d$export$77e61d078c8501ca({ children: children, spotlight: spotlight }) {
        if (!(0, (0, parcelRequire("4R6GH")).fg)('blu-2735_nav4_onboarding')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return spotlight ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: spotlight
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    }
});
parcelRegister("e4A2P", function(module, exports) {
    $parcel$export(module.exports, "UpdateProjectsProvider", ()=>$ac3747600c671f53$export$a50917f7cd2aeeda);
    $parcel$export(module.exports, "useUpdateProjectsInRelayStoreContext", ()=>$ac3747600c671f53$export$5105901d98bfdbf1);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $4R6GH;
    const $ac3747600c671f53$var$UpdateProjectsContext = (0, $5uXOq.createContext)(null);
    const $ac3747600c671f53$export$c80374615e2c5b2 = ({ environment: environment, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId })=>{
        const removeProjectRecord = (projectDataId)=>{
            (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
                const favorites = store.get(favouriteConnectionId);
                const recents = store.get(recentConnectionId);
                if (favorites && projectDataId) (0, $8Uumt.ConnectionHandler).deleteNode(favorites, projectDataId);
                if (recents && projectDataId) (0, $8Uumt.ConnectionHandler).deleteNode(recents, projectDataId);
            });
        };
        const archiveProject = (projectDataId)=>{
            (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
                store.get(projectDataId)?.setValue('ARCHIVED', 'status');
            });
        };
        return {
            deleteProject: removeProjectRecord,
            archiveProject: (0, (0, parcelRequire("4R6GH")).fg)('blu-4674-filter-out-archive-projects-nav4-sidebar') ? removeProjectRecord : archiveProject
        };
    };
    const $ac3747600c671f53$export$a50917f7cd2aeeda = ({ children: children, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId })=>{
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const updateRelayStore = $ac3747600c671f53$export$c80374615e2c5b2({
            environment: environment,
            favouriteConnectionId: favouriteConnectionId,
            recentConnectionId: recentConnectionId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ac3747600c671f53$var$UpdateProjectsContext.Provider, {
            value: updateRelayStore
        }, children);
    };
    const $ac3747600c671f53$export$5105901d98bfdbf1 = ()=>(0, $5uXOq.useContext)($ac3747600c671f53$var$UpdateProjectsContext);
});
parcelRegister("gKabe", function(module, exports) {
    $parcel$export(module.exports, "Recommendations", ()=>$020c59a125f3184a$export$ebd86fc7badb9a5d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $btuiY;
    const $020c59a125f3184a$export$ebd86fc7badb9a5d = ({ appRecommendations: appRecommendations })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "growth-recommendations",
            fallback: "flag",
            packageName: (0, $6dbca5c36e867ae8$export$b8b9d90f9e5bd72b),
            teamName: (0, $6dbca5c36e867ae8$export$d57b6b390e78d90f)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "recommendations"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("btuiY")).Recommendations), {
            appRecommendations: appRecommendations
        })));
    };
});
const $6dbca5c36e867ae8$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4GrowthRecommendations';
const $6dbca5c36e867ae8$export$d57b6b390e78d90f = 'jira-cosmos';
const $6dbca5c36e867ae8$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
parcelRegister("btuiY", function(module, exports) {
    $parcel$export(module.exports, "Recommendations", ()=>$f6ef8ac59a42f476$export$ebd86fc7badb9a5d);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $koVbs;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    var $2CQvU;
    var $25tyu;
    var $jV5Te;
    var $jl3Bs;
    var $6sbqq;
    const $f6ef8ac59a42f476$var$RecommendationsWithoutFG = ({ appRecommendations: appRecommendations })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { selectedRecommendationState: selectedRecommendationState, dismissRecommendation: dismissRecommendation } = (0, (0, parcelRequire("25tyu")).useSelectedRecommendation)({
            appRecommendations: appRecommendations
        });
        if (selectedRecommendationState?.status !== 'success') return null;
        const selectedRecommendation = (0, (0, parcelRequire("6sbqq")).recommendations).find((recommendation)=>recommendation.key === selectedRecommendationState.recommendationKey);
        return selectedRecommendation && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CQvU")).MenuSectionHeading), null, formatMessage((0, (0, parcelRequire("jl3Bs")).default).sectionTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, (0, ($parcel$interopDefault($5uXOq))).createElement(selectedRecommendation.Component, {
            recommendationKey: selectedRecommendation.key,
            dismissRecommendation: dismissRecommendation
        })))));
    };
    const $f6ef8ac59a42f476$var$RecommendationsWithFG = ({ appRecommendations: appRecommendations })=>{
        const [isDismissed, setIsDismissed] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const selectedRecommendationState = (0, (0, parcelRequire("jV5Te")).useSelectedRecommendationFG)({
            appRecommendations: appRecommendations
        });
        const onDismissRecommendation = (0, $5uXOq.useCallback)(()=>{
            setIsDismissed(true);
        }, []);
        if (!selectedRecommendationState?.recommendationKey) return null;
        const selectedRecommendation = (0, (0, parcelRequire("6sbqq")).recommendationsFG).find((recommendation)=>recommendation.key === selectedRecommendationState.recommendationKey);
        return selectedRecommendation && !isDismissed && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CQvU")).MenuSectionHeading), null, formatMessage((0, (0, parcelRequire("jl3Bs")).default).sectionTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, (0, ($parcel$interopDefault($5uXOq))).createElement(selectedRecommendation.Component, {
            recommendationKey: selectedRecommendation.key,
            dismissRecommendation: onDismissRecommendation
        })))));
    };
    const $f6ef8ac59a42f476$export$ebd86fc7badb9a5d = (0, (0, parcelRequire("cSD7y")).componentWithFG)('hot-113350-move-resources-to-rrr', $f6ef8ac59a42f476$var$RecommendationsWithFG, $f6ef8ac59a42f476$var$RecommendationsWithoutFG);
});
parcelRegister("25tyu", function(module, exports) {
    $parcel$export(module.exports, "useSelectedRecommendation", ()=>$6b2ce5b5c74ec887$export$6a60b75e3f5ce2aa);
    var $5uXOq = parcelRequire("5uXOq");
    var $s7Ri8 = parcelRequire("s7Ri8");
    var $2NMNM;
    var $6sbqq;
    var $lCqSu;
    const $6b2ce5b5c74ec887$export$6a60b75e3f5ce2aa = ({ appRecommendations: appRecommendations })=>{
        const [state, setState] = (0, $5uXOq.useState)({
            status: 'loading',
            recommendationKey: null,
            error: null
        });
        const recommendationContext = (0, (0, parcelRequire("lCqSu")).useRecommendationContext)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const dismissRecommendation = (0, $5uXOq.useCallback)(()=>{
            setState({
                status: 'success',
                recommendationKey: null
            });
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            const getSelectedRecommendation = async ()=>{
                try {
                    if (!recommendationContext) {
                        setState({
                            status: 'success',
                            recommendationKey: null
                        });
                        return;
                    }
                    const shuffledRecommendations = (0, ($parcel$interopDefault($s7Ri8)))((0, (0, parcelRequire("6sbqq")).recommendations));
                    const recommendationStatus = await Promise.all(shuffledRecommendations.map(async (recommendation)=>{
                        let isEnabled = false;
                        try {
                            isEnabled = await recommendation.shouldRender(recommendationContext, createAnalyticsEvent({}), appRecommendations);
                        } catch (error) {
                            recommendation.onLoadError(error);
                        }
                        return {
                            key: recommendation.key,
                            isEnabled: isEnabled
                        };
                    }));
                    const selectedRecommendation = recommendationStatus.find((result)=>result.isEnabled);
                    setState({
                        status: 'success',
                        recommendationKey: selectedRecommendation?.key || null
                    });
                } catch (error) {
                    setState({
                        status: 'error',
                        error: error
                    });
                }
            };
            getSelectedRecommendation();
        }, [
            appRecommendations,
            createAnalyticsEvent,
            recommendationContext
        ]);
        return {
            selectedRecommendationState: state,
            dismissRecommendation: dismissRecommendation
        };
    };
});
parcelRegister("6sbqq", function(module, exports) {
    $parcel$export(module.exports, "recommendations", ()=>$6bcef57f4eb6ba01$export$b7e5cef71fa42514);
    $parcel$export(module.exports, "recommendationsFG", ()=>$6bcef57f4eb6ba01$export$210fafb72170a08d);
    var $cf2Z3;
    var $5BWo6;
    const $6bcef57f4eb6ba01$var$createRecommendationsList = ()=>{
        const recommendationsList = [];
        recommendationsList.push((0, (0, parcelRequire("cf2Z3")).jpdRecommendation));
        recommendationsList.push((0, (0, parcelRequire("5BWo6")).jwmSampleProjectRecommendation));
        return recommendationsList;
    };
    const $6bcef57f4eb6ba01$var$createRecommendationsListFG = ()=>{
        const recommendationsListFG = [];
        recommendationsListFG.push((0, (0, parcelRequire("cf2Z3")).jpdRecommendationFG));
        recommendationsListFG.push((0, (0, parcelRequire("5BWo6")).jwmSampleProjectRecommendationFG));
        return recommendationsListFG;
    };
    const $6bcef57f4eb6ba01$export$b7e5cef71fa42514 = $6bcef57f4eb6ba01$var$createRecommendationsList();
    const $6bcef57f4eb6ba01$export$210fafb72170a08d = $6bcef57f4eb6ba01$var$createRecommendationsListFG();
});
parcelRegister("cf2Z3", function(module, exports) {
    $parcel$export(module.exports, "jpdRecommendationFG", ()=>$08d0fa98c47a849b$export$f4aaac6dcd7fd4a9);
    $parcel$export(module.exports, "jpdRecommendation", ()=>$08d0fa98c47a849b$export$f0837513113a320d);
    var $5uXOq = parcelRequire("5uXOq");
    var $jFnH8 = parcelRequire("jFnH8");
    var $941eD = parcelRequire("941eD");
    var $fVnbM;
    var $34gGM;
    var $lj8SI;
    var $cgL5K;
    var $89SaW;
    var $jcw0u;
    var $koVbs;
    var $5FnJJ;
    var $8zOmE;
    var $2NMNM;
    var $90yGq;
    var $2tT7R;
    var $hA8GQ;
    var $i49ho;
    var $83krH;
    var $ZxyRh;
    const $08d0fa98c47a849b$export$da956fe610b96f73 = ({ recommendationKey: recommendationKey, dismissRecommendation: dismissRecommendation })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const crossFlow = (0, $941eD.useCrossFlow)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const environment = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        const jpdCloudCCPProductID = (0, (0, parcelRequire("i49ho")).getProductTypeCcpReferenceIdMapForEnv)(environment).PRODUCT_DISCOVERY;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onLearnMoreClicked = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
                action: 'clicked'
            }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
                level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
                parentItemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
                parentItemId: (0, $496585bee7985bb9$export$de9ad1ebeca97ec1),
                itemId: (0, $496585bee7985bb9$export$ce0bea1467165424),
                targetProductId: jpdCloudCCPProductID,
                recommendedProductIds: [
                    jpdCloudCCPProductID
                ]
            });
        }, [
            createAnalyticsEvent,
            jpdCloudCCPProductID
        ]);
        const onDismissClicked = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
                action: 'clicked'
            }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
                level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
                parentItemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
                parentItemId: (0, $496585bee7985bb9$export$de9ad1ebeca97ec1),
                itemId: (0, $496585bee7985bb9$export$5c09fa42f8d45ed8),
                targetProductId: jpdCloudCCPProductID,
                recommendedProductIds: [
                    jpdCloudCCPProductID
                ]
            });
            dismissRecommendation();
            if (accountId) (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, (0, parcelRequire("i49ho")).JPD_RECOMMENDATION_DISMISS_USER_PROPERTY), 'true').catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'dismissJpdRecommendation',
                        packageName: (0, $6dbca5c36e867ae8$export$b8b9d90f9e5bd72b),
                        teamName: 'navigation'
                    }
                });
            });
        }, [
            accountId,
            createAnalyticsEvent,
            dismissRecommendation,
            jpdCloudCCPProductID
        ]);
        const openCrossFlow = (0, $5uXOq.useCallback)(async (templateId)=>{
            const extensions = (0, $jFnH8.createProvisioningPageExtensions)({
                actions: {
                    primary: {
                        behaviour: (0, $jFnH8.Behaviours).LAND,
                        prompt: (0, $jFnH8.Prompts).NEXT,
                        options: {
                            targetTab: (0, $jFnH8.TargetTabs).SAME,
                            urlParams: {
                                templateId: templateId
                            }
                        }
                    }
                }
            });
            if (crossFlow.isEnabled) crossFlow.api.open({
                journey: (0, $941eD.Journeys).GET_STARTED,
                targetProduct: (0, $941eD.Targets).JIRA_PRODUCT_DISCOVERY,
                sourceComponent: 'projectsMenuSection',
                sourceContext: 'tryThisRecommendation',
                extensions: extensions
            });
        }, [
            crossFlow
        ]);
        const onRecommendationClicked = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                action: 'clicked'
            }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                itemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
                itemId: (0, $496585bee7985bb9$export$de9ad1ebeca97ec1),
                targetProductId: jpdCloudCCPProductID,
                recommendedProductIds: [
                    jpdCloudCCPProductID
                ]
            });
            openCrossFlow((0, (0, parcelRequire("i49ho")).JPD_KEY));
        }, [
            createAnalyticsEvent,
            jpdCloudCCPProductID,
            openCrossFlow
        ]);
        const recommendationActionMenuClickHandler = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
                parentItemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
                parentItemId: (0, $496585bee7985bb9$export$de9ad1ebeca97ec1),
                itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
            });
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("34gGM")).JiraProductDiscoveryIcon), {
                appearance: "brand",
                size: "small"
            }),
            elemAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                appearance: "new",
                isBold: false
            }, formatMessage((0, (0, parcelRequire("83krH")).default).lozengeText)),
            href: "",
            menuId: recommendationKey,
            onClick: onRecommendationClicked,
            actionsOnHover: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hA8GQ")).RecommendationActionMenu), {
                onClick: recommendationActionMenuClickHandler,
                onLearnMoreClicked: onLearnMoreClicked,
                onDismissClicked: onDismissClicked,
                primaryCta: formatMessage((0, (0, parcelRequire("83krH")).default).reasonsModalButtonOk),
                body: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("83krH")).default).reasonsModalExplanation, {
                    strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                            as: "strong"
                        }, chunks)
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("ul", null, (0, ($parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, (0, parcelRequire("83krH")).default).reasonsModalBulletOneSpork)), (0, ($parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, (0, parcelRequire("83krH")).default).reasonsModalBulletTwo))), (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "link",
                    spacing: "none",
                    href: (0, $6dbca5c36e867ae8$export$aefe1c8741b24a28),
                    target: "_blank"
                }, formatMessage((0, (0, parcelRequire("83krH")).default).privacyPolicy))),
                title: formatMessage((0, (0, parcelRequire("83krH")).default).reasonsModalTitle)
            })
        }, formatMessage((0, (0, parcelRequire("83krH")).default).projectTitle)));
    };
    const $08d0fa98c47a849b$var$checkEligibilityFG = (recommendationContext, appRecommendations)=>{
        const { areProductSuggestionsEnabled: areProductSuggestionsEnabled, licensedProducts: licensedProducts, canCreateProject: canCreateProject, accountId: accountId, jpdRecommendationDismissed: jpdRecommendationDismissed } = recommendationContext;
        if (!accountId) return {
            isEligible: false,
            reason: 'Account Id is null'
        };
        if (!areProductSuggestionsEnabled) return {
            isEligible: false,
            reason: 'Product suggestions are disabled'
        };
        if ((0, (0, parcelRequire("ZxyRh")).hasJpdLicense)(licensedProducts)) return {
            isEligible: false,
            reason: 'Instance has JPD license'
        };
        if (!canCreateProject) return {
            isEligible: false,
            reason: 'User cannot create projects'
        };
        if (jpdRecommendationDismissed) return {
            isEligible: false,
            reason: 'JPD recommendation dismissed'
        };
        if (!appRecommendations?.some((entityId)=>entityId === (0, (0, parcelRequire("i49ho")).JPD_ENTITY_ID))) return {
            isEligible: false,
            reason: 'JPD was not in the recommend apps'
        };
        return {
            isEligible: true,
            reason: 'Pass all checks'
        };
    };
    const $08d0fa98c47a849b$var$checkEligibility = async (recommendationContext, appRecommendations)=>{
        const { areProductSuggestionsEnabled: areProductSuggestionsEnabled, licensedProducts: licensedProducts, canCreateProject: canCreateProject, accountId: accountId } = recommendationContext;
        if (!accountId) return {
            isEligible: false,
            reason: 'Account Id is null'
        };
        if (!areProductSuggestionsEnabled) return {
            isEligible: false,
            reason: 'Product suggestions are disabled'
        };
        if ((0, (0, parcelRequire("ZxyRh")).hasJpdLicense)(licensedProducts)) return {
            isEligible: false,
            reason: 'Instance has JPD license'
        };
        if (!canCreateProject) return {
            isEligible: false,
            reason: 'User cannot create projects'
        };
        const [dismissed] = await Promise.all([
            (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, (0, (0, parcelRequire("i49ho")).JPD_RECOMMENDATION_DISMISS_USER_PROPERTY)).catch((error)=>{
                if (error.statusCode === 404) return false;
                throw Error(`${error.statusCode}, JPD recommendation dismissal failed. ${error.name}: ${error.message}`, error);
            })
        ]);
        if (dismissed) return {
            isEligible: false,
            reason: 'JPD recommendation dismissed'
        };
        if (!appRecommendations?.some((entityId)=>entityId === (0, (0, parcelRequire("i49ho")).JPD_ENTITY_ID))) return {
            isEligible: false,
            reason: 'JPD was not in the recommend apps'
        };
        return {
            isEligible: true,
            reason: 'Pass all checks'
        };
    };
    const $08d0fa98c47a849b$export$f4aaac6dcd7fd4a9 = {
        key: (0, (0, parcelRequire("i49ho")).JPD_RECOMMENDATION_KEY),
        shouldRender: (recommendationContext, analyticsEvent, appRecommendations)=>{
            const { isEligible: isEligible, reason: reason } = $08d0fa98c47a849b$var$checkEligibilityFG(recommendationContext, appRecommendations);
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJpdRecommendation succeeded', {
                reason: reason,
                isEligible: isEligible
            });
            return isEligible;
        },
        Component: $08d0fa98c47a849b$export$da956fe610b96f73
    };
    const $08d0fa98c47a849b$export$f0837513113a320d = {
        key: (0, (0, parcelRequire("i49ho")).JPD_RECOMMENDATION_KEY),
        shouldRender: async (recommendationContext, analyticsEvent, appRecommendations)=>{
            const { isEligible: isEligible, reason: reason } = await $08d0fa98c47a849b$var$checkEligibility(recommendationContext, appRecommendations);
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJpdRecommendation succeeded', {
                reason: reason,
                isEligible: isEligible
            });
            return isEligible;
        },
        onLoadError: (error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'loadJpdRecommendation',
                    packageName: (0, $6dbca5c36e867ae8$export$b8b9d90f9e5bd72b),
                    teamName: 'navigation'
                }
            });
        },
        Component: $08d0fa98c47a849b$export$da956fe610b96f73
    };
});
parcelRegister("hA8GQ", function(module, exports) {
    $parcel$export(module.exports, "RecommendationActionMenu", ()=>$8bb3d181661250df$export$ff27431731859712);
    var $5uXOq = parcelRequire("5uXOq");
    var $8U6zd;
    var $3Z96c;
    var $eZUJu;
    var $9UCCQ;
    var $4R6GH;
    var $koVbs;
    var $2KAtx;
    var $iMEh3;
    var $7ju32;
    var $lAku7;
    var $22OQR;
    var $aBLQn;
    const $8bb3d181661250df$var$MENU_TEST_ID = 'recommendations-common.ui.recommendation-popup-menu.menu-group';
    const $8bb3d181661250df$var$CustomTrigger = (0, $5uXOq.forwardRef)(({ ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            ...props,
            ref: ref,
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8U6zd"))))), {
                label: formatMessage((0, (0, parcelRequire("aBLQn")).default).moreActions),
                color: "currentColor",
                spacing: "spacious"
            }),
            testId: "navigation-apps-sidebar-nav4-sidebars-content-growth-recommendations.common.ui.recommendation-action-menu.themed-button"
        });
    });
    const $8bb3d181661250df$var$LearnMoreTrigger = (0, $5uXOq.forwardRef)(({ onLearnMoreClicked: onLearnMoreClicked }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            ref: ref,
            onClick: onLearnMoreClicked
        }, formatMessage((0, (0, parcelRequire("aBLQn")).default).whyAmISeeingThis));
    });
    const $8bb3d181661250df$export$ff27431731859712 = ({ onClick: onClick, onLearnMoreClicked: onLearnMoreClicked, onDismissClicked: onDismissClicked, body: body, primaryCta: primaryCta, title: title })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                body: body,
                primaryCta: primaryCta,
                title: title
            }), [
            body,
            primaryCta,
            title
        ]);
        const modalProps = (0, $5uXOq.useMemo)(()=>({
                width: 400,
                height: 440
            }), []);
        const MenuItems = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), {
                testId: $8bb3d181661250df$var$MENU_TEST_ID
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
                isList: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
                onClick: ()=>onDismissClicked()
            }, formatMessage((0, (0, parcelRequire("aBLQn")).default).dismissButtonText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KAtx")).ModalEntryPointPressableTrigger), {
                entryPoint: (0, (0, parcelRequire("iMEh3")).GrowthRecommendationsEntrypoint),
                entryPointProps: entryPointParams,
                modalProps: modalProps,
                useInternalModal: false
            }, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement($8bb3d181661250df$var$LearnMoreTrigger, {
                    ref: ref,
                    onLearnMoreClicked: onLearnMoreClicked
                })))), [
            entryPointParams,
            formatMessage,
            modalProps,
            onDismissClicked,
            onLearnMoreClicked
        ]);
        const content = (contentProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lAku7")).MenuContent), {
                ...contentProps,
                MenuItems: MenuItems
            });
        return (0, (0, parcelRequire("4R6GH")).fg)('use-relay-entrypoints-for-project-actions-menu') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ju32")).MenuContainer), {
            content: content,
            onClick: onClick,
            CustomTrigger: $8bb3d181661250df$var$CustomTrigger
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ju32")).MenuContainerOld), {
            MenuItems: MenuItems,
            onClick: onClick,
            CustomTrigger: $8bb3d181661250df$var$CustomTrigger
        });
    };
});
parcelRegister("2KAtx", function(module, exports) {
    $parcel$export(module.exports, "ModalEntryPointPressableTrigger", ()=>$a17c22dd70443cfd$export$defad645fcc21c0a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $iwwXK;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $luBm6;
    var $kMSay;
    var $9fuVs;
    var $4R6GH;
    var $c5vfY;
    var $7mPT9;
    var $gJdig;
    var $fiv1r;
    var $dWBzX;
    const $a17c22dd70443cfd$var$emptyObject = {};
    const $a17c22dd70443cfd$export$defad645fcc21c0a = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef })=>{
        const { openModal: openModal } = (0, $5uXOq.useContext)((0, (0, parcelRequire("gJdig")).ModalContext));
        const environmentProvider = (0, (0, parcelRequire("fiv1r")).useJiraRelayEnvironmentProvider)();
        const metricName = (0, $5uXOq.useMemo)(()=>{
            if (interactionName) return interactionName;
            return entryPoint?.root?.getModuleName() ?? 'unknown';
        }, [
            entryPoint,
            interactionName
        ]);
        const pressTracing = (0, (0, parcelRequire("kMSay")).default)(metricName);
        const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $a17c22dd70443cfd$var$emptyObject), [
            entryPoint,
            entryPointParams,
            environmentProvider
        ]);
        const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
            if (interactionName) pressTracing();
        }, [
            interactionName,
            pressTracing
        ]);
        const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
            openModal(({ onClose: closeModal })=>{
                const onClose = ()=>{
                    entryPointProps?.onClose?.();
                    closeModal();
                    dispose();
                };
                const defaultFallbackInner = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, title ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, title) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                    grow: "fill"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null));
                const defaultFallback = useInternalModal ? defaultFallbackInner : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                    onClose: closeModal,
                    width: modalProps?.width,
                    height: modalProps?.height
                }, defaultFallbackInner);
                const container = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer), {
                    entryPointReference: entryPointReference,
                    errorAttributes: errorAttributes,
                    errorFallback: "flag",
                    fallback: Fallback ? (0, ($parcel$interopDefault($5uXOq))).createElement(Fallback, {
                        onClose: closeModal
                    }) : defaultFallback,
                    id: metricName,
                    placeholderName: "modal-entry-point-pressable-trigger-container",
                    runtimeProps: {
                        ...entryPointProps ?? $a17c22dd70443cfd$var$emptyObject,
                        onClose: onClose
                    }
                });
                return useInternalModal ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                    ...modalProps,
                    onClose: onClose
                }, container)) : container;
            });
        }, [
            openModal,
            title,
            useInternalModal,
            modalProps,
            errorAttributes,
            Fallback,
            metricName,
            entryPointProps
        ]);
        const triggerRef = (0, (0, parcelRequire("dWBzX")).usePressablePreloadRef)({
            load: load,
            onBeforeLoad: onBeforeLoad,
            onLoad: onLoad
        });
        if (forwardedRef != null && (0, (0, parcelRequire("4R6GH")).fg)('forward_ref_modalentrypointdropdownitemtrigger')) {
            const ref = (0, (0, parcelRequire("7mPT9")).default)(triggerRef, forwardedRef);
            return children({
                ref: ref
            });
        }
        return children({
            ref: triggerRef
        });
    };
});
parcelRegister("7mPT9", function(module, exports) {
    $parcel$export(module.exports, "mergeRefs", ()=>$d1da29f25d5b5e0a$export$c9058316764c140e);
    $parcel$export(module.exports, "default", ()=>$d1da29f25d5b5e0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $d1da29f25d5b5e0a$export$c9058316764c140e(...refs) {
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    }
    function $d1da29f25d5b5e0a$export$2e2bcd8739ae039(...refs) {
        return (0, $5uXOq.useMemo)(()=>$d1da29f25d5b5e0a$export$c9058316764c140e(...refs), refs);
    }
});
parcelRegister("dWBzX", function(module, exports) {
    $parcel$export(module.exports, "usePressablePreloadRef", ()=>$01294bc664dce1e5$export$1ff47f24e06a5d2d);
    var $5uXOq = parcelRequire("5uXOq");
    const $01294bc664dce1e5$var$PRELOAD_MAX_AGE = 2000;
    const $01294bc664dce1e5$var$TIME_TO_INTENT = 200;
    function $01294bc664dce1e5$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            const el = ref.current;
            if (!el) return;
            const request = {};
            const clearPreloadTimeouts = ()=>{
                if (typeof request.preloadIntentTimeout === 'number') {
                    clearTimeout(request.preloadIntentTimeout);
                    delete request.preloadIntentTimeout;
                }
                if (typeof request.preloadMaxAgeTimeout === 'number') {
                    clearTimeout(request.preloadMaxAgeTimeout);
                    delete request.preloadMaxAgeTimeout;
                }
            };
            const cancelPreload = ()=>{
                clearPreloadTimeouts();
                request.preload?.dispose();
            };
            const loadReference = ()=>{
                if (request.load) return request.load;
                const reference = request.preload?.reference ?? load();
                if (request.preload) delete request.preload;
                request.load = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.load;
                    }
                };
                return request.load;
            };
            const clickListener = ()=>{
                clearPreloadTimeouts();
                onBeforeLoad();
                onLoad(loadReference());
            };
            const mouseDownListener = ()=>{
                clearPreloadTimeouts();
                loadReference();
            };
            const preloadReference = ()=>{
                if (request.preloadIntentTimeout || request.preload) return;
                request.preloadIntentTimeout = setTimeout(()=>{
                    delete request.preloadIntentTimeout;
                    const reference = load();
                    request.preload = {
                        reference: reference,
                        dispose () {
                            reference.dispose();
                            delete request.preload;
                        }
                    };
                    request.preloadMaxAgeTimeout = setTimeout(()=>{
                        delete request.preloadMaxAgeTimeout;
                        request.preload?.dispose();
                    }, $01294bc664dce1e5$var$PRELOAD_MAX_AGE);
                }, $01294bc664dce1e5$var$TIME_TO_INTENT);
            };
            el.addEventListener('click', clickListener);
            el.addEventListener('mousedown', mouseDownListener);
            el.addEventListener('mouseenter', preloadReference);
            el.addEventListener('mouseleave', cancelPreload);
            return ()=>{
                cancelPreload();
                el.removeEventListener('click', clickListener);
                el.removeEventListener('mousedown', mouseDownListener);
                el.removeEventListener('mouseenter', preloadReference);
                el.removeEventListener('mouseleave', cancelPreload);
            };
        }, [
            load,
            onBeforeLoad,
            onLoad
        ]);
        return ref;
    }
});
parcelRegister("iMEh3", function(module, exports) {
    $parcel$export(module.exports, "GrowthRecommendationsEntrypoint", ()=>$657424a8590f6b4d$export$f926c2f51211d688);
    var $eufEc;
    var $fEDBv;
    const $657424a8590f6b4d$export$f926c2f51211d688 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("2ljIE")).then(({ GrowthRecommendationModal: GrowthRecommendationModal })=>GrowthRecommendationModal), {
            moduleId: "356e09a2",
            moduleName: "GrowthRecommendationModal"
        }),
        getPreloadProps: (props)=>({
                queries: {},
                props: props
            })
    });
});
parcelRegister("2ljIE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("77vT3").then(()=>parcelRequire('jcyQJ'));
});
parcelRegister("7ju32", function(module, exports) {
    $parcel$export(module.exports, "MenuContainerOld", ()=>$12b2a0349669ab51$export$8667c8971d02a530);
    $parcel$export(module.exports, "MenuContainer", ()=>$12b2a0349669ab51$export$b286f91cddfedb5a);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $3HwlS;
    var $cDvOQ;
    var $6jY6G;
    var $lAku7;
    var $1aCfv;
    const $12b2a0349669ab51$export$8667c8971d02a530 = ({ MenuItems: MenuItems, onClose: onCloseCustom, CustomTrigger: CustomTrigger, onClick: onClick })=>{
        const { isOpen: isOpen, onClose: onClose, onToggle: onToggle } = (0, (0, parcelRequire("cDvOQ")).useOpenable)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const content = (contentProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lAku7")).MenuContent), {
                ...contentProps,
                MenuItems: MenuItems
            });
        const handleClose = (0, $5uXOq.useCallback)((e)=>{
            try {
                onCloseCustom?.(e);
            } finally{
                onClose();
            }
        }, [
            onCloseCustom,
            onClose
        ]);
        const onClickHandler = (0, $5uXOq.useCallback)(()=>{
            onToggle();
            onClick?.();
        }, [
            onClick,
            onToggle
        ]);
        const trigger = (triggerProps)=>CustomTrigger ? (0, ($parcel$interopDefault($5uXOq))).createElement(CustomTrigger, {
                isSelected: isOpen,
                onClick: onClickHandler,
                ...triggerProps
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aCfv")).MenuTriggerButton), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: onClickHandler
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            content: content,
            isOpen: isOpen,
            onClose: handleClose,
            placement: "bottom-start",
            trigger: trigger,
            shouldRenderToParent: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? !route.name.includes('legacy') : true,
            strategy: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? 'absolute' : 'fixed'
        });
    };
    const $12b2a0349669ab51$export$b286f91cddfedb5a = ({ content: content, CustomTrigger: CustomTrigger, onClick: onClick, onClose: onCloseCustom, buttonTriggerRef: buttonTriggerRef })=>{
        const { isOpen: isOpen, onClose: onClose, onToggle: onToggle } = (0, (0, parcelRequire("cDvOQ")).useOpenable)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const handleClose = (0, $5uXOq.useCallback)((e)=>{
            try {
                onCloseCustom?.(e);
            } finally{
                onClose();
            }
        }, [
            onCloseCustom,
            onClose
        ]);
        const onClickHandler = (0, $5uXOq.useCallback)(()=>{
            onToggle();
            onClick?.();
        }, [
            onClick,
            onToggle
        ]);
        const trigger = (triggerProps)=>{
            const { ref: ref, ...restTriggerProps } = triggerProps;
            return CustomTrigger ? (0, ($parcel$interopDefault($5uXOq))).createElement(CustomTrigger, {
                isSelected: isOpen,
                onClick: onClickHandler,
                ref: (element)=>{
                    buttonTriggerRef && buttonTriggerRef(element);
                    if (typeof ref === 'function') ref(element);
                },
                ...restTriggerProps
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aCfv")).MenuTriggerButton), {
                isSelected: isOpen,
                onClick: onClickHandler,
                ref: (element)=>{
                    buttonTriggerRef && buttonTriggerRef(element);
                    if (typeof ref === 'function') ref(element);
                },
                ...restTriggerProps
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            content: content,
            isOpen: isOpen,
            onClose: handleClose,
            placement: "bottom-start",
            trigger: trigger,
            shouldRenderToParent: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? !route.name.includes('legacy') : true,
            strategy: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? 'absolute' : 'fixed'
        });
    };
});
parcelRegister("lAku7", function(module, exports) {
    $parcel$export(module.exports, "MenuContent", ()=>$9ef97abb06f2bc76$export$479f0f2f71193efe);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZUJu;
    var $dC5iT;
    var $4DrQd;
    const $9ef97abb06f2bc76$var$stopEventPropagation = (event)=>event.stopPropagation();
    const $9ef97abb06f2bc76$export$479f0f2f71193efe = ({ MenuItems: MenuItems, onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            onMouseEnter: $9ef97abb06f2bc76$var$stopEventPropagation,
            onMouseLeave: $9ef97abb06f2bc76$var$stopEventPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), {
            minWidth: (0, (0, parcelRequire("4DrQd")).MENU_GROUP_MIN_WIDTH)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItems, {
            onClose: onClose
        })));
});
parcelRegister("1aCfv", function(module, exports) {
    $parcel$export(module.exports, "MenuTriggerButton", ()=>$697832058741b131$export$a24e6f6ddd974e33);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $1wCbV;
    var $koVbs;
    var $UPOcN;
    const $697832058741b131$export$a24e6f6ddd974e33 = (0, $5uXOq.forwardRef)(({ onClick: onClick, ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            ...props,
            icon: (iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1wCbV"))))), {
                    ...iconProps,
                    color: "var(--ds-icon, #44546F)"
                }),
            label: formatMessage((0, (0, parcelRequire("UPOcN")).default).projectActionsMenu),
            onClick: onClick,
            ref: ref,
            spacing: "compact",
            appearance: "subtle"
        });
    });
});
parcelRegister("UPOcN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5484f6b90ae9d06c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5484f6b90ae9d06c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectActionsMenu: {
            "id": "navigation-project-action-menu.menu-container.project-actions-menu",
            "defaultMessage": "More actions"
        }
    });
});
parcelRegister("22OQR", function(module, exports) {
    $parcel$export(module.exports, "ThemedButton", ()=>$87e6157378e1cf19$export$f67fb575035cc7d0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $2rqOp;
    const $87e6157378e1cf19$export$f67fb575035cc7d0 = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
            ...props,
            as: as,
            ref: ref
        })));
    const $87e6157378e1cf19$var$CustomButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("2rqOp")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aBLQn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd4cafb5aa64f8e3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fd4cafb5aa64f8e3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        whyAmISeeingThis: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.why-am-i-seeing-this",
            "defaultMessage": "Why am I seeing this?"
        },
        moreActions: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.more-actions",
            "defaultMessage": "More actions"
        },
        dismissButtonText: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.dismiss-button-text",
            "defaultMessage": "Not interested"
        },
        reasonsModalTitle: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
            "defaultMessage": "Why am I seeing this?"
        },
        reasonsModalExplanation: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
            "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
        },
        reasonsModalBulletOneSpork: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
            "defaultMessage": "the tools you use (Jira)"
        },
        reasonsModalBulletTwo: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
            "defaultMessage": "the way you use your existing tools and products"
        },
        privacyPolicy: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
            "defaultMessage": "Learn more about your data privacy with Atlassian"
        },
        reasonsModalButtonOk: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
            "defaultMessage": "Ok"
        }
    });
});
parcelRegister("i49ho", function(module, exports) {
    $parcel$export(module.exports, "JPD_RECOMMENDATION_KEY", ()=>$bfae2422736e9114$export$3e6ff24c4f517c4f);
    $parcel$export(module.exports, "JPD_KEY", ()=>$bfae2422736e9114$export$a9c4e38d8a74acd2);
    $parcel$export(module.exports, "JPD_RECOMMENDATION_DISMISS_USER_PROPERTY", ()=>$bfae2422736e9114$export$52b9dedc0088f8);
    $parcel$export(module.exports, "JPD_ENTITY_ID", ()=>$bfae2422736e9114$export$909712ccf16883d);
    $parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", ()=>$bfae2422736e9114$export$29629758934356a6);
    var $iDfVE;
    const $bfae2422736e9114$export$3e6ff24c4f517c4f = 'jpd-recommendation';
    const $bfae2422736e9114$export$a9c4e38d8a74acd2 = 'jpd.product-discovery';
    const $bfae2422736e9114$export$52b9dedc0088f8 = 'JpdRecommendationDismissed';
    const $bfae2422736e9114$export$24de1334acd05ac2 = 'RecommendJpdInProjectsMenuKey';
    const $bfae2422736e9114$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
    const $bfae2422736e9114$export$32601d21b6bdcb50 = 'recommending_jpd_in_projects_menu';
    const $bfae2422736e9114$export$909712ccf16883d = 'jira.polaris:discovery';
    const $bfae2422736e9114$export$29629758934356a6 = (environment)=>{
        const env = environment === 'prod' ? 'prod' : 'staging';
        return {
            BUSINESS: (0, (0, parcelRequire("iDfVE")).FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
            SOFTWARE: (0, (0, parcelRequire("iDfVE")).FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
            SERVICE_DESK: (0, (0, parcelRequire("iDfVE")).FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
            PRODUCT_DISCOVERY: (0, (0, parcelRequire("iDfVE")).FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
        };
    };
});
parcelRegister("83krH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5045a396714061a7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5045a396714061a7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectTitle: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title",
            "defaultMessage": "New discovery project"
        },
        lozengeText: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.lozenge-text",
            "defaultMessage": "try"
        },
        reasonsModalTitle: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
            "defaultMessage": "Why am I seeing this?"
        },
        reasonsModalExplanation: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
            "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
        },
        reasonsModalBulletOneSpork: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
            "defaultMessage": "the tools you use (Jira)"
        },
        reasonsModalBulletTwo: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
            "defaultMessage": "the way you use your existing tools and products"
        },
        privacyPolicy: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
            "defaultMessage": "Learn more about your data privacy with Atlassian"
        },
        reasonsModalButtonOk: {
            "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
            "defaultMessage": "Ok"
        }
    });
});
parcelRegister("ZxyRh", function(module, exports) {
    $parcel$export(module.exports, "hasJpdLicense", ()=>$a544ca433acda2ae$export$2ea69a0925803655);
    const $a544ca433acda2ae$export$2ea69a0925803655 = (licensedProducts)=>licensedProducts['jira-product-discovery'] === true;
});
parcelRegister("5BWo6", function(module, exports) {
    $parcel$export(module.exports, "jwmSampleProjectRecommendationFG", ()=>$ae31da46b6182d37$export$dd8310c4d48e3e5);
    $parcel$export(module.exports, "jwmSampleProjectRecommendation", ()=>$ae31da46b6182d37$export$7e11f831f0650e03);
    var $5uXOq = parcelRequire("5uXOq");
    var $4mBKK;
    var $e4yMr;
    var $lj8SI;
    var $4Pf62;
    var $jcw0u;
    var $eusud;
    var $7HGHK;
    var $pa9q9;
    var $koVbs;
    var $5FnJJ;
    var $8zOmE;
    var $2NMNM;
    var $ldyPw;
    var $hA8GQ;
    var $hJy4g;
    var $ipzap;
    var $cq7em;
    const $ae31da46b6182d37$export$1a4d033f2094f608 = ({ recommendationKey: recommendationKey, dismissRecommendation: dismissRecommendation })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const createSampleProjectClicked = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                action: 'clicked'
            }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                itemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
                itemId: (0, $496585bee7985bb9$export$27e4092edca7bb97)
            });
            $ae31da46b6182d37$var$createJwmSampleProject(showFlag);
        }, [
            createAnalyticsEvent,
            showFlag
        ]);
        const onLearnMoreClicked = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
                action: 'clicked'
            }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
                level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
                parentItemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
                parentItemId: (0, $496585bee7985bb9$export$27e4092edca7bb97),
                itemId: (0, $496585bee7985bb9$export$ce0bea1467165424)
            });
        }, [
            createAnalyticsEvent
        ]);
        const onDismissClicked = (0, $5uXOq.useCallback)(()=>{
            dismissRecommendation();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
                action: 'clicked'
            }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
                level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
                parentItemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
                parentItemId: (0, $496585bee7985bb9$export$27e4092edca7bb97),
                itemId: (0, $496585bee7985bb9$export$5c09fa42f8d45ed8)
            });
            showFlag({
                type: 'success',
                isAutoDismiss: true,
                title: formatMessage((0, (0, parcelRequire("hJy4g")).default).dismissConfirmationTitle),
                description: formatMessage((0, (0, parcelRequire("hJy4g")).default).dismissConfirmationText)
            });
        }, [
            dismissRecommendation,
            createAnalyticsEvent,
            showFlag,
            formatMessage
        ]);
        const recommendationActionMenuClickHandler = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
                parentItemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
                parentItemId: (0, $496585bee7985bb9$export$27e4092edca7bb97),
                itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
            });
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ipzap")).SampleProjectAvatar), null),
            elemAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                appearance: "new",
                isBold: false
            }, formatMessage((0, (0, parcelRequire("hJy4g")).default).lozengeText)),
            href: "",
            menuId: recommendationKey,
            onClick: createSampleProjectClicked,
            actionsOnHover: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hA8GQ")).RecommendationActionMenu), {
                onClick: recommendationActionMenuClickHandler,
                onLearnMoreClicked: onLearnMoreClicked,
                onDismissClicked: onDismissClicked,
                title: formatMessage((0, (0, parcelRequire("hJy4g")).default).modalTitle),
                body: formatMessage((0, (0, parcelRequire("hJy4g")).default).modalBodySpork, {
                    br: (0, ($parcel$interopDefault($5uXOq))).createElement("br", null),
                    link: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                        href: "https://www.atlassian.com/software/jira/work-management",
                        target: "_blank"
                    }, formatMessage((0, (0, parcelRequire("hJy4g")).default).learnMoreLinkSpork))
                }),
                primaryCta: formatMessage((0, (0, parcelRequire("hJy4g")).default).modalCta)
            })
        }, formatMessage((0, (0, parcelRequire("hJy4g")).default).ctaHeadingText)));
    };
    const $ae31da46b6182d37$var$checkEligibilityFG = (recommendationContext)=>{
        const { licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, edition: edition, canCreateProject: canCreateProject, accountId: accountId, siteTraitsData: siteTraitsData, userTraitsData: userTraitsData } = recommendationContext;
        if (!licensedProducts?.[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).JIRA_SOFTWARE]) return {
            isEligible: false,
            reason: 'User does not have jira software'
        };
        if (edition === (0, (0, parcelRequire("ldyPw")).UNLICENSED)) return {
            isEligible: false,
            reason: 'User is unlicensed'
        };
        if (!canCreateProject) return {
            isEligible: false,
            reason: 'User cannot create projects'
        };
        if (!accountId) return {
            isEligible: false,
            reason: 'Account Id is null'
        };
        if (userTraitsData?.some((trait)=>trait.name === (0, $af6c0f17c1811777$export$ce71307e913afd12) && trait.value)) return {
            isEligible: false,
            reason: `User has trait ${0, $af6c0f17c1811777$export$ce71307e913afd12}`
        };
        if (userTraitsData?.some((trait)=>trait.name === (0, $af6c0f17c1811777$export$fc53f723f5163588) && trait.value)) return {
            isEligible: false,
            reason: `User has trait ${0, $af6c0f17c1811777$export$fc53f723f5163588}`
        };
        if (userTraitsData?.some((trait)=>trait.name === (0, $af6c0f17c1811777$export$a1a2e9d60f36ed80) && trait.value)) return {
            isEligible: false,
            reason: `User has trait ${0, $af6c0f17c1811777$export$a1a2e9d60f36ed80}`
        };
        if (!firstActivationDateMs) return {
            isEligible: false,
            reason: 'firstActivationDateMs is undefined'
        };
        if ((0, (0, parcelRequire("4mBKK")).default)(new Date(), firstActivationDateMs) > 28 && userTraitsData?.some((trait)=>trait.name === (0, $af6c0f17c1811777$export$a92ddfff80995acf) && (0, (0, parcelRequire("4mBKK")).default)(new Date(), new Date(trait.value)) > 28)) return {
            isEligible: false,
            reason: 'Experiment dropdown date trait is older than 28 days'
        };
        if ((0, (0, parcelRequire("4mBKK")).default)(new Date(), firstActivationDateMs) > 28 && !siteTraitsData?.some(({ name: name, value: value })=>name === (0, $af6c0f17c1811777$export$9365f74cb008dc7c) && value)) return {
            isEligible: false,
            reason: 'User activation date is greater than 28 days and JSW to JWM ML trait is not set'
        };
        return {
            isEligible: true,
            reason: 'Pass all checks'
        };
    };
    const $ae31da46b6182d37$var$checkEligibility = async (recommendationContext)=>{
        const { licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, edition: edition, canCreateProject: canCreateProject, accountId: accountId, cloudId: cloudId } = recommendationContext;
        if (!licensedProducts?.[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).JIRA_SOFTWARE]) return {
            isEligible: false,
            reason: 'User does not have jira software'
        };
        if (edition === (0, (0, parcelRequire("ldyPw")).UNLICENSED)) return {
            isEligible: false,
            reason: 'User is unlicensed'
        };
        if (!canCreateProject) return {
            isEligible: false,
            reason: 'User cannot create projects'
        };
        if (!accountId) return {
            isEligible: false,
            reason: 'Account Id is null'
        };
        const [userTraits, siteTraits] = await Promise.all([
            (0, (0, parcelRequire("cq7em")).fetchUserTraits)(cloudId, accountId),
            (0, (0, parcelRequire("cq7em")).fetchSiteTraits)(cloudId)
        ]);
        if (userTraits.some((trait)=>trait.name === (0, $af6c0f17c1811777$export$ce71307e913afd12) && trait.value)) return {
            isEligible: false,
            reason: `User has trait ${0, $af6c0f17c1811777$export$ce71307e913afd12}`
        };
        if (userTraits.some((trait)=>trait.name === (0, $af6c0f17c1811777$export$fc53f723f5163588) && trait.value)) return {
            isEligible: false,
            reason: `User has trait ${0, $af6c0f17c1811777$export$fc53f723f5163588}`
        };
        if (userTraits.some((trait)=>trait.name === (0, $af6c0f17c1811777$export$a1a2e9d60f36ed80) && trait.value)) return {
            isEligible: false,
            reason: `User has trait ${0, $af6c0f17c1811777$export$a1a2e9d60f36ed80}`
        };
        if (!firstActivationDateMs) return {
            isEligible: false,
            reason: 'firstActivationDateMs is undefined'
        };
        if ((0, (0, parcelRequire("4mBKK")).default)(new Date(), firstActivationDateMs) > 28 && userTraits.some((trait)=>trait.name === (0, $af6c0f17c1811777$export$a92ddfff80995acf) && (0, (0, parcelRequire("4mBKK")).default)(new Date(), new Date(trait.value)) > 28)) return {
            isEligible: false,
            reason: 'Experiment dropdown date trait is older than 28 days'
        };
        if ((0, (0, parcelRequire("4mBKK")).default)(new Date(), firstActivationDateMs) > 28 && !siteTraits.some(({ name: name, value: value })=>name === (0, $af6c0f17c1811777$export$9365f74cb008dc7c) && value)) return {
            isEligible: false,
            reason: 'User activation date is greater than 28 days and JSW to JWM ML trait is not set'
        };
        return {
            isEligible: true,
            reason: 'Pass all checks'
        };
    };
    const $ae31da46b6182d37$export$dd8310c4d48e3e5 = {
        key: (0, $af6c0f17c1811777$export$4e0e125b835dc0d),
        shouldRender: (recommendationContext, analyticsEvent)=>{
            const { isEligible: isEligible, reason: reason } = $ae31da46b6182d37$var$checkEligibilityFG(recommendationContext);
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJwmSampleProjectRecommendation succeeded', {
                isEligible: isEligible,
                reason: reason
            });
            return isEligible;
        },
        Component: $ae31da46b6182d37$export$1a4d033f2094f608
    };
    const $ae31da46b6182d37$export$7e11f831f0650e03 = {
        key: (0, $af6c0f17c1811777$export$4e0e125b835dc0d),
        shouldRender: async (recommendationContext, analyticsEvent)=>{
            const { isEligible: isEligible, reason: reason } = await $ae31da46b6182d37$var$checkEligibility(recommendationContext);
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJwmSampleProjectRecommendation succeeded', {
                isEligible: isEligible,
                reason: reason
            });
            return isEligible;
        },
        onLoadError: (error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'loadJwmSampleProjectRecommendation',
                    packageName: (0, $6dbca5c36e867ae8$export$b8b9d90f9e5bd72b),
                    teamName: 'navigation'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        },
        Component: $ae31da46b6182d37$export$1a4d033f2094f608
    };
    const $ae31da46b6182d37$var$jwmSampleProjectUrlWithOriginSource = (taskId, originSource)=>`/jira/core/sample/onboarding/${taskId}?originSource=moon-${originSource}`;
    const $ae31da46b6182d37$var$createJwmSampleProject = async (showFlag)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)((0, $af6c0f17c1811777$export$7b412f30d02cee13));
            if (response?.taskId) window.open($ae31da46b6182d37$var$jwmSampleProjectUrlWithOriginSource(response.taskId, (0, $af6c0f17c1811777$export$63fbd2796586b8eb)));
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'createJwmSampleProjectService',
                    packageName: (0, $6dbca5c36e867ae8$export$b8b9d90f9e5bd72b),
                    teamName: 'navigation'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            showFlag({
                key: (0, (0, parcelRequire("7HGHK")).toFlagId)((0, $af6c0f17c1811777$export$529244c5c5612bf2)),
                type: 'error',
                title: (0, (0, parcelRequire("hJy4g")).default).errorFlagTitle,
                description: (0, (0, parcelRequire("hJy4g")).default).errorFlagText
            });
            return error;
        }
    };
});
const $af6c0f17c1811777$export$4e0e125b835dc0d = 'create-jwm-sample-project';
const $af6c0f17c1811777$export$a1a2e9d60f36ed80 = 'jira_software_ui_moon_experiment_create_jwm_sample_experiment_project_dismissed_first';
const $af6c0f17c1811777$export$fc53f723f5163588 = 'jira_software_ui_moon_experiment_create_jwm_sample_experiment_project_created_first';
const $af6c0f17c1811777$export$ce71307e913afd12 = 'jira-core_business_project_created_first';
const $af6c0f17c1811777$export$7b412f30d02cee13 = '/rest/internal/latest/jwm/sample-project';
const $af6c0f17c1811777$export$529244c5c5612bf2 = 'jwmSampleProjectCreateFailure';
const $af6c0f17c1811777$export$63fbd2796586b8eb = 'projects-menu-existing-users';
const $af6c0f17c1811777$export$a92ddfff80995acf = 'jira_screen_viewed_jwmsampleprojectexperimentdropdown_first';
const $af6c0f17c1811777$export$9365f74cb008dc7c = 'brain_jsw_to_jwm_implicit_site_boolean';
parcelRegister("hJy4g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9722128763097cf6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9722128763097cf6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        ctaDescriptionText: {
            "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.cta-description-text",
            "defaultMessage": "Business project"
        },
        lozengeText: {
            "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.lozenge-text",
            "defaultMessage": "TRY NOW"
        },
        trySampleSectionHeader: {
            "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.try-sample-section-header",
            "defaultMessage": "INCLUDED FREE WITH YOUR PLAN"
        },
        dismissConfirmationTitle: {
            "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.dismiss-confirmation-title",
            "defaultMessage": "Got it, thanks for letting us know"
        },
        dismissConfirmationText: {
            "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.dismiss-confirmation-text",
            "defaultMessage": "You won't be seeing this here anymore"
        },
        ctaHeadingText: {
            "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.cta-heading-text",
            "defaultMessage": "Go-to-market sample"
        },
        modalTitle: {
            "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.modal-title",
            "defaultMessage": "Why am I seeing sample projects?"
        },
        modalBodySpork: {
            "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.modal-body-spork",
            "defaultMessage": "Jira is a powerful project management tool with two project types built for software and business teams. {br} {br}\n        The best part is, since you\u2019re using a software project, you already have access to business projects! {br} {br}\n        Create a sample business project to get set up quickly and start exploring. {br} {br}\n        {link}"
        },
        modalCta: {
            "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.modal-cta",
            "defaultMessage": "Ok"
        },
        modalCtaCapitalised: {
            "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.modal-cta-capitalised",
            "defaultMessage": "OK"
        },
        learnMoreLinkSpork: {
            "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.learn-more-link-spork",
            "defaultMessage": "Learn more about business projects in Jira"
        },
        errorFlagTitle: {
            "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.error-flag-title",
            "defaultMessage": "Something went wrong"
        },
        errorFlagText: {
            "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.error-flag-text",
            "defaultMessage": "Please reload the page to try again. If you\u2019re still having trouble, please contact Atlassian support to resolve this."
        }
    });
});
parcelRegister("ipzap", function(module, exports) {
    $parcel$export(module.exports, "SampleProjectAvatar", ()=>$00b8da2a4d91ce48$export$b8d1b0731803f79e);
    var $5uXOq = parcelRequire("5uXOq");
    var $dV6Te;
    const $00b8da2a4d91ce48$export$b8d1b0731803f79e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dV6Te")).default), {
            primaryColor: "#00C7E6",
            size: "medium",
            label: "test"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            id: "Page-1",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            transform: "matrix(0.254436, 0, 0, 0.252786, -5.761572, 0.007035)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            id: "project_avatar_plane"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            id: "plane"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", null, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            id: "Rectangle",
            x: "0",
            y: "0",
            width: "128",
            height: "128",
            transform: "matrix(1, 0, 0, 1, 0, 0)",
            fill: "#00C7E6"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M68.101,74.324 L44.671,97.754 L73.279,130.588 C73.279,130.588 92.075,138.572 96.55,136.575 L68.101,74.324 Z",
            id: "Shape",
            fill: "#2A5083",
            fillRule: "nonzero"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M84.991,80.553 L92.112,87.674 C93.444,89.006 93.444,91.186 92.112,92.518 L75.49,109.141 C72.199,112.432 66.815,112.432 63.525,109.141 L63.525,109.141 C60.234,105.85 60.234,100.466 63.525,97.176 L80.147,80.554 C81.479,79.221 83.659,79.221 84.991,80.553 Z",
            id: "Shape",
            fill: "#DEEBFF",
            fillRule: "nonzero"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M84.991,80.553 L88.552,84.114 L63.525,109.141 C60.234,105.85 60.234,100.466 63.525,97.176 L80.147,80.554 C81.479,79.221 83.659,79.221 84.991,80.553 Z",
            id: "Shape",
            fill: "#194063",
            fillRule: "nonzero",
            opacity: "0.2"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M-0.498,55.283 L28.325,80.937 L51.755,57.507 L-3.36,33.539 C-3.36,33.539 0.359,49.035 -0.498,55.283 Z",
            id: "Shape",
            fill: "#2A5083",
            fillRule: "nonzero"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M101.639,24.782 C95.065,18.207 79.54,23.071 66.966,35.646 L-3.8,104.412 C-0.71,109.906 -7.835,125.894 -3.324,130.231 L102.759,26.148 C102.431,25.659 102.059,25.201 101.639,24.782 Z",
            id: "Shape",
            fill: "#FFFFFF",
            fillRule: "nonzero"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M-2.536,128.037 C1.44,132.069 9.95,132.567 14.874,135.437 L90.856,59.455 C103.431,46.88 108.295,31.356 101.721,24.781 L-2.536,128.037 Z",
            id: "Shape",
            fill: "#DEEBFF",
            fillRule: "nonzero"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M45.639,41.201 L38.518,34.08 C37.186,32.748 35.006,32.748 33.674,34.08 L17.051,50.702 C13.76,53.993 13.76,59.377 17.051,62.667 L17.051,62.667 C20.342,65.958 25.726,65.958 29.016,62.667 L45.638,46.045 C46.971,44.713 46.971,42.533 45.639,41.201 Z",
            id: "Shape",
            fill: "#FFFFFF",
            fillRule: "nonzero"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M45.639,41.201 L42.078,37.64 L17.051,62.667 C20.342,65.958 25.726,65.958 29.016,62.667 L45.638,46.045 C46.971,44.713 46.971,42.533 45.639,41.201 Z",
            id: "Shape",
            fill: "#DEEBFF",
            fillRule: "nonzero",
            opacity: "0.2"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M71.965,63.574 L63.024,54.633 C61.318,52.927 61.318,50.137 63.024,48.431 L65.099,46.356 C66.805,44.65 69.595,44.65 71.301,46.356 L80.242,55.297 C81.948,57.003 81.948,59.793 80.242,61.499 L78.167,63.574 C76.461,65.28 73.67,65.28 71.965,63.574 Z",
            id: "Shape",
            fill: "#194063",
            fillRule: "nonzero",
            opacity: "0.2"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M71.905,60.107 L71.193,59.395 C70.607,58.809 70.607,57.851 71.193,57.266 L73.946,54.513 C74.532,53.927 75.49,53.927 76.075,54.513 L76.788,55.225 C77.374,55.811 77.374,56.769 76.788,57.354 L74.035,60.107 C73.449,60.693 72.491,60.693 71.905,60.107 Z",
            id: "Shape",
            fill: "#194063",
            fillRule: "nonzero"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M66.965,55.167 L66.252,54.455 C65.666,53.869 65.666,52.911 66.252,52.326 L69.005,49.573 C69.591,48.987 70.549,48.987 71.134,49.573 L71.846,50.285 C72.432,50.871 72.432,51.829 71.846,52.414 L69.093,55.167 C68.509,55.752 67.55,55.752 66.965,55.167 Z",
            id: "Shape",
            fill: "#194063",
            fillRule: "nonzero"
        }))))));
});
parcelRegister("cq7em", function(module, exports) {
    $parcel$export(module.exports, "fetchUserTraits", ()=>$33bd230358c0b854$export$2a353ada541e501f);
    $parcel$export(module.exports, "fetchSiteTraits", ()=>$33bd230358c0b854$export$954f05a5dfd487e4);
    var $eusud;
    const $33bd230358c0b854$export$2a353ada541e501f = async (cloudId, accountId)=>{
        try {
            const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            if (response?.attributes) return response.attributes;
            throw Error('response is not defined or null');
        } catch (error) {}
        return [];
    };
    const $33bd230358c0b854$export$954f05a5dfd487e4 = async (cloudId)=>{
        try {
            const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            if (response?.attributes) return response.attributes;
            throw Error('response is not defined or null');
        } catch (error) {}
        return [];
    };
});
parcelRegister("lCqSu", function(module, exports) {
    $parcel$export(module.exports, "useRecommendationContext", ()=>$d48e361b6db9225d$export$3321c0b02f750bcc);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $d40Fj;
    var $90yGq;
    var $k9JTq;
    var $DVljb;
    var $9OXo1;
    const $d48e361b6db9225d$export$3321c0b02f750bcc = ()=>{
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const { cloudId: cloudId, licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [{ canCreateProject: canCreateProject }] = (0, (0, parcelRequire("d40Fj")).useCreateProjectPermission)();
        const { software: edition } = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const environment = (0, $8Uumt.useRelayEnvironment)();
        return (0, $5uXOq.useMemo)(()=>({
                locale: locale,
                cloudId: cloudId,
                accountId: accountId,
                licensedProducts: licensedProducts,
                edition: edition,
                firstActivationDateMs: firstActivationDateMs,
                areProductSuggestionsEnabled: areProductSuggestionsEnabled,
                environment: environment,
                canCreateProject: canCreateProject
            }), [
            accountId,
            areProductSuggestionsEnabled,
            canCreateProject,
            cloudId,
            edition,
            environment,
            firstActivationDateMs,
            licensedProducts,
            locale
        ]);
    };
});
parcelRegister("d40Fj", function(module, exports) {
    $parcel$export(module.exports, "useCreateProjectPermission", ()=>$2e786b3606f3b4dc$export$c92733e8f8c1640f);
    $parcel$export(module.exports, "useCreateProjectPermissionActions", ()=>$2e786b3606f3b4dc$export$d2b8d6f60fe99e2a);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $kEnf8;
    const $2e786b3606f3b4dc$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'create-project-permissions',
        initialState: {
            canCreateProject: false,
            canCreateClassicProject: false,
            canCreateNextGenProject: false,
            isFetching: false,
            fetchError: null,
            promise: null,
            hasFetchedOnce: false,
            hasSuccessOnce: false
        },
        actions: (0, parcelRequire("kEnf8")).actions
    });
    const $2e786b3606f3b4dc$export$5a47fbae725b8f2 = (0, (0, parcelRequire("gg7kZ")).createContainer)($2e786b3606f3b4dc$var$Store);
    const $2e786b3606f3b4dc$export$c92733e8f8c1640f = (0, (0, parcelRequire("3sQ5x")).createHook)($2e786b3606f3b4dc$var$Store);
    const $2e786b3606f3b4dc$export$d2b8d6f60fe99e2a = (0, (0, parcelRequire("3sQ5x")).createHook)($2e786b3606f3b4dc$var$Store, {
        selector: null
    });
});
parcelRegister("kEnf8", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$005c9d409c181858$export$e324594224ef24da);
    var $7f4tk;
    const $005c9d409c181858$export$963556ef97965f0b = async ()=>{
        const url = '/rest/internal/2/projectpermissions';
        const result = await (0, (0, parcelRequire("7f4tk")).default)(url);
        return result;
    };
    const $005c9d409c181858$var$handleFetch = ()=>async ({ setState: setState, getState: getState })=>{
            const { isFetching: isFetching } = getState();
            if (!isFetching) try {
                const result = await $005c9d409c181858$export$963556ef97965f0b();
                setState({
                    ...result,
                    isFetching: false,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                });
            } catch (error) {
                setState({
                    canCreateProject: false,
                    canCreateClassicProject: false,
                    canCreateNextGenProject: false,
                    isFetching: false,
                    fetchError: error,
                    hasFetchedOnce: true
                });
            }
        };
    const $005c9d409c181858$export$e324594224ef24da = {
        fetchCreateProjectPermission: ()=>async ({ setState: setState, dispatch: dispatch })=>{
                const promise = dispatch($005c9d409c181858$var$handleFetch());
                setState({
                    isFetching: true,
                    promise: promise
                });
            }
    };
});
parcelRegister("jV5Te", function(module, exports) {
    $parcel$export(module.exports, "useSelectedRecommendationFG", ()=>$53df4f42c3002472$export$eb4814db6726708b);
    var $2NMNM;
    var $6sbqq;
    var $iYjUI;
    const $53df4f42c3002472$export$eb4814db6726708b = ({ appRecommendations: appRecommendations })=>{
        const recommendationContext = (0, (0, parcelRequire("iYjUI")).useRecommendationContextFG)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        if (!recommendationContext) return {
            recommendationKey: null
        };
        const recommendationStatus = (0, (0, parcelRequire("6sbqq")).recommendationsFG).map((recommendation)=>{
            const isEnabled = recommendation.shouldRender(recommendationContext, createAnalyticsEvent({}), appRecommendations);
            return {
                key: recommendation.key,
                isEnabled: isEnabled
            };
        });
        const selectedRecommendation = recommendationStatus.find((result)=>result.isEnabled);
        return {
            recommendationKey: selectedRecommendation?.key || null
        };
    };
});
parcelRegister("iYjUI", function(module, exports) {
    $parcel$export(module.exports, "useRecommendationContextFG", ()=>$323240e9e564d8aa$export$326bff23c1067d50);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $d40Fj;
    var $4dc0x;
    var $51Yl2;
    var $lXNZG;
    var $90yGq;
    var $k9JTq;
    var $DVljb;
    var $9OXo1;
    var $2YP9W;
    const $323240e9e564d8aa$export$326bff23c1067d50 = ()=>{
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const { cloudId: cloudId, licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [{ canCreateProject: canCreateProject }] = (0, (0, parcelRequire("d40Fj")).useCreateProjectPermission)();
        const { software: edition } = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const jpdRecommendationDismissedResourceData = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("lXNZG")).jpdRecommendationDismissedResource));
        const jpdRecommendationDismissed = jpdRecommendationDismissedResourceData?.data?.hasDismissed ?? false;
        const { data: userTraitsData } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("51Yl2")).fetchUserTraitsResource));
        const { data: siteTraitsData } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("4dc0x")).fetchSiteTraitsResource));
        return (0, $5uXOq.useMemo)(()=>({
                locale: locale,
                cloudId: cloudId,
                accountId: accountId,
                licensedProducts: licensedProducts,
                edition: edition,
                firstActivationDateMs: firstActivationDateMs,
                areProductSuggestionsEnabled: areProductSuggestionsEnabled,
                environment: environment,
                canCreateProject: canCreateProject,
                jpdRecommendationDismissed: jpdRecommendationDismissed,
                userTraitsData: userTraitsData,
                siteTraitsData: siteTraitsData
            }), [
            accountId,
            areProductSuggestionsEnabled,
            canCreateProject,
            cloudId,
            edition,
            environment,
            firstActivationDateMs,
            licensedProducts,
            locale,
            jpdRecommendationDismissed,
            userTraitsData,
            siteTraitsData
        ]);
    };
});
parcelRegister("jl3Bs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$17579479487d4752$export$2e2bcd8739ae039);
    var $7VHMR;
    var $17579479487d4752$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sectionTitle: {
            "id": "shared-with-projects.common.modal.modal-title",
            "defaultMessage": "Recommended"
        }
    });
});
parcelRegister("aq8kS", function(module, exports) {
    $parcel$export(module.exports, "Nav4ProjectsEmptyContent", ()=>$960e03f6eb83ee0c$export$7a7cd6cdc84cf8eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $koVbs;
    var $7lgBG;
    var $6m6lr;
    function $960e03f6eb83ee0c$export$7a7cd6cdc84cf8eb() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return $5uXOq.createElement((0, (0, parcelRequire("7lgBG")).EmptyContentMenuItem), null, $5uXOq.createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            color: "color.text.subtle"
        }, formatMessage((0, (0, parcelRequire("6m6lr")).default).emptyProjectsMessage)));
    }
});
parcelRegister("6m6lr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6781a034e171c4cc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6781a034e171c4cc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyProjectsMessage: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.empty-content.empty-projects-message",
            "defaultMessage": "Once you visit or create projects, they'll show up here."
        }
    });
});
parcelRegister("4iaU1", function(module, exports) {
    $parcel$export(module.exports, "Nav4ProjectMenuItem", ()=>$0448e2d1aaca7c74$export$6a41b9c2eac627cc);
    var $98QWa;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $2vSU6;
    var $4R6GH;
    var $i7frX;
    var $enCNl;
    var $38b7M;
    var $k2PPW;
    var $Xn42p;
    function $0448e2d1aaca7c74$export$6a41b9c2eac627cc({ queryRef: queryRef, setProjectToRestore: setProjectToRestore, isCorePremiumUserSeat: isCorePremiumUserSeat = false, spotlight: spotlight }) {
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("98QWa")).default), queryRef);
        if (!data) return null;
        if (!(0, (0, parcelRequire("4R6GH")).fg)('blu-4674-filter-out-archive-projects-nav4-sidebar') && data.status === 'ARCHIVED') return null;
        const renderMenuItem = ()=>{
            switch(data.projectType){
                case 0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT:
                case 0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38b7M")).AsyncJsmProjectMenu), {
                        projectData: data,
                        spotlight: spotlight
                    });
                case 0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enCNl")).AsyncJpdProjectMenu), {
                        projectData: data,
                        spotlight: spotlight
                    });
                case 0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_SOFTWARE_PROJECT:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2PPW")).JswProjectMenu), {
                        projectData: data,
                        spotlight: spotlight
                    });
                case 0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_CORE_PROJECT:
                default:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i7frX")).JiraBusinessProjectMenu), {
                        projectData: data,
                        isCorePremiumUserSeat: isCorePremiumUserSeat,
                        spotlight: spotlight
                    });
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Xn42p")).ProjectRestoreContext).Provider, {
            value: setProjectToRestore
        }, renderMenuItem());
    }
});
parcelRegister("98QWa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f106e3f340d1fe74$export$2e2bcd8739ae039);
    const $f106e3f340d1fe74$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4ProjectMenuItem",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "status"
                },
                "action": "THROW",
                "path": "status"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectType"
                },
                "action": "THROW",
                "path": "projectType"
            },
            {
                "kind": "FragmentSpread",
                "name": "JiraBusinessProjectMenu"
            },
            {
                "kind": "FragmentSpread",
                "name": "JsmProjectMenu"
            },
            {
                "kind": "FragmentSpread",
                "name": "JpdProjectMenu"
            },
            {
                "kind": "FragmentSpread",
                "name": "JswProjectMenu"
            }
        ],
        "type": "JiraProject"
    };
    $f106e3f340d1fe74$var$node.hash = "5a26636517acdf87ef9fc5b133d01d56";
    var $f106e3f340d1fe74$export$2e2bcd8739ae039 = $f106e3f340d1fe74$var$node;
});
parcelRegister("i7frX", function(module, exports) {
    $parcel$export(module.exports, "JiraBusinessProjectMenu", ()=>$1f543ab89d3e759b$export$6145b58afae943e6);
    var $47xky;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $6Lyip;
    var $4R6GH;
    var $lpwtK;
    var $hUpXm;
    var $jhS4y;
    var $3HwlS;
    var $5FnJJ;
    var $76MhN;
    var $ccuaM;
    var $44kzF;
    var $itmJb;
    var $dcP6E;
    const $1f543ab89d3e759b$export$6145b58afae943e6 = ({ projectData: projectData, isCorePremiumUserSeat: isCorePremiumUserSeat = false, spotlight: spotlight })=>{
        const { sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent } = (0, (0, parcelRequire("hUpXm")).useProjectsAnalyticsL2)();
        const project = (0, $8Uumt.useFragment)((0, (0, parcelRequire("47xky")).default), projectData);
        const projectUrl = (0, (0, parcelRequire("76MhN")).buildProjectUrl)({
            key: project.projectKey,
            projectType: project.projectType,
            defaultViewType: project.defaultNavigationItem?.typeKey,
            boardId: project.navigationMetadata?.boardId,
            isSimpleBoard: project.navigationMetadata?.isSimpleBoard
        });
        const routerLinkConfig = (0, $5uXOq.useMemo)(()=>({
                to: projectUrl,
                prefetch: 'hover'
            }), [
            projectUrl
        ]);
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const hasChangeThemeFeature = isAdmin || project.editProjectConfig?.canPerform;
        const { data: activeProject } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const projectIdOrKey = String(activeProject?.key || activeProject?.id);
        const isCurrentProject = projectIdOrKey === project.projectKey || projectIdOrKey === project.projectId;
        const shouldRenderThemePicker = hasChangeThemeFeature && isCurrentProject && (0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
        const projectActionMenuOnClickHandler = (0, $5uXOq.useCallback)(()=>{
            const { isFavourite: isFavourite, projectId: projectId, projectType: projectType } = project;
            sendMeatBallDropDownOnProjectsAnalyticsEvent({
                starred: isFavourite ?? false,
                recent: !isFavourite,
                projectId: projectId,
                projectType: projectType
            });
        }, [
            project,
            sendMeatBallDropDownOnProjectsAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Lyip")).OnboardingSpotlightMaybe), {
            key: project.projectKey,
            spotlight: spotlight
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dcP6E")).ContainerAvatar), {
                src: project.avatar.large || ''
            }),
            href: routerLinkConfig,
            menuId: (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(project.projectKey),
            actionsOnHover: (0, (0, parcelRequire("4R6GH")).fg)('use-relay-entrypoints-for-project-actions-menu') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ccuaM")).ProjectActionMenuNew), {
                projectKey: project.projectKey,
                isCorePremiumUserSeat: isCorePremiumUserSeat,
                additionalMenuItems: shouldRenderThemePicker && !!activeProject?.id ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("44kzF")).ThemePicker), {
                    projectId: activeProject.id
                }) : undefined,
                onClick: projectActionMenuOnClickHandler
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ccuaM")).ProjectActionMenu), {
                projectFragment: project,
                isCorePremiumUserSeat: isCorePremiumUserSeat,
                additionalMenuItems: shouldRenderThemePicker && !!activeProject?.id ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("44kzF")).ThemePicker), {
                    projectId: activeProject.id
                }) : undefined,
                onClick: projectActionMenuOnClickHandler
            })
        }, project.name));
    };
});
parcelRegister("47xky", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$26729977ea3d44a6$export$2e2bcd8739ae039);
    const $26729977ea3d44a6$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "JiraBusinessProjectMenu",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "large"
                            },
                            "action": "THROW",
                            "path": "avatar.large"
                        }
                    ]
                },
                "action": "THROW",
                "path": "avatar"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "name"
                },
                "action": "THROW",
                "path": "name"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "projectKey",
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "projectKey"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectId"
                },
                "action": "THROW",
                "path": "projectId"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectType"
                },
                "action": "THROW",
                "path": "projectType"
            },
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            {
                "kind": "LinkedField",
                "name": "defaultNavigationItem",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "typeKey"
                            }
                        ],
                        "type": "JiraNavigationItem",
                        "abstractKey": "__isJiraNavigationItem"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "navigationMetadata",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "boardId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isSimpleBoard"
                            }
                        ],
                        "type": "JiraSoftwareProjectNavigationMetadata"
                    }
                ]
            },
            {
                "alias": "editProjectConfig",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "EDIT_PROJECT_CONFIG"
                    }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canPerform"
                    }
                ],
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_navigationProjectActionMenu_ProjectActionMenu"
            }
        ],
        "type": "JiraProject"
    };
    $26729977ea3d44a6$var$node.hash = "ae35eb2d329bcb3071667c6a833a5ec7";
    var $26729977ea3d44a6$export$2e2bcd8739ae039 = $26729977ea3d44a6$var$node;
});
parcelRegister("76MhN", function(module, exports) {
    $parcel$export(module.exports, "buildProjectUrl", ()=>$710c5248ed45c131$export$dcc434876ddcc4c4);
    $parcel$export(module.exports, "removeBaseUrl", ()=>$710c5248ed45c131$export$d401b6140b158f69);
    var $bnWgN;
    var $2vSU6;
    const $710c5248ed45c131$var$isBusinessProject = (project)=>project.projectType === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_CORE_PROJECT);
    const $710c5248ed45c131$var$isSoftwareProject = (project)=>project.projectType === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_SOFTWARE_PROJECT);
    const $710c5248ed45c131$var$isSoftwareProjectWithBoard = (project)=>$710c5248ed45c131$var$isSoftwareProject(project) && 'boardId' in project && 'isSimpleBoard' in project;
    const $710c5248ed45c131$export$dcc434876ddcc4c4 = (params)=>{
        const { key: key, defaultUrl: defaultUrl } = params;
        if ($710c5248ed45c131$var$isBusinessProject(params)) {
            const businessRoute = params.defaultViewType ? (0, (0, parcelRequire("bnWgN")).getRouteForViewType)(key, params.defaultViewType) : undefined;
            return businessRoute ?? `/jira/core/projects/${key}/board`;
        }
        if ($710c5248ed45c131$var$isSoftwareProjectWithBoard(params)) {
            const { boardId: boardId, isSimpleBoard: isSimpleBoard, defaultViewType: defaultViewType } = params;
            const defaultViewPath = defaultViewType ? `/${defaultViewType.toLowerCase()}` : '';
            return `/jira/software/${isSimpleBoard ? '' : 'c/'}projects/${key}/boards/${boardId}${defaultViewPath && defaultViewType !== 'BOARD' ? defaultViewPath : ''}`;
        }
        if ($710c5248ed45c131$var$isSoftwareProject(params) && params.defaultViewType) {
            const { defaultViewType: defaultViewType } = params;
            return `/jira/software/projects/${key}/${defaultViewType.toLowerCase()}`;
        }
        return defaultUrl ?? `/browse/${key}`;
    };
    const $710c5248ed45c131$export$d401b6140b158f69 = (url)=>url.replace(/https?:\/\/[^/]+/, '');
});
parcelRegister("bnWgN", function(module, exports) {
    $parcel$export(module.exports, "getRouteForViewType", ()=>$2a5a115c895474c0$export$354a3334a0b30da2);
    const $2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL = '/jira/core/projects';
    const $2a5a115c895474c0$export$354a3334a0b30da2 = (projectKey, itemTypeKey)=>{
        switch(itemTypeKey){
            case 'SUMMARY':
                return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/summary`;
            case 'BOARD':
                return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/board`;
            case 'LIST':
                return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/list`;
            case 'TIMELINE':
                return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/timeline`;
            case 'CALENDAR':
                return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/calendar`;
            case 'FORMS':
                return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/form`;
            case 'APPROVALS':
                return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/approvals`;
            case 'ATTACHMENTS':
                return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/attachments`;
            case 'PAGES':
                return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/pages`;
            case 'ISSUES':
                return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/issues`;
            case 'ARCHIVED_ISSUES':
                return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/issues/archive`;
            case 'REPORTS':
                return `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`;
            case 'COMPONENTS':
                return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/components`;
            default:
                return undefined;
        }
    };
});
parcelRegister("ccuaM", function(module, exports) {
    $parcel$export(module.exports, "ProjectActionMenu", ()=>$8b67ffb58d27733b$export$b71a0a4e7f29cfd6);
    $parcel$export(module.exports, "ProjectActionMenuNew", ()=>$8b67ffb58d27733b$export$9928e3cb6ca1b907);
    var $kRK2z;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $epOG5;
    var $8U6zd;
    var $3Z96c;
    var $eZUJu;
    var $9UCCQ;
    var $2vSU6;
    var $ivDCs;
    var $co1wz;
    var $4R6GH;
    var $koVbs;
    var $e4A2P;
    var $eDLAW;
    var $3HwlS;
    var $d62in;
    var $76MhN;
    var $j5csE;
    var $kDO0r;
    var $02Psx;
    var $22OQR;
    var $7C9SV;
    var $7dxyN;
    var $itmJb;
    var $9VXkC;
    var $Xn42p;
    var $fO6zD;
    var $aM286;
    var $5k0es;
    var $03DFc;
    var $7ju32;
    var $bMW22;
    var $7mVYv;
    const $8b67ffb58d27733b$var$MENU_TEST_ID = 'navigation-common.ui.project-popup-menu.menu-group';
    const $8b67ffb58d27733b$var$CustomTrigger = (0, $5uXOq.forwardRef)(({ ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            ...props,
            ref: ref,
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8U6zd"))))), {
                label: formatMessage((0, (0, parcelRequire("bMW22")).default).moreActions),
                color: "currentColor",
                spacing: "spacious"
            }),
            testId: "navigation-project-action-menu.ui.themed-button"
        });
    });
    const $8b67ffb58d27733b$export$b71a0a4e7f29cfd6 = ({ projectFragment: projectFragment, additionalMenuItems: additionalMenuItems, isCorePremiumUserSeat: isCorePremiumUserSeat = false, withThemedTrigger: withThemedTrigger = false, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [activeEntryPoint, setActiveEntryPoint] = (0, $5uXOq.useState)(null);
        const { sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent } = (0, (0, parcelRequire("eDLAW")).useProjectsAnalyticsL3)();
        const setProjectToRestore = (0, $5uXOq.useContext)((0, (0, parcelRequire("Xn42p")).ProjectRestoreContext));
        const project = (0, $8Uumt.useFragment)((0, (0, parcelRequire("kRK2z")).default), projectFragment);
        const isProjectAdmin = project?.canEditProjectConfig?.canPerform ?? false;
        const canViewProjectConfig = project?.canViewProjectConfig?.canPerform ?? false;
        const hasProjectSettings = (0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5') ? isProjectAdmin || canViewProjectConfig : isProjectAdmin;
        const { deleteProject: deleteProject, archiveProject: archiveProject } = (0, (0, parcelRequire("e4A2P")).useUpdateProjectsInRelayStoreContext)() || {};
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const isArchived = project?.status === 'ARCHIVED';
        const settingsUrl = (0, $5uXOq.useMemo)(()=>{
            switch(project.projectType){
                case 0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT:
                    return (0, (0, parcelRequire("9VXkC")).generatePath)((0, (0, parcelRequire("7dxyN")).routeGroupsProjectSettingsServicedeskDetailsRoute).path, {
                        projectKey: project.projectKey
                    });
                case 0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT:
                    return `/jira/polaris/projects/${project.projectKey}/ideas/settings/details`;
                case 0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_SOFTWARE_PROJECT:
                case 0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_CORE_PROJECT:
                case 0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT:
                    if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2')) return (0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).convertToProjectType)(project.projectType), project.projectKey);
                    return project.webUrl ? `${(0, (0, parcelRequire("76MhN")).removeBaseUrl)(project.webUrl)}/settings` : undefined;
                default:
                    return project.webUrl ? `${(0, (0, parcelRequire("76MhN")).removeBaseUrl)(project.webUrl)}/settings` : undefined;
            }
        }, [
            project.projectType,
            project.webUrl,
            project.projectKey
        ]);
        const projectType = project.projectType;
        const isSimplified = project.projectStyle === (0, (0, parcelRequire("2vSU6")).TEAM_MANAGED_PROJECT);
        const canAdministerProject = isProjectAdmin;
        const shouldShowArchiveProject = (0, (0, parcelRequire("j5csE")).useShouldShowArchiveProjectTrigger)({
            isAdmin: isAdmin,
            isSimplified: isSimplified,
            canAdministerProject: canAdministerProject,
            projectType: (0, (0, parcelRequire("2vSU6")).convertToProjectType)(projectType),
            isCorePremiumUserSeat: isCorePremiumUserSeat
        });
        const shouldShowDeleteProject = (0, (0, parcelRequire("kDO0r")).shouldShowTrashProjectTrigger)({
            isAdmin: isAdmin,
            isSimplified: isSimplified,
            canAdministerProject: canAdministerProject,
            projectType: (0, (0, parcelRequire("2vSU6")).convertToProjectType)(projectType)
        });
        const shouldShowSaveAsTemplate = project.projectType === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_SOFTWARE_PROJECT) && isAdmin && !isSimplified && (0, (0, parcelRequire("4R6GH")).fg)('jira_custom_templates_ux');
        const MenuItems = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), {
                testId: $8b67ffb58d27733b$var$MENU_TEST_ID
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
                isList: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d62in")).FavoriteToggleButton), {
                onClick: ()=>sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent({
                        starred: project.isFavourite ?? false,
                        recent: !project.isFavourite,
                        projectId: project.projectId,
                        itemId: project.isFavourite ? (0, $496585bee7985bb9$export$7ae7abcf2c19d3e5) : (0, $496585bee7985bb9$export$78fd0bd637fe1684),
                        projectType: project.projectType
                    }),
                entityId: project.id,
                defaultIsStarred: Boolean(project.isFavourite),
                entityTypeName: "JiraProject"
            }), (isAdmin || isProjectAdmin) && project.projectType !== (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fO6zD")).AddPeopleButton), {
                onClick: ()=>{
                    sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent({
                        starred: project.isFavourite ?? false,
                        recent: !project.isFavourite,
                        projectId: project.projectId,
                        itemId: (0, $496585bee7985bb9$export$c540230986f848f6),
                        projectType: project.projectType
                    });
                },
                isAdmin: isAdmin,
                projectId: Number(project.projectId),
                projectKey: project.projectKey,
                projectType: projectType
            }), shouldShowSaveAsTemplate && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7mVYv")).SaveAsTemplateButton), null), !isArchived && (isAdmin || hasProjectSettings) && settingsUrl && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
                onClick: ()=>{
                    sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent({
                        starred: project.isFavourite ?? false,
                        recent: !project.isFavourite,
                        projectId: project.projectId,
                        itemId: (0, $496585bee7985bb9$export$3cc9ab700c406a19),
                        projectType: project.projectType
                    });
                },
                href: settingsUrl,
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("epOG5"))))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                })
            }, formatMessage((0, (0, parcelRequire("bMW22")).default).projectSettings)), additionalMenuItems), !isArchived && (isAdmin || isProjectAdmin) && (shouldShowArchiveProject || shouldShowDeleteProject) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
                isList: true,
                hasSeparator: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aM286")).ArchiveProject), {
                onClick: ()=>{
                    sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent({
                        starred: project.isFavourite ?? false,
                        recent: !project.isFavourite,
                        projectId: project.projectId,
                        itemId: (0, $496585bee7985bb9$export$dc23a793cf9e9de8),
                        projectType: project.projectType
                    });
                },
                projectId: project.id,
                jiraProjectStyle: project.projectStyle,
                jiraProjectType: projectType,
                isAdmin: isAdmin,
                canAdministerProject: isProjectAdmin,
                setActiveEntryPoint: setActiveEntryPoint,
                setProjectToRestore: setProjectToRestore,
                isCorePremiumUserSeat: isCorePremiumUserSeat,
                onArchiveSuccess: ()=>archiveProject?.(project.__id)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5k0es")).DeleteProject), {
                onClick: ()=>{
                    sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent({
                        starred: project.isFavourite ?? false,
                        recent: !project.isFavourite,
                        projectId: project.projectId,
                        itemId: (0, $496585bee7985bb9$export$22748439827110a4),
                        projectType: project.projectType
                    });
                },
                projectId: project.id,
                jiraProjectStyle: project?.projectStyle,
                jiraProjectType: projectType,
                isAdmin: isAdmin,
                canAdministerProject: isProjectAdmin,
                setActiveEntryPoint: setActiveEntryPoint,
                setProjectToRestore: setProjectToRestore,
                onDeleteSuccess: ()=>deleteProject?.(project.__id)
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C9SV")).ProjectTypeTile), {
                projectType: project.projectType,
                projectStyle: project?.projectStyle
            })), [
            project.id,
            project.isFavourite,
            project.projectType,
            project.projectId,
            project.projectKey,
            project.projectStyle,
            project.__id,
            isAdmin,
            isProjectAdmin,
            projectType,
            isArchived,
            hasProjectSettings,
            settingsUrl,
            formatMessage,
            additionalMenuItems,
            setProjectToRestore,
            isCorePremiumUserSeat,
            sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent,
            shouldShowArchiveProject,
            shouldShowDeleteProject,
            shouldShowSaveAsTemplate,
            archiveProject,
            deleteProject
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ju32")).MenuContainerOld), {
            MenuItems: MenuItems,
            onClick: onClick,
            CustomTrigger: withThemedTrigger && (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? $8b67ffb58d27733b$var$CustomTrigger : undefined
        }), activeEntryPoint !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivDCs")).ModalEntryPointContainer), {
            ...activeEntryPoint,
            id: project.id,
            packageName: "jira-navigation-apps-project-action-menu"
        }));
    };
    const $8b67ffb58d27733b$export$9928e3cb6ca1b907 = ({ additionalMenuItems: additionalMenuItems, isCorePremiumUserSeat: isCorePremiumUserSeat = false, withThemedTrigger: withThemedTrigger = false, projectKey: projectKey, onClick: onClick })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("03DFc")).EntryPointContent), {
            additionalMenuItems: additionalMenuItems,
            onClick: onClick,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            CustomTrigger: withThemedTrigger && (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? $8b67ffb58d27733b$var$CustomTrigger : undefined,
            projectKey: projectKey
        });
    };
});
parcelRegister("kRK2z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7940df017fec47cc$export$2e2bcd8739ae039);
    const $7940df017fec47cc$var$node = function() {
        var v0 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ];
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ui_navigationProjectActionMenu_ProjectActionMenu",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "id"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "projectId"
                    },
                    "action": "THROW",
                    "path": "projectId"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "projectKey",
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    "action": "THROW",
                    "path": "projectKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                },
                {
                    "kind": "ScalarField",
                    "name": "projectStyle"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "projectType"
                    },
                    "action": "THROW",
                    "path": "projectType"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "webUrl"
                    },
                    "action": "THROW",
                    "path": "webUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "alias": "canEditProjectConfig",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_PROJECT_CONFIG"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": v0,
                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                },
                {
                    "alias": "canViewProjectConfig",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "VIEW_PROJECT_CONFIG"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": v0,
                    "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__id"
                        }
                    ]
                }
            ],
            "type": "JiraProject"
        };
    }();
    $7940df017fec47cc$var$node.hash = "1eaad261749ca59fb9d45c192a018c0a";
    var $7940df017fec47cc$export$2e2bcd8739ae039 = $7940df017fec47cc$var$node;
});
parcelRegister("eDLAW", function(module, exports) {
    $parcel$export(module.exports, "useProjectsAnalyticsL3", ()=>$304a05e3ff22f010$export$619b8904be99ed7c);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $aTtGi;
    const $304a05e3ff22f010$export$619b8904be99ed7c = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const commonAttributes = (0, $5uXOq.useMemo)(()=>({
                level: (0, $951a0ed422513987$export$f9db6a58b4aabd18)
            }), []);
        const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ itemId: itemId, recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
            });
            const attributes = {
                ...commonAttributes,
                componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
                itemId: itemId,
                parentItemId: projectId,
                parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
                projectType: projectType,
                section: (0, (0, parcelRequire("aTtGi")).getSectionByStarredOrRecent)({
                    starred: starred,
                    recent: recent
                })
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
        }, [
            commonAttributes,
            createAnalyticsEvent
        ]);
        const sendMeatBallDropDownOnBoardsAnalyticsEvent = (0, $5uXOq.useCallback)(({ recent: recent, starred: starred, boardId: boardId, projectId: projectId, projectType: projectType })=>{
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
            });
            const attributes = {
                ...commonAttributes,
                componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
                itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e),
                projectId: projectId,
                parentItemId: boardId,
                parentItemType: (0, $632bd8725b437a12$export$9b8283d5878d2491),
                projectType: projectType,
                section: (0, (0, parcelRequire("aTtGi")).getSectionByStarredOrRecent)({
                    starred: starred,
                    recent: recent
                })
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
        }, [
            commonAttributes,
            createAnalyticsEvent
        ]);
        return {
            sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent,
            sendMeatBallDropDownOnBoardsAnalyticsEvent: sendMeatBallDropDownOnBoardsAnalyticsEvent
        };
    };
});
parcelRegister("j5csE", function(module, exports) {
    $parcel$export(module.exports, "useShouldShowArchiveProjectTrigger", ()=>$0115ce7a250913b5$export$b73fe2adeac2987c);
    $parcel$export(module.exports, "ProjectArchiveTrigger", ()=>$0115ce7a250913b5$export$8901cb385df588dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $6B7KL;
    var $lj8SI;
    var $2vSU6;
    var $koVbs;
    var $k9JTq;
    var $3hsHx;
    var $iviep;
    function $0115ce7a250913b5$export$b73fe2adeac2987c({ isAdmin: isAdmin, isSimplified: isSimplified, canAdministerProject: canAdministerProject, projectType: projectType, shouldHideFeatureGateTrigger: shouldHideFeatureGateTrigger, isCorePremiumUserSeat: isCorePremiumUserSeat }) {
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        if (!(0, (0, parcelRequire("iviep")).hasPermissionToArchive)({
            projectType: projectType,
            isSimplified: isSimplified,
            isAdmin: isAdmin,
            canAdministerProject: canAdministerProject
        })) return false;
        const isJswPremiumEdition = (0, (0, parcelRequire("iviep")).hasPermissionGate)((0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT), appEditions);
        const isJswStandardEdition = (0, (0, parcelRequire("iviep")).isStandardEdition)((0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT), appEditions);
        const isJswFreeEdition = (0, (0, parcelRequire("iviep")).isFreeEdition)((0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT), appEditions);
        const isJsmPremiumEdition = (0, (0, parcelRequire("iviep")).hasPermissionGate)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), appEditions);
        if (projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) && isJswPremiumEdition || projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT) && isJsmPremiumEdition) return {
            showPremiumLozenge: false
        };
        if (isAdmin && !shouldHideFeatureGateTrigger && (projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) || projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)) && (isJswStandardEdition || isJswFreeEdition)) return {
            showPremiumLozenge: true
        };
        if (projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT) && isCorePremiumUserSeat) return {
            showPremiumLozenge: false
        };
        return false;
    }
    const $0115ce7a250913b5$export$8901cb385df588dc = (props)=>{
        const { projectType: projectType, onClick: onClick, isAdmin: isAdmin, canAdministerProject: canAdministerProject, isSimplified: isSimplified, Component: Component, isCorePremiumUserSeat: isCorePremiumUserSeat, shouldHideFeatureGateTrigger: shouldHideFeatureGateTrigger, customLabelText: customLabelText } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const premiumLozenge = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($0115ce7a250913b5$var$LozengeWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                appearance: "new"
            }, formatMessage((0, (0, parcelRequire("3hsHx")).default).premiumLozenge))), [
            formatMessage
        ]);
        const getDropdownItem = ({ showPremiumLozenge: showPremiumLozenge })=>{
            const dropdownChildren = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, customLabelText || formatMessage(projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT) ? (0, (0, parcelRequire("3hsHx")).default).archiveTriggerServiceManagement : (0, (0, parcelRequire("3hsHx")).default).archiveTrigger), showPremiumLozenge && premiumLozenge);
            return Component ? (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null, dropdownChildren) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                onClick: onClick
            }, dropdownChildren);
        };
        const shouldShowResult = $0115ce7a250913b5$export$b73fe2adeac2987c({
            isAdmin: isAdmin,
            isSimplified: isSimplified,
            canAdministerProject: canAdministerProject,
            projectType: projectType,
            shouldHideFeatureGateTrigger: shouldHideFeatureGateTrigger,
            isCorePremiumUserSeat: isCorePremiumUserSeat
        });
        if (!shouldShowResult) return null;
        return getDropdownItem(shouldShowResult);
    };
    const $0115ce7a250913b5$var$LozengeWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1nu9 _18u01b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6B7KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ff85f737833a5bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $VSDnB;
    var $l7Q0F;
    const $9ff85f737833a5bc$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;
});
parcelRegister("3hsHx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bfe2f488870be757$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bfe2f488870be757$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        archiveTrigger: {
            "id": "project-archive-trigger.archive-trigger",
            "defaultMessage": "Archive"
        },
        archiveTriggerServiceManagement: {
            "id": "project-archive-trigger.archive-trigger-service-management",
            "defaultMessage": "Move to archive"
        },
        premiumLozenge: {
            "id": "project-archive-trigger.premium-lozenge",
            "defaultMessage": "Premium"
        }
    });
});
parcelRegister("iviep", function(module, exports) {
    $parcel$export(module.exports, "hasPermissionGate", ()=>$39a9a56ffba74d2e$export$2d7869ada39bf0b);
    $parcel$export(module.exports, "isStandardEdition", ()=>$39a9a56ffba74d2e$export$4b1af5399a63f452);
    $parcel$export(module.exports, "isFreeEdition", ()=>$39a9a56ffba74d2e$export$a8e9f6df1deeb7d);
    $parcel$export(module.exports, "hasPermissionToArchive", ()=>$39a9a56ffba74d2e$export$70eef98d89c5d158);
    var $2vSU6;
    var $ldyPw;
    const $39a9a56ffba74d2e$export$2d7869ada39bf0b = (projectType, appEditions)=>(0, (0, parcelRequire("ldyPw")).getEditionForProject)(projectType, appEditions) === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
    const $39a9a56ffba74d2e$export$4b1af5399a63f452 = (projectType, appEditions)=>(0, (0, parcelRequire("ldyPw")).getEditionForProject)(projectType, appEditions) === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION);
    const $39a9a56ffba74d2e$export$a8e9f6df1deeb7d = (projectType, appEditions)=>(0, (0, parcelRequire("ldyPw")).getEditionForProject)(projectType, appEditions) === (0, (0, parcelRequire("ldyPw")).FREE_EDITION);
    const $39a9a56ffba74d2e$var$hasPermissionToArchiveProject = (isSimplified, isAdmin, canAdministerProject)=>{
        if (isSimplified) return isAdmin || canAdministerProject;
        return isAdmin;
    };
    const $39a9a56ffba74d2e$export$70eef98d89c5d158 = ({ projectType: projectType, isSimplified: isSimplified, isAdmin: isAdmin, canAdministerProject: canAdministerProject })=>{
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return $39a9a56ffba74d2e$var$hasPermissionToArchiveProject(isSimplified, isAdmin, canAdministerProject);
            default:
                return false;
        }
    };
});
parcelRegister("kDO0r", function(module, exports) {
    $parcel$export(module.exports, "shouldShowTrashProjectTrigger", ()=>$ea1964a427a6c77f$export$efbe59f7e76b22d6);
    var $2vSU6;
    const $ea1964a427a6c77f$var$shouldShowTrashTriggerForSoftwareType = (isSimplified, isAdmin, canAdministerProject)=>{
        if (isSimplified) return isAdmin || canAdministerProject;
        return isAdmin;
    };
    const $ea1964a427a6c77f$var$shouldShowTrashTriggerForCoreType = (isAdmin)=>isAdmin;
    const $ea1964a427a6c77f$var$shouldShowTrashTriggerForJSMType = (isSimplified, isAdmin, canAdministerProject)=>$ea1964a427a6c77f$var$shouldShowTrashTriggerForSoftwareType(isSimplified, isAdmin, canAdministerProject);
    const $ea1964a427a6c77f$export$efbe59f7e76b22d6 = ({ projectType: projectType, isSimplified: isSimplified, isAdmin: isAdmin, canAdministerProject: canAdministerProject })=>{
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT:
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return $ea1964a427a6c77f$var$shouldShowTrashTriggerForSoftwareType(isSimplified, isAdmin, canAdministerProject);
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return $ea1964a427a6c77f$var$shouldShowTrashTriggerForCoreType(isAdmin);
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return $ea1964a427a6c77f$var$shouldShowTrashTriggerForJSMType(isSimplified, isAdmin, canAdministerProject);
            default:
                return false;
        }
    };
});
parcelRegister("7C9SV", function(module, exports) {
    $parcel$export(module.exports, "ProjectTypeTile", ()=>$8b0b606c09a520b2$export$4e8293996ff551f8);
    var $5uXOq = parcelRequire("5uXOq");
    var $29YN9;
    var $34gGM;
    var $epnSS;
    var $kgoHi;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $2vSU6;
    var $4R6GH;
    var $koVbs;
    var $6gwcE;
    const $8b0b606c09a520b2$export$4e8293996ff551f8 = ({ projectType: projectType, projectStyle: projectStyle })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const IconComponent = (0, $5uXOq.useMemo)(()=>{
            switch(projectType){
                case 0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT:
                case 0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT:
                    return 0, (0, parcelRequire("epnSS")).JiraServiceManagementIcon;
                case 0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT:
                    return 0, (0, parcelRequire("34gGM")).JiraProductDiscoveryIcon;
                default:
                    return 0, (0, parcelRequire("29YN9")).JiraIcon;
            }
        }, [
            projectType
        ]);
        const projectStyleName = (0, $5uXOq.useMemo)(()=>projectStyle === (0, (0, parcelRequire("2vSU6")).COMPANY_MANAGED_PROJECT) ? formatMessage((0, (0, parcelRequire("6gwcE")).default).companyManagedDescription) : formatMessage((0, (0, parcelRequire("6gwcE")).default).teamManagedDescription), [
            projectStyle,
            formatMessage
        ]);
        const projectTypeMessage = (0, $5uXOq.useMemo)(()=>{
            if (projectType === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT)) return formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? (0, (0, parcelRequire("6gwcE")).default).projectTypeDescriptionProductDiscovery : (0, (0, parcelRequire("6gwcE")).default).projectTypeDescriptionJiraProductDiscovery);
            if (projectType === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT) || projectType === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT)) return formatMessage((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? (0, (0, parcelRequire("6gwcE")).default).projectTypeDescriptionServiceProject : (0, (0, parcelRequire("6gwcE")).default).projectTypeDescriptionServiceDesk);
            if (projectType === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_CORE_PROJECT) && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2')) return formatMessage((0, (0, parcelRequire("6gwcE")).default).projectTypeDescriptionBusinessProject);
            if (projectType === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_SOFTWARE_PROJECT) && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2')) return formatMessage((0, (0, parcelRequire("6gwcE")).default).projectTypeDescriptionSoftwareProject);
            const projectTypeNameShort = (0, (0, parcelRequire("2vSU6")).convertToProjectTypeUiText)(projectType);
            return formatMessage((0, (0, parcelRequire("6gwcE")).default).projectTypeDescriptionJiraDash, {
                projectTypeName: projectTypeNameShort.toLowerCase()
            });
        }, [
            projectType,
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "group",
            "aria-label": formatMessage((0, (0, parcelRequire("6gwcE")).default).projectTypeGroupAccessibleLabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "start",
            xcss: $8b0b606c09a520b2$var$projectTypeStyles,
            testId: "project-type-tile.project-type-tile"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(IconComponent, {
            size: "xsmall",
            appearance: "brand",
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            weight: "medium",
            color: "color.text",
            testId: "project-type-tile.project-description"
        }, projectTypeMessage), projectType !== (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            color: "color.text.subtle",
            testId: "project-type-tile.project-caption"
        }, projectStyleName))));
    };
    const $8b0b606c09a520b2$var$projectTypeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlock: 'space.200',
        paddingInline: 'space.250',
        gap: 'space.200',
        borderBlockStart: `1px solid ${"var(--ds-border, #091E4224)"}`,
        backgroundColor: 'elevation.surface.sunken'
    });
});
parcelRegister("6gwcE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91a1d24e48d6a117$export$2e2bcd8739ae039);
    var $7VHMR;
    var $91a1d24e48d6a117$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        teamManagedDescription: {
            "id": "project-type-tile.team-managed-description",
            "defaultMessage": "Team-managed"
        },
        companyManagedDescription: {
            "id": "project-type-tile.company-managed-description",
            "defaultMessage": "Company-managed"
        },
        projectTypeGroupAccessibleLabel: {
            "id": "project-type-tile.project-type-group-accessible-label",
            "defaultMessage": "Project type details"
        },
        projectTypeDescriptionProductDiscovery: {
            "id": "project-type-tile.project-type-description-product-discovery",
            "defaultMessage": "Discovery project"
        },
        projectTypeDescriptionJiraDash: {
            "id": "project-type-tile.project-type-description-jira-dash",
            "defaultMessage": "Jira - {projectTypeName}"
        },
        projectTypeDescriptionJiraProductDiscovery: {
            "id": "project-type-tile.project-type-description-jira-product-discovery",
            "defaultMessage": "Jira Product Discovery"
        },
        projectTypeDescriptionServiceDesk: {
            "id": "project-type-tile.project-type-description-service-desk",
            "defaultMessage": "Jira Service Management"
        },
        projectTypeDescriptionServiceProject: {
            "id": "project-type-tile.project-type-description-service-project",
            "defaultMessage": "Service project"
        },
        projectTypeDescriptionBusinessProject: {
            "id": "project-type-tile.project-type-description-business-project",
            "defaultMessage": "Business project"
        },
        projectTypeDescriptionSoftwareProject: {
            "id": "project-type-tile.project-type-description-software-project",
            "defaultMessage": "Software project"
        }
    });
});
parcelRegister("Xn42p", function(module, exports) {
    $parcel$export(module.exports, "ProjectRestoreContext", ()=>$992f13279a3a116d$export$bc50e4f0d149dd7c);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    const $992f13279a3a116d$export$bc50e4f0d149dd7c = (0, $5uXOq.createContext)((0, ($parcel$interopDefault($8Rkzz))));
});
parcelRegister("fO6zD", function(module, exports) {
    $parcel$export(module.exports, "AddPeopleButton", ()=>$490af0c0cc104372$export$fba1c3a5227f2b60);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $1bKdn;
    var $kJpBP;
    var $2vSU6;
    var $koVbs;
    var $fjJ1B;
    var $3GUxJ;
    const $490af0c0cc104372$export$fba1c3a5227f2b60 = ({ isAdmin: isAdmin, projectId: projectId, projectKey: projectKey, projectType: projectType, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const handleOnClick = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(true);
            onClick?.();
        }, [
            onClick
        ]);
        const handleOnClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1bKdn"))))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            onClick: handleOnClick
        }, formatMessage((0, (0, parcelRequire("3GUxJ")).default).addPeople)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fjJ1B")).default), {
            isAdmin: isAdmin,
            isOpen: isOpen,
            projectId: projectId,
            projectKey: projectKey,
            allowFlags: true,
            baseUrl: "",
            projectType: (0, (0, parcelRequire("2vSU6")).convertToProjectType)(projectType),
            analyticsPrefix: "sidebar-nav4-add-people",
            onStopPerfMetric: (0, ($parcel$interopDefault($8Rkzz))),
            onAddSuccess: (0, ($parcel$interopDefault($8Rkzz))),
            onClose: handleOnClose,
            onError: (0, ($parcel$interopDefault($8Rkzz)))
        }));
    };
});
parcelRegister("fjJ1B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05d4cefe384a250f$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "AddPeopleModalBoundary", ()=>$05d4cefe384a250f$export$374b95de0cd72a02);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $7CMCs;
    var $gjEtj;
    var $lfTZh;
    var $kxZPA;
    const $05d4cefe384a250f$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ftwOI")), {
        moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
    });
    const $05d4cefe384a250f$export$c4cbbeec160c9988 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "async-project-add-people-dialog",
            packageName: "project-add-people"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-add-people-dialog",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
                metricKey: (0, $f7307e9423a0bb88$export$b68a44ad9e8d6ce)
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($05d4cefe384a250f$var$LazyComponent, props)));
    var $05d4cefe384a250f$export$2e2bcd8739ae039 = $05d4cefe384a250f$export$c4cbbeec160c9988;
    const $05d4cefe384a250f$export$374b95de0cd72a02 = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjEtj")).ModalBoundary), {
            id: "add-people-modal",
            metricKey: (0, $f7307e9423a0bb88$export$b68a44ad9e8d6ce),
            ...props
        }, children);
});
parcelRegister("gjEtj", function(module, exports) {
    $parcel$export(module.exports, "ModalBoundary", ()=>$c322f875acea1654$export$c3f500e812fb1bb3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $i2Rm5;
    var $b71gk;
    var $lfTZh;
    const $c322f875acea1654$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
        const ErrorState = (0, $5uXOq.useCallback)((args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i2Rm5")).ErrorFlagRenderer), {
                id: id,
                error: args.error
            }), [
            id
        ]);
        const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: metricKey
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b71gk")).default), {
            id: id,
            packageName: packageName,
            render: ErrorState,
            onError: onError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: id,
            fallback: fallback
        }, children));
    };
});
const $f7307e9423a0bb88$export$8fcd8ea7ed6539b1 = 'project-settings-apps.add-people-dialog';
const $f7307e9423a0bb88$export$b68a44ad9e8d6ce = 'ADD_PEOPLE_LOAD_START_MARK_KEY';
const $f7307e9423a0bb88$export$656613627a47a509 = 'ADD_PEOPLE_LOAD_END_MARK_KEY';
const $f7307e9423a0bb88$export$61762786d0849c64 = 'ADD_PEOPLE_READY_MARK_KEY';
parcelRegister("ftwOI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1TWxe")
    ]).then(()=>parcelRequire('jd2mv'));
});
parcelRegister("3GUxJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc6d73c7756a99c1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cc6d73c7756a99c1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addPeople: {
            "id": "navigation-project-action-menu.add-people-button.add-people",
            "defaultMessage": "Add people"
        }
    });
});
parcelRegister("aM286", function(module, exports) {
    $parcel$export(module.exports, "ArchiveProject", ()=>$4f6825017d8279bd$export$ac29ddcfeb62ef1a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2vSU6;
    var $47gW9;
    var $4mO32;
    var $koVbs;
    var $iviep;
    var $ibPPY;
    var $kRt9N;
    var $k9JTq;
    var $dImtH;
    var $9sPcp;
    function $4f6825017d8279bd$export$ac29ddcfeb62ef1a({ projectId: projectId, jiraProjectStyle: jiraProjectStyle, jiraProjectType: jiraProjectType, isAdmin: isAdmin = false, canAdministerProject: canAdministerProject = false, isCorePremiumUserSeat: isCorePremiumUserSeat = false, setActiveEntryPoint: setActiveEntryPoint, setProjectToRestore: setProjectToRestore, onArchiveSuccess: archiveSuccessCallback, onClick: onClick }) {
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const projectType = (0, (0, parcelRequire("2vSU6")).convertToProjectType)(jiraProjectType);
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                projectId: projectId
            }), [
            projectId
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isSoftwareAppStandardEdition = (0, (0, parcelRequire("iviep")).isStandardEdition)((0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT), appEditions);
        const isSoftwareAppFreeEdition = (0, (0, parcelRequire("iviep")).isFreeEdition)((0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT), appEditions);
        const { entryPointReferenceSubject: archiveRefSubject, entryPointActions: archiveActions } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("kRt9N")).archiveProjectModalEntryPoint), entryPointParams, undefined, {
            timeToIntent: 50
        });
        const archiveEntryPointRuntimeProps = (0, $5uXOq.useMemo)(()=>({
                onClose: ()=>(0, ($parcel$interopDefault($8Rkzz))),
                onArchiveProjectSuccess: ()=>{
                    archiveActions.unload();
                    setActiveEntryPoint(null);
                    archiveSuccessCallback?.();
                },
                onProjectRestore: setProjectToRestore
            }), [
            archiveActions,
            setProjectToRestore,
            setActiveEntryPoint,
            archiveSuccessCallback
        ]);
        const archiveTriggerRef = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(archiveActions);
        const { entryPointReferenceSubject: archiveProjectFeatureGateRefSubject, entryPointActions: archiveProjectFeatureGateActions } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("ibPPY")).archiveProjectFeatureGateModalEntryPoint), {});
        const archiveFeatureGateEntryPointRuntimeProps = (0, $5uXOq.useMemo)(()=>({
                onClose: ()=>{
                    archiveProjectFeatureGateActions.unload();
                }
            }), [
            archiveProjectFeatureGateActions
        ]);
        const archiveFeatureGateTriggerRef = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(archiveProjectFeatureGateActions);
        const archiveTriggerRefToUse = (jiraProjectType === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_SOFTWARE_PROJECT) || jiraProjectType === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_CORE_PROJECT)) && (isSoftwareAppStandardEdition || isSoftwareAppFreeEdition) ? archiveFeatureGateTriggerRef : archiveTriggerRef;
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            if ((isSoftwareAppStandardEdition || isSoftwareAppFreeEdition) && (jiraProjectType === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_SOFTWARE_PROJECT) || jiraProjectType === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_CORE_PROJECT))) setActiveEntryPoint({
                entryPointReferenceSubject: archiveProjectFeatureGateRefSubject,
                runtimeProps: archiveFeatureGateEntryPointRuntimeProps,
                entryPointActions: archiveProjectFeatureGateActions,
                id: 'project-archive-feature-gate-modal'
            });
            else setActiveEntryPoint({
                entryPointReferenceSubject: archiveRefSubject,
                runtimeProps: archiveEntryPointRuntimeProps,
                entryPointActions: archiveActions,
                id: 'project-archive-modal'
            });
            onClick?.();
        }, [
            isSoftwareAppStandardEdition,
            isSoftwareAppFreeEdition,
            jiraProjectType,
            setActiveEntryPoint,
            archiveProjectFeatureGateRefSubject,
            archiveFeatureGateEntryPointRuntimeProps,
            archiveProjectFeatureGateActions,
            archiveRefSubject,
            archiveEntryPointRuntimeProps,
            archiveActions,
            onClick
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dImtH")).ArchiveTriggerButton), {
            ref: archiveTriggerRefToUse,
            projectType: projectType,
            isAdmin: isAdmin,
            canAdministerProject: canAdministerProject,
            isSimplified: jiraProjectStyle === (0, (0, parcelRequire("2vSU6")).TEAM_MANAGED_PROJECT),
            onClick: handleClick,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            customLabelText: formatMessage((0, (0, parcelRequire("9sPcp")).default).archiveProject)
        });
    }
});
parcelRegister("ibPPY", function(module, exports) {
    $parcel$export(module.exports, "archiveProjectFeatureGateModalEntryPoint", ()=>$efb56fa3ccd065b0$export$fcdeeeabe3fc5ecf);
    var $eufEc;
    var $fEDBv;
    const $efb56fa3ccd065b0$export$fcdeeeabe3fc5ecf = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("5HNBc")), {
            moduleId: "1b29af53"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("5HNBc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6DFtN")
    ]).then(()=>parcelRequire('awct0'));
});
parcelRegister("kRt9N", function(module, exports) {
    $parcel$export(module.exports, "archiveProjectModalEntryPoint", ()=>$de9347d67c4d5780$export$31eb70b07b11d874);
    var $6mG7r;
    var $eufEc;
    var $fEDBv;
    const $de9347d67c4d5780$export$31eb70b07b11d874 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("ewfTs")), {
            moduleId: "a707d335"
        }),
        getPreloadProps: ({ projectId: projectId })=>({
                queries: {
                    project: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, parcelRequire("6mG7r")).default,
                        variables: {
                            projectId: projectId
                        }
                    }
                }
            })
    });
});
parcelRegister("6mG7r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42b91c010617dcca$export$2e2bcd8739ae039);
    const $42b91c010617dcca$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "a9daa742fffdffb3be75a50f4d433a30c07a6212c4a9d23a43b3664323d1faa0",
            "metadata": {},
            "name": "uiArchiveProjectModal_getProjectQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $42b91c010617dcca$export$2e2bcd8739ae039 = $42b91c010617dcca$var$node;
});
parcelRegister("ewfTs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8WZsV").then(()=>parcelRequire('enCHC'));
});
parcelRegister("dImtH", function(module, exports) {
    $parcel$export(module.exports, "ArchiveTriggerButton", ()=>$25d2ee30ddf37975$export$3cd1d37124bb8b29);
    var $5uXOq = parcelRequire("5uXOq");
    var $41CZr;
    var $kJpBP;
    var $cgL5K;
    var $j5csE;
    const $25d2ee30ddf37975$export$3cd1d37124bb8b29 = (0, $5uXOq.forwardRef)($25d2ee30ddf37975$var$_ArchiveTriggerButton);
    function $25d2ee30ddf37975$var$_ArchiveTriggerButton(props, ref) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j5csE")).ProjectArchiveTrigger), {
            ...props,
            Component: ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                    ref: ref,
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("41CZr"))))), {
                        label: "",
                        spacing: "spacious",
                        color: "var(--ds-icon, #44546F)"
                    }),
                    onClick: props.onClick
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    color: "color.text"
                }, children))
        });
    }
});
parcelRegister("9sPcp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13903a54950c5f8b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $13903a54950c5f8b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        archiveProject: {
            "id": "navigation-project-action-menu.archive-project.archive-project",
            "defaultMessage": "Archive project"
        }
    });
});
parcelRegister("5k0es", function(module, exports) {
    $parcel$export(module.exports, "DeleteProject", ()=>$b170078ffabf9677$export$586545b1530694c4);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $4IrpZ;
    var $kJpBP;
    var $cgL5K;
    var $2vSU6;
    var $47gW9;
    var $4mO32;
    var $koVbs;
    var $kDO0r;
    var $iVNLr;
    var $iqCgS;
    function $b170078ffabf9677$export$586545b1530694c4({ projectId: projectId, jiraProjectStyle: jiraProjectStyle, jiraProjectType: jiraProjectType, isAdmin: isAdmin = false, canAdministerProject: canAdministerProject = false, setActiveEntryPoint: setActiveEntryPoint, setProjectToRestore: setProjectToRestore, onDeleteSuccess: deleteSuccessCallback, onClick: onClick }) {
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                projectId: projectId
            }), [
            projectId
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { entryPointReferenceSubject: deleteRefSubject, entryPointActions: deleteActions } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("iVNLr")).deleteProjectModalEntryPoint), entryPointParams, undefined, {
            timeToIntent: 50
        });
        const deleteEntryPointRuntimeProps = (0, $5uXOq.useMemo)(()=>({
                onClose: ()=>(0, ($parcel$interopDefault($8Rkzz))),
                onDeleteProjectSuccess: ()=>{
                    deleteActions.unload();
                    setActiveEntryPoint(null);
                    deleteSuccessCallback?.();
                },
                onProjectRestore: setProjectToRestore
            }), [
            deleteActions,
            setActiveEntryPoint,
            setProjectToRestore,
            deleteSuccessCallback
        ]);
        const deleteTriggerRef = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(deleteActions);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            setActiveEntryPoint({
                entryPointReferenceSubject: deleteRefSubject,
                runtimeProps: deleteEntryPointRuntimeProps,
                entryPointActions: deleteActions,
                id: 'project-delete-modal'
            });
            onClick?.();
        }, [
            deleteRefSubject,
            deleteEntryPointRuntimeProps,
            deleteActions,
            setActiveEntryPoint,
            onClick
        ]);
        if (!(0, (0, parcelRequire("kDO0r")).shouldShowTrashProjectTrigger)({
            projectType: (0, (0, parcelRequire("2vSU6")).convertToProjectType)(jiraProjectType),
            isAdmin: isAdmin,
            canAdministerProject: canAdministerProject,
            isSimplified: jiraProjectStyle === (0, (0, parcelRequire("2vSU6")).TEAM_MANAGED_PROJECT)
        })) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            ref: deleteTriggerRef,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4IrpZ"))))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            onClick: handleClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.danger"
        }, formatMessage((0, (0, parcelRequire("iqCgS")).default).deleteProject)));
    }
});
parcelRegister("iVNLr", function(module, exports) {
    $parcel$export(module.exports, "deleteProjectModalEntryPoint", ()=>$be5cb60b714e4982$export$71ab1db8fa3662de);
    var $7L4m7;
    var $eufEc;
    var $fEDBv;
    const $be5cb60b714e4982$export$71ab1db8fa3662de = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("4P3m2")), {
            moduleId: "0a83cef5"
        }),
        getPreloadProps: ({ projectId: projectId })=>({
                queries: {
                    project: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, parcelRequire("7L4m7")).default,
                        variables: {
                            projectId: projectId
                        }
                    }
                }
            })
    });
});
parcelRegister("7L4m7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad982b59eb99c13b$export$2e2bcd8739ae039);
    const $ad982b59eb99c13b$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "b970039aa2992a80e17db04733801c9fc94a870f85ad01abf94a227b9b0a28de",
            "metadata": {},
            "name": "uiDeleteProjectModal_getProjectQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $ad982b59eb99c13b$export$2e2bcd8739ae039 = $ad982b59eb99c13b$var$node;
});
parcelRegister("4P3m2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("2qoav")
    ]).then(()=>parcelRequire('9cip1'));
});
parcelRegister("iqCgS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0e77ef8365bec66$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b0e77ef8365bec66$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        deleteProject: {
            "id": "navigation-project-action-menu.delete-project.delete-project",
            "defaultMessage": "Delete project"
        }
    });
});
parcelRegister("03DFc", function(module, exports) {
    $parcel$export(module.exports, "EntryPointContent", ()=>$507768618964e449$export$912f81dce8d58e46);
    var $5uXOq = parcelRequire("5uXOq");
    var $47gW9;
    var $7XluA;
    var $4mO32;
    var $koeKL;
    var $2oEQb;
    var $7ju32;
    var $eSIes;
    const $507768618964e449$export$912f81dce8d58e46 = ({ CustomTrigger: CustomTrigger, onClick: onClick, additionalMenuItems: additionalMenuItems, isCorePremiumUserSeat: isCorePremiumUserSeat = false, projectKey: projectKey })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("2oEQb")).projectActionMenuEntryPoint), (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                projectKey: projectKey
            }), [
            cloudId,
            projectKey
        ]));
        const buttonTriggerRef = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(entryPointActions);
        const content = (0, $5uXOq.useCallback)((contentProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "project-actions-menu-popup-content",
                packageName: "jira-navigation-apps-project-action-menu",
                runtimeProps: {
                    isCorePremiumUserSeat: isCorePremiumUserSeat,
                    additionalMenuItems: additionalMenuItems,
                    contentProps: contentProps
                },
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eSIes")).Skeleton), null)
            }), [
            entryPointReferenceSubject,
            additionalMenuItems,
            isCorePremiumUserSeat
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ju32")).MenuContainer), {
            content: content,
            CustomTrigger: CustomTrigger,
            onClick: onClick,
            buttonTriggerRef: buttonTriggerRef
        });
    };
});
parcelRegister("2oEQb", function(module, exports) {
    $parcel$export(module.exports, "projectActionMenuEntryPoint", ()=>$a5951ff1cd0da4db$export$30ec6de22da54fa0);
    var $lvLIW;
    var $eufEc;
    var $fEDBv;
    const $a5951ff1cd0da4db$var$fetchPolicy = 'network-only';
    const $a5951ff1cd0da4db$export$30ec6de22da54fa0 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("ioJ2x")).then((module)=>module.AsyncMenuWithQuery), {
            moduleId: "eb74dcae"
        }),
        getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>{
            const projectActionMenuQuery = {
                parameters: (0, (0, parcelRequire("lvLIW")).default),
                variables: {
                    cloudId: cloudId,
                    projectKey: projectKey
                },
                options: {
                    fetchPolicy: $a5951ff1cd0da4db$var$fetchPolicy
                }
            };
            return {
                queries: {
                    projectActionMenuQuery: projectActionMenuQuery
                }
            };
        }
    });
});
parcelRegister("lvLIW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8f29594fd996b113$export$2e2bcd8739ae039);
    const $8f29594fd996b113$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "30d00a603e063cd0c224df1287d43579532806f35c6c43a87f769b3d96287e03",
            "metadata": {},
            "name": "async_AsyncMenuContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $8f29594fd996b113$export$2e2bcd8739ae039 = $8f29594fd996b113$var$node;
});
parcelRegister("ioJ2x", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a0WjB").then(()=>parcelRequire('aSeFh'));
});
parcelRegister("eSIes", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$618f6270b8f60e9b$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZUJu;
    var $9UCCQ;
    var $iwwXK;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $4DrQd;
    const $618f6270b8f60e9b$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $618f6270b8f60e9b$var$wrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), {
            minWidth: (0, (0, parcelRequire("4DrQd")).MENU_GROUP_MIN_WIDTH)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            isList: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            isList: true,
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $618f6270b8f60e9b$var$projectTileSkeleton
        }))));
    const $618f6270b8f60e9b$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        boxSizing: 'border-box',
        inlineSize: `${(0, (0, parcelRequire("4DrQd")).MENU_GROUP_MIN_WIDTH)}px`
    });
    const $618f6270b8f60e9b$var$projectTileSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-600, 48px)",
        flex: 1
    });
});
parcelRegister("bMW22", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5136b67e6c38f9a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f5136b67e6c38f9a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectSettings: {
            "id": "navigation-project-action-menu.project-settings",
            "defaultMessage": "Project settings"
        },
        moreActions: {
            "id": "navigation-project-action-menu.more-actions",
            "defaultMessage": "More actions"
        }
    });
});
parcelRegister("7mVYv", function(module, exports) {
    $parcel$export(module.exports, "SaveAsTemplateButton", ()=>$1adf6f8484495f82$export$ec281d5630467023);
    var $5uXOq = parcelRequire("5uXOq");
    var $gsyzJ;
    var $kJpBP;
    var $koVbs;
    var $bmUCL;
    const $1adf6f8484495f82$export$ec281d5630467023 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: ()=>{},
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gsyzJ"))))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            })
        }, formatMessage((0, (0, parcelRequire("bmUCL")).default).saveAsTemplateNonFinal));
    };
});
parcelRegister("bmUCL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79b5cbe01f2be778$export$2e2bcd8739ae039);
    var $7VHMR;
    var $79b5cbe01f2be778$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        saveAsTemplateNonFinal: {
            "id": "navigation-project-action-menu.save-as-template.save-as-template-non-final",
            "defaultMessage": "Save as template"
        }
    });
});
parcelRegister("44kzF", function(module, exports) {
    $parcel$export(module.exports, "ThemePicker", ()=>$f5453100331219b3$export$75505f096a733fb9);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dRNbD;
    var $1I7E8;
    var $3bDjY;
    var $j5YhT;
    var $cm8b5;
    var $47gW9;
    var $7XluA;
    var $4mO32;
    var $kaHBi;
    var $4R6GH;
    var $pa9q9;
    var $7VHMR;
    var $koVbs;
    var $g8I5C;
    var $3HwlS;
    var $6jY6G;
    var $iXVV6;
    var $8zOmE;
    var $2NMNM;
    var $ky2ui;
    var $koeKL;
    var $jpH5a;
    var $ca7Zi;
    var $lwRIP;
    var $3LH0C;
    var $22OQR;
    var $gHWtm;
    var $9yzIq;
    const $f5453100331219b3$var$SOURCE_NAME = 'projectThemePicker';
    const $f5453100331219b3$var$SOURCE_NAME_OLD = 'businessProjectThemePicker';
    const $f5453100331219b3$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        backgroundTitle: {
            "id": "business-theme-components.theme-picker.background-title",
            "defaultMessage": "Project background"
        },
        buttonTitle: {
            "id": "business-theme-components.theme-picker.button-title",
            "defaultMessage": "Set project background"
        },
        errorFlagTitle: {
            "id": "business-theme-components.theme-picker.error-flag-title",
            "defaultMessage": "Something's gone wrong"
        },
        errorFlagDescription: {
            "id": "business-theme-components.theme-picker.error-flag-description",
            "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian Support."
        }
    });
    const $f5453100331219b3$export$bb0d35c1fc48487f = {
        id: 'open-theme-picker-error',
        type: 'error',
        title: $f5453100331219b3$var$messages.errorFlagTitle,
        description: $f5453100331219b3$var$messages.errorFlagDescription,
        isAutoDismiss: true
    };
    const $f5453100331219b3$export$75505f096a733fb9 = (0, $5uXOq.memo)(({ isOpen: isOpen, onOpenChange: onOpenChange, projectId: projectId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const projectAri = (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
            siteId: cloudId,
            projectId: String(projectId)
        }).toString();
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("gHWtm")).backgroundPickerPopupContentEntryPoint), (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                projectAri: projectAri
            }), [
            cloudId,
            projectAri
        ]));
        const startExperienceOld = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("jpH5a")).VIEW_THEME_PICKER_EXPERIENCE_OLD));
        const startExperience = (0, (0, parcelRequire("kaHBi")).useExperienceStart)((0, (0, parcelRequire("jpH5a")).VIEW_THEME_PICKER_EXPERIENCE));
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isCustomNavEnabled = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
        const [openState, setOpenState] = (0, $5uXOq.useState)(false);
        const isThemePickerOpen = isOpen && !isCustomNavEnabled ? isOpen : openState;
        const setIsThemePickerOpen = onOpenChange && !isCustomNavEnabled ? onOpenChange : setOpenState;
        const toggleThemePicker = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            if (!isThemePickerOpen) (0, (0, parcelRequire("4R6GH")).fg)('jira_simple_theming_platformisation') ? startExperience() : startExperienceOld();
            setIsThemePickerOpen((oldValue)=>!oldValue);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent ?? createAnalyticsEvent({}), 'button clicked', 'themePickerButton');
            setFlagShown(false);
        }, [
            isThemePickerOpen,
            startExperience,
            startExperienceOld,
            setIsThemePickerOpen,
            createAnalyticsEvent
        ]);
        const renderNudgeWrapper = (0, $5uXOq.useCallback)((children)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ky2ui")).BackgroundColourNudgeAsync), null, children), []);
        const buttonTrigger = isCustomNavEnabled ? (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(entryPointActions, !isThemePickerOpen) : (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(entryPointActions);
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                onOpenChange: setIsThemePickerOpen
            }), [
            setIsThemePickerOpen
        ]);
        const trigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage($f5453100331219b3$var$messages.buttonTitle),
                hideTooltipOnClick: true,
                position: "top"
            }, isCustomNavEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3LH0C")).ThemePickerButtonItem), {
                ...triggerProps,
                isSelected: isThemePickerOpen,
                testId: "project-theme-components.ui.theme-picker.trigger",
                ref: (element)=>{
                    buttonTrigger(element);
                    if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
                },
                onClick: toggleThemePicker
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement($f5453100331219b3$var$RoundButton, {
                ...triggerProps,
                testId: "project-theme-components.ui.theme-picker.button",
                isSelected: isThemePickerOpen,
                ref: (element)=>{
                    buttonTrigger(element);
                    if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
                },
                onClick: toggleThemePicker,
                appearance: "subtle",
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dRNbD"))))), {
                    label: formatMessage($f5453100331219b3$var$messages.buttonTitle),
                    size: "medium"
                })
            })), [
            buttonTrigger,
            formatMessage,
            isThemePickerOpen,
            toggleThemePicker,
            isCustomNavEnabled
        ]);
        const errorFallback = (0, $5uXOq.useCallback)(({ error: error })=>{
            if (!flagShown) {
                showFlag($f5453100331219b3$export$bb0d35c1fc48487f);
                setFlagShown(true);
            }
            return (0, (0, parcelRequire("4R6GH")).fg)('jira_simple_theming_platformisation') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ca7Zi")).ExperienceFailed), {
                experience: (0, (0, parcelRequire("jpH5a")).VIEW_THEME_PICKER_EXPERIENCE),
                error: error
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
                experience: (0, (0, parcelRequire("jpH5a")).VIEW_THEME_PICKER_EXPERIENCE_OLD),
                error: error
            });
        }, [
            flagShown,
            showFlag
        ]);
        const content = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "background-picker-popup-content",
                packageName: "@atlassian/jira-project-theme-components",
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yzIq")).ThemePickerSkeleton), null),
                errorFallback: errorFallback,
                runtimeProps: runtimeProps
            }), [
            errorFallback,
            entryPointReferenceSubject,
            runtimeProps
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g8I5C")).QuickstartNudge), {
            renderWrapper: renderNudgeWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: (0, (0, parcelRequire("4R6GH")).fg)('jira_simple_theming_platformisation') ? $f5453100331219b3$var$SOURCE_NAME : $f5453100331219b3$var$SOURCE_NAME_OLD,
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isThemePickerOpen,
            onClose: ()=>setIsThemePickerOpen(false),
            shouldRenderToParent: route.name.includes('legacy') && (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? false : isCustomNavEnabled,
            content: content,
            trigger: trigger,
            placement: isCustomNavEnabled ? 'right-start' : 'bottom-start',
            id: (0, (0, parcelRequire("lwRIP")).THEME_PICKER_ELEMENT_ID)
        })));
    });
    const $f5453100331219b3$var$RoundButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("22OQR")).ThemedButton), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rkoaq80",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dRNbD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a186610b26bee8b1$var$_react = $a186610b26bee8b1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $a186610b26bee8b1$var$_paintBucket = $a186610b26bee8b1$var$_interopRequireDefault((parcelRequire("ciYaM")));
    function $a186610b26bee8b1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a186610b26bee8b1$var$EditorBackgroundColorIcon = (props)=>$a186610b26bee8b1$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m7.818 12.56 4.243 4.243 4.242-4.242-4.242-4.243zm-1.414 1.415a1.995 1.995 0 0 1 0-2.828l4.243-4.243a1.995 1.995 0 0 1 2.828 0l4.243 4.243c.78.78.786 2.041 0 2.828l-4.243 4.243a1.996 1.996 0 0 1-2.828 0zM6.5 13h11l-5.44 5.218zm2.732-8.925a1 1 0 0 1 1.414 0l3.536 3.536-1.414 1.414L9.232 5.49a1 1 0 0 1 0-1.415M18 16s1.5 2 1.5 3.5c0 1-1 1.5-1.5 1.5s-1.5-.4-1.5-1.5C16.5 18 18 16 18 16"/></svg>`
        }, props, {
            newIcon: $a186610b26bee8b1$var$_paintBucket.default
        }));
    $a186610b26bee8b1$var$EditorBackgroundColorIcon.displayName = 'EditorBackgroundColorIcon';
    var $a186610b26bee8b1$var$_default = module.exports.default = $a186610b26bee8b1$var$EditorBackgroundColorIcon;
});
parcelRegister("ciYaM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8f55d7939f8010e4$var$_react = $8f55d7939f8010e4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8f55d7939f8010e4$var$_baseNew = $8f55d7939f8010e4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8f55d7939f8010e4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8f55d7939f8010e4$var$PaintBucketIcon = (props)=>$8f55d7939f8010e4$var$_react.default.createElement($8f55d7939f8010e4$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 2.25 1.134 7.866a1.25 1.25 0 0 0 0 1.768l4.732 4.732a1.25 1.25 0 0 0 1.768 0L13.25 8.75zm0 0L5.125.625M1.25 8.75h11m3 5.75a.75.75 0 0 1-1.5 0c0-.414.75-1.75.75-1.75s.75 1.336.75 1.75Z"/>`
        }, props));
    $8f55d7939f8010e4$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
    var $8f55d7939f8010e4$var$_default = module.exports.default = $8f55d7939f8010e4$var$PaintBucketIcon;
});
parcelRegister("ky2ui", function(module, exports) {
    $parcel$export(module.exports, "BackgroundColourNudgeAsync", ()=>$cb3deafbb4dbbb82$export$a3dbb521061a599a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $kxZPA;
    const $cb3deafbb4dbbb82$var$BackgroundColourNudgeLazy = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("hHwjC")).then((exportedModule)=>exportedModule.BackgroundColourNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges-jwm-background-color/src/index.tsx"
    });
    const $cb3deafbb4dbbb82$export$a3dbb521061a599a = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $d231c4839441ff18$export$eb0b199de90a7ec2),
            fallback: children,
            attributes: {
                nudgeId: (0, $d231c4839441ff18$export$eb0b199de90a7ec2)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "background-colour-onboarding-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cb3deafbb4dbbb82$var$BackgroundColourNudgeLazy, null, children)));
    $cb3deafbb4dbbb82$export$a3dbb521061a599a.displayName = 'BackgroundColourNudgeAsync';
});
const $d231c4839441ff18$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
parcelRegister("hHwjC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("ebypf")
    ]).then(()=>parcelRequire('8uIuW'));
});
parcelRegister("jpH5a", function(module, exports) {
    $parcel$export(module.exports, "VIEW_THEME_PICKER_EXPERIENCE_OLD", ()=>$34fd6f1472f32723$export$47a1a20f3722c8ce);
    $parcel$export(module.exports, "VIEW_THEME_PICKER_EXPERIENCE", ()=>$34fd6f1472f32723$export$9a8c95b97c1ee885);
    const $34fd6f1472f32723$export$47a1a20f3722c8ce = {
        experience: 'viewThemePicker',
        packageName: 'jiraBusinessThemeComponents',
        teamName: 'work-management-frontier'
    };
    const $34fd6f1472f32723$export$9a8c95b97c1ee885 = {
        experience: 'viewThemePicker',
        analyticsSource: 'jiraProjectThemeComponents',
        teamName: 'work-management-frontier'
    };
});
parcelRegister("ca7Zi", function(module, exports) {
    $parcel$export(module.exports, "useExperienceFail", ()=>$99088cc1a7014505$export$606da7704d8eaf06);
    $parcel$export(module.exports, "ExperienceFailed", ()=>$99088cc1a7014505$export$ae65a9e09c4516b3);
    $parcel$export(module.exports, "ExperienceSuccess", ()=>$99088cc1a7014505$export$4962f3898bd5c829);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $93jKl;
    var $3bQtK;
    var $jJZqs;
    const $99088cc1a7014505$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, teamName: teamName })=>{
        const onExperienceFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: experience
        });
        const onFail = (0, $5uXOq.useCallback)((location, error, extraAttributes)=>{
            const relevantError = error?.networkError ?? error;
            if (relevantError instanceof (0, (0, parcelRequire("jJZqs")).ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
            extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: `experience-tracker-${experienceId ?? experience}`,
                    packageName: analyticsSource,
                    teamName: teamName
                },
                attributes: {
                    location: location
                },
                error: relevantError,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            onExperienceFail,
            experienceId,
            experience,
            analyticsSource,
            teamName
        ]);
        return onFail;
    };
    const $99088cc1a7014505$export$ae65a9e09c4516b3 = (0, $5uXOq.memo)(({ experience: experience, error: error, attributes: attributes })=>{
        const onFail = $99088cc1a7014505$export$606da7704d8eaf06(experience);
        (0, $5uXOq.useEffect)(()=>{
            onFail(experience.experience, error, attributes);
        }, [
            attributes,
            error,
            experience,
            onFail
        ]);
        return null;
    });
    const $99088cc1a7014505$export$4962f3898bd5c829 = (0, $5uXOq.memo)(({ experience: experience, attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: experience.experience,
            attributes: {
                ...experience.experienceId == null ? undefined : {
                    experienceId: experience.experienceId
                },
                ...attributes
            }
        }));
});
parcelRegister("lwRIP", function(module, exports) {
    $parcel$export(module.exports, "CREATE_CUSTOM_BACKGROUND_EXPERIENCE_OLD", ()=>$9162f72ca6991e19$export$91a4460f34f2ee75);
    $parcel$export(module.exports, "CREATE_CUSTOM_BACKGROUND_EXPERIENCE", ()=>$9162f72ca6991e19$export$46e0706742711dad);
    $parcel$export(module.exports, "UPDATE_ALT_TEXT_EXPERIENCE_OLD", ()=>$9162f72ca6991e19$export$3b5b01b3ae53bee3);
    $parcel$export(module.exports, "UPDATE_ALT_TEXT_EXPERIENCE", ()=>$9162f72ca6991e19$export$678653f2c10961c5);
    $parcel$export(module.exports, "DELETE_CUSTOM_BACKGROUND_EXPERIENCE_OLD", ()=>$9162f72ca6991e19$export$da5da525dec4b73a);
    $parcel$export(module.exports, "DELETE_CUSTOM_BACKGROUND_EXPERIENCE", ()=>$9162f72ca6991e19$export$f84f0c56982ddf9a);
    $parcel$export(module.exports, "THEME_PICKER_ELEMENT_ID", ()=>$9162f72ca6991e19$export$8dde8522a4856b87);
    const $9162f72ca6991e19$export$91a4460f34f2ee75 = {
        experience: 'createCustomBackground',
        packageName: 'jiraBusinessThemeComponents',
        teamName: 'work-management-frontier'
    };
    const $9162f72ca6991e19$export$46e0706742711dad = {
        experience: 'createCustomBackground',
        analyticsSource: 'jiraProjectThemeComponents',
        teamName: 'work-management-frontier'
    };
    const $9162f72ca6991e19$export$3b5b01b3ae53bee3 = {
        experience: 'updateCustomBackground',
        packageName: 'jiraBusinessThemeComponents',
        teamName: 'work-management-frontier'
    };
    const $9162f72ca6991e19$export$678653f2c10961c5 = {
        experience: 'updateCustomBackground',
        analyticsSource: 'jiraProjectThemeComponents',
        teamName: 'work-management-frontier'
    };
    const $9162f72ca6991e19$export$da5da525dec4b73a = {
        experience: 'deleteCustomBackground',
        packageName: 'jiraBusinessThemeComponents',
        teamName: 'work-management-frontier'
    };
    const $9162f72ca6991e19$export$f84f0c56982ddf9a = {
        experience: 'deleteCustomBackground',
        analyticsSource: 'jiraProjectThemeComponents',
        teamName: 'work-management-frontier'
    };
    const $9162f72ca6991e19$export$8dde8522a4856b87 = 'background-picker-popup-wrapper';
});
parcelRegister("3LH0C", function(module, exports) {
    $parcel$export(module.exports, "ThemePickerButtonItem", ()=>$bf1403620c7d37d2$export$27d1624818d3e0be);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebd3R;
    var $dRNbD;
    var $kJpBP;
    var $koVbs;
    var $eCaG4;
    const $bf1403620c7d37d2$export$27d1624818d3e0be = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, testId: testId, ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dRNbD"))))), {
                label: "",
                size: "medium"
            }),
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ebd3R"))))), {
                label: "",
                size: "medium"
            }),
            onClick: onClick,
            testId: testId,
            isSelected: isSelected,
            ref: ref,
            ...props
        }, formatMessage((0, (0, parcelRequire("eCaG4")).default).setProjectBackgroundMenuItem));
    }));
});
parcelRegister("eCaG4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$375a1027f7dcdae1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $375a1027f7dcdae1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        setProjectBackgroundMenuItem: {
            "id": "business-theme-components.theme-picker-button-item.set-project-background-menu-item",
            "defaultMessage": "Set project background"
        }
    });
});
parcelRegister("gHWtm", function(module, exports) {
    $parcel$export(module.exports, "backgroundPickerPopupContentEntryPoint", ()=>$52bb029027935944$export$e02fb03d7ff1aabe);
    var $6s1PB;
    var $22q3R;
    var $eufEc;
    var $fEDBv;
    const $52bb029027935944$var$fetchPolicy = 'network-only';
    const $52bb029027935944$export$e02fb03d7ff1aabe = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("jR7UX")).then((module)=>module.BackgroundPickerPopupContent), {
            moduleId: "e1737386",
            moduleName: "PopupContent"
        }),
        getPreloadProps: ({ cloudId: cloudId, projectAri: projectAri })=>{
            const imageBackgroundsQuery = {
                parameters: (0, (0, parcelRequire("22q3R")).default),
                variables: {
                    cloudId: cloudId,
                    entityId: projectAri,
                    durationInSeconds: 900,
                    imageCount: 50,
                    jwm_unsplash_images: (0, (0, parcelRequire("6s1PB")).expValEquals)('jwm_unsplash_images_experiment', 'cohort', 'experiment')
                },
                options: {
                    fetchPolicy: $52bb029027935944$var$fetchPolicy
                }
            };
            return {
                queries: {
                    imageBackgroundsQuery: imageBackgroundsQuery
                }
            };
        }
    });
});
parcelRegister("22q3R", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$201654d4ad1f249e$export$2e2bcd8739ae039);
    const $201654d4ad1f249e$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "898107f14cb141796b4e634698cfa63c8920a1321515e8bd0436ef327a0ed29d",
            "metadata": {},
            "name": "PopupContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $201654d4ad1f249e$export$2e2bcd8739ae039 = $201654d4ad1f249e$var$node;
});
parcelRegister("jR7UX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7Pwl1")
    ]).then(()=>parcelRequire('97vnf'));
});
parcelRegister("9yzIq", function(module, exports) {
    $parcel$export(module.exports, "ThemePickerSkeleton", ()=>$828cc9a1e99f3131$export$c3dc17aa42c33254);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $eZJjh;
    const $828cc9a1e99f3131$export$c3dc17aa42c33254 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $828cc9a1e99f3131$var$skeletonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "medium"
        }));
    const $828cc9a1e99f3131$var$skeletonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '346px',
        height: '240px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 'space.100',
        paddingBottom: 'space.100'
    });
});
parcelRegister("enCNl", function(module, exports) {
    $parcel$export(module.exports, "AsyncJpdProjectMenu", ()=>$438c4e2b82a869b9$export$b446e65eeda5c1fb);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $l8ruj;
    var $kxZPA;
    const $438c4e2b82a869b9$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hongU")).then(({ JpdProjectMenu: JpdProjectMenu })=>JpdProjectMenu), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jpd-project-menu/src/ui/index.tsx"
    });
    const $438c4e2b82a869b9$export$b446e65eeda5c1fb = (0, $5uXOq.memo)(({ projectData: projectData, spotlight: spotlight })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.jpd-project-menu",
            packageName: "jiraNavigationAppsSidebarNav4JPDProjectMenu"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.sidebar.jpd-project-menu"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.jpd-project-menu",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($438c4e2b82a869b9$var$LazySidebarContent, {
            projectData: projectData,
            spotlight: spotlight
        })))));
});
parcelRegister("7VBev", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$af3b5ba721400353$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $bgrar;
    var $luBm6;
    var $8CUq3;
    const $af3b5ba721400353$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200",
            xcss: $af3b5ba721400353$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bgrar")).default), {
            columnGap: "space.100",
            rowGap: "space.050",
            alignItems: "center",
            templateAreas: [
                'avatar name',
                'avatar type'
            ],
            templateColumns: "min-content 1fr",
            xcss: $af3b5ba721400353$var$projectHeading
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$projectAvatar,
            style: {
                gridArea: 'avatar'
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$projectName,
            style: {
                gridArea: 'name'
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$projectType,
            style: {
                gridArea: 'type'
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        })));
    const $af3b5ba721400353$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%',
        padding: 'space.200'
    });
    const $af3b5ba721400353$var$backButton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $af3b5ba721400353$var$headingSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $af3b5ba721400353$var$projectHeading = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.100',
        marginBottom: 'space.100'
    });
    const $af3b5ba721400353$var$projectAvatar = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $af3b5ba721400353$var$projectName = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-200, 16px)",
        borderRadius: 'border.radius.100'
    });
    const $af3b5ba721400353$var$projectType = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-100, 8px)",
        borderRadius: 'border.radius.100'
    });
    const $af3b5ba721400353$var$menuItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("hongU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kWrFZ"),
        $6fhBS("eRaYd")
    ]).then(()=>parcelRequire('eaE9P'));
});
parcelRegister("38b7M", function(module, exports) {
    $parcel$export(module.exports, "AsyncJsmProjectMenu", ()=>$044e27f3d755a1d3$export$bf0d7afec25f82d7);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $l8ruj;
    var $kxZPA;
    const $044e27f3d755a1d3$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("h1MlY")).then(({ JsmProjectMenu: JsmProjectMenu })=>JsmProjectMenu), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jsm-project-menu/src/ui/project-menu/index.tsx"
    });
    const $044e27f3d755a1d3$export$bf0d7afec25f82d7 = (0, $5uXOq.memo)(({ projectData: projectData, spotlight: spotlight })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.jsm-project-menu",
            packageName: "jiraNavigationAppsSidebarNav4JsmProjectMenu"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.sidebar.jsm-project-menu"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.jsm-project-menu.loading-lazy",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($044e27f3d755a1d3$var$LazySidebarContent, {
            projectData: projectData,
            spotlight: spotlight
        })))));
});
parcelRegister("h1MlY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8MFe5")
    ]).then(()=>parcelRequire('22eIY'));
});
parcelRegister("k2PPW", function(module, exports) {
    $parcel$export(module.exports, "JswProjectMenu", ()=>$37f44a28095ceb78$export$6bfce83b67850c4);
    var $erlTu;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $2vSU6;
    var $c1pSA;
    var $igsK5;
    const $37f44a28095ceb78$export$6bfce83b67850c4 = ({ projectData: projectData, spotlight: spotlight })=>{
        const project = (0, $8Uumt.useFragment)((0, (0, parcelRequire("erlTu")).default), projectData);
        if (project.softwareBoardCount && project.softwareBoardCount > 0 && project.projectStyle === (0, (0, parcelRequire("2vSU6")).COMPANY_MANAGED_PROJECT)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c1pSA")).JswExpandableProject), {
            projectData: project,
            spotlight: spotlight
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("igsK5")).JswNonExpandableProject), {
            projectData: project,
            spotlight: spotlight
        });
    };
});
parcelRegister("erlTu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$40b193e92809e464$export$2e2bcd8739ae039);
    const $40b193e92809e464$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "JswProjectMenu",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "softwareBoardCount"
            },
            {
                "kind": "ScalarField",
                "name": "projectStyle"
            },
            {
                "kind": "FragmentSpread",
                "name": "JswNonExpandableProject"
            },
            {
                "kind": "FragmentSpread",
                "name": "JswExpandableProject"
            }
        ],
        "type": "JiraProject"
    };
    $40b193e92809e464$var$node.hash = "7cc91a753899861d32e66014f2049a36";
    var $40b193e92809e464$export$2e2bcd8739ae039 = $40b193e92809e464$var$node;
});
parcelRegister("c1pSA", function(module, exports) {
    $parcel$export(module.exports, "JswExpandableProject", ()=>$fb08c4a99aac50be$export$a77599e713340697);
    var $kKbGS;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $6Lyip;
    var $7XluA;
    var $4mO32;
    var $kavsL;
    var $fNJRN;
    var $jhS4y;
    var $c16H2;
    var $338xa;
    var $7C7jZ;
    var $dQbFB;
    var $4zcxJ;
    var $76MhN;
    var $60FHh;
    var $koeKL;
    var $dcP6E;
    var $lnznH;
    var $cZa9B;
    var $dwZUI;
    const $fb08c4a99aac50be$export$a77599e713340697 = ({ projectData: projectData, spotlight: spotlight })=>{
        const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, (0, parcelRequire("fNJRN")).useProjectsAnalyticsL1)();
        const project = (0, $8Uumt.useFragment)((0, (0, parcelRequire("kKbGS")).default), projectData);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                projectId: project.id,
                noOfBoardsToFetch: (0, $ba4e5f586c2a87d8$export$420a3ee5deb615a9)
            }), [
            cloudId,
            project.id
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("dwZUI")).asyncJswExpandableProjectQuery), entryPointParams);
        const triggerRef = (0, (0, parcelRequire("4zcxJ")).useExpandableEntryPointTrigger)(entryPointActions);
        const { getLinkProps: getLinkProps } = (0, (0, parcelRequire("7C7jZ")).useGetLinkProps)();
        if (!project) return null;
        const popupItemAction = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("60FHh")).ProjectActions), {
                projectFragment: project
            });
        const menuId = (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(project.projectKey);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            menuId: menuId,
            onSystemToggle: (hasExpanded)=>{
                if (hasExpanded) entryPointActions.load();
            },
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) {
                    entryPointActions.load();
                    sendProjectMenuItemAnalyticsEvent({
                        starred: project.isFavourite ?? false,
                        recent: !project.isFavourite,
                        projectId: project.projectId,
                        projectType: project.projectType
                    });
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Lyip")).OnboardingSpotlightMaybe), {
            key: project.projectKey,
            spotlight: spotlight
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            ...getLinkProps((0, (0, parcelRequire("76MhN")).removeBaseUrl)(project.webUrl)),
            actionsOnHover: popupItemAction(),
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dcP6E")).ContainerAvatar), {
                src: project.avatar.large
            }),
            ref: triggerRef,
            onClick: (ev)=>{
                if ((0, (0, parcelRequire("kavsL")).isNormalClick)(ev)) ev.preventDefault();
            },
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, project.name)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jsw-expandable-project",
            packageName: (0, $ba4e5f586c2a87d8$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $ba4e5f586c2a87d8$export$d57b6b390e78d90f),
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null),
            runtimeProps: entryPointParams
        })));
    };
});
parcelRegister("kKbGS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c3bea37742d5a83$export$2e2bcd8739ae039);
    const $6c3bea37742d5a83$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "JswExpandableProject",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "projectKey",
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "projectKey"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectId"
                },
                "action": "THROW",
                "path": "projectId"
            },
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            {
                "kind": "ScalarField",
                "name": "projectType"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "large"
                            },
                            "action": "THROW",
                            "path": "avatar.large"
                        }
                    ]
                },
                "action": "THROW",
                "path": "avatar"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "name"
                },
                "action": "THROW",
                "path": "name"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "webUrl"
                },
                "action": "THROW",
                "path": "webUrl"
            },
            {
                "kind": "FragmentSpread",
                "name": "ProjectActions"
            }
        ],
        "type": "JiraProject"
    };
    $6c3bea37742d5a83$var$node.hash = "97fa53b11ac066ee14270d6da1ac0254";
    var $6c3bea37742d5a83$export$2e2bcd8739ae039 = $6c3bea37742d5a83$var$node;
});
parcelRegister("7C7jZ", function(module, exports) {
    $parcel$export(module.exports, "useGetLinkProps", ()=>$a1cefbecfd084e6c$export$a3307878c8496d13);
    var $5uXOq = parcelRequire("5uXOq");
    var $9VXkC;
    var $doZTA;
    const $a1cefbecfd084e6c$export$a3307878c8496d13 = ()=>{
        const [{ location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const getLinkProps = (0, $5uXOq.useCallback)((menuItemPath, options)=>$a1cefbecfd084e6c$var$getMenuLinkPropsFromUrlPath({
                currentPath: location.pathname,
                menuItemPath: menuItemPath,
                options: options
            }), [
            location.pathname
        ]);
        const getLinkPropsFromRoute = (0, $5uXOq.useCallback)((menuItemRoute, pathParamValues = {}, options)=>{
            const menuItemPath = (0, (0, parcelRequire("9VXkC")).generatePath)(menuItemRoute.path, pathParamValues);
            return getLinkProps(menuItemPath, options);
        }, [
            getLinkProps
        ]);
        return {
            getLinkPropsFromRoute: getLinkPropsFromRoute,
            getLinkProps: getLinkProps
        };
    };
    const $a1cefbecfd084e6c$var$defaultOptions = {
        shouldMatchExactPath: true
    };
    const $a1cefbecfd084e6c$var$getMenuLinkPropsFromUrlPath = ({ currentPath: currentPath, menuItemPath: menuItemPath, options: options })=>{
        const { shouldMatchExactPath: shouldMatchExactPath } = {
            ...$a1cefbecfd084e6c$var$defaultOptions,
            ...options
        };
        return {
            href: menuItemPath,
            isSelected: shouldMatchExactPath ? currentPath.replace(/\/$/, '') === menuItemPath.replace(/\/$/, '') : currentPath.includes(menuItemPath.replace(/\/$/, ''))
        };
    };
});
parcelRegister("60FHh", function(module, exports) {
    $parcel$export(module.exports, "ProjectActions", ()=>$0230a4e09f5a8c38$export$7f68bfd3564d5c6f);
    var $5jRC6;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8Uumt = parcelRequire("8Uumt");
    var $dIWbq;
    var $kgoHi;
    var $3bDjY;
    var $1ADgn;
    var $4R6GH;
    var $koVbs;
    var $hUpXm;
    var $1xonH;
    var $ccuaM;
    var $brwH6;
    var $jzmXi;
    var $7TnTU;
    const $0230a4e09f5a8c38$export$7f68bfd3564d5c6f = ({ projectFragment: projectFragment, isCorePremiumUserSeat: isCorePremiumUserSeat = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent, sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent } = (0, (0, parcelRequire("hUpXm")).useProjectsAnalyticsL2)();
        const createBoardButtonRef = (0, (0, parcelRequire("4R6GH")).fg)('nav4_simplified_board_create_beta') ? (0, $5uXOq.useRef)(null) : undefined;
        const project = (0, $8Uumt.useFragment)((0, (0, parcelRequire("5jRC6")).default), projectFragment);
        const onClickCreateBoard = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("1ADgn")).default)();
            const { isFavourite: isFavourite, projectId: projectId, projectType: projectType } = project;
            sendCreateBoardOnBoardMenuItemAnalyticsEvent({
                starred: isFavourite ?? false,
                recent: !isFavourite,
                projectId: projectId,
                projectType: projectType
            });
        }, [
            sendCreateBoardOnBoardMenuItemAnalyticsEvent,
            project
        ]);
        const projectActionMenu = (0, $5uXOq.useMemo)(()=>{
            return (0, (0, parcelRequire("4R6GH")).fg)('use-relay-entrypoints-for-project-actions-menu') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ccuaM")).ProjectActionMenuNew), {
                onClick: ()=>{
                    const { isFavourite: isFavourite, projectId: projectId, projectType: projectType } = project;
                    sendMeatBallDropDownOnProjectsAnalyticsEvent({
                        starred: isFavourite ?? false,
                        recent: !isFavourite,
                        projectId: projectId,
                        projectType: projectType
                    });
                },
                projectKey: project.projectKey,
                isCorePremiumUserSeat: isCorePremiumUserSeat
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ccuaM")).ProjectActionMenu), {
                onClick: ()=>{
                    const { isFavourite: isFavourite, projectId: projectId, projectType: projectType } = project;
                    sendMeatBallDropDownOnProjectsAnalyticsEvent({
                        starred: isFavourite ?? false,
                        recent: !isFavourite,
                        projectId: projectId,
                        projectType: projectType
                    });
                },
                projectFragment: project,
                isCorePremiumUserSeat: isCorePremiumUserSeat
            });
        }, [
            project,
            isCorePremiumUserSeat,
            sendMeatBallDropDownOnProjectsAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.050",
            alignItems: "center"
        }, (0, (0, parcelRequire("7TnTU")).isCompanyManagedSoftwareProject)(project.projectStyle, project.projectType) && !(0, (0, parcelRequire("4R6GH")).fg)('nav4-simplified-board-create') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("jzmXi")).default).createBoard)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xonH")).CommonNavMenuButton), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("dIWbq"))))),
            label: formatMessage((0, (0, parcelRequire("jzmXi")).default).createBoard),
            onClick: onClickCreateBoard
        })), (0, (0, parcelRequire("7TnTU")).isCompanyManagedSoftwareProject)(project.projectStyle, project.projectType) && (0, (0, parcelRequire("4R6GH")).fg)('nav4-simplified-board-create') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("brwH6")).BoardCreate), {
            projectId: project.projectId,
            projectAvatar: project.avatar?.large || undefined,
            projectKey: project.projectKey,
            ...(0, (0, parcelRequire("4R6GH")).fg)('nav4_simplified_board_create_beta') && {
                triggerRef: createBoardButtonRef
            },
            renderTrigger: ({ triggerRef: triggerRef, ...props })=>{
                const setRef = (0, (0, parcelRequire("4R6GH")).fg)('nav4_simplified_board_create_beta') ? (buttonElement)=>{
                    if (createBoardButtonRef) createBoardButtonRef.current = buttonElement;
                    if (typeof triggerRef === 'function') triggerRef(buttonElement);
                } : (0, ($parcel$interopDefault($8Rkzz)));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: formatMessage((0, (0, parcelRequire("jzmXi")).default).createBoard)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xonH")).CommonNavMenuButton), {
                    ...props,
                    onClick: (event)=>{
                        const { onClick: onClick } = props;
                        onClick?.(event);
                        sendCreateBoardOnBoardMenuItemAnalyticsEvent({
                            starred: project.isFavourite ?? false,
                            recent: !project.isFavourite,
                            projectId: project.projectId,
                            projectType: project.projectType
                        });
                    },
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("dIWbq"))))),
                    label: formatMessage((0, (0, parcelRequire("jzmXi")).default).createBoard),
                    ref: (0, (0, parcelRequire("4R6GH")).fg)('nav4_simplified_board_create_beta') ? setRef : triggerRef
                }));
            }
        })), projectActionMenu);
    };
});
parcelRegister("5jRC6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a16e1f422bc99009$export$2e2bcd8739ae039);
    const $a16e1f422bc99009$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ProjectActions",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "projectKey",
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "projectKey"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectId"
                },
                "action": "THROW",
                "path": "projectId"
            },
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            {
                "kind": "ScalarField",
                "name": "projectStyle"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectType"
                },
                "action": "THROW",
                "path": "projectType"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_navigationProjectActionMenu_ProjectActionMenu"
            },
            {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "large"
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
    $a16e1f422bc99009$var$node.hash = "bc47ec09c3b2847c107052a602a25230";
    var $a16e1f422bc99009$export$2e2bcd8739ae039 = $a16e1f422bc99009$var$node;
});
parcelRegister("brwH6", function(module, exports) {
    $parcel$export(module.exports, "BoardCreate", ()=>$07d90eee58b2fab1$export$c753ba73bc24874c);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $6prxh;
    var $1P6DN;
    const $07d90eee58b2fab1$export$c753ba73bc24874c = ({ projectId: projectId, projectAvatar: projectAvatar, projectKey: projectKey, renderTrigger: renderTrigger, triggerRef: triggerRef })=>{
        if (!projectId || !projectKey) {
            (0, (0, parcelRequire("6prxh")).fireBoardCreateErrorAnalytics)({
                error: new Error('Failed to load board create flyout menu: projectId or projectKey undefined'),
                attributes: {
                    projectId: projectId,
                    projectKey: projectKey
                },
                id: 'loadFlyoutMenu'
            });
            return null;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1P6DN")).BoardCreateFlyoutMenu), {
            renderTrigger: renderTrigger,
            projectId: projectId,
            projectKey: projectKey,
            projectAvatar: projectAvatar,
            ...(0, (0, parcelRequire("4R6GH")).fg)('nav4_simplified_board_create_beta') && {
                triggerRef: triggerRef
            }
        });
    };
});
parcelRegister("6prxh", function(module, exports) {
    $parcel$export(module.exports, "fireBoardCreateErrorAnalytics", ()=>$a085e033b99a140e$export$77dbc1f87d29b068);
    $parcel$export(module.exports, "descriptionMapping", ()=>$a085e033b99a140e$export$56900bfb74887fe8);
    var $jcw0u;
    var $h3KSk;
    var $6p4sE;
    const $a085e033b99a140e$export$77dbc1f87d29b068 = ({ attributes: attributes, id: id, error: error })=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            attributes: attributes,
            meta: {
                id: `jiraSoftwareBoardCreate_${id}`,
                packageName: (0, (0, parcelRequire("h3KSk")).BOARD_CREATE_PACKAGE_NAME),
                teamName: (0, (0, parcelRequire("h3KSk")).TEAM_NAME)
            }
        });
    };
    const $a085e033b99a140e$export$56900bfb74887fe8 = {
        [(0, (0, parcelRequire("h3KSk")).BOARD_TYPES).KANBAN]: (0, (0, parcelRequire("6p4sE")).default).kanbanBoardCreationDescription,
        [(0, (0, parcelRequire("h3KSk")).BOARD_TYPES).SCRUM]: (0, (0, parcelRequire("6p4sE")).default).scrumBoardCreationDescription
    };
});
parcelRegister("h3KSk", function(module, exports) {
    $parcel$export(module.exports, "FLYOUT_MENU_CONTENT_ID", ()=>$f576620d788b19e6$export$ff67d81ebedcc801);
    $parcel$export(module.exports, "BOARD_CREATE_PACKAGE_NAME", ()=>$f576620d788b19e6$export$3df8123340981894);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$f576620d788b19e6$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "BOARD_TYPES", ()=>$f576620d788b19e6$export$165dc6fdd115b0c1);
    $parcel$export(module.exports, "BOARD_SOURCE_FIELDS", ()=>$f576620d788b19e6$export$318250ad9945de5c);
    $parcel$export(module.exports, "BOARD_SOURCE_FIELDS_JQLTERM", ()=>$f576620d788b19e6$export$9f85086c10bd31f5);
    $parcel$export(module.exports, "PICKER_SEARCH_DEBOUNCE_TIME", ()=>$f576620d788b19e6$export$f487cf015ececc3a);
    $parcel$export(module.exports, "VALIDATION_ERROR_EMPTY", ()=>$f576620d788b19e6$export$7b060a5763a6e199);
    $parcel$export(module.exports, "BOARD_NAME_LIMIT", ()=>$f576620d788b19e6$export$d760e95d248dc3a3);
    const $f576620d788b19e6$export$edded98b84a6f50f = 'jsw-board-create';
    const $f576620d788b19e6$export$ff67d81ebedcc801 = 'jsw-board-create-flyout-menu-content';
    const $f576620d788b19e6$export$3df8123340981894 = 'jiraSoftwareBoardCreate';
    const $f576620d788b19e6$export$d57b6b390e78d90f = 'deliveroo';
    const $f576620d788b19e6$export$165dc6fdd115b0c1 = {
        KANBAN: 'KANBAN',
        SCRUM: 'SCRUM'
    };
    const $f576620d788b19e6$export$318250ad9945de5c = {
        TEAM: 'team',
        ISSUE_TYPES: 'issueTypes',
        LABELS: 'labels',
        SAVED_FILTER: 'savedFilter'
    };
    const $f576620d788b19e6$export$9f85086c10bd31f5 = {
        [$f576620d788b19e6$export$318250ad9945de5c.ISSUE_TYPES]: 'type',
        [$f576620d788b19e6$export$318250ad9945de5c.LABELS]: 'labels'
    };
    const $f576620d788b19e6$export$f487cf015ececc3a = 500;
    const $f576620d788b19e6$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
    const $f576620d788b19e6$export$d760e95d248dc3a3 = 155;
});
parcelRegister("6p4sE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30e80f50e57185ba$export$2e2bcd8739ae039);
    var $7VHMR;
    var $30e80f50e57185ba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        boardCreationTitle: {
            "id": "software-board-create.common.board-creation-title",
            "defaultMessage": "Create a board"
        },
        scrumBoardCreationHeader: {
            "id": "software-board-create.common.scrum-board-creation-header",
            "defaultMessage": "Scrum"
        },
        scrumBoardCreationDescription: {
            "id": "software-board-create.common.scrum-board-creation-description",
            "defaultMessage": "Sprint towards your team objectives with a board, backlog, and reports."
        },
        kanbanBoardCreationHeader: {
            "id": "software-board-create.common.kanban-board-creation-header",
            "defaultMessage": "Kanban"
        },
        kanbanBoardCreationDescription: {
            "id": "software-board-create.common.kanban-board-creation-description",
            "defaultMessage": "Manage a continuous delivery of work with a kanban board and reports."
        },
        loadSavedFiltersErrorTitle: {
            "id": "software-board-create.common.load-saved-filters-error-title",
            "defaultMessage": "We can\u2019t load saved filters right now"
        },
        loadSavedFiltersErrorDescription: {
            "id": "software-board-create.common.load-saved-filters-error-description",
            "defaultMessage": "Refresh the page and try again."
        },
        requiredFieldsHeader: {
            "id": "software-board-create.common.required-fields-header",
            "defaultMessage": "Required fields are marked with an asterisk *"
        }
    });
});
parcelRegister("1P6DN", function(module, exports) {
    $parcel$export(module.exports, "BoardCreateFlyoutMenu", ()=>$585e525931061bc7$export$6a893f4168172b4e);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $BLPHT;
    var $dZbEw;
    var $3nfCi;
    const $585e525931061bc7$export$a27652ddcad2c9dc = ({ triggerRef: triggerRef, ...props })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            ...props,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("dZbEw"))))),
            label: "create board",
            ref: triggerRef,
            testId: "software-board-create.ui.flyout-menu.trigger"
        });
    };
    const $585e525931061bc7$export$6a893f4168172b4e = ({ renderTrigger: Trigger = $585e525931061bc7$export$a27652ddcad2c9dc, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            trigger: Trigger,
            shouldRenderToParent: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3nfCi")).AsyncFlyoutMenuContent), props));
});
parcelRegister("3nfCi", function(module, exports) {
    $parcel$export(module.exports, "AsyncFlyoutMenuContent", ()=>$ec0472afe4c77c87$export$3f0e1916911c9d6a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $h3KSk;
    var $37QrD;
    var $jFvRN;
    const $ec0472afe4c77c87$var$entryPointParams = {};
    const $ec0472afe4c77c87$export$3f0e1916911c9d6a = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("37QrD")).flyoutMenuContentEntryPoint), $ec0472afe4c77c87$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: (0, (0, parcelRequire("h3KSk")).FLYOUT_MENU_CONTENT_ID),
            packageName: (0, (0, parcelRequire("h3KSk")).BOARD_CREATE_PACKAGE_NAME),
            teamName: (0, (0, parcelRequire("h3KSk")).TEAM_NAME),
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jFvRN")).FlyoutMenuContentFallback), null),
            errorFallback: "flag",
            runtimeProps: props
        });
    };
});
parcelRegister("37QrD", function(module, exports) {
    $parcel$export(module.exports, "flyoutMenuContentEntryPoint", ()=>$dfaa4ef5476ceb15$export$e6b36ab0519985d7);
    var $eufEc;
    var $fEDBv;
    const $dfaa4ef5476ceb15$export$e6b36ab0519985d7 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("kWGoR"))), {
            moduleId: "53a3dd04"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("kWGoR", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "FlyoutContentContainer", ()=>$1c9edbc1633491d5$export$b7a36d8992ebabdb);
    $parcel$export(module.exports, "default", ()=>$1c9edbc1633491d5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aRoVz;
    var $8EsNC;
    var $8mG85;
    var $c8oLN;
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $koVbs;
    var $h3KSk;
    var $6p4sE;
    var $iCBgO;
    const $1c9edbc1633491d5$export$b7a36d8992ebabdb = ({ children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1c9edbc1633491d5$var$menuContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1c9edbc1633491d5$var$headerContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1c9edbc1633491d5$var$headerStyles
        }, formatMessage((0, (0, parcelRequire("6p4sE")).default).boardCreationTitle))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c8oLN")).default), {
            block: "space.050"
        }, children));
    };
    const $1c9edbc1633491d5$var$BoardCreateFlyoutMenuContent = ({ props: { projectId: projectId, projectAvatar: projectAvatar, projectKey: projectKey, triggerRef: triggerRef } })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const dropdownItems = (0, $5uXOq.useMemo)(()=>{
            const items = [
                {
                    boardType: (0, (0, parcelRequire("h3KSk")).BOARD_TYPES).SCRUM,
                    title: formatMessage((0, (0, parcelRequire("6p4sE")).default).scrumBoardCreationHeader),
                    description: formatMessage((0, (0, parcelRequire("6p4sE")).default).scrumBoardCreationDescription),
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8mG85"))))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    })
                },
                {
                    boardType: (0, (0, parcelRequire("h3KSk")).BOARD_TYPES).KANBAN,
                    title: formatMessage((0, (0, parcelRequire("6p4sE")).default).kanbanBoardCreationHeader),
                    description: formatMessage((0, (0, parcelRequire("6p4sE")).default).kanbanBoardCreationDescription),
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8EsNC"))))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    })
                }
            ];
            return items.map(({ boardType: boardType, ...props }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iCBgO")).DropdownItemContainer), {
                    key: boardType,
                    entryPointProps: {
                        boardType: boardType,
                        projectId: projectId,
                        projectAvatar: projectAvatar,
                        projectKey: projectKey,
                        triggerRef: triggerRef
                    },
                    ...(0, (0, parcelRequire("4R6GH")).fg)('forward_ref_modalentrypointdropdownitemtrigger') && {
                        index: index
                    },
                    ...props
                }));
        }, [
            formatMessage,
            projectId,
            projectAvatar,
            projectKey,
            triggerRef
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1c9edbc1633491d5$export$b7a36d8992ebabdb, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, dropdownItems));
    };
    var $1c9edbc1633491d5$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1c9edbc1633491d5$var$BoardCreateFlyoutMenuContent);
    const $1c9edbc1633491d5$var$headerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: 'font.heading.xxsmall',
        color: 'color.text.subtlest'
    });
    const $1c9edbc1633491d5$var$menuContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '273px',
        paddingTop: 'space.100',
        paddingBottom: 'space.100'
    });
    const $1c9edbc1633491d5$var$headerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: 'space.200',
        padding: 'space.200',
        paddingTop: 'space.100',
        paddingBottom: 'space.100'
    });
});
parcelRegister("aRoVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c1f89f82839ba50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    const $6c1f89f82839ba50$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;
});
parcelRegister("8EsNC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $64c8661ab6d81803$var$_react = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $64c8661ab6d81803$var$_baseNew = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $64c8661ab6d81803$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $64c8661ab6d81803$var$BoardIcon = (props)=>$64c8661ab6d81803$var$_react.default.createElement($64c8661ab6d81803$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M5.583 2.75H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25h3.583m0-10.5v10.5m0-10.5h4.834m-4.834 10.5h4.834m0-10.5H14c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25h-3.583m0-10.5v10.5"/>`
        }, props));
    $64c8661ab6d81803$var$BoardIcon.displayName = 'BoardIcon';
    var $64c8661ab6d81803$var$_default = module.exports.default = $64c8661ab6d81803$var$BoardIcon;
});
parcelRegister("8mG85", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $61710ed7f2aa84a3$var$_react = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $61710ed7f2aa84a3$var$_baseNew = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $61710ed7f2aa84a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $61710ed7f2aa84a3$var$SprintIcon = (props)=>$61710ed7f2aa84a3$var$_react.default.createElement($61710ed7f2aa84a3$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.5 6.25a5.5 5.5 0 1 0-5.5 5.5m0 0H0m8 0h6.75m-3-3.5 3.5 3.5-3.5 3.5"/>`
        }, props));
    $61710ed7f2aa84a3$var$SprintIcon.displayName = 'SprintIcon';
    var $61710ed7f2aa84a3$var$_default = module.exports.default = $61710ed7f2aa84a3$var$SprintIcon;
});
parcelRegister("c8oLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e401c8401021557f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8CUq3;
    function $e401c8401021557f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e401c8401021557f$var$baseStyles = {
        name: "1khn195",
        styles: "box-sizing:border-box"
    };
    const $e401c8401021557f$var$blockBleedMap = {
        'space.025': {
            name: "9w2fxh",
            styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "1qhe0y6",
            styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "s0o2nz",
            styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "151e4o3",
            styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "16sn062",
            styles: "margin-block:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $e401c8401021557f$var$inlineBleedMap = {
        'space.025': {
            name: "16oxh68",
            styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "tdc6fz",
            styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "crujrn",
            styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "y28d58",
            styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "1vfkteg",
            styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $e401c8401021557f$var$Bleed = (0, ($parcel$interopDefault($5uXOq))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
        const resolvedStyles = (0, (0, parcelRequire("8CUq3")).parseXcss)(xcss);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: resolvedStyles.static,
            css: [
                $e401c8401021557f$var$baseStyles,
                (inline || all) && $e401c8401021557f$var$inlineBleedMap[inline || all],
                (block || all) && $e401c8401021557f$var$blockBleedMap[block || all],
                resolvedStyles.emotion
            ],
            "data-testid": testId
        }, children);
    });
    $e401c8401021557f$var$Bleed.displayName = 'Bleed';
    var $e401c8401021557f$export$2e2bcd8739ae039 = $e401c8401021557f$var$Bleed;
});
parcelRegister("iCBgO", function(module, exports) {
    $parcel$export(module.exports, "DropdownItemContainer", ()=>$8729a548ec5065a8$export$cfb1162696b4c012);
    var $5uXOq = parcelRequire("5uXOq");
    var $l1N8i;
    var $f5TWP;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $4R6GH;
    var $koVbs;
    var $lXAdy;
    var $8zOmE;
    var $2NMNM;
    var $h3KSk;
    var $gPHY5;
    var $4MxwN;
    var $aDXGG;
    const $8729a548ec5065a8$export$cfb1162696b4c012 = ({ entryPointProps: entryPointProps, title: title, description: description, icon: icon, index: index })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const triggerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (index === 0 && triggerRef.current && (0, (0, parcelRequire("4R6GH")).fg)('forward_ref_modalentrypointdropdownitemtrigger')) triggerRef.current.focus();
        }, [
            index
        ]);
        const handleOnDropdownItemClick = (0, $5uXOq.useCallback)(()=>{
            const boardTypePascalCase = entryPointProps.boardType === (0, (0, parcelRequire("h3KSk")).BOARD_TYPES).SCRUM ? 'Scrum' : 'Kanban';
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'dropdownItem',
                action: 'clicked'
            }), `create${boardTypePascalCase}Board`);
        }, [
            createAnalyticsEvent,
            entryPointProps.boardType
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lXAdy")).ModalEntryPointDropdownItemTrigger), {
            "aria-label": formatMessage((0, (0, parcelRequire("aDXGG")).default).createBoardLabel, {
                boardType: entryPointProps.boardType.toLowerCase()
            }),
            ...(0, (0, parcelRequire("4R6GH")).fg)('forward_ref_modalentrypointdropdownitemtrigger') && {
                forwardedRef: triggerRef
            },
            entryPoint: (0, (0, parcelRequire("gPHY5")).boardCreateModalEntryPoint),
            testId: "software-board-create.ui.flyout-menu.flyout-menu-content.dropdown-item-container.dropdown-item-trigger",
            interactionName: "open-create-board-modal",
            entryPointProps: entryPointProps,
            Fallback: (0, (0, parcelRequire("4MxwN")).BoardCreateModalFallback),
            onClick: handleOnDropdownItemClick,
            useInternalModal: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100",
            alignBlock: "start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            alignInline: "center",
            xcss: $8729a548ec5065a8$var$itemIconBackgroundStyles
        }, icon), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, title), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "medium"
        }, description))));
    };
    const $8729a548ec5065a8$var$ICON_BACKGROUND_CONTAINER_SIZE = '32px';
    const $8729a548ec5065a8$var$itemIconBackgroundStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.neutral',
        width: $8729a548ec5065a8$var$ICON_BACKGROUND_CONTAINER_SIZE,
        height: $8729a548ec5065a8$var$ICON_BACKGROUND_CONTAINER_SIZE,
        borderRadius: "var(--ds-border-radius-050, 3px)",
        padding: 'space.050',
        flexShrink: 0
    });
});
parcelRegister("lXAdy", function(module, exports) {
    $parcel$export(module.exports, "ModalEntryPointDropdownItemTrigger", ()=>$d1639b87be26e4ed$export$82b29db923c97084);
    var $5uXOq = parcelRequire("5uXOq");
    var $6B7KL;
    var $2KAtx;
    const $d1639b87be26e4ed$export$82b29db923c97084 = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef, ...dropdownProps })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KAtx")).ModalEntryPointPressableTrigger), {
            forwardedRef: forwardedRef,
            entryPoint: entryPoint,
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            errorAttributes: errorAttributes,
            Fallback: Fallback,
            interactionName: interactionName,
            title: modalTitle,
            modalProps: modalProps,
            useInternalModal: useInternalModal
        }, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                ref: ref,
                ...dropdownProps
            }, children));
    };
});
parcelRegister("gPHY5", function(module, exports) {
    $parcel$export(module.exports, "boardCreateModalEntryPoint", ()=>$7eac46aad6713698$export$ae34a65266b8e906);
    var $eufEc;
    var $fEDBv;
    const $7eac46aad6713698$export$ae34a65266b8e906 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("4MxwN"))), {
            moduleId: "6c073853"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("4MxwN", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "BoardCreateModalFallback", ()=>$be001cef457a59e7$export$303db58b19f6b446);
    $parcel$export(module.exports, "default", ()=>$be001cef457a59e7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $9fuVs;
    var $4R6GH;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $2NMNM;
    var $6p4sE;
    var $6prxh;
    var $2NRUh;
    var $keWq7;
    var $4K4Ab;
    const $be001cef457a59e7$var$MODAL_WIDTH = 1000;
    const $be001cef457a59e7$var$MODAL_HEIGHT = 551;
    const $be001cef457a59e7$export$303db58b19f6b446 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            height: $be001cef457a59e7$var$MODAL_HEIGHT,
            width: $be001cef457a59e7$var$MODAL_WIDTH,
            label: (0, (0, parcelRequire("4R6GH")).fg)('a11y_violations_fixes_fase_2') ? formatMessage((0, (0, parcelRequire("4K4Ab")).default).loadingLabel) : undefined
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("keWq7")).BoardCreateFormFallback), null));
    };
    const $be001cef457a59e7$var$BoardCreateModal = ({ boardType: boardType, projectId: projectId, onClose: onClose, triggerRef: triggerRef })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleOnClose = (_mouseEvent, _analyticEvent, didSubmit)=>{
            const event = createAnalyticsEvent({
                action: 'closed',
                actionSubject: 'modalDialog'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'createNewBoardModal', {
                didSubmit: !!didSubmit,
                boardType: boardType.toLowerCase()
            });
            onClose?.();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            testId: "software-board-create.ui.modal",
            onClose: handleOnClose,
            width: $be001cef457a59e7$var$MODAL_WIDTH,
            height: $be001cef457a59e7$var$MODAL_HEIGHT,
            label: (0, (0, parcelRequire("4R6GH")).fg)('nav4_simplified_board_create_beta') ? `${formatMessage((0, (0, parcelRequire("6p4sE")).default).boardCreationTitle)}. ${formatMessage((0, (0, parcelRequire("6prxh")).descriptionMapping)[boardType])}` : formatMessage((0, (0, parcelRequire("4K4Ab")).default).createBoardDialogLabel, {
                boardDescription: formatMessage((0, (0, parcelRequire("6prxh")).descriptionMapping)[boardType])
            }),
            ...(0, (0, parcelRequire("4R6GH")).fg)('nav4_simplified_board_create_beta') && {
                shouldReturnFocus: triggerRef
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("keWq7")).BoardCreateForm), {
            projectId: projectId,
            boardType: boardType,
            onClose: handleOnClose
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                boardType: boardType.toLowerCase()
            }
        }));
    };
    const $be001cef457a59e7$var$BoardCreateModalWithContext = ({ props: { projectAvatar: projectAvatar, projectKey: projectKey, ...restProps } })=>{
        const value = (0, $5uXOq.useMemo)(()=>({
                projectId: restProps.projectId,
                projectAvatar: projectAvatar,
                projectKey: projectKey
            }), [
            restProps.projectId,
            projectAvatar,
            projectKey
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2NRUh")).BoardCreateContext).Provider, {
            value: value
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "createNewBoard",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($be001cef457a59e7$var$BoardCreateModal, restProps))));
    };
    var $be001cef457a59e7$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($be001cef457a59e7$var$BoardCreateModalWithContext);
});
parcelRegister("2NRUh", function(module, exports) {
    $parcel$export(module.exports, "BoardCreateContext", ()=>$267ce53d896f9c4d$export$5169319147995508);
    $parcel$export(module.exports, "useBoardCreateContext", ()=>$267ce53d896f9c4d$export$768ffccd7d71d6d9);
    var $5uXOq = parcelRequire("5uXOq");
    const $267ce53d896f9c4d$var$initialContext = {
        projectId: undefined,
        projectAvatar: undefined,
        projectKey: undefined
    };
    const $267ce53d896f9c4d$export$5169319147995508 = (0, $5uXOq.createContext)($267ce53d896f9c4d$var$initialContext);
    const $267ce53d896f9c4d$export$768ffccd7d71d6d9 = ()=>(0, $5uXOq.useContext)($267ce53d896f9c4d$export$5169319147995508);
});
parcelRegister("keWq7", function(module, exports) {
    $parcel$export(module.exports, "BoardCreateFormFallback", ()=>$c2504b6b008fc3bd$export$efb232229a99ba7b);
    $parcel$export(module.exports, "BoardCreateForm", ()=>$c2504b6b008fc3bd$export$bc90d453a0e513ff);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $efXp3;
    var $8jRgk;
    var $3lQ26;
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $8CUq3;
    var $1DVhQ;
    var $8zOmE;
    var $2NMNM;
    var $BUgEw;
    var $hBw29;
    var $cPVty;
    var $aDJ8l;
    var $2ze4l;
    var $7GuB2;
    var $g5ZcC;
    var $iizLc;
    const $c2504b6b008fc3bd$export$efb232229a99ba7b = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $c2504b6b008fc3bd$var$formContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.1000",
            xcss: $c2504b6b008fc3bd$var$formContentStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $c2504b6b008fc3bd$var$columnStyles,
            spread: "space-between"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.300"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.150"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "150px",
            height: "20px",
            borderRadius: "3px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "100%",
            height: "12px",
            borderRadius: "3px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "20%",
            height: "12px",
            borderRadius: "3px"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "100px",
            height: "12px",
            borderRadius: "3px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "100%",
            height: "30px",
            borderRadius: "3px"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "200px",
            height: "12px",
            borderRadius: "3px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "100%",
            height: "30px",
            borderRadius: "3px"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            justifyContent: "end"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.050"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "70px",
            height: "32px",
            borderRadius: "3px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "70px",
            height: "32px",
            borderRadius: "3px"
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $c2504b6b008fc3bd$var$columnStyles,
            space: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "150px",
            height: "20px",
            borderRadius: "3px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "412px",
            height: "307px",
            borderRadius: "16px"
        }))));
    };
    const $c2504b6b008fc3bd$export$bc90d453a0e513ff = ({ boardType: boardType, projectId: projectId, onClose: onClose })=>{
        const { submit: submit } = (0, (0, parcelRequire("BUgEw")).useBoardCreateController)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleOnSubmit = (0, $5uXOq.useCallback)(async (data)=>{
            const errors = (0, (0, parcelRequire("iizLc")).validateFormData)(data);
            const hasValidationErrors = errors.boardName || errors.sourceType || errors.sourceValue;
            let sourceValueLength = 0;
            if (data.sourceValue != null) sourceValueLength = Array.isArray(data.sourceValue) ? data.sourceValue.length : 1;
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'createNewBoard', {
                sourceType: data.sourceType,
                sourceValueLength: sourceValueLength,
                errors: hasValidationErrors && errors
            });
            if (hasValidationErrors) return errors;
            await submit({
                boardType: boardType,
                formValues: data,
                locationProjectId: projectId ?? '',
                onSuccess: ()=>onClose(undefined, undefined, true)
            });
        }, [
            createAnalyticsEvent,
            submit,
            boardType,
            projectId,
            onClose
        ]);
        const resetSourceValue = (0, $5uXOq.useCallback)((setFieldValue)=>()=>setFieldValue((0, (0, parcelRequire("g5ZcC")).SOURCE_VALUE_FIELD_NAME), undefined), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $c2504b6b008fc3bd$var$formContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("efXp3")).default), {
            onSubmit: handleOnSubmit
        }, ({ formProps: formProps, submitting: submitting, setFieldValue: setFieldValue })=>(0, ($parcel$interopDefault($5uXOq))).createElement("form", {
                ...formProps,
                noValidate: true,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_18m91wug _1bsb1osq"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                gap: "space.1000",
                xcss: $c2504b6b008fc3bd$var$formContentStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                xcss: $c2504b6b008fc3bd$var$columnStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBw29")).ModalHeader), {
                type: boardType
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $c2504b6b008fc3bd$var$formFieldsContainerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3lQ26")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2ze4l")).BoardNameField), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3lQ26")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7GuB2")).SourceTypePicker), {
                resetSourceValue: resetSourceValue(setFieldValue)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g5ZcC")).SourceValuePicker), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $c2504b6b008fc3bd$var$buttonGroupContainerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8jRgk")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aDJ8l")).FormActions), {
                submitting: submitting,
                onClose: onClose
            })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                xcss: $c2504b6b008fc3bd$var$columnStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cPVty")).ModalIllustration), null))))));
    };
    const $c2504b6b008fc3bd$var$formStyles = null;
    const $c2504b6b008fc3bd$var$formContentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%',
        width: '100%'
    });
    const $c2504b6b008fc3bd$var$columnStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: 'calc(50% - 40px)',
        flex: 'none',
        paddingTop: 'space.200'
    });
    const $c2504b6b008fc3bd$var$formFieldsContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexGrow: 1
    });
    const $c2504b6b008fc3bd$var$buttonGroupContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        alignSelf: 'end',
        justifySelf: 'end'
    });
    const $c2504b6b008fc3bd$var$formContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.600',
        paddingLeft: 'space.600',
        paddingRight: 'space.600',
        paddingBottom: 'space.500',
        height: '100%'
    });
});
parcelRegister("efXp3", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$987e2ff089e89967$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$987e2ff089e89967$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$987e2ff089e89967$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $987e2ff089e89967$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $987e2ff089e89967$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        const childrenContent = (()=>{
            if (typeof children === 'function') {
                const result = children.length > 0 ? children({
                    formProps: {
                        onSubmit: handleSubmit,
                        ref: formRef,
                        onKeyDown: handleKeyDown
                    },
                    dirty: dirty,
                    reset: handleReset,
                    submitting: submitting,
                    disabled: isDisabled,
                    getState: ()=>form.getState(),
                    getValues: ()=>form.getState().values,
                    setFieldValue: form.change
                }) : children();
                return result === undefined ? null : result;
            }
            return children;
        })();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, childrenContent));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("8jRgk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09f31c1f2cf95b88$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $09f31c1f2cf95b88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $09f31c1f2cf95b88$var$formFooterWrapperStyles = {
        name: "1rruhyk",
        styles: "display:flex;justify-content:flex-end;margin-block-start:var(--ds-space-300, 24px)"
    };
    const $09f31c1f2cf95b88$var$justifyContentStyles = {
        name: "11g6mpt",
        styles: "justify-content:flex-start"
    };
    function $09f31c1f2cf95b88$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("footer", {
            css: [
                $09f31c1f2cf95b88$var$formFooterWrapperStyles,
                align === 'start' && $09f31c1f2cf95b88$var$justifyContentStyles
            ]
        }, children);
    }
});
parcelRegister("3lQ26", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3e71eeb72c100e3$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $l1N8i;
    var $dC5iT;
    var $8CUq3;
    const $b3e71eeb72c100e3$var$formSectionDescriptionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.100'
    });
    const $b3e71eeb72c100e3$var$formSectionWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.300'
    });
    const $b3e71eeb72c100e3$var$FormSectionWrapper = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b3e71eeb72c100e3$var$formSectionWrapperStyles
        }, children);
    };
    const $b3e71eeb72c100e3$var$FormSectionDescription = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b3e71eeb72c100e3$var$formSectionDescriptionStyles
        }, children);
    };
    const $b3e71eeb72c100e3$var$FormSection = ({ children: children, description: description, title: title })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)($b3e71eeb72c100e3$var$FormSectionWrapper, null, title && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l1N8i")).default), {
            size: "medium"
        }, title), description && (0, (0, parcelRequire("f8Sb3")).jsx)($b3e71eeb72c100e3$var$FormSectionDescription, null, description), children);
    };
    var $b3e71eeb72c100e3$export$2e2bcd8739ae039 = $b3e71eeb72c100e3$var$FormSection;
});
parcelRegister("BUgEw", function(module, exports) {
    $parcel$export(module.exports, "useBoardCreateController", ()=>$6954e7e33c19033d$export$b1247ee6c4be437f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $j5YhT;
    var $4R6GH;
    var $koVbs;
    var $4DrQd;
    var $7Cqm7;
    var $koeKL;
    var $lVJAU;
    var $iJZ8l;
    var $6prxh;
    var $6fAG8;
    var $2NRUh;
    var $96pTU;
    var $16xB9;
    var $3i0DH;
    const $6954e7e33c19033d$export$43cdff4ae424f89f = ()=>{
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        return (0, $5uXOq.useCallback)(({ id: id, projectId: projectId })=>{
            (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
                try {
                    if (!id) throw new Error('Failed to add board to project, missing id');
                    if (!projectId) throw new Error('Failed to add board to project, missing projectId');
                    const projectRelayDataId = (0, (0, parcelRequire("iJZ8l")).default)({
                        id: (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
                            siteId: cloudId,
                            projectId: String(projectId)
                        })
                    }, 'JiraProject');
                    if (!projectRelayDataId) throw new Error(`Failed to create project relay data id, projectId: ${projectId}`);
                    const project = store.get(projectRelayDataId);
                    if (!project) throw new Error(`Failed to find the project, projectId: ${projectId}`);
                    const projectBoardsConnection = project.getLinkedRecord('boards', {
                        first: (0, (0, parcelRequire("4DrQd")).NO_OF_BOARDS_TO_SHOW)
                    });
                    if (!projectBoardsConnection) throw new Error('Failed to find the project-boards connection');
                    const newNode = store.get(id);
                    if (!newNode) throw new Error(`Failed to find the new board, id: ${id}`);
                    const newEdge = (0, $8Uumt.ConnectionHandler).createEdge(store, projectBoardsConnection, newNode, 'JiraBoardEdge');
                    (0, $8Uumt.ConnectionHandler).insertEdgeBefore(projectBoardsConnection, newEdge);
                } catch (error) {
                    (0, (0, parcelRequire("6prxh")).fireBoardCreateErrorAnalytics)({
                        id: 'addBoardToProject',
                        error: error instanceof Error ? error : new Error(`Failed to add board to project: ${error}`)
                    });
                }
            });
        }, [
            environment,
            cloudId
        ]);
    };
    const $6954e7e33c19033d$export$b1247ee6c4be437f = ()=>{
        const { handleMutation: handleMutation } = (0, (0, parcelRequire("6fAG8")).useBoardCreateMutation)();
        const { projectKey: projectKey } = (0, (0, parcelRequire("2NRUh")).useBoardCreateContext)();
        const { showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag } = (0, (0, parcelRequire("96pTU")).useBoardCreateFlag)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const addBoardToProject = $6954e7e33c19033d$export$43cdff4ae424f89f();
        const isBacklogRoute = (0, (0, parcelRequire("4R6GH")).fg)('nav4_simplified_board_create_beta') ? (0, (0, parcelRequire("7Cqm7")).useIsBacklogRoute)() : false;
        const submit = (0, $5uXOq.useCallback)(async ({ boardType: boardType, locationProjectId: locationProjectId, formValues: formValues, onSuccess: onSuccess, onError: onError })=>{
            const input = (0, (0, parcelRequire("3i0DH")).transformInput)({
                boardType: boardType,
                locationProjectId: locationProjectId,
                formValues: formValues
            });
            try {
                const result = await handleMutation(input);
                onSuccess?.(result);
                showSuccessFlag({
                    title: formatMessage((0, (0, parcelRequire("16xB9")).default).successTitle)
                });
                addBoardToProject({
                    projectId: locationProjectId,
                    id: result.jira?.createBoard?.board?.__id
                });
                const resultBoardId = result?.jira?.createBoard?.board?.boardId;
                const resultBoardType = result?.jira?.createBoard?.board?.boardType;
                const boardUrl = (0, (0, parcelRequire("4R6GH")).fg)('fix_board_url_value_in_graphql_apis') ? (0, (0, parcelRequire("3i0DH")).buildBoardUrl)(result?.jira?.createBoard?.board?.boardUrl, resultBoardType) : (0, (0, parcelRequire("3i0DH")).buildBoardUrlOld)(projectKey, resultBoardId, resultBoardType);
                if (!boardUrl) (0, (0, parcelRequire("6prxh")).fireBoardCreateErrorAnalytics)({
                    error: new Error('Failed to generate board URL after board creation'),
                    attributes: {
                        boardId: resultBoardId,
                        boardType: resultBoardType
                    },
                    id: 'generateUrl'
                });
                else resultBoardType === 'SCRUM' && isBacklogRoute && (0, (0, parcelRequire("4R6GH")).fg)('nav4_simplified_board_create_beta') ? (0, (0, parcelRequire("3i0DH")).redirectToBacklog)(boardUrl) : push(boardUrl);
            } catch (error) {
                onError?.(error);
                showErrorFlag({
                    title: formatMessage((0, (0, parcelRequire("16xB9")).default).errorTitle),
                    description: formatMessage((0, (0, parcelRequire("16xB9")).default).errorDescription)
                });
                (0, (0, parcelRequire("6prxh")).fireBoardCreateErrorAnalytics)({
                    error: new Error(`Failed to create board: ${error}`),
                    id: 'createBoard'
                });
            }
        }, [
            handleMutation,
            showSuccessFlag,
            formatMessage,
            addBoardToProject,
            projectKey,
            isBacklogRoute,
            push,
            showErrorFlag
        ]);
        return {
            submit: submit
        };
    };
});
parcelRegister("7Cqm7", function(module, exports) {
    $parcel$export(module.exports, "useIsBacklogRoute", ()=>$6df6a0c87d7ecf35$export$1894da4846b402db);
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $6jY6G;
    const $6df6a0c87d7ecf35$export$1894da4846b402db = ()=>{
        const { name: name } = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        return (0, $5uXOq.useMemo)(()=>name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG) || name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG) || name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED), [
            name
        ]);
    };
});
parcelRegister("6fAG8", function(module, exports) {
    $parcel$export(module.exports, "useBoardCreateMutation", ()=>$1f641104976de7c6$export$99c7414664697f66);
    var $h3EhD;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $koeKL;
    const $1f641104976de7c6$export$99c7414664697f66 = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [commit] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("h3EhD")).default));
        const handleMutation = (0, $5uXOq.useCallback)(async (input)=>new Promise((resolve, reject)=>{
                commit({
                    variables: {
                        cloudId: cloudId,
                        input: input
                    },
                    onCompleted: (result)=>{
                        resolve(result);
                    },
                    onError: (error)=>{
                        reject(error);
                    }
                });
            }), [
            cloudId,
            commit
        ]);
        return {
            handleMutation: handleMutation
        };
    };
});
parcelRegister("h3EhD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d774c68c24dc8f2$export$2e2bcd8739ae039);
    const $9d774c68c24dc8f2$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        }, v3 = {
            "concreteType": "JiraBoard",
            "kind": "LinkedField",
            "name": "board",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "boardId"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                v2,
                {
                    "kind": "ScalarField",
                    "name": "boardType"
                },
                {
                    "kind": "ScalarField",
                    "name": "boardUrl"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__id"
                        }
                    ]
                }
            ]
        }, v4 = {
            "kind": "ScalarField",
            "name": "success"
        }, v5 = {
            "kind": "ScalarField",
            "name": "message"
        }, v6 = {
            "kind": "ScalarField",
            "name": "errorType"
        }, v7 = {
            "kind": "ScalarField",
            "name": "statusCode"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "useBoardCreateMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraCreateBoardPayload",
                                "kind": "LinkedField",
                                "name": "createBoard",
                                "plural": false,
                                "selections": [
                                    v3,
                                    v4,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v5,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    v6,
                                                    v7
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "useBoardCreateMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraCreateBoardPayload",
                                "kind": "LinkedField",
                                "name": "createBoard",
                                "plural": false,
                                "selections": [
                                    v3,
                                    v4,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v5,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v6,
                                                    v7,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v2
                                                        ],
                                                        "type": "BulkMutationErrorExtension"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "39733200dfeb8f5ca8e119e986adf5ee373acba404794290d4a84a17b45673c2",
                "metadata": {},
                "name": "useBoardCreateMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $9d774c68c24dc8f2$var$node.hash = "6559f8aeeafe0e444aad2224af38c3cb";
    var $9d774c68c24dc8f2$export$2e2bcd8739ae039 = $9d774c68c24dc8f2$var$node;
});
parcelRegister("96pTU", function(module, exports) {
    $parcel$export(module.exports, "useBoardCreateFlag", ()=>$0104309d6559195a$export$b93e10fcc9489915);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    const $0104309d6559195a$export$b93e10fcc9489915 = ()=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const showSuccessFlag = (0, $5uXOq.useCallback)(({ title: title, description: description })=>{
            showFlag({
                type: 'success',
                title: title,
                description: description,
                isAutoDismiss: true
            });
        }, [
            showFlag
        ]);
        const showErrorFlag = (0, $5uXOq.useCallback)(({ title: title, description: description })=>{
            showFlag({
                type: 'error',
                title: title,
                description: description,
                isAutoDismiss: true
            });
        }, [
            showFlag
        ]);
        return {
            showSuccessFlag: showSuccessFlag,
            showErrorFlag: showErrorFlag
        };
    };
});
parcelRegister("16xB9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01c40c2337fb8cba$export$2e2bcd8739ae039);
    var $7VHMR;
    var $01c40c2337fb8cba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        successTitle: {
            "id": "software-board-create.controllers.use-board-create-controller.success-title",
            "defaultMessage": "Board successfully created"
        },
        errorTitle: {
            "id": "software-board-create.controllers.use-board-create-controller.error-title",
            "defaultMessage": "We couldn\u2019t create the board"
        },
        errorDescription: {
            "id": "software-board-create.controllers.use-board-create-controller.error-description",
            "defaultMessage": "Refresh the page and try again."
        }
    });
});
parcelRegister("3i0DH", function(module, exports) {
    $parcel$export(module.exports, "transformInput", ()=>$e5dcc01ab0bf80c8$export$28b8f0b21b2796a2);
    $parcel$export(module.exports, "buildBoardUrlOld", ()=>$e5dcc01ab0bf80c8$export$b5a27f317af70564);
    $parcel$export(module.exports, "buildBoardUrl", ()=>$e5dcc01ab0bf80c8$export$d807737c3f4eaba6);
    $parcel$export(module.exports, "redirectToBacklog", ()=>$e5dcc01ab0bf80c8$export$594b405ab77720dc);
    var $h3KSk;
    const $e5dcc01ab0bf80c8$var$formatFieldInput = (input)=>{
        if (!input.sourceType || input.sourceType === (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).SAVED_FILTER || !input.sourceValue) return null;
        const { sourceType: sourceType, sourceValue: sourceValue } = input;
        switch(sourceType){
            case (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).TEAM:
                return {
                    teams: [
                        {
                            teamId: sourceValue.id
                        }
                    ]
                };
            case (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).ISSUE_TYPES:
                return {
                    issueTypes: sourceValue.map(({ value: value })=>({
                            issueTypeId: value
                        }))
                };
            case (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).LABELS:
                return {
                    labels: sourceValue.map(({ value: value })=>({
                            name: value
                        }))
                };
            default:
                {
                    const _exhaustiveCheck = sourceType;
                    return null;
                }
        }
    };
    const $e5dcc01ab0bf80c8$var$getCreateBoardSource = (formValues, locationProjectId)=>{
        if (formValues?.sourceType === (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).SAVED_FILTER) return {
            savedFilterId: formValues.sourceValue?.value ? Number(formValues.sourceValue.value) : null
        };
        return {
            fieldInput: {
                projects: [
                    {
                        projectId: locationProjectId
                    }
                ],
                ...formValues.sourceType && formValues.sourceValue && $e5dcc01ab0bf80c8$var$formatFieldInput(formValues)
            }
        };
    };
    const $e5dcc01ab0bf80c8$export$28b8f0b21b2796a2 = ({ boardType: boardType, locationProjectId: locationProjectId, formValues: formValues })=>({
            createBoardSource: $e5dcc01ab0bf80c8$var$getCreateBoardSource(formValues, locationProjectId),
            location: {
                locationId: locationProjectId,
                locationType: 'PROJECT'
            },
            name: formValues.boardName,
            preset: boardType
        });
    const $e5dcc01ab0bf80c8$export$b5a27f317af70564 = (projectKey, boardId, boardType)=>{
        if (!projectKey || !boardId) return null;
        return `/jira/software/c/projects/${projectKey}/boards/${boardId}${boardType === 'SCRUM' ? '/backlog' : ''}`;
    };
    const $e5dcc01ab0bf80c8$export$d807737c3f4eaba6 = (boardUrl, boardType)=>{
        if (!boardUrl) return null;
        return `${boardUrl}${boardType === 'SCRUM' ? '/backlog' : ''}`;
    };
    const $e5dcc01ab0bf80c8$export$594b405ab77720dc = (backlogUrl)=>{
        window.location.href = backlogUrl;
    };
});
parcelRegister("hBw29", function(module, exports) {
    $parcel$export(module.exports, "ModalHeader", ()=>$36f6cf40bfe43457$export$f50a68e3694789ee);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $luBm6;
    var $cgL5K;
    var $koVbs;
    var $6p4sE;
    var $6prxh;
    const $36f6cf40bfe43457$export$f50a68e3694789ee = ({ type: type })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return $5uXOq.createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, $5uXOq.createElement("h4", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8o0gd _k48pmoej _syaz1fxt"
            ])
        }, formatMessage((0, (0, parcelRequire("6p4sE")).default).boardCreationTitle)), $5uXOq.createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "medium",
            color: "color.text.accent.gray.bolder"
        }, (0, (0, parcelRequire("6prxh")).descriptionMapping)[type] && formatMessage((0, (0, parcelRequire("6prxh")).descriptionMapping)[type])), $5uXOq.createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "em",
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage((0, (0, parcelRequire("6p4sE")).default).requiredFieldsHeader)));
    };
    const $36f6cf40bfe43457$var$modalHeaderStyles = null;
});
parcelRegister("cPVty", function(module, exports) {
    $parcel$export(module.exports, "ModalIllustration", ()=>$9f435b77d548b26f$export$dc26d3e21d436b08);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $bUa6y;
    var $luBm6;
    var $2YF0r;
    var $koVbs;
    var $evWvw;
    const $9f435b77d548b26f$export$dc26d3e21d436b08 = ()=>{
        const state = (0, (0, parcelRequire("bUa6y")).useFormState)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("h5", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81bk4 _k48p1pd9 _syaz1gjq _18u01axu _1bto1l2s _1reo15vq _18m915vq _o5721q9c _p12fp3fh"
            ])
        }, state?.values.boardName?.trim() || formatMessage((0, (0, parcelRequire("evWvw")).default).illustrationPlaceHolderHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2YF0r")).default), {
            alt: formatMessage((0, (0, parcelRequire("evWvw")).default).illustrationAltText),
            height: "334px"
        })));
    };
    const $9f435b77d548b26f$var$modalIllustrationHeaderStyles = null;
});
parcelRegister("bUa6y", function(module, exports) {
    $parcel$export(module.exports, "useFormState", ()=>$0ed03f14f588391e$export$606f11b2eb45ecc6);
    var $5uXOq = parcelRequire("5uXOq");
    var $efXp3;
    const $0ed03f14f588391e$var$defaultSubscriptionConfig = {
        values: true
    };
    const $0ed03f14f588391e$var$getSubscriptionHash = (subscriptionConfig)=>{
        let hash = '';
        for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
        return hash;
    };
    const $0ed03f14f588391e$export$606f11b2eb45ecc6 = (subscriptionConfig = $0ed03f14f588391e$var$defaultSubscriptionConfig)=>{
        const { subscribe: subscribe } = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).FormContext));
        const [state, setState] = (0, $5uXOq.useState)();
        const subscriptionConfigHash = (0, $5uXOq.useMemo)(()=>$0ed03f14f588391e$var$getSubscriptionHash(subscriptionConfig), [
            subscriptionConfig
        ]);
        const config = (0, $5uXOq.useMemo)(()=>subscriptionConfig, [
            subscriptionConfigHash
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = subscribe((formState)=>{
                setState(formState);
            }, config);
            return ()=>unsubscribe();
        }, [
            subscribe,
            config
        ]);
        return state;
    };
});
parcelRegister("2YF0r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bda248573ba546d$export$2e2bcd8739ae039);
    var $dCLgq;
    var $iPiYN = parcelRequire("iPiYN");
    const $1bda248573ba546d$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($iPiYN)),
        srcDark: ($parcel$interopDefault($iPiYN))
    });
    var $1bda248573ba546d$export$2e2bcd8739ae039 = $1bda248573ba546d$var$Illustration;
    const $1bda248573ba546d$export$a179c88182cb9d56 = [
        0,
        0,
        448,
        334
    ];
});
parcelRegister("iPiYN", function(module, exports) {
    module.exports = new URL("bug-and-task-cards-in-a-column.455dfa61.svg", import.meta.url).toString();
});
parcelRegister("evWvw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a855b2f67ecf66fc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a855b2f67ecf66fc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        illustrationPlaceHolderHeader: {
            "id": "software-board-create.modal.illustration.illustration-place-holder-header",
            "defaultMessage": "New board"
        },
        illustrationAltText: {
            "id": "software-board-create.modal.illustration.illustration-alt-text",
            "defaultMessage": "Bug and task cards in a board column"
        }
    });
});
parcelRegister("aDJ8l", function(module, exports) {
    $parcel$export(module.exports, "FormActions", ()=>$015f57e976cf5b77$export$9494d5a5e5299081);
    var $5uXOq = parcelRequire("5uXOq");
    var $ldJSL;
    var $eCeGD;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $iLQ6N;
    const $015f57e976cf5b77$export$9494d5a5e5299081 = ({ onClose: onClose, submitting: submitting })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $015f57e976cf5b77$var$buttonGroupContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "subtle",
            isDisabled: submitting,
            onClick: onClose,
            testId: "software-board-create.ui.modal.form.actions.board-create-cancel-button"
        }, formatMessage((0, (0, parcelRequire("iLQ6N")).default).modalCancelButton)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "primary",
            type: "submit",
            isLoading: submitting,
            testId: "software-board-create.ui.modal.form.actions.board-create-confirm-button"
        }, formatMessage((0, (0, parcelRequire("iLQ6N")).default).modalConfirmButton))));
    };
    const $015f57e976cf5b77$var$buttonGroupContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBottom: 'space.100'
    });
});
parcelRegister("iLQ6N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ebfc75c64d3ab56$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7ebfc75c64d3ab56$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        modalConfirmButton: {
            "id": "software-board-create.modal.form.actions.modal-confirm-button",
            "defaultMessage": "Create"
        },
        modalCancelButton: {
            "id": "software-board-create.modal.form.actions.modal-cancel-button",
            "defaultMessage": "Cancel"
        }
    });
});
parcelRegister("2ze4l", function(module, exports) {
    $parcel$export(module.exports, "BoardNameField", ()=>$a633258a18403e34$export$f710d048b5529d22);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $qfj8c;
    var $7O4UO;
    var $bUa6y;
    var $kY99m;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $h3KSk;
    var $4D12X;
    const $a633258a18403e34$export$f710d048b5529d22 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const formState = (0, (0, parcelRequire("bUa6y")).useFormState)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [value, setValue] = (0, $5uXOq.useState)('');
        const hasEdited = (0, $5uXOq.useRef)(false);
        const debouncedHandleOnChange = (0, $5uXOq.useRef)((0, ($parcel$interopDefault($lFKmC)))(()=>{
            if (!hasEdited.current) {
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: 'changed',
                    actionSubject: 'input'
                }), 'boardName');
                hasEdited.current = true;
            }
        }, 300)).current;
        const handleOnChange = (0, $5uXOq.useCallback)((event)=>{
            setValue(event.currentTarget.value);
            const newValue = event.currentTarget.value;
            setValue(newValue);
            debouncedHandleOnChange();
        }, [
            debouncedHandleOnChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            label: formatMessage((0, (0, parcelRequire("4D12X")).default).boardNameFieldLabel),
            name: "boardName",
            isRequired: true
        }, ({ fieldProps: { onChange: onChange, ...rest }, error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                ...rest,
                placeholder: formatMessage((0, (0, parcelRequire("4D12X")).default).boardNameFieldPlaceholder),
                maxLength: (0, (0, parcelRequire("h3KSk")).BOARD_NAME_LIMIT),
                testId: "software-board-create.ui.modal.form.board-name.board-name-input",
                value: value,
                onChange: (event)=>{
                    handleOnChange(event);
                    onChange(event);
                }
            }), error === (0, (0, parcelRequire("h3KSk")).VALIDATION_ERROR_EMPTY) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), {
                testId: "software-board-create.ui.modal.form.board-name.board-name-error"
            }, formatMessage((0, (0, parcelRequire("4D12X")).default).boardNameEmptyError)), formState?.values.boardName && formState.values.boardName.length >= (0, (0, parcelRequire("h3KSk")).BOARD_NAME_LIMIT) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).HelperMessage), null, formatMessage((0, (0, parcelRequire("4D12X")).default).boardNameMaxChars, {
                maxLength: (0, (0, parcelRequire("h3KSk")).BOARD_NAME_LIMIT)
            }))));
    };
});
parcelRegister("qfj8c", function(module, exports) {
    $parcel$export(module.exports, "HelperMessage", ()=>$b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
    $parcel$export(module.exports, "ErrorMessage", ()=>$b2d5b368fed948c9$export$915e9e7bd4f0f96d);
    $parcel$export(module.exports, "ValidMessage", ()=>$b2d5b368fed948c9$export$5505afb209a532c8);
    $parcel$export(module.exports, "MessageWrapper", ()=>$b2d5b368fed948c9$export$ec445f12f63100a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $059q9;
    var $g4M8x;
    var $dRN65;
    function $b2d5b368fed948c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b2d5b368fed948c9$var$messageStyles = {
        name: "drnq1s",
        styles: "display:flex;justify-content:baseline;gap:var(--ds-space-075, 6px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
    };
    const $b2d5b368fed948c9$var$messageAppearanceStyles = {
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
        }),
        error: {
            name: "g75jq6",
            styles: "color:var(--ds-text-danger, #AE2A19)"
        },
        valid: {
            name: "118r6eb",
            styles: "color:var(--ds-text-success, #216E4E)"
        }
    };
    const $b2d5b368fed948c9$var$iconWrapperStyles = {
        name: "x5c876",
        styles: "display:flex;height:16px;align-items:center"
    };
    const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $b2d5b368fed948c9$var$iconWrapperStyles
        }, children);
    };
    const $b2d5b368fed948c9$var$messageIcons = {
        error: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("059q9"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "error"
        }),
        valid: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("g4M8x"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "success"
        })
    };
    const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
        const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
        const messageRef = (0, $5uXOq.useRef)(null);
        const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
        const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$export$579aef2c392a54d4);
        (0, $5uXOq.useEffect)(()=>{
            if (messageRef.current) setHasMessageWrapper(isWrapper);
        }, [
            isWrapper
        ]);
        const content = typeof children === 'string' ? children : (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $b2d5b368fed948c9$var$messageStyles,
                $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
            ],
            "data-testid": testId,
            id: fieldId,
            ref: messageRef,
            "aria-live": !hasMessageWrapper ? 'polite' : undefined
        }, icon && (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$IconWrapper, null, icon), content);
    };
    const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$579aef2c392a54d4 = (0, $5uXOq.createContext)({
        isWrapper: false
    });
    const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
        const contextValue = {
            isWrapper: true
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$export$579aef2c392a54d4.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper"
        }, children));
    };
});
parcelRegister("059q9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));
    var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
    function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>$00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
            LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
        }, props));
    $00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
    var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;
});
parcelRegister("hAZqC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ccf572dfbabebdf7$var$_react = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ccf572dfbabebdf7$var$_baseNew = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ccf572dfbabebdf7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ccf572dfbabebdf7$var$ErrorIcon = (props)=>$ccf572dfbabebdf7$var$_react.default.createElement($ccf572dfbabebdf7$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $ccf572dfbabebdf7$var$ErrorIcon.displayName = 'ErrorIcon';
    var $ccf572dfbabebdf7$var$_default = module.exports.default = $ccf572dfbabebdf7$var$ErrorIcon;
});
parcelRegister("g4M8x", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bb425bfe72dc5677$var$_react = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bb425bfe72dc5677$var$_success = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("hs3k8")));
    var $bb425bfe72dc5677$var$_success2 = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("kJ541")));
    function $bb425bfe72dc5677$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bb425bfe72dc5677$var$SuccessIcon = (props)=>$bb425bfe72dc5677$var$_react.default.createElement($bb425bfe72dc5677$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $bb425bfe72dc5677$var$_success2.default
        }, props));
    $bb425bfe72dc5677$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $bb425bfe72dc5677$var$_default = module.exports.default = $bb425bfe72dc5677$var$SuccessIcon;
});
parcelRegister("hs3k8", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0347594f5084a834$var$_react = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0347594f5084a834$var$_baseNew = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0347594f5084a834$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0347594f5084a834$var$SuccessIcon = (props)=>$0347594f5084a834$var$_react.default.createElement($0347594f5084a834$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $0347594f5084a834$var$SuccessIcon.displayName = 'SuccessIcon';
    var $0347594f5084a834$var$_default = module.exports.default = $0347594f5084a834$var$SuccessIcon;
});
parcelRegister("kJ541", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
    function $f16bf031974cd311$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>$f16bf031974cd311$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
        }, props, {
            newIcon: $f16bf031974cd311$var$_success.default
        }));
    $f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
    var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;
});
parcelRegister("dRN65", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$706cd4dbd4574fd7$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $706cd4dbd4574fd7$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("7O4UO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e20204ce79b642c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $9KnKW;
    var $dRN65;
    var $efXp3;
    var $2x3Cb;
    var $kxqHl;
    var $6cAn5 = parcelRequire("6cAn5");
    function $7e20204ce79b642c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7e20204ce79b642c$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $7e20204ce79b642c$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $7e20204ce79b642c$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $7e20204ce79b642c$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
        const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7e20204ce79b642c$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kxqHl")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("2x3Cb", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$987b76a5b7a0ea9b$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$987b76a5b7a0ea9b$export$ed247974535929c7);
    var $f8Sb3;
    function $987b76a5b7a0ea9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles
        }, children);
    };
    var $987b76a5b7a0ea9b$export$2e2bcd8739ae039 = $987b76a5b7a0ea9b$export$b04be29aa201d4f5;
});
parcelRegister("kxqHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55ac25356e81a33$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d55ac25356e81a33$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d55ac25356e81a33$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d55ac25356e81a33$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    var $VSDnB;
    var $h9kUS;
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)" : "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_safari_input_fix') ? `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}` : `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_safari_input_fix') ? `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"}` : `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            },
            [`${(0, (0, parcelRequire("h9kUS")).media).above.xs}`]: {
                font: (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)" : undefined,
                '&[data-compact]': {
                    padding: (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_safari_input_fix') ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : undefined
                },
                '&:not([data-compact])': {
                    padding: (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_safari_input_fix') ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}` : undefined
                }
            }
        });
});
parcelRegister("4D12X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37b6bea23dba762b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $37b6bea23dba762b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        boardNameFieldLabel: {
            "id": "software-board-create.modal.form.board-name.board-name-field-label",
            "defaultMessage": "Name this board"
        },
        boardNameFieldPlaceholder: {
            "id": "software-board-create.modal.form.board-name.board-name-field-placeholder",
            "defaultMessage": "Enter a name for this board"
        },
        boardNameEmptyError: {
            "id": "software-board-create.modal.form.board-name.board-name-empty-error",
            "defaultMessage": "Enter a board name"
        },
        boardNameMaxChars: {
            "id": "software-board-create.modal.form.board-name.board-name-max-chars",
            "defaultMessage": "Maximum {maxLength, plural, one {# character} other {# characters}}"
        }
    });
});
parcelRegister("7GuB2", function(module, exports) {
    $parcel$export(module.exports, "SourceTypePicker", ()=>$24e530c3fc1a0dce$export$879aac32ab2e56ba);
    var $5uXOq = parcelRequire("5uXOq");
    var $183uB = parcelRequire("183uB");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $ujWmd;
    var $qfj8c;
    var $7O4UO;
    var $kgoHi;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $bChGW;
    var $7K5PP;
    var $i0vxP;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $2NRUh;
    var $kJMdt;
    var $c6RuI;
    const $24e530c3fc1a0dce$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
    const $24e530c3fc1a0dce$var$formatOptionLabel = (option)=>{
        const { icon: Icon, title: title, description: description } = option;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center",
            gap: "space.150",
            xcss: $24e530c3fc1a0dce$var$optionStyles
        }, typeof Icon === 'string' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            src: Icon,
            size: "xsmall",
            appearance: "square",
            borderColor: "transparent"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
            label: "",
            name: "projectIcon"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.050"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, title), description && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            color: "color.text.subtlest"
        }, description)));
    };
    const $24e530c3fc1a0dce$var$SingleValue = (props)=>{
        const { data: { selectedTitle: selectedTitle, icon: Icon } } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).SingleValue, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center",
            gap: "space.100"
        }, typeof Icon === 'string' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            src: Icon,
            size: "xsmall",
            appearance: "square",
            name: "avatar"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage(selectedTitle, {
            strong: (children)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "strong"
                }, children)
        }))));
    };
    const $24e530c3fc1a0dce$export$77e74af9508bfdeb = ()=>(0, $5uXOq.useState)();
    const $24e530c3fc1a0dce$export$879aac32ab2e56ba = ({ resetSourceValue: resetSourceValue })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [selected, setSelected] = $24e530c3fc1a0dce$export$77e74af9508bfdeb();
        const { projectAvatar: projectAvatar } = (0, (0, parcelRequire("2NRUh")).useBoardCreateContext)();
        const optionGroups = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("c6RuI")).getOptionGroups)({
                formatMessage: formatMessage,
                projectAvatar: projectAvatar,
                setLabel: true
            }), [
            formatMessage,
            projectAvatar
        ]);
        const optionGroupsOld = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("c6RuI")).getOptionGroups)({
                formatMessage: formatMessage,
                projectAvatar: projectAvatar
            }), [
            formatMessage,
            projectAvatar
        ]);
        const flattenedOptions = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($183uB)))(optionGroups.map((group)=>group.options)), [
            optionGroups
        ]);
        const handleChange = (0, $5uXOq.useCallback)((onFieldChange)=>(value)=>{
                const option = value?.value || null;
                resetSourceValue();
                setSelected(option);
                onFieldChange(option);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    actionSubject: 'select',
                    action: 'changed'
                }), 'boardSourceType', {
                    sourceType: option
                });
            }, [
            createAnalyticsEvent,
            resetSourceValue,
            setSelected
        ]);
        const handleOnMenuOpen = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'select',
                action: 'opened'
            }), 'boardSourceType');
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            name: "sourceType",
            label: formatMessage((0, (0, parcelRequire("kJMdt")).default).sourceTypeFieldLabel),
            defaultValue: undefined,
            isRequired: true
        }, ({ fieldProps: { onChange: onFieldChange, ...rest }, error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("4R6GH")).fg)('nav4_simplified_board_create_beta') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i0vxP")).default), {
                onEscape: (0, ($parcel$interopDefault($8Rkzz)))
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                ...rest,
                "aria-label": formatMessage((0, (0, parcelRequire("kJMdt")).default).sourceTypePickerAriaLabel),
                options: optionGroups,
                isSearchable: false,
                formatOptionLabel: $24e530c3fc1a0dce$var$formatOptionLabel,
                components: {
                    SingleValue: $24e530c3fc1a0dce$var$SingleValue
                },
                placeholder: formatMessage((0, (0, parcelRequire("kJMdt")).default).selectPlaceholder),
                menuPosition: "fixed",
                classNamePrefix: "source-type-picker",
                onChange: handleChange(onFieldChange),
                value: flattenedOptions.find((option)=>option.value === selected),
                styles: {
                    control: (base, state)=>({
                            ...base,
                            borderColor: state.isFocused ? `var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B100})` : base.borderColor,
                            ':focus-within': {
                                boxShadow: state.isFocused ? `inset 0px 0px 0px 1px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B100})`}` : base.boxShadow
                            },
                            ':hover': {
                                borderColor: state.isFocused ? `var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B100})` : base.borderColor,
                                boxShadow: state.isFocused ? 'elevation.shadow.raised' : base.boxShadow
                            }
                        }),
                    option: (base)=>({
                            ...base,
                            padding: `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-300, 24px)"}`
                        }),
                    group: (base)=>({
                            ...base,
                            padding: 0,
                            ':not(:last-of-type)': {
                                borderBottomWidth: '2px',
                                borderBottomStyle: 'solid',
                                borderBottomColor: "var(--ds-border, #091E4224)"
                            }
                        }),
                    groupHeading: (base)=>({
                            ...base,
                            margin: 0
                        }),
                    menuList: (base)=>({
                            ...base,
                            padding: 0,
                            maxHeight: 325
                        })
                },
                onMenuOpen: handleOnMenuOpen
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                ...rest,
                "aria-label": formatMessage((0, (0, parcelRequire("kJMdt")).default).sourceTypePickerAriaLabel),
                options: optionGroupsOld,
                isSearchable: false,
                formatOptionLabel: $24e530c3fc1a0dce$var$formatOptionLabel,
                components: {
                    SingleValue: $24e530c3fc1a0dce$var$SingleValue
                },
                placeholder: formatMessage((0, (0, parcelRequire("kJMdt")).default).selectPlaceholder),
                menuPosition: "fixed",
                classNamePrefix: "source-type-picker",
                onChange: handleChange(onFieldChange),
                value: flattenedOptions.find((option)=>option.value === selected),
                styles: {
                    option: (base)=>({
                            ...base,
                            padding: `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-300, 24px)"}`
                        }),
                    group: (base)=>({
                            ...base,
                            padding: 0,
                            ':not(:last-of-type)': {
                                borderBottomWidth: '2px',
                                borderBottomStyle: 'solid',
                                borderBottomColor: "var(--ds-border, #091E4224)"
                            }
                        }),
                    groupHeading: (base)=>({
                            ...base,
                            margin: 0
                        }),
                    menuList: (base)=>({
                            ...base,
                            padding: 0,
                            maxHeight: 325
                        })
                },
                onMenuOpen: handleOnMenuOpen
            }), error === $24e530c3fc1a0dce$export$7b060a5763a6e199 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), {
                testId: "software-board-create.ui.modal.form.source-type-picker.error"
            }, formatMessage((0, (0, parcelRequire("kJMdt")).default).sourceTypeEmptyError))));
    };
    const $24e530c3fc1a0dce$var$optionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minHeight: '40px'
    });
});
parcelRegister("bChGW", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$ea75c1778b4e3ad2$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$ea75c1778b4e3ad2$export$71abc632aa29e6fe);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("95iuW")).ClearIndicator),
        Control: (0, (0, parcelRequire("eZFhY")).default),
        DropdownIndicator: (0, (0, parcelRequire("95iuW")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("95iuW")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("95iuW")).CrossIcon),
        Group: (0, (0, parcelRequire("i48X9")).default),
        GroupHeading: (0, (0, parcelRequire("i48X9")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("h1QWG")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("95iuW")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("dS5G5")).default),
        LoadingIndicator: (0, (0, parcelRequire("95iuW")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("aA8TC")).default),
        MenuList: (0, (0, parcelRequire("aA8TC")).MenuList),
        MenuPortal: (0, (0, parcelRequire("aA8TC")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("aA8TC")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("aA8TC")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hqcPo")).default),
        MultiValueContainer: (0, (0, parcelRequire("hqcPo")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hqcPo")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hqcPo")).MultiValueRemove),
        Option: (0, (0, parcelRequire("8l2RA")).default),
        Placeholder: (0, (0, parcelRequire("kKm82")).default),
        SelectContainer: (0, (0, parcelRequire("h1QWG")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("hpcbi")).default),
        ValueContainer: (0, (0, parcelRequire("h1QWG")).ValueContainer)
    };
    const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
            ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("h1QWG", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$78186faf13ea75d3$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$78186faf13ea75d3$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$78186faf13ea75d3$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$78186faf13ea75d3$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$78186faf13ea75d3$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$78186faf13ea75d3$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $gyjU7;
    const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            position: 'relative',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            pointerEvents: 'all',
            cursor: isDisabled ? 'not-allowed' : undefined
        });
    const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            padding: `${isCompact ? 0 : "var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`
        });
    const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0,
            paddingRight: "var(--ds-space-050, 4px)"
        });
    const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("gyjU7", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$109d3f9af5469308$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$109d3f9af5469308$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$109d3f9af5469308$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$109d3f9af5469308$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$109d3f9af5469308$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$109d3f9af5469308$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$109d3f9af5469308$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$109d3f9af5469308$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$109d3f9af5469308$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$109d3f9af5469308$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$109d3f9af5469308$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$109d3f9af5469308$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$109d3f9af5469308$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$109d3f9af5469308$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$109d3f9af5469308$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$109d3f9af5469308$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$109d3f9af5469308$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$109d3f9af5469308$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$109d3f9af5469308$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$109d3f9af5469308$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$109d3f9af5469308$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$109d3f9af5469308$export$4213b25a1c4e877);
    const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
    const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
    function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
        if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $109d3f9af5469308$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $109d3f9af5469308$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
        const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
            $109d3f9af5469308$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $109d3f9af5469308$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $109d3f9af5469308$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $109d3f9af5469308$var$passiveOptionAccessed = false;
    const $109d3f9af5469308$var$options = {
        get passive () {
            return $109d3f9af5469308$var$passiveOptionAccessed = true;
        }
    };
    const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
    if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
        $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
        $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
    }
    const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
    function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("eZFhY", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$728816cb4150b6bc$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$728816cb4150b6bc$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, isCompact: isCompact, appearance: appearance })=>{
        let borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
        let backgroundColor = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)";
        let backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
        let borderColorHover = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
        if (isDisabled) {
            backgroundColor = "var(--ds-background-disabled, #091E4208)";
            borderColor = "var(--ds-background-disabled, #091E4208)";
        }
        if (isInvalid) {
            borderColor = "var(--ds-border-danger, #E2483D)";
            borderColorHover = "var(--ds-border-danger, #E2483D)";
        }
        const transitionDuration = '200ms';
        if (appearance === 'subtle') {
            borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : 'transparent';
            backgroundColor = isFocused ? "var(--ds-surface, #FFFFFF)" : 'transparent';
            backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
        }
        if (appearance === 'none') {
            borderColor = 'transparent';
            backgroundColor = 'transparent';
            backgroundColorHover = 'transparent';
            borderColorHover = 'transparent';
        }
        return {
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            outline: '0 !important',
            position: 'relative',
            pointerEvents: isDisabled ? 'none' : undefined,
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            borderStyle: 'solid',
            borderRadius: "var(--ds-border-radius-100, 3px)",
            borderWidth: "var(--ds-border-width, 1px)",
            boxShadow: isInvalid ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
            '&:focus-within': {
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
            },
            minHeight: isCompact ? 32 : 40,
            padding: 0,
            transition: `background-color ${transitionDuration} ease-in-out,
border-color ${transitionDuration} ease-in-out`,
            '::-webkit-scrollbar': {
                height: 8,
                width: 8
            },
            '::-webkit-scrollbar-corner': {
                display: 'none'
            },
            ':hover': {
                '::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0,0,0,0.2)'
                },
                cursor: 'pointer',
                backgroundColor: backgroundColorHover,
                borderColor: borderColorHover
            },
            '::-webkit-scrollbar-thumb:hover': {
                backgroundColor: 'rgba(0,0,0,0.4)'
            }
        };
    };
    const $728816cb4150b6bc$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;
});
parcelRegister("i48X9", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$902e86f4b4fe337b$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$902e86f4b4fe337b$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$902e86f4b4fe337b$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$902e86f4b4fe337b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $902e86f4b4fe337b$export$b6794329c1460634 = ({})=>({
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingTop: "var(--ds-space-100, 8px)"
        });
    const $902e86f4b4fe337b$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({})=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            fontSize: '75%',
            marginBottom: '0.25em',
            paddingLeft: "var(--ds-space-150, 12px)",
            paddingRight: "var(--ds-space-150, 12px)",
            font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            color: "var(--ds-text-subtle, #44546F)",
            fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
            textTransform: 'none'
        });
    const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;
});
parcelRegister("95iuW", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$13f090f36c42825d$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$13f090f36c42825d$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$13f090f36c42825d$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$13f090f36c42825d$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$13f090f36c42825d$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$13f090f36c42825d$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$13f090f36c42825d$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$13f090f36c42825d$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$13f090f36c42825d$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$13f090f36c42825d$export$7c20be4c1d342248);
    var $f8Sb3;
    var $gyjU7;
    function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13f090f36c42825d$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $13f090f36c42825d$var$styles,
            ...props
        });
    const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $13f090f36c42825d$export$e1687335805e1230 = ({ isCompact: isCompact, isDisabled: isDisabled })=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtle, #44546F)",
            padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
            ':hover': {
                color: "var(--ds-text-subtle, #44546F)"
            }
        });
    const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
    };
    const $13f090f36c42825d$export$9c0419fd944c1def = ({ isCompact: isCompact })=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            color: "var(--ds-text-subtlest, #626F86)",
            padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
            ':hover': {
                color: "var(--ds-text-subtle, #44546F)"
            }
        });
    const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
    };
    const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled })=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            backgroundColor: isDisabled ? "var(--ds-border-disabled, #091E420F)" : "var(--ds-border, #091E4224)",
            marginBottom: "var(--ds-space-100, 8px)",
            marginTop: "var(--ds-space-100, 8px)"
        });
    const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $13f090f36c42825d$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, isCompact: isCompact, theme: { colors: colors } })=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`
        });
    const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("dS5G5", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$1c949ac6f5985b40$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$1c949ac6f5985b40$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } })=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$1c949ac6f5985b40$var$containerStyle,
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: "var(--ds-text, hsl(0, 0%, 20%))"
        });
    const $1c949ac6f5985b40$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $1c949ac6f5985b40$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$1c949ac6f5985b40$var$spacingStyle
        }
    };
    const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$1c949ac6f5985b40$var$spacingStyle
        });
    const $1c949ac6f5985b40$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $1c949ac6f5985b40$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;
});
parcelRegister("aA8TC", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$1fde8cb844828ae2$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$1fde8cb844828ae2$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$1fde8cb844828ae2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$1fde8cb844828ae2$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$1fde8cb844828ae2$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$1fde8cb844828ae2$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$1fde8cb844828ae2$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$1fde8cb844828ae2$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$1fde8cb844828ae2$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$1fde8cb844828ae2$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $gyjU7;
    function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("gyjU7")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("gyjU7")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("gyjU7")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $1fde8cb844828ae2$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } })=>({
            label: 'menu',
            [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            borderRadius: borderRadius,
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter,
            backgroundColor: "var(--ds-surface-overlay, white)",
            boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
        });
    const $1fde8cb844828ae2$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $1fde8cb844828ae2$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
    const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight })=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)"
        });
    const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            textAlign: 'center',
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        });
    const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("gyjU7")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hqcPo", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$20933ad7b05a0c37$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$20933ad7b05a0c37$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$20933ad7b05a0c37$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$20933ad7b05a0c37$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$20933ad7b05a0c37$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$20933ad7b05a0c37$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    var $gyjU7;
    var $95iuW;
    const $20933ad7b05a0c37$export$23c213f7717186af = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } })=>{
        let backgroundColor;
        let color;
        if (isDisabled) {
            backgroundColor = "var(--ds-background-neutral, #091E420F)";
            color = "var(--ds-text-disabled, #091E424F)";
        } else if (isFocused) {
            backgroundColor = "var(--ds-background-selected, #E9F2FF)";
            color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
        } else {
            backgroundColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : "var(--ds-background-neutral, #091E420F)";
            color = "var(--ds-text, hsl(0, 0%, 20%))";
        }
        return {
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            margin: "var(--ds-space-025, 2px)",
            borderRadius: "var(--ds-border-radius-050, 2px)",
            backgroundColor: backgroundColor,
            boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
            maxWidth: '100%',
            '@media screen and (-ms-high-contrast: active)': {
                border: isFocused ? '1px solid transparent' : 'none'
            },
            color: color,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                borderRadius: "var(--ds-border-radius-100, 4px)",
                borderColor: '#B7B9BE',
                borderWidth: "var(--ds-border-width, 1px)",
                borderStyle: 'solid',
                backgroundColor: "var(--ds-background-input, #FFFFFF)"
            }
        };
    };
    const $20933ad7b05a0c37$export$f40612612e0af964 = ({ cropWithEllipsis: cropWithEllipsis, isDisabled: isDisabled })=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            borderRadius: "var(--ds-border-radius-050, 2px)",
            fontSize: '85%',
            font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            padding: "var(--ds-space-025, 2px)",
            color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : 'inherit',
            paddingLeft: "var(--ds-space-075, 6px)",
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: "var(--ds-space-050, 4px)"
            }
        });
    const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ isFocused: isFocused })=>({
            alignItems: 'center',
            display: 'flex',
            backgroundColor: isFocused ? "var(--ds-UNSAFE-transparent, transparent)" : undefined,
            fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            borderRadius: '0px 2px 2px 0px',
            ':hover': {
                backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)",
                fill: "var(--ds-text-danger, #000)"
            },
            ':active': {
                backgroundColor: "var(--ds-background-danger-pressed, #FD9891)",
                fill: "var(--ds-text-danger, #000)"
            },
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                border: 'none',
                alignItems: 'center',
                justifyContent: 'center',
                alignSelf: 'center',
                appearance: 'none',
                borderRadius: "var(--ds-border-radius, 4px)",
                color: "var(--ds-text, #172B4D)",
                padding: "var(--ds-space-025, 2px)",
                marginRight: "var(--ds-space-025, 2px)",
                ':focus-visible': {
                    outlineOffset: "var(--ds-space-negative-025, -2px)"
                },
                ':hover': {
                    backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                },
                ':active': {
                    backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                }
            }
        });
    const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("95iuW")).CrossIcon), {
            size: 14
        }));
    }
    const $20933ad7b05a0c37$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;
});
parcelRegister("8l2RA", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$6e6d67a90b457dc1$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$6e6d67a90b457dc1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        let color = "var(--ds-text, #172B4D)";
        if (isDisabled) color = "var(--ds-text-disabled, #091E424F)";
        else if (isSelected) color = "var(--ds-text-selected, #0C66E4)";
        let boxShadow;
        let backgroundColor;
        if (isDisabled) backgroundColor = undefined;
        else if (isSelected && isFocused) backgroundColor = "var(--ds-background-selected-hovered, #CCE0FF)";
        else if (isSelected) backgroundColor = "var(--ds-background-selected, #E9F2FF)";
        else if (isFocused) backgroundColor = "var(--ds-background-neutral-subtle-hovered, #091E420F)";
        if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${"var(--ds-border-selected, #0C66E4)"}`;
        const cursor = isDisabled ? 'not-allowed' : 'default';
        return {
            label: 'option',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
            backgroundColor: backgroundColor,
            color: color,
            cursor: cursor,
            boxShadow: boxShadow,
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? "var(--ds-background-selected-pressed, #85B8FF)" : "var(--ds-background-neutral-subtle-pressed, #091E4224)" : undefined
            },
            '@media screen and (-ms-high-contrast: active)': {
                borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
            }
        };
    };
    const $6e6d67a90b457dc1$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;
});
parcelRegister("kKm82", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$889d652a9d0dc097$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$889d652a9d0dc097$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ isDisabled: isDisabled })=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            margin: `0 ${"var(--ds-space-025, 2px)"}`,
            color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtlest, #626F86)"
        });
    const $889d652a9d0dc097$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;
});
parcelRegister("hpcbi", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$aff94346c62a222f$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$aff94346c62a222f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing } })=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            margin: `0 ${"var(--ds-space-025, 2px)"}`,
            color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text, #172B4D)"
        });
    const $aff94346c62a222f$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;
});
parcelRegister("7K5PP", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$c2d344e1481a2d3b$export$2e2bcd8739ae039);
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $eAthk;
    var $3c98u;
    const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
    const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
    const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    const $c2d344e1481a2d3b$var$Select = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'select',
        packageName: $c2d344e1481a2d3b$var$packageName,
        packageVersion: $c2d344e1481a2d3b$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $c2d344e1481a2d3b$var$packageName,
                packageVersion: $c2d344e1481a2d3b$var$packageVersion
            }
        })
    })($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
    var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;
});
parcelRegister("eAthk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d0cf20527a3a891$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("iaInK")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $9uJ4X;
    const $6d0cf20527a3a891$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("iaInK")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("9uJ4X")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;
});
parcelRegister("2QhWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e863683b34816f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $aCMCu;
    var $eEtcC;
    var $bChGW;
    var $jtVgE;
    var $9cRAr;
    var $galqx;
    var $81i5b;
    var $aA8TC;
    var $5JAlL;
    var $7VXAu;
    var $5HBcW;
    var $gyjU7;
    const $d8e863683b34816f$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("5JAlL")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("eEtcC")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("eEtcC")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("eEtcC")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("eEtcC")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("gyjU7")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true
    };
    function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
        const label = $d8e863683b34816f$var$getOptionLabel(props, option);
        const value = $d8e863683b34816f$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("gyjU7")).notNullish));
    }
    function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
        return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
    }
    function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
        return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
    }
    function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $d8e863683b34816f$var$instanceId = 1;
    class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props), this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            }, this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, this.isAppleDevice = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("aCMCu")).isSafari)() : (0, (0, parcelRequire("aCMCu")).isAppleDevice)(), this.controlRef = null, this.getControlRef = (ref)=>{
                this.controlRef = ref;
            }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            }, this.inputRef = null, this.getInputRef = (ref)=>{
                this.inputRef = ref;
            }, this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            }, this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            }, this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            }, this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            }, this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("gyjU7")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            }, this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            }, this.getFocusedOptionId = (focusedOption)=>{
                return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            }, this.getFocusableOptionsWithIds = ()=>{
                return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, (0, parcelRequire("gyjU7")).classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
                return $d8e863683b34816f$var$getOptionLabel(this.props, data);
            }, this.getOptionValue = (data)=>{
                return $d8e863683b34816f$var$getOptionValue(this.props, data);
            }, this.getStyles = (key, props)=>{
                const base = (0, (0, parcelRequire("7VXAu")).defaultStyles)[key](props);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            }, this.getComponents = ()=>{
                return (0, (0, parcelRequire("bChGW")).defaultComponents)(this.props);
            }, this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            }, this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            }, this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            }, this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            }, this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            }, this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            }, this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("gyjU7")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            }, this.onCompositionStart = ()=>{
                this.isComposing = true;
            }, this.onCompositionEnd = ()=>{
                this.isComposing = false;
            }, this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            }, this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            }, this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            }, this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            }, this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            }, this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            }, this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            }, this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            }, this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            }, this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            }, this.shouldHideSelectedOptions = ()=>{
                return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
            }, this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            }, this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("5HBcW")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("5HBcW")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("5HBcW")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtVgE")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("gyjU7")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            const isCompact = spacing === 'compact';
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused,
                isCompact: isCompact
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const isCompact = spacing === 'compact';
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isCompact: isCompact
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, spacing: spacing } = this.props;
            const { isFocused: isFocused } = this.state;
            const isCompact = spacing === 'compact';
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isCompact: isCompact
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aA8TC")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("galqx")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cRAr")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81i5b")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            const isCompact = spacing === 'compact';
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                appearance: appearance,
                isInvalid: isInvalid,
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen,
                isCompact: isCompact
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled,
                isCompact: isCompact
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("aCMCu", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$150018e79a44f2ed$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$150018e79a44f2ed$export$e1865c3bedcd822b);
    function $150018e79a44f2ed$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $150018e79a44f2ed$export$186c6964ca17d99() {
        return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
    }
    function $150018e79a44f2ed$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $150018e79a44f2ed$export$9ac100e40613ea10() {
        return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
    }
    function $150018e79a44f2ed$export$7bef049ce92e4224() {
        return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $150018e79a44f2ed$export$fedb369cb70207f1() {
        return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
    }
    function $150018e79a44f2ed$export$e1865c3bedcd822b() {
        return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
    }
});
parcelRegister("eEtcC", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$1a3d0f2eb875e1af$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$1a3d0f2eb875e1af$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$1a3d0f2eb875e1af$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$1a3d0f2eb875e1af$export$56bd0c8d90db075);
    const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
    const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
    const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
    const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("jtVgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe53037961824c2$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $afe53037961824c2$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("gyjU7")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $afe53037961824c2$var$dummyInputStyles
        });
    }
});
parcelRegister("9cRAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a388fa48a9e96271$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eGmKJ;
    function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a388fa48a9e96271$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $a388fa48a9e96271$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("eGmKJ")).default)
        });
    var $a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;
});
parcelRegister("galqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15a49c0b3452f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $59IMp;
    var $3jzRI;
    function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15a49c0b3452f71$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("59IMp")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("3jzRI")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $e15a49c0b3452f71$var$blurSelectInput,
            css: $e15a49c0b3452f71$var$styles
        }), children(targetRef));
    }
});
parcelRegister("59IMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c08116303d9e3a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    const $96c08116303d9e3a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("gyjU7")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("3jzRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840302f0f43020c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $840302f0f43020c5$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $840302f0f43020c5$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $840302f0f43020c5$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $840302f0f43020c5$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $840302f0f43020c5$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $840302f0f43020c5$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $840302f0f43020c5$var$activeScrollLocks = 0;
    const $840302f0f43020c5$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                    const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
            $840302f0f43020c5$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("81i5b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3ccfcdca5695e58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dQlbw;
    var $bEd7d;
    const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("dQlbw")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;
});
parcelRegister("dQlbw", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$d3258ad64818881e$export$a7265767c78f9bae);
    var $VSDnB;
    const $d3258ad64818881e$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bEd7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc43afa82d3c33b$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7cc43afa82d3c33b$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $7cc43afa82d3c33b$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7cc43afa82d3c33b$var$styles,
            ...props
        });
    var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;
});
parcelRegister("5JAlL", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $bXu2O;
    const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("bXu2O")).stripDiacritics));
    const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("bXu2O")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("bXu2O", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$df93339199dda18e$export$b5bee4b27048330b);
    const $df93339199dda18e$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $df93339199dda18e$var$diacriticToBase = {};
    for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
        let diacritic = $df93339199dda18e$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
        return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
    };
});
parcelRegister("7VXAu", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$11d0fd648d1f51c0$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$11d0fd648d1f51c0$export$e618dc39ac9ad607);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("95iuW")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("h1QWG")).containerCSS),
        control: (0, (0, parcelRequire("eZFhY")).css),
        dropdownIndicator: (0, (0, parcelRequire("95iuW")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("i48X9")).groupCSS),
        groupHeading: (0, (0, parcelRequire("i48X9")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("h1QWG")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("95iuW")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("dS5G5")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("95iuW")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("aA8TC")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("aA8TC")).menuCSS),
        menuList: (0, (0, parcelRequire("aA8TC")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("aA8TC")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hqcPo")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hqcPo")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hqcPo")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("aA8TC")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("8l2RA")).optionCSS),
        placeholder: (0, (0, parcelRequire("kKm82")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("hpcbi")).css),
        valueContainer: (0, (0, parcelRequire("h1QWG")).valueContainerCSS)
    };
    function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("5HBcW", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$f64b5780144c9fe8$export$164de7ab8df77ef0);
    const $f64b5780144c9fe8$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $f64b5780144c9fe8$var$borderRadius = 4;
    const $f64b5780144c9fe8$var$baseUnit = 4;
    const $f64b5780144c9fe8$var$controlHeight = 38;
    const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
    const $f64b5780144c9fe8$export$5458b64234d1333c = {
        baseUnit: $f64b5780144c9fe8$var$baseUnit,
        controlHeight: $f64b5780144c9fe8$var$controlHeight,
        menuGutter: $f64b5780144c9fe8$var$menuGutter
    };
    const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
        borderRadius: $f64b5780144c9fe8$var$borderRadius,
        colors: $f64b5780144c9fe8$export$8f45430ccf837300,
        spacing: $f64b5780144c9fe8$export$5458b64234d1333c
    };
});
parcelRegister("iaInK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e85c90096c52fe4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("gyjU7")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("9uJ4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b6d9d338d10de1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("3c98u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$628a0199069e875a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $l4W7r;
    var $1k2at;
    var $j1GDZ;
    var $bA56e;
    var $1DATb;
    function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("l4W7r")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("l4W7r")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("l4W7r")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("1k2at")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("1k2at")).IndicatorSeparator,
                    Input: (0, parcelRequire("j1GDZ")).Input,
                    NoOptionsMessage: (0, parcelRequire("bA56e")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("1DATb")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid || validationState === 'error',
                ...restProps,
                components: components,
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("l4W7r", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$9145857df3efc9da$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$9145857df3efc9da$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$9145857df3efc9da$export$7c20be4c1d342248);
    var $f8Sb3;
    var $c8Oei;
    var $cQz2U;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $eZJjh;
    const $9145857df3efc9da$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $9145857df3efc9da$var$dropdownWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075'
    });
    const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $9145857df3efc9da$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $9145857df3efc9da$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })));
    };
});
parcelRegister("cQz2U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));
    var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
    function $95a586bfe482ffec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>$95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
        }, props));
    $95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;
});
parcelRegister("47etd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ff30a5d9a7d32b6$var$_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>$2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("1k2at", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$5fdfa3c8145f4e13$export$bd638c2ba7915668);
    var $f8Sb3;
    var $673MF;
    var $bjGSs;
    var $VSDnB;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $l4W7r;
    function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5fdfa3c8145f4e13$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $5fdfa3c8145f4e13$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("673MF"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;
});
parcelRegister("bjGSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83d2ba975692c1a3$var$_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83d2ba975692c1a3$var$CrossIcon = (props)=>$83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
    var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;
});
parcelRegister("j1GDZ", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$4cb02513bf42b58e$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("bA56e", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$eeac7d0aa054dce2$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $bChGW;
    const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("1DATb", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$a998ee34d66f3da7$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$a998ee34d66f3da7$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$a998ee34d66f3da7$export$8ee33f304118fce4);
    function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("i0vxP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e488d7f69150a6e1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fW62l = parcelRequire("fW62l");
    class $e488d7f69150a6e1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onEscape: null,
                onEnter: null,
                onBlur: null,
                className: undefined
            };
        }
        componentDidMount() {
            if (this.ref) this.ref.addEventListener('keydown', this.handleKeyDown);
        }
        componentWillUnmount() {
            if (this.ref) this.ref.removeEventListener('keydown', this.handleKeyDown);
        }
        render() {
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                onBlur: this.props.onBlur,
                ref: this.setRef,
                className: this.props.className
            }, this.props.children));
        }
        constructor(...args){
            super(...args), this.setRef = (ref)=>{
                this.ref = ref;
            }, this.handleKeyDown = (event)=>{
                switch(event.keyCode){
                    case (0, ($parcel$interopDefault($fW62l)))('escape'):
                        if (this.props.onEscape) {
                            this.props.onEscape(event);
                            event.stopPropagation();
                        }
                        break;
                    case (0, ($parcel$interopDefault($fW62l)))('enter'):
                        if (this.props.onEnter) {
                            this.props.onEnter(event);
                            event.stopPropagation();
                        }
                        break;
                    default:
                        break;
                }
            };
        }
    }
});
parcelRegister("fW62l", function(module, exports) {
    function keyCode(searchInput) {
        if (searchInput && 'object' === typeof searchInput) {
            var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
            if (hasKeyCode) searchInput = hasKeyCode;
        }
        if ('number' === typeof searchInput) return names[searchInput];
        var search = String(searchInput);
        var foundNamedKey = codes[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        var foundNamedKey = aliases[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        if (search.length === 1) return search.charCodeAt(0);
        return undefined;
    }
    keyCode.isEventKey = function isEventKey(event, nameOrCode) {
        if (event && 'object' === typeof event) {
            var keyCode = event.which || event.keyCode || event.charCode;
            if (keyCode === null || keyCode === undefined) return false;
            if (typeof nameOrCode === 'string') {
                var foundNamedKey = codes[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
                var foundNamedKey = aliases[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
            } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
            return false;
        }
    };
    exports = module.exports = keyCode;
    var codes = exports.code = exports.codes = {
        'backspace': 8,
        'tab': 9,
        'enter': 13,
        'shift': 16,
        'ctrl': 17,
        'alt': 18,
        'pause/break': 19,
        'caps lock': 20,
        'esc': 27,
        'space': 32,
        'page up': 33,
        'page down': 34,
        'end': 35,
        'home': 36,
        'left': 37,
        'up': 38,
        'right': 39,
        'down': 40,
        'insert': 45,
        'delete': 46,
        'command': 91,
        'left command': 91,
        'right command': 93,
        'numpad *': 106,
        'numpad +': 107,
        'numpad -': 109,
        'numpad .': 110,
        'numpad /': 111,
        'num lock': 144,
        'scroll lock': 145,
        'my computer': 182,
        'my calculator': 183,
        ';': 186,
        '=': 187,
        ',': 188,
        '-': 189,
        '.': 190,
        '/': 191,
        '`': 192,
        '[': 219,
        '\\': 220,
        ']': 221,
        "'": 222
    };
    var aliases = exports.aliases = {
        'windows': 91,
        "\u21E7": 16,
        "\u2325": 18,
        "\u2303": 17,
        "\u2318": 91,
        'ctl': 17,
        'control': 17,
        'option': 18,
        'pause': 19,
        'break': 19,
        'caps': 20,
        'return': 13,
        'escape': 27,
        'spc': 32,
        'spacebar': 32,
        'pgup': 33,
        'pgdn': 34,
        'ins': 45,
        'del': 46,
        'cmd': 91
    };
    for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
    for(var i = 48; i < 58; i++)codes[i - 48] = i;
    for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
    for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
    var names = exports.names = exports.title = {};
    for(i in codes)names[codes[i]] = i;
    for(var alias in aliases)codes[alias] = aliases[alias];
});
parcelRegister("kJMdt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1d6d450ba6ea5ae$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c1d6d450ba6ea5ae$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        selectPlaceholder: {
            "id": "software-board-create.modal.form.source-type-picker.select-placeholder",
            "defaultMessage": "Select"
        },
        sourceTypeFieldLabel: {
            "id": "software-board-create.modal.form.source-type-picker.source-type-field-label",
            "defaultMessage": "Choose what to include in this board"
        },
        teamTitle: {
            "id": "software-board-create.modal.form.source-type-picker.team-title",
            "defaultMessage": "Team"
        },
        teamSelectedTitle: {
            "id": "software-board-create.modal.form.source-type-picker.team-selected-title",
            "defaultMessage": "Issues based on <strong>Team</strong>"
        },
        teamDescription: {
            "id": "software-board-create.modal.form.source-type-picker.team-description",
            "defaultMessage": "Show all issues assigned to a team"
        },
        issueTypesTitle: {
            "id": "software-board-create.modal.form.source-type-picker.issue-types-title",
            "defaultMessage": "Issue type"
        },
        issueTypesSelectedTitle: {
            "id": "software-board-create.modal.form.source-type-picker.issue-types-selected-title",
            "defaultMessage": "Issues based on <strong>Issue type</strong>"
        },
        issueTypesDescription: {
            "id": "software-board-create.modal.form.source-type-picker.issue-types-description",
            "defaultMessage": "Show all issues associated with an issue type"
        },
        labelsTitle: {
            "id": "software-board-create.modal.form.source-type-picker.labels-title",
            "defaultMessage": "Label"
        },
        labelsSelectedTitle: {
            "id": "software-board-create.modal.form.source-type-picker.labels-selected-title",
            "defaultMessage": "Issues based on <strong>Label</strong>"
        },
        labelsDescription: {
            "id": "software-board-create.modal.form.source-type-picker.labels-description",
            "defaultMessage": "Show all issues tagged with a specific label"
        },
        allIssuesFromProjectTitle: {
            "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-title",
            "defaultMessage": "All issues from your project"
        },
        allIssuesFromProjectSelectedTitle: {
            "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title",
            "defaultMessage": "Issues based on <strong>All issues from your project</strong>"
        },
        savedFilterTitle: {
            "id": "software-board-create.modal.form.source-type-picker.saved-filter-title",
            "defaultMessage": "Advanced"
        },
        savedFilterSelectedTitle: {
            "id": "software-board-create.modal.form.source-type-picker.saved-filter-selected-title",
            "defaultMessage": "Issues based on a <strong>Saved filter</strong>"
        },
        savedFilterDescription: {
            "id": "software-board-create.modal.form.source-type-picker.saved-filter-description",
            "defaultMessage": "Show issues from a saved JQL filter"
        },
        sourceTypePickerAriaLabel: {
            "id": "software-board-create.modal.form.source-type-picker.source-type-picker-aria-label",
            "defaultMessage": "Select what to include in this board"
        },
        sourceTypeEmptyError: {
            "id": "software-board-create.modal.form.source-type-picker.source-type-empty-error",
            "defaultMessage": "Select what to include in this board"
        }
    });
});
parcelRegister("c6RuI", function(module, exports) {
    $parcel$export(module.exports, "getOptionGroups", ()=>$febdc73d67318f4a$export$eec1253b95a159cc);
    var $2o8gl;
    var $lJosW;
    var $bB6uF;
    var $kYQTv;
    var $dXQDI;
    var $h3KSk;
    var $kJMdt;
    const $febdc73d67318f4a$export$eec1253b95a159cc = ({ formatMessage: formatMessage, projectAvatar: projectAvatar, setLabel: setLabel })=>{
        return setLabel ? [
            {
                options: [
                    {
                        label: formatMessage((0, (0, parcelRequire("kJMdt")).default).allIssuesFromProjectTitle),
                        title: formatMessage((0, (0, parcelRequire("kJMdt")).default).allIssuesFromProjectTitle),
                        selectedTitle: (0, (0, parcelRequire("kJMdt")).default).allIssuesFromProjectSelectedTitle,
                        value: null,
                        icon: projectAvatar || (0, ($parcel$interopDefault((0, parcelRequire("dXQDI")))))
                    }
                ]
            },
            {
                options: [
                    {
                        label: formatMessage((0, (0, parcelRequire("kJMdt")).default).teamTitle),
                        title: formatMessage((0, (0, parcelRequire("kJMdt")).default).teamTitle),
                        selectedTitle: (0, (0, parcelRequire("kJMdt")).default).teamSelectedTitle,
                        description: formatMessage((0, (0, parcelRequire("kJMdt")).default).teamDescription),
                        value: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).TEAM,
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("kYQTv")))))
                    },
                    {
                        label: formatMessage((0, (0, parcelRequire("kJMdt")).default).issueTypesTitle),
                        title: formatMessage((0, (0, parcelRequire("kJMdt")).default).issueTypesTitle),
                        selectedTitle: (0, (0, parcelRequire("kJMdt")).default).issueTypesSelectedTitle,
                        description: formatMessage((0, (0, parcelRequire("kJMdt")).default).issueTypesDescription),
                        value: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).ISSUE_TYPES,
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("lJosW")))))
                    },
                    {
                        label: formatMessage((0, (0, parcelRequire("kJMdt")).default).labelsTitle),
                        title: formatMessage((0, (0, parcelRequire("kJMdt")).default).labelsTitle),
                        selectedTitle: (0, (0, parcelRequire("kJMdt")).default).labelsSelectedTitle,
                        description: formatMessage((0, (0, parcelRequire("kJMdt")).default).labelsDescription),
                        value: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).LABELS,
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("bB6uF")))))
                    }
                ]
            },
            {
                options: [
                    {
                        label: formatMessage((0, (0, parcelRequire("kJMdt")).default).savedFilterTitle),
                        title: formatMessage((0, (0, parcelRequire("kJMdt")).default).savedFilterTitle),
                        selectedTitle: (0, (0, parcelRequire("kJMdt")).default).savedFilterSelectedTitle,
                        description: formatMessage((0, (0, parcelRequire("kJMdt")).default).savedFilterDescription),
                        value: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).SAVED_FILTER,
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("2o8gl")))))
                    }
                ]
            }
        ] : [
            {
                options: [
                    {
                        title: formatMessage((0, (0, parcelRequire("kJMdt")).default).allIssuesFromProjectTitle),
                        selectedTitle: (0, (0, parcelRequire("kJMdt")).default).allIssuesFromProjectSelectedTitle,
                        value: null,
                        icon: projectAvatar || (0, ($parcel$interopDefault((0, parcelRequire("dXQDI")))))
                    }
                ]
            },
            {
                options: [
                    {
                        title: formatMessage((0, (0, parcelRequire("kJMdt")).default).teamTitle),
                        selectedTitle: (0, (0, parcelRequire("kJMdt")).default).teamSelectedTitle,
                        description: formatMessage((0, (0, parcelRequire("kJMdt")).default).teamDescription),
                        value: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).TEAM,
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("kYQTv")))))
                    },
                    {
                        title: formatMessage((0, (0, parcelRequire("kJMdt")).default).issueTypesTitle),
                        selectedTitle: (0, (0, parcelRequire("kJMdt")).default).issueTypesSelectedTitle,
                        description: formatMessage((0, (0, parcelRequire("kJMdt")).default).issueTypesDescription),
                        value: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).ISSUE_TYPES,
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("lJosW")))))
                    },
                    {
                        title: formatMessage((0, (0, parcelRequire("kJMdt")).default).labelsTitle),
                        selectedTitle: (0, (0, parcelRequire("kJMdt")).default).labelsSelectedTitle,
                        description: formatMessage((0, (0, parcelRequire("kJMdt")).default).labelsDescription),
                        value: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).LABELS,
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("bB6uF")))))
                    }
                ]
            },
            {
                options: [
                    {
                        title: formatMessage((0, (0, parcelRequire("kJMdt")).default).savedFilterTitle),
                        selectedTitle: (0, (0, parcelRequire("kJMdt")).default).savedFilterSelectedTitle,
                        description: formatMessage((0, (0, parcelRequire("kJMdt")).default).savedFilterDescription),
                        value: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).SAVED_FILTER,
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("2o8gl")))))
                    }
                ]
            }
        ];
    };
});
parcelRegister("2o8gl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1bd43b75b5db29b6$var$_react = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1bd43b75b5db29b6$var$_filter = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("jX361")));
    var $1bd43b75b5db29b6$var$_filter2 = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("bTqXB")));
    function $1bd43b75b5db29b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1bd43b75b5db29b6$var$FilterIcon = (props)=>$1bd43b75b5db29b6$var$_react.default.createElement($1bd43b75b5db29b6$var$_filter.default, Object.assign({
            LEGACY_fallbackIcon: $1bd43b75b5db29b6$var$_filter2.default
        }, props));
    $1bd43b75b5db29b6$var$FilterIcon.Name = 'FilterIconMigration';
    var $1bd43b75b5db29b6$var$_default = module.exports.default = $1bd43b75b5db29b6$var$FilterIcon;
});
parcelRegister("lJosW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fd20c75a63e82b8e$var$_react = $fd20c75a63e82b8e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fd20c75a63e82b8e$var$_issues = $fd20c75a63e82b8e$var$_interopRequireDefault((parcelRequire("gmyWi")));
    var $fd20c75a63e82b8e$var$_issues2 = $fd20c75a63e82b8e$var$_interopRequireDefault((parcelRequire("8sgpE")));
    function $fd20c75a63e82b8e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fd20c75a63e82b8e$var$IssuesIcon = (props)=>$fd20c75a63e82b8e$var$_react.default.createElement($fd20c75a63e82b8e$var$_issues.default, Object.assign({
            LEGACY_fallbackIcon: $fd20c75a63e82b8e$var$_issues2.default
        }, props));
    $fd20c75a63e82b8e$var$IssuesIcon.Name = 'IssuesIconMigration';
    var $fd20c75a63e82b8e$var$_default = module.exports.default = $fd20c75a63e82b8e$var$IssuesIcon;
});
parcelRegister("bB6uF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $87182fe6ca83cdb6$var$_react = $87182fe6ca83cdb6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $87182fe6ca83cdb6$var$_tag = $87182fe6ca83cdb6$var$_interopRequireDefault((parcelRequire("eKl4L")));
    var $87182fe6ca83cdb6$var$_label = $87182fe6ca83cdb6$var$_interopRequireDefault((parcelRequire("cL0IW")));
    function $87182fe6ca83cdb6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $87182fe6ca83cdb6$var$TagIcon = (props)=>$87182fe6ca83cdb6$var$_react.default.createElement($87182fe6ca83cdb6$var$_tag.default, Object.assign({
            LEGACY_fallbackIcon: $87182fe6ca83cdb6$var$_label.default
        }, props));
    $87182fe6ca83cdb6$var$TagIcon.Name = 'TagIconMigration';
    var $87182fe6ca83cdb6$var$_default = module.exports.default = $87182fe6ca83cdb6$var$TagIcon;
});
parcelRegister("eKl4L", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $abc5b5ca44dcd9b7$var$_react = $abc5b5ca44dcd9b7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $abc5b5ca44dcd9b7$var$_baseNew = $abc5b5ca44dcd9b7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $abc5b5ca44dcd9b7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $abc5b5ca44dcd9b7$var$TagIcon = (props)=>$abc5b5ca44dcd9b7$var$_react.default.createElement($abc5b5ca44dcd9b7$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8.768 1.75H13c.69 0 1.25.56 1.25 1.25v4.232c0 .332-.132.65-.366.884l-5.75 5.75a1.25 1.25 0 0 1-1.768 0L2.134 9.634a1.25 1.25 0 0 1 0-1.768l5.75-5.75a1.25 1.25 0 0 1 .884-.366Z"/><rect width="2" height="2" x="10" y="4" fill="currentcolor" rx="1"/>`
        }, props));
    $abc5b5ca44dcd9b7$var$TagIcon.displayName = 'TagIcon';
    var $abc5b5ca44dcd9b7$var$_default = module.exports.default = $abc5b5ca44dcd9b7$var$TagIcon;
});
parcelRegister("cL0IW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $949a6f91366cfd9f$var$_react = $949a6f91366cfd9f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $949a6f91366cfd9f$var$_tag = $949a6f91366cfd9f$var$_interopRequireDefault((parcelRequire("eKl4L")));
    function $949a6f91366cfd9f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $949a6f91366cfd9f$var$LabelIcon = (props)=>$949a6f91366cfd9f$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.433 5.428-4.207.6A2 2 0 0 0 5.53 7.727l-.6 4.207a1 1 0 0 0 .281.849l6.895 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283m-.647 5.858A1.666 1.666 0 1 1 8.43 8.929a1.666 1.666 0 0 1 2.357 2.357"/></svg>`
        }, props, {
            newIcon: $949a6f91366cfd9f$var$_tag.default
        }));
    $949a6f91366cfd9f$var$LabelIcon.displayName = 'LabelIcon';
    var $949a6f91366cfd9f$var$_default = module.exports.default = $949a6f91366cfd9f$var$LabelIcon;
});
parcelRegister("kYQTv", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f46270f5595a12ea$var$_react = $f46270f5595a12ea$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f46270f5595a12ea$var$_teams = $f46270f5595a12ea$var$_interopRequireDefault((parcelRequire("c781K")));
    var $f46270f5595a12ea$var$_teams2 = $f46270f5595a12ea$var$_interopRequireDefault((parcelRequire("8E9tB")));
    function $f46270f5595a12ea$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f46270f5595a12ea$var$TeamsIcon = (props)=>$f46270f5595a12ea$var$_react.default.createElement($f46270f5595a12ea$var$_teams.default, Object.assign({
            LEGACY_fallbackIcon: $f46270f5595a12ea$var$_teams2.default
        }, props));
    $f46270f5595a12ea$var$TeamsIcon.Name = 'TeamsIconMigration';
    var $f46270f5595a12ea$var$_default = module.exports.default = $f46270f5595a12ea$var$TeamsIcon;
});
parcelRegister("8E9tB", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $64b968f6017085d1$var$_react = $64b968f6017085d1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $64b968f6017085d1$var$_teams = $64b968f6017085d1$var$_interopRequireDefault((parcelRequire("c781K")));
    function $64b968f6017085d1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $64b968f6017085d1$var$TeamsIcon = (props)=>$64b968f6017085d1$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 7.2a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m7.8 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m1.2 9.3a4.5 4.5 0 0 0-4.5-4.5h-1.378c-.484 0-1.275.127-1.875.41l.77 1.627c.14-.066.342-.129.566-.174s.421-.063.539-.063H17.1a2.7 2.7 0 0 1 2.7 2.7V18a.6.6 0 0 1-.6.6h-3.478a2.7 2.7 0 0 1-2.538-1.777l-.676-1.86A4.5 4.5 0 0 0 8.278 12H6.9a4.5 4.5 0 0 0-4.5 4.5V18a2.4 2.4 0 0 0 2.4 2.4h4.8v-1.8H4.8a.6.6 0 0 1-.6-.6v-1.5a2.7 2.7 0 0 1 2.7-2.7h1.378a2.7 2.7 0 0 1 2.538 1.777l.676 1.86a4.5 4.5 0 0 0 4.23 2.963H19.2a2.4 2.4 0 0 0 2.4-2.4z" clip-rule="evenodd"/></svg>`
        }, props, {
            newIcon: $64b968f6017085d1$var$_teams.default
        }));
    $64b968f6017085d1$var$TeamsIcon.displayName = 'TeamsIcon';
    var $64b968f6017085d1$var$_default = module.exports.default = $64b968f6017085d1$var$TeamsIcon;
});
parcelRegister("g5ZcC", function(module, exports) {
    $parcel$export(module.exports, "SOURCE_VALUE_FIELD_NAME", ()=>$327b54d1894940ae$export$2acdb7270c211b02);
    $parcel$export(module.exports, "SourceValuePicker", ()=>$327b54d1894940ae$export$427e84d70337182b);
    var $5uXOq = parcelRequire("5uXOq");
    var $qfj8c;
    var $7O4UO;
    var $bUa6y;
    var $koVbs;
    var $6prxh;
    var $lq9tz;
    var $6r4tP;
    const $327b54d1894940ae$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
    const $327b54d1894940ae$export$2acdb7270c211b02 = 'sourceValue';
    const $327b54d1894940ae$export$427e84d70337182b = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const formState = (0, (0, parcelRequire("bUa6y")).useFormState)();
        const sourceType = formState?.values.sourceType;
        if (!sourceType) return null;
        const mappedSource = (0, (0, parcelRequire("6r4tP")).boardSourceFieldComponentMap)[sourceType];
        if (!mappedSource) {
            (0, (0, parcelRequire("6prxh")).fireBoardCreateErrorAnalytics)({
                error: new Error(`No source field component found for ${sourceType}`),
                id: 'unmappedSourceType'
            });
            return null;
        }
        const { component: PickerComponent, extraProps: extraProps, label: label } = mappedSource;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            key: `sourceValue-${sourceType}`,
            name: $327b54d1894940ae$export$2acdb7270c211b02,
            label: formatMessage(label),
            isRequired: true
        }, ({ fieldProps: fieldProps, error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(PickerComponent, {
                key: `sourceValue-${sourceType}-picker`,
                label: formatMessage(label),
                ...fieldProps,
                ...extraProps
            }), error === $327b54d1894940ae$export$7b060a5763a6e199 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), {
                testId: "software-board-create.ui.modal.form.source-value-picker.error"
            }, formatMessage((0, (0, parcelRequire("lq9tz")).default).sourceValueEmptyError))));
    };
});
parcelRegister("lq9tz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6bce06a89957b13f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6bce06a89957b13f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueTypeFieldLabel: {
            "id": "software-board-create.modal.form.source-value-picker.issue-type-field-label",
            "defaultMessage": "Issue type"
        },
        teamFieldLabel: {
            "id": "software-board-create.modal.form.source-value-picker.team-field-label",
            "defaultMessage": "Team"
        },
        labelsFieldLabel: {
            "id": "software-board-create.modal.form.source-value-picker.labels-field-label",
            "defaultMessage": "Label"
        },
        savedFilterLabel: {
            "id": "software-board-create.modal.form.source-value-picker.saved-filter-label",
            "defaultMessage": "Select a saved filter"
        },
        sourceValueEmptyError: {
            "id": "software-board-create.modal.form.source-value-picker.source-value-empty-error",
            "defaultMessage": "Please select a value"
        }
    });
});
parcelRegister("6r4tP", function(module, exports) {
    $parcel$export(module.exports, "boardSourceFieldComponentMap", ()=>$735afc375e726c9d$export$69996e7483e1a92f);
    var $h3KSk;
    var $aoE9s;
    var $lq9tz;
    var $bVi3d;
    var $d8KW7;
    const $735afc375e726c9d$export$69996e7483e1a92f = {
        [(0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).ISSUE_TYPES]: {
            component: (0, (0, parcelRequire("aoE9s")).GenericPicker),
            label: (0, (0, parcelRequire("lq9tz")).default).issueTypeFieldLabel,
            id: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).ISSUE_TYPES,
            extraProps: {
                jqlTerm: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS_JQLTERM)[(0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).ISSUE_TYPES]
            }
        },
        [(0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).TEAM]: {
            component: (0, (0, parcelRequire("d8KW7")).TeamPicker),
            label: (0, (0, parcelRequire("lq9tz")).default).teamFieldLabel,
            id: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).TEAM
        },
        [(0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).LABELS]: {
            component: (0, (0, parcelRequire("aoE9s")).GenericPicker),
            label: (0, (0, parcelRequire("lq9tz")).default).labelsFieldLabel,
            id: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).LABELS,
            extraProps: {
                jqlTerm: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS_JQLTERM)[(0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).LABELS]
            }
        },
        [(0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).SAVED_FILTER]: {
            component: (0, (0, parcelRequire("bVi3d")).SavedFilterPicker),
            label: (0, (0, parcelRequire("lq9tz")).default).savedFilterLabel,
            id: (0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).SAVED_FILTER
        }
    };
});
parcelRegister("aoE9s", function(module, exports) {
    $parcel$export(module.exports, "GenericPicker", ()=>$e447e0e5a912af84$export$37d6fee5be00e6be);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $ujWmd;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $d7FF4;
    var $i0vxP;
    var $4R6GH;
    var $koVbs;
    var $h3KSk;
    var $1eigM;
    var $hp64R;
    const $e447e0e5a912af84$var$formatOptionLabel = (option)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center"
        }, option.avatar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $e447e0e5a912af84$var$imgStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: "square",
            size: "xsmall",
            src: option.avatar,
            borderColor: "transparent"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e447e0e5a912af84$var$optionStyles
        }, option.label));
    const $e447e0e5a912af84$export$37d6fee5be00e6be = ({ onChange: onChange, value: value, jqlTerm: jqlTerm, isInvalid: isInvalid, label: label })=>{
        const { loadOptions: loadOptions, isLoading: isLoading } = (0, (0, parcelRequire("1eigM")).useLoadOptionsController)();
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)();
        const [menuIsOpen, setMenuIsOpen] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, $5uXOq.useEffect)(()=>{
            loadOptions(jqlTerm)('').then((options)=>setDefaultOptions(options));
        }, [
            jqlTerm,
            loadOptions
        ]);
        const debouncedLoadOptions = (0, ($parcel$interopDefault($lFKmC)))((searchString, callback)=>loadOptions(jqlTerm)(searchString).then((options)=>callback(options)), (0, (0, parcelRequire("h3KSk")).PICKER_SEARCH_DEBOUNCE_TIME));
        const handleOnKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (!menuIsOpen && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) setMenuIsOpen(true);
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') setMenuIsOpen(false);
            if (event.key === 'Enter' && !menuIsOpen) event.preventDefault();
        }, [
            menuIsOpen
        ]);
        return (0, (0, parcelRequire("4R6GH")).fg)('nav4_simplified_board_create_beta') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i0vxP")).default), {
            onEscape: (0, ($parcel$interopDefault($8Rkzz)))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), {
            "aria-label": label,
            isMulti: true,
            isLoading: isLoading,
            formatOptionLabel: $e447e0e5a912af84$var$formatOptionLabel,
            defaultOptions: defaultOptions,
            loadOptions: debouncedLoadOptions,
            onChange: onChange,
            value: value,
            placeholder: formatMessage((0, (0, parcelRequire("hp64R")).default).genericPickerPlaceholder),
            menuPosition: "fixed",
            classNamePrefix: "source-value-picker",
            isInvalid: isInvalid,
            onFocus: ()=>setMenuIsOpen(true),
            onBlur: ()=>setMenuIsOpen(false),
            menuIsOpen: menuIsOpen,
            blurInputOnSelect: false,
            onKeyDown: handleOnKeyDown
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), {
            "aria-label": formatMessage((0, (0, parcelRequire("hp64R")).default).genericPickerAriaLabel),
            isMulti: true,
            isLoading: isLoading,
            formatOptionLabel: $e447e0e5a912af84$var$formatOptionLabel,
            defaultOptions: defaultOptions,
            loadOptions: debouncedLoadOptions,
            onChange: onChange,
            value: value,
            placeholder: formatMessage((0, (0, parcelRequire("hp64R")).default).genericPickerPlaceholder),
            menuPosition: "fixed",
            classNamePrefix: "source-value-picker",
            isInvalid: isInvalid,
            onFocus: ()=>setMenuIsOpen(true),
            onBlur: ()=>setMenuIsOpen(false),
            menuIsOpen: menuIsOpen,
            blurInputOnSelect: false
        });
    };
    const $e447e0e5a912af84$var$imgStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingRight: 'space.100'
    });
    const $e447e0e5a912af84$var$optionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    });
});
parcelRegister("d7FF4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac4d84cf4438daea$export$2e2bcd8739ae039);
    var $eAthk;
    var $3c98u;
    const $ac4d84cf4438daea$var$AsyncSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    var $ac4d84cf4438daea$export$2e2bcd8739ae039 = $ac4d84cf4438daea$var$AsyncSelect;
});
parcelRegister("1eigM", function(module, exports) {
    $parcel$export(module.exports, "useLoadOptionsController", ()=>$7d96f2b549b45260$export$50422aa3bb02e176);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $h3KSk;
    var $6prxh;
    var $hN9Wa;
    var $2NRUh;
    var $96pTU;
    var $cOgwf;
    const $7d96f2b549b45260$var$errorMessageMap = {
        [(0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS_JQLTERM)[(0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).ISSUE_TYPES]]: {
            title: (0, (0, parcelRequire("cOgwf")).default).failedToLoadIssueTypesTitle,
            description: (0, (0, parcelRequire("cOgwf")).default).failedToLoadIssueTypesDescription
        },
        [(0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS_JQLTERM)[(0, (0, parcelRequire("h3KSk")).BOARD_SOURCE_FIELDS).LABELS]]: {
            title: (0, (0, parcelRequire("cOgwf")).default).failedToLoadLabelsTitle,
            description: (0, (0, parcelRequire("cOgwf")).default).failedToLoadLabelsDescription
        },
        DEFAULT: {
            title: (0, (0, parcelRequire("cOgwf")).default).failedToLoadOptionsTitle,
            description: (0, (0, parcelRequire("cOgwf")).default).failedToLoadOptionsTitle
        }
    };
    const $7d96f2b549b45260$export$4dface15d86304a4 = ()=>(0, $5uXOq.useState)(false);
    const $7d96f2b549b45260$export$50422aa3bb02e176 = ()=>{
        const { projectId: projectId } = (0, (0, parcelRequire("2NRUh")).useBoardCreateContext)();
        const jqlBuilderFetch = (0, (0, parcelRequire("hN9Wa")).useJQLBuilderFetch)({
            projectId: projectId
        });
        const [isLoading, setIsLoading] = $7d96f2b549b45260$export$4dface15d86304a4();
        const { showErrorFlag: showErrorFlag } = (0, (0, parcelRequire("96pTU")).useBoardCreateFlag)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const loadOptions = (0, $5uXOq.useCallback)((jqlTerm)=>async (searchString)=>{
                setIsLoading(true);
                return jqlBuilderFetch(jqlTerm, searchString).catch((error)=>{
                    const errorText = $7d96f2b549b45260$var$errorMessageMap[jqlTerm] || $7d96f2b549b45260$var$errorMessageMap.DEFAULT;
                    showErrorFlag({
                        title: formatMessage(errorText.title),
                        description: formatMessage(errorText.description)
                    });
                    (0, (0, parcelRequire("6prxh")).fireBoardCreateErrorAnalytics)({
                        error: new Error(`Failed to fetch picker options: ${error}`),
                        attributes: {
                            jqlTerm: jqlTerm
                        },
                        id: 'fetchPickerOptions'
                    });
                    return [];
                }).finally(()=>{
                    setIsLoading(false);
                });
            }, [
            formatMessage,
            jqlBuilderFetch,
            setIsLoading,
            showErrorFlag
        ]);
        return {
            loadOptions: loadOptions,
            isLoading: isLoading
        };
    };
});
parcelRegister("hN9Wa", function(module, exports) {
    $parcel$export(module.exports, "useJQLBuilderFetch", ()=>$270d18388ecfb4c0$export$a8efb2384cee4751);
    var $5xKik;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $koeKL;
    const $270d18388ecfb4c0$export$a8efb2384cee4751 = ({ projectId: projectId })=>{
        if (projectId === undefined) throw new Error('Project ID is undefined');
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const environment = (0, $8Uumt.useRelayEnvironment)();
        return (0, $5uXOq.useCallback)(async (jqlTerm, searchString)=>(0, $8Uumt.fetchQuery)(environment, (0, (0, parcelRequire("5xKik")).default), {
                cloudId: cloudId,
                jqlTerm: jqlTerm,
                jql: `project = ${projectId}`,
                searchString: searchString
            }).toPromise().then((response)=>{
                if (response?.jira?.jqlBuilder?.fieldValues?.edges) {
                    const data = response.jira.jqlBuilder.fieldValues.edges.map((edge)=>{
                        if (jqlTerm === 'type') return {
                            label: edge?.node?.displayName || '',
                            value: edge?.node?.issueTypes && edge?.node?.issueTypes[0]?.issueTypeId || '',
                            avatar: edge?.node?.issueTypes && edge?.node?.issueTypes[0].avatar?.small || ''
                        };
                        return {
                            label: edge?.node?.displayName || '',
                            value: edge?.node?.displayName || ''
                        };
                    }) || [];
                    return data;
                }
                throw new Error('No response');
            }), [
            cloudId,
            environment,
            projectId
        ]);
    };
});
parcelRegister("5xKik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fa4b5f990b2941c$export$2e2bcd8739ae039);
    const $2fa4b5f990b2941c$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jqlTerm"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchString"
        }, v4 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v5 = [
            {
                "kind": "Variable",
                "name": "jqlContext",
                "variableName": "jql"
            },
            {
                "kind": "Variable",
                "name": "jqlTerm",
                "variableName": "jqlTerm"
            },
            {
                "kind": "Variable",
                "name": "searchString",
                "variableName": "searchString"
            }
        ], v6 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v7 = {
            "kind": "ScalarField",
            "name": "issueTypeId"
        }, v8 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "small"
                }
            ]
        }, v9 = {
            "kind": "InlineFragment",
            "selections": [
                v6
            ],
            "type": "JiraJqlLabelFieldValue"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3
                ],
                "kind": "Fragment",
                "name": "useJqlBuilderFetchQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v4,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v5,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v6,
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v7,
                                                                            v8
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueTypeFieldValue"
                                                            },
                                                            v9
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v2,
                    v1,
                    v3
                ],
                "kind": "Operation",
                "name": "useJqlBuilderFetchQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v4,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v5,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__typename"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v6,
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v7,
                                                                            v8,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "id"
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueTypeFieldValue"
                                                            },
                                                            v9
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "9c1b5bc55b0e3a4a61ff20a7b89ec0bf355a6530849d7e75a79eb5d499feda60",
                "metadata": {},
                "name": "useJqlBuilderFetchQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $2fa4b5f990b2941c$var$node.hash = "f9c373fe0144a8b52692f108c8ed6461";
    var $2fa4b5f990b2941c$export$2e2bcd8739ae039 = $2fa4b5f990b2941c$var$node;
});
parcelRegister("cOgwf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df0d6f28e92c570a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $df0d6f28e92c570a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        failedToLoadIssueTypesTitle: {
            "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-title",
            "defaultMessage": "We can\u2019t load issue types right now"
        },
        failedToLoadIssueTypesDescription: {
            "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-description",
            "defaultMessage": "Refresh the page and try again."
        },
        failedToLoadLabelsTitle: {
            "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-labels-title",
            "defaultMessage": "We can\u2019t load labels right now"
        },
        failedToLoadLabelsDescription: {
            "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-labels-description",
            "defaultMessage": "Refresh the page and try again."
        },
        failedToLoadOptionsTitle: {
            "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-options-title",
            "defaultMessage": "Something went wrong"
        },
        failedToLoadOptionsDescription: {
            "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-options-description",
            "defaultMessage": "Refresh the page and try again."
        }
    });
});
parcelRegister("hp64R", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92cf92e0de820ada$export$2e2bcd8739ae039);
    var $7VHMR;
    var $92cf92e0de820ada$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        genericPickerAriaLabel: {
            "id": "software-board-create.modal.form.source-value-picker.generic-picker.generic-picker-aria-label",
            "defaultMessage": "Select an option"
        },
        genericPickerPlaceholder: {
            "id": "software-board-create.modal.form.source-value-picker.generic-picker.generic-picker-placeholder",
            "defaultMessage": "Select"
        }
    });
});
parcelRegister("bVi3d", function(module, exports) {
    $parcel$export(module.exports, "SavedFilterPicker", ()=>$42f519acc50d59d9$export$7408ad1ebc985020);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $bTqXB;
    var $kgoHi;
    var $d7FF4;
    var $i0vxP;
    var $4R6GH;
    var $koVbs;
    var $h3KSk;
    var $j7OAx;
    var $jkPTf;
    const $42f519acc50d59d9$var$formatOptionLabel = (option)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center",
            gap: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bTqXB"))))), {
            label: option.label
        }), option.label);
    const $42f519acc50d59d9$export$7408ad1ebc985020 = ({ onChange: onChange, value: value, isInvalid: isInvalid, label: label })=>{
        const { loadOptions: loadOptions, isLoading: isLoading } = (0, (0, parcelRequire("j7OAx")).useLoadSavedFiltersController)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const debouncedLoadOptions = (0, ($parcel$interopDefault($lFKmC)))((searchString, callback)=>loadOptions(searchString).then((options)=>callback(options)), (0, (0, parcelRequire("h3KSk")).PICKER_SEARCH_DEBOUNCE_TIME));
        return (0, (0, parcelRequire("4R6GH")).fg)('nav4_simplified_board_create_beta') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i0vxP")).default), {
            onEscape: (0, ($parcel$interopDefault($8Rkzz)))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), {
            "aria-label": label,
            isLoading: isLoading,
            formatOptionLabel: $42f519acc50d59d9$var$formatOptionLabel,
            defaultOptions: true,
            loadOptions: debouncedLoadOptions,
            onChange: onChange,
            value: value,
            placeholder: formatMessage((0, (0, parcelRequire("jkPTf")).default).savedFilterPickerPlaceholder),
            menuPosition: "fixed",
            classNamePrefix: "source-value-picker",
            isInvalid: isInvalid
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), {
            "aria-label": formatMessage((0, (0, parcelRequire("jkPTf")).default).savedFilterPickerAriaLabel),
            isLoading: isLoading,
            formatOptionLabel: $42f519acc50d59d9$var$formatOptionLabel,
            defaultOptions: true,
            loadOptions: debouncedLoadOptions,
            onChange: onChange,
            value: value,
            placeholder: formatMessage((0, (0, parcelRequire("jkPTf")).default).savedFilterPickerPlaceholder),
            menuPosition: "fixed",
            classNamePrefix: "source-value-picker",
            isInvalid: isInvalid
        });
    };
});
parcelRegister("j7OAx", function(module, exports) {
    $parcel$export(module.exports, "useLoadSavedFiltersController", ()=>$c506adadb53c5f15$export$bb3a63b49faf836c);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $6p4sE;
    var $6prxh;
    var $96S1K;
    var $96pTU;
    const $c506adadb53c5f15$export$4dface15d86304a4 = ()=>(0, $5uXOq.useState)(false);
    const $c506adadb53c5f15$export$bb3a63b49faf836c = ()=>{
        const savedFiltersFetch = (0, (0, parcelRequire("96S1K")).useSavedFiltersFetch)();
        const [isLoading, setIsLoading] = $c506adadb53c5f15$export$4dface15d86304a4();
        const { showErrorFlag: showErrorFlag } = (0, (0, parcelRequire("96pTU")).useBoardCreateFlag)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const loadOptions = (0, $5uXOq.useCallback)(async (searchString)=>{
            setIsLoading(true);
            return savedFiltersFetch(searchString).catch((error)=>{
                showErrorFlag({
                    title: formatMessage((0, (0, parcelRequire("6p4sE")).default).loadSavedFiltersErrorTitle),
                    description: formatMessage((0, (0, parcelRequire("6p4sE")).default).loadSavedFiltersErrorDescription)
                });
                (0, (0, parcelRequire("6prxh")).fireBoardCreateErrorAnalytics)({
                    error: new Error(`Failed to fetch saved filters: ${error}`),
                    id: 'fetchSavedFilters'
                });
                return [];
            }).finally(()=>{
                setIsLoading(false);
            });
        }, [
            formatMessage,
            savedFiltersFetch,
            setIsLoading,
            showErrorFlag
        ]);
        return {
            loadOptions: loadOptions,
            isLoading: isLoading
        };
    };
});
parcelRegister("96S1K", function(module, exports) {
    $parcel$export(module.exports, "useSavedFiltersFetch", ()=>$c60033a932502cc6$export$919a4c273fb6b0e5);
    var $hNMmP;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $koeKL;
    const $c60033a932502cc6$export$919a4c273fb6b0e5 = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const environment = (0, $8Uumt.useRelayEnvironment)();
        return (0, $5uXOq.useCallback)(async (searchString)=>(0, $8Uumt.fetchQuery)(environment, (0, (0, parcelRequire("hNMmP")).default), {
                cloudId: cloudId,
                searchString: searchString
            }).toPromise().then((response)=>{
                if (response?.jira?.savedFilters?.edges) {
                    const data = response.jira.savedFilters.edges.map((edge)=>{
                        return {
                            label: edge?.node?.name || '',
                            value: edge?.node?.filterId || ''
                        };
                    }) || [];
                    return data;
                }
                throw new Error('No response');
            }), [
            cloudId,
            environment
        ]);
    };
});
parcelRegister("hNMmP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$15727aff43405dba$export$2e2bcd8739ae039);
    const $15727aff43405dba$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "searchString"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Literal",
                "name": "first",
                "value": 20
            },
            {
                "kind": "Variable",
                "name": "keyword",
                "variableName": "searchString"
            }
        ], v2 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "filterId"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ],
            "type": "JiraCustomFilter"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "useSavedFiltersFetchQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1,
                                    "concreteType": "JiraFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "savedFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v2
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.savedFilters.edges.node"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.savedFilters"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "useSavedFiltersFetchQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraFilterConnection",
                                "kind": "LinkedField",
                                "name": "savedFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v2,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "1c54fe404b07b4a4533c203ab6c68bf936d5a086953aa1a446da9bec5a0a67f5",
                "metadata": {},
                "name": "useSavedFiltersFetchQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $15727aff43405dba$var$node.hash = "69a6cd0661c8d852b37f79d9513a1db0";
    var $15727aff43405dba$export$2e2bcd8739ae039 = $15727aff43405dba$var$node;
});
parcelRegister("jkPTf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b4a2c8c458ce637b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b4a2c8c458ce637b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        savedFilterPickerAriaLabel: {
            "id": "software-board-create.modal.form.source-value-picker.saved-filter-picker.saved-filter-picker-aria-label",
            "defaultMessage": "Select an option"
        },
        savedFilterPickerPlaceholder: {
            "id": "software-board-create.modal.form.source-value-picker.saved-filter-picker.saved-filter-picker-placeholder",
            "defaultMessage": "Select"
        }
    });
});
parcelRegister("d8KW7", function(module, exports) {
    $parcel$export(module.exports, "TeamPicker", ()=>$6335ae6b67167392$export$3529dc978be43e9d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dqoiX;
    var $i0vxP;
    var $b71gk;
    var $4R6GH;
    var $koVbs;
    var $8vFwj;
    var $hgQ4J;
    var $koeKL;
    var $ghnVw;
    const $6335ae6b67167392$var$TEAM_A11Y_LABEL_ID = 'software-board-create.source-value.team';
    const $6335ae6b67167392$export$3529dc978be43e9d = ({ onChange: onChange, value: value, isInvalid: isInvalid, label: label })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const handleOnCreate = (0, $5uXOq.useCallback)((team)=>{
            if (!team) return;
            setTimeout(()=>{
                onChange(team);
            }, 1000);
        }, [
            onChange
        ]);
        const [createTeamDialog, createTeamDialogTrigger] = (0, (0, parcelRequire("8vFwj")).useCreateTeamDialog)({
            onCreate: handleOnCreate
        });
        const handleChange = (team)=>{
            onChange?.(team || null);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6335ae6b67167392$var$TeamPickerEditWrapper, null, (0, (0, parcelRequire("4R6GH")).fg)('nav4_simplified_board_create_beta') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            id: $6335ae6b67167392$var$TEAM_A11Y_LABEL_ID
        }, label), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i0vxP")).default), {
            onEscape: (0, ($parcel$interopDefault($8Rkzz)))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hgQ4J")).TeamPickerEdit), {
            siteId: cloudId,
            isCompact: false,
            hasNoTeamOption: false,
            createTeamDialogTrigger: createTeamDialogTrigger,
            placeholder: formatMessage((0, (0, parcelRequire("ghnVw")).default).placeholder),
            onChange: handleChange,
            defaultValue: value,
            isDropdownMenuFixedAndLayered: true,
            isInvalid: isInvalid,
            isClearable: false,
            "aria-labelledby": $6335ae6b67167392$var$TEAM_A11Y_LABEL_ID
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hgQ4J")).TeamPickerEdit), {
            siteId: cloudId,
            isCompact: false,
            hasNoTeamOption: false,
            createTeamDialogTrigger: createTeamDialogTrigger,
            placeholder: formatMessage((0, (0, parcelRequire("ghnVw")).default).placeholder),
            onChange: handleChange,
            defaultValue: value,
            isDropdownMenuFixedAndLayered: true,
            isInvalid: isInvalid,
            isClearable: false
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b71gk")).default), {
            id: "board-create-team-create-dialog"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("form", {
            tabIndex: -1,
            name: "create-team-dialog-form",
            onSubmit: (e)=>{
                e.stopPropagation();
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cglyw"
            ])
        }, createTeamDialog)));
    };
    const $6335ae6b67167392$var$removeFormSpaceStyle = null;
    const $6335ae6b67167392$var$TeamPickerEditWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_b9cj1ylp _t0z71ylp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8vFwj", function(module, exports) {
    $parcel$export(module.exports, "useCreateTeamDialog", ()=>$e708dcb0d93e7fe3$export$e8b8170429d616be);
    var $5uXOq = parcelRequire("5uXOq");
    var $euiLX;
    var $pa9q9;
    var $1wpPp;
    var $4ywcn;
    var $8igKv;
    var $koVbs;
    var $lfTZh;
    var $cYlk7;
    var $14XJw;
    var $9OXo1;
    var $0Wtmq;
    var $kxZPA;
    const $e708dcb0d93e7fe3$export$75096afde50756fd = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("gtwZw")).then((module)=>module.TeamCreateDialog), {
        moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
    });
    const $e708dcb0d93e7fe3$export$e8b8170429d616be = (props = {})=>{
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const [inputTeamName, setInputTeamName] = (0, $5uXOq.useState)('');
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = tenantContext;
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { data: { user: user } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        if (!atlassianAccountId && !user.accountId) throw new Error('Missing current user id');
        const addFlag = (0, $5uXOq.useCallback)(({ appearance: appearance, ...flagProps })=>{
            if (appearance === 'success' || appearance === 'normal') showFlag((serviceProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ywcn")).default), {
                    messageType: "transactional",
                    ...flagProps,
                    ...serviceProps
                }));
            if (appearance === 'warning') showFlag((serviceProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8igKv")).default), {
                    messageType: "transactional",
                    ...flagProps,
                    ...serviceProps
                }));
            if (appearance === 'error') showFlag((serviceProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wpPp")).default), {
                    messageType: "transactional",
                    ...flagProps,
                    ...serviceProps
                }));
        }, [
            showFlag
        ]);
        const { onCancel: onCancel } = {
            onCancel: ()=>null,
            ...props
        };
        const callback = (0, $5uXOq.useCallback)((teamName)=>{
            setInputTeamName(teamName);
            setIsOpen(true);
        }, []);
        const handleOnClose = ()=>{
            setIsOpen(false);
            onCancel();
        };
        const handleOnCreate = (team)=>{
            const formattedTeam = {
                ...team,
                name: team.displayName
            };
            props.onCreate?.(formattedTeam);
        };
        return [
            isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: "team-create-dialog"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("0Wtmq")).PeopleAndTeamsConfigurationProvider), {
                product: "jira",
                locale: (0, (0, parcelRequire("euiLX")).default)(locale)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($e708dcb0d93e7fe3$export$75096afde50756fd, {
                cloudId: cloudId,
                orgId: orgId,
                product: "jira",
                principalId: atlassianAccountId || user.accountId || '',
                onClose: handleOnClose,
                onCreateTeamSuccess: handleOnCreate,
                extraAnalyticsAttrs: props.analyticsCtx,
                enableMembershipSettingsChoice: true,
                currentUser: user.accountId ? {
                    id: user.accountId,
                    fullName: user.userFullname,
                    avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                    ...user
                } : undefined,
                prepopulatedFields: {
                    teamName: inputTeamName
                },
                addFlag: addFlag
            }))) : null,
            callback
        ];
    };
});
parcelRegister("1wpPp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ebed3b5115fbfc5$export$2e2bcd8739ae039);
    var $3KRpp;
    var $2ebed3b5115fbfc5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).ErrorFlag);
});
parcelRegister("4ywcn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a612b92e24f3853$export$2e2bcd8739ae039);
    var $3KRpp;
    var $1a612b92e24f3853$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).SuccessFlag);
});
parcelRegister("8igKv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87b804070d792a00$export$2e2bcd8739ae039);
    var $3KRpp;
    var $87b804070d792a00$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).WarningFlag);
});
parcelRegister("gtwZw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gPU4t")
    ]).then(()=>parcelRequire('75dcc'));
});
parcelRegister("hgQ4J", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "TeamPickerEdit", ()=>$a2ba033eb79fbb50$export$cb5f622bec189851);
    $parcel$export(module.exports, "TeamPickerEditEntryPointContent", ()=>$a2ba033eb79fbb50$export$93a79bad2594cfb5);
    $parcel$export(module.exports, "default", ()=>$a2ba033eb79fbb50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iM1TE;
    var $4R6GH;
    var $4qXN2 = parcelRequire("4qXN2");
    var $koVbs;
    var $lElIo;
    var $14XJw;
    var $4vyX4;
    var $4G4ne = parcelRequire("4G4ne");
    var $lWune;
    var $fAxaP;
    const $a2ba033eb79fbb50$var$stylesOverrides = {
        valueContainer: (base)=>({
                ...base,
                display: 'grid'
            }),
        placeholder: (base)=>({
                ...base,
                position: undefined,
                top: undefined,
                left: undefined,
                transform: undefined
            })
    };
    const $a2ba033eb79fbb50$export$cb5f622bec189851 = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { siteId: siteId, defaultValue: defaultValue, isClearable: isClearable = true, isDisabled: isDisabled = false, isInvalid: isInvalid = false, autoFocus: autoFocus = false, width: width = '100%', debounceTime: debounceTime = 300, onChange: onChange, placeholder: placeholder = formatMessage((0, (0, parcelRequire("4vyX4")).default).placeholderTeamEditSelector), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, styles: styles, noValueText: noValueText, createTeamDialogTrigger: createTeamDialogTrigger, isCompact: isCompact = true, hasNoTeamOption: hasNoTeamOption = true, ...fieldProps } = props;
        const [isCreateButtonFocused, setIsCreateButtonFocused] = (0, $5uXOq.useState)(false);
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const [hasTeams, setHasTeams] = (0, $5uXOq.useState)(true);
        const formattedNoValueText = formatMessage((0, (0, parcelRequire("4vyX4")).default).defaultNoValueText);
        const [updatedPlaceholder, setUpdatedPlaceholder] = (0, $5uXOq.useState)(placeholder);
        const [inputQuery, setInputQuery] = (0, $5uXOq.useState)('');
        const finalStyles = {
            ...(0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            ...styles || {},
            ...$a2ba033eb79fbb50$var$stylesOverrides
        };
        const maybeAddNoTeamOption = (0, $5uXOq.useCallback)((users, query)=>{
            setHasTeams(!(users.length === 0 && query.length === 0));
            if (query === '' && !!defaultValue && hasNoTeamOption) return [
                {
                    avatarUrl: (0, (0, parcelRequire("4R6GH")).fg)('move_issue_view_assets_into_central_location') ? (0, ($parcel$interopDefault($4qXN2))) : (0, ($parcel$interopDefault($4G4ne))),
                    id: (0, $7808beff4be6dc7e$export$53782b65600ab96d),
                    name: noValueText ?? formattedNoValueText
                }
            ].concat(users);
            setIsCreateButtonFocused(query.length > 0 && users.length === 0);
            return users;
        }, [
            defaultValue,
            noValueText,
            formattedNoValueText,
            hasNoTeamOption
        ]);
        const handleOnChange = (newValue, actionType)=>{
            if (Array.isArray(newValue)) return;
            if (onChange) {
                onChange(newValue?.id === (0, $7808beff4be6dc7e$export$53782b65600ab96d) ? null : newValue, actionType);
                setUpdatedPlaceholder(newValue?.id === (0, $7808beff4be6dc7e$export$53782b65600ab96d) ? formattedNoValueText : placeholder);
            }
        };
        const handleCreateTeam = (0, $5uXOq.useCallback)(()=>{
            createTeamDialogTrigger(inputQuery);
        }, [
            inputQuery,
            createTeamDialogTrigger
        ]);
        const handleOnKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (isCreateButtonFocused && event.key === 'Enter') handleCreateTeam();
        }, [
            isCreateButtonFocused,
            handleCreateTeam
        ]);
        const handleOnInputChange = (0, $5uXOq.useCallback)((query)=>{
            setInputQuery(query || '');
        }, [
            setInputQuery
        ]);
        const footer = (0, $5uXOq.useMemo)(()=>hasTeams && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lWune")).CreateTeamOption), {
                isFocused: isCreateButtonFocused,
                onClick: handleCreateTeam
            }), [
            hasTeams,
            handleCreateTeam,
            isCreateButtonFocused
        ]);
        const noOptionsMessage = (0, $5uXOq.useMemo)(()=>!hasTeams ? ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAxaP")).TeamPickerEmptyState), {
                    onActionClick: handleCreateTeam
                }) : undefined, [
            hasTeams,
            handleCreateTeam
        ]);
        const menuListStyle = (0, $5uXOq.useMemo)(()=>!hasTeams ? {
                menuList: (base)=>({
                        ...base,
                        maxHeight: '350px'
                    })
            } : {}, [
            hasTeams
        ]);
        const fixedMenuPosition = (0, (0, parcelRequire("4R6GH")).fg)('bugfix_team_field_menu_fixed_position') ? 'fixed' : 'absolute';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iM1TE")).default), {
            width: width,
            autoFocus: autoFocus,
            appearance: isCompact ? 'compact' : 'normal',
            debounceTime: debounceTime,
            fieldId: "team",
            filterOptions: maybeAddNoTeamOption,
            footer: footer,
            includeGroups: false,
            includeTeams: true,
            includeUsers: false,
            isClearable: isClearable,
            isMulti: false,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            productKey: "jira",
            siteId: siteId,
            value: defaultValue,
            onChange: handleOnChange,
            orgId: orgId,
            placeholder: updatedPlaceholder,
            menuPosition: isDropdownMenuFixedAndLayered === true ? fixedMenuPosition : undefined,
            styles: {
                ...finalStyles,
                ...menuListStyle
            },
            onInputChange: handleOnInputChange,
            onKeyDown: handleOnKeyDown,
            noOptionsMessage: noOptionsMessage,
            ...(0, (0, parcelRequire("4R6GH")).fg)('a11y_aria_label_on_business_fields_package') ? {
                ariaLabel: updatedPlaceholder
            } : {},
            ariaLabelledBy: fieldProps['aria-labelledby'],
            placeholderAvatar: "team"
        });
    };
    const $a2ba033eb79fbb50$export$93a79bad2594cfb5 = ({ props: props })=>(0, ($parcel$interopDefault($5uXOq))).createElement($a2ba033eb79fbb50$export$cb5f622bec189851, props);
    var $a2ba033eb79fbb50$export$2e2bcd8739ae039 = $a2ba033eb79fbb50$export$cb5f622bec189851;
});
parcelRegister("iM1TE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b137a2d3db08fbd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hOhJj;
    var $lO1N9;
    var $adPMl;
    const $2b137a2d3db08fbd$var$SmartUserPickerWithIntlProvider = (props)=>{
        const ufoId = props.inputId || props.fieldId;
        (0, (0, parcelRequire("adPMl")).useUFOConcurrentExperience)((0, (0, parcelRequire("adPMl")).smartUserPickerRenderedUfoExperience), ufoId);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adPMl")).UfoErrorBoundary), {
            id: ufoId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lO1N9")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hOhJj")).SmartUserPicker), props)));
    };
    var $2b137a2d3db08fbd$export$2e2bcd8739ae039 = $2b137a2d3db08fbd$var$SmartUserPickerWithIntlProvider;
});
parcelRegister("hOhJj", function(module, exports) {
    $parcel$export(module.exports, "SmartUserPicker", ()=>$04b57dfeec197d1a$export$9eedb6e5d313efdb);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $cb25w;
    var $8QpSo;
    var $8RXs9;
    var $jZA09;
    var $cr0SA;
    var $3smIt;
    var $4Mwus;
    var $lO1N9;
    var $3Q8Js;
    var $bjnDn;
    var $adPMl;
    const $04b57dfeec197d1a$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
    const $04b57dfeec197d1a$var$ufoEndStateConfig = (fieldId)=>{
        return {
            metadata: {
                contextType: fieldId
            }
        };
    };
    const $04b57dfeec197d1a$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
    const $04b57dfeec197d1a$var$stringContains = (str, substr)=>{
        if (str === null || str === undefined) return false;
        if (substr === null || substr === '' || substr === undefined) return true;
        return str.toLowerCase().includes(substr.toLowerCase());
    };
    const $04b57dfeec197d1a$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
                id: id,
                type: type
            }));
    const $04b57dfeec197d1a$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
    class $04b57dfeec197d1a$export$9b9bd453d1d4e4ce extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                baseUrl: '',
                includeUsers: true,
                includeGroups: false,
                includeTeams: false,
                includeNonLicensedUsers: false,
                prefetch: false,
                principalId: 'Context',
                debounceTime: $04b57dfeec197d1a$var$DEFAULT_DEBOUNCE_TIME_MS
            };
        }
        constructor(props){
            super(props), this.state = {
                users: [],
                loading: false,
                closed: true,
                query: '',
                defaultValue: [],
                bootstrapOptions: []
            }, this.abortOptionsShownUfoExperience = ()=>{
                if (this.optionsShownUfoExperienceInstance.state.id === (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id) this.optionsShownUfoExperienceInstance.abort();
            }, this.startOptionsShownUfoExperience = ()=>{
                this.abortOptionsShownUfoExperience();
                this.optionsShownUfoExperienceInstance.start();
            }, this.fireEvent = (eventCreator, ...args)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                if (createAnalyticsEvent) (0, (0, parcelRequire("4Mwus")).createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
            }, this.filterOptions = (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users, this.memoizedFilterOptions = (0, (0, parcelRequire("8QpSo")).default)(this.filterOptions), this.getUsers = (0, ($parcel$interopDefault($lFKmC)))(async ()=>{
                const { query: query, sessionId: sessionId, closed: closed } = this.state;
                const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, orgId: orgId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, searchQueryFilter: searchQueryFilter, siteId: siteId } = this.props;
                const maxNumberOfResults = maxOptions || 100;
                const startTime = window.performance.now();
                const recommendationsRequest = {
                    baseUrl: baseUrl,
                    context: {
                        containerId: containerId,
                        contextType: fieldId,
                        objectId: objectId,
                        principalId: principalId,
                        productKey: productKey,
                        siteId: siteId,
                        organizationId: orgId,
                        childObjectId: childObjectId,
                        sessionId: sessionId,
                        productAttributes: productAttributes
                    },
                    includeUsers: includeUsers,
                    includeGroups: includeGroups,
                    includeTeams: includeTeams,
                    includeNonLicensedUsers: includeNonLicensedUsers,
                    maxNumberOfResults: maxNumberOfResults,
                    query: query,
                    searchQueryFilter: searchQueryFilter
                };
                try {
                    this.fireEvent((0, (0, parcelRequire("4Mwus")).requestUsersEvent));
                    const recommendedUsers = await (0, (0, parcelRequire("3Q8Js")).default)(recommendationsRequest, intl);
                    if (overrideByline) {
                        for (let option of recommendedUsers)if ((0, (0, parcelRequire("3smIt")).isUser)(option) || (0, (0, parcelRequire("3smIt")).isExternalUser)(option) || (0, (0, parcelRequire("3smIt")).isTeam)(option)) option.byline = overrideByline(option);
                    }
                    const elapsedTimeMilli = window.performance.now() - startTime;
                    const displayedUsers = recommendedUsers.length === 0 && onEmpty ? await onEmpty(query) ?? [] : recommendedUsers;
                    this.setState((state)=>{
                        const applicable = state.query === query;
                        const users = applicable ? displayedUsers : state.users;
                        const loading = !applicable;
                        this.fireEvent((0, (0, parcelRequire("4Mwus")).successfulRequestUsersEvent), {
                            users: $04b57dfeec197d1a$var$getUsersForAnalytics(recommendedUsers),
                            elapsedTimeMilli: elapsedTimeMilli,
                            displayedUsers: $04b57dfeec197d1a$var$getUsersForAnalytics(displayedUsers),
                            productAttributes: productAttributes,
                            applicable: applicable
                        });
                        return {
                            users: users,
                            loading: loading
                        };
                    });
                } catch (e) {
                    const is5xxEvent = $04b57dfeec197d1a$var$checkIf500Event(e.statusCode);
                    if (!closed && !onError && is5xxEvent) this.optionsShownUfoExperienceInstance.failure($04b57dfeec197d1a$var$ufoEndStateConfig(this.props.fieldId));
                    this.setState({
                        users: []
                    });
                    let onErrorProducedError = false;
                    let defaultUsers = [];
                    try {
                        defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                    } catch (error) {
                        onErrorProducedError = true;
                    }
                    if (onErrorProducedError && is5xxEvent) this.optionsShownUfoExperienceInstance.failure($04b57dfeec197d1a$var$ufoEndStateConfig(this.props.fieldId));
                    if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                    this.setState({
                        users: defaultUsers,
                        loading: false
                    });
                    const elapsedTimeMilli = window.performance.now() - startTime;
                    this.fireEvent((0, (0, parcelRequire("4Mwus")).failedRequestUsersEvent), {
                        elapsedTimeMilli: elapsedTimeMilli,
                        productAttributes: productAttributes
                    });
                }
            }, this.props.debounceTime ?? 0), this.onInputChange = (newQuery, sessionId)=>{
                const query = newQuery || '';
                const { closed: closed } = this.state;
                if (query === this.state.query) return;
                if (!closed) {
                    this.startOptionsShownUfoExperience();
                    this.setState({
                        loading: true,
                        query: query,
                        sessionId: sessionId
                    });
                    if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
                }
            }, this.filterUsers = ()=>{
                const { loading: loading, users: users, query: query } = this.state;
                const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
                if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                    const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                    this.fireEvent((0, (0, parcelRequire("4Mwus")).filterUsersEvent), {
                        filtered: $04b57dfeec197d1a$var$getUsersForAnalytics(bootstrapFilteredUsers),
                        all: $04b57dfeec197d1a$var$getUsersForAnalytics(this.props.bootstrapOptions)
                    });
                    return bootstrapFilteredUsers;
                }
                if (!loading) return filteredUsers;
                const queryFilteredUsers = filteredUsers.filter((user)=>$04b57dfeec197d1a$var$stringContains(user.name, query));
                this.fireEvent((0, (0, parcelRequire("4Mwus")).filterUsersEvent), {
                    filtered: $04b57dfeec197d1a$var$getUsersForAnalytics(queryFilteredUsers),
                    all: $04b57dfeec197d1a$var$getUsersForAnalytics(users)
                });
                return filteredUsers;
            }, this.onFocus = (sessionId)=>{
                const state = {
                    query: '',
                    closed: false
                };
                this.startOptionsShownUfoExperience();
                if (this.state.users.length === 0) {
                    state.sessionId = sessionId;
                    state.loading = true;
                } else this.fireEvent((0, (0, parcelRequire("4Mwus")).preparedUsersLoadedEvent), {
                    users: $04b57dfeec197d1a$var$getUsersForAnalytics(this.state.users),
                    preparedSessionId: this.state.sessionId,
                    sessionId: sessionId
                });
                this.setState((currentState)=>({
                        ...currentState,
                        ...state
                    }));
                if (this.props.onFocus) this.props.onFocus(sessionId);
            }, this.onBlur = (sessionId)=>{
                this.getUsers.cancel();
                this.abortOptionsShownUfoExperience();
                const users = this.state.query.length === 0 ? this.state.users : [];
                this.setState({
                    loading: false,
                    closed: true,
                    users: users
                });
                if (this.props.onBlur) this.props.onBlur(sessionId);
            };
            this.optionsShownUfoExperienceInstance = (0, (0, parcelRequire("adPMl")).smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
        }
        async componentDidMount() {
            try {
                const value = await (0, (0, parcelRequire("bjnDn")).default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey);
                this.setState({
                    defaultValue: value
                });
            } catch (e) {
                const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
                this.setState({
                    defaultValue: defaultValue
                });
            }
            const { prefetch: prefetch } = this.props;
            if (prefetch) {
                const sessionId = (0, $7Jxgt.v4)();
                this.fireEvent((0, (0, parcelRequire("4Mwus")).mountedWithPrefetchEvent), {
                    sessionId: sessionId
                });
                this.setState({
                    sessionId: sessionId
                });
            }
        }
        componentDidUpdate(prevProps, prevState) {
            if ($04b57dfeec197d1a$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
                users: []
            });
            if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
            else if (!this.state.closed && !this.state.loading) {
                if (![
                    (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
                    (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
                    (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
                ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($04b57dfeec197d1a$var$ufoEndStateConfig(this.props.fieldId));
            }
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lO1N9")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cr0SA")).UserPicker), {
                ...this.props,
                onInputChange: this.onInputChange,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                defaultValue: this.state.defaultValue,
                isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
                options: this.filterUsers()
            }));
        }
    }
    const $04b57dfeec197d1a$export$9eedb6e5d313efdb = (0, (0, parcelRequire("cb25w")).default)()((0, (0, parcelRequire("8RXs9")).default)($04b57dfeec197d1a$export$9b9bd453d1d4e4ce));
});
parcelRegister("jZA09", function(module, exports) {
    $parcel$export(module.exports, "UFOExperienceState", ()=>$175f7a63840c5fab$export$81b70111112841a0);
    const $175f7a63840c5fab$export$81b70111112841a0 = {
        NOT_STARTED: {
            id: 'NOT_STARTED',
            final: true
        },
        STARTED: {
            id: 'STARTED'
        },
        IN_PROGRESS: {
            id: 'IN_PROGRESS'
        },
        BLOCKED: {
            id: 'BLOCKED'
        },
        RECOVERED: {
            id: 'RECOVERED'
        },
        SUCCEEDED: {
            id: 'SUCCEEDED',
            final: true,
            success: true
        },
        SUCCEEDED_WAITING_FOR_DEPS: {
            id: 'SUCCEEDED_WAITING_FOR_DEPS'
        },
        FAILED: {
            id: 'FAILED',
            final: true
        },
        ABORTED: {
            id: 'ABORTED',
            final: true
        }
    };
});
parcelRegister("cr0SA", function(module, exports) {
    $parcel$export(module.exports, "UserPicker", ()=>$ee13645786fb45b4$export$83e0c73b09b3a9cd);
    var $cb25w;
    var $iOwNT;
    var $7K5PP;
    var $jZA09;
    var $5uXOq = parcelRequire("5uXOq");
    var $d3gzD;
    var $2wgOn;
    var $dyegP;
    var $fuG1P;
    var $hcX3V;
    var $hrO1B;
    var $2vFqP;
    var $pk97C;
    var $7Jxgt = parcelRequire("7Jxgt");
    class $ee13645786fb45b4$export$164f4d95e5d7e2f5 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.ufoId = (0, $7Jxgt.v4)();
            const experienceForId = (0, (0, parcelRequire("pk97C")).userPickerRenderedUfoExperience).getInstance(this.ufoId);
            experienceForId.start();
        }
        static{
            this.defaultProps = {
                width: 350,
                isMulti: false
            };
        }
        componentDidMount() {
            const experienceForId = (0, (0, parcelRequire("pk97C")).userPickerRenderedUfoExperience).getInstance(this.ufoId);
            if ([
                (0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id,
                (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
            ].includes(experienceForId.state.id)) experienceForId.success();
        }
        render() {
            const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false } = this.props;
            const width = this.props.width;
            const SelectComponent = allowEmail ? (0, (0, parcelRequire("iOwNT")).default) : (0, (0, parcelRequire("7K5PP")).default);
            const creatableProps = suggestEmailsForDomain ? (0, (0, parcelRequire("hcX3V")).getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, (0, parcelRequire("fuG1P")).getCreatableProps)(isValidEmail);
            const defaultPickerProps = {
                closeMenuOnScroll: closeMenuOnScroll,
                menuPortalTarget: menuPortalTarget,
                menuPosition: menuPosition,
                menuShouldBlockScroll: menuShouldBlockScroll,
                captureMenuScroll: captureMenuScroll,
                required: required
            };
            const pickerProps = allowEmail ? {
                ...defaultPickerProps,
                ...creatableProps,
                emailLabel: emailLabel
            } : {
                ...defaultPickerProps
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("pk97C")).UfoErrorBoundary), {
                id: this.ufoId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hrO1B")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2vFqP")).ExusUserSourceProvider), {
                fetchUserSource: loadUserSource
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d3gzD")).BaseUserPickerWithoutAnalytics), {
                ...this.props,
                width: width,
                SelectComponent: SelectComponent,
                styles: (0, (0, parcelRequire("2wgOn")).getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, this.props.isInvalid),
                components: (0, (0, parcelRequire("dyegP")).getComponents)(isMulti, anchor),
                pickerProps: pickerProps
            }))));
        }
    }
    const $ee13645786fb45b4$export$83e0c73b09b3a9cd = (0, (0, parcelRequire("cb25w")).default)()($ee13645786fb45b4$export$164f4d95e5d7e2f5);
});
parcelRegister("iOwNT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59b6485f0cb008dd$export$2e2bcd8739ae039);
    var $9OU1i;
    var $3c98u;
    const $59b6485f0cb008dd$var$CreatableSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("9OU1i")).default));
    var $59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;
});
parcelRegister("9OU1i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b29f1caecd9c7d5a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useCreatable", ()=>(parcelRequire("2HH7Y")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $2HH7Y;
    var $9uJ4X;
    const $b29f1caecd9c7d5a$var$CreatableSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const creatableProps = (0, (0, parcelRequire("9uJ4X")).default)(props);
        const selectProps = (0, (0, parcelRequire("2HH7Y")).default)(creatableProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;
});
parcelRegister("2HH7Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$994aeb783b6f955a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eEtcC;
    var $gyjU7;
    const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
        const candidate = String(inputValue).toLowerCase();
        const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
        const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
        return optionValue === candidate || optionLabel === candidate;
    };
    const $994aeb783b6f955a$var$builtins = {
        formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
        isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
        getNewOptionData: (inputValue, optionLabel)=>({
                label: optionLabel,
                value: inputValue,
                __isNew__: true
            })
    };
    function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
        const { getOptionValue: getOptionValue = (0, (0, parcelRequire("eEtcC")).getOptionValue), getOptionLabel: getOptionLabel = (0, (0, parcelRequire("eEtcC")).getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
        const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, (0, parcelRequire("gyjU7")).cleanValue)(value), propsOptions, {
                getOptionValue: getOptionValue,
                getOptionLabel: getOptionLabel
            }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
            formatCreateLabel,
            getNewOptionData,
            getOptionLabel,
            getOptionValue,
            inputValue,
            isValidNewOption,
            propsOptions,
            value
        ]);
        const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
                newOption,
                ...propsOptions
            ] : [
                ...propsOptions,
                newOption
            ] : propsOptions, [
            allowCreateWhileLoading,
            createOptionPosition,
            isLoading,
            newOption,
            propsOptions
        ]);
        const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
            const valueArray = Array.isArray(newValue) ? newValue : [
                newValue
            ];
            if (valueArray[valueArray.length - 1] === newOption) {
                if (onCreateOption) onCreateOption(inputValue);
                else {
                    const newOptionData = getNewOptionData(inputValue, inputValue);
                    const newActionMeta = {
                        action: 'create-option',
                        name: name,
                        option: newOptionData
                    };
                    propsOnChange((0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, [
                        ...(0, (0, parcelRequire("gyjU7")).cleanValue)(value),
                        newOptionData
                    ], newOptionData), newActionMeta);
                }
                return;
            }
            propsOnChange(newValue, actionMeta);
        }, [
            getNewOptionData,
            inputValue,
            isMulti,
            name,
            newOption,
            onCreateOption,
            propsOnChange,
            value
        ]);
        return {
            ...restSelectProps,
            options: options,
            onChange: onChange
        };
    }
});
parcelRegister("d3gzD", function(module, exports) {
    $parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", ()=>$d045e9522a427a64$export$b4ff48c8d43b18c3);
    var $cb25w;
    var $jZA09;
    var $lFKmC = parcelRequire("lFKmC");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $fUmMr;
    var $78Gdn;
    var $8fG8p;
    var $3smIt;
    var $pk97C;
    const $d045e9522a427a64$var$loadingMessage = ()=>null;
    const $d045e9522a427a64$var$classNamePrefix = 'fabric-user-picker';
    class $d045e9522a427a64$export$b4ff48c8d43b18c3 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isMulti: false,
                subtle: false,
                noBorder: false,
                textFieldBackgroundColor: false,
                isClearable: true,
                loadOptionsErrorMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("8fG8p")).messages).errorMessage),
                openMenuOnClick: false
            };
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            const derivedState = {};
            if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
            if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
            if (nextProps.value !== undefined) derivedState.value = (0, (0, parcelRequire("3smIt")).optionToSelectableOptions)(nextProps.value);
            else if ((0, (0, parcelRequire("3smIt")).isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
                derivedState.value = (0, (0, parcelRequire("3smIt")).optionToSelectableOptions)(nextProps.defaultValue);
                derivedState.isDefaultSet = true;
            }
            if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
            if (nextProps.options !== undefined) derivedState.options = nextProps.options;
            return derivedState;
        }
        constructor(props){
            super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                    if (this.selectRef) callback(this.selectRef);
                }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
                if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
            }, this.blur = ()=>{
                if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
            }, this.selectOption = this.withSelectRef((select)=>{
                const focusedOption = select.state.focusedOption;
                select.selectOption(focusedOption);
            }), this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
                if (removedValue && removedValue.data.fixed) return;
                this.resetInputState();
                const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
                (0, (0, parcelRequire("3smIt")).callCallback)(onChange, (0, (0, parcelRequire("3smIt")).extractOptionValue)(value), action);
                switch(action){
                    case 'select-option':
                        if (value) (0, (0, parcelRequire("3smIt")).callCallback)(onSelection, (0, (0, parcelRequire("3smIt")).extractOptionValue)(value), this.getSessionId(), this);
                        this.fireEvent((0, (0, parcelRequire("fUmMr")).selectEvent), isMulti ? option : value);
                        this.session = isMulti ? (0, (0, parcelRequire("fUmMr")).startSession)() : undefined;
                        break;
                    case 'clear':
                        (0, (0, parcelRequire("3smIt")).callCallback)(onClear);
                        this.fireEvent((0, (0, parcelRequire("fUmMr")).clearEvent));
                        break;
                    case 'remove-value':
                    case 'pop-value':
                        if (removedValue) this.fireEvent((0, (0, parcelRequire("fUmMr")).deleteEvent), removedValue.data);
                        break;
                }
                this.fireEvent((0, (0, parcelRequire("fUmMr")).searchedEvent));
                if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                    const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                    this.setState({
                        value: remainingValues ? remainingValues : [],
                        menuIsOpen: true
                    });
                }
                if (!this.props.value) this.setState({
                    value: value ? value : []
                });
            }, this.handleSelectRef = (ref)=>{
                this.selectRef = ref;
            }, this.addOptions = (0, (0, parcelRequire("78Gdn")).batchByKey)((request, newOptions)=>{
                const { resolving: resolving } = this.state;
                this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                    if (inflightRequest.toString() === request) return {
                        options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                        count: count - newOptions.length,
                        resolving: count - newOptions.length !== 0
                    };
                    return null;
                });
            }), this.handleLoadOptionsError = ()=>{
                const { count: count } = this.state;
                const newCount = count - 1;
                const resolving = newCount !== 0;
                let showError = false;
                if (!resolving) showError = true;
                this.setState({
                    count: newCount,
                    resolving: resolving,
                    showError: showError
                });
                this.fireEvent((0, (0, parcelRequire("fUmMr")).failedEvent));
            }, this.debouncedLoadOptions = (0, ($parcel$interopDefault($lFKmC)))((search)=>{
                const { loadOptions: loadOptions } = this.props;
                if (loadOptions) this.setState(({ inflightRequest: previousRequest })=>{
                    const inflightRequest = previousRequest + 1;
                    const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                    const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                    let count = 0;
                    if ((0, (0, parcelRequire("3smIt")).isIterable)(result)) for (const value of result){
                        Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                        count++;
                    }
                    else {
                        Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                        count++;
                    }
                    return {
                        inflightRequest: inflightRequest,
                        count: count,
                        resolving: count !== 0,
                        options: []
                    };
                });
            }, 200), this.abortOptionsShownUfoExperience = ()=>{
                if (this.optionsShownUfoExperienceInstance.state.id === (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id) this.optionsShownUfoExperienceInstance.abort();
            }, this.startOptionsShownUfoExperience = ()=>{
                this.abortOptionsShownUfoExperience();
                this.optionsShownUfoExperienceInstance.start();
            }, this.executeLoadOptions = (search)=>{
                const { loadOptions: loadOptions } = this.props;
                if (loadOptions) this.setState({
                    resolving: true,
                    showError: false
                }, ()=>this.debouncedLoadOptions(search));
            }, this.handleFocus = (event)=>{
                const { value: value, menuIsOpen: menuIsOpen } = this.state;
                if (!menuIsOpen || !this.session) this.startSession();
                this.startOptionsShownUfoExperience();
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onFocus, this.getSessionId());
                if (!this.isMenuOpenOnClickForSingleSelect) {
                    this.setState({
                        menuIsOpen: true
                    });
                    if (!this.props.isMulti && (0, (0, parcelRequire("3smIt")).isSingleValue)(value)) {
                        const input = event.target;
                        this.setState({
                            inputValue: value.label
                        }, ()=>{
                            if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                        });
                    }
                }
            }, this.resetInputState = ()=>{
                this.setState({
                    inputValue: ''
                });
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onInputChange, '', this.getSessionId());
            }, this.handleBlur = ()=>{
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onBlur, this.getSessionId());
                if ((0, (0, parcelRequire("3smIt")).isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
                this.resetInputState();
                this.abortOptionsShownUfoExperience();
                this.setState({
                    menuIsOpen: false,
                    initialFocusHandled: false,
                    options: []
                });
            }, this.handleOpen = ()=>{
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onOpen, this.getSessionId());
                this.setState({
                    menuIsOpen: true
                });
            }, this.handleClose = ()=>{
                this.resetInputState();
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onClose, this.getSessionId());
                this.setState({
                    menuIsOpen: false,
                    options: []
                });
            }, this.handleInputChange = (search, { action: action })=>{
                if (action === 'input-change' || action === 'set-value') {
                    (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onInputChange, search, this.getSessionId());
                    this.setState({
                        inputValue: search
                    });
                    this.startOptionsShownUfoExperience();
                }
            }, this.fireEvent = (eventCreator, ...args)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                if (createAnalyticsEvent) (0, (0, parcelRequire("fUmMr")).createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
            }, this.startSession = ()=>{
                this.session = (0, (0, parcelRequire("fUmMr")).startSession)();
                this.journeyId = this.getSessionId();
                this.fireEvent((0, (0, parcelRequire("fUmMr")).focusEvent));
            }, this.handleKeyDown = (event)=>{
                if (!this.isMenuOpenOnClickForSingleSelect) {
                    if (event.keyCode === 27) this.blur();
                    if (event.keyCode === 32 && !this.state.inputValue) {
                        event.preventDefault();
                        !this.props.disableInput && this.setState({
                            inputValue: ' '
                        });
                    }
                }
                if (this.session) {
                    this.session.lastKey = event.keyCode;
                    switch(event.keyCode){
                        case 38:
                            this.session.upCount++;
                            break;
                        case 40:
                            this.session.downCount++;
                            break;
                    }
                }
                this.props.onKeyDown && this.props.onKeyDown(event);
            }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
                this.setState({
                    hoveringClearIndicator: hoveringClearIndicator
                });
            }, this.getOptions = ()=>{
                const options = (0, (0, parcelRequire("3smIt")).getOptions)(this.state.options) || [];
                const { maxOptions: maxOptions, isMulti: isMulti } = this.props;
                if (maxOptions === 0) return [];
                if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                    const { value: value } = this.state;
                    let filteredOptions = options;
                    if (isMulti && Array.isArray(value)) {
                        const valueIds = value.map((item)=>item.data.id);
                        filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                    }
                    return filteredOptions.slice(0, maxOptions);
                }
                return options;
            }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
                if (this.state.initialFocusHandled) {
                    if (this.state.menuIsOpen) this.handleClose();
                    else this.handleOpen();
                } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                    this.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            this.state = {
                options: [],
                isDefaultSet: false,
                inflightRequest: 0,
                count: 0,
                hoveringClearIndicator: false,
                menuIsOpen: !!this.props.open,
                inputValue: props.search || '',
                resolving: false,
                showError: false,
                initialFocusHandled: false
            };
            this.optionsShownUfoExperienceInstance = (0, (0, parcelRequire("pk97C")).userPickerOptionsShownUfoExperience).getInstance((0, $7Jxgt.v4)());
        }
        get isMenuOpenOnClickForSingleSelect() {
            return this.props.openMenuOnClick && !this.props.isMulti;
        }
        componentDidMount() {
            const { open: open, search: search } = this.props;
            if (open) {
                if (!this.session) this.startSession();
                this.executeLoadOptions(search);
            }
        }
        componentDidUpdate(_, prevState) {
            const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
            if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
            if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
            if (!menuIsOpen && prevState.menuIsOpen && this.session) {
                this.fireEvent((0, (0, parcelRequire("fUmMr")).cancelEvent), prevState);
                this.session = undefined;
            }
            if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, (0, parcelRequire("fUmMr")).searchedEvent));
            if (this.state.inputValue !== prevState.inputValue) {
                if (this.session) this.session.inputChangeTime = Date.now();
            }
            if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
                (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id,
                (0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
        }
        get ariaProps() {
            const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
            const props = {
                ...this.props
            };
            return ariaLabels.reduce((obj, key)=>({
                    ...obj,
                    [key]: props[key]
                }), {});
        }
        render() {
            const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
            const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
            const appearance = this.getAppearance();
            const menuOpenDeciderProps = {
                ...!this.isMenuOpenOnClickForSingleSelect && {
                    menuIsOpen: menuIsOpen,
                    blurInputOnSelect: !isMulti,
                    openMenuOnFocus: true
                }
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
                name: name,
                value: value,
                autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
                "aria-labelledby": ariaLabelledBy,
                "aria-label": ariaLabel,
                "aria-live": ariaLive,
                "aria-required": required,
                required: required,
                ref: this.handleSelectRef,
                isMulti: isMulti,
                options: this.getOptions(),
                styles: styles,
                enableAnimation: isMulti,
                components: components,
                inputValue: inputValue,
                isLoading: count > 0 || resolving || isLoading,
                loadingMessage: $d045e9522a427a64$var$loadingMessage,
                menuPlacement: "auto",
                placeholder: placeholder ?? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("8fG8p")).messages).placeholder),
                addMoreMessage: addMoreMessage,
                classNamePrefix: $d045e9522a427a64$var$classNamePrefix,
                hoveringClearIndicator: hoveringClearIndicator,
                appearance: appearance,
                isClearable: isClearable,
                noBorder: noBorder,
                subtle: subtle,
                closeMenuOnSelect: !isMulti,
                noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
                footer: footer,
                isDisabled: isDisabled,
                isInvalid: isInvalid,
                isFocused: menuIsOpen,
                backspaceRemovesValue: isMulti,
                filterOption: null,
                clearValueLabel: clearValueLabel,
                menuMinWidth: menuMinWidth,
                menuPortalTarget: menuPortalTarget,
                disableInput: disableInput || isDisabled,
                instanceId: fieldId,
                inputId: inputId,
                onChange: this.handleChange,
                onMenuOpen: this.handleOpen,
                onFocus: this.handleFocus,
                onBlur: this.handleBlur,
                onMenuClose: this.handleClose,
                onInputChange: this.handleInputChange,
                onClearIndicatorHover: this.handleClearIndicatorHover,
                onKeyDown: this.handleKeyDown,
                maxPickerHeight: maxPickerHeight,
                textFieldBackgroundColor: textFieldBackgroundColor,
                header: header,
                placeholderAvatar: placeholderAvatar,
                ...this.ariaProps,
                ...pickerProps,
                ...UNSAFE_hasDraggableParentComponent && {
                    onValueContainerClick: this.handleClickDraggableParentComponent
                },
                ...menuOpenDeciderProps
            });
        }
    }
    const $d045e9522a427a64$export$d099ade7b4f4d2a4 = (0, (0, parcelRequire("cb25w")).default)()($d045e9522a427a64$export$b4ff48c8d43b18c3);
});
parcelRegister("fUmMr", function(module, exports) {
    $parcel$export(module.exports, "startSession", ()=>$e345c0b18a65d683$export$c0d84948cecf78d8);
    $parcel$export(module.exports, "createAndFireEventInElementsChannel", ()=>$e345c0b18a65d683$export$53eef0dcd9611650);
    $parcel$export(module.exports, "focusEvent", ()=>$e345c0b18a65d683$export$e7818c470f37c4bd);
    $parcel$export(module.exports, "clearEvent", ()=>$e345c0b18a65d683$export$7b5800e732182efb);
    $parcel$export(module.exports, "deleteEvent", ()=>$e345c0b18a65d683$export$95711ec6c6227e9a);
    $parcel$export(module.exports, "cancelEvent", ()=>$e345c0b18a65d683$export$e9caaaecfee38128);
    $parcel$export(module.exports, "selectEvent", ()=>$e345c0b18a65d683$export$48143d759475d90f);
    $parcel$export(module.exports, "searchedEvent", ()=>$e345c0b18a65d683$export$911fb7184b6037eb);
    $parcel$export(module.exports, "failedEvent", ()=>$e345c0b18a65d683$export$c2aec355fef65c9c);
    $parcel$export(module.exports, "userInfoEvent", ()=>$e345c0b18a65d683$export$f541f04954b0c11e);
    var $gB4mS;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $3smIt;
    const $e345c0b18a65d683$var$packageName = "platform-pkg";
    const $e345c0b18a65d683$var$packageVersion = "0.0.0-use.local";
    const $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
    const $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
    const $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
    const $e345c0b18a65d683$export$c0d84948cecf78d8 = ()=>({
            id: (0, $7Jxgt.v4)(),
            start: Date.now(),
            inputChangeTime: Date.now(),
            upCount: 0,
            downCount: 0,
            lastKey: undefined
        });
    const $e345c0b18a65d683$export$53eef0dcd9611650 = (0, (0, parcelRequire("gB4mS")).default)('fabric-elements');
    const $e345c0b18a65d683$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
            eventType: eventType,
            action: action,
            actionSubject: actionSubject,
            attributes: {
                packageName: $e345c0b18a65d683$var$packageName,
                packageVersion: $e345c0b18a65d683$var$packageVersion,
                ...attributes
            }
        });
    const $e345c0b18a65d683$var$checkValidId = (id)=>{
        return $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
    };
    const $e345c0b18a65d683$var$optionData2Analytics = (option)=>{
        const { id: id, type: type } = option;
        const validatedData = {
            id: $e345c0b18a65d683$var$checkValidId(id) ? id : null,
            type: type || null
        };
        if ((0, (0, parcelRequire("3smIt")).isExternalUser)(option)) return {
            ...validatedData,
            type: 'external_user',
            sources: option.sources,
            externalUserType: option.externalUserType
        };
        if ((0, (0, parcelRequire("3smIt")).isCustom)(option) && option.analyticsType) return {
            ...validatedData,
            type: option.analyticsType
        };
        return validatedData;
    };
    const $e345c0b18a65d683$var$buildValueForAnalytics = (value)=>{
        if (value) {
            const valueToConvert = Array.isArray(value) ? value : [
                value
            ];
            return valueToConvert.map(({ data: data })=>$e345c0b18a65d683$var$optionData2Analytics(data));
        }
        return [];
    };
    const $e345c0b18a65d683$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
            context: props.fieldId,
            sessionId: $e345c0b18a65d683$var$sessionId(session),
            pickerType: $e345c0b18a65d683$var$pickerType(props),
            journeyId: journeyId
        });
    const $e345c0b18a65d683$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'focused', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            values: $e345c0b18a65d683$var$buildValueForAnalytics(state.value)
        });
    const $e345c0b18a65d683$export$7b5800e732182efb = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'cleared', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            pickerOpen: state.menuIsOpen,
            values: $e345c0b18a65d683$var$values(state)
        });
    const $e345c0b18a65d683$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'deleted', 'userPickerItem', {
            context: props.fieldId,
            sessionId: $e345c0b18a65d683$var$sessionId(session),
            journeyId: journeyId,
            value: $e345c0b18a65d683$var$optionData2Analytics(args[0]),
            pickerOpen: state.menuIsOpen
        });
    const $e345c0b18a65d683$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'cancelled', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
            queryLength: $e345c0b18a65d683$var$queryLength(args[0]),
            spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(args[0]),
            upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
            downKeyCount: $e345c0b18a65d683$var$downKeyCount(session)
        });
    const $e345c0b18a65d683$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
        return $e345c0b18a65d683$var$createEvent('ui', $e345c0b18a65d683$var$selectEventType(session), 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
            position: $e345c0b18a65d683$var$position(state, args[0]),
            queryLength: $e345c0b18a65d683$var$queryLength(state),
            spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(state),
            upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
            downKeyCount: $e345c0b18a65d683$var$downKeyCount(session),
            result: $e345c0b18a65d683$var$result(args[0]),
            numberOfResults: $e345c0b18a65d683$var$numberOfResults(state)
        });
    };
    const $e345c0b18a65d683$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
        const searchResults = $e345c0b18a65d683$var$results(state);
        return $e345c0b18a65d683$var$createEvent('operational', 'searched', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
            durationSinceInputChange: $e345c0b18a65d683$var$durationSinceInputChange(session),
            queryLength: $e345c0b18a65d683$var$queryLength(state),
            isLoading: $e345c0b18a65d683$var$isLoading(props, state),
            results: searchResults,
            numberOfResults: searchResults.length
        });
    };
    const $e345c0b18a65d683$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$e345c0b18a65d683$var$createEvent('operational', 'failed', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId)
        });
    const $e345c0b18a65d683$export$f541f04954b0c11e = (sources, accountId)=>$e345c0b18a65d683$var$createEvent('ui', 'displayed', 'userInfo', {
            sources: sources,
            accountId: $e345c0b18a65d683$var$checkValidId(accountId) ? accountId : null
        });
    function $e345c0b18a65d683$var$queryLength(state) {
        return state.inputValue.length;
    }
    function $e345c0b18a65d683$var$selectEventType(session) {
        return session && session.lastKey === 13 ? 'pressed' : 'clicked';
    }
    function $e345c0b18a65d683$var$upKeyCount(session) {
        return session ? session.upCount : null;
    }
    function $e345c0b18a65d683$var$downKeyCount(session) {
        return session ? session.downCount : null;
    }
    function $e345c0b18a65d683$var$spaceInQuery(state) {
        return state.inputValue.indexOf(' ') !== -1;
    }
    function $e345c0b18a65d683$var$sessionDuration(session) {
        return session ? Date.now() - session.start : null;
    }
    function $e345c0b18a65d683$var$durationSinceInputChange(session) {
        return session ? Date.now() - session.inputChangeTime : null;
    }
    function $e345c0b18a65d683$var$sessionId(session) {
        return session && session.id;
    }
    function $e345c0b18a65d683$var$position(state, value) {
        return value ? state.options.findIndex((option)=>option === value.data) : -1;
    }
    function $e345c0b18a65d683$var$pickerType(props) {
        return props.isMulti ? 'multi' : 'single';
    }
    function $e345c0b18a65d683$var$result(option) {
        return option ? $e345c0b18a65d683$var$optionData2Analytics(option.data) : null;
    }
    function $e345c0b18a65d683$var$results(state) {
        return (state.options || []).map($e345c0b18a65d683$var$optionData2Analytics);
    }
    function $e345c0b18a65d683$var$isLoading(props, state) {
        return state.count > 0 || props.isLoading;
    }
    function $e345c0b18a65d683$var$values(state) {
        return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$e345c0b18a65d683$var$optionData2Analytics(option.data)) : [
            $e345c0b18a65d683$var$optionData2Analytics(state.value.data)
        ] : [];
    }
    function $e345c0b18a65d683$var$numberOfResults(state) {
        return (state.options || []).length;
    }
});
parcelRegister("3smIt", function(module, exports) {
    $parcel$export(module.exports, "isExternalUser", ()=>$02015d62698c11ec$export$f6058dbcb5980cb);
    $parcel$export(module.exports, "isUser", ()=>$02015d62698c11ec$export$2e44165f1da65304);
    $parcel$export(module.exports, "isTeam", ()=>$02015d62698c11ec$export$f8c4277cb588611f);
    $parcel$export(module.exports, "isGroup", ()=>$02015d62698c11ec$export$d7976824e9f55785);
    $parcel$export(module.exports, "isEmail", ()=>$02015d62698c11ec$export$7fbbfbca30081d0);
    $parcel$export(module.exports, "isCustom", ()=>$02015d62698c11ec$export$d3a8f0b77e9737fc);
    $parcel$export(module.exports, "isDefaultValuePopulated", ()=>$02015d62698c11ec$export$d6978985a41b0c8);
    $parcel$export(module.exports, "extractOptionValue", ()=>$02015d62698c11ec$export$7ae97131df521bff);
    $parcel$export(module.exports, "isIterable", ()=>$02015d62698c11ec$export$9652023d9040757);
    $parcel$export(module.exports, "getOptions", ()=>$02015d62698c11ec$export$d2312e68e1f5ad00);
    $parcel$export(module.exports, "optionToSelectableOptions", ()=>$02015d62698c11ec$export$e6fda14a194bcbcc);
    $parcel$export(module.exports, "getAvatarSize", ()=>$02015d62698c11ec$export$695fb564e621339a);
    $parcel$export(module.exports, "isChildInput", ()=>$02015d62698c11ec$export$3c62cf9a01367f27);
    $parcel$export(module.exports, "isSingleValue", ()=>$02015d62698c11ec$export$203c2bd2662d1ca2);
    $parcel$export(module.exports, "hasValue", ()=>$02015d62698c11ec$export$96bdbc84526f3739);
    $parcel$export(module.exports, "callCallback", ()=>$02015d62698c11ec$export$df325aa844b03c31);
    $parcel$export(module.exports, "getAvatarUrl", ()=>$02015d62698c11ec$export$b4f8f1f54acec99b);
    $parcel$export(module.exports, "isPopupUserPickerByComponent", ()=>$02015d62698c11ec$export$4f60a74234178416);
    $parcel$export(module.exports, "isLozengeText", ()=>$02015d62698c11ec$export$5419897287f5f1c7);
    var $8QpSo;
    var $b9dFI;
    const $02015d62698c11ec$export$f6058dbcb5980cb = (option)=>option.type === (0, $f93312f7d4958f08$export$50042ec1d2e00e63) || Boolean(option.isExternal);
    const $02015d62698c11ec$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $f93312f7d4958f08$export$8436e53e45ffe15b);
    const $02015d62698c11ec$export$f8c4277cb588611f = (option)=>option.type === (0, $f93312f7d4958f08$export$26bc40b960693765);
    const $02015d62698c11ec$export$d7976824e9f55785 = (option)=>option.type === (0, $f93312f7d4958f08$export$d460f747b73abb10);
    const $02015d62698c11ec$export$7fbbfbca30081d0 = (option)=>option.type === (0, $f93312f7d4958f08$export$6662b3461398ef8c);
    const $02015d62698c11ec$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $f93312f7d4958f08$export$eafd0979afa5b224);
    const $02015d62698c11ec$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
    const $02015d62698c11ec$var$isOptionData = (option)=>option.name !== undefined;
    const $02015d62698c11ec$export$3f993c492bd6c728 = (option)=>{
        if ($02015d62698c11ec$var$isOptionData(option)) return {
            data: option,
            isDisabled: option.isDisabled,
            label: option.name,
            value: option.id
        };
        else return {
            data: {
                ...option,
                name: option.id
            },
            isDisabled: option.isDisabled,
            label: option.id,
            value: option.id
        };
    };
    const $02015d62698c11ec$export$7ae97131df521bff = (value)=>{
        if (!value) return undefined;
        if (Array.isArray(value)) return value.map(({ data: option })=>option);
        return value.data;
    };
    const $02015d62698c11ec$export$9652023d9040757 = (a)=>typeof a[Symbol.iterator] === 'function';
    const $02015d62698c11ec$export$d2312e68e1f5ad00 = (0, (0, parcelRequire("8QpSo")).default)((options)=>options.map($02015d62698c11ec$export$3f993c492bd6c728));
    const $02015d62698c11ec$export$e6fda14a194bcbcc = (0, (0, parcelRequire("8QpSo")).default)((defaultValue)=>{
        if (!defaultValue) return null;
        if (Array.isArray(defaultValue)) return defaultValue.map($02015d62698c11ec$export$3f993c492bd6c728);
        return $02015d62698c11ec$export$3f993c492bd6c728(defaultValue);
    });
    const $02015d62698c11ec$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
    const $02015d62698c11ec$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
    const $02015d62698c11ec$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
    const $02015d62698c11ec$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
    const $02015d62698c11ec$export$df325aa844b03c31 = (callback, ...args)=>{
        if (typeof callback === 'function') try {
            return callback(...args);
        } catch (error) {
            console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
        }
    };
    const $02015d62698c11ec$export$b4f8f1f54acec99b = (optionData)=>{
        if ($02015d62698c11ec$export$2e44165f1da65304(optionData) || $02015d62698c11ec$export$f8c4277cb588611f(optionData) || $02015d62698c11ec$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
        return undefined;
    };
    const $02015d62698c11ec$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, (0, parcelRequire("b9dFI")).default);
    const $02015d62698c11ec$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
    const $02015d62698c11ec$export$5419897287f5f1c7 = (lozengeProp)=>{
        return lozengeProp?.hasOwnProperty('text') || false;
    };
});
const $f93312f7d4958f08$export$8436e53e45ffe15b = 'user';
const $f93312f7d4958f08$export$50042ec1d2e00e63 = 'external_user';
const $f93312f7d4958f08$export$26bc40b960693765 = 'team';
const $f93312f7d4958f08$export$d460f747b73abb10 = 'group';
const $f93312f7d4958f08$export$6662b3461398ef8c = 'email';
const $f93312f7d4958f08$export$eafd0979afa5b224 = 'custom';
parcelRegister("b9dFI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$768d8504b373d7ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $7nsd3 = parcelRequire("7nsd3");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $5n5w4;
    var $283js;
    var $iGDLS;
    var $4wJSY = parcelRequire("4wJSY");
    var $9KnKW;
    var $7VXAu;
    var $7K5PP;
    var $1DATb;
    var $hT6ku;
    const $768d8504b373d7ff$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
    const $768d8504b373d7ff$var$modifiers = [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            enabled: true,
            options: {
                padding: 5,
                boundary: 'clippingParents',
                altAxis: true,
                altBoundary: true
            }
        }
    ];
    const $768d8504b373d7ff$var$defaultPopperProps = {
        modifiers: $768d8504b373d7ff$var$modifiers,
        placement: 'bottom-start'
    };
    const $768d8504b373d7ff$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
    class $768d8504b373d7ff$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                closeMenuOnSelect: true,
                shouldCloseMenuOnTab: true,
                components: {},
                maxMenuHeight: 300,
                maxMenuWidth: 440,
                minMenuWidth: 220,
                popperProps: {},
                isSearchable: true,
                searchThreshold: 5,
                styles: {},
                options: []
            };
        }
        static getDerivedStateFromProps(props, state) {
            const newState = {};
            const mergedPopperProps = {
                ...$768d8504b373d7ff$var$defaultPopperProps,
                ...props.popperProps
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
            const mergedComponents = {
                ...(0, (0, parcelRequire("hT6ku")).defaultComponents),
                ...props.components
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
            if (!$768d8504b373d7ff$var$isEmpty(newState)) return newState;
            return null;
        }
        componentDidMount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'click',
                listener: this.handleClick,
                options: {
                    capture: true
                }
            });
        }
        componentWillUnmount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick?.();
            this.unbindWindowClick = null;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }
        componentDidUpdate(prevProps) {
            const { isOpen: isOpen } = this.props;
            if (prevProps.isOpen !== isOpen) {
                if (isOpen === true) this.open({
                    controlOverride: true
                });
                else if (isOpen === false) this.close({
                    controlOverride: true
                });
            }
        }
        render() {
            const { target: target } = this.props;
            const { isOpen: isOpen } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5n5w4")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9KnKW")).IdProvider), {
                postfix: "-popup-select"
            }, ({ id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iGDLS")).Reference), null, ({ ref: ref })=>target && target({
                        isOpen: isOpen,
                        onKeyDown: this.handleTargetKeyDown,
                        ref: this.resolveTargetRef(ref),
                        'aria-haspopup': 'true',
                        'aria-expanded': isOpen,
                        'aria-controls': isOpen ? id : undefined
                    })), this.renderSelect(id))));
        }
        constructor(...args){
            super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
                groupHeading: (provided)=>({
                        ...provided,
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`
                    })
            }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
                focusLockEnabled: false,
                isOpen: this.defaultOpenState ?? false,
                mergedComponents: (0, (0, parcelRequire("hT6ku")).defaultComponents),
                mergedPopperProps: $768d8504b373d7ff$var$defaultPopperProps
            }, this.handleTargetKeyDown = (event)=>{
                switch(event.key){
                    case 'ArrowDown':
                        this.open();
                        break;
                    default:
                }
            }, this.handleKeyDown = (event)=>{
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
                switch(event.key){
                    case 'Escape':
                    case 'Esc':
                        this.close();
                        break;
                    default:
                }
                if (this.props.onKeyDown) this.props.onKeyDown(event);
            }, this.handleClick = ({ target: target })=>{
                const { isOpen: isOpen } = this.state;
                if (!(target instanceof Element)) return;
                if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
                if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
            }, this.handleSelectChange = (value, actionMeta)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
                if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
                if (onChange) onChange(value, actionMeta);
            }, this.handleFirstPopperUpdate = ()=>{
                this.setState({
                    focusLockEnabled: true
                });
            }, this.open = (options)=>{
                const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onOpen) onOpen();
                if (onMenuOpen) onMenuOpen();
                this.setState({
                    isOpen: true
                }, ()=>{
                    if (this.selectRef) this.selectRef.select?.openMenu('first');
                });
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: 'keydown',
                    listener: this.handleKeyDown,
                    options: {
                        capture: true
                    }
                });
            }, this.close = (options)=>{
                const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onClose) onClose();
                if (onMenuClose) onMenuClose();
                this.setState({
                    isOpen: false
                });
                this.setState({
                    focusLockEnabled: false
                });
                if (this.targetRef != null) this.targetRef.focus();
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown?.();
                this.unbindWindowKeydown = null;
            }, this.resolveTargetRef = (popperRef)=>(ref)=>{
                    if (!this.targetRef && popperRef && ref) {
                        this.targetRef = ref;
                        if (typeof popperRef === 'function') popperRef(ref);
                        else popperRef.current = ref;
                    }
                }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                    this.menuRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }, this.getSelectRef = (ref)=>{
                this.selectRef = ref;
            }, this.getItemCount = ()=>{
                const { options: options } = this.props;
                let count = 0;
                options.forEach((groupOrOption)=>{
                    if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                    else count++;
                });
                return count;
            }, this.getMaxHeight = ()=>{
                const { maxMenuHeight: maxMenuHeight } = this.props;
                if (!this.selectRef) return maxMenuHeight;
                const showSearchControl = this.showSearchControl();
                const controlRef = this.selectRef.select?.controlRef;
                const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
                const maxHeight = maxMenuHeight - offsetHeight;
                return maxHeight;
            }, this.showSearchControl = ()=>{
                const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
                return isSearchable && this.getItemCount() > searchThreshold;
            }, this.renderSelect = (id)=>{
                const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
                const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
                const showSearchControl = this.showSearchControl();
                const portalDestination = $768d8504b373d7ff$var$canUseDOM() ? document.body : null;
                if (!portalDestination || !isOpen) return null;
                const selectComponents = {
                    ...mergedComponents,
                    Control: showSearchControl ? mergedComponents.Control : (0, (0, parcelRequire("hT6ku")).DummyControl)
                };
                const getLabel = ()=>{
                    if (label) return label;
                    else if (typeof placeholder === 'string') return placeholder;
                };
                const providedAriaLabel = getLabel();
                const updateInputAriaLabel = (ariaLabelText)=>{
                    if (this.selectRef?.select?.inputRef) {
                        if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                        this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                    }
                };
                const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                    const { focused: focused } = onFocusProps;
                    const options = props?.options || [];
                    const totalLength = options?.length;
                    const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                    const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                    const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                    return ariaLabelText;
                };
                const onReactSelectFocus = (onFocusProps)=>{
                    const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                    let ariaLabelText = '';
                    let ariaLiveMessage = '';
                    if (props.options?.length) {
                        if ((0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options)) {
                            const totalLength = (0, (0, parcelRequire("1DATb")).countAllOptions)(props.options);
                            ariaLiveMessage = (0, (0, parcelRequire("1DATb")).onFocus)(onFocusProps, props.options);
                            ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                        } else {
                            ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                            ariaLiveMessage = ariaLabelText;
                        }
                        updateInputAriaLabel(ariaLabelText);
                        return ariaLiveMessage;
                    }
                    return ariaLiveMessage;
                };
                const popper = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("283js")).Popper), {
                    ...mergedPopperProps,
                    onFirstUpdate: (state)=>{
                        this.handleFirstPopperUpdate();
                        mergedPopperProps.onFirstUpdate?.(state);
                    }
                }, ({ placement: placement, ref: ref, style: style })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hT6ku")).MenuDialog), {
                        style: style,
                        "data-placement": placement,
                        minWidth: minMenuWidth,
                        maxWidth: maxMenuWidth,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
                        disabled: !focusLockEnabled,
                        returnFocus: true
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                        "aria-label": providedAriaLabel,
                        backspaceRemovesValue: false,
                        controlShouldRenderValue: false,
                        isClearable: false,
                        tabSelectsValue: false,
                        menuIsOpen: true,
                        placeholder: placeholder,
                        ref: this.getSelectRef,
                        ...props,
                        isSearchable: showSearchControl,
                        styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)(this.defaultStyles, props.styles || {}),
                        maxMenuHeight: this.getMaxHeight(),
                        components: selectComponents,
                        onChange: this.handleSelectChange,
                        ariaLiveMessages: !showSearchControl ? {
                            onFocus: onReactSelectFocus,
                            ...props.ariaLiveMessages
                        } : props.ariaLiveMessages
                    }), footer)));
                return mergedPopperProps.strategy === 'fixed' ? popper : (0, $7nsd3.createPortal)(popper, portalDestination);
            };
        }
    }
});
parcelRegister("5n5w4", function(module, exports) {
    $parcel$export(module.exports, "ManagerReferenceNodeContext", ()=>$3e93612641040812$export$3dbd3405086fec7b);
    $parcel$export(module.exports, "ManagerReferenceNodeSetterContext", ()=>$3e93612641040812$export$cbabb21c2529b130);
    $parcel$export(module.exports, "Manager", ()=>$3e93612641040812$export$d0d38e7dec7a1a61);
    var $5uXOq = parcelRequire("5uXOq");
    var $3e93612641040812$export$3dbd3405086fec7b = $5uXOq.createContext();
    var $3e93612641040812$export$cbabb21c2529b130 = $5uXOq.createContext();
    function $3e93612641040812$export$d0d38e7dec7a1a61(_ref) {
        var children = _ref.children;
        var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
        var hasUnmounted = $5uXOq.useRef(false);
        $5uXOq.useEffect(function() {
            return function() {
                hasUnmounted.current = true;
            };
        }, []);
        var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
            if (!hasUnmounted.current) setReferenceNode(node);
        }, []);
        return $5uXOq.createElement($3e93612641040812$export$3dbd3405086fec7b.Provider, {
            value: referenceNode
        }, $5uXOq.createElement($3e93612641040812$export$cbabb21c2529b130.Provider, {
            value: handleSetReferenceNode
        }, children));
    }
});
parcelRegister("283js", function(module, exports) {
    $parcel$export(module.exports, "Popper", ()=>$18cee5f949ac4034$export$badac9ada3a0bdf9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5n5w4;
    var $eclLw;
    var $fNOWl;
    var $18cee5f949ac4034$var$NOOP = function NOOP() {
        return void 0;
    };
    var $18cee5f949ac4034$var$NOOP_PROMISE = function NOOP_PROMISE() {
        return Promise.resolve(null);
    };
    var $18cee5f949ac4034$var$EMPTY_MODIFIERS = [];
    function $18cee5f949ac4034$export$badac9ada3a0bdf9(_ref) {
        var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $18cee5f949ac4034$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
        var referenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeContext));
        var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
        var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
        $5uXOq.useEffect(function() {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, popperElement);
        }, [
            innerRef,
            popperElement
        ]);
        var options = $5uXOq.useMemo(function() {
            return {
                placement: placement,
                strategy: strategy,
                onFirstUpdate: onFirstUpdate,
                modifiers: [].concat(modifiers, [
                    {
                        name: 'arrow',
                        enabled: arrowElement != null,
                        options: {
                            element: arrowElement
                        }
                    }
                ])
            };
        }, [
            placement,
            strategy,
            onFirstUpdate,
            modifiers,
            arrowElement
        ]);
        var _usePopper = (0, (0, parcelRequire("fNOWl")).usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
        var childrenProps = $5uXOq.useMemo(function() {
            return {
                ref: setPopperElement,
                style: styles.popper,
                placement: state ? state.placement : placement,
                hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
                isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
                arrowProps: {
                    style: styles.arrow,
                    ref: setArrowElement
                },
                forceUpdate: forceUpdate || $18cee5f949ac4034$var$NOOP,
                update: update || $18cee5f949ac4034$var$NOOP_PROMISE
            };
        }, [
            setPopperElement,
            setArrowElement,
            placement,
            state,
            styles,
            update,
            forceUpdate
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)(childrenProps);
    }
});
parcelRegister("eclLw", function(module, exports) {
    $parcel$export(module.exports, "unwrapArray", ()=>$a56311d537d20f47$export$f52c55943429c8b6);
    $parcel$export(module.exports, "safeInvoke", ()=>$a56311d537d20f47$export$3dfa7c28635fe028);
    $parcel$export(module.exports, "setRef", ()=>$a56311d537d20f47$export$4bb192c7cacf928f);
    $parcel$export(module.exports, "fromEntries", ()=>$a56311d537d20f47$export$5150077fc2e7c662);
    $parcel$export(module.exports, "useIsomorphicLayoutEffect", ()=>$a56311d537d20f47$export$700979bc83e7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $a56311d537d20f47$export$f52c55943429c8b6 = function unwrapArray(arg) {
        return Array.isArray(arg) ? arg[0] : arg;
    };
    var $a56311d537d20f47$export$3dfa7c28635fe028 = function safeInvoke(fn) {
        if (typeof fn === 'function') {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return fn.apply(void 0, args);
        }
    };
    var $a56311d537d20f47$export$4bb192c7cacf928f = function setRef(ref, node) {
        if (typeof ref === 'function') return $a56311d537d20f47$export$3dfa7c28635fe028(ref, node);
        else if (ref != null) ref.current = node;
    };
    var $a56311d537d20f47$export$5150077fc2e7c662 = function fromEntries(entries) {
        return entries.reduce(function(acc, _ref) {
            var key = _ref[0], value = _ref[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    var $a56311d537d20f47$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
});
parcelRegister("fNOWl", function(module, exports) {
    $parcel$export(module.exports, "usePopper", ()=>$b812f23d0bbb9e85$export$f4d5bf230a36dd6e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $8Pv9O;
    var $lHrkK = parcelRequire("lHrkK");
    var $eclLw;
    var $b812f23d0bbb9e85$var$EMPTY_MODIFIERS = [];
    var $b812f23d0bbb9e85$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
        if (options === void 0) options = {};
        var prevOptions = $5uXOq.useRef(null);
        var optionsWithDefaults = {
            onFirstUpdate: options.onFirstUpdate,
            placement: options.placement || 'bottom',
            strategy: options.strategy || 'absolute',
            modifiers: options.modifiers || $b812f23d0bbb9e85$var$EMPTY_MODIFIERS
        };
        var _React$useState = $5uXOq.useState({
            styles: {
                popper: {
                    position: optionsWithDefaults.strategy,
                    left: '0',
                    top: '0'
                },
                arrow: {
                    position: 'absolute'
                }
            },
            attributes: {}
        }), state = _React$useState[0], setState = _React$useState[1];
        var updateStateModifier = $5uXOq.useMemo(function() {
            return {
                name: 'updateState',
                enabled: true,
                phase: 'write',
                fn: function fn(_ref) {
                    var state = _ref.state;
                    var elements = Object.keys(state.elements);
                    $7nsd3.flushSync(function() {
                        setState({
                            styles: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.styles[element] || {}
                                ];
                            })),
                            attributes: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.attributes[element]
                                ];
                            }))
                        });
                    });
                },
                requires: [
                    'computeStyles'
                ]
            };
        }, []);
        var popperOptions = $5uXOq.useMemo(function() {
            var newOptions = {
                onFirstUpdate: optionsWithDefaults.onFirstUpdate,
                placement: optionsWithDefaults.placement,
                strategy: optionsWithDefaults.strategy,
                modifiers: [].concat(optionsWithDefaults.modifiers, [
                    updateStateModifier,
                    {
                        name: 'applyStyles',
                        enabled: false
                    }
                ])
            };
            if ((0, ($parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
            else {
                prevOptions.current = newOptions;
                return newOptions;
            }
        }, [
            optionsWithDefaults.onFirstUpdate,
            optionsWithDefaults.placement,
            optionsWithDefaults.strategy,
            optionsWithDefaults.modifiers,
            updateStateModifier
        ]);
        var popperInstanceRef = $5uXOq.useRef();
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
        }, [
            popperOptions
        ]);
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (referenceElement == null || popperElement == null) return;
            var createPopper = options.createPopper || (0, (0, parcelRequire("8Pv9O")).createPopper);
            var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
            popperInstanceRef.current = popperInstance;
            return function() {
                popperInstance.destroy();
                popperInstanceRef.current = null;
            };
        }, [
            referenceElement,
            popperElement,
            options.createPopper
        ]);
        return {
            state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
            styles: state.styles,
            attributes: state.attributes,
            update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
            forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
        };
    };
});
parcelRegister("8Pv9O", function(module, exports) {
    $parcel$export(module.exports, "createPopper", ()=>$66db415bc009fd50$export$8f7491d57c8f97a9);
    var $dsn8Y;
    var $4TVC8;
    var $j8nKB;
    var $baic6;
    var $1AoLg;
    var $gy4Xr;
    var $3dDWl;
    var $1DdSC;
    var $gzAfz;
    var $6iLAT;
    var $66db415bc009fd50$export$d34966752335dd47 = [
        (0, (0, parcelRequire("4TVC8")).default),
        (0, (0, parcelRequire("j8nKB")).default),
        (0, (0, parcelRequire("baic6")).default),
        (0, (0, parcelRequire("1AoLg")).default),
        (0, (0, parcelRequire("gy4Xr")).default),
        (0, (0, parcelRequire("3dDWl")).default),
        (0, (0, parcelRequire("1DdSC")).default),
        (0, (0, parcelRequire("gzAfz")).default),
        (0, (0, parcelRequire("6iLAT")).default)
    ];
    var $66db415bc009fd50$export$8f7491d57c8f97a9 = (0, (0, parcelRequire("dsn8Y")).popperGenerator)({
        defaultModifiers: $66db415bc009fd50$export$d34966752335dd47
    });
});
parcelRegister("dsn8Y", function(module, exports) {
    $parcel$export(module.exports, "popperGenerator", ()=>$9cbfd7bdb6a4f3f1$export$ed5e13716264f202);
    var $gvlia;
    var $jkGDj;
    var $2r6BH;
    var $gbHJy;
    var $kcmIg;
    var $a8clb;
    var $i9xH7;
    var $gmkfg;
    var $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS = {
        placement: 'bottom',
        modifiers: [],
        strategy: 'absolute'
    };
    function $9cbfd7bdb6a4f3f1$var$areValidElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return !args.some(function(element) {
            return !(element && typeof element.getBoundingClientRect === 'function');
        });
    }
    function $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(generatorOptions) {
        if (generatorOptions === void 0) generatorOptions = {};
        var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS : _generatorOptions$def2;
        return function createPopper(reference, popper, options) {
            if (options === void 0) options = defaultOptions;
            var state = {
                placement: 'bottom',
                orderedModifiers: [],
                options: Object.assign({}, $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS, defaultOptions),
                modifiersData: {},
                elements: {
                    reference: reference,
                    popper: popper
                },
                attributes: {},
                styles: {}
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
                state: state,
                setOptions: function setOptions(setOptionsAction) {
                    var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                    cleanupModifierEffects();
                    state.options = Object.assign({}, defaultOptions, state.options, options);
                    state.scrollParents = {
                        reference: (0, (0, parcelRequire("gmkfg")).isElement)(reference) ? (0, (0, parcelRequire("2r6BH")).default)(reference) : reference.contextElement ? (0, (0, parcelRequire("2r6BH")).default)(reference.contextElement) : [],
                        popper: (0, (0, parcelRequire("2r6BH")).default)(popper)
                    };
                    var orderedModifiers = (0, (0, parcelRequire("kcmIg")).default)((0, (0, parcelRequire("i9xH7")).default)([].concat(defaultModifiers, state.options.modifiers)));
                    state.orderedModifiers = orderedModifiers.filter(function(m) {
                        return m.enabled;
                    });
                    runModifierEffects();
                    return instance.update();
                },
                forceUpdate: function forceUpdate() {
                    if (isDestroyed) return;
                    var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
                    if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return;
                    state.rects = {
                        reference: (0, (0, parcelRequire("gvlia")).default)(reference, (0, (0, parcelRequire("gbHJy")).default)(popper), state.options.strategy === 'fixed'),
                        popper: (0, (0, parcelRequire("jkGDj")).default)(popper)
                    };
                    state.reset = false;
                    state.placement = state.options.placement;
                    state.orderedModifiers.forEach(function(modifier) {
                        return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                    });
                    for(var index = 0; index < state.orderedModifiers.length; index++){
                        if (state.reset === true) {
                            state.reset = false;
                            index = -1;
                            continue;
                        }
                        var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                        if (typeof fn === 'function') state = fn({
                            state: state,
                            options: _options,
                            name: name,
                            instance: instance
                        }) || state;
                    }
                },
                update: (0, (0, parcelRequire("a8clb")).default)(function() {
                    return new Promise(function(resolve) {
                        instance.forceUpdate();
                        resolve(state);
                    });
                }),
                destroy: function destroy() {
                    cleanupModifierEffects();
                    isDestroyed = true;
                }
            };
            if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return instance;
            instance.setOptions(options).then(function(state) {
                if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
            });
            function runModifierEffects() {
                state.orderedModifiers.forEach(function(_ref) {
                    var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                    if (typeof effect === 'function') {
                        var cleanupFn = effect({
                            state: state,
                            name: name,
                            instance: instance,
                            options: options
                        });
                        var noopFn = function noopFn() {};
                        effectCleanupFns.push(cleanupFn || noopFn);
                    }
                });
            }
            function cleanupModifierEffects() {
                effectCleanupFns.forEach(function(fn) {
                    return fn();
                });
                effectCleanupFns = [];
            }
            return instance;
        };
    }
    var $9cbfd7bdb6a4f3f1$export$8f7491d57c8f97a9 = $9cbfd7bdb6a4f3f1$export$ed5e13716264f202();
});
parcelRegister("gvlia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0400ebb908e52cb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $9FFjG;
    var $f5IBt;
    var $gmkfg;
    var $imzt5;
    var $eVELE;
    var $c6EdA;
    var $90xPK;
    function $c0400ebb908e52cb$var$isElementScaled(element) {
        var rect = element.getBoundingClientRect();
        var scaleX = (0, (0, parcelRequire("90xPK")).round)(rect.width) / element.offsetWidth || 1;
        var scaleY = (0, (0, parcelRequire("90xPK")).round)(rect.height) / element.offsetHeight || 1;
        return scaleX !== 1 || scaleY !== 1;
    }
    function $c0400ebb908e52cb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
        if (isFixed === void 0) isFixed = false;
        var isOffsetParentAnElement = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent);
        var offsetParentIsScaled = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent) && $c0400ebb908e52cb$var$isElementScaled(offsetParent);
        var documentElement = (0, (0, parcelRequire("eVELE")).default)(offsetParent);
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
        var scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        var offsets = {
            x: 0,
            y: 0
        };
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) !== 'body' || (0, (0, parcelRequire("c6EdA")).default)(documentElement)) scroll = (0, (0, parcelRequire("9FFjG")).default)(offsetParent);
            if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent)) {
                offsets = (0, (0, parcelRequire("g2O7Z")).default)(offsetParent, true);
                offsets.x += offsetParent.clientLeft;
                offsets.y += offsetParent.clientTop;
            } else if (documentElement) offsets.x = (0, (0, parcelRequire("imzt5")).default)(documentElement);
        }
        return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height
        };
    }
});
parcelRegister("g2O7Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bae3b796a534b2cf$export$2e2bcd8739ae039);
    var $gmkfg;
    var $90xPK;
    var $1Prpe;
    var $d8bsQ;
    function $bae3b796a534b2cf$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        var clientRect = element.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (includeScale && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            scaleX = element.offsetWidth > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.width) / element.offsetWidth || 1 : 1;
            scaleY = element.offsetHeight > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.height) / element.offsetHeight || 1 : 1;
        }
        var _ref = (0, (0, parcelRequire("gmkfg")).isElement)(element) ? (0, (0, parcelRequire("1Prpe")).default)(element) : window, visualViewport = _ref.visualViewport;
        var addVisualOffsets = !(0, (0, parcelRequire("d8bsQ")).default)() && isFixedStrategy;
        var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
        var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
        var width = clientRect.width / scaleX;
        var height = clientRect.height / scaleY;
        return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y
        };
    }
});
parcelRegister("gmkfg", function(module, exports) {
    $parcel$export(module.exports, "isElement", ()=>$be8e67adfa808002$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$be8e67adfa808002$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isShadowRoot", ()=>$be8e67adfa808002$export$af51f0f06c0f328a);
    var $1Prpe;
    function $be8e67adfa808002$export$45a5e7f76e0caa8d(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).Element;
        return node instanceof OwnElement || node instanceof Element;
    }
    function $be8e67adfa808002$export$1b3bfaa9684536aa(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).HTMLElement;
        return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function $be8e67adfa808002$export$af51f0f06c0f328a(node) {
        if (typeof ShadowRoot === 'undefined') return false;
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).ShadowRoot;
        return node instanceof OwnElement || node instanceof ShadowRoot;
    }
});
parcelRegister("1Prpe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$154fd01b154b825f$export$2e2bcd8739ae039);
    function $154fd01b154b825f$export$2e2bcd8739ae039(node) {
        if (node == null) return window;
        if (node.toString() !== '[object Window]') {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
        }
        return node;
    }
});
parcelRegister("90xPK", function(module, exports) {
    $parcel$export(module.exports, "max", ()=>$68ee5bce69e9df7e$export$8960430cfd85939f);
    $parcel$export(module.exports, "min", ()=>$68ee5bce69e9df7e$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "round", ()=>$68ee5bce69e9df7e$export$2077e0241d6afd3c);
    var $68ee5bce69e9df7e$export$8960430cfd85939f = Math.max;
    var $68ee5bce69e9df7e$export$96ec731ed4dcb222 = Math.min;
    var $68ee5bce69e9df7e$export$2077e0241d6afd3c = Math.round;
});
parcelRegister("d8bsQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98f4ea48bb7f7060$export$2e2bcd8739ae039);
    var $j5Xhq;
    function $98f4ea48bb7f7060$export$2e2bcd8739ae039() {
        return !/^((?!chrome|android).)*safari/i.test((0, (0, parcelRequire("j5Xhq")).default)());
    }
});
parcelRegister("j5Xhq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de6c77c242bcf4cf$export$2e2bcd8739ae039);
    function $de6c77c242bcf4cf$export$2e2bcd8739ae039() {
        var uaData = navigator.userAgentData;
        if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
            return item.brand + "/" + item.version;
        }).join(' ');
        return navigator.userAgent;
    }
});
parcelRegister("9FFjG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70a7fdf85bb2e8b8$export$2e2bcd8739ae039);
    var $8YTLN;
    var $1Prpe;
    var $gmkfg;
    var $i1ad3;
    function $70a7fdf85bb2e8b8$export$2e2bcd8739ae039(node) {
        if (node === (0, (0, parcelRequire("1Prpe")).default)(node) || !(0, (0, parcelRequire("gmkfg")).isHTMLElement)(node)) return (0, (0, parcelRequire("8YTLN")).default)(node);
        else return (0, (0, parcelRequire("i1ad3")).default)(node);
    }
});
parcelRegister("8YTLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$689f300ec0defb42$export$2e2bcd8739ae039);
    var $1Prpe;
    function $689f300ec0defb42$export$2e2bcd8739ae039(node) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(node);
        var scrollLeft = win.pageXOffset;
        var scrollTop = win.pageYOffset;
        return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        };
    }
});
parcelRegister("i1ad3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1e03d69dfb9832f$export$2e2bcd8739ae039);
    function $d1e03d69dfb9832f$export$2e2bcd8739ae039(element) {
        return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
    }
});
parcelRegister("f5IBt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afc9ebf0aa1487e4$export$2e2bcd8739ae039);
    function $afc9ebf0aa1487e4$export$2e2bcd8739ae039(element) {
        return element ? (element.nodeName || '').toLowerCase() : null;
    }
});
parcelRegister("imzt5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5e5cb506db8cdcb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $eVELE;
    var $8YTLN;
    function $d5e5cb506db8cdcb$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("g2O7Z")).default)((0, (0, parcelRequire("eVELE")).default)(element)).left + (0, (0, parcelRequire("8YTLN")).default)(element).scrollLeft;
    }
});
parcelRegister("eVELE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ade6032ba4b824fe$export$2e2bcd8739ae039);
    var $gmkfg;
    function $ade6032ba4b824fe$export$2e2bcd8739ae039(element) {
        return (((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
    }
});
parcelRegister("c6EdA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d053e13cecc73ee$export$2e2bcd8739ae039);
    var $1ix2F;
    function $8d053e13cecc73ee$export$2e2bcd8739ae039(element) {
        var _getComputedStyle = (0, (0, parcelRequire("1ix2F")).default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
});
parcelRegister("1ix2F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f211a5db2cb1d1b$export$2e2bcd8739ae039);
    var $1Prpe;
    function $0f211a5db2cb1d1b$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("1Prpe")).default)(element).getComputedStyle(element);
    }
});
parcelRegister("jkGDj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e130f49f6e9ebcb4$export$2e2bcd8739ae039);
    var $g2O7Z;
    function $e130f49f6e9ebcb4$export$2e2bcd8739ae039(element) {
        var clientRect = (0, (0, parcelRequire("g2O7Z")).default)(element);
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
        if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
        return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height
        };
    }
});
parcelRegister("2r6BH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c633a6ac170841a$export$2e2bcd8739ae039);
    var $k82dT;
    var $eTUzl;
    var $1Prpe;
    var $c6EdA;
    function $1c633a6ac170841a$export$2e2bcd8739ae039(element, list) {
        var _element$ownerDocumen;
        if (list === void 0) list = [];
        var scrollParent = (0, (0, parcelRequire("k82dT")).default)(element);
        var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
        var win = (0, (0, parcelRequire("1Prpe")).default)(scrollParent);
        var target = isBody ? [
            win
        ].concat(win.visualViewport || [], (0, (0, parcelRequire("c6EdA")).default)(scrollParent) ? scrollParent : []) : scrollParent;
        var updatedList = list.concat(target);
        return isBody ? updatedList : updatedList.concat($1c633a6ac170841a$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(target)));
    }
});
parcelRegister("k82dT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea7647704a508683$export$2e2bcd8739ae039);
    var $eTUzl;
    var $c6EdA;
    var $f5IBt;
    var $gmkfg;
    function $ea7647704a508683$export$2e2bcd8739ae039(node) {
        if ([
            'html',
            'body',
            '#document'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(node)) >= 0) return node.ownerDocument.body;
        if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(node) && (0, (0, parcelRequire("c6EdA")).default)(node)) return node;
        return $ea7647704a508683$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(node));
    }
});
parcelRegister("eTUzl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad921528f26834dd$export$2e2bcd8739ae039);
    var $f5IBt;
    var $eVELE;
    var $gmkfg;
    function $ad921528f26834dd$export$2e2bcd8739ae039(element) {
        if ((0, (0, parcelRequire("f5IBt")).default)(element) === 'html') return element;
        return (element.assignedSlot || element.parentNode || ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(element) ? element.host : null) || (0, (0, parcelRequire("eVELE")).default)(element));
    }
});
parcelRegister("gbHJy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc8f9908a1e4106f$export$2e2bcd8739ae039);
    var $1Prpe;
    var $f5IBt;
    var $1ix2F;
    var $gmkfg;
    var $6hs9X;
    var $eTUzl;
    var $j5Xhq;
    function $bc8f9908a1e4106f$var$getTrueOffsetParent(element) {
        if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || (0, (0, parcelRequire("1ix2F")).default)(element).position === 'fixed') return null;
        return element.offsetParent;
    }
    function $bc8f9908a1e4106f$var$getContainingBlock(element) {
        var isFirefox = /firefox/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        var isIE = /Trident/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        if (isIE && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            var elementCss = (0, (0, parcelRequire("1ix2F")).default)(element);
            if (elementCss.position === 'fixed') return null;
        }
        var currentNode = (0, (0, parcelRequire("eTUzl")).default)(element);
        if ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(currentNode)) currentNode = currentNode.host;
        while((0, (0, parcelRequire("gmkfg")).isHTMLElement)(currentNode) && [
            'html',
            'body'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(currentNode)) < 0){
            var css = (0, (0, parcelRequire("1ix2F")).default)(currentNode);
            if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
                'transform',
                'perspective'
            ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
            else currentNode = currentNode.parentNode;
        }
        return null;
    }
    function $bc8f9908a1e4106f$export$2e2bcd8739ae039(element) {
        var window = (0, (0, parcelRequire("1Prpe")).default)(element);
        var offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(element);
        while(offsetParent && (0, (0, parcelRequire("6hs9X")).default)(offsetParent) && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(offsetParent);
        if (offsetParent && ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'html' || (0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'body' && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')) return window;
        return offsetParent || $bc8f9908a1e4106f$var$getContainingBlock(element) || window;
    }
});
parcelRegister("6hs9X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$492a2c861940c94d$export$2e2bcd8739ae039);
    var $f5IBt;
    function $492a2c861940c94d$export$2e2bcd8739ae039(element) {
        return [
            'table',
            'td',
            'th'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(element)) >= 0;
    }
});
parcelRegister("kcmIg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb468bf0752088cc$export$2e2bcd8739ae039);
    var $kJPed;
    function $eb468bf0752088cc$var$order(modifiers) {
        var map = new Map();
        var visited = new Set();
        var result = [];
        modifiers.forEach(function(modifier) {
            map.set(modifier.name, modifier);
        });
        function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
            requires.forEach(function(dep) {
                if (!visited.has(dep)) {
                    var depModifier = map.get(dep);
                    if (depModifier) sort(depModifier);
                }
            });
            result.push(modifier);
        }
        modifiers.forEach(function(modifier) {
            if (!visited.has(modifier.name)) sort(modifier);
        });
        return result;
    }
    function $eb468bf0752088cc$export$2e2bcd8739ae039(modifiers) {
        var orderedModifiers = $eb468bf0752088cc$var$order(modifiers);
        return (0, (0, parcelRequire("kJPed")).modifierPhases).reduce(function(acc, phase) {
            return acc.concat(orderedModifiers.filter(function(modifier) {
                return modifier.phase === phase;
            }));
        }, []);
    }
});
parcelRegister("kJPed", function(module, exports) {
    $parcel$export(module.exports, "top", ()=>$f18fbf7b212a7c8e$export$1e95b668f3b82d);
    $parcel$export(module.exports, "bottom", ()=>$f18fbf7b212a7c8e$export$40e543e69a8b3fbb);
    $parcel$export(module.exports, "right", ()=>$f18fbf7b212a7c8e$export$79ffe56a765070d2);
    $parcel$export(module.exports, "left", ()=>$f18fbf7b212a7c8e$export$eabcd2c8791e7bf4);
    $parcel$export(module.exports, "auto", ()=>$f18fbf7b212a7c8e$export$dfb5619354ba860);
    $parcel$export(module.exports, "basePlacements", ()=>$f18fbf7b212a7c8e$export$aec2ce47c367b8c3);
    $parcel$export(module.exports, "start", ()=>$f18fbf7b212a7c8e$export$b3571188c770cc5a);
    $parcel$export(module.exports, "end", ()=>$f18fbf7b212a7c8e$export$bd5df0f255a350f8);
    $parcel$export(module.exports, "clippingParents", ()=>$f18fbf7b212a7c8e$export$390fd549c5303b4d);
    $parcel$export(module.exports, "viewport", ()=>$f18fbf7b212a7c8e$export$d7b7311ec04a3e8f);
    $parcel$export(module.exports, "popper", ()=>$f18fbf7b212a7c8e$export$ae5ab1c730825774);
    $parcel$export(module.exports, "reference", ()=>$f18fbf7b212a7c8e$export$ca50aac9f3ba507f);
    $parcel$export(module.exports, "variationPlacements", ()=>$f18fbf7b212a7c8e$export$368f9a87e87fa4e1);
    $parcel$export(module.exports, "placements", ()=>$f18fbf7b212a7c8e$export$803cd8101b6c182b);
    $parcel$export(module.exports, "modifierPhases", ()=>$f18fbf7b212a7c8e$export$d087d3878fdf71d5);
    var $f18fbf7b212a7c8e$export$1e95b668f3b82d = 'top';
    var $f18fbf7b212a7c8e$export$40e543e69a8b3fbb = 'bottom';
    var $f18fbf7b212a7c8e$export$79ffe56a765070d2 = 'right';
    var $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4 = 'left';
    var $f18fbf7b212a7c8e$export$dfb5619354ba860 = 'auto';
    var $f18fbf7b212a7c8e$export$aec2ce47c367b8c3 = [
        $f18fbf7b212a7c8e$export$1e95b668f3b82d,
        $f18fbf7b212a7c8e$export$40e543e69a8b3fbb,
        $f18fbf7b212a7c8e$export$79ffe56a765070d2,
        $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4
    ];
    var $f18fbf7b212a7c8e$export$b3571188c770cc5a = 'start';
    var $f18fbf7b212a7c8e$export$bd5df0f255a350f8 = 'end';
    var $f18fbf7b212a7c8e$export$390fd549c5303b4d = 'clippingParents';
    var $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f = 'viewport';
    var $f18fbf7b212a7c8e$export$ae5ab1c730825774 = 'popper';
    var $f18fbf7b212a7c8e$export$ca50aac9f3ba507f = 'reference';
    var $f18fbf7b212a7c8e$export$368f9a87e87fa4e1 = $f18fbf7b212a7c8e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
        return acc.concat([
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$803cd8101b6c182b = [].concat($f18fbf7b212a7c8e$export$aec2ce47c367b8c3, [
        $f18fbf7b212a7c8e$export$dfb5619354ba860
    ]).reduce(function(acc, placement) {
        return acc.concat([
            placement,
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$421679a7c3d56e = 'beforeRead';
    var $f18fbf7b212a7c8e$export$aafa59e2e03f2942 = 'read';
    var $f18fbf7b212a7c8e$export$6964f6c886723980 = 'afterRead';
    var $f18fbf7b212a7c8e$export$c65e99957a05207c = 'beforeMain';
    var $f18fbf7b212a7c8e$export$f22da7240b7add18 = 'main';
    var $f18fbf7b212a7c8e$export$bab79516f2d662fe = 'afterMain';
    var $f18fbf7b212a7c8e$export$8d4d2d70e7d46032 = 'beforeWrite';
    var $f18fbf7b212a7c8e$export$68d8715fc104d294 = 'write';
    var $f18fbf7b212a7c8e$export$70a6e5159acce2e6 = 'afterWrite';
    var $f18fbf7b212a7c8e$export$d087d3878fdf71d5 = [
        $f18fbf7b212a7c8e$export$421679a7c3d56e,
        $f18fbf7b212a7c8e$export$aafa59e2e03f2942,
        $f18fbf7b212a7c8e$export$6964f6c886723980,
        $f18fbf7b212a7c8e$export$c65e99957a05207c,
        $f18fbf7b212a7c8e$export$f22da7240b7add18,
        $f18fbf7b212a7c8e$export$bab79516f2d662fe,
        $f18fbf7b212a7c8e$export$8d4d2d70e7d46032,
        $f18fbf7b212a7c8e$export$68d8715fc104d294,
        $f18fbf7b212a7c8e$export$70a6e5159acce2e6
    ];
});
parcelRegister("a8clb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7604395822cc5d61$export$2e2bcd8739ae039);
    function $7604395822cc5d61$export$2e2bcd8739ae039(fn) {
        var pending;
        return function() {
            if (!pending) pending = new Promise(function(resolve) {
                Promise.resolve().then(function() {
                    pending = undefined;
                    resolve(fn());
                });
            });
            return pending;
        };
    }
});
parcelRegister("i9xH7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3733441fcf2e882$export$2e2bcd8739ae039);
    function $d3733441fcf2e882$export$2e2bcd8739ae039(modifiers) {
        var merged = modifiers.reduce(function(merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing ? Object.assign({}, existing, current, {
                options: Object.assign({}, existing.options, current.options),
                data: Object.assign({}, existing.data, current.data)
            }) : current;
            return merged;
        }, {});
        return Object.keys(merged).map(function(key) {
            return merged[key];
        });
    }
});
parcelRegister("4TVC8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3918fd6b815bcf57$export$2e2bcd8739ae039);
    var $1Prpe;
    var $3918fd6b815bcf57$var$passive = {
        passive: true
    };
    function $3918fd6b815bcf57$var$effect(_ref) {
        var state = _ref.state, instance = _ref.instance, options = _ref.options;
        var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
        var window = (0, (0, parcelRequire("1Prpe")).default)(state.elements.popper);
        var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.addEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
        });
        if (resize) window.addEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        return function() {
            if (scroll) scrollParents.forEach(function(scrollParent) {
                scrollParent.removeEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
            });
            if (resize) window.removeEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        };
    }
    var $3918fd6b815bcf57$export$2e2bcd8739ae039 = {
        name: 'eventListeners',
        enabled: true,
        phase: 'write',
        fn: function fn() {},
        effect: $3918fd6b815bcf57$var$effect,
        data: {}
    };
});
parcelRegister("j8nKB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dee1300a39219bb5$export$2e2bcd8739ae039);
    var $dJ0Jl;
    function $dee1300a39219bb5$var$popperOffsets(_ref) {
        var state = _ref.state, name = _ref.name;
        state.modifiersData[name] = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: state.rects.reference,
            element: state.rects.popper,
            strategy: 'absolute',
            placement: state.placement
        });
    }
    var $dee1300a39219bb5$export$2e2bcd8739ae039 = {
        name: 'popperOffsets',
        enabled: true,
        phase: 'read',
        fn: $dee1300a39219bb5$var$popperOffsets,
        data: {}
    };
});
parcelRegister("dJ0Jl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fe00b5c334118ac$export$2e2bcd8739ae039);
    var $QXpw1;
    var $cGRJ4;
    var $9GF9F;
    var $kJPed;
    function $9fe00b5c334118ac$export$2e2bcd8739ae039(_ref) {
        var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
        var basePlacement = placement ? (0, (0, parcelRequire("QXpw1")).default)(placement) : null;
        var variation = placement ? (0, (0, parcelRequire("cGRJ4")).default)(placement) : null;
        var commonX = reference.x + reference.width / 2 - element.width / 2;
        var commonY = reference.y + reference.height / 2 - element.height / 2;
        var offsets;
        switch(basePlacement){
            case 0, (0, parcelRequire("kJPed")).top:
                offsets = {
                    x: commonX,
                    y: reference.y - element.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).bottom:
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).right:
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 0, (0, parcelRequire("kJPed")).left:
                offsets = {
                    x: reference.x - element.width,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        var mainAxis = basePlacement ? (0, (0, parcelRequire("9GF9F")).default)(basePlacement) : null;
        if (mainAxis != null) {
            var len = mainAxis === 'y' ? 'height' : 'width';
            switch(variation){
                case 0, (0, parcelRequire("kJPed")).start:
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                    break;
                case 0, (0, parcelRequire("kJPed")).end:
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                    break;
                default:
            }
        }
        return offsets;
    }
});
parcelRegister("QXpw1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09f2f123ac4a9fdf$export$2e2bcd8739ae039);
    function $09f2f123ac4a9fdf$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[0];
    }
});
parcelRegister("cGRJ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93d315208040ceed$export$2e2bcd8739ae039);
    function $93d315208040ceed$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[1];
    }
});
parcelRegister("9GF9F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70d7f5cda4210aa3$export$2e2bcd8739ae039);
    function $70d7f5cda4210aa3$export$2e2bcd8739ae039(placement) {
        return [
            'top',
            'bottom'
        ].indexOf(placement) >= 0 ? 'x' : 'y';
    }
});
parcelRegister("baic6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$820ebddbe0682e4f$export$2e2bcd8739ae039);
    var $kJPed;
    var $gbHJy;
    var $1Prpe;
    var $eVELE;
    var $1ix2F;
    var $QXpw1;
    var $cGRJ4;
    var $90xPK;
    var $820ebddbe0682e4f$var$unsetSides = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
    };
    function $820ebddbe0682e4f$var$roundOffsetsByDPR(_ref, win) {
        var x = _ref.x, y = _ref.y;
        var dpr = win.devicePixelRatio || 1;
        return {
            x: (0, (0, parcelRequire("90xPK")).round)(x * dpr) / dpr || 0,
            y: (0, (0, parcelRequire("90xPK")).round)(y * dpr) / dpr || 0
        };
    }
    function $820ebddbe0682e4f$export$378fa78a8fea596f(_ref2) {
        var _Object$assign2;
        var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
        var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
        var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
            x: x,
            y: y
        }) : {
            x: x,
            y: y
        };
        x = _ref3.x;
        y = _ref3.y;
        var hasX = offsets.hasOwnProperty('x');
        var hasY = offsets.hasOwnProperty('y');
        var sideX = (0, (0, parcelRequire("kJPed")).left);
        var sideY = (0, (0, parcelRequire("kJPed")).top);
        var win = window;
        if (adaptive) {
            var offsetParent = (0, (0, parcelRequire("gbHJy")).default)(popper);
            var heightProp = 'clientHeight';
            var widthProp = 'clientWidth';
            if (offsetParent === (0, (0, parcelRequire("1Prpe")).default)(popper)) {
                offsetParent = (0, (0, parcelRequire("eVELE")).default)(popper);
                if ((0, (0, parcelRequire("1ix2F")).default)(offsetParent).position !== 'static' && position === 'absolute') {
                    heightProp = 'scrollHeight';
                    widthProp = 'scrollWidth';
                }
            }
            offsetParent;
            if (placement === (0, (0, parcelRequire("kJPed")).top) || (placement === (0, (0, parcelRequire("kJPed")).left) || placement === (0, (0, parcelRequire("kJPed")).right)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideY = (0, (0, parcelRequire("kJPed")).bottom);
                var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
                y -= offsetY - popperRect.height;
                y *= gpuAcceleration ? 1 : -1;
            }
            if (placement === (0, (0, parcelRequire("kJPed")).left) || (placement === (0, (0, parcelRequire("kJPed")).top) || placement === (0, (0, parcelRequire("kJPed")).bottom)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideX = (0, (0, parcelRequire("kJPed")).right);
                var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
                x -= offsetX - popperRect.width;
                x *= gpuAcceleration ? 1 : -1;
            }
        }
        var commonStyles = Object.assign({
            position: position
        }, adaptive && $820ebddbe0682e4f$var$unsetSides);
        var _ref4 = roundOffsets === true ? $820ebddbe0682e4f$var$roundOffsetsByDPR({
            x: x,
            y: y
        }, (0, (0, parcelRequire("1Prpe")).default)(popper)) : {
            x: x,
            y: y
        };
        x = _ref4.x;
        y = _ref4.y;
        if (gpuAcceleration) {
            var _Object$assign;
            return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
        }
        return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function $820ebddbe0682e4f$var$computeStyles(_ref5) {
        var state = _ref5.state, options = _ref5.options;
        var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
        var commonStyles = {
            placement: (0, (0, parcelRequire("QXpw1")).default)(state.placement),
            variation: (0, (0, parcelRequire("cGRJ4")).default)(state.placement),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === 'fixed'
        };
        if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.popperOffsets,
            position: state.options.strategy,
            adaptive: adaptive,
            roundOffsets: roundOffsets
        })));
        if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.arrow,
            position: 'absolute',
            adaptive: false,
            roundOffsets: roundOffsets
        })));
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-placement': state.placement
        });
    }
    var $820ebddbe0682e4f$export$2e2bcd8739ae039 = {
        name: 'computeStyles',
        enabled: true,
        phase: 'beforeWrite',
        fn: $820ebddbe0682e4f$var$computeStyles,
        data: {}
    };
});
parcelRegister("1AoLg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$127c5c56b9511f5f$export$2e2bcd8739ae039);
    var $f5IBt;
    var $gmkfg;
    function $127c5c56b9511f5f$var$applyStyles(_ref) {
        var state = _ref.state;
        Object.keys(state.elements).forEach(function(name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name];
            if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(name) {
                var value = attributes[name];
                if (value === false) element.removeAttribute(name);
                else element.setAttribute(name, value === true ? '' : value);
            });
        });
    }
    function $127c5c56b9511f5f$var$effect(_ref2) {
        var state = _ref2.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
        return function() {
            Object.keys(state.elements).forEach(function(name) {
                var element = state.elements[name];
                var attributes = state.attributes[name] || {};
                var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
                var style = styleProperties.reduce(function(style, property) {
                    style[property] = '';
                    return style;
                }, {});
                if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
                Object.assign(element.style, style);
                Object.keys(attributes).forEach(function(attribute) {
                    element.removeAttribute(attribute);
                });
            });
        };
    }
    var $127c5c56b9511f5f$export$2e2bcd8739ae039 = {
        name: 'applyStyles',
        enabled: true,
        phase: 'write',
        fn: $127c5c56b9511f5f$var$applyStyles,
        effect: $127c5c56b9511f5f$var$effect,
        requires: [
            'computeStyles'
        ]
    };
});
parcelRegister("gy4Xr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0c3aad300d72ee1$export$2e2bcd8739ae039);
    var $QXpw1;
    var $kJPed;
    function $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, rects, offset) {
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
        var invertDistance = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).top)
        ].indexOf(basePlacement) >= 0 ? -1 : 1;
        var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
            placement: placement
        })) : offset, skidding = _ref[0], distance = _ref[1];
        skidding = skidding || 0;
        distance = (distance || 0) * invertDistance;
        return [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0 ? {
            x: distance,
            y: skidding
        } : {
            x: skidding,
            y: distance
        };
    }
    function $c0c3aad300d72ee1$var$offset(_ref2) {
        var state = _ref2.state, options = _ref2.options, name = _ref2.name;
        var _options$offset = options.offset, offset = _options$offset === void 0 ? [
            0,
            0
        ] : _options$offset;
        var data = (0, (0, parcelRequire("kJPed")).placements).reduce(function(acc, placement) {
            acc[placement] = $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, state.rects, offset);
            return acc;
        }, {});
        var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
        if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
        }
        state.modifiersData[name] = data;
    }
    var $c0c3aad300d72ee1$export$2e2bcd8739ae039 = {
        name: 'offset',
        enabled: true,
        phase: 'main',
        requires: [
            'popperOffsets'
        ],
        fn: $c0c3aad300d72ee1$var$offset
    };
});
parcelRegister("3dDWl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$258191447a7022df$export$2e2bcd8739ae039);
    var $jwSgb;
    var $QXpw1;
    var $4tIVJ;
    var $kgkit;
    var $cqF2x;
    var $kJPed;
    var $cGRJ4;
    function $258191447a7022df$var$getExpandedFallbackPlacements(placement) {
        if ((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto)) return [];
        var oppositePlacement = (0, (0, parcelRequire("jwSgb")).default)(placement);
        return [
            (0, (0, parcelRequire("4tIVJ")).default)(placement),
            oppositePlacement,
            (0, (0, parcelRequire("4tIVJ")).default)(oppositePlacement)
        ];
    }
    function $258191447a7022df$var$flip(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        if (state.modifiersData[name]._skip) return;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
        var preferredPlacement = state.options.placement;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(preferredPlacement);
        var isBasePlacement = basePlacement === preferredPlacement;
        var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            (0, (0, parcelRequire("jwSgb")).default)(preferredPlacement)
        ] : $258191447a7022df$var$getExpandedFallbackPlacements(preferredPlacement));
        var placements = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement) {
            return acc.concat((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto) ? (0, (0, parcelRequire("cqF2x")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements
            }) : placement);
        }, []);
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var checksMap = new Map();
        var makeFallbackChecks = true;
        var firstFittingPlacement = placements[0];
        for(var i = 0; i < placements.length; i++){
            var placement = placements[i];
            var _basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
            var isStartVariation = (0, (0, parcelRequire("cGRJ4")).default)(placement) === (0, (0, parcelRequire("kJPed")).start);
            var isVertical = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).bottom)
            ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? 'width' : 'height';
            var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding
            });
            var mainVariationSide = isVertical ? isStartVariation ? (0, (0, parcelRequire("kJPed")).right) : (0, (0, parcelRequire("kJPed")).left) : isStartVariation ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).top);
            if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var altVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var checks = [];
            if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
            if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
            if (checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement;
                makeFallbackChecks = false;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) {
            var numberOfChecks = flipVariations ? 3 : 1;
            var _loop = function _loop(_i) {
                var fittingPlacement = placements.find(function(placement) {
                    var checks = checksMap.get(placement);
                    if (checks) return checks.slice(0, _i).every(function(check) {
                        return check;
                    });
                });
                if (fittingPlacement) {
                    firstFittingPlacement = fittingPlacement;
                    return "break";
                }
            };
            for(var _i = numberOfChecks; _i > 0; _i--){
                var _ret = _loop(_i);
                if (_ret === "break") break;
            }
        }
        if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
        }
    }
    var $258191447a7022df$export$2e2bcd8739ae039 = {
        name: 'flip',
        enabled: true,
        phase: 'main',
        fn: $258191447a7022df$var$flip,
        requiresIfExists: [
            'offset'
        ],
        data: {
            _skip: false
        }
    };
});
parcelRegister("jwSgb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e37b1862c86f39c4$export$2e2bcd8739ae039);
    var $e37b1862c86f39c4$var$hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    function $e37b1862c86f39c4$export$2e2bcd8739ae039(placement) {
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return $e37b1862c86f39c4$var$hash[matched];
        });
    }
});
parcelRegister("4tIVJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$342cb90cb2622617$export$2e2bcd8739ae039);
    var $342cb90cb2622617$var$hash = {
        start: 'end',
        end: 'start'
    };
    function $342cb90cb2622617$export$2e2bcd8739ae039(placement) {
        return placement.replace(/start|end/g, function(matched) {
            return $342cb90cb2622617$var$hash[matched];
        });
    }
});
parcelRegister("kgkit", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec050bcf5e349283$export$2e2bcd8739ae039);
    var $dknpr;
    var $eVELE;
    var $g2O7Z;
    var $dJ0Jl;
    var $h8W1z;
    var $kJPed;
    var $gmkfg;
    var $gIXWB;
    var $50KfK;
    function $ec050bcf5e349283$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, (0, parcelRequire("kJPed")).clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, (0, parcelRequire("kJPed")).viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, (0, parcelRequire("kJPed")).popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
        var paddingObject = (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
        var altContext = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? (0, (0, parcelRequire("kJPed")).reference) : (0, (0, parcelRequire("kJPed")).popper);
        var popperRect = state.rects.popper;
        var element = state.elements[altBoundary ? altContext : elementContext];
        var clippingClientRect = (0, (0, parcelRequire("dknpr")).default)((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element : element.contextElement || (0, (0, parcelRequire("eVELE")).default)(state.elements.popper), boundary, rootBoundary, strategy);
        var referenceClientRect = (0, (0, parcelRequire("g2O7Z")).default)(state.elements.reference);
        var popperOffsets = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: referenceClientRect,
            element: popperRect,
            strategy: 'absolute',
            placement: placement
        });
        var popperClientRect = (0, (0, parcelRequire("h8W1z")).default)(Object.assign({}, popperRect, popperOffsets));
        var elementClientRect = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? popperClientRect : referenceClientRect;
        var overflowOffsets = {
            top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
            bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
            left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
            right: elementClientRect.right - clippingClientRect.right + paddingObject.right
        };
        var offsetData = state.modifiersData.offset;
        if (elementContext === (0, (0, parcelRequire("kJPed")).popper) && offsetData) {
            var offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function(key) {
                var multiply = [
                    (0, (0, parcelRequire("kJPed")).right),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 1 : -1;
                var axis = [
                    (0, (0, parcelRequire("kJPed")).top),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 'y' : 'x';
                overflowOffsets[key] += offset[axis] * multiply;
            });
        }
        return overflowOffsets;
    }
});
parcelRegister("dknpr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b3f4d3932acb3b2$export$2e2bcd8739ae039);
    var $kJPed;
    var $3V2hG;
    var $9NXD7;
    var $2r6BH;
    var $gbHJy;
    var $eVELE;
    var $1ix2F;
    var $gmkfg;
    var $g2O7Z;
    var $eTUzl;
    var $j6yPg;
    var $f5IBt;
    var $h8W1z;
    var $90xPK;
    function $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(element, strategy) {
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(element, false, strategy === 'fixed');
        rect.top = rect.top + element.clientTop;
        rect.left = rect.left + element.clientLeft;
        rect.bottom = rect.top + element.clientHeight;
        rect.right = rect.left + element.clientWidth;
        rect.width = element.clientWidth;
        rect.height = element.clientHeight;
        rect.x = rect.left;
        rect.y = rect.top;
        return rect;
    }
    function $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
        return clippingParent === (0, (0, parcelRequire("kJPed")).viewport) ? (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("3V2hG")).default)(element, strategy)) : (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) ? $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("9NXD7")).default)((0, (0, parcelRequire("eVELE")).default)(element)));
    }
    function $9b3f4d3932acb3b2$var$getClippingParents(element) {
        var clippingParents = (0, (0, parcelRequire("2r6BH")).default)((0, (0, parcelRequire("eTUzl")).default)(element));
        var canEscapeClipping = [
            'absolute',
            'fixed'
        ].indexOf((0, (0, parcelRequire("1ix2F")).default)(element).position) >= 0;
        var clipperElement = canEscapeClipping && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) ? (0, (0, parcelRequire("gbHJy")).default)(element) : element;
        if (!(0, (0, parcelRequire("gmkfg")).isElement)(clipperElement)) return [];
        return clippingParents.filter(function(clippingParent) {
            return (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) && (0, (0, parcelRequire("j6yPg")).default)(clippingParent, clipperElement) && (0, (0, parcelRequire("f5IBt")).default)(clippingParent) !== 'body';
        });
    }
    function $9b3f4d3932acb3b2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
        var mainClippingParents = boundary === 'clippingParents' ? $9b3f4d3932acb3b2$var$getClippingParents(element) : [].concat(boundary);
        var clippingParents = [].concat(mainClippingParents, [
            rootBoundary
        ]);
        var firstClippingParent = clippingParents[0];
        var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
            var rect = $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy);
            accRect.top = (0, (0, parcelRequire("90xPK")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("90xPK")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("90xPK")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("90xPK")).max)(rect.left, accRect.left);
            return accRect;
        }, $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
        clippingRect.width = clippingRect.right - clippingRect.left;
        clippingRect.height = clippingRect.bottom - clippingRect.top;
        clippingRect.x = clippingRect.left;
        clippingRect.y = clippingRect.top;
        return clippingRect;
    }
});
parcelRegister("3V2hG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2da877912142c34b$export$2e2bcd8739ae039);
    var $1Prpe;
    var $eVELE;
    var $imzt5;
    var $d8bsQ;
    function $2da877912142c34b$export$2e2bcd8739ae039(element, strategy) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(element);
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var visualViewport = win.visualViewport;
        var width = html.clientWidth;
        var height = html.clientHeight;
        var x = 0;
        var y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = (0, (0, parcelRequire("d8bsQ")).default)();
            if (layoutViewport || !layoutViewport && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x + (0, (0, parcelRequire("imzt5")).default)(element),
            y: y
        };
    }
});
parcelRegister("9NXD7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7236f1f1532b7fe8$export$2e2bcd8739ae039);
    var $eVELE;
    var $1ix2F;
    var $imzt5;
    var $8YTLN;
    var $90xPK;
    function $7236f1f1532b7fe8$export$2e2bcd8739ae039(element) {
        var _element$ownerDocumen;
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var winScroll = (0, (0, parcelRequire("8YTLN")).default)(element);
        var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
        var width = (0, (0, parcelRequire("90xPK")).max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
        var height = (0, (0, parcelRequire("90xPK")).max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
        var x = -winScroll.scrollLeft + (0, (0, parcelRequire("imzt5")).default)(element);
        var y = -winScroll.scrollTop;
        if ((0, (0, parcelRequire("1ix2F")).default)(body || html).direction === 'rtl') x += (0, (0, parcelRequire("90xPK")).max)(html.clientWidth, body ? body.clientWidth : 0) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
});
parcelRegister("j6yPg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de89978be23479c4$export$2e2bcd8739ae039);
    var $gmkfg;
    function $de89978be23479c4$export$2e2bcd8739ae039(parent, child) {
        var rootNode = child.getRootNode && child.getRootNode();
        if (parent.contains(child)) return true;
        else if (rootNode && (0, (0, parcelRequire("gmkfg")).isShadowRoot)(rootNode)) {
            var next = child;
            do {
                if (next && parent.isSameNode(next)) return true;
                next = next.parentNode || next.host;
            }while (next)
        }
        return false;
    }
});
parcelRegister("h8W1z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7b0316bb2f8fd97$export$2e2bcd8739ae039);
    function $c7b0316bb2f8fd97$export$2e2bcd8739ae039(rect) {
        return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height
        });
    }
});
parcelRegister("gIXWB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2cf410c4fe133f4$export$2e2bcd8739ae039);
    var $1ANH0;
    function $c2cf410c4fe133f4$export$2e2bcd8739ae039(paddingObject) {
        return Object.assign({}, (0, (0, parcelRequire("1ANH0")).default)(), paddingObject);
    }
});
parcelRegister("1ANH0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$128fb32b18b92ffa$export$2e2bcd8739ae039);
    function $128fb32b18b92ffa$export$2e2bcd8739ae039() {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
    }
});
parcelRegister("50KfK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a60d4b4ac4f93e5$export$2e2bcd8739ae039);
    function $3a60d4b4ac4f93e5$export$2e2bcd8739ae039(value, keys) {
        return keys.reduce(function(hashMap, key) {
            hashMap[key] = value;
            return hashMap;
        }, {});
    }
});
parcelRegister("cqF2x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90c7bf65fbdbec33$export$2e2bcd8739ae039);
    var $cGRJ4;
    var $kJPed;
    var $kgkit;
    var $QXpw1;
    function $90c7bf65fbdbec33$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, (0, parcelRequire("kJPed")).placements) : _options$allowedAutoP;
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(placement);
        var placements = variation ? flipVariations ? (0, (0, parcelRequire("kJPed")).variationPlacements) : (0, (0, parcelRequire("kJPed")).variationPlacements).filter(function(placement) {
            return (0, (0, parcelRequire("cGRJ4")).default)(placement) === variation;
        }) : (0, (0, parcelRequire("kJPed")).basePlacements);
        var allowedPlacements = placements.filter(function(placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
        });
        if (allowedPlacements.length === 0) allowedPlacements = placements;
        var overflows = allowedPlacements.reduce(function(acc, placement) {
            acc[placement] = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding
            })[(0, (0, parcelRequire("QXpw1")).default)(placement)];
            return acc;
        }, {});
        return Object.keys(overflows).sort(function(a, b) {
            return overflows[a] - overflows[b];
        });
    }
});
parcelRegister("1DdSC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13043339457d5bc5$export$2e2bcd8739ae039);
    var $kJPed;
    var $QXpw1;
    var $9GF9F;
    var $dNtrn;
    var $4WpIh;
    var $jkGDj;
    var $gbHJy;
    var $kgkit;
    var $cGRJ4;
    var $1ANH0;
    var $90xPK;
    function $13043339457d5bc5$var$preventOverflow(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
        var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            altBoundary: altBoundary
        });
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(state.placement);
        var isBasePlacement = !variation;
        var mainAxis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var altAxis = (0, (0, parcelRequire("dNtrn")).default)(mainAxis);
        var popperOffsets = state.modifiersData.popperOffsets;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
            placement: state.placement
        })) : tetherOffset;
        var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue
        } : Object.assign({
            mainAxis: 0,
            altAxis: 0
        }, tetherOffsetValue);
        var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
        var data = {
            x: 0,
            y: 0
        };
        if (!popperOffsets) return;
        if (checkMainAxis) {
            var _offsetModifierState$;
            var mainSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var altSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var len = mainAxis === 'y' ? 'height' : 'width';
            var offset = popperOffsets[mainAxis];
            var min = offset + overflow[mainSide];
            var max = offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen = variation === (0, (0, parcelRequire("kJPed")).start) ? referenceRect[len] : popperRect[len];
            var maxLen = variation === (0, (0, parcelRequire("kJPed")).start) ? -popperRect[len] : -referenceRect[len];
            var arrowElement = state.elements.arrow;
            var arrowRect = tether && arrowElement ? (0, (0, parcelRequire("jkGDj")).default)(arrowElement) : {
                width: 0,
                height: 0
            };
            var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, (0, parcelRequire("1ANH0")).default)();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide];
            var arrowLen = (0, (0, parcelRequire("4WpIh")).within)(0, referenceRect[len], arrowRect[len]);
            var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent = state.elements.arrow && (0, (0, parcelRequire("gbHJy")).default)(state.elements.arrow);
            var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
            var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
            var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = offset + maxOffset - offsetModifierValue;
            var preventedOffset = (0, (0, parcelRequire("4WpIh")).within)(tether ? (0, (0, parcelRequire("90xPK")).min)(min, tetherMin) : min, offset, tether ? (0, (0, parcelRequire("90xPK")).max)(max, tetherMax) : max);
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2;
            var _mainSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var _altSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var _offset = popperOffsets[altAxis];
            var _len = altAxis === 'y' ? 'height' : 'width';
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var isOriginSide = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).left)
            ].indexOf(basePlacement) !== -1;
            var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
            var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
            var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
            var _preventedOffset = tether && isOriginSide ? (0, (0, parcelRequire("4WpIh")).withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, (0, parcelRequire("4WpIh")).within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    }
    var $13043339457d5bc5$export$2e2bcd8739ae039 = {
        name: 'preventOverflow',
        enabled: true,
        phase: 'main',
        fn: $13043339457d5bc5$var$preventOverflow,
        requiresIfExists: [
            'offset'
        ]
    };
});
parcelRegister("dNtrn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0b6b03fadcbdfd7$export$2e2bcd8739ae039);
    function $a0b6b03fadcbdfd7$export$2e2bcd8739ae039(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
});
parcelRegister("4WpIh", function(module, exports) {
    $parcel$export(module.exports, "within", ()=>$3990864f59117d05$export$f28d906d67a997f3);
    $parcel$export(module.exports, "withinMaxClamp", ()=>$3990864f59117d05$export$86c8af6d3ef0b4a);
    var $90xPK;
    function $3990864f59117d05$export$f28d906d67a997f3(min, value, max) {
        return (0, (0, parcelRequire("90xPK")).max)(min, (0, (0, parcelRequire("90xPK")).min)(value, max));
    }
    function $3990864f59117d05$export$86c8af6d3ef0b4a(min, value, max) {
        var v = $3990864f59117d05$export$f28d906d67a997f3(min, value, max);
        return v > max ? max : v;
    }
});
parcelRegister("gzAfz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c10c08bd5e0ed9fb$export$2e2bcd8739ae039);
    var $QXpw1;
    var $jkGDj;
    var $j6yPg;
    var $gbHJy;
    var $9GF9F;
    var $4WpIh;
    var $gIXWB;
    var $50KfK;
    var $kJPed;
    var $c10c08bd5e0ed9fb$var$toPaddingObject = function toPaddingObject(padding, state) {
        padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
            placement: state.placement
        })) : padding;
        return (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
    };
    function $c10c08bd5e0ed9fb$var$arrow(_ref) {
        var _state$modifiersData$;
        var state = _ref.state, name = _ref.name, options = _ref.options;
        var arrowElement = state.elements.arrow;
        var popperOffsets = state.modifiersData.popperOffsets;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var axis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var isVertical = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0;
        var len = isVertical ? 'height' : 'width';
        if (!arrowElement || !popperOffsets) return;
        var paddingObject = $c10c08bd5e0ed9fb$var$toPaddingObject(options.padding, state);
        var arrowRect = (0, (0, parcelRequire("jkGDj")).default)(arrowElement);
        var minProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
        var maxProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
        var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
        var startDiff = popperOffsets[axis] - state.rects.reference[axis];
        var arrowOffsetParent = (0, (0, parcelRequire("gbHJy")).default)(arrowElement);
        var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
        var centerToReference = endDiff / 2 - startDiff / 2;
        var min = paddingObject[minProp];
        var max = clientSize - arrowRect[len] - paddingObject[maxProp];
        var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
        var offset = (0, (0, parcelRequire("4WpIh")).within)(min, center, max);
        var axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function $c10c08bd5e0ed9fb$var$effect(_ref2) {
        var state = _ref2.state, options = _ref2.options;
        var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
        if (arrowElement == null) return;
        if (typeof arrowElement === 'string') {
            arrowElement = state.elements.popper.querySelector(arrowElement);
            if (!arrowElement) return;
        }
        if (!(0, (0, parcelRequire("j6yPg")).default)(state.elements.popper, arrowElement)) return;
        state.elements.arrow = arrowElement;
    }
    var $c10c08bd5e0ed9fb$export$2e2bcd8739ae039 = {
        name: 'arrow',
        enabled: true,
        phase: 'main',
        fn: $c10c08bd5e0ed9fb$var$arrow,
        effect: $c10c08bd5e0ed9fb$var$effect,
        requires: [
            'popperOffsets'
        ],
        requiresIfExists: [
            'preventOverflow'
        ]
    };
});
parcelRegister("6iLAT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$496957b0c691a0ed$export$2e2bcd8739ae039);
    var $kJPed;
    var $kgkit;
    function $496957b0c691a0ed$var$getSideOffsets(overflow, rect, preventedOffsets) {
        if (preventedOffsets === void 0) preventedOffsets = {
            x: 0,
            y: 0
        };
        return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x
        };
    }
    function $496957b0c691a0ed$var$isAnySideFullyClipped(overflow) {
        return [
            (0, (0, parcelRequire("kJPed")).top),
            (0, (0, parcelRequire("kJPed")).right),
            (0, (0, parcelRequire("kJPed")).bottom),
            (0, (0, parcelRequire("kJPed")).left)
        ].some(function(side) {
            return overflow[side] >= 0;
        });
    }
    function $496957b0c691a0ed$var$hide(_ref) {
        var state = _ref.state, name = _ref.name;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var preventedOffsets = state.modifiersData.preventOverflow;
        var referenceOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            elementContext: 'reference'
        });
        var popperAltOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            altBoundary: true
        });
        var referenceClippingOffsets = $496957b0c691a0ed$var$getSideOffsets(referenceOverflow, referenceRect);
        var popperEscapeOffsets = $496957b0c691a0ed$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
        var isReferenceHidden = $496957b0c691a0ed$var$isAnySideFullyClipped(referenceClippingOffsets);
        var hasPopperEscaped = $496957b0c691a0ed$var$isAnySideFullyClipped(popperEscapeOffsets);
        state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped
        };
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-reference-hidden': isReferenceHidden,
            'data-popper-escaped': hasPopperEscaped
        });
    }
    var $496957b0c691a0ed$export$2e2bcd8739ae039 = {
        name: 'hide',
        enabled: true,
        phase: 'main',
        requiresIfExists: [
            'preventOverflow'
        ],
        fn: $496957b0c691a0ed$var$hide
    };
});
parcelRegister("iGDLS", function(module, exports) {
    $parcel$export(module.exports, "Reference", ()=>$d9aafffd117cbcc1$export$e0be378c32fb70a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hBYjV = parcelRequire("hBYjV");
    var $5n5w4;
    var $eclLw;
    function $d9aafffd117cbcc1$export$e0be378c32fb70a7(_ref) {
        var children = _ref.children, innerRef = _ref.innerRef;
        var setReferenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeSetterContext));
        var refHandler = $5uXOq.useCallback(function(node) {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, node);
            (0, (0, parcelRequire("eclLw")).safeInvoke)(setReferenceNode, node);
        }, [
            innerRef,
            setReferenceNode
        ]);
        $5uXOq.useEffect(function() {
            return function() {
                return (0, (0, parcelRequire("eclLw")).setRef)(innerRef, null);
            };
        }, []);
        $5uXOq.useEffect(function() {
            (0, ($parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
        }, [
            setReferenceNode
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)({
            ref: refHandler
        });
    }
});
parcelRegister("4wJSY", function(module, exports) {
    $parcel$export(module.exports, "shallowEqualObjects", ()=>$34bdbe885d924a05$export$3e67810a3f0e9f1c);
    function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
        if (arrA === arrB) return true;
        if (!arrA || !arrB) return false;
        const len = arrA.length;
        if (arrB.length !== len) return false;
        for(let i = 0; i < len; i++){
            if (arrA[i] !== arrB[i]) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
        if (objA === objB) return true;
        if (!objA || !objB) return false;
        const aKeys = Object.keys(objA);
        const bKeys = Object.keys(objB);
        const len = aKeys.length;
        if (bKeys.length !== len) return false;
        for(let i = 0; i < len; i++){
            const key = aKeys[i];
            if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
        const aIsArr = Array.isArray(a);
        const bIsArr = Array.isArray(b);
        if (aIsArr !== bIsArr) return false;
        if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
        return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
    }
});
parcelRegister("hT6ku", function(module, exports) {
    $parcel$export(module.exports, "MenuDialog", ()=>$3f79b132df1e01ff$export$c94219dad7c0e37d);
    $parcel$export(module.exports, "DummyControl", ()=>$3f79b132df1e01ff$export$87ce933b7fc29b8c);
    $parcel$export(module.exports, "defaultComponents", ()=>$3f79b132df1e01ff$export$71abc632aa29e6fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gMMNe;
    var $bChGW;
    var $k5uoT;
    var $jldZL;
    function $3f79b132df1e01ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3f79b132df1e01ff$var$menuDialogStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
        backgroundColor: "var(--ds-surface-overlay, white)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`
    });
    const $3f79b132df1e01ff$export$c94219dad7c0e37d = (0, $5uXOq.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            css: [
                $3f79b132df1e01ff$var$menuDialogStyles,
                {
                    maxWidth: maxWidth,
                    minWidth: minWidth
                }
            ],
            style: style,
            id: id,
            "data-testid": testId && `${testId}--menu`
        }, children));
    const $3f79b132df1e01ff$var$dropdownStyles = {
        name: "7693z9",
        styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
    };
    const $3f79b132df1e01ff$var$DropdownIndicator = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3f79b132df1e01ff$var$dropdownStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("gMMNe"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: "open"
        }));
    const $3f79b132df1e01ff$var$controlStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $3f79b132df1e01ff$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            css: $3f79b132df1e01ff$var$controlStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, {
            ...props,
            innerProps: innerProps
        }));
    const $3f79b132df1e01ff$export$87ce933b7fc29b8c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, props));
    const $3f79b132df1e01ff$var$Menu = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $3f79b132df1e01ff$var$IndicatorSeparator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).IndicatorSeparator, props);
    const $3f79b132df1e01ff$var$ClearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, props);
    const $3f79b132df1e01ff$var$MultiValueRemove = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props);
    const $3f79b132df1e01ff$export$71abc632aa29e6fe = {
        Control: $3f79b132df1e01ff$var$Control,
        DropdownIndicator: $3f79b132df1e01ff$var$DropdownIndicator,
        Menu: $3f79b132df1e01ff$var$Menu,
        IndicatorSeparator: $3f79b132df1e01ff$var$IndicatorSeparator,
        ClearIndicator: $3f79b132df1e01ff$var$ClearIndicator,
        MultiValueRemove: $3f79b132df1e01ff$var$MultiValueRemove
    };
});
parcelRegister("gMMNe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c386fa4cb21167b0$var$_react = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c386fa4cb21167b0$var$_search = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("hyOJh")));
    var $c386fa4cb21167b0$var$_search2 = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("77ZoC")));
    function $c386fa4cb21167b0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c386fa4cb21167b0$var$SearchIcon = (props)=>$c386fa4cb21167b0$var$_react.default.createElement($c386fa4cb21167b0$var$_search.default, Object.assign({
            LEGACY_fallbackIcon: $c386fa4cb21167b0$var$_search2.default
        }, props));
    $c386fa4cb21167b0$var$SearchIcon.Name = 'SearchIconMigration';
    var $c386fa4cb21167b0$var$_default = module.exports.default = $c386fa4cb21167b0$var$SearchIcon;
});
parcelRegister("77ZoC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
    function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>$5308cfd5e45a5605$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
        }, props, {
            newIcon: $5308cfd5e45a5605$var$_search.default
        }));
    $5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
    var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;
});
parcelRegister("78Gdn", function(module, exports) {
    $parcel$export(module.exports, "batchByKey", ()=>$2e9cc1cdc768945e$export$da86c38211c1c0a8);
    function $2e9cc1cdc768945e$export$da86c38211c1c0a8(callback) {
        const calls = {};
        return (key, ...args)=>{
            if (!calls[key]) {
                window.setTimeout(()=>{
                    callback(key, calls[key]);
                    delete calls[key];
                });
                calls[key] = [];
            }
            calls[key].push(args);
        };
    }
});
parcelRegister("8fG8p", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$7b21650c04984462$export$defe85febe8b728c);
    var $7VHMR;
    const $7b21650c04984462$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            id: 'fabric.elements.user-picker.placeholder',
            defaultMessage: 'Enter people or teams...',
            description: 'Placeholder description for empty user/team/email select field.'
        },
        addMore: {
            id: 'fabric.elements.user-picker.placeholder.add-more',
            defaultMessage: 'add more people...',
            description: 'Placeholder for multi user picker when the field is not empty.'
        },
        remove: {
            id: 'fabric.elements.user-picker.multi.remove-item',
            defaultMessage: 'Remove',
            description: 'Tooltip for the single item remove button in a multi user select field.'
        },
        clear: {
            id: 'fabric.elements.user-picker.single.clear',
            defaultMessage: 'Clear',
            description: 'Tooltip for clear button in the single user select field.'
        },
        errorMessage: {
            id: 'fabric.elements.user-picker.error.message',
            defaultMessage: 'Something went wrong',
            description: 'Error message to display when options fail to load.'
        },
        memberCountWithoutYou: {
            id: 'fabric.elements.user-picker.team.member.count',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
            description: 'Byline to show the number of members in the team when the current user is not a member of the team'
        },
        memberCountWithYou: {
            id: 'fabric.elements.user-picker.team.member.count.including.you',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
            description: 'Byline to show the number of members in the team when the current user is also a member of the team'
        },
        plus50MembersWithoutYou: {
            id: 'fabric.elements.user-picker.team.member.50plus',
            defaultMessage: "Team \u2022 50+ members",
            description: 'Byline to show the number of members in the team when the number exceeds 50'
        },
        plus50MembersWithYou: {
            id: 'fabric.elements.user-picker.team.member.50plus.including.you',
            defaultMessage: "Team \u2022 50+ members, including you",
            description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
        },
        addEmail: {
            id: 'fabric.elements.user-picker.email.add',
            defaultMessage: 'Add user',
            description: 'Byline for valid email option.'
        },
        selectToAddEmail: {
            id: 'fabric.elements.user-picker.email.select.to.add',
            defaultMessage: 'Select an email address',
            description: 'Byline for valid email option.'
        },
        continueToAddEmail: {
            id: 'fabric.elements.user-picker.email.add.potential',
            defaultMessage: 'Enter an email address',
            description: 'Byline for a potentially valid email option.'
        },
        groupByline: {
            id: 'fabric.elements.user-picker.group.byline',
            defaultMessage: 'Admin-managed group',
            description: 'Byline for admin-managed groups'
        },
        externalUserSourcesHeading: {
            id: 'fabric.elements.user-picker.external.sourced.from',
            defaultMessage: 'Found in:',
            description: 'From where the external user is coming'
        },
        externalUserSourcesError: {
            id: 'fabric.elements.user-picker.external.sourced.error',
            defaultMessage: "We can't connect you right now.",
            description: "Error message when we can't fetch a user's import sources"
        },
        slackProvider: {
            id: 'fabric.elements.user-picker.slack.provider',
            defaultMessage: 'Slack',
            description: 'This external user is sourced from Slack provider'
        },
        googleProvider: {
            id: 'fabric.elements.user-picker.google.provider',
            defaultMessage: 'Google',
            description: 'This external user is sourced from Google provider'
        },
        microsoftProvider: {
            id: 'fabric.elements.user-picker.microsoft.provider',
            defaultMessage: 'Microsoft',
            description: 'This external user is sourced from Microsoft provider'
        },
        gitHubProvider: {
            id: 'fabric.elements.user-picker.github.provider',
            defaultMessage: 'GitHub',
            description: 'This external user is sourced from GitHub provider'
        },
        jiraSource: {
            id: 'fabric.elements.user-picker.source.jira',
            defaultMessage: 'Jira',
            description: 'This external user is sourced from Jira'
        },
        confluenceSource: {
            id: 'fabric.elements.user-picker.source.confluence',
            defaultMessage: 'Confluence',
            description: 'This external user is sourced from Confluence'
        },
        otherAtlassianSource: {
            id: 'fabric.elements.user-picker.source.other-atlassian',
            defaultMessage: 'Other Atlassian products',
            description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
        },
        memberLozengeText: {
            id: 'fabric.elements.user-picker.member.lozenge.text',
            defaultMessage: 'MEMBER',
            description: 'Text within the Lozenge when the user is a workspace member'
        },
        guestLozengeText: {
            id: 'fabric.elements.user-picker.guest.lozenge.text',
            defaultMessage: 'GUEST',
            description: 'Text within the lozenge when the user is a guest of confluence'
        },
        guestUserLozengeTooltip: {
            id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
            defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
            description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
        },
        guestGroupLozengeTooltip: {
            id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
            defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
            description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
        }
    });
});
parcelRegister("pk97C", function(module, exports) {
    $parcel$export(module.exports, "userPickerRenderedUfoExperience", ()=>$06ebadcdd7d5e231$export$b49757166e1acfc2);
    $parcel$export(module.exports, "userPickerOptionsShownUfoExperience", ()=>$06ebadcdd7d5e231$export$135a264e0da507ae);
    $parcel$export(module.exports, "UfoErrorBoundary", ()=>$06ebadcdd7d5e231$export$5ef1c2550074a375);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBycP;
    var $7Zbvr;
    var $jZA09;
    const $06ebadcdd7d5e231$export$b49757166e1acfc2 = new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('user-picker-rendered', {
        platform: {
            component: 'user-picker'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $06ebadcdd7d5e231$export$135a264e0da507ae = new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('user-picker-options-shown', {
        platform: {
            component: 'user-picker'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).InlineResult
    });
    class $06ebadcdd7d5e231$export$5ef1c2550074a375 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch() {
            const instance = $06ebadcdd7d5e231$export$b49757166e1acfc2.getInstance(this.props.id);
            if (instance.state.id !== (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id) instance.failure();
        }
        render() {
            return this.props.children;
        }
    }
});
parcelRegister("cBycP", function(module, exports) {
    $parcel$export(module.exports, "ConcurrentExperience", ()=>$d4c0ab33dd6972cc$export$ac1cddfee07ba6ac);
    var $dCAsn;
    var $boHLC;
    class $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac {
        constructor(experienceId, config){
            this.instances = {};
            this.experienceId = experienceId;
            this.config = config;
        }
        getInstance(instanceId) {
            if (!this.instances[instanceId]) this.instances[instanceId] = new (0, (0, parcelRequire("boHLC")).UFOExperience)(this.experienceId, this.config, instanceId);
            return this.instances[instanceId];
        }
        release(instanceId) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('instanceId', instanceId);
            if (this.instances[instanceId]) this.instances[instanceId].abort();
            delete this.instances[instanceId];
        }
    }
});
parcelRegister("dCAsn", function(module, exports) {
    $parcel$export(module.exports, "ufolog", ()=>$c8856379f9e2d7e8$export$b4958caff08a0960);
    $parcel$export(module.exports, "ufowarn", ()=>$c8856379f9e2d7e8$export$d53d07b6034c4560);
    class $c8856379f9e2d7e8$var$UFOLogger {
        static{
            this.UFOprefix = "[ufo\uD83D\uDEF8]";
        }
        log(...args) {
            this.enabled && console.log($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
        }
        warn(...args) {
            this.enabled && console.warn($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
        }
        enable() {
            this.enabled = true;
        }
        disable() {
            this.enabled = false;
        }
        constructor(){
            this.enabled = false;
        }
    }
    const $c8856379f9e2d7e8$export$4ab84f6f04f6566d = new $c8856379f9e2d7e8$var$UFOLogger();
    const $c8856379f9e2d7e8$export$b4958caff08a0960 = (...args)=>{
        $c8856379f9e2d7e8$export$4ab84f6f04f6566d.log(...args);
    };
    const $c8856379f9e2d7e8$export$d53d07b6034c4560 = (...args)=>{
        $c8856379f9e2d7e8$export$4ab84f6f04f6566d.warn(...args);
    };
});
parcelRegister("boHLC", function(module, exports) {
    $parcel$export(module.exports, "UFOExperience", ()=>$69d53cdb5241e240$export$c00d22927c60484a);
    var $iLwDN;
    class $69d53cdb5241e240$export$c00d22927c60484a extends (0, (0, parcelRequire("iLwDN")).UFOAbstractExperience) {
    }
});
parcelRegister("iLwDN", function(module, exports) {
    $parcel$export(module.exports, "UFOAbstractExperience", ()=>$cc70575b2203e361$export$d31c89db257648c);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $1vlV8;
    var $dCAsn;
    var $dlucd;
    var $blQsS;
    var $9tjMO;
    var $1CRHx;
    var $jZA09;
    var $hM2B6;
    var $7Zbvr;
    const $cc70575b2203e361$var$getPageVisibleState = ()=>{
        return !(0, (0, parcelRequire("1CRHx")).isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, (0, parcelRequire("blQsS")).PageVisibleState).VISIBLE : (0, (0, parcelRequire("blQsS")).PageVisibleState).HIDDEN;
    };
    const $cc70575b2203e361$export$c753e8669d30c8ad = (timestamp)=>{
        if (timestamp !== undefined) return ~~timestamp;
        return (0, (0, parcelRequire("9tjMO")).roundPerfNow)();
    };
    class $cc70575b2203e361$export$d31c89db257648c {
        constructor(id, config, instanceId = null){
            this.state = (0, (0, parcelRequire("jZA09")).UFOExperienceState).NOT_STARTED;
            this.instanceId = null;
            this.parent = null;
            this.category = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.explicitTimings = {};
            this.isSSROutputAsFMP = false;
            this.uuid = null;
            this._until = null;
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this.performanceConfig = {};
            this.setPageVisibleStateToMixed = ()=>{
                this.pageVisibleState = (0, (0, parcelRequire("blQsS")).PageVisibleState).MIXED;
                (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            };
            this.id = id;
            this.category = config?.category || null;
            this.until = config?.until || null;
            this.instanceId = instanceId;
            this.handleDoneBind = this._handleDoneExperience.bind(this);
            this.type = config.type;
            this.performanceType = config.performanceType;
            this.performanceConfig = config.performanceConfig || {};
            this.config = config;
            this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
            this.featureFlags = config.featureFlags || [];
            this.timings = config.timings || [];
            if (config.performanceType === (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
        }
        async transition(newState, timestamp) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('async transition', this.id, this.state.id, newState.id);
            if ((0, (0, parcelRequire("hM2B6")).canTransition)(this.state, newState)) {
                (0, (0, parcelRequire("dCAsn")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
                if (newState === (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED) this._reset();
                if (this.state.final && !newState.final) {
                    this.metrics.startTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                    this.uuid = (0, $7Jxgt.v4)();
                }
                this.state = newState;
                if (newState.final) {
                    this.metrics.endTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                    if (!this._isManualStateEnabled()) (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).unsubscribeEvent)((0, (0, parcelRequire("blQsS")).SUBSCRIBE_ALL), this.handleDoneBind));
                    const data = await this.exportData();
                    (0, (0, parcelRequire("dCAsn")).ufolog)('this.parent', this.parent);
                    (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).experiencePayloadEvent)(data));
                }
                return true;
            }
            (0, (0, parcelRequire("dCAsn")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
            (0, (0, parcelRequire("dCAsn")).ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
            return false;
        }
        async start(startTime) {
            const transitionSuccessful = await this.transition((0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED, startTime);
            if (transitionSuccessful) {
                this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
                (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                if (!this._isManualStateEnabled()) {
                    (0, (0, parcelRequire("dCAsn")).ufolog)('subscribed', this.id);
                    (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).subscribeEvent)((0, (0, parcelRequire("blQsS")).SUBSCRIBE_ALL), this.handleDoneBind));
                }
            }
        }
        mark(name, timestamp) {
            if (name !== (0, (0, parcelRequire("blQsS")).FMP_MARK) && name !== (0, (0, parcelRequire("blQsS")).INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
            else (0, (0, parcelRequire("dCAsn")).ufowarn)('please use markFMP or markInlineResponse for specialised marks');
        }
        _mark(name, timestamp) {
            this.metrics.marks.push({
                name: name,
                time: $cc70575b2203e361$export$c753e8669d30c8ad(timestamp)
            });
            this.transition((0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS);
        }
        markFMP(timestamp) {
            this._mark((0, (0, parcelRequire("blQsS")).FMP_MARK), timestamp);
        }
        markInlineResponse(timestamp) {
            this._mark((0, (0, parcelRequire("blQsS")).INLINE_RESPONSE_MARK), timestamp);
        }
        _isManualStateEnabled() {
            return this.until === null;
        }
        _validateManualState() {
            if (!this._isManualStateEnabled()) {
                (0, (0, parcelRequire("dCAsn")).ufowarn)('manual change of state not allowed as "until" is defined');
                return false;
            }
            return true;
        }
        switchToEndState(state, config) {
            if (!config?.force && !this._validateManualState()) return null;
            if (config?.metadata) this.addMetadata(config.metadata);
            (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            return this.transition(state);
        }
        async success(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED, config);
        }
        async failure(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED, config);
        }
        async abort(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED, config);
        }
        addMetadata(data) {
            Object.assign(this.metadata, data);
        }
        _handleDoneExperience(data) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
            if (data.state.final) {
                if (this._until !== null) {
                    const { done: done, state: state } = this._until(data);
                    if (done && !this.state.final) this.transition(state);
                }
            }
        }
        async getId() {
            return this.id;
        }
        async exportData() {
            return {
                id: await this.getId(),
                uuid: this.uuid,
                type: this.type,
                schemaVersion: (0, $bbbd8b5766b053fb$export$2295b861f318254a) || 'unknown',
                performanceType: this.performanceType,
                category: this.category,
                state: this.state,
                metadata: {
                    ...this.metadata
                },
                metrics: {
                    ...this.metrics
                },
                children: [
                    ...this.childExperiences
                ],
                result: {
                    success: !!this.state.success,
                    startTime: this.metrics.startTime,
                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                },
                platform: this.config.platform || null,
                pageVisibleState: this.pageVisibleState,
                featureFlags: this.featureFlags,
                isSSROutputAsFMP: this.isSSROutputAsFMP,
                timings: this.timings,
                explicitTimings: this.explicitTimings,
                performanceConfig: this.performanceConfig
            };
        }
        _reset() {
            this.parent = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this._until = this.until ? this.until() : null;
        }
    }
});
const $bbbd8b5766b053fb$export$2295b861f318254a = '0.1.5';
parcelRegister("1vlV8", function(module, exports) {
    $parcel$export(module.exports, "getGlobalEventStream", ()=>$d117cb8be5e8747a$export$6123a44dc2384540);
    $parcel$export(module.exports, "subscribeEvent", ()=>$d117cb8be5e8747a$export$37863216db4b714d);
    $parcel$export(module.exports, "unsubscribeEvent", ()=>$d117cb8be5e8747a$export$ee1a7bd1fc9ea85e);
    $parcel$export(module.exports, "experiencePayloadEvent", ()=>$d117cb8be5e8747a$export$7c957416596ca127);
    var $dCAsn;
    var $blQsS;
    const $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH = 250;
    const $d117cb8be5e8747a$export$6123a44dc2384540 = ()=>{
        if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
            const earlyStream = (()=>{
                const stream = [];
                return {
                    __buffer_only__: true,
                    push: (event)=>{
                        if (stream.length < $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                    },
                    getStream: ()=>stream
                };
            })();
            globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
        }
        return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
    };
    const $d117cb8be5e8747a$export$c1522520b417b066 = (eventStream)=>{
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
            (0, (0, parcelRequire("dCAsn")).ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
            return;
        }
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
    };
    const $d117cb8be5e8747a$export$37863216db4b714d = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).SUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).UNSUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $d117cb8be5e8747a$export$7c957416596ca127 = (data)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
            payload: data
        };
    };
});
parcelRegister("blQsS", function(module, exports) {
    $parcel$export(module.exports, "UFOGlobalEventStreamEventType", ()=>$2d245cff606eb60d$export$96253c35c37cf96b);
    $parcel$export(module.exports, "PageVisibleState", ()=>$2d245cff606eb60d$export$a12c67b37a306b13);
    $parcel$export(module.exports, "SUBSCRIBE_ALL", ()=>$2d245cff606eb60d$export$79bf131685ad41d7);
    $parcel$export(module.exports, "FMP_MARK", ()=>$2d245cff606eb60d$export$9f2bf58999404c75);
    $parcel$export(module.exports, "INLINE_RESPONSE_MARK", ()=>$2d245cff606eb60d$export$837e0f79a8056912);
    var $2d245cff606eb60d$export$96253c35c37cf96b;
    (function(UFOGlobalEventStreamEventType) {
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    })($2d245cff606eb60d$export$96253c35c37cf96b || ($2d245cff606eb60d$export$96253c35c37cf96b = {}));
    var $2d245cff606eb60d$export$a12c67b37a306b13;
    (function(PageVisibleState) {
        PageVisibleState["VISIBLE"] = "visible";
        PageVisibleState["HIDDEN"] = "hidden";
        PageVisibleState["MIXED"] = "mixed";
    })($2d245cff606eb60d$export$a12c67b37a306b13 || ($2d245cff606eb60d$export$a12c67b37a306b13 = {}));
    var $2d245cff606eb60d$export$66b33c055cbb625e;
    (function(PageLoadMetrics) {
        PageLoadMetrics["fmp"] = "fmp";
        PageLoadMetrics["tti"] = "tti";
    })($2d245cff606eb60d$export$66b33c055cbb625e || ($2d245cff606eb60d$export$66b33c055cbb625e = {}));
    var $2d245cff606eb60d$export$3ce489cbe02dc21b;
    (function(PageSegmentLoadMetrics) {
        PageSegmentLoadMetrics["fmp"] = "fmp";
        PageSegmentLoadMetrics["tti"] = "tti";
    })($2d245cff606eb60d$export$3ce489cbe02dc21b || ($2d245cff606eb60d$export$3ce489cbe02dc21b = {}));
    var $2d245cff606eb60d$export$341b330828bd3906;
    (function(InteractionMetrics) {
        InteractionMetrics["response"] = "response";
        InteractionMetrics["result"] = "result";
    })($2d245cff606eb60d$export$341b330828bd3906 || ($2d245cff606eb60d$export$341b330828bd3906 = {}));
    var $2d245cff606eb60d$export$b9b20160f581e4f8;
    (function(CustomMetrics) {
        CustomMetrics["duration"] = "duration";
    })($2d245cff606eb60d$export$b9b20160f581e4f8 || ($2d245cff606eb60d$export$b9b20160f581e4f8 = {}));
    const $2d245cff606eb60d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
    const $2d245cff606eb60d$export$9f2bf58999404c75 = 'fmp';
    const $2d245cff606eb60d$export$837e0f79a8056912 = 'inline-response';
});
parcelRegister("dlucd", function(module, exports) {
    $parcel$export(module.exports, "visibilityChangeObserver", ()=>$46b8336a04974a29$export$13e680397ec8f3eb);
    var $1CRHx;
    class $46b8336a04974a29$var$VisibilityChangeObserver {
        start() {
            if (this.started) return;
            this.started = true;
            document.addEventListener('visibilitychange', this.broadcast);
            if ((0, (0, parcelRequire("1CRHx")).isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
        }
        subscribe(callback) {
            this.observers.push(callback);
        }
        unsubscribe(callback) {
            this.observers = this.observers.filter((fn)=>fn !== callback);
        }
        constructor(){
            this.started = false;
            this.observers = [];
            this.broadcast = ()=>{
                this.observers.forEach((fn)=>fn());
                this.observers = [];
            };
        }
    }
    const $46b8336a04974a29$export$13e680397ec8f3eb = new $46b8336a04974a29$var$VisibilityChangeObserver();
});
parcelRegister("1CRHx", function(module, exports) {
    $parcel$export(module.exports, "isWindowObjectAvailable", ()=>$5d24ea5e24f61a4f$export$15e172712955e18f);
    const $5d24ea5e24f61a4f$export$15e172712955e18f = ()=>{
        return typeof window !== 'undefined';
    };
});
parcelRegister("9tjMO", function(module, exports) {
    $parcel$export(module.exports, "roundPerfNow", ()=>$29608d3bcf65c265$export$5f490af6b2b115cf);
    const $29608d3bcf65c265$export$5f490af6b2b115cf = ()=>~~performance.now();
});
parcelRegister("hM2B6", function(module, exports) {
    $parcel$export(module.exports, "canTransition", ()=>$6edf4365ea9733d4$export$178881f329fdb81f);
    var $jZA09;
    const $6edf4365ea9733d4$var$UFOStateAvailableTransitions = {
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).NOT_STARTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).RECOVERED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).RECOVERED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ]
    };
    const $6edf4365ea9733d4$export$178881f329fdb81f = (state1, state2)=>{
        return $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id] && $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
    };
});
parcelRegister("7Zbvr", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTypes", ()=>$e40e68027603de60$export$994164cf3ae1cc9a);
    $parcel$export(module.exports, "ExperiencePerformanceTypes", ()=>$e40e68027603de60$export$cc26007c03242fff);
    var $e40e68027603de60$export$994164cf3ae1cc9a;
    (function(ExperienceTypes) {
        ExperienceTypes["Load"] = "load";
        ExperienceTypes["Experience"] = "experience";
        ExperienceTypes["Operation"] = "operation";
    })($e40e68027603de60$export$994164cf3ae1cc9a || ($e40e68027603de60$export$994164cf3ae1cc9a = {}));
    var $e40e68027603de60$export$cc26007c03242fff;
    (function(ExperiencePerformanceTypes) {
        ExperiencePerformanceTypes["PageLoad"] = "page-load";
        ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
        ExperiencePerformanceTypes["InlineResult"] = "inline-result";
        ExperiencePerformanceTypes["Custom"] = "custom";
    })($e40e68027603de60$export$cc26007c03242fff || ($e40e68027603de60$export$cc26007c03242fff = {}));
});
parcelRegister("2wgOn", function(module, exports) {
    $parcel$export(module.exports, "BORDER_PADDING", ()=>$01bdbab7be42e070$export$59c188914e58c94b);
    $parcel$export(module.exports, "getStyles", ()=>$01bdbab7be42e070$export$ffd58b7f6f099a57);
    $parcel$export(module.exports, "getPopupStyles", ()=>$01bdbab7be42e070$export$4e983f376ad8a3af);
    var $8QpSo;
    var $7VXAu;
    const $01bdbab7be42e070$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
    const $01bdbab7be42e070$export$53937c04f7dfc2ae = 6;
    const $01bdbab7be42e070$export$2c62ba763e976c54 = 39;
    const $01bdbab7be42e070$export$ffd58b7f6f099a57 = (0, (0, parcelRequire("8QpSo")).default)((width, isMulti, isCompact, overrideStyles, isInvalid)=>{
        let styles = {
            menu: (css, state)=>({
                    ...css,
                    width: width,
                    minWidth: state.selectProps.menuMinWidth,
                    zIndex: '400'
                }),
            menuList: (css)=>({
                    ...css,
                    zIndex: '400'
                }),
            control: (css, state)=>{
                const isMulti = state.selectProps.isMulti;
                return {
                    ...css,
                    width: width,
                    borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                    backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`,
                    '&:hover .fabric-user-picker__clear-indicator': {
                        opacity: 1
                    },
                    ':hover': {
                        ...css[':hover'],
                        borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                        backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $829f609a65d26a98$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`
                    },
                    padding: 0,
                    minHeight: isCompact ? 'none' : 44,
                    height: isCompact || isMulti ? '100%' : 44,
                    maxWidth: '100%'
                };
            },
            clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                    ...css,
                    opacity: 1,
                    '@media (hover: hover) and (pointer: fine)': {
                        opacity: 0
                    },
                    transition: css.transition + ', opacity 150ms',
                    paddingTop: 0,
                    padding: 0,
                    ':hover': {
                        color: `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`
                    }
                }),
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
                const isMulti = state.selectProps.isMulti;
                return {
                    ...css,
                    gridTemplateColumns: 'auto 1fr',
                    paddingTop: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                    paddingBottom: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                    paddingLeft: isMulti ? $01bdbab7be42e070$export$59c188914e58c94b : 0,
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    scrollbarWidth: 'none',
                    maxHeight: state.selectProps.maxPickerHeight || '100%',
                    '::-webkit-scrollbar': {
                        width: 0,
                        background: 'transparent'
                    }
                };
            },
            multiValue: (css)=>({
                    ...css,
                    borderRadius: 24,
                    cursor: 'default'
                }),
            multiValueLabel: (css)=>({
                    ...css,
                    fontSize: '100%',
                    display: 'flex'
                }),
            multiValueRemove: (css)=>({
                    ...css,
                    borderRadius: 24,
                    cursor: 'pointer'
                }),
            placeholder: (css, state)=>{
                if (css.position === 'absolute' && !css.left) css.left = `${$01bdbab7be42e070$export$59c188914e58c94b}px`;
                return {
                    ...css,
                    gridArea: '1/2/2/3',
                    paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                    margin: 0,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                };
            },
            option: (css)=>({
                    ...css,
                    overflow: 'hidden'
                }),
            input: (css, state)=>({
                    ...css,
                    gridArea: '1/2/2/3',
                    gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                    margin: `${"var(--ds-space-050, 4px)"} 0`,
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                    '& input::placeholder': {
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
                        opacity: 1
                    },
                    '& input:-ms-input-placeholder': {
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`
                    }
                }),
            singleValue: (css)=>({
                    ...css,
                    margin: 0,
                    gridArea: '1/2/2/3'
                })
        };
        return overrideStyles ? (0, (0, parcelRequire("7VXAu")).mergeStyles)(styles, overrideStyles) : styles;
    });
    const $01bdbab7be42e070$export$4e983f376ad8a3af = (0, (0, parcelRequire("8QpSo")).default)((width, isMulti, overrideStyles)=>({
            ...$01bdbab7be42e070$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles)
        }));
});
parcelRegister("dyegP", function(module, exports) {
    $parcel$export(module.exports, "getComponents", ()=>$27e51ea041192381$export$4e811121b221213b);
    $parcel$export(module.exports, "getPopupComponents", ()=>$27e51ea041192381$export$19205fd341a6bb08);
    var $8QpSo;
    var $dqbw8;
    var $8Y8Qe;
    var $fIpmY;
    var $3QONt;
    var $6Kkci;
    var $OxpB4;
    var $ee8bl;
    var $h3ej5;
    var $6Ks8i;
    var $lYehz;
    const $27e51ea041192381$export$4e811121b221213b = (0, (0, parcelRequire("8QpSo")).default)((multi, anchor)=>{
        if (anchor) return {
            Control: anchor,
            Option: (0, parcelRequire("3QONt")).Option
        };
        else return {
            MultiValue: (0, parcelRequire("8Y8Qe")).MultiValue,
            DropdownIndicator: null,
            SingleValue: (0, parcelRequire("6Kkci")).SingleValue,
            ClearIndicator: multi ? null : (0, (0, parcelRequire("dqbw8")).ClearIndicator),
            Option: (0, parcelRequire("3QONt")).Option,
            ValueContainer: multi ? (0, (0, parcelRequire("fIpmY")).MultiValueContainer) : (0, (0, parcelRequire("ee8bl")).SingleValueContainer),
            Input: (0, parcelRequire("OxpB4")).Input,
            Menu: (0, parcelRequire("lYehz")).Menu
        };
    });
    const $27e51ea041192381$export$19205fd341a6bb08 = (0, (0, parcelRequire("8QpSo")).default)((hasPopupTitle)=>{
        const baseProps = {
            DropdownIndicator: null,
            SingleValue: (0, parcelRequire("6Kkci")).SingleValue,
            ClearIndicator: (0, parcelRequire("dqbw8")).ClearIndicator,
            Option: (0, parcelRequire("3QONt")).Option,
            ValueContainer: (0, (0, parcelRequire("ee8bl")).SingleValueContainer),
            Input: (0, (0, parcelRequire("h3ej5")).PopupInput)
        };
        if (hasPopupTitle) return {
            ...baseProps,
            Control: (0, (0, parcelRequire("6Ks8i")).PopupControl)
        };
        return baseProps;
    });
});
parcelRegister("dqbw8", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$11bf495008933d24$export$ecf9cf59142dd54a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    const $11bf495008933d24$var$AsyncTooltip = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("inSCC")).then((module)=>{
            return {
                default: module.default
            };
        }));
    class $11bf495008933d24$export$ecf9cf59142dd54a extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { selectProps: { clearValueLabel: clearValueLabel } } = this.props;
            const Indicator = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
                ...this.props,
                innerProps: {
                    ...this.props.innerProps,
                    onMouseDown: this.handleMouseDown
                }
            });
            return clearValueLabel ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Suspense, {
                fallback: Indicator
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($11bf495008933d24$var$AsyncTooltip, {
                content: clearValueLabel
            }, Indicator)) : Indicator;
        }
        constructor(...args){
            super(...args), this.handleMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                const { clearValue: clearValue, selectProps: selectProps } = this.props;
                clearValue();
                if (selectProps && !selectProps.isFocused) event.stopPropagation();
            };
        }
    }
});
parcelRegister("inSCC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lOT8O").then(()=>parcelRequire('8hfZh'));
});
parcelRegister("8Y8Qe", function(module, exports) {
    $parcel$export(module.exports, "MultiValue", ()=>$65368b71d1856c3a$export$419cdf50db8b579);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $f8Sb3;
    var $dW8NE;
    var $5pJx4;
    var $3smIt;
    var $4hqZ5;
    var $fuhQD;
    var $VSDnB;
    function $65368b71d1856c3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $65368b71d1856c3a$export$118122ebc1e626fa = (valueContainer, control)=>{
        const { top: top, height: height } = valueContainer.getBoundingClientRect();
        const { height: controlHeight } = control.getBoundingClientRect();
        if (top - height < 0) valueContainer.scrollIntoView();
        if (top + height > controlHeight) valueContainer.scrollIntoView(false);
    };
    const $65368b71d1856c3a$var$groupTagContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.025',
        marginTop: 'space.025'
    });
    const $65368b71d1856c3a$var$nameWrapper = {
        name: "6urmvo",
        styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
    };
    class $65368b71d1856c3a$export$419cdf50db8b579 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props), this.getElemBefore = ()=>{
                const { data: { data: data } } = this.props;
                if ((0, (0, parcelRequire("3smIt")).isEmail)(data)) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dW8NE")).AddOptionAvatar), {
                    isLozenge: true
                });
                if ((0, (0, parcelRequire("3smIt")).isGroup)(data)) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $65368b71d1856c3a$var$groupTagContainer
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("4hqZ5"))))), {
                    LEGACY_margin: "-2px 0 0 0",
                    color: "currentColor",
                    label: "",
                    LEGACY_size: "small"
                }));
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5pJx4")).SizeableAvatar), {
                    appearance: "multi",
                    src: (0, (0, parcelRequire("3smIt")).getAvatarUrl)(data),
                    type: (0, (0, parcelRequire("3smIt")).isTeam)(data) && (0, (0, parcelRequire("VSDnB")).fg)('verified-team-in-user-picker') ? 'team' : 'person'
                });
            }, this.getElemAfter = ()=>{
                const { data: { data: data } } = this.props;
                if ((0, (0, parcelRequire("3smIt")).isTeam)(data) && data.verified && (0, (0, parcelRequire("VSDnB")).fg)('verified-team-in-user-picker')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fuhQD")).VerifiedTeamIcon), {
                    size: "small"
                });
                return null;
            };
            this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
        }
        componentDidUpdate() {
            const { isFocused: isFocused } = this.props;
            if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $65368b71d1856c3a$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
        }
        shouldComponentUpdate(nextProps) {
            const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
            const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
            return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
        }
        render() {
            const { children: children, innerProps: innerProps, ...rest } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValue, {
                ...rest,
                innerProps: {
                    ref: this.containerRef
                },
                cropWithEllipsis: false
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                alignBlock: "center"
            }, this.getElemBefore(), " ", (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $65368b71d1856c3a$var$nameWrapper
            }, children), this.getElemAfter()));
        }
    }
});
parcelRegister("dW8NE", function(module, exports) {
    $parcel$export(module.exports, "AddOptionAvatar", ()=>$f3236d5a67f7ff1f$export$df396db45e491922);
    var $aVnO1;
    var $f8Sb3;
    parcelRequire("5uXOq");
    const $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
        const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            padding: padding,
            backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            marginLeft: "var(--ds-space-025, 2px)"
        });
    };
    const $f3236d5a67f7ff1f$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle(isLozenge)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("aVnO1"))))), {
            testId: "add-option-avatar-email-icon",
            label: label || '',
            LEGACY_size: isLozenge ? 'small' : 'medium',
            LEGACY_margin: "0 0 0 -2px",
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        })));
    };
});
parcelRegister("aVnO1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7f41b19bed4136e0$var$_react = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7f41b19bed4136e0$var$_email = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("eRB05")));
    var $7f41b19bed4136e0$var$_email2 = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5bEkJ")));
    function $7f41b19bed4136e0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7f41b19bed4136e0$var$EmailIcon = (props)=>$7f41b19bed4136e0$var$_react.default.createElement($7f41b19bed4136e0$var$_email.default, Object.assign({
            LEGACY_fallbackIcon: $7f41b19bed4136e0$var$_email2.default
        }, props));
    $7f41b19bed4136e0$var$EmailIcon.Name = 'EmailIconMigration';
    var $7f41b19bed4136e0$var$_default = module.exports.default = $7f41b19bed4136e0$var$EmailIcon;
});
parcelRegister("5bEkJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3c6d443366bf8cbb$var$_react = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $3c6d443366bf8cbb$var$_email = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("eRB05")));
    function $3c6d443366bf8cbb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3c6d443366bf8cbb$var$EmailIcon = (props)=>$3c6d443366bf8cbb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
        }, props, {
            newIcon: $3c6d443366bf8cbb$var$_email.default
        }));
    $3c6d443366bf8cbb$var$EmailIcon.displayName = 'EmailIcon';
    var $3c6d443366bf8cbb$var$_default = module.exports.default = $3c6d443366bf8cbb$var$EmailIcon;
});
parcelRegister("5pJx4", function(module, exports) {
    $parcel$export(module.exports, "SizeableAvatar", ()=>$50cd04ab4dcbd6e5$export$44d81a88129649da);
    var $ujWmd;
    var $fwSAz;
    var $5uXOq = parcelRequire("5uXOq");
    var $3smIt;
    class $50cd04ab4dcbd6e5$export$44d81a88129649da extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
            const props = {
                size: (0, (0, parcelRequire("3smIt")).getAvatarSize)(appearance),
                src: src,
                borderColor: 'transparent',
                presence: presence
            };
            return type === 'team' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fwSAz")).default), props) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), props);
        }
    }
});
parcelRegister("fwSAz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cdf5ede1a400c9d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $2w1D3;
    const $6cdf5ede1a400c9d$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $6cdf5ede1a400c9d$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
    function $6cdf5ede1a400c9d$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: "circle",
            ...props,
            size: size,
            src: src,
            testId: `${testId}-team-avatar`
        }, (innerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2w1D3")).TeamAvatarImage), {
                src: src,
                size: size,
                testId: testId,
                ...innerProps
            }));
    }
});
parcelRegister("2w1D3", function(module, exports) {
    $parcel$export(module.exports, "TeamAvatarImage", ()=>$7d2527153712d181$export$ac3673635a5387be);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $vIiRg;
    var $h8cgU;
    function $7d2527153712d181$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7d2527153712d181$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $7d2527153712d181$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
    const $7d2527153712d181$var$ICON_PADDING = 4;
    const $7d2527153712d181$var$avatarDefaultIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        backgroundColor: $7d2527153712d181$var$ICON_COLOR,
        borderRadius: '50%',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $7d2527153712d181$var$nestedAvatarStyles = Object.entries((0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)).reduce((styles, [key, size])=>{
        return {
            ...styles,
            [key]: (0, (0, parcelRequire("f8Sb3")).css)({
                width: `${size}px`,
                height: `${size}px`,
                '& svg': {
                    width: `${size - $7d2527153712d181$var$ICON_PADDING}px`,
                    height: `${size - $7d2527153712d181$var$ICON_PADDING}px`
                }
            })
        };
    }, {});
    const $7d2527153712d181$var$avatarImageStyles = {
        name: "n68006",
        styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
    };
    const $7d2527153712d181$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, ...rest })=>{
        const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            setHasImageErrored(false);
        }, [
            src
        ]);
        if (!src || hasImageErrored) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $7d2527153712d181$var$avatarDefaultIconStyles,
                $7d2527153712d181$var$nestedAvatarStyles[size]
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("h8cgU"))))), {
            label: alt,
            primaryColor: $7d2527153712d181$var$ICON_BACKGROUND,
            secondaryColor: $7d2527153712d181$var$ICON_COLOR,
            testId: testId && `${testId}--team`
        }));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", rest, (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            src: src,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            css: $7d2527153712d181$var$avatarImageStyles,
            onError: ()=>setHasImageErrored(true)
        }));
    };
});
parcelRegister("h8cgU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c78cb3eb85357720$var$_react = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c78cb3eb85357720$var$_peopleGroup = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("fptva")));
    function $c78cb3eb85357720$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c78cb3eb85357720$var$PeopleIcon = (props)=>$c78cb3eb85357720$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
        }, props, {
            newIcon: $c78cb3eb85357720$var$_peopleGroup.default
        }));
    $c78cb3eb85357720$var$PeopleIcon.displayName = 'PeopleIcon';
    var $c78cb3eb85357720$var$_default = module.exports.default = $c78cb3eb85357720$var$PeopleIcon;
});
parcelRegister("4hqZ5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $31ddae7439c341a9$var$_react = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $31ddae7439c341a9$var$_peopleGroup = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("fptva")));
    var $31ddae7439c341a9$var$_people = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("h8cgU")));
    function $31ddae7439c341a9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $31ddae7439c341a9$var$PeopleGroupIcon = (props)=>$31ddae7439c341a9$var$_react.default.createElement($31ddae7439c341a9$var$_peopleGroup.default, Object.assign({
            LEGACY_fallbackIcon: $31ddae7439c341a9$var$_people.default
        }, props));
    $31ddae7439c341a9$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
    var $31ddae7439c341a9$var$_default = module.exports.default = $31ddae7439c341a9$var$PeopleGroupIcon;
});
parcelRegister("fuhQD", function(module, exports) {
    $parcel$export(module.exports, "VerifiedTeamIcon", ()=>$a137cc376204c926$export$d7949f68d31e5edd);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gqGjQ;
    var $fGmbh;
    var $3bDjY;
    var $27dJz;
    const $a137cc376204c926$export$d7949f68d31e5edd = ({ size: size, label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, (0, parcelRequire("27dJz")).messages).verifiedIconDefaultTooltip) : undefined;
        return tooltipContent ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            tabIndex: 0,
            role: "button",
            "aria-hidden": "true",
            "data-testid": "verified-team-icon"
        }, ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gqGjQ"))))), {
            color: "var(--ds-icon-accent-blue, #1D7AFC)",
            LEGACY_size: size,
            label: tooltipContent,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (0, parcelRequire("fGmbh")).default)
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gqGjQ"))))), {
            color: "var(--ds-icon-accent-blue, #1D7AFC)",
            LEGACY_size: size,
            spacing: "spacious",
            label: label,
            LEGACY_fallbackIcon: (0, (0, parcelRequire("fGmbh")).default)
        });
    };
});
parcelRegister("gqGjQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bf5fe6b7538334be$var$_react = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bf5fe6b7538334be$var$_baseNew = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $bf5fe6b7538334be$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bf5fe6b7538334be$var$StatusVerifiedIcon = (props)=>$bf5fe6b7538334be$var$_react.default.createElement($bf5fe6b7538334be$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.15.444a1.713 1.713 0 0 0-2.3 0L5.7 1.486a.2.2 0 0 1-.15.055L4 1.481a1.713 1.713 0 0 0-1.763 1.48l-.21 1.536a.2.2 0 0 1-.08.139l-1.226.95c-.696.54-.87 1.52-.4 2.266l.828 1.312c.03.047.04.104.027.159l-.328 1.515A1.713 1.713 0 0 0 2 12.831l1.477.474a.2.2 0 0 1 .123.103l.723 1.372c.41.78 1.346 1.12 2.162.787l1.436-.586a.2.2 0 0 1 .16 0l1.436.586a1.713 1.713 0 0 0 2.162-.787l.723-1.372a.2.2 0 0 1 .123-.103l1.477-.474a1.713 1.713 0 0 0 1.15-1.993l-.328-1.515a.2.2 0 0 1 .028-.159l.827-1.312a1.71 1.71 0 0 0-.4-2.266l-1.225-.95a.2.2 0 0 1-.08-.14l-.21-1.536A1.713 1.713 0 0 0 12 1.481l-1.55.06a.2.2 0 0 1-.15-.055zm3.176 5.036-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $bf5fe6b7538334be$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
    var $bf5fe6b7538334be$var$_default = module.exports.default = $bf5fe6b7538334be$var$StatusVerifiedIcon;
});
parcelRegister("fGmbh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9bd2ad2ea16bb95$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $d9bd2ad2ea16bb95$var$VerifiedIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "33",
            height: "32",
            viewBox: "0 0 33 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        }));
    const $d9bd2ad2ea16bb95$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $d9bd2ad2ea16bb95$var$VerifiedIconGlyph
        });
    var $d9bd2ad2ea16bb95$export$2e2bcd8739ae039 = $d9bd2ad2ea16bb95$var$VerifiedIcon;
});
parcelRegister("27dJz", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$952fb45ddff9712a$export$defe85febe8b728c);
    var $7VHMR;
    const $952fb45ddff9712a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        verifiedIconDefaultTooltip: {
            id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
            defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
            description: 'Tooltip text for the verified team icon'
        }
    });
});
parcelRegister("fIpmY", function(module, exports) {
    $parcel$export(module.exports, "MultiValueContainer", ()=>$0a44bca42d442dd9$export$cf9cf2a30a59265c);
    var $bChGW;
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $ousew;
    var $8fG8p;
    var $3smIt;
    var $jNYXM;
    class $0a44bca42d442dd9$export$cf9cf2a30a59265c extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static getDerivedStateFromProps(nextProps, prevState) {
            return {
                valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
                previousValueSize: prevState.valueSize
            };
        }
        constructor(props){
            super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
                this.timeoutId = window.setTimeout(()=>{
                    const { ref: { current: current } } = this.valueContainerInnerProps;
                    if (current !== null) {
                        const container = (0, ($parcel$interopDefault($7nsd3))).findDOMNode(current);
                        if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                    }
                    this.timeoutId = null;
                });
            }, this.showPlaceholder = ()=>{
                const { selectProps: { value: value } } = this.props;
                return value && value.length > 0;
            }, this.addPlaceholder = (placeholder)=>{
                const children = (0, ($parcel$interopDefault($5uXOq))).Children.map(this.props.children, (child)=>(0, (0, parcelRequire("3smIt")).isChildInput)(child) && this.showPlaceholder() ? (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                        placeholder: placeholder
                    }) : child);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, children);
            }, this.renderChildren = ()=>{
                const { selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
                if (isDisabled) return this.props.children;
                if (addMoreMessage === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("8fG8p")).messages).addMore, (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                });
                return this.addPlaceholder(addMoreMessage);
            }, this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
            this.state = {
                valueSize: 0,
                previousValueSize: 0
            };
            this.valueContainerInnerProps = {
                ref: (0, ($parcel$interopDefault($5uXOq))).createRef()
            };
        }
        componentDidUpdate() {
            const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
            const { isFocused: isFocused } = this.props.selectProps;
            if (valueSize > previousValueSize && isFocused) {
                if (this.timeoutId) {
                    window.clearTimeout(this.timeoutId);
                    this.timeoutId = null;
                }
                this.scrollToBottom();
            }
        }
        componentWillUnmount() {
            if (this.timeoutId) window.clearTimeout(this.timeoutId);
        }
        render() {
            const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
            const props = {
                ...valueContainerProps,
                innerProps: this.valueContainerInnerProps
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNYXM")).default), {
                isEnabled: this.onValueContainerClick,
                onMouseDown: this.onValueContainerClick
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).ValueContainer, props, this.renderChildren()));
        }
    }
});
parcelRegister("jNYXM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4661c12157fe2c0e$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $4661c12157fe2c0e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $4661c12157fe2c0e$var$_ref = {
        name: "1ff36h2",
        styles: "flex-grow:1"
    };
    const $4661c12157fe2c0e$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
        return isEnabled ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $4661c12157fe2c0e$var$_ref,
            onMouseDown: onMouseDown
        }, children) : children;
    };
    var $4661c12157fe2c0e$export$2e2bcd8739ae039 = $4661c12157fe2c0e$var$ValueContainerWrapper;
});
parcelRegister("3QONt", function(module, exports) {
    $parcel$export(module.exports, "Option", ()=>$99bbff5d4b124ec0$export$36d18380658d5d20);
    var $dC5iT;
    var $bChGW;
    var $3bDjY;
    var $5uXOq = parcelRequire("5uXOq");
    var $7SChb;
    var $IMPHa;
    var $8QliZ;
    var $jC9IK;
    var $3SqqV;
    var $f4ndh;
    var $3smIt;
    var $M0UM1;
    const $99bbff5d4b124ec0$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7SChb")).UserOption), {
            user: data,
            status: status,
            isSelected: isSelected
        });
    const $99bbff5d4b124ec0$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
        if ((0, (0, parcelRequire("3smIt")).isExternalUser)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("IMPHa")).default), {
            user: data,
            status: status,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("3smIt")).isUser)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7SChb")).UserOption), {
            user: data,
            status: status,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("3smIt")).isEmail)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3SqqV")).default), {
            email: data,
            emailValidity: (0, (0, parcelRequire("M0UM1")).isValidEmail)(data.id),
            isSelected: isSelected,
            label: selectProps.emailLabel
        });
        if ((0, (0, parcelRequire("3smIt")).isTeam)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8QliZ")).default), {
            team: data,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("3smIt")).isGroup)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jC9IK")).default), {
            group: data,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("3smIt")).isCustom)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4ndh")).default), {
            data: data,
            isSelected: isSelected
        });
        return null;
    };
    const $99bbff5d4b124ec0$var$dataOptionWithTooltip = (props)=>{
        if (props.data?.data?.tooltip) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: props.data?.data?.tooltip
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), tooltipProps, $99bbff5d4b124ec0$var$dataOption(props)));
        return $99bbff5d4b124ec0$var$dataOption(props);
    };
    const $99bbff5d4b124ec0$export$36d18380658d5d20 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Option, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Suspense, {
            fallback: $99bbff5d4b124ec0$var$defaultOption(props)
        }, $99bbff5d4b124ec0$var$dataOptionWithTooltip(props)));
});
parcelRegister("7SChb", function(module, exports) {
    $parcel$export(module.exports, "UserOption", ()=>$f97ab606ddc0972b$export$8e59f78010871662);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $bfXHv;
    var $1Y8bw;
    var $5pJx4;
    var $3smIt;
    class $f97ab606ddc0972b$export$8e59f78010871662 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bfXHv")).AvatarItemOption), {
                avatar: this.renderAvatar(),
                lozenge: this.getLozengeProps(),
                isDisabled: this.props.user.isDisabled,
                primaryText: this.getPrimaryText(),
                secondaryText: this.renderSecondaryText()
            });
        }
        constructor(...args){
            super(...args), this.getPrimaryText = ()=>{
                const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
                const result = [
                    (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                        key: "name",
                        css: (0, (0, parcelRequire("bfXHv")).textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`)
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1Y8bw")).HighlightText), {
                        highlights: highlight && highlight.name
                    }, name))
                ];
                if ((0, (0, parcelRequire("3smIt")).hasValue)(publicName) && name.trim() !== publicName.trim()) result.push((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                    key: "publicName"
                }, ' ', (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: (0, (0, parcelRequire("bfXHv")).textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
                }, "(", (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1Y8bw")).HighlightText), {
                    highlights: highlight && highlight.publicName
                }, publicName), ")")));
                return result;
            }, this.renderSecondaryText = ()=>this.props.user.byline ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: (0, (0, parcelRequire("bfXHv")).textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
                }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
                const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5pJx4")).SizeableAvatar), {
                    appearance: "big",
                    src: avatarUrl,
                    presence: status
                });
            }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                    text: this.props.user.lozenge
                } : this.props.user.lozenge;
        }
    }
});
parcelRegister("bfXHv", function(module, exports) {
    $parcel$export(module.exports, "textWrapper", ()=>$9d51fec62de0f8e9$export$aa6223da92b253dd);
    $parcel$export(module.exports, "AvatarItemOption", ()=>$9d51fec62de0f8e9$export$164a9d9b3b86dd0c);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $lj8SI;
    var $3smIt;
    function $9d51fec62de0f8e9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9d51fec62de0f8e9$var$AsyncTooltip = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("inSCC")).then((module)=>{
            return {
                default: module.default
            };
        }));
    const $9d51fec62de0f8e9$var$wrapper = (isDisabled)=>(0, (0, parcelRequire("f8Sb3")).css)({
            alignItems: 'center',
            boxSizing: 'border-box',
            display: 'flex',
            lineHeight: 1,
            outline: 'none',
            margin: 0,
            width: '100%',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
        });
    const $9d51fec62de0f8e9$var$optionWrapper = {
        name: "yyrqoa",
        styles: "max-width:100%;min-width:0;flex:1 1 100%;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
    };
    const $9d51fec62de0f8e9$var$getTextStyle = (isSecondary)=>{
        const secondaryCssArgs = isSecondary ? {
            fontSize: '0.85em'
        } : {};
        return (0, (0, parcelRequire("f8Sb3")).css)({
            margin: 0,
            overflowX: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...secondaryCssArgs
        });
    };
    const $9d51fec62de0f8e9$var$additionalInfo = {
        name: "tjo4qw",
        styles: "float:right"
    };
    const $9d51fec62de0f8e9$export$aa6223da92b253dd = (color)=>(0, (0, parcelRequire("f8Sb3")).css)({
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'inline',
            color: color
        });
    const $9d51fec62de0f8e9$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
        const renderLozenge = ()=>{
            if ((0, (0, parcelRequire("3smIt")).isLozengeText)(lozenge)) {
                if (lozenge?.tooltip) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Suspense, {
                    fallback: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), lozenge, lozenge.text)
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($9d51fec62de0f8e9$var$AsyncTooltip, {
                    content: lozenge.tooltip
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), lozenge, lozenge.text)));
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), lozenge, lozenge.text);
            }
            return lozenge;
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $9d51fec62de0f8e9$var$wrapper(isDisabled)
        }, avatar, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9d51fec62de0f8e9$var$optionWrapper
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9d51fec62de0f8e9$var$getTextStyle()
        }, primaryText), secondaryText && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9d51fec62de0f8e9$var$getTextStyle(true)
        }, secondaryText))), lozenge && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9d51fec62de0f8e9$var$additionalInfo
        }, renderLozenge())));
    };
});
parcelRegister("1Y8bw", function(module, exports) {
    $parcel$export(module.exports, "HighlightText", ()=>$dbc13bb98bfc2c59$export$bb02e7bc6e1a7119);
    var $5uXOq = parcelRequire("5uXOq");
    class $dbc13bb98bfc2c59$export$bb02e7bc6e1a7119 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { children: children, highlights: highlights } = this.props;
            const parts = [];
            let lastIndex = 0;
            if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
                const lastHighlight = highlights[highlights.length - 1];
                if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
                if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
                return highlights;
            }, []).forEach((highlight)=>{
                const { start: start, end: end } = highlight;
                if (start >= end) return;
                if (start > lastIndex) parts.push({
                    value: children.substring(lastIndex, start),
                    matches: false
                });
                parts.push({
                    value: children.substring(start, end + 1),
                    matches: true
                });
                lastIndex = end + 1;
            });
            if (lastIndex < children.length) parts.push({
                value: children.substring(lastIndex, children.length),
                matches: false
            });
            return parts.map((part, index)=>{
                if (part.matches) return (0, ($parcel$interopDefault($5uXOq))).createElement("b", {
                    key: index
                }, part.value);
                return part.value;
            });
        }
    }
});
parcelRegister("IMPHa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$244ad38dc6a6e0e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $244ad38dc6a6e0e3$var$AsyncExternalUserOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("8ED06")).then((module)=>{
            return {
                default: module.ExternalUserOption
            };
        }));
    var $244ad38dc6a6e0e3$export$2e2bcd8739ae039 = $244ad38dc6a6e0e3$var$AsyncExternalUserOption;
});
parcelRegister("8ED06", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7GjMk")
    ]).then(()=>parcelRequire('358Ik'));
});
parcelRegister("8QliZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e55a6473b89765e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $6e55a6473b89765e$var$AsyncTeamOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("aepOh")).then((module)=>{
            return {
                default: module.TeamOption
            };
        }));
    var $6e55a6473b89765e$export$2e2bcd8739ae039 = $6e55a6473b89765e$var$AsyncTeamOption;
});
parcelRegister("aepOh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bmRp3").then(()=>parcelRequire('8Pt0F'));
});
parcelRegister("jC9IK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d883d47691bcfd0f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $d883d47691bcfd0f$var$AsyncGroupOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("i1qww")).then((module)=>{
            return {
                default: module.GroupOption
            };
        }));
    var $d883d47691bcfd0f$export$2e2bcd8739ae039 = $d883d47691bcfd0f$var$AsyncGroupOption;
});
parcelRegister("i1qww", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("mdJEp").then(()=>parcelRequire('ctysX'));
});
parcelRegister("3SqqV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$120c09dc4c3dec5f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $120c09dc4c3dec5f$var$AsyncEmailOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("bng6R")).then((module)=>{
            return {
                default: module.EmailOption
            };
        }));
    var $120c09dc4c3dec5f$export$2e2bcd8739ae039 = $120c09dc4c3dec5f$var$AsyncEmailOption;
});
parcelRegister("bng6R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("AE9nS").then(()=>parcelRequire('4CChz'));
});
parcelRegister("f4ndh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57cc7ffb924c0e65$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $57cc7ffb924c0e65$var$AsyncCustomOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("3UNwy")).then((module)=>{
            return {
                default: module.CustomOption
            };
        }));
    var $57cc7ffb924c0e65$export$2e2bcd8739ae039 = $57cc7ffb924c0e65$var$AsyncCustomOption;
});
parcelRegister("3UNwy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lQtwe").then(()=>parcelRequire('iphiD'));
});
parcelRegister("M0UM1", function(module, exports) {
    $parcel$export(module.exports, "isValidEmail", ()=>$8e40db00ccd032ac$export$371e338370561054);
    const $8e40db00ccd032ac$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
    const $8e40db00ccd032ac$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
    const $8e40db00ccd032ac$export$371e338370561054 = (inputText)=>{
        if (inputText.match($8e40db00ccd032ac$var$validRegex)) return 'VALID';
        if (inputText.match($8e40db00ccd032ac$var$potentialRegex)) return 'POTENTIAL';
        return 'INVALID';
    };
});
parcelRegister("6Kkci", function(module, exports) {
    $parcel$export(module.exports, "SingleValue", ()=>$667e1159563155af$export$1949dac661ba6e3a);
    var $7sUFC;
    var $f8Sb3;
    var $bChGW;
    var $5pJx4;
    var $3smIt;
    var $fuhQD;
    var $VSDnB;
    var $f5TWP;
    const $667e1159563155af$var$avatarItemComponent = (0, (0, parcelRequire("f8Sb3")).css)({
        border: 'none !important',
        padding: `${"var(--ds-space-0, 0px)"} !important`,
        width: 'auto',
        overflow: 'hidden',
        minWidth: '100px',
        '& > span': {
            boxSizing: 'border-box'
        },
        '&:hover': {
            width: 'auto',
            padding: 0,
            border: 'none'
        }
    });
    const $667e1159563155af$var$ElementAfter = (props)=>{
        const { data: { data: data } } = props;
        if ((0, (0, parcelRequire("3smIt")).isTeam)(data) && data.verified) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fuhQD")).VerifiedTeamIcon), {
            size: "small"
        });
        return null;
    };
    const $667e1159563155af$export$1949dac661ba6e3a = (props)=>{
        const { data: { label: label, data: data }, selectProps: { appearance: appearance, isFocused: isFocused } } = props;
        return !isFocused ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).SingleValue, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7sUFC")).default), {
            backgroundColor: "transparent",
            avatar: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5pJx4")).SizeableAvatar), {
                src: (0, (0, parcelRequire("3smIt")).getAvatarUrl)(data),
                appearance: appearance,
                type: (0, (0, parcelRequire("3smIt")).isTeam)(data) && (0, (0, parcelRequire("VSDnB")).fg)('verified-team-in-user-picker') ? 'team' : 'person'
            }),
            primaryText: (0, (0, parcelRequire("VSDnB")).fg)('verified-team-in-user-picker') ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                alignBlock: "center"
            }, label, (0, (0, parcelRequire("f8Sb3")).jsx)($667e1159563155af$var$ElementAfter, props)) : label
        }, ({ ref: ref, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $667e1159563155af$var$avatarItemComponent,
                ...props
            }))) : null;
    };
});
parcelRegister("7sUFC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fee6a3655f9d2d5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $cgL5K;
    var $k5uoT;
    var $vIiRg;
    var $kyyq3;
    function $0fee6a3655f9d2d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0fee6a3655f9d2d5$var$avatarItemStyles = {
        name: "1dq1lfl",
        styles: "min-width:0;max-width:100%;flex:1 1 100%;line-height:1.4;padding-inline-start:var(--ds-space-100, 8px)"
    };
    const $0fee6a3655f9d2d5$var$secondaryTextOldStyles = {
        name: "1udad45",
        styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.85em"
    };
    const $0fee6a3655f9d2d5$var$baseTextStyles = {
        name: "1sodx6b",
        styles: "display:block;color:var(--ds-text, #172B4D)"
    };
    const $0fee6a3655f9d2d5$var$truncationStyles = {
        name: "n3ut7m",
        styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $0fee6a3655f9d2d5$var$getStyles = (css, { backgroundColor: backgroundColor, isInteractive: isInteractive, isDisabled: isDisabled })=>css`
		align-items: center;
		background-color: ${backgroundColor};
		border-radius: ${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px;
		border: ${0, (0, parcelRequire("vIiRg")).BORDER_WIDTH}px solid transparent;
		box-sizing: border-box;
		color: inherit;
		display: flex;
		font-size: inherit;
		font-style: normal;
		font-weight: normal;
		line-height: 1;
		outline: none;
		margin: ${"var(--ds-space-0, 0px)"};
		padding: ${"var(--ds-space-050, 4px)"};
		text-align: left;
		text-decoration: none;
		width: 100%;

		${isInteractive && `
        :hover {
          background-color: ${`var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`};
          cursor: pointer;
          text-decoration: none;
        }

        :focus {
          outline: none;
          border-color: ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`};
        }

        :active {
          background-color: ${`var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$226de0355ed012f8})`};
        }
      `}

		${isDisabled && `
        cursor: not-allowed;
        opacity: ${"var(--ds-opacity-disabled, 0.5)"};
        pointer-events: none;
      `}
	`;
    const $0fee6a3655f9d2d5$var$AvatarItem = (0, $5uXOq.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', children: children, isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
        const getTestId = (testId, children)=>!children ? {
                'data-testid': `${testId}--itemInner`
            } : {
                testId: `${testId}--itemInner`
            };
        const componentProps = ()=>{
            if (isDisabled) return {
                disabled: true
            };
            return {
                ...href && (0, (0, parcelRequire("kyyq3")).getLinkProps)(href, target),
                ...onClick && !href ? (0, (0, parcelRequire("kyyq3")).getButtonProps)(onClick) : {
                    onClick: onClick
                }
            };
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f8Sb3")).ClassNames), null, ({ css: css })=>{
            const props = {
                ref: ref,
                className: $0fee6a3655f9d2d5$var$getStyles(css, {
                    backgroundColor: backgroundColor,
                    isInteractive: Boolean(onClick || href),
                    isDisabled: isDisabled
                }),
                ...componentProps(),
                ...testId && getTestId(testId, children),
                ...(onClick || href) && {
                    'aria-label': label
                },
                children: (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, avatar, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: $0fee6a3655f9d2d5$var$avatarItemStyles
                }, (0, (0, parcelRequire("VSDnB")).fg)('platform.design-system-team.avatar-item-font-size_830x6') ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
                    maxLines: isTruncationDisabled ? undefined : 1
                }, primaryText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
                    color: "color.text.subtlest",
                    maxLines: isTruncationDisabled ? undefined : 1,
                    size: "UNSAFE_small"
                }, secondaryText)) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: [
                        $0fee6a3655f9d2d5$var$baseTextStyles,
                        !isTruncationDisabled && $0fee6a3655f9d2d5$var$truncationStyles
                    ]
                }, primaryText), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: [
                        $0fee6a3655f9d2d5$var$baseTextStyles,
                        $0fee6a3655f9d2d5$var$secondaryTextOldStyles,
                        !isTruncationDisabled && $0fee6a3655f9d2d5$var$truncationStyles
                    ]
                }, secondaryText))))
            };
            return children ? children(props) : (0, $5uXOq.createElement)((0, (0, parcelRequire("kyyq3")).getCustomElement)(isDisabled, href, onClick), props);
        });
    });
    $0fee6a3655f9d2d5$var$AvatarItem.displayName = 'AvatarItem';
    var $0fee6a3655f9d2d5$export$2e2bcd8739ae039 = $0fee6a3655f9d2d5$var$AvatarItem;
});
parcelRegister("OxpB4", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$98c53988263e2c5c$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    class $98c53988263e2c5c$export$f5b8910cec6cf069 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        get ariaLabelledBy() {
            return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
        }
        get ariaDescribedBy() {
            return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
                ...this.props,
                "aria-labelledby": this.ariaLabelledBy,
                "aria-describedby": this.ariaDescribedBy,
                innerRef: this.props.innerRef,
                onKeyPress: this.handleKeyPress
            });
        }
        constructor(...args){
            super(...args), this.handleKeyPress = (e)=>{
                if (e.key === 'Enter') e.preventDefault();
                if (this.props.selectProps?.disableInput) e.preventDefault();
            };
        }
    }
});
parcelRegister("ee8bl", function(module, exports) {
    $parcel$export(module.exports, "SingleValueContainer", ()=>$bd8914f05f01f9cc$export$afa5f855316c6a48);
    var $bChGW;
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $5pJx4;
    var $2wgOn;
    var $jNYXM;
    function $bd8914f05f01f9cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bd8914f05f01f9cc$var$placeholderIconContainer = (0, (0, parcelRequire("f8Sb3")).css)({
        paddingLeft: (0, (0, parcelRequire("2wgOn")).BORDER_PADDING),
        lineHeight: 0,
        gridArea: '1/1/2/2'
    });
    const $bd8914f05f01f9cc$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
    var $bd8914f05f01f9cc$var$_ref = {
        name: "1ff36h2",
        styles: "flex-grow:1"
    };
    class $bd8914f05f01f9cc$export$afa5f855316c6a48 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { children: children, ...valueContainerProps } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jNYXM")).default), {
                isEnabled: this.onValueContainerClick,
                onMouseDown: this.onValueContainerClick
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ValueContainer, valueContainerProps, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $bd8914f05f01f9cc$var$placeholderIconContainer
            }, this.renderAvatar()), children));
        }
        constructor(...args){
            super(...args), this.renderAvatar = ()=>{
                const { hasValue: hasValue, selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
                if (isFocused || !hasValue) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5pJx4")).SizeableAvatar), {
                    appearance: appearance,
                    type: placeholderAvatar,
                    src: $bd8914f05f01f9cc$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
                });
                return null;
            }, this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
                return this.onValueContainerClick ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: $bd8914f05f01f9cc$var$_ref,
                    onMouseDown: this.onValueContainerClick
                }, children) : children;
            };
        }
    }
});
parcelRegister("h3ej5", function(module, exports) {
    $parcel$export(module.exports, "PopupInput", ()=>$be92b88945d06137$export$d8edbfd510a7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $OxpB4;
    class $be92b88945d06137$export$d8edbfd510a7db82 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidMount() {
            if (this.ref) this.ref.select();
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("OxpB4")).Input), {
                ...this.props,
                innerRef: this.handleInnerRef
            });
        }
        constructor(...args){
            super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
                this.ref = ref;
                if (this.props.innerRef) this.props.innerRef(ref);
            };
        }
    }
});
parcelRegister("6Ks8i", function(module, exports) {
    $parcel$export(module.exports, "PopupControl", ()=>$77b9c0d4ebdf44c2$export$a0cb1b4352357fcc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    var $f8Sb3;
    const $77b9c0d4ebdf44c2$var$spacing = 8;
    const $77b9c0d4ebdf44c2$var$fontSize = 12;
    const $77b9c0d4ebdf44c2$var$innerHeight = $77b9c0d4ebdf44c2$var$spacing * 2;
    const $77b9c0d4ebdf44c2$var$lineHeight = $77b9c0d4ebdf44c2$var$innerHeight / $77b9c0d4ebdf44c2$var$fontSize;
    const $77b9c0d4ebdf44c2$var$controlWrapper = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        flexDirection: 'column',
        padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    });
    const $77b9c0d4ebdf44c2$var$getLabelStyle = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
            fontSize: `${$77b9c0d4ebdf44c2$var$fontSize}px`,
            fontWeight: 600,
            lineHeight: `${$77b9c0d4ebdf44c2$var$lineHeight}`,
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingLeft: "var(--ds-space-0, 0px)",
            paddingRight: "var(--ds-space-0, 0px)",
            paddingTop: "var(--ds-space-250, 20px)"
        });
    class $77b9c0d4ebdf44c2$export$a0cb1b4352357fcc extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { selectProps: { popupTitle: popupTitle } } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $77b9c0d4ebdf44c2$var$controlWrapper
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $77b9c0d4ebdf44c2$var$getLabelStyle()
            }, popupTitle), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, this.props));
        }
    }
});
parcelRegister("lYehz", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$9f291598157d275c$export$d9b273488cd8ce6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    var $f8Sb3;
    const $9f291598157d275c$var$getFooterStyle = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)({
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
        });
    };
    class $9f291598157d275c$export$d9b273488cd8ce6f extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $9f291598157d275c$var$getFooterStyle()
            }, this.props.selectProps.footer));
        }
    }
});
parcelRegister("fuG1P", function(module, exports) {
    $parcel$export(module.exports, "getCreatableProps", ()=>$3865687a924ab788$export$36f97d8afa97203d);
    var $8QpSo;
    var $M0UM1;
    var $3smIt;
    const $3865687a924ab788$var$validOption = [
        'VALID',
        'POTENTIAL'
    ];
    const $3865687a924ab788$var$isValidNewOption = (isValidEmail = (0, (0, parcelRequire("M0UM1")).isValidEmail))=>(inputValue)=>inputValue && $3865687a924ab788$var$validOption.includes(isValidEmail(inputValue));
    const $3865687a924ab788$var$getNewOptionData = (inputValue)=>({
            label: inputValue,
            value: inputValue,
            data: {
                id: inputValue,
                name: inputValue,
                type: (0, $f93312f7d4958f08$export$6662b3461398ef8c)
            }
        });
    const $3865687a924ab788$var$formatCreateLabel = (inputText)=>{
        if (inputText) return inputText.trim();
        return '';
    };
    const $3865687a924ab788$var$isOptionDisabled = (isValidEmail = (0, (0, parcelRequire("M0UM1")).isValidEmail))=>(option)=>{
            if ((0, (0, parcelRequire("3smIt")).isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
            return !!option.isDisabled;
        };
    function $3865687a924ab788$var$creatableProps(isValidEmail) {
        return {
            allowCreateWhileLoading: true,
            createOptionPosition: 'first',
            isValidNewOption: $3865687a924ab788$var$isValidNewOption(isValidEmail),
            getNewOptionData: $3865687a924ab788$var$getNewOptionData,
            formatCreateLabel: $3865687a924ab788$var$formatCreateLabel,
            isOptionDisabled: $3865687a924ab788$var$isOptionDisabled(isValidEmail)
        };
    }
    const $3865687a924ab788$export$36f97d8afa97203d = (0, (0, parcelRequire("8QpSo")).default)($3865687a924ab788$var$creatableProps);
});
parcelRegister("hcX3V", function(module, exports) {
    $parcel$export(module.exports, "getCreatableSuggestedEmailProps", ()=>$fd587de6edc26aae$export$34b9dd2dd6a225e5);
    var $8QpSo;
    var $M0UM1;
    var $3smIt;
    const $fd587de6edc26aae$var$validOption = [
        'VALID',
        'POTENTIAL'
    ];
    const $fd587de6edc26aae$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
    const $fd587de6edc26aae$var$getNewOptionData = (isValidEmail = (0, (0, parcelRequire("M0UM1")).isValidEmail), emailDomain)=>(inputValue)=>{
            if (!inputValue) return null;
            const isEmail = inputValue && $fd587de6edc26aae$var$validOption.includes(isValidEmail(inputValue));
            const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
            return {
                label: value,
                value: value,
                data: {
                    id: value,
                    name: value,
                    type: (0, $f93312f7d4958f08$export$6662b3461398ef8c),
                    suggestion: true
                }
            };
        };
    const $fd587de6edc26aae$var$formatCreateLabel = (inputText)=>{
        if (inputText) return inputText.trim();
        return '';
    };
    const $fd587de6edc26aae$var$isOptionDisabled = (isValidEmail = (0, (0, parcelRequire("M0UM1")).isValidEmail))=>(option)=>{
            if ((0, (0, parcelRequire("3smIt")).isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
            return !!option.isDisabled;
        };
    const $fd587de6edc26aae$export$34b9dd2dd6a225e5 = (0, (0, parcelRequire("8QpSo")).default)((emailDomain, isValidEmail)=>({
            allowCreateWhileLoading: true,
            createOptionPosition: 'last',
            isValidNewOption: $fd587de6edc26aae$var$isValidNewOption,
            getNewOptionData: $fd587de6edc26aae$var$getNewOptionData(isValidEmail, emailDomain),
            formatCreateLabel: $fd587de6edc26aae$var$formatCreateLabel,
            isOptionDisabled: $fd587de6edc26aae$var$isOptionDisabled(isValidEmail)
        }));
});
parcelRegister("hrO1B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ce4a8fbf6631c4e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    var $55C8M;
    const $9ce4a8fbf6631c4e$var$EMPTY = {};
    const $9ce4a8fbf6631c4e$var$useI18n = (locale)=>{
        const [messages, setMessages] = (0, ($parcel$interopDefault($5uXOq))).useState($9ce4a8fbf6631c4e$var$EMPTY);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            let aborted = false;
            setMessages($9ce4a8fbf6631c4e$var$EMPTY);
            (0, (0, parcelRequire("55C8M")).getMessagesForLocale)(locale).then((messages)=>{
                if (!aborted) setMessages(messages);
            }).catch((error)=>{
                console.error(error);
            });
            return ()=>{
                aborted = true;
            };
        }, [
            locale
        ]);
        return messages;
    };
    const $9ce4a8fbf6631c4e$var$MessagesIntlProvider = (props)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { children: children } = props;
        const messages = $9ce4a8fbf6631c4e$var$useI18n(intl.locale);
        const mergedMessages = (0, $5uXOq.useMemo)(()=>{
            return {
                ...intl.messages,
                ...messages
            };
        }, [
            intl.messages,
            messages
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: intl.locale,
            messages: mergedMessages
        }, children);
    };
    var $9ce4a8fbf6631c4e$export$2e2bcd8739ae039 = $9ce4a8fbf6631c4e$var$MessagesIntlProvider;
});
parcelRegister("55C8M", function(module, exports) {
    $parcel$export(module.exports, "getMessagesForLocale", ()=>$0d1c237fd5360db1$export$d0a3169680473b6c);
    const $0d1c237fd5360db1$export$d0a3169680473b6c = async (locale)=>{
        switch(locale){
            case 'cs':
                return (parcelRequire("asouP")).then((mod)=>mod.default);
            case 'da':
                return (parcelRequire("gCFP1")).then((mod)=>mod.default);
            case 'de':
                return (parcelRequire("ctXnR")).then((mod)=>mod.default);
            case 'en':
                return (parcelRequire("dVeZ7")).then((mod)=>mod.default);
            case 'en_GB':
                return (parcelRequire("5wasS")).then((mod)=>mod.default);
            case 'en_ZZ':
                return (parcelRequire("kXvsh")).then((mod)=>mod.default);
            case 'es':
                return (parcelRequire("8wFHw")).then((mod)=>mod.default);
            case 'et':
                return (parcelRequire("42RiL")).then((mod)=>mod.default);
            case 'fi':
                return (parcelRequire("01V88")).then((mod)=>mod.default);
            case 'fr':
                return (parcelRequire("7OhhH")).then((mod)=>mod.default);
            case 'hu':
                return (parcelRequire("ekPaa")).then((mod)=>mod.default);
            case 'is':
                return (parcelRequire("cgaOk")).then((mod)=>mod.default);
            case 'it':
                return (parcelRequire("4Ijhe")).then((mod)=>mod.default);
            case 'ja':
                return (parcelRequire("iO6Ar")).then((mod)=>mod.default);
            case 'ko':
                return (parcelRequire("DNotf")).then((mod)=>mod.default);
            case 'nb':
                return (parcelRequire("h1BPr")).then((mod)=>mod.default);
            case 'nl':
                return (parcelRequire("32FdM")).then((mod)=>mod.default);
            case 'pl':
                return (parcelRequire("6anuW")).then((mod)=>mod.default);
            case 'pt_BR':
            case 'pt-BR':
                return (parcelRequire("coeB4")).then((mod)=>mod.default);
            case 'pt_PT':
            case 'pt-PT':
                return (parcelRequire("4OfGz")).then((mod)=>mod.default);
            case 'ro':
                return (parcelRequire("7jMxK")).then((mod)=>mod.default);
            case 'ru':
                return (parcelRequire("8oKS4")).then((mod)=>mod.default);
            case 'sk':
                return (parcelRequire("lRSYN")).then((mod)=>mod.default);
            case 'sv':
                return (parcelRequire("lfcui")).then((mod)=>mod.default);
            case 'th':
                return (parcelRequire("kC3tY")).then((mod)=>mod.default);
            case 'tr':
                return (parcelRequire("jRqJp")).then((mod)=>mod.default);
            case 'uk':
                return (parcelRequire("hXOFb")).then((mod)=>mod.default);
            case 'vi':
                return (parcelRequire("5mdNh")).then((mod)=>mod.default);
            case 'zh_TW':
                return (parcelRequire("cj5fC")).then((mod)=>mod.default);
            case 'zh':
                return (parcelRequire("kZyWC")).then((mod)=>mod.default);
            default:
                {
                    const fragments = locale.split(/[_-]/);
                    if (fragments.length === 2) return $0d1c237fd5360db1$export$d0a3169680473b6c(fragments[0]);
                    else return (parcelRequire("dVeZ7")).then((mod)=>mod.default);
                }
        }
    };
});
parcelRegister("asouP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5lpPT").then(()=>parcelRequire('gXZJY'));
});
parcelRegister("gCFP1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kfO0l").then(()=>parcelRequire('4a4Fm'));
});
parcelRegister("ctXnR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("e7FWi").then(()=>parcelRequire('l8jlf'));
});
parcelRegister("dVeZ7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("auLKS").then(()=>parcelRequire('8JpVG'));
});
parcelRegister("5wasS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3W1ZK").then(()=>parcelRequire('e3biM'));
});
parcelRegister("kXvsh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Tlspk").then(()=>parcelRequire('dnuc7'));
});
parcelRegister("8wFHw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5X8ey").then(()=>parcelRequire('l3vqz'));
});
parcelRegister("42RiL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bmWXN").then(()=>parcelRequire('4oZES'));
});
parcelRegister("01V88", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bI4uf").then(()=>parcelRequire('2WBzr'));
});
parcelRegister("7OhhH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2H83s").then(()=>parcelRequire('bfZBm'));
});
parcelRegister("ekPaa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lUuxE").then(()=>parcelRequire('1tcJ6'));
});
parcelRegister("cgaOk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eN4os").then(()=>parcelRequire('4duqz'));
});
parcelRegister("4Ijhe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gvuTb").then(()=>parcelRequire('dizwu'));
});
parcelRegister("iO6Ar", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2Li3C").then(()=>parcelRequire('9N5CX'));
});
parcelRegister("DNotf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bh153").then(()=>parcelRequire('aZBlm'));
});
parcelRegister("h1BPr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gdZbx").then(()=>parcelRequire('fGwOM'));
});
parcelRegister("32FdM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aMnvr").then(()=>parcelRequire('NLRKB'));
});
parcelRegister("6anuW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("b7E7V").then(()=>parcelRequire('cHWkp'));
});
parcelRegister("coeB4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bCfU6").then(()=>parcelRequire('d6RJ6'));
});
parcelRegister("4OfGz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5b76P").then(()=>parcelRequire('bPIQC'));
});
parcelRegister("7jMxK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4Qca8").then(()=>parcelRequire('foWaf'));
});
parcelRegister("8oKS4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8ExDS").then(()=>parcelRequire('d41ym'));
});
parcelRegister("lRSYN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("57IRb").then(()=>parcelRequire('77rKe'));
});
parcelRegister("lfcui", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6iyhv").then(()=>parcelRequire('lwY85'));
});
parcelRegister("kC3tY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6FMDk").then(()=>parcelRequire('j3ZnO'));
});
parcelRegister("jRqJp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6583j").then(()=>parcelRequire('I9Pmk'));
});
parcelRegister("hXOFb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hdz1o").then(()=>parcelRequire('h4y14'));
});
parcelRegister("5mdNh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jefTP").then(()=>parcelRequire('6gWmN'));
});
parcelRegister("cj5fC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("j2uQo").then(()=>parcelRequire('haTkv'));
});
parcelRegister("kZyWC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("afbbf").then(()=>parcelRequire('lbgbB'));
});
parcelRegister("2vFqP", function(module, exports) {
    $parcel$export(module.exports, "ExusUserSourceProvider", ()=>$4629e0617f660bbc$export$bcd5c65b586ee3c3);
    $parcel$export(module.exports, "useUserSource", ()=>$4629e0617f660bbc$export$c6c0c1a2bac363f);
    var $5uXOq = parcelRequire("5uXOq");
    const $4629e0617f660bbc$var$ExusUserSourceContext = (0, $5uXOq.createContext)({});
    const $4629e0617f660bbc$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($4629e0617f660bbc$var$ExusUserSourceContext.Provider, {
            value: {
                fetchUserSource: fetchUserSource
            }
        }, children);
    const $4629e0617f660bbc$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
        const { fetchUserSource: fetchUserSource } = (0, $5uXOq.useContext)($4629e0617f660bbc$var$ExusUserSourceContext);
        const [externalSources, setExternalSources] = (0, $5uXOq.useState)([]);
        const [loading, setLoading] = (0, $5uXOq.useState)(true);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const abortController = (0, $5uXOq.useMemo)(()=>{
            if (typeof AbortController === 'undefined') return;
            return new AbortController();
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            let isMounted = true;
            const cleanup = ()=>{
                abortController?.abort();
                isMounted = false;
            };
            if (!fetchUserSource || !shouldFetchSources) {
                setLoading(false);
                return cleanup;
            }
            fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
                if (!isMounted) return;
                setLoading(false);
                const externalSourceTypes = externalSources.map((source)=>source.sourceType);
                setExternalSources(externalSourceTypes);
            }).catch((error)=>{
                if (!isMounted) return;
                setLoading(false);
                setError(error);
            });
            return cleanup;
        }, [
            fetchUserSource,
            accountId,
            abortController,
            shouldFetchSources
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                sources: Array.from(new Set([
                    ...existingSources ?? [],
                    ...externalSources
                ])),
                loading: loading,
                error: error
            }), [
            error,
            existingSources,
            externalSources,
            loading
        ]);
    };
});
parcelRegister("4Mwus", function(module, exports) {
    $parcel$export(module.exports, "createAndFireEventInElementsChannel", ()=>$e9f71e1c1698f563$export$53eef0dcd9611650);
    $parcel$export(module.exports, "preparedUsersLoadedEvent", ()=>$e9f71e1c1698f563$export$185f4c3d9b7ef9bf);
    $parcel$export(module.exports, "mountedWithPrefetchEvent", ()=>$e9f71e1c1698f563$export$9cfb4251e50d7b91);
    $parcel$export(module.exports, "filterUsersEvent", ()=>$e9f71e1c1698f563$export$fbba77127d7cb173);
    $parcel$export(module.exports, "requestUsersEvent", ()=>$e9f71e1c1698f563$export$1762ed8845ff2d9b);
    $parcel$export(module.exports, "successfulRequestUsersEvent", ()=>$e9f71e1c1698f563$export$bfc020018aa738d0);
    $parcel$export(module.exports, "failedRequestUsersEvent", ()=>$e9f71e1c1698f563$export$738aca68b593db8e);
    var $gB4mS;
    var $7Jxgt = parcelRequire("7Jxgt");
    const $e9f71e1c1698f563$var$packageName = "platform-pkg";
    const $e9f71e1c1698f563$var$packageVersion = "0.0.0-use.local";
    const $e9f71e1c1698f563$export$c0d84948cecf78d8 = ()=>({
            id: (0, $7Jxgt.v4)(),
            start: Date.now(),
            inputChangeTime: Date.now(),
            upCount: 0,
            downCount: 0,
            lastKey: undefined
        });
    const $e9f71e1c1698f563$export$53eef0dcd9611650 = (0, (0, parcelRequire("gB4mS")).default)('fabric-elements');
    const $e9f71e1c1698f563$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
            eventType: eventType,
            action: action,
            actionSubject: actionSubject,
            attributes: {
                packageName: $e9f71e1c1698f563$var$packageName,
                packageVersion: $e9f71e1c1698f563$var$packageVersion,
                ...attributes
            }
        });
    const $e9f71e1c1698f563$var$createDefaultSmartPickerAttributes = (props, state)=>{
        const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
        const { sessionId: sessionId, query: query } = state;
        const maxNumberOfResults = maxOptions || 100;
        return {
            context: fieldId,
            childObjectId: childObjectId,
            containerId: containerId,
            hasFilterOptions: Boolean(filterOptions),
            includeTeams: includeTeams,
            maxNumberOfResults: maxNumberOfResults,
            objectId: objectId,
            prefetch: prefetch,
            principalId: principalId,
            productKey: productKey,
            queryLength: (query || '').length,
            siteId: siteId,
            orgId: orgId,
            sessionId: sessionId
        };
    };
    const $e9f71e1c1698f563$var$createSmartUserPickerEvent = (action, actionSubect, attributes = {})=>({
            source: 'smart-user-picker',
            ...$e9f71e1c1698f563$var$createEvent('operational', action, actionSubect, attributes)
        });
    const $e9f71e1c1698f563$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>$e9f71e1c1698f563$var$createSmartUserPickerEvent('loaded', 'preparedUsers', {
            ...$e9f71e1c1698f563$var$createDefaultSmartPickerAttributes(props, state),
            ...attributes
        });
    const $e9f71e1c1698f563$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>$e9f71e1c1698f563$var$createSmartUserPickerEvent('mounted', 'prefetch', {
            ...$e9f71e1c1698f563$var$createDefaultSmartPickerAttributes(props, state),
            ...attributes
        });
    const $e9f71e1c1698f563$export$fbba77127d7cb173 = (props, state, attributes = {})=>$e9f71e1c1698f563$var$createSmartUserPickerEvent('filtered', 'users', {
            ...$e9f71e1c1698f563$var$createDefaultSmartPickerAttributes(props, state),
            ...attributes
        });
    const $e9f71e1c1698f563$export$1762ed8845ff2d9b = (props, state, attributes = {})=>$e9f71e1c1698f563$var$createSmartUserPickerEvent('requested', 'users', {
            ...$e9f71e1c1698f563$var$createDefaultSmartPickerAttributes(props, state),
            ...attributes
        });
    const $e9f71e1c1698f563$export$bfc020018aa738d0 = (props, state, attributes = {})=>$e9f71e1c1698f563$var$createSmartUserPickerEvent('successful', 'usersRequest', {
            ...$e9f71e1c1698f563$var$createDefaultSmartPickerAttributes(props, state),
            ...attributes
        });
    const $e9f71e1c1698f563$export$738aca68b593db8e = (props, state, attributes = {})=>$e9f71e1c1698f563$var$createSmartUserPickerEvent('failed', 'usersRequest', {
            ...$e9f71e1c1698f563$var$createDefaultSmartPickerAttributes(props, state),
            ...attributes
        });
});
parcelRegister("lO1N9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56606639d6bbed24$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $i5FdW;
    var $j8CnN;
    const $56606639d6bbed24$var$EMPTY = {};
    const $56606639d6bbed24$var$useI18n = (locale)=>{
        const [messages, setMessages] = (0, ($parcel$interopDefault($5uXOq))).useState($56606639d6bbed24$var$EMPTY);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            let aborted = false;
            setMessages($56606639d6bbed24$var$EMPTY);
            (0, (0, parcelRequire("j8CnN")).getMessagesForLocale)(locale).then((messages)=>{
                if (!aborted) setMessages(messages);
            }).catch((error)=>{
                console.error(error);
            });
            return ()=>{
                aborted = true;
            };
        }, [
            locale
        ]);
        return messages;
    };
    const $56606639d6bbed24$var$MessagesIntlProvider = (props)=>{
        const { intl: intl, children: children } = props;
        const messages = $56606639d6bbed24$var$useI18n(intl.locale);
        const mergedMessages = (0, $5uXOq.useMemo)(()=>{
            return {
                ...intl.messages,
                ...messages
            };
        }, [
            intl.messages,
            messages
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: intl.locale,
            messages: mergedMessages
        }, children);
    };
    var $56606639d6bbed24$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($56606639d6bbed24$var$MessagesIntlProvider);
});
parcelRegister("j8CnN", function(module, exports) {
    $parcel$export(module.exports, "getMessagesForLocale", ()=>$2d5115da3ffac2ef$export$d0a3169680473b6c);
    const $2d5115da3ffac2ef$export$d0a3169680473b6c = async (locale)=>{
        switch(locale){
            case 'cs':
                return (parcelRequire("82ALw")).then((mod)=>mod.default);
            case 'da':
                return (parcelRequire("fEVHl")).then((mod)=>mod.default);
            case 'de':
                return (parcelRequire("jIU4p")).then((mod)=>mod.default);
            case 'en':
                return (parcelRequire("1juPw")).then((mod)=>mod.default);
            case 'en_GB':
                return (parcelRequire("85s3M")).then((mod)=>mod.default);
            case 'es':
                return (parcelRequire("aFLWs")).then((mod)=>mod.default);
            case 'et':
                return (parcelRequire("9fIQo")).then((mod)=>mod.default);
            case 'fi':
                return (parcelRequire("8KCpd")).then((mod)=>mod.default);
            case 'fr':
                return (parcelRequire("8j3No")).then((mod)=>mod.default);
            case 'hu':
                return (parcelRequire("h2n5o")).then((mod)=>mod.default);
            case 'is':
                return (parcelRequire("9vbw1")).then((mod)=>mod.default);
            case 'it':
                return (parcelRequire("98NGq")).then((mod)=>mod.default);
            case 'ja':
                return (parcelRequire("6mRZR")).then((mod)=>mod.default);
            case 'ko':
                return (parcelRequire("apOek")).then((mod)=>mod.default);
            case 'nb':
                return (parcelRequire("O2H51")).then((mod)=>mod.default);
            case 'nl':
                return (parcelRequire("19T2B")).then((mod)=>mod.default);
            case 'pl':
                return (parcelRequire("iB186")).then((mod)=>mod.default);
            case 'pt_BR':
            case 'pt-BR':
                return (parcelRequire("a8z3j")).then((mod)=>mod.default);
            case 'pt_PT':
            case 'pt-PT':
                return (parcelRequire("lKkun")).then((mod)=>mod.default);
            case 'ro':
                return (parcelRequire("kplbl")).then((mod)=>mod.default);
            case 'ru':
                return (parcelRequire("aZMac")).then((mod)=>mod.default);
            case 'sk':
                return (parcelRequire("4TvIC")).then((mod)=>mod.default);
            case 'sv':
                return (parcelRequire("9ffZP")).then((mod)=>mod.default);
            case 'th':
                return (parcelRequire("6eJc6")).then((mod)=>mod.default);
            case 'tr':
                return (parcelRequire("1exEk")).then((mod)=>mod.default);
            case 'uk':
                return (parcelRequire("9PG2W")).then((mod)=>mod.default);
            case 'vi':
                return (parcelRequire("359Tn")).then((mod)=>mod.default);
            case 'zh_TW':
                return (parcelRequire("9CxFB")).then((mod)=>mod.default);
            case 'zh':
                return (parcelRequire("j8F8a")).then((mod)=>mod.default);
            default:
                {
                    const fragments = locale.split(/[_-]/);
                    if (fragments.length === 2) return $2d5115da3ffac2ef$export$d0a3169680473b6c(fragments[0]);
                    else return (parcelRequire("1juPw")).then((mod)=>mod.default);
                }
        }
    };
});
parcelRegister("82ALw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ceBcy").then(()=>parcelRequire('hTttX'));
});
parcelRegister("fEVHl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gehQ4").then(()=>parcelRequire('fO125'));
});
parcelRegister("jIU4p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bARdr").then(()=>parcelRequire('i9hQB'));
});
parcelRegister("1juPw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8DJr1").then(()=>parcelRequire('fbTE6'));
});
parcelRegister("85s3M", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("l5qiV").then(()=>parcelRequire('2jzdD'));
});
parcelRegister("aFLWs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5CtwW").then(()=>parcelRequire('9zjC3'));
});
parcelRegister("9fIQo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2dKZG").then(()=>parcelRequire('3f70t'));
});
parcelRegister("8KCpd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dJtYV").then(()=>parcelRequire('kK8ZL'));
});
parcelRegister("8j3No", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5Lcol").then(()=>parcelRequire('lGM67'));
});
parcelRegister("h2n5o", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gMIbU").then(()=>parcelRequire('jXmR0'));
});
parcelRegister("9vbw1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6XTUE").then(()=>parcelRequire('47jiC'));
});
parcelRegister("98NGq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8689w").then(()=>parcelRequire('lzA6o'));
});
parcelRegister("6mRZR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cn1mf").then(()=>parcelRequire('hsl5L'));
});
parcelRegister("apOek", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ebSnr").then(()=>parcelRequire('l7zWx'));
});
parcelRegister("O2H51", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5930M").then(()=>parcelRequire('hbdA6'));
});
parcelRegister("19T2B", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6jYea").then(()=>parcelRequire('7V1eq'));
});
parcelRegister("iB186", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9i5Df").then(()=>parcelRequire('dyLwU'));
});
parcelRegister("a8z3j", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bi5ml").then(()=>parcelRequire('jHvZz'));
});
parcelRegister("lKkun", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("MAnZb").then(()=>parcelRequire('98VHa'));
});
parcelRegister("kplbl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jUUl6").then(()=>parcelRequire('3jBFZ'));
});
parcelRegister("aZMac", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dpQnt").then(()=>parcelRequire('bxjPN'));
});
parcelRegister("4TvIC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jvGnQ").then(()=>parcelRequire('9rrms'));
});
parcelRegister("9ffZP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cDMIN").then(()=>parcelRequire('fcT12'));
});
parcelRegister("6eJc6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4yYP5").then(()=>parcelRequire('aEMJ7'));
});
parcelRegister("1exEk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("itcmU").then(()=>parcelRequire('iMCZJ'));
});
parcelRegister("9PG2W", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9MbCL").then(()=>parcelRequire('3fBNA'));
});
parcelRegister("359Tn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8jDvM").then(()=>parcelRequire('XsSGE'));
});
parcelRegister("9CxFB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("195SC").then(()=>parcelRequire('gyRwx'));
});
parcelRegister("j8F8a", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4uT2A").then(()=>parcelRequire('8nTzb'));
});
parcelRegister("3Q8Js", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94c7434acb15702b$export$2e2bcd8739ae039);
    var $f5wjp;
    var $lrQGi;
    const $94c7434acb15702b$var$getUserRecommendations = (request, intl)=>{
        const url = (0, (0, parcelRequire("lrQGi")).config).getRecommendationServiceUrl(request.baseUrl || '');
        return fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                context: request.context,
                includeUsers: request.includeUsers,
                includeGroups: request.includeGroups,
                includeTeams: request.includeTeams,
                includeNonLicensedUsers: request.includeNonLicensedUsers,
                maxNumberOfResults: request.maxNumberOfResults,
                performSearchQueryOnly: false,
                searchQuery: {
                    cpusQueryHighlights: {
                        query: '',
                        field: ''
                    },
                    ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                        productAccessPermissionIds: [
                            'write',
                            'external-collaborator-write'
                        ]
                    },
                    customQuery: '',
                    customerDirectoryId: '',
                    filter: request.searchQueryFilter || '',
                    minimumAccessLevel: 'APPLICATION',
                    queryString: request.query,
                    restrictTo: {
                        userIds: [],
                        groupIds: []
                    },
                    searchUserbase: false
                }
            })
        }).then((response)=>{
            if (response.status === 200) return response.json();
            return Promise.reject({
                message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
                statusCode: response.status
            });
        }).then((response)=>(0, (0, parcelRequire("f5wjp")).transformUsers)(response, intl));
    };
    var $94c7434acb15702b$export$2e2bcd8739ae039 = $94c7434acb15702b$var$getUserRecommendations;
});
parcelRegister("f5wjp", function(module, exports) {
    $parcel$export(module.exports, "transformUsers", ()=>$ba878881f0891deb$export$fb8c90bfc4beaa59);
    var $Jzvpo;
    var $60uqU;
    const $ba878881f0891deb$var$getLozenzeProperties = (entity, intl)=>{
        if (entity.attributes?.workspaceMember) return intl.formatMessage((0, (0, parcelRequire("Jzvpo")).messages).memberLozengeText);
        if (entity.attributes?.isConfluenceExternalCollaborator) {
            const lozengeTooltipMessage = entity.entityType === (0, (0, parcelRequire("60uqU")).EntityType).GROUP ? (0, (0, parcelRequire("Jzvpo")).messages).guestGroupLozengeTooltip : (0, (0, parcelRequire("Jzvpo")).messages).guestUserLozengeTooltip;
            return {
                text: intl.formatMessage((0, (0, parcelRequire("Jzvpo")).messages).guestLozengeText),
                tooltip: intl.formatMessage(lozengeTooltipMessage),
                appearance: 'default'
            };
        }
        return undefined;
    };
    const $ba878881f0891deb$var$transformUser = (item, intl)=>{
        const type = item.entityType;
        if (type === (0, (0, parcelRequire("60uqU")).EntityType).USER) {
            const user = item;
            const lozenge = $ba878881f0891deb$var$getLozenzeProperties(user, intl);
            return {
                id: user.id,
                type: user.nonLicensedUser ? (0, $f93312f7d4958f08$export$50042ec1d2e00e63) : (0, $f93312f7d4958f08$export$8436e53e45ffe15b),
                avatarUrl: user.avatarUrl,
                name: user.name,
                email: user.email,
                title: user.title,
                lozenge: lozenge,
                tooltip: user.name,
                isExternal: Boolean(user.nonLicensedUser),
                sources: user.nonLicensedUser ? [
                    'other-atlassian'
                ] : undefined
            };
        }
        if (type === (0, (0, parcelRequire("60uqU")).EntityType).TEAM) {
            const team = item;
            return {
                id: team.id,
                type: (0, $f93312f7d4958f08$export$26bc40b960693765),
                description: team.description || '',
                name: team.displayName || '',
                memberCount: team.memberCount,
                members: team.members,
                includesYou: team.includesYou,
                avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
                tooltip: team.displayName,
                verified: team.verified
            };
        }
        if (type === (0, (0, parcelRequire("60uqU")).EntityType).GROUP) {
            const group = item;
            const lozenge = $ba878881f0891deb$var$getLozenzeProperties(group, intl);
            return {
                id: group.id,
                type: (0, $f93312f7d4958f08$export$d460f747b73abb10),
                name: group.name || '',
                lozenge: lozenge
            };
        }
        return;
    };
    const $ba878881f0891deb$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$ba878881f0891deb$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);
});
parcelRegister("Jzvpo", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$0fd0da3298001d54$export$defe85febe8b728c);
    var $7VHMR;
    const $0fd0da3298001d54$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        externalUserSourcesHeading: {
            id: 'fabric.elements.user-picker.external.sourced.from',
            defaultMessage: 'Found in:',
            description: 'From where the external user is coming'
        },
        slackProvider: {
            id: 'fabric.elements.user-picker.slack.provider',
            defaultMessage: 'Slack',
            description: 'This external user is sourced from Slack provider'
        },
        googleProvider: {
            id: 'fabric.elements.user-picker.google.provider',
            defaultMessage: 'Google',
            description: 'This external user is sourced from Google provider'
        },
        microsoftProvider: {
            id: 'fabric.elements.user-picker.microsoft.provider',
            defaultMessage: 'Microsoft',
            description: 'This external user is sourced from Microsoft provider'
        },
        gitHubProvider: {
            id: 'fabric.elements.user-picker.github.provider',
            defaultMessage: 'GitHub',
            description: 'This external user is sourced from GitHub provider'
        },
        memberLozengeText: {
            id: 'fabric.elements.user-picker.member.lozenge.text',
            defaultMessage: 'MEMBER',
            description: 'Text within the Lozenge when the user is a workspace member'
        },
        guestLozengeText: {
            id: 'fabric.elements.user-picker.guest.lozenge.text',
            defaultMessage: 'GUEST',
            description: 'Text within the lozenge when the user is a guest of confluence'
        },
        guestUserLozengeTooltip: {
            id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
            defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
            description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
        },
        guestGroupLozengeTooltip: {
            id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
            defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
            description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
        }
    });
});
parcelRegister("60uqU", function(module, exports) {
    $parcel$export(module.exports, "EntityType", ()=>$e9a061fa52eafd84$export$8eda7e02f8f033b2);
    var $e9a061fa52eafd84$export$8eda7e02f8f033b2;
    (function(EntityType) {
        EntityType["USER"] = "USER";
        EntityType["TEAM"] = "TEAM";
        EntityType["GROUP"] = "GROUP";
    })($e9a061fa52eafd84$export$8eda7e02f8f033b2 || ($e9a061fa52eafd84$export$8eda7e02f8f033b2 = {}));
});
parcelRegister("lrQGi", function(module, exports) {
    $parcel$export(module.exports, "config", ()=>$8648972412521072$export$e506a1d27d1eaa20);
    const $8648972412521072$export$e506a1d27d1eaa20 = {
        getRecommendationServiceUrl (baseUrl) {
            return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
        },
        getUsersServiceUrl (productKey, baseUrl = '') {
            return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
        },
        getGraphQLUrl (baseUrl) {
            return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
        },
        getTeamsUrl (baseUrl) {
            return baseUrl ? `${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
        }
    };
});
parcelRegister("bjnDn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44f7a8d9e6b8d706$export$2e2bcd8739ae039);
    var $lrQGi;
    var $gNcwE;
    var $ePY59;
    var $jN74Q;
    const $44f7a8d9e6b8d706$var$getHydratedUsersFromProducts = (request)=>{
        const url = `${(0, (0, parcelRequire("lrQGi")).config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
        let params = new URLSearchParams();
        request.accountIds.map((id)=>params.append('accountId', id));
        params.append('maxResults', '2000');
        return fetch(`${url}?${params}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            }
        }).then((response)=>{
            if (response.status === 200) return response.json();
            return Promise.reject({
                message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
            });
        }).then(request.productKey === 'jira' ? $44f7a8d9e6b8d706$var$transformJiraUsers : $44f7a8d9e6b8d706$var$transformConfluenceUsers);
    };
    const $44f7a8d9e6b8d706$var$transformJiraUsers = (userResponse)=>userResponse.values.map($44f7a8d9e6b8d706$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
    const $44f7a8d9e6b8d706$var$transformJiraUser = (item)=>{
        if (!item) return null;
        return {
            id: item.accountId,
            type: (0, $f93312f7d4958f08$export$8436e53e45ffe15b),
            avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
            name: item.displayName,
            email: item.emailAddress
        };
    };
    const $44f7a8d9e6b8d706$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($44f7a8d9e6b8d706$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
    const $44f7a8d9e6b8d706$var$transformConfluenceUser = (item)=>{
        if (!item) return null;
        return {
            id: item.accountId,
            type: (0, $f93312f7d4958f08$export$8436e53e45ffe15b),
            avatarUrl: item.profilePicture ? item.profilePicture.path : '',
            name: item.publicName,
            email: item.email
        };
    };
    const $44f7a8d9e6b8d706$var$sortResults = (options, sortIds)=>{
        const resultsMap = new Map(options.map((option)=>[
                option && option.id,
                option
            ]));
        return sortIds.map((option)=>{
            const user = resultsMap.get(option.id);
            if (user) return user;
            return {
                id: option.id,
                type: option.type,
                name: (0, (0, parcelRequire("jN74Q")).UNKNOWN)
            };
        });
    };
    const $44f7a8d9e6b8d706$var$isOptionData = (option)=>{
        return option.name !== undefined;
    };
    const $44f7a8d9e6b8d706$var$hydrateTeamIds = async (baseUrl, values)=>{
        if (values.length === 0) return [];
        const legionPromises = values.map((value)=>(0, (0, parcelRequire("ePY59")).default)({
                baseUrl: baseUrl,
                id: value.id
            }));
        return await Promise.all(legionPromises);
    };
    const $44f7a8d9e6b8d706$var$hydrateAccountIds = async (baseUrl, productKey, values)=>{
        if (values.length === 0) return [];
        const accountIds = values.map((val)=>val.id);
        return productKey === 'jira' || productKey === 'confluence' ? await $44f7a8d9e6b8d706$var$getHydratedUsersFromProducts({
            baseUrl: baseUrl,
            productKey: productKey,
            accountIds: accountIds
        }) : await (0, (0, parcelRequire("gNcwE")).default)(baseUrl, accountIds);
    };
    async function $44f7a8d9e6b8d706$var$hydrateDefaultValues(baseUrl, value, productKey) {
        if (!value || Array.isArray(value) && value.length === 0) return [];
        const values = Array.isArray(value) ? value : [
            value
        ];
        if (!values.some((val)=>!$44f7a8d9e6b8d706$var$isOptionData(val))) return value;
        const [hydratedUsers, hydratedTeams] = await Promise.all([
            $44f7a8d9e6b8d706$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$44f7a8d9e6b8d706$var$isOptionData(val) && val.type === 'user')),
            $44f7a8d9e6b8d706$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$44f7a8d9e6b8d706$var$isOptionData(val) && val.type === 'team'))
        ]);
        const hydratedOptions = values.filter((val)=>$44f7a8d9e6b8d706$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
        return $44f7a8d9e6b8d706$var$sortResults(hydratedOptions, values);
    }
    var $44f7a8d9e6b8d706$export$2e2bcd8739ae039 = $44f7a8d9e6b8d706$var$hydrateDefaultValues;
});
parcelRegister("gNcwE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d23ee2bd503b8568$export$2e2bcd8739ae039);
    var $jN74Q;
    var $3CXSS;
    var $lrQGi;
    const $d23ee2bd503b8568$var$buildUsersQuery = (accountIds)=>({
            query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
            variables: {
                accountIds: accountIds
            }
        });
    const $d23ee2bd503b8568$var$makeRequest = async (url, accountIds)=>{
        const query = $d23ee2bd503b8568$var$buildUsersQuery(accountIds);
        return await (0, (0, parcelRequire("3CXSS")).graphqlQuery)(url, query);
    };
    const $d23ee2bd503b8568$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
                avatarUrl: picture,
                id: accountId,
                name: name,
                type: 'user'
            }));
    const $d23ee2bd503b8568$var$getHydratedUsers = (baseUrl, userIds)=>{
        const url = (0, (0, parcelRequire("lrQGi")).config).getGraphQLUrl(baseUrl);
        return new Promise((resolve)=>{
            $d23ee2bd503b8568$var$makeRequest(url, userIds).then((data)=>{
                resolve($d23ee2bd503b8568$var$modifyResponse(data.users));
            }).catch(()=>{
                resolve(userIds.map((id)=>({
                        ...(0, (0, parcelRequire("jN74Q")).UNKNOWN_USER),
                        id: id
                    })));
            });
        });
    };
    var $d23ee2bd503b8568$export$2e2bcd8739ae039 = $d23ee2bd503b8568$var$getHydratedUsers;
});
parcelRegister("jN74Q", function(module, exports) {
    $parcel$export(module.exports, "UNKNOWN", ()=>$0ddad3c1364f0383$export$78244dbb77cfa6b6);
    $parcel$export(module.exports, "UNKNOWN_USER", ()=>$0ddad3c1364f0383$export$d1f5101c0939e3fe);
    $parcel$export(module.exports, "UNKNOWN_TEAM", ()=>$0ddad3c1364f0383$export$8144dcfc9025ca57);
    const $0ddad3c1364f0383$export$78244dbb77cfa6b6 = 'Unknown';
    const $0ddad3c1364f0383$export$d1f5101c0939e3fe = {
        id: $0ddad3c1364f0383$export$78244dbb77cfa6b6,
        name: $0ddad3c1364f0383$export$78244dbb77cfa6b6,
        type: 'user'
    };
    const $0ddad3c1364f0383$export$8144dcfc9025ca57 = {
        id: $0ddad3c1364f0383$export$78244dbb77cfa6b6,
        name: $0ddad3c1364f0383$export$78244dbb77cfa6b6,
        type: 'team'
    };
});
parcelRegister("3CXSS", function(module, exports) {
    $parcel$export(module.exports, "graphqlQuery", ()=>$2c71ea00102d5220$export$74eb8d79ae3e02b5);
    const $2c71ea00102d5220$var$buildHeaders = ()=>{
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    };
    function $2c71ea00102d5220$export$74eb8d79ae3e02b5(serviceUrl, query) {
        const headers = $2c71ea00102d5220$var$buildHeaders();
        return fetch(new Request(`${serviceUrl}`, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: headers,
            body: JSON.stringify(query)
        })).then((response)=>{
            if (!response.ok) return Promise.reject({
                code: response.status,
                reason: response.statusText
            });
            return response;
        }).then((response)=>response.json()).then((json)=>{
            if (json.errors) return Promise.reject({
                reason: json.errors[0]?.category || 'default'
            });
            return json.data;
        });
    }
});
parcelRegister("ePY59", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8f36f3458a567667$export$2e2bcd8739ae039);
    var $lrQGi;
    var $jN74Q;
    const $8f36f3458a567667$var$transformTeam = (team, id)=>{
        return {
            id: id,
            name: team.displayName,
            type: 'team',
            avatarUrl: team.smallAvatarImageUrl
        };
    };
    const $8f36f3458a567667$var$hydrateTeamFromLegion = (request)=>{
        const url = `${(0, (0, parcelRequire("lrQGi")).config).getTeamsUrl(request.baseUrl)}/${request.id}`;
        return fetch(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            }
        }).then((response)=>{
            if (response.status === 200) return response.json();
            return Promise.reject({
                message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
            });
        }).then((response)=>{
            return $8f36f3458a567667$var$transformTeam(response, request.id);
        }).catch(()=>({
                ...(0, (0, parcelRequire("jN74Q")).UNKNOWN_TEAM),
                id: request.id
            }));
    };
    var $8f36f3458a567667$export$2e2bcd8739ae039 = $8f36f3458a567667$var$hydrateTeamFromLegion;
});
parcelRegister("adPMl", function(module, exports) {
    $parcel$export(module.exports, "smartUserPickerRenderedUfoExperience", ()=>$55e968402cb7b08a$export$df77da4c0210f1c1);
    $parcel$export(module.exports, "smartUserPickerOptionsShownUfoExperience", ()=>$55e968402cb7b08a$export$a0e7cca3ab9586eb);
    $parcel$export(module.exports, "useUFOConcurrentExperience", ()=>$55e968402cb7b08a$export$e5e0512991825310);
    $parcel$export(module.exports, "UfoErrorBoundary", ()=>$55e968402cb7b08a$export$5ef1c2550074a375);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBycP;
    var $7Zbvr;
    var $jZA09;
    const $55e968402cb7b08a$var$COMPONENT_NAME = 'smart-user-picker';
    const $55e968402cb7b08a$export$df77da4c0210f1c1 = new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-user-picker-rendered', {
        platform: {
            component: $55e968402cb7b08a$var$COMPONENT_NAME
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $55e968402cb7b08a$export$a0e7cca3ab9586eb = new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-user-picker-options-shown', {
        platform: {
            component: $55e968402cb7b08a$var$COMPONENT_NAME
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).InlineResult
    });
    const $55e968402cb7b08a$export$e5e0512991825310 = (experience, id)=>{
        const experienceForId = experience.getInstance(id);
        (0, $5uXOq.useState)(()=>{
            experienceForId.start();
        });
        (0, $5uXOq.useEffect)(()=>{
            if (experienceForId.state !== (0, (0, parcelRequire("jZA09")).UFOExperienceState)['FAILED']) experienceForId.success();
            return ()=>{
                if ([
                    (0, (0, parcelRequire("jZA09")).UFOExperienceState)['STARTED'],
                    (0, (0, parcelRequire("jZA09")).UFOExperienceState)['IN_PROGRESS']
                ].includes(experienceForId.state)) experienceForId.abort();
            };
        }, []);
    };
    class $55e968402cb7b08a$export$5ef1c2550074a375 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch() {
            $55e968402cb7b08a$export$df77da4c0210f1c1.getInstance(this.props.id).failure();
        }
        render() {
            return this.props.children;
        }
    }
});
parcelRegister("4qXN2", function(module, exports) {
    module.exports = new URL("team-two-people.dd270d21.svg", import.meta.url).toString();
});
parcelRegister("lElIo", function(module, exports) {
    $parcel$export(module.exports, "defaultSelectStyles", ()=>$f1f1a093823579de$export$b12192ea1a215e5f);
    $parcel$export(module.exports, "indicatorFixSelectStyles", ()=>$f1f1a093823579de$export$eca30945eaf474dd);
    var $gwIPs;
    const $f1f1a093823579de$export$b12192ea1a215e5f = {
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, (0, parcelRequire("gwIPs")).layers).modal
            }),
        menu: (base)=>({
                ...base,
                zIndex: (0, (0, parcelRequire("gwIPs")).layers).modal
            })
    };
    const $f1f1a093823579de$var$inputIconPaddingLeft = "var(--ds-space-025, 2px)";
    const $f1f1a093823579de$var$inputIconPaddingRight = "var(--ds-space-050, 4px)";
    const $f1f1a093823579de$export$eca30945eaf474dd = {
        loadingIndicator: (base)=>({
                ...base,
                paddingLeft: $f1f1a093823579de$var$inputIconPaddingLeft,
                paddingRight: $f1f1a093823579de$var$inputIconPaddingRight
            }),
        clearIndicator: (base)=>({
                ...base,
                paddingLeft: $f1f1a093823579de$var$inputIconPaddingLeft,
                paddingRight: $f1f1a093823579de$var$inputIconPaddingRight
            })
    };
    const $f1f1a093823579de$export$a9f371909ef7b4d6 = {
        container: (base)=>({
                ...base,
                border: `${"var(--ds-space-025, 2px)"} solid ${`var(--ds-border-danger, ${(0, $829f609a65d26a98$exports).R400})`}`,
                borderRadius: "var(--ds-space-050, 4px)"
            })
    };
});
const $7808beff4be6dc7e$export$53782b65600ab96d = '__UNASSIGNED_TEAM__';
const $7808beff4be6dc7e$export$3f4352abc4ee4b48 = '__CREATE_TEAM__';
parcelRegister("4vyX4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8457da62d9869465$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8457da62d9869465$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "issue-field-team.error-title",
            "defaultMessage": "We couldn't set the team value"
        },
        errorMessage: {
            "id": "issue-field-team.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        },
        teamErrorViewTooltip: {
            "id": "issue-field-team.team-error-view-tooltip",
            "defaultMessage": "This team may have been deleted, or you do not have access"
        },
        teamErrorViewText: {
            "id": "issue-field-team.team-error-view-text",
            "defaultMessage": "Not available"
        },
        placeholderTeamEditSelector: {
            "id": "issue-field-team.placeholder-team-edit-selector",
            "defaultMessage": "Choose a team"
        },
        defaultNoValueText: {
            "id": "issue-field-team.default-no-value-text",
            "defaultMessage": "None"
        },
        createTeamButtonText: {
            "id": "issue-field-team.create-team-button-text",
            "defaultMessage": "Create a team"
        },
        emptyStateDescription: {
            "id": "issue-field-team.empty-state-description",
            "defaultMessage": "Create a team to assign work across Jira and track it on your team\u2019s profile"
        },
        noOptionsMessage: {
            "id": "issue-field-team.no-options-message",
            "defaultMessage": "No options"
        }
    });
});
parcelRegister("4G4ne", function(module, exports) {
    module.exports = new URL("no-team-avatar.fa4b7eb2.svg", import.meta.url).toString();
});
parcelRegister("lWune", function(module, exports) {
    $parcel$export(module.exports, "CreateTeamOption", ()=>$3964fd12f1894d2f$export$8920795307e75f7e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $c8oLN;
    var $f4ndh;
    var $4R6GH;
    var $aQLOb = parcelRequire("aQLOb");
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $4vyX4;
    var $7xOrU;
    var $flc0O = parcelRequire("flc0O");
    function $3964fd12f1894d2f$export$8920795307e75f7e({ onClick: onClick, isFocused: isFocused }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const formattedCreateTeamText = formatMessage((0, (0, parcelRequire("4vyX4")).default).createTeamButtonText);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleCreateTeamOptionClick = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
                teamsFieldEmptyState: false
            });
            onClick();
        }, [
            onClick,
            createAnalyticsEvent
        ]);
        const { canCreateTeams: canCreateTeams } = (0, (0, parcelRequire("7xOrU")).useTeamPermissions)();
        return canCreateTeams ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Suspense, {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c8oLN")).default), {
            inline: "space.200",
            block: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3964fd12f1894d2f$var$CreateButtonBorder, null), (0, ($parcel$interopDefault($5uXOq))).createElement($3964fd12f1894d2f$var$Container, {
            onClick: handleCreateTeamOptionClick,
            isFocused: isFocused,
            "data-testid": "issue-field-team.ui.edit-mode.create-team-option.create-team-inline-option"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3964fd12f1894d2f$var$OptionDataWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4ndh")).default), {
            isSelected: false,
            data: {
                id: (0, $7808beff4be6dc7e$export$3f4352abc4ee4b48),
                name: formattedCreateTeamText,
                type: 'custom',
                avatarUrl: (0, (0, parcelRequire("4R6GH")).fg)('move_issue_view_assets_into_central_location') ? (0, ($parcel$interopDefault($aQLOb))) : (0, ($parcel$interopDefault($flc0O)))
            }
        }))))) : null;
    }
    const $3964fd12f1894d2f$var$CreateButtonBorder = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_x3do13y8",
                __cmplp.className
            ])
        });
    });
    const $3964fd12f1894d2f$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isFocused: isFocused, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkv77o _1bsb1osq _4t3i1osq _irr31dko _1dbz1l95",
                __cmplp.isFocused ? "_bfhk1dko" : "_bfhk18uv",
                __cmplp.isFocused ? "_16qs1l95" : "_16qsglyw",
                __cmplp.className
            ])
        });
    });
    const $3964fd12f1894d2f$var$OptionDataWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41ano",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aQLOb", function(module, exports) {
    module.exports = new URL("team-two-people-with-plus.5493a468.svg", import.meta.url).toString();
});
parcelRegister("7xOrU", function(module, exports) {
    $parcel$export(module.exports, "useTeamPermissions", ()=>$dbab4d033b21c1e7$export$8cbbe0c59dd60253);
    var $14XJw;
    var $9OXo1;
    var $95nUS;
    const $dbab4d033b21c1e7$export$8cbbe0c59dd60253 = ()=>{
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { permissions: permissions } = (0, (0, parcelRequire("95nUS")).useTeamsPermissionsService)({
            orgId: orgId,
            cloudId: cloudId
        }, {
            enabled: false
        });
        return permissions;
    };
});
parcelRegister("flc0O", function(module, exports) {
    module.exports = new URL("create-team-avatar.a06263d8.svg", import.meta.url).toString();
});
parcelRegister("fAxaP", function(module, exports) {
    $parcel$export(module.exports, "TeamPickerEmptyState", ()=>$93f56cb34a904dc8$export$f53d61da818dafb4);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $el82k;
    var $ousew;
    var $8zOmE;
    var $2NMNM;
    var $4vyX4;
    var $7xOrU;
    var $2qnTp = parcelRequire("2qnTp");
    const $93f56cb34a904dc8$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz10s3 _otyr1ejb _19pkze3t",
                __cmplp.className
            ])
        });
    });
    const $93f56cb34a904dc8$var$Image = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyrpxbi",
                __cmplp.className
            ])
        });
    });
    const $93f56cb34a904dc8$var$imageWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.200'
    });
    const $93f56cb34a904dc8$export$f53d61da818dafb4 = ({ onActionClick: onActionClick })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { canCreateTeams: canCreateTeams } = (0, (0, parcelRequire("7xOrU")).useTeamPermissions)();
        const handleCreateTeamOptionClick = ()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
                teamsFieldEmptyState: true
            });
            onActionClick();
        };
        return canCreateTeams ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlock: "space.200",
            testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.empty-state"
        }, !(0, (0, parcelRequire("4R6GH")).fg)('move_issue_view_assets_into_central_location') && (0, ($parcel$interopDefault($5uXOq))).createElement($93f56cb34a904dc8$var$Image, {
            src: (0, ($parcel$interopDefault($2qnTp))),
            alt: ""
        }), (0, (0, parcelRequire("4R6GH")).fg)('move_issue_view_assets_into_central_location') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $93f56cb34a904dc8$var$imageWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("el82k")).default), {
            alt: "",
            width: 130,
            height: 122
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($93f56cb34a904dc8$var$Description, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("4vyX4")).default).emptyStateDescription)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "primary",
            onClick: handleCreateTeamOptionClick,
            testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button",
            interactionName: "auto-generated.issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button.button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("4vyX4")).default).createTeamButtonText))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("4vyX4")).default).noOptionsMessage);
    };
});
parcelRegister("el82k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce20a57a3049c2d5$export$2e2bcd8739ae039);
    var $dCLgq;
    var $2Lts4 = parcelRequire("2Lts4");
    const $ce20a57a3049c2d5$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($2Lts4)),
        srcDark: ($parcel$interopDefault($2Lts4))
    });
    var $ce20a57a3049c2d5$export$2e2bcd8739ae039 = $ce20a57a3049c2d5$var$Illustration;
    const $ce20a57a3049c2d5$export$a179c88182cb9d56 = [
        0,
        0,
        130,
        122
    ];
});
parcelRegister("2Lts4", function(module, exports) {
    module.exports = new URL("people-and-tasks.dedc2456.svg", import.meta.url).toString();
});
parcelRegister("2qnTp", function(module, exports) {
    module.exports = new URL("team-picker-empty-state.357906ab.svg", import.meta.url).toString();
});
parcelRegister("ghnVw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$032f58b3b8fec432$export$2e2bcd8739ae039);
    var $7VHMR;
    var $032f58b3b8fec432$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "software-board-create.modal.form.source-value-picker.team-picker.placeholder",
            "defaultMessage": "Select"
        }
    });
});
parcelRegister("iizLc", function(module, exports) {
    $parcel$export(module.exports, "validateFormData", ()=>$cafe185f92d40f5f$export$cc0ea38c9ab56613);
    var $h3KSk;
    const $cafe185f92d40f5f$var$validateBoardName = (value)=>{
        return !value || value.trim().length === 0 ? (0, (0, parcelRequire("h3KSk")).VALIDATION_ERROR_EMPTY) : undefined;
    };
    const $cafe185f92d40f5f$var$validateSourceType = (value)=>{
        return value === undefined ? (0, (0, parcelRequire("h3KSk")).VALIDATION_ERROR_EMPTY) : undefined;
    };
    const $cafe185f92d40f5f$var$validateSourceValue = (value)=>{
        if (Array.isArray(value) && !value.length || !Array.isArray(value) && !value) return 0, (0, parcelRequire("h3KSk")).VALIDATION_ERROR_EMPTY;
    };
    const $cafe185f92d40f5f$export$cc0ea38c9ab56613 = (data)=>({
            boardName: $cafe185f92d40f5f$var$validateBoardName(data.boardName),
            sourceType: $cafe185f92d40f5f$var$validateSourceType(data.sourceType),
            sourceValue: data.sourceType ? $cafe185f92d40f5f$var$validateSourceValue(data.sourceValue) : undefined
        });
});
parcelRegister("4K4Ab", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc97b5447a838fc3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cc97b5447a838fc3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createBoardDialogLabel: {
            "id": "software-board-create.modal.create-board-dialog-label",
            "defaultMessage": "Create board dialog, {boardDescription}"
        },
        loadingLabel: {
            "id": "software-board-create.modal.loading-label",
            "defaultMessage": "Loading"
        }
    });
});
parcelRegister("aDXGG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$caddba559d8e417f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $caddba559d8e417f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createBoardLabel: {
            "id": "software-board-create.flyout-menu.flyout-menu-content.dropdown-item-container.create-board-label",
            "defaultMessage": "Create a {boardType} board"
        }
    });
});
parcelRegister("jFvRN", function(module, exports) {
    $parcel$export(module.exports, "FlyoutMenuContentFallback", ()=>$1f33e86f0e9f6b4d$export$aad294dc6c6989e8);
    var $5uXOq = parcelRequire("5uXOq");
    var $iwwXK;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $4R6GH;
    var $koVbs;
    var $kWGoR;
    var $gzrSn;
    const $1f33e86f0e9f6b4d$export$aad294dc6c6989e8 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if ((0, (0, parcelRequire("4R6GH")).fg)('a11y_violations_fixes_fase_2')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kWGoR")).FlyoutContentContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlockStart: "space.100",
            xcss: $1f33e86f0e9f6b4d$var$skeletonItemContainerStyles,
            role: "menuitem",
            "aria-label": formatMessage((0, (0, parcelRequire("gzrSn")).default).loadingLabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true,
            width: "100%"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlockStart: "space.100",
            xcss: $1f33e86f0e9f6b4d$var$skeletonItemContainerStyles,
            role: "menuitem",
            "aria-label": formatMessage((0, (0, parcelRequire("gzrSn")).default).loadingLabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true,
            width: "100%"
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kWGoR")).FlyoutContentContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $1f33e86f0e9f6b4d$var$skeletonItemContainerStyles,
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true,
            width: "100%"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $1f33e86f0e9f6b4d$var$skeletonItemContainerStyles,
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true,
            width: "100%"
        })));
    };
    const $1f33e86f0e9f6b4d$var$skeletonItemContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '56px'
    });
});
parcelRegister("gzrSn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f92c872d37e78842$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f92c872d37e78842$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        loadingLabel: {
            "id": "software-board-create.flyout-menu.flyout-menu-content.flyout-menu-content-fallback.loading-label",
            "defaultMessage": "Loading"
        }
    });
});
parcelRegister("jzmXi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af5b5398f44bbc0e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $af5b5398f44bbc0e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createBoard: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-common.project-actions.create-board",
            "defaultMessage": "Create board"
        }
    });
});
parcelRegister("7TnTU", function(module, exports) {
    $parcel$export(module.exports, "isCompanyManagedSoftwareProject", ()=>$9eab6e02685f3c3c$export$531964df831b0883);
    var $2vSU6;
    const $9eab6e02685f3c3c$export$531964df831b0883 = (projectStyle, projectType)=>projectStyle === 'COMPANY_MANAGED_PROJECT' && projectType === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_SOFTWARE_PROJECT);
});
const $ba4e5f586c2a87d8$export$b8b9d90f9e5bd72b = '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-jsw-project-menu';
const $ba4e5f586c2a87d8$export$d57b6b390e78d90f = 'jira-cosmos';
const $ba4e5f586c2a87d8$export$420a3ee5deb615a9 = 25;
const $ba4e5f586c2a87d8$export$99240e55cc48c47e = 5;
parcelRegister("dwZUI", function(module, exports) {
    $parcel$export(module.exports, "asyncJswExpandableProjectQuery", ()=>$a51b1482b4cc12b0$export$ae81f6dde63e63eb);
    var $gIUIa;
    var $eufEc;
    var $fEDBv;
    const $a51b1482b4cc12b0$export$ae81f6dde63e63eb = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("9ox91")).then(({ JswExpandableProjectQuery: JswExpandableProjectQuery })=>JswExpandableProjectQuery), {
            moduleId: "69299f40",
            moduleName: "JswExpandableProjectQuery"
        }),
        getPreloadProps: ({ cloudId: cloudId, projectId: projectId, noOfBoardsToFetch: noOfBoardsToFetch })=>({
                queries: {
                    projects: {
                        parameters: (0, parcelRequire("gIUIa")).default,
                        variables: {
                            cloudId: cloudId,
                            projectId: projectId,
                            noOfBoardsToFetch: noOfBoardsToFetch
                        }
                    }
                }
            })
    });
});
parcelRegister("gIUIa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b76d34c79f26c888$export$2e2bcd8739ae039);
    const $b76d34c79f26c888$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "noOfBoardsToFetch"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectId"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "id"
        }, v4 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v5 = {
            "kind": "ScalarField",
            "name": "boardId"
        }, v6 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v7 = {
            "kind": "InlineFragment",
            "selections": [
                v3
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "JswExpandableProjectQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "noOfBoardsToFetch",
                                                        "variableName": "noOfBoardsToFetch"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "JswBoards"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraProject"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "JswExpandableProjectQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProject",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "projectKey",
                                        "kind": "ScalarField",
                                        "name": "key"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "projectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "projectType"
                                    },
                                    v3,
                                    v4,
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "first",
                                                "variableName": "noOfBoardsToFetch"
                                            }
                                        ],
                                        "concreteType": "JiraBoardConnection",
                                        "kind": "LinkedField",
                                        "name": "boards",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraBoardEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraBoard",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "name"
                                                            },
                                                            v5,
                                                            {
                                                                "concreteType": "JiraFavouriteValue",
                                                                "kind": "LinkedField",
                                                                "name": "favouriteValue",
                                                                "plural": false,
                                                                "selections": [
                                                                    v4,
                                                                    v3
                                                                ]
                                                            },
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "defaultNavigationItem",
                                                                "plural": false,
                                                                "selections": [
                                                                    v6,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "typeKey"
                                                                            }
                                                                        ],
                                                                        "type": "JiraNavigationItem",
                                                                        "abstractKey": "__isJiraNavigationItem"
                                                                    },
                                                                    v7
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "boardType"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "canEdit"
                                                            },
                                                            {
                                                                "kind": "ClientExtension",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "__id"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "mostRecentlyViewedBoard",
                                        "plural": false,
                                        "selections": [
                                            v6,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v5
                                                ],
                                                "type": "JiraBoard"
                                            },
                                            v7
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "softwareBoardCount"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "9ad13ddff087716f666932837f761c02085f716557773c6dd039817b89ec41d7",
                "metadata": {},
                "name": "JswExpandableProjectQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $b76d34c79f26c888$var$node.hash = "3485df9fb7e555ae936fa7dc74f15c59";
    var $b76d34c79f26c888$export$2e2bcd8739ae039 = $b76d34c79f26c888$var$node;
});
parcelRegister("9ox91", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("01uJN").then(()=>parcelRequire('fhfEu'));
});
parcelRegister("igsK5", function(module, exports) {
    $parcel$export(module.exports, "JswNonExpandableProject", ()=>$503472fd334f467b$export$cbea0eaf70f0156d);
    var $3Ycm4;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $6Lyip;
    var $2vSU6;
    var $fNJRN;
    var $jhS4y;
    var $5FnJJ;
    var $76MhN;
    var $60FHh;
    var $dcP6E;
    const $503472fd334f467b$export$cbea0eaf70f0156d = ({ projectData: projectData, spotlight: spotlight })=>{
        const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, (0, parcelRequire("fNJRN")).useProjectsAnalyticsL1)();
        const project = (0, $8Uumt.useFragment)((0, (0, parcelRequire("3Ycm4")).default), projectData);
        const projectUrl = (0, (0, parcelRequire("76MhN")).buildProjectUrl)({
            key: project.projectKey,
            projectType: (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_TYPE_SOFTWARE_PROJECT),
            defaultViewType: project.defaultNavigationItem?.typeKey,
            ...project.navigationMetadata?.boardId && {
                boardId: project.navigationMetadata.boardId
            },
            isSimpleBoard: project.navigationMetadata?.isSimpleBoard
        });
        const routerLinkConfig = (0, $5uXOq.useMemo)(()=>({
                to: projectUrl,
                prefetch: 'hover'
            }), [
            projectUrl
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Lyip")).OnboardingSpotlightMaybe), {
            key: project.projectKey,
            spotlight: spotlight
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FnJJ")).Nav4MenuLinkItem), {
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dcP6E")).ContainerAvatar), {
                src: project.avatar.large || ''
            }),
            href: routerLinkConfig,
            menuId: (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(project.projectKey),
            onClick: ()=>{
                sendProjectMenuItemAnalyticsEvent({
                    starred: project.isFavourite ?? false,
                    recent: !project.isFavourite,
                    projectId: project.projectId,
                    projectType: project.projectType
                });
            },
            actionsOnHover: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("60FHh")).ProjectActions), {
                projectFragment: project
            })
        }, project.name));
    };
});
parcelRegister("3Ycm4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$308da0e532a359a0$export$2e2bcd8739ae039);
    const $308da0e532a359a0$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "JswNonExpandableProject",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectId"
                },
                "action": "THROW",
                "path": "projectId"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "projectKey",
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "projectKey"
            },
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            {
                "kind": "ScalarField",
                "name": "projectType"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "large"
                            },
                            "action": "THROW",
                            "path": "avatar.large"
                        }
                    ]
                },
                "action": "THROW",
                "path": "avatar"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "name"
                },
                "action": "THROW",
                "path": "name"
            },
            {
                "kind": "LinkedField",
                "name": "navigationMetadata",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "boardId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isSimpleBoard"
                            }
                        ],
                        "type": "JiraSoftwareProjectNavigationMetadata"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "defaultNavigationItem",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "typeKey"
                            }
                        ],
                        "type": "JiraNavigationItem",
                        "abstractKey": "__isJiraNavigationItem"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "ProjectActions"
            }
        ],
        "type": "JiraProject"
    };
    $308da0e532a359a0$var$node.hash = "aa6f9c8488de8d2daa09d45b293894c8";
    var $308da0e532a359a0$export$2e2bcd8739ae039 = $308da0e532a359a0$var$node;
});
parcelRegister("hohDO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53f5333898bb26f9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2NMNM;
    var $fVnbM;
    var $2rqOp;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $9fuVs;
    var $2vSU6;
    var $34Vv8;
    var $az4zD;
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $1ppIJ;
    var $24wrg;
    var $izP7o;
    var $7Cf8E;
    var $1OpzN;
    const $53f5333898bb26f9$export$a43ae427db1e9df7 = 'restore-from-trash';
    const $53f5333898bb26f9$export$ec2a19e79c04c9d2 = 'restore-from-archive';
    const $53f5333898bb26f9$export$cee26a329c363b31 = (props)=>{
        const { isProjectSimplified: isProjectSimplified, projectType: projectType, projectName: projectName, baseUrl: baseUrl = '', projectId: projectId, projectKey: projectKey, projectInactiveDate: projectInactiveDate, intl: { formatMessage: formatMessage }, onClose: onClose, onProjectRestoreSuccess: onProjectRestoreSuccess, onProjectRestoreFailure: onProjectRestoreFailure, flagService: { showFlag: showFlag } } = props;
        const [isRestoring, restoreProject] = (0, (0, parcelRequire("24wrg")).useProjectRestoreService)({
            baseUrl: baseUrl,
            projectId: projectId
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const attributes = {
            projectType: projectType,
            isProjectSimplified: isProjectSimplified
        };
        const onSuccess = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'restored'
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'project restored', projectId.toString(), {
                ...attributes,
                durationInTrash: (0, (0, parcelRequire("1OpzN")).getDurationInTrash)(projectInactiveDate)
            });
            onProjectRestoreSuccess();
            if (projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) showFlag({
                type: 'success',
                title: (0, (0, parcelRequire("izP7o")).default).restoreServiceDeskSuccessMessageTitle,
                description: (0, (0, parcelRequire("izP7o")).default).restoreServiceDeskSuccessMessageContent,
                testId: 'project-restore-modal.ui.flags.success-flag',
                actions: [
                    {
                        content: (0, (0, parcelRequire("izP7o")).default).restoreServiceDeskSuccessMessageActionEmailSettings,
                        href: `/jira/servicedesk/projects/${projectKey}/settings/email`
                    }
                ]
            });
            else showFlag({
                type: 'success',
                title: (0, (0, parcelRequire("izP7o")).default).restoreSuccessMessageTitle,
                testId: 'project-restore-modal.ui.flags.success-flag'
            });
        };
        const onFailure = (error)=>{
            onProjectRestoreFailure(error);
            showFlag({
                type: 'error',
                title: [
                    (0, (0, parcelRequire("izP7o")).default).restoreErrorMessageTitle,
                    {
                        projectName: projectName
                    }
                ],
                description: [
                    (0, (0, parcelRequire("izP7o")).default).restoreErrorMessageDescription,
                    {
                        projectName: projectName
                    }
                ],
                testId: 'project-restore-modal.ui.flags.failure-flag'
            });
        };
        const onRestore = (e, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'restoreProjectButton');
            restoreProject({
                onSuccess: onSuccess,
                onFailure: onFailure
            });
        };
        const ModalDialogDescription = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("p", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Cf8E")).ModalMessageContent), {
                projectType: projectType
            }));
        const onCancelOrNoop = !isRestoring ? onClose : (0, ($parcel$interopDefault($8Rkzz)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "restoreProject",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            attributes: attributes,
            containerId: `${projectId}`,
            containerType: "project"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1ppIJ")).ModalDialog), {
            onClose: onCancelOrNoop,
            autoFocus: false,
            width: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage(projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT) ? (0, (0, parcelRequire("izP7o")).default).jsmModalHeader : (0, (0, parcelRequire("izP7o")).default).modalHeader, {
            projectName: projectName
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement(ModalDialogDescription, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            onClick: onCancelOrNoop,
            isDisabled: isRestoring,
            testId: "project-restore-modal.ui.close-button-wrapper"
        }, formatMessage((0, (0, parcelRequire("izP7o")).default).cancelRestoreButton)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            appearance: "primary",
            onClick: onRestore,
            isDisabled: isRestoring,
            isLoading: isRestoring,
            testId: "project-restore-modal.ui.restore-button-wrapper"
        }, formatMessage((0, (0, parcelRequire("izP7o")).default).confirmRestoreButton))))));
    };
    const $53f5333898bb26f9$export$9c21a3269931e1e6 = {
        isRestoring: false,
        onClose: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $53f5333898bb26f9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)((0, (0, parcelRequire("34Vv8")).default)($53f5333898bb26f9$export$cee26a329c363b31));
});
parcelRegister("1ppIJ", function(module, exports) {
    $parcel$export(module.exports, "ModalDialog", ()=>$8fbdebf88f199b98$export$1fa217be60c2f188);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $lu5k0;
    const $8fbdebf88f199b98$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
        const returnFocusTarget = (0, (0, parcelRequire("lu5k0")).useReturnFocusTo)();
        const { setReturnFocusTo: setReturnFocusTo } = (0, (0, parcelRequire("lu5k0")).useModalDialogActions)();
        (0, $5uXOq.useEffect)(()=>()=>{
                if (returnFocusTarget?.current) {
                    !shouldReturnFocus && returnFocusTarget.current.focus();
                    setReturnFocusTo(null);
                }
            }, [
            returnFocusTarget,
            setReturnFocusTo,
            shouldReturnFocus
        ]);
        const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            shouldReturnFocus: returnFocus,
            ...rest
        });
    };
});
parcelRegister("lu5k0", function(module, exports) {
    $parcel$export(module.exports, "useModalDialogActions", ()=>$5f429bdcb9dbbc95$export$3cf2e4b6d3541465);
    $parcel$export(module.exports, "useReturnFocusTo", ()=>$5f429bdcb9dbbc95$export$217308a4ece853b2);
    var $3sQ5x;
    var $iXqE5;
    var $49R2H;
    var $a3Qjd;
    var $kIxMH;
    const $5f429bdcb9dbbc95$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'JiraSoftwareModalDialog',
        initialState: (0, parcelRequire("49R2H")).initialState,
        actions: (0, parcelRequire("a3Qjd")).actions
    });
    const $5f429bdcb9dbbc95$export$3cf2e4b6d3541465 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($5f429bdcb9dbbc95$var$Store);
    const $5f429bdcb9dbbc95$export$217308a4ece853b2 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($5f429bdcb9dbbc95$var$Store, {
        selector: (0, (0, parcelRequire("kIxMH")).getReturnFocusTo)
    });
});
parcelRegister("49R2H", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$1a3a816977643252$export$d4c72bab9d6cc13a);
    const $1a3a816977643252$export$d4c72bab9d6cc13a = {
        returnFocusTo: null
    };
});
parcelRegister("a3Qjd", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$1886bc9c17d47b9b$export$e324594224ef24da);
    const $1886bc9c17d47b9b$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
            setState({
                returnFocusTo: returnFocusTo
            });
        };
    const $1886bc9c17d47b9b$export$e324594224ef24da = {
        setReturnFocusTo: $1886bc9c17d47b9b$export$b263d1e638b131c2
    };
});
parcelRegister("kIxMH", function(module, exports) {
    $parcel$export(module.exports, "getReturnFocusTo", ()=>$cd4eb273a1fc9e15$export$d5f8692765ccd209);
    const $cd4eb273a1fc9e15$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;
});
parcelRegister("24wrg", function(module, exports) {
    $parcel$export(module.exports, "useProjectRestoreService", ()=>$45f308a92ac01734$export$3726936b35df382d);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $eusud;
    var $64c16;
    const $45f308a92ac01734$export$3726936b35df382d = ({ baseUrl: baseUrl, projectId: projectId })=>{
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const restoreProject = ({ onSuccess: onSuccess, onFailure: onFailure })=>{
            const url = (0, (0, parcelRequire("64c16")).getProjectRestoreUrl)(baseUrl, projectId);
            setLoading(true);
            (0, (0, parcelRequire("eusud")).performPostRequest)(url).then(()=>{
                setLoading(false);
                onSuccess();
            }).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useProjectRestoreService',
                        packageName: 'jiraProjectRestoreModal'
                    },
                    error: error,
                    attributes: {
                        projectId: projectId,
                        errorStatusCode: error.statusCode
                    }
                });
                setLoading(false);
                onFailure(error);
            });
        };
        return [
            loading,
            restoreProject
        ];
    };
});
parcelRegister("64c16", function(module, exports) {
    $parcel$export(module.exports, "getProjectRestoreUrl", ()=>$d662aeed5fd2bfed$export$f120ca318b319edc);
    const $d662aeed5fd2bfed$export$f120ca318b319edc = (baseUrl, projectId)=>`${baseUrl}/rest/api/2/project/${projectId}/restore`;
});
parcelRegister("izP7o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e2e27b03d33852c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3e2e27b03d33852c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        modalHeader: {
            "id": "project-restore-modal.modal-header",
            "defaultMessage": "Restore project?"
        },
        jsmModalHeader: {
            "id": "project-restore-modal.jsm-modal-header",
            "defaultMessage": "Restore this service project?"
        },
        jsmExplainWhatProjectRestoreDoes: {
            "id": "project-restore-modal.jsm-explain-what-project-restore-does",
            "defaultMessage": "Once restored, this service project will work as normal. It will appear in directories and requests will appear in search results."
        },
        confirmRestoreButton: {
            "id": "project-restore-modal.confirm-restore-button",
            "defaultMessage": "Restore"
        },
        cancelRestoreButton: {
            "id": "project-restore-modal.cancel-restore-button",
            "defaultMessage": "Cancel"
        },
        restoreSuccessMessageTitle: {
            "id": "project-restore-modal.restore-success-message-title",
            "defaultMessage": "Project successfully restored"
        },
        restoreServiceDeskSuccessMessageTitle: {
            "id": "project-restore-modal.restore-service-desk-success-message-title",
            "defaultMessage": "Service project restored"
        },
        restoreServiceDeskSuccessMessageContent: {
            "id": "project-restore-modal.restore-service-desk-success-message-content",
            "defaultMessage": "You may need to turn on email support for your service project to work as normal."
        },
        restoreServiceDeskSuccessMessageActionEmailSettings: {
            "id": "project-restore-modal.restore-service-desk-success-message-action-email-settings",
            "defaultMessage": "Go to email settings"
        },
        restoreErrorMessageTitle: {
            "id": "project-restore-modal.restore-error-message-title",
            "defaultMessage": "Something went wrong"
        },
        restoreErrorMessageDescription: {
            "id": "project-restore-modal.restore-error-message-description",
            "defaultMessage": "We couldn\u2019t restore the \u201C{projectName}\u201D project. Try again."
        }
    });
});
parcelRegister("7Cf8E", function(module, exports) {
    $parcel$export(module.exports, "ModalMessageContent", ()=>$db408ba139d077c4$export$6c33ff8e4ab0adf4);
    var $5uXOq = parcelRequire("5uXOq");
    var $41j30;
    var $2vSU6;
    var $6s1PB;
    var $koVbs;
    var $h33Ak;
    const $db408ba139d077c4$var$isServiceDesk = (projectType)=>projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
    const $db408ba139d077c4$export$49587436f0d2c314 = ({ projectType: projectType })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getMessage = ()=>{
            let message;
            if ((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) message = $db408ba139d077c4$var$isServiceDesk(projectType) ? (0, (0, parcelRequire("h33Ak")).default).jsmExplainWhatProjectRestoreDoesIssueTermRefresh : (0, (0, parcelRequire("h33Ak")).default).explainWhatProjectRestoreDoesPart1IssueTermRefresh;
            else message = $db408ba139d077c4$var$isServiceDesk(projectType) ? (0, (0, parcelRequire("h33Ak")).default).jsmExplainWhatProjectRestoreDoes : (0, (0, parcelRequire("h33Ak")).default).explainWhatProjectRestoreDoesPart1;
            return message;
        };
        const formattedMessage = formatMessage(getMessage());
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, formattedMessage, "\xa0");
    };
    const $db408ba139d077c4$export$d608ae2ec728a3cf = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("41j30")).default), {
            href: (0, $14d5c91aea6dd559$export$367c841df4ac5730),
            target: "_blank"
        }, formatMessage((0, (0, parcelRequire("h33Ak")).default).jsmLearnMoreAboutTrashAndRestore));
    };
    const $db408ba139d077c4$export$6c33ff8e4ab0adf4 = ({ projectType: projectType })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($db408ba139d077c4$export$49587436f0d2c314, {
            projectType: projectType
        }), $db408ba139d077c4$var$isServiceDesk(projectType) && (0, ($parcel$interopDefault($5uXOq))).createElement($db408ba139d077c4$export$d608ae2ec728a3cf, null));
});
parcelRegister("41j30", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c2f3c33a6194375$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8oe80;
    var $hDzhb;
    function $7c2f3c33a6194375$var$Link(props) {
        const { children: children, ...rest } = props;
        delete rest.createAnalyticsEvent;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), rest, children);
    }
    var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('link', {
        onClick: 'clicked'
    })($7c2f3c33a6194375$var$Link);
});
const $14d5c91aea6dd559$export$37312a67c3e314c6 = 'PROJECT_RESTORE_MODAL_LOAD_START_MARK_KEY';
const $14d5c91aea6dd559$export$367c841df4ac5730 = 'https://support.atlassian.com/jira-service-management-cloud/docs/trash-and-restore-a-project/';
parcelRegister("h33Ak", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3c890d2f3f15262$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f3c890d2f3f15262$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        explainWhatProjectRestoreDoesPart1: {
            "id": "project-restore-modal.modal-message.explain-what-project-restore-does-part-1",
            "defaultMessage": "The project along with its issues, Jira components, attachments, and versions will be restored."
        },
        jsmExplainWhatProjectRestoreDoes: {
            "id": "project-restore-modal.modal-message.jsm-explain-what-project-restore-does",
            "defaultMessage": "Once restored, this service project will appear in directories and its issues will appear in search results. You may need to turn on email support for this service project to work as normal."
        },
        jsmLearnMoreAboutTrashAndRestore: {
            "id": "project-restore-modal.modal-message.jsm-learn-more-about-trash-and-restore",
            "defaultMessage": "Learn more about trash and restore."
        },
        explainWhatProjectRestoreDoesPart1IssueTermRefresh: {
            "id": "project-restore-modal.modal-message.explain-what-project-restore-does-part-1-issue-term-refresh",
            "defaultMessage": "The project along with its work items, Jira components, attachments, and versions will be restored"
        },
        jsmExplainWhatProjectRestoreDoesIssueTermRefresh: {
            "id": "project-restore-modal.modal-message.jsm-explain-what-project-restore-does-issue-term-refresh",
            "defaultMessage": "Once restored, this service project will appear in directories and its work items will appear in search results. You may need to turn on email support for this service project to work as normal."
        }
    });
});
parcelRegister("1OpzN", function(module, exports) {
    $parcel$export(module.exports, "getDurationInTrash", ()=>$ba4edd4ad4308bc8$export$d40938201f7514c5);
    var $4mBKK;
    var $jovBr;
    var $eZDAP;
    const $ba4edd4ad4308bc8$export$d40938201f7514c5 = (projectTrashedDate)=>{
        const parsedProjectTrashedDate = (0, (0, parcelRequire("jovBr")).default)((0, (0, parcelRequire("eZDAP")).default)(projectTrashedDate)) ? (0, (0, parcelRequire("eZDAP")).default)(projectTrashedDate) : new Date(projectTrashedDate);
        return (0, (0, parcelRequire("4mBKK")).default)(new Date(), parsedProjectTrashedDate);
    };
});
parcelRegister("7nWhn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2425df2f0841aa4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b2425df2f0841aa4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        recent: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.recent",
            "defaultMessage": "Recent"
        },
        starred: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.starred",
            "defaultMessage": "Starred"
        },
        viewAllStarred: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.view-all-starred",
            "defaultMessage": "View all starred"
        }
    });
});
parcelRegister("abrAF", function(module, exports) {
    $parcel$export(module.exports, "Recent", ()=>$ca7c92fe8a3d50e4$export$1147d6e1036afec);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $l8ruj;
    var $paz61;
    const $ca7c92fe8a3d50e4$export$1147d6e1036afec = ({ isDefaultOpen: isDefaultOpen = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-recent"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "recent",
            packageName: (0, $7ad55196d5c142dd$export$b8b9d90f9e5bd72b),
            teamName: (0, $7ad55196d5c142dd$export$d57b6b390e78d90f)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("paz61")).RecentMenu), {
            isDefaultOpen: isDefaultOpen
        })));
});
const $7ad55196d5c142dd$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Recent';
const $7ad55196d5c142dd$export$d57b6b390e78d90f = 'jira-cosmos';
const $7ad55196d5c142dd$export$56ff071570537731 = 15;
const $7ad55196d5c142dd$export$fe791c4fa892e400 = 'PROJECT';
const $7ad55196d5c142dd$export$c303e491e026ebc6 = 'PLAN';
const $7ad55196d5c142dd$export$c1c49903035a02df = 'FILTER';
const $7ad55196d5c142dd$export$4695c1a423ffe431 = 'DASHBOARD';
const $7ad55196d5c142dd$export$9b8283d5878d2491 = 'BOARD';
const $7ad55196d5c142dd$export$5828682c822c26e7 = 'QUEUE';
const $7ad55196d5c142dd$export$76a449e52fa0e1e8 = 'ISSUE';
const $7ad55196d5c142dd$export$fd6cd74eeb4b51a7 = 'searchRecentItems';
const $7ad55196d5c142dd$export$f91d73dc0ffb6584 = 'viewAllRecentItems';
const $7ad55196d5c142dd$export$ee6bbe0a973ca0e8 = 'today';
const $7ad55196d5c142dd$export$91c1c08ffbb5f1be = 'yesterday';
const $7ad55196d5c142dd$export$4bada75a9cb45bec = 'thisWeek';
const $7ad55196d5c142dd$export$1385d821597ee807 = 'thisMonth';
const $7ad55196d5c142dd$export$d64d14c448d5a065 = 'moreThanAMonth';
parcelRegister("paz61", function(module, exports) {
    $parcel$export(module.exports, "RecentMenu", ()=>$041364aacc6e1a81$export$9051cd0d0927b696);
    var $5uXOq = parcelRequire("5uXOq");
    var $hyKRO;
    var $htawR;
    var $47gW9;
    var $7XluA;
    var $4mO32;
    var $4R6GH;
    var $jecJ3;
    var $iszzG;
    var $46Cti;
    var $338xa;
    var $24a2m;
    var $8zOmE;
    var $2NMNM;
    var $koeKL;
    var $jUDIz;
    var $17aWz;
    var $lBNLs;
    var $kIiWz;
    var $jh7Sz;
    function $041364aacc6e1a81$export$9051cd0d0927b696({ isDefaultOpen: isDefaultOpen = false }) {
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("kIiWz")).default).recent, (0, ($parcel$interopDefault((0, parcelRequire("hyKRO"))))));
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("jh7Sz")).sidebarRecentMenuEntryPoint), {
            cloudId: cloudId,
            count: (0, $7ad55196d5c142dd$export$56ff071570537731)
        });
        const triggerRef = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(entryPointActions);
        const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iszzG")).NavItemsContext));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onOpenChange = (0, $5uXOq.useCallback)((isMenuOpen)=>{
            if (isDefaultOpen && isMenuOpen) entryPointActions.load();
            if (isMenuOpen) {
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
                });
                const isInMore = moreMenuIds.includes((0, (0, parcelRequire("46Cti")).L1_MENU_ID).RECENT);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_RECENT), {
                    isInMore: isInMore
                });
            }
        }, [
            entryPointActions,
            isDefaultOpen,
            moreMenuIds,
            createAnalyticsEvent
        ]);
        return (0, (0, parcelRequire("4R6GH")).fg)('jira_global_recent_menu_item') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("htawR")).GlobalRecentMenuItem), {
            triggerRef: triggerRef,
            onOpenChange: onOpenChange,
            isDefaultOpen: isDefaultOpen
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jUDIz")).FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isDefaultOpen: isDefaultOpen
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lBNLs")).FlyoutMenuItemTrigger), {
            interactionName: "nav4-sidebar-recent",
            ref: triggerRef,
            iconBefore: icon
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17aWz")).FlyoutMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-recent-default",
            packageName: (0, $7ad55196d5c142dd$export$b8b9d90f9e5bd72b),
            teamName: (0, $7ad55196d5c142dd$export$d57b6b390e78d90f),
            errorFallback: "flag",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null),
            runtimeProps: {}
        })));
    }
});
parcelRegister("htawR", function(module, exports) {
    $parcel$export(module.exports, "GlobalRecentMenuItem", ()=>$57b036c2634ba046$export$c58a64243715c6bf);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $hyKRO;
    var $jUDIz;
    var $17aWz;
    var $lBNLs;
    var $kiLoo;
    var $4JtKA;
    const $57b036c2634ba046$export$1a14f8e769122bb2 = (Content)=>({ onOpenChange: onOpenChange, isDefaultOpen: isDefaultOpen, triggerRef: triggerRef })=>{
            const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jUDIz")).FlyoutMenuItem), {
                onOpenChange: onOpenChange,
                isDefaultOpen: isDefaultOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lBNLs")).FlyoutMenuItemTrigger), {
                ref: triggerRef,
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyKRO"))))), {
                    label: "",
                    color: "currentColor"
                })
            }, formatMessage((0, (0, parcelRequire("4JtKA")).messages).flyoutMenuItemTriggerTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17aWz")).FlyoutMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement(Content, null)));
        };
    const $57b036c2634ba046$export$c58a64243715c6bf = $57b036c2634ba046$export$1a14f8e769122bb2((0, (0, parcelRequire("kiLoo")).GlobalRecentMenuContent));
});
parcelRegister("kiLoo", function(module, exports) {
    $parcel$export(module.exports, "GlobalRecentMenuContent", ()=>$47989ae97937a74d$export$29802207e0d6c9fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f4cXA;
    var $koVbs;
    var $l1N8i;
    var $i6luQ;
    var $dC5iT;
    var $luBm6;
    var $eMAVw;
    var $gSZmd;
    var $aAbfD;
    var $eeeRe;
    var $ekA4E;
    var $4JtKA;
    const $47989ae97937a74d$var$VIEW_ALL_LINK = 'https://home.atlassian.com/recents';
    const $47989ae97937a74d$var$LazyGlobalRecentItems = (0, $5uXOq.lazy)(()=>(parcelRequire("cvdHU")));
    const $47989ae97937a74d$export$29802207e0d6c9fc = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingInline: "space.075",
            paddingBlock: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("4JtKA")).messages).flyoutMenuItemTriggerTitle))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeeRe")).ErrorState), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ekA4E")).LoadingState), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($47989ae97937a74d$var$LazyGlobalRecentItems, null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aAbfD")).Divider), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMAVw")).MenuLinkItem), {
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("i6luQ"))))), {
                label: "",
                spacing: "spacious",
                color: "currentColor"
            }),
            href: $47989ae97937a74d$var$VIEW_ALL_LINK
        }, formatMessage((0, (0, parcelRequire("4JtKA")).messages).viewAllRecentItems))));
    };
    var $47989ae97937a74d$export$2e2bcd8739ae039 = $47989ae97937a74d$export$29802207e0d6c9fc;
});
parcelRegister("eeeRe", function(module, exports) {
    $parcel$export(module.exports, "ErrorState", ()=>$895870e33aa4e530$export$c1ed4f415b9e7023);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $l1N8i;
    var $dC5iT;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $4JtKA;
    const $895870e33aa4e530$export$c1ed4f415b9e7023 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $895870e33aa4e530$var$styles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            alignInline: "center",
            space: "space.050"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("4JtKA")).messages).errorStateHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            align: "center",
            color: "color.text.subtle"
        }, formatMessage((0, (0, parcelRequire("4JtKA")).messages).errorStateDescription))));
    };
    const $895870e33aa4e530$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlock: 'space.1000',
        paddingInline: 'space.100'
    });
});
parcelRegister("4JtKA", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2d3bb08aab81d13d$export$defe85febe8b728c);
    var $7VHMR;
    const $2d3bb08aab81d13d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        flyoutMenuItemTriggerTitle: {
            id: 'navigation.global-recent.flyout-menu-item-trigger-title.non-final',
            description: 'Label of the control that triggers the flyout menu.',
            defaultMessage: 'Recent'
        },
        viewAllRecentItems: {
            id: 'navigation.global-recent.view-all-recent-items.non-final',
            description: 'Label of the control that links to a page with all of the recent items.',
            defaultMessage: 'View all recent items'
        },
        menuSectionHeadingToday: {
            id: 'navigation.global-recent.menu-section-heading-today.non-final',
            description: "Heading of the section rendering today's items.",
            defaultMessage: 'Today'
        },
        menuSectionHeadingYesterday: {
            id: 'navigation.global-recent.menu-section-heading-yesterday.non-final',
            description: "Heading of the section rendering yesterday's items.",
            defaultMessage: 'Yesterday'
        },
        menuSectionHeadingThisWeek: {
            id: 'navigation.global-recent.menu-section-heading-this-week.non-final',
            description: 'Heading of the section rendering items for the current week.',
            defaultMessage: 'This week'
        },
        menuSectionHeadingThisMonth: {
            id: 'navigation.global-recent.menu-section-heading-this-month.non-final',
            description: 'Heading of the section rendering items for the current month.',
            defaultMessage: 'This Month'
        },
        menuSectionHeadingMoreThanAMonthAgo: {
            id: 'navigation.global-recent.menu-section-heading-this-month.non-final',
            description: 'Heading of the section rendering items older than a month ago.',
            defaultMessage: 'More than a month ago'
        },
        errorStateHeading: {
            id: 'navigation.global-recent.error-state-heading.non-final',
            description: "Heading of the error state UI indicating we couldn't load the data.",
            defaultMessage: "Can't load items"
        },
        errorStateDescription: {
            id: 'navigation.global-recent.error-state-description.non-final',
            description: "Description of the error state UI indicating we couldn't load the data.",
            defaultMessage: "We're having trouble loading your data. Please try again later."
        },
        emptyStateHeading: {
            id: 'navigation.global-recent.empty-state-heading.non-final',
            description: "Heading of the empty state UI indicating there's no content available.",
            defaultMessage: 'Nothing to see here!'
        },
        emptyStateDescription: {
            id: 'navigation.global-recent.empty-state-description.non-final',
            description: "Description of the empty state UI indicating there's no content available.",
            defaultMessage: "Once you visit, edit, or create items, they'll show up here."
        },
        loadingStateVisuallyHiddenLabel: {
            id: 'navigation.global-recent.loading-state-visually-hidden-label.non-final',
            description: 'Label of the loading state UI only available to screen reader users.',
            defaultMessage: 'Loading recent content'
        },
        confluenceDraftDefaultTitle: {
            id: 'navigation.global-recent.confluence-item-draft-title.non-final',
            description: 'Default title for draft pages and blog posts in Confluence.',
            defaultMessage: 'Untitled'
        },
        confluenceDraftLabel: {
            id: 'navigation.global-recent.confluence-item-draft-label.non-final',
            description: 'Label of the lozenge indicating a Confluence item is a draft.',
            defaultMessage: 'Draft'
        }
    });
});
parcelRegister("ekA4E", function(module, exports) {
    $parcel$export(module.exports, "LoadingState", ()=>$48beae453ce3023e$export$62aa48085237e36f);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $iwwXK;
    var $jldZL;
    var $1qQhw;
    var $4JtKA;
    const $48beae453ce3023e$export$62aa48085237e36f = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const items = Array.from({
            length: 5
        }, (_, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
                isShimmering: true,
                width: "100%"
            })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, formatMessage((0, (0, parcelRequire("4JtKA")).messages).loadingStateVisuallyHiddenLabel)), items);
    };
});
parcelRegister("cvdHU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cTXNp").then(()=>parcelRequire('iUmYx'));
});
parcelRegister("kIiWz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa748d68241ef7a4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fa748d68241ef7a4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        recent: {
            "id": "navigation-apps-sidebar-nav4-recent.recent",
            "defaultMessage": "Recent"
        }
    });
});
parcelRegister("jh7Sz", function(module, exports) {
    $parcel$export(module.exports, "sidebarRecentMenuEntryPoint", ()=>$59b75f87881a1c54$export$52be5f9ca0100885);
    var $4R6GH;
    var $6sGCE;
    var $eufEc;
    var $fEDBv;
    const $59b75f87881a1c54$export$52be5f9ca0100885 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("WLIiV")), {
            moduleId: "1a0fa847"
        }),
        getPreloadProps: ({ cloudId: cloudId, count: count })=>({
                queries: {
                    recentMenuData: {
                        parameters: (0, parcelRequire("6sGCE")).default,
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        variables: {
                            cloudId: cloudId,
                            count: count,
                            keyword: '',
                            isEapDrop2Enabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2')
                        }
                    }
                }
            })
    });
});
parcelRegister("6sGCE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de7f5d7554961488$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    const $de7f5d7554961488$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "count"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEapDrop2Enabled"
        }, v3 = {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "keyword"
        }, v4 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v5 = {
            "kind": "Variable",
            "name": "keyword",
            "variableName": "keyword"
        }, v6 = {
            "kind": "Literal",
            "name": "types",
            "value": [
                "PROJECT",
                "FILTER",
                "DASHBOARD",
                "BOARD",
                "QUEUE",
                "ISSUE",
                "PLAN"
            ]
        }, v7 = [
            v4,
            {
                "fields": [
                    v5
                ],
                "kind": "ObjectValue",
                "name": "filter"
            },
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            },
            v6
        ], v8 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "startCursor"
                }
            ]
        }, v9 = [
            v4,
            {
                "fields": [
                    {
                        "kind": "Literal",
                        "name": "includeArchivedProjects",
                        "value": false
                    },
                    v5
                ],
                "kind": "ObjectValue",
                "name": "filter"
            },
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "count"
            },
            v6
        ], v10 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v11 = {
            "kind": "ScalarField",
            "name": "id"
        }, v12 = {
            "kind": "ScalarField",
            "name": "lastViewedTimestamp"
        }, v13 = {
            "kind": "InlineFragment",
            "selections": [
                v11
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v14 = {
            "kind": "ScalarField",
            "name": "boardId"
        }, v15 = [
            v11,
            v12,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "filterName",
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "filterUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "filterId"
                    }
                ],
                "type": "JiraFilter",
                "abstractKey": "__isJiraFilter"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3
                ],
                "kind": "Fragment",
                "name": "recentMenuQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": "recent",
                                        "args": v7,
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v8,
                                                "action": "THROW",
                                                "path": "jira.recent.pageInfo"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.recent"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "count",
                                "variableName": "count"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "recentMenu_navigationAppsSidebarNav4SidebarsContentRecent"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v3,
                    v1,
                    v2
                ],
                "kind": "Operation",
                "name": "recentMenuQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "recent",
                                "args": v7,
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    v8
                                ]
                            },
                            {
                                "alias": "_recentItems",
                                "args": v9,
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v10,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v11,
                                                            v12,
                                                            {
                                                                "concreteType": "JiraSingleLineTextField",
                                                                "kind": "LinkedField",
                                                                "name": "summaryField",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "text"
                                                                    },
                                                                    v11
                                                                ]
                                                            },
                                                            {
                                                                "alias": "issueWebUrl",
                                                                "kind": "ScalarField",
                                                                "name": "webUrl"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "issueId"
                                                            }
                                                        ],
                                                        "type": "JiraIssue"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v11,
                                                            v12,
                                                            {
                                                                "alias": "title",
                                                                "kind": "ScalarField",
                                                                "name": "name"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "key"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "projectType"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "webUrl"
                                                            },
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "defaultNavigationItem",
                                                                "plural": false,
                                                                "selections": [
                                                                    v10,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "typeKey"
                                                                            }
                                                                        ],
                                                                        "type": "JiraNavigationItem",
                                                                        "abstractKey": "__isJiraNavigationItem"
                                                                    },
                                                                    v13
                                                                ]
                                                            },
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "navigationMetadata",
                                                                "plural": false,
                                                                "selections": [
                                                                    v10,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v14,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "isSimpleBoard"
                                                                            },
                                                                            v11
                                                                        ],
                                                                        "type": "JiraSoftwareProjectNavigationMetadata"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "description"
                                                            },
                                                            {
                                                                "concreteType": "JiraAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "large"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "projectId"
                                                            }
                                                        ],
                                                        "type": "JiraProject"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v11,
                                                            v12,
                                                            {
                                                                "condition": "isEapDrop2Enabled",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "planId"
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraScenario",
                                                                        "kind": "LinkedField",
                                                                        "name": "scenario",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "scenarioId"
                                                                            },
                                                                            v11
                                                                        ]
                                                                    },
                                                                    {
                                                                        "alias": "planTitle",
                                                                        "kind": "ScalarField",
                                                                        "name": "title"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraPlan"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v11,
                                                            v12,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "name"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "boardUrl"
                                                            },
                                                            v14
                                                        ],
                                                        "type": "JiraBoard"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v11,
                                                            v12,
                                                            {
                                                                "alias": "dashboardTitle",
                                                                "kind": "ScalarField",
                                                                "name": "title"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "dashboardUrl"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "dashboardId"
                                                            }
                                                        ],
                                                        "type": "JiraDashboard"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": v15,
                                                        "type": "JiraSystemFilter"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": v15,
                                                        "type": "JiraCustomFilter"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v11,
                                                            v12,
                                                            {
                                                                "alias": "queueTitle",
                                                                "kind": "ScalarField",
                                                                "name": "title"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "queueUrl"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "queueId"
                                                            }
                                                        ],
                                                        "type": "JiraServiceManagementQueue"
                                                    },
                                                    v13
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "alias": "_recentItems",
                                "args": v9,
                                "filters": [
                                    "cloudId",
                                    "types",
                                    "filter"
                                ],
                                "handle": "connection",
                                "key": "RecentMenuContent__recentItems",
                                "kind": "LinkedHandle",
                                "name": "recentItems"
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "90c4e2c99d742f6808f0e7ff5013ecb2de16348bdf79e9592d1a0456a9fdbe3e",
                "metadata": {},
                "name": "recentMenuQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $de7f5d7554961488$var$node.hash = "94e27adeb440e09abc6c822a3d4eefbd";
    (0, $eiowN.PreloadableQueryRegistry).set($de7f5d7554961488$var$node.params.id, $de7f5d7554961488$var$node);
    var $de7f5d7554961488$export$2e2bcd8739ae039 = $de7f5d7554961488$var$node;
});
parcelRegister("WLIiV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("04G5Q")
    ]).then(()=>parcelRequire('U4Few'));
});
parcelRegister("3J4Wg", function(module, exports) {
    $parcel$export(module.exports, "Nav4Roadmaps", ()=>$3d2666959f2cadcc$export$257bbde911c73386);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $l8ruj;
    var $goFx9;
    const $3d2666959f2cadcc$export$257bbde911c73386 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-roadmaps"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "roadmaps-section",
            packageName: (0, $071bfededeb4df80$export$b8b9d90f9e5bd72b),
            teamName: (0, $071bfededeb4df80$export$d57b6b390e78d90f)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("goFx9")).Nav4RoadmapsContainer), props)));
});
const $071bfededeb4df80$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Roadmaps';
const $071bfededeb4df80$export$d57b6b390e78d90f = 'jpd-aurora';
const $071bfededeb4df80$export$3fc15b6d7f7757ac = 'viewAllRoadmaps';
const $071bfededeb4df80$export$862abc666c31a61a = 'createRoadmaps';
const $071bfededeb4df80$export$f06dfcec5ff912e = 'meatballDropdown';
parcelRegister("goFx9", function(module, exports) {
    $parcel$export(module.exports, "Nav4RoadmapsContainer", ()=>$e6e3de17ba8008de$export$ed3c6c4c390f5940);
    var $5uXOq = parcelRequire("5uXOq");
    var $agzbr;
    var $9OXo1;
    var $6ZDS2;
    var $fBbR0;
    var $5Ah0W;
    function $e6e3de17ba8008de$export$ed3c6c4c390f5940(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ZDS2")).AnalyticContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement($e6e3de17ba8008de$export$257bbde911c73386, props));
    }
    const $e6e3de17ba8008de$export$257bbde911c73386 = ({ isExpanded: isExpanded })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e6e3de17ba8008de$var$EmojiDataContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Ah0W")).RoadmapsDefault), {
            actionsOnHover: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fBbR0")).ActionButtons), null),
            isExpanded: isExpanded
        }));
    };
    const $e6e3de17ba8008de$var$EmojiDataContainer = ({ children: children })=>{
        const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("agzbr")).EmojiContainer), {
            cloudId: cloudId,
            currentUser: atlassianAccountId || undefined
        }, children);
    };
});
parcelRegister("agzbr", function(module, exports) {
    $parcel$export(module.exports, "useEmoji", ()=>$9992f7de1dfa0390$export$482903c4ce3f5633);
    $parcel$export(module.exports, "useEmojiById", ()=>$9992f7de1dfa0390$export$659ae98cb5b73fba);
    $parcel$export(module.exports, "useEmojiProviderPromise", ()=>$9992f7de1dfa0390$export$d020ccccbff96c19);
    $parcel$export(module.exports, "EmojiContainer", ()=>$9992f7de1dfa0390$export$5138cd734f185a21);
    var $5uXOq = parcelRequire("5uXOq");
    var $hXRXz;
    var $gg7kZ;
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    const $9992f7de1dfa0390$var$actions = {
        loadEmoji: (emojiId)=>async ({ getState: getState, setState: setState })=>{
                const { provider: provider } = getState();
                if (!provider) return;
                const resolvedProvider = await provider;
                const optionalDescription = await resolvedProvider.findById(emojiId);
                const emoji = optionalDescription !== undefined ? await resolvedProvider.getMediaEmojiDescriptionURLWithInlineToken(optionalDescription) : optionalDescription;
                setState({
                    cachedEmojis: {
                        ...getState().cachedEmojis,
                        [emojiId]: emoji ?? null
                    }
                });
            }
    };
    const $9992f7de1dfa0390$var$initialState = {
        provider: undefined,
        cachedEmojis: {}
    };
    const $9992f7de1dfa0390$var$EmojiStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $9992f7de1dfa0390$var$initialState,
        actions: $9992f7de1dfa0390$var$actions,
        name: 'PolarisEmojiStore'
    });
    const $9992f7de1dfa0390$var$useEmojis = (0, (0, parcelRequire("3sQ5x")).createHook)($9992f7de1dfa0390$var$EmojiStore);
    const $9992f7de1dfa0390$export$482903c4ce3f5633 = (emojiId)=>{
        const [emoji, setEmoji] = (0, $5uXOq.useState)(undefined);
        const [{ provider: provider }] = $9992f7de1dfa0390$var$useEmojis();
        (0, $5uXOq.useEffect)(()=>{
            if (emojiId !== undefined && provider !== undefined) provider.then((resolvedProvider)=>{
                Promise.resolve(resolvedProvider.findById(emojiId)).then((optionalDescription)=>optionalDescription !== undefined ? resolvedProvider.getMediaEmojiDescriptionURLWithInlineToken(optionalDescription) : optionalDescription).then(setEmoji);
            });
            else setEmoji(undefined);
        }, [
            provider,
            emojiId
        ]);
        return emojiId !== undefined ? emoji : undefined;
    };
    const $9992f7de1dfa0390$export$659ae98cb5b73fba = (0, (0, parcelRequire("3sQ5x")).createHook)($9992f7de1dfa0390$var$EmojiStore, {
        selector: (0, (0, parcelRequire("6dDSs")).createSelector)((state, { emojiId: emojiId })=>emojiId ? state.cachedEmojis[emojiId] : undefined, (emoji)=>emoji)
    });
    const $9992f7de1dfa0390$export$d020ccccbff96c19 = ()=>{
        const [{ provider: provider }] = $9992f7de1dfa0390$var$useEmojis();
        return provider !== undefined ? provider : Promise.reject(new Error('emoji provider not initialized'));
    };
    const $9992f7de1dfa0390$export$5138cd734f185a21 = (0, (0, parcelRequire("gg7kZ")).createContainer)($9992f7de1dfa0390$var$EmojiStore, {
        onInit: ()=>(storeActionApi, { cloudId: cloudId, currentUser: currentUser })=>{
                storeActionApi.setState({
                    provider: (0, (0, parcelRequire("hXRXz")).getEmojiProviderWithCustomEmoji)(cloudId, currentUser) || undefined
                });
            }
    });
});
parcelRegister("hXRXz", function(module, exports) {
    $parcel$export(module.exports, "getEmojiProvider", ()=>$8599af293a85f3b3$export$8210f5f78c0bcf27);
    $parcel$export(module.exports, "getEmojiProviderWithCustomEmoji", ()=>$8599af293a85f3b3$export$f9c5a1e85ff0cb72);
    $parcel$export(module.exports, "getEmojiProviderWithCustomEmojiUploadDisabled", ()=>$8599af293a85f3b3$export$7cda0fc535c2710f);
    var $3Uu1D;
    var $9CGZY;
    const $8599af293a85f3b3$var$baseProviders = (serviceBaseUrl)=>[
            {
                url: `${serviceBaseUrl}/emoji/standard`
            },
            {
                url: `${serviceBaseUrl}/emoji/atlassian`
            }
        ];
    const $8599af293a85f3b3$export$8210f5f78c0bcf27 = ()=>(0, (0, parcelRequire("9CGZY")).getServiceProvider)((0, (0, parcelRequire("9CGZY")).EMOJI_SERVICEID), (serviceBaseUrl)=>{
            const emojiResource = new (0, (0, parcelRequire("3Uu1D")).default)({
                providers: $8599af293a85f3b3$var$baseProviders(serviceBaseUrl)
            });
            return emojiResource.getEmojiProvider();
        });
    const $8599af293a85f3b3$export$f9c5a1e85ff0cb72 = (cloudId, accountId)=>(0, (0, parcelRequire("9CGZY")).getServiceProvider)((0, (0, parcelRequire("9CGZY")).EMOJI_WITH_CUSTOM_SERVICEID), (serviceBaseUrl)=>{
            const providers = cloudId ? [
                ...$8599af293a85f3b3$var$baseProviders(serviceBaseUrl),
                {
                    url: `${serviceBaseUrl}/emoji/${cloudId}/site`
                }
            ] : $8599af293a85f3b3$var$baseProviders(serviceBaseUrl);
            const emojiResource = new (0, (0, parcelRequire("3Uu1D")).default)({
                providers: providers,
                allowUpload: true,
                currentUser: {
                    id: accountId
                }
            });
            return emojiResource.getEmojiProvider();
        });
    const $8599af293a85f3b3$export$7cda0fc535c2710f = (cloudId, accountId)=>(0, (0, parcelRequire("9CGZY")).getServiceProvider)((0, (0, parcelRequire("9CGZY")).EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID), (serviceBaseUrl)=>{
            const providers = cloudId ? [
                ...$8599af293a85f3b3$var$baseProviders(serviceBaseUrl),
                {
                    url: `${serviceBaseUrl}/emoji/${cloudId}/site`
                }
            ] : $8599af293a85f3b3$var$baseProviders(serviceBaseUrl);
            const emojiResource = new (0, (0, parcelRequire("3Uu1D")).default)({
                providers: providers,
                allowUpload: false,
                currentUser: {
                    id: accountId
                }
            });
            return emojiResource.getEmojiProvider();
        });
});
parcelRegister("3Uu1D", function(module, exports) {
    $parcel$export(module.exports, "supportsUploadFeature", ()=>$b4e19b4b20da22f1$export$7b697b720032fd6f);
    $parcel$export(module.exports, "default", ()=>$b4e19b4b20da22f1$export$2e2bcd8739ae039);
    var $dS9cn = parcelRequire("dS9cn");
    var $kin1Z;
    var $b8sgr;
    var $5B9Cy;
    var $d9blH;
    var $9AR2K;
    var $f2M1N;
    var $WeQTx;
    var $62WHo;
    var $d2UcN;
    const $b4e19b4b20da22f1$export$7b697b720032fd6f = (emojiProvider)=>{
        const emojiUploadProvider = emojiProvider;
        return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
    };
    class $b4e19b4b20da22f1$export$b5efafc6dd611ec5 extends (0, $dS9cn.AbstractResource) {
        constructor(config){
            super(), this.activeLoaders = 0, this.initialLoaders = 0, this.retries = new Map(), this.isInitialised = false, this.fetchOnDemand = false, this.getOptimisticImageURL = (emojiId)=>{
                if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
                return;
            }, this.isRepositoryAvailable = (repository)=>{
                return !!repository;
            }, this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
            this.emojiProviderConfig = config;
            this.recordConfig = config.recordConfig;
            this.currentUser = config.currentUser;
            if ((0, (0, parcelRequire("d9blH")).default)('localStorage')) this.selectedTone = this.loadStoredTone();
            if (config.providers.length === 0) throw new Error('No providers specified');
            this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
            this.initialLoaders = this.emojiProviderConfig.providers.length;
            this.activeLoaders = this.emojiProviderConfig.providers.length;
            this.emojiResponses = [];
        }
        async getEmojiProvider(options = {
            fetchAtStart: !this.fetchOnDemand
        }) {
            if (options.fetchAtStart) try {
                await this.fetchEmojiProvider();
            } catch (error) {
                (0, (0, parcelRequire("b8sgr")).default)(error);
                return Promise.resolve(this);
            }
            return Promise.resolve(this);
        }
        async fetchIndividualProvider(provider, index) {
            const providerType = this.getProviderType(provider);
            try {
                (0, (0, parcelRequire("d2UcN")).sampledUfoEmojiResourceFetched)(providerType).start({
                    samplingRate: (0, (0, parcelRequire("kin1Z")).SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
                });
                (0, (0, parcelRequire("d2UcN")).sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                    type: providerType
                });
                const loader = new (0, (0, parcelRequire("f2M1N")).default)(provider);
                const emojiResponse = await loader.loadEmoji();
                (0, (0, parcelRequire("d2UcN")).sampledUfoEmojiResourceFetched)(providerType).success();
                this.emojiResponses[index] = emojiResponse;
                this.initEmojiRepository(this.emojiResponses);
                await this.initSiteEmojiResource(emojiResponse, provider);
                this.activeLoaders--;
                this.performRetries();
                this.refreshLastFilter();
            } catch (error) {
                this.activeLoaders--;
                this.notifyError(error);
                (0, (0, parcelRequire("d2UcN")).sampledUfoEmojiResourceFetched)(providerType).failure({
                    metadata: {
                        reason: error,
                        source: 'EmojiProvider',
                        providerUrl: provider.url
                    }
                });
                (0, (0, parcelRequire("b8sgr")).default)(`failed to fetch emoji provider for ${provider.url}`, error);
                throw new Error(`failed to fetch emoji from ${provider.url}`);
            }
        }
        async fetchEmojiProvider(force = false) {
            if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
                this.isInitialised = true;
                this.emojiResponses = [];
                await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
            }
            return Promise.resolve(this.emojiRepository);
        }
        onlyFetchOnDemand() {
            return this.fetchOnDemand;
        }
        async fetchByEmojiId(emojiId, optimistic) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
                const emoji = await this.findByEmojiId(emojiId);
                if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
            if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
                const provider = {
                    url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                    securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
                };
                const loader = new (0, (0, parcelRequire("f2M1N")).default)(provider);
                try {
                    const loadEmoji = await loader.loadEmoji();
                    if (!loadEmoji.emojis[0]) return;
                    if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                    return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
                } catch  {
                    const emoji = await this.findByEmojiId(emojiId);
                    if (!emoji) return;
                    return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
                }
            }
            const emoji = await this.findByEmojiId(emojiId);
            if (!emoji) return;
            return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        getProviderType(provider) {
            if (provider.url.includes('/site')) return (0, (0, parcelRequire("9AR2K")).ProviderTypes).SITE;
            else if (provider.url.includes('/standard')) return (0, (0, parcelRequire("9AR2K")).ProviderTypes).STANDARD;
            else if (provider.url.includes('/atlassian')) return (0, (0, parcelRequire("9AR2K")).ProviderTypes).ATLASSIAN;
            return (0, (0, parcelRequire("9AR2K")).ProviderTypes).UNKNOWN;
        }
        initEmojiRepository(emojiResponses) {
            let emojis = [];
            emojiResponses.forEach((emojiResponse)=>{
                emojis = emojis.concat(emojiResponse.emojis);
            });
            this.emojiRepository = new (0, (0, parcelRequire("WeQTx")).default)(emojis);
        }
        initSiteEmojiResource(emojiResponse, provider) {
            if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
                this.siteEmojiResource = new (0, (0, parcelRequire("62WHo")).default)(provider, emojiResponse.mediaApiToken);
                const { emojis: emojis } = emojiResponse;
                if (emojis.length) {
                    const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                    if ((0, (0, parcelRequire("5B9Cy")).isPromise)(done)) return done.then(()=>{
                        (0, (0, parcelRequire("b8sgr")).default)('Primed siteEmojiResource');
                    }).catch(()=>{
                        (0, (0, parcelRequire("b8sgr")).default)('Failed to prime siteEmojiResource');
                    });
                    else (0, (0, parcelRequire("b8sgr")).default)('Already primed siteEmojiResource');
                } else (0, (0, parcelRequire("b8sgr")).default)('No emoji to prime siteEmojiResource with');
            }
            return Promise.resolve();
        }
        performRetries() {
            const currentRetries = this.retries;
            this.retries = new Map();
            currentRetries.forEach((resolveReject, retry)=>{
                const result = retry();
                if ((0, (0, parcelRequire("5B9Cy")).isPromise)(result)) result.then((response)=>{
                    resolveReject.resolve(response);
                }).catch((reason)=>{
                    resolveReject.reject(reason);
                });
                else resolveReject.resolve(result);
            });
        }
        loadStoredTone() {
            if (typeof window === 'undefined') return undefined;
            const storedToneString = window.localStorage.getItem((0, (0, parcelRequire("kin1Z")).selectedToneStorageKey));
            if (storedToneString) {
                const storedTone = parseInt(storedToneString, 10);
                return !isNaN(storedTone) ? storedTone : undefined;
            }
            return undefined;
        }
        refreshLastFilter() {
            if (typeof this.lastQuery !== 'undefined') {
                const { query: query, options: options } = this.lastQuery;
                this.filter(query, options);
            }
        }
        retryIfLoading(retry, defaultResponse) {
            if (!this.isLoaded()) return new Promise((resolve, reject)=>{
                this.retries.set(retry, {
                    resolve: resolve,
                    reject: reject
                });
            });
            return Promise.resolve(defaultResponse);
        }
        notifyResult(result) {
            if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
        }
        async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
            if (this.isRepositoryAvailable(this.siteEmojiResource)) {
                const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
                return {
                    ...emoji,
                    representation: representation,
                    altRepresentation: altRepresentation
                };
            }
            return emoji;
        }
        loadMediaEmoji(emoji, useAlt) {
            if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, (0, parcelRequire("5B9Cy")).isMediaEmoji)(emoji)) return emoji;
            return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
        }
        optimisticMediaRendering(emoji, useAlt) {
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaEmoji)(emoji)) return true;
            if (!this.isRepositoryAvailable(this.siteEmojiResource)) return false;
            const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
            if ((0, (0, parcelRequire("5B9Cy")).isPromise)(optimistic)) return false;
            return optimistic;
        }
        filter(query, options) {
            (0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-searched'].start();
            (0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-searched'].addMetadata({
                queryLength: query?.length || 0
            });
            this.lastQuery = {
                query: query,
                options: options
            };
            if (this.isRepositoryAvailable(this.emojiRepository)) {
                const searchResults = this.emojiRepository.search(query, options);
                this.notifyResult(searchResults);
                (0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-searched'].success({
                    metadata: {
                        emojisLength: searchResults.emojis.length,
                        source: options?.source || 'typeahead'
                    }
                });
            } else this.notifyNotReady();
        }
        findByShortName(shortName) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findByShortName(shortName);
            return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
        }
        findByEmojiId(emojiId) {
            const { id: id, shortName: shortName } = emojiId;
            if (this.isRepositoryAvailable(this.emojiRepository)) {
                if (id) {
                    const emoji = this.emojiRepository.findById(id);
                    if (emoji) return emoji;
                    if (this.isLoaded()) {
                        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                            if (!emoji) return this.findByShortName(shortName);
                            this.addUnknownEmoji(emoji);
                            return emoji;
                        });
                        return this.findByShortName(shortName);
                    }
                } else return this.findByShortName(shortName);
            }
            return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
        }
        findById(id) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
            return this.retryIfLoading(()=>this.findById(id), undefined);
        }
        findInCategory(categoryId) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
            return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
        }
        getAsciiMap() {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
            return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
        }
        getFrequentlyUsed(options) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
            return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
        }
        recordSelection(emoji) {
            const { recordConfig: recordConfig } = this;
            if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
            if (recordConfig) {
                const queryParams = {
                    emojiId: (0, (0, parcelRequire("5B9Cy")).toEmojiId)(emoji)
                };
                const requestInit = {
                    method: 'POST'
                };
                return (0, $dS9cn.utils).requestService(recordConfig, {
                    queryParams: queryParams,
                    requestInit: requestInit
                });
            }
            return Promise.resolve();
        }
        deleteSiteEmoji(emoji) {
            if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
                if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                    this.emojiRepository.delete(emoji);
                    return true;
                }
                return false;
            }).catch((err)=>{
                console.error('failed to delete site emoji', err);
                return false;
            });
            return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
        }
        getSelectedTone() {
            return this.selectedTone;
        }
        setSelectedTone(tone) {
            this.selectedTone = tone;
            if (typeof window === 'undefined') return;
            if ((0, (0, parcelRequire("d9blH")).default)('localStorage')) try {
                window.localStorage.setItem((0, (0, parcelRequire("kin1Z")).selectedToneStorageKey), tone ? tone.toString() : '');
            } catch (e) {
                console.error('failed to store selected emoji skin tone', e);
            }
        }
        calculateDynamicCategories() {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
            return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
        }
        getCurrentUser() {
            return this.currentUser;
        }
        addUnknownEmoji(emoji) {
            if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
        }
    }
    class $b4e19b4b20da22f1$export$2e2bcd8739ae039 extends $b4e19b4b20da22f1$export$b5efafc6dd611ec5 {
        constructor(config){
            super(config);
            this.allowUpload = !!config.allowUpload;
        }
        isUploadSupported() {
            if (!this.allowUpload) return Promise.resolve(false);
            if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
            return this.retryIfLoading(()=>this.isUploadSupported(), false);
        }
        uploadCustomEmoji(upload, retry = false) {
            return this.isUploadSupported().then((supported)=>{
                if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
                return this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                    emoji.representation.imagePath = upload.dataURL;
                    this.addUnknownEmoji(emoji);
                    this.refreshLastFilter();
                    return emoji;
                });
            });
        }
        prepareForUpload() {
            if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
            return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
        }
    }
});
parcelRegister("kin1Z", function(module, exports) {
    $parcel$export(module.exports, "customCategory", ()=>$1c1f8a5ed290c232$export$5e4e3d1c3e43156a);
    $parcel$export(module.exports, "frequentCategory", ()=>$1c1f8a5ed290c232$export$78ccdc4be403c468);
    $parcel$export(module.exports, "searchCategory", ()=>$1c1f8a5ed290c232$export$1b0258512be88334);
    $parcel$export(module.exports, "yourUploadsCategory", ()=>$1c1f8a5ed290c232$export$42b510423367f354);
    $parcel$export(module.exports, "customTitle", ()=>$1c1f8a5ed290c232$export$5d0f2d8ee50f86f5);
    $parcel$export(module.exports, "userCustomTitle", ()=>$1c1f8a5ed290c232$export$1debc2f10cc69389);
    $parcel$export(module.exports, "dataURLPrefix", ()=>$1c1f8a5ed290c232$export$8ac325bfd32359b0);
    $parcel$export(module.exports, "deleteEmojiLabel", ()=>$1c1f8a5ed290c232$export$a330961542edfe6f);
    $parcel$export(module.exports, "MAX_ORDINAL", ()=>$1c1f8a5ed290c232$export$1a817f1886276c6d);
    $parcel$export(module.exports, "defaultEmojiHeight", ()=>$1c1f8a5ed290c232$export$3f99ac31dc0406db);
    $parcel$export(module.exports, "emojiPickerWidth", ()=>$1c1f8a5ed290c232$export$d171dc12fee2b1da);
    $parcel$export(module.exports, "sizeGap", ()=>$1c1f8a5ed290c232$export$c10ac8125a260041);
    $parcel$export(module.exports, "defaultEmojiPickerSize", ()=>$1c1f8a5ed290c232$export$5248fb9e0cccc41f);
    $parcel$export(module.exports, "emojiPickerMinHeight", ()=>$1c1f8a5ed290c232$export$94f75d625e7801d3);
    $parcel$export(module.exports, "emojiPickerHeight", ()=>$1c1f8a5ed290c232$export$7ed599d166d65aea);
    $parcel$export(module.exports, "emojiPickerListHeight", ()=>$1c1f8a5ed290c232$export$7722b8e9522021df);
    $parcel$export(module.exports, "emojiPickerHeightWithPreview", ()=>$1c1f8a5ed290c232$export$e67f617938b111f1);
    $parcel$export(module.exports, "localStoragePrefix", ()=>$1c1f8a5ed290c232$export$e394a0c530ae5631);
    $parcel$export(module.exports, "selectedToneStorageKey", ()=>$1c1f8a5ed290c232$export$79ee4ef84c545f8f);
    $parcel$export(module.exports, "defaultCategories", ()=>$1c1f8a5ed290c232$export$d7ab74456f1aa1ad);
    $parcel$export(module.exports, "KeyboardKeys", ()=>$1c1f8a5ed290c232$export$70f9e5bc10d7eac);
    $parcel$export(module.exports, "KeyboardNavigationDirection", ()=>$1c1f8a5ed290c232$export$1c4f2adc1f8e19d3);
    $parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", ()=>$1c1f8a5ed290c232$export$99130b698ea188ae);
    $parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", ()=>$1c1f8a5ed290c232$export$84b035f8d01101cc);
    $parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", ()=>$1c1f8a5ed290c232$export$e27d4e477c0cd4ec);
    $parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", ()=>$1c1f8a5ed290c232$export$97027974dc06eeee);
    $parcel$export(module.exports, "DEFAULT_TONE", ()=>$1c1f8a5ed290c232$export$4f0ee90b28d6efc5);
    $parcel$export(module.exports, "EMOJI_LIST_COLUMNS", ()=>$1c1f8a5ed290c232$export$2829f3ec323f8ec0);
    $parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", ()=>$1c1f8a5ed290c232$export$ce3a0e7d2d7d6ba2);
    $parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", ()=>$1c1f8a5ed290c232$export$858e8dc100a97278);
    $parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", ()=>$1c1f8a5ed290c232$export$83aab2ae64548423);
    $parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", ()=>$1c1f8a5ed290c232$export$66cabad5e268b05e);
    const $1c1f8a5ed290c232$export$5e4e3d1c3e43156a = 'CUSTOM';
    const $1c1f8a5ed290c232$export$78ccdc4be403c468 = 'FREQUENT';
    const $1c1f8a5ed290c232$export$2c4b04c3aacdf1b3 = 'SITE';
    const $1c1f8a5ed290c232$export$1b0258512be88334 = 'SEARCH';
    const $1c1f8a5ed290c232$export$42b510423367f354 = 'USER_CUSTOM';
    const $1c1f8a5ed290c232$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
    const $1c1f8a5ed290c232$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
    const $1c1f8a5ed290c232$export$8ac325bfd32359b0 = 'data:';
    const $1c1f8a5ed290c232$export$a330961542edfe6f = 'delete-emoji';
    const $1c1f8a5ed290c232$export$1a817f1886276c6d = 100000;
    const $1c1f8a5ed290c232$export$3f99ac31dc0406db = 20;
    const $1c1f8a5ed290c232$export$d171dc12fee2b1da = 350;
    const $1c1f8a5ed290c232$export$c10ac8125a260041 = 80;
    const $1c1f8a5ed290c232$export$5248fb9e0cccc41f = 'medium';
    const $1c1f8a5ed290c232$export$94f75d625e7801d3 = 260;
    const $1c1f8a5ed290c232$export$7ed599d166d65aea = 295;
    const $1c1f8a5ed290c232$export$7722b8e9522021df = $1c1f8a5ed290c232$export$7ed599d166d65aea - 58;
    const $1c1f8a5ed290c232$export$e218e5cb105a0e22 = 54;
    const $1c1f8a5ed290c232$export$e67f617938b111f1 = $1c1f8a5ed290c232$export$7ed599d166d65aea + $1c1f8a5ed290c232$export$e218e5cb105a0e22;
    const $1c1f8a5ed290c232$export$e394a0c530ae5631 = 'fabric.emoji';
    const $1c1f8a5ed290c232$export$79ee4ef84c545f8f = `${$1c1f8a5ed290c232$export$e394a0c530ae5631}.selectedTone`;
    const $1c1f8a5ed290c232$export$d7ab74456f1aa1ad = [
        'PEOPLE',
        'NATURE',
        'FOODS',
        'ACTIVITY',
        'PLACES',
        'OBJECTS',
        'SYMBOLS',
        'FLAGS'
    ];
    var $1c1f8a5ed290c232$export$70f9e5bc10d7eac;
    (function(KeyboardKeys) {
        KeyboardKeys["ArrowLeft"] = "ArrowLeft";
        KeyboardKeys["ArrowRight"] = "ArrowRight";
        KeyboardKeys["ArrowUp"] = "ArrowUp";
        KeyboardKeys["ArrowDown"] = "ArrowDown";
        KeyboardKeys["PageUp"] = "PageUp";
        KeyboardKeys["PageDown"] = "PageDown";
        KeyboardKeys["Home"] = "Home";
        KeyboardKeys["End"] = "End";
        KeyboardKeys["Enter"] = "Enter";
        KeyboardKeys["Tab"] = "Tab";
        KeyboardKeys["Space"] = " ";
        KeyboardKeys["Backspace"] = "Backspace";
    })($1c1f8a5ed290c232$export$70f9e5bc10d7eac || ($1c1f8a5ed290c232$export$70f9e5bc10d7eac = {}));
    var $1c1f8a5ed290c232$export$1c4f2adc1f8e19d3;
    (function(KeyboardNavigationDirection) {
        KeyboardNavigationDirection["Down"] = "Down";
        KeyboardNavigationDirection["Up"] = "Up";
        KeyboardNavigationDirection["Left"] = "Left";
        KeyboardNavigationDirection["Right"] = "Right";
    })($1c1f8a5ed290c232$export$1c4f2adc1f8e19d3 || ($1c1f8a5ed290c232$export$1c4f2adc1f8e19d3 = {}));
    const $1c1f8a5ed290c232$export$99130b698ea188ae = [
        "ArrowRight",
        "ArrowLeft",
        "Home",
        "End"
    ];
    const $1c1f8a5ed290c232$export$84b035f8d01101cc = [
        "Enter",
        "Backspace",
        " "
    ];
    const $1c1f8a5ed290c232$export$e27d4e477c0cd4ec = [
        "Enter",
        "Tab",
        " "
    ];
    const $1c1f8a5ed290c232$export$97027974dc06eeee = [
        "ArrowRight",
        "ArrowLeft",
        "Home",
        "End",
        "ArrowUp",
        "ArrowDown",
        "PageUp",
        "PageDown"
    ];
    const $1c1f8a5ed290c232$export$4f0ee90b28d6efc5 = 0;
    const $1c1f8a5ed290c232$export$9f7de4293d27f3aa = 50;
    const $1c1f8a5ed290c232$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
    const $1c1f8a5ed290c232$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
    const $1c1f8a5ed290c232$export$2829f3ec323f8ec0 = 8;
    const $1c1f8a5ed290c232$export$ce3a0e7d2d7d6ba2 = 5;
    const $1c1f8a5ed290c232$export$858e8dc100a97278 = 150;
    const $1c1f8a5ed290c232$export$83aab2ae64548423 = 20;
    const $1c1f8a5ed290c232$export$66cabad5e268b05e = 100;
});
parcelRegister("b8sgr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b76154abb8f2c59$export$2e2bcd8739ae039);
    let $1b76154abb8f2c59$var$debugEnabled = false;
    let $1b76154abb8f2c59$var$stacktracesEnabled = false;
    function $1b76154abb8f2c59$export$748ada60eaf985cc(enable) {
        $1b76154abb8f2c59$var$debugEnabled = enable;
    }
    function $1b76154abb8f2c59$export$4f7017086af31c25(enable) {
        $1b76154abb8f2c59$var$stacktracesEnabled = enable;
    }
    function $1b76154abb8f2c59$export$2a858f450a2f66d() {
        if ($1b76154abb8f2c59$var$stacktracesEnabled) console.log(new Error().stack);
    }
    function $1b76154abb8f2c59$export$2e2bcd8739ae039(msg, ...args) {
        if ($1b76154abb8f2c59$var$debugEnabled) console.log(msg, ...args);
    }
});
parcelRegister("5B9Cy", function(module, exports) {
    $parcel$export(module.exports, "isSpriteServiceRepresentation", ()=>$fb1b6c003b1856ef$export$1c52f72b88b558e8);
    $parcel$export(module.exports, "isSpriteRepresentation", ()=>$fb1b6c003b1856ef$export$a194199d673d75de);
    $parcel$export(module.exports, "isImageRepresentation", ()=>$fb1b6c003b1856ef$export$90b099a26fbd8b41);
    $parcel$export(module.exports, "isMediaRepresentation", ()=>$fb1b6c003b1856ef$export$979133dc1df141c6);
    $parcel$export(module.exports, "isPromise", ()=>$fb1b6c003b1856ef$export$4369c812aac99591);
    $parcel$export(module.exports, "isEmojiDescription", ()=>$fb1b6c003b1856ef$export$378ed2c87d03531c);
    $parcel$export(module.exports, "isMediaEmoji", ()=>$fb1b6c003b1856ef$export$a7e82c67204c73a1);
    $parcel$export(module.exports, "isLoadedMediaEmoji", ()=>$fb1b6c003b1856ef$export$d25a80b2c86d7fdf);
    $parcel$export(module.exports, "isEmojiDescriptionWithVariations", ()=>$fb1b6c003b1856ef$export$b0ed6d8df471f3cc);
    $parcel$export(module.exports, "isEmojiVariationDescription", ()=>$fb1b6c003b1856ef$export$82a0350e1f6b5c0a);
    $parcel$export(module.exports, "isMessagesKey", ()=>$fb1b6c003b1856ef$export$dddfba07c16c94d2);
    $parcel$export(module.exports, "toEmojiId", ()=>$fb1b6c003b1856ef$export$8d7d3de6b5b305d1);
    $parcel$export(module.exports, "containsEmojiId", ()=>$fb1b6c003b1856ef$export$39ed0ad389e58ef7);
    $parcel$export(module.exports, "convertImageToMediaRepresentation", ()=>$fb1b6c003b1856ef$export$20a1bd1d33069ce7);
    $parcel$export(module.exports, "convertMediaToImageEmoji", ()=>$fb1b6c003b1856ef$export$f1a89a11f425faaa);
    $parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", ()=>$fb1b6c003b1856ef$export$a48c58c688a3131);
    $parcel$export(module.exports, "getCategoryId", ()=>$fb1b6c003b1856ef$export$4bcbf61cb6832a8e);
    var $aSE1r;
    var $kin1Z;
    const $fb1b6c003b1856ef$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
    const $fb1b6c003b1856ef$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
    const $fb1b6c003b1856ef$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
    const $fb1b6c003b1856ef$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
    const $fb1b6c003b1856ef$export$4369c812aac99591 = (p)=>!!(p && p.then);
    const $fb1b6c003b1856ef$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
    const $fb1b6c003b1856ef$export$a7e82c67204c73a1 = (emoji)=>$fb1b6c003b1856ef$export$979133dc1df141c6(emoji.representation);
    const $fb1b6c003b1856ef$export$7720a4954d6f75f8 = (rep)=>$fb1b6c003b1856ef$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, (0, parcelRequire("kin1Z")).dataURLPrefix)) === 0;
    const $fb1b6c003b1856ef$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, (0, parcelRequire("kin1Z")).customCategory) && $fb1b6c003b1856ef$export$7720a4954d6f75f8(emoji.representation);
    const $fb1b6c003b1856ef$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
    const $fb1b6c003b1856ef$export$82a0350e1f6b5c0a = (object)=>{
        return 'baseId' in object;
    };
    const $fb1b6c003b1856ef$export$dddfba07c16c94d2 = (key)=>key in (0, (0, parcelRequire("aSE1r")).messages);
    const $fb1b6c003b1856ef$export$8d7d3de6b5b305d1 = (emoji)=>({
            shortName: emoji.shortName,
            id: emoji.id,
            fallback: emoji.fallback
        });
    const $fb1b6c003b1856ef$export$2dbfa5a5d35af350 = (emoji)=>{
        if (!emoji) return undefined;
        return $fb1b6c003b1856ef$export$8d7d3de6b5b305d1(emoji);
    };
    const $fb1b6c003b1856ef$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
    const $fb1b6c003b1856ef$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
        if (!emojiId) return false;
        for(let i = 0; i < emojis.length; i++){
            if ($fb1b6c003b1856ef$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
        }
        return false;
    };
    const $fb1b6c003b1856ef$export$20a1bd1d33069ce7 = (rep)=>({
            mediaPath: rep.imagePath,
            height: rep.height,
            width: rep.width
        });
    const $fb1b6c003b1856ef$export$3197405d49d2e298 = (rep, newImagePath)=>({
            imagePath: newImagePath || rep.mediaPath,
            height: rep.height,
            width: rep.width
        });
    const $fb1b6c003b1856ef$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
        const mediaRepresentation = emoji.representation;
        const mediaAltRepresentation = emoji.altRepresentation;
        const imgPath = !useAlt ? newImagePath : undefined;
        const altImgPath = useAlt ? newImagePath : undefined;
        if (!$fb1b6c003b1856ef$export$979133dc1df141c6(mediaRepresentation) && !$fb1b6c003b1856ef$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
        const representation = $fb1b6c003b1856ef$export$979133dc1df141c6(mediaRepresentation) ? $fb1b6c003b1856ef$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
        const altRepresentation = $fb1b6c003b1856ef$export$979133dc1df141c6(mediaAltRepresentation) ? $fb1b6c003b1856ef$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
        const baseEmoji = {
            ...emoji,
            representation: representation
        };
        return $fb1b6c003b1856ef$export$a48c58c688a3131(baseEmoji, altRepresentation);
    };
    const $fb1b6c003b1856ef$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
        if (!altRepresentation) return emoji;
        return {
            ...emoji,
            altRepresentation: altRepresentation
        };
    };
    const $fb1b6c003b1856ef$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;
});
parcelRegister("aSE1r", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$11d87ef7c2048740$export$defe85febe8b728c);
    var $7VHMR;
    const $11d87ef7c2048740$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        deleteEmojiTooltip: {
            id: 'fabric.emoji.delete.tooltip',
            defaultMessage: 'Delete',
            description: 'Tooltip content for delete emoji when focus on deletable emoji'
        },
        deleteEmojiTooltipForScreenreader: {
            id: 'fabric.emoji.delete.screenreader.tooltip',
            defaultMessage: 'To delete {shortName} emoji, press Backspace',
            description: 'Tooltip content for delete emoji when focus on deletable emoji'
        },
        deleteEmojiTitle: {
            id: 'fabric.emoji.delete.title',
            defaultMessage: 'Remove emoji',
            description: 'Title for emoji removal dialog'
        },
        deleteEmojiDescription: {
            id: 'fabric.emoji.delete.description',
            defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
            description: 'Description for emoji removal dialog'
        },
        deleteEmojiLabel: {
            id: 'fabric.emoji.delete.label',
            defaultMessage: 'Remove',
            description: 'Button label to remove emoji'
        },
        addCustomEmojiLabel: {
            id: 'fabric.emoji.add.custom.emoji.label',
            defaultMessage: 'Add your own emoji',
            description: 'Button label to add custom emoji'
        },
        emojiPlaceholder: {
            id: 'fabric.emoji.placeholder',
            defaultMessage: 'e.g. hello',
            description: 'Placeholder for emoji that provides an example for emoji name'
        },
        emojiNameAriaLabel: {
            id: 'fabric.emoji.name.ariaLabel',
            defaultMessage: 'Enter a name for the new emoji',
            description: 'Explains to enter a name for a new emoji'
        },
        emojiChooseFileTitle: {
            id: 'fabric.emoji.choose.file.title',
            defaultMessage: 'Choose file',
            description: 'Choose custom emoji file'
        },
        emojiChooseFileScreenReaderDescription: {
            id: 'fabric.emoji.choose.file.screenReaderDescription',
            defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
            description: 'Message indicating the purpose of choosing the file and requirements for the file'
        },
        emojiSelectSkinToneButtonAriaLabelText: {
            id: 'fabric.emoji.select.skin.tone.ariaLabel',
            defaultMessage: 'Choose your skin tone, {selectedTone} selected',
            description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
        },
        emojiSelectSkinToneListAriaLabelText: {
            id: 'fabric.emoji.select.skin.list.ariaLabel',
            defaultMessage: 'Skin tone selector',
            description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
        },
        emojiImageRequirements: {
            id: 'fabric.emoji.image.requirements',
            defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
            description: 'Message for emoji image requirements and maximum file size'
        },
        emojiPreviewTitle: {
            id: 'fabric.emoji.preview.title',
            defaultMessage: 'Preview',
            description: 'Emoji preview title'
        },
        emojiPreview: {
            id: 'fabric.emoji.preview',
            defaultMessage: 'Your new emoji {emoji} looks great',
            description: 'Emoji preview'
        },
        addEmojiLabel: {
            id: 'fabric.emoji.add.label',
            defaultMessage: 'Add emoji',
            description: 'verb - Button label to add emoji'
        },
        retryLabel: {
            id: 'fabric.emoji.retry.label',
            defaultMessage: 'Retry',
            description: 'verb - Button label to retry upload'
        },
        cancelLabel: {
            id: 'fabric.emoji.cancel.label',
            defaultMessage: 'Cancel',
            description: 'verb - button label to cancel operation'
        },
        searchPlaceholder: {
            id: 'fabric.emoji.search.placeholder',
            defaultMessage: 'Search',
            description: 'Placeholder for search emoji field'
        },
        searchLabel: {
            id: 'fabric.emoji.search.label',
            defaultMessage: 'Emoji name',
            description: 'verb - button label to search'
        },
        searchResultsStatusSeeAll: {
            id: 'fabric.emoji.search.status',
            defaultMessage: 'Seeing all emojis',
            description: 'search results status when no search query for screenreader to read out'
        },
        categoriesSelectorLabel: {
            id: 'fabric.emoji.categories.label',
            defaultMessage: 'Choose an emoji category',
            description: 'Aria label for Emoji categories selector at the top of emoji picker'
        },
        categoriesSearchResults: {
            id: 'fabric.emoji.categories.search.results',
            defaultMessage: 'Search results',
            description: 'Emoji categories search results'
        },
        frequentCategory: {
            id: 'fabric.emoji.category.frequent',
            defaultMessage: 'Frequent',
            description: 'Emoji frequent category'
        },
        peopleCategory: {
            id: 'fabric.emoji.category.people',
            defaultMessage: 'People',
            description: 'Emoji frequent category'
        },
        natureCategory: {
            id: 'fabric.emoji.category.nature',
            defaultMessage: 'Nature',
            description: 'Emoji nature category'
        },
        foodsCategory: {
            id: 'fabric.emoji.category.foods',
            defaultMessage: 'Food & Drink',
            description: 'Emoji Foods category'
        },
        activityCategory: {
            id: 'fabric.emoji.category.activity',
            defaultMessage: 'Activity',
            description: 'Emoji activity category'
        },
        placesCategory: {
            id: 'fabric.emoji.category.places',
            defaultMessage: 'Travel & Places',
            description: 'Emoji Places category'
        },
        objectsCategory: {
            id: 'fabric.emoji.category.objects',
            defaultMessage: 'Objects',
            description: 'Emoji objects category'
        },
        symbolsCategory: {
            id: 'fabric.emoji.category.symbols',
            defaultMessage: 'Symbols',
            description: 'Emoji symbols category'
        },
        flagsCategory: {
            id: 'fabric.emoji.category.flags',
            defaultMessage: 'Flags',
            description: 'Emoji flags category'
        },
        productivityCategory: {
            id: 'fabric.emoji.category.productivity',
            defaultMessage: 'Productivity',
            description: 'Emoji productivity category'
        },
        userUploadsCustomCategory: {
            id: 'fabric.emoji.category.user.uploads',
            defaultMessage: 'Your uploads',
            description: 'User uploads in the custom category'
        },
        allUploadsCustomCategory: {
            id: 'fabric.emoji.category.all.uploads',
            defaultMessage: 'All uploads',
            description: 'All uploads in the custom category'
        },
        deleteEmojiFailed: {
            id: 'fabric.emoji.error.delete.failed',
            defaultMessage: 'Remove failed',
            description: 'Error message when custom emoji failed to be removed'
        },
        emojiInvalidImage: {
            id: 'fabric.emoji.error.invalid.image',
            defaultMessage: 'Selected image is invalid',
            description: 'Error message for invalid selected image'
        },
        emojiUploadFailed: {
            id: 'fabric.emoji.error.upload.failed',
            defaultMessage: 'Upload failed',
            description: 'Failed to upload emoji image'
        },
        emojiImageTooBig: {
            id: 'fabric.emoji.error.image.too.big',
            defaultMessage: 'Selected image is more than 1 MB',
            description: 'Error message for image too big, beyond the size limit'
        },
        emojiPickerTitle: {
            id: 'fabric.emoji.picker',
            defaultMessage: 'Emoji picker',
            description: 'Aria label for emoji picker'
        },
        emojiPickerListPanel: {
            id: 'fabric.emoji.pickerlist.tabpanel',
            defaultMessage: 'Emojis actions and list panel',
            description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
        },
        emojiPickerGrid: {
            id: 'fabric.emoji.pickerlist.grid',
            defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
            description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
        },
        emojiButtonRoleDescription: {
            id: 'fabric.emoji.emojipicker.emoi.roledescription',
            defaultMessage: 'emoji button',
            description: `Aria roledescription for emoji button, used in emoji picker.`
        },
        error: {
            id: 'fabric.emoji.emojipicker.error',
            defaultMessage: 'Error!',
            description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
        }
    });
});
parcelRegister("d9blH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0506955bcee8f359$export$2e2bcd8739ae039);
    function $0506955bcee8f359$export$2e2bcd8739ae039(type) {
        if (typeof window === 'undefined') return false;
        var storage;
        try {
            storage = window[type];
            var x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && storage && storage.length !== 0;
        }
    }
});
parcelRegister("9AR2K", function(module, exports) {
    $parcel$export(module.exports, "SearchSort", ()=>$d0b081d2572cc7bf$export$a15e9a4340d08b2e);
    $parcel$export(module.exports, "SearchSourceTypes", ()=>$d0b081d2572cc7bf$export$db41220f541db607);
    $parcel$export(module.exports, "ProviderTypes", ()=>$d0b081d2572cc7bf$export$bf337c9223e5c8b);
    $parcel$export(module.exports, "UfoExperienceName", ()=>$d0b081d2572cc7bf$export$d0d1c9cd31a11a64);
    $parcel$export(module.exports, "UfoComponentName", ()=>$d0b081d2572cc7bf$export$122ce5c8fda96269);
    $parcel$export(module.exports, "UfoEmojiTimingsKeys", ()=>$d0b081d2572cc7bf$export$265ee18146a6885e);
    $parcel$export(module.exports, "UfoEmojiTimings", ()=>$d0b081d2572cc7bf$export$482549d945a3723);
    var $d0b081d2572cc7bf$export$a15e9a4340d08b2e;
    (function(SearchSort) {
        SearchSort[SearchSort["None"] = 0] = "None";
        SearchSort[SearchSort["Default"] = 1] = "Default";
        SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    })($d0b081d2572cc7bf$export$a15e9a4340d08b2e || ($d0b081d2572cc7bf$export$a15e9a4340d08b2e = {}));
    var $d0b081d2572cc7bf$export$db41220f541db607;
    (function(SearchSourceTypes) {
        SearchSourceTypes["PICKER"] = "picker";
        SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    })($d0b081d2572cc7bf$export$db41220f541db607 || ($d0b081d2572cc7bf$export$db41220f541db607 = {}));
    var $d0b081d2572cc7bf$export$bf337c9223e5c8b;
    (function(ProviderTypes) {
        ProviderTypes["SITE"] = "SITE";
        ProviderTypes["STANDARD"] = "STANDARD";
        ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
        ProviderTypes["UNKNOWN"] = "UNKNOWN";
        ProviderTypes["SINGLE"] = "SINGLE";
    })($d0b081d2572cc7bf$export$bf337c9223e5c8b || ($d0b081d2572cc7bf$export$bf337c9223e5c8b = {}));
    var $d0b081d2572cc7bf$export$d0d1c9cd31a11a64;
    (function(UfoExperienceName) {
        UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
        UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
        UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
        UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
        UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
        UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    })($d0b081d2572cc7bf$export$d0d1c9cd31a11a64 || ($d0b081d2572cc7bf$export$d0d1c9cd31a11a64 = {}));
    var $d0b081d2572cc7bf$export$122ce5c8fda96269;
    (function(UfoComponentName) {
        UfoComponentName["EMOJI"] = "emoji";
        UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
        UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    })($d0b081d2572cc7bf$export$122ce5c8fda96269 || ($d0b081d2572cc7bf$export$122ce5c8fda96269 = {}));
    var $d0b081d2572cc7bf$export$265ee18146a6885e;
    (function(UfoEmojiTimingsKeys) {
        UfoEmojiTimingsKeys["FMP"] = "fmp";
        UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
        UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
        UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
        UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    })($d0b081d2572cc7bf$export$265ee18146a6885e || ($d0b081d2572cc7bf$export$265ee18146a6885e = {}));
    var $d0b081d2572cc7bf$export$482549d945a3723;
    (function(UfoEmojiTimings) {
        UfoEmojiTimings["FMP_END"] = "fmp";
        UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
        UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
        UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
        UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
        UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
        UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
        UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    })($d0b081d2572cc7bf$export$482549d945a3723 || ($d0b081d2572cc7bf$export$482549d945a3723 = {}));
});
parcelRegister("f2M1N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8439b55200f22364$export$2e2bcd8739ae039);
    var $0Bueq;
    class $8439b55200f22364$export$2e2bcd8739ae039 {
        constructor(config){
            this.config = config;
        }
        loadEmoji() {
            const emojisPromise = (0, (0, parcelRequire("0Bueq")).emojiRequest)(this.config);
            return emojisPromise.then((emojiServiceResponse)=>(0, (0, parcelRequire("0Bueq")).denormaliseEmojiServiceResponse)(emojiServiceResponse));
        }
    }
});
parcelRegister("0Bueq", function(module, exports) {
    $parcel$export(module.exports, "emojiRequest", ()=>$9b95bf1aff58b644$export$ea1accde4cc117f4);
    $parcel$export(module.exports, "getAltRepresentation", ()=>$9b95bf1aff58b644$export$4a0301d636367e1d);
    $parcel$export(module.exports, "denormaliseEmojiServiceResponse", ()=>$9b95bf1aff58b644$export$afaea97e40b5ca70);
    $parcel$export(module.exports, "shouldUseAltRepresentation", ()=>$9b95bf1aff58b644$export$b7e9058f156d8d19);
    var $dS9cn = parcelRequire("dS9cn");
    var $5B9Cy;
    var $b8sgr;
    const $9b95bf1aff58b644$export$ea1accde4cc117f4 = (provider, options)=>{
        const { getRatio: getRatio = $9b95bf1aff58b644$export$d39ce20a37bba061, ...serviceConfig } = provider;
        const scaleQueryParams = $9b95bf1aff58b644$var$calculateScale(getRatio);
        const { queryParams: queryParams = {}, ...otherOptions } = options || {};
        const requestOptions = {
            ...otherOptions,
            queryParams: {
                ...scaleQueryParams,
                ...queryParams,
                preferredRepresentation: 'IMAGE'
            }
        };
        return (0, $dS9cn.utils).requestService(serviceConfig, requestOptions);
    };
    const $9b95bf1aff58b644$var$calculateScale = (getRatio)=>{
        if (getRatio() > 1) return {
            scale: 'XHDPI',
            altScale: 'XXXHDPI'
        };
        return {
            altScale: 'XHDPI'
        };
    };
    const $9b95bf1aff58b644$export$d39ce20a37bba061 = ()=>{
        if (typeof window === 'undefined') return 0;
        return window.devicePixelRatio;
    };
    const $9b95bf1aff58b644$export$4a0301d636367e1d = (reps)=>{
        return reps[$9b95bf1aff58b644$var$calculateScale($9b95bf1aff58b644$export$d39ce20a37bba061).altScale];
    };
    const $9b95bf1aff58b644$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
    const $9b95bf1aff58b644$export$55077db3efc820aa = (representation, meta)=>{
        if ((0, (0, parcelRequire("5B9Cy")).isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
            const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
            const spriteSheet = meta.spriteSheets[spriteRef];
            if (spriteSheet) return {
                sprite: spriteSheet,
                height: height,
                width: width,
                x: x,
                y: y,
                xIndex: xIndex,
                yIndex: yIndex
            };
        } else if ((0, (0, parcelRequire("5B9Cy")).isImageRepresentation)(representation)) {
            const { height: height, width: width, imagePath: imagePath } = representation;
            if ($9b95bf1aff58b644$export$db05e6ae1fd416af(imagePath, meta)) return (0, (0, parcelRequire("5B9Cy")).convertImageToMediaRepresentation)(representation);
            return {
                height: height,
                width: width,
                imagePath: imagePath
            };
        }
        (0, (0, parcelRequire("b8sgr")).default)('failed conversion for representation', representation, meta);
        return undefined;
    };
    const $9b95bf1aff58b644$export$aa9faa01267cb2e7 = (altReps, meta)=>{
        return !altReps || Object.keys(altReps).length === 0 ? undefined : $9b95bf1aff58b644$export$55077db3efc820aa($9b95bf1aff58b644$export$4a0301d636367e1d(altReps), meta);
    };
    const $9b95bf1aff58b644$export$e3da49c88c2e54d5 = (emoji, meta)=>{
        if (!emoji.skinVariations) return [];
        const skinEmoji = emoji.skinVariations;
        const baseId = emoji.id;
        return skinEmoji.map((skin)=>{
            const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
            return {
                baseId: baseId,
                representation: $9b95bf1aff58b644$export$55077db3efc820aa(representation, meta),
                altRepresentation: $9b95bf1aff58b644$export$aa9faa01267cb2e7(altRepresentations, meta),
                ...other
            };
        });
    };
    const $9b95bf1aff58b644$export$afaea97e40b5ca70 = (emojiData)=>{
        const emojis = emojiData.emojis.map((emoji)=>{
            const newRepresentation = $9b95bf1aff58b644$export$55077db3efc820aa(emoji.representation, emojiData.meta);
            const altRepresentation = $9b95bf1aff58b644$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
            const newSkinVariations = $9b95bf1aff58b644$export$e3da49c88c2e54d5(emoji, emojiData.meta);
            const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
            const response = {
                ...trimmedServiceDesc,
                representation: newRepresentation,
                skinVariations: newSkinVariations
            };
            return (0, (0, parcelRequire("5B9Cy")).buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
        });
        const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
        return {
            emojis: emojis,
            mediaApiToken: mediaApiToken
        };
    };
    const $9b95bf1aff58b644$var$getHeight = (fitToHeight)=>$9b95bf1aff58b644$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
    const $9b95bf1aff58b644$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $9b95bf1aff58b644$var$getHeight(fitToHeight) > emoji.representation.height);
});
parcelRegister("WeQTx", function(module, exports) {
    $parcel$export(module.exports, "getEmojiVariation", ()=>$1d50887d5f60ae61$export$e55e46e1520c899d);
    $parcel$export(module.exports, "default", ()=>$1d50887d5f60ae61$export$2e2bcd8739ae039);
    var $lH7AH = parcelRequire("lH7AH");
    var $kin1Z;
    var $5B9Cy;
    var $9AR2K;
    var $9aDRG;
    var $fjHZk;
    var $8Ov1g;
    var $VSDnB;
    class $1d50887d5f60ae61$var$Tokenizer {
        tokenize(text) {
            return this.tokenizeAsTokens(text).map((token)=>token.token);
        }
        tokenizeAsTokens(text) {
            let match;
            let tokens = [];
            (0, (0, parcelRequire("9aDRG")).tokenizerRegex).lastIndex = 0;
            while((match = (0, (0, parcelRequire("9aDRG")).tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
                token: match[0],
                start: match.index
            });
            return tokens;
        }
    }
    const $1d50887d5f60ae61$var$addAllVariants = (emoji, fnKey, map)=>{
        const key = fnKey(emoji);
        if (!map.has(key)) map.set(key, []);
        const emojisForKey = map.get(key);
        if (emojisForKey) emojisForKey.push(emoji);
        if ((0, (0, parcelRequire("5B9Cy")).isEmojiDescriptionWithVariations)(emoji)) {
            const variations = emoji.skinVariations;
            if (variations) variations.forEach((variation)=>$1d50887d5f60ae61$var$addAllVariants(variation, fnKey, map));
        }
    };
    const $1d50887d5f60ae61$var$findByKey = (map, key)=>{
        const emojis = map.get(key);
        if (emojis && emojis.length) return emojis[emojis.length - 1];
        return undefined;
    };
    const $1d50887d5f60ae61$var$splitQuery = (query = '')=>{
        const isColonQuery = query.indexOf(':') === 0;
        if (isColonQuery) return {
            nameQuery: query.slice(1),
            asciiQuery: query
        };
        return {
            nameQuery: query,
            asciiQuery: ''
        };
    };
    const $1d50887d5f60ae61$export$e55e46e1520c899d = (emoji, options)=>{
        if ((0, (0, parcelRequire("5B9Cy")).isEmojiDescriptionWithVariations)(emoji) && options) {
            const skinTone = options.skinTone;
            if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
                const skinToneEmoji = emoji.skinVariations[skinTone - 1];
                if (skinToneEmoji) return skinToneEmoji;
            }
        }
        return emoji;
    };
    const $1d50887d5f60ae61$var$findEmojiIndex = (emojis, toFind)=>{
        const findId = toFind.id;
        let match = -1;
        emojis.forEach((emoji, index)=>{
            if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
                match = index;
                return;
            }
        });
        return match;
    };
    class $1d50887d5f60ae61$export$2e2bcd8739ae039 {
        static{
            this.defaultEmojiWeight = 1000000;
        }
        constructor(emojis, usageTracker){
            this.fullSearchReady = false;
            this.emojis = emojis;
            this.initMembers(usageTracker);
        }
        all() {
            const options = {
                sort: (0, (0, parcelRequire("9AR2K")).SearchSort).None
            };
            return this.search('', options);
        }
        search(query, options) {
            let filteredEmoji = [];
            const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $1d50887d5f60ae61$var$splitQuery(query);
            if (nameQuery) {
                filteredEmoji = this.getSearchIndex().search(nameQuery);
                if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
            } else filteredEmoji = this.getAllSearchableEmojis();
            filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
            return {
                emojis: filteredEmoji,
                query: query
            };
        }
        findAllMatchingShortName(shortName) {
            return this.shortNameMap.get(shortName) || [];
        }
        findByShortName(shortName) {
            return $1d50887d5f60ae61$var$findByKey(this.shortNameMap, shortName);
        }
        findById(id) {
            return $1d50887d5f60ae61$var$findByKey(this.idMap, id);
        }
        findByAsciiRepresentation(asciiEmoji) {
            return this.asciiMap.get(asciiEmoji);
        }
        findInCategory(categoryId) {
            if (categoryId === (0, (0, parcelRequire("kin1Z")).frequentCategory)) return this.getFrequentlyUsed();
            else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
        }
        addUnknownEmoji(emoji) {
            this.emojis = [
                ...this.emojis,
                emoji
            ];
            this.getSearchIndex().addDocuments([
                emoji
            ]);
            this.addToMaps(emoji);
            this.addToDynamicCategories(emoji);
        }
        getAsciiMap() {
            return this.asciiMap;
        }
        getFrequentlyUsed(options) {
            const emojiIds = this.usageTracker.getOrder();
            let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
            if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
            return emojiResult;
        }
        getDynamicCategoryList() {
            return this.dynamicCategoryList.slice();
        }
        used(emoji) {
            this.usageTracker.recordUsage(emoji);
            if (this.dynamicCategoryList.indexOf((0, (0, parcelRequire("kin1Z")).frequentCategory)) === -1) {
                if (typeof window === 'undefined') return;
                window.setTimeout(()=>{
                    this.dynamicCategoryList.push((0, (0, parcelRequire("kin1Z")).frequentCategory));
                });
            }
        }
        delete(emoji) {
            const deletedIndex = $1d50887d5f60ae61$var$findEmojiIndex(this.emojis, emoji);
            if (deletedIndex !== -1) {
                this.emojis.splice(deletedIndex, 1);
                this.initMembers(this.usageTracker);
            }
        }
        withAsciiMatch(ascii, emojis) {
            let result = emojis;
            const asciiEmoji = this.findByAsciiRepresentation(ascii);
            if (asciiEmoji) {
                result = emojis.filter((e)=>e.id !== asciiEmoji.id);
                result = [
                    asciiEmoji,
                    ...result
                ];
            }
            return result;
        }
        applySearchOptions(emojis, query, options) {
            if (!options) options = {};
            if (options.sort === undefined) options.sort = (0, (0, parcelRequire("9AR2K")).SearchSort).Default;
            let comparator;
            if (options.sort === (0, (0, parcelRequire("9AR2K")).SearchSort).Default) comparator = (0, (0, parcelRequire("fjHZk")).createSearchEmojiComparator)(query, this.usageTracker.getOrder());
            else if (options.sort === (0, (0, parcelRequire("9AR2K")).SearchSort).UsageFrequency) comparator = (0, (0, parcelRequire("fjHZk")).createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
            if (comparator) {
                comparator.compare = comparator.compare.bind(comparator);
                emojis = emojis.sort(comparator.compare);
            }
            if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
            if (options.skinTone) return emojis.map((emoji)=>{
                return $1d50887d5f60ae61$export$e55e46e1520c899d(emoji, options);
            });
            return emojis;
        }
        initMembers(usageTracker) {
            this.usageTracker = usageTracker || new (0, (0, parcelRequire("8Ov1g")).UsageFrequencyTracker)();
            this.initRepositoryMetadata();
            if (!(0, (0, parcelRequire("VSDnB")).fg)('platform_index_emoji_just_in_time')) this.initSearchIndex();
        }
        initRepositoryMetadata() {
            this.shortNameMap = new Map();
            this.idMap = new Map();
            this.asciiMap = new Map();
            const categorySet = new Set();
            this.emojis.forEach((emoji)=>{
                categorySet.add(emoji.category);
                this.addToMaps(emoji);
            });
            if (this.usageTracker.getOrder().length) categorySet.add((0, (0, parcelRequire("kin1Z")).frequentCategory));
            this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, (0, parcelRequire("kin1Z")).defaultCategories).indexOf(category) === -1);
        }
        initSearchIndex() {
            this.fullSearch = new (0, $lH7AH.Search)('id');
            this.fullSearch.tokenizer = new $1d50887d5f60ae61$var$Tokenizer();
            this.fullSearch.searchIndex = new (0, $lH7AH.UnorderedSearchIndex)();
            this.fullSearch.addIndex('name');
            this.fullSearch.addIndex('shortName');
            this.fullSearch.addDocuments(this.getAllSearchableEmojis());
            this.fullSearchReady = true;
        }
        getSearchIndex() {
            if (!this.fullSearchReady) this.initSearchIndex();
            return this.fullSearch;
        }
        getAllSearchableEmojis() {
            return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
        }
        addToMaps(emoji) {
            if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $1d50887d5f60ae61$export$2e2bcd8739ae039.defaultEmojiWeight;
            if (typeof emoji.id === 'undefined') emoji.id = $1d50887d5f60ae61$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
            $1d50887d5f60ae61$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
            $1d50887d5f60ae61$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
            if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
        }
        addToDynamicCategories(emoji) {
            const category = (0, (0, parcelRequire("5B9Cy")).getCategoryId)(emoji);
            if ((0, (0, parcelRequire("kin1Z")).defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
        }
    }
});
parcelRegister("lH7AH", function(module, exports) {
    $parcel$export(module.exports, "UnorderedSearchIndex", ()=>$fcb38080bd8576e6$export$5e70dbef3f0d47db);
    $parcel$export(module.exports, "Search", ()=>$fcb38080bd8576e6$export$4b85d3515bd863a5);
    var $fcb38080bd8576e6$export$58ac23006833dfe0 = function() {
        function AllSubstringsIndexStrategy() {}
        var _proto = AllSubstringsIndexStrategy.prototype;
        _proto.expandToken = function expandToken(token) {
            var expandedTokens = [];
            var string;
            for(var i = 0, length = token.length; i < length; ++i){
                string = '';
                for(var j = i; j < length; ++j){
                    string += token.charAt(j);
                    expandedTokens.push(string);
                }
            }
            return expandedTokens;
        };
        return AllSubstringsIndexStrategy;
    }();
    var $fcb38080bd8576e6$export$1dcc2d6a64836c8f = function() {
        function ExactWordIndexStrategy() {}
        var _proto = ExactWordIndexStrategy.prototype;
        _proto.expandToken = function expandToken(token) {
            return token ? [
                token
            ] : [];
        };
        return ExactWordIndexStrategy;
    }();
    var $fcb38080bd8576e6$export$eb7fc80cfe9abfe6 = function() {
        function PrefixIndexStrategy() {}
        var _proto = PrefixIndexStrategy.prototype;
        _proto.expandToken = function expandToken(token) {
            var expandedTokens = [];
            var string = '';
            for(var i = 0, length = token.length; i < length; ++i){
                string += token.charAt(i);
                expandedTokens.push(string);
            }
            return expandedTokens;
        };
        return PrefixIndexStrategy;
    }();
    var $fcb38080bd8576e6$export$b88ffe9b5486f99a = function() {
        function CaseSensitiveSanitizer() {}
        var _proto = CaseSensitiveSanitizer.prototype;
        _proto.sanitize = function sanitize(text) {
            return text ? text.trim() : '';
        };
        return CaseSensitiveSanitizer;
    }();
    var $fcb38080bd8576e6$export$147e8ac43c84713a = function() {
        function LowerCaseSanitizer() {}
        var _proto = LowerCaseSanitizer.prototype;
        _proto.sanitize = function sanitize(text) {
            return text ? text.toLocaleLowerCase().trim() : '';
        };
        return LowerCaseSanitizer;
    }();
    function $fcb38080bd8576e6$var$getNestedFieldValue(object, path) {
        path = path || [];
        object = object || {};
        var value = object;
        for(var i = 0; i < path.length; i++){
            value = value[path[i]];
            if (value == null) return null;
        }
        return value;
    }
    var $fcb38080bd8576e6$export$a1138c79781169cc = function() {
        function TfIdfSearchIndex(uidFieldName) {
            this._uidFieldName = uidFieldName;
            this._tokenToIdfCache = {};
            this._tokenMap = {};
        }
        var _proto = TfIdfSearchIndex.prototype;
        _proto.indexDocument = function indexDocument(token, uid, doc) {
            this._tokenToIdfCache = {};
            var tokenMap = this._tokenMap;
            var tokenDatum;
            if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
                $numDocumentOccurrences: 0,
                $totalNumOccurrences: 1,
                $uidMap: {}
            };
            else {
                tokenDatum = tokenMap[token];
                tokenDatum.$totalNumOccurrences++;
            }
            var uidMap = tokenDatum.$uidMap;
            if (typeof uidMap[uid] !== 'object') {
                tokenDatum.$numDocumentOccurrences++;
                uidMap[uid] = {
                    $document: doc,
                    $numTokenOccurrences: 1
                };
            } else uidMap[uid].$numTokenOccurrences++;
        };
        _proto.search = function search(tokens, corpus) {
            var uidToDocumentMap = {};
            for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
                var token = tokens[i];
                var tokenMetadata = this._tokenMap[token];
                if (!tokenMetadata) return [];
                if (i === 0) {
                    var keys = Object.keys(tokenMetadata.$uidMap);
                    for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                        var uid = keys[j];
                        uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                    }
                } else {
                    var keys = Object.keys(uidToDocumentMap);
                    for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                        var uid = keys[j];
                        if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                    }
                }
            }
            var documents = [];
            for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
            var calculateTfIdf = this._createCalculateTfIdf();
            return documents.sort(function(documentA, documentB) {
                return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
            });
        };
        _proto._createCalculateIdf = function _createCalculateIdf() {
            var tokenMap = this._tokenMap;
            var tokenToIdfCache = this._tokenToIdfCache;
            return function calculateIdf(token, documents) {
                if (!tokenToIdfCache[token]) {
                    var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                    tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
                }
                return tokenToIdfCache[token];
            };
        };
        _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
            var tokenMap = this._tokenMap;
            var uidFieldName = this._uidFieldName;
            var calculateIdf = this._createCalculateIdf();
            return function calculateTfIdf(tokens, document, documents) {
                var score = 0;
                for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                    var token = tokens[i];
                    var inverseDocumentFrequency = calculateIdf(token, documents);
                    if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                    var uid;
                    if (uidFieldName instanceof Array) uid = document && $fcb38080bd8576e6$var$getNestedFieldValue(document, uidFieldName);
                    else uid = document && document[uidFieldName];
                    var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                    score += termFrequency * inverseDocumentFrequency;
                }
                return score;
            };
        };
        return TfIdfSearchIndex;
    }();
    var $fcb38080bd8576e6$export$5e70dbef3f0d47db = function() {
        function UnorderedSearchIndex() {
            this._tokenToUidToDocumentMap = {};
        }
        var _proto = UnorderedSearchIndex.prototype;
        _proto.indexDocument = function indexDocument(token, uid, doc) {
            if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
            this._tokenToUidToDocumentMap[token][uid] = doc;
        };
        _proto.search = function search(tokens, corpus) {
            var intersectingDocumentMap = {};
            var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
            for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
                var token = tokens[i];
                var documentMap = tokenToUidToDocumentMap[token];
                if (!documentMap) return [];
                if (i === 0) {
                    var keys = Object.keys(documentMap);
                    for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                        var uid = keys[j];
                        intersectingDocumentMap[uid] = documentMap[uid];
                    }
                } else {
                    var keys = Object.keys(intersectingDocumentMap);
                    for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                        var uid = keys[j];
                        if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                    }
                }
            }
            var keys = Object.keys(intersectingDocumentMap);
            var documents = [];
            for(var i = 0, numKeys = keys.length; i < numKeys; i++){
                var uid = keys[i];
                documents.push(intersectingDocumentMap[uid]);
            }
            return documents;
        };
        return UnorderedSearchIndex;
    }();
    var $fcb38080bd8576e6$var$REGEX = /[^a-zа-яё0-9\-']+/i;
    var $fcb38080bd8576e6$export$f5ac5ec3cb556ad6 = function() {
        function SimpleTokenizer() {}
        var _proto = SimpleTokenizer.prototype;
        _proto.tokenize = function tokenize(text) {
            return text.split($fcb38080bd8576e6$var$REGEX).filter(function(text) {
                return text;
            });
        };
        return SimpleTokenizer;
    }();
    var $fcb38080bd8576e6$export$d2c689c98d4dcb27 = function() {
        function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
            this._stemmingFunction = stemmingFunction;
            this._tokenizer = decoratedTokenizer;
        }
        var _proto = StemmingTokenizer.prototype;
        _proto.tokenize = function tokenize(text) {
            return this._tokenizer.tokenize(text).map(this._stemmingFunction);
        };
        return StemmingTokenizer;
    }();
    var $fcb38080bd8576e6$export$eeaf491a400e882a = {
        a: true,
        able: true,
        about: true,
        across: true,
        after: true,
        all: true,
        almost: true,
        also: true,
        am: true,
        among: true,
        an: true,
        and: true,
        any: true,
        are: true,
        as: true,
        at: true,
        be: true,
        because: true,
        been: true,
        but: true,
        by: true,
        can: true,
        cannot: true,
        could: true,
        dear: true,
        did: true,
        'do': true,
        does: true,
        either: true,
        'else': true,
        ever: true,
        every: true,
        'for': true,
        from: true,
        'get': true,
        got: true,
        had: true,
        has: true,
        have: true,
        he: true,
        her: true,
        hers: true,
        him: true,
        his: true,
        how: true,
        however: true,
        i: true,
        'if': true,
        'in': true,
        into: true,
        is: true,
        it: true,
        its: true,
        just: true,
        least: true,
        "let": true,
        like: true,
        likely: true,
        may: true,
        me: true,
        might: true,
        most: true,
        must: true,
        my: true,
        neither: true,
        no: true,
        nor: true,
        not: true,
        of: true,
        off: true,
        often: true,
        on: true,
        only: true,
        or: true,
        other: true,
        our: true,
        own: true,
        rather: true,
        said: true,
        say: true,
        says: true,
        she: true,
        should: true,
        since: true,
        so: true,
        some: true,
        than: true,
        that: true,
        the: true,
        their: true,
        them: true,
        then: true,
        there: true,
        these: true,
        they: true,
        'this': true,
        tis: true,
        to: true,
        too: true,
        twas: true,
        us: true,
        wants: true,
        was: true,
        we: true,
        were: true,
        what: true,
        when: true,
        where: true,
        which: true,
        'while': true,
        who: true,
        whom: true,
        why: true,
        will: true,
        'with': true,
        would: true,
        yet: true,
        you: true,
        your: true
    };
    $fcb38080bd8576e6$export$eeaf491a400e882a.constructor = false;
    $fcb38080bd8576e6$export$eeaf491a400e882a.hasOwnProperty = false;
    $fcb38080bd8576e6$export$eeaf491a400e882a.isPrototypeOf = false;
    $fcb38080bd8576e6$export$eeaf491a400e882a.propertyIsEnumerable = false;
    $fcb38080bd8576e6$export$eeaf491a400e882a.toLocaleString = false;
    $fcb38080bd8576e6$export$eeaf491a400e882a.toString = false;
    $fcb38080bd8576e6$export$eeaf491a400e882a.valueOf = false;
    var $fcb38080bd8576e6$export$59d4dfff8ed0ca89 = function() {
        function StopWordsTokenizer(decoratedTokenizer) {
            this._tokenizer = decoratedTokenizer;
        }
        var _proto = StopWordsTokenizer.prototype;
        _proto.tokenize = function tokenize(text) {
            return this._tokenizer.tokenize(text).filter(function(token) {
                return !$fcb38080bd8576e6$export$eeaf491a400e882a[token];
            });
        };
        return StopWordsTokenizer;
    }();
    function $fcb38080bd8576e6$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function $fcb38080bd8576e6$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $fcb38080bd8576e6$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $fcb38080bd8576e6$var$_defineProperties(Constructor, staticProps);
        return Constructor;
    }
    var $fcb38080bd8576e6$export$4b85d3515bd863a5 = function() {
        function Search(uidFieldName) {
            if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
            this._uidFieldName = uidFieldName;
            this._indexStrategy = new $fcb38080bd8576e6$export$eb7fc80cfe9abfe6();
            this._searchIndex = new $fcb38080bd8576e6$export$a1138c79781169cc(uidFieldName);
            this._sanitizer = new $fcb38080bd8576e6$export$147e8ac43c84713a();
            this._tokenizer = new $fcb38080bd8576e6$export$f5ac5ec3cb556ad6();
            this._documents = [];
            this._searchableFields = [];
        }
        var _proto = Search.prototype;
        _proto.addDocument = function addDocument(document) {
            this.addDocuments([
                document
            ]);
        };
        _proto.addDocuments = function addDocuments(documents) {
            this._documents = this._documents.concat(documents);
            this.indexDocuments_(documents, this._searchableFields);
        };
        _proto.addIndex = function addIndex(field) {
            this._searchableFields.push(field);
            this.indexDocuments_(this._documents, [
                field
            ]);
        };
        _proto.search = function search(query) {
            var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
            return this._searchIndex.search(tokens, this._documents);
        };
        _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
            this._initialized = true;
            var indexStrategy = this._indexStrategy;
            var sanitizer = this._sanitizer;
            var searchIndex = this._searchIndex;
            var tokenizer = this._tokenizer;
            var uidFieldName = this._uidFieldName;
            for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
                var doc = documents[di];
                var uid;
                if (uidFieldName instanceof Array) uid = $fcb38080bd8576e6$var$getNestedFieldValue(doc, uidFieldName);
                else uid = doc[uidFieldName];
                for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                    var fieldValue;
                    var searchableField = _searchableFields[sfi];
                    if (searchableField instanceof Array) fieldValue = $fcb38080bd8576e6$var$getNestedFieldValue(doc, searchableField);
                    else fieldValue = doc[searchableField];
                    if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                    if (typeof fieldValue === 'string') {
                        var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                        for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                            var fieldToken = fieldTokens[fti];
                            var expandedTokens = indexStrategy.expandToken(fieldToken);
                            for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                                var expandedToken = expandedTokens[eti];
                                searchIndex.indexDocument(expandedToken, uid, doc);
                            }
                        }
                    }
                }
            }
        };
        $fcb38080bd8576e6$var$_createClass(Search, [
            {
                key: "indexStrategy",
                set: function set(value) {
                    if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                    this._indexStrategy = value;
                },
                get: function get() {
                    return this._indexStrategy;
                }
            },
            {
                key: "sanitizer",
                set: function set(value) {
                    if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                    this._sanitizer = value;
                },
                get: function get() {
                    return this._sanitizer;
                }
            },
            {
                key: "searchIndex",
                set: function set(value) {
                    if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                    this._searchIndex = value;
                },
                get: function get() {
                    return this._searchIndex;
                }
            },
            {
                key: "tokenizer",
                set: function set(value) {
                    if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                    this._tokenizer = value;
                },
                get: function get() {
                    return this._tokenizer;
                }
            }
        ]);
        return Search;
    }();
    var $fcb38080bd8576e6$export$11e693a7f8ce1bcc = function() {
        function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
            this._indexStrategy = opt_indexStrategy || new $fcb38080bd8576e6$export$eb7fc80cfe9abfe6();
            this._sanitizer = opt_sanitizer || new $fcb38080bd8576e6$export$147e8ac43c84713a();
            this._wrapperTagName = opt_wrapperTagName || 'mark';
        }
        var _proto = TokenHighlighter.prototype;
        _proto.highlight = function highlight(text, tokens) {
            var tagsLength = this._wrapText('').length;
            var tokenDictionary = Object.create(null);
            for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
                var token = this._sanitizer.sanitize(tokens[i]);
                var expandedTokens = this._indexStrategy.expandToken(token);
                for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                    var expandedToken = expandedTokens[j];
                    if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                        token
                    ];
                    else tokenDictionary[expandedToken].push(token);
                }
            }
            var actualCurrentWord = '';
            var sanitizedCurrentWord = '';
            var currentWordStartIndex = 0;
            for(var i = 0, textLength = text.length; i < textLength; i++){
                var character = text.charAt(i);
                if (character === ' ') {
                    actualCurrentWord = '';
                    sanitizedCurrentWord = '';
                    currentWordStartIndex = i + 1;
                } else {
                    actualCurrentWord += character;
                    sanitizedCurrentWord += this._sanitizer.sanitize(character);
                }
                if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                    actualCurrentWord = this._wrapText(actualCurrentWord);
                    text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                    i += tagsLength;
                    textLength += tagsLength;
                }
            }
            return text;
        };
        _proto._wrapText = function _wrapText(text) {
            var tagName = this._wrapperTagName;
            return "<" + tagName + ">" + text + "</" + tagName + ">";
        };
        return TokenHighlighter;
    }();
});
parcelRegister("9aDRG", function(module, exports) {
    $parcel$export(module.exports, "tokenizerRegex", ()=>$646a79216f1b7bf8$export$6558e5d0f0e834f8);
    const $646a79216f1b7bf8$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');
});
parcelRegister("fjHZk", function(module, exports) {
    $parcel$export(module.exports, "createSearchEmojiComparator", ()=>$60550181d33ca139$export$e6097b005751df7);
    $parcel$export(module.exports, "createUsageOnlyEmojiComparator", ()=>$60550181d33ca139$export$1bd055808eeccb4e);
    var $kin1Z;
    var $5B9Cy;
    function $60550181d33ca139$export$e6097b005751df7(query, orderedIds) {
        const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
        const comparators = [];
        if (query) comparators.push(new $60550181d33ca139$export$ff92575cd1bbad0e(query));
        if (textQuery) comparators.push(new $60550181d33ca139$export$3026b08b79541139(textQuery));
        if (orderedIds && orderedIds.length) comparators.push(new $60550181d33ca139$export$55e24837a4bf653(orderedIds));
        if (textQuery) comparators.push(new $60550181d33ca139$export$587c775915dc4869(textQuery, 'shortName'), new $60550181d33ca139$export$587c775915dc4869(textQuery, 'name'));
        comparators.push($60550181d33ca139$export$165e96ceead77edd.Instance, $60550181d33ca139$export$30ce221e1adf48c1.Instance);
        const comparator = new $60550181d33ca139$export$a8052d0852821684(...comparators);
        comparator.compare = comparator.compare.bind(comparator);
        return comparator;
    }
    function $60550181d33ca139$export$1bd055808eeccb4e(orderedIds) {
        const comparator = new $60550181d33ca139$export$a8052d0852821684(new $60550181d33ca139$export$55e24837a4bf653(orderedIds), new $60550181d33ca139$export$a7f7a0b04013a8a8(), $60550181d33ca139$export$165e96ceead77edd.Instance);
        comparator.compare = comparator.compare.bind(comparator);
        return comparator;
    }
    class $60550181d33ca139$export$a8052d0852821684 {
        constructor(...comparators){
            this.chain = comparators;
        }
        compare(e1, e2) {
            for(let i = 0; i < this.chain.length; i++){
                const result = this.chain[i].compare(e1, e2);
                if (result !== 0) return result;
            }
            return 0;
        }
    }
    class $60550181d33ca139$export$ff92575cd1bbad0e {
        constructor(query){
            this.query = query;
        }
        compare(e1, e2) {
            const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
            const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
            if (e1HasAscii && !e2HasAscii) return -1;
            else if (!e1HasAscii && e2HasAscii) return 1;
            return 0;
        }
    }
    class $60550181d33ca139$export$3026b08b79541139 {
        constructor(query){
            this.colonQuery = `:${query}:`;
            this.typeComparator = new $60550181d33ca139$export$a7f7a0b04013a8a8(true);
        }
        compare(e1, e2) {
            if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
            else if (e1.shortName === this.colonQuery) return -1;
            else if (e2.shortName === this.colonQuery) return 1;
            return 0;
        }
    }
    class $60550181d33ca139$export$a7f7a0b04013a8a8 {
        constructor(reverse){
            if (reverse) this.typeToNumber = new Map([
                [
                    'SITE',
                    0
                ],
                [
                    'ATLASSIAN',
                    1
                ],
                [
                    'STANDARD',
                    2
                ]
            ]);
            else this.typeToNumber = new Map([
                [
                    'STANDARD',
                    0
                ],
                [
                    'ATLASSIAN',
                    1
                ],
                [
                    'SITE',
                    2
                ]
            ]);
        }
        compare(e1, e2) {
            return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
        }
        emojiTypeToOrdinal(emoji) {
            let ordinal = this.typeToNumber.get(emoji.type);
            if (ordinal === undefined) ordinal = 10;
            return ordinal;
        }
    }
    class $60550181d33ca139$export$55e24837a4bf653 {
        constructor(orderedIds){
            this.positionLookup = new Map();
            orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
        }
        compare(e1, e2) {
            if (!e1.id || !e2.id) return 0;
            let i1 = this.getPositionInOrder(e1);
            let i2 = this.getPositionInOrder(e2);
            return i1 - i2;
        }
        getPositionInOrder(emoji) {
            let id = emoji.id ? emoji.id : '0';
            if ((0, (0, parcelRequire("5B9Cy")).isEmojiVariationDescription)(emoji)) id = emoji.baseId;
            const position = this.positionLookup.get(id);
            if (position) return position;
            else return 0, (0, parcelRequire("kin1Z")).MAX_ORDINAL;
        }
    }
    class $60550181d33ca139$export$587c775915dc4869 {
        constructor(query, propertyToCompare){
            this.query = query;
            if (!propertyToCompare) throw new Error('propertyToCompare is required');
            this.propertyName = propertyToCompare;
        }
        getScore(emoji) {
            const propertyValue = emoji[this.propertyName];
            const score = propertyValue ? propertyValue.indexOf(this.query) : (0, (0, parcelRequire("kin1Z")).MAX_ORDINAL);
            return score === -1 ? (0, (0, parcelRequire("kin1Z")).MAX_ORDINAL) : score;
        }
        compare(e1, e2) {
            return this.getScore(e1) - this.getScore(e2);
        }
    }
    class $60550181d33ca139$export$165e96ceead77edd {
        constructor(){}
        static get Instance() {
            return this.INSTANCE || (this.INSTANCE = new this());
        }
        compare(e1, e2) {
            let o1 = e1.order ? e1.order : (0, (0, parcelRequire("kin1Z")).MAX_ORDINAL);
            let o2 = e2.order ? e2.order : (0, (0, parcelRequire("kin1Z")).MAX_ORDINAL);
            return o1 - o2;
        }
    }
    class $60550181d33ca139$export$30ce221e1adf48c1 {
        constructor(){}
        static get Instance() {
            return this.INSTANCE || (this.INSTANCE = new this());
        }
        compare(e1, e2) {
            return e1.shortName.localeCompare(e2.shortName);
        }
    }
});
parcelRegister("8Ov1g", function(module, exports) {
    $parcel$export(module.exports, "UsageFrequencyTracker", ()=>$03e35e6585a0c1a4$export$3f86810331c44209);
    var $5B9Cy;
    var $kin1Z;
    var $2FvtQ;
    var $fWsKa;
    var $d9blH;
    class $03e35e6585a0c1a4$export$3f86810331c44209 {
        static{
            this.queueOptions = {
                storage: (0, (0, parcelRequire("d9blH")).default)('localStorage') ? window.localStorage : undefined,
                storagePrefix: (0, (0, parcelRequire("kin1Z")).localStoragePrefix),
                maxDuplicates: 25,
                minUniqueItems: 5
            };
        }
        constructor(useStorageIfPossible = true){
            const options = $03e35e6585a0c1a4$export$3f86810331c44209.queueOptions;
            if (useStorageIfPossible && options.storage) {
                const queueOptions = {
                    ...options,
                    storage: options.storage
                };
                this.queue = new (0, (0, parcelRequire("fWsKa")).default)(queueOptions);
            } else this.queue = new (0, (0, parcelRequire("2FvtQ")).default)(options);
            this.gateway = new $03e35e6585a0c1a4$export$a0e1fa6601cae894(10);
        }
        recordUsage(emoji) {
            let emojiId = emoji.id;
            if (emojiId) {
                if ((0, (0, parcelRequire("5B9Cy")).isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
                this.gateway.submit(()=>{
                    if (emojiId) this.queue.enqueue(emojiId);
                });
            }
        }
        getOrder() {
            return this.queue.getItemsOrderedByDuplicateCount();
        }
        clear() {
            this.queue.clear();
        }
    }
    class $03e35e6585a0c1a4$export$a0e1fa6601cae894 {
        constructor(maximumPermitted){
            if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
            this.maximumPermitted = maximumPermitted;
            this.count = 0;
        }
        submit(f) {
            if (this.count >= this.maximumPermitted) return false;
            this.count++;
            const wrappedFunc = ()=>{
                try {
                    f();
                } finally{
                    this.completed();
                }
            };
            if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
            return true;
        }
        completed() {
            this.count--;
        }
    }
});
parcelRegister("2FvtQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e862ce217e71f514$export$2e2bcd8739ae039);
    class $e862ce217e71f514$export$2e2bcd8739ae039 {
        constructor(options){
            if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
            if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
            this.maximumSize = options.maxDuplicates * options.minUniqueItems;
            this.perItemSize = options.maxDuplicates;
            this.createEmptyState();
        }
        enqueue(item) {
            this.enqueueWithoutOrdering(item);
            this.itemsOrderedByFrequency = this.orderItemsByFrequency();
        }
        getItemsOrderedByDuplicateCount() {
            return this.itemsOrderedByFrequency;
        }
        clear() {
            this.createEmptyState();
        }
        bulkEnqueue(items) {
            items.map((item)=>this.enqueueWithoutOrdering(item));
            this.itemsOrderedByFrequency = this.orderItemsByFrequency();
        }
        getItems() {
            return this.items;
        }
        createEmptyState() {
            this.items = new Array();
            this.itemCountMap = new Map();
            this.itemsOrderedByFrequency = new Array();
        }
        enqueueWithoutOrdering(item) {
            const count = this.itemCountMap.get(item);
            if (count && count >= this.perItemSize) this.removeFirstOccurrence(item);
            else if (this.items.length >= this.maximumSize) this.remove();
            this.add(item);
        }
        orderItemsByFrequency() {
            const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
                return b[1] - a[1];
            });
            return orderedEntries.map((value)=>value[0]);
        }
        decrementCount(item) {
            let count = this.itemCountMap.get(item);
            if (count) {
                count--;
                if (count > 0) this.itemCountMap.set(item, count);
                else this.itemCountMap.delete(item);
            }
        }
        removeFirstOccurrence(item) {
            const index = this.items.indexOf(item);
            if (index !== -1) {
                this.items.splice(index, 1);
                this.decrementCount(item);
            }
        }
        remove() {
            const removed = this.items.shift();
            if (removed !== undefined) this.decrementCount(removed);
            return removed;
        }
        add(item) {
            this.items.push(item);
            const count = this.itemCountMap.get(item);
            if (count) this.itemCountMap.set(item, count + 1);
            else this.itemCountMap.set(item, 1);
        }
    }
});
parcelRegister("fWsKa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6962a764dc80122$export$2e2bcd8739ae039);
    var $2FvtQ;
    var $b8sgr;
    class $e6962a764dc80122$export$2e2bcd8739ae039 extends (0, (0, parcelRequire("2FvtQ")).default) {
        static{
            this.storageKey = 'lastUsed';
        }
        constructor(options){
            super(options);
            this.storage = options.storage;
            this.prefixedStorageKey = `${options.storagePrefix}.${$e6962a764dc80122$export$2e2bcd8739ae039.storageKey}`;
            this.load();
        }
        enqueue(item) {
            super.enqueue(item);
            this.save();
        }
        clear() {
            super.clear();
            this.storage.removeItem(this.prefixedStorageKey);
        }
        load() {
            const itemsJson = this.storage.getItem(this.prefixedStorageKey);
            if (itemsJson) try {
                const items = JSON.parse(itemsJson);
                this.bulkEnqueue(items);
            } catch (e) {
                (0, (0, parcelRequire("b8sgr")).default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
            }
        }
        save() {
            const itemsJson = JSON.stringify(this.getItems());
            try {
                this.storage.setItem(this.prefixedStorageKey, itemsJson);
            } catch (e) {
                (0, (0, parcelRequire("b8sgr")).default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
            }
        }
    }
});
parcelRegister("62WHo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f7f47d6423aa49d$export$2e2bcd8739ae039);
    var $dS9cn = parcelRequire("dS9cn");
    var $cEHh7;
    var $5B9Cy;
    var $0l85J;
    var $0Bueq;
    var $ijzU9;
    var $b8sgr;
    const $9f7f47d6423aa49d$export$6f3a08dea02a7b2b = 0.95;
    class $9f7f47d6423aa49d$export$2e2bcd8739ae039 {
        constructor(siteServiceConfig, mediaApiToken){
            this.postToEmojiService = (upload, fileId)=>{
                const { shortName: shortName, name: name } = upload;
                const { width: width, height: height } = upload;
                const requestInit = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        shortName: shortName,
                        name: name,
                        width: width,
                        height: height,
                        fileId: fileId
                    })
                };
                return (0, $dS9cn.utils).requestService(this.siteServiceConfig, {
                    requestInit: requestInit
                }).then((response)=>{
                    const { emojis: emojis } = response;
                    if (emojis.length) {
                        const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                        const response = {
                            ...emoji,
                            representation: (0, (0, parcelRequire("5B9Cy")).convertImageToMediaRepresentation)(emoji.representation)
                        };
                        const altRepresentation = (0, (0, parcelRequire("0Bueq")).getAltRepresentation)(altRepresentations || {});
                        const imgAltRepresentation = altRepresentation ? (0, (0, parcelRequire("5B9Cy")).convertImageToMediaRepresentation)(altRepresentation) : undefined;
                        return (0, (0, parcelRequire("5B9Cy")).buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                    }
                    throw new Error('No emoji returns from upload. Upload failed.');
                });
            };
            this.siteServiceConfig = siteServiceConfig;
            this.mediaApiToken = mediaApiToken;
            this.tokenManager = new (0, (0, parcelRequire("ijzU9")).default)(siteServiceConfig);
            this.tokenManager.addToken('read', mediaApiToken);
            this.mediaEmojiCache = new (0, (0, parcelRequire("0l85J")).default)(this.tokenManager);
        }
        async generateTokenisedMediaURLS(representation, altRepresentation) {
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(representation)) return {
                representation: representation,
                altRepresentation: altRepresentation
            };
            try {
                const readToken = await this.tokenManager.getToken('read');
                return Object.entries({
                    representation: representation,
                    altRepresentation: altRepresentation
                }).reduce((acc, [key, value])=>{
                    if (value && (0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(value)) {
                        const path = new URL(value.mediaPath);
                        const params = path.searchParams;
                        if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                        if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                        acc[key] = {
                            ...value,
                            mediaPath: path.toString()
                        };
                    }
                    return acc;
                }, {
                    representation: representation,
                    altRepresentation: altRepresentation
                });
            } catch (error) {
                return {
                    representation: representation,
                    altRepresentation: altRepresentation
                };
            }
        }
        loadMediaEmoji(emoji, useAlt) {
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
            return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
        }
        optimisticRendering(emoji, useAlt) {
            const representation = useAlt ? emoji.altRepresentation : emoji.representation;
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
            const { mediaPath: mediaPath } = representation;
            return this.mediaEmojiCache.optimisticRendering(mediaPath);
        }
        uploadEmoji(upload, retry = false, progressCallback) {
            const startTime = Date.now();
            return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
                const tokenLoadTime = Date.now() - startTime;
                (0, (0, parcelRequire("b8sgr")).default)('upload token load time', tokenLoadTime);
                return new Promise((resolve, reject)=>{
                    const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                    const mediaClient = (0, (0, parcelRequire("cEHh7")).getMediaClient)({
                        authProvider: ()=>Promise.resolve({
                                clientId: clientId,
                                token: uploadToken.jwt,
                                baseUrl: url
                            }),
                        useSha256ForUploads: true
                    });
                    const subscription = mediaClient.file.upload({
                        content: upload.dataURL,
                        name: upload.filename,
                        collection: collectionName
                    }).subscribe({
                        next: (state)=>{
                            if (state.status === 'uploading' && progressCallback) progressCallback({
                                percent: state.progress * $9f7f47d6423aa49d$export$6f3a08dea02a7b2b
                            });
                            else if (state.status === 'processing') {
                                subscription.unsubscribe();
                                const totalUploadTime = Date.now() - startTime;
                                const mediaUploadTime = totalUploadTime - tokenLoadTime;
                                (0, (0, parcelRequire("b8sgr")).default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                                this.postToEmojiService(upload, state.id).then((emoji)=>{
                                    resolve(emoji);
                                }).catch((httpError)=>{
                                    reject(httpError.reason || httpError);
                                });
                            }
                        },
                        error (error) {
                            reject(error);
                        }
                    });
                });
            });
        }
        hasUploadToken() {
            const tokenPromise = this.tokenManager.getToken('upload');
            return tokenPromise.then((token)=>{
                return token !== undefined;
            }, ()=>{
                return false;
            });
        }
        prepareForUpload() {
            this.tokenManager.getToken('upload');
        }
        findEmoji(emojiId) {
            if (!emojiId.id) return Promise.reject(false);
            const path = `../${encodeURIComponent(emojiId.id)}`;
            return (0, (0, parcelRequire("0Bueq")).emojiRequest)(this.siteServiceConfig, {
                path: path
            }).then((serviceResponse)=>{
                const response = (0, (0, parcelRequire("0Bueq")).denormaliseEmojiServiceResponse)(serviceResponse);
                return response.emojis[0];
            }).catch((error)=>{
                (0, (0, parcelRequire("b8sgr")).default)('failed to load emoji', emojiId, error);
                return undefined;
            });
        }
        deleteEmoji(emoji) {
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaEmoji)(emoji) && !(0, (0, parcelRequire("5B9Cy")).isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
            if (!emoji.id) return Promise.reject(false);
            const path = `${encodeURIComponent(emoji.id)}`;
            const requestInit = {
                method: 'DELETE'
            };
            return (0, $dS9cn.utils).requestService(this.siteServiceConfig, {
                path: path,
                requestInit: requestInit
            }).then(()=>true).catch(()=>false);
        }
    }
});
parcelRegister("cEHh7", function(module, exports) {
    $parcel$export(module.exports, "MediaClientContext", ()=>$2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
    $parcel$export(module.exports, "getMediaClient", ()=>$2a03c62fd3cc05ea$export$c9ecbc1b719fd417);
    $parcel$export(module.exports, "MediaClientProvider", ()=>$2a03c62fd3cc05ea$export$5bff351c86f56d97);
    $parcel$export(module.exports, "useMediaClient", ()=>$2a03c62fd3cc05ea$export$8b3e87ea56c3a345);
    var $5uXOq = parcelRequire("5uXOq");
    var $9z04W;
    const $2a03c62fd3cc05ea$export$ba5d7212f2b4619f = (0, ($parcel$interopDefault($5uXOq))).createContext(undefined);
    const $2a03c62fd3cc05ea$export$f92e83e86b03c398 = new Map();
    const $2a03c62fd3cc05ea$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
        if (!mediaClientConfig) return new (0, (0, parcelRequire("9z04W")).MediaClient)({
            authProvider: ()=>Promise.resolve({
                    clientId: '',
                    token: '',
                    baseUrl: ''
                })
        });
        let mediaClient = $2a03c62fd3cc05ea$export$f92e83e86b03c398.get(mediaClientConfig);
        if (!mediaClient) {
            mediaClient = new (0, (0, parcelRequire("9z04W")).MediaClient)(mediaClientConfig);
            $2a03c62fd3cc05ea$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
        }
        return mediaClient;
    };
    const $2a03c62fd3cc05ea$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
        const mediaClient = (0, $5uXOq.useMemo)(()=>$2a03c62fd3cc05ea$export$c9ecbc1b719fd417(clientConfig), [
            clientConfig
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2a03c62fd3cc05ea$export$ba5d7212f2b4619f.Provider, {
            value: mediaClient
        }, children);
    };
    const $2a03c62fd3cc05ea$export$8b3e87ea56c3a345 = ()=>{
        const mediaClient = (0, ($parcel$interopDefault($5uXOq))).useContext($2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
        if (!mediaClient) throw new Error('No MediaClient set, use MediaClientProvider to set one');
        return mediaClient;
    };
});
parcelRegister("9z04W", function(module, exports) {
    $parcel$export(module.exports, "MediaClient", ()=>$a9f77c891230da5c$export$fba8b4ca6d386aec);
    var $7n9mn = parcelRequire("7n9mn");
    parcelRequire("LmkUS");
    var $gPrGh = parcelRequire("gPrGh");
    var $1FyHg;
    var $iKPaV;
    var $5eAc2;
    parcelRequire("8HaZs");
    var $fN64m = parcelRequire("fN64m");
    class $a9f77c891230da5c$export$fba8b4ca6d386aec {
        constructor(mediaClientConfig, store = (0, $fN64m.mediaStore), mediaApi){
            this.mediaClientConfig = mediaClientConfig;
            this.store = store;
            this.mediaStore = mediaApi ?? new (0, (0, parcelRequire("1FyHg")).MediaStore)({
                authProvider: mediaClientConfig.authProvider,
                initialAuth: mediaClientConfig.initialAuth,
                chunkHashAlgorithm: mediaClientConfig.useSha256ForUploads ? (0, $gPrGh.ChunkHashAlgorithm).Sha256 : (0, $gPrGh.ChunkHashAlgorithm).Sha1,
                authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
            });
            this.config = mediaClientConfig;
            this.file = new (0, (0, parcelRequire("iKPaV")).FileFetcherImpl)(this.mediaStore, this.store);
            this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
            this.stargate = new (0, (0, parcelRequire("5eAc2")).StargateClient)(mediaClientConfig.stargateBaseUrl);
        }
        __DO_NOT_USE__getMediaStore() {
            return this.store;
        }
        getImage(id, params, controller, fetchMaxRes, traceContext) {
            return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
        }
        getImageUrl(id, params) {
            return this.mediaStore.getFileImageURL(id, params);
        }
        getImageUrlSync(id, params) {
            return this.mediaStore.getFileImageURLSync(id, params);
        }
        async getImageMetadata(id, params) {
            return (await this.mediaStore.getImageMetadata(id, params)).metadata;
        }
        async mobileUploadPromise() {
            if (this.mobileUpload) return this.mobileUpload;
            const module = await (parcelRequire("hUEMO"));
            this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
            return this.mobileUpload;
        }
        async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
            await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
        }
        on(event, listener) {
            this.eventEmitter.on(event, listener);
        }
        off(event, listener) {
            this.eventEmitter.off(event, listener);
        }
        emit(event, payload) {
            return this.eventEmitter.emit(event, payload);
        }
    }
});
parcelRegister("LmkUS", function(module, exports) {
    $parcel$export(module.exports, "mediaState", ()=>(parcelRequire("6a8j4")).mediaState);
    $parcel$export(module.exports, "isClientBasedAuth", ()=>(parcelRequire("hQvj4")).isClientBasedAuth);
    $parcel$export(module.exports, "authToOwner", ()=>(parcelRequire("hQvj4")).authToOwner);
    $parcel$export(module.exports, "ChunkHashAlgorithm", ()=>(parcelRequire("gPrGh")).ChunkHashAlgorithm);
    var $6a8j4 = parcelRequire("6a8j4");
    var $hQvj4 = parcelRequire("hQvj4");
    var $gPrGh = parcelRequire("gPrGh");
});
parcelRegister("6a8j4", function(module, exports) {
    $parcel$export(module.exports, "mediaState", ()=>$dc598dfdde7cc536$export$8cef61637918b288);
    var $7n9mn = parcelRequire("7n9mn");
    var $iwKVT = parcelRequire("iwKVT");
    const $dc598dfdde7cc536$export$8cef61637918b288 = {
        streams: new (0, $iwKVT.LRUMap)(1000),
        stateDeferreds: new Map(),
        eventEmitter: new (0, $7n9mn.EventEmitter2)()
    };
});
parcelRegister("iwKVT", function(module, exports) {
    !function(g, c) {
        c(module.exports);
    }(module.exports, function(g) {
        const c = Symbol("newer"), e = Symbol("older");
        class n {
            constructor(a, b){
                typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
            }
            _markEntryAsUsed(a) {
                if (a === this.newest) return;
                a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
            }
            assign(a) {
                let b, d = this.limit || Number.MAX_VALUE;
                this._keymap.clear();
                let m = a[Symbol.iterator]();
                for(let h = m.next(); !h.done; h = m.next()){
                    let f = new l(h.value[0], h.value[1]);
                    this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                    if (d-- == 0) throw new Error("overflow");
                }
                this.newest = b, this.size = this._keymap.size;
            }
            get(a) {
                var b = this._keymap.get(a);
                return b ? (this._markEntryAsUsed(b), b.value) : void 0;
            }
            set(a, b) {
                var d = this._keymap.get(a);
                return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
            }
            shift() {
                var a = this.oldest;
                if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                    a.key,
                    a.value
                ];
            }
            find(a) {
                let b = this._keymap.get(a);
                return b ? b.value : void 0;
            }
            has(a) {
                return this._keymap.has(a);
            }
            delete(a) {
                var b = this._keymap.get(a);
                return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
            }
            clear() {
                this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
            }
            keys() {
                return new j(this.oldest);
            }
            values() {
                return new k(this.oldest);
            }
            entries() {
                return this;
            }
            [Symbol.iterator]() {
                return new i(this.oldest);
            }
            forEach(a, b) {
                typeof b !== "object" && (b = this);
                let d = this.oldest;
                for(; d;)a.call(b, d.value, d.key, this), d = d[c];
            }
            toJSON() {
                for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                    key: d.key,
                    value: d.value
                }, d = d[c];
                return a;
            }
            toString() {
                for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
                return a;
            }
        }
        g.LRUMap = n;
        function l(a, b) {
            this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
        }
        function i(a) {
            this.entry = a;
        }
        i.prototype[Symbol.iterator] = function() {
            return this;
        }, i.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: [
                    a.key,
                    a.value
                ]
            }) : {
                done: !0,
                value: void 0
            };
        };
        function j(a) {
            this.entry = a;
        }
        j.prototype[Symbol.iterator] = function() {
            return this;
        }, j.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.key
            }) : {
                done: !0,
                value: void 0
            };
        };
        function k(a) {
            this.entry = a;
        }
        k.prototype[Symbol.iterator] = function() {
            return this;
        }, k.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.value
            }) : {
                done: !0,
                value: void 0
            };
        };
    });
});
parcelRegister("hQvj4", function(module, exports) {
    $parcel$export(module.exports, "isClientBasedAuth", ()=>$449c85d7d5bc4f1f$export$6ba49fcac9c46e54);
    $parcel$export(module.exports, "authToOwner", ()=>$449c85d7d5bc4f1f$export$17f6055767a8d96a);
    function $449c85d7d5bc4f1f$export$6ba49fcac9c46e54(auth) {
        return !!auth.clientId;
    }
    function $449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth) {
        return !!auth.asapIssuer;
    }
    const $449c85d7d5bc4f1f$export$17f6055767a8d96a = (auth)=>{
        if ($449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth)) return auth;
        const clientAuth = {
            id: auth.clientId,
            baseUrl: auth.baseUrl,
            token: auth.token
        };
        return clientAuth;
    };
});
parcelRegister("gPrGh", function(module, exports) {
    $parcel$export(module.exports, "ChunkHashAlgorithm", ()=>$506f1dfda055692a$export$d3e73a50cc549c2e);
    var $506f1dfda055692a$export$d3e73a50cc549c2e;
    (function(ChunkHashAlgorithm) {
        ChunkHashAlgorithm["Sha1"] = "sha1";
        ChunkHashAlgorithm["Sha256"] = "sha256";
    })($506f1dfda055692a$export$d3e73a50cc549c2e || ($506f1dfda055692a$export$d3e73a50cc549c2e = {}));
});
parcelRegister("1FyHg", function(module, exports) {
    $parcel$export(module.exports, "MediaStore", ()=>$5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba);
    $parcel$export(module.exports, "getMediaEnvironment", ()=>$5d0b8a2b8f8558c8$export$c8b741e18397852a);
    $parcel$export(module.exports, "getMediaRegion", ()=>$5d0b8a2b8f8558c8$export$20f9315304dd6726);
    parcelRequire("LmkUS");
    var $gPrGh = parcelRequire("gPrGh");
    var $hQvj4 = parcelRequire("hQvj4");
    var $7E56q;
    var $7LFAu;
    var $hzvnk;
    var $ale1y;
    var $eeVEv;
    var $5cMkQ;
    var $VSDnB;
    var $h2NC7;
    const $5d0b8a2b8f8558c8$var$MEDIA_API_REGION = 'media-api-region';
    const $5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
    const $5d0b8a2b8f8558c8$var$extendImageParams = (params, fetchMaxRes = false)=>{
        return {
            ...params,
            'max-age': params?.['max-age'] ?? (0, (0, parcelRequire("7E56q")).FILE_CACHE_MAX_AGE),
            allowAnimated: params?.allowAnimated ?? true,
            mode: params?.mode ?? 'crop',
            ...fetchMaxRes ? {
                width: (0, (0, parcelRequire("7E56q")).MAX_RESOLUTION),
                height: (0, (0, parcelRequire("7E56q")).MAX_RESOLUTION)
            } : {}
        };
    };
    const $5d0b8a2b8f8558c8$var$jsonHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    const $5d0b8a2b8f8558c8$var$cdnFeatureFlag = (endpoint)=>{
        let result = endpoint;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_media_cdn_delivery')) {
            if ((0, (0, parcelRequire("h2NC7")).isCommercial)()) result += '/cdn';
        }
        return result;
    };
    class $5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba {
        constructor(config){
            this.config = config;
            this.resolveAuth = (authContext)=>(0, (0, parcelRequire("5cMkQ")).resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
            this.resolveInitialAuth = ()=>(0, (0, parcelRequire("5cMkQ")).resolveInitialAuth)(this.config.initialAuth);
            this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $gPrGh.ChunkHashAlgorithm).Sha1;
        }
        async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
            const metadata = {
                method: 'PUT',
                endpoint: '/collection/{collectionName}'
            };
            const body = {
                actions: [
                    {
                        action: 'remove',
                        item: {
                            type: 'file',
                            id: id,
                            occurrenceKey: occurrenceKey
                        }
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            await this.request(`/collection/${collectionName}`, options);
        }
        createUpload(createUpTo = 1, collectionName, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/upload'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                params: {
                    createUpTo: createUpTo,
                    hashAlgorithm: this._chunkHashAlgorithm
                },
                headers: {
                    Accept: 'application/json'
                },
                traceContext: traceContext
            };
            return this.request(`/upload`, options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
            const metadata = {
                method: 'PUT',
                endpoint: '/chunk/{etag}'
            };
            const options = {
                ...metadata,
                params: {
                    uploadId: uploadId,
                    partNumber: partNumber
                },
                authContext: {
                    collectionName: collectionName
                },
                body: blob,
                traceContext: traceContext
            };
            await this.request(`/chunk/${etag}`, options);
        }
        createFileFromUpload(body, params = {}, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/file/upload'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                params: params,
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            return this.request('/file/upload', options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        getRejectedResponseFromDescriptor(descriptor, limit) {
            return {
                fileId: descriptor.fileId,
                error: {
                    code: 'ExceedMaxFileSizeLimit',
                    title: 'The expected file size exceeded the maximum size limit.',
                    href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                    limit: limit,
                    size: descriptor.size
                }
            };
        }
        async touchFiles(body, params = {}, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/upload/createWithFiles'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext,
                params: {
                    hashAlgorithm: this._chunkHashAlgorithm
                }
            };
            return this.request('/upload/createWithFiles', options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        getFile(fileId, params = {}, traceContext) {
            const metadata = {
                method: 'GET',
                endpoint: '/file/{fileId}'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                params: params,
                traceContext: traceContext
            };
            return this.request(`/file/${fileId}`, options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async getFileImageURL(id, params) {
            const { collection: collectionName } = params || {};
            const auth = await this.resolveAuth({
                collectionName: collectionName
            });
            return this.createFileImageURL(id, auth, params);
        }
        getFileImageURLSync(id, params) {
            const auth = this.resolveInitialAuth();
            return this.createFileImageURL(id, auth, params);
        }
        createFileImageURL(id, auth, params) {
            const options = {
                params: $5d0b8a2b8f8558c8$var$extendImageParams(params),
                auth: auth
            };
            const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
            return (0, (0, parcelRequire("eeVEv")).mapToMediaCdnUrl)((0, (0, parcelRequire("ale1y")).createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
        }
        async getFileBinary(id, collectionName, abortController, maxAge = (0, (0, parcelRequire("7E56q")).FILE_CACHE_MAX_AGE)) {
            const headers = {};
            const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
            const metadata = {
                method: 'GET',
                endpoint: `/file/{fileId}/${binaryEndpoint}`
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: headers,
                params: {
                    collection: collectionName,
                    'max-age': `${maxAge}`
                }
            };
            return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, (0, parcelRequire("ale1y")).createMapResponseToBlob)(metadata));
        }
        async getFileBinaryURL(id, collectionName, maxAge = (0, (0, parcelRequire("7E56q")).FILE_CACHE_MAX_AGE)) {
            const auth = await this.resolveAuth({
                collectionName: collectionName
            });
            const options = {
                params: {
                    dl: true,
                    collection: collectionName,
                    'max-age': maxAge
                },
                auth: auth
            };
            const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
            return (0, (0, parcelRequire("eeVEv")).mapToMediaCdnUrl)((0, (0, parcelRequire("ale1y")).createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
        }
        async getArtifactURL(artifacts, artifactName, collectionName) {
            const artifactUrl = (0, (0, parcelRequire("7LFAu")).getArtifactUrl)(artifacts, artifactName);
            if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
            const auth = await this.resolveAuth({
                collectionName: collectionName
            });
            const options = {
                params: {
                    collection: collectionName,
                    'max-age': (0, (0, parcelRequire("7E56q")).FILE_CACHE_MAX_AGE)
                },
                auth: auth
            };
            return (0, (0, parcelRequire("ale1y")).createUrl)((0, (0, parcelRequire("eeVEv")).mapToMediaCdnUrl)(artifactUrl, auth.token), options);
        }
        async getImage(id, params, controller, fetchMaxRes, traceContext) {
            const isWebpSupported = false;
            const headers = {};
            if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
            const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
            const metadata = {
                method: 'GET',
                endpoint: `/file/{fileId}/${imageEndpoint}`
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params && params.collection
                },
                params: $5d0b8a2b8f8558c8$var$extendImageParams(params, fetchMaxRes),
                headers: headers,
                traceContext: traceContext,
                addMediaClientParam: true
            };
            return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, (0, parcelRequire("ale1y")).createMapResponseToBlob)(metadata));
        }
        async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
            const descriptors = ids.map((id)=>({
                    type: 'file',
                    id: id,
                    collection: collectionName
                }));
            const metadata = {
                method: 'POST',
                endpoint: '/items'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify({
                    descriptors: descriptors,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                }),
                traceContext: traceContext
            };
            return this.request('/items', options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async getImageMetadata(id, params, traceContext) {
            const metadata = {
                method: 'GET',
                endpoint: '/file/{fileId}/image/metadata'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params && params.collection
                },
                params: params,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/image/metadata`, options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
            const metadata = {
                method: 'PUT',
                endpoint: '/upload/{uploadId}/chunks'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            await this.request(`/upload/${uploadId}/chunks`, options);
        }
        copyFileWithToken(body, params, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/file/copy/withToken'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                params: params,
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            return this.request('/file/copy/withToken', options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        copyFile(id, params, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/v2/file/copy'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                params: params,
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify({
                    id: id
                }),
                traceContext: traceContext
            };
            return this.request('/v2/file/copy', options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async registerCopyIntents(ids, collectionName, traceContext) {
            const files = ids.map((id)=>({
                    id: id,
                    collection: collectionName
                }));
            const metadata = {
                method: 'POST',
                endpoint: '/file/copy/intents'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify({
                    files: files
                }),
                traceContext: traceContext
            };
            await this.request('/file/copy/intents', options);
        }
        async request(path, options = {
            method: 'GET',
            endpoint: undefined,
            authContext: {}
        }, controller, useMediaCdn) {
            const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam } = options;
            const auth = await this.resolveAuth(authContext);
            const clientId = (0, $hQvj4.isClientBasedAuth)(auth) ? auth.clientId : undefined;
            const extendedTraceContext = (0, (0, parcelRequire("ale1y")).extendTraceContext)(traceContext);
            const extendedParams = addMediaClientParam ? {
                ...params,
                clientId: clientId
            } : params;
            let url = `${auth.baseUrl}${path}`;
            if (useMediaCdn) url = (0, (0, parcelRequire("eeVEv")).mapToMediaCdnUrl)(url, auth.token);
            const response = await (0, (0, parcelRequire("hzvnk")).request)(url, {
                method: method,
                endpoint: endpoint,
                auth: auth,
                params: extendedParams,
                headers: headers,
                body: body,
                clientOptions: clientOptions,
                traceContext: extendedTraceContext
            }, controller);
            $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
            $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
            return response;
        }
        async testUrl(url, options = {}) {
            const { traceContext: traceContext } = options;
            await (0, (0, parcelRequire("hzvnk")).request)(url, {
                method: 'HEAD',
                traceContext: (0, (0, parcelRequire("ale1y")).extendTraceContext)(traceContext),
                clientOptions: {
                    retryOptions: {
                        maxAttempts: 1
                    }
                }
            });
        }
        get chunkHashAlgorithm() {
            return this._chunkHashAlgorithm;
        }
    }
    const $5d0b8a2b8f8558c8$var$getValueFromSessionStorage = (key)=>{
        return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
    };
    const $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage = (key, value)=>{
        if (!value || !(window && window.sessionStorage)) return;
        const currentValue = window.sessionStorage.getItem(key);
        if (currentValue !== value) window.sessionStorage.setItem(key, value);
    };
    const $5d0b8a2b8f8558c8$export$c8b741e18397852a = ()=>{
        return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT);
    };
    const $5d0b8a2b8f8558c8$export$20f9315304dd6726 = ()=>{
        return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION);
    };
});
parcelRegister("7E56q", function(module, exports) {
    $parcel$export(module.exports, "RECENTS_COLLECTION", ()=>$7a454a77a18dd963$export$860a16125e30000b);
    $parcel$export(module.exports, "FILE_CACHE_MAX_AGE", ()=>$7a454a77a18dd963$export$bd6e8fe09a90927b);
    $parcel$export(module.exports, "MAX_RESOLUTION", ()=>$7a454a77a18dd963$export$6e70f30e392bc53f);
    $parcel$export(module.exports, "CHUNK_SIZE", ()=>$7a454a77a18dd963$export$c1abb8bab1e615cd);
    $parcel$export(module.exports, "PROCESSING_BATCH_SIZE", ()=>$7a454a77a18dd963$export$3d5157f0def70e54);
    $parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", ()=>$7a454a77a18dd963$export$f14f521f3d306044);
    var $749LC;
    const $7a454a77a18dd963$export$860a16125e30000b = 'recents';
    const $7a454a77a18dd963$export$bd6e8fe09a90927b = 2592000;
    const $7a454a77a18dd963$export$6e70f30e392bc53f = 4096;
    const $7a454a77a18dd963$export$c1abb8bab1e615cd = 5 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
    const $7a454a77a18dd963$export$3d5157f0def70e54 = 1000;
    const $7a454a77a18dd963$export$f14f521f3d306044 = 2 * (0, (0, parcelRequire("749LC")).DATA_UNIT).TB;
});
parcelRegister("749LC", function(module, exports) {
    $parcel$export(module.exports, "isNotFoundMediaItemDetails", ()=>$330ebd66cbfb5bbe$export$fd27d7abbc4a746d);
    $parcel$export(module.exports, "DATA_UNIT", ()=>$330ebd66cbfb5bbe$export$76cfea4c354af843);
    const $330ebd66cbfb5bbe$export$350ede7b7a6acf99 = (type)=>{
        const defaultPreviewableTypes = [
            'audio',
            'video',
            'image',
            'doc'
        ];
        return defaultPreviewableTypes.indexOf(type) > -1;
    };
    const $330ebd66cbfb5bbe$export$fd27d7abbc4a746d = (itemDetails)=>{
        return 'type' in itemDetails && itemDetails.type === 'not-found';
    };
    var $330ebd66cbfb5bbe$export$76cfea4c354af843;
    (function(DATA_UNIT) {
        DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
        DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
        DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    })($330ebd66cbfb5bbe$export$76cfea4c354af843 || ($330ebd66cbfb5bbe$export$76cfea4c354af843 = {}));
});
parcelRegister("7LFAu", function(module, exports) {
    $parcel$export(module.exports, "getArtifactUrl", ()=>$cc56e843db2c0cea$export$1cc24defa44e7f84);
    var $VSDnB;
    var $h2NC7;
    const $cc56e843db2c0cea$export$1cc24defa44e7f84 = (artifacts, prop)=>{
        if ((0, (0, parcelRequire("h2NC7")).isCommercial)() && (0, (0, parcelRequire("VSDnB")).fg)('platform_media_cdn_delivery') && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
        return artifacts[prop]?.url;
    };
});
parcelRegister("h2NC7", function(module, exports) {
    $parcel$export(module.exports, "isCommercial", ()=>$bc3c8a168b66c7db$export$df69ff6733e73e50);
    function $bc3c8a168b66c7db$export$df69ff6733e73e50() {
        const global = globalThis;
        const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
        if (perimeter) return perimeter === 'commercial';
        return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
    }
});
parcelRegister("hzvnk", function(module, exports) {
    $parcel$export(module.exports, "request", ()=>$ac16e0b7f5d65450$export$b5fe3f66a567bec0);
    var $1As4I;
    var $ale1y;
    async function $ac16e0b7f5d65450$export$b5fe3f66a567bec0(url, options = {}, controller) {
        const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
        const { retryOptions: retryOptions } = clientOptions;
        const metadata = {
            method: method,
            endpoint: endpoint,
            traceContext: traceContext
        };
        const doFetch = ()=>fetch((0, (0, parcelRequire("ale1y")).createUrl)(url, {
                params: params
            }), {
                method: method,
                body: body,
                headers: (0, (0, parcelRequire("ale1y")).extendHeaders)(headers, auth, traceContext),
                signal: controller && controller.signal
            }).then((0, (0, parcelRequire("ale1y")).createProcessFetchResponse)(metadata));
        return (0, (0, parcelRequire("ale1y")).fetchRetry)(doFetch, metadata, retryOptions);
    }
});
parcelRegister("1As4I", function(module, exports) {
    $parcel$export(module.exports, "RequestError", ()=>$a9b96946563d0d09$export$43ee7d0e4f429743);
    $parcel$export(module.exports, "isRequestError", ()=>$a9b96946563d0d09$export$3717b1ffef4428ea);
    var $gFZHi;
    class $a9b96946563d0d09$export$43ee7d0e4f429743 extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, metadata, innerError){
            super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        }
        get attributes() {
            const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
            return {
                reason: reason,
                method: method,
                endpoint: endpoint,
                mediaRegion: mediaRegion,
                mediaEnv: mediaEnv,
                attempts: attempts,
                clientExhaustedRetries: clientExhaustedRetries,
                statusCode: statusCode,
                metadata: {
                    traceContext: traceContext
                },
                innerError: innerError
            };
        }
    }
    function $a9b96946563d0d09$export$3717b1ffef4428ea(err) {
        return err instanceof $a9b96946563d0d09$export$43ee7d0e4f429743;
    }
});
parcelRegister("gFZHi", function(module, exports) {
    $parcel$export(module.exports, "BaseMediaClientError", ()=>$fd6342ef86e499fe$export$2b0aca14d61c3190);
    var $loYHr;
    class $fd6342ef86e499fe$export$2b0aca14d61c3190 extends Error {
        constructor(message){
            super(message), this.message = message;
            Object.setPrototypeOf(this, new.target.prototype);
            if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
        }
    }
});
parcelRegister("loYHr", function(module, exports) {
    $parcel$export(module.exports, "isMediaClientError", ()=>$8608a1f56c9594c2$export$2491e0bbdb59256e);
    $parcel$export(module.exports, "getMediaClientErrorReason", ()=>$8608a1f56c9594c2$export$c15d72765ee2baa4);
    function $8608a1f56c9594c2$export$2491e0bbdb59256e(error) {
        return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
    }
    function $8608a1f56c9594c2$export$c15d72765ee2baa4(err) {
        return $8608a1f56c9594c2$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
    }
});
parcelRegister("ale1y", function(module, exports) {
    $parcel$export(module.exports, "isRateLimitedError", ()=>$96f7b73b7943f312$export$bc96a6a479480590);
    $parcel$export(module.exports, "extendTraceContext", ()=>$96f7b73b7943f312$export$ee24a95986dfd173);
    $parcel$export(module.exports, "createUrl", ()=>$96f7b73b7943f312$export$7138c24907de3954);
    $parcel$export(module.exports, "extendHeaders", ()=>$96f7b73b7943f312$export$18cfbabc415d771c);
    $parcel$export(module.exports, "createMapResponseToJson", ()=>$96f7b73b7943f312$export$e0519b126b73efa6);
    $parcel$export(module.exports, "createMapResponseToBlob", ()=>$96f7b73b7943f312$export$5cc7b0795397da86);
    $parcel$export(module.exports, "fetchRetry", ()=>$96f7b73b7943f312$export$782df2acbe10b22c);
    $parcel$export(module.exports, "createRequestErrorReason", ()=>$96f7b73b7943f312$export$6397609af718d008);
    $parcel$export(module.exports, "createProcessFetchResponse", ()=>$96f7b73b7943f312$export$6e2e477edb7d6032);
    parcelRequire("LmkUS");
    var $hQvj4 = parcelRequire("hQvj4");
    var $27T0s;
    var $3JV6R;
    var $1As4I;
    function $96f7b73b7943f312$export$80c51ea1e89203dd(timeout) {
        return new Promise((resolve)=>setTimeout(resolve, timeout));
    }
    function $96f7b73b7943f312$export$de0b576cf7ce4a53(err) {
        return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
    }
    function $96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) {
        return err instanceof TypeError;
    }
    function $96f7b73b7943f312$export$bc96a6a479480590(error) {
        return !!error && (0, (0, parcelRequire("1As4I")).isRequestError)(error) && error.attributes.statusCode === 429 || !!error && !!error.message && error.message.includes('429');
    }
    const $96f7b73b7943f312$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
            ...traceContext,
            spanId: traceContext?.spanId || (0, (0, parcelRequire("27T0s")).getRandomHex)(8)
        } : undefined;
    const $96f7b73b7943f312$export$922566b90d0535ce = {
        traceId: 'x-b3-traceid',
        spanId: 'x-b3-spanid',
        parentSpanId: 'x-b3-parentspanid',
        sampled: 'x-b3-sampled',
        flags: 'x-b3-flags'
    };
    const $96f7b73b7943f312$var$mapTraceIdToRequestHeaders = (traceContext)=>{
        return traceContext ? {
            [$96f7b73b7943f312$export$922566b90d0535ce.traceId]: traceContext.traceId,
            [$96f7b73b7943f312$export$922566b90d0535ce.spanId]: traceContext.spanId
        } : {};
    };
    function $96f7b73b7943f312$export$eaf4479116d2f925(auth) {
        if (!auth) return {};
        if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
            'X-Client-Id': auth.clientId,
            Authorization: `Bearer ${auth.token}`
        };
        return {
            'X-Issuer': auth.asapIssuer,
            Authorization: `Bearer ${auth.token}`
        };
    }
    function $96f7b73b7943f312$export$7138c24907de3954(url, { params: params, auth: auth }) {
        const parsedUrl = new URL(url, auth?.baseUrl);
        const authParams = auth && (0, (0, parcelRequire("3JV6R")).mapAuthToQueryParameters)(auth) || {};
        const paramsToAppend = {
            ...params,
            ...authParams
        };
        Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
            parsedUrl.searchParams.append(...pair);
        });
        parsedUrl.searchParams.sort();
        return parsedUrl.toString();
    }
    function $96f7b73b7943f312$export$18cfbabc415d771c(headers, auth, traceContext) {
        if (!auth && !traceContext && !headers) return undefined;
        return {
            ...headers ?? {},
            ...$96f7b73b7943f312$export$eaf4479116d2f925(auth),
            ...$96f7b73b7943f312$var$mapTraceIdToRequestHeaders(traceContext)
        };
    }
    function $96f7b73b7943f312$export$e0519b126b73efa6(metadata) {
        return async (response)=>{
            try {
                return await response.json();
            } catch (err) {
                throw new (0, (0, parcelRequire("1As4I")).RequestError)('serverInvalidBody', {
                    ...metadata,
                    ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                    statusCode: response.status
                }, err instanceof Error ? err : undefined);
            }
        };
    }
    function $96f7b73b7943f312$export$5cc7b0795397da86(metadata) {
        return async (response)=>{
            try {
                return await response.blob();
            } catch (err) {
                throw new (0, (0, parcelRequire("1As4I")).RequestError)('serverInvalidBody', {
                    ...metadata,
                    ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                    statusCode: response.status
                }, err instanceof Error ? err : undefined);
            }
        };
    }
    const $96f7b73b7943f312$export$c65cfa70960d8fe5 = {
        startTimeoutInMs: 1000,
        maxAttempts: 5,
        factor: 2
    };
    function $96f7b73b7943f312$export$359f19ca51f9eba1(error, extraMetadata) {
        const { reason: reason, metadata: metadata, innerError: innerError } = error;
        return new (0, (0, parcelRequire("1As4I")).RequestError)(reason, {
            ...metadata,
            ...extraMetadata
        }, innerError);
    }
    async function $96f7b73b7943f312$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
        const options = {
            ...$96f7b73b7943f312$export$c65cfa70960d8fe5,
            ...overwriteOptions
        };
        const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor } = options;
        let attempts = 0;
        let timeoutInMs = startTimeoutInMs;
        let lastError;
        const waitAndBumpTimeout = async ()=>{
            await $96f7b73b7943f312$export$80c51ea1e89203dd(timeoutInMs);
            timeoutInMs *= factor;
            attempts += 1;
        };
        while(attempts < maxAttempts)try {
            return await functionToRetry();
        } catch (err) {
            lastError = err;
            if ($96f7b73b7943f312$export$de0b576cf7ce4a53(err)) throw new (0, (0, parcelRequire("1As4I")).RequestError)('clientAbortedRequest', metadata, err);
            if (!$96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) && !(0, (0, parcelRequire("1As4I")).isRequestError)(err) || (0, (0, parcelRequire("1As4I")).isRequestError)(err) && (!err.metadata || !err.metadata.statusCode || err.metadata.statusCode < 500)) throw err;
            await waitAndBumpTimeout();
        }
        if ((0, (0, parcelRequire("1As4I")).isRequestError)(lastError)) throw $96f7b73b7943f312$export$359f19ca51f9eba1(lastError, {
            attempts: attempts,
            clientExhaustedRetries: true
        });
        throw new (0, (0, parcelRequire("1As4I")).RequestError)('serverUnexpectedError', {
            ...metadata,
            attempts: attempts,
            clientExhaustedRetries: true
        }, lastError);
    }
    function $96f7b73b7943f312$export$6397609af718d008(statusCode) {
        switch(statusCode){
            case 400:
                return 'serverBadRequest';
            case 401:
                return 'serverUnauthorized';
            case 403:
                return 'serverForbidden';
            case 404:
                return 'serverNotFound';
            case 429:
                return 'serverRateLimited';
            case 500:
                return 'serverInternalError';
            case 502:
                return 'serverBadGateway';
            default:
                return 'serverUnexpectedError';
        }
    }
    function $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response) {
        const { status: statusCode } = response;
        const reason = $96f7b73b7943f312$export$6397609af718d008(statusCode);
        return new (0, (0, parcelRequire("1As4I")).RequestError)(reason, {
            ...metadata,
            ...$96f7b73b7943f312$export$ea175c0c5497224(response),
            statusCode: statusCode
        });
    }
    function $96f7b73b7943f312$export$6e2e477edb7d6032(metadata) {
        return (response)=>{
            if (response.ok || response.status < 400) return response;
            const requestError = $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response);
            throw requestError;
        };
    }
    function $96f7b73b7943f312$export$ea175c0c5497224(response) {
        const { headers: headers } = response;
        const mediaRegion = headers.get('x-media-region') || 'unknown';
        const mediaEnv = headers.get('x-media-env') || 'unknown';
        return {
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv
        };
    }
});
parcelRegister("27T0s", function(module, exports) {
    $parcel$export(module.exports, "isUndefined", ()=>$5713248736bc73bb$export$fce6876652108ab);
    $parcel$export(module.exports, "omitBy", ()=>$5713248736bc73bb$export$d7a617dda645b4e3);
    $parcel$export(module.exports, "getRandomHex", ()=>$5713248736bc73bb$export$456b25e3a9b4a843);
    const $5713248736bc73bb$export$fce6876652108ab = (value)=>value === undefined;
    const $5713248736bc73bb$export$357523c63a2253b9 = (obj, keys = [])=>{
        if (obj === undefined) return {};
        return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
    };
    const $5713248736bc73bb$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
    const $5713248736bc73bb$export$61fc7d43ac8f84b0 = (func, wait)=>{
        let timeout;
        return (...args)=>{
            clearTimeout(timeout);
            timeout = setTimeout(()=>func(...args), wait);
        };
    };
    const $5713248736bc73bb$export$de994efd351b291c = (srcObj)=>{
        return (obj)=>{
            let key;
            for(key in srcObj){
                if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
            }
            return true;
        };
    };
    function $5713248736bc73bb$var$getRandomHexValues(byte) {
        return [
            ...Array(byte * 2)
        ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
    }
    function $5713248736bc73bb$export$456b25e3a9b4a843(byte) {
        let randomHex;
        if (window?.crypto) try {
            randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
        } catch (e) {
            randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
        }
        else randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
        return randomHex;
    }
});
parcelRegister("3JV6R", function(module, exports) {
    $parcel$export(module.exports, "mapAuthToQueryParameters", ()=>$30be3f63a223d0a0$export$6833b130611df767);
    parcelRequire("LmkUS");
    var $hQvj4 = parcelRequire("hQvj4");
    function $30be3f63a223d0a0$export$6833b130611df767(auth) {
        if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
            client: auth.clientId,
            token: auth.token
        };
        else return {
            issuer: auth.asapIssuer,
            token: auth.token
        };
    }
});
parcelRegister("eeVEv", function(module, exports) {
    $parcel$export(module.exports, "mapToMediaCdnUrl", ()=>$ac061c5da59ee1d7$export$fb88a576cf28364d);
    var $VSDnB;
    var $h2NC7;
    const $ac061c5da59ee1d7$export$8a9b6ab3569a543a = {
        'api.media.atlassian.com': 'media-cdn.atlassian.com',
        'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
    };
    const $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
    function $ac061c5da59ee1d7$export$fb88a576cf28364d(url, token) {
        const tokenLength = token?.length ?? 0;
        if (!(0, (0, parcelRequire("h2NC7")).isCommercial)() || tokenLength > $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_media_cdn_delivery') && (0, (0, parcelRequire("VSDnB")).fg)('platform_media_cdn_single_host')) try {
            const parsedUrl = new URL(url);
            const cdnHost = $ac061c5da59ee1d7$export$8a9b6ab3569a543a[parsedUrl.host];
            if (!cdnHost) return url;
            parsedUrl.host = cdnHost;
            return parsedUrl.toString();
        } catch (error) {
            return url;
        }
        return url;
    }
});
parcelRegister("5cMkQ", function(module, exports) {
    $parcel$export(module.exports, "resolveAuth", ()=>$c6441b149d7d138c$export$4b4cec3dcdfce972);
    $parcel$export(module.exports, "resolveInitialAuth", ()=>$c6441b149d7d138c$export$5211e1371264aec3);
    var $ciNTb;
    var $irn0C;
    const $c6441b149d7d138c$export$560085fe411c0660 = 10000;
    const $c6441b149d7d138c$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $c6441b149d7d138c$export$560085fe411c0660)=>{
        let auth;
        try {
            auth = await Promise.race([
                authProvider(authContext),
                (0, (0, parcelRequire("irn0C")).rejectTimeout)(authProviderTimeout, new (0, (0, parcelRequire("ciNTb")).MediaStoreError)('authProviderTimedOut'))
            ]);
        } catch (err) {
            if (err instanceof (0, (0, parcelRequire("ciNTb")).MediaStoreError)) throw err;
            throw new (0, (0, parcelRequire("ciNTb")).MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
        }
        if (!auth) throw new (0, (0, parcelRequire("ciNTb")).MediaStoreError)('emptyAuth');
        return auth;
    };
    const $c6441b149d7d138c$export$5211e1371264aec3 = (auth)=>{
        if (!auth) throw new (0, (0, parcelRequire("ciNTb")).MediaStoreError)('missingInitialAuth');
        return auth;
    };
});
parcelRegister("ciNTb", function(module, exports) {
    $parcel$export(module.exports, "MediaStoreError", ()=>$63300db0f534a20c$export$b78480bd311630bc);
    $parcel$export(module.exports, "isMediaStoreError", ()=>$63300db0f534a20c$export$8d2a9b675b2ce37a);
    var $gFZHi;
    class $63300db0f534a20c$export$b78480bd311630bc extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, innerError){
            super(reason), this.reason = reason, this.innerError = innerError;
        }
        get attributes() {
            const { reason: reason, innerError: innerError } = this;
            return {
                reason: reason,
                innerError: innerError
            };
        }
    }
    function $63300db0f534a20c$export$8d2a9b675b2ce37a(err) {
        return err instanceof $63300db0f534a20c$export$b78480bd311630bc;
    }
});
parcelRegister("irn0C", function(module, exports) {
    $parcel$export(module.exports, "rejectTimeout", ()=>$974e005d07aa0732$export$cf2d2a1124beacb2);
    const $974e005d07aa0732$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
            setTimeout(resolve, timeout, resolveWith);
        });
    const $974e005d07aa0732$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
            setTimeout(reject, timeout, rejectWith);
        });
});
parcelRegister("iKPaV", function(module, exports) {
    $parcel$export(module.exports, "FileFetcherImpl", ()=>$acdec836078e8c40$export$fe17eabf77aabacb);
    $parcel$export(module.exports, "FileFetcherError", ()=>(parcelRequire("gpU3c")).FileFetcherError);
    var $aZdZn = parcelRequire("aZdZn");
    var $cVFxd = parcelRequire("cVFxd");
    var $bXrHm = parcelRequire("bXrHm");
    parcelRequire("LmkUS");
    var $hQvj4 = parcelRequire("hQvj4");
    var $txcJN;
    var $1FyHg;
    var $1Pp1U;
    var $749LC;
    var $gpU3c;
    var $i57HF;
    var $hkwMq;
    var $bfb59;
    var $7E56q;
    var $6CZ6k = parcelRequire("6CZ6k");
    var $7p3Ot;
    var $lVahM;
    var $dhdZw;
    var $gayAy;
    var $j1BIJ;
    var $lYDAe;
    var $29M1K;
    var $2Mh8o;
    var $jzW7G;
    var $gR4o6;
    var $dJ905;
    var $9KWg9;
    parcelRequire("8HaZs");
    var $fN64m = parcelRequire("fN64m");
    class $acdec836078e8c40$export$fe17eabf77aabacb {
        constructor(mediaApi, store = (0, $fN64m.mediaStore)){
            this.mediaApi = mediaApi;
            this.store = store;
            this.getErrorFileState = (error, id, occurrenceKey)=>{
                const { metadata: metadata, ...attributes } = error?.attributes ?? {};
                return typeof error === 'string' ? {
                    status: 'error',
                    id: id,
                    reason: error,
                    occurrenceKey: occurrenceKey,
                    message: error
                } : {
                    status: 'error',
                    id: id,
                    reason: error?.reason,
                    details: {
                        ...attributes,
                        ...metadata?.traceContext && {
                            metadata: metadata
                        }
                    },
                    occurrenceKey: occurrenceKey,
                    message: error?.message
                };
            };
            this.setFileState = (id, fileState)=>{
                this.store.setState((state)=>{
                    state.files[id] = fileState;
                });
            };
            this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles)=>{
                const subject = (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
                const poll = new (0, (0, parcelRequire("dJ905")).PollingFunction)();
                poll.onError = (error)=>subject.error(error);
                poll.execute(async ()=>{
                    const response = await this.dataloader.load({
                        id: id,
                        collectionName: collectionName,
                        includeHashForDuplicateFiles: includeHashForDuplicateFiles
                    });
                    if ((0, (0, parcelRequire("749LC")).isNotFoundMediaItemDetails)(response)) throw new (0, (0, parcelRequire("gpU3c")).FileFetcherError)('emptyItems', id, {
                        collectionName: collectionName,
                        occurrenceKey: occurrenceKey,
                        traceContext: response.metadataTraceContext
                    });
                    if ((0, (0, parcelRequire("9KWg9")).isEmptyFile)(response)) throw new (0, (0, parcelRequire("gpU3c")).FileFetcherError)('zeroVersionFile', id, {
                        collectionName: collectionName,
                        occurrenceKey: occurrenceKey,
                        traceContext: response.metadataTraceContext
                    });
                    const fileState = (0, (0, parcelRequire("1Pp1U")).mapMediaItemToFileState)(id, response);
                    subject.next(fileState);
                    switch(fileState.status){
                        case 'processing':
                            poll.next();
                            break;
                        case 'processed':
                            subject.complete();
                            break;
                    }
                });
                return subject;
            };
            this.getUploadingFileStateBase = (file, upfrontId)=>{
                if (typeof file.content === 'string') file.content = (0, (0, parcelRequire("gayAy")).convertBase64ToBlob)(file.content);
                const { content: content, name: name = '' } = file;
                const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
                let preview;
                let size = 0;
                let mimeType = '';
                if (content instanceof Blob) {
                    size = content.size;
                    mimeType = content.type;
                    preview = {
                        value: content,
                        origin: 'local'
                    };
                }
                const mediaType = (0, (0, parcelRequire("lVahM")).getMediaTypeFromUploadableFile)(file);
                return {
                    id: id,
                    occurrenceKey: occurrenceKey,
                    name: name,
                    size: size,
                    mediaType: mediaType,
                    mimeType: mimeType,
                    preview: preview
                };
            };
            this.dataloader = (0, (0, parcelRequire("7p3Ot")).createFileDataloader)(mediaApi);
        }
        getFileState(id, options = {}) {
            const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
            if (!(0, ($parcel$interopDefault($6CZ6k)))(id)) {
                const subject = (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
                const err = new (0, (0, parcelRequire("gpU3c")).FileFetcherError)('invalidFileId', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                const { metadata: metadata, ...attributes } = err?.attributes ?? {};
                const errorFileState = {
                    status: 'error',
                    id: id,
                    reason: err?.reason,
                    message: err?.message,
                    occurrenceKey: occurrenceKey,
                    details: {
                        ...attributes,
                        ...metadata?.traceContext && {
                            metadata: metadata
                        }
                    }
                };
                subject.error(err);
                this.setFileState(id, errorFileState);
                return (0, (0, parcelRequire("j1BIJ")).fromObservable)(subject);
            }
            return (0, (0, parcelRequire("j1BIJ")).fromObservable)((0, (0, parcelRequire("hkwMq")).getFileStreamsCache)().getOrInsert(id, ()=>{
                const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles);
                subject.subscribe({
                    next: (fileState)=>{
                        this.setFileState(id, fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(id, errorFileState);
                    }
                });
                return subject;
            }));
        }
        getCurrentState(id, options) {
            return (0, (0, parcelRequire("lYDAe")).toPromise)(this.getFileState(id, options));
        }
        getArtifactURL(artifacts, artifactName, collectionName) {
            return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
        }
        getFileBinaryURL(id, collectionName, maxAge) {
            return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
        }
        touchFiles(descriptors, collection, traceContext) {
            return this.mediaApi.touchFiles({
                descriptors: descriptors
            }, {
                collection: collection
            }, traceContext).then(({ data: data })=>data);
        }
        generateUploadableFileUpfrontIds(collection, traceContext) {
            const id = (0, ($parcel$interopDefault($bXrHm)))();
            const occurrenceKey = (0, ($parcel$interopDefault($bXrHm)))();
            const touchFileDescriptor = {
                fileId: id,
                occurrenceKey: occurrenceKey,
                collection: collection
            };
            const deferredUploadId = this.touchFiles([
                touchFileDescriptor
            ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                deferredUploadId: deferredUploadId
            };
        }
        async uploadExternal(url, collection, traceContext) {
            const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
            const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
            const subject = (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
            const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
            const preview = new Promise(async (resolve, reject)=>{
                const blob = await deferredBlob;
                if (!blob) reject('Could not fetch the blob');
                resolve({
                    value: blob,
                    origin: 'remote'
                });
            });
            const name = url.split('/').pop() || '';
            const fileState = {
                status: 'processing',
                name: name,
                size: 0,
                mediaType: 'unknown',
                mimeType: '',
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            };
            subject.next(fileState);
            (0, (0, parcelRequire("hkwMq")).getFileStreamsCache)().set(id, subject);
            this.setFileState(id, fileState);
            return new Promise(async (resolve, reject)=>{
                const blob = await deferredBlob;
                if (!blob) return reject('Could not download remote file');
                const { type: type, size: size } = blob;
                const file = {
                    content: blob,
                    mimeType: type,
                    collection: collection,
                    name: name,
                    size: size
                };
                const mediaType = (0, (0, parcelRequire("jzW7G")).getMediaTypeFromMimeType)(type);
                subject.next({
                    status: 'processing',
                    name: name,
                    size: size,
                    mediaType: mediaType,
                    mimeType: type,
                    id: id,
                    occurrenceKey: occurrenceKey,
                    preview: preview
                });
                this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
                let dimensions;
                try {
                    dimensions = await (0, (0, parcelRequire("29M1K")).getDimensionsFromBlob)(mediaType, blob);
                } catch (error) {
                    reject(error);
                    return;
                }
                resolve({
                    dimensions: dimensions,
                    mimeType: type,
                    uploadableFileUpfrontIds: uploadableFileUpfrontIds
                });
            });
        }
        upload(file, controller, uploadableFileUpfrontIds, traceContext) {
            const { collection: collection } = file;
            const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            const stateBase = this.getUploadingFileStateBase(file, upfrontId);
            const subject = (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
            (0, (0, parcelRequire("hkwMq")).getFileStreamsCache)().set(id, subject);
            const onProgress = (progress)=>{
                const fileState = {
                    status: 'uploading',
                    ...stateBase,
                    progress: progress
                };
                subject.next(fileState);
                this.setFileState(id, fileState);
            };
            let processingSubscription = new (0, $aZdZn.Subscription)();
            const onUploadFinish = (error)=>{
                if (error) {
                    const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                    return subject.error(error);
                }
                processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $cVFxd.map)((remoteFileState)=>({
                        ...stateBase,
                        ...remoteFileState,
                        ...(0, (0, parcelRequire("dhdZw")).overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                    }))).subscribe({
                    next: (fileState)=>{
                        subject.next(fileState);
                        this.setFileState(id, fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        subject.error(err);
                        this.setFileState(id, errorFileState);
                    },
                    complete: subject.complete
                });
            };
            const { cancel: cancel } = (0, (0, parcelRequire("i57HF")).uploadFile)(file, this.mediaApi, upfrontId, {
                onUploadFinish: onUploadFinish,
                onProgress: onProgress
            }, traceContext);
            controller?.setAbort(()=>{
                cancel();
                processingSubscription.unsubscribe();
            });
            setTimeout(onProgress, 0, 0);
            return (0, (0, parcelRequire("j1BIJ")).fromObservable)(subject);
        }
        async downloadBinary(id, name = 'download', collectionName, traceContext) {
            const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
            (0, (0, parcelRequire("txcJN")).downloadUrl)(url, {
                name: name
            });
            (0, (0, parcelRequire("bfb59")).globalMediaEventEmitter).emit('media-viewed', {
                fileId: id,
                isUserCollection: collectionName === (0, (0, parcelRequire("7E56q")).RECENTS_COLLECTION),
                viewingLevel: 'download'
            });
            await this.mediaApi.testUrl(url, {
                traceContext: traceContext
            });
        }
        async copyFile(source, destination, options = {}, traceContext) {
            const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
            const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
            const { preview: preview, mimeType: mimeType } = options;
            const mediaStore = destination.mediaStore || new (0, (0, parcelRequire("1FyHg")).MediaStore)({
                authProvider: destinationAuthProvider
            });
            const owner = (0, $hQvj4.authToOwner)(await authProvider({
                collectionName: sourceCollection
            }));
            const body = {
                sourceFile: {
                    id: id,
                    collection: sourceCollection,
                    owner: owner
                }
            };
            const params = {
                collection: destinationCollectionName,
                replaceFileId: replaceFileId,
                occurrenceKey: occurrenceKey
            };
            const cache = (0, (0, parcelRequire("hkwMq")).getFileStreamsCache)();
            let processingSubscription;
            try {
                const { data: copiedFile } = await mediaStore.copyFileWithToken(body, params, traceContext);
                const copiedFileWithMimeType = {
                    ...copiedFile,
                    ...mimeType ? {
                        mimeType: mimeType
                    } : undefined
                };
                const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
                const mediaType = copiedMimeType ? (0, (0, parcelRequire("jzW7G")).getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
                const copiedFileState = (0, (0, parcelRequire("1Pp1U")).mapMediaFileToFileState)({
                    data: copiedFileWithMimeType
                });
                const fileCache = cache.get(copiedId);
                const subject = fileCache || (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
                const previewOverride = !(0, (0, parcelRequire("1Pp1U")).isErrorFileState)(copiedFileState) && !!preview ? {
                    preview: preview
                } : {};
                if (!(0, (0, parcelRequire("1Pp1U")).isFinalFileState)(copiedFileState) && copiedMimeType && await (0, (0, parcelRequire("gR4o6")).shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                    const fileState = {
                        ...copiedFileState,
                        ...(0, (0, parcelRequire("dhdZw")).overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                        ...previewOverride
                    };
                    subject.next(fileState);
                    this.setFileState(copiedId, fileState);
                    processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                        next: (remoteFileState)=>{
                            const fileState = {
                                ...remoteFileState,
                                ...(0, (0, parcelRequire("dhdZw")).overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                                ...!(0, (0, parcelRequire("1Pp1U")).isErrorFileState)(remoteFileState) && previewOverride
                            };
                            this.setFileState(copiedId, fileState);
                            return subject.next(fileState);
                        },
                        error: (err)=>{
                            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                            this.setFileState(copiedId, errorFileState);
                            return subject.error(err);
                        },
                        complete: ()=>subject.complete()
                    });
                } else if (!(0, (0, parcelRequire("1Pp1U")).isProcessingFileState)(copiedFileState)) {
                    const fileState = {
                        ...copiedFileState,
                        ...!(0, (0, parcelRequire("1Pp1U")).isErrorFileState)(copiedFileState) && previewOverride
                    };
                    subject.next(fileState);
                    this.setFileState(copiedId, fileState);
                }
                if (!cache.has(copiedId)) (0, (0, parcelRequire("hkwMq")).getFileStreamsCache)().set(copiedId, subject);
                return copiedFile;
            } catch (error) {
                if (processingSubscription) processingSubscription.unsubscribe();
                if (replaceFileId) {
                    const fileCache = cache.get(replaceFileId);
                    const replaceFileState = this.store.getState().files[replaceFileId];
                    if (fileCache) fileCache.error(error);
                    else cache.set(id, (0, (0, parcelRequire("2Mh8o")).createMediaSubject)(error));
                    const key = replaceFileState ? replaceFileId : id;
                    const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                    this.setFileState(key, errorFileState);
                }
                throw error;
            }
        }
    }
});
parcelRegister("txcJN", function(module, exports) {
    $parcel$export(module.exports, "downloadUrl", ()=>$4c4bd5defea17306$export$8a96edb1c96563f4);
    const $4c4bd5defea17306$export$8a96edb1c96563f4 = (url, options)=>{
        const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const iframeName = 'media-download-iframe';
        const link = document.createElement('a');
        let iframe = document.getElementById(iframeName);
        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.id = iframeName;
            iframe.name = iframeName;
            document.body.appendChild(iframe);
        }
        link.href = url;
        if (options && options.name) link.download = options.name;
        link.target = isIE11 || isSafari ? '_blank' : iframeName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
});
parcelRegister("1Pp1U", function(module, exports) {
    $parcel$export(module.exports, "isUploadingFileState", ()=>$8f64b07ac8c4c4df$export$70eb3481b487c668);
    $parcel$export(module.exports, "isProcessingFileState", ()=>$8f64b07ac8c4c4df$export$5c30e6dd75278e66);
    $parcel$export(module.exports, "isProcessedFileState", ()=>$8f64b07ac8c4c4df$export$1d17291aafa5f231);
    $parcel$export(module.exports, "isErrorFileState", ()=>$8f64b07ac8c4c4df$export$f863e1e09c8a926);
    $parcel$export(module.exports, "isPreviewableFileState", ()=>$8f64b07ac8c4c4df$export$92dd692b31e42e64);
    $parcel$export(module.exports, "isFinalFileState", ()=>$8f64b07ac8c4c4df$export$270b3fc27120edd0);
    $parcel$export(module.exports, "isImageRepresentationReady", ()=>$8f64b07ac8c4c4df$export$4e33ccde53b4f0bf);
    $parcel$export(module.exports, "mapMediaFileToFileState", ()=>$8f64b07ac8c4c4df$export$ddfd67d20657322f);
    $parcel$export(module.exports, "mapMediaItemToFileState", ()=>$8f64b07ac8c4c4df$export$ea3730792e8bebfb);
    const $8f64b07ac8c4c4df$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
    const $8f64b07ac8c4c4df$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
    const $8f64b07ac8c4c4df$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
    const $8f64b07ac8c4c4df$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
    const $8f64b07ac8c4c4df$export$92dd692b31e42e64 = (fileState)=>!$8f64b07ac8c4c4df$export$f863e1e09c8a926(fileState) && !!fileState.preview;
    const $8f64b07ac8c4c4df$export$270b3fc27120edd0 = (fileState)=>[
            'processed',
            'failed-processing',
            'error'
        ].includes(fileState.status);
    const $8f64b07ac8c4c4df$export$4e33ccde53b4f0bf = (fileState)=>{
        switch(fileState.status){
            case 'processing':
            case 'processed':
            case 'failed-processing':
                return !!(fileState.representations && fileState.representations.image);
            default:
                return false;
        }
    };
    const $8f64b07ac8c4c4df$export$ddfd67d20657322f = (mediaFile)=>{
        const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash } = mediaFile.data;
        const baseState = {
            id: id,
            name: name,
            size: size,
            mediaType: mediaType,
            mimeType: mimeType,
            artifacts: artifacts,
            representations: representations,
            createdAt: createdAt,
            hash: hash,
            metadataTraceContext: metadataTraceContext
        };
        switch(processingStatus){
            case 'pending':
            case undefined:
                return {
                    ...baseState,
                    status: 'processing'
                };
            case 'succeeded':
                return {
                    ...baseState,
                    status: 'processed'
                };
            case 'failed':
                return {
                    ...baseState,
                    status: 'failed-processing'
                };
        }
    };
    const $8f64b07ac8c4c4df$export$ea3730792e8bebfb = (id, item)=>{
        return $8f64b07ac8c4c4df$export$ddfd67d20657322f({
            data: {
                id: id,
                ...item
            }
        });
    };
});
parcelRegister("gpU3c", function(module, exports) {
    $parcel$export(module.exports, "FileFetcherError", ()=>$5a4b48edf9ec6627$export$e3e60f0dab8641de);
    var $gFZHi;
    class $5a4b48edf9ec6627$export$e3e60f0dab8641de extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, id, metadata){
            super(reason), this.reason = reason, this.id = id, this.metadata = metadata;
        }
        get attributes() {
            const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } = {} } = this;
            return {
                reason: reason,
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey,
                ...traceContext && {
                    metadata: {
                        traceContext: traceContext
                    }
                }
            };
        }
    }
    function $5a4b48edf9ec6627$export$5c3435f75ce0ce70(err) {
        return err instanceof $5a4b48edf9ec6627$export$e3e60f0dab8641de;
    }
});
parcelRegister("i57HF", function(module, exports) {
    $parcel$export(module.exports, "uploadFile", ()=>$8cd2ca9b1610ac88$export$a5575dbeeffdad98);
    var $fEpeZ;
    var $gI62y = parcelRequire("gI62y");
    var $ib0Rz = parcelRequire("ib0Rz");
    var $f6rzU;
    var $20Dmg;
    var $7E56q;
    var $empHz;
    const $8cd2ca9b1610ac88$var$hashingFunction = async (blob, hashAlgorithm)=>{
        const hasher = await (0, (0, parcelRequire("f6rzU")).createHasher)(hashAlgorithm);
        return hasher.hash(blob);
    };
    const $8cd2ca9b1610ac88$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
            return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
        };
    const $8cd2ca9b1610ac88$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
        let offset = 0;
        return async (chunks)=>{
            await store.appendChunksToUpload(await deferredUploadId, {
                chunks: $8cd2ca9b1610ac88$var$hashedChunks(chunks),
                offset: offset
            }, collection, traceContext);
            offset += chunks.length;
        };
    };
    const $8cd2ca9b1610ac88$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
        const { collection: collection, name: name, mimeType: mimeType } = file;
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const body = file.size ? {
            uploadId: uploadId,
            name: name,
            mimeType: mimeType,
            conditions: {
                size: file.size
            }
        } : {
            uploadId: uploadId,
            name: name,
            mimeType: mimeType
        };
        return store.createFileFromUpload(body, {
            occurrenceKey: occurrenceKey,
            collection: collection,
            replaceFileId: id
        }, traceContext);
    };
    const $8cd2ca9b1610ac88$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
        const { content: content, collection: collection } = file;
        const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        let chunkSize = (0, (0, parcelRequire("7E56q")).CHUNK_SIZE);
        try {
            if (content instanceof Blob) chunkSize = (0, (0, parcelRequire("empHz")).calculateChunkSize)(content.size);
        } catch (err) {
            if (err instanceof Error && err.message === (0, (0, parcelRequire("empHz")).fileSizeError)) callbacks?.onUploadFinish(new (0, (0, parcelRequire("20Dmg")).UploaderError)(err.message, id, {
                collectionName: collection,
                occurrenceKey: occurrenceKey
            }));
            return {
                cancel: ()=>{
                    callbacks?.onUploadFinish('canceled');
                }
            };
        }
        const chunkinatorObservable = (0, (0, parcelRequire("fEpeZ")).chunkinator)(content, {
            hashingFunction: (blob)=>$8cd2ca9b1610ac88$var$hashingFunction(blob, store.chunkHashAlgorithm),
            hashingConcurrency: 5,
            chunkSize: chunkSize,
            uploadingConcurrency: 3,
            uploadingFunction: $8cd2ca9b1610ac88$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
            processingBatchSize: (0, (0, parcelRequire("7E56q")).PROCESSING_BATCH_SIZE),
            processingFunction: $8cd2ca9b1610ac88$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
        }, {
            onProgress (progress) {
                if (callbacks) callbacks.onProgress(progress);
            }
        });
        const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
        const subscription = (0, $gI62y.from)(deferredUploadId).pipe((0, $ib0Rz.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $ib0Rz.concatMap)(()=>(0, $gI62y.from)($8cd2ca9b1610ac88$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
            error: (err)=>onUploadFinish(err),
            complete: ()=>onUploadFinish()
        });
        return {
            cancel: ()=>{
                subscription.unsubscribe();
                onUploadFinish('canceled');
            }
        };
    };
    const $8cd2ca9b1610ac88$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);
});
parcelRegister("fEpeZ", function(module, exports) {
    $parcel$export(module.exports, "chunkinator", ()=>$2c9b70a291565367$export$9ab6bef3838698f8);
    var $j7Dz8 = parcelRequire("j7Dz8");
    var $ib0Rz = parcelRequire("ib0Rz");
    var $9RLLl = parcelRequire("9RLLl");
    var $bXPjr = parcelRequire("bXPjr");
    var $dglPr;
    var $kDczJ;
    var $4Vmg1;
    var $6SPPN;
    var $RsgFX;
    var $gI62y = parcelRequire("gI62y");
    const $2c9b70a291565367$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $bXPjr.fromPromise)((0, (0, parcelRequire("RsgFX")).fetchBlob)(file)).pipe((0, $ib0Rz.concatMap)((blob)=>{
            const { chunkSize: chunkSize } = options;
            const { onProgress: onProgress } = callbacks;
            const totalChunks = Math.ceil(blob.size / chunkSize);
            const slicenatedBlobs = (0, (0, parcelRequire("dglPr")).slicenator)(blob, {
                size: chunkSize
            });
            const hashinatedBlobs = (0, (0, parcelRequire("kDczJ")).hashinator)(slicenatedBlobs, {
                concurrency: options.hashingConcurrency,
                hasher: options.hashingFunction
            });
            let uploadedChunks = 0;
            let uploadedBlobs = (0, (0, parcelRequire("4Vmg1")).uploadinator)(hashinatedBlobs, {
                concurrency: options.uploadingConcurrency,
                uploader: options.uploadingFunction
            });
            if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $j7Dz8.tap)(()=>{
                uploadedChunks += 1;
                onProgress(uploadedChunks / totalChunks);
            }));
            return (0, (0, parcelRequire("6SPPN")).processinator)(uploadedBlobs, {
                batchSize: options.processingBatchSize,
                processor: options.processingFunction
            }).pipe((0, $ib0Rz.concatMap)((batchedChunks)=>{
                return (0, $gI62y.from)(batchedChunks);
            }), (0, $9RLLl.bufferCount)(totalChunks));
        }));
    const $2c9b70a291565367$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
        return $2c9b70a291565367$export$88e80b3a0bb31f63(file, options, callbacks);
    };
});
parcelRegister("dglPr", function(module, exports) {
    $parcel$export(module.exports, "slicenator", ()=>$f0508944ab60c7e6$export$5b92d769f2f57509);
    var $eTa7E = parcelRequire("eTa7E");
    var $cVFxd = parcelRequire("cVFxd");
    const $f0508944ab60c7e6$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
        const totalChunks = Math.ceil(blob.size / chunkSize);
        return (0, $eTa7E.range)(0, totalChunks).pipe((0, $cVFxd.map)((index)=>{
            return {
                partNumber: index + 1,
                blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
            };
        }));
    };
});
parcelRegister("kDczJ", function(module, exports) {
    $parcel$export(module.exports, "hashinator", ()=>$3a9c605917062ecc$export$d5f5a550a38ec367);
    var $RsgFX;
    const $3a9c605917062ecc$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                    blob: slicedBlob.blob,
                    hash: `${hash}-${slicedBlob.blob.size}`,
                    partNumber: slicedBlob.partNumber
                }));
    const $3a9c605917062ecc$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, (0, parcelRequire("RsgFX")).asyncMap)($3a9c605917062ecc$export$28a452a485721473(hasher), concurrency)(blobs$);
});
parcelRegister("RsgFX", function(module, exports) {
    $parcel$export(module.exports, "fetchBlob", ()=>$32ba0ece4537a1a3$export$14e9cfd4a872cc1e);
    $parcel$export(module.exports, "asyncMap", ()=>$32ba0ece4537a1a3$export$707ee4c4c95d39e3);
    var $kVLXA = parcelRequire("kVLXA");
    var $80gxR = parcelRequire("80gxR");
    async function $32ba0ece4537a1a3$export$14e9cfd4a872cc1e(file) {
        if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
        else return file;
    }
    const $32ba0ece4537a1a3$var$notify = (promise, observer, onReady)=>{
        const notifier = {
            notifyIfReady: ()=>false
        };
        promise.then((value)=>{
            notifier.notifyIfReady = ()=>{
                observer.next(value);
                observer.complete();
                return true;
            };
            onReady(notifier);
        }, (reason)=>{
            notifier.notifyIfReady = ()=>{
                observer.error(reason);
                return true;
            };
            onReady(notifier);
        });
        return notifier;
    };
    const $32ba0ece4537a1a3$var$mapper = (project)=>{
        const notifiers = new Array();
        const onReady = ()=>{
            const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
            if (notReadyIdx > 0) notifiers.splice(0, notReadyIdx);
        };
        return (value)=>new (0, $kVLXA.Observable)((sub)=>{
                notifiers.push($32ba0ece4537a1a3$var$notify(project(value), sub, onReady));
            });
    };
    const $32ba0ece4537a1a3$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $80gxR.mergeMap)($32ba0ece4537a1a3$var$mapper(project), concurrent);
});
parcelRegister("4Vmg1", function(module, exports) {
    $parcel$export(module.exports, "uploadinator", ()=>$a4f565ebdd47f0f4$export$94ce0f3fcf999415);
    var $RsgFX;
    const $a4f565ebdd47f0f4$export$94ce0f3fcf999415 = (blobs$, options)=>{
        const upload = (blob)=>{
            return options.uploader(blob).then(()=>blob);
        };
        return blobs$.pipe((0, (0, parcelRequire("RsgFX")).asyncMap)(upload, options.concurrency));
    };
});
parcelRegister("6SPPN", function(module, exports) {
    $parcel$export(module.exports, "processinator", ()=>$389997e3e47b2450$export$2f21790600302ed);
    var $9RLLl = parcelRequire("9RLLl");
    var $ib0Rz = parcelRequire("ib0Rz");
    const $389997e3e47b2450$export$2f21790600302ed = (blobs$, options)=>{
        const process = (blobs)=>{
            if (options.processor) return options.processor(blobs).then(()=>blobs);
            else return Promise.resolve(blobs);
        };
        return blobs$.pipe((0, $9RLLl.bufferCount)(options.batchSize)).pipe((0, $ib0Rz.concatMap)(process));
    };
});
parcelRegister("f6rzU", function(module, exports) {
    $parcel$export(module.exports, "createHasher", ()=>$8249c54a4574cd31$export$14b114effbc08b6b);
    parcelRequire("LmkUS");
    var $gPrGh = parcelRequire("gPrGh");
    let $8249c54a4574cd31$var$hasher = null;
    let $8249c54a4574cd31$var$sha256Hasher = null;
    const $8249c54a4574cd31$export$b7d263e6bc26b29a = ()=>$8249c54a4574cd31$var$hasher = null;
    const $8249c54a4574cd31$export$14b114effbc08b6b = async (algorithm)=>{
        const numWorkers = 3;
        if (algorithm === (0, $gPrGh.ChunkHashAlgorithm).Sha256) {
            if (!$8249c54a4574cd31$var$sha256Hasher) {
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("gT6vU"));
                $8249c54a4574cd31$var$sha256Hasher = new SimpleHasher();
            }
            return $8249c54a4574cd31$var$sha256Hasher;
        } else if (!$8249c54a4574cd31$var$hasher) try {
            const { WorkerHasher: WorkerHasher } = await (parcelRequire("0c3mv"));
            $8249c54a4574cd31$var$hasher = new WorkerHasher(numWorkers);
        } catch (error) {
            const { SimpleHasher: SimpleHasher } = await (parcelRequire("4yBex"));
            $8249c54a4574cd31$var$hasher = new SimpleHasher();
        }
        return $8249c54a4574cd31$var$hasher;
    };
});
parcelRegister("gT6vU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("istkm").then(()=>parcelRequire('kXp7T'));
});
parcelRegister("0c3mv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("l0S2x")
    ]).then(()=>parcelRequire('3Gx8H'));
});
parcelRegister("4yBex", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("iIdh2")
    ]).then(()=>parcelRequire('e4mxx'));
});
parcelRegister("20Dmg", function(module, exports) {
    $parcel$export(module.exports, "UploaderError", ()=>$5ee433d2b5ace7bb$export$515240c3f059c807);
    var $gFZHi;
    class $5ee433d2b5ace7bb$export$515240c3f059c807 extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, id, metadata){
            super(reason), this.reason = reason, this.id = id, this.metadata = metadata;
        }
        get attributes() {
            const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
            return {
                reason: reason,
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            };
        }
    }
    function $5ee433d2b5ace7bb$export$80ee180172bc336(err) {
        return err instanceof $5ee433d2b5ace7bb$export$515240c3f059c807;
    }
});
parcelRegister("empHz", function(module, exports) {
    $parcel$export(module.exports, "fileSizeError", ()=>$247cdc788c0fb235$export$b36239e4c33c2902);
    $parcel$export(module.exports, "calculateChunkSize", ()=>$247cdc788c0fb235$export$71f452e02035c1e2);
    var $749LC;
    var $7E56q;
    const $247cdc788c0fb235$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
    const $247cdc788c0fb235$export$71f452e02035c1e2 = (fileSize)=>{
        if (fileSize > (0, (0, parcelRequire("7E56q")).MAX_UPLOAD_FILE_SIZE)) throw new Error($247cdc788c0fb235$export$b36239e4c33c2902);
        if (fileSize <= 5 * (0, (0, parcelRequire("749LC")).DATA_UNIT).GB) return 5 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
        if (fileSize > 5 * (0, (0, parcelRequire("749LC")).DATA_UNIT).GB && fileSize <= 50 * (0, (0, parcelRequire("749LC")).DATA_UNIT).GB) return 50 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
        if (fileSize > 50 * (0, (0, parcelRequire("749LC")).DATA_UNIT).GB && fileSize <= 0.95 * (0, (0, parcelRequire("749LC")).DATA_UNIT).TB) return 100 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
        return 210 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
    };
});
parcelRegister("hkwMq", function(module, exports) {
    $parcel$export(module.exports, "getFileStreamsCache", ()=>$451397184147c26f$export$f2f061938c1e6810);
    class $451397184147c26f$export$4293896e79732236 {
        constructor(streams){
            this.streams = streams;
        }
        has(id) {
            return !!this.streams.find(id);
        }
        set(id, stream) {
            this.streams.set(id, stream);
        }
        get(id) {
            return this.streams.get(id);
        }
        getOrInsert(id, callback) {
            if (!this.has(id)) this.set(id, callback());
            return this.get(id);
        }
        removeAll() {
            this.streams.clear();
        }
        remove(id) {
            this.streams.delete(id);
        }
        get size() {
            return this.streams.size;
        }
    }
    let $451397184147c26f$var$streamCache;
    const $451397184147c26f$export$f2f061938c1e6810 = ()=>{
        if (!$451397184147c26f$var$streamCache) {
            const mediaState = (parcelRequire("6a8j4")).mediaState;
            $451397184147c26f$var$streamCache = new $451397184147c26f$export$4293896e79732236(mediaState.streams);
        }
        return $451397184147c26f$var$streamCache;
    };
});
parcelRegister("bfb59", function(module, exports) {
    $parcel$export(module.exports, "globalMediaEventEmitter", ()=>$22065e01bf236cb8$export$68d003d3105952ad);
    parcelRequire("LmkUS");
    var $6a8j4 = parcelRequire("6a8j4");
    const $22065e01bf236cb8$export$68d003d3105952ad = {
        on (event, listener) {
            if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.on(event, listener);
        },
        off (event, listener) {
            if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.off(event, listener);
        },
        emit (event, payload) {
            if ((0, $6a8j4.mediaState).eventEmitter) return (0, $6a8j4.mediaState).eventEmitter.emit(event, payload);
            return undefined;
        }
    };
});
parcelRegister("6CZ6k", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $4d35b0145f276bfe$require$Buffer = $5k7LC.Buffer;
    var $4d35b0145f276bfe$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    var $4d35b0145f276bfe$var$_byteToHex = [];
    for(var $4d35b0145f276bfe$var$i = 0; $4d35b0145f276bfe$var$i < 256; $4d35b0145f276bfe$var$i++)$4d35b0145f276bfe$var$_byteToHex[$4d35b0145f276bfe$var$i] = ($4d35b0145f276bfe$var$i + 0x100).toString(16).substr(1);
    function $4d35b0145f276bfe$var$unparse(buf, offset) {
        var i = offset || 0, bth = $4d35b0145f276bfe$var$_byteToHex;
        return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
    }
    module.exports = function(uuid, version) {
        var parsedUuid;
        if ($4d35b0145f276bfe$require$Buffer.isBuffer(uuid)) parsedUuid = $4d35b0145f276bfe$var$unparse(uuid);
        else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
        else return false;
        parsedUuid = parsedUuid.toLowerCase();
        if (!$4d35b0145f276bfe$var$pattern.test(parsedUuid)) return false;
        if (version === undefined) version = $4d35b0145f276bfe$var$extractVersion(parsedUuid);
        else if ($4d35b0145f276bfe$var$extractVersion(parsedUuid) !== version) return false;
        switch(version){
            case 1:
            case 2:
                return true;
            case 3:
            case 4:
            case 5:
                return [
                    '8',
                    '9',
                    'a',
                    'b'
                ].indexOf(parsedUuid.charAt(19)) !== -1;
            default:
                throw new Error('Invalid version provided.');
        }
    };
    var $4d35b0145f276bfe$var$extractVersion = module.exports.version = function(uuid) {
        return uuid.charAt(14) | 0;
    };
});
parcelRegister("7p3Ot", function(module, exports) {
    $parcel$export(module.exports, "createFileDataloader", ()=>$40dc831f91888cf8$export$ae188fee39529b82);
    var $hhZW9 = parcelRequire("hhZW9");
    var $27T0s;
    const $40dc831f91888cf8$export$b79d95ee17a87a = 100;
    const $40dc831f91888cf8$var$isBatchLoadingErrorResult = (result)=>{
        return result.error instanceof Error;
    };
    const $40dc831f91888cf8$var$isResponseFileItem = (fileItem)=>{
        return 'details' in fileItem;
    };
    const $40dc831f91888cf8$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
    const $40dc831f91888cf8$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
        const itemsByKey = fileItems.reduce((prev, fileItem)=>{
            const { id: id, collection: collection } = fileItem;
            const key = $40dc831f91888cf8$var$makeCacheKey(id, collection);
            if ($40dc831f91888cf8$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
            else if ($40dc831f91888cf8$var$isResponseFileItem(fileItem)) prev[key] = {
                ...fileItem.details,
                metadataTraceContext: fileItem.metadataTraceContext
            };
            else prev[key] = {
                id: id,
                collection: collection,
                type: 'not-found',
                metadataTraceContext: fileItem.metadataTraceContext
            };
            return prev;
        }, {});
        return dataloaderKeys.map((dataloaderKey)=>{
            const { id: id, collectionName: collectionName } = dataloaderKey;
            const key = $40dc831f91888cf8$var$makeCacheKey(id, collectionName);
            return itemsByKey[key] || {
                id: id,
                type: 'not-found'
            };
        });
    };
    function $40dc831f91888cf8$export$4a53beb129e8c49a(mediaStore) {
        return async (keys)=>{
            const nonCollectionName = '__media-single-file-collection__';
            const includeHashByCollection = keys.reduce((acc, key)=>{
                const collectionName = key.collectionName || nonCollectionName;
                if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
                return acc;
            }, {});
            const fileIdsByCollection = keys.reduce((acc, key)=>{
                const collectionName = key.collectionName || nonCollectionName;
                const fileIds = acc[collectionName] || [];
                if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
                acc[collectionName] = fileIds;
                return acc;
            }, {});
            const items = [];
            await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
                const metadataTraceContext = {
                    traceId: (0, (0, parcelRequire("27T0s")).getRandomHex)(8),
                    spanId: (0, (0, parcelRequire("27T0s")).getRandomHex)(8)
                };
                const fileIds = fileIdsByCollection[collectionNameKey];
                const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
                const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
                try {
                    const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                    const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                            ...item,
                            metadataTraceContext: metadataTraceContext
                        }));
                    items.push(...itemsWithMetadataTraceContext);
                    const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                    const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                    fileIdsNotFound.forEach((fileId)=>{
                        items.push({
                            id: fileId,
                            collection: collectionName,
                            type: 'not-found',
                            metadataTraceContext: metadataTraceContext
                        });
                    });
                } catch (error) {
                    fileIds.forEach((fileId)=>{
                        items.push({
                            id: fileId,
                            collection: collectionName,
                            error: error
                        });
                    });
                }
            }));
            return $40dc831f91888cf8$export$71cd2e8f8162d47b(keys, items);
        };
    }
    function $40dc831f91888cf8$export$ae188fee39529b82(mediaStore) {
        return new (0, ($parcel$interopDefault($hhZW9)))($40dc831f91888cf8$export$4a53beb129e8c49a(mediaStore), {
            maxBatchSize: $40dc831f91888cf8$export$b79d95ee17a87a
        });
    }
});
parcelRegister("hhZW9", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    "use strict";
    var $c964119340a5ebe3$var$DataLoader = function() {
        function DataLoader(batchLoadFn, options) {
            if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
            this._batchLoadFn = batchLoadFn;
            this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
            this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
            this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
            this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
            this._batch = null;
            this.name = $c964119340a5ebe3$var$getValidName(options);
        }
        var _proto = DataLoader.prototype;
        _proto.load = function load(key) {
            if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
            var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
            var cacheMap = this._cacheMap;
            var cacheKey = this._cacheKeyFn(key);
            if (cacheMap) {
                var cachedPromise = cacheMap.get(cacheKey);
                if (cachedPromise) {
                    var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                    return new Promise(function(resolve) {
                        cacheHits.push(function() {
                            resolve(cachedPromise);
                        });
                    });
                }
            }
            batch.keys.push(key);
            var promise = new Promise(function(resolve, reject) {
                batch.callbacks.push({
                    resolve: resolve,
                    reject: reject
                });
            });
            if (cacheMap) cacheMap.set(cacheKey, promise);
            return promise;
        };
        _proto.loadMany = function loadMany(keys) {
            if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
            var loadPromises = [];
            for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
                return error;
            }));
            return Promise.all(loadPromises);
        };
        _proto.clear = function clear(key) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                cacheMap["delete"](cacheKey);
            }
            return this;
        };
        _proto.clearAll = function clearAll() {
            var cacheMap = this._cacheMap;
            if (cacheMap) cacheMap.clear();
            return this;
        };
        _proto.prime = function prime(key, value) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                if (cacheMap.get(cacheKey) === undefined) {
                    var promise;
                    if (value instanceof Error) {
                        promise = Promise.reject(value);
                        promise["catch"](function() {});
                    } else promise = Promise.resolve(value);
                    cacheMap.set(cacheKey, promise);
                }
            }
            return this;
        };
        return DataLoader;
    }();
    var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
        if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
        $c964119340a5ebe3$var$resolvedPromise.then(function() {
            $6cAn5.nextTick(fn);
        });
    } : typeof setImmediate === 'function' ? function(fn) {
        setImmediate(fn);
    } : function(fn) {
        setTimeout(fn);
    };
    var $c964119340a5ebe3$var$resolvedPromise;
    function $c964119340a5ebe3$var$getCurrentBatch(loader) {
        var existingBatch = loader._batch;
        if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
        var newBatch = {
            hasDispatched: false,
            keys: [],
            callbacks: []
        };
        loader._batch = newBatch;
        loader._batchScheduleFn(function() {
            $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
        });
        return newBatch;
    }
    function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
        batch.hasDispatched = true;
        if (batch.keys.length === 0) {
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            return;
        }
        var batchPromise;
        try {
            batchPromise = loader._batchLoadFn(batch.keys);
        } catch (e) {
            return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
        }
        if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
        batchPromise.then(function(values) {
            if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
            if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            for(var i = 0; i < batch.callbacks.length; i++){
                var value = values[i];
                if (value instanceof Error) batch.callbacks[i].reject(value);
                else batch.callbacks[i].resolve(value);
            }
        })["catch"](function(error) {
            $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
        });
    }
    function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        for(var i = 0; i < batch.keys.length; i++){
            loader.clear(batch.keys[i]);
            batch.callbacks[i].reject(error);
        }
    }
    function $c964119340a5ebe3$var$resolveCacheHits(batch) {
        if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
    }
    function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
        var shouldBatch = !options || options.batch !== false;
        if (!shouldBatch) return 1;
        var maxBatchSize = options && options.maxBatchSize;
        if (maxBatchSize === undefined) return Infinity;
        if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
        return maxBatchSize;
    }
    function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
        var batchScheduleFn = options && options.batchScheduleFn;
        if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
        if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
        return batchScheduleFn;
    }
    function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
        var cacheKeyFn = options && options.cacheKeyFn;
        if (cacheKeyFn === undefined) return function(key) {
            return key;
        };
        if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
        return cacheKeyFn;
    }
    function $c964119340a5ebe3$var$getValidCacheMap(options) {
        var shouldCache = !options || options.cache !== false;
        if (!shouldCache) return null;
        var cacheMap = options && options.cacheMap;
        if (cacheMap === undefined) return new Map();
        if (cacheMap !== null) {
            var cacheFunctions = [
                'get',
                'set',
                'delete',
                'clear'
            ];
            var missingFunctions = cacheFunctions.filter(function(fnName) {
                return cacheMap && typeof cacheMap[fnName] !== 'function';
            });
            if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
        }
        return cacheMap;
    }
    function $c964119340a5ebe3$var$getValidName(options) {
        if (options && options.name) return options.name;
        return null;
    }
    function $c964119340a5ebe3$var$isArrayLike(x) {
        return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
    }
    module.exports = $c964119340a5ebe3$var$DataLoader;
});
parcelRegister("lVahM", function(module, exports) {
    $parcel$export(module.exports, "getMediaTypeFromUploadableFile", ()=>$748ba0ab0f854341$export$ac3214931ffd82af);
    var $jzW7G;
    const $748ba0ab0f854341$export$ac3214931ffd82af = (file)=>{
        if (file.content instanceof Blob) {
            const type = file.content.type;
            return (0, (0, parcelRequire("jzW7G")).getMediaTypeFromMimeType)(type);
        } else return 'unknown';
    };
});
parcelRegister("jzW7G", function(module, exports) {
    $parcel$export(module.exports, "getMediaTypeFromMimeType", ()=>$08d056d70136c4e2$export$79e1dc0d1801e8ef);
    $parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", ()=>(parcelRequire("8GKRF")).isImageMimeTypeSupportedByBrowser);
    $parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", ()=>(parcelRequire("8GKRF")).isVideoMimeTypeSupportedByBrowser);
    var $92ewp;
    var $8GKRF;
    var $lF4MN;
    const $08d056d70136c4e2$export$79e1dc0d1801e8ef = (mimeType)=>{
        if ((0, (0, parcelRequire("92ewp")).isArchive)(mimeType)) return 'archive';
        if ((0, (0, parcelRequire("8GKRF")).isImageMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("lF4MN")).isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
        if ((0, (0, parcelRequire("8GKRF")).isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("lF4MN")).isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
        if ((0, (0, parcelRequire("8GKRF")).isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("lF4MN")).isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
        if ((0, (0, parcelRequire("8GKRF")).isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("lF4MN")).isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
        return 'unknown';
    };
});
parcelRegister("92ewp", function(module, exports) {
    $parcel$export(module.exports, "isArchive", ()=>$addf45fda6198a62$export$f47f3fe506e20fe6);
    const $addf45fda6198a62$export$f47f3fe506e20fe6 = (mimeType)=>[
            'application/x-archive',
            'application/x-cpio',
            'application/x-shar',
            'application/x-iso9660-image',
            'application/x-sbx',
            'application/x-tar',
            'application/x-bzip2',
            'application/gzip',
            'application/x-gzip',
            'application/x-lzip',
            'application/x-lzma',
            'application/x-lzop',
            'application/x-snappy-framed',
            'application/x-xz',
            'application/x-compress',
            'application/zstd',
            'application/x-7z-compressed',
            'application/x-ace-compressed',
            'application/x-astrotite-afa',
            'application/x-alz-compressed',
            'application/vnd.android.package-archive',
            'application/x-freearc',
            'application/x-arj',
            'application/x-b1',
            'application/vnd.ms-cab-compressed',
            'application/x-cfs-compressed',
            'application/x-dar',
            'application/x-dgc-compressed',
            'application/x-apple-diskimage',
            'application/x-gca-compressed',
            'application/java-archive',
            'application/x-lzh',
            'application/x-lzx',
            'application/x-rar-compressed',
            'application/x-stuffit',
            'application/x-stuffitx',
            'application/x-gtar',
            'application/x-ms-wim',
            'application/x-xar',
            'application/zip',
            'application/x-zoo',
            'application/x-par2'
        ].indexOf(mimeType.toLowerCase()) > -1;
});
parcelRegister("8GKRF", function(module, exports) {
    $parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$c021f2623a75015f);
    $parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$74325e3c843a9555);
    $parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$ff36075ea755a717);
    $parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$87bf945cf31ec2d9);
    $parcel$export(module.exports, "isMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$55ca6cdaf6093034);
    const $3af4ecf7d6cb882c$export$c021f2623a75015f = (mimeType)=>[
            'image/apng',
            'image/bmp',
            'image/gif',
            'image/x-icon',
            'image/jpeg',
            'image/png',
            'image/webp'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $3af4ecf7d6cb882c$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
    const $3af4ecf7d6cb882c$export$ff36075ea755a717 = (mimeType)=>[
            'audio/aac',
            'audio/flac',
            'audio/mp4',
            'audio/mpeg',
            'audio/ogg',
            'audio/x-ogg',
            'audio/wav',
            'audio/x-wav'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $3af4ecf7d6cb882c$export$87bf945cf31ec2d9 = (mimeType)=>[
            'video/mp4',
            'video/quicktime'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $3af4ecf7d6cb882c$export$55ca6cdaf6093034 = (mimeType)=>$3af4ecf7d6cb882c$export$74325e3c843a9555(mimeType) || $3af4ecf7d6cb882c$export$c021f2623a75015f(mimeType) || $3af4ecf7d6cb882c$export$ff36075ea755a717(mimeType) || $3af4ecf7d6cb882c$export$87bf945cf31ec2d9(mimeType);
});
parcelRegister("lF4MN", function(module, exports) {
    $parcel$export(module.exports, "isImageMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$e9a065a80f76311e);
    $parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$86baad7a89d908e9);
    $parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$8cba23825d020bbb);
    $parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$9c2b4de5fdca2ce3);
    $parcel$export(module.exports, "isMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$548d9148a80556a3);
    const $8b8147e427110cee$export$e9a065a80f76311e = (mimeType)=>[
            'image/bmp',
            'image/x-windows-bmp',
            'application/dicom',
            'image/gif',
            'image/jpeg',
            'image/jpg',
            'image/jp_',
            'application/jpg',
            'application/x-jpg',
            'image/png',
            'application/png',
            'application/x-png',
            'application/vnd.adobe.photoshop',
            'image/vnd.adobe.photoshop',
            'image/photoshop',
            'image/x-photoshop',
            'image/psd',
            'application/photoshop',
            'application/psd',
            'zz-application/zz-winassoc-psd',
            'image/tiff',
            'image/x-tif',
            'image/x-tiff',
            'application/tif',
            'application/x-tif',
            'application/tiff',
            'application/x-tiff',
            'image/svg+xml',
            'image/heif',
            'image/heif-sequence',
            'image/heic',
            'image/heic-sequence'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$86baad7a89d908e9 = (mimeType)=>[
            'application/pdf',
            'application/x-pdf',
            'application/acrobat',
            'applications/vnd.pdf',
            'text/pdf',
            'text/x-pdf',
            'application/vnd.adobe.illustrator',
            'application/vnd.ms-office',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
            'application/vnd.ms-word.document.macroenabled.12',
            'application/vnd.ms-word.template.macroenabled.12',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
            'application/vnd.ms-excel.sheet.macroenabled.12',
            'application/vnd.ms-excel.template.macroenabled.12',
            'application/vnd.ms-excel.addin.macroenabled.12',
            'application/vnd.ms-excel.sheet.macroenabled',
            'application/vnd.ms-excel.template.macroenabled',
            'application/vnd.ms-excel.addin.macroenabled',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.openxmlformats-officedocument.presentationml.template',
            'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
            'application/vnd.ms-powerpoint.presentation.macroenabled.12',
            'application/vnd.ms-powerpoint.template.macroenabled.12',
            'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
            'application/vnd.sun.xml.writer',
            'application/vnd.sun.xml.writer.template',
            'application/vnd.sun.xml.draw',
            'application/vnd.sun.xml.draw.template',
            'application/vnd.oasis.opendocument.graphics',
            'application/vnd.oasis.opendocument.presentation',
            'application/x-vnd.oasis.opendocument.presentation',
            'application/vnd.sun.xml.calc',
            'application/vnd.sun.xml.calc.template',
            'application/vnd.oasis.opendocument.spreadsheet',
            'application/x-vnd.oasis.opendocument.spreadsheet',
            'application/vnd.oasis.opendocument.spreadsheet-template',
            'application/vnd.oasis.opendocument.text',
            'application/vnd.oasis.opendocument.text-template',
            'application/vnd.oasis.opendocument.text-master',
            'application/x-vnd.oasis.opendocument.text',
            'application/x-vnd.oasis.opendocument.text-template',
            'application/x-vnd.oasis.opendocument.text-master',
            'application/vnd.wordperfect',
            'text/csv',
            'text/x-diff',
            'text/x-perl',
            'text/x-python',
            'text/x-ruby',
            'text/rtf',
            'text/richtext',
            'text/plain',
            'application/txt',
            'application/rtf',
            'application/x-rtf',
            'application/postscript'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$8cba23825d020bbb = (mimeType)=>[
            'audio/aac',
            'audio/x-hx-aac-adts',
            'audio/vnd.dolby.dd-raw',
            'audio/aiff',
            'audio/x-aiff',
            'audio/x-monkeys-audio',
            'audio/x-ape',
            'audio/basic',
            'audio/flac',
            'audio/mp4',
            'audio/midi',
            'audio/x-matroska',
            'audio/x-mod',
            'audio/mpeg',
            'audio/ogg',
            'audio/x-ogg',
            'audio/x-pn-realaudio',
            'audio/wav',
            'audio/x-wav',
            'audio/x-ms-wma'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$9c2b4de5fdca2ce3 = (mimeType)=>[
            'video/3gpp',
            'video/3gpp2',
            'video/x-ms-asf',
            'video/avi',
            'video/msvideo',
            'video/x-msvideo',
            'video/x-dv',
            'video/x-flv',
            'video/m2ts',
            'video/x-m4v',
            'video/x-matroska',
            'video/quicktime',
            'video/mp4',
            'video/mpeg',
            'video/ogg',
            'video/x-ogg',
            'video/webm',
            'video/x-ms-wmv'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$94e1479e01d2af53 = (mimeType)=>[
            'binary/octet-stream'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$548d9148a80556a3 = (mimeType)=>$8b8147e427110cee$export$e9a065a80f76311e(mimeType) || $8b8147e427110cee$export$86baad7a89d908e9(mimeType) || $8b8147e427110cee$export$8cba23825d020bbb(mimeType) || $8b8147e427110cee$export$9c2b4de5fdca2ce3(mimeType) || $8b8147e427110cee$export$94e1479e01d2af53(mimeType);
});
parcelRegister("dhdZw", function(module, exports) {
    $parcel$export(module.exports, "overrideMediaTypeIfUnknown", ()=>$c0fce003746ff4f7$export$89097c0ec1e0dee1);
    var $1Pp1U;
    const $c0fce003746ff4f7$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
        if (!(0, (0, parcelRequire("1Pp1U")).isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
            mediaType: mediaType
        };
        return {};
    };
});
parcelRegister("gayAy", function(module, exports) {
    $parcel$export(module.exports, "convertBase64ToBlob", ()=>$0fff1104576a2bb3$export$ed17558b11b88056);
    const $0fff1104576a2bb3$export$ed17558b11b88056 = (base64)=>{
        const sliceSize = 512;
        const base64Data = base64.split(',')[1];
        const byteCharacters = atob(base64Data);
        const byteArrays = [];
        for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, {
            type: 'image/jpeg'
        });
    };
});
parcelRegister("j1BIJ", function(module, exports) {
    $parcel$export(module.exports, "fromObservable", ()=>$6582fd60bc4bbd36$export$4b2432e2d8723823);
    var $2Mh8o;
    function $6582fd60bc4bbd36$export$4b2432e2d8723823(observable) {
        return {
            subscribe: (observer)=>{
                const subscription = observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
                return {
                    unsubscribe: ()=>{
                        subscription.unsubscribe();
                    }
                };
            }
        };
    }
    function $6582fd60bc4bbd36$export$8659d1f07d151381(item) {
        return $6582fd60bc4bbd36$export$4b2432e2d8723823((0, (0, parcelRequire("2Mh8o")).createMediaSubject)(item));
    }
});
parcelRegister("2Mh8o", function(module, exports) {
    $parcel$export(module.exports, "createMediaSubject", ()=>$c9b8fad0d34272f1$export$bc76d51553fa5e35);
    var $dZ0DN = parcelRequire("dZ0DN");
    function $c9b8fad0d34272f1$export$bc76d51553fa5e35(initialState) {
        const subject = new (0, $dZ0DN.ReplaySubject)(1);
        if (initialState instanceof Error) subject.error(initialState);
        else if (initialState) subject.next(initialState);
        return subject;
    }
});
parcelRegister("lYDAe", function(module, exports) {
    $parcel$export(module.exports, "toPromise", ()=>$44429e0ad2a9ded6$export$4dbaaf6c79705e6c);
    var $aZdZn = parcelRequire("aZdZn");
    const $44429e0ad2a9ded6$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $aZdZn.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
                next: (state)=>{
                    resolve(state);
                    subscription.unsubscribe();
                },
                error: (error)=>{
                    reject(error);
                    subscription.unsubscribe();
                }
            })));
});
parcelRegister("29M1K", function(module, exports) {
    $parcel$export(module.exports, "getDimensionsFromBlob", ()=>$c92d9e8096a99b5b$export$71797c284d89a3e1);
    var $8IWWt;
    var $5CbXO;
    const $c92d9e8096a99b5b$export$71797c284d89a3e1 = async (mediaType, blob)=>{
        switch(mediaType){
            case 'image':
                {
                    const url = URL.createObjectURL(blob);
                    try {
                        return await (0, (0, parcelRequire("8IWWt")).getImageDimensionsFromBlob)(url);
                    } finally{
                        URL.revokeObjectURL(url);
                    }
                }
            case 'video':
                return (0, (0, parcelRequire("5CbXO")).getVideoDimensionsFromBlob)(blob);
            default:
                throw new Error(`Can't extract dimensions from ${mediaType}`);
        }
    };
});
parcelRegister("8IWWt", function(module, exports) {
    $parcel$export(module.exports, "getImageDimensionsFromBlob", ()=>$094f7e5912c5e863$export$a1c3205f28a20414);
    const $094f7e5912c5e863$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
            const img = new Image();
            img.src = url;
            img.onload = ()=>resolve({
                    width: img.width,
                    height: img.height
                });
            img.onerror = reject;
        });
});
parcelRegister("5CbXO", function(module, exports) {
    $parcel$export(module.exports, "getVideoDimensionsFromBlob", ()=>$3629651e482443d2$export$62aabd5ff85d0451);
    const $3629651e482443d2$export$62aabd5ff85d0451 = async (blob)=>{
        return new Promise((resolve, reject)=>{
            const url = URL.createObjectURL(blob);
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.src = url;
            video.muted = true;
            video.addEventListener('loadedmetadata', function timeupdateHandler() {
                video.removeEventListener('loadedmetadata', timeupdateHandler);
                resolve({
                    width: video.videoWidth,
                    height: video.videoHeight
                });
                URL.revokeObjectURL(url);
            });
            video.addEventListener('error', ()=>{
                reject(new Error('failed to load video'));
                URL.revokeObjectURL(url);
            });
        });
    };
});
parcelRegister("gR4o6", function(module, exports) {
    $parcel$export(module.exports, "shouldFetchRemoteFileStates", ()=>$81fca2ad541e7785$export$2ccdd6f9a9eba6a);
    var $8GKRF;
    var $lF4MN;
    var $5CbXO;
    async function $81fca2ad541e7785$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
        if ((mediaType === 'doc' || !(0, (0, parcelRequire("8GKRF")).isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, (0, parcelRequire("lF4MN")).isMimeTypeSupportedByServer)(mimeType)) return true;
        if (mediaType === 'video' && !!preview) {
            const content = (await preview).value;
            if (!(content instanceof Blob)) return false;
            try {
                const { width: width, height: height } = await (0, (0, parcelRequire("5CbXO")).getVideoDimensionsFromBlob)(content);
                return !width && !height;
            } catch (e) {
                return true;
            }
        }
        return false;
    }
});
parcelRegister("dJ905", function(module, exports) {
    $parcel$export(module.exports, "PollingFunction", ()=>$a9b60fcbc1595cd8$export$4c54d536f8e37dc2);
    var $j8kdR;
    const $a9b60fcbc1595cd8$export$9f15a162d6785fc9 = {
        poll_intervalMs: 3000,
        poll_maxAttempts: 30,
        poll_backoffFactor: 1.25,
        poll_maxIntervalMs: 200000
    };
    class $a9b60fcbc1595cd8$export$4c54d536f8e37dc2 {
        constructor(options){
            this.poll_intervalMs = 0;
            this.attempt = 1;
            this.shouldIterate = true;
            this.timeoutId = 0;
            this.options = {
                ...$a9b60fcbc1595cd8$export$9f15a162d6785fc9,
                ...options
            };
            this.poll_intervalMs = this.options.poll_intervalMs;
        }
        async execute(executor) {
            const { poll_maxAttempts: poll_maxAttempts } = this.options;
            if (poll_maxAttempts === 0) return this.fail(new (0, (0, parcelRequire("j8kdR")).PollingError)('pollingMaxAttemptsExceeded', this.attempt));
            try {
                this.shouldIterate = false;
                await executor();
                if (!this.shouldIterate) return;
                if (this.attempt >= poll_maxAttempts) return this.fail(new (0, (0, parcelRequire("j8kdR")).PollingError)('pollingMaxAttemptsExceeded', this.attempt));
                this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
                this.attempt++;
                this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
            } catch (error) {
                this.fail(error);
            }
        }
        fail(error) {
            const { onError: onError } = this;
            this.cancel();
            onError && onError(error);
        }
        getIntervalMsForIteration(iteration) {
            let poll_intervalMs = this.options.poll_intervalMs;
            if (iteration === 1) return poll_intervalMs;
            for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
            return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
        }
        next() {
            this.shouldIterate = true;
        }
        cancel() {
            window.clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    }
});
parcelRegister("j8kdR", function(module, exports) {
    $parcel$export(module.exports, "PollingError", ()=>$ba72cde1b79a6066$export$c3748c310e92340a);
    $parcel$export(module.exports, "isPollingError", ()=>$ba72cde1b79a6066$export$541e3e52eea6fece);
    var $gFZHi;
    class $ba72cde1b79a6066$export$c3748c310e92340a extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, attempts){
            super(reason), this.reason = reason, this.attempts = attempts;
        }
        get attributes() {
            const { reason: reason, attempts: attempts } = this;
            return {
                reason: reason,
                attempts: attempts
            };
        }
    }
    function $ba72cde1b79a6066$export$541e3e52eea6fece(err) {
        return err instanceof $ba72cde1b79a6066$export$c3748c310e92340a;
    }
});
parcelRegister("9KWg9", function(module, exports) {
    $parcel$export(module.exports, "isEmptyFile", ()=>$6625df65da5f0486$export$728192ce8dd94659);
    const $6625df65da5f0486$export$d32fc52697b2ec92 = 43200000;
    function $6625df65da5f0486$export$728192ce8dd94659(fileDetails, now = Date.now()) {
        const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
        if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
            const msSinceFileCreation = now - createdAt;
            if (msSinceFileCreation > $6625df65da5f0486$export$d32fc52697b2ec92) return true;
        }
        return false;
    }
});
parcelRegister("8HaZs", function(module, exports) {
    $parcel$export(module.exports, "mediaStore", ()=>(parcelRequire("fN64m")).mediaStore);
    var $fN64m = parcelRequire("fN64m");
});
parcelRegister("fN64m", function(module, exports) {
    $parcel$export(module.exports, "mediaStore", ()=>$df71566ec1e8fa2a$export$5785580dea19518d);
    var $bIv98;
    var $70n8Q;
    var $ee7sp;
    const $df71566ec1e8fa2a$var$mediaStoreWithoutDevtools = (0, (0, parcelRequire("ee7sp")).createStore)()((0, (0, parcelRequire("bIv98")).subscribeWithSelector)((0, (0, parcelRequire("70n8Q")).immer)(()=>({
            files: {}
        }))));
    const $df71566ec1e8fa2a$var$mediaStoreWithDevtools = (0, (0, parcelRequire("ee7sp")).createStore)()((0, (0, parcelRequire("bIv98")).devtools)((0, (0, parcelRequire("bIv98")).subscribeWithSelector)((0, (0, parcelRequire("70n8Q")).immer)(()=>({
            files: {}
        })))));
    const $df71566ec1e8fa2a$export$5785580dea19518d = $df71566ec1e8fa2a$var$mediaStoreWithoutDevtools;
    const $df71566ec1e8fa2a$export$503459913a0dc356 = (initialStore)=>{
        return (0, (0, parcelRequire("ee7sp")).createStore)()((0, (0, parcelRequire("bIv98")).subscribeWithSelector)((0, (0, parcelRequire("70n8Q")).immer)(()=>({
                files: {},
                ...initialStore
            }))));
    };
});
parcelRegister("bIv98", function(module, exports) {
    $parcel$export(module.exports, "devtools", ()=>$887bf6c78f4461c3$export$6922d3b3a607469e);
    $parcel$export(module.exports, "subscribeWithSelector", ()=>$887bf6c78f4461c3$export$5c593627aef9f076);
    var $887bf6c78f4461c3$import_meta = Object.assign(Object.create(null), {
        url: "file:///node_modules/zustand/esm/middleware.mjs"
    });
    const $887bf6c78f4461c3$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
            api.dispatch = (action)=>{
                set((state)=>reducer(state, action), false, action);
                return action;
            };
            api.dispatchFromDevtools = true;
            return {
                dispatch: (...a)=>api.dispatch(...a),
                ...initial
            };
        };
    const $887bf6c78f4461c3$export$4feba8a1bc8e9afd = $887bf6c78f4461c3$var$reduxImpl;
    const $887bf6c78f4461c3$var$trackedConnections = new Map();
    const $887bf6c78f4461c3$var$getTrackedConnectionState = (name)=>{
        const api = $887bf6c78f4461c3$var$trackedConnections.get(name);
        if (!api) return {};
        return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
                key,
                api2.getState()
            ]));
    };
    const $887bf6c78f4461c3$var$extractConnectionInformation = (store, extensionConnector, options)=>{
        if (store === void 0) return {
            type: "untracked",
            connection: extensionConnector.connect(options)
        };
        const existingConnection = $887bf6c78f4461c3$var$trackedConnections.get(options.name);
        if (existingConnection) return {
            type: "tracked",
            store: store,
            ...existingConnection
        };
        const newConnection = {
            connection: extensionConnector.connect(options),
            stores: {}
        };
        $887bf6c78f4461c3$var$trackedConnections.set(options.name, newConnection);
        return {
            type: "tracked",
            store: store,
            ...newConnection
        };
    };
    const $887bf6c78f4461c3$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
            const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
            let extensionConnector;
            try {
                extensionConnector = (enabled != null ? enabled : ($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
            } catch (e) {}
            if (!extensionConnector) {
                if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
                return fn(set, get, api);
            }
            const { connection: connection, ...connectionInformation } = $887bf6c78f4461c3$var$extractConnectionInformation(store, extensionConnector, options);
            let isRecording = true;
            api.setState = (state, replace, nameOrAction)=>{
                const r = set(state, replace);
                if (!isRecording) return r;
                const action = nameOrAction === void 0 ? {
                    type: anonymousActionType || "anonymous"
                } : typeof nameOrAction === "string" ? {
                    type: nameOrAction
                } : nameOrAction;
                if (store === void 0) {
                    connection == null || connection.send(action, get());
                    return r;
                }
                connection == null || connection.send({
                    ...action,
                    type: `${store}/${action.type}`
                }, {
                    ...$887bf6c78f4461c3$var$getTrackedConnectionState(options.name),
                    [store]: api.getState()
                });
                return r;
            };
            const setStateFromDevtools = (...a)=>{
                const originalIsRecording = isRecording;
                isRecording = false;
                set(...a);
                isRecording = originalIsRecording;
            };
            const initialState = fn(api.setState, get, api);
            if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
            else {
                connectionInformation.stores[connectionInformation.store] = api;
                connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                        key,
                        key === connectionInformation.store ? initialState : store2.getState()
                    ])));
            }
            if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
                let didWarnAboutReservedActionType = false;
                const originalDispatch = api.dispatch;
                api.dispatch = (...a)=>{
                    if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                        console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                        didWarnAboutReservedActionType = true;
                    }
                    originalDispatch(...a);
                };
            }
            connection.subscribe((message)=>{
                var _a;
                switch(message.type){
                    case "ACTION":
                        if (typeof message.payload !== "string") {
                            console.error("[zustand devtools middleware] Unsupported action format");
                            return;
                        }
                        return $887bf6c78f4461c3$var$parseJsonThen(message.payload, (action)=>{
                            if (action.type === "__setState") {
                                if (store === void 0) {
                                    setStateFromDevtools(action.state);
                                    return;
                                }
                                if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                                const stateFromDevtools = action.state[store];
                                if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                                if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                                return;
                            }
                            if (!api.dispatchFromDevtools) return;
                            if (typeof api.dispatch !== "function") return;
                            api.dispatch(action);
                        });
                    case "DISPATCH":
                        switch(message.payload.type){
                            case "RESET":
                                setStateFromDevtools(initialState);
                                if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                                return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                            case "COMMIT":
                                if (store === void 0) {
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                            case "ROLLBACK":
                                return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                    if (store === void 0) {
                                        setStateFromDevtools(state);
                                        connection == null || connection.init(api.getState());
                                        return;
                                    }
                                    setStateFromDevtools(state[store]);
                                    connection == null || connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                                });
                            case "JUMP_TO_STATE":
                            case "JUMP_TO_ACTION":
                                return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                    if (store === void 0) {
                                        setStateFromDevtools(state);
                                        return;
                                    }
                                    if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                                });
                            case "IMPORT_STATE":
                                {
                                    const { nextLiftedState: nextLiftedState } = message.payload;
                                    const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                    if (!lastComputedState) return;
                                    if (store === void 0) setStateFromDevtools(lastComputedState);
                                    else setStateFromDevtools(lastComputedState[store]);
                                    connection == null || connection.send(null, nextLiftedState);
                                    return;
                                }
                            case "PAUSE_RECORDING":
                                return isRecording = !isRecording;
                        }
                        return;
                }
            });
            return initialState;
        };
    const $887bf6c78f4461c3$export$6922d3b3a607469e = $887bf6c78f4461c3$var$devtoolsImpl;
    const $887bf6c78f4461c3$var$parseJsonThen = (stringified, f)=>{
        let parsed;
        try {
            parsed = JSON.parse(stringified);
        } catch (e) {
            console.error("[zustand devtools middleware] Could not parse the received json", e);
        }
        if (parsed !== void 0) f(parsed);
    };
    const $887bf6c78f4461c3$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
            const origSubscribe = api.subscribe;
            api.subscribe = (selector, optListener, options)=>{
                let listener = selector;
                if (optListener) {
                    const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                    let currentSlice = selector(api.getState());
                    listener = (state)=>{
                        const nextSlice = selector(state);
                        if (!equalityFn(currentSlice, nextSlice)) {
                            const previousSlice = currentSlice;
                            optListener(currentSlice = nextSlice, previousSlice);
                        }
                    };
                    if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
                }
                return origSubscribe(listener);
            };
            const initialState = fn(set, get, api);
            return initialState;
        };
    const $887bf6c78f4461c3$export$5c593627aef9f076 = $887bf6c78f4461c3$var$subscribeWithSelectorImpl;
    const $887bf6c78f4461c3$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
    function $887bf6c78f4461c3$export$95a3b7b12ab518f9(getStorage, options) {
        let storage;
        try {
            storage = getStorage();
        } catch (e) {
            return;
        }
        const persistStorage = {
            getItem: (name)=>{
                var _a;
                const parse = (str2)=>{
                    if (str2 === null) return null;
                    return JSON.parse(str2, options == null ? void 0 : options.reviver);
                };
                const str = (_a = storage.getItem(name)) != null ? _a : null;
                if (str instanceof Promise) return str.then(parse);
                return parse(str);
            },
            setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
            removeItem: (name)=>storage.removeItem(name)
        };
        return persistStorage;
    }
    const $887bf6c78f4461c3$var$toThenable = (fn)=>(input)=>{
            try {
                const result = fn(input);
                if (result instanceof Promise) return result;
                return {
                    then (onFulfilled) {
                        return $887bf6c78f4461c3$var$toThenable(onFulfilled)(result);
                    },
                    catch (_onRejected) {
                        return this;
                    }
                };
            } catch (e) {
                return {
                    then (_onFulfilled) {
                        return this;
                    },
                    catch (onRejected) {
                        return $887bf6c78f4461c3$var$toThenable(onRejected)(e);
                    }
                };
            }
        };
    const $887bf6c78f4461c3$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
            let options = {
                getStorage: ()=>localStorage,
                serialize: JSON.stringify,
                deserialize: JSON.parse,
                partialize: (state)=>state,
                version: 0,
                merge: (persistedState, currentState)=>({
                        ...currentState,
                        ...persistedState
                    }),
                ...baseOptions
            };
            let hasHydrated = false;
            const hydrationListeners = new Set();
            const finishHydrationListeners = new Set();
            let storage;
            try {
                storage = options.getStorage();
            } catch (e) {}
            if (!storage) return config((...args)=>{
                console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
                set(...args);
            }, get, api);
            const thenableSerialize = $887bf6c78f4461c3$var$toThenable(options.serialize);
            const setItem = ()=>{
                const state = options.partialize({
                    ...get()
                });
                let errorInSync;
                const thenable = thenableSerialize({
                    state: state,
                    version: options.version
                }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                    errorInSync = e;
                });
                if (errorInSync) throw errorInSync;
                return thenable;
            };
            const savedSetState = api.setState;
            api.setState = (state, replace)=>{
                savedSetState(state, replace);
                setItem();
            };
            const configResult = config((...args)=>{
                set(...args);
                setItem();
            }, get, api);
            let stateFromStorage;
            const hydrate = ()=>{
                var _a;
                if (!storage) return;
                hasHydrated = false;
                hydrationListeners.forEach((cb)=>cb(get()));
                const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
                return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                    if (storageValue) return options.deserialize(storageValue);
                }).then((deserializedStorageValue)=>{
                    if (deserializedStorageValue) {
                        if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                            if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                        } else return deserializedStorageValue.state;
                    }
                }).then((migratedState)=>{
                    var _a2;
                    stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                    set(stateFromStorage, true);
                    return setItem();
                }).then(()=>{
                    postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                    hasHydrated = true;
                    finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
                }).catch((e)=>{
                    postRehydrationCallback == null || postRehydrationCallback(void 0, e);
                });
            };
            api.persist = {
                setOptions: (newOptions)=>{
                    options = {
                        ...options,
                        ...newOptions
                    };
                    if (newOptions.getStorage) storage = newOptions.getStorage();
                },
                clearStorage: ()=>{
                    storage == null || storage.removeItem(options.name);
                },
                getOptions: ()=>options,
                rehydrate: ()=>hydrate(),
                hasHydrated: ()=>hasHydrated,
                onHydrate: (cb)=>{
                    hydrationListeners.add(cb);
                    return ()=>{
                        hydrationListeners.delete(cb);
                    };
                },
                onFinishHydration: (cb)=>{
                    finishHydrationListeners.add(cb);
                    return ()=>{
                        finishHydrationListeners.delete(cb);
                    };
                }
            };
            hydrate();
            return stateFromStorage || configResult;
        };
    const $887bf6c78f4461c3$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
            let options = {
                storage: $887bf6c78f4461c3$export$95a3b7b12ab518f9(()=>localStorage),
                partialize: (state)=>state,
                version: 0,
                merge: (persistedState, currentState)=>({
                        ...currentState,
                        ...persistedState
                    }),
                ...baseOptions
            };
            let hasHydrated = false;
            const hydrationListeners = new Set();
            const finishHydrationListeners = new Set();
            let storage = options.storage;
            if (!storage) return config((...args)=>{
                console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
                set(...args);
            }, get, api);
            const setItem = ()=>{
                const state = options.partialize({
                    ...get()
                });
                return storage.setItem(options.name, {
                    state: state,
                    version: options.version
                });
            };
            const savedSetState = api.setState;
            api.setState = (state, replace)=>{
                savedSetState(state, replace);
                setItem();
            };
            const configResult = config((...args)=>{
                set(...args);
                setItem();
            }, get, api);
            api.getInitialState = ()=>configResult;
            let stateFromStorage;
            const hydrate = ()=>{
                var _a, _b;
                if (!storage) return;
                hasHydrated = false;
                hydrationListeners.forEach((cb)=>{
                    var _a2;
                    return cb((_a2 = get()) != null ? _a2 : configResult);
                });
                const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
                return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                    if (deserializedStorageValue) {
                        if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                            if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                        } else return deserializedStorageValue.state;
                    }
                }).then((migratedState)=>{
                    var _a2;
                    stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                    set(stateFromStorage, true);
                    return setItem();
                }).then(()=>{
                    postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                    stateFromStorage = get();
                    hasHydrated = true;
                    finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
                }).catch((e)=>{
                    postRehydrationCallback == null || postRehydrationCallback(void 0, e);
                });
            };
            api.persist = {
                setOptions: (newOptions)=>{
                    options = {
                        ...options,
                        ...newOptions
                    };
                    if (newOptions.storage) storage = newOptions.storage;
                },
                clearStorage: ()=>{
                    storage == null || storage.removeItem(options.name);
                },
                getOptions: ()=>options,
                rehydrate: ()=>hydrate(),
                hasHydrated: ()=>hasHydrated,
                onHydrate: (cb)=>{
                    hydrationListeners.add(cb);
                    return ()=>{
                        hydrationListeners.delete(cb);
                    };
                },
                onFinishHydration: (cb)=>{
                    finishHydrationListeners.add(cb);
                    return ()=>{
                        finishHydrationListeners.delete(cb);
                    };
                }
            };
            if (!options.skipHydration) hydrate();
            return stateFromStorage || configResult;
        };
    const $887bf6c78f4461c3$var$persistImpl = (config, baseOptions)=>{
        if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
            if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
            return $887bf6c78f4461c3$var$oldImpl(config, baseOptions);
        }
        return $887bf6c78f4461c3$var$newImpl(config, baseOptions);
    };
    const $887bf6c78f4461c3$export$9a6132153fba2e0 = $887bf6c78f4461c3$var$persistImpl;
});
parcelRegister("70n8Q", function(module, exports) {
    $parcel$export(module.exports, "immer", ()=>$519a7bf2c276fd5a$export$428de7ec69ac95c);
    var $86xFr;
    const $519a7bf2c276fd5a$var$immerImpl = (initializer)=>(set, get, store)=>{
            store.setState = (updater, replace, ...a)=>{
                const nextState = typeof updater === "function" ? (0, (0, parcelRequire("86xFr")).produce)(updater) : updater;
                return set(nextState, replace, ...a);
            };
            return initializer(store.setState, get, store);
        };
    const $519a7bf2c276fd5a$export$428de7ec69ac95c = $519a7bf2c276fd5a$var$immerImpl;
});
parcelRegister("86xFr", function(module, exports) {
    $parcel$export(module.exports, "produce", ()=>fn);
    function n(n) {
        for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
        var i, o;
        throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
            return "'" + n + "'";
        }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
    }
    function r(n) {
        return !!n && !!n[Q];
    }
    function t(n) {
        var r;
        return !!n && (function(n) {
            if (!n || "object" != typeof n) return !1;
            var r = Object.getPrototypeOf(n);
            if (null === r) return !0;
            var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
            return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
        }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
    }
    function e(t) {
        return r(t) || n(23, t), t[Q].t;
    }
    function i(n, r, t) {
        void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
            t && "symbol" == typeof e || r(e, n[e], n);
        }) : n.forEach(function(t, e) {
            return r(e, t, n);
        });
    }
    function o(n) {
        var r = n[Q];
        return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
    }
    function u(n, r) {
        return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
    }
    function a(n, r) {
        return 2 === o(n) ? n.get(r) : n[r];
    }
    function f(n, r, t) {
        var e = o(n);
        2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
    }
    function c(n, r) {
        return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
    }
    function s(n) {
        return X && n instanceof Map;
    }
    function v(n) {
        return q && n instanceof Set;
    }
    function p(n) {
        return n.o || n.t;
    }
    function l(n) {
        if (Array.isArray(n)) return Array.prototype.slice.call(n);
        var r = rn(n);
        delete r[Q];
        for(var t = nn(r), e = 0; e < t.length; e++){
            var i = t[e], o = r[i];
            !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
                configurable: !0,
                writable: !0,
                enumerable: o.enumerable,
                value: n[i]
            });
        }
        return Object.create(Object.getPrototypeOf(n), r);
    }
    function d(n, e) {
        return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
            return d(r, !0);
        }, !0)), n;
    }
    function h() {
        n(2);
    }
    function y(n) {
        return null == n || "object" != typeof n || Object.isFrozen(n);
    }
    function b(r) {
        var t = tn[r];
        return t || n(18, r), t;
    }
    function m(n, r) {
        tn[n] || (tn[n] = r);
    }
    function _() {
        return U;
    }
    function j(n, r) {
        r && (b("Patches"), n.u = [], n.s = [], n.v = r);
    }
    function g(n) {
        O(n), n.p.forEach(S), n.p = null;
    }
    function O(n) {
        n === U && (U = n.l);
    }
    function w(n) {
        return U = {
            p: [],
            l: U,
            h: n,
            m: !0,
            _: 0
        };
    }
    function S(n) {
        var r = n[Q];
        0 === r.i || 1 === r.i ? r.j() : r.g = !0;
    }
    function P(r, e) {
        e._ = e.p.length;
        var i = e.p[0], o = void 0 !== r && r !== i;
        return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
    }
    function M(n, r, t) {
        if (y(r)) return r;
        var e = r[Q];
        if (!e) return i(r, function(i, o) {
            return A(n, e, r, i, o, t);
        }, !0), r;
        if (e.A !== n) return r;
        if (!e.P) return x(n, e.t, !0), e.t;
        if (!e.I) {
            e.I = !0, e.A._--;
            var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
            3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
                return A(n, e, o, r, i, t, a);
            }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
        }
        return e.o;
    }
    function A(e, i, o, a, c, s, v) {
        if (r(c)) {
            var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
            if (f(o, a, p), !r(p)) return;
            e.m = !1;
        } else v && o.add(c);
        if (t(c) && !y(c)) {
            if (!e.h.D && e._ < 1) return;
            M(e, c), i && i.A.l || x(e, c);
        }
    }
    function x(n, r, t) {
        void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
    }
    function z(n, r) {
        var t = n[Q];
        return (t ? p(t) : n)[r];
    }
    function I(n, r) {
        if (r in n) for(var t = Object.getPrototypeOf(n); t;){
            var e = Object.getOwnPropertyDescriptor(t, r);
            if (e) return e;
            t = Object.getPrototypeOf(t);
        }
    }
    function k(n) {
        n.P || (n.P = !0, n.l && k(n.l));
    }
    function E(n) {
        n.o || (n.o = l(n.t));
    }
    function N(n, r, t) {
        var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
            var t = Array.isArray(n), e = {
                i: t ? 1 : 0,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: null,
                o: null,
                j: null,
                C: !1
            }, i = e, o = en;
            t && (i = [
                e
            ], o = on);
            var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
            return e.k = f, e.j = a, f;
        }(r, t) : b("ES5").J(r, t);
        return (t ? t.A : _()).p.push(e), e;
    }
    function R(e) {
        return r(e) || n(22, e), function n(r) {
            if (!t(r)) return r;
            var e, u = r[Q], c = o(r);
            if (u) {
                if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
                u.I = !0, e = D(r, c), u.I = !1;
            } else e = D(r, c);
            return i(e, function(r, t) {
                u && a(u.t, r) === t || f(e, r, n(t));
            }), 3 === c ? new Set(e) : e;
        }(e);
    }
    function D(n, r) {
        switch(r){
            case 2:
                return new Map(n);
            case 3:
                return Array.from(n);
        }
        return l(n);
    }
    function F() {
        function t(n, r) {
            var t = s[n];
            return t ? t.enumerable = r : s[n] = t = {
                configurable: !0,
                enumerable: r,
                get: function() {
                    var r = this[Q];
                    return en.get(r, n);
                },
                set: function(r) {
                    var t = this[Q];
                    en.set(t, n, r);
                }
            }, t;
        }
        function e(n) {
            for(var r = n.length - 1; r >= 0; r--){
                var t = n[r][Q];
                if (!t.P) switch(t.i){
                    case 5:
                        a(t) && k(t);
                        break;
                    case 4:
                        o(t) && k(t);
                }
            }
        }
        function o(n) {
            for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
                var o = e[i];
                if (o !== Q) {
                    var a = r[o];
                    if (void 0 === a && !u(r, o)) return !0;
                    var f = t[o], s = f && f[Q];
                    if (s ? s.t !== a : !c(f, a)) return !0;
                }
            }
            var v = !!r[Q];
            return e.length !== nn(r).length + (v ? 0 : 1);
        }
        function a(n) {
            var r = n.k;
            if (r.length !== n.t.length) return !0;
            var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
            if (t && !t.get) return !0;
            for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
            return !1;
        }
        function f(r) {
            r.g && n(3, JSON.stringify(p(r)));
        }
        var s = {};
        m("ES5", {
            J: function(n, r) {
                var e = Array.isArray(n), i = function(n, r) {
                    if (n) {
                        for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                        return e;
                    }
                    var o = rn(r);
                    delete o[Q];
                    for(var u = nn(o), a = 0; a < u.length; a++){
                        var f = u[a];
                        o[f] = t(f, n || !!o[f].enumerable);
                    }
                    return Object.create(Object.getPrototypeOf(r), o);
                }(e, n), o = {
                    i: e ? 5 : 4,
                    A: r ? r.A : _(),
                    P: !1,
                    I: !1,
                    R: {},
                    l: r,
                    t: n,
                    k: i,
                    o: null,
                    g: !1,
                    C: !1
                };
                return Object.defineProperty(i, Q, {
                    value: o,
                    writable: !0
                }), i;
            },
            S: function(n, t, o) {
                o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                    if (r && "object" == typeof r) {
                        var t = r[Q];
                        if (t) {
                            var e = t.t, o = t.k, f = t.R, c = t.i;
                            if (4 === c) i(o, function(r) {
                                r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                            }), i(e, function(n) {
                                void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                            });
                            else if (5 === c) {
                                if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                                else for(var v = e.length; v < o.length; v++)f[v] = !0;
                                for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                            }
                        }
                    }
                }(n.p[0]), e(n.p));
            },
            K: function(n) {
                return 4 === n.i ? o(n) : a(n);
            }
        });
    }
    function T() {
        function e(n) {
            if (!t(n)) return n;
            if (Array.isArray(n)) return n.map(e);
            if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
                return [
                    n[0],
                    e(n[1])
                ];
            }));
            if (v(n)) return new Set(Array.from(n).map(e));
            var r = Object.create(Object.getPrototypeOf(n));
            for(var i in n)r[i] = e(n[i]);
            return u(n, L) && (r[L] = n[L]), r;
        }
        function f(n) {
            return r(n) ? e(n) : n;
        }
        var c = "add";
        m("Patches", {
            $: function(r, t) {
                return t.forEach(function(t) {
                    for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                        var v = o(f), p = i[s];
                        "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                    }
                    var l = o(f), d = e(t.value), h = i[i.length - 1];
                    switch(u){
                        case "replace":
                            switch(l){
                                case 2:
                                    return f.set(h, d);
                                case 3:
                                    n(16);
                                default:
                                    return f[h] = d;
                            }
                        case c:
                            switch(l){
                                case 1:
                                    return "-" === h ? f.push(d) : f.splice(h, 0, d);
                                case 2:
                                    return f.set(h, d);
                                case 3:
                                    return f.add(d);
                                default:
                                    return f[h] = d;
                            }
                        case "remove":
                            switch(l){
                                case 1:
                                    return f.splice(h, 1);
                                case 2:
                                    return f.delete(h);
                                case 3:
                                    return f.delete(t.value);
                                default:
                                    return delete f[h];
                            }
                        default:
                            n(17, u);
                    }
                }), r;
            },
            N: function(n, r, t, e) {
                switch(n.i){
                    case 0:
                    case 4:
                    case 2:
                        return function(n, r, t, e) {
                            var o = n.t, s = n.o;
                            i(n.R, function(n, i) {
                                var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                                if (v !== p || "replace" !== l) {
                                    var d = r.concat(n);
                                    t.push("remove" === l ? {
                                        op: l,
                                        path: d
                                    } : {
                                        op: l,
                                        path: d,
                                        value: p
                                    }), e.push(l === c ? {
                                        op: "remove",
                                        path: d
                                    } : "remove" === l ? {
                                        op: c,
                                        path: d,
                                        value: f(v)
                                    } : {
                                        op: "replace",
                                        path: d,
                                        value: f(v)
                                    });
                                }
                            });
                        }(n, r, t, e);
                    case 5:
                    case 1:
                        return function(n, r, t, e) {
                            var i = n.t, o = n.R, u = n.o;
                            if (u.length < i.length) {
                                var a = [
                                    u,
                                    i
                                ];
                                i = a[0], u = a[1];
                                var s = [
                                    e,
                                    t
                                ];
                                t = s[0], e = s[1];
                            }
                            for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                                var p = r.concat([
                                    v
                                ]);
                                t.push({
                                    op: "replace",
                                    path: p,
                                    value: f(u[v])
                                }), e.push({
                                    op: "replace",
                                    path: p,
                                    value: f(i[v])
                                });
                            }
                            for(var l = i.length; l < u.length; l++){
                                var d = r.concat([
                                    l
                                ]);
                                t.push({
                                    op: c,
                                    path: d,
                                    value: f(u[l])
                                });
                            }
                            i.length < u.length && e.push({
                                op: "replace",
                                path: r.concat([
                                    "length"
                                ]),
                                value: i.length
                            });
                        }(n, r, t, e);
                    case 3:
                        return function(n, r, t, e) {
                            var i = n.t, o = n.o, u = 0;
                            i.forEach(function(n) {
                                if (!o.has(n)) {
                                    var i = r.concat([
                                        u
                                    ]);
                                    t.push({
                                        op: "remove",
                                        path: i,
                                        value: n
                                    }), e.unshift({
                                        op: c,
                                        path: i,
                                        value: n
                                    });
                                }
                                u++;
                            }), u = 0, o.forEach(function(n) {
                                if (!i.has(n)) {
                                    var o = r.concat([
                                        u
                                    ]);
                                    t.push({
                                        op: c,
                                        path: o,
                                        value: n
                                    }), e.unshift({
                                        op: "remove",
                                        path: o,
                                        value: n
                                    });
                                }
                                u++;
                            });
                        }(n, r, t, e);
                }
            },
            M: function(n, r, t, e) {
                t.push({
                    op: "replace",
                    path: [],
                    value: r === H ? void 0 : r
                }), e.push({
                    op: "replace",
                    path: [],
                    value: n
                });
            }
        });
    }
    function C() {
        function r(n, r) {
            function t() {
                this.constructor = n;
            }
            a(n, r), n.prototype = (t.prototype = r.prototype, new t);
        }
        function e(n) {
            n.o || (n.R = new Map, n.o = new Map(n.t));
        }
        function o(n) {
            n.o || (n.o = new Set, n.t.forEach(function(r) {
                if (t(r)) {
                    var e = N(n.A.h, r, n);
                    n.p.set(r, e), n.o.add(e);
                } else n.o.add(r);
            }));
        }
        function u(r) {
            r.g && n(3, JSON.stringify(p(r)));
        }
        var a = function(n, r) {
            return (a = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(n, r) {
                n.__proto__ = r;
            } || function(n, r) {
                for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
            })(n, r);
        }, f = function() {
            function n(n, r) {
                return this[Q] = {
                    i: 2,
                    l: r,
                    A: r ? r.A : _(),
                    P: !1,
                    I: !1,
                    o: void 0,
                    R: void 0,
                    t: n,
                    k: this,
                    C: !1,
                    g: !1
                }, this;
            }
            r(n, Map);
            var o = n.prototype;
            return Object.defineProperty(o, "size", {
                get: function() {
                    return p(this[Q]).size;
                }
            }), o.has = function(n) {
                return p(this[Q]).has(n);
            }, o.set = function(n, r) {
                var t = this[Q];
                return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
            }, o.delete = function(n) {
                if (!this.has(n)) return !1;
                var r = this[Q];
                return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
            }, o.clear = function() {
                var n = this[Q];
                u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                    n.R.set(r, !1);
                }), n.o.clear());
            }, o.forEach = function(n, r) {
                var t = this;
                p(this[Q]).forEach(function(e, i) {
                    n.call(r, t.get(i), i, t);
                });
            }, o.get = function(n) {
                var r = this[Q];
                u(r);
                var i = p(r).get(n);
                if (r.I || !t(i)) return i;
                if (i !== r.t.get(n)) return i;
                var o = N(r.A.h, i, r);
                return e(r), r.o.set(n, o), o;
            }, o.keys = function() {
                return p(this[Q]).keys();
            }, o.values = function() {
                var n, r = this, t = this.keys();
                return (n = {})[V] = function() {
                    return r.values();
                }, n.next = function() {
                    var n = t.next();
                    return n.done ? n : {
                        done: !1,
                        value: r.get(n.value)
                    };
                }, n;
            }, o.entries = function() {
                var n, r = this, t = this.keys();
                return (n = {})[V] = function() {
                    return r.entries();
                }, n.next = function() {
                    var n = t.next();
                    if (n.done) return n;
                    var e = r.get(n.value);
                    return {
                        done: !1,
                        value: [
                            n.value,
                            e
                        ]
                    };
                }, n;
            }, o[V] = function() {
                return this.entries();
            }, n;
        }(), c = function() {
            function n(n, r) {
                return this[Q] = {
                    i: 3,
                    l: r,
                    A: r ? r.A : _(),
                    P: !1,
                    I: !1,
                    o: void 0,
                    t: n,
                    k: this,
                    p: new Map,
                    g: !1,
                    C: !1
                }, this;
            }
            r(n, Set);
            var t = n.prototype;
            return Object.defineProperty(t, "size", {
                get: function() {
                    return p(this[Q]).size;
                }
            }), t.has = function(n) {
                var r = this[Q];
                return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
            }, t.add = function(n) {
                var r = this[Q];
                return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
            }, t.delete = function(n) {
                if (!this.has(n)) return !1;
                var r = this[Q];
                return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
            }, t.clear = function() {
                var n = this[Q];
                u(n), p(n).size && (o(n), k(n), n.o.clear());
            }, t.values = function() {
                var n = this[Q];
                return u(n), o(n), n.o.values();
            }, t.entries = function() {
                var n = this[Q];
                return u(n), o(n), n.o.entries();
            }, t.keys = function() {
                return this.values();
            }, t[V] = function() {
                return this.values();
            }, t.forEach = function(n, r) {
                for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
            }, n;
        }();
        m("MapSet", {
            F: function(n, r) {
                return new f(n, r);
            },
            T: function(n, r) {
                return new c(n, r);
            }
        });
    }
    function J() {
        F(), C(), T();
    }
    function K(n) {
        return n;
    }
    function $(n) {
        return n;
    }
    var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
        0: "Illegal state",
        1: "Immer drafts cannot have computed properties",
        2: "This object has been frozen and should not be mutated",
        3: function(n) {
            return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
        },
        4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
        5: "Immer forbids circular references",
        6: "The first or second argument to `produce` must be a function",
        7: "The third argument to `produce` must be a function or undefined",
        8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
        9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
        10: "The given draft is already finalized",
        11: "Object.defineProperty() cannot be used on an Immer draft",
        12: "Object.setPrototypeOf() cannot be used on an Immer draft",
        13: "Immer only supports deleting array indices",
        14: "Immer only supports setting array indices and the 'length' property",
        15: function(n) {
            return "Cannot apply patch, path doesn't resolve: " + n;
        },
        16: 'Sets cannot have "replace" patches.',
        17: function(n) {
            return "Unsupported patch operation: " + n;
        },
        18: function(n) {
            return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
        },
        20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
        21: function(n) {
            return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
        },
        22: function(n) {
            return "'current' expects a draft, got: " + n;
        },
        23: function(n) {
            return "'original' expects a draft, got: " + n;
        },
        24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
    }, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
        return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
    } : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
        var r = {};
        return nn(n).forEach(function(t) {
            r[t] = Object.getOwnPropertyDescriptor(n, t);
        }), r;
    }, tn = {}, en = {
        get: function(n, r) {
            if (r === Q) return n;
            var e = p(n);
            if (!u(e, r)) return function(n, r, t) {
                var e, i = I(r, t);
                return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
            }(n, e, r);
            var i = e[r];
            return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
        },
        has: function(n, r) {
            return r in p(n);
        },
        ownKeys: function(n) {
            return Reflect.ownKeys(p(n));
        },
        set: function(n, r, t) {
            var e = I(p(n), r);
            if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
            if (!n.P) {
                var i = z(p(n), r), o = null == i ? void 0 : i[Q];
                if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
                if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
                E(n), k(n);
            }
            return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
        },
        deleteProperty: function(n, r) {
            return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
        },
        getOwnPropertyDescriptor: function(n, r) {
            var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
            return e ? {
                writable: !0,
                configurable: 1 !== n.i || "length" !== r,
                enumerable: e.enumerable,
                value: t[r]
            } : e;
        },
        defineProperty: function() {
            n(11);
        },
        getPrototypeOf: function(n) {
            return Object.getPrototypeOf(n.t);
        },
        setPrototypeOf: function() {
            n(12);
        }
    }, on = {};
    i(en, function(n, r) {
        on[n] = function() {
            return arguments[0] = arguments[0][0], r.apply(this, arguments);
        };
    }), on.deleteProperty = function(r, t) {
        return on.set.call(this, r, t, void 0);
    }, on.set = function(r, t, e) {
        return en.set.call(this, r[0], t, e, r[0]);
    };
    var un = function() {
        function e(r) {
            var e = this;
            this.O = B, this.D = !0, this.produce = function(r, i, o) {
                if ("function" == typeof r && "function" != typeof i) {
                    var u = i;
                    i = r;
                    var a = e;
                    return function(n) {
                        var r = this;
                        void 0 === n && (n = u);
                        for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                        return a.produce(n, function(n) {
                            var t;
                            return (t = i).call.apply(t, [
                                r,
                                n
                            ].concat(e));
                        });
                    };
                }
                var f;
                if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                    var c = w(e), s = N(e, r, void 0), v = !0;
                    try {
                        f = i(s), v = !1;
                    } finally{
                        v ? g(c) : O(c);
                    }
                    return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                        return j(c, o), P(n, c);
                    }, function(n) {
                        throw g(c), n;
                    }) : (j(c, o), P(f, c));
                }
                if (!r || "object" != typeof r) {
                    if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                        var p = [], l = [];
                        b("Patches").M(r, f, p, l), o(p, l);
                    }
                    return f;
                }
                n(21, r);
            }, this.produceWithPatches = function(n, r) {
                if ("function" == typeof n) return function(r) {
                    for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                    return e.produceWithPatches(r, function(r) {
                        return n.apply(void 0, [
                            r
                        ].concat(i));
                    });
                };
                var t, i, o = e.produce(n, r, function(n, r) {
                    t = n, i = r;
                });
                return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                    return [
                        n,
                        t,
                        i
                    ];
                }) : [
                    o,
                    t,
                    i
                ];
            }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
        }
        var i = e.prototype;
        return i.createDraft = function(e) {
            t(e) || n(8), r(e) && (e = R(e));
            var i = w(this), o = N(this, e, void 0);
            return o[Q].C = !0, O(i), o;
        }, i.finishDraft = function(r, t) {
            var e = r && r[Q];
            var i = e.A;
            return j(i, t), P(void 0, i);
        }, i.setAutoFreeze = function(n) {
            this.D = n;
        }, i.setUseProxies = function(r) {
            r && !B && n(20), this.O = r;
        }, i.applyPatches = function(n, t) {
            var e;
            for(e = t.length - 1; e >= 0; e--){
                var i = t[e];
                if (0 === i.path.length && "replace" === i.op) {
                    n = i.value;
                    break;
                }
            }
            e > -1 && (t = t.slice(e + 1));
            var o = b("Patches").$;
            return r(n) ? o(n, t) : this.produce(n, function(n) {
                return o(n, t);
            });
        }, e;
    }(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
    var $5e68ffea5fb572cb$export$2e2bcd8739ae039 = fn;
});
parcelRegister("ee7sp", function(module, exports) {
    $parcel$export(module.exports, "createStore", ()=>$a5b82856cfbd137f$export$f51a9068ac82ea43);
    var $a5b82856cfbd137f$import_meta = Object.assign(Object.create(null), {
        url: "file:///node_modules/zustand/esm/vanilla.mjs"
    });
    const $a5b82856cfbd137f$var$createStoreImpl = (createState)=>{
        let state;
        const listeners = new Set();
        const setState = (partial, replace)=>{
            const nextState = typeof partial === "function" ? partial(state) : partial;
            if (!Object.is(nextState, state)) {
                const previousState = state;
                state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
                listeners.forEach((listener)=>listener(state, previousState));
            }
        };
        const getState = ()=>state;
        const getInitialState = ()=>initialState;
        const subscribe = (listener)=>{
            listeners.add(listener);
            return ()=>listeners.delete(listener);
        };
        const destroy = ()=>{
            if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
            listeners.clear();
        };
        const api = {
            setState: setState,
            getState: getState,
            getInitialState: getInitialState,
            subscribe: subscribe,
            destroy: destroy
        };
        const initialState = state = createState(setState, getState, api);
        return api;
    };
    const $a5b82856cfbd137f$export$f51a9068ac82ea43 = (createState)=>createState ? $a5b82856cfbd137f$var$createStoreImpl(createState) : $a5b82856cfbd137f$var$createStoreImpl;
    var $a5b82856cfbd137f$export$2e2bcd8739ae039 = (createState)=>{
        if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
        return $a5b82856cfbd137f$export$f51a9068ac82ea43(createState);
    };
});
parcelRegister("5eAc2", function(module, exports) {
    $parcel$export(module.exports, "StargateClient", ()=>$0084b28d1d44d0da$export$c66ca190f89caaac);
    class $0084b28d1d44d0da$export$c66ca190f89caaac {
        constructor(baseUrl){
            this.baseUrl = baseUrl || '/gateway/api';
        }
        async fetchToken(clientId) {
            return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
                credentials: 'include',
                headers: {
                    'x-client-id': clientId
                }
            })).json();
        }
        isTokenExpired(token) {
            const currentTimeInSeconds = new Date().getTime() / 1000;
            return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
        }
    }
});
parcelRegister("hUEMO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ais1M").then(()=>parcelRequire('piTsY'));
});
parcelRegister("0l85J", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$468763407d64700f$export$2e2bcd8739ae039);
    var $5B9Cy;
    var $aEbo8;
    var $b8sgr;
    var $iwKVT = parcelRequire("iwKVT");
    const $468763407d64700f$var$getRequiredRepresentation = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;
    const $468763407d64700f$var$isUnsupportedBrowser = ()=>{
        const isIE = !!document.documentMode;
        const isEdge = !isIE && !!window.StyleMedia;
        return isIE || isEdge;
    };
    class $468763407d64700f$export$3850f566ce8d817a {
        constructor(mediaImageLoader){
            this.cachedImageUrls = new Set();
            (0, (0, parcelRequire("b8sgr")).default)('BrowserCacheStrategy');
            this.mediaImageLoader = mediaImageLoader;
        }
        loadEmoji(emoji, useAlt) {
            const representation = $468763407d64700f$var$getRequiredRepresentation(emoji, useAlt);
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(representation)) return emoji;
            const { mediaPath: mediaPath } = representation;
            if (this.cachedImageUrls.has(mediaPath)) return emoji;
            return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
                this.cachedImageUrls.add(mediaPath);
                return emoji;
            }).catch(()=>{
                return undefined;
            });
        }
        optimisticRendering() {
            return true;
        }
        static supported(mediaPath, mediaImageLoader) {
            if ($468763407d64700f$var$isUnsupportedBrowser()) return Promise.resolve(false);
            return mediaImageLoader.loadMediaImage(mediaPath).then(()=>new Promise((resolve)=>{
                    const img = new Image();
                    img.addEventListener('load', ()=>{
                        resolve(true);
                    });
                    img.addEventListener('error', ()=>{
                        resolve(false);
                    });
                    img.src = mediaPath;
                })).catch(()=>false);
        }
    }
    const $468763407d64700f$var$maxImageCached = 1000;
    const $468763407d64700f$var$maxImageSize = 10000;
    class $468763407d64700f$export$b522858a3709f4c {
        constructor(mediaImageLoader){
            (0, (0, parcelRequire("b8sgr")).default)('MemoryCacheStrategy');
            this.mediaImageLoader = mediaImageLoader;
            this.dataURLCache = new (0, $iwKVT.LRUMap)($468763407d64700f$var$maxImageCached);
        }
        loadEmoji(emoji, useAlt) {
            const representation = $468763407d64700f$var$getRequiredRepresentation(emoji, useAlt);
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(representation)) return emoji;
            const { mediaPath: mediaPath } = representation;
            const dataURL = this.dataURLCache.get(mediaPath);
            if (dataURL) return (0, (0, parcelRequire("5B9Cy")).convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
                const loadedEmoji = (0, (0, parcelRequire("5B9Cy")).convertMediaToImageEmoji)(emoji, dataURL, useAlt);
                if (dataURL.length <= $468763407d64700f$var$maxImageSize) this.dataURLCache.set(mediaPath, dataURL);
                else (0, (0, parcelRequire("b8sgr")).default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
                return loadedEmoji;
            }).catch(()=>{
                return undefined;
            });
        }
        optimisticRendering() {
            return false;
        }
    }
    class $468763407d64700f$export$2e2bcd8739ae039 {
        constructor(tokenManager){
            this.waitingInitUrls = [];
            (0, (0, parcelRequire("b8sgr")).default)('MediaEmojiCache');
            this.mediaImageLoader = new (0, (0, parcelRequire("aEbo8")).default)(tokenManager);
        }
        loadEmoji(emoji, useAlt) {
            const representation = $468763407d64700f$var$getRequiredRepresentation(emoji, useAlt);
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(representation)) return emoji;
            const { mediaPath: mediaPath } = representation;
            const emojiCache = this.getCache(mediaPath);
            if ((0, (0, parcelRequire("5B9Cy")).isPromise)(emojiCache)) return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
            return emojiCache.loadEmoji(emoji, useAlt);
        }
        optimisticRendering(url) {
            const emojiCache = this.getCache(url);
            if ((0, (0, parcelRequire("5B9Cy")).isPromise)(emojiCache)) return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
            return emojiCache.optimisticRendering();
        }
        getCache(url) {
            if (this.cache) return this.cache;
            this.waitingInitUrls.push(url);
            if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
                this.cache = cache;
                this.cacheLoading = undefined;
                return cache;
            }).catch((err)=>{
                this.cacheLoading = undefined;
                throw err;
            });
            return this.cacheLoading;
        }
        initCache() {
            const url = this.waitingInitUrls.pop();
            if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
            return $468763407d64700f$export$3850f566ce8d817a.supported(url, this.mediaImageLoader).then((supported)=>{
                this.waitingInitUrls = [];
                this.cacheLoading = undefined;
                if (supported) return new $468763407d64700f$export$3850f566ce8d817a(this.mediaImageLoader);
                return new $468763407d64700f$export$b522858a3709f4c(this.mediaImageLoader);
            }).catch(()=>{
                return this.initCache();
            });
        }
    }
});
parcelRegister("aEbo8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12bf8241dae2d3e6$export$2e2bcd8739ae039);
    var $gQ3yg;
    const $12bf8241dae2d3e6$var$defaultConcurrentDownloadLimit = 16;
    const $12bf8241dae2d3e6$var$backoffMaxDelayInMillis = 600;
    const $12bf8241dae2d3e6$var$defaultMaxRetriesOnNotFound = 2;
    class $12bf8241dae2d3e6$export$2e2bcd8739ae039 {
        constructor(tokenManager, options){
            this.mediaImageQueue = [];
            this.activeProcessing = 0;
            this.pendingRequests = new Map();
            this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $12bf8241dae2d3e6$var$defaultConcurrentDownloadLimit;
            this.tokenManager = tokenManager;
        }
        loadMediaImage(url) {
            const maybePending = this.pendingRequests.get(url);
            if (maybePending !== undefined) return maybePending;
            const pending = new Promise((resolve, reject)=>{
                this.mediaImageQueue.push({
                    url: url,
                    resolve: resolve,
                    reject: reject
                });
                this.processFromQueue();
            }).then((result)=>{
                this.pendingRequests.delete(url);
                return result;
            }).catch((error)=>{
                this.pendingRequests.delete(url);
                throw error;
            });
            this.pendingRequests.set(url, pending);
            return pending;
        }
        getQueueSize() {
            return this.mediaImageQueue.length;
        }
        getActiveDownloads() {
            return this.activeProcessing;
        }
        processFromQueue() {
            while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
                this.activeProcessing++;
                const item = this.mediaImageQueue.shift();
                const { url: url, resolve: resolve, reject: reject } = item;
                this.tokenManager.getToken('read', false).then((token)=>{
                    this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                        resolve(dataURL);
                        this.completedItem();
                    }).catch((error)=>{
                        reject(error);
                        this.completedItem();
                    });
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }
        }
        completedItem() {
            this.activeProcessing--;
            this.processFromQueue();
        }
        delay(durationInMillis) {
            return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
        }
        requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $12bf8241dae2d3e6$var$defaultMaxRetriesOnNotFound) {
            return (0, (0, parcelRequire("gQ3yg")).imageAcceptHeader)().then((acceptHeader)=>{
                const options = {
                    headers: {
                        Authorization: `Bearer ${token.jwt}`,
                        'X-Client-Id': token.clientId,
                        Accept: acceptHeader
                    }
                };
                return fetch(url, options).then((response)=>{
                    if (response.status === 404 && retriesOnNotFound > 0) return this.delay($12bf8241dae2d3e6$var$backoffMaxDelayInMillis / retriesOnNotFound).then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                    else if (response.status === 403 && retryOnAuthError) return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                    else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                    throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
                });
            });
        }
        readBlob(blob) {
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.addEventListener('load', ()=>resolve(reader.result));
                reader.addEventListener('error', ()=>reject(reader.error));
                reader.readAsDataURL(blob);
            });
        }
    }
});
parcelRegister("gQ3yg", function(module, exports) {
    $parcel$export(module.exports, "getNaturalImageSize", ()=>$0ad0cc252faa2438$export$90153ab95f408dfa);
    $parcel$export(module.exports, "parseImage", ()=>$0ad0cc252faa2438$export$37bbb051492a18a7);
    $parcel$export(module.exports, "hasFileExceededSize", ()=>$0ad0cc252faa2438$export$a115ddd5941792f1);
    $parcel$export(module.exports, "imageAcceptHeader", ()=>$0ad0cc252faa2438$export$f8e7886bc155c2e6);
    const $0ad0cc252faa2438$var$maxEmojiSizeInBytes = 1048576;
    const $0ad0cc252faa2438$export$90153ab95f408dfa = (dataURL)=>{
        return new Promise((resolve, reject)=>{
            const img = new Image();
            img.addEventListener('load', ()=>{
                resolve({
                    width: img.naturalWidth,
                    height: img.naturalHeight
                });
            });
            img.addEventListener('error', reject);
            img.src = dataURL;
        });
    };
    const $0ad0cc252faa2438$export$37bbb051492a18a7 = (dataURL)=>{
        return new Promise((resolve, reject)=>{
            let img = new Image();
            img.onload = ()=>resolve({
                    src: img.src
                });
            img.onerror = ()=>reject();
            img.src = dataURL;
        });
    };
    const $0ad0cc252faa2438$export$a115ddd5941792f1 = (file)=>{
        return file && file.size > $0ad0cc252faa2438$var$maxEmojiSizeInBytes;
    };
    let $0ad0cc252faa2438$var$isWebpSupported;
    const $0ad0cc252faa2438$export$c5a964eb84c7fca8 = ()=>{
        if ($0ad0cc252faa2438$var$isWebpSupported !== undefined) return Promise.resolve($0ad0cc252faa2438$var$isWebpSupported);
        return new Promise((resolve)=>{
            const img = new Image();
            const checkSupport = ()=>{
                $0ad0cc252faa2438$var$isWebpSupported = img.height === 2;
                resolve($0ad0cc252faa2438$var$isWebpSupported);
            };
            img.addEventListener('load', checkSupport);
            img.addEventListener('error', checkSupport);
            img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
        });
    };
    const $0ad0cc252faa2438$export$f8e7886bc155c2e6 = ()=>$0ad0cc252faa2438$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
            const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
            const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
            return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
        });
});
parcelRegister("ijzU9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$237e13119c8cb0fd$export$2e2bcd8739ae039);
    var $dS9cn = parcelRequire("dS9cn");
    const $237e13119c8cb0fd$export$866c20c059277b6 = 30;
    class $237e13119c8cb0fd$export$2e2bcd8739ae039 {
        constructor(siteServiceConfig){
            this.siteServiceConfig = siteServiceConfig;
            this.tokens = new Map();
        }
        isValidToken(mediaApiToken) {
            const nowInSeconds = Date.now() / 1000;
            const expiresAt = mediaApiToken.expiresAt - $237e13119c8cb0fd$export$866c20c059277b6;
            if (nowInSeconds < expiresAt) return true;
            return false;
        }
        fetchNewToken(type) {
            return (0, $dS9cn.utils).requestService(this.siteServiceConfig, {
                path: `token/${type}`
            });
        }
        addToken(type, mediaApiToken) {
            this.tokens.set(type, {
                mediaApiToken: mediaApiToken
            });
        }
        getToken(type, forceRefresh) {
            let tokenDetail = this.tokens.get(type);
            if (!tokenDetail) {
                tokenDetail = {};
                this.tokens.set(type, tokenDetail);
            }
            const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
            if (mediaApiToken) {
                if (this.isValidToken(mediaApiToken) && !forceRefresh) return Promise.resolve(mediaApiToken);
            }
            if (activeTokenRefresh) return activeTokenRefresh;
            tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
                tokenDetail.mediaApiToken = token;
                tokenDetail.activeTokenRefresh = undefined;
                return token;
            });
            return tokenDetail.activeTokenRefresh;
        }
    }
});
parcelRegister("d2UcN", function(module, exports) {
    $parcel$export(module.exports, "ufoExperiences", ()=>$350e11372b641899$export$615f888019c45765);
    $parcel$export(module.exports, "sampledUfoRenderedEmoji", ()=>$350e11372b641899$export$71c8cba6f1251ea9);
    $parcel$export(module.exports, "hasUfoMarked", ()=>$350e11372b641899$export$a9be054d2a5cedc0);
    $parcel$export(module.exports, "sampledUfoEmojiResourceFetched", ()=>$350e11372b641899$export$1466212a1606133);
    var $9AR2K;
    var $cBycP;
    var $7Zbvr;
    var $boHLC;
    var $bHWpv;
    const $350e11372b641899$var$createRenderExperience = (componentName)=>{
        return {
            platform: {
                component: componentName
            },
            type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad
        };
    };
    const $350e11372b641899$var$createInlineExperience = (componentName)=>{
        return {
            platform: {
                component: componentName
            },
            type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Experience,
            performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).InlineResult
        };
    };
    const $350e11372b641899$var$customEmojiTimings = [
        {
            key: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimingsKeys).FMP,
            endMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).FMP_END
        },
        {
            key: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimingsKeys).METADATA,
            component: 'resourced-emoji',
            startMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).METADATA_START,
            endMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).METADATA_END
        },
        {
            key: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimingsKeys).MEDIADATA,
            component: 'caching-emoji',
            startMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).MEDIA_START,
            endMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).MEDIA_END
        },
        {
            key: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimingsKeys).MOUNTED,
            component: 'emoji',
            endMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).MOUNTED_END
        },
        {
            key: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimingsKeys).ONLOAD,
            startMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).ONLOAD_START,
            endMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).ONLOAD_END
        }
    ];
    const $350e11372b641899$export$615f888019c45765 = {
        'emoji-rendered': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)((0, (0, parcelRequire("9AR2K")).UfoExperienceName).EMOJI_RENDERED, {
            platform: {
                component: (0, (0, parcelRequire("9AR2K")).UfoComponentName).EMOJI
            },
            type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Operation,
            performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).Custom,
            timings: $350e11372b641899$var$customEmojiTimings
        }),
        'emoji-resource-fetched': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)((0, (0, parcelRequire("9AR2K")).UfoExperienceName).EMOJI_RESOURCE_FETCHED, $350e11372b641899$var$createRenderExperience((0, (0, parcelRequire("9AR2K")).UfoComponentName).EMOJI_PROVIDER)),
        'emoji-picker-opened': new (0, (0, parcelRequire("boHLC")).UFOExperience)((0, (0, parcelRequire("9AR2K")).UfoExperienceName).EMOJI_PICKER_OPENED, $350e11372b641899$var$createRenderExperience((0, (0, parcelRequire("9AR2K")).UfoComponentName).EMOJI_PICKER)),
        'emoji-selection-recorded': new (0, (0, parcelRequire("boHLC")).UFOExperience)((0, (0, parcelRequire("9AR2K")).UfoExperienceName).EMOJI_SELECTION_RECORDED, $350e11372b641899$var$createInlineExperience((0, (0, parcelRequire("9AR2K")).UfoComponentName).EMOJI_PROVIDER)),
        'emoji-uploaded': new (0, (0, parcelRequire("boHLC")).UFOExperience)((0, (0, parcelRequire("9AR2K")).UfoExperienceName).EMOJI_UPLOADED, $350e11372b641899$var$createInlineExperience((0, (0, parcelRequire("9AR2K")).UfoComponentName).EMOJI_PICKER)),
        'emoji-searched': new (0, (0, parcelRequire("boHLC")).UFOExperience)((0, (0, parcelRequire("9AR2K")).UfoExperienceName).EMOJI_SEARCHED, $350e11372b641899$var$createInlineExperience((0, (0, parcelRequire("9AR2K")).UfoComponentName).EMOJI_PICKER))
    };
    const $350e11372b641899$export$71c8cba6f1251ea9 = (emojiId)=>{
        return (0, (0, parcelRequire("bHWpv")).withSampling)($350e11372b641899$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
    };
    const $350e11372b641899$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
        return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
    };
    const $350e11372b641899$export$1466212a1606133 = (providerType)=>{
        return (0, (0, parcelRequire("bHWpv")).withSampling)($350e11372b641899$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
    };
});
parcelRegister("bHWpv", function(module, exports) {
    $parcel$export(module.exports, "withSampling", ()=>$8c8d9cbeece0ed73$export$dc2f0946255b3f89);
    const $8c8d9cbeece0ed73$export$c7c4959fece2f3ec = {};
    const $8c8d9cbeece0ed73$export$cdff9a865136ae27 = ()=>{
        for (const prop of Object.getOwnPropertyNames($8c8d9cbeece0ed73$export$c7c4959fece2f3ec))delete $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[prop];
    };
    const $8c8d9cbeece0ed73$export$1c967630b3ea2d58 = (rate)=>{
        if (rate === 1) return true;
        if (rate === 0) return false;
        return Math.random() * rate <= 1;
    };
    const $8c8d9cbeece0ed73$var$hasSampledFromStart = (experience)=>{
        if (!$8c8d9cbeece0ed73$export$c7c4959fece2f3ec[experience.id]) return false;
        if (experience.instanceId) return $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
        return $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[experience.id].sampled;
    };
    const $8c8d9cbeece0ed73$export$dc2f0946255b3f89 = (ufoExperience)=>{
        const init = ()=>{
            if (!$8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id]) $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id] = {
                sampled: false,
                sampledInstance: {}
            };
        };
        const start = async (options)=>{
            if ($8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
            const isSampled = options.samplingFunc || $8c8d9cbeece0ed73$export$1c967630b3ea2d58;
            if (!isSampled(options.samplingRate)) {
                if (ufoExperience.instanceId) $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
                $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
                return;
            }
            if (ufoExperience.instanceId) {
                $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
                $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
            }
            return ufoExperience.start(options.startTime);
        };
        const success = async (config)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return null;
            return ufoExperience.success(config);
        };
        const failure = async (config)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return null;
            return ufoExperience.failure(config);
        };
        const abort = async (config)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return null;
            return ufoExperience.abort(config);
        };
        const addMetadata = (data)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
            return ufoExperience.addMetadata(data);
        };
        const mark = (name, timestamp)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
            return ufoExperience.mark(name, timestamp);
        };
        const markFMP = (timestamp)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
            return ufoExperience.markFMP(timestamp);
        };
        const markInlineResponse = (timestamp)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
            return ufoExperience.markInlineResponse(timestamp);
        };
        init();
        return {
            ...ufoExperience,
            start: start,
            addMetadata: addMetadata,
            success: success,
            failure: failure,
            abort: abort,
            mark: mark,
            markFMP: markFMP,
            markInlineResponse: markInlineResponse
        };
    };
});
parcelRegister("9CGZY", function(module, exports) {
    $parcel$export(module.exports, "EMOJI_SERVICEID", ()=>$2d9090d159781c68$export$f3c4ed49c0fff3de);
    $parcel$export(module.exports, "EMOJI_WITH_CUSTOM_SERVICEID", ()=>$2d9090d159781c68$export$f8b39b441e3e8eb2);
    $parcel$export(module.exports, "EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID", ()=>$2d9090d159781c68$export$2cdcb9248b6d4704);
    $parcel$export(module.exports, "getServiceProvider", ()=>$2d9090d159781c68$export$a4c27db78169052e);
    $parcel$export(module.exports, "default", ()=>$2d9090d159781c68$export$2e2bcd8739ae039);
    var $j8DrX;
    const $2d9090d159781c68$var$providersRepository = {};
    const $2d9090d159781c68$export$f3c4ed49c0fff3de = 'emoji';
    const $2d9090d159781c68$export$f8b39b441e3e8eb2 = 'emoji-with-custom';
    const $2d9090d159781c68$export$2cdcb9248b6d4704 = 'emoji-with-custom-upload-disabled';
    const $2d9090d159781c68$var$getServiceBaseUrl = (serviceId)=>{
        if (serviceId === $2d9090d159781c68$export$f8b39b441e3e8eb2 || serviceId === $2d9090d159781c68$export$2cdcb9248b6d4704) return (0, (0, parcelRequire("j8DrX")).default)('ajs-fabric-emoji-url');
        return (0, (0, parcelRequire("j8DrX")).default)(`ajs-fabric-${serviceId}-url`);
    };
    const $2d9090d159781c68$export$a4c27db78169052e = (serviceId, serviceProviderGenerator)=>{
        try {
            let serviceProvider = $2d9090d159781c68$var$providersRepository[serviceId];
            if (serviceProvider === undefined) {
                const serviceBaseUrl = $2d9090d159781c68$var$getServiceBaseUrl(serviceId);
                if (serviceBaseUrl) {
                    serviceProvider = Promise.resolve(serviceProviderGenerator(serviceBaseUrl));
                    $2d9090d159781c68$var$providersRepository[serviceId] = serviceProvider;
                }
            }
            return serviceProvider;
        } catch (e) {
            return null;
        }
    };
    const $2d9090d159781c68$export$59790759c19337ec = ()=>{
        Object.keys($2d9090d159781c68$var$providersRepository).forEach((key)=>{
            delete $2d9090d159781c68$var$providersRepository[key];
        });
    };
    var $2d9090d159781c68$export$2e2bcd8739ae039 = $2d9090d159781c68$var$getServiceBaseUrl;
});
parcelRegister("6ZDS2", function(module, exports) {
    $parcel$export(module.exports, "AnalyticContext", ()=>$c529cbf8cbd12a6e$export$da0556bf821b3494);
    $parcel$export(module.exports, "AnalyticContextProvider", ()=>$c529cbf8cbd12a6e$export$aea8e3edcdec81e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $ivGSs;
    var $jhS4y;
    var $8zOmE;
    var $2NMNM;
    const $c529cbf8cbd12a6e$export$da0556bf821b3494 = (0, $5uXOq.createContext)({
        fireUIAnalyticForFixMenuItem: (0, ($parcel$interopDefault($8Rkzz))),
        fireUIAnalyticForFixButton: (0, ($parcel$interopDefault($8Rkzz))),
        fireUIAnalyticForFavouriteToggle: (0, ($parcel$interopDefault($8Rkzz))),
        fireUIAnalyticForRoadmapsItems: (0, ($parcel$interopDefault($8Rkzz)))
    });
    const $c529cbf8cbd12a6e$export$aea8e3edcdec81e3 = ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireUIAnalyticForFixMenuItem = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS],
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    itemId: (0, $071bfededeb4df80$export$3fc15b6d7f7757ac)
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        const fireUIAnalyticForFixButton = (0, $5uXOq.useCallback)(({ itemId: itemId })=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS],
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    itemId: itemId
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        const fireUIAnalyticForFavouriteToggle = (0, $5uXOq.useCallback)(({ starType: starType, parentItemId: parentItemId })=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS],
                attributes: {
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    componentType: (0, $1e554a683893bd46$export$74712b62056d422e),
                    parentItemId: parentItemId,
                    parentItemType: 'roadmap',
                    itemId: starType
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        const fireUIAnalyticForRoadmapsItems = (0, $5uXOq.useCallback)(({ itemId: itemId, section: section })=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS],
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                    itemType: (0, $632bd8725b437a12$export$bb8a37ab8d9ba82b).toLowerCase(),
                    itemId: itemId,
                    section: section
                }
            });
        }, [
            createAnalyticsEvent
        ]);
        const value = (0, $5uXOq.useMemo)(()=>({
                fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem,
                fireUIAnalyticForFixButton: fireUIAnalyticForFixButton,
                fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle,
                fireUIAnalyticForRoadmapsItems: fireUIAnalyticForRoadmapsItems
            }), [
            fireUIAnalyticForFavouriteToggle,
            fireUIAnalyticForFixButton,
            fireUIAnalyticForFixMenuItem,
            fireUIAnalyticForRoadmapsItems
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c529cbf8cbd12a6e$export$da0556bf821b3494.Provider, {
            value: value
        }, children);
    };
});
parcelRegister("fBbR0", function(module, exports) {
    $parcel$export(module.exports, "ActionButtons", ()=>$eba81b1617cf8340$export$88c65d2d98aab183);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIWbq;
    var $eZUJu;
    var $3bDjY;
    var $koVbs;
    var $46Cti;
    var $1xonH;
    var $eaKdt;
    var $aCS3f;
    var $kG753;
    var $daoB1;
    var $6ZDS2;
    var $1poXk;
    function $eba81b1617cf8340$export$88c65d2d98aab183() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { hasProductDiscoveryAccess: hasProductDiscoveryAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6ZDS2")).AnalyticContext));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kG753")).CollectionCreate), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false)
        }), hasProductDiscoveryAccess && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("1poXk")).default).createRoadmap)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xonH")).CommonNavMenuButton), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("dIWbq"))))),
            label: formatMessage((0, (0, parcelRequire("1poXk")).default).createRoadmap),
            onClick: ()=>{
                fireUIAnalyticForFixButton({
                    itemId: (0, $071bfededeb4df80$export$862abc666c31a61a)
                });
                setIsOpen(true);
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            onOpen: ()=>fireUIAnalyticForFixButton({
                    itemId: (0, $071bfededeb4df80$export$f06dfcec5ff912e)
                }),
            MenuItems: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaKdt")).HideL1MenuItemSection), {
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS,
                    hasSeparator: false
                }))
        }));
    }
});
parcelRegister("kG753", function(module, exports) {
    $parcel$export(module.exports, "CollectionCreate", ()=>$ea1a9a9ad6a5b7f5$export$e31c3ec1e288349f);
    var $5uXOq = parcelRequire("5uXOq");
    var $k8nZq;
    var $dC5iT;
    var $bgrar;
    var $f5TWP;
    var $8CUq3;
    var $4R6GH;
    var $iXVV6;
    var $eOMZh;
    var $3FQk4;
    var $dnM4Q;
    var $6Gni9;
    const $ea1a9a9ad6a5b7f5$export$e31c3ec1e288349f = ({ isOpen: isOpen, onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
            sourceName: "collectionCreate"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k8nZq")).default), {
            zIndex: (0, (0, parcelRequire("eOMZh")).DRAWER_Z_INDEX)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dnM4Q")).Drawer), {
            isOpen: isOpen,
            onClose: onClose
        }, (0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            spread: "space-between",
            xcss: $ea1a9a9ad6a5b7f5$var$innerWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ea1a9a9ad6a5b7f5$var$backgroundLeftStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3FQk4")).BackgroundLeft), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ea1a9a9ad6a5b7f5$var$backgroundRightStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3FQk4")).BackgroundRight), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ea1a9a9ad6a5b7f5$var$formStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Gni9")).Form), {
            onSuccess: onClose
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bgrar")).default), {
            templateColumns: "minmax(550px, 1fr) minmax(0, 1fr)",
            alignItems: "center",
            xcss: (0, (0, parcelRequire("8CUq3")).xcss)({
                height: '100%'
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Gni9")).Form), {
            onSuccess: onClose
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3FQk4")).Background), null)))));
    const $ea1a9a9ad6a5b7f5$var$innerWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%'
    });
    const $ea1a9a9ad6a5b7f5$var$backgroundLeftStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        alignSelf: 'flex-start',
        transform: 'translateY(150px)',
        order: 1
    });
    const $ea1a9a9ad6a5b7f5$var$formStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%',
        marginBlock: 'space.1000',
        marginInline: 'space.400',
        flex: 1,
        maxWidth: '420px',
        order: 2
    });
    const $ea1a9a9ad6a5b7f5$var$backgroundRightStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        alignSelf: 'flex-end',
        transform: 'translateX(-60px) translateY(-40px)',
        order: 3
    });
});
parcelRegister("eOMZh", function(module, exports) {
    $parcel$export(module.exports, "DRAWER_Z_INDEX", ()=>$fa757a7b31bbf91b$export$66cb31822cec84b0);
    var $gwIPs;
    const $fa757a7b31bbf91b$export$66cb31822cec84b0 = (0, (0, parcelRequire("gwIPs")).layers).navigation - 1;
});
parcelRegister("3FQk4", function(module, exports) {
    $parcel$export(module.exports, "BackgroundRight", ()=>$936ceae5a4a545da$export$db8dbd68737e686a);
    $parcel$export(module.exports, "BackgroundLeft", ()=>$936ceae5a4a545da$export$91862e78ed08ce2b);
    $parcel$export(module.exports, "Background", ()=>$936ceae5a4a545da$export$668799e4797757a8);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    const $936ceae5a4a545da$export$db8dbd68737e686a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "198",
            height: "206",
            viewBox: "0 0 198 206",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M99.0774 0.0321045C156.491 0.0321045 197.203 33.417 197.203 90.797C197.203 148.177 156.491 180.518 99.0774 180.518C41.6639 180.518 0.952148 148.177 0.952148 90.797C0.952148 33.417 41.6639 0.0321045 99.0774 0.0321045Z",
            fill: "#BF63F3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M157.964 158.788C154.33 158.315 148.912 160.281 145.992 158.838C146.88 158.921 147.369 147.145 144.44 149.268C143.594 149.972 143.196 151.283 144.482 151.623C142.092 152.734 145.793 158.78 140.234 161.301C140.151 158.108 125.772 163.076 134.152 163.225C134.351 161.956 134.401 165.24 136.757 162.827C145.22 163.689 141.901 167.745 144.83 174.105C144.415 182.846 150.688 176.046 147.452 171.725C149.709 166.127 141.653 161.765 151.302 164.17C152.273 162.13 163.407 161.997 157.956 158.788H157.964Z",
            fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M189.965 177.962C187.667 176.884 184.78 178.725 183.411 176.452C185.161 177.166 184.929 167.993 182.042 170.166C181.693 171.593 180.855 171.418 182.332 171.908C179.851 171.924 182.158 173.5 182.075 173.724C180.723 173.757 182.49 174.52 181.204 174.255C180.457 174.404 182.639 176.295 181.162 175.789C180.689 177.846 178.383 177.829 178.897 179.081C178.872 178.227 171.206 178.028 173.33 181.295C174.674 181.229 174.5 182.738 174.699 180.773C175.106 183.211 176.01 180.773 176.226 180.831C176.425 182.199 176.823 180.309 176.765 181.644C176.964 182.365 178.258 180.06 178.001 181.569C182.473 182.738 178.806 183.999 181.386 186.537C181.643 187.714 181.013 191.537 183.776 191.181C187.41 190.136 183.17 183.609 185.327 182.473C186.29 181.611 187.659 180.524 189.476 181.262C190.372 181.279 191.525 177.622 189.974 177.953L189.965 177.962Z",
            fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M172.525 138.793C173.363 139.689 180.225 139.755 180.225 139.755C180.225 139.755 181.66 141.298 181.137 142.467C182.407 143.305 182.448 145.378 182.166 147.501C182.257 148.588 186.19 149.118 185.518 147.402C186.356 145.818 183.685 140.883 185.676 141.281C185.659 139.092 189.401 140.013 188.264 137.027C187.933 135.095 186.406 136.214 186.257 135.791C181.561 139.764 185.908 125.135 181.005 127.523C180.772 128.983 181.104 132.126 180.582 133.229C179.71 134.282 179.76 135.534 180.001 136.845C178.507 136.438 172.21 136.82 172.517 138.785L172.525 138.793Z",
            fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M130.892 130.293C128.178 129.613 127.374 132.723 126.95 127.457C126.552 125.035 124.76 125.707 124.146 126.511C123.773 126.992 124.934 129.281 124.478 129.497C124.478 129.497 124.528 131.388 124.652 132.416C124.52 131.321 120.354 131.918 118.43 132.731C118.43 132.731 117.061 134.398 119.002 135.418C119.118 135.385 122.852 134.912 123.914 135.319C125.656 136.546 124.312 136.861 124.627 138.188C124.943 139.507 124.909 145.337 128.66 141.937C128.801 139.283 128.776 138.769 128.295 135.12C128.892 134.116 129.805 133.395 131.182 133.627C131.912 133.411 132.053 129.704 130.9 130.293H130.892Z",
            fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M145.154 192.806C142.441 192.126 141.636 195.236 141.213 189.97C140.815 187.548 139.022 188.22 138.408 189.025C138.035 189.506 139.197 191.795 138.74 192.01C138.74 192.01 138.79 193.901 138.915 194.929C138.782 193.835 134.617 194.432 132.692 195.244C132.692 195.244 131.323 196.911 133.264 197.931C133.381 197.898 137.114 197.426 138.176 197.832C139.919 199.059 138.574 199.374 138.89 200.701C139.205 202.02 139.172 207.85 142.922 204.45C143.063 201.796 143.038 201.282 142.557 197.633C143.154 196.629 144.067 195.908 145.444 196.14C146.174 195.925 146.315 192.218 145.162 192.806H145.154Z",
            fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M146.631 115.598C146.73 115.614 151.584 114.644 151.061 116.037C152.082 117.472 151.202 120.822 152.903 121.212C157.4 121.461 154.455 118.674 155.201 116.775C156.944 117.397 158.993 114.379 157.085 113.068C156.703 113.657 155.766 112.446 155.857 113.159L155.849 112.853C155.177 113.383 154.778 113.508 153.998 112.43C153.301 113.989 155.649 107.363 151.949 108.673C151.277 109.22 152.463 112.33 150.97 112.173C149.784 112.869 148.124 112.363 146.996 112.844C146.067 113.242 145.519 114.196 146.647 115.598H146.631Z",
            fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M99.6953 164.411C99.7949 164.427 104.649 163.457 104.126 164.85C105.146 166.285 104.267 169.635 105.968 170.025C110.465 170.274 107.519 167.487 108.266 165.588C110.008 166.21 112.058 163.192 110.149 161.881C109.768 162.47 108.83 161.259 108.921 161.973L108.913 161.666C108.241 162.196 107.843 162.321 107.063 161.243C106.366 162.802 108.714 156.176 105.014 157.486C104.342 158.033 105.528 161.143 104.035 160.986C102.848 161.682 101.189 161.176 100.06 161.657C99.1311 162.055 98.5835 163.009 99.7119 164.411H99.6953Z",
            fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M175.072 182.158C177.371 183.236 180.258 181.395 181.627 183.667C179.876 182.954 180.109 192.126 182.996 189.954C183.344 188.527 184.182 188.701 182.705 188.212C185.186 188.195 182.88 186.62 182.963 186.396C184.315 186.363 182.548 185.6 183.834 185.865C184.581 185.716 182.398 183.825 183.875 184.331C184.348 182.274 186.655 182.291 186.14 181.039C186.165 181.893 193.832 182.092 191.708 178.824C190.363 178.891 190.538 177.381 190.339 179.347C189.932 176.909 189.028 179.347 188.812 179.289C188.613 177.92 188.215 179.811 188.273 178.476C188.074 177.754 186.779 180.06 187.036 178.551C182.564 177.381 186.232 176.121 183.651 173.583C183.394 172.405 184.025 168.582 181.262 168.939C177.628 169.984 181.867 176.51 179.71 177.647C178.748 178.509 177.379 179.595 175.562 178.857C174.666 178.841 173.513 182.498 175.064 182.166L175.072 182.158Z",
            fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }));
    const $936ceae5a4a545da$export$91862e78ed08ce2b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "229",
            height: "348",
            viewBox: "0 0 229 348",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M-17.712 223.275C25.1866 219.079 43.3717 192.967 43.3717 157.529C43.3717 124.889 26.5855 99.7089 -17.712 93.6471L-17.712 0.389389C91.8659 3.65341 156.68 62.4058 156.68 159.86C156.68 253.118 96.0624 317.932 -15.8469 317.932L-17.712 317.932L-17.712 223.275Z",
            fill: "#FCA700"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M-53.0385 204.302C-55.7656 201.702 -58.2371 198.874 -60.4691 195.838C-61.9722 194.501 -63.4991 193.184 -64.9488 191.79C-68.3729 187.463 -71.1376 182.829 -74.5539 178.482C-76.0293 176.194 -77.2453 173.75 -78.9148 171.594C-80.7764 169.09 -82.0795 166.235 -83.4797 163.46C-84.3114 161.804 -85.0303 160.095 -85.6462 158.347C-86.381 156.344 -86.9969 154.302 -87.5673 152.247C-88.1812 150.94 -88.7832 149.629 -89.3239 148.288C-89.916 144.689 -90.3201 141.065 -90.9855 137.481C-91.4509 135.292 -91.1875 133.056 -91.3419 130.842C-91.3677 128.04 -91.7499 125.131 -90.8746 122.426C-90.3557 120.52 -89.6071 118.69 -88.7813 116.902C-88.6248 115.617 -88.7892 114.185 -88.2545 112.993C-87.6762 111.943 -87.0424 110.929 -86.3849 109.927C-85.9334 108.806 -85.4957 107.675 -84.9333 106.606C-83.5252 104.584 -82.0359 102.619 -80.507 100.686C-79.6535 99.516 -78.8395 98.298 -77.8216 97.2603C-73.6765 92.9845 -68.88 89.4356 -63.7447 86.4352C-57.4549 82.5536 -50.6442 79.5493 -43.3978 78.0065C-40.6747 76.8084 -37.8665 75.9885 -34.9335 75.5033C-26.4354 73.7863 -17.7533 72.8158 -9.07898 72.8515C-2.17917 72.8753 4.69687 73.4931 11.561 74.1388C13.1196 74.4616 14.6584 74.923 16.2012 75.3211C18.3262 75.6518 20.473 75.8895 22.5504 76.4618C24.9883 77.1847 27.4777 77.6421 29.9731 78.1135C32.4545 78.6462 34.8924 79.377 37.3462 80.0246C41.3466 81.0386 45.1253 82.7576 48.9812 84.2132C56.487 86.7798 63.7809 89.9307 70.7164 93.7885C73.9762 95.3887 77.428 96.678 80.4601 98.6881C83.5258 100.831 86.7875 102.667 90.1384 104.322C91.5307 105.089 92.5823 106.228 93.8359 107.184C94.7726 107.677 95.7034 108.172 96.6362 108.673C98.076 109.337 99.0642 110.638 100.239 111.67C101.371 112.712 102.698 113.531 103.881 114.52C105.005 115.138 106.124 115.761 107.239 116.397C108.2 117.227 109.079 118.162 109.996 119.047C112.111 120.71 114.171 122.449 116.068 124.362C119.033 127.303 121.607 130.591 124.348 133.732C125.323 135.261 126.384 136.734 127.41 138.223C128.147 139.657 128.86 141.095 129.622 142.515C129.995 143.331 130.549 144.064 130.917 144.88C131.201 145.903 131.393 146.947 131.757 147.949C132.155 149.306 132.589 150.686 132.589 152.112C132.529 153.205 132.809 154.269 132.84 155.358C132.729 156.079 132.577 156.794 132.389 157.497C132.393 158.047 132.351 158.667 132.102 159.143C131.529 160.27 131.034 161.43 130.454 162.549C130.042 163.234 129.49 163.83 129.307 164.626C129.143 165.1 128.571 165.28 128.188 165.551C127.818 166.183 127.355 166.726 126.804 167.205C126.446 167.884 125.921 168.393 125.236 168.734C125.2 168.892 125.168 169.043 125.057 169.17C124.901 169.35 124.675 169.417 124.455 169.486C124.364 169.605 124.251 169.754 124.132 169.837C124.004 169.926 123.833 169.962 123.681 169.991C123.552 170.492 123.029 170.778 122.556 170.906C122.243 171.421 121.732 171.794 121.168 171.962C120.885 172.023 120.629 171.819 120.799 171.53C121.14 171.067 121.677 170.74 122.223 170.562C122.459 170.132 122.877 169.746 123.38 169.702C123.421 169.585 123.467 169.461 123.544 169.368C123.645 169.251 123.831 169.152 123.982 169.073C124.049 168.914 124.115 168.754 124.243 168.637C124.404 168.492 124.604 168.447 124.81 168.403C125.16 167.744 125.723 167.304 126.345 166.912C126.798 166.363 127.287 165.854 127.808 165.369C127.921 165.062 127.957 164.718 128.109 164.426C128.339 164.102 128.761 163.902 129.044 163.626C129.636 162.713 130.038 161.804 130.565 160.877C130.907 159.917 130.939 158.804 131.377 157.895C131.656 157.136 131.498 156.293 131.525 155.497C131.64 154.788 131.723 154.083 131.785 153.368C131.349 150.639 131.159 147.83 129.783 145.385C129.341 143.668 128.729 141.974 127.751 140.481C126.826 139.188 125.939 137.778 125.111 136.451C123.968 135.067 122.897 133.631 121.849 132.171C119.621 129.579 117.078 127.258 114.581 124.923C111.852 122.317 109.21 119.599 105.988 117.593C105.166 116.692 104.332 115.751 103.502 114.87C102.534 114.139 101.556 113.419 100.599 112.727C99.286 111.826 97.7967 111.204 96.4005 110.434C95.337 109.565 94.3092 108.644 93.2378 107.778C91.9802 107.131 90.7147 106.495 89.4492 105.867C86.1003 103.18 82.4405 101.021 78.5014 99.3357C75.6417 97.8227 72.9147 96.0423 70.045 94.5352C65.9277 92.6478 61.7946 90.7961 57.6059 89.0712C51.6053 86.354 45.4501 83.9854 39.0434 82.415C34.4726 80.8267 29.8008 79.5334 25.2042 78.0897C22.0157 77.5431 18.8965 76.9549 15.7516 76.2578C14.1217 76.1331 12.4918 76.032 10.86 75.9489C8.02003 75.4142 5.30882 75.0121 2.45304 74.8181C-9.58003 73.8556 -21.9775 74.3705 -33.7828 76.7529C-35.6108 77.1233 -37.407 77.6164 -39.2132 78.0759C-40.5737 78.2759 -41.9323 78.4937 -43.2869 78.7512C-45.8119 79.6562 -48.2954 80.6544 -50.5986 81.6981C-56.0349 83.9973 -61.5643 86.1996 -66.3113 89.7624C-69.9514 92.531 -73.3874 95.3927 -76.3343 98.8862C-78.7128 101.142 -80.7605 103.851 -82.1924 106.78C-82.8241 108.01 -83.7292 109.081 -84.3946 110.297C-84.6659 111.195 -84.9194 112.098 -85.1373 113.013C-85.1987 113.522 -85.4462 113.971 -85.7532 114.373C-86.3117 115.221 -86.8503 116.084 -87.3593 116.962C-87.6465 119.067 -87.8841 121.182 -88.0307 123.301C-88.203 125.038 -88.7238 126.525 -88.8664 128.216C-89.1773 130.385 -89.1952 132.565 -88.9456 134.74C-88.7971 136.39 -88.9357 138.069 -88.6763 139.711C-88.3436 142.151 -87.694 144.484 -86.7988 146.769C-86.2958 148.31 -86.28 149.997 -85.8859 151.579C-84.4303 155.404 -82.6419 159.026 -80.9071 162.717C-79.9129 164.844 -78.6969 166.856 -77.6374 168.946C-76.564 171.409 -75.2965 173.75 -73.6508 175.883C-72.2288 177.784 -71.0386 179.846 -69.6543 181.777C-67.2619 184.561 -64.8181 187.302 -62.3802 190.045C-61.3266 191.689 -60.2809 193.297 -59.1759 194.893C-57.3321 196.725 -55.1497 198.508 -53.4247 200.419C-51.1155 202.649 -49.0717 205.108 -46.9566 207.521C-45.5169 208.727 -44.0612 209.917 -42.5918 211.089C-39.4944 213.798 -36.4465 216.573 -33.2125 219.13C-30.8261 221.009 -28.2911 222.685 -25.9067 224.558C-23.1796 226.671 -20.3219 228.598 -17.4443 230.493C-14.2895 232.777 -11.0455 234.908 -7.60158 236.732C-5.39736 237.946 -3.65063 239.851 -1.61673 241.326C3.69873 244.392 9.21423 247.012 14.6644 249.721C18.6906 251.712 22.7623 253.597 26.9291 255.284C31.9951 257.705 36.758 260.756 41.9467 262.923C44.5747 264.145 47.3216 265.066 50.0486 266.034C55.1383 268.066 60.1865 270.243 65.4445 271.813C73.8098 274.582 82.4385 276.354 90.9781 278.465C96.1926 279.743 101.49 280.731 106.855 281.078C111.313 281.539 115.779 282.004 120.259 282.171C122.631 282.139 124.954 281.86 127.289 281.6C133.227 281.485 139.186 280.806 144.913 279.19C146.387 278.794 147.876 278.453 149.333 278.002C150.658 277.358 151.914 276.582 153.217 275.905C155.819 275.049 158.356 273.982 160.756 272.651C162.701 271.165 164.81 269.421 166.737 268.032C169.601 265.454 171.932 262.335 174.312 259.321C175.352 257.897 176.519 256.568 177.525 255.118C179.091 252.106 180.648 249.024 181.434 245.703C182.098 242.659 183.197 239.73 183.749 236.659C184.468 233.151 184.72 229.561 184.547 225.986C184.569 224.015 185.227 222.079 185.379 220.108C185.003 219.173 184.611 218.247 184.211 217.324C183.866 216.476 183.339 215.751 183.43 214.797C183.395 213.085 183.51 211.351 183.282 209.653C183.044 208.053 182.735 206.548 182.426 204.976C182.216 203.098 182.074 201.205 181.799 199.329C180.925 196.721 179.911 194.17 179.006 191.574C176.479 184.9 174.917 177.84 171.649 171.467C168.876 165.557 165.012 160.256 161.972 154.499C161.368 153.348 160.753 152.205 160.121 151.066C158.871 149.369 157.562 147.716 156.299 146.032C155.217 144.238 154.12 142.456 152.979 140.701C151.985 139.501 150.981 138.307 149.965 137.124C146.804 133.445 143.762 129.666 140.614 125.978C139.047 124.491 137.455 123.03 135.859 121.572C134.421 119.893 133.056 118.128 131.589 116.462C130.078 114.951 128.551 113.456 127.004 111.977C123.917 108.85 120.631 105.944 117.136 103.277C115.496 101.823 113.844 100.385 112.163 98.9773C110.382 97.7237 108.588 96.4998 106.782 95.2877C102.726 91.6041 98.381 88.2493 93.7666 85.2945C89.1878 82.3318 84.7121 79.2027 80.0541 76.3628C78.1331 75.4755 76.2002 74.616 74.2594 73.7763C71.061 72.0316 67.7933 70.3007 64.5553 68.7144C62.0817 67.4449 59.4042 66.6329 56.8395 65.5853C53.5184 63.8881 50.1655 62.3453 46.7275 60.9154C44.8401 60.4421 42.9488 60.0005 41.0555 59.5569C39.2494 58.8756 37.469 58.129 35.6549 57.4636C32.8902 56.6952 30.0998 56.0198 27.3034 55.3821C18.0489 52.6987 8.52702 51.1658 -0.901798 49.2309C-1.3771 49.1359 -1.5692 48.6388 -1.37512 48.2189C-1.13549 47.702 -0.513629 47.4129 0.0369304 47.5238C12.272 50.1697 24.8002 51.7738 36.6926 55.796C39.3365 56.5149 42.1012 56.9189 44.545 58.2141C48.8604 60.4223 53.655 61.3947 58.1783 63.09C60.3231 63.9277 62.3174 65.1298 64.379 66.1576C67.411 67.5023 70.4233 68.8946 73.3939 70.368C76.1804 71.6177 78.6559 73.4159 81.1711 75.127C83.7793 76.4955 86.3697 77.9016 88.9165 79.3869C93.8517 82.2031 98.4622 85.5381 103.146 88.7444C105.318 90.2674 107.725 91.4774 109.796 93.133C111.157 94.3352 112.497 95.561 113.83 96.7988C115.486 98.2524 117.286 99.5496 118.968 100.978C120.772 102.52 122.423 104.235 124.129 105.881C125.75 107.337 127.392 108.776 128.981 110.27C130.719 111.87 132.308 113.628 134.041 115.231C135.591 116.615 137.158 117.983 138.657 119.419C140.15 121.237 141.457 123.206 142.966 125.004C146.64 129.026 150.12 133.235 153.138 137.774C154.714 140.301 156.823 142.426 158.604 144.808C159.675 146.553 160.711 148.318 161.731 150.094C162.994 151.785 164.294 153.457 165.494 155.192C168.528 160.095 170.88 165.363 173.356 170.56C175.691 175.651 178.452 180.555 180.434 185.801C182.05 189.924 182.88 194.315 183.624 198.668C184.316 200.742 185.246 202.762 185.621 204.926C186.049 207.659 186.494 210.374 187.211 213.048C187.306 213.495 187.425 213.939 187.496 214.391C187.488 215.143 187.213 215.874 187.086 216.611C186.849 217.712 186.585 218.803 186.312 219.896C186.68 221.944 187.54 223.968 187.274 226.063C186.874 230.222 186.377 234.375 185.769 238.508C185.524 240.033 185.237 241.548 184.9 243.053C184.528 244.598 183.795 246.032 183.177 247.493C182.008 250.266 180.723 252.993 179.107 255.536C177.069 260.342 173.647 264.39 169.678 267.733C168.13 268.973 166.779 270.431 165.228 271.668C164.068 272.453 162.87 273.18 161.652 273.867C159.214 275.604 156.683 277.235 154.017 278.598C152.619 279.046 151.185 279.37 149.749 279.689C148.616 280.145 147.476 280.584 146.327 280.996C139.861 283.003 133.05 283.801 126.329 284.371C122.594 284.284 118.866 284.062 115.125 284.088C108.556 284.038 101.855 282.894 95.444 281.767C91.493 281.103 87.5342 280.444 83.6307 279.547C77.834 278.004 72.3839 276.265 66.7813 274.421C58.9447 271.615 50.8646 269.405 43.3726 265.715C39.9524 264.331 36.5461 262.901 33.1596 261.432C29.878 259.956 26.4598 258.752 23.3248 256.976C20.2769 255.247 17.0943 253.775 13.9375 252.258C9.24195 249.69 4.75232 246.777 0.191408 243.982C-0.71563 243.42 -1.61871 242.853 -2.5218 242.283C-5.27855 240.976 -8.24721 240.035 -10.6316 238.082C-13.0557 236.245 -15.5946 234.589 -18.1454 232.937C-21.2329 230.86 -24.1461 228.549 -27.1761 226.39C-31.7034 223.023 -35.9197 219.262 -40.3242 215.741C-43.1166 213.539 -45.6377 211.03 -48.0518 208.426C-49.7134 207.057 -51.47 205.78 -53.0405 204.308L-53.0385 204.302Z",
            fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M21.4958 155.939C21.8541 154.991 23.0616 155.369 23.7123 155.757C24.6372 156.182 25.5454 156.643 26.5067 156.988C29.3333 152.853 30.9243 147.991 33.6697 143.811C34.158 143.236 35.0857 143.573 35.6189 143.903C36.562 144.549 36.5214 145.893 36.3815 146.871C36.3339 148.146 36.3815 149.401 36.7201 150.637C36.979 151.916 37.6058 153.1 37.8465 154.381C38.3461 156.915 38.4706 159.49 38.7197 162.055C39.5383 162.25 40.3708 162.377 41.1754 162.626C41.9464 161.758 42.4362 160.685 43.175 159.798C44.3644 158.34 45.8784 157.376 47.5534 156.559C48.8841 155.923 50.2302 155.312 51.5763 154.714C52.9252 153.858 54.7317 153.879 55.9421 154.982C57.645 156.658 55.9169 159.43 54.7975 160.985C53.5871 162.56 51.9975 163.905 50.0735 164.494C52.7895 165.662 54.8996 167.806 57.3092 169.468C58.7869 170.496 60.154 171.695 61.7128 172.597C62.7972 173.226 62.3732 174.423 61.1531 174.383C60.424 174.386 59.8335 173.936 59.2738 173.529C58.1292 173.2 56.986 172.866 55.8666 172.459C53.9075 171.752 52.0003 170.925 49.9644 170.454C48.5986 169.985 47.2371 169.524 45.7959 169.351C46.5025 169.906 47.2092 170.462 47.9144 171.019C49.6635 171.986 51.5232 172.831 52.9896 174.213C53.6613 174.714 54.0741 175.589 54.8829 175.874C55.2369 175.977 55.6609 176.171 55.7014 176.588C55.735 177.019 55.2816 177.204 54.915 177.194C54.568 177.219 54.1944 177.081 53.9873 176.808C53.5479 176.571 53.1323 176.287 52.6692 176.088C50.6654 175.053 48.5259 174.275 46.6033 173.088C46.045 172.755 45.4838 172.424 44.9255 172.094C44.3798 171.94 43.8033 171.825 43.3485 171.464C42.821 171.089 43.2967 170.498 43.8383 170.698C44.3924 170.83 44.8332 171.199 45.2851 171.528C46.9559 172.169 48.6336 172.774 50.184 173.678C49.2409 172.989 48.3888 172.2 47.503 171.443C46.3514 170.84 45.1998 170.237 44.051 169.631C43.0715 168.923 41.9087 168.965 40.7528 168.858C41.3308 170.35 42.0822 171.774 42.5873 173.293C43.3079 175.534 43.8411 177.833 44.5547 180.075C45.1088 181.635 45.6434 183.148 46.1569 184.581C46.4228 185.322 46.5949 185.805 46.8439 186.494C46.9265 186.723 46.9531 186.947 46.8327 187.172C46.2884 188.016 44.8374 187.642 44.5505 186.751C43.7361 184.466 42.9315 182.18 42.1213 179.893C40.8032 176.785 39.4109 173.683 38.8554 170.33C37.8899 171.22 36.7271 171.868 35.6762 172.657C34.5022 174.149 33.3674 175.674 32.1822 177.158C31.7988 177.643 31.4574 178.196 30.8795 178.467C30.1253 178.88 28.7679 178.337 28.9722 177.351C29.0464 176.501 29.8244 176.045 30.4275 175.555C31.3482 174.419 32.2844 173.314 32.9882 172.024C33.5381 171.078 34.235 170.224 34.8646 169.331C35.1599 168.903 35.4719 168.496 35.8889 168.178C32.5124 167.456 29.1332 166.726 25.7287 166.152C24.5687 165.902 22.8741 166.012 22.3186 164.74C22.0234 163.587 22.4264 162.219 23.098 161.263C23.7585 160.282 24.3896 159.282 25.2222 158.434C24.3546 158.012 23.5304 157.489 22.6041 157.204C22.0178 157.132 21.3181 156.588 21.4986 155.937L21.4958 155.939ZM24.1909 164.642C28.8281 165.325 33.5157 165.685 38.1684 166.168C38.153 166.102 38.139 166.037 38.1236 165.972C34.5428 164.102 31.4854 161.381 27.8066 159.689C27.3365 161.042 26.4171 162.143 25.6349 163.326C25.1844 163.8 24.5967 164.127 24.1895 164.644L24.1909 164.642ZM33.1785 149.713C31.7918 152.524 30.0525 155.144 28.5776 157.908C30.261 158.772 31.9247 159.668 33.5815 160.583C34.6771 160.913 35.7686 161.257 36.867 161.576C36.3689 160.022 35.7252 158.509 35.2508 156.949C35.1151 156.105 34.9962 155.257 34.866 154.412C34.6575 151.954 35.1893 149.439 34.4672 147.028C34.0433 147.926 33.6249 148.829 33.1771 149.715L33.1785 149.713ZM31.4364 160.831C33.5409 161.896 35.6958 162.883 37.7024 164.127C37.6772 164.018 37.652 163.91 37.6282 163.801C37.5835 163.607 37.5107 163.414 37.4393 163.223C35.4509 162.387 33.5395 161.355 31.4364 160.831ZM39.7859 164.172C39.5005 164.069 39.2178 163.961 38.9352 163.849C39.0583 164.225 39.1814 164.602 39.3032 164.978C39.5089 164.726 39.7118 164.472 39.9147 164.216C39.8713 164.202 39.8279 164.188 39.7845 164.172L39.7859 164.172ZM42.3298 167.004C46.5963 168.606 51.2769 168.753 55.6147 170.186C53.748 168.73 51.7373 167.522 49.7307 166.299C48.8687 165.749 47.9536 165.279 46.9699 164.994C46.3304 165.008 45.6937 165.047 45.0515 165.029C43.967 165.384 43.1302 166.226 42.3298 167.006L42.3298 167.004ZM43.4283 163.128C46.4927 163.72 51.1663 163.356 53.047 160.528C53.7718 159.136 54.2084 157.276 53.3996 155.839C52.6468 155.497 51.6883 155.844 50.9858 156.178C49.5684 157.198 48.4405 158.54 47.3799 159.911C46.1485 161.085 44.7688 162.084 43.4283 163.128Z",
            fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }));
    const $936ceae5a4a545da$export$668799e4797757a8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            fill: "none",
            viewBox: "0 0 708 668",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12ft3m1 _1ul91pna"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#BF63F3",
            d: "m4.069 90.41 590.332-41.28 33.37 477.195-590.333 41.28z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#1868DB",
            d: "M351.104 188h421.728v458.717H351.104z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#1228D1",
            fillRule: "evenodd",
            d: "m604.112 188 23.658 338.325-276.666 19.346V188h253.008Z",
            clipRule: "evenodd"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#FCA700",
            fillRule: "evenodd",
            d: "M222.378 554.723c-24.674-74.653-85.271-135.819-166.89-157.689a243.661 243.661 0 0 0-30.343-6.104L32.38 494.4c37.444 10.839 67.076 35.898 84.576 67.694l105.422-7.371Z",
            clipRule: "evenodd"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-neutral-bold-pressed, #172B4D)",
            d: "M43.894 585.588c.355-.056 3.156 8.9 3.127 12.736 1.357.554 2.753 2.283 3.061 4.271 5.853 3.055.847-6.33-.779-9.234-.483 2.205-.754-3.129-1.567-3.824.123.437-2.432-8.271-3.66-5.551-.264-.239-.568 1.923-.189 1.599l.007.003ZM25.547 598.159c.7 1.901.146 3.691-.95 5.484 2.085 6.623 5.445-4.93 6.223-7.742 0 0 1.471-4.908 1.6-4.353.826-.489 4.652-7.588 1.377-6.909-.764 1.133-1.192 3.693-2.22 3.829-2.197.857-3.66 7.484-6.026 9.701l-.004-.01ZM6.053 583.065c-.322 4.42 7.291-.05 10.474-.712 0 0 3.337-.507 4.148-1.227-.485.073 11.23-2.412 4.615-3.693-.157.082-4.215.936-4.215.936-5.59-.444-10.942 2.067-15.025 4.703l.003-.007Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-lime-subtle, #94C748)",
            d: "M326.048 626.989a100.386 100.386 0 0 1-17.178 3.843c-2.96 1.059-5.911 2.165-8.91 3.108-8.501 1.45-16.928 1.767-25.451 3.192-4.243.308-8.505.143-12.714.815-4.829.676-9.722.322-14.576.161a68.394 68.394 0 0 1-8.637-.863c-3.296-.494-6.558-1.18-9.804-1.939-2.253-.138-4.502-.296-6.746-.56-5.378-1.886-10.65-4.049-16.065-5.824-3.349-1.003-6.218-3.041-9.37-4.489-3.862-2.066-8.138-3.723-11.191-6.952-2.223-2.14-4.171-4.538-6.004-7.012-1.645-1.178-3.732-2.026-4.966-3.653-1.006-1.58-1.921-3.209-2.802-4.862-1.198-1.46-2.421-2.908-3.466-4.481-1.716-3.447-3.294-6.962-4.798-10.508-.965-2.048-2.025-4.077-2.684-6.251-2.756-8.89-4.026-18.128-4.289-27.419-.607-11.535.38-23.127 3.698-34.22.399-4.633 1.38-9.098 2.914-13.484 4.017-12.94 9.196-25.573 15.749-37.441 5.206-9.443 11.209-18.409 17.241-27.337 1.611-1.895 3.397-3.659 5.1-5.476 2.047-2.666 3.982-5.432 6.325-7.851 2.819-2.801 5.313-5.872 7.83-8.94 2.591-3.003 5.421-5.798 8.149-8.677 4.39-4.726 9.58-8.618 14.467-12.814 9.147-8.368 18.937-16.007 29.427-22.625 4.638-3.27 8.994-7.037 14.024-9.687 5.237-2.597 10.2-5.693 14.983-9.047 2.095-1.334 4.445-1.922 6.696-2.924 1.379-.915 2.756-1.82 4.142-2.723 1.989-1.477 4.514-1.857 6.81-2.694 2.278-.772 4.397-1.977 6.638-2.857a377.842 377.842 0 0 1 5.093-3.198c1.858-.695 3.799-1.2 5.701-1.793 3.867-1.653 7.795-3.174 11.841-4.341 6.256-1.86 12.694-2.925 19.056-4.329 2.827-.19 5.644-.54 8.455-.831 2.518.065 5.025.166 7.543.185 1.398.101 2.819-.11 4.214-.003 1.616.379 3.191.898 4.839 1.15 2.158.471 4.376.912 6.332 1.981 1.454.901 3.122 1.315 4.639 2.089a31.065 31.065 0 0 1 2.594 2.222c.758.408 1.577.93 2.042 1.628 1.116 1.63 2.336 3.179 3.435 4.814.631 1.078 1.034 2.283 1.989 3.13.526.58.344 1.5.43 2.227a10.34 10.34 0 0 1 1.229 3.139 5.45 5.45 0 0 1 .921 3.297c.19.167.373.324.463.571.13.349.053.709-.017 1.063.095.214.214.48.239.705.026.244-.053.504-.127.735.591.553.59 1.483.412 2.229.471.815.598 1.795.406 2.695-.128.434-.599.632-.868.181-.38-.814-.426-1.795-.26-2.678-.413-.646-.629-1.508-.312-2.231-.129-.144-.266-.3-.336-.476-.084-.226-.08-.556-.076-.821-.167-.212-.338-.421-.401-.686-.078-.328.009-.636.104-.951-.642-.976-.823-2.077-.894-3.223a25.397 25.397 0 0 1-1.018-3.164c-.337-.385-.782-.692-1.067-1.119-.273-.559-.231-1.287-.397-1.882-.808-1.497-1.753-2.729-2.629-4.147-1.06-1.19-2.562-2.068-3.48-3.349-.831-.952-2.107-1.367-3.178-2.002a44.557 44.557 0 0 0-2.724-1.952c-4.069-1.449-8.063-3.294-12.448-3.24-2.686-.682-5.467-1.113-8.248-.891-2.467.299-5.065.458-7.506.598-2.755.529-5.527.922-8.314 1.264-5.225 1.111-10.314 2.858-15.388 4.532-5.62 1.788-11.327 3.373-16.494 6.287-1.852.452-3.767.89-5.598 1.367-1.728.78-3.45 1.581-5.115 2.374-2.22 1.125-4.189 2.701-6.292 4.038-1.99.806-4.023 1.525-6.013 2.345a451.134 451.134 0 0 0-5.462 3.762c-6.196 2.578-11.9 5.978-17.164 10.115-4.219 2.787-8.705 5.192-12.924 7.997-5.675 4.23-11.313 8.509-16.819 12.96-8.225 6.191-16.088 12.855-23.045 20.463-5.605 5.076-10.881 10.513-16.307 15.733-3.14 3.963-6.286 7.799-9.6 11.589a300.024 300.024 0 0 0-4.091 6.476c-2.863 3.493-5.447 6.909-7.854 10.68-10.342 15.778-18.931 33.164-24.516 51.138-.863 2.784-1.533 5.617-2.258 8.438a156.1 156.1 0 0 0-2.128 6.093 152.853 152.853 0 0 0-1.441 12.235c-.924 9.179-2.05 18.412-.724 27.593 1.068 7.067 2.415 13.924 4.996 20.585 1.31 4.952 3.49 9.792 6.432 13.951 1.213 1.789 2.004 3.833 3.172 5.657a72.49 72.49 0 0 0 3.167 3.054c.651.466 1.082 1.143 1.403 1.865a84.73 84.73 0 0 0 2.345 4.143c2.672 1.972 5.394 3.884 8.19 5.674 2.252 1.538 3.901 3.368 6.113 4.831a39.697 39.697 0 0 0 8.886 5c2.374 1.034 4.573 2.483 7.018 3.358 3.596 1.373 7.282 2.232 11.087 2.718 2.49.465 4.815 1.709 7.28 2.355 6.336.871 12.644 1.135 19.006 1.524 3.662.231 7.333.073 10.992.186 4.184.376 8.344.393 12.502-.265 3.674-.524 7.393-.61 11.079-1.061 5.612-1.192 11.202-2.488 16.792-3.775 3.043-.212 6.033-.44 9.05-.759 3.894-1.154 7.975-2.811 11.889-3.743 4.789-1.494 9.694-2.453 14.588-3.544a370.752 370.752 0 0 0 8.166-3.31c6.037-2.216 12.127-4.315 18.058-6.832 4.366-1.864 8.564-4.083 12.921-5.948 4.943-2.155 9.728-4.629 14.484-7.154 5.497-2.614 10.851-5.464 15.934-8.819 3.318-2.112 7.24-3.079 10.788-4.762 8.189-4.99 15.917-10.589 23.719-16.031 5.748-4.028 11.386-8.198 16.824-12.646 7.117-5.133 14.873-9.375 21.734-14.866 3.646-2.687 6.968-5.763 10.341-8.777 6.603-5.455 13.372-10.746 19.468-16.778 10.069-9.395 18.969-19.898 28.267-30.025 5.661-6.193 10.988-12.716 15.486-19.813 3.975-5.767 7.962-11.541 11.549-17.559 1.735-3.277 3.094-6.672 4.489-10.069 4.294-8.227 7.831-16.908 9.909-25.973.562-2.318 1.211-4.615 1.685-6.952.111-2.3-.012-4.603.036-6.898.778-4.21 1.217-8.489 1.191-12.778-.578-3.781-1.389-7.981-1.848-11.664-1.389-5.86-3.918-11.395-6.266-16.92-1.173-2.493-2.121-5.089-3.354-7.555-2.956-4.407-6.015-8.852-9.979-12.42-3.677-3.192-6.869-6.896-10.667-9.956-4.27-3.616-9.005-6.653-14.036-9.097-2.686-1.507-4.849-3.861-7.436-5.548a176.89 176.89 0 0 0-4.695-.485c-1.42-.163-2.809.016-4.05-.825-2.373-1.234-4.666-2.692-7.164-3.653-2.372-.874-4.668-1.578-7.055-2.334-2.732-1.12-5.435-2.344-8.213-3.372-4.232-.758-8.49-1.281-12.729-1.986-11.046-1.539-21.899-4.69-33.088-4.988-10.182-.629-20.349.694-30.523.546-2.03-.034-4.059-.047-6.094-.034-3.264.441-6.513.996-9.769 1.467-3.271.137-6.538.305-9.799.554-2.391.463-4.782.944-7.165 1.451-7.415 1.575-14.878 2.913-22.295 4.466a522.826 522.826 0 0 0-9.608 3.217c-3.38.712-6.823 1.26-10.207 2.023-3.205.939-6.4 1.912-9.589 2.924a146.917 146.917 0 0 0-19.329 7.009 361.298 361.298 0 0 0-9.624 3.595 450.444 450.444 0 0 0-9.094 4.612c-8.092 2.8-15.95 6.242-23.462 10.354-7.495 4.057-15.142 7.849-22.529 12.106a410.8 410.8 0 0 0-7.891 6.007c-4.791 3.078-9.614 6.261-14.217 9.511-3.595 2.44-6.716 5.503-10.076 8.234a221.902 221.902 0 0 0-13.985 10.365c-2.064 2.233-4.088 4.495-6.116 6.759-2.288 1.966-4.647 3.847-6.92 5.836-3.126 3.215-6.145 6.535-9.116 9.891-10.618 10.678-19.86 22.586-29.582 34.064-.487.58-1.313.471-1.743-.11-.529-.716-.459-1.785.106-2.457 12.801-14.794 24.394-30.77 38.827-44.061 2.968-3.087 5.595-6.575 9.203-8.955 6.264-4.262 11.192-10.107 16.908-15.039 2.757-2.312 5.901-4.146 8.856-6.202 4.117-3.149 8.285-6.236 12.533-9.205 3.802-2.884 8.124-4.93 12.356-7.096 3.833-2.55 7.703-5.048 11.649-7.427 7.562-4.655 15.592-8.477 23.501-12.495 3.717-1.837 7.18-4.23 11.004-5.829a345.74 345.74 0 0 1 8.051-2.783c3.235-1.18 6.363-2.676 9.582-3.911 3.468-1.317 7.058-2.296 10.593-3.401 3.213-1.132 6.418-2.304 9.656-3.362 3.498-1.185 7.101-2.044 10.597-3.219 3.061-1.089 6.112-2.211 9.205-3.19 3.612-.684 7.292-1 10.889-1.722 8.27-2.021 16.65-3.637 25.137-4.372 4.647-.267 9.142-1.566 13.744-2.221 3.196-.161 6.392-.258 9.593-.325 3.266-.464 6.532-.993 9.811-1.338 8.999-.483 17.987.24 26.968.742 8.733.616 17.527.507 26.207 1.722 6.866.876 13.508 3.03 20.036 5.273 3.361.607 6.829.845 10.078 1.955 4.068 1.462 8.125 2.887 12.329 3.909.685.205 1.382.375 2.055.615 1.026.576 1.822 1.501 2.737 2.227a165.76 165.76 0 0 1 3.925 3.525c3.084 1.031 6.504 1.37 9.178 3.305a389.078 389.078 0 0 1 15.936 11.395 119.388 119.388 0 0 1 5.581 4.6c1.839 1.668 3.255 3.748 4.796 5.691 2.926 3.681 5.702 7.489 7.977 11.611 5.063 6.398 8.048 14.126 9.656 22.075.539 3.053 1.525 5.998 2.059 9.052a81.1 81.1 0 0 1 .333 6.553c.554 4.645.894 9.339.763 14.016-.434 2.253-1.064 4.463-1.703 6.671a150.288 150.288 0 0 1-.774 5.672c-2.097 10.371-6.109 20.308-10.367 29.953-2.92 5.056-6.019 10.001-8.788 15.15-4.994 8.971-11.588 17.302-17.94 25.248-3.872 4.92-7.745 9.854-11.902 14.534-6.461 6.792-12.932 12.961-19.661 19.261-9.724 8.642-18.813 18.065-29.49 25.572a696.524 696.524 0 0 1-13.531 10.792c-4.484 3.394-8.698 7.178-13.484 10.145-4.656 2.883-9.06 6.144-13.507 9.335-7.043 4.513-14.404 8.485-21.656 12.644a580.174 580.174 0 0 1-4.364 2.446c-3.859 2.8-7.375 6.166-11.841 7.971-4.337 1.946-8.511 4.186-12.689 6.446-5.163 2.676-10.517 4.938-15.749 7.474-8.011 3.684-16.329 6.645-24.46 10.045-5.113 2.178-10.444 3.753-15.825 5.111-3.123 1.252-6.191 2.703-9.387 3.753l-.006-.007Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M58.5 126.242h426v221h-426z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
            d: "M82.5 150.242h24v24h-24z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fill: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
            clipPath: "url(#a)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M137.403 165.089c-.376.089-.371-.674-.424-.817.048.143.048.906.424.812v.005Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M194.807 162.553c-.605.158-1.561.478-3.03.965-.044-.019-.171-.02-.2-.059-1.546.571-3.21.734-4.869.749-1.664.019-3.337-.089-5.064-.094.039.148-.078.256-.181.177l.044-.177c-2.327.281-3.717-.419-5.888-.039l.273-.212a58.17 58.17 0 0 1-2.81-.345 1.469 1.469 0 0 1-.249-.044 1.485 1.485 0 0 1-.542-.256 1.443 1.443 0 0 1-.488-.64l-.136-.37-.171-.418a8.98 8.98 0 0 0-.429-.872c-.342-.586-.844-1.236-1.615-1.674-.776-.453-1.698-.517-2.425-.413-.376.049-.707.142-1.044.236l-.498.182c-.107.054-.248.069-.346.158l-.302.216-.635.453-.317.227-.327.202-.653.404c-.22.128-.449.231-.669.349-.444.251-.907.394-1.356.591-.464.128-.917.286-1.376.345a7.71 7.71 0 0 1-2.727-.01c-.898-.158-1.771-.488-2.62-.872l.024.04-.024.014c.268.242 1.127.769 1.971 1.094.215.073.419.147.61.216.195.049.375.094.532.128.307.089.512.099.512.099-.625.187-1.303.157-1.966.01a7.072 7.072 0 0 1-1.913-.828c-1.22-.724-2.303-1.718-3.542-2.457l.137-.187c1.058.665 2.015 1.152 2.429 1.266-.883-.601-1.966-1.423-3.346-2.255a12.005 12.005 0 0 0-2.367-1.123c-.439-.163-.927-.261-1.414-.35l-.757-.059c-.253-.024-.512.015-.766.02-1.014.093-2.015.384-2.829.847a8.651 8.651 0 0 0-1.015.62 5.132 5.132 0 0 0-1.083-.335c-1.303-.256-2.542-.098-3.645.187-2.215.601-3.995 1.675-5.474 2.679a28.06 28.06 0 0 0-3.429 2.802c-1.596 1.58-1.874 2.211.009 1.093l-.044.29c1.742-1.359 3.259-2.452 5.391-3.299.259-.187.308-.177.215-.344.059-.069.156-.187.088-.242-.259-.394.468-.586.746-.733.171.758 1.698-.099 3.494-.591a6.914 6.914 0 0 1 2.234-.271c-.166.167-.327.33-.493.492-.131.133-.263.261-.414.454a4.3 4.3 0 0 0-.391.536 4.87 4.87 0 0 0-.736 2.196c.102-.059.117-.512.278-.98.17-.458.473-.911.829-.906-.727 1.094-.868 2.472-.6 3.644-.376.089-.376-.67-.424-.812-.015.069-.02.182-.015.334 0 .153.015.35.058.577.079.453.254 1.068.674 1.703.112.153.229.31.361.473.141.148.283.31.453.448.337.281.708.561 1.264.763.268.104.629.172.966.177.346 0 .693-.069 1.03-.206a3.07 3.07 0 0 0 .907-.626c.239-.241.429-.507.585-.778.601-1.088.757-2.245.688-3.427-.087-1.177-.444-2.412-1.239-3.496-.019-.029-.049-.054-.068-.083.2-.099.4-.188.605-.266a4.307 4.307 0 0 1 2.103-.271c1.453.153 3 1.034 4.581 1.999 1.595.96 3.278 2.043 5.244 2.654.976.295 2.001.492 3.03.492 1.02-.014 2.039-.123 2.971-.418 1.888-.532 3.508-1.458 4.933-2.413l.268-.177.054-.035-.005.005c.01 0 .019-.009.029-.009h.039l.108-.04c.078-.02.156-.054.229-.064.293-.059.58-.103.785-.064.43.064.517.217.717.552l.035-.089c.009.054.141.157.083.256.156.103.356.335.556.65.102.158.2.34.297.527.127.276.303.586.488.832.381.512.839.862 1.191 1.068.351.207.59.291.59.291.337.123.693.197 1.034.226l.796.035c.531.029 1.063.034 1.59.049 0 0 1.351.256 2.996.389 1.639.138 3.571.163 4.669-.128 2.741.108 5.508.01 8.269-.438 0 0 .215-.044.547-.148.331-.103.785-.221 1.258-.409.952-.349 1.971-.896 2.371-1.27.488-.497.718-.911.674-1.162-.044-.251-.366-.345-.976-.197Zm-54.594 4.54c-.19-.084-.288-.168-.263-.212.019-.044.175-.039.415-.069a2.533 2.533 0 0 1-.596-.492 2.672 2.672 0 0 1-.468-.67c-.132-.241-.205-.512-.263-.783a3.051 3.051 0 0 1 .619-2.437c.083-.123.195-.207.303-.33.146-.128.292-.256.439-.389.146-.128.292-.266.439-.389l.356-.271c.078.094.166.192.259.301.331.379.639.886.585 1.201a2.866 2.866 0 0 0-.303-.226c-.053.152.161.689.274 1.467.122.763.102 1.807-.274 2.575-.185.384-.439.64-.746.748a1.071 1.071 0 0 1-.776-.029v.005Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M82.5 187.242h378v40h-378z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            stroke: "var(--ds-border, #091E4224)",
            d: "M83 187.742h377v39H83z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
            d: "M90.5 199.242h16v16h-16z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)",
            d: "M202.95 206.951c-13.865 2.577-24.095-4.017-38.098 1.392-.654-2.317-2.344-5.218-4.873-5.261 2.11.053 5.484 6.106 2.094 2.052-1.993-3.088-10.703.685-4.028-1.999-4.608.569-8.833 4.326-11.947 7.669-5.181 4.761-1.249-4.453-4.995-9.087-5.309-6.441-21.422 10.309-18.175 10.32 2.067-2.099 4.841-3.407 5.989-5.734 20.21-13.78 5.628 11.723 17.665 7.45 19.662-17.712 9.725-1.679 21.267-2.774 6.728-6.419 35.334 3.646 35.106-4.028h-.005Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "55.941",
            height: "24",
            x: "324.618",
            y: "195.242",
            fill: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
            rx: "3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#b)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#77B255",
            d: "M342.801 205.642a7.76 7.76 0 0 0-1.28 1.076c-.056-1.887-.51-4.327-3.01-5.521-.494-2.691-6.263-1.324-5.747-1.063 1.029.52 1.576 1.844 2.237 2.54 1.18 1.241 2.491 1.317 3.143.346 1.541 1.002 1.643 2.902 1.596 4.933-.006.224-.011.433-.011.623v6.222c0 .491 1.778.491 1.778 0v-5.107c.241-.424.943-1.557 1.969-2.352.705.619 1.841.421 2.873-.665.661-.696 1.019-2.019 2.047-2.54.543-.275-5.689-1.775-5.595 1.508Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-lime-subtle, #94C748)",
            d: "M371.685 205.685c-.008-.045-1.459-.543-2.196-.424.008.216-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.075c.156.275-.29.625-.878.684v-.35a.678.678 0 0 0 .573-.305s-3.796.313-3.773.209c-.365-.618-7.8-1.206-6.021 1.191 0 0 3.751 1.146 3.743 1.183.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.342.216-.737.238-1.109.038-.752-.201-1.369-.885-1.101l.015.007Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "55.941",
            height: "24",
            x: "396.559",
            y: "195.242",
            fill: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            rx: "3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#c)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#DD2E44",
            d: "M420.508 204.502a4.385 4.385 0 0 0-4.385-4.386 4.38 4.38 0 0 0-3.564 1.835 4.378 4.378 0 0 0-3.563-1.835 4.386 4.386 0 0 0-4.386 4.386c0 .343.044.675.119.996.608 3.783 4.815 7.775 7.83 8.871 3.015-1.096 7.222-5.088 7.83-8.871.076-.32.119-.653.119-.996Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-red-subtle, #F87168)",
            d: "M443.626 205.685c-.008-.045-1.459-.543-2.196-.424.008.216-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.075c.156.275-.29.625-.878.684v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.209c-.364-.618-7.799-1.206-6.02 1.191 0 0 3.751 1.146 3.743 1.183.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.342.216-.737.238-1.109.038-.752-.201-1.369-.885-1.101l.015.007Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M82.5 235.242h378v40h-378z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            stroke: "var(--ds-border, #091E4224)",
            d: "M83 235.742h377v39H83z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
            d: "M90.5 247.242h16v16h-16z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)",
            d: "M122.775 256.709c.74.458 1.533.659 2.347.787.82.128 1.674.162 2.662.162.242-.115.29-.074.216-.33.053-.06.141-.168.08-.262-.208-.599.39-.525.619-.632.181 1.008 1.593.551 2.905-.289 1.311-.834 2.622-1.937 3.012-2.044.498.806 1.426-.539 2.004-.27-.02.048-.148.296-.162.343.283.249 1.816-.598 3.127-.376.646.101 1.224.41 1.439.686.242.255.175.349-.329.275l.161.283c.047.101.094.208.141.316l.141.309.121.343.128.343.101.37c.007.04.06.168.101.282l.134.343c.094.222.215.437.357.639.578.8 1.607 1.311 2.683 1.251a3.314 3.314 0 0 0 1.566-.471c.343-.222.686-.437 1.029-.666.504-.356 1.069-.612 1.614-.941.282-.141.571-.262.86-.404l.438-.208.45-.168c1.197-.498 2.495-.814 3.833-1.036 2.676-.437 5.534-.275 8.176.195 2.656.485 5.11 1.251 7.161 2.192l-.04-.127c.06.053.282.047.302.195.942-.168 3.268.08 3.268.08.834.047 1.675.081 2.515.108 0 0 1.029.329 2.313.558 1.278.249 2.818.336 3.712.02 2.152.289 4.364.404 6.583.155 0 0 .679-.182 1.439-.451.746-.316 1.566-.712 1.862-1.109.377-.457.538-.901.478-1.231-.061-.336-.35-.564-.875-.585-.517-.006-1.277.155-2.393.518-.034-.034-.135-.054-.162-.114-1.156.511-2.434.497-3.671.41-1.251-.128-2.488-.37-3.799-.471.013.202-.094.343-.161.236l.053-.242c-1.815.275-2.777-.706-4.552-.195l.256-.283c-2.784-.471-6.052-1.372-9.481-2.158-3.429-.773-7.094-1.392-10.443-1.143l.034.033-.013.034c.309.128 1.196.269 1.976.45.397.081.767.155 1.036.229.269.067.45.108.45.108a4.863 4.863 0 0 1-1.681.37 11.412 11.412 0 0 1-1.707-.108c-1.15-.162-2.367-.35-3.524-.162l-.033-.316c.504-.06.975-.148 1.371-.248.39-.095.706-.168.881-.249-1.829-.121-4.727.148-7.343 1.325-.652.295-1.297.591-1.876.968-.295.181-.591.349-.867.538-.269.201-.531.397-.787.591l-.188.148c-.06.047.014 0-.013.027l-.047.061a.427.427 0 0 1-.135.107c-.101.061-.235.081-.363.061-.067.114.047.107.128.134.087.027.148.101.208.518a1.067 1.067 0 0 1-.639-.121c-.201-.101-.322-.309-.403-.518.457-.228.377.007.471-.013a.822.822 0 0 0 .006-.229c.014 0-.027-.101-.06-.188a6.818 6.818 0 0 1-.101-.282c-.067-.195-.195-.417-.309-.653a4.798 4.798 0 0 0-.458-.759c-.094-.135-.195-.269-.295-.417a17.177 17.177 0 0 0-.384-.417c-.248-.296-.612-.545-.975-.814-.396-.228-.82-.464-1.304-.598-.948-.303-1.97-.323-2.905-.195-.935.134-1.788.403-2.609.699-1.64.605-3.113 1.378-4.505 2.024-1.385.652-2.663 1.177-3.732 1.425-1.069.249-1.896.249-2.521.155-.619-.101-1.063-.249-1.271-.134-.195.087-.161.43.424 1.035l-.269.168.013.02Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "55.941",
            height: "24",
            x: "324.618",
            y: "243.242",
            fill: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
            rx: "3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#d)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#BF6952",
            d: "m345.39 260.028-9.537.034-.733 2.148a.56.56 0 0 0-.032.259.906.906 0 0 0 .896.773h9.286a.908.908 0 0 0 .897-.773.561.561 0 0 0-.033-.259l-.744-2.182Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#854836",
            d: "m345.39 260.028-.085-.247a.65.65 0 0 0-.617-.445h-8.122a.65.65 0 0 0-.617.445l-.096.28a7.565 7.565 0 0 0 4.746 1.669 7.57 7.57 0 0 0 4.791-1.702Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#AA8DD8",
            d: "M340.598 260.921a6.795 6.795 0 1 0 0-13.59 6.795 6.795 0 0 0 0 13.59Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#744EAA",
            d: "M342.959 254.605a1.865 1.865 0 1 0-.002-3.73 1.865 1.865 0 0 0 .002 3.73ZM339.229 256.935a1.398 1.398 0 1 0 0-2.796 1.398 1.398 0 0 0 0 2.796ZM339.696 250.41a.933.933 0 1 0-.001-1.865.933.933 0 0 0 .001 1.865Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
            d: "M371.685 253.685c-.008-.045-1.459-.543-2.196-.424.008.216-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.075c.156.275-.29.625-.878.684v-.35a.678.678 0 0 0 .573-.305s-3.796.313-3.773.209c-.365-.618-7.8-1.206-6.021 1.191 0 0 3.751 1.146 3.743 1.183.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.342.216-.737.238-1.109.038-.752-.201-1.369-.885-1.101l.015.007Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "55.941",
            height: "24",
            x: "396.559",
            y: "243.242",
            fill: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            rx: "3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#e)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#5DADEC",
            d: "M420.508 252.502a4.385 4.385 0 0 0-4.385-4.386 4.38 4.38 0 0 0-3.564 1.835 4.378 4.378 0 0 0-3.563-1.835 4.386 4.386 0 0 0-4.386 4.386c0 .343.044.675.119.996.608 3.783 4.815 7.775 7.83 8.871 3.015-1.096 7.222-5.088 7.83-8.871.076-.32.119-.653.119-.996Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-blue-subtle, #579DFF)",
            d: "M443.626 253.685c-.008-.045-1.459-.543-2.196-.424.008.216-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.075c.156.275-.29.625-.878.684v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.209c-.364-.618-7.799-1.206-6.02 1.191 0 0 3.751 1.146 3.743 1.183.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.342.216-.737.238-1.109.038-.752-.201-1.369-.885-1.101l.015.007Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M82.5 283.242h378v40h-378z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            stroke: "var(--ds-border, #091E4224)",
            d: "M83 283.742h377v39H83z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
            d: "M90.5 295.242h16v16h-16z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)",
            d: "M122.775 304.709c.74.458 1.533.659 2.347.787.82.128 1.674.162 2.662.162.242-.115.29-.074.216-.33.053-.06.141-.168.08-.262-.208-.599.39-.525.619-.632.181 1.008 1.593.551 2.905-.289 1.311-.834 2.622-1.937 3.012-2.044.498.806 1.426-.539 2.004-.27-.02.048-.148.296-.162.343.283.249 1.816-.598 3.127-.376.646.101 1.224.41 1.439.686.242.255.175.349-.329.275l.161.283c.047.101.094.208.141.316l.141.309.121.343.128.343.101.37c.007.04.06.168.101.282l.134.343c.094.222.215.437.357.639.578.8 1.607 1.311 2.683 1.251a3.314 3.314 0 0 0 1.566-.471c.343-.222.686-.437 1.029-.666.504-.356 1.069-.612 1.614-.941.282-.141.571-.262.86-.404l.438-.208.45-.168c1.197-.498 2.495-.814 3.833-1.036 2.676-.437 5.534-.275 8.176.195 2.656.485 5.11 1.251 7.161 2.192l-.04-.127c.06.053.282.047.302.195.942-.168 3.268.08 3.268.08.834.047 1.675.081 2.515.108 0 0 1.029.329 2.313.558 1.278.249 2.818.336 3.712.02 2.152.289 4.364.404 6.583.155 0 0 .679-.182 1.439-.451.746-.316 1.566-.712 1.862-1.109.377-.457.538-.901.478-1.231-.061-.336-.35-.564-.875-.585-.517-.006-1.277.155-2.393.518-.034-.034-.135-.054-.162-.114-1.156.511-2.434.497-3.671.41-1.251-.128-2.488-.37-3.799-.471.013.202-.094.343-.161.236l.053-.242c-1.815.275-2.777-.706-4.552-.195l.256-.283c-2.784-.471-6.052-1.372-9.481-2.158-3.429-.773-7.094-1.392-10.443-1.143l.034.033-.013.034c.309.128 1.196.269 1.976.45.397.081.767.155 1.036.229.269.067.45.108.45.108a4.863 4.863 0 0 1-1.681.37 11.412 11.412 0 0 1-1.707-.108c-1.15-.162-2.367-.35-3.524-.162l-.033-.316c.504-.06.975-.148 1.371-.248.39-.095.706-.168.881-.249-1.829-.121-4.727.148-7.343 1.325-.652.295-1.297.591-1.876.968-.295.181-.591.349-.867.538-.269.201-.531.397-.787.591l-.188.148c-.06.047.014 0-.013.027l-.047.061a.427.427 0 0 1-.135.107c-.101.061-.235.081-.363.061-.067.114.047.107.128.134.087.027.148.101.208.518a1.067 1.067 0 0 1-.639-.121c-.201-.101-.322-.309-.403-.518.457-.228.377.007.471-.013a.822.822 0 0 0 .006-.229c.014 0-.027-.101-.06-.188a6.818 6.818 0 0 1-.101-.282c-.067-.195-.195-.417-.309-.653a4.798 4.798 0 0 0-.458-.759c-.094-.135-.195-.269-.295-.417a17.177 17.177 0 0 0-.384-.417c-.248-.296-.612-.545-.975-.814-.396-.228-.82-.464-1.304-.598-.948-.303-1.97-.323-2.905-.195-.935.134-1.788.403-2.609.699-1.64.605-3.113 1.378-4.505 2.024-1.385.652-2.663 1.177-3.732 1.425-1.069.249-1.896.249-2.521.155-.619-.101-1.063-.249-1.271-.134-.195.087-.161.43.424 1.035l-.269.168.013.02Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "55.941",
            height: "24",
            x: "324.618",
            y: "291.242",
            fill: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            rx: "3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#f)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#FFAC33",
            d: "m347.883 302.75-3.955-1.464-1.477-4.84a.443.443 0 0 0-.849 0l-1.477 4.84-3.955 1.464a.445.445 0 0 0 0 .834l3.953 1.464 1.477 4.988a.446.446 0 0 0 .853-.001l1.477-4.988 3.954-1.463a.444.444 0 0 0-.001-.834Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#FFCC4D",
            d: "m338.994 307.64-1.028-.381-.4-1.466a.443.443 0 0 0-.857-.001l-.4 1.467-1.028.38a.445.445 0 0 0 0 .834l1.022.379.404 1.61a.444.444 0 0 0 .862-.001l.403-1.609 1.022-.379a.444.444 0 0 0 0-.833Zm-1.928-9.628-1.05-.389-.39-1.051a.443.443 0 0 0-.833 0l-.389 1.051-1.051.389a.445.445 0 0 0 0 .833l1.051.389.389 1.051a.445.445 0 0 0 .833 0l.389-1.051 1.051-.389a.444.444 0 0 0 0-.833Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
            d: "M371.685 301.685c-.008-.045-1.459-.543-2.196-.424.008.216-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.075c.156.275-.29.625-.878.684v-.35a.678.678 0 0 0 .573-.305s-3.796.313-3.773.209c-.365-.618-7.8-1.206-6.021 1.191 0 0 3.751 1.146 3.743 1.183.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.342.216-.737.238-1.109.038-.752-.201-1.369-.885-1.101l.015.007Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "55.941",
            height: "24",
            x: "396.559",
            y: "291.242",
            fill: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
            rx: "3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#g)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#F4900C",
            d: "M420.115 303.687c0-.917-.164-1.796-.463-2.608-.204 2.395-1.481 3.625-2.815 3.052-1.25-.537-.408-2.63-.346-3.628.105-1.693-.005-3.631-3.08-5.242 1.278 2.444.148 3.963-1.037 4.055-1.315.103-2.519-1.129-2.074-3.129-1.439 1.06-1.481 2.845-1.037 4 .463 1.203-.019 2.203-1.148 2.314-1.262.125-1.964-1.351-1.317-3.703a7.556 7.556 0 1 0 13.317 4.889Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#FFCC4D",
            d: "M417.178 305.908c.066 1.371-1.138 1.908-1.786 1.649-.936-.375-.685-1.018-.926-2.352-.24-1.333-1.166-2.259-2.536-2.666 1 2.814-.555 3.852-1.369 4.037-.832.189-1.668-.001-1.764-1.781a5.315 5.315 0 0 0-1.547 4.265 7.53 7.53 0 0 0 5.309 2.182c2.07 0 3.944-.834 5.309-2.182a5.298 5.298 0 0 0-.69-3.152Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-orange-subtle, #FEA362)",
            d: "M443.626 301.685c-.008-.045-1.459-.544-2.196-.424.008.215-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.074c.156.276-.29.626-.878.685v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.208c-.364-.617-7.799-1.205-6.02 1.191 0 0 3.751 1.146 3.743 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.038-.752-.201-1.37-.885-1.102l.015.008Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M247.5 366.242h426v221h-426z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            d: "M271.5 390.242h24v24h-24z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#h)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-blue-subtle, #579DFF)",
            d: "M312.616 403.953c.483.182 1.005.163 1.498.094.995-.153 1.961-.483 3.04-.817.268-.173.317-.153.229-.325.058-.064.156-.178.088-.237-.239-.404.453-.556.717-.704.083.374.512.355 1.103.177.17-.049.234-.073.395-.088.175-.025.361-.054.556-.084.38-.039.805-.098 1.195-.054.395.034.771.147 1.064.404.297.251.512.625.678.984.166.365.288.704.42.98.121.276.248.458.312.566-.083.148-.064.375.122.532.078.099.21.138.341.192.142.035.298.05.454.045.322-.025.629-.133.893-.217.234-.099.454-.158.619-.153-.019.05-.229.286-.253.325.18.064.824-.197 1.556-.655a23.664 23.664 0 0 0 2.317-1.708c1.488-1.207 2.64-2.216 1.913-1.133a30.234 30.234 0 0 0 1.742-1.009c.146-.094.297-.187.449-.281l.102-.064.049-.024c.029-.015.063-.035.092-.04h.103s.024.01.054.01l.122-.01c.161-.019.312 0 .473 0 .619.03 1.18.148 1.576.443.409.276.741.749 1.146 1.458.205.349.429.753.766 1.187.332.428.854.915 1.522 1.157.166.049.332.108.498.142.161.025.327.045.493.06.302 0 .624-.001.893-.06.136-.024.282-.044.414-.078l.381-.109c.263-.069.483-.167.722-.256 1.82-.768 3.327-1.822 4.82-2.9l.932-.694.473-.182c.181-.074.342-.089.512-.138a.684.684 0 0 1 .235-.035l.219-.019c.073-.01.117.014.181.014.058.005.122 0 .161.03.19.034.361.182.595.428.458.488.98 1.487 1.99 2.147.259.153.513.31.796.399.136.049.278.103.414.143l.43.079.273.044c.093.01.18.049.268.015l.508-.109.6-.123c3.19-.669 6.327-.605 8.977-.246l-.078-.084c.083.03.346-.01.409.094.527-.143 1.493-.222 2.328-.276.834-.059 1.536-.064 1.536-.064l3.011-.148s1.293.158 2.859.247c1.566.083 3.405.083 4.454-.212 2.62.079 5.274.074 7.908-.301 0 0 .205-.039.527-.103.317-.084.752-.212 1.21-.354.459-.153.947-.286 1.361-.478.415-.197.771-.384.981-.542.527-.394.81-.758.81-1.014s-.293-.404-.932-.359a6.927 6.927 0 0 0-1.224.226c-.498.138-1.123.241-1.85.453-.039-.02-.165-.025-.19-.064-1.532.483-3.127.596-4.722.601-.796.014-1.606-.054-2.411-.059-.809-.02-1.629-.074-2.458-.055.039.143-.074.257-.171.183l.039-.178c-2.24.296-3.606-.359-5.699.138l.254-.226c-1.766-.069-3.688-.197-5.728-.276-2.034-.094-4.181-.123-6.366-.01l-1.645.118c-.546.05-1.097.143-1.644.217l-.819.118-.815.177-.81.183-.351.078c.039 0-.02.01-.025 0-.014 0 0 0-.034-.009l-.122-.015c-.088 0-.141-.049-.214-.064-.147-.03-.254-.123-.386-.182-.239-.168-.493-.444-.785-.818-.298-.364-.615-.861-1.196-1.334-.122-.118-.312-.217-.468-.32a2.226 2.226 0 0 0-.532-.241c-.375-.158-.741-.163-1.098-.192.015.004.035.019.054.029l-.024.025.551.142c.224.05.503.207.776.345.546.345.951.872 1.224 1.3.283.443.478.788.649 1.029.171.222.283.36.283.35-.541-.177-.99-.68-1.459-1.211-.248-.261-.492-.547-.834-.759-.322-.236-.722-.359-1.117-.423a4.168 4.168 0 0 0-1.166.019c-.4.035-.717.143-1.122.247l-.171.049c-.054.025-.102.059-.156.093l-.259.158-.434.271c-.288.187-.566.374-.844.566l-.117-.202c.478-.32.903-.674 1.249-.965l.063-.054.113-.089c.073-.054.131-.123.209-.157a7.407 7.407 0 0 0 .801-.404c-.147.044-.293.084-.449.128l-.278.089-.176.059c-.059.029-.107.069-.161.103l-.839.552c-.527.344-1.098.709-1.698 1.068-.595.36-1.225.734-1.859 1.044-.624.315-1.288.61-1.839.719-.259.044-.508.079-.639.044a.65.65 0 0 1-.342-.167c-.132-.109-.302-.325-.488-.606-.185-.276-.375-.596-.61-.935-.443-.67-1.117-1.394-1.907-1.793a4.361 4.361 0 0 0-2.181-.468c.029.045.146.065.312.069.166.015.391.045.62.084.229.054.468.143.649.261.18.133.307.286.327.458-.571-.315-1.205-.423-1.786-.453l-.434-.01-.415.035c-.136.01-.278.014-.405.039-.156.025-.312.044-.463.069-.025-.094.014-.158.092-.212a.818.818 0 0 1 .142-.069c.044-.019.078-.029.122-.044.166-.054.361-.049.419-.084-.058-.005-.161-.024-.287-.015-.064 0-.137.005-.215.01-.117.01-.244.025-.381.035-.073.005-.146.015-.229.024l-.122.01c-.039.015-.068.045-.102.064l-.439.315c-.186.129-.396.271-.62.429-.883.615-2.059 1.443-3.42 2.339-.678.453-1.41.896-2.161 1.319-.186.099-.376.192-.566.291l-.561.251-.264.088-.132.05-.048.01a.286.286 0 0 1-.132.014c-.073 0-.117-.069-.137-.133l-.146-.492a9.047 9.047 0 0 0-.273-.832 4.607 4.607 0 0 0-.513-.96c-.131-.158-.258-.32-.409-.463-.161-.133-.317-.286-.498-.384-.717-.448-1.478-.566-2.088-.566-.644-.015-1.171.073-1.737.182-.088.024-.2.02-.302.069l-.279.118-.361.167c-.229.113-.448.222-.653.335-.83.443-1.571.862-2.259 1.197-.683.334-1.317.59-1.805.699-.239.054-.439.064-.557.054a.618.618 0 0 1-.263-.064c-.137-.069-.302-.325-.4-.551-.112-.222-.176-.409-.259-.468-.078-.064-.146-.015-.209.172-.064.192-.122.522-.03.995a1.609 1.609 0 0 1-.253-.109c.146.503.497.951.985 1.123l-.01-.02Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M271.5 427.242h378v40h-378z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            stroke: "var(--ds-border, #091E4224)",
            d: "M272 427.742h377v39H272z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
            d: "M279.5 439.242h16v16h-16z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)",
            d: "M391.95 446.951c-13.865 2.577-24.095-4.018-38.098 1.392-.654-2.317-2.344-5.218-4.873-5.261 2.11.053 5.484 6.106 2.094 2.051-1.993-3.087-10.703.686-4.028-1.998-4.608.569-8.833 4.326-11.947 7.669-5.181 4.761-1.249-4.454-4.995-9.088-5.309-6.44-21.422 10.31-18.175 10.321 2.067-2.1 4.841-3.407 5.989-5.735 20.21-13.779 5.628 11.724 17.665 7.451 19.662-17.712 9.725-1.679 21.267-2.774 6.728-6.42 35.334 3.646 35.106-4.028h-.005Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "55.941",
            height: "24",
            x: "513.618",
            y: "435.242",
            fill: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            rx: "3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#i)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#FFAC33",
            d: "m536.883 446.75-3.955-1.464-1.477-4.84a.443.443 0 0 0-.849 0l-1.477 4.84-3.955 1.464a.445.445 0 0 0 0 .834l3.953 1.464 1.477 4.988a.445.445 0 0 0 .853-.001l1.477-4.988 3.954-1.463a.445.445 0 0 0-.001-.834Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#FFCC4D",
            d: "m527.994 451.639-1.028-.38-.4-1.467a.444.444 0 0 0-.857 0l-.4 1.467-1.028.38a.444.444 0 0 0 0 .834l1.022.379.404 1.61a.444.444 0 0 0 .862-.001l.403-1.61 1.022-.379a.443.443 0 0 0 0-.833Zm-1.928-9.628-1.05-.388-.39-1.052a.443.443 0 0 0-.833 0l-.389 1.052-1.051.388a.444.444 0 0 0 0 .834l1.051.389.389 1.051a.444.444 0 0 0 .833 0l.389-1.051 1.051-.389a.445.445 0 0 0 0-.834Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
            d: "M560.685 445.685c-.008-.045-1.459-.544-2.196-.424.008.215-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.074c.156.276-.29.626-.878.685v-.35a.678.678 0 0 0 .573-.305s-3.796.313-3.773.208c-.365-.617-7.8-1.205-6.021 1.191 0 0 3.751 1.146 3.743 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.038-.752-.201-1.37-.885-1.102l.015.008Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "55.941",
            height: "24",
            x: "585.559",
            y: "435.242",
            fill: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
            rx: "3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#j)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#77B255",
            d: "M603.742 445.641c-.481.32-.91.693-1.28 1.077-.057-1.887-.51-4.327-3.01-5.521-.495-2.692-6.263-1.324-5.747-1.063 1.028.52 1.576 1.843 2.237 2.54 1.179 1.241 2.491 1.317 3.143.346 1.541 1.001 1.643 2.901 1.596 4.933-.006.224-.011.433-.011.623v6.222c0 .491 1.778.491 1.778 0v-5.107c.241-.424.943-1.558 1.969-2.353.705.619 1.841.422 2.872-.664.662-.697 1.02-2.02 2.048-2.54.543-.275-5.689-1.775-5.595 1.507Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-lime-subtle, #94C748)",
            d: "M632.626 445.685c-.008-.045-1.459-.544-2.196-.424.008.215-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.074c.156.276-.29.626-.878.685v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.208c-.364-.617-7.799-1.205-6.02 1.191 0 0 3.751 1.146 3.743 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.038-.752-.201-1.37-.885-1.102l.015.008Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M271.5 475.242h378v40h-378z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M271.5 475.242h378v40h-378z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            stroke: "var(--ds-border, #091E4224)",
            d: "M272 475.742h377v39H272z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
            d: "M279.5 487.242h16v16h-16z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)",
            d: "M311.775 496.709c.74.457 1.533.659 2.347.787.82.128 1.674.161 2.662.161.242-.114.29-.074.216-.329.053-.061.141-.168.08-.263-.208-.598.39-.524.619-.632.181 1.009 1.593.552 2.905-.289 1.311-.833 2.622-1.936 3.012-2.044.498.807 1.426-.538 2.004-.269-.02.047-.148.296-.162.343.283.249 1.816-.598 3.127-.376.646.101 1.224.41 1.439.685.242.256.175.35-.329.276l.161.283c.047.1.094.208.141.316l.141.309.121.343.128.343.101.37c.007.04.06.168.101.282l.134.343c.094.222.215.437.357.639.578.8 1.607 1.311 2.683 1.25a3.313 3.313 0 0 0 1.566-.47c.343-.222.686-.437 1.029-.666.504-.356 1.069-.612 1.614-.941.282-.141.571-.263.86-.404l.438-.208.45-.168c1.197-.498 2.495-.814 3.833-1.036 2.676-.437 5.534-.276 8.176.195 2.656.484 5.11 1.251 7.161 2.192l-.04-.128c.06.054.282.048.302.195.942-.168 3.268.081 3.268.081.834.047 1.675.081 2.515.108 0 0 1.029.329 2.313.558 1.278.249 2.818.336 3.712.02 2.152.289 4.364.403 6.583.155 0 0 .679-.182 1.439-.451.746-.316 1.566-.713 1.862-1.109.377-.458.538-.901.478-1.231-.061-.336-.35-.565-.875-.585-.517-.007-1.277.155-2.393.518-.034-.034-.135-.054-.162-.114-1.156.511-2.434.497-3.671.41-1.251-.128-2.488-.37-3.799-.471.013.202-.094.343-.161.235l.053-.242c-1.815.276-2.777-.706-4.552-.195l.256-.282c-2.784-.471-6.052-1.372-9.481-2.158-3.429-.774-7.094-1.392-10.443-1.144l.034.034-.013.034c.309.127 1.196.269 1.976.45.397.081.767.155 1.036.229.269.067.45.107.45.107a4.84 4.84 0 0 1-1.681.37 11.278 11.278 0 0 1-1.707-.107c-1.15-.162-2.367-.35-3.524-.162l-.033-.316c.504-.06.975-.148 1.371-.249.39-.094.706-.168.881-.248-1.829-.121-4.727.148-7.343 1.324-.652.296-1.297.592-1.876.969-.295.181-.591.349-.867.537-.269.202-.531.397-.787.592l-.188.148c-.06.047.014 0-.013.027l-.047.06a.43.43 0 0 1-.135.108c-.101.061-.235.081-.363.061-.067.114.047.107.128.134.087.027.148.101.208.518a1.067 1.067 0 0 1-.639-.121c-.201-.101-.322-.309-.403-.518.457-.229.377.007.471-.013a.822.822 0 0 0 .006-.229c.014 0-.027-.101-.06-.188a6.882 6.882 0 0 1-.101-.283c-.067-.195-.195-.417-.309-.652a4.85 4.85 0 0 0-.458-.76c-.094-.134-.195-.269-.295-.417a19.281 19.281 0 0 0-.384-.416c-.248-.296-.612-.545-.975-.814-.396-.229-.82-.464-1.304-.599-.948-.302-1.97-.322-2.905-.195-.935.135-1.788.404-2.609.7-1.64.605-3.113 1.378-4.505 2.024-1.385.652-2.663 1.176-3.732 1.425-1.069.249-1.896.249-2.521.155-.619-.101-1.063-.249-1.271-.135-.195.088-.161.431.424 1.036l-.269.168.013.02Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "55.941",
            height: "24",
            x: "513.5",
            y: "483.242",
            fill: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
            rx: "3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#k)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#BF6952",
            d: "m534.272 500.028-9.537.033-.733 2.149a.573.573 0 0 0-.033.259.908.908 0 0 0 .897.773h9.286a.908.908 0 0 0 .897-.773.573.573 0 0 0-.033-.259l-.744-2.182Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#854836",
            d: "m534.272 500.027-.085-.247a.65.65 0 0 0-.617-.445h-8.122a.65.65 0 0 0-.617.445l-.096.281a7.565 7.565 0 0 0 4.746 1.669 7.564 7.564 0 0 0 4.791-1.703Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#AA8DD8",
            d: "M529.48 500.92a6.794 6.794 0 1 0 .001-13.589 6.794 6.794 0 0 0-.001 13.589Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#744EAA",
            d: "M531.841 494.604a1.864 1.864 0 1 0 0-3.728 1.864 1.864 0 0 0 0 3.728ZM528.111 496.935a1.398 1.398 0 1 0 0-2.797 1.398 1.398 0 0 0 0 2.797ZM528.577 490.409a.933.933 0 1 0 .001-1.865.933.933 0 0 0-.001 1.865Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
            d: "M560.566 493.685c-.007-.045-1.458-.544-2.195-.424.007.215-.03 0-.03 0-.491.55-1.191.245-1.191.245-1.533.186-3.617-.171-5.276.283v.074c.156.276-.29.626-.878.685v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.208c-.364-.617-7.799-1.205-6.021 1.191 0 0 3.751 1.146 3.744 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.037-.752-.201-1.37-.885-1.102l.014.008Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "55.941",
            height: "24",
            x: "585.441",
            y: "483.242",
            fill: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            rx: "3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#l)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#DD2E44",
            d: "M609.39 492.501a4.386 4.386 0 0 0-4.385-4.386 4.376 4.376 0 0 0-3.564 1.836 4.376 4.376 0 0 0-3.563-1.836 4.386 4.386 0 0 0-4.386 4.386c0 .343.044.676.118.996.609 3.784 4.816 7.775 7.831 8.871 3.015-1.096 7.222-5.087 7.83-8.87.075-.321.119-.653.119-.997Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-red-subtle, #F87168)",
            d: "M632.507 493.685c-.007-.045-1.458-.544-2.195-.424.007.215-.03 0-.03 0-.491.55-1.191.245-1.191.245-1.533.186-3.617-.171-5.276.283v.074c.156.276-.291.626-.878.685v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.208c-.364-.617-7.799-1.205-6.021 1.191 0 0 3.751 1.146 3.744 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.037-.752-.201-1.37-.885-1.102l.014.008Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M271.5 523.242h378v40h-378z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            stroke: "var(--ds-border, #091E4224)",
            d: "M272 523.742h377v39H272z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
            d: "M279.5 535.242h16v16h-16z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)",
            d: "M311.775 544.709c.74.457 1.533.659 2.347.787.82.128 1.674.161 2.662.161.242-.114.29-.074.216-.329.053-.061.141-.168.08-.263-.208-.598.39-.524.619-.632.181 1.009 1.593.552 2.905-.289 1.311-.833 2.622-1.936 3.012-2.044.498.807 1.426-.538 2.004-.269-.02.047-.148.296-.162.343.283.249 1.816-.598 3.127-.376.646.101 1.224.41 1.439.685.242.256.175.35-.329.276l.161.283c.047.1.094.208.141.316l.141.309.121.343.128.343.101.37c.007.04.06.168.101.282l.134.343c.094.222.215.437.357.639.578.8 1.607 1.311 2.683 1.25a3.313 3.313 0 0 0 1.566-.47c.343-.222.686-.437 1.029-.666.504-.356 1.069-.612 1.614-.941.282-.141.571-.263.86-.404l.438-.208.45-.168c1.197-.498 2.495-.814 3.833-1.036 2.676-.437 5.534-.276 8.176.195 2.656.484 5.11 1.251 7.161 2.192l-.04-.128c.06.054.282.048.302.195.942-.168 3.268.081 3.268.081.834.047 1.675.081 2.515.108 0 0 1.029.329 2.313.558 1.278.249 2.818.336 3.712.02 2.152.289 4.364.403 6.583.155 0 0 .679-.182 1.439-.451.746-.316 1.566-.713 1.862-1.109.377-.458.538-.901.478-1.231-.061-.336-.35-.565-.875-.585-.517-.007-1.277.155-2.393.518-.034-.034-.135-.054-.162-.114-1.156.511-2.434.497-3.671.41-1.251-.128-2.488-.37-3.799-.471.013.202-.094.343-.161.235l.053-.242c-1.815.276-2.777-.706-4.552-.195l.256-.282c-2.784-.471-6.052-1.372-9.481-2.158-3.429-.774-7.094-1.392-10.443-1.144l.034.034-.013.034c.309.127 1.196.269 1.976.45.397.081.767.155 1.036.229.269.067.45.107.45.107a4.84 4.84 0 0 1-1.681.37 11.278 11.278 0 0 1-1.707-.107c-1.15-.162-2.367-.35-3.524-.162l-.033-.316c.504-.06.975-.148 1.371-.249.39-.094.706-.168.881-.248-1.829-.121-4.727.148-7.343 1.324-.652.296-1.297.592-1.876.969-.295.181-.591.349-.867.537-.269.202-.531.397-.787.592l-.188.148c-.06.047.014 0-.013.027l-.047.06a.43.43 0 0 1-.135.108c-.101.061-.235.081-.363.061-.067.114.047.107.128.134.087.027.148.101.208.518a1.067 1.067 0 0 1-.639-.121c-.201-.101-.322-.309-.403-.518.457-.229.377.007.471-.013a.822.822 0 0 0 .006-.229c.014 0-.027-.101-.06-.188a6.882 6.882 0 0 1-.101-.283c-.067-.195-.195-.417-.309-.652a4.85 4.85 0 0 0-.458-.76c-.094-.134-.195-.269-.295-.417a19.281 19.281 0 0 0-.384-.416c-.248-.296-.612-.545-.975-.814-.396-.229-.82-.464-1.304-.599-.948-.302-1.97-.322-2.905-.195-.935.135-1.788.404-2.609.7-1.64.605-3.113 1.378-4.505 2.024-1.385.652-2.663 1.176-3.732 1.425-1.069.249-1.896.249-2.521.155-.619-.101-1.063-.249-1.271-.135-.195.088-.161.431.424 1.036l-.269.168.013.02Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "55.941",
            height: "24",
            x: "513.618",
            y: "531.242",
            fill: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            rx: "3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#m)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#5DADEC",
            d: "M537.567 540.501a4.386 4.386 0 0 0-4.385-4.386c-1.47 0-2.768.726-3.564 1.836a4.376 4.376 0 0 0-3.563-1.836 4.386 4.386 0 0 0-4.386 4.386c0 .343.044.676.119.996.609 3.784 4.815 7.775 7.83 8.871 3.015-1.096 7.222-5.087 7.83-8.87.076-.321.119-.653.119-.997Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-blue-subtle, #579DFF)",
            d: "M560.685 541.685c-.008-.045-1.459-.544-2.196-.424.008.215-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.074c.156.276-.29.626-.878.685v-.35a.678.678 0 0 0 .573-.305s-3.796.313-3.773.208c-.365-.617-7.8-1.205-6.021 1.191 0 0 3.751 1.146 3.743 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.038-.752-.201-1.37-.885-1.102l.015.008Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "55.941",
            height: "24",
            x: "585.559",
            y: "531.242",
            fill: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
            rx: "3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#n)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#F4900C",
            d: "M609.115 543.687c0-.917-.164-1.796-.463-2.608-.204 2.395-1.481 3.625-2.815 3.052-1.25-.537-.408-2.63-.346-3.628.105-1.693-.005-3.631-3.08-5.242 1.278 2.444.148 3.963-1.037 4.055-1.315.103-2.519-1.129-2.074-3.129-1.439 1.06-1.481 2.845-1.037 4 .463 1.203-.019 2.203-1.148 2.314-1.262.125-1.964-1.351-1.317-3.703a7.556 7.556 0 1 0 13.317 4.889Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "#FFCC4D",
            d: "M606.178 545.908c.066 1.371-1.138 1.908-1.786 1.649-.936-.375-.685-1.018-.926-2.352-.24-1.333-1.166-2.259-2.536-2.666 1 2.814-.555 3.852-1.369 4.037-.832.189-1.668-.001-1.764-1.781a5.315 5.315 0 0 0-1.547 4.265 7.53 7.53 0 0 0 5.309 2.182c2.07 0 3.944-.834 5.309-2.182a5.298 5.298 0 0 0-.69-3.152Z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-accent-orange-subtle, #FEA362)",
            d: "M632.626 541.685c-.008-.045-1.459-.544-2.196-.424.008.215-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.074c.156.276-.29.626-.878.685v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.208c-.364-.617-7.799-1.205-6.02 1.191 0 0 3.751 1.146 3.743 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.038-.752-.201-1.37-.885-1.102l.015.008Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-background-neutral-bold-pressed, #172B4D)",
            d: "M518.264 99.905c6.529-18.04 30.147 5.868 36.898 13.189 9.072.279 19.086-2.55 22.525-11.771 3.449-6.28-.888-13.645-3.862-19.293-6.057-11.315-7.009-9.148-18.45-12.63-9.205-3.08-41.917-17.443-33.248-30.676 6.673-5.714 17.773 4.284 23.344 8.145 6.799 5.45 13.008 11.605 18.629 18.107 3.196 4.15 5.149 7.188 11.002 7.04 16.192 2.166 53.875 1.082 50.314-23.069-5.728-17.442-23.877-27.113-37.972-36.859-.587-.484.988.243 5.302 2.64l-.758-.678c8.902 5.679 17.552 10.706 24.742 18.413.261.303.69.815.514.74-.081.688 2.432 2.912 2.835 3.636 15.806 15.374 4.683 31.406-14.91 35.623.199-.013 1.44-.2 1.605-.213-7.51 2.758-24.344 2.496-32.123 1.098-2.221-.316-2.603-.297.28.323a98.624 98.624 0 0 1-4.397-.593c5.118 7.42 10.918 15.553 10.613 24.93-2.261 11.778-12.57 17.487-23.877 17.642 10.789 12.269 13.413 31.492-6.844 33.752 11.05-4.578 17.221-10.514 11.333-23.381-6.66-13.48-6.629-9.118-19.631-11.979-8.957-2.442-21.577-5.579-23.874-14.137h.01Zm38.794-40.612a145.906 145.906 0 0 0-15.036-12.95l-.05.221c4.494 3.339 8.105 6.804 9.507 8.221-5.662-4.935-14.531-12.837-23.118-15.248-6.361-2.118-6.58 6.516-2.901 9.523 8.167 7.848 18.091 13.71 28.435 17.727-1.898-.493-5.88-2.57-7.479-2.792 4.461 2.112 9.071 3.918 13.553 5.244.102-.333-2.506-.981-2.984-1.238.523.164 5.931 1.785 9.909 2.594-2.852-3.909-6.22-7.698-9.842-11.304l.006.002Zm-36.34 42.291c.257.436.542.888.919 1.318-.112-.148-.459-.824-.5-.913 7.915 7.969 20.564 10.112 31.575 11.049-2.915-3.235-10.083-9.685-14.571-12.508.25.012-.144-.38-.589-.585.012-.005.055.227.061.229-3.891-2.435-7.402-5.349-11.999-4.638-2.73.46-6.779 2.905-4.894 6.052l-.002-.004Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "m529.558 103.599.002.004-.007-.006.005.002Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "a"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M121.5 151.742h339v21h-339z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "b"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M332.618 199.242h16v16h-16z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "c"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M404.559 199.242h16v16h-16z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "d"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M332.618 247.242h16v16h-16z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "e"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M404.559 247.242h16v16h-16z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "f"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M332.618 295.242h16v16h-16z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "g"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M404.559 295.242h16v16h-16z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "h"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M310.5 398.242h186v8h-186z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "i"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M521.618 439.242h16v16h-16z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "j"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M593.559 439.242h16v16h-16z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "k"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M521.5 487.242h16v16h-16z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "l"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M593.441 487.242h16v16h-16z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "m"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M521.618 535.242h16v16h-16z"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "n"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "var(--ds-surface, #FFFFFF)",
            d: "M593.559 535.242h16v16h-16z"
        }))));
    const $936ceae5a4a545da$var$svgStyles = null;
});
parcelRegister("dnM4Q", function(module, exports) {
    $parcel$export(module.exports, "Drawer", ()=>$a9cf9b1218f39ca6$export$4071300121a182f5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $42CjB;
    var $lLLkM;
    var $35XSW;
    var $8Sbj3;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $9IUNr;
    const $a9cf9b1218f39ca6$var$animationTimingFunction = ()=>(0, $eba99f58997c09b3$export$57636bb43b1ccbb0);
    const $a9cf9b1218f39ca6$export$4071300121a182f5 = ({ isOpen: isOpen, onClose: onClose, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Escape' && isOpen) onClose();
        }, [
            isOpen,
            onClose
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen) window.addEventListener('keydown', handleKeyDown);
            else window.removeEventListener('keydown', handleKeyDown);
            return ()=>{
                window.removeEventListener('keydown', handleKeyDown);
            };
        }, [
            isOpen,
            handleKeyDown
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("35XSW")).default), {
            appear: true
        }, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Sbj3")).default), {
            animationTimingFunction: $a9cf9b1218f39ca6$var$animationTimingFunction,
            duration: 400,
            enterFrom: "left",
            exitTo: "left"
        }, (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($a9cf9b1218f39ca6$var$Container, props, children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $a9cf9b1218f39ca6$var$closeButtonStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                shape: "circle",
                icon: (0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))),
                label: formatMessage((0, (0, parcelRequire("9IUNr")).default).closeButtonLabel),
                appearance: "subtle",
                onClick: onClose
            })))));
    };
    const $a9cf9b1218f39ca6$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ip97y _1bsbauwl _kqsw1n9t _154ieaa0 _1ltvze3t _1pbyfjpv _bfhk1bhr _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $a9cf9b1218f39ca6$var$closeButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: 'space.250',
        left: 'space.250'
    });
});
parcelRegister("9IUNr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83b6fecaa440afb3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $83b6fecaa440afb3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        closeButtonLabel: {
            "id": "polaris-component-collection-create.drawer.close-button-label",
            "defaultMessage": "Close"
        }
    });
});
parcelRegister("6Gni9", function(module, exports) {
    $parcel$export(module.exports, "Form", ()=>$a988e489098890b8$export$a7fed597f4b8afd8);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $efXp3;
    var $7O4UO;
    var $2x3Cb;
    var $l1N8i;
    var $dASv8;
    var $dC5iT;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $kY99m;
    var $4R6GH;
    var $koVbs;
    var $aOD49;
    var $dpYV0;
    var $1qdF0;
    var $1X3JP;
    var $jdnWL;
    var $eW55R;
    var $90yGq;
    var $lVJAU;
    var $eOMZh;
    var $9iiI8;
    var $gE10J;
    var $isxus;
    var $17h70;
    var $v0rRn;
    var $9xjQI;
    var $4AjLa;
    const $a988e489098890b8$var$MAX_COLLECTION_NAME_LENGTH = 100;
    const $a988e489098890b8$export$a7fed597f4b8afd8 = ({ onSuccess: onSuccess })=>{
        const [projectKeys, setProjectKeys] = (0, $5uXOq.useState)([]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [selectedEmojiId, setSelectedEmojiId] = (0, $5uXOq.useState)();
        const [ideasCountOLD, setIdeasCountOLD] = (0, $5uXOq.useState)(0);
        const { createCollection: createCollection, createView: createView } = (0, (0, parcelRequire("1qdF0")).useCollectionsActions)();
        const { errorWithRefresh: errorWithRefresh } = (0, (0, parcelRequire("eW55R")).useNotifications)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const ownerId = (0, (0, parcelRequire("90yGq")).useAccountId)() ?? '';
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [ideasCount, isIdeasCountLoading] = (0, (0, parcelRequire("4AjLa")).useCollectionIdeasCount)(projectKeys);
        const validateNameField = (0, $5uXOq.useCallback)((value)=>{
            if (value === undefined || value.trim().length === 0) return formatMessage((0, (0, parcelRequire("v0rRn")).default).emptyNameError);
            if (value.length > $a988e489098890b8$var$MAX_COLLECTION_NAME_LENGTH) return formatMessage((0, (0, parcelRequire("v0rRn")).default).nameTooLongError);
            return undefined;
        }, [
            formatMessage
        ]);
        const validateProjectsField = (0, $5uXOq.useCallback)((value)=>{
            if (value === undefined || value.length === 0) return formatMessage((0, (0, parcelRequire("v0rRn")).default).emptyProjectsError);
            return undefined;
        }, [
            formatMessage
        ]);
        const handleSubmit = (0, $5uXOq.useCallback)(async (formData)=>{
            try {
                const projectKeysOLD = formData[(0, (0, parcelRequire("gE10J")).FormFieldKeys).PROJECTS];
                const filtersJql = formData[(0, (0, parcelRequire("gE10J")).FormFieldKeys).FILTERS];
                const jql = (0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering') ? (0, (0, parcelRequire("dpYV0")).getJQLForCollection)(projectKeys, filtersJql) : (0, (0, parcelRequire("dpYV0")).getJQLForCollection)(projectKeysOLD, undefined);
                if ((0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering')) {
                    if (ideasCount && ideasCount > (0, (0, parcelRequire("gE10J")).IDEAS_COUNT_LIMIT)) return;
                } else {
                    const newIdeasCount = await (0, (0, parcelRequire("9iiI8")).getIdeasCountForCollection)(jql);
                    setIdeasCountOLD(newIdeasCount);
                    if (newIdeasCount > (0, (0, parcelRequire("gE10J")).IDEAS_COUNT_LIMIT)) return;
                }
                const collection = await createCollection({
                    name: formData[(0, (0, parcelRequire("gE10J")).FormFieldKeys).COLLECTION_NAME],
                    jql: jql,
                    emoji: selectedEmojiId,
                    ownerId: ownerId,
                    createAnalyticsEvent: createAnalyticsEvent
                });
                if (!collection) return;
                const fields = [
                    (0, $7d87475f2d1b3049$export$469f8bf472cb9ca),
                    (0, $7d87475f2d1b3049$export$1fd24e9c03ef9b18)
                ];
                await createView(collection.uuid, {
                    visualizationType: (0, $739ce7f4993d045e$export$76e8cbc60f99881d),
                    name: formatMessage((0, (0, parcelRequire("v0rRn")).default).listViewName),
                    fields: fields
                });
                await createView(collection.uuid, {
                    visualizationType: (0, $739ce7f4993d045e$export$b536e56a69266159),
                    name: formatMessage((0, (0, parcelRequire("v0rRn")).default).timelineViewName),
                    fields: fields
                });
                await createView(collection.uuid, {
                    visualizationType: (0, $739ce7f4993d045e$export$1ad049af934b4509),
                    name: formatMessage((0, (0, parcelRequire("v0rRn")).default).boardViewName),
                    fields: fields
                });
                await createView(collection.uuid, {
                    visualizationType: (0, $739ce7f4993d045e$export$2b0330ebc4df6bb5),
                    name: formatMessage((0, (0, parcelRequire("v0rRn")).default).matrixViewName),
                    fields: fields
                });
                push((0, (0, parcelRequire("aOD49")).getCollectionDetailsPageUrl)(collection.uuid));
                onSuccess?.(collection.uuid);
            } catch (err) {
                errorWithRefresh({
                    title: formatMessage((0, (0, parcelRequire("v0rRn")).default).errorTitle),
                    description: formatMessage((0, (0, parcelRequire("v0rRn")).default).errorDescription)
                });
            }
        }, [
            ideasCount,
            projectKeys,
            createCollection,
            selectedEmojiId,
            ownerId,
            createAnalyticsEvent,
            createView,
            formatMessage,
            push,
            onSuccess,
            errorWithRefresh
        ]);
        const exceedsIdeasLimit = ideasCountOLD > (0, (0, parcelRequire("gE10J")).IDEAS_COUNT_LIMIT);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlock: (0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering') ? undefined : 'space.1000',
            paddingInline: (0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering') ? undefined : 'space.400'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: (0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering') ? undefined : $a988e489098890b8$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xxlarge"
        }, formatMessage((0, (0, parcelRequire("v0rRn")).default).heading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlockStart: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, formatMessage((0, (0, parcelRequire("v0rRn")).default).description))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("efXp3")).default), {
            onSubmit: handleSubmit
        }, ({ formProps: formProps, submitting: submitting })=>(0, ($parcel$interopDefault($5uXOq))).createElement("form", {
                ...formProps,
                name: "collection-create-form"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                space: "space.150"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                label: formatMessage((0, (0, parcelRequire("v0rRn")).default).roadmapNameFieldLabel),
                name: (0, (0, parcelRequire("gE10J")).FormFieldKeys).COLLECTION_NAME,
                isRequired: true,
                validate: validateNameField
            }, ({ fieldProps: fieldProps, error: error, meta: meta })=>{
                const isInvalid = fieldProps.isInvalid && !!error && (meta.submitFailed || meta.dirty);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                    ...fieldProps,
                    isInvalid: isInvalid,
                    isRequired: false,
                    testId: "polaris-component-collection-create.ui.form.collection-name",
                    autoFocus: true,
                    placeholder: formatMessage((0, (0, parcelRequire("v0rRn")).default).roadmapNameFieldPlaceholder),
                    elemBeforeInput: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                        paddingInlineStart: "space.025"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1X3JP")).EmojiPicker), {
                        onEmojiSelected: (emoji)=>{
                            setSelectedEmojiId(emoji?.id);
                        },
                        readonly: submitting,
                        selectedEmojiId: selectedEmojiId,
                        emojiAddIcon: (iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dASv8"))))), {
                                ...iconProps,
                                color: "var(--ds-icon, #44546F)",
                                LEGACY_primaryColor: "var(--ds-icon, #44546F)"
                            }),
                        zIndex: (0, (0, parcelRequire("eOMZh")).DRAWER_Z_INDEX) + 1
                    }))
                }), isInvalid && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jdnWL")).ErrorContainer), {
                    "data-testid": "polaris-component-collection-create.ui.form.name-field-error"
                }, error));
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                label: formatMessage((0, (0, parcelRequire("v0rRn")).default).projectsSelectFieldLabel),
                name: (0, (0, parcelRequire("gE10J")).FormFieldKeys).PROJECTS,
                isRequired: true,
                validate: validateProjectsField
            }, ({ fieldProps: { onChange: onChange, ...restFieldProps }, error: error, meta: meta })=>{
                const isInvalid = restFieldProps.isInvalid && !!error && (meta.submitFailed || meta.dirty);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9xjQI")).ProjectSelect), {
                    ...restFieldProps,
                    isInvalid: isInvalid,
                    onChange: (values)=>{
                        if ((0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering')) {
                            if (Array.isArray(values)) setProjectKeys(values);
                        } else setIdeasCountOLD(0);
                        onChange(values);
                    }
                }), isInvalid && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jdnWL")).ErrorContainer), {
                    "data-testid": "polaris-component-collection-create.ui.form.projects-field-error"
                }, error));
            }), (0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                label: formatMessage((0, (0, parcelRequire("v0rRn")).default).filtersLabel),
                name: (0, (0, parcelRequire("gE10J")).FormFieldKeys).FILTERS,
                isRequired: true
            }, ({ fieldProps: fieldProps })=>{
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isxus")).Filters), {
                    ...fieldProps,
                    projectKeys: projectKeys
                });
            }), exceedsIdeasLimit && !(0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                paddingBlockStart: "space.100"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                space: "space.100"
            }, !(0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2x3Cb")).Label), {
                htmlFor: ""
            }, formatMessage((0, (0, parcelRequire("v0rRn")).default).filtersLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                padding: "space.100",
                backgroundColor: "color.background.warning",
                xcss: $a988e489098890b8$var$ideasLimitStyles
            }, formatMessage((0, (0, parcelRequire("v0rRn")).default).limitExceededError, {
                ideasCountOLD: ideasCountOLD,
                b: (text)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, text)
            }), ' ', formatMessage((0, (0, parcelRequire("v0rRn")).default).limitExceededErrorAction, {
                ideasCountOLD: ideasCountOLD,
                maxIdeas: (0, (0, parcelRequire("gE10J")).IDEAS_COUNT_LIMIT)
            })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17h70")).Footer), {
                submitting: submitting,
                ideasCount: (0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering') ? ideasCount : ideasCountOLD,
                isIdeasCountLoading: isIdeasCountLoading
            }))))));
    };
    const $a988e489098890b8$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: '0 auto',
        maxWidth: '410px'
    });
    const $a988e489098890b8$var$ideasLimitStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("dASv8", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9e58e9efff88d680$var$_react = $9e58e9efff88d680$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9e58e9efff88d680$var$_emojiAdd = $9e58e9efff88d680$var$_interopRequireDefault((parcelRequire("4orob")));
    var $9e58e9efff88d680$var$_emojiAdd2 = $9e58e9efff88d680$var$_interopRequireDefault((parcelRequire("c6gwd")));
    function $9e58e9efff88d680$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9e58e9efff88d680$var$EmojiAddIcon = (props)=>$9e58e9efff88d680$var$_react.default.createElement($9e58e9efff88d680$var$_emojiAdd.default, Object.assign({
            LEGACY_fallbackIcon: $9e58e9efff88d680$var$_emojiAdd2.default
        }, props));
    $9e58e9efff88d680$var$EmojiAddIcon.Name = 'EmojiAddIconMigration';
    var $9e58e9efff88d680$var$_default = module.exports.default = $9e58e9efff88d680$var$EmojiAddIcon;
});
parcelRegister("4orob", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $332ea63b7d225997$var$_react = $332ea63b7d225997$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $332ea63b7d225997$var$_baseNew = $332ea63b7d225997$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $332ea63b7d225997$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $332ea63b7d225997$var$EmojiAddIcon = (props)=>$332ea63b7d225997$var$_react.default.createElement($332ea63b7d225997$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M6.25 6.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M10.5 2.75H16M13.25 0v5.5m2 2.5A7.25 7.25 0 1 1 8 .75m3.25 9S10 11.5 8 11.5 4.75 9.75 4.75 9.75m1.5-3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
        }, props));
    $332ea63b7d225997$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
    var $332ea63b7d225997$var$_default = module.exports.default = $332ea63b7d225997$var$EmojiAddIcon;
});
parcelRegister("c6gwd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8cf2dbd3b6261f85$var$_react = $8cf2dbd3b6261f85$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $8cf2dbd3b6261f85$var$_emojiAdd = $8cf2dbd3b6261f85$var$_interopRequireDefault((parcelRequire("4orob")));
    function $8cf2dbd3b6261f85$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8cf2dbd3b6261f85$var$EmojiAddIcon = (props)=>$8cf2dbd3b6261f85$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.049 14.197c-.166-.476.103-.991.602-1.15.5-.159 1.039.098 1.205.575.06.174.225.487.495.796.426.488.955.764 1.649.764.693 0 1.223-.276 1.65-.764.27-.31.433-.622.494-.796.166-.476.706-.734 1.204-.575.5.159.77.673.603 1.15-.13.371-.395.876-.839 1.385C14.348 16.458 13.306 17 12 17s-2.348-.542-3.112-1.418a4.4 4.4 0 0 1-.839-1.385M9.5 11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M19 5h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0V7h-1a1 1 0 0 1 0-2h1V4a1 1 0 0 1 2 0zm-5-1.777V5.29A7 7 0 1 0 18.71 10h2.067A9 9 0 1 1 14 3.223"/></svg>`
        }, props, {
            newIcon: $8cf2dbd3b6261f85$var$_emojiAdd.default
        }));
    $8cf2dbd3b6261f85$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
    var $8cf2dbd3b6261f85$var$_default = module.exports.default = $8cf2dbd3b6261f85$var$EmojiAddIcon;
});
parcelRegister("aOD49", function(module, exports) {
    $parcel$export(module.exports, "getCollectionDetailsPageUrl", ()=>$a92ae6c7b428c3ad$export$6d4e7a90e74e9b12);
    $parcel$export(module.exports, "getCollectionViewPageUrl", ()=>$a92ae6c7b428c3ad$export$32ac8841347e1f79);
    $parcel$export(module.exports, "getCollectionsPageUrl", ()=>$a92ae6c7b428c3ad$export$d15219b9c6a3e2f7);
    const $a92ae6c7b428c3ad$export$6d4e7a90e74e9b12 = (collectionUUID)=>`/jira/polaris/roadmaps/${collectionUUID}/view`;
    const $a92ae6c7b428c3ad$export$32ac8841347e1f79 = (collectionUUID, viewUUID)=>`/jira/polaris/roadmaps/${collectionUUID}/view/${viewUUID}`;
    const $a92ae6c7b428c3ad$export$d15219b9c6a3e2f7 = ()=>'/jira/polaris/roadmaps';
});
parcelRegister("dpYV0", function(module, exports) {
    $parcel$export(module.exports, "getJQLForCollection", ()=>$982aeb25f1017157$export$8d4a8272ec8d3589);
    $parcel$export(module.exports, "extractProjectKeysFromJql", ()=>$982aeb25f1017157$export$35840c54e03d7673);
    var $iEIQF;
    var $eK6AG;
    var $bzbto;
    var $l0V05;
    var $4R6GH;
    const $982aeb25f1017157$var$quoteProjectKey = (projectKey)=>`"${projectKey}"`;
    const $982aeb25f1017157$export$8d4a8272ec8d3589 = (projectsKeys = [], filtersJql = '')=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering')) {
            const jast = new (0, (0, parcelRequire("eK6AG")).JastBuilder)().build(filtersJql);
            projectsKeys.length && jast.query?.appendClause((0, (0, parcelRequire("iEIQF")).default).terminalClause((0, (0, parcelRequire("iEIQF")).default).field('project'), (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_IN)), (0, (0, parcelRequire("iEIQF")).default).listOperand(projectsKeys.map($982aeb25f1017157$var$quoteProjectKey).map((0, (0, parcelRequire("iEIQF")).default).byText.valueOperand))), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            return (0, (0, parcelRequire("l0V05")).print)(jast);
        }
        if (!projectsKeys.length) return '';
        const jast = (0, (0, parcelRequire("iEIQF")).default).jast((0, (0, parcelRequire("iEIQF")).default).query((0, (0, parcelRequire("iEIQF")).default).terminalClause((0, (0, parcelRequire("iEIQF")).default).field('project'), (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_IN)), (0, (0, parcelRequire("iEIQF")).default).listOperand(projectsKeys.map($982aeb25f1017157$var$quoteProjectKey).map((0, (0, parcelRequire("iEIQF")).default).byText.valueOperand)))));
        return (0, (0, parcelRequire("l0V05")).print)(jast);
    };
    const $982aeb25f1017157$var$projectInRegex = /project\s+in\s+\((.*?)\)/;
    const $982aeb25f1017157$var$projectKeyRegex = /"(.*?)"/g;
    const $982aeb25f1017157$export$35840c54e03d7673 = (jql)=>{
        const projectInMatch = $982aeb25f1017157$var$projectInRegex.exec(jql);
        const projectKeys = [];
        if (projectInMatch) {
            const projectInClause = projectInMatch[1];
            let match;
            while((match = $982aeb25f1017157$var$projectKeyRegex.exec(projectInClause)) !== null)projectKeys.push(match[1]);
        }
        return projectKeys;
    };
});
const $3cef51f82b2cbe1d$export$6d6d48d210d3ca97 = 'and';
const $3cef51f82b2cbe1d$export$7b8f0a728d79a753 = 'or';
parcelRegister("iEIQF", function(module, exports) {
    $parcel$export(module.exports, "internalCreators", ()=>$76b4580b91797d8b$export$64d991963cfb5532);
    $parcel$export(module.exports, "default", ()=>$76b4580b91797d8b$export$2e2bcd8739ae039);
    var $gzGcl;
    var $awXvh;
    var $3hoxA;
    var $2TUEL;
    var $9TMIk;
    var $23cr9;
    var $an0VC;
    var $kO6UE;
    var $AZ9nU;
    var $9HHq9;
    var $6qN6D;
    var $3J4gf;
    var $her2D;
    var $j37YY;
    var $doe2p;
    var $k9DKN;
    var $jRA9z;
    var $bF1Nb;
    var $bW5aY;
    var $dgZwd;
    var $1zQFd;
    var $eWV0u;
    const $76b4580b91797d8b$export$64d991963cfb5532 = {
        query: (0, (0, parcelRequire("dgZwd")).queryInternal),
        compoundClause: (0, (0, parcelRequire("awXvh")).compoundClauseInternal),
        compoundOperator: (0, (0, parcelRequire("3hoxA")).compoundOperatorInternal),
        terminalClause: (0, (0, parcelRequire("1zQFd")).terminalClauseInternal),
        notClause: (0, (0, parcelRequire("9HHq9")).notClauseInternal),
        notClauseOperator: (0, (0, parcelRequire("6qN6D")).notClauseOperatorInternal),
        predicate: (0, (0, parcelRequire("jRA9z")).predicateInternal),
        predicateOperator: (0, (0, parcelRequire("bF1Nb")).predicateOperatorInternal),
        field: (0, (0, parcelRequire("2TUEL")).fieldInternal),
        property: (0, (0, parcelRequire("bW5aY")).propertyInternal),
        operator: (0, (0, parcelRequire("3J4gf")).operatorInternal),
        valueOperand: (0, (0, parcelRequire("eWV0u")).valueOperandInternal),
        keywordOperand: (0, (0, parcelRequire("kO6UE")).keywordOperandInternal),
        functionOperand: (0, (0, parcelRequire("9TMIk")).functionOperandInternal),
        functionString: (0, (0, parcelRequire("23cr9")).functionStringInternal),
        argument: (0, (0, parcelRequire("gzGcl")).argumentInternal),
        listOperand: (0, (0, parcelRequire("AZ9nU")).listOperandInternal),
        orderBy: (0, (0, parcelRequire("her2D")).orderByInternal),
        orderByOperator: (0, (0, parcelRequire("k9DKN")).orderByOperatorInternal),
        orderByField: (0, (0, parcelRequire("doe2p")).orderByFieldInternal),
        orderByDirection: (0, (0, parcelRequire("j37YY")).orderByDirectionInternal)
    };
    var $76b4580b91797d8b$export$2e2bcd8739ae039 = {
        jast: (0, parcelRequire("an0VC")).jast,
        query: (0, parcelRequire("dgZwd")).query,
        compoundClause: (0, parcelRequire("awXvh")).compoundClause,
        compoundOperator: (0, parcelRequire("3hoxA")).compoundOperator,
        terminalClause: (0, parcelRequire("1zQFd")).terminalClause,
        notClause: (0, parcelRequire("9HHq9")).notClause,
        notClauseOperator: (0, parcelRequire("6qN6D")).notClauseOperator,
        predicate: (0, parcelRequire("jRA9z")).predicate,
        predicateOperator: (0, parcelRequire("bF1Nb")).predicateOperator,
        field: (0, parcelRequire("2TUEL")).field,
        property: (0, parcelRequire("bW5aY")).property,
        operator: (0, parcelRequire("3J4gf")).operator,
        valueOperand: (0, parcelRequire("eWV0u")).valueOperand,
        keywordOperand: (0, parcelRequire("kO6UE")).keywordOperand,
        functionOperand: (0, parcelRequire("9TMIk")).functionOperand,
        functionString: (0, parcelRequire("23cr9")).functionString,
        argument: (0, parcelRequire("gzGcl")).argument,
        listOperand: (0, parcelRequire("AZ9nU")).listOperand,
        orderBy: (0, parcelRequire("her2D")).orderBy,
        orderByOperator: (0, parcelRequire("k9DKN")).orderByOperator,
        orderByField: (0, parcelRequire("doe2p")).orderByField,
        orderByDirection: (0, parcelRequire("j37YY")).orderByDirection,
        byText: {
            argument: (0, (0, parcelRequire("gzGcl")).argumentByText),
            valueOperand: (0, (0, parcelRequire("eWV0u")).valueOperandByText)
        }
    };
});
parcelRegister("gzGcl", function(module, exports) {
    $parcel$export(module.exports, "argument", ()=>$1f5307df81a07b07$export$6ea29ee575e3f5ff);
    $parcel$export(module.exports, "argumentInternal", ()=>$1f5307df81a07b07$export$5b341d50fa5bcdd5);
    $parcel$export(module.exports, "argumentByText", ()=>$1f5307df81a07b07$export$84c43d23f51170cb);
    var $gq4pj;
    var $2lgiK;
    var $WCvOq;
    function $1f5307df81a07b07$var$acceptArgument(visitor) {
        return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
    }
    function $1f5307df81a07b07$var$enterNode(listener) {
        listener.enterArgument && listener.enterArgument(this);
    }
    function $1f5307df81a07b07$var$exitNode(listener) {
        listener.exitArgument && listener.exitArgument(this);
    }
    const $1f5307df81a07b07$export$6ea29ee575e3f5ff = (value)=>$1f5307df81a07b07$export$5b341d50fa5bcdd5(value, (0, (0, parcelRequire("2lgiK")).sanitiseJqlString)(value));
    const $1f5307df81a07b07$export$84c43d23f51170cb = (text)=>$1f5307df81a07b07$export$5b341d50fa5bcdd5((0, (0, parcelRequire("gq4pj")).normaliseJqlString)(text), text);
    const $1f5307df81a07b07$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $1f5307df81a07b07$var$acceptArgument,
            enterNode: $1f5307df81a07b07$var$enterNode,
            exitNode: $1f5307df81a07b07$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("gq4pj", function(module, exports) {
    $parcel$export(module.exports, "normaliseJqlString", ()=>$dd481207f70e9cdd$export$cecf78a779acc0ff);
    const $dd481207f70e9cdd$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
        if (maybeQuotedString.length < 2) return false;
        return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
    };
    const $dd481207f70e9cdd$export$d5efd6512db694fd = (maybeQuotedString)=>{
        if (maybeQuotedString.length < 2) return false;
        return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
    };
    const $dd481207f70e9cdd$export$b86601123607fee5 = (maybeQuotedString)=>$dd481207f70e9cdd$export$7a0b99b892e0dda8(maybeQuotedString) || $dd481207f70e9cdd$export$d5efd6512db694fd(maybeQuotedString);
    const $dd481207f70e9cdd$export$cecf78a779acc0ff = (maybeQuotedString)=>{
        if ($dd481207f70e9cdd$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
        if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
        return maybeQuotedString;
    };
});
parcelRegister("2lgiK", function(module, exports) {
    $parcel$export(module.exports, "sanitiseJqlString", ()=>$6e52f9b4063b6286$export$3eb9033c48208278);
    var $8QDwl = parcelRequire("8QDwl");
    const $6e52f9b4063b6286$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, ($parcel$interopDefault($8QDwl)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
    const $6e52f9b4063b6286$export$3eb9033c48208278 = (jqlString)=>{
        if ($6e52f9b4063b6286$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
        return jqlString;
    };
});
parcelRegister("8QDwl", function(module, exports) {
    var $jJVtR = parcelRequire("jJVtR");
    var $6711d60dd8e02df4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $6711d60dd8e02df4$var$reHasRegExpChar = RegExp($6711d60dd8e02df4$var$reRegExpChar.source);
    function $6711d60dd8e02df4$var$escapeRegExp(string) {
        string = $jJVtR(string);
        return string && $6711d60dd8e02df4$var$reHasRegExpChar.test(string) ? string.replace($6711d60dd8e02df4$var$reRegExpChar, '\\$&') : string;
    }
    module.exports = $6711d60dd8e02df4$var$escapeRegExp;
});
parcelRegister("WCvOq", function(module, exports) {
    $parcel$export(module.exports, "noChildren", ()=>$90e2b276351fabc1$export$470bef71e654b804);
    $parcel$export(module.exports, "assignParent", ()=>$90e2b276351fabc1$export$a4685923af2913a);
    const $90e2b276351fabc1$export$470bef71e654b804 = ()=>[];
    const $90e2b276351fabc1$export$a4685923af2913a = (node)=>{
        node.getChildren().forEach((child)=>{
            child.parent = node;
        });
    };
});
parcelRegister("awXvh", function(module, exports) {
    $parcel$export(module.exports, "compoundClause", ()=>$3e337dfb3ad8a3f8$export$ab714e56a32c25f2);
    $parcel$export(module.exports, "compoundClauseInternal", ()=>$3e337dfb3ad8a3f8$export$cd65eed8c10b0911);
    var $3AraL;
    var $WCvOq;
    function $3e337dfb3ad8a3f8$var$acceptCompoundClause(visitor) {
        return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
    }
    function $3e337dfb3ad8a3f8$var$enterNode(listener) {
        listener.enterCompoundClause && listener.enterCompoundClause(this);
    }
    function $3e337dfb3ad8a3f8$var$exitNode(listener) {
        listener.exitCompoundClause && listener.exitCompoundClause(this);
    }
    function $3e337dfb3ad8a3f8$var$getChildren() {
        return [
            this.operator,
            ...this.clauses
        ];
    }
    const $3e337dfb3ad8a3f8$export$ab714e56a32c25f2 = (operator, clauses)=>{
        return $3e337dfb3ad8a3f8$export$cd65eed8c10b0911(operator, clauses);
    };
    const $3e337dfb3ad8a3f8$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$2d205682cc545947),
            clauseType: (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b),
            operator: operator,
            clauses: clauses,
            position: position,
            accept: $3e337dfb3ad8a3f8$var$acceptCompoundClause,
            enterNode: $3e337dfb3ad8a3f8$var$enterNode,
            exitNode: $3e337dfb3ad8a3f8$var$exitNode,
            getChildren: $3e337dfb3ad8a3f8$var$getChildren,
            parent: null,
            appendClause: (0, parcelRequire("3AraL")).appendClause,
            remove: (0, parcelRequire("3AraL")).remove,
            removeClause: (0, parcelRequire("3AraL")).removeClause,
            replace: (0, parcelRequire("3AraL")).replace,
            replaceClause: (0, parcelRequire("3AraL")).replaceClause
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
const $e9a0ef16a223cbc7$export$7a58b23488ea076b = 'compound';
const $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a = 'terminal';
const $e9a0ef16a223cbc7$export$e356b89f8c8d2fcb = 'not';
const $c1dc40b7a30d95e8$export$98dda21ec825792 = 'query';
const $c1dc40b7a30d95e8$export$2d205682cc545947 = 'clause';
const $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d = 'operand';
const $c1dc40b7a30d95e8$export$da0f73edded4a63d = 'order_by';
parcelRegister("3AraL", function(module, exports) {
    $parcel$export(module.exports, "appendClause", ()=>appendClause);
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "removeClause", ()=>removeClause);
    $parcel$export(module.exports, "replace", ()=>replace);
    $parcel$export(module.exports, "replaceClause", ()=>replaceClause);
    var $WCvOq;
    function appendClause(clause) {
        let clausesToAppend = [
            clause
        ];
        if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
        this.clauses.push(...clausesToAppend);
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function remove() {
        if (this.parent) this.parent.removeClause(this);
    }
    function removeClause(clause) {
        this.clauses = this.clauses.filter((val)=>val !== clause);
        if (this.clauses.length === 1) this.replace(this.clauses[0]);
        else if (this.clauses.length === 0) this.remove();
    }
    function replace(nextClause) {
        if (this.parent) this.parent.replaceClause(this, nextClause);
    }
    function replaceClause(clause, nextClause) {
        this.clauses = this.clauses.map((child)=>{
            return child === clause ? nextClause : child;
        });
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
});
parcelRegister("3hoxA", function(module, exports) {
    $parcel$export(module.exports, "compoundOperator", ()=>$fe3f499b83b55a64$export$84bb3ebbba491aee);
    $parcel$export(module.exports, "compoundOperatorInternal", ()=>$fe3f499b83b55a64$export$63c33bc3fe74fee6);
    var $WCvOq;
    function $fe3f499b83b55a64$var$acceptCompoundOperator(visitor) {
        return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
    }
    function $fe3f499b83b55a64$var$enterNode(listener) {
        listener.enterCompoundOperator && listener.enterCompoundOperator(this);
    }
    function $fe3f499b83b55a64$var$exitNode(listener) {
        listener.exitCompoundOperator && listener.exitCompoundOperator(this);
    }
    const $fe3f499b83b55a64$export$84bb3ebbba491aee = (value)=>$fe3f499b83b55a64$export$63c33bc3fe74fee6(value, []);
    const $fe3f499b83b55a64$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
            value: value,
            positions: operatorPositions,
            position: null,
            accept: $fe3f499b83b55a64$var$acceptCompoundOperator,
            enterNode: $fe3f499b83b55a64$var$enterNode,
            exitNode: $fe3f499b83b55a64$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("2TUEL", function(module, exports) {
    $parcel$export(module.exports, "field", ()=>$1c31156a69528c72$export$e0f35d825088c098);
    $parcel$export(module.exports, "fieldInternal", ()=>$1c31156a69528c72$export$2193f8c541622b6);
    var $2lgiK;
    var $WCvOq;
    function $1c31156a69528c72$var$acceptField(visitor) {
        return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
    }
    function $1c31156a69528c72$var$enterNode(listener) {
        listener.enterField && listener.enterField(this);
    }
    function $1c31156a69528c72$var$exitNode(listener) {
        listener.exitField && listener.exitField(this);
    }
    function $1c31156a69528c72$var$getChildren() {
        return this.properties ? [
            ...this.properties
        ] : [];
    }
    const $1c31156a69528c72$export$e0f35d825088c098 = (value, properties)=>{
        return $1c31156a69528c72$export$2193f8c541622b6(value, (0, (0, parcelRequire("2lgiK")).sanitiseJqlString)(value), properties);
    };
    const $1c31156a69528c72$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
        const node = {
            text: text,
            value: value,
            properties: properties,
            position: position,
            accept: $1c31156a69528c72$var$acceptField,
            enterNode: $1c31156a69528c72$var$enterNode,
            exitNode: $1c31156a69528c72$var$exitNode,
            getChildren: $1c31156a69528c72$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("9TMIk", function(module, exports) {
    $parcel$export(module.exports, "functionOperand", ()=>$413f1d947acf321b$export$4f981b0e83488ce);
    $parcel$export(module.exports, "functionOperandInternal", ()=>$413f1d947acf321b$export$c1f2ce91dc05872a);
    var $WCvOq;
    function $413f1d947acf321b$var$acceptFunctionOperand(visitor) {
        return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
    }
    function $413f1d947acf321b$var$enterNode(listener) {
        listener.enterFunctionOperand && listener.enterFunctionOperand(this);
    }
    function $413f1d947acf321b$var$exitNode(listener) {
        listener.exitFunctionOperand && listener.exitFunctionOperand(this);
    }
    function $413f1d947acf321b$var$getChildren() {
        return [
            this.function,
            ...this.arguments
        ];
    }
    const $413f1d947acf321b$export$4f981b0e83488ce = (functionString, args = [])=>$413f1d947acf321b$export$c1f2ce91dc05872a(functionString, args);
    const $413f1d947acf321b$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
            operandType: (0, $49b29ef7baa2a152$export$19c7c729db381f9d),
            function: functionString,
            arguments: args,
            position: position,
            accept: $413f1d947acf321b$var$acceptFunctionOperand,
            enterNode: $413f1d947acf321b$var$enterNode,
            exitNode: $413f1d947acf321b$var$exitNode,
            getChildren: $413f1d947acf321b$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
const $49b29ef7baa2a152$export$38accfc5a5d1c113 = 'value';
const $49b29ef7baa2a152$export$f6049126fd97001f = 'keyword';
const $49b29ef7baa2a152$export$19c7c729db381f9d = 'function';
const $49b29ef7baa2a152$export$fabec4aebba3f4df = 'list';
const $49b29ef7baa2a152$export$1c46dca02aac24dd = 'empty';
parcelRegister("23cr9", function(module, exports) {
    $parcel$export(module.exports, "functionString", ()=>$a67350f9199f98c5$export$4e1bb9a7ff8d0ef9);
    $parcel$export(module.exports, "functionStringInternal", ()=>$a67350f9199f98c5$export$7aa9944588b7a69f);
    var $2lgiK;
    var $WCvOq;
    function $a67350f9199f98c5$var$acceptFunctionString(visitor) {
        return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
    }
    function $a67350f9199f98c5$var$enterNode(listener) {
        listener.enterFunction && listener.enterFunction(this);
    }
    function $a67350f9199f98c5$var$exitNode(listener) {
        listener.exitFunction && listener.exitFunction(this);
    }
    const $a67350f9199f98c5$export$4e1bb9a7ff8d0ef9 = (value)=>$a67350f9199f98c5$export$7aa9944588b7a69f(value, (0, (0, parcelRequire("2lgiK")).sanitiseJqlString)(value));
    const $a67350f9199f98c5$export$7aa9944588b7a69f = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $a67350f9199f98c5$var$acceptFunctionString,
            enterNode: $a67350f9199f98c5$var$enterNode,
            exitNode: $a67350f9199f98c5$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("an0VC", function(module, exports) {
    $parcel$export(module.exports, "jast", ()=>$99ec58cecea09c23$export$b9e70a00f479ff43);
    const $99ec58cecea09c23$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
            query: query,
            represents: represents,
            errors: errors
        });
});
parcelRegister("kO6UE", function(module, exports) {
    $parcel$export(module.exports, "keywordOperand", ()=>$374a6d53e0ec4f5c$export$2edd4971ed69f2ce);
    $parcel$export(module.exports, "keywordOperandInternal", ()=>$374a6d53e0ec4f5c$export$7cc55480b054047b);
    var $WCvOq;
    function $374a6d53e0ec4f5c$var$acceptKeywordOperand(visitor) {
        return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
    }
    function $374a6d53e0ec4f5c$var$enterNode(listener) {
        listener.enterKeywordOperand && listener.enterKeywordOperand(this);
    }
    function $374a6d53e0ec4f5c$var$exitNode(listener) {
        listener.exitKeywordOperand && listener.exitKeywordOperand(this);
    }
    const $374a6d53e0ec4f5c$export$2edd4971ed69f2ce = ()=>$374a6d53e0ec4f5c$export$7cc55480b054047b((0, $49b29ef7baa2a152$export$1c46dca02aac24dd));
    const $374a6d53e0ec4f5c$export$7cc55480b054047b = (value, position = null)=>({
            type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
            operandType: (0, $49b29ef7baa2a152$export$f6049126fd97001f),
            value: value,
            position: position,
            accept: $374a6d53e0ec4f5c$var$acceptKeywordOperand,
            enterNode: $374a6d53e0ec4f5c$var$enterNode,
            exitNode: $374a6d53e0ec4f5c$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("AZ9nU", function(module, exports) {
    $parcel$export(module.exports, "listOperand", ()=>$c52de47ddabd701d$export$769866c3e9d41d50);
    $parcel$export(module.exports, "listOperandInternal", ()=>$c52de47ddabd701d$export$663c7831528c984b);
    var $eDTUO;
    var $WCvOq;
    function $c52de47ddabd701d$var$acceptListOperand(visitor) {
        return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
    }
    function $c52de47ddabd701d$var$enterNode(listener) {
        listener.enterListOperand && listener.enterListOperand(this);
    }
    function $c52de47ddabd701d$var$exitNode(listener) {
        listener.exitListOperand && listener.exitListOperand(this);
    }
    function $c52de47ddabd701d$var$getChildren() {
        return [
            ...this.values
        ];
    }
    const $c52de47ddabd701d$export$769866c3e9d41d50 = (values)=>$c52de47ddabd701d$export$663c7831528c984b(values);
    const $c52de47ddabd701d$export$663c7831528c984b = (values, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
            operandType: (0, $49b29ef7baa2a152$export$fabec4aebba3f4df),
            values: values,
            position: position,
            accept: $c52de47ddabd701d$var$acceptListOperand,
            enterNode: $c52de47ddabd701d$var$enterNode,
            exitNode: $c52de47ddabd701d$var$exitNode,
            getChildren: $c52de47ddabd701d$var$getChildren,
            parent: null,
            appendOperand: (0, parcelRequire("eDTUO")).appendOperand
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("eDTUO", function(module, exports) {
    $parcel$export(module.exports, "appendOperand", ()=>$9a86be0ad84d7cf1$export$d94c54f1aee177c4);
    var $WCvOq;
    function $9a86be0ad84d7cf1$export$d94c54f1aee177c4(operand) {
        this.values.push(...operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df) ? operand.values : [
            operand
        ]);
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
});
parcelRegister("9HHq9", function(module, exports) {
    $parcel$export(module.exports, "notClause", ()=>$ed106cb5124eff4e$export$b4734a9fedb4d44e);
    $parcel$export(module.exports, "notClauseInternal", ()=>$ed106cb5124eff4e$export$b25621824fea4548);
    var $fjrwK;
    var $WCvOq;
    var $6qN6D;
    function $ed106cb5124eff4e$var$acceptNotClause(visitor) {
        return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
    }
    function $ed106cb5124eff4e$var$enterNode(listener) {
        listener.enterNotClause && listener.enterNotClause(this);
    }
    function $ed106cb5124eff4e$var$exitNode(listener) {
        listener.exitNotClause && listener.exitNotClause(this);
    }
    function $ed106cb5124eff4e$var$getChildren() {
        return [
            this.operator,
            this.clause
        ];
    }
    const $ed106cb5124eff4e$export$b4734a9fedb4d44e = (clause)=>{
        return $ed106cb5124eff4e$export$b25621824fea4548(clause, (0, (0, parcelRequire("6qN6D")).notClauseOperator)());
    };
    const $ed106cb5124eff4e$export$b25621824fea4548 = (clause, operator, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$2d205682cc545947),
            clauseType: (0, $e9a0ef16a223cbc7$export$e356b89f8c8d2fcb),
            clause: clause,
            operator: operator,
            position: position,
            accept: $ed106cb5124eff4e$var$acceptNotClause,
            enterNode: $ed106cb5124eff4e$var$enterNode,
            exitNode: $ed106cb5124eff4e$var$exitNode,
            getChildren: $ed106cb5124eff4e$var$getChildren,
            parent: null,
            remove: (0, parcelRequire("fjrwK")).remove,
            removeClause: (0, parcelRequire("fjrwK")).removeClause,
            replace: (0, parcelRequire("fjrwK")).replace,
            replaceClause: (0, parcelRequire("fjrwK")).replaceClause
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("fjrwK", function(module, exports) {
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "removeClause", ()=>removeClause);
    $parcel$export(module.exports, "replace", ()=>replace);
    $parcel$export(module.exports, "replaceClause", ()=>replaceClause);
    var $WCvOq;
    function remove() {
        if (this.parent) this.parent.removeClause(this);
    }
    function removeClause(clause) {
        if (this.clause === clause) this.remove();
    }
    function replace(nextClause) {
        if (this.parent) this.parent.replaceClause(this, nextClause);
    }
    function replaceClause(clause, nextClause) {
        if (this.clause === clause) {
            this.clause = nextClause;
            (0, (0, parcelRequire("WCvOq")).assignParent)(this);
        }
    }
});
parcelRegister("6qN6D", function(module, exports) {
    $parcel$export(module.exports, "notClauseOperator", ()=>$467f41c633037180$export$d2cd8239f99c13d3);
    $parcel$export(module.exports, "notClauseOperatorInternal", ()=>$467f41c633037180$export$1b15a32bb57b9020);
    var $bzbto;
    var $WCvOq;
    function $467f41c633037180$var$acceptNotClauseOperator(visitor) {
        return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
    }
    function $467f41c633037180$var$enterNode(listener) {
        listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
    }
    function $467f41c633037180$var$exitNode(listener) {
        listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
    }
    const $467f41c633037180$export$d2cd8239f99c13d3 = ()=>$467f41c633037180$export$1b15a32bb57b9020();
    const $467f41c633037180$export$1b15a32bb57b9020 = (position = null)=>({
            value: (0, (0, parcelRequire("bzbto")).CLAUSE_OPERATOR_NOT),
            position: position,
            accept: $467f41c633037180$var$acceptNotClauseOperator,
            enterNode: $467f41c633037180$var$enterNode,
            exitNode: $467f41c633037180$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("bzbto", function(module, exports) {
    $parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", ()=>$bee8c61d429e7e04$export$c6c71ceedb15cda9);
    $parcel$export(module.exports, "OPERATOR_EQUALS", ()=>$bee8c61d429e7e04$export$466517a888d00195);
    $parcel$export(module.exports, "OPERATOR_NOT_EQUALS", ()=>$bee8c61d429e7e04$export$6d0d8810623974a5);
    $parcel$export(module.exports, "OPERATOR_GT", ()=>$bee8c61d429e7e04$export$bcbb090ab3c498b3);
    $parcel$export(module.exports, "OPERATOR_LT", ()=>$bee8c61d429e7e04$export$4bf1a4aa659c6ea4);
    $parcel$export(module.exports, "OPERATOR_GT_EQUALS", ()=>$bee8c61d429e7e04$export$83ce674214a54b2a);
    $parcel$export(module.exports, "OPERATOR_LT_EQUALS", ()=>$bee8c61d429e7e04$export$9629fd1727ef62ee);
    $parcel$export(module.exports, "OPERATOR_IN", ()=>$bee8c61d429e7e04$export$c4e3fb55e320e979);
    $parcel$export(module.exports, "OPERATOR_NOT_IN", ()=>$bee8c61d429e7e04$export$f9857532eaa24ddc);
    $parcel$export(module.exports, "OPERATOR_LIKE", ()=>$bee8c61d429e7e04$export$221595834b8766ab);
    $parcel$export(module.exports, "OPERATOR_NOT_LIKE", ()=>$bee8c61d429e7e04$export$fcefabf94a9bffbf);
    $parcel$export(module.exports, "OPERATOR_IS", ()=>$bee8c61d429e7e04$export$4feeb3f4ff56bcef);
    $parcel$export(module.exports, "OPERATOR_IS_NOT", ()=>$bee8c61d429e7e04$export$d08d969a0da27188);
    $parcel$export(module.exports, "OPERATOR_WAS", ()=>$bee8c61d429e7e04$export$8f907e179985256d);
    $parcel$export(module.exports, "OPERATOR_WAS_IN", ()=>$bee8c61d429e7e04$export$cc7b9d0b3ee23193);
    $parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", ()=>$bee8c61d429e7e04$export$585d3c004af078bb);
    $parcel$export(module.exports, "OPERATOR_WAS_NOT", ()=>$bee8c61d429e7e04$export$123eaa9ccc2d9445);
    $parcel$export(module.exports, "OPERATOR_CHANGED", ()=>$bee8c61d429e7e04$export$15f5b446ba8c941e);
    $parcel$export(module.exports, "EQUALS_OPERATORS", ()=>$bee8c61d429e7e04$export$643c6101f3fc8547);
    $parcel$export(module.exports, "LIKE_OPERATORS", ()=>$bee8c61d429e7e04$export$329664c9cf18cca6);
    $parcel$export(module.exports, "COMPARISON_OPERATORS", ()=>$bee8c61d429e7e04$export$1b167a3705885a8b);
    $parcel$export(module.exports, "IN_OPERATORS", ()=>$bee8c61d429e7e04$export$f25cf16c2270312f);
    $parcel$export(module.exports, "IS_OPERATORS", ()=>$bee8c61d429e7e04$export$eb58cfffe4a6b805);
    $parcel$export(module.exports, "WAS_OPERATORS", ()=>$bee8c61d429e7e04$export$c22a981f581de218);
    $parcel$export(module.exports, "WAS_IN_OPERATORS", ()=>$bee8c61d429e7e04$export$6d08c4699bb75284);
    $parcel$export(module.exports, "CHANGED_OPERATORS", ()=>$bee8c61d429e7e04$export$b7dc214eef214c1c);
    $parcel$export(module.exports, "OPERATORS", ()=>$bee8c61d429e7e04$export$184799fc79ccac89);
    $parcel$export(module.exports, "LIST_OPERATORS", ()=>$bee8c61d429e7e04$export$77c793736847e030);
    const $bee8c61d429e7e04$export$c6c71ceedb15cda9 = 'not';
    const $bee8c61d429e7e04$export$466517a888d00195 = '=';
    const $bee8c61d429e7e04$export$6d0d8810623974a5 = '!=';
    const $bee8c61d429e7e04$export$bcbb090ab3c498b3 = '>';
    const $bee8c61d429e7e04$export$4bf1a4aa659c6ea4 = '<';
    const $bee8c61d429e7e04$export$83ce674214a54b2a = '>=';
    const $bee8c61d429e7e04$export$9629fd1727ef62ee = '<=';
    const $bee8c61d429e7e04$export$c4e3fb55e320e979 = 'in';
    const $bee8c61d429e7e04$export$f9857532eaa24ddc = 'not in';
    const $bee8c61d429e7e04$export$221595834b8766ab = '~';
    const $bee8c61d429e7e04$export$fcefabf94a9bffbf = '!~';
    const $bee8c61d429e7e04$export$4feeb3f4ff56bcef = 'is';
    const $bee8c61d429e7e04$export$d08d969a0da27188 = 'is not';
    const $bee8c61d429e7e04$export$8f907e179985256d = 'was';
    const $bee8c61d429e7e04$export$cc7b9d0b3ee23193 = 'was in';
    const $bee8c61d429e7e04$export$585d3c004af078bb = 'was not in';
    const $bee8c61d429e7e04$export$123eaa9ccc2d9445 = 'was not';
    const $bee8c61d429e7e04$export$15f5b446ba8c941e = 'changed';
    const $bee8c61d429e7e04$export$643c6101f3fc8547 = [
        $bee8c61d429e7e04$export$466517a888d00195,
        $bee8c61d429e7e04$export$6d0d8810623974a5
    ];
    const $bee8c61d429e7e04$export$329664c9cf18cca6 = [
        $bee8c61d429e7e04$export$221595834b8766ab,
        $bee8c61d429e7e04$export$fcefabf94a9bffbf
    ];
    const $bee8c61d429e7e04$export$1b167a3705885a8b = [
        $bee8c61d429e7e04$export$4bf1a4aa659c6ea4,
        $bee8c61d429e7e04$export$bcbb090ab3c498b3,
        $bee8c61d429e7e04$export$9629fd1727ef62ee,
        $bee8c61d429e7e04$export$83ce674214a54b2a
    ];
    const $bee8c61d429e7e04$export$f25cf16c2270312f = [
        $bee8c61d429e7e04$export$c4e3fb55e320e979,
        $bee8c61d429e7e04$export$f9857532eaa24ddc
    ];
    const $bee8c61d429e7e04$export$eb58cfffe4a6b805 = [
        $bee8c61d429e7e04$export$4feeb3f4ff56bcef,
        $bee8c61d429e7e04$export$d08d969a0da27188
    ];
    const $bee8c61d429e7e04$export$c22a981f581de218 = [
        $bee8c61d429e7e04$export$8f907e179985256d,
        $bee8c61d429e7e04$export$123eaa9ccc2d9445
    ];
    const $bee8c61d429e7e04$export$6d08c4699bb75284 = [
        $bee8c61d429e7e04$export$cc7b9d0b3ee23193,
        $bee8c61d429e7e04$export$585d3c004af078bb
    ];
    const $bee8c61d429e7e04$export$b7dc214eef214c1c = [
        $bee8c61d429e7e04$export$15f5b446ba8c941e
    ];
    const $bee8c61d429e7e04$export$184799fc79ccac89 = [
        ...$bee8c61d429e7e04$export$643c6101f3fc8547,
        ...$bee8c61d429e7e04$export$329664c9cf18cca6,
        ...$bee8c61d429e7e04$export$1b167a3705885a8b,
        ...$bee8c61d429e7e04$export$f25cf16c2270312f,
        ...$bee8c61d429e7e04$export$eb58cfffe4a6b805,
        ...$bee8c61d429e7e04$export$c22a981f581de218,
        ...$bee8c61d429e7e04$export$6d08c4699bb75284,
        ...$bee8c61d429e7e04$export$b7dc214eef214c1c
    ];
    const $bee8c61d429e7e04$export$77c793736847e030 = [
        $bee8c61d429e7e04$export$c4e3fb55e320e979,
        $bee8c61d429e7e04$export$f9857532eaa24ddc,
        $bee8c61d429e7e04$export$cc7b9d0b3ee23193,
        $bee8c61d429e7e04$export$585d3c004af078bb
    ];
});
parcelRegister("3J4gf", function(module, exports) {
    $parcel$export(module.exports, "operator", ()=>$6fd03a148f63af84$export$dbd72860f701d4f3);
    $parcel$export(module.exports, "operatorInternal", ()=>$6fd03a148f63af84$export$649025bc60ab9c3b);
    var $WCvOq;
    function $6fd03a148f63af84$var$acceptOperator(visitor) {
        return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
    }
    function $6fd03a148f63af84$var$enterNode(listener) {
        listener.enterOperator && listener.enterOperator(this);
    }
    function $6fd03a148f63af84$var$exitNode(listener) {
        listener.exitOperator && listener.exitOperator(this);
    }
    const $6fd03a148f63af84$export$dbd72860f701d4f3 = (value)=>$6fd03a148f63af84$export$649025bc60ab9c3b(value, value);
    const $6fd03a148f63af84$export$649025bc60ab9c3b = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $6fd03a148f63af84$var$acceptOperator,
            enterNode: $6fd03a148f63af84$var$enterNode,
            exitNode: $6fd03a148f63af84$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("her2D", function(module, exports) {
    $parcel$export(module.exports, "orderBy", ()=>$37cf08d9a2045c25$export$f18af21d6f4dafd8);
    $parcel$export(module.exports, "orderByInternal", ()=>$37cf08d9a2045c25$export$e4eb1fa6bc8465c1);
    var $5HQt3;
    var $WCvOq;
    var $k9DKN;
    function $37cf08d9a2045c25$var$acceptOrderBy(visitor) {
        return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
    }
    function $37cf08d9a2045c25$var$enterNode(listener) {
        listener.enterOrderBy && listener.enterOrderBy(this);
    }
    function $37cf08d9a2045c25$var$exitNode(listener) {
        listener.exitOrderBy && listener.exitOrderBy(this);
    }
    function $37cf08d9a2045c25$var$getChildren() {
        return [
            this.operator,
            ...this.fields
        ];
    }
    const $37cf08d9a2045c25$export$f18af21d6f4dafd8 = (fields)=>{
        return $37cf08d9a2045c25$export$e4eb1fa6bc8465c1(fields, (0, (0, parcelRequire("k9DKN")).orderByOperator)());
    };
    const $37cf08d9a2045c25$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$da0f73edded4a63d),
            operator: operator,
            fields: fields,
            position: position,
            accept: $37cf08d9a2045c25$var$acceptOrderBy,
            enterNode: $37cf08d9a2045c25$var$enterNode,
            exitNode: $37cf08d9a2045c25$var$exitNode,
            getChildren: $37cf08d9a2045c25$var$getChildren,
            parent: null,
            prependOrderField: (0, parcelRequire("5HQt3")).prependOrderField,
            setOrderDirection: (0, parcelRequire("5HQt3")).setOrderDirection,
            replace: (0, parcelRequire("5HQt3")).replace,
            replaceOrderField: (0, parcelRequire("5HQt3")).replaceOrderField,
            remove: (0, parcelRequire("5HQt3")).remove,
            removeOrderField: (0, parcelRequire("5HQt3")).removeOrderField
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("5HQt3", function(module, exports) {
    $parcel$export(module.exports, "prependOrderField", ()=>prependOrderField);
    $parcel$export(module.exports, "setOrderDirection", ()=>setOrderDirection);
    $parcel$export(module.exports, "replace", ()=>replace);
    $parcel$export(module.exports, "replaceOrderField", ()=>replaceOrderField);
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "removeOrderField", ()=>removeOrderField);
    var $WCvOq;
    function prependOrderField(orderField) {
        this.fields.unshift(orderField);
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function setOrderDirection(orderDirection) {
        if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
    }
    function replace(nextOrderBy) {
        if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
    }
    function replaceOrderField(orderByField, nextOrderByField) {
        this.fields = this.fields.map((child)=>{
            return child === orderByField ? nextOrderByField : child;
        });
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function remove() {
        if (this.parent) this.parent.removeOrderBy();
    }
    function removeOrderField(orderByField) {
        this.fields = this.fields.filter((field)=>field !== orderByField);
        if (this.fields.length === 0) this.remove();
    }
});
parcelRegister("k9DKN", function(module, exports) {
    $parcel$export(module.exports, "orderByOperator", ()=>$0824f859de091a85$export$c7307b67924c61ea);
    $parcel$export(module.exports, "orderByOperatorInternal", ()=>$0824f859de091a85$export$739e30af23a08da0);
    var $WCvOq;
    function $0824f859de091a85$var$acceptOrderByOperator(visitor) {
        return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
    }
    function $0824f859de091a85$var$enterNode(listener) {
        listener.enterOrderByOperator && listener.enterOrderByOperator(this);
    }
    function $0824f859de091a85$var$exitNode(listener) {
        listener.exitOrderByOperator && listener.exitOrderByOperator(this);
    }
    const $0824f859de091a85$export$c7307b67924c61ea = ()=>$0824f859de091a85$export$739e30af23a08da0();
    const $0824f859de091a85$export$739e30af23a08da0 = (position = null)=>({
            value: (0, $9f1dbb2b39d4d9a2$export$ca51f5fd60a74517),
            position: position,
            accept: $0824f859de091a85$var$acceptOrderByOperator,
            enterNode: $0824f859de091a85$var$enterNode,
            exitNode: $0824f859de091a85$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
const $9f1dbb2b39d4d9a2$export$ca51f5fd60a74517 = 'ORDER BY';
const $9f1dbb2b39d4d9a2$export$6d60017b9e092e73 = 'ASC';
const $9f1dbb2b39d4d9a2$export$2ea27ea5f2121899 = 'DESC';
parcelRegister("j37YY", function(module, exports) {
    $parcel$export(module.exports, "orderByDirection", ()=>$c155c373ff42c873$export$864d934efed3ccaa);
    $parcel$export(module.exports, "orderByDirectionInternal", ()=>$c155c373ff42c873$export$8c65cac1a7852d1f);
    var $WCvOq;
    function $c155c373ff42c873$var$acceptOrderByDirection(visitor) {
        return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
    }
    function $c155c373ff42c873$var$enterNode(listener) {
        listener.enterOrderByDirection && listener.enterOrderByDirection(this);
    }
    function $c155c373ff42c873$var$exitNode(listener) {
        listener.exitOrderByDirection && listener.exitOrderByDirection(this);
    }
    const $c155c373ff42c873$export$864d934efed3ccaa = (value)=>$c155c373ff42c873$export$8c65cac1a7852d1f(value);
    const $c155c373ff42c873$export$8c65cac1a7852d1f = (value, position = null)=>({
            value: value,
            position: position,
            accept: $c155c373ff42c873$var$acceptOrderByDirection,
            enterNode: $c155c373ff42c873$var$enterNode,
            exitNode: $c155c373ff42c873$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("doe2p", function(module, exports) {
    $parcel$export(module.exports, "orderByField", ()=>$b5422aff91034201$export$942df63e5e3d3899);
    $parcel$export(module.exports, "orderByFieldInternal", ()=>$b5422aff91034201$export$661a7786e3d15926);
    var $g2iOq;
    var $WCvOq;
    function $b5422aff91034201$var$acceptOrderByField(visitor) {
        return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
    }
    function $b5422aff91034201$var$enterNode(listener) {
        listener.enterOrderByField && listener.enterOrderByField(this);
    }
    function $b5422aff91034201$var$exitNode(listener) {
        listener.exitOrderByField && listener.exitOrderByField(this);
    }
    function $b5422aff91034201$var$getChildren() {
        const children = [
            this.field
        ];
        if (this.direction) children.push(this.direction);
        return children;
    }
    const $b5422aff91034201$export$942df63e5e3d3899 = (field, direction)=>$b5422aff91034201$export$661a7786e3d15926(field, direction);
    const $b5422aff91034201$export$661a7786e3d15926 = (field, direction, position = null)=>{
        const node = {
            field: field,
            direction: direction,
            position: position,
            accept: $b5422aff91034201$var$acceptOrderByField,
            enterNode: $b5422aff91034201$var$enterNode,
            exitNode: $b5422aff91034201$var$exitNode,
            getChildren: $b5422aff91034201$var$getChildren,
            parent: null,
            setOrderDirection: (0, parcelRequire("g2iOq")).setOrderDirection,
            replace: (0, parcelRequire("g2iOq")).replace,
            remove: (0, parcelRequire("g2iOq")).remove
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("g2iOq", function(module, exports) {
    $parcel$export(module.exports, "setOrderDirection", ()=>$27f36e283e6ff201$export$b596730931a09703);
    $parcel$export(module.exports, "replace", ()=>$27f36e283e6ff201$export$77ad94ebf1c2b9ed);
    $parcel$export(module.exports, "remove", ()=>$27f36e283e6ff201$export$cd7f480d6b8286c3);
    var $WCvOq;
    function $27f36e283e6ff201$export$b596730931a09703(orderDirection) {
        this.direction = orderDirection;
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function $27f36e283e6ff201$export$77ad94ebf1c2b9ed(orderByField) {
        if (this.parent) this.parent.replaceOrderField(this, orderByField);
    }
    function $27f36e283e6ff201$export$cd7f480d6b8286c3() {
        if (this.parent) this.parent.removeOrderField(this);
    }
});
parcelRegister("jRA9z", function(module, exports) {
    $parcel$export(module.exports, "predicate", ()=>$ff1c73953498b7ec$export$5fc51e445ce24faf);
    $parcel$export(module.exports, "predicateInternal", ()=>$ff1c73953498b7ec$export$a767a27ad05a38a2);
    var $WCvOq;
    function $ff1c73953498b7ec$var$acceptPredicate(visitor) {
        return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
    }
    function $ff1c73953498b7ec$var$enterNode(listener) {
        listener.enterPredicate && listener.enterPredicate(this);
    }
    function $ff1c73953498b7ec$var$exitNode(listener) {
        listener.exitPredicate && listener.exitPredicate(this);
    }
    function $ff1c73953498b7ec$var$getChildren() {
        const children = [
            this.operator
        ];
        if (this.operand) children.push(this.operand);
        return children;
    }
    const $ff1c73953498b7ec$export$5fc51e445ce24faf = (operator, operand)=>$ff1c73953498b7ec$export$a767a27ad05a38a2(operator, operand);
    const $ff1c73953498b7ec$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
        const node = {
            operator: operator,
            operand: operand,
            position: position,
            accept: $ff1c73953498b7ec$var$acceptPredicate,
            enterNode: $ff1c73953498b7ec$var$enterNode,
            exitNode: $ff1c73953498b7ec$var$exitNode,
            getChildren: $ff1c73953498b7ec$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("bF1Nb", function(module, exports) {
    $parcel$export(module.exports, "predicateOperator", ()=>$fb65b796ae9eab4e$export$5419b7f16910ea62);
    $parcel$export(module.exports, "predicateOperatorInternal", ()=>$fb65b796ae9eab4e$export$c69d893689716768);
    var $WCvOq;
    function $fb65b796ae9eab4e$var$acceptPredicateOperator(visitor) {
        return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
    }
    function $fb65b796ae9eab4e$var$enterNode(listener) {
        listener.enterPredicateOperator && listener.enterPredicateOperator(this);
    }
    function $fb65b796ae9eab4e$var$exitNode(listener) {
        listener.exitPredicateOperator && listener.exitPredicateOperator(this);
    }
    const $fb65b796ae9eab4e$export$5419b7f16910ea62 = (value)=>$fb65b796ae9eab4e$export$c69d893689716768(value, value);
    const $fb65b796ae9eab4e$export$c69d893689716768 = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $fb65b796ae9eab4e$var$acceptPredicateOperator,
            enterNode: $fb65b796ae9eab4e$var$enterNode,
            exitNode: $fb65b796ae9eab4e$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("bW5aY", function(module, exports) {
    $parcel$export(module.exports, "property", ()=>$1f1ea1ef09d97bb3$export$d541bacb2bda4494);
    $parcel$export(module.exports, "propertyInternal", ()=>$1f1ea1ef09d97bb3$export$1cbd90994fef1fad);
    var $WCvOq;
    function $1f1ea1ef09d97bb3$var$acceptProperty(visitor) {
        return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
    }
    function $1f1ea1ef09d97bb3$var$enterNode(listener) {
        listener.enterProperty && listener.enterProperty(this);
    }
    function $1f1ea1ef09d97bb3$var$exitNode(listener) {
        listener.exitProperty && listener.exitProperty(this);
    }
    function $1f1ea1ef09d97bb3$var$getChildren() {
        const children = [];
        if (this.key) children.push(this.key);
        if (this.path) return children.concat(this.path);
        return children;
    }
    const $1f1ea1ef09d97bb3$export$d541bacb2bda4494 = (key, path = [])=>$1f1ea1ef09d97bb3$export$1cbd90994fef1fad(key, path);
    const $1f1ea1ef09d97bb3$export$1cbd90994fef1fad = (key, path, position = null)=>{
        const node = {
            key: key,
            path: path,
            position: position,
            accept: $1f1ea1ef09d97bb3$var$acceptProperty,
            enterNode: $1f1ea1ef09d97bb3$var$enterNode,
            exitNode: $1f1ea1ef09d97bb3$var$exitNode,
            getChildren: $1f1ea1ef09d97bb3$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("dgZwd", function(module, exports) {
    $parcel$export(module.exports, "query", ()=>$3aa450a0eb1b166a$export$2fa187e846a241c4);
    $parcel$export(module.exports, "queryInternal", ()=>$3aa450a0eb1b166a$export$bc2d6e2e1fd9014);
    var $aqdKa;
    var $WCvOq;
    function $3aa450a0eb1b166a$var$acceptQuery(visitor) {
        return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
    }
    function $3aa450a0eb1b166a$var$enterNode(listener) {
        listener.enterQuery && listener.enterQuery(this);
    }
    function $3aa450a0eb1b166a$var$exitNode(listener) {
        listener.exitQuery && listener.exitQuery(this);
    }
    function $3aa450a0eb1b166a$var$getChildren() {
        const children = [];
        if (this.where) children.push(this.where);
        if (this.orderBy) children.push(this.orderBy);
        return children;
    }
    const $3aa450a0eb1b166a$export$2fa187e846a241c4 = (where, orderBy)=>$3aa450a0eb1b166a$export$bc2d6e2e1fd9014(where, orderBy);
    const $3aa450a0eb1b166a$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$98dda21ec825792),
            where: where,
            orderBy: orderBy,
            position: position,
            accept: $3aa450a0eb1b166a$var$acceptQuery,
            enterNode: $3aa450a0eb1b166a$var$enterNode,
            exitNode: $3aa450a0eb1b166a$var$exitNode,
            getChildren: $3aa450a0eb1b166a$var$getChildren,
            parent: null,
            appendClause: (0, parcelRequire("aqdKa")).appendClause,
            prependOrderField: (0, parcelRequire("aqdKa")).prependOrderField,
            setOrderDirection: (0, parcelRequire("aqdKa")).setOrderDirection,
            removeClause: (0, parcelRequire("aqdKa")).removeClause,
            replaceClause: (0, parcelRequire("aqdKa")).replaceClause,
            replaceOrderBy: (0, parcelRequire("aqdKa")).replaceOrderBy,
            removeOrderBy: (0, parcelRequire("aqdKa")).removeOrderBy
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("aqdKa", function(module, exports) {
    $parcel$export(module.exports, "appendClause", ()=>appendClause);
    $parcel$export(module.exports, "prependOrderField", ()=>prependOrderField);
    $parcel$export(module.exports, "setOrderDirection", ()=>setOrderDirection);
    $parcel$export(module.exports, "removeClause", ()=>removeClause);
    $parcel$export(module.exports, "replaceOrderBy", ()=>replaceOrderBy);
    $parcel$export(module.exports, "replaceClause", ()=>replaceClause);
    $parcel$export(module.exports, "removeOrderBy", ()=>removeOrderBy);
    var $iEIQF;
    var $WCvOq;
    function appendClause(clause, compoundOperatorValue) {
        if (!this.where) this.where = clause;
        else {
            const nextCompoundOperator = (0, (0, parcelRequire("iEIQF")).default).compoundOperator(compoundOperatorValue);
            const nextClause = (0, (0, parcelRequire("iEIQF")).default).compoundClause(nextCompoundOperator, []);
            nextClause.appendClause(this.where);
            nextClause.appendClause(clause);
            this.where = nextClause;
        }
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function prependOrderField(orderField) {
        if (!this.orderBy) {
            this.orderBy = (0, (0, parcelRequire("iEIQF")).default).orderBy([
                orderField
            ]);
            (0, (0, parcelRequire("WCvOq")).assignParent)(this);
        } else this.orderBy.prependOrderField(orderField);
    }
    function setOrderDirection(orderDirection) {
        if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
    }
    function removeClause(clause) {
        if (this.where === clause) this.where = undefined;
    }
    function replaceOrderBy(orderBy) {
        if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
        else {
            this.orderBy = orderBy;
            (0, (0, parcelRequire("WCvOq")).assignParent)(this);
        }
    }
    function replaceClause(clause, nextClause) {
        if (this.where === clause) {
            this.where = nextClause;
            (0, (0, parcelRequire("WCvOq")).assignParent)(this);
        }
    }
    function removeOrderBy() {
        this.orderBy = undefined;
    }
});
parcelRegister("1zQFd", function(module, exports) {
    $parcel$export(module.exports, "terminalClause", ()=>$ad22ef70da25a752$export$2627cbe08dd86b00);
    $parcel$export(module.exports, "terminalClauseInternal", ()=>$ad22ef70da25a752$export$cc08e43598d091fc);
    var $b6t5q;
    var $WCvOq;
    function $ad22ef70da25a752$var$acceptTerminalClause(visitor) {
        return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
    }
    function $ad22ef70da25a752$var$enterNode(listener) {
        listener.enterTerminalClause && listener.enterTerminalClause(this);
    }
    function $ad22ef70da25a752$var$exitNode(listener) {
        listener.exitTerminalClause && listener.exitTerminalClause(this);
    }
    function $ad22ef70da25a752$var$getChildren() {
        const children = [
            this.field
        ];
        if (this.operator) children.push(this.operator);
        if (this.operand) children.push(this.operand);
        return children.concat(this.predicates);
    }
    const $ad22ef70da25a752$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
        return $ad22ef70da25a752$export$cc08e43598d091fc(field, operator, operand, predicates);
    };
    const $ad22ef70da25a752$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$2d205682cc545947),
            clauseType: (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a),
            field: field,
            operator: operator,
            operand: operand,
            predicates: predicates,
            position: position,
            accept: $ad22ef70da25a752$var$acceptTerminalClause,
            enterNode: $ad22ef70da25a752$var$enterNode,
            exitNode: $ad22ef70da25a752$var$exitNode,
            getChildren: $ad22ef70da25a752$var$getChildren,
            parent: null,
            setOperator: (0, parcelRequire("b6t5q")).setOperator,
            setOperand: (0, parcelRequire("b6t5q")).setOperand,
            appendOperand: (0, parcelRequire("b6t5q")).appendOperand,
            remove: (0, parcelRequire("b6t5q")).remove,
            replace: (0, parcelRequire("b6t5q")).replace
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("b6t5q", function(module, exports) {
    $parcel$export(module.exports, "setOperator", ()=>setOperator);
    $parcel$export(module.exports, "setOperand", ()=>setOperand);
    $parcel$export(module.exports, "appendOperand", ()=>appendOperand);
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "replace", ()=>replace);
    var $iEIQF;
    var $WCvOq;
    function setOperator(operator) {
        this.operator = operator;
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function setOperand(operand) {
        this.operand = operand;
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function appendOperand(operand) {
        if (this.operand) {
            if (this.operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
            else this.setOperand((0, (0, parcelRequire("iEIQF")).default).listOperand([
                this.operand,
                ...operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df) ? operand.values : [
                    operand
                ]
            ]));
        } else this.setOperand(operand);
    }
    function remove() {
        if (this.parent) this.parent.removeClause(this);
    }
    function replace(nextClause) {
        if (this.parent) this.parent.replaceClause(this, nextClause);
    }
});
parcelRegister("eWV0u", function(module, exports) {
    $parcel$export(module.exports, "valueOperand", ()=>$f1a80cb053576a13$export$2b6e4d2ed8d53bf3);
    $parcel$export(module.exports, "valueOperandInternal", ()=>$f1a80cb053576a13$export$79c37d97caac8627);
    $parcel$export(module.exports, "valueOperandByText", ()=>$f1a80cb053576a13$export$3ac9155bde56a45f);
    var $gq4pj;
    var $2lgiK;
    var $WCvOq;
    function $f1a80cb053576a13$var$acceptValueOperand(visitor) {
        return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
    }
    function $f1a80cb053576a13$var$enterNode(listener) {
        listener.enterValueOperand && listener.enterValueOperand(this);
    }
    function $f1a80cb053576a13$var$exitNode(listener) {
        listener.exitValueOperand && listener.exitValueOperand(this);
    }
    const $f1a80cb053576a13$export$2b6e4d2ed8d53bf3 = (value)=>$f1a80cb053576a13$export$79c37d97caac8627(value, (0, (0, parcelRequire("2lgiK")).sanitiseJqlString)(value));
    const $f1a80cb053576a13$export$3ac9155bde56a45f = (text)=>$f1a80cb053576a13$export$79c37d97caac8627((0, (0, parcelRequire("gq4pj")).normaliseJqlString)(text), text);
    const $f1a80cb053576a13$export$79c37d97caac8627 = (value, text, position = null)=>({
            type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
            operandType: (0, $49b29ef7baa2a152$export$38accfc5a5d1c113),
            text: text,
            value: value,
            position: position,
            accept: $f1a80cb053576a13$var$acceptValueOperand,
            enterNode: $f1a80cb053576a13$var$enterNode,
            exitNode: $f1a80cb053576a13$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("eK6AG", function(module, exports) {
    $parcel$export(module.exports, "JastBuilder", ()=>$ccc4ef92204502d2$export$99cae18a5a6ba8cf);
    var $hCaMj = parcelRequire("hCaMj");
    var $8QpSo;
    var $39War;
    var $k9No4;
    var $iEIQF;
    var $lKjSa;
    var $k9iwN;
    var $bK3p2;
    class $ccc4ef92204502d2$export$99cae18a5a6ba8cf {
        setErrorHandler(errorHandler) {
            this.errorHandler = errorHandler;
            return this;
        }
        setErrorListeners(errorListeners) {
            this.errorListeners = this.errorListeners.concat(errorListeners);
            return this;
        }
        build(value) {
            const tokens = this.getTokens(value);
            const parser = this.getParser(tokens);
            const astErrorListener = new (0, (0, parcelRequire("lKjSa")).JastBuilderErrorListener)();
            parser.removeErrorListeners();
            parser.addErrorListener(astErrorListener);
            this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
            if (this.errorHandler) {
                parser.errorHandler = this.errorHandler;
                this.errorHandler.reset(parser);
            }
            const visitor = new (0, (0, parcelRequire("bK3p2")).QueryVisitor)(tokens);
            try {
                const parseTree = parser.jqlQuery();
                const query = parseTree.accept(visitor);
                return (0, (0, parcelRequire("iEIQF")).default).jast(query, value, astErrorListener.errors);
            } catch (error) {
                return (0, (0, parcelRequire("iEIQF")).default).jast(undefined, value, [
                    new (0, (0, parcelRequire("k9iwN")).JQLParseError)(error.message, error)
                ]);
            }
        }
        constructor(){
            this.errorListeners = [];
            this.errorHandler = undefined;
            this.getTokens = (0, (0, parcelRequire("8QpSo")).default)((value)=>{
                const chars = (0, $hCaMj.CharStreams).fromString(value);
                const lexer = new (0, (0, parcelRequire("39War")).JQLLexer)(chars);
                return new (0, $hCaMj.CommonTokenStream)(lexer);
            });
            this.getParser = (0, (0, parcelRequire("8QpSo")).default)((tokens)=>new (0, (0, parcelRequire("k9No4")).JQLParser)(tokens));
        }
    }
});
parcelRegister("hCaMj", function(module, exports) {
    "use strict";
    var $cd2e58a1d1fa972f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        Object.defineProperty(o, k2, {
            enumerable: true,
            get: function() {
                return m[k];
            }
        });
    } : function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    });
    var $cd2e58a1d1fa972f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
        for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cd2e58a1d1fa972f$var$__createBinding(exports1, m, p);
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fJ9SA")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1lYFk")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("g8XSE")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("b0kN8")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1UkCC")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("QidO0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("9NnFz")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1Olk0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("7ufNj")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("j53rr")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("gWaB3")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("a0nC0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("e5mHr")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("4CCJj")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("4a3G0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5Poq6")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("ea0YW")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("iLUMi")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5FrZ8")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("ceaEj")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("igNLf")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("gMbxO")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fOEQQ")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("drCaH")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("hKCjP")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("jIG0W")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("2pQQd")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("dReoi")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("6bmaO")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("65iNZ")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5xwgp")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fLdDn")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("kBaAZ")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("c8jEe")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("77rdV")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5IgvW")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1ivK9")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("2DVsz")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("eftJA")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("9rAj4")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5jPdD")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("dIykH")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1MVGg")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("3n2FE")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("6UcB4")), module.exports);
});
parcelRegister("fJ9SA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("1lYFk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("g8XSE", function(module, exports) {
    "use strict";
    var $bc0bd7b6659a2632$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ANTLRInputStream = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $d6D31 = parcelRequire("d6D31");
    var $ceaEj = parcelRequire("ceaEj");
    const $bc0bd7b6659a2632$var$READ_BUFFER_SIZE = 1024;
    const $bc0bd7b6659a2632$var$INITIAL_BUFFER_SIZE = 1024;
    class $bc0bd7b6659a2632$var$ANTLRInputStream {
        constructor(input){
            this.p = 0;
            this.data = input;
            this.n = input.length;
        }
        reset() {
            this.p = 0;
        }
        consume() {
            if (this.p >= this.n) {
                $bbHFU(this.LA(1) === $ceaEj.IntStream.EOF);
                throw new Error("cannot consume EOF");
            }
            if (this.p < this.n) this.p++;
        }
        LA(i) {
            if (i === 0) return 0;
            if (i < 0) {
                i++;
                if (this.p + i - 1 < 0) return $ceaEj.IntStream.EOF;
            }
            if (this.p + i - 1 >= this.n) return $ceaEj.IntStream.EOF;
            return this.data.charCodeAt(this.p + i - 1);
        }
        LT(i) {
            return this.LA(i);
        }
        get index() {
            return this.p;
        }
        get size() {
            return this.n;
        }
        mark() {
            return -1;
        }
        release(marker) {}
        seek(index) {
            if (index <= this.p) {
                this.p = index;
                return;
            }
            index = Math.min(index, this.n);
            while(this.p < index)this.consume();
        }
        getText(interval) {
            let start = interval.a;
            let stop = interval.b;
            if (stop >= this.n) stop = this.n - 1;
            let count = stop - start + 1;
            if (start >= this.n) return "";
            return this.data.substr(start, count);
        }
        get sourceName() {
            if (!this.name) return $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
            return this.name;
        }
        toString() {
            return this.data;
        }
    }
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "consume", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "LA", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "index", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "size", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "mark", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "release", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "seek", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "getText", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "sourceName", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "toString", null);
    module.exports.ANTLRInputStream = $bc0bd7b6659a2632$var$ANTLRInputStream;
});
parcelRegister("bbHFU", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    function $825299b5d0c0a9a5$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $825299b5d0c0a9a5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $825299b5d0c0a9a5$var$_typeof(o);
    }
    function $825299b5d0c0a9a5$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $825299b5d0c0a9a5$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $825299b5d0c0a9a5$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $825299b5d0c0a9a5$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $825299b5d0c0a9a5$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $825299b5d0c0a9a5$var$_toPropertyKey(arg) {
        var key = $825299b5d0c0a9a5$var$_toPrimitive(arg, "string");
        return $825299b5d0c0a9a5$var$_typeof(key) === "symbol" ? key : String(key);
    }
    function $825299b5d0c0a9a5$var$_toPrimitive(input, hint) {
        if ($825299b5d0c0a9a5$var$_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if ($825299b5d0c0a9a5$var$_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function $825299b5d0c0a9a5$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var $8JAro = parcelRequire("8JAro");
    var $825299b5d0c0a9a5$var$_require$codes = $8JAro.codes, $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT = $825299b5d0c0a9a5$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_ARG_TYPE, $825299b5d0c0a9a5$var$ERR_INVALID_ARG_VALUE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_ARG_VALUE, $825299b5d0c0a9a5$var$ERR_INVALID_RETURN_VALUE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_RETURN_VALUE, $825299b5d0c0a9a5$var$ERR_MISSING_ARGS = $825299b5d0c0a9a5$var$_require$codes.ERR_MISSING_ARGS;
    var $3ZLjA = parcelRequire("3ZLjA");
    var $9kAQu = parcelRequire("9kAQu");
    var $825299b5d0c0a9a5$var$inspect = $9kAQu.inspect;
    var $9kAQu = parcelRequire("9kAQu");
    var $825299b5d0c0a9a5$require$_require$types = $9kAQu.types;
    var $825299b5d0c0a9a5$var$isPromise = $825299b5d0c0a9a5$require$_require$types.isPromise, $825299b5d0c0a9a5$var$isRegExp = $825299b5d0c0a9a5$require$_require$types.isRegExp;
    var $825299b5d0c0a9a5$var$objectAssign = (parcelRequire("8s5ew"))();
    var $825299b5d0c0a9a5$var$objectIs = (parcelRequire("eJazH"))();
    var $825299b5d0c0a9a5$var$RegExpPrototypeTest = (parcelRequire("53KqO"))('RegExp.prototype.test');
    var $825299b5d0c0a9a5$var$errorCache = new Map();
    var $825299b5d0c0a9a5$var$isDeepEqual;
    var $825299b5d0c0a9a5$var$isDeepStrictEqual;
    var $825299b5d0c0a9a5$var$parseExpressionAt;
    var $825299b5d0c0a9a5$var$findNodeAround;
    var $825299b5d0c0a9a5$var$decoder;
    function $825299b5d0c0a9a5$var$lazyLoadComparison() {
        var comparison = (parcelRequire("dztjv"));
        $825299b5d0c0a9a5$var$isDeepEqual = comparison.isDeepEqual;
        $825299b5d0c0a9a5$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
    }
    var $825299b5d0c0a9a5$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
    var $825299b5d0c0a9a5$var$meta = [
        "\\u0000",
        "\\u0001",
        "\\u0002",
        "\\u0003",
        "\\u0004",
        "\\u0005",
        "\\u0006",
        "\\u0007",
        '\\b',
        '',
        '',
        "\\u000b",
        '\\f',
        '',
        "\\u000e",
        "\\u000f",
        "\\u0010",
        "\\u0011",
        "\\u0012",
        "\\u0013",
        "\\u0014",
        "\\u0015",
        "\\u0016",
        "\\u0017",
        "\\u0018",
        "\\u0019",
        "\\u001a",
        "\\u001b",
        "\\u001c",
        "\\u001d",
        "\\u001e",
        "\\u001f"
    ];
    var $825299b5d0c0a9a5$var$escapeFn = function escapeFn(str) {
        return $825299b5d0c0a9a5$var$meta[str.charCodeAt(0)];
    };
    var $825299b5d0c0a9a5$var$warned = false;
    var $825299b5d0c0a9a5$var$assert = module.exports = $825299b5d0c0a9a5$var$ok;
    var $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL = {};
    function $825299b5d0c0a9a5$var$innerFail(obj) {
        if (obj.message instanceof Error) throw obj.message;
        throw new $3ZLjA(obj);
    }
    function $825299b5d0c0a9a5$var$fail(actual, expected, message, operator, stackStartFn) {
        var argsLen = arguments.length;
        var internalMessage;
        if (argsLen === 0) internalMessage = 'Failed';
        else if (argsLen === 1) {
            message = actual;
            actual = undefined;
        } else {
            if ($825299b5d0c0a9a5$var$warned === false) {
                $825299b5d0c0a9a5$var$warned = true;
                var warn = $6cAn5.emitWarning ? $6cAn5.emitWarning : console.warn.bind(console);
                warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
            }
            if (argsLen === 2) operator = '!=';
        }
        if (message instanceof Error) throw message;
        var errArgs = {
            actual: actual,
            expected: expected,
            operator: operator === undefined ? 'fail' : operator,
            stackStartFn: stackStartFn || $825299b5d0c0a9a5$var$fail
        };
        if (message !== undefined) errArgs.message = message;
        var err = new $3ZLjA(errArgs);
        if (internalMessage) {
            err.message = internalMessage;
            err.generatedMessage = true;
        }
        throw err;
    }
    $825299b5d0c0a9a5$var$assert.fail = $825299b5d0c0a9a5$var$fail;
    $825299b5d0c0a9a5$var$assert.AssertionError = $3ZLjA;
    function $825299b5d0c0a9a5$var$innerOk(fn, argLen, value, message) {
        if (!value) {
            var generatedMessage = false;
            if (argLen === 0) {
                generatedMessage = true;
                message = 'No value argument passed to `assert.ok()`';
            } else if (message instanceof Error) throw message;
            var err = new $3ZLjA({
                actual: value,
                expected: true,
                message: message,
                operator: '==',
                stackStartFn: fn
            });
            err.generatedMessage = generatedMessage;
            throw err;
        }
    }
    function $825299b5d0c0a9a5$var$ok() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        $825299b5d0c0a9a5$var$innerOk.apply(void 0, [
            $825299b5d0c0a9a5$var$ok,
            args.length
        ].concat(args));
    }
    $825299b5d0c0a9a5$var$assert.ok = $825299b5d0c0a9a5$var$ok;
    $825299b5d0c0a9a5$var$assert.equal = function equal(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if (actual != expected) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: '==',
            stackStartFn: equal
        });
    };
    $825299b5d0c0a9a5$var$assert.notEqual = function notEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if (actual == expected) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: '!=',
            stackStartFn: notEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.deepEqual = function deepEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if (!$825299b5d0c0a9a5$var$isDeepEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'deepEqual',
            stackStartFn: deepEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if ($825299b5d0c0a9a5$var$isDeepEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'notDeepEqual',
            stackStartFn: notDeepEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if (!$825299b5d0c0a9a5$var$isDeepStrictEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'deepStrictEqual',
            stackStartFn: deepStrictEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.notDeepStrictEqual = $825299b5d0c0a9a5$var$notDeepStrictEqual;
    function $825299b5d0c0a9a5$var$notDeepStrictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if ($825299b5d0c0a9a5$var$isDeepStrictEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'notDeepStrictEqual',
            stackStartFn: $825299b5d0c0a9a5$var$notDeepStrictEqual
        });
    }
    $825299b5d0c0a9a5$var$assert.strictEqual = function strictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if (!$825299b5d0c0a9a5$var$objectIs(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'strictEqual',
            stackStartFn: strictEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$objectIs(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'notStrictEqual',
            stackStartFn: notStrictEqual
        });
    };
    var $825299b5d0c0a9a5$var$Comparison = $825299b5d0c0a9a5$var$_createClass(function Comparison(obj, keys, actual) {
        var _this = this;
        $825299b5d0c0a9a5$var$_classCallCheck(this, Comparison);
        keys.forEach(function(key) {
            if (key in obj) {
                if (actual !== undefined && typeof actual[key] === 'string' && $825299b5d0c0a9a5$var$isRegExp(obj[key]) && $825299b5d0c0a9a5$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
                else _this[key] = obj[key];
            }
        });
    });
    function $825299b5d0c0a9a5$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
        if (!(key in actual) || !$825299b5d0c0a9a5$var$isDeepStrictEqual(actual[key], expected[key])) {
            if (!message) {
                var a = new $825299b5d0c0a9a5$var$Comparison(actual, keys);
                var b = new $825299b5d0c0a9a5$var$Comparison(expected, keys, actual);
                var err = new $3ZLjA({
                    actual: a,
                    expected: b,
                    operator: 'deepStrictEqual',
                    stackStartFn: fn
                });
                err.actual = actual;
                err.expected = expected;
                err.operator = fn.name;
                throw err;
            }
            $825299b5d0c0a9a5$var$innerFail({
                actual: actual,
                expected: expected,
                message: message,
                operator: fn.name,
                stackStartFn: fn
            });
        }
    }
    function $825299b5d0c0a9a5$var$expectedException(actual, expected, msg, fn) {
        if (typeof expected !== 'function') {
            if ($825299b5d0c0a9a5$var$isRegExp(expected)) return $825299b5d0c0a9a5$var$RegExpPrototypeTest(expected, actual);
            if (arguments.length === 2) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('expected', [
                'Function',
                'RegExp'
            ], expected);
            if ($825299b5d0c0a9a5$var$_typeof(actual) !== 'object' || actual === null) {
                var err = new $3ZLjA({
                    actual: actual,
                    expected: expected,
                    message: msg,
                    operator: 'deepStrictEqual',
                    stackStartFn: fn
                });
                err.operator = fn.name;
                throw err;
            }
            var keys = Object.keys(expected);
            if (expected instanceof Error) keys.push('name', 'message');
            else if (keys.length === 0) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
            if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
            keys.forEach(function(key) {
                if (typeof actual[key] === 'string' && $825299b5d0c0a9a5$var$isRegExp(expected[key]) && $825299b5d0c0a9a5$var$RegExpPrototypeTest(expected[key], actual[key])) return;
                $825299b5d0c0a9a5$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
            });
            return true;
        }
        if (expected.prototype !== undefined && actual instanceof expected) return true;
        if (Error.isPrototypeOf(expected)) return false;
        return expected.call({}, actual) === true;
    }
    function $825299b5d0c0a9a5$var$getActual(fn) {
        if (typeof fn !== 'function') throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
        try {
            fn();
        } catch (e) {
            return e;
        }
        return $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL;
    }
    function $825299b5d0c0a9a5$var$checkIsPromise(obj) {
        return $825299b5d0c0a9a5$var$isPromise(obj) || obj !== null && $825299b5d0c0a9a5$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
    }
    function $825299b5d0c0a9a5$var$waitForActual(promiseFn) {
        return Promise.resolve().then(function() {
            var resultPromise;
            if (typeof promiseFn === 'function') {
                resultPromise = promiseFn();
                if (!$825299b5d0c0a9a5$var$checkIsPromise(resultPromise)) throw new $825299b5d0c0a9a5$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
            } else if ($825299b5d0c0a9a5$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
            else throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('promiseFn', [
                'Function',
                'Promise'
            ], promiseFn);
            return Promise.resolve().then(function() {
                return resultPromise;
            }).then(function() {
                return $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL;
            }).catch(function(e) {
                return e;
            });
        });
    }
    function $825299b5d0c0a9a5$var$expectsError(stackStartFn, actual, error, message) {
        if (typeof error === 'string') {
            if (arguments.length === 4) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('error', [
                'Object',
                'Error',
                'Function',
                'RegExp'
            ], error);
            if ($825299b5d0c0a9a5$var$_typeof(actual) === 'object' && actual !== null) {
                if (actual.message === error) throw new $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
            } else if (actual === error) throw new $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
            message = error;
            error = undefined;
        } else if (error != null && $825299b5d0c0a9a5$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if (actual === $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL) {
            var details = '';
            if (error && error.name) details += " (".concat(error.name, ")");
            details += message ? ": ".concat(message) : '.';
            var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
            $825299b5d0c0a9a5$var$innerFail({
                actual: undefined,
                expected: error,
                operator: stackStartFn.name,
                message: "Missing expected ".concat(fnType).concat(details),
                stackStartFn: stackStartFn
            });
        }
        if (error && !$825299b5d0c0a9a5$var$expectedException(actual, error, message, stackStartFn)) throw actual;
    }
    function $825299b5d0c0a9a5$var$expectsNoError(stackStartFn, actual, error, message) {
        if (actual === $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL) return;
        if (typeof error === 'string') {
            message = error;
            error = undefined;
        }
        if (!error || $825299b5d0c0a9a5$var$expectedException(actual, error)) {
            var details = message ? ": ".concat(message) : '.';
            var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
            $825299b5d0c0a9a5$var$innerFail({
                actual: actual,
                expected: error,
                operator: stackStartFn.name,
                message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
                stackStartFn: stackStartFn
            });
        }
        throw actual;
    }
    $825299b5d0c0a9a5$var$assert.throws = function throws(promiseFn) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        $825299b5d0c0a9a5$var$expectsError.apply(void 0, [
            throws,
            $825299b5d0c0a9a5$var$getActual(promiseFn)
        ].concat(args));
    };
    $825299b5d0c0a9a5$var$assert.rejects = function rejects(promiseFn) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return $825299b5d0c0a9a5$var$waitForActual(promiseFn).then(function(result) {
            return $825299b5d0c0a9a5$var$expectsError.apply(void 0, [
                rejects,
                result
            ].concat(args));
        });
    };
    $825299b5d0c0a9a5$var$assert.doesNotThrow = function doesNotThrow(fn) {
        for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        $825299b5d0c0a9a5$var$expectsNoError.apply(void 0, [
            doesNotThrow,
            $825299b5d0c0a9a5$var$getActual(fn)
        ].concat(args));
    };
    $825299b5d0c0a9a5$var$assert.doesNotReject = function doesNotReject(fn) {
        for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
        return $825299b5d0c0a9a5$var$waitForActual(fn).then(function(result) {
            return $825299b5d0c0a9a5$var$expectsNoError.apply(void 0, [
                doesNotReject,
                result
            ].concat(args));
        });
    };
    $825299b5d0c0a9a5$var$assert.ifError = function ifError(err) {
        if (err !== null && err !== undefined) {
            var message = 'ifError got unwanted exception: ';
            if ($825299b5d0c0a9a5$var$_typeof(err) === 'object' && typeof err.message === 'string') {
                if (err.message.length === 0 && err.constructor) message += err.constructor.name;
                else message += err.message;
            } else message += $825299b5d0c0a9a5$var$inspect(err);
            var newErr = new $3ZLjA({
                actual: err,
                expected: null,
                operator: 'ifError',
                message: message,
                stackStartFn: ifError
            });
            var origStack = err.stack;
            if (typeof origStack === 'string') {
                var tmp2 = origStack.split('\n');
                tmp2.shift();
                var tmp1 = newErr.stack.split('\n');
                for(var i = 0; i < tmp2.length; i++){
                    var pos = tmp1.indexOf(tmp2[i]);
                    if (pos !== -1) {
                        tmp1 = tmp1.slice(0, pos);
                        break;
                    }
                }
                newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
            }
            throw newErr;
        }
    };
    function $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, fn, fnName) {
        if (!$825299b5d0c0a9a5$var$isRegExp(regexp)) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
        var match = fnName === 'match';
        if (typeof string !== 'string' || $825299b5d0c0a9a5$var$RegExpPrototypeTest(regexp, string) !== match) {
            if (message instanceof Error) throw message;
            var generatedMessage = !message;
            message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($825299b5d0c0a9a5$var$_typeof(string), " (").concat($825299b5d0c0a9a5$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($825299b5d0c0a9a5$var$inspect(regexp), ". Input:\n\n").concat($825299b5d0c0a9a5$var$inspect(string), "\n"));
            var err = new $3ZLjA({
                actual: string,
                expected: regexp,
                message: message,
                operator: fnName,
                stackStartFn: fn
            });
            err.generatedMessage = generatedMessage;
            throw err;
        }
    }
    $825299b5d0c0a9a5$var$assert.match = function match(string, regexp, message) {
        $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, match, 'match');
    };
    $825299b5d0c0a9a5$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
        $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
    };
    function $825299b5d0c0a9a5$var$strict() {
        for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
        $825299b5d0c0a9a5$var$innerOk.apply(void 0, [
            $825299b5d0c0a9a5$var$strict,
            args.length
        ].concat(args));
    }
    $825299b5d0c0a9a5$var$assert.strict = $825299b5d0c0a9a5$var$objectAssign($825299b5d0c0a9a5$var$strict, $825299b5d0c0a9a5$var$assert, {
        equal: $825299b5d0c0a9a5$var$assert.strictEqual,
        deepEqual: $825299b5d0c0a9a5$var$assert.deepStrictEqual,
        notEqual: $825299b5d0c0a9a5$var$assert.notStrictEqual,
        notDeepEqual: $825299b5d0c0a9a5$var$assert.notDeepStrictEqual
    });
    $825299b5d0c0a9a5$var$assert.strict.strict = $825299b5d0c0a9a5$var$assert.strict;
});
parcelRegister("8JAro", function(module, exports) {
    $parcel$export(module.exports, "codes", ()=>$65becb1820e5a079$export$e45cb6485273080e, (v)=>$65becb1820e5a079$export$e45cb6485273080e = v);
    var $65becb1820e5a079$export$e45cb6485273080e;
    'use strict';
    function $65becb1820e5a079$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $65becb1820e5a079$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $65becb1820e5a079$var$_typeof(o);
    }
    function $65becb1820e5a079$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $65becb1820e5a079$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $65becb1820e5a079$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $65becb1820e5a079$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $65becb1820e5a079$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $65becb1820e5a079$var$_toPropertyKey(arg) {
        var key = $65becb1820e5a079$var$_toPrimitive(arg, "string");
        return $65becb1820e5a079$var$_typeof(key) === "symbol" ? key : String(key);
    }
    function $65becb1820e5a079$var$_toPrimitive(input, hint) {
        if ($65becb1820e5a079$var$_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if ($65becb1820e5a079$var$_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function $65becb1820e5a079$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $65becb1820e5a079$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        Object.defineProperty(subClass, "prototype", {
            writable: false
        });
        if (superClass) $65becb1820e5a079$var$_setPrototypeOf(subClass, superClass);
    }
    function $65becb1820e5a079$var$_setPrototypeOf(o, p) {
        $65becb1820e5a079$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return $65becb1820e5a079$var$_setPrototypeOf(o, p);
    }
    function $65becb1820e5a079$var$_createSuper(Derived) {
        var hasNativeReflectConstruct = $65becb1820e5a079$var$_isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = $65becb1820e5a079$var$_getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = $65becb1820e5a079$var$_getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return $65becb1820e5a079$var$_possibleConstructorReturn(this, result);
        };
    }
    function $65becb1820e5a079$var$_possibleConstructorReturn(self, call) {
        if (call && ($65becb1820e5a079$var$_typeof(call) === "object" || typeof call === "function")) return call;
        else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return $65becb1820e5a079$var$_assertThisInitialized(self);
    }
    function $65becb1820e5a079$var$_assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function $65becb1820e5a079$var$_isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function $65becb1820e5a079$var$_getPrototypeOf(o) {
        $65becb1820e5a079$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return $65becb1820e5a079$var$_getPrototypeOf(o);
    }
    var $65becb1820e5a079$var$codes = {};
    var $65becb1820e5a079$var$assert;
    var $65becb1820e5a079$var$util;
    function $65becb1820e5a079$var$createErrorType(code, message, Base) {
        if (!Base) Base = Error;
        function getMessage(arg1, arg2, arg3) {
            if (typeof message === 'string') return message;
            else return message(arg1, arg2, arg3);
        }
        var NodeError = function(_Base) {
            $65becb1820e5a079$var$_inherits(NodeError, _Base);
            var _super = $65becb1820e5a079$var$_createSuper(NodeError);
            function NodeError(arg1, arg2, arg3) {
                var _this;
                $65becb1820e5a079$var$_classCallCheck(this, NodeError);
                _this = _super.call(this, getMessage(arg1, arg2, arg3));
                _this.code = code;
                return _this;
            }
            return $65becb1820e5a079$var$_createClass(NodeError);
        }(Base);
        $65becb1820e5a079$var$codes[code] = NodeError;
    }
    function $65becb1820e5a079$var$oneOf(expected, thing) {
        if (Array.isArray(expected)) {
            var len = expected.length;
            expected = expected.map(function(i) {
                return String(i);
            });
            if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
            else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
            else return "of ".concat(thing, " ").concat(expected[0]);
        } else return "of ".concat(thing, " ").concat(String(expected));
    }
    function $65becb1820e5a079$var$startsWith(str, search, pos) {
        return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    }
    function $65becb1820e5a079$var$endsWith(str, search, this_len) {
        if (this_len === undefined || this_len > str.length) this_len = str.length;
        return str.substring(this_len - search.length, this_len) === search;
    }
    function $65becb1820e5a079$var$includes(str, search, start) {
        if (typeof start !== 'number') start = 0;
        if (start + search.length > str.length) return false;
        else return str.indexOf(search, start) !== -1;
    }
    $65becb1820e5a079$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);
    $65becb1820e5a079$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
        if ($65becb1820e5a079$var$assert === undefined) $65becb1820e5a079$var$assert = (parcelRequire("bbHFU"));
        $65becb1820e5a079$var$assert(typeof name === 'string', "'name' must be a string");
        var determiner;
        if (typeof expected === 'string' && $65becb1820e5a079$var$startsWith(expected, 'not ')) {
            determiner = 'must not be';
            expected = expected.replace(/^not /, '');
        } else determiner = 'must be';
        var msg;
        if ($65becb1820e5a079$var$endsWith(name, ' argument')) msg = "The ".concat(name, " ").concat(determiner, " ").concat($65becb1820e5a079$var$oneOf(expected, 'type'));
        else {
            var type = $65becb1820e5a079$var$includes(name, '.') ? 'property' : 'argument';
            msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($65becb1820e5a079$var$oneOf(expected, 'type'));
        }
        msg += ". Received type ".concat($65becb1820e5a079$var$_typeof(actual));
        return msg;
    }, TypeError);
    $65becb1820e5a079$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
        var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
        if ($65becb1820e5a079$var$util === undefined) $65becb1820e5a079$var$util = (parcelRequire("9kAQu"));
        var inspected = $65becb1820e5a079$var$util.inspect(value);
        if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
        return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
    }, TypeError, RangeError);
    $65becb1820e5a079$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
        var type;
        if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
        else type = "type ".concat($65becb1820e5a079$var$_typeof(value));
        return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
    }, TypeError);
    $65becb1820e5a079$var$createErrorType('ERR_MISSING_ARGS', function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if ($65becb1820e5a079$var$assert === undefined) $65becb1820e5a079$var$assert = (parcelRequire("bbHFU"));
        $65becb1820e5a079$var$assert(args.length > 0, 'At least one arg needs to be specified');
        var msg = 'The ';
        var len = args.length;
        args = args.map(function(a) {
            return "\"".concat(a, "\"");
        });
        switch(len){
            case 1:
                msg += "".concat(args[0], " argument");
                break;
            case 2:
                msg += "".concat(args[0], " and ").concat(args[1], " arguments");
                break;
            default:
                msg += args.slice(0, len - 1).join(', ');
                msg += ", and ".concat(args[len - 1], " arguments");
                break;
        }
        return "".concat(msg, " must be specified");
    }, TypeError);
    $65becb1820e5a079$export$e45cb6485273080e = $65becb1820e5a079$var$codes;
});
parcelRegister("9kAQu", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    var $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
        var keys = Object.keys(obj);
        var descriptors = {};
        for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
        return descriptors;
    };
    var $6cb29018fbdc8fcc$var$formatRegExp = /%[sdj%]/g;
    module.exports.format = function(f) {
        if (!$6cb29018fbdc8fcc$var$isString(f)) {
            var objects = [];
            for(var i = 0; i < arguments.length; i++)objects.push($6cb29018fbdc8fcc$var$inspect(arguments[i]));
            return objects.join(' ');
        }
        var i = 1;
        var args = arguments;
        var len = args.length;
        var str = String(f).replace($6cb29018fbdc8fcc$var$formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                default:
                    return x;
            }
        });
        for(var x = args[i]; i < len; x = args[++i])if ($6cb29018fbdc8fcc$var$isNull(x) || !$6cb29018fbdc8fcc$var$isObject(x)) str += ' ' + x;
        else str += ' ' + $6cb29018fbdc8fcc$var$inspect(x);
        return str;
    };
    module.exports.deprecate = function(fn, msg) {
        if (typeof $6cAn5 !== 'undefined' && $6cAn5.noDeprecation === true) return fn;
        if (typeof $6cAn5 === 'undefined') return function() {
            return module.exports.deprecate(fn, msg).apply(this, arguments);
        };
        var warned = false;
        function deprecated() {
            if (!warned) {
                if ($6cAn5.throwDeprecation) throw new Error(msg);
                else if ($6cAn5.traceDeprecation) console.trace(msg);
                else console.error(msg);
                warned = true;
            }
            return fn.apply(this, arguments);
        }
        return deprecated;
    };
    var $6cb29018fbdc8fcc$var$debugs = {};
    var $6cb29018fbdc8fcc$var$debugEnvRegex = /^$/;
    var $6cb29018fbdc8fcc$var$debugEnv;
    module.exports.debuglog = function(set) {
        set = set.toUpperCase();
        if (!$6cb29018fbdc8fcc$var$debugs[set]) {
            if ($6cb29018fbdc8fcc$var$debugEnvRegex.test(set)) {
                var pid = $6cAn5.pid;
                $6cb29018fbdc8fcc$var$debugs[set] = function() {
                    var msg = module.exports.format.apply(module.exports, arguments);
                    console.error('%s %d: %s', set, pid, msg);
                };
            } else $6cb29018fbdc8fcc$var$debugs[set] = function() {};
        }
        return $6cb29018fbdc8fcc$var$debugs[set];
    };
    function $6cb29018fbdc8fcc$var$inspect(obj, opts) {
        var ctx = {
            seen: [],
            stylize: $6cb29018fbdc8fcc$var$stylizeNoColor
        };
        if (arguments.length >= 3) ctx.depth = arguments[2];
        if (arguments.length >= 4) ctx.colors = arguments[3];
        if ($6cb29018fbdc8fcc$var$isBoolean(opts)) ctx.showHidden = opts;
        else if (opts) module.exports._extend(ctx, opts);
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.depth)) ctx.depth = 2;
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.colors)) ctx.colors = false;
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
        if (ctx.colors) ctx.stylize = $6cb29018fbdc8fcc$var$stylizeWithColor;
        return $6cb29018fbdc8fcc$var$formatValue(ctx, obj, ctx.depth);
    }
    module.exports.inspect = $6cb29018fbdc8fcc$var$inspect;
    $6cb29018fbdc8fcc$var$inspect.colors = {
        'bold': [
            1,
            22
        ],
        'italic': [
            3,
            23
        ],
        'underline': [
            4,
            24
        ],
        'inverse': [
            7,
            27
        ],
        'white': [
            37,
            39
        ],
        'grey': [
            90,
            39
        ],
        'black': [
            30,
            39
        ],
        'blue': [
            34,
            39
        ],
        'cyan': [
            36,
            39
        ],
        'green': [
            32,
            39
        ],
        'magenta': [
            35,
            39
        ],
        'red': [
            31,
            39
        ],
        'yellow': [
            33,
            39
        ]
    };
    $6cb29018fbdc8fcc$var$inspect.styles = {
        'special': 'cyan',
        'number': 'yellow',
        'boolean': 'yellow',
        'undefined': 'grey',
        'null': 'bold',
        'string': 'green',
        'date': 'magenta',
        'regexp': 'red'
    };
    function $6cb29018fbdc8fcc$var$stylizeWithColor(str, styleType) {
        var style = $6cb29018fbdc8fcc$var$inspect.styles[styleType];
        if (style) return '\u001b[' + $6cb29018fbdc8fcc$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $6cb29018fbdc8fcc$var$inspect.colors[style][1] + 'm';
        else return str;
    }
    function $6cb29018fbdc8fcc$var$stylizeNoColor(str, styleType) {
        return str;
    }
    function $6cb29018fbdc8fcc$var$arrayToHash(array) {
        var hash = {};
        array.forEach(function(val, idx) {
            hash[val] = true;
        });
        return hash;
    }
    function $6cb29018fbdc8fcc$var$formatValue(ctx, value, recurseTimes) {
        if (ctx.customInspect && value && $6cb29018fbdc8fcc$var$isFunction(value.inspect) && value.inspect !== module.exports.inspect && !(value.constructor && value.constructor.prototype === value)) {
            var ret = value.inspect(recurseTimes, ctx);
            if (!$6cb29018fbdc8fcc$var$isString(ret)) ret = $6cb29018fbdc8fcc$var$formatValue(ctx, ret, recurseTimes);
            return ret;
        }
        var primitive = $6cb29018fbdc8fcc$var$formatPrimitive(ctx, value);
        if (primitive) return primitive;
        var keys = Object.keys(value);
        var visibleKeys = $6cb29018fbdc8fcc$var$arrayToHash(keys);
        if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
        if ($6cb29018fbdc8fcc$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $6cb29018fbdc8fcc$var$formatError(value);
        if (keys.length === 0) {
            if ($6cb29018fbdc8fcc$var$isFunction(value)) {
                var name = value.name ? ': ' + value.name : '';
                return ctx.stylize('[Function' + name + ']', 'special');
            }
            if ($6cb29018fbdc8fcc$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
            if ($6cb29018fbdc8fcc$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
            if ($6cb29018fbdc8fcc$var$isError(value)) return $6cb29018fbdc8fcc$var$formatError(value);
        }
        var base = '', array = false, braces = [
            '{',
            '}'
        ];
        if ($6cb29018fbdc8fcc$var$isArray(value)) {
            array = true;
            braces = [
                '[',
                ']'
            ];
        }
        if ($6cb29018fbdc8fcc$var$isFunction(value)) {
            var n = value.name ? ': ' + value.name : '';
            base = ' [Function' + n + ']';
        }
        if ($6cb29018fbdc8fcc$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
        if ($6cb29018fbdc8fcc$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
        if ($6cb29018fbdc8fcc$var$isError(value)) base = ' ' + $6cb29018fbdc8fcc$var$formatError(value);
        if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
        if (recurseTimes < 0) {
            if ($6cb29018fbdc8fcc$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
            else return ctx.stylize('[Object]', 'special');
        }
        ctx.seen.push(value);
        var output;
        if (array) output = $6cb29018fbdc8fcc$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
        else output = keys.map(function(key) {
            return $6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
        });
        ctx.seen.pop();
        return $6cb29018fbdc8fcc$var$reduceToSingleString(output, base, braces);
    }
    function $6cb29018fbdc8fcc$var$formatPrimitive(ctx, value) {
        if ($6cb29018fbdc8fcc$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
        if ($6cb29018fbdc8fcc$var$isString(value)) {
            var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
            return ctx.stylize(simple, 'string');
        }
        if ($6cb29018fbdc8fcc$var$isNumber(value)) return ctx.stylize('' + value, 'number');
        if ($6cb29018fbdc8fcc$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
        if ($6cb29018fbdc8fcc$var$isNull(value)) return ctx.stylize('null', 'null');
    }
    function $6cb29018fbdc8fcc$var$formatError(value) {
        return '[' + Error.prototype.toString.call(value) + ']';
    }
    function $6cb29018fbdc8fcc$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
        var output = [];
        for(var i = 0, l = value.length; i < l; ++i)if ($6cb29018fbdc8fcc$var$hasOwnProperty(value, String(i))) output.push($6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
        else output.push('');
        keys.forEach(function(key) {
            if (!key.match(/^\d+$/)) output.push($6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
        });
        return output;
    }
    function $6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
        var name, str, desc;
        desc = Object.getOwnPropertyDescriptor(value, key) || {
            value: value[key]
        };
        if (desc.get) {
            if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
            else str = ctx.stylize('[Getter]', 'special');
        } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
        if (!$6cb29018fbdc8fcc$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
        if (!str) {
            if (ctx.seen.indexOf(desc.value) < 0) {
                if ($6cb29018fbdc8fcc$var$isNull(recurseTimes)) str = $6cb29018fbdc8fcc$var$formatValue(ctx, desc.value, null);
                else str = $6cb29018fbdc8fcc$var$formatValue(ctx, desc.value, recurseTimes - 1);
                if (str.indexOf('\n') > -1) {
                    if (array) str = str.split('\n').map(function(line) {
                        return '  ' + line;
                    }).join('\n').slice(2);
                    else str = '\n' + str.split('\n').map(function(line) {
                        return '   ' + line;
                    }).join('\n');
                }
            } else str = ctx.stylize('[Circular]', 'special');
        }
        if ($6cb29018fbdc8fcc$var$isUndefined(name)) {
            if (array && key.match(/^\d+$/)) return str;
            name = JSON.stringify('' + key);
            if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                name = name.slice(1, -1);
                name = ctx.stylize(name, 'name');
            } else {
                name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                name = ctx.stylize(name, 'string');
            }
        }
        return name + ': ' + str;
    }
    function $6cb29018fbdc8fcc$var$reduceToSingleString(output, base, braces) {
        var numLinesEst = 0;
        var length = output.reduce(function(prev, cur) {
            numLinesEst++;
            if (cur.indexOf('\n') >= 0) numLinesEst++;
            return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
        }, 0);
        if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
        return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
    }
    module.exports.types = (parcelRequire("jGyMi"));
    function $6cb29018fbdc8fcc$var$isArray(ar) {
        return Array.isArray(ar);
    }
    module.exports.isArray = $6cb29018fbdc8fcc$var$isArray;
    function $6cb29018fbdc8fcc$var$isBoolean(arg) {
        return typeof arg === 'boolean';
    }
    module.exports.isBoolean = $6cb29018fbdc8fcc$var$isBoolean;
    function $6cb29018fbdc8fcc$var$isNull(arg) {
        return arg === null;
    }
    module.exports.isNull = $6cb29018fbdc8fcc$var$isNull;
    function $6cb29018fbdc8fcc$var$isNullOrUndefined(arg) {
        return arg == null;
    }
    module.exports.isNullOrUndefined = $6cb29018fbdc8fcc$var$isNullOrUndefined;
    function $6cb29018fbdc8fcc$var$isNumber(arg) {
        return typeof arg === 'number';
    }
    module.exports.isNumber = $6cb29018fbdc8fcc$var$isNumber;
    function $6cb29018fbdc8fcc$var$isString(arg) {
        return typeof arg === 'string';
    }
    module.exports.isString = $6cb29018fbdc8fcc$var$isString;
    function $6cb29018fbdc8fcc$var$isSymbol(arg) {
        return typeof arg === 'symbol';
    }
    module.exports.isSymbol = $6cb29018fbdc8fcc$var$isSymbol;
    function $6cb29018fbdc8fcc$var$isUndefined(arg) {
        return arg === void 0;
    }
    module.exports.isUndefined = $6cb29018fbdc8fcc$var$isUndefined;
    function $6cb29018fbdc8fcc$var$isRegExp(re) {
        return $6cb29018fbdc8fcc$var$isObject(re) && $6cb29018fbdc8fcc$var$objectToString(re) === '[object RegExp]';
    }
    module.exports.isRegExp = $6cb29018fbdc8fcc$var$isRegExp;
    module.exports.types.isRegExp = $6cb29018fbdc8fcc$var$isRegExp;
    function $6cb29018fbdc8fcc$var$isObject(arg) {
        return typeof arg === 'object' && arg !== null;
    }
    module.exports.isObject = $6cb29018fbdc8fcc$var$isObject;
    function $6cb29018fbdc8fcc$var$isDate(d) {
        return $6cb29018fbdc8fcc$var$isObject(d) && $6cb29018fbdc8fcc$var$objectToString(d) === '[object Date]';
    }
    module.exports.isDate = $6cb29018fbdc8fcc$var$isDate;
    module.exports.types.isDate = $6cb29018fbdc8fcc$var$isDate;
    function $6cb29018fbdc8fcc$var$isError(e) {
        return $6cb29018fbdc8fcc$var$isObject(e) && ($6cb29018fbdc8fcc$var$objectToString(e) === '[object Error]' || e instanceof Error);
    }
    module.exports.isError = $6cb29018fbdc8fcc$var$isError;
    module.exports.types.isNativeError = $6cb29018fbdc8fcc$var$isError;
    function $6cb29018fbdc8fcc$var$isFunction(arg) {
        return typeof arg === 'function';
    }
    module.exports.isFunction = $6cb29018fbdc8fcc$var$isFunction;
    function $6cb29018fbdc8fcc$var$isPrimitive(arg) {
        return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || typeof arg === 'undefined';
    }
    module.exports.isPrimitive = $6cb29018fbdc8fcc$var$isPrimitive;
    module.exports.isBuffer = (parcelRequire("kEU0N"));
    function $6cb29018fbdc8fcc$var$objectToString(o) {
        return Object.prototype.toString.call(o);
    }
    function $6cb29018fbdc8fcc$var$pad(n) {
        return n < 10 ? '0' + n.toString(10) : n.toString(10);
    }
    var $6cb29018fbdc8fcc$var$months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    function $6cb29018fbdc8fcc$var$timestamp() {
        var d = new Date();
        var time = [
            $6cb29018fbdc8fcc$var$pad(d.getHours()),
            $6cb29018fbdc8fcc$var$pad(d.getMinutes()),
            $6cb29018fbdc8fcc$var$pad(d.getSeconds())
        ].join(':');
        return [
            d.getDate(),
            $6cb29018fbdc8fcc$var$months[d.getMonth()],
            time
        ].join(' ');
    }
    module.exports.log = function() {
        console.log('%s - %s', $6cb29018fbdc8fcc$var$timestamp(), module.exports.format.apply(module.exports, arguments));
    };
    module.exports.inherits = (parcelRequire("v3bBu"));
    module.exports._extend = function(origin, add) {
        if (!add || !$6cb29018fbdc8fcc$var$isObject(add)) return origin;
        var keys = Object.keys(add);
        var i = keys.length;
        while(i--)origin[keys[i]] = add[keys[i]];
        return origin;
    };
    function $6cb29018fbdc8fcc$var$hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    var $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
    module.exports.promisify = function promisify(original) {
        if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
        if ($6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol && original[$6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol]) {
            var fn = original[$6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol];
            if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            Object.defineProperty(fn, $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol, {
                value: fn,
                enumerable: false,
                writable: false,
                configurable: true
            });
            return fn;
        }
        function fn() {
            var promiseResolve, promiseReject;
            var promise = new Promise(function(resolve, reject) {
                promiseResolve = resolve;
                promiseReject = reject;
            });
            var args = [];
            for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
            args.push(function(err, value) {
                if (err) promiseReject(err);
                else promiseResolve(value);
            });
            try {
                original.apply(this, args);
            } catch (err) {
                promiseReject(err);
            }
            return promise;
        }
        Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
        if ($6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return Object.defineProperties(fn, $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors(original));
    };
    module.exports.promisify.custom = $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol;
    function $6cb29018fbdc8fcc$var$callbackifyOnRejected(reason, cb) {
        if (!reason) {
            var newReason = new Error('Promise was rejected with a falsy value');
            newReason.reason = reason;
            reason = newReason;
        }
        return cb(reason);
    }
    function $6cb29018fbdc8fcc$var$callbackify(original) {
        if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
        function callbackified() {
            var args = [];
            for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
            var maybeCb = args.pop();
            if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
            var self = this;
            var cb = function() {
                return maybeCb.apply(self, arguments);
            };
            original.apply(this, args).then(function(ret) {
                $6cAn5.nextTick(cb.bind(null, null, ret));
            }, function(rej) {
                $6cAn5.nextTick($6cb29018fbdc8fcc$var$callbackifyOnRejected.bind(null, rej, cb));
            });
        }
        Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
        Object.defineProperties(callbackified, $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors(original));
        return callbackified;
    }
    module.exports.callbackify = $6cb29018fbdc8fcc$var$callbackify;
});
parcelRegister("jGyMi", function(module, exports) {
    'use strict';
    var $eyPxb = parcelRequire("eyPxb");
    var $kF7vh = parcelRequire("kF7vh");
    var $hdl59;
    var $dFTgY;
    function $e54ceaba9c647d57$var$uncurryThis(f) {
        return f.call.bind(f);
    }
    var $e54ceaba9c647d57$var$BigIntSupported = typeof BigInt !== 'undefined';
    var $e54ceaba9c647d57$var$SymbolSupported = typeof Symbol !== 'undefined';
    var $e54ceaba9c647d57$var$ObjectToString = $e54ceaba9c647d57$var$uncurryThis(Object.prototype.toString);
    var $e54ceaba9c647d57$var$numberValue = $e54ceaba9c647d57$var$uncurryThis(Number.prototype.valueOf);
    var $e54ceaba9c647d57$var$stringValue = $e54ceaba9c647d57$var$uncurryThis(String.prototype.valueOf);
    var $e54ceaba9c647d57$var$booleanValue = $e54ceaba9c647d57$var$uncurryThis(Boolean.prototype.valueOf);
    if ($e54ceaba9c647d57$var$BigIntSupported) var $e54ceaba9c647d57$var$bigIntValue = $e54ceaba9c647d57$var$uncurryThis(BigInt.prototype.valueOf);
    if ($e54ceaba9c647d57$var$SymbolSupported) var $e54ceaba9c647d57$var$symbolValue = $e54ceaba9c647d57$var$uncurryThis(Symbol.prototype.valueOf);
    function $e54ceaba9c647d57$var$checkBoxedPrimitive(value, prototypeValueOf) {
        if (typeof value !== 'object') return false;
        try {
            prototypeValueOf(value);
            return true;
        } catch (e) {
            return false;
        }
    }
    module.exports.isArgumentsObject = $eyPxb;
    module.exports.isGeneratorFunction = $kF7vh;
    module.exports.isTypedArray = (0, parcelRequire("dFTgY"));
    function $e54ceaba9c647d57$var$isPromise(input) {
        return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
    }
    module.exports.isPromise = $e54ceaba9c647d57$var$isPromise;
    function $e54ceaba9c647d57$var$isArrayBufferView(value) {
        if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
        return (0, parcelRequire("dFTgY"))(value) || $e54ceaba9c647d57$var$isDataView(value);
    }
    module.exports.isArrayBufferView = $e54ceaba9c647d57$var$isArrayBufferView;
    function $e54ceaba9c647d57$var$isUint8Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint8Array';
    }
    module.exports.isUint8Array = $e54ceaba9c647d57$var$isUint8Array;
    function $e54ceaba9c647d57$var$isUint8ClampedArray(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint8ClampedArray';
    }
    module.exports.isUint8ClampedArray = $e54ceaba9c647d57$var$isUint8ClampedArray;
    function $e54ceaba9c647d57$var$isUint16Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint16Array';
    }
    module.exports.isUint16Array = $e54ceaba9c647d57$var$isUint16Array;
    function $e54ceaba9c647d57$var$isUint32Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint32Array';
    }
    module.exports.isUint32Array = $e54ceaba9c647d57$var$isUint32Array;
    function $e54ceaba9c647d57$var$isInt8Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Int8Array';
    }
    module.exports.isInt8Array = $e54ceaba9c647d57$var$isInt8Array;
    function $e54ceaba9c647d57$var$isInt16Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Int16Array';
    }
    module.exports.isInt16Array = $e54ceaba9c647d57$var$isInt16Array;
    function $e54ceaba9c647d57$var$isInt32Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Int32Array';
    }
    module.exports.isInt32Array = $e54ceaba9c647d57$var$isInt32Array;
    function $e54ceaba9c647d57$var$isFloat32Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Float32Array';
    }
    module.exports.isFloat32Array = $e54ceaba9c647d57$var$isFloat32Array;
    function $e54ceaba9c647d57$var$isFloat64Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Float64Array';
    }
    module.exports.isFloat64Array = $e54ceaba9c647d57$var$isFloat64Array;
    function $e54ceaba9c647d57$var$isBigInt64Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'BigInt64Array';
    }
    module.exports.isBigInt64Array = $e54ceaba9c647d57$var$isBigInt64Array;
    function $e54ceaba9c647d57$var$isBigUint64Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'BigUint64Array';
    }
    module.exports.isBigUint64Array = $e54ceaba9c647d57$var$isBigUint64Array;
    function $e54ceaba9c647d57$var$isMapToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Map]';
    }
    $e54ceaba9c647d57$var$isMapToString.working = typeof Map !== 'undefined' && $e54ceaba9c647d57$var$isMapToString(new Map());
    function $e54ceaba9c647d57$var$isMap(value) {
        if (typeof Map === 'undefined') return false;
        return $e54ceaba9c647d57$var$isMapToString.working ? $e54ceaba9c647d57$var$isMapToString(value) : value instanceof Map;
    }
    module.exports.isMap = $e54ceaba9c647d57$var$isMap;
    function $e54ceaba9c647d57$var$isSetToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Set]';
    }
    $e54ceaba9c647d57$var$isSetToString.working = typeof Set !== 'undefined' && $e54ceaba9c647d57$var$isSetToString(new Set());
    function $e54ceaba9c647d57$var$isSet(value) {
        if (typeof Set === 'undefined') return false;
        return $e54ceaba9c647d57$var$isSetToString.working ? $e54ceaba9c647d57$var$isSetToString(value) : value instanceof Set;
    }
    module.exports.isSet = $e54ceaba9c647d57$var$isSet;
    function $e54ceaba9c647d57$var$isWeakMapToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WeakMap]';
    }
    $e54ceaba9c647d57$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $e54ceaba9c647d57$var$isWeakMapToString(new WeakMap());
    function $e54ceaba9c647d57$var$isWeakMap(value) {
        if (typeof WeakMap === 'undefined') return false;
        return $e54ceaba9c647d57$var$isWeakMapToString.working ? $e54ceaba9c647d57$var$isWeakMapToString(value) : value instanceof WeakMap;
    }
    module.exports.isWeakMap = $e54ceaba9c647d57$var$isWeakMap;
    function $e54ceaba9c647d57$var$isWeakSetToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WeakSet]';
    }
    $e54ceaba9c647d57$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $e54ceaba9c647d57$var$isWeakSetToString(new WeakSet());
    function $e54ceaba9c647d57$var$isWeakSet(value) {
        return $e54ceaba9c647d57$var$isWeakSetToString(value);
    }
    module.exports.isWeakSet = $e54ceaba9c647d57$var$isWeakSet;
    function $e54ceaba9c647d57$var$isArrayBufferToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object ArrayBuffer]';
    }
    $e54ceaba9c647d57$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $e54ceaba9c647d57$var$isArrayBufferToString(new ArrayBuffer());
    function $e54ceaba9c647d57$var$isArrayBuffer(value) {
        if (typeof ArrayBuffer === 'undefined') return false;
        return $e54ceaba9c647d57$var$isArrayBufferToString.working ? $e54ceaba9c647d57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
    }
    module.exports.isArrayBuffer = $e54ceaba9c647d57$var$isArrayBuffer;
    function $e54ceaba9c647d57$var$isDataViewToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object DataView]';
    }
    $e54ceaba9c647d57$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $e54ceaba9c647d57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
    function $e54ceaba9c647d57$var$isDataView(value) {
        if (typeof DataView === 'undefined') return false;
        return $e54ceaba9c647d57$var$isDataViewToString.working ? $e54ceaba9c647d57$var$isDataViewToString(value) : value instanceof DataView;
    }
    module.exports.isDataView = $e54ceaba9c647d57$var$isDataView;
    var $e54ceaba9c647d57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
    function $e54ceaba9c647d57$var$isSharedArrayBufferToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object SharedArrayBuffer]';
    }
    function $e54ceaba9c647d57$var$isSharedArrayBuffer(value) {
        if (typeof $e54ceaba9c647d57$var$SharedArrayBufferCopy === 'undefined') return false;
        if (typeof $e54ceaba9c647d57$var$isSharedArrayBufferToString.working === 'undefined') $e54ceaba9c647d57$var$isSharedArrayBufferToString.working = $e54ceaba9c647d57$var$isSharedArrayBufferToString(new $e54ceaba9c647d57$var$SharedArrayBufferCopy());
        return $e54ceaba9c647d57$var$isSharedArrayBufferToString.working ? $e54ceaba9c647d57$var$isSharedArrayBufferToString(value) : value instanceof $e54ceaba9c647d57$var$SharedArrayBufferCopy;
    }
    module.exports.isSharedArrayBuffer = $e54ceaba9c647d57$var$isSharedArrayBuffer;
    function $e54ceaba9c647d57$var$isAsyncFunction(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object AsyncFunction]';
    }
    module.exports.isAsyncFunction = $e54ceaba9c647d57$var$isAsyncFunction;
    function $e54ceaba9c647d57$var$isMapIterator(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Map Iterator]';
    }
    module.exports.isMapIterator = $e54ceaba9c647d57$var$isMapIterator;
    function $e54ceaba9c647d57$var$isSetIterator(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Set Iterator]';
    }
    module.exports.isSetIterator = $e54ceaba9c647d57$var$isSetIterator;
    function $e54ceaba9c647d57$var$isGeneratorObject(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Generator]';
    }
    module.exports.isGeneratorObject = $e54ceaba9c647d57$var$isGeneratorObject;
    function $e54ceaba9c647d57$var$isWebAssemblyCompiledModule(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WebAssembly.Module]';
    }
    module.exports.isWebAssemblyCompiledModule = $e54ceaba9c647d57$var$isWebAssemblyCompiledModule;
    function $e54ceaba9c647d57$var$isNumberObject(value) {
        return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$numberValue);
    }
    module.exports.isNumberObject = $e54ceaba9c647d57$var$isNumberObject;
    function $e54ceaba9c647d57$var$isStringObject(value) {
        return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$stringValue);
    }
    module.exports.isStringObject = $e54ceaba9c647d57$var$isStringObject;
    function $e54ceaba9c647d57$var$isBooleanObject(value) {
        return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$booleanValue);
    }
    module.exports.isBooleanObject = $e54ceaba9c647d57$var$isBooleanObject;
    function $e54ceaba9c647d57$var$isBigIntObject(value) {
        return $e54ceaba9c647d57$var$BigIntSupported && $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$bigIntValue);
    }
    module.exports.isBigIntObject = $e54ceaba9c647d57$var$isBigIntObject;
    function $e54ceaba9c647d57$var$isSymbolObject(value) {
        return $e54ceaba9c647d57$var$SymbolSupported && $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$symbolValue);
    }
    module.exports.isSymbolObject = $e54ceaba9c647d57$var$isSymbolObject;
    function $e54ceaba9c647d57$var$isBoxedPrimitive(value) {
        return $e54ceaba9c647d57$var$isNumberObject(value) || $e54ceaba9c647d57$var$isStringObject(value) || $e54ceaba9c647d57$var$isBooleanObject(value) || $e54ceaba9c647d57$var$isBigIntObject(value) || $e54ceaba9c647d57$var$isSymbolObject(value);
    }
    module.exports.isBoxedPrimitive = $e54ceaba9c647d57$var$isBoxedPrimitive;
    function $e54ceaba9c647d57$var$isAnyArrayBuffer(value) {
        return typeof Uint8Array !== 'undefined' && ($e54ceaba9c647d57$var$isArrayBuffer(value) || $e54ceaba9c647d57$var$isSharedArrayBuffer(value));
    }
    module.exports.isAnyArrayBuffer = $e54ceaba9c647d57$var$isAnyArrayBuffer;
    [
        'isProxy',
        'isExternal',
        'isModuleNamespaceObject'
    ].forEach(function(method) {
        Object.defineProperty(module.exports, method, {
            enumerable: false,
            value: function() {
                throw new Error(method + ' is not supported in userland');
            }
        });
    });
});
parcelRegister("eyPxb", function(module, exports) {
    'use strict';
    var $a99c3747cd09063d$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $53KqO = parcelRequire("53KqO");
    var $a99c3747cd09063d$var$$toString = $53KqO('Object.prototype.toString');
    var $a99c3747cd09063d$var$isStandardArguments = function isArguments(value) {
        if ($a99c3747cd09063d$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
        return $a99c3747cd09063d$var$$toString(value) === '[object Arguments]';
    };
    var $a99c3747cd09063d$var$isLegacyArguments = function isArguments(value) {
        if ($a99c3747cd09063d$var$isStandardArguments(value)) return true;
        return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $a99c3747cd09063d$var$$toString(value) !== '[object Array]' && $a99c3747cd09063d$var$$toString(value.callee) === '[object Function]';
    };
    var $a99c3747cd09063d$var$supportsStandardArguments = function() {
        return $a99c3747cd09063d$var$isStandardArguments(arguments);
    }();
    $a99c3747cd09063d$var$isStandardArguments.isLegacyArguments = $a99c3747cd09063d$var$isLegacyArguments;
    module.exports = $a99c3747cd09063d$var$supportsStandardArguments ? $a99c3747cd09063d$var$isStandardArguments : $a99c3747cd09063d$var$isLegacyArguments;
});
parcelRegister("fmBzB", function(module, exports) {
    'use strict';
    var $9T9x9 = parcelRequire("9T9x9");
    module.exports = function hasToStringTagShams() {
        return $9T9x9() && !!Symbol.toStringTag;
    };
});
parcelRegister("kF7vh", function(module, exports) {
    'use strict';
    var $f0ad750370f41c64$var$toStr = Object.prototype.toString;
    var $f0ad750370f41c64$var$fnToStr = Function.prototype.toString;
    var $f0ad750370f41c64$var$isFnRegex = /^\s*(?:function)?\*/;
    var $f0ad750370f41c64$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $f0ad750370f41c64$var$getProto = Object.getPrototypeOf;
    var $f0ad750370f41c64$var$getGeneratorFunc = function() {
        if (!$f0ad750370f41c64$var$hasToStringTag) return false;
        try {
            return Function('return function*() {}')();
        } catch (e) {}
    };
    var $f0ad750370f41c64$var$GeneratorFunction;
    module.exports = function isGeneratorFunction(fn) {
        if (typeof fn !== 'function') return false;
        if ($f0ad750370f41c64$var$isFnRegex.test($f0ad750370f41c64$var$fnToStr.call(fn))) return true;
        if (!$f0ad750370f41c64$var$hasToStringTag) {
            var str = $f0ad750370f41c64$var$toStr.call(fn);
            return str === '[object GeneratorFunction]';
        }
        if (!$f0ad750370f41c64$var$getProto) return false;
        if (typeof $f0ad750370f41c64$var$GeneratorFunction === 'undefined') {
            var generatorFunc = $f0ad750370f41c64$var$getGeneratorFunc();
            $f0ad750370f41c64$var$GeneratorFunction = generatorFunc ? $f0ad750370f41c64$var$getProto(generatorFunc) : false;
        }
        return $f0ad750370f41c64$var$getProto(fn) === $f0ad750370f41c64$var$GeneratorFunction;
    };
});
parcelRegister("hdl59", function(module, exports) {
    'use strict';
    var $258uT = parcelRequire("258uT");
    var $9ME5O;
    var $h05ZS = parcelRequire("h05ZS");
    var $53KqO = parcelRequire("53KqO");
    var $lBvcQ;
    var $c884010d01443113$var$$toString = $53KqO('Object.prototype.toString');
    var $c884010d01443113$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $c884010d01443113$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
    var $c884010d01443113$var$typedArrays = (0, parcelRequire("9ME5O"))();
    var $c884010d01443113$var$$slice = $53KqO('String.prototype.slice');
    var $c884010d01443113$var$getPrototypeOf = Object.getPrototypeOf;
    var $c884010d01443113$var$$indexOf = $53KqO('Array.prototype.indexOf', true) || function indexOf(array, value) {
        for(var i = 0; i < array.length; i += 1){
            if (array[i] === value) return i;
        }
        return -1;
    };
    var $c884010d01443113$var$cache = {
        __proto__: null
    };
    if ($c884010d01443113$var$hasToStringTag && (0, parcelRequire("lBvcQ")) && $c884010d01443113$var$getPrototypeOf) $258uT($c884010d01443113$var$typedArrays, function(typedArray) {
        var arr = new $c884010d01443113$var$g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = $c884010d01443113$var$getPrototypeOf(arr);
            var descriptor = (0, parcelRequire("lBvcQ"))(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = $c884010d01443113$var$getPrototypeOf(proto);
                descriptor = (0, parcelRequire("lBvcQ"))(superProto, Symbol.toStringTag);
            }
            $c884010d01443113$var$cache['$' + typedArray] = $h05ZS(descriptor.get);
        }
    });
    else $258uT($c884010d01443113$var$typedArrays, function(typedArray) {
        var arr = new $c884010d01443113$var$g[typedArray]();
        var fn = arr.slice || arr.set;
        if (fn) $c884010d01443113$var$cache['$' + typedArray] = $h05ZS(fn);
    });
    var $c884010d01443113$var$tryTypedArrays = function tryAllTypedArrays(value) {
        var found = false;
        $258uT($c884010d01443113$var$cache, function(getter, typedArray) {
            if (!found) try {
                if ('$' + getter(value) === typedArray) found = $c884010d01443113$var$$slice(typedArray, 1);
            } catch (e) {}
        });
        return found;
    };
    var $c884010d01443113$var$trySlices = function tryAllSlices(value) {
        var found = false;
        $258uT($c884010d01443113$var$cache, function(getter, name) {
            if (!found) try {
                getter(value);
                found = $c884010d01443113$var$$slice(name, 1);
            } catch (e) {}
        });
        return found;
    };
    module.exports = function whichTypedArray(value) {
        if (!value || typeof value !== 'object') return false;
        if (!$c884010d01443113$var$hasToStringTag) {
            var tag = $c884010d01443113$var$$slice($c884010d01443113$var$$toString(value), 8, -1);
            if ($c884010d01443113$var$$indexOf($c884010d01443113$var$typedArrays, tag) > -1) return tag;
            if (tag !== 'Object') return false;
            return $c884010d01443113$var$trySlices(value);
        }
        if (!(0, parcelRequire("lBvcQ"))) return null;
        return $c884010d01443113$var$tryTypedArrays(value);
    };
});
parcelRegister("258uT", function(module, exports) {
    'use strict';
    var $f0Tdg = parcelRequire("f0Tdg");
    var $1842a3cb7df292b5$var$toStr = Object.prototype.toString;
    var $1842a3cb7df292b5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    var $1842a3cb7df292b5$var$forEachArray = function forEachArray(array, iterator, receiver) {
        for(var i = 0, len = array.length; i < len; i++)if ($1842a3cb7df292b5$var$hasOwnProperty.call(array, i)) {
            if (receiver == null) iterator(array[i], i, array);
            else iterator.call(receiver, array[i], i, array);
        }
    };
    var $1842a3cb7df292b5$var$forEachString = function forEachString(string, iterator, receiver) {
        for(var i = 0, len = string.length; i < len; i++)if (receiver == null) iterator(string.charAt(i), i, string);
        else iterator.call(receiver, string.charAt(i), i, string);
    };
    var $1842a3cb7df292b5$var$forEachObject = function forEachObject(object, iterator, receiver) {
        for(var k in object)if ($1842a3cb7df292b5$var$hasOwnProperty.call(object, k)) {
            if (receiver == null) iterator(object[k], k, object);
            else iterator.call(receiver, object[k], k, object);
        }
    };
    var $1842a3cb7df292b5$var$forEach = function forEach(list, iterator, thisArg) {
        if (!$f0Tdg(iterator)) throw new TypeError('iterator must be a function');
        var receiver;
        if (arguments.length >= 3) receiver = thisArg;
        if ($1842a3cb7df292b5$var$toStr.call(list) === '[object Array]') $1842a3cb7df292b5$var$forEachArray(list, iterator, receiver);
        else if (typeof list === 'string') $1842a3cb7df292b5$var$forEachString(list, iterator, receiver);
        else $1842a3cb7df292b5$var$forEachObject(list, iterator, receiver);
    };
    module.exports = $1842a3cb7df292b5$var$forEach;
});
parcelRegister("f0Tdg", function(module, exports) {
    'use strict';
    var $02d21778b0eebae4$var$fnToStr = Function.prototype.toString;
    var $02d21778b0eebae4$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
    var $02d21778b0eebae4$var$badArrayLike;
    var $02d21778b0eebae4$var$isCallableMarker;
    if (typeof $02d21778b0eebae4$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
        $02d21778b0eebae4$var$badArrayLike = Object.defineProperty({}, 'length', {
            get: function() {
                throw $02d21778b0eebae4$var$isCallableMarker;
            }
        });
        $02d21778b0eebae4$var$isCallableMarker = {};
        $02d21778b0eebae4$var$reflectApply(function() {
            throw 42;
        }, null, $02d21778b0eebae4$var$badArrayLike);
    } catch (_) {
        if (_ !== $02d21778b0eebae4$var$isCallableMarker) $02d21778b0eebae4$var$reflectApply = null;
    }
    else $02d21778b0eebae4$var$reflectApply = null;
    var $02d21778b0eebae4$var$constructorRegex = /^\s*class\b/;
    var $02d21778b0eebae4$var$isES6ClassFn = function isES6ClassFunction(value) {
        try {
            var fnStr = $02d21778b0eebae4$var$fnToStr.call(value);
            return $02d21778b0eebae4$var$constructorRegex.test(fnStr);
        } catch (e) {
            return false;
        }
    };
    var $02d21778b0eebae4$var$tryFunctionObject = function tryFunctionToStr(value) {
        try {
            if ($02d21778b0eebae4$var$isES6ClassFn(value)) return false;
            $02d21778b0eebae4$var$fnToStr.call(value);
            return true;
        } catch (e) {
            return false;
        }
    };
    var $02d21778b0eebae4$var$toStr = Object.prototype.toString;
    var $02d21778b0eebae4$var$objectClass = '[object Object]';
    var $02d21778b0eebae4$var$fnClass = '[object Function]';
    var $02d21778b0eebae4$var$genClass = '[object GeneratorFunction]';
    var $02d21778b0eebae4$var$ddaClass = '[object HTMLAllCollection]';
    var $02d21778b0eebae4$var$ddaClass2 = '[object HTML document.all class]';
    var $02d21778b0eebae4$var$ddaClass3 = '[object HTMLCollection]';
    var $02d21778b0eebae4$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag;
    var $02d21778b0eebae4$var$isIE68 = !(0 in [
        , 
    ]);
    var $02d21778b0eebae4$var$isDDA = function isDocumentDotAll() {
        return false;
    };
    if (typeof document === 'object') {
        var $02d21778b0eebae4$var$all = document.all;
        if ($02d21778b0eebae4$var$toStr.call($02d21778b0eebae4$var$all) === $02d21778b0eebae4$var$toStr.call(document.all)) $02d21778b0eebae4$var$isDDA = function isDocumentDotAll(value) {
            if (($02d21778b0eebae4$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
                var str = $02d21778b0eebae4$var$toStr.call(value);
                return (str === $02d21778b0eebae4$var$ddaClass || str === $02d21778b0eebae4$var$ddaClass2 || str === $02d21778b0eebae4$var$ddaClass3 || str === $02d21778b0eebae4$var$objectClass) && value('') == null;
            } catch (e) {}
            return false;
        };
    }
    module.exports = $02d21778b0eebae4$var$reflectApply ? function isCallable(value) {
        if ($02d21778b0eebae4$var$isDDA(value)) return true;
        if (!value) return false;
        if (typeof value !== 'function' && typeof value !== 'object') return false;
        try {
            $02d21778b0eebae4$var$reflectApply(value, null, $02d21778b0eebae4$var$badArrayLike);
        } catch (e) {
            if (e !== $02d21778b0eebae4$var$isCallableMarker) return false;
        }
        return !$02d21778b0eebae4$var$isES6ClassFn(value) && $02d21778b0eebae4$var$tryFunctionObject(value);
    } : function isCallable(value) {
        if ($02d21778b0eebae4$var$isDDA(value)) return true;
        if (!value) return false;
        if (typeof value !== 'function' && typeof value !== 'object') return false;
        if ($02d21778b0eebae4$var$hasToStringTag) return $02d21778b0eebae4$var$tryFunctionObject(value);
        if ($02d21778b0eebae4$var$isES6ClassFn(value)) return false;
        var strClass = $02d21778b0eebae4$var$toStr.call(value);
        if (strClass !== $02d21778b0eebae4$var$fnClass && strClass !== $02d21778b0eebae4$var$genClass && !/^\[object HTML/.test(strClass)) return false;
        return $02d21778b0eebae4$var$tryFunctionObject(value);
    };
});
parcelRegister("9ME5O", function(module, exports) {
    'use strict';
    var $8a51N;
    var $71f7b254c38edcde$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
    module.exports = function availableTypedArrays() {
        var out = [];
        for(var i = 0; i < (0, parcelRequire("8a51N")).length; i++)if (typeof $71f7b254c38edcde$var$g[(0, parcelRequire("8a51N"))[i]] === 'function') out[out.length] = (0, parcelRequire("8a51N"))[i];
        return out;
    };
});
parcelRegister("8a51N", function(module, exports) {
    'use strict';
    module.exports = [
        'Float32Array',
        'Float64Array',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'BigInt64Array',
        'BigUint64Array'
    ];
});
parcelRegister("dFTgY", function(module, exports) {
    'use strict';
    var $hdl59;
    module.exports = function isTypedArray(value) {
        return !!(0, parcelRequire("hdl59"))(value);
    };
});
parcelRegister("kEU0N", function(module, exports) {
    module.exports = function isBuffer(arg) {
        return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
    };
});
parcelRegister("v3bBu", function(module, exports) {
    if (typeof Object.create === 'function') module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
parcelRegister("3ZLjA", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    function $2e8bc5606025d797$var$ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function $2e8bc5606025d797$var$_objectSpread(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? $2e8bc5606025d797$var$ownKeys(Object(t), !0).forEach(function(r) {
                $2e8bc5606025d797$var$_defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e8bc5606025d797$var$ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function $2e8bc5606025d797$var$_defineProperty(obj, key, value) {
        key = $2e8bc5606025d797$var$_toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $2e8bc5606025d797$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $2e8bc5606025d797$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $2e8bc5606025d797$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $2e8bc5606025d797$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $2e8bc5606025d797$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $2e8bc5606025d797$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $2e8bc5606025d797$var$_toPropertyKey(arg) {
        var key = $2e8bc5606025d797$var$_toPrimitive(arg, "string");
        return $2e8bc5606025d797$var$_typeof(key) === "symbol" ? key : String(key);
    }
    function $2e8bc5606025d797$var$_toPrimitive(input, hint) {
        if ($2e8bc5606025d797$var$_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if ($2e8bc5606025d797$var$_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function $2e8bc5606025d797$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        Object.defineProperty(subClass, "prototype", {
            writable: false
        });
        if (superClass) $2e8bc5606025d797$var$_setPrototypeOf(subClass, superClass);
    }
    function $2e8bc5606025d797$var$_createSuper(Derived) {
        var hasNativeReflectConstruct = $2e8bc5606025d797$var$_isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = $2e8bc5606025d797$var$_getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = $2e8bc5606025d797$var$_getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return $2e8bc5606025d797$var$_possibleConstructorReturn(this, result);
        };
    }
    function $2e8bc5606025d797$var$_possibleConstructorReturn(self, call) {
        if (call && ($2e8bc5606025d797$var$_typeof(call) === "object" || typeof call === "function")) return call;
        else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return $2e8bc5606025d797$var$_assertThisInitialized(self);
    }
    function $2e8bc5606025d797$var$_assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function $2e8bc5606025d797$var$_wrapNativeSuper(Class) {
        var _cache = typeof Map === "function" ? new Map() : undefined;
        $2e8bc5606025d797$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
            if (Class === null || !$2e8bc5606025d797$var$_isNativeFunction(Class)) return Class;
            if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
            if (typeof _cache !== "undefined") {
                if (_cache.has(Class)) return _cache.get(Class);
                _cache.set(Class, Wrapper);
            }
            function Wrapper() {
                return $2e8bc5606025d797$var$_construct(Class, arguments, $2e8bc5606025d797$var$_getPrototypeOf(this).constructor);
            }
            Wrapper.prototype = Object.create(Class.prototype, {
                constructor: {
                    value: Wrapper,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            return $2e8bc5606025d797$var$_setPrototypeOf(Wrapper, Class);
        };
        return $2e8bc5606025d797$var$_wrapNativeSuper(Class);
    }
    function $2e8bc5606025d797$var$_construct(Parent, args, Class) {
        if ($2e8bc5606025d797$var$_isNativeReflectConstruct()) $2e8bc5606025d797$var$_construct = Reflect.construct.bind();
        else $2e8bc5606025d797$var$_construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) $2e8bc5606025d797$var$_setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return $2e8bc5606025d797$var$_construct.apply(null, arguments);
    }
    function $2e8bc5606025d797$var$_isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function $2e8bc5606025d797$var$_isNativeFunction(fn) {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }
    function $2e8bc5606025d797$var$_setPrototypeOf(o, p) {
        $2e8bc5606025d797$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return $2e8bc5606025d797$var$_setPrototypeOf(o, p);
    }
    function $2e8bc5606025d797$var$_getPrototypeOf(o) {
        $2e8bc5606025d797$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return $2e8bc5606025d797$var$_getPrototypeOf(o);
    }
    function $2e8bc5606025d797$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $2e8bc5606025d797$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $2e8bc5606025d797$var$_typeof(o);
    }
    var $9kAQu = parcelRequire("9kAQu");
    var $2e8bc5606025d797$var$inspect = $9kAQu.inspect;
    var $8JAro = parcelRequire("8JAro");
    var $2e8bc5606025d797$var$ERR_INVALID_ARG_TYPE = $8JAro.codes.ERR_INVALID_ARG_TYPE;
    function $2e8bc5606025d797$var$endsWith(str, search, this_len) {
        if (this_len === undefined || this_len > str.length) this_len = str.length;
        return str.substring(this_len - search.length, this_len) === search;
    }
    function $2e8bc5606025d797$var$repeat(str, count) {
        count = Math.floor(count);
        if (str.length == 0 || count == 0) return '';
        var maxCount = str.length * count;
        count = Math.floor(Math.log(count) / Math.log(2));
        while(count){
            str += str;
            count--;
        }
        str += str.substring(0, maxCount - str.length);
        return str;
    }
    var $2e8bc5606025d797$var$blue = '';
    var $2e8bc5606025d797$var$green = '';
    var $2e8bc5606025d797$var$red = '';
    var $2e8bc5606025d797$var$white = '';
    var $2e8bc5606025d797$var$kReadableOperator = {
        deepStrictEqual: 'Expected values to be strictly deep-equal:',
        strictEqual: 'Expected values to be strictly equal:',
        strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
        deepEqual: 'Expected values to be loosely deep-equal:',
        equal: 'Expected values to be loosely equal:',
        notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
        notStrictEqual: 'Expected "actual" to be strictly unequal to:',
        notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
        notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
        notEqual: 'Expected "actual" to be loosely unequal to:',
        notIdentical: 'Values identical but not reference-equal:'
    };
    var $2e8bc5606025d797$var$kMaxShortLength = 10;
    function $2e8bc5606025d797$var$copyError(source) {
        var keys = Object.keys(source);
        var target = Object.create(Object.getPrototypeOf(source));
        keys.forEach(function(key) {
            target[key] = source[key];
        });
        Object.defineProperty(target, 'message', {
            value: source.message
        });
        return target;
    }
    function $2e8bc5606025d797$var$inspectValue(val) {
        return $2e8bc5606025d797$var$inspect(val, {
            compact: false,
            customInspect: false,
            depth: 1000,
            maxArrayLength: Infinity,
            showHidden: false,
            breakLength: Infinity,
            showProxy: false,
            sorted: true,
            getters: true
        });
    }
    function $2e8bc5606025d797$var$createErrDiff(actual, expected, operator) {
        var other = '';
        var res = '';
        var lastPos = 0;
        var end = '';
        var skipped = false;
        var actualInspected = $2e8bc5606025d797$var$inspectValue(actual);
        var actualLines = actualInspected.split('\n');
        var expectedLines = $2e8bc5606025d797$var$inspectValue(expected).split('\n');
        var i = 0;
        var indicator = '';
        if (operator === 'strictEqual' && $2e8bc5606025d797$var$_typeof(actual) === 'object' && $2e8bc5606025d797$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
        if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
            var inputLength = actualLines[0].length + expectedLines[0].length;
            if (inputLength <= $2e8bc5606025d797$var$kMaxShortLength) {
                if (($2e8bc5606025d797$var$_typeof(actual) !== 'object' || actual === null) && ($2e8bc5606025d797$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) return "".concat($2e8bc5606025d797$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
            } else if (operator !== 'strictEqualObject') {
                var maxLength = $6cAn5.stderr && $6cAn5.stderr.isTTY ? $6cAn5.stderr.columns : 80;
                if (inputLength < maxLength) {
                    while(actualLines[0][i] === expectedLines[0][i])i++;
                    if (i > 2) {
                        indicator = "\n  ".concat($2e8bc5606025d797$var$repeat(' ', i), "^");
                        i = 0;
                    }
                }
            }
        }
        var a = actualLines[actualLines.length - 1];
        var b = expectedLines[expectedLines.length - 1];
        while(a === b){
            if (i++ < 2) end = "\n  ".concat(a).concat(end);
            else other = a;
            actualLines.pop();
            expectedLines.pop();
            if (actualLines.length === 0 || expectedLines.length === 0) break;
            a = actualLines[actualLines.length - 1];
            b = expectedLines[expectedLines.length - 1];
        }
        var maxLines = Math.max(actualLines.length, expectedLines.length);
        if (maxLines === 0) {
            var _actualLines = actualInspected.split('\n');
            if (_actualLines.length > 30) {
                _actualLines[26] = "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                while(_actualLines.length > 27)_actualLines.pop();
            }
            return "".concat($2e8bc5606025d797$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
        }
        if (i > 3) {
            end = "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white).concat(end);
            skipped = true;
        }
        if (other !== '') {
            end = "\n  ".concat(other).concat(end);
            other = '';
        }
        var printedLines = 0;
        var msg = $2e8bc5606025d797$var$kReadableOperator[operator] + "\n".concat($2e8bc5606025d797$var$green, "+ actual").concat($2e8bc5606025d797$var$white, " ").concat($2e8bc5606025d797$var$red, "- expected").concat($2e8bc5606025d797$var$white);
        var skippedMsg = " ".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white, " Lines skipped");
        for(i = 0; i < maxLines; i++){
            var cur = i - lastPos;
            if (actualLines.length < i + 1) {
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(expectedLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(expectedLines[i - 1]);
                    printedLines++;
                }
                lastPos = i;
                other += "\n".concat($2e8bc5606025d797$var$red, "-").concat($2e8bc5606025d797$var$white, " ").concat(expectedLines[i]);
                printedLines++;
            } else if (expectedLines.length < i + 1) {
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                lastPos = i;
                res += "\n".concat($2e8bc5606025d797$var$green, "+").concat($2e8bc5606025d797$var$white, " ").concat(actualLines[i]);
                printedLines++;
            } else {
                var expectedLine = expectedLines[i];
                var actualLine = actualLines[i];
                var divergingLines = actualLine !== expectedLine && (!$2e8bc5606025d797$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
                if (divergingLines && $2e8bc5606025d797$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                    divergingLines = false;
                    actualLine += ',';
                }
                if (divergingLines) {
                    if (cur > 1 && i > 2) {
                        if (cur > 4) {
                            res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                            skipped = true;
                        } else if (cur > 3) {
                            res += "\n  ".concat(actualLines[i - 2]);
                            printedLines++;
                        }
                        res += "\n  ".concat(actualLines[i - 1]);
                        printedLines++;
                    }
                    lastPos = i;
                    res += "\n".concat($2e8bc5606025d797$var$green, "+").concat($2e8bc5606025d797$var$white, " ").concat(actualLine);
                    other += "\n".concat($2e8bc5606025d797$var$red, "-").concat($2e8bc5606025d797$var$white, " ").concat(expectedLine);
                    printedLines += 2;
                } else {
                    res += other;
                    other = '';
                    if (cur === 1 || i === 0) {
                        res += "\n  ".concat(actualLine);
                        printedLines++;
                    }
                }
            }
            if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white).concat(other, "\n") + "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
        }
        return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
    }
    var $2e8bc5606025d797$var$AssertionError = function(_Error, _inspect$custom) {
        $2e8bc5606025d797$var$_inherits(AssertionError, _Error);
        var _super = $2e8bc5606025d797$var$_createSuper(AssertionError);
        function AssertionError(options) {
            var _this;
            $2e8bc5606025d797$var$_classCallCheck(this, AssertionError);
            if ($2e8bc5606025d797$var$_typeof(options) !== 'object' || options === null) throw new $2e8bc5606025d797$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
            var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
            var actual = options.actual, expected = options.expected;
            var limit = Error.stackTraceLimit;
            Error.stackTraceLimit = 0;
            if (message != null) _this = _super.call(this, String(message));
            else {
                if ($6cAn5.stderr && $6cAn5.stderr.isTTY) {
                    if ($6cAn5.stderr && $6cAn5.stderr.getColorDepth && $6cAn5.stderr.getColorDepth() !== 1) {
                        $2e8bc5606025d797$var$blue = "\x1B[34m";
                        $2e8bc5606025d797$var$green = "\x1B[32m";
                        $2e8bc5606025d797$var$white = "\x1B[39m";
                        $2e8bc5606025d797$var$red = "\x1B[31m";
                    } else {
                        $2e8bc5606025d797$var$blue = '';
                        $2e8bc5606025d797$var$green = '';
                        $2e8bc5606025d797$var$white = '';
                        $2e8bc5606025d797$var$red = '';
                    }
                }
                if ($2e8bc5606025d797$var$_typeof(actual) === 'object' && actual !== null && $2e8bc5606025d797$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                    actual = $2e8bc5606025d797$var$copyError(actual);
                    expected = $2e8bc5606025d797$var$copyError(expected);
                }
                if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $2e8bc5606025d797$var$createErrDiff(actual, expected, operator));
                else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                    var base = $2e8bc5606025d797$var$kReadableOperator[operator];
                    var res = $2e8bc5606025d797$var$inspectValue(actual).split('\n');
                    if (operator === 'notStrictEqual' && $2e8bc5606025d797$var$_typeof(actual) === 'object' && actual !== null) base = $2e8bc5606025d797$var$kReadableOperator.notStrictEqualObject;
                    if (res.length > 30) {
                        res[26] = "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        while(res.length > 27)res.pop();
                    }
                    if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                    else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
                } else {
                    var _res = $2e8bc5606025d797$var$inspectValue(actual);
                    var other = '';
                    var knownOperators = $2e8bc5606025d797$var$kReadableOperator[operator];
                    if (operator === 'notDeepEqual' || operator === 'notEqual') {
                        _res = "".concat($2e8bc5606025d797$var$kReadableOperator[operator], "\n\n").concat(_res);
                        if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                    } else {
                        other = "".concat($2e8bc5606025d797$var$inspectValue(expected));
                        if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                        if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                        if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                        else other = " ".concat(operator, " ").concat(other);
                    }
                    _this = _super.call(this, "".concat(_res).concat(other));
                }
            }
            Error.stackTraceLimit = limit;
            _this.generatedMessage = !message;
            Object.defineProperty($2e8bc5606025d797$var$_assertThisInitialized(_this), 'name', {
                value: 'AssertionError [ERR_ASSERTION]',
                enumerable: false,
                writable: true,
                configurable: true
            });
            _this.code = 'ERR_ASSERTION';
            _this.actual = actual;
            _this.expected = expected;
            _this.operator = operator;
            if (Error.captureStackTrace) Error.captureStackTrace($2e8bc5606025d797$var$_assertThisInitialized(_this), stackStartFn);
            _this.stack;
            _this.name = 'AssertionError';
            return $2e8bc5606025d797$var$_possibleConstructorReturn(_this);
        }
        $2e8bc5606025d797$var$_createClass(AssertionError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
                }
            },
            {
                key: _inspect$custom,
                value: function value(recurseTimes, ctx) {
                    return $2e8bc5606025d797$var$inspect(this, $2e8bc5606025d797$var$_objectSpread($2e8bc5606025d797$var$_objectSpread({}, ctx), {}, {
                        customInspect: false,
                        depth: 0
                    }));
                }
            }
        ]);
        return AssertionError;
    }($2e8bc5606025d797$var$_wrapNativeSuper(Error), $2e8bc5606025d797$var$inspect.custom);
    module.exports = $2e8bc5606025d797$var$AssertionError;
});
parcelRegister("8s5ew", function(module, exports) {
    'use strict';
    var $3WQC3 = parcelRequire("3WQC3");
    var $0196883fce51d67b$var$lacksProperEnumerationOrder = function() {
        if (!Object.assign) return false;
        var str = 'abcdefghijklmnopqrst';
        var letters = str.split('');
        var map = {};
        for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
        var obj = Object.assign({}, map);
        var actual = '';
        for(var k in obj)actual += k;
        return str !== actual;
    };
    var $0196883fce51d67b$var$assignHasPendingExceptions = function() {
        if (!Object.assign || !Object.preventExtensions) return false;
        var thrower = Object.preventExtensions({
            1: 2
        });
        try {
            Object.assign(thrower, 'xy');
        } catch (e) {
            return thrower[1] === 'y';
        }
        return false;
    };
    module.exports = function getPolyfill() {
        if (!Object.assign) return $3WQC3;
        if ($0196883fce51d67b$var$lacksProperEnumerationOrder()) return $3WQC3;
        if ($0196883fce51d67b$var$assignHasPendingExceptions()) return $3WQC3;
        return Object.assign;
    };
});
parcelRegister("3WQC3", function(module, exports) {
    'use strict';
    var $dZMWQ = parcelRequire("dZMWQ");
    var $2dff99ad8985d37e$var$hasSymbols = (parcelRequire("9T9x9"))();
    var $53KqO = parcelRequire("53KqO");
    var $2dff99ad8985d37e$var$toObject = Object;
    var $2dff99ad8985d37e$var$$push = $53KqO('Array.prototype.push');
    var $2dff99ad8985d37e$var$$propIsEnumerable = $53KqO('Object.prototype.propertyIsEnumerable');
    var $2dff99ad8985d37e$var$originalGetSymbols = $2dff99ad8985d37e$var$hasSymbols ? Object.getOwnPropertySymbols : null;
    module.exports = function assign(target, source1) {
        if (target == null) throw new TypeError('target must be an object');
        var to = $2dff99ad8985d37e$var$toObject(target);
        if (arguments.length === 1) return to;
        for(var s = 1; s < arguments.length; ++s){
            var from = $2dff99ad8985d37e$var$toObject(arguments[s]);
            var keys = $dZMWQ(from);
            var getSymbols = $2dff99ad8985d37e$var$hasSymbols && (Object.getOwnPropertySymbols || $2dff99ad8985d37e$var$originalGetSymbols);
            if (getSymbols) {
                var syms = getSymbols(from);
                for(var j = 0; j < syms.length; ++j){
                    var key = syms[j];
                    if ($2dff99ad8985d37e$var$$propIsEnumerable(from, key)) $2dff99ad8985d37e$var$$push(keys, key);
                }
            }
            for(var i = 0; i < keys.length; ++i){
                var nextKey = keys[i];
                if ($2dff99ad8985d37e$var$$propIsEnumerable(from, nextKey)) {
                    var propValue = from[nextKey];
                    to[nextKey] = propValue;
                }
            }
        }
        return to;
    };
});
parcelRegister("dZMWQ", function(module, exports) {
    'use strict';
    var $a306f0f1bb5f232a$var$slice = Array.prototype.slice;
    var $1Houy = parcelRequire("1Houy");
    var $a306f0f1bb5f232a$var$origKeys = Object.keys;
    var $a306f0f1bb5f232a$var$keysShim = $a306f0f1bb5f232a$var$origKeys ? function keys(o) {
        return $a306f0f1bb5f232a$var$origKeys(o);
    } : (parcelRequire("eQVXL"));
    var $a306f0f1bb5f232a$var$originalKeys = Object.keys;
    $a306f0f1bb5f232a$var$keysShim.shim = function shimObjectKeys() {
        if (Object.keys) {
            var keysWorksWithArguments = function() {
                var args = Object.keys(arguments);
                return args && args.length === arguments.length;
            }(1, 2);
            if (!keysWorksWithArguments) Object.keys = function keys(object) {
                if ($1Houy(object)) return $a306f0f1bb5f232a$var$originalKeys($a306f0f1bb5f232a$var$slice.call(object));
                return $a306f0f1bb5f232a$var$originalKeys(object);
            };
        } else Object.keys = $a306f0f1bb5f232a$var$keysShim;
        return Object.keys || $a306f0f1bb5f232a$var$keysShim;
    };
    module.exports = $a306f0f1bb5f232a$var$keysShim;
});
parcelRegister("1Houy", function(module, exports) {
    'use strict';
    var $13ccce2fa6936c75$var$toStr = Object.prototype.toString;
    module.exports = function isArguments(value) {
        var str = $13ccce2fa6936c75$var$toStr.call(value);
        var isArgs = str === '[object Arguments]';
        if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $13ccce2fa6936c75$var$toStr.call(value.callee) === '[object Function]';
        return isArgs;
    };
});
parcelRegister("eQVXL", function(module, exports) {
    'use strict';
    var $ad02e23a59d3730f$var$keysShim;
    if (!Object.keys) {
        var $ad02e23a59d3730f$var$has = Object.prototype.hasOwnProperty;
        var $ad02e23a59d3730f$var$toStr = Object.prototype.toString;
        var $ad02e23a59d3730f$var$isArgs = (parcelRequire("1Houy"));
        var $ad02e23a59d3730f$var$isEnumerable = Object.prototype.propertyIsEnumerable;
        var $ad02e23a59d3730f$var$hasDontEnumBug = !$ad02e23a59d3730f$var$isEnumerable.call({
            toString: null
        }, 'toString');
        var $ad02e23a59d3730f$var$hasProtoEnumBug = $ad02e23a59d3730f$var$isEnumerable.call(function() {}, 'prototype');
        var $ad02e23a59d3730f$var$dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
        ];
        var $ad02e23a59d3730f$var$equalsConstructorPrototype = function(o) {
            var ctor = o.constructor;
            return ctor && ctor.prototype === o;
        };
        var $ad02e23a59d3730f$var$excludedKeys = {
            $applicationCache: true,
            $console: true,
            $external: true,
            $frame: true,
            $frameElement: true,
            $frames: true,
            $innerHeight: true,
            $innerWidth: true,
            $onmozfullscreenchange: true,
            $onmozfullscreenerror: true,
            $outerHeight: true,
            $outerWidth: true,
            $pageXOffset: true,
            $pageYOffset: true,
            $parent: true,
            $scrollLeft: true,
            $scrollTop: true,
            $scrollX: true,
            $scrollY: true,
            $self: true,
            $webkitIndexedDB: true,
            $webkitStorageInfo: true,
            $window: true
        };
        var $ad02e23a59d3730f$var$hasAutomationEqualityBug = function() {
            if (typeof window === 'undefined') return false;
            for(var k in window)try {
                if (!$ad02e23a59d3730f$var$excludedKeys['$' + k] && $ad02e23a59d3730f$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                    $ad02e23a59d3730f$var$equalsConstructorPrototype(window[k]);
                } catch (e) {
                    return true;
                }
            } catch (e) {
                return true;
            }
            return false;
        }();
        var $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
            if (typeof window === 'undefined' || !$ad02e23a59d3730f$var$hasAutomationEqualityBug) return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
            try {
                return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
            } catch (e) {
                return false;
            }
        };
        $ad02e23a59d3730f$var$keysShim = function keys(object) {
            var isObject = object !== null && typeof object === 'object';
            var isFunction = $ad02e23a59d3730f$var$toStr.call(object) === '[object Function]';
            var isArguments = $ad02e23a59d3730f$var$isArgs(object);
            var isString = isObject && $ad02e23a59d3730f$var$toStr.call(object) === '[object String]';
            var theKeys = [];
            if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
            var skipProto = $ad02e23a59d3730f$var$hasProtoEnumBug && isFunction;
            if (isString && object.length > 0 && !$ad02e23a59d3730f$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
            if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
            else {
                for(var name in object)if (!(skipProto && name === 'prototype') && $ad02e23a59d3730f$var$has.call(object, name)) theKeys.push(String(name));
            }
            if ($ad02e23a59d3730f$var$hasDontEnumBug) {
                var skipConstructor = $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy(object);
                for(var k = 0; k < $ad02e23a59d3730f$var$dontEnums.length; ++k)if (!(skipConstructor && $ad02e23a59d3730f$var$dontEnums[k] === 'constructor') && $ad02e23a59d3730f$var$has.call(object, $ad02e23a59d3730f$var$dontEnums[k])) theKeys.push($ad02e23a59d3730f$var$dontEnums[k]);
            }
            return theKeys;
        };
    }
    module.exports = $ad02e23a59d3730f$var$keysShim;
});
parcelRegister("eJazH", function(module, exports) {
    'use strict';
    var $iwNFM = parcelRequire("iwNFM");
    module.exports = function getPolyfill() {
        return typeof Object.is === 'function' ? Object.is : $iwNFM;
    };
});
parcelRegister("iwNFM", function(module, exports) {
    'use strict';
    var $d7d1bf25ec690182$var$numberIsNaN = function(value) {
        return value !== value;
    };
    module.exports = function is(a, b) {
        if (a === 0 && b === 0) return 1 / a === 1 / b;
        if (a === b) return true;
        if ($d7d1bf25ec690182$var$numberIsNaN(a) && $d7d1bf25ec690182$var$numberIsNaN(b)) return true;
        return false;
    };
});
parcelRegister("dztjv", function(module, exports) {
    'use strict';
    function $9e15485748de85e6$var$_slicedToArray(arr, i) {
        return $9e15485748de85e6$var$_arrayWithHoles(arr) || $9e15485748de85e6$var$_iterableToArrayLimit(arr, i) || $9e15485748de85e6$var$_unsupportedIterableToArray(arr, i) || $9e15485748de85e6$var$_nonIterableRest();
    }
    function $9e15485748de85e6$var$_nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function $9e15485748de85e6$var$_unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return $9e15485748de85e6$var$_arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9e15485748de85e6$var$_arrayLikeToArray(o, minLen);
    }
    function $9e15485748de85e6$var$_arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function $9e15485748de85e6$var$_iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function $9e15485748de85e6$var$_arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function $9e15485748de85e6$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $9e15485748de85e6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $9e15485748de85e6$var$_typeof(o);
    }
    var $9e15485748de85e6$var$regexFlagsSupported = /a/g.flags !== undefined;
    var $9e15485748de85e6$var$arrayFromSet = function arrayFromSet(set) {
        var array = [];
        set.forEach(function(value) {
            return array.push(value);
        });
        return array;
    };
    var $9e15485748de85e6$var$arrayFromMap = function arrayFromMap(map) {
        var array = [];
        map.forEach(function(value, key) {
            return array.push([
                key,
                value
            ]);
        });
        return array;
    };
    var $9e15485748de85e6$var$objectIs = Object.is ? Object.is : (parcelRequire("joK88"));
    var $9e15485748de85e6$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
        return [];
    };
    var $9e15485748de85e6$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("laO4W"));
    function $9e15485748de85e6$var$uncurryThis(f) {
        return f.call.bind(f);
    }
    var $9e15485748de85e6$var$hasOwnProperty = $9e15485748de85e6$var$uncurryThis(Object.prototype.hasOwnProperty);
    var $9e15485748de85e6$var$propertyIsEnumerable = $9e15485748de85e6$var$uncurryThis(Object.prototype.propertyIsEnumerable);
    var $9e15485748de85e6$var$objectToString = $9e15485748de85e6$var$uncurryThis(Object.prototype.toString);
    var $9kAQu = parcelRequire("9kAQu");
    var $9e15485748de85e6$require$_require$types = $9kAQu.types;
    var $9e15485748de85e6$var$isAnyArrayBuffer = $9e15485748de85e6$require$_require$types.isAnyArrayBuffer, $9e15485748de85e6$var$isArrayBufferView = $9e15485748de85e6$require$_require$types.isArrayBufferView, $9e15485748de85e6$var$isDate = $9e15485748de85e6$require$_require$types.isDate, $9e15485748de85e6$var$isMap = $9e15485748de85e6$require$_require$types.isMap, $9e15485748de85e6$var$isRegExp = $9e15485748de85e6$require$_require$types.isRegExp, $9e15485748de85e6$var$isSet = $9e15485748de85e6$require$_require$types.isSet, $9e15485748de85e6$var$isNativeError = $9e15485748de85e6$require$_require$types.isNativeError, $9e15485748de85e6$var$isBoxedPrimitive = $9e15485748de85e6$require$_require$types.isBoxedPrimitive, $9e15485748de85e6$var$isNumberObject = $9e15485748de85e6$require$_require$types.isNumberObject, $9e15485748de85e6$var$isStringObject = $9e15485748de85e6$require$_require$types.isStringObject, $9e15485748de85e6$var$isBooleanObject = $9e15485748de85e6$require$_require$types.isBooleanObject, $9e15485748de85e6$var$isBigIntObject = $9e15485748de85e6$require$_require$types.isBigIntObject, $9e15485748de85e6$var$isSymbolObject = $9e15485748de85e6$require$_require$types.isSymbolObject, $9e15485748de85e6$var$isFloat32Array = $9e15485748de85e6$require$_require$types.isFloat32Array, $9e15485748de85e6$var$isFloat64Array = $9e15485748de85e6$require$_require$types.isFloat64Array;
    function $9e15485748de85e6$var$isNonIndex(key) {
        if (key.length === 0 || key.length > 10) return true;
        for(var i = 0; i < key.length; i++){
            var code = key.charCodeAt(i);
            if (code < 48 || code > 57) return true;
        }
        return key.length === 10 && key >= Math.pow(2, 32);
    }
    function $9e15485748de85e6$var$getOwnNonIndexProperties(value) {
        return Object.keys(value).filter($9e15485748de85e6$var$isNonIndex).concat($9e15485748de85e6$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
    }
    function $9e15485748de85e6$var$compare(a, b) {
        if (a === b) return 0;
        var x = a.length;
        var y = b.length;
        for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    }
    var $9e15485748de85e6$var$ONLY_ENUMERABLE = undefined;
    var $9e15485748de85e6$var$kStrict = true;
    var $9e15485748de85e6$var$kLoose = false;
    var $9e15485748de85e6$var$kNoIterator = 0;
    var $9e15485748de85e6$var$kIsArray = 1;
    var $9e15485748de85e6$var$kIsSet = 2;
    var $9e15485748de85e6$var$kIsMap = 3;
    function $9e15485748de85e6$var$areSimilarRegExps(a, b) {
        return $9e15485748de85e6$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
    }
    function $9e15485748de85e6$var$areSimilarFloatArrays(a, b) {
        if (a.byteLength !== b.byteLength) return false;
        for(var offset = 0; offset < a.byteLength; offset++){
            if (a[offset] !== b[offset]) return false;
        }
        return true;
    }
    function $9e15485748de85e6$var$areSimilarTypedArrays(a, b) {
        if (a.byteLength !== b.byteLength) return false;
        return $9e15485748de85e6$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
    }
    function $9e15485748de85e6$var$areEqualArrayBuffers(buf1, buf2) {
        return buf1.byteLength === buf2.byteLength && $9e15485748de85e6$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
    }
    function $9e15485748de85e6$var$isEqualBoxedPrimitive(val1, val2) {
        if ($9e15485748de85e6$var$isNumberObject(val1)) return $9e15485748de85e6$var$isNumberObject(val2) && $9e15485748de85e6$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
        if ($9e15485748de85e6$var$isStringObject(val1)) return $9e15485748de85e6$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
        if ($9e15485748de85e6$var$isBooleanObject(val1)) return $9e15485748de85e6$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
        if ($9e15485748de85e6$var$isBigIntObject(val1)) return $9e15485748de85e6$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
        return $9e15485748de85e6$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
    }
    function $9e15485748de85e6$var$innerDeepEqual(val1, val2, strict, memos) {
        if (val1 === val2) {
            if (val1 !== 0) return true;
            return strict ? $9e15485748de85e6$var$objectIs(val1, val2) : true;
        }
        if (strict) {
            if ($9e15485748de85e6$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $9e15485748de85e6$var$numberIsNaN(val1) && $9e15485748de85e6$var$numberIsNaN(val2);
            if ($9e15485748de85e6$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
            if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
        } else {
            if (val1 === null || $9e15485748de85e6$var$_typeof(val1) !== 'object') {
                if (val2 === null || $9e15485748de85e6$var$_typeof(val2) !== 'object') return val1 == val2;
                return false;
            }
            if (val2 === null || $9e15485748de85e6$var$_typeof(val2) !== 'object') return false;
        }
        var val1Tag = $9e15485748de85e6$var$objectToString(val1);
        var val2Tag = $9e15485748de85e6$var$objectToString(val2);
        if (val1Tag !== val2Tag) return false;
        if (Array.isArray(val1)) {
            if (val1.length !== val2.length) return false;
            var keys1 = $9e15485748de85e6$var$getOwnNonIndexProperties(val1, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            var keys2 = $9e15485748de85e6$var$getOwnNonIndexProperties(val2, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            if (keys1.length !== keys2.length) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsArray, keys1);
        }
        if (val1Tag === '[object Object]') {
            if (!$9e15485748de85e6$var$isMap(val1) && $9e15485748de85e6$var$isMap(val2) || !$9e15485748de85e6$var$isSet(val1) && $9e15485748de85e6$var$isSet(val2)) return false;
        }
        if ($9e15485748de85e6$var$isDate(val1)) {
            if (!$9e15485748de85e6$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
        } else if ($9e15485748de85e6$var$isRegExp(val1)) {
            if (!$9e15485748de85e6$var$isRegExp(val2) || !$9e15485748de85e6$var$areSimilarRegExps(val1, val2)) return false;
        } else if ($9e15485748de85e6$var$isNativeError(val1) || val1 instanceof Error) {
            if (val1.message !== val2.message || val1.name !== val2.name) return false;
        } else if ($9e15485748de85e6$var$isArrayBufferView(val1)) {
            if (!strict && ($9e15485748de85e6$var$isFloat32Array(val1) || $9e15485748de85e6$var$isFloat64Array(val1))) {
                if (!$9e15485748de85e6$var$areSimilarFloatArrays(val1, val2)) return false;
            } else if (!$9e15485748de85e6$var$areSimilarTypedArrays(val1, val2)) return false;
            var _keys = $9e15485748de85e6$var$getOwnNonIndexProperties(val1, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            var _keys2 = $9e15485748de85e6$var$getOwnNonIndexProperties(val2, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            if (_keys.length !== _keys2.length) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kNoIterator, _keys);
        } else if ($9e15485748de85e6$var$isSet(val1)) {
            if (!$9e15485748de85e6$var$isSet(val2) || val1.size !== val2.size) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsSet);
        } else if ($9e15485748de85e6$var$isMap(val1)) {
            if (!$9e15485748de85e6$var$isMap(val2) || val1.size !== val2.size) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsMap);
        } else if ($9e15485748de85e6$var$isAnyArrayBuffer(val1)) {
            if (!$9e15485748de85e6$var$areEqualArrayBuffers(val1, val2)) return false;
        } else if ($9e15485748de85e6$var$isBoxedPrimitive(val1) && !$9e15485748de85e6$var$isEqualBoxedPrimitive(val1, val2)) return false;
        return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kNoIterator);
    }
    function $9e15485748de85e6$var$getEnumerables(val, keys) {
        return keys.filter(function(k) {
            return $9e15485748de85e6$var$propertyIsEnumerable(val, k);
        });
    }
    function $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
        if (arguments.length === 5) {
            aKeys = Object.keys(val1);
            var bKeys = Object.keys(val2);
            if (aKeys.length !== bKeys.length) return false;
        }
        var i = 0;
        for(; i < aKeys.length; i++){
            if (!$9e15485748de85e6$var$hasOwnProperty(val2, aKeys[i])) return false;
        }
        if (strict && arguments.length === 5) {
            var symbolKeysA = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val1);
            if (symbolKeysA.length !== 0) {
                var count = 0;
                for(i = 0; i < symbolKeysA.length; i++){
                    var key = symbolKeysA[i];
                    if ($9e15485748de85e6$var$propertyIsEnumerable(val1, key)) {
                        if (!$9e15485748de85e6$var$propertyIsEnumerable(val2, key)) return false;
                        aKeys.push(key);
                        count++;
                    } else if ($9e15485748de85e6$var$propertyIsEnumerable(val2, key)) return false;
                }
                var symbolKeysB = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val2);
                if (symbolKeysA.length !== symbolKeysB.length && $9e15485748de85e6$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
            } else {
                var _symbolKeysB = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val2);
                if (_symbolKeysB.length !== 0 && $9e15485748de85e6$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
            }
        }
        if (aKeys.length === 0 && (iterationType === $9e15485748de85e6$var$kNoIterator || iterationType === $9e15485748de85e6$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
        if (memos === undefined) memos = {
            val1: new Map(),
            val2: new Map(),
            position: 0
        };
        else {
            var val2MemoA = memos.val1.get(val1);
            if (val2MemoA !== undefined) {
                var val2MemoB = memos.val2.get(val2);
                if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
            }
            memos.position++;
        }
        memos.val1.set(val1, memos.position);
        memos.val2.set(val2, memos.position);
        var areEq = $9e15485748de85e6$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
        memos.val1.delete(val1);
        memos.val2.delete(val2);
        return areEq;
    }
    function $9e15485748de85e6$var$setHasEqualElement(set, val1, strict, memo) {
        var setValues = $9e15485748de85e6$var$arrayFromSet(set);
        for(var i = 0; i < setValues.length; i++){
            var val2 = setValues[i];
            if ($9e15485748de85e6$var$innerDeepEqual(val1, val2, strict, memo)) {
                set.delete(val2);
                return true;
            }
        }
        return false;
    }
    function $9e15485748de85e6$var$findLooseMatchingPrimitives(prim) {
        switch($9e15485748de85e6$var$_typeof(prim)){
            case 'undefined':
                return null;
            case 'object':
                return undefined;
            case 'symbol':
                return false;
            case 'string':
                prim = +prim;
            case 'number':
                if ($9e15485748de85e6$var$numberIsNaN(prim)) return false;
        }
        return true;
    }
    function $9e15485748de85e6$var$setMightHaveLoosePrim(a, b, prim) {
        var altValue = $9e15485748de85e6$var$findLooseMatchingPrimitives(prim);
        if (altValue != null) return altValue;
        return b.has(altValue) && !a.has(altValue);
    }
    function $9e15485748de85e6$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
        var altValue = $9e15485748de85e6$var$findLooseMatchingPrimitives(prim);
        if (altValue != null) return altValue;
        var curB = b.get(altValue);
        if (curB === undefined && !b.has(altValue) || !$9e15485748de85e6$var$innerDeepEqual(item, curB, false, memo)) return false;
        return !a.has(altValue) && $9e15485748de85e6$var$innerDeepEqual(item, curB, false, memo);
    }
    function $9e15485748de85e6$var$setEquiv(a, b, strict, memo) {
        var set = null;
        var aValues = $9e15485748de85e6$var$arrayFromSet(a);
        for(var i = 0; i < aValues.length; i++){
            var val = aValues[i];
            if ($9e15485748de85e6$var$_typeof(val) === 'object' && val !== null) {
                if (set === null) set = new Set();
                set.add(val);
            } else if (!b.has(val)) {
                if (strict) return false;
                if (!$9e15485748de85e6$var$setMightHaveLoosePrim(a, b, val)) return false;
                if (set === null) set = new Set();
                set.add(val);
            }
        }
        if (set !== null) {
            var bValues = $9e15485748de85e6$var$arrayFromSet(b);
            for(var _i = 0; _i < bValues.length; _i++){
                var _val = bValues[_i];
                if ($9e15485748de85e6$var$_typeof(_val) === 'object' && _val !== null) {
                    if (!$9e15485748de85e6$var$setHasEqualElement(set, _val, strict, memo)) return false;
                } else if (!strict && !a.has(_val) && !$9e15485748de85e6$var$setHasEqualElement(set, _val, strict, memo)) return false;
            }
            return set.size === 0;
        }
        return true;
    }
    function $9e15485748de85e6$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
        var setValues = $9e15485748de85e6$var$arrayFromSet(set);
        for(var i = 0; i < setValues.length; i++){
            var key2 = setValues[i];
            if ($9e15485748de85e6$var$innerDeepEqual(key1, key2, strict, memo) && $9e15485748de85e6$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
                set.delete(key2);
                return true;
            }
        }
        return false;
    }
    function $9e15485748de85e6$var$mapEquiv(a, b, strict, memo) {
        var set = null;
        var aEntries = $9e15485748de85e6$var$arrayFromMap(a);
        for(var i = 0; i < aEntries.length; i++){
            var _aEntries$i = $9e15485748de85e6$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
            if ($9e15485748de85e6$var$_typeof(key) === 'object' && key !== null) {
                if (set === null) set = new Set();
                set.add(key);
            } else {
                var item2 = b.get(key);
                if (item2 === undefined && !b.has(key) || !$9e15485748de85e6$var$innerDeepEqual(item1, item2, strict, memo)) {
                    if (strict) return false;
                    if (!$9e15485748de85e6$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                    if (set === null) set = new Set();
                    set.add(key);
                }
            }
        }
        if (set !== null) {
            var bEntries = $9e15485748de85e6$var$arrayFromMap(b);
            for(var _i2 = 0; _i2 < bEntries.length; _i2++){
                var _bEntries$_i = $9e15485748de85e6$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
                if ($9e15485748de85e6$var$_typeof(_key) === 'object' && _key !== null) {
                    if (!$9e15485748de85e6$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
                } else if (!strict && (!a.has(_key) || !$9e15485748de85e6$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$9e15485748de85e6$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
            }
            return set.size === 0;
        }
        return true;
    }
    function $9e15485748de85e6$var$objEquiv(a, b, strict, keys, memos, iterationType) {
        var i = 0;
        if (iterationType === $9e15485748de85e6$var$kIsSet) {
            if (!$9e15485748de85e6$var$setEquiv(a, b, strict, memos)) return false;
        } else if (iterationType === $9e15485748de85e6$var$kIsMap) {
            if (!$9e15485748de85e6$var$mapEquiv(a, b, strict, memos)) return false;
        } else if (iterationType === $9e15485748de85e6$var$kIsArray) for(; i < a.length; i++){
            if ($9e15485748de85e6$var$hasOwnProperty(a, i)) {
                if (!$9e15485748de85e6$var$hasOwnProperty(b, i) || !$9e15485748de85e6$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
            } else if ($9e15485748de85e6$var$hasOwnProperty(b, i)) return false;
            else {
                var keysA = Object.keys(a);
                for(; i < keysA.length; i++){
                    var key = keysA[i];
                    if (!$9e15485748de85e6$var$hasOwnProperty(b, key) || !$9e15485748de85e6$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
                }
                if (keysA.length !== Object.keys(b).length) return false;
                return true;
            }
        }
        for(i = 0; i < keys.length; i++){
            var _key2 = keys[i];
            if (!$9e15485748de85e6$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
        }
        return true;
    }
    function $9e15485748de85e6$var$isDeepEqual(val1, val2) {
        return $9e15485748de85e6$var$innerDeepEqual(val1, val2, $9e15485748de85e6$var$kLoose);
    }
    function $9e15485748de85e6$var$isDeepStrictEqual(val1, val2) {
        return $9e15485748de85e6$var$innerDeepEqual(val1, val2, $9e15485748de85e6$var$kStrict);
    }
    module.exports = {
        isDeepEqual: $9e15485748de85e6$var$isDeepEqual,
        isDeepStrictEqual: $9e15485748de85e6$var$isDeepStrictEqual
    };
});
parcelRegister("joK88", function(module, exports) {
    'use strict';
    var $d94D2 = parcelRequire("d94D2");
    var $h05ZS = parcelRequire("h05ZS");
    var $iwNFM = parcelRequire("iwNFM");
    var $eJazH = parcelRequire("eJazH");
    var $90RaO = parcelRequire("90RaO");
    var $e1f40ab7009ea590$var$polyfill = $h05ZS($eJazH(), Object);
    $d94D2($e1f40ab7009ea590$var$polyfill, {
        getPolyfill: $eJazH,
        implementation: $iwNFM,
        shim: $90RaO
    });
    module.exports = $e1f40ab7009ea590$var$polyfill;
});
parcelRegister("d94D2", function(module, exports) {
    'use strict';
    var $dZMWQ = parcelRequire("dZMWQ");
    var $991fb4ca00f3da54$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
    var $991fb4ca00f3da54$var$toStr = Object.prototype.toString;
    var $991fb4ca00f3da54$var$concat = Array.prototype.concat;
    var $le88V;
    var $991fb4ca00f3da54$var$isFunction = function(fn) {
        return typeof fn === 'function' && $991fb4ca00f3da54$var$toStr.call(fn) === '[object Function]';
    };
    var $991fb4ca00f3da54$var$supportsDescriptors = (parcelRequire("9lmlE"))();
    var $991fb4ca00f3da54$var$defineProperty = function(object, name, value, predicate) {
        if (name in object) {
            if (predicate === true) {
                if (object[name] === value) return;
            } else if (!$991fb4ca00f3da54$var$isFunction(predicate) || !predicate()) return;
        }
        if ($991fb4ca00f3da54$var$supportsDescriptors) (0, parcelRequire("le88V"))(object, name, value, true);
        else (0, parcelRequire("le88V"))(object, name, value);
    };
    var $991fb4ca00f3da54$var$defineProperties = function(object, map) {
        var predicates = arguments.length > 2 ? arguments[2] : {};
        var props = $dZMWQ(map);
        if ($991fb4ca00f3da54$var$hasSymbols) props = $991fb4ca00f3da54$var$concat.call(props, Object.getOwnPropertySymbols(map));
        for(var i = 0; i < props.length; i += 1)$991fb4ca00f3da54$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
    };
    $991fb4ca00f3da54$var$defineProperties.supportsDescriptors = !!$991fb4ca00f3da54$var$supportsDescriptors;
    module.exports = $991fb4ca00f3da54$var$defineProperties;
});
parcelRegister("90RaO", function(module, exports) {
    'use strict';
    var $eJazH = parcelRequire("eJazH");
    var $d94D2 = parcelRequire("d94D2");
    module.exports = function shimObjectIs() {
        var polyfill = $eJazH();
        $d94D2(Object, {
            is: polyfill
        }, {
            is: function testObjectIs() {
                return Object.is !== polyfill;
            }
        });
        return polyfill;
    };
});
parcelRegister("laO4W", function(module, exports) {
    'use strict';
    var $h05ZS = parcelRequire("h05ZS");
    var $d94D2 = parcelRequire("d94D2");
    var $hdPWo = parcelRequire("hdPWo");
    var $gmOnv = parcelRequire("gmOnv");
    var $hXuHX = parcelRequire("hXuHX");
    var $f6a160b687432d3b$var$polyfill = $h05ZS($gmOnv(), Number);
    $d94D2($f6a160b687432d3b$var$polyfill, {
        getPolyfill: $gmOnv,
        implementation: $hdPWo,
        shim: $hXuHX
    });
    module.exports = $f6a160b687432d3b$var$polyfill;
});
parcelRegister("hdPWo", function(module, exports) {
    'use strict';
    module.exports = function isNaN(value) {
        return value !== value;
    };
});
parcelRegister("gmOnv", function(module, exports) {
    'use strict';
    var $hdPWo = parcelRequire("hdPWo");
    module.exports = function getPolyfill() {
        if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
        return $hdPWo;
    };
});
parcelRegister("hXuHX", function(module, exports) {
    'use strict';
    var $d94D2 = parcelRequire("d94D2");
    var $gmOnv = parcelRequire("gmOnv");
    module.exports = function shimNumberIsNaN() {
        var polyfill = $gmOnv();
        $d94D2(Number, {
            isNaN: polyfill
        }, {
            isNaN: function testIsNaN() {
                return Number.isNaN !== polyfill;
            }
        });
        return polyfill;
    };
});
parcelRegister("d6D31", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
    function $98aa1ff32ce30be5$var$NotNull(target, propertyKey, propertyDescriptor) {}
    module.exports.NotNull = $98aa1ff32ce30be5$var$NotNull;
    function $98aa1ff32ce30be5$var$Nullable(target, propertyKey, propertyDescriptor) {}
    module.exports.Nullable = $98aa1ff32ce30be5$var$Nullable;
    function $98aa1ff32ce30be5$var$Override(target, propertyKey, propertyDescriptor) {}
    module.exports.Override = $98aa1ff32ce30be5$var$Override;
    function $98aa1ff32ce30be5$var$SuppressWarnings(options) {
        return (target, propertyKey, descriptor)=>{};
    }
    module.exports.SuppressWarnings = $98aa1ff32ce30be5$var$SuppressWarnings;
});
parcelRegister("ceaEj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntStream = void 0;
    var $8e6f0d8930cd60b2$var$IntStream;
    (function(IntStream) {
        IntStream.EOF = -1;
        IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
    })($8e6f0d8930cd60b2$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));
});
parcelRegister("b0kN8", function(module, exports) {
    "use strict";
    var $802fd28fa76a2f4f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BailErrorStrategy = void 0;
    var $4CCJj = parcelRequire("4CCJj");
    var $iLUMi = parcelRequire("iLUMi");
    var $d6D31 = parcelRequire("d6D31");
    var $3kXUy = parcelRequire("3kXUy");
    class $802fd28fa76a2f4f$var$BailErrorStrategy extends $4CCJj.DefaultErrorStrategy {
        recover(recognizer, e) {
            for(let context = recognizer.context; context; context = context.parent)context.exception = e;
            throw new $3kXUy.ParseCancellationException(e);
        }
        recoverInline(recognizer) {
            let e = new $iLUMi.InputMismatchException(recognizer);
            for(let context = recognizer.context; context; context = context.parent)context.exception = e;
            throw new $3kXUy.ParseCancellationException(e);
        }
        sync(recognizer) {}
    }
    $802fd28fa76a2f4f$var$__decorate([
        $d6D31.Override
    ], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "recover", null);
    $802fd28fa76a2f4f$var$__decorate([
        $d6D31.Override
    ], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "recoverInline", null);
    $802fd28fa76a2f4f$var$__decorate([
        $d6D31.Override
    ], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "sync", null);
    module.exports.BailErrorStrategy = $802fd28fa76a2f4f$var$BailErrorStrategy;
});
parcelRegister("4CCJj", function(module, exports) {
    "use strict";
    var $35d8c0fbab48edc4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $35d8c0fbab48edc4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DefaultErrorStrategy = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $ea0YW = parcelRequire("ea0YW");
    var $iLUMi = parcelRequire("iLUMi");
    var $hGRod = parcelRequire("hGRod");
    var $hKCjP = parcelRequire("hKCjP");
    var $8DTT0 = parcelRequire("8DTT0");
    var $2DVsz = parcelRequire("2DVsz");
    var $d6D31 = parcelRequire("d6D31");
    class $35d8c0fbab48edc4$var$DefaultErrorStrategy {
        constructor(){
            this.errorRecoveryMode = false;
            this.lastErrorIndex = -1;
            this.nextTokensState = $7j0Pc.ATNState.INVALID_STATE_NUMBER;
        }
        reset(recognizer) {
            this.endErrorCondition(recognizer);
        }
        beginErrorCondition(recognizer) {
            this.errorRecoveryMode = true;
        }
        inErrorRecoveryMode(recognizer) {
            return this.errorRecoveryMode;
        }
        endErrorCondition(recognizer) {
            this.errorRecoveryMode = false;
            this.lastErrorStates = undefined;
            this.lastErrorIndex = -1;
        }
        reportMatch(recognizer) {
            this.endErrorCondition(recognizer);
        }
        reportError(recognizer, e) {
            if (this.inErrorRecoveryMode(recognizer)) return;
            this.beginErrorCondition(recognizer);
            if (e instanceof $hKCjP.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
            else if (e instanceof $iLUMi.InputMismatchException) this.reportInputMismatch(recognizer, e);
            else if (e instanceof $ea0YW.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
            else {
                console.error(`unknown recognition error type: ${e}`);
                this.notifyErrorListeners(recognizer, e.toString(), e);
            }
        }
        notifyErrorListeners(recognizer, message, e) {
            let offendingToken = e.getOffendingToken(recognizer);
            if (offendingToken === undefined) offendingToken = null;
            recognizer.notifyErrorListeners(message, offendingToken, e);
        }
        recover(recognizer, e) {
            if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) recognizer.consume();
            this.lastErrorIndex = recognizer.inputStream.index;
            if (!this.lastErrorStates) this.lastErrorStates = new $hGRod.IntervalSet();
            this.lastErrorStates.add(recognizer.state);
            let followSet = this.getErrorRecoverySet(recognizer);
            this.consumeUntil(recognizer, followSet);
        }
        sync(recognizer) {
            let s = recognizer.interpreter.atn.states[recognizer.state];
            if (this.inErrorRecoveryMode(recognizer)) return;
            let tokens = recognizer.inputStream;
            let la = tokens.LA(1);
            let nextTokens = recognizer.atn.nextTokens(s);
            if (nextTokens.contains(la)) {
                this.nextTokensContext = undefined;
                this.nextTokensState = $7j0Pc.ATNState.INVALID_STATE_NUMBER;
                return;
            }
            if (nextTokens.contains($2DVsz.Token.EPSILON)) {
                if (this.nextTokensContext === undefined) {
                    this.nextTokensContext = recognizer.context;
                    this.nextTokensState = recognizer.state;
                }
                return;
            }
            switch(s.stateType){
                case $1bs3X.ATNStateType.BLOCK_START:
                case $1bs3X.ATNStateType.STAR_BLOCK_START:
                case $1bs3X.ATNStateType.PLUS_BLOCK_START:
                case $1bs3X.ATNStateType.STAR_LOOP_ENTRY:
                    if (this.singleTokenDeletion(recognizer)) return;
                    throw new $iLUMi.InputMismatchException(recognizer);
                case $1bs3X.ATNStateType.PLUS_LOOP_BACK:
                case $1bs3X.ATNStateType.STAR_LOOP_BACK:
                    this.reportUnwantedToken(recognizer);
                    let expecting = recognizer.getExpectedTokens();
                    let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                    this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                    break;
                default:
                    break;
            }
        }
        reportNoViableAlternative(recognizer, e) {
            let tokens = recognizer.inputStream;
            let input;
            if (tokens) {
                if (e.startToken.type === $2DVsz.Token.EOF) input = "<EOF>";
                else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
            } else input = "<unknown input>";
            let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
            this.notifyErrorListeners(recognizer, msg, e);
        }
        reportInputMismatch(recognizer, e) {
            let expected = e.expectedTokens;
            let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
            let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
            this.notifyErrorListeners(recognizer, msg, e);
        }
        reportFailedPredicate(recognizer, e) {
            let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
            let msg = "rule " + ruleName + " " + e.message;
            this.notifyErrorListeners(recognizer, msg, e);
        }
        reportUnwantedToken(recognizer) {
            if (this.inErrorRecoveryMode(recognizer)) return;
            this.beginErrorCondition(recognizer);
            let t = recognizer.currentToken;
            let tokenName = this.getTokenErrorDisplay(t);
            let expecting = this.getExpectedTokens(recognizer);
            let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
            recognizer.notifyErrorListeners(msg, t, undefined);
        }
        reportMissingToken(recognizer) {
            if (this.inErrorRecoveryMode(recognizer)) return;
            this.beginErrorCondition(recognizer);
            let t = recognizer.currentToken;
            let expecting = this.getExpectedTokens(recognizer);
            let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
            recognizer.notifyErrorListeners(msg, t, undefined);
        }
        recoverInline(recognizer) {
            let matchedSymbol = this.singleTokenDeletion(recognizer);
            if (matchedSymbol) {
                recognizer.consume();
                return matchedSymbol;
            }
            if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
            if (this.nextTokensContext === undefined) throw new $iLUMi.InputMismatchException(recognizer);
            else throw new $iLUMi.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
        }
        singleTokenInsertion(recognizer) {
            let currentSymbolType = recognizer.inputStream.LA(1);
            let currentState = recognizer.interpreter.atn.states[recognizer.state];
            let next = currentState.transition(0).target;
            let atn = recognizer.interpreter.atn;
            let expectingAtLL2 = atn.nextTokens(next, $8DTT0.PredictionContext.fromRuleContext(atn, recognizer.context));
            if (expectingAtLL2.contains(currentSymbolType)) {
                this.reportMissingToken(recognizer);
                return true;
            }
            return false;
        }
        singleTokenDeletion(recognizer) {
            let nextTokenType = recognizer.inputStream.LA(2);
            let expecting = this.getExpectedTokens(recognizer);
            if (expecting.contains(nextTokenType)) {
                this.reportUnwantedToken(recognizer);
                recognizer.consume();
                let matchedSymbol = recognizer.currentToken;
                this.reportMatch(recognizer);
                return matchedSymbol;
            }
            return undefined;
        }
        getMissingSymbol(recognizer) {
            let currentSymbol = recognizer.currentToken;
            let expecting = this.getExpectedTokens(recognizer);
            let expectedTokenType = $2DVsz.Token.INVALID_TYPE;
            if (!expecting.isNil) expectedTokenType = expecting.minElement;
            let tokenText;
            if (expectedTokenType === $2DVsz.Token.EOF) tokenText = "<missing EOF>";
            else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
            let current = currentSymbol;
            let lookback = recognizer.inputStream.tryLT(-1);
            if (current.type === $2DVsz.Token.EOF && lookback != null) current = lookback;
            return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
        }
        constructToken(tokenSource, expectedTokenType, tokenText, current) {
            let factory = tokenSource.tokenFactory;
            let x = current.tokenSource;
            let stream = x ? x.inputStream : undefined;
            return factory.create({
                source: tokenSource,
                stream: stream
            }, expectedTokenType, tokenText, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
        }
        getExpectedTokens(recognizer) {
            return recognizer.getExpectedTokens();
        }
        getTokenErrorDisplay(t) {
            if (!t) return "<no token>";
            let s = this.getSymbolText(t);
            if (!s) {
                if (this.getSymbolType(t) === $2DVsz.Token.EOF) s = "<EOF>";
                else s = `<${this.getSymbolType(t)}>`;
            }
            return this.escapeWSAndQuote(s);
        }
        getSymbolText(symbol) {
            return symbol.text;
        }
        getSymbolType(symbol) {
            return symbol.type;
        }
        escapeWSAndQuote(s) {
            s = s.replace("\n", "\\n");
            s = s.replace("\r", "\\r");
            s = s.replace("\t", "\\t");
            return "'" + s + "'";
        }
        getErrorRecoverySet(recognizer) {
            let atn = recognizer.interpreter.atn;
            let ctx = recognizer.context;
            let recoverSet = new $hGRod.IntervalSet();
            while(ctx && ctx.invokingState >= 0){
                let invokingState = atn.states[ctx.invokingState];
                let rt = invokingState.transition(0);
                let follow = atn.nextTokens(rt.followState);
                recoverSet.addAll(follow);
                ctx = ctx._parent;
            }
            recoverSet.remove($2DVsz.Token.EPSILON);
            return recoverSet;
        }
        consumeUntil(recognizer, set) {
            let ttype = recognizer.inputStream.LA(1);
            while(ttype !== $2DVsz.Token.EOF && !set.contains(ttype)){
                recognizer.consume();
                ttype = recognizer.inputStream.LA(1);
            }
        }
    }
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reset", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportMatch", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportError", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "recover", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "sync", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "recoverInline", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
    module.exports.DefaultErrorStrategy = $35d8c0fbab48edc4$var$DefaultErrorStrategy;
});
parcelRegister("7j0Pc", function(module, exports) {
    "use strict";
    var $551af28bc8fe1b8c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNState = void 0;
    var $d6D31 = parcelRequire("d6D31");
    const $551af28bc8fe1b8c$var$INITIAL_NUM_TRANSITIONS = 4;
    class $551af28bc8fe1b8c$var$ATNState {
        constructor(){
            this.stateNumber = $551af28bc8fe1b8c$var$ATNState.INVALID_STATE_NUMBER;
            this.ruleIndex = 0;
            this.epsilonOnlyTransitions = false;
            this.transitions = [];
            this.optimizedTransitions = this.transitions;
        }
        getStateNumber() {
            return this.stateNumber;
        }
        get nonStopStateNumber() {
            return this.getStateNumber();
        }
        hashCode() {
            return this.stateNumber;
        }
        equals(o) {
            if (o instanceof $551af28bc8fe1b8c$var$ATNState) return this.stateNumber === o.stateNumber;
            return false;
        }
        get isNonGreedyExitState() {
            return false;
        }
        toString() {
            return String(this.stateNumber);
        }
        getTransitions() {
            return this.transitions.slice(0);
        }
        get numberOfTransitions() {
            return this.transitions.length;
        }
        addTransition(e, index) {
            if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
            else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
                this.epsilonOnlyTransitions = false;
                throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
            }
            this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
        }
        transition(i) {
            return this.transitions[i];
        }
        setTransition(i, e) {
            this.transitions[i] = e;
        }
        removeTransition(index) {
            return this.transitions.splice(index, 1)[0];
        }
        get onlyHasEpsilonTransitions() {
            return this.epsilonOnlyTransitions;
        }
        setRuleIndex(ruleIndex) {
            this.ruleIndex = ruleIndex;
        }
        get isOptimized() {
            return this.optimizedTransitions !== this.transitions;
        }
        get numberOfOptimizedTransitions() {
            return this.optimizedTransitions.length;
        }
        getOptimizedTransition(i) {
            return this.optimizedTransitions[i];
        }
        addOptimizedTransition(e) {
            if (!this.isOptimized) this.optimizedTransitions = new Array();
            this.optimizedTransitions.push(e);
        }
        setOptimizedTransition(i, e) {
            if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
            this.optimizedTransitions[i] = e;
        }
        removeOptimizedTransition(i) {
            if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
            this.optimizedTransitions.splice(i, 1);
        }
    }
    $551af28bc8fe1b8c$var$__decorate([
        $d6D31.Override
    ], $551af28bc8fe1b8c$var$ATNState.prototype, "hashCode", null);
    $551af28bc8fe1b8c$var$__decorate([
        $d6D31.Override
    ], $551af28bc8fe1b8c$var$ATNState.prototype, "equals", null);
    $551af28bc8fe1b8c$var$__decorate([
        $d6D31.Override
    ], $551af28bc8fe1b8c$var$ATNState.prototype, "toString", null);
    module.exports.ATNState = $551af28bc8fe1b8c$var$ATNState;
    (function(ATNState) {
        ATNState.INVALID_STATE_NUMBER = -1;
    })($551af28bc8fe1b8c$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));
});
parcelRegister("1bs3X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNStateType = void 0;
    var $0dcc96396a04e502$var$ATNStateType;
    (function(ATNStateType) {
        ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
        ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
        ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
        ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
        ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
        ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
        ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
        ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
        ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
        ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
        ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
        ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
        ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
    })($0dcc96396a04e502$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));
});
parcelRegister("ea0YW", function(module, exports) {
    "use strict";
    var $a4f2c2ded442ae18$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $a4f2c2ded442ae18$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.FailedPredicateException = void 0;
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    var $hnaRv = parcelRequire("hnaRv");
    let $a4f2c2ded442ae18$var$FailedPredicateException = class FailedPredicateException extends $fLdDn.RecognitionException {
        constructor(recognizer, predicate, message){
            super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
            let s = recognizer.interpreter.atn.states[recognizer.state];
            let trans = s.transition(0);
            if (trans instanceof $hnaRv.PredicateTransition) {
                this._ruleIndex = trans.ruleIndex;
                this._predicateIndex = trans.predIndex;
            } else {
                this._ruleIndex = 0;
                this._predicateIndex = 0;
            }
            this._predicate = predicate;
            super.setOffendingToken(recognizer, recognizer.currentToken);
        }
        get ruleIndex() {
            return this._ruleIndex;
        }
        get predicateIndex() {
            return this._predicateIndex;
        }
        get predicate() {
            return this._predicate;
        }
        static formatMessage(predicate, message) {
            if (message) return message;
            return `failed predicate: {${predicate}}?`;
        }
    };
    $a4f2c2ded442ae18$var$__decorate([
        $d6D31.NotNull
    ], $a4f2c2ded442ae18$var$FailedPredicateException, "formatMessage", null);
    $a4f2c2ded442ae18$var$FailedPredicateException = $a4f2c2ded442ae18$var$__decorate([
        $a4f2c2ded442ae18$var$__param(0, $d6D31.NotNull)
    ], $a4f2c2ded442ae18$var$FailedPredicateException);
    module.exports.FailedPredicateException = $a4f2c2ded442ae18$var$FailedPredicateException;
});
parcelRegister("fLdDn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RecognitionException = void 0;
    class $b795d243382c1d9c$var$RecognitionException extends Error {
        constructor(recognizer, input, ctx, message){
            super(message);
            this._offendingState = -1;
            this._recognizer = recognizer;
            this.input = input;
            this.ctx = ctx;
            if (recognizer) this._offendingState = recognizer.state;
        }
        get offendingState() {
            return this._offendingState;
        }
        setOffendingState(offendingState) {
            this._offendingState = offendingState;
        }
        get expectedTokens() {
            if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
            return undefined;
        }
        get context() {
            return this.ctx;
        }
        get inputStream() {
            return this.input;
        }
        getOffendingToken(recognizer) {
            if (recognizer && recognizer !== this._recognizer) return undefined;
            return this.offendingToken;
        }
        setOffendingToken(recognizer, offendingToken) {
            if (recognizer === this._recognizer) this.offendingToken = offendingToken;
        }
        get recognizer() {
            return this._recognizer;
        }
    }
    module.exports.RecognitionException = $b795d243382c1d9c$var$RecognitionException;
});
parcelRegister("hnaRv", function(module, exports) {
    "use strict";
    var $ca5d02a3d9cef56c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ca5d02a3d9cef56c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PredicateTransition = void 0;
    var $fMVaR = parcelRequire("fMVaR");
    var $d6D31 = parcelRequire("d6D31");
    var $eHMgW = parcelRequire("eHMgW");
    let $ca5d02a3d9cef56c$var$PredicateTransition = class PredicateTransition extends $fMVaR.AbstractPredicateTransition {
        constructor(target, ruleIndex, predIndex, isCtxDependent){
            super(target);
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
        get serializationType() {
            return 4;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        get predicate() {
            return new $eHMgW.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
        }
        toString() {
            return "pred_" + this.ruleIndex + ":" + this.predIndex;
        }
    };
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "serializationType", null);
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "isEpsilon", null);
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "matches", null);
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "toString", null);
    $ca5d02a3d9cef56c$var$PredicateTransition = $ca5d02a3d9cef56c$var$__decorate([
        $ca5d02a3d9cef56c$var$__param(0, $d6D31.NotNull)
    ], $ca5d02a3d9cef56c$var$PredicateTransition);
    module.exports.PredicateTransition = $ca5d02a3d9cef56c$var$PredicateTransition;
});
parcelRegister("fMVaR", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.AbstractPredicateTransition = void 0;
    var $5tcOQ = parcelRequire("5tcOQ");
    class $b7e7b04ea6d15f5c$var$AbstractPredicateTransition extends $5tcOQ.Transition {
        constructor(target){
            super(target);
        }
    }
    module.exports.AbstractPredicateTransition = $b7e7b04ea6d15f5c$var$AbstractPredicateTransition;
});
parcelRegister("5tcOQ", function(module, exports) {
    "use strict";
    var $3fb99acb0a3a1848$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $3fb99acb0a3a1848$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Transition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    let $3fb99acb0a3a1848$var$Transition = class Transition {
        constructor(target){
            if (target == null) throw new Error("target cannot be null.");
            this.target = target;
        }
        get isEpsilon() {
            return false;
        }
        get label() {
            return undefined;
        }
    };
    $3fb99acb0a3a1848$var$Transition.serializationNames = [
        "INVALID",
        "EPSILON",
        "RANGE",
        "RULE",
        "PREDICATE",
        "ATOM",
        "ACTION",
        "SET",
        "NOT_SET",
        "WILDCARD",
        "PRECEDENCE"
    ];
    $3fb99acb0a3a1848$var$__decorate([
        $d6D31.NotNull
    ], $3fb99acb0a3a1848$var$Transition.prototype, "target", void 0);
    $3fb99acb0a3a1848$var$Transition = $3fb99acb0a3a1848$var$__decorate([
        $3fb99acb0a3a1848$var$__param(0, $d6D31.NotNull)
    ], $3fb99acb0a3a1848$var$Transition);
    module.exports.Transition = $3fb99acb0a3a1848$var$Transition;
});
parcelRegister("eHMgW", function(module, exports) {
    "use strict";
    var $ab4a86b5def51fe2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ab4a86b5def51fe2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SemanticContext = void 0;
    var $7Veax = parcelRequire("7Veax");
    var $3sNxf = parcelRequire("3sNxf");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $2IEP9 = parcelRequire("2IEP9");
    function $ab4a86b5def51fe2$var$max(items) {
        let result;
        for (let current of items){
            if (result === undefined) {
                result = current;
                continue;
            }
            let comparison = result.compareTo(current);
            if (comparison < 0) result = current;
        }
        return result;
    }
    function $ab4a86b5def51fe2$var$min(items) {
        let result;
        for (let current of items){
            if (result === undefined) {
                result = current;
                continue;
            }
            let comparison = result.compareTo(current);
            if (comparison > 0) result = current;
        }
        return result;
    }
    class $ab4a86b5def51fe2$var$SemanticContext {
        static get NONE() {
            if ($ab4a86b5def51fe2$var$SemanticContext._NONE === undefined) $ab4a86b5def51fe2$var$SemanticContext._NONE = new $ab4a86b5def51fe2$var$SemanticContext.Predicate();
            return $ab4a86b5def51fe2$var$SemanticContext._NONE;
        }
        evalPrecedence(parser, parserCallStack) {
            return this;
        }
        static and(a, b) {
            if (!a || a === $ab4a86b5def51fe2$var$SemanticContext.NONE) return b;
            if (b === $ab4a86b5def51fe2$var$SemanticContext.NONE) return a;
            let result = new $ab4a86b5def51fe2$var$SemanticContext.AND(a, b);
            if (result.opnds.length === 1) return result.opnds[0];
            return result;
        }
        static or(a, b) {
            if (!a) return b;
            if (a === $ab4a86b5def51fe2$var$SemanticContext.NONE || b === $ab4a86b5def51fe2$var$SemanticContext.NONE) return $ab4a86b5def51fe2$var$SemanticContext.NONE;
            let result = new $ab4a86b5def51fe2$var$SemanticContext.OR(a, b);
            if (result.opnds.length === 1) return result.opnds[0];
            return result;
        }
    }
    module.exports.SemanticContext = $ab4a86b5def51fe2$var$SemanticContext;
    (function(SemanticContext) {
        const AND_HASHCODE = 40363613;
        const OR_HASHCODE = 486279973;
        function filterPrecedencePredicates(collection) {
            let result = [];
            for(let i = 0; i < collection.length; i++){
                let context = collection[i];
                if (context instanceof SemanticContext.PrecedencePredicate) {
                    result.push(context);
                    collection.splice(i, 1);
                    i--;
                }
            }
            return result;
        }
        class Predicate extends SemanticContext {
            constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
                super();
                this.ruleIndex = ruleIndex;
                this.predIndex = predIndex;
                this.isCtxDependent = isCtxDependent;
            }
            eval(parser, parserCallStack) {
                let localctx = this.isCtxDependent ? parserCallStack : undefined;
                return parser.sempred(localctx, this.ruleIndex, this.predIndex);
            }
            hashCode() {
                let hashCode = $iXFjm.MurmurHash.initialize();
                hashCode = $iXFjm.MurmurHash.update(hashCode, this.ruleIndex);
                hashCode = $iXFjm.MurmurHash.update(hashCode, this.predIndex);
                hashCode = $iXFjm.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
                hashCode = $iXFjm.MurmurHash.finish(hashCode, 3);
                return hashCode;
            }
            equals(obj) {
                if (!(obj instanceof Predicate)) return false;
                if (this === obj) return true;
                return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
            }
            toString() {
                return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
            }
        }
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "toString", null);
        SemanticContext.Predicate = Predicate;
        class PrecedencePredicate extends SemanticContext {
            constructor(precedence){
                super();
                this.precedence = precedence;
            }
            eval(parser, parserCallStack) {
                return parser.precpred(parserCallStack, this.precedence);
            }
            evalPrecedence(parser, parserCallStack) {
                if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
                else return undefined;
            }
            compareTo(o) {
                return this.precedence - o.precedence;
            }
            hashCode() {
                let hashCode = 1;
                hashCode = 31 * hashCode + this.precedence;
                return hashCode;
            }
            equals(obj) {
                if (!(obj instanceof PrecedencePredicate)) return false;
                if (this === obj) return true;
                return this.precedence === obj.precedence;
            }
            toString() {
                return "{" + this.precedence + ">=prec}?";
            }
        }
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "evalPrecedence", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "compareTo", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "toString", null);
        SemanticContext.PrecedencePredicate = PrecedencePredicate;
        class Operator extends SemanticContext {
        }
        SemanticContext.Operator = Operator;
        let AND = class AND extends Operator {
            constructor(a, b){
                super();
                let operands = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
                if (a instanceof AND) operands.addAll(a.opnds);
                else operands.add(a);
                if (b instanceof AND) operands.addAll(b.opnds);
                else operands.add(b);
                this.opnds = operands.toArray();
                let precedencePredicates = filterPrecedencePredicates(this.opnds);
                let reduced = $ab4a86b5def51fe2$var$min(precedencePredicates);
                if (reduced) this.opnds.push(reduced);
            }
            get operands() {
                return this.opnds;
            }
            equals(obj) {
                if (this === obj) return true;
                if (!(obj instanceof AND)) return false;
                return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
            }
            hashCode() {
                return $iXFjm.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
            }
            eval(parser, parserCallStack) {
                for (let opnd of this.opnds){
                    if (!opnd.eval(parser, parserCallStack)) return false;
                }
                return true;
            }
            evalPrecedence(parser, parserCallStack) {
                let differs = false;
                let operands = [];
                for (let context of this.opnds){
                    let evaluated = context.evalPrecedence(parser, parserCallStack);
                    differs = differs || evaluated !== context;
                    if (evaluated == null) return undefined;
                    else if (evaluated !== SemanticContext.NONE) operands.push(evaluated);
                }
                if (!differs) return this;
                if (operands.length === 0) return SemanticContext.NONE;
                let result = operands[0];
                for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
                return result;
            }
            toString() {
                return $2IEP9.join(this.opnds, "&&");
            }
        };
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "operands", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "evalPrecedence", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "toString", null);
        AND = $ab4a86b5def51fe2$var$__decorate([
            $ab4a86b5def51fe2$var$__param(0, $d6D31.NotNull),
            $ab4a86b5def51fe2$var$__param(1, $d6D31.NotNull)
        ], AND);
        SemanticContext.AND = AND;
        let OR = class OR extends Operator {
            constructor(a, b){
                super();
                let operands = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
                if (a instanceof OR) operands.addAll(a.opnds);
                else operands.add(a);
                if (b instanceof OR) operands.addAll(b.opnds);
                else operands.add(b);
                this.opnds = operands.toArray();
                let precedencePredicates = filterPrecedencePredicates(this.opnds);
                let reduced = $ab4a86b5def51fe2$var$max(precedencePredicates);
                if (reduced) this.opnds.push(reduced);
            }
            get operands() {
                return this.opnds;
            }
            equals(obj) {
                if (this === obj) return true;
                if (!(obj instanceof OR)) return false;
                return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
            }
            hashCode() {
                return $iXFjm.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
            }
            eval(parser, parserCallStack) {
                for (let opnd of this.opnds){
                    if (opnd.eval(parser, parserCallStack)) return true;
                }
                return false;
            }
            evalPrecedence(parser, parserCallStack) {
                let differs = false;
                let operands = [];
                for (let context of this.opnds){
                    let evaluated = context.evalPrecedence(parser, parserCallStack);
                    differs = differs || evaluated !== context;
                    if (evaluated === SemanticContext.NONE) return SemanticContext.NONE;
                    else if (evaluated) operands.push(evaluated);
                }
                if (!differs) return this;
                if (operands.length === 0) return undefined;
                let result = operands[0];
                for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
                return result;
            }
            toString() {
                return $2IEP9.join(this.opnds, "||");
            }
        };
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "operands", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "evalPrecedence", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "toString", null);
        OR = $ab4a86b5def51fe2$var$__decorate([
            $ab4a86b5def51fe2$var$__param(0, $d6D31.NotNull),
            $ab4a86b5def51fe2$var$__param(1, $d6D31.NotNull)
        ], OR);
        SemanticContext.OR = OR;
    })($ab4a86b5def51fe2$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));
});
parcelRegister("7Veax", function(module, exports) {
    "use strict";
    var $5c48d8f2b0160dc3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $5c48d8f2b0160dc3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Array2DHashSet = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $1EUnG = parcelRequire("1EUnG");
    var $d6D31 = parcelRequire("d6D31");
    var $iXFjm = parcelRequire("iXFjm");
    const $5c48d8f2b0160dc3$var$INITAL_CAPACITY = 16;
    const $5c48d8f2b0160dc3$var$LOAD_FACTOR = 0.75;
    class $5c48d8f2b0160dc3$var$Array2DHashSet {
        constructor(comparatorOrSet, initialCapacity = $5c48d8f2b0160dc3$var$INITAL_CAPACITY){
            this.n = 0;
            this.threshold = Math.floor($5c48d8f2b0160dc3$var$INITAL_CAPACITY * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
            if (comparatorOrSet instanceof $5c48d8f2b0160dc3$var$Array2DHashSet) {
                this.comparator = comparatorOrSet.comparator;
                this.buckets = comparatorOrSet.buckets.slice(0);
                for(let i = 0; i < this.buckets.length; i++){
                    let bucket = this.buckets[i];
                    if (bucket) this.buckets[i] = bucket.slice(0);
                }
                this.n = comparatorOrSet.n;
                this.threshold = comparatorOrSet.threshold;
            } else {
                this.comparator = comparatorOrSet || $1EUnG.DefaultEqualityComparator.INSTANCE;
                this.buckets = this.createBuckets(initialCapacity);
            }
        }
        getOrAdd(o) {
            if (this.n > this.threshold) this.expand();
            return this.getOrAddImpl(o);
        }
        getOrAddImpl(o) {
            let b = this.getBucket(o);
            let bucket = this.buckets[b];
            if (!bucket) {
                bucket = [
                    o
                ];
                this.buckets[b] = bucket;
                this.n++;
                return o;
            }
            for (let existing of bucket){
                if (this.comparator.equals(existing, o)) return existing;
            }
            bucket.push(o);
            this.n++;
            return o;
        }
        get(o) {
            if (o == null) return o;
            let b = this.getBucket(o);
            let bucket = this.buckets[b];
            if (!bucket) return undefined;
            for (let e of bucket){
                if (this.comparator.equals(e, o)) return e;
            }
            return undefined;
        }
        getBucket(o) {
            let hash = this.comparator.hashCode(o);
            let b = hash & this.buckets.length - 1;
            return b;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            for (let bucket of this.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    hash = $iXFjm.MurmurHash.update(hash, this.comparator.hashCode(o));
                }
            }
            hash = $iXFjm.MurmurHash.finish(hash, this.size);
            return hash;
        }
        equals(o) {
            if (o === this) return true;
            if (!(o instanceof $5c48d8f2b0160dc3$var$Array2DHashSet)) return false;
            if (o.size !== this.size) return false;
            let same = this.containsAll(o);
            return same;
        }
        expand() {
            let old = this.buckets;
            let newCapacity = this.buckets.length * 2;
            let newTable = this.createBuckets(newCapacity);
            this.buckets = newTable;
            this.threshold = Math.floor(newCapacity * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
            let oldSize = this.size;
            for (let bucket of old){
                if (!bucket) continue;
                for (let o of bucket){
                    let b = this.getBucket(o);
                    let newBucket = this.buckets[b];
                    if (!newBucket) {
                        newBucket = [];
                        this.buckets[b] = newBucket;
                    }
                    newBucket.push(o);
                }
            }
            $bbHFU(this.n === oldSize);
        }
        add(t) {
            let existing = this.getOrAdd(t);
            return existing === t;
        }
        get size() {
            return this.n;
        }
        get isEmpty() {
            return this.n === 0;
        }
        contains(o) {
            return this.containsFast(this.asElementType(o));
        }
        containsFast(obj) {
            if (obj == null) return false;
            return this.get(obj) != null;
        }
        *[Symbol.iterator]() {
            yield* this.toArray();
        }
        toArray() {
            const a = new Array(this.size);
            let i = 0;
            for (let bucket of this.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    a[i++] = o;
                }
            }
            return a;
        }
        containsAll(collection) {
            if (collection instanceof $5c48d8f2b0160dc3$var$Array2DHashSet) {
                let s = collection;
                for (let bucket of s.buckets){
                    if (bucket == null) continue;
                    for (let o of bucket){
                        if (o == null) break;
                        if (!this.containsFast(this.asElementType(o))) return false;
                    }
                }
            } else for (let o of collection){
                if (!this.containsFast(this.asElementType(o))) return false;
            }
            return true;
        }
        addAll(c) {
            let changed = false;
            for (let o of c){
                let existing = this.getOrAdd(o);
                if (existing !== o) changed = true;
            }
            return changed;
        }
        clear() {
            this.buckets = this.createBuckets($5c48d8f2b0160dc3$var$INITAL_CAPACITY);
            this.n = 0;
            this.threshold = Math.floor($5c48d8f2b0160dc3$var$INITAL_CAPACITY * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
        }
        toString() {
            if (this.size === 0) return "{}";
            let buf = "{";
            let first = true;
            for (let bucket of this.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (first) first = false;
                    else buf += ", ";
                    buf += o.toString();
                }
            }
            buf += "}";
            return buf;
        }
        toTableString() {
            let buf = "";
            for (let bucket of this.buckets){
                if (bucket == null) {
                    buf += "null\n";
                    continue;
                }
                buf += "[";
                let first = true;
                for (let o of bucket){
                    if (first) first = false;
                    else buf += " ";
                    if (o == null) buf += "_";
                    else buf += o.toString();
                }
                buf += "]\n";
            }
            return buf;
        }
        asElementType(o) {
            return o;
        }
        createBuckets(capacity) {
            return new Array(capacity);
        }
    }
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.NotNull
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "comparator", void 0);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "hashCode", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "equals", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "add", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "size", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "isEmpty", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "contains", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $5c48d8f2b0160dc3$var$__param(0, $d6D31.Nullable)
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "containsFast", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, Symbol.iterator, null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "toArray", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "containsAll", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "addAll", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "clear", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "toString", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.SuppressWarnings("unchecked")
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "asElementType", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.SuppressWarnings("unchecked")
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "createBuckets", null);
    module.exports.Array2DHashSet = $5c48d8f2b0160dc3$var$Array2DHashSet;
});
parcelRegister("1EUnG", function(module, exports) {
    "use strict";
    var $135542f8f0124ec7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DefaultEqualityComparator = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $iXFjm = parcelRequire("iXFjm");
    var $a4Flx = parcelRequire("a4Flx");
    class $135542f8f0124ec7$var$DefaultEqualityComparator {
        hashCode(obj) {
            if (obj == null) return 0;
            else if (typeof obj === "string" || typeof obj === "number") return $iXFjm.MurmurHash.hashCode([
                obj
            ]);
            else return $a4Flx.ObjectEqualityComparator.INSTANCE.hashCode(obj);
        }
        equals(a, b) {
            if (a == null) return b == null;
            else if (typeof a === "string" || typeof a === "number") return a === b;
            else return $a4Flx.ObjectEqualityComparator.INSTANCE.equals(a, b);
        }
    }
    $135542f8f0124ec7$var$DefaultEqualityComparator.INSTANCE = new $135542f8f0124ec7$var$DefaultEqualityComparator();
    $135542f8f0124ec7$var$__decorate([
        $d6D31.Override
    ], $135542f8f0124ec7$var$DefaultEqualityComparator.prototype, "hashCode", null);
    $135542f8f0124ec7$var$__decorate([
        $d6D31.Override
    ], $135542f8f0124ec7$var$DefaultEqualityComparator.prototype, "equals", null);
    module.exports.DefaultEqualityComparator = $135542f8f0124ec7$var$DefaultEqualityComparator;
});
parcelRegister("iXFjm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.MurmurHash = void 0;
    var $dcddc83c17bb111f$var$MurmurHash;
    (function(MurmurHash) {
        const DEFAULT_SEED = 0;
        function initialize(seed = DEFAULT_SEED) {
            return seed;
        }
        MurmurHash.initialize = initialize;
        function update(hash, value) {
            const c1 = 0xCC9E2D51;
            const c2 = 0x1B873593;
            const r1 = 15;
            const r2 = 13;
            const m = 5;
            const n = 0xE6546B64;
            if (value == null) value = 0;
            else if (typeof value === "string") value = hashString(value);
            else if (typeof value === "object") value = value.hashCode();
            let k = value;
            k = Math.imul(k, c1);
            k = k << r1 | k >>> 32 - r1;
            k = Math.imul(k, c2);
            hash = hash ^ k;
            hash = hash << r2 | hash >>> 32 - r2;
            hash = Math.imul(hash, m) + n;
            return hash & 0xFFFFFFFF;
        }
        MurmurHash.update = update;
        function finish(hash, numberOfWords) {
            hash = hash ^ numberOfWords * 4;
            hash = hash ^ hash >>> 16;
            hash = Math.imul(hash, 0x85EBCA6B);
            hash = hash ^ hash >>> 13;
            hash = Math.imul(hash, 0xC2B2AE35);
            hash = hash ^ hash >>> 16;
            return hash;
        }
        MurmurHash.finish = finish;
        function hashCode(data, seed = DEFAULT_SEED) {
            let hash = initialize(seed);
            let length = 0;
            for (let value of data){
                hash = update(hash, value);
                length++;
            }
            hash = finish(hash, length);
            return hash;
        }
        MurmurHash.hashCode = hashCode;
        function hashString(str) {
            let len = str.length;
            if (len === 0) return 0;
            let hash = 0;
            for(let i = 0; i < len; i++){
                let c = str.charCodeAt(i);
                hash = (hash << 5 >>> 0) - hash + c;
                hash |= 0;
            }
            return hash;
        }
    })($dcddc83c17bb111f$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));
});
parcelRegister("a4Flx", function(module, exports) {
    "use strict";
    var $755a59a5b7943f39$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ObjectEqualityComparator = void 0;
    var $d6D31 = parcelRequire("d6D31");
    class $755a59a5b7943f39$var$ObjectEqualityComparator {
        hashCode(obj) {
            if (obj == null) return 0;
            return obj.hashCode();
        }
        equals(a, b) {
            if (a == null) return b == null;
            return a.equals(b);
        }
    }
    $755a59a5b7943f39$var$ObjectEqualityComparator.INSTANCE = new $755a59a5b7943f39$var$ObjectEqualityComparator();
    $755a59a5b7943f39$var$__decorate([
        $d6D31.Override
    ], $755a59a5b7943f39$var$ObjectEqualityComparator.prototype, "hashCode", null);
    $755a59a5b7943f39$var$__decorate([
        $d6D31.Override
    ], $755a59a5b7943f39$var$ObjectEqualityComparator.prototype, "equals", null);
    module.exports.ObjectEqualityComparator = $755a59a5b7943f39$var$ObjectEqualityComparator;
});
parcelRegister("3sNxf", function(module, exports) {
    "use strict";
    var $285a6946513e4d3e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ArrayEqualityComparator = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $iXFjm = parcelRequire("iXFjm");
    var $a4Flx = parcelRequire("a4Flx");
    class $285a6946513e4d3e$var$ArrayEqualityComparator {
        hashCode(obj) {
            if (obj == null) return 0;
            return $iXFjm.MurmurHash.hashCode(obj, 0);
        }
        equals(a, b) {
            if (a == null) return b == null;
            else if (b == null) return false;
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!$a4Flx.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
            }
            return true;
        }
    }
    $285a6946513e4d3e$var$ArrayEqualityComparator.INSTANCE = new $285a6946513e4d3e$var$ArrayEqualityComparator();
    $285a6946513e4d3e$var$__decorate([
        $d6D31.Override
    ], $285a6946513e4d3e$var$ArrayEqualityComparator.prototype, "hashCode", null);
    $285a6946513e4d3e$var$__decorate([
        $d6D31.Override
    ], $285a6946513e4d3e$var$ArrayEqualityComparator.prototype, "equals", null);
    module.exports.ArrayEqualityComparator = $285a6946513e4d3e$var$ArrayEqualityComparator;
});
parcelRegister("2IEP9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
    function $1faf5ba696168af5$var$escapeWhitespace(s, escapeSpaces) {
        return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
    }
    module.exports.escapeWhitespace = $1faf5ba696168af5$var$escapeWhitespace;
    function $1faf5ba696168af5$var$join(collection, separator) {
        let buf = "";
        let first = true;
        for (let current of collection){
            if (first) first = false;
            else buf += separator;
            buf += current;
        }
        return buf;
    }
    module.exports.join = $1faf5ba696168af5$var$join;
    function $1faf5ba696168af5$var$equals(x, y) {
        if (x === y) return true;
        if (x === undefined || y === undefined) return false;
        return x.equals(y);
    }
    module.exports.equals = $1faf5ba696168af5$var$equals;
    function $1faf5ba696168af5$var$toMap(keys) {
        let m = new Map();
        for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
        return m;
    }
    module.exports.toMap = $1faf5ba696168af5$var$toMap;
    function $1faf5ba696168af5$var$toCharArray(str) {
        if (typeof str === "string") {
            let result = new Uint16Array(str.length);
            for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
            return result;
        } else return str.toCharArray();
    }
    module.exports.toCharArray = $1faf5ba696168af5$var$toCharArray;
});
parcelRegister("iLUMi", function(module, exports) {
    "use strict";
    var $daa8a8b6b270e309$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $daa8a8b6b270e309$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.InputMismatchException = void 0;
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    let $daa8a8b6b270e309$var$InputMismatchException = class InputMismatchException extends $fLdDn.RecognitionException {
        constructor(recognizer, state, context){
            if (context === undefined) context = recognizer.context;
            super(recognizer, recognizer.inputStream, context);
            if (state !== undefined) this.setOffendingState(state);
            this.setOffendingToken(recognizer, recognizer.currentToken);
        }
    };
    $daa8a8b6b270e309$var$InputMismatchException = $daa8a8b6b270e309$var$__decorate([
        $daa8a8b6b270e309$var$__param(0, $d6D31.NotNull)
    ], $daa8a8b6b270e309$var$InputMismatchException);
    module.exports.InputMismatchException = $daa8a8b6b270e309$var$InputMismatchException;
});
parcelRegister("hGRod", function(module, exports) {
    "use strict";
    var $ce0fc5f35b4fec79$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ce0fc5f35b4fec79$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntervalSet = void 0;
    var $3sNxf = parcelRequire("3sNxf");
    var $37SGk = parcelRequire("37SGk");
    var $gcfUE = parcelRequire("gcfUE");
    var $igNLf = parcelRequire("igNLf");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $ce0fc5f35b4fec79$var$IntervalSet {
        constructor(intervals){
            this.readonly = false;
            if (intervals != null) this._intervals = intervals.slice(0);
            else this._intervals = [];
        }
        static get COMPLETE_CHAR_SET() {
            if ($ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
                $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET = $ce0fc5f35b4fec79$var$IntervalSet.of($igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE);
                $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
            }
            return $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET;
        }
        static get EMPTY_SET() {
            if ($ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET == null) {
                $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET = new $ce0fc5f35b4fec79$var$IntervalSet();
                $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET.setReadonly(true);
            }
            return $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET;
        }
        static of(a, b = a) {
            let s = new $ce0fc5f35b4fec79$var$IntervalSet();
            s.add(a, b);
            return s;
        }
        clear() {
            if (this.readonly) throw new Error("can't alter readonly IntervalSet");
            this._intervals.length = 0;
        }
        add(a, b = a) {
            this.addRange($gcfUE.Interval.of(a, b));
        }
        addRange(addition) {
            if (this.readonly) throw new Error("can't alter readonly IntervalSet");
            if (addition.b < addition.a) return;
            for(let i = 0; i < this._intervals.length; i++){
                let r = this._intervals[i];
                if (addition.equals(r)) return;
                if (addition.adjacent(r) || !addition.disjoint(r)) {
                    let bigger = addition.union(r);
                    this._intervals[i] = bigger;
                    while(i < this._intervals.length - 1){
                        i++;
                        let next = this._intervals[i];
                        if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                        this._intervals.splice(i, 1);
                        i--;
                        this._intervals[i] = bigger.union(next);
                    }
                    return;
                }
                if (addition.startsBeforeDisjoint(r)) {
                    this._intervals.splice(i, 0, addition);
                    return;
                }
            }
            this._intervals.push(addition);
        }
        static or(sets) {
            let r = new $ce0fc5f35b4fec79$var$IntervalSet();
            for (let s of sets)r.addAll(s);
            return r;
        }
        addAll(set) {
            if (set == null) return this;
            if (set instanceof $ce0fc5f35b4fec79$var$IntervalSet) {
                let other = set;
                let n = other._intervals.length;
                for(let i = 0; i < n; i++){
                    let I = other._intervals[i];
                    this.add(I.a, I.b);
                }
            } else for (let value of set.toArray())this.add(value);
            return this;
        }
        complementRange(minElement, maxElement) {
            return this.complement($ce0fc5f35b4fec79$var$IntervalSet.of(minElement, maxElement));
        }
        complement(vocabulary) {
            if (vocabulary.isNil) return $ce0fc5f35b4fec79$var$IntervalSet.EMPTY_SET;
            let vocabularyIS;
            if (vocabulary instanceof $ce0fc5f35b4fec79$var$IntervalSet) vocabularyIS = vocabulary;
            else {
                vocabularyIS = new $ce0fc5f35b4fec79$var$IntervalSet();
                vocabularyIS.addAll(vocabulary);
            }
            return vocabularyIS.subtract(this);
        }
        subtract(a) {
            if (a == null || a.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet(this._intervals);
            if (a instanceof $ce0fc5f35b4fec79$var$IntervalSet) return $ce0fc5f35b4fec79$var$IntervalSet.subtract(this, a);
            let other = new $ce0fc5f35b4fec79$var$IntervalSet();
            other.addAll(a);
            return $ce0fc5f35b4fec79$var$IntervalSet.subtract(this, other);
        }
        static subtract(left, right) {
            if (left.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet();
            let result = new $ce0fc5f35b4fec79$var$IntervalSet(left._intervals);
            if (right.isNil) return result;
            let resultI = 0;
            let rightI = 0;
            while(resultI < result._intervals.length && rightI < right._intervals.length){
                let resultInterval = result._intervals[resultI];
                let rightInterval = right._intervals[rightI];
                if (rightInterval.b < resultInterval.a) {
                    rightI++;
                    continue;
                }
                if (rightInterval.a > resultInterval.b) {
                    resultI++;
                    continue;
                }
                let beforeCurrent;
                let afterCurrent;
                if (rightInterval.a > resultInterval.a) beforeCurrent = new $gcfUE.Interval(resultInterval.a, rightInterval.a - 1);
                if (rightInterval.b < resultInterval.b) afterCurrent = new $gcfUE.Interval(rightInterval.b + 1, resultInterval.b);
                if (beforeCurrent) {
                    if (afterCurrent) {
                        result._intervals[resultI] = beforeCurrent;
                        result._intervals.splice(resultI + 1, 0, afterCurrent);
                        resultI++;
                        rightI++;
                        continue;
                    } else {
                        result._intervals[resultI] = beforeCurrent;
                        resultI++;
                        continue;
                    }
                } else if (afterCurrent) {
                    result._intervals[resultI] = afterCurrent;
                    rightI++;
                    continue;
                } else {
                    result._intervals.splice(resultI, 1);
                    continue;
                }
            }
            return result;
        }
        or(a) {
            let o = new $ce0fc5f35b4fec79$var$IntervalSet();
            o.addAll(this);
            o.addAll(a);
            return o;
        }
        and(other) {
            if (other.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet();
            let myIntervals = this._intervals;
            let theirIntervals = other._intervals;
            let intersection;
            let mySize = myIntervals.length;
            let theirSize = theirIntervals.length;
            let i = 0;
            let j = 0;
            while(i < mySize && j < theirSize){
                let mine = myIntervals[i];
                let theirs = theirIntervals[j];
                if (mine.startsBeforeDisjoint(theirs)) i++;
                else if (theirs.startsBeforeDisjoint(mine)) j++;
                else if (mine.properlyContains(theirs)) {
                    if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                    intersection.addRange(mine.intersection(theirs));
                    j++;
                } else if (theirs.properlyContains(mine)) {
                    if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                    intersection.addRange(mine.intersection(theirs));
                    i++;
                } else if (!mine.disjoint(theirs)) {
                    if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                    intersection.addRange(mine.intersection(theirs));
                    if (mine.startsAfterNonDisjoint(theirs)) j++;
                    else if (theirs.startsAfterNonDisjoint(mine)) i++;
                }
            }
            if (!intersection) return new $ce0fc5f35b4fec79$var$IntervalSet();
            return intersection;
        }
        contains(el) {
            let n = this._intervals.length;
            let l = 0;
            let r = n - 1;
            while(l <= r){
                let m = l + r >> 1;
                let I = this._intervals[m];
                let a = I.a;
                let b = I.b;
                if (b < el) l = m + 1;
                else if (a > el) r = m - 1;
                else return true;
            }
            return false;
        }
        get isNil() {
            return this._intervals == null || this._intervals.length === 0;
        }
        get maxElement() {
            if (this.isNil) throw new RangeError("set is empty");
            let last = this._intervals[this._intervals.length - 1];
            return last.b;
        }
        get minElement() {
            if (this.isNil) throw new RangeError("set is empty");
            return this._intervals[0].a;
        }
        get intervals() {
            return this._intervals;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            for (let I of this._intervals){
                hash = $iXFjm.MurmurHash.update(hash, I.a);
                hash = $iXFjm.MurmurHash.update(hash, I.b);
            }
            hash = $iXFjm.MurmurHash.finish(hash, this._intervals.length * 2);
            return hash;
        }
        equals(o) {
            if (o == null || !(o instanceof $ce0fc5f35b4fec79$var$IntervalSet)) return false;
            return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
        }
        toString(elemAreChar = false) {
            let buf = "";
            if (this._intervals == null || this._intervals.length === 0) return "{}";
            if (this.size > 1) buf += "{";
            let first = true;
            for (let I of this._intervals){
                if (first) first = false;
                else buf += ", ";
                let a = I.a;
                let b = I.b;
                if (a === b) {
                    if (a === $2DVsz.Token.EOF) buf += "<EOF>";
                    else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                    else buf += a;
                } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
                else buf += a + ".." + b;
            }
            if (this.size > 1) buf += "}";
            return buf;
        }
        toStringVocabulary(vocabulary) {
            if (this._intervals == null || this._intervals.length === 0) return "{}";
            let buf = "";
            if (this.size > 1) buf += "{";
            let first = true;
            for (let I of this._intervals){
                if (first) first = false;
                else buf += ", ";
                let a = I.a;
                let b = I.b;
                if (a === b) buf += this.elementName(vocabulary, a);
                else for(let i = a; i <= b; i++){
                    if (i > a) buf += ", ";
                    buf += this.elementName(vocabulary, i);
                }
            }
            if (this.size > 1) buf += "}";
            return buf;
        }
        elementName(vocabulary, a) {
            if (a === $2DVsz.Token.EOF) return "<EOF>";
            else if (a === $2DVsz.Token.EPSILON) return "<EPSILON>";
            else return vocabulary.getDisplayName(a);
        }
        get size() {
            let n = 0;
            let numIntervals = this._intervals.length;
            if (numIntervals === 1) {
                let firstInterval = this._intervals[0];
                return firstInterval.b - firstInterval.a + 1;
            }
            for(let i = 0; i < numIntervals; i++){
                let I = this._intervals[i];
                n += I.b - I.a + 1;
            }
            return n;
        }
        toIntegerList() {
            let values = new $37SGk.IntegerList(this.size);
            let n = this._intervals.length;
            for(let i = 0; i < n; i++){
                let I = this._intervals[i];
                let a = I.a;
                let b = I.b;
                for(let v = a; v <= b; v++)values.add(v);
            }
            return values;
        }
        toSet() {
            let s = new Set();
            for (let I of this._intervals){
                let a = I.a;
                let b = I.b;
                for(let v = a; v <= b; v++)s.add(v);
            }
            return s;
        }
        toArray() {
            let values = new Array();
            let n = this._intervals.length;
            for(let i = 0; i < n; i++){
                let I = this._intervals[i];
                let a = I.a;
                let b = I.b;
                for(let v = a; v <= b; v++)values.push(v);
            }
            return values;
        }
        remove(el) {
            if (this.readonly) throw new Error("can't alter readonly IntervalSet");
            let n = this._intervals.length;
            for(let i = 0; i < n; i++){
                let I = this._intervals[i];
                let a = I.a;
                let b = I.b;
                if (el < a) break;
                if (el === a && el === b) {
                    this._intervals.splice(i, 1);
                    break;
                }
                if (el === a) {
                    this._intervals[i] = $gcfUE.Interval.of(I.a + 1, I.b);
                    break;
                }
                if (el === b) {
                    this._intervals[i] = $gcfUE.Interval.of(I.a, I.b - 1);
                    break;
                }
                if (el > a && el < b) {
                    let oldb = I.b;
                    this._intervals[i] = $gcfUE.Interval.of(I.a, el - 1);
                    this.add(el + 1, oldb);
                }
            }
        }
        get isReadonly() {
            return this.readonly;
        }
        setReadonly(readonly) {
            if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
            this.readonly = readonly;
        }
    }
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "addAll", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "complement", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "subtract", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "or", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "and", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "contains", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "isNil", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "hashCode", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "equals", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $ce0fc5f35b4fec79$var$__param(0, $d6D31.NotNull)
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "toStringVocabulary", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.NotNull,
        $ce0fc5f35b4fec79$var$__param(0, $d6D31.NotNull)
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "elementName", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "size", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "remove", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.NotNull
    ], $ce0fc5f35b4fec79$var$IntervalSet, "of", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.NotNull
    ], $ce0fc5f35b4fec79$var$IntervalSet, "subtract", null);
    module.exports.IntervalSet = $ce0fc5f35b4fec79$var$IntervalSet;
});
parcelRegister("37SGk", function(module, exports) {
    "use strict";
    var $246c712c5583aa9c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntegerList = void 0;
    var $9yG1X = parcelRequire("9yG1X");
    var $d6D31 = parcelRequire("d6D31");
    const $246c712c5583aa9c$var$EMPTY_DATA = new Int32Array(0);
    const $246c712c5583aa9c$var$INITIAL_SIZE = 4;
    const $246c712c5583aa9c$var$MAX_ARRAY_SIZE = 2147483639;
    class $246c712c5583aa9c$var$IntegerList {
        constructor(arg){
            if (!arg) {
                this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                this._size = 0;
            } else if (arg instanceof $246c712c5583aa9c$var$IntegerList) {
                this._data = arg._data.slice(0);
                this._size = arg._size;
            } else if (typeof arg === "number") {
                if (arg === 0) {
                    this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                    this._size = 0;
                } else {
                    this._data = new Int32Array(arg);
                    this._size = 0;
                }
            } else {
                this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                this._size = 0;
                for (let value of arg)this.add(value);
            }
        }
        add(value) {
            if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
            this._data[this._size] = value;
            this._size++;
        }
        addAll(list) {
            if (Array.isArray(list)) {
                this.ensureCapacity(this._size + list.length);
                this._data.subarray(this._size, this._size + list.length).set(list);
                this._size += list.length;
            } else if (list instanceof $246c712c5583aa9c$var$IntegerList) {
                this.ensureCapacity(this._size + list._size);
                this._data.subarray(this._size, this._size + list.size).set(list._data);
                this._size += list._size;
            } else {
                this.ensureCapacity(this._size + list.size);
                let current = 0;
                for (let xi of list){
                    this._data[this._size + current] = xi;
                    current++;
                }
                this._size += list.size;
            }
        }
        get(index) {
            if (index < 0 || index >= this._size) throw RangeError();
            return this._data[index];
        }
        contains(value) {
            for(let i = 0; i < this._size; i++){
                if (this._data[i] === value) return true;
            }
            return false;
        }
        set(index, value) {
            if (index < 0 || index >= this._size) throw RangeError();
            let previous = this._data[index];
            this._data[index] = value;
            return previous;
        }
        removeAt(index) {
            let value = this.get(index);
            this._data.copyWithin(index, index + 1, this._size);
            this._data[this._size - 1] = 0;
            this._size--;
            return value;
        }
        removeRange(fromIndex, toIndex) {
            if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
            if (fromIndex > toIndex) throw RangeError();
            this._data.copyWithin(toIndex, fromIndex, this._size);
            this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
            this._size -= toIndex - fromIndex;
        }
        get isEmpty() {
            return this._size === 0;
        }
        get size() {
            return this._size;
        }
        trimToSize() {
            if (this._data.length === this._size) return;
            this._data = this._data.slice(0, this._size);
        }
        clear() {
            this._data.fill(0, 0, this._size);
            this._size = 0;
        }
        toArray() {
            if (this._size === 0) return [];
            return Array.from(this._data.subarray(0, this._size));
        }
        sort() {
            this._data.subarray(0, this._size).sort();
        }
        equals(o) {
            if (o === this) return true;
            if (!(o instanceof $246c712c5583aa9c$var$IntegerList)) return false;
            if (this._size !== o._size) return false;
            for(let i = 0; i < this._size; i++){
                if (this._data[i] !== o._data[i]) return false;
            }
            return true;
        }
        hashCode() {
            let hashCode = 1;
            for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
            return hashCode;
        }
        toString() {
            return this._data.toString();
        }
        binarySearch(key, fromIndex, toIndex) {
            if (fromIndex === undefined) fromIndex = 0;
            if (toIndex === undefined) toIndex = this._size;
            if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
            if (fromIndex > toIndex) throw new RangeError();
            return $9yG1X.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
        }
        ensureCapacity(capacity) {
            if (capacity < 0 || capacity > $246c712c5583aa9c$var$MAX_ARRAY_SIZE) throw new RangeError();
            let newLength;
            if (this._data.length === 0) newLength = $246c712c5583aa9c$var$INITIAL_SIZE;
            else newLength = this._data.length;
            while(newLength < capacity){
                newLength = newLength * 2;
                if (newLength < 0 || newLength > $246c712c5583aa9c$var$MAX_ARRAY_SIZE) newLength = $246c712c5583aa9c$var$MAX_ARRAY_SIZE;
            }
            let tmp = new Int32Array(newLength);
            tmp.set(this._data);
            this._data = tmp;
        }
        toCharArray() {
            let resultArray = new Uint16Array(this._size);
            let resultIdx = 0;
            let calculatedPreciseResultSize = false;
            for(let i = 0; i < this._size; i++){
                let codePoint = this._data[i];
                if (codePoint >= 0 && codePoint < 0x10000) {
                    resultArray[resultIdx] = codePoint;
                    resultIdx++;
                    continue;
                }
                if (!calculatedPreciseResultSize) {
                    let newResultArray = new Uint16Array(this.charArraySize());
                    newResultArray.set(resultArray, 0);
                    resultArray = newResultArray;
                    calculatedPreciseResultSize = true;
                }
                let pair = String.fromCodePoint(codePoint);
                resultArray[resultIdx] = pair.charCodeAt(0);
                resultArray[resultIdx + 1] = pair.charCodeAt(1);
                resultIdx += 2;
            }
            return resultArray;
        }
        charArraySize() {
            let result = 0;
            for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
            return result;
        }
    }
    $246c712c5583aa9c$var$__decorate([
        $d6D31.NotNull
    ], $246c712c5583aa9c$var$IntegerList.prototype, "_data", void 0);
    $246c712c5583aa9c$var$__decorate([
        $d6D31.Override
    ], $246c712c5583aa9c$var$IntegerList.prototype, "equals", null);
    $246c712c5583aa9c$var$__decorate([
        $d6D31.Override
    ], $246c712c5583aa9c$var$IntegerList.prototype, "hashCode", null);
    $246c712c5583aa9c$var$__decorate([
        $d6D31.Override
    ], $246c712c5583aa9c$var$IntegerList.prototype, "toString", null);
    module.exports.IntegerList = $246c712c5583aa9c$var$IntegerList;
});
parcelRegister("9yG1X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Arrays = void 0;
    var $6f57e46e4dc9d39b$var$Arrays;
    (function(Arrays) {
        function binarySearch(array, key, fromIndex, toIndex) {
            return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
        }
        Arrays.binarySearch = binarySearch;
        function binarySearch0(array, fromIndex, toIndex, key) {
            let low = fromIndex;
            let high = toIndex - 1;
            while(low <= high){
                let mid = low + high >>> 1;
                let midVal = array[mid];
                if (midVal < key) low = mid + 1;
                else if (midVal > key) high = mid - 1;
                else return mid;
            }
            return -(low + 1);
        }
        function toString(array) {
            let result = "[";
            let first = true;
            for (let element of array){
                if (first) first = false;
                else result += ", ";
                if (element === null) result += "null";
                else if (element === undefined) result += "undefined";
                else result += element;
            }
            result += "]";
            return result;
        }
        Arrays.toString = toString;
    })($6f57e46e4dc9d39b$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));
});
parcelRegister("gcfUE", function(module, exports) {
    "use strict";
    var $bcaa1c4749d34439$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Interval = void 0;
    var $d6D31 = parcelRequire("d6D31");
    const $bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE = 1000;
    class $bcaa1c4749d34439$var$Interval {
        constructor(a, b){
            this.a = a;
            this.b = b;
        }
        static get INVALID() {
            return $bcaa1c4749d34439$var$Interval._INVALID;
        }
        static of(a, b) {
            if (a !== b || a < 0 || a > $bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE) return new $bcaa1c4749d34439$var$Interval(a, b);
            if ($bcaa1c4749d34439$var$Interval.cache[a] == null) $bcaa1c4749d34439$var$Interval.cache[a] = new $bcaa1c4749d34439$var$Interval(a, a);
            return $bcaa1c4749d34439$var$Interval.cache[a];
        }
        get length() {
            if (this.b < this.a) return 0;
            return this.b - this.a + 1;
        }
        equals(o) {
            if (o === this) return true;
            else if (!(o instanceof $bcaa1c4749d34439$var$Interval)) return false;
            return this.a === o.a && this.b === o.b;
        }
        hashCode() {
            let hash = 23;
            hash = hash * 31 + this.a;
            hash = hash * 31 + this.b;
            return hash;
        }
        startsBeforeDisjoint(other) {
            return this.a < other.a && this.b < other.a;
        }
        startsBeforeNonDisjoint(other) {
            return this.a <= other.a && this.b >= other.a;
        }
        startsAfter(other) {
            return this.a > other.a;
        }
        startsAfterDisjoint(other) {
            return this.a > other.b;
        }
        startsAfterNonDisjoint(other) {
            return this.a > other.a && this.a <= other.b;
        }
        disjoint(other) {
            return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
        }
        adjacent(other) {
            return this.a === other.b + 1 || this.b === other.a - 1;
        }
        properlyContains(other) {
            return other.a >= this.a && other.b <= this.b;
        }
        union(other) {
            return $bcaa1c4749d34439$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
        }
        intersection(other) {
            return $bcaa1c4749d34439$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
        }
        differenceNotProperlyContained(other) {
            let diff;
            if (other.startsBeforeNonDisjoint(this)) diff = $bcaa1c4749d34439$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
            else if (other.startsAfterNonDisjoint(this)) diff = $bcaa1c4749d34439$var$Interval.of(this.a, other.a - 1);
            return diff;
        }
        toString() {
            return this.a + ".." + this.b;
        }
    }
    $bcaa1c4749d34439$var$Interval._INVALID = new $bcaa1c4749d34439$var$Interval(-1, -2);
    $bcaa1c4749d34439$var$Interval.cache = new Array($bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE + 1);
    $bcaa1c4749d34439$var$__decorate([
        $d6D31.Override
    ], $bcaa1c4749d34439$var$Interval.prototype, "equals", null);
    $bcaa1c4749d34439$var$__decorate([
        $d6D31.Override
    ], $bcaa1c4749d34439$var$Interval.prototype, "hashCode", null);
    $bcaa1c4749d34439$var$__decorate([
        $d6D31.Override
    ], $bcaa1c4749d34439$var$Interval.prototype, "toString", null);
    module.exports.Interval = $bcaa1c4749d34439$var$Interval;
});
parcelRegister("igNLf", function(module, exports) {
    "use strict";
    var $d4d0521f20d9c4ac$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Lexer = void 0;
    var $gWaB3 = parcelRequire("gWaB3");
    var $6Kebn = parcelRequire("6Kebn");
    var $gcfUE = parcelRequire("gcfUE");
    var $ceaEj = parcelRequire("ceaEj");
    var $lQecE = parcelRequire("lQecE");
    var $fOEQQ = parcelRequire("fOEQQ");
    var $d6D31 = parcelRequire("d6D31");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $2DVsz = parcelRequire("2DVsz");
    class $d4d0521f20d9c4ac$var$Lexer extends $kBaAZ.Recognizer {
        constructor(input){
            super();
            this._factory = $gWaB3.CommonTokenFactory.DEFAULT;
            this._tokenStartCharIndex = -1;
            this._tokenStartLine = 0;
            this._tokenStartCharPositionInLine = 0;
            this._hitEOF = false;
            this._channel = 0;
            this._type = 0;
            this._modeStack = new $6Kebn.IntegerStack();
            this._mode = $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE;
            this._input = input;
            this._tokenFactorySourcePair = {
                source: this,
                stream: input
            };
        }
        static get DEFAULT_TOKEN_CHANNEL() {
            return $2DVsz.Token.DEFAULT_CHANNEL;
        }
        static get HIDDEN() {
            return $2DVsz.Token.HIDDEN_CHANNEL;
        }
        reset(resetInput) {
            if (resetInput === undefined || resetInput) this._input.seek(0);
            this._token = undefined;
            this._type = $2DVsz.Token.INVALID_TYPE;
            this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
            this._tokenStartCharIndex = -1;
            this._tokenStartCharPositionInLine = -1;
            this._tokenStartLine = -1;
            this._text = undefined;
            this._hitEOF = false;
            this._mode = $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE;
            this._modeStack.clear();
            this.interpreter.reset();
        }
        nextToken() {
            if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
            let tokenStartMarker = this._input.mark();
            try {
                outer: while(true){
                    if (this._hitEOF) return this.emitEOF();
                    this._token = undefined;
                    this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
                    this._tokenStartCharIndex = this._input.index;
                    this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                    this._tokenStartLine = this.interpreter.line;
                    this._text = undefined;
                    do {
                        this._type = $2DVsz.Token.INVALID_TYPE;
                        let ttype;
                        try {
                            ttype = this.interpreter.match(this._input, this._mode);
                        } catch (e) {
                            if (e instanceof $fOEQQ.LexerNoViableAltException) {
                                this.notifyListeners(e);
                                this.recover(e);
                                ttype = $d4d0521f20d9c4ac$var$Lexer.SKIP;
                            } else throw e;
                        }
                        if (this._input.LA(1) === $ceaEj.IntStream.EOF) this._hitEOF = true;
                        if (this._type === $2DVsz.Token.INVALID_TYPE) this._type = ttype;
                        if (this._type === $d4d0521f20d9c4ac$var$Lexer.SKIP) continue outer;
                    }while (this._type === $d4d0521f20d9c4ac$var$Lexer.MORE)
                    if (this._token == null) return this.emit();
                    return this._token;
                }
            } finally{
                this._input.release(tokenStartMarker);
            }
        }
        skip() {
            this._type = $d4d0521f20d9c4ac$var$Lexer.SKIP;
        }
        more() {
            this._type = $d4d0521f20d9c4ac$var$Lexer.MORE;
        }
        mode(m) {
            this._mode = m;
        }
        pushMode(m) {
            if ($lQecE.LexerATNSimulator.debug) console.log("pushMode " + m);
            this._modeStack.push(this._mode);
            this.mode(m);
        }
        popMode() {
            if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
            if ($lQecE.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
            this.mode(this._modeStack.pop());
            return this._mode;
        }
        get tokenFactory() {
            return this._factory;
        }
        set tokenFactory(factory) {
            this._factory = factory;
        }
        get inputStream() {
            return this._input;
        }
        set inputStream(input) {
            this.reset(false);
            this._input = input;
            this._tokenFactorySourcePair = {
                source: this,
                stream: this._input
            };
        }
        get sourceName() {
            return this._input.sourceName;
        }
        emit(token) {
            if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
            this._token = token;
            return token;
        }
        emitEOF() {
            let cpos = this.charPositionInLine;
            let line = this.line;
            let eof = this._factory.create(this._tokenFactorySourcePair, $2DVsz.Token.EOF, undefined, $2DVsz.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
            this.emit(eof);
            return eof;
        }
        get line() {
            return this.interpreter.line;
        }
        set line(line) {
            this.interpreter.line = line;
        }
        get charPositionInLine() {
            return this.interpreter.charPositionInLine;
        }
        set charPositionInLine(charPositionInLine) {
            this.interpreter.charPositionInLine = charPositionInLine;
        }
        get charIndex() {
            return this._input.index;
        }
        get text() {
            if (this._text != null) return this._text;
            return this.interpreter.getText(this._input);
        }
        set text(text) {
            this._text = text;
        }
        get token() {
            return this._token;
        }
        set token(_token) {
            this._token = _token;
        }
        set type(ttype) {
            this._type = ttype;
        }
        get type() {
            return this._type;
        }
        set channel(channel) {
            this._channel = channel;
        }
        get channel() {
            return this._channel;
        }
        getAllTokens() {
            let tokens = [];
            let t = this.nextToken();
            while(t.type !== $2DVsz.Token.EOF){
                tokens.push(t);
                t = this.nextToken();
            }
            return tokens;
        }
        notifyListeners(e) {
            let text = this._input.getText($gcfUE.Interval.of(this._tokenStartCharIndex, this._input.index));
            let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
            let listener = this.getErrorListenerDispatch();
            if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
        }
        getErrorDisplay(s) {
            if (typeof s === "number") {
                switch(s){
                    case $2DVsz.Token.EOF:
                        return "<EOF>";
                    case 0x0a:
                        return "\\n";
                    case 0x09:
                        return "\\t";
                    case 0x0d:
                        return "\\r";
                }
                return String.fromCharCode(s);
            }
            return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
        }
        getCharErrorDisplay(c) {
            let s = this.getErrorDisplay(c);
            return "'" + s + "'";
        }
        recover(re) {
            if (re instanceof $fOEQQ.LexerNoViableAltException) {
                if (this._input.LA(1) !== $ceaEj.IntStream.EOF) this.interpreter.consume(this._input);
            } else this._input.consume();
        }
    }
    $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE = 0;
    $d4d0521f20d9c4ac$var$Lexer.MORE = -2;
    $d4d0521f20d9c4ac$var$Lexer.SKIP = -3;
    $d4d0521f20d9c4ac$var$Lexer.MIN_CHAR_VALUE = 0x0000;
    $d4d0521f20d9c4ac$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "nextToken", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "tokenFactory", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "inputStream", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "sourceName", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "line", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "charPositionInLine", null);
    module.exports.Lexer = $d4d0521f20d9c4ac$var$Lexer;
});
parcelRegister("gWaB3", function(module, exports) {
    "use strict";
    var $c54a4863b793dbc8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CommonTokenFactory = void 0;
    var $j53rr = parcelRequire("j53rr");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    class $c54a4863b793dbc8$var$CommonTokenFactory {
        constructor(copyText = false){
            this.copyText = copyText;
        }
        create(source, type, text, channel, start, stop, line, charPositionInLine) {
            let t = new $j53rr.CommonToken(type, text, source, channel, start, stop);
            t.line = line;
            t.charPositionInLine = charPositionInLine;
            if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($gcfUE.Interval.of(start, stop));
            return t;
        }
        createSimple(type, text) {
            return new $j53rr.CommonToken(type, text);
        }
    }
    $c54a4863b793dbc8$var$__decorate([
        $d6D31.Override
    ], $c54a4863b793dbc8$var$CommonTokenFactory.prototype, "create", null);
    $c54a4863b793dbc8$var$__decorate([
        $d6D31.Override
    ], $c54a4863b793dbc8$var$CommonTokenFactory.prototype, "createSimple", null);
    module.exports.CommonTokenFactory = $c54a4863b793dbc8$var$CommonTokenFactory;
    (function(CommonTokenFactory) {
        CommonTokenFactory.DEFAULT = new CommonTokenFactory();
    })($c54a4863b793dbc8$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));
});
parcelRegister("j53rr", function(module, exports) {
    "use strict";
    var $de41275c931ca469$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $de41275c931ca469$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CommonToken = void 0;
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $de41275c931ca469$var$CommonToken = class CommonToken {
        constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $2DVsz.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
            this._line = 0;
            this._charPositionInLine = -1;
            this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
            this.index = -1;
            this._text = text;
            this._type = type;
            this.source = source;
            this._channel = channel;
            this.start = start;
            this.stop = stop;
            if (source.source != null) {
                this._line = source.source.line;
                this._charPositionInLine = source.source.charPositionInLine;
            }
        }
        static fromToken(oldToken) {
            let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
            result._line = oldToken.line;
            result.index = oldToken.tokenIndex;
            result._charPositionInLine = oldToken.charPositionInLine;
            if (oldToken instanceof CommonToken) {
                result._text = oldToken._text;
                result.source = oldToken.source;
            } else {
                result._text = oldToken.text;
                result.source = {
                    source: oldToken.tokenSource,
                    stream: oldToken.inputStream
                };
            }
            return result;
        }
        get type() {
            return this._type;
        }
        set type(type) {
            this._type = type;
        }
        get line() {
            return this._line;
        }
        set line(line) {
            this._line = line;
        }
        get text() {
            if (this._text != null) return this._text;
            let input = this.inputStream;
            if (input == null) return undefined;
            let n = input.size;
            if (this.start < n && this.stop < n) return input.getText($gcfUE.Interval.of(this.start, this.stop));
            else return "<EOF>";
        }
        set text(text) {
            this._text = text;
        }
        get charPositionInLine() {
            return this._charPositionInLine;
        }
        set charPositionInLine(charPositionInLine) {
            this._charPositionInLine = charPositionInLine;
        }
        get channel() {
            return this._channel;
        }
        set channel(channel) {
            this._channel = channel;
        }
        get startIndex() {
            return this.start;
        }
        set startIndex(start) {
            this.start = start;
        }
        get stopIndex() {
            return this.stop;
        }
        set stopIndex(stop) {
            this.stop = stop;
        }
        get tokenIndex() {
            return this.index;
        }
        set tokenIndex(index) {
            this.index = index;
        }
        get tokenSource() {
            return this.source.source;
        }
        get inputStream() {
            return this.source.stream;
        }
        toString(recognizer) {
            let channelStr = "";
            if (this._channel > 0) channelStr = ",channel=" + this._channel;
            let txt = this.text;
            if (txt != null) {
                txt = txt.replace(/\n/g, "\\n");
                txt = txt.replace(/\r/g, "\\r");
                txt = txt.replace(/\t/g, "\\t");
            } else txt = "<no text>";
            let typeString = String(this._type);
            if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
            return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
        }
    };
    $de41275c931ca469$var$CommonToken.EMPTY_SOURCE = {
        source: undefined,
        stream: undefined
    };
    $de41275c931ca469$var$__decorate([
        $d6D31.NotNull
    ], $de41275c931ca469$var$CommonToken.prototype, "source", void 0);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "type", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "line", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "text", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "charPositionInLine", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "channel", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "startIndex", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "stopIndex", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "tokenIndex", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "tokenSource", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "inputStream", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "toString", null);
    $de41275c931ca469$var$__decorate([
        $de41275c931ca469$var$__param(0, $d6D31.NotNull)
    ], $de41275c931ca469$var$CommonToken, "fromToken", null);
    $de41275c931ca469$var$CommonToken = $de41275c931ca469$var$__decorate([
        $de41275c931ca469$var$__param(2, $d6D31.NotNull)
    ], $de41275c931ca469$var$CommonToken);
    module.exports.CommonToken = $de41275c931ca469$var$CommonToken;
});
parcelRegister("2DVsz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Token = void 0;
    var $ceaEj = parcelRequire("ceaEj");
    var $1ecbcb9fde4eac7e$var$Token;
    (function(Token) {
        Token.INVALID_TYPE = 0;
        Token.EPSILON = -2;
        Token.MIN_USER_TOKEN_TYPE = 1;
        Token.EOF = $ceaEj.IntStream.EOF;
        Token.DEFAULT_CHANNEL = 0;
        Token.HIDDEN_CHANNEL = 1;
        Token.MIN_USER_CHANNEL_VALUE = 2;
    })($1ecbcb9fde4eac7e$var$Token = module.exports.Token || (module.exports.Token = {}));
});
parcelRegister("6Kebn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntegerStack = void 0;
    var $37SGk = parcelRequire("37SGk");
    class $4e920a4df7f4a425$var$IntegerStack extends $37SGk.IntegerList {
        constructor(arg){
            super(arg);
        }
        push(value) {
            this.add(value);
        }
        pop() {
            return this.removeAt(this.size - 1);
        }
        peek() {
            return this.get(this.size - 1);
        }
    }
    module.exports.IntegerStack = $4e920a4df7f4a425$var$IntegerStack;
});
parcelRegister("lQecE", function(module, exports) {
    "use strict";
    var $fe6978bd928c111b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $fe6978bd928c111b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerATNSimulator = void 0;
    var $41NTU = parcelRequire("41NTU");
    var $bcnvE = parcelRequire("bcnvE");
    var $gcX0f = parcelRequire("gcX0f");
    var $c1ClW = parcelRequire("c1ClW");
    var $kr9A1 = parcelRequire("kr9A1");
    var $2jevZ = parcelRequire("2jevZ");
    var $gcfUE = parcelRequire("gcfUE");
    var $ceaEj = parcelRequire("ceaEj");
    var $igNLf = parcelRequire("igNLf");
    var $3AYVu = parcelRequire("3AYVu");
    var $fOEQQ = parcelRequire("fOEQQ");
    var $d6D31 = parcelRequire("d6D31");
    var $9tIYC = parcelRequire("9tIYC");
    var $8DTT0 = parcelRequire("8DTT0");
    var $4kGBm = parcelRequire("4kGBm");
    var $2DVsz = parcelRequire("2DVsz");
    var $bbHFU = parcelRequire("bbHFU");
    let $fe6978bd928c111b$var$LexerATNSimulator = class LexerATNSimulator extends $kr9A1.ATNSimulator {
        constructor(atn, recog){
            super(atn);
            this.optimize_tail_calls = true;
            this.startIndex = -1;
            this._line = 1;
            this._charPositionInLine = 0;
            this.mode = $igNLf.Lexer.DEFAULT_MODE;
            this.prevAccept = new LexerATNSimulator.SimState();
            this.recog = recog;
        }
        copyState(simulator) {
            this._charPositionInLine = simulator.charPositionInLine;
            this._line = simulator._line;
            this.mode = simulator.mode;
            this.startIndex = simulator.startIndex;
        }
        match(input, mode) {
            this.mode = mode;
            let mark = input.mark();
            try {
                this.startIndex = input.index;
                this.prevAccept.reset();
                let s0 = this.atn.modeToDFA[mode].s0;
                if (s0 == null) return this.matchATN(input);
                else return this.execATN(input, s0);
            } finally{
                input.release(mark);
            }
        }
        reset() {
            this.prevAccept.reset();
            this.startIndex = -1;
            this._line = 1;
            this._charPositionInLine = 0;
            this.mode = $igNLf.Lexer.DEFAULT_MODE;
        }
        matchATN(input) {
            let startState = this.atn.modeToStartState[this.mode];
            if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
            let old_mode = this.mode;
            let s0_closure = this.computeStartState(input, startState);
            let suppressEdge = s0_closure.hasSemanticContext;
            if (suppressEdge) s0_closure.hasSemanticContext = false;
            let next = this.addDFAState(s0_closure);
            if (!suppressEdge) {
                let dfa = this.atn.modeToDFA[this.mode];
                if (!dfa.s0) dfa.s0 = next;
                else next = dfa.s0;
            }
            let predict = this.execATN(input, next);
            if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
            return predict;
        }
        execATN(input, ds0) {
            if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
            if (ds0.isAcceptState) this.captureSimState(this.prevAccept, input, ds0);
            let t = input.LA(1);
            let s = ds0;
            while(true){
                if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
                let target = this.getExistingTargetState(s, t);
                if (target == null) target = this.computeTargetState(input, s, t);
                if (target === $kr9A1.ATNSimulator.ERROR) break;
                if (t !== $ceaEj.IntStream.EOF) this.consume(input);
                if (target.isAcceptState) {
                    this.captureSimState(this.prevAccept, input, target);
                    if (t === $ceaEj.IntStream.EOF) break;
                }
                t = input.LA(1);
                s = target;
            }
            return this.failOrAccept(this.prevAccept, input, s.configs, t);
        }
        getExistingTargetState(s, t) {
            let target = s.getTarget(t);
            if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
            return target;
        }
        computeTargetState(input, s, t) {
            let reach = new $9tIYC.OrderedATNConfigSet();
            this.getReachableConfigSet(input, s.configs, reach, t);
            if (reach.isEmpty) {
                if (!reach.hasSemanticContext) this.addDFAEdge(s, t, $kr9A1.ATNSimulator.ERROR);
                return $kr9A1.ATNSimulator.ERROR;
            }
            return this.addDFAEdge(s, t, reach);
        }
        failOrAccept(prevAccept, input, reach, t) {
            if (prevAccept.dfaState != null) {
                let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
                this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
                return prevAccept.dfaState.prediction;
            } else {
                if (t === $ceaEj.IntStream.EOF && input.index === this.startIndex) return $2DVsz.Token.EOF;
                throw new $fOEQQ.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
            }
        }
        getReachableConfigSet(input, closure, reach, t) {
            let skipAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            for (let c of closure){
                let currentAltReachedAcceptState = c.alt === skipAlt;
                if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
                if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(trans, t);
                    if (target != null) {
                        let lexerActionExecutor = c.lexerActionExecutor;
                        let config;
                        if (lexerActionExecutor != null) {
                            lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                            config = c.transform(target, true, lexerActionExecutor);
                        } else {
                            $bbHFU(c.lexerActionExecutor == null);
                            config = c.transform(target, true);
                        }
                        let treatEofAsEpsilon = t === $ceaEj.IntStream.EOF;
                        if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                            skipAlt = c.alt;
                            break;
                        }
                    }
                }
            }
        }
        accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
            if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
            input.seek(index);
            this._line = line;
            this._charPositionInLine = charPos;
            if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
        }
        getReachableTarget(trans, t) {
            if (trans.matches(t, $igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE)) return trans.target;
            return undefined;
        }
        computeStartState(input, p) {
            let initialContext = $8DTT0.PredictionContext.EMPTY_FULL;
            let configs = new $9tIYC.OrderedATNConfigSet();
            for(let i = 0; i < p.numberOfTransitions; i++){
                let target = p.transition(i).target;
                let c = $gcX0f.ATNConfig.create(target, i + 1, initialContext);
                this.closure(input, c, configs, false, false, false);
            }
            return configs;
        }
        closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
            if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
            if (config.state instanceof $4kGBm.RuleStopState) {
                if (LexerATNSimulator.debug) {
                    if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                    else console.log(`closure at rule stop ${config}`);
                }
                let context = config.context;
                if (context.isEmpty) {
                    configs.add(config);
                    return true;
                } else if (context.hasEmpty) {
                    configs.add(config.transform(config.state, true, $8DTT0.PredictionContext.EMPTY_FULL));
                    currentAltReachedAcceptState = true;
                }
                for(let i = 0; i < context.size; i++){
                    let returnStateNumber = context.getReturnState(i);
                    if (returnStateNumber === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let newContext = context.getParent(i);
                    let returnState = this.atn.states[returnStateNumber];
                    let c = config.transform(returnState, false, newContext);
                    currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
                }
                return currentAltReachedAcceptState;
            }
            if (!config.state.onlyHasEpsilonTransitions) {
                if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
            }
            let p = config.state;
            for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
                let t = p.getOptimizedTransition(i);
                let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
                if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
            let c;
            switch(t.serializationType){
                case 3:
                    let ruleTransition = t;
                    if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                    else {
                        let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                        c = config.transform(t.target, true, newContext);
                    }
                    break;
                case 10:
                    throw new Error("Precedence predicates are not supported in lexers.");
                case 4:
                    let pt = t;
                    if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                    configs.hasSemanticContext = true;
                    if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                    else c = undefined;
                    break;
                case 6:
                    if (config.context.hasEmpty) {
                        let lexerActionExecutor = $3AYVu.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                        c = config.transform(t.target, true, lexerActionExecutor);
                        break;
                    } else {
                        c = config.transform(t.target, true);
                        break;
                    }
                case 1:
                    c = config.transform(t.target, true);
                    break;
                case 5:
                case 2:
                case 7:
                    if (treatEofAsEpsilon) {
                        if (t.matches($ceaEj.IntStream.EOF, $igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE)) {
                            c = config.transform(t.target, false);
                            break;
                        }
                    }
                    c = undefined;
                    break;
                default:
                    c = undefined;
                    break;
            }
            return c;
        }
        evaluatePredicate(input, ruleIndex, predIndex, speculative) {
            if (this.recog == null) return true;
            if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
            let savedCharPositionInLine = this._charPositionInLine;
            let savedLine = this._line;
            let index = input.index;
            let marker = input.mark();
            try {
                this.consume(input);
                return this.recog.sempred(undefined, ruleIndex, predIndex);
            } finally{
                this._charPositionInLine = savedCharPositionInLine;
                this._line = savedLine;
                input.seek(index);
                input.release(marker);
            }
        }
        captureSimState(settings, input, dfaState) {
            settings.index = input.index;
            settings.line = this._line;
            settings.charPos = this._charPositionInLine;
            settings.dfaState = dfaState;
        }
        addDFAEdge(p, t, q) {
            if (q instanceof $c1ClW.ATNConfigSet) {
                let suppressEdge = q.hasSemanticContext;
                if (suppressEdge) q.hasSemanticContext = false;
                let to = this.addDFAState(q);
                if (suppressEdge) return to;
                this.addDFAEdge(p, t, to);
                return to;
            } else {
                if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
                if (p != null) p.setTarget(t, q);
            }
        }
        addDFAState(configs) {
            $bbHFU(!configs.hasSemanticContext);
            let proposed = new $2jevZ.DFAState(configs);
            let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
            if (existing != null) return existing;
            configs.optimizeConfigs(this);
            let newState = new $2jevZ.DFAState(configs.clone(true));
            let firstConfigWithRuleStopState;
            for (let c of configs)if (c.state instanceof $4kGBm.RuleStopState) {
                firstConfigWithRuleStopState = c;
                break;
            }
            if (firstConfigWithRuleStopState != null) {
                let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
                let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
                newState.acceptStateInfo = new $41NTU.AcceptStateInfo(prediction, lexerActionExecutor);
            }
            return this.atn.modeToDFA[this.mode].addState(newState);
        }
        getDFA(mode) {
            return this.atn.modeToDFA[mode];
        }
        getText(input) {
            return input.getText($gcfUE.Interval.of(this.startIndex, input.index - 1));
        }
        get line() {
            return this._line;
        }
        set line(line) {
            this._line = line;
        }
        get charPositionInLine() {
            return this._charPositionInLine;
        }
        set charPositionInLine(charPositionInLine) {
            this._charPositionInLine = charPositionInLine;
        }
        consume(input) {
            let curChar = input.LA(1);
            if (curChar === "\n".charCodeAt(0)) {
                this._line++;
                this._charPositionInLine = 0;
            } else this._charPositionInLine++;
            input.consume();
        }
        getTokenName(t) {
            if (t === -1) return "EOF";
            return "'" + String.fromCharCode(t) + "'";
        }
    };
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "prevAccept", void 0);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "copyState", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "match", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.Override
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "reset", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "matchATN", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "execATN", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "computeTargetState", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "accept", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "computeStartState", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "closure", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(3, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "captureSimState", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "addDFAState", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getDFA", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getText", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "consume", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getTokenName", null);
    $fe6978bd928c111b$var$LexerATNSimulator = $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator);
    module.exports.LexerATNSimulator = $fe6978bd928c111b$var$LexerATNSimulator;
    (function(LexerATNSimulator) {
        LexerATNSimulator.debug = false;
        LexerATNSimulator.dfa_debug = false;
        class SimState {
            constructor(){
                this.index = -1;
                this.line = 0;
                this.charPos = -1;
            }
            reset() {
                this.index = -1;
                this.line = 0;
                this.charPos = -1;
                this.dfaState = undefined;
            }
        }
        LexerATNSimulator.SimState = SimState;
    })($fe6978bd928c111b$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
    module.exports.LexerATNSimulator = $fe6978bd928c111b$var$LexerATNSimulator;
});
parcelRegister("41NTU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.AcceptStateInfo = void 0;
    class $2eedf6a56837c02c$var$AcceptStateInfo {
        constructor(prediction, lexerActionExecutor){
            this._prediction = prediction;
            this._lexerActionExecutor = lexerActionExecutor;
        }
        get prediction() {
            return this._prediction;
        }
        get lexerActionExecutor() {
            return this._lexerActionExecutor;
        }
    }
    module.exports.AcceptStateInfo = $2eedf6a56837c02c$var$AcceptStateInfo;
});
parcelRegister("bcnvE", function(module, exports) {
    "use strict";
    var $82730d2c6766359c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $82730d2c6766359c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATN = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $jJRyp = parcelRequire("jJRyp");
    var $hGRod = parcelRequire("hGRod");
    var $l4Nh1 = parcelRequire("l4Nh1");
    var $iiE1V = parcelRequire("iiE1V");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $2DVsz = parcelRequire("2DVsz");
    var $bbHFU = parcelRequire("bbHFU");
    let $82730d2c6766359c$var$ATN = class ATN {
        constructor(grammarType, maxTokenType){
            this.states = [];
            this.decisionToState = [];
            this.modeNameToStartState = new Map();
            this.modeToStartState = [];
            this.contextCache = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.decisionToDFA = [];
            this.modeToDFA = [];
            this.LL1Table = new Map();
            this.grammarType = grammarType;
            this.maxTokenType = maxTokenType;
        }
        clearDFA() {
            this.decisionToDFA = new Array(this.decisionToState.length);
            for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $jJRyp.DFA(this.decisionToState[i], i);
            this.modeToDFA = new Array(this.modeToStartState.length);
            for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $jJRyp.DFA(this.modeToStartState[i]);
            this.contextCache.clear();
            this.LL1Table.clear();
        }
        get contextCacheSize() {
            return this.contextCache.size;
        }
        getCachedContext(context) {
            return $8DTT0.PredictionContext.getCachedContext(context, this.contextCache, new $8DTT0.PredictionContext.IdentityHashMap());
        }
        getDecisionToDFA() {
            $bbHFU(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
            return this.decisionToDFA;
        }
        nextTokens(s, ctx) {
            if (ctx) {
                let anal = new $iiE1V.LL1Analyzer(this);
                let next = anal.LOOK(s, ctx);
                return next;
            } else {
                if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
                s.nextTokenWithinRule = this.nextTokens(s, $8DTT0.PredictionContext.EMPTY_LOCAL);
                s.nextTokenWithinRule.setReadonly(true);
                return s.nextTokenWithinRule;
            }
        }
        addState(state) {
            state.atn = this;
            state.stateNumber = this.states.length;
            this.states.push(state);
        }
        removeState(state) {
            let invalidState = new $l4Nh1.InvalidState();
            invalidState.atn = this;
            invalidState.stateNumber = state.stateNumber;
            this.states[state.stateNumber] = invalidState;
        }
        defineMode(name, s) {
            this.modeNameToStartState.set(name, s);
            this.modeToStartState.push(s);
            this.modeToDFA.push(new $jJRyp.DFA(s));
            this.defineDecisionState(s);
        }
        defineDecisionState(s) {
            this.decisionToState.push(s);
            s.decision = this.decisionToState.length - 1;
            this.decisionToDFA.push(new $jJRyp.DFA(s, s.decision));
            return s.decision;
        }
        getDecisionState(decision) {
            if (this.decisionToState.length > 0) return this.decisionToState[decision];
            return undefined;
        }
        get numberOfDecisions() {
            return this.decisionToState.length;
        }
        getExpectedTokens(stateNumber, context) {
            if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
            let ctx = context;
            let s = this.states[stateNumber];
            let following = this.nextTokens(s);
            if (!following.contains($2DVsz.Token.EPSILON)) return following;
            let expected = new $hGRod.IntervalSet();
            expected.addAll(following);
            expected.remove($2DVsz.Token.EPSILON);
            while(ctx != null && ctx.invokingState >= 0 && following.contains($2DVsz.Token.EPSILON)){
                let invokingState = this.states[ctx.invokingState];
                let rt = invokingState.transition(0);
                following = this.nextTokens(rt.followState);
                expected.addAll(following);
                expected.remove($2DVsz.Token.EPSILON);
                ctx = ctx._parent;
            }
            if (following.contains($2DVsz.Token.EPSILON)) expected.add($2DVsz.Token.EOF);
            return expected;
        }
    };
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "states", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "decisionToState", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "modeNameToStartState", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "modeToStartState", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "decisionToDFA", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "modeToDFA", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "nextTokens", null);
    $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN.prototype, "removeState", null);
    $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull),
        $82730d2c6766359c$var$__param(1, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN.prototype, "defineMode", null);
    $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN.prototype, "defineDecisionState", null);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "getExpectedTokens", null);
    $82730d2c6766359c$var$ATN = $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN);
    module.exports.ATN = $82730d2c6766359c$var$ATN;
    (function(ATN) {
        ATN.INVALID_ALT_NUMBER = 0;
    })($82730d2c6766359c$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
    module.exports.ATN = $82730d2c6766359c$var$ATN;
});
parcelRegister("fP17P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Array2DHashMap = void 0;
    var $7Veax = parcelRequire("7Veax");
    class $b84c7de35a10478c$var$MapKeyEqualityComparator {
        constructor(keyComparator){
            this.keyComparator = keyComparator;
        }
        hashCode(obj) {
            return this.keyComparator.hashCode(obj.key);
        }
        equals(a, b) {
            return this.keyComparator.equals(a.key, b.key);
        }
    }
    class $b84c7de35a10478c$var$Array2DHashMap {
        constructor(keyComparer){
            if (keyComparer instanceof $b84c7de35a10478c$var$Array2DHashMap) this.backingStore = new $7Veax.Array2DHashSet(keyComparer.backingStore);
            else this.backingStore = new $7Veax.Array2DHashSet(new $b84c7de35a10478c$var$MapKeyEqualityComparator(keyComparer));
        }
        clear() {
            this.backingStore.clear();
        }
        containsKey(key) {
            return this.backingStore.contains({
                key: key
            });
        }
        get(key) {
            let bucket = this.backingStore.get({
                key: key
            });
            if (!bucket) return undefined;
            return bucket.value;
        }
        get isEmpty() {
            return this.backingStore.isEmpty;
        }
        put(key, value) {
            let element = this.backingStore.get({
                key: key,
                value: value
            });
            let result;
            if (!element) this.backingStore.add({
                key: key,
                value: value
            });
            else {
                result = element.value;
                element.value = value;
            }
            return result;
        }
        putIfAbsent(key, value) {
            let element = this.backingStore.get({
                key: key,
                value: value
            });
            let result;
            if (!element) this.backingStore.add({
                key: key,
                value: value
            });
            else result = element.value;
            return result;
        }
        get size() {
            return this.backingStore.size;
        }
        hashCode() {
            return this.backingStore.hashCode();
        }
        equals(o) {
            if (!(o instanceof $b84c7de35a10478c$var$Array2DHashMap)) return false;
            return this.backingStore.equals(o.backingStore);
        }
    }
    module.exports.Array2DHashMap = $b84c7de35a10478c$var$Array2DHashMap;
});
parcelRegister("jJRyp", function(module, exports) {
    "use strict";
    var $e5ebc30517b3d229$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $e5ebc30517b3d229$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DFA = void 0;
    var $7Veax = parcelRequire("7Veax");
    var $c1ClW = parcelRequire("c1ClW");
    var $yhTtv = parcelRequire("yhTtv");
    var $2jevZ = parcelRequire("2jevZ");
    var $aeRGo = parcelRequire("aeRGo");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $f9raX = parcelRequire("f9raX");
    var $3n2FE = parcelRequire("3n2FE");
    let $e5ebc30517b3d229$var$DFA = class DFA {
        constructor(atnStartState, decision = 0){
            this.states = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.nextStateNumber = 0;
            if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
            this.atnStartState = atnStartState;
            this.atn = atnStartState.atn;
            this.decision = decision;
            let isPrecedenceDfa = false;
            if (atnStartState instanceof $f9raX.StarLoopEntryState) {
                if (atnStartState.precedenceRuleDecision) {
                    isPrecedenceDfa = true;
                    this.s0 = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                    this.s0full = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                }
            }
            this.precedenceDfa = isPrecedenceDfa;
        }
        get isPrecedenceDfa() {
            return this.precedenceDfa;
        }
        getPrecedenceStartState(precedence, fullContext) {
            if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
            if (fullContext) return this.s0full.getTarget(precedence);
            else return this.s0.getTarget(precedence);
        }
        setPrecedenceStartState(precedence, fullContext, startState) {
            if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
            if (precedence < 0) return;
            if (fullContext) this.s0full.setTarget(precedence, startState);
            else this.s0.setTarget(precedence, startState);
        }
        get isEmpty() {
            if (this.isPrecedenceDfa) return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
            return this.s0 == null && this.s0full == null;
        }
        get isContextSensitive() {
            if (this.isPrecedenceDfa) return this.s0full.getEdgeMap().size > 0;
            return this.s0full != null;
        }
        addState(state) {
            state.stateNumber = this.nextStateNumber++;
            return this.states.getOrAdd(state);
        }
        toString(vocabulary, ruleNames) {
            if (!vocabulary) vocabulary = $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
            if (!this.s0) return "";
            let serializer;
            if (ruleNames) serializer = new $yhTtv.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
            else serializer = new $yhTtv.DFASerializer(this, vocabulary);
            return serializer.toString();
        }
        toLexerString() {
            if (!this.s0) return "";
            let serializer = new $aeRGo.LexerDFASerializer(this);
            return serializer.toString();
        }
    };
    $e5ebc30517b3d229$var$__decorate([
        $d6D31.NotNull
    ], $e5ebc30517b3d229$var$DFA.prototype, "states", void 0);
    $e5ebc30517b3d229$var$__decorate([
        $d6D31.NotNull
    ], $e5ebc30517b3d229$var$DFA.prototype, "atnStartState", void 0);
    $e5ebc30517b3d229$var$__decorate([
        $d6D31.NotNull
    ], $e5ebc30517b3d229$var$DFA.prototype, "atn", void 0);
    $e5ebc30517b3d229$var$DFA = $e5ebc30517b3d229$var$__decorate([
        $e5ebc30517b3d229$var$__param(0, $d6D31.NotNull)
    ], $e5ebc30517b3d229$var$DFA);
    module.exports.DFA = $e5ebc30517b3d229$var$DFA;
});
parcelRegister("c1ClW", function(module, exports) {
    "use strict";
    var $8c13542112ebfd78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNConfigSet = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $7Veax = parcelRequire("7Veax");
    var $3sNxf = parcelRequire("3sNxf");
    var $bcnvE = parcelRequire("bcnvE");
    var $gcX0f = parcelRequire("gcX0f");
    var $5BPMp = parcelRequire("5BPMp");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $6vF7J = parcelRequire("6vF7J");
    var $eHMgW = parcelRequire("eHMgW");
    var $bbHFU = parcelRequire("bbHFU");
    var $2IEP9 = parcelRequire("2IEP9");
    class $8c13542112ebfd78$var$KeyTypeEqualityComparer {
        hashCode(key) {
            return key.state ^ key.alt;
        }
        equals(a, b) {
            return a.state === b.state && a.alt === b.alt;
        }
    }
    $8c13542112ebfd78$var$KeyTypeEqualityComparer.INSTANCE = new $8c13542112ebfd78$var$KeyTypeEqualityComparer();
    function $8c13542112ebfd78$var$NewKeyedConfigMap(map) {
        if (map) return new $fP17P.Array2DHashMap(map);
        else return new $fP17P.Array2DHashMap($8c13542112ebfd78$var$KeyTypeEqualityComparer.INSTANCE);
    }
    class $8c13542112ebfd78$var$ATNConfigSet {
        constructor(set, readonly){
            this._uniqueAlt = 0;
            this._hasSemanticContext = false;
            this._dipsIntoOuterContext = false;
            this.outermostConfigSet = false;
            this.cachedHashCode = -1;
            if (!set) {
                this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap();
                this.unmerged = [];
                this.configs = [];
                this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            } else {
                if (readonly) {
                    this.mergedConfigs = undefined;
                    this.unmerged = undefined;
                } else if (!set.isReadOnly) {
                    this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap(set.mergedConfigs);
                    this.unmerged = set.unmerged.slice(0);
                } else {
                    this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap();
                    this.unmerged = [];
                }
                this.configs = set.configs.slice(0);
                this._dipsIntoOuterContext = set._dipsIntoOuterContext;
                this._hasSemanticContext = set._hasSemanticContext;
                this.outermostConfigSet = set.outermostConfigSet;
                if (readonly || !set.isReadOnly) {
                    this._uniqueAlt = set._uniqueAlt;
                    this._conflictInfo = set._conflictInfo;
                }
            }
        }
        getRepresentedAlternatives() {
            if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
            let alts = new $5BPMp.BitSet();
            for (let config of this)alts.set(config.alt);
            return alts;
        }
        get isReadOnly() {
            return this.mergedConfigs == null;
        }
        get isOutermostConfigSet() {
            return this.outermostConfigSet;
        }
        set isOutermostConfigSet(outermostConfigSet) {
            if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
            $bbHFU(!outermostConfigSet || !this._dipsIntoOuterContext);
            this.outermostConfigSet = outermostConfigSet;
        }
        getStates() {
            let states = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            for (let c of this.configs)states.add(c.state);
            return states;
        }
        optimizeConfigs(interpreter) {
            if (this.configs.length === 0) return;
            for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
        }
        clone(readonly) {
            let copy = new $8c13542112ebfd78$var$ATNConfigSet(this, readonly);
            if (!readonly && this.isReadOnly) copy.addAll(this.configs);
            return copy;
        }
        get size() {
            return this.configs.length;
        }
        get isEmpty() {
            return this.configs.length === 0;
        }
        contains(o) {
            if (!(o instanceof $gcX0f.ATNConfig)) return false;
            if (this.mergedConfigs && this.unmerged) {
                let config = o;
                let configKey = this.getKey(config);
                let mergedConfig = this.mergedConfigs.get(configKey);
                if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
                for (let c of this.unmerged){
                    if (c.contains(o)) return true;
                }
            } else for (let c of this.configs){
                if (c.contains(o)) return true;
            }
            return false;
        }
        *[Symbol.iterator]() {
            yield* this.configs;
        }
        toArray() {
            return this.configs;
        }
        add(e, contextCache) {
            this.ensureWritable();
            if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
            $bbHFU(!this.outermostConfigSet || !e.reachesIntoOuterContext);
            if (contextCache == null) contextCache = $6vF7J.PredictionContextCache.UNCACHED;
            let addKey;
            let key = this.getKey(e);
            let mergedConfig = this.mergedConfigs.get(key);
            addKey = mergedConfig == null;
            if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
                mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $8DTT0.PredictionContext.join(mergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (mergedConfig.context === joined) return false;
                mergedConfig.context = joined;
                return true;
            }
            for(let i = 0; i < this.unmerged.length; i++){
                let unmergedConfig = this.unmerged[i];
                if (this.canMerge(e, key, unmergedConfig)) {
                    unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                    if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                    let joined = $8DTT0.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                    this.updatePropertiesForMergedConfig(e);
                    if (unmergedConfig.context === joined) return false;
                    unmergedConfig.context = joined;
                    if (addKey) {
                        this.mergedConfigs.put(key, unmergedConfig);
                        this.unmerged.splice(i, 1);
                    }
                    return true;
                }
            }
            this.configs.push(e);
            if (addKey) this.mergedConfigs.put(key, e);
            else this.unmerged.push(e);
            this.updatePropertiesForAddedConfig(e);
            return true;
        }
        updatePropertiesForMergedConfig(config) {
            this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
            $bbHFU(!this.outermostConfigSet || !this._dipsIntoOuterContext);
        }
        updatePropertiesForAddedConfig(config) {
            if (this.configs.length === 1) this._uniqueAlt = config.alt;
            else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            this._hasSemanticContext = this._hasSemanticContext || !$eHMgW.SemanticContext.NONE.equals(config.semanticContext);
            this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
            $bbHFU(!this.outermostConfigSet || !this._dipsIntoOuterContext);
        }
        canMerge(left, leftKey, right) {
            if (left.state.stateNumber !== right.state.stateNumber) return false;
            if (leftKey.alt !== right.alt) return false;
            return left.semanticContext.equals(right.semanticContext);
        }
        getKey(e) {
            return {
                state: e.state.stateNumber,
                alt: e.alt
            };
        }
        containsAll(c) {
            for (let o of c){
                if (!(o instanceof $gcX0f.ATNConfig)) return false;
                if (!this.contains(o)) return false;
            }
            return true;
        }
        addAll(c, contextCache) {
            this.ensureWritable();
            let changed = false;
            for (let group of c)if (this.add(group, contextCache)) changed = true;
            return changed;
        }
        clear() {
            this.ensureWritable();
            if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
            this.mergedConfigs.clear();
            this.unmerged.length = 0;
            this.configs.length = 0;
            this._dipsIntoOuterContext = false;
            this._hasSemanticContext = false;
            this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            this._conflictInfo = undefined;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof $8c13542112ebfd78$var$ATNConfigSet)) return false;
            return this.outermostConfigSet === obj.outermostConfigSet && $2IEP9.equals(this._conflictInfo, obj._conflictInfo) && $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
        }
        hashCode() {
            if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
            let hashCode = 1;
            hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
            hashCode = 5 * hashCode ^ $3sNxf.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
            if (this.isReadOnly) this.cachedHashCode = hashCode;
            return hashCode;
        }
        toString(showContext) {
            if (showContext == null) showContext = false;
            let buf = "";
            let sortedConfigs = this.configs.slice(0);
            sortedConfigs.sort((o1, o2)=>{
                if (o1.alt !== o2.alt) return o1.alt - o2.alt;
                else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
                else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
            });
            buf += "[";
            for(let i = 0; i < sortedConfigs.length; i++){
                if (i > 0) buf += ", ";
                buf += sortedConfigs[i].toString(undefined, true, showContext);
            }
            buf += "]";
            if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
            if (this._uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
            if (this._conflictInfo != null) {
                buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
                if (!this._conflictInfo.isExact) buf += "*";
            }
            if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
            return buf.toString();
        }
        get uniqueAlt() {
            return this._uniqueAlt;
        }
        get hasSemanticContext() {
            return this._hasSemanticContext;
        }
        set hasSemanticContext(value) {
            this.ensureWritable();
            this._hasSemanticContext = value;
        }
        get conflictInfo() {
            return this._conflictInfo;
        }
        set conflictInfo(conflictInfo) {
            this.ensureWritable();
            this._conflictInfo = conflictInfo;
        }
        get conflictingAlts() {
            if (this._conflictInfo == null) return undefined;
            return this._conflictInfo.conflictedAlts;
        }
        get isExactConflict() {
            if (this._conflictInfo == null) return false;
            return this._conflictInfo.isExact;
        }
        get dipsIntoOuterContext() {
            return this._dipsIntoOuterContext;
        }
        get(index) {
            return this.configs[index];
        }
        ensureWritable() {
            if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
        }
    }
    $8c13542112ebfd78$var$__decorate([
        $d6D31.NotNull
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "size", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "isEmpty", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "contains", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, Symbol.iterator, null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "toArray", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "containsAll", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "clear", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "equals", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "hashCode", null);
    module.exports.ATNConfigSet = $8c13542112ebfd78$var$ATNConfigSet;
});
parcelRegister("gcX0f", function(module, exports) {
    "use strict";
    var $bccb89124e8dfda2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $bccb89124e8dfda2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNConfig = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $dPYn6 = parcelRequire("dPYn6");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $eHMgW = parcelRequire("eHMgW");
    var $bbHFU = parcelRequire("bbHFU");
    const $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
    let $bccb89124e8dfda2$var$ATNConfig = class ATNConfig {
        constructor(state, altOrConfig, context){
            if (typeof altOrConfig === "number") {
                $bbHFU((altOrConfig & 0xFFFFFF) === altOrConfig);
                this._state = state;
                this.altAndOuterContextDepth = altOrConfig;
                this._context = context;
            } else {
                this._state = state;
                this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
                this._context = context;
            }
        }
        static create(state, alt, context, semanticContext = $eHMgW.SemanticContext.NONE, lexerActionExecutor) {
            if (semanticContext !== $eHMgW.SemanticContext.NONE) {
                if (lexerActionExecutor != null) return new $bccb89124e8dfda2$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
                else return new $bccb89124e8dfda2$var$SemanticContextATNConfig(semanticContext, state, alt, context);
            } else if (lexerActionExecutor != null) return new $bccb89124e8dfda2$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
            else return new ATNConfig(state, alt, context);
        }
        get state() {
            return this._state;
        }
        get alt() {
            return this.altAndOuterContextDepth & 0x00FFFFFF;
        }
        get context() {
            return this._context;
        }
        set context(context) {
            this._context = context;
        }
        get reachesIntoOuterContext() {
            return this.outerContextDepth !== 0;
        }
        get outerContextDepth() {
            return this.altAndOuterContextDepth >>> 24 & 0x7F;
        }
        set outerContextDepth(outerContextDepth) {
            $bbHFU(outerContextDepth >= 0);
            outerContextDepth = Math.min(outerContextDepth, 0x7F);
            this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
        }
        get lexerActionExecutor() {
            return undefined;
        }
        get semanticContext() {
            return $eHMgW.SemanticContext.NONE;
        }
        get hasPassedThroughNonGreedyDecision() {
            return false;
        }
        clone() {
            return this.transform(this.state, false);
        }
        transform(state, checkNonGreedy, arg2) {
            if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
            else if (arg2 instanceof $8DTT0.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
            else if (arg2 instanceof $eHMgW.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
            else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
        }
        transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
            let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
            if (semanticContext !== $eHMgW.SemanticContext.NONE) {
                if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bccb89124e8dfda2$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
                else return new $bccb89124e8dfda2$var$SemanticContextATNConfig(semanticContext, state, this, context);
            } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bccb89124e8dfda2$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
            else return new ATNConfig(state, this, context);
        }
        static checkNonGreedyDecision(source, target) {
            return source.hasPassedThroughNonGreedyDecision || target instanceof $dPYn6.DecisionState && target.nonGreedy;
        }
        appendContext(context, contextCache) {
            if (typeof context === "number") {
                let appendedContext = this.context.appendSingleContext(context, contextCache);
                let result = this.transform(this.state, false, appendedContext);
                return result;
            } else {
                let appendedContext = this.context.appendContext(context, contextCache);
                let result = this.transform(this.state, false, appendedContext);
                return result;
            }
        }
        contains(subconfig) {
            if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
            let leftWorkList = [];
            let rightWorkList = [];
            leftWorkList.push(this.context);
            rightWorkList.push(subconfig.context);
            while(true){
                let left = leftWorkList.pop();
                let right = rightWorkList.pop();
                if (!left || !right) break;
                if (left === right) return true;
                if (left.size < right.size) return false;
                if (right.isEmpty) return left.hasEmpty;
                else for(let i = 0; i < right.size; i++){
                    let index = left.findReturnState(right.getReturnState(i));
                    if (index < 0) return false;
                    leftWorkList.push(left.getParent(index));
                    rightWorkList.push(right.getParent(i));
                }
            }
            return false;
        }
        get isPrecedenceFilterSuppressed() {
            return (this.altAndOuterContextDepth & $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
        }
        set isPrecedenceFilterSuppressed(value) {
            if (value) this.altAndOuterContextDepth |= $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER;
            else this.altAndOuterContextDepth &= ~$bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER;
        }
        equals(o) {
            if (this === o) return true;
            else if (!(o instanceof ATNConfig)) return false;
            return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $a4Flx.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
        }
        hashCode() {
            let hashCode = $iXFjm.MurmurHash.initialize(7);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.state.stateNumber);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.alt);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.context);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.semanticContext);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.lexerActionExecutor);
            hashCode = $iXFjm.MurmurHash.finish(hashCode, 7);
            return hashCode;
        }
        toDotString() {
            let builder = "";
            builder += "digraph G {\n";
            builder += "rankdir=LR;\n";
            let visited = new $fP17P.Array2DHashMap($8DTT0.PredictionContext.IdentityEqualityComparator.INSTANCE);
            let workList = [];
            function getOrAddContext(context) {
                let newNumber = visited.size;
                let result = visited.putIfAbsent(context, newNumber);
                if (result != null) return result;
                workList.push(context);
                return newNumber;
            }
            workList.push(this.context);
            visited.put(this.context, 0);
            while(true){
                let current = workList.pop();
                if (!current) break;
                for(let i = 0; i < current.size; i++){
                    builder += "  s" + getOrAddContext(current);
                    builder += "->";
                    builder += "s" + getOrAddContext(current.getParent(i));
                    builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
                }
            }
            builder += "}\n";
            return builder.toString();
        }
        toString(recog, showAlt, showContext) {
            if (showContext == null) showContext = showAlt != null;
            if (showAlt == null) showAlt = true;
            let buf = "";
            let contexts;
            if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
            else contexts = [
                "?"
            ];
            let first = true;
            for (let contextDesc of contexts){
                if (first) first = false;
                else buf += ", ";
                buf += "(";
                buf += this.state;
                if (showAlt) {
                    buf += ",";
                    buf += this.alt;
                }
                if (this.context) {
                    buf += ",";
                    buf += contextDesc;
                }
                if (this.semanticContext !== $eHMgW.SemanticContext.NONE) {
                    buf += ",";
                    buf += this.semanticContext;
                }
                if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
                buf += ")";
            }
            return buf.toString();
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "_state", void 0);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "_context", void 0);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "state", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull,
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "context", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "semanticContext", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "clone", null);
    $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "transformImpl", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "equals", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "hashCode", null);
    $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(3, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig, "create", null);
    $bccb89124e8dfda2$var$ATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig);
    module.exports.ATNConfig = $bccb89124e8dfda2$var$ATNConfig;
    let $bccb89124e8dfda2$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $bccb89124e8dfda2$var$ATNConfig {
        constructor(semanticContext, state, altOrConfig, context){
            if (typeof altOrConfig === "number") super(state, altOrConfig, context);
            else super(state, altOrConfig, context);
            this._semanticContext = semanticContext;
        }
        get semanticContext() {
            return this._semanticContext;
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$SemanticContextATNConfig.prototype, "semanticContext", null);
    $bccb89124e8dfda2$var$SemanticContextATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$SemanticContextATNConfig);
    let $bccb89124e8dfda2$var$ActionATNConfig = class ActionATNConfig extends $bccb89124e8dfda2$var$ATNConfig {
        constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
            if (typeof altOrConfig === "number") super(state, altOrConfig, context);
            else {
                super(state, altOrConfig, context);
                if (altOrConfig.semanticContext !== $eHMgW.SemanticContext.NONE) throw new Error("Not supported");
            }
            this._lexerActionExecutor = lexerActionExecutor;
            this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
        }
        get lexerActionExecutor() {
            return this._lexerActionExecutor;
        }
        get hasPassedThroughNonGreedyDecision() {
            return this.passedThroughNonGreedyDecision;
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
    $bccb89124e8dfda2$var$ActionATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ActionATNConfig);
    let $bccb89124e8dfda2$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $bccb89124e8dfda2$var$SemanticContextATNConfig {
        constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
            if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
            else super(semanticContext, state, altOrConfig, context);
            this._lexerActionExecutor = lexerActionExecutor;
            this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
        }
        get lexerActionExecutor() {
            return this._lexerActionExecutor;
        }
        get hasPassedThroughNonGreedyDecision() {
            return this.passedThroughNonGreedyDecision;
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
    $bccb89124e8dfda2$var$ActionSemanticContextATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig);
});
parcelRegister("dPYn6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DecisionState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    class $a12ede58b33ddcba$var$DecisionState extends $7j0Pc.ATNState {
        constructor(){
            super(...arguments);
            this.decision = -1;
            this.nonGreedy = false;
            this.sll = false;
        }
    }
    module.exports.DecisionState = $a12ede58b33ddcba$var$DecisionState;
});
parcelRegister("8DTT0", function(module, exports) {
    "use strict";
    var $64ad510fde44ff92$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $64ad510fde44ff92$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $7Veax = parcelRequire("7Veax");
    var $9yG1X = parcelRequire("9yG1X");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $6vF7J = parcelRequire("6vF7J");
    var $bbHFU = parcelRequire("bbHFU");
    const $64ad510fde44ff92$var$INITIAL_HASH = 1;
    class $64ad510fde44ff92$var$PredictionContext {
        constructor(cachedHashCode){
            this.cachedHashCode = cachedHashCode;
        }
        static calculateEmptyHashCode() {
            let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
            hash = $iXFjm.MurmurHash.finish(hash, 0);
            return hash;
        }
        static calculateSingleHashCode(parent, returnState) {
            let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
            hash = $iXFjm.MurmurHash.update(hash, parent);
            hash = $iXFjm.MurmurHash.update(hash, returnState);
            hash = $iXFjm.MurmurHash.finish(hash, 2);
            return hash;
        }
        static calculateHashCode(parents, returnStates) {
            let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
            for (let parent of parents)hash = $iXFjm.MurmurHash.update(hash, parent);
            for (let returnState of returnStates)hash = $iXFjm.MurmurHash.update(hash, returnState);
            hash = $iXFjm.MurmurHash.finish(hash, 2 * parents.length);
            return hash;
        }
        static fromRuleContext(atn, outerContext, fullContext = true) {
            if (outerContext.isEmpty) return fullContext ? $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL : $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
            let parent;
            if (outerContext._parent) parent = $64ad510fde44ff92$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
            else parent = fullContext ? $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL : $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
            let state = atn.states[outerContext.invokingState];
            let transition = state.transition(0);
            return parent.getChild(transition.followState.stateNumber);
        }
        static addEmptyContext(context) {
            return context.addEmptyContext();
        }
        static removeEmptyContext(context) {
            return context.removeEmptyContext();
        }
        static join(context0, context1, contextCache = $6vF7J.PredictionContextCache.UNCACHED) {
            if (context0 === context1) return context0;
            if (context0.isEmpty) return $64ad510fde44ff92$var$PredictionContext.isEmptyLocal(context0) ? context0 : $64ad510fde44ff92$var$PredictionContext.addEmptyContext(context1);
            else if (context1.isEmpty) return $64ad510fde44ff92$var$PredictionContext.isEmptyLocal(context1) ? context1 : $64ad510fde44ff92$var$PredictionContext.addEmptyContext(context0);
            let context0size = context0.size;
            let context1size = context1.size;
            if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
                let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
                if (merged === context0.getParent(0)) return context0;
                else if (merged === context1.getParent(0)) return context1;
                else return merged.getChild(context0.getReturnState(0));
            }
            let count = 0;
            let parentsList = new Array(context0size + context1size);
            let returnStatesList = new Array(parentsList.length);
            let leftIndex = 0;
            let rightIndex = 0;
            let canReturnLeft = true;
            let canReturnRight = true;
            while(leftIndex < context0size && rightIndex < context1size){
                if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                    parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                    returnStatesList[count] = context0.getReturnState(leftIndex);
                    canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                    canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                    leftIndex++;
                    rightIndex++;
                } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                    parentsList[count] = context0.getParent(leftIndex);
                    returnStatesList[count] = context0.getReturnState(leftIndex);
                    canReturnRight = false;
                    leftIndex++;
                } else {
                    $bbHFU(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                    parentsList[count] = context1.getParent(rightIndex);
                    returnStatesList[count] = context1.getReturnState(rightIndex);
                    canReturnLeft = false;
                    rightIndex++;
                }
                count++;
            }
            while(leftIndex < context0size){
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                leftIndex++;
                canReturnRight = false;
                count++;
            }
            while(rightIndex < context1size){
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                rightIndex++;
                canReturnLeft = false;
                count++;
            }
            if (canReturnLeft) return context0;
            else if (canReturnRight) return context1;
            if (count < parentsList.length) {
                parentsList = parentsList.slice(0, count);
                returnStatesList = returnStatesList.slice(0, count);
            }
            if (parentsList.length === 0) return $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL;
            else if (parentsList.length === 1) return new $64ad510fde44ff92$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
            else return new $64ad510fde44ff92$var$ArrayPredictionContext(parentsList, returnStatesList);
        }
        static isEmptyLocal(context) {
            return context === $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
        }
        static getCachedContext(context, contextCache, visited) {
            if (context.isEmpty) return context;
            let existing = visited.get(context);
            if (existing) return existing;
            existing = contextCache.get(context);
            if (existing) {
                visited.put(context, existing);
                return existing;
            }
            let changed = false;
            let parents = new Array(context.size);
            for(let i = 0; i < parents.length; i++){
                let parent = $64ad510fde44ff92$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
                if (changed || parent !== context.getParent(i)) {
                    if (!changed) {
                        parents = new Array(context.size);
                        for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                        changed = true;
                    }
                    parents[i] = parent;
                }
            }
            if (!changed) {
                existing = contextCache.putIfAbsent(context, context);
                visited.put(context, existing != null ? existing : context);
                return context;
            }
            let updated;
            if (parents.length === 1) updated = new $64ad510fde44ff92$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
            else {
                let returnStates = new Array(context.size);
                for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
                updated = new $64ad510fde44ff92$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
            }
            existing = contextCache.putIfAbsent(updated, updated);
            visited.put(updated, existing || updated);
            visited.put(context, existing || updated);
            return updated;
        }
        appendSingleContext(returnContext, contextCache) {
            return this.appendContext($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
        }
        getChild(returnState) {
            return new $64ad510fde44ff92$var$SingletonPredictionContext(this, returnState);
        }
        hashCode() {
            return this.cachedHashCode;
        }
        toStrings(recognizer, currentState, stop = $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL) {
            let result = [];
            outer: for(let perm = 0;; perm++){
                let offset = 0;
                let last = true;
                let p = this;
                let stateNumber = currentState;
                let localBuffer = "";
                localBuffer += "[";
                while(!p.isEmpty && p !== stop){
                    let index = 0;
                    if (p.size > 0) {
                        let bits = 1;
                        while(1 << bits >>> 0 < p.size)bits++;
                        let mask = (1 << bits >>> 0) - 1;
                        index = perm >> offset & mask;
                        last = last && index >= p.size - 1;
                        if (index >= p.size) continue outer;
                        offset += bits;
                    }
                    if (recognizer) {
                        if (localBuffer.length > 1) localBuffer += " ";
                        let atn = recognizer.atn;
                        let s = atn.states[stateNumber];
                        let ruleName = recognizer.ruleNames[s.ruleIndex];
                        localBuffer += ruleName;
                    } else if (p.getReturnState(index) !== $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                        if (!p.isEmpty) {
                            if (localBuffer.length > 1) localBuffer += " ";
                            localBuffer += p.getReturnState(index);
                        }
                    }
                    stateNumber = p.getReturnState(index);
                    p = p.getParent(index);
                }
                localBuffer += "]";
                result.push(localBuffer);
                if (last) break;
            }
            return result;
        }
    }
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$PredictionContext.prototype, "hashCode", null);
    $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(1, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(2, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$PredictionContext, "join", null);
    $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(1, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(2, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$PredictionContext, "getCachedContext", null);
    module.exports.PredictionContext = $64ad510fde44ff92$var$PredictionContext;
    class $64ad510fde44ff92$var$EmptyPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
        constructor(fullContext){
            super($64ad510fde44ff92$var$PredictionContext.calculateEmptyHashCode());
            this.fullContext = fullContext;
        }
        get isFullContext() {
            return this.fullContext;
        }
        addEmptyContext() {
            return this;
        }
        removeEmptyContext() {
            throw new Error("Cannot remove the empty context from itself.");
        }
        getParent(index) {
            throw new Error("index out of bounds");
        }
        getReturnState(index) {
            throw new Error("index out of bounds");
        }
        findReturnState(returnState) {
            return -1;
        }
        get size() {
            return 0;
        }
        appendSingleContext(returnContext, contextCache) {
            return contextCache.getChild(this, returnContext);
        }
        appendContext(suffix, contextCache) {
            return suffix;
        }
        get isEmpty() {
            return true;
        }
        get hasEmpty() {
            return true;
        }
        equals(o) {
            return this === o;
        }
        toStrings(recognizer, currentState, stop) {
            return [
                "[]"
            ];
        }
    }
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "getParent", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "getReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "findReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "size", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "appendContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "isEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "hasEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "equals", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "toStrings", null);
    let $64ad510fde44ff92$var$ArrayPredictionContext = class ArrayPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
        constructor(parents, returnStates, hashCode){
            super(hashCode || $64ad510fde44ff92$var$PredictionContext.calculateHashCode(parents, returnStates));
            $bbHFU(parents.length === returnStates.length);
            $bbHFU(returnStates.length > 1 || returnStates[0] !== $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
            this.parents = parents;
            this.returnStates = returnStates;
        }
        getParent(index) {
            return this.parents[index];
        }
        getReturnState(index) {
            return this.returnStates[index];
        }
        findReturnState(returnState) {
            return $9yG1X.Arrays.binarySearch(this.returnStates, returnState);
        }
        get size() {
            return this.returnStates.length;
        }
        get isEmpty() {
            return false;
        }
        get hasEmpty() {
            return this.returnStates[this.returnStates.length - 1] === $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        addEmptyContext() {
            if (this.hasEmpty) return this;
            let parents2 = this.parents.slice(0);
            let returnStates2 = this.returnStates.slice(0);
            parents2.push($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL);
            returnStates2.push($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
        removeEmptyContext() {
            if (!this.hasEmpty) return this;
            if (this.returnStates.length === 2) return new $64ad510fde44ff92$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
            else {
                let parents2 = this.parents.slice(0, this.parents.length - 1);
                let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
                return new ArrayPredictionContext(parents2, returnStates2);
            }
        }
        appendContext(suffix, contextCache) {
            return ArrayPredictionContext.appendContextImpl(this, suffix, new $64ad510fde44ff92$var$PredictionContext.IdentityHashMap());
        }
        static appendContextImpl(context, suffix, visited) {
            if (suffix.isEmpty) {
                if ($64ad510fde44ff92$var$PredictionContext.isEmptyLocal(suffix)) {
                    if (context.hasEmpty) return $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
                    throw new Error("what to do here?");
                }
                return context;
            }
            if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
            let result = visited.get(context);
            if (!result) {
                if (context.isEmpty) result = suffix;
                else {
                    let parentCount = context.size;
                    if (context.hasEmpty) parentCount--;
                    let updatedParents = new Array(parentCount);
                    let updatedReturnStates = new Array(parentCount);
                    for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                    for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                    if (updatedParents.length === 1) result = new $64ad510fde44ff92$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                    else {
                        $bbHFU(updatedParents.length > 1);
                        result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                    }
                    if (context.hasEmpty) result = $64ad510fde44ff92$var$PredictionContext.join(result, suffix);
                }
                visited.put(context, result);
            }
            return result;
        }
        equals(o) {
            if (this === o) return true;
            else if (!(o instanceof ArrayPredictionContext)) return false;
            if (this.hashCode() !== o.hashCode()) return false;
            let other = o;
            return this.equalsImpl(other, new $7Veax.Array2DHashSet());
        }
        equalsImpl(other, visited) {
            let selfWorkList = [];
            let otherWorkList = [];
            selfWorkList.push(this);
            otherWorkList.push(other);
            while(true){
                let currentSelf = selfWorkList.pop();
                let currentOther = otherWorkList.pop();
                if (!currentSelf || !currentOther) break;
                let operands = new $6vF7J.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
                if (!visited.add(operands)) continue;
                let selfSize = operands.x.size;
                if (selfSize === 0) {
                    if (!operands.x.equals(operands.y)) return false;
                    continue;
                }
                let otherSize = operands.y.size;
                if (selfSize !== otherSize) return false;
                for(let i = 0; i < selfSize; i++){
                    if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                    let selfParent = operands.x.getParent(i);
                    let otherParent = operands.y.getParent(i);
                    if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                    if (selfParent !== otherParent) {
                        selfWorkList.push(selfParent);
                        otherWorkList.push(otherParent);
                    }
                }
            }
            return true;
        }
    };
    $64ad510fde44ff92$var$__decorate([
        $d6D31.NotNull
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "parents", void 0);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.NotNull
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "returnStates", void 0);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "getParent", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "getReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "findReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "size", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "isEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "hasEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "appendContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "equals", null);
    $64ad510fde44ff92$var$ArrayPredictionContext = $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$ArrayPredictionContext);
    let $64ad510fde44ff92$var$SingletonPredictionContext = class SingletonPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
        constructor(parent, returnState){
            super($64ad510fde44ff92$var$PredictionContext.calculateSingleHashCode(parent, returnState));
            this.parent = parent;
            this.returnState = returnState;
        }
        getParent(index) {
            return this.parent;
        }
        getReturnState(index) {
            return this.returnState;
        }
        findReturnState(returnState) {
            return this.returnState === returnState ? 0 : -1;
        }
        get size() {
            return 1;
        }
        get isEmpty() {
            return false;
        }
        get hasEmpty() {
            return false;
        }
        appendContext(suffix, contextCache) {
            return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
        }
        addEmptyContext() {
            let parents = [
                this.parent,
                $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL
            ];
            let returnStates = [
                this.returnState,
                $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY
            ];
            return new $64ad510fde44ff92$var$ArrayPredictionContext(parents, returnStates);
        }
        removeEmptyContext() {
            return this;
        }
        equals(o) {
            if (o === this) return true;
            else if (!(o instanceof SingletonPredictionContext)) return false;
            let other = o;
            if (this.hashCode() !== other.hashCode()) return false;
            return this.returnState === other.returnState && this.parent.equals(other.parent);
        }
    };
    $64ad510fde44ff92$var$__decorate([
        $d6D31.NotNull
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "parent", void 0);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "getParent", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "getReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "findReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "size", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "isEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "hasEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "appendContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "equals", null);
    $64ad510fde44ff92$var$SingletonPredictionContext = $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$SingletonPredictionContext);
    module.exports.SingletonPredictionContext = $64ad510fde44ff92$var$SingletonPredictionContext;
    (function(PredictionContext) {
        PredictionContext.EMPTY_LOCAL = new $64ad510fde44ff92$var$EmptyPredictionContext(false);
        PredictionContext.EMPTY_FULL = new $64ad510fde44ff92$var$EmptyPredictionContext(true);
        PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
        PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
        class IdentityHashMap extends $fP17P.Array2DHashMap {
            constructor(){
                super(IdentityEqualityComparator.INSTANCE);
            }
        }
        PredictionContext.IdentityHashMap = IdentityHashMap;
        class IdentityEqualityComparator {
            IdentityEqualityComparator() {}
            hashCode(obj) {
                return obj.hashCode();
            }
            equals(a, b) {
                return a === b;
            }
        }
        IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
        $64ad510fde44ff92$var$__decorate([
            $d6D31.Override
        ], IdentityEqualityComparator.prototype, "hashCode", null);
        $64ad510fde44ff92$var$__decorate([
            $d6D31.Override
        ], IdentityEqualityComparator.prototype, "equals", null);
        PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
    })($64ad510fde44ff92$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));
});
parcelRegister("6vF7J", function(module, exports) {
    "use strict";
    var $4bd589a149816580$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PredictionContextCache = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $bbHFU = parcelRequire("bbHFU");
    class $4bd589a149816580$var$PredictionContextCache {
        constructor(enableCache = true){
            this.contexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.childContexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.joinContexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.enableCache = enableCache;
        }
        getAsCached(context) {
            if (!this.enableCache) return context;
            let result = this.contexts.get(context);
            if (!result) {
                result = context;
                this.contexts.put(context, context);
            }
            return result;
        }
        getChild(context, invokingState) {
            if (!this.enableCache) return context.getChild(invokingState);
            let operands = new $4bd589a149816580$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
            let result = this.childContexts.get(operands);
            if (!result) {
                result = context.getChild(invokingState);
                result = this.getAsCached(result);
                this.childContexts.put(operands, result);
            }
            return result;
        }
        join(x, y) {
            if (!this.enableCache) return $8DTT0.PredictionContext.join(x, y, this);
            let operands = new $4bd589a149816580$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
            let result = this.joinContexts.get(operands);
            if (result) return result;
            result = $8DTT0.PredictionContext.join(x, y, this);
            result = this.getAsCached(result);
            this.joinContexts.put(operands, result);
            return result;
        }
    }
    module.exports.PredictionContextCache = $4bd589a149816580$var$PredictionContextCache;
    $4bd589a149816580$var$PredictionContextCache.UNCACHED = new $4bd589a149816580$var$PredictionContextCache(false);
    (function(PredictionContextCache) {
        class PredictionContextAndInt {
            constructor(obj, value){
                this.obj = obj;
                this.value = value;
            }
            equals(obj) {
                if (!(obj instanceof PredictionContextAndInt)) return false;
                else if (obj === this) return true;
                let other = obj;
                return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
            }
            hashCode() {
                let hashCode = 5;
                hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
                hashCode = 7 * hashCode + this.value;
                return hashCode;
            }
        }
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], PredictionContextAndInt.prototype, "equals", null);
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], PredictionContextAndInt.prototype, "hashCode", null);
        PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
        class IdentityCommutativePredictionContextOperands {
            constructor(x, y){
                $bbHFU(x != null);
                $bbHFU(y != null);
                this._x = x;
                this._y = y;
            }
            get x() {
                return this._x;
            }
            get y() {
                return this._y;
            }
            equals(o) {
                if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
                else if (this === o) return true;
                let other = o;
                return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
            }
            hashCode() {
                return this._x.hashCode() ^ this._y.hashCode();
            }
        }
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
        PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
    })($4bd589a149816580$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));
});
parcelRegister("5BPMp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BitSet = void 0;
    var $9kAQu = parcelRequire("9kAQu");
    var $iXFjm = parcelRequire("iXFjm");
    const $415892d73e8925a4$var$EMPTY_DATA = new Uint16Array(0);
    function $415892d73e8925a4$var$getIndex(bitNumber) {
        return bitNumber >>> 4;
    }
    function $415892d73e8925a4$var$unIndex(n) {
        return n * 16;
    }
    function $415892d73e8925a4$var$findLSBSet(word) {
        let bit = 1;
        for(let i = 0; i < 16; i++){
            if ((word & bit) !== 0) return i;
            bit = bit << 1 >>> 0;
        }
        throw new RangeError("No specified bit found");
    }
    function $415892d73e8925a4$var$findMSBSet(word) {
        let bit = 32768;
        for(let i = 15; i >= 0; i--){
            if ((word & bit) !== 0) return i;
            bit = bit >>> 1;
        }
        throw new RangeError("No specified bit found");
    }
    function $415892d73e8925a4$var$bitsFor(fromBit, toBit) {
        fromBit &= 0xF;
        toBit &= 0xF;
        if (fromBit === toBit) return 1 << fromBit >>> 0;
        return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
    }
    const $415892d73e8925a4$var$POP_CNT = new Uint8Array(65536);
    for(let i = 0; i < 16; i++){
        const stride = 1 << i >>> 0;
        let index = 0;
        while(index < $415892d73e8925a4$var$POP_CNT.length){
            index += stride;
            for(let j = 0; j < stride; j++){
                $415892d73e8925a4$var$POP_CNT[index]++;
                index++;
            }
        }
    }
    class $415892d73e8925a4$var$BitSet {
        constructor(arg){
            if (!arg) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            else if (typeof arg === "number") {
                if (arg < 0) throw new RangeError("nbits cannot be negative");
                else this.data = new Uint16Array($415892d73e8925a4$var$getIndex(arg - 1) + 1);
            } else if (arg instanceof $415892d73e8925a4$var$BitSet) this.data = arg.data.slice(0);
            else {
                let max = -1;
                for (let v of arg)if (max < v) max = v;
                this.data = new Uint16Array($415892d73e8925a4$var$getIndex(max - 1) + 1);
                for (let v of arg)this.set(v);
            }
        }
        and(set) {
            const data = this.data;
            const other = set.data;
            const words = Math.min(data.length, other.length);
            let lastWord = -1;
            for(let i = 0; i < words; i++){
                let value = data[i] &= other[i];
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
        }
        andNot(set) {
            const data = this.data;
            const other = set.data;
            const words = Math.min(data.length, other.length);
            let lastWord = -1;
            for(let i = 0; i < words; i++){
                let value = data[i] &= other[i] ^ 0xFFFF;
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
        }
        cardinality() {
            if (this.isEmpty) return 0;
            const data = this.data;
            const length = data.length;
            let result = 0;
            for(let i = 0; i < length; i++)result += $415892d73e8925a4$var$POP_CNT[data[i]];
            return result;
        }
        clear(fromIndex, toIndex) {
            if (fromIndex == null) this.data.fill(0);
            else if (toIndex == null) this.set(fromIndex, false);
            else this.set(fromIndex, toIndex, false);
        }
        flip(fromIndex, toIndex) {
            if (toIndex == null) toIndex = fromIndex;
            if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            const lastWord = $415892d73e8925a4$var$getIndex(toIndex);
            if (word === lastWord) this.data[word] ^= $415892d73e8925a4$var$bitsFor(fromIndex, toIndex);
            else {
                this.data[word++] ^= $415892d73e8925a4$var$bitsFor(fromIndex, 15);
                while(word < lastWord)this.data[word++] ^= 0xFFFF;
                this.data[word++] ^= $415892d73e8925a4$var$bitsFor(0, toIndex);
            }
        }
        get(fromIndex, toIndex) {
            if (toIndex === undefined) return !!(this.data[$415892d73e8925a4$var$getIndex(fromIndex)] & $415892d73e8925a4$var$bitsFor(fromIndex, fromIndex));
            else {
                let result = new $415892d73e8925a4$var$BitSet(toIndex + 1);
                for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
                return result;
            }
        }
        intersects(set) {
            let smallerLength = Math.min(this.length(), set.length());
            if (smallerLength === 0) return false;
            let bound = $415892d73e8925a4$var$getIndex(smallerLength - 1);
            for(let i = 0; i <= bound; i++){
                if ((this.data[i] & set.data[i]) !== 0) return true;
            }
            return false;
        }
        get isEmpty() {
            return this.length() === 0;
        }
        length() {
            if (!this.data.length) return 0;
            return this.previousSetBit($415892d73e8925a4$var$unIndex(this.data.length) - 1) + 1;
        }
        nextClearBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word > length) return -1;
            let ignore = 0xFFFF ^ $415892d73e8925a4$var$bitsFor(fromIndex, 15);
            if ((data[word] | ignore) === 0xFFFF) {
                word++;
                ignore = 0;
                for(; word < length; word++){
                    if (data[word] !== 0xFFFF) break;
                }
                if (word === length) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
        }
        nextSetBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word > length) return -1;
            let mask = $415892d73e8925a4$var$bitsFor(fromIndex, 15);
            if ((data[word] & mask) === 0) {
                word++;
                mask = 0xFFFF;
                for(; word < length; word++){
                    if (data[word] !== 0) break;
                }
                if (word >= length) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findLSBSet(data[word] & mask);
        }
        or(set) {
            const data = this.data;
            const other = set.data;
            const minWords = Math.min(data.length, other.length);
            const words = Math.max(data.length, other.length);
            const dest = data.length === words ? data : new Uint16Array(words);
            let lastWord = -1;
            for(let i = 0; i < minWords; i++){
                let value = dest[i] = data[i] | other[i];
                if (value !== 0) lastWord = i;
            }
            const longer = data.length > other.length ? data : other;
            for(let i = minWords; i < words; i++){
                let value = dest[i] = longer[i];
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            else if (dest.length === lastWord + 1) this.data = dest;
            else this.data = dest.slice(0, lastWord);
        }
        previousClearBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word >= length) word = length - 1;
            let ignore = 0xFFFF ^ $415892d73e8925a4$var$bitsFor(0, fromIndex);
            if ((data[word] | ignore) === 0xFFFF) {
                ignore = 0;
                word--;
                for(; word >= 0; word--){
                    if (data[word] !== 0xFFFF) break;
                }
                if (word < 0) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
        }
        previousSetBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word >= length) word = length - 1;
            let mask = $415892d73e8925a4$var$bitsFor(0, fromIndex);
            if ((data[word] & mask) === 0) {
                word--;
                mask = 0xFFFF;
                for(; word >= 0; word--){
                    if (data[word] !== 0) break;
                }
                if (word < 0) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findMSBSet(data[word] & mask);
        }
        set(fromIndex, toIndex, value) {
            if (toIndex === undefined) {
                toIndex = fromIndex;
                value = true;
            } else if (typeof toIndex === "boolean") {
                value = toIndex;
                toIndex = fromIndex;
            }
            if (value === undefined) value = true;
            if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            let lastWord = $415892d73e8925a4$var$getIndex(toIndex);
            if (value && lastWord >= this.data.length) {
                let temp = new Uint16Array(lastWord + 1);
                this.data.forEach((value, index)=>temp[index] = value);
                this.data = temp;
            } else if (!value) {
                if (word >= this.data.length) return;
                if (lastWord >= this.data.length) {
                    lastWord = this.data.length - 1;
                    toIndex = this.data.length * 16 - 1;
                }
            }
            if (word === lastWord) this._setBits(word, value, $415892d73e8925a4$var$bitsFor(fromIndex, toIndex));
            else {
                this._setBits(word++, value, $415892d73e8925a4$var$bitsFor(fromIndex, 15));
                while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
                this._setBits(word, value, $415892d73e8925a4$var$bitsFor(0, toIndex));
            }
        }
        _setBits(word, value, mask) {
            if (value) this.data[word] |= mask;
            else this.data[word] &= 0xFFFF ^ mask;
        }
        get size() {
            return this.data.byteLength * 8;
        }
        hashCode() {
            return $iXFjm.MurmurHash.hashCode(this.data, 22);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $415892d73e8925a4$var$BitSet)) return false;
            const len = this.length();
            if (len !== obj.length()) return false;
            if (len === 0) return true;
            let bound = $415892d73e8925a4$var$getIndex(len - 1);
            for(let i = 0; i <= bound; i++){
                if (this.data[i] !== obj.data[i]) return false;
            }
            return true;
        }
        toString() {
            let result = "{";
            let first = true;
            for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
                if (first) first = false;
                else result += ", ";
                result += i;
            }
            result += "}";
            return result;
        }
        xor(set) {
            const data = this.data;
            const other = set.data;
            const minWords = Math.min(data.length, other.length);
            const words = Math.max(data.length, other.length);
            const dest = data.length === words ? data : new Uint16Array(words);
            let lastWord = -1;
            for(let i = 0; i < minWords; i++){
                let value = dest[i] = data[i] ^ other[i];
                if (value !== 0) lastWord = i;
            }
            const longer = data.length > other.length ? data : other;
            for(let i = minWords; i < words; i++){
                let value = dest[i] = longer[i];
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            else if (dest.length === lastWord + 1) this.data = dest;
            else this.data = dest.slice(0, lastWord + 1);
        }
        clone() {
            return new $415892d73e8925a4$var$BitSet(this);
        }
        [Symbol.iterator]() {
            return new $415892d73e8925a4$var$BitSetIterator(this.data);
        }
        [$9kAQu.inspect.custom]() {
            return "BitSet " + this.toString();
        }
    }
    module.exports.BitSet = $415892d73e8925a4$var$BitSet;
    class $415892d73e8925a4$var$BitSetIterator {
        constructor(data){
            this.data = data;
            this.index = 0;
            this.mask = 0xFFFF;
        }
        next() {
            while(this.index < this.data.length){
                const bits = this.data[this.index] & this.mask;
                if (bits !== 0) {
                    const bitNumber = $415892d73e8925a4$var$unIndex(this.index) + $415892d73e8925a4$var$findLSBSet(bits);
                    this.mask = $415892d73e8925a4$var$bitsFor(bitNumber + 1, 15);
                    return {
                        done: false,
                        value: bitNumber
                    };
                }
                this.index++;
                this.mask = 0xFFFF;
            }
            return {
                done: true,
                value: -1
            };
        }
        [Symbol.iterator]() {
            return this;
        }
    }
});
parcelRegister("yhTtv", function(module, exports) {
    "use strict";
    var $06710e6ae1da410a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DFASerializer = void 0;
    var $kr9A1 = parcelRequire("kr9A1");
    var $d6D31 = parcelRequire("d6D31");
    var $8DTT0 = parcelRequire("8DTT0");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $3n2FE = parcelRequire("3n2FE");
    class $06710e6ae1da410a$var$DFASerializer {
        constructor(dfa, vocabulary, ruleNames, atn){
            if (vocabulary instanceof $kBaAZ.Recognizer) {
                ruleNames = vocabulary.ruleNames;
                atn = vocabulary.atn;
                vocabulary = vocabulary.vocabulary;
            } else if (!vocabulary) vocabulary = $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
            this.dfa = dfa;
            this.vocabulary = vocabulary;
            this.ruleNames = ruleNames;
            this.atn = atn;
        }
        toString() {
            if (!this.dfa.s0) return "";
            let buf = "";
            if (this.dfa.states) {
                let states = new Array(...this.dfa.states.toArray());
                states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
                for (let s of states){
                    let edges = s.getEdgeMap();
                    let edgeKeys = [
                        ...edges.keys()
                    ].sort((a, b)=>a - b);
                    let contextEdges = s.getContextEdgeMap();
                    let contextEdgeKeys = [
                        ...contextEdges.keys()
                    ].sort((a, b)=>a - b);
                    for (let entry of edgeKeys){
                        let value = edges.get(entry);
                        if ((value == null || value === $kr9A1.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                        let contextSymbol = false;
                        buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                        if (s.isContextSymbol(entry)) {
                            buf += "!";
                            contextSymbol = true;
                        }
                        let t = value;
                        if (t && t.stateNumber !== $kr9A1.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                        else if (contextSymbol) buf += "ctx\n";
                    }
                    if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
                }
            }
            let output = buf;
            if (output.length === 0) return "";
            return output;
        }
        getContextLabel(i) {
            if (i === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
            else if (i === $8DTT0.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
            if (this.atn && i > 0 && i <= this.atn.states.length) {
                let state = this.atn.states[i];
                let ruleIndex = state.ruleIndex;
                if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
            }
            return "ctx:" + String(i);
        }
        getEdgeLabel(i) {
            return this.vocabulary.getDisplayName(i);
        }
        getStateString(s) {
            if (s === $kr9A1.ATNSimulator.ERROR) return "ERROR";
            let n = s.stateNumber;
            let stateStr = "s" + n;
            if (s.isAcceptState) {
                if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
                else stateStr = ":s" + n + "=>" + s.prediction;
            }
            if (s.isContextSensitive) {
                stateStr += "*";
                for (let config of s.configs)if (config.reachesIntoOuterContext) {
                    stateStr += "*";
                    break;
                }
            }
            return stateStr;
        }
    }
    $06710e6ae1da410a$var$__decorate([
        $d6D31.NotNull
    ], $06710e6ae1da410a$var$DFASerializer.prototype, "dfa", void 0);
    $06710e6ae1da410a$var$__decorate([
        $d6D31.NotNull
    ], $06710e6ae1da410a$var$DFASerializer.prototype, "vocabulary", void 0);
    $06710e6ae1da410a$var$__decorate([
        $d6D31.Override
    ], $06710e6ae1da410a$var$DFASerializer.prototype, "toString", null);
    module.exports.DFASerializer = $06710e6ae1da410a$var$DFASerializer;
});
parcelRegister("kr9A1", function(module, exports) {
    "use strict";
    var $ee0dc2a763a7368a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ee0dc2a763a7368a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNSimulator = void 0;
    var $c1ClW = parcelRequire("c1ClW");
    var $2jevZ = parcelRequire("2jevZ");
    var $d6D31 = parcelRequire("d6D31");
    var $8DTT0 = parcelRequire("8DTT0");
    let $ee0dc2a763a7368a$var$ATNSimulator = class ATNSimulator {
        constructor(atn){
            this.atn = atn;
        }
        static get ERROR() {
            if (!ATNSimulator._ERROR) {
                ATNSimulator._ERROR = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                ATNSimulator._ERROR.stateNumber = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
            }
            return ATNSimulator._ERROR;
        }
        clearDFA() {
            this.atn.clearDFA();
        }
    };
    $ee0dc2a763a7368a$var$__decorate([
        $d6D31.NotNull
    ], $ee0dc2a763a7368a$var$ATNSimulator.prototype, "atn", void 0);
    $ee0dc2a763a7368a$var$__decorate([
        $d6D31.NotNull
    ], $ee0dc2a763a7368a$var$ATNSimulator, "ERROR", null);
    $ee0dc2a763a7368a$var$ATNSimulator = $ee0dc2a763a7368a$var$__decorate([
        $ee0dc2a763a7368a$var$__param(0, $d6D31.NotNull)
    ], $ee0dc2a763a7368a$var$ATNSimulator);
    module.exports.ATNSimulator = $ee0dc2a763a7368a$var$ATNSimulator;
    (function(ATNSimulator) {
        const RULE_VARIANT_DELIMITER = "$";
        const RULE_LF_VARIANT_MARKER = "$lf$";
        const RULE_NOLF_VARIANT_MARKER = "$nolf$";
    })($ee0dc2a763a7368a$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
    module.exports.ATNSimulator = $ee0dc2a763a7368a$var$ATNSimulator;
});
parcelRegister("2jevZ", function(module, exports) {
    "use strict";
    var $1ae89d7ac78d8bff$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $1ae89d7ac78d8bff$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DFAState = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $5BPMp = parcelRequire("5BPMp");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $8DTT0 = parcelRequire("8DTT0");
    var $bbHFU = parcelRequire("bbHFU");
    class $1ae89d7ac78d8bff$var$DFAState {
        constructor(configs){
            this.stateNumber = -1;
            this.configs = configs;
            this.edges = new Map();
            this.contextEdges = new Map();
        }
        get isContextSensitive() {
            return !!this.contextSymbols;
        }
        isContextSymbol(symbol) {
            if (!this.isContextSensitive) return false;
            return this.contextSymbols.get(symbol);
        }
        setContextSymbol(symbol) {
            $bbHFU(this.isContextSensitive);
            this.contextSymbols.set(symbol);
        }
        setContextSensitive(atn) {
            $bbHFU(!this.configs.isOutermostConfigSet);
            if (this.isContextSensitive) return;
            if (!this.contextSymbols) this.contextSymbols = new $5BPMp.BitSet();
        }
        get acceptStateInfo() {
            return this._acceptStateInfo;
        }
        set acceptStateInfo(acceptStateInfo) {
            this._acceptStateInfo = acceptStateInfo;
        }
        get isAcceptState() {
            return !!this._acceptStateInfo;
        }
        get prediction() {
            if (!this._acceptStateInfo) return $bcnvE.ATN.INVALID_ALT_NUMBER;
            return this._acceptStateInfo.prediction;
        }
        get lexerActionExecutor() {
            if (!this._acceptStateInfo) return undefined;
            return this._acceptStateInfo.lexerActionExecutor;
        }
        getTarget(symbol) {
            return this.edges.get(symbol);
        }
        setTarget(symbol, target) {
            this.edges.set(symbol, target);
        }
        getEdgeMap() {
            return this.edges;
        }
        getContextTarget(invokingState) {
            if (invokingState === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
            return this.contextEdges.get(invokingState);
        }
        setContextTarget(invokingState, target) {
            if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
            if (invokingState === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
            this.contextEdges.set(invokingState, target);
        }
        getContextEdgeMap() {
            let map = new Map(this.contextEdges);
            let existing = map.get(-1);
            if (existing !== undefined) {
                if (map.size === 1) {
                    let result = new Map();
                    result.set($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                    return result;
                } else {
                    map.delete(-1);
                    map.set($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                }
            }
            return map;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize(7);
            hash = $iXFjm.MurmurHash.update(hash, this.configs.hashCode());
            hash = $iXFjm.MurmurHash.finish(hash, 1);
            return hash;
        }
        equals(o) {
            if (this === o) return true;
            if (!(o instanceof $1ae89d7ac78d8bff$var$DFAState)) return false;
            let other = o;
            let sameSet = this.configs.equals(other.configs);
            return sameSet;
        }
        toString() {
            let buf = "";
            buf += this.stateNumber + ":" + this.configs;
            if (this.isAcceptState) {
                buf += "=>";
                if (this.predicates) buf += this.predicates;
                else buf += this.prediction;
            }
            return buf.toString();
        }
    }
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "configs", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "edges", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "contextEdges", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "hashCode", null);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "equals", null);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "toString", null);
    module.exports.DFAState = $1ae89d7ac78d8bff$var$DFAState;
    (function(DFAState) {
        let PredPrediction = class PredPrediction {
            constructor(pred, alt){
                this.alt = alt;
                this.pred = pred;
            }
            toString() {
                return "(" + this.pred + ", " + this.alt + ")";
            }
        };
        $1ae89d7ac78d8bff$var$__decorate([
            $d6D31.NotNull
        ], PredPrediction.prototype, "pred", void 0);
        $1ae89d7ac78d8bff$var$__decorate([
            $d6D31.Override
        ], PredPrediction.prototype, "toString", null);
        PredPrediction = $1ae89d7ac78d8bff$var$__decorate([
            $1ae89d7ac78d8bff$var$__param(0, $d6D31.NotNull)
        ], PredPrediction);
        DFAState.PredPrediction = PredPrediction;
    })($1ae89d7ac78d8bff$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));
});
parcelRegister("kBaAZ", function(module, exports) {
    "use strict";
    var $efef7b6bec20bc2a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $efef7b6bec20bc2a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Recognizer = void 0;
    var $e5mHr = parcelRequire("e5mHr");
    var $65iNZ = parcelRequire("65iNZ");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    var $2IEP9 = parcelRequire("2IEP9");
    class $efef7b6bec20bc2a$var$Recognizer {
        constructor(){
            this._listeners = [
                $e5mHr.ConsoleErrorListener.INSTANCE
            ];
            this._stateNumber = -1;
        }
        getTokenTypeMap() {
            let vocabulary = this.vocabulary;
            let result = $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache.get(vocabulary);
            if (result == null) {
                let intermediateResult = new Map();
                for(let i = 0; i <= this.atn.maxTokenType; i++){
                    let literalName = vocabulary.getLiteralName(i);
                    if (literalName != null) intermediateResult.set(literalName, i);
                    let symbolicName = vocabulary.getSymbolicName(i);
                    if (symbolicName != null) intermediateResult.set(symbolicName, i);
                }
                intermediateResult.set("EOF", $2DVsz.Token.EOF);
                result = intermediateResult;
                $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
            }
            return result;
        }
        getRuleIndexMap() {
            let ruleNames = this.ruleNames;
            if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
            let result = $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache.get(ruleNames);
            if (result == null) {
                result = $2IEP9.toMap(ruleNames);
                $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
            }
            return result;
        }
        getTokenType(tokenName) {
            let ttype = this.getTokenTypeMap().get(tokenName);
            if (ttype != null) return ttype;
            return $2DVsz.Token.INVALID_TYPE;
        }
        get serializedATN() {
            throw new Error("there is no serialized ATN");
        }
        get atn() {
            return this._interp.atn;
        }
        get interpreter() {
            return this._interp;
        }
        set interpreter(interpreter) {
            this._interp = interpreter;
        }
        get parseInfo() {
            return Promise.resolve(undefined);
        }
        getErrorHeader(e) {
            let token = e.getOffendingToken();
            if (!token) return "";
            let line = token.line;
            let charPositionInLine = token.charPositionInLine;
            return "line " + line + ":" + charPositionInLine;
        }
        addErrorListener(listener) {
            if (!listener) throw new TypeError("listener must not be null");
            this._listeners.push(listener);
        }
        removeErrorListener(listener) {
            let position = this._listeners.indexOf(listener);
            if (position !== -1) this._listeners.splice(position, 1);
        }
        removeErrorListeners() {
            this._listeners.length = 0;
        }
        getErrorListeners() {
            return this._listeners.slice(0);
        }
        getErrorListenerDispatch() {
            return new $65iNZ.ProxyErrorListener(this.getErrorListeners());
        }
        sempred(_localctx, ruleIndex, actionIndex) {
            return true;
        }
        precpred(localctx, precedence) {
            return true;
        }
        action(_localctx, ruleIndex, actionIndex) {}
        get state() {
            return this._stateNumber;
        }
        set state(atnState) {
            this._stateNumber = atnState;
        }
    }
    $efef7b6bec20bc2a$var$Recognizer.EOF = -1;
    $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache = new WeakMap();
    $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache = new WeakMap();
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.SuppressWarnings("serial"),
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "_listeners", void 0);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getTokenTypeMap", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getRuleIndexMap", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "serializedATN", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "atn", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull,
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "interpreter", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull,
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getErrorHeader", null);
    $efef7b6bec20bc2a$var$__decorate([
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "addErrorListener", null);
    $efef7b6bec20bc2a$var$__decorate([
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "removeErrorListener", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getErrorListeners", null);
    module.exports.Recognizer = $efef7b6bec20bc2a$var$Recognizer;
});
parcelRegister("e5mHr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ConsoleErrorListener = void 0;
    class $a413240156cc2e50$var$ConsoleErrorListener {
        syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
            console.error(`line ${line}:${charPositionInLine} ${msg}`);
        }
    }
    module.exports.ConsoleErrorListener = $a413240156cc2e50$var$ConsoleErrorListener;
    $a413240156cc2e50$var$ConsoleErrorListener.INSTANCE = new $a413240156cc2e50$var$ConsoleErrorListener();
});
parcelRegister("65iNZ", function(module, exports) {
    "use strict";
    var $46e1cc07c7f5b3d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $46e1cc07c7f5b3d6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ProxyErrorListener = void 0;
    var $d6D31 = parcelRequire("d6D31");
    class $46e1cc07c7f5b3d6$var$ProxyErrorListener {
        constructor(delegates){
            this.delegates = delegates;
            if (!delegates) throw new Error("Invalid delegates");
        }
        getDelegates() {
            return this.delegates;
        }
        syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
            this.delegates.forEach((listener)=>{
                if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
            });
        }
    }
    $46e1cc07c7f5b3d6$var$__decorate([
        $d6D31.Override,
        $46e1cc07c7f5b3d6$var$__param(0, $d6D31.NotNull),
        $46e1cc07c7f5b3d6$var$__param(4, $d6D31.NotNull)
    ], $46e1cc07c7f5b3d6$var$ProxyErrorListener.prototype, "syntaxError", null);
    module.exports.ProxyErrorListener = $46e1cc07c7f5b3d6$var$ProxyErrorListener;
});
parcelRegister("3n2FE", function(module, exports) {
    "use strict";
    var $27459777e7d4e735$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.VocabularyImpl = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $27459777e7d4e735$var$VocabularyImpl {
        constructor(literalNames, symbolicNames, displayNames){
            this.literalNames = literalNames;
            this.symbolicNames = symbolicNames;
            this.displayNames = displayNames;
            this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
        }
        get maxTokenType() {
            return this._maxTokenType;
        }
        getLiteralName(tokenType) {
            if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
            return undefined;
        }
        getSymbolicName(tokenType) {
            if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
            if (tokenType === $2DVsz.Token.EOF) return "EOF";
            return undefined;
        }
        getDisplayName(tokenType) {
            if (tokenType >= 0 && tokenType < this.displayNames.length) {
                let displayName = this.displayNames[tokenType];
                if (displayName) return displayName;
            }
            let literalName = this.getLiteralName(tokenType);
            if (literalName) return literalName;
            let symbolicName = this.getSymbolicName(tokenType);
            if (symbolicName) return symbolicName;
            return String(tokenType);
        }
    }
    $27459777e7d4e735$var$VocabularyImpl.EMPTY_VOCABULARY = new $27459777e7d4e735$var$VocabularyImpl([], [], []);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "literalNames", void 0);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "symbolicNames", void 0);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "displayNames", void 0);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "maxTokenType", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "getLiteralName", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "getSymbolicName", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "getDisplayName", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
    module.exports.VocabularyImpl = $27459777e7d4e735$var$VocabularyImpl;
});
parcelRegister("aeRGo", function(module, exports) {
    "use strict";
    var $7744da7bed4bb192$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7744da7bed4bb192$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerDFASerializer = void 0;
    var $yhTtv = parcelRequire("yhTtv");
    var $d6D31 = parcelRequire("d6D31");
    var $3n2FE = parcelRequire("3n2FE");
    let $7744da7bed4bb192$var$LexerDFASerializer = class LexerDFASerializer extends $yhTtv.DFASerializer {
        constructor(dfa){
            super(dfa, $3n2FE.VocabularyImpl.EMPTY_VOCABULARY);
        }
        getEdgeLabel(i) {
            return "'" + String.fromCodePoint(i) + "'";
        }
    };
    $7744da7bed4bb192$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7744da7bed4bb192$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
    $7744da7bed4bb192$var$LexerDFASerializer = $7744da7bed4bb192$var$__decorate([
        $7744da7bed4bb192$var$__param(0, $d6D31.NotNull)
    ], $7744da7bed4bb192$var$LexerDFASerializer);
    module.exports.LexerDFASerializer = $7744da7bed4bb192$var$LexerDFASerializer;
});
parcelRegister("f9raX", function(module, exports) {
    "use strict";
    var $b07cc6cfd56668a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.StarLoopEntryState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $5BPMp = parcelRequire("5BPMp");
    var $dPYn6 = parcelRequire("dPYn6");
    var $d6D31 = parcelRequire("d6D31");
    class $b07cc6cfd56668a7$var$StarLoopEntryState extends $dPYn6.DecisionState {
        constructor(){
            super(...arguments);
            this.precedenceRuleDecision = false;
            this.precedenceLoopbackStates = new $5BPMp.BitSet();
        }
        get stateType() {
            return $1bs3X.ATNStateType.STAR_LOOP_ENTRY;
        }
    }
    $b07cc6cfd56668a7$var$__decorate([
        $d6D31.Override
    ], $b07cc6cfd56668a7$var$StarLoopEntryState.prototype, "stateType", null);
    module.exports.StarLoopEntryState = $b07cc6cfd56668a7$var$StarLoopEntryState;
});
parcelRegister("l4Nh1", function(module, exports) {
    "use strict";
    var $f580316b3d8851ef$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.InvalidState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $4yiuQ = parcelRequire("4yiuQ");
    var $d6D31 = parcelRequire("d6D31");
    class $f580316b3d8851ef$var$InvalidState extends $4yiuQ.BasicState {
        get stateType() {
            return $1bs3X.ATNStateType.INVALID_TYPE;
        }
    }
    $f580316b3d8851ef$var$__decorate([
        $d6D31.Override
    ], $f580316b3d8851ef$var$InvalidState.prototype, "stateType", null);
    module.exports.InvalidState = $f580316b3d8851ef$var$InvalidState;
});
parcelRegister("4yiuQ", function(module, exports) {
    "use strict";
    var $3508af691e74fe3f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BasicState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $3508af691e74fe3f$var$BasicState extends $7j0Pc.ATNState {
        get stateType() {
            return $1bs3X.ATNStateType.BASIC;
        }
    }
    $3508af691e74fe3f$var$__decorate([
        $d6D31.Override
    ], $3508af691e74fe3f$var$BasicState.prototype, "stateType", null);
    module.exports.BasicState = $3508af691e74fe3f$var$BasicState;
});
parcelRegister("iiE1V", function(module, exports) {
    "use strict";
    var $d528f592a4fe7f4e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $d528f592a4fe7f4e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LL1Analyzer = void 0;
    var $fMVaR = parcelRequire("fMVaR");
    var $7Veax = parcelRequire("7Veax");
    var $gcX0f = parcelRequire("gcX0f");
    var $5BPMp = parcelRequire("5BPMp");
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $FLEKS = parcelRequire("FLEKS");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $4kGBm = parcelRequire("4kGBm");
    var $aybFP = parcelRequire("aybFP");
    var $2DVsz = parcelRequire("2DVsz");
    var $aPmi9 = parcelRequire("aPmi9");
    let $d528f592a4fe7f4e$var$LL1Analyzer = class LL1Analyzer {
        constructor(atn){
            this.atn = atn;
        }
        getDecisionLookahead(s) {
            if (s == null) return undefined;
            let look = new Array(s.numberOfTransitions);
            for(let alt = 0; alt < s.numberOfTransitions; alt++){
                let current = new $hGRod.IntervalSet();
                look[alt] = current;
                let lookBusy = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
                let seeThruPreds = false;
                this._LOOK(s.transition(alt).target, undefined, $8DTT0.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $5BPMp.BitSet(), seeThruPreds, false);
                if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                    current = undefined;
                    look[alt] = current;
                }
            }
            return look;
        }
        LOOK(s, ctx, stopState) {
            if (stopState === undefined) {
                if (s.atn == null) throw new Error("Illegal state");
                stopState = s.atn.ruleToStopState[s.ruleIndex];
            } else if (stopState === null) stopState = undefined;
            let r = new $hGRod.IntervalSet();
            let seeThruPreds = true;
            let addEOF = true;
            this._LOOK(s, stopState, ctx, r, new $7Veax.Array2DHashSet(), new $5BPMp.BitSet(), seeThruPreds, addEOF);
            return r;
        }
        _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
            let c = $gcX0f.ATNConfig.create(s, 0, ctx);
            if (!lookBusy.add(c)) return;
            if (s === stopState) {
                if ($8DTT0.PredictionContext.isEmptyLocal(ctx)) {
                    look.add($2DVsz.Token.EPSILON);
                    return;
                } else if (ctx.isEmpty) {
                    if (addEOF) look.add($2DVsz.Token.EOF);
                    return;
                }
            }
            if (s instanceof $4kGBm.RuleStopState) {
                if (ctx.isEmpty && !$8DTT0.PredictionContext.isEmptyLocal(ctx)) {
                    if (addEOF) look.add($2DVsz.Token.EOF);
                    return;
                }
                let removed = calledRuleStack.get(s.ruleIndex);
                try {
                    calledRuleStack.clear(s.ruleIndex);
                    for(let i = 0; i < ctx.size; i++){
                        if (ctx.getReturnState(i) === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                        let returnState = this.atn.states[ctx.getReturnState(i)];
                        this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                    }
                } finally{
                    if (removed) calledRuleStack.set(s.ruleIndex);
                }
            }
            let n = s.numberOfTransitions;
            for(let i = 0; i < n; i++){
                let t = s.transition(i);
                if (t instanceof $aybFP.RuleTransition) {
                    if (calledRuleStack.get(t.ruleIndex)) continue;
                    let newContext = ctx.getChild(t.followState.stateNumber);
                    try {
                        calledRuleStack.set(t.ruleIndex);
                        this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                    } finally{
                        calledRuleStack.clear(t.ruleIndex);
                    }
                } else if (t instanceof $fMVaR.AbstractPredicateTransition) {
                    if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                    else look.add(LL1Analyzer.HIT_PRED);
                } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else if (t instanceof $aPmi9.WildcardTransition) look.addAll($hGRod.IntervalSet.of($2DVsz.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                else {
                    let set = t.label;
                    if (set != null) {
                        if (t instanceof $FLEKS.NotSetTransition) set = set.complement($hGRod.IntervalSet.of($2DVsz.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                        look.addAll(set);
                    }
                }
            }
        }
    };
    $d528f592a4fe7f4e$var$LL1Analyzer.HIT_PRED = $2DVsz.Token.INVALID_TYPE;
    $d528f592a4fe7f4e$var$__decorate([
        $d6D31.NotNull
    ], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "atn", void 0);
    $d528f592a4fe7f4e$var$__decorate([
        $d6D31.NotNull,
        $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(1, $d6D31.NotNull)
    ], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "LOOK", null);
    $d528f592a4fe7f4e$var$__decorate([
        $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(2, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(3, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(4, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(5, $d6D31.NotNull)
    ], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "_LOOK", null);
    $d528f592a4fe7f4e$var$LL1Analyzer = $d528f592a4fe7f4e$var$__decorate([
        $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull)
    ], $d528f592a4fe7f4e$var$LL1Analyzer);
    module.exports.LL1Analyzer = $d528f592a4fe7f4e$var$LL1Analyzer;
});
parcelRegister("FLEKS", function(module, exports) {
    "use strict";
    var $07d8cc01972b24a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $07d8cc01972b24a7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.NotSetTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $Np2R3 = parcelRequire("Np2R3");
    let $07d8cc01972b24a7$var$NotSetTransition = class NotSetTransition extends $Np2R3.SetTransition {
        constructor(target, set){
            super(target, set);
        }
        get serializationType() {
            return 8;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
        }
        toString() {
            return "~" + super.toString();
        }
    };
    $07d8cc01972b24a7$var$__decorate([
        $d6D31.Override
    ], $07d8cc01972b24a7$var$NotSetTransition.prototype, "serializationType", null);
    $07d8cc01972b24a7$var$__decorate([
        $d6D31.Override
    ], $07d8cc01972b24a7$var$NotSetTransition.prototype, "matches", null);
    $07d8cc01972b24a7$var$__decorate([
        $d6D31.Override
    ], $07d8cc01972b24a7$var$NotSetTransition.prototype, "toString", null);
    $07d8cc01972b24a7$var$NotSetTransition = $07d8cc01972b24a7$var$__decorate([
        $07d8cc01972b24a7$var$__param(0, $d6D31.NotNull),
        $07d8cc01972b24a7$var$__param(1, $d6D31.Nullable)
    ], $07d8cc01972b24a7$var$NotSetTransition);
    module.exports.NotSetTransition = $07d8cc01972b24a7$var$NotSetTransition;
});
parcelRegister("Np2R3", function(module, exports) {
    "use strict";
    var $094801244c2d1a04$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $094801244c2d1a04$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SetTransition = void 0;
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $094801244c2d1a04$var$SetTransition = class SetTransition extends $5tcOQ.Transition {
        constructor(target, set){
            super(target);
            if (set == null) set = $hGRod.IntervalSet.of($2DVsz.Token.INVALID_TYPE);
            this.set = set;
        }
        get serializationType() {
            return 7;
        }
        get label() {
            return this.set;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return this.set.contains(symbol);
        }
        toString() {
            return this.set.toString();
        }
    };
    $094801244c2d1a04$var$__decorate([
        $d6D31.NotNull
    ], $094801244c2d1a04$var$SetTransition.prototype, "set", void 0);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override
    ], $094801244c2d1a04$var$SetTransition.prototype, "serializationType", null);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $094801244c2d1a04$var$SetTransition.prototype, "label", null);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override
    ], $094801244c2d1a04$var$SetTransition.prototype, "matches", null);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $094801244c2d1a04$var$SetTransition.prototype, "toString", null);
    $094801244c2d1a04$var$SetTransition = $094801244c2d1a04$var$__decorate([
        $094801244c2d1a04$var$__param(0, $d6D31.NotNull),
        $094801244c2d1a04$var$__param(1, $d6D31.Nullable)
    ], $094801244c2d1a04$var$SetTransition);
    module.exports.SetTransition = $094801244c2d1a04$var$SetTransition;
});
parcelRegister("4kGBm", function(module, exports) {
    "use strict";
    var $327a1377d5873c46$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleStopState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $327a1377d5873c46$var$RuleStopState extends $7j0Pc.ATNState {
        get nonStopStateNumber() {
            return -1;
        }
        get stateType() {
            return $1bs3X.ATNStateType.RULE_STOP;
        }
    }
    $327a1377d5873c46$var$__decorate([
        $d6D31.Override
    ], $327a1377d5873c46$var$RuleStopState.prototype, "nonStopStateNumber", null);
    $327a1377d5873c46$var$__decorate([
        $d6D31.Override
    ], $327a1377d5873c46$var$RuleStopState.prototype, "stateType", null);
    module.exports.RuleStopState = $327a1377d5873c46$var$RuleStopState;
});
parcelRegister("aybFP", function(module, exports) {
    "use strict";
    var $7ae622834621fa3c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7ae622834621fa3c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $7ae622834621fa3c$var$RuleTransition = class RuleTransition extends $5tcOQ.Transition {
        constructor(ruleStart, ruleIndex, precedence, followState){
            super(ruleStart);
            this.tailCall = false;
            this.optimizedTailCall = false;
            this.ruleIndex = ruleIndex;
            this.precedence = precedence;
            this.followState = followState;
        }
        get serializationType() {
            return 3;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
    };
    $7ae622834621fa3c$var$__decorate([
        $d6D31.NotNull
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "followState", void 0);
    $7ae622834621fa3c$var$__decorate([
        $d6D31.Override
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "serializationType", null);
    $7ae622834621fa3c$var$__decorate([
        $d6D31.Override
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "isEpsilon", null);
    $7ae622834621fa3c$var$__decorate([
        $d6D31.Override
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "matches", null);
    $7ae622834621fa3c$var$RuleTransition = $7ae622834621fa3c$var$__decorate([
        $7ae622834621fa3c$var$__param(0, $d6D31.NotNull),
        $7ae622834621fa3c$var$__param(3, $d6D31.NotNull)
    ], $7ae622834621fa3c$var$RuleTransition);
    module.exports.RuleTransition = $7ae622834621fa3c$var$RuleTransition;
});
parcelRegister("aPmi9", function(module, exports) {
    "use strict";
    var $7e1ff581bbf7382f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7e1ff581bbf7382f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.WildcardTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $7e1ff581bbf7382f$var$WildcardTransition = class WildcardTransition extends $5tcOQ.Transition {
        constructor(target){
            super(target);
        }
        get serializationType() {
            return 9;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
        }
        toString() {
            return ".";
        }
    };
    $7e1ff581bbf7382f$var$__decorate([
        $d6D31.Override
    ], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "serializationType", null);
    $7e1ff581bbf7382f$var$__decorate([
        $d6D31.Override
    ], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "matches", null);
    $7e1ff581bbf7382f$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "toString", null);
    $7e1ff581bbf7382f$var$WildcardTransition = $7e1ff581bbf7382f$var$__decorate([
        $7e1ff581bbf7382f$var$__param(0, $d6D31.NotNull)
    ], $7e1ff581bbf7382f$var$WildcardTransition);
    module.exports.WildcardTransition = $7e1ff581bbf7382f$var$WildcardTransition;
});
parcelRegister("3AYVu", function(module, exports) {
    "use strict";
    var $29e3fe8db7459e78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $29e3fe8db7459e78$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerActionExecutor = void 0;
    var $3sNxf = parcelRequire("3sNxf");
    var $4LVXs = parcelRequire("4LVXs");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    let $29e3fe8db7459e78$var$LexerActionExecutor = class LexerActionExecutor {
        constructor(lexerActions){
            this._lexerActions = lexerActions;
            let hash = $iXFjm.MurmurHash.initialize();
            for (let lexerAction of lexerActions)hash = $iXFjm.MurmurHash.update(hash, lexerAction);
            this.cachedHashCode = $iXFjm.MurmurHash.finish(hash, lexerActions.length);
        }
        static append(lexerActionExecutor, lexerAction) {
            if (!lexerActionExecutor) return new LexerActionExecutor([
                lexerAction
            ]);
            let lexerActions = lexerActionExecutor._lexerActions.slice(0);
            lexerActions.push(lexerAction);
            return new LexerActionExecutor(lexerActions);
        }
        fixOffsetBeforeMatch(offset) {
            let updatedLexerActions;
            for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $4LVXs.LexerIndexedCustomAction)) {
                if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
                updatedLexerActions[i] = new $4LVXs.LexerIndexedCustomAction(offset, this._lexerActions[i]);
            }
            if (!updatedLexerActions) return this;
            return new LexerActionExecutor(updatedLexerActions);
        }
        get lexerActions() {
            return this._lexerActions;
        }
        execute(lexer, input, startIndex) {
            let requiresSeek = false;
            let stopIndex = input.index;
            try {
                for (let lexerAction of this._lexerActions){
                    if (lexerAction instanceof $4LVXs.LexerIndexedCustomAction) {
                        let offset = lexerAction.offset;
                        input.seek(startIndex + offset);
                        lexerAction = lexerAction.action;
                        requiresSeek = startIndex + offset !== stopIndex;
                    } else if (lexerAction.isPositionDependent) {
                        input.seek(stopIndex);
                        requiresSeek = false;
                    }
                    lexerAction.execute(lexer);
                }
            } finally{
                if (requiresSeek) input.seek(stopIndex);
            }
        }
        hashCode() {
            return this.cachedHashCode;
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof LexerActionExecutor)) return false;
            return this.cachedHashCode === obj.cachedHashCode && $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
        }
    };
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.NotNull
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.NotNull
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "lexerActions", null);
    $29e3fe8db7459e78$var$__decorate([
        $29e3fe8db7459e78$var$__param(0, $d6D31.NotNull)
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "execute", null);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.Override
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "hashCode", null);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.Override
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "equals", null);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.NotNull,
        $29e3fe8db7459e78$var$__param(1, $d6D31.NotNull)
    ], $29e3fe8db7459e78$var$LexerActionExecutor, "append", null);
    $29e3fe8db7459e78$var$LexerActionExecutor = $29e3fe8db7459e78$var$__decorate([
        $29e3fe8db7459e78$var$__param(0, $d6D31.NotNull)
    ], $29e3fe8db7459e78$var$LexerActionExecutor);
    module.exports.LexerActionExecutor = $29e3fe8db7459e78$var$LexerActionExecutor;
});
parcelRegister("4LVXs", function(module, exports) {
    "use strict";
    var $3798827adeb28bf0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $3798827adeb28bf0$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerIndexedCustomAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    let $3798827adeb28bf0$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
        constructor(offset, action){
            this._offset = offset;
            this._action = action;
        }
        get offset() {
            return this._offset;
        }
        get action() {
            return this._action;
        }
        get actionType() {
            return this._action.actionType;
        }
        get isPositionDependent() {
            return true;
        }
        execute(lexer) {
            this._action.execute(lexer);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this._offset);
            hash = $iXFjm.MurmurHash.update(hash, this._action);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof LexerIndexedCustomAction)) return false;
            return this._offset === obj._offset && this._action.equals(obj._action);
        }
    };
    $3798827adeb28bf0$var$__decorate([
        $d6D31.NotNull
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "action", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "actionType", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "execute", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "hashCode", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "equals", null);
    $3798827adeb28bf0$var$LexerIndexedCustomAction = $3798827adeb28bf0$var$__decorate([
        $3798827adeb28bf0$var$__param(1, $d6D31.NotNull)
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction);
    module.exports.LexerIndexedCustomAction = $3798827adeb28bf0$var$LexerIndexedCustomAction;
});
parcelRegister("fOEQQ", function(module, exports) {
    "use strict";
    var $b83b36c534666cfd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $b83b36c534666cfd$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerNoViableAltException = void 0;
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    var $gcfUE = parcelRequire("gcfUE");
    var $2IEP9 = parcelRequire("2IEP9");
    let $b83b36c534666cfd$var$LexerNoViableAltException = class LexerNoViableAltException extends $fLdDn.RecognitionException {
        constructor(lexer, input, startIndex, deadEndConfigs){
            super(lexer, input);
            this._startIndex = startIndex;
            this._deadEndConfigs = deadEndConfigs;
        }
        get startIndex() {
            return this._startIndex;
        }
        get deadEndConfigs() {
            return this._deadEndConfigs;
        }
        get inputStream() {
            return super.inputStream;
        }
        toString() {
            let symbol = "";
            if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
                symbol = this.inputStream.getText($gcfUE.Interval.of(this._startIndex, this._startIndex));
                symbol = $2IEP9.escapeWhitespace(symbol, false);
            }
            return `LexerNoViableAltException('${symbol}')`;
        }
    };
    $b83b36c534666cfd$var$__decorate([
        $d6D31.Override
    ], $b83b36c534666cfd$var$LexerNoViableAltException.prototype, "inputStream", null);
    $b83b36c534666cfd$var$__decorate([
        $d6D31.Override
    ], $b83b36c534666cfd$var$LexerNoViableAltException.prototype, "toString", null);
    $b83b36c534666cfd$var$LexerNoViableAltException = $b83b36c534666cfd$var$__decorate([
        $b83b36c534666cfd$var$__param(1, $d6D31.NotNull)
    ], $b83b36c534666cfd$var$LexerNoViableAltException);
    module.exports.LexerNoViableAltException = $b83b36c534666cfd$var$LexerNoViableAltException;
});
parcelRegister("9tIYC", function(module, exports) {
    "use strict";
    var $6e69b5e962f238b8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.OrderedATNConfigSet = void 0;
    var $c1ClW = parcelRequire("c1ClW");
    var $d6D31 = parcelRequire("d6D31");
    class $6e69b5e962f238b8$var$OrderedATNConfigSet extends $c1ClW.ATNConfigSet {
        constructor(set, readonly){
            if (set != null && readonly != null) super(set, readonly);
            else super();
        }
        clone(readonly) {
            let copy = new $6e69b5e962f238b8$var$OrderedATNConfigSet(this, readonly);
            if (!readonly && this.isReadOnly) copy.addAll(this);
            return copy;
        }
        getKey(e) {
            return {
                state: 0,
                alt: e.hashCode()
            };
        }
        canMerge(left, leftKey, right) {
            return left.equals(right);
        }
    }
    $6e69b5e962f238b8$var$__decorate([
        $d6D31.Override
    ], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "clone", null);
    $6e69b5e962f238b8$var$__decorate([
        $d6D31.Override
    ], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "getKey", null);
    $6e69b5e962f238b8$var$__decorate([
        $d6D31.Override
    ], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "canMerge", null);
    module.exports.OrderedATNConfigSet = $6e69b5e962f238b8$var$OrderedATNConfigSet;
});
parcelRegister("hKCjP", function(module, exports) {
    "use strict";
    var $cec474d99a10f341$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.NoViableAltException = void 0;
    var $jIG0W = parcelRequire("jIG0W");
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    class $cec474d99a10f341$var$NoViableAltException extends $fLdDn.RecognitionException {
        constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
            if (recognizer instanceof $jIG0W.Parser) {
                if (input === undefined) input = recognizer.inputStream;
                if (startToken === undefined) startToken = recognizer.currentToken;
                if (offendingToken === undefined) offendingToken = recognizer.currentToken;
                if (ctx === undefined) ctx = recognizer.context;
            }
            super(recognizer, input, ctx);
            this._deadEndConfigs = deadEndConfigs;
            this._startToken = startToken;
            this.setOffendingToken(recognizer, offendingToken);
        }
        get startToken() {
            return this._startToken;
        }
        get deadEndConfigs() {
            return this._deadEndConfigs;
        }
    }
    $cec474d99a10f341$var$__decorate([
        $d6D31.NotNull
    ], $cec474d99a10f341$var$NoViableAltException.prototype, "_startToken", void 0);
    module.exports.NoViableAltException = $cec474d99a10f341$var$NoViableAltException;
});
parcelRegister("jIG0W", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    "use strict";
    var $e5b2b780657df507$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $e5b2b780657df507$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var $e5b2b780657df507$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Parser = void 0;
    var $2IEP9 = parcelRequire("2IEP9");
    var $2M2qJ = parcelRequire("2M2qJ");
    var $dvgsl = parcelRequire("dvgsl");
    var $4CCJj = parcelRequire("4CCJj");
    var $cdCft = parcelRequire("cdCft");
    var $6Kebn = parcelRequire("6Kebn");
    var $igNLf = parcelRequire("igNLf");
    var $d6D31 = parcelRequire("d6D31");
    var $3iOjI = parcelRequire("3iOjI");
    var $kzbnL = parcelRequire("kzbnL");
    var $5xwgp = parcelRequire("5xwgp");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $kYC92 = parcelRequire("kYC92");
    var $2DVsz = parcelRequire("2DVsz");
    class $e5b2b780657df507$var$TraceListener {
        constructor(ruleNames, tokenStream){
            this.ruleNames = ruleNames;
            this.tokenStream = tokenStream;
        }
        enterEveryRule(ctx) {
            console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
        }
        exitEveryRule(ctx) {
            console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
        }
        visitErrorNode(node) {}
        visitTerminal(node) {
            let parent = node.parent.ruleContext;
            let token = node.symbol;
            console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
        }
    }
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "enterEveryRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "exitEveryRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "visitErrorNode", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "visitTerminal", null);
    class $e5b2b780657df507$var$Parser extends $kBaAZ.Recognizer {
        constructor(input){
            super();
            this._errHandler = new $4CCJj.DefaultErrorStrategy();
            this._precedenceStack = new $6Kebn.IntegerStack();
            this._buildParseTrees = true;
            this._parseListeners = [];
            this._syntaxErrors = 0;
            this.matchedEOF = false;
            this._precedenceStack.push(0);
            this.inputStream = input;
        }
        reset(resetInput) {
            if (resetInput === undefined || resetInput) this.inputStream.seek(0);
            this._errHandler.reset(this);
            this._ctx = undefined;
            this._syntaxErrors = 0;
            this.matchedEOF = false;
            this.isTrace = false;
            this._precedenceStack.clear();
            this._precedenceStack.push(0);
            let interpreter = this.interpreter;
            if (interpreter != null) interpreter.reset();
        }
        match(ttype) {
            let t = this.currentToken;
            if (t.type === ttype) {
                if (ttype === $2DVsz.Token.EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            } else {
                t = this._errHandler.recoverInline(this);
                if (this._buildParseTrees && t.tokenIndex === -1) this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
            }
            return t;
        }
        matchWildcard() {
            let t = this.currentToken;
            if (t.type > 0) {
                this._errHandler.reportMatch(this);
                this.consume();
            } else {
                t = this._errHandler.recoverInline(this);
                if (this._buildParseTrees && t.tokenIndex === -1) this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
            }
            return t;
        }
        set buildParseTree(buildParseTrees) {
            this._buildParseTrees = buildParseTrees;
        }
        get buildParseTree() {
            return this._buildParseTrees;
        }
        getParseListeners() {
            return this._parseListeners;
        }
        addParseListener(listener) {
            if (listener == null) throw new TypeError("listener cannot be null");
            this._parseListeners.push(listener);
        }
        removeParseListener(listener) {
            let index = this._parseListeners.findIndex((l)=>l === listener);
            if (index !== -1) this._parseListeners.splice(index, 1);
        }
        removeParseListeners() {
            this._parseListeners.length = 0;
        }
        triggerEnterRuleEvent() {
            for (let listener of this._parseListeners){
                if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
                this._ctx.enterRule(listener);
            }
        }
        triggerExitRuleEvent() {
            for(let i = this._parseListeners.length - 1; i >= 0; i--){
                let listener = this._parseListeners[i];
                this._ctx.exitRule(listener);
                if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
            }
        }
        get numberOfSyntaxErrors() {
            return this._syntaxErrors;
        }
        get tokenFactory() {
            return this._input.tokenSource.tokenFactory;
        }
        getATNWithBypassAlts() {
            let serializedAtn = this.serializedATN;
            if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
            let result = $e5b2b780657df507$var$Parser.bypassAltsAtnCache.get(serializedAtn);
            if (result == null) {
                let deserializationOptions = new $2M2qJ.ATNDeserializationOptions();
                deserializationOptions.isGenerateRuleBypassTransitions = true;
                result = new $dvgsl.ATNDeserializer(deserializationOptions).deserialize($2IEP9.toCharArray(serializedAtn));
                $e5b2b780657df507$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
            }
            return result;
        }
        compileParseTreePattern(pattern, patternRuleIndex, lexer) {
            return $e5b2b780657df507$var$__awaiter(this, void 0, void 0, function*() {
                if (!lexer) {
                    if (this.inputStream) {
                        let tokenSource = this.inputStream.tokenSource;
                        if (tokenSource instanceof $igNLf.Lexer) lexer = tokenSource;
                    }
                    if (!lexer) throw new Error("Parser can't discover a lexer to use");
                }
                let currentLexer = lexer;
                let m = yield Promise.resolve().then(()=>(parcelRequire("dE6Cn")));
                let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
                return matcher.compile(pattern, patternRuleIndex);
            });
        }
        get errorHandler() {
            return this._errHandler;
        }
        set errorHandler(handler) {
            this._errHandler = handler;
        }
        get inputStream() {
            return this._input;
        }
        set inputStream(input) {
            this.reset(false);
            this._input = input;
        }
        get currentToken() {
            return this._input.LT(1);
        }
        notifyErrorListeners(msg, offendingToken, e) {
            if (offendingToken === undefined) offendingToken = this.currentToken;
            else if (offendingToken === null) offendingToken = undefined;
            this._syntaxErrors++;
            let line = -1;
            let charPositionInLine = -1;
            if (offendingToken != null) {
                line = offendingToken.line;
                charPositionInLine = offendingToken.charPositionInLine;
            }
            let listener = this.getErrorListenerDispatch();
            if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
        }
        consume() {
            let o = this.currentToken;
            if (o.type !== $e5b2b780657df507$var$Parser.EOF) this.inputStream.consume();
            let hasListener = this._parseListeners.length !== 0;
            if (this._buildParseTrees || hasListener) {
                if (this._errHandler.inErrorRecoveryMode(this)) {
                    let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                    if (hasListener) {
                        for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                    }
                } else {
                    let node = this.createTerminalNode(this._ctx, o);
                    this._ctx.addChild(node);
                    if (hasListener) {
                        for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                    }
                }
            }
            return o;
        }
        createTerminalNode(parent, t) {
            return new $kYC92.TerminalNode(t);
        }
        createErrorNode(parent, t) {
            return new $cdCft.ErrorNode(t);
        }
        addContextToParseTree() {
            let parent = this._ctx._parent;
            if (parent != null) parent.addChild(this._ctx);
        }
        enterRule(localctx, state, ruleIndex) {
            this.state = state;
            this._ctx = localctx;
            this._ctx._start = this._input.LT(1);
            if (this._buildParseTrees) this.addContextToParseTree();
            this.triggerEnterRuleEvent();
        }
        enterLeftFactoredRule(localctx, state, ruleIndex) {
            this.state = state;
            if (this._buildParseTrees) {
                let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
                this._ctx.removeLastChild();
                factoredContext._parent = localctx;
                localctx.addChild(factoredContext);
            }
            this._ctx = localctx;
            this._ctx._start = this._input.LT(1);
            if (this._buildParseTrees) this.addContextToParseTree();
            this.triggerEnterRuleEvent();
        }
        exitRule() {
            if (this.matchedEOF) this._ctx._stop = this._input.LT(1);
            else this._ctx._stop = this._input.tryLT(-1);
            this.triggerExitRuleEvent();
            this.state = this._ctx.invokingState;
            this._ctx = this._ctx._parent;
        }
        enterOuterAlt(localctx, altNum) {
            localctx.altNumber = altNum;
            if (this._buildParseTrees && this._ctx !== localctx) {
                let parent = this._ctx._parent;
                if (parent != null) {
                    parent.removeLastChild();
                    parent.addChild(localctx);
                }
            }
            this._ctx = localctx;
        }
        get precedence() {
            if (this._precedenceStack.isEmpty) return -1;
            return this._precedenceStack.peek();
        }
        enterRecursionRule(localctx, state, ruleIndex, precedence) {
            this.state = state;
            this._precedenceStack.push(precedence);
            this._ctx = localctx;
            this._ctx._start = this._input.LT(1);
            this.triggerEnterRuleEvent();
        }
        pushNewRecursionContext(localctx, state, ruleIndex) {
            let previous = this._ctx;
            previous._parent = localctx;
            previous.invokingState = state;
            previous._stop = this._input.tryLT(-1);
            this._ctx = localctx;
            this._ctx._start = previous._start;
            if (this._buildParseTrees) this._ctx.addChild(previous);
            this.triggerEnterRuleEvent();
        }
        unrollRecursionContexts(_parentctx) {
            this._precedenceStack.pop();
            this._ctx._stop = this._input.tryLT(-1);
            let retctx = this._ctx;
            if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
                this.triggerExitRuleEvent();
                this._ctx = this._ctx._parent;
            }
            else this._ctx = _parentctx;
            retctx._parent = _parentctx;
            if (this._buildParseTrees && _parentctx != null) _parentctx.addChild(retctx);
        }
        getInvokingContext(ruleIndex) {
            let p = this._ctx;
            while(p && p.ruleIndex !== ruleIndex)p = p._parent;
            return p;
        }
        get context() {
            return this._ctx;
        }
        set context(ctx) {
            this._ctx = ctx;
        }
        precpred(localctx, precedence) {
            return precedence >= this._precedenceStack.peek();
        }
        getErrorListenerDispatch() {
            return new $5xwgp.ProxyParserErrorListener(this.getErrorListeners());
        }
        inContext(context) {
            return false;
        }
        isExpectedToken(symbol) {
            let atn = this.interpreter.atn;
            let ctx = this._ctx;
            let s = atn.states[this.state];
            let following = atn.nextTokens(s);
            if (following.contains(symbol)) return true;
            if (!following.contains($2DVsz.Token.EPSILON)) return false;
            while(ctx != null && ctx.invokingState >= 0 && following.contains($2DVsz.Token.EPSILON)){
                let invokingState = atn.states[ctx.invokingState];
                let rt = invokingState.transition(0);
                following = atn.nextTokens(rt.followState);
                if (following.contains(symbol)) return true;
                ctx = ctx._parent;
            }
            if (following.contains($2DVsz.Token.EPSILON) && symbol === $2DVsz.Token.EOF) return true;
            return false;
        }
        get isMatchedEOF() {
            return this.matchedEOF;
        }
        getExpectedTokens() {
            return this.atn.getExpectedTokens(this.state, this.context);
        }
        getExpectedTokensWithinCurrentRule() {
            let atn = this.interpreter.atn;
            let s = atn.states[this.state];
            return atn.nextTokens(s);
        }
        getRuleIndex(ruleName) {
            let ruleIndex = this.getRuleIndexMap().get(ruleName);
            if (ruleIndex != null) return ruleIndex;
            return -1;
        }
        get ruleContext() {
            return this._ctx;
        }
        getRuleInvocationStack(ctx = this._ctx) {
            let p = ctx;
            let ruleNames = this.ruleNames;
            let stack = [];
            while(p != null){
                let ruleIndex = p.ruleIndex;
                if (ruleIndex < 0) stack.push("n/a");
                else stack.push(ruleNames[ruleIndex]);
                p = p._parent;
            }
            return stack;
        }
        getDFAStrings() {
            let s = [];
            for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
            return s;
        }
        dumpDFA() {
            let seenOne = false;
            for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
                if (seenOne) console.log();
                console.log("Decision " + dfa.decision + ":");
                $6cAn5.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
                seenOne = true;
            }
        }
        get sourceName() {
            return this._input.sourceName;
        }
        get parseInfo() {
            return Promise.resolve().then(()=>(parcelRequire("kSEFX"))).then((m)=>{
                let interp = this.interpreter;
                if (interp instanceof m.ProfilingATNSimulator) return new $3iOjI.ParseInfo(interp);
                return undefined;
            });
        }
        setProfile(profile) {
            return $e5b2b780657df507$var$__awaiter(this, void 0, void 0, function*() {
                let m = yield Promise.resolve().then(()=>(parcelRequire("kSEFX")));
                let interp = this.interpreter;
                if (profile) {
                    if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
                } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $kzbnL.ParserATNSimulator(this.atn, this);
                this.interpreter.setPredictionMode(interp.getPredictionMode());
            });
        }
        set isTrace(trace) {
            if (!trace) {
                if (this._tracer) {
                    this.removeParseListener(this._tracer);
                    this._tracer = undefined;
                }
            } else {
                if (this._tracer) this.removeParseListener(this._tracer);
                else this._tracer = new $e5b2b780657df507$var$TraceListener(this.ruleNames, this._input);
                this.addParseListener(this._tracer);
            }
        }
        get isTrace() {
            return this._tracer != null;
        }
    }
    $e5b2b780657df507$var$Parser.bypassAltsAtnCache = new Map();
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "_errHandler", void 0);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "match", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "matchWildcard", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getParseListeners", null);
    $e5b2b780657df507$var$__decorate([
        $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
    ], $e5b2b780657df507$var$Parser.prototype, "addParseListener", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getATNWithBypassAlts", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull,
        $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
    ], $e5b2b780657df507$var$Parser.prototype, "errorHandler", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$Parser.prototype, "inputStream", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "currentToken", null);
    $e5b2b780657df507$var$__decorate([
        $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
    ], $e5b2b780657df507$var$Parser.prototype, "enterRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override,
        $e5b2b780657df507$var$__param(0, $d6D31.Nullable)
    ], $e5b2b780657df507$var$Parser.prototype, "precpred", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$Parser.prototype, "getErrorListenerDispatch", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getExpectedTokens", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$Parser.prototype, "parseInfo", null);
    module.exports.Parser = $e5b2b780657df507$var$Parser;
});
parcelRegister("2M2qJ", function(module, exports) {
    "use strict";
    var $2051f30d0c577226$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNDeserializationOptions = void 0;
    var $d6D31 = parcelRequire("d6D31");
    class $2051f30d0c577226$var$ATNDeserializationOptions {
        constructor(options){
            this.readOnly = false;
            if (options) {
                this.verifyATN = options.verifyATN;
                this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
                this.optimize = options.optimize;
            } else {
                this.verifyATN = true;
                this.generateRuleBypassTransitions = false;
                this.optimize = true;
            }
        }
        static get defaultOptions() {
            if ($2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions == null) {
                $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions = new $2051f30d0c577226$var$ATNDeserializationOptions();
                $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
            }
            return $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions;
        }
        get isReadOnly() {
            return this.readOnly;
        }
        makeReadOnly() {
            this.readOnly = true;
        }
        get isVerifyATN() {
            return this.verifyATN;
        }
        set isVerifyATN(verifyATN) {
            this.throwIfReadOnly();
            this.verifyATN = verifyATN;
        }
        get isGenerateRuleBypassTransitions() {
            return this.generateRuleBypassTransitions;
        }
        set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
            this.throwIfReadOnly();
            this.generateRuleBypassTransitions = generateRuleBypassTransitions;
        }
        get isOptimize() {
            return this.optimize;
        }
        set isOptimize(optimize) {
            this.throwIfReadOnly();
            this.optimize = optimize;
        }
        throwIfReadOnly() {
            if (this.isReadOnly) throw new Error("The object is read only.");
        }
    }
    $2051f30d0c577226$var$__decorate([
        $d6D31.NotNull
    ], $2051f30d0c577226$var$ATNDeserializationOptions, "defaultOptions", null);
    module.exports.ATNDeserializationOptions = $2051f30d0c577226$var$ATNDeserializationOptions;
});
parcelRegister("dvgsl", function(module, exports) {
    "use strict";
    var $9d4aef733dce84f9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $9d4aef733dce84f9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNDeserializer = void 0;
    var $gxlfY = parcelRequire("gxlfY");
    var $7Veax = parcelRequire("7Veax");
    var $bcnvE = parcelRequire("bcnvE");
    var $2M2qJ = parcelRequire("2M2qJ");
    var $1bs3X = parcelRequire("1bs3X");
    var $5r7n7 = parcelRequire("5r7n7");
    var $gAm9p = parcelRequire("gAm9p");
    var $4yiuQ = parcelRequire("4yiuQ");
    var $5BPMp = parcelRequire("5BPMp");
    var $loKp0 = parcelRequire("loKp0");
    var $65vNG = parcelRequire("65vNG");
    var $dPYn6 = parcelRequire("dPYn6");
    var $jJRyp = parcelRequire("jJRyp");
    var $bpnRH = parcelRequire("bpnRH");
    var $hGRod = parcelRequire("hGRod");
    var $l4Nh1 = parcelRequire("l4Nh1");
    var $iw4Ko = parcelRequire("iw4Ko");
    var $RgRAX = parcelRequire("RgRAX");
    var $jgJtt = parcelRequire("jgJtt");
    var $l606e = parcelRequire("l606e");
    var $6hIs4 = parcelRequire("6hIs4");
    var $a9nIX = parcelRequire("a9nIX");
    var $2Gb96 = parcelRequire("2Gb96");
    var $ayRdK = parcelRequire("ayRdK");
    var $kfqEk = parcelRequire("kfqEk");
    var $d6D31 = parcelRequire("d6D31");
    var $FLEKS = parcelRequire("FLEKS");
    var $kzbnL = parcelRequire("kzbnL");
    var $d1V7w = parcelRequire("d1V7w");
    var $7qlbM = parcelRequire("7qlbM");
    var $7KGEQ = parcelRequire("7KGEQ");
    var $hnaRv = parcelRequire("hnaRv");
    var $aISkF = parcelRequire("aISkF");
    var $j2zc8 = parcelRequire("j2zc8");
    var $4kGBm = parcelRequire("4kGBm");
    var $aybFP = parcelRequire("aybFP");
    var $Np2R3 = parcelRequire("Np2R3");
    var $jEsaF = parcelRequire("jEsaF");
    var $bjwd1 = parcelRequire("bjwd1");
    var $f9raX = parcelRequire("f9raX");
    var $2DVsz = parcelRequire("2DVsz");
    var $WS4d7 = parcelRequire("WS4d7");
    var $kWxOc = parcelRequire("kWxOc");
    var $aPmi9 = parcelRequire("aPmi9");
    var $9d4aef733dce84f9$var$UnicodeDeserializingMode;
    (function(UnicodeDeserializingMode) {
        UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
        UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
    })($9d4aef733dce84f9$var$UnicodeDeserializingMode || ($9d4aef733dce84f9$var$UnicodeDeserializingMode = {}));
    class $9d4aef733dce84f9$var$ATNDeserializer {
        constructor(deserializationOptions){
            if (deserializationOptions === undefined) deserializationOptions = $2M2qJ.ATNDeserializationOptions.defaultOptions;
            this.deserializationOptions = deserializationOptions;
        }
        static get SERIALIZED_VERSION() {
            return 3;
        }
        static isFeatureSupported(feature, actualUuid) {
            let featureIndex = $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
            if (featureIndex < 0) return false;
            return $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
        }
        static getUnicodeDeserializer(mode) {
            if (mode === 0) return {
                readUnicode: (data, p)=>{
                    return $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
                },
                size: 1
            };
            else return {
                readUnicode: (data, p)=>{
                    return $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, p);
                },
                size: 2
            };
        }
        deserialize(data) {
            data = data.slice(0);
            for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
            let p = 0;
            let version = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            if (version !== $9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_VERSION) {
                let reason = `Could not deserialize ATN with version ${version} (expected ${$9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_VERSION}).`;
                throw new Error(reason);
            }
            let uuid = $9d4aef733dce84f9$var$ATNDeserializer.toUUID(data, p);
            p += 8;
            if ($9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
                let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
                throw new Error(reason);
            }
            let supportsLexerActions = $9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
            let grammarType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            let maxTokenType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            let atn = new $bcnvE.ATN(grammarType, maxTokenType);
            let loopBackStateNumbers = [];
            let endStateNumbers = [];
            let nstates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nstates; i++){
                let stype = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                if (stype === $1bs3X.ATNStateType.INVALID_TYPE) {
                    atn.addState(new $l4Nh1.InvalidState());
                    continue;
                }
                let ruleIndex = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                if (ruleIndex === 0xFFFF) ruleIndex = -1;
                let s = this.stateFactory(stype, ruleIndex);
                if (stype === $1bs3X.ATNStateType.LOOP_END) {
                    let loopBackStateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    loopBackStateNumbers.push([
                        s,
                        loopBackStateNumber
                    ]);
                } else if (s instanceof $65vNG.BlockStartState) {
                    let endStateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    endStateNumbers.push([
                        s,
                        endStateNumber
                    ]);
                }
                atn.addState(s);
            }
            for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
            for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
            let numNonGreedyStates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < numNonGreedyStates; i++){
                let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.states[stateNumber].nonGreedy = true;
            }
            let numSllDecisions = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < numSllDecisions; i++){
                let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.states[stateNumber].sll = true;
            }
            let numPrecedenceStates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < numPrecedenceStates; i++){
                let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.states[stateNumber].isPrecedenceRule = true;
            }
            let nrules = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            if (atn.grammarType === 0) atn.ruleToTokenType = new Int32Array(nrules);
            atn.ruleToStartState = new Array(nrules);
            for(let i = 0; i < nrules; i++){
                let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                let startState = atn.states[s];
                startState.leftFactored = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]) !== 0;
                atn.ruleToStartState[i] = startState;
                if (atn.grammarType === 0) {
                    let tokenType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    if (tokenType === 0xFFFF) tokenType = $2DVsz.Token.EOF;
                    atn.ruleToTokenType[i] = tokenType;
                    if (!$9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                        let actionIndexIgnored = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                    }
                }
            }
            atn.ruleToStopState = new Array(nrules);
            for (let state of atn.states){
                if (!(state instanceof $4kGBm.RuleStopState)) continue;
                atn.ruleToStopState[state.ruleIndex] = state;
                atn.ruleToStartState[state.ruleIndex].stopState = state;
            }
            let nmodes = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nmodes; i++){
                let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.modeToStartState.push(atn.states[s]);
            }
            atn.modeToDFA = new Array(nmodes);
            for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $jJRyp.DFA(atn.modeToStartState[i]);
            let sets = [];
            p = this.deserializeSets(data, p, sets, $9d4aef733dce84f9$var$ATNDeserializer.getUnicodeDeserializer(0));
            if ($9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $9d4aef733dce84f9$var$ATNDeserializer.getUnicodeDeserializer(1));
            let nedges = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nedges; i++){
                let src = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
                let trg = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 1]);
                let ttype = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 2]);
                let arg1 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 3]);
                let arg2 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 4]);
                let arg3 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 5]);
                let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
                let srcState = atn.states[src];
                srcState.addTransition(trans);
                p += 6;
            }
            let returnTransitionsSet = new $7Veax.Array2DHashSet({
                hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
                equals: (a, b)=>{
                    return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
                }
            });
            let returnTransitions = [];
            for (let state of atn.states){
                let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
                for(let i = 0; i < state.numberOfTransitions; i++){
                    let t = state.transition(i);
                    if (!(t instanceof $aybFP.RuleTransition)) continue;
                    let ruleTransition = t;
                    let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                    if (!returningFromLeftFactored && returningToLeftFactored) continue;
                    let outermostPrecedenceReturn = -1;
                    if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                        if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                    }
                    let current = {
                        stopState: ruleTransition.target.ruleIndex,
                        returnState: ruleTransition.followState.stateNumber,
                        outermostPrecedenceReturn: outermostPrecedenceReturn
                    };
                    if (returnTransitionsSet.add(current)) returnTransitions.push(current);
                }
            }
            for (let returnTransition of returnTransitions){
                let transition = new $bpnRH.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
                atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
            }
            for (let state of atn.states){
                if (state instanceof $65vNG.BlockStartState) {
                    if (state.endState === undefined) throw new Error("IllegalStateException");
                    if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                    state.endState.startState = state;
                }
                if (state instanceof $7qlbM.PlusLoopbackState) {
                    let loopbackState = state;
                    for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                        let target = loopbackState.transition(i).target;
                        if (target instanceof $d1V7w.PlusBlockStartState) target.loopBackState = loopbackState;
                    }
                } else if (state instanceof $bjwd1.StarLoopbackState) {
                    let loopbackState = state;
                    for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                        let target = loopbackState.transition(i).target;
                        if (target instanceof $f9raX.StarLoopEntryState) target.loopBackState = loopbackState;
                    }
                }
            }
            let ndecisions = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 1; i <= ndecisions; i++){
                let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                let decState = atn.states[s];
                atn.decisionToState.push(decState);
                decState.decision = i - 1;
            }
            if (atn.grammarType === 0) {
                if (supportsLexerActions) {
                    atn.lexerActions = new Array($9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]));
                    for(let i = 0; i < atn.lexerActions.length; i++){
                        let actionType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        let data1 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        if (data1 === 0xFFFF) data1 = -1;
                        let data2 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        if (data2 === 0xFFFF) data2 = -1;
                        let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                        atn.lexerActions[i] = lexerAction;
                    }
                } else {
                    let legacyLexerActions = [];
                    for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                        let transition = state.transition(i);
                        if (!(transition instanceof $gxlfY.ActionTransition)) continue;
                        let ruleIndex = transition.ruleIndex;
                        let actionIndex = transition.actionIndex;
                        let lexerAction = new $RgRAX.LexerCustomAction(ruleIndex, actionIndex);
                        state.setTransition(i, new $gxlfY.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                        legacyLexerActions.push(lexerAction);
                    }
                    atn.lexerActions = legacyLexerActions;
                }
            }
            this.markPrecedenceDecisions(atn);
            atn.decisionToDFA = new Array(ndecisions);
            for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $jJRyp.DFA(atn.decisionToState[i], i);
            if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
            if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1) {
                atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
                for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
                for(let i = 0; i < atn.ruleToStartState.length; i++){
                    let bypassStart = new $gAm9p.BasicBlockStartState();
                    bypassStart.ruleIndex = i;
                    atn.addState(bypassStart);
                    let bypassStop = new $loKp0.BlockEndState();
                    bypassStop.ruleIndex = i;
                    atn.addState(bypassStop);
                    bypassStart.endState = bypassStop;
                    atn.defineDecisionState(bypassStart);
                    bypassStop.startState = bypassStart;
                    let endState;
                    let excludeTransition;
                    if (atn.ruleToStartState[i].isPrecedenceRule) {
                        endState = undefined;
                        for (let state of atn.states){
                            if (state.ruleIndex !== i) continue;
                            if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                            let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                            if (!(maybeLoopEndState instanceof $kfqEk.LoopEndState)) continue;
                            if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4kGBm.RuleStopState) {
                                endState = state;
                                break;
                            }
                        }
                        if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                        excludeTransition = endState.loopBackState.transition(0);
                    } else endState = atn.ruleToStopState[i];
                    for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                        let transition = state.transition(i);
                        if (transition === excludeTransition) continue;
                        if (transition.target === endState) transition.target = bypassStop;
                    }
                    while(atn.ruleToStartState[i].numberOfTransitions > 0){
                        let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                        bypassStart.addTransition(transition);
                    }
                    atn.ruleToStartState[i].addTransition(new $bpnRH.EpsilonTransition(bypassStart));
                    bypassStop.addTransition(new $bpnRH.EpsilonTransition(endState));
                    let matchState = new $4yiuQ.BasicState();
                    atn.addState(matchState);
                    matchState.addTransition(new $5r7n7.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                    bypassStart.addTransition(new $bpnRH.EpsilonTransition(matchState));
                }
                if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
            }
            if (this.deserializationOptions.isOptimize) {
                while(true){
                    let optimizationCount = 0;
                    optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.inlineSetRules(atn);
                    optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.combineChainedEpsilons(atn);
                    let preserveOrder = atn.grammarType === 0;
                    optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                    if (optimizationCount === 0) break;
                }
                if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
            }
            $9d4aef733dce84f9$var$ATNDeserializer.identifyTailCalls(atn);
            return atn;
        }
        deserializeSets(data, p, sets, unicodeDeserializer) {
            let nsets = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nsets; i++){
                let nintervals = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
                p++;
                let set = new $hGRod.IntervalSet();
                sets.push(set);
                let containsEof = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]) !== 0;
                if (containsEof) set.add(-1);
                for(let j = 0; j < nintervals; j++){
                    let a = unicodeDeserializer.readUnicode(data, p);
                    p += unicodeDeserializer.size;
                    let b = unicodeDeserializer.readUnicode(data, p);
                    p += unicodeDeserializer.size;
                    set.add(a, b);
                }
            }
            return p;
        }
        markPrecedenceDecisions(atn) {
            let rulePrecedenceDecisions = new Map();
            for (let state of atn.states){
                if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                    let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                    if (maybeLoopEndState instanceof $kfqEk.LoopEndState) {
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4kGBm.RuleStopState) {
                            rulePrecedenceDecisions.set(state.ruleIndex, state);
                            state.precedenceRuleDecision = true;
                            state.precedenceLoopbackStates = new $5BPMp.BitSet(atn.states.length);
                        }
                    }
                }
            }
            for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
                if (transition.serializationType !== 1) continue;
                let epsilonTransition = transition;
                if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
                precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
            }
        }
        verifyATN(atn) {
            for (let state of atn.states){
                this.checkCondition(state !== undefined, "ATN states should not be undefined.");
                if (state.stateType === $1bs3X.ATNStateType.INVALID_TYPE) continue;
                this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
                if (state instanceof $d1V7w.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
                if (state instanceof $f9raX.StarLoopEntryState) {
                    let starLoopEntryState = state;
                    this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                    this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                    if (starLoopEntryState.transition(0).target instanceof $jEsaF.StarBlockStartState) {
                        this.checkCondition(starLoopEntryState.transition(1).target instanceof $kfqEk.LoopEndState);
                        this.checkCondition(!starLoopEntryState.nonGreedy);
                    } else if (starLoopEntryState.transition(0).target instanceof $kfqEk.LoopEndState) {
                        this.checkCondition(starLoopEntryState.transition(1).target instanceof $jEsaF.StarBlockStartState);
                        this.checkCondition(starLoopEntryState.nonGreedy);
                    } else throw new Error("IllegalStateException");
                }
                if (state instanceof $bjwd1.StarLoopbackState) {
                    this.checkCondition(state.numberOfTransitions === 1);
                    this.checkCondition(state.transition(0).target instanceof $f9raX.StarLoopEntryState);
                }
                if (state instanceof $kfqEk.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
                if (state instanceof $j2zc8.RuleStartState) this.checkCondition(state.stopState !== undefined);
                if (state instanceof $65vNG.BlockStartState) this.checkCondition(state.endState !== undefined);
                if (state instanceof $loKp0.BlockEndState) this.checkCondition(state.startState !== undefined);
                if (state instanceof $dPYn6.DecisionState) {
                    let decisionState = state;
                    this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
                } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $4kGBm.RuleStopState);
            }
        }
        checkCondition(condition, message) {
            if (!condition) throw new Error("IllegalStateException: " + message);
        }
        static inlineSetRules(atn) {
            let inlinedCalls = 0;
            let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let startState = atn.ruleToStartState[i];
                let middleState = startState;
                while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1)middleState = middleState.getOptimizedTransition(0).target;
                if (middleState.numberOfOptimizedTransitions !== 1) continue;
                let matchTransition = middleState.getOptimizedTransition(0);
                let matchTarget = matchTransition.target;
                if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $4kGBm.RuleStopState)) continue;
                switch(matchTransition.serializationType){
                    case 5:
                    case 2:
                    case 7:
                        ruleToInlineTransition[i] = matchTransition;
                        break;
                    case 8:
                    case 9:
                        continue;
                    default:
                        continue;
                }
            }
            for (let state of atn.states){
                if (state.ruleIndex < 0) continue;
                let optimizedTransitions;
                for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                    let transition = state.getOptimizedTransition(i);
                    if (!(transition instanceof $aybFP.RuleTransition)) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue;
                    }
                    let ruleTransition = transition;
                    let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                    if (effective === undefined) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue;
                    }
                    if (optimizedTransitions === undefined) {
                        optimizedTransitions = [];
                        for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                    }
                    inlinedCalls++;
                    let target = ruleTransition.followState;
                    let intermediateState = new $4yiuQ.BasicState();
                    intermediateState.setRuleIndex(target.ruleIndex);
                    atn.addState(intermediateState);
                    optimizedTransitions.push(new $bpnRH.EpsilonTransition(intermediateState));
                    switch(effective.serializationType){
                        case 5:
                            intermediateState.addTransition(new $5r7n7.AtomTransition(target, effective._label));
                            break;
                        case 2:
                            intermediateState.addTransition(new $aISkF.RangeTransition(target, effective.from, effective.to));
                            break;
                        case 7:
                            intermediateState.addTransition(new $Np2R3.SetTransition(target, effective.label));
                            break;
                        default:
                            throw new Error("UnsupportedOperationException");
                    }
                }
                if (optimizedTransitions !== undefined) {
                    if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                    for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
                }
            }
            if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
            return inlinedCalls;
        }
        static combineChainedEpsilons(atn) {
            let removedEdges = 0;
            for (let state of atn.states){
                if (!state.onlyHasEpsilonTransitions || state instanceof $4kGBm.RuleStopState) continue;
                let optimizedTransitions;
                nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                    let transition = state.getOptimizedTransition(i);
                    let intermediate = transition.target;
                    if (transition.serializationType !== 1 || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $1bs3X.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue nextTransition;
                    }
                    for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue nextTransition;
                    }
                    removedEdges++;
                    if (optimizedTransitions === undefined) {
                        optimizedTransitions = [];
                        for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                    }
                    for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                        let target = intermediate.getOptimizedTransition(j).target;
                        optimizedTransitions.push(new $bpnRH.EpsilonTransition(target));
                    }
                }
                if (optimizedTransitions !== undefined) {
                    if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                    for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
                }
            }
            if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
            return removedEdges;
        }
        static optimizeSets(atn, preserveOrder) {
            if (preserveOrder) return 0;
            let removedPaths = 0;
            let decisions = atn.decisionToState;
            for (let decision of decisions){
                let setTransitions = new $hGRod.IntervalSet();
                for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                    let epsTransition = decision.getOptimizedTransition(i);
                    if (!(epsTransition instanceof $bpnRH.EpsilonTransition)) continue;
                    if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                    let transition = epsTransition.target.getOptimizedTransition(0);
                    if (!(transition.target instanceof $loKp0.BlockEndState)) continue;
                    if (transition instanceof $FLEKS.NotSetTransition) continue;
                    if (transition instanceof $5r7n7.AtomTransition || transition instanceof $aISkF.RangeTransition || transition instanceof $Np2R3.SetTransition) setTransitions.add(i);
                }
                if (setTransitions.size <= 1) continue;
                let optimizedTransitions = [];
                for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
                let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
                let matchSet = new $hGRod.IntervalSet();
                for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                    let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                    if (matchTransition instanceof $FLEKS.NotSetTransition) throw new Error("Not yet implemented.");
                    else matchSet.addAll(matchTransition.label);
                }
                let newTransition;
                if (matchSet.intervals.length === 1) {
                    if (matchSet.size === 1) newTransition = new $5r7n7.AtomTransition(blockEndState, matchSet.minElement);
                    else {
                        let matchInterval = matchSet.intervals[0];
                        newTransition = new $aISkF.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                    }
                } else newTransition = new $Np2R3.SetTransition(blockEndState, matchSet);
                let setOptimizedState = new $4yiuQ.BasicState();
                setOptimizedState.setRuleIndex(decision.ruleIndex);
                atn.addState(setOptimizedState);
                setOptimizedState.addTransition(newTransition);
                optimizedTransitions.push(new $bpnRH.EpsilonTransition(setOptimizedState));
                removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
                if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
            }
            if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
            return removedPaths;
        }
        static identifyTailCalls(atn) {
            for (let state of atn.states){
                for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $aybFP.RuleTransition)) continue;
                    transition.tailCall = this.testTailCall(atn, transition, false);
                    transition.optimizedTailCall = this.testTailCall(atn, transition, true);
                }
                if (!state.isOptimized) continue;
                for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                    let transition = state.getOptimizedTransition(i);
                    if (!(transition instanceof $aybFP.RuleTransition)) continue;
                    transition.tailCall = this.testTailCall(atn, transition, false);
                    transition.optimizedTailCall = this.testTailCall(atn, transition, true);
                }
            }
        }
        static testTailCall(atn, transition, optimizedPath) {
            if (!optimizedPath && transition.tailCall) return true;
            if (optimizedPath && transition.optimizedTailCall) return true;
            let reachable = new $5BPMp.BitSet(atn.states.length);
            let worklist = [];
            worklist.push(transition.followState);
            while(true){
                let state = worklist.pop();
                if (!state) break;
                if (reachable.get(state.stateNumber)) continue;
                if (state instanceof $4kGBm.RuleStopState) continue;
                if (!state.onlyHasEpsilonTransitions) return false;
                let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
                for(let i = 0; i < transitionCount; i++){
                    let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                    if (t.serializationType !== 1) return false;
                    worklist.push(t.target);
                }
            }
            return true;
        }
        static toInt(c) {
            return c;
        }
        static toInt32(data, offset) {
            return (data[offset] | data[offset + 1] << 16) >>> 0;
        }
        static toUUID(data, offset) {
            let leastSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset);
            let lessSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 2);
            let moreSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 4);
            let mostSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 6);
            return new $kWxOc.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
        }
        edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
            let target = atn.states[trg];
            switch(type){
                case 1:
                    return new $bpnRH.EpsilonTransition(target);
                case 2:
                    if (arg3 !== 0) return new $aISkF.RangeTransition(target, $2DVsz.Token.EOF, arg2);
                    else return new $aISkF.RangeTransition(target, arg1, arg2);
                case 3:
                    let rt = new $aybFP.RuleTransition(atn.states[arg1], arg2, arg3, target);
                    return rt;
                case 4:
                    let pt = new $hnaRv.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                    return pt;
                case 10:
                    return new $7KGEQ.PrecedencePredicateTransition(target, arg1);
                case 5:
                    if (arg3 !== 0) return new $5r7n7.AtomTransition(target, $2DVsz.Token.EOF);
                    else return new $5r7n7.AtomTransition(target, arg1);
                case 6:
                    let a = new $gxlfY.ActionTransition(target, arg1, arg2, arg3 !== 0);
                    return a;
                case 7:
                    return new $Np2R3.SetTransition(target, sets[arg1]);
                case 8:
                    return new $FLEKS.NotSetTransition(target, sets[arg1]);
                case 9:
                    return new $aPmi9.WildcardTransition(target);
            }
            throw new Error("The specified transition type is not valid.");
        }
        stateFactory(type, ruleIndex) {
            let s;
            switch(type){
                case $1bs3X.ATNStateType.INVALID_TYPE:
                    return new $l4Nh1.InvalidState();
                case $1bs3X.ATNStateType.BASIC:
                    s = new $4yiuQ.BasicState();
                    break;
                case $1bs3X.ATNStateType.RULE_START:
                    s = new $j2zc8.RuleStartState();
                    break;
                case $1bs3X.ATNStateType.BLOCK_START:
                    s = new $gAm9p.BasicBlockStartState();
                    break;
                case $1bs3X.ATNStateType.PLUS_BLOCK_START:
                    s = new $d1V7w.PlusBlockStartState();
                    break;
                case $1bs3X.ATNStateType.STAR_BLOCK_START:
                    s = new $jEsaF.StarBlockStartState();
                    break;
                case $1bs3X.ATNStateType.TOKEN_START:
                    s = new $WS4d7.TokensStartState();
                    break;
                case $1bs3X.ATNStateType.RULE_STOP:
                    s = new $4kGBm.RuleStopState();
                    break;
                case $1bs3X.ATNStateType.BLOCK_END:
                    s = new $loKp0.BlockEndState();
                    break;
                case $1bs3X.ATNStateType.STAR_LOOP_BACK:
                    s = new $bjwd1.StarLoopbackState();
                    break;
                case $1bs3X.ATNStateType.STAR_LOOP_ENTRY:
                    s = new $f9raX.StarLoopEntryState();
                    break;
                case $1bs3X.ATNStateType.PLUS_LOOP_BACK:
                    s = new $7qlbM.PlusLoopbackState();
                    break;
                case $1bs3X.ATNStateType.LOOP_END:
                    s = new $kfqEk.LoopEndState();
                    break;
                default:
                    let message = `The specified state type ${type} is not valid.`;
                    throw new Error(message);
            }
            s.ruleIndex = ruleIndex;
            return s;
        }
        lexerActionFactory(type, data1, data2) {
            switch(type){
                case 0:
                    return new $iw4Ko.LexerChannelAction(data1);
                case 1:
                    return new $RgRAX.LexerCustomAction(data1, data2);
                case 2:
                    return new $jgJtt.LexerModeAction(data1);
                case 3:
                    return $l606e.LexerMoreAction.INSTANCE;
                case 4:
                    return $6hIs4.LexerPopModeAction.INSTANCE;
                case 5:
                    return new $a9nIX.LexerPushModeAction(data1);
                case 6:
                    return $2Gb96.LexerSkipAction.INSTANCE;
                case 7:
                    return new $ayRdK.LexerTypeAction(data1);
                default:
                    let message = `The specified lexer action type ${type} is not valid.`;
                    throw new Error(message);
            }
        }
    }
    $9d4aef733dce84f9$var$ATNDeserializer.BASE_SERIALIZED_UUID = $kWxOc.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
    $9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $kWxOc.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
    $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP = $kWxOc.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
    $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS = [
        $9d4aef733dce84f9$var$ATNDeserializer.BASE_SERIALIZED_UUID,
        $9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
        $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP
    ];
    $9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_UUID = $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP;
    $9d4aef733dce84f9$var$__decorate([
        $d6D31.NotNull
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
    $9d4aef733dce84f9$var$__decorate([
        $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "deserialize", null);
    $9d4aef733dce84f9$var$__decorate([
        $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
    $9d4aef733dce84f9$var$__decorate([
        $d6D31.NotNull,
        $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "edgeFactory", null);
    module.exports.ATNDeserializer = $9d4aef733dce84f9$var$ATNDeserializer;
});
parcelRegister("gxlfY", function(module, exports) {
    "use strict";
    var $c0a0378a1b984eee$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $c0a0378a1b984eee$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ActionTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $c0a0378a1b984eee$var$ActionTransition = class ActionTransition extends $5tcOQ.Transition {
        constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
            super(target);
            this.ruleIndex = ruleIndex;
            this.actionIndex = actionIndex;
            this.isCtxDependent = isCtxDependent;
        }
        get serializationType() {
            return 6;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        toString() {
            return "action_" + this.ruleIndex + ":" + this.actionIndex;
        }
    };
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "serializationType", null);
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "isEpsilon", null);
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "matches", null);
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "toString", null);
    $c0a0378a1b984eee$var$ActionTransition = $c0a0378a1b984eee$var$__decorate([
        $c0a0378a1b984eee$var$__param(0, $d6D31.NotNull)
    ], $c0a0378a1b984eee$var$ActionTransition);
    module.exports.ActionTransition = $c0a0378a1b984eee$var$ActionTransition;
});
parcelRegister("5r7n7", function(module, exports) {
    "use strict";
    var $010580cb6b5878c3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $010580cb6b5878c3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.AtomTransition = void 0;
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $010580cb6b5878c3$var$AtomTransition = class AtomTransition extends $5tcOQ.Transition {
        constructor(target, label){
            super(target);
            this._label = label;
        }
        get serializationType() {
            return 5;
        }
        get label() {
            return $hGRod.IntervalSet.of(this._label);
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return this._label === symbol;
        }
        toString() {
            return String(this.label);
        }
    };
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "serializationType", null);
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "label", null);
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "matches", null);
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "toString", null);
    $010580cb6b5878c3$var$AtomTransition = $010580cb6b5878c3$var$__decorate([
        $010580cb6b5878c3$var$__param(0, $d6D31.NotNull)
    ], $010580cb6b5878c3$var$AtomTransition);
    module.exports.AtomTransition = $010580cb6b5878c3$var$AtomTransition;
});
parcelRegister("gAm9p", function(module, exports) {
    "use strict";
    var $c13130ce46eb4f6a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BasicBlockStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $65vNG = parcelRequire("65vNG");
    var $d6D31 = parcelRequire("d6D31");
    class $c13130ce46eb4f6a$var$BasicBlockStartState extends $65vNG.BlockStartState {
        get stateType() {
            return $1bs3X.ATNStateType.BLOCK_START;
        }
    }
    $c13130ce46eb4f6a$var$__decorate([
        $d6D31.Override
    ], $c13130ce46eb4f6a$var$BasicBlockStartState.prototype, "stateType", null);
    module.exports.BasicBlockStartState = $c13130ce46eb4f6a$var$BasicBlockStartState;
});
parcelRegister("65vNG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BlockStartState = void 0;
    var $dPYn6 = parcelRequire("dPYn6");
    class $46ebe09d19265106$var$BlockStartState extends $dPYn6.DecisionState {
    }
    module.exports.BlockStartState = $46ebe09d19265106$var$BlockStartState;
});
parcelRegister("loKp0", function(module, exports) {
    "use strict";
    var $f93fd5601d243552$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BlockEndState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $f93fd5601d243552$var$BlockEndState extends $7j0Pc.ATNState {
        get stateType() {
            return $1bs3X.ATNStateType.BLOCK_END;
        }
    }
    $f93fd5601d243552$var$__decorate([
        $d6D31.Override
    ], $f93fd5601d243552$var$BlockEndState.prototype, "stateType", null);
    module.exports.BlockEndState = $f93fd5601d243552$var$BlockEndState;
});
parcelRegister("bpnRH", function(module, exports) {
    "use strict";
    var $84e48a9cb4812173$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $84e48a9cb4812173$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.EpsilonTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $84e48a9cb4812173$var$EpsilonTransition = class EpsilonTransition extends $5tcOQ.Transition {
        constructor(target, outermostPrecedenceReturn = -1){
            super(target);
            this._outermostPrecedenceReturn = outermostPrecedenceReturn;
        }
        get outermostPrecedenceReturn() {
            return this._outermostPrecedenceReturn;
        }
        get serializationType() {
            return 1;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        toString() {
            return "epsilon";
        }
    };
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "serializationType", null);
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "isEpsilon", null);
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "matches", null);
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "toString", null);
    $84e48a9cb4812173$var$EpsilonTransition = $84e48a9cb4812173$var$__decorate([
        $84e48a9cb4812173$var$__param(0, $d6D31.NotNull)
    ], $84e48a9cb4812173$var$EpsilonTransition);
    module.exports.EpsilonTransition = $84e48a9cb4812173$var$EpsilonTransition;
});
parcelRegister("iw4Ko", function(module, exports) {
    "use strict";
    var $d7aee5df2113a2bc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $d7aee5df2113a2bc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerChannelAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $d7aee5df2113a2bc$var$LexerChannelAction {
        constructor(channel){
            this._channel = channel;
        }
        get channel() {
            return this._channel;
        }
        get actionType() {
            return 0;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.channel = this._channel;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._channel);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $d7aee5df2113a2bc$var$LexerChannelAction)) return false;
            return this._channel === obj._channel;
        }
        toString() {
            return `channel(${this._channel})`;
        }
    }
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "actionType", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "isPositionDependent", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override,
        $d7aee5df2113a2bc$var$__param(0, $d6D31.NotNull)
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "execute", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "hashCode", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "equals", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "toString", null);
    module.exports.LexerChannelAction = $d7aee5df2113a2bc$var$LexerChannelAction;
});
parcelRegister("RgRAX", function(module, exports) {
    "use strict";
    var $0a0208144418eb04$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $0a0208144418eb04$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerCustomAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $0a0208144418eb04$var$LexerCustomAction {
        constructor(ruleIndex, actionIndex){
            this._ruleIndex = ruleIndex;
            this._actionIndex = actionIndex;
        }
        get ruleIndex() {
            return this._ruleIndex;
        }
        get actionIndex() {
            return this._actionIndex;
        }
        get actionType() {
            return 1;
        }
        get isPositionDependent() {
            return true;
        }
        execute(lexer) {
            lexer.action(undefined, this._ruleIndex, this._actionIndex);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._ruleIndex);
            hash = $iXFjm.MurmurHash.update(hash, this._actionIndex);
            return $iXFjm.MurmurHash.finish(hash, 3);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $0a0208144418eb04$var$LexerCustomAction)) return false;
            return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
        }
    }
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "actionType", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "isPositionDependent", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override,
        $0a0208144418eb04$var$__param(0, $d6D31.NotNull)
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "execute", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "hashCode", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "equals", null);
    module.exports.LexerCustomAction = $0a0208144418eb04$var$LexerCustomAction;
});
parcelRegister("jgJtt", function(module, exports) {
    "use strict";
    var $e072c93b157fdb6e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $e072c93b157fdb6e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerModeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $e072c93b157fdb6e$var$LexerModeAction {
        constructor(mode){
            this._mode = mode;
        }
        get mode() {
            return this._mode;
        }
        get actionType() {
            return 2;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.mode(this._mode);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._mode);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $e072c93b157fdb6e$var$LexerModeAction)) return false;
            return this._mode === obj._mode;
        }
        toString() {
            return `mode(${this._mode})`;
        }
    }
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "actionType", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "isPositionDependent", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override,
        $e072c93b157fdb6e$var$__param(0, $d6D31.NotNull)
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "execute", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "hashCode", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "equals", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "toString", null);
    module.exports.LexerModeAction = $e072c93b157fdb6e$var$LexerModeAction;
});
parcelRegister("l606e", function(module, exports) {
    "use strict";
    var $f5ba3c4a18e49934$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $f5ba3c4a18e49934$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerMoreAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $f5ba3c4a18e49934$var$LexerMoreAction {
        constructor(){}
        get actionType() {
            return 3;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.more();
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            return $iXFjm.MurmurHash.finish(hash, 1);
        }
        equals(obj) {
            return obj === this;
        }
        toString() {
            return "more";
        }
    }
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "actionType", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "isPositionDependent", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override,
        $f5ba3c4a18e49934$var$__param(0, $d6D31.NotNull)
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "execute", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "hashCode", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "equals", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "toString", null);
    module.exports.LexerMoreAction = $f5ba3c4a18e49934$var$LexerMoreAction;
    (function(LexerMoreAction) {
        LexerMoreAction.INSTANCE = new LexerMoreAction();
    })($f5ba3c4a18e49934$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));
});
parcelRegister("6hIs4", function(module, exports) {
    "use strict";
    var $4936cfc70a1820aa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $4936cfc70a1820aa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerPopModeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $4936cfc70a1820aa$var$LexerPopModeAction {
        constructor(){}
        get actionType() {
            return 4;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.popMode();
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            return $iXFjm.MurmurHash.finish(hash, 1);
        }
        equals(obj) {
            return obj === this;
        }
        toString() {
            return "popMode";
        }
    }
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "actionType", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "isPositionDependent", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override,
        $4936cfc70a1820aa$var$__param(0, $d6D31.NotNull)
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "execute", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "hashCode", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "equals", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "toString", null);
    module.exports.LexerPopModeAction = $4936cfc70a1820aa$var$LexerPopModeAction;
    (function(LexerPopModeAction) {
        LexerPopModeAction.INSTANCE = new LexerPopModeAction();
    })($4936cfc70a1820aa$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));
});
parcelRegister("a9nIX", function(module, exports) {
    "use strict";
    var $763d25c4cd7cf3b5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $763d25c4cd7cf3b5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerPushModeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $763d25c4cd7cf3b5$var$LexerPushModeAction {
        constructor(mode){
            this._mode = mode;
        }
        get mode() {
            return this._mode;
        }
        get actionType() {
            return 5;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.pushMode(this._mode);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._mode);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $763d25c4cd7cf3b5$var$LexerPushModeAction)) return false;
            return this._mode === obj._mode;
        }
        toString() {
            return `pushMode(${this._mode})`;
        }
    }
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "actionType", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "isPositionDependent", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override,
        $763d25c4cd7cf3b5$var$__param(0, $d6D31.NotNull)
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "execute", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "hashCode", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "equals", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "toString", null);
    module.exports.LexerPushModeAction = $763d25c4cd7cf3b5$var$LexerPushModeAction;
});
parcelRegister("2Gb96", function(module, exports) {
    "use strict";
    var $1f3826579173f858$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $1f3826579173f858$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerSkipAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $1f3826579173f858$var$LexerSkipAction {
        constructor(){}
        get actionType() {
            return 6;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.skip();
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            return $iXFjm.MurmurHash.finish(hash, 1);
        }
        equals(obj) {
            return obj === this;
        }
        toString() {
            return "skip";
        }
    }
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "actionType", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "isPositionDependent", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override,
        $1f3826579173f858$var$__param(0, $d6D31.NotNull)
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "execute", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "hashCode", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "equals", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "toString", null);
    module.exports.LexerSkipAction = $1f3826579173f858$var$LexerSkipAction;
    (function(LexerSkipAction) {
        LexerSkipAction.INSTANCE = new LexerSkipAction();
    })($1f3826579173f858$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));
});
parcelRegister("ayRdK", function(module, exports) {
    "use strict";
    var $7b065cdfc5f207e7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7b065cdfc5f207e7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerTypeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $7b065cdfc5f207e7$var$LexerTypeAction {
        constructor(type){
            this._type = type;
        }
        get type() {
            return this._type;
        }
        get actionType() {
            return 7;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.type = this._type;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._type);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $7b065cdfc5f207e7$var$LexerTypeAction)) return false;
            return this._type === obj._type;
        }
        toString() {
            return `type(${this._type})`;
        }
    }
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "actionType", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "isPositionDependent", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override,
        $7b065cdfc5f207e7$var$__param(0, $d6D31.NotNull)
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "execute", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "hashCode", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "equals", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "toString", null);
    module.exports.LexerTypeAction = $7b065cdfc5f207e7$var$LexerTypeAction;
});
parcelRegister("kfqEk", function(module, exports) {
    "use strict";
    var $ebd9e16490628daf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LoopEndState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $ebd9e16490628daf$var$LoopEndState extends $7j0Pc.ATNState {
        get stateType() {
            return $1bs3X.ATNStateType.LOOP_END;
        }
    }
    $ebd9e16490628daf$var$__decorate([
        $d6D31.Override
    ], $ebd9e16490628daf$var$LoopEndState.prototype, "stateType", null);
    module.exports.LoopEndState = $ebd9e16490628daf$var$LoopEndState;
});
parcelRegister("kzbnL", function(module, exports) {
    "use strict";
    var $ef8fe7d2bd819f1c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ef8fe7d2bd819f1c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParserATNSimulator = void 0;
    var $41NTU = parcelRequire("41NTU");
    var $gxlfY = parcelRequire("gxlfY");
    var $7Veax = parcelRequire("7Veax");
    var $9yG1X = parcelRequire("9yG1X");
    var $bcnvE = parcelRequire("bcnvE");
    var $gcX0f = parcelRequire("gcX0f");
    var $c1ClW = parcelRequire("c1ClW");
    var $kr9A1 = parcelRequire("kr9A1");
    var $1bs3X = parcelRequire("1bs3X");
    var $5r7n7 = parcelRequire("5r7n7");
    var $5BPMp = parcelRequire("5BPMp");
    var $gsRaX = parcelRequire("gsRaX");
    var $dPYn6 = parcelRequire("dPYn6");
    var $2jevZ = parcelRequire("2jevZ");
    var $37SGk = parcelRequire("37SGk");
    var $gcfUE = parcelRequire("gcfUE");
    var $ceaEj = parcelRequire("ceaEj");
    var $d6D31 = parcelRequire("d6D31");
    var $FLEKS = parcelRequire("FLEKS");
    var $hKCjP = parcelRequire("hKCjP");
    var $a4Flx = parcelRequire("a4Flx");
    var $6bmaO = parcelRequire("6bmaO");
    var $8DTT0 = parcelRequire("8DTT0");
    var $6vF7J = parcelRequire("6vF7J");
    var $gDZVV = parcelRequire("gDZVV");
    var $4kGBm = parcelRequire("4kGBm");
    var $aybFP = parcelRequire("aybFP");
    var $eHMgW = parcelRequire("eHMgW");
    var $Np2R3 = parcelRequire("Np2R3");
    var $g7SCF = parcelRequire("g7SCF");
    var $2DVsz = parcelRequire("2DVsz");
    var $3n2FE = parcelRequire("3n2FE");
    var $bbHFU = parcelRequire("bbHFU");
    const $ef8fe7d2bd819f1c$var$MAX_SHORT_VALUE = 0xFFFF;
    const $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE = -2147483648;
    let $ef8fe7d2bd819f1c$var$ParserATNSimulator = class ParserATNSimulator extends $kr9A1.ATNSimulator {
        constructor(atn, parser){
            super(atn);
            this.predictionMode = $gDZVV.PredictionMode.LL;
            this.force_global_context = false;
            this.always_try_local_context = true;
            this.enable_global_context_dfa = false;
            this.optimize_unique_closure = true;
            this.optimize_ll1 = true;
            this.optimize_tail_calls = true;
            this.tail_call_preserves_sll = true;
            this.treat_sllk1_conflict_as_ambiguity = false;
            this.reportAmbiguities = false;
            this.userWantsCtxSensitive = true;
            this._parser = parser;
        }
        getPredictionMode() {
            return this.predictionMode;
        }
        setPredictionMode(predictionMode) {
            this.predictionMode = predictionMode;
        }
        reset() {}
        adaptivePredict(input, decision, outerContext, useContext) {
            if (useContext === undefined) useContext = false;
            let dfa = this.atn.decisionToDFA[decision];
            $bbHFU(dfa != null);
            if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
                let ll_1 = input.LA(1);
                if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                    let key = (decision << 16 >>> 0) + ll_1;
                    let alt = this.atn.LL1Table.get(key);
                    if (alt != null) return alt;
                }
            }
            this.dfa = dfa;
            if (this.force_global_context) useContext = true;
            else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
            this.userWantsCtxSensitive = useContext || this.predictionMode !== $gDZVV.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
            if (outerContext == null) outerContext = $6bmaO.ParserRuleContext.emptyContext();
            let state;
            if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
            if (state == null) {
                if (outerContext == null) outerContext = $6bmaO.ParserRuleContext.emptyContext();
                if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
                state = this.computeStartState(dfa, outerContext, useContext);
            }
            let m = input.mark();
            let index = input.index;
            try {
                let alt = this.execDFA(dfa, input, index, state);
                if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                return alt;
            } finally{
                this.dfa = undefined;
                input.seek(index);
                input.release(m);
            }
        }
        getStartState(dfa, input, outerContext, useContext) {
            if (!useContext) {
                if (dfa.isPrecedenceDfa) {
                    let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                    if (state == null) return undefined;
                    return new $g7SCF.SimulatorState(outerContext, state, false, outerContext);
                } else {
                    if (dfa.s0 == null) return undefined;
                    return new $g7SCF.SimulatorState(outerContext, dfa.s0, false, outerContext);
                }
            }
            if (!this.enable_global_context_dfa) return undefined;
            let remainingContext = outerContext;
            $bbHFU(outerContext != null);
            let s0;
            if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
            else s0 = dfa.s0full;
            while(remainingContext != null && s0 != null && s0.isContextSensitive){
                remainingContext = this.skipTailCalls(remainingContext);
                s0 = s0.getContextTarget(this.getReturnState(remainingContext));
                if (remainingContext.isEmpty) $bbHFU(s0 == null || !s0.isContextSensitive);
                else remainingContext = remainingContext.parent;
            }
            if (s0 == null) return undefined;
            return new $g7SCF.SimulatorState(outerContext, s0, useContext, remainingContext);
        }
        execDFA(dfa, input, startIndex, state) {
            let outerContext = state.outerContext;
            if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            let s = state.s0;
            let t = input.LA(1);
            let remainingOuterContext = state.remainingOuterContext;
            while(true){
                if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
                if (state.useContext) while(s.isContextSymbol(t)){
                    let next;
                    if (remainingOuterContext != null) {
                        remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                        next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                    }
                    if (next == null) {
                        let initialState = new $g7SCF.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                        return this.execATN(dfa, input, startIndex, initialState);
                    }
                    $bbHFU(remainingOuterContext != null);
                    remainingOuterContext = remainingOuterContext.parent;
                    s = next;
                }
                if (this.isAcceptState(s, state.useContext)) {
                    if (s.predicates != null) {
                        if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                    } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                    break;
                }
                $bbHFU(!this.isAcceptState(s, state.useContext));
                let target = this.getExistingTargetState(s, t);
                if (target == null) {
                    if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                    let alt;
                    if (ParserATNSimulator.dfa_debug) {
                        let interval = $gcfUE.Interval.of(startIndex, this._parser.inputStream.index);
                        console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                    }
                    let initialState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                    alt = this.execATN(dfa, input, startIndex, initialState);
                    if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                    if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                    return alt;
                } else if (target === $kr9A1.ATNSimulator.ERROR) {
                    let errorState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                    return this.handleNoViableAlt(input, startIndex, errorState);
                }
                s = target;
                if (!this.isAcceptState(s, state.useContext) && t !== $ceaEj.IntStream.EOF) {
                    input.consume();
                    t = input.LA(1);
                }
            }
            if (!state.useContext && s.configs.conflictInfo != null) {
                if (dfa.atnStartState instanceof $dPYn6.DecisionState) {
                    if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                    else {
                        $bbHFU(!state.useContext);
                        let conflictingAlts;
                        let predicates = s.predicates;
                        if (predicates != null) {
                            let conflictIndex = input.index;
                            if (conflictIndex !== startIndex) input.seek(startIndex);
                            conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                            if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                            if (conflictIndex !== startIndex) input.seek(conflictIndex);
                        }
                        if (this.reportAmbiguities) {
                            let conflictState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                            this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                        }
                        input.seek(startIndex);
                        return this.adaptivePredict(input, dfa.decision, outerContext, true);
                    }
                }
            }
            let predicates = s.predicates;
            if (predicates != null) {
                let stopIndex = input.index;
                if (startIndex !== stopIndex) input.seek(startIndex);
                let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $gDZVV.PredictionMode.LL_EXACT_AMBIG_DETECTION);
                switch(alts.cardinality()){
                    case 0:
                        throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                    case 1:
                        return alts.nextSetBit(0);
                    default:
                        if (startIndex !== stopIndex) input.seek(stopIndex);
                        this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                        return alts.nextSetBit(0);
                }
            }
            if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
            return s.prediction;
        }
        isAcceptState(state, useContext) {
            if (!state.isAcceptState) return false;
            if (state.configs.conflictingAlts == null) return true;
            if (useContext && this.predictionMode === $gDZVV.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
            return true;
        }
        execATN(dfa, input, startIndex, initialState) {
            if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
            let outerContext = initialState.outerContext;
            let useContext = initialState.useContext;
            let t = input.LA(1);
            let previous = initialState;
            let contextCache = new $6vF7J.PredictionContextCache();
            while(true){
                let nextState = this.computeReachSet(dfa, previous, t, contextCache);
                if (nextState == null) {
                    this.setDFAEdge(previous.s0, input.LA(1), $kr9A1.ATNSimulator.ERROR);
                    return this.handleNoViableAlt(input, startIndex, previous);
                }
                let D = nextState.s0;
                $bbHFU(D.isAcceptState || D.prediction === $bcnvE.ATN.INVALID_ALT_NUMBER);
                $bbHFU(D.isAcceptState || D.configs.conflictInfo == null);
                if (this.isAcceptState(D, useContext)) {
                    let conflictingAlts = D.configs.conflictingAlts;
                    let predictedAlt = conflictingAlts == null ? D.prediction : $bcnvE.ATN.INVALID_ALT_NUMBER;
                    if (predictedAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                        if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                            if (t >= 0 && t <= $ef8fe7d2bd819f1c$var$MAX_SHORT_VALUE) {
                                let key = (dfa.decision << 16 >>> 0) + t;
                                this.atn.LL1Table.set(key, predictedAlt);
                            }
                        }
                        if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                    }
                    predictedAlt = D.prediction;
                    let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                    if (attemptFullContext) attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                    if (D.configs.hasSemanticContext) {
                        let predPredictions = D.predicates;
                        if (predPredictions != null) {
                            let conflictIndex = input.index;
                            if (conflictIndex !== startIndex) input.seek(startIndex);
                            conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                            switch(conflictingAlts.cardinality()){
                                case 0:
                                    throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                                case 1:
                                    return conflictingAlts.nextSetBit(0);
                                default:
                                    break;
                            }
                            if (conflictIndex !== startIndex) input.seek(conflictIndex);
                        }
                    }
                    if (!attemptFullContext) {
                        if (conflictingAlts != null) {
                            if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                            predictedAlt = conflictingAlts.nextSetBit(0);
                        }
                        return predictedAlt;
                    } else {
                        $bbHFU(!useContext);
                        $bbHFU(this.isAcceptState(D, false));
                        if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                        let fullContextState = this.computeStartState(dfa, outerContext, true);
                        if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                        input.seek(startIndex);
                        return this.execATN(dfa, input, startIndex, fullContextState);
                    }
                }
                previous = nextState;
                if (t !== $ceaEj.IntStream.EOF) {
                    input.consume();
                    t = input.LA(1);
                }
            }
        }
        handleNoViableAlt(input, startIndex, previous) {
            if (previous.s0 != null) {
                let alts = new $5BPMp.BitSet();
                let maxAlt = 0;
                for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4kGBm.RuleStopState) {
                    alts.set(config.alt);
                    maxAlt = Math.max(maxAlt, config.alt);
                }
                switch(alts.cardinality()){
                    case 0:
                        break;
                    case 1:
                        return alts.nextSetBit(0);
                    default:
                        if (!previous.s0.configs.hasSemanticContext) return alts.nextSetBit(0);
                        let filteredConfigs = new $c1ClW.ATNConfigSet();
                        for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4kGBm.RuleStopState) filteredConfigs.add(config);
                        let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                        if (altToPred != null) {
                            let predicates = this.getPredicatePredictions(alts, altToPred);
                            if (predicates != null) {
                                let stopIndex = input.index;
                                try {
                                    input.seek(startIndex);
                                    let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                    if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                                } finally{
                                    input.seek(stopIndex);
                                }
                            }
                        }
                        return alts.nextSetBit(0);
                }
            }
            throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
        }
        computeReachSet(dfa, previous, t, contextCache) {
            let useContext = previous.useContext;
            let remainingGlobalContext = previous.remainingOuterContext;
            let s = previous.s0;
            if (useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingGlobalContext != null) {
                    remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                    next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
                }
                if (next == null) break;
                $bbHFU(remainingGlobalContext != null);
                remainingGlobalContext = remainingGlobalContext.parent;
                s = next;
            }
            $bbHFU(!this.isAcceptState(s, useContext));
            if (this.isAcceptState(s, useContext)) return new $g7SCF.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
            let s0 = s;
            let target = this.getExistingTargetState(s0, t);
            if (target == null) {
                let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
                target = result[0];
                remainingGlobalContext = result[1];
            }
            if (target === $kr9A1.ATNSimulator.ERROR) return undefined;
            $bbHFU(!useContext || !target.configs.dipsIntoOuterContext);
            return new $g7SCF.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
        }
        getExistingTargetState(s, t) {
            return s.getTarget(t);
        }
        computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
            let closureConfigs = s.configs.toArray();
            let contextElements;
            let reach = new $c1ClW.ATNConfigSet();
            let stepIntoGlobal;
            do {
                let hasMoreContext = !useContext || remainingGlobalContext != null;
                if (!hasMoreContext) reach.isOutermostConfigSet = true;
                let reachIntermediate = new $c1ClW.ATNConfigSet();
                let skippedStopStates;
                for (let c of closureConfigs){
                    if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                    if (c.state instanceof $4kGBm.RuleStopState) {
                        $bbHFU(c.context.isEmpty);
                        if (useContext && !c.reachesIntoOuterContext || t === $ceaEj.IntStream.EOF) {
                            if (skippedStopStates == null) skippedStopStates = [];
                            skippedStopStates.push(c);
                        }
                        continue;
                    }
                    let n = c.state.numberOfOptimizedTransitions;
                    for(let ti = 0; ti < n; ti++){
                        let trans = c.state.getOptimizedTransition(ti);
                        let target = this.getReachableTarget(c, trans, t);
                        if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                    }
                }
                if (this.optimize_unique_closure && skippedStopStates == null && t !== $2DVsz.Token.EOF && reachIntermediate.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                    reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                    reach = reachIntermediate;
                    break;
                }
                let collectPredicates = false;
                let treatEofAsEpsilon = t === $2DVsz.Token.EOF;
                this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
                stepIntoGlobal = reach.dipsIntoOuterContext;
                if (t === $ceaEj.IntStream.EOF) reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
                if (skippedStopStates != null && (!useContext || !$gDZVV.PredictionMode.hasConfigInRuleStopState(reach))) {
                    $bbHFU(skippedStopStates.length > 0);
                    for (let c of skippedStopStates)reach.add(c, contextCache);
                }
                if (useContext && stepIntoGlobal) {
                    reach.clear();
                    remainingGlobalContext;
                    remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                    let nextContextElement = this.getReturnState(remainingGlobalContext);
                    if (contextElements == null) contextElements = new $37SGk.IntegerList();
                    if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                    else remainingGlobalContext = remainingGlobalContext.parent;
                    contextElements.add(nextContextElement);
                    if (nextContextElement !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
                }
            }while (useContext && stepIntoGlobal)
            if (reach.isEmpty) {
                this.setDFAEdge(s, t, $kr9A1.ATNSimulator.ERROR);
                return [
                    $kr9A1.ATNSimulator.ERROR,
                    remainingGlobalContext
                ];
            }
            let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
            return [
                result,
                remainingGlobalContext
            ];
        }
        removeAllConfigsNotInRuleStopState(configs, contextCache) {
            if ($gDZVV.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
            let result = new $c1ClW.ATNConfigSet();
            for (let config of configs){
                if (!(config.state instanceof $4kGBm.RuleStopState)) continue;
                result.add(config, contextCache);
            }
            return result;
        }
        computeStartState(dfa, globalContext, useContext) {
            let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
            if (s0 != null) {
                if (!useContext) return new $g7SCF.SimulatorState(globalContext, s0, useContext, globalContext);
                s0.setContextSensitive(this.atn);
            }
            let decision = dfa.decision;
            let p = dfa.atnStartState;
            let previousContext = 0;
            let remainingGlobalContext = globalContext;
            let initialContext = useContext ? $8DTT0.PredictionContext.EMPTY_FULL : $8DTT0.PredictionContext.EMPTY_LOCAL;
            let contextCache = new $6vF7J.PredictionContextCache();
            if (useContext) {
                if (!this.enable_global_context_dfa) {
                    while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                        previousContext = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
                        remainingGlobalContext = undefined;
                    } else {
                        previousContext = this.getReturnState(remainingGlobalContext);
                        initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                        remainingGlobalContext = remainingGlobalContext.parent;
                    }
                }
                while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                    let next;
                    remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                    if (remainingGlobalContext.isEmpty) {
                        next = s0.getContextTarget($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY);
                        previousContext = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
                        remainingGlobalContext = undefined;
                    } else {
                        previousContext = this.getReturnState(remainingGlobalContext);
                        next = s0.getContextTarget(previousContext);
                        initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                        remainingGlobalContext = remainingGlobalContext.parent;
                    }
                    if (next == null) break;
                    s0 = next;
                }
            }
            if (s0 != null && !s0.isContextSensitive) return new $g7SCF.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
            let configs = new $c1ClW.ATNConfigSet();
            while(true){
                let reachIntermediate = new $c1ClW.ATNConfigSet();
                let n = p.numberOfTransitions;
                for(let ti = 0; ti < n; ti++){
                    let target = p.transition(ti).target;
                    reachIntermediate.add($gcX0f.ATNConfig.create(target, ti + 1, initialContext));
                }
                let hasMoreContext = remainingGlobalContext != null;
                if (!hasMoreContext) configs.isOutermostConfigSet = true;
                let collectPredicates = true;
                this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
                let stepIntoGlobal = configs.dipsIntoOuterContext;
                let next;
                if (useContext && !this.enable_global_context_dfa) {
                    s0 = this.addDFAState(dfa, configs, contextCache);
                    break;
                } else if (s0 == null) {
                    if (!dfa.isPrecedenceDfa) {
                        next = this.addDFAState(dfa, configs, contextCache);
                        if (useContext) {
                            if (!dfa.s0full) dfa.s0full = next;
                            else next = dfa.s0full;
                        } else if (!dfa.s0) dfa.s0 = next;
                        else next = dfa.s0;
                    } else {
                        configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                        next = this.addDFAState(dfa, configs, contextCache);
                        dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                    }
                } else {
                    if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    s0.setContextTarget(previousContext, next);
                }
                s0 = next;
                if (!useContext || !stepIntoGlobal) break;
                next.setContextSensitive(this.atn);
                remainingGlobalContext;
                configs.clear();
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                if (nextContextElement !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
                previousContext = nextContextElement;
            }
            return new $g7SCF.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        }
        applyPrecedenceFilter(configs, globalContext, contextCache) {
            let statesFromAlt1 = new Map();
            let configSet = new $c1ClW.ATNConfigSet();
            for (let config of configs){
                if (config.alt !== 1) continue;
                let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
                if (updatedContext == null) continue;
                statesFromAlt1.set(config.state.stateNumber, config.context);
                if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
                else configSet.add(config, contextCache);
            }
            for (let config of configs){
                if (config.alt === 1) continue;
                if (!config.isPrecedenceFilterSuppressed) {
                    let context = statesFromAlt1.get(config.state.stateNumber);
                    if (context != null && context.equals(config.context)) continue;
                }
                configSet.add(config, contextCache);
            }
            return configSet;
        }
        getReachableTarget(source, trans, ttype) {
            if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
            return undefined;
        }
        predicateDFAState(D, configs, nalts) {
            let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
            if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
            if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
            let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
            let predPredictions;
            if (altToPred != null) {
                predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
                D.predicates = predPredictions;
            }
            return predPredictions;
        }
        getPredsForAmbigAlts(ambigAlts, configs, nalts) {
            let altToPred = new Array(nalts + 1);
            let n = altToPred.length;
            for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $eHMgW.SemanticContext.or(altToPred[c.alt], c.semanticContext);
            let nPredAlts = 0;
            for(let i = 0; i < n; i++){
                if (altToPred[i] == null) altToPred[i] = $eHMgW.SemanticContext.NONE;
                else if (altToPred[i] !== $eHMgW.SemanticContext.NONE) nPredAlts++;
            }
            let result = altToPred;
            if (nPredAlts === 0) result = undefined;
            if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $9yG1X.Arrays.toString(result) : "undefined"));
            return result;
        }
        getPredicatePredictions(ambigAlts, altToPred) {
            let pairs = [];
            let containsPredicate = false;
            for(let i = 1; i < altToPred.length; i++){
                let pred = altToPred[i];
                $bbHFU(pred != null);
                if (ambigAlts != null && ambigAlts.get(i) && pred === $eHMgW.SemanticContext.NONE) pairs.push(new $2jevZ.DFAState.PredPrediction(pred, i));
                else if (pred !== $eHMgW.SemanticContext.NONE) {
                    containsPredicate = true;
                    pairs.push(new $2jevZ.DFAState.PredPrediction(pred, i));
                }
            }
            if (!containsPredicate) return undefined;
            return pairs;
        }
        evalSemanticContext(predPredictions, outerContext, complete) {
            let predictions = new $5BPMp.BitSet();
            for (let pair of predPredictions){
                if (pair.pred === $eHMgW.SemanticContext.NONE) {
                    predictions.set(pair.alt);
                    if (!complete) break;
                    continue;
                }
                let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
                if (evaluatedResult) {
                    if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                    predictions.set(pair.alt);
                    if (!complete) break;
                }
            }
            return predictions;
        }
        evalSemanticContextImpl(pred, parserCallStack, alt) {
            return pred.eval(this._parser, parserCallStack);
        }
        closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
            if (contextCache == null) contextCache = $6vF7J.PredictionContextCache.UNCACHED;
            let currentConfigs = sourceConfigs;
            let closureBusy = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            while(currentConfigs.size > 0){
                let intermediate = new $c1ClW.ATNConfigSet();
                for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
                currentConfigs = intermediate;
            }
        }
        closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
            if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
            if (config.state instanceof $4kGBm.RuleStopState) {
                if (!config.context.isEmpty) {
                    let hasEmpty = config.context.hasEmpty;
                    let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                    for(let i = 0; i < nonEmptySize; i++){
                        let newContext = config.context.getParent(i);
                        let returnState = this.atn.states[config.context.getReturnState(i)];
                        let c = $gcX0f.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                        c.outerContextDepth = config.outerContextDepth;
                        c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                        $bbHFU(depth > $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE);
                        this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                    }
                    if (!hasEmpty || !hasMoreContexts) return;
                    config = config.transform(config.state, false, $8DTT0.PredictionContext.EMPTY_LOCAL);
                } else if (!hasMoreContexts) {
                    configs.add(config, contextCache);
                    return;
                } else {
                    if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                    if (config.context === $8DTT0.PredictionContext.EMPTY_FULL) config = config.transform(config.state, false, $8DTT0.PredictionContext.EMPTY_LOCAL);
                    else if (!config.reachesIntoOuterContext && $8DTT0.PredictionContext.isEmptyLocal(config.context)) configs.add(config, contextCache);
                }
            }
            let p = config.state;
            if (!p.onlyHasEpsilonTransitions) {
                configs.add(config, contextCache);
                if (ParserATNSimulator.debug) console.log("added config " + configs);
            }
            for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
                if (i === 0 && p.stateType === $1bs3X.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                    let precedenceDecision = p;
                    let suppress = true;
                    for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                        suppress = false;
                        break;
                    }
                    if (suppress) continue;
                }
                let t = p.getOptimizedTransition(i);
                let continueCollecting = !(t instanceof $gxlfY.ActionTransition) && collectPredicates;
                let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
                if (c != null) {
                    if (t instanceof $aybFP.RuleTransition) {
                        if (intermediate != null && !collectPredicates) {
                            intermediate.add(c, contextCache);
                            continue;
                        }
                    }
                    let newDepth = depth;
                    if (config.state instanceof $4kGBm.RuleStopState) {
                        if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                            let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                            if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                        }
                        c.outerContextDepth = c.outerContextDepth + 1;
                        if (!closureBusy.add(c)) continue;
                        $bbHFU(newDepth > $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE);
                        newDepth--;
                        if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                    } else if (t instanceof $aybFP.RuleTransition) {
                        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$8DTT0.PredictionContext.isEmptyLocal(config.context))) {
                            $bbHFU(c.context === config.context);
                            if (newDepth === 0) {
                                newDepth--;
                                if (!this.tail_call_preserves_sll && $8DTT0.PredictionContext.isEmptyLocal(config.context)) c.outerContextDepth = c.outerContextDepth + 1;
                            }
                        } else if (newDepth >= 0) newDepth++;
                    } else {
                        if (!t.isEpsilon && !closureBusy.add(c)) continue;
                    }
                    this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
                }
            }
        }
        getRuleName(index) {
            if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
            return "<rule " + index + ">";
        }
        getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
            switch(t.serializationType){
                case 3:
                    return this.ruleTransition(config, t, contextCache);
                case 10:
                    return this.precedenceTransition(config, t, collectPredicates, inContext);
                case 4:
                    return this.predTransition(config, t, collectPredicates, inContext);
                case 6:
                    return this.actionTransition(config, t);
                case 1:
                    return config.transform(t.target, false);
                case 5:
                case 2:
                case 7:
                    if (treatEofAsEpsilon) {
                        if (t.matches($2DVsz.Token.EOF, 0, 1)) return config.transform(t.target, false);
                    }
                    return undefined;
                default:
                    return undefined;
            }
        }
        actionTransition(config, t) {
            if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
            return config.transform(t.target, false);
        }
        precedenceTransition(config, pt, collectPredicates, inContext) {
            if (ParserATNSimulator.debug) {
                console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
                if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
            }
            let c;
            if (collectPredicates && inContext) {
                let newSemCtx = $eHMgW.SemanticContext.and(config.semanticContext, pt.predicate);
                c = config.transform(pt.target, false, newSemCtx);
            } else c = config.transform(pt.target, false);
            if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
            return c;
        }
        predTransition(config, pt, collectPredicates, inContext) {
            if (ParserATNSimulator.debug) {
                console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
                if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
            }
            let c;
            if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
                let newSemCtx = $eHMgW.SemanticContext.and(config.semanticContext, pt.predicate);
                c = config.transform(pt.target, false, newSemCtx);
            } else c = config.transform(pt.target, false);
            if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
            return c;
        }
        ruleTransition(config, t, contextCache) {
            if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
            let returnState = t.followState;
            let newContext;
            if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$8DTT0.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
            else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
            else newContext = config.context.getChild(returnState.stateNumber);
            return config.transform(t.target, false, newContext);
        }
        isConflicted(configset, contextCache) {
            if (configset.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
            let configs = configset.toArray();
            configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
            let exact = !configset.dipsIntoOuterContext;
            let alts = new $5BPMp.BitSet();
            let minAlt = configs[0].alt;
            alts.set(minAlt);
            let currentState = configs[0].state.nonStopStateNumber;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                if (stateNumber !== currentState) {
                    if (config.alt !== minAlt) return undefined;
                    currentState = stateNumber;
                }
            }
            let representedAlts;
            if (exact) {
                currentState = configs[0].state.nonStopStateNumber;
                representedAlts = new $5BPMp.BitSet();
                let maxAlt = minAlt;
                for (let config of configs){
                    if (config.state.nonStopStateNumber !== currentState) break;
                    let alt = config.alt;
                    representedAlts.set(alt);
                    maxAlt = alt;
                }
                currentState = configs[0].state.nonStopStateNumber;
                let currentAlt = minAlt;
                for (let config of configs){
                    let stateNumber = config.state.nonStopStateNumber;
                    let alt = config.alt;
                    if (stateNumber !== currentState) {
                        if (currentAlt !== maxAlt) {
                            exact = false;
                            break;
                        }
                        currentState = stateNumber;
                        currentAlt = minAlt;
                    } else if (alt !== currentAlt) {
                        if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                            exact = false;
                            break;
                        }
                        currentAlt = alt;
                    }
                }
            }
            currentState = configs[0].state.nonStopStateNumber;
            let firstIndexCurrentState = 0;
            let lastIndexCurrentStateMinAlt = 0;
            let joinedCheckContext = configs[0].context;
            for(let i = 1; i < configs.length; i++){
                let config = configs[i];
                if (config.alt !== minAlt) break;
                if (config.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
            }
            for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
                let config = configs[i];
                let state = config.state;
                alts.set(config.alt);
                if (state.nonStopStateNumber !== currentState) {
                    currentState = state.nonStopStateNumber;
                    firstIndexCurrentState = i;
                    lastIndexCurrentStateMinAlt = i;
                    joinedCheckContext = config.context;
                    for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                        let config2 = configs[j];
                        if (config2.alt !== minAlt) break;
                        if (config2.state.nonStopStateNumber !== currentState) break;
                        lastIndexCurrentStateMinAlt = j;
                        joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                    }
                    i = lastIndexCurrentStateMinAlt;
                    continue;
                }
                let joinedCheckContext2 = config.context;
                let currentAlt = config.alt;
                let lastIndexCurrentStateCurrentAlt = i;
                for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== currentAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateCurrentAlt = j;
                    joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
                }
                i = lastIndexCurrentStateCurrentAlt;
                let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
                if (!joinedCheckContext.equals(check)) return undefined;
                exact = exact && joinedCheckContext.equals(joinedCheckContext2);
            }
            return new $gsRaX.ConflictInfo(alts, exact);
        }
        getConflictingAltsFromConfigSet(configs) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts == null && configs.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                conflictingAlts = new $5BPMp.BitSet();
                conflictingAlts.set(configs.uniqueAlt);
            }
            return conflictingAlts;
        }
        getTokenName(t) {
            if (t === $2DVsz.Token.EOF) return "EOF";
            let vocabulary = this._parser != null ? this._parser.vocabulary : $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
            let displayName = vocabulary.getDisplayName(t);
            if (displayName === String(t)) return displayName;
            return displayName + "<" + t + ">";
        }
        getLookaheadName(input) {
            return this.getTokenName(input.LA(1));
        }
        dumpDeadEndConfigs(nvae) {
            console.log("dead end configs: ");
            let deadEndConfigs = nvae.deadEndConfigs;
            if (!deadEndConfigs) return;
            for (let c of deadEndConfigs){
                let trans = "no edges";
                if (c.state.numberOfOptimizedTransitions > 0) {
                    let t = c.state.getOptimizedTransition(0);
                    if (t instanceof $5r7n7.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                    else if (t instanceof $Np2R3.SetTransition) {
                        let not = t instanceof $FLEKS.NotSetTransition;
                        trans = (not ? "~" : "") + "Set " + t.set.toString();
                    }
                }
                console.log(c.toString(this._parser, true) + ":" + trans);
            }
        }
        noViableAlt(input, outerContext, configs, startIndex) {
            return new $hKCjP.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
        }
        getUniqueAlt(configs) {
            let alt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            for (let c of configs){
                if (alt === $bcnvE.ATN.INVALID_ALT_NUMBER) alt = c.alt;
                else if (c.alt !== alt) return $bcnvE.ATN.INVALID_ALT_NUMBER;
            }
            return alt;
        }
        configWithAltAtStopState(configs, alt) {
            for (let c of configs)if (c.alt === alt) {
                if (c.state instanceof $4kGBm.RuleStopState) return true;
            }
            return false;
        }
        addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
            $bbHFU(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
            let from = fromState;
            let to = this.addDFAState(dfa, toConfigs, contextCache);
            if (contextTransitions != null) for (let context of contextTransitions.toArray()){
                if (context === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (from.configs.isOutermostConfigSet) continue;
                }
                from.setContextSensitive(this.atn);
                from.setContextSymbol(t);
                let next = from.getContextTarget(context);
                if (next != null) {
                    from = next;
                    continue;
                }
                next = this.addDFAContextState(dfa, from.configs, context, contextCache);
                $bbHFU(context !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
                from.setContextTarget(context, next);
                from = next;
            }
            if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
            this.setDFAEdge(from, t, to);
            if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $3n2FE.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
            return to;
        }
        setDFAEdge(p, t, q) {
            if (p != null) p.setTarget(t, q);
        }
        addDFAContextState(dfa, configs, returnContext, contextCache) {
            if (returnContext !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) {
                let contextConfigs = new $c1ClW.ATNConfigSet();
                for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
                return this.addDFAState(dfa, contextConfigs, contextCache);
            } else {
                $bbHFU(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
                configs = configs.clone(true);
                configs.isOutermostConfigSet = true;
                return this.addDFAState(dfa, configs, contextCache);
            }
        }
        addDFAState(dfa, configs, contextCache) {
            let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
            if (enableDfa) {
                if (!configs.isReadOnly) configs.optimizeConfigs(this);
                let proposed = this.createDFAState(dfa, configs);
                let existing = dfa.states.get(proposed);
                if (existing != null) return existing;
            }
            if (!configs.isReadOnly) {
                if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
            }
            let newState = this.createDFAState(dfa, configs.clone(true));
            let decisionState = this.atn.getDecisionState(dfa.decision);
            let predictedAlt = this.getUniqueAlt(configs);
            if (predictedAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $41NTU.AcceptStateInfo(predictedAlt);
            else if (configs.conflictingAlts != null) {
                let conflictingAlts = configs.conflictingAlts;
                if (conflictingAlts) newState.acceptStateInfo = new $41NTU.AcceptStateInfo(conflictingAlts.nextSetBit(0));
            }
            if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
            if (!enableDfa) return newState;
            let added = dfa.addState(newState);
            if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
            return added;
        }
        createDFAState(dfa, configs) {
            return new $2jevZ.DFAState(configs);
        }
        reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
            if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
                let interval = $gcfUE.Interval.of(startIndex, stopIndex);
                console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
            }
            if (this._parser != null) {
                let listener = this._parser.getErrorListenerDispatch();
                if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
            }
        }
        reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
            if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
                let interval = $gcfUE.Interval.of(startIndex, stopIndex);
                console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
            }
            if (this._parser != null) {
                let listener = this._parser.getErrorListenerDispatch();
                if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
            }
        }
        reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
            if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
                let interval = $gcfUE.Interval.of(startIndex, stopIndex);
                console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
            }
            if (this._parser != null) {
                let listener = this._parser.getErrorListenerDispatch();
                if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
            }
        }
        getReturnState(context) {
            if (context.isEmpty) return $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
            let state = this.atn.states[context.invokingState];
            let transition = state.transition(0);
            return transition.followState.stateNumber;
        }
        skipTailCalls(context) {
            if (!this.optimize_tail_calls) return context;
            while(!context.isEmpty){
                let state = this.atn.states[context.invokingState];
                $bbHFU(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3);
                let transition = state.transition(0);
                if (!transition.tailCall) break;
                context = context.parent;
            }
            return context;
        }
        get parser() {
            return this._parser;
        }
    };
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.debug = false;
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.dfa_debug = false;
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.retry_debug = false;
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
        let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
        if (diff !== 0) return diff;
        diff = o1.alt - o2.alt;
        if (diff !== 0) return diff;
        return 0;
    };
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "predictionMode", void 0);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getPredictionMode", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "setPredictionMode", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.Override
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reset", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "adaptivePredict", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getStartState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "execDFA", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "execATN", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "computeTargetState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "computeStartState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getReachableTarget", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(4, $d6D31.Nullable)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "closure", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable),
        $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(6, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "closureImpl", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getRuleName", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "actionTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.Nullable,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "precedenceTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.Nullable,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "predTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "ruleTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "isConflicted", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getTokenName", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "noViableAlt", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(4, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAEdge", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.Nullable),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "setDFAEdge", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAContextState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "createDFAState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(5, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(6, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
    $ef8fe7d2bd819f1c$var$ParserATNSimulator = $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator);
    module.exports.ParserATNSimulator = $ef8fe7d2bd819f1c$var$ParserATNSimulator;
});
parcelRegister("gsRaX", function(module, exports) {
    "use strict";
    var $bfc8827830a146f2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ConflictInfo = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $2IEP9 = parcelRequire("2IEP9");
    class $bfc8827830a146f2$var$ConflictInfo {
        constructor(conflictedAlts, exact){
            this._conflictedAlts = conflictedAlts;
            this.exact = exact;
        }
        get conflictedAlts() {
            return this._conflictedAlts;
        }
        get isExact() {
            return this.exact;
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $bfc8827830a146f2$var$ConflictInfo)) return false;
            return this.isExact === obj.isExact && $2IEP9.equals(this.conflictedAlts, obj.conflictedAlts);
        }
        hashCode() {
            return this.conflictedAlts.hashCode();
        }
    }
    $bfc8827830a146f2$var$__decorate([
        $d6D31.Override
    ], $bfc8827830a146f2$var$ConflictInfo.prototype, "equals", null);
    $bfc8827830a146f2$var$__decorate([
        $d6D31.Override
    ], $bfc8827830a146f2$var$ConflictInfo.prototype, "hashCode", null);
    module.exports.ConflictInfo = $bfc8827830a146f2$var$ConflictInfo;
});
parcelRegister("6bmaO", function(module, exports) {
    "use strict";
    var $4804f857ecc73c01$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParserRuleContext = void 0;
    var $cdCft = parcelRequire("cdCft");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $c8jEe = parcelRequire("c8jEe");
    var $kYC92 = parcelRequire("kYC92");
    class $4804f857ecc73c01$var$ParserRuleContext extends $c8jEe.RuleContext {
        constructor(parent, invokingStateNumber){
            if (invokingStateNumber == null) super();
            else super(parent, invokingStateNumber);
        }
        static emptyContext() {
            return $4804f857ecc73c01$var$ParserRuleContext.EMPTY;
        }
        copyFrom(ctx) {
            this._parent = ctx._parent;
            this.invokingState = ctx.invokingState;
            this._start = ctx._start;
            this._stop = ctx._stop;
            if (ctx.children) {
                this.children = [];
                for (let child of ctx.children)if (child instanceof $cdCft.ErrorNode) this.addChild(child);
            }
        }
        enterRule(listener) {}
        exitRule(listener) {}
        addAnyChild(t) {
            if (!this.children) this.children = [
                t
            ];
            else this.children.push(t);
            return t;
        }
        addChild(t) {
            let result;
            if (t instanceof $kYC92.TerminalNode) {
                t.setParent(this);
                this.addAnyChild(t);
                return;
            } else if (t instanceof $c8jEe.RuleContext) {
                this.addAnyChild(t);
                return;
            } else {
                t = new $kYC92.TerminalNode(t);
                this.addAnyChild(t);
                t.setParent(this);
                return t;
            }
        }
        addErrorNode(node) {
            if (node instanceof $cdCft.ErrorNode) {
                const errorNode = node;
                errorNode.setParent(this);
                return this.addAnyChild(errorNode);
            } else {
                const badToken = node;
                let t = new $cdCft.ErrorNode(badToken);
                this.addAnyChild(t);
                t.setParent(this);
                return t;
            }
        }
        removeLastChild() {
            if (this.children) this.children.pop();
        }
        get parent() {
            let parent = super.parent;
            if (parent === undefined || parent instanceof $4804f857ecc73c01$var$ParserRuleContext) return parent;
            throw new TypeError("Invalid parent type for ParserRuleContext");
        }
        getChild(i, ctxType) {
            if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
            if (ctxType == null) return this.children[i];
            let result = this.tryGetChild(i, ctxType);
            if (result === undefined) throw new Error("The specified node does not exist");
            return result;
        }
        tryGetChild(i, ctxType) {
            if (!this.children || i < 0 || i >= this.children.length) return undefined;
            let j = -1;
            for (let o of this.children)if (o instanceof ctxType) {
                j++;
                if (j === i) return o;
            }
            return undefined;
        }
        getToken(ttype, i) {
            let result = this.tryGetToken(ttype, i);
            if (result === undefined) throw new Error("The specified token does not exist");
            return result;
        }
        tryGetToken(ttype, i) {
            if (!this.children || i < 0 || i >= this.children.length) return undefined;
            let j = -1;
            for (let o of this.children)if (o instanceof $kYC92.TerminalNode) {
                let symbol = o.symbol;
                if (symbol.type === ttype) {
                    j++;
                    if (j === i) return o;
                }
            }
            return undefined;
        }
        getTokens(ttype) {
            let tokens = [];
            if (!this.children) return tokens;
            for (let o of this.children)if (o instanceof $kYC92.TerminalNode) {
                let symbol = o.symbol;
                if (symbol.type === ttype) tokens.push(o);
            }
            return tokens;
        }
        get ruleContext() {
            return this;
        }
        getRuleContext(i, ctxType) {
            return this.getChild(i, ctxType);
        }
        tryGetRuleContext(i, ctxType) {
            return this.tryGetChild(i, ctxType);
        }
        getRuleContexts(ctxType) {
            let contexts = [];
            if (!this.children) return contexts;
            for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
            return contexts;
        }
        get childCount() {
            return this.children ? this.children.length : 0;
        }
        get sourceInterval() {
            if (!this._start) return $gcfUE.Interval.INVALID;
            if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $gcfUE.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1);
            return $gcfUE.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
        }
        get start() {
            return this._start;
        }
        get stop() {
            return this._stop;
        }
        toInfoString(recognizer) {
            let rules = recognizer.getRuleInvocationStack(this).reverse();
            return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
        }
    }
    $4804f857ecc73c01$var$ParserRuleContext.EMPTY = new $4804f857ecc73c01$var$ParserRuleContext();
    $4804f857ecc73c01$var$__decorate([
        $d6D31.Override
    ], $4804f857ecc73c01$var$ParserRuleContext.prototype, "parent", null);
    $4804f857ecc73c01$var$__decorate([
        $d6D31.Override
    ], $4804f857ecc73c01$var$ParserRuleContext.prototype, "childCount", null);
    $4804f857ecc73c01$var$__decorate([
        $d6D31.Override
    ], $4804f857ecc73c01$var$ParserRuleContext.prototype, "sourceInterval", null);
    module.exports.ParserRuleContext = $4804f857ecc73c01$var$ParserRuleContext;
});
parcelRegister("cdCft", function(module, exports) {
    "use strict";
    var $8e545e4dd69efabc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ErrorNode = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $kYC92 = parcelRequire("kYC92");
    class $8e545e4dd69efabc$var$ErrorNode extends $kYC92.TerminalNode {
        constructor(token){
            super(token);
        }
        accept(visitor) {
            return visitor.visitErrorNode(this);
        }
    }
    $8e545e4dd69efabc$var$__decorate([
        $d6D31.Override
    ], $8e545e4dd69efabc$var$ErrorNode.prototype, "accept", null);
    module.exports.ErrorNode = $8e545e4dd69efabc$var$ErrorNode;
});
parcelRegister("kYC92", function(module, exports) {
    "use strict";
    var $f4570001c9e8b34c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.TerminalNode = void 0;
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $f4570001c9e8b34c$var$TerminalNode {
        constructor(symbol){
            this._symbol = symbol;
        }
        getChild(i) {
            throw new RangeError("Terminal Node has no children.");
        }
        get symbol() {
            return this._symbol;
        }
        get parent() {
            return this._parent;
        }
        setParent(parent) {
            this._parent = parent;
        }
        get payload() {
            return this._symbol;
        }
        get sourceInterval() {
            let tokenIndex = this._symbol.tokenIndex;
            return new $gcfUE.Interval(tokenIndex, tokenIndex);
        }
        get childCount() {
            return 0;
        }
        accept(visitor) {
            return visitor.visitTerminal(this);
        }
        get text() {
            return this._symbol.text || "";
        }
        toStringTree(parser) {
            return this.toString();
        }
        toString() {
            if (this._symbol.type === $2DVsz.Token.EOF) return "<EOF>";
            return this._symbol.text || "";
        }
    }
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "getChild", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "parent", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "setParent", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "payload", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "sourceInterval", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "childCount", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "accept", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "text", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "toStringTree", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "toString", null);
    module.exports.TerminalNode = $f4570001c9e8b34c$var$TerminalNode;
});
parcelRegister("c8jEe", function(module, exports) {
    "use strict";
    var $8d557908ece2e6d0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleContext = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $2WQcE = parcelRequire("2WQcE");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $axprj = parcelRequire("axprj");
    var $6bmaO = parcelRequire("6bmaO");
    class $8d557908ece2e6d0$var$RuleContext extends $2WQcE.RuleNode {
        constructor(parent, invokingState){
            super();
            this._parent = parent;
            this.invokingState = invokingState != null ? invokingState : -1;
        }
        static getChildContext(parent, invokingState) {
            return new $8d557908ece2e6d0$var$RuleContext(parent, invokingState);
        }
        depth() {
            let n = 0;
            let p = this;
            while(p){
                p = p._parent;
                n++;
            }
            return n;
        }
        get isEmpty() {
            return this.invokingState === -1;
        }
        get sourceInterval() {
            return $gcfUE.Interval.INVALID;
        }
        get ruleContext() {
            return this;
        }
        get parent() {
            return this._parent;
        }
        setParent(parent) {
            this._parent = parent;
        }
        get payload() {
            return this;
        }
        get text() {
            if (this.childCount === 0) return "";
            let builder = "";
            for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
            return builder.toString();
        }
        get ruleIndex() {
            return -1;
        }
        get altNumber() {
            return $bcnvE.ATN.INVALID_ALT_NUMBER;
        }
        set altNumber(altNumber) {}
        getChild(i) {
            throw new RangeError("i must be greater than or equal to 0 and less than childCount");
        }
        get childCount() {
            return 0;
        }
        accept(visitor) {
            return visitor.visitChildren(this);
        }
        toStringTree(recog) {
            return $axprj.Trees.toStringTree(this, recog);
        }
        toString(arg1, stop) {
            const ruleNames = arg1 instanceof $kBaAZ.Recognizer ? arg1.ruleNames : arg1;
            stop = stop || $6bmaO.ParserRuleContext.emptyContext();
            let buf = "";
            let p = this;
            buf += "[";
            while(p && p !== stop){
                if (!ruleNames) {
                    if (!p.isEmpty) buf += p.invokingState;
                } else {
                    let ruleIndex = p.ruleIndex;
                    let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                    buf += ruleName;
                }
                if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
                p = p._parent;
            }
            buf += "]";
            return buf.toString();
        }
    }
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "sourceInterval", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "ruleContext", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "parent", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "setParent", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "payload", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "text", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "getChild", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "childCount", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "accept", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "toStringTree", null);
    module.exports.RuleContext = $8d557908ece2e6d0$var$RuleContext;
});
parcelRegister("2WQcE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleNode = void 0;
    class $22597dffc9942eb7$var$RuleNode {
    }
    module.exports.RuleNode = $22597dffc9942eb7$var$RuleNode;
});
parcelRegister("axprj", function(module, exports) {
    "use strict";
    var $7ac0b835c35ad12a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7ac0b835c35ad12a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Trees = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $j53rr = parcelRequire("j53rr");
    var $cdCft = parcelRequire("cdCft");
    var $d6D31 = parcelRequire("d6D31");
    var $jIG0W = parcelRequire("jIG0W");
    var $6bmaO = parcelRequire("6bmaO");
    var $2WQcE = parcelRequire("2WQcE");
    var $kYC92 = parcelRequire("kYC92");
    var $2DVsz = parcelRequire("2DVsz");
    var $2IEP9 = parcelRequire("2IEP9");
    class $7ac0b835c35ad12a$var$Trees {
        static toStringTree(t, arg2) {
            let ruleNames;
            if (arg2 instanceof $jIG0W.Parser) ruleNames = arg2.ruleNames;
            else ruleNames = arg2;
            let s = $2IEP9.escapeWhitespace(this.getNodeText(t, ruleNames), false);
            if (t.childCount === 0) return s;
            let buf = "";
            buf += "(";
            s = $2IEP9.escapeWhitespace(this.getNodeText(t, ruleNames), false);
            buf += s;
            buf += " ";
            for(let i = 0; i < t.childCount; i++){
                if (i > 0) buf += " ";
                buf += this.toStringTree(t.getChild(i), ruleNames);
            }
            buf += ")";
            return buf;
        }
        static getNodeText(t, arg2) {
            let ruleNames;
            if (arg2 instanceof $jIG0W.Parser) ruleNames = arg2.ruleNames;
            else if (arg2) ruleNames = arg2;
            else {
                let payload = t.payload;
                if (typeof payload.text === "string") return payload.text;
                return t.payload.toString();
            }
            if (t instanceof $2WQcE.RuleNode) {
                let ruleContext = t.ruleContext;
                let ruleIndex = ruleContext.ruleIndex;
                let ruleName = ruleNames[ruleIndex];
                let altNumber = ruleContext.altNumber;
                if (altNumber !== $bcnvE.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
                return ruleName;
            } else if (t instanceof $cdCft.ErrorNode) return t.toString();
            else if (t instanceof $kYC92.TerminalNode) {
                let symbol = t.symbol;
                return symbol.text || "";
            }
            throw new TypeError("Unexpected node type");
        }
        static getChildren(t) {
            let kids = [];
            for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
            return kids;
        }
        static getAncestors(t) {
            let ancestors = [];
            let p = t.parent;
            while(p){
                ancestors.unshift(p);
                p = p.parent;
            }
            return ancestors;
        }
        static isAncestorOf(t, u) {
            if (!t || !u || !t.parent) return false;
            let p = u.parent;
            while(p){
                if (t === p) return true;
                p = p.parent;
            }
            return false;
        }
        static findAllTokenNodes(t, ttype) {
            return $7ac0b835c35ad12a$var$Trees.findAllNodes(t, ttype, true);
        }
        static findAllRuleNodes(t, ruleIndex) {
            return $7ac0b835c35ad12a$var$Trees.findAllNodes(t, ruleIndex, false);
        }
        static findAllNodes(t, index, findTokens) {
            let nodes = [];
            $7ac0b835c35ad12a$var$Trees._findAllNodes(t, index, findTokens, nodes);
            return nodes;
        }
        static _findAllNodes(t, index, findTokens, nodes) {
            if (findTokens && t instanceof $kYC92.TerminalNode) {
                if (t.symbol.type === index) nodes.push(t);
            } else if (!findTokens && t instanceof $6bmaO.ParserRuleContext) {
                if (t.ruleIndex === index) nodes.push(t);
            }
            for(let i = 0; i < t.childCount; i++)$7ac0b835c35ad12a$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
        }
        static getDescendants(t) {
            let nodes = [];
            function recurse(e) {
                nodes.push(e);
                const n = e.childCount;
                for(let i = 0; i < n; i++)recurse(e.getChild(i));
            }
            recurse(t);
            return nodes;
        }
        static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
            let n = t.childCount;
            for(let i = 0; i < n; i++){
                let child = t.getChild(i);
                let r = $7ac0b835c35ad12a$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
                if (r) return r;
            }
            if (t instanceof $6bmaO.ParserRuleContext) {
                let stopToken = t.stop;
                if (startTokenIndex >= t.start.tokenIndex && (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) return t;
            }
            return undefined;
        }
        static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
            if (!t) return;
            let count = t.childCount;
            for(let i = 0; i < count; i++){
                let child = t.getChild(i);
                let range = child.sourceInterval;
                if (child instanceof $6bmaO.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                    if ($7ac0b835c35ad12a$var$Trees.isAncestorOf(child, root)) {
                        let abbrev = new $j53rr.CommonToken($2DVsz.Token.INVALID_TYPE, "...");
                        t.children[i] = new $kYC92.TerminalNode(abbrev);
                    }
                }
            }
        }
        static findNodeSuchThat(t, pred) {
            if (pred(t)) return t;
            let n = t.childCount;
            for(let i = 0; i < n; i++){
                let u = $7ac0b835c35ad12a$var$Trees.findNodeSuchThat(t.getChild(i), pred);
                if (u !== undefined) return u;
            }
            return undefined;
        }
    }
    $7ac0b835c35ad12a$var$__decorate([
        $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
    ], $7ac0b835c35ad12a$var$Trees, "toStringTree", null);
    $7ac0b835c35ad12a$var$__decorate([
        $d6D31.NotNull,
        $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
    ], $7ac0b835c35ad12a$var$Trees, "getAncestors", null);
    $7ac0b835c35ad12a$var$__decorate([
        $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
    ], $7ac0b835c35ad12a$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
    module.exports.Trees = $7ac0b835c35ad12a$var$Trees;
});
parcelRegister("gDZVV", function(module, exports) {
    "use strict";
    var $c1e05489d1cdbc78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PredictionMode = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $4kGBm = parcelRequire("4kGBm");
    var $c1e05489d1cdbc78$var$PredictionMode;
    (function(PredictionMode) {
        PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
        PredictionMode[PredictionMode["LL"] = 1] = "LL";
        PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
    })($c1e05489d1cdbc78$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
    (function(PredictionMode) {
        class AltAndContextMap extends $fP17P.Array2DHashMap {
            constructor(){
                super(AltAndContextConfigEqualityComparator.INSTANCE);
            }
        }
        class AltAndContextConfigEqualityComparator {
            AltAndContextConfigEqualityComparator() {}
            hashCode(o) {
                let hashCode = $iXFjm.MurmurHash.initialize(7);
                hashCode = $iXFjm.MurmurHash.update(hashCode, o.state.stateNumber);
                hashCode = $iXFjm.MurmurHash.update(hashCode, o.context);
                hashCode = $iXFjm.MurmurHash.finish(hashCode, 2);
                return hashCode;
            }
            equals(a, b) {
                if (a === b) return true;
                if (a == null || b == null) return false;
                return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
            }
        }
        AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
        $c1e05489d1cdbc78$var$__decorate([
            $d6D31.Override
        ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
        $c1e05489d1cdbc78$var$__decorate([
            $d6D31.Override
        ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
        function hasConfigInRuleStopState(configs) {
            for (let c of configs){
                if (c.state instanceof $4kGBm.RuleStopState) return true;
            }
            return false;
        }
        PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
        function allConfigsInRuleStopStates(configs) {
            for (let config of configs){
                if (!(config.state instanceof $4kGBm.RuleStopState)) return false;
            }
            return true;
        }
        PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
    })($c1e05489d1cdbc78$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
});
parcelRegister("g7SCF", function(module, exports) {
    "use strict";
    var $bbd7abb561fe52b9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $bbd7abb561fe52b9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SimulatorState = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $6bmaO = parcelRequire("6bmaO");
    let $bbd7abb561fe52b9$var$SimulatorState = class SimulatorState {
        constructor(outerContext, s0, useContext, remainingOuterContext){
            this.outerContext = outerContext != null ? outerContext : $6bmaO.ParserRuleContext.emptyContext();
            this.s0 = s0;
            this.useContext = useContext;
            this.remainingOuterContext = remainingOuterContext;
        }
    };
    $bbd7abb561fe52b9$var$SimulatorState = $bbd7abb561fe52b9$var$__decorate([
        $bbd7abb561fe52b9$var$__param(1, $d6D31.NotNull)
    ], $bbd7abb561fe52b9$var$SimulatorState);
    module.exports.SimulatorState = $bbd7abb561fe52b9$var$SimulatorState;
});
parcelRegister("d1V7w", function(module, exports) {
    "use strict";
    var $97c7ad4039a43616$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PlusBlockStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $65vNG = parcelRequire("65vNG");
    var $d6D31 = parcelRequire("d6D31");
    class $97c7ad4039a43616$var$PlusBlockStartState extends $65vNG.BlockStartState {
        get stateType() {
            return $1bs3X.ATNStateType.PLUS_BLOCK_START;
        }
    }
    $97c7ad4039a43616$var$__decorate([
        $d6D31.Override
    ], $97c7ad4039a43616$var$PlusBlockStartState.prototype, "stateType", null);
    module.exports.PlusBlockStartState = $97c7ad4039a43616$var$PlusBlockStartState;
});
parcelRegister("7qlbM", function(module, exports) {
    "use strict";
    var $567b65d0d9bb1bcd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PlusLoopbackState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $dPYn6 = parcelRequire("dPYn6");
    var $d6D31 = parcelRequire("d6D31");
    class $567b65d0d9bb1bcd$var$PlusLoopbackState extends $dPYn6.DecisionState {
        get stateType() {
            return $1bs3X.ATNStateType.PLUS_LOOP_BACK;
        }
    }
    $567b65d0d9bb1bcd$var$__decorate([
        $d6D31.Override
    ], $567b65d0d9bb1bcd$var$PlusLoopbackState.prototype, "stateType", null);
    module.exports.PlusLoopbackState = $567b65d0d9bb1bcd$var$PlusLoopbackState;
});
parcelRegister("7KGEQ", function(module, exports) {
    "use strict";
    var $5a4deb3ba0fdbe62$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $5a4deb3ba0fdbe62$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PrecedencePredicateTransition = void 0;
    var $fMVaR = parcelRequire("fMVaR");
    var $d6D31 = parcelRequire("d6D31");
    var $eHMgW = parcelRequire("eHMgW");
    let $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $fMVaR.AbstractPredicateTransition {
        constructor(target, precedence){
            super(target);
            this.precedence = precedence;
        }
        get serializationType() {
            return 10;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        get predicate() {
            return new $eHMgW.SemanticContext.PrecedencePredicate(this.precedence);
        }
        toString() {
            return this.precedence + " >= _p";
        }
    };
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "serializationType", null);
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "matches", null);
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "toString", null);
    $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition = $5a4deb3ba0fdbe62$var$__decorate([
        $5a4deb3ba0fdbe62$var$__param(0, $d6D31.NotNull)
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition);
    module.exports.PrecedencePredicateTransition = $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition;
});
parcelRegister("aISkF", function(module, exports) {
    "use strict";
    var $7ce828b1bf424f49$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7ce828b1bf424f49$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RangeTransition = void 0;
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $7ce828b1bf424f49$var$RangeTransition = class RangeTransition extends $5tcOQ.Transition {
        constructor(target, from, to){
            super(target);
            this.from = from;
            this.to = to;
        }
        get serializationType() {
            return 2;
        }
        get label() {
            return $hGRod.IntervalSet.of(this.from, this.to);
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return symbol >= this.from && symbol <= this.to;
        }
        toString() {
            return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
        }
    };
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "serializationType", null);
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "label", null);
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "matches", null);
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "toString", null);
    $7ce828b1bf424f49$var$RangeTransition = $7ce828b1bf424f49$var$__decorate([
        $7ce828b1bf424f49$var$__param(0, $d6D31.NotNull)
    ], $7ce828b1bf424f49$var$RangeTransition);
    module.exports.RangeTransition = $7ce828b1bf424f49$var$RangeTransition;
});
parcelRegister("j2zc8", function(module, exports) {
    "use strict";
    var $ddc981289e81a506$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleStartState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $ddc981289e81a506$var$RuleStartState extends $7j0Pc.ATNState {
        constructor(){
            super(...arguments);
            this.isPrecedenceRule = false;
            this.leftFactored = false;
        }
        get stateType() {
            return $1bs3X.ATNStateType.RULE_START;
        }
    }
    $ddc981289e81a506$var$__decorate([
        $d6D31.Override
    ], $ddc981289e81a506$var$RuleStartState.prototype, "stateType", null);
    module.exports.RuleStartState = $ddc981289e81a506$var$RuleStartState;
});
parcelRegister("jEsaF", function(module, exports) {
    "use strict";
    var $e4e79af439480b0e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.StarBlockStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $65vNG = parcelRequire("65vNG");
    var $d6D31 = parcelRequire("d6D31");
    class $e4e79af439480b0e$var$StarBlockStartState extends $65vNG.BlockStartState {
        get stateType() {
            return $1bs3X.ATNStateType.STAR_BLOCK_START;
        }
    }
    $e4e79af439480b0e$var$__decorate([
        $d6D31.Override
    ], $e4e79af439480b0e$var$StarBlockStartState.prototype, "stateType", null);
    module.exports.StarBlockStartState = $e4e79af439480b0e$var$StarBlockStartState;
});
parcelRegister("bjwd1", function(module, exports) {
    "use strict";
    var $83ca741f127bc1b0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.StarLoopbackState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $83ca741f127bc1b0$var$StarLoopbackState extends $7j0Pc.ATNState {
        get loopEntryState() {
            return this.transition(0).target;
        }
        get stateType() {
            return $1bs3X.ATNStateType.STAR_LOOP_BACK;
        }
    }
    $83ca741f127bc1b0$var$__decorate([
        $d6D31.Override
    ], $83ca741f127bc1b0$var$StarLoopbackState.prototype, "stateType", null);
    module.exports.StarLoopbackState = $83ca741f127bc1b0$var$StarLoopbackState;
});
parcelRegister("WS4d7", function(module, exports) {
    "use strict";
    var $0b0f5b750847d473$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.TokensStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $dPYn6 = parcelRequire("dPYn6");
    var $d6D31 = parcelRequire("d6D31");
    class $0b0f5b750847d473$var$TokensStartState extends $dPYn6.DecisionState {
        get stateType() {
            return $1bs3X.ATNStateType.TOKEN_START;
        }
    }
    $0b0f5b750847d473$var$__decorate([
        $d6D31.Override
    ], $0b0f5b750847d473$var$TokensStartState.prototype, "stateType", null);
    module.exports.TokensStartState = $0b0f5b750847d473$var$TokensStartState;
});
parcelRegister("kWxOc", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.UUID = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    class $f3f3731a7838b7f9$var$UUID {
        constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
            this.data = new Uint32Array(4);
            this.data[0] = mostSigBits;
            this.data[1] = moreSigBits;
            this.data[2] = lessSigBits;
            this.data[3] = leastSigBits;
        }
        static fromString(data) {
            if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
            let segments = data.split("-");
            let mostSigBits = parseInt(segments[0], 16);
            let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
            let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
            let leastSigBits = parseInt(segments[4].substr(-8), 16);
            return new $f3f3731a7838b7f9$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
        }
        hashCode() {
            return $iXFjm.MurmurHash.hashCode([
                this.data[0],
                this.data[1],
                this.data[2],
                this.data[3]
            ]);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $f3f3731a7838b7f9$var$UUID)) return false;
            return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
        }
        toString() {
            return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
        }
    }
    module.exports.UUID = $f3f3731a7838b7f9$var$UUID;
});
parcelRegister("3iOjI", function(module, exports) {
    "use strict";
    var $267a15775466fb93$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $267a15775466fb93$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParseInfo = void 0;
    var $d6D31 = parcelRequire("d6D31");
    let $267a15775466fb93$var$ParseInfo = class ParseInfo {
        constructor(atnSimulator){
            this.atnSimulator = atnSimulator;
        }
        getDecisionInfo() {
            return this.atnSimulator.getDecisionInfo();
        }
        getLLDecisions() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let LL = [];
            for(let i = 0; i < decisions.length; i++){
                let fallBack = decisions[i].LL_Fallback;
                if (fallBack > 0) LL.push(i);
            }
            return LL;
        }
        getTotalTimeInPrediction() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let t = 0;
            for (let decision of decisions)t += decision.timeInPrediction;
            return t;
        }
        getTotalSLLLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.SLL_TotalLook;
            return k;
        }
        getTotalLLLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.LL_TotalLook;
            return k;
        }
        getTotalSLLATNLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.SLL_ATNTransitions;
            return k;
        }
        getTotalLLATNLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.LL_ATNTransitions;
            return k;
        }
        getTotalATNLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions){
                k += decision.SLL_ATNTransitions;
                k += decision.LL_ATNTransitions;
            }
            return k;
        }
        getDFASize(decision) {
            if (decision) {
                let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
                return decisionToDFA.states.size;
            } else {
                let n = 0;
                let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
                for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
                return n;
            }
        }
    };
    $267a15775466fb93$var$__decorate([
        $d6D31.NotNull
    ], $267a15775466fb93$var$ParseInfo.prototype, "getDecisionInfo", null);
    $267a15775466fb93$var$__decorate([
        $d6D31.NotNull
    ], $267a15775466fb93$var$ParseInfo.prototype, "getLLDecisions", null);
    $267a15775466fb93$var$ParseInfo = $267a15775466fb93$var$__decorate([
        $267a15775466fb93$var$__param(0, $d6D31.NotNull)
    ], $267a15775466fb93$var$ParseInfo);
    module.exports.ParseInfo = $267a15775466fb93$var$ParseInfo;
});
parcelRegister("5xwgp", function(module, exports) {
    "use strict";
    var $40890fafca7801d5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ProxyParserErrorListener = void 0;
    var $65iNZ = parcelRequire("65iNZ");
    var $d6D31 = parcelRequire("d6D31");
    class $40890fafca7801d5$var$ProxyParserErrorListener extends $65iNZ.ProxyErrorListener {
        constructor(delegates){
            super(delegates);
        }
        reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
            this.getDelegates().forEach((listener)=>{
                if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
            });
        }
        reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
            this.getDelegates().forEach((listener)=>{
                if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
            });
        }
        reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
            this.getDelegates().forEach((listener)=>{
                if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
            });
        }
    }
    $40890fafca7801d5$var$__decorate([
        $d6D31.Override
    ], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
    $40890fafca7801d5$var$__decorate([
        $d6D31.Override
    ], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
    $40890fafca7801d5$var$__decorate([
        $d6D31.Override
    ], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
    module.exports.ProxyParserErrorListener = $40890fafca7801d5$var$ProxyParserErrorListener;
});
parcelRegister("dE6Cn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1rIkv").then(()=>parcelRequire('gpWGO'));
});
parcelRegister("kSEFX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d6qIW").then(()=>parcelRequire('cJzXV'));
});
parcelRegister("3kXUy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParseCancellationException = void 0;
    class $26e1b6704997a3f4$var$ParseCancellationException extends Error {
        constructor(cause){
            super(cause.message);
            this.cause = cause;
            this.stack = cause.stack;
        }
        getCause() {
            return this.cause;
        }
    }
    module.exports.ParseCancellationException = $26e1b6704997a3f4$var$ParseCancellationException;
});
parcelRegister("1UkCC", function(module, exports) {
    "use strict";
    var $163b0480402006d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $163b0480402006d6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BufferedTokenStream = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $j53rr = parcelRequire("j53rr");
    var $gcfUE = parcelRequire("gcfUE");
    var $igNLf = parcelRequire("igNLf");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $163b0480402006d6$var$BufferedTokenStream = class BufferedTokenStream {
        constructor(tokenSource){
            this.tokens = [];
            this.p = -1;
            this.fetchedEOF = false;
            if (tokenSource == null) throw new Error("tokenSource cannot be null");
            this._tokenSource = tokenSource;
        }
        get tokenSource() {
            return this._tokenSource;
        }
        set tokenSource(tokenSource) {
            this._tokenSource = tokenSource;
            this.tokens.length = 0;
            this.p = -1;
            this.fetchedEOF = false;
        }
        get index() {
            return this.p;
        }
        mark() {
            return 0;
        }
        release(marker) {}
        seek(index) {
            this.lazyInit();
            this.p = this.adjustSeekIndex(index);
        }
        get size() {
            return this.tokens.length;
        }
        consume() {
            let skipEofCheck;
            if (this.p >= 0) {
                if (this.fetchedEOF) skipEofCheck = this.p < this.tokens.length - 1;
                else skipEofCheck = this.p < this.tokens.length;
            } else skipEofCheck = false;
            if (!skipEofCheck && this.LA(1) === $2DVsz.Token.EOF) throw new Error("cannot consume EOF");
            if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
        }
        sync(i) {
            $bbHFU(i >= 0);
            let n = i - this.tokens.length + 1;
            if (n > 0) {
                let fetched = this.fetch(n);
                return fetched >= n;
            }
            return true;
        }
        fetch(n) {
            if (this.fetchedEOF) return 0;
            for(let i = 0; i < n; i++){
                let t = this.tokenSource.nextToken();
                if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
                this.tokens.push(t);
                if (t.type === $2DVsz.Token.EOF) {
                    this.fetchedEOF = true;
                    return i + 1;
                }
            }
            return n;
        }
        get(i) {
            if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
            return this.tokens[i];
        }
        getRange(start, stop) {
            if (start < 0 || stop < 0) return [];
            this.lazyInit();
            let subset = new Array();
            if (stop >= this.tokens.length) stop = this.tokens.length - 1;
            for(let i = start; i <= stop; i++){
                let t = this.tokens[i];
                if (t.type === $2DVsz.Token.EOF) break;
                subset.push(t);
            }
            return subset;
        }
        LA(i) {
            let token = this.LT(i);
            if (!token) return $2DVsz.Token.INVALID_TYPE;
            return token.type;
        }
        tryLB(k) {
            if (this.p - k < 0) return undefined;
            return this.tokens[this.p - k];
        }
        LT(k) {
            let result = this.tryLT(k);
            if (result === undefined) throw new RangeError("requested lookback index out of range");
            return result;
        }
        tryLT(k) {
            this.lazyInit();
            if (k === 0) throw new RangeError("0 is not a valid lookahead index");
            if (k < 0) return this.tryLB(-k);
            let i = this.p + k - 1;
            this.sync(i);
            if (i >= this.tokens.length) return this.tokens[this.tokens.length - 1];
            return this.tokens[i];
        }
        adjustSeekIndex(i) {
            return i;
        }
        lazyInit() {
            if (this.p === -1) this.setup();
        }
        setup() {
            this.sync(0);
            this.p = this.adjustSeekIndex(0);
        }
        getTokens(start, stop, types) {
            this.lazyInit();
            if (start === undefined) {
                $bbHFU(stop === undefined && types === undefined);
                return this.tokens;
            } else if (stop === undefined) stop = this.tokens.length - 1;
            if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
            if (start > stop) return [];
            if (types === undefined) return this.tokens.slice(start, stop + 1);
            else if (typeof types === "number") types = new Set().add(types);
            let typesSet = types;
            let filteredTokens = this.tokens.slice(start, stop + 1);
            filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
            return filteredTokens;
        }
        nextTokenOnChannel(i, channel) {
            this.sync(i);
            if (i >= this.size) return this.size - 1;
            let token = this.tokens[i];
            while(token.channel !== channel){
                if (token.type === $2DVsz.Token.EOF) return i;
                i++;
                this.sync(i);
                token = this.tokens[i];
            }
            return i;
        }
        previousTokenOnChannel(i, channel) {
            this.sync(i);
            if (i >= this.size) return this.size - 1;
            while(i >= 0){
                let token = this.tokens[i];
                if (token.type === $2DVsz.Token.EOF || token.channel === channel) return i;
                i--;
            }
            return i;
        }
        getHiddenTokensToRight(tokenIndex, channel = -1) {
            this.lazyInit();
            if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
            let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL);
            let to;
            let from = tokenIndex + 1;
            if (nextOnChannel === -1) to = this.size - 1;
            else to = nextOnChannel;
            return this.filterForChannel(from, to, channel);
        }
        getHiddenTokensToLeft(tokenIndex, channel = -1) {
            this.lazyInit();
            if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
            if (tokenIndex === 0) return [];
            let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL);
            if (prevOnChannel === tokenIndex - 1) return [];
            let from = prevOnChannel + 1;
            let to = tokenIndex - 1;
            return this.filterForChannel(from, to, channel);
        }
        filterForChannel(from, to, channel) {
            let hidden = new Array();
            for(let i = from; i <= to; i++){
                let t = this.tokens[i];
                if (channel === -1) {
                    if (t.channel !== $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
                } else if (t.channel === channel) hidden.push(t);
            }
            return hidden;
        }
        get sourceName() {
            return this.tokenSource.sourceName;
        }
        getText(interval) {
            if (interval === undefined) interval = $gcfUE.Interval.of(0, this.size - 1);
            else if (!(interval instanceof $gcfUE.Interval)) interval = interval.sourceInterval;
            let start = interval.a;
            let stop = interval.b;
            if (start < 0 || stop < 0) return "";
            this.fill();
            if (stop >= this.tokens.length) stop = this.tokens.length - 1;
            let buf = "";
            for(let i = start; i <= stop; i++){
                let t = this.tokens[i];
                if (t.type === $2DVsz.Token.EOF) break;
                buf += t.text;
            }
            return buf.toString();
        }
        getTextFromRange(start, stop) {
            if (this.isToken(start) && this.isToken(stop)) return this.getText($gcfUE.Interval.of(start.tokenIndex, stop.tokenIndex));
            return "";
        }
        fill() {
            this.lazyInit();
            const blockSize = 1000;
            while(true){
                let fetched = this.fetch(blockSize);
                if (fetched < blockSize) return;
            }
        }
        isWritableToken(t) {
            return t instanceof $j53rr.CommonToken;
        }
        isToken(t) {
            return t instanceof $j53rr.CommonToken;
        }
    };
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "tokenSource", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "index", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "mark", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "release", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "seek", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "size", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "consume", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "get", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "LA", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull,
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "LT", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "sourceName", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull,
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "getText", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull,
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "getTextFromRange", null);
    $163b0480402006d6$var$BufferedTokenStream = $163b0480402006d6$var$__decorate([
        $163b0480402006d6$var$__param(0, $d6D31.NotNull)
    ], $163b0480402006d6$var$BufferedTokenStream);
    module.exports.BufferedTokenStream = $163b0480402006d6$var$BufferedTokenStream;
});
parcelRegister("QidO0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("9NnFz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CharStreams = void 0;
    var $1Olk0 = parcelRequire("1Olk0");
    var $7ufNj = parcelRequire("7ufNj");
    var $ceaEj = parcelRequire("ceaEj");
    var $721b0cebe5798117$var$CharStreams;
    (function(CharStreams) {
        function fromString(s, sourceName) {
            if (sourceName === undefined || sourceName.length === 0) sourceName = $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
            let codePointBufferBuilder = $1Olk0.CodePointBuffer.builder(s.length);
            let cb = new Uint16Array(s.length);
            for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
            codePointBufferBuilder.append(cb);
            return $7ufNj.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
        }
        CharStreams.fromString = fromString;
    })($721b0cebe5798117$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));
});
parcelRegister("1Olk0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CodePointBuffer = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $gIRNa = parcelRequire("gIRNa");
    class $151b0001e5dcadf1$var$CodePointBuffer {
        constructor(buffer, size){
            this.buffer = buffer;
            this._position = 0;
            this._size = size;
        }
        static withArray(buffer) {
            return new $151b0001e5dcadf1$var$CodePointBuffer(buffer, buffer.length);
        }
        get position() {
            return this._position;
        }
        set position(newPosition) {
            if (newPosition < 0 || newPosition > this._size) throw new RangeError();
            this._position = newPosition;
        }
        get remaining() {
            return this._size - this.position;
        }
        get(offset) {
            return this.buffer[offset];
        }
        array() {
            return this.buffer.slice(0, this._size);
        }
        static builder(initialBufferSize) {
            return new $151b0001e5dcadf1$var$CodePointBuffer.Builder(initialBufferSize);
        }
    }
    module.exports.CodePointBuffer = $151b0001e5dcadf1$var$CodePointBuffer;
    (function(CodePointBuffer) {
        let Type;
        (function(Type) {
            Type[Type["BYTE"] = 0] = "BYTE";
            Type[Type["CHAR"] = 1] = "CHAR";
            Type[Type["INT"] = 2] = "INT";
        })(Type || (Type = {}));
        class Builder {
            constructor(initialBufferSize){
                this.type = 0;
                this.buffer = new Uint8Array(initialBufferSize);
                this.prevHighSurrogate = -1;
                this.position = 0;
            }
            build() {
                return new CodePointBuffer(this.buffer, this.position);
            }
            static roundUpToNextPowerOfTwo(i) {
                let nextPowerOfTwo = 32 - Math.clz32(i - 1);
                return Math.pow(2, nextPowerOfTwo);
            }
            ensureRemaining(remainingNeeded) {
                switch(this.type){
                    case 0:
                        if (this.buffer.length - this.position < remainingNeeded) {
                            let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                            let newBuffer = new Uint8Array(newCapacity);
                            newBuffer.set(this.buffer.subarray(0, this.position), 0);
                            this.buffer = newBuffer;
                        }
                        break;
                    case 1:
                        if (this.buffer.length - this.position < remainingNeeded) {
                            let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                            let newBuffer = new Uint16Array(newCapacity);
                            newBuffer.set(this.buffer.subarray(0, this.position), 0);
                            this.buffer = newBuffer;
                        }
                        break;
                    case 2:
                        if (this.buffer.length - this.position < remainingNeeded) {
                            let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                            let newBuffer = new Int32Array(newCapacity);
                            newBuffer.set(this.buffer.subarray(0, this.position), 0);
                            this.buffer = newBuffer;
                        }
                        break;
                }
            }
            append(utf16In) {
                this.ensureRemaining(utf16In.length);
                this.appendArray(utf16In);
            }
            appendArray(utf16In) {
                switch(this.type){
                    case 0:
                        this.appendArrayByte(utf16In);
                        break;
                    case 1:
                        this.appendArrayChar(utf16In);
                        break;
                    case 2:
                        this.appendArrayInt(utf16In);
                        break;
                }
            }
            appendArrayByte(utf16In) {
                $bbHFU(this.prevHighSurrogate === -1);
                let input = utf16In;
                let inOffset = 0;
                let inLimit = utf16In.length;
                let outByte = this.buffer;
                let outOffset = this.position;
                while(inOffset < inLimit){
                    let c = input[inOffset];
                    if (c <= 0xFF) outByte[outOffset] = c;
                    else {
                        utf16In = utf16In.subarray(inOffset, inLimit);
                        this.position = outOffset;
                        if (!$gIRNa.isHighSurrogate(c)) {
                            this.byteToCharBuffer(utf16In.length);
                            this.appendArrayChar(utf16In);
                            return;
                        } else {
                            this.byteToIntBuffer(utf16In.length);
                            this.appendArrayInt(utf16In);
                            return;
                        }
                    }
                    inOffset++;
                    outOffset++;
                }
                this.position = outOffset;
            }
            appendArrayChar(utf16In) {
                $bbHFU(this.prevHighSurrogate === -1);
                let input = utf16In;
                let inOffset = 0;
                let inLimit = utf16In.length;
                let outChar = this.buffer;
                let outOffset = this.position;
                while(inOffset < inLimit){
                    let c = input[inOffset];
                    if (!$gIRNa.isHighSurrogate(c)) outChar[outOffset] = c;
                    else {
                        utf16In = utf16In.subarray(inOffset, inLimit);
                        this.position = outOffset;
                        this.charToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                    inOffset++;
                    outOffset++;
                }
                this.position = outOffset;
            }
            appendArrayInt(utf16In) {
                let input = utf16In;
                let inOffset = 0;
                let inLimit = utf16In.length;
                let outInt = this.buffer;
                let outOffset = this.position;
                while(inOffset < inLimit){
                    let c = input[inOffset];
                    inOffset++;
                    if (this.prevHighSurrogate !== -1) {
                        if ($gIRNa.isLowSurrogate(c)) {
                            outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        } else {
                            outInt[outOffset] = this.prevHighSurrogate;
                            outOffset++;
                            if ($gIRNa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                            else {
                                outInt[outOffset] = c;
                                outOffset++;
                                this.prevHighSurrogate = -1;
                            }
                        }
                    } else if ($gIRNa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                    else {
                        outInt[outOffset] = c;
                        outOffset++;
                    }
                }
                if (this.prevHighSurrogate !== -1) {
                    outInt[outOffset] = this.prevHighSurrogate;
                    outOffset++;
                }
                this.position = outOffset;
            }
            byteToCharBuffer(toAppend) {
                let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
                newBuffer.set(this.buffer.subarray(0, this.position), 0);
                this.type = 1;
                this.buffer = newBuffer;
            }
            byteToIntBuffer(toAppend) {
                let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
                newBuffer.set(this.buffer.subarray(0, this.position), 0);
                this.type = 2;
                this.buffer = newBuffer;
            }
            charToIntBuffer(toAppend) {
                let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
                newBuffer.set(this.buffer.subarray(0, this.position), 0);
                this.type = 2;
                this.buffer = newBuffer;
            }
        }
        CodePointBuffer.Builder = Builder;
    })($151b0001e5dcadf1$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));
});
parcelRegister("gIRNa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
    function $c2ca7b5ca2fc06e2$var$isHighSurrogate(ch) {
        return ch >= 0xD800 && ch <= 0xDBFF;
    }
    module.exports.isHighSurrogate = $c2ca7b5ca2fc06e2$var$isHighSurrogate;
    function $c2ca7b5ca2fc06e2$var$isLowSurrogate(ch) {
        return ch >= 0xDC00 && ch <= 0xDFFF;
    }
    module.exports.isLowSurrogate = $c2ca7b5ca2fc06e2$var$isLowSurrogate;
    function $c2ca7b5ca2fc06e2$var$isSupplementaryCodePoint(ch) {
        return ch >= 0x10000;
    }
    module.exports.isSupplementaryCodePoint = $c2ca7b5ca2fc06e2$var$isSupplementaryCodePoint;
});
parcelRegister("7ufNj", function(module, exports) {
    "use strict";
    var $57379632ac21bb89$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CodePointCharStream = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $ceaEj = parcelRequire("ceaEj");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    class $57379632ac21bb89$var$CodePointCharStream {
        constructor(array, position, remaining, name){
            $bbHFU(position === 0);
            this._array = array;
            this._size = remaining;
            this._name = name;
            this._position = 0;
        }
        get internalStorage() {
            return this._array;
        }
        static fromBuffer(codePointBuffer, name) {
            if (name === undefined || name.length === 0) name = $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
            return new $57379632ac21bb89$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
        }
        consume() {
            if (this._size - this._position === 0) {
                $bbHFU(this.LA(1) === $ceaEj.IntStream.EOF);
                throw new RangeError("cannot consume EOF");
            }
            this._position++;
        }
        get index() {
            return this._position;
        }
        get size() {
            return this._size;
        }
        mark() {
            return -1;
        }
        release(marker) {}
        seek(index) {
            this._position = index;
        }
        get sourceName() {
            return this._name;
        }
        toString() {
            return this.getText($gcfUE.Interval.of(0, this.size - 1));
        }
        LA(i) {
            let offset;
            switch(Math.sign(i)){
                case -1:
                    offset = this.index + i;
                    if (offset < 0) return $ceaEj.IntStream.EOF;
                    return this._array[offset];
                case 0:
                    return 0;
                case 1:
                    offset = this.index + i - 1;
                    if (offset >= this.size) return $ceaEj.IntStream.EOF;
                    return this._array[offset];
            }
            throw new RangeError("Not reached");
        }
        getText(interval) {
            const startIdx = Math.min(interval.a, this.size);
            const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
            if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
            else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        }
    }
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "consume", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "index", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "size", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "mark", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "release", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "seek", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "sourceName", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "toString", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "LA", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "getText", null);
    module.exports.CodePointCharStream = $57379632ac21bb89$var$CodePointCharStream;
});
parcelRegister("a0nC0", function(module, exports) {
    "use strict";
    var $748c38524e2afd86$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $748c38524e2afd86$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CommonTokenStream = void 0;
    var $1UkCC = parcelRequire("1UkCC");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $748c38524e2afd86$var$CommonTokenStream = class CommonTokenStream extends $1UkCC.BufferedTokenStream {
        constructor(tokenSource, channel = $2DVsz.Token.DEFAULT_CHANNEL){
            super(tokenSource);
            this.channel = channel;
        }
        adjustSeekIndex(i) {
            return this.nextTokenOnChannel(i, this.channel);
        }
        tryLB(k) {
            if (this.p - k < 0) return undefined;
            let i = this.p;
            let n = 1;
            while(n <= k && i > 0){
                i = this.previousTokenOnChannel(i - 1, this.channel);
                n++;
            }
            if (i < 0) return undefined;
            return this.tokens[i];
        }
        tryLT(k) {
            this.lazyInit();
            if (k === 0) throw new RangeError("0 is not a valid lookahead index");
            if (k < 0) return this.tryLB(-k);
            let i = this.p;
            let n = 1;
            while(n < k){
                if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
                n++;
            }
            return this.tokens[i];
        }
        getNumberOfOnChannelTokens() {
            let n = 0;
            this.fill();
            for (let t of this.tokens){
                if (t.channel === this.channel) n++;
                if (t.type === $2DVsz.Token.EOF) break;
            }
            return n;
        }
    };
    $748c38524e2afd86$var$__decorate([
        $d6D31.Override
    ], $748c38524e2afd86$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
    $748c38524e2afd86$var$__decorate([
        $d6D31.Override
    ], $748c38524e2afd86$var$CommonTokenStream.prototype, "tryLB", null);
    $748c38524e2afd86$var$__decorate([
        $d6D31.Override
    ], $748c38524e2afd86$var$CommonTokenStream.prototype, "tryLT", null);
    $748c38524e2afd86$var$CommonTokenStream = $748c38524e2afd86$var$__decorate([
        $748c38524e2afd86$var$__param(0, $d6D31.NotNull)
    ], $748c38524e2afd86$var$CommonTokenStream);
    module.exports.CommonTokenStream = $748c38524e2afd86$var$CommonTokenStream;
});
parcelRegister("4a3G0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Dependents = void 0;
    var $307af2a6cd217eb5$var$Dependents;
    (function(Dependents) {
        Dependents[Dependents["SELF"] = 0] = "SELF";
        Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
        Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
        Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
        Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
        Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
        Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
        Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
        Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
        Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
    })($307af2a6cd217eb5$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));
});
parcelRegister("5Poq6", function(module, exports) {
    "use strict";
    var $43e4a87e035cc726$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $43e4a87e035cc726$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DiagnosticErrorListener = void 0;
    var $5BPMp = parcelRequire("5BPMp");
    var $d6D31 = parcelRequire("d6D31");
    var $gcfUE = parcelRequire("gcfUE");
    class $43e4a87e035cc726$var$DiagnosticErrorListener {
        constructor(exactOnly = true){
            this.exactOnly = exactOnly;
            this.exactOnly = exactOnly;
        }
        syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {}
        reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
            if (this.exactOnly && !exact) return;
            let decision = this.getDecisionDescription(recognizer, dfa);
            let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
            let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
            let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
            recognizer.notifyErrorListeners(message);
        }
        reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
            let format = "reportAttemptingFullContext d=%s, input='%s'";
            let decision = this.getDecisionDescription(recognizer, dfa);
            let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
            let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
            recognizer.notifyErrorListeners(message);
        }
        reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
            let format = "reportContextSensitivity d=%s, input='%s'";
            let decision = this.getDecisionDescription(recognizer, dfa);
            let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
            let message = `reportContextSensitivity d=${decision}, input='${text}'`;
            recognizer.notifyErrorListeners(message);
        }
        getDecisionDescription(recognizer, dfa) {
            let decision = dfa.decision;
            let ruleIndex = dfa.atnStartState.ruleIndex;
            let ruleNames = recognizer.ruleNames;
            if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
            let ruleName = ruleNames[ruleIndex];
            if (!ruleName) return decision.toString();
            return `${decision} (${ruleName})`;
        }
        getConflictingAlts(reportedAlts, configs) {
            if (reportedAlts != null) return reportedAlts;
            let result = new $5BPMp.BitSet();
            for (let config of configs)result.set(config.alt);
            return result;
        }
    }
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "syntaxError", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override,
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(6, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override,
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(5, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override,
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(5, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
    $43e4a87e035cc726$var$__decorate([
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.NotNull,
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
    module.exports.DiagnosticErrorListener = $43e4a87e035cc726$var$DiagnosticErrorListener;
});
parcelRegister("5FrZ8", function(module, exports) {
    "use strict";
    var $42067d58e54221f4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.InterpreterRuleContext = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $6bmaO = parcelRequire("6bmaO");
    class $42067d58e54221f4$var$InterpreterRuleContext extends $6bmaO.ParserRuleContext {
        constructor(ruleIndex, parent, invokingStateNumber){
            if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
            else super();
            this._ruleIndex = ruleIndex;
        }
        get ruleIndex() {
            return this._ruleIndex;
        }
    }
    $42067d58e54221f4$var$__decorate([
        $d6D31.Override
    ], $42067d58e54221f4$var$InterpreterRuleContext.prototype, "ruleIndex", null);
    module.exports.InterpreterRuleContext = $42067d58e54221f4$var$InterpreterRuleContext;
});
parcelRegister("gMbxO", function(module, exports) {
    "use strict";
    var $c36a1586c540a239$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $c36a1586c540a239$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerInterpreter = void 0;
    var $igNLf = parcelRequire("igNLf");
    var $lQecE = parcelRequire("lQecE");
    var $d6D31 = parcelRequire("d6D31");
    var $d6D31 = parcelRequire("d6D31");
    let $c36a1586c540a239$var$LexerInterpreter = class LexerInterpreter extends $igNLf.Lexer {
        constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
            super(input);
            if (atn.grammarType !== 0) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._channelNames = channelNames.slice(0);
            this._modeNames = modeNames.slice(0);
            this._vocabulary = vocabulary;
            this._interp = new $lQecE.LexerATNSimulator(atn, this);
        }
        get atn() {
            return this._atn;
        }
        get grammarFileName() {
            return this._grammarFileName;
        }
        get ruleNames() {
            return this._ruleNames;
        }
        get channelNames() {
            return this._channelNames;
        }
        get modeNames() {
            return this._modeNames;
        }
        get vocabulary() {
            return this._vocabulary;
        }
    };
    $c36a1586c540a239$var$__decorate([
        $d6D31.NotNull
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "_vocabulary", void 0);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "atn", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "grammarFileName", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "ruleNames", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "channelNames", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "modeNames", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "vocabulary", null);
    $c36a1586c540a239$var$LexerInterpreter = $c36a1586c540a239$var$__decorate([
        $c36a1586c540a239$var$__param(1, $d6D31.NotNull)
    ], $c36a1586c540a239$var$LexerInterpreter);
    module.exports.LexerInterpreter = $c36a1586c540a239$var$LexerInterpreter;
});
parcelRegister("drCaH", function(module, exports) {
    "use strict";
    var $9c9b68135c38f0cc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $9c9b68135c38f0cc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ListTokenSource = void 0;
    var $gWaB3 = parcelRequire("gWaB3");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $9c9b68135c38f0cc$var$ListTokenSource = class ListTokenSource {
        constructor(tokens, sourceName){
            this.i = 0;
            this._factory = $gWaB3.CommonTokenFactory.DEFAULT;
            if (tokens == null) throw new Error("tokens cannot be null");
            this.tokens = tokens;
            this._sourceName = sourceName;
        }
        get charPositionInLine() {
            if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
            else if (this.eofToken != null) return this.eofToken.charPositionInLine;
            else if (this.tokens.length > 0) {
                let lastToken = this.tokens[this.tokens.length - 1];
                let tokenText = lastToken.text;
                if (tokenText != null) {
                    let lastNewLine = tokenText.lastIndexOf("\n");
                    if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
                }
                return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
            }
            return 0;
        }
        nextToken() {
            if (this.i >= this.tokens.length) {
                if (this.eofToken == null) {
                    let start = -1;
                    if (this.tokens.length > 0) {
                        let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                        if (previousStop !== -1) start = previousStop + 1;
                    }
                    let stop = Math.max(-1, start - 1);
                    this.eofToken = this._factory.create({
                        source: this,
                        stream: this.inputStream
                    }, $2DVsz.Token.EOF, "EOF", $2DVsz.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
                }
                return this.eofToken;
            }
            let t = this.tokens[this.i];
            if (this.i === this.tokens.length - 1 && t.type === $2DVsz.Token.EOF) this.eofToken = t;
            this.i++;
            return t;
        }
        get line() {
            if (this.i < this.tokens.length) return this.tokens[this.i].line;
            else if (this.eofToken != null) return this.eofToken.line;
            else if (this.tokens.length > 0) {
                let lastToken = this.tokens[this.tokens.length - 1];
                let line = lastToken.line;
                let tokenText = lastToken.text;
                if (tokenText != null) {
                    for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
                }
                return line;
            }
            return 1;
        }
        get inputStream() {
            if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
            else if (this.eofToken != null) return this.eofToken.inputStream;
            else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
            return undefined;
        }
        get sourceName() {
            if (this._sourceName) return this._sourceName;
            let inputStream = this.inputStream;
            if (inputStream != null) return inputStream.sourceName;
            return "List";
        }
        set tokenFactory(factory) {
            this._factory = factory;
        }
        get tokenFactory() {
            return this._factory;
        }
    };
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "charPositionInLine", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "nextToken", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "line", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "inputStream", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "sourceName", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull,
        $9c9b68135c38f0cc$var$__param(0, $d6D31.NotNull)
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "tokenFactory", null);
    $9c9b68135c38f0cc$var$ListTokenSource = $9c9b68135c38f0cc$var$__decorate([
        $9c9b68135c38f0cc$var$__param(0, $d6D31.NotNull)
    ], $9c9b68135c38f0cc$var$ListTokenSource);
    module.exports.ListTokenSource = $9c9b68135c38f0cc$var$ListTokenSource;
});
parcelRegister("2pQQd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("dReoi", function(module, exports) {
    "use strict";
    var $a16b634f90dd81f4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $a16b634f90dd81f4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParserInterpreter = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $5BPMp = parcelRequire("5BPMp");
    var $ea0YW = parcelRequire("ea0YW");
    var $iLUMi = parcelRequire("iLUMi");
    var $5FrZ8 = parcelRequire("5FrZ8");
    var $kfqEk = parcelRequire("kfqEk");
    var $d6D31 = parcelRequire("d6D31");
    var $d6D31 = parcelRequire("d6D31");
    var $jIG0W = parcelRequire("jIG0W");
    var $kzbnL = parcelRequire("kzbnL");
    var $fLdDn = parcelRequire("fLdDn");
    var $f9raX = parcelRequire("f9raX");
    var $2DVsz = parcelRequire("2DVsz");
    let $a16b634f90dd81f4$var$ParserInterpreter = class ParserInterpreter extends $jIG0W.Parser {
        constructor(grammarFileName, vocabulary, ruleNames, atn, input){
            super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
            this._parentContextStack = [];
            this.overrideDecision = -1;
            this.overrideDecisionInputIndex = -1;
            this.overrideDecisionAlt = -1;
            this.overrideDecisionReached = false;
            this._overrideDecisionRoot = undefined;
            if (grammarFileName instanceof ParserInterpreter) {
                let old = grammarFileName;
                this._grammarFileName = old._grammarFileName;
                this._atn = old._atn;
                this.pushRecursionContextStates = old.pushRecursionContextStates;
                this._ruleNames = old._ruleNames;
                this._vocabulary = old._vocabulary;
                this.interpreter = new $kzbnL.ParserATNSimulator(this._atn, this);
            } else {
                vocabulary;
                ruleNames;
                atn;
                this._grammarFileName = grammarFileName;
                this._atn = atn;
                this._ruleNames = ruleNames.slice(0);
                this._vocabulary = vocabulary;
                this.pushRecursionContextStates = new $5BPMp.BitSet(atn.states.length);
                for (let state of atn.states){
                    if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                    if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
                }
                this.interpreter = new $kzbnL.ParserATNSimulator(atn, this);
            }
        }
        reset(resetInput) {
            if (resetInput === undefined) super.reset();
            else super.reset(resetInput);
            this.overrideDecisionReached = false;
            this._overrideDecisionRoot = undefined;
        }
        get atn() {
            return this._atn;
        }
        get vocabulary() {
            return this._vocabulary;
        }
        get ruleNames() {
            return this._ruleNames;
        }
        get grammarFileName() {
            return this._grammarFileName;
        }
        parse(startRuleIndex) {
            let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
            this._rootContext = this.createInterpreterRuleContext(undefined, $7j0Pc.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
            if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
            else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
            while(true){
                let p = this.atnState;
                switch(p.stateType){
                    case $1bs3X.ATNStateType.RULE_STOP:
                        if (this._ctx.isEmpty) {
                            if (startRuleStartState.isPrecedenceRule) {
                                let result = this._ctx;
                                let parentContext = this._parentContextStack.pop();
                                this.unrollRecursionContexts(parentContext[0]);
                                return result;
                            } else {
                                this.exitRule();
                                return this._rootContext;
                            }
                        }
                        this.visitRuleStopState(p);
                        break;
                    default:
                        try {
                            this.visitState(p);
                        } catch (e) {
                            if (e instanceof $fLdDn.RecognitionException) {
                                this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                                this.context.exception = e;
                                this.errorHandler.reportError(this, e);
                                this.recover(e);
                            } else throw e;
                        }
                        break;
                }
            }
        }
        enterRecursionRule(localctx, state, ruleIndex, precedence) {
            this._parentContextStack.push([
                this._ctx,
                localctx.invokingState
            ]);
            super.enterRecursionRule(localctx, state, ruleIndex, precedence);
        }
        get atnState() {
            return this._atn.states[this.state];
        }
        visitState(p) {
            let predictedAlt = 1;
            if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
            let transition = p.transition(predictedAlt - 1);
            switch(transition.serializationType){
                case 1:
                    if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $kfqEk.LoopEndState)) {
                        let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                        let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                        this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                    }
                    break;
                case 5:
                    this.match(transition._label);
                    break;
                case 2:
                case 7:
                case 8:
                    if (!transition.matches(this._input.LA(1), $2DVsz.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                    this.matchWildcard();
                    break;
                case 9:
                    this.matchWildcard();
                    break;
                case 3:
                    let ruleStartState = transition.target;
                    let ruleIndex = ruleStartState.ruleIndex;
                    let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                    if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                    else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                    break;
                case 4:
                    let predicateTransition = transition;
                    if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $ea0YW.FailedPredicateException(this);
                    break;
                case 6:
                    let actionTransition = transition;
                    this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                    break;
                case 10:
                    if (!this.precpred(this._ctx, transition.precedence)) {
                        let precedence = transition.precedence;
                        throw new $ea0YW.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                    }
                    break;
                default:
                    throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
            }
            this.state = transition.target.stateNumber;
        }
        visitDecisionState(p) {
            let predictedAlt;
            this.errorHandler.sync(this);
            let decision = p.decision;
            if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
                predictedAlt = this.overrideDecisionAlt;
                this.overrideDecisionReached = true;
            } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
            return predictedAlt;
        }
        createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
            return new $5FrZ8.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
        }
        visitRuleStopState(p) {
            let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
            if (ruleStartState.isPrecedenceRule) {
                let parentContext = this._parentContextStack.pop();
                this.unrollRecursionContexts(parentContext[0]);
                this.state = parentContext[1];
            } else this.exitRule();
            let ruleTransition = this._atn.states[this.state].transition(0);
            this.state = ruleTransition.followState.stateNumber;
        }
        addDecisionOverride(decision, tokenIndex, forcedAlt) {
            this.overrideDecision = decision;
            this.overrideDecisionInputIndex = tokenIndex;
            this.overrideDecisionAlt = forcedAlt;
        }
        get overrideDecisionRoot() {
            return this._overrideDecisionRoot;
        }
        recover(e) {
            let i = this._input.index;
            this.errorHandler.recover(this, e);
            if (this._input.index === i) {
                let tok = e.getOffendingToken();
                if (!tok) throw new Error("Expected exception to have an offending token");
                let source = tok.tokenSource;
                let stream = source !== undefined ? source.inputStream : undefined;
                let sourcePair = {
                    source: source,
                    stream: stream
                };
                if (e instanceof $iLUMi.InputMismatchException) {
                    let expectedTokens = e.expectedTokens;
                    if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                    let expectedTokenType = $2DVsz.Token.INVALID_TYPE;
                    if (!expectedTokens.isNil) expectedTokenType = expectedTokens.minElement;
                    let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                    this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
                } else {
                    let source = tok.tokenSource;
                    let errToken = this.tokenFactory.create(sourcePair, $2DVsz.Token.INVALID_TYPE, tok.text, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                    this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
                }
            }
        }
        recoverInline() {
            return this._errHandler.recoverInline(this);
        }
        get rootContext() {
            return this._rootContext;
        }
    };
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.NotNull
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "_vocabulary", void 0);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "reset", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "atn", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "vocabulary", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "ruleNames", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "grammarFileName", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "enterRecursionRule", null);
    $a16b634f90dd81f4$var$ParserInterpreter = $a16b634f90dd81f4$var$__decorate([
        $a16b634f90dd81f4$var$__param(1, $d6D31.NotNull)
    ], $a16b634f90dd81f4$var$ParserInterpreter);
    module.exports.ParserInterpreter = $a16b634f90dd81f4$var$ParserInterpreter;
});
parcelRegister("77rdV", function(module, exports) {
    "use strict";
    var $52ee4de454858848$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleContextWithAltNum = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $d6D31 = parcelRequire("d6D31");
    var $6bmaO = parcelRequire("6bmaO");
    class $52ee4de454858848$var$RuleContextWithAltNum extends $6bmaO.ParserRuleContext {
        constructor(parent, invokingStateNumber){
            if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
            else super();
            this._altNumber = $bcnvE.ATN.INVALID_ALT_NUMBER;
        }
        get altNumber() {
            return this._altNumber;
        }
        set altNumber(altNum) {
            this._altNumber = altNum;
        }
    }
    $52ee4de454858848$var$__decorate([
        $d6D31.Override
    ], $52ee4de454858848$var$RuleContextWithAltNum.prototype, "altNumber", null);
    module.exports.RuleContextWithAltNum = $52ee4de454858848$var$RuleContextWithAltNum;
});
parcelRegister("5IgvW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleDependency = void 0;
    function $428ddf2e82bfc6fb$var$RuleDependency(dependency) {
        return (target, propertyKey, propertyDescriptor)=>{};
    }
    module.exports.RuleDependency = $428ddf2e82bfc6fb$var$RuleDependency;
});
parcelRegister("1ivK9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleVersion = void 0;
    function $0f201872a8ca959f$var$RuleVersion(version) {
        return (target, propertyKey, propertyDescriptor)=>{};
    }
    module.exports.RuleVersion = $0f201872a8ca959f$var$RuleVersion;
});
parcelRegister("eftJA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("9rAj4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("5jPdD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("dIykH", function(module, exports) {
    "use strict";
    var $9fca043c2d5f0853$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $9fca043c2d5f0853$var$TokenStreamRewriter {
        constructor(tokens){
            this.tokens = tokens;
            this.programs = new Map();
            this.programs.set($9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
            this.lastRewriteTokenIndexes = new Map();
        }
        getTokenStream() {
            return this.tokens;
        }
        rollback(instructionIndex, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let is = this.programs.get(programName);
            if (is != null) this.programs.set(programName, is.slice($9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
        }
        deleteProgram(programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            this.rollback($9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
        }
        insertAfter(tokenOrIndex, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let index;
            if (typeof tokenOrIndex === "number") index = tokenOrIndex;
            else index = tokenOrIndex.tokenIndex;
            let rewrites = this.getProgram(programName);
            let op = new $9fca043c2d5f0853$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
            rewrites.push(op);
        }
        insertBefore(tokenOrIndex, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let index;
            if (typeof tokenOrIndex === "number") index = tokenOrIndex;
            else index = tokenOrIndex.tokenIndex;
            let rewrites = this.getProgram(programName);
            let op = new $9fca043c2d5f0853$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
            rewrites.push(op);
        }
        replaceSingle(index, text) {
            if (typeof index === "number") this.replace(index, index, text);
            else this.replace(index, index, text);
        }
        replace(from, to, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            if (typeof from !== "number") from = from.tokenIndex;
            if (typeof to !== "number") to = to.tokenIndex;
            if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
            let rewrites = this.getProgram(programName);
            let op = new $9fca043c2d5f0853$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
            rewrites.push(op);
        }
        delete(from, to, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            if (to === undefined) to = from;
            if (typeof from === "number") this.replace(from, to, "", programName);
            else this.replace(from, to, "", programName);
        }
        getLastRewriteTokenIndex(programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let I = this.lastRewriteTokenIndexes.get(programName);
            if (I == null) return -1;
            return I;
        }
        setLastRewriteTokenIndex(programName, i) {
            this.lastRewriteTokenIndexes.set(programName, i);
        }
        getProgram(name) {
            let is = this.programs.get(name);
            if (is == null) is = this.initializeProgram(name);
            return is;
        }
        initializeProgram(name) {
            let is = [];
            this.programs.set(name, is);
            return is;
        }
        getText(intervalOrProgram, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let interval;
            if (intervalOrProgram instanceof $gcfUE.Interval) interval = intervalOrProgram;
            else interval = $gcfUE.Interval.of(0, this.tokens.size - 1);
            if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
            let rewrites = this.programs.get(programName);
            let start = interval.a;
            let stop = interval.b;
            if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
            if (start < 0) start = 0;
            if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval);
            let buf = [];
            let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
            let i = start;
            while(i <= stop && i < this.tokens.size){
                let op = indexToOp.get(i);
                indexToOp.delete(i);
                let t = this.tokens.get(i);
                if (op == null) {
                    if (t.type !== $2DVsz.Token.EOF) buf.push(String(t.text));
                    i++;
                } else i = op.execute(buf);
            }
            if (stop === this.tokens.size - 1) {
                for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
            }
            return buf.join("");
        }
        reduceToSingleOperationPerIndex(rewrites) {
            for(let i = 0; i < rewrites.length; i++){
                let op = rewrites[i];
                if (op == null) continue;
                if (!(op instanceof $9fca043c2d5f0853$var$ReplaceOp)) continue;
                let rop = op;
                let inserts = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$InsertBeforeOp, i);
                for (let iop of inserts){
                    if (iop.index === rop.index) {
                        rewrites[iop.instructionIndex] = undefined;
                        rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                    } else if (iop.index > rop.index && iop.index <= rop.lastIndex) rewrites[iop.instructionIndex] = undefined;
                }
                let prevReplaces = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$ReplaceOp, i);
                for (let prevRop of prevReplaces){
                    if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                        rewrites[prevRop.instructionIndex] = undefined;
                        continue;
                    }
                    let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                    if (prevRop.text == null && rop.text == null && !disjoint) {
                        rewrites[prevRop.instructionIndex] = undefined;
                        rop.index = Math.min(prevRop.index, rop.index);
                        rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                    } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
                }
            }
            for(let i = 0; i < rewrites.length; i++){
                let op = rewrites[i];
                if (op == null) continue;
                if (!(op instanceof $9fca043c2d5f0853$var$InsertBeforeOp)) continue;
                let iop = op;
                let prevInserts = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$InsertBeforeOp, i);
                for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                    if (prevIop instanceof $9fca043c2d5f0853$var$InsertAfterOp) {
                        iop.text = this.catOpText(prevIop.text, iop.text);
                        rewrites[prevIop.instructionIndex] = undefined;
                    } else if (prevIop instanceof $9fca043c2d5f0853$var$InsertBeforeOp) {
                        iop.text = this.catOpText(iop.text, prevIop.text);
                        rewrites[prevIop.instructionIndex] = undefined;
                    }
                }
                let prevReplaces = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$ReplaceOp, i);
                for (let rop of prevReplaces){
                    if (iop.index === rop.index) {
                        rop.text = this.catOpText(iop.text, rop.text);
                        rewrites[i] = undefined;
                        continue;
                    }
                    if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
                }
            }
            let m = new Map();
            for (let op of rewrites){
                if (op == null) continue;
                if (m.get(op.index) != null) throw new Error("should only be one op per index");
                m.set(op.index, op);
            }
            return m;
        }
        catOpText(a, b) {
            let x = "";
            let y = "";
            if (a != null) x = a.toString();
            if (b != null) y = b.toString();
            return x + y;
        }
        getKindOfOps(rewrites, kind, before) {
            let ops = [];
            for(let i = 0; i < before && i < rewrites.length; i++){
                let op = rewrites[i];
                if (op == null) continue;
                if (op instanceof kind) ops.push(op);
            }
            return ops;
        }
    }
    module.exports.TokenStreamRewriter = $9fca043c2d5f0853$var$TokenStreamRewriter;
    $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
    $9fca043c2d5f0853$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
    $9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
    class $9fca043c2d5f0853$var$RewriteOperation {
        constructor(tokens, index, instructionIndex, text){
            this.tokens = tokens;
            this.instructionIndex = instructionIndex;
            this.index = index;
            this.text = text === undefined ? "" : text;
        }
        execute(buf) {
            return this.index;
        }
        toString() {
            let opName = this.constructor.name;
            let $index = opName.indexOf("$");
            opName = opName.substring($index + 1, opName.length);
            return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
        }
    }
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$RewriteOperation.prototype, "toString", null);
    module.exports.RewriteOperation = $9fca043c2d5f0853$var$RewriteOperation;
    class $9fca043c2d5f0853$var$InsertBeforeOp extends $9fca043c2d5f0853$var$RewriteOperation {
        constructor(tokens, index, instructionIndex, text){
            super(tokens, index, instructionIndex, text);
        }
        execute(buf) {
            buf.push(this.text.toString());
            if (this.tokens.get(this.index).type !== $2DVsz.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
            return this.index + 1;
        }
    }
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$InsertBeforeOp.prototype, "execute", null);
    class $9fca043c2d5f0853$var$InsertAfterOp extends $9fca043c2d5f0853$var$InsertBeforeOp {
        constructor(tokens, index, instructionIndex, text){
            super(tokens, index + 1, instructionIndex, text);
        }
    }
    class $9fca043c2d5f0853$var$ReplaceOp extends $9fca043c2d5f0853$var$RewriteOperation {
        constructor(tokens, from, to, instructionIndex, text){
            super(tokens, from, instructionIndex, text);
            this.lastIndex = to;
        }
        execute(buf) {
            if (this.text != null) buf.push(this.text.toString());
            return this.lastIndex + 1;
        }
        toString() {
            if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
            return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
        }
    }
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$ReplaceOp.prototype, "execute", null);
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$ReplaceOp.prototype, "toString", null);
});
parcelRegister("1MVGg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("6UcB4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("39War", function(module, exports) {
    $parcel$export(module.exports, "JQLLexer", ()=>$801b4612eb9312ce$export$375c79404cc64c7f);
    var $dvgsl = parcelRequire("dvgsl");
    var $igNLf = parcelRequire("igNLf");
    var $lQecE = parcelRequire("lQecE");
    var $3n2FE = parcelRequire("3n2FE");
    var $2IEP9 = parcelRequire("2IEP9");
    class $801b4612eb9312ce$export$375c79404cc64c7f extends (0, $igNLf.Lexer) {
        static{
            this.LPAREN = 1;
        }
        static{
            this.RPAREN = 2;
        }
        static{
            this.COMMA = 3;
        }
        static{
            this.LBRACKET = 4;
        }
        static{
            this.RBRACKET = 5;
        }
        static{
            this.BANG = 6;
        }
        static{
            this.LT = 7;
        }
        static{
            this.GT = 8;
        }
        static{
            this.GTEQ = 9;
        }
        static{
            this.LTEQ = 10;
        }
        static{
            this.EQUALS = 11;
        }
        static{
            this.NOT_EQUALS = 12;
        }
        static{
            this.LIKE = 13;
        }
        static{
            this.NOT_LIKE = 14;
        }
        static{
            this.IN = 15;
        }
        static{
            this.IS = 16;
        }
        static{
            this.AND = 17;
        }
        static{
            this.OR = 18;
        }
        static{
            this.NOT = 19;
        }
        static{
            this.EMPTY = 20;
        }
        static{
            this.WAS = 21;
        }
        static{
            this.CHANGED = 22;
        }
        static{
            this.BEFORE = 23;
        }
        static{
            this.AFTER = 24;
        }
        static{
            this.FROM = 25;
        }
        static{
            this.TO = 26;
        }
        static{
            this.ON = 27;
        }
        static{
            this.DURING = 28;
        }
        static{
            this.ORDER = 29;
        }
        static{
            this.BY = 30;
        }
        static{
            this.ASC = 31;
        }
        static{
            this.DESC = 32;
        }
        static{
            this.POSNUMBER = 33;
        }
        static{
            this.NEGNUMBER = 34;
        }
        static{
            this.CUSTOMFIELD = 35;
        }
        static{
            this.RESERVED_WORD = 36;
        }
        static{
            this.STRING = 37;
        }
        static{
            this.MATCHWS = 38;
        }
        static{
            this.ERROR_RESERVED = 39;
        }
        static{
            this.ERRORCHAR = 40;
        }
        static{
            this.QUOTE_STRING = 41;
        }
        static{
            this.UNCLOSED_QUOTE_STRING = 42;
        }
        static{
            this.INVALID_QUOTE_STRING = 43;
        }
        static{
            this.SQUOTE_STRING = 44;
        }
        static{
            this.UNCLOSED_SQUOTE_STRING = 45;
        }
        static{
            this.INVALID_SQUOTE_STRING = 46;
        }
        static{
            this.QUOTED_STR = 1;
        }
        static{
            this.SQUOTED_STR = 2;
        }
        static{
            this.channelNames = [
                'DEFAULT_TOKEN_CHANNEL',
                'HIDDEN'
            ];
        }
        static{
            this.modeNames = [
                'DEFAULT_MODE',
                'QUOTED_STR',
                'SQUOTED_STR'
            ];
        }
        static{
            this.ruleNames = [
                'LPAREN',
                'RPAREN',
                'COMMA',
                'LBRACKET',
                'RBRACKET',
                'LQUOTE',
                'LSQUOTE',
                'BANG',
                'LT',
                'GT',
                'GTEQ',
                'LTEQ',
                'EQUALS',
                'NOT_EQUALS',
                'LIKE',
                'NOT_LIKE',
                'IN',
                'IS',
                'AND',
                'OR',
                'NOT',
                'EMPTY',
                'WAS',
                'CHANGED',
                'BEFORE',
                'AFTER',
                'FROM',
                'TO',
                'ON',
                'DURING',
                'ORDER',
                'BY',
                'ASC',
                'DESC',
                'POSNUMBER',
                'NEGNUMBER',
                'CUSTOMFIELD',
                'RESERVED_WORD',
                'STRING',
                'MATCHWS',
                'ERROR_RESERVED',
                'ERRORCHAR',
                'QUOTE_STRING',
                'QUOTED_CONTENT',
                'UNCLOSED_QUOTE_STRING',
                'INVALID_QUOTE_STRING',
                'SQUOTE_STRING',
                'SQUOTED_CONTENT',
                'UNCLOSED_SQUOTE_STRING',
                'INVALID_SQUOTE_STRING',
                'VALID_UNQUOTED_CHARS',
                'VALID_QUOTED_CHARS',
                'VALID_SQUOTED_CHARS',
                'RESERVED_CHARS',
                'QUOTE',
                'SQUOTE',
                'BSLASH',
                'NL',
                'CR',
                'SPACE',
                'AMPER',
                'AMPER_AMPER',
                'PIPE',
                'PIPE_PIPE',
                'ESCAPE',
                'NEWLINE',
                'HEXDIGIT',
                'WS',
                'MINUS',
                'DIGIT',
                'A',
                'B',
                'C',
                'D',
                'E',
                'F',
                'G',
                'H',
                'I',
                'J',
                'K',
                'L',
                'M',
                'N',
                'O',
                'P',
                'Q',
                'R',
                'S',
                'T',
                'U',
                'V',
                'W',
                'X',
                'Y',
                'Z'
            ];
        }
        static{
            this._LITERAL_NAMES = [
                undefined,
                "'('",
                "')'",
                "','",
                "'['",
                "']'",
                "'!'",
                "'<'",
                "'>'",
                "'>='",
                "'<='",
                "'='",
                "'!='",
                "'~'",
                "'!~'"
            ];
        }
        static{
            this._SYMBOLIC_NAMES = [
                undefined,
                'LPAREN',
                'RPAREN',
                'COMMA',
                'LBRACKET',
                'RBRACKET',
                'BANG',
                'LT',
                'GT',
                'GTEQ',
                'LTEQ',
                'EQUALS',
                'NOT_EQUALS',
                'LIKE',
                'NOT_LIKE',
                'IN',
                'IS',
                'AND',
                'OR',
                'NOT',
                'EMPTY',
                'WAS',
                'CHANGED',
                'BEFORE',
                'AFTER',
                'FROM',
                'TO',
                'ON',
                'DURING',
                'ORDER',
                'BY',
                'ASC',
                'DESC',
                'POSNUMBER',
                'NEGNUMBER',
                'CUSTOMFIELD',
                'RESERVED_WORD',
                'STRING',
                'MATCHWS',
                'ERROR_RESERVED',
                'ERRORCHAR',
                'QUOTE_STRING',
                'UNCLOSED_QUOTE_STRING',
                'INVALID_QUOTE_STRING',
                'SQUOTE_STRING',
                'UNCLOSED_SQUOTE_STRING',
                'INVALID_SQUOTE_STRING'
            ];
        }
        static{
            this.VOCABULARY = new (0, $3n2FE.VocabularyImpl)($801b4612eb9312ce$export$375c79404cc64c7f._LITERAL_NAMES, $801b4612eb9312ce$export$375c79404cc64c7f._SYMBOLIC_NAMES, []);
        }
        get vocabulary() {
            return $801b4612eb9312ce$export$375c79404cc64c7f.VOCABULARY;
        }
        constructor(input){
            super(input);
            this._interp = new (0, $lQecE.LexerATNSimulator)($801b4612eb9312ce$export$375c79404cc64c7f._ATN, this);
        }
        get grammarFileName() {
            return 'JQLLexer.g4';
        }
        get ruleNames() {
            return $801b4612eb9312ce$export$375c79404cc64c7f.ruleNames;
        }
        get serializedATN() {
            return $801b4612eb9312ce$export$375c79404cc64c7f._serializedATN;
        }
        get channelNames() {
            return $801b4612eb9312ce$export$375c79404cc64c7f.channelNames;
        }
        get modeNames() {
            return $801b4612eb9312ce$export$375c79404cc64c7f.modeNames;
        }
        static{
            this._serializedATNSegments = 3;
        }
        static{
            this._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
        }
        static{
            this._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
        }
        static{
            this._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
        }
        static{
            this._serializedATN = $2IEP9.join([
                $801b4612eb9312ce$export$375c79404cc64c7f._serializedATNSegment0,
                $801b4612eb9312ce$export$375c79404cc64c7f._serializedATNSegment1,
                $801b4612eb9312ce$export$375c79404cc64c7f._serializedATNSegment2
            ], '');
        }
        static get _ATN() {
            if (!$801b4612eb9312ce$export$375c79404cc64c7f.__ATN) $801b4612eb9312ce$export$375c79404cc64c7f.__ATN = new (0, $dvgsl.ATNDeserializer)().deserialize($2IEP9.toCharArray($801b4612eb9312ce$export$375c79404cc64c7f._serializedATN));
            return $801b4612eb9312ce$export$375c79404cc64c7f.__ATN;
        }
    }
});
parcelRegister("k9No4", function(module, exports) {
    $parcel$export(module.exports, "JQLParser", ()=>$371e898df891458a$export$9c4772e191bdb810);
    var $dvgsl = parcelRequire("dvgsl");
    var $hKCjP = parcelRequire("hKCjP");
    var $jIG0W = parcelRequire("jIG0W");
    var $6bmaO = parcelRequire("6bmaO");
    var $kzbnL = parcelRequire("kzbnL");
    var $fLdDn = parcelRequire("fLdDn");
    var $2DVsz = parcelRequire("2DVsz");
    var $3n2FE = parcelRequire("3n2FE");
    var $2IEP9 = parcelRequire("2IEP9");
    class $371e898df891458a$export$9c4772e191bdb810 extends (0, $jIG0W.Parser) {
        static{
            this.LPAREN = 1;
        }
        static{
            this.RPAREN = 2;
        }
        static{
            this.COMMA = 3;
        }
        static{
            this.LBRACKET = 4;
        }
        static{
            this.RBRACKET = 5;
        }
        static{
            this.BANG = 6;
        }
        static{
            this.LT = 7;
        }
        static{
            this.GT = 8;
        }
        static{
            this.GTEQ = 9;
        }
        static{
            this.LTEQ = 10;
        }
        static{
            this.EQUALS = 11;
        }
        static{
            this.NOT_EQUALS = 12;
        }
        static{
            this.LIKE = 13;
        }
        static{
            this.NOT_LIKE = 14;
        }
        static{
            this.IN = 15;
        }
        static{
            this.IS = 16;
        }
        static{
            this.AND = 17;
        }
        static{
            this.OR = 18;
        }
        static{
            this.NOT = 19;
        }
        static{
            this.EMPTY = 20;
        }
        static{
            this.WAS = 21;
        }
        static{
            this.CHANGED = 22;
        }
        static{
            this.BEFORE = 23;
        }
        static{
            this.AFTER = 24;
        }
        static{
            this.FROM = 25;
        }
        static{
            this.TO = 26;
        }
        static{
            this.ON = 27;
        }
        static{
            this.DURING = 28;
        }
        static{
            this.ORDER = 29;
        }
        static{
            this.BY = 30;
        }
        static{
            this.ASC = 31;
        }
        static{
            this.DESC = 32;
        }
        static{
            this.POSNUMBER = 33;
        }
        static{
            this.NEGNUMBER = 34;
        }
        static{
            this.CUSTOMFIELD = 35;
        }
        static{
            this.RESERVED_WORD = 36;
        }
        static{
            this.STRING = 37;
        }
        static{
            this.MATCHWS = 38;
        }
        static{
            this.ERROR_RESERVED = 39;
        }
        static{
            this.ERRORCHAR = 40;
        }
        static{
            this.QUOTE_STRING = 41;
        }
        static{
            this.UNCLOSED_QUOTE_STRING = 42;
        }
        static{
            this.INVALID_QUOTE_STRING = 43;
        }
        static{
            this.SQUOTE_STRING = 44;
        }
        static{
            this.UNCLOSED_SQUOTE_STRING = 45;
        }
        static{
            this.INVALID_SQUOTE_STRING = 46;
        }
        static{
            this.RULE_jqlQuery = 0;
        }
        static{
            this.RULE_jqlWhere = 1;
        }
        static{
            this.RULE_jqlOrClause = 2;
        }
        static{
            this.RULE_jqlAndClause = 3;
        }
        static{
            this.RULE_jqlNotClause = 4;
        }
        static{
            this.RULE_jqlSubClause = 5;
        }
        static{
            this.RULE_jqlTerminalClause = 6;
        }
        static{
            this.RULE_jqlTerminalClauseRhs = 7;
        }
        static{
            this.RULE_jqlEqualsOperator = 8;
        }
        static{
            this.RULE_jqlLikeOperator = 9;
        }
        static{
            this.RULE_jqlComparisonOperator = 10;
        }
        static{
            this.RULE_jqlInOperator = 11;
        }
        static{
            this.RULE_jqlIsOperator = 12;
        }
        static{
            this.RULE_jqlWasOperator = 13;
        }
        static{
            this.RULE_jqlWasInOperator = 14;
        }
        static{
            this.RULE_jqlChangedOperator = 15;
        }
        static{
            this.RULE_jqlField = 16;
        }
        static{
            this.RULE_jqlFieldProperty = 17;
        }
        static{
            this.RULE_jqlCustomField = 18;
        }
        static{
            this.RULE_jqlString = 19;
        }
        static{
            this.RULE_jqlNumber = 20;
        }
        static{
            this.RULE_jqlOperand = 21;
        }
        static{
            this.RULE_jqlEmpty = 22;
        }
        static{
            this.RULE_jqlValue = 23;
        }
        static{
            this.RULE_jqlFunction = 24;
        }
        static{
            this.RULE_jqlFunctionName = 25;
        }
        static{
            this.RULE_jqlArgumentList = 26;
        }
        static{
            this.RULE_jqlList = 27;
        }
        static{
            this.RULE_jqlListStart = 28;
        }
        static{
            this.RULE_jqlListEnd = 29;
        }
        static{
            this.RULE_jqlPropertyArgument = 30;
        }
        static{
            this.RULE_jqlArgument = 31;
        }
        static{
            this.RULE_jqlWasPredicate = 32;
        }
        static{
            this.RULE_jqlChangedPredicate = 33;
        }
        static{
            this.RULE_jqlDatePredicateOperator = 34;
        }
        static{
            this.RULE_jqlDateRangePredicateOperator = 35;
        }
        static{
            this.RULE_jqlUserPredicateOperator = 36;
        }
        static{
            this.RULE_jqlValuePredicateOperator = 37;
        }
        static{
            this.RULE_jqlPredicateOperand = 38;
        }
        static{
            this.RULE_jqlOrderBy = 39;
        }
        static{
            this.RULE_jqlSearchSort = 40;
        }
        static{
            this.ruleNames = [
                'jqlQuery',
                'jqlWhere',
                'jqlOrClause',
                'jqlAndClause',
                'jqlNotClause',
                'jqlSubClause',
                'jqlTerminalClause',
                'jqlTerminalClauseRhs',
                'jqlEqualsOperator',
                'jqlLikeOperator',
                'jqlComparisonOperator',
                'jqlInOperator',
                'jqlIsOperator',
                'jqlWasOperator',
                'jqlWasInOperator',
                'jqlChangedOperator',
                'jqlField',
                'jqlFieldProperty',
                'jqlCustomField',
                'jqlString',
                'jqlNumber',
                'jqlOperand',
                'jqlEmpty',
                'jqlValue',
                'jqlFunction',
                'jqlFunctionName',
                'jqlArgumentList',
                'jqlList',
                'jqlListStart',
                'jqlListEnd',
                'jqlPropertyArgument',
                'jqlArgument',
                'jqlWasPredicate',
                'jqlChangedPredicate',
                'jqlDatePredicateOperator',
                'jqlDateRangePredicateOperator',
                'jqlUserPredicateOperator',
                'jqlValuePredicateOperator',
                'jqlPredicateOperand',
                'jqlOrderBy',
                'jqlSearchSort'
            ];
        }
        static{
            this._LITERAL_NAMES = [
                undefined,
                "'('",
                "')'",
                "','",
                "'['",
                "']'",
                "'!'",
                "'<'",
                "'>'",
                "'>='",
                "'<='",
                "'='",
                "'!='",
                "'~'",
                "'!~'"
            ];
        }
        static{
            this._SYMBOLIC_NAMES = [
                undefined,
                'LPAREN',
                'RPAREN',
                'COMMA',
                'LBRACKET',
                'RBRACKET',
                'BANG',
                'LT',
                'GT',
                'GTEQ',
                'LTEQ',
                'EQUALS',
                'NOT_EQUALS',
                'LIKE',
                'NOT_LIKE',
                'IN',
                'IS',
                'AND',
                'OR',
                'NOT',
                'EMPTY',
                'WAS',
                'CHANGED',
                'BEFORE',
                'AFTER',
                'FROM',
                'TO',
                'ON',
                'DURING',
                'ORDER',
                'BY',
                'ASC',
                'DESC',
                'POSNUMBER',
                'NEGNUMBER',
                'CUSTOMFIELD',
                'RESERVED_WORD',
                'STRING',
                'MATCHWS',
                'ERROR_RESERVED',
                'ERRORCHAR',
                'QUOTE_STRING',
                'UNCLOSED_QUOTE_STRING',
                'INVALID_QUOTE_STRING',
                'SQUOTE_STRING',
                'UNCLOSED_SQUOTE_STRING',
                'INVALID_SQUOTE_STRING'
            ];
        }
        static{
            this.VOCABULARY = new (0, $3n2FE.VocabularyImpl)($371e898df891458a$export$9c4772e191bdb810._LITERAL_NAMES, $371e898df891458a$export$9c4772e191bdb810._SYMBOLIC_NAMES, []);
        }
        get vocabulary() {
            return $371e898df891458a$export$9c4772e191bdb810.VOCABULARY;
        }
        get grammarFileName() {
            return 'JQLParser.g4';
        }
        get ruleNames() {
            return $371e898df891458a$export$9c4772e191bdb810.ruleNames;
        }
        get serializedATN() {
            return $371e898df891458a$export$9c4772e191bdb810._serializedATN;
        }
        constructor(input){
            super(input);
            this._interp = new (0, $kzbnL.ParserATNSimulator)($371e898df891458a$export$9c4772e191bdb810._ATN, this);
        }
        jqlQuery() {
            let _localctx = new $371e898df891458a$export$ff413535b9575c8(this._ctx, this.state);
            this.enterRule(_localctx, 0, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlQuery);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 83;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.LPAREN | 1 << $371e898df891458a$export$9c4772e191bdb810.BANG | 1 << $371e898df891458a$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $371e898df891458a$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                    this.state = 82;
                    this.jqlWhere();
                }
                this.state = 86;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === $371e898df891458a$export$9c4772e191bdb810.ORDER) {
                    this.state = 85;
                    this.jqlOrderBy();
                }
                this.state = 88;
                this.match($371e898df891458a$export$9c4772e191bdb810.EOF);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWhere() {
            let _localctx = new $371e898df891458a$export$4148a879cab28017(this._ctx, this.state);
            this.enterRule(_localctx, 2, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWhere);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 90;
                this.jqlOrClause();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlOrClause() {
            let _localctx = new $371e898df891458a$export$d69831d387793480(this._ctx, this.state);
            this.enterRule(_localctx, 4, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrClause);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 92;
                this.jqlAndClause();
                this.state = 97;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.OR){
                    this.state = 93;
                    this.match($371e898df891458a$export$9c4772e191bdb810.OR);
                    this.state = 94;
                    this.jqlAndClause();
                    this.state = 99;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlAndClause() {
            let _localctx = new $371e898df891458a$export$f16819001158b9e(this._ctx, this.state);
            this.enterRule(_localctx, 6, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlAndClause);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 100;
                this.jqlNotClause();
                this.state = 105;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.AND){
                    this.state = 101;
                    this.match($371e898df891458a$export$9c4772e191bdb810.AND);
                    this.state = 102;
                    this.jqlNotClause();
                    this.state = 107;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlNotClause() {
            let _localctx = new $371e898df891458a$export$5e9146f8d5cf1330(this._ctx, this.state);
            this.enterRule(_localctx, 8, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNotClause);
            let _la;
            try {
                this.state = 112;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.BANG:
                    case $371e898df891458a$export$9c4772e191bdb810.NOT:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 108;
                        _la = this._input.LA(1);
                        if (!(_la === $371e898df891458a$export$9c4772e191bdb810.BANG || _la === $371e898df891458a$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                        else {
                            if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 109;
                        this.jqlNotClause();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.LPAREN:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 110;
                        this.jqlSubClause();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD:
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 3);
                        this.state = 111;
                        this.jqlTerminalClause();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlSubClause() {
            let _localctx = new $371e898df891458a$export$a136a0e9655bfb04(this._ctx, this.state);
            this.enterRule(_localctx, 10, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSubClause);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 114;
                this.match($371e898df891458a$export$9c4772e191bdb810.LPAREN);
                this.state = 115;
                this.jqlOrClause();
                this.state = 116;
                this.match($371e898df891458a$export$9c4772e191bdb810.RPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlTerminalClause() {
            let _localctx = new $371e898df891458a$export$23486a2f2ddd5bcd(this._ctx, this.state);
            this.enterRule(_localctx, 12, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClause);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 118;
                this.jqlField();
                this.state = 119;
                this.jqlTerminalClauseRhs();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlTerminalClauseRhs() {
            let _localctx = new $371e898df891458a$export$93924a205c12d32c(this._ctx, this.state);
            this.enterRule(_localctx, 14, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
            let _la;
            try {
                this.state = 176;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                    case 1:
                        _localctx = new $371e898df891458a$export$c428f709a58396e5(_localctx);
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 121;
                        this.jqlEqualsOperator();
                        this.state = 125;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                            case 1:
                                this.state = 122;
                                this.jqlEmpty();
                                break;
                            case 2:
                                this.state = 123;
                                this.jqlValue();
                                break;
                            case 3:
                                this.state = 124;
                                this.jqlFunction();
                                break;
                        }
                        break;
                    case 2:
                        _localctx = new $371e898df891458a$export$1b131204ef9fa33d(_localctx);
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 127;
                        this.jqlLikeOperator();
                        this.state = 131;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                            case 1:
                                this.state = 128;
                                this.jqlEmpty();
                                break;
                            case 2:
                                this.state = 129;
                                this.jqlValue();
                                break;
                            case 3:
                                this.state = 130;
                                this.jqlFunction();
                                break;
                        }
                        break;
                    case 3:
                        _localctx = new $371e898df891458a$export$d83706ee80a9852a(_localctx);
                        this.enterOuterAlt(_localctx, 3);
                        this.state = 133;
                        this.jqlComparisonOperator();
                        this.state = 136;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                            case 1:
                                this.state = 134;
                                this.jqlValue();
                                break;
                            case 2:
                                this.state = 135;
                                this.jqlFunction();
                                break;
                        }
                        break;
                    case 4:
                        _localctx = new $371e898df891458a$export$2934b8ff22fddd2d(_localctx);
                        this.enterOuterAlt(_localctx, 4);
                        this.state = 138;
                        this.jqlInOperator();
                        this.state = 141;
                        this._errHandler.sync(this);
                        switch(this._input.LA(1)){
                            case $371e898df891458a$export$9c4772e191bdb810.LPAREN:
                                this.state = 139;
                                this.jqlList();
                                break;
                            case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                            case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                            case $371e898df891458a$export$9c4772e191bdb810.STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                                this.state = 140;
                                this.jqlFunction();
                                break;
                            default:
                                throw new (0, $hKCjP.NoViableAltException)(this);
                        }
                        break;
                    case 5:
                        _localctx = new $371e898df891458a$export$8b84310182afcf93(_localctx);
                        this.enterOuterAlt(_localctx, 5);
                        this.state = 143;
                        this.jqlIsOperator();
                        this.state = 144;
                        this.jqlEmpty();
                        break;
                    case 6:
                        _localctx = new $371e898df891458a$export$5df295dc7a2cac7c(_localctx);
                        this.enterOuterAlt(_localctx, 6);
                        this.state = 146;
                        this.jqlWasOperator();
                        this.state = 150;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                            case 1:
                                this.state = 147;
                                this.jqlEmpty();
                                break;
                            case 2:
                                this.state = 148;
                                this.jqlValue();
                                break;
                            case 3:
                                this.state = 149;
                                this.jqlFunction();
                                break;
                        }
                        this.state = 155;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.ON | 1 << $371e898df891458a$export$9c4772e191bdb810.DURING | 1 << $371e898df891458a$export$9c4772e191bdb810.BY)) !== 0){
                            this.state = 152;
                            this.jqlWasPredicate();
                            this.state = 157;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                    case 7:
                        _localctx = new $371e898df891458a$export$9ac3367aee261b32(_localctx);
                        this.enterOuterAlt(_localctx, 7);
                        this.state = 158;
                        this.jqlWasInOperator();
                        this.state = 161;
                        this._errHandler.sync(this);
                        switch(this._input.LA(1)){
                            case $371e898df891458a$export$9c4772e191bdb810.LPAREN:
                                this.state = 159;
                                this.jqlList();
                                break;
                            case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                            case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                            case $371e898df891458a$export$9c4772e191bdb810.STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                                this.state = 160;
                                this.jqlFunction();
                                break;
                            default:
                                throw new (0, $hKCjP.NoViableAltException)(this);
                        }
                        this.state = 166;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.ON | 1 << $371e898df891458a$export$9c4772e191bdb810.DURING | 1 << $371e898df891458a$export$9c4772e191bdb810.BY)) !== 0){
                            this.state = 163;
                            this.jqlWasPredicate();
                            this.state = 168;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                    case 8:
                        _localctx = new $371e898df891458a$export$7a7defca8628a13c(_localctx);
                        this.enterOuterAlt(_localctx, 8);
                        this.state = 169;
                        this.jqlChangedOperator();
                        this.state = 173;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.FROM | 1 << $371e898df891458a$export$9c4772e191bdb810.TO | 1 << $371e898df891458a$export$9c4772e191bdb810.ON | 1 << $371e898df891458a$export$9c4772e191bdb810.DURING | 1 << $371e898df891458a$export$9c4772e191bdb810.BY)) !== 0){
                            this.state = 170;
                            this.jqlChangedPredicate();
                            this.state = 175;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlEqualsOperator() {
            let _localctx = new $371e898df891458a$export$41e475fc1988e413(this._ctx, this.state);
            this.enterRule(_localctx, 16, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 178;
                _la = this._input.LA(1);
                if (!(_la === $371e898df891458a$export$9c4772e191bdb810.EQUALS || _la === $371e898df891458a$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlLikeOperator() {
            let _localctx = new $371e898df891458a$export$b76fe5387fdd7efd(this._ctx, this.state);
            this.enterRule(_localctx, 18, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlLikeOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 180;
                _la = this._input.LA(1);
                if (!(_la === $371e898df891458a$export$9c4772e191bdb810.LIKE || _la === $371e898df891458a$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlComparisonOperator() {
            let _localctx = new $371e898df891458a$export$d821da0716b3ec95(this._ctx, this.state);
            this.enterRule(_localctx, 20, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 182;
                _la = this._input.LA(1);
                if (!((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.LT | 1 << $371e898df891458a$export$9c4772e191bdb810.GT | 1 << $371e898df891458a$export$9c4772e191bdb810.GTEQ | 1 << $371e898df891458a$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlInOperator() {
            let _localctx = new $371e898df891458a$export$178478bfa8292f72(this._ctx, this.state);
            this.enterRule(_localctx, 22, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlInOperator);
            try {
                this.state = 187;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.IN:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 184;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.NOT:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 185;
                        this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                        this.state = 186;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlIsOperator() {
            let _localctx = new $371e898df891458a$export$e64c31d2830b66e4(this._ctx, this.state);
            this.enterRule(_localctx, 24, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlIsOperator);
            try {
                this.state = 192;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 189;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IS);
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 190;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IS);
                        this.state = 191;
                        this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWasOperator() {
            let _localctx = new $371e898df891458a$export$7e283636700e4a6c(this._ctx, this.state);
            this.enterRule(_localctx, 26, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasOperator);
            try {
                this.state = 197;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 194;
                        this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 195;
                        this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                        this.state = 196;
                        this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWasInOperator() {
            let _localctx = new $371e898df891458a$export$b9118b1ed9a78d66(this._ctx, this.state);
            this.enterRule(_localctx, 28, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasInOperator);
            try {
                this.state = 204;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 199;
                        this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                        this.state = 200;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 201;
                        this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                        this.state = 202;
                        this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                        this.state = 203;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlChangedOperator() {
            let _localctx = new $371e898df891458a$export$493d626ed78ca66(this._ctx, this.state);
            this.enterRule(_localctx, 30, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedOperator);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 206;
                this.match($371e898df891458a$export$9c4772e191bdb810.CHANGED);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlField() {
            let _localctx = new $371e898df891458a$export$b33300c3d916229a(this._ctx, this.state);
            this.enterRule(_localctx, 32, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlField);
            let _la;
            try {
                this.state = 219;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        _localctx = new $371e898df891458a$export$11fec15307d2e17b(_localctx);
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 208;
                        this.jqlNumber();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD:
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        _localctx = new $371e898df891458a$export$b8b24f99f985ebb3(_localctx);
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 211;
                        this._errHandler.sync(this);
                        switch(this._input.LA(1)){
                            case $371e898df891458a$export$9c4772e191bdb810.STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                                this.state = 209;
                                this.jqlString();
                                break;
                            case $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD:
                                this.state = 210;
                                this.jqlCustomField();
                                break;
                            default:
                                throw new (0, $hKCjP.NoViableAltException)(this);
                        }
                        this.state = 216;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while(_la === $371e898df891458a$export$9c4772e191bdb810.LBRACKET){
                            this.state = 213;
                            this.jqlFieldProperty();
                            this.state = 218;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlFieldProperty() {
            let _localctx = new $371e898df891458a$export$b02d0b6637ce0593(this._ctx, this.state);
            this.enterRule(_localctx, 34, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFieldProperty);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 221;
                this.match($371e898df891458a$export$9c4772e191bdb810.LBRACKET);
                this.state = 222;
                this.jqlArgument();
                this.state = 223;
                this.match($371e898df891458a$export$9c4772e191bdb810.RBRACKET);
                this.state = 228;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $371e898df891458a$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                    this.state = 225;
                    this.jqlPropertyArgument();
                    this.state = 230;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlCustomField() {
            let _localctx = new $371e898df891458a$export$401a038855cc5b15(this._ctx, this.state);
            this.enterRule(_localctx, 36, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlCustomField);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 231;
                this.match($371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD);
                this.state = 232;
                this.match($371e898df891458a$export$9c4772e191bdb810.LBRACKET);
                this.state = 233;
                this.match($371e898df891458a$export$9c4772e191bdb810.POSNUMBER);
                this.state = 234;
                this.match($371e898df891458a$export$9c4772e191bdb810.RBRACKET);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlString() {
            let _localctx = new $371e898df891458a$export$bde73d8ad7c8b71e(this._ctx, this.state);
            this.enterRule(_localctx, 38, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlString);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 236;
                _la = this._input.LA(1);
                if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 37 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlNumber() {
            let _localctx = new $371e898df891458a$export$8737d94a1880e8b3(this._ctx, this.state);
            this.enterRule(_localctx, 40, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNumber);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 238;
                _localctx._jqlNum = this._input.LT(1);
                _la = this._input.LA(1);
                if (!(_la === $371e898df891458a$export$9c4772e191bdb810.POSNUMBER || _la === $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlOperand() {
            let _localctx = new $371e898df891458a$export$2eaac5a9828bf647(this._ctx, this.state);
            this.enterRule(_localctx, 42, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOperand);
            try {
                this.state = 244;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 240;
                        this.jqlEmpty();
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 241;
                        this.jqlValue();
                        break;
                    case 3:
                        this.enterOuterAlt(_localctx, 3);
                        this.state = 242;
                        this.jqlFunction();
                        break;
                    case 4:
                        this.enterOuterAlt(_localctx, 4);
                        this.state = 243;
                        this.jqlList();
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlEmpty() {
            let _localctx = new $371e898df891458a$export$d85a062f90025e5c(this._ctx, this.state);
            this.enterRule(_localctx, 44, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEmpty);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 246;
                this.match($371e898df891458a$export$9c4772e191bdb810.EMPTY);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlValue() {
            let _localctx = new $371e898df891458a$export$2e17d457b0933bec(this._ctx, this.state);
            this.enterRule(_localctx, 46, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValue);
            try {
                this.state = 250;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 248;
                        this.jqlString();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 249;
                        this.jqlNumber();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlFunction() {
            let _localctx = new $371e898df891458a$export$ebf0cc785e9ee41a(this._ctx, this.state);
            this.enterRule(_localctx, 48, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunction);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 252;
                this.jqlFunctionName();
                this.state = 253;
                this.match($371e898df891458a$export$9c4772e191bdb810.LPAREN);
                this.state = 255;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $371e898df891458a$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                    this.state = 254;
                    this.jqlArgumentList();
                }
                this.state = 257;
                this.match($371e898df891458a$export$9c4772e191bdb810.RPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlFunctionName() {
            let _localctx = new $371e898df891458a$export$1f5f7ac816788f44(this._ctx, this.state);
            this.enterRule(_localctx, 50, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunctionName);
            try {
                this.state = 261;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 259;
                        this.jqlString();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 260;
                        this.jqlNumber();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlArgumentList() {
            let _localctx = new $371e898df891458a$export$83d7c13849b931c3(this._ctx, this.state);
            this.enterRule(_localctx, 52, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgumentList);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 263;
                this.jqlArgument();
                this.state = 268;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.COMMA){
                    this.state = 264;
                    this.match($371e898df891458a$export$9c4772e191bdb810.COMMA);
                    this.state = 265;
                    this.jqlArgument();
                    this.state = 270;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlList() {
            let _localctx = new $371e898df891458a$export$9cb97a63f2be4864(this._ctx, this.state);
            this.enterRule(_localctx, 54, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlList);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 271;
                this.jqlListStart();
                this.state = 272;
                this.jqlOperand();
                this.state = 277;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.COMMA){
                    this.state = 273;
                    this.match($371e898df891458a$export$9c4772e191bdb810.COMMA);
                    this.state = 274;
                    this.jqlOperand();
                    this.state = 279;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 280;
                this.jqlListEnd();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlListStart() {
            let _localctx = new $371e898df891458a$export$c419f717bfc46a5d(this._ctx, this.state);
            this.enterRule(_localctx, 56, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListStart);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 282;
                this.match($371e898df891458a$export$9c4772e191bdb810.LPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlListEnd() {
            let _localctx = new $371e898df891458a$export$f6cd3e372f5ab120(this._ctx, this.state);
            this.enterRule(_localctx, 58, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListEnd);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 284;
                this.match($371e898df891458a$export$9c4772e191bdb810.RPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlPropertyArgument() {
            let _localctx = new $371e898df891458a$export$e20ce4a2ed16372c(this._ctx, this.state);
            this.enterRule(_localctx, 60, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 286;
                this.jqlArgument();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlArgument() {
            let _localctx = new $371e898df891458a$export$a95583953c237f88(this._ctx, this.state);
            this.enterRule(_localctx, 62, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgument);
            try {
                this.state = 290;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 288;
                        this.jqlString();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 289;
                        this.jqlNumber();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWasPredicate() {
            let _localctx = new $371e898df891458a$export$9fa1e4d63f31b911(this._ctx, this.state);
            this.enterRule(_localctx, 64, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasPredicate);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 295;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.BEFORE:
                    case $371e898df891458a$export$9c4772e191bdb810.AFTER:
                    case $371e898df891458a$export$9c4772e191bdb810.ON:
                        this.state = 292;
                        this.jqlDatePredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.DURING:
                        this.state = 293;
                        this.jqlDateRangePredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.BY:
                        this.state = 294;
                        this.jqlUserPredicateOperator();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
                this.state = 297;
                this.jqlPredicateOperand();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlChangedPredicate() {
            let _localctx = new $371e898df891458a$export$e77e479a48133015(this._ctx, this.state);
            this.enterRule(_localctx, 66, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 303;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.BEFORE:
                    case $371e898df891458a$export$9c4772e191bdb810.AFTER:
                    case $371e898df891458a$export$9c4772e191bdb810.ON:
                        this.state = 299;
                        this.jqlDatePredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.DURING:
                        this.state = 300;
                        this.jqlDateRangePredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.BY:
                        this.state = 301;
                        this.jqlUserPredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.FROM:
                    case $371e898df891458a$export$9c4772e191bdb810.TO:
                        this.state = 302;
                        this.jqlValuePredicateOperator();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
                this.state = 305;
                this.jqlPredicateOperand();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlDatePredicateOperator() {
            let _localctx = new $371e898df891458a$export$dc01290aee731418(this._ctx, this.state);
            this.enterRule(_localctx, 68, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 307;
                _la = this._input.LA(1);
                if (!((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlDateRangePredicateOperator() {
            let _localctx = new $371e898df891458a$export$75412b8b6a6442e1(this._ctx, this.state);
            this.enterRule(_localctx, 70, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 309;
                this.match($371e898df891458a$export$9c4772e191bdb810.DURING);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlUserPredicateOperator() {
            let _localctx = new $371e898df891458a$export$ad402332075c8656(this._ctx, this.state);
            this.enterRule(_localctx, 72, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 311;
                this.match($371e898df891458a$export$9c4772e191bdb810.BY);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlValuePredicateOperator() {
            let _localctx = new $371e898df891458a$export$4239d7c0fbafd3f1(this._ctx, this.state);
            this.enterRule(_localctx, 74, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 313;
                _la = this._input.LA(1);
                if (!(_la === $371e898df891458a$export$9c4772e191bdb810.FROM || _la === $371e898df891458a$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlPredicateOperand() {
            let _localctx = new $371e898df891458a$export$6b796c5a4b8c18e(this._ctx, this.state);
            this.enterRule(_localctx, 76, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 315;
                this.jqlOperand();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlOrderBy() {
            let _localctx = new $371e898df891458a$export$534469b9c8f44139(this._ctx, this.state);
            this.enterRule(_localctx, 78, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrderBy);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 317;
                this.match($371e898df891458a$export$9c4772e191bdb810.ORDER);
                this.state = 318;
                this.match($371e898df891458a$export$9c4772e191bdb810.BY);
                this.state = 319;
                this.jqlSearchSort();
                this.state = 324;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.COMMA){
                    this.state = 320;
                    this.match($371e898df891458a$export$9c4772e191bdb810.COMMA);
                    this.state = 321;
                    this.jqlSearchSort();
                    this.state = 326;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlSearchSort() {
            let _localctx = new $371e898df891458a$export$c7d8f03f36952a46(this._ctx, this.state);
            this.enterRule(_localctx, 80, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSearchSort);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 327;
                this.jqlField();
                this.state = 329;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === $371e898df891458a$export$9c4772e191bdb810.ASC || _la === $371e898df891458a$export$9c4772e191bdb810.DESC) {
                    this.state = 328;
                    _la = this._input.LA(1);
                    if (!(_la === $371e898df891458a$export$9c4772e191bdb810.ASC || _la === $371e898df891458a$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        static{
            this._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
        }
        static get _ATN() {
            if (!$371e898df891458a$export$9c4772e191bdb810.__ATN) $371e898df891458a$export$9c4772e191bdb810.__ATN = new (0, $dvgsl.ATNDeserializer)().deserialize($2IEP9.toCharArray($371e898df891458a$export$9c4772e191bdb810._serializedATN));
            return $371e898df891458a$export$9c4772e191bdb810.__ATN;
        }
    }
    class $371e898df891458a$export$ff413535b9575c8 extends (0, $6bmaO.ParserRuleContext) {
        EOF() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.EOF, 0);
        }
        jqlWhere() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$4148a879cab28017);
        }
        jqlOrderBy() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$534469b9c8f44139);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlQuery;
        }
        enterRule(listener) {
            if (listener.enterJqlQuery) listener.enterJqlQuery(this);
        }
        exitRule(listener) {
            if (listener.exitJqlQuery) listener.exitJqlQuery(this);
        }
        accept(visitor) {
            if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$4148a879cab28017 extends (0, $6bmaO.ParserRuleContext) {
        jqlOrClause() {
            return this.getRuleContext(0, $371e898df891458a$export$d69831d387793480);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWhere;
        }
        enterRule(listener) {
            if (listener.enterJqlWhere) listener.enterJqlWhere(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWhere) listener.exitJqlWhere(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$d69831d387793480 extends (0, $6bmaO.ParserRuleContext) {
        jqlAndClause(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$f16819001158b9e);
            else return this.getRuleContext(i, $371e898df891458a$export$f16819001158b9e);
        }
        OR(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.OR);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.OR, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrClause;
        }
        enterRule(listener) {
            if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$f16819001158b9e extends (0, $6bmaO.ParserRuleContext) {
        jqlNotClause(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$5e9146f8d5cf1330);
            else return this.getRuleContext(i, $371e898df891458a$export$5e9146f8d5cf1330);
        }
        AND(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.AND);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.AND, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlAndClause;
        }
        enterRule(listener) {
            if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$5e9146f8d5cf1330 extends (0, $6bmaO.ParserRuleContext) {
        jqlNotClause() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$5e9146f8d5cf1330);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        BANG() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.BANG, 0);
        }
        jqlSubClause() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$a136a0e9655bfb04);
        }
        jqlTerminalClause() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$23486a2f2ddd5bcd);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNotClause;
        }
        enterRule(listener) {
            if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$a136a0e9655bfb04 extends (0, $6bmaO.ParserRuleContext) {
        LPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.LPAREN, 0);
        }
        jqlOrClause() {
            return this.getRuleContext(0, $371e898df891458a$export$d69831d387793480);
        }
        RPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.RPAREN, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSubClause;
        }
        enterRule(listener) {
            if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$23486a2f2ddd5bcd extends (0, $6bmaO.ParserRuleContext) {
        jqlField() {
            return this.getRuleContext(0, $371e898df891458a$export$b33300c3d916229a);
        }
        jqlTerminalClauseRhs() {
            return this.getRuleContext(0, $371e898df891458a$export$93924a205c12d32c);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClause;
        }
        enterRule(listener) {
            if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$93924a205c12d32c extends (0, $6bmaO.ParserRuleContext) {
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
        }
        copyFrom(ctx) {
            super.copyFrom(ctx);
        }
    }
    class $371e898df891458a$export$c428f709a58396e5 extends $371e898df891458a$export$93924a205c12d32c {
        jqlEqualsOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$41e475fc1988e413);
        }
        jqlEmpty() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$1b131204ef9fa33d extends $371e898df891458a$export$93924a205c12d32c {
        jqlLikeOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$b76fe5387fdd7efd);
        }
        jqlEmpty() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$d83706ee80a9852a extends $371e898df891458a$export$93924a205c12d32c {
        jqlComparisonOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$d821da0716b3ec95);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$2934b8ff22fddd2d extends $371e898df891458a$export$93924a205c12d32c {
        jqlInOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$178478bfa8292f72);
        }
        jqlList() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$9cb97a63f2be4864);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlInClause) listener.enterJqlInClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlInClause) listener.exitJqlInClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$8b84310182afcf93 extends $371e898df891458a$export$93924a205c12d32c {
        jqlIsOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$e64c31d2830b66e4);
        }
        jqlEmpty() {
            return this.getRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$5df295dc7a2cac7c extends $371e898df891458a$export$93924a205c12d32c {
        jqlWasOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$7e283636700e4a6c);
        }
        jqlEmpty() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        jqlWasPredicate(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$9fa1e4d63f31b911);
            else return this.getRuleContext(i, $371e898df891458a$export$9fa1e4d63f31b911);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$9ac3367aee261b32 extends $371e898df891458a$export$93924a205c12d32c {
        jqlWasInOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$b9118b1ed9a78d66);
        }
        jqlList() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$9cb97a63f2be4864);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        jqlWasPredicate(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$9fa1e4d63f31b911);
            else return this.getRuleContext(i, $371e898df891458a$export$9fa1e4d63f31b911);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$7a7defca8628a13c extends $371e898df891458a$export$93924a205c12d32c {
        jqlChangedOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$493d626ed78ca66);
        }
        jqlChangedPredicate(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$e77e479a48133015);
            else return this.getRuleContext(i, $371e898df891458a$export$e77e479a48133015);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$41e475fc1988e413 extends (0, $6bmaO.ParserRuleContext) {
        EQUALS() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.EQUALS, 0);
        }
        NOT_EQUALS() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT_EQUALS, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b76fe5387fdd7efd extends (0, $6bmaO.ParserRuleContext) {
        LIKE() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LIKE, 0);
        }
        NOT_LIKE() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT_LIKE, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlLikeOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$d821da0716b3ec95 extends (0, $6bmaO.ParserRuleContext) {
        LT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LT, 0);
        }
        GT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.GT, 0);
        }
        LTEQ() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LTEQ, 0);
        }
        GTEQ() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.GTEQ, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$178478bfa8292f72 extends (0, $6bmaO.ParserRuleContext) {
        IN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.IN, 0);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlInOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$e64c31d2830b66e4 extends (0, $6bmaO.ParserRuleContext) {
        IS() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.IS, 0);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlIsOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$7e283636700e4a6c extends (0, $6bmaO.ParserRuleContext) {
        WAS() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.WAS, 0);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b9118b1ed9a78d66 extends (0, $6bmaO.ParserRuleContext) {
        WAS() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.WAS, 0);
        }
        IN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.IN, 0);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasInOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$493d626ed78ca66 extends (0, $6bmaO.ParserRuleContext) {
        CHANGED() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.CHANGED, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b33300c3d916229a extends (0, $6bmaO.ParserRuleContext) {
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlField;
        }
        copyFrom(ctx) {
            super.copyFrom(ctx);
        }
    }
    class $371e898df891458a$export$11fec15307d2e17b extends $371e898df891458a$export$b33300c3d916229a {
        jqlNumber() {
            return this.getRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b8b24f99f985ebb3 extends $371e898df891458a$export$b33300c3d916229a {
        jqlString() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
        }
        jqlCustomField() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$401a038855cc5b15);
        }
        jqlFieldProperty(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$b02d0b6637ce0593);
            else return this.getRuleContext(i, $371e898df891458a$export$b02d0b6637ce0593);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b02d0b6637ce0593 extends (0, $6bmaO.ParserRuleContext) {
        LBRACKET() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LBRACKET, 0);
        }
        RBRACKET() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.RBRACKET, 0);
        }
        jqlPropertyArgument(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$e20ce4a2ed16372c);
            else return this.getRuleContext(i, $371e898df891458a$export$e20ce4a2ed16372c);
        }
        jqlArgument() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$a95583953c237f88);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFieldProperty;
        }
        enterRule(listener) {
            if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
        }
        exitRule(listener) {
            if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
        }
        accept(visitor) {
            if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$401a038855cc5b15 extends (0, $6bmaO.ParserRuleContext) {
        CUSTOMFIELD() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD, 0);
        }
        LBRACKET() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.LBRACKET, 0);
        }
        POSNUMBER() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.POSNUMBER, 0);
        }
        RBRACKET() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.RBRACKET, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlCustomField;
        }
        enterRule(listener) {
            if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
        }
        exitRule(listener) {
            if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
        }
        accept(visitor) {
            if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$bde73d8ad7c8b71e extends (0, $6bmaO.ParserRuleContext) {
        STRING() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.STRING, 0);
        }
        QUOTE_STRING() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING, 0);
        }
        SQUOTE_STRING() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlString;
        }
        enterRule(listener) {
            if (listener.enterJqlString) listener.enterJqlString(this);
        }
        exitRule(listener) {
            if (listener.exitJqlString) listener.exitJqlString(this);
        }
        accept(visitor) {
            if (visitor.visitJqlString) return visitor.visitJqlString(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$8737d94a1880e8b3 extends (0, $6bmaO.ParserRuleContext) {
        POSNUMBER() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.POSNUMBER, 0);
        }
        NEGNUMBER() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NEGNUMBER, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNumber;
        }
        enterRule(listener) {
            if (listener.enterJqlNumber) listener.enterJqlNumber(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNumber) listener.exitJqlNumber(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$2eaac5a9828bf647 extends (0, $6bmaO.ParserRuleContext) {
        jqlEmpty() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        jqlList() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$9cb97a63f2be4864);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOperand;
        }
        enterRule(listener) {
            if (listener.enterJqlOperand) listener.enterJqlOperand(this);
        }
        exitRule(listener) {
            if (listener.exitJqlOperand) listener.exitJqlOperand(this);
        }
        accept(visitor) {
            if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$d85a062f90025e5c extends (0, $6bmaO.ParserRuleContext) {
        EMPTY() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.EMPTY, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEmpty;
        }
        enterRule(listener) {
            if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
        }
        exitRule(listener) {
            if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
        }
        accept(visitor) {
            if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$2e17d457b0933bec extends (0, $6bmaO.ParserRuleContext) {
        jqlString() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
        }
        jqlNumber() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValue;
        }
        enterRule(listener) {
            if (listener.enterJqlValue) listener.enterJqlValue(this);
        }
        exitRule(listener) {
            if (listener.exitJqlValue) listener.exitJqlValue(this);
        }
        accept(visitor) {
            if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$ebf0cc785e9ee41a extends (0, $6bmaO.ParserRuleContext) {
        jqlFunctionName() {
            return this.getRuleContext(0, $371e898df891458a$export$1f5f7ac816788f44);
        }
        LPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.LPAREN, 0);
        }
        RPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.RPAREN, 0);
        }
        jqlArgumentList() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$83d7c13849b931c3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunction;
        }
        enterRule(listener) {
            if (listener.enterJqlFunction) listener.enterJqlFunction(this);
        }
        exitRule(listener) {
            if (listener.exitJqlFunction) listener.exitJqlFunction(this);
        }
        accept(visitor) {
            if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$1f5f7ac816788f44 extends (0, $6bmaO.ParserRuleContext) {
        jqlString() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
        }
        jqlNumber() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunctionName;
        }
        enterRule(listener) {
            if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
        }
        exitRule(listener) {
            if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
        }
        accept(visitor) {
            if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$83d7c13849b931c3 extends (0, $6bmaO.ParserRuleContext) {
        jqlArgument(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$a95583953c237f88);
            else return this.getRuleContext(i, $371e898df891458a$export$a95583953c237f88);
        }
        COMMA(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.COMMA);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.COMMA, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgumentList;
        }
        enterRule(listener) {
            if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
        }
        exitRule(listener) {
            if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
        }
        accept(visitor) {
            if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$9cb97a63f2be4864 extends (0, $6bmaO.ParserRuleContext) {
        jqlListStart() {
            return this.getRuleContext(0, $371e898df891458a$export$c419f717bfc46a5d);
        }
        jqlOperand(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$2eaac5a9828bf647);
            else return this.getRuleContext(i, $371e898df891458a$export$2eaac5a9828bf647);
        }
        jqlListEnd() {
            return this.getRuleContext(0, $371e898df891458a$export$f6cd3e372f5ab120);
        }
        COMMA(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.COMMA);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.COMMA, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlList;
        }
        enterRule(listener) {
            if (listener.enterJqlList) listener.enterJqlList(this);
        }
        exitRule(listener) {
            if (listener.exitJqlList) listener.exitJqlList(this);
        }
        accept(visitor) {
            if (visitor.visitJqlList) return visitor.visitJqlList(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$c419f717bfc46a5d extends (0, $6bmaO.ParserRuleContext) {
        LPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.LPAREN, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListStart;
        }
        enterRule(listener) {
            if (listener.enterJqlListStart) listener.enterJqlListStart(this);
        }
        exitRule(listener) {
            if (listener.exitJqlListStart) listener.exitJqlListStart(this);
        }
        accept(visitor) {
            if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$f6cd3e372f5ab120 extends (0, $6bmaO.ParserRuleContext) {
        RPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.RPAREN, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListEnd;
        }
        enterRule(listener) {
            if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
        }
        exitRule(listener) {
            if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
        }
        accept(visitor) {
            if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$e20ce4a2ed16372c extends (0, $6bmaO.ParserRuleContext) {
        jqlArgument() {
            return this.getRuleContext(0, $371e898df891458a$export$a95583953c237f88);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
        }
        enterRule(listener) {
            if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
        }
        exitRule(listener) {
            if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
        }
        accept(visitor) {
            if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$a95583953c237f88 extends (0, $6bmaO.ParserRuleContext) {
        jqlString() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
        }
        jqlNumber() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgument;
        }
        enterRule(listener) {
            if (listener.enterJqlArgument) listener.enterJqlArgument(this);
        }
        exitRule(listener) {
            if (listener.exitJqlArgument) listener.exitJqlArgument(this);
        }
        accept(visitor) {
            if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$9fa1e4d63f31b911 extends (0, $6bmaO.ParserRuleContext) {
        jqlPredicateOperand() {
            return this.getRuleContext(0, $371e898df891458a$export$6b796c5a4b8c18e);
        }
        jqlDatePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$dc01290aee731418);
        }
        jqlDateRangePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$75412b8b6a6442e1);
        }
        jqlUserPredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ad402332075c8656);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasPredicate;
        }
        enterRule(listener) {
            if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$e77e479a48133015 extends (0, $6bmaO.ParserRuleContext) {
        jqlPredicateOperand() {
            return this.getRuleContext(0, $371e898df891458a$export$6b796c5a4b8c18e);
        }
        jqlDatePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$dc01290aee731418);
        }
        jqlDateRangePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$75412b8b6a6442e1);
        }
        jqlUserPredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ad402332075c8656);
        }
        jqlValuePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$4239d7c0fbafd3f1);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
        }
        enterRule(listener) {
            if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
        }
        exitRule(listener) {
            if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
        }
        accept(visitor) {
            if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$dc01290aee731418 extends (0, $6bmaO.ParserRuleContext) {
        AFTER() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.AFTER, 0);
        }
        BEFORE() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.BEFORE, 0);
        }
        ON() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.ON, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$75412b8b6a6442e1 extends (0, $6bmaO.ParserRuleContext) {
        DURING() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.DURING, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$ad402332075c8656 extends (0, $6bmaO.ParserRuleContext) {
        BY() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.BY, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$4239d7c0fbafd3f1 extends (0, $6bmaO.ParserRuleContext) {
        FROM() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.FROM, 0);
        }
        TO() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.TO, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$6b796c5a4b8c18e extends (0, $6bmaO.ParserRuleContext) {
        jqlOperand() {
            return this.getRuleContext(0, $371e898df891458a$export$2eaac5a9828bf647);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
        }
        enterRule(listener) {
            if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
        }
        exitRule(listener) {
            if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
        }
        accept(visitor) {
            if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$534469b9c8f44139 extends (0, $6bmaO.ParserRuleContext) {
        ORDER() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.ORDER, 0);
        }
        BY() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.BY, 0);
        }
        jqlSearchSort(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$c7d8f03f36952a46);
            else return this.getRuleContext(i, $371e898df891458a$export$c7d8f03f36952a46);
        }
        COMMA(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.COMMA);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.COMMA, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrderBy;
        }
        enterRule(listener) {
            if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
        }
        exitRule(listener) {
            if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
        }
        accept(visitor) {
            if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$c7d8f03f36952a46 extends (0, $6bmaO.ParserRuleContext) {
        jqlField() {
            return this.getRuleContext(0, $371e898df891458a$export$b33300c3d916229a);
        }
        DESC() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.DESC, 0);
        }
        ASC() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.ASC, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSearchSort;
        }
        enterRule(listener) {
            if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
        }
        exitRule(listener) {
            if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
        }
        accept(visitor) {
            if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
            else return visitor.visitChildren(this);
        }
    }
});
parcelRegister("lKjSa", function(module, exports) {
    $parcel$export(module.exports, "JastBuilderErrorListener", ()=>$6eeebc6d04d5cc03$export$d0857f60ff1f385);
    var $k9iwN;
    var $gbJ9P;
    class $6eeebc6d04d5cc03$export$d0857f60ff1f385 {
        constructor(){
            this.errors = [];
            this.syntaxError = (recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
                if (offendingSymbol === undefined) this.errors.push(new (0, (0, parcelRequire("k9iwN")).JQLParseError)(msg));
                else this.errors.push(new (0, (0, parcelRequire("gbJ9P")).JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
            };
        }
    }
});
parcelRegister("k9iwN", function(module, exports) {
    $parcel$export(module.exports, "JQLParseError", ()=>$c014cc1dfc254ce5$export$e8cfe2b2c93fbd4b);
    class $c014cc1dfc254ce5$export$e8cfe2b2c93fbd4b extends Error {
        constructor(message, cause){
            super(message);
            this.name = 'JQLParseError';
            this.cause = cause;
            this.description = message;
        }
    }
});
parcelRegister("gbJ9P", function(module, exports) {
    $parcel$export(module.exports, "JQLSyntaxError", ()=>$59495a4ee8e45f22$export$3276184116160c41);
    var $k9iwN;
    class $59495a4ee8e45f22$export$3276184116160c41 extends (0, (0, parcelRequire("k9iwN")).JQLParseError) {
        constructor(message, start, stop, line, charPositionInLine){
            super(message);
            this.name = 'JQLSyntaxError';
            this.start = start;
            this.stop = stop;
            this.line = line;
            this.charPositionInLine = charPositionInLine;
        }
    }
});
parcelRegister("bK3p2", function(module, exports) {
    $parcel$export(module.exports, "QueryVisitor", ()=>$0cc7bd3e15dd4aeb$export$418003b930734805);
    var $iEIQF;
    var $flxWO;
    var $fcxPF;
    var $gW3lb;
    class $0cc7bd3e15dd4aeb$export$418003b930734805 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.whereVisitor = new (0, (0, parcelRequire("gW3lb")).WhereVisitor)(this.tokens), this.orderByVisitor = new (0, (0, parcelRequire("fcxPF")).OrderByVisitor)(this.tokens), this.visitJqlQuery = (ctx)=>{
                const whereContext = ctx.jqlWhere();
                const orderByContext = ctx.jqlOrderBy();
                return (0, (0, parcelRequire("iEIQF")).internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
});
parcelRegister("flxWO", function(module, exports) {
    $parcel$export(module.exports, "JastBuildingVisitor", ()=>$4f91741519176bb0$export$d3c14d7188b09387);
    $parcel$export(module.exports, "getPositionFromToken", ()=>$4f91741519176bb0$export$85a4e6d858dbc6fb);
    $parcel$export(module.exports, "getPositionFromContext", ()=>$4f91741519176bb0$export$264629d4cd3cad3f);
    $parcel$export(module.exports, "getPositionsFromTerminalNodes", ()=>$4f91741519176bb0$export$30d51184879cbaa8);
    $parcel$export(module.exports, "normalizeText", ()=>$4f91741519176bb0$export$7c2714a5250b9239);
    class $4f91741519176bb0$export$d3c14d7188b09387 {
        constructor(tokens){
            this.tokens = tokens;
        }
        visit(tree) {
            throw new Error('Unsupported operation visit(ParseTree)');
        }
        visitChildren(node) {
            throw new Error('Unsupported operation visitChildren(RuleNode)');
        }
        visitErrorNode(node) {
            throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
        }
        visitTerminal(node) {
            throw new Error('Unsupported operation visitTerminal(TerminalNode)');
        }
    }
    const $4f91741519176bb0$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
            startToken.startIndex,
            (stopToken || startToken).stopIndex + 1
        ];
    const $4f91741519176bb0$export$264629d4cd3cad3f = (ctx)=>[
            ctx.start.startIndex,
            ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
        ];
    const $4f91741519176bb0$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$4f91741519176bb0$export$85a4e6d858dbc6fb(node.payload));
    const $4f91741519176bb0$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');
});
parcelRegister("fcxPF", function(module, exports) {
    $parcel$export(module.exports, "OrderByVisitor", ()=>$10359fbb24d00401$export$2774b71b99734811);
    var $iEIQF;
    var $kzRYu;
    var $flxWO;
    var $8sbD2;
    class $10359fbb24d00401$export$2774b71b99734811 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.searchSortVisitor = new $10359fbb24d00401$var$SearchSortVisitor(this.tokens), this.visitJqlOrderBy = (ctx)=>{
                if (ctx.exception) return undefined;
                const operator = (0, (0, parcelRequire("iEIQF")).internalCreators).orderByOperator((0, (0, parcelRequire("flxWO")).getPositionFromToken)(ctx.ORDER().payload, ctx.BY().payload));
                const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return (0, (0, parcelRequire("iEIQF")).internalCreators).orderBy(fields, operator, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $10359fbb24d00401$var$SearchSortVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.fieldVisitor = new (0, (0, parcelRequire("8sbD2")).FieldVisitor)(this.tokens), this.visitJqlSearchSort = (ctx)=>{
                const fieldCtx = ctx.jqlField();
                if (fieldCtx.exception) return undefined;
                let direction;
                const desc = ctx.DESC();
                const asc = ctx.ASC();
                if (desc !== undefined) direction = (0, (0, parcelRequire("iEIQF")).internalCreators).orderByDirection((0, $9f1dbb2b39d4d9a2$export$2ea27ea5f2121899), (0, (0, parcelRequire("flxWO")).getPositionFromToken)(desc.payload));
                else if (asc !== undefined) direction = (0, (0, parcelRequire("iEIQF")).internalCreators).orderByDirection((0, $9f1dbb2b39d4d9a2$export$6d60017b9e092e73), (0, (0, parcelRequire("flxWO")).getPositionFromToken)(asc.payload));
                return (0, (0, parcelRequire("iEIQF")).internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
});
parcelRegister("kzRYu", function(module, exports) {
    $parcel$export(module.exports, "notUndefined", ()=>$7297aaf6104af1ea$export$9a1adf421b69c6a);
    function $7297aaf6104af1ea$export$9a1adf421b69c6a(x) {
        return x !== undefined;
    }
});
parcelRegister("8sbD2", function(module, exports) {
    $parcel$export(module.exports, "FieldVisitor", ()=>$3b522eccd35764cb$export$c6a85c4c3bf2317d);
    var $iEIQF;
    var $31uE9;
    var $flxWO;
    var $gpYZF;
    class $3b522eccd35764cb$export$c6a85c4c3bf2317d extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.stringVisitor = new (0, (0, parcelRequire("gpYZF")).StringVisitor)(this.tokens), this.fieldPropertyVisitor = new $3b522eccd35764cb$var$FieldPropertyVisitor(this.tokens), this.visitJqlNumberField = (ctx)=>{
                const text = this.tokens.getText(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).field(text, text, undefined, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            }, this.visitJqlNonNumberField = (ctx)=>{
                const stringContext = ctx.jqlString();
                const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).field(stringValue.value, stringValue.text, properties, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
                const text = this.tokens.getText(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).field(text, text, properties, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $3b522eccd35764cb$var$FieldPropertyVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.argumentVisitor = new (0, (0, parcelRequire("31uE9")).ArgumentVisitor)(this.tokens), this.propertyArgumentVisitor = new $3b522eccd35764cb$var$PropertyArgumentVisitor(this.tokens), this.visitJqlFieldProperty = (ctx)=>{
                const argumentContext = ctx.jqlArgument();
                const propertyArgumentContext = ctx.jqlPropertyArgument();
                const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
                return (0, (0, parcelRequire("iEIQF")).internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $3b522eccd35764cb$var$PropertyArgumentVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.argumentVisitor = new (0, (0, parcelRequire("31uE9")).ArgumentVisitor)(this.tokens), this.visitJqlPropertyArgument = (ctx)=>{
                return ctx.jqlArgument().accept(this.argumentVisitor);
            };
        }
    }
});
parcelRegister("31uE9", function(module, exports) {
    $parcel$export(module.exports, "ArgumentVisitor", ()=>$11f58529c551c5c5$export$46b5a1f6d962d533);
    var $iEIQF;
    var $flxWO;
    var $gpYZF;
    class $11f58529c551c5c5$export$46b5a1f6d962d533 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.stringVisitor = new (0, (0, parcelRequire("gpYZF")).StringVisitor)(this.tokens), this.visitJqlArgument = (ctx)=>{
                const stringContext = ctx.jqlString();
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
                } else {
                    const text = this.tokens.getText(ctx);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).argument(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
            };
        }
    }
});
parcelRegister("gpYZF", function(module, exports) {
    $parcel$export(module.exports, "StringVisitor", ()=>$15b8c92276e87e16$export$617850cb96304515);
    var $flxWO;
    class $15b8c92276e87e16$export$617850cb96304515 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.visitJqlString = (ctx)=>{
                const text = this.tokens.getText(ctx);
                const position = (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx);
                let value;
                if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
                else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
                else value = text;
                return {
                    text: text,
                    value: value,
                    position: position
                };
            };
        }
    }
});
parcelRegister("gW3lb", function(module, exports) {
    $parcel$export(module.exports, "WhereVisitor", ()=>$e8ab3cb2e5350018$export$c573472f1d20e15d);
    var $iEIQF;
    var $kzRYu;
    var $flxWO;
    var $aSD70;
    class $e8ab3cb2e5350018$export$c573472f1d20e15d extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.terminalClauseVisitor = new (0, (0, parcelRequire("aSD70")).TerminalClauseVisitor)(this.tokens), this.visitJqlWhere = (ctx)=>{
                return this.visitJqlOrClause(ctx.jqlOrClause());
            }, this.visitJqlOrClause = (ctx)=>{
                const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                if (clauses.length > 1) {
                    const operator = (0, (0, parcelRequire("iEIQF")).internalCreators).compoundOperator((0, $3cef51f82b2cbe1d$export$7b8f0a728d79a753), (0, (0, parcelRequire("flxWO")).getPositionsFromTerminalNodes)(ctx.OR()));
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).compoundClause(operator, clauses, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
                return clauses.length === 0 ? undefined : clauses[0];
            }, this.visitJqlAndClause = (ctx)=>{
                const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                if (clauses.length > 1) {
                    const operator = (0, (0, parcelRequire("iEIQF")).internalCreators).compoundOperator((0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97), (0, (0, parcelRequire("flxWO")).getPositionsFromTerminalNodes)(ctx.AND()));
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).compoundClause(operator, clauses, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
                return clauses.length === 0 ? undefined : clauses[0];
            }, this.visitJqlNotClause = (ctx)=>{
                const notClauseContext = ctx.jqlNotClause();
                const subClauseContext = ctx.jqlSubClause();
                const terminalClauseContext = ctx.jqlTerminalClause();
                let clause;
                if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
                else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
                else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
                let notToken = ctx.NOT();
                notToken = notToken === undefined ? ctx.BANG() : notToken;
                if (notToken && clause) return (0, (0, parcelRequire("iEIQF")).internalCreators).notClause(clause, (0, (0, parcelRequire("iEIQF")).internalCreators).notClauseOperator((0, (0, parcelRequire("flxWO")).getPositionFromToken)(notToken.payload)), (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                return clause;
            }, this.visitJqlSubClause = (ctx)=>{
                return this.visitJqlOrClause(ctx.jqlOrClause());
            };
        }
    }
});
parcelRegister("aSD70", function(module, exports) {
    $parcel$export(module.exports, "TerminalClauseVisitor", ()=>$059f8caffc466ad5$export$14576ae5bd1874a9);
    var $iEIQF;
    var $kzRYu;
    var $flxWO;
    var $8sbD2;
    var $dE1pq;
    var $hUHF5;
    var $3qoPC;
    class $059f8caffc466ad5$export$14576ae5bd1874a9 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.fieldVisitor = new (0, (0, parcelRequire("8sbD2")).FieldVisitor)(this.tokens), this.terminalClauseRhsVisitor = new $059f8caffc466ad5$var$TerminalClauseRhsVisitor(this.tokens), this.visitJqlTerminalClause = (ctx)=>{
                const field = ctx.jqlField().accept(this.fieldVisitor);
                const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
                const position = (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).terminalClause(field, operator, operand, predicates, position);
            };
        }
    }
    class $059f8caffc466ad5$var$TerminalClauseRhsVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.operatorVisitor = new (0, (0, parcelRequire("hUHF5")).OperatorVisitor)(this.tokens), this.terminalClauseOperandVisitor = new $059f8caffc466ad5$var$TerminalClauseOperandVisitor(this.tokens), this.predicateVisitor = new (0, (0, parcelRequire("3qoPC")).PredicateVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
                const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            }, this.visitJqlLikeClause = (ctx)=>{
                const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            }, this.visitJqlComparisonClause = (ctx)=>{
                const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            }, this.visitJqlInClause = (ctx)=>{
                const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            }, this.visitJqlIsClause = (ctx)=>{
                const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            }, this.visitJqlWasClause = (ctx)=>{
                const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return {
                    operator: operator,
                    operand: operand,
                    predicates: predicates
                };
            }, this.visitJqlWasInClause = (ctx)=>{
                const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return {
                    operator: operator,
                    operand: operand,
                    predicates: predicates
                };
            }, this.visitJqlChangedClause = (ctx)=>{
                const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
                const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return {
                    operator: operator,
                    operand: undefined,
                    predicates: predicates
                };
            }, this.visitChildren = (node)=>{
                const operator = node.accept(this.operatorVisitor);
                return {
                    operator: operator,
                    operand: undefined,
                    predicates: []
                };
            };
        }
    }
    class $059f8caffc466ad5$var$TerminalClauseOperandVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.operandVisitor = new (0, (0, parcelRequire("dE1pq")).OperandVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            }, this.visitJqlLikeClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            }, this.visitJqlComparisonClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            }, this.visitJqlInClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlList(),
                    ctx.jqlFunction()
                ]);
            }, this.visitJqlIsClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty()
                ]);
            }, this.visitJqlWasClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            }, this.visitJqlWasInClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlList(),
                    ctx.jqlFunction()
                ]);
            }, this.getOperandForContexts = (contexts)=>{
                const operandContext = contexts.find((0, (0, parcelRequire("kzRYu")).notUndefined));
                return operandContext?.accept(this.operandVisitor);
            };
        }
    }
});
parcelRegister("dE1pq", function(module, exports) {
    $parcel$export(module.exports, "OperandVisitor", ()=>$f0dc0c50bebb9cb5$export$ef8ae1aa15d9c9af);
    var $iEIQF;
    var $kzRYu;
    var $31uE9;
    var $flxWO;
    var $h5KaL;
    var $gpYZF;
    class $f0dc0c50bebb9cb5$export$ef8ae1aa15d9c9af extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.stringVisitor = new (0, (0, parcelRequire("gpYZF")).StringVisitor)(this.tokens), this.numberVisitor = new (0, (0, parcelRequire("h5KaL")).NumberVisitor)(this.tokens), this.functionNameVisitor = new $f0dc0c50bebb9cb5$var$FunctionNameVisitor(this.tokens), this.argumentListVisitor = new $f0dc0c50bebb9cb5$var$ArgumentListVisitor(this.tokens), this.visitJqlOperand = (ctx)=>{
                const operandContext = [
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlList(),
                    ctx.jqlFunction()
                ].find((0, (0, parcelRequire("kzRYu")).notUndefined));
                return operandContext?.accept(this);
            }, this.visitJqlEmpty = (ctx)=>{
                if (ctx.exception) return undefined;
                return (0, (0, parcelRequire("iEIQF")).internalCreators).keywordOperand((0, $49b29ef7baa2a152$export$1c46dca02aac24dd), (0, (0, parcelRequire("flxWO")).getPositionFromToken)(ctx.EMPTY().payload));
            }, this.visitJqlValue = (ctx)=>{
                const stringContext = ctx.jqlString();
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
                }
                const numberContext = ctx.jqlNumber();
                if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
            }, this.visitJqlList = (ctx)=>{
                const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return (0, (0, parcelRequire("iEIQF")).internalCreators).listOperand(values, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            }, this.visitJqlFunction = (ctx)=>{
                const argumentListContext = ctx.jqlArgumentList();
                return (0, (0, parcelRequire("iEIQF")).internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $f0dc0c50bebb9cb5$var$FunctionNameVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.stringVisitor = new (0, (0, parcelRequire("gpYZF")).StringVisitor)(this.tokens), this.visitJqlFunctionName = (ctx)=>{
                const stringContext = ctx.jqlString();
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
                } else {
                    const text = this.tokens.getText(ctx);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).functionString(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
            };
        }
    }
    class $f0dc0c50bebb9cb5$var$ArgumentListVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.argumentVisitor = new (0, (0, parcelRequire("31uE9")).ArgumentVisitor)(this.tokens), this.visitJqlArgumentList = (ctx)=>{
                return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
            };
        }
    }
});
parcelRegister("h5KaL", function(module, exports) {
    $parcel$export(module.exports, "NumberVisitor", ()=>$949fba49fb4026f9$export$a55432f0884633e4);
    var $iEIQF;
    var $flxWO;
    class $949fba49fb4026f9$export$a55432f0884633e4 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.visitJqlNumber = (ctx)=>{
                const text = this.tokens.getText(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).valueOperand(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
});
parcelRegister("hUHF5", function(module, exports) {
    $parcel$export(module.exports, "OperatorVisitor", ()=>$ce76282d2f3e5bd1$export$e56f89ba95b51d2a);
    var $iEIQF;
    var $dI0u8;
    var $flxWO;
    class $ce76282d2f3e5bd1$export$e56f89ba95b51d2a extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        visitJqlEqualsOperator(ctx) {
            const text = this.tokens.getText(ctx);
            if (!(0, (0, parcelRequire("dI0u8")).isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlLikeOperator(ctx) {
            const text = this.tokens.getText(ctx);
            if (!(0, (0, parcelRequire("dI0u8")).isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlComparisonOperator(ctx) {
            const text = this.tokens.getText(ctx);
            if (!(0, (0, parcelRequire("dI0u8")).isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlInOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isInOperator)(value)) return undefined;
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlIsOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlWasOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlWasInOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlChangedOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        constructor(...args){
            super(...args), this.visitChildren = (node)=>{
                const { sourceInterval: sourceInterval } = node;
                const text = this.tokens.getText(sourceInterval);
                if (text) {
                    const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
                    const { a: startIndex, b: stopIndex } = sourceInterval;
                    const startToken = this.tokens.get(startIndex);
                    const stopToken = this.tokens.get(stopIndex);
                    const position = (0, (0, parcelRequire("flxWO")).getPositionFromToken)(startToken, stopToken);
                    if ((0, (0, parcelRequire("dI0u8")).isOperator)(value)) return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, position);
                }
            };
        }
    }
});
parcelRegister("dI0u8", function(module, exports) {
    $parcel$export(module.exports, "isOperator", ()=>$ced3977476a8d3df$export$4e40859592ee7ac2);
    $parcel$export(module.exports, "isEqualsOperator", ()=>$ced3977476a8d3df$export$6d0fc196fa8a1673);
    $parcel$export(module.exports, "isLikeOperator", ()=>$ced3977476a8d3df$export$ad91b6d6a89cb64e);
    $parcel$export(module.exports, "isComparisonOperator", ()=>$ced3977476a8d3df$export$4477c442bd5c2a6d);
    $parcel$export(module.exports, "isInOperator", ()=>$ced3977476a8d3df$export$c5e1cdef30e30bff);
    $parcel$export(module.exports, "isIsOperator", ()=>$ced3977476a8d3df$export$ccc3334744e395c7);
    $parcel$export(module.exports, "isWasOperator", ()=>$ced3977476a8d3df$export$2b1c5d7e7856f91d);
    $parcel$export(module.exports, "isWasInOperator", ()=>$ced3977476a8d3df$export$55d8c9b20d99509f);
    $parcel$export(module.exports, "isChangedOperator", ()=>$ced3977476a8d3df$export$b65d23d23ade534b);
    $parcel$export(module.exports, "isListOperator", ()=>$ced3977476a8d3df$export$b09522e4061bbdd6);
    var $bzbto;
    const $ced3977476a8d3df$export$4e40859592ee7ac2 = (operator)=>(0, (0, parcelRequire("bzbto")).OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$6d0fc196fa8a1673 = (operator)=>(0, (0, parcelRequire("bzbto")).EQUALS_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$ad91b6d6a89cb64e = (operator)=>(0, (0, parcelRequire("bzbto")).LIKE_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$4477c442bd5c2a6d = (operator)=>(0, (0, parcelRequire("bzbto")).COMPARISON_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$c5e1cdef30e30bff = (operator)=>(0, (0, parcelRequire("bzbto")).IN_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$ccc3334744e395c7 = (operator)=>(0, (0, parcelRequire("bzbto")).IS_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$2b1c5d7e7856f91d = (operator)=>(0, (0, parcelRequire("bzbto")).WAS_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$55d8c9b20d99509f = (operator)=>(0, (0, parcelRequire("bzbto")).WAS_IN_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$b65d23d23ade534b = (operator)=>(0, (0, parcelRequire("bzbto")).CHANGED_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$b09522e4061bbdd6 = (operator)=>(0, (0, parcelRequire("bzbto")).LIST_OPERATORS).includes(operator);
});
parcelRegister("3qoPC", function(module, exports) {
    $parcel$export(module.exports, "PredicateVisitor", ()=>$377f729dab70cce1$export$33bb52a35c693109);
    var $iEIQF;
    var $k75oj;
    var $kzRYu;
    var $flxWO;
    var $dE1pq;
    class $377f729dab70cce1$export$33bb52a35c693109 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.predicateOperatorVisitor = new $377f729dab70cce1$var$PredicateOperatorVisitor(this.tokens), this.predicateOperandVisitor = new $377f729dab70cce1$var$PredicateOperandVisitor(this.tokens), this.visitJqlWasPredicate = (ctx)=>{
                const operator = this.getOperatorForContexts([
                    ctx.jqlDatePredicateOperator(),
                    ctx.jqlDateRangePredicateOperator(),
                    ctx.jqlUserPredicateOperator()
                ]);
                const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
                const position = (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).predicate(operator, operand, position);
            }, this.visitJqlChangedPredicate = (ctx)=>{
                const operator = this.getOperatorForContexts([
                    ctx.jqlDatePredicateOperator(),
                    ctx.jqlDateRangePredicateOperator(),
                    ctx.jqlUserPredicateOperator(),
                    ctx.jqlValuePredicateOperator()
                ]);
                const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
                const position = (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).predicate(operator, operand, position);
            }, this.getOperatorForContexts = (contexts)=>{
                const operatorContext = contexts.find((0, (0, parcelRequire("kzRYu")).notUndefined));
                if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
                else throw new Error('Undefined predicate operator context');
            };
        }
    }
    class $377f729dab70cce1$var$PredicateOperatorVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.visitJqlDatePredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            }, this.visitJqlDateRangePredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            }, this.visitJqlUserPredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            }, this.visitJqlValuePredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            }, this.getPredicateOperator = (ctx)=>{
                const text = this.tokens.getText(ctx);
                const value = text.toLowerCase().replace(/\s+/g, ' ');
                if (!(0, (0, parcelRequire("k75oj")).isPredicateOperator)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).predicateOperator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $377f729dab70cce1$var$PredicateOperandVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.operandVisitor = new (0, (0, parcelRequire("dE1pq")).OperandVisitor)(this.tokens), this.visitJqlPredicateOperand = (ctx)=>{
                return ctx.jqlOperand().accept(this.operandVisitor);
            };
        }
    }
});
parcelRegister("k75oj", function(module, exports) {
    $parcel$export(module.exports, "isPredicateOperator", ()=>$d2e5ca8020522bfa$export$188978ad94919403);
    var $2OsFJ;
    const $d2e5ca8020522bfa$export$188978ad94919403 = (operator)=>(0, (0, parcelRequire("2OsFJ")).PREDICATE_OPERATORS).includes(operator);
});
parcelRegister("2OsFJ", function(module, exports) {
    $parcel$export(module.exports, "PREDICATE_OPERATORS", ()=>$7ee5a5e33e4550f1$export$e200440af9f1d9f);
    const $7ee5a5e33e4550f1$export$3d56e2ae1b4bbbf9 = 'after';
    const $7ee5a5e33e4550f1$export$f0a816341603bb63 = 'before';
    const $7ee5a5e33e4550f1$export$cdc81c84f768d513 = 'by';
    const $7ee5a5e33e4550f1$export$8a5280c65e704c3d = 'during';
    const $7ee5a5e33e4550f1$export$71f882dcac65f97a = 'from';
    const $7ee5a5e33e4550f1$export$5685a35c6b0a7ee8 = 'on';
    const $7ee5a5e33e4550f1$export$5a83c4789e531a = 'to';
    const $7ee5a5e33e4550f1$export$e200440af9f1d9f = [
        $7ee5a5e33e4550f1$export$3d56e2ae1b4bbbf9,
        $7ee5a5e33e4550f1$export$f0a816341603bb63,
        $7ee5a5e33e4550f1$export$cdc81c84f768d513,
        $7ee5a5e33e4550f1$export$8a5280c65e704c3d,
        $7ee5a5e33e4550f1$export$71f882dcac65f97a,
        $7ee5a5e33e4550f1$export$5685a35c6b0a7ee8,
        $7ee5a5e33e4550f1$export$5a83c4789e531a
    ];
});
parcelRegister("l0V05", function(module, exports) {
    $parcel$export(module.exports, "print", ()=>$2a6ee55a17f6829c$export$c2d084dc44961371);
    var $3NMrl = parcelRequire("3NMrl");
    var $jcm7E;
    var $4gL4M;
    const $2a6ee55a17f6829c$export$c2d084dc44961371 = (jast, options = {})=>{
        return (0, (0, parcelRequire("4gL4M")).printDocToString)((0, (0, parcelRequire("jcm7E")).printAstToDoc)(jast, (0, ($parcel$interopDefault($3NMrl)))(options, [
            'operatorCase'
        ])), (0, ($parcel$interopDefault($3NMrl)))(options, [
            'printWidth'
        ]));
    };
});
parcelRegister("jcm7E", function(module, exports) {
    $parcel$export(module.exports, "printAstToDoc", ()=>$7ac43980ca69512e$export$f0ef38932978952);
    var $bv7J5;
    var $d4xUO;
    const $7ac43980ca69512e$var$formatOperator = (operator, operatorCase)=>{
        switch(operatorCase){
            case 'lower':
                return operator.toLowerCase();
            case 'upper':
                return operator.toUpperCase();
            case 'preserve':
                return operator;
        }
    };
    class $7ac43980ca69512e$export$27a275559a5c8102 extends (0, (0, parcelRequire("bv7J5")).AbstractJastVisitor) {
        constructor({ operatorCase: operatorCase } = {}){
            super();
            this.operatorCase = operatorCase || 'preserve';
        }
        visitArgument(argument) {
            return argument.text;
        }
        joinNodes(nodes, separator) {
            const docs = [];
            nodes.forEach((node)=>{
                if (separator !== undefined && docs.length > 0) docs.push(separator);
                docs.push(node.accept(this));
            });
            return docs;
        }
        visitCompoundClause(compoundClause) {
            const operatorDoc = compoundClause.operator.accept(this);
            const clauseDocs = [];
            compoundClause.clauses.forEach((clause)=>{
                if (clauseDocs.length > 0) clauseDocs.push((0, (0, parcelRequire("d4xUO")).ifBreak)((0, (0, parcelRequire("d4xUO")).newLine)(), ' '), operatorDoc, ' ');
                if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
                else clauseDocs.push(clause.accept(this));
            });
            return (0, (0, parcelRequire("d4xUO")).group)(clauseDocs);
        }
        visitCompoundOperator(compoundOperator) {
            return $7ac43980ca69512e$var$formatOperator(compoundOperator.value, this.operatorCase);
        }
        visitField(field) {
            const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
            return (0, (0, parcelRequire("d4xUO")).group)([
                field.text,
                ...propertyDocs
            ]);
        }
        visitFunction(functionString) {
            return functionString.text;
        }
        visitFunctionOperand(functionOperand) {
            const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
            return (0, (0, parcelRequire("d4xUO")).group)([
                functionOperand.function.accept(this),
                '(',
                ...argumentDocs,
                ')'
            ]);
        }
        visitKeywordOperand(keywordOperand) {
            return keywordOperand.value;
        }
        visitListOperand(listOperand) {
            const operandDocs = this.joinNodes(listOperand.values, ', ');
            return (0, (0, parcelRequire("d4xUO")).group)([
                '(',
                ...operandDocs,
                ')'
            ]);
        }
        visitOperator(operator) {
            return $7ac43980ca69512e$var$formatOperator(operator.text, this.operatorCase);
        }
        visitOrderBy(orderBy) {
            const fieldDocs = this.joinNodes(orderBy.fields, ', ');
            return (0, (0, parcelRequire("d4xUO")).group)([
                orderBy.operator.accept(this),
                ' ',
                ...fieldDocs
            ]);
        }
        visitOrderByDirection(orderByDirection) {
            return orderByDirection.value;
        }
        visitOrderByField(orderByField) {
            const docs = [
                orderByField.field.accept(this)
            ];
            if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
            return (0, (0, parcelRequire("d4xUO")).group)(docs);
        }
        visitOrderByOperator(orderByOperator) {
            return $7ac43980ca69512e$var$formatOperator(orderByOperator.value, this.operatorCase);
        }
        visitPredicate(predicate) {
            const docs = [
                predicate.operator.accept(this)
            ];
            if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
            return (0, (0, parcelRequire("d4xUO")).group)(docs);
        }
        visitPredicateOperator(predicateOperator) {
            return $7ac43980ca69512e$var$formatOperator(predicateOperator.text, this.operatorCase);
        }
        visitProperty(property) {
            const docs = [];
            if (property.key) docs.push('[', property.key.accept(this), ']');
            if (property.path) {
                const pathDocs = this.joinNodes(property.path, ' ');
                docs.push(...pathDocs);
            }
            return (0, (0, parcelRequire("d4xUO")).group)(docs);
        }
        visitQuery(query) {
            if (query.where && query.orderBy) return (0, (0, parcelRequire("d4xUO")).group)([
                query.where.accept(this),
                (0, (0, parcelRequire("d4xUO")).ifBreak)((0, (0, parcelRequire("d4xUO")).newLine)(), ' '),
                query.orderBy.accept(this)
            ]);
            else if (query.where) return query.where.accept(this);
            else if (query.orderBy) return query.orderBy.accept(this);
            return '';
        }
        visitTerminalClause(terminalClause) {
            const docs = [
                terminalClause.field.accept(this)
            ];
            if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
            if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
            terminalClause.predicates.forEach((predicate)=>{
                docs.push(' ', predicate.accept(this));
            });
            return (0, (0, parcelRequire("d4xUO")).group)(docs);
        }
        visitValueOperand(valueOperand) {
            return valueOperand.text;
        }
        visitNotClause(notClause) {
            const clauseDocs = [];
            if (notClause.clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
            else clauseDocs.push(notClause.clause.accept(this));
            return (0, (0, parcelRequire("d4xUO")).group)([
                notClause.operator.accept(this),
                ' ',
                ...clauseDocs
            ]);
        }
        visitNotClauseOperator(notClauseOperator) {
            return notClauseOperator.value;
        }
        visitChildren() {
            throw new Error('Required visit method not implemented for node');
        }
        defaultResult() {
            return '';
        }
    }
    const $7ac43980ca69512e$export$f0ef38932978952 = (jast, options)=>{
        const astToDocVisitor = new $7ac43980ca69512e$export$27a275559a5c8102(options);
        return jast.query ? jast.query.accept(astToDocVisitor) : '';
    };
});
parcelRegister("bv7J5", function(module, exports) {
    $parcel$export(module.exports, "AbstractJastVisitor", ()=>$564d8ceecff04d6a$export$51be62b46ee668fd);
    class $564d8ceecff04d6a$export$51be62b46ee668fd {
        visit(node) {
            return node.accept(this);
        }
        visitChildren(node) {
            let result = this.defaultResult();
            const children = node.getChildren();
            for(let i = 0; i < children.length; i++){
                if (!this.shouldVisitNextChild(node, result)) break;
                const childResult = children[i].accept(this);
                result = this.aggregateResult(result, childResult);
            }
            return result;
        }
        aggregateResult(aggregate, nextResult) {
            return nextResult;
        }
        shouldVisitNextChild(node, currentResult) {
            return true;
        }
    }
});
parcelRegister("d4xUO", function(module, exports) {
    $parcel$export(module.exports, "group", ()=>$9ef2b92937def9ad$export$e5e25fbcc1f7affe);
    $parcel$export(module.exports, "ifBreak", ()=>$9ef2b92937def9ad$export$1db8e61901dcb0fa);
    $parcel$export(module.exports, "newLine", ()=>$9ef2b92937def9ad$export$dc84f6841f96b7da);
    const $9ef2b92937def9ad$export$e5e25fbcc1f7affe = (contents)=>{
        return {
            type: 'group',
            contents: contents
        };
    };
    const $9ef2b92937def9ad$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
        return {
            type: 'if-break',
            breakContents: breakContents,
            flatContents: flatContents
        };
    };
    const $9ef2b92937def9ad$export$dc84f6841f96b7da = ()=>{
        return {
            type: 'new-line'
        };
    };
});
parcelRegister("4gL4M", function(module, exports) {
    $parcel$export(module.exports, "printDocToString", ()=>$b6450d092f32aba3$export$316fc7e94b95b118);
    const $b6450d092f32aba3$var$computeFlatWidth = (doc)=>{
        if (typeof doc === 'string') return doc.length;
        if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $b6450d092f32aba3$var$computeFlatWidth(innerDoc), 0);
        switch(doc.type){
            case 'group':
                return $b6450d092f32aba3$var$computeFlatWidth(doc.contents);
            case 'if-break':
                return $b6450d092f32aba3$var$computeFlatWidth(doc.flatContents);
            case 'new-line':
                return 0;
            default:
                throw new Error('Unrecognised doc type.');
        }
    };
    const $b6450d092f32aba3$var$printDoc = (doc, context)=>{
        if (typeof doc === 'string') return {
            result: doc,
            endIndex: context.startIndex + doc.length
        };
        switch(doc.type){
            case 'group':
                return $b6450d092f32aba3$var$printGroup(doc, context);
            case 'if-break':
                return $b6450d092f32aba3$var$printIfBreak(doc, context);
            case 'new-line':
                return $b6450d092f32aba3$var$printNewLine();
            default:
                throw new Error('Unrecognised doc type.');
        }
    };
    const $b6450d092f32aba3$var$printGroup = (doc, context)=>{
        const docWidth = context.startIndex + $b6450d092f32aba3$var$computeFlatWidth(doc);
        const breakContents = context.printWidth !== null && docWidth > context.printWidth;
        return doc.contents.reduce((agg, innerDoc)=>{
            const innerContext = {
                ...context,
                startIndex: agg.endIndex,
                breakContents: breakContents
            };
            const output = $b6450d092f32aba3$var$printDoc(innerDoc, innerContext);
            return {
                result: agg.result + output.result,
                endIndex: output.endIndex
            };
        }, {
            result: '',
            endIndex: context.startIndex
        });
    };
    const $b6450d092f32aba3$var$printIfBreak = (doc, context)=>{
        if (context.breakContents) return $b6450d092f32aba3$var$printDoc(doc.breakContents, context);
        return $b6450d092f32aba3$var$printDoc(doc.flatContents, context);
    };
    const $b6450d092f32aba3$var$printNewLine = ()=>{
        return {
            result: '\n',
            endIndex: 0
        };
    };
    const $b6450d092f32aba3$var$defaultPrintWidth = 100;
    const $b6450d092f32aba3$export$316fc7e94b95b118 = (doc, options = {})=>{
        const { printWidth: printWidth = $b6450d092f32aba3$var$defaultPrintWidth } = options;
        const output = $b6450d092f32aba3$var$printDoc(doc, {
            printWidth: printWidth,
            startIndex: 0,
            breakContents: false
        });
        return output.result;
    };
});
parcelRegister("1qdF0", function(module, exports) {
    $parcel$export(module.exports, "useCollectionsActions", ()=>$1eef7de227d1974d$export$ba61932a631ba139);
    $parcel$export(module.exports, "useCollectionsOwnersIds", ()=>$1eef7de227d1974d$export$47ee56d816ebfe18);
    $parcel$export(module.exports, "useFilteredCollections", ()=>$1eef7de227d1974d$export$a4dbccbfbbac764d);
    $parcel$export(module.exports, "useCollectionsLoading", ()=>$1eef7de227d1974d$export$c4791ba8ac9a58e5);
    $parcel$export(module.exports, "useCollectionsHasError", ()=>$1eef7de227d1974d$export$1b07b501c3f8f216);
    $parcel$export(module.exports, "useCollectionsCount", ()=>$1eef7de227d1974d$export$41be1fea11eb73ec);
    $parcel$export(module.exports, "useCollectionName", ()=>$1eef7de227d1974d$export$71661e51ce252508);
    $parcel$export(module.exports, "useCollectionEmoji", ()=>$1eef7de227d1974d$export$c35637e36ec6f8fd);
    $parcel$export(module.exports, "useCollectionJql", ()=>$1eef7de227d1974d$export$3ddba651313f7cb0);
    $parcel$export(module.exports, "useCollectionViews", ()=>$1eef7de227d1974d$export$4d3e73040770b6);
    $parcel$export(module.exports, "useCollectionLoading", ()=>$1eef7de227d1974d$export$6073e01a27128de4);
    $parcel$export(module.exports, "useCollectionError", ()=>$1eef7de227d1974d$export$5a7fad0d58c5f5e2);
    $parcel$export(module.exports, "useCollectionHasError", ()=>$1eef7de227d1974d$export$a864c959274a94b8);
    $parcel$export(module.exports, "useCollectionViewsCount", ()=>$1eef7de227d1974d$export$1a42c92187206222);
    $parcel$export(module.exports, "useHasFetchedCollectionViews", ()=>$1eef7de227d1974d$export$32becd83126d3e5b);
    $parcel$export(module.exports, "useCollectionOwnerId", ()=>$1eef7de227d1974d$export$333713f4878fc62d);
    $parcel$export(module.exports, "useCollectionDescription", ()=>$1eef7de227d1974d$export$31549a29278f29ca);
    $parcel$export(module.exports, "useProjectCollectionsCount", ()=>$1eef7de227d1974d$export$e785641239dc5c88);
    $parcel$export(module.exports, "useIsCollectionDescriptionLoading", ()=>$1eef7de227d1974d$export$d01e52f887fd0aef);
    $parcel$export(module.exports, "useCollectionDescriptionHasError", ()=>$1eef7de227d1974d$export$d8d51044786d761);
    var $kGsr8 = parcelRequire("kGsr8");
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    var $74N90;
    var $emOwp;
    const $1eef7de227d1974d$var$initialState = {
        collections: {},
        isLoading: true,
        error: undefined,
        descriptions: {}
    };
    const $1eef7de227d1974d$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $1eef7de227d1974d$var$initialState,
        actions: (0, parcelRequire("74N90")),
        name: 'PolarisCollections'
    });
    const $1eef7de227d1974d$export$ba61932a631ba139 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($1eef7de227d1974d$var$Store);
    const $1eef7de227d1974d$var$getCollections = (state)=>state.collections;
    const $1eef7de227d1974d$var$getCollectionsList = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollections, (collections)=>Object.values(collections).map((c)=>c?.data).filter(Boolean));
    const $1eef7de227d1974d$var$getCollectionIds = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollections, (collections)=>Object.keys(collections));
    const $1eef7de227d1974d$var$getCollectionsLoading = (state)=>state.isLoading;
    const $1eef7de227d1974d$var$getCollectionsError = (state)=>state.error;
    const $1eef7de227d1974d$var$getCollectionsHasError = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollectionsError, (error)=>!!error);
    const $1eef7de227d1974d$var$getCollectionsOwnersIds = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollectionsList, (collections)=>(0, ($parcel$interopDefault($kGsr8)))(collections.map(({ ownerId: ownerId })=>ownerId).filter(Boolean)));
    const $1eef7de227d1974d$var$getFilteredCollections = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>$1eef7de227d1974d$var$getCollectionsList(state), (_, { text: text })=>text, (_, { ownerIds: ownerIds })=>ownerIds, (_, { projects: projects })=>projects, (collections, text, ownerIds, projects)=>collections ? collections.filter((collection)=>(0, (0, parcelRequire("emOwp")).filterCollectionByText)(text)(collection) && (0, (0, parcelRequire("emOwp")).filterCollectionByOwnerIds)(ownerIds)(collection) && (0, (0, parcelRequire("emOwp")).filterCollectionByProjectKeys)(projects)(collection)) : []);
    const $1eef7de227d1974d$var$getCollectionsCount = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollectionsList, (collections)=>collections.length);
    const $1eef7de227d1974d$export$47ee56d816ebfe18 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionsOwnersIds
    });
    const $1eef7de227d1974d$export$a4dbccbfbbac764d = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getFilteredCollections
    });
    const $1eef7de227d1974d$export$2b5787016ed09c4d = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollections
    });
    const $1eef7de227d1974d$export$c4791ba8ac9a58e5 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionsLoading
    });
    const $1eef7de227d1974d$export$1b07b501c3f8f216 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionsHasError
    });
    const $1eef7de227d1974d$export$41be1fea11eb73ec = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionsCount
    });
    const $1eef7de227d1974d$export$e9fd0b8259ad0113 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionIds
    });
    const $1eef7de227d1974d$var$getCollectionWithMeta = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollections, (_, { collectionUUID: collectionUUID })=>collectionUUID, (collections, collectionUUID)=>collectionUUID ? collections[collectionUUID] : undefined);
    const $1eef7de227d1974d$var$getCollection = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollectionWithMeta, (collection)=>collection?.data);
    const $1eef7de227d1974d$var$getCollectionName = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.name);
    const $1eef7de227d1974d$var$getCollectionEmoji = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.emoji);
    const $1eef7de227d1974d$var$getCollectionJql = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.jql);
    const $1eef7de227d1974d$var$getCollectionViews = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.views || []);
    const $1eef7de227d1974d$var$hasFetchedCollectionViews = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>Array.isArray(collection?.views));
    const $1eef7de227d1974d$var$getIsCollectionLoading = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollectionWithMeta, (collection)=>!!collection?.isLoading && !collection?.data?.views);
    const $1eef7de227d1974d$var$getCollectionProjectKeys = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.projectKeys);
    const $1eef7de227d1974d$var$getProjectCollectionsCount = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollections, (collections)=>Object.values(collections).flatMap((collection)=>collection?.data?.projectKeys).filter((key)=>!!key).reduce((acc, projectKey)=>{
            acc[projectKey] = (acc[projectKey] ?? 0) + 1;
            return acc;
        }, {}));
    const $1eef7de227d1974d$var$getError = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollectionWithMeta, (collection)=>collection?.error);
    const $1eef7de227d1974d$var$hasError = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getError, (error)=>!!error);
    const $1eef7de227d1974d$var$getCollectionViewsOwnersIds = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollectionViews, (views)=>(0, ($parcel$interopDefault($kGsr8)))(views.map(({ ownerId: ownerId })=>ownerId).filter(Boolean)));
    const $1eef7de227d1974d$var$getCollectionView = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollectionViews, (_, { viewUUID: viewUUID })=>viewUUID, (views, viewUUID)=>viewUUID ? views.find((view)=>view.uuid === viewUUID) : undefined);
    const $1eef7de227d1974d$var$getCollectionViewTitle = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollectionView, (view)=>view?.title);
    const $1eef7de227d1974d$var$getCollectionViewsCount = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.views?.length || collection?.viewsCount);
    const $1eef7de227d1974d$var$getCollectionOwnerId = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.ownerId);
    const $1eef7de227d1974d$var$getDescriptions = (state)=>state.descriptions;
    const $1eef7de227d1974d$var$getCollectionDescriptionWithMeta = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getDescriptions, (_, { collectionUUID: collectionUUID })=>collectionUUID, (descriptions, collectionUUID)=>collectionUUID ? descriptions[collectionUUID] : undefined);
    const $1eef7de227d1974d$var$getCollectionDescription = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollectionDescriptionWithMeta, (descriptionWithMeta)=>descriptionWithMeta?.description);
    const $1eef7de227d1974d$var$getIsCollectionDescriptionLoading = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollectionDescriptionWithMeta, (descriptionWithMeta)=>!!descriptionWithMeta?.isLoading);
    const $1eef7de227d1974d$var$getCollectionDescriptionHasError = (0, (0, parcelRequire("6dDSs")).createSelector)($1eef7de227d1974d$var$getCollectionDescriptionWithMeta, (descriptionWithMeta)=>!!descriptionWithMeta?.error);
    const $1eef7de227d1974d$export$6cd28814d92fa9c9 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollection
    });
    const $1eef7de227d1974d$export$71661e51ce252508 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionName
    });
    const $1eef7de227d1974d$export$c35637e36ec6f8fd = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionEmoji
    });
    const $1eef7de227d1974d$export$3ddba651313f7cb0 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionJql
    });
    const $1eef7de227d1974d$export$4d3e73040770b6 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionViews
    });
    const $1eef7de227d1974d$export$6073e01a27128de4 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getIsCollectionLoading
    });
    const $1eef7de227d1974d$export$5a7fad0d58c5f5e2 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getError
    });
    const $1eef7de227d1974d$export$a864c959274a94b8 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$hasError
    });
    const $1eef7de227d1974d$export$794fd3b80c093caa = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionViewsOwnersIds
    });
    const $1eef7de227d1974d$export$61588707ea3d7293 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionView
    });
    const $1eef7de227d1974d$export$652691088e3ed5ff = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionViewTitle
    });
    const $1eef7de227d1974d$export$1a42c92187206222 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionViewsCount
    });
    const $1eef7de227d1974d$export$32becd83126d3e5b = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$hasFetchedCollectionViews
    });
    const $1eef7de227d1974d$export$333713f4878fc62d = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionOwnerId
    });
    const $1eef7de227d1974d$export$31549a29278f29ca = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionDescription
    });
    const $1eef7de227d1974d$export$627b89d60c64164a = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionProjectKeys
    });
    const $1eef7de227d1974d$export$e785641239dc5c88 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getProjectCollectionsCount
    });
    const $1eef7de227d1974d$export$d01e52f887fd0aef = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getIsCollectionDescriptionLoading
    });
    const $1eef7de227d1974d$export$d8d51044786d761 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1eef7de227d1974d$var$Store, {
        selector: $1eef7de227d1974d$var$getCollectionDescriptionHasError
    });
});
parcelRegister("74N90", function(module, exports) {
    $parcel$export(module.exports, "initialize", ()=>(parcelRequire("iKoRi")).initialize);
    $parcel$export(module.exports, "createCollection", ()=>(parcelRequire("iKoRi")).createCollection);
    $parcel$export(module.exports, "deleteCollection", ()=>(parcelRequire("iKoRi")).deleteCollection);
    $parcel$export(module.exports, "updateCollection", ()=>(parcelRequire("iKoRi")).updateCollection);
    $parcel$export(module.exports, "loadCollection", ()=>(parcelRequire("iKoRi")).loadCollection);
    $parcel$export(module.exports, "loadCollections", ()=>(parcelRequire("iKoRi")).loadCollections);
    $parcel$export(module.exports, "copyCollection", ()=>(parcelRequire("iKoRi")).copyCollection);
    $parcel$export(module.exports, "createView", ()=>(parcelRequire("2ejmj")).createView);
    $parcel$export(module.exports, "deleteView", ()=>(parcelRequire("2ejmj")).deleteView);
    $parcel$export(module.exports, "fetchCollectionsViewsCounts", ()=>(parcelRequire("2ejmj")).fetchCollectionsViewsCounts);
    $parcel$export(module.exports, "loadCollectionDescription", ()=>(parcelRequire("3WCAK")).loadCollectionDescription);
    $parcel$export(module.exports, "updateCollectionDescription", ()=>(parcelRequire("3WCAK")).updateCollectionDescription);
    var $iKoRi;
    var $2ejmj;
    var $3WCAK;
});
parcelRegister("iKoRi", function(module, exports) {
    $parcel$export(module.exports, "createCollection", ()=>$329c76ef83bcd303$export$c74125a8e3af6bb2);
    $parcel$export(module.exports, "initialize", ()=>$329c76ef83bcd303$export$2a47f398eeff8b01);
    $parcel$export(module.exports, "loadCollection", ()=>$329c76ef83bcd303$export$1f19ddbd9e78c2f5);
    $parcel$export(module.exports, "loadCollections", ()=>$329c76ef83bcd303$export$569b2ddb07e9ef58);
    $parcel$export(module.exports, "deleteCollection", ()=>$329c76ef83bcd303$export$3d16e031f6551662);
    $parcel$export(module.exports, "updateCollection", ()=>$329c76ef83bcd303$export$c0683150b517c317);
    $parcel$export(module.exports, "copyCollection", ()=>$329c76ef83bcd303$export$36928e43600c4b00);
    var $jcw0u;
    var $eiARp;
    var $jDD5V;
    var $1BW2P;
    var $1As78;
    var $8zOmE;
    var $dpYV0;
    var $8EJ2P;
    const $329c76ef83bcd303$export$c74125a8e3af6bb2 = ({ name: name, color: color, emoji: emoji, jql: jql, ownerId: ownerId, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState })=>{
            try {
                return await (0, (0, parcelRequire("jDD5V")).wrapWithExperience)((0, (0, parcelRequire("eiARp")).experience).collections.createCollection, async ()=>{
                    const newCollection = await (0, (0, parcelRequire("8EJ2P")).createCollection)({
                        name: name,
                        color: color,
                        emoji: emoji,
                        jql: jql
                    });
                    const state = getState();
                    setState({
                        collections: {
                            ...state.collections,
                            [newCollection.uuid]: {
                                data: {
                                    ...newCollection,
                                    ownerId: ownerId
                                }
                            }
                        }
                    });
                    const actionSubjectAndAction = 'collection created';
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction);
                    (0, (0, parcelRequire("1BW2P")).sendPendoTrackEvent)({
                        actionSubjectAndAction: actionSubjectAndAction
                    });
                    return newCollection;
                });
            } catch (error) {
                if (error instanceof Error) {
                    (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.error.createCollectionFailed', error));
                    throw error;
                }
            }
        };
    const $329c76ef83bcd303$export$2a47f398eeff8b01 = (collections)=>({ setState: setState })=>{
            setState({
                collections: collections.reduce((acc, collection)=>{
                    acc[collection.uuid] = {
                        data: collection
                    };
                    return acc;
                }, {}),
                isLoading: false,
                error: undefined
            });
        };
    const $329c76ef83bcd303$export$1f19ddbd9e78c2f5 = (collectionUUID, shouldIncludeViews)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            const existingCollection = state.collections[collectionUUID] || {
                data: undefined
            };
            if (existingCollection.isLoading || existingCollection.data?.views !== undefined) return;
            const loadExperience = shouldIncludeViews ? (0, (0, parcelRequire("eiARp")).experience).collections.loadCollectionViews : (0, (0, parcelRequire("eiARp")).experience).collections.loadCollection;
            try {
                await (0, (0, parcelRequire("jDD5V")).wrapWithExperience)(loadExperience, async ()=>{
                    setState({
                        collections: {
                            ...state.collections,
                            [collectionUUID]: {
                                ...existingCollection,
                                isLoading: true,
                                error: undefined
                            }
                        }
                    });
                    const newCollection = await (0, (0, parcelRequire("8EJ2P")).fetchCollection)(collectionUUID, shouldIncludeViews);
                    setState({
                        collections: {
                            ...state.collections,
                            [collectionUUID]: {
                                data: {
                                    ...existingCollection.data,
                                    ...newCollection
                                },
                                isLoading: false
                            }
                        }
                    });
                });
            } catch (error) {
                if (error instanceof Error) {
                    (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.error.collectionLoadingFailed', error));
                    setState({
                        collections: {
                            ...state.collections,
                            [collectionUUID]: {
                                ...existingCollection,
                                isLoading: false,
                                error: error
                            }
                        }
                    });
                }
            }
        };
    const $329c76ef83bcd303$export$569b2ddb07e9ef58 = ()=>async ({ setState: setState, dispatch: dispatch })=>{
            try {
                return await (0, (0, parcelRequire("jDD5V")).wrapWithExperience)((0, (0, parcelRequire("eiARp")).experience).collections.loadCollections, async ()=>{
                    setState({
                        collections: {},
                        isLoading: true
                    });
                    const collections = await (0, (0, parcelRequire("8EJ2P")).fetchAllCollections)();
                    dispatch($329c76ef83bcd303$export$2a47f398eeff8b01(collections));
                    return collections;
                });
            } catch (error) {
                if (error instanceof Error) {
                    (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.error.allCollectionsLoadingFailed', error));
                    setState({
                        isLoading: false,
                        error: error
                    });
                }
            }
            return undefined;
        };
    const $329c76ef83bcd303$export$3d16e031f6551662 = (collectionUUID)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            try {
                await (0, (0, parcelRequire("jDD5V")).wrapWithExperience)((0, (0, parcelRequire("eiARp")).experience).collections.deleteCollection, async ()=>{
                    const { [collectionUUID]: _, ...collections } = state.collections;
                    await (0, (0, parcelRequire("8EJ2P")).deleteCollection)(collectionUUID);
                    setState({
                        collections: collections
                    });
                });
            } catch (error) {
                if (error instanceof Error) (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.error.collectionDeletionFailed', error));
                throw error;
            }
        };
    const $329c76ef83bcd303$export$c0683150b517c317 = (collectionUUID, collection)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            const existingCollection = state.collections[collectionUUID];
            const data = existingCollection?.data;
            if (!data) return;
            try {
                await (0, (0, parcelRequire("jDD5V")).wrapWithExperience)((0, (0, parcelRequire("eiARp")).experience).collections.updateCollection, async ()=>{
                    const { name: name, color: color, emoji: emoji, projectKeys: projectKeys } = collection;
                    const updatedCollection = {
                        name: name || data.name,
                        color: 'color' in collection ? color : data.color,
                        emoji: 'emoji' in collection ? emoji : data.emoji,
                        jql: projectKeys ? (0, (0, parcelRequire("dpYV0")).getJQLForCollection)(projectKeys) : data.jql
                    };
                    await (0, (0, parcelRequire("8EJ2P")).updateCollection)(collectionUUID, updatedCollection);
                    setState({
                        collections: {
                            ...state.collections,
                            [collectionUUID]: {
                                ...existingCollection,
                                data: {
                                    ...data,
                                    ...updatedCollection
                                }
                            }
                        }
                    });
                });
            } catch (error) {
                if (error instanceof Error) (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.error.collectionUpdateFailed', error));
                throw error;
            }
        };
    const $329c76ef83bcd303$export$36928e43600c4b00 = (collectionUUID, newCollectionName, newCollectionOwnerId)=>async ({ setState: setState, getState: getState })=>{
            try {
                const state = getState();
                const collectionToCopy = state.collections[collectionUUID]?.data;
                if (!collectionToCopy || !newCollectionOwnerId) return;
                return await (0, (0, parcelRequire("jDD5V")).wrapWithExperience)((0, (0, parcelRequire("eiARp")).experience).collections.copyCollection, async ()=>{
                    const { uuid: uuid } = await (0, (0, parcelRequire("8EJ2P")).cloneCollection)(collectionUUID, newCollectionName);
                    setState({
                        collections: {
                            ...state.collections,
                            [uuid]: {
                                isLoading: false,
                                error: undefined,
                                data: {
                                    ...collectionToCopy,
                                    name: newCollectionName,
                                    ownerId: newCollectionOwnerId,
                                    uuid: uuid
                                }
                            }
                        }
                    });
                    return uuid;
                });
            } catch (error) {
                if (error instanceof Error) {
                    (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.error.copyCollectionFailed', error));
                    throw error;
                }
            }
        };
});
parcelRegister("eiARp", function(module, exports) {
    $parcel$export(module.exports, "experience", ()=>$197962e595787fdc$export$45794d16c9d83fe2);
    var $j7O7S;
    var $g4YUd;
    var $5aZmE;
    var $1vklt;
    var $hsleu;
    var $a6HzE;
    var $fL5Br;
    var $7fAfw;
    var $3BB7g;
    var $hZFBk;
    var $7OYCX;
    var $aLKMx;
    var $kKtJE;
    var $izXrc;
    var $fziiF;
    var $5vb9d;
    var $eP0jx;
    var $5jGaO;
    var $2fH9t;
    var $kCQpt;
    var $brO00;
    const $197962e595787fdc$export$45794d16c9d83fe2 = {
        listView: (0, parcelRequire("7OYCX")).default,
        formulaField: (0, parcelRequire("hsleu")).default,
        headerView: (0, parcelRequire("fL5Br")).default,
        boardView: (0, parcelRequire("j7O7S")).default,
        ideaView: (0, parcelRequire("3BB7g")).default,
        ideaViewBentoSidebar: (0, parcelRequire("7fAfw")).default,
        matrixView: (0, parcelRequire("aLKMx")).default,
        navBar: (0, parcelRequire("kKtJE")).default,
        project: (0, parcelRequire("eP0jx")).default,
        timelineView: (0, parcelRequire("2fH9t")).default,
        fieldsSidebar: (0, parcelRequire("1vklt")).default,
        issues: (0, parcelRequire("hZFBk")).default,
        deliveryItems: (0, parcelRequire("5aZmE")).default,
        sharing: (0, parcelRequire("5jGaO")).default,
        productAccess: (0, parcelRequire("5vb9d")).default,
        globalFieldsAdministration: (0, parcelRequire("a6HzE")).default,
        playSidepanel: (0, parcelRequire("fziiF")).default,
        noViewsScreen: (0, parcelRequire("izXrc")).default,
        view: (0, parcelRequire("brO00")).default,
        viewPermissions: (0, parcelRequire("kCQpt")).default,
        collections: (0, parcelRequire("g4YUd")).default
    };
});
parcelRegister("j7O7S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$713aabc44094d1be$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $713aabc44094d1be$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.board-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $713aabc44094d1be$var$scrollPerformance = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.board-view.scroll-performance', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom
    }));
    var $713aabc44094d1be$export$2e2bcd8739ae039 = {
        scrollPerformance: $713aabc44094d1be$var$scrollPerformance,
        pageSegmentLoad: $713aabc44094d1be$var$pageSegmentLoad
    };
});
parcelRegister("jDD5V", function(module, exports) {
    $parcel$export(module.exports, "createMarkedJpdExperience", ()=>$d337991d320bf50a$export$bffa5dc83c7b8f85);
    $parcel$export(module.exports, "createJpdExperience", ()=>$d337991d320bf50a$export$2510480a5584184);
    $parcel$export(module.exports, "wrapPromiseWithExperience", ()=>$d337991d320bf50a$export$745ef3600a4acb32);
    $parcel$export(module.exports, "wrapWithExperience", ()=>$d337991d320bf50a$export$9527dfc663dbb238);
    var $agVdz = parcelRequire("agVdz");
    var $jcw0u;
    var $jJZqs;
    var $fZneA;
    const $d337991d320bf50a$export$bffa5dc83c7b8f85 = (ufoExperience, marks)=>({
            ...$d337991d320bf50a$export$2510480a5584184(ufoExperience),
            marks: marks
        });
    const $d337991d320bf50a$var$handleReason = (handler, error)=>{
        if (error === undefined) {
            handler();
            return;
        }
        if (typeof error === 'object' && 'statusCode' in error && 'message' in error) {
            handler({
                metadata: {
                    error: `status: ${error.statusCode} message: ${error.message} name: ${error.name}`,
                    errors: 'errors' in error && Array.isArray(error.errors) ? error.errors.map((err)=>{
                        if (typeof err === 'string') return err;
                        if (typeof err === 'object' && err !== null && 'error' in err) return err.error;
                        return '';
                    }).join(', ') : undefined
                }
            });
            return;
        }
        if (error instanceof Error) {
            handler({
                metadata: {
                    error: error.message
                }
            });
            return;
        }
        if ((0, ($parcel$interopDefault($agVdz)))(error)) {
            handler({
                metadata: {
                    error: error
                }
            });
            return;
        }
        handler(error);
    };
    const $d337991d320bf50a$export$2510480a5584184 = (ufoExperience)=>({
            ufoExperience: ufoExperience,
            start: (startTime)=>{
                ufoExperience.start();
                if (startTime !== undefined) Object.assign(ufoExperience.metrics, {
                    ...ufoExperience.metrics,
                    startTime: startTime
                });
            },
            mark: (mark)=>{
                ufoExperience.mark(mark);
            },
            success: (meta, endTime)=>{
                ufoExperience.success(meta);
                if (endTime !== undefined) Object.assign(ufoExperience.metrics, {
                    ...ufoExperience.metrics,
                    endTime: endTime
                });
            },
            successWithReason: (reason)=>{
                $d337991d320bf50a$var$handleReason((meta)=>ufoExperience.success(meta), reason);
            },
            failure: (reason)=>{
                $d337991d320bf50a$var$handleReason((meta)=>ufoExperience.failure(meta), reason);
            },
            abort: (reason)=>{
                $d337991d320bf50a$var$handleReason((meta)=>ufoExperience.abort(meta), reason);
            }
        });
    const $d337991d320bf50a$export$745ef3600a4acb32 = (promise, experience, errorAnalyticsId)=>{
        experience.start();
        return promise.then((response)=>{
            experience.success();
            return response;
        }).catch((error)=>{
            if (errorAnalyticsId) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: errorAnalyticsId,
                    teamName: 'polaris'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            if ((0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) {
                experience.abort(error);
                throw error;
            }
            if ((0, (0, parcelRequire("jJZqs")).isValidationError)(error)) {
                experience.abort(error);
                throw error;
            }
            experience.failure(error);
            throw error;
        });
    };
    const $d337991d320bf50a$export$9527dfc663dbb238 = (experience, callback)=>{
        experience.start();
        return callback().then((result)=>{
            experience.success();
            return result;
        }).catch((error)=>{
            if ((0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) {
                experience.abort(error);
                throw error;
            }
            if (error instanceof Error) experience.failure(error);
            throw error;
        });
    };
});
parcelRegister("g4YUd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f47dfcedb9a9cd64$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $f47dfcedb9a9cd64$var$pageLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageLoad
    }));
    const $f47dfcedb9a9cd64$var$create = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.create', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadCollections = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.load-collections', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadViewCount = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.load-view-count', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadUsers = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.load-users', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadProjects = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.load-projects', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$createCollection = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.create-collection', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$copyCollection = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.copy-collection', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$deleteCollection = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.delete-collection', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$updateCollection = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.update-collection', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadCollection = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.load-collection', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadCollectionViews = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.load-collection-views', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadCollectionDescription = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.load-collection-description', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$updateCollectionDescription = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.update-collection-description', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$createView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.create-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$deleteView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.collections.delete-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $f47dfcedb9a9cd64$export$2e2bcd8739ae039 = {
        pageLoad: $f47dfcedb9a9cd64$var$pageLoad,
        create: $f47dfcedb9a9cd64$var$create,
        loadCollections: $f47dfcedb9a9cd64$var$loadCollections,
        loadViewCount: $f47dfcedb9a9cd64$var$loadViewCount,
        loadUsers: $f47dfcedb9a9cd64$var$loadUsers,
        loadProjects: $f47dfcedb9a9cd64$var$loadProjects,
        createCollection: $f47dfcedb9a9cd64$var$createCollection,
        copyCollection: $f47dfcedb9a9cd64$var$copyCollection,
        loadCollection: $f47dfcedb9a9cd64$var$loadCollection,
        loadCollectionViews: $f47dfcedb9a9cd64$var$loadCollectionViews,
        deleteCollection: $f47dfcedb9a9cd64$var$deleteCollection,
        updateCollection: $f47dfcedb9a9cd64$var$updateCollection,
        loadCollectionDescription: $f47dfcedb9a9cd64$var$loadCollectionDescription,
        updateCollectionDescription: $f47dfcedb9a9cd64$var$updateCollectionDescription,
        createView: $f47dfcedb9a9cd64$var$createView,
        deleteView: $f47dfcedb9a9cd64$var$deleteView
    };
});
parcelRegister("5aZmE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8039a4f9b6c69dfe$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $8039a4f9b6c69dfe$var$loadChildIssues = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.delivery-items.load.childIssues', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8039a4f9b6c69dfe$var$loadAggregatedDeliveryProgressBasedOnProjectId = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.delivery-items.load.aggregatedDeliveryProgressBasedOnProjectId', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8039a4f9b6c69dfe$var$loadAggregatedDeliveryProgress = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.delivery-items.load.aggregatedDeliveryProgress', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8039a4f9b6c69dfe$var$loadLinkedDeliveryTickets = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.delivery-items.load.linkedDeliveryTickets', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8039a4f9b6c69dfe$var$loadTransitiveChildrenArjHierarchy = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.delivery-items.load.transitiveChildrenArjHierarchy', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8039a4f9b6c69dfe$var$loadTransitiveChildrenInTwoLevelCoreHierarchy = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.delivery-items.load.transitiveChildrenInTwoLevelCoreHierarchy', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $8039a4f9b6c69dfe$export$2e2bcd8739ae039 = {
        loadChildIssues: $8039a4f9b6c69dfe$var$loadChildIssues,
        loadAggregatedDeliveryProgressBasedOnProjectId: $8039a4f9b6c69dfe$var$loadAggregatedDeliveryProgressBasedOnProjectId,
        loadAggregatedDeliveryProgress: $8039a4f9b6c69dfe$var$loadAggregatedDeliveryProgress,
        loadLinkedDeliveryTickets: $8039a4f9b6c69dfe$var$loadLinkedDeliveryTickets,
        loadTransitiveChildrenArjHierarchy: $8039a4f9b6c69dfe$var$loadTransitiveChildrenArjHierarchy,
        loadTransitiveChildrenInTwoLevelCoreHierarchy: $8039a4f9b6c69dfe$var$loadTransitiveChildrenInTwoLevelCoreHierarchy
    };
});
parcelRegister("1vklt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5dea1a79ad34e84c$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $5dea1a79ad34e84c$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.fields-sidebar.load', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $5dea1a79ad34e84c$var$fieldToggle = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.fields-sidebar.field-toggle', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $5dea1a79ad34e84c$var$fieldHide = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.fields-sidebar.field-hide', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $5dea1a79ad34e84c$var$fieldDelete = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.fields-sidebar.field-delete', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $5dea1a79ad34e84c$var$fieldRegularCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.fields-sidebar.field-regular-create', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $5dea1a79ad34e84c$var$fieldFormulaCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.fields-sidebar.field-formula-create', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $5dea1a79ad34e84c$var$fieldPlayCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.fields-sidebar.field-play-create', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $5dea1a79ad34e84c$var$fieldConfigurationUpdate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.fields-sidebar.field-configuration-update', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $5dea1a79ad34e84c$export$2e2bcd8739ae039 = {
        fieldToggle: $5dea1a79ad34e84c$var$fieldToggle,
        fieldHide: $5dea1a79ad34e84c$var$fieldHide,
        fieldDelete: $5dea1a79ad34e84c$var$fieldDelete,
        fieldRegularCreate: $5dea1a79ad34e84c$var$fieldRegularCreate,
        fieldFormulaCreate: $5dea1a79ad34e84c$var$fieldFormulaCreate,
        fieldPlayCreate: $5dea1a79ad34e84c$var$fieldPlayCreate,
        fieldConfigurationUpdate: $5dea1a79ad34e84c$var$fieldConfigurationUpdate,
        pageSegmentLoad: $5dea1a79ad34e84c$var$pageSegmentLoad
    };
});
parcelRegister("hsleu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ada778994f5f2fe$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $6ada778994f5f2fe$var$precalculateFormulaFieldAllValuesSelector = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.formula-field.precalculate-all-values-selector', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $6ada778994f5f2fe$export$2e2bcd8739ae039 = {
        precalculateFormulaFieldAllValuesSelector: $6ada778994f5f2fe$var$precalculateFormulaFieldAllValuesSelector
    };
});
parcelRegister("a6HzE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43bb153204899b03$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $43bb153204899b03$var$globalFieldCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.field-create', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldDelete = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.field-delete', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldAssociate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.field-associate', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldUnassociate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.field-unassociate', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldCheckViewsUsage = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.field-check-views-usage', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldUpdate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.field-update', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldUpdateConfig = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.field-update-config', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldCheckProjectUsage = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.field-check-project-usage', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$loadGlobalFields = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.load-fields', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$loadGlobalLabels = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.load-global-labels', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$loadJpdProjects = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.load-jpd-projects', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$loadProjectsWithField = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.load-projects-with-field', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$fieldAddOptions = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.field-add-options', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$fieldDeleteOption = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.field-delete-option', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$fieldRenameOption = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.field-rename-option', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$fieldMoveOptions = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.field-move-options', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$copyValues = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global-fields-administration.copy-values', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $43bb153204899b03$export$2e2bcd8739ae039 = {
        globalFieldCreate: $43bb153204899b03$var$globalFieldCreate,
        globalFieldDelete: $43bb153204899b03$var$globalFieldDelete,
        globalFieldAssociate: $43bb153204899b03$var$globalFieldAssociate,
        globalFieldUnassociate: $43bb153204899b03$var$globalFieldUnassociate,
        globalFieldCheckViewsUsage: $43bb153204899b03$var$globalFieldCheckViewsUsage,
        globalFieldUpdate: $43bb153204899b03$var$globalFieldUpdate,
        globalFieldUpdateConfig: $43bb153204899b03$var$globalFieldUpdateConfig,
        globalFieldCheckProjectUsage: $43bb153204899b03$var$globalFieldCheckProjectUsage,
        loadGlobalFields: $43bb153204899b03$var$loadGlobalFields,
        loadGlobalLabels: $43bb153204899b03$var$loadGlobalLabels,
        loadJpdProjects: $43bb153204899b03$var$loadJpdProjects,
        loadProjectsWithField: $43bb153204899b03$var$loadProjectsWithField,
        fieldAddOptions: $43bb153204899b03$var$fieldAddOptions,
        fieldDeleteOption: $43bb153204899b03$var$fieldDeleteOption,
        fieldRenameOption: $43bb153204899b03$var$fieldRenameOption,
        fieldMoveOptions: $43bb153204899b03$var$fieldMoveOptions,
        copyValues: $43bb153204899b03$var$copyValues
    };
});
parcelRegister("fL5Br", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db9a3be9cda48e16$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $db9a3be9cda48e16$var$updateViewDescription = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.header-view.update-view-description', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $db9a3be9cda48e16$var$viewGroupBy = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.header-view.view-group-by', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $db9a3be9cda48e16$var$viewSort = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.header-view.view-sort', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $db9a3be9cda48e16$var$viewFilter = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.header-view.view-filter', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $db9a3be9cda48e16$export$2e2bcd8739ae039 = {
        updateViewDescription: $db9a3be9cda48e16$var$updateViewDescription,
        viewGroupBy: $db9a3be9cda48e16$var$viewGroupBy,
        viewSort: $db9a3be9cda48e16$var$viewSort,
        viewFilter: $db9a3be9cda48e16$var$viewFilter
    };
});
parcelRegister("7fAfw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed8cbb8d1e75d594$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $ed8cbb8d1e75d594$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.idea-view-bento-sidebar', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    var $ed8cbb8d1e75d594$export$2e2bcd8739ae039 = {
        pageSegmentLoad: $ed8cbb8d1e75d594$var$pageSegmentLoad
    };
});
parcelRegister("3BB7g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa811d79693859dc$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $aa811d79693859dc$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.idea-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $aa811d79693859dc$var$directPageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.idea-view-direct', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $aa811d79693859dc$var$summaryUpdate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.idea-view.summary-update', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$descriptionUpdate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.idea-view.description-update', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$deliveryTicketCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.idea-view.delivery-ticket-create', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$commentCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.idea-view.comment-create', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$insightCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.idea-view.insight-create', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$issueLinkCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.idea-view.issue-link-create', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$commentsSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.idea-view.comments', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $aa811d79693859dc$var$insightsSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.idea-view.insights', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $aa811d79693859dc$var$fileAttach = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.idea-view.attach-file', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$makeFieldUpdate = ()=>(0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.idea-view.field-update', {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
        }));
    var $aa811d79693859dc$export$2e2bcd8739ae039 = {
        pageSegmentLoad: $aa811d79693859dc$var$pageSegmentLoad,
        directPageSegmentLoad: $aa811d79693859dc$var$directPageSegmentLoad,
        summaryUpdate: $aa811d79693859dc$var$summaryUpdate,
        descriptionUpdate: $aa811d79693859dc$var$descriptionUpdate,
        deliveryTicketCreate: $aa811d79693859dc$var$deliveryTicketCreate,
        commentCreate: $aa811d79693859dc$var$commentCreate,
        insightCreate: $aa811d79693859dc$var$insightCreate,
        issueLinkCreate: $aa811d79693859dc$var$issueLinkCreate,
        commentsSegmentLoad: $aa811d79693859dc$var$commentsSegmentLoad,
        insightsSegmentLoad: $aa811d79693859dc$var$insightsSegmentLoad,
        fileAttach: $aa811d79693859dc$var$fileAttach,
        makeFieldUpdate: $aa811d79693859dc$var$makeFieldUpdate
    };
});
parcelRegister("hZFBk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93f260704cbd9bf2$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $93f260704cbd9bf2$var$loadIssuesRestBatched = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.issues.load.rest-batched', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$loadIssueRest = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.issue.load.rest', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$loadIssuesJpdApi = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.issues.load.jpd-api', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$loadIssueJpdApi = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.issue.load.jpd-api', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$loadIssuesRanksRestBatched = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.issues.ranks.load.rest-batched', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$loadIssuesRanksJpdApi = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.issues.ranks.load.jpd-api', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$rankIssue = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.issue.rank', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$loadIssuePickerIssuesRest = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.issue-picker.load', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$globalJpdIssueCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.global.jpd.create-issue', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $93f260704cbd9bf2$export$2e2bcd8739ae039 = {
        loadIssuesRanksRestBatched: $93f260704cbd9bf2$var$loadIssuesRanksRestBatched,
        loadIssuesRanksJpdApi: $93f260704cbd9bf2$var$loadIssuesRanksJpdApi,
        loadIssuesRestBatched: $93f260704cbd9bf2$var$loadIssuesRestBatched,
        loadIssuesJpdApi: $93f260704cbd9bf2$var$loadIssuesJpdApi,
        loadIssueJpdApi: $93f260704cbd9bf2$var$loadIssueJpdApi,
        loadIssueRest: $93f260704cbd9bf2$var$loadIssueRest,
        rankIssue: $93f260704cbd9bf2$var$rankIssue,
        loadIssuePickerIssuesRest: $93f260704cbd9bf2$var$loadIssuePickerIssuesRest,
        globalJpdIssueCreate: $93f260704cbd9bf2$var$globalJpdIssueCreate
    };
});
parcelRegister("7OYCX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b79ce5313c591e2$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $9b79ce5313c591e2$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.list-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $9b79ce5313c591e2$var$createIdeaInline = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.list-view.create-idea-inline', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $9b79ce5313c591e2$var$createIdeaInlineClickResponse = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.list-view.create-idea-inline-button-click', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom
    }));
    const $9b79ce5313c591e2$var$changeViewName = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.list-view.change-view-name', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $9b79ce5313c591e2$var$listScrollPerformance = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.list-view.scroll-performance', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom
    }));
    const $9b79ce5313c591e2$var$makeFieldUpdate = ()=>(0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.list-view.field-update', {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
            timings: [
                {
                    key: 'internal_state',
                    endMark: 'backend_request_start'
                },
                {
                    key: 'backend_request',
                    startMark: 'backend_request_start'
                }
            ]
        }));
    var $9b79ce5313c591e2$export$2e2bcd8739ae039 = {
        changeViewName: $9b79ce5313c591e2$var$changeViewName,
        createIdeaInline: $9b79ce5313c591e2$var$createIdeaInline,
        createIdeaInlineClickResponse: $9b79ce5313c591e2$var$createIdeaInlineClickResponse,
        listScrollPerformance: $9b79ce5313c591e2$var$listScrollPerformance,
        pageSegmentLoad: $9b79ce5313c591e2$var$pageSegmentLoad,
        makeFieldUpdate: $9b79ce5313c591e2$var$makeFieldUpdate
    };
});
parcelRegister("aLKMx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3e34426082afc38$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $c3e34426082afc38$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.matrix-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    var $c3e34426082afc38$export$2e2bcd8739ae039 = {
        pageSegmentLoad: $c3e34426082afc38$var$pageSegmentLoad
    };
});
parcelRegister("kKtJE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30ef3794d6f0e57e$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $30ef3794d6f0e57e$var$changeViewName = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.nav-bar.change-view-name', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $30ef3794d6f0e57e$var$changeViewRank = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.nav-bar.change-view-rank', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $30ef3794d6f0e57e$var$createView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.nav-bar.create-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $30ef3794d6f0e57e$export$2e2bcd8739ae039 = {
        changeViewName: $30ef3794d6f0e57e$var$changeViewName,
        changeViewRank: $30ef3794d6f0e57e$var$changeViewRank,
        createView: $30ef3794d6f0e57e$var$createView
    };
});
parcelRegister("izXrc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2aec2d2eb41963e$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $c2aec2d2eb41963e$var$createView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.no-views-screen.create-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $c2aec2d2eb41963e$export$2e2bcd8739ae039 = {
        createView: $c2aec2d2eb41963e$var$createView
    };
});
parcelRegister("fziiF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$971b7c6c0f6a6248$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $971b7c6c0f6a6248$var$updatePlayField = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.play-sidepanel.field-update', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $971b7c6c0f6a6248$export$2e2bcd8739ae039 = {
        updatePlayField: $971b7c6c0f6a6248$var$updatePlayField
    };
});
parcelRegister("5vb9d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$54872f75c13964ef$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $54872f75c13964ef$var$loadSharingConfig = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.product-access.load-publish-config', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $54872f75c13964ef$var$updateSharingConfig = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.product-access.update-publish-config', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $54872f75c13964ef$export$2e2bcd8739ae039 = {
        loadSharingConfig: $54872f75c13964ef$var$loadSharingConfig,
        updateSharingConfig: $54872f75c13964ef$var$updateSharingConfig
    };
});
parcelRegister("eP0jx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9663d0cc0faff39$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $f9663d0cc0faff39$var$applyTemplateMarks = {
        APPLY_TEMPLATE_POLLING_START_MARK: 'apply_template_polling_start',
        APPLY_TEMPLATE_POLLING_STOP_MARK: 'apply_template_polling_stop'
    };
    const $f9663d0cc0faff39$var$pageLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.project', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageLoad
    }));
    const $f9663d0cc0faff39$var$pageLoadWithRateLimit = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.project.rate-limit', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageLoad
    }));
    const $f9663d0cc0faff39$var$applyTemplate = (0, (0, parcelRequire("jDD5V")).createMarkedJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.project.apply-template', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        featureFlags: [
            'polaris.project.creation.template'
        ],
        timings: [
            {
                key: 'apply_template_polling',
                startMark: $f9663d0cc0faff39$var$applyTemplateMarks.APPLY_TEMPLATE_POLLING_START_MARK,
                endMark: $f9663d0cc0faff39$var$applyTemplateMarks.APPLY_TEMPLATE_POLLING_STOP_MARK
            }
        ]
    }), $f9663d0cc0faff39$var$applyTemplateMarks);
    const $f9663d0cc0faff39$var$create = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.project.create', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $f9663d0cc0faff39$export$2e2bcd8739ae039 = {
        pageLoad: $f9663d0cc0faff39$var$pageLoad,
        pageLoadWithRateLimit: $f9663d0cc0faff39$var$pageLoadWithRateLimit,
        applyTemplate: $f9663d0cc0faff39$var$applyTemplate,
        create: $f9663d0cc0faff39$var$create
    };
});
parcelRegister("5jGaO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8256c1be52a9ff31$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $8256c1be52a9ff31$var$dialogLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.shared.control-dialog-load', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $8256c1be52a9ff31$var$loadStakeholders = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.shared.load-stakeholders', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8256c1be52a9ff31$var$addStakeholders = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.shared.add-stakeholders', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8256c1be52a9ff31$var$removeStakeholders = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.shared.remove-stakeholders', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8256c1be52a9ff31$var$loadSettings = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.shared.load-settings', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8256c1be52a9ff31$var$updateSettings = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.shared.update-settings', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8256c1be52a9ff31$var$loadSiteConfig = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.shared.load-site-config', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8256c1be52a9ff31$var$loadSitePublicSharingConfig = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.shared.load-site-public-sharing-config', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $8256c1be52a9ff31$export$2e2bcd8739ae039 = {
        dialogLoad: $8256c1be52a9ff31$var$dialogLoad,
        loadStakeholders: $8256c1be52a9ff31$var$loadStakeholders,
        addStakeholders: $8256c1be52a9ff31$var$addStakeholders,
        removeStakeholders: $8256c1be52a9ff31$var$removeStakeholders,
        loadSettings: $8256c1be52a9ff31$var$loadSettings,
        updateSettings: $8256c1be52a9ff31$var$updateSettings,
        loadSiteConfig: $8256c1be52a9ff31$var$loadSiteConfig,
        loadSitePublicSharingConfig: $8256c1be52a9ff31$var$loadSitePublicSharingConfig
    };
});
parcelRegister("2fH9t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4089a9b61ccedd94$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $4089a9b61ccedd94$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.timeline-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    var $4089a9b61ccedd94$export$2e2bcd8739ae039 = {
        pageSegmentLoad: $4089a9b61ccedd94$var$pageSegmentLoad
    };
});
parcelRegister("kCQpt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$28eb3963187c0ff9$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $28eb3963187c0ff9$var$openDialog = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.view-permissions.open-dialog', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $28eb3963187c0ff9$var$loadViewAccess = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.view-permissions.load-view-access', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $28eb3963187c0ff9$var$updateViewAccess = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.view-permissions.update-view-access', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $28eb3963187c0ff9$var$updatePrincipals = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.view-permissions.update-principals', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $28eb3963187c0ff9$var$loadCurrentUserViewPermissions = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.view-permissions.load-current-user-view-permissions', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    var $28eb3963187c0ff9$export$2e2bcd8739ae039 = {
        openDialog: $28eb3963187c0ff9$var$openDialog,
        loadViewAccess: $28eb3963187c0ff9$var$loadViewAccess,
        updateViewAccess: $28eb3963187c0ff9$var$updateViewAccess,
        updatePrincipals: $28eb3963187c0ff9$var$updatePrincipals,
        loadCurrentUserViewPermissions: $28eb3963187c0ff9$var$loadCurrentUserViewPermissions
    };
});
parcelRegister("brO00", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b36fcf167fca27fa$export$2e2bcd8739ae039);
    var $atdLB;
    var $duUGa;
    var $jDD5V;
    const $b36fcf167fca27fa$var$getView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.view.get-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $b36fcf167fca27fa$var$updateView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.view.update-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $b36fcf167fca27fa$var$deleteView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.view.delete-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    }));
    const $b36fcf167fca27fa$var$makeGenericIssueFieldUpdate = ()=>(0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.issue-update.field', {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
            timings: [
                {
                    key: 'internal_state',
                    endMark: 'backend_request_start'
                },
                {
                    key: 'backend_request',
                    startMark: 'backend_request_start'
                }
            ]
        }));
    const $b36fcf167fca27fa$var$updateIssueFields = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("duUGa")).UFOExperience)('jpd.issue-update.fields', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        timings: [
            {
                key: 'internal_state',
                endMark: 'backend_request_start'
            },
            {
                key: 'backend_request',
                startMark: 'backend_request_start'
            }
        ]
    }));
    var $b36fcf167fca27fa$export$2e2bcd8739ae039 = {
        getView: $b36fcf167fca27fa$var$getView,
        updateView: $b36fcf167fca27fa$var$updateView,
        deleteView: $b36fcf167fca27fa$var$deleteView,
        makeGenericIssueFieldUpdate: $b36fcf167fca27fa$var$makeGenericIssueFieldUpdate,
        updateIssueFields: $b36fcf167fca27fa$var$updateIssueFields
    };
});
parcelRegister("1BW2P", function(module, exports) {
    $parcel$export(module.exports, "sendPendoTrackEvent", ()=>$76c604c1de726c59$export$c6da4636619f7369);
    $parcel$export(module.exports, "updatePendoVisitorOptions", ()=>$76c604c1de726c59$export$862313c5bc1d6788);
    var $4Jd69;
    const $76c604c1de726c59$var$QUEUE_LIMIT = 50;
    let $76c604c1de726c59$var$queue = [];
    const $76c604c1de726c59$var$waitForPendoReadiness = ()=>{
        if (false) return;
        const interval = setInterval(()=>{
            if ((0, (0, parcelRequire("4Jd69")).isPendoReady)()) {
                $76c604c1de726c59$var$queue.forEach(([event, attributes])=>window?.pendo?.track(event, attributes));
                $76c604c1de726c59$var$queue = [];
                clearInterval(interval);
            }
        }, 1000);
    };
    function $76c604c1de726c59$export$c6da4636619f7369(event, properties) {
        let pendoEvent;
        let attributes;
        if (typeof event === 'string') {
            pendoEvent = event;
            attributes = properties;
        } else {
            const fullEvent = [
                event.source,
                event.actionSubjectAndAction,
                event.actionSubjectId
            ].filter((part)=>part !== undefined).join(' - ');
            pendoEvent = fullEvent;
            attributes = event.attributes;
        }
        try {
            if ((0, (0, parcelRequire("4Jd69")).isPendoReady)()) window.pendo.track(pendoEvent, attributes);
            else {
                $76c604c1de726c59$var$queue.length < $76c604c1de726c59$var$QUEUE_LIMIT && $76c604c1de726c59$var$queue.push([
                    pendoEvent,
                    attributes
                ]);
                $76c604c1de726c59$var$waitForPendoReadiness();
            }
        } catch (err) {
            (0, (0, parcelRequire("4Jd69")).logError)('pendoTrackEvent', err);
        }
    }
    const $76c604c1de726c59$export$862313c5bc1d6788 = (metadata)=>{
        try {
            if ((0, (0, parcelRequire("4Jd69")).isPendoReady)()) window.pendo.updateOptions(metadata);
        } catch (err) {
            (0, (0, parcelRequire("4Jd69")).logError)('pendoUpdateOptions', err);
        }
    };
});
parcelRegister("4Jd69", function(module, exports) {
    $parcel$export(module.exports, "logError", ()=>$a4ab8bc78cddcb09$export$58da9968c3170cb1);
    $parcel$export(module.exports, "isPendoReady", ()=>$a4ab8bc78cddcb09$export$3f386d356f8c718f);
    var $dJl1T;
    var $jcw0u;
    const $a4ab8bc78cddcb09$export$58da9968c3170cb1 = (errorSubject, error)=>{
        const ERROR_ID = 'polaris-error';
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: ERROR_ID,
                teamName: 'polaris'
            },
            attributes: {
                subject: errorSubject
            },
            error: error
        });
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(`${ERROR_ID}.${errorSubject}`, error.message, error);
    };
    const $a4ab8bc78cddcb09$export$3f386d356f8c718f = ()=>window?.pendo?.isReady && typeof window.pendo.isReady === 'function' && window.pendo.isReady();
});
parcelRegister("1As78", function(module, exports) {
    $parcel$export(module.exports, "createErrorAnalytics", ()=>$7cf658edd2cdbf14$export$9841879b4fea885b);
    $parcel$export(module.exports, "useErrorHandlers", ()=>$7cf658edd2cdbf14$export$e0b4869c7401cacb);
    $parcel$export(module.exports, "useOnCyclicFormulaFieldError", ()=>$7cf658edd2cdbf14$export$4e01d30cacaf82b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nnPp;
    var $lj8SI;
    var $jcw0u;
    var $koVbs;
    var $eW55R;
    var $lH8Ty;
    var $l6caf;
    var $aiePb;
    const $7cf658edd2cdbf14$export$9841879b4fea885b = (id, error)=>({
            meta: {
                id: id
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    const $7cf658edd2cdbf14$var$handleCallback = (errorObject, callback)=>{
        callback && callback((0, (0, parcelRequire("aiePb")).getMetadata)(errorObject));
    };
    const $7cf658edd2cdbf14$var$useGeneralDataLoadingFailedHandling = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { errorWithRefresh: errorWithRefresh } = (0, (0, parcelRequire("eW55R")).useNotifications)();
        return (0, $5uXOq.useCallback)((errorObject, callback)=>{
            $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
            errorWithRefresh({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).errorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).serverLoadFailedDescription)
            });
            (0, (0, parcelRequire("jcw0u")).default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalDataLoadingFailed', errorObject));
        }, [
            errorWithRefresh,
            formatMessage
        ]);
    };
    const $7cf658edd2cdbf14$var$useGeneralDataUpdateFailedHandling = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { error: error, errorWithRefresh: errorWithRefresh, customFlag: customFlag } = (0, (0, parcelRequire("eW55R")).useNotifications)();
        return (0, $5uXOq.useCallback)((errorObject, callback)=>{
            $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
            (0, (0, parcelRequire("jcw0u")).default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalDataUpdateFailed', errorObject));
            const entityLimitError = (0, (0, parcelRequire("lH8Ty")).getEntityLimitError)(errorObject);
            if (entityLimitError) {
                const errorMessage = (0, (0, parcelRequire("lH8Ty")).getErrorMessageDescriptor)(entityLimitError);
                return errorMessage ? customFlag({
                    title: formatMessage((0, (0, parcelRequire("l6caf")).default).entityLimitErrorTitle),
                    description: formatMessage(errorMessage, {
                        item: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, chunks)
                    }),
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                        label: "Error",
                        primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
                    })
                }) : null;
            }
            if ((0, (0, parcelRequire("aiePb")).isPermissionError)(errorObject)) return error({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).errorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).permissionErrorDescription)
            });
            if ((0, (0, parcelRequire("aiePb")).isConfigError)(errorObject)) return error({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).configErrorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).configErrorDescription)
            });
            errorWithRefresh({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).errorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).serverUpdateFailedDescription)
            });
        }, [
            customFlag,
            error,
            errorWithRefresh,
            formatMessage
        ]);
    };
    const $7cf658edd2cdbf14$var$useGeneralActionFailedHandling = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { errorWithRefresh: errorWithRefresh } = (0, (0, parcelRequire("eW55R")).useNotifications)();
        return (0, $5uXOq.useCallback)((errorObject, callback)=>{
            $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
            errorWithRefresh({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).errorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).errorDescription)
            });
            (0, (0, parcelRequire("jcw0u")).default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
        }, [
            errorWithRefresh,
            formatMessage
        ]);
    };
    const $7cf658edd2cdbf14$var$usePossibleAccessLossError = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { errorWithRefresh: errorWithRefresh } = (0, (0, parcelRequire("eW55R")).useNotifications)();
        return (0, $5uXOq.useCallback)((errorObject, callback)=>{
            $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
            errorWithRefresh({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).errorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).errorPossibleAccessLoss)
            });
            (0, (0, parcelRequire("jcw0u")).default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
        }, [
            errorWithRefresh,
            formatMessage
        ]);
    };
    const $7cf658edd2cdbf14$export$e0b4869c7401cacb = ()=>{
        const possibleAccessLossError = $7cf658edd2cdbf14$var$usePossibleAccessLossError();
        const generalActionFailedError = $7cf658edd2cdbf14$var$useGeneralActionFailedHandling();
        const generalDataUpdateFailedError = $7cf658edd2cdbf14$var$useGeneralDataUpdateFailedHandling();
        const generalDataLoadingFailedError = $7cf658edd2cdbf14$var$useGeneralDataLoadingFailedHandling();
        return (0, $5uXOq.useMemo)(()=>({
                possibleAccessLossError: possibleAccessLossError,
                generalActionFailedError: generalActionFailedError,
                generalDataUpdateFailedError: generalDataUpdateFailedError,
                generalDataLoadingFailedError: generalDataLoadingFailedError
            }), [
            possibleAccessLossError,
            generalActionFailedError,
            generalDataUpdateFailedError,
            generalDataLoadingFailedError
        ]);
    };
    const $7cf658edd2cdbf14$export$4e01d30cacaf82b8 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { error: error } = (0, (0, parcelRequire("eW55R")).useNotifications)();
        return (0, $5uXOq.useCallback)((fieldLabels)=>{
            error({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).errorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).cyclicFormulaFieldDescription, {
                    fieldLabels: fieldLabels.join(', ')
                })
            });
            (0, (0, parcelRequire("jcw0u")).default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.cyclicFormula', new Error('Cyclic formula field')));
        }, [
            error,
            formatMessage
        ]);
    };
});
parcelRegister("eW55R", function(module, exports) {
    $parcel$export(module.exports, "useNotifications", ()=>$3e7591c0992d0e62$export$53d5ca6c3f53e109);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $btivG;
    var $7nnPp;
    var $7R4eB;
    var $d4xRU;
    var $7HGHK;
    var $pa9q9;
    const $3e7591c0992d0e62$var$customFlagCommon = (notification, onDismiss, AkFlagComponent)=>{
        const id = (0, ($parcel$interopDefault($7Jxgt)))();
        return {
            id: id,
            render: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(AkFlagComponent, {
                    id: id,
                    ...notification,
                    onDismissed: (flagId)=>onDismiss(flagId),
                    ...props
                })
        };
    };
    const $3e7591c0992d0e62$var$customFlag = (notification, onDismiss)=>$3e7591c0992d0e62$var$customFlagCommon(notification, onDismiss, (0, (0, parcelRequire("d4xRU")).default));
    const $3e7591c0992d0e62$var$customAutoDismissFlag = (notification, onDismiss)=>$3e7591c0992d0e62$var$customFlagCommon(notification, onDismiss, (0, (0, parcelRequire("7R4eB")).default));
    const $3e7591c0992d0e62$var$success = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
            title: notification.title,
            description: notification.description,
            actions: notification.actions?.map((action, index)=>({
                    ...action,
                    testId: `polaris.nofitication.success.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
                })),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("btivG"))))), {
                label: "Success icon",
                primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
            }),
            appearance: 'normal',
            testId: 'polaris-lib-notifications.controllers.notification.success'
        }, onDismiss);
    const $3e7591c0992d0e62$var$errorWithRefresh = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
            title: notification.title,
            description: notification.description,
            actions: [
                ...notification.actions || [],
                {
                    content: 'Refresh',
                    testId: 'refresh',
                    onClick: ()=>window.location.reload()
                }
            ].map((action, index)=>({
                    ...action,
                    testId: `polaris.nofitication.error-refresh.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
                })),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                label: "Error",
                primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
            }),
            appearance: 'normal',
            testId: 'polaris-lib-notifications.controllers.notification.error-refresh'
        }, onDismiss);
    const $3e7591c0992d0e62$var$error = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
            title: notification.title,
            description: notification.description,
            actions: notification.actions?.map((action, index)=>({
                    ...action,
                    testId: `polaris.nofitication.error.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
                })),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                label: "Error",
                primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
            }),
            appearance: 'normal',
            testId: 'polaris-lib-notifications.controllers.notification.error'
        }, onDismiss);
    const $3e7591c0992d0e62$export$53d5ca6c3f53e109 = ()=>{
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        return (0, $5uXOq.useMemo)(()=>({
                customFlag: (notification)=>{
                    const flagId = showFlag($3e7591c0992d0e62$var$customFlag(notification, dismissFlag));
                    return ()=>dismissFlag(flagId);
                },
                success: (notification)=>{
                    const flagId = showFlag($3e7591c0992d0e62$var$success(notification, dismissFlag));
                    return ()=>dismissFlag(flagId);
                },
                errorWithRefresh: (notification)=>{
                    const flagId = showFlag($3e7591c0992d0e62$var$errorWithRefresh(notification, dismissFlag));
                    return ()=>dismissFlag(flagId);
                },
                error: (notification)=>{
                    const flagId = showFlag($3e7591c0992d0e62$var$error(notification, dismissFlag));
                    return ()=>dismissFlag(flagId);
                },
                showFlag: (flag)=>{
                    const id = flag.id !== undefined ? flag.id : (0, (0, parcelRequire("7HGHK")).toFlagId)((0, ($parcel$interopDefault($7Jxgt)))());
                    const flagId = showFlag({
                        ...flag,
                        id: id,
                        key: id
                    });
                    return ()=>dismissFlag(flagId);
                },
                showCustomFlag: (flag)=>{
                    const id = flag.id !== undefined ? flag.id : (0, (0, parcelRequire("7HGHK")).toFlagId)((0, ($parcel$interopDefault($7Jxgt)))());
                    const flagId = showFlag({
                        ...flag,
                        id: id
                    });
                    return ()=>dismissFlag(flagId);
                },
                dismissFlag: dismissFlag
            }), [
            showFlag,
            dismissFlag
        ]);
    };
});
parcelRegister("lH8Ty", function(module, exports) {
    $parcel$export(module.exports, "EntityLimitError", ()=>$bbaa521f44d79b10$export$c4e01b2c2ba95919);
    $parcel$export(module.exports, "getEntityLimitError", ()=>$bbaa521f44d79b10$export$13f6f9a6b905ebbd);
    $parcel$export(module.exports, "getErrorMessageDescriptor", ()=>$bbaa521f44d79b10$export$cf58cbb2768ea4f);
    var $e3a3O;
    var $ht021;
    var $j7a90;
    var $lTDxG;
    class $bbaa521f44d79b10$export$c4e01b2c2ba95919 extends (0, (0, parcelRequire("ht021")).default) {
        constructor(message, errors = [], statusCode = null, type){
            super(message, {
                cause: errors[0]
            }), this.name = 'EntityLimitError';
            this.errors = errors;
            this.statusCode = statusCode;
            this.type = type;
        }
    }
    const $bbaa521f44d79b10$export$13f6f9a6b905ebbd = (error)=>{
        if (error instanceof $bbaa521f44d79b10$export$c4e01b2c2ba95919) return error;
        if (!(error instanceof (0, (0, parcelRequire("e3a3O")).ApolloError))) return null;
        const entityLimitError = error.graphQLErrors?.filter((err)=>err.extensions?.limitType)[0];
        if (!entityLimitError?.extensions) return null;
        const { statusCode: statusCode, limitType: limitType } = entityLimitError.extensions;
        const entityLimitErrorType = (0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE)[limitType];
        return new $bbaa521f44d79b10$export$c4e01b2c2ba95919(entityLimitError.message, [
            {
                error: entityLimitError.message
            }
        ], statusCode, entityLimitErrorType);
    };
    const $bbaa521f44d79b10$export$cf58cbb2768ea4f = (error)=>(0, (0, parcelRequire("j7a90")).default)[error.type] || null;
});
parcelRegister("j7a90", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6233b95581c40425$export$2e2bcd8739ae039);
    var $7VHMR;
    var $lTDxG;
    var $6233b95581c40425$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).COMMENTS_PER_VIEW]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.comments-per-view",
            "defaultMessage": "We couldn\u2019t create a new <item>comment</item> because this <item>view</item> has reached its limit for <item>comments</item>. Remove <item>comment</item> to create a new <item>comment</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_VIEW]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-view",
            "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>view</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_PROJECT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-project",
            "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>project</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_IDEA]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-idea",
            "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>idea</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_PROJECT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-project",
            "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>project</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).LABELS_PER_SNIPPET]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.labels-per-snippet",
            "defaultMessage": "We couldn\u2019t create a new <item>label</item> because this <item>snippet</item> has reached its limit for <item>labels</item>. Remove <item>label</item> to create a new <item>label</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).OPTIONS_PER_FIELD]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.options-per-field",
            "defaultMessage": "We couldn\u2019t create a new <item>option</item> because this <item>field</item> has reached its limit for <item>options</item>. Remove <item>option</item> to create a new <item>option</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PLAY]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-play",
            "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>vote</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PROJECT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-project",
            "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>project</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).PLAYS_PER_PROJECT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.plays-per-project",
            "defaultMessage": "We couldn\u2019t create a new <item>vote</item> because this <item>project</item> has reached its limit for <item>votes</item>. Remove <item>vote</item> to create a new <item>vote</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).SNIPPETS_PER_INSIGHT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.snippets-per-insight",
            "defaultMessage": "We couldn\u2019t create a new <item>snippet</item> because this <item>insight</item> has reached its limit for <item>snippets</item>. Remove <item>snippet</item> to create a new <item>snippet</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).VIEWS_PER_PROJECT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.views-per-project",
            "defaultMessage": "We couldn\u2019t create a new <item>view</item> because this <item>project</item> has reached its limit for <item>views</item>. Remove <item>view</item> to create a new <item>view</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project",
            "defaultMessage": "We couldn\u2019t create a new <item>section</item> because this <item>project</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
        }
    });
});
parcelRegister("lTDxG", function(module, exports) {
    $parcel$export(module.exports, "ENTITY_LIMIT_ERROR_TYPE", ()=>$557259e823a7e117$export$a197d88688faa32c);
    const $557259e823a7e117$export$a197d88688faa32c = {
        COMMENTS_PER_VIEW: 'commentsPerView',
        FIELDS_PER_VIEW: 'fieldsPerView',
        FIELDS_PER_PROJECT: 'fieldsPerProject',
        INSIGHTS_PER_IDEA: 'insightsPerIdea',
        INSIGHTS_PER_PROJECT: 'insightsPerProject',
        LABELS_PER_SNIPPET: 'labelsPerSnippet',
        OPTIONS_PER_FIELD: 'optionsPerField',
        PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
        PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
        PLAYS_PER_PROJECT: 'playsPerProject',
        SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
        VIEWS_PER_PROJECT: 'viewsPerProject',
        VIEWSETS_PER_PROJECT: 'viewsetsPerProject'
    };
});
parcelRegister("l6caf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$891c8f37fb7de7f7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $891c8f37fb7de7f7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "polaris-lib-errors.controllers.error-title",
            "defaultMessage": "Something went wrong."
        },
        permissionErrorDescription: {
            "id": "polaris-lib-errors.controllers.permission-error-description",
            "defaultMessage": "You may not have the permissions required to perform this operation."
        },
        configErrorTitle: {
            "id": "polaris-lib-errors.controllers.config-error-title",
            "defaultMessage": "We couldn't save that."
        },
        configErrorDescription: {
            "id": "polaris-lib-errors.controllers.config-error-description",
            "defaultMessage": "This usually happens because the configuration data on this field is too big. Contact support for more details"
        },
        serverLoadFailedDescription: {
            "id": "polaris-lib-errors.controllers.server-load-failed-description",
            "defaultMessage": "We had difficulties to fetch some data from the server. Please refresh the page."
        },
        serverUpdateFailedDescription: {
            "id": "polaris-lib-errors.controllers.server-update-failed-description",
            "defaultMessage": "We had some difficulties to save some data to the server. Please try again or refresh the page."
        },
        errorDescription: {
            "id": "polaris-lib-errors.controllers.error-description",
            "defaultMessage": "We failed to execute your last operation. Our team has been notified. Please refresh the page to try again."
        },
        workflowLoadingFailedDescription: {
            "id": "polaris-lib-errors.controllers.workflow-loading-failed-description",
            "defaultMessage": "We had some difficulties to load some workflow data from the server. Please refresh the page."
        },
        errorPossibleAccessLoss: {
            "id": "polaris-lib-errors.controllers.error-possible-access-loss",
            "defaultMessage": "You may have lost access to the project or site. Please refresh the page."
        },
        cyclicFormulaFieldDescription: {
            "id": "polaris-lib-errors.controllers.cyclic-formula-field-description",
            "defaultMessage": "We cannot calculate the value of some fields because they contain a cyclic formula. Please edit the field configurations and refresh: {fieldLabels}"
        },
        entityLimitErrorTitle: {
            "id": "polaris-lib-errors.controllers.entity-limit-error-title",
            "defaultMessage": "You\u2019ve hit a limit"
        }
    });
});
parcelRegister("aiePb", function(module, exports) {
    $parcel$export(module.exports, "isPermissionError", ()=>$b7e19fcceac7c31b$export$e11674744930cd15);
    $parcel$export(module.exports, "isRateLimitError", ()=>$b7e19fcceac7c31b$export$a8908c3867f6f20b);
    $parcel$export(module.exports, "isAccessForbiddenError", ()=>$b7e19fcceac7c31b$export$443ae86cf12ba84);
    $parcel$export(module.exports, "isNotFoundError", ()=>$b7e19fcceac7c31b$export$6ccdb59d3479f4f1);
    $parcel$export(module.exports, "isClientClosedError", ()=>$b7e19fcceac7c31b$export$ce14333297f1d017);
    $parcel$export(module.exports, "isBadRequest", ()=>$b7e19fcceac7c31b$export$9ec5d1f0bf2939c);
    $parcel$export(module.exports, "isConfigError", ()=>$b7e19fcceac7c31b$export$5e48c9e1c3c8f299);
    $parcel$export(module.exports, "getMetadata", ()=>$b7e19fcceac7c31b$export$8548546c0aa631e6);
    var $561FV = parcelRequire("561FV");
    var $8LQ84 = parcelRequire("8LQ84");
    var $icGZu = parcelRequire("icGZu");
    const $b7e19fcceac7c31b$export$e11674744930cd15 = (errorObject)=>{
        if ((0, ($parcel$interopDefault($561FV)))(errorObject, 'statusCode')) return errorObject.statusCode === 401 || errorObject.statusCode === 403;
        if ((0, ($parcel$interopDefault($561FV)))(errorObject, 'graphQLErrors') && (0, ($parcel$interopDefault($8LQ84)))(errorObject.graphQLErrors)) return (0, ($parcel$interopDefault($icGZu)))(errorObject.graphQLErrors, (error)=>{
            const safeMessage = error.message || '';
            return error.extensions?.statusCode === 403 || error.extensions?.statusCode === 401 || safeMessage.includes('JIRA_ACCESS_NOT_PERMITTED') || safeMessage.includes('RequestStatus: 401') || safeMessage.includes('RequestStatus: 403') || safeMessage.includes('status code 401') || safeMessage.includes('status code 403');
        });
        return false;
    };
    const $b7e19fcceac7c31b$var$checkRateLimitErrorMatch = (error)=>{
        const safeMessage = error?.message || '';
        return error && 'statusCode' in error && error?.statusCode === 429 || error && 'extensions' in error && error.extensions?.statusCode === 429 || safeMessage.includes('RequestStatus: 429') || safeMessage.includes('status code 429');
    };
    const $b7e19fcceac7c31b$export$a8908c3867f6f20b = (errorObject)=>{
        return $b7e19fcceac7c31b$var$checkRateLimitErrorMatch(errorObject) || errorObject.networkError && $b7e19fcceac7c31b$var$checkRateLimitErrorMatch(errorObject.networkError) || errorObject?.graphQLErrors?.some((error)=>$b7e19fcceac7c31b$var$checkRateLimitErrorMatch(error)) || false;
    };
    const $b7e19fcceac7c31b$export$443ae86cf12ba84 = (errorObject)=>{
        if ((0, ($parcel$interopDefault($561FV)))(errorObject, 'statusCode')) return errorObject.statusCode === 403;
        return false;
    };
    const $b7e19fcceac7c31b$export$6ccdb59d3479f4f1 = (errorObject)=>{
        if ((0, ($parcel$interopDefault($561FV)))(errorObject, 'statusCode')) return errorObject.statusCode === 404;
        return false;
    };
    const $b7e19fcceac7c31b$export$ce14333297f1d017 = (errorObject)=>{
        if ((0, ($parcel$interopDefault($561FV)))(errorObject, 'statusCode')) return errorObject.statusCode === 499;
        return false;
    };
    const $b7e19fcceac7c31b$export$9ec5d1f0bf2939c = (errorObject)=>{
        if (errorObject?.statusCode) return errorObject?.statusCode >= 400 && errorObject?.statusCode < 500;
        return false;
    };
    const $b7e19fcceac7c31b$export$5e48c9e1c3c8f299 = (errorObject)=>{
        if ((0, ($parcel$interopDefault($561FV)))(errorObject, 'statusCode') && (0, ($parcel$interopDefault($561FV)))(errorObject, 'message')) return errorObject.statusCode === 500 && errorObject.message === 'Property is too long';
        return false;
    };
    const $b7e19fcceac7c31b$export$8548546c0aa631e6 = (errorObject)=>({
            metadata: {
                error: errorObject.message
            }
        });
});
parcelRegister("icGZu", function(module, exports) {
    var $2k3l6 = parcelRequire("2k3l6");
    var $bxDef = parcelRequire("bxDef");
    var $6kYP8 = parcelRequire("6kYP8");
    var $8LQ84 = parcelRequire("8LQ84");
    var $4rDUz = parcelRequire("4rDUz");
    function $d40ab2104a331ebd$var$some(collection, predicate, guard) {
        var func = $8LQ84(collection) ? $2k3l6 : $6kYP8;
        if (guard && $4rDUz(collection, predicate, guard)) predicate = undefined;
        return func(collection, $bxDef(predicate, 3));
    }
    module.exports = $d40ab2104a331ebd$var$some;
});
parcelRegister("6kYP8", function(module, exports) {
    var $e7pfQ = parcelRequire("e7pfQ");
    function $49d3cab0435826ab$var$baseSome(collection, predicate) {
        var result;
        $e7pfQ(collection, function(value, index, collection) {
            result = predicate(value, index, collection);
            return !result;
        });
        return !!result;
    }
    module.exports = $49d3cab0435826ab$var$baseSome;
});
parcelRegister("8EJ2P", function(module, exports) {
    $parcel$export(module.exports, "createCollection", ()=>$18031dc7a5aa6b32$export$c74125a8e3af6bb2);
    $parcel$export(module.exports, "fetchCollection", ()=>$18031dc7a5aa6b32$export$efeb96fc7f2aeaf9);
    $parcel$export(module.exports, "fetchAllCollections", ()=>$18031dc7a5aa6b32$export$fb62ec897a9d1e05);
    $parcel$export(module.exports, "deleteCollection", ()=>$18031dc7a5aa6b32$export$3d16e031f6551662);
    $parcel$export(module.exports, "updateCollection", ()=>$18031dc7a5aa6b32$export$c0683150b517c317);
    $parcel$export(module.exports, "fetchCollectionsViewsCounts", ()=>$18031dc7a5aa6b32$export$4ead91e2f6058f41);
    $parcel$export(module.exports, "fetchCollectionDescription", ()=>$18031dc7a5aa6b32$export$8cd86b5346d1e786);
    $parcel$export(module.exports, "cloneCollection", ()=>$18031dc7a5aa6b32$export$d753eba18153f51e);
    var $4R6GH;
    var $7f4tk;
    var $eusud;
    var $b2npD;
    var $dpYV0;
    var $cPshp;
    const $18031dc7a5aa6b32$var$generateProjectKeys = (jql)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('polaris-collections-show-projects-list')) return (0, (0, parcelRequire("dpYV0")).extractProjectKeysFromJql)(jql);
        return [];
    };
    const $18031dc7a5aa6b32$export$c74125a8e3af6bb2 = (collectionToCreate)=>(0, (0, parcelRequire("eusud")).performPostRequest)(`${(0, (0, parcelRequire("b2npD")).getJpdViewsServicePathPrefix)()}/v1/collections`, {
            body: JSON.stringify(collectionToCreate)
        }).then((response)=>({
                uuid: response.uuid,
                name: response.name,
                emoji: response.emoji,
                color: response.color,
                jql: response.jql,
                ownerId: response.owner,
                projectKeys: $18031dc7a5aa6b32$var$generateProjectKeys(response.jql)
            }));
    const $18031dc7a5aa6b32$export$efeb96fc7f2aeaf9 = (collectionUUID, shouldIncludeViews = false)=>(0, (0, parcelRequire("7f4tk")).default)(`${(0, (0, parcelRequire("b2npD")).getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}${shouldIncludeViews ? '?expand=views' : ''}`).then((response)=>({
                uuid: response.uuid,
                name: response.name,
                emoji: response.emoji,
                color: response.color,
                jql: response.jql,
                ownerId: response.owner,
                views: response.views?.map((0, (0, parcelRequire("cPshp")).transformView)),
                projectKeys: $18031dc7a5aa6b32$var$generateProjectKeys(response.jql)
            }));
    const $18031dc7a5aa6b32$export$fb62ec897a9d1e05 = ()=>(0, (0, parcelRequire("7f4tk")).default)(`${(0, (0, parcelRequire("b2npD")).getJpdViewsServicePathPrefix)()}/v1/collections`).then(({ collections: collections })=>collections.map((collection)=>({
                    uuid: collection.uuid,
                    name: collection.name,
                    emoji: collection.emoji,
                    color: collection.color,
                    jql: collection.jql,
                    ownerId: collection.owner,
                    projectKeys: $18031dc7a5aa6b32$var$generateProjectKeys(collection.jql)
                })));
    const $18031dc7a5aa6b32$export$3d16e031f6551662 = async (collectionUUID)=>{
        await (0, (0, parcelRequire("eusud")).performDeleteRequest)(`${(0, (0, parcelRequire("b2npD")).getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}`);
    };
    const $18031dc7a5aa6b32$export$c0683150b517c317 = async (collectionUUID, collectionToUpdate)=>{
        await (0, (0, parcelRequire("eusud")).performPutRequest)(`${(0, (0, parcelRequire("b2npD")).getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}`, {
            body: JSON.stringify(collectionToUpdate)
        });
    };
    const $18031dc7a5aa6b32$export$4ead91e2f6058f41 = (collectionsUUIDs)=>(0, (0, parcelRequire("eusud")).performPostRequest)(`${(0, (0, parcelRequire("b2npD")).getJpdViewsServicePathPrefix)()}/v1/collections/views-count`, {
            body: JSON.stringify({
                uuids: collectionsUUIDs
            })
        });
    const $18031dc7a5aa6b32$export$8cd86b5346d1e786 = (collectionUUID)=>(0, (0, parcelRequire("7f4tk")).default)(`${(0, (0, parcelRequire("b2npD")).getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/description`);
    const $18031dc7a5aa6b32$export$d753eba18153f51e = (collectionUUID, newCollectionName)=>(0, (0, parcelRequire("eusud")).performPostRequest)(`${(0, (0, parcelRequire("b2npD")).getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/clone`, {
            body: JSON.stringify({
                name: newCollectionName
            })
        });
});
parcelRegister("b2npD", function(module, exports) {
    $parcel$export(module.exports, "getJpdViewsServicePathPrefix", ()=>$234049bfb6060538$export$1d2754f769c8a3c6);
    const $234049bfb6060538$export$1d2754f769c8a3c6 = ()=>{
        return '/gateway/api/jpd';
    };
});
parcelRegister("cPshp", function(module, exports) {
    $parcel$export(module.exports, "transformView", ()=>$173999f9e481de31$export$601ea8be46c5c28c);
    const $173999f9e481de31$export$601ea8be46c5c28c = (view)=>({
            uuid: view.uuid,
            ownerId: view.owner,
            kind: view.visualizationType,
            title: view.name,
            emoji: view.emoji,
            description: view.description,
            apiResponse: view
        });
});
parcelRegister("2ejmj", function(module, exports) {
    $parcel$export(module.exports, "createView", ()=>$b949e30510085a07$export$d7febe7b891e79f0);
    $parcel$export(module.exports, "fetchCollectionsViewsCounts", ()=>$b949e30510085a07$export$4ead91e2f6058f41);
    $parcel$export(module.exports, "deleteView", ()=>$b949e30510085a07$export$443d89549b135c95);
    var $dPSWJ = parcelRequire("dPSWJ");
    var $jcw0u;
    var $eiARp;
    var $jDD5V;
    var $1As78;
    var $8EJ2P;
    var $gtfOZ;
    const $b949e30510085a07$export$d7febe7b891e79f0 = (collectionUUID, view)=>async ({ setState: setState, getState: getState })=>{
            try {
                const state = getState();
                const existingCollection = state.collections[collectionUUID];
                const data = existingCollection?.data;
                if (!data) return;
                return await (0, (0, parcelRequire("jDD5V")).wrapWithExperience)((0, (0, parcelRequire("eiARp")).experience).collections.createView, async ()=>{
                    const newView = await (0, (0, parcelRequire("gtfOZ")).createView)(collectionUUID, view);
                    setState({
                        collections: {
                            ...state.collections,
                            [collectionUUID]: {
                                ...existingCollection,
                                data: {
                                    ...data,
                                    views: [
                                        ...data?.views || [],
                                        newView
                                    ]
                                }
                            }
                        }
                    });
                    return newView;
                });
            } catch (error) {
                if (error instanceof Error) {
                    (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.error.collectionViewCreationFailed', error));
                    throw error;
                }
            }
        };
    const $b949e30510085a07$export$4ead91e2f6058f41 = ()=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            const collectionsUUIDs = Object.keys(state.collections);
            if (collectionsUUIDs.length === 0) return;
            try {
                await (0, (0, parcelRequire("jDD5V")).wrapWithExperience)((0, (0, parcelRequire("eiARp")).experience).collections.loadViewCount, async ()=>{
                    const collectionsViewsCountMap = await (0, (0, parcelRequire("8EJ2P")).fetchCollectionsViewsCounts)(collectionsUUIDs);
                    setState({
                        collections: (0, ($parcel$interopDefault($dPSWJ)))(state.collections, (collection)=>{
                            if (collection?.data) return {
                                ...collection,
                                data: {
                                    ...collection.data,
                                    viewsCount: collectionsViewsCountMap[collection.data.uuid] || 0
                                }
                            };
                            return collection;
                        })
                    });
                });
            } catch (error) {
                if (error instanceof Error) (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.error.collectionsViewsCountLoadingFailed', error));
                throw error;
            }
        };
    const $b949e30510085a07$export$443d89549b135c95 = (collectionUUID, viewUUID)=>async ({ setState: setState, getState: getState })=>{
            try {
                const state = getState();
                const existingCollection = state.collections[collectionUUID];
                const data = existingCollection?.data;
                if (!data) return;
                await (0, (0, parcelRequire("jDD5V")).wrapWithExperience)((0, (0, parcelRequire("eiARp")).experience).collections.deleteView, async ()=>{
                    await (0, (0, parcelRequire("gtfOZ")).deleteView)(collectionUUID, viewUUID);
                    setState({
                        collections: {
                            ...state.collections,
                            [collectionUUID]: {
                                ...existingCollection,
                                data: {
                                    ...data,
                                    viewsCount: data.viewsCount ? data.viewsCount - 1 : undefined,
                                    views: data?.views?.filter((view)=>view.uuid !== viewUUID)
                                }
                            }
                        }
                    });
                });
            } catch (error) {
                if (error instanceof Error) {
                    (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.error.collectionViewDeletionFailed', error));
                    throw error;
                }
            }
        };
});
parcelRegister("dPSWJ", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $hDnyx = parcelRequire("hDnyx");
    var $bxDef = parcelRequire("bxDef");
    function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
        var result = {};
        iteratee = $bxDef(iteratee, 3);
        $hDnyx(object, function(value, key, object) {
            $1m3dq(result, key, iteratee(value, key, object));
        });
        return result;
    }
    module.exports = $a12aa8fd8ab9a7da$var$mapValues;
});
parcelRegister("gtfOZ", function(module, exports) {
    $parcel$export(module.exports, "createView", ()=>$9832d7839d9f46b2$export$d7febe7b891e79f0);
    $parcel$export(module.exports, "deleteView", ()=>$9832d7839d9f46b2$export$443d89549b135c95);
    var $eusud;
    var $b2npD;
    var $cPshp;
    const $9832d7839d9f46b2$export$d7febe7b891e79f0 = (collectionUUID, viewToCreate)=>(0, (0, parcelRequire("eusud")).performPostRequest)(`${(0, (0, parcelRequire("b2npD")).getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/views`, {
            body: JSON.stringify(viewToCreate)
        }).then((0, (0, parcelRequire("cPshp")).transformView));
    const $9832d7839d9f46b2$export$443d89549b135c95 = async (collectionUUID, viewUUID)=>{
        await (0, (0, parcelRequire("eusud")).performDeleteRequest)(`${(0, (0, parcelRequire("b2npD")).getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/views/${viewUUID}`);
    };
});
parcelRegister("3WCAK", function(module, exports) {
    $parcel$export(module.exports, "loadCollectionDescription", ()=>$c0c970158da04e57$export$da25d48c64ab9a24);
    $parcel$export(module.exports, "updateCollectionDescription", ()=>$c0c970158da04e57$export$95146d83152efba8);
    var $jcw0u;
    var $eiARp;
    var $jDD5V;
    var $1As78;
    var $8EJ2P;
    const $c0c970158da04e57$export$da25d48c64ab9a24 = (collectionUUID)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            const existingDescription = state.descriptions[collectionUUID];
            if (existingDescription?.isLoading || existingDescription && !existingDescription.error) return;
            try {
                await (0, (0, parcelRequire("jDD5V")).wrapWithExperience)((0, (0, parcelRequire("eiARp")).experience).collections.loadCollectionDescription, async ()=>{
                    setState({
                        descriptions: {
                            ...state.descriptions,
                            [collectionUUID]: {
                                description: undefined,
                                isLoading: true,
                                error: undefined
                            }
                        }
                    });
                    const newDescription = await (0, (0, parcelRequire("8EJ2P")).fetchCollectionDescription)(collectionUUID);
                    setState({
                        descriptions: {
                            ...state.descriptions,
                            [collectionUUID]: {
                                description: newDescription ?? undefined,
                                isLoading: false
                            }
                        }
                    });
                });
            } catch (error) {
                if (error instanceof Error) {
                    (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.error.collectionDescriptionLoadingFailed', error));
                    setState({
                        descriptions: {
                            ...state.descriptions,
                            [collectionUUID]: {
                                description: undefined,
                                isLoading: false,
                                error: error
                            }
                        }
                    });
                }
                throw error;
            }
        };
    const $c0c970158da04e57$export$95146d83152efba8 = (collectionUUID, description)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            const existingCollection = state.collections[collectionUUID];
            const data = existingCollection?.data;
            if (!data) return;
            try {
                await (0, (0, parcelRequire("jDD5V")).wrapWithExperience)((0, (0, parcelRequire("eiARp")).experience).collections.updateCollectionDescription, async ()=>{
                    await (0, (0, parcelRequire("8EJ2P")).updateCollection)(collectionUUID, {
                        ...data,
                        description: description
                    });
                    setState({
                        descriptions: {
                            ...state.descriptions,
                            [collectionUUID]: {
                                isLoading: false,
                                error: undefined,
                                description: description
                            }
                        }
                    });
                });
            } catch (error) {
                if (error instanceof Error) (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.error.collectionDescriptionUpdateFailed', error));
                throw error;
            }
        };
});
parcelRegister("emOwp", function(module, exports) {
    $parcel$export(module.exports, "filterCollectionByOwnerIds", ()=>$fb72f39750296f26$export$a5af2fa2fc5a6608);
    $parcel$export(module.exports, "filterCollectionByProjectKeys", ()=>$fb72f39750296f26$export$197fb91166111e5e);
    $parcel$export(module.exports, "filterCollectionByText", ()=>$fb72f39750296f26$export$29aabb123440d65b);
    const $fb72f39750296f26$export$a5af2fa2fc5a6608 = (ownerIds)=>(collection)=>!ownerIds?.length || ownerIds.some((accountId)=>accountId === collection.ownerId);
    const $fb72f39750296f26$export$197fb91166111e5e = (projectKeys)=>(collection)=>!projectKeys?.length || projectKeys.some((projectKey)=>collection.projectKeys.includes(projectKey));
    const $fb72f39750296f26$export$29aabb123440d65b = (search = '')=>{
        const searchLower = search.toLocaleLowerCase();
        return ({ name: name })=>!search || name?.toLocaleLowerCase().includes(searchLower);
    };
});
const $7d87475f2d1b3049$export$3aafeb2daa00df8b = 'key';
const $7d87475f2d1b3049$export$48927a8f78b0130e = 'issueid';
const $7d87475f2d1b3049$export$469f8bf472cb9ca = 'summary';
const $7d87475f2d1b3049$export$29157f6cae91bb2f = 'status';
const $7d87475f2d1b3049$export$dd03acb09519222 = 'issuetype';
const $7d87475f2d1b3049$export$ed9d952d27dea151 = 'labels';
const $7d87475f2d1b3049$export$1f3d7d17213e853b = 'votes';
const $7d87475f2d1b3049$export$cb59b69c70ea9e18 = 'reporter';
const $7d87475f2d1b3049$export$d6749ecf5a14d5b = 'description';
const $7d87475f2d1b3049$export$7e67ea07bd31e757 = 'assignee';
const $7d87475f2d1b3049$export$4b6f00f5eeabd293 = 'creator';
const $7d87475f2d1b3049$export$16313363fca8abe5 = 'created';
const $7d87475f2d1b3049$export$77c57adf6bed37b8 = 'updated';
const $7d87475f2d1b3049$export$1fd24e9c03ef9b18 = 'project';
const $739ce7f4993d045e$export$76e8cbc60f99881d = 'TABLE';
const $739ce7f4993d045e$export$1ad049af934b4509 = 'BOARD';
const $739ce7f4993d045e$export$2b0330ebc4df6bb5 = 'MATRIX';
const $739ce7f4993d045e$export$b536e56a69266159 = 'TIMELINE';
const $739ce7f4993d045e$export$4f6053f7f1423a0c = 'SECTION';
const $739ce7f4993d045e$export$84ce1bdcbd34dd0c = 'TWOXTWO';
parcelRegister("1X3JP", function(module, exports) {
    $parcel$export(module.exports, "EmojiPicker", ()=>$277af980fb64cf62$export$6335145236247192);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $42CjB;
    var $flZch;
    var $7LZcH;
    var $dASv8;
    var $kJpBP;
    var $eZUJu;
    var $9UCCQ;
    var $1I7E8;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $koVbs;
    var $agzbr;
    var $a8fLF;
    const $277af980fb64cf62$export$6335145236247192 = ({ onEmojiSelected: onEmojiSelected, selectedEmojiId: selectedEmojiId, readonly: readonly = false, placement: placement = 'bottom-start', noPadding: noPadding = false, color: color, offset: offset, zIndex: zIndex, emojiAddIcon: emojiAddIcon, shouldRenderToParent: shouldRenderToParent = false, onOpenChange: onOpenChange, onEmojiLoaded: onEmojiLoaded })=>{
        const [isPickerOpen, setIsPickerOpen] = (0, $5uXOq.useState)(false);
        const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const selectedEmoji = (0, (0, parcelRequire("agzbr")).useEmoji)(selectedEmojiId);
        const emojiProviderPromise = (0, (0, parcelRequire("agzbr")).useEmojiProviderPromise)();
        const onSelection = (0, $5uXOq.useCallback)((_emoji, emojiDescription)=>{
            setIsPickerOpen(false);
            onEmojiSelected?.(emojiDescription);
        }, [
            onEmojiSelected
        ]);
        const handleEmojiClick = ()=>{
            setIsMenuOpen(true);
            setIsPickerOpen(false);
        };
        const handleEditEmoji = ()=>{
            setIsMenuOpen(false);
            setIsPickerOpen(true);
        };
        const toggleEmojiPicker = ()=>{
            setIsPickerOpen((prev)=>!prev);
        };
        const handleDeleteEmoji = ()=>{
            setIsMenuOpen(false);
            onEmojiSelected?.(undefined);
        };
        (0, $5uXOq.useEffect)(()=>{
            onOpenChange?.(isPickerOpen);
        }, [
            isPickerOpen,
            onOpenChange
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (selectedEmoji === undefined) onEmojiLoaded?.(null);
        }, [
            selectedEmoji,
            onEmojiLoaded
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            xcss: $277af980fb64cf62$var$emojiPickerContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isPickerOpen,
            onClose: ()=>setIsPickerOpen(false),
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("flZch")).default), {
                    emojiProvider: emojiProviderPromise,
                    onSelection: onSelection
                })),
            shouldRenderToParent: shouldRenderToParent,
            trigger: (emojiPickerTriggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                    isOpen: isMenuOpen,
                    content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), {
                            onClick: (e)=>e.stopPropagation()
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                            onClick: handleEditEmoji,
                            testId: "polaris-lib-emoji-picker.ui.edit-button"
                        }, formatMessage((0, (0, parcelRequire("a8fLF")).default).editEmoji)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                            onClick: handleDeleteEmoji,
                            testId: "polaris-lib-emoji-picker.ui.remove-button"
                        }, formatMessage((0, (0, parcelRequire("a8fLF")).default).removeEmoji)))),
                    placement: "bottom-start",
                    onClose: ()=>setIsMenuOpen(false),
                    trigger: (popupTriggerProps)=>selectedEmoji ? (0, ($parcel$interopDefault($5uXOq))).createElement($277af980fb64cf62$var$EmojiButton, {
                            "data-testid": "polaris-lib-emoji-picker.ui.emoji-button",
                            ...isMenuOpen ? popupTriggerProps : emojiPickerTriggerProps,
                            disabled: readonly,
                            color: color,
                            onClick: handleEmojiClick,
                            noPadding: noPadding,
                            type: "button"
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7LZcH")).default), {
                            emoji: selectedEmoji,
                            fitToHeight: 24,
                            showTooltip: true,
                            onLoadSuccess: onEmojiLoaded
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                            testId: "polaris-lib-emoji-picker.ui.add-button",
                            ...emojiPickerTriggerProps,
                            isDisabled: readonly,
                            icon: emojiAddIcon ?? (0, ($parcel$interopDefault((0, parcelRequire("dASv8"))))),
                            appearance: "subtle",
                            label: formatMessage((0, (0, parcelRequire("a8fLF")).default).emojiButtonCaption),
                            onClick: toggleEmojiPicker,
                            spacing: noPadding ? 'compact' : 'default',
                            type: "button"
                        }),
                    zIndex: zIndex
                }),
            placement: placement,
            offset: offset,
            zIndex: zIndex
        }));
    };
    const $277af980fb64cf62$var$emojiPickerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxWidth: '192px'
    });
    const $277af980fb64cf62$var$EmojiButton = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { noPadding: noPadding, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_rmkr0o": (0, (0, parcelRequire("lD23V")).default)(__cmplp.noPadding ? 24 : 32, "px"),
                "--_1cy9snk": (0, (0, parcelRequire("lD23V")).default)(__cmplp.color || 'transparent')
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _19itglyw _80omtlke _1bsbifu1 _4t3iifu1 _1bah1h6o _4cvr1h6o _2rkosqtm _v5641yx9 _bfhk1dst _tv5y11pc _cun918uv _j5dh13gf _1j55clii _1di6yucn",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("flZch", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7660efb2d62946a5$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "EmojiPicker", ()=>(parcelRequire("k9ixM")).default);
    var $dS9cn = parcelRequire("dS9cn");
    var $7LZcH;
    var $kAeq1;
    var $2l0ub;
    var $k9ixM;
    var $qb63L;
    var $2TUWQ;
    var $3Uu1D;
    var $bNyWE;
    var $bHWpv;
    var $kin1Z;
    var $9AR2K;
    var $7660efb2d62946a5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("k9ixM")).default);
});
parcelRegister("7LZcH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e978b8e9836bc944$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3bDjY;
    var $0Bueq;
    var $kin1Z;
    var $5B9Cy;
    var $9AR2K;
    var $6f82C;
    var $8L6cL;
    var $2TUWQ;
    var $d2UcN;
    var $d8gl8;
    var $lsSGz;
    var $7zSof;
    var $d2UcN;
    var $jtKZR;
    var $50JWu;
    const $e978b8e9836bc944$var$handleMouseDown = (props, event)=>{
        if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, (0, parcelRequire("kin1Z")).deleteEmojiLabel)) return;
        const { emoji: emoji, onSelected: onSelected } = props;
        if (onSelected && (0, (0, parcelRequire("6f82C")).leftClick)(event)) onSelected((0, (0, parcelRequire("5B9Cy")).toEmojiId)(emoji), emoji, event);
    };
    const $e978b8e9836bc944$var$handleKeyDown = (props, event)=>{
        if (!(0, (0, parcelRequire("kin1Z")).EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
        event.preventDefault();
        event.stopPropagation();
        const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
        if (onSelected && (event.key === (0, (0, parcelRequire("kin1Z")).KeyboardKeys).Enter || event.key === (0, (0, parcelRequire("kin1Z")).KeyboardKeys).Space)) onSelected((0, (0, parcelRequire("5B9Cy")).toEmojiId)(emoji), emoji, event);
        if (showDelete && event.key === (0, (0, parcelRequire("kin1Z")).KeyboardKeys).Backspace) $e978b8e9836bc944$var$handleDelete(props, event);
    };
    const $e978b8e9836bc944$var$handleMouseMove = (props, event)=>{
        const { emoji: emoji, onMouseMove: onMouseMove } = props;
        if (onMouseMove) onMouseMove((0, (0, parcelRequire("5B9Cy")).toEmojiId)(emoji), emoji, event);
    };
    const $e978b8e9836bc944$var$handleFocus = (props, event)=>{
        const { emoji: emoji, onFocus: onFocus } = props;
        if (onFocus) onFocus((0, (0, parcelRequire("5B9Cy")).toEmojiId)(emoji), emoji, event);
    };
    const $e978b8e9836bc944$var$handleDelete = (props, event)=>{
        const { emoji: emoji, onDelete: onDelete } = props;
        if (onDelete) onDelete((0, (0, parcelRequire("5B9Cy")).toEmojiId)(emoji), emoji, event);
    };
    const $e978b8e9836bc944$var$handleImageError = (props, event)=>{
        const { emoji: emoji, onLoadError: onLoadError } = props;
        if (event.target) {
            const target = event.target;
            target.style.visibility = 'hidden';
        }
        if (onLoadError) onLoadError((0, (0, parcelRequire("5B9Cy")).toEmojiId)(emoji), emoji, event);
    };
    const $e978b8e9836bc944$export$ef49ddbb198ce334 = (props)=>{
        const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
        const representation = emoji.representation;
        const sprite = representation.sprite;
        const classes = `${(0, (0, parcelRequire("2TUWQ")).emojiNodeStyles)} ${selected ? (0, (0, parcelRequire("2TUWQ")).commonSelectedStyles) : ''} ${selectOnHover ? (0, (0, parcelRequire("2TUWQ")).selectOnHoverStyles) : ''} ${className ? className : ''}`;
        let sizing = {};
        if (fitToHeight) sizing = {
            width: `${fitToHeight}px`,
            height: `${fitToHeight}px`,
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
        const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
        const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
        const style = {
            backgroundImage: `url(${sprite.url})`,
            backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
            backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
            ...sizing
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)($e978b8e9836bc944$export$ce5eef59d8e46687, {
            ...props,
            type: "sprite",
            className: classes
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            className: (0, (0, parcelRequire("2TUWQ")).emojiSprite),
            style: style
        })));
    };
    const $e978b8e9836bc944$export$99dfeb9d71c11788 = (props)=>{
        const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth } = props;
        const [ref, inView] = (0, (0, parcelRequire("7zSof")).useInView)({
            triggerOnce: true
        });
        const ufoExp = (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emoji);
        const classes = `${(0, (0, parcelRequire("2TUWQ")).emojiMainStyle)} ${(0, (0, parcelRequire("2TUWQ")).emojiNodeStyles)} ${selected ? (0, (0, parcelRequire("2TUWQ")).commonSelectedStyles) : ''} ${selectOnHover ? (0, (0, parcelRequire("2TUWQ")).selectOnHoverStyles) : ''} ${(0, (0, parcelRequire("2TUWQ")).emojiImage)} ${className ? className : ''} ${showDelete ? (0, (0, parcelRequire("2TUWQ")).deletableEmoji) : ''}`;
        let width;
        let height;
        let src;
        const representation = (0, (0, parcelRequire("0Bueq")).shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
        if ((0, (0, parcelRequire("5B9Cy")).isImageRepresentation)(representation)) {
            src = representation.imagePath;
            width = representation.width;
            height = representation.height;
        } else if ((0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(representation)) {
            src = representation.mediaPath;
            width = representation.width;
            height = representation.height;
        }
        let sizing = {};
        if (fitToHeight && width && height) sizing = {
            width: autoWidth && !(0, (0, parcelRequire("50JWu")).isSSR)() ? 'auto' : fitToHeight / height * width,
            height: fitToHeight
        };
        const onError = (event)=>{
            $e978b8e9836bc944$var$handleImageError(props, event);
        };
        const onLoad = ()=>{
            const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).MOUNTED_END);
            if (!(0, (0, parcelRequire("d2UcN")).hasUfoMarked)(ufoExp, (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
            const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).ONLOAD_START);
            if (mountedMark && loadedStartMark) ufoExp.addMetadata({
                lazyLoad: loadedStartMark.time > mountedMark.time
            });
            if (!(0, (0, parcelRequire("d2UcN")).hasUfoMarked)(ufoExp, (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).ONLOAD_END);
            ufoExp.success({
                metadata: {
                    IBSupported: (0, (0, parcelRequire("lsSGz")).default).supportsIntersectionObserver
                }
            });
            if (onLoadSuccess) onLoadSuccess(emoji);
        };
        const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
            if (!(0, (0, parcelRequire("d2UcN")).hasUfoMarked)(ufoExp, (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).ONLOAD_START);
        }, [
            ufoExp
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (inView) onBeforeLoad();
        }, [
            inView,
            onBeforeLoad
        ]);
        const emojiNode = (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            loading: disableLazyLoad ? 'eager' : 'lazy',
            src: src,
            key: src,
            alt: emoji.name || emoji.shortName,
            "data-emoji-short-name": emoji.shortName,
            "data-emoji-id": emoji.id,
            "data-emoji-text": emoji.fallback || emoji.shortName,
            className: "emoji",
            style: {
                visibility: 'visible'
            },
            onError: onError,
            onLoad: onLoad,
            ...sizing,
            "data-vc": "emoji"
        });
        if (showDelete) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jtKZR")).DeletableEmojiTooltipContent), null),
            position: "right-start",
            tag: "span"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($e978b8e9836bc944$export$ce5eef59d8e46687, {
            ...props,
            "aria-labelledby": `screenreader-emoji-${emoji.id}`,
            type: "image",
            className: classes,
            ref: ref,
            showTooltip: false,
            onMouseOver: (e)=>{
                if (!document.activeElement?.contains(e.target)) e.stopPropagation();
            }
        }, emojiNode, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8L6cL")).default), {
            onClick: (event)=>$e978b8e9836bc944$var$handleDelete(props, event)
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jtKZR")).DeletableEmojiTooltipContentForScreenReader), {
            emoji: emoji
        })));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)($e978b8e9836bc944$export$ce5eef59d8e46687, {
            ...props,
            type: "image",
            className: classes,
            ref: ref
        }, emojiNode));
    };
    const $e978b8e9836bc944$export$ce5eef59d8e46687 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, ...other } = props;
        let accessibilityProps;
        if (editorEmoji) accessibilityProps = {
            role: undefined
        };
        else if (shouldBeInteractive) accessibilityProps = {
            role: 'button',
            'aria-label': emoji.shortName
        };
        else accessibilityProps = {
            role: 'img',
            'aria-label': emoji.shortName
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...accessibilityProps,
            ref: ref,
            "data-testid": `${type}-emoji-${emoji.shortName}`,
            "data-emoji-type": type,
            tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
            css: type === 'sprite' ? (0, (0, parcelRequire("2TUWQ")).emojiSpriteContainer) : (0, (0, parcelRequire("2TUWQ")).emojiImageContainer),
            className: className,
            onKeyDown: (event)=>$e978b8e9836bc944$var$handleKeyDown(props, event),
            onMouseDown: (event)=>{
                $e978b8e9836bc944$var$handleMouseDown(props, event);
            },
            onMouseEnter: (event)=>{
                $e978b8e9836bc944$var$handleMouseMove(props, event);
            },
            onFocus: (event)=>{
                $e978b8e9836bc944$var$handleFocus(props, event);
            },
            title: showTooltip ? emoji.shortName : undefined,
            ...other
        }, children));
    });
    const $e978b8e9836bc944$export$56cc48506ff790a = (props)=>{
        const { emoji: emoji } = props;
        (0, (0, parcelRequire("d8gl8")).useSampledUFOComponentExperience)((0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, (0, parcelRequire("kin1Z")).SAMPLING_RATE_EMOJI_RENDERED_EXP), {
            source: 'Emoji',
            emojiId: emoji.id
        });
        (0, $5uXOq.useEffect)(()=>{
            const ufoExp = (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emoji);
            if (!(0, (0, parcelRequire("d2UcN")).hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
            if (!(0, (0, parcelRequire("d2UcN")).hasUfoMarked)(ufoExp, (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).MOUNTED_END);
        }, []);
        if ((0, (0, parcelRequire("5B9Cy")).isSpriteRepresentation)(emoji.representation)) return (0, (0, parcelRequire("f8Sb3")).jsx)($e978b8e9836bc944$export$ef49ddbb198ce334, props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($e978b8e9836bc944$export$99dfeb9d71c11788, props);
    };
    var $e978b8e9836bc944$export$2e2bcd8739ae039 = $e978b8e9836bc944$export$56cc48506ff790a;
});
parcelRegister("6f82C", function(module, exports) {
    $parcel$export(module.exports, "leftClick", ()=>$4e45da7e67a9a10d$export$34ebdaf2c517ae75);
    function $4e45da7e67a9a10d$export$fd3cd03f8ac42187(event) {
        return {
            x: event.clientX,
            y: event.clientY
        };
    }
    function $4e45da7e67a9a10d$export$de744e30016241b0(oldPosition, newPosition) {
        if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
        return false;
    }
    function $4e45da7e67a9a10d$export$34ebdaf2c517ae75(reactEvent) {
        return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
    }
});
parcelRegister("8L6cL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebae65259713fbe9$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $fVnbM;
    var $7uxj1;
    var $kin1Z;
    var $2TUWQ;
    var $dC5iT;
    var $8CUq3;
    const $ebae65259713fbe9$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
    const $ebae65259713fbe9$var$boxWrapperStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '18px',
        height: '18px'
    });
    const $ebae65259713fbe9$var$DeleteButton = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("2TUWQ")).deleteButton),
            className: (0, (0, parcelRequire("2TUWQ")).emojiDeleteButton),
            "data-testid": $ebae65259713fbe9$export$28fc7374cf1206d4
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
            iconBefore: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $ebae65259713fbe9$var$boxWrapperStyle
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("7uxj1"))))), {
                label: (0, (0, parcelRequire("kin1Z")).deleteEmojiLabel),
                color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
                LEGACY_size: "small"
            })),
            onClick: props.onClick,
            appearance: "subtle-link",
            spacing: "none",
            testId: "emoji-delete-button",
            tabIndex: -1
        }));
    var $ebae65259713fbe9$export$2e2bcd8739ae039 = $ebae65259713fbe9$var$DeleteButton;
});
parcelRegister("7uxj1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $57452b9b34160439$var$_react = $57452b9b34160439$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $57452b9b34160439$var$_crossCircle = $57452b9b34160439$var$_interopRequireDefault((parcelRequire("47etd")));
    var $57452b9b34160439$var$_crossCircle2 = $57452b9b34160439$var$_interopRequireDefault((parcelRequire("d5Zn3")));
    function $57452b9b34160439$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $57452b9b34160439$var$CrossCircleIcon = (props)=>$57452b9b34160439$var$_react.default.createElement($57452b9b34160439$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $57452b9b34160439$var$_crossCircle2.default
        }, props));
    $57452b9b34160439$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $57452b9b34160439$var$_default = module.exports.default = $57452b9b34160439$var$CrossCircleIcon;
});
parcelRegister("d5Zn3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $988b58f36f60a149$var$_react = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $988b58f36f60a149$var$_crossCircle = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $988b58f36f60a149$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $988b58f36f60a149$var$CrossCircleIcon = (props)=>$988b58f36f60a149$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
        }, props, {
            newIcon: $988b58f36f60a149$var$_crossCircle.default
        }));
    $988b58f36f60a149$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $988b58f36f60a149$var$_default = module.exports.default = $988b58f36f60a149$var$CrossCircleIcon;
});
parcelRegister("2TUWQ", function(module, exports) {
    $parcel$export(module.exports, "commonSelectedStyles", ()=>$63856011855bb785$export$8633a0edef8e95dd);
    $parcel$export(module.exports, "selectOnHoverStyles", ()=>$63856011855bb785$export$860109dfd198259b);
    $parcel$export(module.exports, "emojiSprite", ()=>$63856011855bb785$export$1c10634420a08d8a);
    $parcel$export(module.exports, "emojiNodeStyles", ()=>$63856011855bb785$export$b06c4aab1d012063);
    $parcel$export(module.exports, "emojiImage", ()=>$63856011855bb785$export$da61cef1c8919f7c);
    $parcel$export(module.exports, "emojiDeleteButton", ()=>$63856011855bb785$export$b11fa39b56a371f6);
    $parcel$export(module.exports, "emojiMainStyle", ()=>$63856011855bb785$export$11462c0756c24ab6);
    $parcel$export(module.exports, "deletableEmoji", ()=>$63856011855bb785$export$22b19c311e9caa4);
    $parcel$export(module.exports, "deleteButton", ()=>$63856011855bb785$export$62f325dbfbc8f81);
    $parcel$export(module.exports, "emojiToneSelectorContainer", ()=>$63856011855bb785$export$db71293054aaa6b);
    $parcel$export(module.exports, "emojiImageContainer", ()=>$63856011855bb785$export$2734b068d8ad3149);
    $parcel$export(module.exports, "emojiSpriteContainer", ()=>$63856011855bb785$export$30d3e4d3e2eb9353);
    $parcel$export(module.exports, "placeholder", ()=>$63856011855bb785$export$c7187bbd1a7a9244);
    $parcel$export(module.exports, "placeholderContainer", ()=>$63856011855bb785$export$d2e90c45f7c3d8ae);
    $parcel$export(module.exports, "placeholderContainerAnimated", ()=>$63856011855bb785$export$7c86135efb919ea8);
    $parcel$export(module.exports, "hidden", ()=>$63856011855bb785$export$73920f18ca706874);
    $parcel$export(module.exports, "emojiButton", ()=>$63856011855bb785$export$8888b57f0a0f6212);
    $parcel$export(module.exports, "emojiRadio", ()=>$63856011855bb785$export$1f65a91a7e57ef09);
    $parcel$export(module.exports, "emojiPickerAddEmoji", ()=>$63856011855bb785$export$b0fe756d87022806);
    $parcel$export(module.exports, "previewText", ()=>$63856011855bb785$export$b0c1ec5994495ae0);
    $parcel$export(module.exports, "emojiName", ()=>$63856011855bb785$export$54f98cf16037e484);
    $parcel$export(module.exports, "emojiShortName", ()=>$63856011855bb785$export$f544abd4ed25bf26);
    $parcel$export(module.exports, "preview", ()=>$63856011855bb785$export$48c2d0f2f545ac27);
    $parcel$export(module.exports, "previewImg", ()=>$63856011855bb785$export$fd824239f75849bd);
    $parcel$export(module.exports, "emojiUpload", ()=>$63856011855bb785$export$1e9c48a9a2a120a2);
    $parcel$export(module.exports, "emojiUploadTop", ()=>$63856011855bb785$export$b79d6461124a02ae);
    $parcel$export(module.exports, "uploadChooseFileMessage", ()=>$63856011855bb785$export$e59dc3792ffcd30d);
    $parcel$export(module.exports, "closeEmojiUploadButton", ()=>$63856011855bb785$export$8560ff62d6d7b310);
    $parcel$export(module.exports, "uploadChooseFileRow", ()=>$63856011855bb785$export$8a3d57e9dcb73d21);
    $parcel$export(module.exports, "uploadChooseFileEmojiName", ()=>$63856011855bb785$export$3be66059eec1ad35);
    $parcel$export(module.exports, "uploadPreviewFooter", ()=>$63856011855bb785$export$88e7d769c40006c);
    $parcel$export(module.exports, "uploadPreview", ()=>$63856011855bb785$export$172e07efac4144fc);
    $parcel$export(module.exports, "uploadPreviewText", ()=>$63856011855bb785$export$8411439a61ad397e);
    $parcel$export(module.exports, "bigEmojiPreview", ()=>$63856011855bb785$export$4ddd1871b37bc98f);
    $parcel$export(module.exports, "uploadAddRow", ()=>$63856011855bb785$export$621cc43b2e7ce00c);
    $parcel$export(module.exports, "addCustomEmoji", ()=>$63856011855bb785$export$dced3bf3423d07ee);
    $parcel$export(module.exports, "deletePreview", ()=>$63856011855bb785$export$646fe58047f2f06b);
    $parcel$export(module.exports, "deleteText", ()=>$63856011855bb785$export$69b97c52b23537e1);
    $parcel$export(module.exports, "headingH5", ()=>$63856011855bb785$export$b47e8b05b9bbfd4d);
    $parcel$export(module.exports, "previewButtonGroup", ()=>$63856011855bb785$export$acd445d99f0cd2ca);
    $parcel$export(module.exports, "deleteFooter", ()=>$63856011855bb785$export$37160940a651309e);
    $parcel$export(module.exports, "emojiDeleteErrorMessage", ()=>$63856011855bb785$export$8e680fd3ed8103f1);
    $parcel$export(module.exports, "emojiChooseFileErrorMessage", ()=>$63856011855bb785$export$92939898c3fc14e8);
    $parcel$export(module.exports, "emojiPreviewErrorMessage", ()=>$63856011855bb785$export$363abc227d983415);
    $parcel$export(module.exports, "addCustomEmojiButton", ()=>$63856011855bb785$export$7de8c97e0e1a1a10);
    $parcel$export(module.exports, "buttonSpinner", ()=>$63856011855bb785$export$f65e889602b4eb1c);
    $parcel$export(module.exports, "emojiActionsWrapper", ()=>$63856011855bb785$export$a68c05d31ed3f6f6);
    $parcel$export(module.exports, "tooltipShortcutStyle", ()=>$63856011855bb785$export$e40bd189a7b2cd7);
    var $f8Sb3;
    var $kin1Z;
    var $24VeY;
    var $k5uoT;
    var $3RZIb;
    function $63856011855bb785$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $63856011855bb785$export$8633a0edef8e95dd = 'emoji-common-selected';
    const $63856011855bb785$export$860109dfd198259b = 'emoji-common-select-on-hover';
    const $63856011855bb785$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
    const $63856011855bb785$export$b06c4aab1d012063 = 'emoji-common-node';
    const $63856011855bb785$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
    const $63856011855bb785$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
    const $63856011855bb785$export$11462c0756c24ab6 = 'emoji-common-main-styles';
    const $63856011855bb785$export$22b19c311e9caa4 = 'emoji-common-deletable';
    const $63856011855bb785$export$62f325dbfbc8f81 = {
        name: "1e82evl",
        styles: "visibility:hidden;display:flex;position:absolute;top:var(--ds-space-negative-100, -8px);right:var(--ds-space-negative-100, -8px);z-index:1;& span{line-height:0;}"
    };
    const $63856011855bb785$export$db71293054aaa6b = {
        name: "nwmv0g",
        styles: "flex:1;display:flex;justify-content:flex-end;padding:11px 10px 12px 0"
    };
    const $63856011855bb785$export$2734b068d8ad3149 = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: "var(--ds-border-radius-100, 3px)",
        backgroundColor: 'transparent',
        display: 'inline-block',
        verticalAlign: 'middle',
        margin: '-1px 0',
        img: {
            display: 'block'
        },
        [`&.${$63856011855bb785$export$8633a0edef8e95dd},&.${$63856011855bb785$export$860109dfd198259b}:hover`]: {
            backgroundColor: (0, (0, parcelRequire("24VeY")).akEmojiSelectedBackgroundColor)
        },
        [`&.${$63856011855bb785$export$8633a0edef8e95dd},&.${$63856011855bb785$export$860109dfd198259b}:hover .${$63856011855bb785$export$b11fa39b56a371f6}`]: {
            visibility: 'visible'
        },
        [`&.${$63856011855bb785$export$22b19c311e9caa4}`]: {
            position: 'relative'
        },
        [`&.${$63856011855bb785$export$22b19c311e9caa4}:focus-within .${$63856011855bb785$export$b11fa39b56a371f6}`]: {
            visibility: 'visible'
        },
        '&:focus': {
            boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            transitionDuration: '0s, 0.2s',
            outline: 'none'
        }
    });
    const $63856011855bb785$export$30d3e4d3e2eb9353 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        margin: '-1px 0',
        [`&.${$63856011855bb785$export$8633a0edef8e95dd},&.${$63856011855bb785$export$860109dfd198259b}:hover`]: {
            backgroundColor: (0, (0, parcelRequire("24VeY")).akEmojiSelectedBackgroundColor)
        },
        [`.${$63856011855bb785$export$1c10634420a08d8a}`]: {
            background: 'transparent no-repeat',
            display: 'inline-block',
            minHeight: `${(0, (0, parcelRequire("kin1Z")).defaultEmojiHeight)}px`,
            minWidth: `${(0, (0, parcelRequire("kin1Z")).defaultEmojiHeight)}px`,
            verticalAlign: 'middle'
        },
        '&:focus': {
            boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            transitionDuration: '0s, 0.2s',
            outline: 'none'
        }
    });
    const $63856011855bb785$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
    const $63856011855bb785$export$d2e90c45f7c3d8ae = {
        name: "gb7a29",
        styles: "position:relative;margin:-1px 0;display:inline-block;background:var(--ds-border, #f7f7f7);border-radius:var(--ds-border-radius-100, 3px);overflow:hidden;vertical-align:middle;white-space:nowrap;text-align:center"
    };
    const $63856011855bb785$var$easeSweep = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        from: {
            transform: 'translateX(-100%)'
        },
        to: {
            transform: 'translateX(100%)'
        }
    });
    const $63856011855bb785$export$7c86135efb919ea8 = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`,
            height: '100%',
            width: '100%',
            animation: `${$63856011855bb785$var$easeSweep} 1s cubic-bezier(0.4, 0.0, 0.2, 1) infinite`
        }
    });
    const $63856011855bb785$export$73920f18ca706874 = {
        name: "1835etr",
        styles: "opacity:0;visibility:hidden;display:none"
    };
    const $63856011855bb785$export$8888b57f0a0f6212 = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: 'transparent',
        border: '0',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        cursor: 'pointer',
        padding: 0,
        position: 'relative',
        display: 'inline-block',
        ['&::-moz-focus-inner']: {
            border: '0 none',
            padding: 0
        },
        '&>span': {
            padding: "var(--ds-space-075, 6px)",
            [`&>.${$63856011855bb785$export$1c10634420a08d8a}`]: {
                height: '24px',
                width: '24px'
            },
            [`&>img`]: {
                height: '24px',
                width: '24px'
            }
        },
        '&:focus': {
            boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            transitionDuration: '0s, 0.2s',
            outline: 'none'
        }
    });
    const $63856011855bb785$export$1f65a91a7e57ef09 = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: 0,
        position: 'absolute',
        top: '-10px',
        left: '-10px',
        '+span': {
            borderRadius: "var(--ds-border-radius-100, 3px)"
        },
        '&:focus + span': {
            boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            transitionDuration: '0s, 0.2s',
            outline: 'none'
        }
    });
    const $63856011855bb785$export$b0fe756d87022806 = 'emoji-picker-add-emoji';
    const $63856011855bb785$export$b0c1ec5994495ae0 = {
        name: "1dn05ko",
        styles: "display:flex;flex-direction:column;align-self:center;margin-top:var(--ds-space-negative-025, -2px);margin-left:10px;max-width:285px;width:285px;flex-grow:1;flex-shrink:1"
    };
    const $63856011855bb785$export$54f98cf16037e484 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ['&:first-letter']: {
            textTransform: 'uppercase'
        }
    });
    const $63856011855bb785$export$f544abd4ed25bf26 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        lineHeight: 1,
        marginBottom: "var(--ds-space-negative-025, -2px)",
        overflow: 'hidden',
        paddingBottom: "var(--ds-space-025, 2px)",
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ['&:first-of-type']: {
            color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
        }
    });
    const $63856011855bb785$export$48c2d0f2f545ac27 = {
        name: "xc6blf",
        styles: "display:flex;flex-direction:row;flex-wrap:nowrap;padding:10px;height:32px;align-items:center"
    };
    const $63856011855bb785$export$fd824239f75849bd = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        flex: 'initial',
        width: '32px',
        [`& .${$63856011855bb785$export$1c10634420a08d8a}, span[role="img"]`]: {
            width: '32px',
            height: '32px',
            padding: 0,
            maxHeight: 'inherit'
        },
        [`& span[role="img"] > img`]: {
            position: 'relative',
            left: '50%',
            top: '50%',
            transform: 'translateX(-50%) translateY(-50%)',
            maxHeight: '32px',
            maxWidth: '32px',
            padding: 0,
            display: 'block'
        }
    });
    const $63856011855bb785$export$4e6da4bf7766def = (0, (0, parcelRequire("f8Sb3")).css)({
        border: `1px solid ${"var(--ds-border, #fff)"}`,
        borderRadius: "var(--ds-border-radius-100, 3px)",
        display: 'block',
        margin: '0',
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: '0'
    });
    const $63856011855bb785$export$1e9c48a9a2a120a2 = {
        name: "4ig074",
        styles: "height:78px;padding:10px;display:flex;flex-direction:column;justify-content:space-around"
    };
    const $63856011855bb785$export$b79d6461124a02ae = {
        name: "1vuh687",
        styles: "padding-bottom:7px;display:flex;justify-content:space-between;align-items:flex-end;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    };
    const $63856011855bb785$export$e59dc3792ffcd30d = (0, (0, parcelRequire("f8Sb3")).css)({
        '&&': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
        }
    });
    const $63856011855bb785$export$8560ff62d6d7b310 = {
        name: "zjik7",
        styles: "display:flex"
    };
    const $63856011855bb785$export$1179580a43517a40 = {
        name: "b4lf34",
        styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    };
    const $63856011855bb785$export$8a3d57e9dcb73d21 = {
        name: "t04h3w",
        styles: "display:flex;justify-content:space-between;padding-bottom:7px"
    };
    const $63856011855bb785$export$3be66059eec1ad35 = (0, (0, parcelRequire("f8Sb3")).css)({
        flex: '1 1 auto',
        marginRight: '5px',
        input: {
            background: 'transparent',
            border: 0,
            outline: 'none',
            ['&:invalid']: {
                boxShadow: 'none'
            },
            ['&::-ms-clear']: {
                display: 'none'
            }
        }
    });
    const $63856011855bb785$export$88e7d769c40006c = {
        name: "9o0thy",
        styles: "display:flex;flex-direction:column;height:100px;padding:10px"
    };
    const $63856011855bb785$export$172e07efac4144fc = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        borderRadius: "var(--ds-border-radius-100, 3px)",
        padding: '10px'
    });
    const $63856011855bb785$export$8411439a61ad397e = (0, (0, parcelRequire("f8Sb3")).css)({
        h5: {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
            paddingBottom: "var(--ds-space-050, 4px)",
            font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
        },
        img: {
            maxHeight: '20px',
            maxWidth: '50px'
        }
    });
    const $63856011855bb785$export$4ddd1871b37bc98f = {
        name: "z1virw",
        styles: "padding-left:var(--ds-space-050, 4px);img{max-height:40px;max-width:100px;}"
    };
    const $63856011855bb785$export$621cc43b2e7ce00c = {
        name: "n5qme0",
        styles: "display:flex;justify-content:flex-end;align-items:center;padding-top:10px"
    };
    const $63856011855bb785$export$dced3bf3423d07ee = {
        name: "udr5k",
        styles: "align-self:center;margin-left:10px;margin-bottom:10px"
    };
    const $63856011855bb785$export$403c84b6b5d8319b = 'emoji-submit-delete';
    const $63856011855bb785$export$646fe58047f2f06b = {
        name: "k4dmy0",
        styles: "height:100px;padding:10px;display:flex;flex-direction:column;justify-content:flex-end"
    };
    const $63856011855bb785$export$69b97c52b23537e1 = (0, (0, parcelRequire("f8Sb3")).css)({
        height: '64px',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        '&:first-of-type': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
            lineHeight: '16px'
        }
    });
    const $63856011855bb785$export$b47e8b05b9bbfd4d = (0, (0, parcelRequire("f8Sb3")).css)({
        '&&': {
            font: `var(--ds-font-body-UNSAFE_small, ${(0, (0, parcelRequire("3RZIb")).fontFallback).body.UNSAFE_small})`,
            fontWeight: "var(--ds-font-weight-semibold, 600)"
        }
    });
    const $63856011855bb785$export$1b3e3e033487450f = (0, (0, parcelRequire("f8Sb3")).css)({
        paddingLeft: "var(--ds-space-025, 2px)",
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: (0, (0, parcelRequire("k5uoT")).fontFamily)()
    });
    const $63856011855bb785$export$acd445d99f0cd2ca = {
        name: "zjik7",
        styles: "display:flex"
    };
    const $63856011855bb785$export$37160940a651309e = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '40px',
        alignItems: 'center',
        justifyContent: 'space-between',
        font: `var(--ds-font-body, ${(0, (0, parcelRequire("3RZIb")).fontFallback).body.medium})`,
        img: {
            maxHeight: '32px',
            maxWidth: '72px'
        },
        [`.${$63856011855bb785$export$403c84b6b5d8319b}`]: {
            width: '84px',
            fontWeight: "var(--ds-font-weight-bold, bold)",
            marginRight: "var(--ds-space-050, 4px)"
        }
    });
    const $63856011855bb785$export$8e680fd3ed8103f1 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingRight: "var(--ds-space-050, 4px)"
    });
    const $63856011855bb785$export$92939898c3fc14e8 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        paddingRight: '10px',
        justifyContent: 'flex-start'
    });
    const $63856011855bb785$export$363abc227d983415 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        paddingRight: '10px',
        justifyContent: 'flex-end',
        alignItems: 'center'
    });
    const $63856011855bb785$export$7de8c97e0e1a1a10 = {
        name: "1vnsw82",
        styles: "max-width:285px"
    };
    const $63856011855bb785$export$f65e889602b4eb1c = {
        name: "15lh70q",
        styles: "margin-right:10px;margin-left:10px"
    };
    const $63856011855bb785$export$a68c05d31ed3f6f6 = {
        name: "5ej25d",
        styles: "display:flex;justify-content:flex-end;align-items:center"
    };
    const $63856011855bb785$export$e40bd189a7b2cd7 = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: '3px',
        backgroundColor: `var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`,
        padding: `0 ${"var(--ds-space-025, 2px)"}`,
        label: 'tooltip-shortcut'
    });
});
parcelRegister("24VeY", function(module, exports) {
    $parcel$export(module.exports, "emojiPickerBorderColor", ()=>$cc9794b972f9b285$export$c925743aa555d078);
    $parcel$export(module.exports, "emojiPickerBoxShadow", ()=>$cc9794b972f9b285$export$af9bf85c64bea8f4);
    $parcel$export(module.exports, "noDialogContainerBorderColor", ()=>$cc9794b972f9b285$export$d4d7be6055c9b630);
    $parcel$export(module.exports, "noDialogContainerBorderRadius", ()=>$cc9794b972f9b285$export$1245062fdd1d17da);
    $parcel$export(module.exports, "noDialogContainerBoxShadow", ()=>$cc9794b972f9b285$export$e0fb6f9113466b83);
    $parcel$export(module.exports, "akEmojiSelectedBackgroundColor", ()=>$cc9794b972f9b285$export$57ff7d2ede5bd73);
    $parcel$export(module.exports, "emojiPreviewSelectedColor", ()=>$cc9794b972f9b285$export$19ac926916b8b927);
    $parcel$export(module.exports, "emojiTypeAheadMaxHeight", ()=>$cc9794b972f9b285$export$b68d1ac7839910c2);
    $parcel$export(module.exports, "emojiTypeAheadWidth", ()=>$cc9794b972f9b285$export$149c380dc04eef99);
    var $kin1Z;
    const $cc9794b972f9b285$export$23db3d0b0da6d608 = (0, (0, parcelRequire("kin1Z")).emojiPickerWidth);
    const $cc9794b972f9b285$export$7722b8e9522021df = 205;
    const $cc9794b972f9b285$export$c925743aa555d078 = `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
    const $cc9794b972f9b285$export$af9bf85c64bea8f4 = "var(--ds-shadow-overlay, 0 3px 6px rgba(0, 0, 0, 0.2))";
    const $cc9794b972f9b285$export$d4d7be6055c9b630 = `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
    const $cc9794b972f9b285$export$1245062fdd1d17da = "var(--ds-border-radius-100, 3px)";
    const $cc9794b972f9b285$export$e0fb6f9113466b83 = "var(--ds-shadow-overlay, 0 3px 6px rgba(0, 0, 0, 0.2))";
    const $cc9794b972f9b285$export$57ff7d2ede5bd73 = `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $cc9794b972f9b285$export$19ac926916b8b927 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $cc9794b972f9b285$export$b68d1ac7839910c2 = 350;
    const $cc9794b972f9b285$export$149c380dc04eef99 = 350;
});
parcelRegister("d8gl8", function(module, exports) {
    $parcel$export(module.exports, "useSampledUFOComponentExperience", ()=>$56723850686121aa$export$f959821a7419dee1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bHWpv;
    const $56723850686121aa$var$useConstructor = (callback)=>{
        const hasBeenFired = (0, $5uXOq.useRef)(false);
        if (!hasBeenFired.current) {
            callback();
            hasBeenFired.current = true;
        }
        return null;
    };
    const $56723850686121aa$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                (0, (0, parcelRequire("bHWpv")).withSampling)(experience).abort();
            };
        }, []);
        $56723850686121aa$var$useConstructor(()=>{
            (0, (0, parcelRequire("bHWpv")).withSampling)(experience).start({
                samplingRate: samplingRate
            });
            const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
            if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
        });
        return null;
    };
});
parcelRegister("lsSGz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b352fff4283dbda5$export$2e2bcd8739ae039);
    const $b352fff4283dbda5$var$result = {
        mac: false,
        supportsIntersectionObserver: false
    };
    if (typeof navigator !== 'undefined') {
        $b352fff4283dbda5$var$result.mac = /Mac/.test(navigator.platform);
        $b352fff4283dbda5$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    }
    var $b352fff4283dbda5$export$2e2bcd8739ae039 = $b352fff4283dbda5$var$result;
});
parcelRegister("7zSof", function(module, exports) {
    $parcel$export(module.exports, "useInView", ()=>$58303c715e6c41b6$export$2f62ee6831462844);
    var $6ggyj;
    var $lsSGz;
    const $58303c715e6c41b6$export$2f62ee6831462844 = (options)=>{
        const hookResult = (0, (0, parcelRequire("6ggyj")).useInView)(options);
        if (!(0, (0, parcelRequire("lsSGz")).default).supportsIntersectionObserver) return [
            undefined,
            true
        ];
        return hookResult;
    };
});
parcelRegister("6ggyj", function(module, exports) {
    $parcel$export(module.exports, "useInView", ()=>$48f113a7cf9419a6$export$2f62ee6831462844);
    var $5uXOq = parcelRequire("5uXOq");
    function $48f113a7cf9419a6$var$_extends() {
        $48f113a7cf9419a6$var$_extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return $48f113a7cf9419a6$var$_extends.apply(this, arguments);
    }
    function $48f113a7cf9419a6$var$_inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        $48f113a7cf9419a6$var$_setPrototypeOf(subClass, superClass);
    }
    function $48f113a7cf9419a6$var$_setPrototypeOf(o, p) {
        $48f113a7cf9419a6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return $48f113a7cf9419a6$var$_setPrototypeOf(o, p);
    }
    function $48f113a7cf9419a6$var$_objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    var $48f113a7cf9419a6$var$observerMap = new Map();
    var $48f113a7cf9419a6$var$RootIds = new WeakMap();
    var $48f113a7cf9419a6$var$rootId = 0;
    var $48f113a7cf9419a6$var$unsupportedValue = undefined;
    function $48f113a7cf9419a6$export$2ef3a60ee1f37bec(inView) {
        $48f113a7cf9419a6$var$unsupportedValue = inView;
    }
    function $48f113a7cf9419a6$var$getRootId(root) {
        if (!root) return '0';
        if ($48f113a7cf9419a6$var$RootIds.has(root)) return $48f113a7cf9419a6$var$RootIds.get(root);
        $48f113a7cf9419a6$var$rootId += 1;
        $48f113a7cf9419a6$var$RootIds.set(root, $48f113a7cf9419a6$var$rootId.toString());
        return $48f113a7cf9419a6$var$RootIds.get(root);
    }
    function $48f113a7cf9419a6$var$optionsToId(options) {
        return Object.keys(options).sort().filter(function(key) {
            return options[key] !== undefined;
        }).map(function(key) {
            return key + "_" + (key === 'root' ? $48f113a7cf9419a6$var$getRootId(options.root) : options[key]);
        }).toString();
    }
    function $48f113a7cf9419a6$var$createObserver(options) {
        var id = $48f113a7cf9419a6$var$optionsToId(options);
        var instance = $48f113a7cf9419a6$var$observerMap.get(id);
        if (!instance) {
            var elements = new Map();
            var thresholds;
            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    var _elements$get;
                    var inView = entry.isIntersecting && thresholds.some(function(threshold) {
                        return entry.intersectionRatio >= threshold;
                    });
                    if (options.trackVisibility && typeof entry.isVisible === 'undefined') entry.isVisible = inView;
                    (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach(function(callback) {
                        callback(inView, entry);
                    });
                });
            }, options);
            thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
                options.threshold || 0
            ]);
            instance = {
                id: id,
                observer: observer,
                elements: elements
            };
            $48f113a7cf9419a6$var$observerMap.set(id, instance);
        }
        return instance;
    }
    function $48f113a7cf9419a6$export$d1203567a167490e(element, callback, options, fallbackInView) {
        if (options === void 0) options = {};
        if (fallbackInView === void 0) fallbackInView = $48f113a7cf9419a6$var$unsupportedValue;
        if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
            var bounds = element.getBoundingClientRect();
            callback(fallbackInView, {
                isIntersecting: fallbackInView,
                target: element,
                intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
                time: 0,
                boundingClientRect: bounds,
                intersectionRect: bounds,
                rootBounds: bounds
            });
            return function() {};
        }
        var _createObserver = $48f113a7cf9419a6$var$createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements;
        var callbacks = elements.get(element) || [];
        if (!elements.has(element)) elements.set(element, callbacks);
        callbacks.push(callback);
        observer.observe(element);
        return function unobserve() {
            callbacks.splice(callbacks.indexOf(callback), 1);
            if (callbacks.length === 0) {
                elements["delete"](element);
                observer.unobserve(element);
            }
            if (elements.size === 0) {
                observer.disconnect();
                $48f113a7cf9419a6$var$observerMap["delete"](id);
            }
        };
    }
    var $48f113a7cf9419a6$var$_excluded = [
        "children",
        "as",
        "triggerOnce",
        "threshold",
        "root",
        "rootMargin",
        "onChange",
        "skip",
        "trackVisibility",
        "delay",
        "initialInView",
        "fallbackInView"
    ];
    function $48f113a7cf9419a6$var$isPlainChildren(props) {
        return typeof props.children !== 'function';
    }
    var $48f113a7cf9419a6$export$a62107ca74432f44 = function(_React$Component) {
        $48f113a7cf9419a6$var$_inheritsLoose(InView, _React$Component);
        function InView(props) {
            var _this;
            _this = _React$Component.call(this, props) || this;
            _this.node = null;
            _this._unobserveCb = null;
            _this.handleNode = function(node) {
                if (_this.node) {
                    _this.unobserve();
                    if (!node && !_this.props.triggerOnce && !_this.props.skip) _this.setState({
                        inView: !!_this.props.initialInView,
                        entry: undefined
                    });
                }
                _this.node = node ? node : null;
                _this.observeNode();
            };
            _this.handleChange = function(inView, entry) {
                if (inView && _this.props.triggerOnce) _this.unobserve();
                if (!$48f113a7cf9419a6$var$isPlainChildren(_this.props)) _this.setState({
                    inView: inView,
                    entry: entry
                });
                if (_this.props.onChange) _this.props.onChange(inView, entry);
            };
            _this.state = {
                inView: !!props.initialInView,
                entry: undefined
            };
            return _this;
        }
        var _proto = InView.prototype;
        _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
            if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
                this.unobserve();
                this.observeNode();
            }
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unobserve();
            this.node = null;
        };
        _proto.observeNode = function observeNode() {
            if (!this.node || this.props.skip) return;
            var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay, fallbackInView = _this$props.fallbackInView;
            this._unobserveCb = $48f113a7cf9419a6$export$d1203567a167490e(this.node, this.handleChange, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin,
                trackVisibility: trackVisibility,
                delay: delay
            }, fallbackInView);
        };
        _proto.unobserve = function unobserve() {
            if (this._unobserveCb) {
                this._unobserveCb();
                this._unobserveCb = null;
            }
        };
        _proto.render = function render() {
            if (!$48f113a7cf9419a6$var$isPlainChildren(this.props)) {
                var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
                return this.props.children({
                    inView: inView,
                    entry: entry,
                    ref: this.handleNode
                });
            }
            var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, props = $48f113a7cf9419a6$var$_objectWithoutPropertiesLoose(_this$props2, $48f113a7cf9419a6$var$_excluded);
            return $5uXOq.createElement(as || 'div', $48f113a7cf9419a6$var$_extends({
                ref: this.handleNode
            }, props), children);
        };
        return InView;
    }($5uXOq.Component);
    $48f113a7cf9419a6$export$a62107ca74432f44.displayName = 'InView';
    $48f113a7cf9419a6$export$a62107ca74432f44.defaultProps = {
        threshold: 0,
        triggerOnce: false,
        initialInView: false
    };
    function $48f113a7cf9419a6$export$2f62ee6831462844(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, threshold = _ref.threshold, delay = _ref.delay, trackVisibility = _ref.trackVisibility, rootMargin = _ref.rootMargin, root = _ref.root, triggerOnce = _ref.triggerOnce, skip = _ref.skip, initialInView = _ref.initialInView, fallbackInView = _ref.fallbackInView;
        var unobserve = $5uXOq.useRef();
        var _React$useState = $5uXOq.useState({
            inView: !!initialInView
        }), state = _React$useState[0], setState = _React$useState[1];
        var setRef = $5uXOq.useCallback(function(node) {
            if (unobserve.current !== undefined) {
                unobserve.current();
                unobserve.current = undefined;
            }
            if (skip) return;
            if (node) unobserve.current = $48f113a7cf9419a6$export$d1203567a167490e(node, function(inView, entry) {
                setState({
                    inView: inView,
                    entry: entry
                });
                if (entry.isIntersecting && triggerOnce && unobserve.current) {
                    unobserve.current();
                    unobserve.current = undefined;
                }
            }, {
                root: root,
                rootMargin: rootMargin,
                threshold: threshold,
                trackVisibility: trackVisibility,
                delay: delay
            }, fallbackInView);
        }, [
            Array.isArray(threshold) ? threshold.toString() : threshold,
            root,
            rootMargin,
            triggerOnce,
            skip,
            trackVisibility,
            fallbackInView,
            delay
        ]);
        (0, $5uXOq.useEffect)(function() {
            if (!unobserve.current && state.entry && !triggerOnce && !skip) setState({
                inView: !!initialInView
            });
        });
        var result = [
            setRef,
            state.inView,
            state.entry
        ];
        result.ref = result[0];
        result.inView = result[1];
        result.entry = result[2];
        return result;
    }
});
parcelRegister("jtKZR", function(module, exports) {
    $parcel$export(module.exports, "DeletableEmojiTooltipContent", ()=>$1932ba1320ae3825$export$4727956877b6f612);
    $parcel$export(module.exports, "DeletableEmojiTooltipContentForScreenReader", ()=>$1932ba1320ae3825$export$d151e4941072147c);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $aSE1r;
    var $bjlYp;
    var $cH8IX;
    var $jldZL;
    const $1932ba1320ae3825$export$4727956877b6f612 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bjlYp")).ToolTipContentWithKeymap), {
            description: formatMessage((0, (0, parcelRequire("aSE1r")).messages).deleteEmojiTooltip),
            keymap: (0, (0, parcelRequire("cH8IX")).backspace)
        });
    };
    const $1932ba1320ae3825$export$d151e4941072147c = ({ emoji: emoji })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), {
            id: `screenreader-emoji-${emoji.id}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("aSE1r")).messages).deleteEmojiTooltipForScreenreader,
            values: {
                shortName: emoji.shortName
            }
        }));
    };
});
parcelRegister("bjlYp", function(module, exports) {
    $parcel$export(module.exports, "ToolTipContentWithKeymap", ()=>$bf61861434f5a860$export$c7308f5f9ed494ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cH8IX;
    var $2TUWQ;
    const $bf61861434f5a860$export$c7308f5f9ed494ac = (0, ($parcel$interopDefault($5uXOq))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
        const shortcut = shortcutOverride || keymap && (0, (0, parcelRequire("cH8IX")).formatShortcut)(keymap);
        return shortcut || description ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, description, shortcut && description && '\u00A0', shortcut && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("2TUWQ")).tooltipShortcutStyle)
        }, shortcut)) : null;
    });
});
parcelRegister("cH8IX", function(module, exports) {
    $parcel$export(module.exports, "backspace", ()=>$8c801b5eb0fedf3e$export$1ea584ca7009bcc1);
    $parcel$export(module.exports, "formatShortcut", ()=>$8c801b5eb0fedf3e$export$384a290f8c265cc5);
    var $lsSGz;
    const $8c801b5eb0fedf3e$export$1ea584ca7009bcc1 = $8c801b5eb0fedf3e$export$7e6b588cc98b34f1('Backspace', 'Backspace');
    function $8c801b5eb0fedf3e$export$d8a7f422d8d42038(description, windows, mac, common) {
        return {
            description: description,
            windows: windows.replace(/Mod/i, 'Ctrl'),
            mac: mac.replace(/Mod/i, 'Cmd'),
            common: common
        };
    }
    function $8c801b5eb0fedf3e$export$7e6b588cc98b34f1(description, common) {
        const windows = common.replace(/Mod/i, 'Ctrl');
        const mac = common.replace(/Mod/i, 'Cmd');
        return $8c801b5eb0fedf3e$export$d8a7f422d8d42038(description, windows, mac, common);
    }
    const $8c801b5eb0fedf3e$export$8d734690d3a46118 = {
        ARROWLEFT: '\u2190',
        ARROWRIGHT: '\u2192',
        ARROWUP: '\u2191',
        ARROWDOWN: '\u2193'
    };
    function $8c801b5eb0fedf3e$export$384a290f8c265cc5(keymap) {
        let shortcut;
        if ((0, (0, parcelRequire("lsSGz")).default).mac) shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
        else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
        const keys = shortcut.split('-');
        let lastKey = keys[keys.length - 1];
        if (lastKey.length === 1) lastKey = lastKey.toUpperCase();
        keys[keys.length - 1] = $8c801b5eb0fedf3e$export$8d734690d3a46118[lastKey.toUpperCase()] || lastKey;
        return keys.join((0, (0, parcelRequire("lsSGz")).default).mac ? '' : '+');
    }
});
parcelRegister("50JWu", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$ea1a71963de9abbf$export$48d7c418edadb60c);
    var $6cAn5 = parcelRequire("6cAn5");
    function $ea1a71963de9abbf$export$48d7c418edadb60c() {
        try {
            return Boolean(typeof document === 'undefined' || typeof $6cAn5 !== 'undefined' && $6cAn5?.env?.REACT_SSR);
        } catch (e) {
            return false;
        }
    }
});
parcelRegister("kAeq1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3b03b8ed1cdbc30$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $kin1Z;
    var $2TUWQ;
    const $e3b03b8ed1cdbc30$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
    const $e3b03b8ed1cdbc30$var$EmojiPlaceholder = (props)=>{
        const { shortName: shortName, size: size = (0, (0, parcelRequire("kin1Z")).defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false } = props;
        let scaledWidth;
        let scaledHeight;
        if (representation && size) {
            const width = representation.width;
            const height = representation.height;
            if (width && height) {
                scaledWidth = size / height * width;
                scaledHeight = size;
            }
        }
        const width = scaledWidth || size;
        const height = scaledHeight || size;
        const style = {
            fill: 'f7f7f7',
            minWidth: `${width}px`,
            width: `${width}px`,
            height: `${height}px`
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-testid": $e3b03b8ed1cdbc30$export$73987987fac5266b(shortName),
            "aria-busy": loading,
            role: "status",
            "aria-label": shortName,
            className: (0, (0, parcelRequire("2TUWQ")).placeholder),
            css: loading ? [
                (0, (0, parcelRequire("2TUWQ")).placeholderContainer),
                (0, (0, parcelRequire("2TUWQ")).placeholderContainerAnimated)
            ] : (0, (0, parcelRequire("2TUWQ")).placeholderContainer),
            style: style,
            title: showTooltip ? shortName : ''
        });
    };
    var $e3b03b8ed1cdbc30$export$2e2bcd8739ae039 = $e3b03b8ed1cdbc30$var$EmojiPlaceholder;
});
parcelRegister("2l0ub", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1dfb11fb8acb3045$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $cC0Yc;
    var $jagXT;
    var $d2UcN;
    var $kin1Z;
    const $1dfb11fb8acb3045$var$ResourcedEmoji = (props)=>{
        const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
        (0, $5uXOq.useEffect)(()=>{
            if (!emojiId) return;
            var shouldAlwaysSample = (0, (0, parcelRequire("VSDnB")).fg)('platform_always_sample_rendered_emoji');
            (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emojiId).start({
                samplingRate: shouldAlwaysSample ? 1 : (0, (0, parcelRequire("kin1Z")).SAMPLING_RATE_EMOJI_RENDERED_EXP)
            });
            (0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
                source: 'ResourcedEmoji',
                emojiId: emojiId.id,
                isOptimisticImageURL: !!optimisticImageURL
            });
            return ()=>{
                (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emojiId).abort({
                    metadata: {
                        source: 'ResourcedEmoji',
                        reason: 'unmount'
                    }
                });
            };
        }, [
            emojiId,
            optimisticImageURL
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jagXT")).UfoErrorBoundary), {
            experiences: [
                (0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cC0Yc")).ResourcedEmojiComponent), props));
    };
    var $1dfb11fb8acb3045$export$2e2bcd8739ae039 = $1dfb11fb8acb3045$var$ResourcedEmoji;
});
parcelRegister("cC0Yc", function(module, exports) {
    $parcel$export(module.exports, "ResourcedEmojiComponent", ()=>$7e04d51fabd85670$export$7bfde52eceb3e2f6);
    var $5uXOq = parcelRequire("5uXOq");
    var $kin1Z;
    var $5B9Cy;
    var $9AR2K;
    var $7LZcH;
    var $kAeq1;
    var $d2UcN;
    var $fIUtB;
    var $d2UcN;
    var $7e04d51fabd85670$var$ResourcedEmojiComponentRenderStatesEnum;
    (function(ResourcedEmojiComponentRenderStatesEnum) {
        ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
        ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
        ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    })($7e04d51fabd85670$var$ResourcedEmojiComponentRenderStatesEnum || ($7e04d51fabd85670$var$ResourcedEmojiComponentRenderStatesEnum = {}));
    const $7e04d51fabd85670$export$7bfde52eceb3e2f6 = (props)=>{
        const { emojiProvider: emojiProvider, emojiId: emojiId, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, (0, parcelRequire("kin1Z")).defaultEmojiHeight), optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji } = props;
        const { shortName: shortName, id: id, fallback: fallback } = emojiId;
        const [emoji, setEmoji] = (0, $5uXOq.useState)();
        const [loaded, setLoaded] = (0, $5uXOq.useState)(false);
        const [imageLoadError, setImageLoadError] = (0, $5uXOq.useState)(false);
        const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $5uXOq.useState)();
        const fetchOrGetEmoji = (0, $5uXOq.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
            if (!_emojiProvider.fetchByEmojiId) {
                setEmoji(undefined);
                (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: 'missing fetchByEmojiId interface',
                        source: 'ResourcedEmojiComponent'
                    }
                });
            }
            const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch);
            (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emojiId).mark((0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).METADATA_START);
            if ((0, (0, parcelRequire("5B9Cy")).isPromise)(foundEmoji)) {
                setLoaded(false);
                foundEmoji.then((emoji)=>{
                    setEmoji(emoji);
                    if (!emoji) (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: 'failed to find',
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }).catch(()=>{
                    setEmoji(undefined);
                    (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: 'failed to load',
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }).finally(()=>{
                    setLoaded(true);
                    (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emojiId).mark((0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).METADATA_END);
                });
            } else {
                setEmoji(foundEmoji);
                setLoaded(true);
                (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emojiId).mark((0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).METADATA_END);
            }
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (!emojiId) return;
            if (!(0, (0, parcelRequire("d2UcN")).hasUfoMarked)((0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emojiId), (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).FMP_END)) (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emojiId).markFMP();
        }, [
            emojiId
        ]);
        (0, $5uXOq.useMemo)(()=>{
            if (!resolvedEmojiProvider || !emojiId) return;
            fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
        }, [
            resolvedEmojiProvider,
            emojiId,
            optimistic,
            fetchOrGetEmoji
        ]);
        (0, $5uXOq.useEffect)(()=>{
            Promise.resolve(emojiProvider).then((emojiProvider)=>{
                setResolvedEmojiProvider(emojiProvider);
            });
        }, [
            emojiProvider
        ]);
        const emojiRenderState = (0, $5uXOq.useMemo)(()=>{
            if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
            else if (!emoji && loaded || imageLoadError) return "FALLBACK";
            return "EMOJI";
        }, [
            emoji,
            loaded,
            optimisticImageURL,
            imageLoadError
        ]);
        const optimisticEmojiDescription = (0, $5uXOq.useMemo)(()=>{
            if (optimisticImageURL) {
                if (emoji && ((0, (0, parcelRequire("5B9Cy")).isImageRepresentation)(emoji.representation) || (0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(emoji?.representation))) {
                    const { width: width, height: height } = emoji.representation;
                    return {
                        ...emoji,
                        representation: {
                            width: width,
                            height: height,
                            imagePath: optimisticImageURL
                        }
                    };
                } else return {
                    id: id,
                    shortName: shortName,
                    fallback: fallback,
                    type: '',
                    category: '',
                    representation: {
                        height: fitToHeight || (0, (0, parcelRequire("kin1Z")).defaultEmojiHeight),
                        width: fitToHeight || (0, (0, parcelRequire("kin1Z")).defaultEmojiHeight),
                        imagePath: optimisticImageURL
                    },
                    searchable: true
                };
            }
            return emoji;
        }, [
            emoji,
            optimisticImageURL,
            fallback,
            fitToHeight,
            id,
            shortName
        ]);
        const handleOnLoadError = (0, $5uXOq.useCallback)((emojiId)=>{
            setImageLoadError(true);
            (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: 'load error',
                    source: 'ResourcedEmojiComponent',
                    emojiId: emojiId.id
                }
            });
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fIUtB")).EmojiCommonProvider), {
            emojiProvider: resolvedEmojiProvider
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-emoji-id": id,
            "data-emoji-short-name": shortName,
            "data-emoji-text": fallback || shortName
        }, emojiRenderState === "INITIAL" && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kAeq1")).default), {
            shortName: shortName,
            showTooltip: showTooltip,
            size: fitToHeight || (0, (0, parcelRequire("kin1Z")).defaultEmojiHeight),
            loading: true
        }), emojiRenderState === "FALLBACK" && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, customFallback || fallback || shortName), emojiRenderState === "EMOJI" && optimisticEmojiDescription && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7LZcH")).default), {
            emoji: optimisticEmojiDescription,
            onLoadError: handleOnLoadError,
            showTooltip: showTooltip,
            fitToHeight: fitToHeight,
            autoWidth: !!emoji ? false : true,
            editorEmoji: editorEmoji
        })));
    };
    var $7e04d51fabd85670$export$2e2bcd8739ae039 = $7e04d51fabd85670$export$7bfde52eceb3e2f6;
});
parcelRegister("fIUtB", function(module, exports) {
    $parcel$export(module.exports, "EmojiCommonProvider", ()=>$bccbd11b1b65c6ff$export$1120e666998e21b5);
    var $5uXOq = parcelRequire("5uXOq");
    var $jXu3z;
    const $bccbd11b1b65c6ff$export$1120e666998e21b5 = (props)=>{
        if (props.emojiProvider) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jXu3z")).EmojiContextProvider), {
            emojiContextValue: {
                emoji: {
                    emojiProvider: props.emojiProvider
                }
            }
        }, props.children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    };
});
parcelRegister("jXu3z", function(module, exports) {
    $parcel$export(module.exports, "EmojiContextProvider", ()=>$13463f47d01f8908$export$f4a09143833145ed);
    var $5uXOq = parcelRequire("5uXOq");
    var $hXj7Q;
    var $b8sgr;
    const $13463f47d01f8908$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
        const memoizedEmojiContextValue = (0, $5uXOq.useMemo)(()=>emojiContextValue, [
            emojiContextValue
        ]);
        (0, $5uXOq.useEffect)(()=>{
            async function fetchEmojiProvider() {
                try {
                    await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
                } catch (error) {
                    (0, (0, parcelRequire("b8sgr")).default)('fetchEmojiProvider error catched from outside', error);
                }
            }
            if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
                const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
                if (!isFetchingOnDemand) fetchEmojiProvider();
            } else fetchEmojiProvider();
        }, [
            memoizedEmojiContextValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hXj7Q")).EmojiContext).Provider, {
            value: memoizedEmojiContextValue
        }, children);
    };
});
parcelRegister("hXj7Q", function(module, exports) {
    $parcel$export(module.exports, "EmojiContext", ()=>$328171771ca4c781$export$9fab6c37a453c65e);
    var $5uXOq = parcelRequire("5uXOq");
    const $328171771ca4c781$export$9fab6c37a453c65e = (0, $5uXOq.createContext)(null);
});
parcelRegister("jagXT", function(module, exports) {
    $parcel$export(module.exports, "UfoErrorBoundary", ()=>$e764d90a3b7c2797$export$5ef1c2550074a375);
    var $5uXOq = parcelRequire("5uXOq");
    class $e764d90a3b7c2797$export$5ef1c2550074a375 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch(error, errorInfo) {
            for (const exp of this.props.experiences){
                const { name: name, message: message } = error;
                const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
                exp.failure({
                    metadata: {
                        source: 'UfoErrorBoundary',
                        reason: 'error',
                        error: {
                            name: name,
                            message: message,
                            infoStack: infoStack
                        }
                    }
                });
            }
        }
        render() {
            return this.props.children;
        }
    }
});
parcelRegister("k9ixM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$18908061011bd1ae$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $cb25w;
    var $d2UcN;
    var $1h51u;
    var $gDHgg;
    var $bWaI3;
    var $jagXT;
    var $kin1Z;
    var $fIUtB;
    const $18908061011bd1ae$var$emojiPickerModuleLoader = ()=>(parcelRequire("4eFcO"));
    const $18908061011bd1ae$var$emojiPickerLoader = ()=>$18908061011bd1ae$var$emojiPickerModuleLoader().then((module)=>module.default);
    class $18908061011bd1ae$export$bcf219a275f21b24 extends (0, (0, parcelRequire("1h51u")).default) {
        static{
            this.defaultProps = {
                size: (0, (0, parcelRequire("kin1Z")).defaultEmojiPickerSize)
            };
        }
        constructor(props){
            super(props, {}), this.state = {
                asyncLoadedComponent: $18908061011bd1ae$export$bcf219a275f21b24.AsyncLoadedComponent
            };
            (0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-picker-opened'].start();
        }
        asyncLoadComponent() {
            $18908061011bd1ae$var$emojiPickerLoader().then((component)=>{
                $18908061011bd1ae$export$bcf219a275f21b24.AsyncLoadedComponent = component;
                this.setAsyncState(component);
            });
        }
        renderLoading() {
            const item = new (0, (0, parcelRequire("gDHgg")).LoadingItem)();
            const handlePickerRef = (ref)=>{
                if (this.props.onPickerRef) this.props.onPickerRef(ref);
            };
            (0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-picker-opened'].markFMP();
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: (0, (0, parcelRequire("bWaI3")).emojiPicker)(),
                ref: handlePickerRef
            }, item.renderItem()));
        }
        renderLoaded(loadedEmojiProvider, EmojiPickerComponent) {
            const { emojiProvider: emojiProvider, ...otherProps } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jagXT")).UfoErrorBoundary), {
                experiences: [
                    (0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-picker-opened']
                ]
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fIUtB")).EmojiCommonProvider), {
                emojiProvider: loadedEmojiProvider
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(EmojiPickerComponent, otherProps)));
        }
    }
    const $18908061011bd1ae$var$EmojiPicker = (0, (0, parcelRequire("cb25w")).default)()($18908061011bd1ae$export$bcf219a275f21b24);
    var $18908061011bd1ae$export$2e2bcd8739ae039 = $18908061011bd1ae$var$EmojiPicker;
});
parcelRegister("1h51u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44a2073a204c061f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    class $44a2073a204c061f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        constructor(props, state){
            super(props), this.isUnmounted = false, this.loaded = (state)=>!!state.asyncLoadedComponent && !!state.loadedEmojiProvider;
            this.state = state;
            this.loadEmojiProvider(this.props.emojiProvider);
        }
        componentDidMount() {
            if (!this.state.asyncLoadedComponent) this.asyncLoadComponent();
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_elements_emoji')) this.loadEmojiProvider(nextProps.emojiProvider);
        }
        componentDidUpdate(prevProps) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_elements_emoji')) {
                if (this.props !== prevProps) this.loadEmojiProvider(this.props.emojiProvider);
            }
        }
        componentWillUnmount() {
            this.isUnmounted = true;
        }
        loadEmojiProvider(futureEmojiProvider) {
            futureEmojiProvider.then((loadedEmojiProvider)=>{
                if (!this.isUnmounted) this.setState({
                    loadedEmojiProvider: loadedEmojiProvider
                });
            }).catch(()=>{
                if (!this.isUnmounted) this.setState({
                    loadedEmojiProvider: undefined
                });
            });
        }
        setAsyncState(asyncLoadedComponent) {
            if (!this.isUnmounted) this.setState({
                asyncLoadedComponent: asyncLoadedComponent
            });
        }
        renderLoading() {
            return null;
        }
        render() {
            if (this.loaded(this.state)) {
                const { loadedEmojiProvider: loadedEmojiProvider, asyncLoadedComponent: asyncLoadedComponent } = this.state;
                return this.renderLoaded(loadedEmojiProvider, asyncLoadedComponent);
            }
            return this.renderLoading();
        }
    }
});
parcelRegister("gDHgg", function(module, exports) {
    $parcel$export(module.exports, "EmojisRowItem", ()=>$dc40d18219354582$export$99598b6ddae6b40f);
    $parcel$export(module.exports, "LoadingItem", ()=>$dc40d18219354582$export$a16bfd7fb92e211d);
    $parcel$export(module.exports, "CategoryHeadingItem", ()=>$dc40d18219354582$export$7fb68de373aba588);
    $parcel$export(module.exports, "virtualItemRenderer", ()=>$dc40d18219354582$export$1786779f88a71e20);
    var $f8Sb3;
    var $eZJjh;
    var $ch8Ni;
    var $8Uus1;
    var $idvip;
    var $bWaI3;
    class $dc40d18219354582$export$8faa7b3aa4960e00 {
        constructor(props, height){
            this.props = props;
            this.height = height;
        }
    }
    class $dc40d18219354582$export$99598b6ddae6b40f extends $dc40d18219354582$export$8faa7b3aa4960e00 {
        constructor(props){
            super(props, (0, (0, parcelRequire("idvip")).sizes).emojiRowHeight), this.renderItem = (context)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8Uus1")).default), {
                    ...this.props,
                    virtualItemContext: context
                });
        }
    }
    class $dc40d18219354582$export$a16bfd7fb92e211d extends $dc40d18219354582$export$8faa7b3aa4960e00 {
        constructor(){
            super({}, (0, (0, parcelRequire("idvip")).sizes).loadingRowHeight), this.renderItem = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: (0, (0, parcelRequire("bWaI3")).emojiPickerSpinner)
                }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
                    size: "medium"
                })));
        }
    }
    class $dc40d18219354582$export$7fb68de373aba588 extends $dc40d18219354582$export$8faa7b3aa4960e00 {
        constructor(props){
            super(props, (0, (0, parcelRequire("idvip")).sizes).categoryHeadingHeight), this.renderItem = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ch8Ni")).default), this.props);
        }
    }
    const $dc40d18219354582$export$1786779f88a71e20 = (rows, context)=>{
        const { index: index, key: key } = context;
        const row = rows[index];
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            key: key
        }, row && row.renderItem(context));
    };
});
parcelRegister("ch8Ni", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ab28caab6a65832$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $ousew;
    var $5B9Cy;
    var $aSE1r;
    var $bWaI3;
    const $3ab28caab6a65832$export$354d69a9ad71a0a0 = 'render-emoji-picker-categorty-heading';
    const $3ab28caab6a65832$var$EmojiPickerCategoryHeading = ({ id: id, title: title, className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            id: id,
            "data-category-id": id,
            className: className,
            "data-testid": $3ab28caab6a65832$export$354d69a9ad71a0a0,
            role: "rowheader"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("bWaI3")).emojiCategoryTitle)
        }, (0, (0, parcelRequire("5B9Cy")).isMessagesKey)(title) ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("aSE1r")).messages)[title]) : title));
    var $3ab28caab6a65832$export$2e2bcd8739ae039 = $3ab28caab6a65832$var$EmojiPickerCategoryHeading;
});
parcelRegister("bWaI3", function(module, exports) {
    $parcel$export(module.exports, "emojiPicker", ()=>$38d97a0427590411$export$4d7e4d3283b3fc57);
    $parcel$export(module.exports, "categorySelector", ()=>$38d97a0427590411$export$7c89eef3f229d1f2);
    $parcel$export(module.exports, "categorySelectorTablist", ()=>$38d97a0427590411$export$7f23f57e60dbc6be);
    $parcel$export(module.exports, "emojiPickerList", ()=>$38d97a0427590411$export$f9d03d445c711176);
    $parcel$export(module.exports, "virtualList", ()=>$38d97a0427590411$export$a6ae08629eb03133);
    $parcel$export(module.exports, "searchIcon", ()=>$38d97a0427590411$export$8687ffcdea58e000);
    $parcel$export(module.exports, "input", ()=>$38d97a0427590411$export$b7e3ae3d7c15e42e);
    $parcel$export(module.exports, "pickerSearch", ()=>$38d97a0427590411$export$1b0c24c65645549c);
    $parcel$export(module.exports, "emojiPickerSpinner", ()=>$38d97a0427590411$export$a579ece9a2e8f617);
    $parcel$export(module.exports, "emojiPickerRow", ()=>$38d97a0427590411$export$cf1a426ea4f4518f);
    $parcel$export(module.exports, "emojiCategoryTitle", ()=>$38d97a0427590411$export$424c09992034cd7b);
    $parcel$export(module.exports, "emojiItem", ()=>$38d97a0427590411$export$a4a44ff8714b822c);
    $parcel$export(module.exports, "emojiPickerFooter", ()=>$38d97a0427590411$export$846f87d37982f09e);
    $parcel$export(module.exports, "emojiPickerFooterWithTopShadow", ()=>$38d97a0427590411$export$f3fb7231c82af364);
    $parcel$export(module.exports, "emojiActionsContainerWithBottomShadow", ()=>$38d97a0427590411$export$48935215d23ca864);
    var $f8Sb3;
    var $24VeY;
    var $2TUWQ;
    var $kin1Z;
    var $dh8C2;
    function $38d97a0427590411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $38d97a0427590411$export$4d7e4d3283b3fc57 = (hasPreview, size = (0, (0, parcelRequire("kin1Z")).defaultEmojiPickerSize))=>{
        const heightOffset = (0, (0, parcelRequire("dh8C2")).emojiPickerHeightOffset)(size);
        return (0, (0, parcelRequire("f8Sb3")).css)({
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            background: "var(--ds-surface-overlay, white)",
            border: `${(0, (0, parcelRequire("24VeY")).emojiPickerBorderColor)} 1px solid`,
            borderRadius: "var(--ds-border-radius-100, 3px)",
            boxShadow: (0, (0, parcelRequire("24VeY")).emojiPickerBoxShadow),
            height: `${hasPreview ? (0, (0, parcelRequire("kin1Z")).emojiPickerHeightWithPreview) + heightOffset : (0, (0, parcelRequire("kin1Z")).emojiPickerHeight) + heightOffset}px`,
            width: `${(0, (0, parcelRequire("kin1Z")).emojiPickerWidth)}px`,
            minWidth: `${(0, (0, parcelRequire("kin1Z")).emojiPickerWidth)}px`,
            minHeight: `${(0, (0, parcelRequire("kin1Z")).emojiPickerMinHeight) + heightOffset}px`,
            maxHeight: 'calc(80vh - 86px)'
        });
    };
    const $38d97a0427590411$export$7c89eef3f229d1f2 = (0, (0, parcelRequire("f8Sb3")).css)({
        flex: '0 0 auto',
        backgroundColor: `var(--ds-surface-sunken, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        button: {
            display: 'flex'
        }
    });
    const $38d97a0427590411$export$7f23f57e60dbc6be = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center'
    });
    const $38d97a0427590411$export$f9d03d445c711176 = {
        name: "122uufz",
        styles: "display:flex;flex-direction:column;flex:1 1 auto;height:0"
    };
    const $38d97a0427590411$export$a6ae08629eb03133 = {
        name: "x1r3en",
        styles: "overflow-x:hidden;overflow-y:auto;&:focus{outline:none;}padding-bottom:var(--ds-space-100, 8px)"
    };
    const $38d97a0427590411$export$8687ffcdea58e000 = {
        name: "91qhdj",
        styles: "opacity:0.5;margin-left:var(--ds-space-negative-025, -2px)"
    };
    const $38d97a0427590411$export$b7e3ae3d7c15e42e = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        outline: 'none',
        padding: `1px ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`,
        width: '100%',
        ['&:invalid']: {
            boxShadow: 'none'
        },
        ['&::-ms-clear']: {
            display: 'none'
        }
    });
    const $38d97a0427590411$export$1b0c24c65645549c = {
        name: "1efm33k",
        styles: "box-sizing:border-box;padding:var(--ds-space-150, 12px);width:100%"
    };
    const $38d97a0427590411$export$a579ece9a2e8f617 = {
        name: "1ebchlz",
        styles: "display:flex;width:100%;height:150px;justify-content:center;align-items:center;>div{flex:0 0 auto;}"
    };
    const $38d97a0427590411$export$cf1a426ea4f4518f = {
        name: "9kivhj",
        styles: "margin-left:var(--ds-space-100, 8px)"
    };
    const $38d97a0427590411$export$424c09992034cd7b = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
        textTransform: 'lowercase',
        '&:first-letter': {
            textTransform: 'uppercase'
        }
    });
    const $38d97a0427590411$export$a4a44ff8714b822c = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        textAlign: 'center',
        width: '40px',
        [`& .${0, (0, parcelRequire("2TUWQ")).emojiNodeStyles}`]: {
            cursor: 'pointer',
            padding: "var(--ds-space-100, 8px)",
            borderRadius: '5px',
            width: '24px',
            height: '24px'
        },
        [`& .${0, (0, parcelRequire("2TUWQ")).placeholder}`]: {
            padding: "var(--ds-space-0, 0px)",
            margin: "var(--ds-space-100, 8px)",
            minWidth: '24px',
            maxWidth: '24px'
        },
        [`& .${0, (0, parcelRequire("2TUWQ")).emojiNodeStyles} .${0, (0, parcelRequire("2TUWQ")).placeholder}`]: {
            margin: "var(--ds-space-0, 0px)"
        },
        [`& .${0, (0, parcelRequire("2TUWQ")).emojiNodeStyles} > img`]: {
            position: 'relative',
            left: '50%',
            top: '50%',
            transform: 'translateX(-50%) translateY(-50%)',
            maxHeight: '24px',
            maxWidth: '24px',
            display: 'block'
        },
        [`& .${0, (0, parcelRequire("2TUWQ")).emojiNodeStyles} > .${0, (0, parcelRequire("2TUWQ")).emojiSprite}`]: {
            height: '24px',
            width: '24px'
        }
    });
    const $38d97a0427590411$export$846f87d37982f09e = {
        name: "ou8xsw",
        styles: "flex:0 0 auto"
    };
    const $38d97a0427590411$export$f3fb7231c82af364 = (0, (0, parcelRequire("f8Sb3")).css)({
        borderTop: `2px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`}`,
        boxShadow: `0px -1px 1px 0px ${"var(--ds-border, rgba(0, 0, 0, 0.1))"}`
    });
    const $38d97a0427590411$export$48935215d23ca864 = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBottom: `2px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`}`,
        boxShadow: `0px 1px 1px 0px ${"var(--ds-border, rgba(0, 0, 0, 0.1))"}`
    });
});
parcelRegister("dh8C2", function(module, exports) {
    $parcel$export(module.exports, "emojiPickerHeightOffset", ()=>$5d5fdf8b1c2caf31$export$54c040840696be9a);
    $parcel$export(module.exports, "scrollToRow", ()=>$5d5fdf8b1c2caf31$export$71590875881b540);
    var $kin1Z;
    const $5d5fdf8b1c2caf31$export$54c040840696be9a = (size)=>{
        if (size === 'medium') return 0, (0, parcelRequire("kin1Z")).sizeGap;
        else if (size === 'large') return (0, (0, parcelRequire("kin1Z")).sizeGap) * 2;
        return 0;
    };
    const $5d5fdf8b1c2caf31$export$71590875881b540 = (listRef, index)=>{
        listRef.current?.scrollToRow(index);
    };
});
parcelRegister("8Uus1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55af6a6500a6382e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $9MC40;
    var $bWaI3;
    var $lWKb4;
    var $aSE1r;
    const $55af6a6500a6382e$var$EmojiPickerEmojiRow = ({ emojis: emojis, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, title: title, showDelete: showDelete, onDelete: onDelete, virtualItemContext: virtualItemContext })=>{
        const { currentEmojisFocus: currentEmojisFocus, setEmojisFocus: setEmojisFocus } = (0, (0, parcelRequire("lWKb4")).useEmojiPickerListContext)();
        const rowIndex = virtualItemContext?.index || 0;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleFocus = (index)=>(emojiId, emoji, event)=>{
                setEmojisFocus({
                    rowIndex: rowIndex,
                    columnIndex: index
                });
                onFocus && onFocus(emojiId, emoji, event);
            };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("bWaI3")).emojiPickerRow),
            role: "presentation"
        }, emojis.map((emoji, index)=>{
            const { shortName: shortName, id: id } = emoji;
            const key = id ? `${id}-${title}` : `${shortName}-${title}`;
            const focus = currentEmojisFocus.rowIndex === rowIndex && currentEmojisFocus.columnIndex === index;
            return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: (0, (0, parcelRequire("bWaI3")).emojiItem),
                key: key,
                role: "gridcell",
                "aria-colindex": index + 1
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9MC40")).default), {
                emoji: emoji,
                selectOnHover: true,
                onSelected: onSelected,
                onMouseMove: onMouseMove,
                onFocus: handleFocus(index),
                showDelete: showDelete,
                onDelete: onDelete,
                placeholderSize: 24,
                "data-focus-index": `${rowIndex}-${index}`,
                tabIndex: focus ? 0 : -1,
                "aria-roledescription": formatMessage((0, (0, parcelRequire("aSE1r")).messages).emojiButtonRoleDescription),
                shouldBeInteractive: true
            }));
        })));
    };
    var $55af6a6500a6382e$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($55af6a6500a6382e$var$EmojiPickerEmojiRow);
});
parcelRegister("9MC40", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$edb6887b165c9a7a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5B9Cy;
    var $9AR2K;
    var $b8sgr;
    var $7LZcH;
    var $kAeq1;
    var $jagXT;
    var $d2UcN;
    var $d8gl8;
    var $kin1Z;
    var $d2UcN;
    var $4tMKr;
    var $bNyWE;
    const $edb6887b165c9a7a$export$e81207f376d36133 = (props)=>{
        const { emoji: emoji, placeholderSize: placeholderSize, ...restProps } = props;
        (0, (0, parcelRequire("d8gl8")).useSampledUFOComponentExperience)((0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, (0, parcelRequire("kin1Z")).SAMPLING_RATE_EMOJI_RENDERED_EXP), {
            source: 'CachingEmoji',
            emojiId: emoji.id
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("d2UcN")).hasUfoMarked)((0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emoji), 'fmp')) (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emoji).markFMP();
        }, []);
        const emojiNode = ()=>{
            if ((0, (0, parcelRequire("5B9Cy")).isMediaEmoji)(emoji)) return (0, ($parcel$interopDefault($5uXOq))).createElement($edb6887b165c9a7a$export$aa961da7639f7a98, {
                emoji: emoji,
                placeholderSize: placeholderSize,
                ...restProps
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7LZcH")).default), {
                emoji: emoji,
                ...restProps
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jagXT")).UfoErrorBoundary), {
            experiences: [
                (0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-rendered'].getInstance(props.emoji.id || props.emoji.shortName)
            ]
        }, emojiNode());
    };
    const $edb6887b165c9a7a$export$aa961da7639f7a98 = (props)=>{
        const { emoji: emoji, placeholderSize: placeholderSize, showTooltip: showTooltip, fitToHeight: fitToHeight, children: children, ...restProps } = props;
        const { shortName: shortName, representation: representation } = emoji;
        const [cachedEmoji, setCachedEmoji] = (0, $5uXOq.useState)();
        const [inValidImage, setInvalidImage] = (0, $5uXOq.useState)(false);
        const { emojiProvider: emojiProvider } = (0, (0, parcelRequire("4tMKr")).useEmoji)();
        const loadEmoji = (0, $5uXOq.useCallback)((emojiProvider)=>{
            (0, (0, parcelRequire("b8sgr")).default)('Loading image via media cache', emoji.shortName);
            (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emoji).mark((0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).MEDIA_START);
            emojiProvider.getMediaEmojiDescriptionURLWithInlineToken(emoji).then((cachedEmoji)=>{
                setCachedEmoji(cachedEmoji);
                setInvalidImage(false);
                (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emoji).mark((0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).MEDIA_END);
            }).catch((error)=>{
                setCachedEmoji(undefined);
                setInvalidImage(true);
                (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(emoji).failure({
                    metadata: {
                        error: (0, (0, parcelRequire("bNyWE")).extractErrorInfo)(error),
                        reason: 'failed to load media emoji',
                        source: 'CachingMediaEmoji',
                        emojiId: emoji.id
                    }
                });
            });
        }, [
            emoji
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (emojiProvider) loadEmoji(emojiProvider);
        }, [
            emojiProvider,
            loadEmoji
        ]);
        const handleLoadError = (_emojiId)=>{
            (0, (0, parcelRequire("d2UcN")).sampledUfoRenderedEmoji)(_emojiId).failure({
                metadata: {
                    reason: 'load error',
                    source: 'CachingMediaEmoji',
                    emojiId: _emojiId.id
                }
            });
            setInvalidImage(true);
        };
        if (cachedEmoji && !inValidImage) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7LZcH")).default), {
            ...restProps,
            showTooltip: showTooltip,
            fitToHeight: fitToHeight,
            emoji: cachedEmoji,
            onLoadError: handleLoadError
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kAeq1")).default), {
            size: fitToHeight || placeholderSize,
            shortName: shortName,
            showTooltip: showTooltip,
            representation: representation
        });
    };
    var $edb6887b165c9a7a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($edb6887b165c9a7a$export$e81207f376d36133);
});
parcelRegister("4tMKr", function(module, exports) {
    $parcel$export(module.exports, "useEmoji", ()=>$764410eb7b73b8ee$export$482903c4ce3f5633);
    var $5uXOq = parcelRequire("5uXOq");
    var $hXj7Q;
    const $764410eb7b73b8ee$var$supportsUploadFeature = (emojiProvider)=>{
        const emojiUploadProvider = emojiProvider;
        return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
    };
    const $764410eb7b73b8ee$export$482903c4ce3f5633 = ()=>{
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("hXj7Q")).EmojiContext));
        const [isUploadSupported, setIsUploadSupported] = (0, $5uXOq.useState)(false);
        if (!context) throw new Error('useEmoji must be used within EmojiContext');
        const { emojiProvider: emojiProvider } = context.emoji;
        (0, $5uXOq.useEffect)(()=>{
            if ($764410eb7b73b8ee$var$supportsUploadFeature(emojiProvider)) {
                const checkIfUploadIsSupported = async ()=>{
                    try {
                        const supported = await emojiProvider.isUploadSupported();
                        setIsUploadSupported(supported);
                    } catch (error) {
                        return false;
                    }
                };
                checkIfUploadIsSupported();
            }
        }, [
            emojiProvider
        ]);
        return {
            emojiProvider: emojiProvider,
            isUploadSupported: isUploadSupported
        };
    };
});
parcelRegister("bNyWE", function(module, exports) {
    $parcel$export(module.exports, "createAndFireEventInElementsChannel", ()=>$c50d4677eacae213$export$53eef0dcd9611650);
    $parcel$export(module.exports, "recordSucceededEmoji", ()=>$c50d4677eacae213$export$3125c3f60f61a0a9);
    $parcel$export(module.exports, "recordFailedEmoji", ()=>$c50d4677eacae213$export$ccd0c8bcbda28b7a);
    $parcel$export(module.exports, "openedPickerEvent", ()=>$c50d4677eacae213$export$956acef77052d363);
    $parcel$export(module.exports, "closedPickerEvent", ()=>$c50d4677eacae213$export$151c59c3f6a1ff5f);
    $parcel$export(module.exports, "pickerClickedEvent", ()=>$c50d4677eacae213$export$d69b5cd43769bb6b);
    $parcel$export(module.exports, "categoryClickedEvent", ()=>$c50d4677eacae213$export$8e021f755a07e0d2);
    $parcel$export(module.exports, "pickerSearchedEvent", ()=>$c50d4677eacae213$export$d800a6d814034c48);
    $parcel$export(module.exports, "toneSelectedEvent", ()=>$c50d4677eacae213$export$e559e98af3da9d17);
    $parcel$export(module.exports, "toneSelectorOpenedEvent", ()=>$c50d4677eacae213$export$7274b855c80879c4);
    $parcel$export(module.exports, "toneSelectorClosedEvent", ()=>$c50d4677eacae213$export$301f0d0181307f7);
    $parcel$export(module.exports, "uploadBeginButton", ()=>$c50d4677eacae213$export$be48de448ed1f64f);
    $parcel$export(module.exports, "uploadConfirmButton", ()=>$c50d4677eacae213$export$b82a2393560e5893);
    $parcel$export(module.exports, "uploadCancelButton", ()=>$c50d4677eacae213$export$47ef032c3ec0a60a);
    $parcel$export(module.exports, "uploadSucceededEvent", ()=>$c50d4677eacae213$export$6aed2b90719a7d39);
    $parcel$export(module.exports, "uploadFailedEvent", ()=>$c50d4677eacae213$export$18cfbd0c8c6d2297);
    $parcel$export(module.exports, "deleteBeginEvent", ()=>$c50d4677eacae213$export$d74d89c79fff5a67);
    $parcel$export(module.exports, "deleteConfirmEvent", ()=>$c50d4677eacae213$export$87a8007f9e978b47);
    $parcel$export(module.exports, "deleteCancelEvent", ()=>$c50d4677eacae213$export$9877255e5a8f0cde);
    $parcel$export(module.exports, "selectedFileEvent", ()=>$c50d4677eacae213$export$fc14407a1d009938);
    $parcel$export(module.exports, "recordSelectionSucceededSli", ()=>$c50d4677eacae213$export$524400435f62e003);
    $parcel$export(module.exports, "recordSelectionFailedSli", ()=>$c50d4677eacae213$export$d1176b797f0912b8);
    $parcel$export(module.exports, "extractErrorInfo", ()=>$c50d4677eacae213$export$74aaf4784c2edb2c);
    var $gB4mS;
    var $9AR2K;
    const $c50d4677eacae213$export$53eef0dcd9611650 = (0, (0, parcelRequire("gB4mS")).default)('fabric-elements');
    const $c50d4677eacae213$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
            eventType: eventType,
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                packageName: "platform-pkg",
                packageVersion: "0.0.0-use.local",
                ...attributes
            }
        });
    const $c50d4677eacae213$export$3125c3f60f61a0a9 = (emoji)=>(source)=>{
            return $c50d4677eacae213$var$createEvent('operational', 'succeeded', 'recordEmojiSelection', undefined, {
                source: source,
                emojiId: emoji?.id,
                emojiType: emoji?.type,
                emojiCategory: emoji?.category
            });
        };
    const $c50d4677eacae213$export$4e713a2b020a4dca = (source)=>{
        return $c50d4677eacae213$var$createEvent('operational', 'succeeded', 'recordEmojiSelection', undefined, {
            source: source
        });
    };
    const $c50d4677eacae213$export$ccd0c8bcbda28b7a = (emoji)=>(source)=>{
            return $c50d4677eacae213$var$createEvent('operational', 'failed', 'recordEmojiSelection', undefined, {
                source: source,
                emojiId: emoji?.id,
                emojiType: emoji?.type,
                emojiCategory: emoji?.category
            });
        };
    const $c50d4677eacae213$export$5bd025a43378005c = (source)=>{
        return $c50d4677eacae213$var$createEvent('operational', 'failed', 'recordEmojiSelection', undefined, {
            source: source
        });
    };
    const $c50d4677eacae213$var$emojiPickerEvent = (action, attributes = {}, actionSubjectId)=>$c50d4677eacae213$var$createEvent('ui', action, 'emojiPicker', actionSubjectId, attributes);
    const $c50d4677eacae213$export$956acef77052d363 = ()=>$c50d4677eacae213$var$emojiPickerEvent('opened');
    const $c50d4677eacae213$export$151c59c3f6a1ff5f = (attributes)=>$c50d4677eacae213$var$emojiPickerEvent('closed', attributes);
    const $c50d4677eacae213$var$skinTones = [
        {
            id: '-1f3fb',
            skinToneModifier: 'light'
        },
        {
            id: '-1f3fc',
            skinToneModifier: 'mediumLight'
        },
        {
            id: '-1f3fd',
            skinToneModifier: 'medium'
        },
        {
            id: '-1f3fe',
            skinToneModifier: 'mediumDark'
        },
        {
            id: '-1f3ff',
            skinToneModifier: 'dark'
        }
    ];
    const $c50d4677eacae213$var$getSkinTone = (emojiId)=>{
        if (!emojiId) return {};
        for (const { id: id, skinToneModifier: skinToneModifier } of $c50d4677eacae213$var$skinTones){
            if (emojiId.indexOf(id) !== -1) return {
                skinToneModifier: skinToneModifier,
                baseEmojiId: emojiId.replace(id, '')
            };
        }
        return {};
    };
    const $c50d4677eacae213$export$d69b5cd43769bb6b = (attributes)=>$c50d4677eacae213$var$emojiPickerEvent('clicked', {
            ...$c50d4677eacae213$var$getSkinTone(attributes.emojiId),
            ...attributes
        }, 'emoji');
    const $c50d4677eacae213$export$8e021f755a07e0d2 = (attributes)=>$c50d4677eacae213$var$emojiPickerEvent('clicked', attributes, 'category');
    const $c50d4677eacae213$export$d800a6d814034c48 = (attributes)=>$c50d4677eacae213$var$emojiPickerEvent('searched', attributes, 'query');
    const $c50d4677eacae213$var$skintoneSelectorEvent = (action, attributes = {})=>$c50d4677eacae213$var$createEvent('ui', action, 'emojiSkintoneSelector', undefined, attributes);
    const $c50d4677eacae213$export$e559e98af3da9d17 = (attributes)=>$c50d4677eacae213$var$skintoneSelectorEvent('clicked', attributes);
    const $c50d4677eacae213$export$7274b855c80879c4 = (attributes)=>$c50d4677eacae213$var$skintoneSelectorEvent('opened', attributes);
    const $c50d4677eacae213$export$301f0d0181307f7 = ()=>$c50d4677eacae213$var$skintoneSelectorEvent('cancelled');
    const $c50d4677eacae213$var$emojiUploaderEvent = (action, actionSubjectId, attributes)=>$c50d4677eacae213$var$createEvent('ui', action, 'emojiUploader', actionSubjectId, attributes);
    const $c50d4677eacae213$export$be48de448ed1f64f = ()=>$c50d4677eacae213$var$emojiUploaderEvent('clicked', 'addButton');
    const $c50d4677eacae213$export$b82a2393560e5893 = (attributes)=>$c50d4677eacae213$var$emojiUploaderEvent('clicked', 'confirmButton', attributes);
    const $c50d4677eacae213$export$47ef032c3ec0a60a = ()=>$c50d4677eacae213$var$emojiUploaderEvent('clicked', 'cancelButton');
    const $c50d4677eacae213$export$6aed2b90719a7d39 = (attributes)=>$c50d4677eacae213$var$createEvent('operational', 'finished', 'emojiUploader', undefined, attributes);
    const $c50d4677eacae213$export$18cfbd0c8c6d2297 = (attributes)=>$c50d4677eacae213$var$createEvent('operational', 'failed', 'emojiUploader', undefined, attributes);
    const $c50d4677eacae213$export$d74d89c79fff5a67 = (attributes)=>$c50d4677eacae213$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiTrigger', attributes);
    const $c50d4677eacae213$export$87a8007f9e978b47 = (attributes)=>$c50d4677eacae213$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiConfirm', attributes);
    const $c50d4677eacae213$export$9877255e5a8f0cde = (attributes)=>$c50d4677eacae213$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiCancel', attributes);
    const $c50d4677eacae213$export$fc14407a1d009938 = ()=>$c50d4677eacae213$var$createEvent('ui', 'clicked', 'emojiUploader', 'selectFile');
    const $c50d4677eacae213$var$extractCommonAttributes = (query, emojiList)=>{
        return {
            queryLength: query ? query.length : 0,
            spaceInQuery: query ? query.indexOf(' ') !== -1 : false,
            emojiIds: emojiList ? emojiList.map((emoji)=>emoji.id).filter(Boolean).slice(0, 20) : []
        };
    };
    const $c50d4677eacae213$export$89566522a5321393 = (duration, query, emojiList)=>$c50d4677eacae213$var$createEvent('ui', 'cancelled', 'emojiTypeahead', undefined, {
            duration: duration,
            ...$c50d4677eacae213$var$extractCommonAttributes(query, emojiList)
        });
    const $c50d4677eacae213$var$getPosition = (emojiList, selectedEmoji)=>{
        if (emojiList) {
            const index = emojiList.findIndex((emoji)=>emoji.id === selectedEmoji.id);
            return index === -1 ? undefined : index;
        }
        return;
    };
    const $c50d4677eacae213$export$475603c082d8a174 = (pressed, duration, emoji, emojiList, query, exactMatch)=>$c50d4677eacae213$var$createEvent('ui', pressed ? 'pressed' : 'clicked', 'emojiTypeahead', undefined, {
            duration: duration,
            position: $c50d4677eacae213$var$getPosition(emojiList, emoji),
            ...$c50d4677eacae213$var$extractCommonAttributes(query, emojiList),
            ...$c50d4677eacae213$var$getSkinTone(emoji.id),
            emojiType: emoji.type,
            exactMatch: exactMatch || false
        });
    const $c50d4677eacae213$export$bbbb081930a4e19d = (duration, query, emojiList)=>$c50d4677eacae213$var$createEvent('operational', 'rendered', 'emojiTypeahead', undefined, {
            duration: duration,
            ...$c50d4677eacae213$var$extractCommonAttributes(query, emojiList)
        });
    const $c50d4677eacae213$export$524400435f62e003 = (emoji, options)=>()=>{
            if (options && options.createAnalyticsEvent) (0, (0, parcelRequire("gB4mS")).default)('editor')($c50d4677eacae213$export$3125c3f60f61a0a9(emoji)((0, (0, parcelRequire("9AR2K")).SearchSourceTypes).TYPEAHEAD))(options.createAnalyticsEvent);
        };
    const $c50d4677eacae213$export$d1176b797f0912b8 = (emoji, options)=>(err)=>{
            if (options && options.createAnalyticsEvent) (0, (0, parcelRequire("gB4mS")).default)('editor')($c50d4677eacae213$export$ccd0c8bcbda28b7a(emoji)((0, (0, parcelRequire("9AR2K")).SearchSourceTypes).TYPEAHEAD))(options.createAnalyticsEvent);
            return Promise.reject(err);
        };
    const $c50d4677eacae213$export$74aaf4784c2edb2c = (error)=>{
        if (error instanceof Error) return {
            name: error.name,
            message: error.message
        };
        return error;
    };
});
parcelRegister("lWKb4", function(module, exports) {
    $parcel$export(module.exports, "useEmojiPickerListContext", ()=>$8bc24763db69c878$export$1d569b16c0178739);
    var $5uXOq = parcelRequire("5uXOq");
    var $e7rQA;
    const $8bc24763db69c878$export$1d569b16c0178739 = ()=>(0, $5uXOq.useContext)((0, (0, parcelRequire("e7rQA")).EmojiPickerListContext));
});
parcelRegister("e7rQA", function(module, exports) {
    $parcel$export(module.exports, "EmojiPickerListContext", ()=>$df2e7a5f6081bf32$export$968c8d71e683bcd1);
    $parcel$export(module.exports, "EmojiPickerListContextProvider", ()=>$df2e7a5f6081bf32$export$6f4d9357992f0254);
    var $5uXOq = parcelRequire("5uXOq");
    const $df2e7a5f6081bf32$export$968c8d71e683bcd1 = (0, $5uXOq.createContext)({
        currentEmojisFocus: {
            rowIndex: 0,
            columnIndex: 0
        },
        setEmojisFocus: ()=>{}
    });
    const $df2e7a5f6081bf32$export$6f4d9357992f0254 = (props)=>{
        const [currentEmojisFocus, setEmojisFocus] = (0, $5uXOq.useState)(props.initialEmojisFocus);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($df2e7a5f6081bf32$export$968c8d71e683bcd1.Provider, {
            value: {
                currentEmojisFocus: currentEmojisFocus,
                setEmojisFocus: setEmojisFocus
            }
        }, props.children);
    };
});
parcelRegister("idvip", function(module, exports) {
    $parcel$export(module.exports, "sizes", ()=>$d3af91510c24d35d$export$c647cb0ee6e282fe);
    var $kin1Z;
    const $d3af91510c24d35d$export$c647cb0ee6e282fe = {
        listHeight: (0, (0, parcelRequire("kin1Z")).emojiPickerListHeight),
        listWidth: (0, (0, parcelRequire("kin1Z")).emojiPickerWidth),
        searchHeight: 52,
        categoryHeadingHeight: 30,
        emojiRowHeight: 40,
        addEmojiHeight: 32,
        loadingRowHeight: 150,
        uploadActionHeight: 40,
        emojiPerRow: 8
    };
});
parcelRegister("4eFcO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hcfj2")
    ]).then(()=>parcelRequire('h7V3i'));
});
parcelRegister("qb63L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0a0bc4fa1f045d1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $5B9Cy;
    var $6f82C;
    var $eZwRF;
    var $fIUtB;
    var $h14c7;
    class $e0a0bc4fa1f045d1$var$EmojiTypeAheadItemInternal extends (0, $5uXOq.PureComponent) {
        render() {
            const { selected: selected, emoji: emoji, emojiProvider: emojiProvider } = this.props;
            const classes = [
                (0, (0, parcelRequire("h14c7")).typeAheadItem),
                selected && (0, (0, parcelRequire("h14c7")).selected)
            ];
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fIUtB")).EmojiCommonProvider), {
                emojiProvider: emojiProvider
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                className: `ak-emoji-typeahead-item ${selected ? (0, (0, parcelRequire("h14c7")).typeaheadSelected) : ''}`,
                css: classes,
                onMouseDown: this.onEmojiSelected,
                onMouseMove: this.onEmojiMenuItemMouseMove,
                "data-emoji-id": emoji.shortName,
                ref: this.props.forwardedRef
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: (0, (0, parcelRequire("h14c7")).typeAheadItemRow)
            }, emoji && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZwRF")).EmojiPreviewComponent), {
                emoji: emoji
            }))));
        }
        constructor(...args){
            super(...args), this.onEmojiSelected = (event)=>{
                const { emoji: emoji, onSelection: onSelection } = this.props;
                if ((0, (0, parcelRequire("6f82C")).leftClick)(event) && onSelection) {
                    event.preventDefault();
                    onSelection((0, (0, parcelRequire("5B9Cy")).toEmojiId)(emoji), emoji, event);
                }
            }, this.onEmojiMenuItemMouseMove = (event)=>{
                const { emoji: emoji, onMouseMove: onMouseMove } = this.props;
                if (onMouseMove) onMouseMove((0, (0, parcelRequire("5B9Cy")).toEmojiId)(emoji), emoji, event);
            };
        }
    }
    const $e0a0bc4fa1f045d1$var$EmojiTypeAheadItem = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)($e0a0bc4fa1f045d1$var$EmojiTypeAheadItemInternal, {
            ...props,
            forwardedRef: ref
        });
    });
    var $e0a0bc4fa1f045d1$export$2e2bcd8739ae039 = $e0a0bc4fa1f045d1$var$EmojiTypeAheadItem;
});
parcelRegister("eZwRF", function(module, exports) {
    $parcel$export(module.exports, "EmojiPreviewComponent", ()=>$765c403a38efdb02$export$222c91bd2db2d158);
    var $f8Sb3;
    var $9MC40;
    var $2TUWQ;
    const $765c403a38efdb02$export$222c91bd2db2d158 = ({ emoji: emoji })=>{
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("2TUWQ")).preview)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("2TUWQ")).previewImg)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9MC40")).default), {
            key: emoji.id || emoji.shortName,
            emoji: emoji
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("2TUWQ")).previewText)
        }, emoji.name && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("2TUWQ")).emojiName)
        }, emoji.name), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("2TUWQ")).emojiShortName)
        }, emoji.shortName))));
    };
});
parcelRegister("h14c7", function(module, exports) {
    $parcel$export(module.exports, "typeaheadSelected", ()=>$bdde198ca5c4332c$export$214089244105a739);
    $parcel$export(module.exports, "selected", ()=>$bdde198ca5c4332c$export$d90250155de6d7e7);
    $parcel$export(module.exports, "typeAheadItem", ()=>$bdde198ca5c4332c$export$cc2c857259981452);
    $parcel$export(module.exports, "typeAheadItemRow", ()=>$bdde198ca5c4332c$export$60dc9fd85ca58ef5);
    var $f8Sb3;
    var $24VeY;
    function $bdde198ca5c4332c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bdde198ca5c4332c$export$dca0df2a2f0ab6cf = 'emoji-typeahead-element';
    const $bdde198ca5c4332c$export$9b2d029b494a863e = 'emoji-typeahead-list-container';
    const $bdde198ca5c4332c$export$214089244105a739 = 'emoji-typeahead-selected';
    const $bdde198ca5c4332c$export$261a9e7d3ba3728d = (0, (0, parcelRequire("f8Sb3")).css)({
        background: "var(--ds-surface-overlay, white)",
        border: `1px solid ${(0, (0, parcelRequire("24VeY")).noDialogContainerBorderColor)}`,
        borderRadius: (0, (0, parcelRequire("24VeY")).noDialogContainerBorderRadius),
        boxShadow: (0, (0, parcelRequire("24VeY")).noDialogContainerBoxShadow),
        color: "var(--ds-text-subtle, #333)",
        width: (0, (0, parcelRequire("24VeY")).emojiTypeAheadWidth)
    });
    const $bdde198ca5c4332c$export$592b730734d5a996 = {
        name: "eivff4",
        styles: "display:none"
    };
    const $bdde198ca5c4332c$export$d90250155de6d7e7 = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: (0, (0, parcelRequire("24VeY")).emojiPreviewSelectedColor)
    });
    const $bdde198ca5c4332c$export$cc2c857259981452 = (0, (0, parcelRequire("f8Sb3")).css)({
        cursor: 'pointer',
        display: 'block',
        listStyleType: 'none',
        overflow: 'hidden',
        width: (0, (0, parcelRequire("24VeY")).emojiTypeAheadWidth)
    });
    const $bdde198ca5c4332c$export$60dc9fd85ca58ef5 = {
        name: "1oa7hyp",
        styles: "display:flex;flex-direction:row;flex-wrap:wrap;vertical-align:middle"
    };
    const $bdde198ca5c4332c$export$3f82d4ec1be98df3 = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        height: `${(0, (0, parcelRequire("24VeY")).emojiTypeAheadMaxHeight)}px`,
        paddingTop: `${(((0, (0, parcelRequire("24VeY")).emojiTypeAheadMaxHeight) - 30) / 2).toFixed()}px`,
        boxSizing: 'border-box'
    });
    const $bdde198ca5c4332c$export$88d4af77c0c741a3 = {
        name: "1azakc",
        styles: "text-align:center"
    };
});
parcelRegister("a8fLF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82e371cc00e3cdc3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $82e371cc00e3cdc3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emojiButtonCaption: {
            "id": "polaris-lib-emoji-picker.emoji-button-caption",
            "defaultMessage": "Pick an emoji"
        },
        removeEmoji: {
            "id": "polaris-lib-emoji-picker.remove-emoji",
            "defaultMessage": "Remove emoji"
        },
        editEmoji: {
            "id": "polaris-lib-emoji-picker.edit-emoji",
            "defaultMessage": "Edit emoji"
        },
        readOnlyField: {
            "id": "polaris-lib-emoji-picker.read-only-field",
            "defaultMessage": "This is a default field and it cannot be edited or deleted"
        }
    });
});
parcelRegister("jdnWL", function(module, exports) {
    $parcel$export(module.exports, "ErrorContainer", ()=>$8c8571e764ada196$export$97bdf39f6b82bb0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $8c8571e764ada196$export$97bdf39f6b82bb0 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _vchhusvi _19pk14y2 _1yt418iy _2rkosqtm _bfhk1378 _syaz15cr _16qs1mxi _nt751r31 _49pcglyw _1hvw1o36",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9iiI8", function(module, exports) {
    $parcel$export(module.exports, "getIdeasCountForCollection", ()=>$42668e2cd1ae7607$export$d355ccab36abee74);
    var $jcw0u;
    var $eusud;
    var $1As78;
    const $42668e2cd1ae7607$export$d355ccab36abee74 = async (jql)=>(0, (0, parcelRequire("eusud")).performPostRequest)('/rest/polaris/issues/searchCountForJql', {
            body: JSON.stringify({
                jql: jql,
                archived: 'ACTIVE_ONLY'
            })
        }).then((response)=>response.count).catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.error.getIdeasCountForCollectionFailed', error));
            throw error;
        });
});
parcelRegister("gE10J", function(module, exports) {
    $parcel$export(module.exports, "FormFieldKeys", ()=>$7969c7aeb7af51e3$export$77563030951a87d8);
    $parcel$export(module.exports, "IDEAS_COUNT_LIMIT", ()=>$7969c7aeb7af51e3$export$651fede5bf66f749);
    const $7969c7aeb7af51e3$export$77563030951a87d8 = {
        COLLECTION_NAME: 'collectionName',
        PROJECTS: 'projects',
        FILTERS: 'filters'
    };
    const $7969c7aeb7af51e3$export$651fede5bf66f749 = 2000;
});
parcelRegister("isxus", function(module, exports) {
    $parcel$export(module.exports, "Filters", ()=>$3a151750aa48f2ed$export$92a576f896a9bf72);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $3bDjY;
    var $koVbs;
    var $ifQ0j;
    var $1aUn4;
    var $eNPxN;
    const $3a151750aa48f2ed$var$SearchModeSwitcher = ({ isBasicModeDisabled: isBasicModeDisabled, onUpdateSearchMode: onUpdateSearchMode, searchMode: searchMode })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const options = [
            {
                id: 'basic',
                label: isBasicModeDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: formatMessage((0, (0, parcelRequire("eNPxN")).default).basicModeDisabledTooltip),
                    tag: "span"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    as: "span"
                }, formatMessage((0, (0, parcelRequire("eNPxN")).default).basicMode))) : formatMessage((0, (0, parcelRequire("eNPxN")).default).basicMode),
                isDisabled: isBasicModeDisabled,
                testId: ''
            },
            {
                id: 'advanced',
                label: formatMessage((0, (0, parcelRequire("eNPxN")).default).advancedMode),
                testId: ''
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aUn4")).default), {
            label: formatMessage((0, (0, parcelRequire("eNPxN")).default).label),
            options: options,
            selectedOption: searchMode,
            onChange: (value)=>onUpdateSearchMode(value)
        });
    };
    const $3a151750aa48f2ed$var$EditorContainer = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $3a151750aa48f2ed$var$editorContainerStyles
        }, children);
    const $3a151750aa48f2ed$export$92a576f896a9bf72 = (props)=>{
        const { projectKeys: projectKeys, onChange: onChange, value: value } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifQ0j")).default), {
            query: value || '',
            analyticsSource: "jpdRoadmapFilters",
            components: {
                SearchModeSwitcher: $3a151750aa48f2ed$var$SearchModeSwitcher,
                EditorContainer: $3a151750aa48f2ed$var$EditorContainer
            },
            userPreferencesData: null,
            onSearch: onChange,
            projectKeys: projectKeys,
            excludedFields: [
                'project'
            ],
            basicModeVisibleFields: [],
            hideTextSearchInput: true
        });
    };
    const $3a151750aa48f2ed$var$editorContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: 1
    });
});
parcelRegister("ifQ0j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d0241969d25b90c$export$2e2bcd8739ae039);
    var $3qgE9;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $kGsr8 = parcelRequire("kGsr8");
    var $8Uumt = parcelRequire("8Uumt");
    var $gcl1l;
    var $7iJwP;
    var $7XYc4;
    var $4R6GH;
    var $7ckRQ;
    var $OomEm;
    var $caSpf;
    var $lfTZh;
    var $iXVV6;
    var $90yGq;
    var $koeKL;
    var $032ey;
    var $atxn1;
    var $55ttp;
    var $aRep0;
    var $2G1VO;
    const $9d0241969d25b90c$var$JQLBUILDER_FRAGMENT = (0, (0, parcelRequire("3qgE9")).default);
    const $9d0241969d25b90c$var$JQLBuilderOld = ({ onPerformanceMark: onPerformanceMark, ...props })=>{
        const userPreferencesRef = (0, $8Uumt.useFragment)($9d0241969d25b90c$var$JQLBUILDER_FRAGMENT, props.userPreferencesData);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: "unhandled",
            packageName: "jiraJqlBuilder",
            teamName: "empanada",
            sendToPrivacyUnsafeSplunk: true,
            attributes: (0, (0, parcelRequire("gcl1l")).isLoaderErrorAttributes)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "jqlBuilder",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("caSpf")).PerformanceContext).Provider, {
            value: onPerformanceMark || (0, ($parcel$interopDefault($8Rkzz)))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRep0")).JQLBuilderUIOld), {
            ...props,
            userPreferences: userPreferencesRef
        }))));
    };
    const $9d0241969d25b90c$var$JQLBuilder = ({ query: query, viewContext: viewContext = null, projectKeys: projectKeys, searchModes: searchModes = [
        (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED),
        (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC)
    ], searchModeSwitcherLocation: searchModeSwitcherLocation = (0, (0, parcelRequire("032ey")).SEARCH_MODE_SWITCHER_LEFT_LOCATION), showOrderByPicker: showOrderByPicker, hideTextSearchInput: hideTextSearchInput = false, onPerformanceMark: onPerformanceMark, maybeHydrationQueryReference: maybeHydrationQueryReference, ...props })=>{
        const { onLoad: onLoad } = props;
        const loadingModeRef = (0, $5uXOq.useRef)();
        const onLoadingMode = (0, $5uXOq.useCallback)((mode)=>{
            loadingModeRef.current = mode;
            onLoad?.(mode);
        }, [
            onLoad
        ]);
        const userPreferencesRef = (0, $8Uumt.useFragment)($9d0241969d25b90c$var$JQLBUILDER_FRAGMENT, props.userPreferencesData);
        const searchModeResponse = userPreferencesRef?.jqlBuilderSearchMode;
        const selectedSearchMode = (0, (0, parcelRequire("atxn1")).toSearchModeWithBasicModeFallback)(searchModeResponse);
        if (searchModes.length === 0) throw new Error('Search mode should be non empty');
        const uniqueSearchModes = (0, ($parcel$interopDefault($kGsr8)))(searchModes);
        const isSearchModeToggleEnabled = uniqueSearchModes ? uniqueSearchModes.length > 1 : true;
        const irremovableFields = (0, (0, parcelRequire("7ckRQ")).useIrremovableFields)(props.basicModeVisibleFields ?? (0, (0, parcelRequire("7ckRQ")).DEFAULT_IRREMOVABLE_FIELDS));
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const originalQuery = (0, $5uXOq.useRef)(query);
        const contextJql = (0, (0, parcelRequire("55ttp")).useContextJql)({
            jql: originalQuery.current,
            projectKeys: projectKeys
        });
        const fallback = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2G1VO")).JQLBuilderFallback), {
            query: query,
            searchModes: searchModes,
            onLoad: onLoadingMode,
            selectedSearchMode: selectedSearchMode,
            isSearchModeToggleEnabled: isSearchModeToggleEnabled,
            beforeControls: props.beforeControls,
            renderExtraControls: props.renderExtraControls,
            excludedFields: props.excludedFields,
            components: props.components,
            irremovableFields: irremovableFields,
            hideTextSearchInput: hideTextSearchInput,
            searchModeSwitcherLocation: searchModeSwitcherLocation,
            showOrderByPicker: showOrderByPicker
        });
        const [initialQueryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("OomEm")).HYDRATION_QUERY), (0, (0, parcelRequire("4R6GH")).fg)('nin_request_hydrate_query_earlier') ? maybeHydrationQueryReference : undefined);
        (0, $5uXOq.useEffect)(()=>{
            if (!initialQueryRef) loadQuery({
                accountId: accountId ?? '',
                cloudId: cloudId,
                includeUser: originalQuery.current.length > 0 && !!accountId,
                includeJira: originalQuery.current.length > 0,
                jql: contextJql,
                isFilter: false,
                filterAri: '',
                viewContext: viewContext
            }, {
                fetchPolicy: 'store-or-network',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            });
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: "unhandled",
            packageName: "jiraJqlBuilder",
            teamName: "empanada",
            sendToPrivacyUnsafeSplunk: true,
            attributes: (0, (0, parcelRequire("gcl1l")).isLoaderErrorAttributes)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "jqlBuilder",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("caSpf")).PerformanceContext).Provider, {
            value: onPerformanceMark || (0, ($parcel$interopDefault($8Rkzz)))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jql-builder-main",
            fallback: fallback
        }, initialQueryRef ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRep0")).default), {
            query: query,
            searchModes: searchModes,
            selectedSearchMode: selectedSearchMode,
            isSearchModeToggleEnabled: isSearchModeToggleEnabled,
            beforeControls: props.beforeControls,
            renderExtraControls: props.renderExtraControls,
            excludedFields: props.excludedFields,
            components: props.components,
            irremovableFields: irremovableFields,
            uniqueSearchModes: uniqueSearchModes,
            hideTextSearchInput: hideTextSearchInput,
            searchModeSwitcherLocation: searchModeSwitcherLocation,
            showOrderByPicker: showOrderByPicker,
            viewContext: viewContext,
            projectKeys: projectKeys,
            userPreferences: userPreferencesRef,
            initialQueryRef: initialQueryRef,
            onLoadingMode: onLoadingMode,
            loadingModeRef: loadingModeRef,
            ...props
        }) : fallback))));
    };
    var $9d0241969d25b90c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('nin_migrate_jql_builder_to_refetchable_query'), (0, $5uXOq.memo)($9d0241969d25b90c$var$JQLBuilder), (0, $5uXOq.memo)($9d0241969d25b90c$var$JQLBuilderOld));
});
parcelRegister("3qgE9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2e59103f695f715$export$2e2bcd8739ae039);
    const $d2e59103f695f715$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "main_jqlBuilder_JQLBuilder",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_jqlBuilder_JQLBuilderUI"
            },
            {
                "kind": "ScalarField",
                "name": "jqlBuilderSearchMode"
            }
        ],
        "type": "JiraUserPreferences"
    };
    $d2e59103f695f715$var$node.hash = "939f009c6569621eae121104d8e94579";
    var $d2e59103f695f715$export$2e2bcd8739ae039 = $d2e59103f695f715$var$node;
});
parcelRegister("gcl1l", function(module, exports) {
    $parcel$export(module.exports, "isLoaderErrorAttributes", ()=>$ecfe970d67067a10$export$c7209ce2e0d060ea);
    var $bCf8q;
    const $ecfe970d67067a10$export$c7209ce2e0d060ea = (error)=>({
            isLoaderError: (0, (0, parcelRequire("bCf8q")).isLoaderError)(error)
        });
});
parcelRegister("7ckRQ", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_IRREMOVABLE_FIELDS", ()=>$015fe2e823c5f467$export$10049973e0522c22);
    $parcel$export(module.exports, "useIrremovableFields", ()=>$015fe2e823c5f467$export$28001ca0e14d9f37);
    $parcel$export(module.exports, "useIrremovableFieldsAnalyticsAttributes", ()=>$015fe2e823c5f467$export$1b10c62780608464);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $jcw0u;
    var $koVbs;
    var $2NMNM;
    var $5Dsab;
    var $i4OXX;
    const $015fe2e823c5f467$export$10049973e0522c22 = [
        'project',
        'type',
        'status',
        'assignee'
    ];
    const $015fe2e823c5f467$var$getBuiltInIrremovableFields = (formatMessage)=>({
            [(0, (0, parcelRequire("5Dsab")).PROJECT_FIELD_JQL_TERM)]: {
                ...(0, (0, parcelRequire("5Dsab")).PROJECT),
                displayName: formatMessage((0, (0, parcelRequire("i4OXX")).default).refinementProject)
            },
            [(0, (0, parcelRequire("5Dsab")).TYPE_FIELD_JQL_TERM)]: {
                ...(0, (0, parcelRequire("5Dsab")).TYPE),
                displayName: formatMessage((0, (0, parcelRequire("i4OXX")).default).refinementType)
            },
            [(0, (0, parcelRequire("5Dsab")).STATUS_FIELD_JQL_TERM)]: {
                ...(0, (0, parcelRequire("5Dsab")).STATUS),
                displayName: formatMessage((0, (0, parcelRequire("i4OXX")).default).refinementStatus)
            },
            [(0, (0, parcelRequire("5Dsab")).ASSIGNEE_FIELD_JQL_TERM)]: {
                ...(0, (0, parcelRequire("5Dsab")).ASSIGNEE),
                displayName: formatMessage((0, (0, parcelRequire("i4OXX")).default).refinementAssignee)
            },
            [(0, (0, parcelRequire("5Dsab")).RESOLUTION_FIELD_JQL_TERM)]: {
                ...(0, (0, parcelRequire("5Dsab")).RESOLUTION),
                displayName: formatMessage((0, (0, parcelRequire("i4OXX")).default).refinementResolution)
            },
            [(0, (0, parcelRequire("5Dsab")).LABELS_FIELD_JQL_TERM)]: {
                ...(0, (0, parcelRequire("5Dsab")).LABELS),
                displayName: formatMessage((0, (0, parcelRequire("i4OXX")).default).refinementLabels)
            }
        });
    const $015fe2e823c5f467$var$getInvalidCustomFieldProperties = ({ displayName: displayName, jqlTerm: jqlTerm, fieldType: fieldType, searchTemplate: searchTemplate, operators: operators })=>{
        const invalidFieldProps = [];
        if (!displayName) invalidFieldProps.push('displayName');
        if (!jqlTerm) invalidFieldProps.push('jqlTerm');
        if (!fieldType) invalidFieldProps.push('fieldType');
        if (!searchTemplate) invalidFieldProps.push('searchTemplate');
        if (!operators || operators.length === 0) invalidFieldProps.push('operators');
        return invalidFieldProps;
    };
    const $015fe2e823c5f467$export$28001ca0e14d9f37 = (irremovableFieldsConfig)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const irremovableFields = (0, $5uXOq.useMemo)(()=>{
            const builtInFields = $015fe2e823c5f467$var$getBuiltInIrremovableFields(formatMessage);
            const entries = irremovableFieldsConfig.map((keyOrField)=>{
                if (typeof keyOrField === 'string') {
                    const builtInField = builtInFields[keyOrField];
                    if (!builtInField) throw new Error(`useIrremovableFields hook received an unsupported key: ${keyOrField}`);
                    return [
                        keyOrField,
                        builtInField
                    ];
                }
                const invalidFieldProps = $015fe2e823c5f467$var$getInvalidCustomFieldProperties(keyOrField);
                if (invalidFieldProps.length > 0) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        event: createAnalyticsEvent({}),
                        meta: {
                            id: 'useIrremovableFields',
                            packageName: (0, (0, parcelRequire("5Dsab")).PACKAGE_NAME),
                            teamName: (0, (0, parcelRequire("5Dsab")).TEAM_NAME)
                        },
                        attributes: {
                            fieldType: keyOrField.fieldType,
                            searchTemplate: keyOrField.searchTemplate,
                            invalidFieldProps: invalidFieldProps.join(',')
                        }
                    });
                    throw new Error('useIrremovableFields hook received an unsupported field');
                }
                const jqlTerm = keyOrField.jqlTerm.toLowerCase();
                const field = {
                    ...keyOrField,
                    jqlTerm: jqlTerm
                };
                return [
                    jqlTerm,
                    field
                ];
            });
            return new Map(entries);
        }, [
            createAnalyticsEvent,
            formatMessage,
            irremovableFieldsConfig
        ]);
        return irremovableFields;
    };
    const $015fe2e823c5f467$export$1b10c62780608464 = (irremovableFields)=>(0, $5uXOq.useMemo)(()=>{
            const irremovableFieldTypes = [
                ...irremovableFields.values()
            ].map(({ fieldType: fieldType })=>fieldType);
            const irremovableFieldCount = irremovableFields.size;
            const isDefaultIrremovableFields = (0, ($parcel$interopDefault($ajpes)))(Array.from(irremovableFields.keys()), $015fe2e823c5f467$export$10049973e0522c22);
            return {
                irremovableFieldTypes: irremovableFieldTypes,
                irremovableFieldCount: irremovableFieldCount,
                isDefaultIrremovableFields: isDefaultIrremovableFields
            };
        }, [
            irremovableFields
        ]);
});
parcelRegister("5Dsab", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$f231a8145cfae881$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$f231a8145cfae881$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "jqlAnonymizerVisitor", ()=>$f231a8145cfae881$export$8b46ceeb1d0f7a0f);
    $parcel$export(module.exports, "PROJECT_FIELD_JQL_TERM", ()=>$f231a8145cfae881$export$a94927c1053f515e);
    $parcel$export(module.exports, "TYPE_FIELD_JQL_TERM", ()=>$f231a8145cfae881$export$92a0328342946939);
    $parcel$export(module.exports, "STATUS_FIELD_JQL_TERM", ()=>$f231a8145cfae881$export$b9f8115d86beaf2e);
    $parcel$export(module.exports, "ASSIGNEE_FIELD_JQL_TERM", ()=>$f231a8145cfae881$export$fe13eb78c06cd416);
    $parcel$export(module.exports, "RESOLUTION_FIELD_JQL_TERM", ()=>$f231a8145cfae881$export$45a7314200effcd0);
    $parcel$export(module.exports, "LABELS_FIELD_JQL_TERM", ()=>$f231a8145cfae881$export$952c102639c1ed96);
    $parcel$export(module.exports, "TEXT", ()=>$f231a8145cfae881$export$d597759d33be802e);
    $parcel$export(module.exports, "PROJECT", ()=>$f231a8145cfae881$export$fe791c4fa892e400);
    $parcel$export(module.exports, "TYPE", ()=>$f231a8145cfae881$export$b87f371cbc396fcf);
    $parcel$export(module.exports, "STATUS", ()=>$f231a8145cfae881$export$e50006273435e7d4);
    $parcel$export(module.exports, "ASSIGNEE", ()=>$f231a8145cfae881$export$f8f7545d2bb78afb);
    $parcel$export(module.exports, "RESOLUTION", ()=>$f231a8145cfae881$export$f1a6ce22cbb7eb32);
    $parcel$export(module.exports, "LABELS", ()=>$f231a8145cfae881$export$79b91d4669dcadcb);
    $parcel$export(module.exports, "SPRINT", ()=>$f231a8145cfae881$export$a316570a0dbfd2b0);
    $parcel$export(module.exports, "AFFECTED_VERSION", ()=>$f231a8145cfae881$export$d02178e10ccc3ea);
    $parcel$export(module.exports, "FIX_VERSION", ()=>$f231a8145cfae881$export$4c55d92eb3c27f18);
    $parcel$export(module.exports, "PARENT", ()=>$f231a8145cfae881$export$e0dfb65d1047c53c);
    $parcel$export(module.exports, "COMPONENT", ()=>$f231a8145cfae881$export$af1e30ebbae9df3b);
    $parcel$export(module.exports, "CREATOR", ()=>$f231a8145cfae881$export$39a35fc5bd7af053);
    $parcel$export(module.exports, "REPORTER", ()=>$f231a8145cfae881$export$6d7021166edc895c);
    $parcel$export(module.exports, "dateSearchTemplates", ()=>$f231a8145cfae881$export$ffcdf2c6c4831acc);
    $parcel$export(module.exports, "userFieldSearchTemplates", ()=>$f231a8145cfae881$export$6616be37c70ab33f);
    $parcel$export(module.exports, "EPIC_LINK", ()=>$f231a8145cfae881$export$19f652d3d336f069);
    $parcel$export(module.exports, "appearanceMap", ()=>$f231a8145cfae881$export$c743cc8f0e853412);
    $parcel$export(module.exports, "FunctionName", ()=>$f231a8145cfae881$export$4b826ede0e88b93);
    $parcel$export(module.exports, "KeywordName", ()=>$f231a8145cfae881$export$84606816405f7142);
    $parcel$export(module.exports, "OperandValues", ()=>$f231a8145cfae881$export$1ab4f98e21fe0811);
    $parcel$export(module.exports, "CASCADE_SELECT_FIELD_SEARCH_TEMPLATE", ()=>$f231a8145cfae881$export$3e3df380922ad777);
    $parcel$export(module.exports, "CASCADE_OPTION_FUNCTION_NAME", ()=>$f231a8145cfae881$export$cd361098212837ad);
    $parcel$export(module.exports, "NUMBER_RANGE_FIELD_SEARCH_TEMPLATE", ()=>$f231a8145cfae881$export$4e0f2021e5a6dd20);
    $parcel$export(module.exports, "NUMBER_RANGE_PICKER_ALLOWED_OPERATORS", ()=>$f231a8145cfae881$export$787eee4b393220a3);
    $parcel$export(module.exports, "CMDB_FIELD_SEARCH_TEMPLATE", ()=>$f231a8145cfae881$export$51829c816d2b6247);
    $parcel$export(module.exports, "JSM_REQUEST_TYPE_SEARCH_TEMPLATE", ()=>$f231a8145cfae881$export$33aa1485e40ffbb7);
    $parcel$export(module.exports, "JSM_ORGANIZATIONS_SEARCH_TEMPLATE", ()=>$f231a8145cfae881$export$b7429d5dab3b6ce5);
    $parcel$export(module.exports, "JSM_WORK_CATEGORY_SEARCH_TEMPLATE", ()=>$f231a8145cfae881$export$6f9d9c0166c7b52d);
    $parcel$export(module.exports, "AQL_FUNCTION_NAME", ()=>$f231a8145cfae881$export$ee8b282423818e0d);
    $parcel$export(module.exports, "IQL_FUNCTION_NAME", ()=>$f231a8145cfae881$export$c91c40035dea81da);
    $parcel$export(module.exports, "ISSUE_KEY", ()=>$f231a8145cfae881$export$5daa28d10e23592);
    $parcel$export(module.exports, "getTextSearchInputField", ()=>$f231a8145cfae881$export$3274f6964f86ac9b);
    $parcel$export(module.exports, "getTextSearchInputFieldData", ()=>$f231a8145cfae881$export$4129f168e11a8dd0);
    var $fhHBZ;
    var $bzbto;
    var $4R6GH;
    const $f231a8145cfae881$export$b8b9d90f9e5bd72b = 'jiraJqlBuilderBasic';
    const $f231a8145cfae881$export$d57b6b390e78d90f = 'empanada';
    const $f231a8145cfae881$export$8b46ceeb1d0f7a0f = new (0, (0, parcelRequire("fhHBZ")).JqlAnonymizerVisitor)();
    const $f231a8145cfae881$export$da273f945769bea1 = 'text';
    const $f231a8145cfae881$export$719a91e0b07fb80e = 'textfields';
    const $f231a8145cfae881$export$a94927c1053f515e = 'project';
    const $f231a8145cfae881$export$92a0328342946939 = 'type';
    const $f231a8145cfae881$export$b9f8115d86beaf2e = 'status';
    const $f231a8145cfae881$export$fe13eb78c06cd416 = 'assignee';
    const $f231a8145cfae881$export$45a7314200effcd0 = 'resolution';
    const $f231a8145cfae881$export$952c102639c1ed96 = 'labels';
    const $f231a8145cfae881$export$b2dcd38723ba8c75 = {
        jqlTerm: $f231a8145cfae881$export$719a91e0b07fb80e,
        searchTemplate: 'textFields',
        fieldType: 'textFields',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_LIKE)
        ]
    };
    const $f231a8145cfae881$export$d597759d33be802e = {
        jqlTerm: $f231a8145cfae881$export$da273f945769bea1,
        searchTemplate: 'text',
        fieldType: 'text',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_LIKE)
        ]
    };
    const $f231a8145cfae881$export$fe791c4fa892e400 = {
        jqlTerm: $f231a8145cfae881$export$a94927c1053f515e,
        searchTemplate: 'project',
        fieldType: 'project',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS)
        ]
    };
    const $f231a8145cfae881$export$b87f371cbc396fcf = {
        jqlTerm: $f231a8145cfae881$export$92a0328342946939,
        searchTemplate: 'issuetype',
        fieldType: 'issuetype',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS)
        ]
    };
    const $f231a8145cfae881$export$e50006273435e7d4 = {
        jqlTerm: $f231a8145cfae881$export$b9f8115d86beaf2e,
        searchTemplate: 'status',
        fieldType: 'status',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_CHANGED)
        ]
    };
    const $f231a8145cfae881$export$f8f7545d2bb78afb = {
        jqlTerm: $f231a8145cfae881$export$fe13eb78c06cd416,
        searchTemplate: 'assignee',
        fieldType: 'assignee',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_CHANGED),
            (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN)
        ]
    };
    const $f231a8145cfae881$export$f1a6ce22cbb7eb32 = {
        jqlTerm: $f231a8145cfae881$export$45a7314200effcd0,
        searchTemplate: 'resolution',
        fieldType: 'resolution',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_LT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_GT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_GT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_LT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_CHANGED)
        ]
    };
    const $f231a8145cfae881$export$79b91d4669dcadcb = {
        jqlTerm: $f231a8145cfae881$export$952c102639c1ed96,
        searchTemplate: 'labels',
        fieldType: 'labels',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS)
        ]
    };
    const $f231a8145cfae881$export$a316570a0dbfd2b0 = {
        jqlTerm: 'sprint',
        searchTemplate: 'com.pyxis.greenhopper.jira:gh-sprint-searcher',
        fieldType: 'com.pyxis.greenhopper.jira:gh-sprint',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS)
        ]
    };
    const $f231a8145cfae881$export$d02178e10ccc3ea = {
        jqlTerm: 'affectedversion',
        searchTemplate: 'versions',
        fieldType: 'versions',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_LT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_LT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_GT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_GT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IN)
        ]
    };
    const $f231a8145cfae881$export$4c55d92eb3c27f18 = {
        jqlTerm: 'fixversion',
        searchTemplate: 'fixVersions',
        fieldType: 'fixVersions',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_LT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_LT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_GT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_GT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IN)
        ]
    };
    const $f231a8145cfae881$export$e0dfb65d1047c53c = {
        jqlTerm: 'parent',
        searchTemplate: 'parent',
        fieldType: 'parent',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT)
        ]
    };
    const $f231a8145cfae881$export$af1e30ebbae9df3b = {
        jqlTerm: 'component',
        searchTemplate: 'components',
        fieldType: 'components',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT)
        ]
    };
    const $f231a8145cfae881$export$39a35fc5bd7af053 = {
        jqlTerm: 'creator',
        searchTemplate: 'creator',
        fieldType: 'creator',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT)
        ]
    };
    const $f231a8145cfae881$export$6d7021166edc895c = {
        jqlTerm: 'reporter',
        searchTemplate: 'reporter',
        fieldType: 'reporter',
        operators: [
            (0, (0, parcelRequire("bzbto")).OPERATOR_CHANGED),
            (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS_NOT_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IS),
            (0, (0, parcelRequire("bzbto")).OPERATOR_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_WAS_IN),
            (0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN)
        ]
    };
    const $f231a8145cfae881$export$ffcdf2c6c4831acc = new Set([
        'updated',
        'created',
        'duedate',
        'resolutiondate',
        'com.atlassian.jira.plugin.system.customfieldtypes:datetimerange',
        'com.atlassian.jira.plugin.system.customfieldtypes:daterange',
        'statuscategorychangedate',
        'com.atlassian.jira.toolkit:LastCommentDateSearcher',
        'com.atlassian.jira.ext.charting:firstreponsedatesearcher',
        'com.atlassian.jpo:jpo-custom-field-baseline-start-searcher',
        'com.atlassian.jpo:jpo-custom-field-baseline-end-searcher',
        'com.atlassian.servicedesk:sd-request-feedback-date-searcher'
    ]);
    const $f231a8145cfae881$export$6616be37c70ab33f = new Set([
        'assignee',
        'reporter',
        'creator',
        'com.atlassian.jira.plugin.system.customfieldtypes:userpickergroupsearcher',
        'com.atlassian.jira.plugin.system.customfieldtypes:next-gen-people-searcher',
        'com.atlassian.jira.toolkit:participantsearcher',
        'com.atlassian.jira.toolkit:lastparticipantsearcher',
        'com.atlassian.servicedesk:sd-request-participants-searcher'
    ]);
    const $f231a8145cfae881$export$19f652d3d336f069 = {
        jqlTerm: 'epic link',
        searchTemplate: 'com.pyxis.greenhopper.jira:gh-epic-link-searcher'
    };
    const $f231a8145cfae881$export$c743cc8f0e853412 = {
        BLUE_GRAY: 'default',
        MEDIUM_GRAY: 'default',
        BROWN: 'default',
        GREEN: 'success',
        YELLOW: 'inprogress',
        WARM_RED: 'removed'
    };
    const $f231a8145cfae881$export$4b826ede0e88b93 = {
        currentUser: 'currentUser',
        standardIssueTypes: 'standardIssueTypes',
        subTaskIssueTypes: 'subTaskIssueTypes',
        membersOf: 'membersOf',
        releasedVersions: 'releasedVersions',
        unreleasedVersions: 'unreleasedVersions'
    };
    const $f231a8145cfae881$export$84606816405f7142 = {
        empty: 'empty'
    };
    const $f231a8145cfae881$export$1ab4f98e21fe0811 = {
        currentUser: {
            value: 'currentUser()',
            type: (0, $49b29ef7baa2a152$export$19c7c729db381f9d)
        },
        empty: {
            value: 'EMPTY',
            type: (0, $49b29ef7baa2a152$export$f6049126fd97001f)
        },
        standardIssueTypes: {
            value: 'standardIssueTypes()',
            isList: true,
            type: (0, $49b29ef7baa2a152$export$19c7c729db381f9d)
        },
        subTaskIssueTypes: {
            value: 'subTaskIssueTypes()',
            isList: true,
            type: (0, $49b29ef7baa2a152$export$19c7c729db381f9d)
        },
        membersOf: {
            value: 'membersOf',
            isList: true,
            hasArgs: true,
            template: 'membersOf("$1")',
            type: (0, $49b29ef7baa2a152$export$19c7c729db381f9d)
        },
        releasedVersions: {
            value: 'releasedVersions()',
            isList: true,
            type: (0, $49b29ef7baa2a152$export$19c7c729db381f9d)
        },
        unreleasedVersions: {
            value: 'unreleasedVersions()',
            isList: true,
            type: (0, $49b29ef7baa2a152$export$19c7c729db381f9d)
        }
    };
    const $f231a8145cfae881$export$3e3df380922ad777 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselectsearcher';
    const $f231a8145cfae881$export$cd361098212837ad = 'cascadeOption';
    const $f231a8145cfae881$export$4e0f2021e5a6dd20 = 'com.atlassian.jira.plugin.system.customfieldtypes:numberrange';
    const $f231a8145cfae881$export$3e72793810b8a135 = 'jql-builder-basic-textarea.ui.text-area';
    const $f231a8145cfae881$export$796f418f6ff91516 = 'jql-builder-basic-textarea.ui.update-button';
    const $f231a8145cfae881$export$787eee4b393220a3 = [
        (0, (0, parcelRequire("bzbto")).OPERATOR_LT_EQUALS),
        (0, (0, parcelRequire("bzbto")).OPERATOR_GT_EQUALS)
    ];
    const $f231a8145cfae881$export$51829c816d2b6247 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-searcher';
    const $f231a8145cfae881$export$33aa1485e40ffbb7 = 'com.atlassian.servicedesk:vp-origin-searcher';
    const $f231a8145cfae881$export$b7429d5dab3b6ce5 = 'com.atlassian.servicedesk:sd-customer-organizations-searcher';
    const $f231a8145cfae881$export$6f9d9c0166c7b52d = 'com.atlassian.jira.plugins.work-category-field:work-category-field-searcher';
    const $f231a8145cfae881$export$ee8b282423818e0d = 'aqlFunction';
    const $f231a8145cfae881$export$c91c40035dea81da = 'iqlFunction';
    const $f231a8145cfae881$export$913055729e1380b2 = 'summary';
    const $f231a8145cfae881$export$d44826c816b5619b = 'description';
    const $f231a8145cfae881$export$5daa28d10e23592 = 'issuekey';
    const $f231a8145cfae881$export$7167c830cefcb6b5 = 'key';
    const $f231a8145cfae881$export$3274f6964f86ac9b = ()=>(0, (0, parcelRequire("4R6GH")).fg)('nin-text-fields-new-text-search-field') ? $f231a8145cfae881$export$719a91e0b07fb80e : $f231a8145cfae881$export$da273f945769bea1;
    const $f231a8145cfae881$export$4129f168e11a8dd0 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('nin-text-fields-new-text-search-field') ? $f231a8145cfae881$export$b2dcd38723ba8c75 : $f231a8145cfae881$export$d597759d33be802e;
});
parcelRegister("fhHBZ", function(module, exports) {
    $parcel$export(module.exports, "JqlAnonymizerVisitor", ()=>$c69a6e9a1c8df586$export$17681d1ffeaac612);
    var $gBxta;
    var $DhVIK;
    var $kzRYu;
    var $bv7J5;
    const $c69a6e9a1c8df586$var$ANONYMIZED_FIELD = '"?"';
    const $c69a6e9a1c8df586$var$ANONYMIZED_VALUE = '"?"';
    const $c69a6e9a1c8df586$var$CUSTOM_FIELD_PATTERN = /^cf\[\d+]$/i;
    const $c69a6e9a1c8df586$var$privacySafeFields = new Set((0, (0, parcelRequire("DhVIK")).PRIVACY_SAFE_FIELDS));
    const $c69a6e9a1c8df586$var$getPrivacySafeFieldName = (field)=>{
        if ($c69a6e9a1c8df586$var$privacySafeFields.has(field.value.toLowerCase())) return field.text;
        if ($c69a6e9a1c8df586$var$CUSTOM_FIELD_PATTERN.test(field.value)) return field.text;
        const match = field.text.match((0, (0, parcelRequire("gBxta")).COLLAPSED_CUSTOM_FIELD_PATTERN));
        if (match) return `"?[${match[1]}]"`;
        return $c69a6e9a1c8df586$var$ANONYMIZED_FIELD;
    };
    class $c69a6e9a1c8df586$export$17681d1ffeaac612 extends (0, (0, parcelRequire("bv7J5")).AbstractJastVisitor) {
        defaultResult() {
            return '';
        }
        constructor(...args){
            super(...args), this.visitQuery = (query)=>{
                const where = query.where ? query.where.accept(this) : undefined;
                const orderBy = query.orderBy ? query.orderBy.accept(this) : undefined;
                return [
                    where,
                    orderBy
                ].filter((0, (0, parcelRequire("kzRYu")).notUndefined)).join(' ');
            }, this.visitField = (field)=>{
                const name = $c69a6e9a1c8df586$var$getPrivacySafeFieldName(field);
                if (field.properties && field.properties.length) {
                    const properties = field.properties.map((property)=>{
                        const key = property.key ? property.key.text : '';
                        const path = property.path ? property.path.map((arg)=>arg.text).join('') : '';
                        return `[${key}]${path}`;
                    }).join('');
                    return `${name}${properties}`;
                }
                return name;
            }, this.visitTerminalClause = (terminalClause)=>{
                const field = terminalClause.field.accept(this);
                const operator = terminalClause.operator ? terminalClause.operator.text : undefined;
                const operand = terminalClause.operand ? terminalClause.operand.accept(this) : undefined;
                const predicates = terminalClause.predicates.map((predicate)=>predicate.accept(this));
                return [
                    field,
                    operator,
                    operand,
                    ...predicates
                ].filter((0, (0, parcelRequire("kzRYu")).notUndefined)).join(' ');
            }, this.visitCompoundClause = (compoundClause)=>{
                const operator = compoundClause.operator.value;
                return compoundClause.clauses.map((clause)=>{
                    return clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b) ? `(${clause.accept(this)})` : clause.accept(this);
                }).join(` ${operator} `);
            }, this.visitNotClause = (notClause)=>{
                const nestedClause = notClause.clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b) ? `(${notClause.clause.accept(this)})` : notClause.clause.accept(this);
                return `${notClause.operator.value} ${nestedClause}`;
            }, this.visitValueOperand = ()=>{
                return $c69a6e9a1c8df586$var$ANONYMIZED_VALUE;
            }, this.visitListOperand = (listOperand)=>{
                return `(${listOperand.values.map((value)=>value.accept(this)).join(', ')})`;
            }, this.visitFunctionOperand = (functionOperand)=>{
                const functionName = functionOperand.function.text;
                const functionArguments = functionOperand.arguments.map(()=>$c69a6e9a1c8df586$var$ANONYMIZED_VALUE).join(', ');
                return `${functionName}(${functionArguments})`;
            }, this.visitKeywordOperand = (keywordOperand)=>{
                return keywordOperand.value;
            }, this.visitPredicate = (predicate)=>{
                const operator = predicate.operator.text;
                const operand = predicate.operand ? predicate.operand.accept(this) : undefined;
                return [
                    operator,
                    operand
                ].filter((0, (0, parcelRequire("kzRYu")).notUndefined)).join(' ');
            }, this.visitOrderBy = (orderBy)=>{
                const orderByFields = orderBy.fields.map((orderByField)=>{
                    const field = orderByField.field.accept(this);
                    const direction = orderByField.direction ? orderByField.direction.value : undefined;
                    return [
                        field,
                        direction
                    ].filter((0, (0, parcelRequire("kzRYu")).notUndefined)).join(' ');
                });
                return `${0, $9f1dbb2b39d4d9a2$export$ca51f5fd60a74517} ${orderByFields.join(', ')}`;
            };
        }
    }
});
parcelRegister("gBxta", function(module, exports) {
    $parcel$export(module.exports, "TEAM_CUSTOM_FIELD_TYPE", ()=>$4f5c700fe10f7ce2$export$7db5aa892c7d5359);
    $parcel$export(module.exports, "COLLAPSED_CUSTOM_FIELD_PATTERN", ()=>$4f5c700fe10f7ce2$export$72fbd4b3f260d743);
    $parcel$export(module.exports, "COLLAPSED_CUSTOM_FIELD_PATTERN_NO_QUOTES", ()=>$4f5c700fe10f7ce2$export$4b8ecf135de492a1);
    const $4f5c700fe10f7ce2$export$7db5aa892c7d5359 = '[team]';
    const $4f5c700fe10f7ce2$export$72fbd4b3f260d743 = /^['"].+\[(\D+)]['"]$/i;
    const $4f5c700fe10f7ce2$export$4b8ecf135de492a1 = /^.+\[(\D+)]$/i;
});
parcelRegister("DhVIK", function(module, exports) {
    $parcel$export(module.exports, "ASSIGNEE_FIELD", ()=>$cde2e75b8dceda30$export$f7a08bf17a7ac661);
    $parcel$export(module.exports, "CREATED_FIELD", ()=>$cde2e75b8dceda30$export$9063bfeedbc1236f);
    $parcel$export(module.exports, "DUE_DATE_FIELD", ()=>$cde2e75b8dceda30$export$f4a47f55547a932c);
    $parcel$export(module.exports, "ISSUE_TYPE_FIELD", ()=>$cde2e75b8dceda30$export$2d5a62a3515ad4c6);
    $parcel$export(module.exports, "LAST_VIEWED_FIELD", ()=>$cde2e75b8dceda30$export$eac61537b9fdb3be);
    $parcel$export(module.exports, "PRIORITY_FIELD", ()=>$cde2e75b8dceda30$export$de14210faa5f2099);
    $parcel$export(module.exports, "PROJECT_FIELD", ()=>$cde2e75b8dceda30$export$aa5680ad8f8be9fc);
    $parcel$export(module.exports, "REPORTER_FIELD", ()=>$cde2e75b8dceda30$export$d64150fd9c66969c);
    $parcel$export(module.exports, "RESOLUTION_DATE_FIELD", ()=>$cde2e75b8dceda30$export$f603d3cf4c8489e8);
    $parcel$export(module.exports, "STATUS_FIELD", ()=>$cde2e75b8dceda30$export$3068d6fae4de53c8);
    $parcel$export(module.exports, "SUMMARY_FIELD", ()=>$cde2e75b8dceda30$export$9b9fe8882c3e0da3);
    $parcel$export(module.exports, "TYPE_FIELD", ()=>$cde2e75b8dceda30$export$e53b76a613c435e0);
    $parcel$export(module.exports, "UPDATED_FIELD", ()=>$cde2e75b8dceda30$export$7101642b50bf10bc);
    $parcel$export(module.exports, "RESOLUTION_FIELD", ()=>$cde2e75b8dceda30$export$252fb981af0e2e4e);
    $parcel$export(module.exports, "PRIVACY_SAFE_FIELDS", ()=>$cde2e75b8dceda30$export$49017cdca0837b83);
    const $cde2e75b8dceda30$export$f7a08bf17a7ac661 = 'assignee';
    const $cde2e75b8dceda30$export$9063bfeedbc1236f = 'created';
    const $cde2e75b8dceda30$export$f4a47f55547a932c = 'duedate';
    const $cde2e75b8dceda30$export$28d0e5e03b779eff = 'issuekey';
    const $cde2e75b8dceda30$export$2d5a62a3515ad4c6 = 'issuetype';
    const $cde2e75b8dceda30$export$eac61537b9fdb3be = 'lastviewed';
    const $cde2e75b8dceda30$export$de14210faa5f2099 = 'priority';
    const $cde2e75b8dceda30$export$aa5680ad8f8be9fc = 'project';
    const $cde2e75b8dceda30$export$d64150fd9c66969c = 'reporter';
    const $cde2e75b8dceda30$export$ad2fb2fa5ecb427a = 'resolved';
    const $cde2e75b8dceda30$export$f603d3cf4c8489e8 = 'resolutiondate';
    const $cde2e75b8dceda30$export$3068d6fae4de53c8 = 'status';
    const $cde2e75b8dceda30$export$f4d2dc00d9b9c983 = 'statuscategory';
    const $cde2e75b8dceda30$export$9b9fe8882c3e0da3 = 'summary';
    const $cde2e75b8dceda30$export$23ca38ad884e35f1 = 'text';
    const $cde2e75b8dceda30$export$b3e1b98671aae084 = 'textfields';
    const $cde2e75b8dceda30$export$e53b76a613c435e0 = 'type';
    const $cde2e75b8dceda30$export$7101642b50bf10bc = 'updated';
    const $cde2e75b8dceda30$export$c7761054d987f9ab = 'affectedversion';
    const $cde2e75b8dceda30$export$9ae86b690ef8ceed = 'approvals';
    const $cde2e75b8dceda30$export$4b5a561405c5f211 = 'category';
    const $cde2e75b8dceda30$export$a3ff506aee89f5de = 'component';
    const $cde2e75b8dceda30$export$6a045eda3865d703 = 'description';
    const $cde2e75b8dceda30$export$b6b1af0981f1891e = 'development';
    const $cde2e75b8dceda30$export$39df30b837789c3 = 'environment';
    const $cde2e75b8dceda30$export$8723b724f0b3ac65 = 'epic link';
    const $cde2e75b8dceda30$export$4b5030dff66bb705 = 'filter';
    const $cde2e75b8dceda30$export$3ec395376855802f = 'fixversion';
    const $cde2e75b8dceda30$export$a8945db82fc2e785 = 'labels';
    const $cde2e75b8dceda30$export$bf9df74e065af482 = 'parent';
    const $cde2e75b8dceda30$export$252fb981af0e2e4e = 'resolution';
    const $cde2e75b8dceda30$export$64238d76a1dc0703 = 'sprint';
    const $cde2e75b8dceda30$export$62edbfa1bb10b91 = 'assignee.property';
    const $cde2e75b8dceda30$export$5afd9733860db123 = 'creator.property';
    const $cde2e75b8dceda30$export$3ccfe20fd4420801 = 'issue.property';
    const $cde2e75b8dceda30$export$d955a5d923cc59e6 = 'project.property';
    const $cde2e75b8dceda30$export$ed42e707855fc6a4 = 'reporter.property';
    const $cde2e75b8dceda30$export$3b63269c1c533321 = 'voter.property';
    const $cde2e75b8dceda30$export$bd7061bb445305dd = 'watcher.property';
    const $cde2e75b8dceda30$export$49017cdca0837b83 = [
        $cde2e75b8dceda30$export$f7a08bf17a7ac661,
        $cde2e75b8dceda30$export$9063bfeedbc1236f,
        $cde2e75b8dceda30$export$f4a47f55547a932c,
        $cde2e75b8dceda30$export$28d0e5e03b779eff,
        $cde2e75b8dceda30$export$2d5a62a3515ad4c6,
        $cde2e75b8dceda30$export$eac61537b9fdb3be,
        $cde2e75b8dceda30$export$de14210faa5f2099,
        $cde2e75b8dceda30$export$aa5680ad8f8be9fc,
        $cde2e75b8dceda30$export$d64150fd9c66969c,
        $cde2e75b8dceda30$export$ad2fb2fa5ecb427a,
        $cde2e75b8dceda30$export$f603d3cf4c8489e8,
        $cde2e75b8dceda30$export$3068d6fae4de53c8,
        $cde2e75b8dceda30$export$f4d2dc00d9b9c983,
        $cde2e75b8dceda30$export$9b9fe8882c3e0da3,
        $cde2e75b8dceda30$export$23ca38ad884e35f1,
        $cde2e75b8dceda30$export$b3e1b98671aae084,
        $cde2e75b8dceda30$export$e53b76a613c435e0,
        $cde2e75b8dceda30$export$7101642b50bf10bc,
        $cde2e75b8dceda30$export$c7761054d987f9ab,
        $cde2e75b8dceda30$export$9ae86b690ef8ceed,
        $cde2e75b8dceda30$export$4b5a561405c5f211,
        $cde2e75b8dceda30$export$a3ff506aee89f5de,
        $cde2e75b8dceda30$export$6a045eda3865d703,
        $cde2e75b8dceda30$export$b6b1af0981f1891e,
        $cde2e75b8dceda30$export$39df30b837789c3,
        $cde2e75b8dceda30$export$8723b724f0b3ac65,
        $cde2e75b8dceda30$export$4b5030dff66bb705,
        $cde2e75b8dceda30$export$3ec395376855802f,
        $cde2e75b8dceda30$export$a8945db82fc2e785,
        $cde2e75b8dceda30$export$bf9df74e065af482,
        $cde2e75b8dceda30$export$252fb981af0e2e4e,
        $cde2e75b8dceda30$export$64238d76a1dc0703,
        $cde2e75b8dceda30$export$62edbfa1bb10b91,
        $cde2e75b8dceda30$export$5afd9733860db123,
        $cde2e75b8dceda30$export$3ccfe20fd4420801,
        $cde2e75b8dceda30$export$d955a5d923cc59e6,
        $cde2e75b8dceda30$export$ed42e707855fc6a4,
        $cde2e75b8dceda30$export$3b63269c1c533321,
        $cde2e75b8dceda30$export$bd7061bb445305dd
    ];
});
parcelRegister("i4OXX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2054e533ca4e44d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a2054e533ca4e44d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        refinementProject: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-project",
            "defaultMessage": "Project"
        },
        refinementStatus: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-status",
            "defaultMessage": "Status"
        },
        refinementStatusCategory: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-status-category",
            "defaultMessage": "Status category"
        },
        refinementSummary: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-summary",
            "defaultMessage": "Summary"
        },
        refinementAssignee: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-assignee",
            "defaultMessage": "Assignee"
        },
        refinementReporter: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-reporter",
            "defaultMessage": "Reporter"
        },
        refinementType: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-type",
            "defaultMessage": "Type"
        },
        refinementPriority: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-priority",
            "defaultMessage": "Priority"
        },
        refinementResolution: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-resolution",
            "defaultMessage": "Resolution"
        },
        refinementUpdated: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-updated",
            "defaultMessage": "Updated date"
        },
        refinementCreated: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-created",
            "defaultMessage": "Created date"
        },
        refinementDueDate: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-due-date",
            "defaultMessage": "Due date"
        },
        refinementResolutionDate: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-resolution-date",
            "defaultMessage": "Resolution date"
        },
        refinementComponent: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-component",
            "defaultMessage": "Component"
        },
        refinementParent: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-parent",
            "defaultMessage": "Parent"
        },
        refinementFixVersion: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-fix-version",
            "defaultMessage": "Fix version"
        },
        refinementAffectedVersion: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-affected-version",
            "defaultMessage": "Affects version"
        },
        refinementLabel: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-label",
            "defaultMessage": "Label"
        },
        refinementLabels: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-labels",
            "defaultMessage": "Labels"
        },
        refinementEpicLink: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-epic-link",
            "defaultMessage": "Epic link"
        },
        refinementSprint: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-sprint",
            "defaultMessage": "Sprint"
        },
        refinementCreator: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-creator",
            "defaultMessage": "Creator"
        },
        refinementDescription: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-description",
            "defaultMessage": "Description"
        },
        refinementEnvironment: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-environment",
            "defaultMessage": "Environment"
        },
        refinementNotFound: {
            "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-not-found",
            "defaultMessage": "Unknown Field"
        }
    });
});
parcelRegister("OomEm", function(module, exports) {
    $parcel$export(module.exports, "HYDRATION_QUERY", ()=>$e1f1ad0dadb1a1b8$export$988ee43373cb9bb2);
    $parcel$export(module.exports, "useHydrationQueryLoader", ()=>$e1f1ad0dadb1a1b8$export$b318e912f6cbc59b);
    var $16Yit;
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $8Uumt = parcelRequire("8Uumt");
    var $jcw0u;
    var $90yGq;
    var $koeKL;
    const $e1f1ad0dadb1a1b8$export$988ee43373cb9bb2 = (0, (0, parcelRequire("16Yit")).default);
    const $e1f1ad0dadb1a1b8$export$9562d1ce91742cb1 = (variables)=>{
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const [isFetching, setIsFetching] = (0, $5uXOq.useState)(false);
        const [prefetchedVariables, setPrefetchedVariables] = (0, $5uXOq.useState)(variables);
        const [fetchPolicy, setFetchPolicy] = (0, $5uXOq.useState)('store-or-network');
        const inFlightRequest = (0, $5uXOq.useRef)();
        const inFlightVariables = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, ($parcel$interopDefault($ajpes)))(variables, prefetchedVariables) && !(0, ($parcel$interopDefault($ajpes)))(variables, inFlightVariables.current)) {
                inFlightRequest.current?.unsubscribe();
                inFlightVariables.current = variables;
                setIsFetching(true);
                inFlightRequest.current = (0, $8Uumt.fetchQuery)(environment, $e1f1ad0dadb1a1b8$export$988ee43373cb9bb2, variables, {
                    fetchPolicy: 'store-or-network',
                    networkCacheConfig: {
                        metadata: {
                            META_SLOW_ENDPOINT: true
                        }
                    }
                }).subscribe({
                    complete: ()=>{
                        setPrefetchedVariables(variables);
                        setFetchPolicy('store-only');
                        setIsFetching(false);
                        inFlightVariables.current = undefined;
                    },
                    error: (error)=>{
                        setIsFetching(false);
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                id: 'hydrateJqlBuilderQuery',
                                packageName: 'jiraJqlBuilderCommon',
                                teamName: 'empanada'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                    }
                });
            }
        }, [
            environment,
            prefetchedVariables,
            variables
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                variables: prefetchedVariables,
                fetchPolicy: fetchPolicy,
                isFetching: isFetching
            }), [
            prefetchedVariables,
            fetchPolicy,
            isFetching
        ]);
    };
    const $e1f1ad0dadb1a1b8$export$b318e912f6cbc59b = (query, viewContext)=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { variables: variables, fetchPolicy: fetchPolicy, isFetching: isFetching } = $e1f1ad0dadb1a1b8$export$9562d1ce91742cb1({
            accountId: accountId ?? '',
            cloudId: cloudId,
            includeUser: query.length > 0 && !!accountId,
            includeJira: query.length > 0,
            jql: query,
            isFilter: false,
            filterAri: '',
            viewContext: viewContext
        });
        const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)($e1f1ad0dadb1a1b8$export$988ee43373cb9bb2);
        (0, $5uXOq.useEffect)(()=>{
            loadQuery(variables, {
                fetchPolicy: fetchPolicy,
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            });
        }, [
            fetchPolicy,
            loadQuery,
            variables
        ]);
        return [
            queryReference,
            isFetching
        ];
    };
});
parcelRegister("caSpf", function(module, exports) {
    $parcel$export(module.exports, "PerformanceContext", ()=>$24fa6d2cc4aafb68$export$39bcde15aa963086);
    $parcel$export(module.exports, "usePerformanceContext", ()=>$24fa6d2cc4aafb68$export$851a2d8ae957dc96);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    const $24fa6d2cc4aafb68$export$39bcde15aa963086 = (0, $5uXOq.createContext)((0, ($parcel$interopDefault($8Rkzz))));
    const $24fa6d2cc4aafb68$export$851a2d8ae957dc96 = ()=>(0, $5uXOq.useContext)($24fa6d2cc4aafb68$export$39bcde15aa963086);
});
parcelRegister("atxn1", function(module, exports) {
    $parcel$export(module.exports, "toSearchModeWithBasicModeFallback", ()=>$b0ab4dfe8728dd0f$export$7c0f55a4bd3730ea);
    $parcel$export(module.exports, "toServerSearchMode", ()=>$b0ab4dfe8728dd0f$export$32a166cc1b3e6927);
    var $032ey;
    function $b0ab4dfe8728dd0f$export$7c0f55a4bd3730ea(value) {
        switch(value){
            case 0, (0, parcelRequire("032ey")).SERVER_SEARCH_MODE_ADVANCED:
                return 0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED;
            default:
                return 0, (0, parcelRequire("032ey")).DEFAULT_SEARCH_MODE;
        }
    }
    function $b0ab4dfe8728dd0f$export$32a166cc1b3e6927(mode) {
        switch(mode){
            case 0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED:
                return 0, (0, parcelRequire("032ey")).SERVER_SEARCH_MODE_ADVANCED;
            default:
                return 0, (0, parcelRequire("032ey")).SERVER_SEARCH_MODE_BASIC;
        }
    }
});
parcelRegister("55ttp", function(module, exports) {
    $parcel$export(module.exports, "useContextJql", ()=>$290b1179285f772f$export$68b4e7df5f221bf);
    var $5uXOq = parcelRequire("5uXOq");
    var $iEIQF;
    var $eK6AG;
    var $bzbto;
    var $l0V05;
    var $5Dsab;
    const $290b1179285f772f$var$isProjectKey = (projectKey)=>Boolean(projectKey);
    const $290b1179285f772f$export$68b4e7df5f221bf = ({ jql: jql, projectKeys: projectKeys })=>{
        return (0, $5uXOq.useMemo)(()=>{
            const jast = new (0, (0, parcelRequire("eK6AG")).JastBuilder)().build(jql);
            const sanitizedProjectKeys = projectKeys?.filter($290b1179285f772f$var$isProjectKey) ?? [];
            if (sanitizedProjectKeys.length === 0) return jql;
            jast.query?.appendClause((0, (0, parcelRequire("iEIQF")).default).terminalClause((0, (0, parcelRequire("iEIQF")).default).field((0, (0, parcelRequire("5Dsab")).PROJECT_FIELD_JQL_TERM)), (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_IN)), (0, (0, parcelRequire("iEIQF")).default).listOperand(sanitizedProjectKeys.map((0, (0, parcelRequire("iEIQF")).default).valueOperand))), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            return (0, (0, parcelRequire("l0V05")).print)(jast, {
                operatorCase: 'upper'
            });
        }, [
            jql,
            projectKeys
        ]);
    };
});
parcelRegister("aRep0", function(module, exports) {
    $parcel$export(module.exports, "JQLBuilderUIOld", ()=>$c957fe2570b7a195$export$328ac4451491d9e0);
    $parcel$export(module.exports, "default", ()=>$c957fe2570b7a195$export$2e2bcd8739ae039);
    var $8Q5yU;
    var $562DD;
    var $5uXOq = parcelRequire("5uXOq");
    var $kGsr8 = parcelRequire("kGsr8");
    var $8Uumt = parcelRequire("8Uumt");
    var $7ckRQ;
    var $OomEm;
    var $lfTZh;
    var $5Pkdl;
    var $032ey;
    var $atxn1;
    var $1PKzp;
    var $55ttp;
    var $kcuJ8;
    var $k3Vq9;
    var $e6DTX;
    var $2G1VO;
    var $gFE9c;
    const $c957fe2570b7a195$export$66ac472152813d8b = (0, (0, parcelRequire("562DD")).default);
    const $c957fe2570b7a195$var$JQLBuilderUI = ({ userPreferences: userPreferences, searchModes: searchModes = [
        (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED),
        (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC)
    ], onUpdateSearchMode: onUpdateSearchMode, selectedSearchMode: selectedSearchMode, isSearchModeToggleEnabled: isSearchModeToggleEnabled, irremovableFields: irremovableFields, uniqueSearchModes: uniqueSearchModes, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode = false, hideTextSearchInput: hideTextSearchInput, searchModeSwitcherLocation: searchModeSwitcherLocation, projectKeys: projectKeys, showOrderByPicker: showOrderByPicker, viewContext: viewContext = null, initialQueryRef: initialQueryRef, onLoadingMode: onLoadingMode, loadingModeRef: loadingModeRef, ...props })=>{
        const userPreferencesData = (0, $8Uumt.useFragment)($c957fe2570b7a195$export$66ac472152813d8b, userPreferences);
        const saveSearchModePreference = (0, (0, parcelRequire("e6DTX")).useSearchModeMutation)(userPreferencesData);
        const contextJql = (0, (0, parcelRequire("55ttp")).useContextJql)({
            jql: props.query,
            projectKeys: projectKeys
        });
        const hydrationQueryData = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("OomEm")).HYDRATION_QUERY), initialQueryRef);
        const [hydrationData, hydrationRefetch] = (0, $8Uumt.useRefetchableFragment)((0, (0, parcelRequire("8Q5yU")).default), hydrationQueryData);
        const onSearchModeChange = (0, $5uXOq.useCallback)((searchMode, reason)=>{
            if (reason === 'UserTriggered' || reason === 'ExternalTriggered') saveSearchModePreference(searchMode);
            onUpdateSearchMode?.(searchMode, reason);
        }, [
            onUpdateSearchMode,
            saveSearchModePreference
        ]);
        const fallback = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2G1VO")).JQLBuilderFallback), {
            query: props.query,
            searchModes: searchModes,
            onLoad: onLoadingMode,
            selectedSearchMode: selectedSearchMode,
            isSearchModeToggleEnabled: isSearchModeToggleEnabled,
            beforeControls: props.beforeControls,
            renderExtraControls: props.renderExtraControls,
            excludedFields: props.excludedFields,
            components: props.components,
            irremovableFields: irremovableFields,
            hideTextSearchInput: hideTextSearchInput,
            searchModeSwitcherLocation: searchModeSwitcherLocation,
            showOrderByPicker: showOrderByPicker
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jql-builder-ui",
            fallback: fallback
        }, hydrationData ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k3Vq9")).HydrationQueryProvider), {
            query: (0, (0, parcelRequire("5Pkdl")).default),
            refetch: hydrationRefetch,
            contextJql: contextJql
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kcuJ8")).QuerySupportedContainer), {
            query: props.query,
            excludedFields: props.excludedFields,
            jqlMessages: props.jqlMessages,
            hydrationData: hydrationData,
            simplifiedOperators: hideOperatorDropdownBasicMode,
            hideTextSearchInput: hideTextSearchInput,
            contextJql: contextJql
        }, uniqueSearchModes.length === 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1PKzp")).SingleSearchModeContainer), {
            searchMode: uniqueSearchModes[0]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gFE9c")).JQLBuilderUIImpl), {
            searchModes: uniqueSearchModes,
            hydrationData: hydrationData,
            selectedSearchMode: selectedSearchMode,
            onUpdateSearchMode: onUpdateSearchMode,
            hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
            irremovableFields: irremovableFields,
            hideTextSearchInput: hideTextSearchInput,
            searchModeSwitcherLocation: searchModeSwitcherLocation,
            contextJql: contextJql,
            showOrderByPicker: showOrderByPicker,
            loadingModeRef: loadingModeRef,
            viewContext: viewContext,
            ...props
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1PKzp")).SelectedSearchModeContainer), {
            searchMode: selectedSearchMode,
            onSearchModeChange: onSearchModeChange
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gFE9c")).JQLBuilderUIImpl), {
            searchModes: uniqueSearchModes,
            hydrationData: hydrationData,
            selectedSearchMode: selectedSearchMode,
            onUpdateSearchMode: onUpdateSearchMode,
            hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
            irremovableFields: irremovableFields,
            hideTextSearchInput: hideTextSearchInput,
            searchModeSwitcherLocation: searchModeSwitcherLocation,
            contextJql: contextJql,
            showOrderByPicker: showOrderByPicker,
            loadingModeRef: loadingModeRef,
            viewContext: viewContext,
            ...props
        })))) : fallback);
    };
    const $c957fe2570b7a195$export$328ac4451491d9e0 = ({ userPreferences: userPreferences, searchModes: searchModes = [
        (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED),
        (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC)
    ], onUpdateSearchMode: onUpdateSearchMode, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode = false, hideTextSearchInput: hideTextSearchInput = false, searchModeSwitcherLocation: searchModeSwitcherLocation = (0, (0, parcelRequire("032ey")).SEARCH_MODE_SWITCHER_LEFT_LOCATION), projectKeys: projectKeys, showOrderByPicker: showOrderByPicker, viewContext: viewContext = null, ...props })=>{
        const { onLoad: onLoad } = props;
        const loadingModeRef = (0, $5uXOq.useRef)();
        const onLoadingMode = (0, $5uXOq.useCallback)((mode)=>{
            loadingModeRef.current = mode;
            onLoad?.(mode);
        }, [
            onLoad
        ]);
        const userPreferencesData = (0, $8Uumt.useFragment)($c957fe2570b7a195$export$66ac472152813d8b, userPreferences);
        const searchModeResponse = userPreferencesData?.jqlBuilderSearchMode;
        const selectedSearchMode = (0, (0, parcelRequire("atxn1")).toSearchModeWithBasicModeFallback)(searchModeResponse);
        const saveSearchModePreference = (0, (0, parcelRequire("e6DTX")).useSearchModeMutation)(userPreferencesData);
        if (searchModes.length === 0) throw new Error('Search mode should be non empty');
        const uniqueSearchModes = (0, ($parcel$interopDefault($kGsr8)))(searchModes);
        const contextJql = (0, (0, parcelRequire("55ttp")).useContextJql)({
            jql: props.query,
            projectKeys: projectKeys
        });
        const [hydrationQueryRef, isHydrating] = (0, (0, parcelRequire("OomEm")).useHydrationQueryLoader)(contextJql, viewContext);
        const isSearchModeToggleEnabled = uniqueSearchModes ? uniqueSearchModes.length > 1 : true;
        const onSearchModeChange = (0, $5uXOq.useCallback)((searchMode, reason)=>{
            if (reason === 'UserTriggered' || reason === 'ExternalTriggered') saveSearchModePreference(searchMode);
            onUpdateSearchMode?.(searchMode, reason);
        }, [
            onUpdateSearchMode,
            saveSearchModePreference
        ]);
        const irremovableFields = (0, (0, parcelRequire("7ckRQ")).useIrremovableFields)(props.basicModeVisibleFields ?? (0, (0, parcelRequire("7ckRQ")).DEFAULT_IRREMOVABLE_FIELDS));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jql-builder-ui",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2G1VO")).JQLBuilderFallback), {
                query: props.query,
                searchModes: searchModes,
                selectedSearchMode: selectedSearchMode,
                isSearchModeToggleEnabled: isSearchModeToggleEnabled,
                beforeControls: props.beforeControls,
                renderExtraControls: props.renderExtraControls,
                excludedFields: props.excludedFields,
                components: props.components,
                irremovableFields: irremovableFields,
                hideTextSearchInput: hideTextSearchInput,
                searchModeSwitcherLocation: searchModeSwitcherLocation,
                showOrderByPicker: showOrderByPicker
            })
        }, hydrationQueryRef ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kcuJ8")).QuerySupportedContainerOld), {
            query: props.query,
            excludedFields: props.excludedFields,
            jqlMessages: props.jqlMessages,
            hydrationQueryRef: hydrationQueryRef,
            isHydrating: isHydrating,
            simplifiedOperators: hideOperatorDropdownBasicMode,
            hideTextSearchInput: hideTextSearchInput,
            contextJql: contextJql
        }, uniqueSearchModes.length === 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1PKzp")).SingleSearchModeContainer), {
            searchMode: uniqueSearchModes[0]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gFE9c")).JQLBuilderUIImplOld), {
            searchModes: uniqueSearchModes,
            hydrationQueryRef: hydrationQueryRef,
            selectedSearchMode: selectedSearchMode,
            isHydrating: isHydrating,
            onUpdateSearchMode: onUpdateSearchMode,
            hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
            irremovableFields: irremovableFields,
            hideTextSearchInput: hideTextSearchInput,
            searchModeSwitcherLocation: searchModeSwitcherLocation,
            contextJql: contextJql,
            showOrderByPicker: showOrderByPicker,
            loadingModeRef: loadingModeRef,
            viewContext: viewContext,
            ...props
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1PKzp")).SelectedSearchModeContainer), {
            searchMode: selectedSearchMode,
            onSearchModeChange: onSearchModeChange
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gFE9c")).JQLBuilderUIImplOld), {
            searchModes: uniqueSearchModes,
            hydrationQueryRef: hydrationQueryRef,
            selectedSearchMode: selectedSearchMode,
            isHydrating: isHydrating,
            onUpdateSearchMode: onUpdateSearchMode,
            hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
            irremovableFields: irremovableFields,
            hideTextSearchInput: hideTextSearchInput,
            searchModeSwitcherLocation: searchModeSwitcherLocation,
            contextJql: contextJql,
            showOrderByPicker: showOrderByPicker,
            loadingModeRef: loadingModeRef,
            viewContext: viewContext,
            ...props
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2G1VO")).JQLBuilderFallback), {
            query: props.query,
            onLoad: onLoadingMode,
            searchModes: searchModes,
            selectedSearchMode: selectedSearchMode,
            isSearchModeToggleEnabled: isSearchModeToggleEnabled,
            beforeControls: props.beforeControls,
            renderExtraControls: props.renderExtraControls,
            excludedFields: props.excludedFields,
            components: props.components,
            irremovableFields: irremovableFields,
            hideTextSearchInput: hideTextSearchInput,
            searchModeSwitcherLocation: searchModeSwitcherLocation,
            showOrderByPicker: showOrderByPicker
        }));
    };
    var $c957fe2570b7a195$export$2e2bcd8739ae039 = $c957fe2570b7a195$var$JQLBuilderUI;
});
parcelRegister("8Q5yU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba4d3d6d29eb2038$export$2e2bcd8739ae039);
    var $5Pkdl;
    const $ba4d3d6d29eb2038$var$node = function() {
        var v0 = {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }, v1 = [
            {
                "kind": "ScalarField",
                "name": "__typename"
            }
        ];
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "accountId"
                },
                {
                    "kind": "RootArgument",
                    "name": "cloudId"
                },
                {
                    "kind": "RootArgument",
                    "name": "filterAri"
                },
                {
                    "kind": "RootArgument",
                    "name": "includeJira"
                },
                {
                    "kind": "RootArgument",
                    "name": "includeUser"
                },
                {
                    "kind": "RootArgument",
                    "name": "isFilter"
                },
                {
                    "kind": "RootArgument",
                    "name": "jql"
                },
                {
                    "kind": "RootArgument",
                    "name": "viewContext"
                }
            ],
            "kind": "Fragment",
            "metadata": {
                "refetch": {
                    "fragmentPathInResult": [],
                    "operation": (0, (0, parcelRequire("5Pkdl")).default)
                }
            },
            "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValues"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useQuery"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValues_cascadeSelectPicker"
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "query",
                                                            "variableName": "jql"
                                                        },
                                                        v0
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v1
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "id",
                                                            "variableName": "filterAri"
                                                        },
                                                        v0
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v1
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        };
    }();
    $ba4d3d6d29eb2038$var$node.hash = "c68222eec6395468da06c55f73b3f4e6";
    var $ba4d3d6d29eb2038$export$2e2bcd8739ae039 = $ba4d3d6d29eb2038$var$node;
});
parcelRegister("5Pkdl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8f5bd4c6fab98c4$export$2e2bcd8739ae039);
    const $a8f5bd4c6fab98c4$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "accountId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filterAri"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "includeJira"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "includeUser"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isFilter"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "jql"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "viewContext"
            }
        ], v1 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v2 = {
            "kind": "ScalarField",
            "name": "id"
        }, v3 = [
            v1,
            {
                "kind": "ScalarField",
                "name": "picture"
            },
            v2
        ], v4 = {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }, v5 = {
            "kind": "ScalarField",
            "name": "jqlTerm"
        }, v6 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v7 = {
            "kind": "ScalarField",
            "name": "key"
        }, v8 = [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "colorName"
                    },
                    v2
                ]
            }
        ], v9 = {
            "kind": "ScalarField",
            "name": "optionId"
        }, v10 = [
            v1,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jql"
                    },
                    {
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                            v1,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v5,
                                    {
                                        "concreteType": "JiraJqlField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            v6,
                                            {
                                                "concreteType": "JiraJqlSearchTemplate",
                                                "kind": "LinkedField",
                                                "name": "searchTemplate",
                                                "plural": false,
                                                "selections": [
                                                    v7
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "shouldShowInContext"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "type"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "description"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "operators"
                                            },
                                            {
                                                "concreteType": "JiraFieldType",
                                                "kind": "LinkedField",
                                                "name": "fieldType",
                                                "plural": false,
                                                "selections": [
                                                    v6
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": true,
                                        "selections": [
                                            v1,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v5,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "values",
                                                        "plural": true,
                                                        "selections": [
                                                            v1,
                                                            v5,
                                                            v6,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v7,
                                                                            {
                                                                                "concreteType": "JiraAvatar",
                                                                                "kind": "LinkedField",
                                                                                "name": "avatar",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "small"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v2
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlProjectFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v8,
                                                                "type": "JiraJqlStatusFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v8,
                                                                "type": "JiraJqlStatusCategoryFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraAvatar",
                                                                                "kind": "LinkedField",
                                                                                "name": "avatar",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "xsmall"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v2
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueTypeFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": v3
                                                                    }
                                                                ],
                                                                "type": "JiraJqlUserFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "iconUrl"
                                                                            },
                                                                            v2
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlPriorityFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "issue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "fields",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v1,
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "text"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraSingleLineTextField"
                                                                                                    },
                                                                                                    v2
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v2
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprint",
                                                                        "kind": "LinkedField",
                                                                        "name": "sprint",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "state"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "boardName"
                                                                            },
                                                                            v2
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlSprintFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v9,
                                                                    {
                                                                        "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "parentOption",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v6,
                                                                            v5,
                                                                            v9
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlCascadingOptionFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraJqlQueryHydratedValue"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v5,
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "error",
                                                        "plural": false,
                                                        "selections": [
                                                            v1
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraJqlQueryHydratedError"
                                            }
                                        ]
                                    }
                                ],
                                "type": "JiraJqlQueryHydratedField"
                            }
                        ]
                    }
                ],
                "type": "JiraJqlHydratedQuery"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "message"
                    }
                ],
                "type": "QueryError"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "HydrationRefetchQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "HydrationRefetchQuery",
                "selections": [
                    {
                        "condition": "includeUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "accountId",
                                        "variableName": "accountId"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": v3
                            }
                        ]
                    },
                    {
                        "condition": "includeJira",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "cloudId",
                                                "variableName": "cloudId"
                                            }
                                        ],
                                        "concreteType": "JiraJqlBuilder",
                                        "kind": "LinkedField",
                                        "name": "jqlBuilder",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "query",
                                                                "variableName": "jql"
                                                            },
                                                            v4
                                                        ],
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQuery",
                                                        "plural": false,
                                                        "selections": v10
                                                    }
                                                ]
                                            },
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "id",
                                                                "variableName": "filterAri"
                                                            },
                                                            v4
                                                        ],
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQueryForFilter",
                                                        "plural": false,
                                                        "selections": v10
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "fe4d73c2374f4622a9ae124a15e1805c5a799c225a83bba386362323218851de",
                "metadata": {},
                "name": "HydrationRefetchQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $a8f5bd4c6fab98c4$var$node.hash = "c68222eec6395468da06c55f73b3f4e6";
    var $a8f5bd4c6fab98c4$export$2e2bcd8739ae039 = $a8f5bd4c6fab98c4$var$node;
});
parcelRegister("562DD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$414d5d545801f7be$export$2e2bcd8739ae039);
    const $414d5d545801f7be$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_jqlBuilder_JQLBuilderUI",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "searchMode_useSearchMode_JQLBuilder"
            },
            {
                "kind": "ScalarField",
                "name": "jqlBuilderSearchMode"
            }
        ],
        "type": "JiraUserPreferences"
    };
    $414d5d545801f7be$var$node.hash = "9fbe210abfde6a98b4eff53d65746395";
    var $414d5d545801f7be$export$2e2bcd8739ae039 = $414d5d545801f7be$var$node;
});
parcelRegister("1PKzp", function(module, exports) {
    $parcel$export(module.exports, "SelectedSearchModeContainer", ()=>$ed4a31a78e0b03e2$export$d19caa48d475b9e3);
    $parcel$export(module.exports, "SingleSearchModeContainer", ()=>$ed4a31a78e0b03e2$export$a70c1ee31d8bd058);
    $parcel$export(module.exports, "useSelectedSearchMode", ()=>$ed4a31a78e0b03e2$export$af5effaed2abb303);
    var $5uXOq = parcelRequire("5uXOq");
    var $gdJXC;
    var $8zOmE;
    var $2NMNM;
    var $032ey;
    var $kcuJ8;
    const $ed4a31a78e0b03e2$var$getSafeSearchMode = (mode)=>{
        switch(mode){
            case 0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC:
                return 0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC;
            case 0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED:
                return 0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED;
            default:
                return undefined;
        }
    };
    const $ed4a31a78e0b03e2$var$SelectedSearchModeContext = (0, $5uXOq.createContext)({
        searchMode: (0, (0, parcelRequire("032ey")).DEFAULT_SEARCH_MODE),
        setSelectedSearchMode: ()=>null
    });
    const $ed4a31a78e0b03e2$var$getValidSelectedSearchMode = (searchMode, querySupported)=>{
        if (searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED)) return 0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED;
        if (searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC) && querySupported) return 0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC;
        return 0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED;
    };
    const $ed4a31a78e0b03e2$export$d19caa48d475b9e3 = ({ children: children, searchMode: searchMode, onSearchModeChange: onSearchModeChange })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { querySupported: querySupported } = (0, (0, parcelRequire("kcuJ8")).useIsQuerySupported)();
        (0, (0, parcelRequire("gdJXC")).useRunOnce)(()=>{
            if (!querySupported && searchMode !== (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED)) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'queryTooComplex triggered', {
                searchMode: searchMode
            });
        });
        const [searchModeInternal, setSearchModeInternal] = (0, $5uXOq.useState)($ed4a31a78e0b03e2$var$getValidSelectedSearchMode(searchMode, querySupported));
        if (!querySupported && searchModeInternal !== (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED)) {
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'queryTooComplex triggered', {
                searchMode: searchModeInternal
            });
            setSearchModeInternal((0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED));
        }
        (0, $5uXOq.useEffect)(()=>{
            if (!querySupported && searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC) && searchModeInternal === (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED)) onSearchModeChange?.((0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED), 'QueryUnsupported');
        }, [
            onSearchModeChange,
            querySupported,
            searchMode,
            searchModeInternal
        ]);
        const setSelectedSearchMode = (0, $5uXOq.useCallback)((newSearchMode, userTriggered)=>{
            const safeSearchMode = $ed4a31a78e0b03e2$var$getSafeSearchMode(newSearchMode);
            if (!safeSearchMode) return;
            setSearchModeInternal(safeSearchMode);
            onSearchModeChange?.(safeSearchMode, userTriggered ? 'UserTriggered' : 'ExternalTriggered');
            if (userTriggered) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'switchJQLEditor', {
                switchToEditor: (0, (0, parcelRequire("032ey")).mapSearchModeToAnalyticAtribute)[safeSearchMode]
            });
        }, [
            createAnalyticsEvent,
            onSearchModeChange
        ]);
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                searchMode: searchModeInternal,
                setSelectedSearchMode: setSelectedSearchMode
            }), [
            searchModeInternal,
            setSelectedSearchMode
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ed4a31a78e0b03e2$var$SelectedSearchModeContext.Provider, {
            value: contextValue
        }, children);
    };
    const $ed4a31a78e0b03e2$export$a70c1ee31d8bd058 = ({ children: children, searchMode: searchMode })=>{
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                searchMode: searchMode,
                setSelectedSearchMode: ()=>null
            }), [
            searchMode
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ed4a31a78e0b03e2$var$SelectedSearchModeContext.Provider, {
            value: contextValue
        }, children);
    };
    const $ed4a31a78e0b03e2$export$af5effaed2abb303 = ()=>(0, $5uXOq.useContext)($ed4a31a78e0b03e2$var$SelectedSearchModeContext);
});
parcelRegister("gdJXC", function(module, exports) {
    $parcel$export(module.exports, "useRunOnce", ()=>$0c4640a50ed5ee95$export$a3576ea6e6df583c);
    var $5uXOq = parcelRequire("5uXOq");
    const $0c4640a50ed5ee95$export$a3576ea6e6df583c = (cb, identifier)=>{
        const ref = (0, $5uXOq.useRef)(true);
        const identifierRef = (0, $5uXOq.useRef)(identifier);
        if (identifierRef.current !== identifier) {
            ref.current = true;
            identifierRef.current = identifier;
        }
        if (ref.current) cb();
        ref.current = false;
    };
});
parcelRegister("kcuJ8", function(module, exports) {
    $parcel$export(module.exports, "QuerySupportedContainerOld", ()=>$07b5dc85de1a70b9$export$f94eb234c660c8a5);
    $parcel$export(module.exports, "QuerySupportedContainer", ()=>$07b5dc85de1a70b9$export$34660422c2aeae3d);
    $parcel$export(module.exports, "useIsQuerySupported", ()=>$07b5dc85de1a70b9$export$8ce0898530622ab2);
    var $1QEdi;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $6H2U3;
    var $89g1C;
    var $OomEm;
    var $8vNru;
    var $caSpf;
    var $k3Vq9;
    const $07b5dc85de1a70b9$export$7b6dd859fbd6fe77 = (0, (0, parcelRequire("1QEdi")).default);
    const $07b5dc85de1a70b9$var$useQuerySupportedOld = ({ currentJql: currentJql, excludedFields: excludedFields = [], jqlErrors: jqlErrors, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, simplifiedOperators: simplifiedOperators, hideTextSearchInput: hideTextSearchInput, contextJql: contextJql })=>{
        const onPerformanceMark = (0, (0, parcelRequire("caSpf")).usePerformanceContext)();
        onPerformanceMark({
            mark: (0, (0, parcelRequire("8vNru")).JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_HYDRATE_START
        });
        const hydratedData = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("OomEm")).HYDRATION_QUERY), hydrationQueryRef);
        onPerformanceMark({
            mark: (0, (0, parcelRequire("8vNru")).JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_HYDRATE_END
        });
        const fieldsHydrationData = (0, $8Uumt.useFragment)($07b5dc85de1a70b9$export$7b6dd859fbd6fe77, hydratedData);
        return (0, $5uXOq.useMemo)(()=>{
            const fieldsData = {};
            if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQuery.fields.forEach((field)=>{
                if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                    jqlTerm: field.jqlTerm,
                    searchTemplate: field.field.searchTemplate.key,
                    operators: field.field.operators.map((0, (0, parcelRequire("89g1C")).mapOperators)),
                    fieldType: field.field.type,
                    hydratedValues: field.values
                };
            });
            else if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQueryForFilter.fields.forEach((field)=>{
                if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                    jqlTerm: field.jqlTerm,
                    searchTemplate: field.field.searchTemplate.key,
                    operators: field.field.operators.map((0, (0, parcelRequire("89g1C")).mapOperators)),
                    fieldType: field.field.type,
                    hydratedValues: field.values
                };
            });
            const isLastHydrationQuery = contextJql !== hydrationQueryRef?.variables.jql;
            const querySupported = isHydrating || isLastHydrationQuery ? !(0, (0, parcelRequire("6H2U3")).isQueryTooComplex)({
                jql: currentJql,
                excludedFields: excludedFields,
                shouldValidateOperators: false,
                hideTextSearchInput: hideTextSearchInput
            }) : !(0, (0, parcelRequire("6H2U3")).isQueryTooComplex)({
                jql: currentJql,
                excludedFields: excludedFields,
                fieldsData: fieldsData,
                simplifiedOperators: simplifiedOperators,
                hideTextSearchInput: hideTextSearchInput
            }) && !jqlErrors?.length;
            return {
                querySupported: querySupported
            };
        }, [
            fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields,
            fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields,
            contextJql,
            hydrationQueryRef?.variables.jql,
            currentJql,
            isHydrating,
            excludedFields,
            hideTextSearchInput,
            simplifiedOperators,
            jqlErrors?.length
        ]);
    };
    const $07b5dc85de1a70b9$export$f94eb234c660c8a5 = ({ query: query, excludedFields: excludedFields = [], jqlMessages: jqlMessages, children: children, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating = false, simplifiedOperators: simplifiedOperators = false, hideTextSearchInput: hideTextSearchInput = false, contextJql: contextJql })=>{
        const jqlErrors = (0, $5uXOq.useMemo)(()=>(jqlMessages || []).filter((e)=>e.type === 'error'), [
            jqlMessages
        ]);
        const { querySupported: querySupported } = $07b5dc85de1a70b9$var$useQuerySupportedOld({
            currentJql: query,
            excludedFields: excludedFields,
            jqlErrors: jqlErrors,
            hydrationQueryRef: hydrationQueryRef,
            isHydrating: isHydrating,
            simplifiedOperators: simplifiedOperators,
            hideTextSearchInput: hideTextSearchInput,
            contextJql: contextJql
        });
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                querySupported: querySupported
            }), [
            querySupported
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($07b5dc85de1a70b9$var$QuerySupportedContext.Provider, {
            value: contextValue
        }, children);
    };
    const $07b5dc85de1a70b9$var$useQuerySupported = ({ currentJql: currentJql, excludedFields: excludedFields = [], jqlErrors: jqlErrors, hydrationData: hydrationData, simplifiedOperators: simplifiedOperators, hideTextSearchInput: hideTextSearchInput, contextJql: contextJql })=>{
        const fieldsHydrationData = (0, $8Uumt.useFragment)($07b5dc85de1a70b9$export$7b6dd859fbd6fe77, hydrationData);
        const { hydrationQueryIsFetching: hydrationQueryIsFetching, hydrationQueryContextJql: hydrationQueryContextJql } = (0, (0, parcelRequire("k3Vq9")).useHydrationQuery)();
        return (0, $5uXOq.useMemo)(()=>{
            const fieldsData = {};
            if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQuery.fields.forEach((field)=>{
                if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                    jqlTerm: field.jqlTerm,
                    searchTemplate: field.field.searchTemplate.key,
                    operators: field.field.operators.map((0, (0, parcelRequire("89g1C")).mapOperators)),
                    fieldType: field.field.type,
                    hydratedValues: field.values
                };
            });
            else if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQueryForFilter.fields.forEach((field)=>{
                if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                    jqlTerm: field.jqlTerm,
                    searchTemplate: field.field.searchTemplate.key,
                    operators: field.field.operators.map((0, (0, parcelRequire("89g1C")).mapOperators)),
                    fieldType: field.field.type,
                    hydratedValues: field.values
                };
            });
            const isLastHydrationQuery = contextJql !== hydrationQueryContextJql;
            const querySupported = hydrationQueryIsFetching || isLastHydrationQuery ? !(0, (0, parcelRequire("6H2U3")).isQueryTooComplex)({
                jql: currentJql,
                excludedFields: excludedFields,
                shouldValidateOperators: false,
                hideTextSearchInput: hideTextSearchInput
            }) : !(0, (0, parcelRequire("6H2U3")).isQueryTooComplex)({
                jql: currentJql,
                excludedFields: excludedFields,
                fieldsData: fieldsData,
                simplifiedOperators: simplifiedOperators,
                hideTextSearchInput: hideTextSearchInput
            }) && !jqlErrors?.length;
            return {
                querySupported: querySupported
            };
        }, [
            fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields,
            fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields,
            contextJql,
            hydrationQueryContextJql,
            hydrationQueryIsFetching,
            currentJql,
            excludedFields,
            hideTextSearchInput,
            simplifiedOperators,
            jqlErrors?.length
        ]);
    };
    const $07b5dc85de1a70b9$var$QuerySupportedContext = (0, $5uXOq.createContext)({
        querySupported: true
    });
    const $07b5dc85de1a70b9$export$34660422c2aeae3d = ({ query: query, excludedFields: excludedFields = [], jqlMessages: jqlMessages, children: children, hydrationData: hydrationData, simplifiedOperators: simplifiedOperators = false, hideTextSearchInput: hideTextSearchInput = false, contextJql: contextJql })=>{
        const jqlErrors = (0, $5uXOq.useMemo)(()=>(jqlMessages || []).filter((e)=>e.type === 'error'), [
            jqlMessages
        ]);
        const { querySupported: querySupported } = $07b5dc85de1a70b9$var$useQuerySupported({
            currentJql: query,
            excludedFields: excludedFields,
            jqlErrors: jqlErrors,
            hydrationData: hydrationData,
            simplifiedOperators: simplifiedOperators,
            hideTextSearchInput: hideTextSearchInput,
            contextJql: contextJql
        });
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                querySupported: querySupported
            }), [
            querySupported
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($07b5dc85de1a70b9$var$QuerySupportedContext.Provider, {
            value: contextValue
        }, children);
    };
    const $07b5dc85de1a70b9$export$8ce0898530622ab2 = ()=>(0, $5uXOq.useContext)($07b5dc85de1a70b9$var$QuerySupportedContext);
});
parcelRegister("1QEdi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01f9bf733604f8cd$export$2e2bcd8739ae039);
    const $01f9bf733604f8cd$var$node = function() {
        var v0 = {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }, v1 = {
            "kind": "ScalarField",
            "name": "jqlTerm"
        }, v2 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v3 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v4 = {
            "kind": "ScalarField",
            "name": "optionId"
        }, v5 = [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v1,
                                    {
                                        "concreteType": "JiraJqlField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "operators"
                                            },
                                            {
                                                "concreteType": "JiraJqlSearchTemplate",
                                                "kind": "LinkedField",
                                                "name": "searchTemplate",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "key"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "type"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v2,
                                                    v1,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "values",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v2,
                                                                    v1,
                                                                    v3,
                                                                    v4,
                                                                    {
                                                                        "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "parentOption",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v3,
                                                                            v1,
                                                                            v4
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlCascadingOptionFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraJqlQueryHydratedValue"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v2,
                                                    v1
                                                ],
                                                "type": "JiraJqlQueryHydratedError"
                                            }
                                        ]
                                    }
                                ],
                                "type": "JiraJqlQueryHydratedField"
                            }
                        ]
                    }
                ],
                "type": "JiraJqlHydratedQuery"
            }
        ];
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "cloudId"
                },
                {
                    "kind": "RootArgument",
                    "name": "filterAri"
                },
                {
                    "kind": "RootArgument",
                    "name": "includeJira"
                },
                {
                    "kind": "RootArgument",
                    "name": "isFilter"
                },
                {
                    "kind": "RootArgument",
                    "name": "jql"
                },
                {
                    "kind": "RootArgument",
                    "name": "viewContext"
                }
            ],
            "kind": "Fragment",
            "name": "useQuery",
            "selections": [
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "query",
                                                            "variableName": "jql"
                                                        },
                                                        v0
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v5
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "id",
                                                            "variableName": "filterAri"
                                                        },
                                                        v0
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v5
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        };
    }();
    $01f9bf733604f8cd$var$node.hash = "2f363277414286c5c850b5c424d00b46";
    var $01f9bf733604f8cd$export$2e2bcd8739ae039 = $01f9bf733604f8cd$var$node;
});
parcelRegister("6H2U3", function(module, exports) {
    $parcel$export(module.exports, "isQueryTooComplex", ()=>$6a273a05a18a6f17$export$4a510b220f67686c);
    var $eK6AG;
    var $5Dsab;
    var $8RcVP;
    var $i00hv;
    var $eftWU;
    var $6jt9j;
    var $4uLp9;
    const $6a273a05a18a6f17$var$haveKnownUnsupportedOperators = (clauses)=>clauses.some((clause)=>clause.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a) && clause.operator && (0, (0, parcelRequire("4uLp9")).getUnsupportedOperators)().includes(clause.operator.value));
    const $6a273a05a18a6f17$var$isClauseTooComplex = ({ clauses: clauses, searchTemplate: searchTemplate, hydratedValues: hydratedValues })=>{
        if (!searchTemplate || (0, (0, parcelRequire("5Dsab")).dateSearchTemplates).has(searchTemplate)) return clauses.length > 2 || $6a273a05a18a6f17$var$haveKnownUnsupportedOperators(clauses);
        if (searchTemplate === (0, (0, parcelRequire("5Dsab")).CASCADE_SELECT_FIELD_SEARCH_TEMPLATE)) {
            const unambiguousCascadeFieldValue = (0, (0, parcelRequire("i00hv")).findUnambiguousCascadeFieldValue)({
                clause: clauses[0],
                hydratedValues: hydratedValues
            });
            return clauses.length !== 1 || unambiguousCascadeFieldValue === undefined;
        }
        if (searchTemplate === (0, (0, parcelRequire("5Dsab")).NUMBER_RANGE_FIELD_SEARCH_TEMPLATE) || searchTemplate === 'workratio') {
            const operatorValues = clauses.map((clause)=>clause?.operator?.value.toString());
            return clauses.length > 2 || clauses.length === 2 && !(0, (0, parcelRequire("5Dsab")).NUMBER_RANGE_PICKER_ALLOWED_OPERATORS).every((op)=>operatorValues.includes(op));
        }
        if (searchTemplate === (0, (0, parcelRequire("5Dsab")).CMDB_FIELD_SEARCH_TEMPLATE)) return clauses.length !== 1 || (0, (0, parcelRequire("eftWU")).isCmdbClauseTooComplexForBasicMode)(clauses[0]);
        return clauses.length > 1;
    };
    const $6a273a05a18a6f17$export$4a510b220f67686c = ({ jql: jql, excludedFields: excludedFields = [], fieldsData: fieldsData, shouldValidateOperators: shouldValidateOperators = true, simplifiedOperators: simplifiedOperators = false, hideTextSearchInput: hideTextSearchInput = false })=>{
        const jast = new (0, (0, parcelRequire("eK6AG")).JastBuilder)().build(jql);
        if (jast.errors.length) return true;
        try {
            const jqlClauseCollectingVisitor = new (0, (0, parcelRequire("6jt9j")).JqlClauseCollectingVisitor)(shouldValidateOperators, excludedFields, fieldsData, simplifiedOperators);
            const result = jast.query && jast.query.accept(jqlClauseCollectingVisitor);
            if (!result) return false;
            return (result.textSearchInputClause && hideTextSearchInput || !(0, (0, parcelRequire("8RcVP")).default).validate(result.textSearchInputClause) || Object.keys(result.clauseMap).some((key)=>{
                const clauses = result.clauseMap[key];
                const searchTemplate = fieldsData?.[key]?.searchTemplate;
                return $6a273a05a18a6f17$var$isClauseTooComplex({
                    clauses: clauses,
                    searchTemplate: searchTemplate,
                    hydratedValues: fieldsData?.[key]?.hydratedValues
                });
            }));
        } catch (error) {
            return true;
        }
    };
});
parcelRegister("8RcVP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$805845a75e8bdf1e$export$2e2bcd8739ae039);
    var $iEIQF;
    var $bzbto;
    var $l0V05;
    var $4R6GH;
    var $5Dsab;
    var $1dTaH;
    var $k3hd7;
    const $805845a75e8bdf1e$var$validate = (compoundClause)=>{
        const isTextFieldsEnabled = (0, (0, parcelRequire("4R6GH")).fg)('nin-text-fields-new-text-search-field');
        if (!compoundClause) return true;
        try {
            compoundClause.accept(new (0, (0, parcelRequire("k3hd7")).TextSearchInputVisitor)({
                isTextFieldsEnabled: isTextFieldsEnabled
            }));
            return true;
        } catch (e) {
            return false;
        }
    };
    const $805845a75e8bdf1e$var$value = (textSearchClause)=>{
        const isTextFieldsEnabled = (0, (0, parcelRequire("4R6GH")).fg)('nin-text-fields-new-text-search-field');
        if (!textSearchClause) return undefined;
        try {
            return textSearchClause.accept(new (0, (0, parcelRequire("k3hd7")).TextSearchInputVisitor)({
                isTextFieldsEnabled: isTextFieldsEnabled
            }));
        } catch (e) {
            return undefined;
        }
    };
    const $805845a75e8bdf1e$var$createTextSearchInputClause = ({ quotedKeyword: quotedKeyword, isIssueKey: isIssueKey })=>{
        const textSearchInputClause = (0, (0, parcelRequire("iEIQF")).default).terminalClause((0, (0, parcelRequire("iEIQF")).default).field((0, (0, parcelRequire("5Dsab")).getTextSearchInputField)()), (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_LIKE)), (0, (0, parcelRequire("iEIQF")).default).byText.valueOperand(quotedKeyword));
        if (isIssueKey) {
            const issueKeyClause = (0, (0, parcelRequire("iEIQF")).default).terminalClause((0, (0, parcelRequire("iEIQF")).default).field((0, (0, parcelRequire("5Dsab")).ISSUE_KEY)), (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS)), (0, (0, parcelRequire("iEIQF")).default).byText.valueOperand(quotedKeyword));
            return (0, (0, parcelRequire("iEIQF")).default).compoundClause((0, (0, parcelRequire("iEIQF")).default).compoundOperator((0, $3cef51f82b2cbe1d$export$7b8f0a728d79a753)), [
                textSearchInputClause,
                issueKeyClause
            ]);
        }
        return textSearchInputClause;
    };
    const $805845a75e8bdf1e$var$update = (ast, textSearchInputClause, val)=>{
        if (!$805845a75e8bdf1e$var$validate(textSearchInputClause)) return ast.represents;
        if (val === undefined || val === null || val === '') {
            if (textSearchInputClause) textSearchInputClause.remove();
            else return ast.represents;
        } else {
            const isIssueKey = (0, (0, parcelRequire("k3hd7")).isIssueKeyValue)(val);
            const quotedKeyword = (0, (0, parcelRequire("1dTaH")).wrapWithQuotes)((0, (0, parcelRequire("1dTaH")).escapeBackslashes)(val));
            const newTextSearchInputClause = $805845a75e8bdf1e$var$createTextSearchInputClause({
                quotedKeyword: quotedKeyword,
                isIssueKey: isIssueKey
            });
            if (textSearchInputClause) textSearchInputClause.replace(newTextSearchInputClause);
            else ast.query?.appendClause(newTextSearchInputClause, (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
        }
        return (0, (0, parcelRequire("l0V05")).print)(ast, {
            operatorCase: 'upper'
        });
    };
    const $805845a75e8bdf1e$var$TextFieldType = {
        validate: $805845a75e8bdf1e$var$validate,
        value: $805845a75e8bdf1e$var$value,
        update: $805845a75e8bdf1e$var$update
    };
    var $805845a75e8bdf1e$export$2e2bcd8739ae039 = $805845a75e8bdf1e$var$TextFieldType;
});
parcelRegister("1dTaH", function(module, exports) {
    $parcel$export(module.exports, "generateOptions", ()=>$7ba5746e0a05ea50$export$c21133b4499f5374);
    $parcel$export(module.exports, "generateErrorOptions", ()=>$7ba5746e0a05ea50$export$b1b163cf4487fb60);
    $parcel$export(module.exports, "fireJqlBuilderBasicErrorAnalytics", ()=>$7ba5746e0a05ea50$export$2704bef70095c059);
    $parcel$export(module.exports, "wrapWithQuotes", ()=>$7ba5746e0a05ea50$export$125e49598117a72);
    $parcel$export(module.exports, "escapeBackslashes", ()=>$7ba5746e0a05ea50$export$fbd15c27bb7e257c);
    $parcel$export(module.exports, "isPickerPropType", ()=>$7ba5746e0a05ea50$export$353a391606dc3779);
    $parcel$export(module.exports, "isTextAreaPropType", ()=>$7ba5746e0a05ea50$export$96188d366777c3f5);
    var $jcw0u;
    var $5Dsab;
    var $8OILN;
    const $7ba5746e0a05ea50$export$c21133b4499f5374 = (options, totalCount, endCursor)=>({
            options: options,
            totalCount: totalCount === undefined ? null : totalCount,
            endCursor: endCursor
        });
    const $7ba5746e0a05ea50$export$b1b163cf4487fb60 = (error)=>$7ba5746e0a05ea50$export$c21133b4499f5374([
            {
                optionType: 'error',
                error: error,
                onRetry: ()=>undefined
            }
        ]);
    const $7ba5746e0a05ea50$export$2704bef70095c059 = (id, searchTemplate, error)=>(0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: id,
                packageName: (0, (0, parcelRequire("5Dsab")).PACKAGE_NAME),
                teamName: (0, (0, parcelRequire("5Dsab")).TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                searchTemplate: searchTemplate
            }
        });
    const $7ba5746e0a05ea50$export$125e49598117a72 = (text)=>`"${text.replace(/"/g, '\\"')}"`;
    const $7ba5746e0a05ea50$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');
    const $7ba5746e0a05ea50$export$353a391606dc3779 = (propType)=>Object.values((0, (0, parcelRequire("8OILN")).PickerPropTypes)).includes(propType);
    const $7ba5746e0a05ea50$export$96188d366777c3f5 = (propType)=>Object.values((0, (0, parcelRequire("8OILN")).TextAreaPropTypes)).includes(propType);
});
parcelRegister("8OILN", function(module, exports) {
    $parcel$export(module.exports, "PickerTypes", ()=>$7fe736d8adf76ba6$export$823060bb41f9b9ce);
    $parcel$export(module.exports, "PickerPropTypes", ()=>$7fe736d8adf76ba6$export$8673a3795efdab32);
    $parcel$export(module.exports, "TextAreaPropTypes", ()=>$7fe736d8adf76ba6$export$84f313a0fe939ad2);
    $parcel$export(module.exports, "GenericPropTypes", ()=>$7fe736d8adf76ba6$export$39db718405e40735);
    const $7fe736d8adf76ba6$export$823060bb41f9b9ce = {
        CascadeSelect: 'CascadeSelect',
        DateTime: 'DateTime',
        DueDate: 'DueDate',
        DateTimeRange: 'DateTimeRange',
        NumberRange: 'NumberRange',
        Picker: 'Picker',
        Text: 'Text',
        TextArea: 'TextArea',
        BooleanType: 'BooleanType',
        Unsupported: 'Unsupported'
    };
    const $7fe736d8adf76ba6$export$8673a3795efdab32 = {
        CommonWithEmpty: 'CommonWithEmpty',
        Common: 'Common',
        IssueType: 'IssueType',
        Project: 'Project',
        Sprint: 'Sprint',
        Version: 'Version',
        User: 'User',
        Group: 'Group'
    };
    const $7fe736d8adf76ba6$export$84f313a0fe939ad2 = {
        Text: 'Text',
        Number: 'Number',
        Aql: 'Aql',
        ExactText: 'ExactText'
    };
    const $7fe736d8adf76ba6$export$39db718405e40735 = {
        NoProp: 'NoProp'
    };
});
parcelRegister("k3hd7", function(module, exports) {
    $parcel$export(module.exports, "isIssueKeyValue", ()=>$c01848c35007a5b6$export$ac7a009e7c9d6434);
    $parcel$export(module.exports, "TextSearchInputVisitor", ()=>$c01848c35007a5b6$export$d5784d52b31adc66);
    var $bv7J5;
    var $bzbto;
    var $5Dsab;
    var $kznWD;
    const $c01848c35007a5b6$var$areTerminalClauses = (clauses)=>{
        for (const clause of clauses){
            if (clause.clauseType !== (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) return false;
        }
        return true;
    };
    const $c01848c35007a5b6$var$ISSUE_KEY_REGEXP = new RegExp('^[A-Z][A-Z0-9]+-[0-9]+$', 'i');
    const $c01848c35007a5b6$export$ac7a009e7c9d6434 = (value)=>value !== undefined && value !== null && $c01848c35007a5b6$var$ISSUE_KEY_REGEXP.test(value);
    class $c01848c35007a5b6$export$d5784d52b31adc66 extends (0, (0, parcelRequire("bv7J5")).AbstractJastVisitor) {
        constructor({ isTextFieldsEnabled: isTextFieldsEnabled }){
            super(), this.visitCompoundClause = (compoundClause)=>{
                if (compoundClause.clauses.length > 2 || compoundClause.clauses.length < 1 || compoundClause.operator.value !== (0, $3cef51f82b2cbe1d$export$7b8f0a728d79a753) || !$c01848c35007a5b6$var$areTerminalClauses(compoundClause.clauses)) throw new (0, (0, parcelRequire("kznWD")).InvalidTextSearchInputError)('Invalid search input clause');
                const valueMap = {};
                const value = compoundClause.clauses.reduce((result, terminalClause)=>{
                    const clauseFieldName = terminalClause.field.value.toLowerCase();
                    const fieldName = clauseFieldName === 'key' ? 'issuekey' : clauseFieldName;
                    if (valueMap[fieldName]) throw new (0, (0, parcelRequire("kznWD")).InvalidTextSearchInputError)(`Duplicated field ${fieldName}`);
                    else valueMap[fieldName] = true;
                    return this.aggregateResult(terminalClause.accept(this), result);
                }, undefined);
                if (!valueMap[(0, (0, parcelRequire("5Dsab")).getTextSearchInputField)()] || valueMap.issuekey !== undefined && !valueMap.issuekey) throw new (0, (0, parcelRequire("kznWD")).InvalidTextSearchInputError)('Missing required field in search input');
                return value;
            }, this.visitTerminalClause = (terminalClause)=>{
                const fieldName = terminalClause.field.value.toLowerCase();
                if (terminalClause.operand?.operandType !== (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)) throw new (0, (0, parcelRequire("kznWD")).InvalidTextSearchInputError)(`Invalid operandType ${terminalClause.operand?.operandType}`);
                if (fieldName === (0, (0, parcelRequire("5Dsab")).getTextSearchInputField)()) {
                    if (terminalClause.operator?.value !== (0, (0, parcelRequire("bzbto")).OPERATOR_LIKE)) throw new (0, (0, parcelRequire("kznWD")).InvalidTextSearchInputError)(`Invalid operator in ${fieldName}`);
                    return terminalClause.operand.value;
                }
                if (fieldName === 'issuekey' || fieldName === 'key') {
                    if (terminalClause.operator?.value !== (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS)) throw new (0, (0, parcelRequire("kznWD")).InvalidTextSearchInputError)(`Invalid operator in ${fieldName}`);
                    if (!$c01848c35007a5b6$export$ac7a009e7c9d6434(terminalClause.operand.value)) throw new (0, (0, parcelRequire("kznWD")).InvalidTextSearchInputError)(`Invalid value in ${fieldName}`);
                    return terminalClause.operand.value;
                }
                throw new (0, (0, parcelRequire("kznWD")).InvalidTextSearchInputError)(`Invalid field ${fieldName}`);
            }, this.aggregateResult = (aggregate, nextResult)=>{
                if (nextResult !== undefined && aggregate !== nextResult) throw new (0, (0, parcelRequire("kznWD")).InvalidTextSearchInputError)('Mismatched values in search input');
                return aggregate;
            };
            this.isTextFieldsEnabled = isTextFieldsEnabled;
        }
        defaultResult() {
            throw new (0, (0, parcelRequire("kznWD")).InvalidTextSearchInputError)('Invalid search input clause');
        }
    }
});
parcelRegister("kznWD", function(module, exports) {
    $parcel$export(module.exports, "InvalidTextSearchInputError", ()=>$dc80ec1a6ef3f97f$export$d6efcb4541a8aae7);
    class $dc80ec1a6ef3f97f$export$d6efcb4541a8aae7 extends Error {
    }
});
parcelRegister("i00hv", function(module, exports) {
    $parcel$export(module.exports, "findUnambiguousCascadeFieldValue", ()=>$fc1c10b0cc689c7e$export$b146240c7e4a7cf6);
    var $5Dsab;
    const $fc1c10b0cc689c7e$export$d6b4e2aa5cb86d59 = 'JiraJqlCascadingOptionFieldValue';
    const $fc1c10b0cc689c7e$var$isHydrationJqlValueOrError = (value)=>value?.__typename === 'JiraJqlQueryHydratedValue' || value?.__typename === 'JiraJqlQueryHydratedError';
    const $fc1c10b0cc689c7e$var$matchValueToClause = (hydratedValues, clauseValue)=>clauseValue ? hydratedValues?.find((fieldValue)=>$fc1c10b0cc689c7e$var$isHydrationJqlValueOrError(fieldValue) && fieldValue?.jqlTerm?.toLowerCase() === clauseValue?.toLowerCase()) : undefined;
    const $fc1c10b0cc689c7e$var$isCascadingOptionFieldValue = (value)=>value?.__typename === 'JiraJqlCascadingOptionFieldValue';
    const $fc1c10b0cc689c7e$var$getCascadingSelectStateFromFieldValue = (value)=>{
        if (!value?.optionId || !value?.displayName) return undefined;
        if (value.parentOption?.optionId && value.parentOption?.displayName) return {
            childOption: {
                label: value.displayName,
                value: value.optionId
            },
            parentOption: {
                label: value.parentOption.displayName,
                value: value.parentOption.optionId
            }
        };
        return {
            parentOption: {
                label: value.displayName,
                value: value.optionId
            }
        };
    };
    const $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption = (valueOrError)=>({
            label: valueOrError.jqlTerm,
            value: valueOrError.jqlTerm,
            isInvalid: true
        });
    const $fc1c10b0cc689c7e$var$getCascadingSelectStateForFunction = (parent, child)=>{
        if (!parent) return undefined;
        if (parent?.__typename === 'JiraJqlQueryHydratedError') return {
            parentOption: $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption(parent),
            childOption: child ? $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption(child) : undefined
        };
        const parentValues = parent?.values?.filter($fc1c10b0cc689c7e$var$isCascadingOptionFieldValue).filter((parentValue)=>!parentValue?.parentOption);
        if (!child && parentValues?.length === 1) return $fc1c10b0cc689c7e$var$getCascadingSelectStateFromFieldValue(parentValues[0]);
        if (!child) return undefined;
        if (child?.__typename === 'JiraJqlQueryHydratedError') return parentValues?.length === 1 ? {
            ...$fc1c10b0cc689c7e$var$getCascadingSelectStateFromFieldValue(parentValues[0]),
            childOption: $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption(child)
        } : {
            parentOption: $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption(parent),
            childOption: $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption(child)
        };
        const childValues = child?.values?.filter($fc1c10b0cc689c7e$var$isCascadingOptionFieldValue).filter((childValue)=>parentValues?.some((parentValue)=>childValue?.parentOption && parentValue?.optionId === childValue?.parentOption.optionId));
        if (childValues?.length === 1) return $fc1c10b0cc689c7e$var$getCascadingSelectStateFromFieldValue(childValues[0]);
    };
    const $fc1c10b0cc689c7e$export$b146240c7e4a7cf6 = ({ hydratedValues: hydratedValues, clause: clause })=>{
        if (clause?.clauseType !== (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) return;
        if (clause?.operand?.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df) && clause?.operand?.values?.length > 1) return;
        if (clause?.operand?.operandType === (0, $49b29ef7baa2a152$export$19c7c729db381f9d) && clause?.operand?.function.value === (0, (0, parcelRequire("5Dsab")).CASCADE_OPTION_FUNCTION_NAME) && clause?.operand?.arguments && clause?.operand?.arguments.length <= 2) {
            const { operand: operand } = clause;
            return $fc1c10b0cc689c7e$var$getCascadingSelectStateForFunction($fc1c10b0cc689c7e$var$matchValueToClause(hydratedValues, operand?.arguments[0]?.value), $fc1c10b0cc689c7e$var$matchValueToClause(hydratedValues, operand?.arguments[1]?.value));
        }
        if (clause?.operand?.operandType !== (0, $49b29ef7baa2a152$export$f6049126fd97001f)) {
            let clauseValue = '';
            switch(clause?.operand?.operandType){
                case 0, $49b29ef7baa2a152$export$fabec4aebba3f4df:
                    if (clause?.operand?.values?.[0]?.operandType !== (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)) return;
                    clauseValue = clause?.operand?.values?.[0]?.value;
                    break;
                case 0, $49b29ef7baa2a152$export$38accfc5a5d1c113:
                    clauseValue = clause?.operand?.value;
                    break;
                default:
                    return;
            }
            const matchedValue = $fc1c10b0cc689c7e$var$matchValueToClause(hydratedValues, clauseValue);
            if (matchedValue?.__typename === 'JiraJqlQueryHydratedError') return {
                parentOption: $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption(matchedValue)
            };
            if (matchedValue?.values && matchedValue.values.length === 1 && $fc1c10b0cc689c7e$var$isCascadingOptionFieldValue(matchedValue.values[0])) return $fc1c10b0cc689c7e$var$getCascadingSelectStateFromFieldValue(matchedValue.values[0]);
        }
        return undefined;
    };
});
parcelRegister("eftWU", function(module, exports) {
    $parcel$export(module.exports, "isCmdbClauseTooComplexForBasicMode", ()=>$65337d97e1daaca1$export$eed7916f3400f094);
    var $5Dsab;
    const $65337d97e1daaca1$export$eed7916f3400f094 = (clause)=>clause.clauseType !== (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a) || clause.operand?.operandType !== (0, $49b29ef7baa2a152$export$19c7c729db381f9d) || ![
            (0, (0, parcelRequire("5Dsab")).AQL_FUNCTION_NAME).toLowerCase(),
            (0, (0, parcelRequire("5Dsab")).IQL_FUNCTION_NAME).toLowerCase()
        ].includes(clause.operand?.function.value.toLowerCase()) || clause.operand?.arguments.length !== 1;
});
parcelRegister("6jt9j", function(module, exports) {
    $parcel$export(module.exports, "JqlClauseCollectingVisitor", ()=>$ed1a767d3d234642$export$566c7abb4018442d);
    var $3dHKF = parcelRequire("3dHKF");
    var $bv7J5;
    var $5Dsab;
    var $8OILN;
    var $i0Cp4;
    var $j200s;
    class $ed1a767d3d234642$export$566c7abb4018442d extends (0, (0, parcelRequire("bv7J5")).AbstractJastVisitor) {
        constructor(shouldValidateOperators = true, excludedFields = [], fieldsData, simplifiedOperators = false){
            super(), this.visitCompoundClause = (compoundClause)=>{
                const operator = compoundClause.operator.value;
                if (operator === (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97)) return compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), {
                    clauseMap: {}
                });
                if (operator === (0, $3cef51f82b2cbe1d$export$7b8f0a728d79a753)) return {
                    clauseMap: {},
                    textSearchInputClause: compoundClause
                };
                throw new (0, (0, parcelRequire("j200s")).UnsupportedRefinementError)(`Compound clauses using the operator '${operator}' is not supported`);
            }, this.visitTerminalClause = (terminalClause)=>{
                const fieldName = terminalClause.field.value.toLowerCase();
                if (this.shouldValidateOperators) {
                    if (this.excludedFields.includes(fieldName)) throw new (0, (0, parcelRequire("j200s")).UnsupportedRefinementError)(`Field with name '${fieldName}' of type ${terminalClause.clauseType} is not supported`);
                    const operator = terminalClause.operator?.value ?? '';
                    if (this.fieldsData) {
                        const textSearchInputData = (0, (0, parcelRequire("5Dsab")).getTextSearchInputFieldData)();
                        const fieldData = fieldName === textSearchInputData.jqlTerm ? textSearchInputData : this.fieldsData[fieldName];
                        const { allowedOperators: allowedOperators, pickerType: pickerType } = (0, (0, parcelRequire("i0Cp4")).getPickerType)({
                            searchTemplate: fieldData.searchTemplate,
                            fieldType: fieldData.fieldType,
                            operators: fieldData.operators,
                            simplifiedOperators: this.simplifiedOperators
                        });
                        if (pickerType !== (0, (0, parcelRequire("8OILN")).PickerTypes).Unsupported && allowedOperators) {
                            const isAllowedOperator = allowedOperators.map((allowedOperator)=>allowedOperator.value.toLowerCase()).includes(operator.toLowerCase());
                            if (!isAllowedOperator) throw new (0, (0, parcelRequire("j200s")).UnsupportedRefinementError)(`Field with value '${fieldName}' and searchTemplate '${fieldData.searchTemplate}' of type ${terminalClause.clauseType} is using an unsupported operator [${operator}]`);
                        }
                    } else throw new (0, (0, parcelRequire("j200s")).UnsupportedRefinementError)('Field data should be defined to validate operators');
                }
                if (fieldName === (0, (0, parcelRequire("5Dsab")).getTextSearchInputField)()) return {
                    clauseMap: {},
                    textSearchInputClause: terminalClause
                };
                return {
                    clauseMap: {
                        [terminalClause.field.value.toLowerCase()]: [
                            terminalClause
                        ]
                    }
                };
            };
            this.shouldValidateOperators = shouldValidateOperators;
            this.excludedFields = excludedFields;
            this.fieldsData = fieldsData;
            this.simplifiedOperators = simplifiedOperators;
        }
        visitNotClause() {
            throw new (0, (0, parcelRequire("j200s")).UnsupportedRefinementError)('JqlClauseCollectingVisitor visited an unsupported node while traversing the AST');
        }
        defaultResult() {
            return {
                clauseMap: {}
            };
        }
        aggregateResult(aggregate, nextResult) {
            if (nextResult.textSearchInputClause && aggregate.textSearchInputClause) throw new (0, (0, parcelRequire("j200s")).UnsupportedRefinementError)('Too many text search input clause clauses');
            return {
                clauseMap: (0, ($parcel$interopDefault($3dHKF)))(nextResult.clauseMap, aggregate.clauseMap, (destValue, srcValue)=>srcValue.concat(destValue ?? [])),
                textSearchInputClause: aggregate.textSearchInputClause === undefined ? nextResult.textSearchInputClause : aggregate.textSearchInputClause
            };
        }
    }
});
parcelRegister("3dHKF", function(module, exports) {
    var $1m1GH = parcelRequire("1m1GH");
    var $9MM2g = parcelRequire("9MM2g");
    var $2584862af7fb4983$var$mergeWith = $9MM2g(function(object, source, srcIndex, customizer) {
        $1m1GH(object, source, srcIndex, customizer);
    });
    module.exports = $2584862af7fb4983$var$mergeWith;
});
parcelRegister("i0Cp4", function(module, exports) {
    $parcel$export(module.exports, "getUnsupportedPickerType", ()=>$02d8cf8959551cab$export$fb7c01070886ad20);
    $parcel$export(module.exports, "getPickerType", ()=>$02d8cf8959551cab$export$42840c00d43e8a94);
    var $4R6GH;
    var $5Dsab;
    var $8OILN;
    var $8OqfS;
    const $02d8cf8959551cab$export$fb7c01070886ad20 = ({ searchTemplate: searchTemplate, fieldType: fieldType })=>({
            searchTemplate: searchTemplate,
            fieldType: fieldType,
            pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Unsupported,
            propType: (0, (0, parcelRequire("8OILN")).GenericPropTypes).NoProp
        });
    const $02d8cf8959551cab$var$getPickerData = ({ searchTemplate: searchTemplate, fieldType: fieldType, pickerType: pickerType, propType: propType, fieldOperators: fieldOperators, simplifiedOperators: simplifiedOperators = false })=>({
            searchTemplate: searchTemplate,
            fieldType: fieldType,
            pickerType: pickerType,
            propType: propType,
            allowedOperators: (0, (0, parcelRequire("8OqfS")).getAllowedOperators)({
                pickerType: pickerType,
                fieldOperators: fieldOperators,
                propType: propType,
                simplifiedOperators: simplifiedOperators
            })
        });
    const $02d8cf8959551cab$export$42840c00d43e8a94 = ({ searchTemplate: searchTemplate, fieldType: fieldType, operators: fieldOperators, simplifiedOperators: simplifiedOperators })=>{
        const commonAttributes = {
            searchTemplate: searchTemplate,
            fieldType: fieldType,
            fieldOperators: fieldOperators,
            simplifiedOperators: simplifiedOperators
        };
        switch(searchTemplate){
            case 'text':
                if ((0, (0, parcelRequire("4R6GH")).fg)('nin-text-fields-new-text-search-field')) return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).TextArea,
                    propType: (0, (0, parcelRequire("8OILN")).TextAreaPropTypes).Text
                });
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Text,
                    propType: (0, (0, parcelRequire("8OILN")).GenericPropTypes).NoProp
                });
            case 'textFields':
                if ((0, (0, parcelRequire("4R6GH")).fg)('nin-text-fields-new-text-search-field')) return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Text,
                    propType: (0, (0, parcelRequire("8OILN")).GenericPropTypes).NoProp
                });
                return $02d8cf8959551cab$export$fb7c01070886ad20({
                    searchTemplate: searchTemplate,
                    fieldType: fieldType
                });
            case 'summary':
            case 'description':
            case 'environment':
            case 'com.atlassian.jira.plugin.system.customfieldtypes:textsearcher':
            case 'comment':
            case 'com.pyxis.greenhopper.jira:gh-epic-label-searcher':
            case 'jira.polaris:textsearcher':
            case 'com.atlassian.jira.ext.charting:textsearcher':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).TextArea,
                    propType: (0, (0, parcelRequire("8OILN")).TextAreaPropTypes).Text
                });
            case 'com.atlassian.jira.plugin.system.customfieldtypes:exacttextsearcher':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).TextArea,
                    propType: (0, (0, parcelRequire("8OILN")).TextAreaPropTypes).ExactText
                });
            case 'created':
            case 'updated':
            case 'resolutiondate':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).DateTime,
                    propType: (0, (0, parcelRequire("8OILN")).GenericPropTypes).NoProp
                });
            case 'com.atlassian.jira.plugin.system.customfieldtypes:daterange':
            case 'statuscategorychangedate':
            case 'com.atlassian.jpo:jpo-custom-field-baseline-start-searcher':
            case 'com.atlassian.jpo:jpo-custom-field-baseline-end-searcher':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).DateTime,
                    propType: (0, (0, parcelRequire("8OILN")).GenericPropTypes).NoProp
                });
            case 'com.atlassian.jira.toolkit:LastCommentDateSearcher':
            case 'com.atlassian.jira.ext.charting:firstreponsedatesearcher':
            case 'com.atlassian.servicedesk:sd-request-feedback-date-searcher':
            case 'com.atlassian.jira.plugin.system.customfieldtypes:datetimerange':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).DateTimeRange,
                    propType: (0, (0, parcelRequire("8OILN")).GenericPropTypes).NoProp
                });
            case 'duedate':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).DueDate,
                    propType: (0, (0, parcelRequire("8OILN")).GenericPropTypes).NoProp
                });
            case 'labels':
            case 'priority':
            case 'resolution':
            case 'status':
            case 'statusCategory':
            case 'com.atlassian.jira.plugin.system.customfieldtypes:labelsearcher':
            case 'com.atlassian.jira.plugin.system.customfieldtypes:multiselectsearcher':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Picker,
                    propType: (0, (0, parcelRequire("8OILN")).PickerPropTypes).Common
                });
            case 'components':
            case 'parent':
            case 'com.pyxis.greenhopper.jira:gh-epic-link-searcher':
            case 'ticketCategory':
            case 'com.pyxis.greenhopper.jira:gh-epic-status-searcher':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Picker,
                    propType: (0, (0, parcelRequire("8OILN")).PickerPropTypes).CommonWithEmpty
                });
            case 'versions':
            case 'fixVersions':
            case 'com.atlassian.jira.plugin.system.customfieldtypes:versionsearcher':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Picker,
                    propType: (0, (0, parcelRequire("8OILN")).PickerPropTypes).Version
                });
            case 'assignee':
            case 'creator':
            case 'reporter':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Picker,
                    propType: (0, (0, parcelRequire("8OILN")).PickerPropTypes).User
                });
            case 'com.atlassian.jira.plugin.system.customfieldtypes:userpickergroupsearcher':
            case 'com.atlassian.jira.plugin.system.customfieldtypes:next-gen-people-searcher':
            case 'com.atlassian.jira.toolkit:participantsearcher':
            case 'com.atlassian.jira.toolkit:lastparticipantsearcher':
            case 'com.atlassian.servicedesk:sd-request-participants-searcher':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Picker,
                    propType: (0, (0, parcelRequire("8OILN")).PickerPropTypes).User
                });
            case 'issuetype':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Picker,
                    propType: (0, (0, parcelRequire("8OILN")).PickerPropTypes).IssueType
                });
            case 'project':
            case 'com.atlassian.jira.plugin.system.customfieldtypes:projectsearcher':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Picker,
                    propType: (0, (0, parcelRequire("8OILN")).PickerPropTypes).Project
                });
            case 'com.pyxis.greenhopper.jira:gh-sprint-searcher':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Picker,
                    propType: (0, (0, parcelRequire("8OILN")).PickerPropTypes).Sprint
                });
            case 'com.atlassian.jira.plugin.system.customfieldtypes:grouppickersearcher':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Picker,
                    propType: (0, (0, parcelRequire("8OILN")).PickerPropTypes).Group
                });
            case 0, (0, parcelRequire("5Dsab")).CASCADE_SELECT_FIELD_SEARCH_TEMPLATE:
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).CascadeSelect,
                    propType: (0, (0, parcelRequire("8OILN")).GenericPropTypes).NoProp
                });
            case 'com.atlassian.jira.plugin.system.customfieldtypes:exactnumber':
            case 'com.pyxis.greenhopper.jira:jsw-story-points-searcher':
            case 'jira.polaris:exact-number-searcher':
            case 'com.atlassian.servicedesk:sd-request-feedback-searcher':
            case 'com.atlassian.jira.toolkit:commentcountsearcher':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).TextArea,
                    propType: (0, (0, parcelRequire("8OILN")).TextAreaPropTypes).Number
                });
            case 'com.atlassian.jira.toolkit:lastcommentersearcher':
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).BooleanType,
                    propType: (0, (0, parcelRequire("8OILN")).GenericPropTypes).NoProp
                });
            case 'workratio':
            case 0, (0, parcelRequire("5Dsab")).NUMBER_RANGE_FIELD_SEARCH_TEMPLATE:
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).NumberRange,
                    propType: (0, (0, parcelRequire("8OILN")).GenericPropTypes).NoProp
                });
            case 0, (0, parcelRequire("5Dsab")).CMDB_FIELD_SEARCH_TEMPLATE:
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).TextArea,
                    propType: (0, (0, parcelRequire("8OILN")).TextAreaPropTypes).Aql
                });
            case 0, (0, parcelRequire("5Dsab")).JSM_REQUEST_TYPE_SEARCH_TEMPLATE:
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Picker,
                    propType: (0, (0, parcelRequire("8OILN")).PickerPropTypes).CommonWithEmpty
                });
            case 0, (0, parcelRequire("5Dsab")).JSM_ORGANIZATIONS_SEARCH_TEMPLATE:
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Picker,
                    propType: (0, (0, parcelRequire("8OILN")).PickerPropTypes).CommonWithEmpty
                });
            case 0, (0, parcelRequire("5Dsab")).JSM_WORK_CATEGORY_SEARCH_TEMPLATE:
                return $02d8cf8959551cab$var$getPickerData({
                    ...commonAttributes,
                    pickerType: (0, (0, parcelRequire("8OILN")).PickerTypes).Picker,
                    propType: (0, (0, parcelRequire("8OILN")).PickerPropTypes).CommonWithEmpty
                });
            default:
                return $02d8cf8959551cab$export$fb7c01070886ad20({
                    searchTemplate: searchTemplate,
                    fieldType: fieldType
                });
        }
    };
});
parcelRegister("8OqfS", function(module, exports) {
    $parcel$export(module.exports, "getAllowedOperators", ()=>$4bd50ae926c39c04$export$e56c61b51c1beb84);
    var $iEIQF;
    var $bzbto;
    var $5Dsab;
    var $8OILN;
    var $1dTaH;
    const $4bd50ae926c39c04$var$SIMPLIFIED_PICKER_ALLOWED_OPERATORS = [
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS)),
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_IN))
    ];
    const $4bd50ae926c39c04$var$PICKER_ALLOWED_OPERATORS = [
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS)),
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS)),
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_IN)),
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN)),
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_IS)),
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT))
    ];
    const $4bd50ae926c39c04$var$TEXT_PICKER_ALLOWED_OPERATORS = [
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_LIKE))
    ];
    const $4bd50ae926c39c04$export$362ce0c36f9a70b6 = (propType)=>{
        if (!(0, (0, parcelRequire("1dTaH")).isTextAreaPropType)(propType)) throw new Error(`Unsupported TextAreaPropType: ${propType}`);
        switch(propType){
            case (0, (0, parcelRequire("8OILN")).TextAreaPropTypes).Number:
            case (0, (0, parcelRequire("8OILN")).TextAreaPropTypes).ExactText:
                return [
                    (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS))
                ];
            case (0, (0, parcelRequire("8OILN")).TextAreaPropTypes).Text:
                return [
                    (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_LIKE))
                ];
            case (0, (0, parcelRequire("8OILN")).TextAreaPropTypes).Aql:
                return [
                    (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_IN))
                ];
            default:
                throw new Error(`Unsupported TextAreaPropType: ${propType}`);
        }
    };
    const $4bd50ae926c39c04$var$DATE_PICKER_ALLOWED_OPERATORS = [
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_LT_EQUALS)),
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_GT_EQUALS))
    ];
    const $4bd50ae926c39c04$var$CASCADE_SELECT_PICKER_ALLOWED_OPERATORS = [
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_IN)),
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS))
    ];
    const $4bd50ae926c39c04$var$BOOLEAN_PICKER_ALLOWED_OPERATORS = [
        (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS))
    ];
    const $4bd50ae926c39c04$var$getPickerOperators = (fieldOperators)=>$4bd50ae926c39c04$var$PICKER_ALLOWED_OPERATORS.filter((allowedOperator)=>fieldOperators.findIndex((fieldOperator)=>allowedOperator.value === fieldOperator) >= 0);
    const $4bd50ae926c39c04$export$e56c61b51c1beb84 = ({ pickerType: pickerType, fieldOperators: fieldOperators = [], propType: propType = (0, (0, parcelRequire("8OILN")).GenericPropTypes).NoProp, simplifiedOperators: simplifiedOperators })=>{
        switch(pickerType){
            case (0, (0, parcelRequire("8OILN")).PickerTypes).Text:
                return $4bd50ae926c39c04$var$TEXT_PICKER_ALLOWED_OPERATORS;
            case (0, (0, parcelRequire("8OILN")).PickerTypes).TextArea:
                return $4bd50ae926c39c04$export$362ce0c36f9a70b6(propType);
            case (0, (0, parcelRequire("8OILN")).PickerTypes).DateTime:
            case (0, (0, parcelRequire("8OILN")).PickerTypes).DueDate:
            case (0, (0, parcelRequire("8OILN")).PickerTypes).DateTimeRange:
                return $4bd50ae926c39c04$var$DATE_PICKER_ALLOWED_OPERATORS;
            case (0, (0, parcelRequire("8OILN")).PickerTypes).Picker:
                return !simplifiedOperators ? $4bd50ae926c39c04$var$getPickerOperators(fieldOperators) : $4bd50ae926c39c04$var$SIMPLIFIED_PICKER_ALLOWED_OPERATORS;
            case (0, (0, parcelRequire("8OILN")).PickerTypes).CascadeSelect:
                return $4bd50ae926c39c04$var$CASCADE_SELECT_PICKER_ALLOWED_OPERATORS;
            case (0, (0, parcelRequire("8OILN")).PickerTypes).NumberRange:
                return (0, (0, parcelRequire("5Dsab")).NUMBER_RANGE_PICKER_ALLOWED_OPERATORS).map((op)=>(0, (0, parcelRequire("iEIQF")).default).operator(op));
            case (0, (0, parcelRequire("8OILN")).PickerTypes).BooleanType:
                return $4bd50ae926c39c04$var$BOOLEAN_PICKER_ALLOWED_OPERATORS;
            default:
                return [];
        }
    };
});
parcelRegister("j200s", function(module, exports) {
    $parcel$export(module.exports, "UnsupportedRefinementError", ()=>$53b8b25bbeadef10$export$251a1c8599975384);
    class $53b8b25bbeadef10$export$251a1c8599975384 extends Error {
    }
});
parcelRegister("4uLp9", function(module, exports) {
    $parcel$export(module.exports, "getUnsupportedOperators", ()=>$53eaf9d83eedc533$export$4b9252b112620e15);
    var $bzbto;
    const $53eaf9d83eedc533$var$UNSUPPORTED_OPERATORS = [
        ...(0, (0, parcelRequire("bzbto")).CHANGED_OPERATORS),
        ...(0, (0, parcelRequire("bzbto")).WAS_OPERATORS),
        ...(0, (0, parcelRequire("bzbto")).WAS_IN_OPERATORS)
    ];
    const $53eaf9d83eedc533$export$4b9252b112620e15 = ()=>$53eaf9d83eedc533$var$UNSUPPORTED_OPERATORS;
});
parcelRegister("89g1C", function(module, exports) {
    $parcel$export(module.exports, "mapOperators", ()=>$c5bd6006021452d1$export$ad17522432f44705);
    var $bzbto;
    const $c5bd6006021452d1$export$ad17522432f44705 = (jiraJqlOpeartor)=>{
        switch(jiraJqlOpeartor){
            case 'EQUALS':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS;
            case 'NOT_EQUALS':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_NOT_EQUALS;
            case 'IS':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_IS;
            case 'IN':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_IN;
            case 'IS_NOT':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_IS_NOT;
            case 'NOT_IN':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_NOT_IN;
            case 'CONTAINS':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_LIKE;
            case 'DOES_NOT_CONTAIN':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_NOT_LIKE;
            case 'WAS_NOT_IN':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_WAS_NOT_IN;
            case 'WAS_NOT':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_WAS_NOT;
            case 'WAS_IN':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_WAS_IN;
            case 'WAS':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_WAS;
            case 'CHANGED':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_CHANGED;
            case 'GREATER_THAN':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_GT;
            case 'GREATER_THAN_OR_EQUAL':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_GT_EQUALS;
            case 'LESS_THAN':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_LT;
            case 'LESS_THAN_OR_EQUAL':
                return 0, (0, parcelRequire("bzbto")).OPERATOR_LT_EQUALS;
            default:
                throw new Error(`Operator ${jiraJqlOpeartor} not supported`);
        }
    };
});
parcelRegister("8vNru", function(module, exports) {
    $parcel$export(module.exports, "JQL_BUILDER_PERFORMANCE_MARKS", ()=>$491ce87882605bf7$export$5fd6d8ece357700d);
    const $491ce87882605bf7$var$JQL_BUILDER_START = 'JQL_BUILDER_START';
    const $491ce87882605bf7$var$JQL_BUILDER_END = 'JQL_BUILDER_END';
    const $491ce87882605bf7$var$JQL_BUILDER_HYDRATE_START = 'JQL_BUILDER_HYDRATE_START';
    const $491ce87882605bf7$var$JQL_BUILDER_HYDRATE_END = 'JQL_BUILDER_HYDRATE_END';
    const $491ce87882605bf7$var$JQL_BUILDER_BASIC_START = 'JQL_BUILDER_BASIC_START';
    const $491ce87882605bf7$var$JQL_BUILDER_BASIC_END = 'JQL_BUILDER_BASIC_END';
    const $491ce87882605bf7$var$JQL_BUILDER_BASIC_JS_START = 'JQL_BUILDER_BASIC_JS_START';
    const $491ce87882605bf7$var$JQL_BUILDER_BASIC_JS_END = 'JQL_BUILDER_BASIC_JS_END';
    const $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_START = 'JQL_BUILDER_ADVANCED_START';
    const $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_END = 'JQL_BUILDER_ADVANCED_END';
    const $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_JS_START = 'JQL_BUILDER_ADVANCED_JS_START';
    const $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_JS_END = 'JQL_BUILDER_ADVANCED_JS_END';
    const $491ce87882605bf7$export$5fd6d8ece357700d = {
        JQL_BUILDER_START: $491ce87882605bf7$var$JQL_BUILDER_START,
        JQL_BUILDER_END: $491ce87882605bf7$var$JQL_BUILDER_END,
        JQL_BUILDER_HYDRATE_START: $491ce87882605bf7$var$JQL_BUILDER_HYDRATE_START,
        JQL_BUILDER_HYDRATE_END: $491ce87882605bf7$var$JQL_BUILDER_HYDRATE_END,
        JQL_BUILDER_BASIC_JS_START: $491ce87882605bf7$var$JQL_BUILDER_BASIC_JS_START,
        JQL_BUILDER_BASIC_JS_END: $491ce87882605bf7$var$JQL_BUILDER_BASIC_JS_END,
        JQL_BUILDER_BASIC_START: $491ce87882605bf7$var$JQL_BUILDER_BASIC_START,
        JQL_BUILDER_BASIC_END: $491ce87882605bf7$var$JQL_BUILDER_BASIC_END,
        JQL_BUILDER_ADVANCED_JS_START: $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_JS_START,
        JQL_BUILDER_ADVANCED_JS_END: $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_JS_END,
        JQL_BUILDER_ADVANCED_START: $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_START,
        JQL_BUILDER_ADVANCED_END: $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_END
    };
});
parcelRegister("k3Vq9", function(module, exports) {
    $parcel$export(module.exports, "useHydrationQuery", ()=>$e0d752ab8ed72d46$export$9992ca387dbb4d57);
    $parcel$export(module.exports, "HydrationQueryProvider", ()=>$e0d752ab8ed72d46$export$bb83aa31c9e87b59);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $8Uumt = parcelRequire("8Uumt");
    var $jcw0u;
    var $90yGq;
    var $koeKL;
    const $e0d752ab8ed72d46$var$HydrationQueryContext = (0, $5uXOq.createContext)({
        hydrationQueryIsFetching: false,
        hydrationQueryContextJql: ''
    });
    $e0d752ab8ed72d46$var$HydrationQueryContext.displayName = 'HydrationQueryContext';
    const $e0d752ab8ed72d46$export$9992ca387dbb4d57 = ()=>(0, $5uXOq.useContext)($e0d752ab8ed72d46$var$HydrationQueryContext);
    const $e0d752ab8ed72d46$export$bb83aa31c9e87b59 = ({ refetch: refetch, query: query, contextJql: contextJql, children: children })=>{
        const [hydrationQueryIsFetching, setHydrationQueryIsFetching] = (0, $5uXOq.useState)(false);
        const [hydrationQueryContextJql, setHydrationQueryContextJql] = (0, $5uXOq.useState)(contextJql);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const atlassianAccountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const inFlightRequest = (0, $5uXOq.useRef)();
        const inFlightContextJql = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, ($parcel$interopDefault($ajpes)))(contextJql, hydrationQueryContextJql) && !(0, ($parcel$interopDefault($ajpes)))(contextJql, inFlightContextJql.current)) {
                inFlightRequest.current?.unsubscribe();
                inFlightContextJql.current = contextJql;
                const variables = {
                    filterAri: '',
                    includeFilter: false,
                    jql: contextJql,
                    accountId: atlassianAccountId ?? '',
                    includeJira: true,
                    includeUser: true,
                    cloudId: cloudId,
                    isFilter: false
                };
                setHydrationQueryIsFetching(true);
                inFlightRequest.current = (0, $8Uumt.fetchQuery)(environment, query, variables, {
                    fetchPolicy: 'store-or-network',
                    networkCacheConfig: {
                        metadata: {
                            META_SLOW_ENDPOINT: true
                        }
                    }
                }).subscribe({
                    complete: ()=>{
                        refetch(variables, {
                            fetchPolicy: 'store-only',
                            onComplete: ()=>{
                                setHydrationQueryIsFetching(false);
                                setHydrationQueryContextJql(contextJql);
                                inFlightContextJql.current = undefined;
                            }
                        });
                    },
                    error: (error)=>{
                        setHydrationQueryIsFetching(false);
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                id: 'hydrateJqlBuilderQuery',
                                packageName: 'jiraJqlBuilder',
                                teamName: 'empanada'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                    }
                });
            }
        }, [
            atlassianAccountId,
            cloudId,
            contextJql,
            environment,
            hydrationQueryContextJql,
            query,
            refetch,
            setHydrationQueryIsFetching
        ]);
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                hydrationQueryIsFetching: hydrationQueryIsFetching,
                hydrationQueryContextJql: hydrationQueryContextJql
            }), [
            hydrationQueryIsFetching,
            hydrationQueryContextJql
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e0d752ab8ed72d46$var$HydrationQueryContext.Provider, {
            value: contextValue
        }, children);
    };
});
parcelRegister("e6DTX", function(module, exports) {
    $parcel$export(module.exports, "useSearchModeMutation", ()=>$2f4765bfe1d2c101$export$f4f7ced39b30a5ad);
    var $RsPlF;
    var $1MwyQ;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jcw0u;
    var $koeKL;
    var $cZpsT;
    var $032ey;
    var $atxn1;
    const $2f4765bfe1d2c101$var$SEARCH_MODE_KEY_IN_RELAY_STORE = 'jqlBuilderSearchMode';
    const $2f4765bfe1d2c101$var$relayStoreUpdater = (store, userPreferencesData, searchMode)=>{
        if (typeof userPreferencesData?.__id === 'string') {
            const record = store.get(userPreferencesData.__id);
            record?.setValue(searchMode, $2f4765bfe1d2c101$var$SEARCH_MODE_KEY_IN_RELAY_STORE);
        }
    };
    const $2f4765bfe1d2c101$export$f4f7ced39b30a5ad = (userPreferences)=>{
        const userPreferencesData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("1MwyQ")).default), userPreferences || null);
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        const [commitMutation] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("RsPlF")).default));
        return (0, $5uXOq.useCallback)((mode)=>{
            if (!isAnonymous) {
                const serverSearchMode = (0, (0, parcelRequire("atxn1")).toServerSearchMode)(mode);
                commitMutation({
                    variables: {
                        cloudId: cloudId,
                        searchMode: (0, (0, parcelRequire("atxn1")).toServerSearchMode)(mode)
                    },
                    onError: (error)=>{
                        (0, (0, parcelRequire("jcw0u")).default)({
                            sendToPrivacyUnsafeSplunk: true,
                            error: error,
                            meta: {
                                id: 'mainSelectedJqlBuilderModeMutation',
                                packageName: (0, (0, parcelRequire("032ey")).PACKAGE_NAME),
                                teamName: (0, (0, parcelRequire("032ey")).TEAM_NAME)
                            }
                        });
                        (0, $8Uumt.commitLocalUpdate)(environment, (store)=>$2f4765bfe1d2c101$var$relayStoreUpdater(store, userPreferencesData, serverSearchMode));
                    },
                    updater: (store)=>$2f4765bfe1d2c101$var$relayStoreUpdater(store, userPreferencesData, serverSearchMode)
                });
            }
        }, [
            cloudId,
            commitMutation,
            environment,
            isAnonymous,
            userPreferencesData
        ]);
    };
});
parcelRegister("RsPlF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d1e5ceeb3c9b59e$export$2e2bcd8739ae039);
    const $4d1e5ceeb3c9b59e$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "searchMode"
            }
        ], v1 = [
            {
                "concreteType": "JiraMutation",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraUserPreferencesMutation",
                        "kind": "LinkedField",
                        "name": "userPreferences",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "searchMode",
                                        "variableName": "searchMode"
                                    }
                                ],
                                "concreteType": "JiraJQLBuilderSearchModeMutationPayload",
                                "kind": "LinkedField",
                                "name": "setJQLBuilderSearchMode",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "success"
                                    },
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "message"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "userSearchMode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "searchModeJqlBuilder_updateJQLBuilderSearchModeMutation",
                "selections": v1,
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "searchModeJqlBuilder_updateJQLBuilderSearchModeMutation",
                "selections": v1
            },
            "params": {
                "id": "ea28f854d9d34cb357f7b0a2d32ddcfaabb301d65019ccde74b53cf76b1aeb39",
                "metadata": {},
                "name": "searchModeJqlBuilder_updateJQLBuilderSearchModeMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $4d1e5ceeb3c9b59e$var$node.hash = "92ba3afb837dca41d4ee89012d43ffd1";
    var $4d1e5ceeb3c9b59e$export$2e2bcd8739ae039 = $4d1e5ceeb3c9b59e$var$node;
});
parcelRegister("1MwyQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5e8dfe38cbeb25f$export$2e2bcd8739ae039);
    const $c5e8dfe38cbeb25f$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchMode_useSearchMode_JQLBuilder",
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraUserPreferences"
    };
    $c5e8dfe38cbeb25f$var$node.hash = "b610d5310493b4f35efc509255a102c4";
    var $c5e8dfe38cbeb25f$export$2e2bcd8739ae039 = $c5e8dfe38cbeb25f$var$node;
});
parcelRegister("2G1VO", function(module, exports) {
    $parcel$export(module.exports, "JQLBuilderFallback", ()=>$9e8a9ae0035ed442$export$61e39bbfd9e09552);
    var $5uXOq = parcelRequire("5uXOq");
    var $hwGLa;
    var $9TK8T;
    var $4R6GH;
    var $imju0;
    var $jDMe3;
    var $6H2U3;
    var $3HwlS;
    var $032ey;
    var $3fufq;
    var $kdzZz;
    var $8xRQz;
    var $jX4vm;
    var $g9ghO;
    const $9e8a9ae0035ed442$export$61e39bbfd9e09552 = ({ selectedSearchMode: selectedSearchMode, searchModes: searchModes, query: query, onLoad: onLoad, isSearchModeToggleEnabled: isSearchModeToggleEnabled, renderExtraControls: renderExtraControls, beforeControls: beforeControls, excludedFields: excludedFields, components: components, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchModeSwitcherLocation: searchModeSwitcherLocation = (0, (0, parcelRequire("032ey")).SEARCH_MODE_SWITCHER_LEFT_LOCATION), showOrderByPicker: showOrderByPicker })=>{
        const onJqlBuilderBasicLoad = (0, $5uXOq.useCallback)(()=>{
            onLoad && onLoad((0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC));
        }, [
            onLoad
        ]);
        const searchModeCandidate = (0, $5uXOq.useMemo)(()=>{
            if (selectedSearchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED)) return 0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED;
            return (0, (0, parcelRequire("6H2U3")).isQueryTooComplex)({
                jql: query,
                excludedFields: excludedFields,
                shouldValidateOperators: false,
                hideTextSearchInput: hideTextSearchInput
            }) ? (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED) : (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC);
        }, [
            excludedFields,
            hideTextSearchInput,
            query,
            selectedSearchMode
        ]);
        const searchMode = (0, $5uXOq.useMemo)(()=>{
            let resolvedSearchMode = searchModeCandidate;
            if (!searchModes?.length) resolvedSearchMode = searchModeCandidate;
            else resolvedSearchMode = searchModes.includes(searchModeCandidate) ? searchModeCandidate : searchModes[0];
            if (resolvedSearchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED)) (0, (0, parcelRequire("9TK8T")).preloadJQLEditor)();
            else (0, (0, parcelRequire("imju0")).preloadJqlBuilderBasic)();
            return resolvedSearchMode;
        }, [
            searchModes,
            searchModeCandidate
        ]);
        (0, $5uXOq.useEffect)(()=>{
            searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED) && onLoad && onLoad((0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED));
        }, [
            onLoad,
            searchMode
        ]);
        const jqlBuilderFallbackComponent = searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX4vm")).AdvancedEditorWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hwGLa")).JQLEditorReadOnly), {
            isCompact: true,
            isSearch: true,
            query: query
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDMe3")).JQLBuilderBasicFallback), {
            query: query,
            excludedFields: excludedFields,
            onLoad: onJqlBuilderBasicLoad,
            shouldUseListMarkup: true,
            irremovableFields: irremovableFields,
            hideTextSearchInput: hideTextSearchInput,
            showOrderByPicker: showOrderByPicker
        });
        const { SearchModeSwitcher: SearchModeSwitcher = (0, (0, parcelRequire("3fufq")).SearchModeSwitcher) } = components ?? {};
        const BeforeJqlBuilderWrapper = searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC) ? (0, (0, parcelRequire("jX4vm")).BeforeJqlBuilderListItemContainer) : (0, (0, parcelRequire("jX4vm")).BeforeJqlBuilderContainer);
        const isSearchModeSwitcherOnLeft = searchModeSwitcherLocation === (0, (0, parcelRequire("032ey")).SEARCH_MODE_SWITCHER_LEFT_LOCATION) && (0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
        const searchModeSwitcherComponent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8xRQz")).SearchModeSwitcherContainer), {
            testId: "jql-builder.ui.jql-builder-fallback.toggle-container",
            isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(SearchModeSwitcher, {
            searchMode: searchMode,
            isBasicModeDisabled: false,
            onUpdateSearchMode: ()=>{}
        }));
        const editorContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, beforeControls && (0, ($parcel$interopDefault($5uXOq))).createElement(BeforeJqlBuilderWrapper, null, beforeControls), isSearchModeToggleEnabled && isSearchModeSwitcherOnLeft && (0, ($parcel$interopDefault($5uXOq))).createElement(BeforeJqlBuilderWrapper, null, searchModeSwitcherComponent), jqlBuilderFallbackComponent, renderExtraControls && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g9ghO")).default), {
            searchMode: searchMode,
            renderExtraControls: renderExtraControls,
            shouldUseListMarkup: searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC)
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX4vm")).Container), {
            "data-testid": "jql-builder",
            "data-vc": `jql-builder-fallback${false ? '-ssr' : ''}`,
            ...false && (0, (0, parcelRequire("4R6GH")).fg)('add_ssr_placeholder_replacements_to_nin_and_nav') && {
                'data-ssr-placeholder': 'jql-builder-fallback-placeholder'
            },
            ...!false && (0, (0, parcelRequire("4R6GH")).fg)('add_ssr_placeholder_replacements_to_nin_and_nav') && {
                'data-ssr-placeholder-replace': 'jql-builder-fallback-placeholder'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kdzZz")).DefaultJqlBuilderContainer), {
            showAdvancedEditor: searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED)
        }, searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX4vm")).BasicEditorListContainer), {
            "data-testid": "jql-builder.ui.jql-builder-fallback.basic-editor-list-container"
        }, editorContent) : editorContent), isSearchModeToggleEnabled && !isSearchModeSwitcherOnLeft && searchModeSwitcherComponent);
    };
});
parcelRegister("hwGLa", function(module, exports) {
    $parcel$export(module.exports, "JQLEditorReadOnly", ()=>$6fa24fc74eb1cbcf$export$96157d0351f40cdc);
    $parcel$export(module.exports, "default", ()=>$6fa24fc74eb1cbcf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $dC5iT;
    var $7adc8;
    var $d4UB4;
    var $4eVtJ;
    var $gbYDd;
    const $6fa24fc74eb1cbcf$var$JQLEditorLayout = (props)=>{
        const { defaultMaxRows: defaultMaxRows, expandedRows: expandedRows, isSearch: isSearch, isCompact: isCompact } = (0, (0, parcelRequire("7adc8")).useEditorThemeContext)();
        const { editorViewHasFocus: editorViewHasFocus, EditorControlsContent: EditorControlsContent, EditorFooterContent: EditorFooterContent, editorViewIsInvalid: editorViewIsInvalid, lineNumbersVisible: lineNumbersVisible, mainId: mainId, onEditorMainRef: onEditorMainRef, onEditorViewContainerRef: onEditorViewContainerRef, onEditorViewContainerScroll: onEditorViewContainerScroll, onEditorViewRef: onEditorViewRef, onEditorViewBlur: onEditorViewBlur, onEditorViewFocus: onEditorViewFocus, onEditorViewTransitionEnd: onEditorViewTransitionEnd } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gbYDd")).EditorMain), {
            id: mainId,
            ref: onEditorMainRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gbYDd")).EditorViewContainer), {
            editorViewHasFocus: editorViewHasFocus,
            editorViewIsInvalid: editorViewIsInvalid,
            ref: onEditorViewContainerRef,
            onScroll: onEditorViewContainerScroll
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gbYDd")).LineNumberToolbar), {
            lineNumbersVisible: lineNumbersVisible
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gbYDd")).EditorView), {
            defaultMaxRows: defaultMaxRows,
            expandedRows: expandedRows,
            isCompact: isCompact,
            lineNumbersVisible: lineNumbersVisible,
            ref: onEditorViewRef,
            onBlur: onEditorViewBlur,
            onFocus: onEditorViewFocus,
            onTransitionEnd: onEditorViewTransitionEnd
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gbYDd")).EditorControls), {
            isSearch: isSearch,
            isCompact: isCompact,
            isVisualRefresh: (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')
        }, EditorControlsContent)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gbYDd")).EditorFooter), null, EditorFooterContent));
    };
    const $6fa24fc74eb1cbcf$var$JQLEditorReadOnlyWithoutTheme = ({ query: query })=>{
        const { defaultMaxRows: defaultMaxRows, expandedRows: expandedRows, isSearch: isSearch, isCompact: isCompact } = (0, (0, parcelRequire("7adc8")).useEditorThemeContext)();
        const blocks = (0, (0, parcelRequire("d4UB4")).splitTextByNewLine)(query);
        const lineNumbersVisible = blocks.length > 1;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gbYDd")).EditorMain), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gbYDd")).ReadOnlyEditorViewContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gbYDd")).LineNumberToolbar), {
            lineNumbersVisible: lineNumbersVisible
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gbYDd")).ReadOnlyEditorView), {
            "data-testid": "jql-editor-read-only",
            role: "combobox",
            "aria-readonly": true,
            defaultMaxRows: defaultMaxRows,
            expandedRows: expandedRows,
            lineNumbersVisible: lineNumbersVisible,
            isCompact: isCompact,
            "aria-expanded": false,
            "aria-controls": "dummy-jql-editor-auto-complete-id",
            "aria-label": "JQL query"
        }, blocks.map((block, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                as: "p",
                key: index
            }, block))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gbYDd")).EditorControls), {
            isSearch: isSearch,
            isCompact: isCompact
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4eVtJ")).ReadOnlyControlsContent), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gbYDd")).EditorFooter), null));
    };
    const $6fa24fc74eb1cbcf$export$96157d0351f40cdc = ({ isSearch: isSearch, isCompact: isCompact, ...props })=>{
        const editorTheme = (0, (0, parcelRequire("7adc8")).useEditorTheme)({
            isSearch: isSearch,
            isCompact: isCompact
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7adc8")).EditorThemeContext).Provider, {
            value: editorTheme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6fa24fc74eb1cbcf$var$JQLEditorReadOnlyWithoutTheme, props));
    };
    var $6fa24fc74eb1cbcf$export$2e2bcd8739ae039 = $6fa24fc74eb1cbcf$var$JQLEditorLayout;
});
parcelRegister("7adc8", function(module, exports) {
    $parcel$export(module.exports, "EditorThemeContext", ()=>$9a083fc7d5baaf48$export$fc25b324c910bbf4);
    $parcel$export(module.exports, "useEditorTheme", ()=>$9a083fc7d5baaf48$export$c119185e316114b3);
    $parcel$export(module.exports, "useEditorThemeContext", ()=>$9a083fc7d5baaf48$export$cf804716df5ed454);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    const $9a083fc7d5baaf48$var$defaultMaxRows = 3;
    const $9a083fc7d5baaf48$var$expandedRows = 15;
    const $9a083fc7d5baaf48$var$defaultEditorTheme = {
        defaultMaxRows: $9a083fc7d5baaf48$var$defaultMaxRows,
        expanded: false,
        expandedRows: $9a083fc7d5baaf48$var$expandedRows,
        toggleExpanded: (0, ($parcel$interopDefault($8Rkzz))),
        isSearch: false,
        isCompact: false
    };
    const $9a083fc7d5baaf48$export$fc25b324c910bbf4 = (0, $5uXOq.createContext)($9a083fc7d5baaf48$var$defaultEditorTheme);
    const $9a083fc7d5baaf48$export$c119185e316114b3 = ({ isSearch: isSearch = false, isCompact: isCompact = false })=>{
        const [expanded, setExpanded] = (0, $5uXOq.useState)(false);
        const toggleExpanded = (0, $5uXOq.useCallback)(()=>setExpanded((prevState)=>!prevState), []);
        return (0, $5uXOq.useMemo)(()=>({
                defaultMaxRows: $9a083fc7d5baaf48$var$defaultMaxRows,
                expanded: expanded,
                expandedRows: $9a083fc7d5baaf48$var$expandedRows,
                toggleExpanded: toggleExpanded,
                isSearch: isSearch,
                isCompact: isCompact
            }), [
            expanded,
            toggleExpanded,
            isSearch,
            isCompact
        ]);
    };
    const $9a083fc7d5baaf48$export$cf804716df5ed454 = ()=>(0, $5uXOq.useContext)($9a083fc7d5baaf48$export$fc25b324c910bbf4);
});
parcelRegister("d4UB4", function(module, exports) {
    $parcel$export(module.exports, "splitTextByNewLine", ()=>$6de1f87efe366391$export$ccd327fb940bd525);
    const $6de1f87efe366391$export$ccd327fb940bd525 = (text)=>text.split(/(?:\r\n?|\n)/);
});
parcelRegister("4eVtJ", function(module, exports) {
    $parcel$export(module.exports, "ReadOnlyControlsContent", ()=>$4dc01ca63b8b7941$export$26cf64f30d6cc7f3);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $7adc8;
    var $bb6KR;
    var $7yvmN;
    var $a3xRH;
    const $4dc01ca63b8b7941$export$26cf64f30d6cc7f3 = ()=>{
        const { isSearch: isSearch } = (0, (0, parcelRequire("7adc8")).useEditorThemeContext)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bb6KR")).BaseExpandToggle), {
            label: 'Editor',
            editorId: '',
            expanded: false,
            onClick: (0, ($parcel$interopDefault($8Rkzz))),
            isDisabled: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a3xRH")).BaseSyntaxHelp), {
            label: '',
            onClick: (0, ($parcel$interopDefault($8Rkzz))),
            isDisabled: true
        }), isSearch && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7yvmN")).BaseSearch), {
            label: 'Search',
            onSearch: (0, ($parcel$interopDefault($8Rkzz))),
            isDisabled: true
        }));
    };
});
parcelRegister("bb6KR", function(module, exports) {
    $parcel$export(module.exports, "BaseExpandToggle", ()=>$44d12f406f665836$export$651ea466a727285d);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $42CjB;
    var $l14Zy;
    var $8KRBa;
    var $6LXPU;
    var $2bcm3;
    var $VSDnB;
    var $7lVlV;
    const $44d12f406f665836$var$ExpandCircleIcon = ({ isDisabled: isDisabled })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("l14Zy"))))), {
            label: '',
            LEGACY_size: 'small',
            color: isDisabled ? `var(--ds-icon-disabled, ${0, $829f609a65d26a98$export$8754fc7e6d8b3000})` : `var(--ds-icon, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`,
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("6LXPU")))))
        });
    const $44d12f406f665836$var$CollapseCircleIcon = ({ isDisabled: isDisabled })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8KRBa"))))), {
            label: '',
            LEGACY_size: 'small',
            color: isDisabled ? `var(--ds-icon-disabled, ${0, $829f609a65d26a98$export$8754fc7e6d8b3000})` : `var(--ds-icon, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`,
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("2bcm3")))))
        });
    const $44d12f406f665836$export$651ea466a727285d = ({ expanded: expanded, editorId: editorId, isDisabled: isDisabled, label: label, onClick: onClick })=>{
        let Icon;
        if (expanded) Icon = $44d12f406f665836$var$CollapseCircleIcon;
        else Icon = $44d12f406f665836$var$ExpandCircleIcon;
        return (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: 'subtle',
            spacing: "compact",
            "aria-expanded": expanded,
            "aria-controls": editorId,
            label: label,
            isDisabled: isDisabled,
            onClick: onClick,
            icon: expanded ? (0, ($parcel$interopDefault((0, parcelRequire("8KRBa"))))) : (0, ($parcel$interopDefault((0, parcelRequire("l14Zy")))))
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7lVlV")).ExpandToggleContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: 'subtle',
            "aria-expanded": expanded,
            "aria-controls": editorId,
            "aria-label": label,
            isDisabled: isDisabled,
            spacing: 'none',
            onClick: onClick,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
                isDisabled: isDisabled
            })
        }));
    };
});
parcelRegister("l14Zy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f4cd903aabaa4c53$var$_react = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f4cd903aabaa4c53$var$_baseNew = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $f4cd903aabaa4c53$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f4cd903aabaa4c53$var$GrowDiagonalIcon = (props)=>$f4cd903aabaa4c53$var$_react.default.createElement($f4cd903aabaa4c53$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
        }, props));
    $f4cd903aabaa4c53$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
    var $f4cd903aabaa4c53$var$_default = module.exports.default = $f4cd903aabaa4c53$var$GrowDiagonalIcon;
});
parcelRegister("8KRBa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $65fc322a3db160cb$var$_react = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $65fc322a3db160cb$var$_baseNew = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $65fc322a3db160cb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $65fc322a3db160cb$var$ShrinkDiagonalIcon = (props)=>$65fc322a3db160cb$var$_react.default.createElement($65fc322a3db160cb$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 14.5 5.25-5.25M14.5 1.5 9.25 6.75M6.75 14V9.25H2M9.25 2v4.75H14"/>`
        }, props));
    $65fc322a3db160cb$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
    var $65fc322a3db160cb$var$_default = module.exports.default = $65fc322a3db160cb$var$ShrinkDiagonalIcon;
});
parcelRegister("6LXPU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4ee58c13163bfe09$var$_react = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4ee58c13163bfe09$var$_growDiagonal = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("l14Zy")));
    function $4ee58c13163bfe09$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4ee58c13163bfe09$var$MediaServicesActualSizeIcon = (props)=>$4ee58c13163bfe09$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
        }, props, {
            newIcon: $4ee58c13163bfe09$var$_growDiagonal.default
        }));
    $4ee58c13163bfe09$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
    var $4ee58c13163bfe09$var$_default = module.exports.default = $4ee58c13163bfe09$var$MediaServicesActualSizeIcon;
});
parcelRegister("2bcm3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1966313a87133c34$var$_react = $1966313a87133c34$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1966313a87133c34$var$_shrinkDiagonal = $1966313a87133c34$var$_interopRequireDefault((parcelRequire("8KRBa")));
    function $1966313a87133c34$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1966313a87133c34$var$MediaServicesFitToPageIcon = (props)=>$1966313a87133c34$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
        }, props, {
            newIcon: $1966313a87133c34$var$_shrinkDiagonal.default
        }));
    $1966313a87133c34$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
    var $1966313a87133c34$var$_default = module.exports.default = $1966313a87133c34$var$MediaServicesFitToPageIcon;
});
parcelRegister("7lVlV", function(module, exports) {
    $parcel$export(module.exports, "ExpandToggleContainer", ()=>$d70ed8f4f3b3c7fb$export$e6d67f4f78864edc);
    var $bWGt6 = parcelRequire("bWGt6");
    const $d70ed8f4f3b3c7fb$export$e6d67f4f78864edc = (0, $bWGt6.default)("div", {
        target: "e1cnrddf0"
    })({
        '> button': {
            borderRadius: '100%',
            margin: `${"var(--ds-space-050, 4px)"} 0`,
            '&:hover': {
                background: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`
            },
            "&:active, &[data-firefox-is-active='true']": {
                background: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`
            }
        }
    });
});
parcelRegister("7yvmN", function(module, exports) {
    $parcel$export(module.exports, "BaseSearch", ()=>$2e78b61c4b6acd63$export$c3a2772f8bfd85f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $2rqOp;
    var $42CjB;
    var $gMMNe;
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    const $2e78b61c4b6acd63$var$style = {
        overflow: 'hidden'
    };
    const $2e78b61c4b6acd63$var$iconStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.050',
        display: 'flex'
    });
    const $2e78b61c4b6acd63$var$buttonContainerStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden'
    });
    const $2e78b61c4b6acd63$export$c3a2772f8bfd85f4 = ({ isDisabled: isDisabled, isSearching: isSearching, label: label, onSearch: onSearch })=>{
        const preventRepeatClick = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Enter' && e.repeat) e.preventDefault();
        }, []);
        return (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $2e78b61c4b6acd63$var$buttonContainerStyle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            label: label,
            isDisabled: isDisabled,
            testId: "jql-editor-search",
            appearance: 'primary',
            spacing: "compact",
            onClick: onSearch,
            onKeyDown: preventRepeatClick,
            isLoading: isSearching,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("gMMNe")))))
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            "aria-label": label,
            isDisabled: isDisabled,
            testId: "jql-editor-search",
            style: $2e78b61c4b6acd63$var$style,
            appearance: 'primary',
            spacing: 'none',
            onClick: onSearch,
            onKeyDown: preventRepeatClick,
            isLoading: isSearching,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $2e78b61c4b6acd63$var$iconStyle
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gMMNe"))))), {
                color: "currentColor",
                label: '',
                LEGACY_size: 'medium',
                LEGACY_margin: "-4px"
            }))
        });
    };
});
parcelRegister("a3xRH", function(module, exports) {
    $parcel$export(module.exports, "BaseSyntaxHelp", ()=>$c5c8b48ab4cf2509$export$7267128805e130a);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $krXdA;
    var $8nk07;
    var $7QGmb;
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    var $fxabn;
    const $c5c8b48ab4cf2509$var$iconStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.025',
        display: 'inline-flex'
    });
    const $c5c8b48ab4cf2509$export$7267128805e130a = ({ describedby: describedby, isDisabled: isDisabled, label: label, onClick: onClick })=>{
        return (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("krXdA")).default), {
            "aria-describedby": describedby,
            label: label,
            isDisabled: isDisabled,
            appearance: "subtle",
            spacing: "compact",
            onClick: onClick,
            target: "blank",
            href: "https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Advanced+searching",
            icon: (iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8nk07"))))), {
                    ...iconProps,
                    color: "var(--ds-icon-subtle, #626F86)"
                })
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fxabn")).SyntaxHelpContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            "aria-describedby": describedby,
            "aria-label": label,
            isDisabled: isDisabled,
            appearance: 'subtle',
            spacing: 'none',
            target: 'blank',
            href: "https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Advanced+searching",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $c5c8b48ab4cf2509$var$iconStyle
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8nk07"))))), {
                label: '',
                color: isDisabled ? `var(--ds-icon-disabled, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-icon-inverse, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                LEGACY_size: 'small',
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("7QGmb"))))),
                LEGACY_margin: "-2px"
            })),
            onClick: onClick
        }));
    };
});
parcelRegister("7QGmb", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5b6e3ee3ed88bbe3$var$_react = $5b6e3ee3ed88bbe3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5b6e3ee3ed88bbe3$var$_questionCircle = $5b6e3ee3ed88bbe3$var$_interopRequireDefault((parcelRequire("8nk07")));
    function $5b6e3ee3ed88bbe3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5b6e3ee3ed88bbe3$var$QuestionIcon = (props)=>$5b6e3ee3ed88bbe3$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18a1 1 0 0 1 0-2 1 1 0 0 1 0 2m-2-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path d="M15.89 8.048a3.97 3.97 0 0 0-2.951-2.94A4.005 4.005 0 0 0 8 9.087l.009.008 1.878.022.112-.116A2 2 0 0 1 12 7c1.103 0 2 .897 2 2s-.897 2-2 2h.008a1 1 0 0 0-.998.987v2.014a1 1 0 1 0 2 0v-.782c0-.217.145-.399.349-.472a3.99 3.99 0 0 0 2.53-4.699"/></g></svg>`
        }, props, {
            newIcon: $5b6e3ee3ed88bbe3$var$_questionCircle.default
        }));
    $5b6e3ee3ed88bbe3$var$QuestionIcon.displayName = 'QuestionIcon';
    var $5b6e3ee3ed88bbe3$var$_default = module.exports.default = $5b6e3ee3ed88bbe3$var$QuestionIcon;
});
parcelRegister("fxabn", function(module, exports) {
    $parcel$export(module.exports, "SyntaxHelpContainer", ()=>$73b4ff731c707a83$export$4e1b8f789d662a1c);
    var $bWGt6 = parcelRequire("bWGt6");
    const $73b4ff731c707a83$export$4e1b8f789d662a1c = (0, $bWGt6.default)("div", {
        target: "e1rcevfp0"
    })({
        '> a': {
            background: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
            borderRadius: '100%',
            margin: "var(--ds-space-050, 4px)",
            '&:hover': {
                background: `var(--ds-background-neutral-bold-hovered, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
            },
            '&:focus': {
                background: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`
            },
            "&:active, &[data-firefox-is-active='true']": {
                background: `var(--ds-background-neutral-bold-pressed, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`
            },
            '&[disabled]': {
                background: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`
            }
        }
    });
});
parcelRegister("gbYDd", function(module, exports) {
    $parcel$export(module.exports, "EditorMain", ()=>$7d26a293c5ce6398$export$4a1fe064357e4803);
    $parcel$export(module.exports, "EditorFooter", ()=>$7d26a293c5ce6398$export$6b199f86fb39c56e);
    $parcel$export(module.exports, "EditorViewContainer", ()=>$7d26a293c5ce6398$export$e1a59ec983b6e626);
    $parcel$export(module.exports, "ReadOnlyEditorViewContainer", ()=>$7d26a293c5ce6398$export$92dc95fac89d1410);
    $parcel$export(module.exports, "LineNumberToolbar", ()=>$7d26a293c5ce6398$export$c7f458a6447d7077);
    $parcel$export(module.exports, "EditorView", ()=>$7d26a293c5ce6398$export$eece2fccabbb77c5);
    $parcel$export(module.exports, "ReadOnlyEditorView", ()=>$7d26a293c5ce6398$export$1eeaf339fa9196a5);
    $parcel$export(module.exports, "EditorControls", ()=>$7d26a293c5ce6398$export$3ebfd5942f1290ac);
    var $f8Sb3;
    var $k5uoT;
    var $wIAb2;
    var $bWGt6 = parcelRequire("bWGt6");
    function $7d26a293c5ce6398$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7d26a293c5ce6398$var$fadeIn = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        from: {
            opacity: 0
        },
        to: {
            opacity: 1
        }
    });
    const $7d26a293c5ce6398$var$fadeOut = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        from: {
            visibility: 'visible',
            opacity: 1
        },
        to: {
            opacity: 0
        }
    });
    const $7d26a293c5ce6398$export$4a1fe064357e4803 = (0, $bWGt6.default)("div", {
        target: "ezls2j67"
    })("font-family:", (0, (0, parcelRequire("k5uoT")).fontFamily)(), ";font-size:", (0, (0, parcelRequire("k5uoT")).fontSize)(), "px;flex-grow:1;/* These styles and animations are derived from @atlaskit/tooltip */.", (0, (0, parcelRequire("wIAb2")).TOOLTIP_CLASSNAME), "{background-color:", `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`, ";color:", `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";border-radius:var(--ds-border-radius-100, 3px);box-sizing:border-box;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);line-height:1.3;max-width:240px;padding:var(--ds-space-025, 2px) var(--ds-space-075, 6px);word-wrap:break-word;overflow-wrap:break-word;z-index:", (0, (0, parcelRequire("k5uoT")).layers).tooltip(), ";pointer-events:none;position:absolute;visibility:hidden;transform:translate(-50%, calc(-100% - var(--ds-space-200, 16px)));&.", (0, (0, parcelRequire("wIAb2")).TOOLTIP_ENTER_CLASSNAME), "{animation:", $7d26a293c5ce6398$var$fadeIn, " 350ms cubic-bezier(0.15, 1, 0.3, 1);visibility:visible;}&.", (0, (0, parcelRequire("wIAb2")).TOOLTIP_EXIT_CLASSNAME), "{animation:", $7d26a293c5ce6398$var$fadeOut, " 350ms cubic-bezier(0.15, 1, 0.3, 1);}}");
    const $7d26a293c5ce6398$export$6b199f86fb39c56e = (0, $bWGt6.default)("div", {
        target: "ezls2j66"
    })({
        name: "y524xc",
        styles: "display:flex;justify-content:space-between;min-height:20px"
    });
    const $7d26a293c5ce6398$var$rowHeight = (0, (0, parcelRequire("k5uoT")).gridSize)() * 2.75;
    const $7d26a293c5ce6398$var$getEditorInputVerticalPadding = (isCompact)=>isCompact ? 3 : 7;
    const $7d26a293c5ce6398$var$editorInputHorizontalPadding = 6;
    const $7d26a293c5ce6398$export$e1a59ec983b6e626 = (0, $bWGt6.default)("div", {
        target: "ezls2j65"
    })({
        backgroundColor: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        borderColor: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        borderRadius: "var(--ds-border-radius-100, 3px)",
        padding: "var(--ds-border-width, 1px)",
        boxSizing: 'border-box',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        display: 'flex',
        overflow: 'auto',
        transition: 'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out'
    }, (props)=>props.editorViewIsInvalid && (0, (0, parcelRequire("f8Sb3")).css)({
            borderColor: `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`}`
        }), (props)=>props.editorViewHasFocus ? (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`
        }) : (0, (0, parcelRequire("f8Sb3")).css)({
            '&:hover': {
                backgroundColor: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
            }
        }));
    const $7d26a293c5ce6398$export$92dc95fac89d1410 = (0, $bWGt6.default)($7d26a293c5ce6398$export$e1a59ec983b6e626, {
        target: "ezls2j64"
    })({
        backgroundColor: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        pointerEvents: 'none'
    });
    var $7d26a293c5ce6398$var$_ref2 = {
        name: "eivff4",
        styles: "display:none"
    };
    const $7d26a293c5ce6398$export$c7f458a6447d7077 = (0, $bWGt6.default)("div", {
        target: "ezls2j63"
    })({
        backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        flexShrink: 0,
        width: '30px',
        position: 'sticky',
        top: 0
    }, (props)=>!props.lineNumbersVisible && $7d26a293c5ce6398$var$_ref2);
    var $7d26a293c5ce6398$var$_ref = {
        name: "eivff4",
        styles: "display:none"
    };
    const $7d26a293c5ce6398$export$eece2fccabbb77c5 = (0, $bWGt6.default)("div", {
        target: "ezls2j62"
    })("counter-reset:lineNumber;flex-grow:1;transition:height 250ms cubic-bezier(0.15, 1, 0.3, 1),max-height 250ms cubic-bezier(0.15, 1, 0.3, 1);max-height:", (props)=>$7d26a293c5ce6398$var$rowHeight * props.defaultMaxRows + $7d26a293c5ce6398$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;line-height:", $7d26a293c5ce6398$var$rowHeight / (0, (0, parcelRequire("k5uoT")).fontSize)(), ";font-family:", (0, (0, parcelRequire("k5uoT")).codeFontFamily)(), ";word-break:break-word;overflow-wrap:anywhere;white-space:pre-wrap;&[data-expanded]{height:", (props)=>$7d26a293c5ce6398$var$rowHeight * props.expandedRows + $7d26a293c5ce6398$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;max-height:", (props)=>$7d26a293c5ce6398$var$rowHeight * props.expandedRows + $7d26a293c5ce6398$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;}.ProseMirror{color:", `var(--ds-text, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`, ";padding:", (props)=>$7d26a293c5ce6398$var$getEditorInputVerticalPadding(props.isCompact), "px ", $7d26a293c5ce6398$var$editorInputHorizontalPadding, "px;&:focus{outline:none;}.mark-token-keyword{color:", `var(--ds-text-accent-purple, ${(0, $829f609a65d26a98$export$c71e4279dd54a18d)})`, ";}.mark-token-field{color:", `var(--ds-text-accent-blue, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`, ";}.mark-token-operator{color:", `var(--ds-text-accent-green, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`, ";}.mark-token-error{color:", `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`, ";text-decoration:wavy underline;text-decoration-thickness:1px;text-decoration-skip-ink:none;}}p{margin:0;counter-increment:lineNumber;position:relative;&::before{content:counter(lineNumber);color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`, ";font-size:10px;line-height:", $7d26a293c5ce6398$var$rowHeight / 10, ";padding:0 var(--ds-space-100, 8px) 0 var(--ds-space-025, 2px);position:absolute;box-sizing:border-box;transform:translateX(calc(-100% - var(--ds-space-100, 8px)));max-width:30px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;", (props)=>!props.lineNumbersVisible && $7d26a293c5ce6398$var$_ref, ";}}");
    const $7d26a293c5ce6398$export$1eeaf339fa9196a5 = (0, $bWGt6.default)($7d26a293c5ce6398$export$eece2fccabbb77c5, {
        target: "ezls2j61"
    })("padding:", (props)=>$7d26a293c5ce6398$var$getEditorInputVerticalPadding(props.isCompact), "px ", $7d26a293c5ce6398$var$editorInputHorizontalPadding, "px;max-height:", (props)=>$7d26a293c5ce6398$var$rowHeight * props.defaultMaxRows, "px;>p{min-height:", $7d26a293c5ce6398$var$rowHeight, "px;}");
    const $7d26a293c5ce6398$export$3ebfd5942f1290ac = (0, $bWGt6.default)("div", {
        target: "ezls2j60"
    })((props)=>({
            alignItems: 'center',
            display: 'flex',
            flexShrink: 0,
            marginLeft: 'auto',
            marginRight: `${props.isSearch ? $7d26a293c5ce6398$var$getEditorInputVerticalPadding(props.isCompact) - 1 : $7d26a293c5ce6398$var$editorInputHorizontalPadding - 3}px`,
            lineHeight: 'normal',
            position: 'sticky',
            top: 0,
            height: `${$7d26a293c5ce6398$var$rowHeight + 2 * $7d26a293c5ce6398$var$getEditorInputVerticalPadding(props.isCompact)}px`,
            gap: props.isVisualRefresh ? "var(--ds-space-025, 2px)" : 'unset'
        }));
});
parcelRegister("wIAb2", function(module, exports) {
    $parcel$export(module.exports, "JQLValidationTooltipPluginKey", ()=>$0c380f6f438ac6d5$export$9c08c6e09c037890);
    $parcel$export(module.exports, "TOOLTIP_CLASSNAME", ()=>$0c380f6f438ac6d5$export$a6e3ebd2348b0a1);
    $parcel$export(module.exports, "TOOLTIP_ENTER_CLASSNAME", ()=>$0c380f6f438ac6d5$export$c58b4cecb88a4d51);
    $parcel$export(module.exports, "TOOLTIP_EXIT_CLASSNAME", ()=>$0c380f6f438ac6d5$export$22dac80660f4fba2);
    var $gZGBX;
    const $0c380f6f438ac6d5$export$9c08c6e09c037890 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('jql-validation-tooltip-plugin');
    const $0c380f6f438ac6d5$export$a6e3ebd2348b0a1 = 'jql-validation-tooltip';
    const $0c380f6f438ac6d5$export$c58b4cecb88a4d51 = 'jql-validation-tooltip-enter';
    const $0c380f6f438ac6d5$export$22dac80660f4fba2 = 'jql-validation-tooltip-exit';
});
parcelRegister("gZGBX", function(module, exports) {
    $parcel$export(module.exports, "Selection", ()=>$c5f36586ce432e9f$export$52baac22726c72bf);
    $parcel$export(module.exports, "SelectionRange", ()=>$c5f36586ce432e9f$export$7bd1839c3c5d5bd4);
    $parcel$export(module.exports, "TextSelection", ()=>$c5f36586ce432e9f$export$c2b25f346d19bcbb);
    $parcel$export(module.exports, "AllSelection", ()=>$c5f36586ce432e9f$export$c15d9ba76bdbcd95);
    $parcel$export(module.exports, "NodeSelection", ()=>$c5f36586ce432e9f$export$e2940151ac854c0b);
    $parcel$export(module.exports, "Transaction", ()=>$c5f36586ce432e9f$export$febc5573c75cefb0);
    $parcel$export(module.exports, "EditorState", ()=>$c5f36586ce432e9f$export$afa855cbfaff27f2);
    $parcel$export(module.exports, "Plugin", ()=>$c5f36586ce432e9f$export$901cf72dabf2112a);
    $parcel$export(module.exports, "PluginKey", ()=>$c5f36586ce432e9f$export$1692d8b0e89cecc3);
    var $kCV8T;
    var $eS2Dn;
    const $c5f36586ce432e9f$var$classesById = Object.create(null);
    class $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor($anchor, $head, ranges){
            this.$anchor = $anchor;
            this.$head = $head;
            this.ranges = ranges || [
                new $c5f36586ce432e9f$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
            ];
        }
        get anchor() {
            return this.$anchor.pos;
        }
        get head() {
            return this.$head.pos;
        }
        get from() {
            return this.$from.pos;
        }
        get to() {
            return this.$to.pos;
        }
        get $from() {
            return this.ranges[0].$from;
        }
        get $to() {
            return this.ranges[0].$to;
        }
        get empty() {
            let ranges = this.ranges;
            for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
            return true;
        }
        content() {
            return this.$from.doc.slice(this.from, this.to, true);
        }
        replace(tr, content = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            let lastNode = content.content.lastChild, lastParent = null;
            for(let i = 0; i < content.openEnd; i++){
                lastParent = lastNode;
                lastNode = lastNode.lastChild;
            }
            let mapFrom = tr.steps.length, ranges = this.ranges;
            for(let i = 0; i < ranges.length; i++){
                let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
                tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, (0, parcelRequire("kCV8T")).Slice).empty : content);
                if (i == 0) $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
            }
        }
        replaceWith(tr, node) {
            let mapFrom = tr.steps.length, ranges = this.ranges;
            for(let i = 0; i < ranges.length; i++){
                let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
                let from = mapping.map($from.pos), to = mapping.map($to.pos);
                if (i) tr.deleteRange(from, to);
                else {
                    tr.replaceRangeWith(from, to, node);
                    $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
                }
            }
        }
        static findFrom($pos, dir, textOnly = false) {
            let inner = $pos.parent.inlineContent ? new $c5f36586ce432e9f$export$c2b25f346d19bcbb($pos) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
            if (inner) return inner;
            for(let depth = $pos.depth - 1; depth >= 0; depth--){
                let found = dir < 0 ? $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
                if (found) return found;
            }
            return null;
        }
        static near($pos, bias = 1) {
            return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95($pos.node(0));
        }
        static atStart(doc) {
            return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, 0, 0, 1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        static atEnd(doc) {
            return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        static fromJSON(doc, json) {
            if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
            let cls = $c5f36586ce432e9f$var$classesById[json.type];
            if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
            return cls.fromJSON(doc, json);
        }
        static jsonID(id, selectionClass) {
            if (id in $c5f36586ce432e9f$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
            $c5f36586ce432e9f$var$classesById[id] = selectionClass;
            selectionClass.prototype.jsonID = id;
            return selectionClass;
        }
        getBookmark() {
            return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
        }
    }
    $c5f36586ce432e9f$export$52baac22726c72bf.prototype.visible = true;
    class $c5f36586ce432e9f$export$7bd1839c3c5d5bd4 {
        constructor($from, $to){
            this.$from = $from;
            this.$to = $to;
        }
    }
    let $c5f36586ce432e9f$var$warnedAboutTextSelection = false;
    function $c5f36586ce432e9f$var$checkTextSelection($pos) {
        if (!$c5f36586ce432e9f$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
            $c5f36586ce432e9f$var$warnedAboutTextSelection = true;
            console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
        }
    }
    class $c5f36586ce432e9f$export$c2b25f346d19bcbb extends $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor($anchor, $head = $anchor){
            $c5f36586ce432e9f$var$checkTextSelection($anchor);
            $c5f36586ce432e9f$var$checkTextSelection($head);
            super($anchor, $head);
        }
        get $cursor() {
            return this.$anchor.pos == this.$head.pos ? this.$head : null;
        }
        map(doc, mapping) {
            let $head = doc.resolve(mapping.map(this.head));
            if (!$head.parent.inlineContent) return $c5f36586ce432e9f$export$52baac22726c72bf.near($head);
            let $anchor = doc.resolve(mapping.map(this.anchor));
            return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
        }
        replace(tr, content = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            super.replace(tr, content);
            if (content == (0, (0, parcelRequire("kCV8T")).Slice).empty) {
                let marks = this.$from.marksAcross(this.$to);
                if (marks) tr.ensureMarks(marks);
            }
        }
        eq(other) {
            return other instanceof $c5f36586ce432e9f$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
        }
        getBookmark() {
            return new $c5f36586ce432e9f$var$TextBookmark(this.anchor, this.head);
        }
        toJSON() {
            return {
                type: "text",
                anchor: this.anchor,
                head: this.head
            };
        }
        static fromJSON(doc, json) {
            if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
            return new $c5f36586ce432e9f$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
        }
        static create(doc, anchor, head = anchor) {
            let $anchor = doc.resolve(anchor);
            return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
        }
        static between($anchor, $head, bias) {
            let dPos = $anchor.pos - $head.pos;
            if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
            if (!$head.parent.inlineContent) {
                let found = $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, -bias, true);
                if (found) $head = found.$head;
                else return $c5f36586ce432e9f$export$52baac22726c72bf.near($head, bias);
            }
            if (!$anchor.parent.inlineContent) {
                if (dPos == 0) $anchor = $head;
                else {
                    $anchor = ($c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                    if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
                }
            }
            return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor, $head);
        }
    }
    $c5f36586ce432e9f$export$52baac22726c72bf.jsonID("text", $c5f36586ce432e9f$export$c2b25f346d19bcbb);
    class $c5f36586ce432e9f$var$TextBookmark {
        constructor(anchor, head){
            this.anchor = anchor;
            this.head = head;
        }
        map(mapping) {
            return new $c5f36586ce432e9f$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
        }
        resolve(doc) {
            return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
        }
    }
    class $c5f36586ce432e9f$export$e2940151ac854c0b extends $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor($pos){
            let node = $pos.nodeAfter;
            let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
            super($pos, $end);
            this.node = node;
        }
        map(doc, mapping) {
            let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
            let $pos = doc.resolve(pos);
            if (deleted) return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
            return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
        }
        content() {
            return new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(this.node), 0, 0);
        }
        eq(other) {
            return other instanceof $c5f36586ce432e9f$export$e2940151ac854c0b && other.anchor == this.anchor;
        }
        toJSON() {
            return {
                type: "node",
                anchor: this.anchor
            };
        }
        getBookmark() {
            return new $c5f36586ce432e9f$var$NodeBookmark(this.anchor);
        }
        static fromJSON(doc, json) {
            if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
            return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(json.anchor));
        }
        static create(doc, from) {
            return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(from));
        }
        static isSelectable(node) {
            return !node.isText && node.type.spec.selectable !== false;
        }
    }
    $c5f36586ce432e9f$export$e2940151ac854c0b.prototype.visible = false;
    $c5f36586ce432e9f$export$52baac22726c72bf.jsonID("node", $c5f36586ce432e9f$export$e2940151ac854c0b);
    class $c5f36586ce432e9f$var$NodeBookmark {
        constructor(anchor){
            this.anchor = anchor;
        }
        map(mapping) {
            let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
            return deleted ? new $c5f36586ce432e9f$var$TextBookmark(pos, pos) : new $c5f36586ce432e9f$var$NodeBookmark(pos);
        }
        resolve(doc) {
            let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
            if (node && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(node)) return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
            return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
        }
    }
    class $c5f36586ce432e9f$export$c15d9ba76bdbcd95 extends $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor(doc){
            super(doc.resolve(0), doc.resolve(doc.content.size));
        }
        replace(tr, content = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            if (content == (0, (0, parcelRequire("kCV8T")).Slice).empty) {
                tr.delete(0, tr.doc.content.size);
                let sel = $c5f36586ce432e9f$export$52baac22726c72bf.atStart(tr.doc);
                if (!sel.eq(tr.selection)) tr.setSelection(sel);
            } else super.replace(tr, content);
        }
        toJSON() {
            return {
                type: "all"
            };
        }
        static fromJSON(doc) {
            return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        map(doc) {
            return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        eq(other) {
            return other instanceof $c5f36586ce432e9f$export$c15d9ba76bdbcd95;
        }
        getBookmark() {
            return $c5f36586ce432e9f$var$AllBookmark;
        }
    }
    $c5f36586ce432e9f$export$52baac22726c72bf.jsonID("all", $c5f36586ce432e9f$export$c15d9ba76bdbcd95);
    const $c5f36586ce432e9f$var$AllBookmark = {
        map () {
            return this;
        },
        resolve (doc) {
            return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
    };
    function $c5f36586ce432e9f$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
        if (node.inlineContent) return $c5f36586ce432e9f$export$c2b25f346d19bcbb.create(doc, pos);
        for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
            let child = node.child(i);
            if (!child.isAtom) {
                let inner = $c5f36586ce432e9f$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
                if (inner) return inner;
            } else if (!text && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(child)) return $c5f36586ce432e9f$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
            pos += child.nodeSize * dir;
        }
        return null;
    }
    function $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, startLen, bias) {
        let last = tr.steps.length - 1;
        if (last < startLen) return;
        let step = tr.steps[last];
        if (!(step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep) || step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceAroundStep))) return;
        let map = tr.mapping.maps[last], end;
        map.forEach((_from, _to, _newFrom, newTo)=>{
            if (end == null) end = newTo;
        });
        tr.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
    }
    const $c5f36586ce432e9f$var$UPDATED_SEL = 1, $c5f36586ce432e9f$var$UPDATED_MARKS = 2, $c5f36586ce432e9f$var$UPDATED_SCROLL = 4;
    class $c5f36586ce432e9f$export$febc5573c75cefb0 extends (0, (0, parcelRequire("eS2Dn")).Transform) {
        constructor(state){
            super(state.doc);
            this.curSelectionFor = 0;
            this.updated = 0;
            this.meta = Object.create(null);
            this.time = Date.now();
            this.curSelection = state.selection;
            this.storedMarks = state.storedMarks;
        }
        get selection() {
            if (this.curSelectionFor < this.steps.length) {
                this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
                this.curSelectionFor = this.steps.length;
            }
            return this.curSelection;
        }
        setSelection(selection) {
            if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
            this.curSelection = selection;
            this.curSelectionFor = this.steps.length;
            this.updated = (this.updated | $c5f36586ce432e9f$var$UPDATED_SEL) & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
            this.storedMarks = null;
            return this;
        }
        get selectionSet() {
            return (this.updated & $c5f36586ce432e9f$var$UPDATED_SEL) > 0;
        }
        setStoredMarks(marks) {
            this.storedMarks = marks;
            this.updated |= $c5f36586ce432e9f$var$UPDATED_MARKS;
            return this;
        }
        ensureMarks(marks) {
            if (!(0, (0, parcelRequire("kCV8T")).Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
            return this;
        }
        addStoredMark(mark) {
            return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
        }
        removeStoredMark(mark) {
            return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
        }
        get storedMarksSet() {
            return (this.updated & $c5f36586ce432e9f$var$UPDATED_MARKS) > 0;
        }
        addStep(step, doc) {
            super.addStep(step, doc);
            this.updated = this.updated & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
            this.storedMarks = null;
        }
        setTime(time) {
            this.time = time;
            return this;
        }
        replaceSelection(slice) {
            this.selection.replace(this, slice);
            return this;
        }
        replaceSelectionWith(node, inheritMarks = true) {
            let selection = this.selection;
            if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, (0, parcelRequire("kCV8T")).Mark).none));
            selection.replaceWith(this, node);
            return this;
        }
        deleteSelection() {
            this.selection.replace(this);
            return this;
        }
        insertText(text, from, to) {
            let schema = this.doc.type.schema;
            if (from == null) {
                if (!text) return this.deleteSelection();
                return this.replaceSelectionWith(schema.text(text), true);
            } else {
                if (to == null) to = from;
                to = to == null ? from : to;
                if (!text) return this.deleteRange(from, to);
                let marks = this.storedMarks;
                if (!marks) {
                    let $from = this.doc.resolve(from);
                    marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
                }
                this.replaceRangeWith(from, to, schema.text(text, marks));
                if (!this.selection.empty) this.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(this.selection.$to));
                return this;
            }
        }
        setMeta(key, value) {
            this.meta[typeof key == "string" ? key : key.key] = value;
            return this;
        }
        getMeta(key) {
            return this.meta[typeof key == "string" ? key : key.key];
        }
        get isGeneric() {
            for(let _ in this.meta)return false;
            return true;
        }
        scrollIntoView() {
            this.updated |= $c5f36586ce432e9f$var$UPDATED_SCROLL;
            return this;
        }
        get scrolledIntoView() {
            return (this.updated & $c5f36586ce432e9f$var$UPDATED_SCROLL) > 0;
        }
    }
    function $c5f36586ce432e9f$var$bind(f, self) {
        return !self || !f ? f : f.bind(self);
    }
    class $c5f36586ce432e9f$var$FieldDesc {
        constructor(name, desc, self){
            this.name = name;
            this.init = $c5f36586ce432e9f$var$bind(desc.init, self);
            this.apply = $c5f36586ce432e9f$var$bind(desc.apply, self);
        }
    }
    const $c5f36586ce432e9f$var$baseFields = [
        new $c5f36586ce432e9f$var$FieldDesc("doc", {
            init (config) {
                return config.doc || config.schema.topNodeType.createAndFill();
            },
            apply (tr) {
                return tr.doc;
            }
        }),
        new $c5f36586ce432e9f$var$FieldDesc("selection", {
            init (config, instance) {
                return config.selection || $c5f36586ce432e9f$export$52baac22726c72bf.atStart(instance.doc);
            },
            apply (tr) {
                return tr.selection;
            }
        }),
        new $c5f36586ce432e9f$var$FieldDesc("storedMarks", {
            init (config) {
                return config.storedMarks || null;
            },
            apply (tr, _marks, _old, state) {
                return state.selection.$cursor ? tr.storedMarks : null;
            }
        }),
        new $c5f36586ce432e9f$var$FieldDesc("scrollToSelection", {
            init () {
                return 0;
            },
            apply (tr, prev) {
                return tr.scrolledIntoView ? prev + 1 : prev;
            }
        })
    ];
    class $c5f36586ce432e9f$var$Configuration {
        constructor(schema, plugins){
            this.schema = schema;
            this.plugins = [];
            this.pluginsByKey = Object.create(null);
            this.fields = $c5f36586ce432e9f$var$baseFields.slice();
            if (plugins) plugins.forEach((plugin)=>{
                if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
                this.plugins.push(plugin);
                this.pluginsByKey[plugin.key] = plugin;
                if (plugin.spec.state) this.fields.push(new $c5f36586ce432e9f$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
            });
        }
    }
    class $c5f36586ce432e9f$export$afa855cbfaff27f2 {
        constructor(config){
            this.config = config;
        }
        get schema() {
            return this.config.schema;
        }
        get plugins() {
            return this.config.plugins;
        }
        apply(tr) {
            return this.applyTransaction(tr).state;
        }
        filterTransaction(tr, ignore = -1) {
            for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
                let plugin = this.config.plugins[i];
                if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
            }
            return true;
        }
        applyTransaction(rootTr) {
            if (!this.filterTransaction(rootTr)) return {
                state: this,
                transactions: []
            };
            let trs = [
                rootTr
            ], newState = this.applyInner(rootTr), seen = null;
            for(;;){
                let haveNew = false;
                for(let i = 0; i < this.config.plugins.length; i++){
                    let plugin = this.config.plugins[i];
                    if (plugin.spec.appendTransaction) {
                        let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                        let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                        if (tr && newState.filterTransaction(tr, i)) {
                            tr.setMeta("appendedTransaction", rootTr);
                            if (!seen) {
                                seen = [];
                                for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                    state: newState,
                                    n: trs.length
                                } : {
                                    state: this,
                                    n: 0
                                });
                            }
                            trs.push(tr);
                            newState = newState.applyInner(tr);
                            haveNew = true;
                        }
                        if (seen) seen[i] = {
                            state: newState,
                            n: trs.length
                        };
                    }
                }
                if (!haveNew) return {
                    state: newState,
                    transactions: trs
                };
            }
        }
        applyInner(tr) {
            if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
            let newInstance = new $c5f36586ce432e9f$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
            for(let i = 0; i < fields.length; i++){
                let field = fields[i];
                newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
            }
            return newInstance;
        }
        get tr() {
            return new $c5f36586ce432e9f$export$febc5573c75cefb0(this);
        }
        static create(config) {
            let $config = new $c5f36586ce432e9f$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
            let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
            for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
            return instance;
        }
        reconfigure(config) {
            let $config = new $c5f36586ce432e9f$var$Configuration(this.schema, config.plugins);
            let fields = $config.fields, instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
            for(let i = 0; i < fields.length; i++){
                let name = fields[i].name;
                instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
            }
            return instance;
        }
        toJSON(pluginFields) {
            let result = {
                doc: this.doc.toJSON(),
                selection: this.selection.toJSON()
            };
            if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
            if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
                if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
                let plugin = pluginFields[prop], state = plugin.spec.state;
                if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
            }
            return result;
        }
        static fromJSON(config, json, pluginFields) {
            if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
            if (!config.schema) throw new RangeError("Required config field 'schema' missing");
            let $config = new $c5f36586ce432e9f$var$Configuration(config.schema, config.plugins);
            let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
            $config.fields.forEach((field)=>{
                if (field.name == "doc") instance.doc = (0, (0, parcelRequire("kCV8T")).Node).fromJSON(config.schema, json.doc);
                else if (field.name == "selection") instance.selection = $c5f36586ce432e9f$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
                else if (field.name == "storedMarks") {
                    if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
                } else {
                    if (pluginFields) for(let prop in pluginFields){
                        let plugin = pluginFields[prop], state = plugin.spec.state;
                        if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                            instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                            return;
                        }
                    }
                    instance[field.name] = field.init(config, instance);
                }
            });
            return instance;
        }
    }
    function $c5f36586ce432e9f$var$bindProps(obj, self, target) {
        for(let prop in obj){
            let val = obj[prop];
            if (val instanceof Function) val = val.bind(self);
            else if (prop == "handleDOMEvents") val = $c5f36586ce432e9f$var$bindProps(val, self, {});
            target[prop] = val;
        }
        return target;
    }
    class $c5f36586ce432e9f$export$901cf72dabf2112a {
        constructor(spec){
            this.spec = spec;
            this.props = {};
            if (spec.props) $c5f36586ce432e9f$var$bindProps(spec.props, this, this.props);
            this.key = spec.key ? spec.key.key : $c5f36586ce432e9f$var$createKey("plugin");
        }
        getState(state) {
            return state[this.key];
        }
    }
    const $c5f36586ce432e9f$var$keys = Object.create(null);
    function $c5f36586ce432e9f$var$createKey(name) {
        if (name in $c5f36586ce432e9f$var$keys) return name + "$" + ++$c5f36586ce432e9f$var$keys[name];
        $c5f36586ce432e9f$var$keys[name] = 0;
        return name + "$";
    }
    class $c5f36586ce432e9f$export$1692d8b0e89cecc3 {
        constructor(name = "key"){
            this.key = $c5f36586ce432e9f$var$createKey(name);
        }
        get(state) {
            return state.config.pluginsByKey[this.key];
        }
        getState(state) {
            return state[this.key];
        }
    }
});
parcelRegister("kCV8T", function(module, exports) {
    $parcel$export(module.exports, "Fragment", ()=>$f043ae92c0a873f0$export$ffb0004e005737fa);
    $parcel$export(module.exports, "Mark", ()=>$f043ae92c0a873f0$export$c9d15bcfc6d42044);
    $parcel$export(module.exports, "ReplaceError", ()=>$f043ae92c0a873f0$export$6de0e778727af3f2);
    $parcel$export(module.exports, "Slice", ()=>$f043ae92c0a873f0$export$b3f2e2de3a8baa1e);
    $parcel$export(module.exports, "ResolvedPos", ()=>$f043ae92c0a873f0$export$b2a42f82e59e4b19);
    $parcel$export(module.exports, "NodeRange", ()=>$f043ae92c0a873f0$export$7bc461ceb770fb16);
    $parcel$export(module.exports, "Node", ()=>$f043ae92c0a873f0$export$85c928794f8d04d4);
    $parcel$export(module.exports, "MarkType", ()=>$f043ae92c0a873f0$export$b6a78689043c6521);
    $parcel$export(module.exports, "Schema", ()=>$f043ae92c0a873f0$export$19342e026b58ebb7);
    $parcel$export(module.exports, "DOMParser", ()=>$f043ae92c0a873f0$export$1059c6e7d2ce5669);
    $parcel$export(module.exports, "DOMSerializer", ()=>$f043ae92c0a873f0$export$3476b78f8f5a8b72);
    var $dHeNB;
    function $f043ae92c0a873f0$var$findDiffStart(a, b, pos) {
        for(let i = 0;; i++){
            if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
            let childA = a.child(i), childB = b.child(i);
            if (childA == childB) {
                pos += childA.nodeSize;
                continue;
            }
            if (!childA.sameMarkup(childB)) return pos;
            if (childA.isText && childA.text != childB.text) {
                for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
                return pos;
            }
            if (childA.content.size || childB.content.size) {
                let inner = $f043ae92c0a873f0$var$findDiffStart(childA.content, childB.content, pos + 1);
                if (inner != null) return inner;
            }
            pos += childA.nodeSize;
        }
    }
    function $f043ae92c0a873f0$var$findDiffEnd(a, b, posA, posB) {
        for(let iA = a.childCount, iB = b.childCount;;){
            if (iA == 0 || iB == 0) return iA == iB ? null : {
                a: posA,
                b: posB
            };
            let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
            if (childA == childB) {
                posA -= size;
                posB -= size;
                continue;
            }
            if (!childA.sameMarkup(childB)) return {
                a: posA,
                b: posB
            };
            if (childA.isText && childA.text != childB.text) {
                let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
                while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                    same++;
                    posA--;
                    posB--;
                }
                return {
                    a: posA,
                    b: posB
                };
            }
            if (childA.content.size || childB.content.size) {
                let inner = $f043ae92c0a873f0$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
                if (inner) return inner;
            }
            posA -= size;
            posB -= size;
        }
    }
    class $f043ae92c0a873f0$export$ffb0004e005737fa {
        constructor(content, size){
            this.content = content;
            this.size = size || 0;
            if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
        }
        nodesBetween(from, to, f, nodeStart = 0, parent) {
            for(let i = 0, pos = 0; pos < to; i++){
                let child = this.content[i], end = pos + child.nodeSize;
                if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                    let start = pos + 1;
                    child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
                }
                pos = end;
            }
        }
        descendants(f) {
            this.nodesBetween(0, this.size, f);
        }
        textBetween(from, to, blockSeparator, leafText) {
            let text = "", first = true;
            this.nodesBetween(from, to, (node, pos)=>{
                let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
                if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                    if (first) first = false;
                    else text += blockSeparator;
                }
                text += nodeText;
            }, 0);
            return text;
        }
        append(other) {
            if (!other.size) return this;
            if (!this.size) return other;
            let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
            if (last.isText && last.sameMarkup(first)) {
                content[content.length - 1] = last.withText(last.text + first.text);
                i = 1;
            }
            for(; i < other.content.length; i++)content.push(other.content[i]);
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(content, this.size + other.size);
        }
        cut(from, to = this.size) {
            if (from == 0 && to == this.size) return this;
            let result = [], size = 0;
            if (to > from) for(let i = 0, pos = 0; pos < to; i++){
                let child = this.content[i], end = pos + child.nodeSize;
                if (end > from) {
                    if (pos < from || end > to) {
                        if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                        else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                    }
                    result.push(child);
                    size += child.nodeSize;
                }
                pos = end;
            }
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(result, size);
        }
        cutByIndex(from, to) {
            if (from == to) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            if (from == 0 && to == this.content.length) return this;
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.slice(from, to));
        }
        replaceChild(index, node) {
            let current = this.content[index];
            if (current == node) return this;
            let copy = this.content.slice();
            let size = this.size + node.nodeSize - current.nodeSize;
            copy[index] = node;
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(copy, size);
        }
        addToStart(node) {
            return new $f043ae92c0a873f0$export$ffb0004e005737fa([
                node
            ].concat(this.content), this.size + node.nodeSize);
        }
        addToEnd(node) {
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
        }
        eq(other) {
            if (this.content.length != other.content.length) return false;
            for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
            return true;
        }
        get firstChild() {
            return this.content.length ? this.content[0] : null;
        }
        get lastChild() {
            return this.content.length ? this.content[this.content.length - 1] : null;
        }
        get childCount() {
            return this.content.length;
        }
        child(index) {
            let found = this.content[index];
            if (!found) throw new RangeError("Index " + index + " out of range for " + this);
            return found;
        }
        maybeChild(index) {
            return this.content[index] || null;
        }
        forEach(f) {
            for(let i = 0, p = 0; i < this.content.length; i++){
                let child = this.content[i];
                f(child, p, i);
                p += child.nodeSize;
            }
        }
        findDiffStart(other, pos = 0) {
            return $f043ae92c0a873f0$var$findDiffStart(this, other, pos);
        }
        findDiffEnd(other, pos = this.size, otherPos = other.size) {
            return $f043ae92c0a873f0$var$findDiffEnd(this, other, pos, otherPos);
        }
        findIndex(pos, round = -1) {
            if (pos == 0) return $f043ae92c0a873f0$var$retIndex(0, pos);
            if (pos == this.size) return $f043ae92c0a873f0$var$retIndex(this.content.length, pos);
            if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
            for(let i = 0, curPos = 0;; i++){
                let cur = this.child(i), end = curPos + cur.nodeSize;
                if (end >= pos) {
                    if (end == pos || round > 0) return $f043ae92c0a873f0$var$retIndex(i + 1, end);
                    return $f043ae92c0a873f0$var$retIndex(i, curPos);
                }
                curPos = end;
            }
        }
        toString() {
            return "<" + this.toStringInner() + ">";
        }
        toStringInner() {
            return this.content.join(", ");
        }
        toJSON() {
            return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
        }
        static fromJSON(schema, value) {
            if (!value) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
        }
        static fromArray(array) {
            if (!array.length) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            let joined, size = 0;
            for(let i = 0; i < array.length; i++){
                let node = array[i];
                size += node.nodeSize;
                if (i && node.isText && array[i - 1].sameMarkup(node)) {
                    if (!joined) joined = array.slice(0, i);
                    joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
                } else if (joined) joined.push(node);
            }
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(joined || array, size);
        }
        static from(nodes) {
            if (!nodes) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            if (nodes instanceof $f043ae92c0a873f0$export$ffb0004e005737fa) return nodes;
            if (Array.isArray(nodes)) return this.fromArray(nodes);
            if (nodes.attrs) return new $f043ae92c0a873f0$export$ffb0004e005737fa([
                nodes
            ], nodes.nodeSize);
            throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
        }
    }
    $f043ae92c0a873f0$export$ffb0004e005737fa.empty = new $f043ae92c0a873f0$export$ffb0004e005737fa([], 0);
    const $f043ae92c0a873f0$var$found = {
        index: 0,
        offset: 0
    };
    function $f043ae92c0a873f0$var$retIndex(index, offset) {
        $f043ae92c0a873f0$var$found.index = index;
        $f043ae92c0a873f0$var$found.offset = offset;
        return $f043ae92c0a873f0$var$found;
    }
    function $f043ae92c0a873f0$var$compareDeep(a, b) {
        if (a === b) return true;
        if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
        let array = Array.isArray(a);
        if (Array.isArray(b) != array) return false;
        if (array) {
            if (a.length != b.length) return false;
            for(let i = 0; i < a.length; i++)if (!$f043ae92c0a873f0$var$compareDeep(a[i], b[i])) return false;
        } else {
            for(let p in a)if (!(p in b) || !$f043ae92c0a873f0$var$compareDeep(a[p], b[p])) return false;
            for(let p in b)if (!(p in a)) return false;
        }
        return true;
    }
    class $f043ae92c0a873f0$export$c9d15bcfc6d42044 {
        constructor(type, attrs){
            this.type = type;
            this.attrs = attrs;
        }
        addToSet(set) {
            let copy, placed = false;
            for(let i = 0; i < set.length; i++){
                let other = set[i];
                if (this.eq(other)) return set;
                if (this.type.excludes(other.type)) {
                    if (!copy) copy = set.slice(0, i);
                } else if (other.type.excludes(this.type)) return set;
                else {
                    if (!placed && other.type.rank > this.type.rank) {
                        if (!copy) copy = set.slice(0, i);
                        copy.push(this);
                        placed = true;
                    }
                    if (copy) copy.push(other);
                }
            }
            if (!copy) copy = set.slice();
            if (!placed) copy.push(this);
            return copy;
        }
        removeFromSet(set) {
            for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
            return set;
        }
        isInSet(set) {
            for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
            return false;
        }
        eq(other) {
            return this == other || this.type == other.type && $f043ae92c0a873f0$var$compareDeep(this.attrs, other.attrs);
        }
        toJSON() {
            let obj = {
                type: this.type.name
            };
            for(let _ in this.attrs){
                obj.attrs = this.attrs;
                break;
            }
            return obj;
        }
        static fromJSON(schema, json) {
            if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
            let type = schema.marks[json.type];
            if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
            let mark = type.create(json.attrs);
            type.checkAttrs(mark.attrs);
            return mark;
        }
        static sameSet(a, b) {
            if (a == b) return true;
            if (a.length != b.length) return false;
            for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
            return true;
        }
        static setFrom(marks) {
            if (!marks || Array.isArray(marks) && marks.length == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            if (marks instanceof $f043ae92c0a873f0$export$c9d15bcfc6d42044) return [
                marks
            ];
            let copy = marks.slice();
            copy.sort((a, b)=>a.type.rank - b.type.rank);
            return copy;
        }
    }
    $f043ae92c0a873f0$export$c9d15bcfc6d42044.none = [];
    class $f043ae92c0a873f0$export$6de0e778727af3f2 extends Error {
    }
    class $f043ae92c0a873f0$export$b3f2e2de3a8baa1e {
        constructor(content, openStart, openEnd){
            this.content = content;
            this.openStart = openStart;
            this.openEnd = openEnd;
        }
        get size() {
            return this.content.size - this.openStart - this.openEnd;
        }
        insertAt(pos, fragment) {
            let content = $f043ae92c0a873f0$var$insertInto(this.content, pos + this.openStart, fragment);
            return content && new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
        }
        removeBetween(from, to) {
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
        }
        eq(other) {
            return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
        }
        toString() {
            return this.content + "(" + this.openStart + "," + this.openEnd + ")";
        }
        toJSON() {
            if (!this.content.size) return null;
            let json = {
                content: this.content.toJSON()
            };
            if (this.openStart > 0) json.openStart = this.openStart;
            if (this.openEnd > 0) json.openEnd = this.openEnd;
            return json;
        }
        static fromJSON(schema, json) {
            if (!json) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
            let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
            if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
        }
        static maxOpen(fragment, openIsolating = true) {
            let openStart = 0, openEnd = 0;
            for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
            for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
        }
    }
    $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty = new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.empty, 0, 0);
    function $f043ae92c0a873f0$var$removeRange(content, from, to) {
        let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
        let { index: indexTo, offset: offsetTo } = content.findIndex(to);
        if (offset == from || child.isText) {
            if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
            return content.cut(0, from).append(content.cut(to));
        }
        if (index != indexTo) throw new RangeError("Removing non-flat range");
        return content.replaceChild(index, child.copy($f043ae92c0a873f0$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
    }
    function $f043ae92c0a873f0$var$insertInto(content, dist, insert, parent) {
        let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
        if (offset == dist || child.isText) {
            if (parent && !parent.canReplace(index, index, insert)) return null;
            return content.cut(0, dist).append(insert).append(content.cut(dist));
        }
        let inner = $f043ae92c0a873f0$var$insertInto(child.content, dist - offset - 1, insert);
        return inner && content.replaceChild(index, child.copy(inner));
    }
    function $f043ae92c0a873f0$var$replace($from, $to, slice) {
        if (slice.openStart > $from.depth) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inserted content deeper than insertion position");
        if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inconsistent open depths");
        return $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, 0);
    }
    function $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth) {
        let index = $from.index(depth), node = $from.node(depth);
        if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
            let inner = $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth + 1);
            return node.copy(node.content.replaceChild(index, inner));
        } else if (!slice.content.size) return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth));
        else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
            let parent = $from.parent, content = parent.content;
            return $f043ae92c0a873f0$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
        } else {
            let { start: start, end: end } = $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $from);
            return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceThreeWay($from, start, end, $to, depth));
        }
    }
    function $f043ae92c0a873f0$var$checkJoin(main, sub) {
        if (!sub.type.compatibleContent(main.type)) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
    }
    function $f043ae92c0a873f0$var$joinable($before, $after, depth) {
        let node = $before.node(depth);
        $f043ae92c0a873f0$var$checkJoin(node, $after.node(depth));
        return node;
    }
    function $f043ae92c0a873f0$var$addNode(child, target) {
        let last = target.length - 1;
        if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
        else target.push(child);
    }
    function $f043ae92c0a873f0$var$addRange($start, $end, depth, target) {
        let node = ($end || $start).node(depth);
        let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
        if ($start) {
            startIndex = $start.index(depth);
            if ($start.depth > depth) startIndex++;
            else if ($start.textOffset) {
                $f043ae92c0a873f0$var$addNode($start.nodeAfter, target);
                startIndex++;
            }
        }
        for(let i = startIndex; i < endIndex; i++)$f043ae92c0a873f0$var$addNode(node.child(i), target);
        if ($end && $end.depth == depth && $end.textOffset) $f043ae92c0a873f0$var$addNode($end.nodeBefore, target);
    }
    function $f043ae92c0a873f0$var$close(node, content) {
        node.type.checkContent(content);
        return node.copy(content);
    }
    function $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth) {
        let openStart = $from.depth > depth && $f043ae92c0a873f0$var$joinable($from, $start, depth + 1);
        let openEnd = $to.depth > depth && $f043ae92c0a873f0$var$joinable($end, $to, depth + 1);
        let content = [];
        $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
        if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
            $f043ae92c0a873f0$var$checkJoin(openStart, openEnd);
            $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
        } else {
            if (openStart) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceTwoWay($from, $start, depth + 1)), content);
            $f043ae92c0a873f0$var$addRange($start, $end, depth, content);
            if (openEnd) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openEnd, $f043ae92c0a873f0$var$replaceTwoWay($end, $to, depth + 1)), content);
        }
        $f043ae92c0a873f0$var$addRange($to, null, depth, content);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
    }
    function $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth) {
        let content = [];
        $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
        if ($from.depth > depth) {
            let type = $f043ae92c0a873f0$var$joinable($from, $to, depth + 1);
            $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(type, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth + 1)), content);
        }
        $f043ae92c0a873f0$var$addRange($to, null, depth, content);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
    }
    function $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $along) {
        let extra = $along.depth - slice.openStart, parent = $along.node(extra);
        let node = parent.copy(slice.content);
        for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
        return {
            start: node.resolveNoCache(slice.openStart + extra),
            end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
        };
    }
    class $f043ae92c0a873f0$export$b2a42f82e59e4b19 {
        constructor(pos, path, parentOffset){
            this.pos = pos;
            this.path = path;
            this.parentOffset = parentOffset;
            this.depth = path.length / 3 - 1;
        }
        resolveDepth(val) {
            if (val == null) return this.depth;
            if (val < 0) return this.depth + val;
            return val;
        }
        get parent() {
            return this.node(this.depth);
        }
        get doc() {
            return this.node(0);
        }
        node(depth) {
            return this.path[this.resolveDepth(depth) * 3];
        }
        index(depth) {
            return this.path[this.resolveDepth(depth) * 3 + 1];
        }
        indexAfter(depth) {
            depth = this.resolveDepth(depth);
            return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
        }
        start(depth) {
            depth = this.resolveDepth(depth);
            return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        }
        end(depth) {
            depth = this.resolveDepth(depth);
            return this.start(depth) + this.node(depth).content.size;
        }
        before(depth) {
            depth = this.resolveDepth(depth);
            if (!depth) throw new RangeError("There is no position before the top-level node");
            return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
        }
        after(depth) {
            depth = this.resolveDepth(depth);
            if (!depth) throw new RangeError("There is no position after the top-level node");
            return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
        }
        get textOffset() {
            return this.pos - this.path[this.path.length - 1];
        }
        get nodeAfter() {
            let parent = this.parent, index = this.index(this.depth);
            if (index == parent.childCount) return null;
            let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
            return dOff ? parent.child(index).cut(dOff) : child;
        }
        get nodeBefore() {
            let index = this.index(this.depth);
            let dOff = this.pos - this.path[this.path.length - 1];
            if (dOff) return this.parent.child(index).cut(0, dOff);
            return index == 0 ? null : this.parent.child(index - 1);
        }
        posAtIndex(index, depth) {
            depth = this.resolveDepth(depth);
            let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
            for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
            return pos;
        }
        marks() {
            let parent = this.parent, index = this.index();
            if (parent.content.size == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            if (this.textOffset) return parent.child(index).marks;
            let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
            if (!main) {
                let tmp = main;
                main = other;
                other = tmp;
            }
            let marks = main.marks;
            for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
            return marks;
        }
        marksAcross($end) {
            let after = this.parent.maybeChild(this.index());
            if (!after || !after.isInline) return null;
            let marks = after.marks, next = $end.parent.maybeChild($end.index());
            for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
            return marks;
        }
        sharedDepth(pos) {
            for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
            return 0;
        }
        blockRange(other = this, pred) {
            if (other.pos < this.pos) return other.blockRange(this);
            for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $f043ae92c0a873f0$export$7bc461ceb770fb16(this, other, d);
            return null;
        }
        sameParent(other) {
            return this.pos - this.parentOffset == other.pos - other.parentOffset;
        }
        max(other) {
            return other.pos > this.pos ? other : this;
        }
        min(other) {
            return other.pos < this.pos ? other : this;
        }
        toString() {
            let str = "";
            for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
            return str + ":" + this.parentOffset;
        }
        static resolve(doc, pos) {
            if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
            let path = [];
            let start = 0, parentOffset = pos;
            for(let node = doc;;){
                let { index: index, offset: offset } = node.content.findIndex(parentOffset);
                let rem = parentOffset - offset;
                path.push(node, index, start + offset);
                if (!rem) break;
                node = node.child(index);
                if (node.isText) break;
                parentOffset = rem - 1;
                start += offset + 1;
            }
            return new $f043ae92c0a873f0$export$b2a42f82e59e4b19(pos, path, parentOffset);
        }
        static resolveCached(doc, pos) {
            let cache = $f043ae92c0a873f0$var$resolveCache.get(doc);
            if (cache) for(let i = 0; i < cache.elts.length; i++){
                let elt = cache.elts[i];
                if (elt.pos == pos) return elt;
            }
            else $f043ae92c0a873f0$var$resolveCache.set(doc, cache = new $f043ae92c0a873f0$var$ResolveCache);
            let result = cache.elts[cache.i] = $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(doc, pos);
            cache.i = (cache.i + 1) % $f043ae92c0a873f0$var$resolveCacheSize;
            return result;
        }
    }
    class $f043ae92c0a873f0$var$ResolveCache {
        constructor(){
            this.elts = [];
            this.i = 0;
        }
    }
    const $f043ae92c0a873f0$var$resolveCacheSize = 12, $f043ae92c0a873f0$var$resolveCache = new WeakMap();
    class $f043ae92c0a873f0$export$7bc461ceb770fb16 {
        constructor($from, $to, depth){
            this.$from = $from;
            this.$to = $to;
            this.depth = depth;
        }
        get start() {
            return this.$from.before(this.depth + 1);
        }
        get end() {
            return this.$to.after(this.depth + 1);
        }
        get parent() {
            return this.$from.node(this.depth);
        }
        get startIndex() {
            return this.$from.index(this.depth);
        }
        get endIndex() {
            return this.$to.indexAfter(this.depth);
        }
    }
    const $f043ae92c0a873f0$var$emptyAttrs = Object.create(null);
    class $f043ae92c0a873f0$export$85c928794f8d04d4 {
        constructor(type, attrs, content, marks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none){
            this.type = type;
            this.attrs = attrs;
            this.marks = marks;
            this.content = content || $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        }
        get nodeSize() {
            return this.isLeaf ? 1 : 2 + this.content.size;
        }
        get childCount() {
            return this.content.childCount;
        }
        child(index) {
            return this.content.child(index);
        }
        maybeChild(index) {
            return this.content.maybeChild(index);
        }
        forEach(f) {
            this.content.forEach(f);
        }
        nodesBetween(from, to, f, startPos = 0) {
            this.content.nodesBetween(from, to, f, startPos, this);
        }
        descendants(f) {
            this.nodesBetween(0, this.content.size, f);
        }
        get textContent() {
            return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
        }
        textBetween(from, to, blockSeparator, leafText) {
            return this.content.textBetween(from, to, blockSeparator, leafText);
        }
        get firstChild() {
            return this.content.firstChild;
        }
        get lastChild() {
            return this.content.lastChild;
        }
        eq(other) {
            return this == other || this.sameMarkup(other) && this.content.eq(other.content);
        }
        sameMarkup(other) {
            return this.hasMarkup(other.type, other.attrs, other.marks);
        }
        hasMarkup(type, attrs, marks) {
            return this.type == type && $f043ae92c0a873f0$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $f043ae92c0a873f0$var$emptyAttrs) && $f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $f043ae92c0a873f0$export$c9d15bcfc6d42044.none);
        }
        copy(content = null) {
            if (content == this.content) return this;
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
        }
        mark(marks) {
            return marks == this.marks ? this : new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
        }
        cut(from, to = this.content.size) {
            if (from == 0 && to == this.content.size) return this;
            return this.copy(this.content.cut(from, to));
        }
        slice(from, to = this.content.size, includeParents = false) {
            if (from == to) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
            let $from = this.resolve(from), $to = this.resolve(to);
            let depth = includeParents ? 0 : $from.sharedDepth(to);
            let start = $from.start(depth), node = $from.node(depth);
            let content = node.content.cut($from.pos - start, $to.pos - start);
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
        }
        replace(from, to, slice) {
            return $f043ae92c0a873f0$var$replace(this.resolve(from), this.resolve(to), slice);
        }
        nodeAt(pos) {
            for(let node = this;;){
                let { index: index, offset: offset } = node.content.findIndex(pos);
                node = node.maybeChild(index);
                if (!node) return null;
                if (offset == pos || node.isText) return node;
                pos -= offset + 1;
            }
        }
        childAfter(pos) {
            let { index: index, offset: offset } = this.content.findIndex(pos);
            return {
                node: this.content.maybeChild(index),
                index: index,
                offset: offset
            };
        }
        childBefore(pos) {
            if (pos == 0) return {
                node: null,
                index: 0,
                offset: 0
            };
            let { index: index, offset: offset } = this.content.findIndex(pos);
            if (offset < pos) return {
                node: this.content.child(index),
                index: index,
                offset: offset
            };
            let node = this.content.child(index - 1);
            return {
                node: node,
                index: index - 1,
                offset: offset - node.nodeSize
            };
        }
        resolve(pos) {
            return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolveCached(this, pos);
        }
        resolveNoCache(pos) {
            return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(this, pos);
        }
        rangeHasMark(from, to, type) {
            let found = false;
            if (to > from) this.nodesBetween(from, to, (node)=>{
                if (type.isInSet(node.marks)) found = true;
                return !found;
            });
            return found;
        }
        get isBlock() {
            return this.type.isBlock;
        }
        get isTextblock() {
            return this.type.isTextblock;
        }
        get inlineContent() {
            return this.type.inlineContent;
        }
        get isInline() {
            return this.type.isInline;
        }
        get isText() {
            return this.type.isText;
        }
        get isLeaf() {
            return this.type.isLeaf;
        }
        get isAtom() {
            return this.type.isAtom;
        }
        toString() {
            if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
            let name = this.type.name;
            if (this.content.size) name += "(" + this.content.toStringInner() + ")";
            return $f043ae92c0a873f0$var$wrapMarks(this.marks, name);
        }
        contentMatchAt(index) {
            let match = this.type.contentMatch.matchFragment(this.content, 0, index);
            if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
            return match;
        }
        canReplace(from, to, replacement = $f043ae92c0a873f0$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
            let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
            let two = one && one.matchFragment(this.content, to);
            if (!two || !two.validEnd) return false;
            for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
            return true;
        }
        canReplaceWith(from, to, type, marks) {
            if (marks && !this.type.allowsMarks(marks)) return false;
            let start = this.contentMatchAt(from).matchType(type);
            let end = start && start.matchFragment(this.content, to);
            return end ? end.validEnd : false;
        }
        canAppend(other) {
            if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
            else return this.type.compatibleContent(other.type);
        }
        check() {
            this.type.checkContent(this.content);
            this.type.checkAttrs(this.attrs);
            let copy = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            for(let i = 0; i < this.marks.length; i++){
                let mark = this.marks[i];
                mark.type.checkAttrs(mark.attrs);
                copy = mark.addToSet(copy);
            }
            if (!$f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
            this.content.forEach((node)=>node.check());
        }
        toJSON() {
            let obj = {
                type: this.type.name
            };
            for(let _ in this.attrs){
                obj.attrs = this.attrs;
                break;
            }
            if (this.content.size) obj.content = this.content.toJSON();
            if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
            return obj;
        }
        static fromJSON(schema, json) {
            if (!json) throw new RangeError("Invalid input for Node.fromJSON");
            let marks = undefined;
            if (json.marks) {
                if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
                marks = json.marks.map(schema.markFromJSON);
            }
            if (json.type == "text") {
                if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
                return schema.text(json.text, marks);
            }
            let content = $f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content);
            let node = schema.nodeType(json.type).create(json.attrs, content, marks);
            node.type.checkAttrs(node.attrs);
            return node;
        }
    }
    $f043ae92c0a873f0$export$85c928794f8d04d4.prototype.text = undefined;
    class $f043ae92c0a873f0$var$TextNode extends $f043ae92c0a873f0$export$85c928794f8d04d4 {
        constructor(type, attrs, content, marks){
            super(type, attrs, null, marks);
            if (!content) throw new RangeError("Empty text nodes are not allowed");
            this.text = content;
        }
        toString() {
            if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
            return $f043ae92c0a873f0$var$wrapMarks(this.marks, JSON.stringify(this.text));
        }
        get textContent() {
            return this.text;
        }
        textBetween(from, to) {
            return this.text.slice(from, to);
        }
        get nodeSize() {
            return this.text.length;
        }
        mark(marks) {
            return marks == this.marks ? this : new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, this.text, marks);
        }
        withText(text) {
            if (text == this.text) return this;
            return new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, text, this.marks);
        }
        cut(from = 0, to = this.text.length) {
            if (from == 0 && to == this.text.length) return this;
            return this.withText(this.text.slice(from, to));
        }
        eq(other) {
            return this.sameMarkup(other) && this.text == other.text;
        }
        toJSON() {
            let base = super.toJSON();
            base.text = this.text;
            return base;
        }
    }
    function $f043ae92c0a873f0$var$wrapMarks(marks, str) {
        for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
        return str;
    }
    class $f043ae92c0a873f0$export$364ed450558d7ec4 {
        constructor(validEnd){
            this.validEnd = validEnd;
            this.next = [];
            this.wrapCache = [];
        }
        static parse(string, nodeTypes) {
            let stream = new $f043ae92c0a873f0$var$TokenStream(string, nodeTypes);
            if (stream.next == null) return $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
            let expr = $f043ae92c0a873f0$var$parseExpr(stream);
            if (stream.next) stream.err("Unexpected trailing text");
            let match = $f043ae92c0a873f0$var$dfa($f043ae92c0a873f0$var$nfa(expr));
            $f043ae92c0a873f0$var$checkForDeadEnds(match, stream);
            return match;
        }
        matchType(type) {
            for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
            return null;
        }
        matchFragment(frag, start = 0, end = frag.childCount) {
            let cur = this;
            for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
            return cur;
        }
        get inlineContent() {
            return this.next.length != 0 && this.next[0].type.isInline;
        }
        get defaultType() {
            for(let i = 0; i < this.next.length; i++){
                let { type: type } = this.next[i];
                if (!(type.isText || type.hasRequiredAttrs())) return type;
            }
            return null;
        }
        compatible(other) {
            for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
            return false;
        }
        fillBefore(after, toEnd = false, startIndex = 0) {
            let seen = [
                this
            ];
            function search(match, types) {
                let finished = match.matchFragment(after, startIndex);
                if (finished && (!toEnd || finished.validEnd)) return $f043ae92c0a873f0$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
                for(let i = 0; i < match.next.length; i++){
                    let { type: type, next: next } = match.next[i];
                    if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                        seen.push(next);
                        let found = search(next, types.concat(type));
                        if (found) return found;
                    }
                }
                return null;
            }
            return search(this, []);
        }
        findWrapping(target) {
            for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
            let computed = this.computeWrapping(target);
            this.wrapCache.push(target, computed);
            return computed;
        }
        computeWrapping(target) {
            let seen = Object.create(null), active = [
                {
                    match: this,
                    type: null,
                    via: null
                }
            ];
            while(active.length){
                let current = active.shift(), match = current.match;
                if (match.matchType(target)) {
                    let result = [];
                    for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                    return result.reverse();
                }
                for(let i = 0; i < match.next.length; i++){
                    let { type: type, next: next } = match.next[i];
                    if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                        active.push({
                            match: type.contentMatch,
                            type: type,
                            via: current
                        });
                        seen[type.name] = true;
                    }
                }
            }
            return null;
        }
        get edgeCount() {
            return this.next.length;
        }
        edge(n) {
            if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
            return this.next[n];
        }
        toString() {
            let seen = [];
            function scan(m) {
                seen.push(m);
                for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
            }
            scan(this);
            return seen.map((m, i)=>{
                let out = i + (m.validEnd ? "*" : " ") + " ";
                for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
                return out;
            }).join("\n");
        }
    }
    $f043ae92c0a873f0$export$364ed450558d7ec4.empty = new $f043ae92c0a873f0$export$364ed450558d7ec4(true);
    class $f043ae92c0a873f0$var$TokenStream {
        constructor(string, nodeTypes){
            this.string = string;
            this.nodeTypes = nodeTypes;
            this.inline = null;
            this.pos = 0;
            this.tokens = string.split(/\s*(?=\b|\W|$)/);
            if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
            if (this.tokens[0] == "") this.tokens.shift();
        }
        get next() {
            return this.tokens[this.pos];
        }
        eat(tok) {
            return this.next == tok && (this.pos++ || true);
        }
        err(str) {
            throw new SyntaxError(str + " (in content expression '" + this.string + "')");
        }
    }
    function $f043ae92c0a873f0$var$parseExpr(stream) {
        let exprs = [];
        do exprs.push($f043ae92c0a873f0$var$parseExprSeq(stream));
        while (stream.eat("|"))
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    }
    function $f043ae92c0a873f0$var$parseExprSeq(stream) {
        let exprs = [];
        do exprs.push($f043ae92c0a873f0$var$parseExprSubscript(stream));
        while (stream.next && stream.next != ")" && stream.next != "|")
        return exprs.length == 1 ? exprs[0] : {
            type: "seq",
            exprs: exprs
        };
    }
    function $f043ae92c0a873f0$var$parseExprSubscript(stream) {
        let expr = $f043ae92c0a873f0$var$parseExprAtom(stream);
        for(;;){
            if (stream.eat("+")) expr = {
                type: "plus",
                expr: expr
            };
            else if (stream.eat("*")) expr = {
                type: "star",
                expr: expr
            };
            else if (stream.eat("?")) expr = {
                type: "opt",
                expr: expr
            };
            else if (stream.eat("{")) expr = $f043ae92c0a873f0$var$parseExprRange(stream, expr);
            else break;
        }
        return expr;
    }
    function $f043ae92c0a873f0$var$parseNum(stream) {
        if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
        let result = Number(stream.next);
        stream.pos++;
        return result;
    }
    function $f043ae92c0a873f0$var$parseExprRange(stream, expr) {
        let min = $f043ae92c0a873f0$var$parseNum(stream), max = min;
        if (stream.eat(",")) {
            if (stream.next != "}") max = $f043ae92c0a873f0$var$parseNum(stream);
            else max = -1;
        }
        if (!stream.eat("}")) stream.err("Unclosed braced range");
        return {
            type: "range",
            min: min,
            max: max,
            expr: expr
        };
    }
    function $f043ae92c0a873f0$var$resolveName(stream, name) {
        let types = stream.nodeTypes, type = types[name];
        if (type) return [
            type
        ];
        let result = [];
        for(let typeName in types){
            let type = types[typeName];
            if (type.groups.indexOf(name) > -1) result.push(type);
        }
        if (result.length == 0) stream.err("No node type or group '" + name + "' found");
        return result;
    }
    function $f043ae92c0a873f0$var$parseExprAtom(stream) {
        if (stream.eat("(")) {
            let expr = $f043ae92c0a873f0$var$parseExpr(stream);
            if (!stream.eat(")")) stream.err("Missing closing paren");
            return expr;
        } else if (!/\W/.test(stream.next)) {
            let exprs = $f043ae92c0a873f0$var$resolveName(stream, stream.next).map((type)=>{
                if (stream.inline == null) stream.inline = type.isInline;
                else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
                return {
                    type: "name",
                    value: type
                };
            });
            stream.pos++;
            return exprs.length == 1 ? exprs[0] : {
                type: "choice",
                exprs: exprs
            };
        } else stream.err("Unexpected token '" + stream.next + "'");
    }
    function $f043ae92c0a873f0$var$nfa(expr) {
        let nfa = [
            []
        ];
        connect(compile(expr, 0), node());
        return nfa;
        function node() {
            return nfa.push([]) - 1;
        }
        function edge(from, to, term) {
            let edge = {
                term: term,
                to: to
            };
            nfa[from].push(edge);
            return edge;
        }
        function connect(edges, to) {
            edges.forEach((edge)=>edge.to = to);
        }
        function compile(expr, from) {
            if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
            else if (expr.type == "seq") for(let i = 0;; i++){
                let next = compile(expr.exprs[i], from);
                if (i == expr.exprs.length - 1) return next;
                connect(next, from = node());
            }
            else if (expr.type == "star") {
                let loop = node();
                edge(from, loop);
                connect(compile(expr.expr, loop), loop);
                return [
                    edge(loop)
                ];
            } else if (expr.type == "plus") {
                let loop = node();
                connect(compile(expr.expr, from), loop);
                connect(compile(expr.expr, loop), loop);
                return [
                    edge(loop)
                ];
            } else if (expr.type == "opt") return [
                edge(from)
            ].concat(compile(expr.expr, from));
            else if (expr.type == "range") {
                let cur = from;
                for(let i = 0; i < expr.min; i++){
                    let next = node();
                    connect(compile(expr.expr, cur), next);
                    cur = next;
                }
                if (expr.max == -1) connect(compile(expr.expr, cur), cur);
                else for(let i = expr.min; i < expr.max; i++){
                    let next = node();
                    edge(cur, next);
                    connect(compile(expr.expr, cur), next);
                    cur = next;
                }
                return [
                    edge(cur)
                ];
            } else if (expr.type == "name") return [
                edge(from, undefined, expr.value)
            ];
            else throw new Error("Unknown expr type");
        }
    }
    function $f043ae92c0a873f0$var$cmp(a, b) {
        return b - a;
    }
    function $f043ae92c0a873f0$var$nullFrom(nfa, node) {
        let result = [];
        scan(node);
        return result.sort($f043ae92c0a873f0$var$cmp);
        function scan(node) {
            let edges = nfa[node];
            if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
            result.push(node);
            for(let i = 0; i < edges.length; i++){
                let { term: term, to: to } = edges[i];
                if (!term && result.indexOf(to) == -1) scan(to);
            }
        }
    }
    function $f043ae92c0a873f0$var$dfa(nfa) {
        let labeled = Object.create(null);
        return explore($f043ae92c0a873f0$var$nullFrom(nfa, 0));
        function explore(states) {
            let out = [];
            states.forEach((node)=>{
                nfa[node].forEach(({ term: term, to: to })=>{
                    if (!term) return;
                    let set;
                    for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                    $f043ae92c0a873f0$var$nullFrom(nfa, to).forEach((node)=>{
                        if (!set) out.push([
                            term,
                            set = []
                        ]);
                        if (set.indexOf(node) == -1) set.push(node);
                    });
                });
            });
            let state = labeled[states.join(",")] = new $f043ae92c0a873f0$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
            for(let i = 0; i < out.length; i++){
                let states = out[i][1].sort($f043ae92c0a873f0$var$cmp);
                state.next.push({
                    type: out[i][0],
                    next: labeled[states.join(",")] || explore(states)
                });
            }
            return state;
        }
    }
    function $f043ae92c0a873f0$var$checkForDeadEnds(match, stream) {
        for(let i = 0, work = [
            match
        ]; i < work.length; i++){
            let state = work[i], dead = !state.validEnd, nodes = [];
            for(let j = 0; j < state.next.length; j++){
                let { type: type, next: next } = state.next[j];
                nodes.push(type.name);
                if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
                if (work.indexOf(next) == -1) work.push(next);
            }
            if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
        }
    }
    function $f043ae92c0a873f0$var$defaultAttrs(attrs) {
        let defaults = Object.create(null);
        for(let attrName in attrs){
            let attr = attrs[attrName];
            if (!attr.hasDefault) return null;
            defaults[attrName] = attr.default;
        }
        return defaults;
    }
    function $f043ae92c0a873f0$var$computeAttrs(attrs, value) {
        let built = Object.create(null);
        for(let name in attrs){
            let given = value && value[name];
            if (given === undefined) {
                let attr = attrs[name];
                if (attr.hasDefault) given = attr.default;
                else throw new RangeError("No value supplied for attribute " + name);
            }
            built[name] = given;
        }
        return built;
    }
    function $f043ae92c0a873f0$var$checkAttrs(attrs, values, type, name) {
        for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
        for(let name in attrs){
            let attr = attrs[name];
            if (attr.validate) attr.validate(values[name]);
        }
    }
    function $f043ae92c0a873f0$var$initAttrs(typeName, attrs) {
        let result = Object.create(null);
        if (attrs) for(let name in attrs)result[name] = new $f043ae92c0a873f0$var$Attribute(typeName, name, attrs[name]);
        return result;
    }
    class $f043ae92c0a873f0$export$f06e977173f1857c {
        constructor(name, schema, spec){
            this.name = name;
            this.schema = schema;
            this.spec = spec;
            this.markSet = null;
            this.groups = spec.group ? spec.group.split(" ") : [];
            this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
            this.defaultAttrs = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
            this.contentMatch = null;
            this.inlineContent = null;
            this.isBlock = !(spec.inline || name == "text");
            this.isText = name == "text";
        }
        get isInline() {
            return !this.isBlock;
        }
        get isTextblock() {
            return this.isBlock && this.inlineContent;
        }
        get isLeaf() {
            return this.contentMatch == $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
        }
        get isAtom() {
            return this.isLeaf || !!this.spec.atom;
        }
        get whitespace() {
            return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
        }
        hasRequiredAttrs() {
            for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
            return false;
        }
        compatibleContent(other) {
            return this == other || this.contentMatch.compatible(other.contentMatch);
        }
        computeAttrs(attrs) {
            if (!attrs && this.defaultAttrs) return this.defaultAttrs;
            else return $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs);
        }
        create(attrs = null, content, marks) {
            if (this.isText) throw new Error("NodeType.create can't construct text nodes");
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $f043ae92c0a873f0$export$ffb0004e005737fa.from(content), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        createChecked(attrs = null, content, marks) {
            content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
            this.checkContent(content);
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        createAndFill(attrs = null, content, marks) {
            attrs = this.computeAttrs(attrs);
            content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
            if (content.size) {
                let before = this.contentMatch.fillBefore(content);
                if (!before) return null;
                content = before.append(content);
            }
            let matched = this.contentMatch.matchFragment(content);
            let after = matched && matched.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true);
            if (!after) return null;
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, attrs, content.append(after), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        validContent(content) {
            let result = this.contentMatch.matchFragment(content);
            if (!result || !result.validEnd) return false;
            for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
            return true;
        }
        checkContent(content) {
            if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
        }
        checkAttrs(attrs) {
            $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "node", this.name);
        }
        allowsMarkType(markType) {
            return this.markSet == null || this.markSet.indexOf(markType) > -1;
        }
        allowsMarks(marks) {
            if (this.markSet == null) return true;
            for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
            return true;
        }
        allowedMarks(marks) {
            if (this.markSet == null) return marks;
            let copy;
            for(let i = 0; i < marks.length; i++){
                if (!this.allowsMarkType(marks[i].type)) {
                    if (!copy) copy = marks.slice(0, i);
                } else if (copy) copy.push(marks[i]);
            }
            return !copy ? marks : copy.length ? copy : $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        }
        static compile(nodes, schema) {
            let result = Object.create(null);
            nodes.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$f06e977173f1857c(name, schema, spec));
            let topType = schema.spec.topNode || "doc";
            if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
            if (!result.text) throw new RangeError("Every schema needs a 'text' type");
            for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
            return result;
        }
    }
    function $f043ae92c0a873f0$var$validateType(typeName, attrName, type) {
        let types = type.split("|");
        return (value)=>{
            let name = value === null ? "null" : typeof value;
            if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
        };
    }
    class $f043ae92c0a873f0$var$Attribute {
        constructor(typeName, attrName, options){
            this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
            this.default = options.default;
            this.validate = typeof options.validate == "string" ? $f043ae92c0a873f0$var$validateType(typeName, attrName, options.validate) : options.validate;
        }
        get isRequired() {
            return !this.hasDefault;
        }
    }
    class $f043ae92c0a873f0$export$b6a78689043c6521 {
        constructor(name, rank, schema, spec){
            this.name = name;
            this.rank = rank;
            this.schema = schema;
            this.spec = spec;
            this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
            this.excluded = null;
            let defaults = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
            this.instance = defaults ? new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, defaults) : null;
        }
        create(attrs = null) {
            if (!attrs && this.instance) return this.instance;
            return new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs));
        }
        static compile(marks, schema) {
            let result = Object.create(null), rank = 0;
            marks.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$b6a78689043c6521(name, rank++, schema, spec));
            return result;
        }
        removeFromSet(set) {
            for(var i = 0; i < set.length; i++)if (set[i].type == this) {
                set = set.slice(0, i).concat(set.slice(i + 1));
                i--;
            }
            return set;
        }
        isInSet(set) {
            for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
        }
        checkAttrs(attrs) {
            $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "mark", this.name);
        }
        excludes(other) {
            return this.excluded.indexOf(other) > -1;
        }
    }
    class $f043ae92c0a873f0$export$19342e026b58ebb7 {
        constructor(spec){
            this.linebreakReplacement = null;
            this.cached = Object.create(null);
            let instanceSpec = this.spec = {};
            for(let prop in spec)instanceSpec[prop] = spec[prop];
            instanceSpec.nodes = (0, (0, parcelRequire("dHeNB")).default).from(spec.nodes), instanceSpec.marks = (0, (0, parcelRequire("dHeNB")).default).from(spec.marks || {}), this.nodes = $f043ae92c0a873f0$export$f06e977173f1857c.compile(this.spec.nodes, this);
            this.marks = $f043ae92c0a873f0$export$b6a78689043c6521.compile(this.spec.marks, this);
            let contentExprCache = Object.create(null);
            for(let prop in this.nodes){
                if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
                let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
                type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $f043ae92c0a873f0$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
                type.inlineContent = type.contentMatch.inlineContent;
                if (type.spec.linebreakReplacement) {
                    if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                    if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                    this.linebreakReplacement = type;
                }
                type.markSet = markExpr == "_" ? null : markExpr ? $f043ae92c0a873f0$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
            }
            for(let prop in this.marks){
                let type = this.marks[prop], excl = type.spec.excludes;
                type.excluded = excl == null ? [
                    type
                ] : excl == "" ? [] : $f043ae92c0a873f0$var$gatherMarks(this, excl.split(" "));
            }
            this.nodeFromJSON = this.nodeFromJSON.bind(this);
            this.markFromJSON = this.markFromJSON.bind(this);
            this.topNodeType = this.nodes[this.spec.topNode || "doc"];
            this.cached.wrappings = Object.create(null);
        }
        node(type, attrs = null, content, marks) {
            if (typeof type == "string") type = this.nodeType(type);
            else if (!(type instanceof $f043ae92c0a873f0$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
            else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
            return type.createChecked(attrs, content, marks);
        }
        text(text, marks) {
            let type = this.nodes.text;
            return new $f043ae92c0a873f0$var$TextNode(type, type.defaultAttrs, text, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        mark(type, attrs) {
            if (typeof type == "string") type = this.marks[type];
            return type.create(attrs);
        }
        nodeFromJSON(json) {
            return $f043ae92c0a873f0$export$85c928794f8d04d4.fromJSON(this, json);
        }
        markFromJSON(json) {
            return $f043ae92c0a873f0$export$c9d15bcfc6d42044.fromJSON(this, json);
        }
        nodeType(name) {
            let found = this.nodes[name];
            if (!found) throw new RangeError("Unknown node type: " + name);
            return found;
        }
    }
    function $f043ae92c0a873f0$var$gatherMarks(schema, marks) {
        let found = [];
        for(let i = 0; i < marks.length; i++){
            let name = marks[i], mark = schema.marks[name], ok = mark;
            if (mark) found.push(mark);
            else for(let prop in schema.marks){
                let mark = schema.marks[prop];
                if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
            }
            if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
        }
        return found;
    }
    function $f043ae92c0a873f0$var$isTagRule(rule) {
        return rule.tag != null;
    }
    function $f043ae92c0a873f0$var$isStyleRule(rule) {
        return rule.style != null;
    }
    class $f043ae92c0a873f0$export$1059c6e7d2ce5669 {
        constructor(schema, rules){
            this.schema = schema;
            this.rules = rules;
            this.tags = [];
            this.styles = [];
            let matchedStyles = this.matchedStyles = [];
            rules.forEach((rule)=>{
                if ($f043ae92c0a873f0$var$isTagRule(rule)) this.tags.push(rule);
                else if ($f043ae92c0a873f0$var$isStyleRule(rule)) {
                    let prop = /[^=]*/.exec(rule.style)[0];
                    if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                    this.styles.push(rule);
                }
            });
            this.normalizeLists = !this.tags.some((r)=>{
                if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
                let node = schema.nodes[r.node];
                return node.contentMatch.matchType(node);
            });
        }
        parse(dom, options = {}) {
            let context = new $f043ae92c0a873f0$var$ParseContext(this, options, false);
            context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
            return context.finish();
        }
        parseSlice(dom, options = {}) {
            let context = new $f043ae92c0a873f0$var$ParseContext(this, options, true);
            context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
            return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
        }
        matchTag(dom, context, after) {
            for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
                let rule = this.tags[i];
                if ($f043ae92c0a873f0$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                    if (rule.getAttrs) {
                        let result = rule.getAttrs(dom);
                        if (result === false) continue;
                        rule.attrs = result || undefined;
                    }
                    return rule;
                }
            }
        }
        matchStyle(prop, value, context, after) {
            for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
                let rule = this.styles[i], style = rule.style;
                if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
                if (rule.getAttrs) {
                    let result = rule.getAttrs(value);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
        static schemaRules(schema) {
            let result = [];
            function insert(rule) {
                let priority = rule.priority == null ? 50 : rule.priority, i = 0;
                for(; i < result.length; i++){
                    let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                    if (nextPriority < priority) break;
                }
                result.splice(i, 0, rule);
            }
            for(let name in schema.marks){
                let rules = schema.marks[name].spec.parseDOM;
                if (rules) rules.forEach((rule)=>{
                    insert(rule = $f043ae92c0a873f0$var$copy(rule));
                    if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
                });
            }
            for(let name in schema.nodes){
                let rules = schema.nodes[name].spec.parseDOM;
                if (rules) rules.forEach((rule)=>{
                    insert(rule = $f043ae92c0a873f0$var$copy(rule));
                    if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
                });
            }
            return result;
        }
        static fromSchema(schema) {
            return schema.cached.domParser || (schema.cached.domParser = new $f043ae92c0a873f0$export$1059c6e7d2ce5669(schema, $f043ae92c0a873f0$export$1059c6e7d2ce5669.schemaRules(schema)));
        }
    }
    const $f043ae92c0a873f0$var$blockTags = {
        address: true,
        article: true,
        aside: true,
        blockquote: true,
        canvas: true,
        dd: true,
        div: true,
        dl: true,
        fieldset: true,
        figcaption: true,
        figure: true,
        footer: true,
        form: true,
        h1: true,
        h2: true,
        h3: true,
        h4: true,
        h5: true,
        h6: true,
        header: true,
        hgroup: true,
        hr: true,
        li: true,
        noscript: true,
        ol: true,
        output: true,
        p: true,
        pre: true,
        section: true,
        table: true,
        tfoot: true,
        ul: true
    };
    const $f043ae92c0a873f0$var$ignoreTags = {
        head: true,
        noscript: true,
        object: true,
        script: true,
        style: true,
        title: true
    };
    const $f043ae92c0a873f0$var$listTags = {
        ol: true,
        ul: true
    };
    const $f043ae92c0a873f0$var$OPT_PRESERVE_WS = 1, $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL = 2, $f043ae92c0a873f0$var$OPT_OPEN_LEFT = 4;
    function $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWhitespace, base) {
        if (preserveWhitespace != null) return (preserveWhitespace ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : 0);
        return type && type.whitespace == "pre" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS | $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : base & ~$f043ae92c0a873f0$var$OPT_OPEN_LEFT;
    }
    class $f043ae92c0a873f0$var$NodeContext {
        constructor(type, attrs, marks, solid, match, options){
            this.type = type;
            this.attrs = attrs;
            this.marks = marks;
            this.solid = solid;
            this.options = options;
            this.content = [];
            this.activeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            this.match = match || (options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT ? null : type.contentMatch);
        }
        findWrapping(node) {
            if (!this.match) {
                if (!this.type) return [];
                let fill = this.type.contentMatch.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
                if (fill) this.match = this.type.contentMatch.matchFragment(fill);
                else {
                    let start = this.type.contentMatch, wrap;
                    if (wrap = start.findWrapping(node.type)) {
                        this.match = start;
                        return wrap;
                    } else return null;
                }
            }
            return this.match.findWrapping(node.type);
        }
        finish(openEnd) {
            if (!(this.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
                let last = this.content[this.content.length - 1], m;
                if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                    let text = last;
                    if (last.text.length == m[0].length) this.content.pop();
                    else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
                }
            }
            let content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(this.content);
            if (!openEnd && this.match) content = content.append(this.match.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true));
            return this.type ? this.type.create(this.attrs, content, this.marks) : content;
        }
        inlineContext(node) {
            if (this.type) return this.type.inlineContent;
            if (this.content.length) return this.content[0].isInline;
            return node.parentNode && !$f043ae92c0a873f0$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
        }
    }
    class $f043ae92c0a873f0$var$ParseContext {
        constructor(parser, options, isOpen){
            this.parser = parser;
            this.options = options;
            this.isOpen = isOpen;
            this.open = 0;
            let topNode = options.topNode, topContext;
            let topOptions = $f043ae92c0a873f0$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $f043ae92c0a873f0$var$OPT_OPEN_LEFT : 0);
            if (topNode) topContext = new $f043ae92c0a873f0$var$NodeContext(topNode.type, topNode.attrs, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
            else if (isOpen) topContext = new $f043ae92c0a873f0$var$NodeContext(null, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
            else topContext = new $f043ae92c0a873f0$var$NodeContext(parser.schema.topNodeType, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
            this.nodes = [
                topContext
            ];
            this.find = options.findPositions;
            this.needsBlock = false;
        }
        get top() {
            return this.nodes[this.open];
        }
        addDOM(dom, marks) {
            if (dom.nodeType == 3) this.addTextNode(dom, marks);
            else if (dom.nodeType == 1) this.addElement(dom, marks);
        }
        addTextNode(dom, marks) {
            let value = dom.nodeValue;
            let top = this.top;
            if (top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
                if (!(top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
                    value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                    if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                        let nodeBefore = top.content[top.content.length - 1];
                        let domNodeBefore = dom.previousSibling;
                        if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                    }
                } else if (!(top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL)) value = value.replace(/\r?\n|\r/g, " ");
                else value = value.replace(/\r\n?/g, "\n");
                if (value) this.insertNode(this.parser.schema.text(value), marks);
                this.findInText(dom);
            } else this.findInside(dom);
        }
        addElement(dom, marks, matchAfter) {
            let name = dom.nodeName.toLowerCase(), ruleID;
            if ($f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $f043ae92c0a873f0$var$normalizeList(dom);
            let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
            if (rule ? rule.ignore : $f043ae92c0a873f0$var$ignoreTags.hasOwnProperty(name)) {
                this.findInside(dom);
                this.ignoreFallback(dom, marks);
            } else if (!rule || rule.skip || rule.closeParent) {
                if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
                else if (rule && rule.skip.nodeType) dom = rule.skip;
                let sync, top = this.top, oldNeedsBlock = this.needsBlock;
                if ($f043ae92c0a873f0$var$blockTags.hasOwnProperty(name)) {
                    if (top.content.length && top.content[0].isInline && this.open) {
                        this.open--;
                        top = this.top;
                    }
                    sync = true;
                    if (!top.type) this.needsBlock = true;
                } else if (!dom.firstChild) {
                    this.leafFallback(dom, marks);
                    return;
                }
                let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
                if (innerMarks) this.addAll(dom, innerMarks);
                if (sync) this.sync(top);
                this.needsBlock = oldNeedsBlock;
            } else {
                let innerMarks = this.readStyles(dom, marks);
                if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
            }
        }
        leafFallback(dom, marks) {
            if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
        }
        ignoreFallback(dom, marks) {
            if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
        }
        readStyles(dom, marks) {
            let styles = dom.style;
            if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
                let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
                if (value) for(let after = undefined;;){
                    let rule = this.parser.matchStyle(name, value, this, after);
                    if (!rule) break;
                    if (rule.ignore) return null;
                    if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                    else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                    if (rule.consuming === false) after = rule;
                    else break;
                }
            }
            return marks;
        }
        addElementByRule(dom, rule, marks, continueAfter) {
            let sync, nodeType;
            if (rule.node) {
                nodeType = this.parser.schema.nodes[rule.node];
                if (!nodeType.isLeaf) {
                    let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                    if (inner) {
                        sync = true;
                        marks = inner;
                    }
                } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
            } else {
                let markType = this.parser.schema.marks[rule.mark];
                marks = marks.concat(markType.create(rule.attrs));
            }
            let startIn = this.top;
            if (nodeType && nodeType.isLeaf) this.findInside(dom);
            else if (continueAfter) this.addElement(dom, marks, continueAfter);
            else if (rule.getContent) {
                this.findInside(dom);
                rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
            } else {
                let contentDOM = dom;
                if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
                else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
                else if (rule.contentElement) contentDOM = rule.contentElement;
                this.findAround(dom, contentDOM, true);
                this.addAll(contentDOM, marks);
            }
            if (sync && this.sync(startIn)) this.open--;
        }
        addAll(parent, marks, startIndex, endIndex) {
            let index = startIndex || 0;
            for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
                this.findAtPoint(parent, index);
                this.addDOM(dom, marks);
            }
            this.findAtPoint(parent, index);
        }
        findPlace(node, marks) {
            let route, sync;
            for(let depth = this.open; depth >= 0; depth--){
                let cx = this.nodes[depth];
                let found = cx.findWrapping(node);
                if (found && (!route || route.length > found.length)) {
                    route = found;
                    sync = cx;
                    if (!found.length) break;
                }
                if (cx.solid) break;
            }
            if (!route) return null;
            this.sync(sync);
            for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
            return marks;
        }
        insertNode(node, marks) {
            if (node.isInline && this.needsBlock && !this.top.type) {
                let block = this.textblockFromContext();
                if (block) marks = this.enterInner(block, null, marks);
            }
            let innerMarks = this.findPlace(node, marks);
            if (innerMarks) {
                this.closeExtra();
                let top = this.top;
                if (top.match) top.match = top.match.matchType(node.type);
                let nodeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
                for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
                top.content.push(node.mark(nodeMarks));
                return true;
            }
            return false;
        }
        enter(type, attrs, marks, preserveWS) {
            let innerMarks = this.findPlace(type.create(attrs), marks);
            if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
            return innerMarks;
        }
        enterInner(type, attrs, marks, solid = false, preserveWS) {
            this.closeExtra();
            let top = this.top;
            top.match = top.match && top.match.matchType(type);
            let options = $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWS, top.options);
            if (top.options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $f043ae92c0a873f0$var$OPT_OPEN_LEFT;
            let applyMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            marks = marks.filter((m)=>{
                if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, type)) {
                    applyMarks = m.addToSet(applyMarks);
                    return false;
                }
                return true;
            });
            this.nodes.push(new $f043ae92c0a873f0$var$NodeContext(type, attrs, applyMarks, solid, null, options));
            this.open++;
            return marks;
        }
        closeExtra(openEnd = false) {
            let i = this.nodes.length - 1;
            if (i > this.open) {
                for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
                this.nodes.length = this.open + 1;
            }
        }
        finish() {
            this.open = 0;
            this.closeExtra(this.isOpen);
            return this.nodes[0].finish(this.isOpen || this.options.topOpen);
        }
        sync(to) {
            for(let i = this.open; i >= 0; i--)if (this.nodes[i] == to) {
                this.open = i;
                return true;
            }
            return false;
        }
        get currentPos() {
            this.closeExtra();
            let pos = 0;
            for(let i = this.open; i >= 0; i--){
                let content = this.nodes[i].content;
                for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
                if (i) pos++;
            }
            return pos;
        }
        findAtPoint(parent, offset) {
            if (this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
            }
        }
        findInside(parent) {
            if (this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
            }
        }
        findAround(parent, content, before) {
            if (parent != content && this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                    let pos = content.compareDocumentPosition(this.find[i].node);
                    if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
                }
            }
        }
        findInText(textNode) {
            if (this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
            }
        }
        matchesContext(context) {
            if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
            let parts = context.split("/");
            let option = this.options.context;
            let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
            let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
            let match = (i, depth)=>{
                for(; i >= 0; i--){
                    let part = parts[i];
                    if (part == "") {
                        if (i == parts.length - 1 || i == 0) continue;
                        for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                        return false;
                    } else {
                        let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                        if (!next || next.name != part && next.groups.indexOf(part) == -1) return false;
                        depth--;
                    }
                }
                return true;
            };
            return match(parts.length - 1, this.open);
        }
        textblockFromContext() {
            let $context = this.options.context;
            if ($context) for(let d = $context.depth; d >= 0; d--){
                let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
                if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
            }
            for(let name in this.parser.schema.nodes){
                let type = this.parser.schema.nodes[name];
                if (type.isTextblock && type.defaultAttrs) return type;
            }
        }
    }
    function $f043ae92c0a873f0$var$normalizeList(dom) {
        for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
            let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
            if (name && $f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && prevItem) {
                prevItem.appendChild(child);
                child = prevItem;
            } else if (name == "li") prevItem = child;
            else if (name) prevItem = null;
        }
    }
    function $f043ae92c0a873f0$var$matches(dom, selector) {
        return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
    }
    function $f043ae92c0a873f0$var$copy(obj) {
        let copy = {};
        for(let prop in obj)copy[prop] = obj[prop];
        return copy;
    }
    function $f043ae92c0a873f0$var$markMayApply(markType, nodeType) {
        let nodes = nodeType.schema.nodes;
        for(let name in nodes){
            let parent = nodes[name];
            if (!parent.allowsMarkType(markType)) continue;
            let seen = [], scan = (match)=>{
                seen.push(match);
                for(let i = 0; i < match.edgeCount; i++){
                    let { type: type, next: next } = match.edge(i);
                    if (type == nodeType) return true;
                    if (seen.indexOf(next) < 0 && scan(next)) return true;
                }
            };
            if (scan(parent.contentMatch)) return true;
        }
    }
    class $f043ae92c0a873f0$export$3476b78f8f5a8b72 {
        constructor(nodes, marks){
            this.nodes = nodes;
            this.marks = marks;
        }
        serializeFragment(fragment, options = {}, target) {
            if (!target) target = $f043ae92c0a873f0$var$doc(options).createDocumentFragment();
            let top = target, active = [];
            fragment.forEach((node)=>{
                if (active.length || node.marks.length) {
                    let keep = 0, rendered = 0;
                    while(keep < active.length && rendered < node.marks.length){
                        let next = node.marks[rendered];
                        if (!this.marks[next.type.name]) {
                            rendered++;
                            continue;
                        }
                        if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                        keep++;
                        rendered++;
                    }
                    while(keep < active.length)top = active.pop()[1];
                    while(rendered < node.marks.length){
                        let add = node.marks[rendered++];
                        let markDOM = this.serializeMark(add, node.isInline, options);
                        if (markDOM) {
                            active.push([
                                add,
                                top
                            ]);
                            top.appendChild(markDOM.dom);
                            top = markDOM.contentDOM || markDOM.dom;
                        }
                    }
                }
                top.appendChild(this.serializeNodeInner(node, options));
            });
            return target;
        }
        serializeNodeInner(node, options) {
            let { dom: dom, contentDOM: contentDOM } = $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
            if (contentDOM) {
                if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
                this.serializeFragment(node.content, options, contentDOM);
            }
            return dom;
        }
        serializeNode(node, options = {}) {
            let dom = this.serializeNodeInner(node, options);
            for(let i = node.marks.length - 1; i >= 0; i--){
                let wrap = this.serializeMark(node.marks[i], node.isInline, options);
                if (wrap) {
                    (wrap.contentDOM || wrap.dom).appendChild(dom);
                    dom = wrap.dom;
                }
            }
            return dom;
        }
        serializeMark(mark, inline, options = {}) {
            let toDOM = this.marks[mark.type.name];
            return toDOM && $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), toDOM(mark, inline), null, mark.attrs);
        }
        static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
            return $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
        }
        static fromSchema(schema) {
            return schema.cached.domSerializer || (schema.cached.domSerializer = new $f043ae92c0a873f0$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
        }
        static nodesFromSchema(schema) {
            let result = $f043ae92c0a873f0$var$gatherToDOM(schema.nodes);
            if (!result.text) result.text = (node)=>node.text;
            return result;
        }
        static marksFromSchema(schema) {
            return $f043ae92c0a873f0$var$gatherToDOM(schema.marks);
        }
    }
    function $f043ae92c0a873f0$var$gatherToDOM(obj) {
        let result = {};
        for(let name in obj){
            let toDOM = obj[name].spec.toDOM;
            if (toDOM) result[name] = toDOM;
        }
        return result;
    }
    function $f043ae92c0a873f0$var$doc(options) {
        return options.document || window.document;
    }
    const $f043ae92c0a873f0$var$suspiciousAttributeCache = new WeakMap();
    function $f043ae92c0a873f0$var$suspiciousAttributes(attrs) {
        let value = $f043ae92c0a873f0$var$suspiciousAttributeCache.get(attrs);
        if (value === undefined) $f043ae92c0a873f0$var$suspiciousAttributeCache.set(attrs, value = $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs));
        return value;
    }
    function $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs) {
        let result = null;
        function scan(value) {
            if (value && typeof value == "object") {
                if (Array.isArray(value)) {
                    if (typeof value[0] == "string") {
                        if (!result) result = [];
                        result.push(value);
                    } else for(let i = 0; i < value.length; i++)scan(value[i]);
                } else for(let prop in value)scan(value[prop]);
            }
        }
        scan(attrs);
        return result;
    }
    function $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
        if (typeof structure == "string") return {
            dom: doc.createTextNode(structure)
        };
        if (structure.nodeType != null) return {
            dom: structure
        };
        if (structure.dom && structure.dom.nodeType != null) return structure;
        let tagName = structure[0], suspicious;
        if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
        if (blockArraysIn && (suspicious = $f043ae92c0a873f0$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
        let space = tagName.indexOf(" ");
        if (space > 0) {
            xmlNS = tagName.slice(0, space);
            tagName = tagName.slice(space + 1);
        }
        let contentDOM;
        let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
        let attrs = structure[1], start = 1;
        if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
            start = 2;
            for(let name in attrs)if (attrs[name] != null) {
                let space = name.indexOf(" ");
                if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
                else dom.setAttribute(name, attrs[name]);
            }
        }
        for(let i = start; i < structure.length; i++){
            let child = structure[i];
            if (child === 0) {
                if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
                return {
                    dom: dom,
                    contentDOM: dom
                };
            } else {
                let { dom: inner, contentDOM: innerContent } = $f043ae92c0a873f0$var$renderSpec(doc, child, xmlNS, blockArraysIn);
                dom.appendChild(inner);
                if (innerContent) {
                    if (contentDOM) throw new RangeError("Multiple content holes");
                    contentDOM = innerContent;
                }
            }
        }
        return {
            dom: dom,
            contentDOM: contentDOM
        };
    }
});
parcelRegister("dHeNB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f8ac547b0b2e1f8$export$2e2bcd8739ae039);
    function $9f8ac547b0b2e1f8$var$OrderedMap(content) {
        this.content = content;
    }
    $9f8ac547b0b2e1f8$var$OrderedMap.prototype = {
        constructor: $9f8ac547b0b2e1f8$var$OrderedMap,
        find: function(key) {
            for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
            return -1;
        },
        get: function(key) {
            var found = this.find(key);
            return found == -1 ? undefined : this.content[found + 1];
        },
        update: function(key, value, newKey) {
            var self = newKey && newKey != key ? this.remove(newKey) : this;
            var found = self.find(key), content = self.content.slice();
            if (found == -1) content.push(newKey || key, value);
            else {
                content[found + 1] = value;
                if (newKey) content[found] = newKey;
            }
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        remove: function(key) {
            var found = this.find(key);
            if (found == -1) return this;
            var content = this.content.slice();
            content.splice(found, 2);
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        addToStart: function(key, value) {
            return new $9f8ac547b0b2e1f8$var$OrderedMap([
                key,
                value
            ].concat(this.remove(key).content));
        },
        addToEnd: function(key, value) {
            var content = this.remove(key).content.slice();
            content.push(key, value);
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        addBefore: function(place, key, value) {
            var without = this.remove(key), content = without.content.slice();
            var found = without.find(place);
            content.splice(found == -1 ? content.length : found, 0, key, value);
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        forEach: function(f) {
            for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
        },
        prepend: function(map) {
            map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
            if (!map.size) return this;
            return new $9f8ac547b0b2e1f8$var$OrderedMap(map.content.concat(this.subtract(map).content));
        },
        append: function(map) {
            map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
            if (!map.size) return this;
            return new $9f8ac547b0b2e1f8$var$OrderedMap(this.subtract(map).content.concat(map.content));
        },
        subtract: function(map) {
            var result = this;
            map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
            for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
            return result;
        },
        toObject: function() {
            var result = {};
            this.forEach(function(key, value) {
                result[key] = value;
            });
            return result;
        },
        get size () {
            return this.content.length >> 1;
        }
    };
    $9f8ac547b0b2e1f8$var$OrderedMap.from = function(value) {
        if (value instanceof $9f8ac547b0b2e1f8$var$OrderedMap) return value;
        var content = [];
        if (value) for(var prop in value)content.push(prop, value[prop]);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    };
    var $9f8ac547b0b2e1f8$export$2e2bcd8739ae039 = $9f8ac547b0b2e1f8$var$OrderedMap;
});
parcelRegister("eS2Dn", function(module, exports) {
    $parcel$export(module.exports, "StepMap", ()=>$ad3826e817ebec37$export$c53d01c3ab9721b3);
    $parcel$export(module.exports, "Mapping", ()=>$ad3826e817ebec37$export$f5f785078011b62);
    $parcel$export(module.exports, "Step", ()=>$ad3826e817ebec37$export$fd55ce593607084a);
    $parcel$export(module.exports, "StepResult", ()=>$ad3826e817ebec37$export$8ebf1578a4199c09);
    $parcel$export(module.exports, "AddMarkStep", ()=>$ad3826e817ebec37$export$d24ba56b0e3464a9);
    $parcel$export(module.exports, "RemoveMarkStep", ()=>$ad3826e817ebec37$export$94150db1311f67a9);
    $parcel$export(module.exports, "AddNodeMarkStep", ()=>$ad3826e817ebec37$export$adefd16c402fee4e);
    $parcel$export(module.exports, "RemoveNodeMarkStep", ()=>$ad3826e817ebec37$export$fdf7d1dc10724da2);
    $parcel$export(module.exports, "ReplaceStep", ()=>$ad3826e817ebec37$export$5c860b2e74034756);
    $parcel$export(module.exports, "ReplaceAroundStep", ()=>$ad3826e817ebec37$export$444ba800d6024a98);
    $parcel$export(module.exports, "liftTarget", ()=>$ad3826e817ebec37$export$f1508b72cc76a09e);
    $parcel$export(module.exports, "findWrapping", ()=>$ad3826e817ebec37$export$118cb9a83e81ba37);
    $parcel$export(module.exports, "canSplit", ()=>$ad3826e817ebec37$export$5aaf008897aef029);
    $parcel$export(module.exports, "canJoin", ()=>$ad3826e817ebec37$export$f15f89fd9d8cc98a);
    $parcel$export(module.exports, "joinPoint", ()=>$ad3826e817ebec37$export$41b1d4cb5ceb3147);
    $parcel$export(module.exports, "insertPoint", ()=>$ad3826e817ebec37$export$64cb316d02de1dd1);
    $parcel$export(module.exports, "dropPoint", ()=>$ad3826e817ebec37$export$2819d598d048fc9c);
    $parcel$export(module.exports, "replaceStep", ()=>$ad3826e817ebec37$export$ed6ac67359824afd);
    $parcel$export(module.exports, "AttrStep", ()=>$ad3826e817ebec37$export$626399c38172f669);
    $parcel$export(module.exports, "DocAttrStep", ()=>$ad3826e817ebec37$export$f50707b396300ac9);
    $parcel$export(module.exports, "Transform", ()=>$ad3826e817ebec37$export$563a914cafbdc389);
    var $kCV8T;
    const $ad3826e817ebec37$var$lower16 = 0xffff;
    const $ad3826e817ebec37$var$factor16 = Math.pow(2, 16);
    function $ad3826e817ebec37$var$makeRecover(index, offset) {
        return index + offset * $ad3826e817ebec37$var$factor16;
    }
    function $ad3826e817ebec37$var$recoverIndex(value) {
        return value & $ad3826e817ebec37$var$lower16;
    }
    function $ad3826e817ebec37$var$recoverOffset(value) {
        return (value - (value & $ad3826e817ebec37$var$lower16)) / $ad3826e817ebec37$var$factor16;
    }
    const $ad3826e817ebec37$var$DEL_BEFORE = 1, $ad3826e817ebec37$var$DEL_AFTER = 2, $ad3826e817ebec37$var$DEL_ACROSS = 4, $ad3826e817ebec37$var$DEL_SIDE = 8;
    class $ad3826e817ebec37$export$c77c9be41668e9b4 {
        constructor(pos, delInfo, recover){
            this.pos = pos;
            this.delInfo = delInfo;
            this.recover = recover;
        }
        get deleted() {
            return (this.delInfo & $ad3826e817ebec37$var$DEL_SIDE) > 0;
        }
        get deletedBefore() {
            return (this.delInfo & ($ad3826e817ebec37$var$DEL_BEFORE | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
        }
        get deletedAfter() {
            return (this.delInfo & ($ad3826e817ebec37$var$DEL_AFTER | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
        }
        get deletedAcross() {
            return (this.delInfo & $ad3826e817ebec37$var$DEL_ACROSS) > 0;
        }
    }
    class $ad3826e817ebec37$export$c53d01c3ab9721b3 {
        constructor(ranges, inverted = false){
            this.ranges = ranges;
            this.inverted = inverted;
            if (!ranges.length && $ad3826e817ebec37$export$c53d01c3ab9721b3.empty) return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        recover(value) {
            let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(value);
            if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
            return this.ranges[index * 3] + diff + $ad3826e817ebec37$var$recoverOffset(value);
        }
        mapResult(pos, assoc = 1) {
            return this._map(pos, assoc, false);
        }
        map(pos, assoc = 1) {
            return this._map(pos, assoc, true);
        }
        _map(pos, assoc, simple) {
            let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
            for(let i = 0; i < this.ranges.length; i += 3){
                let start = this.ranges[i] - (this.inverted ? diff : 0);
                if (start > pos) break;
                let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
                if (pos <= end) {
                    let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                    let result = start + diff + (side < 0 ? 0 : newSize);
                    if (simple) return result;
                    let recover = pos == (assoc < 0 ? start : end) ? null : $ad3826e817ebec37$var$makeRecover(i / 3, pos - start);
                    let del = pos == start ? $ad3826e817ebec37$var$DEL_AFTER : pos == end ? $ad3826e817ebec37$var$DEL_BEFORE : $ad3826e817ebec37$var$DEL_ACROSS;
                    if (assoc < 0 ? pos != start : pos != end) del |= $ad3826e817ebec37$var$DEL_SIDE;
                    return new $ad3826e817ebec37$export$c77c9be41668e9b4(result, del, recover);
                }
                diff += newSize - oldSize;
            }
            return simple ? pos + diff : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos + diff, 0, null);
        }
        touches(pos, recover) {
            let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(recover);
            let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
            for(let i = 0; i < this.ranges.length; i += 3){
                let start = this.ranges[i] - (this.inverted ? diff : 0);
                if (start > pos) break;
                let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
                if (pos <= end && i == index * 3) return true;
                diff += this.ranges[i + newIndex] - oldSize;
            }
            return false;
        }
        forEach(f) {
            let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
            for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
                let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
                let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
                f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
                diff += newSize - oldSize;
            }
        }
        invert() {
            return new $ad3826e817ebec37$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
        }
        toString() {
            return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
        }
        static offset(n) {
            return n == 0 ? $ad3826e817ebec37$export$c53d01c3ab9721b3.empty : new $ad3826e817ebec37$export$c53d01c3ab9721b3(n < 0 ? [
                0,
                -n,
                0
            ] : [
                0,
                0,
                n
            ]);
        }
    }
    $ad3826e817ebec37$export$c53d01c3ab9721b3.empty = new $ad3826e817ebec37$export$c53d01c3ab9721b3([]);
    class $ad3826e817ebec37$export$f5f785078011b62 {
        constructor(maps = [], mirror, from = 0, to = maps.length){
            this.maps = maps;
            this.mirror = mirror;
            this.from = from;
            this.to = to;
        }
        slice(from = 0, to = this.maps.length) {
            return new $ad3826e817ebec37$export$f5f785078011b62(this.maps, this.mirror, from, to);
        }
        copy() {
            return new $ad3826e817ebec37$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
        }
        appendMap(map, mirrors) {
            this.to = this.maps.push(map);
            if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
        }
        appendMapping(mapping) {
            for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
                let mirr = mapping.getMirror(i);
                this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
            }
        }
        getMirror(n) {
            if (this.mirror) {
                for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
            }
        }
        setMirror(n, m) {
            if (!this.mirror) this.mirror = [];
            this.mirror.push(n, m);
        }
        appendMappingInverted(mapping) {
            for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
                let mirr = mapping.getMirror(i);
                this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
            }
        }
        invert() {
            let inverse = new $ad3826e817ebec37$export$f5f785078011b62;
            inverse.appendMappingInverted(this);
            return inverse;
        }
        map(pos, assoc = 1) {
            if (this.mirror) return this._map(pos, assoc, true);
            for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
            return pos;
        }
        mapResult(pos, assoc = 1) {
            return this._map(pos, assoc, false);
        }
        _map(pos, assoc, simple) {
            let delInfo = 0;
            for(let i = this.from; i < this.to; i++){
                let map = this.maps[i], result = map.mapResult(pos, assoc);
                if (result.recover != null) {
                    let corr = this.getMirror(i);
                    if (corr != null && corr > i && corr < this.to) {
                        i = corr;
                        pos = this.maps[corr].recover(result.recover);
                        continue;
                    }
                }
                delInfo |= result.delInfo;
                pos = result.pos;
            }
            return simple ? pos : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos, delInfo, null);
        }
    }
    const $ad3826e817ebec37$var$stepsByID = Object.create(null);
    class $ad3826e817ebec37$export$fd55ce593607084a {
        getMap() {
            return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        merge(other) {
            return null;
        }
        static fromJSON(schema, json) {
            if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
            let type = $ad3826e817ebec37$var$stepsByID[json.stepType];
            if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
            return type.fromJSON(schema, json);
        }
        static jsonID(id, stepClass) {
            if (id in $ad3826e817ebec37$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
            $ad3826e817ebec37$var$stepsByID[id] = stepClass;
            stepClass.prototype.jsonID = id;
            return stepClass;
        }
    }
    class $ad3826e817ebec37$export$8ebf1578a4199c09 {
        constructor(doc, failed){
            this.doc = doc;
            this.failed = failed;
        }
        static ok(doc) {
            return new $ad3826e817ebec37$export$8ebf1578a4199c09(doc, null);
        }
        static fail(message) {
            return new $ad3826e817ebec37$export$8ebf1578a4199c09(null, message);
        }
        static fromReplace(doc, from, to, slice) {
            try {
                return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
            } catch (e) {
                if (e instanceof (0, (0, parcelRequire("kCV8T")).ReplaceError)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail(e.message);
                throw e;
            }
        }
    }
    function $ad3826e817ebec37$var$mapFragment(fragment, f, parent) {
        let mapped = [];
        for(let i = 0; i < fragment.childCount; i++){
            let child = fragment.child(i);
            if (child.content.size) child = child.copy($ad3826e817ebec37$var$mapFragment(child.content, f, child));
            if (child.isInline) child = f(child, parent, i);
            mapped.push(child);
        }
        return (0, (0, parcelRequire("kCV8T")).Fragment).fromArray(mapped);
    }
    class $ad3826e817ebec37$export$d24ba56b0e3464a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, mark){
            super();
            this.from = from;
            this.to = to;
            this.mark = mark;
        }
        apply(doc) {
            let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
            let parent = $from.node($from.sharedDepth(this.to));
            let slice = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node, parent)=>{
                if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
                return node.mark(this.mark.addToSet(node.marks));
            }, parent), oldSlice.openStart, oldSlice.openEnd);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
        }
        invert() {
            return new $ad3826e817ebec37$export$94150db1311f67a9(this.from, this.to, this.mark);
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            if (from.deleted && to.deleted || from.pos >= to.pos) return null;
            return new $ad3826e817ebec37$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
        }
        merge(other) {
            if (other instanceof $ad3826e817ebec37$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
            return null;
        }
        toJSON() {
            return {
                stepType: "addMark",
                mark: this.mark.toJSON(),
                from: this.from,
                to: this.to
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("addMark", $ad3826e817ebec37$export$d24ba56b0e3464a9);
    class $ad3826e817ebec37$export$94150db1311f67a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, mark){
            super();
            this.from = from;
            this.to = to;
            this.mark = mark;
        }
        apply(doc) {
            let oldSlice = doc.slice(this.from, this.to);
            let slice = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node)=>{
                return node.mark(this.mark.removeFromSet(node.marks));
            }, doc), oldSlice.openStart, oldSlice.openEnd);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
        }
        invert() {
            return new $ad3826e817ebec37$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            if (from.deleted && to.deleted || from.pos >= to.pos) return null;
            return new $ad3826e817ebec37$export$94150db1311f67a9(from.pos, to.pos, this.mark);
        }
        merge(other) {
            if (other instanceof $ad3826e817ebec37$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
            return null;
        }
        toJSON() {
            return {
                stepType: "removeMark",
                mark: this.mark.toJSON(),
                from: this.from,
                to: this.to
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeMark", $ad3826e817ebec37$export$94150db1311f67a9);
    class $ad3826e817ebec37$export$adefd16c402fee4e extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(pos, mark){
            super();
            this.pos = pos;
            this.mark = mark;
        }
        apply(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
            let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
        }
        invert(doc) {
            let node = doc.nodeAt(this.pos);
            if (node) {
                let newSet = this.mark.addToSet(node.marks);
                if (newSet.length == node.marks.length) {
                    for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, node.marks[i]);
                    return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
                }
            }
            return new $ad3826e817ebec37$export$fdf7d1dc10724da2(this.pos, this.mark);
        }
        map(mapping) {
            let pos = mapping.mapResult(this.pos, 1);
            return pos.deletedAfter ? null : new $ad3826e817ebec37$export$adefd16c402fee4e(pos.pos, this.mark);
        }
        toJSON() {
            return {
                stepType: "addNodeMark",
                pos: this.pos,
                mark: this.mark.toJSON()
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("addNodeMark", $ad3826e817ebec37$export$adefd16c402fee4e);
    class $ad3826e817ebec37$export$fdf7d1dc10724da2 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(pos, mark){
            super();
            this.pos = pos;
            this.mark = mark;
        }
        apply(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
            let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
        }
        invert(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node || !this.mark.isInSet(node.marks)) return this;
            return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
        }
        map(mapping) {
            let pos = mapping.mapResult(this.pos, 1);
            return pos.deletedAfter ? null : new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos.pos, this.mark);
        }
        toJSON() {
            return {
                stepType: "removeNodeMark",
                pos: this.pos,
                mark: this.mark.toJSON()
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeNodeMark", $ad3826e817ebec37$export$fdf7d1dc10724da2);
    class $ad3826e817ebec37$export$5c860b2e74034756 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, slice, structure = false){
            super();
            this.from = from;
            this.to = to;
            this.slice = slice;
            this.structure = structure;
        }
        apply(doc) {
            if (this.structure && $ad3826e817ebec37$var$contentBetween(doc, this.from, this.to)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
        }
        getMap() {
            return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
                this.from,
                this.to - this.from,
                this.slice.size
            ]);
        }
        invert(doc) {
            return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            if (from.deletedAcross && to.deletedAcross) return null;
            return new $ad3826e817ebec37$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
        }
        merge(other) {
            if (!(other instanceof $ad3826e817ebec37$export$5c860b2e74034756) || other.structure || this.structure) return null;
            if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
                let slice = this.slice.size + other.slice.size == 0 ? (0, (0, parcelRequire("kCV8T")).Slice).empty : new (0, (0, parcelRequire("kCV8T")).Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
                return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
            } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
                let slice = this.slice.size + other.slice.size == 0 ? (0, (0, parcelRequire("kCV8T")).Slice).empty : new (0, (0, parcelRequire("kCV8T")).Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
                return new $ad3826e817ebec37$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
            } else return null;
        }
        toJSON() {
            let json = {
                stepType: "replace",
                from: this.from,
                to: this.to
            };
            if (this.slice.size) json.slice = this.slice.toJSON();
            if (this.structure) json.structure = true;
            return json;
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
            return new $ad3826e817ebec37$export$5c860b2e74034756(json.from, json.to, (0, (0, parcelRequire("kCV8T")).Slice).fromJSON(schema, json.slice), !!json.structure);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("replace", $ad3826e817ebec37$export$5c860b2e74034756);
    class $ad3826e817ebec37$export$444ba800d6024a98 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, gapFrom, gapTo, slice, insert, structure = false){
            super();
            this.from = from;
            this.to = to;
            this.gapFrom = gapFrom;
            this.gapTo = gapTo;
            this.slice = slice;
            this.insert = insert;
            this.structure = structure;
        }
        apply(doc) {
            if (this.structure && ($ad3826e817ebec37$var$contentBetween(doc, this.from, this.gapFrom) || $ad3826e817ebec37$var$contentBetween(doc, this.gapTo, this.to))) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
            let gap = doc.slice(this.gapFrom, this.gapTo);
            if (gap.openStart || gap.openEnd) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Gap is not a flat range");
            let inserted = this.slice.insertAt(this.insert, gap.content);
            if (!inserted) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Content does not fit in gap");
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
        }
        getMap() {
            return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
                this.from,
                this.gapFrom - this.from,
                this.insert,
                this.gapTo,
                this.to - this.gapTo,
                this.slice.size - this.insert
            ]);
        }
        invert(doc) {
            let gap = this.gapTo - this.gapFrom;
            return new $ad3826e817ebec37$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
            let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
            if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
            return new $ad3826e817ebec37$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
        }
        toJSON() {
            let json = {
                stepType: "replaceAround",
                from: this.from,
                to: this.to,
                gapFrom: this.gapFrom,
                gapTo: this.gapTo,
                insert: this.insert
            };
            if (this.slice.size) json.slice = this.slice.toJSON();
            if (this.structure) json.structure = true;
            return json;
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
            return new $ad3826e817ebec37$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, (0, parcelRequire("kCV8T")).Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("replaceAround", $ad3826e817ebec37$export$444ba800d6024a98);
    function $ad3826e817ebec37$var$contentBetween(doc, from, to) {
        let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
        while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
            depth--;
            dist--;
        }
        if (dist > 0) {
            let next = $from.node(depth).maybeChild($from.indexAfter(depth));
            while(dist > 0){
                if (!next || next.isLeaf) return true;
                next = next.firstChild;
                dist--;
            }
        }
        return false;
    }
    function $ad3826e817ebec37$var$addMark(tr, from, to, mark) {
        let removed = [], added = [];
        let removing, adding;
        tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.isInline) return;
            let marks = node.marks;
            if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
                let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
                let newSet = mark.addToSet(marks);
                for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                    if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                    else removed.push(removing = new $ad3826e817ebec37$export$94150db1311f67a9(start, end, marks[i]));
                }
                if (adding && adding.to == start) adding.to = end;
                else added.push(adding = new $ad3826e817ebec37$export$d24ba56b0e3464a9(start, end, mark));
            }
        });
        removed.forEach((s)=>tr.step(s));
        added.forEach((s)=>tr.step(s));
    }
    function $ad3826e817ebec37$var$removeMark(tr, from, to, mark) {
        let matched = [], step = 0;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            if (!node.isInline) return;
            step++;
            let toRemove = null;
            if (mark instanceof (0, (0, parcelRequire("kCV8T")).MarkType)) {
                let set = node.marks, found;
                while(found = mark.isInSet(set)){
                    (toRemove || (toRemove = [])).push(found);
                    set = found.removeFromSet(set);
                }
            } else if (mark) {
                if (mark.isInSet(node.marks)) toRemove = [
                    mark
                ];
            } else toRemove = node.marks;
            if (toRemove && toRemove.length) {
                let end = Math.min(pos + node.nodeSize, to);
                for(let i = 0; i < toRemove.length; i++){
                    let style = toRemove[i], found;
                    for(let j = 0; j < matched.length; j++){
                        let m = matched[j];
                        if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                    }
                    if (found) {
                        found.to = end;
                        found.step = step;
                    } else matched.push({
                        style: style,
                        from: Math.max(pos, from),
                        to: end,
                        step: step
                    });
                }
            }
        });
        matched.forEach((m)=>tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(m.from, m.to, m.style)));
    }
    function $ad3826e817ebec37$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
        let node = tr.doc.nodeAt(pos);
        let replSteps = [], cur = pos + 1;
        for(let i = 0; i < node.childCount; i++){
            let child = node.child(i), end = cur + child.nodeSize;
            let allowed = match.matchType(child.type);
            if (!allowed) replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur, end, (0, (0, parcelRequire("kCV8T")).Slice).empty));
            else {
                match = allowed;
                for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(cur, end, child.marks[j]));
                if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                    let m, newline = /\r?\n|\r/g, slice;
                    while(m = newline.exec(child.text)){
                        if (!slice) slice = new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                        replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                    }
                }
            }
            cur = end;
        }
        if (!match.validEnd) {
            let fill = match.fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true);
            tr.replace(cur, cur, new (0, (0, parcelRequire("kCV8T")).Slice)(fill, 0, 0));
        }
        for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
    }
    function $ad3826e817ebec37$var$canCut(node, start, end) {
        return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
    }
    function $ad3826e817ebec37$export$f1508b72cc76a09e(range) {
        let parent = range.parent;
        let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
        for(let depth = range.depth;; --depth){
            let node = range.$from.node(depth);
            let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
            if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
            if (depth == 0 || node.type.spec.isolating || !$ad3826e817ebec37$var$canCut(node, index, endIndex)) break;
        }
        return null;
    }
    function $ad3826e817ebec37$var$lift(tr, range, target) {
        let { $from: $from, $to: $to, depth: depth } = range;
        let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
        let start = gapStart, end = gapEnd;
        let before = (0, (0, parcelRequire("kCV8T")).Fragment).empty, openStart = 0;
        for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
            splitting = true;
            before = (0, (0, parcelRequire("kCV8T")).Fragment).from($from.node(d).copy(before));
            openStart++;
        } else start--;
        let after = (0, (0, parcelRequire("kCV8T")).Fragment).empty, openEnd = 0;
        for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
            splitting = true;
            after = (0, (0, parcelRequire("kCV8T")).Fragment).from($to.node(d).copy(after));
            openEnd++;
        } else end++;
        tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, (0, parcelRequire("kCV8T")).Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
    }
    function $ad3826e817ebec37$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
        let around = $ad3826e817ebec37$var$findWrappingOutside(range, nodeType);
        let inner = around && $ad3826e817ebec37$var$findWrappingInside(innerRange, nodeType);
        if (!inner) return null;
        return around.map($ad3826e817ebec37$var$withAttrs).concat({
            type: nodeType,
            attrs: attrs
        }).concat(inner.map($ad3826e817ebec37$var$withAttrs));
    }
    function $ad3826e817ebec37$var$withAttrs(type) {
        return {
            type: type,
            attrs: null
        };
    }
    function $ad3826e817ebec37$var$findWrappingOutside(range, type) {
        let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
        let around = parent.contentMatchAt(startIndex).findWrapping(type);
        if (!around) return null;
        let outer = around.length ? around[0] : type;
        return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
    }
    function $ad3826e817ebec37$var$findWrappingInside(range, type) {
        let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
        let inner = parent.child(startIndex);
        let inside = type.contentMatch.findWrapping(inner.type);
        if (!inside) return null;
        let lastType = inside.length ? inside[inside.length - 1] : type;
        let innerMatch = lastType.contentMatch;
        for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
        if (!innerMatch || !innerMatch.validEnd) return null;
        return inside;
    }
    function $ad3826e817ebec37$var$wrap(tr, range, wrappers) {
        let content = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
        for(let i = wrappers.length - 1; i >= 0; i--){
            if (content.size) {
                let match = wrappers[i].type.contentMatch.matchFragment(content);
                if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
            }
            content = (0, (0, parcelRequire("kCV8T")).Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
        }
        let start = range.start, end = range.end;
        tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, start, end, new (0, (0, parcelRequire("kCV8T")).Slice)(content, 0, 0), wrappers.length, true));
    }
    function $ad3826e817ebec37$var$setBlockType(tr, from, to, type, attrs) {
        if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
        let mapFrom = tr.steps.length;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
            if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $ad3826e817ebec37$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
                let convertNewlines = null;
                if (type.schema.linebreakReplacement) {
                    let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                    if (pre && !supportLinebreak) convertNewlines = false;
                    else if (!pre && supportLinebreak) convertNewlines = true;
                }
                if (convertNewlines === false) $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom);
                $ad3826e817ebec37$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
                let mapping = tr.mapping.slice(mapFrom);
                let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
                tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
                if (convertNewlines === true) $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom);
                return false;
            }
        });
    }
    function $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom) {
        node.forEach((child, offset)=>{
            if (child.isText) {
                let m, newline = /\r?\n|\r/g;
                while(m = newline.exec(child.text)){
                    let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                    tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
                }
            }
        });
    }
    function $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom) {
        node.forEach((child, offset)=>{
            if (child.type == child.type.schema.linebreakReplacement) {
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
                tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
            }
        });
    }
    function $ad3826e817ebec37$var$canChangeType(doc, pos, type) {
        let $pos = doc.resolve(pos), index = $pos.index();
        return $pos.parent.canReplaceWith(index, index + 1, type);
    }
    function $ad3826e817ebec37$var$setNodeMarkup(tr, pos, type, attrs, marks) {
        let node = tr.doc.nodeAt(pos);
        if (!node) throw new RangeError("No node at given position");
        if (!type) type = node.type;
        let newNode = type.create(attrs, null, marks || node.marks);
        if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
        if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
        tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(newNode), 0, 0), 1, true));
    }
    function $ad3826e817ebec37$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
        let $pos = doc.resolve(pos), base = $pos.depth - depth;
        let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
        if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
        for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
            let node = $pos.node(d), index = $pos.index(d);
            if (node.type.spec.isolating) return false;
            let rest = node.content.cutByIndex(index, node.childCount);
            let overrideChild = typesAfter && typesAfter[i + 1];
            if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
            let after = typesAfter && typesAfter[i] || node;
            if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
        }
        let index = $pos.indexAfter(base);
        let baseType = typesAfter && typesAfter[0];
        return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
    }
    function $ad3826e817ebec37$var$split(tr, pos, depth = 1, typesAfter) {
        let $pos = tr.doc.resolve(pos), before = (0, (0, parcelRequire("kCV8T")).Fragment).empty, after = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
        for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
            before = (0, (0, parcelRequire("kCV8T")).Fragment).from($pos.node(d).copy(before));
            let typeAfter = typesAfter && typesAfter[i];
            after = (0, (0, parcelRequire("kCV8T")).Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
        }
        tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(pos, pos, new (0, (0, parcelRequire("kCV8T")).Slice)(before.append(after), depth, depth), true));
    }
    function $ad3826e817ebec37$export$f15f89fd9d8cc98a(doc, pos) {
        let $pos = doc.resolve(pos), index = $pos.index();
        return $ad3826e817ebec37$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
    }
    function $ad3826e817ebec37$var$joinable(a, b) {
        return !!(a && b && !a.isLeaf && a.canAppend(b));
    }
    function $ad3826e817ebec37$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
        let $pos = doc.resolve(pos);
        for(let d = $pos.depth;; d--){
            let before, after, index = $pos.index(d);
            if (d == $pos.depth) {
                before = $pos.nodeBefore;
                after = $pos.nodeAfter;
            } else if (dir > 0) {
                before = $pos.node(d + 1);
                index++;
                after = $pos.node(d).maybeChild(index);
            } else {
                before = $pos.node(d).maybeChild(index - 1);
                after = $pos.node(d + 1);
            }
            if (before && !before.isTextblock && $ad3826e817ebec37$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
            if (d == 0) break;
            pos = dir < 0 ? $pos.before(d) : $pos.after(d);
        }
    }
    function $ad3826e817ebec37$var$join(tr, pos, depth) {
        let step = new $ad3826e817ebec37$export$5c860b2e74034756(pos - depth, pos + depth, (0, (0, parcelRequire("kCV8T")).Slice).empty, true);
        tr.step(step);
    }
    function $ad3826e817ebec37$export$64cb316d02de1dd1(doc, pos, nodeType) {
        let $pos = doc.resolve(pos);
        if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
        if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
            let index = $pos.index(d);
            if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
            if (index > 0) return null;
        }
        if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
            let index = $pos.indexAfter(d);
            if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
            if (index < $pos.node(d).childCount) return null;
        }
        return null;
    }
    function $ad3826e817ebec37$export$2819d598d048fc9c(doc, pos, slice) {
        let $pos = doc.resolve(pos);
        if (!slice.content.size) return pos;
        let content = slice.content;
        for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
        for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
            let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
            let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
            let parent = $pos.node(d), fits = false;
            if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
            else {
                let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
                fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
            }
            if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
        }
        return null;
    }
    function $ad3826e817ebec37$export$ed6ac67359824afd(doc, from, to = from, slice = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
        if (from == to && !slice.size) return null;
        let $from = doc.resolve(from), $to = doc.resolve(to);
        if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice);
        return new $ad3826e817ebec37$var$Fitter($from, $to, slice).fit();
    }
    function $ad3826e817ebec37$var$fitsTrivially($from, $to, slice) {
        return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
    }
    class $ad3826e817ebec37$var$Fitter {
        constructor($from, $to, unplaced){
            this.$from = $from;
            this.$to = $to;
            this.unplaced = unplaced;
            this.frontier = [];
            this.placed = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
            for(let i = 0; i <= $from.depth; i++){
                let node = $from.node(i);
                this.frontier.push({
                    type: node.type,
                    match: node.contentMatchAt($from.indexAfter(i))
                });
            }
            for(let i = $from.depth; i > 0; i--)this.placed = (0, (0, parcelRequire("kCV8T")).Fragment).from($from.node(i).copy(this.placed));
        }
        get depth() {
            return this.frontier.length - 1;
        }
        fit() {
            while(this.unplaced.size){
                let fit = this.findFittable();
                if (fit) this.placeNodes(fit);
                else this.openMore() || this.dropNode();
            }
            let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
            let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
            if (!$to) return null;
            let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
            while(openStart && openEnd && content.childCount == 1){
                content = content.firstChild.content;
                openStart--;
                openEnd--;
            }
            let slice = new (0, (0, parcelRequire("kCV8T")).Slice)(content, openStart, openEnd);
            if (moveInline > -1) return new $ad3826e817ebec37$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
            if (slice.size || $from.pos != this.$to.pos) return new $ad3826e817ebec37$export$5c860b2e74034756($from.pos, $to.pos, slice);
            return null;
        }
        findFittable() {
            let startDepth = this.unplaced.openStart;
            for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
                let node = cur.firstChild;
                if (cur.childCount > 1) openEnd = 0;
                if (node.type.spec.isolating && openEnd <= d) {
                    startDepth = d;
                    break;
                }
                cur = node.content;
            }
            for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
                let fragment, parent = null;
                if (sliceDepth) {
                    parent = $ad3826e817ebec37$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                    fragment = parent.content;
                } else fragment = this.unplaced.content;
                let first = fragment.firstChild;
                for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                    let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                    if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                        sliceDepth: sliceDepth,
                        frontierDepth: frontierDepth,
                        parent: parent,
                        inject: inject
                    };
                    else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                        sliceDepth: sliceDepth,
                        frontierDepth: frontierDepth,
                        parent: parent,
                        wrap: wrap
                    };
                    if (parent && match.matchType(parent.type)) break;
                }
            }
        }
        openMore() {
            let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
            let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
            if (!inner.childCount || inner.firstChild.isLeaf) return false;
            this.unplaced = new (0, (0, parcelRequire("kCV8T")).Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
            return true;
        }
        dropNode() {
            let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
            let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
            if (inner.childCount <= 1 && openStart > 0) {
                let openAtEnd = content.size - openStart <= openStart + inner.size;
                this.unplaced = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
            } else this.unplaced = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
        }
        placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
            while(this.depth > frontierDepth)this.closeFrontierNode();
            if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
            let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
            let openStart = slice.openStart - sliceDepth;
            let taken = 0, add = [];
            let { match: match, type: type } = this.frontier[frontierDepth];
            if (inject) {
                for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
                match = match.matchFragment(inject);
            }
            let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
            while(taken < fragment.childCount){
                let next = fragment.child(taken), matches = match.matchType(next.type);
                if (!matches) break;
                taken++;
                if (taken > 1 || openStart == 0 || next.content.size) {
                    match = matches;
                    add.push($ad3826e817ebec37$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
                }
            }
            let toEnd = taken == fragment.childCount;
            if (!toEnd) openEndCount = -1;
            this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, frontierDepth, (0, (0, parcelRequire("kCV8T")).Fragment).from(add));
            this.frontier[frontierDepth].match = match;
            if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
            for(let i = 0, cur = fragment; i < openEndCount; i++){
                let node = cur.lastChild;
                this.frontier.push({
                    type: node.type,
                    match: node.contentMatchAt(node.childCount)
                });
                cur = node.content;
            }
            this.unplaced = !toEnd ? new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, (0, parcelRequire("kCV8T")).Slice).empty : new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
        }
        mustMoveInline() {
            if (!this.$to.parent.isTextblock) return -1;
            let top = this.frontier[this.depth], level;
            if (!top.type.isTextblock || !$ad3826e817ebec37$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
            let { depth: depth } = this.$to, after = this.$to.after(depth);
            while(depth > 1 && after == this.$to.end(--depth))++after;
            return after;
        }
        findCloseLevel($to) {
            scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
                let { match: match, type: type } = this.frontier[i];
                let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
                let fit = $ad3826e817ebec37$var$contentAfterFits($to, i, type, match, dropInner);
                if (!fit) continue;
                for(let d = i - 1; d >= 0; d--){
                    let { match: match, type: type } = this.frontier[d];
                    let matches = $ad3826e817ebec37$var$contentAfterFits($to, d, type, match, true);
                    if (!matches || matches.childCount) continue scan;
                }
                return {
                    depth: i,
                    fit: fit,
                    move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
                };
            }
        }
        close($to) {
            let close = this.findCloseLevel($to);
            if (!close) return null;
            while(this.depth > close.depth)this.closeFrontierNode();
            if (close.fit.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, close.depth, close.fit);
            $to = close.move;
            for(let d = close.depth + 1; d <= $to.depth; d++){
                let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
                this.openFrontierNode(node.type, node.attrs, add);
            }
            return $to;
        }
        openFrontierNode(type, attrs = null, content) {
            let top = this.frontier[this.depth];
            top.match = top.match.matchType(type);
            this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.depth, (0, (0, parcelRequire("kCV8T")).Fragment).from(type.create(attrs, content)));
            this.frontier.push({
                type: type,
                match: type.contentMatch
            });
        }
        closeFrontierNode() {
            let open = this.frontier.pop();
            let add = open.match.fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true);
            if (add.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.frontier.length, add);
        }
    }
    function $ad3826e817ebec37$var$dropFromFragment(fragment, depth, count) {
        if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
        return fragment.replaceChild(0, fragment.firstChild.copy($ad3826e817ebec37$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
    }
    function $ad3826e817ebec37$var$addToFragment(fragment, depth, content) {
        if (depth == 0) return fragment.append(content);
        return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($ad3826e817ebec37$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
    }
    function $ad3826e817ebec37$var$contentAt(fragment, depth) {
        for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
        return fragment;
    }
    function $ad3826e817ebec37$var$closeNodeStart(node, openStart, openEnd) {
        if (openStart <= 0) return node;
        let frag = node.content;
        if (openStart > 1) frag = frag.replaceChild(0, $ad3826e817ebec37$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
        if (openStart > 0) {
            frag = node.type.contentMatch.fillBefore(frag).append(frag);
            if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true));
        }
        return node.copy(frag);
    }
    function $ad3826e817ebec37$var$contentAfterFits($to, depth, type, match, open) {
        let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
        if (index == node.childCount && !type.compatibleContent(node.type)) return null;
        let fit = match.fillBefore(node.content, true, index);
        return fit && !$ad3826e817ebec37$var$invalidMarks(type, node.content, index) ? fit : null;
    }
    function $ad3826e817ebec37$var$invalidMarks(type, fragment, start) {
        for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
        return false;
    }
    function $ad3826e817ebec37$var$definesContent(type) {
        return type.spec.defining || type.spec.definingForContent;
    }
    function $ad3826e817ebec37$var$replaceRange(tr, from, to, slice) {
        if (!slice.size) return tr.deleteRange(from, to);
        let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
        if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice));
        let targetDepths = $ad3826e817ebec37$var$coveredDepths($from, tr.doc.resolve(to));
        if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
        let preferredTarget = -($from.depth + 1);
        targetDepths.unshift(preferredTarget);
        for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
            let spec = $from.node(d).type.spec;
            if (spec.defining || spec.definingAsContext || spec.isolating) break;
            if (targetDepths.indexOf(d) > -1) preferredTarget = d;
            else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
        }
        let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
        let leftNodes = [], preferredDepth = slice.openStart;
        for(let content = slice.content, i = 0;; i++){
            let node = content.firstChild;
            leftNodes.push(node);
            if (i == slice.openStart) break;
            content = node.content;
        }
        for(let d = preferredDepth - 1; d >= 0; d--){
            let leftNode = leftNodes[d], def = $ad3826e817ebec37$var$definesContent(leftNode.type);
            if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
            else if (def || !leftNode.type.isTextblock) break;
        }
        for(let j = slice.openStart; j >= 0; j--){
            let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
            let insert = leftNodes[openDepth];
            if (!insert) continue;
            for(let i = 0; i < targetDepths.length; i++){
                let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
                if (targetDepth < 0) {
                    expand = false;
                    targetDepth = -targetDepth;
                }
                let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
                if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
            }
        }
        let startSteps = tr.steps.length;
        for(let i = targetDepths.length - 1; i >= 0; i--){
            tr.replace(from, to, slice);
            if (tr.steps.length > startSteps) break;
            let depth = targetDepths[i];
            if (depth < 0) continue;
            from = $from.before(depth);
            to = $to.after(depth);
        }
    }
    function $ad3826e817ebec37$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
        if (depth < oldOpen) {
            let first = fragment.firstChild;
            fragment = fragment.replaceChild(0, first.copy($ad3826e817ebec37$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
        }
        if (depth > newOpen) {
            let match = parent.contentMatchAt(0);
            let start = match.fillBefore(fragment).append(fragment);
            fragment = start.append(match.matchFragment(start).fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true));
        }
        return fragment;
    }
    function $ad3826e817ebec37$var$replaceRangeWith(tr, from, to, node) {
        if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
            let point = $ad3826e817ebec37$export$64cb316d02de1dd1(tr.doc, from, node.type);
            if (point != null) from = to = point;
        }
        tr.replaceRange(from, to, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(node), 0, 0));
    }
    function $ad3826e817ebec37$var$deleteRange(tr, from, to) {
        let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
        let covered = $ad3826e817ebec37$var$coveredDepths($from, $to);
        for(let i = 0; i < covered.length; i++){
            let depth = covered[i], last = i == covered.length - 1;
            if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
            if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
        }
        for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
            if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d) return tr.delete($from.before(d), to);
        }
        tr.delete(from, to);
    }
    function $ad3826e817ebec37$var$coveredDepths($from, $to) {
        let result = [], minDepth = Math.min($from.depth, $to.depth);
        for(let d = minDepth; d >= 0; d--){
            let start = $from.start(d);
            if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
            if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
        }
        return result;
    }
    class $ad3826e817ebec37$export$626399c38172f669 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(pos, attr, value){
            super();
            this.pos = pos;
            this.attr = attr;
            this.value = value;
        }
        apply(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at attribute step's position");
            let attrs = Object.create(null);
            for(let name in node.attrs)attrs[name] = node.attrs[name];
            attrs[this.attr] = this.value;
            let updated = node.type.create(attrs, null, node.marks);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
        }
        getMap() {
            return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        invert(doc) {
            return new $ad3826e817ebec37$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
        }
        map(mapping) {
            let pos = mapping.mapResult(this.pos, 1);
            return pos.deletedAfter ? null : new $ad3826e817ebec37$export$626399c38172f669(pos.pos, this.attr, this.value);
        }
        toJSON() {
            return {
                stepType: "attr",
                pos: this.pos,
                attr: this.attr,
                value: this.value
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
            return new $ad3826e817ebec37$export$626399c38172f669(json.pos, json.attr, json.value);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("attr", $ad3826e817ebec37$export$626399c38172f669);
    class $ad3826e817ebec37$export$f50707b396300ac9 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(attr, value){
            super();
            this.attr = attr;
            this.value = value;
        }
        apply(doc) {
            let attrs = Object.create(null);
            for(let name in doc.attrs)attrs[name] = doc.attrs[name];
            attrs[this.attr] = this.value;
            let updated = doc.type.create(attrs, doc.content, doc.marks);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(updated);
        }
        getMap() {
            return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        invert(doc) {
            return new $ad3826e817ebec37$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
        }
        map(mapping) {
            return this;
        }
        toJSON() {
            return {
                stepType: "docAttr",
                attr: this.attr,
                value: this.value
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
            return new $ad3826e817ebec37$export$f50707b396300ac9(json.attr, json.value);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("docAttr", $ad3826e817ebec37$export$f50707b396300ac9);
    let $ad3826e817ebec37$export$88cc3a1dfce48dd3 = class extends Error {
    };
    $ad3826e817ebec37$export$88cc3a1dfce48dd3 = function TransformError(message) {
        let err = Error.call(this, message);
        err.__proto__ = TransformError.prototype;
        return err;
    };
    $ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
    $ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.constructor = $ad3826e817ebec37$export$88cc3a1dfce48dd3;
    $ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
    class $ad3826e817ebec37$export$563a914cafbdc389 {
        constructor(doc){
            this.doc = doc;
            this.steps = [];
            this.docs = [];
            this.mapping = new $ad3826e817ebec37$export$f5f785078011b62;
        }
        get before() {
            return this.docs.length ? this.docs[0] : this.doc;
        }
        step(step) {
            let result = this.maybeStep(step);
            if (result.failed) throw new $ad3826e817ebec37$export$88cc3a1dfce48dd3(result.failed);
            return this;
        }
        maybeStep(step) {
            let result = step.apply(this.doc);
            if (!result.failed) this.addStep(step, result.doc);
            return result;
        }
        get docChanged() {
            return this.steps.length > 0;
        }
        addStep(step, doc) {
            this.docs.push(this.doc);
            this.steps.push(step);
            this.mapping.appendMap(step.getMap());
            this.doc = doc;
        }
        replace(from, to = from, slice = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            let step = $ad3826e817ebec37$export$ed6ac67359824afd(this.doc, from, to, slice);
            if (step) this.step(step);
            return this;
        }
        replaceWith(from, to, content) {
            return this.replace(from, to, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(content), 0, 0));
        }
        delete(from, to) {
            return this.replace(from, to, (0, (0, parcelRequire("kCV8T")).Slice).empty);
        }
        insert(pos, content) {
            return this.replaceWith(pos, pos, content);
        }
        replaceRange(from, to, slice) {
            $ad3826e817ebec37$var$replaceRange(this, from, to, slice);
            return this;
        }
        replaceRangeWith(from, to, node) {
            $ad3826e817ebec37$var$replaceRangeWith(this, from, to, node);
            return this;
        }
        deleteRange(from, to) {
            $ad3826e817ebec37$var$deleteRange(this, from, to);
            return this;
        }
        lift(range, target) {
            $ad3826e817ebec37$var$lift(this, range, target);
            return this;
        }
        join(pos, depth = 1) {
            $ad3826e817ebec37$var$join(this, pos, depth);
            return this;
        }
        wrap(range, wrappers) {
            $ad3826e817ebec37$var$wrap(this, range, wrappers);
            return this;
        }
        setBlockType(from, to = from, type, attrs = null) {
            $ad3826e817ebec37$var$setBlockType(this, from, to, type, attrs);
            return this;
        }
        setNodeMarkup(pos, type, attrs = null, marks) {
            $ad3826e817ebec37$var$setNodeMarkup(this, pos, type, attrs, marks);
            return this;
        }
        setNodeAttribute(pos, attr, value) {
            this.step(new $ad3826e817ebec37$export$626399c38172f669(pos, attr, value));
            return this;
        }
        setDocAttribute(attr, value) {
            this.step(new $ad3826e817ebec37$export$f50707b396300ac9(attr, value));
            return this;
        }
        addNodeMark(pos, mark) {
            this.step(new $ad3826e817ebec37$export$adefd16c402fee4e(pos, mark));
            return this;
        }
        removeNodeMark(pos, mark) {
            if (!(mark instanceof (0, (0, parcelRequire("kCV8T")).Mark))) {
                let node = this.doc.nodeAt(pos);
                if (!node) throw new RangeError("No node at position " + pos);
                mark = mark.isInSet(node.marks);
                if (!mark) return this;
            }
            this.step(new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos, mark));
            return this;
        }
        split(pos, depth = 1, typesAfter) {
            $ad3826e817ebec37$var$split(this, pos, depth, typesAfter);
            return this;
        }
        addMark(from, to, mark) {
            $ad3826e817ebec37$var$addMark(this, from, to, mark);
            return this;
        }
        removeMark(from, to, mark) {
            $ad3826e817ebec37$var$removeMark(this, from, to, mark);
            return this;
        }
        clearIncompatible(pos, parentType, match) {
            $ad3826e817ebec37$var$clearIncompatible(this, pos, parentType, match);
            return this;
        }
    }
});
parcelRegister("9TK8T", function(module, exports) {
    $parcel$export(module.exports, "preloadJQLEditor", ()=>$ed5f2cd8810d4c1a$export$d5d5e8328005e2ec);
    $parcel$export(module.exports, "JQLEditorAsync", ()=>$ed5f2cd8810d4c1a$export$ecdc147409ce705b);
    var $5uXOq = parcelRequire("5uXOq");
    var $kc9vJ = parcelRequire("kc9vJ");
    var $9wOa1;
    var $czW0Y;
    var $hwGLa;
    const $ed5f2cd8810d4c1a$var$JQLEditor = (0, $kc9vJ.lazyForPaint)(()=>(parcelRequire("cln6b")).then(({ default: JQLEditorUI })=>JQLEditorUI), {
        ssr: false
    });
    const $ed5f2cd8810d4c1a$export$d5d5e8328005e2ec = ()=>$ed5f2cd8810d4c1a$var$JQLEditor.preload();
    const $ed5f2cd8810d4c1a$export$ecdc147409ce705b = (0, (0, parcelRequire("czW0Y")).withIntlProvider)((0, (0, parcelRequire("9wOa1")).withErrorBoundary)((props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kc9vJ.LazySuspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hwGLa")).JQLEditorReadOnly), {
                query: props.query,
                isSearch: !!props.onSearch,
                isCompact: props.isCompact
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ed5f2cd8810d4c1a$var$JQLEditor, props));
    }));
});
parcelRegister("9wOa1", function(module, exports) {
    $parcel$export(module.exports, "withErrorBoundary", ()=>$6e59b32e706bac41$export$f0c7a449e0cfaec7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hwGLa;
    class $6e59b32e706bac41$var$ErrorBoundary extends (0, $5uXOq.Component) {
        componentDidCatch(error) {
            this.setState({
                error: error
            });
            this.props.onError && this.props.onError(error);
        }
        render() {
            const { children: children, render: renderFallback } = this.props;
            const { error: error } = this.state;
            if (error === null) return children;
            return renderFallback({
                error: error
            });
        }
        constructor(...args){
            super(...args), this.state = {
                error: null
            };
        }
    }
    const $6e59b32e706bac41$export$f0c7a449e0cfaec7 = (WrappedComponent)=>{
        return (props)=>{
            const { query: query, onRenderError: onRenderError, onSearch: onSearch, isCompact: isCompact } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($6e59b32e706bac41$var$ErrorBoundary, {
                onError: onRenderError,
                render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hwGLa")).JQLEditorReadOnly), {
                        query: query,
                        isSearch: !!onSearch,
                        isCompact: isCompact
                    })
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));
        };
    };
});
parcelRegister("czW0Y", function(module, exports) {
    $parcel$export(module.exports, "withIntlProvider", ()=>$6f80dd24c96d3f53$export$a5d940130f33be3f);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    const $6f80dd24c96d3f53$export$a5d940130f33be3f = (WrappedComponent)=>{
        return (props)=>{
            const { locale: locale, ...rest } = props;
            if (locale) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
                locale: locale
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, rest));
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, rest);
        };
    };
});
parcelRegister("cln6b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jfnVE")
    ]).then(()=>parcelRequire('1BQAE'));
});
parcelRegister("imju0", function(module, exports) {
    $parcel$export(module.exports, "preloadJqlBuilderBasic", ()=>$d68345fea548f228$export$680bac3b2d4b8db0);
    $parcel$export(module.exports, "JQLBuilderBasicOldAsync", ()=>$d68345fea548f228$export$50e4159fe4baf68e);
    $parcel$export(module.exports, "default", ()=>$d68345fea548f228$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8vNru;
    var $caSpf;
    var $kxZPA;
    var $jDMe3;
    const $d68345fea548f228$var$AsyncJQLEditorUIOld = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("cg4FO")).then((module)=>module.JQLEditorUIWithErrorBoundaryOld), {
        ssr: false,
        moduleId: "./src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx"
    });
    const $d68345fea548f228$var$AsyncJQLEditorUI = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("cg4FO")), {
        ssr: false,
        moduleId: "./src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx"
    });
    const $d68345fea548f228$export$680bac3b2d4b8db0 = ()=>$d68345fea548f228$var$AsyncJQLEditorUI.preload();
    const $d68345fea548f228$export$50e4159fe4baf68e = (props)=>{
        const onPerformanceMark = (0, (0, parcelRequire("caSpf")).usePerformanceContext)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            onPerformanceMark({
                mark: (0, (0, parcelRequire("8vNru")).JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_START
            });
        }, [
            onPerformanceMark
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDMe3")).JQLBuilderBasicUIWithAnalyticsOld), {
            ...props,
            JQLEditor: $d68345fea548f228$var$AsyncJQLEditorUIOld
        });
    };
    const $d68345fea548f228$var$JQLBuilderBasicAsync = (props)=>{
        const onPerformanceMark = (0, (0, parcelRequire("caSpf")).usePerformanceContext)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            onPerformanceMark({
                mark: (0, (0, parcelRequire("8vNru")).JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_START
            });
        }, [
            onPerformanceMark
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDMe3")).default), {
            ...props,
            JQLEditor: $d68345fea548f228$var$AsyncJQLEditorUI
        });
    };
    var $d68345fea548f228$export$2e2bcd8739ae039 = $d68345fea548f228$var$JQLBuilderBasicAsync;
});
parcelRegister("jDMe3", function(module, exports) {
    $parcel$export(module.exports, "JQLBuilderBasicFallback", ()=>$681286dd03941848$export$c5a574f152d930c7);
    $parcel$export(module.exports, "JQLBuilderBasicUIWithAnalyticsOld", ()=>$681286dd03941848$export$64a4e59c434c7d2d);
    $parcel$export(module.exports, "default", ()=>$681286dd03941848$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $iXVV6;
    var $kG16F;
    var $lW1IZ;
    var $lzKFP;
    const $681286dd03941848$var$debouncedSearch = (0, ($parcel$interopDefault($lFKmC)))((onSearch, newJql)=>onSearch(newJql), 1000, {
        leading: false,
        trailing: true
    });
    const $681286dd03941848$var$JQLBuilderBasicUIOld = (props)=>{
        const { query: query, JQLEditor: JQLEditor, onSearch: triggerSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields, onReady: onReady, onLoad: onLoad, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, projectOptions: projectOptions, singleSelectFields: singleSelectFields, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, showOrderByPicker: showOrderByPicker, contextJql: contextJql, viewContext: viewContext = null } = props;
        const [jql, setJql] = (0, $5uXOq.useState)(query);
        const onSearch = (0, $5uXOq.useCallback)((newJql)=>{
            setJql(newJql);
            triggerSearch && $681286dd03941848$var$debouncedSearch(triggerSearch, newJql);
        }, [
            triggerSearch
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setJql(query);
        }, [
            query,
            setJql
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kG16F")).ASTContainer), {
            jql: jql,
            onSwitchToJql: onSwitchToJql
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lW1IZ")).SearchStateContainer), {
            excludedFields: excludedFields,
            irremovableFields: irremovableFields
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(JQLEditor, {
            NoOptionComponent: NoOptionComponent,
            query: jql,
            onSearch: onSearch,
            onSwitchToJql: onSwitchToJql,
            excludedFields: excludedFields,
            onReady: onReady,
            onLoad: onLoad,
            onJourneyStart: onJourneyStart,
            hydrationQueryRef: hydrationQueryRef,
            isHydrating: isHydrating,
            projectOptions: projectOptions,
            singleSelectFields: singleSelectFields,
            shouldUseListMarkup: shouldUseListMarkup,
            hideOperatorDropdown: hideOperatorDropdown,
            irremovableFields: irremovableFields,
            hideTextSearchInput: hideTextSearchInput,
            showOrderByPicker: showOrderByPicker,
            contextJql: contextJql,
            viewContext: viewContext
        })));
    };
    const $681286dd03941848$var$JQLBuilderBasicUI = (props)=>{
        const { query: query, JQLEditor: JQLEditor, onSearch: triggerSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields, onReady: onReady, onLoad: onLoad, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, projectOptions: projectOptions, singleSelectFields: singleSelectFields, hydrationData: hydrationData, isHydrating: isHydrating, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, showOrderByPicker: showOrderByPicker, contextJql: contextJql, viewContext: viewContext = null } = props;
        const [jql, setJql] = (0, $5uXOq.useState)(query);
        const onSearch = (0, $5uXOq.useCallback)((newJql)=>{
            setJql(newJql);
            triggerSearch && $681286dd03941848$var$debouncedSearch(triggerSearch, newJql);
        }, [
            triggerSearch
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setJql(query);
        }, [
            query,
            setJql
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kG16F")).ASTContainer), {
            jql: jql,
            onSwitchToJql: onSwitchToJql
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lW1IZ")).SearchStateContainer), {
            excludedFields: excludedFields,
            irremovableFields: irremovableFields
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(JQLEditor, {
            NoOptionComponent: NoOptionComponent,
            query: jql,
            onSearch: onSearch,
            onSwitchToJql: onSwitchToJql,
            excludedFields: excludedFields,
            onReady: onReady,
            onLoad: onLoad,
            onJourneyStart: onJourneyStart,
            hydrationData: hydrationData,
            isHydrating: isHydrating,
            projectOptions: projectOptions,
            singleSelectFields: singleSelectFields,
            shouldUseListMarkup: shouldUseListMarkup,
            hideOperatorDropdown: hideOperatorDropdown,
            irremovableFields: irremovableFields,
            hideTextSearchInput: hideTextSearchInput,
            showOrderByPicker: showOrderByPicker,
            contextJql: contextJql,
            viewContext: viewContext
        })));
    };
    const $681286dd03941848$export$c5a574f152d930c7 = ({ query: jql, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kG16F")).ASTContainer), {
            jql: jql
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lW1IZ")).SearchStateContainer), {
            excludedFields: props.excludedFields,
            irremovableFields: props.irremovableFields
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lzKFP")).default), props)));
    const $681286dd03941848$export$64a4e59c434c7d2d = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "jqlBuilderBasic",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($681286dd03941848$var$JQLBuilderBasicUIOld, props));
    const $681286dd03941848$var$JQLBuilderBasicUIWithAnalytics = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "jqlBuilderBasic",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($681286dd03941848$var$JQLBuilderBasicUI, props));
    var $681286dd03941848$export$2e2bcd8739ae039 = $681286dd03941848$var$JQLBuilderBasicUIWithAnalytics;
});
parcelRegister("kG16F", function(module, exports) {
    $parcel$export(module.exports, "ASTContainer", ()=>$e3071c28735d4f8b$export$9046b5020ab1c824);
    $parcel$export(module.exports, "useAST", ()=>$e3071c28735d4f8b$export$2d94ebd7e6bbb03c);
    $parcel$export(module.exports, "useClauseMap", ()=>$e3071c28735d4f8b$export$32019dca04f1bace);
    $parcel$export(module.exports, "useTextSearchInputClause", ()=>$e3071c28735d4f8b$export$53c45c55dec81810);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $c5AV2;
    const $e3071c28735d4f8b$var$actions = Object.freeze({});
    const $e3071c28735d4f8b$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            ast: {
                query: undefined,
                represents: '',
                errors: []
            },
            clauseMap: {},
            textSearchInputClause: undefined
        },
        actions: $e3071c28735d4f8b$var$actions,
        name: 'JQLBasic-ASTService'
    });
    const $e3071c28735d4f8b$var$Container = (0, (0, parcelRequire("gg7kZ")).createContainer)($e3071c28735d4f8b$var$store, {
        onInit: ()=>({ setState: setState }, props)=>{
                setState((0, (0, parcelRequire("c5AV2")).getASTAndClausesFromJQL)(props));
            },
        onUpdate: ()=>({ setState: setState }, props)=>{
                setState((0, (0, parcelRequire("c5AV2")).getASTAndClausesFromJQL)(props));
            }
    });
    const $e3071c28735d4f8b$export$9046b5020ab1c824 = ({ jql: jql, children: children, onSwitchToJql: onSwitchToJql })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e3071c28735d4f8b$var$Container, {
            jql: jql,
            createAnalyticsEvent: createAnalyticsEvent,
            onSwitchToJql: onSwitchToJql
        }, children);
    };
    const $e3071c28735d4f8b$export$2d94ebd7e6bbb03c = (0, (0, parcelRequire("3sQ5x")).createHook)($e3071c28735d4f8b$var$store, {
        selector: ({ ast: ast })=>ast
    });
    const $e3071c28735d4f8b$export$32019dca04f1bace = (0, (0, parcelRequire("3sQ5x")).createHook)($e3071c28735d4f8b$var$store, {
        selector: ({ clauseMap: clauseMap })=>clauseMap
    });
    const $e3071c28735d4f8b$export$53c45c55dec81810 = (0, (0, parcelRequire("3sQ5x")).createHook)($e3071c28735d4f8b$var$store, {
        selector: ({ textSearchInputClause: textSearchInputClause })=>textSearchInputClause
    });
});
parcelRegister("c5AV2", function(module, exports) {
    $parcel$export(module.exports, "getASTAndClausesFromJQL", ()=>$f51f2f52962d8ecb$export$1029f331f2d8b0fd);
    var $eK6AG;
    var $jcw0u;
    var $5Dsab;
    var $6jt9j;
    var $j200s;
    const $f51f2f52962d8ecb$export$1029f331f2d8b0fd = ({ jql: jql, createAnalyticsEvent: createAnalyticsEvent, onSwitchToJql: onSwitchToJql })=>{
        const ast = new (0, (0, parcelRequire("eK6AG")).JastBuilder)().build(jql);
        let clauseMap = {};
        let textSearchInputClause;
        if (ast.query) try {
            ({ clauseMap: clauseMap, textSearchInputClause: textSearchInputClause } = new (0, (0, parcelRequire("6jt9j")).JqlClauseCollectingVisitor)(false).visit(ast.query));
        } catch (error) {
            if (error instanceof (0, (0, parcelRequire("j200s")).UnsupportedRefinementError)) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    event: createAnalyticsEvent({}),
                    error: error,
                    meta: {
                        id: 'queryTooComplexInBasicMode',
                        packageName: (0, (0, parcelRequire("5Dsab")).PACKAGE_NAME),
                        teamName: (0, (0, parcelRequire("5Dsab")).TEAM_NAME)
                    },
                    attributes: {
                        anonymizedJql: ast.query ? ast.query.accept((0, (0, parcelRequire("5Dsab")).jqlAnonymizerVisitor)) : undefined
                    }
                });
                onSwitchToJql && onSwitchToJql();
            } else throw error;
        }
        return {
            ast: ast,
            clauseMap: clauseMap,
            textSearchInputClause: textSearchInputClause
        };
    };
});
parcelRegister("lW1IZ", function(module, exports) {
    $parcel$export(module.exports, "SearchStateContainer", ()=>$3e7055e4c82a9c84$export$f57da8b87ed90917);
    $parcel$export(module.exports, "useSearchState", ()=>$3e7055e4c82a9c84$export$5fd14fa624074d55);
    var $5uXOq = parcelRequire("5uXOq");
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $kG16F;
    var $47om7;
    const $3e7055e4c82a9c84$var$actions = Object.freeze({});
    const $3e7055e4c82a9c84$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            astClauseOrder: [],
            clausesByFieldId: {},
            secondaryClausesByFieldId: {}
        },
        actions: $3e7055e4c82a9c84$var$actions,
        name: 'JQLBasic-SeachStateService'
    });
    const $3e7055e4c82a9c84$var$Container = (0, (0, parcelRequire("gg7kZ")).createContainer)($3e7055e4c82a9c84$var$store, {
        onInit: ()=>({ setState: setState }, props)=>{
                setState((0, (0, parcelRequire("47om7")).getClausesData)(props));
            },
        onUpdate: ()=>({ setState: setState }, props)=>{
                setState((0, (0, parcelRequire("47om7")).getClausesData)(props));
            }
    });
    const $3e7055e4c82a9c84$var$DEFAULT_EXCLUDED_FIELDS = [];
    const $3e7055e4c82a9c84$export$f57da8b87ed90917 = ({ excludedFields: excludedFields = $3e7055e4c82a9c84$var$DEFAULT_EXCLUDED_FIELDS, irremovableFields: irremovableFields, children: children })=>{
        const [clauseMap] = (0, (0, parcelRequire("kG16F")).useClauseMap)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3e7055e4c82a9c84$var$Container, {
            clauseMap: clauseMap,
            excludedFields: excludedFields,
            irremovableFields: irremovableFields
        }, children);
    };
    const $3e7055e4c82a9c84$export$5fd14fa624074d55 = (0, (0, parcelRequire("3sQ5x")).createHook)($3e7055e4c82a9c84$var$store);
});
parcelRegister("47om7", function(module, exports) {
    $parcel$export(module.exports, "getClausesData", ()=>$650b3b1ce62a0d18$export$27e1563385d8bc4e);
    const $650b3b1ce62a0d18$export$27e1563385d8bc4e = ({ clauseMap: clauseMap, excludedFields: excludedFields, irremovableFields: irremovableFields })=>{
        const clausesByFieldId = {};
        const secondaryClausesByFieldId = {};
        const astClauseOrder = [];
        Object.keys(clauseMap).forEach((fieldId)=>{
            const fieldIsNotIrremovable = !irremovableFields.has(fieldId);
            const fieldIsNotYetIncluded = !astClauseOrder.includes(fieldId);
            const isNotExcludedField = !excludedFields.includes(fieldId);
            if (fieldIsNotIrremovable && fieldIsNotYetIncluded && isNotExcludedField) astClauseOrder.push(fieldId);
            if (isNotExcludedField) {
                const clauses = clauseMap[fieldId];
                clausesByFieldId[fieldId] = clauses && clauses[0] ? clauses[0] : undefined;
                secondaryClausesByFieldId[fieldId] = clauses && clauses[1] ? clauses[1] : undefined;
            }
        });
        return {
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        };
    };
});
parcelRegister("lzKFP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d7872117bccdccde$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $izCUH;
    var $kG16F;
    var $lW1IZ;
    var $b1PJk;
    var $f1i4L;
    const $d7872117bccdccde$export$407dcaf889e68e30 = ({ onLoad: onLoad, excludedFields: excludedFields, shouldUseListMarkup: shouldUseListMarkup, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, showOrderByPicker: showOrderByPicker })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const [ast] = (0, (0, parcelRequire("kG16F")).useAST)();
        const [{ astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId }] = (0, (0, parcelRequire("lW1IZ")).useSearchState)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            onLoad && onLoad();
        }, [
            onLoad
        ]);
        const { fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount } = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("b1PJk")).gatherIrremovableFields)({
                excludedFields: excludedFields,
                intl: intl,
                irremovableFields: irremovableFields,
                astClauseOrder: astClauseOrder,
                clausesByFieldId: clausesByFieldId,
                secondaryClausesByFieldId: secondaryClausesByFieldId
            }), [
            astClauseOrder,
            clausesByFieldId,
            excludedFields,
            intl,
            irremovableFields,
            secondaryClausesByFieldId
        ]);
        const orderByFieldCount = (0, $5uXOq.useMemo)(()=>showOrderByPicker ? (0, (0, parcelRequire("f1i4L")).getAstSortFields)(ast).length : undefined, [
            ast,
            showOrderByPicker
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("izCUH")).JQLEditorLoading), {
            fieldsToRender: fieldsToRender,
            optionalFieldsCount: optionalFieldsCount,
            shouldUseListMarkup: shouldUseListMarkup,
            hideTextSearchInput: hideTextSearchInput,
            showOrderByPicker: showOrderByPicker,
            orderByFieldsCount: orderByFieldCount
        });
    };
    var $d7872117bccdccde$export$2e2bcd8739ae039 = $d7872117bccdccde$export$407dcaf889e68e30;
});
parcelRegister("izCUH", function(module, exports) {
    $parcel$export(module.exports, "JQLEditorLoading", ()=>$dd8f44802117d048$export$30c56a653ec47247);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Dsab;
    var $8OILN;
    var $dnfgF;
    var $b1ym7;
    var $aFqsz;
    var $8DDZN;
    var $17Whx;
    const $dd8f44802117d048$export$30c56a653ec47247 = ({ fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount, orderByFieldsCount: orderByFieldsCount, shouldUseListMarkup: shouldUseListMarkup, hideTextSearchInput: hideTextSearchInput, showOrderByPicker: showOrderByPicker })=>{
        const FieldWrapper = shouldUseListMarkup ? (0, (0, parcelRequire("aFqsz")).StyledListItemChild) : (0, (0, parcelRequire("aFqsz")).StyledChild);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !hideTextSearchInput && (0, ($parcel$interopDefault($5uXOq))).createElement(FieldWrapper, {
            key: (0, (0, parcelRequire("5Dsab")).getTextSearchInputField)(),
            "data-testid": "jql-builder-basic-refinement-fallback"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17Whx")).TextSearchInputLoading), null)), fieldsToRender.map((fieldToRender)=>{
            const { clause: clause, picker: picker, fieldId: fieldId, fieldLabel: fieldLabel, isIrremovable: isIrremovable } = fieldToRender;
            if (!isIrremovable) return null;
            switch(picker.pickerType){
                case (0, (0, parcelRequire("8OILN")).PickerTypes).Picker:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(FieldWrapper, {
                        key: fieldId,
                        "data-testid": "jql-builder-basic-refinement-fallback"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b1ym7")).default), {
                        clause: clause,
                        fieldId: fieldId,
                        fieldDisplayName: fieldLabel,
                        fieldDescription: null,
                        isIrremovable: isIrremovable
                    }));
                default:
                    return null;
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(FieldWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dnfgF")).default), {
            optionalFieldsCount: optionalFieldsCount
        })), showOrderByPicker && (0, ($parcel$interopDefault($5uXOq))).createElement(FieldWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8DDZN")).default), {
            orderByFieldsCount: orderByFieldsCount ?? 0
        })));
    };
});
parcelRegister("dnfgF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c758ade4ad924bf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $16T6Y;
    var $fVnbM;
    var $7ymNM;
    var $koVbs;
    var $6fhxU;
    var $k6gg6;
    var $3AuGJ;
    const $6c758ade4ad924bf$var$AddFilterFallback = ({ optionalFieldsCount: optionalFieldsCount })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (optionalFieldsCount > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k6gg6")).LoadingStateAnimationWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "default",
            isSelected: true,
            onClick: (0, ($parcel$interopDefault($8Rkzz))),
            label: "addButton",
            testId: "jql-builder-basic.common.ui.add-filter-fallback.loading"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3AuGJ")).Container), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3AuGJ")).StyledLabel), null, formatMessage((0, (0, parcelRequire("6fhxU")).default).moreButton)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3AuGJ")).StyledBadge), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), {
            appearance: "primary"
        }, `+${optionalFieldsCount}`)))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "default",
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7ymNM"))))), {
                label: "addIcon",
                size: "small"
            }),
            isSelected: false,
            onClick: (0, ($parcel$interopDefault($8Rkzz))),
            label: "addButton",
            testId: "jql-builder-basic.common.ui.add-filter-fallback.loading"
        }, formatMessage((0, (0, parcelRequire("6fhxU")).default).moreButton));
    };
    var $6c758ade4ad924bf$export$2e2bcd8739ae039 = $6c758ade4ad924bf$var$AddFilterFallback;
});
parcelRegister("16T6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe7856b71523badd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $ehtcU;
    function $fe7856b71523badd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $fe7856b71523badd$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.200',
        display: 'inline-flex',
        blockSize: 'min-content',
        flexShrink: 0
    });
    const $fe7856b71523badd$var$neutral300 = '#DDDEE1';
    const $fe7856b71523badd$var$red300 = '#FD9891';
    const $fe7856b71523badd$var$blue300 = '#8FB8F6';
    const $fe7856b71523badd$var$neutral1000 = '#292A2E';
    const $fe7856b71523badd$var$styles = {
        root: {
            name: "85bcg3",
            styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
        },
        added: {
            name: "4x7cmh",
            styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
        },
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$neutral300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        important: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$red300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primary: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$blue300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primaryInverted: {
            name: "1425qmy",
            styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
        },
        removed: {
            name: "10hiq01",
            styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
        }
    };
    const $fe7856b71523badd$var$Badge = (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-testid": testId,
            css: [
                $fe7856b71523badd$var$styles.root,
                $fe7856b71523badd$var$styles[appearance]
            ],
            style: {
                background: style?.backgroundColor,
                color: style?.color
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            align: "center",
            color: "inherit"
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            as: "span",
            backgroundColor: $fe7856b71523badd$var$backgroundColors[appearance],
            xcss: $fe7856b71523badd$var$boxStyles,
            style: {
                background: style?.backgroundColor,
                color: style?.color
            },
            paddingInline: "space.075"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $fe7856b71523badd$var$textColors[appearance]
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
    });
    $fe7856b71523badd$var$Badge.displayName = 'Badge';
    var $fe7856b71523badd$export$2e2bcd8739ae039 = $fe7856b71523badd$var$Badge;
    const $fe7856b71523badd$var$backgroundColors = {
        added: 'color.background.success',
        default: 'color.background.neutral',
        important: 'color.background.danger.bold',
        primary: 'color.background.brand.bold',
        primaryInverted: 'elevation.surface',
        removed: 'color.background.danger'
    };
    const $fe7856b71523badd$var$textColors = {
        added: 'color.text.success',
        default: 'color.text',
        important: 'color.text.inverse',
        primary: 'color.text.inverse',
        primaryInverted: 'color.text.brand',
        removed: 'color.text.danger'
    };
});
parcelRegister("ehtcU", function(module, exports) {
    $parcel$export(module.exports, "formatValue", ()=>$24d41a560822020b$export$7c4d25c0c3217d8c);
    function $24d41a560822020b$var$getSafeValue(value = 0) {
        const numericValue = +value;
        if (numericValue < 0) return 0;
        return value;
    }
    function $24d41a560822020b$export$7c4d25c0c3217d8c(value, max) {
        const safeValue = $24d41a560822020b$var$getSafeValue(value);
        const safeMax = $24d41a560822020b$var$getSafeValue(max);
        if (safeMax && safeMax < safeValue) return `${safeMax}+`;
        if (safeValue === Infinity) return "\u221E";
        return safeValue.toString();
    }
});
parcelRegister("6fhxU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$919c599fa052caed$export$2e2bcd8739ae039);
    var $7VHMR;
    const $919c599fa052caed$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moreButton: {
            "id": "jql-builder-basic.common.more-button",
            "defaultMessage": "More"
        },
        refinementSearch: {
            "id": "jql-builder-basic.jql-editor.refinement-search",
            "defaultMessage": "Search issues"
        },
        searchCurrentPage: {
            "id": "jql-builder-basic.common.search-current-page",
            "defaultMessage": "Search on current page"
        },
        refinementSearchIssueTermRefresh: {
            "id": "jql-builder-basic.common.refinement-search-issue-term-refresh",
            "defaultMessage": "Search work"
        }
    });
    var $919c599fa052caed$export$2e2bcd8739ae039 = $919c599fa052caed$var$messages;
});
parcelRegister("k6gg6", function(module, exports) {
    $parcel$export(module.exports, "LoadingStateAnimationWrapper", ()=>$01a163aee5b9ae9b$export$c7a90a9f6120efb7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $01a163aee5b9ae9b$export$c7a90a9f6120efb7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _y44vkmg5",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3AuGJ", function(module, exports) {
    $parcel$export(module.exports, "TriggerComponentNoOperator", ()=>$5921bcde41c9c2f7$export$2d8feb52cd4e66ea);
    $parcel$export(module.exports, "Container", ()=>$5921bcde41c9c2f7$export$42a852a2b6b56249);
    $parcel$export(module.exports, "LabelContainer", ()=>$5921bcde41c9c2f7$export$f5ae33f1b01a6402);
    $parcel$export(module.exports, "StyledLabel", ()=>$5921bcde41c9c2f7$export$eea83358d9434634);
    $parcel$export(module.exports, "StyledBadge", ()=>$5921bcde41c9c2f7$export$1eb8c4092e3d2863);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $16T6Y;
    const $5921bcde41c9c2f7$export$96bdbc84526f3739 = (value)=>Array.isArray(value) ? value.length > 0 : typeof value === 'object' && value !== null;
    const $5921bcde41c9c2f7$export$2d8feb52cd4e66ea = ({ isInvalid: isInvalid = false, label: label = '', value: value })=>{
        if (!value || !$5921bcde41c9c2f7$export$96bdbc84526f3739(value)) return (0, ($parcel$interopDefault($5uXOq))).createElement($5921bcde41c9c2f7$export$42a852a2b6b56249, null, (0, ($parcel$interopDefault($5uXOq))).createElement($5921bcde41c9c2f7$export$f5ae33f1b01a6402, {
            "data-testid": (0, $227fa8a1aa91f085$export$743be55d5cf4a20d)
        }, label));
        const valueMap = value.map((v)=>v.optionType !== 'error' && v.label !== undefined ? v.label : '');
        const valueLength = valueMap.length;
        const [firstValue, ...rest] = valueMap;
        const badgeAppearance = isInvalid ? 'important' : 'primary';
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5921bcde41c9c2f7$export$42a852a2b6b56249, null, (0, ($parcel$interopDefault($5uXOq))).createElement($5921bcde41c9c2f7$export$f5ae33f1b01a6402, {
            "data-testid": (0, $227fa8a1aa91f085$export$743be55d5cf4a20d)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5921bcde41c9c2f7$export$eea83358d9434634, null, label, ":"), firstValue), valueLength > 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement($5921bcde41c9c2f7$export$1eb8c4092e3d2863, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), {
            testId: (0, $227fa8a1aa91f085$export$fca2db27fe6c1305),
            appearance: badgeAppearance
        }, `+${rest.length}`)) : null);
    };
    const $5921bcde41c9c2f7$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $5921bcde41c9c2f7$export$f5ae33f1b01a6402 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12fo812 _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
    const $5921bcde41c9c2f7$export$eea83358d9434634 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p8n31 _2hwx1b66",
                __cmplp.className
            ])
        });
    });
    const $5921bcde41c9c2f7$export$1eb8c4092e3d2863 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _18u01b66",
                __cmplp.className
            ])
        });
    });
});
const $227fa8a1aa91f085$export$743be55d5cf4a20d = 'jql-builder-basic.common.ui.format-label.label-container';
const $227fa8a1aa91f085$export$fca2db27fe6c1305 = 'jql-builder-basic.common.ui.format-label.badge';
parcelRegister("b1ym7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7da778154ab24786$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $4Hz9T;
    const $7da778154ab24786$export$15138d86eb9e97c3 = ({ label: label = '' })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7da778154ab24786$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($7da778154ab24786$var$LabelContainer, null, label));
    const $7da778154ab24786$var$PickerFallback = ({ clause: clause, fieldId: fieldId, fieldDisplayName: fieldDisplayName, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Hz9T")).default), {
            isInvalid: false,
            isSelected: false,
            hasValues: !!clause,
            onClick: (0, ($parcel$interopDefault($8Rkzz))),
            testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
            isLoading: !!clause,
            fieldDescription: fieldDescription,
            isIrremovable: isIrremovable
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7da778154ab24786$export$15138d86eb9e97c3, {
            label: fieldDisplayName
        }));
    var $7da778154ab24786$export$2e2bcd8739ae039 = $7da778154ab24786$var$PickerFallback;
    const $7da778154ab24786$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $7da778154ab24786$var$LabelContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _p12fo812 _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4Hz9T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58abe43cfea5235b$export$2e2bcd8739ae039);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $gtreQ;
    var $c8Oei;
    var $cgL5K;
    var $3bDjY;
    var $ousew;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $5Dsab;
    var $90Iri;
    var $kyiZW;
    var $k6gg6;
    var $izo0U;
    const $58abe43cfea5235b$var$Button = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _ju3gewfl _mt1tewfl",
                __cmplp.className
            ])
        });
    });
    const $58abe43cfea5235b$var$isKeyboardEvent = (event)=>event.key !== undefined;
    const $58abe43cfea5235b$var$PickerTrigger = (0, $5uXOq.forwardRef)(({ children: children, isInvalid: isInvalid, isSelected: isSelected, isLoading: isLoading, hasValues: hasValues, onClick: onClick, onClear: onClear, testId: testId, searchTemplate: searchTemplate, fieldDescription: fieldDescription, isIrremovable: isIrremovable = false }, ref)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleOnClear = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            const isKeyboard = $58abe43cfea5235b$var$isKeyboardEvent(e);
            const shouldClear = isKeyboard && (e.key === 'Enter' || e.key === ' ') || !isKeyboard;
            onClear && shouldClear && onClear();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'removeFilter', {
                keyboard: isKeyboard
            });
        }, [
            createAnalyticsEvent,
            onClear
        ]);
        if (isLoading === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k6gg6")).LoadingStateAnimationWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            isSelected: true,
            testId: `${testId}.loading`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$var$ButtonContent, null, children)));
        const Content = (0, ($parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$var$ButtonContent, null, searchTemplate === (0, (0, parcelRequire("5Dsab")).EPIC_LINK).searchTemplate && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("izo0U")).default).deprecatedEpicLinkMessage,
                values: {
                    strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                            as: "strong",
                            color: "inherit",
                            size: "UNSAFE_small"
                        }, chunks)
                }
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$var$IconWrapperLeft, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
            label: "",
            primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y400})`,
            size: "small"
        }))), children);
        const IconAfterContent = (0, ($parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$var$IconWrapper, {
            visualRefresh: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
        }, fieldDescription && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kyiZW")).FieldDescriptionPopup), {
            fieldDescription: fieldDescription,
            isParentPickerActive: hasValues || isSelected
        }), !isIrremovable ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("90Iri")).ClearButton), {
            onClick: handleOnClear,
            label: intl.formatMessage((0, (0, parcelRequire("izo0U")).default).removeField)
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            label: "",
            color: "currentColor"
        }));
        return isInvalid ? (0, ($parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$export$332fba2134818c97, {
            isSelected: isSelected || hasValues,
            onClick: onClick,
            ref: ref,
            testId: testId,
            iconAfter: IconAfterContent
        }, Content) : (0, ($parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$var$Button, {
            isSelected: isSelected || hasValues,
            "aria-expanded": isSelected,
            onClick: onClick,
            ref: ref,
            testId: testId,
            iconAfter: IconAfterContent
        }, Content);
    });
    var $58abe43cfea5235b$export$2e2bcd8739ae039 = $58abe43cfea5235b$var$PickerTrigger;
    const $58abe43cfea5235b$var$ButtonContent = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y",
                __cmplp.className
            ])
        });
    });
    const $58abe43cfea5235b$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_gg26t5": (0, (0, parcelRequire("lD23V")).default)(__cmplp.visualRefresh ? "var(--ds-space-0, 0px)" : "var(--ds-space-negative-075, -6px)")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _2hwxyz14",
                __cmplp.className
            ])
        });
    });
    const $58abe43cfea5235b$var$IconWrapperLeft = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwx1b66 _18u01i6y",
                __cmplp.className
            ])
        });
    });
    const $58abe43cfea5235b$export$332fba2134818c97 = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$var$Button, {
            ...props,
            ref: ref,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1w90y6er _16hge569 _zelmy6er _1fh1y6er _18y1e569 _u1mbe569"
            ])
        }));
    const $58abe43cfea5235b$var$styles = null;
    const $58abe43cfea5235b$export$27305c69e65286e6 = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1mh3 _30l34pxi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("90Iri", function(module, exports) {
    $parcel$export(module.exports, "ClearButton", ()=>$7764ff8b7abaa99a$export$13ec83e50bf04290);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $aFYTH;
    const $7764ff8b7abaa99a$export$13ec83e50bf04290 = ({ label: label, onClick: onClick })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7764ff8b7abaa99a$var$StyledClearButton, {
            tabIndex: "0",
            role: "button",
            onClick: onClick,
            onKeyPress: onClick,
            "data-testid": "jql-editor-basic.common.ui.clear-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("aFYTH"))))), {
            color: "currentColor",
            label: label
        }));
    var $7764ff8b7abaa99a$export$2e2bcd8739ae039 = $7764ff8b7abaa99a$export$13ec83e50bf04290;
    const $7764ff8b7abaa99a$var$StyledClearButton = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _syaz17iv _f8pj10mn _7ehi1vt6 _nt751r31 _49pcglyw _1hvw1o36 _vn891l7b _30l310mn",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aFYTH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c5cf8a572bea882$var$_react = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7c5cf8a572bea882$var$_cross = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("bjGSs")));
    var $7c5cf8a572bea882$var$_close = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("2C7j9")));
    function $7c5cf8a572bea882$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c5cf8a572bea882$var$CrossIcon = (props)=>$7c5cf8a572bea882$var$_react.default.createElement($7c5cf8a572bea882$var$_cross.default, Object.assign({
            LEGACY_fallbackIcon: $7c5cf8a572bea882$var$_close.default
        }, props));
    $7c5cf8a572bea882$var$CrossIcon.Name = 'CrossIconMigration';
    var $7c5cf8a572bea882$var$_default = module.exports.default = $7c5cf8a572bea882$var$CrossIcon;
});
parcelRegister("2C7j9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
    function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>$1e74cc92a54dd799$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
        }, props, {
            newIcon: $1e74cc92a54dd799$var$_close.default
        }));
    $1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
    var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;
});
parcelRegister("kyiZW", function(module, exports) {
    $parcel$export(module.exports, "FieldDescriptionPopup", ()=>$0e776a0cc6b017ab$export$8adaffb2a3e09bc3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $kkuz9;
    var $1I7E8;
    var $3bDjY;
    var $9fuVs;
    var $47gW9;
    var $7XluA;
    var $4mO32;
    var $koVbs;
    var $5Dsab;
    var $6Srtb;
    var $aD513;
    var $7UbtS;
    const $0e776a0cc6b017ab$var$entryPointParams = {};
    const $0e776a0cc6b017ab$export$8adaffb2a3e09bc3 = ({ fieldDescription: fieldDescription, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false, isParentPickerActive: isParentPickerActive })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(shouldOpenOnFirstRender);
        const toggleOpenCloseState = (0, $5uXOq.useCallback)(()=>{
            setIsOpen((currentIsOpenValue)=>!currentIsOpenValue);
        }, []);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("aD513")).default), $0e776a0cc6b017ab$var$entryPointParams);
        const buttonTrigger = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(entryPointActions);
        const renderContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: (0, $b0f3fc705d61334f$export$723ee4d7411b97b4),
                packageName: (0, (0, parcelRequire("5Dsab")).PACKAGE_NAME),
                errorFallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Srtb")).ContentBox), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Srtb")).ContentError), null)),
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Srtb")).ContentBox), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Srtb")).ContentLoading), null)),
                runtimeProps: {
                    fieldDescription: fieldDescription
                }
            }), [
            entryPointReferenceSubject,
            fieldDescription
        ]);
        const renderTrigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage((0, (0, parcelRequire("7UbtS")).default).showDescription),
                position: "top"
            }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement($0e776a0cc6b017ab$var$Trigger, {
                    ...tooltipProps,
                    ...triggerProps,
                    ref: (element)=>{
                        buttonTrigger(element);
                        tooltipProps.ref(element);
                        triggerProps.ref(element);
                    },
                    isOpen: isOpen,
                    isParentPickerActive: isParentPickerActive,
                    onClick: (e)=>{
                        e.stopPropagation();
                        toggleOpenCloseState();
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kkuz9"))))), {
                    label: isOpen ? formatMessage((0, (0, parcelRequire("7UbtS")).default).hideDescription) : formatMessage((0, (0, parcelRequire("7UbtS")).default).showDescription)
                }))), [
            buttonTrigger,
            formatMessage,
            isOpen,
            isParentPickerActive,
            toggleOpenCloseState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-start",
            content: renderContent,
            trigger: renderTrigger
        }), isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null));
    };
    const $0e776a0cc6b017ab$var$Trigger = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isOpen: isOpen, isParentPickerActive: isParentPickerActive, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_o4jtyu": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isParentPickerActive ? (0, $829f609a65d26a98$export$9fdfb749e33cdf97) : (0, $829f609a65d26a98$export$c39c0fe0f26207ae))
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19itglyw _bfhk18uv _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _f8pj10mn _7ehi1vt6 _nt751r31 _49pcglyw _1hvw1o36 _vn891l7b _30l310mn",
                __cmplp.isOpen ? "_syaz17u6" : "_syaz17iv",
                __cmplp.className
            ])
        });
    });
});
const $b0f3fc705d61334f$export$723ee4d7411b97b4 = 'field-description-popup-content';
parcelRegister("6Srtb", function(module, exports) {
    $parcel$export(module.exports, "ContentBox", ()=>$7e60d592ad923b2d$export$2966b8ec97c144ae);
    $parcel$export(module.exports, "ContentError", ()=>$7e60d592ad923b2d$export$f2a1a543c1677898);
    $parcel$export(module.exports, "ContentLoading", ()=>$7e60d592ad923b2d$export$199be3e6e7e83c08);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $34Rrn;
    var $hD8l9;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $eZJjh;
    var $koVbs;
    var $dCm1o;
    var $iiJVH;
    const $7e60d592ad923b2d$export$2966b8ec97c144ae = ({ children: children })=>{
        const propagationTrap = (e)=>e.stopPropagation();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            padding: "space.150",
            xcss: $7e60d592ad923b2d$var$contentBoxStyles,
            onClick: propagationTrap,
            tabIndex: 0
        }, children);
    };
    const $7e60d592ad923b2d$export$f2a1a543c1677898 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center"
        }, !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement($7e60d592ad923b2d$var$FlexRow, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("34Rrn"))))), {
            label: "",
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("hD8l9"))))),
            LEGACY_size: "xlarge",
            LEGACY_primaryColor: "color.text",
            color: "var(--ds-icon-warning, #E56910)",
            testId: "jql-builder-basic.common.ui.field-description-popup-common.editor-warning-icon"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($7e60d592ad923b2d$var$FlexRow, null, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $7e60d592ad923b2d$var$warningIconStyle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("34Rrn"))))), {
            label: "",
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("hD8l9"))))),
            LEGACY_size: "xlarge",
            LEGACY_primaryColor: "color.text",
            color: "var(--ds-icon-warning, #E56910)",
            testId: "jql-builder-basic.common.ui.field-description-popup-common.editor-warning-icon"
        })), formatMessage((0, (0, parcelRequire("iiJVH")).default).error)));
    };
    const $7e60d592ad923b2d$export$199be3e6e7e83c08 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            testId: "jql-builder-basic.common.ui.field-description-popup-common.spinner",
            size: "small"
        });
    const $7e60d592ad923b2d$var$contentBoxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxWidth: '300px',
        maxHeight: '300px',
        overflow: 'auto',
        outline: 'none'
    });
    const $7e60d592ad923b2d$var$FlexRow = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _y3gn1h6o _syaz1fxt",
                __cmplp.className
            ])
        });
    });
    const $7e60d592ad923b2d$var$warningIconStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.100',
        display: 'inline'
    });
});
parcelRegister("hD8l9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cd5c8c5b40614fc0$var$_react = $cd5c8c5b40614fc0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $cd5c8c5b40614fc0$var$_warning = $cd5c8c5b40614fc0$var$_interopRequireDefault((parcelRequire("34Rrn")));
    function $cd5c8c5b40614fc0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cd5c8c5b40614fc0$var$EditorWarningIcon = (props)=>$cd5c8c5b40614fc0$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
        }, props, {
            newIcon: $cd5c8c5b40614fc0$var$_warning.default
        }));
    $cd5c8c5b40614fc0$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
    var $cd5c8c5b40614fc0$var$_default = module.exports.default = $cd5c8c5b40614fc0$var$EditorWarningIcon;
});
parcelRegister("iiJVH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8bc850f0f20c3659$export$2e2bcd8739ae039);
    var $7VHMR;
    const $8bc850f0f20c3659$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        error: {
            "id": "jql-builder-basic.common.field-description-popup-common.error",
            "defaultMessage": "We cannot show the field description at this time. Please refresh to try again."
        }
    });
    var $8bc850f0f20c3659$export$2e2bcd8739ae039 = $8bc850f0f20c3659$var$messages;
});
parcelRegister("aD513", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c439a020623e24f3$export$2e2bcd8739ae039);
    var $eufEc;
    var $fEDBv;
    const $c439a020623e24f3$var$FieldDescriptionContentEntryPoint = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("kM1rq")), {
            moduleId: "91602efd"
        }),
        getPreloadProps: ()=>({})
    });
    var $c439a020623e24f3$export$2e2bcd8739ae039 = $c439a020623e24f3$var$FieldDescriptionContentEntryPoint;
});
parcelRegister("kM1rq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gHy5x")
    ]).then(()=>parcelRequire('5mAw8'));
});
parcelRegister("7UbtS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ca72366f29682d4$export$2e2bcd8739ae039);
    var $7VHMR;
    const $6ca72366f29682d4$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        showDescription: {
            "id": "jql-builder-basic.common.field-description-popup.show-description",
            "defaultMessage": "Show the description for this field"
        },
        hideDescription: {
            "id": "jql-builder-basic.common.field-description-popup.hide-description",
            "defaultMessage": "Hide the description for this field"
        }
    });
    var $6ca72366f29682d4$export$2e2bcd8739ae039 = $6ca72366f29682d4$var$messages;
});
parcelRegister("izo0U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b80dd7b4460f7661$export$2e2bcd8739ae039);
    var $7VHMR;
    const $b80dd7b4460f7661$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        removeField: {
            "id": "jql-builder-basic.common.picker-trigger.remove-field",
            "defaultMessage": "Remove field"
        },
        deprecatedEpicLinkMessage: {
            "id": "jql-builder-basic.common.picker-trigger.deprecated-epic-link-message",
            "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>."
        }
    });
    var $b80dd7b4460f7661$export$2e2bcd8739ae039 = $b80dd7b4460f7661$var$messages;
});
parcelRegister("aFqsz", function(module, exports) {
    $parcel$export(module.exports, "StyledChild", ()=>$9d12758baec1c265$export$8133811dea85f484);
    $parcel$export(module.exports, "StyledListItemChild", ()=>$9d12758baec1c265$export$b24abe39371fec57);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $9d12758baec1c265$export$8133811dea85f484 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8u49m _1ul9idpf",
                __cmplp.className
            ])
        });
    });
    const $9d12758baec1c265$export$b24abe39371fec57 = (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s89ng6 _1ul9idpf _qtt8glyw",
                __cmplp.className
            ])
        });
    });
    const $9d12758baec1c265$export$999ca5bf223f627 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1mjv",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8DDZN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb19a4d5cffc2857$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k6gg6;
    var $bRlQB;
    const $fb19a4d5cffc2857$var$ORDER_BY_LOADING_BUTTON_ID = 'jql-builder-basic-order-by-trigger-loading';
    const $fb19a4d5cffc2857$var$OrderByPickerLoading = ({ orderByFieldsCount: orderByFieldsCount })=>orderByFieldsCount > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k6gg6")).LoadingStateAnimationWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bRlQB")).default), {
            numberOfFields: orderByFieldsCount,
            buttonId: $fb19a4d5cffc2857$var$ORDER_BY_LOADING_BUTTON_ID,
            isSelected: true
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bRlQB")).default), {
            numberOfFields: orderByFieldsCount,
            buttonId: $fb19a4d5cffc2857$var$ORDER_BY_LOADING_BUTTON_ID,
            isSelected: false
        });
    var $fb19a4d5cffc2857$export$2e2bcd8739ae039 = $fb19a4d5cffc2857$var$OrderByPickerLoading;
});
parcelRegister("bRlQB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$256a08af8fc686a4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $16T6Y;
    var $eCeGD;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $koVbs;
    var $b7WzA;
    var $bbrNS;
    const $256a08af8fc686a4$var$OrderByButton = ({ onClick: onClick, numberOfFields: numberOfFields, triggerProps: triggerProps, buttonId: buttonId, isSelected: isSelected })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const label = numberOfFields ? formatMessage((0, (0, parcelRequire("b7WzA")).default).labelNameWithBadge, {
            fieldCount: numberOfFields
        }) : formatMessage((0, (0, parcelRequire("b7WzA")).default).name);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            ...triggerProps,
            id: buttonId,
            isSelected: Boolean(numberOfFields) || isSelected,
            onClick: onClick,
            iconAfter: (...iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $256a08af8fc686a4$var$iconContainerStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bbrNS")).default), {
                    ...iconProps,
                    size: "small",
                    label: ""
                })),
            "aria-label": label,
            testId: "jql-builder-basic.common.ui.order-by-trigger-button.button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.050"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, formatMessage((0, (0, parcelRequire("b7WzA")).default).name)), Boolean(numberOfFields) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), {
            appearance: "primary"
        }, numberOfFields))));
    };
    var $256a08af8fc686a4$export$2e2bcd8739ae039 = $256a08af8fc686a4$var$OrderByButton;
    const $256a08af8fc686a4$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingRight: 'space.050',
        paddingTop: 'space.025'
    });
});
parcelRegister("b7WzA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ffa5089e7ddea1c$export$2e2bcd8739ae039);
    var $7VHMR;
    'src/packages/jql-builder/basic/src/ui/jql-editor/order-by-picker/trigger-button/messages.tsx';
    const $5ffa5089e7ddea1c$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        name: {
            "id": "jql-builder-basic.common.order-by-trigger-button.name",
            "defaultMessage": "Order"
        },
        labelNameWithBadge: {
            "id": "jql-builder-basic.common.order-by-trigger-button.label-name-with-badge",
            "defaultMessage": "Order, currently {fieldCount, plural, other {# fields} one {# field}} selected"
        }
    });
    var $5ffa5089e7ddea1c$export$2e2bcd8739ae039 = $5ffa5089e7ddea1c$var$messages;
});
parcelRegister("bbrNS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19e6120943fc1adf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $19e6120943fc1adf$var$sortOrderGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 16 16",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label']
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "none",
            d: "M1.7749 3.25001L4.24978 0.775132L6.72465 3.25001M14.2251 10.75L11.7502 13.2249L9.27535 10.75M11.75 12.5V0.75M4.25 13.25L4.25 1.50001",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "square",
            strokeLinejoin: "round"
        }));
    const $19e6120943fc1adf$var$SortIcon = ({ label: label, size: size = 'medium' })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $19e6120943fc1adf$var$sortOrderGlyph,
            label: label,
            size: size
        });
    var $19e6120943fc1adf$export$2e2bcd8739ae039 = $19e6120943fc1adf$var$SortIcon;
});
parcelRegister("17Whx", function(module, exports) {
    $parcel$export(module.exports, "TextSearchInputLoading", ()=>$0e5aab6ab62a608c$export$d8de07f8c0b1e278);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $6s1PB;
    var $koVbs;
    var $kG16F;
    var $8RcVP;
    var $ibQjx;
    var $6fhxU;
    var $4TUUg;
    const $0e5aab6ab62a608c$export$d8de07f8c0b1e278 = ()=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const [textSearchInputClause] = (0, (0, parcelRequire("kG16F")).useTextSearchInputClause)();
        const value = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("ibQjx")).removeSurroundingQuotes)((0, (0, parcelRequire("8RcVP")).default).value(textSearchInputClause) || ''), [
            textSearchInputClause
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4TUUg")).default), {
            label: intl.formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("6fhxU")).default).refinementSearchIssueTermRefresh : (0, (0, parcelRequire("6fhxU")).default).refinementSearch),
            value: value,
            onChange: (0, ($parcel$interopDefault($8Rkzz))),
            isDisabled: true
        });
    };
});
parcelRegister("ibQjx", function(module, exports) {
    $parcel$export(module.exports, "removeSurroundingQuotes", ()=>$ee9ecbb7ad59ed78$export$8de447c869ac6d85);
    const $ee9ecbb7ad59ed78$export$8de447c869ac6d85 = (maybeQuotedString)=>maybeQuotedString.replace(/^["']|["']$/g, '');
});
parcelRegister("4TUUg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cdc5b4c13c9152e8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lFKmC = parcelRequire("lFKmC");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2xSAL;
    var $dCm1o;
    const $cdc5b4c13c9152e8$var$debounceOnChange = (0, ($parcel$interopDefault($lFKmC)))(({ onSendOptionAnalytics: onSendOptionAnalytics = (0, ($parcel$interopDefault($8Rkzz))), onChange: onChange, targetValue: targetValue })=>{
        onChange(targetValue);
        onSendOptionAnalytics({
            searchStringLength: targetValue ? targetValue.length : 0
        });
    }, 500, {
        leading: false,
        trailing: true
    });
    const $cdc5b4c13c9152e8$var$TextField = ({ inputRef: inputRef, label: label, value: value, isDisabled: isDisabled = false, onChange: onChange, onFocus: onFocus, onSendOptionAnalytics: onSendOptionAnalytics })=>{
        const handleChange = (0, $5uXOq.useCallback)((targetValue)=>{
            $cdc5b4c13c9152e8$var$debounceOnChange({
                onChange: onChange,
                targetValue: targetValue,
                onSendOptionAnalytics: onSendOptionAnalytics
            });
        }, [
            onChange,
            onSendOptionAnalytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($cdc5b4c13c9152e8$var$StyledContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2xSAL")).SearchField), {
            onChange: handleChange,
            onFocus: onFocus,
            value: value,
            placeholder: label,
            placeholderAlwaysVisible: true,
            isCompact: true,
            isResponsive: true,
            inputRef: inputRef,
            testId: "jql-builder-basic.common.ui.text-field.search-field",
            isDisabled: isDisabled,
            showIconBeforeInput: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
        }));
    };
    var $cdc5b4c13c9152e8$export$2e2bcd8739ae039 = $cdc5b4c13c9152e8$var$TextField;
    const $cdc5b4c13c9152e8$var$StyledContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2xSAL", function(module, exports) {
    $parcel$export(module.exports, "SearchField", ()=>$f115db1c327fbbaa$export$b94867ecbd698f21);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $fW62l = parcelRequire("fW62l");
    var $2NMNM;
    var $kY99m;
    var $koVbs;
    var $dCm1o;
    var $cBssJ;
    var $hJBhl;
    var $5yLnO;
    const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
    const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
        const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const textInput = (0, $5uXOq.useRef)(null);
        const previousValueRef = (0, $5uXOq.useRef)();
        const previousValue = previousValueRef.current;
        if (externalValue !== previousValue && externalValue !== value) setValue(externalValue);
        previousValueRef.current = externalValue;
        const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
            setIsFocused(true);
            onFocus && onFocus(event);
        }, [
            onFocus
        ]);
        const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur && onBlur(event);
            setIsFocused(false);
        }, [
            onBlur
        ]);
        const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
            const { value: val } = currentTarget;
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue(val);
            onChange(val, analyticsEvent);
        }, [
            createAnalyticsEvent,
            onChange
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            if (event.key === 'Escape') {
                setValue('');
                onChange('', analyticsEvent);
            }
            if (onEnter && event.keyCode === (0, ($parcel$interopDefault($fW62l)))('enter')) {
                event.preventDefault();
                onEnter(event.currentTarget && event.currentTarget.value);
            }
        }, [
            createAnalyticsEvent,
            onChange,
            onEnter
        ]);
        const handleOnClear = (0, $5uXOq.useCallback)(()=>{
            if (value !== '') {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'changed'
                });
                setValue('');
                onChange('', analyticsEvent);
            }
            if (inputRef && inputRef.current !== null) inputRef.current.blur();
            if (textInput.current !== null) textInput.current.blur();
        }, [
            createAnalyticsEvent,
            inputRef,
            onChange,
            value
        ]);
        const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
        const textFieldProps = {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, (0, parcelRequire("cBssJ")).messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $f115db1c327fbbaa$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
        const searchIconDynamic = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIconDynamic), {
            onClear: handleOnClear,
            hasValue: value !== '',
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear),
            searchIconVisible: searchIconVisible,
            primaryColor: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
            onlyIconSpacing: isResponsive && !isExpanded
        });
        const searchIcon = showIconBeforeInput ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIcon), {
            searchIconVisible: searchIconVisible,
            onlyIconSpacing: isResponsive && !isExpanded
        }) : undefined;
        const clearIcon = showIconBeforeInput && value !== '' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJBhl")).ClearFieldIcon), {
            onClear: handleOnClear,
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear)
        }) : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
            shouldFitContainerWidth: shouldFitContainerWidth
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
            isExpanded: isExpanded,
            shouldFitContainerWidth: shouldFitContainerWidth,
            increasedWidth: increasedWidth,
            maxWidth: increasedWidth ? 328 : 184,
            placeholderAlwaysVisible: placeholderAlwaysVisible,
            isResponsive: isResponsive
        }, renderCustomSearchField !== undefined ? renderCustomSearchField({
            textFieldProps: textFieldProps,
            searchIcon: searchIconDynamic
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            ...textFieldProps,
            elemBeforeInput: searchIcon,
            elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
            ...id !== undefined ? {
                id: id
            } : {}
        })));
    };
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
    const $f115db1c327fbbaa$export$b94867ecbd698f21 = (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
    $f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search';
    const $f115db1c327fbbaa$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.shouldFitContainerWidth && "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $f115db1c327fbbaa$var$InputWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1et2rhb": (0, (0, parcelRequire("lD23V")).default)(__cmplp.maxWidth, "px"),
                "--_47juog": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
                "--_5cv8rq": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : '32px'),
                "--_jy5l88": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
                "--_1skyi4s": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : 0),
                "--_1qenfck": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 1 : 0),
                "--_1b7586u": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
                "--_1b72lxu": (0, (0, parcelRequire("lD23V")).default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
                __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
                __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cBssJ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$08273d4fc2a6d6da$export$defe85febe8b728c);
    var $7VHMR;
    const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clear: {
            "id": "searchfield.clear",
            "defaultMessage": "Clear"
        },
        search: {
            "id": "searchfield.search",
            "defaultMessage": "Search"
        }
    });
});
parcelRegister("hJBhl", function(module, exports) {
    $parcel$export(module.exports, "ClearFieldIcon", ()=>$99940a7c159b00c0$export$84038b503874befa);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $i28qQ;
    var $dC5iT;
    var $h9kUS;
    var $8CUq3;
    const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $99940a7c159b00c0$var$wrapperStylesCloseIcon
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            testId: "searchfield.ui.clearfield-icon.clear-button",
            onClick: onClear,
            label: clearIconLabel,
            spacing: "compact",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("i28qQ")))))
        }));
    const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginRight: 'space.025',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginRight: 'space.050'
        }
    });
});
parcelRegister("5yLnO", function(module, exports) {
    $parcel$export(module.exports, "SearchFieldIconDynamic", ()=>$71cc18983db63a0d$export$9eef03e91cdeba14);
    $parcel$export(module.exports, "SearchFieldIcon", ()=>$71cc18983db63a0d$export$8a82bff895521bd9);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $84THj;
    var $26g7Y;
    var $hyOJh;
    var $dC5iT;
    var $h9kUS;
    var $8CUq3;
    const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
        const akSearchIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("26g7Y"))))), {
            LEGACY_size: "small",
            label: "",
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        });
        const searchIcon = searchIconVisible ? akSearchIcon : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStyles,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
            ]
        }, hasValue ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            spacing: "none",
            "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
            testId: "searchfield.ui.searchfield-icon.clear-button",
            onClick: onClear,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("84THj"))))), {
                LEGACY_size: "small",
                label: clearIconLabel,
                LEGACY_primaryColor: primaryColor,
                color: "currentColor"
            })
        }) : searchIcon);
    };
    const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStylesBefore,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
            ]
        }, searchIconVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyOJh"))))), {
            spacing: "none",
            label: "",
            color: "var(--ds-icon, #44546F)"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null));
    const $71cc18983db63a0d$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.accent.gray',
        marginTop: 'space.0',
        marginRight: 'space.100',
        marginBottom: 'space.0',
        marginLeft: 'space.0',
        height: '16px',
        display: 'flex'
    });
    const $71cc18983db63a0d$var$spacingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginRight: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$wrapperStylesBefore = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginRight: 'space.0',
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$spacingStylesBefore = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
});
parcelRegister("b1PJk", function(module, exports) {
    $parcel$export(module.exports, "gatherFields", ()=>$c6d9a58efc4e5979$export$af0604ea1b6b60ec);
    $parcel$export(module.exports, "gatherIrremovableFields", ()=>$c6d9a58efc4e5979$export$2965c0f6ab2d5c39);
    var $ifg6x = parcelRequire("ifg6x");
    var $7qDUb = parcelRequire("7qDUb");
    var $i0Cp4;
    var $89g1C;
    const $c6d9a58efc4e5979$var$getDataFromHydratedData = ({ fieldsHydratedData: fieldsHydratedData })=>{
        const fieldsData = {};
        (fieldsHydratedData?.jira?.jqlBuilder?.hydrateJqlQuery ?? fieldsHydratedData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.forEach((hydratedField)=>{
            if (hydratedField.field && hydratedField.jqlTerm) {
                const { field: { displayName: displayName, searchTemplate: searchTemplate, type: type, description: description, operators: operators, fieldType: fieldType, shouldShowInContext: shouldShowInContext }, jqlTerm: jqlTerm } = hydratedField;
                if (searchTemplate?.key == null || type == null) return;
                if (!fieldsData[jqlTerm.toLowerCase()]) fieldsData[jqlTerm.toLowerCase()] = {
                    displayName: displayName,
                    searchTemplate: searchTemplate.key,
                    fieldType: type,
                    fieldDescription: description ?? null,
                    fieldTypeDisplayName: fieldType?.displayName ?? null,
                    operators: operators.map((0, (0, parcelRequire("89g1C")).mapOperators)),
                    isDuplicated: false,
                    shouldShowInContext: shouldShowInContext ?? true
                };
                else fieldsData[jqlTerm.toLowerCase()].isDuplicated = true;
            }
        });
        return fieldsData;
    };
    const $c6d9a58efc4e5979$var$getOptionalFieldsToRender = ({ astClauseOrder: astClauseOrder, selectedFields: selectedFields, fieldsData: fieldsData, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId, excludedFields: excludedFields })=>{
        const allFields = [
            ...new Set([
                ...astClauseOrder,
                ...selectedFields.map((sf)=>sf.value.toLowerCase())
            ])
        ];
        const selectedFieldsData = selectedFields.reduce((map, selectedField)=>{
            map[selectedField.value.toLowerCase()] = {
                displayName: selectedField.label,
                searchTemplate: selectedField.searchTemplate,
                fieldType: selectedField.fieldType,
                fieldDescription: selectedField.fieldDescription,
                operators: selectedField.operators,
                fieldTypeDisplayName: selectedField.fieldTypeDisplayName,
                isDuplicated: false,
                shouldShowInContext: true
            };
            return map;
        }, {});
        const [fieldsWithHydration, fieldsMissingHydration] = (0, ($parcel$interopDefault($ifg6x)))(allFields, (fieldId)=>fieldsData[fieldId] ?? selectedFieldsData[fieldId]);
        const optionalFieldsToRender = fieldsWithHydration.filter((fieldId)=>!excludedFields.includes(fieldId)).map((fieldId)=>{
            const fieldData = fieldsData[fieldId] ?? selectedFieldsData[fieldId];
            const { isDuplicated: isDuplicated, searchTemplate: searchTemplate, fieldType: fieldType, displayName: displayName, fieldDescription: fieldDescription, operators: operators, fieldTypeDisplayName: fieldTypeDisplayName, shouldShowInContext: shouldShowInContext } = fieldData;
            const fieldToRender = {
                fieldId: fieldId,
                fieldLabel: displayName ?? undefined,
                fieldDescription: fieldDescription,
                fieldTypeDisplayName: fieldTypeDisplayName,
                shouldShowInContext: shouldShowInContext,
                ...isDuplicated ? {
                    picker: (0, (0, parcelRequire("i0Cp4")).getUnsupportedPickerType)({
                        searchTemplate: searchTemplate,
                        fieldType: fieldType
                    }),
                    clause: undefined,
                    secondaryClause: undefined
                } : {
                    picker: (0, (0, parcelRequire("i0Cp4")).getPickerType)({
                        searchTemplate: searchTemplate,
                        fieldType: fieldType,
                        operators: operators
                    }),
                    clause: clausesByFieldId[fieldId],
                    secondaryClause: secondaryClausesByFieldId[fieldId]
                }
            };
            return fieldToRender;
        });
        return {
            optionalFieldsToRender: optionalFieldsToRender,
            fieldsMissingHydration: fieldsMissingHydration
        };
    };
    const $c6d9a58efc4e5979$var$getIrremovableFieldsToRender = ({ clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId, excludedFields: excludedFields, irremovableFields: irremovableFields })=>{
        const irremovableFieldsToRender = [];
        irremovableFields.forEach((irremovableField)=>{
            const isIrremovableFieldConfiguredAsExcludedField = excludedFields.includes(irremovableField.jqlTerm);
            if (!isIrremovableFieldConfiguredAsExcludedField) irremovableFieldsToRender.push({
                isIrremovable: true,
                fieldId: irremovableField.jqlTerm,
                fieldLabel: irremovableField.displayName,
                picker: (0, (0, parcelRequire("i0Cp4")).getPickerType)({
                    searchTemplate: irremovableField.searchTemplate,
                    fieldType: irremovableField.fieldType,
                    operators: irremovableField.operators
                }),
                fieldDescription: null,
                fieldTypeDisplayName: null,
                clause: clausesByFieldId[irremovableField.jqlTerm],
                secondaryClause: secondaryClausesByFieldId[irremovableField.jqlTerm]
            });
        });
        return irremovableFieldsToRender;
    };
    const $c6d9a58efc4e5979$export$af0604ea1b6b60ec = ({ selectedFields: selectedFields, excludedFields: excludedFields = [], intl: intl, fieldsHydratedData: fieldsHydratedData, previousFieldToRender: previousFieldToRender = [], irremovableFields: irremovableFields, astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId })=>{
        const { optionalFieldsToRender: optionalFieldsToRender, fieldsMissingHydration: fieldsMissingHydration } = $c6d9a58efc4e5979$var$getOptionalFieldsToRender({
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            fieldsData: $c6d9a58efc4e5979$var$getDataFromHydratedData({
                fieldsHydratedData: fieldsHydratedData
            }),
            secondaryClausesByFieldId: secondaryClausesByFieldId,
            selectedFields: selectedFields,
            excludedFields: excludedFields
        });
        const fieldsToRender = $c6d9a58efc4e5979$var$getIrremovableFieldsToRender({
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId,
            excludedFields: excludedFields,
            intl: intl,
            irremovableFields: irremovableFields
        }).concat(optionalFieldsToRender);
        const missingHydration = fieldsMissingHydration.length > 0;
        let sortedFieldsToRender = fieldsToRender;
        if (previousFieldToRender.length > 0) {
            const previousFieldToRendeFieldIds = previousFieldToRender.map((field)=>field.fieldId);
            sortedFieldsToRender = (0, ($parcel$interopDefault($7qDUb)))(fieldsToRender, (fieldToRender)=>{
                const index = previousFieldToRendeFieldIds.indexOf(fieldToRender.fieldId);
                return index === -1 ? previousFieldToRendeFieldIds.length : index;
            });
        }
        return {
            fieldsToRender: sortedFieldsToRender,
            optionalFieldsCount: astClauseOrder.length,
            missingHydration: missingHydration
        };
    };
    const $c6d9a58efc4e5979$export$2965c0f6ab2d5c39 = ({ excludedFields: excludedFields = [], intl: intl, irremovableFields: irremovableFields, astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId })=>{
        const fieldsToRender = $c6d9a58efc4e5979$var$getIrremovableFieldsToRender({
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId,
            excludedFields: excludedFields,
            intl: intl,
            irremovableFields: irremovableFields
        });
        return {
            fieldsToRender: fieldsToRender,
            optionalFieldsCount: astClauseOrder.length,
            missingHydration: true
        };
    };
});
parcelRegister("f1i4L", function(module, exports) {
    $parcel$export(module.exports, "getAstSortFields", ()=>$3c27ae72e6f3583d$export$dcd0fae6e8b9823a);
    const $3c27ae72e6f3583d$export$dcd0fae6e8b9823a = (ast)=>{
        if (ast && ast.query && ast.query.orderBy) return ast.query.orderBy.fields.map((orderByFieldFromAst)=>({
                jqlTerm: orderByFieldFromAst.field.value,
                direction: orderByFieldFromAst.direction ? orderByFieldFromAst.direction.value : undefined
            }));
        return [];
    };
});
parcelRegister("cg4FO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3ZBUM")
    ]).then(()=>parcelRequire('kWbha'));
});
parcelRegister("3fufq", function(module, exports) {
    $parcel$export(module.exports, "SearchModeSwitcher", ()=>$f745ad211a5a5809$export$639730063e548c7);
    $parcel$export(module.exports, "SearchModeSwitcherWithTarget", ()=>$f745ad211a5a5809$export$ed9a97307608e2d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cgL5K;
    var $3bDjY;
    var $koVbs;
    var $5Czte;
    var $1aUn4;
    var $dCm1o;
    var $032ey;
    var $16gY8;
    const $f745ad211a5a5809$export$639730063e548c7 = ({ isBasicModeDisabled: isBasicModeDisabled, onUpdateSearchMode: onUpdateSearchMode, searchMode: searchMode })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const testIdPrefix = 'issue-navigator.ui.refinement-bar.search-mode-switcher.toggle-button.';
        const options = [
            {
                id: (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC),
                label: isBasicModeDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: formatMessage((0, (0, parcelRequire("16gY8")).messages).basicModeDisabledTooltip),
                    tag: "span"
                }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    as: "span"
                }, formatMessage((0, (0, parcelRequire("16gY8")).messages).basicMode)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    size: "UNSAFE_small",
                    weight: "semibold",
                    color: "inherit"
                }, formatMessage((0, (0, parcelRequire("16gY8")).messages).basicMode))) : formatMessage((0, (0, parcelRequire("16gY8")).messages).basicMode),
                isDisabled: isBasicModeDisabled,
                testId: `${testIdPrefix}${(0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC)}`
            },
            {
                id: (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED),
                label: formatMessage((0, (0, parcelRequire("16gY8")).messages).advancedMode),
                testId: `${testIdPrefix}${(0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED)}`
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aUn4")).default), {
            label: formatMessage((0, (0, parcelRequire("16gY8")).messages).label),
            options: options,
            selectedOption: searchMode,
            onChange: (value)=>onUpdateSearchMode(value)
        });
    };
    const $f745ad211a5a5809$export$ed9a97307608e2d9 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Czte")).NinChangeboardingTourTarget), {
            engagementId: "nin.jql-builder.searchmode-switcher"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f745ad211a5a5809$export$639730063e548c7, props));
});
parcelRegister("5Czte", function(module, exports) {
    $parcel$export(module.exports, "NinChangeboardingContext", ()=>$56f2750f0b6ae1db$export$b349f970aff316d8);
    $parcel$export(module.exports, "EnableNinChangeboardingProvider", ()=>$56f2750f0b6ae1db$export$dd1deacfc61c978a);
    $parcel$export(module.exports, "NinChangeboardingTourTarget", ()=>$56f2750f0b6ae1db$export$eb95770b90ecc1f3);
    $parcel$export(module.exports, "NinChangeboardingTourCard", ()=>$56f2750f0b6ae1db$export$7c27d65549066b5);
    $parcel$export(module.exports, "useGlobalScopeOptInFlag", ()=>$56f2750f0b6ae1db$export$9e9f507adee88e58);
    var $5uXOq = parcelRequire("5uXOq");
    var $6s1PB;
    var $pa9q9;
    var $5Zxxp;
    var $1oOi0;
    var $fB2N8;
    var $6s4Eg;
    var $eiUE8;
    const $56f2750f0b6ae1db$export$b349f970aff316d8 = (0, $5uXOq.createContext)(false);
    const $56f2750f0b6ae1db$export$dd1deacfc61c978a = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($56f2750f0b6ae1db$export$b349f970aff316d8.Provider, {
            value: true
        }, children);
    const $56f2750f0b6ae1db$export$eb95770b90ecc1f3 = ({ children: children, engagementId: engagementId })=>{
        const isTourEnabled = (0, $5uXOq.useContext)($56f2750f0b6ae1db$export$b349f970aff316d8);
        if (!isTourEnabled) return children;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6s4Eg")).default), {
            engagementId: engagementId
        }, children);
    };
    const $56f2750f0b6ae1db$export$7c27d65549066b5 = ({ mode: mode, view: view, hasIssueResults: hasIssueResults, isAiEnabled: isAiEnabled })=>{
        const isTourEnabled = (0, $5uXOq.useContext)($56f2750f0b6ae1db$export$b349f970aff316d8);
        if (!isTourEnabled) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fB2N8")).AsyncSpotlightCard), {
            mode: mode,
            view: view,
            hasIssueResults: hasIssueResults,
            isAiEnabled: isAiEnabled
        });
    };
    const $56f2750f0b6ae1db$export$9e9f507adee88e58 = ()=>{
        const isFlagEnabled = (0, $5uXOq.useContext)($56f2750f0b6ae1db$export$b349f970aff316d8);
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const onOpenInProductHelpArticle = (0, (0, parcelRequire("5Zxxp")).useHelpPanelLink)();
        const onLearnMore = (0, $5uXOq.useCallback)(()=>{
            onOpenInProductHelpArticle((0, (0, parcelRequire("1oOi0")).LEARN_MORE_IPH_ARTICLE_ID));
        }, [
            onOpenInProductHelpArticle
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const shouldShowOptInFlag = sessionStorage.getItem('showNinOptInFlag');
            if (isFlagEnabled && shouldShowOptInFlag === 'true') {
                showFlag({
                    type: 'success',
                    title: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eiUE8")).default).successOptInTitleIssueTermRefresh : (0, (0, parcelRequire("eiUE8")).default).successOptInTitle,
                    description: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eiUE8")).default).successOptInDescIssueTermRefresh : (0, (0, parcelRequire("eiUE8")).default).successOptInDesc,
                    actions: [
                        {
                            content: (0, (0, parcelRequire("eiUE8")).default).successActionLearnMoreLink,
                            onClick: onLearnMore
                        }
                    ],
                    isAutoDismiss: false,
                    testId: 'issue-navigator-changeboarding.optin-success-flag'
                });
                sessionStorage.removeItem('showNinOptInFlag');
            }
        }, []);
    };
});
parcelRegister("1oOi0", function(module, exports) {
    $parcel$export(module.exports, "FALLBACK_SUPPORT_ARTICLE", ()=>$43fa307c6841ead5$export$ff66aa7a4971d979);
    $parcel$export(module.exports, "LEARN_MORE_IPH_ARTICLE_ID", ()=>$43fa307c6841ead5$export$88d16e35389ab3c6);
    $parcel$export(module.exports, "getEngagementPlatformlMessageId", ()=>$43fa307c6841ead5$export$91074f0ada4f4533);
    $parcel$export(module.exports, "TOUR_MESSAGE_ID", ()=>$43fa307c6841ead5$export$4ac775bda929f47);
    $parcel$export(module.exports, "views", ()=>$43fa307c6841ead5$export$d0079916fe6800ac);
    const $43fa307c6841ead5$export$565b01733f42b193 = 'https://community.atlassian.com/t5/Jira-articles/We-re-bringing-updates-to-the-issue-navigator/ba-p/2096660';
    const $43fa307c6841ead5$export$ff66aa7a4971d979 = 'https://support.atlassian.com/jira-software-cloud/docs/search-for-issues-in-jira/';
    const $43fa307c6841ead5$export$88d16e35389ab3c6 = '3FGQv6n7fB93yWWTYqY0hq';
    const $43fa307c6841ead5$export$91074f0ada4f4533 = (id)=>`${id}-march2024`;
    const $43fa307c6841ead5$export$4ac775bda929f47 = 'nin-changeboarding-start';
    const $43fa307c6841ead5$export$6c69c3d1b5f6fe55 = {
        basic: 'basic',
        advanced: 'advanced'
    };
    const $43fa307c6841ead5$export$d0079916fe6800ac = {
        list: 'list-view',
        detail: 'split-view'
    };
});
parcelRegister("fB2N8", function(module, exports) {
    $parcel$export(module.exports, "AsyncSpotlightCard", ()=>$a20090c0d2e5eb6a$export$40e85aa59c198f98);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $a20090c0d2e5eb6a$var$SpotlightCard = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("h24l5")), {
        ssr: false,
        moduleId: "./src/packages/issue-navigator/changeboarding/src/common/ui/spotlight/spotlight-card/index.tsx"
    });
    const $a20090c0d2e5eb6a$export$40e85aa59c198f98 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            packageName: "jiraIssueNavigatorChangeboarding",
            id: "async-spotlight-card",
            sendToPrivacyUnsafeSplunk: true,
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-spotlight-card",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a20090c0d2e5eb6a$var$SpotlightCard, props)));
});
parcelRegister("h24l5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("epMgw").then(()=>parcelRequire('dqR1S'));
});
parcelRegister("6s4Eg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60c5b26aae55f177$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Fk4Z;
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $60c5b26aae55f177$var$EngagementSpotlightAsync = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("9zmsr")).then(({ EngagementSpotlight: EngagementSpotlight })=>EngagementSpotlight), {
        ssr: false,
        moduleId: "../platform/packages/personalization/engagekit-ts/src/index.ts"
    });
    const $60c5b26aae55f177$var$SpotlightTourTarget = ({ children: children, engagementId: engagementId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: engagementId
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            packageName: "jiraIssueNavigatorChangeboarding",
            id: "async-engagement-spotlight",
            sendToPrivacyUnsafeSplunk: true,
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-engagement-spotlight"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($60c5b26aae55f177$var$EngagementSpotlightAsync, {
            engagementId: engagementId
        }))));
    var $60c5b26aae55f177$export$2e2bcd8739ae039 = $60c5b26aae55f177$var$SpotlightTourTarget;
});
parcelRegister("9zmsr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ePxTo")
    ]).then(()=>parcelRequire('k4MwF'));
});
parcelRegister("eiUE8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$172614e7cfb99d43$export$2e2bcd8739ae039);
    var $7VHMR;
    const $172614e7cfb99d43$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        successOptInTitle: {
            "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title",
            "defaultMessage": "You've switched to the new issue search"
        },
        successOptInDesc: {
            "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc",
            "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for issues across Jira."
        },
        successActionLearnMoreLink: {
            "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-action-learn-more-link",
            "defaultMessage": "Learn more"
        },
        successOptInTitleIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title-issue-term-refresh",
            "defaultMessage": "You've switched to the new search"
        },
        successOptInDescIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc-issue-term-refresh",
            "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for work across Jira."
        }
    });
    var $172614e7cfb99d43$export$2e2bcd8739ae039 = $172614e7cfb99d43$var$messages;
});
parcelRegister("1aUn4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3938a8ce9ce3c5ba$export$2e2bcd8739ae039);
    var $7XYc4;
    var $dCm1o;
    var $6maaD;
    var $1AOfx;
    var $3938a8ce9ce3c5ba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), (0, (0, parcelRequire("6maaD")).ToggleButtons), (0, (0, parcelRequire("1AOfx")).default));
});
parcelRegister("6maaD", function(module, exports) {
    $parcel$export(module.exports, "ToggleButtons", ()=>$5bbd957d88c15d3d$export$34301fadafd0cd9d);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    const $5bbd957d88c15d3d$export$34301fadafd0cd9d = ({ options: options, selectedOption: selectedOption, onChange: onChange, label: label, isCompact: isCompact })=>{
        const getButtonWithContext = (0, $5uXOq.useCallback)(({ option: option, isSelected: isSelected })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                key: option.id,
                role: "radio",
                "aria-checked": isSelected,
                xcss: [
                    $5bbd957d88c15d3d$var$baseStyles,
                    !isCompact && $5bbd957d88c15d3d$var$wideStyles,
                    isSelected && $5bbd957d88c15d3d$var$selectedStyles
                ],
                onClick: (event)=>!isSelected && onChange(option.id, event),
                isDisabled: option.isDisabled,
                testId: option.testId
            }, option.label), [
            onChange,
            isCompact
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            role: "radiogroup",
            xcss: $5bbd957d88c15d3d$var$containerStyles,
            "aria-label": label,
            as: "fieldset"
        }, options.map((option)=>getButtonWithContext({
                option: option,
                isSelected: option.id === selectedOption
            }))));
    };
    const $5bbd957d88c15d3d$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderColor: 'color.border',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: "var(--ds-border-radius-100, 4px)",
        paddingInline: 'space.025',
        gap: 'space.025',
        display: 'inline-flex',
        alignItems: 'center',
        height: '2rem'
    });
    const $5bbd957d88c15d3d$var$baseStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-neutral-subtle, #00000000)",
        border: '1px solid transparent',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        color: 'color.text.subtle',
        height: '26px',
        fontWeight: '500',
        padding: 'space.0',
        ':hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            color: 'color.text.subtle'
        },
        ':active': {
            background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
            color: 'color.text.subtle'
        },
        ':focus': {
            outlineOffset: 'space.0'
        },
        ':disabled': {
            background: "var(--ds-background-disabled, #091E4208)",
            color: 'color.text.disabled'
        }
    });
    const $5bbd957d88c15d3d$var$selectedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-selected, #E9F2FF)",
        border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
        color: 'color.text.selected',
        cursor: 'default',
        ':hover': {
            background: "var(--ds-background-selected, #E9F2FF)",
            color: 'color.text.selected'
        }
    });
    const $5bbd957d88c15d3d$var$wideStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.150',
        paddingRight: 'space.150'
    });
});
parcelRegister("1AOfx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3d0d9bc4668d1db$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gwIPs;
    var $iR4uK;
    var $gmQXa;
    let $b3d0d9bc4668d1db$var$uniqueId = 0;
    var $b3d0d9bc4668d1db$export$2e2bcd8739ae039 = ({ label: label, options: options, selectedOption: selectedOption, onChange: onChange })=>{
        (0, (0, parcelRequire("gmQXa")).assertPrecondition)(()=>({
                precondition: options.length > 0,
                message: `ToggleButtons requires at least one option, but received ${options.length}`
            }));
        (0, (0, parcelRequire("gmQXa")).assertPrecondition)(()=>({
                precondition: (0, (0, parcelRequire("gmQXa")).findDuplicateIds)(options) === null,
                message: `ToggleButtons requires that every option has a unique ID, but received "${(0, (0, parcelRequire("gmQXa")).findDuplicateIds)(options)}" multiple times`
            }));
        (0, (0, parcelRequire("gmQXa")).assertPrecondition)(()=>({
                precondition: options.findIndex((option)=>option.id === selectedOption) !== -1,
                message: `ToggleButtons requires that the selectedOption matches the ID of one of the passed options, but "${selectedOption}" did not`
            }));
        const [id] = (0, $5uXOq.useState)(()=>`toggle-buttons-${$b3d0d9bc4668d1db$var$uniqueId++}`);
        const fieldsetRef = (0, $5uXOq.useRef)(null);
        const selectedOptionRef = (0, $5uXOq.useRef)();
        const [selectedOptionPosition, setSelectedOptionPosition] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            const fieldset = fieldsetRef.current;
            if (!fieldset || !window.ResizeObserver) return ()=>{};
            const resizeObserver = new window.ResizeObserver(()=>{
                const element = selectedOptionRef.current;
                if (element) setSelectedOptionPosition({
                    left: element.offsetLeft,
                    top: element.offsetTop,
                    width: element.offsetWidth,
                    height: element.offsetHeight
                });
            });
            resizeObserver.observe(fieldset);
            return ()=>{
                resizeObserver.unobserve(fieldset);
            };
        }, [
            selectedOption
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b3d0d9bc4668d1db$var$Fieldset, {
            ref: fieldsetRef,
            selectedOptionPosition: selectedOptionPosition
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("legend", null, label), options.map((option)=>{
            const isChecked = selectedOption === option.id;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iR4uK")).default), {
                key: option.id,
                name: id,
                value: option.id,
                isChecked: isChecked,
                isDisabled: !!option.isDisabled,
                onChange: onChange,
                ref: isChecked ? selectedOptionRef : undefined,
                testId: option.testId
            }, option.label);
        }));
    };
    const $b3d0d9bc4668d1db$var$selectedOptionIndicator = {
        backgroundColor: `${`var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N0})`} !important`,
        borderRadius: `${(0, (0, parcelRequire("gwIPs")).borderRadius)}px !important`
    };
    const $b3d0d9bc4668d1db$var$Fieldset = (0, $5uXOq.forwardRef)(({ as: C = "fieldset", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { selectedOptionPosition: selectedOptionPosition, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_ozn9do": (0, (0, parcelRequire("lD23V")).default)(__cmplp.selectedOptionPosition?.left, "px"),
                "--_1ibdxcf": (0, (0, parcelRequire("lD23V")).default)(__cmplp.selectedOptionPosition?.top, "px"),
                "--_1ggrzjo": (0, (0, parcelRequire("lD23V")).default)(__cmplp.selectedOptionPosition?.width, "px"),
                "--_1797z6d": (0, (0, parcelRequire("lD23V")).default)(__cmplp.selectedOptionPosition?.height, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1n261g80 _1bsb1ris _p12f1osq _kqswh2mm _bfhk1s4m _2rko1l7b _1yt41b66 _11c8qk37 _k48p1pd9 _vwz41clk _1p1dangw _syazaj1x _1r9t7mnp _ho6m1wmp _soiet94y _1se6t94y _1jdg1n1a _z71v1n1a _1o5t1n1a _irrs1n1a _p8t715vq _b4u715vq _1qiiidpf _12o6idpf _19mbidpf _1ob8idpf _1jhnstnw _10bvh2mm _1nvfze3t _1nei1b66 _rt2pze3t _bmksze3t _fhioidpf _1kt9b3bt _1cs8stnw _1rus1tag _rfx31wa3 _qs2z1l1k _1cg61yx9 _mlfedkwg",
                __cmplp.selectedOptionPosition ? "_cfu11ule" : "_cfu1glyw",
                __cmplp.selectedOptionPosition?.left ? "_qnecejz7" : "_qnecidpf",
                __cmplp.selectedOptionPosition?.top ? "_1auk1nuc" : "_1aukidpf",
                __cmplp.selectedOptionPosition?.width ? "_1mp412nj" : "_1mp4idpf",
                __cmplp.selectedOptionPosition?.height ? "_kfgt1d85" : "_kfgtidpf",
                !__cmplp.selectedOptionPosition && "_15e91tag _1ph31wa3",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iR4uK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e56adc76929ce8ab$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $e56adc76929ce8ab$export$2e2bcd8739ae039 = (0, $5uXOq.forwardRef)(({ name: name, value: value, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, children: children, testId: testId }, ref)=>{
        const id = `${name}-${value}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e56adc76929ce8ab$var$Container, {
            ref: ref
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            type: "radio",
            id: id,
            name: name,
            value: value,
            checked: isChecked,
            disabled: isDisabled,
            "data-testid": testId,
            onChange: (event)=>onChange(value, event)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("label", {
            htmlFor: id
        }, children));
    });
    const $e56adc76929ce8ab$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11127mnp _1q091wmp _pytkt94y _5hv9t94y _2x4g1n1a _12hv1n1a _x5bd1n1a _1rgf1n1a _1yzy15vq _bgrh15vq _v69yidpf _ogxmidpf _1qtqidpf _n9z4idpf _khufstnw _15pj1ule _136ejjoz _1vzltlke _1ioh1l7b _1hhy73ad _1emz73ad _1efl8q0r _7el91vt6 _15pqglyw _vrjh14ae _c2fy18uv _ynfu18uv",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("gmQXa", function(module, exports) {
    $parcel$export(module.exports, "findDuplicateIds", ()=>$1d35542953a1be7d$export$e5f5e25214715ca1);
    $parcel$export(module.exports, "assertPrecondition", ()=>$1d35542953a1be7d$export$5565eefbe4b468a0);
    const $1d35542953a1be7d$export$e5f5e25214715ca1 = (options)=>{
        for(let i = 0; i < options.length - 1; ++i)for(let j = i + 1; j < options.length; ++j){
            if (options[i].id === options[j].id) return options[i].id;
        }
        return null;
    };
    const $1d35542953a1be7d$export$5565eefbe4b468a0 = (evaluatePrecondition)=>{};
});
parcelRegister("16gY8", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$fab52cd589ab817a$export$defe85febe8b728c);
    var $7VHMR;
    const $fab52cd589ab817a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "jql-builder.search-mode-switcher.label",
            "defaultMessage": "Select search mode"
        },
        basicModeDisabledTooltip: {
            "id": "jql-builder.search-mode-switcher.basic-mode-disabled-tooltip",
            "defaultMessage": "You can't switch to basic as the query is too complex or is invalid"
        },
        basicMode: {
            "id": "jql-builder.search-mode-switcher.basic-mode",
            "defaultMessage": "Basic"
        },
        advancedMode: {
            "id": "jql-builder.search-mode-switcher.advanced-mode",
            "defaultMessage": "JQL"
        }
    });
});
parcelRegister("kdzZz", function(module, exports) {
    $parcel$export(module.exports, "DefaultJqlBuilderContainer", ()=>$5d734fc2527ab532$export$ef9307b2d2a6d612);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $5d734fc2527ab532$export$ef9307b2d2a6d612 = ({ showAdvancedEditor: showAdvancedEditor, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $5d734fc2527ab532$var$jqlBuilderContainerStyles,
                showAdvancedEditor ? $5d734fc2527ab532$var$jqlBuilderContainerAdvancedStyles : $5d734fc2527ab532$var$jqlBuilderContainerBasicStyles
            ]
        }, children);
    const $5d734fc2527ab532$var$jqlBuilderContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        flexGrow: 1
    });
    const $5d734fc2527ab532$var$jqlBuilderContainerBasicStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexWrap: 'wrap',
        marginTop: 'space.negative.025',
        marginRight: 'space.negative.050',
        marginBottom: 'space.200',
        marginLeft: 'space.negative.025'
    });
    const $5d734fc2527ab532$var$jqlBuilderContainerAdvancedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.negative.025',
        marginRight: 'space.negative.050',
        marginBottom: 'space.negative.050',
        marginLeft: 'space.negative.025'
    });
});
parcelRegister("8xRQz", function(module, exports) {
    $parcel$export(module.exports, "SearchModeSwitcherContainer", ()=>$b50f5561c6df80cb$export$c9785cf59aeeda5f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $3HwlS;
    const $b50f5561c6df80cb$export$c9785cf59aeeda5f = ({ testId: testId, children: children, isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b50f5561c6df80cb$var$getContainerXcss(isSearchModeSwitcherOnLeft),
            testId: testId
        }, children);
    const $b50f5561c6df80cb$var$getContainerXcss = (isSearchModeSwitcherOnLeft)=>{
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) {
            if (isSearchModeSwitcherOnLeft) return [
                $b50f5561c6df80cb$var$searchModeSwitcherBaseContainerStyle
            ];
            return [
                $b50f5561c6df80cb$var$searchModeSwitcherBaseContainerStyle,
                $b50f5561c6df80cb$var$searchModeSwitcherRightAlignedContainerStyle
            ];
        }
        return [
            $b50f5561c6df80cb$var$searchModeSwitcherContainerStyle
        ];
    };
    const $b50f5561c6df80cb$var$searchModeSwitcherBaseContainerStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        alignSelf: 'start',
        minHeight: "var(--ds-space-400, 32px)",
        display: 'flex'
    });
    const $b50f5561c6df80cb$var$searchModeSwitcherRightAlignedContainerStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.025',
        marginLeft: 'space.100'
    });
    const $b50f5561c6df80cb$var$searchModeSwitcherContainerStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.100',
        alignSelf: 'start',
        marginTop: 'space.025',
        minHeight: "var(--ds-space-400, 32px)",
        display: 'flex'
    });
});
parcelRegister("jX4vm", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$3048b7aecf50a50c$export$42a852a2b6b56249);
    $parcel$export(module.exports, "BasicEditorListContainer", ()=>$3048b7aecf50a50c$export$5937a18186f4570f);
    $parcel$export(module.exports, "AdvancedEditorWrapper", ()=>$3048b7aecf50a50c$export$500c96524dd0cfc7);
    $parcel$export(module.exports, "Divider", ()=>$3048b7aecf50a50c$export$2e0a83ec2e27ecbb);
    $parcel$export(module.exports, "BeforeJqlBuilderContainer", ()=>$3048b7aecf50a50c$export$c139d55dec6a3c8a);
    $parcel$export(module.exports, "BeforeJqlBuilderListItemContainer", ()=>$3048b7aecf50a50c$export$4245b33623eb8df4);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $3048b7aecf50a50c$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $3048b7aecf50a50c$export$5937a18186f4570f = (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1n261g80 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _rcujidpf _o81cidpf _1l6uidpf _149midpf",
                __cmplp.className
            ])
        });
    });
    const $3048b7aecf50a50c$var$negativeMarginOffsetStyles = {
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
    };
    const $3048b7aecf50a50c$export$500c96524dd0cfc7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _18s89ng6",
                __cmplp.className
            ])
        });
    });
    const $3048b7aecf50a50c$export$2e0a83ec2e27ecbb = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _4t3izwfg _19pk1b66 _18u01b66 _1yt4x7n9 _vchhusvi _1kl7h6cr",
                __cmplp.className
            ])
        });
    });
    const $3048b7aecf50a50c$export$c139d55dec6a3c8a = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s89ng6",
                __cmplp.className
            ])
        });
    });
    const $3048b7aecf50a50c$export$4245b33623eb8df4 = (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s89ng6 _qtt8glyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("g9ghO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$88f954ca0498c9f0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4R6GH;
    var $dCm1o;
    var $jX4vm;
    const $88f954ca0498c9f0$var$StyledChild = (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw",
                __cmplp.className
            ])
        });
    });
    const $88f954ca0498c9f0$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlidpf _1o9zidpf",
                __cmplp.className
            ])
        });
    });
    const $88f954ca0498c9f0$var$ExtraControls = ({ searchMode: searchMode, renderExtraControls: renderExtraControls, shouldUseListMarkup: shouldUseListMarkup })=>{
        const extraControls = (0, $5uXOq.useMemo)(()=>renderExtraControls(), [
            renderExtraControls
        ]);
        const shouldApplyVisualRefreshChanges = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_2');
        const content = shouldUseListMarkup ? extraControls.map((Component, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($88f954ca0498c9f0$var$StyledChild, {
                key: index
            }, index === 0 && !shouldApplyVisualRefreshChanges && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX4vm")).Divider), null), (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                searchMode: searchMode
            }))) : (0, ($parcel$interopDefault($5uXOq))).createElement($88f954ca0498c9f0$var$Container, null, !shouldApplyVisualRefreshChanges && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX4vm")).Divider), null), extraControls.map((Component, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                key: index,
                searchMode: searchMode
            })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, extraControls.length > 0 && content);
    };
    var $88f954ca0498c9f0$export$2e2bcd8739ae039 = $88f954ca0498c9f0$var$ExtraControls;
});
parcelRegister("gFE9c", function(module, exports) {
    $parcel$export(module.exports, "JQLBuilderUIImplOld", ()=>$6173244194fe7b03$export$8d394b0b8f88059a);
    $parcel$export(module.exports, "JQLBuilderUIImpl", ()=>$6173244194fe7b03$export$d33754885f040153);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $jcw0u;
    var $5Czte;
    var $isD5C;
    var $imju0;
    var $7ckRQ;
    var $8vNru;
    var $caSpf;
    var $3HwlS;
    var $8zOmE;
    var $5oFIy;
    var $2NMNM;
    var $imS60;
    var $032ey;
    var $kdzZz;
    var $1PKzp;
    var $k3Vq9;
    var $jX4vm;
    var $g9ghO;
    var $ixr8x;
    const $6173244194fe7b03$export$8d394b0b8f88059a = ({ analyticsSource: analyticsSource, query: query, onSearch: onSearchProp, onUpdate: onUpdate, beforeControls: beforeControls, renderExtraControls: renderExtraControls, isSearching: isSearching, onLoad: onLoad, onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, jqlMessages: jqlMessages, excludedFields: excludedFields, searchModes: searchModes, selectedSearchMode: selectedSearchMode, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, components: components, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchModeSwitcherLocation: searchModeSwitcherLocation, showOrderByPicker: showOrderByPicker, contextJql: contextJql, loadingModeRef: loadingModeRef, ...props })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const irremovableFieldsAnalyticsAttributes = (0, (0, parcelRequire("7ckRQ")).useIrremovableFieldsAnalyticsAttributes)(irremovableFields);
        const { searchMode: searchMode, setSelectedSearchMode: setSelectedSearchMode } = (0, (0, parcelRequire("1PKzp")).useSelectedSearchMode)();
        const onPerformanceMark = (0, (0, parcelRequire("caSpf")).usePerformanceContext)();
        const onSwitchToJql = (0, $5uXOq.useCallback)(()=>{
            setSelectedSearchMode((0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED), true);
        }, [
            setSelectedSearchMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const jqlErrors = (jqlMessages || []).filter((e)=>e.type === 'error');
            if (jqlErrors?.length) {
                const errorAnalyticsEvent = createAnalyticsEvent({});
                (0, (0, parcelRequire("jcw0u")).default)({
                    event: errorAnalyticsEvent,
                    meta: {
                        id: 'jqlBuilderJqlInvalid',
                        packageName: 'jiraJqlBuilder',
                        teamName: 'empanada'
                    },
                    attributes: {
                        queryMode: searchMode
                    }
                });
            }
        }, []);
        const onJqlBuilderAdvancedReady = (0, $5uXOq.useCallback)(()=>{
            onPerformanceMark({
                mark: (0, (0, parcelRequire("8vNru")).JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_ADVANCED_JS_END
            });
            onReady && onReady((0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED));
        }, [
            onPerformanceMark,
            onReady
        ]);
        const onJqlBuilderBasicReady = (0, $5uXOq.useCallback)(()=>{
            onReady && onReady((0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC));
        }, [
            onReady
        ]);
        let onSearch = onSearchProp;
        if (onSearchProp) onSearch = (jql)=>{
            onSearchProp(jql);
            const event = createAnalyticsEvent({
                action: 'submitted',
                actionSubject: 'search'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'jqlBuilder', {
                searchMode: searchMode
            });
        };
        const { SearchModeSwitcher: SearchModeSwitcher, EditorContainer: CustomEditorContainer } = components ?? {};
        const isSearchModeToggleEnabled = searchModes ? searchModes.length > 1 : true;
        const isSearchModeSwitcherOnLeft = searchModeSwitcherLocation === (0, (0, parcelRequire("032ey")).SEARCH_MODE_SWITCHER_LEFT_LOCATION) && (0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
        const SearchModeSwitcherComponent = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ixr8x")).SearchModeSwitcherRenderer), {
                isSearchModeToggleEnabled: isSearchModeToggleEnabled,
                SearchModeSwitcher: SearchModeSwitcher,
                isHydrating: isHydrating,
                isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
            }), [
            SearchModeSwitcher,
            isHydrating,
            isSearchModeSwitcherOnLeft,
            isSearchModeToggleEnabled
        ]);
        const Editor = (0, $5uXOq.useMemo)(()=>{
            let jqlBuilderComponent;
            switch(searchMode){
                case 0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC:
                    jqlBuilderComponent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
                        name: "jql-builder-basic"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imju0")).JQLBuilderBasicOldAsync), {
                        query: query,
                        onSearch: onSearch || onUpdate || (0, ($parcel$interopDefault($8Rkzz))),
                        onSwitchToJql: onSwitchToJql,
                        excludedFields: excludedFields,
                        onReady: onJqlBuilderBasicReady,
                        onJourneyStart: onJourneyStart,
                        NoOptionComponent: NoOptionComponent,
                        hydrationQueryRef: hydrationQueryRef,
                        isHydrating: isHydrating,
                        shouldUseListMarkup: true,
                        hideOperatorDropdown: hideOperatorDropdownBasicMode,
                        irremovableFields: irremovableFields,
                        hideTextSearchInput: hideTextSearchInput,
                        showOrderByPicker: showOrderByPicker,
                        contextJql: contextJql,
                        ...props
                    }));
                    break;
                default:
                    jqlBuilderComponent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
                        name: "jql-builder-advanced"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Czte")).NinChangeboardingTourTarget), {
                        engagementId: "nin.jql-builder.advanced"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX4vm")).AdvancedEditorWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isD5C")).default), {
                        analyticsSource: analyticsSource,
                        onSearch: onSearch,
                        onUpdate: onUpdate,
                        query: query,
                        jqlMessages: jqlMessages,
                        isSearching: isSearching,
                        isCompact: true,
                        excludedAutocompleteFields: excludedFields,
                        onReady: onJqlBuilderAdvancedReady,
                        onJourneyStart: onJourneyStart,
                        ...props
                    }))));
            }
            const BeforeJqlBuilderWrapper = searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC) ? (0, (0, parcelRequire("jX4vm")).BeforeJqlBuilderListItemContainer) : (0, (0, parcelRequire("jX4vm")).BeforeJqlBuilderContainer);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, beforeControls && (0, ($parcel$interopDefault($5uXOq))).createElement(BeforeJqlBuilderWrapper, null, beforeControls), isSearchModeSwitcherOnLeft && (0, ($parcel$interopDefault($5uXOq))).createElement(BeforeJqlBuilderWrapper, null, SearchModeSwitcherComponent), jqlBuilderComponent, renderExtraControls && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g9ghO")).default), {
                searchMode: searchMode,
                renderExtraControls: renderExtraControls,
                shouldUseListMarkup: searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC)
            }));
        }, [
            searchMode,
            beforeControls,
            isSearchModeSwitcherOnLeft,
            SearchModeSwitcherComponent,
            renderExtraControls,
            query,
            onSearch,
            onUpdate,
            onSwitchToJql,
            excludedFields,
            onJqlBuilderBasicReady,
            onJourneyStart,
            NoOptionComponent,
            hydrationQueryRef,
            isHydrating,
            hideOperatorDropdownBasicMode,
            irremovableFields,
            hideTextSearchInput,
            contextJql,
            props,
            analyticsSource,
            jqlMessages,
            isSearching,
            onJqlBuilderAdvancedReady,
            showOrderByPicker
        ]);
        const EffectiveJqlBuilderContainer = CustomEditorContainer ?? (0, (0, parcelRequire("kdzZz")).DefaultJqlBuilderContainer);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX4vm")).Container), {
            "data-testid": "jql-builder"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(EffectiveJqlBuilderContainer, {
            showAdvancedEditor: searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED),
            "data-testid": "jql-builder.ui.effective-jql-builder-container"
        }, searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX4vm")).BasicEditorListContainer), null, Editor) : Editor), !isSearchModeSwitcherOnLeft && SearchModeSwitcherComponent, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireUiAnalytics), {
            actionSubject: "screen",
            action: "viewed",
            actionSubjectId: "jqlBuilder",
            attributes: {
                selectedSearchMode: selectedSearchMode,
                queryMode: (0, (0, parcelRequire("032ey")).mapSearchModeToAnalyticAtribute)[searchMode],
                ...irremovableFieldsAnalyticsAttributes,
                loadingMode: loadingModeRef.current
            }
        })));
    };
    const $6173244194fe7b03$export$d33754885f040153 = ({ analyticsSource: analyticsSource, query: query, onSearch: onSearchProp, onUpdate: onUpdate, beforeControls: beforeControls, renderExtraControls: renderExtraControls, isSearching: isSearching, onLoad: onLoad, onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, jqlMessages: jqlMessages, excludedFields: excludedFields, searchModes: searchModes, selectedSearchMode: selectedSearchMode, hydrationData: hydrationData, components: components, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchModeSwitcherLocation: searchModeSwitcherLocation, showOrderByPicker: showOrderByPicker, contextJql: contextJql, loadingModeRef: loadingModeRef, ...props })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const irremovableFieldsAnalyticsAttributes = (0, (0, parcelRequire("7ckRQ")).useIrremovableFieldsAnalyticsAttributes)(irremovableFields);
        const { searchMode: searchMode, setSelectedSearchMode: setSelectedSearchMode } = (0, (0, parcelRequire("1PKzp")).useSelectedSearchMode)();
        const { hydrationQueryIsFetching: hydrationQueryIsFetching } = (0, (0, parcelRequire("k3Vq9")).useHydrationQuery)();
        const onPerformanceMark = (0, (0, parcelRequire("caSpf")).usePerformanceContext)();
        const onSwitchToJql = (0, $5uXOq.useCallback)(()=>{
            setSelectedSearchMode((0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED), true);
        }, [
            setSelectedSearchMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const jqlErrors = (jqlMessages || []).filter((e)=>e.type === 'error');
            if (jqlErrors?.length) {
                const errorAnalyticsEvent = createAnalyticsEvent({});
                (0, (0, parcelRequire("jcw0u")).default)({
                    event: errorAnalyticsEvent,
                    meta: {
                        id: 'jqlBuilderJqlInvalid',
                        packageName: 'jiraJqlBuilder',
                        teamName: 'empanada'
                    },
                    attributes: {
                        queryMode: searchMode
                    }
                });
            }
        }, []);
        const onJqlBuilderAdvancedReady = (0, $5uXOq.useCallback)(()=>{
            onPerformanceMark({
                mark: (0, (0, parcelRequire("8vNru")).JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_ADVANCED_JS_END
            });
            onReady && onReady((0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED));
        }, [
            onPerformanceMark,
            onReady
        ]);
        const onJqlBuilderBasicReady = (0, $5uXOq.useCallback)(()=>{
            onReady && onReady((0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC));
        }, [
            onReady
        ]);
        let onSearch = onSearchProp;
        if (onSearchProp) onSearch = (jql)=>{
            onSearchProp(jql);
            const event = createAnalyticsEvent({
                action: 'submitted',
                actionSubject: 'search'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'jqlBuilder', {
                searchMode: searchMode
            });
        };
        const { SearchModeSwitcher: SearchModeSwitcher, EditorContainer: CustomEditorContainer } = components ?? {};
        const isSearchModeToggleEnabled = searchModes ? searchModes.length > 1 : true;
        const isSearchModeSwitcherOnLeft = searchModeSwitcherLocation === (0, (0, parcelRequire("032ey")).SEARCH_MODE_SWITCHER_LEFT_LOCATION) && (0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
        const SearchModeSwitcherComponent = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ixr8x")).SearchModeSwitcherRenderer), {
                isSearchModeToggleEnabled: isSearchModeToggleEnabled,
                SearchModeSwitcher: SearchModeSwitcher,
                isHydrating: hydrationQueryIsFetching,
                isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
            }), [
            SearchModeSwitcher,
            hydrationQueryIsFetching,
            isSearchModeSwitcherOnLeft,
            isSearchModeToggleEnabled
        ]);
        const Editor = (0, $5uXOq.useMemo)(()=>{
            let jqlBuilderComponent;
            switch(searchMode){
                case 0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC:
                    jqlBuilderComponent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
                        name: "jql-builder-basic"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imju0")).default), {
                        query: query,
                        onSearch: onSearch || onUpdate || (0, ($parcel$interopDefault($8Rkzz))),
                        onSwitchToJql: onSwitchToJql,
                        excludedFields: excludedFields,
                        onReady: onJqlBuilderBasicReady,
                        onJourneyStart: onJourneyStart,
                        NoOptionComponent: NoOptionComponent,
                        hydrationData: hydrationData,
                        isHydrating: hydrationQueryIsFetching,
                        shouldUseListMarkup: true,
                        hideOperatorDropdown: hideOperatorDropdownBasicMode,
                        irremovableFields: irremovableFields,
                        hideTextSearchInput: hideTextSearchInput,
                        showOrderByPicker: showOrderByPicker,
                        contextJql: contextJql,
                        ...props
                    }));
                    break;
                default:
                    jqlBuilderComponent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
                        name: "jql-builder-advanced"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Czte")).NinChangeboardingTourTarget), {
                        engagementId: "nin.jql-builder.advanced"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX4vm")).AdvancedEditorWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isD5C")).default), {
                        analyticsSource: analyticsSource,
                        onSearch: onSearch,
                        onUpdate: onUpdate,
                        query: query,
                        jqlMessages: jqlMessages,
                        isSearching: isSearching,
                        isCompact: true,
                        excludedAutocompleteFields: excludedFields,
                        onReady: onJqlBuilderAdvancedReady,
                        onJourneyStart: onJourneyStart,
                        ...props
                    }))));
            }
            const BeforeJqlBuilderWrapper = searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC) ? (0, (0, parcelRequire("jX4vm")).BeforeJqlBuilderListItemContainer) : (0, (0, parcelRequire("jX4vm")).BeforeJqlBuilderContainer);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, beforeControls && (0, ($parcel$interopDefault($5uXOq))).createElement(BeforeJqlBuilderWrapper, null, beforeControls), isSearchModeSwitcherOnLeft && (0, ($parcel$interopDefault($5uXOq))).createElement(BeforeJqlBuilderWrapper, null, SearchModeSwitcherComponent), jqlBuilderComponent, renderExtraControls && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g9ghO")).default), {
                searchMode: searchMode,
                renderExtraControls: renderExtraControls,
                shouldUseListMarkup: searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC)
            }));
        }, [
            searchMode,
            beforeControls,
            isSearchModeSwitcherOnLeft,
            SearchModeSwitcherComponent,
            renderExtraControls,
            query,
            onSearch,
            onUpdate,
            onSwitchToJql,
            excludedFields,
            onJqlBuilderBasicReady,
            onJourneyStart,
            NoOptionComponent,
            hydrationData,
            hydrationQueryIsFetching,
            hideOperatorDropdownBasicMode,
            irremovableFields,
            hideTextSearchInput,
            showOrderByPicker,
            contextJql,
            props,
            analyticsSource,
            jqlMessages,
            isSearching,
            onJqlBuilderAdvancedReady
        ]);
        const EffectiveJqlBuilderContainer = CustomEditorContainer ?? (0, (0, parcelRequire("kdzZz")).DefaultJqlBuilderContainer);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX4vm")).Container), {
            "data-testid": "jql-builder"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(EffectiveJqlBuilderContainer, {
            showAdvancedEditor: searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_ADVANCED),
            "data-testid": "jql-builder.ui.effective-jql-builder-container"
        }, searchMode === (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX4vm")).BasicEditorListContainer), null, Editor) : Editor), !isSearchModeSwitcherOnLeft && SearchModeSwitcherComponent, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireUiAnalytics), {
            actionSubject: "screen",
            action: "viewed",
            actionSubjectId: "jqlBuilder",
            attributes: {
                selectedSearchMode: selectedSearchMode,
                queryMode: (0, (0, parcelRequire("032ey")).mapSearchModeToAnalyticAtribute)[searchMode],
                ...irremovableFieldsAnalyticsAttributes,
                loadingMode: loadingModeRef.current
            }
        })));
    };
});
parcelRegister("isD5C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62b418d1d2bd976d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9TK8T;
    var $iK2TS;
    const $62b418d1d2bd976d$var$JQLBuilderAdvancedAsync = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iK2TS")).default), {
            ...props,
            JQLEditor: (0, (0, parcelRequire("9TK8T")).JQLEditorAsync)
        });
    var $62b418d1d2bd976d$export$2e2bcd8739ae039 = $62b418d1d2bd976d$var$JQLBuilderAdvancedAsync;
});
parcelRegister("iK2TS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3427075489fb9d2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $eWXbg;
    var $jKUMq;
    var $8OuHv;
    var $5p1kJ;
    var $5rVQI;
    var $eG9rp;
    var $879xD;
    var $dJl1T;
    var $jcw0u;
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $pa9q9;
    var $koVbs;
    var $8vNru;
    var $caSpf;
    var $iXVV6;
    var $8zOmE;
    var $2NMNM;
    var $g9E9n;
    var $apc2O;
    var $b3ogM;
    var $3pImq;
    var $8BS0n;
    const $d3427075489fb9d2$var$JQLBuilderAdvancedUI = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)(requestAnimationFrame);
        const { analyticsSource: analyticsSource, JQLEditor: JQLEditor, query: query, jqlMessages: jqlMessages, isCompact: isCompact, isSearching: isSearching, onUpdate: onUpdate, onReady: onReady, onSearch: onSearch, excludedAutocompleteFields: excludedAutocompleteFields, onJourneyStart: onJourneyStart, autoFocus: autoFocus, viewContext: viewContext = null } = props;
        const onPerformanceMark = (0, (0, parcelRequire("caSpf")).usePerformanceContext)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            onPerformanceMark({
                mark: (0, (0, parcelRequire("8vNru")).JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_ADVANCED_JS_START
            });
        }, [
            onPerformanceMark
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onHydrate = (0, (0, parcelRequire("8BS0n")).useOnHydrate)(viewContext);
        const getInitialData = (0, (0, parcelRequire("b3ogM")).useAutocompleteInitialData)(excludedAutocompleteFields);
        const getSuggestions = (0, (0, parcelRequire("3pImq")).useAutocompleteSuggestions)();
        const autocompleteProvider = (0, (0, parcelRequire("8OuHv")).useAutocompleteProvider)(analyticsSource, getInitialData, getSuggestions);
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const onExperienceStart = (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experienceId: undefined,
            experience: (0, $d791d5657a673291$export$abc61f74b6bec12c),
            analyticsSource: analyticsSource
        });
        const onExperienceFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: (0, $d791d5657a673291$export$abc61f74b6bec12c)
        });
        const onExperienceSuccess = (0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: (0, $d791d5657a673291$export$abc61f74b6bec12c)
        });
        const onError = (0, $5uXOq.useCallback)((error)=>{
            showFlag({
                type: 'error',
                title: (0, (0, parcelRequire("apc2O")).default).errorFlagTitle,
                description: (0, (0, parcelRequire("apc2O")).default).errorFlagDescription
            });
            onExperienceStart();
            onExperienceFail(analyticsSource, error);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: (0, $d791d5657a673291$export$abc61f74b6bec12c),
                    packageName: (0, $d791d5657a673291$export$b8b9d90f9e5bd72b),
                    teamName: (0, $d791d5657a673291$export$d57b6b390e78d90f)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            showFlag,
            onExperienceStart,
            onExperienceFail,
            analyticsSource
        ]);
        const onDebugUnsafeMessage = (0, $5uXOq.useCallback)((message, event)=>{
            (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('jiraJqlBuilderAdvanced.onDebugUnsafeMessage', message, event);
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            onExperienceStart();
        }, [
            onExperienceStart
        ]);
        const searchInputRef = (0, $5uXOq.useRef)(null);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const focusSearchInput = (0, $5uXOq.useCallback)(()=>{
            requestAnimationFrame(()=>{
                searchInputRef?.current?.focus();
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'pressed',
                actionSubject: 'keyboardShortcut'
            }), 'jqlEditorAdvancedSearchInputKeyboardShortcut', {
                keyPressed: 'f',
                keyboardShortcut: true
            });
        }, [
            createAnalyticsEvent
        ]);
        const onEditorMounted = (0, $5uXOq.useCallback)(()=>{
            onExperienceSuccess();
            if (autoFocus) focusSearchInput();
            onReady && onReady();
        }, [
            onExperienceSuccess,
            onReady,
            autoFocus,
            focusSearchInput
        ]);
        const { getKeywords: getKeywords } = (0, (0, parcelRequire("eG9rp")).useCommandKeywords)();
        const onFocus = (0, $5uXOq.useCallback)(()=>{
            if (!onJourneyStart) return;
            const analyticsEvent = createAnalyticsEvent({
                action: 'focused',
                actionSubject: 'input'
            });
            const attributes = onJourneyStart();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'jqlEditorAdvancedSearchInput', attributes);
        }, [
            createAnalyticsEvent,
            onJourneyStart
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("879xD")).CommandShortcuts), {
            keyMap: {
                f: {
                    callback: focusSearchInput,
                    registerInCommandPalette: {
                        id: 'jql-builder-advanced-focus-search-input',
                        name: formatMessage((0, (0, parcelRequire("apc2O")).default).searchCurrentPage),
                        keywords: getKeywords('pageSearchSynonyms'),
                        components: {
                            LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eWXbg"))))), {
                                    label: formatMessage((0, (0, parcelRequire("apc2O")).default).searchCurrentPage)
                                })
                        },
                        priority: (0, (0, parcelRequire("5rVQI")).COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                        section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).quickActions,
                        analytics: {
                            action: 'searchCurrentPage'
                        }
                    }
                }
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(JQLEditor, {
            inputRef: searchInputRef,
            analyticsSource: analyticsSource,
            query: query,
            messages: jqlMessages,
            isCompact: isCompact,
            isSearching: isSearching,
            onEditorMounted: onEditorMounted,
            onUpdate: onUpdate,
            onSearch: onSearch,
            onHydrate: onHydrate,
            onFocus: onJourneyStart ? onFocus : undefined,
            autocompleteProvider: autocompleteProvider,
            onRenderError: onError,
            onDebugUnsafeMessage: onDebugUnsafeMessage,
            enableRichInlineNodes: true
        }));
    };
    const $d3427075489fb9d2$var$JQLBuilderAdvancedUIWithAnalytics = (props)=>{
        const clientWrapper = (0, $5uXOq.useRef)((0, (0, parcelRequire("g9E9n")).getAnalyticsWebClient)());
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jKUMq")).default), {
            client: clientWrapper.current?.analyticsClient
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "jqlBuilderAdvanced",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d3427075489fb9d2$var$JQLBuilderAdvancedUI, props)));
    };
    var $d3427075489fb9d2$export$2e2bcd8739ae039 = $d3427075489fb9d2$var$JQLBuilderAdvancedUIWithAnalytics;
});
parcelRegister("eWXbg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ae246388ea520792$var$_react = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $ae246388ea520792$var$_page = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("kdfZa")));
    function $ae246388ea520792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ae246388ea520792$var$PageIcon = (props)=>$ae246388ea520792$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
        }, props, {
            newIcon: $ae246388ea520792$var$_page.default
        }));
    $ae246388ea520792$var$PageIcon.displayName = 'PageIcon';
    var $ae246388ea520792$var$_default = module.exports.default = $ae246388ea520792$var$PageIcon;
});
parcelRegister("kdfZa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb716bf3c984513d$var$_react = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eb716bf3c984513d$var$_baseNew = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eb716bf3c984513d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb716bf3c984513d$var$PageIcon = (props)=>$eb716bf3c984513d$var$_react.default.createElement($eb716bf3c984513d$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $eb716bf3c984513d$var$PageIcon.displayName = 'PageIcon';
    var $eb716bf3c984513d$var$_default = module.exports.default = $eb716bf3c984513d$var$PageIcon;
});
parcelRegister("jKUMq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$543063cb12ed6a26$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvUB1;
    var $2wJF1;
    var $96ICE;
    var $aCLsW;
    class $543063cb12ed6a26$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props), this.handleEventWrapper = (event)=>{
                (0, (0, parcelRequire("96ICE")).handleEvent)(event, this.logger, this.props.client);
            };
            this.logger = new (0, (0, parcelRequire("aCLsW")).default)({
                logLevel: props.logLevel
            });
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvUB1")).default), {
                onEvent: this.handleEventWrapper,
                channel: (0, (0, parcelRequire("2wJF1")).ANALYTICS_CHANNEL)
            }, this.props.children);
        }
    }
});
parcelRegister("2wJF1", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_CHANNEL", ()=>$b21d58e566fa28d5$export$85183a312807388d);
    $parcel$export(module.exports, "EventType", ()=>$b21d58e566fa28d5$export$3d7865934588d77e);
    const $b21d58e566fa28d5$export$85183a312807388d = 'jql-editor';
    var $b21d58e566fa28d5$export$3d7865934588d77e;
    (function(EventType) {
        EventType["OPERATIONAL"] = "operational";
        EventType["SCREEN"] = "screen";
        EventType["TRACK"] = "track";
        EventType["UI"] = "ui";
    })($b21d58e566fa28d5$export$3d7865934588d77e || ($b21d58e566fa28d5$export$3d7865934588d77e = {}));
});
parcelRegister("96ICE", function(module, exports) {
    $parcel$export(module.exports, "handleEvent", ()=>$5c9820b735892360$export$d6e5ca10785815df);
    var $2X7XF;
    var $k3OI8;
    const $5c9820b735892360$export$d6e5ca10785815df = (event, logger, client)=>{
        if (!event.payload) return;
        const payload = (0, (0, parcelRequire("k3OI8")).processEventPayload)(event);
        (0, (0, parcelRequire("2X7XF")).sendEvent)(logger, client)(payload);
    };
});
parcelRegister("2X7XF", function(module, exports) {
    $parcel$export(module.exports, "sendEvent", ()=>$258dc07c14dea243$export$7329bcdc3edcd90e);
    const $258dc07c14dea243$var$isPromise = (c)=>{
        return typeof c.then === 'function';
    };
    const $258dc07c14dea243$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
            if (client) {
                const gasEvent = {
                    ...event
                };
                delete gasEvent.eventType;
                const withClient = (cb)=>{
                    if ($258dc07c14dea243$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                    else try {
                        cb(client);
                    } catch (e) {
                        logger.warn('There was an error sending the event', e);
                    }
                };
                switch(event.eventType){
                    case 'ui':
                        logger.debug('Sending UI Event via analytics client', gasEvent);
                        withClient((client)=>client.sendUIEvent(gasEvent));
                        break;
                    case 'operational':
                        logger.debug('Sending Operational Event via analytics client', gasEvent);
                        withClient((client)=>client.sendOperationalEvent(gasEvent));
                        break;
                    case 'track':
                        logger.debug('Sending Track Event via analytics client', gasEvent);
                        withClient((client)=>client.sendTrackEvent(gasEvent));
                        break;
                    case 'screen':
                        logger.debug('Sending Screen Event via analytics client', gasEvent);
                        withClient((client)=>client.sendScreenEvent(gasEvent));
                        break;
                    default:
                        logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
                }
            } else logger.warn('AnalyticsWebClient instance is not provided');
        };
});
parcelRegister("k3OI8", function(module, exports) {
    $parcel$export(module.exports, "processEventPayload", ()=>$12515031cdf6cace$export$c37d638b7f2ca192);
    var $1UikQ = parcelRequire("1UikQ");
    const $12515031cdf6cace$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, ($parcel$interopDefault($1UikQ)))(result, {
                        [key]: ctx[key]
                    }) : result, {})).reduce((result, item)=>(0, ($parcel$interopDefault($1UikQ)))(result, item), {});
    const $12515031cdf6cace$var$fieldExtractor = ()=>$12515031cdf6cace$var$extractFieldsFromContext([
            'source',
            'objectType',
            'objectId',
            'containerType',
            'containerId'
        ]);
    const $12515031cdf6cace$var$updatePayloadWithContext = (event)=>{
        if (event.context.length === 0) return {
            source: (0, $676c5e519aa5ba55$export$b055de0e665cb20c),
            ...event.payload
        };
        const fields = $12515031cdf6cace$var$fieldExtractor()(event.context);
        return {
            source: (0, $676c5e519aa5ba55$export$b055de0e665cb20c),
            ...fields,
            ...event.payload
        };
    };
    const $12515031cdf6cace$export$c37d638b7f2ca192 = (event)=>{
        return $12515031cdf6cace$var$updatePayloadWithContext(event);
    };
});
parcelRegister("aCLsW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7c111b9de87f3e6$export$2e2bcd8739ae039);
    const $e7c111b9de87f3e6$export$ffe0c436e29512cf = {
        DEBUG: 0,
        INFO: 1,
        WARN: 2,
        ERROR: 3,
        OFF: 4
    };
    class $e7c111b9de87f3e6$export$2e2bcd8739ae039 {
        constructor({ logLevel: logLevel } = {}){
            this.logLevel = $e7c111b9de87f3e6$export$ffe0c436e29512cf.OFF;
            if (typeof logLevel === 'number') this.setLogLevel(logLevel);
        }
        setLogLevel(logLevel) {
            if (logLevel >= $e7c111b9de87f3e6$export$ffe0c436e29512cf.DEBUG && logLevel <= $e7c111b9de87f3e6$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
            else this.logLevel = $e7c111b9de87f3e6$export$ffe0c436e29512cf.OFF;
        }
        logMessage(level, type, ...args) {
            if (level >= this.logLevel) console[type](...args);
        }
        debug(...args) {
            this.logMessage($e7c111b9de87f3e6$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
        }
        info(...args) {
            this.logMessage($e7c111b9de87f3e6$export$ffe0c436e29512cf.INFO, 'info', ...args);
        }
        warn(...args) {
            this.logMessage($e7c111b9de87f3e6$export$ffe0c436e29512cf.WARN, 'warn', ...args);
        }
        error(...args) {
            this.logMessage($e7c111b9de87f3e6$export$ffe0c436e29512cf.ERROR, 'error', ...args);
        }
    }
});
parcelRegister("8OuHv", function(module, exports) {
    $parcel$export(module.exports, "useAutocompleteProvider", ()=>$77a2c328a702fe11$export$2ae605545144a62d);
    var $5uXOq = parcelRequire("5uXOq");
    var $papfC;
    var $knLQw;
    var $hFp5Y;
    var $3z2bS;
    var $jIHJp;
    var $fGAX8;
    const $77a2c328a702fe11$export$2ae605545144a62d = (analyticsSource, getInitialData, getSuggestions)=>{
        const { createAndFireAnalyticsEvent: createAndFireAnalyticsEvent } = (0, (0, parcelRequire("papfC")).useJqlEditorAutocompleteAnalytics)(analyticsSource);
        const [, { load: load }] = (0, (0, parcelRequire("knLQw")).useJqlAutocompleteActions)();
        const [jqlSearchableFields$] = (0, (0, parcelRequire("knLQw")).useJqlSearchableFieldsObservable)();
        const [jqlOrderableFields$] = (0, (0, parcelRequire("knLQw")).useJqlOrderableFieldsObservable)();
        const [jqlFunctions$] = (0, (0, parcelRequire("knLQw")).useJqlFunctionsObservable)();
        const onFields = (0, (0, parcelRequire("hFp5Y")).default)(jqlSearchableFields$, jqlOrderableFields$);
        const onOperators = (0, (0, parcelRequire("jIHJp")).default)(jqlSearchableFields$);
        const onFunctions = (0, (0, parcelRequire("3z2bS")).default)(jqlSearchableFields$, jqlFunctions$);
        const onValues = (0, (0, parcelRequire("fGAX8")).default)(jqlSearchableFields$, getSuggestions, createAndFireAnalyticsEvent);
        (0, $5uXOq.useEffect)(()=>{
            load(getInitialData, createAndFireAnalyticsEvent);
        }, [
            createAndFireAnalyticsEvent,
            getInitialData,
            load
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                onFields: onFields,
                onOperators: onOperators,
                onFunctions: onFunctions,
                onValues: onValues
            }), [
            onFields,
            onOperators,
            onFunctions,
            onValues
        ]);
    };
});
parcelRegister("papfC", function(module, exports) {
    $parcel$export(module.exports, "useJqlEditorAutocompleteAnalytics", ()=>$a77f5d8f549b61f2$export$67ceee19d6563eac);
    var $2wJF1;
    var $8xk8v;
    var $5W7PV;
    const $a77f5d8f549b61f2$export$67ceee19d6563eac = (analyticsSource)=>{
        return (0, (0, parcelRequire("8xk8v")).useJqlPackageAnalytics)(analyticsSource, "platform-pkg", "0.0.0-use.local", (0, (0, parcelRequire("2wJF1")).ANALYTICS_CHANNEL));
    };
});
parcelRegister("8xk8v", function(module, exports) {
    $parcel$export(module.exports, "useJqlPackageAnalytics", ()=>$40aad5b9c70a886d$export$62edc016e6670a97);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    const $40aad5b9c70a886d$export$62edc016e6670a97 = (analyticsSource, packageName, packageVersion, analyticsChannel)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const createAndFireAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    analyticsSource: analyticsSource,
                    packageName: packageName,
                    packageVersion: packageVersion
                }
            });
            event.fire(analyticsChannel);
        }, [
            createAnalyticsEvent,
            analyticsSource,
            packageName,
            packageVersion,
            analyticsChannel
        ]);
        return {
            createAndFireAnalyticsEvent: createAndFireAnalyticsEvent
        };
    };
});
parcelRegister("5W7PV", function(module, exports) {
    $parcel$export(module.exports, "Action", ()=>$9abaecd1c9a9c6e6$export$e19cd5f9376f8cee);
    $parcel$export(module.exports, "ActionSubject", ()=>$9abaecd1c9a9c6e6$export$7f97440769de1377);
    var $9abaecd1c9a9c6e6$export$e19cd5f9376f8cee;
    (function(Action) {
        Action["FAILED"] = "failed";
        Action["SUCCESS"] = "success";
    })($9abaecd1c9a9c6e6$export$e19cd5f9376f8cee || ($9abaecd1c9a9c6e6$export$e19cd5f9376f8cee = {}));
    var $9abaecd1c9a9c6e6$export$7f97440769de1377;
    (function(ActionSubject) {
        ActionSubject["AUTOCOMPLETE_INITIAL_DATA"] = "autocompleteInitialData";
        ActionSubject["AUTOCOMPLETE_SUGGESTIONS"] = "autocompleteSuggestions";
    })($9abaecd1c9a9c6e6$export$7f97440769de1377 || ($9abaecd1c9a9c6e6$export$7f97440769de1377 = {}));
    var $9abaecd1c9a9c6e6$export$cb7d54f314e067cb;
    $9abaecd1c9a9c6e6$export$cb7d54f314e067cb || ($9abaecd1c9a9c6e6$export$cb7d54f314e067cb = {});
});
parcelRegister("knLQw", function(module, exports) {
    $parcel$export(module.exports, "useJqlAutocompleteActions", ()=>$e744f35bd94f1ef2$export$dfe74b189a0a3dd);
    $parcel$export(module.exports, "useJqlSearchableFieldsObservable", ()=>$e744f35bd94f1ef2$export$e00ad85496518b08);
    $parcel$export(module.exports, "useJqlOrderableFieldsObservable", ()=>$e744f35bd94f1ef2$export$ddac70d4fccb6121);
    $parcel$export(module.exports, "useJqlFunctionsObservable", ()=>$e744f35bd94f1ef2$export$20ce426c77c6c794);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $gI62y = parcelRequire("gI62y");
    var $ib0Rz = parcelRequire("ib0Rz");
    var $2wJF1;
    var $5W7PV;
    const $e744f35bd94f1ef2$var$initialData = {
        jqlSearchableFields: [],
        jqlOrderableFields: [],
        jqlFunctions: []
    };
    const $e744f35bd94f1ef2$var$initialState = {
        initialDataFetched: false,
        jqlSearchableFields$: (0, $gI62y.from)($e744f35bd94f1ef2$var$initialData.jqlSearchableFields),
        jqlOrderableFields$: (0, $gI62y.from)($e744f35bd94f1ef2$var$initialData.jqlOrderableFields),
        jqlFunctions$: (0, $gI62y.from)($e744f35bd94f1ef2$var$initialData.jqlFunctions)
    };
    const $e744f35bd94f1ef2$export$e324594224ef24da = {
        load: (getInitialData, createAndFireAnalyticsEvent)=>({ getState: getState, setState: setState })=>{
                const { initialDataFetched: initialDataFetched } = getState();
                if (initialDataFetched) return;
                const promise = getInitialData(`/rest/api/latest/jql/autocompletedata`).then((res)=>{
                    const initialValue = {
                        jqlSearchableFields: [],
                        jqlOrderableFields: [],
                        jqlFunctions: res.jqlFunctions
                    };
                    const data = res.jqlFields.reduce((result, field)=>{
                        if (field.searchable === 'true') result.jqlSearchableFields.push(field);
                        if (field.orderable === 'true') result.jqlOrderableFields.push(field);
                        return result;
                    }, initialValue);
                    setState({
                        jqlSearchableFields$: (0, $gI62y.from)(data.jqlSearchableFields),
                        jqlOrderableFields$: (0, $gI62y.from)(data.jqlOrderableFields),
                        jqlFunctions$: (0, $gI62y.from)(data.jqlFunctions)
                    });
                    createAndFireAnalyticsEvent({
                        action: (0, (0, parcelRequire("5W7PV")).Action).SUCCESS,
                        actionSubject: (0, (0, parcelRequire("5W7PV")).ActionSubject).AUTOCOMPLETE_INITIAL_DATA,
                        eventType: (0, (0, parcelRequire("2wJF1")).EventType).OPERATIONAL
                    });
                    return data;
                }).catch(()=>{
                    setState({
                        jqlSearchableFields$: $e744f35bd94f1ef2$var$initialState.jqlSearchableFields$,
                        jqlOrderableFields$: $e744f35bd94f1ef2$var$initialState.jqlOrderableFields$,
                        jqlFunctions$: $e744f35bd94f1ef2$var$initialState.jqlFunctions$
                    });
                    createAndFireAnalyticsEvent({
                        action: (0, (0, parcelRequire("5W7PV")).Action).FAILED,
                        actionSubject: (0, (0, parcelRequire("5W7PV")).ActionSubject).AUTOCOMPLETE_INITIAL_DATA,
                        eventType: (0, (0, parcelRequire("2wJF1")).EventType).OPERATIONAL
                    });
                    return $e744f35bd94f1ef2$var$initialData;
                });
                setState({
                    initialDataFetched: true,
                    jqlSearchableFields$: (0, $gI62y.from)(promise).pipe((0, $ib0Rz.concatMap)(({ jqlSearchableFields: jqlSearchableFields })=>jqlSearchableFields)),
                    jqlOrderableFields$: (0, $gI62y.from)(promise).pipe((0, $ib0Rz.concatMap)(({ jqlOrderableFields: jqlOrderableFields })=>jqlOrderableFields)),
                    jqlFunctions$: (0, $gI62y.from)(promise).pipe((0, $ib0Rz.concatMap)(({ jqlFunctions: jqlFunctions })=>jqlFunctions))
                });
            }
    };
    const $e744f35bd94f1ef2$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $e744f35bd94f1ef2$var$initialState,
        actions: $e744f35bd94f1ef2$export$e324594224ef24da
    });
    const $e744f35bd94f1ef2$export$96c8f4ecc88d96a5 = (0, (0, parcelRequire("gg7kZ")).createContainer)($e744f35bd94f1ef2$export$6f57813fe9f31bf9);
    const $e744f35bd94f1ef2$export$dfe74b189a0a3dd = (0, (0, parcelRequire("3sQ5x")).createHook)($e744f35bd94f1ef2$export$6f57813fe9f31bf9, {
        selector: null
    });
    const $e744f35bd94f1ef2$export$e00ad85496518b08 = (0, (0, parcelRequire("3sQ5x")).createHook)($e744f35bd94f1ef2$export$6f57813fe9f31bf9, {
        selector: ({ jqlSearchableFields$: jqlSearchableFields$ })=>jqlSearchableFields$
    });
    const $e744f35bd94f1ef2$export$ddac70d4fccb6121 = (0, (0, parcelRequire("3sQ5x")).createHook)($e744f35bd94f1ef2$export$6f57813fe9f31bf9, {
        selector: ({ jqlOrderableFields$: jqlOrderableFields$ })=>jqlOrderableFields$
    });
    const $e744f35bd94f1ef2$export$20ce426c77c6c794 = (0, (0, parcelRequire("3sQ5x")).createHook)($e744f35bd94f1ef2$export$6f57813fe9f31bf9, {
        selector: ({ jqlFunctions$: jqlFunctions$ })=>jqlFunctions$
    });
});
parcelRegister("hFp5Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b59854c2057622fa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aN8zr = parcelRequire("aN8zr");
    var $8B7Oi = parcelRequire("8B7Oi");
    var $4cJXk = parcelRequire("4cJXk");
    var $cVFxd = parcelRequire("cVFxd");
    var $cQZy3 = parcelRequire("cQZy3");
    var $iQUbM = parcelRequire("iQUbM");
    var $btETJ;
    var $4sLMQ;
    const $b59854c2057622fa$export$df27029b4333540b = 20;
    const $b59854c2057622fa$var$CF_ID_PATTERN = /^"?cf\[\d+]"?$/;
    const $b59854c2057622fa$var$COLLAPSED_FIELD_PATTERN = /^"?.+\[(.+)]"?$/;
    const $b59854c2057622fa$var$isCollapsedField = ({ value: value })=>$b59854c2057622fa$var$COLLAPSED_FIELD_PATTERN.test(value) && !$b59854c2057622fa$var$CF_ID_PATTERN.test(value);
    const $b59854c2057622fa$export$b9089a6e41ed43aa = (field)=>{
        if (!$b59854c2057622fa$var$isCollapsedField(field)) return null;
        const matches = $b59854c2057622fa$var$COLLAPSED_FIELD_PATTERN.exec(field.value);
        if (!matches || matches.length < 2) return null;
        return matches[1];
    };
    const $b59854c2057622fa$var$useOnFields = (jqlSearchableFields$, jqlOrderableFields$)=>{
        return (0, $5uXOq.useCallback)((query, clause)=>{
            if (clause === undefined) return (0, $8B7Oi.empty)();
            const jqlFields$ = clause === 'orderBy' ? jqlOrderableFields$ : jqlSearchableFields$;
            return jqlFields$.pipe((0, $4cJXk.filter)((field)=>(0, (0, parcelRequire("btETJ")).filterJqlValue)(field, query)), (0, $cQZy3.take)($b59854c2057622fa$export$df27029b4333540b), (0, $cVFxd.map)((field)=>{
                const fieldType = $b59854c2057622fa$export$b9089a6e41ed43aa(field);
                if (fieldType !== null) {
                    const name = (0, ($parcel$interopDefault($aN8zr)))(field.displayName).replace(` - ${(0, (0, parcelRequire("4sLMQ")).normalize)(field.value)}`, '');
                    return {
                        name: name,
                        value: field.value,
                        fieldType: fieldType,
                        isDeprecated: field.deprecated === 'true',
                        deprecatedSearcherKey: field.deprecatedSearcherKey
                    };
                }
                return {
                    name: (0, ($parcel$interopDefault($aN8zr)))(field.displayName),
                    value: field.value,
                    isDeprecated: field.deprecated === 'true',
                    deprecatedSearcherKey: field.deprecatedSearcherKey
                };
            }), (0, $iQUbM.toArray)(), (0, $4cJXk.filter)((fields)=>fields.length > 0));
        }, [
            jqlSearchableFields$,
            jqlOrderableFields$
        ]);
    };
    var $b59854c2057622fa$export$2e2bcd8739ae039 = $b59854c2057622fa$var$useOnFields;
});
parcelRegister("aN8zr", function(module, exports) {
    var $jJVtR = parcelRequire("jJVtR");
    var $04YKD = parcelRequire("04YKD");
    var $7db520ee7c182c99$var$reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, $7db520ee7c182c99$var$reHasEscapedHtml = RegExp($7db520ee7c182c99$var$reEscapedHtml.source);
    function $7db520ee7c182c99$var$unescape(string) {
        string = $jJVtR(string);
        return string && $7db520ee7c182c99$var$reHasEscapedHtml.test(string) ? string.replace($7db520ee7c182c99$var$reEscapedHtml, $04YKD) : string;
    }
    module.exports = $7db520ee7c182c99$var$unescape;
});
parcelRegister("04YKD", function(module, exports) {
    var $h2dNA = parcelRequire("h2dNA");
    var $00ef7fc28f2140e4$var$htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    var $00ef7fc28f2140e4$var$unescapeHtmlChar = $h2dNA($00ef7fc28f2140e4$var$htmlUnescapes);
    module.exports = $00ef7fc28f2140e4$var$unescapeHtmlChar;
});
parcelRegister("btETJ", function(module, exports) {
    $parcel$export(module.exports, "filterJqlValue", ()=>$66088c70eed2f41e$export$7a9ba8200d77b3fe);
    var $4sLMQ;
    const $66088c70eed2f41e$export$7a9ba8200d77b3fe = ({ displayName: displayName, value: value }, query)=>{
        if (typeof query !== 'string' || query === '') return true;
        const normalizedQuery = (0, (0, parcelRequire("4sLMQ")).normalize)(query);
        const normalizedDisplayName = (0, (0, parcelRequire("4sLMQ")).normalize)(displayName);
        const normalizedValue = (0, (0, parcelRequire("4sLMQ")).normalize)(value);
        if ((0, (0, parcelRequire("4sLMQ")).isQuoted)(query)) return (0, (0, parcelRequire("4sLMQ")).areStringsEquivalent)(normalizedQuery, normalizedValue);
        return (0, (0, parcelRequire("4sLMQ")).areStringsEquivalent)(normalizedQuery, normalizedDisplayName.substring(0, normalizedQuery.length)) || (0, (0, parcelRequire("4sLMQ")).areStringsEquivalent)(normalizedQuery, normalizedValue.substring(0, normalizedQuery.length));
    };
});
parcelRegister("4sLMQ", function(module, exports) {
    $parcel$export(module.exports, "isQuoted", ()=>$373318c93c0a8ad4$export$b86601123607fee5);
    $parcel$export(module.exports, "normalize", ()=>$373318c93c0a8ad4$export$a3295358bff77e);
    $parcel$export(module.exports, "areStringsEquivalent", ()=>$373318c93c0a8ad4$export$cef6d95c2df8ec7f);
    const $373318c93c0a8ad4$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
        if (maybeQuotedString.length < 2) return false;
        return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
    };
    const $373318c93c0a8ad4$export$d5efd6512db694fd = (maybeQuotedString)=>{
        if (maybeQuotedString.length < 2) return false;
        return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
    };
    const $373318c93c0a8ad4$export$b86601123607fee5 = (maybeQuotedString)=>$373318c93c0a8ad4$export$7a0b99b892e0dda8(maybeQuotedString) || $373318c93c0a8ad4$export$d5efd6512db694fd(maybeQuotedString);
    const $373318c93c0a8ad4$export$a3295358bff77e = (maybeQuotedString)=>{
        if ($373318c93c0a8ad4$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
        if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
        return maybeQuotedString;
    };
    const $373318c93c0a8ad4$var$collator = new Intl.Collator(undefined, {
        sensitivity: 'base'
    });
    const $373318c93c0a8ad4$export$cef6d95c2df8ec7f = (a, b)=>$373318c93c0a8ad4$var$collator.compare(a, b) === 0;
});
parcelRegister("3z2bS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34de4c66b9b1f2f3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QDwl = parcelRequire("8QDwl");
    var $8B7Oi = parcelRequire("8B7Oi");
    var $ib0Rz = parcelRequire("ib0Rz");
    var $4cJXk = parcelRequire("4cJXk");
    var $cVFxd = parcelRequire("cVFxd");
    var $iQUbM = parcelRequire("iQUbM");
    var $1TOs2;
    const $34de4c66b9b1f2f3$var$useOnFunctions = (jqlSearchableFields$, jqlFunctions$)=>{
        return (0, $5uXOq.useCallback)((query, field, isListOperator)=>{
            if (typeof field !== 'string' || field === '') return (0, $8B7Oi.empty)();
            const filterRegex = typeof query === 'string' && query !== '' ? new RegExp(`^${(0, ($parcel$interopDefault($8QDwl)))(query)}[^$]`, 'i') : undefined;
            const field$ = (0, (0, parcelRequire("1TOs2")).default)(jqlSearchableFields$, field);
            return field$.pipe((0, $ib0Rz.concatMap)((matchingField)=>jqlFunctions$.pipe((0, $4cJXk.filter)((func)=>!filterRegex || func.displayName.match(filterRegex) !== null), (0, $4cJXk.filter)((func)=>!!isListOperator || func.isList !== 'true'), (0, $4cJXk.filter)((func)=>func.types.filter((type)=>matchingField.types.includes(type)).length > 0), (0, $cVFxd.map)((func)=>({
                        name: func.displayName,
                        value: func.value,
                        isListFunction: func.isList === 'true' || func.supportsListAndSingleValueOperators === 'true'
                    })), (0, $iQUbM.toArray)())), (0, $4cJXk.filter)((operands)=>operands.length > 0));
        }, [
            jqlSearchableFields$,
            jqlFunctions$
        ]);
    };
    var $34de4c66b9b1f2f3$export$2e2bcd8739ae039 = $34de4c66b9b1f2f3$var$useOnFunctions;
});
parcelRegister("1TOs2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c3e15c1a60a4c17$export$2e2bcd8739ae039);
    var $4cJXk = parcelRequire("4cJXk");
    var $cQZy3 = parcelRequire("cQZy3");
    var $4sLMQ;
    const $1c3e15c1a60a4c17$var$findField$ = (jqlFields$, field)=>{
        return jqlFields$.pipe((0, $4cJXk.filter)(({ value: value })=>{
            const normalizedField = (0, (0, parcelRequire("4sLMQ")).normalize)(field);
            const normalizedValue = (0, (0, parcelRequire("4sLMQ")).normalize)(value);
            return (0, (0, parcelRequire("4sLMQ")).areStringsEquivalent)(normalizedField, normalizedValue);
        }), (0, $cQZy3.take)(1));
    };
    var $1c3e15c1a60a4c17$export$2e2bcd8739ae039 = $1c3e15c1a60a4c17$var$findField$;
});
parcelRegister("jIHJp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dd4a125a9492e729$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QDwl = parcelRequire("8QDwl");
    var $8B7Oi = parcelRequire("8B7Oi");
    var $ib0Rz = parcelRequire("ib0Rz");
    var $4cJXk = parcelRequire("4cJXk");
    var $cVFxd = parcelRequire("cVFxd");
    var $iQUbM = parcelRequire("iQUbM");
    var $1TOs2;
    const $dd4a125a9492e729$var$useOnOperators = (jqlSearchableFields$)=>{
        return (0, $5uXOq.useCallback)((query, field)=>{
            if (typeof field !== 'string' || field === '') return (0, $8B7Oi.empty)();
            const filterRegex = typeof query === 'string' && query !== '' ? new RegExp(`^${(0, ($parcel$interopDefault($8QDwl)))(query)}[^$]`, 'i') : undefined;
            return (0, (0, parcelRequire("1TOs2")).default)(jqlSearchableFields$, field).pipe((0, $ib0Rz.concatMap)(({ operators: operators })=>operators), (0, $4cJXk.filter)((operator)=>!filterRegex || operator.match(filterRegex) !== null), (0, $cVFxd.map)((operator)=>{
                const value = operator.toUpperCase();
                return {
                    name: value,
                    value: value
                };
            }), (0, $iQUbM.toArray)(), (0, $4cJXk.filter)((operators)=>operators.length > 0));
        }, [
            jqlSearchableFields$
        ]);
    };
    var $dd4a125a9492e729$export$2e2bcd8739ae039 = $dd4a125a9492e729$var$useOnOperators;
});
parcelRegister("fGAX8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72dd3dc618ddc391$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $8B7Oi = parcelRequire("8B7Oi");
    var $aq199 = parcelRequire("aq199");
    var $ib0Rz = parcelRequire("ib0Rz");
    var $8EnuM = parcelRequire("8EnuM");
    var $4cJXk = parcelRequire("4cJXk");
    var $1TOs2;
    var $4sLMQ;
    var $kAR7R;
    const $72dd3dc618ddc391$var$getValueType = (field)=>{
        if (field.types.includes((0, $bdc8b6b10db4258c$export$7cba791a20c35c0c))) return 'user';
        return undefined;
    };
    const $72dd3dc618ddc391$var$fieldValuesReducer = (state, action)=>{
        const { cacheKey: cacheKey, values: values } = action.payload;
        return {
            ...state,
            [cacheKey]: values
        };
    };
    const $72dd3dc618ddc391$var$initialState = {};
    const $72dd3dc618ddc391$var$OPERANDS_DELAY_MS = 650;
    const $72dd3dc618ddc391$var$BASIC_REMOVE_EMAIL_REGEX = /\s-\s\S+@\S+\.\S+$/;
    const $72dd3dc618ddc391$var$useOnValues = (jqlSearchableFields$, getSuggestions, createAndFireAnalyticsEvent)=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, $5uXOq.useReducer));
        const fetchFieldValues = (0, (0, parcelRequire("kAR7R")).useFetchFieldValues)(getSuggestions, createAndFireAnalyticsEvent);
        const [fieldValuesCache, dispatch] = (0, $5uXOq.useReducer)($72dd3dc618ddc391$var$fieldValuesReducer, $72dd3dc618ddc391$var$initialState);
        return (0, $5uXOq.useCallback)((query, field)=>{
            if (typeof field !== 'string' || field === '') return (0, $8B7Oi.empty)();
            const field$ = (0, (0, parcelRequire("1TOs2")).default)(jqlSearchableFields$, field);
            const normalizedField = (0, (0, parcelRequire("4sLMQ")).normalize)(field);
            const normalizedQuery = query !== undefined ? (0, (0, parcelRequire("4sLMQ")).normalize)(query) : '';
            const cacheKey = `${normalizedField}:${normalizedQuery}`;
            const isCacheHit = Object.prototype.hasOwnProperty.call(fieldValuesCache, cacheKey);
            return field$.pipe((0, $4cJXk.filter)((matchingField)=>matchingField.auto === 'true'), (0, $ib0Rz.concatMap)((matchingField)=>{
                if (isCacheHit) return (0, $aq199.of)(fieldValuesCache[cacheKey]);
                const fieldNameForFetch = matchingField.cfid ?? normalizedField;
                return (0, $aq199.of)(null).pipe((0, $8EnuM.delay)($72dd3dc618ddc391$var$OPERANDS_DELAY_MS), (0, $ib0Rz.concatMap)(()=>fetchFieldValues(fieldNameForFetch, normalizedQuery).then((values)=>{
                        const valueType = $72dd3dc618ddc391$var$getValueType(matchingField);
                        if (valueType === 'user') values.forEach((value)=>{
                            value.valueType = valueType;
                            value.nameOnRichInlineNode = value.name.replace($72dd3dc618ddc391$var$BASIC_REMOVE_EMAIL_REGEX, '');
                        });
                        dispatch({
                            type: 'update-cache',
                            payload: {
                                cacheKey: cacheKey,
                                values: values
                            }
                        });
                        return values;
                    }).catch(()=>[])));
            }), (0, $4cJXk.filter)((operands)=>operands.length > 0));
        }, [
            jqlSearchableFields$,
            fieldValuesCache,
            fetchFieldValues
        ]);
    };
    var $72dd3dc618ddc391$export$2e2bcd8739ae039 = $72dd3dc618ddc391$var$useOnValues;
});
const $bdc8b6b10db4258c$export$7cba791a20c35c0c = 'com.atlassian.jira.user.ApplicationUser';
parcelRegister("kAR7R", function(module, exports) {
    $parcel$export(module.exports, "useFetchFieldValues", ()=>$f700af7241368f96$export$6cb851ed13e3949e);
    var $5uXOq = parcelRequire("5uXOq");
    var $2wJF1;
    var $5W7PV;
    const $f700af7241368f96$export$7bf3f44bca0a7a65 = (field, query)=>`/rest/api/latest/jql/autocompletedata/suggestions?fieldName=${field}&fieldValue=${query ?? ''}`;
    const $f700af7241368f96$export$6cb851ed13e3949e = (getSuggestions, createAndFireAnalyticsEvent)=>{
        return (0, $5uXOq.useCallback)(async (field, query)=>{
            try {
                const data = await getSuggestions($f700af7241368f96$export$7bf3f44bca0a7a65(field, query));
                const div = document.createElement('div');
                const results = data.results.map((operand)=>{
                    div.innerHTML = operand.displayName;
                    return {
                        name: div.textContent ?? '',
                        value: operand.value
                    };
                });
                createAndFireAnalyticsEvent({
                    action: (0, (0, parcelRequire("5W7PV")).Action).SUCCESS,
                    actionSubject: (0, (0, parcelRequire("5W7PV")).ActionSubject).AUTOCOMPLETE_SUGGESTIONS,
                    eventType: (0, (0, parcelRequire("2wJF1")).EventType).OPERATIONAL
                });
                return results;
            } catch (error) {
                createAndFireAnalyticsEvent({
                    action: (0, (0, parcelRequire("5W7PV")).Action).FAILED,
                    actionSubject: (0, (0, parcelRequire("5W7PV")).ActionSubject).AUTOCOMPLETE_SUGGESTIONS,
                    eventType: (0, (0, parcelRequire("2wJF1")).EventType).OPERATIONAL
                });
                throw error;
            }
        }, [
            createAndFireAnalyticsEvent,
            getSuggestions
        ]);
    };
});
parcelRegister("5p1kJ", function(module, exports) {
    $parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", ()=>$7691773a5eed3db6$export$16b06d29ef8f802b);
    $parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", ()=>$7691773a5eed3db6$export$156ebd2354e25466);
    $parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", ()=>$7691773a5eed3db6$export$7fe859528e87e623);
    $parcel$export(module.exports, "COMMAND_PALETTE_ID", ()=>$7691773a5eed3db6$export$9f646ab88e1d2b14);
    $parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", ()=>$7691773a5eed3db6$export$abf26cc5daebd2c8);
    $parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", ()=>$7691773a5eed3db6$export$12514ca8899b0521);
    $parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", ()=>$7691773a5eed3db6$export$5fa0bcf59f933c21);
    $parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", ()=>$7691773a5eed3db6$export$7d9743be0b7d862f);
    $parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", ()=>$7691773a5eed3db6$export$b4e1633c86db2b70);
    $parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", ()=>$7691773a5eed3db6$export$5e5a87aac5d9771f);
    var $7691773a5eed3db6$export$16b06d29ef8f802b;
    (function(COMMAND_PALETTE_SECTIONS) {
        COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
        COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
        COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
        COMMAND_PALETTE_SECTIONS["help"] = "help";
        COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
        COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
        COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
        COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    })($7691773a5eed3db6$export$16b06d29ef8f802b || ($7691773a5eed3db6$export$16b06d29ef8f802b = {}));
    const $7691773a5eed3db6$export$156ebd2354e25466 = 'issueActions';
    const $7691773a5eed3db6$export$7fe859528e87e623 = {
        action: 'pressed',
        actionSubject: 'commandPaletteKeyboardShortcut'
    };
    const $7691773a5eed3db6$export$9f646ab88e1d2b14 = 'commandPalette';
    var $7691773a5eed3db6$export$abf26cc5daebd2c8;
    (function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    })($7691773a5eed3db6$export$abf26cc5daebd2c8 || ($7691773a5eed3db6$export$abf26cc5daebd2c8 = {}));
    var $7691773a5eed3db6$export$12514ca8899b0521;
    (function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    })($7691773a5eed3db6$export$12514ca8899b0521 || ($7691773a5eed3db6$export$12514ca8899b0521 = {}));
    var $7691773a5eed3db6$export$5fa0bcf59f933c21;
    (function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
        COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
        COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    })($7691773a5eed3db6$export$5fa0bcf59f933c21 || ($7691773a5eed3db6$export$5fa0bcf59f933c21 = {}));
    var $7691773a5eed3db6$export$7d9743be0b7d862f;
    (function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    })($7691773a5eed3db6$export$7d9743be0b7d862f || ($7691773a5eed3db6$export$7d9743be0b7d862f = {}));
    var $7691773a5eed3db6$export$b4e1633c86db2b70;
    (function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
    })($7691773a5eed3db6$export$b4e1633c86db2b70 || ($7691773a5eed3db6$export$b4e1633c86db2b70 = {}));
    var $7691773a5eed3db6$export$5e5a87aac5d9771f;
    (function(COMMAND_PALETTE_HELP_PRIORITY) {
        COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
        COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    })($7691773a5eed3db6$export$5e5a87aac5d9771f || ($7691773a5eed3db6$export$5e5a87aac5d9771f = {}));
});
parcelRegister("5rVQI", function(module, exports) {
    $parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", ()=>$c7aab549acec9d6e$export$5ea2dca0a260365d);
    var $c7aab549acec9d6e$export$5ea2dca0a260365d;
    (function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
    })($c7aab549acec9d6e$export$5ea2dca0a260365d || ($c7aab549acec9d6e$export$5ea2dca0a260365d = {}));
});
parcelRegister("eG9rp", function(module, exports) {
    $parcel$export(module.exports, "useCommandKeywords", ()=>$61ebfb9239c4f8e5$export$4d8fe3ef6385358);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dYWZb;
    const $61ebfb9239c4f8e5$export$4d8fe3ef6385358 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getKeywords = (0, $5uXOq.useCallback)((keywordGroup)=>(0, (0, parcelRequire("dYWZb")).messages)[keywordGroup] ? formatMessage((0, (0, parcelRequire("dYWZb")).messages)[keywordGroup]) : undefined, [
            formatMessage
        ]);
        return {
            getKeywords: getKeywords
        };
    };
});
parcelRegister("dYWZb", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$df7d7dd7b88156b7$export$defe85febe8b728c);
    var $7VHMR;
    const $df7d7dd7b88156b7$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchYourIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
            "defaultMessage": "Find my ideas tickets requests tasks work"
        },
        changeStatusSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
            "defaultMessage": "Move through workflow  Progress Done Complete transition"
        },
        assignToMeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
            "defaultMessage": "self"
        },
        assignIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
            "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
        },
        startWatchingIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
            "defaultMessage": "Follow work Track Unwatch Unfollow"
        },
        backlogSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
            "defaultMessage": "Inventory Go"
        },
        boardSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
            "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
        },
        reportsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
            "defaultMessage": "Summary Insights Burndown Go"
        },
        timelineSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
            "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
        },
        quickSearchSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
            "defaultMessage": "Search products across Atlassian Go to"
        },
        pageSearchSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
            "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
        },
        createIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
            "defaultMessage": "work Start idea New ticket task"
        },
        switchDarkThemeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
            "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
        },
        matchSystemThemeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
            "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
        },
        copyCurrentPageUrlSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
            "defaultMessage": "link website address"
        },
        getHelpSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
            "defaultMessage": "In-product Support Documentation Questions Answers"
        },
        viewKeyboardShortcutsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
            "defaultMessage": "Hotkeys Show See"
        },
        editDescriptionSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
            "defaultMessage": "Completion criteria Info Information Details Add Write"
        },
        addAttachmentSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
            "defaultMessage": "Attach Upload Document Media"
        },
        addCommentSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
            "defaultMessage": "Write Message"
        },
        logWorkSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
            "defaultMessage": "Track Record hours Time spent"
        },
        addRemoveFlagSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
            "defaultMessage": "Unflag Mark Unmark Star Unstar"
        },
        cloneIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
            "defaultMessage": "Copy Duplicate Task Idea Request"
        },
        linkConfluencePageSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
            "defaultMessage": "Relate Add Connect"
        },
        addAUrlSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
            "defaultMessage": "Connect Weblink Link Website Domain"
        },
        goToIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
            "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
        },
        goToPersonalSettingsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
            "defaultMessage": "Preferences Notifications Theme Jira labs"
        },
        goToAccountSettingsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
            "defaultMessage": "Preferences Privacy Profile Your details Personal information"
        },
        viewAllIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
            "defaultMessage": "Site issues JQL View all"
        },
        viewAllProjectsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllPlansSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllBoardsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllFiltersSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllDashboardsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
            "defaultMessage": "List Go"
        },
        checkNotificationsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
            "defaultMessage": "window See Updates"
        },
        goToUserManagementSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
            "defaultMessage": "Permissions"
        },
        goToIssuesSynonymsIssueTermRefresh: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms-issue-term-refresh",
            "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
        },
        viewAllIssuesSynonymsIssueTermRefresh: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms-issue-term-refresh",
            "defaultMessage": "Site issues JQL View all"
        }
    });
});
parcelRegister("879xD", function(module, exports) {
    $parcel$export(module.exports, "CommandShortcuts", ()=>$6700f9962d7215c2$export$7ff7e4fe85a5960a);
    var $5uXOq = parcelRequire("5uXOq");
    var $1Kt4o;
    var $556k7;
    var $jh7L9;
    var $3Tty1;
    const $6700f9962d7215c2$export$7ff7e4fe85a5960a = (props)=>{
        const { keyMap: keyMap } = props;
        const mappedCommands = (0, $5uXOq.useMemo)(()=>{
            const commands = [];
            Object.entries(keyMap).forEach(([key, mapItem])=>{
                if (!mapItem.registerInCommandPalette) return;
                const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
                let shortcutPrimaryAction;
                if (primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST || primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
                else if (mapItem.callback) shortcutPrimaryAction = {
                    type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                    perform: ()=>mapItem.callback()
                };
                commands.push({
                    id: `command-shortcut-${key}`,
                    shortcut: key,
                    ...command,
                    primaryAction: shortcutPrimaryAction
                });
            });
            return commands;
        }, [
            keyMap
        ]);
        const shortcutIds = (0, $5uXOq.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
            mappedCommands
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Tty1")).default), props), !!mappedCommands.length && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("556k7")).RegisterCommands), {
            registrationId: (0, (0, parcelRequire("1Kt4o")).COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
            commands: mappedCommands,
            deps: [
                shortcutIds
            ]
        }));
    };
});
parcelRegister("1Kt4o", function(module, exports) {
    $parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", ()=>$3add01bee0e3b846$export$689de18177335e39);
    $parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", ()=>$3add01bee0e3b846$export$96f61eb1261e42c3);
    const $3add01bee0e3b846$export$689de18177335e39 = {
        ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
        ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
        CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
        COPY_URL: 'COPY_URL',
        DESCRIPTION: 'DESCRIPTION',
        ISSUE_ACTIONS: 'ISSUE_ACTIONS',
        ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
        ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
        ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
        LOG_WORK: 'LOG_WORK',
        NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
        PARENT: 'PARENT',
        PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
        QUICK_ADD: 'QUICK_ADD',
        QUICK_SEARCH: 'QUICK_SEARCH',
        SHORTCUTS: 'SHORTCUTS',
        STATUS: 'STATUS',
        STORY_POINTS: 'STORY_POINTS',
        TEST: 'TEST',
        THEME_MODE: 'THEME_MODE'
    };
    const $3add01bee0e3b846$var$teams = {
        Deliveroo: 'Deliveroo'
    };
    const $3add01bee0e3b846$export$96f61eb1261e42c3 = {
        ADMIN_NAVIGATION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ADMIN_NAVIGATION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        CHECK_NOTIFICATIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.CHECK_NOTIFICATIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        COPY_URL: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.COPY_URL,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        DESCRIPTION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.DESCRIPTION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_FIELD_ASSIGN: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_HEADER_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_SUB_HEADER_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        LOG_WORK: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.LOG_WORK,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        NAVIGATION_COMMANDS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.NAVIGATION_COMMANDS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        PARENT: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.PARENT,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        PROJECT_NAVIGATION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.PROJECT_NAVIGATION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        QUICK_ADD: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_ADD,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        QUICK_SEARCH: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_SEARCH,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        SHORTCUTS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.SHORTCUTS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        STATUS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.STATUS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        STORY_POINTS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.STORY_POINTS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        THEME_MODE: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.THEME_MODE,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        }
    };
});
parcelRegister("556k7", function(module, exports) {
    $parcel$export(module.exports, "RegisterCommands", ()=>$ba0d6dd9c2ef02f6$export$cd555833c78729f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $buHQa;
    const $ba0d6dd9c2ef02f6$export$cd555833c78729f1 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("buHQa")).RegisterCommandsWithRegistry), props);
});
parcelRegister("buHQa", function(module, exports) {
    $parcel$export(module.exports, "RegisterCommandsWithRegistry", ()=>$3f4c8625aa6e8942$export$b8955a01360d2876);
    var $6QoIp;
    function $3f4c8625aa6e8942$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
        (0, (0, parcelRequire("6QoIp")).useRegisterCommandsWithRegistry)(registrationId, commands, deps);
        return null;
    }
});
parcelRegister("6QoIp", function(module, exports) {
    $parcel$export(module.exports, "useRegisterCommandsWithRegistry", ()=>$9d04f6fb396fa7c9$export$8a824ae164ff968d);
    var $5uXOq = parcelRequire("5uXOq");
    var $fIZf0;
    function $9d04f6fb396fa7c9$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
        const subscribe = (0, (0, parcelRequire("fIZf0")).useSubscribeCommandsWithRegistry)();
        const commandCache = (0, $5uXOq.useRef)(commands);
        (0, $5uXOq.useEffect)(()=>{
            commandCache.current = commands;
        }, [
            commands
        ]);
        (0, $5uXOq.useEffect)(()=>subscribe(registrationId, commandCache.current), [
            ...dependencies,
            subscribe
        ]);
    }
});
parcelRegister("fIZf0", function(module, exports) {
    $parcel$export(module.exports, "useSubscribeCommandsWithRegistry", ()=>$72118e9f2599bc72$export$880fc01e31710b27);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    function $72118e9f2599bc72$export$880fc01e31710b27() {
        const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        const subscribe = (0, $5uXOq.useCallback)((registrationId, commands)=>{
            updateActiveRegistry(registrationId, commands);
            addCommands(commands);
            return ()=>{
                removeCommands(commands);
                removeFromActiveRegistry(registrationId, commands);
            };
        }, [
            addCommands,
            removeCommands,
            removeFromActiveRegistry,
            updateActiveRegistry
        ]);
        return subscribe;
    }
});
parcelRegister("d8lE2", function(module, exports) {
    $parcel$export(module.exports, "useCommandPalette", ()=>$f75514d959bfcca8$export$6b58f9610017fbb7);
    $parcel$export(module.exports, "useActionsCommandPalette", ()=>$f75514d959bfcca8$export$72aa7bc7c6a83c36);
    $parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", ()=>$f75514d959bfcca8$export$1f90c8f89f98110e);
    $parcel$export(module.exports, "useCommandPaletteIsOpen", ()=>$f75514d959bfcca8$export$cc979be9b69236df);
    $parcel$export(module.exports, "useCommandPaletteHasChildPopup", ()=>$f75514d959bfcca8$export$a18633b655403b12);
    $parcel$export(module.exports, "useCommandPaletteIsLoaded", ()=>$f75514d959bfcca8$export$af8fd8cd4b048315);
    $parcel$export(module.exports, "useCommandPaletteSessionId", ()=>$f75514d959bfcca8$export$7422170a403e909);
    $parcel$export(module.exports, "useCommandPaletteExpandedCommand", ()=>$f75514d959bfcca8$export$282aa48e4a3afada);
    $parcel$export(module.exports, "useCommandPaletteSearch", ()=>$f75514d959bfcca8$export$96819dfb22ad05d3);
    $parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", ()=>$f75514d959bfcca8$export$f893891deedab3c6);
    $parcel$export(module.exports, "useCommandPaletteUsePerformModeState", ()=>$f75514d959bfcca8$export$bbc05723eb144e03);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    var $gM5ou;
    var $2sRNe;
    const $f75514d959bfcca8$var$initialState = {
        commandPaletteSessionId: '',
        isOpen: false,
        isLoaded: false,
        search: '',
        activeIndex: 0,
        isSearchFieldFocused: false,
        commands: [],
        parentCommand: [],
        sections: [],
        isDisabled: false,
        registry: {},
        activeRegistry: {
            commandRegistry: {},
            registryIds: []
        },
        onClosePendingCommandAction: undefined,
        isLoadChildrenError: false
    };
    const $f75514d959bfcca8$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $f75514d959bfcca8$var$initialState,
        actions: (0, parcelRequire("2sRNe")).actions,
        name: 'commandPalette'
    });
    const $f75514d959bfcca8$export$6b58f9610017fbb7 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store);
    const $f75514d959bfcca8$export$72aa7bc7c6a83c36 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($f75514d959bfcca8$var$store);
    const $f75514d959bfcca8$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
            const commandPalette = $f75514d959bfcca8$export$6b58f9610017fbb7();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
                ...props,
                commandPalette: commandPalette
            });
        };
    const $f75514d959bfcca8$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
            wordCount: (0, (0, parcelRequire("gM5ou")).getWordCount)(search),
            queryLength: search.length,
            queryHash: (0, (0, parcelRequire("gM5ou")).getQueryHash)(search),
            commandPaletteSessionId: commandPaletteSessionId,
            cpMenu: expandedCommand?.id || 'rootMenu',
            ...(0, (0, parcelRequire("gM5ou")).getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
            activeRegistryIds: activeRegistry.registryIds,
            activeRegistryIdsLength: activeRegistry.registryIds.length,
            activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
            relevancyModel: 'v2-string-similarity'
        });
    const $f75514d959bfcca8$export$1f90c8f89f98110e = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: $f75514d959bfcca8$export$56f06313122d0aac
    });
    const $f75514d959bfcca8$export$cc979be9b69236df = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ isOpen: isOpen })=>({
                isOpen: isOpen
            })
    });
    const $f75514d959bfcca8$export$a18633b655403b12 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($f75514d959bfcca8$var$store, {
        selector: (state)=>state.hasPopupOverlay
    });
    const $f75514d959bfcca8$export$af8fd8cd4b048315 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ isLoaded: isLoaded })=>({
                isLoaded: isLoaded
            })
    });
    const $f75514d959bfcca8$export$4372697329bd9cbe = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ isDisabled: isDisabled })=>({
                isDisabled: isDisabled
            })
    });
    const $f75514d959bfcca8$export$7422170a403e909 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
                commandPaletteSessionId: commandPaletteSessionId
            })
    });
    const $f75514d959bfcca8$export$282aa48e4a3afada = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
                expandedCommand: expandedCommand,
                isOpen: isOpen
            })
    });
    const $f75514d959bfcca8$export$96819dfb22ad05d3 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ search: search })=>({
                search: search
            })
    });
    const $f75514d959bfcca8$export$a40e8ae3e53feab0 = (0, (0, parcelRequire("6dDSs")).createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
            registry: registry,
            activeRegistry: activeRegistry,
            expandedCommand: expandedCommand
        }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
        if (!expandedCommand) return undefined;
        const registryData = (0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, expandedCommand.id);
        return {
            registryData: registryData,
            analyticsAttributes: registryData
        };
    });
    const $f75514d959bfcca8$export$f893891deedab3c6 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: $f75514d959bfcca8$export$a40e8ae3e53feab0
    });
    const $f75514d959bfcca8$export$bbc05723eb144e03 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
                commands: commands,
                search: search,
                expandedCommand: expandedCommand,
                childResult: childResult,
                registry: registry,
                activeRegistry: activeRegistry
            })
    });
});
parcelRegister("gM5ou", function(module, exports) {
    $parcel$export(module.exports, "getRegistryData", ()=>$cf289af0c139712c$export$6a1ed481c04a3ae6);
    $parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", ()=>$cf289af0c139712c$export$eb055284806da6e5);
    $parcel$export(module.exports, "getShortcutSpecialCharacters", ()=>$cf289af0c139712c$export$e6994b845b967732);
    $parcel$export(module.exports, "removeShortcutSpecialCharacters", ()=>$cf289af0c139712c$export$cd2a5827eae5f4cf);
    $parcel$export(module.exports, "mergeSections", ()=>$cf289af0c139712c$export$389b0273703d5c48);
    $parcel$export(module.exports, "mergeChildResults", ()=>$cf289af0c139712c$export$60a91e1b94ab4fef);
    $parcel$export(module.exports, "getAnalyticsAttributesFromState", ()=>$cf289af0c139712c$export$4023cd53e5e5fcb8);
    $parcel$export(module.exports, "isSecondaryTrigger", ()=>$cf289af0c139712c$export$daa5beabdf8d9fc3);
    $parcel$export(module.exports, "hasChildren", ()=>$cf289af0c139712c$export$bd5ff50f0e53d41c);
    $parcel$export(module.exports, "getAnalyticsAttributesFromResult", ()=>$cf289af0c139712c$export$bc9cd28438b3ea4b);
    $parcel$export(module.exports, "getQueryHash", ()=>$cf289af0c139712c$export$fa1c95a5ffa92036);
    $parcel$export(module.exports, "getWordCount", ()=>$cf289af0c139712c$export$dba3e2bcdbd49da4);
    $parcel$export(module.exports, "getCommandAction", ()=>$cf289af0c139712c$export$fb6dafa07e60c21a);
    $parcel$export(module.exports, "hasAction", ()=>$cf289af0c139712c$export$e217e69099d082f5);
    $parcel$export(module.exports, "useSetTimeoutAutoClear", ()=>$cf289af0c139712c$export$c3d20e8c1e93a572);
    var $5uXOq = parcelRequire("5uXOq");
    var $bdDiz = parcelRequire("bdDiz");
    var $2f2jJ;
    var $bcTvL;
    var $jh7L9;
    const $cf289af0c139712c$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
        if (!commandId) return undefined;
        const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
        const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
        return registryData;
    };
    const $cf289af0c139712c$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
    const $cf289af0c139712c$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
        const parentCommandIds = parentCommands?.map((command)=>command.id);
        while(parentCommandIds?.length){
            const nextParentCommandId = parentCommandIds?.pop();
            const registryData = $cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
            if (registryData) return registryData;
        }
        return undefined;
    };
    const $cf289af0c139712c$export$e6994b845b967732 = ()=>[
            {
                char: ' ',
                replacement: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).THEN
            },
            {
                char: '+',
                replacement: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).PLUS
            },
            {
                char: '|',
                replacement: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).OR
            }
        ];
    const $cf289af0c139712c$export$cd2a5827eae5f4cf = (shortcut)=>{
        const specialChars = $cf289af0c139712c$export$e6994b845b967732();
        let strippedShortcut = shortcut;
        specialChars.forEach(({ char: char })=>{
            strippedShortcut = strippedShortcut.split(char).join('');
        });
        return strippedShortcut.toLowerCase();
    };
    const $cf289af0c139712c$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
            Object.entries(curr).forEach(([key, entry])=>{
                acc[key] = entry;
            });
            return acc;
        }, {});
    const $cf289af0c139712c$export$60a91e1b94ab4fef = (childResults)=>{
        const commands = [];
        const sections = [];
        childResults.forEach((childResult)=>{
            commands.push(...childResult.commands);
            if (childResult.sections) sections.push(childResult.sections);
        });
        return {
            commands: commands,
            sections: $cf289af0c139712c$export$389b0273703d5c48(sections)
        };
    };
    const $cf289af0c139712c$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
        const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
        const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
        const regex = new RegExp(regexString, 'g');
        return text.replace(/[.,]/g, '').replace(regex, '').replace(/\s{2,}/g, ' ').trim();
    };
    const $cf289af0c139712c$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
        const analyticsAttributes = {
            commandPaletteId: command.id,
            commandPaletteSessionId: state.commandPaletteSessionId,
            searchTaken: !!state.search,
            method: method,
            cpMenu: 'rootMenu',
            action: command.id,
            actionCategory: 'none',
            wasSecondaryTriggered: wasSecondaryTriggered,
            ...$cf289af0c139712c$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
            ...$cf289af0c139712c$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
            ...$cf289af0c139712c$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
            ...attributes,
            ...!!command.analytics && command.analytics
        };
        if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
        else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
        const sections = state.expandedCommand && state.childResult?.sections ? $cf289af0c139712c$export$389b0273703d5c48([
            ...state.sections,
            state.childResult?.sections
        ]) : $cf289af0c139712c$export$389b0273703d5c48(state.sections);
        const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
        const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
        analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
        return analyticsAttributes;
    };
    const $cf289af0c139712c$export$daa5beabdf8d9fc3 = (event)=>(0, (0, parcelRequire("2f2jJ")).isMacOs)() ? event.metaKey : event.ctrlKey;
    const $cf289af0c139712c$export$bd5ff50f0e53d41c = (command)=>{
        if (command?.wasSecondaryTriggered) {
            if (command?.secondaryAction?.type) {
                const hasSecondaryChildren = (0, (0, parcelRequire("jh7L9")).COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
                return hasSecondaryChildren;
            }
            return (0, (0, parcelRequire("jh7L9")).COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
        }
        return (0, (0, parcelRequire("jh7L9")).COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    };
    const $cf289af0c139712c$export$bc9cd28438b3ea4b = (result)=>{
        if (result) return {
            globalIndex: result.index,
            sectionIndex: result.sectionIndex,
            indexWithinSection: result.indexWithinSection,
            sectionId: result.sectionId
        };
        return {};
    };
    const $cf289af0c139712c$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
    const $cf289af0c139712c$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
    const $cf289af0c139712c$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
        if (!command) return null;
        const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
        if (!primaryAction) return null;
        const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
        return {
            ...commandAction
        };
    };
    const $cf289af0c139712c$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
    const $cf289af0c139712c$export$c3d20e8c1e93a572 = ()=>{
        const timeoutRef = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>()=>{
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
            }, []);
        const setTimeoutAutoClear = (...args)=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(...args);
        };
        return {
            setTimeoutAutoClear: setTimeoutAutoClear
        };
    };
});
parcelRegister("2f2jJ", function(module, exports) {
    $parcel$export(module.exports, "isMacOs", ()=>$6846128323867ebd$export$c5e71f489eb3970b);
    $parcel$export(module.exports, "getShortcutModifierKey", ()=>$6846128323867ebd$export$fe66dae91c68619b);
    const $6846128323867ebd$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
    const $6846128323867ebd$export$fe66dae91c68619b = ()=>$6846128323867ebd$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';
});
parcelRegister("bcTvL", function(module, exports) {
    $parcel$export(module.exports, "UI_EVENT_TYPE", ()=>$3996a4302dca83b1$export$a1562d08625f5d7e);
    $parcel$export(module.exports, "TRACK_EVENT_TYPE", ()=>$3996a4302dca83b1$export$947dac6c72b26f81);
    $parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", ()=>$3996a4302dca83b1$export$1ee9d153576afd13);
    $parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", ()=>$3996a4302dca83b1$export$894e19fc96687503);
    const $3996a4302dca83b1$export$a1562d08625f5d7e = 'UI';
    const $3996a4302dca83b1$export$947dac6c72b26f81 = 'TRACK';
    const $3996a4302dca83b1$export$f1d537d508d2945a = 'SCREEN';
    const $3996a4302dca83b1$export$12346a674644c156 = 'OPERATIONAL';
    var $3996a4302dca83b1$export$1ee9d153576afd13;
    (function(SHORTCUT_ELEMENT_TYPES) {
        SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
        SHORTCUT_ELEMENT_TYPES["OR"] = "or";
        SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
        SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    })($3996a4302dca83b1$export$1ee9d153576afd13 || ($3996a4302dca83b1$export$1ee9d153576afd13 = {}));
    const $3996a4302dca83b1$export$894e19fc96687503 = 250;
});
parcelRegister("jh7L9", function(module, exports) {
    $parcel$export(module.exports, "CommandActionType", ()=>$b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
    $parcel$export(module.exports, "COMMAND_WITH_CHILDREN", ()=>$b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3);
    var $b1e48ebd4c8d5e4e$export$f041b1b117ab382f;
    (function(CommandActionType) {
        CommandActionType["PERFORM"] = "perform";
        CommandActionType["COMMAND_LIST"] = "command-list";
    })($b1e48ebd4c8d5e4e$export$f041b1b117ab382f || ($b1e48ebd4c8d5e4e$export$f041b1b117ab382f = {}));
    const $b1e48ebd4c8d5e4e$export$3e448fd53031e13c = Object.values($b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
    const $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3 = [
        "command-list"
    ];
});
parcelRegister("2sRNe", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$4f4c9e92d50d4f24$export$e324594224ef24da);
    var $kGsr8 = parcelRequire("kGsr8");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $e7WVN;
    var $eTXmK;
    var $2f2jJ;
    var $jcw0u;
    var $bcTvL;
    var $jh7L9;
    var $gM5ou;
    var $4DwnT;
    var $h3eZO;
    const $4f4c9e92d50d4f24$var$rootCommands = {
        parentCommand: [],
        expandedCommand: undefined,
        childCommands: undefined,
        childResult: undefined
    };
    const $4f4c9e92d50d4f24$var$open = ()=>({ setState: setState, getState: getState })=>{
            if (getState().isDisabled) return;
            setState({
                commandPaletteSessionId: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                isOpen: true,
                activeIndex: 0,
                search: ''
            });
        };
    const $4f4c9e92d50d4f24$var$close = ()=>({ setState: setState })=>{
            setState({
                isOpen: false,
                commandPaletteSessionId: '',
                search: '',
                ...$4f4c9e92d50d4f24$var$rootCommands
            });
        };
    const $4f4c9e92d50d4f24$var$toggle = ()=>({ setState: setState, getState: getState })=>{
            const isOpen = !getState().isOpen;
            setState({
                isOpen: isOpen,
                activeIndex: 0,
                search: '',
                commandPaletteSessionId: isOpen ? (0, ($parcel$interopDefault($7Jxgt))).v4() : '',
                ...!isOpen ? $4f4c9e92d50d4f24$var$rootCommands : {}
            });
        };
    const $4f4c9e92d50d4f24$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newCommands = currentState.commands.concat(commands);
            const newState = {
                commands: newCommands
            };
            if (currentState.expandedCommand) {
                const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
                if (matchedExpandedCommand.length === 1) {
                    const [updatedExpandedCommand] = matchedExpandedCommand;
                    newState.expandedCommand = updatedExpandedCommand;
                }
            }
            setState(newState);
        };
    const $4f4c9e92d50d4f24$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
            const newCommands = getState().commands.filter((command)=>!commands.includes(command));
            setState({
                commands: newCommands
            });
        };
    const $4f4c9e92d50d4f24$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
            const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
            setState({
                commands: newCommands
            });
        };
    const $4f4c9e92d50d4f24$var$handleSearch = (search)=>({ setState: setState })=>{
            setState({
                search: search,
                activeIndex: 0
            });
        };
    const $4f4c9e92d50d4f24$var$forceSearchValue = (search)=>({ setState: setState })=>{
            setState({
                search: search,
                shouldForceSearchValue: true
            });
        };
    const $4f4c9e92d50d4f24$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
            setState({
                shouldForceSearchValue: false
            });
        };
    const $4f4c9e92d50d4f24$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (!currentState.expandedCommand) return;
            const newState = {
                search: '',
                activeIndex: 0,
                childResult: undefined,
                forceSearchFocus: true
            };
            if (currentState.parentCommand.length && !goToRoot) {
                newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
                newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
                if (newState.expandedCommand?.primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                    commands: newState.expandedCommand?.primaryAction?.commands,
                    sections: newState.expandedCommand?.primaryAction?.sections
                };
            } else {
                newState.loadingList = false;
                newState.parentCommand = [];
                newState.expandedCommand = undefined;
                newState.childResult = undefined;
            }
            if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            }), (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                attributes: {
                    cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                    searchSessionId: currentState.commandPaletteSessionId,
                    action: goToRoot ? 'backToRoot' : 'backToParent',
                    actionCategory: 'back',
                    method: analytics?.method
                }
            });
            setState(newState);
        };
    const $4f4c9e92d50d4f24$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
            setState({
                forceSearchFocus: forceSearchFocus
            });
        };
    const $4f4c9e92d50d4f24$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
            const { isSearchFieldFocused: isSearchFieldFocused } = getState();
            setState({
                activeIndex: index,
                ...!isSearchFieldFocused ? {
                    forceSearchFocus: true
                } : {}
            });
        };
    const $4f4c9e92d50d4f24$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
    const $4f4c9e92d50d4f24$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
            setTimeout(()=>{
                const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
                if (onClosePendingCommandAction !== undefined) {
                    try {
                        (0, (0, parcelRequire("eTXmK")).default)('command-palette-executed');
                        onClosePendingCommandAction.perform();
                        if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                            const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                                action: 'taskSucceeded',
                                actionSubject: 'commandPalette'
                            });
                            onAnalytics(performAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                                attributes: onClosePendingCommandAction?.analyticsArgs
                            });
                        }
                    } catch (err) {
                        const error = err instanceof Error ? err : new Error('Command palette perform error');
                        (0, (0, parcelRequire("jcw0u")).default)({
                            error: error,
                            meta: {
                                id: 'compal.performDialogCloseCommand',
                                packageName: 'jiraCommandPalette',
                                teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                            },
                            attributes: onClosePendingCommandAction.analyticsArgs
                        });
                        (0, (0, parcelRequire("e7WVN")).setInteractionError)('command-palette-executed', {
                            errorMessage: error.message,
                            name: 'performDialogCloseCommandPerformError'
                        });
                    }
                    setState({
                        onClosePendingCommandAction: undefined
                    });
                }
            }, 0);
        };
    const $4f4c9e92d50d4f24$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newState = {
                ...!(0, (0, parcelRequire("4DwnT")).getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                    search: ''
                },
                activeIndex: 0
            };
            const analyticsAttributes = (0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
            const currentCommandAction = (0, (0, parcelRequire("gM5ou")).getCommandAction)(command, wasSecondaryTriggered);
            if (!currentCommandAction) return;
            if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
                const analyticsEvent = analytics.createAnalyticsEvent({
                    action: 'navigation',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(analyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                    attributes: analyticsAttributes
                });
            }
            const shouldLoadChildren = (0, (0, parcelRequire("gM5ou")).hasChildren)({
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            });
            const shouldExecutePerform = currentCommandAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM;
            if (shouldLoadChildren) {
                (0, (0, parcelRequire("eTXmK")).default)('command-palette-load-child-command-list');
                if (currentState.expandedCommand) newState.parentCommand = [
                    ...currentState.parentCommand,
                    currentState.expandedCommand
                ];
                newState.expandedCommand = {
                    ...command,
                    wasSecondaryTriggered: wasSecondaryTriggered
                };
                newState.childResult = undefined;
                newState.forceSearchFocus = true;
                if ((0, (0, parcelRequire("h3eZO")).isSearchableChildrenAction)(currentCommandAction)) {
                    newState.childResult = {
                        commands: currentCommandAction.commands,
                        sections: currentCommandAction.sections
                    };
                    if (command.parentCommands?.length) newState.parentCommand = [
                        ...newState.parentCommand || [],
                        ...command.parentCommands
                    ];
                } else newState.childResult = undefined;
                setState(newState);
                if (currentCommandAction.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
            } else if (shouldExecutePerform) {
                if (!currentCommandAction.preventModalClose) {
                    newState.commandPaletteSessionId = '';
                    newState.isOpen = false;
                    newState.expandedCommand = undefined;
                    newState.parentCommand = [];
                    newState.childResult = undefined;
                    setState(newState);
                    if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                        const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                            action: 'closed',
                            actionSubject: 'commandPalette'
                        });
                        currentState.onAnalytics(closeAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).UI_EVENT_TYPE), {
                            attributes: analyticsAttributes
                        });
                    }
                }
                if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'secondaryAction',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                        attributes: {
                            ...analyticsAttributes,
                            keyPressed: (0, (0, parcelRequire("2f2jJ")).isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                            ...currentCommandAction.analyticsArgs
                        }
                    });
                }
                if (currentCommandAction.preventModalClose) try {
                    (0, (0, parcelRequire("eTXmK")).default)('command-palette-executed');
                    currentCommandAction.perform();
                    if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                        const performAnalyticsEvent = analytics.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        currentState.onAnalytics(performAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                            attributes: analyticsAttributes
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'compal.executeCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                        },
                        attributes: analytics?.attributes
                    });
                    (0, (0, parcelRequire("e7WVN")).setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'executeCommandPerformError'
                    });
                }
                else setState({
                    onClosePendingCommandAction: {
                        ...currentCommandAction,
                        analyticsArgs: analyticsAttributes,
                        createAnalyticsEvent: analytics?.createAnalyticsEvent
                    }
                });
            }
        };
    const $4f4c9e92d50d4f24$var$setChildCommands = (childResult)=>({ setState: setState })=>{
            setState({
                childResult: childResult
            });
        };
    const $4f4c9e92d50d4f24$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
            setState({
                loadingList: loadingList
            });
        };
    const $4f4c9e92d50d4f24$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
                isSearchFieldFocused: isSearchFieldFocused
            });
    const $4f4c9e92d50d4f24$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const sections = currentState.sections.slice(0);
            sections.push(newSections);
            setState({
                sections: sections
            });
        };
    const $4f4c9e92d50d4f24$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const sections = currentState.sections.filter((section)=>section !== newSections);
            setState({
                sections: sections
            });
        };
    const $4f4c9e92d50d4f24$var$markAsLoaded = ()=>({ setState: setState })=>{
            setState({
                isLoaded: true
            });
        };
    const $4f4c9e92d50d4f24$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
            setState({
                isDisabled: isDisabled,
                ...isDisabled ? {
                    isOpen: false
                } : {}
            });
        };
    const $4f4c9e92d50d4f24$var$setRegistry = (registry)=>({ setState: setState })=>{
            setState({
                registry: registry
            });
        };
    const $4f4c9e92d50d4f24$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
            const currentActiveRegistry = getState().activeRegistry;
            const activeRegistry = {
                commandRegistry: {
                    ...currentActiveRegistry.commandRegistry,
                    ...commands.reduce((acc, command)=>{
                        acc[command.id] = {
                            registryId: registryId
                        };
                        return acc;
                    }, {})
                },
                registryIds: (0, ($parcel$interopDefault($kGsr8)))([
                    ...currentActiveRegistry.registryIds,
                    registryId
                ])
            };
            setState({
                activeRegistry: activeRegistry
            });
        };
    const $4f4c9e92d50d4f24$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
            const currentActiveRegistry = getState().activeRegistry;
            const commandRegistry = {
                ...currentActiveRegistry.commandRegistry
            };
            commands.forEach((command)=>{
                delete commandRegistry[command.id];
            });
            setState({
                activeRegistry: {
                    commandRegistry: commandRegistry,
                    registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
                }
            });
        };
    const $4f4c9e92d50d4f24$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
            setState({
                onAnalytics: onAnalytics,
                onErrorAnalytics: onErrorAnalytics
            });
        };
    const $4f4c9e92d50d4f24$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
            setState({
                fallbackOverride: fallbackOverride
            });
        };
    const $4f4c9e92d50d4f24$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
            setState({
                hasPopupOverlay: hasPopupOverlay
            });
        };
    const $4f4c9e92d50d4f24$export$e324594224ef24da = {
        open: $4f4c9e92d50d4f24$var$open,
        toggle: $4f4c9e92d50d4f24$var$toggle,
        close: $4f4c9e92d50d4f24$var$close,
        addCommands: $4f4c9e92d50d4f24$var$addCommands,
        removeCommands: $4f4c9e92d50d4f24$var$removeCommands,
        handleSearch: $4f4c9e92d50d4f24$var$handleSearch,
        forceFocusSearch: $4f4c9e92d50d4f24$var$forceFocusSearch,
        setActiveIndex: $4f4c9e92d50d4f24$var$setActiveIndex,
        executeCommand: $4f4c9e92d50d4f24$var$executeCommand,
        goBackLevel: $4f4c9e92d50d4f24$var$goBackLevel,
        setChildCommands: $4f4c9e92d50d4f24$var$setChildCommands,
        setLoadingList: $4f4c9e92d50d4f24$var$setLoadingList,
        setFocusInput: $4f4c9e92d50d4f24$var$setFocusInput,
        registerSections: $4f4c9e92d50d4f24$var$registerSections,
        unregisterSections: $4f4c9e92d50d4f24$var$unregisterSections,
        markAsLoaded: $4f4c9e92d50d4f24$var$markAsLoaded,
        getAnalyticsAttributes: $4f4c9e92d50d4f24$var$getAnalyticsAttributes,
        setIsDisabled: $4f4c9e92d50d4f24$var$setIsDisabled,
        setRegistry: $4f4c9e92d50d4f24$var$setRegistry,
        updateActiveRegistry: $4f4c9e92d50d4f24$var$updateActiveRegistry,
        removeCommandsById: $4f4c9e92d50d4f24$var$removeCommandsById,
        removeFromActiveRegistry: $4f4c9e92d50d4f24$var$removeFromActiveRegistry,
        performDialogCloseCommand: $4f4c9e92d50d4f24$var$performDialogCloseCommand,
        setAnalytics: $4f4c9e92d50d4f24$var$setAnalytics,
        setFallbackOverride: $4f4c9e92d50d4f24$var$setFallbackOverride,
        setHasPopupOverlay: $4f4c9e92d50d4f24$var$setHasPopupOverlay,
        forceSearchValue: $4f4c9e92d50d4f24$var$forceSearchValue,
        resetShouldForceSearchValue: $4f4c9e92d50d4f24$var$resetShouldForceSearchValue
    };
});
parcelRegister("4DwnT", function(module, exports) {
    $parcel$export(module.exports, "getActiveCommandList", ()=>$b4088022dc3f5c54$export$639b7f41b0b47a01);
    var $jh7L9;
    const $b4088022dc3f5c54$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
        if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
        if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
        return null;
    };
});
parcelRegister("h3eZO", function(module, exports) {
    $parcel$export(module.exports, "isSearchableChildrenAction", ()=>$dd5db8363c7eeda7$export$d75616d77443fe4e);
    var $jh7L9;
    const $dd5db8363c7eeda7$export$d75616d77443fe4e = (action)=>action?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST && action.commands !== undefined;
});
parcelRegister("3Tty1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ba57d5dc6c0de0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9IeM0;
    var $4lkOX;
    var $h0GOb;
    var $k4r7E;
    var $9fuVs;
    var $kspvB;
    let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
    let $6ba57d5dc6c0de0a$var$subscription = null;
    const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
        const parentRegistry = (0, $5uXOq.useContext)((0, (0, parcelRequire("9fuVs")).ShortcutRegistryContext)) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                    keyMap: (0, (0, parcelRequire("kspvB")).bindKeyMapWithErrorHandling)(keyMap, location),
                    label: label
                })), [
            label,
            parentRegistry,
            keyMap,
            location
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
            const removeKeyMap = addKeyMap();
            return ()=>{
                removeKeyMap();
                $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
                if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                    $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                    $6ba57d5dc6c0de0a$var$subscription = null;
                }
            };
        }, [
            addKeyMap
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || (0, (0, parcelRequire("h0GOb")).default)().subscribe((0, (0, parcelRequire("4lkOX")).default));
        }, [
            parentRegistry,
            keyMap
        ]);
        return null;
    };
    var $6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, (0, parcelRequire("9IeM0")).useKeyboardShortcutsToggle), ...props })=>{
        const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
        return isEnabled && !false ? (0, ($parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
    };
});
parcelRegister("9IeM0", function(module, exports) {
    $parcel$export(module.exports, "useKeyboardShortcutsToggle", ()=>$dc712fc9bec05022$export$a33a81f1fc5458ad);
    var $jcw0u;
    var $eusud;
    var $j8DrX;
    var $8zOmE;
    var $3sQ5x;
    var $iXqE5;
    const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
    const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
            const currentState = getState().isEnabled;
            const status = currentState ? 'off' : 'on';
            const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)(url);
                setState({
                    isEnabled: !currentState,
                    error: null
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                    isEnabled: !currentState
                });
            } catch (err) {
                setState({
                    error: err
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'keyboardShortcutToggleFailure',
                        packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                    },
                    error: err
                });
            }
        };
    const $dc712fc9bec05022$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            isEnabled: false ? false : !((0, (0, parcelRequire("j8DrX")).default)('ajs-keyboard-shortcuts-enabled') === 'false'),
            error: null
        },
        actions: {
            toggle: $dc712fc9bec05022$export$b62f67be35e65859
        }
    });
    const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, (0, parcelRequire("3sQ5x")).createHook)($dc712fc9bec05022$var$Store);
});
parcelRegister("4lkOX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f11d50ddafbb6f85$export$2e2bcd8739ae039);
    var $h0GOb;
    var $k4r7E;
    const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
    var $f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
        const { sequence: sequence, e: e } = keySequence || {};
        const activeKeyMap = (0, (0, parcelRequire("k4r7E")).rootRegistry).getActiveKeyMap();
        if (sequence !== undefined && activeKeyMap[sequence]) {
            activeKeyMap[sequence].callback(e);
            (0, (0, parcelRequire("h0GOb")).flush)();
        } else {
            const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
            if (!isFutureMatchPossible) (0, (0, parcelRequire("h0GOb")).flush)();
        }
    };
});
parcelRegister("h0GOb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$849cd54ac4017470$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "flush", ()=>$849cd54ac4017470$export$4909b86c8034bf73);
    var $kVLXA = parcelRequire("kVLXA");
    var $cab1K = parcelRequire("cab1K");
    parcelRequire("jG6Un");
    parcelRequire("eSGL3");
    parcelRequire("1oQta");
    parcelRequire("4kRRr");
    parcelRequire("d0pqD");
    parcelRequire("iQCJJ");
    parcelRequire("fjPtF");
    parcelRequire("2R2to");
    var $lIZQG;
    const $849cd54ac4017470$var$ignoredKeys = {
        Control: true,
        Meta: true,
        Shift: true,
        Alt: true,
        AltGraph: true,
        CapsLock: true,
        Fn: true,
        FnLock: true,
        Hyper: true,
        NumLock: true,
        OS: true,
        ScrollLock: true,
        Super: true,
        Symbol: true,
        SymbolLock: true
    };
    const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
    const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
    const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
    const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
        const elBlankets = document.querySelectorAll('.aui-blanket');
        if (elBlankets.length === 0) return true;
        const isAllHidden = Array.from(elBlankets || []).every((el)=>{
            if (el.getAttribute('aria-hidden') === 'true' || el.getAttribute('hidden') !== null) return true;
            return false;
        });
        return isAllHidden;
    };
    let $849cd54ac4017470$var$key$;
    const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
    var $849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
        if (!$849cd54ac4017470$var$key$) {
            $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, (0, parcelRequire("lIZQG")).toKeyWithModifiers));
            const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
                if (!key || !seq) return undefined;
                return {
                    sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                    e: key.e
                };
            });
            $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
        }
        return $849cd54ac4017470$var$key$;
    };
    const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
        $849cd54ac4017470$var$flush$.next();
    };
});
parcelRegister("kspvB", function(module, exports) {
    $parcel$export(module.exports, "bindKeyMapWithErrorHandling", ()=>$f9e30ab2465f6f16$export$77477772a9b904da);
    var $dJl1T;
    const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
            try {
                callback(e);
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
            }
        };
    const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location)=>Object.keys(keyMap).reduce((map, key)=>({
                ...map,
                [key]: {
                    ...keyMap[key],
                    callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
                }
            }), {});
});
const $d791d5657a673291$export$abc61f74b6bec12c = 'viewJqlBuilderAdvanced';
const $d791d5657a673291$export$b8b9d90f9e5bd72b = 'jiraJqlBuilderAdvanced';
const $d791d5657a673291$export$d57b6b390e78d90f = 'empanada';
parcelRegister("apc2O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb8e67980bca7270$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cb8e67980bca7270$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "jql-builder-advanced.error-flag-title",
            "defaultMessage": "We couldn't edit the query"
        },
        errorFlagDescription: {
            "id": "jql-builder-advanced.error-flag-description",
            "defaultMessage": "The JQL builder is unresponsive. Refresh the page to try again."
        },
        searchCurrentPage: {
            "id": "jql-builder-advanced.search-current-page",
            "defaultMessage": "Search on current page"
        }
    });
});
parcelRegister("b3ogM", function(module, exports) {
    $parcel$export(module.exports, "useAutocompleteInitialData", ()=>$dc220e745e296d72$export$21e39afbf909ee71);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $7f4tk;
    var $aYrMA;
    const $dc220e745e296d72$export$21e39afbf909ee71 = (excludedAutocompleteFields = [])=>(0, $5uXOq.useCallback)((url)=>{
            const options = {
                method: 'POST',
                body: JSON.stringify({
                    includeCollapsedFields: true
                })
            };
            return (0, (0, parcelRequire("aYrMA")).fetchWithRetry)(()=>(0, (0, parcelRequire("7f4tk")).default)(url, options), 1).then((res)=>({
                    jqlFields: excludedAutocompleteFields.length === 0 ? res.visibleFieldNames : res.visibleFieldNames.filter((field)=>!excludedAutocompleteFields.includes(field.value)),
                    jqlFunctions: res.visibleFunctionNames
                })).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'getAutocompleteInitialData',
                        packageName: (0, $d791d5657a673291$export$b8b9d90f9e5bd72b),
                        teamName: (0, $d791d5657a673291$export$d57b6b390e78d90f)
                    }
                });
                throw error;
            });
        }, [
            excludedAutocompleteFields
        ]);
});
parcelRegister("aYrMA", function(module, exports) {
    $parcel$export(module.exports, "fetchWithRetry", ()=>$cd66ab16f42aa45f$export$cffaac380b94df26);
    const $cd66ab16f42aa45f$export$cffaac380b94df26 = async (fetchCall, retryAttempts)=>{
        try {
            return await fetchCall();
        } catch (error) {
            if (retryAttempts > 0) return $cd66ab16f42aa45f$export$cffaac380b94df26(fetchCall, retryAttempts - 1);
            throw error;
        }
    };
});
parcelRegister("3pImq", function(module, exports) {
    $parcel$export(module.exports, "useAutocompleteSuggestions", ()=>$016ed0d8dff873d2$export$b39a9f86c7843060);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $7f4tk;
    const $016ed0d8dff873d2$export$b39a9f86c7843060 = ()=>{
        const baseUrl = '';
        return (0, $5uXOq.useCallback)((url)=>(0, (0, parcelRequire("7f4tk")).default)(baseUrl + url).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'getAutocompleteSuggestions',
                        packageName: (0, $d791d5657a673291$export$b8b9d90f9e5bd72b),
                        teamName: (0, $d791d5657a673291$export$d57b6b390e78d90f)
                    }
                });
                throw error;
            }), [
            baseUrl
        ]);
    };
});
parcelRegister("8BS0n", function(module, exports) {
    $parcel$export(module.exports, "useOnHydrate", ()=>$9b35be75c4b6069c$export$6d016355519acd77);
    var $46LbS;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jcw0u;
    var $9OXo1;
    const $9b35be75c4b6069c$export$f2e498f301ac7cdf = (response)=>{
        if (!response?.jira?.jqlBuilder?.hydrateJqlQuery?.fields) return {};
        const hydratedValues = {};
        response.jira.jqlBuilder.hydrateJqlQuery.fields.forEach((field)=>{
            if (field.values) {
                const fieldValues = [];
                field.values.forEach((valueResult)=>{
                    if (valueResult?.values) valueResult.values.forEach((value)=>{
                        if (value?.__typename === 'JiraJqlUserFieldValue') fieldValues.push({
                            type: 'user',
                            id: value.jqlTerm,
                            name: value.displayName,
                            avatarUrl: value.user?.picture ?? ''
                        });
                    });
                });
                if (field.field && field.field.searchTemplate) {
                    const fieldName = field.field.jqlTerm;
                    if ((0, $37ea070a15b5378a$export$3df7f6b39477220a) === field.field.searchTemplate.key) fieldValues.push({
                        type: 'deprecated-field',
                        id: fieldName,
                        deprecatedSearcherKey: field.field.searchTemplate.key
                    });
                }
                if (field.field && field.field.searchTemplate) {
                    const fieldName = field.field.jqlTerm;
                    if ((0, $37ea070a15b5378a$export$f8cba5bda41a61a0) === field.field.searchTemplate.key) fieldValues.push({
                        type: 'deprecated-field',
                        id: fieldName,
                        deprecatedSearcherKey: field.field.searchTemplate.key
                    });
                }
                if (fieldValues.length > 0 && field.field) {
                    const fieldName = field.field.jqlTerm;
                    hydratedValues[fieldName] = fieldValues;
                }
            }
        });
        return hydratedValues;
    };
    const $9b35be75c4b6069c$export$6d016355519acd77 = (viewContext)=>{
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return (0, $5uXOq.useCallback)(async (jql)=>{
            try {
                const data = await (0, $8Uumt.fetchQuery)(environment, (0, (0, parcelRequire("46LbS")).default), {
                    jql: jql,
                    cloudId: cloudId,
                    viewContext: viewContext
                }, {
                    networkCacheConfig: {
                        metadata: {
                            META_SLOW_ENDPOINT: true
                        }
                    }
                }).toPromise();
                return $9b35be75c4b6069c$export$f2e498f301ac7cdf(data);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'useOnHydrateRelay',
                        packageName: (0, $d791d5657a673291$export$b8b9d90f9e5bd72b),
                        teamName: (0, $d791d5657a673291$export$d57b6b390e78d90f)
                    }
                });
                throw error;
            }
        }, [
            cloudId,
            environment,
            viewContext
        ]);
    };
});
parcelRegister("46LbS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$332dbdaedb96ffcc$export$2e2bcd8739ae039);
    const $332dbdaedb96ffcc$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewContext"
        }, v3 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v4 = [
            {
                "kind": "Variable",
                "name": "query",
                "variableName": "jql"
            },
            {
                "kind": "Variable",
                "name": "viewContext",
                "variableName": "viewContext"
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "jqlTerm"
        }, v6 = {
            "concreteType": "JiraJqlField",
            "kind": "LinkedField",
            "name": "field",
            "plural": false,
            "selections": [
                v5,
                {
                    "concreteType": "JiraJqlSearchTemplate",
                    "kind": "LinkedField",
                    "name": "searchTemplate",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        }, v7 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v8 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v9 = {
            "kind": "ScalarField",
            "name": "picture"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2
                ],
                "kind": "Fragment",
                "name": "hydrationRelayJqlBuilderAdvancedQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v4,
                                        "kind": "LinkedField",
                                        "name": "hydrateJqlQuery",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "fields",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v6,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "values",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "values",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v5,
                                                                                            v7,
                                                                                            v8,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "user",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v9
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraJqlUserFieldValue"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraJqlQueryHydratedValue"
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlQueryHydratedField"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraJqlHydratedQuery"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0,
                    v2
                ],
                "kind": "Operation",
                "name": "hydrationRelayJqlBuilderAdvancedQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v4,
                                        "kind": "LinkedField",
                                        "name": "hydrateJqlQuery",
                                        "plural": false,
                                        "selections": [
                                            v8,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "fields",
                                                        "plural": true,
                                                        "selections": [
                                                            v8,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v6,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "values",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v8,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "values",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v5,
                                                                                            v7,
                                                                                            v8,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "user",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v8,
                                                                                                            v9,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "id"
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraJqlUserFieldValue"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraJqlQueryHydratedValue"
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlQueryHydratedField"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraJqlHydratedQuery"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "ba4fcfcd09e227177aa23416dd3fdedaf9a469a4454cbd34e0ea60cb63a5bf4e",
                "metadata": {},
                "name": "hydrationRelayJqlBuilderAdvancedQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $332dbdaedb96ffcc$var$node.hash = "b26239c922b8627fea8a8e88766856e6";
    var $332dbdaedb96ffcc$export$2e2bcd8739ae039 = $332dbdaedb96ffcc$var$node;
});
const $37ea070a15b5378a$export$3df7f6b39477220a = 'com.pyxis.greenhopper.jira:gh-epic-link-searcher';
const $37ea070a15b5378a$export$f8cba5bda41a61a0 = 'com.atlassian.jpo:jpo-custom-field-parent-searcher';
parcelRegister("ixr8x", function(module, exports) {
    $parcel$export(module.exports, "SearchModeSwitcherRenderer", ()=>$7c3e0f295f843416$export$f054999725e0d47f);
    var $5uXOq = parcelRequire("5uXOq");
    var $032ey;
    var $3fufq;
    var $8xRQz;
    var $1PKzp;
    var $kcuJ8;
    const $7c3e0f295f843416$export$f054999725e0d47f = ({ isSearchModeToggleEnabled: isSearchModeToggleEnabled, SearchModeSwitcher: SearchModeSwitcher = (0, (0, parcelRequire("3fufq")).SearchModeSwitcherWithTarget), isHydrating: isHydrating, isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft })=>{
        const { searchMode: selectedSearchMode, setSelectedSearchMode: setSelectedSearchMode } = (0, (0, parcelRequire("1PKzp")).useSelectedSearchMode)();
        const { querySupported: querySupported } = (0, (0, parcelRequire("kcuJ8")).useIsQuerySupported)();
        const onUpdateSearchMode = (0, $5uXOq.useCallback)((searchMode)=>{
            setSelectedSearchMode(searchMode, true);
        }, [
            setSelectedSearchMode
        ]);
        const isBasicModeDisabled = (0, $5uXOq.useMemo)(()=>!querySupported || isHydrating && selectedSearchMode !== (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC), [
            isHydrating,
            querySupported,
            selectedSearchMode
        ]);
        return isSearchModeToggleEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8xRQz")).SearchModeSwitcherContainer), {
            testId: "jql-builder.ui.search-mode-switcher-renderer.toggle-container",
            isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(SearchModeSwitcher, {
            searchMode: selectedSearchMode,
            isBasicModeDisabled: isBasicModeDisabled,
            onUpdateSearchMode: onUpdateSearchMode
        })) : null;
    };
});
parcelRegister("eNPxN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a434027abe881a8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6a434027abe881a8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "polaris-component-collection-create.form.filters.label",
            "defaultMessage": "Select search mode"
        },
        basicModeDisabledTooltip: {
            "id": "polaris-component-collection-create.form.filters.basic-mode-disabled-tooltip",
            "defaultMessage": "You can't switch to basic as the query is too complex or is invalid"
        },
        basicMode: {
            "id": "polaris-component-collection-create.form.filters.basic-mode",
            "defaultMessage": "Basic"
        },
        advancedMode: {
            "id": "polaris-component-collection-create.form.filters.advanced-mode",
            "defaultMessage": "Advanced"
        }
    });
});
parcelRegister("17h70", function(module, exports) {
    $parcel$export(module.exports, "Footer", ()=>$c23f03eba55d136e$export$a06f1c675e846f6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $8jRgk;
    var $gtreQ;
    var $1I7E8;
    var $dC5iT;
    var $f5TWP;
    var $5ILhZ;
    var $cgL5K;
    var $8CUq3;
    var $4R6GH;
    var $koVbs;
    var $gE10J;
    var $5eNy4;
    const $c23f03eba55d136e$export$a06f1c675e846f6f = ({ submitting: submitting, ideasCount: ideasCount, isIdeasCountLoading: isIdeasCountLoading })=>{
        const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, (0, parcelRequire("koVbs")).default)();
        const [isLimitWarningPopupOpen, setIsLimitWarningPopupOpen] = (0, $5uXOq.useState)(false);
        const limitWarningMessage = formatMessage((0, (0, parcelRequire("5eNy4")).default).ideasCountLimitMessage, {
            ideasCountLimit: formatNumber((0, (0, parcelRequire("gE10J")).IDEAS_COUNT_LIMIT))
        });
        const openWarningPopup = (e)=>{
            e.stopPropagation();
            setIsLimitWarningPopupOpen(true);
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering')) {
            const exceedsIdeasLimit = !isIdeasCountLoading && !!ideasCount && ideasCount > (0, (0, parcelRequire("gE10J")).IDEAS_COUNT_LIMIT);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $c23f03eba55d136e$var$footerStyles,
                alignInline: "end",
                space: "space.300",
                alignBlock: "start"
            }, ideasCount !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                alignBlock: "start",
                space: "space.050",
                xcss: $c23f03eba55d136e$var$ideasCountWrapperStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $c23f03eba55d136e$var$issuesCountStyles
            }, ideasCount !== undefined && formatMessage((0, (0, parcelRequire("5eNy4")).default).ideasCount), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                weight: "bold"
            }, " ", isIdeasCountLoading ? '' : formatNumber(ideasCount))), exceedsIdeasLimit && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: isLimitWarningPopupOpen,
                onClose: ()=>setIsLimitWarningPopupOpen(false),
                placement: "bottom",
                content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                        xcss: $c23f03eba55d136e$var$limitWarningPopupStyles
                    }, limitWarningMessage),
                trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                        ...triggerProps,
                        onClick: openWarningPopup,
                        xcss: $c23f03eba55d136e$var$ideasCountWarningIconButtonStyles
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                        label: limitWarningMessage,
                        primaryColor: "var(--ds-icon-warning, #E56910)"
                    }))
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                testId: "polaris-component-collection-create.ui.form.footer.button",
                type: exceedsIdeasLimit ? 'button' : 'submit',
                appearance: "primary",
                isLoading: submitting,
                onClick: exceedsIdeasLimit ? openWarningPopup : undefined
            }, formatMessage((0, (0, parcelRequire("5eNy4")).default).createButtonLabel)));
        }
        const exceedsIdeasLimit = !!ideasCount && ideasCount > (0, (0, parcelRequire("gE10J")).IDEAS_COUNT_LIMIT);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8jRgk")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            testId: "polaris-component-collection-create.ui.form.footer.button",
            type: "submit",
            appearance: "primary",
            isLoading: submitting,
            isDisabled: exceedsIdeasLimit
        }, formatMessage((0, (0, parcelRequire("5eNy4")).default).createButtonLabel)));
    };
    const $c23f03eba55d136e$var$footerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.300'
    });
    const $c23f03eba55d136e$var$ideasCountWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: 1
    });
    const $c23f03eba55d136e$var$ideasCountWarningIconButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: 'transparent',
        flexShrink: 0,
        marginTop: 'space.050'
    });
    const $c23f03eba55d136e$var$issuesCountStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.075'
    });
    const $c23f03eba55d136e$var$limitWarningPopupStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.200',
        maxWidth: '410px'
    });
});
parcelRegister("5eNy4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80a485c0ecae9ade$export$2e2bcd8739ae039);
    var $7VHMR;
    var $80a485c0ecae9ade$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createButtonLabel: {
            "id": "polaris-component-collection-create.form.create-button-label",
            "defaultMessage": "Create roadmap"
        },
        ideasCount: {
            "id": "polaris-component-collection-create.form.ideas-count",
            "defaultMessage": "Ideas in roadmap:"
        },
        ideasCountLimitMessage: {
            "id": "polaris-component-collection-create.form.footer.ideas-count-limit-message",
            "defaultMessage": "The roadmap views have a limit of {ideasCountLimit} ideas. To display the views correctly, filter ideas out."
        }
    });
});
parcelRegister("v0rRn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$29f3cce106e8c8c5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $29f3cce106e8c8c5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "polaris-component-collection-create.form.heading",
            "defaultMessage": "Create new roadmap"
        },
        description: {
            "id": "polaris-component-collection-create.form.description",
            "defaultMessage": "Curate your discovery projects ideas in a roadmap."
        },
        roadmapNameFieldLabel: {
            "id": "polaris-component-collection-create.form.roadmap-name-field-label",
            "defaultMessage": "Name your roadmap"
        },
        roadmapNameFieldPlaceholder: {
            "id": "polaris-component-collection-create.form.roadmap-name-field-placeholder",
            "defaultMessage": "Roadmap name"
        },
        projectsSelectFieldLabel: {
            "id": "polaris-component-collection-create.form.projects-select-field-label",
            "defaultMessage": "Select the discovery projects you want to pull ideas from"
        },
        filtersLabel: {
            "id": "polaris-component-collection-create.form.filters-label",
            "defaultMessage": "Filter your roadmap ideas"
        },
        limitExceededError: {
            "id": "polaris-component-collection-create.form.limit-exceeded-error",
            "defaultMessage": "You have <b>{ideasCount, plural, one {# idea} other {# ideas}}</b> in your roadmap."
        },
        limitExceededErrorAction: {
            "id": "polaris-component-collection-create.form.limit-exceeded-error-action",
            "defaultMessage": "Apply filters to have {maxIdeas, plural, one {# idea} other {# ideas}} maximum."
        },
        errorTitle: {
            "id": "polaris-component-collection-create.form.error-title",
            "defaultMessage": "We couldn\u2019t create the roadmap"
        },
        errorDescription: {
            "id": "polaris-component-collection-create.form.error-description",
            "defaultMessage": "Please try again or refresh the page."
        },
        listViewName: {
            "id": "polaris-component-collection-create.form.list-view-name",
            "defaultMessage": "List view"
        },
        timelineViewName: {
            "id": "polaris-component-collection-create.form.timeline-view-name",
            "defaultMessage": "Timeline view"
        },
        boardViewName: {
            "id": "polaris-component-collection-create.form.board-view-name",
            "defaultMessage": "Board view"
        },
        matrixViewName: {
            "id": "polaris-component-collection-create.form.matrix-view-name",
            "defaultMessage": "Matrix view"
        },
        emptyNameError: {
            "id": "polaris-component-collection-create.form.empty-name-error",
            "defaultMessage": "Provide a name for your roadmap."
        },
        emptyProjectsError: {
            "id": "polaris-component-collection-create.form.empty-projects-error",
            "defaultMessage": "Select at least one project."
        },
        nameTooLongError: {
            "id": "polaris-component-collection-create.form.name-too-long-error",
            "defaultMessage": "Roadmap name is too long."
        }
    });
});
parcelRegister("9xjQI", function(module, exports) {
    $parcel$export(module.exports, "ProjectSelect", ()=>$25c99bb80dd0985e$export$a1f52e0b0bd99ab8);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $f5TWP;
    var $d7FF4;
    var $itpgN;
    var $bChGW;
    var $koVbs;
    var $9Xe2s;
    var $ahip4;
    const $25c99bb80dd0985e$export$a1f52e0b0bd99ab8 = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { onChange: onChange, value: value, id: id, isRequired: isRequired, ...restProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), {
            ...restProps,
            cacheOptions: true,
            defaultOptions: true,
            loadOptions: (0, (0, parcelRequire("ahip4")).loadProjectsOptions),
            placeholder: formatMessage((0, (0, parcelRequire("9Xe2s")).default).projectsSelectFieldPlaceholder),
            onChange: (values)=>{
                onChange(values.map((v)=>v.value));
            },
            components: {
                Option: ({ children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("itpgN")).CheckboxOption), rest, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                        paddingInlineStart: "space.100"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                        space: "space.100",
                        alignBlock: "center"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
                        alt: rest.data.label,
                        src: rest.data.imageUrl,
                        className: (0, (0, parcelRequire("bwpsq")).default)([
                            "_1bsbpxbi _4t3ipxbi _2rkogqwt"
                        ])
                    }), children))),
                MultiValueLabel: ({ children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).MultiValueLabel, rest, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                        space: "space.050",
                        alignBlock: "center"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
                        alt: rest.data.label,
                        src: rest.data.imageUrl,
                        className: (0, (0, parcelRequire("bwpsq")).default)([
                            "_1bsbpxbi _4t3ipxbi _2rkogqwt"
                        ])
                    }), children))
            },
            closeMenuOnSelect: false,
            hideSelectedOptions: false,
            isMulti: true
        });
    };
    const $25c99bb80dd0985e$var$projectAvatarStyles = null;
});
parcelRegister("itpgN", function(module, exports) {
    $parcel$export(module.exports, "CheckboxOption", ()=>$f5875245cd0ad0c1$export$d40cc97ecda916f9);
    $parcel$export(module.exports, "RadioOption", ()=>$f5875245cd0ad0c1$export$82ab7168879267a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6aY6N;
    var $iQHJo;
    var $dV6Te;
    var $VSDnB;
    function $f5875245cd0ad0c1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f5875245cd0ad0c1$var$getPrimitiveStyles = (props)=>{
        const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
        const baseStyles = {
            alignItems: 'center',
            backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : 'transparent',
            color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
            display: 'flex ',
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingLeft: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-050, 4px)",
            boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}` : 'none',
            ':active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
            },
            '@media screen and (-ms-high-contrast: active)': {
                borderLeft: isFocused ? '2px solid transparent' : ''
            }
        };
        const augmentedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
            ...getStyles('option', props),
            ...baseStyles
        });
        const bemClasses = {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        };
        return [
            augmentedStyles,
            cx(bemClasses, className)
        ];
    };
    const $f5875245cd0ad0c1$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isActive) return `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
        else if (isFocused) return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
        else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (!isSelected) return 'transparent';
        return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isActive) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused) return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
    };
    const $f5875245cd0ad0c1$var$baseIconStyles = {
        name: "35x0q3",
        styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
    };
    const $f5875245cd0ad0c1$var$baseOptionStyles = {
        name: "16e0ede",
        styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    class $f5875245cd0ad0c1$var$ControlOption extends (0, $5uXOq.Component) {
        render() {
            const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
            const props = {
                ...innerProps,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            const [styles, classes] = $f5875245cd0ad0c1$var$getPrimitiveStyles({
                getStyles: getStyles,
                ...rest
            });
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: styles,
                className: classes,
                ref: innerRef,
                ...props
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $f5875245cd0ad0c1$var$baseIconStyles,
                    {
                        '& svg rect, & svg circle:first-of-type': {
                            stroke: $f5875245cd0ad0c1$var$getBorderColor({
                                ...this.props,
                                ...this.state
                            })
                        }
                    }
                ]
            }, !!Icon ? (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
                label: "",
                primaryColor: $f5875245cd0ad0c1$var$getPrimaryColor({
                    ...this.props,
                    ...this.state
                }),
                secondaryColor: $f5875245cd0ad0c1$var$getSecondaryColor({
                    ...this.props,
                    ...this.state
                }),
                isFacadeDisabled: true
            }) : null), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $f5875245cd0ad0c1$var$baseOptionStyles
            }, children)));
        }
        constructor(...args){
            super(...args), this.state = {
                isActive: false
            }, this.onMouseDown = ()=>this.setState({
                    isActive: true
                }), this.onMouseUp = ()=>this.setState({
                    isActive: false
                }), this.onMouseLeave = ()=>this.setState({
                    isActive: false
                });
        }
    }
    const $f5875245cd0ad0c1$var$NewCheckboxIcon = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), props, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            fill: "currentColor"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        })));
    const $f5875245cd0ad0c1$var$NewRadioIcon = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), props, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "6.75",
            fill: "currentColor",
            strokeWidth: "1.5"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "3",
            fill: "inherit"
        })));
    const $f5875245cd0ad0c1$export$d40cc97ecda916f9 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? $f5875245cd0ad0c1$var$NewCheckboxIcon : (0, ($parcel$interopDefault((0, parcelRequire("6aY6N"))))),
            ...props
        });
    const $f5875245cd0ad0c1$export$82ab7168879267a7 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? $f5875245cd0ad0c1$var$NewRadioIcon : (0, ($parcel$interopDefault((0, parcelRequire("iQHJo"))))),
            ...props
        });
});
parcelRegister("6aY6N", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $47f24d9003b82760$var$_react = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $47f24d9003b82760$var$_checkboxChecked = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("aoKYM")));
    function $47f24d9003b82760$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $47f24d9003b82760$var$CheckboxIcon = (props)=>$47f24d9003b82760$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $47f24d9003b82760$var$_checkboxChecked.default
        }));
    $47f24d9003b82760$var$CheckboxIcon.displayName = 'CheckboxIcon';
    var $47f24d9003b82760$var$_default = module.exports.default = $47f24d9003b82760$var$CheckboxIcon;
});
parcelRegister("aoKYM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $79209663d32c0c44$var$_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $79209663d32c0c44$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>$79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
    var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;
});
parcelRegister("iQHJo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $db8f016a0af5fda9$var$_react = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $db8f016a0af5fda9$var$_radioChecked = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("kqGQn")));
    function $db8f016a0af5fda9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $db8f016a0af5fda9$var$RadioIcon = (props)=>$db8f016a0af5fda9$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
        }, props, {
            newIcon: $db8f016a0af5fda9$var$_radioChecked.default
        }));
    $db8f016a0af5fda9$var$RadioIcon.displayName = 'RadioIcon';
    var $db8f016a0af5fda9$var$_default = module.exports.default = $db8f016a0af5fda9$var$RadioIcon;
});
parcelRegister("kqGQn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $edf7783e719984ba$var$_react = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $edf7783e719984ba$var$_baseNew = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $edf7783e719984ba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $edf7783e719984ba$var$RadioCheckedIcon = (props)=>$edf7783e719984ba$var$_react.default.createElement($edf7783e719984ba$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
        }, props));
    $edf7783e719984ba$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
    var $edf7783e719984ba$var$_default = module.exports.default = $edf7783e719984ba$var$RadioCheckedIcon;
});
parcelRegister("9Xe2s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$024dda0f50435df8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $024dda0f50435df8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectsSelectFieldPlaceholder: {
            "id": "polaris-component-collection-create.form.project-select.projects-select-field-placeholder",
            "defaultMessage": "Select projects"
        }
    });
});
parcelRegister("ahip4", function(module, exports) {
    $parcel$export(module.exports, "loadProjectsOptions", ()=>$fcba6568b7400bba$export$93f98588ddc2c5);
    var $jcw0u;
    var $1As78;
    var $joxHT;
    const $fcba6568b7400bba$export$93f98588ddc2c5 = async (searchQuery)=>(0, (0, parcelRequire("joxHT")).getJpdProjects)(searchQuery).then((projects)=>projects.map((project)=>({
                    id: project.id,
                    label: project.name,
                    imageUrl: project.avatarUrls['16x16'],
                    value: project.key
                }))).catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.error.availableProjectsLoadingFailed', error));
            throw error;
        });
});
parcelRegister("joxHT", function(module, exports) {
    $parcel$export(module.exports, "getJpdProjects", ()=>$17c2776772b8d30c$export$e47ac985e655d4a9);
    var $2vSU6;
    var $7f4tk;
    const $17c2776772b8d30c$export$e47ac985e655d4a9 = async (searchQuery = '')=>{
        const queryParams = new URLSearchParams({
            typeKey: (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT),
            query: searchQuery
        });
        const projects = await (0, (0, parcelRequire("7f4tk")).default)(`/rest/api/3/project/search?${queryParams.toString()}`);
        return projects.values.map(({ id: id, key: key, name: name, avatarUrls: avatarUrls })=>({
                id: id,
                key: key,
                name: name,
                avatarUrls: avatarUrls
            }));
    };
});
parcelRegister("4AjLa", function(module, exports) {
    $parcel$export(module.exports, "useCollectionIdeasCount", ()=>$9fbcca376ebc2df6$export$28cc502c982e0868);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $4R6GH;
    var $dpYV0;
    var $9iiI8;
    const $9fbcca376ebc2df6$var$debouncedGetIdeasCountWithJQL = (0, ($parcel$interopDefault($lFKmC)))((jql, res, rej)=>{
        (0, (0, parcelRequire("9iiI8")).getIdeasCountForCollection)(jql).then(res, rej);
    }, 500);
    const $9fbcca376ebc2df6$export$28cc502c982e0868 = (projectKeys)=>{
        const jql = (0, (0, parcelRequire("dpYV0")).getJQLForCollection)(projectKeys, undefined);
        const [ideasCount, setIdeasCount] = (0, $5uXOq.useState)(undefined);
        const [isLoading, setLoading] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)(null);
        (0, $5uXOq.useEffect)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jpd-aurora-roadmap-advanced-filtering')) {
                if (jql) {
                    setLoading(true);
                    $9fbcca376ebc2df6$var$debouncedGetIdeasCountWithJQL(jql, (newCount)=>{
                        setIdeasCount(newCount);
                        setLoading(false);
                        setError(null);
                    }, (err)=>{
                        setIdeasCount(undefined);
                        setLoading(false);
                        setError(err);
                    });
                } else setIdeasCount(undefined);
            }
        }, [
            jql
        ]);
        return [
            ideasCount,
            isLoading,
            error
        ];
    };
});
parcelRegister("1poXk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0be62508276a2865$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0be62508276a2865$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createRoadmap: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons.create-roadmap",
            "defaultMessage": "Create roadmap"
        }
    });
});
parcelRegister("5Ah0W", function(module, exports) {
    $parcel$export(module.exports, "RoadmapsDefault", ()=>$a8b3f8aa66bb30ce$export$2ebfa8774d2594c8);
    var $5uXOq = parcelRequire("5uXOq");
    var $jecJ3;
    var $jhS4y;
    var $46Cti;
    var $c16H2;
    var $dQbFB;
    var $eQV8d;
    var $dUyqZ;
    var $lnznH;
    var $cZa9B;
    var $8tJaf;
    function $a8b3f8aa66bb30ce$export$2ebfa8774d2594c8(props) {
        const { actionsOnHover: actionsOnHover, isExpanded: isExpanded } = props;
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS);
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        const menuId = (0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c16H2")).Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: menuId,
            onExpansionToggle: (hasExpanded)=>{
                if (hasExpanded) sendSectionItemAnalyticsEvent({
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS,
                    sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_ROADMAPS)
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZa9B")).ExpandableMenuItemTrigger), {
            interactionName: "nav4-sidebar-roadmaps-default",
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            testId: (0, (0, parcelRequire("dQbFB")).getTestId)(menuId)
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnznH")).ExpandableMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8tJaf")).Footer), null)));
    }
});
parcelRegister("8tJaf", function(module, exports) {
    $parcel$export(module.exports, "Footer", ()=>$cb38e1a17d55c084$export$a06f1c675e846f6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $jhS4y;
    var $34PKs;
    var $gSZmd;
    var $1qQhw;
    var $1FdfO;
    var $6ZDS2;
    var $fZq5p;
    const $cb38e1a17d55c084$var$VIEW_ALL_ROADMAPS_HREF = '/jira/polaris/roadmaps';
    const $cb38e1a17d55c084$export$a06f1c675e846f6f = ({ onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6ZDS2")).AnalyticContext));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FdfO")).MenuSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("34PKs")).ViewAllEntityMenuItem), {
            href: $cb38e1a17d55c084$var$VIEW_ALL_ROADMAPS_HREF,
            menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS_VIEW_ALL),
            onClick: (e)=>{
                fireUIAnalyticForFixMenuItem();
                onClose?.(e);
            }
        }, formatMessage((0, (0, parcelRequire("fZq5p")).default).viewAllRoadmaps)))));
    };
});
parcelRegister("fZq5p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e15b7e182815cf6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6e15b7e182815cf6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewAllRoadmaps: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.footer.view-all-roadmaps",
            "defaultMessage": "View all roadmaps"
        }
    });
});
parcelRegister("cq1bX", function(module, exports) {
    $parcel$export(module.exports, "Starred", ()=>$75f7926d6c4a87ae$export$8cd2a0520fb55072);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $l8ruj;
    var $2lF9G;
    var $xP1Je;
    const $75f7926d6c4a87ae$export$8cd2a0520fb55072 = ({ isDefaultOpen: isDefaultOpen = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-starred"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "starred",
            packageName: (0, (0, parcelRequire("2lF9G")).PACKAGE_NAME),
            teamName: (0, (0, parcelRequire("2lF9G")).TEAM_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xP1Je")).StarredFlyoutMenuItem), {
            isDefaultOpen: isDefaultOpen
        })));
});
parcelRegister("2lF9G", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$ebc2aa74f4359e69$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$ebc2aa74f4359e69$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "FAVOURITE_QUERY_LIMIT", ()=>$ebc2aa74f4359e69$export$77881eca52f4f5a6);
    $parcel$export(module.exports, "FAVORITE_TYPE_MAP", ()=>$ebc2aa74f4359e69$export$c2849e00cccc2078);
    $parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MAP", ()=>$ebc2aa74f4359e69$export$531e43cc63c1e036);
    $parcel$export(module.exports, "VALID_FAVORITE_TYPES", ()=>$ebc2aa74f4359e69$export$336e25f77ad481a9);
    $parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MESSAGE", ()=>$ebc2aa74f4359e69$export$de9a288dad6f35f1);
    $parcel$export(module.exports, "SEARCH_STARRED_ITEMS", ()=>$ebc2aa74f4359e69$export$6b181848cd9c8308);
    $parcel$export(module.exports, "FILTER", ()=>$ebc2aa74f4359e69$export$c1c49903035a02df);
    var $hWFET;
    const $ebc2aa74f4359e69$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Starred';
    const $ebc2aa74f4359e69$export$d57b6b390e78d90f = 'jira-cosmos';
    const $ebc2aa74f4359e69$export$77881eca52f4f5a6 = 15;
    const $ebc2aa74f4359e69$export$c2849e00cccc2078 = {
        PROJECT: 'PROJECT',
        FILTER: 'FILTER',
        DASHBOARD: 'DASHBOARD',
        PLAN: 'PLAN',
        BOARD: 'BOARD',
        QUEUE: 'QUEUE'
    };
    const $ebc2aa74f4359e69$export$531e43cc63c1e036 = {
        ...$ebc2aa74f4359e69$export$c2849e00cccc2078,
        ALL: 'ALL'
    };
    const $ebc2aa74f4359e69$export$336e25f77ad481a9 = Object.values($ebc2aa74f4359e69$export$c2849e00cccc2078);
    const $ebc2aa74f4359e69$export$de9a288dad6f35f1 = {
        [$ebc2aa74f4359e69$export$531e43cc63c1e036.PROJECT]: (0, (0, parcelRequire("hWFET")).messages).projects,
        [$ebc2aa74f4359e69$export$531e43cc63c1e036.FILTER]: (0, (0, parcelRequire("hWFET")).messages).filters,
        [$ebc2aa74f4359e69$export$531e43cc63c1e036.DASHBOARD]: (0, (0, parcelRequire("hWFET")).messages).dashboards,
        [$ebc2aa74f4359e69$export$531e43cc63c1e036.PLAN]: (0, (0, parcelRequire("hWFET")).messages).plans,
        [$ebc2aa74f4359e69$export$531e43cc63c1e036.BOARD]: (0, (0, parcelRequire("hWFET")).messages).boards,
        [$ebc2aa74f4359e69$export$531e43cc63c1e036.QUEUE]: (0, (0, parcelRequire("hWFET")).messages).queues,
        [$ebc2aa74f4359e69$export$531e43cc63c1e036.ALL]: (0, (0, parcelRequire("hWFET")).messages).all
    };
    const $ebc2aa74f4359e69$export$6b181848cd9c8308 = 'searchStarredItems';
    const $ebc2aa74f4359e69$export$6634c30fd405ac9 = 'viewAllStarredItems';
    const $ebc2aa74f4359e69$export$c1c49903035a02df = 'filter';
});
parcelRegister("hWFET", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$ef19a8d714970feb$export$defe85febe8b728c);
    var $7VHMR;
    const $ef19a8d714970feb$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projects: {
            "id": "navigation-apps-sidebar-nav4-starred.common.projects",
            "defaultMessage": "Projects"
        },
        filters: {
            "id": "navigation-apps-sidebar-nav4-starred.common.filters",
            "defaultMessage": "Filters"
        },
        dashboards: {
            "id": "navigation-apps-sidebar-nav4-starred.common.dashboards",
            "defaultMessage": "Dashboards"
        },
        plans: {
            "id": "navigation-apps-sidebar-nav4-starred.common.plans",
            "defaultMessage": "Plans"
        },
        boards: {
            "id": "navigation-apps-sidebar-nav4-starred.common.boards",
            "defaultMessage": "Boards"
        },
        queues: {
            "id": "navigation-apps-sidebar-nav4-starred.common.queues",
            "defaultMessage": "Queues"
        },
        all: {
            "id": "navigation-apps-sidebar-nav4-starred.common.all",
            "defaultMessage": "All"
        }
    });
});
parcelRegister("xP1Je", function(module, exports) {
    $parcel$export(module.exports, "StarredFlyoutMenuItem", ()=>$4533cea19a1bfb96$export$b5a36b539503145d);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAf5R;
    var $47gW9;
    var $7XluA;
    var $4mO32;
    var $jecJ3;
    var $iszzG;
    var $46Cti;
    var $338xa;
    var $24a2m;
    var $8zOmE;
    var $2NMNM;
    var $koeKL;
    var $jUDIz;
    var $17aWz;
    var $lBNLs;
    var $2lF9G;
    var $64Fry;
    var $aOVaR;
    function $4533cea19a1bfb96$export$b5a36b539503145d({ isDefaultOpen: isDefaultOpen = false }) {
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iszzG")).NavItemsContext));
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("aOVaR")).sidebarStarredMenuEntryPoint), {
            cloudId: cloudId,
            filter: {
                types: (0, (0, parcelRequire("2lF9G")).VALID_FAVORITE_TYPES),
                sort: {
                    order: 'DESC'
                },
                includeArchivedProjects: false
            },
            count: (0, (0, parcelRequire("2lF9G")).FAVOURITE_QUERY_LIMIT)
        });
        const triggerRef = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(entryPointActions);
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("64Fry")).default).starred, (0, ($parcel$interopDefault((0, parcelRequire("dAf5R"))))));
        const onOpenChangeHandler = async (isOpen)=>{
            if (isDefaultOpen && isOpen) entryPointActions.load();
            if (isOpen) {
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
                });
                const isInMore = moreMenuIds.includes((0, (0, parcelRequire("46Cti")).L1_MENU_ID).STARRED);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_STARRED), {
                    isInMore: isInMore
                });
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jUDIz")).FlyoutMenuItem), {
            isDefaultOpen: isDefaultOpen,
            onOpenChange: onOpenChangeHandler
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lBNLs")).FlyoutMenuItemTrigger), {
            interactionName: "nav4-sidebar-starred",
            ref: triggerRef,
            iconBefore: icon
        }, formattedMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17aWz")).FlyoutMenuItemContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-starred-default",
            packageName: (0, (0, parcelRequire("2lF9G")).PACKAGE_NAME),
            teamName: (0, (0, parcelRequire("2lF9G")).TEAM_NAME),
            errorFallback: "flag",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("338xa")).SkeletonNavMenuItems), null),
            runtimeProps: {}
        })));
    }
});
parcelRegister("64Fry", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d29101a3b8ab7b9b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d29101a3b8ab7b9b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        starred: {
            "id": "navigation-apps-sidebar-nav4-starred.starred",
            "defaultMessage": "Starred"
        }
    });
});
parcelRegister("aOVaR", function(module, exports) {
    $parcel$export(module.exports, "sidebarStarredMenuEntryPoint", ()=>$ee124e0d33917030$export$72aec40208131d);
    var $jFWWh;
    var $eufEc;
    var $fEDBv;
    const $ee124e0d33917030$export$72aec40208131d = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("etRP5")), {
            moduleId: "ab25fe7d"
        }),
        getPreloadProps: ({ cloudId: cloudId, filter: filter, count: count })=>({
                queries: {
                    starredMenuData: {
                        parameters: (0, parcelRequire("jFWWh")).default,
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        variables: {
                            cloudId: cloudId,
                            count: count,
                            filter: filter
                        }
                    }
                }
            })
    });
});
parcelRegister("jFWWh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$346d8a8aa569881a$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    const $346d8a8aa569881a$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "count"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }, v3 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v4 = {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }, v5 = [
            v3,
            v4,
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            }
        ], v6 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "startCursor"
                }
            ]
        }, v7 = [
            v3,
            v4,
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "count"
            }
        ], v8 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v9 = {
            "kind": "ScalarField",
            "name": "id"
        }, v10 = {
            "kind": "ScalarField",
            "name": "name"
        }, v11 = {
            "kind": "InlineFragment",
            "selections": [
                v9
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v12 = {
            "kind": "ScalarField",
            "name": "boardId"
        }, v13 = {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
        }, v14 = [
            v9,
            {
                "kind": "InlineFragment",
                "selections": [
                    v10,
                    {
                        "kind": "ScalarField",
                        "name": "filterUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "filterId"
                    },
                    v13
                ],
                "type": "JiraFilter",
                "abstractKey": "__isJiraFilter"
            }
        ], v15 = {
            "kind": "ScalarField",
            "name": "title"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2
                ],
                "kind": "Fragment",
                "name": "starredMenuQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "allFavourites",
                                    "args": v5,
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v6,
                                            "action": "THROW",
                                            "path": "jira.allFavourites.pageInfo"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "count",
                                "variableName": "count"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "starredMenu_navigationAppsSidebarNav4SidebarsContentStarred"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v2,
                    v1
                ],
                "kind": "Operation",
                "name": "starredMenuQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "allFavourites",
                                "args": v5,
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    v6
                                ]
                            },
                            {
                                "alias": "starredItems",
                                "args": v7,
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v8,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v9,
                                                            v10,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "key"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "projectType"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "webUrl"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "projectId"
                                                            },
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "defaultNavigationItem",
                                                                "plural": false,
                                                                "selections": [
                                                                    v8,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "typeKey"
                                                                            }
                                                                        ],
                                                                        "type": "JiraNavigationItem",
                                                                        "abstractKey": "__isJiraNavigationItem"
                                                                    },
                                                                    v11
                                                                ]
                                                            },
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "navigationMetadata",
                                                                "plural": false,
                                                                "selections": [
                                                                    v8,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v12,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "isSimpleBoard"
                                                                            },
                                                                            v9
                                                                        ],
                                                                        "type": "JiraSoftwareProjectNavigationMetadata"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "large"
                                                                    }
                                                                ]
                                                            },
                                                            v13
                                                        ],
                                                        "type": "JiraProject"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": v14,
                                                        "type": "JiraSystemFilter"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": v14,
                                                        "type": "JiraCustomFilter"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v9,
                                                            v15,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "dashboardUrl"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "dashboardId"
                                                            },
                                                            v13
                                                        ],
                                                        "type": "JiraDashboard"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v9,
                                                            v15,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "planUrl"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "planId"
                                                            },
                                                            v13
                                                        ],
                                                        "type": "JiraPlan"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v9,
                                                            {
                                                                "alias": "title",
                                                                "kind": "ScalarField",
                                                                "name": "name"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "boardUrl"
                                                            },
                                                            v12,
                                                            v13
                                                        ],
                                                        "type": "JiraBoard"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v9,
                                                            v15,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "queueUrl"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "queueId"
                                                            },
                                                            v13
                                                        ],
                                                        "type": "JiraServiceManagementQueue"
                                                    },
                                                    v11
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "alias": "starredItems",
                                "args": v7,
                                "filters": [
                                    "cloudId",
                                    "filter"
                                ],
                                "handle": "connection",
                                "key": "StarredMenuListContent_starredItems",
                                "kind": "LinkedHandle",
                                "name": "favourites"
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "cbff3b2f4a0d23e32bcd28cc3036e99f400d17a6c35fac79336e3078ad42f762",
                "metadata": {},
                "name": "starredMenuQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $346d8a8aa569881a$var$node.hash = "a986e516464a8c05df425dc6bf3d574d";
    (0, $eiowN.PreloadableQueryRegistry).set($346d8a8aa569881a$var$node.params.id, $346d8a8aa569881a$var$node);
    var $346d8a8aa569881a$export$2e2bcd8739ae039 = $346d8a8aa569881a$var$node;
});
parcelRegister("etRP5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("bbPMV")
    ]).then(()=>parcelRequire('1K2XC'));
});
parcelRegister("96poX", function(module, exports) {
    $parcel$export(module.exports, "Teams", ()=>$b8d06ffc4011b778$export$b3a34d915d8dd11e);
    var $5uXOq = parcelRequire("5uXOq");
    var $fElvF;
    var $7CMCs;
    var $l8ruj;
    var $9SHwc;
    const $b8d06ffc4011b778$export$b3a34d915d8dd11e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4-sidebar-teams"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "teams",
            packageName: (0, $2cdcf2b7084757bc$export$b8b9d90f9e5bd72b),
            teamName: (0, $2cdcf2b7084757bc$export$d57b6b390e78d90f)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fElvF")).InvitePeopleModalContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9SHwc")).TeamsMenu), null))));
});
const $2cdcf2b7084757bc$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Teams';
const $2cdcf2b7084757bc$export$d57b6b390e78d90f = 'People and Teams Collective';
const $2cdcf2b7084757bc$export$f17fc93a893ec45c = 'add';
const $2cdcf2b7084757bc$export$6ee8a54637c51e7d = 'createATeam';
const $2cdcf2b7084757bc$export$b3dcfa0224e0289c = 'invitePeople';
const $2cdcf2b7084757bc$export$f06dfcec5ff912e = 'meatballDropdown';
const $2cdcf2b7084757bc$export$1245c8aac7dab260 = '/jira/people/search';
parcelRegister("9SHwc", function(module, exports) {
    $parcel$export(module.exports, "TeamsMenu", ()=>$00a1aa44690d74d1$export$deb84fb5c6bff4b0);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $dIWbq;
    var $kJpBP;
    var $eZUJu;
    var $1I7E8;
    var $luBm6;
    var $8CUq3;
    var $koVbs;
    var $jecJ3;
    var $ivGSs;
    var $jhS4y;
    var $46Cti;
    var $eQV8d;
    var $dUyqZ;
    var $eaKdt;
    var $aCS3f;
    var $8zOmE;
    var $2NMNM;
    var $eMAVw;
    var $doZTA;
    var $eXCTi;
    var $eA0nk;
    var $fxSv8;
    function $00a1aa44690d74d1$export$deb84fb5c6bff4b0() {
        const [isOpenTeamsPopup, openTeamsPopup] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)((0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS);
        const [{ location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const path = location.pathname + location.search;
        const isSelected = path === (0, $2cdcf2b7084757bc$export$1245c8aac7dab260);
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const actionSubjectId = (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[0, (0, parcelRequire("jhS4y")).MENU_ID_TEAMS];
        const label = formatMessage((0, (0, parcelRequire("eXCTi")).default).addButton);
        const [createTeamModal, createTeamModalTrigger] = (0, (0, parcelRequire("eA0nk")).useCreateTeamModal)();
        const invitePeopleModalTrigger = (0, (0, parcelRequire("fxSv8")).useInvitePeopleModal)();
        const onLinkClick = ()=>{
            sendSectionItemAnalyticsEvent({
                menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS,
                sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_TEAMS)
            });
        };
        const onPlusButtonClick = ()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: actionSubjectId,
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    parentItemId: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_TEAMS),
                    itemId: (0, $2cdcf2b7084757bc$export$f17fc93a893ec45c)
                }
            });
            openTeamsPopup(true);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, createTeamModal, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMAVw")).MenuLinkItem), {
            testId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.sidenav-teams",
            href: (0, $2cdcf2b7084757bc$export$1245c8aac7dab260),
            isSelected: isSelected,
            elemBefore: icon,
            onClick: onLinkClick,
            actionsOnHover: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                shouldRenderToParent: true,
                placement: "bottom-start",
                onClose: ()=>openTeamsPopup(false),
                trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                        ...triggerProps,
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("dIWbq"))))),
                        appearance: "subtle",
                        spacing: "compact",
                        testId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.sidenav-teams-popup-trigger",
                        isSelected: isOpenTeamsPopup,
                        label: label,
                        tooltip: {
                            content: label
                        },
                        isTooltipDisabled: false,
                        onClick: onPlusButtonClick
                    }),
                isOpen: isOpenTeamsPopup,
                content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                        xcss: $00a1aa44690d74d1$var$teamsMenuStyle
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                        onClick: ()=>{
                            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                                action: 'clicked',
                                actionSubject: 'dropdownItem',
                                actionSubjectId: actionSubjectId,
                                attributes: {
                                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                                    componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                                    parentItemId: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_TEAMS),
                                    itemId: (0, $2cdcf2b7084757bc$export$b3dcfa0224e0289c)
                                }
                            });
                            invitePeopleModalTrigger();
                            openTeamsPopup(false);
                        }
                    }, formatMessage((0, (0, parcelRequire("eXCTi")).default).invitePeople)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                        onClick: ()=>{
                            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                                action: 'clicked',
                                actionSubject: 'dropdownItem',
                                actionSubjectId: actionSubjectId,
                                attributes: {
                                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                                    componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                                    parentItemId: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_TEAMS),
                                    itemId: (0, $2cdcf2b7084757bc$export$6ee8a54637c51e7d)
                                }
                            });
                            createTeamModalTrigger();
                            openTeamsPopup(false);
                        }
                    }, formatMessage((0, (0, parcelRequire("eXCTi")).default).createTeam)))
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
                onOpen: ()=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                        action: 'clicked',
                        actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6),
                        actionSubjectId: actionSubjectId,
                        attributes: {
                            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                            componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                            itemId: (0, $2cdcf2b7084757bc$export$f06dfcec5ff912e)
                        }
                    });
                },
                MenuItems: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaKdt")).HideL1MenuItemSection), {
                        menuId: (0, (0, parcelRequire("jhS4y")).MENU_ID_TEAMS),
                        hasSeparator: false
                    }))
            }))
        }, formattedMessage));
    }
    const $00a1aa44690d74d1$var$teamsMenuStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '260px',
        paddingBlock: 'space.100'
    });
});
parcelRegister("eXCTi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93106a52315d7964$export$2e2bcd8739ae039);
    var $7VHMR;
    var $93106a52315d7964$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addButton: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.add-button",
            "defaultMessage": "Create or invite"
        },
        createTeam: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.create-team",
            "defaultMessage": "Create a team"
        },
        invitePeople: {
            "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.invite-people",
            "defaultMessage": "Invite people"
        }
    });
});
parcelRegister("eA0nk", function(module, exports) {
    $parcel$export(module.exports, "useCreateTeamModal", ()=>$7ef2ce65db55ab3d$export$5458b68a653f4bfe);
    var $5uXOq = parcelRequire("5uXOq");
    var $euiLX;
    var $pa9q9;
    var $1wpPp;
    var $4ywcn;
    var $8igKv;
    var $koVbs;
    var $lfTZh;
    var $cYlk7;
    var $14XJw;
    var $90yGq;
    var $koeKL;
    var $0Wtmq;
    var $kxZPA;
    var $lVJAU;
    const $7ef2ce65db55ab3d$var$LazyTeamCreateDialog = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("gtwZw")).then(({ TeamCreateDialog: TeamCreateDialog })=>TeamCreateDialog), {
        moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
    });
    const $7ef2ce65db55ab3d$export$5458b68a653f4bfe = ()=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { data: { user: user } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const atlassianAccountId = (0, (0, parcelRequire("90yGq")).useAccountId)() || user.accountId;
        const pushRoute = (0, $5uXOq.useCallback)((url)=>push(url), [
            push
        ]);
        const addFlag = (0, $5uXOq.useCallback)(({ appearance: appearance, ...flagProps })=>{
            const Flag = $7ef2ce65db55ab3d$var$getFlagComponent(appearance);
            showFlag((serviceProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Flag, {
                    ...flagProps,
                    ...serviceProps
                }));
        }, [
            showFlag
        ]);
        const callback = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(true);
        }, []);
        if (!atlassianAccountId) throw new Error('Missing current user id');
        return [
            isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: "team-create-dialog"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("0Wtmq")).PeopleAndTeamsConfigurationProvider), {
                product: "jira",
                locale: (0, (0, parcelRequire("euiLX")).default)(locale)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($7ef2ce65db55ab3d$var$LazyTeamCreateDialog, {
                pushRoute: pushRoute,
                cloudId: cloudId,
                orgId: orgId,
                product: "jira",
                principalId: atlassianAccountId,
                onClose: ()=>setIsOpen(false),
                enableMembershipSettingsChoice: true,
                currentUser: user.accountId ? {
                    id: user.accountId,
                    fullName: user.userFullname,
                    email: user.emailAddress !== undefined ? user.emailAddress : '',
                    avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                    nickname: user.userFullname
                } : undefined,
                addFlag: addFlag
            }))) : null,
            callback
        ];
    };
    const $7ef2ce65db55ab3d$var$getFlagComponent = (appearance)=>{
        switch(appearance){
            case 'warning':
                return 0, (0, parcelRequire("8igKv")).default;
            case 'error':
                return 0, (0, parcelRequire("1wpPp")).default;
            case 'success':
            case 'normal':
            default:
                return 0, (0, parcelRequire("4ywcn")).default;
        }
    };
});
parcelRegister("fxSv8", function(module, exports) {
    $parcel$export(module.exports, "useInvitePeopleModal", ()=>$bef8b2441fc0fca4$export$b9ec44715ae5ad99);
    var $5uXOq = parcelRequire("5uXOq");
    var $2JsdQ;
    var $pa9q9;
    var $1wpPp;
    var $4ywcn;
    var $8igKv;
    var $eIokK;
    var $1J3t1;
    var $14XJw;
    var $k9JTq;
    var $koeKL;
    const $bef8b2441fc0fca4$export$b9ec44715ae5ad99 = ()=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { data: projectSidebarNavigationData } = (0, (0, parcelRequire("1J3t1")).useProjectSidebarNavigation)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { software: software } = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const continueUrl = window.location.href;
        const subProduct = (0, (0, parcelRequire("eIokK")).projectTypeToSubProduct)(projectSidebarNavigationData?.projectType);
        const addFlag = (0, $5uXOq.useCallback)(({ appearance: appearance, ...flagProps })=>{
            const Flag = $bef8b2441fc0fca4$var$getFlagComponent(appearance);
            showFlag((serviceProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Flag, {
                    ...flagProps,
                    ...serviceProps
                }));
        }, [
            showFlag
        ]);
        const { openModal: invitePeopleModalTrigger } = (0, (0, parcelRequire("2JsdQ")).useInvitePeopleModal)({
            continueUrl: continueUrl,
            enableThirdParty: true,
            displayInfiSpotlight: true,
            orgId: orgId,
            resourceAri: `ari:cloud:jira::site/${cloudId}`,
            showFlag: addFlag,
            source: 'peopleMenu',
            subProduct: subProduct,
            experimental_applicationEdition: software,
            navigation: {
                directoryContextEntryPoint: '/jira'
            },
            onSubmit: async (data)=>{
                await data.defaultOnSubmit();
            }
        });
        return invitePeopleModalTrigger;
    };
    const $bef8b2441fc0fca4$var$getFlagComponent = (appearance)=>{
        switch(appearance){
            case 'warning':
                return 0, (0, parcelRequire("8igKv")).default;
            case 'error':
                return 0, (0, parcelRequire("1wpPp")).default;
            case 'success':
            case 'normal':
            default:
                return 0, (0, parcelRequire("4ywcn")).default;
        }
    };
});
parcelRegister("eIokK", function(module, exports) {
    $parcel$export(module.exports, "stripUrlToIssueKey", ()=>$2ca77bef45d99b5b$export$1f3c6284caef177b);
    $parcel$export(module.exports, "useInvitePeopleFlags", ()=>$2ca77bef45d99b5b$export$ab5fb7206b83c9ad);
    $parcel$export(module.exports, "projectTypeToSubProduct", ()=>$2ca77bef45d99b5b$export$3500077858760067);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $1wpPp;
    var $g9eN3;
    var $4ywcn;
    var $8igKv;
    const $2ca77bef45d99b5b$var$ISSUE_KEY_REGEXP = /(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
    const $2ca77bef45d99b5b$export$1f3c6284caef177b = (candidateUrl)=>{
        const match = candidateUrl.match($2ca77bef45d99b5b$var$ISSUE_KEY_REGEXP);
        return match && match[1];
    };
    const $2ca77bef45d99b5b$export$ab5fb7206b83c9ad = ()=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const addFlag = (0, $5uXOq.useCallback)(({ appearance: appearance, ...flagProps })=>{
            let FlagComponent = (0, (0, parcelRequire("g9eN3")).default);
            switch(appearance){
                case 'success':
                case 'normal':
                    FlagComponent = (0, (0, parcelRequire("4ywcn")).default);
                    break;
                case 'warning':
                    FlagComponent = (0, (0, parcelRequire("8igKv")).default);
                    break;
                case 'error':
                    FlagComponent = (0, (0, parcelRequire("1wpPp")).default);
                    break;
            }
            showFlag((serviceProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement(FlagComponent, {
                    ...flagProps,
                    ...serviceProps
                }));
        }, [
            showFlag
        ]);
        return {
            addFlag: addFlag
        };
    };
    const $2ca77bef45d99b5b$export$3500077858760067 = (projectType)=>{
        switch(projectType){
            case 'jira_software':
                return 'software';
            case 'jira_service_management':
                return 'servicedesk';
            case 'jira_work_management':
                return 'core';
            case 'jira_product_discovery':
                return 'product-discovery';
            default:
                return undefined;
        }
    };
});
parcelRegister("g9eN3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$100aabc6f0d895d9$export$2e2bcd8739ae039);
    var $3KRpp;
    var $100aabc6f0d895d9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).InfoFlag);
});
parcelRegister("3cFRo", function(module, exports) {
    $parcel$export(module.exports, "Stub", ()=>$39abac17a0bf23b3$export$1ab0b9ce3cf276f8);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZUJu;
    var $jecJ3;
    var $ivGSs;
    var $46Cti;
    var $eQV8d;
    var $dUyqZ;
    var $eaKdt;
    var $aCS3f;
    var $8zOmE;
    var $2NMNM;
    var $eMAVw;
    var $doZTA;
    const $39abac17a0bf23b3$export$1ab0b9ce3cf276f8 = ({ menuId: menuId, href: href })=>{
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)(menuId);
        const [{ location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const path = location.pathname + location.search;
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMAVw")).MenuLinkItem), {
            elemBefore: icon,
            href: href,
            isSelected: path === href,
            actionsOnHover: (0, ($parcel$interopDefault($5uXOq))).createElement($39abac17a0bf23b3$var$ActionButtons, {
                menuId: menuId
            }),
            onClick: ()=>{
                if (menuId === (0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS) sendSectionItemAnalyticsEvent({
                    menuId: (0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS,
                    sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_TEAMS)
                });
            }
        }, formattedMessage);
    };
    function $39abac17a0bf23b3$var$ActionButtons({ menuId: menuId }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCS3f")).MoreNavMenuButton), {
            onOpen: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6),
                    actionSubjectId: (0, (0, parcelRequire("ivGSs")).MENU_ID_ANALYTIC_EVENT_IDS)[menuId],
                    attributes: {
                        level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                        componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                        itemId: (0, $ddbe4b334e21c7a1$export$f06dfcec5ff912e)
                    }
                });
            },
            MenuItems: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaKdt")).HideL1MenuItemSection), {
                    menuId: menuId,
                    hasSeparator: false
                }))
        });
    }
});
parcelRegister("cam2y", function(module, exports) {
    $parcel$export(module.exports, "useFilterL1MenuItemsByEditionAndLicense", ()=>$7076df34d12ead42$export$bf04108d78a3abbe);
    var $5uXOq = parcelRequire("5uXOq");
    var $8J6rn;
    var $4R6GH;
    var $46Cti;
    var $jYFkU;
    var $iKHgp;
    var $h9iZl;
    var $dWQF5;
    const $7076df34d12ead42$export$bf04108d78a3abbe = (navItems)=>{
        const showAssets = (0, (0, parcelRequire("jYFkU")).useShowAssets)();
        const { shouldUseJSM: shouldUseJSM } = (0, (0, parcelRequire("8J6rn")).useOgTenantInfo)();
        const shouldShowRoadmaps = (0, (0, parcelRequire("dWQF5")).useIsCrossProjectViewsEnabled)();
        const shouldRenderOverviews = (0, (0, parcelRequire("iKHgp")).useShouldRenderOverviews)();
        const [shouldRenderPlans] = (0, (0, parcelRequire("h9iZl")).useNavigationPlansVisibility)();
        return (0, $5uXOq.useMemo)(()=>navItems.filter(({ menuId: menuId })=>{
                if (menuId === (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OPERATIONS) return shouldUseJSM;
                if (menuId === (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS) return showAssets;
                if (menuId === (0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS) return shouldShowRoadmaps && (0, (0, parcelRequire("4R6GH")).fg)('polaris-new-nav-entry-roadmaps');
                if (menuId === (0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS) return (0, (0, parcelRequire("4R6GH")).fg)('blu-2858-sidebar-menu-overviews') && shouldRenderOverviews;
                if (menuId === (0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS) return shouldRenderPlans;
                if (menuId === (0, (0, parcelRequire("46Cti")).L1_MENU_ID).GOALS) return false;
                if (menuId === (0, (0, parcelRequire("46Cti")).L1_MENU_ID).CUSTOMER_SERVICE) return (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag');
                return true;
            }), [
            shouldShowRoadmaps,
            navItems,
            shouldUseJSM,
            showAssets,
            shouldRenderOverviews,
            shouldRenderPlans
        ]);
    };
});
parcelRegister("jYFkU", function(module, exports) {
    $parcel$export(module.exports, "useShowAssets", ()=>$e8ba161523dca261$export$6d1797fe1bb33b7a);
    var $ktP1V;
    var $9OXo1;
    function $e8ba161523dca261$export$6d1797fe1bb33b7a() {
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { appPermissions: appPermissions } = tenantContext;
        const isJSMUser = appPermissions.hasServiceDeskAccess;
        if ((0, (0, parcelRequire("ktP1V")).isCMDBEnabledInEnvironment)() && isJSMUser) return true;
        return false;
    }
});
parcelRegister("jM4TX", function(module, exports) {
    $parcel$export(module.exports, "useRefreshL1MenuItems", ()=>$c458e653f6eae5e5$export$6f30ce19c2e3e4c0);
    var $5uXOq = parcelRequire("5uXOq");
    var $k8IPx = parcelRequire("k8IPx");
    var $4R6GH;
    var $1zjdl;
    const $c458e653f6eae5e5$export$6f30ce19c2e3e4c0 = (navItems = [])=>(0, $5uXOq.useMemo)(()=>{
            const missingMenuIds = (0, ($parcel$interopDefault($k8IPx)))((0, (0, parcelRequire("1zjdl")).USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS), navItems.map(({ menuId: menuId })=>menuId));
            const isVisible = (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? true : !navItems.length;
            return [
                ...navItems,
                ...missingMenuIds.map((menuId)=>({
                        menuId: menuId,
                        isVisible: isVisible
                    }))
            ];
        }, [
            navItems
        ]);
});
parcelRegister("cscSc", function(module, exports) {
    $parcel$export(module.exports, "CustomiseSidebar", ()=>$7234c1f5a7f27917$export$8ef5220def5f00e1);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2KAtx;
    var $8Dpzr;
    var $5xBN5;
    var $dKXJF;
    var $jvPG3;
    function $7234c1f5a7f27917$export$8ef5220def5f00e1({ navItems: navItems }) {
        const { setMoreMenuIsOpen: setMoreMenuIsOpen } = (0, $5uXOq.useContext)((0, (0, parcelRequire("5xBN5")).MoreMenuIsOpenContext));
        const onClose = (0, $5uXOq.useCallback)(()=>{
            setMoreMenuIsOpen(false);
        }, [
            setMoreMenuIsOpen
        ]);
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                navItems: navItems,
                onClose: onClose
            }), [
            navItems,
            onClose
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const modalProps = (0, $5uXOq.useMemo)(()=>({
                width: 400,
                height: 440
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KAtx")).ModalEntryPointPressableTrigger), {
            entryPoint: (0, (0, parcelRequire("8Dpzr")).CustomisableSidebarModalEntrypoint),
            entryPointProps: entryPointParams,
            title: formatMessage((0, (0, parcelRequire("dKXJF")).default).header),
            modalProps: modalProps,
            useInternalModal: false
        }, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jvPG3")).CustomiseSidebarTrigger), {
                ref: ref
            }));
    }
});
parcelRegister("8Dpzr", function(module, exports) {
    $parcel$export(module.exports, "CustomisableSidebarModalEntrypoint", ()=>$3ac09ae106e0999d$export$420f0b14c9bb574e);
    var $eufEc;
    var $fEDBv;
    const $3ac09ae106e0999d$export$420f0b14c9bb574e = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("5josM")).then(({ CustomisableSidebarModal: CustomisableSidebarModal })=>CustomisableSidebarModal), {
            moduleId: "5506b7c0"
        }),
        getPreloadProps: (props)=>({
                queries: {},
                props: props
            })
    });
});
parcelRegister("5josM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aHD9Z").then(()=>parcelRequire('537Fw'));
});
parcelRegister("5xBN5", function(module, exports) {
    $parcel$export(module.exports, "MoreMenuIsOpenContext", ()=>$5118c303d0e915f1$export$8888ac4b19e27f70);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    const $5118c303d0e915f1$export$8888ac4b19e27f70 = (0, $5uXOq.createContext)({
        moreMenuIsOpen: false,
        setMoreMenuIsOpen: (0, ($parcel$interopDefault($8Rkzz)))
    });
});
parcelRegister("dKXJF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1cefac76ecdf582$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a1cefac76ecdf582$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        header: {
            "id": "navigation-apps-sidebar-nav4-customise-sidebar.header",
            "defaultMessage": "Customize sidebar"
        },
        reorder: {
            "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu.customise-sidebar.reorder",
            "defaultMessage": "Reorder {itemLabel}"
        },
        separator: {
            "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu.customise-sidebar.separator",
            "defaultMessage": "Separator"
        }
    });
});
parcelRegister("jvPG3", function(module, exports) {
    $parcel$export(module.exports, "CustomiseSidebarTrigger", ()=>$346f128683b8c378$export$923dc28f372c1f3f);
    var $5uXOq = parcelRequire("5uXOq");
    var $4QAwn;
    var $jecJ3;
    var $24a2m;
    var $eQV8d;
    var $d0QZE;
    var $8d31d;
    const $346f128683b8c378$export$923dc28f372c1f3f = (0, $5uXOq.forwardRef)(({ onClick: onClick }, ref)=>{
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("8d31d")).default).customiseSidebar, (0, ($parcel$interopDefault((0, parcelRequire("4QAwn"))))));
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        const onClickHandler = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            sendSectionItemAnalyticsEvent({
                sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_CUSTOMIZE_SIDEBAR)
            });
            onClick?.(event, analyticsEvent);
        }, [
            onClick,
            sendSectionItemAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d0QZE")).MenuButtonItem), {
            interactionName: "nav4-sidebar-customise-modal",
            elemBefore: icon,
            onClick: onClickHandler,
            ref: ref
        }, formattedMessage);
    });
});
parcelRegister("4QAwn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3878591d802e976a$var$_react = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3878591d802e976a$var$_baseNew = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3878591d802e976a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3878591d802e976a$var$CustomizeIcon = (props)=>$3878591d802e976a$var$_react.default.createElement($3878591d802e976a$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.25 11.5V9.375a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625v4.25c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625zm0 0H16m-16 0h7.5m-3.75-7v2.125c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625v-4.25a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625zm0 0H0m16 0H8.5"/>`
        }, props));
    $3878591d802e976a$var$CustomizeIcon.displayName = 'CustomizeIcon';
    var $3878591d802e976a$var$_default = module.exports.default = $3878591d802e976a$var$CustomizeIcon;
});
parcelRegister("d0QZE", function(module, exports) {
    $parcel$export(module.exports, "MenuButtonItem", ()=>$9326b3e0a851d4a3$export$35e89d121b5de79a);
    var $5uXOq = parcelRequire("5uXOq");
    var $fdP8o;
    var $1qQhw;
    const $9326b3e0a851d4a3$export$35e89d121b5de79a = (0, $5uXOq.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled }, forwardedRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qQhw")).MenuListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fdP8o")).MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            actionsOnHover: actionsOnHover,
            onClick: onClick,
            ref: forwardedRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled
        }, children)));
});
parcelRegister("8d31d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$215517791c29e77e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $215517791c29e77e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        customiseSidebar: {
            "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu.customise-sidebar.trigger.customise-sidebar",
            "defaultMessage": "Customize sidebar"
        }
    });
});
parcelRegister("i98eP", function(module, exports) {
    $parcel$export(module.exports, "MoreMenuIsOpenContextProvider", ()=>$b1de343b331e2d66$export$d11e004ed91611ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $5xBN5;
    const $b1de343b331e2d66$export$d11e004ed91611ce = ({ children: children })=>{
        const [moreMenuIsOpen, setMoreMenuIsOpen] = (0, $5uXOq.useState)(false);
        const moreMenuIsOpenContext = (0, $5uXOq.useMemo)(()=>({
                moreMenuIsOpen: moreMenuIsOpen,
                setMoreMenuIsOpen: setMoreMenuIsOpen
            }), [
            moreMenuIsOpen
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5xBN5")).MoreMenuIsOpenContext).Provider, {
            value: moreMenuIsOpenContext
        }, children);
    };
});
parcelRegister("avJY5", function(module, exports) {
    $parcel$export(module.exports, "MoreMenuItem", ()=>$ebf97128d3d3feab$export$e967513bbeba0537);
    var $5uXOq = parcelRequire("5uXOq");
    var $jecJ3;
    var $iszzG;
    var $eQV8d;
    var $bdN0K;
    var $5xBN5;
    var $jBFJA;
    var $9bWqW;
    function $ebf97128d3d3feab$export$e967513bbeba0537({ customiseSidebar: customiseSidebar, menuData: menuData }) {
        const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iszzG")).NavItemsContext));
        const { peekMenuId: peekMenuId, setPeekMenuId: setPeekMenuId } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iszzG")).PeekMenuIdContext));
        const { moreMenuIsOpen: moreMenuIsOpen, setMoreMenuIsOpen: setMoreMenuIsOpen } = (0, $5uXOq.useContext)((0, (0, parcelRequire("5xBN5")).MoreMenuIsOpenContext));
        const sendSectionItemAnalyticsEvent = (0, (0, parcelRequire("eQV8d")).useSectionItemAnalytics)();
        const handleMenuClose = (0, $5uXOq.useCallback)(()=>setMoreMenuIsOpen(false), [
            setMoreMenuIsOpen
        ]);
        const handleMenuToggle = (0, $5uXOq.useCallback)(()=>{
            setMoreMenuIsOpen((value)=>!value);
            sendSectionItemAnalyticsEvent({
                sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_MORE)
            });
        }, [
            sendSectionItemAnalyticsEvent,
            setMoreMenuIsOpen
        ]);
        const MenuItems = [
            ({ onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, moreMenuIds.filter((menuId)=>menuId !== peekMenuId).map((menuId)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jBFJA")).MenuItem), {
                        key: menuId,
                        menuId: menuId,
                        onClick: (e)=>{
                            setPeekMenuId(menuId);
                            onClose?.(e);
                            sendSectionItemAnalyticsEvent({
                                menuId: menuId,
                                sectionItem: (0, (0, parcelRequire("jecJ3")).SECTION_ITEM_MAP)[menuId]
                            });
                        }
                    }))),
            ()=>customiseSidebar
        ];
        return moreMenuIds.length === 0 ? customiseSidebar : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9bWqW")).PeekMenuItem), {
            menuData: menuData
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bdN0K")).L1MoreNavMenuItem), {
            MenuItems: MenuItems,
            isOpen: moreMenuIsOpen,
            onClose: handleMenuClose,
            onToggle: handleMenuToggle
        }));
    }
});
parcelRegister("bdN0K", function(module, exports) {
    $parcel$export(module.exports, "L1MoreNavMenuItem", ()=>$37dcbc182b0ae871$export$4c0f8320eb6cf210);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $54SNu;
    const $37dcbc182b0ae871$var$L1MoreNavMenuItemSubmenu = ({ MenuItems: MenuItems, onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $37dcbc182b0ae871$var$menuGroupWrapperStyles
        }, MenuItems.map((GroupedMenuItems, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                key: index,
                as: "ul",
                xcss: [
                    $37dcbc182b0ae871$var$menuSectionStyles,
                    index > 0 && $37dcbc182b0ae871$var$menuSectionDividerStyles
                ]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(GroupedMenuItems, {
                onClose: onClose
            }))));
    const $37dcbc182b0ae871$export$4c0f8320eb6cf210 = (props)=>{
        const { MenuItems: MenuItems, isOpen: isOpen, onClose: onClose, onToggle: onToggle } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("54SNu")).MoreNavMenuItem), {
            MenuItems: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($37dcbc182b0ae871$var$L1MoreNavMenuItemSubmenu, {
                    MenuItems: MenuItems,
                    onClose: onClose
                }),
            isOpen: isOpen,
            onToggle: onToggle,
            onClose: onClose
        });
    };
    const $37dcbc182b0ae871$var$menuGroupWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.050',
        paddingInline: 'space.050'
    });
    const $37dcbc182b0ae871$var$menuSectionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.0',
        paddingBottom: 'space.050'
    });
    const $37dcbc182b0ae871$var$menuSectionDividerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
        paddingTop: 'space.050',
        marginTop: 'space.0'
    });
});
parcelRegister("54SNu", function(module, exports) {
    $parcel$export(module.exports, "MoreNavMenuItem", ()=>$6cf41ab7bb0f4a0b$export$69b3a144536c53ed);
    var $5uXOq = parcelRequire("5uXOq");
    var $iUFLC;
    var $dC5iT;
    var $8CUq3;
    var $d0QZE;
    var $7vqau;
    const $6cf41ab7bb0f4a0b$export$69b3a144536c53ed = ({ isOpen: isOpen, onClose: onClose, onToggle: onToggle, MenuItems: MenuItems })=>{
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("7vqau")).useMoreFormattedMessageAndIcon)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iUFLC")).Popup), {
            isOpen: isOpen
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iUFLC")).PopupTrigger), null, (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d0QZE")).MenuButtonItem), {
                ...triggerProps,
                elemBefore: icon,
                onClick: onToggle
            }, formattedMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6cf41ab7bb0f4a0b$var$popupContentContainerStyles,
            role: "listitem"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iUFLC")).PopupContent), {
            shouldFitContainer: true,
            placement: "bottom-start",
            offset: [
                -4,
                4
            ],
            onClose: onClose,
            shouldRenderToParent: true,
            strategy: "absolute"
        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuItems, {
                onClose: onClose
            }))));
    };
    const $6cf41ab7bb0f4a0b$var$popupContentContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        marginInline: 'space.negative.050'
    });
});
parcelRegister("7vqau", function(module, exports) {
    $parcel$export(module.exports, "useMoreFormattedMessageAndIcon", ()=>$e4dffbd6e272b91b$export$cb3aaead45d9e574);
    var $8U6zd;
    var $24a2m;
    var $lkmKZ;
    const $e4dffbd6e272b91b$export$cb3aaead45d9e574 = ()=>(0, (0, parcelRequire("24a2m")).useFormattedMessageAndIcon)((0, (0, parcelRequire("lkmKZ")).default).more, (0, ($parcel$interopDefault((0, parcelRequire("8U6zd"))))));
});
parcelRegister("lkmKZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50a2a914e860682e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $50a2a914e860682e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        more: {
            "id": "navigation-apps-sidebar-nav4-common.common.more-nav-menu-item.more",
            "defaultMessage": "More"
        }
    });
});
parcelRegister("jBFJA", function(module, exports) {
    $parcel$export(module.exports, "MenuItem", ()=>$9c4a4187daf4ec53$export$2ce376c2cc3355c8);
    var $5uXOq = parcelRequire("5uXOq");
    var $dUyqZ;
    var $d0QZE;
    var $eMAVw;
    var $1zjdl;
    const $9c4a4187daf4ec53$export$2ce376c2cc3355c8 = ({ menuId: menuId, ...props })=>{
        const { formattedMessage: formattedMessage, icon: icon } = (0, (0, parcelRequire("dUyqZ")).useConfigurableMessageAndIconMap)(menuId);
        const url = (0, (0, parcelRequire("1zjdl")).USER_NAVIGATION_ITEM_LINKS)[menuId];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, url ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMAVw")).MenuLinkItem), {
            ...props,
            elemBefore: icon,
            href: url
        }, formattedMessage) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d0QZE")).MenuButtonItem), {
            ...props,
            elemBefore: icon
        }, formattedMessage));
    };
});
parcelRegister("9bWqW", function(module, exports) {
    $parcel$export(module.exports, "PeekMenuItem", ()=>$75745a39d6a125c8$export$4287f527b7969caa);
    var $5uXOq = parcelRequire("5uXOq");
    var $iszzG;
    var $3muxY;
    const $75745a39d6a125c8$export$4287f527b7969caa = ({ menuData: menuData })=>{
        const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iszzG")).NavItemsContext));
        const { peekMenuId: peekMenuId } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iszzG")).PeekMenuIdContext));
        return !!peekMenuId && moreMenuIds.includes(peekMenuId) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3muxY")).ConfigurableMenuItem), {
            isDefaultOpen: true,
            menuData: menuData,
            menuId: peekMenuId
        });
    };
});
parcelRegister("8FnIk", function(module, exports) {
    $parcel$export(module.exports, "PeekMenuIdContextProvider", ()=>$e1d6abe2c6ea1ed4$export$b7d1a20f5a877f18);
    var $5uXOq = parcelRequire("5uXOq");
    var $jhS4y;
    var $c6x3L;
    var $lJ5jf;
    var $iszzG;
    const $e1d6abe2c6ea1ed4$var$CONFIGURABLE_MENU_IDS_USING_SIDEBAR_CONTEXT = [
        (0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).ASSETS,
        (0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).APPS,
        (0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).DASHBOARDS,
        (0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).FILTERS,
        (0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).OPERATIONS,
        (0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).PLANS,
        (0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID).PROJECTS
    ];
    const $e1d6abe2c6ea1ed4$export$b7d1a20f5a877f18 = ({ children: children })=>{
        const { isSelectedPath: isSelectedPath } = (0, (0, parcelRequire("c6x3L")).useSidebarNav4)();
        const { isControlledNav: isControlledNav, isControlledPath: isControlledPath } = (0, (0, parcelRequire("lJ5jf")).useSidebarNav4Controller)();
        const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iszzG")).NavItemsContext));
        const [peekMenuId, setPeekMenuId] = (0, $5uXOq.useState)(()=>$e1d6abe2c6ea1ed4$var$getAutoPeekMenuId(isSelectedPath, isControlledNav, isControlledPath, moreMenuIds));
        (0, $5uXOq.useLayoutEffect)(()=>setPeekMenuId((currentPeekMenuId)=>$e1d6abe2c6ea1ed4$var$getAutoPeekMenuId(isSelectedPath, isControlledNav, isControlledPath, moreMenuIds, currentPeekMenuId)), [
            isControlledNav,
            isControlledPath,
            isSelectedPath,
            moreMenuIds
        ]);
        const peekMenuIdContext = (0, $5uXOq.useMemo)(()=>({
                peekMenuId: peekMenuId,
                setPeekMenuId: setPeekMenuId
            }), [
            peekMenuId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iszzG")).PeekMenuIdContext).Provider, {
            value: peekMenuIdContext
        }, children);
    };
    const $e1d6abe2c6ea1ed4$var$getAutoPeekMenuId = (isSelectedPath, isControlledNav, isControlledPath, moreMenuIds, peekMenuId)=>{
        if (isControlledNav) return moreMenuIds.find(isControlledPath);
        const autoPeekMenuId = moreMenuIds.find(isSelectedPath);
        if (autoPeekMenuId) return autoPeekMenuId;
        if (peekMenuId && $e1d6abe2c6ea1ed4$var$CONFIGURABLE_MENU_IDS_USING_SIDEBAR_CONTEXT.includes(peekMenuId)) return undefined;
        return peekMenuId;
    };
});
parcelRegister("dOB7H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$358df587d3e80a76$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $lfTZh;
    var $kxZPA;
    var $dEbXe;
    const $358df587d3e80a76$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("kHWPy")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/board/src/ui/main.tsx"
    });
    const $358df587d3e80a76$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.board-settings",
            packageName: "jiraNavigationAppsSidebarNav4BoardSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.board-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dEbXe")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($358df587d3e80a76$var$LazySidebarContent, null)));
    var $358df587d3e80a76$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($358df587d3e80a76$var$AsyncSidebar);
});
parcelRegister("dEbXe", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$ff13cb96c7f2cede$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $8CUq3;
    const $ff13cb96c7f2cede$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        })));
    const $ff13cb96c7f2cede$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlock: 'space.200',
        paddingInline: 'space.200'
    });
    const $ff13cb96c7f2cede$var$backButton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $ff13cb96c7f2cede$var$headingSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $ff13cb96c7f2cede$var$menuItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("kHWPy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gS3ma").then(()=>parcelRequire('gNcDN'));
});
parcelRegister("Tdcaw", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSettingsConnectItems", ()=>$a54a68c44d0262b5$export$f0785b98c99d344c);
    $parcel$export(module.exports, "useIsAppsSettingsConnectAppModule", ()=>$a54a68c44d0262b5$export$8dd86b1eb9fdf786);
    $parcel$export(module.exports, "useGlobalAppsSettingsConnectItemActive", ()=>$a54a68c44d0262b5$export$83008eebb9fccef3);
    var $5uXOq = parcelRequire("5uXOq");
    var $8maDO;
    var $hWBtO;
    var $efOLn;
    var $bYoAQ;
    var $hz6Yb;
    var $doZTA;
    const $a54a68c44d0262b5$var$getItems = (d)=>(0, (0, parcelRequire("hWBtO")).getLinks)(d, [
            'admin_plugins_menu'
        ], {
            skipFilter: true
        }).filter((v)=>![
                'upm_section',
                'jpo-ws-admin'
            ].includes(v.id)).map((0, (0, parcelRequire("efOLn")).transformLink)).filter(Boolean);
    const $a54a68c44d0262b5$export$f0785b98c99d344c = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("bYoAQ")).useNavigationGlobalResource)();
        const items = (0, $5uXOq.useMemo)(()=>data && $a54a68c44d0262b5$var$getItems(data), [
            data
        ]);
        return {
            data: items,
            loading: loading,
            error: error
        };
    };
    const $a54a68c44d0262b5$export$ae997bf97ec22b71 = new Set([
        'configurePage',
        'postInstallPage'
    ]);
    const $a54a68c44d0262b5$export$8dd86b1eb9fdf786 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("hz6Yb")).useConnectGeneralResource)();
        return {
            isActive: $a54a68c44d0262b5$export$ae997bf97ec22b71.has(data?.moduleType),
            loading: loading,
            error: error
        };
    };
    const $a54a68c44d0262b5$export$83008eebb9fccef3 = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = $a54a68c44d0262b5$export$f0785b98c99d344c();
        const { isActive: isAppsSettingsConnectAppModuleActive, loading: isAppsSettingsConnectAppModuleLoading, error: isAppsSettingsConnectAppModuleError } = $a54a68c44d0262b5$export$8dd86b1eb9fdf786();
        const isActive = (0, $5uXOq.useMemo)(()=>Boolean(route && data && (0, (0, parcelRequire("8maDO")).findItemAndStack)(data, route.name, location)?.selected), [
            data,
            route,
            location
        ]);
        return {
            isActive: isActive || isAppsSettingsConnectAppModuleActive,
            loading: loading || isAppsSettingsConnectAppModuleLoading,
            error: error || isAppsSettingsConnectAppModuleError
        };
    };
});
parcelRegister("8maDO", function(module, exports) {
    $parcel$export(module.exports, "findItemAndStack", ()=>$c4af9df81f308e02$export$751e2e6237002565);
    var $ajpes = parcelRequire("ajpes");
    var $k0iPT;
    const $c4af9df81f308e02$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
    const $c4af9df81f308e02$var$isSameQuery = (locationQuery, itemQuery)=>(0, ($parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, ($parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
    const $c4af9df81f308e02$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
        let found = null;
        if (!(0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(routeName)) return found;
        const locationQuery = $c4af9df81f308e02$var$splitRelevantQs(location.search);
        items.some((item)=>{
            const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
            const itemQuery = $c4af9df81f308e02$var$splitRelevantQs(itemQs);
            const sameQuery = $c4af9df81f308e02$var$isSameQuery(locationQuery, itemQuery);
            if (item.section !== true && itemPath === location.pathname && sameQuery) {
                found = {
                    stack: parentStack,
                    selected: item
                };
                return true;
            }
            if (item.items) {
                const stack = item.section === true ? parentStack : parentStack.concat(item.id);
                found = $c4af9df81f308e02$export$751e2e6237002565(item.items, routeName, location, stack);
            }
            return Boolean(found);
        });
        return found;
    };
});
parcelRegister("hWBtO", function(module, exports) {
    $parcel$export(module.exports, "getLinks", ()=>$90a1a565c575dc5b$export$8054dcb2b42da45c);
    var $9KzPc;
    const $90a1a565c575dc5b$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
            if (item.id === legacyId) return item.links;
            return item.links && $90a1a565c575dc5b$var$findChildLinks(item.links, legacyId);
        }).find(Boolean);
    const $90a1a565c575dc5b$var$getLinksFromSidebar = (sidebarConfig, legacyId)=>{
        const links = legacyId != null ? $90a1a565c575dc5b$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
        return links || [];
    };
    const $90a1a565c575dc5b$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
        const acc = [];
        locations.forEach((location)=>{
            const links = $90a1a565c575dc5b$var$getLinksFromSidebar(sidebarConfig, location);
            if (omitSections === true) {
                Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
                return;
            }
            Array.prototype.push.apply(acc, links);
        });
        return acc.filter((item)=>{
            if (!item) return false;
            if (skipFilter === true) return true;
            const hasConnectPrefix = item.id && item.id.includes((0, (0, parcelRequire("9KzPc")).connectPrefix));
            if (hasConnectPrefix) return true;
            const isConnectSection = (0, (0, parcelRequire("9KzPc")).connectSections).includes(item.id);
            if (isConnectSection) return true;
            const isJsdConnectSection = item.id && item.id.includes((0, (0, parcelRequire("9KzPc")).jsdConnectPrefix));
            if (isJsdConnectSection) return true;
            return false;
        });
    };
});
parcelRegister("9KzPc", function(module, exports) {
    $parcel$export(module.exports, "connectPrefix", ()=>$f13744297e4a8bc9$export$196d83ebd873fb40);
    $parcel$export(module.exports, "jsdConnectPrefix", ()=>$f13744297e4a8bc9$export$7fac8f726f52d70);
    $parcel$export(module.exports, "connectSections", ()=>$f13744297e4a8bc9$export$b1c2c1fc5d10280);
    var $16J3A;
    const $f13744297e4a8bc9$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
    const $f13744297e4a8bc9$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
    const $f13744297e4a8bc9$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
    const $f13744297e4a8bc9$var$jsdQueuesConnectSection = 'sd-queues-addons';
    const $f13744297e4a8bc9$export$b1c2c1fc5d10280 = [
        $f13744297e4a8bc9$var$legacyAddonPanelLinkId,
        (0, (0, parcelRequire("16J3A")).REPORTS_IDS).REPORTS_ADDONS,
        $f13744297e4a8bc9$var$jsdQueuesConnectSection
    ];
});
parcelRegister("efOLn", function(module, exports) {
    $parcel$export(module.exports, "transformLink", ()=>$179f73798c754e8b$export$5a32dc366b1d641f);
    $parcel$export(module.exports, "transformLinkV4", ()=>$179f73798c754e8b$export$27267b6b6650eaa5);
    const $179f73798c754e8b$export$5a32dc366b1d641f = (link)=>{
        const items = link.links && link.links.length ? link.links.map($179f73798c754e8b$export$5a32dc366b1d641f).filter(Boolean) : undefined;
        if (link.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(link.name)
            };
            return {
                id: link.id,
                name: String(link.name),
                section: !!link.section,
                items: items
            };
        }
        return {
            id: link.id,
            name: String(link.name),
            url: link.url,
            iconUrl: link.iconUrl || '',
            styleClass: link.styleClass || '',
            items: items
        };
    };
    const $179f73798c754e8b$export$27267b6b6650eaa5 = (data)=>{
        const items = data.links && data.links.length ? data.links.map($179f73798c754e8b$export$27267b6b6650eaa5).filter(Boolean) : undefined;
        if (data.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(data.name)
            };
            return {
                id: data.id,
                name: String(data.name),
                section: !!data.section,
                items: items
            };
        }
        return {
            id: data.id,
            name: String(data.name),
            url: data.url,
            iconUrl: data.iconUrl || '',
            styleClass: data.styleClass || '',
            items: items
        };
    };
});
parcelRegister("bYoAQ", function(module, exports) {
    $parcel$export(module.exports, "useNavigationGlobalResource", ()=>$37852a2b10dca6fc$export$1e1c317ed5b99faa);
    var $atU1t;
    var $2YP9W;
    const $37852a2b10dca6fc$export$1e1c317ed5b99faa = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource));
        return {
            data: data && data.response,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("fbami", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f82a04fb3eb62635$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $kxZPA;
    const $f82a04fb3eb62635$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ajhZM")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/apps/src/ui/main.tsx"
    });
    const $f82a04fb3eb62635$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.apps-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsAppsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "apps"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.apps-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f82a04fb3eb62635$var$LazySidebarContent, null))));
    var $f82a04fb3eb62635$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($f82a04fb3eb62635$var$AsyncSidebar);
});
parcelRegister("cnlm7", function(module, exports) {
    $parcel$export(module.exports, "SidebarContent", ()=>$eb45bd1b3d8207f6$export$49e8f7b58a4df4ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $l1N8i;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $koVbs;
    var $iI75Y;
    var $gSZmd;
    var $3yxBH;
    var $6DDUb;
    var $9GB5z;
    var $jDuwy;
    const $eb45bd1b3d8207f6$export$49e8f7b58a4df4ea = ({ children: children, currentPageName: currentPageName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6DDUb")).SideNavHeader), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200",
            xcss: $eb45bd1b3d8207f6$var$headingStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            grow: "hug",
            space: "space.100",
            testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iI75Y")).BackButton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "small",
            as: "h2"
        }, formatMessage((0, (0, parcelRequire("jDuwy")).default).heading))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9GB5z")).AsyncPageSwitcher), {
            currentPageName: currentPageName
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3yxBH")).SideNavContent), {
            testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSZmd")).MenuList), null, children)));
    };
    const $eb45bd1b3d8207f6$var$headingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInlineStart: 'space.050'
    });
});
parcelRegister("iI75Y", function(module, exports) {
    $parcel$export(module.exports, "BackButton", ()=>$8c6efbfad9d4699a$export$e0d897ee21382f67);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $ctqwA;
    var $3bDjY;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $jKa0E;
    var $dJXtD;
    const $8c6efbfad9d4699a$export$e0d897ee21382f67 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { goBack: goBack } = (0, (0, parcelRequire("jKa0E")).useNavigateBack)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("dJXtD")).default).tooltip),
            hideTooltipOnMouseDown: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            spacing: "compact",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("ctqwA"))))),
            label: formatMessage((0, (0, parcelRequire("dJXtD")).default).label),
            onClick: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
                goBack();
            }
        }));
    };
});
parcelRegister("dJXtD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0b400b92991a2960$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0b400b92991a2960$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tooltip: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip",
            "defaultMessage": "Go back"
        },
        label: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label",
            "defaultMessage": "Navigate back to the previous page"
        }
    });
});
parcelRegister("6DDUb", function(module, exports) {
    $parcel$export(module.exports, "SideNavHeader", ()=>$872964f12a4b72df$export$9d28ff3a0d89869c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $872964f12a4b72df$var$styles = {
        root: "_18zrutpp _1q51utpp _85i51b66"
    };
    const $872964f12a4b72df$export$9d28ff3a0d89869c = ({ children: children })=>{
        return $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $872964f12a4b72df$var$styles.root
            ])
        }, children);
    };
});
parcelRegister("9GB5z", function(module, exports) {
    $parcel$export(module.exports, "AsyncPageSwitcher", ()=>$8f72ed6ff9af1bd8$export$3130bd98029942c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $lfTZh;
    var $kxZPA;
    const $8f72ed6ff9af1bd8$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8f72ed6ff9af1bd8$var$headingSkeleton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8f72ed6ff9af1bd8$var$dropdownSkeleton
        }));
    const $8f72ed6ff9af1bd8$var$LazyPageSwitcher = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("iPVb9")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/common/src/common/ui/page-switcher/main.tsx"
    });
    const $8f72ed6ff9af1bd8$export$3130bd98029942c = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.page-switcher",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($8f72ed6ff9af1bd8$export$8f31e4c4a37b8e9c, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8f72ed6ff9af1bd8$var$LazyPageSwitcher, props));
    const $8f72ed6ff9af1bd8$var$headingSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: '50%',
        height: "var(--ds-space-200, 16px)",
        borderRadius: 'border.radius.100'
    });
    const $8f72ed6ff9af1bd8$var$dropdownSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("iPVb9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6XfVR")
    ]).then(()=>parcelRequire('8dyHT'));
});
parcelRegister("jDuwy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfdc401436033e3a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dfdc401436033e3a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading",
            "defaultMessage": "Jira admin settings"
        }
    });
});
parcelRegister("i8077", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$8a8cf6e18096ea33$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    const $8a8cf6e18096ea33$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$sectionHeading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$sectionHeading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }));
    const $8a8cf6e18096ea33$var$sectionHeading = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: '50%',
        height: "var(--ds-space-200, 16px)",
        borderRadius: 'border.radius.100',
        marginTop: 'space.100'
    });
    const $8a8cf6e18096ea33$var$menuItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("ajhZM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4HmNO")
    ]).then(()=>parcelRequire('6JIAx'));
});
parcelRegister("bCaZu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58b39e5bf0fb90a0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $kxZPA;
    const $58b39e5bf0fb90a0$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ihhaT")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/issues/src/ui/main.tsx"
    });
    const $58b39e5bf0fb90a0$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.issues-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsIssuesSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "issues"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.issues-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($58b39e5bf0fb90a0$var$LazySidebarContent, null))));
    var $58b39e5bf0fb90a0$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($58b39e5bf0fb90a0$var$AsyncSidebar);
});
parcelRegister("ihhaT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hEv4j").then(()=>parcelRequire('fUdDx'));
});
parcelRegister("gYSoA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$425ce2b571ab3ef5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $kxZPA;
    const $425ce2b571ab3ef5$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("f6lak")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/products/src/ui/main.tsx"
    });
    const $425ce2b571ab3ef5$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.products-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProductsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "products"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.products-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($425ce2b571ab3ef5$var$LazySidebarContent, null))));
    var $425ce2b571ab3ef5$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($425ce2b571ab3ef5$var$AsyncSidebar);
});
parcelRegister("f6lak", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eOt8B")
    ]).then(()=>parcelRequire('864s3'));
});
parcelRegister("ieEgo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b88bb6161ed4902f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $kxZPA;
    const $b88bb6161ed4902f$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("iZYzH")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/projects/src/ui/main.tsx"
    });
    const $b88bb6161ed4902f$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.projects-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProjectsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "projects"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.projects-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b88bb6161ed4902f$var$LazySidebarContent, null))));
    var $b88bb6161ed4902f$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b88bb6161ed4902f$var$AsyncSidebar);
});
parcelRegister("iZYzH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7bkDd").then(()=>parcelRequire('fbdwm'));
});
parcelRegister("kNJsg", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSystemSettingsConnectItems", ()=>$90305fd4b8d90c67$export$68950d4e14439158);
    $parcel$export(module.exports, "useGlobalSystemSettingsConnectItemActive", ()=>$90305fd4b8d90c67$export$5efb701a2106707a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8maDO;
    var $hWBtO;
    var $efOLn;
    var $fgeiD;
    var $bYoAQ;
    var $hz6Yb;
    var $doZTA;
    const $90305fd4b8d90c67$var$getItems = (d)=>(0, (0, parcelRequire("hWBtO")).getLinks)(d, [
            'admin_system_menu'
        ], {
            skipFilter: true
        }).map((0, (0, parcelRequire("efOLn")).transformLink)).filter(Boolean);
    const $90305fd4b8d90c67$export$68950d4e14439158 = (0, (0, parcelRequire("fgeiD")).withThrowOnError)(()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("bYoAQ")).useNavigationGlobalResource)();
        const items = (0, $5uXOq.useMemo)(()=>data && $90305fd4b8d90c67$var$getItems(data), [
            data
        ]);
        return {
            data: items,
            loading: loading,
            error: error
        };
    });
    const $90305fd4b8d90c67$export$5efb701a2106707a = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = $90305fd4b8d90c67$export$68950d4e14439158();
        const { data: connectGeneralData, loading: connectGeneralResourceLoading, error: connectGeneralResourceError } = (0, (0, parcelRequire("hz6Yb")).useConnectGeneralResource)();
        const isActive = (0, $5uXOq.useMemo)(()=>Boolean(route && data && (0, (0, parcelRequire("8maDO")).findItemAndStack)(data, route.name, location)?.selected), [
            data,
            route,
            location
        ]);
        return {
            isActive: isActive || connectGeneralData?.moduleType === 'adminPages',
            loading: loading || connectGeneralResourceLoading,
            error: error || connectGeneralResourceError
        };
    };
});
parcelRegister("fgeiD", function(module, exports) {
    $parcel$export(module.exports, "withThrowOnError", ()=>$f9ce174aaa2e063b$export$a018832f2ec4dc91);
    var $gKZoD;
    const $f9ce174aaa2e063b$var$isDataEmpty = (data)=>data == null;
    function $f9ce174aaa2e063b$export$a018832f2ec4dc91(theHook) {
        return (...args)=>{
            (0, (0, parcelRequire("gKZoD")).di)(theHook);
            const result = theHook(...args);
            if (!false && $f9ce174aaa2e063b$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
            return result;
        };
    }
});
parcelRegister("aWnEG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59776b430a24875d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $kxZPA;
    const $59776b430a24875d$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("1Dq95")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/system/src/ui/main.tsx"
    });
    const $59776b430a24875d$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.system-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsSystemSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "system"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.system-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($59776b430a24875d$var$LazySidebarContent, null))));
    var $59776b430a24875d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($59776b430a24875d$var$AsyncSidebar);
});
parcelRegister("1Dq95", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9yM86").then(()=>parcelRequire('rQUQs'));
});
parcelRegister("2KXa8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5d93ac4546abf11$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $lfTZh;
    var $kxZPA;
    var $aUxXz;
    const $b5d93ac4546abf11$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aa9wr")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/help-center/src/ui/main.tsx"
    });
    const $b5d93ac4546abf11$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.help-center-settings",
            packageName: "jiraNavigationAppsSidebarNav4HelpCenterSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.help-center-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aUxXz")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b5d93ac4546abf11$var$LazySidebarContent, null)));
    var $b5d93ac4546abf11$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b5d93ac4546abf11$var$AsyncSidebar);
});
parcelRegister("aUxXz", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$c42d7c14b1508227$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $8CUq3;
    const $c42d7c14b1508227$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c42d7c14b1508227$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c42d7c14b1508227$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c42d7c14b1508227$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c42d7c14b1508227$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c42d7c14b1508227$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c42d7c14b1508227$var$menuItem
        })));
    const $c42d7c14b1508227$var$backButton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $c42d7c14b1508227$var$headingSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $c42d7c14b1508227$var$menuItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("aa9wr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jvUDk").then(()=>parcelRequire('22iKv'));
});
parcelRegister("hrRcW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e7cdaae12475462$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $lfTZh;
    var $kxZPA;
    var $jUfLV;
    const $8e7cdaae12475462$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("7BaRo")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/personal/src/ui/main.tsx"
    });
    const $8e7cdaae12475462$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.personal-settings",
            packageName: "jiraNavigationAppsSidebarNav4PersonalSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.personal-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jUfLV")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8e7cdaae12475462$var$LazySidebarContent, null)));
    var $8e7cdaae12475462$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($8e7cdaae12475462$var$AsyncSidebar);
});
parcelRegister("jUfLV", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$1cdf070fb698d8d2$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $8CUq3;
    const $1cdf070fb698d8d2$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1cdf070fb698d8d2$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1cdf070fb698d8d2$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1cdf070fb698d8d2$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1cdf070fb698d8d2$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1cdf070fb698d8d2$var$menuItem
        })));
    const $1cdf070fb698d8d2$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlock: 'space.200',
        paddingInline: 'space.200'
    });
    const $1cdf070fb698d8d2$var$backButton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $1cdf070fb698d8d2$var$headingSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $1cdf070fb698d8d2$var$menuItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("7BaRo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6lHZh").then(()=>parcelRequire('hox2O'));
});
parcelRegister("lF3VU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$442721cda4044790$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    var $bhcrK;
    const $442721cda4044790$var$LazyPlanSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("bwRDW")).then(({ PlanSettingsSidebar: PlanSettingsSidebar })=>PlanSettingsSidebar), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/plan/src/ui/main.tsx"
    });
    const $442721cda4044790$var$AsyncSidebar = ({ store: store })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "asyncSidebarPlanSettings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bhcrK")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($442721cda4044790$var$LazyPlanSettingsSidebar, {
            store: store
        }));
    var $442721cda4044790$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($442721cda4044790$var$AsyncSidebar);
});
parcelRegister("bhcrK", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$d204c752b5086975$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $8CUq3;
    const $d204c752b5086975$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$titleSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$subtitleItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$subtitleItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$subtitleItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$subtitleItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d204c752b5086975$var$menuItem
        })));
    const $d204c752b5086975$var$titleSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-800, 64px)",
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
    const $d204c752b5086975$var$backButton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-400, 32px)",
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
    const $d204c752b5086975$var$headingSkeleton = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $d204c752b5086975$var$menuItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $d204c752b5086975$var$subtitleItem = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-200, 16px)",
        width: "var(--ds-space-1000, 80px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("bwRDW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("b8Lgd").then(()=>parcelRequire('7UsxD'));
});
parcelRegister("bJJms", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cce9becc602ac5ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $kxZPA;
    const $cce9becc602ac5ad$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("cwL19")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/company-managed/src/ui/main.tsx"
    });
    const $cce9becc602ac5ad$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.business.company-managed",
            packageName: "jiraNavigationAppsSidebarNav4BusinessCompanyManagedProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.business.company-managed",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cce9becc602ac5ad$var$LazySidebarContent, {
            project: project
        })));
    var $cce9becc602ac5ad$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($cce9becc602ac5ad$var$AsyncSidebar);
});
parcelRegister("cwL19", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f7rnD").then(()=>parcelRequire('kaECc'));
});
parcelRegister("6ZLHo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b222bb97daacff3e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $kxZPA;
    const $b222bb97daacff3e$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("g9ow0")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/team-managed/src/ui/main.tsx"
    });
    const $b222bb97daacff3e$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.business.team-managed",
            packageName: "jiraNavigationAppsSidebarNav4BusinessTeamManagedProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.business.team-managed",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b222bb97daacff3e$var$LazySidebarContent, {
            project: project
        })));
    var $b222bb97daacff3e$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b222bb97daacff3e$var$AsyncSidebar);
});
parcelRegister("g9ow0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("l1ol4")
    ]).then(()=>parcelRequire('v17He'));
});
parcelRegister("YiTdm", function(module, exports) {
    $parcel$export(module.exports, "useIsConnectAppActive", ()=>$c92d349d32b0fe9a$export$249b2e8512031cae);
    var $5uXOq = parcelRequire("5uXOq");
    var $8maDO;
    var $doZTA;
    var $eNZur;
    const $c92d349d32b0fe9a$export$249b2e8512031cae = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: connectApps, error: error, loading: loading } = (0, (0, parcelRequire("eNZur")).useConnectApps)();
        const isActive = (0, $5uXOq.useMemo)(()=>Boolean((0, (0, parcelRequire("8maDO")).findItemAndStack)(connectApps, route.name, location)?.selected), [
            connectApps,
            location,
            route.name
        ]);
        return {
            isActive: isActive,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("eNZur", function(module, exports) {
    $parcel$export(module.exports, "useConnectApps", ()=>$5ce3bcf534d9d0ea$export$4864478dcab77643);
    var $5uXOq = parcelRequire("5uXOq");
    var $loy04;
    var $efOLn;
    var $9MFH3;
    const $5ce3bcf534d9d0ea$export$4864478dcab77643 = ()=>{
        const { data: connectResourceItems, error: error, loading: loading } = (0, (0, parcelRequire("loy04")).useProjectSettingsSidebarConnectAddonsNavigationResource)();
        const connectApps = (0, $5uXOq.useMemo)(()=>{
            if (connectResourceItems == null) return [];
            const transformedConnectApps = [];
            for (const item of connectResourceItems){
                const transformedItem = (0, (0, parcelRequire("efOLn")).transformLinkV4)(item);
                if (transformedItem && !(0, (0, parcelRequire("9MFH3")).LEGACY_CONNECT_ITEM_IDS).has(transformedItem.id)) transformedConnectApps.push(transformedItem);
            }
            return transformedConnectApps;
        }, [
            connectResourceItems
        ]);
        return {
            data: connectApps,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("9MFH3", function(module, exports) {
    $parcel$export(module.exports, "LEGACY_CONNECT_ITEM_IDS", ()=>$b25e3cd9691dd3ed$export$911a3d81a5d162b6);
    const $b25e3cd9691dd3ed$export$911a3d81a5d162b6 = new Set([
        'general_configuration',
        'dark_features',
        'troubleshooting_and_support',
        'view_auditing',
        'pluginViewer',
        'pluginViewer',
        'system_info',
        'integrity_checker',
        'logging_profiling',
        'scheduler_details',
        'security_section',
        'project_role_browser',
        'global_permissions',
        'collectors',
        'user_interface',
        'user_defaults',
        'edit_default_dashboard',
        'lookandfeel',
        'com.atlassian.pas:pas-admin-link-jira',
        'import_export_section',
        'vertigo_export',
        'external_import',
        'vertigo_import',
        'vertigo_import_jira_cloud',
        'vertigo_import_jira_server',
        'mail_section',
        'global_mail_settings',
        'outgoing_mail',
        'incoming_mail',
        'send_email',
        'admin-helper-admin-section',
        'permissionhelper-admin-page',
        'notificationhelper-admin-page',
        'shared_section',
        'shared_filters',
        'shared_dashboards',
        'advanced_section',
        'attachments',
        'eventtypes',
        'webhooks-admin',
        'services',
        'manage_dashboards',
        'manage_filters',
        'greenhopper-lexorank-manage',
        'jira.webfragments.view.project.operations:edit_project',
        'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
        'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
        'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
        'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
        'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
        'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
        'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
        'com.atlassian.jira.jira-projects-plugin:administer_project_components',
        'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
        'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
        'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
        'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
        'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
        'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
        'com.atlassian.jira.jira-projects-plugin:administer_project_code',
        'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
        'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
        'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
        'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
        'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
        'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
        'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
        'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
        'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
        'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
        'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
        'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
        'com.codebarrel.addons.automation__cb-automation'
    ]);
});
parcelRegister("kqEpF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2c80e831fc4dee6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $kxZPA;
    const $c2c80e831fc4dee6$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5U4wb")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/product-discovery/src/ui/main.tsx"
    });
    const $c2c80e831fc4dee6$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.jpd-settings",
            packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsJpdSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.jpd-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c2c80e831fc4dee6$var$LazySidebarContent, {
            project: project
        })));
    var $c2c80e831fc4dee6$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($c2c80e831fc4dee6$var$AsyncSidebar);
});
parcelRegister("5U4wb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9Dnuj").then(()=>parcelRequire('aDwWR'));
});
parcelRegister("1G9rm", function(module, exports) {
    $parcel$export(module.exports, "AsyncJsmCmpProjectSettingsSidebar", ()=>$5b1e7bac8593a90d$export$2ce6ad449436c545);
    var $5uXOq = parcelRequire("5uXOq");
    var $juTur;
    var $cljJ9;
    var $7VBev;
    var $84dyl;
    var $lfTZh;
    var $kxZPA;
    const $5b1e7bac8593a90d$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4CeCe")).then(({ JSMCmpProjectSettingsSidebar: JSMCmpProjectSettingsSidebar })=>JSMCmpProjectSettingsSidebar), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/company-managed/src/main.tsx"
    });
    const $5b1e7bac8593a90d$var$analyticsAttributes = {
        projectStyle: 'cmp',
        navVersion: undefined
    };
    const $5b1e7bac8593a90d$export$2ce6ad449436c545 = (0, $5uXOq.memo)(({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.jsm-cmp-project-settings",
            packageName: "jiraNavigationAppsSidebarNav4JsmCmpProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).ContextualAnalyticsData), {
            menuId: (0, (0, parcelRequire("84dyl")).MENU_ID_JSM_SETTINGS),
            attributes: $5b1e7bac8593a90d$var$analyticsAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.jsm-cmp-project-settings.loading-lazy",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5b1e7bac8593a90d$var$LazySidebarContent, {
            project: project
        })))));
});
parcelRegister("84dyl", function(module, exports) {
    $parcel$export(module.exports, "MENU_ID_JSM_SETTINGS", ()=>$8fdaf51231934b8c$export$4c5fa21d31710030);
    $parcel$export(module.exports, "PROJECT_SETTINGS_COMMON_ANALYTICS_ATTRIBUTES", ()=>$8fdaf51231934b8c$export$8092325c2fa271de);
    const $8fdaf51231934b8c$export$4c5fa21d31710030 = 'project/service-desk/settings';
    const $8fdaf51231934b8c$var$COMMON_ANALYTICS_ATTRIBUTES = {
        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
        level: 1
    };
    const $8fdaf51231934b8c$export$8092325c2fa271de = {
        ...$8fdaf51231934b8c$var$COMMON_ANALYTICS_ATTRIBUTES,
        actionSubjectId: (0, $d59b407ab907bf7b$export$13171e509c859bbf)
    };
});
parcelRegister("4CeCe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("k1zH8")
    ]).then(()=>parcelRequire('58Da3'));
});
parcelRegister("drQWa", function(module, exports) {
    $parcel$export(module.exports, "AsyncJsmTmpProjectSettingsSidebar", ()=>$723c8db5701ca405$export$dadf0f8c840cb26d);
    var $5uXOq = parcelRequire("5uXOq");
    var $juTur;
    var $cljJ9;
    var $7VBev;
    var $84dyl;
    var $lfTZh;
    var $kxZPA;
    const $723c8db5701ca405$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("2dCO4")).then(({ JSMTmpProjectSettingsSidebar: JSMTmpProjectSettingsSidebar })=>JSMTmpProjectSettingsSidebar), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/team-managed/src/main.tsx"
    });
    const $723c8db5701ca405$var$analyticsAttributes = {
        projectStyle: 'tmp',
        navVersion: undefined
    };
    const $723c8db5701ca405$export$dadf0f8c840cb26d = (0, $5uXOq.memo)(({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.jsm-tmp-project-settings",
            packageName: "jiraNavigationAppsSidebarNav4JsmTmpProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).ContextualAnalyticsData), {
            menuId: (0, (0, parcelRequire("84dyl")).MENU_ID_JSM_SETTINGS),
            attributes: $723c8db5701ca405$var$analyticsAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.jsm-tmp-project-settings.loading-lazy",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($723c8db5701ca405$var$LazySidebarContent, {
            project: project
        })))));
});
parcelRegister("2dCO4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2ALx4")
    ]).then(()=>parcelRequire('dJT47'));
});
parcelRegister("2DtJE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd62495e40b7984d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $kxZPA;
    const $fd62495e40b7984d$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8qpTU")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/company-managed/src/ui/main.tsx"
    });
    const $fd62495e40b7984d$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.software.company-managed",
            packageName: "jiraNavigationAppsSidebarNav4SoftwareCompanyManagedProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.software.company-managed",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($fd62495e40b7984d$var$LazySidebarContent, {
            project: project
        })));
    var $fd62495e40b7984d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($fd62495e40b7984d$var$AsyncSidebar);
});
parcelRegister("8qpTU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iNMXx").then(()=>parcelRequire('cLlaG'));
});
parcelRegister("cnyf1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$713dabe47adbee45$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $kxZPA;
    const $713dabe47adbee45$var$LazySidebarContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jOLAH")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/team-managed/src/ui/main.tsx"
    });
    const $713dabe47adbee45$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.software.team-managed",
            packageName: "jiraNavigationAppsSidebarNav4SoftwareTeamManagedProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.software.team-managed",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($713dabe47adbee45$var$LazySidebarContent, {
            project: project
        })));
    var $713dabe47adbee45$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($713dabe47adbee45$var$AsyncSidebar);
});
parcelRegister("jOLAH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cxRoY")
    ]).then(()=>parcelRequire('4yoHz'));
});
parcelRegister("eGkew", function(module, exports) {
    $parcel$export(module.exports, "SidebarSelectorProvider", ()=>$8451f19a8196b45e$export$6af584355cfb32c6);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $2vSU6;
    var $lpwtK;
    var $lGo7j;
    var $cin8p;
    var $awp39;
    var $b69Lc;
    var $dlYil;
    var $jjzbO;
    var $hWtQt;
    var $jfqNX;
    var $gZbSF;
    var $dmKXV;
    var $iFaFr;
    var $4IWRY;
    var $hBv66;
    var $iHiHz;
    var $cOg46;
    var $7AyKX;
    var $koWFd;
    var $937TY;
    var $lgSL3;
    var $h0bZU;
    var $9s3j1;
    var $2IHt2;
    var $hz6Yb;
    var $2YP9W;
    const $8451f19a8196b45e$var$renderProjectSidebar = ({ data: project, loading: loading })=>{
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), {
            isFull: true
        });
        if (!project) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2IHt2")).default), null);
        switch(project.type){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
            case 0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h0bZU")).default), null);
            case 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lgSL3")).default), null);
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if (project.isSimplified) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("koWFd")).default), null);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9s3j1")).default), null);
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dmKXV")).default), null);
            default:
                return null;
        }
    };
    const $8451f19a8196b45e$var$ProjectSidebar = (0, $5uXOq.memo)($8451f19a8196b45e$var$renderProjectSidebar, (0, ($parcel$interopDefault($ajpes))));
    const $8451f19a8196b45e$export$6af584355cfb32c6 = ({ sidebar: sidebar, children: children })=>{
        const projectState = (0, (0, parcelRequire("lpwtK")).useProject)();
        const isInsightMenuSelected = (0, (0, parcelRequire("jjzbO")).useInsight)();
        const shouldRenderInsightObjectSchemaSidebar = (0, (0, parcelRequire("jjzbO")).useInsightObjectSchemaSidebar)();
        const { selected: pSelected, loading: pLoading } = (0, (0, parcelRequire("gZbSF")).useProjectConnectItems)();
        const { selected: prSelected, loading: prLoading } = (0, (0, parcelRequire("hWtQt")).useProjectReportsConnectItems)();
        const { selected: psSelected, loading: psLoading } = (0, (0, parcelRequire("jfqNX")).useProjectSettingsConnectItems)();
        const { selected: gSelected, loading: gLoading } = (0, (0, parcelRequire("dlYil")).useGlobalConnectItems)();
        const { selected: gsSelected, loading: gsLoading } = (0, (0, parcelRequire("b69Lc")).useGlobalSettingsConnectItems)();
        const { selected: gssSelected, loading: gssLoading } = (0, (0, parcelRequire("awp39")).useGlobalSettingsSystemConnectItems)();
        const { data: gresData, loading: gresLoading } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("hz6Yb")).connectGeneralResources));
        const { sections: fgSections, loading: fgLoading } = (0, (0, parcelRequire("4IWRY")).useForgeGlobalPageItems)();
        if (shouldRenderInsightObjectSchemaSidebar) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7AyKX")).default), null));
        if (isInsightMenuSelected) return null;
        if (sidebar === (0, (0, parcelRequire("937TY")).default)) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("937TY")).default), null));
        if (sidebar === (0, (0, parcelRequire("iFaFr")).default)) {
            if (fgLoading) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), {
                isFull: true
            }));
            if (fgSections?.length) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iFaFr")).default), null));
            return children(null);
        }
        if (!Array.isArray(sidebar)) {
            const Sidebar = sidebar;
            return children(Sidebar != null ? (0, ($parcel$interopDefault($5uXOq))).createElement(Sidebar, null) : null);
        }
        if (sidebar === (0, (0, parcelRequire("hBv66")).genericConnectSidebars)) {
            const foundInProject = pSelected || prSelected || psSelected || [
                'jiraProjectAdminTabPanels'
            ].includes(gresData?.moduleType);
            const foundSomewhere = foundInProject || gSelected || gsSelected || gssSelected;
            const stillLoading = pLoading || prLoading || psLoading || gLoading || gsLoading || gssLoading || gresLoading;
            if (stillLoading && !foundSomewhere) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), {
                isFull: true
            }));
            if (foundInProject) {
                const projectSidebar = (0, ($parcel$interopDefault($5uXOq))).createElement($8451f19a8196b45e$var$ProjectSidebar, projectState);
                return children(projectSidebar);
            }
            if (gSelected) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cin8p")).default), null));
            if (gsSelected || [
                'configurePage',
                'postInstallPage'
            ].includes(gresData?.moduleType)) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHiHz")).default), null));
            if (gssSelected || [
                'adminPages'
            ].includes(gresData?.moduleType)) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOg46")).default), null));
            return children(null);
        }
        const projectSidebar = (0, ($parcel$interopDefault($5uXOq))).createElement($8451f19a8196b45e$var$ProjectSidebar, projectState);
        return children(projectSidebar);
    };
});
parcelRegister("b69Lc", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSettingsConnectItems", ()=>$ba4edc5b901e34a6$export$f0785b98c99d344c);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $aUDLa;
    var $doZTA;
    var $7tsV0;
    var $4gymV;
    var $5W6pd;
    const $ba4edc5b901e34a6$var$getItemsMemo = (0, (0, parcelRequire("8QpSo")).default)((d)=>(0, (0, parcelRequire("4gymV")).getLinks)(d, [
            'admin_plugins_menu'
        ], {
            skipFilter: true
        }).filter((v)=>![
                'upm_section',
                'jpo-ws-admin'
            ].includes(v.id)).map((0, (0, parcelRequire("5W6pd")).transformLink)).filter(Boolean));
    const $ba4edc5b901e34a6$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $ba4edc5b901e34a6$export$f0785b98c99d344c = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("aUDLa")).useNavigationGlobalResource)();
        const items = (0, $5uXOq.useMemo)(()=>data && $ba4edc5b901e34a6$var$getItemsMemo(data), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $ba4edc5b901e34a6$var$findItemAndStackMemo(items, route.name, location), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("dlYil", function(module, exports) {
    $parcel$export(module.exports, "useGlobalConnectItems", ()=>$17cad8174f7acae6$export$ee355b2e42d6462b);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $aUDLa;
    var $doZTA;
    var $7tsV0;
    var $4gymV;
    var $5W6pd;
    const $17cad8174f7acae6$var$getItemsMemo = (0, (0, parcelRequire("8QpSo")).default)((d)=>(0, (0, parcelRequire("4gymV")).getLinks)(d, [
            'global-navigation-product'
        ]).map((0, (0, parcelRequire("5W6pd")).transformLink)).filter((item)=>item != null && item.items));
    const $17cad8174f7acae6$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $17cad8174f7acae6$export$ee355b2e42d6462b = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("aUDLa")).useNavigationGlobalResource)();
        const sidebars = (0, $5uXOq.useMemo)(()=>data && $17cad8174f7acae6$var$getItemsMemo(data), [
            data
        ]);
        const searchResult = (0, $5uXOq.useMemo)(()=>{
            let result = {
                stack: [],
                selected: null,
                title: null,
                data: null
            };
            if (sidebars != null) sidebars.some((sidebar)=>{
                const { items: items } = sidebar || {};
                if (!sidebar || !route || items == null) return false;
                const found = $17cad8174f7acae6$var$findItemAndStackMemo(items, route.name, location);
                if (found) {
                    result = {
                        ...found,
                        title: sidebar.name,
                        data: items
                    };
                    return true;
                }
                return false;
            });
            return result;
        }, [
            sidebars,
            route,
            location
        ]);
        return {
            ...searchResult,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("jjzbO", function(module, exports) {
    $parcel$export(module.exports, "useInsight", ()=>$25e0b1dc21125803$export$e24dad0705701755);
    $parcel$export(module.exports, "useInsightObjectSchemaSidebar", ()=>$25e0b1dc21125803$export$1f0bd21403710fc);
    var $3HwlS;
    var $6jY6G;
    const $25e0b1dc21125803$export$e24dad0705701755 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        if (route.navigation) return route.navigation.menuId === 'INSIGHT';
        return false;
    };
    const $25e0b1dc21125803$export$1f0bd21403710fc = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return false;
        return route.name === 'servicedesk-cmdb-object-schema';
    };
});
parcelRegister("4IWRY", function(module, exports) {
    $parcel$export(module.exports, "useForgeGlobalPageItems", ()=>$e660bc01a5db5a53$export$ff333fd2f0bf5254);
    var $5uXOq = parcelRequire("5uXOq");
    var $4NrfJ;
    var $7Tlti;
    var $c70gQ;
    var $doZTA;
    const $e660bc01a5db5a53$export$ff333fd2f0bf5254 = ()=>{
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: modules, loading: loading, error: error } = (0, (0, parcelRequire("4NrfJ")).useGlobalForgeApps)();
        const extension = (0, (0, parcelRequire("c70gQ")).useMatchedExtension)({
            modules: modules,
            match: match
        });
        const sections = (0, $5uXOq.useMemo)(()=>extension && (0, (0, parcelRequire("7Tlti")).toSections)(extension), [
            extension
        ]);
        return {
            extension: extension,
            sections: sections,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("4NrfJ", function(module, exports) {
    $parcel$export(module.exports, "getItemHref", ()=>$7a76aaaa3a23f02a$export$ed6342e0e28465a6);
    $parcel$export(module.exports, "useGlobalForgeApps", ()=>$7a76aaaa3a23f02a$export$f834c14187f80532);
    var $5uXOq = parcelRequire("5uXOq");
    var $e5wyW;
    var $4R6GH;
    var $e0AC8;
    var $awp3q;
    var $dvdr4;
    var $5cmSg;
    var $5bkvv;
    var $2YP9W;
    const $7a76aaaa3a23f02a$export$ed6342e0e28465a6 = (extension)=>{
        const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
        return `/jira/apps/${appId}/${envId}`;
    };
    const $7a76aaaa3a23f02a$var$useGlobalForgeAppsV1 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("5bkvv")).forgeGlobalModuleV1Resource));
        const globalPageData = (0, $5uXOq.useMemo)(()=>data?.extensions || null, [
            data
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: globalPageData ? globalPageData.filter((extension)=>(0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, {})) : null,
                loading: loading,
                error: error
            }), [
            globalPageData,
            loading,
            error
        ]);
    };
    const $7a76aaaa3a23f02a$var$useGlobalForgeAppsV2 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("5bkvv")).forgeGlobalModuleV2Resource));
        (0, (0, parcelRequire("dvdr4")).useDisplayConditionsConsistencyCheck)(data, {}, 'global-forge-apps-hook');
        return (0, $5uXOq.useMemo)(()=>({
                data: data ? data.filter((0, (0, parcelRequire("5cmSg")).isExtensionVisible)) : null,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    };
    const $7a76aaaa3a23f02a$export$f834c14187f80532 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $7a76aaaa3a23f02a$var$useGlobalForgeAppsV2, $7a76aaaa3a23f02a$var$useGlobalForgeAppsV1);
});
parcelRegister("7AyKX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cf06d255b5e49f4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $6cf06d255b5e49f4$var$LazyInsightObjectSchemaSidebar = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("4F4a9")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/insight-object-schema/src/index.tsx"
    });
    const $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "insight-object-schema-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6cf06d255b5e49f4$var$LazyInsightObjectSchemaSidebar, null)));
    $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar.displayName = 'InsightObjectSchemaSidebar';
    var $6cf06d255b5e49f4$export$2e2bcd8739ae039 = $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar;
});
parcelRegister("4F4a9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("i5RRW"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("a8Tkc")
    ]).then(()=>parcelRequire('48ZOK'));
});
parcelRegister("lgSL3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$756fa7b51ff3cfd4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $756fa7b51ff3cfd4$var$LazyPolarisProjectSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("9vvGA")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/polaris/src/index.tsx"
    });
    const $756fa7b51ff3cfd4$var$PolarisProjectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "polarisProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($756fa7b51ff3cfd4$var$LazyPolarisProjectSidebar, null)));
    $756fa7b51ff3cfd4$var$PolarisProjectSidebar.displayName = 'PolarisProjectSidebar';
    var $756fa7b51ff3cfd4$export$2e2bcd8739ae039 = $756fa7b51ff3cfd4$var$PolarisProjectSidebar;
});
parcelRegister("9vvGA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("blsmD")
    ]).then(()=>parcelRequire('aSh9m'));
});
parcelRegister("ht71P", function(module, exports) {
    $parcel$export(module.exports, "AsyncNudgeBundledUsersFlagContainer", ()=>$7676eec527946b59$export$30d9dff000fbaa2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $7676eec527946b59$var$NudgeBundledUsersFlagContainer = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5ioBG")).then((module)=>module.NudgeBundledUsersXflow), {
        ssr: false,
        moduleId: "./src/packages/growth/nudge-bundled-users-to-join-connie/src/ui/index.tsx"
    });
    const $7676eec527946b59$export$30d9dff000fbaa2d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "nudgeBundledUserFlag",
            packageName: "nudgeBundledUsersToJoinConnie",
            fallback: "unmount",
            teamName: "confluenceOnboarding"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nudge-bundled-users-flag",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7676eec527946b59$var$NudgeBundledUsersFlagContainer, null)));
});
parcelRegister("5ioBG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ev3ZS")
    ]).then(()=>parcelRequire('6vucW'));
});
parcelRegister("4V52L", function(module, exports) {
    $parcel$export(module.exports, "SidebarFeedbackButton", ()=>$ea1c2dd9a94de02f$export$b270ed097d20c023);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $42CjB;
    var $jpaiZ;
    var $e4yMr;
    var $3bDjY;
    var $4R6GH;
    var $7iULw;
    var $dseDh;
    var $ousew;
    var $koVbs;
    var $j5Q6Z;
    var $dkkQn;
    var $4DrQd;
    var $bw7Gm;
    var $koeKL;
    var $2tT7R;
    var $83YFz;
    function $ea1c2dd9a94de02f$export$b270ed097d20c023() {
        const environment = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { openFeedbackCollector: openFeedbackCollector, closeFeedbackCollector: closeFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const onClickHandler = (0, $5uXOq.useCallback)(()=>{
            const showFeedbackTitleDetailsWithLink = (0, (0, parcelRequire("j5Q6Z")).getWillShowNav4UserOptIn)() || (0, (0, parcelRequire("dkkQn")).getWillShowNav4UserOptOut)();
            const formattedMessageNode = showFeedbackTitleDetailsWithLink ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("83YFz")).default).feedbackTitleDetailsWithLink,
                values: {
                    a: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                            href: "/jira/settings/personal/general",
                            onClick: closeFeedbackCollector
                        }, chunks)
                }
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("83YFz")).default).feedbackTitleDetailsNoLink);
            openFeedbackCollector({
                entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_NAVIGATION_REFRESH),
                feedbackContext: [
                    {
                        id: 'environment',
                        value: environment
                    },
                    {
                        id: 'cloud-id',
                        value: cloudId
                    },
                    {
                        id: 'location',
                        value: (0, (0, parcelRequire("bw7Gm")).default)(window?.location?.href ?? '')
                    }
                ],
                feedbackGroupId: (0, (0, parcelRequire("4DrQd")).NAV4_GENERAL_FEEDBACK_GROUP_ID),
                feedbackTitle: formatMessage((0, (0, parcelRequire("83YFz")).default).feedbackTitle),
                feedbackTitleDetails: formattedMessageNode
            });
        }, [
            closeFeedbackCollector,
            cloudId,
            environment,
            formatMessage,
            openFeedbackCollector
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("83YFz")).default).sidebarFeedbackButtonLabel),
            position: "top"
        }, (0, (0, parcelRequire("4R6GH")).fg)('jira_global_invite_nav4') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("jpaiZ"))))),
            onClick: onClickHandler,
            label: formatMessage((0, (0, parcelRequire("83YFz")).default).sidebarFeedbackButtonLabel)
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            iconBefore: (0, ($parcel$interopDefault((0, parcelRequire("jpaiZ"))))),
            appearance: "subtle",
            onClick: onClickHandler
        }, formatMessage((0, (0, parcelRequire("83YFz")).default).sidebarFeedbackButtonLabel)));
    }
});
parcelRegister("jpaiZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e208588d898f6af2$var$_react = $e208588d898f6af2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e208588d898f6af2$var$_baseNew = $e208588d898f6af2$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $e208588d898f6af2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e208588d898f6af2$var$MegaphoneIcon = (props)=>$e208588d898f6af2$var$_react.default.createElement($e208588d898f6af2$var$_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 4.25H3c-.69 0-1.25.56-1.25 1.25v3.25C1.75 9.44 2.31 10 3 10h1.25m2.5-5.75 5.786-2.314a1.25 1.25 0 0 1 1.714 1.16v8.058a1.25 1.25 0 0 1-1.714 1.16L6.75 10m0-5.75V10m0 0h-2.5m2.5 0v4.25H5.5c-.69 0-1.25-.56-1.25-1.25v-3"/>`
        }, props));
    $e208588d898f6af2$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
    var $e208588d898f6af2$var$_default = module.exports.default = $e208588d898f6af2$var$MegaphoneIcon;
});
parcelRegister("j5Q6Z", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptIn", ()=>$13f1e9a404b61bdc$export$46a00895da9889a2);
    var $4R6GH;
    const $13f1e9a404b61bdc$export$46a00895da9889a2 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4') && $13f1e9a404b61bdc$var$getWillShowNav4UserOptInForExistingCustomers();
    const $13f1e9a404b61bdc$var$getWillShowNav4UserOptInForExistingCustomers = ()=>false;
});
parcelRegister("dkkQn", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptOut", ()=>$1db1544bbdad6d19$export$acb346134ed05173);
    var $4R6GH;
    var $9Qkfw;
    var $d1JDF;
    const $1db1544bbdad6d19$export$acb346134ed05173 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4') && ((0, (0, parcelRequire("9Qkfw")).getWillShowNav4UserOptOutForDogfooding)() || (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap') || (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_existing-customers')) || (0, (0, parcelRequire("d1JDF")).getWillShowNav4UserOptOutForVisualRefresh)();
});
parcelRegister("9Qkfw", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptOutForDogfooding", ()=>$a6cd9fbcbab14454$export$9edbe3a98989e15b);
    var $4R6GH;
    const $a6cd9fbcbab14454$export$9edbe3a98989e15b = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding') && ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-1') || (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-2'));
});
parcelRegister("d1JDF", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptOutForVisualRefresh", ()=>$1ed6defa01bf1a51$export$17e35ae7beae962d);
    var $4R6GH;
    const $1ed6defa01bf1a51$export$17e35ae7beae962d = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh') && ((0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-dogfood') || (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-eap') || (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-beta-existing-customers'));
});
parcelRegister("83YFz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$583ab6a643d91da5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $583ab6a643d91da5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sidebarFeedbackButtonLabel: {
            "id": "sidebar-nav4-feedback-button.sidebar-feedback-button-label",
            "defaultMessage": "Give feedback on the new navigation"
        },
        feedbackTitle: {
            "id": "sidebar-nav4-feedback-button.utils.use-nav4-feedback-collector.feedback-title",
            "defaultMessage": "Help us improve the new navigation"
        },
        feedbackTitleDetailsWithLink: {
            "id": "sidebar-nav4-feedback-button.feedback-title-details",
            "defaultMessage": "We\u2019d love to hear about your experience with the new navigation. If needed, <a>you can switch back to the old navigation</a>."
        },
        feedbackTitleDetailsNoLink: {
            "id": "sidebar-nav4-feedback-button.feedback-title-details-no-link",
            "defaultMessage": "We\u2019d love to hear about your experience with the new navigation."
        }
    });
});
parcelRegister("3AWiS", function(module, exports) {
    $parcel$export(module.exports, "PanelSplitter", ()=>$f535d623adcb2c41$export$db67e3f8d3d6da0f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7nsd3 = parcelRequire("7nsd3");
    var $3joPi = parcelRequire("3joPi");
    var $4hDdm = parcelRequire("4hDdm");
    var $7gWdR = parcelRequire("7gWdR");
    parcelRequire("4dYas");
    var $kLEEo = parcelRequire("kLEEo");
    parcelRequire("hjhoK");
    var $akFFC = parcelRequire("akFFC");
    parcelRequire("fmZmH");
    var $3C4FG = parcelRequire("3C4FG");
    var $5ILhZ;
    var $jldZL;
    var $9NI3h;
    var $fAx1P;
    var $1ICwz;
    const $f535d623adcb2c41$var$containerStyles = {
        root: "_1e0cglyw _kqswstnw _u7coidpf _152tidpf _12ji1r31 _1qu2glyw _12y31o36 _1pbykb7n _181n1ule",
        positionEnd: "_rjxpftgi",
        positionStart: "_1e02zeo2"
    };
    const $f535d623adcb2c41$var$buttonStyles = {
        grabArea: "_1bsbl52n _4t3i1osq _kqswstnw _1yt4ze3t _syaz3acm _bfhk18uv _v5645ge5 _1lww5cps _d0aluf7j _1gavfnf5 _v0vwaqb7 _30l3aqb7 _1gk412xp _o7ks12xp _9h8h16c2 _1gglglyw",
        content: "_1bsb1osq _4t3i1osq"
    };
    const $f535d623adcb2c41$var$lineStyles = {
        root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
    };
    const $f535d623adcb2c41$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, interactionName: interactionName, testId: testId })=>{
        const splitterRef = (0, $5uXOq.useRef)(null);
        const panelSplitterContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("9NI3h")).PanelSplitterContext));
        (0, $3joPi.default)(panelSplitterContext, 'Panel splitter context must be set');
        const { panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef, position: position, isEnabled: isEnabled } = panelSplitterContext;
        (0, $3joPi.default)(portalRef.current, 'Portal ref must be set');
        const direction = (0, (0, parcelRequire("1ICwz")).useTextDirection)(portalRef.current);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const splitter = splitterRef.current;
            (0, $3joPi.default)(splitter, 'Splitter ref must be set');
            return (0, $4hDdm.combine)((0, $kLEEo.blockDraggingToIFrames)({
                element: splitter
            }), (0, $7gWdR.draggable)({
                element: splitter,
                onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                    (0, $akFFC.disableNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage
                    });
                    (0, $3C4FG.preventUnhandled).start();
                },
                getInitialData () {
                    (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                    return {
                        initialWidth: (0, (0, parcelRequire("fAx1P")).getPixelWidth)(panelRef.current)
                    };
                },
                onDragStart ({ source: source }) {
                    (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                    onResizeStart?.({
                        initialWidth: source.data.initialWidth
                    });
                },
                onDrag ({ location: location, source: source }) {
                    (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                    panelRef.current?.style.setProperty(resizingCssVar, `clamp(${resizeBounds.min}, ${(0, (0, parcelRequire("fAx1P")).getWidthFromDragLocation)({
                        initialWidth: source.data.initialWidth,
                        location: location,
                        direction: direction,
                        position: position
                    })}px, ${resizeBounds.max})`);
                },
                onDrop ({ source: source }) {
                    (0, $3C4FG.preventUnhandled).stop();
                    (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                    (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                    const finalWidth = (0, (0, parcelRequire("fAx1P")).getPixelWidth)(panelRef.current);
                    onCompleteResize(finalWidth);
                    onResizeEnd?.({
                        initialWidth: source.data.initialWidth,
                        finalWidth: finalWidth
                    });
                    panelRef.current.style.removeProperty(resizingCssVar);
                }
            }));
        }, [
            onCompleteResize,
            onResizeStart,
            onResizeEnd,
            panelRef,
            resizingCssVar,
            panelWidth,
            resizeBounds,
            direction,
            position,
            isEnabled
        ]);
        if (!isEnabled) return null;
        return (0, $7nsd3.createPortal)($5uXOq.createElement("div", {
            "data-testid": testId ? `${testId}-container` : undefined,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $f535d623adcb2c41$var$containerStyles.root,
                position === 'start' && $f535d623adcb2c41$var$containerStyles.positionStart,
                position === 'end' && $f535d623adcb2c41$var$containerStyles.positionEnd
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("5ILhZ")).default), {
            style: {
                outline: 'none'
            },
            ref: splitterRef,
            xcss: $f535d623adcb2c41$var$buttonStyles.grabArea,
            interactionName: interactionName,
            testId: testId
        }, $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $f535d623adcb2c41$var$buttonStyles.content
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("jldZL")).default), null, label), $5uXOq.createElement("span", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $f535d623adcb2c41$var$lineStyles.root
            ])
        })))), portalRef.current);
    };
    const $f535d623adcb2c41$var$ClientOnly = ({ children: children })=>{
        const [hasMounted, setHasMounted] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            setHasMounted(true);
        }, []);
        return $5uXOq.createElement((0, $5uXOq.Fragment), null, hasMounted ? children : null);
    };
    const $f535d623adcb2c41$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, interactionName: interactionName, testId: testId })=>$5uXOq.createElement($f535d623adcb2c41$var$ClientOnly, null, $5uXOq.createElement($f535d623adcb2c41$var$PortaledPanelSplitter, {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            interactionName: interactionName,
            testId: testId
        }));
});
parcelRegister("4dYas", function(module, exports) {
    $parcel$export(module.exports, "blockDraggingToIFrames", ()=>(parcelRequire("kLEEo")).blockDraggingToIFrames);
    var $kLEEo = parcelRequire("kLEEo");
});
parcelRegister("kLEEo", function(module, exports) {
    $parcel$export(module.exports, "blockDraggingToIFrames", ()=>$85c97841a27447ca$export$6ae1d8fab001518c);
    var $40DDD = parcelRequire("40DDD");
    var $3zl3q = parcelRequire("3zl3q");
    function $85c97841a27447ca$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
        const originalValue = el.style.getPropertyValue(property);
        const originalPriority = el.style.getPropertyPriority(property);
        el.style.setProperty(property, rule, priority);
        return function cleanup() {
            el.style.setProperty(property, originalValue, originalPriority);
        };
    }
    let $85c97841a27447ca$var$isActive = false;
    function $85c97841a27447ca$var$tryStart() {
        if ($85c97841a27447ca$var$isActive) return;
        $85c97841a27447ca$var$isActive = true;
        const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$85c97841a27447ca$var$setStyle(iframe, {
                property: 'pointer-events',
                rule: 'none',
                priority: 'important'
            }));
        const cleanup = (0, $3zl3q.combine)(...iframeCleanups, (0, $40DDD.monitorForElements)({
            onDrop () {
                cleanup();
            }
        }), function release() {
            $85c97841a27447ca$var$isActive = false;
        });
    }
    function $85c97841a27447ca$export$6ae1d8fab001518c({ element: element }) {
        return (0, $40DDD.monitorForElements)({
            onGenerateDragPreview ({ source: source }) {
                if (source.element === element) $85c97841a27447ca$var$tryStart();
            }
        });
    }
});
parcelRegister("hjhoK", function(module, exports) {
    $parcel$export(module.exports, "disableNativeDragPreview", ()=>(parcelRequire("akFFC")).disableNativeDragPreview);
    var $akFFC = parcelRequire("akFFC");
});
parcelRegister("akFFC", function(module, exports) {
    $parcel$export(module.exports, "disableNativeDragPreview", ()=>$1774d76ee1100c7d$export$c588cb30ff3b876e);
    const $1774d76ee1100c7d$var$tinyTransparentImage = (()=>{
        if (typeof window === 'undefined') return null;
        const img = new Image();
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
        return img;
    })();
    function $1774d76ee1100c7d$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
        if (nativeSetDragImage && $1774d76ee1100c7d$var$tinyTransparentImage) nativeSetDragImage($1774d76ee1100c7d$var$tinyTransparentImage, 0, 0);
    }
});
parcelRegister("fmZmH", function(module, exports) {
    $parcel$export(module.exports, "preventUnhandled", ()=>(parcelRequire("3C4FG")).preventUnhandled);
    var $3C4FG = parcelRequire("3C4FG");
});
parcelRegister("3C4FG", function(module, exports) {
    $parcel$export(module.exports, "preventUnhandled", ()=>$bc1937186f99453b$export$453c0582481cc59d);
    var $cBeZP;
    var $h5V4I = parcelRequire("h5V4I");
    function $bc1937186f99453b$var$acceptDrop(event) {
        if (event.defaultPrevented) return;
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        event.preventDefault();
    }
    let $bc1937186f99453b$var$unbindEvents = null;
    function $bc1937186f99453b$var$start() {
        $bc1937186f99453b$var$cleanup();
        $bc1937186f99453b$var$unbindEvents = (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
            {
                type: 'dragover',
                listener: $bc1937186f99453b$var$acceptDrop
            },
            {
                type: 'dragenter',
                listener: $bc1937186f99453b$var$acceptDrop
            },
            {
                type: 'drop',
                listener (event) {
                    event.preventDefault();
                    $bc1937186f99453b$var$cleanup();
                }
            },
            {
                type: 'dragend',
                listener: $bc1937186f99453b$var$cleanup
            },
            ...(0, $h5V4I.getBindingsForBrokenDrags)({
                onDragEnd: $bc1937186f99453b$var$cleanup
            })
        ], {
            capture: false
        });
    }
    function $bc1937186f99453b$var$cleanup() {
        $bc1937186f99453b$var$unbindEvents?.();
        $bc1937186f99453b$var$unbindEvents = null;
    }
    function $bc1937186f99453b$var$stop() {
        if (window.event?.type === 'drop') window.event?.preventDefault();
        $bc1937186f99453b$var$cleanup();
    }
    const $bc1937186f99453b$export$453c0582481cc59d = {
        start: $bc1937186f99453b$var$start,
        stop: $bc1937186f99453b$var$stop
    };
});
parcelRegister("fAx1P", function(module, exports) {
    $parcel$export(module.exports, "getWidthFromDragLocation", ()=>$e9a4e6873a340be1$export$e360234971cb95b8);
    $parcel$export(module.exports, "getPixelWidth", ()=>$e9a4e6873a340be1$export$d942790ad00c41f9);
    const $e9a4e6873a340be1$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
        const diffX = location.current.input.clientX - location.initial.input.clientX;
        if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
        return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
    };
    const $e9a4e6873a340be1$export$d942790ad00c41f9 = (element)=>{
        const { width: width } = window.getComputedStyle(element);
        return parseInt(width);
    };
});
parcelRegister("1ICwz", function(module, exports) {
    $parcel$export(module.exports, "useTextDirection", ()=>$19142174bc5bbe23$export$cf24a79f32f45545);
    var $5uXOq = parcelRequire("5uXOq");
    const $19142174bc5bbe23$export$cf24a79f32f45545 = (element)=>(0, $5uXOq.useMemo)(()=>{
            const { direction: direction } = window.getComputedStyle(element);
            return direction === 'rtl' ? 'rtl' : 'ltr';
        }, [
            element
        ]);
});
parcelRegister("lsO24", function(module, exports) {
    $parcel$export(module.exports, "SideNavFooter", ()=>$c6642da0d03c35b7$export$b773c4c9cf740fbe);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $c6642da0d03c35b7$var$styles = {
        root: "_1yt4utpp _7myae4h9 _1sw7nqa1 _qgnumuej"
    };
    const $c6642da0d03c35b7$export$b773c4c9cf740fbe = ({ children: children, xcss: xcss })=>{
        return $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $c6642da0d03c35b7$var$styles.root,
                xcss
            ])
        }, children);
    };
});
parcelRegister("gxq4u", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$17a71abc75e8d96c$export$defe85febe8b728c);
    var $7VHMR;
    const $17a71abc75e8d96c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sidebarNavigation: {
            "id": "page-container-v2.common.sidebar.sidebar-navigation",
            "defaultMessage": "Sidebar navigation"
        },
        sideBarPanelSplitterLabel: {
            "id": "page-container-v2.common.sidebar.side-bar-panel-splitter-label",
            "defaultMessage": "Resize side navigation panel"
        }
    });
});
parcelRegister("7x18A", function(module, exports) {
    $parcel$export(module.exports, "AsyncResizeButtonTooltip", ()=>$15587b8ab3be3aba$export$e12f5b3a390577de);
    var $kxZPA;
    const $15587b8ab3be3aba$export$e12f5b3a390577de = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("gHSSC")), {
        ssr: false,
        moduleId: "./src/packages/page-container-v2/src/common/ui/sidebar/resize-button-tooltip/main.tsx"
    });
});
parcelRegister("gHSSC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ikCLZ").then(()=>parcelRequire('iIrS6'));
});
parcelRegister("gxCm0", function(module, exports) {
    $parcel$export(module.exports, "TopNav", ()=>$5815562a2673ba2a$export$41d0d88a6b0e456f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5e7oM;
    var $azzrO;
    var $Mp6qH;
    var $ghgbB;
    var $eoNiZ;
    var $e6AHy;
    var $44v1T;
    var $gwIPs;
    var $7CMCs;
    var $93jKl;
    var $7XYc4;
    var $cSD7y;
    var $4R6GH;
    var $3bl6P;
    var $9aaiB;
    var $5X3WH;
    var $3HwlS;
    var $iqLcb;
    var $lfTZh;
    var $5M3R9;
    var $l8ruj;
    var $erBFB;
    var $dm0Uk;
    var $iIpJ6;
    const $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY = 'app_navigation';
    const $5815562a2673ba2a$var$LegacyPageNavigationStyles = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `
                    #page-body { width: 100vw; max-width: 100%; }
                    #cloneissueprogressform { margin-top: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 3}px; }
                    [data-testid="Content"] {margin-top: calc(${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)})!important;}
                    #view-projects-content { margin-top: calc(-1 * ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)}); } /* admin project dir hack */
                `
            }
        });
    const $5815562a2673ba2a$var$TEST_ID = 'page-layout.top-nav';
    function $5815562a2673ba2a$var$NewTopNavWithoutCustomTheming() {
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("9aaiB")).useTopNavState)();
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav_version_exposure')) (0, (0, parcelRequire("5X3WH")).sendNavExposure)({
            componentName: 'nav4'
        });
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.topNav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "topNavigationSkipLink",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).TopNavigationSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).TopNavigation), {
            isFixed: true,
            testId: $5815562a2673ba2a$var$TEST_ID
        }, !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghgbB")).AtlassianNavigationStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "navigation.atlassian-navigation",
            packageName: "jiraPageContainerV2",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).PlaceholderNew), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6AHy")).JiraAtlassianNavigationSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iIpJ6")).AsyncAtlassianNavigation), null)))));
    }
    function $5815562a2673ba2a$var$NewTopNavWithCustomTheming() {
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("9aaiB")).useTopNavState)();
        const theme = (0, (0, parcelRequire("eoNiZ")).useNav4Theme)();
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav_version_exposure')) (0, (0, parcelRequire("5X3WH")).sendNavExposure)({
            componentName: 'nav4'
        });
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.topNav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "topNavigationSkipLink",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).TopNavigationSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).TopNavigation), {
            isFixed: true,
            testId: $5815562a2673ba2a$var$TEST_ID,
            theme: theme
        }, !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghgbB")).AtlassianNavigationStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "navigation.atlassian-navigation",
            packageName: "jiraPageContainerV2",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).PlaceholderNew), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6AHy")).JiraAtlassianNavigationSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iIpJ6")).AsyncAtlassianNavigation), null)))));
    }
    const $5815562a2673ba2a$var$NewTopNav = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_nav4_theming', $5815562a2673ba2a$var$NewTopNavWithCustomTheming, $5815562a2673ba2a$var$NewTopNavWithoutCustomTheming);
    const $5815562a2673ba2a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT = 56;
    function $5815562a2673ba2a$var$OldTopNav() {
        const fullscreenRef = (0, $5uXOq.useRef)(null);
        const { isFullscreen: isFullscreen } = (0, (0, parcelRequire("3bl6P")).useIsFullscreen)(fullscreenRef.current);
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("9aaiB")).useTopNavState)();
        const onFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: (0, (0, parcelRequire("Mp6qH")).EXPERIENCE_NAVIGATION_TOP_MAIN)
        });
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav_version_exposure')) (0, (0, parcelRequire("5X3WH")).sendNavExposure)({
            componentName: 'nav3'
        });
        const height = isFullscreen ? 0 : $5815562a2673ba2a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT;
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "top-navigation"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "topNavigationSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).TopNavigationSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dm0Uk")).ZIndexWrapper), {
            zIndex: (0, (0, parcelRequire("gwIPs")).layers).navigation,
            top: (0, (0, parcelRequire("iqLcb")).UNSAFE_DO_NOT_USE_BANNER_HEIGHT),
            "data-fullscreen-id": "fullscreen.page-container-v2.topnav",
            ref: fullscreenRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).TopNavigation), {
            isFixed: true,
            height: height,
            id: "ak-jira-navigation"
        }, !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghgbB")).AtlassianNavigationStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "navigation.atlassian-navigation",
            packageName: "jiraPageContainer",
            fallback: "flag",
            onError: onFail
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).PlaceholderNew), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6AHy")).JiraAtlassianNavigationSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavTopPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).bundleLoadStart
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavTopSSRPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrStart
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "start",
            traceKey: $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iIpJ6")).AsyncAtlassianNavigation), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "end",
            traceKey: $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavTopSSRPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrEnd
        }))))));
    }
    const $5815562a2673ba2a$export$41d0d88a6b0e456f = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $5815562a2673ba2a$var$NewTopNav, $5815562a2673ba2a$var$OldTopNav);
});
parcelRegister("ghgbB", function(module, exports) {
    $parcel$export(module.exports, "AtlassianNavigationStart", ()=>$d610646e169deef8$export$831e6a6e875b5ef8);
    var $5uXOq = parcelRequire("5uXOq");
    var $kaHBi;
    var $8CVvd;
    var $4oDnX;
    var $6IzHB;
    var $doZTA;
    var $Mp6qH;
    const $d610646e169deef8$export$831e6a6e875b5ef8 = ()=>{
        const [{ location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const [, { setAppStartWithAppId: setAppStartWithAppId }] = (0, (0, parcelRequire("4oDnX")).useSpaStateActions)();
        const pageId = (0, (0, parcelRequire("6IzHB")).usePageId)();
        const startRef = (0, $5uXOq.useRef)({
            location: location,
            startTime: Date.now()
        });
        (0, $5uXOq.useMemo)(()=>{
            if (location !== startRef.current.location) startRef.current = {
                location: location,
                startTime: Date.now()
            };
        }, [
            location
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setAppStartWithAppId((0, $146ecce9d079a34d$export$3a54edb6ba4daa82), startRef.current.startTime);
        }, [
            location,
            setAppStartWithAppId
        ]);
        return (0, (0, parcelRequire("8CVvd")).getWillShowNav3)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaHBi")).ExperienceStart), {
            experience: (0, (0, parcelRequire("Mp6qH")).EXPERIENCE_NAVIGATION_TOP_MAIN),
            analyticsSource: "atlassian-navigation",
            experienceId: pageId
        });
    };
});
parcelRegister("eoNiZ", function(module, exports) {
    $parcel$export(module.exports, "useTheme", ()=>$96d5309c36bfdfee$export$93d4e7f90805808f);
    $parcel$export(module.exports, "useNav4Theme", ()=>$96d5309c36bfdfee$export$b761e7abf0bdf352);
    var $5uXOq = parcelRequire("5uXOq");
    var $4sCvx;
    var $kTHGn;
    var $hxoiH;
    var $9MAC1;
    var $2Ql51;
    var $bt2pf;
    var $ihBhD;
    const $96d5309c36bfdfee$var$caseInsensitiveEquals = (one, two)=>one.toLowerCase() === two.toLowerCase();
    const $96d5309c36bfdfee$var$calculateBackground = (backgroundColor, isDarkMode)=>{
        if ($96d5309c36bfdfee$var$caseInsensitiveEquals(backgroundColor, '#ffffff')) {
            const fallback = isDarkMode ? '#1d2125' : '#ffffff';
            return (0, (0, parcelRequire("kTHGn")).default)('elevation.surface', fallback);
        }
        return isDarkMode ? (0, (0, parcelRequire("ihBhD")).capLightness)(backgroundColor, 35) : backgroundColor;
    };
    const $96d5309c36bfdfee$var$useIsDarkThemeResolver = ()=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        const { theme: preference } = (0, (0, parcelRequire("2Ql51")).useThemePreference)();
        return false ? preference === 'dark' : colorMode === 'dark';
    };
    const $96d5309c36bfdfee$export$93d4e7f90805808f = ()=>{
        const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, (0, parcelRequire("9MAC1")).useTheme)();
        const isDarkMode = $96d5309c36bfdfee$var$useIsDarkThemeResolver();
        const bg = (0, $5uXOq.useMemo)(()=>$96d5309c36bfdfee$var$calculateBackground(backgroundColor, isDarkMode), [
            backgroundColor,
            isDarkMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("bt2pf")).addThemeColor)(bg);
        }, [
            bg
        ]);
        if (!usesCustomColours) return undefined;
        return (0, (0, parcelRequire("4sCvx")).generateTheme)({
            name: 'jira',
            backgroundColor: bg,
            highlightColor: highlightColor
        });
    };
    const $96d5309c36bfdfee$export$b761e7abf0bdf352 = ()=>{
        const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, (0, parcelRequire("9MAC1")).useTheme)();
        const isDarkMode = $96d5309c36bfdfee$var$useIsDarkThemeResolver();
        const bg = (0, $5uXOq.useMemo)(()=>$96d5309c36bfdfee$var$calculateBackground(backgroundColor, isDarkMode), [
            backgroundColor,
            isDarkMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("bt2pf")).addThemeColor)(bg);
        }, [
            bg
        ]);
        if (!usesCustomColours) return undefined;
        return {
            backgroundColor: bg,
            highlightColor: highlightColor
        };
    };
});
parcelRegister("bt2pf", function(module, exports) {
    $parcel$export(module.exports, "addThemeColor", ()=>$274a73c0f1d6297a$export$7b20d133831b2b0f);
    const $274a73c0f1d6297a$var$getMetaNode = (name)=>document.querySelector(`meta[name="${name}"]`);
    const $274a73c0f1d6297a$var$getHead = ()=>document.head || document.querySelector('head');
    const $274a73c0f1d6297a$export$7b20d133831b2b0f = (content)=>{
        if (!content || typeof document === 'undefined' || false) return;
        const existingMeta = $274a73c0f1d6297a$var$getMetaNode('theme-color');
        const meta = document.createElement('meta');
        meta.name = 'theme-color';
        meta.content = content;
        if (existingMeta) existingMeta.replaceWith?.(meta);
        else {
            const head = $274a73c0f1d6297a$var$getHead();
            if (head) head.appendChild?.(meta);
        }
    };
});
parcelRegister("ihBhD", function(module, exports) {
    $parcel$export(module.exports, "capLightness", ()=>$dbd7508aaed6851f$export$8b5544bab97b10dd);
    const $dbd7508aaed6851f$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
    const $dbd7508aaed6851f$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
    const $dbd7508aaed6851f$var$rgbFromHex = (input)=>{
        const fullHex = $dbd7508aaed6851f$var$expandShorthandHex(input);
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
        return result === null ? null : {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        };
    };
    const $dbd7508aaed6851f$var$rgbToHex = ({ r: r, g: g, b: b })=>{
        const convertComponent = (c)=>{
            const cBase16 = c.toString(16);
            return cBase16.length === 1 ? `0${cBase16}` : cBase16;
        };
        return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
    };
    const $dbd7508aaed6851f$var$rgbToXyz = (rgb)=>{
        const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
        const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
        const r = convertRgbComponent(rgb.r / 255);
        const g = convertRgbComponent(rgb.g / 255);
        const b = convertRgbComponent(rgb.b / 255);
        return {
            x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
            y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
            z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
        };
    };
    const $dbd7508aaed6851f$var$xyzToLab = ({ x: x, y: y, z: z })=>({
            l: Math.max(116 * y - 16, 0),
            a: 500 * (x - y),
            b: 200 * (y - z)
        });
    const $dbd7508aaed6851f$var$labToLch = ({ l: l, a: a, b: b })=>{
        let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
        const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
        if (Math.round(c * 10000) === 0) h = Number.NaN;
        return {
            l: l,
            c: c,
            h: h
        };
    };
    const $dbd7508aaed6851f$var$lchToLab = ({ l: l, c: c, h: h })=>{
        const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
        return {
            l: l,
            a: Math.cos(convertH) * c,
            b: Math.sin(convertH) * c
        };
    };
    const $dbd7508aaed6851f$var$labToXyz = ({ l: l, a: a, b: b })=>{
        const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
        const y = (l + 16) / 116;
        const x = a / 500 + y;
        const z = y - b / 200;
        return {
            x: convertComponent(x) * 0.95047,
            y: convertComponent(y),
            z: convertComponent(z) * 1.08883
        };
    };
    const $dbd7508aaed6851f$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
        const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
        return {
            r: $dbd7508aaed6851f$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
            g: $dbd7508aaed6851f$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
            b: $dbd7508aaed6851f$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
        };
    };
    const $dbd7508aaed6851f$var$rgbToLch = (rgb)=>$dbd7508aaed6851f$var$labToLch($dbd7508aaed6851f$var$xyzToLab($dbd7508aaed6851f$var$rgbToXyz(rgb)));
    const $dbd7508aaed6851f$var$lchToRgb = (lch)=>$dbd7508aaed6851f$var$xyzToRgb($dbd7508aaed6851f$var$labToXyz($dbd7508aaed6851f$var$lchToLab(lch)));
    const $dbd7508aaed6851f$export$8b5544bab97b10dd = (color, capPercent)=>{
        const rgb = $dbd7508aaed6851f$var$rgbFromHex(color);
        if (rgb === null) return color;
        const lch = $dbd7508aaed6851f$var$rgbToLch(rgb);
        if (lch.l > capPercent) lch.l = $dbd7508aaed6851f$var$clamp(capPercent, 0, 100);
        return $dbd7508aaed6851f$var$rgbToHex($dbd7508aaed6851f$var$lchToRgb(lch));
    };
});
parcelRegister("e6AHy", function(module, exports) {
    $parcel$export(module.exports, "JiraAtlassianNavigationSkeleton", ()=>$33751c6bf425b3ee$export$38e532bc6b824200);
    var $5uXOq = parcelRequire("5uXOq");
    var $f76p2;
    var $fNobW;
    var $eoNiZ;
    const $33751c6bf425b3ee$export$38e532bc6b824200 = ()=>{
        const theme = (0, (0, parcelRequire("eoNiZ")).useTheme)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "top-navigation"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f76p2")).NavigationSkeleton), {
            theme: theme
        }));
    };
});
parcelRegister("f76p2", function(module, exports) {
    $parcel$export(module.exports, "NavigationSkeleton", ()=>$98921b5eaee337e6$export$ad5e8e6ace98cc2);
    var $f8Sb3;
    var $k2eCO;
    var $hBZh1;
    var $1Gcgr;
    var $29HUs;
    var $PCCxV;
    var $6tzyR;
    var $2yEsI;
    function $98921b5eaee337e6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $98921b5eaee337e6$var$containerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        boxSizing: 'border-box',
        height: (0, $8acc83d90e579622$export$30fa7cc5f2690a43),
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
        borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`}`,
        paddingInlineEnd: "var(--ds-space-150, 12px)",
        paddingInlineStart: "var(--ds-space-150, 12px)"
    });
    const $98921b5eaee337e6$var$leftStyles = {
        name: "vtikxo",
        styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
    };
    const $98921b5eaee337e6$var$rightStyles = {
        name: "1mwlrd6",
        styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
    };
    const $98921b5eaee337e6$export$ad5e8e6ace98cc2 = ({ primaryItemsCount: primaryItemsCount = 4, secondaryItemsCount: secondaryItemsCount = 4, theme: theme = (0, (0, parcelRequire("k2eCO")).defaultTheme), showSiteName: showSiteName = false, shouldShowSearch: shouldShowSearch = true, testId: testId })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hBZh1")).ThemeProvider), {
            value: theme
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.navigation,
            css: $98921b5eaee337e6$var$containerStyles,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $98921b5eaee337e6$var$leftStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1Gcgr")).IconButtonSkeleton), {
            marginLeft: 0,
            marginRight: 5,
            size: 26
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("PCCxV")).ProductHomeSkeleton), {
            showSiteName: showSiteName
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("29HUs")).PrimaryItemsContainerSkeleton), {
            count: primaryItemsCount
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $98921b5eaee337e6$var$rightStyles
        }, shouldShowSearch && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2yEsI")).SearchSkeleton), null), Array.from({
            length: secondaryItemsCount
        }, (_, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1Gcgr")).IconButtonSkeleton), {
                key: index,
                marginLeft: 0,
                marginRight: 4,
                size: 26
            })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6tzyR")).ProfileSkeleton), null))));
    };
    var $98921b5eaee337e6$export$2e2bcd8739ae039 = $98921b5eaee337e6$export$ad5e8e6ace98cc2;
});
const $8acc83d90e579622$export$30fa7cc5f2690a43 = 56;
const $8acc83d90e579622$export$4033a111ca79977d = 1280;
const $8acc83d90e579622$export$24ec62cee78b7042 = 1130;
const $8acc83d90e579622$export$d8bde68ac946124f = '--ds--ans--fbc';
const $8acc83d90e579622$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $8acc83d90e579622$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $8acc83d90e579622$export$d81606c1fc5119bc = '--ds--ans--c';
const $8acc83d90e579622$export$65f656ad520ea71 = '--ds--ans--bc';
parcelRegister("1Gcgr", function(module, exports) {
    $parcel$export(module.exports, "IconButtonSkeleton", ()=>$6478e2d976c97e7a$export$7a24471cb6f25433);
    var $f8Sb3;
    var $gKAEK;
    function $6478e2d976c97e7a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $6478e2d976c97e7a$var$buttonHeight = "var(--ds-space-400, 32px)";
    const $6478e2d976c97e7a$var$skeletonStyles = {
        name: "28gj0e",
        styles: "border-radius:var(--ds-border-radius-circle, 50%);opacity:0.15"
    };
    const $6478e2d976c97e7a$export$7a24471cb6f25433 = ({ className: className, marginLeft: marginLeft, marginRight: marginRight, size: size })=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        const dynamicStyles = {
            marginLeft: typeof marginLeft === 'number' ? marginLeft : "var(--ds-space-050, 4px)",
            marginRight: typeof marginRight === 'number' ? marginRight : 0,
            width: typeof size === 'number' ? size : $6478e2d976c97e7a$var$buttonHeight,
            height: typeof size === 'number' ? size : $6478e2d976c97e7a$var$buttonHeight,
            ...theme.mode.skeleton
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: className,
            style: dynamicStyles,
            css: $6478e2d976c97e7a$var$skeletonStyles
        });
    };
});
parcelRegister("29HUs", function(module, exports) {
    $parcel$export(module.exports, "PrimaryItemsContainerSkeleton", ()=>$72ae9b7bbf3d0bc1$export$fdfc48d2117b79a8);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $bWIvF;
    function $72ae9b7bbf3d0bc1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $72ae9b7bbf3d0bc1$var$primaryButtonSkeletonStyles = {
        name: "yn5kop",
        styles: "margin-inline-end:var(--ds-space-150, 12px);margin-inline-start:var(--ds-space-150, 12px)"
    };
    const $72ae9b7bbf3d0bc1$export$fdfc48d2117b79a8 = (0, $5uXOq.memo)(({ count: count })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, Array.from({
            length: count
        }, (_, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bWIvF")).PrimaryButtonSkeleton), {
                key: index,
                css: $72ae9b7bbf3d0bc1$var$primaryButtonSkeletonStyles
            }))));
});
parcelRegister("bWIvF", function(module, exports) {
    $parcel$export(module.exports, "PrimaryButtonSkeleton", ()=>$4262bf91a1b82d55$export$4bc51fe36728414d);
    var $f8Sb3;
    var $gKAEK;
    const $4262bf91a1b82d55$var$paddingAll = 4;
    const $4262bf91a1b82d55$var$buttonHeight = 32;
    const $4262bf91a1b82d55$var$skeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        width: '68px',
        height: `${$4262bf91a1b82d55$var$buttonHeight - $4262bf91a1b82d55$var$paddingAll * 2.5}px`,
        borderRadius: "var(--ds-border-radius, 4px)",
        opacity: 0.15
    });
    const $4262bf91a1b82d55$export$4bc51fe36728414d = (props)=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.skeleton,
            css: $4262bf91a1b82d55$var$skeletonStyles,
            className: props.className
        });
    };
});
parcelRegister("PCCxV", function(module, exports) {
    $parcel$export(module.exports, "ProductHomeSkeleton", ()=>$10d6b00c8313b481$export$3e79e535d76cce4b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKAEK;
    var $3mMDm;
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
    const $10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
    const $10d6b00c8313b481$var$VAR_SITE_TITLE_BG_COLOR_AFTER = '--site-title-bg-color-after';
    const $10d6b00c8313b481$var$productHomeButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        padding: "var(--ds-space-050, 4px)",
        alignItems: 'center',
        background: 'none',
        border: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        color: 'inherit',
        cursor: 'pointer',
        '&::-moz-focus-inner': {
            border: 0
        },
        '&:first-of-type': {
            marginInlineStart: 0
        },
        '&:active': {
            backgroundColor: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
            boxShadow: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
            color: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
        },
        '&:focus': {
            backgroundColor: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
            boxShadow: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS})`,
            color: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
            outline: 0
        },
        '&:hover': {
            backgroundColor: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
            boxShadow: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
            color: `var(${$10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
        },
        'div&': {
            pointerEvents: 'none'
        },
        [`@media (max-width: ${(0, $8acc83d90e579622$export$4033a111ca79977d) - 0.1}px)`]: {
            margin: `0 ${"var(--ds-space-100, 8px)"}`
        },
        [`@media (min-width: ${0, $8acc83d90e579622$export$4033a111ca79977d}px)`]: {
            margin: `0 ${"var(--ds-space-200, 16px)"}`
        }
    });
    const $10d6b00c8313b481$var$productLogoStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: 120,
        maxWidth: 120,
        height: 24,
        maxHeight: 28,
        opacity: 0.15,
        '& > *': {
            maxHeight: 24
        },
        [`@media (max-width: ${(0, $8acc83d90e579622$export$4033a111ca79977d) - 0.1}px)`]: {
            display: 'none'
        }
    });
    const $10d6b00c8313b481$var$productIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: 28,
        height: 28,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        opacity: 0.15,
        '& > *': {
            maxHeight: 24
        },
        [`@media (min-width: ${0, $8acc83d90e579622$export$4033a111ca79977d}px)`]: {
            display: 'none'
        }
    });
    const $10d6b00c8313b481$var$siteTitleStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: "var(--ds-space-500, 40px)",
        alignItems: 'center',
        backgroundColor: 'transparent',
        marginInlineEnd: "var(--ds-space-050, 4px)",
        marginInlineStart: "var(--ds-space-050, 4px)",
        paddingInlineEnd: "var(--ds-space-200, 16px)",
        '&:after': {
            width: '100%',
            height: 14,
            backgroundColor: `var(${$10d6b00c8313b481$var$VAR_SITE_TITLE_BG_COLOR_AFTER})`,
            borderRadius: "var(--ds-border-radius, 4px)",
            content: '""'
        }
    });
    const $10d6b00c8313b481$export$3e79e535d76cce4b = ({ showSiteName: showSiteName })=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        const primaryButton = theme.mode.primaryButton;
        const productHomeButtonDynamicStyles = (0, (0, parcelRequire("3mMDm")).stripEmptyProperties)({
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
            [$10d6b00c8313b481$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
            [$10d6b00c8313b481$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
        });
        const siteTitleDynamicStyles = {
            borderRight: theme.mode.productHome.borderRight,
            opacity: theme.mode.skeleton.opacity,
            [$10d6b00c8313b481$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: productHomeButtonDynamicStyles,
            css: $10d6b00c8313b481$var$productHomeButtonStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.skeleton,
            css: $10d6b00c8313b481$var$productLogoStyles
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.skeleton,
            css: $10d6b00c8313b481$var$productIconStyles
        })), showSiteName && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: siteTitleDynamicStyles,
            css: $10d6b00c8313b481$var$siteTitleStyles
        }));
    };
});
parcelRegister("6tzyR", function(module, exports) {
    $parcel$export(module.exports, "ProfileSkeleton", ()=>$46f0e835bedc74f2$export$2bab43fd33adda3b);
    var $5uXOq = parcelRequire("5uXOq");
    var $1Gcgr;
    const $46f0e835bedc74f2$export$2bab43fd33adda3b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Gcgr")).IconButtonSkeleton), {
            marginLeft: 6,
            marginRight: 6,
            size: 26
        });
});
parcelRegister("2yEsI", function(module, exports) {
    $parcel$export(module.exports, "SearchSkeleton", ()=>$07e305720ddebdad$export$d8fbade3e5bbb8e0);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKAEK;
    var $1Gcgr;
    const $07e305720ddebdad$var$searchInputContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        marginRight: "var(--ds-space-100, 8px)",
        marginLeft: "var(--ds-space-250, 20px)",
        position: 'relative',
        [`@media (max-width: ${(0, $8acc83d90e579622$export$24ec62cee78b7042) - 1}px)`]: {
            display: 'none !important'
        }
    });
    const $07e305720ddebdad$var$searchInputSkeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        width: '220px',
        height: "var(--ds-space-400, 32px)",
        padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-500, 40px)"}`,
        borderRadius: "var(--ds-border-radius-200, 6px)",
        opacity: 0.15
    });
    const $07e305720ddebdad$var$searchIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [`@media (min-width: ${0, $8acc83d90e579622$export$24ec62cee78b7042}px)`]: {
            display: 'none !important'
        }
    });
    const $07e305720ddebdad$export$d8fbade3e5bbb8e0 = ()=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $07e305720ddebdad$var$searchInputContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.skeleton,
            css: $07e305720ddebdad$var$searchInputSkeletonStyles
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1Gcgr")).IconButtonSkeleton), {
            css: $07e305720ddebdad$var$searchIconStyles,
            marginRight: 5,
            size: 26
        }));
    };
});
parcelRegister("3bl6P", function(module, exports) {
    $parcel$export(module.exports, "useIsFullscreen", ()=>$0124d1f81a2437a4$export$d397eccea5f37b0a);
    var $5uXOq = parcelRequire("5uXOq");
    const $0124d1f81a2437a4$var$fullscreenClassnameExists = (target)=>target?.classList.contains('fullscreen') ?? false;
    const $0124d1f81a2437a4$export$d397eccea5f37b0a = (target)=>{
        const [isFullscreen, setIsFullscreen] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            const handleFullscreen = ()=>{
                setIsFullscreen($0124d1f81a2437a4$var$fullscreenClassnameExists(target));
            };
            const mutationObserver = new MutationObserver(handleFullscreen);
            if (target) mutationObserver.observe(target, {
                attributes: true
            });
            return ()=>mutationObserver.disconnect();
        }, [
            target
        ]);
        return {
            isFullscreen: isFullscreen
        };
    };
});
parcelRegister("9aaiB", function(module, exports) {
    $parcel$export(module.exports, "useTopNavState", ()=>$dd484d7e2bde5991$export$bccbd45ab793bd09);
    var $3sQ5x;
    var $5e5zm;
    const $dd484d7e2bde5991$var$useTopNav = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>({
                ...state.topNavigation,
                shouldRender: !state.isChromeless
            })
    });
    const $dd484d7e2bde5991$export$bccbd45ab793bd09 = ()=>{
        const [state] = $dd484d7e2bde5991$var$useTopNav();
        return state;
    };
});
parcelRegister("5X3WH", function(module, exports) {
    $parcel$export(module.exports, "sendNavExposure", ()=>$f4ce7b379b641f97$export$4d75b96ec704d87d);
    var $gJBT6 = parcelRequire("gJBT6");
    var $fjcgS;
    const $f4ce7b379b641f97$export$4d75b96ec704d87d = (0, ($parcel$interopDefault($gJBT6)))($f4ce7b379b641f97$var$_sendNavExposure, (p)=>p.componentName);
    function $f4ce7b379b641f97$var$_sendNavExposure(params) {
        const { componentName: componentName } = params;
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.getInstance().sendTrackEvent({
                actionSubject: componentName,
                action: 'viewed',
                source: 'navExposure',
                attributes: {}
            });
        });
        return componentName;
    }
});
parcelRegister("iIpJ6", function(module, exports) {
    $parcel$export(module.exports, "AsyncAtlassianNavigation", ()=>$8c4a7263d22ebdbf$export$932edb7b1b20d079);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $adY3A;
    var $ffza4;
    var $e6AHy;
    var $fDtbf;
    var $2Ioew;
    var $frBVt;
    var $6jY6G;
    var $2SVPM;
    const $8c4a7263d22ebdbf$export$932edb7b1b20d079 = ()=>{
        const isUsingEntryPoint = Boolean((0, (0, parcelRequire("6jY6G")).useCurrentRoute)().entryPoint?.());
        const topNavEntryPointReference = (0, (0, parcelRequire("2Ioew")).usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae));
        (0, $5uXOq.useState)(()=>{
            if (!false && isUsingEntryPoint) (0, (0, parcelRequire("adY3A")).topNavigationEntryPoint).root.onComplete(()=>{
                (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
                const resources = performance.getEntriesByType('mark');
                for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))) {
                    (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                    break;
                }
            });
            return undefined;
        });
        return isUsingEntryPoint ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholder), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6AHy")).JiraAtlassianNavigationSkeleton), null),
            entryPoint: (0, (0, parcelRequire("adY3A")).topNavigationEntryPoint)
        }, topNavEntryPointReference ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: topNavEntryPointReference,
            props: {}
        }) : null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation), null);
    };
});
parcelRegister("lvpKt", function(module, exports) {
    $parcel$export(module.exports, "FullHeight", ()=>$c63a700e8bea75a2$export$33e617ec5e4e4f76);
    var $5uXOq = parcelRequire("5uXOq");
    const $c63a700e8bea75a2$var$styleFullHeight = {
        height: '100vh'
    };
    const $c63a700e8bea75a2$export$33e617ec5e4e4f76 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: $c63a700e8bea75a2$var$styleFullHeight
        }, children);
});
parcelRegister("8Ceqd", function(module, exports) {
    $parcel$export(module.exports, "ThemeSetter", ()=>$5b61f4226ddd6087$export$ce1303eaa27a0d3a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7TUFF;
    var $hxoiH;
    var $fjcgS;
    var $dZJHS;
    var $2Ql51;
    var $2YP9W;
    const $5b61f4226ddd6087$var$darkThemeMediaMatchQuery = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
    const $5b61f4226ddd6087$var$GlobalThemeSetter = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("2Ql51")).themePreferenceResource));
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        const [isThemeStylesInHead, setIsThemeStylesInHead] = (0, $5uXOq.useState)(false);
        const setThemeWithToken = (0, $5uXOq.useCallback)(async (theme)=>{
            if (theme !== colorMode) {
                const { loadThemeTokens: loadThemeTokens } = await (parcelRequire("hxMHI"));
                loadThemeTokens(theme);
            }
        }, [
            colorMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loading || error || !data) return undefined;
            if (data?.theme === 'auto') {
                setThemeWithToken($5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light');
                const handler = (e)=>{
                    setThemeWithToken(e.matches ? 'dark' : 'light');
                };
                $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.addEventListener('change', handler);
                return ()=>{
                    $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.removeEventListener('change', handler);
                };
            }
            if (data?.theme === 'dark' || data?.theme === 'light') setThemeWithToken(data?.theme);
            if (!data?.theme) {
                document.documentElement.removeAttribute('data-theme');
                document.documentElement.removeAttribute('data-color-mode');
            }
            return undefined;
        }, [
            data,
            loading,
            error,
            setThemeWithToken
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loading || error || !data) return;
            (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                if (data?.theme) client.setUIViewedAttributes({
                    theme: data.theme
                });
                else client.removeUIViewedAttribute('theme');
            });
        }, [
            data,
            loading,
            error
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                client.setUIViewedAttributes({
                    OStheme: $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light'
                });
            });
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (document.head.querySelector('style[data-theme]')) setIsThemeStylesInHead(true);
        }, []);
        if (!data?.theme || !data?.attrs || !data?.styles) return null;
        const ssrAutoScript = (0, (0, parcelRequire("7TUFF")).default)(data.theme);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !isThemeStylesInHead ? data.styles.map((theme)=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
                key: theme.id,
                ...theme.attrs,
                dangerouslySetInnerHTML: {
                    __html: theme.css
                }
            })) : null, (0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            "data-defer-skip": true,
            dangerouslySetInnerHTML: {
                __html: data.styles.map((theme)=>`document.head.appendChild(document.body.querySelector('style[data-theme="${theme.id}"]'));`).join('\n')
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            "data-defer-skip": true,
            dangerouslySetInnerHTML: {
                __html: Object.entries(data.attrs).map(([key, val])=>{
                    if (key === 'data-color-mode' && ssrAutoScript) return '';
                    return `document.documentElement.setAttribute("${key}", "${val}");`;
                }).join('\n')
            }
        }), ssrAutoScript ? (0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            "data-defer-skip": true,
            dangerouslySetInnerHTML: {
                __html: ssrAutoScript
            }
        }) : null);
    };
    const $5b61f4226ddd6087$export$ce1303eaa27a0d3a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($5b61f4226ddd6087$var$GlobalThemeSetter, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZJHS")).ThemeSetter), null));
});
parcelRegister("7TUFF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$359254c929f8c357$export$2e2bcd8739ae039);
    var $VSDnB;
    var $f8twK;
    var $caSeK;
    const $359254c929f8c357$var$getSSRAutoScript = (colorMode, contrastMode)=>{
        if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
        const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, (0, parcelRequire("caSeK")).darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, (0, parcelRequire("f8twK")).COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
        const setContrastMode = contrastMode === 'auto' && (0, (0, parcelRequire("VSDnB")).fg)('platform_increased-contrast-themes') ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, (0, parcelRequire("caSeK")).moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, (0, parcelRequire("f8twK")).CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
        return `(() => {${setColorMode}${setContrastMode}})()`;
    };
    var $359254c929f8c357$export$2e2bcd8739ae039 = $359254c929f8c357$var$getSSRAutoScript;
});
parcelRegister("dZJHS", function(module, exports) {
    $parcel$export(module.exports, "ThemeSetter", ()=>$724d37049e8e9e6c$export$ce1303eaa27a0d3a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7eveN;
    var $ceKVk;
    var $65Ltd;
    var $3HwlS;
    var $6jY6G;
    var $dC4s3;
    var $1MaBz;
    const $724d37049e8e9e6c$export$ce1303eaa27a0d3a = ()=>{
        const projectTheme = (0, (0, parcelRequire("ceKVk")).useProjectTheme)();
        const overviewTheme = (0, (0, parcelRequire("7eveN")).useOverviewTheme)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const entityTheme = (0, $5uXOq.useMemo)(()=>{
            let result = projectTheme ?? overviewTheme;
            if (result != null) {
                const isFormSubmitView = route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT) || route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED);
                if (isFormSubmitView) result = {
                    ...result,
                    themeSetting: null
                };
            }
            return result;
        }, [
            projectTheme,
            overviewTheme,
            route.name
        ]);
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1MaBz")).ThemeContainer), {
            isGlobal: true,
            entityTheme: entityTheme
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC4s3")).ThemeTokensSetter), null));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, entityTheme != null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1MaBz")).ThemeContainerOld), {
            isGlobal: true,
            ...entityTheme
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC4s3")).ThemeTokensSetter), null));
    };
});
parcelRegister("7eveN", function(module, exports) {
    $parcel$export(module.exports, "useOverviewTheme", ()=>$c0a2b1dfc34915dc$export$a55763fd17eab357);
    var $6cG4N;
    var $jrO9m;
    const $c0a2b1dfc34915dc$export$a55763fd17eab357 = ()=>{
        const { data: data } = (0, (0, parcelRequire("jrO9m")).useOverview)();
        if (data != null) return {
            themeSetting: {
                type: 'color',
                value: data.theme ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name
            },
            entityId: `overview/${data.id}`
        };
        return null;
    };
});
parcelRegister("ceKVk", function(module, exports) {
    $parcel$export(module.exports, "useProjectTheme", ()=>$f0c1f93a3181b765$export$18084206b9430153);
    var $5uXOq = parcelRequire("5uXOq");
    var $6cG4N;
    var $l2N2a;
    var $2YP9W;
    const $f0c1f93a3181b765$export$18084206b9430153 = ()=>{
        const { data: data } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("l2N2a")).projectDetailsResource));
        return (0, $5uXOq.useMemo)(()=>{
            if (data != null) {
                const entityId = `project/${data.currentProject?.id}`;
                const themeSetting = data.themeSetting ?? {
                    type: 'color',
                    value: (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name
                };
                return {
                    themeSetting: themeSetting,
                    entityId: entityId
                };
            }
            return null;
        }, [
            data
        ]);
    };
});
parcelRegister("dC4s3", function(module, exports) {
    $parcel$export(module.exports, "ThemeTokensSetter", ()=>$5026069bddf1adf4$export$41f41c7ff10d45cd);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UikQ = parcelRequire("1UikQ");
    var $gwIPs;
    var $6cG4N;
    var $fHEdP;
    var $4R6GH;
    var $3HwlS;
    var $1MaBz;
    var $1r9V3;
    function $5026069bddf1adf4$var$mergeThemes(theme, ...partialThemes) {
        return (0, ($parcel$interopDefault($1UikQ)))({}, theme, ...partialThemes);
    }
    const $5026069bddf1adf4$var$buildHorizontalNavVariables = (theme)=>{
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return `${0, $5b25b2eb4e8be764$export$539c074adec2188a}: ${theme['color.link']};
${0, $5b25b2eb4e8be764$export$1cfe9795423425c}: ${theme['color.background.neutral.hovered']};
${0, $5b25b2eb4e8be764$export$6f76912df5477959}: ${theme['color.link.pressed']};
${0, $5b25b2eb4e8be764$export$fac615ceaa871e35}: ${theme['color.text.subtle']};
${0, $5b25b2eb4e8be764$export$7748fdcd335afdc0}: ${theme['color.text']};
${0, $5b25b2eb4e8be764$export$88e550ed188132a7}: ${theme['color.elevation.surface']};
${0, $5b25b2eb4e8be764$export$e2e8fadb946a45d2}: ${theme['color.border.selected']};
${0, $5b25b2eb4e8be764$export$4cd72d361867c565}: ${theme['color.border']};
${0, $5b25b2eb4e8be764$export$be4d7e23cb48401e}:  ${theme['color.background.neutral']};`;
        return '';
    };
    const $5026069bddf1adf4$var$buildThemeVariables = (config, backgroundImageUrl, isDarkMode)=>{
        const applicationColorMode = isDarkMode ? 'dark' : 'light';
        const brightnessOverrides = config.brightness === 'high' && !isDarkMode ? (0, (0, parcelRequire("6cG4N")).HIGH_BRIGHTNESS_THEME) : (0, (0, parcelRequire("6cG4N")).LOW_BRIGHTNESS_THEME);
        const isImageConfig = config.name === 'image';
        const isGradientConfig = (0, (0, parcelRequire("fHEdP")).themeManager).isGradientTheme(config.name);
        const theme = $5026069bddf1adf4$var$mergeThemes((0, (0, parcelRequire("6cG4N")).BASE_THEME), isImageConfig ? {} : brightnessOverrides, isGradientConfig ? (0, (0, parcelRequire("6cG4N")).GRADIENT_THEME) : {}, config.theme[applicationColorMode]);
        let elevationSurface = theme['elevation.surface'] ?? theme['color.elevation.surface'];
        if (backgroundImageUrl) elevationSurface = `url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
        else if (applicationColorMode === 'dark') {
            if ((0, (0, parcelRequire("6cG4N")).NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig) elevationSurface = `linear-gradient(180deg, ${theme['color.elevation.surface']} 0%, ${"var(--ds-surface, #1D2125)"} 400px)`;
        }
        const withWrapper = config.name !== (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name;
        const wrapperBackground = withWrapper ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'unset';
        const wrapperBorderRadius = withWrapper ? `${0, (0, parcelRequire("gwIPs")).gridSize}px` : '0';
        const isNav4 = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
        const businessWrapperWithBackgroundHeight = isNav4 ? (0, (0, parcelRequire("4R6GH")).fg)('horizontal_navigation_increase_tab_height') ? (0, (0, parcelRequire("6cG4N")).NAV4_HIGH_TAB_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, (0, parcelRequire("6cG4N")).NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT);
        const businessWrapperHeight = isNav4 ? (0, (0, parcelRequire("4R6GH")).fg)('horizontal_navigation_increase_tab_height') ? (0, (0, parcelRequire("6cG4N")).NAV4_HIGH_TAB_BUSINESS_WRAPPER_HEIGHT) : (0, (0, parcelRequire("6cG4N")).NAV4_BUSINESS_WRAPPER_HEIGHT) : (0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_HEIGHT);
        const wrapperHeight = withWrapper ? businessWrapperWithBackgroundHeight : businessWrapperHeight;
        const wrapperPadding = withWrapper ? `${0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_PADDING}px` : '0';
        const wrapperWidth = withWrapper ? (0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH) : (0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_WIDTH);
        return `
${(0, (0, parcelRequire("6cG4N")).Variables).BACKDROP_FILTER}: ${isImageConfig ? 'blur(8px)' : 'none'};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_BRAND_BOLD}: ${theme['color.background.brand.bold']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_BRAND_BOLD_HOVERED}: ${theme['color.background.brand.bold.hovered']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_BRAND_BOLD_PRESSED}: ${theme['color.background.brand.bold.pressed']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_DISABLED}: ${theme['color.background.disabled']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_INPUT}: ${theme['color.background.input']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL}: ${theme['color.background.neutral']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL_HOVERED}: ${theme['color.background.neutral.hovered']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL_PRESSED}: ${theme['color.background.neutral.pressed']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED}: ${theme['color.background.neutral.subtle.hovered']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED}: ${theme['color.background.neutral.subtle.pressed']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_SELECTED}: ${theme['color.background.selected']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BORDER}: ${theme['color.border']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BORDER_INPUT}: ${theme['color.border.input']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BORDER_INVERSE}: ${theme['color.border.inverse']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BORDER_SELECTED}: ${theme['color.border.selected']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ELEVATION_SURFACE}: ${theme['color.elevation.surface']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ICON_DANGER}: ${theme['color.icon.danger']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ICON_INFORMATION}: ${theme['color.icon.information']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ICON_SUCCESS}: ${theme['color.icon.success']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ICON_WARNING}: ${theme['color.icon.warning']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_LINK}: ${theme['color.link']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_LINK_PRESSED}: ${theme['color.link.pressed']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_SKELETON}: ${theme['color.skeleton']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT}: ${theme['color.text']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_DISABLED}: ${theme['color.text.disabled']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_INVERSE}: ${theme['color.text.inverse']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_SELECTED}: ${theme['color.text.selected']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_SUBTLE}: ${theme['color.text.subtle']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_SUBTLEST}: ${theme['color.text.subtlest']};
${(0, (0, parcelRequire("6cG4N")).Variables).CONTENT_HEIGHT}: ${businessWrapperHeight};
${(0, (0, parcelRequire("6cG4N")).Variables).CONTENT_WIDTH}: ${0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_WIDTH};
${(0, (0, parcelRequire("6cG4N")).Variables).ELEVATION_SURFACE}: ${elevationSurface};
${(0, (0, parcelRequire("6cG4N")).Variables).ELEVATION_SURFACE_CONTRAST}: ${theme['elevation.surface.contrast']};
${(0, (0, parcelRequire("6cG4N")).Variables).ELEVATION_SURFACE_CONTRAST_BOLDER}: ${theme['elevation.surface.contrast.bolder']};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_BACKGROUND}: ${wrapperBackground};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_BORDER_RADIUS}: ${wrapperBorderRadius};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_HEIGHT}: ${wrapperHeight};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_PADDING}: ${wrapperPadding};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_WIDTH}: ${wrapperWidth};
${$5026069bddf1adf4$var$buildHorizontalNavVariables(theme)}`;
    };
    const $5026069bddf1adf4$export$41f41c7ff10d45cd = (0, $5uXOq.memo)(()=>{
        const [{ themeSetting: themeSetting }] = (0, (0, parcelRequire("1MaBz")).useThemeHook)();
        const backgroundConfig = (0, (0, parcelRequire("fHEdP")).themeManager).get({
            themeSetting: themeSetting,
            enableImages: true
        });
        const backgroundImageUrl = (0, (0, parcelRequire("1r9V3")).useBackgroundImageUrl)(themeSetting);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `:root{ ${$5026069bddf1adf4$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, false)} }
        [data-color-mode=dark]{ ${$5026069bddf1adf4$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, true)} }`
            }
        }));
    });
});
parcelRegister("fHEdP", function(module, exports) {
    $parcel$export(module.exports, "themeManager", ()=>$a34e148e1f33a06a$export$aba92a7f3273f617);
    $parcel$export(module.exports, "generateMediaImageUrl", ()=>$a34e148e1f33a06a$export$fe2402bbc6ac3125);
    var $6cG4N;
    class $a34e148e1f33a06a$var$ThemeManager {
        init() {
            (0, (0, parcelRequire("6cG4N")).GRADIENT_BACKGROUND_CONFIGS).forEach((theme)=>{
                this.gradients.set(theme.name, theme);
                this.gradientNames.add(theme.name);
            });
            (0, (0, parcelRequire("6cG4N")).SOLID_COLOR_BACKGROUND_CONFIGS).forEach((theme)=>{
                this.colors.set(theme.name, theme);
                this.colorNames.add(theme.name);
            });
            (0, (0, parcelRequire("6cG4N")).BACKGROUND_CONFIGS_OLD).forEach((theme)=>{
                this.oldColorNames.add(theme.name);
            });
        }
        isColorTheme(themeName) {
            return this.colorNames.has(themeName);
        }
        isOldColorTheme(themeName) {
            return this.oldColorNames.has(themeName);
        }
        isGradientTheme(themeName) {
            return this.gradientNames.has(themeName);
        }
        isImageTheme(themeSetting) {
            return themeSetting.type === 'image';
        }
        getGradient(themeName) {
            return this.gradients.get(themeName);
        }
        getColor(themeName) {
            return this.colors.get(themeName);
        }
        get({ themeSetting: themeSetting, enableImages: enableImages }) {
            if (!themeSetting) return 0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG;
            if (enableImages && themeSetting.type === 'image') return 0, (0, parcelRequire("6cG4N")).IMAGE_BACKGROUND_CONFIG;
            if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG);
            if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG);
            return ((0, (0, parcelRequire("6cG4N")).OLD_TO_NEW_BACKGROUND_CONFIG_MAP)[themeSetting.value] ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG));
        }
        constructor(){
            this.gradients = new Map();
            this.gradientNames = new Set();
            this.colors = new Map();
            this.colorNames = new Set();
            this.oldColorNames = new Set();
            this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isOldColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
        }
    }
    const $a34e148e1f33a06a$export$aba92a7f3273f617 = new $a34e148e1f33a06a$var$ThemeManager();
    $a34e148e1f33a06a$export$aba92a7f3273f617.init();
    function $a34e148e1f33a06a$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
        const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
        url.searchParams.append('client', mediaClientId);
        Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
        return url.toString();
    }
});
parcelRegister("1MaBz", function(module, exports) {
    $parcel$export(module.exports, "ThemeContainerOld", ()=>$5ffb1b62a0c37aa6$export$c6e50a832af54243);
    $parcel$export(module.exports, "ThemeContainer", ()=>$5ffb1b62a0c37aa6$export$11eb671888ed6e7d);
    $parcel$export(module.exports, "useThemeHook", ()=>$5ffb1b62a0c37aa6$export$b95ba2c6b597cfbb);
    $parcel$export(module.exports, "useThemeSetting", ()=>$5ffb1b62a0c37aa6$export$87d26f94ea053d38);
    $parcel$export(module.exports, "useSelectedThemeSetting", ()=>$5ffb1b62a0c37aa6$export$4ba6f9d407e18961);
    var $ajpes = parcelRequire("ajpes");
    var $fHEdP;
    var $gg7kZ;
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    const $5ffb1b62a0c37aa6$var$setTheme = (newTheme)=>({ getState: getState, setState: setState })=>{
            const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
            if ((0, (0, parcelRequire("fHEdP")).themeManager).isValidTheme(newTheme) && !(0, ($parcel$interopDefault($ajpes)))(themeSetting?.value, newTheme?.value)) setState({
                entityId: entityId,
                selectedThemeSetting: selectedThemeSetting,
                themeSetting: newTheme
            });
        };
    const $5ffb1b62a0c37aa6$var$setSelectedThemeSetting = (newTheme)=>({ getState: getState, setState: setState })=>{
            const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
            if (newTheme === null || (0, (0, parcelRequire("fHEdP")).themeManager).isValidTheme(newTheme) && !(0, ($parcel$interopDefault($ajpes)))(selectedThemeSetting?.type === 'image' ? selectedThemeSetting?.id : selectedThemeSetting?.value, newTheme?.type === 'image' ? newTheme?.id : newTheme?.value)) setState({
                entityId: entityId,
                themeSetting: themeSetting,
                selectedThemeSetting: newTheme
            });
        };
    const $5ffb1b62a0c37aa6$var$actions = {
        setTheme: $5ffb1b62a0c37aa6$var$setTheme,
        setSelectedThemeSetting: $5ffb1b62a0c37aa6$var$setSelectedThemeSetting
    };
    const $5ffb1b62a0c37aa6$var$initialState = {
        themeSetting: null,
        selectedThemeSetting: null,
        entityId: ''
    };
    const $5ffb1b62a0c37aa6$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $5ffb1b62a0c37aa6$var$initialState,
        actions: $5ffb1b62a0c37aa6$var$actions,
        name: 'ProjectTheme'
    });
    const $5ffb1b62a0c37aa6$export$c6e50a832af54243 = (0, (0, parcelRequire("gg7kZ")).createContainer)($5ffb1b62a0c37aa6$var$Store, {
        onInit: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme),
        onUpdate: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme)
    });
    const $5ffb1b62a0c37aa6$export$11eb671888ed6e7d = (0, (0, parcelRequire("gg7kZ")).createContainer)($5ffb1b62a0c37aa6$var$Store, {
        onInit: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
                setState(entityTheme ?? $5ffb1b62a0c37aa6$var$initialState);
            },
        onUpdate: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
                setState(entityTheme ?? $5ffb1b62a0c37aa6$var$initialState);
            }
    });
    const $5ffb1b62a0c37aa6$export$b95ba2c6b597cfbb = (0, (0, parcelRequire("3sQ5x")).createHook)($5ffb1b62a0c37aa6$var$Store);
    const $5ffb1b62a0c37aa6$var$getThemeSetting = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.themeSetting, (themeSetting)=>themeSetting);
    const $5ffb1b62a0c37aa6$export$87d26f94ea053d38 = (0, (0, parcelRequire("3sQ5x")).createHook)($5ffb1b62a0c37aa6$var$Store, {
        selector: $5ffb1b62a0c37aa6$var$getThemeSetting
    });
    const $5ffb1b62a0c37aa6$var$getSelectedThemeSetting = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.selectedThemeSetting, (selectedThemeSetting)=>selectedThemeSetting);
    const $5ffb1b62a0c37aa6$export$4ba6f9d407e18961 = (0, (0, parcelRequire("3sQ5x")).createHook)($5ffb1b62a0c37aa6$var$Store, {
        selector: $5ffb1b62a0c37aa6$var$getSelectedThemeSetting
    });
});
const $5b25b2eb4e8be764$export$d1b9ea3245b6a5de = 2;
const $5b25b2eb4e8be764$export$7f37240649d2a1e2 = 36;
const $5b25b2eb4e8be764$export$d07bba395c9390f1 = 56;
const $5b25b2eb4e8be764$export$29911ec08ab2ca2d = 5;
const $5b25b2eb4e8be764$export$b61e6f89a9db76de = 12;
const $5b25b2eb4e8be764$export$7fd2e391116c6ef5 = 9;
const $5b25b2eb4e8be764$export$e1633e494d305bfb = 'MORE';
const $5b25b2eb4e8be764$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $5b25b2eb4e8be764$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $5b25b2eb4e8be764$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $5b25b2eb4e8be764$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $5b25b2eb4e8be764$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $5b25b2eb4e8be764$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $5b25b2eb4e8be764$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $5b25b2eb4e8be764$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $5b25b2eb4e8be764$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $5b25b2eb4e8be764$export$cf26c31143daa350 = '--hn-yjlbv';
parcelRegister("1r9V3", function(module, exports) {
    $parcel$export(module.exports, "useBackgroundImageUrl", ()=>$e9bd8754684007f4$export$16f28a2a10ece447);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $fHEdP;
    var $jcw0u;
    var $fZneA;
    var $l2N2a;
    var $azoug;
    const $e9bd8754684007f4$export$16f28a2a10ece447 = (themeSetting)=>{
        (0, (0, parcelRequire("gKZoD")).di)(URL, fetch);
        const media = (0, (0, parcelRequire("l2N2a")).useMediaConfiguration)();
        const lowResUrl = (0, $5uXOq.useMemo)(()=>media && themeSetting?.type === 'image' ? (0, (0, parcelRequire("fHEdP")).generateMediaImageUrl)({
                mediaClientId: media.clientId,
                mediaExternalEndpointUrl: media.externalEndpointUrl,
                mediaApiFileId: themeSetting.mediaApiFileId,
                token: themeSetting.mediaReadToken,
                mediaEndpoint: 'image',
                width: 1000,
                'max-age': Number.MAX_SAFE_INTEGER
            }) : null, [
            media,
            themeSetting
        ]);
        const [imageUrl, setImageUrl] = (0, $5uXOq.useState)(lowResUrl);
        const currentThemeId = (0, $5uXOq.useRef)(null);
        currentThemeId.current = themeSetting?.type === 'image' ? themeSetting.id : null;
        (0, $5uXOq.useEffect)(()=>{
            setImageUrl(lowResUrl);
            if (!media || themeSetting?.type !== 'image') return;
            const binaryUrl = (0, (0, parcelRequire("fHEdP")).generateMediaImageUrl)({
                mediaClientId: media.clientId,
                mediaExternalEndpointUrl: media.externalEndpointUrl,
                mediaApiFileId: themeSetting.mediaApiFileId,
                mediaEndpoint: 'binary',
                'max-age': Number.MAX_SAFE_INTEGER
            });
            fetch(binaryUrl.toString(), {
                headers: {
                    Authorization: `Bearer ${themeSetting.mediaReadToken}`
                }
            }).then((response)=>response.blob()).then((blob)=>{
                const objectUrl = URL.createObjectURL(blob);
                if (currentThemeId.current === themeSetting.id) {
                    setImageUrl(objectUrl);
                    if (themeSetting.sourceType === 'UNSPLASH' && themeSetting.sourceIdentifier) (0, (0, parcelRequire("azoug")).unsplashTracker).trackImage(themeSetting.sourceIdentifier);
                }
            }).catch((error)=>{
                if (!(0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchBinaryBackgroundImage',
                        packageName: 'jiraProjectThemeComponents',
                        teamName: 'work-management-frontier'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }, [
            themeSetting,
            media,
            lowResUrl
        ]);
        return imageUrl;
    };
});
parcelRegister("azoug", function(module, exports) {
    $parcel$export(module.exports, "unsplashTracker", ()=>$959ca91ba94e3a4e$export$1869e04dbed4c16c);
    var $azYnG = parcelRequire("azYnG");
    var $lFKmC = parcelRequire("lFKmC");
    const $959ca91ba94e3a4e$var$APP_ID = '7066';
    const $959ca91ba94e3a4e$export$ca6dda5263526f75 = `https://views.unsplash.com/v?app_id=${$959ca91ba94e3a4e$var$APP_ID}`;
    const $959ca91ba94e3a4e$var$MAX_URL_LENGTH = 2083;
    const $959ca91ba94e3a4e$var$ID_LENGTH = 12;
    const $959ca91ba94e3a4e$export$28219189b23a0628 = Math.floor($959ca91ba94e3a4e$var$MAX_URL_LENGTH / $959ca91ba94e3a4e$var$ID_LENGTH);
    class $959ca91ba94e3a4e$var$UnsplashTracker {
        send() {
            if (this.queue.size === 0) return;
            const imageIds = Array.from(this.queue);
            this.queue.clear();
            (0, ($parcel$interopDefault($azYnG)))(imageIds, $959ca91ba94e3a4e$export$28219189b23a0628).forEach((chunkIds)=>{
                const url = `${$959ca91ba94e3a4e$export$ca6dda5263526f75}&photoId=${chunkIds.join(',')}`;
                const now = new Date();
                imageIds.forEach((imageId)=>{
                    this.trackedImages.set(imageId, now);
                });
                const handleFailure = ()=>{
                    imageIds.forEach((imageId)=>{
                        this.queue.add(imageId);
                        this.trackedImages.delete(imageId);
                    });
                };
                fetch(url).then((response)=>{
                    if (!response.ok) handleFailure();
                }).catch(()=>handleFailure());
            });
        }
        trackImage(sourceIdentifier) {
            const imageId = sourceIdentifier.split('-').pop();
            if (!imageId) return;
            const lastTracked = this.trackedImages.get(imageId);
            if (lastTracked && Date.now() - lastTracked.getTime() < this.trackingInterval) return;
            this.queue.add(imageId);
            this.sendDebounced();
        }
        trackWhileInViewport(element, sourceIdentifier) {
            let trackIntervalId = null;
            const observer = new IntersectionObserver((entry)=>{
                if (entry[0].isIntersecting && !trackIntervalId) {
                    $959ca91ba94e3a4e$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                    trackIntervalId = window.setInterval(()=>{
                        $959ca91ba94e3a4e$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                    }, this.trackingInterval + 10);
                } else if (trackIntervalId) window.clearInterval(trackIntervalId);
            }, {
                rootMargin: '0px',
                threshold: 1.0
            });
            observer.observe(element);
            return ()=>{
                observer.disconnect();
                if (trackIntervalId) window.clearInterval(trackIntervalId);
            };
        }
        static getInstance() {
            if (!$959ca91ba94e3a4e$var$UnsplashTracker.instance) $959ca91ba94e3a4e$var$UnsplashTracker.instance = new $959ca91ba94e3a4e$var$UnsplashTracker();
            return $959ca91ba94e3a4e$var$UnsplashTracker.instance;
        }
        constructor(){
            this.trackedImages = new Map();
            this.trackingInterval = 600000;
            this.queue = new Set();
            this.sendDebounced = (0, ($parcel$interopDefault($lFKmC)))(this.send, 1000);
        }
    }
    const $959ca91ba94e3a4e$export$1869e04dbed4c16c = $959ca91ba94e3a4e$var$UnsplashTracker.getInstance();
});
parcelRegister("azYnG", function(module, exports) {
    var $dM3Z8 = parcelRequire("dM3Z8");
    var $4rDUz = parcelRequire("4rDUz");
    var $kPZpS = parcelRequire("kPZpS");
    var $7b3c02adf390bcc6$var$nativeCeil = Math.ceil, $7b3c02adf390bcc6$var$nativeMax = Math.max;
    function $7b3c02adf390bcc6$var$chunk(array, size, guard) {
        if (guard ? $4rDUz(array, size, guard) : size === undefined) size = 1;
        else size = $7b3c02adf390bcc6$var$nativeMax($kPZpS(size), 0);
        var length = array == null ? 0 : array.length;
        if (!length || size < 1) return [];
        var index = 0, resIndex = 0, result = Array($7b3c02adf390bcc6$var$nativeCeil(length / size));
        while(index < length)result[resIndex++] = $dM3Z8(array, index, index += size);
        return result;
    }
    module.exports = $7b3c02adf390bcc6$var$chunk;
});
parcelRegister("hxMHI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("OgDz0").then(()=>parcelRequire('gEdc8'));
});
parcelRegister("gk293", function(module, exports) {
    $parcel$export(module.exports, "ThemedContentLayout", ()=>$24fd52a828227843$export$c2c3c7c0b13a1f9d);
    $parcel$export(module.exports, "ProjectThemeWrapper", ()=>$24fd52a828227843$export$65c56727ada4372d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3HwlS;
    var $jtC5b;
    const $24fd52a828227843$var$styles = {
        rootOld: "_kqswh2mm",
        root: "_kqswh2mm _1pbyidpf",
        fullHeight: "_1tkeidpf _4t3i1osq",
        insetRoot: "_1yt4y9h4",
        insetContainer: "_2rko1gnp _bfhkp043"
    };
    const $24fd52a828227843$export$c2c3c7c0b13a1f9d = ({ children: children, appearance: appearance })=>$5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && $24fd52a828227843$var$styles.root,
                !(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && $24fd52a828227843$var$styles.rootOld,
                $24fd52a828227843$var$styles.fullHeight,
                appearance === 'inset' && $24fd52a828227843$var$styles.insetRoot
            ])
        }, $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $24fd52a828227843$var$styles.fullHeight,
                appearance === 'inset' && $24fd52a828227843$var$styles.insetContainer
            ])
        }, children));
    const $24fd52a828227843$export$65c56727ada4372d = ({ withWhiteBackground: withWhiteBackground, children: children })=>{
        if (withWhiteBackground) return $5uXOq.createElement((0, (0, parcelRequire("jtC5b")).OuterWrapperWithBackground), null, $5uXOq.createElement((0, (0, parcelRequire("jtC5b")).InnerWrapperWithBackground), null, children));
        return $5uXOq.createElement((0, (0, parcelRequire("jtC5b")).OuterWrapper), null, $5uXOq.createElement((0, (0, parcelRequire("jtC5b")).InnerWrapper), null, children));
    };
});
parcelRegister("jtC5b", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$c37919f3b01a53ae$export$edaaad985a878983);
    $parcel$export(module.exports, "OuterWrapperWithBackground", ()=>$c37919f3b01a53ae$export$69c6ec128d3729c9);
    $parcel$export(module.exports, "InnerWrapper", ()=>$c37919f3b01a53ae$export$f185744748c379a7);
    $parcel$export(module.exports, "InnerWrapperWithBackground", ()=>$c37919f3b01a53ae$export$2e149d12a18af14b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7XYc4;
    var $cSD7y;
    var $3HwlS;
    const $c37919f3b01a53ae$var$Nav3OuterWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154i1jzz",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$var$Nav4OuterWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154ieda8",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$var$Nav4HighTabOuterWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154i1f46",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$export$edaaad985a878983 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("cSD7y")).componentWithFG)('horizontal_navigation_increase_tab_height', $c37919f3b01a53ae$var$Nav4HighTabOuterWrapper, $c37919f3b01a53ae$var$Nav4OuterWrapper), $c37919f3b01a53ae$var$Nav3OuterWrapper);
    const $c37919f3b01a53ae$export$69c6ec128d3729c9 = (0, $5uXOq.forwardRef)(({ as: C = $c37919f3b01a53ae$export$edaaad985a878983, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4y9h4",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$export$f185744748c379a7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2d3f3q3i _japi1o48 _iu1g1fl4 _fok81wug _q7c11wug",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$export$2e149d12a18af14b = (0, $5uXOq.forwardRef)(({ as: C = $c37919f3b01a53ae$export$f185744748c379a7, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1gnp _bfhkp043 _2d3f15y4 _japizntk",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8Orxo", function(module, exports) {
    $parcel$export(module.exports, "addLeadingSlash", ()=>$66a85aa0db68ca7e$export$5b4913142e03bca8, (v)=>$66a85aa0db68ca7e$export$5b4913142e03bca8 = v);
    $parcel$export(module.exports, "hasBasename", ()=>$66a85aa0db68ca7e$export$10497c7ce66fcb84, (v)=>$66a85aa0db68ca7e$export$10497c7ce66fcb84 = v);
    $parcel$export(module.exports, "stripBasename", ()=>$66a85aa0db68ca7e$export$b69e3301ce081aa3, (v)=>$66a85aa0db68ca7e$export$b69e3301ce081aa3 = v);
    $parcel$export(module.exports, "stripTrailingSlash", ()=>$66a85aa0db68ca7e$export$d95b4586d238a081, (v)=>$66a85aa0db68ca7e$export$d95b4586d238a081 = v);
    $parcel$export(module.exports, "parsePath", ()=>$66a85aa0db68ca7e$export$8ccf933b0513f8d0, (v)=>$66a85aa0db68ca7e$export$8ccf933b0513f8d0 = v);
    $parcel$export(module.exports, "createPath", ()=>$66a85aa0db68ca7e$export$fe53371bee54353d, (v)=>$66a85aa0db68ca7e$export$fe53371bee54353d = v);
    var $66a85aa0db68ca7e$export$1e511d4a378977f5;
    var $66a85aa0db68ca7e$export$5b4913142e03bca8;
    var $66a85aa0db68ca7e$export$79c5b1569e3be9e6;
    var $66a85aa0db68ca7e$export$10497c7ce66fcb84;
    var $66a85aa0db68ca7e$export$b69e3301ce081aa3;
    var $66a85aa0db68ca7e$export$d95b4586d238a081;
    var $66a85aa0db68ca7e$export$8ccf933b0513f8d0;
    var $66a85aa0db68ca7e$export$fe53371bee54353d;
    'use strict';
    $66a85aa0db68ca7e$export$1e511d4a378977f5 = true;
    var $66a85aa0db68ca7e$var$addLeadingSlash = $66a85aa0db68ca7e$export$5b4913142e03bca8 = function addLeadingSlash(path) {
        return path.charAt(0) === '/' ? path : '/' + path;
    };
    var $66a85aa0db68ca7e$var$stripLeadingSlash = $66a85aa0db68ca7e$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
        return path.charAt(0) === '/' ? path.substr(1) : path;
    };
    var $66a85aa0db68ca7e$var$hasBasename = $66a85aa0db68ca7e$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
        return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
    };
    var $66a85aa0db68ca7e$var$stripBasename = $66a85aa0db68ca7e$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
        return $66a85aa0db68ca7e$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
    };
    var $66a85aa0db68ca7e$var$stripTrailingSlash = $66a85aa0db68ca7e$export$d95b4586d238a081 = function stripTrailingSlash(path) {
        return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
    };
    var $66a85aa0db68ca7e$var$parsePath = $66a85aa0db68ca7e$export$8ccf933b0513f8d0 = function parsePath(path) {
        var pathname = path || '/';
        var search = '';
        var hash = '';
        var hashIndex = pathname.indexOf('#');
        if (hashIndex !== -1) {
            hash = pathname.substr(hashIndex);
            pathname = pathname.substr(0, hashIndex);
        }
        var searchIndex = pathname.indexOf('?');
        if (searchIndex !== -1) {
            search = pathname.substr(searchIndex);
            pathname = pathname.substr(0, searchIndex);
        }
        return {
            pathname: pathname,
            search: search === '?' ? '' : search,
            hash: hash === '#' ? '' : hash
        };
    };
    var $66a85aa0db68ca7e$var$createPath = $66a85aa0db68ca7e$export$fe53371bee54353d = function createPath(location) {
        var pathname = location.pathname, search = location.search, hash = location.hash;
        var path = pathname || '/';
        if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
        if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
        return path;
    };
});
parcelRegister("vrkiK", function(module, exports) {
    $parcel$export(module.exports, "calcRapidBoardResetState", ()=>$fd0af9cf1691807e$export$2350ed3ff6c1a082);
    $parcel$export(module.exports, "getApdexMatchObject", ()=>$fd0af9cf1691807e$export$47e434f08768932b);
    $parcel$export(module.exports, "calcRapidBoardResetStateV2", ()=>$fd0af9cf1691807e$export$dbd9185166d0d04c);
    $parcel$export(module.exports, "isValidRoute", ()=>$fd0af9cf1691807e$export$9f3e656a7f6a3adc);
    var $65Ltd;
    const $fd0af9cf1691807e$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
        let rapidBoardPaths = [
            ...boardPaths
        ];
        let resetDone = false;
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
                rapidBoardPaths = [
                    (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)
                ];
                resetDone = true;
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT:
                if (useStoredSettings) {
                    rapidBoardPaths = [
                        ...rapidBoardPaths,
                        'useStoredSettings'
                    ];
                    resetDone = false;
                    break;
                }
                if (!useStoredSettings && rapidBoardPaths.indexOf((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
                rapidBoardPaths = [];
                break;
            default:
                resetDone = false;
        }
        return [
            rapidBoardPaths,
            resetDone
        ];
    };
    const $fd0af9cf1691807e$export$47e434f08768932b = (match, route)=>{
        let cleanMatch = {
            ...match,
            params: {
                ...match.params
            },
            query: {
                ...match.query
            }
        };
        if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
            const { params: params, query: query } = match;
            const paramKeys = params && Object.keys(params);
            const queryKeys = query && Object.keys(query);
            const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
            const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
            if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
            if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
        });
        if (match.query && match.query.view && match.query.view === 'detail') cleanMatch.query.view = undefined;
        if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
        cleanMatch = {
            ...cleanMatch,
            url: ''
        };
        return cleanMatch;
    };
    const $fd0af9cf1691807e$export$dbd9185166d0d04c = (boardPaths, routeName, useStoredSettings)=>{
        let rapidBoardPaths = [
            ...boardPaths
        ];
        let resetDone = false;
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
                rapidBoardPaths = [];
                resetDone = true;
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT:
                if (rapidBoardPaths.includes((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) || rapidBoardPaths.includes('useStoredSettings')) {
                    resetDone = true;
                    rapidBoardPaths = [];
                    break;
                } else if (useStoredSettings) {
                    rapidBoardPaths = [
                        ...rapidBoardPaths,
                        'useStoredSettings'
                    ];
                    break;
                } else {
                    rapidBoardPaths = [];
                    break;
                }
            default:
                if (rapidBoardPaths.includes((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT))) {
                    resetDone = true;
                    rapidBoardPaths = [];
                }
        }
        return [
            rapidBoardPaths,
            resetDone
        ];
    };
    const $fd0af9cf1691807e$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
        if (state) {
            const { currentPage: currentPage, visitedPages: visitedPages } = state;
            const visitedPageLength = visitedPages.length;
            if (currentPage && currentPage.apps[appId]) return true;
            if (visitedPageLength === 0 || searchDepth <= 0) return false;
            for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
                if (visitedPages[visitedPageLength - i].apps[appId]) return true;
            }
        }
        return false;
    };
    const $fd0af9cf1691807e$export$9f3e656a7f6a3adc = (routeToCheck)=>{
        switch(routeToCheck.name){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE_EMBED:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES:
                return true;
            default:
                return false;
        }
    };
});
parcelRegister("5dFS4", function(module, exports) {
    $parcel$export(module.exports, "RemoteActionsContainer", ()=>$1e0d24cbb091f7c4$export$28c2e4c663a86266);
    $parcel$export(module.exports, "useRemoteActions", ()=>$1e0d24cbb091f7c4$export$333357b3de3e67a0);
    $parcel$export(module.exports, "useRemoteActionsData", ()=>$1e0d24cbb091f7c4$export$3cc006661ae2a759);
    $parcel$export(module.exports, "useMeta", ()=>$1e0d24cbb091f7c4$export$3fb9275d3845bd5a);
    $parcel$export(module.exports, "useRemoteActionsStoreActions", ()=>$1e0d24cbb091f7c4$export$3fd21eaf97df4718);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $jOqMN;
    var $4zmoY;
    if (!Object.isFrozen((0, (0, parcelRequire("jOqMN")).default))) (0, (0, parcelRequire("jOqMN")).default).devtools = false;
    const $1e0d24cbb091f7c4$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            meta: {},
            remoteActions: {},
            lastUpdatedAt: 0,
            isLoaded: false,
            product: undefined
        },
        actions: (0, parcelRequire("4zmoY")).actions,
        name: 'remoteActionsStore'
    });
    const $1e0d24cbb091f7c4$export$28c2e4c663a86266 = (0, (0, parcelRequire("gg7kZ")).createContainer)($1e0d24cbb091f7c4$var$Store, {
        onInit: ()=>({ dispatch: dispatch })=>{
                dispatch((0, (0, parcelRequire("4zmoY")).actions).initStore());
            }
    });
    const $1e0d24cbb091f7c4$export$333357b3de3e67a0 = (selector)=>(0, (0, parcelRequire("3sQ5x")).createHook)($1e0d24cbb091f7c4$var$Store, {
            selector: selector
        })();
    const $1e0d24cbb091f7c4$export$3cc006661ae2a759 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1e0d24cbb091f7c4$var$Store, {
        selector: (state)=>state.remoteActions
    });
    const $1e0d24cbb091f7c4$export$3fb9275d3845bd5a = (0, (0, parcelRequire("3sQ5x")).createStateHook)($1e0d24cbb091f7c4$var$Store, {
        selector: (state)=>state.meta
    });
    const $1e0d24cbb091f7c4$export$3fd21eaf97df4718 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($1e0d24cbb091f7c4$var$Store);
});
parcelRegister("4zmoY", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$aaea61f326c14d61$export$e324594224ef24da);
    var $iVuAh;
    var $18IDi;
    var $9sXhr;
    var $5wOe3;
    const $aaea61f326c14d61$export$e324594224ef24da = {
        processRemoteActions: (0, parcelRequire("9sXhr")).processRemoteActions,
        saveActionPerformedAttempt: (0, parcelRequire("5wOe3")).saveActionPerformedAttempt,
        initStore: (0, parcelRequire("18IDi")).initStore,
        clearActionId: (0, parcelRequire("iVuAh")).clearActionId
    };
});
parcelRegister("iVuAh", function(module, exports) {
    $parcel$export(module.exports, "clearActionId", ()=>$713396201de9d9dc$export$8d8b492eefa9efba);
    var $jbSVM;
    const $713396201de9d9dc$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
            const { meta: meta } = getState();
            const newMeta = {
                ...meta
            };
            delete newMeta[actionId];
            setState({
                meta: newMeta
            });
            (0, (0, parcelRequire("jbSVM")).writeRemoteActionsMetasToLocalStorage)(product, meta);
        };
});
parcelRegister("jbSVM", function(module, exports) {
    $parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", ()=>$c376cbc81521c9c0$export$a221266a05084986);
    $parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", ()=>$c376cbc81521c9c0$export$7228aaade919a8b6);
    const $c376cbc81521c9c0$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
    const $c376cbc81521c9c0$export$a221266a05084986 = (product)=>{
        try {
            return JSON.parse(localStorage.getItem(`${$c376cbc81521c9c0$export$b9e25d3c75cffd71}.${product}`) || '{}');
        } catch (e) {
            console.warn('Could not load from localStorage', e);
            return {};
        }
    };
    const $c376cbc81521c9c0$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
        try {
            localStorage.setItem(`${$c376cbc81521c9c0$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
        } catch (e) {
            console.warn('Could not load from localStorage', e);
        }
    };
});
parcelRegister("18IDi", function(module, exports) {
    $parcel$export(module.exports, "initStore", ()=>$46b900e2f6990234$export$41f27b3823a442c6);
    var $jbSVM;
    const $46b900e2f6990234$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
            setState({
                meta: (0, (0, parcelRequire("jbSVM")).readRemoteActionsMetasFromLocalStorage)(product),
                isLoaded: true,
                product: product
            });
        };
});
parcelRegister("9sXhr", function(module, exports) {
    $parcel$export(module.exports, "processRemoteActions", ()=>$12ae2589bf32577c$export$15e69d1dd38ccaa3);
    var $hDuWL;
    const $12ae2589bf32577c$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
            const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
            if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) return;
            const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
                if ((0, (0, parcelRequire("hDuWL")).shouldProcessRemoteAction)(remoteAction)) {
                    const shouldAddAction = remoteAction.conditions.every((condition)=>(0, (0, parcelRequire("hDuWL")).isActionConditionSatisfied)(productData, condition));
                    if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
                }
                return updatedRemoteActions;
            }, {});
            setState({
                meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                    newMeta[id] = meta[id];
                    return newMeta;
                }, {}),
                remoteActions: remoteActions,
                lastUpdatedAt: Date.now()
            });
        };
});
parcelRegister("hDuWL", function(module, exports) {
    $parcel$export(module.exports, "isActionConditionSatisfied", ()=>$5301c54ab422cac2$export$9262d8191a70c677);
    $parcel$export(module.exports, "shouldProcessRemoteAction", ()=>$5301c54ab422cac2$export$c7cc93192d09a3d7);
    var $7DUy3;
    const $5301c54ab422cac2$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
    const $5301c54ab422cac2$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
    const $5301c54ab422cac2$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
        try {
            const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
            const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
            const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
            if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
            if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
        } catch (error) {
            console.warn('error while parsing a build key', error);
        }
        return false;
    };
    const $5301c54ab422cac2$export$9262d8191a70c677 = (productData, condition)=>{
        switch(condition.type){
            case (0, (0, parcelRequire("7DUy3")).ConditionType).buildRange:
                return $5301c54ab422cac2$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition);
            case (0, (0, parcelRequire("7DUy3")).ConditionType).featureFlag:
                return $5301c54ab422cac2$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
            case (0, (0, parcelRequire("7DUy3")).ConditionType).featureGate:
                return $5301c54ab422cac2$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
            default:
                return false;
        }
    };
    const $5301c54ab422cac2$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;
});
parcelRegister("7DUy3", function(module, exports) {
    $parcel$export(module.exports, "ConditionType", ()=>$8113f7b7a082b7e1$export$748d1c753cdf4bfd);
    var $8113f7b7a082b7e1$export$748d1c753cdf4bfd;
    (function(ConditionType) {
        ConditionType["featureFlag"] = "featureFlag";
        ConditionType["featureGate"] = "featureGate";
        ConditionType["buildRange"] = "buildRange";
    })($8113f7b7a082b7e1$export$748d1c753cdf4bfd || ($8113f7b7a082b7e1$export$748d1c753cdf4bfd = {}));
});
parcelRegister("5wOe3", function(module, exports) {
    $parcel$export(module.exports, "saveActionPerformedAttempt", ()=>$a54dff5e62ba5c12$export$e3144a2e886e0e77);
    var $jbSVM;
    const $a54dff5e62ba5c12$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
            const { meta: meta, product: product } = getState();
            const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
            const updatedMetas = {
                ...meta,
                [actionId]: {
                    lastPerformAttemptedAt: Date.now(),
                    attemptCounts: currentAttemptCount + 1
                }
            };
            setState({
                meta: updatedMetas
            });
            if (!product) throw new Error('Product is not defined.');
            (0, (0, parcelRequire("jbSVM")).writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
        };
});
parcelRegister("jsLXn", function(module, exports) {
    $parcel$export(module.exports, "JiraContextContainer", ()=>$88b19a22a09480ac$export$6f7845cc5e693f16);
    var $5uXOq = parcelRequire("5uXOq");
    var $lRFpu;
    var $lzeFL;
    var $5tsrJ;
    var $1OjhZ;
    var $j8DrX;
    var $1nUas;
    var $2HbP2;
    var $8ApFP;
    var $iXVV6;
    var $fiv1r;
    var $14XJw;
    var $9OXo1;
    var $a83ud;
    const $88b19a22a09480ac$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        }, children);
    const $88b19a22a09480ac$export$6f7845cc5e693f16 = (props)=>{
        const state = {
            messages: (parcelRequire("hWnRN"))
        };
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($88b19a22a09480ac$var$ContextualAnalyticsDataFeatureFlagged, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextContainer), {
            isGlobal: true,
            getMeta: (0, (0, parcelRequire("j8DrX")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1nUas")).IntlProvider), {
                messages: state.messages,
                locale: (0, (0, parcelRequire("lzeFL")).standardizeLocale)(tenantContext.locale)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lRFpu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tsrJ")).default), {
                orgId: orgId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1OjhZ")).ExperienceTrackerProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fiv1r")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2HbP2")).ModalContextProvider), null, props.children)))))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a83ud")).LoadingPhaseManager), null));
    };
});
parcelRegister("a83ud", function(module, exports) {
    $parcel$export(module.exports, "LoadingPhaseManager", ()=>$852e6ed10ffe3afe$export$6e4bfef9e80c7eb0);
    var $5uXOq = parcelRequire("5uXOq");
    var $j7rCb;
    const $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0 = ()=>{
        const { startNextPhase: startNextPhase } = (0, (0, parcelRequire("j7rCb")).useLazyPhase)();
        (0, $5uXOq.useEffect)(()=>{
            if (__SPA__) return;
            setTimeout(()=>{
                performance.mark('rll-after-paint-phase');
                startNextPhase();
            }, 2000);
        }, [
            startNextPhase
        ]);
        return null;
    };
});
parcelRegister("hWnRN", function(module, exports) {
    module.exports = __LANG;
});
parcelRegister("5eQ1m", function(module, exports) {
    $parcel$export(module.exports, "StrictMode", ()=>$64cfd661e498c7fe$export$5f8d39834fd61797);
    var $5uXOq = parcelRequire("5uXOq");
    const $64cfd661e498c7fe$export$5f8d39834fd61797 = ({ children: children })=>{
        const isStrictModeDisabled = false;
        if (isStrictModeDisabled) return children;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).StrictMode, null, children);
    };
});
parcelRegister("81ezV", function(module, exports) {
    $parcel$export(module.exports, "JiraRouterLinkConfiguration", ()=>$33ea5bfeb747665b$export$a580704a2f3cfca);
    var $5uXOq = parcelRequire("5uXOq");
    var $hDzhb;
    const $33ea5bfeb747665b$export$a580704a2f3cfca = (0, $5uXOq.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
        if (!href || typeof href === 'string') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
            ref: ref,
            href: href || '#',
            ...rest
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
            ref: ref,
            href: href.href,
            to: href.to,
            replace: href.replace,
            params: href.params,
            query: href.query,
            prefetch: href.prefetch,
            ...rest
        }, children);
    });
});
parcelRegister("b7awD", function(module, exports) {
    $parcel$export(module.exports, "Router", ()=>$87aa2fd82c8be71a$export$55185c17a0fcbe46);
    var $5uXOq = parcelRequire("5uXOq");
    var $hcRPK;
    var $d8orV;
    const $87aa2fd82c8be71a$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
        const pluginsWithOverride = (0, (0, parcelRequire("d8orV")).usePlugins)({
            resourceContext: props.resourceContext,
            resourceData: props.resourceData
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hcRPK")).Router), {
            plugins: pluginsWithOverride,
            ...props
        }, children);
    };
});
parcelRegister("d8orV", function(module, exports) {
    $parcel$export(module.exports, "usePlugins", ()=>$0614c9d3afc2dd7f$export$c41e96fd89bc6106);
    var $5uXOq = parcelRequire("5uXOq");
    var $a2g00;
    var $5yJb9;
    var $9OXo1;
    var $8Y8sk;
    const $0614c9d3afc2dd7f$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [pluginsWithOverride] = (0, $5uXOq.useState)(()=>{
            const jiraPlugins = [];
            const resourcesPlugin = (0, (0, parcelRequire("8Y8sk")).createResourcesPlugin)({
                context: resourceContext,
                resourceData: resourceData
            });
            jiraPlugins.push(resourcesPlugin);
            jiraPlugins.push((0, (0, parcelRequire("a2g00")).createEntryPointsPlugin)({
                environment: (0, (0, parcelRequire("5yJb9")).default)(),
                entryPointParams: {
                    tenantContext: tenantContext
                }
            }));
            return jiraPlugins;
        });
        return pluginsWithOverride;
    };
});
parcelRegister("a2g00", function(module, exports) {
    $parcel$export(module.exports, "createEntryPointsPlugin", ()=>$e3cbf02360bc6f96$export$33586718f82f356f);
    var $8Uumt = parcelRequire("8Uumt");
    var $3gC8D;
    var $3I4nj;
    var $ktB2C;
    const $e3cbf02360bc6f96$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
            id: 'entry-points-plugin',
            routeLoad: ({ context: context })=>{
                const entryPoint = context.route.entryPoint?.();
                const prefetchingRoute = (0, (0, parcelRequire("3I4nj")).getPrefetchingRoute)();
                let entryPointReference = null;
                if (entryPoint) {
                    if (prefetchingRoute && (0, (0, parcelRequire("3gC8D")).isSameRouteMatch)({
                        prevContextMatch: prefetchingRoute.routerContext.match,
                        nextContextMatch: context.match
                    }) && !(0, (0, parcelRequire("3gC8D")).isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                    else entryPointReference = (0, $8Uumt.loadEntryPoint)({
                        getEnvironment: ()=>environment
                    }, entryPoint, {
                        context: context,
                        ...entryPointParams
                    });
                }
                (0, (0, parcelRequire("3I4nj")).getEntryPointsStore)().actions.setLastLoadedRoute({
                    route: context.route,
                    entryPointReference: entryPointReference
                });
                return {
                    entryPoint: entryPointReference
                };
            },
            routePrefetch: ({ nextContext: nextContext })=>{
                const entryPoint = nextContext.route.entryPoint?.();
                if (entryPoint) {
                    const prevPrefetchingRoute = (0, (0, parcelRequire("3I4nj")).getPrefetchingRoute)();
                    if (prevPrefetchingRoute && (0, (0, parcelRequire("3gC8D")).isSameRouteMatch)({
                        prevContextMatch: prevPrefetchingRoute.routerContext.match,
                        nextContextMatch: nextContext.match
                    }) && !(0, (0, parcelRequire("3gC8D")).isExpired)(prevPrefetchingRoute.expiresAt)) return;
                    const entryPointReference = (0, $8Uumt.loadEntryPoint)({
                        getEnvironment: ()=>environment
                    }, entryPoint, {
                        context: nextContext,
                        ...entryPointParams
                    });
                    (0, (0, parcelRequire("3I4nj")).getEntryPointsStore)().actions.setPrefetchingRoute({
                        routerContext: nextContext,
                        expiresAt: (0, (0, parcelRequire("3gC8D")).getExpiresAt)(),
                        entryPointReference: entryPointReference
                    });
                } else (0, (0, parcelRequire("3I4nj")).getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: 0,
                    entryPointReference: null
                });
            },
            waitForEntryPoint: ()=>{
                const lastLoadedRoute = (0, (0, parcelRequire("3I4nj")).getLastLoadedRoute)();
                const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
                if (entryPointReference) return (0, (0, parcelRequire("ktB2C")).waitForEntryPoint)(entryPointReference);
                return Promise.resolve();
            }
        });
});
parcelRegister("3gC8D", function(module, exports) {
    $parcel$export(module.exports, "getExpiresAt", ()=>$f48ce76f20803aec$export$b65d7ba7fbf150f1);
    $parcel$export(module.exports, "isExpired", ()=>$f48ce76f20803aec$export$57947cfd429801a2);
    $parcel$export(module.exports, "isSameRouteMatch", ()=>$f48ce76f20803aec$export$5997e70fc4543270);
    const $f48ce76f20803aec$export$37d3126be6549b13 = 10000;
    const $f48ce76f20803aec$export$b65d7ba7fbf150f1 = ()=>$f48ce76f20803aec$export$37d3126be6549b13 + Date.now();
    const $f48ce76f20803aec$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
    const $f48ce76f20803aec$var$isShallowEqual = (o1, o2)=>{
        const objKeys1 = Object.keys(o1);
        const objKeys2 = Object.keys(o2);
        if (objKeys1.length !== objKeys2.length) return false;
        return objKeys1.every((key)=>o1[key] === o2[key]);
    };
    const $f48ce76f20803aec$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);
});
parcelRegister("ktB2C", function(module, exports) {
    $parcel$export(module.exports, "waitForEntryPoint", ()=>$67d2b262678828c6$export$944f853f194e5dd5);
    var $kipqU;
    const $67d2b262678828c6$export$944f853f194e5dd5 = (entryPointConfig)=>{
        const promises = [];
        try {
            entryPointConfig.getComponent();
        } catch (err) {
            if (err instanceof Promise) promises.push(err);
            else throw err;
        }
        const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
        if (queries) Object.keys(queries).forEach((key)=>{
            if (queries[key].id) {
                const queryPromise = (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(String(queries[key].id));
                if (queryPromise) promises.push(queryPromise);
            }
        });
        if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
            const nestedEntryPointPromise = $67d2b262678828c6$export$944f853f194e5dd5(entryPoints[key]);
            promises.push(nestedEntryPointPromise);
        });
        return Promise.allSettled(promises);
    };
});
parcelRegister("8Y8sk", function(module, exports) {
    $parcel$export(module.exports, "createResourcesPlugin", ()=>$d3b2f44f58ee61bb$export$23ed892c481a96fe);
    var $8fYaK;
    var $4CEu1;
    const $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c = 'resources-plugin';
    const $d3b2f44f58ee61bb$var$loadOnUrlChange = (context, prevContext)=>{
        const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions;
        const nextResources = (0, (0, parcelRequire("4CEu1")).getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
        return Promise.all(requestResources(nextResources, context, {}));
    };
    const $d3b2f44f58ee61bb$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
        const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions;
        const nextResources = (0, (0, parcelRequire("4CEu1")).getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
        cleanExpiredResources(nextResources, nextContext);
    };
    const $d3b2f44f58ee61bb$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
        let latestLoadedResources = Promise.resolve([]);
        (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions.hydrate({
            resourceContext: initialResourceContext,
            resourceData: initialResourceData
        });
        return {
            id: $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c,
            beforeRouteLoad: $d3b2f44f58ee61bb$var$beforeLoad,
            routeLoad: ({ context: context, prevContext: prevContext })=>{
                const { route: route, match: match, query: query } = context;
                if (prevContext) latestLoadedResources = $d3b2f44f58ee61bb$var$loadOnUrlChange(context, prevContext);
                else latestLoadedResources = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions.requestAllResources({
                    route: route,
                    match: match,
                    query: query
                }, {
                    timeout: timeout
                });
            },
            routePrefetch: ({ context: context, nextContext: nextContext })=>{
                const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions;
                const nextResources = (0, (0, parcelRequire("4CEu1")).getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
                return {
                    resources: prefetchResources(nextResources, nextContext, {})
                };
            },
            getLatestResources: ()=>latestLoadedResources,
            getSerializedResources: async ()=>{
                await latestLoadedResources;
                return (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions.getSafeData();
            }
        };
    };
});
parcelRegister("4CEu1", function(module, exports) {
    $parcel$export(module.exports, "getResourcesForNextLocation", ()=>$448a0fea894dd469$export$7cbbc763e2f3d65d);
    var $9KbzN;
    var $dj41J;
    const $448a0fea894dd469$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
        const { route: prevRoute } = prevRouterStoreContext;
        const { resources: prevResources = [] } = prevRoute || {};
        const { route: nextRoute } = nextRouterStoreContext;
        const { resources: nextResources = [] } = nextRoute || {};
        if (!(0, (0, parcelRequire("dj41J")).routeHasResources)(nextRoute)) return [];
        if ((0, (0, parcelRequire("dj41J")).routeHasChanged)(prevRoute, nextRoute)) return nextResources;
        const prevResourceIdentifiers = (0, (0, parcelRequire("9KbzN")).getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
        return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, (0, parcelRequire("9KbzN")).getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
    };
});
parcelRegister("9KbzN", function(module, exports) {
    $parcel$export(module.exports, "getResourceIdentifier", ()=>$82cfa1d66d41fab5$export$c616b176adf9ad4a);
    $parcel$export(module.exports, "getResourceIdentifiers", ()=>$82cfa1d66d41fab5$export$cd7fbe7e979df558);
    const $82cfa1d66d41fab5$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
        const { type: type, getKey: getKey } = resource;
        const key = getKey(routerStoreContext, resourceStoreContext);
        return `${type}/${key}`;
    };
    const $82cfa1d66d41fab5$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$82cfa1d66d41fab5$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));
});
parcelRegister("dj41J", function(module, exports) {
    $parcel$export(module.exports, "routeHasResources", ()=>$9c8422e0259b24f6$export$740886389191c640);
    $parcel$export(module.exports, "routeHasChanged", ()=>$9c8422e0259b24f6$export$221027ff1aa38f82);
    const $9c8422e0259b24f6$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
    const $9c8422e0259b24f6$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;
});
parcelRegister("6YRTH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3bd6eeaf3add142$export$2e2bcd8739ae039);
    var $6vAaw = parcelRequire("6vAaw");
    var $fr1K2 = parcelRequire("fr1K2");
    var $e3bd6eeaf3add142$export$2e2bcd8739ae039 = (paramsToStrip)=>{
        try {
            const parsedUrl = (0, ($parcel$interopDefault($6vAaw))).parse(window.location.href, true);
            const strippedQuery = (0, ($parcel$interopDefault($fr1K2)))(parsedUrl.query || {}, paramsToStrip);
            let strippedUrl = (0, ($parcel$interopDefault($6vAaw))).format({
                ...parsedUrl,
                search: undefined,
                query: strippedQuery
            });
            const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(window.location.search);
            if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
            window.history.replaceState({}, '', strippedUrl);
        } catch (e) {}
    };
});
parcelRegister("TtQEC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8ee37fd26b4ccf1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $jzjy1;
    var $jD5no;
    var $l7nSX;
    const $c8ee37fd26b4ccf1$var$defaultSource = 'dwellComponent';
    const $c8ee37fd26b4ccf1$var$defaultActionSubject = 'dwellComponent';
    const $c8ee37fd26b4ccf1$var$getDwellComponent = (source, actionSubject)=>(0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("jzjy1")).AnalyticsSubject)(actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject), (0, (0, parcelRequire("jzjy1")).AnalyticsSource)(source || $c8ee37fd26b4ccf1$var$defaultSource, (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)))((0, (0, parcelRequire("l7nSX")).default));
    class $c8ee37fd26b4ccf1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props) {
            const { data: data } = props;
            return {
                DwellTimeComponent: $c8ee37fd26b4ccf1$var$getDwellComponent(data.source, data.actionSubject)
            };
        }
        constructor(props){
            super(props);
            this.state = {
                DwellTimeComponent: null
            };
        }
        render() {
            const { sessionId: sessionId, data: data } = this.props;
            const { DwellTimeComponent: DwellTimeComponent } = this.state;
            const enrichedData = {
                ...data,
                source: data && data.source || $c8ee37fd26b4ccf1$var$defaultSource,
                actionSubject: data && data.actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject
            };
            if (sessionId && DwellTimeComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(DwellTimeComponent, {
                sessionId: sessionId,
                data: enrichedData
            }));
            return null;
        }
    }
});
parcelRegister("l7nSX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c5cee06f4a100e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9E7Uh;
    var $8oe80;
    var $hhweD;
    class $8c5cee06f4a100e3$export$1c7ccff61c195c75 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { data: data, sessionId: sessionId } = this.props;
            this.dwellHelper = new (0, (0, parcelRequire("9E7Uh")).default)(this.sendDwellEvent, data, sessionId);
            this.dwellHelper.start();
        }
        componentDidUpdate(oldProps) {
            if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) this.dwellHelper.newPage(this.props.data, this.props.sessionId);
        }
        componentWillUnmount() {
            if (this.dwellHelper) {
                this.dwellHelper.stop();
                this.dwellHelper.destroy();
            }
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.props.children);
        }
        constructor(...args){
            super(...args), this.sendDwellEvent = (payload)=>(0, (0, parcelRequire("hhweD")).fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
        }
    }
    var $8c5cee06f4a100e3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('dwellTime', {
        onDwell: 'dwelled'
    })($8c5cee06f4a100e3$export$1c7ccff61c195c75);
});
parcelRegister("hhweD", function(module, exports) {
    $parcel$export(module.exports, "fireTrackAnalytics", ()=>$a4297ed46523d116$export$13990ad4625571ed);
    var $4f8Oj = parcelRequire("4f8Oj");
    var $gvRPW;
    var $i4iBk;
    const $a4297ed46523d116$var$isNotUndefined = (a)=>a !== undefined;
    const $a4297ed46523d116$var$mapPayload = (payload)=>{
        const context = (0, (0, parcelRequire("i4iBk")).default)(payload);
        const { action: action, actionSubjectId: actionSubjectId } = payload;
        return (0, ($parcel$interopDefault($4f8Oj)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            action: action,
            actionSubjectId: actionSubjectId
        }, $a4297ed46523d116$var$isNotUndefined);
    };
    const $a4297ed46523d116$export$13990ad4625571ed = (event, payload)=>{
        event.update({
            ...$a4297ed46523d116$var$mapPayload(payload),
            analyticsType: (0, (0, parcelRequire("gvRPW")).TRACK_EVENT_TYPE)
        }).fire();
    };
});
parcelRegister("5Jsi2", function(module, exports) {
    $parcel$export(module.exports, "CLEAR_SEARCH_SESSION", ()=>$65e6525a854bf206$export$b669eaa3e4786d5c);
    $parcel$export(module.exports, "skipClearSessionURLs", ()=>$65e6525a854bf206$export$c092460ed33e0e35);
    const $65e6525a854bf206$export$b669eaa3e4786d5c = 'CLEAR_SEARCH_SESSION';
    const $65e6525a854bf206$export$c092460ed33e0e35 = [
        /.*RapidBoard.jspa.*/,
        /\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/,
        /\/jira\/people\/.*\/boards\/.*/
    ];
});
parcelRegister("bShz7", function(module, exports) {
    $parcel$export(module.exports, "setPrefetchStartMark", ()=>$fd73e472799b8227$export$405fde3eab8e39f6);
    $parcel$export(module.exports, "getPrefetchStartMark", ()=>$fd73e472799b8227$export$cbaceb7ffa84279);
    $parcel$export(module.exports, "clearPrefetchStartMarks", ()=>$fd73e472799b8227$export$d6b0928f07bafe57);
    const $fd73e472799b8227$var$prefetchTiming = new Map();
    const $fd73e472799b8227$export$405fde3eab8e39f6 = (match)=>{
        const currentMatch = JSON.stringify(match);
        if (!$fd73e472799b8227$var$prefetchTiming.has(currentMatch)) $fd73e472799b8227$var$prefetchTiming.set(currentMatch, {
            startPrefetchTime: Date.now()
        });
    };
    const $fd73e472799b8227$export$cbaceb7ffa84279 = (match)=>{
        const currentMatch = JSON.stringify(match);
        const { startPrefetchTime: startPrefetchTime } = $fd73e472799b8227$var$prefetchTiming.get(currentMatch) || {
            startPrefetchTime: null
        };
        return startPrefetchTime;
    };
    const $fd73e472799b8227$export$d6b0928f07bafe57 = (match)=>{
        if (!$fd73e472799b8227$var$prefetchTiming || !$fd73e472799b8227$var$prefetchTiming.keys) return;
        const currentMatch = JSON.stringify(match);
        const keys = Array.from($fd73e472799b8227$var$prefetchTiming.keys());
        keys.forEach((mark)=>{
            if (mark !== currentMatch && $fd73e472799b8227$var$prefetchTiming.has(mark)) $fd73e472799b8227$var$prefetchTiming.delete(mark);
        });
    };
});
parcelRegister("5HG6S", function(module, exports) {
    $parcel$export(module.exports, "getSpaRouterContext", ()=>$804f5602998bd8a4$export$1f61c5e3f6410afa);
    const $804f5602998bd8a4$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
            tenantContext: tenantContext
        });
});
parcelRegister("kKlrY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$71f44f620ca2fe28$export$2e2bcd8739ae039);
    var $lANdF;
    var $bFU4G;
    var $auAY8;
    var $3vLAR;
    var $ievYU;
    var $cPbc1;
    var $co1wz;
    var $4R6GH;
    var $j8DrX;
    var $aZWa4;
    var $3dQJA;
    var $cEm1b;
    var $fJbQ9;
    var $itoGf;
    var $dQKfU;
    const $71f44f620ca2fe28$var$getUFOConfigFromLD = ()=>(0, (0, parcelRequire("co1wz")).getFeatureFlagValue)('ufo.config', {});
    const $71f44f620ca2fe28$var$getUFOConfigFromStatsig = ()=>{
        return {
            autoGeneratedRate: 1000,
            enabled: true,
            removeUFOPrefixList: [
                'project-versions',
                'filters-directory'
            ],
            removePageSegmentsUFOPrefixes: true,
            doNotAbortActivePressInteractionOnTransition: [
                'jsm-create-cmp-request-type-from-template',
                'jsm-create-tmp-request-type-from-template'
            ],
            killswitch: [
                'jira.fe.load.UNKNOWN'
            ],
            awaitForSegments: {
                'global-issue.create-modal': [
                    'issue-view-details'
                ],
                'global-issue.create-modal-subsequent': [
                    'issue-view-details'
                ]
            },
            removeAllUFOPrefix: true,
            rates: {
                'issue-view-activity-button-worklog': 1,
                'issue-view-activity-button-history': 1,
                'issue-view-activity-button-comments': 1,
                'arj-toggle-view-mode': 1,
                'global-issue.create-modal-subsequent': 5,
                unknown: 1000,
                'issue-view-activity-button-forge-app': 1,
                'view-mode': 1,
                'backlog.issue-view-opened': 5,
                'create-web-link-inline-field-type-tracing': 1000,
                'issue-view-activity-button-connect-app': 1,
                'single-line-text-field-type-tracing': 100,
                'issue-view-activity-button-all': 1,
                'backlog.card-hover': 100,
                'child-issue-inline-create-type-tracing': 100,
                'show-insights-button': 100,
                'board.issue-view-opened': 5,
                'issue-view-activity-button-jsd-comments': 1,
                'backlog.card-list-toggle': 5,
                'global-issue.create-modal': 5,
                'issue-view-activity-button-approvals': 1
            },
            kind: {
                generic: 0,
                hover: 0,
                legacy: 1,
                page_load: 1,
                press: 1,
                transition: 1,
                typing: 0
            },
            awaitBM3TTI: [
                'jwm_project_pages',
                'software-plan-dependencies',
                'advanced-roadmaps.page-plan.dependencies-tab.load-time',
                'servicedesk-cmdb-object-type-configuration',
                'service-management.insight-cmdb-object-type-configuration',
                'project-components-view',
                'project-components',
                'project-settings-components',
                'people-index',
                'people-profiles',
                'rapidboard-report',
                'classic-report',
                'project-settings-servicedesk-ticket-type-fields',
                'project-settings.issue-type.jsm-cmp-customer-view',
                'project-settings.issue-type.jsm-cmp-agent-view',
                'archived-project-direct-link',
                'project-archived',
                'servicedesk-queues-new',
                'service-management.queues.new',
                'project-settings-software-boards-insights',
                'board-settings-apps.insights-settings-page.page.load',
                'admin-oauth-credentials',
                'admin.oauth-credentials',
                'polaris-ideas',
                'jpd.project',
                'project-settings-software-boards-csm',
                'jira.fe.page-load.software.next-gen.boards.column-status-mapping.page.load',
                'project-settings-servicedesk-language',
                'service-management.languages',
                'project-settings-servicedesk-language-key',
                'service-management.translations',
                'project-settings-servicedesk-classic-apps',
                'service-management.app-discovery',
                'marketplace-index',
                'embedded-marketplace',
                'project-settings-servicedesk-portal-settings',
                'service-management.portal-settings',
                'service-management.portal-settings.portal-groups',
                'project-settings-servicedesk-automation-create',
                'service-management.automation.create-rule',
                'servicedesk-customers-v2',
                'jsm-customers-component-load',
                'archived-project-direct-link',
                'project-archived',
                'project-settings-software-boards-csm',
                'software.next-gen.boards.column-status-mapping.page.load',
                'jira-connect',
                'knowledge-hub-category',
                'service-management.knowledge.category',
                'servicedesk-queues-landing',
                'servicedesk-practice-landing',
                'servicedesk-practice-custom-and-issue',
                'servicedesk-practice-custom-issue',
                'servicedesk-practice-custom-view',
                'servicedesk-queues-custom-and-issue',
                'servicedesk-queues-custom-issue',
                'servicedesk-queues-custom-view'
            ],
            rules: [],
            capability: {
                feature_flag_access: 1,
                react_profiler: 1
            },
            typingMethod: 'timeout',
            removeInteractionsUFOPrefixes: true,
            doNotAbortActivePressInteraction: [
                'global-issue.create-modal',
                'global-issue.create-modal-subsequent'
            ],
            ufoNameOverrides: {
                'global-issue-navigator': {
                    'global-issue-navigator': 'global-issue-navigator-jfe',
                    'new-issue-navigator': 'global-new-issue-navigator'
                },
                'global-issue-navigator-jfe': {
                    'global-issue-navigator-jfe': 'global-issue-navigator-jfe',
                    'new-issue-navigator': 'global-new-issue-navigator'
                },
                'global-settings-migrations-focus-page': {
                    'admin.c2c-migrations.choose-destination': 'admin.c2c-migrations.choose-destination',
                    'admin.c2c-migrations.choose-projects': 'admin.c2c-migrations.choose-projects',
                    'admin.c2c-migrations.preflight-checks': 'admin.c2c-migrations.preflight-checks',
                    'admin.c2c-migrations.review': 'admin.c2c-migrations.review'
                },
                'polaris-ideas': {
                    'project-settings.details': 'project-settings-details-polaris-ideas'
                },
                'project-settings-servicedesk-portal-settings': {
                    'service-management.portal-settings': 'service-management.portal-settings',
                    'service-management.portal-settings.portal-groups': 'service-management.portal-settings.portal-groups'
                },
                'project-settings-servicedesk-ticket-type-fields': {
                    'project-settings.issue-type.jsm-cmp-agent-view': 'project-settings.issue-type.jsm-cmp-agent-view',
                    'project-settings.issue-type.jsm-cmp-customer-view': 'project-settings.issue-type.jsm-cmp-customer-view'
                },
                'servicedesk-practice-custom-and-issue': {
                    'service-management.queues.issue': 'servicedesk-practice-custom-issue',
                    'service-management.queues.view': 'servicedesk-practice-custom-view'
                },
                'servicedesk-queues-custom-and-issue': {
                    'service-management.queues.issue': 'servicedesk-queues-custom-issue',
                    'service-management.queues.view': 'servicedesk-queues-custom-view'
                }
            },
            enableCompleteUsingDoubleRAF: true
        };
    };
    function $71f44f620ca2fe28$var$getAdditionalJiraFields(interaction) {
        try {
            return {
                jira: (0, (0, parcelRequire("3dQJA")).getJiraCustomData)(interaction)
            };
        } catch (error) {
            return {};
        }
    }
    function $71f44f620ca2fe28$var$loadJiraAnalyticsWebClient() {
        return Promise.resolve((parcelRequire("fjcgS")));
    }
    function $71f44f620ca2fe28$export$2e2bcd8739ae039() {
        const ufoConfigFromFF = (0, (0, parcelRequire("4R6GH")).fg)('ufo-use-statsig-config-jira') ? $71f44f620ca2fe28$var$getUFOConfigFromStatsig() : $71f44f620ca2fe28$var$getUFOConfigFromLD();
        (0, (0, parcelRequire("aZWa4")).retrieveAndSetPageLoadTrace)((0, (0, parcelRequire("j8DrX")).default));
        (0, (0, parcelRequire("3vLAR")).configure)((0, (0, parcelRequire("itoGf")).jiraResourceTimingsConfig));
        (0, (0, parcelRequire("ievYU")).startResourceTimingBuffer)();
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira-disable-ufo-bundle-eval-timings')) (0, (0, parcelRequire("lANdF")).configure)((0, (0, parcelRequire("fJbQ9")).jiraBundleEvalTimingsConfig));
        (0, (0, parcelRequire("cPbc1")).configure)((0, (0, parcelRequire("dQKfU")).jiraSsrConfig));
        (0, (0, parcelRequire("cEm1b")).GlobalReactLooselyLazyProfiler).current = (0, (0, parcelRequire("bFU4G")).ModuleLoadingProfiler);
        (0, (0, parcelRequire("auAY8")).init)($71f44f620ca2fe28$var$loadJiraAnalyticsWebClient(), {
            ...ufoConfigFromFF,
            enableSegmentHighlighting: (0, (0, parcelRequire("4R6GH")).fg)('ufo_enable_segment_highlighting_jira'),
            enableAdditionalPerformanceMarks: (0, (0, parcelRequire("4R6GH")).fg)('ufo_enable_segment_highlighting_jira'),
            product: 'jira',
            region: (0, (0, parcelRequire("j8DrX")).default)('ajs-region') || 'unknown',
            additionalPayloadData: $71f44f620ca2fe28$var$getAdditionalJiraFields,
            postInteractionLog: {
                enabled: (0, (0, parcelRequire("4R6GH")).fg)('ufo_capture_late_rerenders_jira'),
                rates: {
                    'issue-view': 1,
                    'new-issue-navigator': 1,
                    'classic-board': 1,
                    'classic-backlog': 1,
                    'next-gen-board': 1,
                    'jwm.list-view': 1,
                    'jwm.jwm-board': 1,
                    'jwm.summary-view': 1,
                    dashboard: 1,
                    'software-issue-navigator': 1,
                    'global-new-issue-navigator': 1,
                    'issue-navigator': 1,
                    'issue-navigator-classic': 1,
                    'issue-navigator-core': 1,
                    'servicedesk-issues': 1
                }
            },
            manuallyTrackReactProfilerMounts: (0, (0, parcelRequire("4R6GH")).fg)('ufo-manually-track-segment-mount-phase-jira'),
            vc: {
                enabled: true,
                heatmapSize: 200,
                oldDomUpdates: false,
                devToolsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('uip_vc_devtools'),
                selectorConfig: {
                    id: true,
                    role: true,
                    className: true,
                    testId: false
                },
                ssr: (0, (0, parcelRequire("4R6GH")).fg)('uip_vc_ssr'),
                stopVCAtInteractionFinish: (0, (0, parcelRequire("4R6GH")).fg)('stop_vc_at_interaction_finish')
            },
            enableBetterPageVisibilityApi: (0, (0, parcelRequire("co1wz")).ff)('uip.vc.better-page-visibility', false)
        });
    }
});
parcelRegister("lANdF", function(module, exports) {
    $parcel$export(module.exports, "configure", ()=>$62d1dc5c906adae4$export$8d21e34596265fa2);
    $parcel$export(module.exports, "getBundleEvalTimings", ()=>$62d1dc5c906adae4$export$2eda1519e91a4386);
    var $bdDDw;
    let $62d1dc5c906adae4$var$config = null;
    function $62d1dc5c906adae4$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
        $62d1dc5c906adae4$var$config = bundleEvalTimingConfiguration;
    }
    const $62d1dc5c906adae4$var$getPerformanceObject = ()=>(window ?? {}).performance;
    function $62d1dc5c906adae4$export$2eda1519e91a4386(interactionStartTime) {
        if ($62d1dc5c906adae4$var$config == null) return {};
        const started = {};
        const timings = {};
        const cachedConfig = $62d1dc5c906adae4$var$config;
        const performance = $62d1dc5c906adae4$var$getPerformanceObject();
        performance?.getEntriesByType('mark').forEach((mark)=>{
            const result = cachedConfig.mapPerformanceMark(mark.name);
            if (!result) return;
            const { type: type, name: name } = result;
            if (type === 'start' && mark.startTime >= interactionStartTime) {
                started[name] = mark;
                return;
            }
            if (type === 'end' && started[name]) {
                timings[name] = {
                    startTime: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(started[name].startTime - interactionStartTime),
                    duration: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(mark.startTime - started[name].startTime)
                };
                delete started[name];
            }
        });
        if (Object.keys(timings).length === 0) return {};
        return timings;
    }
});
parcelRegister("bdDDw", function(module, exports) {
    $parcel$export(module.exports, "roundEpsilon", ()=>$f25e0154c492e45e$export$56014375de40214b);
    const $f25e0154c492e45e$export$56014375de40214b = (num, places = 3)=>{
        const factor = Math.pow(10, places);
        return Math.round((num + Number.EPSILON) * factor) / factor;
    };
});
parcelRegister("auAY8", function(module, exports) {
    $parcel$export(module.exports, "init", ()=>$78c94c158b70469a$export$2cd8252107eb640b);
    var $gg6CF = parcelRequire("gg6CF");
    var $5DPhz;
    var $fe1wc;
    var $37gc9;
    var $bFU4G;
    var $a0hd6;
    let $78c94c158b70469a$var$initialized = false;
    function $78c94c158b70469a$var$sinkInteraction(instance, payloadPackage) {
        (0, (0, parcelRequire("bFU4G")).sinkInteractionHandler)((interactionId, interaction)=>{
            (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), ()=>{
                const payloads = payloadPackage.createPayloads(interactionId, interaction);
                payloads?.forEach((payload)=>{
                    instance.sendOperationalEvent(payload);
                });
            });
        });
    }
    function $78c94c158b70469a$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
        (0, (0, parcelRequire("bFU4G")).sinkPostInteractionLogHandler)((logOutput)=>{
            (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), ()=>{
                const payload = createPostInteractionLogPayload(logOutput);
                if (payload) instance.sendOperationalEvent(payload);
            });
        });
    }
    const $78c94c158b70469a$export$2cd8252107eb640b = (analyticsWebClientAsync, config)=>{
        if ($78c94c158b70469a$var$initialized) return;
        (0, (0, parcelRequire("fe1wc")).setUFOConfig)(config);
        if (config.vc?.enabled) {
            const vcOptions = {
                heatmapSize: config.vc.heatmapSize,
                oldDomUpdates: config.vc.oldDomUpdates,
                devToolsEnabled: config.vc.devToolsEnabled,
                selectorConfig: config.vc.selectorConfig
            };
            (0, (0, parcelRequire("a0hd6")).getVCObserver)(vcOptions).start({
                startTime: 0
            });
            (0, (0, parcelRequire("bFU4G")).postInteractionLog).initializeVCObserver(vcOptions);
            (0, (0, parcelRequire("bFU4G")).postInteractionLog).startVCObserver({
                startTime: 0
            });
        }
        (0, (0, parcelRequire("37gc9")).setupHiddenTimingCapture)();
        (0, (0, parcelRequire("5DPhz")).startLighthouseObserver)();
        $78c94c158b70469a$var$initialized = true;
        Promise.all([
            analyticsWebClientAsync,
            (parcelRequire("aFpFt")),
            (parcelRequire("aKux0"))
        ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage])=>{
            if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
                const instance = client.getInstance();
                $78c94c158b70469a$var$sinkInteraction(instance, payloadPackage);
                if (config.postInteractionLog?.enabled) $78c94c158b70469a$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            });
            else if (awc.sendOperationalEvent) {
                $78c94c158b70469a$var$sinkInteraction(awc, payloadPackage);
                if (config.postInteractionLog?.enabled) $78c94c158b70469a$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            }
        });
    };
});
parcelRegister("5DPhz", function(module, exports) {
    $parcel$export(module.exports, "startLighthouseObserver", ()=>$0fa54be9bd80e4ab$export$5ecf2aafafee3e0);
    $parcel$export(module.exports, "getLighthouseMetrics", ()=>$0fa54be9bd80e4ab$export$b46cecdf698e4bb5);
    var $92xAz;
    var $jKaCJ;
    var $l7wnP;
    var $k0uhA;
    var $7cMne;
    function $0fa54be9bd80e4ab$export$5ecf2aafafee3e0() {
        (0, (0, parcelRequire("7cMne")).startLSObserver)();
        (0, (0, parcelRequire("7cMne")).startLTObserver)();
    }
    const $0fa54be9bd80e4ab$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
        const tbt = (0, (0, parcelRequire("l7wnP")).getTBT)(start, stop, (0, (0, parcelRequire("k0uhA")).EntriesBuffer)[(0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LongTask]);
        const cls = (0, (0, parcelRequire("92xAz")).getCLS)(start, stop, (0, (0, parcelRequire("k0uhA")).EntriesBuffer)[(0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LayoutShift]);
        return {
            'metric:tbt': Math.round(tbt.total),
            'metric:tbt:observed': Math.round(tbt.observed),
            'metric:cls': cls
        };
    };
});
parcelRegister("92xAz", function(module, exports) {
    $parcel$export(module.exports, "getCLS", ()=>$cb361e890ff4f9d8$export$fc6227831ee7c7);
    const $cb361e890ff4f9d8$export$fc6227831ee7c7 = (start, stop, buffer)=>{
        const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
        const sessionWindows = [];
        let currentWindow = null;
        for (const shift of layoutShifts){
            const { startTime: startTime } = shift;
            const endTime = shift.startTime + shift.duration;
            const score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
        const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
        return Math.round(maxScore * 10000) / 10000;
    };
});
parcelRegister("jKaCJ", function(module, exports) {
    $parcel$export(module.exports, "PerformanceObserverEntryTypes", ()=>$c867e70954b5231d$export$a4def92db6fc8e17);
    const $c867e70954b5231d$export$a4def92db6fc8e17 = {
        LayoutShift: 'layout-shift',
        LongTask: 'longtask'
    };
});
parcelRegister("l7wnP", function(module, exports) {
    $parcel$export(module.exports, "getTBT", ()=>$db26c18e70d86e5d$export$2d6e933b35bd3407);
    const $db26c18e70d86e5d$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
    const $db26c18e70d86e5d$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $db26c18e70d86e5d$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
            const longTaskStop = entry.startTime + entry.duration;
            const intersectStart = Math.max(entry.startTime + $db26c18e70d86e5d$var$MAX_ACCEPTABLE_TASK_DURATION, start);
            const intersectStop = Math.min(longTaskStop, stop);
            const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
            tbt.observed += entry.duration - $db26c18e70d86e5d$var$MAX_ACCEPTABLE_TASK_DURATION;
            tbt.total += longTaskIncluded;
            return tbt;
        }, {
            total: 0,
            observed: 0
        });
});
parcelRegister("k0uhA", function(module, exports) {
    $parcel$export(module.exports, "EntriesBuffer", ()=>$74df48ec3def97f8$export$f7dc16cbd16f7bbe);
    var $jKaCJ;
    class $74df48ec3def97f8$export$2c6e86519c9e8188 {
        constructor(maxLength = 1000){
            this.buffer = [];
            this.full = false;
            this.maxLength = maxLength;
        }
        push(item) {
            if (this.full || this.maxLength === this.buffer.length) {
                this.full = true;
                this.buffer.shift();
            }
            this.buffer.push(item);
        }
        getAll() {
            return this.buffer;
        }
    }
    const $74df48ec3def97f8$export$f7dc16cbd16f7bbe = {
        [(0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LongTask]: new $74df48ec3def97f8$export$2c6e86519c9e8188(),
        [(0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LayoutShift]: new $74df48ec3def97f8$export$2c6e86519c9e8188()
    };
});
parcelRegister("7cMne", function(module, exports) {
    $parcel$export(module.exports, "startLSObserver", ()=>$1e6ef4fbf892be45$export$768ccc3ab7bac3ea);
    $parcel$export(module.exports, "startLTObserver", ()=>$1e6ef4fbf892be45$export$54fb8b6aaf70ec9c);
    var $jKaCJ;
    var $k0uhA;
    let $1e6ef4fbf892be45$var$pe = null;
    const $1e6ef4fbf892be45$var$getObserver = ()=>{
        if ($1e6ef4fbf892be45$var$pe !== null) return $1e6ef4fbf892be45$var$pe;
        $1e6ef4fbf892be45$var$pe = new PerformanceObserver((list)=>{
            list.getEntries().forEach((entry)=>{
                if (entry.entryType === (0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LayoutShift) (0, (0, parcelRequire("k0uhA")).EntriesBuffer)[(0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LayoutShift].push(entry);
                if (entry.entryType === (0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LongTask) (0, (0, parcelRequire("k0uhA")).EntriesBuffer)[(0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LongTask].push(entry);
            });
        });
        return $1e6ef4fbf892be45$var$pe;
    };
    const $1e6ef4fbf892be45$export$768ccc3ab7bac3ea = ()=>{
        $1e6ef4fbf892be45$var$getObserver().observe({
            type: (0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LayoutShift,
            buffered: true
        });
    };
    const $1e6ef4fbf892be45$export$54fb8b6aaf70ec9c = ()=>{
        $1e6ef4fbf892be45$var$getObserver().observe({
            type: (0, (0, parcelRequire("jKaCJ")).PerformanceObserverEntryTypes).LongTask,
            buffered: true
        });
    };
});
parcelRegister("37gc9", function(module, exports) {
    $parcel$export(module.exports, "setupHiddenTimingCapture", ()=>$9d4714fe1b0ac403$export$554cefe0f0373da4);
    $parcel$export(module.exports, "getPageVisibilityState", ()=>$9d4714fe1b0ac403$export$768b2008623433e1);
    var $cBeZP;
    const $9d4714fe1b0ac403$var$timings = [];
    let $9d4714fe1b0ac403$var$wasHiddenFlag;
    let $9d4714fe1b0ac403$var$setupFlag = false;
    function $9d4714fe1b0ac403$var$isPageHidden() {
        if ('visibilityState' in document) return document.visibilityState === 'hidden';
        else return document.hidden;
    }
    const $9d4714fe1b0ac403$var$SIZE = 50;
    let $9d4714fe1b0ac403$var$insertIndex = 0;
    function $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag, time) {
        $9d4714fe1b0ac403$var$timings[$9d4714fe1b0ac403$var$insertIndex] = {
            time: time ?? performance.now(),
            hidden: isPageHiddenFlag
        };
        $9d4714fe1b0ac403$var$insertIndex = ($9d4714fe1b0ac403$var$insertIndex + 1) % $9d4714fe1b0ac403$var$SIZE;
        $9d4714fe1b0ac403$var$wasHiddenFlag = isPageHiddenFlag;
    }
    function $9d4714fe1b0ac403$var$handleChange() {
        const isPageHiddenFlag = $9d4714fe1b0ac403$var$isPageHidden();
        if (isPageHiddenFlag) {
            if (!$9d4714fe1b0ac403$var$wasHiddenFlag) $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag);
            $9d4714fe1b0ac403$var$wasHiddenFlag = true;
        } else {
            if ($9d4714fe1b0ac403$var$wasHiddenFlag) $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag);
            $9d4714fe1b0ac403$var$wasHiddenFlag = false;
        }
    }
    function $9d4714fe1b0ac403$var$setup() {
        (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: 'pageshow',
            listener: $9d4714fe1b0ac403$var$handleChange
        });
        (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: 'pagehide',
            listener: $9d4714fe1b0ac403$var$handleChange
        });
        (0, (0, parcelRequire("cBeZP")).bind)(document, {
            type: 'visibilitychange',
            listener: $9d4714fe1b0ac403$var$handleChange
        });
    }
    function $9d4714fe1b0ac403$export$554cefe0f0373da4() {
        if (!$9d4714fe1b0ac403$var$setupFlag) {
            const isPageHiddenFlag = $9d4714fe1b0ac403$var$isPageHidden();
            $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag, 0);
            $9d4714fe1b0ac403$var$setup();
            $9d4714fe1b0ac403$var$setupFlag = true;
        }
    }
    function $9d4714fe1b0ac403$export$768b2008623433e1(start, end) {
        if ($9d4714fe1b0ac403$var$timings.length === 0) return 'visible';
        const currentSize = $9d4714fe1b0ac403$var$timings.length;
        let hiddenState = 'mixed';
        let startIdx = $9d4714fe1b0ac403$var$insertIndex;
        let endIdx = $9d4714fe1b0ac403$var$insertIndex;
        for(let i = 0; i < currentSize; i++){
            const tmpIdx = ($9d4714fe1b0ac403$var$insertIndex + i) % currentSize;
            if ($9d4714fe1b0ac403$var$timings[tmpIdx].time <= end) {
                endIdx = tmpIdx;
                if ($9d4714fe1b0ac403$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
            }
        }
        if (endIdx - startIdx === 0) {
            if ($9d4714fe1b0ac403$var$timings[startIdx].hidden) hiddenState = 'hidden';
            else hiddenState = 'visible';
        }
        return hiddenState;
    }
});
parcelRegister("aFpFt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hjKrw").then(()=>parcelRequire('42zNJ'));
});
parcelRegister("aKux0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fvMNS").then(()=>parcelRequire('8OVem'));
});
parcelRegister("3vLAR", function(module, exports) {
    $parcel$export(module.exports, "configure", ()=>$0b58edb89023fc57$export$8d21e34596265fa2);
    $parcel$export(module.exports, "getConfig", ()=>$0b58edb89023fc57$export$44487a86467333c3);
    var $fe1wc;
    const $0b58edb89023fc57$var$defaultAllowedParams = [
        'operationName',
        'operation',
        'q'
    ];
    const $0b58edb89023fc57$var$getAllowedParams = ()=>{
        const config = (0, (0, parcelRequire("fe1wc")).getConfig)();
        return config?.allowedResourcesParams || $0b58edb89023fc57$var$defaultAllowedParams;
    };
    const $0b58edb89023fc57$var$handleQueryParams = (urlString)=>{
        try {
            if (typeof urlString !== 'string') return urlString;
            const url = new URL(urlString);
            const params = new URLSearchParams(url.search);
            const allowedParams = $0b58edb89023fc57$var$getAllowedParams();
            for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
            return url.toString();
        } catch (e) {
            return urlString;
        }
    };
    let $0b58edb89023fc57$var$config = {
        mapResources: (url)=>url,
        sanitiseEndpoints: (url)=>{
            return $0b58edb89023fc57$var$handleQueryParams(url);
        }
    };
    function $0b58edb89023fc57$export$8d21e34596265fa2(resourceTimingConfig) {
        const newConfig = {
            mapResources: resourceTimingConfig.mapResources,
            sanitiseEndpoints: (url)=>{
                const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
                if (sanitised) return $0b58edb89023fc57$var$handleQueryParams(sanitised);
                return sanitised;
            }
        };
        $0b58edb89023fc57$var$config = newConfig;
    }
    const $0b58edb89023fc57$export$44487a86467333c3 = ()=>$0b58edb89023fc57$var$config;
});
parcelRegister("ievYU", function(module, exports) {
    $parcel$export(module.exports, "startResourceTimingBuffer", ()=>$3ebfc8234e313f10$export$a311cb1baa7d2d62);
    var $8aEFN;
    function $3ebfc8234e313f10$export$a311cb1baa7d2d62() {
        (0, (0, parcelRequire("8aEFN")).resourceTimingBuffer).start();
    }
});
parcelRegister("8aEFN", function(module, exports) {
    $parcel$export(module.exports, "resourceTimingBuffer", ()=>$33f750350a029cdd$export$bea963256235a63e);
    $parcel$export(module.exports, "filterResourceTimings", ()=>$33f750350a029cdd$export$4138a729ef1db028);
    var $bdDDw;
    const $33f750350a029cdd$var$getPerformanceObject = ()=>(window ?? {}).performance;
    const $33f750350a029cdd$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
    const $33f750350a029cdd$export$bea963256235a63e = {
        timings: [],
        maxSize: 1000,
        observer: null,
        transformResource: (entry)=>{
            const duration = (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.duration);
            const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find((timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
            const serverTime = totalBackendTimeEntry ? (0, (0, parcelRequire("bdDDw")).roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
            const networkTime = serverTime ? duration - serverTime : undefined;
            return {
                name: entry.name,
                initiatorType: entry.initiatorType,
                transferSize: entry.transferSize,
                startTime: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.startTime),
                duration: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.duration),
                fetchStart: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.fetchStart || 0),
                workerStart: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.workerStart || 0),
                responseStart: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.responseStart || 0),
                requestStart: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.requestStart || 0),
                serverTime: serverTime,
                networkTime: networkTime,
                encodedSize: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.encodedBodySize),
                decodedSize: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(entry.decodedBodySize)
            };
        },
        start: ()=>{
            const performance = $33f750350a029cdd$var$getPerformanceObject();
            const PerformanceObserver = $33f750350a029cdd$var$getPerformanceObserverObject();
            if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
            if ($33f750350a029cdd$export$bea963256235a63e.observer) return;
            const resources = performance.getEntriesByType?.('resource');
            if (resources) $33f750350a029cdd$export$bea963256235a63e.timings = resources.map((resource)=>$33f750350a029cdd$export$bea963256235a63e.transformResource(resource));
            $33f750350a029cdd$export$bea963256235a63e.observer = new PerformanceObserver($33f750350a029cdd$export$bea963256235a63e.addTimings);
            $33f750350a029cdd$export$bea963256235a63e.observer.observe({
                entryTypes: [
                    'resource'
                ]
            });
        },
        stop: ()=>{
            if ($33f750350a029cdd$export$bea963256235a63e.observer) {
                $33f750350a029cdd$export$bea963256235a63e.observer.disconnect();
                $33f750350a029cdd$export$bea963256235a63e.observer = null;
            }
            $33f750350a029cdd$export$bea963256235a63e.timings = [];
        },
        addTimings: (list)=>{
            const entries = list.getEntries().map((entry)=>$33f750350a029cdd$export$bea963256235a63e.transformResource(entry));
            const overflow = $33f750350a029cdd$export$bea963256235a63e.timings.length + entries.length;
            if (overflow > $33f750350a029cdd$export$bea963256235a63e.maxSize) {
                const fieldsToRemove = overflow - $33f750350a029cdd$export$bea963256235a63e.maxSize;
                $33f750350a029cdd$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
            }
            $33f750350a029cdd$export$bea963256235a63e.timings.push(...entries);
        }
    };
    const $33f750350a029cdd$var$isValidTiming = (timing, startTime, endTime)=>timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
    const $33f750350a029cdd$export$4138a729ef1db028 = (startTime, endTime)=>{
        const performance = $33f750350a029cdd$var$getPerformanceObject();
        const PerformanceObserver = $33f750350a029cdd$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !$33f750350a029cdd$export$bea963256235a63e.observer) {
            const resources = performance?.getEntriesByType('resource');
            if (resources) return resources.filter((timing)=>$33f750350a029cdd$var$isValidTiming(timing, startTime, endTime));
            return null;
        }
        return $33f750350a029cdd$export$bea963256235a63e.timings.filter((timing)=>$33f750350a029cdd$var$isValidTiming(timing, startTime, endTime));
    };
});
parcelRegister("cPbc1", function(module, exports) {
    $parcel$export(module.exports, "configure", ()=>$b6a66b7de4cc2962$export$8d21e34596265fa2);
    $parcel$export(module.exports, "getSSRTimings", ()=>$b6a66b7de4cc2962$export$bf7408e83532dcd0);
    $parcel$export(module.exports, "getSSRSuccess", ()=>$b6a66b7de4cc2962$export$c7ad864055e75537);
    $parcel$export(module.exports, "getSSRDoneTime", ()=>$b6a66b7de4cc2962$export$3def7672244bab0c);
    $parcel$export(module.exports, "getSSRFeatureFlags", ()=>$b6a66b7de4cc2962$export$1c4a9b5e6e22393d);
    const $b6a66b7de4cc2962$var$NESTED_METRIC_SEPARATOR = '/';
    const $b6a66b7de4cc2962$var$filterEntry = (entry)=>!(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
    const $b6a66b7de4cc2962$var$mapEntry = (entry)=>({
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration)
        });
    const $b6a66b7de4cc2962$var$SSR_PREFIX = 'ssr';
    const $b6a66b7de4cc2962$var$mapKey = (key)=>{
        if (key === 'total') return $b6a66b7de4cc2962$var$SSR_PREFIX;
        return `${$b6a66b7de4cc2962$var$SSR_PREFIX}${$b6a66b7de4cc2962$var$NESTED_METRIC_SEPARATOR}${key}`;
    };
    let $b6a66b7de4cc2962$var$config;
    function $b6a66b7de4cc2962$export$8d21e34596265fa2(ssrConfig) {
        $b6a66b7de4cc2962$var$config = ssrConfig;
    }
    function $b6a66b7de4cc2962$export$bf7408e83532dcd0() {
        if (!$b6a66b7de4cc2962$var$config?.getTimings) return {};
        const timings = $b6a66b7de4cc2962$var$config.getTimings();
        if (!timings) return {};
        const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
            if ($b6a66b7de4cc2962$var$filterEntry(entry[1])) acc[$b6a66b7de4cc2962$var$mapKey(entry[0])] = $b6a66b7de4cc2962$var$mapEntry(entry[1]);
            return acc;
        }, {});
        return ssrTimings;
    }
    function $b6a66b7de4cc2962$export$c7ad864055e75537() {
        return !!$b6a66b7de4cc2962$var$config?.getDoneMark();
    }
    function $b6a66b7de4cc2962$export$3def7672244bab0c() {
        return $b6a66b7de4cc2962$var$config?.getDoneMark() ?? undefined;
    }
    function $b6a66b7de4cc2962$export$1c4a9b5e6e22393d() {
        if (!$b6a66b7de4cc2962$var$config?.getFeatureFlags) return undefined;
        try {
            return $b6a66b7de4cc2962$var$config.getFeatureFlags() ?? undefined;
        } catch (e) {}
        return undefined;
    }
});
parcelRegister("aZWa4", function(module, exports) {
    $parcel$export(module.exports, "retrieveAndSetPageLoadTrace", ()=>$b515f2bc55199ff5$export$1a71d2bbe236de99);
    var $tcn7E;
    let $b515f2bc55199ff5$var$alreadySet = false;
    const $b515f2bc55199ff5$export$1a71d2bbe236de99 = (getMeta)=>{
        if (false || $b515f2bc55199ff5$var$alreadySet) return;
        const traceId = getMeta('X-B3-TraceId') || '';
        const spanId = traceId?.substring(traceId.length - 16) || '';
        $b515f2bc55199ff5$var$alreadySet = true;
        (0, (0, parcelRequire("tcn7E")).setActiveTrace)(traceId, spanId, 'page_load');
    };
});
parcelRegister("3dQJA", function(module, exports) {
    $parcel$export(module.exports, "getJiraCustomData", ()=>$f5569bfee184b069$export$abf5e20822fa925);
    var $5uXOq = parcelRequire("5uXOq");
    var $j8DrX;
    var $3HwlS;
    var $sUexw;
    var $5YDBW;
    var $5uZVJ;
    var $eV38z;
    var $jgkaQ;
    var $9NJeU;
    var $3Itig;
    var $6R03U;
    var $bo7zb;
    var $ax2PR;
    var $4xsv9;
    function $f5569bfee184b069$export$abf5e20822fa925(interaction) {
        let customData = {};
        const shard = (0, (0, parcelRequire("j8DrX")).default)('ajs-shard');
        if (shard !== null && shard !== '') customData.shard = shard;
        customData['network:assetEncoding'] = (0, (0, parcelRequire("sUexw")).getAssetEncoding)();
        const buildVariant = window.BUILD_VARIANT;
        if (buildVariant) customData['app:buildVariant'] = buildVariant;
        const bundlerVersion = window.BUNDLER_VERSION;
        if (bundlerVersion) customData['app:bundlerVersion'] = bundlerVersion;
        const useBifrostGateway = window.USE_BIFROST_GATEWAY;
        if (useBifrostGateway) customData['app:useBifrostGateway'] = useBifrostGateway;
        customData.navType = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? 'nav4' : 'nav3';
        customData.httpProtocol = performance.getEntriesByType('resource').find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
        const { start: start, end: end, apdex: apdex } = interaction;
        const stop = apdex?.[0]?.stopTime ?? end;
        customData.memory = (0, (0, parcelRequire("9NJeU")).getMemoryUsageReport)({
            start: start,
            stop: stop
        });
        const lightHouseMetrics = (0, (0, parcelRequire("eV38z")).getLighthouseMetrics)({
            start: start,
            stop: stop
        });
        customData = {
            ...customData,
            ...lightHouseMetrics
        };
        if (interaction.type === 'page_load') customData = {
            ...customData,
            ...(0, (0, parcelRequire("jgkaQ")).getMarks)({
                start: start
            }),
            ...(0, (0, parcelRequire("3Itig")).getPageSizeMetrics)(),
            ...(0, (0, parcelRequire("3Itig")).getExtraNavigationTimings)(),
            ...(0, (0, parcelRequire("bo7zb")).getServerDurationMetrics)(),
            ...(0, (0, parcelRequire("6R03U")).getRouterResourceMetrics)(),
            ...(0, (0, parcelRequire("4xsv9")).getWRMStats)(),
            ...(0, (0, parcelRequire("3Itig")).getPageSizeInfo)({
                start: start,
                stop: stop
            }),
            ...(0, (0, parcelRequire("5YDBW")).getCacheHitRatio)({
                start: start
            }),
            ...(0, (0, parcelRequire("5uZVJ")).getCHRInfo)({
                start: start
            }),
            ...(0, (0, parcelRequire("ax2PR")).getSSRStateInformation)(),
            'app:version:web': window.BUILD_KEY,
            'app:version:ssr': window.SSR_BUILD_KEY,
            'app:framework:name': 'react',
            'app:framework:version': (0, $5uXOq.version)
        };
        return customData;
    }
});
parcelRegister("sUexw", function(module, exports) {
    $parcel$export(module.exports, "getAssetEncoding", ()=>$7cf3b2ddfe1abab1$export$fd12d8f45e126585);
    function $7cf3b2ddfe1abab1$export$fd12d8f45e126585() {
        const assetEncodings = Array.prototype.map.call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')).reduce((acc, i)=>{
            acc[i] = true;
            return acc;
        }, {});
        const uniqueEncodings = Object.keys(assetEncodings).sort();
        let result = 'unknown';
        if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
        if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
        return result;
    }
});
parcelRegister("5YDBW", function(module, exports) {
    $parcel$export(module.exports, "getCacheHitRatio", ()=>$62c0824bd7614469$export$e8a9322c3d9da8a6);
    var $6RCeq;
    const $62c0824bd7614469$var$cacheableTypes = [
        'script',
        'link'
    ];
    const $62c0824bd7614469$var$CACHE_NETWORK = 'network';
    const $62c0824bd7614469$var$CACHE_MEMORY = 'memory';
    const $62c0824bd7614469$var$CACHE_DISK = 'disk';
    const $62c0824bd7614469$var$calculateTransferType = (type, duration, size)=>{
        if (!$62c0824bd7614469$var$cacheableTypes.includes(type)) return $62c0824bd7614469$var$CACHE_NETWORK;
        if ((size === undefined || size === 0) && duration === 0) return $62c0824bd7614469$var$CACHE_MEMORY;
        if (size === 0 && duration > 0) return $62c0824bd7614469$var$CACHE_DISK;
        if (size === undefined) return null;
        return $62c0824bd7614469$var$CACHE_NETWORK;
    };
    const $62c0824bd7614469$export$e8a9322c3d9da8a6 = ({ start: start })=>{
        let fromCache = 0;
        let preloadFromCache = 0;
        let total = 0;
        let totalPreload = 0;
        if (start !== 0) return {};
        try {
            for (const entry of (0, (0, parcelRequire("6RCeq")).default).getEntriesByType('resource')){
                const transferType = $62c0824bd7614469$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
                const isPreload = entry.initiatorType === 'link';
                if (transferType === 'disk' || transferType === 'memory') {
                    fromCache += 1;
                    if (isPreload) preloadFromCache += 1;
                }
                if (transferType !== null) {
                    total += 1;
                    if (isPreload) totalPreload += 1;
                }
            }
            const result = {};
            if (total > 0) result.cacheHitRatio = fromCache / total;
            if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
            return result;
        } catch (e) {
            return {};
        }
    };
});
parcelRegister("5uZVJ", function(module, exports) {
    $parcel$export(module.exports, "getCHRInfo", ()=>$e76f22784dfe18ae$export$9e005e111be93521);
    var $x9xyg;
    var $6RCeq;
    var $d1SfZ;
    const $e76f22784dfe18ae$var$SPA_SSR_RENDERED = 'ssr.spa.rendered';
    const $e76f22784dfe18ae$export$1faf7d001841a41c = ()=>(0, (0, parcelRequire("x9xyg")).getMark)($e76f22784dfe18ae$var$SPA_SSR_RENDERED)?.startTime || null;
    const $e76f22784dfe18ae$export$9e005e111be93521 = ({ start: start })=>{
        if (start !== 0) return {};
        const ssrMark = $e76f22784dfe18ae$export$1faf7d001841a41c();
        const reporter = new (0, (0, parcelRequire("d1SfZ")).CHRReporter)(ssrMark);
        try {
            for (const entry of (0, (0, parcelRequire("6RCeq")).default).getEntriesByType('resource'))reporter.add(entry);
            const chr = reporter.get();
            return chr === null ? {} : {
                chr: chr
            };
        } catch (e) {
            return {};
        }
    };
});
parcelRegister("d1SfZ", function(module, exports) {
    $parcel$export(module.exports, "CHRReporter", ()=>$850475b27a81c50e$export$7d0d4cfb6455ffa5);
    var $80WiQ;
    var $d1r8j;
    class $850475b27a81c50e$export$7d0d4cfb6455ffa5 {
        constructor(ssrMark){
            this.preloaded = new (0, (0, parcelRequire("d1r8j")).CHRSummary)();
            this.all = new (0, (0, parcelRequire("d1r8j")).CHRSummary)();
            this.ssrMark = null;
            this.ssrMark = ssrMark;
        }
        add(item) {
            if (item.encodedBodySize === 0) return;
            if (item.initiatorType === 'link' && (0, (0, parcelRequire("80WiQ")).cacheableTypes).includes(item.initiatorType) && (this.ssrMark === null || item.startTime < this.ssrMark)) this.preloaded.add(item);
            this.all.add(item);
        }
        static round(n) {
            return Math.round(n * 10000) / 10000;
        }
        makePayload(summary) {
            const bundlesLoadType = {
                mem: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).MEMORY_KEY] / summary.bundlesCount),
                disk: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).DISK_KEY] / summary.bundlesCount),
                net: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).NETWORK_KEY] / summary.bundlesCount)
            };
            const bundlesRatio = $850475b27a81c50e$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).MEMORY_KEY] + summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).DISK_KEY]) / summary.bundlesCount);
            const sizeLoadType = {
                mem: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).MEMORY_KEY] / summary.sizeTotal),
                disk: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).DISK_KEY] / summary.sizeTotal),
                net: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).NETWORK_KEY] / summary.sizeTotal)
            };
            const sizeRatio = $850475b27a81c50e$export$7d0d4cfb6455ffa5.round((summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).MEMORY_KEY] + summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).DISK_KEY]) / summary.sizeTotal);
            return {
                bundles: {
                    ratio: bundlesRatio,
                    count: summary.bundlesCount,
                    loadType: bundlesLoadType
                },
                size: {
                    ratio: sizeRatio,
                    total: summary.sizeTotal,
                    loadType: sizeLoadType
                }
            };
        }
        get() {
            if (this.all.bundlesCount === 0) return null;
            return {
                preloaded: this.makePayload(this.preloaded),
                all: this.makePayload(this.all)
            };
        }
    }
});
parcelRegister("80WiQ", function(module, exports) {
    $parcel$export(module.exports, "cacheableTypes", ()=>$0b57baf495baebc5$export$5e1aa91d6932ddaa);
    const $0b57baf495baebc5$export$5e1aa91d6932ddaa = [
        'script',
        'link'
    ];
});
parcelRegister("d1r8j", function(module, exports) {
    $parcel$export(module.exports, "CHRSummary", ()=>$d000becd84478ee1$export$783d6618ee601ba);
    var $80WiQ;
    const $d000becd84478ee1$var$calculateTransferType = (type, duration, size)=>{
        if (!(0, (0, parcelRequire("80WiQ")).cacheableTypes).includes(type)) return null;
        if ((size === undefined || size === 0) && duration === 0) return $d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY;
        if (size === 0 && duration > 0) return $d000becd84478ee1$export$783d6618ee601ba.DISK_KEY;
        if (size === undefined) return null;
        return $d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY;
    };
    class $d000becd84478ee1$export$783d6618ee601ba {
        static{
            this.MEMORY_KEY = 'mem';
        }
        static{
            this.DISK_KEY = 'disk';
        }
        static{
            this.NETWORK_KEY = 'net';
        }
        add(item) {
            const type = $d000becd84478ee1$var$calculateTransferType(item.initiatorType, item.duration, item.transferSize);
            if (type === null) return;
            this.bundles[type] += 1;
            this.bundlesCount += 1;
            this.size[type] += item.encodedBodySize;
            this.sizeTotal += item.encodedBodySize;
        }
        constructor(){
            this.bundles = {
                [$d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY]: 0,
                [$d000becd84478ee1$export$783d6618ee601ba.DISK_KEY]: 0,
                [$d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY]: 0
            };
            this.bundlesCount = 0;
            this.size = {
                [$d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY]: 0,
                [$d000becd84478ee1$export$783d6618ee601ba.DISK_KEY]: 0,
                [$d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY]: 0
            };
            this.sizeTotal = 0;
        }
    }
});
parcelRegister("eV38z", function(module, exports) {
    $parcel$export(module.exports, "getLighthouseMetrics", ()=>$45336243ca9d66b9$export$b46cecdf698e4bb5);
    var $akIBh;
    var $5HXkx;
    var $7hESW;
    var $aOwtG;
    var $8YqT3;
    function $45336243ca9d66b9$export$5ecf2aafafee3e0() {
        (0, (0, parcelRequire("8YqT3")).startLSObserver)();
        (0, (0, parcelRequire("8YqT3")).startLTObserver)();
    }
    const $45336243ca9d66b9$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
        const tbt = (0, (0, parcelRequire("7hESW")).getTBT)(start, stop, (0, (0, parcelRequire("aOwtG")).EntriesBuffer)[(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask]);
        const cls = (0, (0, parcelRequire("akIBh")).getCLS)(start, stop, (0, (0, parcelRequire("aOwtG")).EntriesBuffer)[(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift]);
        return {
            'metric:tbt': Math.round(tbt.total),
            'metric:tbt:observed': Math.round(tbt.observed),
            'metric:cls': cls
        };
    };
});
parcelRegister("akIBh", function(module, exports) {
    $parcel$export(module.exports, "getCLS", ()=>$b182c515ac203eb1$export$fc6227831ee7c7);
    const $b182c515ac203eb1$export$fc6227831ee7c7 = (start, stop, buffer)=>{
        const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
        const sessionWindows = [];
        let currentWindow = null;
        for (const shift of layoutShifts){
            const { startTime: startTime } = shift;
            const endTime = shift.startTime + shift.duration;
            const score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
        const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
        return Math.round(maxScore * 10000) / 10000;
    };
});
parcelRegister("5HXkx", function(module, exports) {
    $parcel$export(module.exports, "PerformanceObserverEntryTypes", ()=>$b2a196da23758bb0$export$a4def92db6fc8e17);
    const $b2a196da23758bb0$export$a4def92db6fc8e17 = {
        LayoutShift: 'layout-shift',
        LongTask: 'longtask'
    };
});
parcelRegister("7hESW", function(module, exports) {
    $parcel$export(module.exports, "getTBT", ()=>$e79996724decdf66$export$2d6e933b35bd3407);
    const $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
    const $e79996724decdf66$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
            const longTaskStop = entry.startTime + entry.duration;
            const intersectStart = Math.max(entry.startTime + $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION, start);
            const intersectStop = Math.min(longTaskStop, stop);
            const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
            tbt.observed += entry.duration - $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION;
            tbt.total += longTaskIncluded;
            return tbt;
        }, {
            total: 0,
            observed: 0
        });
});
parcelRegister("aOwtG", function(module, exports) {
    $parcel$export(module.exports, "EntriesBuffer", ()=>$14dd3fd4391f2796$export$f7dc16cbd16f7bbe);
    var $5HXkx;
    class $14dd3fd4391f2796$export$2c6e86519c9e8188 {
        constructor(maxLength = 1000){
            this.buffer = [];
            this.full = false;
            this.maxLength = maxLength;
        }
        push(item) {
            if (this.full || this.maxLength === this.buffer.length) {
                this.full = true;
                this.buffer.shift();
            }
            this.buffer.push(item);
        }
        getAll() {
            return this.buffer;
        }
    }
    const $14dd3fd4391f2796$export$f7dc16cbd16f7bbe = {
        [(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask]: new $14dd3fd4391f2796$export$2c6e86519c9e8188(),
        [(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift]: new $14dd3fd4391f2796$export$2c6e86519c9e8188()
    };
});
parcelRegister("8YqT3", function(module, exports) {
    $parcel$export(module.exports, "startLSObserver", ()=>$f3198686c7919898$export$768ccc3ab7bac3ea);
    $parcel$export(module.exports, "startLTObserver", ()=>$f3198686c7919898$export$54fb8b6aaf70ec9c);
    var $5HXkx;
    var $aOwtG;
    let $f3198686c7919898$var$pe = null;
    const $f3198686c7919898$var$getObserver = ()=>{
        if ($f3198686c7919898$var$pe !== null) return $f3198686c7919898$var$pe;
        $f3198686c7919898$var$pe = new PerformanceObserver((list)=>{
            list.getEntries().forEach((entry)=>{
                if (entry.entryType === (0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift) (0, (0, parcelRequire("aOwtG")).EntriesBuffer)[(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift].push(entry);
                if (entry.entryType === (0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask) (0, (0, parcelRequire("aOwtG")).EntriesBuffer)[(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask].push(entry);
            });
        });
        return $f3198686c7919898$var$pe;
    };
    const $f3198686c7919898$export$768ccc3ab7bac3ea = ()=>{
        $f3198686c7919898$var$getObserver().observe({
            type: (0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift,
            buffered: true
        });
    };
    const $f3198686c7919898$export$54fb8b6aaf70ec9c = ()=>{
        $f3198686c7919898$var$getObserver().observe({
            type: (0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask,
            buffered: true
        });
    };
});
parcelRegister("jgkaQ", function(module, exports) {
    $parcel$export(module.exports, "getMarks", ()=>$0fe8913ad7f2f853$export$9d952633c9c2237b);
    var $bobSR;
    var $fDtbf;
    const $0fe8913ad7f2f853$export$9d952633c9c2237b = (data)=>{
        const userTiming = (0, (0, parcelRequire("bobSR")).getUserTiming)();
        if (userTiming === null) return null;
        const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
        const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
            let candidateName = baseName;
            let counter = 2;
            let validName;
            while(!validName)if (candidateName in collection) {
                candidateName = `${baseName}_${counter}`;
                counter += 1;
            } else validName = candidateName;
            return validName;
        };
        const marks = {};
        userTiming.filter((item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START)) && !item.name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_STOP)) && item.startTime >= data.start).forEach((item)=>{
            const name = getNextAvailableName({
                baseName: `mark__${sanitizeName(item.name)}`,
                collection: marks
            });
            marks[name] = Math.round(item.startTime - data.start);
        });
        return marks;
    };
});
parcelRegister("9NJeU", function(module, exports) {
    $parcel$export(module.exports, "getMemoryUsageReport", ()=>$8fa3790b95082ce5$export$e5bd2d61c7c80651);
    const $8fa3790b95082ce5$export$e5bd2d61c7c80651 = ({ start: start, stop: stop })=>{
        if (typeof performance === 'undefined' || performance?.memory == null) return null;
        const sessionTime = Math.round(stop - start);
        const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
        return {
            sessionTime: sessionTime,
            performanceMemoryEntry: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        };
    };
});
parcelRegister("3Itig", function(module, exports) {
    $parcel$export(module.exports, "getPageSizeMetrics", ()=>$d593ead38e6ee650$export$84e3d676f1564c75);
    $parcel$export(module.exports, "getExtraNavigationTimings", ()=>$d593ead38e6ee650$export$b37a70af06e58097);
    $parcel$export(module.exports, "getPageSizeInfo", ()=>$d593ead38e6ee650$export$b72e035af6568be7);
    var $6RCeq;
    const $d593ead38e6ee650$export$84e3d676f1564c75 = ()=>{
        let maxDepth = -1;
        let maxWidth = -1;
        let numElements = 0;
        const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
            if (!el) return;
            if (depth > maxDepth) maxDepth = depth;
            if (el.children.length > maxWidth) maxWidth = el.children.length;
            let child = el.firstElementChild;
            while(child){
                calculateDOMsizeAndDepth(child, depth + 1);
                if (child.shadowRoot) calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
                child = child.nextElementSibling;
                numElements += 1;
            }
        };
        calculateDOMsizeAndDepth();
        return {
            totalBodyElements: numElements,
            maxNestedLevels: maxDepth,
            maxChildElements: maxWidth
        };
    };
    const $d593ead38e6ee650$export$b37a70af06e58097 = ()=>{
        if (!(0, (0, parcelRequire("6RCeq")).default)) return {};
        const navigation = (0, (0, parcelRequire("6RCeq")).default).getEntriesByType('navigation')[0];
        if (!navigation) return {};
        return {
            decodedBodySize: navigation.decodedBodySize,
            encodedBodySize: navigation.encodedBodySize,
            transferSize: navigation.transferSize
        };
    };
    const $d593ead38e6ee650$var$assetsTypes = [
        'script',
        'link'
    ];
    const $d593ead38e6ee650$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
        const pageSize = $d593ead38e6ee650$export$b37a70af06e58097();
        if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
        const decoded = {
            total: pageSize.decodedBodySize,
            pageSize: pageSize.decodedBodySize,
            assets: 0,
            endpoints: 0
        };
        const encoded = {
            total: pageSize.encodedBodySize,
            pageSize: pageSize.encodedBodySize,
            assets: 0,
            endpoints: 0
        };
        const net = {
            total: pageSize.transferSize,
            assets: 0,
            endpoints: 0
        };
        for (const entry of (0, (0, parcelRequire("6RCeq")).default).getEntriesByType('resource')){
            if (entry.startTime > stop) continue;
            if ($d593ead38e6ee650$var$assetsTypes.includes(entry.initiatorType)) {
                decoded.total += entry.decodedBodySize;
                decoded.assets += entry.decodedBodySize;
                encoded.total += entry.encodedBodySize;
                encoded.assets += entry.encodedBodySize;
                net.total += entry.transferSize;
                net.assets += entry.transferSize;
            } else {
                decoded.total += entry.decodedBodySize;
                decoded.endpoints += entry.decodedBodySize;
                encoded.total += entry.encodedBodySize;
                encoded.endpoints += entry.encodedBodySize;
                net.total += entry.transferSize;
                net.endpoints += entry.transferSize;
            }
        }
        const returnValue = {};
        Object.keys(decoded).forEach((key)=>{
            returnValue[`size:decoded:${key}`] = decoded[key];
        });
        Object.keys(encoded).forEach((key)=>{
            returnValue[`size:encoded:${key}`] = encoded[key];
        });
        Object.keys(net).forEach((key)=>{
            returnValue[`size:net:${key}`] = net[key];
        });
        return returnValue;
    };
});
parcelRegister("6R03U", function(module, exports) {
    $parcel$export(module.exports, "getRouterResourceMetrics", ()=>$7077665729c4125c$export$e703af446a67c7f4);
    const $7077665729c4125c$export$e703af446a67c7f4 = ()=>{
        const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
            if (key !== key.toUpperCase()) return false;
            const resource = window.SPA_STATE[key];
            if (typeof resource !== 'object') return false;
            const resourceResponse = resource[Object.keys(resource)[0]];
            return resourceResponse?.error?.name === 'TimeoutError';
        }) : [];
        return {
            ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
        };
    };
});
parcelRegister("bo7zb", function(module, exports) {
    $parcel$export(module.exports, "getServerDurationMetrics", ()=>$c797c35a7f1d14f1$export$efd8b60b870e5282);
    const $c797c35a7f1d14f1$export$efd8b60b870e5282 = ()=>{
        const metrics = {};
        try {
            const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
            if (serverDurationElem) {
                const serverDuration = Number(serverDurationElem.value);
                if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
            }
            const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
            if (serverTraceIdElem) {
                const serverRequestTraceId = serverTraceIdElem.value;
                metrics.serverRequestTraceId = serverRequestTraceId;
            }
            const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
            if (serverTraceSampledElem) {
                const serverRequestTraceSampled = serverTraceSampledElem.value;
                switch(serverRequestTraceSampled){
                    case 'true':
                        metrics.serverRequestTraceSampled = true;
                        break;
                    case 'false':
                        metrics.serverRequestTraceSampled = false;
                        break;
                    default:
                        metrics.serverRequestTraceSampled = null;
                        break;
                }
            }
            const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
            if (concurrentRequestsElem) {
                const concurrentRequests = concurrentRequestsElem.value;
                metrics.concurrentRequests = concurrentRequests;
            }
            const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
            if (serverRequestStartTimeElem) {
                const serverRequestStartTime = serverRequestStartTimeElem.value;
                metrics.serverRequestStartTime = serverRequestStartTime;
            }
            const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
            if (frontendFlushStartTimeElem) {
                const frontendFlushStartTime = frontendFlushStartTimeElem.value;
                metrics.frontendFlushStartTime = frontendFlushStartTime;
            }
        } catch (ignored) {}
        return metrics;
    };
});
parcelRegister("ax2PR", function(module, exports) {
    $parcel$export(module.exports, "getSSRStateInformation", ()=>$cefad605288b959d$export$9a46186893ad76bd);
    var $x9xyg;
    const $cefad605288b959d$var$getState = ()=>{
        if ((0, (0, parcelRequire("x9xyg")).getMark)('ssr.spa.state')?.startTime) return 'success';
        if ((0, (0, parcelRequire("x9xyg")).getMark)('ssr.spa.early-common-flush:end')?.startTime) return 'spa-render-failure';
        return 'static-fallback';
    };
    const $cefad605288b959d$export$9a46186893ad76bd = ()=>{
        return {
            'ssr:state': $cefad605288b959d$var$getState()
        };
    };
});
parcelRegister("4xsv9", function(module, exports) {
    $parcel$export(module.exports, "getWRMStats", ()=>$a91d766509875677$export$d2d916ddd03b82bc);
    const $a91d766509875677$export$d2d916ddd03b82bc = ()=>{
        const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
        return {
            wrmStats: wrmStats
        };
    };
});
parcelRegister("fJbQ9", function(module, exports) {
    $parcel$export(module.exports, "jiraBundleEvalTimingsConfig", ()=>$f9b1cc066b55fe02$export$791b8c0cbd574ea9);
    var $fDtbf;
    const $f9b1cc066b55fe02$export$791b8c0cbd574ea9 = {
        mapPerformanceMark: (mark)=>{
            if (mark.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))) return {
                name: mark.substring(0, mark.indexOf((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))),
                type: 'start'
            };
            if (mark.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_STOP))) return {
                name: mark.substring(0, mark.indexOf((0, (0, parcelRequire("fDtbf")).JS_EVAL_STOP))),
                type: 'end'
            };
            return null;
        }
    };
});
parcelRegister("itoGf", function(module, exports) {
    $parcel$export(module.exports, "jiraResourceTimingsConfig", ()=>$be8f5f0d3efbf58f$export$8fa71550bcdc2104);
    var $aZsz6 = parcelRequire("aZsz6");
    var $6pIol;
    const $be8f5f0d3efbf58f$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
    const $be8f5f0d3efbf58f$var$getWRMAssetName = (url)=>{
        const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
        const assetName = (0, (0, parcelRequire("6pIol")).sanitiseAssetName)(false)(url);
        if (!resources) return assetName;
        return `wrm/${resources}/${assetName}`;
    };
    const $be8f5f0d3efbf58f$var$getFileName = (url)=>$be8f5f0d3efbf58f$var$isWRMResource(url) ? $be8f5f0d3efbf58f$var$getWRMAssetName(url) : (0, (0, parcelRequire("6pIol")).sanitiseAssetName)(false)(url);
    const $be8f5f0d3efbf58f$var$sanitiseEndpoints = (url)=>{
        const parsedUrl = (0, ($parcel$interopDefault($aZsz6)))(url, true);
        const { operation: operation, operationName: operationName } = parsedUrl.query;
        const operationNameOverride = operation ?? operationName;
        if (operationNameOverride) return `/${operation}?operation=${operation}`;
        const fileName = parsedUrl.pathname.replace(/\/(project|agent)(-config|s)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(servicedesk)(-data)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(browse|automation|pagination|permissions|async|dialog|itsm)\/([A-Z0-9]+)/g, '/$1/<project-key>').replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>').replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>').replace(/\/user\/[a-fA-F0-9\-:]+/i, '/user/<user-id>').replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/i, '<uuid>').replace(/\/\d+$/i, '/<id>');
        return fileName;
    };
    const $be8f5f0d3efbf58f$export$8fa71550bcdc2104 = {
        sanitiseEndpoints: $be8f5f0d3efbf58f$var$sanitiseEndpoints,
        mapResources: $be8f5f0d3efbf58f$var$getFileName,
        hasTimingHeaders: (url)=>url.includes('jira-frontend-static') || url.includes('jira-frontend-branch') || url.includes('jira-frontend-bifrost') || $be8f5f0d3efbf58f$var$isWRMResource(url),
        xhrFilter: (url)=>url.includes('/rest/greenhopper/')
    };
});
parcelRegister("dQKfU", function(module, exports) {
    $parcel$export(module.exports, "jiraSsrConfig", ()=>$ba8cdb329bff9946$export$7bcf91e323db67dd);
    var $LpImS = parcelRequire("LpImS");
    var $x9xyg;
    var $6RCeq;
    var $4R6GH;
    var $j8DrX;
    function $ba8cdb329bff9946$var$insertTotalTiming(key, timings) {
        const timingValues = timings && Object.values(timings);
        if (!timingValues || !timingValues.length) return timings;
        const startTime = Math.min(...timingValues.map(({ startTime: startTime })=>startTime));
        const endTime = timingValues.reduce((max, { startTime: startTime, duration: duration })=>Math.max(max, startTime + duration), 0);
        const duration = endTime - startTime;
        timings[key] = {
            startTime: startTime,
            duration: duration
        };
        return timings;
    }
    function $ba8cdb329bff9946$var$applyTimingOverrides(timings, { startTimeOffsetMs: startTimeOffsetMs = 0, prefix: prefix = '' } = {}) {
        return timings && Object.fromEntries(Object.entries(timings).map(([key, value])=>{
            const startTime = value.startTime + startTimeOffsetMs;
            return [
                [
                    prefix,
                    key
                ].filter(Boolean).join('/'),
                {
                    ...value,
                    startTime: startTime
                }
            ];
        }));
    }
    function $ba8cdb329bff9946$var$getTesseractTimings() {
        if (!globalThis.SPA_STATE) return null;
        const detailRenderTrace = globalThis.SPA_STATE['ssr/detail_render_trace'];
        const detailRequestTrace = globalThis.SPA_STATE['ssr/detail_request_trace'];
        const highLevelMetrics = globalThis.SPA_STATE['ssr/metrics'];
        const timings = (0, ($parcel$interopDefault($LpImS)))(detailRenderTrace?.data?.traces) || {};
        if (highLevelMetrics?.data) {
            if ('ssrTotal' in highLevelMetrics.data) {
                const totalKey = (0, (0, parcelRequire("4R6GH")).fg)('jira-ssr-update-perf-portal-timings') ? '' : 'total';
                timings[totalKey] = {
                    startTime: 0,
                    duration: highLevelMetrics.data.ssrTotal
                };
            }
            if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
                startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
                duration: highLevelMetrics.data.ssrGetStyle
            };
            if ('ssrPrefetch' in highLevelMetrics.data) {
                const prefetchStartTime = Object.values(detailRenderTrace?.data?.traces || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
                timings.prefetch = {
                    startTime: prefetchStartTime,
                    duration: highLevelMetrics.data.ssrPrefetch
                };
            }
        }
        if (detailRequestTrace?.data) Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
            timings[`prefetch/${key}`] = value;
        });
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira-ssr-update-perf-portal-timings')) return timings;
        return $ba8cdb329bff9946$var$insertTotalTiming('', timings);
    }
    const $ba8cdb329bff9946$var$jiraFeGatewayEarlyFlushKeys = new Set([
        'metatags',
        'feature-flags',
        'statsig',
        'inline-assets',
        'async-inline-assets',
        'css-assets',
        'priority-assets',
        'early-route-flush'
    ]);
    const $ba8cdb329bff9946$var$jiraFeGatewayFilteredKeys = [
        'early-common-flush',
        'prerender-total',
        'resolve-assets'
    ];
    function $ba8cdb329bff9946$var$getJiraFeGatewayTimings() {
        const rawTimings = globalThis._JFGTimings;
        if (!rawTimings) return null;
        const jiraFeGatewayTimings = Object.fromEntries(rawTimings.filter(({ name: name })=>!$ba8cdb329bff9946$var$jiraFeGatewayFilteredKeys.includes(name)).map(({ startTime: startTime, duration: duration, name: name })=>[
                $ba8cdb329bff9946$var$jiraFeGatewayEarlyFlushKeys.has(name) ? `early-flush/${name}` : name,
                {
                    startTime: startTime,
                    duration: duration
                }
            ]));
        return $ba8cdb329bff9946$var$insertTotalTiming('', jiraFeGatewayTimings);
    }
    function $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration(timingMetricKey) {
        const inputElementWithTimingValue = globalThis.document?.querySelector(`#jira_request_timing_info [title="${timingMetricKey}"]`);
        return Number(inputElementWithTimingValue?.value ?? 0);
    }
    function $ba8cdb329bff9946$var$getLegacyJiraMonolithTimings() {
        const duration = $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration('jira.request.server.time');
        if (!duration) return null;
        const timings = {
            '': {
                startTime: 0,
                duration: duration
            },
            'flush-head': {
                startTime: 0,
                duration: $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration('jira.request.server.head.time')
            }
        };
        return timings;
    }
    const $ba8cdb329bff9946$var$monolithTimerRenames = {
        'jira-request-server-time': ''
    };
    function $ba8cdb329bff9946$var$getJiraMonolithTimings() {
        if (!globalThis._monolithTimings) return $ba8cdb329bff9946$var$getLegacyJiraMonolithTimings();
        return Object.fromEntries(Object.entries(globalThis._monolithTimings).map(([name, { start: startTime, duration: duration }])=>[
                $ba8cdb329bff9946$var$monolithTimerRenames[name] ?? name,
                {
                    startTime: startTime,
                    duration: duration
                }
            ]));
    }
    function $ba8cdb329bff9946$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings) {
        if (jiraBeTimings || !tesseractTimings) return null;
        const timings = {
            '': {
                startTime: 0,
                duration: tesseractTimings['']?.duration
            }
        };
        return timings;
    }
    function $ba8cdb329bff9946$var$getOffsetToAlignTimers(referenceTimer, timerToShift) {
        if (!referenceTimer || !timerToShift) return null;
        if (referenceTimer.duration >= timerToShift.duration) return referenceTimer.startTime + referenceTimer.duration - (timerToShift.startTime + timerToShift.duration);
        else return referenceTimer.startTime - timerToShift.startTime;
    }
    function $ba8cdb329bff9946$var$getJfgOffset({ jiraFeGatewayTimings: jiraFeGatewayTimings, jiraBeTimings: jiraBeTimings }) {
        const jiraBeTiming = jiraBeTimings?.['jira-monolith/feGateway'] ?? jiraBeTimings?.['jira-monolith'];
        return $ba8cdb329bff9946$var$getOffsetToAlignTimers(jiraBeTiming, jiraFeGatewayTimings?.['']) ?? 0;
    }
    function $ba8cdb329bff9946$var$getTesseractOffset({ tesseractTimings: tesseractTimings, jiraFeGatewayTimings: jiraFeGatewayTimings, bifrostGatewayTimings: bifrostGatewayTimings }) {
        const jiraFeGatewayTiming = jiraFeGatewayTimings?.['jira-fe-gateway/fetch-tesseract'];
        const jiraBeTesseractOffest = $ba8cdb329bff9946$var$getOffsetToAlignTimers(jiraFeGatewayTiming, tesseractTimings?.['']);
        const bifrostGatewayTiming = bifrostGatewayTimings?.['bifrost-gateway'];
        const bifrostOffset = $ba8cdb329bff9946$var$getOffsetToAlignTimers(bifrostGatewayTiming, tesseractTimings?.['']);
        return bifrostOffset ?? jiraBeTesseractOffest ?? 0;
    }
    function $ba8cdb329bff9946$var$getEdgeTime() {
        const navigatonPerfTimingEntry = (0, (0, parcelRequire("6RCeq")).default)?.getEntriesByType('navigation')?.[0];
        return navigatonPerfTimingEntry?.serverTiming?.find(({ name: name })=>name === 'atl-edge')?.duration ?? 0;
    }
    function $ba8cdb329bff9946$export$6d488733a547304() {
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira-ssr-update-perf-portal-timings')) return $ba8cdb329bff9946$var$getTesseractTimings();
        const jiraBeTimings = $ba8cdb329bff9946$var$getJiraMonolithTimings();
        const jiraFeGatewayTimings = $ba8cdb329bff9946$var$getJiraFeGatewayTimings();
        const tesseractTimings = $ba8cdb329bff9946$var$getTesseractTimings();
        const bifrostGatewayTimings = $ba8cdb329bff9946$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings);
        const edgeTime = $ba8cdb329bff9946$var$getEdgeTime();
        const finalJiraBeTimings = $ba8cdb329bff9946$var$applyTimingOverrides(jiraBeTimings, {
            startTimeOffsetMs: edgeTime,
            prefix: 'jira-monolith'
        });
        const finalBifrostGatewayTimings = $ba8cdb329bff9946$var$applyTimingOverrides(bifrostGatewayTimings, {
            startTimeOffsetMs: edgeTime,
            prefix: 'bifrost-gateway'
        });
        const jfgOffset = $ba8cdb329bff9946$var$getJfgOffset({
            jiraFeGatewayTimings: jiraFeGatewayTimings,
            jiraBeTimings: finalJiraBeTimings
        });
        const finalJfgTimings = $ba8cdb329bff9946$var$applyTimingOverrides(jiraFeGatewayTimings, {
            startTimeOffsetMs: jfgOffset,
            prefix: 'jira-fe-gateway'
        });
        const tesseractOffset = $ba8cdb329bff9946$var$getTesseractOffset({
            tesseractTimings: tesseractTimings,
            jiraFeGatewayTimings: finalJfgTimings,
            bifrostGatewayTimings: finalBifrostGatewayTimings
        });
        const finalTesseractTimings = $ba8cdb329bff9946$var$applyTimingOverrides(tesseractTimings, {
            startTimeOffsetMs: tesseractOffset,
            prefix: 'tesseract'
        });
        const timings = {
            ...edgeTime && {
                edge: {
                    startTime: 0,
                    duration: edgeTime
                }
            },
            ...finalJiraBeTimings,
            ...finalJfgTimings,
            ...finalBifrostGatewayTimings,
            ...finalTesseractTimings
        };
        $ba8cdb329bff9946$var$insertTotalTiming('total', timings);
        return Object.keys(timings).length ? timings : null;
    }
    const $ba8cdb329bff9946$var$SSR_FF_META_TAG = 'spa-service-flags';
    let $ba8cdb329bff9946$var$ffCache;
    let $ba8cdb329bff9946$var$ffCacheInitialiser = ()=>{
        try {
            const metaTagValue = (0, (0, parcelRequire("j8DrX")).default)($ba8cdb329bff9946$var$SSR_FF_META_TAG);
            if (metaTagValue === null) return null;
            $ba8cdb329bff9946$var$ffCache = JSON.parse(metaTagValue) || null;
        } catch (e) {
            $ba8cdb329bff9946$var$ffCache = null;
        }
        $ba8cdb329bff9946$var$ffCacheInitialiser = null;
    };
    function $ba8cdb329bff9946$var$getFeatureFlags() {
        if ($ba8cdb329bff9946$var$ffCacheInitialiser != null) $ba8cdb329bff9946$var$ffCacheInitialiser();
        return $ba8cdb329bff9946$var$ffCache;
    }
    const $ba8cdb329bff9946$export$7bcf91e323db67dd = {
        getDoneMark: ()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('ssr_success_when_spa_success')) {
                const SPASSRRenderedMark = (0, (0, parcelRequire("x9xyg")).getMark)((0, $ce556f125dee8174$export$135c96ab5afee429))?.startTime;
                if (SPASSRRenderedMark && (0, (0, parcelRequire("x9xyg")).getMark)('ssr.spa.state')?.startTime) return SPASSRRenderedMark;
                return null;
            }
            return (0, (0, parcelRequire("x9xyg")).getMark)((0, $ce556f125dee8174$export$135c96ab5afee429))?.startTime || null;
        },
        getTimings: $ba8cdb329bff9946$export$6d488733a547304,
        getFeatureFlags: $ba8cdb329bff9946$var$getFeatureFlags
    };
});
parcelRegister("3qHVS", function(module, exports) {
    $parcel$export(module.exports, "visualRefreshResolverOverride", ()=>$56907fa85239d7b0$export$73a94df81a7c0f2c);
    var $dCm1o;
    const $56907fa85239d7b0$var$visualRefreshPlatformFlags = [
        'platform-component-visual-refresh',
        'platform-visual-refresh-icons-legacy-facade',
        'platform-visual-refresh-icons'
    ];
    const $56907fa85239d7b0$export$73a94df81a7c0f2c = [
        (flagKey)=>$56907fa85239d7b0$var$visualRefreshPlatformFlags.includes(flagKey),
        (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)
    ];
});
parcelRegister("2ChuC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe3490a17e762431$export$2e2bcd8739ae039);
    var $fr1K2 = parcelRequire("fr1K2");
    var $6YRTH;
    var $co1wz;
    var $j8DrX;
    var $7AZuS = parcelRequire("7AZuS");
    var $7o9iL = parcelRequire("7o9iL");
    const $fe3490a17e762431$var$isHeartbeatEnabled = ()=>(0, (0, parcelRequire("co1wz")).ff)('jfp.heartbeat_vfp2h', false);
    const $fe3490a17e762431$var$renderEngagementMessages = ()=>{
        (parcelRequire("1mY2B"));
    };
    const $fe3490a17e762431$var$renderProfileCardNextLegacy = ()=>{
        (parcelRequire("bUWQg"));
    };
    const $fe3490a17e762431$var$renderHeartbeat = ()=>{
        (parcelRequire("5PCBy"));
    };
    const $fe3490a17e762431$var$loadUpFlowAPI = ()=>(parcelRequire("4MqrY"));
    const $fe3490a17e762431$var$installConnectModules = ()=>(parcelRequire("hkk3A"));
    const $fe3490a17e762431$var$markSafeForAnalytics = (str)=>str || null;
    const $fe3490a17e762431$var$renderSearchDwellTimeComponent = ()=>{
        const searchSessionId = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-session-id');
        const containerId = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-container-id');
        const objectId = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-object-id');
        const objectType = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-content-type');
        (0, (0, parcelRequire("6YRTH")).default)([
            'searchSessionId',
            'searchObjectId',
            'searchContainerId',
            'searchContentType'
        ]);
        (0, $7o9iL.default)('search-dwell-time', $fe3490a17e762431$var$markSafeForAnalytics(searchSessionId), {
            containerId: $fe3490a17e762431$var$markSafeForAnalytics(containerId),
            objectId: $fe3490a17e762431$var$markSafeForAnalytics(objectId),
            objectType: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
            actionSubject: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
            source: $fe3490a17e762431$var$markSafeForAnalytics(objectType)
        });
    };
    const $fe3490a17e762431$var$installHighPriorityApps = (args)=>{
        const priorityApps = [];
        if (args.flags) priorityApps.push((0, $7AZuS.renderFlags)());
        if (args.navigation) priorityApps.push(args.renderNavigation());
        return priorityApps;
    };
    const $fe3490a17e762431$var$installLowPriorityApps = (args)=>{
        if (args.upflow) $fe3490a17e762431$var$loadUpFlowAPI();
        if (args.profileCardNextLegacy) $fe3490a17e762431$var$renderProfileCardNextLegacy();
        if (args.connectModules) $fe3490a17e762431$var$installConnectModules();
        if (args.engagementMessages) $fe3490a17e762431$var$renderEngagementMessages();
        if (args.heartbeat) $fe3490a17e762431$var$renderHeartbeat();
        if (args.searchDwellTimeComponent) $fe3490a17e762431$var$renderSearchDwellTimeComponent();
    };
    const $fe3490a17e762431$var$installAppsWithPriorityOrder = async (args)=>{
        await Promise.all($fe3490a17e762431$var$installHighPriorityApps({
            flags: args.flags,
            navigation: args.navigation,
            renderNavigation: args.renderNavigation
        }));
        $fe3490a17e762431$var$installLowPriorityApps((0, ($parcel$interopDefault($fr1K2)))(args, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
    };
    const $fe3490a17e762431$var$defaultArgs = {
        flags: true,
        navigation: true,
        upflow: true,
        profileCardNextLegacy: true,
        heartbeat: $fe3490a17e762431$var$isHeartbeatEnabled(),
        connectModules: true,
        engagementMessages: true,
        searchDwellTimeComponent: true,
        renderNavigation: ()=>null
    };
    var $fe3490a17e762431$export$2e2bcd8739ae039 = {
        install: (args)=>{
            const argsWithDefaults = {
                ...$fe3490a17e762431$var$defaultArgs,
                ...args
            };
            $fe3490a17e762431$var$installAppsWithPriorityOrder(argsWithDefaults);
        },
        installHighPriorityApps: (args)=>{
            const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
                ...$fe3490a17e762431$var$defaultArgs,
                ...args
            };
            $fe3490a17e762431$var$installHighPriorityApps({
                flags: flags,
                navigation: navigation,
                renderNavigation: renderNavigation
            });
        },
        installLowPriorityApps: (args)=>{
            const installArgs = (0, ($parcel$interopDefault($fr1K2)))({
                ...$fe3490a17e762431$var$defaultArgs,
                ...args
            }, [
                'flags',
                'navigation',
                'renderNavigation'
            ]);
            $fe3490a17e762431$var$installLowPriorityApps(installArgs);
        }
    };
});
parcelRegister("7AZuS", function(module, exports) {
    $parcel$export(module.exports, "renderFlags", ()=>$271711a34feab2aa$export$b6228dc14c5adf51);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $dJl1T;
    var $jsLXn;
    var $iNWLk;
    var $5eQ1m;
    var $kxZPA;
    const $271711a34feab2aa$var$throwError = (message)=>{
        const error = new Error(message);
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('flags.entry', message, error);
        throw error;
    };
    const $271711a34feab2aa$var$getContainer = ()=>{
        let container = document.getElementById('flags');
        if (container == null) {
            container = document.createElement('div');
            container.id = 'flags';
            if (document.body) document.body.appendChild(container);
            else $271711a34feab2aa$var$throwError('document.body was not found whilst trying to create the flags container');
        }
        return container;
    };
    const $271711a34feab2aa$var$Flags = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aw7rz")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
    });
    const $271711a34feab2aa$var$AfterPaintFlags = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("aw7rz")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
    });
    const $271711a34feab2aa$export$b6228dc14c5adf51 = ()=>(0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQ1m")).StrictMode), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jsLXn")).JiraContextContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: "flags-entry"
        }, __SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$AfterPaintFlags, null) : (0, ($parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$Flags, null)))), $271711a34feab2aa$var$getContainer());
});
parcelRegister("aw7rz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("h46oV")
    ]).then(()=>parcelRequire('3jTq3'));
});
parcelRegister("7o9iL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87698987077682aa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $5eQ1m;
    var $TtQEC;
    const $87698987077682aa$var$getPlaceholder = (placeholderId)=>{
        const existingPlaceholder = document.getElementById(placeholderId);
        if (existingPlaceholder) return existingPlaceholder;
        const div = document.createElement('div');
        div.id = placeholderId;
        if (document.body) document.body.appendChild(div);
        else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
        return div;
    };
    const $87698987077682aa$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
        if (placeholder && sessionId) (0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQ1m")).StrictMode), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("TtQEC")).default), {
            sessionId: sessionId,
            data: data
        })), $87698987077682aa$var$getPlaceholder(placeholder));
    };
    var $87698987077682aa$export$2e2bcd8739ae039 = $87698987077682aa$var$renderDwellTimeComponent;
});
parcelRegister("1mY2B", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2ZtG1")
    ]).then(()=>parcelRequire('2Q8el'));
});
parcelRegister("bUWQg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("54DPr")
    ]).then(()=>parcelRequire('forzB'));
});
parcelRegister("5PCBy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bERdS").then(()=>parcelRequire('8ymsB'));
});
parcelRegister("4MqrY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("kWrFZ"),
        $6fhBS("i5RRW"),
        $6fhBS("561Jq"),
        $6fhBS("1QYl5"),
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("hPzOn"),
        $6fhBS("dsiAd"),
        $6fhBS("eNmuD"),
        $6fhBS("dzRix")
    ]).then(()=>parcelRequire('faPQm'));
});
parcelRegister("hkk3A", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Nlduf").then(()=>parcelRequire('jEc6C'));
});
parcelRegister("5UHoB", function(module, exports) {
    $parcel$export(module.exports, "layoutWithCondition", ()=>$201222bac9c3aac5$export$c5db53e93ba35c0f);
    const $201222bac9c3aac5$export$c5db53e93ba35c0f = (conditionGetter, itemTrue, itemFalse)=>({
            get isChromeless () {
                return conditionGetter() ? itemTrue.isChromeless : itemFalse.isChromeless;
            },
            get globalComponents () {
                return conditionGetter() ? itemTrue.globalComponents : itemFalse.globalComponents;
            },
            get rightSidebars () {
                return conditionGetter() ? itemTrue.rightSidebars : itemFalse.rightSidebars;
            }
        });
});
$parcel$global.rwr("jfj4N", ()=>{
    parcelRequire("lRSO6");
    parcelRequire("8oLfs");
    var $x9xyg;
    var $5uXOq = parcelRequire("5uXOq");
    const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
    const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
    const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
    const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
    const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
    const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
    const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
    const $281cbd47ba46dd7d$export$6d592df97fba16ca = 'GIN_GLOBAL_ISSUE_NAVIGATOR';
    const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
    const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
    const $281cbd47ba46dd7d$export$4ce203fc8c0eb2d1 = 'ISSUE_MOVE';
    const $281cbd47ba46dd7d$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
    const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
    const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';
    var $87OsA;
    var $65Ltd;
    var $adY3A;
    const $6a0b20679c309df7$export$56ea489e9d4bfa04 = (page)=>({
            root: page.main.root,
            getPreloadProps: (entryPointParams)=>({
                    entryPoints: {
                        [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                            entryPoint: page.main,
                            entryPointParams: entryPointParams
                        }
                    }
                }),
            toString: ()=>'ChromelessEntryPoint'
        });
    const $6a0b20679c309df7$export$955a7619d2679b4c = (page)=>({
            root: page.main.root,
            getPreloadProps: (entryPointParams)=>({
                    entryPoints: {
                        [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                            entryPoint: page.main,
                            entryPointParams: entryPointParams
                        },
                        [(0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae)]: {
                            entryPoint: (0, (0, parcelRequire("adY3A")).topNavigationEntryPoint),
                            entryPointParams: {
                                menuId: page.topNavigationMenuId
                            }
                        },
                        ...page.horizontalNavigation ? {
                            [(0, $6d6ccf8a2b2c5b3c$export$948d4d345566aed3)]: {
                                entryPoint: page.horizontalNavigation,
                                entryPointParams: {}
                            }
                        } : undefined,
                        ...page.rightSidebar ? {
                            [(0, $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb)]: {
                                entryPoint: page.rightSidebar,
                                entryPointParams: entryPointParams
                            }
                        } : undefined
                    }
                }),
            toString: ()=>'PageEntryPoint'
        });
    var $4R6GH;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $2Ql51;
    var $65Ltd;
    const $56923034cf89b966$export$df82cc5024b7f316 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/calendar/embed'
    };
    var $5lsNZ;
    var $kZOse;
    var $6s1PB;
    var $4R6GH;
    const $122674b135b0c50b$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "100c7db672b19d2b2551c4375145f7b97031fc11294e0dc0615a428d1f472fc3",
            "metadata": {},
            "name": "ui_jiraCalendarQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $122674b135b0c50b$export$2e2bcd8739ae039 = $122674b135b0c50b$var$node;
    var $eufEc;
    var $fEDBv;
    const $8623df52c8647276$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED = 'software-plan-calendar-embed';
    const $8623df52c8647276$var$SETTINGS_STORAGE_KEY = 'plans_calendar_view_settings';
    function $8623df52c8647276$var$getViewSettings(key) {
        try {
            const serializedValue = globalThis.localStorage?.getItem(key);
            return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
        } catch  {
            return undefined;
        }
    }
    function $8623df52c8647276$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
        return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
    }
    function $8623df52c8647276$var$getStorageKeyFromScope(context) {
        const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
        const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
        return `${LOCALSTORAGE_KEY_PREFIX}/plan/${planId}/scenario/${scenarioId}`;
    }
    function $8623df52c8647276$var$getStorageValueFromScope(key) {
        const storedData = globalThis.localStorage?.getItem(key) || '';
        return storedData;
    }
    function $8623df52c8647276$var$toMidnightUTCString(date) {
        const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        return new Date(utcMilliseconds).toISOString();
    }
    function $8623df52c8647276$var$toDate(date) {
        if (!date) return new Date();
        try {
            const _date = new Date(date);
            return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
        } catch (e) {
            return new Date();
        }
    }
    function $8623df52c8647276$var$createScope({ context: context, tenantContext: tenantContext }) {
        const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const planScenarioAri = $8623df52c8647276$var$toPlanScenarioAri({
            siteId: cloudId,
            activationId: activationId,
            planId: String(planId),
            scenarioId: String(scenarioId)
        });
        return {
            type: 'plan',
            ids: [
                planScenarioAri
            ]
        };
    }
    function $8623df52c8647276$var$buildScopeInput(scope) {
        return {
            ids: scope.ids
        };
    }
    function $8623df52c8647276$var$buildViewId(scope) {
        return scope.ids?.[0] ?? '';
    }
    function $8623df52c8647276$var$toViewMode(mode) {
        switch(mode){
            case 'week':
                return 'WEEK';
            case 'day':
                return 'DAY';
            default:
                return 'MONTH';
        }
    }
    function $8623df52c8647276$var$toWeekStart(weekStart) {
        switch(weekStart){
            case 'monday':
                return 'MONDAY';
            case 'saturday':
                return 'SATURDAY';
            default:
                return 'SUNDAY';
        }
    }
    function $8623df52c8647276$var$toCalendarWeekStart(weekStart) {
        switch(weekStart){
            case 'sunday':
                return 'sunday';
            case 'saturday':
                return 'saturday';
            default:
                return 'monday';
        }
    }
    function $8623df52c8647276$var$toCalendarColorBy(colorBy) {
        switch(colorBy){
            case 'none':
                return 'none';
            case 'status':
                return 'status';
            default:
                if ((0, (0, parcelRequire("6s1PB")).expVal)('plan_calendar_default_colorby_setting', 'isEnabled', false)) return 'none';
                return 'status';
        }
    }
    function $8623df52c8647276$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
        return {
            date: $8623df52c8647276$var$toMidnightUTCString(selectedDate),
            mode: $8623df52c8647276$var$toViewMode(viewRange),
            weekStart: $8623df52c8647276$var$toWeekStart(weekStartsOn),
            ...(0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination') ? {
                startDateField: startDateField,
                endDateField: endDateField
            } : {},
            viewId: viewId
        };
    }
    function $8623df52c8647276$var$buildIssuesSearchInput(storageKey, filter, isEmbed) {
        if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) return {
            additionalFilterQuery: isEmbed === true ? filter ?? '' : filter || $8623df52c8647276$var$getStorageValueFromScope(storageKey)
        };
        return {
            additionalFilterQuery: $8623df52c8647276$var$getStorageValueFromScope(storageKey)
        };
    }
    function $8623df52c8647276$var$buildUnscheduledIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $8623df52c8647276$var$buildVersionsSearchInput() {
        return {
            versionStatuses: [
                'RELEASED',
                'UNRELEASED'
            ]
        };
    }
    function $8623df52c8647276$var$buildCalendarCrossProjectVersionsInput() {
        return {
            statuses: [
                'RELEASED',
                'UNRELEASED'
            ]
        };
    }
    function $8623df52c8647276$var$buildSprintsSearchInput() {
        return {
            sprintStates: [
                'ACTIVE',
                'FUTURE',
                'CLOSED'
            ]
        };
    }
    function $8623df52c8647276$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorBy) {
        if (hideWeekends || hideSprints || hideVersions || hideIssues || hideIssueKey || weekStartsOnQueryParam || colorBy) return {
            hideWeekends: hideWeekends === 'true' || undefined,
            hideSprints: hideSprints === 'true' || undefined,
            hideVersions: hideVersions === 'true' || undefined,
            hideIssues: hideIssues === 'true' || undefined,
            hideIssueKey: hideIssueKey === 'true' || undefined,
            weekStartsOn: $8623df52c8647276$var$toCalendarWeekStart(weekStartsOnQueryParam),
            colorBy: $8623df52c8647276$var$toCalendarColorBy(colorBy)
        };
        return undefined;
    }
    const $8623df52c8647276$export$19cf4b398f638dc6 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("59Yu1")), {
            moduleId: "53aec496"
        }),
        getPreloadProps: (entryPointRouteParams)=>{
            const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
            const { cloudId: cloudId } = tenantContext;
            const scope = $8623df52c8647276$var$createScope(entryPointRouteParams);
            const scopeInput = $8623df52c8647276$var$buildScopeInput(scope);
            const { date: date, filter: filter, hideWeekends: hideWeekends, hideSprints: hideSprints, hideVersions: hideVersions, hideIssues: hideIssues, hideIssueKey: hideIssueKey, weekStartsOn: weekStartsOnQueryParam, colorBy: colorByQueryParam } = context.query;
            const selectedDate = $8623df52c8647276$var$toDate(date);
            const hasFilterQueryParam = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? Boolean(filter) : false;
            const routeName = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? context.route.name : '';
            const settingsQueryParams = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? $8623df52c8647276$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorByQueryParam) : {};
            const isEmbed = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? routeName === $8623df52c8647276$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED : false;
            const settings = (0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination') ? $8623df52c8647276$var$getViewSettings($8623df52c8647276$var$SETTINGS_STORAGE_KEY) : undefined;
            const viewRange = 'month';
            const weekStartsOn = (0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination') ? settingsQueryParams?.weekStartsOn ?? settings?.weekStartsOn ?? 'monday' : 'monday';
            const startDateField = 'startdate';
            const endDateField = 'duedate';
            const issueEventFields = {
                startDateField: startDateField,
                endDateField: endDateField
            };
            const storageKey = $8623df52c8647276$var$getStorageKeyFromScope(context);
            const viewId = $8623df52c8647276$var$buildViewId(scope);
            const filterQuery = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? $8623df52c8647276$var$buildIssuesSearchInput(storageKey, filter, isEmbed) : $8623df52c8647276$var$buildIssuesSearchInput(storageKey);
            return {
                queries: {
                    calendarData: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: $122674b135b0c50b$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            scopeInput: scopeInput,
                            configurationInput: $8623df52c8647276$var$buildConfigurationInput({
                                selectedDate: selectedDate,
                                viewRange: viewRange,
                                weekStartsOn: weekStartsOn,
                                startDateField: startDateField,
                                endDateField: endDateField,
                                viewId: viewId
                            }),
                            issuesPageSize: 50,
                            issuesSearchInput: filterQuery,
                            unscheduledIssuesSearchInput: $8623df52c8647276$var$buildUnscheduledIssuesSearchInput(),
                            versionsSearchInput: $8623df52c8647276$var$buildVersionsSearchInput(),
                            sprintsSearchInput: $8623df52c8647276$var$buildSprintsSearchInput(),
                            crossProjectVersionsSearchInput: $8623df52c8647276$var$buildCalendarCrossProjectVersionsInput(),
                            viewId: viewId,
                            skipSprintSearch: false,
                            skipPanelIssueSearch: true,
                            skipCrossProjectVersionSearch: false,
                            schedulePermissionsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('calendar_schedule_issue_permissions_check'),
                            pageLoadMoreEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination'),
                            skipVersionsV1Search: (0, (0, parcelRequire("4R6GH")).fg)('plan-calendar-versions-v2-adoption'),
                            skipVersionsV2Search: !(0, (0, parcelRequire("4R6GH")).fg)('plan-calendar-versions-v2-adoption')
                        }
                    }
                },
                entryPoints: {},
                extraProps: {
                    scope: scope,
                    selectedDate: selectedDate,
                    viewRange: viewRange,
                    weekStartsOn: weekStartsOn,
                    issueEventFields: issueEventFields,
                    storageKey: storageKey,
                    hasFilterQueryParam: hasFilterQueryParam,
                    routeName: routeName,
                    settingsQueryParams: settingsQueryParams,
                    filterQuery: (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? filterQuery.additionalFilterQuery : undefined
                }
            };
        }
    });
    const $e45e5c76e61613b2$var$planCalendarEmbedRouteEntry = (0, $6a0b20679c309df7$export$56ea489e9d4bfa04)({
        main: (0, $8623df52c8647276$export$19cf4b398f638dc6)
    });
    const $e45e5c76e61613b2$export$309ed92381819b04 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $56923034cf89b966$export$df82cc5024b7f316), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'software-advanced-roadmaps-calendar-embed',
            component: (0, (0, parcelRequire("5lsNZ")).default),
            skeleton: ()=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZOse")).CalendarSkeleton), null);
                return undefined;
            },
            entryPoint () {
                if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) {
                    (0, (0, parcelRequire("87OsA")).setCapability)((0, $281cbd47ba46dd7d$export$f999749ac7a2cd1));
                    return $e45e5c76e61613b2$var$planCalendarEmbedRouteEntry;
                }
                return undefined;
            },
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)({
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$f999749ac7a2cd1)
            },
            forPaint: []
        }));
    var $65Ltd;
    var $cSD7y;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $2Ql51;
    var $65Ltd;
    const $a006cbf7c7363241$export$aa2fcc70355c7d19 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies/embed'
    };
    var $5lsNZ;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $39df6cea3ba994f5$export$b0feb6e650be3c8c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("cQB2d"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
    });
    const $39df6cea3ba994f5$export$a37f296d90476a73 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $39df6cea3ba994f5$export$b0feb6e650be3c8c,
            pageId: "plan-summary-embed",
            shouldShowSpinner: true
        });
    const $39df6cea3ba994f5$export$48681ab0b4246654 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5JvHC")).then(({ PlanDependenciesReportWithoutPageHeader: PlanDependenciesReportWithoutPageHeader })=>PlanDependenciesReportWithoutPageHeader)), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index.tsx"
    });
    const $39df6cea3ba994f5$export$4ece7fb6c15037f9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $39df6cea3ba994f5$export$48681ab0b4246654,
            pageId: "plan-dependencies-report-embed",
            shouldShowSpinner: true
        });
    const $39df6cea3ba994f5$export$51f2083dff1ee684 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dcrIA")).then(({ PlanIncrementWithoutPageHeader: PlanIncrementWithoutPageHeader })=>PlanIncrementWithoutPageHeader)), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index.tsx"
    });
    const $39df6cea3ba994f5$export$a2ae011b90c17927 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $39df6cea3ba994f5$export$51f2083dff1ee684,
            pageId: "plan-increment-embed",
            shouldShowSpinner: true
        });
    const $b6a501a17ba8d16b$export$2506a377ba649c46 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a006cbf7c7363241$export$aa2fcc70355c7d19), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', (0, $39df6cea3ba994f5$export$4ece7fb6c15037f9), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)({
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            forPaint: [
                (0, $39df6cea3ba994f5$export$48681ab0b4246654)
            ]
        }));
    var $65Ltd;
    var $cSD7y;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $2Ql51;
    var $65Ltd;
    const $703a46ab6dbf162d$export$a6b708cae2ed7f0c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId/embed'
    };
    var $5lsNZ;
    const $ddc531e0f3e9c8bc$export$3feed0b4da010c52 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $703a46ab6dbf162d$export$a6b708cae2ed7f0c), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', (0, $39df6cea3ba994f5$export$a2ae011b90c17927), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)({
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            forPaint: [
                (0, $39df6cea3ba994f5$export$51f2083dff1ee684)
            ]
        }));
    var $65Ltd;
    var $cSD7y;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $lv9xW;
    var $3RJkv;
    var $2Ql51;
    var $65Ltd;
    const $b69f5d396de4d14a$export$2cee7cd37198b3fd = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/summary/embed'
    };
    var $5lsNZ;
    const $6fb04257162ebb90$export$bdc2c75e02c29d7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b69f5d396de4d14a$export$2cee7cd37198b3fd), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', (0, $39df6cea3ba994f5$export$a37f296d90476a73), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)({
                isChromeless: true
            }),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("lv9xW")).advancedRoadmapsSummaryDataResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            forPaint: [
                (0, $39df6cea3ba994f5$export$b0feb6e650be3c8c)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $cSD7y;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $2Ql51;
    var $65Ltd;
    const $1dcb4cf4badff401$export$a60c43befc130169 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/timeline/embed'
    };
    var $5lsNZ;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f243e346f149e756$var$LazyPlanTimelineEmbed = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2GNwF")).then(({ PlanTimelineWithoutHeader: PlanTimelineWithoutHeader })=>PlanTimelineWithoutHeader)), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index.tsx"
    });
    const $f243e346f149e756$var$PlanTimelineEmbedPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f243e346f149e756$var$LazyPlanTimelineEmbed,
            pageId: "plan-timeline-embed",
            shouldShowSpinner: true
        });
    const $f243e346f149e756$export$a977d398db1904ff = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1dcb4cf4badff401$export$a60c43befc130169), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $f243e346f149e756$var$PlanTimelineEmbedPage, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)({
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            forPaint: [
                $f243e346f149e756$var$LazyPlanTimelineEmbed
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $e02b6b91fa7294dc$export$cc2401df741549fe = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT),
        path: '/secure/PortfolioPlanView.jspa'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $c3WQb;
    var $7OYJs;
    var $5W2CW;
    var $2YP9W;
    var $doZTA;
    const $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS = [
        'search'
    ];
    const $3e6624904a2f18eb$var$RedirectLegacyPlanPageWithoutScenarioId = ()=>{
        const [{ query: query }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("c3WQb")).advancedRoadmapsScenarioIdResource));
        if (loading || data === null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/plans/${query.id}/scenarios/${data.scenarioId}`,
            persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
        });
    };
    const $3e6624904a2f18eb$export$c3e4fda2290a52bf = ()=>{
        const [{ query: query }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { id: id, sid: sid } = query;
        if (Number.isNaN(Number.parseFloat(sid))) return (0, ($parcel$interopDefault($5uXOq))).createElement($3e6624904a2f18eb$var$RedirectLegacyPlanPageWithoutScenarioId, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/plans/${id}/scenarios/${sid}`,
            persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
        });
    };
    const $3e6624904a2f18eb$export$ff420400c9900835 = ()=>{
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { planId: planId } = match.params;
        if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
        const { data: data, loading: loading } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource));
        if (loading || data === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        if (!data.success) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5W2CW")).ErrorScreen), {
            errorMessage: data.errorMessage
        });
        if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
            persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $1450d939edbc2ee3$export$bf48e5f1529ddaeb = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2GNwF"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index.tsx"
    });
    var $1450d939edbc2ee3$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1450d939edbc2ee3$export$bf48e5f1529ddaeb,
            pageId: "plan-timeline",
            shouldShowSpinner: true
        });
    const $10eae15c25a3521c$export$e9cfdb950d40e917 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e02b6b91fa7294dc$export$cc2401df741549fe), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $3e6624904a2f18eb$export$c3e4fda2290a52bf),
            isRedirect: true,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsScenarioIdResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1450d939edbc2ee3$export$bf48e5f1529ddaeb)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $8f7607e31ffd1aa8$export$264157b237e791ea = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT),
        path: '/secure/PortfolioReportView.jspa'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $doZTA;
    var $135d7141d14abe41$export$2e2bcd8739ae039 = ()=>{
        const [{ query: query }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/plans/reports/${query.r}`,
            persistSearchParams: false
        });
    };
    const $be1254c729965d54$export$c2a4c5c6576a704c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8f7607e31ffd1aa8$export$264157b237e791ea), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $135d7141d14abe41$export$2e2bcd8739ae039),
            isRedirect: true,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1450d939edbc2ee3$export$bf48e5f1529ddaeb)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $2G9Bk;
    var $c3WQb;
    var $65Ltd;
    const $9072301567f2e36a$export$158bfed3a17a3f80 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/export'
    };
    var $5j7Th;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $b6ed3ac1658c948e$export$890fb5003e472449 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5V8wX"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/index.tsx"
    });
    var $b6ed3ac1658c948e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b6ed3ac1658c948e$export$890fb5003e472449,
            pageId: "advanced-roadmaps-plan",
            shouldShowSpinner: true
        });
    const $e17ef7a70aea4a64$var$ExportPageComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $b6ed3ac1658c948e$export$890fb5003e472449), null);
    const $e17ef7a70aea4a64$var$ExportPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e17ef7a70aea4a64$var$ExportPageComponent,
            pageId: "advanced-roadmap",
            shouldShowSpinner: true
        });
    const $e17ef7a70aea4a64$export$d751e3552b21c604 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9072301567f2e36a$export$158bfed3a17a3f80), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'software-advanced-roadmaps-scenario-export',
            component: $e17ef7a70aea4a64$var$ExportPage,
            layout: {
                isChromeless: true,
                globalComponents: [],
                rightSidebars: []
            },
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource)
            ],
            forPaint: [
                (0, $1450d939edbc2ee3$export$bf48e5f1529ddaeb)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $bd4b1651db8dd510$export$21d57208bfbf7e92 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        path: '/jira/plans/:planId/scenarios/:scenarioId'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $doZTA;
    function $25bed75d5ee084fd$export$2c9e4550ef8bdea9(Component, { to: to, redirectCondition: redirectCondition }) {
        return ()=>{
            const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
            if (match == null || match.params == null || match.params.planId == null || match.params.scenarioId == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                to: "/jira/plans"
            });
            if (!redirectCondition()) return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                to: `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${to}`
            });
        };
    }
    const $877bd5b2a7f04d5c$export$bca2008b514578a0 = (0, $25bed75d5ee084fd$export$2c9e4550ef8bdea9)((0, $1450d939edbc2ee3$export$2e2bcd8739ae039), {
        to: '/timeline',
        redirectCondition: ()=>true
    });
    const $877bd5b2a7f04d5c$export$f85a75f1604118ff = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $bd4b1651db8dd510$export$21d57208bfbf7e92), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'software-advanced-roadmaps-scenario',
            component: $877bd5b2a7f04d5c$export$bca2008b514578a0,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1450d939edbc2ee3$export$bf48e5f1529ddaeb)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $913c6c508acfc56b$export$a3686c51bf984ef9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        path: '/jira/plans/:planId(\\d+)'
    };
    const $c926071780746d94$export$9cbef73b51558ef = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $913c6c508acfc56b$export$a3686c51bf984ef9), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'software-advanced-roadmaps-plan',
            component: (0, $3e6624904a2f18eb$export$ff420400c9900835),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1450d939edbc2ee3$export$bf48e5f1529ddaeb)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $aPfsS;
    var $kxZPA;
    const $fa12faadb00e7e4f$export$b6292b5f7e5b5fad = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("BXMfg")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx"
    });
    const $fa12faadb00e7e4f$export$94e1d79bf65579e2 = (0, (0, parcelRequire("aPfsS")).createLayout)({
        globalComponents: [
            $fa12faadb00e7e4f$export$b6292b5f7e5b5fad
        ]
    });
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $3431221d1e2c8da3$export$bd0ed90cfd1c0a55 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        path: '/jira/plans/reports/:reportId'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $620253f0b511b587$export$fe1fc08f511671db = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5KRXt"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-report/index.tsx"
    });
    const $620253f0b511b587$var$PlanReport = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $620253f0b511b587$export$fe1fc08f511671db,
            pageId: "plan-report",
            shouldShowSpinner: true
        });
    var $620253f0b511b587$export$2e2bcd8739ae039 = $620253f0b511b587$var$PlanReport;
    const $7a323ef2c1a2c74a$export$e71031acce6d7e47 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3431221d1e2c8da3$export$bd0ed90cfd1c0a55), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'software-advanced-roadmaps-report',
            component: (0, $620253f0b511b587$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanReportPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $620253f0b511b587$export$fe1fc08f511671db)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $f9ce588c78c6802b$export$442daaf7ae9abf13 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP),
        path: '/jira/plans/:planId/setup'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $360fed07fa6fa9e9$export$46bb3a1779d7815b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dq5QR"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/setup/src/index.tsx"
    });
    var $360fed07fa6fa9e9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $360fed07fa6fa9e9$export$46bb3a1779d7815b,
            pageId: "advanced-roadmaps-setup",
            shouldShowSpinner: true
        });
    const $3d84c56e2a698202$export$2a24acea4e628148 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f9ce588c78c6802b$export$442daaf7ae9abf13), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $360fed07fa6fa9e9$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $360fed07fa6fa9e9$export$46bb3a1779d7815b)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $c9008f0cd6cfcbbf$export$38c76ea9ddc85b3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT),
        path: '/secure/PortfolioGettingStarted.jspa'
    };
    var $7OYJs;
    const $c59b8ec61d58752b$export$4652a26319dca4d0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c9008f0cd6cfcbbf$export$38c76ea9ddc85b3), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                    to: "/jira/plans?create-sample-plan=true"
                }),
            isRedirect: true,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1450d939edbc2ee3$export$bf48e5f1529ddaeb)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $87OsA;
    var $65Ltd;
    var $2BrOV;
    var $8iyFV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $56322e0cc9119168$export$ca4c39d60ec156a2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR),
        path: '/jira/plans/:planId/scenarios/:scenarioId/calendar'
    };
    var $kZOse;
    var $lmyls;
    const $49df381ba8f49311$export$21806ebf23f23060 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $8623df52c8647276$export$19cf4b398f638dc6),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
    });
    const $4711dd8590f23118$export$67c64fea9be584ed = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $56322e0cc9119168$export$ca4c39d60ec156a2), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'software-advanced-roadmaps-calendar',
            skeleton: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZOse")).CalendarSkeleton), null),
            entryPoint () {
                (0, (0, parcelRequire("87OsA")).setCapability)((0, $281cbd47ba46dd7d$export$f999749ac7a2cd1));
                return 0, $49df381ba8f49311$export$21806ebf23f23060;
            },
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default),
                horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                onlyShowHorizontalOnNav4: true
            },
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$f999749ac7a2cd1)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $8iyFV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $a253d414fb5970e7$export$ad8296aa5394f696 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $49c9e6a9627b668c$export$d4669c7a2f17c261 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5JvHC"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index.tsx"
    });
    var $49c9e6a9627b668c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $49c9e6a9627b668c$export$d4669c7a2f17c261,
            pageId: "plan-dependencies-report",
            shouldShowSpinner: true
        });
    const $35d5ce46f5d8e5a8$export$103062f08086fba0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a253d414fb5970e7$export$ad8296aa5394f696), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $49c9e6a9627b668c$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default),
                horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $49c9e6a9627b668c$export$d4669c7a2f17c261)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $8iyFV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $f06c9277915d7c48$export$850236b64b0aa28b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_RELEASES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/releases'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $dc2ebda85f38ad5d$export$749f5d2513e04ec0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("cp9L3"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-releases/index.tsx"
    });
    var $dc2ebda85f38ad5d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $dc2ebda85f38ad5d$export$749f5d2513e04ec0,
            pageId: "plan-releases",
            shouldShowSpinner: true
        });
    const $4095f2c0ec8f50cf$export$b874fabd66f10ff4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f06c9277915d7c48$export$850236b64b0aa28b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $dc2ebda85f38ad5d$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default),
                horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $dc2ebda85f38ad5d$export$749f5d2513e04ec0)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $4586083606b00135$export$e44088b2cc0206cf = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/auto-scheduler'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $632fd0e21b8de9c8$export$8bcf7155849993f5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jxlwh"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/auto-scheduler/index.tsx"
    });
    var $632fd0e21b8de9c8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $632fd0e21b8de9c8$export$8bcf7155849993f5,
            pageId: "plan-settings-auto-scheduler",
            shouldShowSpinner: true
        });
    const $78ac61c21ed5f382$export$fc7007717398c727 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $4586083606b00135$export$e44088b2cc0206cf), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $632fd0e21b8de9c8$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $632fd0e21b8de9c8$export$8bcf7155849993f5)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $8173736a5bf38da1$export$2634cd63c73f7a35 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/custom-fields'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $7a181f322c9e7d25$export$72bf44dbae2383e5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8jCIm"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/custom-fields/index.tsx"
    });
    var $7a181f322c9e7d25$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7a181f322c9e7d25$export$72bf44dbae2383e5,
            pageId: "plan-settings-custom-fields",
            shouldShowSpinner: true
        });
    const $e3235a40cee1f9ea$export$89472d9db6946668 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8173736a5bf38da1$export$2634cd63c73f7a35), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $7a181f322c9e7d25$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7a181f322c9e7d25$export$72bf44dbae2383e5)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $520050550cd1f444$export$358b0ca69a4bd731 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/exclusion-rules'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $9ac014b7d5fdabc4$export$78f61b03c267e6d9 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8RcGG"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/exclusion-rules/index.tsx"
    });
    var $9ac014b7d5fdabc4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9ac014b7d5fdabc4$export$78f61b03c267e6d9,
            pageId: "plan-settings-exclusion-rules",
            shouldShowSpinner: true
        });
    const $8d454372873657bb$export$cd1b612d0c014154 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $520050550cd1f444$export$358b0ca69a4bd731), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $9ac014b7d5fdabc4$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9ac014b7d5fdabc4$export$78f61b03c267e6d9)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $bcf3aac3d05c5191$export$ab61883f74eb27c2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/find-your-issue'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $428ba58b4dd0959f$export$731998664b7d5e72 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gBsS7"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/find-your-issue/index.tsx"
    });
    var $428ba58b4dd0959f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $428ba58b4dd0959f$export$731998664b7d5e72,
            pageId: "plan-settings-find-your-issue",
            shouldShowSpinner: true
        });
    const $e49a66463b867d46$export$2f975c505121e139 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $bcf3aac3d05c5191$export$ab61883f74eb27c2), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $428ba58b4dd0959f$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $428ba58b4dd0959f$export$731998664b7d5e72)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $da9ac2a12ec5cdcc$export$fa18324265e4400c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/issue-sources'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $b7fcbd3d5b96d4a9$export$7ba4b487efcedeb3 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1Nhzp"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/issue-sources/index.tsx"
    });
    var $b7fcbd3d5b96d4a9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b7fcbd3d5b96d4a9$export$7ba4b487efcedeb3,
            pageId: "plan-settings-issue-sources",
            shouldShowSpinner: true
        });
    const $c2b7559ef928e7c4$export$f0b7e9788ab79be0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $da9ac2a12ec5cdcc$export$fa18324265e4400c), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $b7fcbd3d5b96d4a9$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b7fcbd3d5b96d4a9$export$7ba4b487efcedeb3)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $c8e4ae667061a76b$export$6734c29372722a5e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PERMISSIONS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/permissions'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $8e8c7a9f7faf5b90$export$49f5b76ad5c06a42 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fhZxp"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/permissions/index.tsx"
    });
    var $8e8c7a9f7faf5b90$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8e8c7a9f7faf5b90$export$49f5b76ad5c06a42,
            pageId: "plan-settings-permissions",
            shouldShowSpinner: true
        });
    const $d78d9c80df28a675$export$1afc7a9efa99340 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c8e4ae667061a76b$export$6734c29372722a5e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $8e8c7a9f7faf5b90$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $8e8c7a9f7faf5b90$export$49f5b76ad5c06a42)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $6fdc9140d3fd71a2$export$76e6bdc959f6fa97 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PLAN_INFO),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/plan-info'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $891dc4fe265590fb$export$c1344fd7d24991b3 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("cs3SK"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/plan-info/index.tsx"
    });
    var $891dc4fe265590fb$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $891dc4fe265590fb$export$c1344fd7d24991b3,
            pageId: "plan-settings-plan-info",
            shouldShowSpinner: true
        });
    const $d7dc38a99726fee2$export$1d6300da0c837e02 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6fdc9140d3fd71a2$export$76e6bdc959f6fa97), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $891dc4fe265590fb$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $891dc4fe265590fb$export$c1344fd7d24991b3)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $8498ace38f0217d4$export$3d54c48a91a178c0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/program-boards'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $fc0346cc52c0eaa1$export$ffdec728a47c437c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4gfsQ"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/program-boards/index.tsx"
    });
    var $fc0346cc52c0eaa1$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fc0346cc52c0eaa1$export$ffdec728a47c437c,
            pageId: "plan-settings-program-boards",
            shouldShowSpinner: true
        });
    const $6183d6997fcdbcf0$export$be96222796ad98f0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8498ace38f0217d4$export$3d54c48a91a178c0), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $fc0346cc52c0eaa1$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $fc0346cc52c0eaa1$export$ffdec728a47c437c)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $1a8d996cecbe9939$export$8b77532ba9798e64 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/removed-issues'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $1ba44a18046961e4$export$759df6301ec72119 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9ben8"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/removed-issues/index.tsx"
    });
    var $1ba44a18046961e4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1ba44a18046961e4$export$759df6301ec72119,
            pageId: "plan-settings-removed-issues",
            shouldShowSpinner: true
        });
    const $304853a89d046ccf$export$53a9ea0e0b05ceb5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1a8d996cecbe9939$export$8b77532ba9798e64), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $1ba44a18046961e4$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1ba44a18046961e4$export$759df6301ec72119)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $606c26c5c4fe38cc$export$a0fec30f475e8756 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/saved-views'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $9469a9a95c6fd42f$export$a5398542699d356a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3ZFGv"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/saved-views/index.tsx"
    });
    var $9469a9a95c6fd42f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9469a9a95c6fd42f$export$a5398542699d356a,
            pageId: "plan-settings-saved-views",
            shouldShowSpinner: true
        });
    const $cbe1aa5484552af9$export$64d5b46da2e58194 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $606c26c5c4fe38cc$export$a0fec30f475e8756), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $9469a9a95c6fd42f$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9469a9a95c6fd42f$export$a5398542699d356a)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $56e039c24697690f$export$d32efeefb944c6b7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCENARIOS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scenarios'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $3744eed80f080771$export$94104fcc1a6f460f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("d6TuG"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scenarios/index.tsx"
    });
    var $3744eed80f080771$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3744eed80f080771$export$94104fcc1a6f460f,
            pageId: "plan-settings-scenarios",
            shouldShowSpinner: true
        });
    const $9368211e7352bb42$export$9b6e6b5d471b90f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $56e039c24697690f$export$d32efeefb944c6b7), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $3744eed80f080771$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3744eed80f080771$export$94104fcc1a6f460f)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $e1fdd34e8b323da3$export$a215ef374dd2a8a9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCHEDULING),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scheduling'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5e451d261b446f20$export$3bf11db1bbeae73e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("28rR3"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scheduling/index.tsx"
    });
    var $5e451d261b446f20$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5e451d261b446f20$export$3bf11db1bbeae73e,
            pageId: "plan-settings-scheduling",
            shouldShowSpinner: true
        });
    const $cf0e25b45377825b$export$c1319dec79812860 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e1fdd34e8b323da3$export$a215ef374dd2a8a9), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $5e451d261b446f20$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $5e451d261b446f20$export$3bf11db1bbeae73e)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $8iyFV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $lv9xW;
    var $3RJkv;
    var $65Ltd;
    const $ad2d61946557db6b$export$25a8cf27557a612d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY),
        path: '/jira/plans/:planId/scenarios/:scenarioId/summary'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2ab6a879960150e5$export$c717f0d9d7f11b49 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("cQB2d"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
    });
    var $2ab6a879960150e5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2ab6a879960150e5$export$c717f0d9d7f11b49,
            pageId: "plan-summary",
            shouldShowSpinner: true
        });
    const $e2353036f7312b49$export$4bc10767887a84cc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ad2d61946557db6b$export$25a8cf27557a612d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'software-advanced-roadmaps-summary',
            component: (0, $2ab6a879960150e5$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("lv9xW")).advancedRoadmapsSummaryDataResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default),
                horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2ab6a879960150e5$export$c717f0d9d7f11b49)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $8iyFV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $132f449f27d99391$export$fc66f5c0de18ddc7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TEAMS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/teams'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $7b0bfdd4f2079663$export$f85952f98f28fed0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("iQWcF"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-teams/index.tsx"
    });
    var $7b0bfdd4f2079663$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7b0bfdd4f2079663$export$f85952f98f28fed0,
            pageId: "plan-teams",
            shouldShowSpinner: true
        });
    const $ed7f2a4db7ff0a01$export$cc5b7d3f8546a313 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $132f449f27d99391$export$fc66f5c0de18ddc7), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $7b0bfdd4f2079663$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default),
                horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7b0bfdd4f2079663$export$f85952f98f28fed0)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $8iyFV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $2oTRI;
    const $970ae3ae6d33a9e3$export$c5b46ecd4d9a8abd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2oTRI")).softwarePlanTimelineRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $1450d939edbc2ee3$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default),
                horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1450d939edbc2ee3$export$bf48e5f1529ddaeb)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3DNgf;
    var $3RJkv;
    var $65Ltd;
    const $65e858e2a9642f5e$export$b55de156ac5f7c1b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT),
        path: '/secure/PortfolioDependencySettings.jspa'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $8f893c79e2990b05$export$4fcc3c0f6e792efc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("iLgJ6"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/dependencies/index.tsx"
    });
    const $8f893c79e2990b05$export$d6f045c7c1aaff50 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8f893c79e2990b05$export$4fcc3c0f6e792efc,
            pageId: "arj-settings-dependencies",
            shouldShowSpinner: true
        });
    const $8f893c79e2990b05$export$64761ea1912fdcd9 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3Uhkm"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/loading-limits/index.tsx"
    });
    const $8f893c79e2990b05$export$7bb4c0f22b467385 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8f893c79e2990b05$export$64761ea1912fdcd9,
            pageId: "arj-settings-loading-limits",
            shouldShowSpinner: true
        });
    const $8f893c79e2990b05$export$edb4ae7e85c7908d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("aMm01"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/permissions/index.tsx"
    });
    const $8f893c79e2990b05$export$fa852ea42b98d3de = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8f893c79e2990b05$export$edb4ae7e85c7908d,
            pageId: "arj-settings-permissions",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    const $cf0b6f0a8f874806$export$2d47ce6f15e624e5 = (redirectUrl)=>()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                to: redirectUrl
            });
    const $3678ca52b1bdf235$export$804f2d81dfbdd5c9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $65e858e2a9642f5e$export$b55de156ac5f7c1b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $cf0b6f0a8f874806$export$2d47ce6f15e624e5)('/jira/plans/settings/dependencies'),
            isRedirect: true,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("3DNgf")).issueLinkInformationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $8f893c79e2990b05$export$4fcc3c0f6e792efc)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3DNgf;
    var $3RJkv;
    var $65Ltd;
    const $c7cf556f50e30ad4$export$e657c8aeaaf0932c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES),
        path: '/jira/plans/settings/dependencies'
    };
    const $98e5774d92d39cbd$export$70386609aff5ba12 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7cf556f50e30ad4$export$e657c8aeaaf0932c), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $8f893c79e2990b05$export$d6f045c7c1aaff50),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("3DNgf")).issueLinkInformationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $8f893c79e2990b05$export$4fcc3c0f6e792efc)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $5316282b3e176724$export$c72a1b9971af07d9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT),
        path: '/secure/PortfolioLoadingLimits.jspa'
    };
    const $99f00cddc0758136$export$9f80102c0f64ad9b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5316282b3e176724$export$c72a1b9971af07d9), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $cf0b6f0a8f874806$export$2d47ce6f15e624e5)('/jira/plans/settings/loading-limits'),
            isRedirect: true,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $8f893c79e2990b05$export$64761ea1912fdcd9)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $azWKH;
    var $3RJkv;
    var $65Ltd;
    const $96cfca27570d6199$export$21eaa019c724fc9a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS),
        path: '/jira/plans/settings/loading-limits'
    };
    const $f2c5f02fe8472718$export$6786257309f86d8c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $96cfca27570d6199$export$21eaa019c724fc9a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $8f893c79e2990b05$export$7bb4c0f22b467385),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("azWKH")).arjSettingsLoadingLimitsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $8f893c79e2990b05$export$64761ea1912fdcd9)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $1aR84;
    var $3RJkv;
    var $65Ltd;
    const $2ce735b96a41b4ed$export$6372897c47d731c0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS),
        path: '/jira/plans/settings/permissions'
    };
    const $c52f49db3f216f46$export$4e97658a5cc15eaa = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2ce735b96a41b4ed$export$6372897c47d731c0), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $8f893c79e2990b05$export$fa852ea42b98d3de),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("1aR84")).getGlobalPermissionPageResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $8f893c79e2990b05$export$edb4ae7e85c7908d)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $1aR84;
    var $3RJkv;
    var $65Ltd;
    const $074076b55b1a5217$export$4523847db2f1a42e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT),
        path: '/secure/PortfolioPermissions.jspa'
    };
    const $75e3fe7119ee0518$export$949c8177281fcc39 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $074076b55b1a5217$export$4523847db2f1a42e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $cf0b6f0a8f874806$export$2d47ce6f15e624e5)('/jira/plans/settings/permissions'),
            isRedirect: true,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("1aR84")).getGlobalPermissionPageResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $8f893c79e2990b05$export$edb4ae7e85c7908d)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $8d4bd95d29fd1b87$export$29647353386ad146 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_PLANS_DIRECTORY),
        path: '/jira/plans/settings/archive',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $e8a09ac95de555a1$export$cf676f47aba10db8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lHxXl")).then((module)=>module.ArchivedPlans)), {
        moduleId: "./src/packages/spa-apps/admin-pages/archived-plans/src/index.tsx"
    });
    const $e8a09ac95de555a1$export$ed59bbc59461c00f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e8a09ac95de555a1$export$cf676f47aba10db8,
            pageId: "archived-plans",
            shouldShowSpinner: true
        });
    const $2934b1049cdc0b54$export$b9921058a8a65710 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8d4bd95d29fd1b87$export$29647353386ad146), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $e8a09ac95de555a1$export$ed59bbc59461c00f),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $e8a09ac95de555a1$export$cf676f47aba10db8)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $7j3uW;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $7565a345f1dea2b4$export$7208300f00a36a5f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR),
        path: '/jira/plans/settings/financial-year',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $b5d39848dc9e7ba6$export$dd67c2f01a58231e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("462Ae")).then((module)=>module.ArjSettingsFinancialYear)), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/financial-year/index.tsx"
    });
    const $b5d39848dc9e7ba6$export$785180185eba7ed9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b5d39848dc9e7ba6$export$dd67c2f01a58231e,
            pageId: "arj-settings-financial-year",
            shouldShowSpinner: true
        });
    const $a36cb3f650c3074c$export$b6bba25826e621b9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7565a345f1dea2b4$export$7208300f00a36a5f), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $b5d39848dc9e7ba6$export$785180185eba7ed9),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("7j3uW")).arjSettingsFinancialYearResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b5d39848dc9e7ba6$export$dd67c2f01a58231e)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $8iyFV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $1f9e3780cba4a3e0$export$ef33a75556fde209 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT),
        path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $fd8b21deba1fc1a8$export$e7b9f83d442bac51 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dcrIA"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index.tsx"
    });
    const $fd8b21deba1fc1a8$export$5e1035d0876d64db = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fd8b21deba1fc1a8$export$e7b9f83d442bac51,
            pageId: "plan-increment",
            shouldShowSpinner: true
        });
    const $13d9e6b7582fbfc8$export$a26fa5cabff8bc7c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1f9e3780cba4a3e0$export$ef33a75556fde209), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $fd8b21deba1fc1a8$export$5e1035d0876d64db),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default),
                horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                onlyShowHorizontalOnNav4: true
            },
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $fd8b21deba1fc1a8$export$e7b9f83d442bac51)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $8iyFV;
    var $lmyls;
    var $937TY;
    var $2G9Bk;
    var $aPfsS;
    var $c3WQb;
    var $3RJkv;
    var $65Ltd;
    const $1fae537885c9da25$export$d0986e4bd9568b30 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/program',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d0d482e714f6dec6$export$9da4d4d5c4d7f749 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("irnSu"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-program/index.tsx"
    });
    const $d0d482e714f6dec6$export$fb30c2b19a4f5d59 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d0d482e714f6dec6$export$9da4d4d5c4d7f749,
            pageId: "plan-program",
            shouldShowSpinner: true
        });
    const $38c9ffd9e7c2e0a9$export$f7abc47036ff7dd9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1fae537885c9da25$export$d0986e4bd9568b30), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $d0d482e714f6dec6$export$fb30c2b19a4f5d59),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $fa12faadb00e7e4f$export$94e1d79bf65579e2)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default),
                horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                onlyShowHorizontalOnNav4: true
            },
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d0d482e714f6dec6$export$9da4d4d5c4d7f749)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $378d003abbed757a$export$1a9edb72cd49ca79 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK),
        path: '/jira/plans/plan-trashed',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $1e04fb6816f8b0a0$export$20a71ac28e6a3c8f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1VgiI"))), {
        moduleId: "./src/packages/portfolio-3/plan-trashed-direct-link/src/index.tsx"
    });
    const $1e04fb6816f8b0a0$export$38f3a061bb1fceee = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1e04fb6816f8b0a0$export$20a71ac28e6a3c8f,
            pageId: "trashed-plan-direct-link",
            shouldShowSpinner: false
        });
    const $5f2b7d10b2a973db$export$dbcd0bd16f12397d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $378d003abbed757a$export$1a9edb72cd49ca79), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $1e04fb6816f8b0a0$export$38f3a061bb1fceee),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1e04fb6816f8b0a0$export$20a71ac28e6a3c8f)
            ],
            ufoName: 'plan-trashed'
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $ca7f17f816d2c7cb$export$b1d2299a57fca83a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASH_PLANS_DIRECTORY),
        path: '/jira/plans/settings/trash',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $87393f1bbf5aac77$export$6ac18b311b7e51a1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7nBbQ")).then((module)=>module.TrashedPlans)), {
        moduleId: "./src/packages/spa-apps/admin-pages/trashed-plans/src/index.tsx"
    });
    const $87393f1bbf5aac77$export$b145fa65818ff157 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $87393f1bbf5aac77$export$6ac18b311b7e51a1,
            pageId: "trashed-plans",
            shouldShowSpinner: true
        });
    const $2d67b465f26d4e76$export$eabcbe4dd6fc9f1f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ca7f17f816d2c7cb$export$b1d2299a57fca83a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $87393f1bbf5aac77$export$b145fa65818ff157),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $87393f1bbf5aac77$export$6ac18b311b7e51a1)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    const $f36666704bcc2bab$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
    const $f36666704bcc2bab$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
    const $f36666704bcc2bab$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
    const $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
    const $f36666704bcc2bab$export$137d6d169f402a59 = [
        $f36666704bcc2bab$var$VENDOR_ASSET_REGEX,
        $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX
    ];
    const $f36666704bcc2bab$export$ad16a91905cefb0a = [
        $f36666704bcc2bab$var$VENDOR_ASSET_REGEX,
        $f36666704bcc2bab$var$COMMON_ASSET_REGEX,
        $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX,
        $f36666704bcc2bab$var$PARCEL_COMMON_ASSET_REGEX
    ];
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $dc8070a591fb1e72$export$28e56397699263ca = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_AGENT_STUDIO),
        path: '/jira/support-center/settings/agent-studio'
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0e32f5ae634ca894$export$5c09c843813c837f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2A0mx"))), {
        moduleId: "./src/packages/spa-apps/support-center-settings/agent-studio/src/index.tsx"
    });
    const $0e32f5ae634ca894$export$d6681885c24e1efd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0e32f5ae634ca894$export$5c09c843813c837f,
            pageId: "agent-studio-page",
            shouldShowSpinner: false
        });
    const $0e32f5ae634ca894$export$d29dcad8c82ca10d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $dc8070a591fb1e72$export$28e56397699263ca), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SUPPORT_CENTER_SETTINGS),
            component: $0e32f5ae634ca894$export$d6681885c24e1efd,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $0e32f5ae634ca894$export$5c09c843813c837f
            ],
            earlyAssets: (0, $f36666704bcc2bab$export$137d6d169f402a59)
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $fcb9d046350a5535$export$cd3fc26cf9f696e6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK),
        path: '/jira/errors/project-archived',
        exact: true
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $83811b47cb2e3e0c$export$bcbb38b3c86dba1f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("aKeDz"))), {
        moduleId: "./src/packages/project-pages/project-archive/project-archived-direct-link/src/index.tsx"
    });
    const $83811b47cb2e3e0c$export$2e0968e4c0408481 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $83811b47cb2e3e0c$export$bcbb38b3c86dba1f,
            pageId: "archived-project-direct-link",
            shouldShowSpinner: false
        });
    const $83811b47cb2e3e0c$export$45e68d450757a753 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fcb9d046350a5535$export$cd3fc26cf9f696e6), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_REDIRECTS),
            component: $83811b47cb2e3e0c$export$2e0968e4c0408481,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $83811b47cb2e3e0c$export$bcbb38b3c86dba1f
            ],
            ufoName: 'project-archived'
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $4jMkc;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $cdb39a82bf3cd9b0$export$b60634d0fa43f719 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY),
        path: '/jira/settings/projects/archive',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $7076addc4fa02bdc$export$b220ffb582ee39aa = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gL0L0"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/archived-projects/src/index.tsx"
    });
    var $7076addc4fa02bdc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7076addc4fa02bdc$export$b220ffb582ee39aa,
            pageId: "archived-projects",
            shouldShowSpinner: true
        });
    const $e0db3e001ba4740c$export$dc5f9e3c3931cc36 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cdb39a82bf3cd9b0$export$b60634d0fa43f719), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $7076addc4fa02bdc$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7076addc4fa02bdc$export$b220ffb582ee39aa)
            ],
            ufoName: 'admin.archived-projects'
        }));
    var $ffza4;
    var $65Ltd;
    var $9QpK7;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $h0bZU;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $96c61d85c5909907$export$1c7220e12a2118ce = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/servicedesk/projects/:projectKey/issues/archive',
        exact: true
    };
    var $5lsNZ;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $gyYxw;
    var $aPfsS;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $64109391b810c516$export$5cb97f431a00807d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lWPxc")).then(({ JiraIssuesArchive: JiraIssuesArchive })=>JiraIssuesArchive)), {
        moduleId: "./src/packages/spa-apps/archives/src/index.tsx"
    });
    const $64109391b810c516$export$b8f3c7276fe36123 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $64109391b810c516$export$5cb97f431a00807d,
            pageId: "spa-apps/archives",
            shouldShowSpinner: true
        });
    const $64109391b810c516$export$3dbe917a4c13b1e = ()=>(0, (0, parcelRequire("aPfsS")).createLayout)((0, (0, parcelRequire("gyYxw")).genericProjectLayout));
    const $b2269bc905327468$export$334720f484807a91 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $96c61d85c5909907$export$1c7220e12a2118ce), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
            component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', (0, $64109391b810c516$export$b8f3c7276fe36123), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $64109391b810c516$export$5cb97f431a00807d)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $9QpK7;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $9s3j1;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $df1ff4159dc216e6$export$cd10ef5fdf01245b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/software/c/projects/:projectKey/issues/archive',
        exact: true
    };
    var $5lsNZ;
    var $5PD5h;
    const $8d888d2aca144cd1$export$26f89b9d922d1bea = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $df1ff4159dc216e6$export$cd10ef5fdf01245b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
            component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', (0, $64109391b810c516$export$b8f3c7276fe36123), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, $64109391b810c516$export$3dbe917a4c13b1e)(),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $64109391b810c516$export$5cb97f431a00807d)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $9QpK7;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $aPfsS;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $ff62ef27527a44d2$export$15745ddd07707d60 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/software/projects/:projectKey/issues/archive',
        exact: true
    };
    var $5lsNZ;
    var $5PD5h;
    var $e7bC3;
    const $0bcebe438fd2464d$export$39e83fab54222094 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ff62ef27527a44d2$export$15745ddd07707d60), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
            component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', (0, $64109391b810c516$export$b8f3c7276fe36123), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)((0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $64109391b810c516$export$5cb97f431a00807d)
            ]
        }));
    var $ffza4;
    var $l71WK;
    var $65Ltd;
    var $9QpK7;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $dmKXV;
    var $2G9Bk;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $c7c815cf6f8e49d3$export$4a6781d620bb402 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/core/projects/:projectKey/issues/archive',
        exact: true
    };
    var $5lsNZ;
    const $66bc19155bc886e3$export$cccc8c9dd9619d7f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c7c815cf6f8e49d3$export$4a6781d620bb402), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
            component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', (0, $64109391b810c516$export$b8f3c7276fe36123), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, $64109391b810c516$export$3dbe917a4c13b1e)(),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $64109391b810c516$export$5cb97f431a00807d)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $9QpK7;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $65e0e6d0c8ec9fed$export$1bfee70ca366d995 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/issues/archive',
        exact: true
    };
    var $5lsNZ;
    const $eb7a8f12766dfa01$export$f7d3667678a21360 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $65e0e6d0c8ec9fed$export$1bfee70ca366d995), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
            component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', (0, $64109391b810c516$export$b8f3c7276fe36123), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $64109391b810c516$export$5cb97f431a00807d)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $1WlLE;
    var $iN5FK;
    var $7MCPm;
    const $7846fd35a7cb282e$export$f9891419b34ab305 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iN5FK")).browseProjectRedirectRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_REDIRECTS),
            isRedirect: true,
            component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $ffza4;
    var $l71WK;
    var $2vSU6;
    var $1Du13;
    var $aPfsS;
    var $kxZPA;
    const $d0bc40d3dc70d875$var$Onboarding = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("cXVVY")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/onboarding/index.tsx"
    });
    const $d0bc40d3dc70d875$var$withAnyBusinessProjectContext = (Component)=>(0, (0, parcelRequire("aPfsS")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
            }
        });
    const $d0bc40d3dc70d875$var$RightSidebars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("izvSW")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/right-sidebars/index.tsx"
    });
    const $d0bc40d3dc70d875$var$BusinessOnboarding = $d0bc40d3dc70d875$var$withAnyBusinessProjectContext($d0bc40d3dc70d875$var$Onboarding);
    const $d0bc40d3dc70d875$var$nonSettingsRightSidebars = [
        $d0bc40d3dc70d875$var$withAnyBusinessProjectContext($d0bc40d3dc70d875$var$RightSidebars)
    ];
    const $d0bc40d3dc70d875$var$sharedBusinessProjectLayout = (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout));
    const $d0bc40d3dc70d875$export$dfb0c3e0348f4429 = (0, (0, parcelRequire("aPfsS")).composeLayouts)($d0bc40d3dc70d875$var$sharedBusinessProjectLayout, {
        rightSidebars: $d0bc40d3dc70d875$var$nonSettingsRightSidebars,
        globalComponents: [
            $d0bc40d3dc70d875$var$BusinessOnboarding
        ]
    });
    var $aPfsS;
    const $c3106f352857c22e$export$17e73ed8c35891cb = (0, (0, parcelRequire("aPfsS")).createLayout)({
        isChromeless: true
    });
    var $65Ltd;
    var $6s1PB;
    var $4R6GH;
    var $2BrOV;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $dmKXV;
    var $aVFIE;
    var $2G9Bk;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $ffza4;
    var $l71WK;
    var $65Ltd;
    var $4R6GH;
    var $aPfsS;
    var $lGGIs;
    var $kxZPA;
    var $lODMY;
    var $5DQxU;
    const $59d96d961d806fee$var$LazyIssuePage = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(0, (0, parcelRequire("lGGIs")).markAsBentoBundleReady)((parcelRequire("zLcoH"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
    });
    const $59d96d961d806fee$var$AsyncIssueAppComponent = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(0, (0, parcelRequire("lGGIs")).markAsBentoBundleReady)((parcelRequire("jO7eF"))), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
    });
    const $59d96d961d806fee$var$imports = {
        fullPage: ()=>$59d96d961d806fee$var$LazyIssuePage.preload(),
        embedded: ()=>$59d96d961d806fee$var$AsyncIssueAppComponent.preload()
    };
    const $59d96d961d806fee$var$PrefetchCBBResourcesComponent = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("4NxWn")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/prefetch-wrm-bundle/index.tsx"
    });
    let $59d96d961d806fee$var$serverIssuePreloadIdentifier = '';
    if (!false && window.SPA_STATE?.serverIssuePreload) {
        const importSupplier = $59d96d961d806fee$var$imports[window.SPA_STATE.serverIssuePreload];
        importSupplier && importSupplier();
    }
    const $59d96d961d806fee$var$ISSUE_PRELOAD_COMPONENT_MARK = 'IssuePreloadComponent:rendered';
    const $59d96d961d806fee$var$useParamsSelector = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>({
            query: state.query,
            params: state.match.params
        }));
    const $59d96d961d806fee$var$IssuePreloadComponentBuilder = (identifier, preloadSupplier, preloadContract)=>()=>{
            const { query: query, params: params } = $59d96d961d806fee$var$useParamsSelector();
            if (!preloadContract || preloadContract.some((preloadingMatch)=>(!preloadingMatch.query || (0, (0, parcelRequire("5DQxU")).default)(preloadingMatch.query, query)) && (!preloadingMatch.params || preloadingMatch.params.every(({ key: key, value: value })=>params && params[key] !== undefined && (value === undefined || params[key] === value))))) {
                if (!false) preloadSupplier();
                if (false) $59d96d961d806fee$var$serverIssuePreloadIdentifier = identifier;
                else performance.mark($59d96d961d806fee$var$ISSUE_PRELOAD_COMPONENT_MARK);
            }
            return null;
        };
    const $59d96d961d806fee$export$f55e6973062dc859 = ()=>$59d96d961d806fee$var$serverIssuePreloadIdentifier;
    const $59d96d961d806fee$var$FullPageIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('fullPage', $59d96d961d806fee$var$imports.fullPage);
    $59d96d961d806fee$var$FullPageIssuePreloadComponent.displayName = 'FullPageIssuePreloadComponent';
    const $59d96d961d806fee$export$98e337c40eb151da = (0, (0, parcelRequire("aPfsS")).createLayout)({
        globalComponents: [
            $59d96d961d806fee$var$FullPageIssuePreloadComponent,
            $59d96d961d806fee$var$PrefetchCBBResourcesComponent
        ]
    });
    const $59d96d961d806fee$export$7b113174a456921a = (preloadContract)=>{
        const EmbeddedIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('embedded', $59d96d961d806fee$var$imports.embedded, preloadContract);
        EmbeddedIssuePreloadComponent.displayName = 'EmbeddedIssuePreloadComponent';
        return (0, (0, parcelRequire("aPfsS")).createLayout)({
            globalComponents: [
                EmbeddedIssuePreloadComponent
            ]
        });
    };
    var $kxZPA;
    const $43c3852afc527b13$export$8c70dcc4643464f8 = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("jO7eF")), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
    });
    var $lmyls;
    var $dmKXV;
    var $aVFIE;
    var $2G9Bk;
    var $aPfsS;
    var $d8VYe;
    var $lNicp;
    var $65Ltd;
    const $143b8615692fbb7d$export$bd75a810572fe27d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED),
        path: '/jira/core/projects/:projectKey/board/embed',
        exact: true
    };
    var $65Ltd;
    const $66846ddeea123664$export$14a5cbbd7e1e2dc2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
        exact: true,
        path: '/jira/core/projects/:projectKey/board',
        query: [
            'issue-key?'
        ]
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $e7b72b6f4fea8ed1$export$a21a9228b9e68b40 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("bY2uJ")), {
        moduleId: "./src/packages/spa-apps/business/board-embed/src/index-old.tsx"
    });
    var $e7b72b6f4fea8ed1$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e7b72b6f4fea8ed1$export$a21a9228b9e68b40,
            pageId: "async-business-board-embed",
            shouldShowSpinner: true
        });
    const $cc9b07a0cf3a6615$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "57cedf702b2fe356a4affe4b7a7087d367cb24ca910dd0e7b48587ef8059ca8e",
            "metadata": {},
            "name": "src_jiraBusinessBoardEmbedQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $cc9b07a0cf3a6615$export$2e2bcd8739ae039 = $cc9b07a0cf3a6615$var$node;
    var $eufEc;
    var $fEDBv;
    const $302c841aa900e4ab$export$416ba69e2e054935 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("iXXDL")), {
            moduleId: "c853cc44"
        }),
        getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
            const projectKey = context.match.params.projectKey;
            if (projectKey == null) throw new Error('Project key missing');
            return {
                queries: {
                    boardEmbedQuery: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $cc9b07a0cf3a6615$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                }
            };
        }
    });
    const $b8780d447378502c$export$5046daadb8899791 = (0, $6a0b20679c309df7$export$56ea489e9d4bfa04)({
        main: (0, $302c841aa900e4ab$export$416ba69e2e054935)
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $d8edd4ee45a069a7$export$d663c6b2156921dd = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("2HZX8")), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/business/board/src/index-old.tsx"
    });
    var $d8edd4ee45a069a7$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d8edd4ee45a069a7$export$d663c6b2156921dd,
            pageId: "async-business-board",
            shouldShowSpinner: true
        });
    var $lmyls;
    const $5e141afb773c5347$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "b310b99e34ec25ad16ee0f3f3047867a76ffcc43641ca09c70485a9bc1021faa",
            "metadata": {},
            "name": "src_jiraBusinessBoardQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $5e141afb773c5347$export$2e2bcd8739ae039 = $5e141afb773c5347$var$node;
    var $eufEc;
    var $fEDBv;
    const $a4aaf8c5264c4217$export$937ca5a4cdc1a12e = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("9JsLN")), {
            moduleId: "8dcbcc62"
        }),
        getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
            const projectKey = context.match.params.projectKey;
            if (projectKey == null) throw new Error('Project key missing');
            return {
                queries: {
                    boardQuery: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $5e141afb773c5347$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                }
            };
        }
    });
    const $39c257a891cf9743$export$552f44bed039f041 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $a4aaf8c5264c4217$export$937ca5a4cdc1a12e),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $ac716fbef6179315$export$c7fe0dd4417407a0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $66846ddeea123664$export$14a5cbbd7e1e2dc2), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
            ufoName: 'jwm.jwm-board',
            component: (0, $d8edd4ee45a069a7$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'issue-key'
                    ]
                }
            ])),
            skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                (0, (0, parcelRequire("d8VYe")).workflowIssuesResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d8edd4ee45a069a7$export$d663c6b2156921dd)
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            preloadOptions: {
                earlyChunks: [
                    'business-board-early-entry'
                ]
            },
            entryPoint: ()=>(0, (0, parcelRequire("4R6GH")).fg)('sv-2_convert_board_view_to_entrypoints') ? (0, $39c257a891cf9743$export$552f44bed039f041) : undefined
        }));
    const $ac716fbef6179315$export$7a97e5e258f37b2a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $143b8615692fbb7d$export$bd75a810572fe27d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
            ufoName: 'jwm.jwm-board-embed',
            component: (0, $e7b72b6f4fea8ed1$export$2e2bcd8739ae039),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                (0, (0, parcelRequire("d8VYe")).workflowIssuesResource)
            ],
            forPaint: [
                (0, $e7b72b6f4fea8ed1$export$a21a9228b9e68b40)
            ],
            entryPoint: ()=>(0, (0, parcelRequire("4R6GH")).fg)('sv-2_convert_board_view_to_entrypoints') ? (0, $b8780d447378502c$export$5046daadb8899791) : undefined
        }));
    var $ffza4;
    var $l71WK;
    var $65Ltd;
    var $6s1PB;
    var $lmyls;
    var $dmKXV;
    var $aVFIE;
    var $2G9Bk;
    var $lNicp;
    var $65Ltd;
    const $257b3e3c032338e6$export$ea171f7670960cff = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
        path: '/jira/core/projects/:projectKey/list',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $lmyls;
    const $6fc143a99d34d8f4$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b",
            "metadata": {},
            "name": "formatRulesQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $6fc143a99d34d8f4$export$2e2bcd8739ae039 = $6fc143a99d34d8f4$var$node;
    var $eufEc;
    var $fEDBv;
    const $7b34153964734d60$var$FORMAT_RULES_FIRST = 20;
    const $7b34153964734d60$export$6be4f10150ff6073 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("5ydcY")), {
            moduleId: "b03343a1"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = context.match.params;
            if (!projectKey) throw new Error('projectKey is required');
            return {
                queries: {
                    formattingRulesQuery: {
                        parameters: $6fc143a99d34d8f4$export$2e2bcd8739ae039,
                        variables: {
                            projectKey: projectKey,
                            cloudId: tenantContext.cloudId,
                            first: $7b34153964734d60$var$FORMAT_RULES_FIRST
                        },
                        options: {
                            fetchPolicy: 'network-only'
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            };
        }
    });
    var $5j7Th;
    var $kxZPA;
    const $ec723b069ad81673$export$4bfa19c758c39608 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5ydcY")), {
        moduleId: "./src/packages/spa-apps/business/list/src/index.tsx"
    });
    var $ec723b069ad81673$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ec723b069ad81673$export$4bfa19c758c39608,
            pageId: "async-business-list",
            shouldShowSpinner: true
        });
    const $ec723b069ad81673$export$c338b91a236e608a = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $7b34153964734d60$export$6be4f10150ff6073),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $777878a046a71170$export$9ef24aa950399eaf = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $257b3e3c032338e6$export$ea171f7670960cff), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
            ufoName: 'jwm.list-view',
            component: (0, $ec723b069ad81673$export$2e2bcd8739ae039),
            layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
            skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
            entryPoint: ()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, $ec723b069ad81673$export$c338b91a236e608a) : undefined,
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ec723b069ad81673$export$4bfa19c758c39608)
            ]
        }));
    var $ffza4;
    var $l71WK;
    var $65Ltd;
    var $lmyls;
    var $dmKXV;
    var $2G9Bk;
    var $lNicp;
    var $65Ltd;
    const $2d98eac94414a73a$export$5ab0e07528c31349 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
        path: '/jira/core/overviews/:overviewId',
        exact: true
    };
    var $hqguB;
    var $7MCPm;
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $bmKPg;
    const $31755126abaef7af$var$OverviewRedirect = ()=>{
        const [overviewId] = (0, (0, parcelRequire("bmKPg")).usePathParam)('overviewId');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/core/overviews/${overviewId}/summary`
        });
    };
    var $31755126abaef7af$export$2e2bcd8739ae039 = $31755126abaef7af$var$OverviewRedirect;
    const $1f023b89a193f508$export$766e305da4c78de5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hqguB")).jiraBusinessProjectRedirectRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
            isRedirect: true,
            component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
            layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    const $1f023b89a193f508$export$3aa9116f715693e1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2d98eac94414a73a$export$5ab0e07528c31349), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
            isRedirect: true,
            component: (0, $31755126abaef7af$export$2e2bcd8739ae039),
            layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav)
            },
            resources: (0, (0, parcelRequire("lNicp")).getOverviewViewResources)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $65Ltd;
    const $c0fa680257c9f3d1$export$61383e5418d2ffe3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
        path: '/jira/core/overviews/:overviewId/calendar',
        exact: true
    };
    var $65Ltd;
    const $64a453e593a46414$export$4a86e6b12ce49af9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
        path: '/jira/core/overviews/:overviewId/summary',
        exact: true
    };
    var $65Ltd;
    const $2de2a62458dcdd8a$export$13f0c823ff3059c2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE),
        path: '/jira/core/overviews/:overviewId/timeline',
        exact: true
    };
    var $65Ltd;
    const $5bb44f21c5956447$export$3109a183a442a02d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS),
        path: '/jira/core/projects/:projectKey/approvals',
        exact: true
    };
    var $65Ltd;
    const $2eaf30573c21c250$export$2d0c5d5ce5a00c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS),
        path: '/jira/core/projects/:projectKey/attachments'
    };
    var $65Ltd;
    const $b30762da57e7833b$export$e237859f2fc7cc7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED),
        path: '/jira/core/projects/:projectKey/calendar/embed',
        exact: true
    };
    var $65Ltd;
    const $cc0fb8d6c0f9ea49$export$ba1373c12ea65b4c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
        path: '/jira/core/projects/:projectKey/calendar',
        exact: true
    };
    var $65Ltd;
    const $939973d6db7f74a6$export$5f684808e671de5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER),
        path: '/jira/core/projects/:projectKey/form/:formId/builder',
        exact: true
    };
    var $65Ltd;
    const $63fab73853b00f48$export$e98776bdf96c88ac = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
        path: '/jira/core/projects/:projectKey/form',
        exact: true
    };
    var $65Ltd;
    const $bab948378ba6b470$export$7e8fd15fdfa29385 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED),
        path: '/jira/core/projects/:projectKey/form/:formId/embed',
        exact: true
    };
    var $65Ltd;
    const $6637feb602e2c6a2$export$3cd93ff55b29f07f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT),
        path: '/jira/core/projects/:projectKey/form/:formId',
        exact: true
    };
    var $65Ltd;
    const $a9a3d79a7f5c11b3$export$f0d33cf104c15274 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED),
        path: '/jira/core/projects/:projectKey/list/embed',
        exact: true
    };
    var $65Ltd;
    const $cc13a94c19681f9f$export$cd9c218d7c968d2d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING),
        path: '/jira/core/sample/onboarding/:taskId',
        exact: true
    };
    var $65Ltd;
    const $60aa8b153682dfa1$export$2dd4e8a37d8ac978 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT),
        path: '/jira/core/projects/:projectKey/shortcuts',
        exact: true
    };
    var $65Ltd;
    const $d749196fd651fc48$export$54a218ca6d1c056a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES),
        path: '/jira/core/projects/:projectKey/pages'
    };
    var $ffza4;
    var $l71WK;
    var $65Ltd;
    var $4R6GH;
    var $lmyls;
    var $dmKXV;
    var $aVFIE;
    var $2G9Bk;
    var $lNicp;
    var $kqhaB;
    var $3zj3N;
    var $65Ltd;
    const $75bf41a31996f0a6$export$d4aa7e677d381961 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED),
        path: '/jira/core/projects/:projectKey/summary/embed',
        exact: true
    };
    var $65Ltd;
    const $da1a77dee609f26a$export$ad0ce411d14c71d7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY),
        path: '/jira/core/projects/:projectKey/summary',
        exact: true
    };
    const $6a7b94e3ffb3bd2f$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "ae4216968660d9d5fa7dd9a725e821d8a0434d55113a2497e16f6ac279f1f54d",
            "metadata": {},
            "name": "src_jiraBusinessSummaryEmbedQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $6a7b94e3ffb3bd2f$export$2e2bcd8739ae039 = $6a7b94e3ffb3bd2f$var$node;
    var $eufEc;
    var $fEDBv;
    const $99cc4adc5066587d$export$5a118ab60ce38554 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("gZLHI")), {
            moduleId: "936313f5"
        }),
        getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
            const projectKey = context.match.params.projectKey;
            if (projectKey == null) throw new Error('Project key missing');
            return {
                queries: {
                    summaryEmbedQuery: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $6a7b94e3ffb3bd2f$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                }
            };
        }
    });
    const $8e3b5ebe8bc3ce2b$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "2fa7826555f7e47c6f25502ea0cc3733efe0e7dba669d14a0547a015abad3763",
            "metadata": {},
            "name": "src_jiraBusinessSummaryQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $8e3b5ebe8bc3ce2b$export$2e2bcd8739ae039 = $8e3b5ebe8bc3ce2b$var$node;
    var $eufEc;
    var $fEDBv;
    const $e408b66321f42c9a$export$3d50a9cba1287544 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("hU6op")), {
            moduleId: "75fba772"
        }),
        getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
            const projectKey = context.match.params.projectKey;
            if (projectKey == null) throw new Error('Project key missing');
            return {
                queries: {
                    summaryQuery: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $8e3b5ebe8bc3ce2b$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                }
            };
        }
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $fb865335915410ee$export$a860d403525d69a5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("g209c")), {
        moduleId: "./src/packages/spa-apps/business/summary-embed/src/index-old.tsx"
    });
    var $fb865335915410ee$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fb865335915410ee$export$a860d403525d69a5,
            pageId: "async-business-summary-embed",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $ce4107334d03fb3d$export$68c09444cc6f2843 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ikYqv")), {
        moduleId: "./src/packages/spa-apps/business/summary/src/index-old.tsx"
    });
    var $ce4107334d03fb3d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ce4107334d03fb3d$export$68c09444cc6f2843,
            pageId: "async-business-summary",
            shouldShowSpinner: true
        });
    const $e9b14c9fa65f9b70$var$summaryPageEntrypoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $e408b66321f42c9a$export$3d50a9cba1287544),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $e9b14c9fa65f9b70$export$66365c0c5e8430d2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $da1a77dee609f26a$export$ad0ce411d14c71d7), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
            ufoName: 'jwm.summary-view',
            component: (0, $ce4107334d03fb3d$export$2e2bcd8739ae039),
            layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
            skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                (0, (0, parcelRequire("3zj3N")).summaryDataResource),
                (0, (0, parcelRequire("kqhaB")).activityFeedResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ce4107334d03fb3d$export$68c09444cc6f2843)
            ],
            entryPoint: ()=>(0, (0, parcelRequire("4R6GH")).fg)('sv-6_migrate_summary_page_entrypoint') ? $e9b14c9fa65f9b70$var$summaryPageEntrypoint : undefined
        }));
    const $e9b14c9fa65f9b70$var$summaryEmbedPageEntrypoint = (0, $6a0b20679c309df7$export$56ea489e9d4bfa04)({
        main: (0, $99cc4adc5066587d$export$5a118ab60ce38554)
    });
    const $e9b14c9fa65f9b70$export$2c37f93832ff9919 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $75bf41a31996f0a6$export$d4aa7e677d381961), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
            ufoName: 'jwm.summary-view-embed',
            component: (0, $fb865335915410ee$export$2e2bcd8739ae039),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                (0, (0, parcelRequire("3zj3N")).summaryDataResource),
                (0, (0, parcelRequire("kqhaB")).activityFeedResource)
            ],
            forPaint: [
                (0, $fb865335915410ee$export$a860d403525d69a5)
            ],
            entryPoint: ()=>(0, (0, parcelRequire("4R6GH")).fg)('sv-6_migrate_summary_page_entrypoint') ? $e9b14c9fa65f9b70$var$summaryEmbedPageEntrypoint : undefined
        }));
    var $ffza4;
    var $l71WK;
    var $65Ltd;
    var $4R6GH;
    var $lmyls;
    var $dmKXV;
    var $aVFIE;
    var $2G9Bk;
    var $lNicp;
    var $65Ltd;
    const $12b838a84c0952a0$export$d85fbccfa0ba559a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED),
        path: '/jira/core/projects/:projectKey/timeline/embed',
        exact: true
    };
    var $65Ltd;
    const $d72294ad8bab4281$export$4c71cfbf61bf0bf3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
        path: '/jira/core/projects/:projectKey/timeline',
        exact: true
    };
    const $c96eaccedf3004ad$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "776cc4058b84f9310cb7fb44a6d1d1b48d19c6215f4c1e298d0bf71cc8b16c23",
            "metadata": {},
            "name": "src_jiraBusinessTimelineEmbedQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $c96eaccedf3004ad$export$2e2bcd8739ae039 = $c96eaccedf3004ad$var$node;
    var $eufEc;
    var $fEDBv;
    const $94157aa0ce3558d4$export$12a9d017aa53985f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("fJgPj")), {
            moduleId: "88bc99ab"
        }),
        getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
            const projectKey = context.match.params.projectKey;
            if (projectKey == null) throw new Error('Project key missing');
            return {
                queries: {
                    timelineEmbedQuery: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $c96eaccedf3004ad$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                }
            };
        }
    });
    const $5232f385be868c01$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "d35fba039f478a32001720414c597a8c17f630b064e5dd960be7a1d59c61980c",
            "metadata": {},
            "name": "src_jiraBusinessTimelineQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $5232f385be868c01$export$2e2bcd8739ae039 = $5232f385be868c01$var$node;
    var $eufEc;
    var $fEDBv;
    const $49d4c306324fda15$export$7586afa83216512a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("l9J3G")), {
            moduleId: "cac371d1"
        }),
        getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
            const projectKey = context.match.params.projectKey;
            if (projectKey == null) throw new Error('Project key missing');
            return {
                queries: {
                    timelineQuery: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $5232f385be868c01$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                }
            };
        }
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $cafc00ba0636c72a$export$49e7774ce1be17a4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8y7Tc")), {
        moduleId: "./src/packages/spa-apps/business/timeline-embed/src/index-old.tsx"
    });
    var $cafc00ba0636c72a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cafc00ba0636c72a$export$49e7774ce1be17a4,
            pageId: "async-business-timeline-embed",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $db59fcf727b969e3$export$5ae50f261c16f52a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hmqZp")), {
        moduleId: "./src/packages/spa-apps/business/timeline/src/index-old.tsx"
    });
    var $db59fcf727b969e3$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $db59fcf727b969e3$export$5ae50f261c16f52a,
            pageId: "async-business-timeline",
            shouldShowSpinner: true
        });
    const $b3244f4bab1a985d$var$timelinePageEntrypoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $49d4c306324fda15$export$7586afa83216512a),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $b3244f4bab1a985d$export$5725375da49b5772 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d72294ad8bab4281$export$4c71cfbf61bf0bf3), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
            ufoName: 'jwm.timeline-view',
            component: (0, $db59fcf727b969e3$export$2e2bcd8739ae039),
            layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
            skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $db59fcf727b969e3$export$5ae50f261c16f52a)
            ],
            entryPoint: ()=>(0, (0, parcelRequire("4R6GH")).fg)('sv-8_migrate_timeline_to_entrypoint') ? $b3244f4bab1a985d$var$timelinePageEntrypoint : undefined
        }));
    const $b3244f4bab1a985d$var$timelineEmbedPageEntrypoint = (0, $6a0b20679c309df7$export$56ea489e9d4bfa04)({
        main: (0, $94157aa0ce3558d4$export$12a9d017aa53985f)
    });
    const $b3244f4bab1a985d$export$ef65a62ced1a9df1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $12b838a84c0952a0$export$d85fbccfa0ba559a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
            ufoName: 'jwm.timeline-embed-view',
            component: (0, $cafc00ba0636c72a$export$2e2bcd8739ae039),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
            resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
            forPaint: [
                (0, $cafc00ba0636c72a$export$49e7774ce1be17a4)
            ],
            entryPoint: ()=>(0, (0, parcelRequire("4R6GH")).fg)('sv-8_migrate_timeline_to_entrypoint') ? $b3244f4bab1a985d$var$timelineEmbedPageEntrypoint : undefined
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $dd9ad925b76a4dba$export$70abf918dfb890e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8Cz9F")), {
        moduleId: "./src/packages/spa-apps/business/approvals/src/index-old.tsx"
    });
    var $dd9ad925b76a4dba$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $dd9ad925b76a4dba$export$70abf918dfb890e,
            pageId: "async-business-approvals",
            shouldShowSpinner: true
        });
    var $lmyls;
    const $4cf737eba0cc3036$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "cd3e948c8fb13e046de09efe80872dad680fe76195ff44295aeb9c91f367879d",
            "metadata": {},
            "name": "src_jiraBusinessApprovalsQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $4cf737eba0cc3036$export$2e2bcd8739ae039 = $4cf737eba0cc3036$var$node;
    var $eufEc;
    var $fEDBv;
    const $300bb28bd2b40101$export$25d4a03de93a440e = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("ehclT")), {
            moduleId: "6a9ba200"
        }),
        getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
            const projectKey = context.match.params.projectKey;
            if (projectKey == null) throw new Error('Project key missing');
            return {
                queries: {
                    approvalsQuery: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $4cf737eba0cc3036$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                }
            };
        }
    });
    const $09fa0192771673de$export$52c40d37705be5fa = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $300bb28bd2b40101$export$25d4a03de93a440e),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    var $lmyls;
    var $4R6GH;
    const $6955691f2f41efa8$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "80bca32e39cc37fd5868fcb75478bf4c17e05ff8f14ec377a536e61312c1e09f",
            "metadata": {},
            "name": "src_jiraBusinessAttachmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $6955691f2f41efa8$export$2e2bcd8739ae039 = $6955691f2f41efa8$var$node;
    var $eufEc;
    var $fEDBv;
    const $5488b7c894698968$export$d94bafd9d893ec98 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("hDgu1")), {
            moduleId: "26a1d436"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = context.match.params;
            if (!projectKey) throw new Error('projectKey is required');
            return {
                queries: {
                    jwmAttachmentsQuery: {
                        parameters: $6955691f2f41efa8$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: projectKey,
                            projectKeys: [
                                projectKey
                            ],
                            filters: {
                                fileName: '',
                                authorIds: [],
                                mimeTypes: [],
                                dateRange: {
                                    before: undefined,
                                    after: undefined
                                }
                            },
                            durationInSeconds: 900,
                            maxTokenLength: 65534,
                            attachmentCount: 100,
                            withProjectFragment: (0, (0, parcelRequire("4R6GH")).fg)('sv-16_migrate_attachments_project_context_provider')
                        },
                        options: {
                            fetchPolicy: 'network-only'
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            };
        }
    });
    const $8d9ee4e688aa8c8e$export$d2dbce06a31f0f47 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $5488b7c894698968$export$d94bafd9d893ec98),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $5c1e2f0293284481$export$152b9e0029b084e8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4gbcC")), {
        moduleId: "./src/packages/spa-apps/business/calendar-embed/src/index-old.tsx"
    });
    var $5c1e2f0293284481$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5c1e2f0293284481$export$152b9e0029b084e8,
            pageId: "async-business-calendar-embed",
            shouldShowSpinner: true
        });
    const $6a5d8de5abeff379$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "6ddbf49cfff3b1157dc3e1266f9526e79066930cfe3ce54c85171a6c7cdaa032",
            "metadata": {},
            "name": "src_jiraBusinessCalendarEmbedQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $6a5d8de5abeff379$export$2e2bcd8739ae039 = $6a5d8de5abeff379$var$node;
    var $eufEc;
    var $fEDBv;
    const $6e0458699dd28572$export$6ce8d7eff8d6b026 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("346g2")), {
            moduleId: "806194a7"
        }),
        getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
            const projectKey = context.match.params.projectKey;
            if (projectKey == null) throw new Error('Project key missing');
            return {
                queries: {
                    calendarEmbedQuery: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $6a5d8de5abeff379$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                }
            };
        }
    });
    var $4R6GH;
    var $eufEc;
    var $fEDBv;
    const $38193f9d05bd632a$var$SETTINGS_STORAGE_KEY = 'calendar:settings:business';
    function $38193f9d05bd632a$var$getViewSettings(key) {
        try {
            const serializedValue = globalThis.localStorage?.getItem(key);
            return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
        } catch  {
            return undefined;
        }
    }
    const $38193f9d05bd632a$var$and = (clauses)=>{
        return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
    };
    function $38193f9d05bd632a$var$toMidnightUTCString(date) {
        const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        return new Date(utcMilliseconds).toISOString();
    }
    function $38193f9d05bd632a$var$toDate(date) {
        if (!date) return new Date();
        try {
            const _date = new Date(date);
            return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
        } catch (e) {
            return new Date();
        }
    }
    function $38193f9d05bd632a$var$createScope({ context: context }) {
        return {
            type: 'project',
            projectKeys: [
                String(context.match.params.projectKey)
            ]
        };
    }
    function $38193f9d05bd632a$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
        const { cloudId: cloudId } = tenantContext;
        return {
            projectKeys: {
                cloudId: cloudId,
                keys: scope.projectKeys
            }
        };
    }
    function $38193f9d05bd632a$var$toViewMode(mode) {
        switch(mode){
            case 'week':
                return 'WEEK';
            case 'day':
                return 'DAY';
            default:
                return 'MONTH';
        }
    }
    function $38193f9d05bd632a$var$toWeekStart(weekStart) {
        switch(weekStart){
            case 'monday':
                return 'MONDAY';
            case 'saturday':
                return 'SATURDAY';
            default:
                return 'SUNDAY';
        }
    }
    function $38193f9d05bd632a$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
        return {
            date: $38193f9d05bd632a$var$toMidnightUTCString(selectedDate),
            mode: $38193f9d05bd632a$var$toViewMode(viewRange),
            weekStart: $38193f9d05bd632a$var$toWeekStart(weekStartsOn),
            startDateField: startDateField,
            endDateField: endDateField,
            viewId: null
        };
    }
    function $38193f9d05bd632a$var$jqlSearchText(text) {
        if (text === undefined || text.trim() === '') return '';
        const sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
        const ISSUEKEY_REGEX = '([A-Z][A-Z0-9_]+-\\d+)';
        const issueKeyRegex = new RegExp(`^${ISSUEKEY_REGEX}$`);
        const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
        let search = sanitize(text);
        if (issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
        if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
        return `(summary ~ '${search}' OR description ~ '${search}')`;
    }
    function $38193f9d05bd632a$var$buildIssuesSearchInput(filter = '', text = '', hideDoneItems) {
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination')) return {
            additionalFilterQuery: ''
        };
        const hideDoneItemsQuery = "StatusCategory != 'Complete'";
        const search = $38193f9d05bd632a$var$jqlSearchText(text);
        return {
            additionalFilterQuery: $38193f9d05bd632a$var$and([
                search,
                filter,
                ...hideDoneItems ? [
                    hideDoneItemsQuery
                ] : []
            ])
        };
    }
    function $38193f9d05bd632a$var$buildUnscheduledIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    const $38193f9d05bd632a$export$19cf4b398f638dc6 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("4w2X9")), {
            moduleId: "70b39bf1"
        }),
        getPreloadProps: (entryPointRouteParams)=>{
            const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
            const { cloudId: cloudId } = tenantContext;
            const scope = $38193f9d05bd632a$var$createScope(entryPointRouteParams);
            const { date: date, filter: filter, hideDone: hideDone, text: text } = context.query;
            const selectedDate = $38193f9d05bd632a$var$toDate(date);
            const settings = (0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination') ? $38193f9d05bd632a$var$getViewSettings($38193f9d05bd632a$var$SETTINGS_STORAGE_KEY) : undefined;
            const viewRange = 'month';
            const hideDoneItems = hideDone && (0, (0, parcelRequire("4R6GH")).fg)('calendar-hide-done-query-param') ? true : settings?.hideDoneItems ?? false;
            const weekStartsOn = (0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination') ? settings?.weekStartsOn ?? 'sunday' : 'sunday';
            const startDateField = 'startdate';
            const endDateField = 'duedate';
            const issueEventFields = {
                startDateField: startDateField,
                endDateField: endDateField
            };
            return {
                queries: {
                    calendarData: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $122674b135b0c50b$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            scopeInput: $38193f9d05bd632a$var$buildScopeInput(entryPointRouteParams, scope),
                            configurationInput: $38193f9d05bd632a$var$buildConfigurationInput({
                                selectedDate: selectedDate,
                                viewRange: viewRange,
                                weekStartsOn: weekStartsOn,
                                startDateField: startDateField,
                                endDateField: endDateField
                            }),
                            issuesPageSize: 50,
                            issuesSearchInput: $38193f9d05bd632a$var$buildIssuesSearchInput(filter, text, hideDoneItems),
                            unscheduledIssuesSearchInput: $38193f9d05bd632a$var$buildUnscheduledIssuesSearchInput(),
                            versionsSearchInput: {
                                versionStatuses: [
                                    'RELEASED',
                                    'UNRELEASED'
                                ],
                                includeSharedReleases: true
                            },
                            sprintsSearchInput: null,
                            skipSprintSearch: true,
                            viewId: null,
                            schedulePermissionsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('calendar_schedule_issue_permissions_check'),
                            pageLoadMoreEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination'),
                            skipVersionsV1Search: (0, (0, parcelRequire("4R6GH")).fg)('plan-calendar-versions-v2-adoption'),
                            skipVersionsV2Search: !(0, (0, parcelRequire("4R6GH")).fg)('plan-calendar-versions-v2-adoption')
                        }
                    }
                },
                entryPoints: {},
                extraProps: {
                    scope: scope,
                    selectedDate: selectedDate,
                    viewRange: viewRange,
                    weekStartsOn: weekStartsOn,
                    issueEventFields: issueEventFields
                }
            };
        }
    });
    const $70a9a2194c74ba61$export$9e707055fd805884 = (0, $6a0b20679c309df7$export$56ea489e9d4bfa04)({
        main: (0, $38193f9d05bd632a$export$19cf4b398f638dc6)
    });
    const $70a9a2194c74ba61$export$d2ede18b8c2bb618 = (0, $6a0b20679c309df7$export$56ea489e9d4bfa04)({
        main: (0, $6e0458699dd28572$export$6ce8d7eff8d6b026)
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $db83b57b32636320$export$ebca96bcc4698ee2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hd6bU")), {
        moduleId: "./src/packages/spa-apps/business/calendar/src/index-old.tsx"
    });
    var $db83b57b32636320$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $db83b57b32636320$export$ebca96bcc4698ee2,
            pageId: "async-business-calendar",
            shouldShowSpinner: true
        });
    var $lmyls;
    const $28130442660fe442$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "52091311de7c62539bcc2801cb050c011654c1915f33e47a1173ac2d96bca8c2",
            "metadata": {},
            "name": "src_jiraBusinessCalendarQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $28130442660fe442$export$2e2bcd8739ae039 = $28130442660fe442$var$node;
    var $eufEc;
    var $fEDBv;
    const $1d5ded87a815c51a$export$642797ae4b06d84d = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("bZ8KB")), {
            moduleId: "5d7f32eb"
        }),
        getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
            const projectKey = context.match.params.projectKey;
            if (projectKey == null) throw new Error('Project key missing');
            return {
                queries: {
                    calendarQuery: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $28130442660fe442$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                }
            };
        }
    });
    const $623de1afef111eb1$export$e2ec691d4d2243ca = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $38193f9d05bd632a$export$19cf4b398f638dc6),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $623de1afef111eb1$export$9c79a937486d1f3f = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $1d5ded87a815c51a$export$642797ae4b06d84d),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $69b26f1a607bfd2a$export$2076234d7fde1717 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("1VAUG")), {
        moduleId: "./src/packages/spa-apps/business/form-builder/src/index.tsx"
    });
    var $69b26f1a607bfd2a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $69b26f1a607bfd2a$export$2076234d7fde1717,
            pageId: "async-business-form-builder",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $7b75b9ef7f4c7083$export$4d2f42d18d020964 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3q8eE")), {
        moduleId: "./src/packages/spa-apps/business/form-submit-embed/src/index.tsx"
    });
    var $7b75b9ef7f4c7083$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7b75b9ef7f4c7083$export$4d2f42d18d020964,
            pageId: "async-business-form-submit-embed",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $86d107866af1a870$export$258fcd204933dd75 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4itvs")), {
        moduleId: "./src/packages/spa-apps/business/form-submit/src/index.tsx"
    });
    var $86d107866af1a870$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $86d107866af1a870$export$258fcd204933dd75,
            pageId: "async-business-form-submit",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $32842b78cbaba6f2$export$240a58749ebba091 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aWQgu")), {
        moduleId: "./src/packages/spa-apps/business/form/src/index.tsx"
    });
    var $32842b78cbaba6f2$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $32842b78cbaba6f2$export$240a58749ebba091,
            pageId: "async-business-form",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $5d8b9133c744d9c4$export$55704f3c7b8c3364 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("453PM")), {
        moduleId: "./src/packages/spa-apps/business/list-embed/src/index.tsx"
    });
    var $5d8b9133c744d9c4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5d8b9133c744d9c4$export$55704f3c7b8c3364,
            pageId: "async-business-list-embed",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $d22af251819eb3be$export$5b8a69e38f82df6c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("flfyB")), {
        moduleId: "./src/packages/spa-apps/business/overview-calendar/src/index.tsx"
    });
    var $d22af251819eb3be$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d22af251819eb3be$export$5b8a69e38f82df6c,
            pageId: "async-business-overview-calendar",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $2d4de63580afb00a$export$125428653f4abe07 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3lzAA")), {
        moduleId: "./src/packages/spa-apps/business/overview-summary/src/index.tsx"
    });
    var $2d4de63580afb00a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2d4de63580afb00a$export$125428653f4abe07,
            pageId: "async-business-overview-summary",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $e65cb4f5cee837b4$export$bfea8be13da0d217 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3TIie")), {
        moduleId: "./src/packages/spa-apps/business/overview-timeline/src/index.tsx"
    });
    var $e65cb4f5cee837b4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e65cb4f5cee837b4$export$bfea8be13da0d217,
            pageId: "async-business-overview-timeline",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $2NMNM;
    var $dxCvy;
    var $bVDE5;
    var $7tQej;
    var $2YP9W;
    var $doZTA;
    const $d0b7938065585b86$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, (0, parcelRequire("7tQej")).Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useResource: useResource = (0, (0, parcelRequire("2YP9W")).useResource), useRouter: useRouter = (0, (0, parcelRequire("doZTA")).useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
    const $7e318392f3d5106d$export$c2115a649411f570 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5G6aX"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/business/pages/src/index.tsx"
    });
    const $7e318392f3d5106d$export$7c3b1828ada63555 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $d0b7938065585b86$export$8a3df560509448b8), {
            page: "/pages"
        });
    var $7e318392f3d5106d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7e318392f3d5106d$export$c2115a649411f570,
            pageId: "async-business-pages",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $d8c7c044abd4283c$export$e39375ab6521f3ef = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aSkBG")), {
        moduleId: "./src/packages/spa-apps/business/sample-onboarding/src/index.tsx"
    });
    var $d8c7c044abd4283c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d8c7c044abd4283c$export$e39375ab6521f3ef,
            pageId: "async-business-sample-onboarding",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $dc5f7ef9cda7dd06$export$dfbcb99b55c05486 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("k1jrD")), {
        moduleId: "./src/packages/spa-apps/business/shortcut/src/index-old.tsx"
    });
    var $dc5f7ef9cda7dd06$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $dc5f7ef9cda7dd06$export$dfbcb99b55c05486,
            pageId: "async-business-shortcuts",
            shouldShowSpinner: true
        });
    var $lmyls;
    const $c56df58cb6ff2ae3$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "897373a9ab169540f10b217dda3ac0ada024bc716be58e55e2f4ab636b2bc48c",
            "metadata": {},
            "name": "src_jiraBusinessShortcutsQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $c56df58cb6ff2ae3$export$2e2bcd8739ae039 = $c56df58cb6ff2ae3$var$node;
    var $eufEc;
    var $fEDBv;
    const $2c08d7e07e3e2760$export$212fd76838eeb6ad = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("ixusT")), {
            moduleId: "736f6fc2"
        }),
        getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
            const projectKey = context.match.params.projectKey;
            if (projectKey == null) throw new Error('Project key missing');
            return {
                queries: {
                    shortcutsQuery: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $c56df58cb6ff2ae3$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                }
            };
        }
    });
    const $19b2198152d557fa$export$57a2f1af23fcbb8b = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $2c08d7e07e3e2760$export$212fd76838eeb6ad),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $0e0d75857105a821$export$fb2091db9e7f9102 = [
        (0, $e9b14c9fa65f9b70$export$66365c0c5e8430d2),
        (0, $ac716fbef6179315$export$c7fe0dd4417407a0),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b30762da57e7833b$export$e237859f2fc7cc7), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                ufoName: 'jwm.calendar-embed-view',
                component: (0, $5c1e2f0293284481$export$2e2bcd8739ae039),
                entryPoint () {
                    return (0, (0, parcelRequire("6s1PB")).expValEquals)('business_projects_shared_calendar', 'cohort', 'variation') ? (0, $70a9a2194c74ba61$export$9e707055fd805884) : (0, (0, parcelRequire("4R6GH")).fg)('sv-9_migrate_legacy_calendar_to_entrypoint') ? (0, $70a9a2194c74ba61$export$d2ede18b8c2bb618) : undefined;
                },
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, $5c1e2f0293284481$export$152b9e0029b084e8)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cc0fb8d6c0f9ea49$export$ba1373c12ea65b4c), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                ufoName: 'jwm.calendar-view',
                component: (0, $db83b57b32636320$export$2e2bcd8739ae039),
                entryPoint () {
                    return (0, (0, parcelRequire("6s1PB")).expValEquals)('business_projects_shared_calendar', 'cohort', 'variation') ? (0, $623de1afef111eb1$export$e2ec691d4d2243ca) : (0, (0, parcelRequire("4R6GH")).fg)('sv-9_migrate_legacy_calendar_to_entrypoint') ? (0, $623de1afef111eb1$export$9c79a937486d1f3f) : undefined;
                },
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $db83b57b32636320$export$ebca96bcc4698ee2)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $60aa8b153682dfa1$export$2dd4e8a37d8ac978), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                component: (0, $dc5f7ef9cda7dd06$export$2e2bcd8739ae039),
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $dc5f7ef9cda7dd06$export$dfbcb99b55c05486)
                ],
                entryPoint: ()=>(0, (0, parcelRequire("4R6GH")).fg)('sv-21_migrate_shortcuts_page_to_entrypoint') ? (0, $19b2198152d557fa$export$57a2f1af23fcbb8b) : undefined
            })),
        (0, $777878a046a71170$export$9ef24aa950399eaf),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $63fab73853b00f48$export$e98776bdf96c88ac), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                ufoName: 'jwm.form-directory-view',
                component: (0, $32842b78cbaba6f2$export$2e2bcd8739ae039),
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $32842b78cbaba6f2$export$240a58749ebba091)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6637feb602e2c6a2$export$3cd93ff55b29f07f), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                ufoName: 'jwm.form-submit-view',
                component: (0, $86d107866af1a870$export$2e2bcd8739ae039),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $86d107866af1a870$export$258fcd204933dd75)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $939973d6db7f74a6$export$5f684808e671de5), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                ufoName: 'jwm.form-view',
                component: (0, $69b26f1a607bfd2a$export$2e2bcd8739ae039),
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $69b26f1a607bfd2a$export$2076234d7fde1717)
                ]
            })),
        (0, $b3244f4bab1a985d$export$5725375da49b5772),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5bb44f21c5956447$export$3109a183a442a02d), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                ufoName: 'jwm.approvals-view',
                component: (0, $dd9ad925b76a4dba$export$2e2bcd8739ae039),
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $dd9ad925b76a4dba$export$70abf918dfb890e)
                ],
                entryPoint: ()=>(0, (0, parcelRequire("4R6GH")).fg)('sv-7_migrate_approvals_page_to_entrypoint') ? (0, $09fa0192771673de$export$52c40d37705be5fa) : undefined
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d749196fd651fc48$export$54a218ca6d1c056a), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                resources: [
                    ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, $7e318392f3d5106d$export$2e2bcd8739ae039),
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $7e318392f3d5106d$export$c2115a649411f570)
                ],
                ufoName: 'jwm.jwm-pages'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2eaf30573c21c250$export$2d0c5d5ce5a00c), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                ufoName: 'jwm.attachments-view',
                layout: (0, $d0bc40d3dc70d875$export$dfb0c3e0348f4429),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                entryPoint: ()=>(0, $8d9ee4e688aa8c8e$export$d2dbce06a31f0f47),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)()
            })),
        (0, $b3244f4bab1a985d$export$ef65a62ced1a9df1),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a9a3d79a7f5c11b3$export$f0d33cf104c15274), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                ufoName: 'jwm.list-embed-view',
                component: (0, $5d8b9133c744d9c4$export$2e2bcd8739ae039),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                entryPoint: ()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, $ec723b069ad81673$export$c338b91a236e608a) : undefined,
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, $5d8b9133c744d9c4$export$55704f3c7b8c3364)
                ]
            })),
        (0, $ac716fbef6179315$export$7a97e5e258f37b2a),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $bab948378ba6b470$export$7e8fd15fdfa29385), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                ufoName: 'jwm.form-submit-embed-view',
                component: (0, $7b75b9ef7f4c7083$export$2e2bcd8739ae039),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, $7b75b9ef7f4c7083$export$4d2f42d18d020964)
                ]
            })),
        (0, $e9b14c9fa65f9b70$export$2c37f93832ff9919),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cc13a94c19681f9f$export$cd9c218d7c968d2d), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                component: (0, $d8c7c044abd4283c$export$2e2bcd8739ae039),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: (0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                forPaint: [
                    (0, $d8c7c044abd4283c$export$e39375ab6521f3ef)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2de2a62458dcdd8a$export$13f0c823ff3059c2), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                component: (0, $e65cb4f5cee837b4$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getOverviewViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $e65cb4f5cee837b4$export$bfea8be13da0d217)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c0fa680257c9f3d1$export$61383e5418d2ffe3), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                component: (0, $d22af251819eb3be$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getOverviewViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $d22af251819eb3be$export$5b8a69e38f82df6c)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $64a453e593a46414$export$4a86e6b12ce49af9), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
                component: (0, $2d4de63580afb00a$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getOverviewViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2d4de63580afb00a$export$125428653f4abe07)
                ]
            })),
        (0, $1f023b89a193f508$export$766e305da4c78de5),
        (0, $1f023b89a193f508$export$3aa9116f715693e1)
    ];
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $gADc2;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $b4450c735413409b$export$b8abcf8aa8f4df56 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dYp24"))), {
        moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
    });
    var $b4450c735413409b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b4450c735413409b$export$b8abcf8aa8f4df56,
            pageId: "project-settings-data-classifications",
            shouldShowSpinner: false
        });
    const $72c99d901431c503$export$5b0670f37204a43d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gADc2")).classicProjectSettingsDataClassificationsRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC),
            component: (0, $b4450c735413409b$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b4450c735413409b$export$b8abcf8aa8f4df56)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $3beddbd9a85d45eb$export$c593179674352d0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT),
        path: '/plugins/servlet/project-config/:projectKey/issuelayout',
        query: [
            'screenId'
        ],
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f7c23974aa64ecd2$export$36dcfb52d47cb93a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("h5Sqc"))), {
        moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
    });
    var $f7c23974aa64ecd2$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { issueTypeId: issueTypeId } = match.params;
        const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f7c23974aa64ecd2$export$36dcfb52d47cb93a,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
    const $72a8f02a914333fc$export$47b3bdf88a7d176b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3beddbd9a85d45eb$export$c593179674352d0), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC),
            ufoName: 'project-settings.issue-type.jsw-cmp',
            component: (0, $f7c23974aa64ecd2$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $f7c23974aa64ecd2$export$36dcfb52d47cb93a)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $6s1PB;
    var $7XYc4;
    var $cSD7y;
    var $gyYxw;
    var $2BrOV;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $3HwlS;
    var $9s3j1;
    var $2G9Bk;
    var $aPfsS;
    var $dAmbh;
    var $g4ZHz;
    var $1E3vT;
    var $iNzEe;
    var $l2N2a;
    var $9yEpR;
    var $lfnsv;
    var $lJ1FP;
    var $f5kpo;
    var $2GkDw;
    var $3RJkv;
    var $dxCvy;
    var $aFVvc;
    var $hJAri;
    var $iZ82x;
    var $7GnDe;
    var $2Ql51;
    var $65Ltd;
    const $0939314fcba99a8c$export$3913c8bee519225c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_DIRECTORY_REDIRECT),
        path: '/secure/RapidBoard.jspa'
    };
    var $65Ltd;
    const $af1c8b7df470b6b1$export$ff874528b0b33a61 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        path: '/secure/RapidBoard.jspa',
        query: [
            'rapidView',
            'view=(planning|planning.nodetail)'
        ]
    };
    var $evtTp;
    var $65Ltd;
    const $11672806ba958f46$export$9e1d275c8078512e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog'
    };
    var $65Ltd;
    const $848732acccd8706d$export$991b1be164057e91 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT),
        path: '/secure/RapidBoard.jspa',
        query: [
            'projectKey'
        ],
        __unsafeOrder: 1
    };
    var $65Ltd;
    const $0732a35485277820$export$d27f9ad2fc277ff9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT),
        path: '/secure/RapidBoard.jspa',
        query: [
            'rapidView',
            'view=reporting',
            'chart'
        ]
    };
    var $65Ltd;
    const $090be05d28e65948$export$d37f637b09fb9fda = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/:chartView'
    };
    var $65Ltd;
    const $710a0fc51c857594$export$79c2d9718e914f91 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
        path: '/jira/people/:accountId/boards/:boardId/backlog'
    };
    var $65Ltd;
    const $2f9ddde12b93dadf$export$7b85bca17717def6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_REPORT),
        path: '/jira/people/:accountId/boards/:boardId/reports/:chartView'
    };
    var $65Ltd;
    const $4565df2ae20b6eec$export$ced2612fe5124ff8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC_EMBED),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/embed',
        query: [
            'date?'
        ]
    };
    var $65Ltd;
    const $ad58dc33708a3879$export$f2c3b99639d54eb8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar',
        query: [
            'date?'
        ]
    };
    var $65Ltd;
    const $e5452599d7d96b18$var$jiraIssueFormCreateEndpoint = 'projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?';
    const $e5452599d7d96b18$export$16987cdd084cceba = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED),
        path: `/jira/software/c/${$e5452599d7d96b18$var$jiraIssueFormCreateEndpoint}/embed`,
        exact: true
    };
    var $65Ltd;
    const $a29107263e83fc90$var$jiraIssueFormCreateEndpoint = 'projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?';
    const $a29107263e83fc90$export$92f34907c6bf7007 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT),
        path: `/jira/software/c/${$a29107263e83fc90$var$jiraIssueFormCreateEndpoint}`,
        exact: true
    };
    var $65Ltd;
    const $7462b5ebecb54ef7$export$d92cd77785d00ff = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/code'
    };
    var $65Ltd;
    const $9ede72c8b3eb717b$export$f6cfee0232aa1e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/form/:formId/builder',
        exact: true
    };
    var $65Ltd;
    const $3b49c520878b4671$export$ae560ee5b676193d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/form',
        exact: true
    };
    var $65Ltd;
    const $dcbb2b95e9b9bd2e$export$91d6851bf27349 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/form/:formId',
        exact: true
    };
    var $65Ltd;
    const $7149a36cf3eab9d7$export$812703a022333f7c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC_EMBED),
        path: '/jira/software/c/projects/:projectKey/form/:formId/embed',
        exact: true
    };
    var $65Ltd;
    const $9ec0c22df6343cfe$export$d12f3924cf53b545 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/goals'
    };
    var $65Ltd;
    const $cb27ddbacbb22539$export$1bf758507ca6b2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/list'
    };
    var $65Ltd;
    const $6541879b6a0ea94d$export$de5fcecec40b3c98 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC_EMBED),
        path: '/jira/software/c/projects/:projectKey/list/embed'
    };
    var $65Ltd;
    const $06112c4b48f06dba$export$1e5e610e11119ea7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/reports/cycle-time'
    };
    var $65Ltd;
    const $8904c68da8a25316$export$312c410cb3b49afe = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/reports/deployment-frequency'
    };
    var $65Ltd;
    const $6e5bb4d1423afb31$export$79089e2853f04197 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/roadmap'
    };
    var $65Ltd;
    const $b668e7dcab7792ea$export$b5046fccf399983f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/summary'
    };
    var $65Ltd;
    const $9063b50694a4a155$export$ce5173f7e8fa932b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline'
    };
    var $5lsNZ;
    var $7MCPm;
    var $e4eHl = parcelRequire("e4eHl");
    var $65Ltd;
    var $co1wz;
    var $4R6GH;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $a586f286b7619cb0$export$3356a7870a2717f4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/incidents'
    };
    var $65Ltd;
    const $cf2d0aff779a466b$export$12e1ca6c7cfdfd49 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS),
        path: '/jira/software/projects/:projectKey/incidents'
    };
    var $9LHPC;
    var $5PD5h;
    const $58f54a3a0d651497$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "50f41ae3db36d1741d384023d13472ac68cccc88abdb8a72fb04d3f7c9bc8670",
            "metadata": {
                "connection": [
                    {
                        "count": "servicePageSize",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "linkedOperationsComponentsByProject"
                        ]
                    }
                ]
            },
            "name": "srcIncidentsPageInternalQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $58f54a3a0d651497$export$2e2bcd8739ae039 = $58f54a3a0d651497$var$node;
    var $eufEc;
    var $fEDBv;
    const $b9fe885d02827a63$var$AriGraphSortOrderInput = {
        ASC: 'ASC',
        DESC: 'DESC'
    };
    const $b9fe885d02827a63$var$QUERY_PARAM_SEARCH = 'search';
    const $b9fe885d02827a63$var$QUERY_PARAM_PRIORITY = 'priority';
    const $b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE = 'affected-service';
    const $b9fe885d02827a63$var$QUERY_PARAM_STATUS = 'status';
    const $b9fe885d02827a63$var$QUERY_PARAM_SORT_BY = 'sortBy';
    const $b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER = 'sortOrder';
    const $b9fe885d02827a63$var$STATUS_SORT_KEY = 'status';
    const $b9fe885d02827a63$var$CREATED_SORT_KEY = 'created';
    const $b9fe885d02827a63$var$PRIORITY_SORT_KEY = 'priority';
    const $b9fe885d02827a63$var$SUMMARY_SORT_KEY = 'key';
    const $b9fe885d02827a63$var$ASC_SORT_KEY = 'ASC';
    const $b9fe885d02827a63$var$DESC_SORT_KEY = 'DESC';
    function $b9fe885d02827a63$var$notEmpty(value) {
        return Boolean(value);
    }
    const $b9fe885d02827a63$var$isPriority = $b9fe885d02827a63$var$notEmpty;
    const $b9fe885d02827a63$var$isStatus = (val)=>val === 'resolved' || val === 'open';
    const $b9fe885d02827a63$var$isSortBy = (val)=>val === $b9fe885d02827a63$var$STATUS_SORT_KEY || val === $b9fe885d02827a63$var$CREATED_SORT_KEY || val === $b9fe885d02827a63$var$PRIORITY_SORT_KEY || val === $b9fe885d02827a63$var$SUMMARY_SORT_KEY;
    const $b9fe885d02827a63$var$isSortOrder = (val)=>val === $b9fe885d02827a63$var$ASC_SORT_KEY || val === $b9fe885d02827a63$var$DESC_SORT_KEY;
    const $b9fe885d02827a63$var$isAffectedService = $b9fe885d02827a63$var$notEmpty;
    function $b9fe885d02827a63$var$parseParameter(parameter, parameterValidationFn) {
        return parameter == null ? undefined : parameter.split(',').map((str)=>str.trim()).filter(parameterValidationFn);
    }
    const $b9fe885d02827a63$var$parseQueryParams = (paramsRaw)=>{
        const result = {
            [$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY]: paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] && $b9fe885d02827a63$var$isSortBy(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY]) ? paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] : $b9fe885d02827a63$var$CREATED_SORT_KEY,
            [$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER]: paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER] && $b9fe885d02827a63$var$isSortOrder(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER]) ? paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER] : $b9fe885d02827a63$var$DESC_SORT_KEY
        };
        result[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE], $b9fe885d02827a63$var$isAffectedService);
        result[$b9fe885d02827a63$var$QUERY_PARAM_STATUS] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_STATUS], $b9fe885d02827a63$var$isStatus);
        result[$b9fe885d02827a63$var$QUERY_PARAM_SEARCH] = paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SEARCH] ?? undefined;
        result[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY], $b9fe885d02827a63$var$isPriority);
        return result;
    };
    const $b9fe885d02827a63$var$getFilterValue = (values)=>({
            ...values.length > 0 ? {
                is: values
            } : {}
        });
    const $b9fe885d02827a63$var$parseStatusToFilterValues = (status)=>status.flatMap((stat)=>{
            switch(stat){
                case 'open':
                    return [
                        'NEW',
                        'INDETERMINATE'
                    ];
                case 'resolved':
                    return [
                        'DONE'
                    ];
                default:
                    return [
                        'UNDEFINED'
                    ];
            }
        });
    const $b9fe885d02827a63$var$getGqlFiltersFromQueryParams = (parsedQueryParams)=>({
            and: [
                {
                    to_status: $b9fe885d02827a63$var$getFilterValue($b9fe885d02827a63$var$parseStatusToFilterValues(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_STATUS] ?? [])),
                    to_priority: $b9fe885d02827a63$var$getFilterValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY] ?? []),
                    to_affectedServiceAris: $b9fe885d02827a63$var$getFilterValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE] ?? [])
                }
            ]
        });
    const $b9fe885d02827a63$var$parseSortDirection = (maybeDirection, defaultValue)=>{
        switch(maybeDirection?.toUpperCase()){
            case $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC.toUpperCase():
                return $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC;
            case $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC.toUpperCase():
                return $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC;
            default:
                return defaultValue;
        }
    };
    const $b9fe885d02827a63$var$getSortValue = (sortOrder)=>({
            priority: 2,
            direction: $b9fe885d02827a63$var$parseSortDirection(sortOrder, $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC)
        });
    const $b9fe885d02827a63$var$parseInverseSortDirection = (maybeDirection, defaultValue)=>{
        switch(maybeDirection?.toUpperCase()){
            case $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC.toUpperCase():
                return $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC;
            case $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC.toUpperCase():
                return $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC;
            default:
                return defaultValue;
        }
    };
    const $b9fe885d02827a63$var$getInverseSortValue = (sortOrder)=>({
            priority: 2,
            direction: $b9fe885d02827a63$var$parseInverseSortDirection(sortOrder, $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC)
        });
    const $b9fe885d02827a63$var$getGraphStoreSortFromQueryParams = (parsedQueryParams)=>({
            lastModified: {
                priority: 1,
                direction: $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC
            },
            ...$b9fe885d02827a63$var$STATUS_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
                to_status: $b9fe885d02827a63$var$getSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
            } : {},
            ...$b9fe885d02827a63$var$PRIORITY_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
                to_priority: $b9fe885d02827a63$var$getInverseSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
            } : {},
            ...$b9fe885d02827a63$var$CREATED_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
                createdAt: $b9fe885d02827a63$var$getSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
            } : {}
        });
    const $b9fe885d02827a63$export$a59477eea6e8cd7f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("f0J9E")).then((mod)=>mod.IncidentsPageWrapper), {
            moduleId: "5b8b4ff7"
        }),
        getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
                queries: {
                    incidentPageData: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: $58f54a3a0d651497$export$2e2bcd8739ae039,
                        variables: {
                            incidentPageSize: 30,
                            servicePageSize: 30,
                            cloudId: cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            filter: $b9fe885d02827a63$var$getGqlFiltersFromQueryParams($b9fe885d02827a63$var$parseQueryParams(context.query)),
                            sort: $b9fe885d02827a63$var$getGraphStoreSortFromQueryParams($b9fe885d02827a63$var$parseQueryParams(context.query)),
                            siteAri: `ari:cloud:jira::site/${cloudId}`
                        }
                    }
                }
            })
    });
    const $d2978738121ef6b5$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "associatedComponents"
                        ]
                    }
                ]
            },
            "name": "srcIncidentsLinkedServicesQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $d2978738121ef6b5$export$2e2bcd8739ae039 = $d2978738121ef6b5$var$node;
    var $eufEc;
    var $fEDBv;
    const $b93c8ec26a3d236d$export$a59477eea6e8cd7f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("10MlP")).then((mod)=>mod.IncidentsPageLinkedServicesWrapper), {
            moduleId: "d6132459"
        }),
        getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
                queries: {
                    incidentPageData: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $d2978738121ef6b5$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    }
                }
            })
    });
    var $e7bC3;
    const $9e60de4e7ff199f0$var$entryPointDeprecated = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $b93c8ec26a3d236d$export$a59477eea6e8cd7f),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $9e60de4e7ff199f0$var$entryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $b9fe885d02827a63$export$a59477eea6e8cd7f),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $9e60de4e7ff199f0$export$fd29243dbe4103 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cf2d0aff779a466b$export$12e1ca6c7cfdfd49), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            entryPoint () {
                return (0, (0, parcelRequire("co1wz")).ff)('corex-operandi-incidents-page-in-jira_5ebja') || (0, (0, parcelRequire("4R6GH")).fg)('corex_operandi_incidents_page_in_jira') ? $9e60de4e7ff199f0$var$entryPoint : $9e60de4e7ff199f0$var$entryPointDeprecated;
            },
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            skeleton: (0, (0, parcelRequire("9LHPC")).IncidentsPageSkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("7GnDe")).incidentsInitialPageChecksResource),
                (0, (0, parcelRequire("7GnDe")).incidentsCustomFieldIdResource)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS)),
                    teamName: 'operandi'
                }
            },
            ufoName: 'software-incidents'
        }));
    const $9e60de4e7ff199f0$export$c7d98bfe75274932 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a586f286b7619cb0$export$3356a7870a2717f4), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
            entryPoint () {
                return (0, (0, parcelRequire("co1wz")).ff)('corex-operandi-incidents-page-in-jira_5ebja') || (0, (0, parcelRequire("4R6GH")).fg)('corex_operandi_incidents_page_in_jira') ? $9e60de4e7ff199f0$var$entryPoint : $9e60de4e7ff199f0$var$entryPointDeprecated;
            },
            layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
            skeleton: (0, (0, parcelRequire("9LHPC")).IncidentsPageSkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("7GnDe")).incidentsInitialPageChecksResource),
                (0, (0, parcelRequire("7GnDe")).incidentsCustomFieldIdResource)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC)),
                    teamName: 'operandi'
                }
            },
            ufoName: 'software-incidents'
        }));
    var $aIZdc;
    var $ffza4;
    var $65Ltd;
    var $cSD7y;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $aPfsS;
    var $lfnsv;
    var $lJ1FP;
    var $f5kpo;
    var $3RJkv;
    var $ipmBb;
    var $dxCvy;
    var $7GnDe;
    var $2Ql51;
    var $f7Y15;
    var $gNStA;
    var $5lsNZ;
    var $fEr2a;
    var $lB6pS;
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $4R6GH;
    var $5j7Th;
    var $kxZPA;
    const $b34d0a459c6590c3$export$2164de18d39af313 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8N7Nn")), {
        moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
    });
    const $b34d0a459c6590c3$export$bcc6315cf211edab = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3ucvC")), {
        moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
    });
    const $b34d0a459c6590c3$export$a1c59527bd5131cc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("dpJFJ")).then((module)=>module.BoardConfigSwitcher), {
        moduleId: "./src/packages/router-routes/software/classic/board-settings/switcher/src/index.tsx"
    });
    const $b34d0a459c6590c3$export$4ceb6cf2934825b2 = (props)=>{
        const { route: route, query: query, match: match } = props;
        const basePageId = route && route.name || 'rapid-board';
        const chartParam = query.chart ? `-${query.chart}` : '';
        const boardId = query.rapidView ?? match.params.boardId;
        const pageId = `${basePageId}-${boardId}${chartParam}`;
        if ([
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD)
        ].includes(route.name) && !query.config) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b34d0a459c6590c3$export$2164de18d39af313,
            pageId: pageId,
            shouldShowSpinner: false
        });
        if ([
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED)
        ].includes(route.name) && !query.config) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b34d0a459c6590c3$export$bcc6315cf211edab,
            pageId: pageId,
            shouldShowSpinner: false
        });
        if ([
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED)
        ].includes(route.name) && query.config && (0, (0, parcelRequire("4R6GH")).fg)('simplified-boards-milestone-2_07hbk')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b34d0a459c6590c3$export$a1c59527bd5131cc,
            pageId: pageId,
            shouldShowSpinner: false
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b34d0a459c6590c3$export$9de09057ba255cc4,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
    const $b34d0a459c6590c3$export$9de09057ba255cc4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hpfxj")), {
        moduleId: "./src/packages/spa-apps/rapid-board/src/index.tsx"
    });
    const $b34d0a459c6590c3$export$bcb5bb6438a46dcb = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8kiyc")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/wrm-bundle/get-data/index.tsx"
    });
    const $b34d0a459c6590c3$export$d4640ceb9bdd4b4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("bnQeN")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/data-api/get-data/index.tsx"
    });
    const $b34d0a459c6590c3$export$c96c36c0cbfb2c16 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ifUKB")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/config-api/get-data/index.tsx"
    });
    const $b34d0a459c6590c3$export$2ad64ed8eb98d9e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4ajRG")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/rapidboard-resource/get-data/index.tsx"
    });
    const $b34d0a459c6590c3$export$4a8825f3e310b97 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("eFW1U")), {
        moduleId: "./src/packages/entry-rapid-board-wrm-apps/src/index.tsx"
    });
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $04b859bd88088960$exports = {};
    $04b859bd88088960$exports = new URL("classic-board-app-skeleton.tpl.bf1c26f5.svg", import.meta.url).toString();
    const $845fd4f51bb92262$var$customCssStyles = null;
    const $845fd4f51bb92262$export$631611c5fdf027d5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($04b859bd88088960$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1idpf"
            ])
        });
    var $5PD5h;
    const $e5e1c502f00851e8$var$classicBoardCapability = !false ? (0, $281cbd47ba46dd7d$export$664edf77d4c76110) : (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c);
    const $e5e1c502f00851e8$export$f2cd114cf8ab53aa = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lB6pS")).classicSoftwareBoardRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
            ufoName: 'classic-board',
            component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
            skeleton: (0, $845fd4f51bb92262$export$631611c5fdf027d5),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue',
                        'view=detail'
                    ]
                },
                {
                    query: [
                        'selectedIssue',
                        'modal=detail'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources), (0, (0, parcelRequire("f7Y15")).uifBoardResource)),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources)() && !(0, (0, parcelRequire("aIZdc")).isFedRamp)(), (0, (0, parcelRequire("ipmBb")).nextBestTaskFeatureResource)),
                (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)(),
                (0, (0, parcelRequire("5bkvv")).forgeBoardModuleResource)
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b34d0a459c6590c3$export$2164de18d39af313)
            ],
            preloadOptions: {
                earlyChunks: [
                    'rapidboard-early-entry'
                ]
            },
            meta: {
                capability: $e5e1c502f00851e8$var$classicBoardCapability
            },
            earlyAssets: (0, $f36666704bcc2bab$export$ad16a91905cefb0a)
        }));
    const $e5e1c502f00851e8$export$b5558b683e9c45a4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fEr2a")).classicSoftwareBoardEmbedRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
            ufoName: 'classic-board-embed',
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_board_smartlink_embed', (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)({
                isChromeless: true
            }),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources), (0, (0, parcelRequire("f7Y15")).uifBoardResource)),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources)() && !(0, (0, parcelRequire("aIZdc")).isFedRamp)(), (0, (0, parcelRequire("ipmBb")).nextBestTaskFeatureResource)),
                (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)(),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
                (0, (0, parcelRequire("5bkvv")).forgeBoardModuleResource)
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, $b34d0a459c6590c3$export$2164de18d39af313)
            ],
            meta: {
                capability: $e5e1c502f00851e8$var$classicBoardCapability
            }
        }));
    var $g87MG;
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $aPfsS;
    var $lfnsv;
    var $f5kpo;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $efa50580909009f0$export$9e1d275c8078512e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
        query: [
            'config=insightsConfig'
        ]
    };
    var $i8JTM;
    var $5PD5h;
    var $ibA3M;
    var $ieDtd;
    const $018a8accd0bb9a64$export$f7bc2c5799e41684 = ()=>{
        const { setSelectedConfigTab: setSelectedConfigTab } = (0, (0, parcelRequire("ibA3M")).useSelectedConfigTab)();
        const [, setConfigParam] = (0, (0, parcelRequire("ieDtd")).useQueryParam)('config');
        setSelectedConfigTab('filter');
        setConfigParam('filter');
        return null;
    };
    const $213bc38e0eb732c2$export$afb310a61bc1979c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $efa50580909009f0$export$9e1d275c8078512e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
            ufoName: 'rapidboard-backlog-insights',
            component: (0, $018a8accd0bb9a64$export$f7bc2c5799e41684),
            skeleton: (0, (0, parcelRequire("i8JTM")).NextGenBacklogSkeleton),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue',
                        'view=planning'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("g87MG")).issueHierarchyPageResource),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                (0, $b34d0a459c6590c3$export$4a8825f3e310b97),
                (0, $b34d0a459c6590c3$export$d4640ceb9bdd4b4),
                (0, $b34d0a459c6590c3$export$c96c36c0cbfb2c16),
                (0, $b34d0a459c6590c3$export$bcb5bb6438a46dcb),
                (0, $b34d0a459c6590c3$export$2ad64ed8eb98d9e)
            ],
            preloadOptions: {
                earlyChunks: [
                    'rapidboard-early-entry'
                ]
            },
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4)
            },
            earlyAssets: (0, $f36666704bcc2bab$export$ad16a91905cefb0a)
        }));
    var $g87MG;
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $aPfsS;
    var $lfnsv;
    var $f5kpo;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $7498cf3f30028baa$export$8163d70aae333a78 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId',
        query: [
            'config=insightsConfig'
        ]
    };
    var $5PD5h;
    const $4173ec798b4a3bc2$export$910bdb49ffbc1a01 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7498cf3f30028baa$export$8163d70aae333a78), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
            ufoName: 'rapidboard-board-insights',
            component: (0, $018a8accd0bb9a64$export$f7bc2c5799e41684),
            skeleton: (0, $845fd4f51bb92262$export$631611c5fdf027d5),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue',
                        'view=detail'
                    ]
                },
                {
                    query: [
                        'selectedIssue',
                        'modal=detail'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("g87MG")).issueHierarchyPageResource),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                (0, $b34d0a459c6590c3$export$4a8825f3e310b97),
                (0, $b34d0a459c6590c3$export$d4640ceb9bdd4b4),
                (0, $b34d0a459c6590c3$export$c96c36c0cbfb2c16),
                (0, $b34d0a459c6590c3$export$bcb5bb6438a46dcb),
                (0, $b34d0a459c6590c3$export$2ad64ed8eb98d9e)
            ],
            preloadOptions: {
                earlyChunks: [
                    'rapidboard-early-entry'
                ]
            },
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
            },
            earlyAssets: (0, $f36666704bcc2bab$export$ad16a91905cefb0a)
        }));
    const $f7a61037070d3efe$export$4bab4a9393eceb86 = [
        (0, $213bc38e0eb732c2$export$afb310a61bc1979c),
        (0, $4173ec798b4a3bc2$export$910bdb49ffbc1a01)
    ];
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $aPfsS;
    var $f5kpo;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $9ce629ec8a5c282a$export$8163d70aae333a78 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        path: '/secure/RapidBoard.jspa',
        query: [
            'rapidView'
        ],
        __unsafeOrder: -1
    };
    var $5PD5h;
    const $5e98dd01700151f4$export$4a5b9e48e40676ad = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9ce629ec8a5c282a$export$8163d70aae333a78), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
            ufoName: 'classic-board',
            component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
            skeleton: (0, $845fd4f51bb92262$export$631611c5fdf027d5),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue',
                        'view=detail'
                    ]
                },
                {
                    query: [
                        'selectedIssue',
                        'modal=detail'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)()
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                (0, $b34d0a459c6590c3$export$4a8825f3e310b97)
            ],
            preloadOptions: {
                earlyChunks: [
                    'rapidboard-early-entry'
                ]
            },
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
            },
            earlyAssets: (0, $f36666704bcc2bab$export$ad16a91905cefb0a)
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $b4koY;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $d186f38c5f1ffe01$export$485e4a7b82f29d70 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/deployments'
    };
    var $65Ltd;
    const $df8aa10fdcfe286c$export$3ba8dd9a7886e7d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
        path: '/jira/software/projects/:projectKey/deployments'
    };
    var $kfztd;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2cdb997b770c0bb4$export$ed6d152d5551715c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lChVn"))), {
        moduleId: "./src/packages/spa-apps/deployments/src/index.tsx"
    });
    const $2cdb997b770c0bb4$export$35822a21682c5ed8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2cdb997b770c0bb4$export$ed6d152d5551715c,
            pageId: "deploymentsNextGen",
            shouldShowSpinner: true
        });
    const $2cdb997b770c0bb4$export$7361c0feb3154afe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2cdb997b770c0bb4$export$ed6d152d5551715c,
            pageId: "deploymentsClassic",
            shouldShowSpinner: true
        });
    const $2cdb997b770c0bb4$export$7e5ccb20ad8e1612 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $df8aa10fdcfe286c$export$3ba8dd9a7886e7d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), $2cdb997b770c0bb4$export$35822a21682c5ed8),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("b4koY")).deploymentPreconditionRelayResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $2cdb997b770c0bb4$export$ed6d152d5551715c
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
    const $2cdb997b770c0bb4$export$dcf1f9ba660dedf6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d186f38c5f1ffe01$export$485e4a7b82f29d70), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("b4koY")).deploymentPreconditionRelayResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), $2cdb997b770c0bb4$export$7361c0feb3154afe),
            layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $2cdb997b770c0bb4$export$ed6d152d5551715c
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $6bbae009e0a4162e$export$2076234d7fde1717 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("2M4nF")), {
        moduleId: "./src/packages/spa-apps/software/form-builder/src/index.tsx"
    });
    const $6bbae009e0a4162e$export$a4c73b2a16981930 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6bbae009e0a4162e$export$2076234d7fde1717,
            pageId: "async-software-form-builder",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $7513c2d92a0c1be5$export$240a58749ebba091 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9bKt5")), {
        moduleId: "./src/packages/spa-apps/software/form/src/index.tsx"
    });
    const $7513c2d92a0c1be5$export$7234abc5d81adb58 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7513c2d92a0c1be5$export$240a58749ebba091,
            pageId: "async-software-form",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $de8f9eda1dab06b1$export$4d2f42d18d020964 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("2Whxf")), {
        moduleId: "./src/packages/spa-apps/software/form-submit-embed/src/index.tsx"
    });
    const $de8f9eda1dab06b1$export$3adb3f8f6b2673ae = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $de8f9eda1dab06b1$export$4d2f42d18d020964,
            pageId: "async-software-form-submit-embed",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $a96ac2d599fb8faa$export$258fcd204933dd75 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("53AYd")), {
        moduleId: "./src/packages/spa-apps/software/form-submit/src/index.tsx"
    });
    const $a96ac2d599fb8faa$export$4258f48cc65dca00 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a96ac2d599fb8faa$export$258fcd204933dd75,
            pageId: "async-software-form-submit",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $aIZdc;
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $ajKFd;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $6b68b587bba860e4$export$cb5cec74f302b3c6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/development'
    };
    var $65Ltd;
    const $7949b17dd1606ddf$export$7e7b18da5d3ceba0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE),
        path: '/jira/software/projects/:projectKey/development'
    };
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $9db212062a348ac3$export$9c25b4571a88e1f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gUniW"))), {
        moduleId: "./src/packages/spa-apps/periscope/src/index.tsx"
    });
    const $9db212062a348ac3$export$d86ed8d2756a4d4d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9db212062a348ac3$export$9c25b4571a88e1f,
            pageId: "softwarePeriscopeNextGen",
            shouldShowSpinner: true
        });
    const $9db212062a348ac3$export$fd5920cadc24919d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9db212062a348ac3$export$9c25b4571a88e1f,
            pageId: "softwarePeriscopeClassic",
            shouldShowSpinner: true
        });
    const $9db212062a348ac3$export$7db4d910357a4d89 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7949b17dd1606ddf$export$7e7b18da5d3ceba0), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("aIZdc")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), $9db212062a348ac3$export$d86ed8d2756a4d4d),
            skeleton: (0, (0, parcelRequire("ajKFd")).Skeleton),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9db212062a348ac3$export$9c25b4571a88e1f
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE)),
                    teamName: 'nova'
                }
            }
        }));
    const $9db212062a348ac3$export$d7d49c1a51b3c0a9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6b68b587bba860e4$export$cb5cec74f302b3c6), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
            skeleton: (0, (0, parcelRequire("ajKFd")).Skeleton),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("aIZdc")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), $9db212062a348ac3$export$fd5920cadc24919d),
            layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9db212062a348ac3$export$9c25b4571a88e1f
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC)),
                    teamName: 'nova'
                }
            }
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $bwLf9;
    var $4R6GH;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $en8e6;
    var $5lsNZ;
    var $65Ltd;
    const $c527ab87b834a4bd$export$b7285748f1151353 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/security'
    };
    var $65Ltd;
    const $5fd989928cf1462c$export$3a4d4ecb82e1bfc8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY),
        path: '/jira/software/projects/:projectKey/security'
    };
    var $kfztd;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $1bbbe61aca30e3ab$var$isSecurityPageEnabled = ()=>!(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, (0, parcelRequire("4R6GH")).fg)('isotopes-security-page-in-jira-enabled-v2');
    const $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lIOEX"))), {
        moduleId: "./src/packages/spa-apps/security/src/index.tsx"
    });
    const $1bbbe61aca30e3ab$export$c6cc344ea309349a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3,
            pageId: "securityNextGen",
            shouldShowSpinner: true
        });
    const $1bbbe61aca30e3ab$export$b4dc9ba40afbdd9f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3,
            pageId: "securityClassic",
            shouldShowSpinner: true
        });
    const $1bbbe61aca30e3ab$export$a8dcfae475505e7a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5fd989928cf1462c$export$3a4d4ecb82e1bfc8), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, (0, parcelRequire("bwLf9")).default)($1bbbe61aca30e3ab$var$isSecurityPageEnabled, $1bbbe61aca30e3ab$export$c6cc344ea309349a, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            ufoName: 'software-security-combined',
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("en8e6")).securityPageResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY)),
                    teamName: 'fusion-isotopes'
                }
            }
        }));
    const $1bbbe61aca30e3ab$export$8acfebad16c9d6f2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c527ab87b834a4bd$export$b7285748f1151353), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("en8e6")).securityPageResource)
            ],
            ufoName: 'software-security-combined',
            component: (0, (0, parcelRequire("bwLf9")).default)($1bbbe61aca30e3ab$var$isSecurityPageEnabled, $1bbbe61aca30e3ab$export$b4dc9ba40afbdd9f, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC)),
                    teamName: 'fusion-isotopes'
                }
            }
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $d82700466a756427$export$68c09444cc6f2843 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("6TXTk")), {
        moduleId: "./src/packages/spa-apps/software/summary/src/index.tsx"
    });
    const $d82700466a756427$export$893608e1a22999b9 = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d82700466a756427$export$68c09444cc6f2843,
            pageId: "software-summary",
            shouldShowSpinner: true
        });
    };
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $aPfsS;
    var $lfnsv;
    var $lJ1FP;
    var $f5kpo;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $f7Y15;
    var $gNStA;
    var $lyCs2;
    var $5PD5h;
    const $fd1485349b2df65b$export$cde4dacc737dc0f1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lyCs2")).userBoardRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
            component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
            skeleton: (0, $845fd4f51bb92262$export$631611c5fdf027d5),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue',
                        'view=detail'
                    ]
                },
                {
                    query: [
                        'selectedIssue',
                        'modal=detail'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources), (0, (0, parcelRequire("f7Y15")).uifBoardResource)),
                (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                (0, $b34d0a459c6590c3$export$4a8825f3e310b97),
                (0, $b34d0a459c6590c3$export$d4640ceb9bdd4b4),
                (0, $b34d0a459c6590c3$export$c96c36c0cbfb2c16),
                (0, $b34d0a459c6590c3$export$bcb5bb6438a46dcb),
                (0, $b34d0a459c6590c3$export$2ad64ed8eb98d9e)
            ],
            preloadOptions: {
                earlyChunks: [
                    'rapidboard-early-entry'
                ]
            },
            earlyAssets: (0, $f36666704bcc2bab$export$ad16a91905cefb0a)
        }));
    var $7OYJs;
    var $kZOse;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $0d44d4fc842a7298$exports = {};
    $0d44d4fc842a7298$exports = new URL("classic-report-app-skeleton.tpl.1daae66d.svg", import.meta.url).toString();
    const $61f1e37e5e1946ad$export$d7667341f4db3b8d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($0d44d4fc842a7298$exports)))
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $1d2d2f220593896f$exports = {};
    $1d2d2f220593896f$exports = new URL("list-app-skeleton.tpl.82508714.svg", import.meta.url).toString();
    var $c492ef1f477ffd28$exports = {};
    $c492ef1f477ffd28$exports = new URL("list-embed-app-skeleton.tpl.de94c811.svg", import.meta.url).toString();
    const $6a76608e47ef62ca$export$cbc3335f7a517046 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($1d2d2f220593896f$exports)))
        });
    const $6a76608e47ef62ca$export$2638f1c98fe91c13 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($c492ef1f477ffd28$exports)))
        });
    var $i8JTM;
    var $8STJR;
    var $kfztd;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    var $doZTA;
    const $02623e8fca40b314$export$c70b8d9ef0c891b2 = ()=>{
        const [{ query: query, match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const queryParams = new URLSearchParams(query).toString();
        const { projectKey: projectKey, boardId: boardId } = match.params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: {
                pathname: `/jira/software/c/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
                hash: '',
                search: queryParams
            }
        });
    };
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $c75fcd785e66868e$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $c75fcd785e66868e$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $4a23aaa7a1201d94$export$cabb458181f7566e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6Aupt"))), {
        moduleId: "./src/packages/spa-apps/goals/src/index.tsx"
    });
    var $4a23aaa7a1201d94$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4a23aaa7a1201d94$export$cabb458181f7566e,
            pageId: `classic-atlas-goals-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $a96f990777917c84$export$22681210aaeb910f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5LZ4w")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
    });
    var $a96f990777917c84$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a96f990777917c84$export$22681210aaeb910f,
            pageId: "proforma-issue-forms-direct-embed",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $480a54898b863a19$export$a0f04dd35569e11 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("1NWtC")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct/src/index.tsx"
    });
    var $480a54898b863a19$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $480a54898b863a19$export$a0f04dd35569e11,
            pageId: "proforma-issue-forms-direct",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $636a0aa010a33fb5$export$84165bb08bf42eef = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bTGYj"))), {
        moduleId: "./src/packages/spa-apps/roadmap/src/view/classic/index.tsx"
    });
    var $636a0aa010a33fb5$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { boardId: boardId } = match.params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $636a0aa010a33fb5$export$84165bb08bf42eef,
            pageId: `classic-roadmap-${boardId || ''}`,
            shouldShowSpinner: false
        });
    };
    var $lmyls;
    var $4R6GH;
    var $eufEc;
    var $fEDBv;
    const $d8251bf369abb7ad$var$SETTINGS_STORAGE_KEY = 'calendar:settings:software';
    function $d8251bf369abb7ad$var$getViewSettings(key) {
        try {
            const serializedValue = globalThis.localStorage?.getItem(key);
            return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
        } catch  {
            return undefined;
        }
    }
    function $d8251bf369abb7ad$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
        return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
    }
    function $d8251bf369abb7ad$var$toMidnightUTCString(date) {
        const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        return new Date(utcMilliseconds).toISOString();
    }
    function $d8251bf369abb7ad$var$toDate(date) {
        if (!date) return new Date();
        try {
            const _date = new Date(date);
            return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
        } catch (e) {
            return new Date();
        }
    }
    const $d8251bf369abb7ad$var$SOFTWARE_CALENDAR = 'software-calendar';
    const $d8251bf369abb7ad$var$SOFTWARE_CALENDAR_EMBED = 'software-calendar-embed';
    const $d8251bf369abb7ad$var$TEAM_MANAGED_CALENDAR_ROUTES = [
        $d8251bf369abb7ad$var$SOFTWARE_CALENDAR,
        $d8251bf369abb7ad$var$SOFTWARE_CALENDAR_EMBED
    ];
    function $d8251bf369abb7ad$var$createScope({ context: context, tenantContext: tenantContext }) {
        const { cloudId: cloudId } = tenantContext;
        const isTMP = $d8251bf369abb7ad$var$TEAM_MANAGED_CALENDAR_ROUTES.includes(context.route.name);
        return {
            type: 'board',
            boardId: $d8251bf369abb7ad$var$toBoardAri({
                siteId: cloudId,
                boardId: String(context.match.params.boardId)
            }),
            projectKeys: isTMP ? [
                String(context.match.params.projectKey)
            ] : []
        };
    }
    function $d8251bf369abb7ad$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
        const { cloudId: cloudId } = tenantContext;
        const scopeInput = {
            ids: [
                scope.boardId
            ]
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination') || scope.projectKeys && scope.projectKeys.length > 0) return {
            ...scopeInput,
            projectKeys: {
                cloudId: cloudId,
                keys: scope.projectKeys
            }
        };
        return scopeInput;
    }
    function $d8251bf369abb7ad$var$toViewMode(mode) {
        switch(mode){
            case 'week':
                return 'WEEK';
            case 'day':
                return 'DAY';
            default:
                return 'MONTH';
        }
    }
    function $d8251bf369abb7ad$var$toWeekStart(weekStart) {
        switch(weekStart){
            case 'monday':
                return 'MONDAY';
            case 'saturday':
                return 'SATURDAY';
            default:
                return 'SUNDAY';
        }
    }
    function $d8251bf369abb7ad$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
        return {
            date: $d8251bf369abb7ad$var$toMidnightUTCString(selectedDate),
            mode: $d8251bf369abb7ad$var$toViewMode(viewRange),
            weekStart: $d8251bf369abb7ad$var$toWeekStart(weekStartsOn),
            startDateField: startDateField,
            endDateField: endDateField,
            viewId: null
        };
    }
    function $d8251bf369abb7ad$var$buildIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $d8251bf369abb7ad$var$buildUnscheduledIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $d8251bf369abb7ad$var$buildVersionsSearchInput() {
        return {
            versionStatuses: [
                'RELEASED',
                'UNRELEASED'
            ]
        };
    }
    function $d8251bf369abb7ad$var$buildSprintsSearchInput() {
        return {
            sprintStates: [
                'ACTIVE',
                'FUTURE',
                'CLOSED'
            ]
        };
    }
    const $d8251bf369abb7ad$export$19cf4b398f638dc6 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("eqReh")), {
            moduleId: "57ee20a5"
        }),
        getPreloadProps: (entryPointRouteParams)=>{
            const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
            const { cloudId: cloudId } = tenantContext;
            const scope = $d8251bf369abb7ad$var$createScope(entryPointRouteParams);
            const { date: date } = context.query;
            const selectedDate = $d8251bf369abb7ad$var$toDate(date);
            const boardId = String(context.match.params.boardId);
            const settings = (0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination') ? $d8251bf369abb7ad$var$getViewSettings($d8251bf369abb7ad$var$SETTINGS_STORAGE_KEY) : undefined;
            const viewRange = 'month';
            const weekStartsOn = (0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination') ? settings?.weekStartsOn ?? 'sunday' : 'sunday';
            const startDateField = 'startdate';
            const endDateField = 'duedate';
            const issueEventFields = {
                startDateField: startDateField,
                endDateField: endDateField
            };
            return {
                queries: {
                    calendarData: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $122674b135b0c50b$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            scopeInput: $d8251bf369abb7ad$var$buildScopeInput(entryPointRouteParams, scope),
                            configurationInput: $d8251bf369abb7ad$var$buildConfigurationInput({
                                selectedDate: selectedDate,
                                viewRange: viewRange,
                                weekStartsOn: weekStartsOn,
                                startDateField: startDateField,
                                endDateField: endDateField
                            }),
                            issuesPageSize: 50,
                            issuesSearchInput: $d8251bf369abb7ad$var$buildIssuesSearchInput(),
                            unscheduledIssuesSearchInput: $d8251bf369abb7ad$var$buildUnscheduledIssuesSearchInput(),
                            versionsSearchInput: $d8251bf369abb7ad$var$buildVersionsSearchInput(),
                            sprintsSearchInput: $d8251bf369abb7ad$var$buildSprintsSearchInput(),
                            skipSprintSearch: false,
                            viewId: null,
                            schedulePermissionsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('calendar_schedule_issue_permissions_check'),
                            pageLoadMoreEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination'),
                            skipVersionsV1Search: (0, (0, parcelRequire("4R6GH")).fg)('plan-calendar-versions-v2-adoption'),
                            skipVersionsV2Search: !(0, (0, parcelRequire("4R6GH")).fg)('plan-calendar-versions-v2-adoption')
                        }
                    }
                },
                entryPoints: {},
                extraProps: {
                    scope: scope,
                    selectedDate: selectedDate,
                    viewRange: viewRange,
                    weekStartsOn: weekStartsOn,
                    issueEventFields: issueEventFields,
                    boardId: boardId
                }
            };
        }
    });
    const $24d3258934ab0fe5$export$83b1b9036cc7961a = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $d8251bf369abb7ad$export$19cf4b398f638dc6),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $ebyGx = parcelRequire("ebyGx");
    const $12fea879e07c880e$export$557c2f222778cea6 = ({ location: location, match: match })=>{
        if (match && match.params.boardId) return match.params.boardId;
        const { rapidView: rapidView } = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        return rapidView;
    };
    const $6049b4a08957accb$export$4beafd9dbad29bff = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kt9Vo"))), {
        moduleId: "./src/packages/spa-apps/code/src/index.tsx"
    });
    const $6049b4a08957accb$export$faa081cb222383ac = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("eSbew")), {
        moduleId: "./src/packages/spa-apps/business/jsw-list/src/index.tsx"
    });
    const $6049b4a08957accb$export$ce40123d7c2e29e7 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("bmORQ")), {
        moduleId: "./src/packages/spa-apps/business/jsw-list-embed/src/index.tsx"
    });
    const $6049b4a08957accb$export$d9e8184332f86b53 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6049b4a08957accb$export$4beafd9dbad29bff,
            pageId: `next-gen-code-${(0, $12fea879e07c880e$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $6049b4a08957accb$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6049b4a08957accb$export$4beafd9dbad29bff,
            pageId: `classic-code-${(0, $12fea879e07c880e$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $6049b4a08957accb$export$422a3a028ae77ad3 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6049b4a08957accb$export$faa081cb222383ac,
            pageId: `software-${(0, $12fea879e07c880e$export$557c2f222778cea6)({
                location: location,
                match: match
            })}-list`,
            shouldShowSpinner: true
        });
    const $6049b4a08957accb$export$4a0539d19a2e2694 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6049b4a08957accb$export$ce40123d7c2e29e7,
            pageId: `software-${(0, $12fea879e07c880e$export$557c2f222778cea6)({
                location: location,
                match: match
            })}-list-embed`,
            shouldShowSpinner: true
        });
    var $lmyls;
    var $eufEc;
    var $fEDBv;
    const $093e9fa498e2d713$var$FORMAT_RULES_FIRST = 20;
    const $093e9fa498e2d713$export$6be4f10150ff6073 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("eSbew")), {
            moduleId: "a7ba8596"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = context.match.params;
            if (!projectKey) throw new Error('projectKey is required');
            return {
                queries: {
                    formattingRulesQuery: {
                        parameters: $6fc143a99d34d8f4$export$2e2bcd8739ae039,
                        variables: {
                            projectKey: projectKey,
                            cloudId: tenantContext.cloudId,
                            first: $093e9fa498e2d713$var$FORMAT_RULES_FIRST
                        },
                        options: {
                            fetchPolicy: 'network-only'
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            };
        }
    });
    const $2190319388c8e440$export$f30a66efa682bf2d = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $093e9fa498e2d713$export$6be4f10150ff6073),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $f19a24813079175a$export$956f830ed027f1fb = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("dyzSB")), {
        moduleId: "./src/packages/spa-apps/cycle-time-report/src/index.tsx"
    });
    const $f19a24813079175a$export$e16ce0656a74a015 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f19a24813079175a$export$956f830ed027f1fb,
            pageId: "cycleTimeReportNextGen",
            shouldShowSpinner: true
        });
    const $f19a24813079175a$export$237924ba64065cc3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f19a24813079175a$export$956f830ed027f1fb,
            pageId: "cycleTimeReportClassic",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $edf6d9a26482ed8b$export$5113b2b19ec1fb53 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("pXexG")), {
        moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
    });
    const $edf6d9a26482ed8b$export$e2db9c7426cdb53 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $edf6d9a26482ed8b$export$5113b2b19ec1fb53,
            pageId: "deploymentFrequencyReportNextGen",
            shouldShowSpinner: true
        });
    const $edf6d9a26482ed8b$export$655707e8ae1053d3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $edf6d9a26482ed8b$export$5113b2b19ec1fb53,
            pageId: "deploymentFrequencyReportClassic",
            shouldShowSpinner: true
        });
    const $d1067266a88b60d4$export$edb4b8cf67d7d767 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3ucvC"))), {
        moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
    });
    const $d1067266a88b60d4$var$ProjectsDirectoryRedirect = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/projects"
        });
    const $d1067266a88b60d4$var$classicBacklogCapability = !false ? (0, $281cbd47ba46dd7d$export$571692eec8a399e1) : (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4);
    const $d1067266a88b60d4$export$5b4e616b6b4b672a = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6e5bb4d1423afb31$export$79089e2853f04197), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, $02623e8fca40b314$export$c70b8d9ef0c891b2),
                skeleton: (0, (0, parcelRequire("8STJR")).RoadmapSkeleton),
                layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("hJAri")).classicRoadmapResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'software-roadmap-early-entry'
                    ]
                },
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $636a0aa010a33fb5$export$84165bb08bf42eef)
                ],
                ufoName: 'classic-roadmap'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9063b50694a4a155$export$ce5173f7e8fa932b), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, $636a0aa010a33fb5$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("8STJR")).RoadmapSkeleton),
                layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("hJAri")).classicRoadmapResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'software-roadmap-early-entry'
                    ]
                },
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $636a0aa010a33fb5$export$84165bb08bf42eef)
                ],
                ufoName: 'classic-roadmap'
            })),
        ...(0, $f7a61037070d3efe$export$4bab4a9393eceb86),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("evtTp")).rapidboardBacklogEmbedRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                ufoName: 'classic-backlog-embed',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('enable_backlog_smartlink_route', (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                resources: [
                    ...(0, (0, parcelRequire("f5kpo")).getUIFBacklogDataResource)(),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                    (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                    (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)(),
                    (0, (0, parcelRequire("5bkvv")).forgeBacklogModuleResource),
                    (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
                ],
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    $d1067266a88b60d4$export$edb4b8cf67d7d767
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    capability: $d1067266a88b60d4$var$classicBacklogCapability
                },
                earlyAssets: (0, $f36666704bcc2bab$export$ad16a91905cefb0a)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $11672806ba958f46$export$9e1d275c8078512e), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                ufoName: 'classic-backlog',
                component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
                skeleton: (0, (0, parcelRequire("i8JTM")).NextGenBacklogSkeleton),
                layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue',
                            'view=planning'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getUIFBacklogDataResource)(),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                    (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                    (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)(),
                    (0, (0, parcelRequire("5bkvv")).forgeBacklogModuleResource)
                ],
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $d1067266a88b60d4$export$edb4b8cf67d7d767
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    capability: $d1067266a88b60d4$var$classicBacklogCapability
                },
                earlyAssets: (0, $f36666704bcc2bab$export$ad16a91905cefb0a)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $4565df2ae20b6eec$export$ced2612fe5124ff8), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                skeleton: (0, (0, parcelRequire("kZOse")).CalendarEmbedSkeleton),
                component: (0, (0, parcelRequire("kZOse")).CalendarEmbedSkeleton),
                entryPoint () {
                    if (false) return undefined;
                    return 0, $24d3258934ab0fe5$export$83b1b9036cc7961a;
                },
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                resources: [
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
                ],
                ufoName: 'classic-calendar-embed'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ad58dc33708a3879$export$f2c3b99639d54eb8), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                skeleton: (0, (0, parcelRequire("kZOse")).CalendarSkeleton),
                component: (0, (0, parcelRequire("kZOse")).CalendarSkeleton),
                entryPoint () {
                    if (false) return undefined;
                    return 0, $24d3258934ab0fe5$export$83b1b9036cc7961a;
                },
                layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ],
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ],
                ufoName: 'classic-calendar'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6541879b6a0ea94d$export$de5fcecec40b3c98), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $6049b4a08957accb$export$4a0539d19a2e2694), (0, (0, parcelRequire("5lsNZ")).default)),
                skeleton: (0, $6a76608e47ef62ca$export$2638f1c98fe91c13),
                entryPoint () {
                    return (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, $2190319388c8e440$export$f30a66efa682bf2d) : undefined;
                },
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                resources: [
                    (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource),
                    (0, (0, parcelRequire("iNzEe")).navigationResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource),
                    (0, (0, parcelRequire("9yEpR")).storageDetailsResource),
                    (0, (0, parcelRequire("1E3vT")).navigationItemsResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("dAmbh")).configurationResource),
                    (0, (0, parcelRequire("g4ZHz")).fieldsResource)
                ],
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, $6049b4a08957accb$export$ce40123d7c2e29e7)
                ],
                ufoName: 'classic-list-embed'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cb27ddbacbb22539$export$1bf758507ca6b2), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $6049b4a08957accb$export$422a3a028ae77ad3), (0, (0, parcelRequire("5lsNZ")).default)),
                skeleton: (0, $6a76608e47ef62ca$export$cbc3335f7a517046),
                entryPoint () {
                    return (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, $2190319388c8e440$export$f30a66efa682bf2d) : undefined;
                },
                layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource),
                    (0, (0, parcelRequire("iNzEe")).navigationResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource),
                    (0, (0, parcelRequire("9yEpR")).storageDetailsResource),
                    (0, (0, parcelRequire("1E3vT")).navigationItemsResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("dAmbh")).configurationResource),
                    (0, (0, parcelRequire("g4ZHz")).fieldsResource)
                ],
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6049b4a08957accb$export$faa081cb222383ac)
                ],
                ufoName: 'classic-list'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $090be05d28e65948$export$d37f637b09fb9fda), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
                skeleton: (0, $61f1e37e5e1946ad$export$d7667341f4db3b8d),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    ...(0, $c75fcd785e66868e$export$8cb713295e6b7204)()
                ],
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                    (0, $b34d0a459c6590c3$export$4a8825f3e310b97)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                earlyAssets: (0, $f36666704bcc2bab$export$ad16a91905cefb0a),
                ufoName: 'classic-report'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $06112c4b48f06dba$export$1e5e610e11119ea7), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $f19a24813079175a$export$237924ba64065cc3)),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $c75fcd785e66868e$export$8cb713295e6b7204)(),
                    (0, (0, parcelRequire("2GkDw")).devOpsProviderResource)
                ],
                afterPaint: [
                    (0, $f19a24813079175a$export$956f830ed027f1fb)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f19a24813079175a$export$956f830ed027f1fb)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC)),
                        teamName: 'fusion-solaris'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9ede72c8b3eb717b$export$f6cfee0232aa1e), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                ufoName: 'classic-form-builder',
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, $6bbae009e0a4162e$export$a4c73b2a16981930), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav), ()=>null)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6bbae009e0a4162e$export$2076234d7fde1717)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $dcbb2b95e9b9bd2e$export$91d6851bf27349), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                ufoName: 'classic-form-submit',
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, $a96ac2d599fb8faa$export$4258f48cc65dca00), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $a96ac2d599fb8faa$export$258fcd204933dd75)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7149a36cf3eab9d7$export$812703a022333f7c), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                ufoName: 'classic-form-submit-embed',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_forms_embed', (0, $de8f9eda1dab06b1$export$3adb3f8f6b2673ae), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                resources: [
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
                ],
                forPaint: [
                    (0, $de8f9eda1dab06b1$export$4d2f42d18d020964)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3b49c520878b4671$export$ae560ee5b676193d), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                ufoName: 'classic-form',
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, $7513c2d92a0c1be5$export$7234abc5d81adb58), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav), ()=>null)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $7513c2d92a0c1be5$export$240a58749ebba091)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9ec0c22df6343cfe$export$d12f3924cf53b545), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, $4a23aaa7a1201d94$export$2e2bcd8739ae039),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b668e7dcab7792ea$export$b5046fccf399983f), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                ufoName: 'classic-summary',
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('helios_summary_page_experiment', 'isEnabled', false), (0, $d82700466a756427$export$893608e1a22999b9), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $d82700466a756427$export$68c09444cc6f2843)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a29107263e83fc90$export$92f34907c6bf7007), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, $480a54898b863a19$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $480a54898b863a19$export$a0f04dd35569e11)
                ],
                perfMetricKey: 'issue-forms-direct'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e5452599d7d96b18$export$16987cdd084cceba), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, $a96f990777917c84$export$2e2bcd8739ae039),
                layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, $a96f990777917c84$export$22681210aaeb910f)
                ],
                perfMetricKey: 'issue-forms-direct-embed'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8904c68da8a25316$export$312c410cb3b49afe), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $edf6d9a26482ed8b$export$655707e8ae1053d3)),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $c75fcd785e66868e$export$8cb713295e6b7204)(),
                    (0, (0, parcelRequire("2GkDw")).devOpsProviderResource)
                ],
                afterPaint: [
                    (0, $edf6d9a26482ed8b$export$5113b2b19ec1fb53)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $edf6d9a26482ed8b$export$5113b2b19ec1fb53)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC)),
                        teamName: 'fusion-solaris'
                    }
                }
            })),
        (0, $e5e1c502f00851e8$export$b5558b683e9c45a4),
        (0, $e5e1c502f00851e8$export$f2cd114cf8ab53aa),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $710a0fc51c857594$export$79c2d9718e914f91), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
                skeleton: (0, (0, parcelRequire("i8JTM")).NextGenBacklogSkeleton),
                layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getUIFBacklogDataResource)(),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                    ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)(),
                    (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                    (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
                ],
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $d1067266a88b60d4$export$edb4b8cf67d7d767
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    capability: $d1067266a88b60d4$var$classicBacklogCapability
                },
                earlyAssets: (0, $f36666704bcc2bab$export$ad16a91905cefb0a)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2f9ddde12b93dadf$export$7b85bca17717def6), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
                skeleton: (0, $61f1e37e5e1946ad$export$d7667341f4db3b8d),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    ...(0, $c75fcd785e66868e$export$8cb713295e6b7204)(),
                    ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)()
                ],
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                    (0, $b34d0a459c6590c3$export$4a8825f3e310b97)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                earlyAssets: (0, $f36666704bcc2bab$export$ad16a91905cefb0a)
            })),
        (0, $fd1485349b2df65b$export$cde4dacc737dc0f1),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $af1c8b7df470b6b1$export$ff874528b0b33a61), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                ufoName: 'classic-backlog',
                component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
                skeleton: (0, (0, parcelRequire("i8JTM")).NextGenBacklogSkeleton),
                layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                    {
                        query: [
                            'selectedIssue',
                            'view=planning'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                    ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)()
                ],
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                    (0, $b34d0a459c6590c3$export$4a8825f3e310b97)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    capability: (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4)
                },
                earlyAssets: (0, $f36666704bcc2bab$export$ad16a91905cefb0a)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0732a35485277820$export$d27f9ad2fc277ff9), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, $b34d0a459c6590c3$export$4ceb6cf2934825b2),
                skeleton: (0, $61f1e37e5e1946ad$export$d7667341f4db3b8d),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    ...(0, $c75fcd785e66868e$export$8cb713295e6b7204)(),
                    ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)()
                ],
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b34d0a459c6590c3$export$9de09057ba255cc4),
                    (0, $b34d0a459c6590c3$export$4a8825f3e310b97)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                earlyAssets: (0, $f36666704bcc2bab$export$ad16a91905cefb0a),
                ufoName: 'classic-report'
            })),
        (0, $5e98dd01700151f4$export$4a5b9e48e40676ad),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7462b5ebecb54ef7$export$d92cd77785d00ff), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("iZ82x")).codePageResource)
                ],
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $6049b4a08957accb$export$95e2389b7ca7ccf2)),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6049b4a08957accb$export$4beafd9dbad29bff)
                ]
            })),
        (0, $1bbbe61aca30e3ab$export$8acfebad16c9d6f2),
        (0, $2cdb997b770c0bb4$export$dcf1f9ba660dedf6),
        (0, $9db212062a348ac3$export$d7d49c1a51b3c0a9),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $848732acccd8706d$export$991b1be164057e91), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                isRedirect: true,
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0939314fcba99a8c$export$3913c8bee519225c), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
                component: $d1067266a88b60d4$var$ProjectsDirectoryRedirect,
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                isRedirect: true,
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, $9e60de4e7ff199f0$export$c7d98bfe75274932)
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bTLzO;
    var $3RJkv;
    var $65Ltd;
    const $b5f6af89eb99da17$export$48d633ce1d0d2a0e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_COMPASS_PRODUCT_SETTINGS),
        path: '/jira/settings/products/compass',
        exact: true
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $8b91974ef292d61a$var$LazyCompassProductSettingsPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6Bdj6"))), {
        moduleId: "./src/packages/spa-apps/compass-product-settings/src/index.tsx"
    });
    const $8b91974ef292d61a$export$cf9d12ec1710006a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8b91974ef292d61a$var$LazyCompassProductSettingsPage,
            pageId: "async-compass-product-settings",
            shouldShowSpinner: true
        });
    const $8b91974ef292d61a$export$703b5090da478c9c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b5f6af89eb99da17$export$48d633ce1d0d2a0e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: $8b91974ef292d61a$export$cf9d12ec1710006a,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("bTLzO")).compassProductSettingsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $8b91974ef292d61a$var$LazyCompassProductSettingsPage
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $0d0dc21731e4a98a$export$7b2b015fe316fc5d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONFLUENCE_PRODUCT_SETTINGS),
        path: '/jira/settings/products/confluence',
        exact: true
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5c10d3561f01a6f7$var$LazyConfluenceProductSettingsPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bri2h"))), {
        moduleId: "./src/packages/spa-apps/confluence-product-settings/src/index.tsx"
    });
    const $5c10d3561f01a6f7$export$a094475e0d3636f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5c10d3561f01a6f7$var$LazyConfluenceProductSettingsPage,
            pageId: "async-confluence-product-settings",
            shouldShowSpinner: true
        });
    const $5c10d3561f01a6f7$export$415552b116808717 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0d0dc21731e4a98a$export$7b2b015fe316fc5d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: $5c10d3561f01a6f7$export$a094475e0d3636f,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $5c10d3561f01a6f7$var$LazyConfluenceProductSettingsPage
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $hBv66;
    var $2G9Bk;
    var $aPfsS;
    const $0bf6b9f3f002a423$export$2fdb05fdbf78d595 = [
        'mobile?!=true',
        'includeWebResources?!=true',
        'classifier?!=json',
        'project.key?',
        'project.id?'
    ];
    var $65Ltd;
    const $178b17cd972d15af$export$486ffffd0a2797a5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_INVALID),
        path: '/plugins/servlet/ac/:addonKey//:moduleKey',
        query: (0, $0bf6b9f3f002a423$export$2fdb05fdbf78d595)
    };
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $hz6Yb;
    var $9UABi;
    var $bHhiy;
    var $atU1t;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    const $7a1fe7edd9b898b4$export$2c86c2f79b80cf77 = ()=>[
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
            ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            (0, (0, parcelRequire("hz6Yb")).connectGeneralResources),
            (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
        ];
    const $7a1fe7edd9b898b4$export$4c06110e7d14ab3c = ()=>[
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            (0, (0, parcelRequire("9UABi")).connectProjectResources)
        ];
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $49a774cbbfe614f4$export$c33275abe6c1e577 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("iGYap"))), {
        moduleId: "./src/packages/spa-apps/jira-connect/general-pages/src/index.tsx"
    });
    var $49a774cbbfe614f4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $49a774cbbfe614f4$export$c33275abe6c1e577,
            pageId: "connect",
            shouldShowSpinner: true
        });
    const $eea4a938c8d518ff$export$d8088cb4e7cc7efd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $178b17cd972d15af$export$486ffffd0a2797a5), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)(),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericConnectSidebars)
            },
            component: (0, $49a774cbbfe614f4$export$2e2bcd8739ae039),
            resources: (0, $7a1fe7edd9b898b4$export$2c86c2f79b80cf77)(),
            canTransitionIn: (current, next)=>{
                const { query: query } = next.match;
                if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
                const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
                const addonKey = next.match.params.addonKey || '';
                if (emceeKeyRegex.test(addonKey)) return false;
                return true;
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $49a774cbbfe614f4$export$c33275abe6c1e577)
            ],
            ufoName: 'jira-connect'
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $hBv66;
    var $2G9Bk;
    var $aPfsS;
    var $65Ltd;
    const $1153a77cb71c1b79$export$1fda4850b6314ff0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL),
        path: '/plugins/servlet/ac/:addonKey/:moduleKey',
        query: (0, $0bf6b9f3f002a423$export$2fdb05fdbf78d595)
    };
    const $a1bee888763609f4$export$46273ee39bcd958b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1153a77cb71c1b79$export$1fda4850b6314ff0), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)(),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericConnectSidebars)
            },
            component: (0, $49a774cbbfe614f4$export$2e2bcd8739ae039),
            resources: (0, $7a1fe7edd9b898b4$export$2c86c2f79b80cf77)(),
            canTransitionIn: (current, next)=>{
                const { query: query } = next.match;
                if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
                const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
                const addonKey = next.match.params.addonKey || '';
                if (emceeKeyRegex.test(addonKey)) return false;
                return true;
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $49a774cbbfe614f4$export$c33275abe6c1e577)
            ],
            ufoName: 'jira-connect'
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $hBv66;
    var $2G9Bk;
    var $aPfsS;
    var $fpjJX;
    var $65Ltd;
    const $d699769fc97b2ccd$export$e8a58aee75961b55 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
        path: '/plugins/servlet/ac/:addonKey/:moduleKey',
        query: [
            'mobile?!=true',
            'includeWebResources?!=true',
            'classifier?!=json',
            'project.key?',
            'project.id?',
            'project.key',
            'servicedesk.serviceDeskId'
        ]
    };
    const $70d164d9674a0900$export$487a360459ad1bea = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d699769fc97b2ccd$export$e8a58aee75961b55), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)(),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericConnectSidebars)
            },
            component: (0, $49a774cbbfe614f4$export$2e2bcd8739ae039),
            resources: [
                ...(0, $7a1fe7edd9b898b4$export$2c86c2f79b80cf77)(),
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationSingleResources)()
            ],
            canTransitionIn: (current, next)=>{
                const { query: query } = next.match;
                if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
                const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
                const addonKey = next.match.params.addonKey || '';
                if (emceeKeyRegex.test(addonKey)) return false;
                return true;
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $49a774cbbfe614f4$export$c33275abe6c1e577)
            ],
            ufoName: 'jira-connect'
        }));
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $hBv66;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    const $e64562bb8c3fa371$export$9bb839aee83bf4d8 = [
        'selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)'
    ];
    var $65Ltd;
    const $e3a0435584f46760$export$27e7531864dfb704 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT),
        path: '/projects/:projectKey',
        query: (0, $e64562bb8c3fa371$export$9bb839aee83bf4d8)
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $c9a4402f23043c3c$export$3dadc93ff144628f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dwmMO"))), {
        moduleId: "./src/packages/spa-apps/jira-connect/project-pages/src/index.tsx"
    });
    var $c9a4402f23043c3c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c9a4402f23043c3c$export$3dadc93ff144628f,
            pageId: "connect-projects",
            shouldShowSpinner: true
        });
    const $88ce8816647240e1$export$96bdc57a01f2ee48 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e3a0435584f46760$export$27e7531864dfb704), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
            component: (0, $c9a4402f23043c3c$export$2e2bcd8739ae039),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $c9a4402f23043c3c$export$3dadc93ff144628f)
            ],
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            ufoName: 'jira-connect',
            resources: [
                ...(0, $7a1fe7edd9b898b4$export$4c06110e7d14ab3c)(),
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSharedNavigationSingleResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $e9869d33b741028e$export$5ce9108542315ac8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CREATE_PROJECT),
        path: '/jira/create-project',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $7e202110676952db$export$5c005d1ab6cfe623 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("1OvmD")), {
        moduleId: "./src/packages/spa-apps/create-project/src/index.tsx"
    });
    const $7e202110676952db$export$43b852e2e1a047e8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7e202110676952db$export$5c005d1ab6cfe623,
            pageId: "spa-apps/create-project",
            shouldShowSpinner: true
        });
    const $7e202110676952db$export$28887e2da22c839a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e9869d33b741028e$export$5ce9108542315ac8), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
            component: $7e202110676952db$export$43b852e2e1a047e8,
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7e202110676952db$export$5c005d1ab6cfe623
            ]
        }));
    var $ffza4;
    var $aPfsS;
    var $kxZPA;
    const $f2fce09c535c3a19$export$d4768112536c9dc9 = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("8o619")), {
        ssr: false,
        moduleId: "./src/packages/global-pages/dashboard/background-scripts/src/ui/index.tsx"
    });
    const $79510dabdd765f30$export$4095842bb2e8d712 = (0, $f2fce09c535c3a19$export$d4768112536c9dc9);
    $79510dabdd765f30$export$4095842bb2e8d712.displayName = 'ConditionalDashboardBackgroundScripts';
    const $90a067693c09e346$export$f0a12e66953aa38a = (0, (0, parcelRequire("aPfsS")).createLayout)({
        globalComponents: [
            (0, $79510dabdd765f30$export$4095842bb2e8d712)
        ]
    });
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $aPfsS;
    var $gh1hi;
    var $3RJkv;
    var $65Ltd;
    const $28f71741a95efd1f$export$b6e00d2cd7369fbd = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_EDIT),
        path: '/jira/dashboards/:dashboardId(\\d+)/edit',
        query: [
            'maximized?'
        ],
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $gh1hi;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $92d1f2722b27ff5d$export$50d95db618f58349 = [
        (0, (0, parcelRequire("gh1hi")).dashboardConfigAndWRMResource),
        (0, (0, parcelRequire("gh1hi")).dashboardAMDModulesResource),
        (0, (0, parcelRequire("gh1hi")).dashboardReactGadgetsResource),
        (0, (0, parcelRequire("gh1hi")).dashboardForgeResource)
    ];
    const $92d1f2722b27ff5d$export$c3bf98706b62de2b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("j5mZS"))), {
        moduleId: "./src/packages/global-pages/dashboard/view/src/index.tsx"
    });
    const $92d1f2722b27ff5d$export$94d85118d282a15 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dtemB"))), {
        moduleId: "./src/packages/global-pages/dashboard/view-embed/src/index.tsx"
    });
    const $92d1f2722b27ff5d$export$ca0de361d2830ec0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3G01R"))), {
        moduleId: "./src/packages/global-pages/dashboard/wallboard/src/index.tsx"
    });
    const $92d1f2722b27ff5d$export$8aa1df69fbbf292 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gE8Ee"))), {
        moduleId: "./src/packages/global-pages/dashboard/edit/src/index.tsx"
    });
    const $92d1f2722b27ff5d$export$c8d59d34c3e8f345 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("l7bAo"))), {
        moduleId: "./src/packages/spa-apps/dashboard/system-dashboard-edit/src/index.tsx"
    });
    const $92d1f2722b27ff5d$export$8d692f4ffba40a2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $92d1f2722b27ff5d$export$c3bf98706b62de2b,
            pageId: "dashboard",
            shouldShowSpinner: false
        });
    const $92d1f2722b27ff5d$export$86d9f777f9d4e312 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $92d1f2722b27ff5d$export$94d85118d282a15,
            pageId: "dashboard",
            shouldShowSpinner: true
        });
    const $92d1f2722b27ff5d$export$419b9eec5ed9880d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $92d1f2722b27ff5d$export$ca0de361d2830ec0,
            pageId: "dashboard",
            shouldShowSpinner: true
        });
    const $92d1f2722b27ff5d$export$fb2c0a1de056b738 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $92d1f2722b27ff5d$export$8aa1df69fbbf292,
            pageId: "dashboard",
            shouldShowSpinner: false
        });
    const $92d1f2722b27ff5d$export$dcd19a888f8c85c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $92d1f2722b27ff5d$export$c8d59d34c3e8f345,
            pageId: "system-dashboard-edit",
            shouldShowSpinner: false
        });
    const $ff9c4f8f4f936d52$export$9b0fdfd6a51a17de = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $28f71741a95efd1f$export$b6e00d2cd7369fbd), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
            component: (0, $92d1f2722b27ff5d$export$fb2c0a1de056b738),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $90a067693c09e346$export$f0a12e66953aa38a)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, $92d1f2722b27ff5d$export$50d95db618f58349),
                (0, (0, parcelRequire("gh1hi")).gadgetDirectoryResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $92d1f2722b27ff5d$export$8aa1df69fbbf292)
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            earlyAssets: (0, $f36666704bcc2bab$export$137d6d169f402a59)
        }));
    var $ffza4;
    var $65Ltd;
    var $co1wz;
    var $7XYc4;
    var $aPfsS;
    var $kxZPA;
    const $d1122e3218429f7d$export$cb38f5a820347580 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("hgT7Q")).then((module)=>module.TransitionHomeRenderer), {
        ssr: false,
        moduleId: "./src/packages/eoc/changeboarding/src/ui/transition-home/main.tsx"
    }), ()=>null);
    $d1122e3218429f7d$export$cb38f5a820347580.displayName = 'AsyncTransitionHomeRenderer';
    const $d1122e3218429f7d$export$9cda67d6c86d7b98 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("7K4Fs")).then((module)=>module.WelcomeModalRenderer), {
        ssr: false,
        moduleId: "./src/packages/eoc/changeboarding/src/ui/wizard/main.tsx"
    }), ()=>null);
    $d1122e3218429f7d$export$9cda67d6c86d7b98.displayName = 'AsyncWelcomeModalRenderer';
    const $d1122e3218429f7d$export$b8fa7ac7019001bb = (0, (0, parcelRequire("aPfsS")).createLayout)({
        get globalComponents () {
            return [
                $d1122e3218429f7d$export$cb38f5a820347580,
                $d1122e3218429f7d$export$9cda67d6c86d7b98
            ];
        }
    });
    var $2BrOV;
    var $aPfsS;
    const $226ab3e64821f6b2$export$5b7fb151d60504c = (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), {
        globalComponents: [
            (0, $d1122e3218429f7d$export$cb38f5a820347580),
            (0, $d1122e3218429f7d$export$9cda67d6c86d7b98)
        ]
    });
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $91c4527accb41ff2$export$3bf0ecb39349b6ef = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD),
        path: '/secure/Dashboard.jspa'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $6jY6G;
    var $7OYJs;
    var $9VXkC;
    var $doZTA;
    const $55d04275d2bcfadf$export$da833ddcffcc38ba = ()=>{
        const [{ query: query, location: { hash: hash } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { path: path } = (0, (0, parcelRequire("6jY6G")).useRouteByName)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW)) ?? {};
        if (path == null) throw new Error('Dashboard view route not found');
        const { selectPageId: id } = query;
        const idParam = /^\d+$/.test(id) ? id : 'last-visited';
        const generatedPath = (0, (0, parcelRequire("9VXkC")).generatePath)(path, {
            dashboardId: idParam
        });
        const maximizedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
        const pathWithQuery = maximizedId !== null ? `${generatedPath}?maximized=${maximizedId}` : generatedPath;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: pathWithQuery,
            persistSearchParams: false
        });
    };
    const $1603466baea9815f$export$9fbbaafb58999ac3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $91c4527accb41ff2$export$3bf0ecb39349b6ef), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
            component: (0, $55d04275d2bcfadf$export$da833ddcffcc38ba),
            layout: (0, $226ab3e64821f6b2$export$5b7fb151d60504c),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, $92d1f2722b27ff5d$export$50d95db618f58349)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $92d1f2722b27ff5d$export$c3bf98706b62de2b)
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            isRedirect: true,
            earlyAssets: (0, $f36666704bcc2bab$export$137d6d169f402a59)
        }));
    var $65Ltd;
    var $2G9Bk;
    var $aPfsS;
    var $2Ql51;
    var $65Ltd;
    const $47f4f3f379b59c3e$export$258b5e3f294617d2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW_EMBED),
        path: '/jira/dashboards/:dashboardId(\\d+)/embed',
        query: [],
        exact: true
    };
    const $67a8397fa114200d$export$73a377380ff671af = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $47f4f3f379b59c3e$export$258b5e3f294617d2), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
            component: (0, $92d1f2722b27ff5d$export$86d9f777f9d4e312),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)({
                globalComponents: [
                    (0, $79510dabdd765f30$export$4095842bb2e8d712)
                ],
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
                ...(0, $92d1f2722b27ff5d$export$50d95db618f58349)
            ],
            forPaint: [
                (0, $92d1f2722b27ff5d$export$94d85118d282a15)
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            earlyAssets: (0, $f36666704bcc2bab$export$137d6d169f402a59)
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $aPfsS;
    var $3RJkv;
    var $5gOBf;
    const $c891244b3388b2f7$export$18226b6422149926 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5gOBf")).dashboardViewRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
            component: (0, $92d1f2722b27ff5d$export$8d692f4ffba40a2),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, $90a067693c09e346$export$f0a12e66953aa38a)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, $92d1f2722b27ff5d$export$50d95db618f58349)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $92d1f2722b27ff5d$export$c3bf98706b62de2b)
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            earlyAssets: (0, $f36666704bcc2bab$export$137d6d169f402a59),
            ufoName: 'dashboard'
        }));
    var $65Ltd;
    var $2G9Bk;
    var $aPfsS;
    var $2Ql51;
    var $65Ltd;
    const $59e2472cc6b14119$export$eaa33c953ab9ca63 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD),
        path: '/jira/dashboards/wallboard',
        query: [
            'dashboardId',
            'cyclePeriod?',
            'transitionFx?',
            'random?'
        ],
        exact: true
    };
    const $ae18a94b5423e69e$export$6009dd8e88f1a7de = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $59e2472cc6b14119$export$eaa33c953ab9ca63), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
            component: (0, $92d1f2722b27ff5d$export$419b9eec5ed9880d),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)({
                globalComponents: [
                    (0, $79510dabdd765f30$export$4095842bb2e8d712)
                ],
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
                ...(0, $92d1f2722b27ff5d$export$50d95db618f58349)
            ],
            forPaint: [
                (0, $92d1f2722b27ff5d$export$ca0de361d2830ec0)
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            earlyAssets: (0, $f36666704bcc2bab$export$137d6d169f402a59)
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $f6e234b8f82fcbbd$export$b32070ee9554c3fb = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_SELECTED),
        path: '/secure/Dashboard.jspa',
        query: [
            'selectPageId'
        ]
    };
    const $4fedf6a5f46c9101$export$ac09a8d3ecbafc5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f6e234b8f82fcbbd$export$b32070ee9554c3fb), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
            component: (0, $55d04275d2bcfadf$export$da833ddcffcc38ba),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, $92d1f2722b27ff5d$export$50d95db618f58349)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $92d1f2722b27ff5d$export$c3bf98706b62de2b)
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            isRedirect: true,
            earlyAssets: (0, $f36666704bcc2bab$export$137d6d169f402a59)
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $aPfsS;
    var $gh1hi;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $81fa712f0fcff9b5$export$7367fb465296c7dd = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT),
        path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
        query: [
            'maximized?'
        ]
    };
    const $29daafdf917937bc$export$15f76f1b0d2d671 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $81fa712f0fcff9b5$export$7367fb465296c7dd), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
            component: (0, $92d1f2722b27ff5d$export$dcd19a888f8c85c),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("ibkIl")).globalSettingsLayout), (0, $90a067693c09e346$export$f0a12e66953aa38a)),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                ...(0, $92d1f2722b27ff5d$export$50d95db618f58349),
                (0, (0, parcelRequire("gh1hi")).gadgetDirectoryResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $92d1f2722b27ff5d$export$c8d59d34c3e8f345)
            ],
            earlyAssets: (0, $f36666704bcc2bab$export$137d6d169f402a59)
        }));
    var $ffza4;
    var $65Ltd;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $52511ff99217f467$export$91257312631802bc = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DEVOPS_CONNECTED_PROJECT),
        path: '/jira/devops/connected-project'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $31d281e7968db385$export$dcd3d20b0038b35c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("65UbN"))), {
        moduleId: "./src/packages/spa-apps/devops-connected-project/src/index.tsx"
    });
    var $31d281e7968db385$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $31d281e7968db385$export$dcd3d20b0038b35c,
            pageId: "devops-connected-project",
            shouldShowSpinner: true
        });
    const $b6b724158556afe3$export$ae258fb8ec2c1f86 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $52511ff99217f467$export$91257312631802bc), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DEVOPS),
            ufoName: 'devops.connected-project',
            component: (0, $31d281e7968db385$export$2e2bcd8739ae039),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $31d281e7968db385$export$dcd3d20b0038b35c)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $bPjHb;
    var $3RJkv;
    var $65Ltd;
    const $de45f7ff4b8bd3d7$export$a4fba1ebd6ba91ee = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BOARDS_DIRECTORY)}-redirect`,
        path: '/secure/ManageRapidViews.jspa'
    };
    var $7OYJs;
    var $cFtGt;
    var $7yO8g;
    var $kxZPA;
    const $63ac430661b12a63$export$2826049ae45f4cd = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dg2Zd"))), {
        moduleId: "./src/packages/spa-apps/directories/boards/src/index.tsx"
    });
    const $819db157557bdd41$var$BoardsDirectoryRedirect = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/boards"
        });
    const $819db157557bdd41$export$2a34d21ecf479c40 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $de45f7ff4b8bd3d7$export$a4fba1ebd6ba91ee), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
            component: $819db157557bdd41$var$BoardsDirectoryRedirect,
            skeleton: (0, (0, parcelRequire("cFtGt")).BoardsDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bPjHb")).boardsDirectoryResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $63ac430661b12a63$export$2826049ae45f4cd)
            ],
            isRedirect: true
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $bPjHb;
    var $3RJkv;
    var $jP33S;
    var $cFtGt;
    var $5j7Th;
    const $bb811a13740c7cf1$var$BoardsDirectoryComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $63ac430661b12a63$export$2826049ae45f4cd),
            pageId: "boards-directory",
            shouldShowSpinner: false
        });
    const $bb811a13740c7cf1$export$e78b34c999194638 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jP33S")).boardsDirectoryRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
            component: $bb811a13740c7cf1$var$BoardsDirectoryComponent,
            skeleton: (0, (0, parcelRequire("cFtGt")).BoardsDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bPjHb")).boardsDirectoryResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $63ac430661b12a63$export$2826049ae45f4cd)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $4yCf0;
    var $3RJkv;
    var $65Ltd;
    const $55fec75e9850e3c3$export$b96f6fb3c35a6fe5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
        path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
    };
    var $7OYJs;
    var $cFtGt;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $cd7e3d13d091ccad$export$f2f3fd22cd37e121 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("64Xr4"))), {
        moduleId: "./src/packages/spa-apps/directories/dashboards/src/index.tsx"
    });
    const $cd7e3d13d091ccad$export$1cc6cc01050e1215 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cd7e3d13d091ccad$export$f2f3fd22cd37e121,
            pageId: "dashboards-directory",
            shouldShowSpinner: false
        });
    const $3848740eee1bab7b$var$DashboardsDirectoryRedirect = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/dashboards"
        });
    const $3848740eee1bab7b$export$8dae8091f8e43b97 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $55fec75e9850e3c3$export$b96f6fb3c35a6fe5), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("4yCf0")).dashboardsDirectoryResource)
            ],
            component: !false ? $3848740eee1bab7b$var$DashboardsDirectoryRedirect : (0, $cd7e3d13d091ccad$export$1cc6cc01050e1215),
            skeleton: (0, (0, parcelRequire("cFtGt")).DashboardsDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cd7e3d13d091ccad$export$f2f3fd22cd37e121)
            ],
            isRedirect: true
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $4yCf0;
    var $3RJkv;
    var $dDmlh;
    var $cFtGt;
    const $bc6135fca4882261$export$748e329bd0c282a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dDmlh")).dashboardsDirectoryRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("4yCf0")).dashboardsDirectoryResource)
            ],
            component: (0, $cd7e3d13d091ccad$export$1cc6cc01050e1215),
            skeleton: (0, (0, parcelRequire("cFtGt")).DashboardsDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cd7e3d13d091ccad$export$f2f3fd22cd37e121)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $dRl24;
    var $3RJkv;
    var $65Ltd;
    const $2881371d3e73fb66$export$f4f86e1ddc30a625 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY)}-redirect`,
        path: '/ManageFilters.jspa'
    };
    var $cFtGt;
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $37b0d6d8034450f5$export$c56e739d3bb1fe19 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/filters"
        });
    const $37b0d6d8034450f5$export$cc133cd5c6f1b69d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lOSli"))), {
        moduleId: "./src/packages/spa-apps/directories/filters/src/index.tsx"
    });
    const $37b0d6d8034450f5$export$e5d735e83dacb7c7 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $37b0d6d8034450f5$export$cc133cd5c6f1b69d,
            pageId: "filters-directory",
            shouldShowSpinner: false
        });
    const $03e59a293d347a10$export$41fb3f2a3e68c7c3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2881371d3e73fb66$export$f4f86e1ddc30a625), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dRl24")).filtersDirectoryResource)
            ],
            component: !false ? (0, $37b0d6d8034450f5$export$c56e739d3bb1fe19) : (0, $37b0d6d8034450f5$export$e5d735e83dacb7c7),
            skeleton: (0, (0, parcelRequire("cFtGt")).FiltersDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $37b0d6d8034450f5$export$cc133cd5c6f1b69d)
            ],
            isRedirect: true
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $dRl24;
    var $3RJkv;
    var $b6S3k;
    var $cFtGt;
    const $3947322b61fcc480$export$ca77bc660994f51f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("b6S3k")).filtersDirectoryRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dRl24")).filtersDirectoryResource)
            ],
            component: (0, $37b0d6d8034450f5$export$e5d735e83dacb7c7),
            skeleton: (0, (0, parcelRequire("cFtGt")).FiltersDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $37b0d6d8034450f5$export$cc133cd5c6f1b69d)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $4jMkc;
    var $2G9Bk;
    var $3RJkv;
    var $fsqMg;
    var $cFtGt;
    var $5j7Th;
    var $atU1t;
    var $hW253;
    const $318b78701350b044$export$1b29db6307155621 = [
        (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
        (0, (0, parcelRequire("hW253")).projectsDirectoryPageResource)
    ];
    var $7yO8g;
    var $kxZPA;
    const $d796a5814b8b99a8$export$f9ee24127b8e4a7f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3OnPz"))), {
        moduleId: "./src/packages/spa-apps/directories/projects-v3/src/index.tsx"
    });
    const $1960d4b6e7268d63$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "8bd2c50d7613ef27c0c7f5d9ff9b9f059c7e8c6add7f7091c71b35680d18da7b",
            "metadata": {},
            "name": "src_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $1960d4b6e7268d63$export$2e2bcd8739ae039 = $1960d4b6e7268d63$var$node;
    var $eufEc;
    var $fEDBv;
    const $b89f927130994d16$export$4707e15fd1e8e43a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("6xeDr")), {
            moduleId: "d6ecfa73"
        }),
        getPreloadProps: ({ tenantContext: tenantContext })=>({
                queries: {
                    templatesQueryRef: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: $1960d4b6e7268d63$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            isAnonymous: tenantContext.isAnonymous
                        }
                    }
                }
            })
    });
    var $lmyls;
    var $dXq4S;
    const $a2863fb0305ba6a4$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "af9ae1db2f285065c82807efe7982bd15a72bebc7c10b3ab0526c030f540c5ad",
            "metadata": {},
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $a2863fb0305ba6a4$export$2e2bcd8739ae039 = $a2863fb0305ba6a4$var$node;
    var $eIMrK;
    var $ce6VA;
    var $iyWSs;
    const $ca4f44207dc12143$var$cache = (0, (0, parcelRequire("eIMrK")).createCache)(new Map());
    function $ca4f44207dc12143$export$58f934f3d33a84b6(loader, opts) {
        return $ca4f44207dc12143$var$cache.get(opts.moduleId, ()=>(0, (0, parcelRequire("ce6VA")).PreloadableJSResource)(()=>(0, (0, parcelRequire("iyWSs")).postTask)(loader, {
                    priority: 'user-blocking'
                }), opts));
    }
    var $fEDBv;
    const $94d9041756c0d8ee$var$DEFAULT_LIMIT = 25;
    const $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE = 'projects-directory-manage';
    const $94d9041756c0d8ee$var$DefaultFilterFields = {
        SortOrder: 'sortOrder',
        SortKey: 'sortKey',
        Page: 'page'
    };
    var $94d9041756c0d8ee$var$TableColumns;
    (function(TableColumns) {
        TableColumns["Favourites"] = "favourites";
        TableColumns["Key"] = "key";
        TableColumns["Name"] = "name";
        TableColumns["Type"] = "type";
        TableColumns["Lead"] = "lead";
        TableColumns["Category"] = "category";
        TableColumns["LastIssueUpdate"] = "last_issue_updated_time";
        TableColumns["Url"] = "url";
        TableColumns["Action"] = "actions";
    })($94d9041756c0d8ee$var$TableColumns || ($94d9041756c0d8ee$var$TableColumns = {}));
    const $94d9041756c0d8ee$var$SortableColumns = [
        "key",
        "name",
        "lead",
        "category",
        "last_issue_updated_time"
    ];
    const $94d9041756c0d8ee$var$FilterFields = {
        Keyword: 'keyword',
        ProjectType: 'types',
        ProjectCategoryId: 'projectCategoryId',
        ...$94d9041756c0d8ee$var$DefaultFilterFields
    };
    const $94d9041756c0d8ee$var$filterAliasMap = {
        contains: $94d9041756c0d8ee$var$FilterFields.Keyword,
        selectedProjectType: $94d9041756c0d8ee$var$FilterFields.ProjectType,
        selectedCategory: $94d9041756c0d8ee$var$FilterFields.ProjectCategoryId
    };
    const $94d9041756c0d8ee$var$filterInitialState = {
        [$94d9041756c0d8ee$var$FilterFields.Keyword]: '',
        [$94d9041756c0d8ee$var$FilterFields.ProjectType]: '',
        [$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId]: '',
        [$94d9041756c0d8ee$var$FilterFields.SortOrder]: 'ASC',
        [$94d9041756c0d8ee$var$FilterFields.SortKey]: "name",
        [$94d9041756c0d8ee$var$FilterFields.Page]: '1'
    };
    const $94d9041756c0d8ee$var$LEGACY_ALL_VALUE = 'all';
    const $94d9041756c0d8ee$var$sanitizeLegacyQuery = (query = {})=>({
            ...query,
            selectedProjectType: query.selectedProjectType === $94d9041756c0d8ee$var$LEGACY_ALL_VALUE ? $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.ProjectType] : query.selectedProjectType,
            selectedCategory: query.selectedCategory === $94d9041756c0d8ee$var$LEGACY_ALL_VALUE ? $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId] : query.selectedCategory
        });
    const $94d9041756c0d8ee$var$matchAliases = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
            const alias = aliases[key];
            const queryValue = query[key];
            const hasInitialValue = filter[key] !== undefined;
            if (hasInitialValue && queryValue) {
                filter[key] = queryValue;
                return filter;
            }
            if (!alias || !queryValue) return filter;
            filter[alias] = queryValue;
            return filter;
        }, {
            ...filterState
        });
    const $94d9041756c0d8ee$var$CORE_PROJECT = 'business';
    const $94d9041756c0d8ee$var$SOFTWARE_PROJECT = 'software';
    const $94d9041756c0d8ee$var$SERVICE_DESK_PROJECT = 'service_desk';
    const $94d9041756c0d8ee$var$PRODUCT_DISCOVERY_PROJECT = 'product_discovery';
    const $94d9041756c0d8ee$var$PROJECT_TYPES = [
        $94d9041756c0d8ee$var$CORE_PROJECT,
        $94d9041756c0d8ee$var$SOFTWARE_PROJECT,
        $94d9041756c0d8ee$var$SERVICE_DESK_PROJECT,
        $94d9041756c0d8ee$var$PRODUCT_DISCOVERY_PROJECT
    ];
    const $94d9041756c0d8ee$var$mapQueryToFilter = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
        const variables = {};
        const { [$94d9041756c0d8ee$var$FilterFields.Keyword]: keyword, [$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId]: projectCategoryId, [$94d9041756c0d8ee$var$FilterFields.ProjectType]: types, [$94d9041756c0d8ee$var$FilterFields.SortOrder]: sortOrder, [$94d9041756c0d8ee$var$FilterFields.SortKey]: sortKey } = aliases && query ? $94d9041756c0d8ee$var$matchAliases(filter, query, aliases) : filter;
        if (keyword) variables.keyword = keyword;
        if (projectCategoryId) variables.projectCategoryId = (0, (0, parcelRequire("dXq4S")).isAri)(projectCategoryId) ? projectCategoryId : (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
        if (sortKey || sortOrder) {
            const sortByValue = sortKey && $94d9041756c0d8ee$var$SortableColumns.includes(sortKey) ? sortKey : $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.SortKey];
            variables.sortBy = {
                order: [
                    'ASC',
                    'DESC'
                ].includes(sortOrder) ? sortOrder : $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.SortOrder],
                sortBy: sortByValue.toUpperCase()
            };
        }
        if (types && typeof types === 'string') variables.types = types.split(',').filter((type)=>$94d9041756c0d8ee$var$PROJECT_TYPES.includes(type)).map((type)=>type.toUpperCase());
        return variables;
    };
    const $94d9041756c0d8ee$export$80225215a10b2688 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, $ca4f44207dc12143$export$58f934f3d33a84b6)(()=>(parcelRequire("aljyN")), {
            moduleId: "b77224b3"
        }),
        getPreloadProps ({ context: { query: query, route: route }, tenantContext: tenantContext }) {
            const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
            const extraProps = {
                isAdminProjectDirectoryRoute: route.name === $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE
            };
            if (false && isAnonymous) return {
                extraProps: extraProps
            };
            return {
                queries: {
                    projectsDirectoryPage: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: (0, $a2863fb0305ba6a4$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            filter: $94d9041756c0d8ee$var$mapQueryToFilter($94d9041756c0d8ee$var$filterInitialState, {
                                cloudId: cloudId,
                                query: $94d9041756c0d8ee$var$sanitizeLegacyQuery(query),
                                aliases: $94d9041756c0d8ee$var$filterAliasMap
                            }),
                            first: query?.page ? $94d9041756c0d8ee$var$DEFAULT_LIMIT * (parseInt(query.page, 10) || 1) : $94d9041756c0d8ee$var$DEFAULT_LIMIT,
                            last: $94d9041756c0d8ee$var$DEFAULT_LIMIT,
                            isAdminSettingsContext: route.name === $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE,
                            isAnonymous: isAnonymous
                        }
                    }
                },
                extraProps: extraProps
            };
        }
    });
    const $7c5d8dbcb4091f9b$export$f4985310f86f98fc = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $94d9041756c0d8ee$export$80225215a10b2688),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
        rightSidebar: (0, $b89f927130994d16$export$4707e15fd1e8e43a)
    });
    const $e28e6d3f170e3052$var$LazyAdminProjectsDirectory = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $d796a5814b8b99a8$export$f9ee24127b8e4a7f), {
            isAdminProjectDirectoryRoute: true
        });
    const $e28e6d3f170e3052$var$ProjectsDirectoryManageComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e28e6d3f170e3052$var$LazyAdminProjectsDirectory,
            pageId: "projects-directory-manage-v3",
            shouldShowSpinner: false
        });
    const $e28e6d3f170e3052$export$d5b1a46987369ee4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fsqMg")).manageProjectsDirectoryRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
            component: $e28e6d3f170e3052$var$ProjectsDirectoryManageComponent,
            skeleton: (0, (0, parcelRequire("cFtGt")).ProjectsDirectorySkeleton),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, $318b78701350b044$export$1b29db6307155621)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d796a5814b8b99a8$export$f9ee24127b8e4a7f)
            ],
            ufoName: 'projects-directory-v3-manage',
            entryPoint () {
                return 0, $7c5d8dbcb4091f9b$export$f4985310f86f98fc;
            }
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $4R6GH;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $8jQu6;
    var $cFtGt;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d1aaabcb7e27c9a6$var$LazyPlansDirectory = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lBR19"))), {
        moduleId: "./src/packages/spa-apps/directories/plans/src/index.tsx"
    });
    const $d1aaabcb7e27c9a6$var$PlansDirectoryComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d1aaabcb7e27c9a6$var$LazyPlansDirectory,
            pageId: "plans-directory",
            shouldShowSpinner: false
        });
    const $d1aaabcb7e27c9a6$export$4f9df77811fbdc1f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8jQu6")).plansDirectoryRoute), ()=>({
            shouldOptOutConcurrentMode: (0, (0, parcelRequire("4R6GH")).fg)('jira-concurrent-incremental'),
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
            component: $d1aaabcb7e27c9a6$var$PlansDirectoryComponent,
            skeleton: (0, (0, parcelRequire("cFtGt")).PlansDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $d1aaabcb7e27c9a6$var$LazyPlansDirectory
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $hW253;
    var $65Ltd;
    const $6002c1f8d9c23c57$export$c713f57300a82898 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA)}-redirect`,
        path: '/secure/BrowseProjects.jspa'
    };
    var $cFtGt;
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    const $ab995e642880d205$export$b68dd6112a931c10 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/projects"
        });
    const $8f20c76692c396ce$export$78ff5b5f42b9de4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6002c1f8d9c23c57$export$c713f57300a82898), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
            component: (0, $ab995e642880d205$export$b68dd6112a931c10),
            skeleton: (0, (0, parcelRequire("cFtGt")).ProjectsDirectorySkeleton),
            isRedirect: true,
            layout: (0, $226ab3e64821f6b2$export$5b7fb151d60504c),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("hW253")).projectsDirectoryPageResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d796a5814b8b99a8$export$f9ee24127b8e4a7f)
            ]
        }));
    var $ffza4;
    var $ibkIl;
    var $4jMkc;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $9ef5b86eaaaceda7$export$dbd3b6c012e8b6dc = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-redirect`,
        path: '/secure/project/ViewProjects.jspa'
    };
    var $cFtGt;
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    const $915a7634ecc98c68$export$74316a0a4963952b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/settings/projects/manage"
        });
    const $b468f39f7a3e39f4$export$c3c347e60b82f074 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9ef5b86eaaaceda7$export$dbd3b6c012e8b6dc), ()=>({
            component: (0, $915a7634ecc98c68$export$74316a0a4963952b),
            skeleton: (0, (0, parcelRequire("cFtGt")).ProjectsDirectorySkeleton),
            isRedirect: true,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, $318b78701350b044$export$1b29db6307155621)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d796a5814b8b99a8$export$f9ee24127b8e4a7f)
            ]
        }));
    var $ffza4;
    var $ibkIl;
    var $4jMkc;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $45b46e5e0a379e06$export$4531e3b2e25fad23 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-root-redirect`,
        path: '/jira/settings/projects',
        exact: true
    };
    var $cFtGt;
    const $e677bebc1d8715eb$export$3f6ec3224d4c9da = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $45b46e5e0a379e06$export$4531e3b2e25fad23), ()=>({
            component: (0, $915a7634ecc98c68$export$74316a0a4963952b),
            skeleton: (0, (0, parcelRequire("cFtGt")).ProjectsDirectorySkeleton),
            isRedirect: true,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, $318b78701350b044$export$1b29db6307155621)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d796a5814b8b99a8$export$f9ee24127b8e4a7f)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $hW253;
    var $65Ltd;
    const $529d55d6a6980bfb$export$d44f1be3782f0fde = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY)}-redirect`,
        path: '/projects',
        exact: true
    };
    var $cFtGt;
    const $66b2e7de35cd3e39$export$8d9d65bb59f2354e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $529d55d6a6980bfb$export$d44f1be3782f0fde), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
            component: (0, $ab995e642880d205$export$b68dd6112a931c10),
            skeleton: (0, (0, parcelRequire("cFtGt")).ProjectsDirectorySkeleton),
            isRedirect: true,
            layout: (0, $226ab3e64821f6b2$export$5b7fb151d60504c),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("hW253")).projectsDirectoryPageResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d796a5814b8b99a8$export$f9ee24127b8e4a7f)
            ]
        }));
    var $65Ltd;
    var $4R6GH;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $foR3E;
    var $cFtGt;
    const $00e4719282b1ae8b$export$79292a834772288c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("foR3E")).projectsDirectoryRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
            shouldOptOutConcurrentMode: (0, (0, parcelRequire("4R6GH")).fg)('jira-concurrent-incremental'),
            entryPoint () {
                return 0, $7c5d8dbcb4091f9b$export$f4985310f86f98fc;
            },
            skeleton: (0, (0, parcelRequire("cFtGt")).ProjectsDirectorySkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            ufoName: 'projects-directory-v3'
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $dRl24;
    var $3RJkv;
    var $65Ltd;
    const $6cb8f0f1ec2e6905$export$50796f2aecd63181 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY_SECURE)}-redirect`,
        path: '/secure/ManageFilters.jspa'
    };
    var $cFtGt;
    const $d55bc420bfc42a32$export$c2ec350ee9e78717 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6cb8f0f1ec2e6905$export$50796f2aecd63181), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dRl24")).filtersDirectoryResource)
            ],
            component: !false ? (0, $37b0d6d8034450f5$export$c56e739d3bb1fe19) : (0, $37b0d6d8034450f5$export$e5d735e83dacb7c7),
            skeleton: (0, (0, parcelRequire("cFtGt")).FiltersDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $37b0d6d8034450f5$export$cc133cd5c6f1b69d)
            ],
            isRedirect: true
        }));
    var $6YWw1;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2Fj5v;
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $cd33ec0afa28f27a$export$aea682543f08e131 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("kXCTu")).then(({ HorizontalOperationsConfiguration: HorizontalOperationsConfiguration })=>HorizontalOperationsConfiguration), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-operations-configuration/src/ui/index.tsx"
    });
    const $cd33ec0afa28f27a$export$1f7a0efe3746ea0d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jira-operations-configurations-horizontal-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "asyncHorizontalOperationsConfigurationNav",
            packageName: "jiraOperationsConfigurationsHorizontalNav",
            fallback: "flag",
            teamName: "50cent"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cd33ec0afa28f27a$export$aea682543f08e131, null)));
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $cfb9010ddff8a27d$export$f271eef5f9ec6602 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_CREATE),
        path: '/jira/settings/products/ops/syncs/create',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $9e8891c31cf06876$export$dbbcce89c7be1e71 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5dO1t")).then((module)=>module.AlertIssueSync), {
        moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
    });
    const $9e8891c31cf06876$export$ff3e9ed7471eebce = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5dO1t")).then((module)=>module.AlertIssueSyncCreate), {
        moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
    });
    const $9e8891c31cf06876$export$75137a2a583918e2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5dO1t")).then((module)=>module.AlertIssueSyncDetail), {
        moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
    });
    const $b20b2f013aa8d8a7$export$5a4922ba79d730f4 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $9e8891c31cf06876$export$dbbcce89c7be1e71),
            pageId: "async-jira-eoc-alert-issue-syncing",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    const $4b459ed932e435b5$export$a26f24c49385cf3a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $9e8891c31cf06876$export$ff3e9ed7471eebce),
            pageId: "async-jira-eoc-alert-issue-syncing",
            shouldShowSpinner: true
        });
    const $1afcecac57b51b7c$export$92f4b6644eb6cb88 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cfb9010ddff8a27d$export$f271eef5f9ec6602), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $b20b2f013aa8d8a7$export$5a4922ba79d730f4),
            slot: (0, $4b459ed932e435b5$export$a26f24c49385cf3a),
            basePath: '/jira/settings/products/ops',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("6YWw1")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("6YWw1")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9e8891c31cf06876$export$dbbcce89c7be1e71)
            ]
        }));
    var $6YWw1;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $2a3279be22ec7e63$export$f1b4093ef603b98d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_DETAIL),
        path: '/jira/settings/products/ops/syncs/:syncId',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    const $82010553b53ae722$export$c21f2a7e1aa801a7 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $9e8891c31cf06876$export$75137a2a583918e2),
            pageId: "async-jira-eoc-alert-issue-syncing",
            shouldShowSpinner: true
        });
    const $ea4b5ca423fc7b5e$export$7e604b22ae6e7c1e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2a3279be22ec7e63$export$f1b4093ef603b98d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $b20b2f013aa8d8a7$export$5a4922ba79d730f4),
            slot: (0, $82010553b53ae722$export$c21f2a7e1aa801a7),
            basePath: '/jira/settings/products/ops',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("6YWw1")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("6YWw1")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9e8891c31cf06876$export$dbbcce89c7be1e71)
            ]
        }));
    var $6YWw1;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $8f63b88635f620d8$export$73d6a0dc298aae15 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING),
        path: '/jira/settings/products/ops/syncs',
        exact: true
    };
    const $4abc338af93c95e0$export$c63d0942ec0f93c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8f63b88635f620d8$export$73d6a0dc298aae15), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $b20b2f013aa8d8a7$export$5a4922ba79d730f4),
            slot: null,
            basePath: '/jira/settings/products/ops',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("6YWw1")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("6YWw1")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9e8891c31cf06876$export$dbbcce89c7be1e71)
            ]
        }));
    var $6YWw1;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $d15151561c6a9349$export$a1b7c53ff39475a6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("15g3q")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/eoc-team-dashboard/src/index.tsx"
    });
    const $d15151561c6a9349$var$TeamDashboardSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "eocTeamDashboard"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d15151561c6a9349$export$a1b7c53ff39475a6, null));
    $d15151561c6a9349$var$TeamDashboardSidebar.displayName = 'TeamDashboardSidebar';
    var $d15151561c6a9349$export$2e2bcd8739ae039 = $d15151561c6a9349$var$TeamDashboardSidebar;
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $7836a14152b01d88$export$409c821653bbc63b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jmq4o")).then(({ HorizontalOperationsNav: HorizontalOperationsNav })=>HorizontalOperationsNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-operations/src/ui/index.tsx"
    });
    const $7836a14152b01d88$export$82108adf6887e32e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jmq4o")).then(({ OverviewNav: OverviewNav })=>OverviewNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-operations/src/ui/index.tsx"
    });
    const $7836a14152b01d88$export$1eb785f071697cc5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-operations-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "asyncHorizontalOperationsNav",
            packageName: "jiraOperationsHorizontalNav",
            fallback: "flag",
            teamName: "alexstrasza"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7836a14152b01d88$export$409c821653bbc63b, null)));
    const $7836a14152b01d88$export$27e50c09ebb514f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-operations-overview-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "asyncHorizontalOperationsOverviewNav",
            packageName: "jiraOperationsHorizontalNav",
            fallback: "flag",
            teamName: "alexstrasza"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7836a14152b01d88$export$82108adf6887e32e, null)));
    var $aPfsS;
    var $kxZPA;
    const $687f5bad65d17575$var$RightSidebars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("cQXYd")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/right-sidebars/index.tsx"
    });
    const $687f5bad65d17575$var$Onboarding = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("8cAy7")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/onboarding/index.tsx"
    });
    const $687f5bad65d17575$export$53dd27149810df73 = (0, (0, parcelRequire("aPfsS")).createLayout)({
        get globalComponents () {
            return [
                $687f5bad65d17575$var$Onboarding
            ];
        },
        rightSidebars: [
            $687f5bad65d17575$var$RightSidebars
        ]
    });
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $daedb7d5520453e5$export$915ef1948fe4650a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE),
        path: '/jira/ops/teams/:teamId/syncs/create',
        exact: true
    };
    const $529c88752df4ac9c$export$8c07dc381591dc69 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $daedb7d5520453e5$export$915ef1948fe4650a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $b20b2f013aa8d8a7$export$5a4922ba79d730f4),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: (0, $4b459ed932e435b5$export$a26f24c49385cf3a),
            basePath: '/jira/ops/teams',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("6YWw1")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("6YWw1")).resources).userAccessRightsResource,
                (0, (0, parcelRequire("6YWw1")).resources).getTeamResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9e8891c31cf06876$export$dbbcce89c7be1e71),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $6YWw1;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $19f7daafdc2ca993$export$e91535fc2137c3b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL),
        path: '/jira/ops/teams/:teamId/syncs/:syncId',
        exact: true
    };
    const $a162d438dc34f2e2$export$6298ff494c460e75 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $19f7daafdc2ca993$export$e91535fc2137c3b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $b20b2f013aa8d8a7$export$5a4922ba79d730f4),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: (0, $82010553b53ae722$export$c21f2a7e1aa801a7),
            basePath: '/jira/ops/teams',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("6YWw1")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("6YWw1")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9e8891c31cf06876$export$dbbcce89c7be1e71),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $6YWw1;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $4b9c202f143c618b$export$37ea7624561cbb89 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING),
        path: '/jira/ops/teams/:teamId/syncs',
        exact: true
    };
    const $4357b8f4ed10df63$export$be342a3401146aae = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $4b9c202f143c618b$export$37ea7624561cbb89), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $b20b2f013aa8d8a7$export$5a4922ba79d730f4),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: null,
            basePath: '/jira/ops/teams',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("6YWw1")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("6YWw1")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9e8891c31cf06876$export$dbbcce89c7be1e71),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $2T8SP;
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $3dba976dd77ba6a7$export$84985159d5695f4d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_API_KEY_MANAGEMENT),
        path: '/jira/settings/products/ops/api-key-management',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $eddc6a8c98318a70$export$6ae4b26c31b1b0d2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lPEDD")), {
        moduleId: "./src/packages/eoc/api-key-management/src/index.tsx"
    });
    var $eddc6a8c98318a70$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $eddc6a8c98318a70$export$6ae4b26c31b1b0d2,
            pageId: "async-jira-eoc-api-key-management",
            shouldShowSpinner: false
        });
    const $e19c93c774607b0f$export$e18a6be3d2ffad71 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3dba976dd77ba6a7$export$84985159d5695f4d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $eddc6a8c98318a70$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("2T8SP")).resources)
            ],
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $eddc6a8c98318a70$export$6ae4b26c31b1b0d2)
            ]
        }));
    var $jqlWU;
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $fee4692ea74fc971$export$79c37191a61ac94b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ASSIGN_CUSTOM_ROLES),
        path: '/jira/settings/products/ops/role-assignment',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $cbc95c821be59e53$export$fb6bafef9453a357 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("fXO8u")), {
        moduleId: "./src/packages/eoc/assign-custom-roles/src/index.tsx"
    });
    var $cbc95c821be59e53$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cbc95c821be59e53$export$fb6bafef9453a357,
            pageId: "async-eoc-assign-custom-roles",
            shouldShowSpinner: false
        });
    const $34e2a1a3b5a525df$export$c51a4ee3e3f1b270 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fee4692ea74fc971$export$79c37191a61ac94b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $cbc95c821be59e53$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("jqlWU")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cbc95c821be59e53$export$fb6bafef9453a357)
            ]
        }));
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $0aa16b205f7e3033$export$4a84eb4d8d37c9d4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_AUTOMATIONS),
        path: '/jira/ops/teams/:teamId/automations',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $1cf116b0539aa5be$export$903a0a44cc0933c5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ejRCG")), {
        moduleId: "./src/packages/spa-apps/ops-team-scope-automation/src/index.tsx"
    });
    var $1cf116b0539aa5be$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1cf116b0539aa5be$export$903a0a44cc0933c5,
            pageId: "ops-team-automation",
            shouldShowSpinner: true
        });
    const $dd0ff3cccea414a4$export$6ff606556e19e12 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0aa16b205f7e3033$export$4a84eb4d8d37c9d4), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $1cf116b0539aa5be$export$2e2bcd8739ae039),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1cf116b0539aa5be$export$903a0a44cc0933c5),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $7ygGB;
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $550a6202cdc3f9f3$export$3213a7325ca9911 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_CUSTOM_ROLES),
        path: '/jira/settings/products/ops/roles',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $ae4b2d4dc59e70bc$export$78ed54710f55f948 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("6hhHS")), {
        moduleId: "./src/packages/eoc/custom-roles/src/index.tsx"
    });
    var $ae4b2d4dc59e70bc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ae4b2d4dc59e70bc$export$78ed54710f55f948,
            pageId: "async-eoc-custom-roles",
            shouldShowSpinner: false
        });
    const $98b5efb8026932b2$export$9c9bab95d425eb6f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $550a6202cdc3f9f3$export$3213a7325ca9911), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $ae4b2d4dc59e70bc$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("7ygGB")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ae4b2d4dc59e70bc$export$78ed54710f55f948)
            ]
        }));
    var $jxRF2;
    var $6hGfG;
    var $gQ8M0;
    var $oacWJ;
    var $dqLIo;
    const $400eb496bca9e6a6$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("dqLIo")).uiPreferencesResource),
        (0, (0, parcelRequire("oacWJ")).savedSearchesResource),
        (0, (0, parcelRequire("gQ8M0")).compressionRatioResource),
        (0, (0, parcelRequire("6hGfG")).alertGroupingStateResource),
        ...(0, (0, parcelRequire("jxRF2")).eocCommonResources)()
    ];
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $kxZPA;
    const $423d186a1838bb07$export$674fd99c08c90491 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("j88uz")).then((bundle)=>bundle), {
        moduleId: "./src/packages/navigation-apps/sidebar/eoc-global-alerts/src/index.tsx"
    });
    const $423d186a1838bb07$export$a1c034c1031e8711 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "eocGlobalAlerts"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($423d186a1838bb07$export$674fd99c08c90491, null));
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $lUaB2;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $f17f54a7b3f3d036$export$f4aafff31d950b6c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("d8hKi")), {
        moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
    });
    const $f17f54a7b3f3d036$export$9333bfa567c9c31 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f17f54a7b3f3d036$export$f4aafff31d950b6c,
            pageId: "async-jira-eoc-alert-list",
            shouldShowSpinner: false
        });
    const $0edb022327e9a2a9$export$851a659e50436cff = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lUaB2")).eocGlobalAlertListRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $f17f54a7b3f3d036$export$9333bfa567c9c31),
            layout: (0, $d1122e3218429f7d$export$b8fa7ac7019001bb),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, $400eb496bca9e6a6$export$bc99aaabaf7b70a7),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                sidebar: (0, $423d186a1838bb07$export$a1c034c1031e8711)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $f17f54a7b3f3d036$export$f4aafff31d950b6c),
                (0, $423d186a1838bb07$export$674fd99c08c90491)
            ]
        }));
    var $en1L8;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $8e21c6953880063f$export$4c5c22da74ff47b1 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL),
        path: '/jira/ops/alerts/:id',
        exact: true
    };
    const $ffa726838ac9512f$export$bcb93d8198d511b9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8e21c6953880063f$export$4c5c22da74ff47b1), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $f17f54a7b3f3d036$export$9333bfa567c9c31),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, $400eb496bca9e6a6$export$bc99aaabaf7b70a7),
                ...(0, (0, parcelRequire("en1L8")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                sidebar: (0, $423d186a1838bb07$export$a1c034c1031e8711)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $f17f54a7b3f3d036$export$f4aafff31d950b6c),
                (0, $423d186a1838bb07$export$674fd99c08c90491)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $cM724;
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $b256c068fa7916da$export$9ed12f6fa845edfb = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ESCALATIONS),
        path: '/jira/settings/products/ops/escalation-policies',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $6214dd8c4ed95f14$export$3b298b599f8fb6b1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("boPOw")).then((module)=>module.GlobalEscalationsPage), {
        moduleId: "./src/packages/eoc/global-escalations/src/index.tsx"
    });
    const $6214dd8c4ed95f14$export$3d145c61c426e780 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6214dd8c4ed95f14$export$3b298b599f8fb6b1,
            pageId: "async-jira-eoc-global-escalations",
            shouldShowSpinner: false
        });
    const $6214dd8c4ed95f14$export$adde4536d8e5f94c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b256c068fa7916da$export$9ed12f6fa845edfb), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: $6214dd8c4ed95f14$export$3d145c61c426e780,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("cM724")).globalEscalationsListInfoResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $6214dd8c4ed95f14$export$3b298b599f8fb6b1
            ]
        }));
    var $eYyoJ;
    var $ffza4;
    var $65Ltd;
    var $co1wz;
    var $7XYc4;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $5lsNZ;
    var $65Ltd;
    const $c40ab0d9ba386fc6$export$e6569aff8dfd4c1d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL),
        path: '/jira/ops/group-detail/:id',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $009be0886fa71d74$export$8d4b3992eb19d436 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("c8NZy")), {
        moduleId: "./src/packages/eoc/group-detail/src/ui/index.tsx"
    });
    var $009be0886fa71d74$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $009be0886fa71d74$export$8d4b3992eb19d436,
            pageId: "async-jira-eoc-group-detail",
            shouldShowSpinner: false
        });
    const $08aebbbf84aea52e$export$66928ab349190059 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c40ab0d9ba386fc6$export$e6569aff8dfd4c1d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('platform.aiops-smart-view_yf5qp'), (0, $009be0886fa71d74$export$2e2bcd8739ae039), (0, (0, parcelRequire("5lsNZ")).default)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("eYyoJ")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, $400eb496bca9e6a6$export$bc99aaabaf7b70a7)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                sidebar: (0, $423d186a1838bb07$export$a1c034c1031e8711)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $009be0886fa71d74$export$8d4b3992eb19d436),
                (0, $423d186a1838bb07$export$674fd99c08c90491)
            ]
        }));
    var $eYyoJ;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $co1wz;
    var $7XYc4;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $5lsNZ;
    var $65Ltd;
    const $c70e4aa8d21accf9$export$aa8cf61e94739f21 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL),
        path: '/jira/ops/teams/:teamId/group-detail/:id',
        exact: true
    };
    const $7742cad3c3e8631c$export$2b25520e20820251 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c70e4aa8d21accf9$export$aa8cf61e94739f21), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('platform.aiops-smart-view_yf5qp'), (0, $009be0886fa71d74$export$2e2bcd8739ae039), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, (0, parcelRequire("eYyoJ")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, $400eb496bca9e6a6$export$bc99aaabaf7b70a7)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $009be0886fa71d74$export$8d4b3992eb19d436),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $90XDC;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $2010e6abe8716e4e$export$e935ec688da4c447 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_HEARTBEATS),
        path: '/jira/ops/teams/:teamId/heartbeats',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $b7a7f1ceb2ac2c2a$var$LazyHeartbeats = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("2we79")), {
        moduleId: "./src/packages/eoc/heartbeats/src/index.tsx"
    });
    const $b7a7f1ceb2ac2c2a$var$HeartbeatsComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b7a7f1ceb2ac2c2a$var$LazyHeartbeats,
            pageId: "async-jira-eoc-heartbeats",
            shouldShowSpinner: false
        });
    const $b7a7f1ceb2ac2c2a$export$2c2d6115c4280a08 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2010e6abe8716e4e$export$e935ec688da4c447), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: $b7a7f1ceb2ac2c2a$var$HeartbeatsComponent,
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("90XDC")).resources),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $b7a7f1ceb2ac2c2a$var$LazyHeartbeats,
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffEPd;
    var $3zzQS;
    const $e9a4d4d3026c87cf$export$c83d9fd41123ab31 = [
        (0, (0, parcelRequire("3zzQS")).listResource)
    ];
    const $e9a4d4d3026c87cf$export$63630293105c0f4e = [
        (0, (0, parcelRequire("ffEPd")).detailResource)
    ];
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $f3c8c21142f35b35$export$10f19333da6ac52c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INCOMING_CALL_DETAIL),
        path: '/jira/settings/products/ops/incoming-call/:id',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $25997639b70bd430$export$d76e6607b7e88a7b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ivQDT")).then((module)=>module.IncomingCallPage), {
        moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
    });
    const $25997639b70bd430$export$1c56f2b1fdd5d724 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ivQDT")).then((module)=>module.IncomingCallDetailPage), {
        moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
    });
    const $91ad9944e0af1355$export$6ec51edee1972588 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $25997639b70bd430$export$1c56f2b1fdd5d724),
            pageId: "async-jira-eoc-incoming-call-detail",
            shouldShowSpinner: false
        });
    const $91ad9944e0af1355$export$39f40714591c98c0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f3c8c21142f35b35$export$10f19333da6ac52c), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: $91ad9944e0af1355$export$6ec51edee1972588,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, $e9a4d4d3026c87cf$export$63630293105c0f4e)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $25997639b70bd430$export$d76e6607b7e88a7b)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $6e436edec71d75e1$export$8dd2e8adca05d8a3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INCOMING_CALL),
        path: '/jira/settings/products/ops/incoming-call',
        exact: true
    };
    var $5j7Th;
    const $06d17d7f82b9f72c$export$742ca8be503e0313 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $25997639b70bd430$export$d76e6607b7e88a7b),
            pageId: "async-jira-eoc-incoming-call",
            shouldShowSpinner: false
        });
    const $06d17d7f82b9f72c$export$bf8ccc758901febd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6e436edec71d75e1$export$8dd2e8adca05d8a3), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: $06d17d7f82b9f72c$export$742ca8be503e0313,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, $e9a4d4d3026c87cf$export$c83d9fd41123ab31)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $25997639b70bd430$export$d76e6607b7e88a7b)
            ]
        }));
    var $g9g6m;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $9976afa23f08aee0$export$bb272d36e3c3b7c1 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATION_CREATE),
        path: '/jira/settings/products/ops/integrations/create/:type',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $3157621202ba1387$export$68c40afda0287b61 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("elNBZ")).then((module)=>module.IntegrationAutomation), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $3157621202ba1387$export$fd7f60e3df94c902 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("elNBZ")).then((module)=>module.IntegrationDetail), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $3157621202ba1387$export$aa9358ade7cb53ee = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("elNBZ")).then((module)=>module.IntegrationCreate), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $3157621202ba1387$export$993132b847f26efa = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("elNBZ")).then((module)=>module.IntegrationList), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $3157621202ba1387$export$b02ef932401d95fc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("elNBZ")).then((module)=>module.IntegrationLog), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $fabeb48b83e49532$export$434c3e2269913ac0 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $3157621202ba1387$export$68c40afda0287b61),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    const $4cac4f496a2e098c$export$5cb14595364f02c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $3157621202ba1387$export$aa9358ade7cb53ee),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $675ac2c2cf4991e7$export$62eef9a2917f041f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9976afa23f08aee0$export$bb272d36e3c3b7c1), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            basePath: '/jira/settings/products/ops',
            component: (0, $fabeb48b83e49532$export$434c3e2269913ac0),
            slot: (0, $4cac4f496a2e098c$export$5cb14595364f02c),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).integrationListResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61)
            ]
        }));
    var $g9g6m;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $5333a62eb0093759$export$f826f15073eda98 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATION_DETAIL),
        path: '/jira/settings/products/ops/integrations/:type/:integrationId',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    const $406e3ebe7ebd1095$export$8bb99f196e0be5b6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $3157621202ba1387$export$fd7f60e3df94c902),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $127c0a8b66d1f657$export$b66abbccbf93e9ad = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5333a62eb0093759$export$f826f15073eda98), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            basePath: '/jira/settings/products/ops',
            component: (0, $fabeb48b83e49532$export$434c3e2269913ac0),
            slot: (0, $406e3ebe7ebd1095$export$8bb99f196e0be5b6),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61)
            ]
        }));
    var $g9g6m;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $acf744aa66a83413$export$270e16f240db883b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATION_LIST),
        path: '/jira/settings/products/ops/integrations/list',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    const $0a1886811a543b08$export$955768269b79c203 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $3157621202ba1387$export$993132b847f26efa),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $ed52be46c53ae197$export$790602da39f8af00 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $acf744aa66a83413$export$270e16f240db883b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            basePath: '/jira/settings/products/ops',
            component: (0, $fabeb48b83e49532$export$434c3e2269913ac0),
            slot: (0, $0a1886811a543b08$export$955768269b79c203),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).integrationListResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61)
            ]
        }));
    var $jxRF2;
    var $cekVR;
    var $k5TFj;
    var $8qZNT;
    var $lCbSp;
    const $6eed7288156ead59$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("lCbSp")).uiSettingsResource),
        (0, (0, parcelRequire("8qZNT")).logsResource),
        (0, (0, parcelRequire("cekVR")).byokInformationResource),
        ...(0, (0, parcelRequire("jxRF2")).eocCommonResources)()
    ];
    const $6eed7288156ead59$export$8571305c82629fe4 = [
        (0, (0, parcelRequire("k5TFj")).downloadAuditLogsResource),
        ...(0, (0, parcelRequire("jxRF2")).eocCommonResources)()
    ];
    var $g9g6m;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $69ab4fb51e1e7924$export$71884dc820e415fc = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATION_LOG),
        path: '/jira/settings/products/ops/integrations/:type/:integrationId/logs',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    const $124457f944712cee$export$b545b4a4c4cee016 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, $3157621202ba1387$export$b02ef932401d95fc),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $6535404a8c018f23$export$d30f51d0f351bd8a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $69ab4fb51e1e7924$export$71884dc820e415fc), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            basePath: '/jira/settings/products/ops',
            component: (0, $fabeb48b83e49532$export$434c3e2269913ac0),
            slot: (0, $124457f944712cee$export$b545b4a4c4cee016),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, $6eed7288156ead59$export$bc99aaabaf7b70a7),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61)
            ]
        }));
    var $g9g6m;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $0fed354e3cd747e8$export$e196ff2390a1ec56 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATIONS),
        path: '/jira/settings/products/ops/integrations',
        exact: true
    };
    const $42b9c62ef769e46b$export$6e5cd6656076550f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0fed354e3cd747e8$export$e196ff2390a1ec56), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            basePath: '/jira/settings/products/ops',
            component: (0, $fabeb48b83e49532$export$434c3e2269913ac0),
            slot: null,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61)
            ]
        }));
    var $g9g6m;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $ae27079a91acfd42$export$a2ec7da6c43acbbf = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE),
        path: '/jira/ops/teams/:teamId/integrations/create/:type',
        exact: true
    };
    const $46e74e6464e445dd$export$83aea99d18750f08 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ae27079a91acfd42$export$a2ec7da6c43acbbf), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            basePath: '/jira/ops/teams',
            component: (0, $fabeb48b83e49532$export$434c3e2269913ac0),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: (0, $4cac4f496a2e098c$export$5cb14595364f02c),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).integrationListResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $g9g6m;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $de1d1f48c94d5c8d$export$72169399df792b7c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL),
        path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId',
        exact: true
    };
    const $cd5c132b5b5151e0$export$7e0b6b79953422c1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $de1d1f48c94d5c8d$export$72169399df792b7c), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            basePath: '/jira/ops/teams',
            component: (0, $fabeb48b83e49532$export$434c3e2269913ac0),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: (0, $406e3ebe7ebd1095$export$8bb99f196e0be5b6),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $g9g6m;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $8e217314970bb735$export$b8218f375778e6d7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST),
        path: '/jira/ops/teams/:teamId/integrations/list',
        exact: true
    };
    const $d817aeb7fccbfd68$export$52ee366e7b51f38d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8e217314970bb735$export$b8218f375778e6d7), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            basePath: '/jira/ops/teams',
            component: (0, $fabeb48b83e49532$export$434c3e2269913ac0),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: (0, $0a1886811a543b08$export$955768269b79c203),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).integrationListResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $g9g6m;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $d7b8bbfd81270213$export$ca02d7b2c7df3d60 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG),
        path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId/logs',
        exact: true
    };
    const $77c62c16bb189e65$export$d5e169223d2a5d1d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d7b8bbfd81270213$export$ca02d7b2c7df3d60), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            basePath: '/jira/ops/teams',
            component: (0, $fabeb48b83e49532$export$434c3e2269913ac0),
            slot: (0, $124457f944712cee$export$b545b4a4c4cee016),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, $6eed7288156ead59$export$bc99aaabaf7b70a7),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $g9g6m;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $78efd1de67032a37$export$400ead354c81dee3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATIONS),
        path: '/jira/ops/teams/:teamId/integrations',
        exact: true
    };
    const $97fc56f25f58996b$export$ded9494f81dd2a4d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $78efd1de67032a37$export$400ead354c81dee3), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            basePath: '/jira/ops/teams',
            component: (0, $fabeb48b83e49532$export$434c3e2269913ac0),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            slot: null,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("g9g6m")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("g9g6m")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3157621202ba1387$export$68c40afda0287b61),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $iBsI0;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $7b192d8bc1d0ac68$export$9d65c6548c3b50e4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_MAINTENANCE),
        path: '/jira/settings/products/ops/maintenance',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $e4dedbcf388f1e04$export$c5c7dc53d976edee = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4D5wk")), {
        moduleId: "./src/packages/eoc/maintenance/src/index.tsx"
    });
    const $e4dedbcf388f1e04$export$76d7c25f72022339 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e4dedbcf388f1e04$export$c5c7dc53d976edee,
            pageId: "async-jira-eoc-maintenance",
            shouldShowSpinner: false
        });
    const $e5934255c94fc385$export$ce2a5648c28a5b48 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7b192d8bc1d0ac68$export$9d65c6548c3b50e4), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $e4dedbcf388f1e04$export$76d7c25f72022339),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("iBsI0")).resources)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $e4dedbcf388f1e04$export$c5c7dc53d976edee)
            ]
        }));
    var $iBsI0;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $a2d3b0156e892c32$export$b997369a5c2dab54 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_MAINTENANCE),
        path: '/jira/ops/teams/:teamId/maintenance',
        exact: true
    };
    const $e4663459434822fe$export$e9c59d0d6bfec8a3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a2d3b0156e892c32$export$b997369a5c2dab54), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $e4dedbcf388f1e04$export$76d7c25f72022339),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("iBsI0")).resources),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $e4dedbcf388f1e04$export$c5c7dc53d976edee),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $iufIe;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $deb5dca00817980c$export$5eaa466ae8a4d7d3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL),
        path: '/jira/ops/teams/:teamId/on-call',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    var $7tQej;
    var $doZTA;
    const $da08681b2a2ed397$export$659b7ce11c160b32 = ()=>{
        const [routeContext] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const redirectionUrl = `${routeContext.location.pathname}/on-call`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: redirectionUrl
        });
    };
    const $da08681b2a2ed397$export$772095aa22362f73 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4uLc4")), {
        moduleId: "./src/packages/eoc/on-call/src/index.tsx"
    });
    var $da08681b2a2ed397$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $da08681b2a2ed397$export$772095aa22362f73,
            pageId: "async-jira-eoc-on-call",
            shouldShowSpinner: false
        });
    const $c7dfe385c3b79acf$export$8657ca08ca5cbfc6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $deb5dca00817980c$export$5eaa466ae8a4d7d3), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $da08681b2a2ed397$export$2e2bcd8739ae039),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, (0, parcelRequire("iufIe")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $da08681b2a2ed397$export$772095aa22362f73),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $a8ba51734e8a38fd$export$18cec3860c46aaf2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL_REDIRECT),
        path: '/jira/ops/teams/:teamId',
        exact: true
    };
    const $3f27e199fbc412b1$export$ac245212b12db871 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a8ba51734e8a38fd$export$18cec3860c46aaf2), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $da08681b2a2ed397$export$659b7ce11c160b32),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ],
            isRedirect: true
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $5OcAv;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $0f11196ea10bf082$export$dbe53627482b9f0f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS),
        path: '/jira/ops/overview/teams',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $9dfc49c8c344cd92$export$c7c96cc8d6e9a8f1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("gN3Xa")).then((m)=>m.OverviewPage), {
        moduleId: "./src/packages/eoc/overview/src/ui/overview-page/index.tsx"
    });
    const $9dfc49c8c344cd92$export$9a22ecad8322834e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("veU39")).then((m)=>m.AllTeamsPage), {
        moduleId: "./src/packages/eoc/overview/src/ui/all-teams-page/index.tsx"
    });
    const $9dfc49c8c344cd92$export$b22309f0ee469d5c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9dfc49c8c344cd92$export$c7c96cc8d6e9a8f1,
            pageId: "async-jira-eoc-overview",
            shouldShowSpinner: false
        });
    const $9dfc49c8c344cd92$export$2713003ebbdbb975 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9dfc49c8c344cd92$export$9a22ecad8322834e,
            pageId: "async-jira-eoc-overview-all-teams",
            shouldShowSpinner: false
        });
    const $da84e8a7a2986788$export$842d7c81068bb64e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0f11196ea10bf082$export$dbe53627482b9f0f), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $9dfc49c8c344cd92$export$2713003ebbdbb975),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("5OcAv")).getTeamsResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                horizontal: (0, $7836a14152b01d88$export$27e50c09ebb514f),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7836a14152b01d88$export$82108adf6887e32e),
                (0, $9dfc49c8c344cd92$export$9a22ecad8322834e)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $5OcAv;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $82d2d783c671586e$export$cb929d46451a5c12 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW),
        path: '/jira/ops/overview',
        exact: true
    };
    const $df54ba0aea7ee8de$export$f1a859c727c30be4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $82d2d783c671586e$export$cb929d46451a5c12), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $9dfc49c8c344cd92$export$b22309f0ee469d5c),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("5OcAv")).getTeamsResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                horizontal: (0, $7836a14152b01d88$export$27e50c09ebb514f),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7836a14152b01d88$export$82108adf6887e32e),
                (0, $9dfc49c8c344cd92$export$c7c96cc8d6e9a8f1)
            ]
        }));
    var $j4Jjv;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $a690bc071b9eec32$export$8e6afd724de3be6e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_PERMISSIONS),
        path: '/jira/ops/teams/:teamId/settings',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $54e18f7965bed61c$export$27b4fb95241ab47 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hrn9o")), {
        moduleId: "./src/packages/eoc/member-roles/src/ui/index.tsx"
    });
    var $54e18f7965bed61c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $54e18f7965bed61c$export$27b4fb95241ab47,
            pageId: "async-jira-eoc-member-roles",
            shouldShowSpinner: false
        });
    const $b9f5341ba0d7de14$export$c2ced436a30c60dc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a690bc071b9eec32$export$8e6afd724de3be6e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $54e18f7965bed61c$export$2e2bcd8739ae039),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("j4Jjv")).pageAccessResource),
                ...(0, (0, parcelRequire("j4Jjv")).resources),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $54e18f7965bed61c$export$27b4fb95241ab47),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $f4VN0;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $5c0bbcca2f2afa78$export$eab7ea9e54b67f16 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_POLICIES),
        path: '/jira/ops/teams/:teamId/policies',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $4be02e3c520c2f73$export$3079046c31ee50f7 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("kJNlJ")), {
        moduleId: "./src/packages/eoc/policies/src/index.tsx"
    });
    const $4be02e3c520c2f73$export$882bdfb7e45bd440 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4be02e3c520c2f73$export$3079046c31ee50f7,
            pageId: "async-jira-eoc-alert-policies",
            shouldShowSpinner: false
        });
    const $1722f4808fc919d6$export$eb1e2324ca2031e2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5c0bbcca2f2afa78$export$eab7ea9e54b67f16), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $4be02e3c520c2f73$export$882bdfb7e45bd440),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("f4VN0")).resources),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $4be02e3c520c2f73$export$3079046c31ee50f7),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $f4VN0;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $a0dbfcfca37c6909$export$4eb24a8e860a3df7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_POLICIES),
        path: '/jira/settings/products/ops/policies',
        exact: true
    };
    const $26e6da78b3e43e9c$export$2ee2f43d380cc210 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a0dbfcfca37c6909$export$4eb24a8e860a3df7), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $4be02e3c520c2f73$export$882bdfb7e45bd440),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("f4VN0")).resources)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $4be02e3c520c2f73$export$3079046c31ee50f7)
            ]
        }));
    var $dY89w;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $a80c4e46a4046a66$export$e7c62a288f7d3a11 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORTS),
        path: '/jira/ops/reports',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $cba1f7031d59cee6$export$2404f0e35deca592 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5m16R")), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $cba1f7031d59cee6$export$d33ea1a773b744e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5m16R")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $cba1f7031d59cee6$export$66850ec5549adba6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5m16R")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $cba1f7031d59cee6$export$5fd77c3bbfb22cbd = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5m16R")).then((exportedMembers)=>exportedMembers.OpsReportsUnsubscribe), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $cba1f7031d59cee6$export$22253dbadb46d0cf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cba1f7031d59cee6$export$d33ea1a773b744e,
            pageId: "async-jira-eoc-ops-reports-redirect",
            shouldShowSpinner: false
        });
    const $cba1f7031d59cee6$export$648ddf2d1f8b1c3f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cba1f7031d59cee6$export$66850ec5549adba6,
            pageId: "async-jira-eoc-global-ops-reports",
            shouldShowSpinner: false
        });
    const $cba1f7031d59cee6$export$87e6a54b4f5dc91e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cba1f7031d59cee6$export$2404f0e35deca592,
            pageId: "async-jira-eoc-ops-reports",
            shouldShowSpinner: false
        });
    const $cba1f7031d59cee6$export$7f366d77015c286f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cba1f7031d59cee6$export$5fd77c3bbfb22cbd,
            pageId: "async-jira-eoc-ops-reports-unsubscribe",
            shouldShowSpinner: false
        });
    const $d53f4be60f857b27$export$193586b163d4afae = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a80c4e46a4046a66$export$e7c62a288f7d3a11), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $cba1f7031d59cee6$export$22253dbadb46d0cf),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("dY89w")).resources),
                (0, (0, parcelRequire("dY89w")).opsReportsPermissionResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039)
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cba1f7031d59cee6$export$d33ea1a773b744e),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $dY89w;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $4c6718ca5b31c262$export$2344cc35fd2eff4e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD),
        path: '/jira/ops/reports/:dashboardId',
        exact: true
    };
    const $1fb5a93b84172f00$export$90a73fe101848dd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $4c6718ca5b31c262$export$2344cc35fd2eff4e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $cba1f7031d59cee6$export$648ddf2d1f8b1c3f),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("dY89w")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cba1f7031d59cee6$export$66850ec5549adba6)
            ]
        }));
    var $dY89w;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $5b82cab429b7640d$export$c71b9e52093cd3a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS),
        path: '/jira/ops/teams/:teamId/reports',
        exact: true
    };
    const $8d76deaec1999545$export$c5606e8eeca32c0f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5b82cab429b7640d$export$c71b9e52093cd3a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $cba1f7031d59cee6$export$22253dbadb46d0cf),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, (0, parcelRequire("dY89w")).resources),
                (0, (0, parcelRequire("dY89w")).opsReportsPermissionResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cba1f7031d59cee6$export$d33ea1a773b744e),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $dY89w;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $ffd6c3cc5b5e020a$export$c9e0796615c034f3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_TEAM),
        path: '/jira/ops/teams/:teamId/reports/:dashboardId',
        exact: true
    };
    const $7f20eb6c54fad956$export$cd1c1a81e516fec5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ffd6c3cc5b5e020a$export$c9e0796615c034f3), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $cba1f7031d59cee6$export$87e6a54b4f5dc91e),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, (0, parcelRequire("dY89w")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cba1f7031d59cee6$export$2404f0e35deca592),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $491397448b2426d8$export$72cde899ee974e6e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE),
        path: '/jira/ops/reports/unsubscribe/:templateId/:subscriptionId',
        exact: true
    };
    const $a7106536ac902eff$export$6e8d112a548528b5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $491397448b2426d8$export$72cde899ee974e6e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $cba1f7031d59cee6$export$7f366d77015c286f),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cba1f7031d59cee6$export$5fd77c3bbfb22cbd)
            ]
        }));
    var $hZVks;
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $a10c7ec2c34f1c1e$export$659aa6d7cd021e4b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS_DETAIL),
        path: '/jira/settings/products/ops/role-based-notifications/:id',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $146421eacbb9e306$export$5211e5a7ed694f98 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("g8w4o")).then((module)=>module.RoleBasedNotificationDetail), {
        moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
    });
    const $146421eacbb9e306$export$445112c3a1089cc5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $146421eacbb9e306$export$5211e5a7ed694f98,
            pageId: "async-jira-eoc-role-based-notifications",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $2a321b99d1151318$export$15a244aba8f3b406 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("g8w4o")).then((module)=>module.RoleBasedNotificationsPage), {
        moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
    });
    const $2a321b99d1151318$export$8994be6f8ad6a04a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2a321b99d1151318$export$15a244aba8f3b406,
            pageId: "async-jira-eoc-role-based-notifications",
            shouldShowSpinner: false
        });
    const $29aaea7e1c593cdc$export$565325825b04cec6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a10c7ec2c34f1c1e$export$659aa6d7cd021e4b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $2a321b99d1151318$export$8994be6f8ad6a04a),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            slot: (0, $146421eacbb9e306$export$445112c3a1089cc5),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("hZVks")).resources)[0],
                (0, (0, parcelRequire("hZVks")).resources)[1],
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2a321b99d1151318$export$15a244aba8f3b406)
            ]
        }));
    var $hZVks;
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $2188ae80315aaff9$export$5a10092825ee32e4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS),
        path: '/jira/settings/products/ops/role-based-notifications',
        exact: true
    };
    const $fec308ab1c0618bc$export$60de9875bb8ef1d6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2188ae80315aaff9$export$5a10092825ee32e4), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $2a321b99d1151318$export$8994be6f8ad6a04a),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("hZVks")).resources)[0],
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2a321b99d1151318$export$15a244aba8f3b406)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $jxRF2;
    var $dmLt8;
    const $3fd272a65e76c31a$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("dmLt8")).getTimezonesResource),
        (0, (0, parcelRequire("dmLt8")).getTimeTemplatesResource),
        ...(0, (0, parcelRequire("jxRF2")).eocCommonResources)()
    ];
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $9844eccd8c34fec5$export$10454dc485142eb6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_SCHEDULES),
        path: '/jira/settings/products/ops/schedules',
        exact: true
    };
    var $5j7Th;
    var $kxZPA;
    const $8a8ca7bd84166494$var$LazyScheduleGlobalPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("e62bV")).then((m)=>m.ScheduleGlobalPage), {
        moduleId: "./src/packages/eoc/schedule-global/src/ui/index.tsx"
    });
    const $8a8ca7bd84166494$var$EocScheduleGlobalComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8a8ca7bd84166494$var$LazyScheduleGlobalPage,
            pageId: "async-jira-eoc-schedule-global",
            shouldShowSpinner: false
        });
    const $8a8ca7bd84166494$export$831e8756cdaae4ba = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9844eccd8c34fec5$export$10454dc485142eb6), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: $8a8ca7bd84166494$var$EocScheduleGlobalComponent,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, $3fd272a65e76c31a$export$bc99aaabaf7b70a7),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $8a8ca7bd84166494$var$LazyScheduleGlobalPage
            ]
        }));
    var $en1L8;
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $6dfda5a4ad42a793$export$ac102dc13a0f4aff = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS),
        path: '/jira/ops/teams/:teamId/alerts/:id',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $c4eca2f6e4b2f333$export$f4aafff31d950b6c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("d8hKi")), {
        moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
    });
    var $c4eca2f6e4b2f333$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c4eca2f6e4b2f333$export$f4aafff31d950b6c,
            pageId: "async-jira-eoc-alert-list",
            shouldShowSpinner: false
        });
    const $0f8c358fa6dbfa33$export$94aaa7006da9d63a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6dfda5a4ad42a793$export$ac102dc13a0f4aff), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $c4eca2f6e4b2f333$export$2e2bcd8739ae039),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, $400eb496bca9e6a6$export$bc99aaabaf7b70a7),
                ...(0, (0, parcelRequire("en1L8")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $c4eca2f6e4b2f333$export$f4aafff31d950b6c),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $2r8fH;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $f402982842ecbfd0$export$94efd60f23d97aa5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERTS),
        path: '/jira/ops/teams/:teamId/alerts',
        exact: true
    };
    const $f23486e21e430737$export$de37dab3b3ed8e5c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f402982842ecbfd0$export$94efd60f23d97aa5), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $c4eca2f6e4b2f333$export$2e2bcd8739ae039),
            layout: (0, $687f5bad65d17575$export$53dd27149810df73),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("2r8fH")).resources),
                ...(0, $400eb496bca9e6a6$export$bc99aaabaf7b70a7),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d15151561c6a9349$export$2e2bcd8739ae039),
                horizontal: (0, $7836a14152b01d88$export$1eb785f071697cc5),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, $7836a14152b01d88$export$409c821653bbc63b),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $c4eca2f6e4b2f333$export$f4aafff31d950b6c),
                (0, $d15151561c6a9349$export$a1b7c53ff39475a6)
            ]
        }));
    var $65Ltd;
    var $9QpK7;
    var $ibkIl;
    var $2G9Bk;
    var $bHhiy;
    var $5lsNZ;
    var $65Ltd;
    const $e73c1ac5cb6acb9d$export$678856ccddc0bc05 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD),
        path: '/jira/settings/products/ops/jira-service-management-audit-logs/download/:exportUniqueKey',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5RvQj")), {
        moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
    });
    const $ff16a0c6b99cd2b6$export$898c7cb3b28a6104 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5RvQj")).then(({ CustomerLogsDownloadPage: CustomerLogsDownloadPage })=>CustomerLogsDownloadPage), {
        moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
    });
    var $ff16a0c6b99cd2b6$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce,
            pageId: "async-jira-eoc-customer-logs",
            shouldShowSpinner: false
        });
    const $ff16a0c6b99cd2b6$export$a5786cf859b7b457 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff16a0c6b99cd2b6$export$898c7cb3b28a6104,
            pageId: "async-jira-eoc-customer-logs-download",
            shouldShowSpinner: false
        });
    const $aca15c3cadc5a7fe$export$d2ce6f09ef8aa840 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e73c1ac5cb6acb9d$export$678856ccddc0bc05), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('platform.pun.audit-logs-export-log-release_dvp2f', (0, $ff16a0c6b99cd2b6$export$a5786cf859b7b457), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, $6eed7288156ead59$export$8571305c82629fe4)
            ],
            forPaint: [
                (0, $ff16a0c6b99cd2b6$export$898c7cb3b28a6104)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $3689be50764be7f7$export$4b517044f5f7830d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS),
        path: '/jira/settings/products/ops/jira-service-management-audit-logs',
        exact: true
    };
    const $82450f458637cd82$export$42ca979ec2919b23 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3689be50764be7f7$export$4b517044f5f7830d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            component: (0, $ff16a0c6b99cd2b6$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, $6eed7288156ead59$export$bc99aaabaf7b70a7)
            ],
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $co1wz;
    var $7XYc4;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $ieJ0b;
    const $05907c872dfc2fcc$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("ieJ0b")).transitioningDetailsResource)
    ];
    var $3RJkv;
    var $5lsNZ;
    var $65Ltd;
    const $03066cf43774e262$export$30306de7e00bc5a2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_UNLOCK_OPERATIONS),
        path: '/jira/settings/products/ops/unlock',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $c4c082612871271f$export$55e4754d556d072 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("gxsQH")), {
        moduleId: "./src/packages/eoc/unlock-operations/src/index.tsx"
    });
    var $c4c082612871271f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c4c082612871271f$export$55e4754d556d072,
            pageId: "eoc-products-unlock-operations",
            shouldShowSpinner: false
        });
    const $10f9f9ad449ec307$export$c058f4d1c0667ce1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $03066cf43774e262$export$30306de7e00bc5a2), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            layout: (0, $d1122e3218429f7d$export$b8fa7ac7019001bb),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, $c4c082612871271f$export$2e2bcd8739ae039), (0, (0, parcelRequire("5lsNZ")).default)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, $05907c872dfc2fcc$export$bc99aaabaf7b70a7)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $c4c082612871271f$export$55e4754d556d072)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $vla3y;
    var $ffza4;
    var $65Ltd;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $9Nrj8;
    var $5j7Th;
    var $kxZPA;
    const $b83a8bf24279056f$export$7b03e7437c5d4f77 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ipi8d")), {
        moduleId: "./src/packages/eoc/who-is-on-call/src/ui/index.tsx"
    });
    const $b83a8bf24279056f$export$51430a0cf6ef3c09 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b83a8bf24279056f$export$7b03e7437c5d4f77,
            pageId: "async-jira-eoc-who-is-on-call",
            shouldShowSpinner: false
        });
    const $b83a8bf24279056f$export$fee33ca9661e49dd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9Nrj8")).whoIsOnCallRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
            layout: (0, $d1122e3218429f7d$export$b8fa7ac7019001bb),
            component: $b83a8bf24279056f$export$51430a0cf6ef3c09,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("vla3y")).resources)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $b83a8bf24279056f$export$7b03e7437c5d4f77
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $5lsNZ;
    var $65Ltd;
    const $24256311e2794309$export$465fa01c0f3a0551 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ERRORS_NOT_FOUND),
        path: '/jira/:projectType(software|servicedesk|core)'
    };
    const $083d2dc437d8c2ec$export$c4c012a49b465e94 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $24256311e2794309$export$465fa01c0f3a0551), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ERRORS),
            component: (0, (0, parcelRequire("5lsNZ")).default),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("5lsNZ")).LazyNotFoundErrorPage)
            ]
        }));
    var $ffza4;
    var $gyYxw;
    var $2BrOV;
    var $ibkIl;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $iFaFr;
    var $hBv66;
    var $iHiHz;
    var $78U7j;
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $8fc6117fdc2ce1b9$var$LazyPersonalSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("2zQ5k")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/personal-settings/src/index.tsx"
    });
    const $8fc6117fdc2ce1b9$var$PersonalSettingsSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "personalSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8fc6117fdc2ce1b9$var$LazyPersonalSettingsSidebar, null));
    var $8fc6117fdc2ce1b9$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($8fc6117fdc2ce1b9$var$PersonalSettingsSidebar);
    var $h0bZU;
    var $2G9Bk;
    var $aPfsS;
    var $lNicp;
    var $bHhiy;
    var $2YqLE;
    var $atU1t;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    var $65Ltd;
    const $cc2d93b85ec603e1$export$157f97e6454c2a9f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_ADMIN),
        path: '/jira/settings/apps/:appId/:envId/:route?'
    };
    var $65Ltd;
    const $48618cc01d3d4f81$export$392534a80a0b9b11 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_ADMIN_SETTINGS),
        path: '/jira/settings/apps/:settingsType(configure|get-started)/:appId/:envId/:route?'
    };
    var $65Ltd;
    const $5ea48a875d63d03b$export$2ee4468dd8e9636f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION),
        path: '/jira/settings/issues/field/:fieldId/context/:contextId/configure/app'
    };
    var $65Ltd;
    const $7d160aadc36293c5$export$4146dba061d1c72d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_GLOBAL),
        path: '/jira/apps/:appId/:envId/:route?'
    };
    var $65Ltd;
    const $911d3aa14cf2fd85$export$8cf022892f01dc88 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PERSONAL_SETTINGS),
        path: '/jira/settings/personal/apps/:appId/:envId/:route?'
    };
    var $65Ltd;
    const $d3c18f0b3608cdac$export$998d01fc8f4c3224 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT),
        path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/apps/:appId/:envId/:route?'
    };
    var $65Ltd;
    const $019035708a3fcd5d$export$b77275b989ab42a6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE),
        path: '/jira/servicedesk/projects/:projectKey/queues/apps/:appId/:envId/:route?'
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $bef31a55bb1643fb$export$66ee65dcd4a6458d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5bXwS")), {
        moduleId: "./src/packages/spa-apps/forge/admin/src/index.tsx"
    });
    const $bef31a55bb1643fb$export$c9e5f500ef472147 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bef31a55bb1643fb$export$66ee65dcd4a6458d,
            pageId: "forge-spa-admin",
            shouldShowSpinner: true
        });
    var $bef31a55bb1643fb$export$2e2bcd8739ae039 = $bef31a55bb1643fb$export$c9e5f500ef472147;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $b96b1546635e7c38$export$c53e206c7fd6fb76 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("32VdM")), {
        moduleId: "./src/packages/spa-apps/forge/field-contextual-config/src/index.tsx"
    });
    const $b96b1546635e7c38$export$50bd0baee0b2f946 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b96b1546635e7c38$export$c53e206c7fd6fb76,
            pageId: "forge-spa-field-context-config",
            shouldShowSpinner: true
        });
    var $b96b1546635e7c38$export$2e2bcd8739ae039 = $b96b1546635e7c38$export$50bd0baee0b2f946;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $8f6029962fb4c5dc$export$332293feb5cffd72 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("98CQn")), {
        moduleId: "./src/packages/spa-apps/forge/global/src/index.tsx"
    });
    const $8f6029962fb4c5dc$export$4c36a7b018e5e5cc = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8f6029962fb4c5dc$export$332293feb5cffd72,
            pageId: "forge-spa-global",
            shouldShowSpinner: true
        });
    var $8f6029962fb4c5dc$export$2e2bcd8739ae039 = $8f6029962fb4c5dc$export$4c36a7b018e5e5cc;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $407ba70330fa3fc8$export$984c6340ff981792 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("65N9E")), {
        moduleId: "./src/packages/spa-apps/forge/personal-settings/src/index.tsx"
    });
    const $407ba70330fa3fc8$export$fb659fde7fa91075 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $407ba70330fa3fc8$export$984c6340ff981792,
            pageId: "forge-spa-personal-settings",
            shouldShowSpinner: true
        });
    var $407ba70330fa3fc8$export$2e2bcd8739ae039 = $407ba70330fa3fc8$export$fb659fde7fa91075;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $495262f31d81d9db$export$27b0c9e982208d7e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9ORLZ")), {
        moduleId: "./src/packages/spa-apps/forge/project/src/index.tsx"
    });
    const $495262f31d81d9db$export$99737a64be9f5f1 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $495262f31d81d9db$export$27b0c9e982208d7e,
            pageId: "forge-spa-project",
            shouldShowSpinner: true
        });
    var $495262f31d81d9db$export$2e2bcd8739ae039 = $495262f31d81d9db$export$99737a64be9f5f1;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $ebb310d709581894$export$62e1bcb9c27c99b5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("74XPL")), {
        moduleId: "./src/packages/spa-apps/forge/servicedesk-queue/src/index.tsx"
    });
    const $ebb310d709581894$export$e83b7c5b466e791a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ebb310d709581894$export$62e1bcb9c27c99b5,
            pageId: "forge-spa-servicedesk-queue",
            shouldShowSpinner: true
        });
    var $ebb310d709581894$export$2e2bcd8739ae039 = $ebb310d709581894$export$e83b7c5b466e791a;
    const $a901f652fe0a27d8$export$fc82fa1ad8302441 = ()=>({
            component: (0, $bef31a55bb1643fb$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $bef31a55bb1643fb$export$66ee65dcd4a6458d)
            ]
        });
    const $a901f652fe0a27d8$export$1c55fbe0ae1da308 = ()=>({
            component: (0, $495262f31d81d9db$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSharedNavigationSingleResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $495262f31d81d9db$export$27b0c9e982208d7e)
            ]
        });
    const $a901f652fe0a27d8$export$95c93c3fcfde8901 = ()=>({
            component: (0, $b96b1546635e7c38$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("5bkvv")).forgeCustomFieldTypeResource),
                (0, (0, parcelRequire("2YqLE")).fieldContextConfigPageResource),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b96b1546635e7c38$export$c53e206c7fd6fb76)
            ]
        });
    const $a901f652fe0a27d8$export$a2f53aa48e785c7 = ()=>({
            component: (0, $ebb310d709581894$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ebb310d709581894$export$62e1bcb9c27c99b5)
            ]
        });
    const $a901f652fe0a27d8$export$dbdc27694c56b868 = ()=>({
            component: (0, $8f6029962fb4c5dc$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)(),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iFaFr")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationForgeGlobalPageResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $8f6029962fb4c5dc$export$332293feb5cffd72)
            ]
        });
    const $a901f652fe0a27d8$export$652c32d9980f22f8 = ()=>({
            component: (0, $407ba70330fa3fc8$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROFILE,
                sidebar: (0, $8fc6117fdc2ce1b9$export$2e2bcd8739ae039)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationForgePersonalSettingsPageResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $407ba70330fa3fc8$export$984c6340ff981792)
            ]
        });
    const $a901f652fe0a27d8$export$b1d92ac5cda62e7e = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $48618cc01d3d4f81$export$392534a80a0b9b11), ()=>$a901f652fe0a27d8$export$fc82fa1ad8302441()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cc2d93b85ec603e1$export$157f97e6454c2a9f), ()=>$a901f652fe0a27d8$export$fc82fa1ad8302441()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d3c18f0b3608cdac$export$998d01fc8f4c3224), ()=>$a901f652fe0a27d8$export$1c55fbe0ae1da308()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $019035708a3fcd5d$export$b77275b989ab42a6), ()=>$a901f652fe0a27d8$export$a2f53aa48e785c7()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5ea48a875d63d03b$export$2ee4468dd8e9636f), ()=>$a901f652fe0a27d8$export$95c93c3fcfde8901()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7d160aadc36293c5$export$4146dba061d1c72d), ()=>$a901f652fe0a27d8$export$dbdc27694c56b868()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $911d3aa14cf2fd85$export$8cf022892f01dc88), ()=>$a901f652fe0a27d8$export$652c32d9980f22f8())
    ];
    var $ffza4;
    var $65Ltd;
    var $bwLf9;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $b88e0402aff618ba$export$e69b84daf70501b3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_MAIL_SETTINGS),
        path: '/secure/admin/global-mail-settings',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $cb25w;
    var $dMnMc;
    var $dJl1T;
    var $34Vv8;
    var $j8DrX;
    var $8zOmE;
    var $1bQGJ;
    var $7VHMR;
    const $1d710f8117ed7a9a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "redirect.legacy-routing.flags.error.title",
            "defaultMessage": "We can't find the page you're looking for"
        },
        description: {
            "id": "redirect.legacy-routing.flags.error.description",
            "defaultMessage": "Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content."
        },
        goHome: {
            "id": "redirect.legacy-routing.flags.error.go-home",
            "defaultMessage": "Go to the homepage"
        }
    });
    const $d8474afc40da2ee0$export$b9a7f1ebeaa76953 = ()=>({
            type: 'error',
            title: (0, $1d710f8117ed7a9a$export$defe85febe8b728c).title,
            description: (0, $1d710f8117ed7a9a$export$defe85febe8b728c).description,
            actions: [
                {
                    content: (0, $1d710f8117ed7a9a$export$defe85febe8b728c).goHome,
                    onClick: ()=>window.location.assign('/')
                }
            ]
        });
    const $1513009dd97e8af4$var$THRESHOLD = 30000;
    const $1513009dd97e8af4$var$getScopeType = (scope)=>{
        switch(scope.identifierType){
            case 'boardId':
                return 'board';
            case 'projectId':
            case 'projectKey':
                return scope.pageType === 'settings' ? 'projectSettings' : 'project';
            default:
                return '';
        }
    };
    class $1513009dd97e8af4$export$836fe1ef2cfde075 extends (0, $5uXOq.Component) {
        componentDidMount() {
            (0, (0, parcelRequire("gKZoD")).di)(sessionStorage, window);
            const { location: { pathname: pathname, search: search }, flagService: flagService, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const redirectPathname = pathname.startsWith('//') ? pathname.substr(1) : pathname;
            const lastRedirectTime = Number(sessionStorage.getItem(redirectPathname));
            if (!lastRedirectTime) sessionStorage.setItem(redirectPathname, Date.now().toString());
            else if (Date.now() - lastRedirectTime < $1513009dd97e8af4$var$THRESHOLD) {
                const scopeData = (0, (0, parcelRequire("dMnMc")).default)(window.location.href, (0, (0, parcelRequire("j8DrX")).default));
                const scope = $1513009dd97e8af4$var$getScopeType(scopeData);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('redirect-loop.error', 'Redirect error caused by invalid url', {
                    scope: scope
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
                    action: 'entered'
                }), 'redirect-loop entered', 'endeavour.spa.redirect-loop', {
                    scope: scope
                });
                flagService.showFlag((0, $d8474afc40da2ee0$export$b9a7f1ebeaa76953)());
                sessionStorage.removeItem(redirectPathname);
                return;
            } else sessionStorage.removeItem(redirectPathname);
            window.location.assign(redirectPathname + search);
        }
        render() {
            return null;
        }
    }
    var $1513009dd97e8af4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("1bQGJ")).withRouter)((0, (0, parcelRequire("34Vv8")).default)((0, (0, parcelRequire("cb25w")).default)()($1513009dd97e8af4$export$836fe1ef2cfde075)));
    var $1a0afe23818eb6ed$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $1513009dd97e8af4$export$2e2bcd8739ae039), null);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $cc4123579e370fa7$export$a133d90b2004a90e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("leonD"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/global-mail-settings/src/index.tsx"
    });
    var $cc4123579e370fa7$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cc4123579e370fa7$export$a133d90b2004a90e,
            pageId: "global-mail-settings",
            shouldShowSpinner: false
        });
    const $fc43fd37745c00e2$export$5e1236665a530df4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b88e0402aff618ba$export$e69b84daf70501b3), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.global-mail-settings',
            component: (0, (0, parcelRequire("bwLf9")).default)(()=>true, (0, $cc4123579e370fa7$export$2e2bcd8739ae039), (0, $1a0afe23818eb6ed$export$2e2bcd8739ae039)),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cc4123579e370fa7$export$a133d90b2004a90e)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $cpdjw;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $a19ed616896ad98a$export$45e7d93edcc9507f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS),
        path: '/secure/admin/ViewCustomFields(!default)?.jspa'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0183f6c188d0635c$export$55a5c16f39a046af = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kI1WL"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/custom-fields-directory/src/index.tsx"
    });
    var $0183f6c188d0635c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0183f6c188d0635c$export$55a5c16f39a046af,
            pageId: "admin-pages-custom-fields-directory",
            shouldShowSpinner: true
        });
    const $8b3a43559c4bd90e$export$d83c2e469d070766 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a19ed616896ad98a$export$45e7d93edcc9507f), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.custom-fields-directory',
            component: (0, $0183f6c188d0635c$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("cpdjw")).customFieldsDirectoryResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $0183f6c188d0635c$export$55a5c16f39a046af)
            ]
        }));
    var $427L2;
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $fc7d4480067c689f$export$2eaffde3ad991b33 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HOME_ONBOARDING_REDIRECT),
        path: '/jira/your-work-onboarding',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5oFIy;
    var $lVJAU;
    const $ff7a191a114ce3ba$var$JiraHomeOnboardingRedirect = ()=>{
        const { replace: replace } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        replace('/jira/your-work');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
            eventName: "JiraHomeOnboardingRedirect loaded",
            componentName: "JiraHomeOnboardingRedirect",
            attributes: {
                isRedirectionEnabled: true
            }
        });
    };
    var $ff7a191a114ce3ba$export$2e2bcd8739ae039 = $ff7a191a114ce3ba$var$JiraHomeOnboardingRedirect;
    const $5e597886ba168534$export$2740cfaa979353b9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fc7d4480067c689f$export$2eaffde3ad991b33), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HOME),
            component: (0, $ff7a191a114ce3ba$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            isRedirect: true,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $d39d4562915d89ec$export$f7a252c9d61f8f94 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HOME_REDIRECT),
        path: '/jira',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $dJl1T;
    var $9vlEn;
    var $7tQej;
    var $2YP9W;
    const $2791311ae97b7f0a$export$25a759e49d5049db = 'spa-apps.common.redirect.jira-base-routing';
    const $e5a49877dbf7e167$var$JiraBaseRedirectWrapper = ()=>{
        (0, (0, parcelRequire("gKZoD")).di)(window);
        const { data: data, loading: loading } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("9vlEn")).userHomepageResource));
        (0, $5uXOq.useEffect)(()=>{
            if (!loading && data == null) (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData((0, $2791311ae97b7f0a$export$25a759e49d5049db), 'userHomepage data is null');
        }, [
            loading,
            data
        ]);
        if (loading) return null;
        if (data == null) {
            window.location.replace('/jira');
            return null;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: data.homepagePreference
        });
    };
    var $e5a49877dbf7e167$export$2e2bcd8739ae039 = $e5a49877dbf7e167$var$JiraBaseRedirectWrapper;
    var $92d7d72ca8393409$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $e5a49877dbf7e167$export$2e2bcd8739ae039), null);
    const $f8b2ddb194f05043$export$5379c026da4201e6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d39d4562915d89ec$export$f7a252c9d61f8f94), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HOME),
            component: (0, $92d7d72ca8393409$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            isRedirect: true,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $2G9Bk;
    var $2Ql51;
    var $65Ltd;
    const $fcce99f65e838928$export$c155f4de16b62110 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE_CREATE_EMBED),
        path: '/jira/issues/create/embed'
    };
    var $9NiTW;
    var $5j7Th;
    var $kxZPA;
    const $f0855c0baf74da48$var$handleEmbedLinkClick = (e)=>{
        const eventTarget = e.target;
        if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') eventTarget.target = '_blank';
    };
    const $f0855c0baf74da48$export$980ea815ec2d0180 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jacYd")), {
        ssr: false,
        moduleId: "./src/packages/issue-create/issue-create-embed/src/index.tsx"
    });
    const $f0855c0baf74da48$export$87fa8eff34eb030a = ()=>{
        (0, $5uXOq.useEffect)(()=>{
            window.addEventListener('click', $f0855c0baf74da48$var$handleEmbedLinkClick, true);
            return ()=>{
                window.removeEventListener('click', $f0855c0baf74da48$var$handleEmbedLinkClick);
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f0855c0baf74da48$export$980ea815ec2d0180,
            pageId: "spa-apps/issue-create-embed",
            shouldShowSpinner: true
        }));
    };
    const $f0855c0baf74da48$export$abd0bbe95839baf7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fcce99f65e838928$export$c155f4de16b62110), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE),
            component: $f0855c0baf74da48$export$87fa8eff34eb030a,
            resources: [
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            forPaint: [
                $f0855c0baf74da48$export$980ea815ec2d0180
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2vSU6;
    var $65Ltd;
    var $4R6GH;
    var $gyYxw;
    var $1FeCu;
    var $7DqiA;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $93Yeu;
    var $dAfqg;
    var $2G9Bk;
    var $aPfsS;
    var $lNicp;
    var $bHhiy;
    var $8ZUng;
    var $5CPDv;
    var $9XjL6;
    var $lCj8l;
    var $2M1hQ;
    var $5XgeZ;
    const $2368cab4ab12a1eb$export$3b5744f70b49a5c4 = (0, (0, parcelRequire("2M1hQ")).createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_MEDIA_READ_PERM',
        getKey: ({ match: match })=>match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : '',
        getData: ()=>null,
        isBrowserOnly: true
    }));
    var $2Yhep;
    var $2M1hQ;
    var $5XgeZ;
    const $018bbab5966993b0$export$80c2a5c658bd9e1e = (0, (0, parcelRequire("2M1hQ")).createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_MEDIA_UPLOAD_PERM',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: ()=>null,
        isBrowserOnly: true
    }));
    var $2Yhep;
    var $2M1hQ;
    var $5XgeZ;
    const $c6e148d80f21d036$export$48db4eb29e9be72c = (0, (0, parcelRequire("2M1hQ")).createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_MEDIA_USER_AUTH',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: ()=>null,
        isBrowserOnly: true
    }));
    var $3RJkv;
    var $2M1hQ;
    const $2e493fb3532188a0$export$23978b67a6b2068f = 'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';
    const $3095ecb31c5b9ef2$var$getDataLoader = ()=>(parcelRequire("hPMz6"));
    const $3095ecb31c5b9ef2$export$ec991c565cf31550 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $2e493fb3532188a0$export$23978b67a6b2068f),
        getKey: ()=>'state',
        getDataLoader: $3095ecb31c5b9ef2$var$getDataLoader,
        maxAge: 1800000
    });
    const $3095ecb31c5b9ef2$export$d08a9fee651d30b2 = ()=>[];
    var $dxCvy;
    var $1WlLE;
    var $7GnDe;
    var $2Ql51;
    var $gNStA;
    var $65Ltd;
    const $1c5f13cdd9ba8bf4$export$240aeec71c480594 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE_EMBED),
        path: '/browse/:issueKey(\\w+-\\d+)/embed'
    };
    var $fw7Rx;
    var $gRzZD;
    var $lb0Dk;
    var $lGGIs;
    var $5j7Th;
    var $kxZPA;
    var $7tQej;
    var $bmKPg;
    const $6799e9dd8b372fc2$var$pageId = 'spa-issue';
    const $6799e9dd8b372fc2$var$conditionalSmartRepliesOptInStatusResources = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('smart_replies_m1_jira_labs'), (0, (0, parcelRequire("1FeCu")).smartRepliesOptInStatusResources));
    const $6799e9dd8b372fc2$var$getUnusedRouteResources = ()=>(0, (0, parcelRequire("4R6GH")).fg)('issue_view_remove_unused_route_resources') ? [] : [
            (0, $c6e148d80f21d036$export$48db4eb29e9be72c),
            (0, $2368cab4ab12a1eb$export$3b5744f70b49a5c4),
            (0, $018bbab5966993b0$export$80c2a5c658bd9e1e)
        ];
    const $6799e9dd8b372fc2$var$LazyIssuePage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("lGGIs")).markAsBentoBundleReady)((parcelRequire("zLcoH"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
    });
    const $6799e9dd8b372fc2$export$c1a868ace2f38803 = ()=>{
        const { data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const [issueKey] = (0, (0, parcelRequire("bmKPg")).usePathParam)('issueKey');
        const [projectKey, issueSuffix] = issueKey !== undefined ? issueKey.split('-') : [];
        let actualIssueKey = issueKey;
        if (data?.projectKey && data.projectKey !== projectKey) actualIssueKey = `${data.projectKey}-${issueSuffix}`;
        if (!false && data?.projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT) && data?.projectKey !== undefined && actualIssueKey !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/jira/polaris/projects/${data.projectKey}/ideas?selectedIssue=${actualIssueKey}`
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6799e9dd8b372fc2$var$LazyIssuePage,
            pageId: $6799e9dd8b372fc2$var$pageId,
            shouldShowSpinner: false
        });
    };
    const $6799e9dd8b372fc2$export$ef02bcc0eb1d9ded = ()=>{
        const [issueKey] = (0, (0, parcelRequire("bmKPg")).usePathParam)('issueKey');
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey || '');
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        const projectId = (0, (0, parcelRequire("93Yeu")).useProjectId)(projectKey);
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT) && projectKey !== undefined && projectId !== undefined && issueKey !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/secure/JiraProductDiscoveryEmbedded.jspa?projectId=${projectId}&projectKey=${projectKey}&issueKey=${issueKey}`
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7DqiA")).EmbedModeProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement($6799e9dd8b372fc2$export$c1a868ace2f38803, null));
    };
    const $6799e9dd8b372fc2$export$cef770e7c16cfcc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fw7Rx")).browseIssueRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE),
            shouldOptOutConcurrentMode: (0, (0, parcelRequire("4R6GH")).fg)('jira-concurrent-incremental'),
            preloadOptions: {
                earlyChunks: [
                    'issue-app-early-entry'
                ]
            },
            earlyAssets: (0, $f36666704bcc2bab$export$137d6d169f402a59),
            component: $6799e9dd8b372fc2$export$c1a868ace2f38803,
            skeleton: (0, (0, parcelRequire("lb0Dk")).IssueViewSkeleton),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, $59d96d961d806fee$export$98e337c40eb151da)),
            navigation: {
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3Only),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResourceOnNav3Only),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
                ...(0, $3095ecb31c5b9ef2$export$d08a9fee651d30b2)(),
                ...$6799e9dd8b372fc2$var$getUnusedRouteResources(),
                (0, (0, parcelRequire("9XjL6")).issueGiraDataResource),
                (0, (0, parcelRequire("lCj8l")).issueGiraNonCriticalDataResource),
                (0, (0, parcelRequire("5CPDv")).issueForgeDataResource),
                (0, (0, parcelRequire("8ZUng")).issueViewRelayResource),
                (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
                (0, (0, parcelRequire("gRzZD")).workspaceResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                $6799e9dd8b372fc2$var$conditionalSmartRepliesOptInStatusResources
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $6799e9dd8b372fc2$var$LazyIssuePage
            ],
            ufoName: 'issue-view',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$ef94a84e2990361c)
            },
            bifrost: {
                bundling: {
                    packageName: '@atlassian/jira-router-routes-issue-entries',
                    whichExportToUse: 'browseIssueRouteEntry'
                },
                enabled: true
            }
        }));
    const $6799e9dd8b372fc2$export$e275b3ca0c6ccb5e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1c5f13cdd9ba8bf4$export$240aeec71c480594), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE),
            shouldOptOutConcurrentMode: (0, (0, parcelRequire("4R6GH")).fg)('jira-concurrent-incremental'),
            preloadOptions: {
                earlyChunks: [
                    'issue-app-early-entry'
                ]
            },
            earlyAssets: (0, $f36666704bcc2bab$export$137d6d169f402a59),
            component: $6799e9dd8b372fc2$export$ef02bcc0eb1d9ded,
            skeleton: (0, (0, parcelRequire("lb0Dk")).IssueViewSkeleton),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getModernIssueTransitionResources)(),
                ...$6799e9dd8b372fc2$var$getUnusedRouteResources(),
                (0, (0, parcelRequire("9XjL6")).issueGiraDataResource),
                (0, (0, parcelRequire("lCj8l")).issueGiraNonCriticalDataResource),
                (0, (0, parcelRequire("5CPDv")).issueForgeDataResource),
                (0, (0, parcelRequire("8ZUng")).issueViewRelayResource),
                (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
                (0, (0, parcelRequire("gRzZD")).workspaceResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
                $6799e9dd8b372fc2$var$conditionalSmartRepliesOptInStatusResources
            ],
            forPaint: [
                $6799e9dd8b372fc2$var$LazyIssuePage
            ],
            ufoName: 'issue-view-embed',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$ef94a84e2990361c)
            },
            bifrost: {
                bundling: {
                    packageName: '@atlassian/jira-router-routes-issue-entries',
                    whichExportToUse: 'browseIssueEmbedRouteEntry'
                },
                enabled: true
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $2BrOV;
    var $lmyls;
    var $hBv66;
    var $2G9Bk;
    var $aPfsS;
    var $bHhiy;
    var $65Ltd;
    const $2ca0ba87b3cf3506$export$34695dccebecc6bc = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT),
        path: '/browse/:issueKey?',
        query: [
            'jql|filter'
        ]
    };
    var $65Ltd;
    const $2de97b1bab3baedd$export$126b16ec65343bf = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        path: '/projects/:projectKey/issues/:issueKey?'
    };
    var $1gXMV;
    var $lHYIV;
    var $4R6GH;
    var $lmyls;
    var $96w9D;
    var $8Wi6S;
    var $8CVvd;
    var $bATyw;
    var $89kiv;
    var $atU1t;
    var $3RJkv;
    var $gNStA;
    const $797f27ab9ceb3235$export$2f31f4f387017d83 = ()=>({
            menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS,
            sidebar: (0, (0, parcelRequire("8Wi6S")).AsyncSidebarFiltersGlobal)
        });
    const $797f27ab9ceb3235$export$343e92405307cf8d = ()=>[
            (0, (0, parcelRequire("89kiv")).issueNavigatorRelayResource),
            (0, (0, parcelRequire("89kiv")).issueNavigatorFilterRelayResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('nin_request_hydrate_query_earlier'), (0, (0, parcelRequire("89kiv")).issueNavigatorHydrationRelayResource)),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
            (0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("8CVvd")).getWillShowNav3), (0, (0, parcelRequire("96w9D")).sidebarFiltersGlobalResource))
        ];
    var $4R6GH;
    var $5bkvv;
    var $8uKLe;
    var $1b36n;
    var $a3OKn;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $bATyw;
    var $89kiv;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $gNStA;
    const $c7c9a307c1aca60f$export$6236a7417086ea8d = ()=>[
            (0, (0, parcelRequire("89kiv")).issueNavigatorRelayResource),
            (0, (0, parcelRequire("89kiv")).issueNavigatorFilterRelayResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('nin_request_hydrate_query_earlier'), (0, (0, parcelRequire("89kiv")).issueNavigatorHydrationRelayResource)),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
            (0, (0, parcelRequire("a3OKn")).sidebarProjectIssuesResource),
            (0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource),
            (0, (0, parcelRequire("1b36n")).staticSidebarDefaultPINFiltersResource)
        ];
    var $e4eHl = parcelRequire("e4eHl");
    var $65Ltd;
    const $906089a3c28fb671$export$919daad019702595 = {
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: {
                id: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
                packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR)),
                teamName: 'empanada'
            }
        }
    };
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $65Ltd;
    const $48312ac1f46800b4$export$2dfbbe89ed354013 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        path: '/jira/issues/:issueKey?'
    };
    var $1gXMV;
    var $5uXOq = parcelRequire("5uXOq");
    var $1kQCU;
    var $VILOn;
    var $7SHTM;
    var $1gXMV;
    var $7yO8g;
    var $5j7Th;
    var $cZpsT;
    var $kxZPA;
    var $138ed00c0e48b315$export$2e2bcd8739ae039 = ({ params: params }, { filter: filter, orderby: orderby, keyword: keyword })=>{
        const { projectKey: projectKey, issueKey: issueKey } = params;
        const pageIdPrefix = 'new-issue-navigator';
        let pageId = '';
        try {
            pageId = `${pageIdPrefix}${(projectKey !== null && projectKey !== undefined ? `-${projectKey}` : '') + (issueKey !== null && issueKey !== undefined ? `-${issueKey}` : '') + (filter !== undefined ? `-${filter}` : '') + (orderby !== undefined ? `-${orderby}` : '') + (keyword !== undefined ? `-${keyword}` : '')}`;
        } catch  {
            pageId = pageIdPrefix;
        }
        return pageId;
    };
    const $b7591135658477a3$export$5fcc10c40c224fbc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1UnUc")).then((module)=>module.ProjectIssueNavigatorSPA)), {
        moduleId: "./src/packages/spa-apps/project-issue-navigator/src/index.tsx"
    });
    const $b7591135658477a3$export$2de79bdf33dbf27c = ({ match: match, query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b7591135658477a3$export$5fcc10c40c224fbc,
            pageId: (0, $138ed00c0e48b315$export$2e2bcd8739ae039)(match, query),
            shouldShowSpinner: false
        });
    const $b7591135658477a3$export$8570b543078b8f17 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1UnUc")).then((module)=>module.ServiceDeskProjectIssueNavigatorSPA)), {
        moduleId: "./src/packages/spa-apps/project-issue-navigator/src/index.tsx"
    });
    const $b7591135658477a3$export$5cc1791bbdb6f266 = ({ match: match, query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b7591135658477a3$export$8570b543078b8f17,
            pageId: (0, $138ed00c0e48b315$export$2e2bcd8739ae039)(match, query),
            shouldShowSpinner: false
        });
    const $b7591135658477a3$export$8ff267588532c2ce = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("90rvf")), {
        moduleId: "./src/packages/spa-apps/global-issue-navigator/src/index.tsx"
    });
    const $b7591135658477a3$export$4bd5bc3fa8a52567 = ({ match: match, query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b7591135658477a3$export$8ff267588532c2ce,
            pageId: (0, $138ed00c0e48b315$export$2e2bcd8739ae039)(match, query),
            shouldShowSpinner: false
        });
    const $b7591135658477a3$export$3b4f172f4310bbc = (props)=>{
        const [isNinGlobalScopeEnrolmentEnabled, resourceData] = (0, (0, parcelRequire("1kQCU")).useGlobalScopeEnrolmentEnable)();
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        (0, $5uXOq.useEffect)(()=>{
            if (resourceData !== null && resourceData !== undefined) (0, (0, parcelRequire("VILOn")).setIsGlobalScopeEnrolmentEnabledInLocalStorage)(resourceData);
        }, [
            resourceData
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isNinGlobalScopeEnrolmentEnabled === false) window.location.reload();
        }, [
            isNinGlobalScopeEnrolmentEnabled
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isNinGlobalScopeEnrolmentEnabled) {
                const globalGINFlagDisabled = (0, (0, parcelRequire("VILOn")).getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage)();
                if (globalGINFlagDisabled !== false) {
                    !isAnonymous && (0, (0, parcelRequire("7SHTM")).resetGlobalScopeForcedOptOutGinFlag)();
                    (0, (0, parcelRequire("VILOn")).setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage)();
                }
            }
        }, [
            isAnonymous,
            isNinGlobalScopeEnrolmentEnabled
        ]);
        return isNinGlobalScopeEnrolmentEnabled === true ? (0, ($parcel$interopDefault($5uXOq))).createElement($b7591135658477a3$export$4bd5bc3fa8a52567, props) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gXMV")).GlobalIssueNavigatorSkeleton), null);
    };
    const $a09e1f9770441a11$export$8925c79a030fdfe8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $48312ac1f46800b4$export$2dfbbe89ed354013), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
            ...(0, $906089a3c28fb671$export$919daad019702595),
            component: (0, $b7591135658477a3$export$3b4f172f4310bbc),
            skeleton: (0, (0, parcelRequire("1gXMV")).GlobalIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b7591135658477a3$export$8ff267588532c2ce)
            ],
            ufoName: 'global-issue-navigator-jfe',
            navigation: (0, $797f27ab9ceb3235$export$2f31f4f387017d83)(),
            resources: [
                ...(0, $797f27ab9ceb3235$export$343e92405307cf8d)()
            ],
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $65Ltd;
    const $24353129a3689ea4$export$f4c8e8bc55cd2008 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        path: '/issues/:issueKey?'
    };
    var $1gXMV;
    const $25e6f63d1902d36e$export$3e58fe44312b4093 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $24353129a3689ea4$export$f4c8e8bc55cd2008), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
            ...(0, $906089a3c28fb671$export$919daad019702595),
            component: (0, $b7591135658477a3$export$3b4f172f4310bbc),
            skeleton: (0, (0, parcelRequire("1gXMV")).GlobalIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b7591135658477a3$export$8ff267588532c2ce)
            ],
            ufoName: 'global-issue-navigator-jfe',
            navigation: (0, $797f27ab9ceb3235$export$2f31f4f387017d83)(),
            resources: [
                ...(0, $797f27ab9ceb3235$export$343e92405307cf8d)()
            ],
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
    var $ffza4;
    var $l71WK;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $dmKXV;
    var $2G9Bk;
    var $aPfsS;
    var $65Ltd;
    const $094c8b06738a5fa3$export$e961cccd2405cdd0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
        path: '/jira/core/projects/:projectKey/issues/:issueKey?'
    };
    var $lHYIV;
    const $99398975b82221bf$export$ce258b07e4b7eb8c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $094c8b06738a5fa3$export$e961cccd2405cdd0), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
            ...(0, $906089a3c28fb671$export$919daad019702595),
            component: (0, $b7591135658477a3$export$2de79bdf33dbf27c),
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b7591135658477a3$export$5fcc10c40c224fbc)
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: [
                ...(0, $c7c9a307c1aca60f$export$6236a7417086ea8d)()
            ],
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)((0, (0, parcelRequire("gyYxw")).genericProjectLayout))
        }));
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $9s3j1;
    var $2G9Bk;
    var $aPfsS;
    var $65Ltd;
    const $d2fcf6847b972a2c$export$fa71d22b1c44463b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/issues/:issueKey?'
    };
    var $lHYIV;
    var $5PD5h;
    const $41789f7b84696902$export$88d5f4117ce3d0fb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d2fcf6847b972a2c$export$fa71d22b1c44463b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
            ...(0, $906089a3c28fb671$export$919daad019702595),
            component: (0, $b7591135658477a3$export$2de79bdf33dbf27c),
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b7591135658477a3$export$5fcc10c40c224fbc)
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, $c7c9a307c1aca60f$export$6236a7417086ea8d)()
            ],
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)((0, (0, parcelRequire("gyYxw")).genericProjectLayout))
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $1WlLE;
    var $QbgwQ;
    var $6Z2mh;
    var $lHYIV;
    const $20147c9440522c21$export$b779296ccb8ca1a8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("QbgwQ")).servicedeskIssuesRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
            ...(0, $906089a3c28fb671$export$919daad019702595),
            component: (0, $b7591135658477a3$export$5cc1791bbdb6f266),
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b7591135658477a3$export$8570b543078b8f17)
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, $c7c9a307c1aca60f$export$6236a7417086ea8d)(),
                (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout)
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $koWFd;
    var $2G9Bk;
    var $aPfsS;
    var $65Ltd;
    const $2a8659deda7b2016$export$ccfb6c4a189316bc = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
        path: '/jira/software/projects/:projectKey/issues/:issueKey?'
    };
    var $lHYIV;
    var $5PD5h;
    var $e7bC3;
    const $a82ae7782e05cd6a$export$2a50f64378877c9d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2a8659deda7b2016$export$ccfb6c4a189316bc), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
            ...(0, $906089a3c28fb671$export$919daad019702595),
            component: (0, $b7591135658477a3$export$2de79bdf33dbf27c),
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b7591135658477a3$export$5fcc10c40c224fbc)
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, $c7c9a307c1aca60f$export$6236a7417086ea8d)()
            ],
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)((0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding))
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $doZTA;
    var $265d2c27687434ef$export$2e2bcd8739ae039 = ()=>{
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const issueKey = match.params.issueKey ?? '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/issues/${issueKey}`
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $jcw0u;
    var $iXVV6;
    var $5oFIy;
    var $dxCvy;
    var $7tQej;
    var $2YP9W;
    var $doZTA;
    var $e5b5921263d4891a$export$2e2bcd8739ae039 = ()=>{
        const [{ match: match, query: query }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, error: error, loading: loading } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        (0, $5uXOq.useEffect)(()=>{
            if (error) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'useResourceProjectContext',
                    packageName: 'jiraRouterRoutesIssueNavigatorEntries'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            error
        ]);
        if (!data && !loading || error) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "pinRedirectFailed"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
        if (!data) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const issueKey = match.params.issueKey ?? '';
        const queryParams = new URLSearchParams(query).toString();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "pinRedirect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/jira/${type}/projects/${projectKey}/issues/${issueKey}?${queryParams}`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
    };
    const $1f4483ba9d8ac23e$export$f9a1f59ec7d1f215 = [
        (0, $41789f7b84696902$export$88d5f4117ce3d0fb),
        (0, $a82ae7782e05cd6a$export$2a50f64378877c9d),
        (0, $20147c9440522c21$export$b779296ccb8ca1a8),
        (0, $99398975b82221bf$export$ce258b07e4b7eb8c),
        (0, $25e6f63d1902d36e$export$3e58fe44312b4093),
        (0, $a09e1f9770441a11$export$8925c79a030fdfe8),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2de97b1bab3baedd$export$126b16ec65343bf), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
                ...(0, $906089a3c28fb671$export$919daad019702595),
                component: (0, $e5b5921263d4891a$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b7591135658477a3$export$5fcc10c40c224fbc)
                ],
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
                },
                resources: [
                    ...(0, $c7c9a307c1aca60f$export$6236a7417086ea8d)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                layout: (0, (0, parcelRequire("aPfsS")).createLayout)((0, (0, parcelRequire("gyYxw")).genericProjectLayout))
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2ca0ba87b3cf3506$export$34695dccebecc6bc), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
                ...(0, $906089a3c28fb671$export$919daad019702595),
                component: (0, $265d2c27687434ef$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("1gXMV")).GlobalIssueNavigatorSkeleton),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $b7591135658477a3$export$8ff267588532c2ce)
                ],
                ufoName: 'global-issue-navigator-jfe',
                navigation: (0, $797f27ab9ceb3235$export$2f31f4f387017d83)(),
                resources: [
                    ...(0, $797f27ab9ceb3235$export$343e92405307cf8d)()
                ],
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $vla3y;
    var $ffza4;
    var $65Ltd;
    var $3H5ry;
    var $l9RBL;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $aILzD;
    var $3RJkv;
    var $dIHnK;
    var $7mjY3;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $056174761f438866$var$LazyJiraHomePage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("pC8Oc"))), {
        moduleId: "./src/packages/spa-apps/jira-home/src/index.tsx"
    });
    const $056174761f438866$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
        const data = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734].promise;
        return (0, (0, parcelRequire("3H5ry")).checkShouldUseJSM)(data);
    };
    const $056174761f438866$export$fe7946d7dc386f9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $056174761f438866$var$LazyJiraHomePage,
            pageId: "jira-home",
            shouldShowSpinner: false
        });
    const $056174761f438866$export$578dcb61ac3cb57a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dIHnK")).jiraHomeRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HOME),
            ufoName: 'jira-home',
            component: $056174761f438866$export$fe7946d7dc386f9c,
            skeleton: (0, (0, parcelRequire("7mjY3")).YourWorkSkeleton),
            layout: (0, $226ab3e64821f6b2$export$5b7fb151d60504c),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("aILzD")).jiraHomeResourceWithCache),
                (0, (0, parcelRequire("l9RBL")).jiraHomePageRightSidePanelResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("vla3y")).widgetResources).map((resourceCreator)=>resourceCreator($056174761f438866$var$checkConsolidationOnRouteDependency, [
                        (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                    ]))
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $056174761f438866$var$LazyJiraHomePage
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $e3d75d351326e47a$export$a3a93dcf611b611a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_JIRA_SEARCH),
        path: '/jira/search',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $lb0Dk;
    var $7tQej;
    var $2YP9W;
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $6jY6G;
    var $8zOmE;
    var $2NMNM;
    var $bATyw;
    var $7tQej;
    var $ieDtd;
    var $2YP9W;
    const $2bd6861b4d276506$export$968c2900ae111000 = ({ Redirect: Redirect = (0, (0, parcelRequire("7tQej")).Redirect), fireScreenAnalytics: fireScreenAnalytics = (0, (0, parcelRequire("8zOmE")).fireScreenAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useCurrentRoute: useCurrentRoute = (0, (0, parcelRequire("6jY6G")).useCurrentRoute), useQueryParam: useQueryParam = (0, (0, parcelRequire("ieDtd")).useQueryParam) })=>{
        const route = useCurrentRoute();
        const [searchString] = useQueryParam('searchString');
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        let isNinEnabled;
        if ((0, (0, parcelRequire("4R6GH")).fg)('nin-text-fields-new-text-search-field')) ({ data: isNinEnabled } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource)));
        else isNinEnabled = true;
        (0, $5uXOq.useEffect)(()=>{
            if (!route) return;
            const screenEvent = createAnalyticsEvent({
                screenName: 'quickSearchRedirect',
                attributes: {
                    type: route.name
                }
            });
            fireScreenAnalytics(screenEvent);
        }, [
            createAnalyticsEvent,
            fireScreenAnalytics,
            route
        ]);
        let jql;
        if (isNinEnabled && (0, (0, parcelRequire("4R6GH")).fg)('nin-text-fields-new-text-search-field')) jql = searchString != null ? `textfields ~ "${searchString}"` : 'ORDER BY created DESC';
        else jql = searchString != null ? `text ~ "${searchString}"` : 'order by created DESC';
        const redirectUrl = `/issues/?jql=${encodeURIComponent(jql)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: redirectUrl
        });
    };
    var $2bd6861b4d276506$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($2bd6861b4d276506$export$968c2900ae111000, null);
    var $ebyGx = parcelRequire("ebyGx");
    var $7f4tk;
    var $2M1hQ;
    const $c763bb61845622fe$export$486bd66a4d919be7 = 'RESOURCE_TYPE_JIRA_SEARCH';
    const $c763bb61845622fe$export$d23832be0ebf8a93 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $c763bb61845622fe$export$486bd66a4d919be7,
        getKey: ()=>'search',
        getData: ({ query: query }, { tenantContext: tenantContext })=>{
            const { atlassianAccountId: atlassianAccountId } = tenantContext;
            if (!atlassianAccountId || !query?.searchString) return null;
            const queryStr = (0, ($parcel$interopDefault($ebyGx))).stringify({
                searchString: query.searchString
            });
            return (0, (0, parcelRequire("7f4tk")).default)(`/rest/navigation/4/quicksearch?${queryStr}`);
        },
        isBrowserOnly: true
    });
    const $c1df58920245e964$export$ee180957879b33ac = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, $c763bb61845622fe$export$d23832be0ebf8a93));
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lb0Dk")).IssueViewSkeleton), null);
        if (error || !data?.url) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2bd6861b4d276506$export$968c2900ae111000), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: data.url,
            push: false
        });
    };
    const $06085f80d69fe841$export$76b74d5744e69817 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e3d75d351326e47a$export$a3a93dcf611b611a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_REDIRECTS),
            component: (0, $c1df58920245e964$export$ee180957879b33ac),
            isRedirect: true,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, $c763bb61845622fe$export$d23832be0ebf8a93)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $65Ltd;
    const $5ce80937ea4d4231$export$176ff76c3ba7c4ce = {
        path: '',
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REDIRECT),
        exact: false
    };
    const $c46fefae40525649$var$RedirectComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $1513009dd97e8af4$export$2e2bcd8739ae039), null);
    const $c46fefae40525649$export$27f123cb9320355 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5ce80937ea4d4231$export$176ff76c3ba7c4ce), ()=>({
            component: $c46fefae40525649$var$RedirectComponent,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [],
            isRedirect: true,
            canTransitionIn: ()=>false,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $2G9Bk;
    var $65Ltd;
    const $288f4f9c77816594$export$9efae7a8e8e69866 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LOGIN_EMBED),
        path: '/jira-login/embed'
    };
    var $5j7Th;
    var $kxZPA;
    const $cd382e3a47206865$export$53d5d548e4e9b86 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("35DJb")), {
        moduleId: "./src/packages/spa-apps/login-embed/src/index.tsx"
    });
    const $cd382e3a47206865$export$2a94dc6e96350c82 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cd382e3a47206865$export$53d5d548e4e9b86,
            pageId: "spa-apps/login-embed",
            shouldShowSpinner: true
        });
    const $cd382e3a47206865$export$faa46f8c5e1f06d3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $288f4f9c77816594$export$9efae7a8e8e69866), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ERRORS),
            component: $cd382e3a47206865$export$2a94dc6e96350c82,
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb)
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $5bkvv;
    var $iHiHz;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $k7i8h;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $902d05cb48848402$export$5919da4c9ee4707e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("AsrYC"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/marketplace/src/index.tsx"
    });
    const $902d05cb48848402$export$f0d733b7012e9031 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $902d05cb48848402$export$5919da4c9ee4707e,
            pageId: "marketplace",
            shouldShowSpinner: true
        });
    const $3506fc2f26a58302$export$423a1c80bb2f8b9a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k7i8h")).appRequestRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_MARKETPLACE),
            component: (0, $902d05cb48848402$export$f0d733b7012e9031),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $902d05cb48848402$export$5919da4c9ee4707e)
            ],
            ufoName: 'embedded-marketplace'
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $5bkvv;
    var $iHiHz;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $a326557081fe34cb$export$e264ef643451c60a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_INDEX),
        path: '/jira/marketplace'
    };
    const $202f2f6ea16fcbde$export$422f564c9c56a4f8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a326557081fe34cb$export$e264ef643451c60a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_MARKETPLACE),
            component: (0, $902d05cb48848402$export$f0d733b7012e9031),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $902d05cb48848402$export$5919da4c9ee4707e)
            ],
            ufoName: 'embedded-marketplace'
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $5bkvv;
    var $iHiHz;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $jcvAd;
    const $2e7db6c4b913404f$export$875d88a44b1ff74c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jcvAd")).promotionsRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_MARKETPLACE),
            component: (0, $902d05cb48848402$export$f0d733b7012e9031),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $902d05cb48848402$export$5919da4c9ee4707e)
            ],
            ufoName: 'embedded-marketplace'
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ebyGx = parcelRequire("ebyGx");
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $2GkDw;
    var $3RJkv;
    var $dxCvy;
    var $iZ82x;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $29efee39c2e259e2$export$9d24fc75b0f1d9a0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE),
        path: '/jira/software/projects/:projectKey/code'
    };
    var $65Ltd;
    const $ddb4f261ae7c214b$export$6072946fe7f2d45a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_NEXTGEN_REDIRECT),
        path: '/secure/NextGen.jspa'
    };
    var $65Ltd;
    const $07e07ef6a15f8aed$export$e0d8c26cb1430ae4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burndown'
    };
    var $65Ltd;
    const $7e7ef0af528823d4$export$5b818a6914ca8376 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burnup'
    };
    var $65Ltd;
    const $5f561127b557eb0e$export$8c91815cd4b1c078 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/control'
    };
    var $65Ltd;
    const $63045e7bbaab9903$export$3c48ddd40d00b0d2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cumulative'
    };
    var $65Ltd;
    const $36696e97e70723ad$export$c777bb8f2591081 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cycle-time'
    };
    var $65Ltd;
    const $b876fc8448289e46$export$bbf45ab0423b990 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/deployment-frequency'
    };
    var $65Ltd;
    const $ccee26b223b96f27$export$5bf75a5d8c554930 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports'
    };
    var $65Ltd;
    const $e44f6dc6707a4fed$export$cde83a6497756848 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/velocity'
    };
    var $65Ltd;
    const $e9307309e9fea835$export$866215abd09c0f4d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP_REDIRECT),
        path: '/secure/Roadmap.jspa'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $cSD7y;
    var $4R6GH;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $aPfsS;
    var $3RJkv;
    var $bAB30;
    var $9SRRO;
    var $dxCvy;
    var $7GnDe;
    var $2Ql51;
    var $5lsNZ;
    var $78yv1;
    var $65Ltd;
    const $bb895b75440d1fb3$export$fb454ec14936c0ab = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG),
        path: '/jira/software/projects/:projectKey/boards/:boardId/backlog'
    };
    var $i8JTM;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $ebyGx = parcelRequire("ebyGx");
    const $8f60ec15db3f7d28$export$557c2f222778cea6 = ({ location: location, match: match })=>{
        if (match && match.params.boardId) return match.params.boardId;
        const { rapidView: rapidView } = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        return rapidView;
    };
    const $d6d069823c19bbe2$export$edb4b8cf67d7d767 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3ucvC"))), {
        moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
    });
    const $d6d069823c19bbe2$var$BacklogPage = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d6d069823c19bbe2$export$edb4b8cf67d7d767,
            pageId: `next-gen-backlog-${(0, $8f60ec15db3f7d28$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $d6d069823c19bbe2$export$a5f8ba02d2755510 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $bb895b75440d1fb3$export$fb454ec14936c0ab), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: $d6d069823c19bbe2$var$BacklogPage,
            skeleton: (0, (0, parcelRequire("i8JTM")).NextGenBacklogSkeleton),
            shouldOptOutConcurrentMode: (0, (0, parcelRequire("4R6GH")).fg)('jira-concurrent-incremental-jira'),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3Only),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResourceOnNav3Only),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("bAB30")).backlogResource),
                (0, (0, parcelRequire("9SRRO")).customFiltersResource),
                (0, (0, parcelRequire("5bkvv")).forgeBacklogModuleResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'software-backlog-early-entry'
                ]
            },
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $d6d069823c19bbe2$export$edb4b8cf67d7d767
            ],
            ufoName: 'next-gen-backlog',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$c17f34c425972af1)
            }
        }));
    const $d6d069823c19bbe2$export$7cd14dee22609378 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("78yv1")).softwareBacklogEmbedRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('enable_backlog_smartlink_route', $d6d069823c19bbe2$var$BacklogPage, (0, (0, parcelRequire("5lsNZ")).default)),
            shouldOptOutConcurrentMode: (0, (0, parcelRequire("4R6GH")).fg)('jira-concurrent-incremental-jira'),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)({
                isChromeless: true
            }),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("bAB30")).backlogResource),
                (0, (0, parcelRequire("9SRRO")).customFiltersResource),
                (0, (0, parcelRequire("5bkvv")).forgeBacklogModuleResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                $d6d069823c19bbe2$export$edb4b8cf67d7d767
            ],
            ufoName: 'next-gen-backlog-embed',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$c17f34c425972af1)
            }
        }));
    var $d6d069823c19bbe2$export$2e2bcd8739ae039 = $d6d069823c19bbe2$var$BacklogPage;
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $aIZdc;
    var $ffza4;
    var $65Ltd;
    var $cSD7y;
    var $4R6GH;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $aPfsS;
    var $5qQ9I;
    var $3RJkv;
    var $ipmBb;
    var $dxCvy;
    var $7GnDe;
    var $2Ql51;
    var $gNStA;
    var $5lsNZ;
    var $eeXsz;
    var $7wTzh;
    var $11dfA;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ccb682e3f2b95fd8$export$bd9ede4ec384f41d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8N7Nn"))), {
        moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
    });
    const $ccb682e3f2b95fd8$var$getBoardId = ({ location: location, match: match })=>{
        if (match && match.params.boardId) return match.params.boardId;
        const { rapidView: rapidView } = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        return rapidView;
    };
    const $ccb682e3f2b95fd8$export$78e6ebf73d7f732b = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ccb682e3f2b95fd8$export$bd9ede4ec384f41d,
            pageId: `next-gen-board-${$ccb682e3f2b95fd8$var$getBoardId({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $ccb682e3f2b95fd8$var$conditionalBoardResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)(()=>!(0, (0, parcelRequire("4R6GH")).fg)('critical_board_query_with_relay'), (0, (0, parcelRequire("5qQ9I")).boardResource));
    const $ccb682e3f2b95fd8$var$conditionalBoardRelayResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('critical_board_query_with_relay'), (0, (0, parcelRequire("5qQ9I")).boardRelayResource));
    const $ccb682e3f2b95fd8$var$conditionalBoardNBTOptInResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!(0, (0, parcelRequire("aIZdc")).isFedRamp)(), (0, (0, parcelRequire("ipmBb")).nextBestTaskFeatureResource));
    const $ccb682e3f2b95fd8$export$2964ea1cdd5afa39 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7wTzh")).softwareBoardRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: $ccb682e3f2b95fd8$export$78e6ebf73d7f732b,
            skeleton: (0, (0, parcelRequire("11dfA")).NextGenBoardSkeleton),
            shouldOptOutConcurrentMode: (0, (0, parcelRequire("4R6GH")).fg)('jira-concurrent-incremental'),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3Only),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResourceOnNav3Only),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                $ccb682e3f2b95fd8$var$conditionalBoardResource,
                (0, (0, parcelRequire("5qQ9I")).customFiltersResource),
                $ccb682e3f2b95fd8$var$conditionalBoardRelayResource,
                $ccb682e3f2b95fd8$var$conditionalBoardNBTOptInResource,
                (0, (0, parcelRequire("5bkvv")).forgeBoardModuleResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'software-board-early-entry'
                ]
            },
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $ccb682e3f2b95fd8$export$bd9ede4ec384f41d
            ],
            ufoName: 'next-gen-board',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$f364828958cffad0)
            }
        }));
    const $ccb682e3f2b95fd8$export$ff8632c8a0f5d984 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eeXsz")).softwareBoardEmbedRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            shouldOptOutConcurrentMode: (0, (0, parcelRequire("4R6GH")).fg)('jira-concurrent-incremental'),
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_board_smartlink_embed', $ccb682e3f2b95fd8$export$78e6ebf73d7f732b, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)({
                isChromeless: true
            }),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                $ccb682e3f2b95fd8$var$conditionalBoardNBTOptInResource,
                $ccb682e3f2b95fd8$var$conditionalBoardResource,
                $ccb682e3f2b95fd8$var$conditionalBoardRelayResource,
                (0, (0, parcelRequire("5qQ9I")).customFiltersResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
                (0, (0, parcelRequire("5bkvv")).forgeBoardModuleResource)
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                $ccb682e3f2b95fd8$export$bd9ede4ec384f41d
            ],
            ufoName: 'next-gen-board-embed',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$f364828958cffad0)
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $aPfsS;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $2Ql51;
    var $65Ltd;
    const $e9efd1396eb47ddd$export$b55c4d4efb097c1c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_EMBED),
        path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/embed',
        query: [
            'date?'
        ]
    };
    var $65Ltd;
    const $8d2c5695d9358265$export$d6730f103a4ad844 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR),
        path: '/jira/software/projects/:projectKey/boards/:boardId/calendar',
        query: [
            'date?'
        ]
    };
    var $kZOse;
    var $5PD5h;
    var $e7bC3;
    const $2abc171a2b01be16$export$24fc07c22f0d06 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e9efd1396eb47ddd$export$b55c4d4efb097c1c), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            skeleton: (0, (0, parcelRequire("kZOse")).CalendarEmbedSkeleton),
            component: (0, (0, parcelRequire("kZOse")).CalendarEmbedSkeleton),
            entryPoint () {
                if (false) return undefined;
                return $2abc171a2b01be16$export$d154630e8966be91;
            },
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            ufoName: 'next-gen-calendar-embed'
        }));
    const $2abc171a2b01be16$export$d154630e8966be91 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $d8251bf369abb7ad$export$19cf4b398f638dc6),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $2abc171a2b01be16$export$83b1b9036cc7961a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8d2c5695d9358265$export$d6730f103a4ad844), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            skeleton: (0, (0, parcelRequire("kZOse")).CalendarSkeleton),
            component: (0, (0, parcelRequire("kZOse")).CalendarSkeleton),
            entryPoint () {
                if (false) return undefined;
                return $2abc171a2b01be16$export$d154630e8966be91;
            },
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ],
            ufoName: 'next-gen-calendar'
        }));
    var $ffza4;
    var $65Ltd;
    var $6s1PB;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $3HwlS;
    var $koWFd;
    var $2G9Bk;
    var $l2N2a;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $2ce33b6906a0aad5$export$c5589046ee2a390d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER),
        path: '/jira/software/projects/:projectKey/form/:formId/builder',
        exact: true
    };
    var $5PD5h;
    var $e7bC3;
    const $c07fcdd97b2971f3$export$e8dede7671fad23d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2ce33b6906a0aad5$export$c5589046ee2a390d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'next-gen-form-builder',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, $6bbae009e0a4162e$export$a4c73b2a16981930), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav), ()=>null)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $6bbae009e0a4162e$export$2076234d7fde1717)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $6s1PB;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $3HwlS;
    var $koWFd;
    var $2G9Bk;
    var $l2N2a;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $fca3b9cc3ce6bbb8$export$a46217d369231a5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM),
        path: '/jira/software/projects/:projectKey/form',
        exact: true
    };
    var $5PD5h;
    var $e7bC3;
    const $17db4816c5775fc6$export$563e3b39911993a0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fca3b9cc3ce6bbb8$export$a46217d369231a5), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'next-gen-form',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, $7513c2d92a0c1be5$export$7234abc5d81adb58), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav), ()=>null),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7513c2d92a0c1be5$export$240a58749ebba091)
            ]
        }));
    var $65Ltd;
    var $cSD7y;
    var $2G9Bk;
    var $l2N2a;
    var $5lsNZ;
    var $65Ltd;
    const $fae57e01e4ce41f8$export$2bee26f083dc2946 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_EMBED),
        path: '/jira/software/projects/:projectKey/form/:formId/embed',
        exact: true
    };
    const $eac84389ded397f0$export$ac2e374edf86801f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fae57e01e4ce41f8$export$2bee26f083dc2946), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'next-gen-form-submit-embed',
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_forms_embed', (0, $de8f9eda1dab06b1$export$3adb3f8f6b2673ae), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            resources: [
                (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
            ],
            forPaint: [
                (0, $de8f9eda1dab06b1$export$4d2f42d18d020964)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $6s1PB;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $2G9Bk;
    var $l2N2a;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $a6eb0d1c3eac1f7e$export$75b28ee1c7f02f00 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT),
        path: '/jira/software/projects/:projectKey/form/:formId',
        exact: true
    };
    const $3e2bc0f3ee8b3d3b$export$752724866670c36 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a6eb0d1c3eac1f7e$export$75b28ee1c7f02f00), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'next-gen-form-submit',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, $a96ac2d599fb8faa$export$4258f48cc65dca00), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $a96ac2d599fb8faa$export$258fcd204933dd75)
            ]
        }));
    var $65Ltd;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $7d61fd42ce40e603$export$2328fed7ebee3cce = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS),
        exact: true,
        path: '/jira/software/projects/:projectKey/goals'
    };
    var $5PD5h;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f4f250cf13a0bcf2$export$69b07a7049b7beab = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6Aupt"))), {
        moduleId: "./src/packages/spa-apps/goals/src/index.tsx"
    });
    var $f4f250cf13a0bcf2$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f4f250cf13a0bcf2$export$69b07a7049b7beab,
            pageId: `atlas-goals-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
    const $b91813a6c321b4f0$export$d3fcc412edfa2068 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7d61fd42ce40e603$export$2328fed7ebee3cce), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $f4f250cf13a0bcf2$export$2e2bcd8739ae039),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $6s1PB;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $aPfsS;
    var $dAmbh;
    var $g4ZHz;
    var $iNzEe;
    var $l2N2a;
    var $3RJkv;
    var $dxCvy;
    var $aFVvc;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $7b234b63625cf68c$export$70dd8df584442004 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_EMBED),
        path: '/jira/software/projects/:projectKey/list/embed'
    };
    var $65Ltd;
    const $da08ebba917aac54$export$f3a5b1b732315e13 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST),
        path: '/jira/software/projects/:projectKey/list'
    };
    var $5PD5h;
    var $e7bC3;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $435c36ebe30f5714$export$26b97a235767fc3c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("eSbew"))), {
        moduleId: "./src/packages/spa-apps/business/jsw-list/src/index.tsx"
    });
    const $435c36ebe30f5714$export$8c61f5f5c58f351f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bmORQ"))), {
        moduleId: "./src/packages/spa-apps/business/jsw-list-embed/src/index.tsx"
    });
    const $435c36ebe30f5714$export$422a3a028ae77ad3 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $435c36ebe30f5714$export$26b97a235767fc3c,
            pageId: `next-gen-list-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
    const $435c36ebe30f5714$export$4a0539d19a2e2694 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $435c36ebe30f5714$export$8c61f5f5c58f351f,
            pageId: `next-gen-list-${match.params.boardId || ''}-embed`,
            shouldShowSpinner: false
        });
    const $8c2860a002a4fb1b$var$getListProjectResources = ()=>[
            (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource),
            (0, (0, parcelRequire("iNzEe")).navigationResource),
            (0, (0, parcelRequire("l2N2a")).projectDetailsResource),
            (0, (0, parcelRequire("dAmbh")).configurationResource),
            (0, (0, parcelRequire("g4ZHz")).fieldsResource)
        ];
    const $8c2860a002a4fb1b$export$4425668b2cd90292 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $093e9fa498e2d713$export$6be4f10150ff6073),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8c2860a002a4fb1b$export$f30a66efa682bf2d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $da08ebba917aac54$export$f3a5b1b732315e13), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $435c36ebe30f5714$export$422a3a028ae77ad3), (0, (0, parcelRequire("5lsNZ")).default)),
            skeleton: (0, $6a76608e47ef62ca$export$cbc3335f7a517046),
            entryPoint () {
                return (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? $8c2860a002a4fb1b$export$4425668b2cd90292 : undefined;
            },
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...$8c2860a002a4fb1b$var$getListProjectResources()
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $435c36ebe30f5714$export$26b97a235767fc3c)
            ],
            ufoName: 'next-gen-list'
        }));
    const $8c2860a002a4fb1b$export$1099e0e49394fa9a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7b234b63625cf68c$export$70dd8df584442004), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $435c36ebe30f5714$export$4a0539d19a2e2694), (0, (0, parcelRequire("5lsNZ")).default)),
            skeleton: (0, $6a76608e47ef62ca$export$2638f1c98fe91c13),
            entryPoint () {
                return (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? $8c2860a002a4fb1b$export$4425668b2cd90292 : undefined;
            },
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$8c2860a002a4fb1b$var$getListProjectResources()
            ],
            forPaint: [
                (0, $435c36ebe30f5714$export$8c61f5f5c58f351f)
            ],
            ufoName: 'next-gen-list-embed'
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $aPfsS;
    var $3RJkv;
    var $dxCvy;
    var $jsFU4;
    var $7GnDe;
    var $65Ltd;
    const $d2651e8c2584e2bd$export$a4a573c36fc75b30 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP),
        path: '/jira/software/projects/:projectKey/boards/:boardId/roadmap'
    };
    var $8STJR;
    var $5PD5h;
    var $e7bC3;
    var $7tQej;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $fba9adf99f1ad42b$export$1339c847cf4ab57 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("21w0Z"))), {
        moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
    });
    var $fba9adf99f1ad42b$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fba9adf99f1ad42b$export$1339c847cf4ab57,
            pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
    const $f9f5d14d16dfafed$export$dd8650bb193f860b = ({ match: { params: { projectKey: projectKey, boardId: boardId } }, query: query })=>{
        const queryParams = new URLSearchParams(query).toString();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: {
                pathname: `/jira/software/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
                hash: '',
                search: queryParams
            }
        });
    };
    const $f9f5d14d16dfafed$export$c1d875e34d537389 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d2651e8c2584e2bd$export$a4a573c36fc75b30), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: $f9f5d14d16dfafed$export$dd8650bb193f860b,
            skeleton: (0, (0, parcelRequire("8STJR")).RoadmapSkeleton),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("jsFU4")).nextGenRoadmapResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'software-roadmap-early-entry'
                ]
            },
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $fba9adf99f1ad42b$export$1339c847cf4ab57)
            ],
            ufoName: 'next-gen-roadmap'
        }));
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $6s1PB;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $cff79d22061504ff$export$c6629202e90df62a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY),
        path: '/jira/software/projects/:projectKey/summary'
    };
    var $5PD5h;
    var $e7bC3;
    const $6558dfd987f061ce$export$a2560b0baf928c49 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cff79d22061504ff$export$c6629202e90df62a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'next-gen-summary',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('helios_summary_page_experiment', 'isEnabled', false), (0, $d82700466a756427$export$893608e1a22999b9), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d82700466a756427$export$68c09444cc6f2843)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY)),
                    teamName: 'Helios - Reports'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $aPfsS;
    var $3RJkv;
    var $dxCvy;
    var $jsFU4;
    var $7GnDe;
    var $65Ltd;
    const $2ea9397ffa8c64ef$export$d25dafcda96d5af9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE),
        path: '/jira/software/projects/:projectKey/boards/:boardId/timeline'
    };
    var $8STJR;
    var $5PD5h;
    var $e7bC3;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $faefef5a329d510c$export$1339c847cf4ab57 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("21w0Z"))), {
        moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
    });
    var $faefef5a329d510c$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $faefef5a329d510c$export$1339c847cf4ab57,
            pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
    const $31385a75e55d4e4a$export$ace6a996c7e99f3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2ea9397ffa8c64ef$export$d25dafcda96d5af9), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $faefef5a329d510c$export$2e2bcd8739ae039),
            skeleton: (0, (0, parcelRequire("8STJR")).RoadmapSkeleton),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("jsFU4")).nextGenRoadmapResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'software-roadmap-early-entry'
                ]
            },
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $faefef5a329d510c$export$1339c847cf4ab57)
            ],
            ufoName: 'next-gen-roadmap'
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $aPfsS;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $kt0pG;
    var $5lsNZ;
    var $65Ltd;
    const $901ac67e36c3672e$export$78d11017d9c9ed74 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED),
        path: '/projects/:projectKey/versions/:versionId/tab/:tab/embed',
        exact: true
    };
    var $65Ltd;
    const $29228b2ecd57a3f4$export$3fc8dbcec208bca0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT),
        path: '/browse/:projectKey/fixforversion/:versionId'
    };
    var $65Ltd;
    const $bfff597194375de5$export$f22288f2d2f1b9ea = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
        path: '/projects/:projectKey/versions/:versionId'
    };
    var $12flw;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $aadf76d7366fa419$exports = {};
    $aadf76d7366fa419$exports = new URL("version-detail-skeleton.tpl.c4c4fc18.svg", import.meta.url).toString();
    const $d1c9f0513946a9ed$export$b3661a594ba34350 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($aadf76d7366fa419$exports)))
        });
    var $5PD5h;
    var $e7bC3;
    var $7tQej;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5cbf8f752618c8e3$export$2d31f5f47e6584e0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2Y5QL"))), {
        moduleId: "./src/packages/spa-apps/version-detail/src/index.tsx"
    });
    const $5cbf8f752618c8e3$export$231cc5186b991031 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5cbf8f752618c8e3$export$2d31f5f47e6584e0,
            pageId: "version-detail",
            shouldShowSpinner: false
        });
    const $9c57977169cc077f$var$VersionDetailPageLegacyRedirect = ({ match: { params: { projectKey: projectKey, versionId: versionId, tab: tab } } })=>{
        if (projectKey == null || versionId == null) throw Error('projectKey or versionId not found in match object of RouteContext');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/projects/${projectKey}/versions/${versionId}/tab/${tab != null ? tab : 'release-report-all-issues'}`
        });
    };
    const $9c57977169cc077f$export$c97dabcfe9d495fa = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("12flw")).softwareVersionDetailRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'software.version-details-page',
            component: (0, $5cbf8f752618c8e3$export$231cc5186b991031),
            skeleton: (0, $d1c9f0513946a9ed$export$b3661a594ba34350),
            canTransitionIn: ()=>true,
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: [
                    (0, (0, parcelRequire("koWFd")).default),
                    (0, (0, parcelRequire("9s3j1")).default)
                ]
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("kt0pG")).versionDetailsRelayResourceCustom),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $5cbf8f752618c8e3$export$2d31f5f47e6584e0)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
    const $9c57977169cc077f$export$83102a6097008c79 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $901ac67e36c3672e$export$78d11017d9c9ed74), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            ufoName: 'software.version-details-page-embed',
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_release_smartlink_embed', (0, $5cbf8f752618c8e3$export$231cc5186b991031), (0, (0, parcelRequire("5lsNZ")).default)),
            skeleton: (0, $d1c9f0513946a9ed$export$b3661a594ba34350),
            canTransitionIn: ()=>true,
            layout: (0, (0, parcelRequire("aPfsS")).createLayout)({
                isChromeless: true
            }),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("kt0pG")).versionDetailsRelayResourceCustom),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, $5cbf8f752618c8e3$export$2d31f5f47e6584e0)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
    const $9c57977169cc077f$export$28d16aae32969765 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $bfff597194375de5$export$f22288f2d2f1b9ea), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: $9c57977169cc077f$var$VersionDetailPageLegacyRedirect,
            canTransitionIn: ()=>true,
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: [
                    (0, (0, parcelRequire("koWFd")).default),
                    (0, (0, parcelRequire("9s3j1")).default)
                ],
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $5cbf8f752618c8e3$export$2d31f5f47e6584e0)
            ]
        }));
    const $9c57977169cc077f$export$f29aafdff734071c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $29228b2ecd57a3f4$export$3fc8dbcec208bca0), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: $9c57977169cc077f$var$VersionDetailPageLegacyRedirect,
            canTransitionIn: ()=>true,
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: [
                    (0, (0, parcelRequire("koWFd")).default),
                    (0, (0, parcelRequire("9s3j1")).default)
                ],
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $5cbf8f752618c8e3$export$2d31f5f47e6584e0)
            ]
        }));
    var $kfztd;
    var $5PD5h;
    var $e7bC3;
    var $7tQej;
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $e8677532a1aaea76$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $e8677532a1aaea76$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
    var $ebyGx = parcelRequire("ebyGx");
    const $4ad36038fa160dbe$var$PLAN = 'planning';
    const $4ad36038fa160dbe$var$REPORTING = 'reporting';
    const $4ad36038fa160dbe$var$REPORTS = 'reports';
    const $4ad36038fa160dbe$var$constructUrlForView = (url, view, searchResult)=>{
        if (view.startsWith($4ad36038fa160dbe$var$PLAN)) return `${url}/backlog`;
        if (view.startsWith($4ad36038fa160dbe$var$REPORTING) || view.startsWith($4ad36038fa160dbe$var$REPORTS)) {
            if (searchResult.report) return `${url}/reports/${searchResult.report}`;
            return `${url}/reports`;
        }
        return url;
    };
    const $4ad36038fa160dbe$var$KNOWN_KEYS = [
        'rapidView',
        'projectKey',
        'view',
        'report'
    ];
    const $4ad36038fa160dbe$var$forwardUnknownQueryParams = (url, queryParams)=>{
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify(Object.entries(queryParams).filter(([k])=>!$4ad36038fa160dbe$var$KNOWN_KEYS.includes(k)).reduce((result, [k, v])=>({
                [k]: v,
                ...result
            }), {}));
        if (query) return `${url}?${query}`;
        return url;
    };
    const $4ad36038fa160dbe$export$8c47088cd9b527ba = (location)=>{
        const searchResult = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        const url = `/jira/software/projects/${searchResult.projectKey}/boards/${searchResult.rapidView}`;
        if (searchResult.view) return $4ad36038fa160dbe$var$forwardUnknownQueryParams($4ad36038fa160dbe$var$constructUrlForView(url, searchResult.view, searchResult), searchResult);
        return $4ad36038fa160dbe$var$forwardUnknownQueryParams(url, searchResult);
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $fadca415ac9d888e$export$1339c847cf4ab57 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("21w0Z"))), {
        moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
    });
    var $fadca415ac9d888e$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fadca415ac9d888e$export$1339c847cf4ab57,
            pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $ebyGx = parcelRequire("ebyGx");
    const $8d5a6727ab17b6ba$export$557c2f222778cea6 = ({ location: location, match: match })=>{
        if (match && match.params.boardId) return match.params.boardId;
        const { rapidView: rapidView } = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        return rapidView;
    };
    const $e02d9e74ba3f4d5c$export$4beafd9dbad29bff = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kt9Vo"))), {
        moduleId: "./src/packages/spa-apps/code/src/index.tsx"
    });
    const $e02d9e74ba3f4d5c$export$d9e8184332f86b53 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e02d9e74ba3f4d5c$export$4beafd9dbad29bff,
            pageId: `next-gen-code-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $e02d9e74ba3f4d5c$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e02d9e74ba3f4d5c$export$4beafd9dbad29bff,
            pageId: `classic-code-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $51e496184ed5259a$export$10cd1e761434952 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2sCk8"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/burndown/src/index.tsx"
    });
    var $51e496184ed5259a$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $51e496184ed5259a$export$10cd1e761434952,
            pageId: `next-gen-reports-burndown-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2f0cf451fae61f8d$export$2ae7ab3b633c1d15 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7hZC2"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/burnup/src/index.tsx"
    });
    var $2f0cf451fae61f8d$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2f0cf451fae61f8d$export$2ae7ab3b633c1d15,
            pageId: `next-gen-reports-burnup-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $a8fc70484e9dc624$export$3b0b331107fce76 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6xd2T"))), {
        moduleId: "./src/packages/spa-apps/control-report/src/index.tsx"
    });
    const $a8fc70484e9dc624$export$90d0561918744b3b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a8fc70484e9dc624$export$3b0b331107fce76,
            pageId: "controlReportNextGen",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d11158d5657ed65b$export$c588973e5bd18a8d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9tL3Y"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/cumulative/src/index.tsx"
    });
    var $d11158d5657ed65b$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d11158d5657ed65b$export$c588973e5bd18a8d,
            pageId: `next-gen-reports-cumulative-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $494bd3c8d60b6ff9$export$956f830ed027f1fb = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("dyzSB")), {
        moduleId: "./src/packages/spa-apps/cycle-time-report/src/index.tsx"
    });
    const $494bd3c8d60b6ff9$export$e16ce0656a74a015 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $494bd3c8d60b6ff9$export$956f830ed027f1fb,
            pageId: "cycleTimeReportNextGen",
            shouldShowSpinner: true
        });
    const $494bd3c8d60b6ff9$export$237924ba64065cc3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $494bd3c8d60b6ff9$export$956f830ed027f1fb,
            pageId: "cycleTimeReportClassic",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $2f62bb5293f966a6$export$5113b2b19ec1fb53 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("pXexG")), {
        moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
    });
    const $2f62bb5293f966a6$export$e2db9c7426cdb53 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2f62bb5293f966a6$export$5113b2b19ec1fb53,
            pageId: "deploymentFrequencyReportNextGen",
            shouldShowSpinner: true
        });
    const $2f62bb5293f966a6$export$655707e8ae1053d3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2f62bb5293f966a6$export$5113b2b19ec1fb53,
            pageId: "deploymentFrequencyReportClassic",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5b9a94bde6be5ad0$export$dbd12c5c20c26961 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("eQoM0"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/overview/src/index.tsx"
    });
    var $5b9a94bde6be5ad0$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5b9a94bde6be5ad0$export$dbd12c5c20c26961,
            pageId: `next-gen-reports-overview-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $29d7a4515738ef63$export$a2ca519c668b2f72 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("57GTs"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/velocity/src/index.tsx"
    });
    var $29d7a4515738ef63$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $29d7a4515738ef63$export$a2ca519c668b2f72,
            pageId: `next-gen-reports-velocity-${(0, $8d5a6727ab17b6ba$export$557c2f222778cea6)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $1f4b902ae477a058$var$SoftwareNextgenRedirectComponent = ({ location: location })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: (0, $4ad36038fa160dbe$export$8c47088cd9b527ba)(location)
        });
    const $1f4b902ae477a058$var$SoftwareTimelineLegacyRedirect = ({ query: query })=>{
        const { projectKey: projectKey, rapidView: rapidView, ...restQuery } = query;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: {
                pathname: `/jira/software/projects/${projectKey}/boards/${rapidView}/timeline`,
                hash: '',
                search: (0, ($parcel$interopDefault($ebyGx))).stringify(restQuery)
            }
        });
    };
    const $1f4b902ae477a058$export$688b56fcbc2637ac = [
        (0, $ccb682e3f2b95fd8$export$ff8632c8a0f5d984),
        (0, $ccb682e3f2b95fd8$export$2964ea1cdd5afa39),
        (0, $d6d069823c19bbe2$export$7cd14dee22609378),
        (0, $d6d069823c19bbe2$export$a5f8ba02d2755510),
        (0, $c07fcdd97b2971f3$export$e8dede7671fad23d),
        (0, $17db4816c5775fc6$export$563e3b39911993a0),
        (0, $3e2bc0f3ee8b3d3b$export$752724866670c36),
        (0, $eac84389ded397f0$export$ac2e374edf86801f),
        (0, $b91813a6c321b4f0$export$d3fcc412edfa2068),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7e7ef0af528823d4$export$5b818a6914ca8376), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
                ufoName: 'software-reports.burnup-chart',
                component: (0, $2f0cf451fae61f8d$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2f0cf451fae61f8d$export$2ae7ab3b633c1d15)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e44f6dc6707a4fed$export$cde83a6497756848), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
                ufoName: 'software-reports.velocity-report',
                component: (0, $29d7a4515738ef63$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $29d7a4515738ef63$export$a2ca519c668b2f72)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $63045e7bbaab9903$export$3c48ddd40d00b0d2), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
                ufoName: 'software-reports.cumulative-flow-diagram',
                component: (0, $d11158d5657ed65b$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $d11158d5657ed65b$export$c588973e5bd18a8d)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $07e07ef6a15f8aed$export$e0d8c26cb1430ae4), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
                ufoName: 'software-reports.burndown-chart',
                component: (0, $51e496184ed5259a$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $51e496184ed5259a$export$10cd1e761434952)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $36696e97e70723ad$export$c777bb8f2591081), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $494bd3c8d60b6ff9$export$e16ce0656a74a015)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)(),
                    (0, (0, parcelRequire("2GkDw")).devOpsProviderResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $494bd3c8d60b6ff9$export$956f830ed027f1fb)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME)),
                        teamName: 'fusion-solaris'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b876fc8448289e46$export$bbf45ab0423b990), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $2f62bb5293f966a6$export$e2db9c7426cdb53)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)(),
                    (0, (0, parcelRequire("2GkDw")).devOpsProviderResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2f62bb5293f966a6$export$5113b2b19ec1fb53)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY)),
                        teamName: 'fusion-solaris'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5f561127b557eb0e$export$8c91815cd4b1c078), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
                ufoName: 'software-reports.control-chart',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_enable_avp_control_chart', (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $a8fc70484e9dc624$export$90d0561918744b3b)), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $a8fc70484e9dc624$export$3b0b331107fce76)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL)),
                        teamName: 'helios-reports'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ccee26b223b96f27$export$5bf75a5d8c554930), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
                component: (0, $5b9a94bde6be5ad0$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, $e8677532a1aaea76$export$f234446c23dc22a)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $5b9a94bde6be5ad0$export$dbd12c5c20c26961)
                ],
                ufoName: 'software-reports.overview'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ddb4f261ae7c214b$export$6072946fe7f2d45a), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
                component: $1f4b902ae477a058$var$SoftwareNextgenRedirectComponent,
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $ccb682e3f2b95fd8$export$bd9ede4ec384f41d)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $29efee39c2e259e2$export$9d24fc75b0f1d9a0), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $e02d9e74ba3f4d5c$export$d9e8184332f86b53)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutCode),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("iZ82x")).codePageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $e02d9e74ba3f4d5c$export$4beafd9dbad29bff)
                ],
                ufoName: 'next-gen-code'
            })),
        (0, $1bbbe61aca30e3ab$export$a8dcfae475505e7a),
        (0, $6558dfd987f061ce$export$a2560b0baf928c49),
        (0, $2cdb997b770c0bb4$export$7e5ccb20ad8e1612),
        (0, $9db212062a348ac3$export$7db4d910357a4d89),
        (0, $9c57977169cc077f$export$83102a6097008c79),
        (0, $9c57977169cc077f$export$c97dabcfe9d495fa),
        (0, $9c57977169cc077f$export$28d16aae32969765),
        (0, $9c57977169cc077f$export$f29aafdff734071c),
        (0, $31385a75e55d4e4a$export$ace6a996c7e99f3),
        (0, $f9f5d14d16dfafed$export$c1d875e34d537389),
        (0, $2abc171a2b01be16$export$24fc07c22f0d06),
        (0, $2abc171a2b01be16$export$83b1b9036cc7961a),
        (0, $8c2860a002a4fb1b$export$1099e0e49394fa9a),
        (0, $8c2860a002a4fb1b$export$f30a66efa682bf2d),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e9307309e9fea835$export$866215abd09c0f4d), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
                component: $1f4b902ae477a058$var$SoftwareTimelineLegacyRedirect,
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                afterPaint: [
                    (0, $43c3852afc527b13$export$8c70dcc4643464f8)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $fadca415ac9d888e$export$1339c847cf4ab57)
                ]
            })),
        (0, $9e60de4e7ff199f0$export$fd29243dbe4103)
    ];
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $3d5ce45adc18efc0$export$534a7ac096cb1da2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE),
        path: '/jira/:projectType(software|software/c)/projects/:projectKey/on-call-schedule'
    };
    var $65Ltd;
    const $c8ff7eb22dd44ec6$export$830cd0c207772936 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE)}-redirect`,
        path: '/projects/:projectKey',
        query: [
            'selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page'
        ]
    };
    var $kfztd;
    var $5PD5h;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $2NMNM;
    var $dxCvy;
    var $bVDE5;
    var $7tQej;
    var $2YP9W;
    var $doZTA;
    const $f4de23917d090f8e$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, (0, parcelRequire("7tQej")).Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useResource: useResource = (0, (0, parcelRequire("2YP9W")).useResource), useRouter: useRouter = (0, (0, parcelRequire("doZTA")).useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
    const $aa55fbc557add2b7$export$3a9c3ff70731bdd6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("aphxY"))), {
        moduleId: "./src/packages/spa-apps/project/opsgenie-schedule/src/index.tsx"
    });
    const $aa55fbc557add2b7$export$6ffd640c3062d976 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $f4de23917d090f8e$export$8a3df560509448b8), {
            page: "/on-call-schedule"
        });
    var $aa55fbc557add2b7$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $aa55fbc557add2b7$export$3a9c3ff70731bdd6,
            pageId: "opsgenie-schedule",
            shouldShowSpinner: true
        });
    const $d33ce51d8c4b9036$export$f128c1c4a1f0d631 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c8ff7eb22dd44ec6$export$830cd0c207772936), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
            component: !false ? (0, $aa55fbc557add2b7$export$6ffd640c3062d976) : (0, $aa55fbc557add2b7$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $aa55fbc557add2b7$export$3a9c3ff70731bdd6)
            ],
            isRedirect: true
        }));
    const $d33ce51d8c4b9036$export$924db6cf10ba8696 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3d5ce45adc18efc0$export$534a7ac096cb1da2), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
            ufoName: 'project-opsgenie-schedule',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $aa55fbc557add2b7$export$2e2bcd8739ae039)),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: [
                    (0, (0, parcelRequire("koWFd")).default),
                    (0, (0, parcelRequire("9s3j1")).default)
                ],
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $aa55fbc557add2b7$export$3a9c3ff70731bdd6)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $6s1PB;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $5UHoB;
    var $bHhiy;
    var $3RJkv;
    var $fDWVs;
    var $6Z2mh;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $7f2f7b5455866fc1$var$LazyPeopleProfiles = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("84kXR"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/people-profiles/src/index.tsx"
    });
    const $7f2f7b5455866fc1$export$9e44232fa48ba2ee = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7f2f7b5455866fc1$var$LazyPeopleProfiles,
            pageId: "people-profiles",
            shouldShowSpinner: true
        });
    const $7f2f7b5455866fc1$export$219b6cc00b2f91a0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fDWVs")).peopleProfilesRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PEOPLE_PROFILES),
            component: $7f2f7b5455866fc1$export$9e44232fa48ba2ee,
            layout: (0, (0, parcelRequire("5UHoB")).layoutWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation'), (0, (0, parcelRequire("6Z2mh")).rightSidebarsLayout), (0, (0, parcelRequire("2BrOV")).globalLayout)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7f2f7b5455866fc1$var$LazyPeopleProfiles
            ],
            ufoName: 'people-profiles'
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $aIZdc;
    var $1Xcuw;
    parcelRequire("jxRF2");
    var $ldKOT;
    var $ffza4;
    var $65Ltd;
    var $3H5ry;
    var $2BrOV;
    var $lmyls;
    var $5bkvv;
    var $1C2yb;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $eOlBz;
    var $ipmBb;
    var $gNStA;
    var $7ziML;
    var $65Ltd;
    var $1C2yb;
    const $dee3d03f0dfab121$export$dd556eb586bb36b8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS),
        path: (0, (0, parcelRequire("1C2yb")).LEGACY_PERSONAL_SETTINGS_PATH)
    };
    var $d1xZH;
    var $65Ltd;
    var $1C2yb;
    const $84075aa9af41e0be$export$68ebdd4eccb7b383 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS),
        path: (0, (0, parcelRequire("1C2yb")).OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH)
    };
    var $7OYJs;
    var $a94gn;
    var $7P45F;
    var $eufEc;
    var $fEDBv;
    const $0e73b796ef7555dc$export$44d710abd316d1f1 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("9RvnT")), {
            moduleId: "fe0c927e"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    pageAndProject: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: (0, parcelRequire("7P45F")).default,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectIds: context.query?.projectIds ? context.query.projectIds.split(',') : []
                        }
                    }
                },
                extraProps: {
                    accountId: tenantContext.atlassianAccountId
                }
            })
    });
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5daf430235f9fc0a$var$LazyLegacyPersonalSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bzgPz"))), {
        moduleId: "./src/packages/spa-apps/personal-settings-legacy/src/index.tsx"
    });
    const $5daf430235f9fc0a$var$personalSettingsNotificationsEntryPointPage = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $0e73b796ef7555dc$export$44d710abd316d1f1),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).NOTIFICATIONS
    });
    const $5daf430235f9fc0a$var$LazyGeneralPersonalSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("juaG8"))), {
        moduleId: "./src/packages/spa-apps/personal-settings/general/src/index.tsx"
    });
    const $5daf430235f9fc0a$var$LazyOpsNotificationsPersonalSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("eV2qE"))), {
        moduleId: "./src/packages/spa-apps/personal-settings/ops-notifications/src/index.tsx"
    });
    const $5daf430235f9fc0a$var$checkConsolidationOnRouteDependency = (dependencies)=>{
        const { data: data } = dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734];
        return (0, (0, parcelRequire("3H5ry")).checkShouldUseJSM)(data);
    };
    const $5daf430235f9fc0a$export$31dadfd5bc64c9c9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5daf430235f9fc0a$var$LazyLegacyPersonalSettings,
            pageId: "personal-settings",
            shouldShowSpinner: true
        });
    const $5daf430235f9fc0a$export$81bedf006ef32751 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5daf430235f9fc0a$var$LazyGeneralPersonalSettings,
            pageId: "personal-settings-general",
            shouldShowSpinner: true
        });
    const $5daf430235f9fc0a$export$e30af76ba1def364 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5daf430235f9fc0a$var$LazyOpsNotificationsPersonalSettings,
            pageId: "personal-settings-notifications",
            shouldShowSpinner: true
        });
    const $5daf430235f9fc0a$var$getLabsResources = ()=>[
            (0, (0, parcelRequire("eOlBz")).newIssueViewTransitionLockInStatusResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!(0, (0, parcelRequire("aIZdc")).isFedRamp)(), (0, (0, parcelRequire("ipmBb")).nextBestTaskFeatureResource))
        ];
    const $5daf430235f9fc0a$export$89646e32fa7698db = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $dee3d03f0dfab121$export$dd556eb586bb36b8), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PERSONAL_SETTINGS),
            component: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                    to: (0, (0, parcelRequire("1C2yb")).GENERAL_PERSONAL_SETTINGS_PATH)
                }),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROFILE
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("1Xcuw")).createContactsResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                (0, (0, parcelRequire("1Xcuw")).createNotificationPreferencesResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                (0, (0, parcelRequire("ldKOT")).eocUserResource),
                (0, (0, parcelRequire("1Xcuw")).createMuteResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                (0, (0, parcelRequire("1Xcuw")).createQuietHoursResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                (0, (0, parcelRequire("1Xcuw")).createForwardingRulesResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationForgePersonalSettingsPageResources)(),
                ...$5daf430235f9fc0a$var$getLabsResources()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $5daf430235f9fc0a$var$LazyLegacyPersonalSettings
            ]
        }));
    const $5daf430235f9fc0a$export$e8b7e9281fc3db35 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7ziML")).generalPersonalSettingsRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PERSONAL_SETTINGS),
            component: $5daf430235f9fc0a$export$81bedf006ef32751,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROFILE,
                sidebar: (0, $8fc6117fdc2ce1b9$export$2e2bcd8739ae039)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...$5daf430235f9fc0a$var$getLabsResources(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationForgePersonalSettingsPageResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $5daf430235f9fc0a$var$LazyGeneralPersonalSettings
            ]
        }));
    const $5daf430235f9fc0a$export$640c1b3b96c9032e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("d1xZH")).notificationsPersonalSettingsRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PERSONAL_SETTINGS),
            skeleton: (0, (0, parcelRequire("a94gn")).PersonalSettingsNotificationsAppSkeleton),
            component: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                    to: (0, (0, parcelRequire("1C2yb")).getNotificationsPersonalSettingsPath)()
                }),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROFILE,
                sidebar: (0, $8fc6117fdc2ce1b9$export$2e2bcd8739ae039)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationForgePersonalSettingsPageResources)()
            ],
            pageId: 'personal-settings-notifications',
            entryPoint () {
                return $5daf430235f9fc0a$var$personalSettingsNotificationsEntryPointPage;
            }
        }));
    const $5daf430235f9fc0a$export$d604d3ad2662a845 = [
        $5daf430235f9fc0a$export$89646e32fa7698db,
        $5daf430235f9fc0a$export$e8b7e9281fc3db35,
        $5daf430235f9fc0a$export$640c1b3b96c9032e,
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $84075aa9af41e0be$export$68ebdd4eccb7b383), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PERSONAL_SETTINGS),
                component: $5daf430235f9fc0a$export$e30af76ba1def364,
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROFILE,
                    sidebar: (0, $8fc6117fdc2ce1b9$export$2e2bcd8739ae039)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("1Xcuw")).createContactsResource)(),
                    (0, (0, parcelRequire("1Xcuw")).createNotificationPreferencesResource)(),
                    (0, (0, parcelRequire("ldKOT")).eocUserResource),
                    (0, (0, parcelRequire("1Xcuw")).createMuteResource)(),
                    (0, (0, parcelRequire("1Xcuw")).createQuietHoursResource)(),
                    (0, (0, parcelRequire("1Xcuw")).createForwardingRulesResource)(),
                    ...(0, (0, parcelRequire("5bkvv")).getNavigationForgePersonalSettingsPageResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $5daf430235f9fc0a$var$LazyOpsNotificationsPersonalSettings
                ]
            }))
    ];
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $31434a8eaec0208e$export$d415b74f78a5f159 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_COLLECTIONS),
        path: '/jira/polaris/roadmaps/:collectionUUID?/:section?/:resource?',
        query: [
            'projects?',
            'owners?'
        ],
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $dWQF5;
    var $7yO8g;
    var $5j7Th;
    var $9OXo1;
    var $kxZPA;
    var $7tQej;
    const $1bfc7c5d195e4066$export$f7960e7dbd7e5265 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1feyJ"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/collections/src/index.tsx"
    });
    const $1bfc7c5d195e4066$var$useJpdLicensed = ()=>{
        const context = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return context.licensedProducts['jira-product-discovery'];
    };
    const $1bfc7c5d195e4066$export$3bba33442c4150b1 = ()=>{
        const jpdLicensed = $1bfc7c5d195e4066$var$useJpdLicensed();
        const crossProjectViewsEnabled = (0, (0, parcelRequire("dWQF5")).useIsCrossProjectViewsEnabled)();
        if (!jpdLicensed) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: "/jira/polaris/unlicensed"
        });
        if (!crossProjectViewsEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: "/jira"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1bfc7c5d195e4066$export$f7960e7dbd7e5265,
            pageId: "async-polaris-collections",
            shouldShowSpinner: false
        });
    };
    var $1bfc7c5d195e4066$export$2e2bcd8739ae039 = $1bfc7c5d195e4066$export$3bba33442c4150b1;
    const $4aedad13e1b8926d$export$a034dc25c21d1029 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $31434a8eaec0208e$export$d415b74f78a5f159), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_POLARIS),
            ufoName: 'jpd.collections',
            component: (0, $1bfc7c5d195e4066$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            canTransitionIn: ()=>{
                return true;
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1bfc7c5d195e4066$export$f7960e7dbd7e5265)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $4R6GH;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $3HwlS;
    var $1Du13;
    var $aPfsS;
    const $501e6cef37d28e94$export$d5273c1a2e2fe212 = (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout));
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $3378a983c17fef3f$export$54c333cd4ed2d70e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_IDEAS),
        path: '/jira/polaris/projects/:projectKey/ideas/:section?/:resource?',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $9OXo1;
    var $kxZPA;
    var $7tQej;
    const $9c1678c5da04bd73$export$3fd7cf4494189548 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("g2CVx"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/ideas/src/index.tsx"
    });
    const $9c1678c5da04bd73$var$useJpdLicensed = ()=>{
        const context = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return context.licensedProducts['jira-product-discovery'];
    };
    const $9c1678c5da04bd73$export$8e495e768b5bbae5 = ()=>{
        const jpdLicensed = $9c1678c5da04bd73$var$useJpdLicensed();
        if (!jpdLicensed) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: "/jira/polaris/unlicensed"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9c1678c5da04bd73$export$3fd7cf4494189548,
            pageId: "async-polaris-ideas",
            shouldShowSpinner: false
        });
    };
    var $9c1678c5da04bd73$export$2e2bcd8739ae039 = $9c1678c5da04bd73$export$8e495e768b5bbae5;
    const $a75ffafad7078936$export$26631f98f007b2d2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3378a983c17fef3f$export$54c333cd4ed2d70e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_POLARIS),
            ufoName: 'jpd.project',
            component: (0, $9c1678c5da04bd73$export$2e2bcd8739ae039),
            layout: (0, $501e6cef37d28e94$export$d5273c1a2e2fe212),
            canTransitionIn: (current, next)=>{
                if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && !(0, (0, parcelRequire("4R6GH")).fg)('jpd-nav-v4-disable-page-refresh-between-projects') && current?.match?.params?.projectKey && next?.match?.params?.projectKey && current.match.params.projectKey !== next.match.params.projectKey) return false;
                return true;
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9c1678c5da04bd73$export$3fd7cf4494189548)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $aFVvc;
    var $65Ltd;
    const $d7e18a0721187b3f$export$6696e9deb45fe980 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_ONBOARDING),
        path: '/welcome/discovery',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ff87f692d7c58a17$export$13889cc3ce0d5a93 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("h9Vsi"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/onboarding/src/index.tsx"
    });
    var $ff87f692d7c58a17$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff87f692d7c58a17$export$13889cc3ce0d5a93,
            pageId: "async-polaris-onboarding",
            shouldShowSpinner: false
        });
    const $9a1e9d5292b9a0dc$export$a297a71cb150e2af = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d7e18a0721187b3f$export$6696e9deb45fe980), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_POLARIS),
            component: (0, $ff87f692d7c58a17$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            canTransitionIn: ()=>true,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ff87f692d7c58a17$export$13889cc3ce0d5a93)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $5cb169f7c1c57d8b$export$bfdcdf76e802d67d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_SETTINGS_ACCESS),
        path: '/jira/settings/products/jira-product-discovery/access',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ff4634525ed299f8$export$b66ea0dcd38af7f0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2se5U"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/settings-access/src/index.tsx"
    });
    const $ff4634525ed299f8$export$d46497fe68b0853c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff4634525ed299f8$export$b66ea0dcd38af7f0,
            pageId: "async-polaris-settings-access",
            shouldShowSpinner: false
        });
    const $23f05070dbae84f0$export$9c0f51630c25c3d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5cb169f7c1c57d8b$export$bfdcdf76e802d67d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $ff4634525ed299f8$export$d46497fe68b0853c),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ff4634525ed299f8$export$b66ea0dcd38af7f0)
            ]
        }));
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $1d178fd38105ca54$export$d1d77b6a84982ab8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_SETTINGS_GLOBAL_FIELDS),
        path: '/jira/settings/products/jira-product-discovery/global-fields',
        exact: true
    };
    var $lmyls;
    var $eufEc;
    var $fEDBv;
    const $7946c690dff6c696$export$f2f24531058bc251 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("dICLE")), {
            moduleId: "fead11bc"
        }),
        getPreloadProps: ()=>({})
    });
    const $dd5db072b96b7a9a$export$c682ebcd2290352f = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $7946c690dff6c696$export$f2f24531058bc251),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS
    });
    const $8b674ae9037c6c90$export$e29465c661741392 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1d178fd38105ca54$export$d1d77b6a84982ab8), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            entryPoint () {
                return 0, $dd5db072b96b7a9a$export$c682ebcd2290352f;
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $aFVvc;
    var $65Ltd;
    const $451d03603cca57ae$export$32b1bc71501d2751 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_UNLICENSED),
        path: '/jira/polaris/unlicensed',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $14579de685a40428$export$394984ca86b38b8f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("itokL"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/unlicensed/src/index.tsx"
    });
    var $14579de685a40428$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $14579de685a40428$export$394984ca86b38b8f,
            pageId: "async-polaris-unlicensed",
            shouldShowSpinner: false
        });
    const $ed78a6ddbb53401e$export$f975154b9b0ce777 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $451d03603cca57ae$export$32b1bc71501d2751), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_POLARIS),
            component: (0, $14579de685a40428$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            canTransitionIn: ()=>true,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $14579de685a40428$export$394984ca86b38b8f)
            ]
        }));
    const $a401463e87f56f84$export$44e0cb320cb148ed = [
        (0, $4aedad13e1b8926d$export$a034dc25c21d1029),
        (0, $a75ffafad7078936$export$26631f98f007b2d2),
        (0, $9a1e9d5292b9a0dc$export$a297a71cb150e2af),
        (0, $23f05070dbae84f0$export$9c0f51630c25c3d),
        (0, $8b674ae9037c6c90$export$e29465c661741392),
        (0, $ed78a6ddbb53401e$export$f975154b9b0ce777)
    ];
    var $aIZdc;
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $5lsNZ;
    var $65Ltd;
    const $233b8dbf88e7279c$export$7c663ddc097df1e8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS),
        path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2b1085a0fa643a34$export$1b7f55251df02fe9 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("i7K01"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-chatops-and-video-tools/src/index.tsx"
    });
    var $2b1085a0fa643a34$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2b1085a0fa643a34$export$1b7f55251df02fe9,
            pageId: "products-jsm-chatops-and-video-tools",
            shouldShowSpinner: false
        });
    const $070da13ff0ee1dfd$export$8b55e723205ec5f3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $233b8dbf88e7279c$export$7c663ddc097df1e8), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("aIZdc")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $2b1085a0fa643a34$export$2e2bcd8739ae039)),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, $cd33ec0afa28f27a$export$1f7a0efe3746ea0d),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, $cd33ec0afa28f27a$export$aea682543f08e131),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2b1085a0fa643a34$export$1b7f55251df02fe9)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $7de4aa1c0a8e9753$export$6196bf08f64419da = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_COMPLIANCE),
        path: '/jira/settings/products/jira-service-management-compliance',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $62ef4b19010ca280$export$159d8c0e1862cd2b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1Uh9p"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-compliance/src/index.tsx"
    });
    var $62ef4b19010ca280$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $62ef4b19010ca280$export$159d8c0e1862cd2b,
            pageId: "products-jsm-compliance",
            shouldShowSpinner: false
        });
    const $174710657e8d90a3$export$9cc9423a3967333b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7de4aa1c0a8e9753$export$6196bf08f64419da), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $62ef4b19010ca280$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $62ef4b19010ca280$export$159d8c0e1862cd2b)
            ],
            ufoName: 'admin.jsm-compliance'
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $7d2ff473ef6296e1$export$2ad48fbde4743a97 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_CONFIGURATION),
        path: '/jira/settings/products/jira-service-management-configuration',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2e07bdac6faf88fe$export$aa3f3d5ca376f305 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("aXNfQ"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-configuration/src/index.tsx"
    });
    var $2e07bdac6faf88fe$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e07bdac6faf88fe$export$aa3f3d5ca376f305,
            pageId: "products-jsm-configuration",
            shouldShowSpinner: false
        });
    const $774aaf4ac519071a$export$461f2b06a7a914db = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7d2ff473ef6296e1$export$2ad48fbde4743a97), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.jsm-configuration',
            component: (0, $2e07bdac6faf88fe$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2e07bdac6faf88fe$export$aa3f3d5ca376f305)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $7687bd61dacb24e9$export$6288bb6ea42acf0c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_EMAIL_REQUESTS),
        path: '/jira/settings/products/jira-service-management-email-requests',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f8c99b7a302373fc$export$4c9d90d0caf04d67 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("exMfY"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-email-requests/src/index.tsx"
    });
    var $f8c99b7a302373fc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f8c99b7a302373fc$export$4c9d90d0caf04d67,
            pageId: "products-jsm-email-requests",
            shouldShowSpinner: false
        });
    const $b3d6f3f852ae8387$export$3f8d7424a47f4dd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7687bd61dacb24e9$export$6288bb6ea42acf0c), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.jsm-email-requests',
            component: (0, $f8c99b7a302373fc$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $f8c99b7a302373fc$export$4c9d90d0caf04d67)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $dcb61f2507bdacb1$export$f98dec539fffaa15 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_FEATURE_USAGE),
        path: '/jira/settings/products/servicedesk/feature-usage',
        exact: true
    };
    var $gRzZD;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $48028ef535c008c9$export$5ad1c1e822bd5d34 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("793wN"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-feature-usage/src/index.tsx"
    });
    var $48028ef535c008c9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $48028ef535c008c9$export$5ad1c1e822bd5d34,
            pageId: "products-jsm-feature-usage",
            shouldShowSpinner: false
        });
    const $ff94c4ea1a42404b$export$80a3e4dda2dcd1a4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $dcb61f2507bdacb1$export$f98dec539fffaa15), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $48028ef535c008c9$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("gRzZD")).workspaceResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $48028ef535c008c9$export$5ad1c1e822bd5d34)
            ]
        }));
    var $dY89w;
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $3e538dded475ec91$export$c6d42e4b4a63248d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS),
        path: '/jira/settings/products/ops/reports',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $59dec6d88aab4fac$export$2404f0e35deca592 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5m16R")), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $59dec6d88aab4fac$export$d33ea1a773b744e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5m16R")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $59dec6d88aab4fac$export$66850ec5549adba6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5m16R")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $59dec6d88aab4fac$export$22253dbadb46d0cf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $59dec6d88aab4fac$export$d33ea1a773b744e,
            pageId: "async-jira-eoc-ops-reports-redirect",
            shouldShowSpinner: false
        });
    const $59dec6d88aab4fac$export$648ddf2d1f8b1c3f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $59dec6d88aab4fac$export$66850ec5549adba6,
            pageId: "async-jira-eoc-global-ops-reports",
            shouldShowSpinner: false
        });
    const $59dec6d88aab4fac$export$87e6a54b4f5dc91e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $59dec6d88aab4fac$export$2404f0e35deca592,
            pageId: "async-jira-eoc-ops-reports",
            shouldShowSpinner: false
        });
    const $5f3f997c6af1c603$export$289cc03f2eacd57a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3e538dded475ec91$export$c6d42e4b4a63248d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $59dec6d88aab4fac$export$22253dbadb46d0cf),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("dY89w")).resources),
                (0, (0, parcelRequire("dY89w")).opsReportsPermissionResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $59dec6d88aab4fac$export$66850ec5549adba6)
            ]
        }));
    var $dY89w;
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $126ddc8c4a59a59a$export$d92d66762943b115 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS),
        path: '/jira/settings/products/ops/reports/:dashboardId',
        exact: true
    };
    const $61761389ad3b32bd$export$6a7fc41fb2523290 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $126ddc8c4a59a59a$export$d92d66762943b115), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $59dec6d88aab4fac$export$648ddf2d1f8b1c3f),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("dY89w")).resources),
                (0, (0, parcelRequire("dY89w")).opsReportsPermissionResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $59dec6d88aab4fac$export$d33ea1a773b744e)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $1d5dbffa04bebbb5$export$da6d538ddabade32 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS),
        path: '/jira/settings/products/jira-service-management-incident-management-tools',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $63d70171d6cec69e$export$f541eb9b8f00bfaf = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3EZ2Y"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-incident-management-tools/src/index.tsx"
    });
    var $63d70171d6cec69e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $63d70171d6cec69e$export$f541eb9b8f00bfaf,
            pageId: "products-jsm-incident-management-tools",
            shouldShowSpinner: false
        });
    const $954e97d3acac763c$export$773f8e3318be1dd5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1d5dbffa04bebbb5$export$da6d538ddabade32), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $63d70171d6cec69e$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $63d70171d6cec69e$export$f541eb9b8f00bfaf)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $a35de718c16ba9da$export$339486410c7a783f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_KB_PERMISSIONS),
        path: '/jira/settings/products/jira-service-management-knowledge-base-permissions',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $724367026054fd0c$export$a3e7bdc5dbf2d47e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lNXgd"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-kb-permissions/src/index.tsx"
    });
    var $724367026054fd0c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $724367026054fd0c$export$a3e7bdc5dbf2d47e,
            pageId: "products-jsm-kb-permissions",
            shouldShowSpinner: false
        });
    const $b6759abef36b3efc$export$717e134eb971b450 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a35de718c16ba9da$export$339486410c7a783f), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $724367026054fd0c$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $724367026054fd0c$export$a3e7bdc5dbf2d47e)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $38BXB;
    var $7CBZS;
    var $6nu63;
    var $esddG;
    var $3RJkv;
    var $65Ltd;
    const $a0ada8abfade1bcc$export$bc61991d01535831 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS),
        path: '/jira/settings/products/servicedesk/organizations/:organizationId',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2542e7a566ffd224$export$ff149ceefa65ab70 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dunr3"))), {
        moduleId: "./src/packages/admin-pages/products-jsm-organization-details/src/ui/index.tsx"
    });
    var $2542e7a566ffd224$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2542e7a566ffd224$export$ff149ceefa65ab70,
            pageId: "products-jsm-organization-details",
            shouldShowSpinner: true
        });
    const $d5f0f03722be4af7$export$f7b6cda88404733e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a0ada8abfade1bcc$export$bc61991d01535831), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.jsm-organization-page-list',
            isRedirect: false,
            component: (0, $2542e7a566ffd224$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("7CBZS")).productsJsmOrganizationDetailsResource),
                (0, (0, parcelRequire("6nu63")).productsJsmOrganizationMembersResource),
                (0, (0, parcelRequire("esddG")).productsJsmOrganizationListResource),
                (0, (0, parcelRequire("38BXB")).jsmEmailDomainsListResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2542e7a566ffd224$export$ff149ceefa65ab70)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $esddG;
    var $3RJkv;
    var $65Ltd;
    const $aff64887f4e5e03c$export$512fa30726e0049d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS),
        path: '/jira/settings/products/servicedesk/organizations',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $34fecedc618348fb$export$410bec6e06fd4723 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("eUhw3"))), {
        moduleId: "./src/packages/admin-pages/products-jsm-organizations-list/src/ui/index.tsx"
    });
    var $34fecedc618348fb$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $34fecedc618348fb$export$410bec6e06fd4723,
            pageId: "products-jsm-organizations-list",
            shouldShowSpinner: true
        });
    const $5dc17715cd6fddea$export$34d843946d3894aa = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $aff64887f4e5e03c$export$512fa30726e0049d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.jsm-organization-page-list',
            isRedirect: false,
            component: (0, $34fecedc618348fb$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("esddG")).productsJsmOrganizationListResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $34fecedc618348fb$export$410bec6e06fd4723)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $hwXlc;
    var $8dDE8;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $90ae9e1263695143$export$f9a32397033f9ced = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2BgIE"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-configuration/src/index.tsx"
    });
    var $90ae9e1263695143$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $90ae9e1263695143$export$f9a32397033f9ced,
            pageId: "products-jsw-configuration",
            shouldShowSpinner: false
        });
    const $1733bfec88a8a7ea$export$2f65b1ec4ed05f91 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8dDE8")).productsJswConfigurationRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.jsw-configuration',
            component: (0, $90ae9e1263695143$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("hwXlc")).productsJswConfigurationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $90ae9e1263695143$export$f9a32397033f9ced)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $1vQWT;
    var $65Ltd;
    const $a8588348d631ccae$export$6e126b0e7eabff82 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSW_STORAGE_MANAGEMENT),
        path: '/jira/settings/products/jira-software-configuration/storage-management',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $bad793b8f28a1de3$export$a4f5e12ce817cbb8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fqiq7"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-storage-management/src/index.tsx"
    });
    var $bad793b8f28a1de3$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bad793b8f28a1de3$export$a4f5e12ce817cbb8,
            pageId: "products-jsw-storage-management",
            shouldShowSpinner: true
        });
    const $ebdca188f3705262$export$c62ca2d3fcc552a5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a8588348d631ccae$export$6e126b0e7eabff82), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.jsw-configuration.storage-management',
            component: (0, $bad793b8f28a1de3$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("1vQWT")).productsJswStorageManagementResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $bad793b8f28a1de3$export$a4f5e12ce817cbb8)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $e9663b2cd0ceb8c1$export$5130d152b1cda229 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_EXPORT),
        path: '/jira/forms/export',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $f012061ea42d3cc1$export$5e0d802a5d865352 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("kQwOl")), {
        moduleId: "./src/packages/spa-apps/proforma-export/src/index.tsx"
    });
    var $f012061ea42d3cc1$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f012061ea42d3cc1$export$5e0d802a5d865352,
            pageId: "proforma-export",
            shouldShowSpinner: true
        });
    const $6ada90d55b94e879$export$27be010fc1b30f6c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e9663b2cd0ceb8c1$export$5130d152b1cda229), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            component: (0, $f012061ea42d3cc1$export$2e2bcd8739ae039),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $f012061ea42d3cc1$export$5e0d802a5d865352)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $6484903254af07fd$export$5e0c19066a4c3806 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL),
        path: '/jira/forms/create',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $06427390ad9a129c$export$7c16b09eb95f1c5d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jISyc")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-general/src/index.tsx"
    });
    var $06427390ad9a129c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $06427390ad9a129c$export$7c16b09eb95f1c5d,
            pageId: "proforma-issue-forms-general",
            shouldShowSpinner: true
        });
    const $8d5b2002b38c1828$export$90d7a2fe9ba3bc11 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6484903254af07fd$export$5e0c19066a4c3806), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            component: (0, $06427390ad9a129c$export$2e2bcd8739ae039),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $06427390ad9a129c$export$7c16b09eb95f1c5d)
            ],
            perfMetricKey: 'issue-forms-general'
        }));
    var $65Ltd;
    var $2G9Bk;
    var $dxCvy;
    var $65Ltd;
    const $f7740074df1fc82b$export$b7262fe486f4b412 = 'core';
    const $f7740074df1fc82b$export$2954328f6207617a = 'software';
    const $f7740074df1fc82b$export$5575497f0592ee94 = 'servicedesk';
    const $f7740074df1fc82b$export$c89a2c7b5735cd87 = 'projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?';
    const $937decdff60229d5$export$55ce393dc053bec4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_CLASSIC_BUSINESS),
        path: `/jira/${(0, $f7740074df1fc82b$export$b7262fe486f4b412)}/${(0, $f7740074df1fc82b$export$c89a2c7b5735cd87)}/embed`,
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $321227a7cf9935db$export$22681210aaeb910f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5LZ4w")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
    });
    var $321227a7cf9935db$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $321227a7cf9935db$export$22681210aaeb910f,
            pageId: "proforma-issue-forms-direct-embed",
            shouldShowSpinner: true
        });
    const $0d21ee6685c8bd5a$export$7d132f335f852c6e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $937decdff60229d5$export$55ce393dc053bec4), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            resources: [
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            component: (0, $321227a7cf9935db$export$2e2bcd8739ae039),
            forPaint: [
                (0, $321227a7cf9935db$export$22681210aaeb910f)
            ],
            perfMetricKey: 'issue-forms-direct-embed'
        }));
    var $65Ltd;
    var $18N1t;
    var $lmyls;
    var $2G9Bk;
    var $dxCvy;
    var $65Ltd;
    const $912480f1ad26095e$export$76ab9f3014b2e370 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_CLASSIC_BUSINESS),
        path: `/jira/${(0, $f7740074df1fc82b$export$b7262fe486f4b412)}/${(0, $f7740074df1fc82b$export$c89a2c7b5735cd87)}`,
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $33e9f81a484baab5$export$a0f04dd35569e11 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("1NWtC")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct/src/index.tsx"
    });
    var $33e9f81a484baab5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $33e9f81a484baab5$export$a0f04dd35569e11,
            pageId: "proforma-issue-forms-direct",
            shouldShowSpinner: true
        });
    const $821c1a4ddda27ddd$export$14047a53c7c79a48 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $912480f1ad26095e$export$76ab9f3014b2e370), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            component: (0, $33e9f81a484baab5$export$2e2bcd8739ae039),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            forPaint: [
                (0, $33e9f81a484baab5$export$a0f04dd35569e11)
            ],
            perfMetricKey: 'issue-forms-direct'
        }));
    var $65Ltd;
    var $2G9Bk;
    var $dxCvy;
    var $65Ltd;
    const $9287bbee32d6135b$export$d48be9e2caaca83d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SERVICEDESK),
        path: `/jira/${(0, $f7740074df1fc82b$export$5575497f0592ee94)}/${(0, $f7740074df1fc82b$export$c89a2c7b5735cd87)}/embed`,
        exact: true
    };
    const $5d397d8509ca5a2f$export$aee58781a360177c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9287bbee32d6135b$export$d48be9e2caaca83d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            resources: [
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            component: (0, $321227a7cf9935db$export$2e2bcd8739ae039),
            forPaint: [
                (0, $321227a7cf9935db$export$22681210aaeb910f)
            ],
            perfMetricKey: 'issue-forms-direct-embed'
        }));
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $dxCvy;
    var $65Ltd;
    const $2f8963b0b6c1eb4a$export$574435c4e2f6a27e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SERVICEDESK),
        path: `/jira/${(0, $f7740074df1fc82b$export$5575497f0592ee94)}/${(0, $f7740074df1fc82b$export$c89a2c7b5735cd87)}`,
        exact: true
    };
    var $6Z2mh;
    const $1e962caa58edcf31$export$e95be402bc1a646a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2f8963b0b6c1eb4a$export$574435c4e2f6a27e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            resources: [
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            component: (0, $33e9f81a484baab5$export$2e2bcd8739ae039),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            forPaint: [
                (0, $33e9f81a484baab5$export$a0f04dd35569e11)
            ],
            perfMetricKey: 'issue-forms-direct'
        }));
    var $65Ltd;
    var $2G9Bk;
    var $dxCvy;
    var $65Ltd;
    const $80dd4f00466dd505$export$cd0e54104fd6e37c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SOFTWARE),
        path: `/jira/${(0, $f7740074df1fc82b$export$2954328f6207617a)}/${(0, $f7740074df1fc82b$export$c89a2c7b5735cd87)}/embed`,
        exact: true
    };
    const $119aabab50d41e92$export$7234db75929ebc52 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $80dd4f00466dd505$export$cd0e54104fd6e37c), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            resources: [
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            component: (0, $321227a7cf9935db$export$2e2bcd8739ae039),
            forPaint: [
                (0, $321227a7cf9935db$export$22681210aaeb910f)
            ],
            perfMetricKey: 'issue-forms-direct-embed'
        }));
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $dxCvy;
    var $65Ltd;
    const $cb2335f194390bc8$export$c02a5b8ecf73713e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SOFTWARE),
        path: `/jira/${(0, $f7740074df1fc82b$export$2954328f6207617a)}/${(0, $f7740074df1fc82b$export$c89a2c7b5735cd87)}`,
        exact: true
    };
    var $e7bC3;
    const $61850d407ce9e191$export$a0e51305c115ecf7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cb2335f194390bc8$export$c02a5b8ecf73713e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
            resources: [
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            component: (0, $33e9f81a484baab5$export$2e2bcd8739ae039),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            forPaint: [
                (0, $33e9f81a484baab5$export$a0f04dd35569e11)
            ],
            perfMetricKey: 'issue-forms-direct'
        }));
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $xNRJ9;
    var $dxCvy;
    var $7GnDe;
    const $650eb9307abab3e5$export$1d7a0c194c3e83f2 = [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:components-page'
    ];
    var $65Ltd;
    const $ca17ca5646521c59$export$d370abe25253fa1b = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_COMPONENTS)}-redirect`,
        path: '/projects/:projectKey',
        query: (0, $650eb9307abab3e5$export$1d7a0c194c3e83f2)
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $2NMNM;
    var $dxCvy;
    var $bVDE5;
    var $7tQej;
    var $2YP9W;
    var $doZTA;
    const $d19b3848ac7d27f0$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, (0, parcelRequire("7tQej")).Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useResource: useResource = (0, (0, parcelRequire("2YP9W")).useResource), useRouter: useRouter = (0, (0, parcelRequire("doZTA")).useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
    const $15d396b2dbadf93f$export$f32c20cfbc84532c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("eVMKF"))), {
        moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
    });
    const $15d396b2dbadf93f$export$9cf9ae84482ff18e = ()=>{
        const page = (_, { selectedItem: selectedItem, ...rest })=>{
            const querystring = (0, $aZsz6.qs).stringify(rest, true);
            return `/components${querystring}`;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $d19b3848ac7d27f0$export$8a3df560509448b8), {
            page: page
        });
    };
    var $15d396b2dbadf93f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $15d396b2dbadf93f$export$f32c20cfbc84532c,
            pageId: "project-components",
            shouldShowSpinner: false
        });
    const $4b7fc303ce7a2a17$export$b498607b4440c4ef = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ca17ca5646521c59$export$d370abe25253fa1b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
            component: !false ? (0, $15d396b2dbadf93f$export$9cf9ae84482ff18e) : (0, $15d396b2dbadf93f$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("xNRJ9")).projectsComponentsResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $15d396b2dbadf93f$export$f32c20cfbc84532c)
            ],
            isRedirect: true
        }));
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $xNRJ9;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $c0c0fb35b16dfdd1$export$f76189bea494b0b8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_COMPONENTS),
        path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/components'
    };
    const $97d73743db912d34$export$e60f53ff5ae626cd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c0c0fb35b16dfdd1$export$f76189bea494b0b8), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
            ufoName: 'project-components-view',
            component: (0, $15d396b2dbadf93f$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("xNRJ9")).projectsComponentsResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $15d396b2dbadf93f$export$f32c20cfbc84532c)
            ]
        }));
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $5f4b2f1efa38e84e$export$ad23ddca45852d02 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_NOT_FOUND),
        path: '/jira/:projectType(software|servicedesk|core|polaris)/projects/not-found',
        exact: true
    };
    var $eufEc;
    var $fEDBv;
    const $ad3635ddd4e67df5$export$6ffa2f426ba3b25a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("kI4TI")), {
            moduleId: "51ed29c5"
        }),
        getPreloadProps: ()=>({})
    });
    const $292badf40134cb3e$export$f5a338b3fe5182bb = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $ad3635ddd4e67df5$export$6ffa2f426ba3b25a),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $292badf40134cb3e$export$beae48175e3016b8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5f4b2f1efa38e84e$export$ad23ddca45852d02), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ERRORS),
            entryPoint () {
                return $292badf40134cb3e$export$f5a338b3fe5182bb;
            },
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            pageId: 'project-not-found-page-id'
        }));
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $25092ed805d69948$export$a82cbb9b9c689c40 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES)}-legacy`,
        path: '/projects/:projectKey',
        query: [
            'selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page'
        ]
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $2NMNM;
    var $dxCvy;
    var $bVDE5;
    var $7tQej;
    var $2YP9W;
    var $doZTA;
    const $b1c3ef54235a025d$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, (0, parcelRequire("7tQej")).Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useResource: useResource = (0, (0, parcelRequire("2YP9W")).useResource), useRouter: useRouter = (0, (0, parcelRequire("doZTA")).useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
    const $4be66c9d92628f7f$export$c2115a649411f570 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("VGEuh"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/project/pages/src/index.tsx"
    });
    const $4be66c9d92628f7f$export$7c3b1828ada63555 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $b1c3ef54235a025d$export$8a3df560509448b8), {
            page: "/pages"
        });
    var $4be66c9d92628f7f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4be66c9d92628f7f$export$c2115a649411f570,
            pageId: "project-pages",
            shouldShowSpinner: false
        });
    const $5b3bb769f5acfa20$export$5788c5f8c4e440b1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $25092ed805d69948$export$a82cbb9b9c689c40), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: !false ? (0, $4be66c9d92628f7f$export$7c3b1828ada63555) : (0, $4be66c9d92628f7f$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $4be66c9d92628f7f$export$c2115a649411f570)
            ],
            isRedirect: true
        }));
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $b32f9068985446b1$export$54a218ca6d1c056a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES),
        path: '/jira/:projectType(software|software/c|servicedesk)/projects/:projectKey/pages'
    };
    var $kfztd;
    const $ec177ab479977ba2$export$babf32528ef518e9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b32f9068985446b1$export$54a218ca6d1c056a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $4be66c9d92628f7f$export$2e2bcd8739ae039)),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $4be66c9d92628f7f$export$c2115a649411f570)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $xNRJ9;
    var $dxCvy;
    var $7GnDe;
    var $cQsSp;
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $2NMNM;
    var $dxCvy;
    var $bVDE5;
    var $7tQej;
    var $2YP9W;
    var $doZTA;
    const $55786e10b01ad2e7$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, (0, parcelRequire("7tQej")).Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useResource: useResource = (0, (0, parcelRequire("2YP9W")).useResource), useRouter: useRouter = (0, (0, parcelRequire("doZTA")).useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
    const $2794979f407c5b17$export$bb69d8c36391123 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("eVMKF"))), {
        moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
    });
    const $2794979f407c5b17$export$60cfbcd781a48d01 = ()=>{
        const page = (_, { selectedItem: selectedItem, ...rest })=>{
            const querystring = (0, $aZsz6.qs).stringify(rest, true);
            return `/settings/components${querystring}`;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $55786e10b01ad2e7$export$8a3df560509448b8), {
            page: page
        });
    };
    var $2794979f407c5b17$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2794979f407c5b17$export$bb69d8c36391123,
            pageId: "project-settings-components",
            shouldShowSpinner: true
        });
    const $ad71816b701c4a98$export$72497f4e39dd0df4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cQsSp")).projectSettingsComponentsRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("xNRJ9")).projectsComponentsResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: (0, $2794979f407c5b17$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2794979f407c5b17$export$bb69d8c36391123)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $bC7QJ;
    var $7GnDe;
    var $cXVqt;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $4b5729de9815f9dc$export$9036da4fa9f7a66f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8gvY1"))), {
        moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
    });
    const $4b5729de9815f9dc$export$9aff7dab80671d9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4b5729de9815f9dc$export$9036da4fa9f7a66f,
            pageId: "relay-project-versions",
            shouldShowSpinner: false
        });
    const $1aa15c245eff2860$export$4791201b4877aa5d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cXVqt")).projectSettingsVersionsRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bC7QJ")).projectVersionsRelayResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: (0, $4b5729de9815f9dc$export$9aff7dab80671d9),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $4b5729de9815f9dc$export$9036da4fa9f7a66f)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $7MCPm;
    var $2iuKi;
    const $c72266bbdc090734$export$56f9921db324f30 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2iuKi")).projectsRedirectRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_REDIRECTS),
            isRedirect: true,
            component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $bC7QJ;
    var $7GnDe;
    const $91224398be5e0171$export$ad46185437bb571a = [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:release-page'
    ];
    var $65Ltd;
    const $4cfeade459489896$export$fb5516756c3eba40 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_VERSIONS),
        path: '/projects/:projectKey',
        query: (0, $91224398be5e0171$export$ad46185437bb571a)
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $3890e3ec7715d603$export$9036da4fa9f7a66f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8gvY1"))), {
        moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
    });
    const $3890e3ec7715d603$export$9aff7dab80671d9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3890e3ec7715d603$export$9036da4fa9f7a66f,
            pageId: "relay-project-versions",
            shouldShowSpinner: false
        });
    const $3890e3ec7715d603$export$982bc443ef89cc3f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $4cfeade459489896$export$fb5516756c3eba40), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("bC7QJ")).projectVersionsRelayResource)
            ],
            component: $3890e3ec7715d603$export$9aff7dab80671d9,
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $3890e3ec7715d603$export$9036da4fa9f7a66f
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $cSD7y;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $5lsNZ;
    var $65Ltd;
    const $714e07557512b4c7$export$cb08569a5439c36a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ROVO_DEMAND_TESTS),
        path: '/jira/software/rovo/discover'
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $024c87aebde011e4$export$ad2594850aa1640c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4OVrg"))), {
        moduleId: "./src/packages/spa-apps/rovo-demand-tests/src/index.tsx"
    });
    const $024c87aebde011e4$export$12d166f59b63486e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $024c87aebde011e4$export$ad2594850aa1640c,
            pageId: "rovo-demand-tests",
            shouldShowSpinner: false
        });
    const $024c87aebde011e4$export$95ed5e2f774d3f79 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $714e07557512b4c7$export$cb08569a5439c36a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_rovo_demand_tests_gate', $024c87aebde011e4$export$12d166f59b63486e, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $024c87aebde011e4$export$ad2594850aa1640c
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $cSD7y;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $5lsNZ;
    var $65Ltd;
    const $6960cabbf4f590ee$export$b759d50126e9e39 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SANDBOX_BUNDLER),
        path: '/jira/software/sandbox/bundler',
        exact: true
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $86244a2581bcbace$var$LazyBundlerSandboxPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("cMc6T"))), {
        moduleId: "./src/packages/spa-apps/sandbox/bundler/src/index.tsx"
    });
    const $86244a2581bcbace$var$BundlerSandbox = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $86244a2581bcbace$var$LazyBundlerSandboxPage,
            pageId: "bundler-sandbox",
            shouldShowSpinner: true
        });
    const $86244a2581bcbace$export$9e08a24be2acc3b6 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6960cabbf4f590ee$export$b759d50126e9e39), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SANDBOX),
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('conditional_import_sandbox', $86244a2581bcbace$var$BundlerSandbox, (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $86244a2581bcbace$var$LazyBundlerSandboxPage
                ],
                ufoName: 'bundler-sandbox'
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $e4B7v;
    var $7fRd9;
    var $aitbf;
    var $6Z2mh;
    var $e9YVH;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $e27fdc04f14a6641$var$LazyServicedeskCustomerServiceEscalations = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dEz0W"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/customer-service-escalations/src/index.tsx"
    });
    const $e27fdc04f14a6641$export$1a08682f4847bb2f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e27fdc04f14a6641$var$LazyServicedeskCustomerServiceEscalations,
            pageId: "spa-apps/servicedesk/customer-service-escalations",
            shouldShowSpinner: true
        });
    const $e27fdc04f14a6641$export$36a7c374f4474cc1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aitbf")).escalationsRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("e4B7v")).componentFilterResource),
                (0, (0, parcelRequire("7fRd9")).priorityFilterResource)
            ],
            component: $e27fdc04f14a6641$export$1a08682f4847bb2f,
            perfMetricKey: 'jsm-customer-service-escalations-component-load',
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $e27fdc04f14a6641$var$LazyServicedeskCustomerServiceEscalations
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS),
                    teamName: 'boysenberry'
                }
            }
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $c28aa1a42d481780$var$LazyDirectoryNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4P2oj")).then(({ DirectoryHorizontalNav: DirectoryHorizontalNav })=>DirectoryHorizontalNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/directory/src/ui/index.tsx"
    });
    const $c28aa1a42d481780$export$a237f415539577a5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-jsm-directory-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c28aa1a42d481780$var$LazyDirectoryNav, null));
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $fpjJX;
    var $7yABM;
    var $9foRn;
    var $6Z2mh;
    var $e9YVH;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d306aa8b938adbc6$var$LazyServicedeskCustomerServiceProducts = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("aBVSx"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/customer-service-products/src/index.tsx"
    });
    const $d306aa8b938adbc6$export$46ba99069f037d90 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d306aa8b938adbc6$var$LazyServicedeskCustomerServiceProducts,
            pageId: "spa-apps/servicedesk/customer-service-products",
            shouldShowSpinner: true
        });
    const $d306aa8b938adbc6$export$8e015e39dbc90d0b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9foRn")).productsRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, $c28aa1a42d481780$export$a237f415539577a5),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("7yABM")).customerServiceProductsQueryResource)
            ],
            component: $d306aa8b938adbc6$export$46ba99069f037d90,
            perfMetricKey: 'jsm-customer-service-products-component-load',
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $d306aa8b938adbc6$var$LazyServicedeskCustomerServiceProducts
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_SERVICE_PRODUCTS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_SERVICE_PRODUCTS),
                    teamName: 'boysenberry'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $21b53826ac35bfbd$export$b314ab31b2da625b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SETTINGS_AUTOMATION),
        path: '/jira/settings/automation',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $2NMNM;
    var $dxCvy;
    var $bVDE5;
    var $7tQej;
    var $2YP9W;
    var $doZTA;
    const $5f4113c49e08a927$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, (0, parcelRequire("7tQej")).Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useResource: useResource = (0, (0, parcelRequire("2YP9W")).useResource), useRouter: useRouter = (0, (0, parcelRequire("doZTA")).useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
    const $e4cf560ebe587071$export$4189991a2992b828 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9P7lL"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/automation/src/index.tsx"
    });
    const $e4cf560ebe587071$export$7c85ddcd4f0a813f = ()=>{
        const page = (_, { selectedItem: selectedItem, ...rest })=>{
            const querystring = (0, $aZsz6.qs).stringify(rest, true);
            return `/automation${querystring}`;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5f4113c49e08a927$export$8a3df560509448b8), {
            page: page
        });
    };
    var $e4cf560ebe587071$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e4cf560ebe587071$export$4189991a2992b828,
            pageId: "global-automation",
            shouldShowSpinner: false
        });
    const $2c9e65dfb42014f0$export$4df9f9dcaf8565c9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $21b53826ac35bfbd$export$b314ab31b2da625b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $e4cf560ebe587071$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $e4cf560ebe587071$export$4189991a2992b828)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $db5ba62dbec4de6f$export$5097bfaa68f86ca6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG),
        path: '/secure/admin/CmdbObjectFieldConfiguration'
    };
    var $gRzZD;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $03d0290def261ead$export$ccc6da5137e23637 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("613vm"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/cmdb-field-config/src/index.tsx"
    });
    const $03d0290def261ead$export$8dfbe255f554ebab = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $03d0290def261ead$export$ccc6da5137e23637,
            pageId: "admin-pages-cmdb-field-config",
            shouldShowSpinner: true
        });
    const $89fe0e9a025a7c8e$export$c68a412f25295511 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db5ba62dbec4de6f$export$5097bfaa68f86ca6), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.cmdb-field-config',
            component: (0, $03d0290def261ead$export$8dfbe255f554ebab),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("gRzZD")).workspaceResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $03d0290def261ead$export$ccc6da5137e23637)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $5bkvv;
    var $iHiHz;
    var $2G9Bk;
    var $ldGiq;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $79dbadc9937eefab$export$c0ee28def7ef8783 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS),
        path: '/secure/admin/oauth-credentials'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $a25b27e0ebd790aa$export$101baa25055633e8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bPOLu"))), {
        moduleId: "./src/packages/spa-apps/admin-oauth-credentials/src/index.tsx"
    });
    var $a25b27e0ebd790aa$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a25b27e0ebd790aa$export$101baa25055633e8,
            pageId: "admin-oauth-credentials",
            shouldShowSpinner: true
        });
    const $360b9bb3a5e4b35a$export$d1c67ceb7c5e2d6a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $79dbadc9937eefab$export$c0ee28def7ef8783), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $a25b27e0ebd790aa$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("ldGiq")).adminOauthCredentialsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $a25b27e0ebd790aa$export$101baa25055633e8)
            ],
            ufoName: 'admin.oauth-credentials'
        }));
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $4R6GH;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $8a210ca3a1345de5$export$c25273c48ccc0eb9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED),
        path: '/jira/software/projects/:projectKey/get-started',
        exact: true
    };
    var $5PD5h;
    var $e7bC3;
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $beRD7;
    var $4R6GH;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $9d1d716191d31716$export$476740ebaf571ecc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2AeNp"))), {
        moduleId: "./src/packages/spa-apps/software/onboarding/src/index.tsx"
    });
    const $9d1d716191d31716$var$loadSoftwareOnboardingPage = ()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2AeNp")).catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('router-routes.onboarding.entries.loadSoftwareOnboardingPage', 'Error when loading component', error);
            return ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).JSErrorPageAsync), null);
        }));
    const $9d1d716191d31716$export$984d0318c0541484 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>$9d1d716191d31716$var$loadSoftwareOnboardingPage(), {});
    const $9d1d716191d31716$export$689f7402bb424709 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3YmAs"))), {
        moduleId: "./src/packages/spa-apps/onboarding/get-started/src/index.tsx"
    });
    const $9d1d716191d31716$export$ee768d69c6e3a8bd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, (0, parcelRequire("4R6GH")).fg)('jira-stop-sending-screen-failures-for-load-errors') ? $9d1d716191d31716$export$984d0318c0541484 : $9d1d716191d31716$export$476740ebaf571ecc,
            pageId: "software-onboarding",
            shouldShowSpinner: false
        });
    const $9d1d716191d31716$export$d11bafa06a0717e3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9d1d716191d31716$export$689f7402bb424709,
            pageId: "onboarding-get-started",
            shouldShowSpinner: false
        });
    const $2fac5cfb84bcd36a$export$f08156edd0ce3853 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8a210ca3a1345de5$export$c25273c48ccc0eb9), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_one_screen_onboarding_feature_gate'), (0, $9d1d716191d31716$export$d11bafa06a0717e3), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9d1d716191d31716$export$689f7402bb424709)
            ],
            canTransitionIn: ()=>true,
            ufoName: 'software-onboarding-get-started'
        }));
    var $65Ltd;
    var $4R6GH;
    var $2G9Bk;
    var $c4yut;
    var $2Ql51;
    var $65Ltd;
    const $38b80aa1ac78feb2$export$5e6c92d2f34c1e48 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ONBOARDING),
        path: '/welcome/software',
        exact: true
    };
    const $048906688afed449$export$bb72a943d2340466 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $38b80aa1ac78feb2$export$5e6c92d2f34c1e48), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
            component: (0, $9d1d716191d31716$export$ee768d69c6e3a8bd),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            resources: [
                (0, (0, parcelRequire("c4yut")).jswOnboardingResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("4R6GH")).fg)('jira-stop-sending-screen-failures-for-load-errors') ? (0, $9d1d716191d31716$export$984d0318c0541484) : (0, $9d1d716191d31716$export$476740ebaf571ecc)
            ],
            canTransitionIn: ()=>false
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $4jMkc;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $99acde7d7c12a8d4$export$6eafffd4489b3d4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY),
        path: '/secure/projects/trash',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $5oFIy;
    var $7tQej;
    var $70186afa73ef93b4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "projectsTrashRedirect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: "/jira/settings/projects/trash"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $67a748fd05680154$export$dd65a8ee0a9ac24f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("k31qI"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/trashed-projects/src/index.tsx"
    });
    var $67a748fd05680154$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $67a748fd05680154$export$dd65a8ee0a9ac24f,
            pageId: "trashed-projects",
            shouldShowSpinner: true
        });
    const $c7ed25d526b7ed1b$export$8ea64bac0a832a5c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $99acde7d7c12a8d4$export$6eafffd4489b3d4), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.trashed-projects',
            component: (0, $70186afa73ef93b4$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $67a748fd05680154$export$dd65a8ee0a9ac24f)
            ],
            isRedirect: true
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $4jMkc;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $78ccf5c0c15f3843$export$74ec9fecd42fa96e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY),
        path: '/jira/settings/projects/trash',
        exact: true
    };
    const $dc548005383aa0ca$export$27d1f352c2f7acae = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $78ccf5c0c15f3843$export$74ec9fecd42fa96e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.trashed-projects',
            component: (0, $67a748fd05680154$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $67a748fd05680154$export$dd65a8ee0a9ac24f)
            ]
        }));
    var $2G9Bk;
    var $65Ltd;
    const $875097219108c022$export$b0b13170cadf6395 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_USER_SEGMENTATION),
        path: '/jira/get-started',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $16f27a0ded4f6683$export$bf9c9e0729c919f5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("Y1IrA"))), {
        moduleId: "./src/packages/user-segmentation/src/index.tsx"
    });
    const $16f27a0ded4f6683$export$15f8c5ccbb9c7ec3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $16f27a0ded4f6683$export$bf9c9e0729c919f5,
            pageId: "user-segmentation",
            shouldShowSpinner: true
        });
    const $929524b967f2ea63$export$2af76482b576a135 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $875097219108c022$export$b0b13170cadf6395), ()=>({
            ufoName: 'user-segmentation',
            component: (0, $16f27a0ded4f6683$export$15f8c5ccbb9c7ec3),
            layout: (0, $c3106f352857c22e$export$17e73ed8c35891cb),
            forPaint: [
                (0, $16f27a0ded4f6683$export$bf9c9e0729c919f5)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $65Ltd;
    const $f70c16094aab0919$export$146910ddc36bf151 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR),
        path: '/jira/contact-administrator'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $817988e9accf1b9b$export$bf75747a931b9a2b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("esQGb"))), {
        moduleId: "./src/packages/admin-pages/contact-administrator/src/index.tsx"
    });
    var $817988e9accf1b9b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $817988e9accf1b9b$export$bf75747a931b9a2b,
            pageId: "jira-admin-pages-contact-administrator",
            shouldShowSpinner: true
        });
    const $2f78657934c6661f$export$d213125be8246eea = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f70c16094aab0919$export$146910ddc36bf151), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.contact-administrator',
            component: (0, $817988e9accf1b9b$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $817988e9accf1b9b$export$bf75747a931b9a2b)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $dmx0y;
    var $65Ltd;
    const $acdb6757893e541c$export$aed294a4a292b909 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG),
        path: '/jira/settings/system/notification-logs',
        exact: true
    };
    const $25a34f05175c2102$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d",
            "metadata": {},
            "name": "uiNotificationLogsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $25a34f05175c2102$export$2e2bcd8739ae039 = $25a34f05175c2102$var$node;
    var $eufEc;
    var $fEDBv;
    const $e96cd1acff95af13$export$818d841e00bb3749 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("6Zdot")), {
            moduleId: "d533cc53"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    notificationLogs: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: $25a34f05175c2102$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectIds: context?.query?.projectId,
                            notificationType: 'INTERNAL_NOTIFICATION',
                            notificationActionType: 'USER_INVITE',
                            recipientId: ''
                        }
                    }
                },
                extraProps: {
                    accountId: tenantContext.atlassianAccountId
                }
            })
    });
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $9945f9dd9a251453$var$emailNotificationsLogEntryPointPage = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $e96cd1acff95af13$export$818d841e00bb3749),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS
    });
    const $9945f9dd9a251453$export$b2f1a46be2e3ed3f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6Zdot"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/notification-logs/src/index.tsx"
    });
    const $9945f9dd9a251453$var$NotificationLogs = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9945f9dd9a251453$export$b2f1a46be2e3ed3f,
            pageId: "Notification Logs",
            shouldShowSpinner: false
        });
    const $9945f9dd9a251453$export$4d57b993ce36e7b2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $acdb6757893e541c$export$aed294a4a292b909), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: $9945f9dd9a251453$var$NotificationLogs,
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("dmx0y")).systemConfigurationGeneralResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9945f9dd9a251453$export$b2f1a46be2e3ed3f
            ],
            pageId: 'admin-settings-email-notifications-log',
            entryPoint () {
                return $9945f9dd9a251453$var$emailNotificationsLogEntryPointPage;
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $105ac7e3a2002ccc$export$17c79100fc4c65a1 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EXTERNAL_IMPORT),
        path: '/jira/settings/system/external-import'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $7b72a6c6c5d8947e$var$LazyExternalImport = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hlGoR")), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/admin-pages/external-import/src/index.tsx"
    });
    var $7b72a6c6c5d8947e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7b72a6c6c5d8947e$var$LazyExternalImport,
            pageId: "external-import-general",
            shouldShowSpinner: false
        });
    const $88a6b2c74571ee4b$export$d55ce647d8216437 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $105ac7e3a2002ccc$export$17c79100fc4c65a1), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $7b72a6c6c5d8947e$export$2e2bcd8739ae039),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $cSD7y;
    var $4R6GH;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $kiD5R;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $efa019df4aa72b9f$export$236ce89eb737f752 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_GLOBAL_PERMISSIONS),
        path: '/secure/admin/global-permissions'
    };
    var $5lsNZ;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $29ac5183332fb76e$export$a97b1349c011eb4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fYSiW"))), {
        moduleId: "./src/packages/permissions-administration/pages/global-permissions/src/index.tsx"
    });
    const $29ac5183332fb76e$export$a8d149dea7df681c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $29ac5183332fb76e$export$a97b1349c011eb4,
            pageId: "jira-global-permissions",
            shouldShowSpinner: true
        });
    const $29ac5183332fb76e$export$34203273711b537f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $efa019df4aa72b9f$export$236ce89eb737f752), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('olympus-global-permissions-fe-modernisation', $29ac5183332fb76e$export$a8d149dea7df681c, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("kiD5R")).globalPermissionsResource)
            ],
            canTransitionIn: ()=>(0, (0, parcelRequire("4R6GH")).fg)('olympus-global-permissions-fe-modernisation'),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $29ac5183332fb76e$export$a97b1349c011eb4
            ],
            meta: {
                reporting: {
                    id: 'GlobalPermissions',
                    packageName: 'jiraAdminPagesGlobalPermissions',
                    teamName: 'olympus'
                }
            }
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $g87MG;
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $68115cd41df3c3dd$export$6236a41e09bb858a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT),
        path: '/secure/PortfolioHierarchy.jspa'
    };
    var $7OYJs;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("aTXuq"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-hierarchy-directory/src/index.tsx"
    });
    var $1c0ab549b6b1a06b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd,
            pageId: "jira-admin-pages-issue-hierarchy-directory",
            shouldShowSpinner: true
        });
    const $7b04b3e8e151f1c0$export$ce3302d254f9c0b4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $68115cd41df3c3dd$export$6236a41e09bb858a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                    to: "/jira/settings/issues/issue-hierarchy"
                }),
            isRedirect: true,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("g87MG")).issueHierarchyPageResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd)
            ]
        }));
    var $g87MG;
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $b0028908d5aa290a$export$2c220ed11ae62e14 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY),
        path: '/jira/settings/issues/issue-hierarchy'
    };
    const $7693e36a7d632143$export$119e5b48edcee4ff = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b0028908d5aa290a$export$2c220ed11ae62e14), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'global-admin.issues.issue-hierarchy-config',
            component: (0, $1c0ab549b6b1a06b$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("g87MG")).issueHierarchyPageResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd)
            ]
        }));
    var $hjmEZ;
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $doDFU;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $3e26a0063e6eb003$export$661e1bf38bb82270 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4EN0d"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-types-directory/src/index.tsx"
    });
    var $3e26a0063e6eb003$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3e26a0063e6eb003$export$661e1bf38bb82270,
            pageId: "jira-admin-pages-issue-types-directory",
            shouldShowSpinner: true
        });
    const $c4b1c133efa61697$export$680243b058188dc0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("doDFU")).globalSettingsIssueTypesRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'global-admin.issues.issue-types',
            component: (0, $3e26a0063e6eb003$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("hjmEZ")).issueTypesResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3e26a0063e6eb003$export$661e1bf38bb82270)
            ]
        }));
    var $6oOqs;
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $2bc2621ba9f684f5$export$2aba97aa663f43b3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES),
        path: '/jira/settings/issues/issue-type-schemes'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $651db9488b9701c8$export$611728a54ba37830 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("j6iNi"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-type-schemes-directory/src/index.tsx"
    });
    var $651db9488b9701c8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $651db9488b9701c8$export$611728a54ba37830,
            pageId: "jira-admin-pages-issue-type-schemes-directory",
            shouldShowSpinner: true
        });
    const $50729a11180c681f$export$8f940be66a7e7324 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2bc2621ba9f684f5$export$2aba97aa663f43b3), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'global-admin.issues.view-issue-type-schemes',
            component: (0, $651db9488b9701c8$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("6oOqs")).default)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $651db9488b9701c8$export$611728a54ba37830)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $jKASa;
    var $3RJkv;
    var $65Ltd;
    const $a5162dfcc59db4dc$export$6395086ce7e72e37 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_AUTHENTICATION_SETTINGS),
        path: '/jira/settings/products/servicedesk/authentication',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $a330db909964048e$export$6cd59b0135f3fe86 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fTwAe"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-authentication-settings/src/index.tsx"
    });
    var $a330db909964048e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a330db909964048e$export$6cd59b0135f3fe86,
            pageId: "spa-apps/admin-pages/jsm-authentication-settings",
            shouldShowSpinner: false
        });
    const $9cff46e3a47cb509$export$de5cc5a334946074 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a5162dfcc59db4dc$export$6395086ce7e72e37), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.jsm-authentication-settings',
            component: (0, $a330db909964048e$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("jKASa")).jsmCustomerAuthenticationSettingsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $a330db909964048e$export$6cd59b0135f3fe86)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $6IgbX;
    var $cuwqc;
    var $3RJkv;
    var $65Ltd;
    const $3ca187dfdc0607c8$export$b97e3b6231be8149 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_CUSTOMER_ACCESS),
        path: '/jira/settings/products/servicedesk/customer-access',
        exact: true
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $1b073120d1b5fb73$export$1ae94ce2cc225b3d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("cIGKY"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/customer-access/src/index.tsx"
    });
    const $1b073120d1b5fb73$export$fce5e73f94a6878 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1b073120d1b5fb73$export$1ae94ce2cc225b3d,
            pageId: "spa-apps/admin-pages/customer-access",
            shouldShowSpinner: false
        });
    const $1b073120d1b5fb73$export$d014f5ba2dec6c16 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3ca187dfdc0607c8$export$b97e3b6231be8149), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.jsm-customer-access',
            component: $1b073120d1b5fb73$export$fce5e73f94a6878,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("cuwqc")).jsmGlobalCustomerAccessSettingsResource),
                (0, (0, parcelRequire("6IgbX")).jsmGlobalCustomerAccessAffectedProjectsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $1b073120d1b5fb73$export$1ae94ce2cc225b3d
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $2c4dc81da03ffb36$export$774dc60e785b8ae8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH),
        path: '/jira/settings/issues/new-issue-search-transition'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $4f134f463ddf0416$export$aa5e318abd957ad = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gmNWX"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/new-issue-search-settings/src/index.tsx"
    });
    var $4f134f463ddf0416$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4f134f463ddf0416$export$aa5e318abd957ad,
            pageId: "jira-admin-pages-new-issue-search-transition",
            shouldShowSpinner: true
        });
    const $d3d6f049267991fe$export$ecfeb067cb61f7f7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2c4dc81da03ffb36$export$774dc60e785b8ae8), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'admin.new-issue-search-transition',
            component: (0, $4f134f463ddf0416$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $4f134f463ddf0416$export$aa5e318abd957ad)
            ],
            canTransitionIn: ()=>true
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $d8FBC;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $47674b1aa9d0fa81$export$2b269dcf51f5a4d3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_BULK_MAIL),
        path: '/jira/settings/system/send-email'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0240d4f2c2b35825$export$416f8039fbf50bea = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fg3s6"))), {
        moduleId: "./src/packages/admin-pages/bulk-email/src/index.tsx"
    });
    var $0240d4f2c2b35825$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0240d4f2c2b35825$export$416f8039fbf50bea,
            pageId: "jira-admin-pages-bulk-email",
            shouldShowSpinner: true
        });
    const $afbfb00c133db3e2$export$f1e14d1857713e35 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $47674b1aa9d0fa81$export$2b269dcf51f5a4d3), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $0240d4f2c2b35825$export$2e2bcd8739ae039),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("d8FBC")).SidebarGlobalSettingsSystem)
            },
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $0240d4f2c2b35825$export$416f8039fbf50bea)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $43a348db022c66e4$export$198b0dea5bcb104d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD),
        path: '/jira/settings/system/performance/metrics/customfield'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $416b07e85e5902e2$export$d323aa888b5be0c2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4P6Jd"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-custom-field/src/index.tsx"
    });
    const $416b07e85e5902e2$export$446bf9be075b3cb = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $416b07e85e5902e2$export$d323aa888b5be0c2,
            pageId: "system-performance-metric-detail-custom-field",
            shouldShowSpinner: true
        });
    const $082dced0cf5c2e43$export$8cc68908e4ed5a16 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $43a348db022c66e4$export$198b0dea5bcb104d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $416b07e85e5902e2$export$446bf9be075b3cb),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $416b07e85e5902e2$export$d323aa888b5be0c2)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $cad08cbdd7ac177a$export$a615b79ae9fb06e5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE),
        path: '/jira/settings/system/performance/metrics/issue'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $cc878f5a65037830$export$e44cbefb7c57e031 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("cVwq6"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-issue/src/index.tsx"
    });
    const $cc878f5a65037830$export$30b22d5292fcd86f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cc878f5a65037830$export$e44cbefb7c57e031,
            pageId: "system-performance-metric-detail-issue",
            shouldShowSpinner: true
        });
    const $bf0d17e8163c3686$export$6f8a930d1f2f4103 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cad08cbdd7ac177a$export$a615b79ae9fb06e5), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $cc878f5a65037830$export$30b22d5292fcd86f),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cc878f5a65037830$export$e44cbefb7c57e031)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $cd34eae2613f8100$export$d4f7a24791f8b506 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL),
        path: '/jira/settings/system/performance/metric/:metricKey'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $8zOmE;
    var $7OYJs;
    var $doZTA;
    const $a9257ec476fbe8e1$export$dda90f06f8afe9ec = ()=>{
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (match?.params?.metricKey) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'old-metric-detail-route visited', {
                metricKey: match.params.metricKey
            });
        }, [
            match?.params?.metricKey,
            createAnalyticsEvent
        ]);
        if (match == null || match.params == null || match.params.metricKey == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/settings/system/performance/overview"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/settings/system/performance/metrics/${match.params.metricKey}`
        });
    };
    const $233fa7d3de1e95a8$export$4b547a5bd165bd83 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cd34eae2613f8100$export$d4f7a24791f8b506), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $a9257ec476fbe8e1$export$dda90f06f8afe9ec),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $clE6J;
    var $65Ltd;
    const $895fc96119706708$export$677fc3a2086479d2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW),
        path: '/jira/settings/system/performance/overview'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $53afac4f83d10b4d$export$17b4d4eaede5f445 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4Vh5b"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/overview/src/index.tsx"
    });
    var $53afac4f83d10b4d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $53afac4f83d10b4d$export$17b4d4eaede5f445,
            pageId: "system-performance-overview",
            shouldShowSpinner: true
        });
    const $13d7b69aa99de9b5$export$6f957aade53e2c17 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $895fc96119706708$export$677fc3a2086479d2), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $53afac4f83d10b4d$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("clE6J")).metricsOverviewPageResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $53afac4f83d10b4d$export$17b4d4eaede5f445)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $cSD7y;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $2cfd8d591a3d3df9$export$c0d3487a9dc79ff3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP),
        path: '/jira/settings/system/performance/metrics/projectCleanup'
    };
    var $5lsNZ;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $a4333be24d8fdde0$export$a02cb3bfa11d0dc0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5CzbD"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-cleanup/src/index.tsx"
    });
    const $a4333be24d8fdde0$export$2adb5abd6651c182 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a4333be24d8fdde0$export$a02cb3bfa11d0dc0,
            pageId: "system-performance-metric-detail-project-cleanup",
            shouldShowSpinner: true
        });
    const $5db1194ddce6c383$export$7048705fd224d040 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2cfd8d591a3d3df9$export$c0d3487a9dc79ff3), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('site-optimizer-project-cleanup', (0, $a4333be24d8fdde0$export$2adb5abd6651c182), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $a4333be24d8fdde0$export$a02cb3bfa11d0dc0)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $a0135d88210046c6$export$c81695f590e65a42 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR),
        path: '/jira/settings/system/performance/metrics/projectroleactor'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $e00517ee35b4ce44$export$41ecfa31d3d81e1c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dF55I"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-role-actor/src/index.tsx"
    });
    const $e00517ee35b4ce44$export$3c58376b89706313 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e00517ee35b4ce44$export$41ecfa31d3d81e1c,
            pageId: "system-performance-metric-detail-project-role-actor",
            shouldShowSpinner: true
        });
    const $b0ecc0767e5528eb$export$a37cab737d8b474a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a0135d88210046c6$export$c81695f590e65a42), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $e00517ee35b4ce44$export$3c58376b89706313),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $e00517ee35b4ce44$export$41ecfa31d3d81e1c)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $1Sn7L;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $b0eb7fc8ea8a5934$export$d57f448badd0561f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES),
        path: '/jira/settings/issues/permission-schemes/:schemeId'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $9fc866887d4bbe6b$export$4549705b02900c32 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dHMas"))), {
        moduleId: "./src/packages/permissions-administration/pages/edit-permission-scheme/src/index.tsx"
    });
    var $9fc866887d4bbe6b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9fc866887d4bbe6b$export$4549705b02900c32,
            pageId: "jira-edit-permission-scheme",
            shouldShowSpinner: true
        });
    const $28d525b59d36751f$export$25dca167915e813c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b0eb7fc8ea8a5934$export$d57f448badd0561f), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'global-admin.issues.configure-permission-scheme',
            component: (0, $9fc866887d4bbe6b$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("1Sn7L")).editPermissionSchemePageResource)
            ],
            canTransitionIn: ()=>true,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9fc866887d4bbe6b$export$4549705b02900c32)
            ],
            meta: {
                reporting: {
                    id: 'EditPermissionScheme',
                    packageName: 'jiraAdminPagesEditPermissionScheme',
                    teamName: 'olympus'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $bFrLw;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $1ed22cbad427b1e6$export$ceade8e040291782 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERMISSION_SCHEMES),
        path: '/jira/settings/issues/permission-schemes-new/:schemeId'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d6d274858940e39c$export$f7fcf8304eb17dda = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("i4rUQ"))), {
        moduleId: "./src/packages/permissions-administration/pages/permission-scheme/src/index.tsx"
    });
    var $d6d274858940e39c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d6d274858940e39c$export$f7fcf8304eb17dda,
            pageId: "jira-permission-scheme",
            shouldShowSpinner: true
        });
    const $1a723dff8ec4c1fb$export$85d07cd59d004b5b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1ed22cbad427b1e6$export$ceade8e040291782), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'global-admin.issues.configure-permission-scheme',
            component: (0, $d6d274858940e39c$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("bFrLw")).permissionSchemePageResource)
            ],
            canTransitionIn: ()=>true,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d6d274858940e39c$export$f7fcf8304eb17dda)
            ],
            meta: {
                reporting: {
                    id: 'PermissionScheme',
                    packageName: 'jiraAdminPagesPermissionScheme',
                    teamName: 'olympus'
                }
            }
        }));
    var $65Ltd;
    var $cSD7y;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $20f25386b191950e$export$518516cdf6b7cd83 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES),
        path: '/jira/settings/issues/priorities'
    };
    var $5lsNZ;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $bf15af7ed924092e$export$2b5843205130631c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8Xps6"))), {
        moduleId: "./src/packages/admin-pages/priorities/src/index.tsx"
    });
    const $bf15af7ed924092e$var$PrioritiesPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bf15af7ed924092e$export$2b5843205130631c,
            pageId: "jira-admin-pages-priorities",
            shouldShowSpinner: true
        });
    var $bf15af7ed924092e$export$2e2bcd8739ae039 = $bf15af7ed924092e$var$PrioritiesPage;
    const $90f1ccdb6a2bda75$export$63a56a096ab0d260 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $20f25386b191950e$export$518516cdf6b7cd83), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('priorities_page_frontend_statsig', (0, $bf15af7ed924092e$export$2e2bcd8739ae039), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, $bf15af7ed924092e$export$2b5843205130631c)
            ]
        }));
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $fZEim;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $a7002d7e57e81458$export$20bb8a3b40a3add4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2LTGD"))), {
        moduleId: "./src/packages/admin-pages/priority-schemes/src/ui/index.tsx"
    });
    var $a7002d7e57e81458$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a7002d7e57e81458$export$20bb8a3b40a3add4,
            pageId: "jira-admin-pages-priority-schemes",
            shouldShowSpinner: true
        });
    const $e7cda76e463e35e5$export$a5ac2a64ed09e754 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fZEim")).globalSettingsIssuesPrioritySchemesRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $a7002d7e57e81458$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, $a7002d7e57e81458$export$20bb8a3b40a3add4)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $e95abb1b467ec66d$export$6633247975d81f28 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS),
        path: '/jira/settings/forms/data-connections'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $013d0419ad26989f$export$a81885366284dc75 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7SoLF"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/proforma/data-connections/src/index.tsx"
    });
    var $013d0419ad26989f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $013d0419ad26989f$export$a81885366284dc75,
            pageId: "jira-admin-pages-forms-data-connections",
            shouldShowSpinner: true
        });
    const $3bc9e61b7154fc39$export$d975ee3e4df0b4d2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e95abb1b467ec66d$export$6633247975d81f28), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $013d0419ad26989f$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $013d0419ad26989f$export$a81885366284dc75)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $f7a16e4417c90525$export$3c5a0cf6ecc1bdf1 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES),
        path: '/jira/settings/issues/screen-schemes'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $3b08a72bf07c6137$export$342ae41503f611f1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("beIyx"))), {
        moduleId: "./src/packages/admin-pages/screens/screen-schemes-page/src/index.tsx"
    });
    var $3b08a72bf07c6137$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3b08a72bf07c6137$export$342ae41503f611f1,
            pageId: "jira-admin-pages-screen-schemes-page",
            shouldShowSpinner: true
        });
    const $040da6ab68bb362d$export$d76b41f577aeeba5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f7a16e4417c90525$export$3c5a0cf6ecc1bdf1), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'global-admin.issues.screen-schemes',
            component: (0, $3b08a72bf07c6137$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3b08a72bf07c6137$export$342ae41503f611f1)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $d6c79c93cf657eb0$export$197fd5d0ee709ca4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS),
        path: '/jira/settings/issues/screens'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $38a54f3b8a5e1e01$export$f4e6d546d7f2894c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hD3Wt"))), {
        moduleId: "./src/packages/admin-pages/screens/screens-page/src/index.tsx"
    });
    var $38a54f3b8a5e1e01$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $38a54f3b8a5e1e01$export$f4e6d546d7f2894c,
            pageId: "jira-admin-pages-screens-page",
            shouldShowSpinner: true
        });
    const $39823af69179fb5e$export$ea08b1064c32ddb2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d6c79c93cf657eb0$export$197fd5d0ee709ca4), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'global-admin.issues.screens',
            component: (0, $38a54f3b8a5e1e01$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $38a54f3b8a5e1e01$export$f4e6d546d7f2894c)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $2245c71c2bdfe600$export$df93a4addc359237 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES),
        path: '/jira/settings/issues/issue-type-screen-schemes'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $73b6b725092289e9$export$350edfb57b335a57 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("79U3p"))), {
        moduleId: "./src/packages/admin-pages/screens/issue-type-screen-schemes-page/src/index.tsx"
    });
    var $73b6b725092289e9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $73b6b725092289e9$export$350edfb57b335a57,
            pageId: "jira-admin-pages-issue-type-screen-schemes-page",
            shouldShowSpinner: true
        });
    const $3911900520b0c6a8$export$e2c2c1569887e684 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2245c71c2bdfe600$export$df93a4addc359237), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'global-admin.issues.issue-type-screen-schemes',
            component: (0, $73b6b725092289e9$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $73b6b725092289e9$export$350edfb57b335a57)
            ]
        }));
    var $65Ltd;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $dmx0y;
    var $65Ltd;
    const $3ee9d4dcc92b7ade$export$23418d655258dbfa = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_CONFIGURATION)}-redirect`,
        path: '/secure/admin/ViewApplicationProperties.jspa',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $71a705d1d999c26b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/settings/system/general-configuration"
        });
    const $80a9e9d953a08ffe$export$fcb669e0c0881928 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3ee9d4dcc92b7ade$export$23418d655258dbfa), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $71a705d1d999c26b$export$2e2bcd8739ae039),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("dmx0y")).systemConfigurationGeneralResource)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $dmx0y;
    var $99CoR;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ece5afb522908971$export$c452a8c622781ccd = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("54Qvs"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/system-configuration-general/src/index.tsx"
    });
    var $ece5afb522908971$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ece5afb522908971$export$c452a8c622781ccd,
            pageId: "system-configuration-general",
            shouldShowSpinner: false
        });
    const $1805c641c87a2931$export$360a82088f35f2f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("99CoR")).systemConfigurationRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            component: (0, $ece5afb522908971$export$2e2bcd8739ae039),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("dmx0y")).systemConfigurationGeneralResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ece5afb522908971$export$c452a8c622781ccd)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $0f7678f7ab7e2ce6$export$20631ff3b13dafc0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER),
        path: '/jira/settings/system/ui/announcement-banner'
    };
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $375c8c577ca5ebf6$export$3c41e9fc9ec0d170 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kNqq3"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/system/ui/announcement-banner/src/index.tsx"
    });
    const $375c8c577ca5ebf6$export$eb84257d269db72c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $375c8c577ca5ebf6$export$3c41e9fc9ec0d170,
            pageId: "admin-pages-system-ui-announcement-banner",
            shouldShowSpinner: true
        });
    const $375c8c577ca5ebf6$export$416d225883781012 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0f7678f7ab7e2ce6$export$20631ff3b13dafc0), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'global-admin.system.ui.announcement-banner',
            component: $375c8c577ca5ebf6$export$eb84257d269db72c,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $375c8c577ca5ebf6$export$3c41e9fc9ec0d170
            ]
        }));
    var $3aIZg;
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $416b12e52ba65191$export$f8f2a617a2f4d53 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW),
        path: '/jira/settings/issues/workflows'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $fe432a8ece476800$export$4c64b4f1ecf22fc8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9VrFM"))), {
        moduleId: "./src/packages/admin-pages/workflows/list-workflows/src/index.tsx"
    });
    var $fe432a8ece476800$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fe432a8ece476800$export$4c64b4f1ecf22fc8,
            pageId: "jira-admin-pages-list-workflows",
            shouldShowSpinner: true
        });
    const $68897fd2bacb1927$export$55e4c1d21a9b75e6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $416b12e52ba65191$export$f8f2a617a2f4d53), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'global-admin.issues.view-workflows',
            component: (0, $fe432a8ece476800$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("3aIZg")).default)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $fe432a8ece476800$export$4c64b4f1ecf22fc8)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3RJkv;
    var $65Ltd;
    const $69ca7ef2aafafa96$export$9d533f08a4447cc = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT),
        path: '/jira/settings/issues/workflows/:workflowId'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $793ac7f9af5a2945$export$cb79ebb337a95317 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("czpuT"))), {
        moduleId: "./src/packages/admin-pages/workflows/edit-workflow/src/index.tsx"
    });
    var $793ac7f9af5a2945$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $793ac7f9af5a2945$export$cb79ebb337a95317,
            pageId: "jira-admin-pages-edit-workflow",
            shouldShowSpinner: true
        });
    const $e62e629a6fa746d6$export$d2b3121978e344e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $69ca7ef2aafafa96$export$9d533f08a4447cc), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
            ufoName: 'global-admin.issues.edit-workflow',
            component: (0, $793ac7f9af5a2945$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $793ac7f9af5a2945$export$cb79ebb337a95317)
            ]
        }));
    const $e8fc18994c4f5903$export$c9b96dd6f5a7b454 = [
        (0, $39823af69179fb5e$export$ea08b1064c32ddb2),
        (0, $040da6ab68bb362d$export$d76b41f577aeeba5),
        (0, $3911900520b0c6a8$export$e2c2c1569887e684),
        (0, $e62e629a6fa746d6$export$d2b3121978e344e),
        (0, $68897fd2bacb1927$export$55e4c1d21a9b75e6),
        (0, $7693e36a7d632143$export$119e5b48edcee4ff),
        (0, $7b04b3e8e151f1c0$export$ce3302d254f9c0b4),
        (0, $c4b1c133efa61697$export$680243b058188dc0),
        (0, $50729a11180c681f$export$8f940be66a7e7324),
        (0, $2f78657934c6661f$export$d213125be8246eea),
        (0, $375c8c577ca5ebf6$export$416d225883781012),
        (0, $1b073120d1b5fb73$export$d014f5ba2dec6c16),
        (0, $9cff46e3a47cb509$export$de5cc5a334946074),
        (0, $afbfb00c133db3e2$export$f1e14d1857713e35),
        (0, $28d525b59d36751f$export$25dca167915e813c),
        (0, $1a723dff8ec4c1fb$export$85d07cd59d004b5b),
        (0, $3bc9e61b7154fc39$export$d975ee3e4df0b4d2),
        (0, $d3d6f049267991fe$export$ecfeb067cb61f7f7),
        (0, $13d7b69aa99de9b5$export$6f957aade53e2c17),
        (0, $233fa7d3de1e95a8$export$4b547a5bd165bd83),
        (0, $5db1194ddce6c383$export$7048705fd224d040),
        (0, $082dced0cf5c2e43$export$8cc68908e4ed5a16),
        (0, $bf0d17e8163c3686$export$6f8a930d1f2f4103),
        (0, $b0ecc0767e5528eb$export$a37cab737d8b474a),
        (0, $90f1ccdb6a2bda75$export$63a56a096ab0d260),
        (0, $e7cda76e463e35e5$export$a5ac2a64ed09e754),
        (0, $29ac5183332fb76e$export$34203273711b537f),
        (0, $1805c641c87a2931$export$360a82088f35f2f),
        (0, $80a9e9d953a08ffe$export$fcb669e0c0881928),
        (0, $88a6b2c74571ee4b$export$d55ce647d8216437),
        (0, $9945f9dd9a251453$export$4d57b993ce36e7b2)
    ];
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $cSD7y;
    var $4R6GH;
    var $2BrOV;
    var $lmyls;
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $43189553e9fc21a2$export$ea77f88c1b841127 = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("dbmHR")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/help-center-settings/src/index.tsx"
    });
    const $43189553e9fc21a2$var$HelpCenterSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "servicedeskProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($43189553e9fc21a2$export$ea77f88c1b841127, null)));
    $43189553e9fc21a2$var$HelpCenterSettingsSidebar.displayName = 'HelpCenterSettingsSidebar';
    var $43189553e9fc21a2$export$2e2bcd8739ae039 = $43189553e9fc21a2$var$HelpCenterSettingsSidebar;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $fCXWg;
    var $7D8h0;
    var $k8jl5;
    var $1cpsA;
    var $eUvlM;
    var $5lsNZ;
    var $65Ltd;
    const $956ef53bef7f74b8$var$HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';
    const $956ef53bef7f74b8$export$5adf9b8f07e4dd7b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_ACCESS),
        path: `${$956ef53bef7f74b8$var$HELP_CENTER_SETTINGS_URL}/customer-access`
    };
    var $65Ltd;
    const $e11b5b1fd2c66498$var$HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';
    const $e11b5b1fd2c66498$export$88fcb9acf40a0827 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_NOTIFICATIONS),
        path: `${$e11b5b1fd2c66498$var$HELP_CENTER_SETTINGS_URL}/customer-notifications`
    };
    var $65Ltd;
    const $1e498e8ebd1ddcd1$var$HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';
    const $1e498e8ebd1ddcd1$export$4515288a48c62087 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_EMAIL),
        path: `${$1e498e8ebd1ddcd1$var$HELP_CENTER_SETTINGS_URL}/email`,
        exact: true
    };
    var $65Ltd;
    const $76127e6b6297617e$var$HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';
    const $76127e6b6297617e$export$31bd3e10c42460dc = {
        exact: true,
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_FORM_EDIT),
        path: `${$76127e6b6297617e$var$HELP_CENTER_SETTINGS_URL}/forms/:formId`
    };
    var $65Ltd;
    const $a0406c9ab9debc78$var$HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';
    const $a0406c9ab9debc78$export$45b14c3ed47b2b3a = {
        exact: true,
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_FORMS),
        path: `${$a0406c9ab9debc78$var$HELP_CENTER_SETTINGS_URL}/forms`
    };
    var $65Ltd;
    const $643da700cdb365a5$var$HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';
    const $643da700cdb365a5$export$8a784299dc7faaff = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_KNOWLEDGE_BASE),
        path: `${$643da700cdb365a5$var$HELP_CENTER_SETTINGS_URL}/kb`,
        exact: true
    };
    var $65Ltd;
    const $d552736763a40a3c$var$HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';
    const $d552736763a40a3c$export$f544881b6385f520 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS),
        path: $d552736763a40a3c$var$HELP_CENTER_SETTINGS_URL,
        exact: true
    };
    var $65Ltd;
    const $ce6844775f881a62$var$HELP_CENTER_URL = '/jira/helpcenter';
    const $ce6844775f881a62$export$16970f28ba5bfb66 = {
        exact: true,
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SERVICE_HUBS),
        path: $ce6844775f881a62$var$HELP_CENTER_URL
    };
    var $65Ltd;
    const $4be87f8926815d19$var$HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';
    const $4be87f8926815d19$export$dd1d3b3f528e7077 = {
        exact: true,
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPE_FIELDS),
        path: `${$4be87f8926815d19$var$HELP_CENTER_SETTINGS_URL}/request-types/unassigned/request-type/:requestTypeId/:tabKey?`
    };
    var $65Ltd;
    const $48397a5f2b351d84$var$HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';
    const $48397a5f2b351d84$export$766193806f1c2ba8 = {
        exact: true,
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPES),
        path: `${$48397a5f2b351d84$var$HELP_CENTER_SETTINGS_URL}/request-types/unassigned`
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $c2a27ef145addce1$export$2c331ddbdb6fb4ef = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lseYA"))), {
        moduleId: "./src/packages/spa-apps/help-center-settings/customer-access/src/index.tsx"
    });
    const $c2a27ef145addce1$export$ab643bb246877df = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c2a27ef145addce1$export$2c331ddbdb6fb4ef,
            pageId: "help-center-settings-customer-access",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ce252471da0db8c1$export$b2b6550dec008a98 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gBexg"))), {
        moduleId: "./src/packages/spa-apps/help-center-settings/customer-notifications/src/index.tsx"
    });
    const $ce252471da0db8c1$export$2f2f18f57014444a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ce252471da0db8c1$export$b2b6550dec008a98,
            pageId: "help-center-settings-customer-notifications",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $6353b69d503ce9ba$export$e090cd3a62343249 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ddhnG")), {
        moduleId: "./src/packages/spa-apps/help-center-settings/email/src/index.tsx"
    });
    const $6353b69d503ce9ba$export$962f20e752738967 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6353b69d503ce9ba$export$e090cd3a62343249,
            pageId: "help-center-settings-email",
            shouldShowSpinner: true
        });
    var $lmyls;
    var $eufEc;
    var $fEDBv;
    const $dcaafae9dc3cdb4f$export$262512d610e494f8 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("99koq")), {
            moduleId: "d82eb4d8"
        }),
        getPreloadProps: ()=>{
            return {};
        }
    });
    const $73a7c9331a7a621d$export$2792cba2387cbc5c = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: $dcaafae9dc3cdb4f$export$262512d610e494f8,
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HELP_CENTER_SETTINGS
    });
    var $lmyls;
    var $eufEc;
    var $fEDBv;
    const $dbea87a49a7edd6e$export$ce8253ab16579f12 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("4r0EN")), {
            moduleId: "c7a4dbb9"
        }),
        getPreloadProps: ()=>{
            return {};
        }
    });
    const $cf39360ee106b7b5$export$b50d944f3be2457f = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: $dbea87a49a7edd6e$export$ce8253ab16579f12,
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HELP_CENTER_SETTINGS
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d84b744908886ed8$export$92983043c677b1b1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ktRUb"))), {
        moduleId: "./src/packages/spa-apps/help-center-settings/knowledge-settings/src/index.tsx"
    });
    const $d84b744908886ed8$export$c1d58cf9dc0a2ed3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d84b744908886ed8$export$92983043c677b1b1,
            pageId: "help-center-settings-knowledge-base",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5lsNZ;
    var $7OYJs;
    var $bmKPg;
    const $44cb5391898ae9e8$export$2d8d895a0a0f636e = ()=>{
        const [projectKey = ''] = (0, (0, parcelRequire("bmKPg")).usePathParam)('projectKey');
        const helpCenterSettingsEmail = (0, $1e498e8ebd1ddcd1$export$4515288a48c62087).path.replace(':projectKey', projectKey);
        return projectKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: helpCenterSettingsEmail,
            persistSearchParams: true
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5lsNZ")).default), null);
    };
    var $lmyls;
    var $eufEc;
    var $fEDBv;
    const $0978151941bc8303$export$68ab0caf884fe346 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("9xCIo")), {
            moduleId: "c447b568"
        }),
        getPreloadProps: ()=>{
            return {};
        }
    });
    const $ba28558a5bb4c0c7$export$3c1cef4845013f95 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: $0978151941bc8303$export$68ab0caf884fe346,
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HELP_CENTER_SETTINGS
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $c259901de6c87b95$export$d0ea3970831afb33 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3Jfji")).then((module)=>module.HelpCenterSettingsTicketTypeFieldsPage), {
        moduleId: "./src/packages/spa-apps/help-center-settings/ticket-type-fields/src/ui/index.tsx"
    });
    const $c259901de6c87b95$export$76418008a8957579 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c259901de6c87b95$export$d0ea3970831afb33,
            pageId: "help-center-settings-ticket-type-fields",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $50ba7c7297083618$export$dcabea7d416bc1b4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4eTbq")).then((module)=>module.HelpCenterSettingsTicketTypesConfigPage), {
        moduleId: "./src/packages/spa-apps/help-center-settings/ticket-types-config/src/ui/index.tsx"
    });
    const $50ba7c7297083618$export$4aca0a164c4d76df = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $50ba7c7297083618$export$dcabea7d416bc1b4,
            pageId: "help-center-settings-ticket-types-config",
            shouldShowSpinner: true
        });
    const $58e6269847de16de$var$navigation = {
        sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).HELP_CENTER_SETTINGS,
        menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HELP_CENTER_SETTINGS,
        sidebar: (0, $43189553e9fc21a2$export$2e2bcd8739ae039)
    };
    const $58e6269847de16de$export$c4a6a8e840f7c6b1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d552736763a40a3c$export$f544881b6385f520), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, $44cb5391898ae9e8$export$2d8d895a0a0f636e),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ],
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)()
            ]
        }));
    const $58e6269847de16de$export$caf568619a621961 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $643da700cdb365a5$export$8a784299dc7faaff), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
            perfMetricKey: 'help-center-settings.kb',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jcs_master_flag', (0, $d84b744908886ed8$export$c1d58cf9dc0a2ed3), (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d84b744908886ed8$export$92983043c677b1b1)
            ],
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
    const $58e6269847de16de$export$4e4f38417d267cf6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e11b5b1fd2c66498$export$88fcb9acf40a0827), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
            perfMetricKey: 'help-center-settings.customer-notifications',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jcs_master_flag', (0, $ce252471da0db8c1$export$2f2f18f57014444a), (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ce252471da0db8c1$export$b2b6550dec008a98)
            ],
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)()
            ]
        }));
    const $58e6269847de16de$export$5cfeb28cf3c43d24 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $956ef53bef7f74b8$export$5adf9b8f07e4dd7b), ()=>({
            perfMetricKey: 'help-center-settings.customer-access',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jcs_master_flag', (0, $c2a27ef145addce1$export$ab643bb246877df), (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $c2a27ef145addce1$export$2c331ddbdb6fb4ef)
            ],
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)()
            ]
        }));
    const $58e6269847de16de$export$f95717dac47e4db3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1e498e8ebd1ddcd1$export$4515288a48c62087), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
            perfMetricKey: 'help-center-settings.email',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jcs_master_flag', (0, $6353b69d503ce9ba$export$962f20e752738967), (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $6353b69d503ce9ba$export$e090cd3a62343249)
            ],
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)()
            ]
        }));
    const $58e6269847de16de$export$9a67aaae787c9f40 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a0406c9ab9debc78$export$45b14c3ed47b2b3a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
            perfMetricKey: 'help-center-settings.forms',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("5lsNZ")).default),
            entryPoint () {
                return (0, (0, parcelRequire("4R6GH")).fg)('csm-request-intake-m1') ? (0, $cf39360ee106b7b5$export$b50d944f3be2457f) : undefined;
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                (0, (0, parcelRequire("7D8h0")).formsResource)
            ]
        }));
    const $58e6269847de16de$export$1750cfcab794a07d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $76127e6b6297617e$export$31bd3e10c42460dc), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
            perfMetricKey: 'help-center-settings.form-edit',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("5lsNZ")).default),
            entryPoint () {
                return (0, (0, parcelRequire("4R6GH")).fg)('csm-request-intake-m1') ? (0, $73a7c9331a7a621d$export$2792cba2387cbc5c) : undefined;
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                (0, (0, parcelRequire("fCXWg")).formEditJirafieldsResource)
            ]
        }));
    const $58e6269847de16de$export$9803a0486e374df3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $48397a5f2b351d84$export$766193806f1c2ba8), ()=>({
            perfMetricKey: 'help-center-settings-request-types-configuration',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') && !(0, (0, parcelRequire("4R6GH")).fg)('csm-request-intake-m1'), (0, $50ba7c7297083618$export$4aca0a164c4d76df), (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $50ba7c7297083618$export$dcabea7d416bc1b4)
            ],
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource),
                (0, (0, parcelRequire("k8jl5")).servicedeskIssueTypesResource),
                (0, (0, parcelRequire("1cpsA")).servicedeskPortalGroupsResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
    const $58e6269847de16de$export$7da6f58628a74ff7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $4be87f8926815d19$export$dd1d3b3f528e7077), ()=>({
            perfMetricKey: 'help-center-settings-request-types-fields',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') && !(0, (0, parcelRequire("4R6GH")).fg)('csm-request-intake-m1'), (0, $c259901de6c87b95$export$76418008a8957579), (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $c259901de6c87b95$export$d0ea3970831afb33)
            ],
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)()
            ]
        }));
    const $58e6269847de16de$export$4afd756ea4d2cf7e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ce6844775f881a62$export$16970f28ba5bfb66), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CUSTOMER_SERVICE),
            perfMetricKey: 'customer-service.service-hubs',
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HELP_CENTER_SETTINGS
            },
            component: (0, (0, parcelRequire("5lsNZ")).default),
            entryPoint () {
                return (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? (0, $ba28558a5bb4c0c7$export$3c1cef4845013f95) : undefined;
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ]
        }));
    const $39416b69d8da58fe$export$633933bacdaefead = [
        (0, $58e6269847de16de$export$c4a6a8e840f7c6b1),
        (0, $58e6269847de16de$export$caf568619a621961),
        (0, $58e6269847de16de$export$4e4f38417d267cf6),
        (0, $58e6269847de16de$export$5cfeb28cf3c43d24),
        (0, $58e6269847de16de$export$f95717dac47e4db3),
        (0, $58e6269847de16de$export$9a67aaae787c9f40),
        (0, $58e6269847de16de$export$1750cfcab794a07d),
        (0, $58e6269847de16de$export$9803a0486e374df3),
        (0, $58e6269847de16de$export$7da6f58628a74ff7),
        (0, $58e6269847de16de$export$4afd756ea4d2cf7e)
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $18N1t;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $loy04;
    var $ggg5j;
    var $iEUaw;
    var $8rIQt;
    var $2G9Bk;
    var $lNicp;
    var $kJQXA;
    var $3RJkv;
    var $eOlBz;
    var $dxCvy;
    var $e7C7O;
    var $5lsNZ;
    var $65Ltd;
    const $cb26bde1d38666aa$export$59e3323ba0cc224a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS_REDIRECT),
        path: '/jira/core/projects/:projectKey/settings/people',
        exact: true
    };
    var $65Ltd;
    const $213a8c0a4e177f13$export$fe93051d5b7385a1 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS),
        path: '/jira/core/projects/:projectKey/settings/access',
        exact: true
    };
    var $65Ltd;
    const $2c78c142a4e64bf0$export$ba11c8f378a2c121 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPROVALS),
        path: '/jira/core/projects/:projectKey/settings/approvals',
        exact: true
    };
    var $65Ltd;
    const $68a47d7164ebf1d3$export$1c7e75ffaa491922 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS_FIELDS),
        path: '/jira/core/projects/:projectKey/settings/apps/app-fields',
        exact: true
    };
    var $65Ltd;
    const $7add52f5911a831e$export$c7ac65fb0bbe767f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS),
        path: '/jira/core/projects/:projectKey/settings/apps/:appId?',
        exact: true
    };
    var $65Ltd;
    const $7024005c59ef8f32$export$65a4d727336c49f4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION),
        path: '/jira/core/projects/:projectKey/settings/automation'
    };
    var $65Ltd;
    const $e31b6bde721f5bf5$export$5437af2650f645e0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION),
        path: '/jira/core/projects/:projectKey/settings/automate'
    };
    var $65Ltd;
    const $46bd61981cdecbb8$export$7aae1006c82a79c0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS),
        path: '/jira/core/projects/:projectKey/settings/data-classifications',
        exact: true
    };
    var $65Ltd;
    const $5a27ba0a68240f95$export$322fe16ec991f12 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT),
        path: '/jira/core/projects/:projectKey/settings'
    };
    var $65Ltd;
    const $5d63f1af39ccfc34$export$14535b40530c8690 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS),
        path: '/jira/core/projects/:projectKey/settings/details',
        exact: true
    };
    var $65Ltd;
    const $03614f84baa4becb$export$7c4ee74641923239 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_FIELDS),
        path: '/jira/core/projects/:projectKey/settings/fields',
        exact: true
    };
    var $65Ltd;
    const $ffe7ed90d4a26759$export$b34160f55b6104e9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS),
        path: '/jira/core/projects/:projectKey/settings/apps/:appId/:envId/:route?'
    };
    var $65Ltd;
    const $9890a5b2bae88b9c$export$c3a32433c580b9ff = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES),
        path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId?',
        exact: true
    };
    var $65Ltd;
    const $5c1b1d7296dcb1b9$export$9e79ee307216071b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW),
        path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
        exact: true
    };
    var $65Ltd;
    const $91d0b5fe7c793948$export$b546589f1b048dc = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL),
        path: '/jira/core/projects/:projectKey/settings/notifications/notification-email',
        exact: true
    };
    var $65Ltd;
    const $1ebe41c3d3a19553$export$56a8a0b88329b044 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS_ISSUE_LOGS),
        path: '/jira/core/projects/:projectKey/settings/notifications/issue-logs',
        exact: true
    };
    var $65Ltd;
    const $3cc89fad893f0f33$export$a1ee80066685b98d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS),
        path: '/jira/core/projects/:projectKey/settings/notifications',
        exact: true
    };
    var $65Ltd;
    const $bffeb81c48a88921$export$4e7ce7e6ced0f291 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER),
        path: '/jira/core/projects/:projectKey/settings/forms/form/:templateFormId/edit',
        exact: true
    };
    var $65Ltd;
    const $ca16757f7d5a6f92$export$57fe8c5107a9c0de = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS),
        path: '/jira/core/projects/:projectKey/settings/forms',
        exact: true
    };
    var $jaAyo;
    var $4R6GH;
    const $9ed220cf4f93fbf5$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "b2b412853cb2e067403107800e6bf6a94c8346b563ac95be61ffb329b6395f3f",
            "metadata": {},
            "name": "src_jiraBusinessApprovalsSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $9ed220cf4f93fbf5$export$2e2bcd8739ae039 = $9ed220cf4f93fbf5$var$node;
    var $eufEc;
    var $fEDBv;
    const $d1b68aa40690ad89$export$1389a6ddf34f642e = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("aIXb8")), {
            moduleId: "83e2f2c2"
        }),
        getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
            const projectKey = context.match.params.projectKey;
            if (projectKey == null) throw new Error('Project key missing');
            return {
                queries: {
                    approvalsSettingsQuery: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: $9ed220cf4f93fbf5$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey,
                            withProjectFragment: (0, (0, parcelRequire("4R6GH")).fg)('sv-15_migrate_approvals_settings_to_entrypoint')
                        }
                    }
                }
            };
        }
    });
    const $baebbc2289a2b843$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924",
            "metadata": {},
            "name": "uiIssueNotificationLogsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $baebbc2289a2b843$export$2e2bcd8739ae039 = $baebbc2289a2b843$var$node;
    var $eufEc;
    var $fEDBv;
    const $6adcc3494d7c3774$export$97bbdefcbe0571ac = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("dGsmU")), {
            moduleId: "b2136a4d"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    notificationLogs: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: $baebbc2289a2b843$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectId: Number(context?.query?.projectId ?? 0),
                            notificationType: 'INTERNAL_NOTIFICATION_ISSUE'
                        }
                    }
                },
                extraProps: {
                    accountId: tenantContext.atlassianAccountId,
                    cloudId: tenantContext.cloudId,
                    projectIds: context?.query?.projectId,
                    projectKey: context?.match.params.projectKey
                }
            })
    });
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $7tQej;
    var $5uXOq = parcelRequire("5uXOq");
    var $9QpK7;
    var $1J3t1;
    var $7tQej;
    const $646d86edb6dba940$var$ProjectSettingsRedirectNew = ({ match: match })=>{
        const { data: data } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const { projectKey: projectKey } = match.params;
        if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/jira/core/projects/${String(projectKey)}/settings/details`
        });
        if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
        });
        if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
        });
    };
    const $646d86edb6dba940$var$ProjectSettingsRedirectOld = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
        });
    const $646d86edb6dba940$export$72130cf40a3c3778 = (0, (0, parcelRequire("9QpK7")).componentWithFF)('olympus-da-157-enable-project-settings-navigation_zxaq5', $646d86edb6dba940$var$ProjectSettingsRedirectNew, $646d86edb6dba940$var$ProjectSettingsRedirectOld);
    const $f037ab3fb0896e94$var$approvalsProjectSettingsPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $d1b68aa40690ad89$export$1389a6ddf34f642e),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $f037ab3fb0896e94$var$emailNotificationsLogEntryPointPage = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $6adcc3494d7c3774$export$97bbdefcbe0571ac),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource = ()=>[
            (0, (0, parcelRequire("eOlBz")).newIssueViewTransitionLockInStatusResource),
            (0, (0, parcelRequire("kJQXA")).navigationSidebarAutomationLegacyEnabledResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
            (0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleResource),
            (0, (0, parcelRequire("loy04")).staticProjectSettingsSidebarConnectAddonsNavigationResource)
        ];
    const $f037ab3fb0896e94$var$LazyIssueTypeSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("h5Sqc"))), {
        moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$b6450e98f3b2e500 = ({ match: match })=>{
        const { issueTypeId: issueTypeId } = match.params;
        const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyIssueTypeSettings,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
    const $f037ab3fb0896e94$var$LazyFieldsSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2RcTH"))), {
        moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$642e36be5f0881cd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyFieldsSettings,
            pageId: "project-settings-fields",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyWorkflowNavigationSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fYshJ"))), {
        moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$2fc344606596921e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyWorkflowNavigationSettings,
            pageId: "project-settings-workflow-navigation",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyConnectAppsSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("RJn1w"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$a9e7f90b84deda9f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyConnectAppsSettings,
            pageId: "project-settings-connect-apps",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyConnectAppControlsSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6JK34"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$ceddc4fc7b9c0729 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyConnectAppControlsSettings,
            pageId: "project-settings-connect-app-controls",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyDetailsSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fU2jM"))), {
        moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$3e8048d3cf2ba3fd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyDetailsSettings,
            pageId: "project-settings-details",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyPeopleSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6Eu7X"))), {
        moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$3026e5a52c747d2c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyPeopleSettings,
            pageId: "project-settings-people",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyProjectSettingsProformaProjectForms = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("dju2Q")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$4963607e49ab309f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyProjectSettingsProformaProjectForms,
            pageId: "project-settings-proforma-project-forms",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyProjectSettingsProformaJiraFormBuilder = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("6luCE")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$c32892afcc1da510 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyProjectSettingsProformaJiraFormBuilder,
            pageId: "project-settings-proforma-jira-form-builder",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyProjectSettingsJiraAutomation = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("c32Mm")), {
        moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$132a1e91790bf469 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyProjectSettingsJiraAutomation,
            pageId: "project-settings-jira-automation",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyDataClassificationsSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dYp24"))), {
        moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$a325b082c894541b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyDataClassificationsSettings,
            pageId: "project-settings-data-classifications",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyNotificationsSettings = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lvyS5"))), {
        moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
    });
    const $f037ab3fb0896e94$var$LazyNotificationsIssueLogs = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dGsmU"))), {
        moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$36ba2f559d49a8f6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyNotificationsSettings,
            pageId: "project-settings-software-notifications",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$export$361bca0a4a18e111 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyNotificationsIssueLogs,
            pageId: "project-settings-software-notifications-issue-logs",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyProjectSettingsNotificationEmail = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hM6gT"))), {
        moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$90c2f52b54888c20 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyProjectSettingsNotificationEmail,
            pageId: "project-settings-email-notifications",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyForgeProjectSettingsPage = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3kJhU")), {
        moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$b943f48844c671a5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyForgeProjectSettingsPage,
            pageId: "forge-spa-project-settings",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$export$df1c02c3f28b7a95 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5a27ba0a68240f95$export$322fe16ec991f12), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: (0, $646d86edb6dba940$export$72130cf40a3c3778),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    const $f037ab3fb0896e94$export$95ecbacf0120fcfd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9890a5b2bae88b9c$export$c3a32433c580b9ff), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$b6450e98f3b2e500,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyIssueTypeSettings
            ]
        }));
    const $f037ab3fb0896e94$export$8d8dff75124dcebc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $03614f84baa4becb$export$7c4ee74641923239), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            ufoName: 'project-settings.fields.jwm-tmp',
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("e7C7O")).fieldSettingsRelayResource)
            ],
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('project_fields_page_for_tmp_-_mvp', $f037ab3fb0896e94$export$642e36be5f0881cd, (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyFieldsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$1dfd4811b9065dd6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5c1b1d7296dcb1b9$export$9e79ee307216071b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$2fc344606596921e,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyWorkflowNavigationSettings
            ]
        }));
    const $f037ab3fb0896e94$export$c038a2892f34f1a9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7add52f5911a831e$export$c7ac65fb0bbe767f), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$a9e7f90b84deda9f,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyConnectAppsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$7870a0b1630a504e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $68a47d7164ebf1d3$export$1c7e75ffaa491922), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$ceddc4fc7b9c0729,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyConnectAppControlsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$438a330ccc1e7a91 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5d63f1af39ccfc34$export$14535b40530c8690), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$3e8048d3cf2ba3fd,
            skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsDetailsSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyDetailsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$8188648c76953df0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $213a8c0a4e177f13$export$fe93051d5b7385a1), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$3026e5a52c747d2c,
            skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsAccessSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyPeopleSettings
            ],
            ufoName: 'project-settings.access'
        }));
    const $f037ab3fb0896e94$export$36e1851c22975fc0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cb26bde1d38666aa$export$59e3323ba0cc224a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                    to: `/jira/core/projects/${String(match.params.projectKey)}/settings/access`,
                    push: false
                }),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyPeopleSettings
            ]
        }));
    const $f037ab3fb0896e94$export$5e9e27f116094fdf = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ca16757f7d5a6f92$export$57fe8c5107a9c0de), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$4963607e49ab309f,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsProformaProjectForms
            ],
            perfMetricKey: 'forms-settings'
        }));
    const $f037ab3fb0896e94$export$46d6b55ebf21ccc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $bffeb81c48a88921$export$4e7ce7e6ced0f291), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$c32892afcc1da510,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsProformaJiraFormBuilder
            ],
            perfMetricKey: 'form-builder'
        }));
    const $f037ab3fb0896e94$export$a244870e56f5c9a3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7024005c59ef8f32$export$65a4d727336c49f4), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$132a1e91790bf469,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsJiraAutomation
            ],
            ufoName: 'project-settings-automation-core'
        }));
    const $f037ab3fb0896e94$export$a2c8a6767edeeaed = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e31b6bde721f5bf5$export$5437af2650f645e0), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$132a1e91790bf469,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsJiraAutomation
            ]
        }));
    const $f037ab3fb0896e94$export$cf5194c476e8bcdb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $46bd61981cdecbb8$export$7aae1006c82a79c0), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$a325b082c894541b,
            skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsDetailsSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    const $f037ab3fb0896e94$export$ed481b03aa858542 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3cc89fad893f0f33$export$a1ee80066685b98d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$36ba2f559d49a8f6,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyNotificationsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$e562140c482cb0c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1ebe41c3d3a19553$export$56a8a0b88329b044), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$361bca0a4a18e111,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyNotificationsIssueLogs
            ],
            entryPoint () {
                return $f037ab3fb0896e94$var$emailNotificationsLogEntryPointPage;
            }
        }));
    const $f037ab3fb0896e94$export$da36a1671d868927 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $91d0b5fe7c793948$export$b546589f1b048dc), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$90c2f52b54888c20,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsNotificationEmail
            ]
        }));
    const $f037ab3fb0896e94$export$1006fd9f5f02b1c2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ffe7ed90d4a26759$export$b34160f55b6104e9), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$b943f48844c671a5,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyForgeProjectSettingsPage
            ]
        }));
    const $f037ab3fb0896e94$export$728033a86ab68014 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2c78c142a4e64bf0$export$ba11c8f378a2c121), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            entryPoint () {
                return $f037ab3fb0896e94$var$approvalsProjectSettingsPageEntryPoint;
            },
            ufoName: 'project-settings-approvals-core'
        }));
    const $f037ab3fb0896e94$export$4bad3905623f839b = [
        $f037ab3fb0896e94$export$95ecbacf0120fcfd,
        $f037ab3fb0896e94$export$8d8dff75124dcebc,
        $f037ab3fb0896e94$export$1dfd4811b9065dd6,
        $f037ab3fb0896e94$export$7870a0b1630a504e,
        $f037ab3fb0896e94$export$c038a2892f34f1a9,
        $f037ab3fb0896e94$export$438a330ccc1e7a91,
        $f037ab3fb0896e94$export$8188648c76953df0,
        $f037ab3fb0896e94$export$36e1851c22975fc0,
        $f037ab3fb0896e94$export$5e9e27f116094fdf,
        $f037ab3fb0896e94$export$46d6b55ebf21ccc,
        $f037ab3fb0896e94$export$a2c8a6767edeeaed,
        $f037ab3fb0896e94$export$cf5194c476e8bcdb,
        $f037ab3fb0896e94$export$a244870e56f5c9a3,
        $f037ab3fb0896e94$export$ed481b03aa858542,
        $f037ab3fb0896e94$export$e562140c482cb0c,
        $f037ab3fb0896e94$export$da36a1671d868927,
        $f037ab3fb0896e94$export$1006fd9f5f02b1c2,
        $f037ab3fb0896e94$export$728033a86ab68014,
        $f037ab3fb0896e94$export$df1c02c3f28b7a95
    ];
    var $ffza4;
    var $65Ltd;
    var $co1wz;
    var $cSD7y;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $gmE3I;
    var $2pT4g;
    var $dxCvy;
    var $e7C7O;
    var $fpjJX;
    var $cAofY;
    var $10cgn;
    var $8CwPO;
    var $6sNnq;
    var $gNStA;
    var $5lsNZ;
    var $e4eHl = parcelRequire("e4eHl");
    var $65Ltd;
    var $4R6GH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $5lsNZ;
    var $65Ltd;
    var $1eBsr;
    const $f6a9df88dc0097bb$export$5920ce3a2ccf6e2b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLAYBOOKS_EDIT),
        path: `${(0, (0, parcelRequire("1eBsr")).getProjectSettingsUrl)((0, (0, parcelRequire("1eBsr")).SERVICE_DESK_PRODUCT))}/playbooks/:id`,
        exact: true
    };
    var $8YZBz;
    var $6Z2mh;
    var $eufEc;
    var $fEDBv;
    const $7c46caae51932151$var$playbookEditViewEntryPoint = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("3JBxD")), {
            moduleId: "15e5be42"
        }),
        getPreloadProps: ({ context: context })=>{
            const { projectKey: projectKey } = context.match.params;
            if (!projectKey) throw new Error('projectKey is required');
            return {
                extraProps: {
                    playbookId: context?.match.params.id || '__new__',
                    projectKey: projectKey
                },
                queries: {}
            };
        }
    });
    var $7c46caae51932151$export$2e2bcd8739ae039 = $7c46caae51932151$var$playbookEditViewEntryPoint;
    var $8fDOc;
    var $6YEEX;
    var $eufEc;
    var $fEDBv;
    const $787278c10397c75e$var$playbookListViewEntryPoint = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("8RxBf")), {
            moduleId: "a498670b"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = context.match.params;
            const { tab: tab = 'list' } = context.query;
            if (!projectKey) throw new Error('projectKey is required');
            const entryPoints = tab === 'logs' ? {
                preloadedPlaybookLogsEntryPoint: {
                    entryPoint: (0, (0, parcelRequire("6YEEX")).playbookLogsEntryPoint),
                    entryPointParams: {
                        cloudId: tenantContext.cloudId
                    }
                }
            } : {
                preloadedPlaybookListEntryPoint: {
                    entryPoint: (0, (0, parcelRequire("8fDOc")).playbookListEntryPoint),
                    entryPointParams: {
                        cloudId: tenantContext.cloudId
                    }
                }
            };
            return {
                extraProps: {
                    accountId: tenantContext.atlassianAccountId,
                    cloudId: tenantContext.cloudId,
                    projectId: context.query.projectId,
                    projectKey: context.match.params.projectKey
                },
                entryPoints: entryPoints
            };
        }
    });
    var $787278c10397c75e$export$2e2bcd8739ae039 = $787278c10397c75e$var$playbookListViewEntryPoint;
    const $89f595ea28ec651e$var$listEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $787278c10397c75e$export$2e2bcd8739ae039),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $89f595ea28ec651e$var$editEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $7c46caae51932151$export$2e2bcd8739ae039),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $89f595ea28ec651e$var$getServiceDeskRoutesCommon = ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            }
        });
    const $89f595ea28ec651e$export$89ee08578c593726 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8YZBz")).servicedeskPlaybooksListRoute), ()=>({
                ...$89f595ea28ec651e$var$getServiceDeskRoutesCommon(),
                entryPoint () {
                    return (0, (0, parcelRequire("4R6GH")).fg)('playbooks-in-jsm') ? $89f595ea28ec651e$var$listEntryPoint : undefined;
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: 'project-settings.playbooks.admin-list-view',
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLAYBOOKS_LIST)),
                        teamName: 'ITOps Phantom'
                    }
                },
                component: (0, (0, parcelRequire("5lsNZ")).default),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                ufoName: 'playbook-list'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f6a9df88dc0097bb$export$5920ce3a2ccf6e2b), ()=>({
                ...$89f595ea28ec651e$var$getServiceDeskRoutesCommon(),
                entryPoint () {
                    return (0, (0, parcelRequire("4R6GH")).fg)('playbooks-in-jsm') ? $89f595ea28ec651e$var$editEntryPoint : undefined;
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: 'project-settings.playbooks.admin-edit-view',
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLAYBOOKS_EDIT)),
                        teamName: 'ITOps Phantom'
                    }
                },
                component: (0, (0, parcelRequire("5lsNZ")).default),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                ufoName: 'playbook-edit'
            }))
    ];
    var $7HDop;
    var $65Ltd;
    var $fFv0O;
    const $b9987e58af4bd5dd$export$10bafd1256118bb8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/apps/:appId/:envId/:route?`
    };
    var $65Ltd;
    var $fFv0O;
    const $332bb1f1674139e3$export$18c6f3890d9fd8b8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/notifications`,
        exact: true
    };
    var $9ujoJ;
    var $buwAo;
    var $65Ltd;
    var $fFv0O;
    const $728b3991bd6c3f5e$export$eb1177fbc6c41b97 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-access-redirect`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/people`,
        exact: true
    };
    var $1upsT;
    var $65Ltd;
    var $fFv0O;
    const $5754bd1d880cbd9d$export$7ae67c73ac5367a8 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-apps`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/apps/:appId?`,
        exact: true
    };
    var $cARMJ;
    var $hXPqO;
    var $65Ltd;
    var $fFv0O;
    const $744f8595a3eb8031$export$77d19d35e71558b3 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/channels`,
        exact: true
    };
    var $hj1rS;
    var $h1R4C;
    var $6QV1R;
    var $c7Cuy;
    var $fCKoM;
    var $k3pgS;
    var $5AlVM;
    var $e9ygf;
    var $dD71x;
    var $7dxyN;
    var $bHuHZ;
    var $hllBd;
    var $kEqE6;
    var $6MVjO;
    var $5lhuE;
    var $6pNsO;
    var $iMriO;
    var $65Ltd;
    var $fFv0O;
    const $c4193216794a9ba4$export$5ed718db41f9c966 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes-workflow`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/issuetypes/:issueTypeId/:initialSection(workflow)`,
        exact: true
    };
    var $4dsIk;
    var $d3Aot;
    var $6Y0Zp;
    var $f8kSl;
    var $6oHQj;
    var $65Ltd;
    var $fFv0O;
    const $fb231bf25e7005a7$export$ce59d5cb98345f8e = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-proforma-jira-form-builder`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/forms/form/:templateFormId/edit`,
        exact: true
    };
    var $dDinN;
    var $65Ltd;
    var $fFv0O;
    const $4d7c8f7ead571cf5$export$43b5b901d4988763 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-redirect`,
        path: (0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)
    };
    var $gIHTV;
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $7aaa8a1a977bd12c$export$5575497f0592ee94 = 'servicedesk';
    const $7aaa8a1a977bd12c$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $32c2488afce521ea$export$5b3aca7bf312c9a3 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-copy-rule`,
        path: `${(0, $7aaa8a1a977bd12c$export$5132c64eefe46250)((0, $7aaa8a1a977bd12c$export$5575497f0592ee94))}/automation/copy/:ruleId`
    };
    var $65Ltd;
    const $3ee467b4e1568034$export$3b8691f4e10340a9 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-create`,
        path: `${(0, $7aaa8a1a977bd12c$export$5132c64eefe46250)((0, $7aaa8a1a977bd12c$export$5575497f0592ee94))}/automation/blueprint/:blueprintKey`
    };
    var $65Ltd;
    const $6c95fb6d8dbdc82f$export$c581a12a4f58fa26 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-edit-rule`,
        path: `${(0, $7aaa8a1a977bd12c$export$5132c64eefe46250)((0, $7aaa8a1a977bd12c$export$5575497f0592ee94))}/automation/ruleset/:ruleId`
    };
    var $65Ltd;
    const $a5c20e51e1d79372$export$3e9315c24fe609c3 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-summary`,
        path: `${(0, $7aaa8a1a977bd12c$export$5132c64eefe46250)((0, $7aaa8a1a977bd12c$export$5575497f0592ee94))}/automation`
    };
    var $65Ltd;
    const $6d13f0535904970b$export$e0ddfe5d87fb5601 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-view-log`,
        path: `${(0, $7aaa8a1a977bd12c$export$5132c64eefe46250)((0, $7aaa8a1a977bd12c$export$5575497f0592ee94))}/automation/log/:ruleId`
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $10ca54f4f21ea64a$export$4a3b5f6370555dbc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("f4piI")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-copy-rule/src/index.tsx"
    });
    var $10ca54f4f21ea64a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $10ca54f4f21ea64a$export$4a3b5f6370555dbc,
            pageId: "project-settings-automation-copy-rule",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $2a5fc816810cf307$export$5b197b51eb5ad982 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("gCMPW")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-create-rule/src/index.tsx"
    });
    var $2a5fc816810cf307$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2a5fc816810cf307$export$5b197b51eb5ad982,
            pageId: "project-settings-automation-create-rule",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $0645e13982e9c11f$export$c1c9a68738a9ab36 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("bSsDz")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-edit-rule/src/index.tsx"
    });
    var $0645e13982e9c11f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0645e13982e9c11f$export$c1c9a68738a9ab36,
            pageId: "project-settings-automation-edit-rule",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $02Psx;
    var $g5X3G;
    var $7tQej;
    const $69d1eaf61634b750$export$39684840f773be1e = (pageType)=>{
        switch(pageType){
            case 'edit':
                return 'ruleset/:ruleId';
            case 'copy':
                return 'copy/:ruleId';
            case 'create':
                return 'blueprint/:blueprintKey';
            case 'viewlog':
                return 'log/:ruleId';
            default:
                return '';
        }
    };
    const $69d1eaf61634b750$var$newAutomationUrl = (baseUrl, { match: match }, pageType)=>{
        const { projectKey: projectKey } = match.params;
        if (pageType === 'edit') {
            const { ruleId: ruleId } = match.params;
            return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation/ruleset/${ruleId || ''}`;
        }
        if (pageType === 'copy') {
            const { ruleId: ruleId } = match.params;
            return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation/copy/${ruleId || ''}`;
        }
        if (pageType === 'viewlog') {
            const { ruleId: ruleId } = match.params;
            return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation/log/${ruleId || ''}`;
        }
        if (pageType === 'create') {
            const { blueprintKey: blueprintKey } = match.params;
            return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation/blueprint/${blueprintKey || ''}`;
        }
        return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation`;
    };
    const $69d1eaf61634b750$export$d6674bfa636b8090 = (pageType)=>(routeContext)=>{
            const emptyBaseUrl = (0, (0, parcelRequire("g5X3G")).toBaseUrl)('');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: $69d1eaf61634b750$var$newAutomationUrl(emptyBaseUrl, routeContext, pageType),
                push: false
            });
        };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $8a03171b9122a104$export$2fc8c3fcbb365b89 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aP8ev")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-summary/src/index.tsx"
    });
    var $8a03171b9122a104$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8a03171b9122a104$export$2fc8c3fcbb365b89,
            pageId: "project-settings-automation-summary",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $6f8757b068912193$export$db6c5cdbc65b2b4a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("l7KAf")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-view-log/src/index.tsx"
    });
    var $6f8757b068912193$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6f8757b068912193$export$db6c5cdbc65b2b4a,
            pageId: "project-settings-automation-view-log",
            shouldShowSpinner: true
        });
    const $da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon = ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        });
    const $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute = (pageType)=>(0, (0, parcelRequire("2G9Bk")).createEntry)({
            name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-redirect-${pageType}`,
            path: `/projects/:projectKey/settings/automation/${(0, $69d1eaf61634b750$export$39684840f773be1e)(pageType)}`
        }, ()=>({
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                forPaint: [],
                component: (0, $69d1eaf61634b750$export$d6674bfa636b8090)(pageType)
            }));
    const $da7bdd95981ae4d9$export$8521f0867b2d52e4 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6c95fb6d8dbdc82f$export$c581a12a4f58fa26), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.edit-rule',
                component: (0, $0645e13982e9c11f$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $0645e13982e9c11f$export$c1c9a68738a9ab36)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $32c2488afce521ea$export$5b3aca7bf312c9a3), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.copy-rule',
                component: (0, $10ca54f4f21ea64a$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $10ca54f4f21ea64a$export$4a3b5f6370555dbc)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3ee467b4e1568034$export$3b8691f4e10340a9), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.create-rule',
                component: (0, $2a5fc816810cf307$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2a5fc816810cf307$export$5b197b51eb5ad982)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6d13f0535904970b$export$e0ddfe5d87fb5601), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.log',
                component: (0, $6f8757b068912193$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6f8757b068912193$export$db6c5cdbc65b2b4a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a5c20e51e1d79372$export$3e9315c24fe609c3), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.summary',
                component: (0, $8a03171b9122a104$export$2e2bcd8739ae039),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8a03171b9122a104$export$2fc8c3fcbb365b89)
                ]
            })),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('create'),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('edit'),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('copy'),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('viewlog'),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('summary')
    ];
    var $ffza4;
    var $65Ltd;
    var $cSD7y;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $6t7hJ;
    var $f4T09;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    const $aa137e884608085b$export$8249a46a710af6da = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-notifications`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: url
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $7OYJs;
    var $doZTA;
    var $8WSu7;
    var $aTz47;
    var $jEJ7g;
    const $ebd0dfae741c0d7b$export$c224e724e933fbea = (page, pathname)=>{
        if (page === 'customer-notifications') {
            const customerNotificationsPage = pathname.split('/settings/customer-notifications')[1];
            if (customerNotificationsPage === '/template') return 'customer-notifications-template';
            if (customerNotificationsPage === '/account-notification/invite-customer') return 'customer-notifications-invite-customer';
            if (/rule\/\d+/.test(customerNotificationsPage)) return 'customer-notifications-rule';
        }
        return page;
    };
    const $ebd0dfae741c0d7b$export$2d1034e371a567c6 = (page, pathname)=>{
        switch(page){
            case 'kb':
                return (0, (0, parcelRequire("8WSu7")).getSettingsPath)(pathname.replace('/confluence-kb', '/kb'), true);
            default:
                return (0, (0, parcelRequire("8WSu7")).getSettingsPath)(pathname, true);
        }
    };
    const $ebd0dfae741c0d7b$export$a24ec33acfeae48d = ({ page: page, children: children })=>{
        const [{ location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isJCS = (0, (0, parcelRequire("jEJ7g")).useIsJCS)();
        (0, $5uXOq.useEffect)(()=>{
            if (isJCS && !(0, (0, parcelRequire("aTz47")).isHelpCenterSettingsPath)()) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
                page: $ebd0dfae741c0d7b$export$c224e724e933fbea(page, location.pathname)
            });
        }, [
            createAnalyticsEvent,
            isJCS,
            location.pathname,
            page
        ]);
        if (isJCS && !(0, (0, parcelRequire("aTz47")).isHelpCenterSettingsPath)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: $ebd0dfae741c0d7b$export$2d1034e371a567c6(page, location.pathname),
            persistSearchParams: true
        });
        return children;
    };
    var $5j7Th;
    var $kxZPA;
    const $6081b8204512e323$export$c763ea321ade5f68 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("eDXxK")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-notifications/src/index.tsx"
    });
    var $6081b8204512e323$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ebd0dfae741c0d7b$export$a24ec33acfeae48d), {
            page: "customer-notifications"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6081b8204512e323$export$c763ea321ade5f68,
            pageId: "project-settings-customer-notifications",
            shouldShowSpinner: true
        }));
    const $6cda2c2384bf3147$export$d6bb339f4d05f5c5 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6t7hJ")).routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $6081b8204512e323$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6081b8204512e323$export$c763ea321ade5f68)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("f4T09")).routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $aa137e884608085b$export$8249a46a710af6da), (0, $6081b8204512e323$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $6081b8204512e323$export$c763ea321ade5f68)
                ]
            }))
    ];
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $fpjJX;
    var $8u8s7;
    var $7ptuV;
    var $6Z2mh;
    var $lmyls;
    const $5c24657e8d4ddd13$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "a167719dd25bf7bab3041ef961fefa3d673c39f413e94051e24f3dca8b62fac9",
            "metadata": {},
            "name": "JourneyConfigurationPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $5c24657e8d4ddd13$export$2e2bcd8739ae039 = $5c24657e8d4ddd13$var$node;
    var $eufEc;
    var $fEDBv;
    const $1dfcd84f3f61c84b$export$26f82de7820f0c3 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("dnPrO")), {
            moduleId: "6bffb775",
            moduleName: "JourneyConfigurationPage"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    jiraJourneyConfiguration: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: $5c24657e8d4ddd13$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            journeyId: context.match.params.journeyId ?? ''
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            })
    });
    const $e2e16678033c3122$export$35537410b0bf07ea = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $1dfcd84f3f61c84b$export$26f82de7820f0c3),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    var $lmyls;
    const $0dab8bc029613fb5$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "93f4c558a2556dbc81f0b97b89b4ca9b15422f9b285f26f257e73153505df67b",
            "metadata": {},
            "name": "JourneysPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $0dab8bc029613fb5$export$2e2bcd8739ae039 = $0dab8bc029613fb5$var$node;
    var $eufEc;
    var $fEDBv;
    const $1cbf56bd5b792bd0$export$4ded7f93dbe6eb63 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("ec5aY")), {
            moduleId: "ab11e2ef",
            moduleName: "JourneysPage"
        }),
        getPreloadProps: ({ tenantContext: tenantContext })=>({
                queries: {
                    journeysPageQueryRef: {
                        parameters: $0dab8bc029613fb5$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: tenantContext.cloudId
                        },
                        options: {
                            fetchPolicy: 'store-and-network'
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            })
    });
    const $afecb2c38eb0ad75$export$3b90f0eb27bdd52f = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $1cbf56bd5b792bd0$export$4ded7f93dbe6eb63),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $6ffe646ddf6221b0$export$5dfc85c70e03c102 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7ptuV")).routeGroupsProjectSettingsServicedeskJourneysRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)()
                ],
                entryPoint: ()=>(0, $afecb2c38eb0ad75$export$3b90f0eb27bdd52f)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8u8s7")).routeGroupsProjectSettingsServicedeskJourneyConfigurationRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)()
                ],
                entryPoint: ()=>(0, $e2e16678033c3122$export$35537410b0bf07ea)
            }))
    ];
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $jpwsu;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0bf88a8d63415148$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
    const $0bf88a8d63415148$export$1aa47348ef6dbdda = 'project/service-desk/settings';
    const $0bf88a8d63415148$export$583a442626bd3345 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8G8Xo")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-knowledge-base/src/index.tsx"
    });
    const $0bf88a8d63415148$export$7c7186fdd8c56428 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jpppj"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-settings/src/index.tsx"
    });
    const $0bf88a8d63415148$export$6d92735e249274bb = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ebd0dfae741c0d7b$export$a24ec33acfeae48d), {
            page: "kb"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0bf88a8d63415148$export$7c7186fdd8c56428,
            pageId: "project-settings-knowledge-base",
            shouldShowSpinner: true
        }));
    var $0bf88a8d63415148$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0bf88a8d63415148$export$583a442626bd3345,
            pageId: "project-settings-knowledge-base",
            shouldShowSpinner: true
        });
    const $62c3d1c204167743$export$f90c0f16cffd8883 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jpwsu")).routeGroupsProjectSettingsServicedeskKbRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                perfMetricKey: 'service-management.kb-settings',
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                component: (0, $0bf88a8d63415148$export$6d92735e249274bb),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $0bf88a8d63415148$export$7c7186fdd8c56428)
                ],
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ]
            }))
    ];
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $dxCvy;
    var $fpjJX;
    var $4wBwP;
    var $hewRX;
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $l8ruj;
    var $kxZPA;
    const $45b508c287c9b763$export$a6694c07cb5be8c1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("g4dfU"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-sla-settings/src/index.tsx"
    });
    const $45b508c287c9b763$export$c56fde3803c5a1a3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "project-settings-service-desk-sla-settings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $45b508c287c9b763$export$a6694c07cb5be8c1,
            pageId: "project-settings-service-desk-sla-settings",
            shouldShowSpinner: true
        }));
    const $e00888b39cabebc3$export$fd1a58e6255623a = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hewRX")).servicedeskSlaSettingsRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).SLA_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).SLA_SETTINGS),
                        teamName: 'bumblebee'
                    }
                },
                perfMetricKey: 'jsm-sla-settings',
                component: (0, $45b508c287c9b763$export$c56fde3803c5a1a3),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("4wBwP")).slaMetricsDataResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $45b508c287c9b763$export$a6694c07cb5be8c1)
                ]
            }))
    ];
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $eUvlM;
    var $65Ltd;
    const $09d23763853027e1$export$5575497f0592ee94 = 'servicedesk';
    const $b00bd3879c91ba3c$export$50e6baca5c1f7a5b = {
        exact: true,
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-ticket-type-fields`,
        path: `/jira/${(0, $09d23763853027e1$export$5575497f0592ee94)}/projects/:projectKey/settings/request-types/category/:practice/request-type/:requestTypeId/:tabKey?`
    };
    var $65Ltd;
    const $4a5d7aa2ba92a0e4$export$51c2cd63e9954ab7 = {
        exact: true,
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-ticket-type-fields`,
        path: `/jira/${(0, $09d23763853027e1$export$5575497f0592ee94)}/projects/:projectKey/settings/request-types/request-type/:requestTypeId/:tabKey?`
    };
    var $65Ltd;
    const $19ff4b5d7b99e4a6$export$eeb615fb989a6e4d = {
        exact: true,
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-unassigned-ticket-type-fields`,
        path: `/jira/${(0, $09d23763853027e1$export$5575497f0592ee94)}/projects/:projectKey/settings/request-types/unassigned/request-type/:requestTypeId/:tabKey?`
    };
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $e9f2572a89172526$export$471040ce01e559fc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("k4XYc")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-type-fields/src/index.tsx"
    });
    var $e9f2572a89172526$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ebd0dfae741c0d7b$export$a24ec33acfeae48d), {
            page: "ticket-type-fields"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e9f2572a89172526$export$471040ce01e559fc,
            pageId: "project-settings-ticket-type-fields",
            shouldShowSpinner: true
        }));
    const $26c11c644324b9a1$var$getTicketTypeFieldsRoutesCommon = ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
            component: (0, $e9f2572a89172526$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $e9f2572a89172526$export$471040ce01e559fc)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).REQUEST_TYPE_FIELDS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).REQUEST_TYPE_FIELDS),
                    teamName: 'jsd-shield'
                }
            },
            ufoName: `${0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK}-ticket-type-fields`
        });
    const $26c11c644324b9a1$export$caa50198aadcf21c = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $19ff4b5d7b99e4a6$export$eeb615fb989a6e4d), ()=>({
                ...$26c11c644324b9a1$var$getTicketTypeFieldsRoutesCommon(),
                component: (0, $e9f2572a89172526$export$2e2bcd8739ae039)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b00bd3879c91ba3c$export$50e6baca5c1f7a5b), ()=>({
                ...$26c11c644324b9a1$var$getTicketTypeFieldsRoutesCommon()
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $4a5d7aa2ba92a0e4$export$51c2cd63e9954ab7), ()=>({
                ...$26c11c644324b9a1$var$getTicketTypeFieldsRoutesCommon()
            }))
    ];
    var $ffza4;
    var $65Ltd;
    var $co1wz;
    var $4R6GH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $2pT4g;
    var $dxCvy;
    var $fpjJX;
    var $k8jl5;
    var $1cpsA;
    var $eUvlM;
    var $6sNnq;
    var $gNStA;
    var $65Ltd;
    const $e4e0164ff340f46d$export$96fd54e139924473 = {
        exact: true,
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-ticket-types-config`,
        path: `/jira/${(0, $c537a1906485aaa6$export$5575497f0592ee94)}/projects/:projectKey/settings/request-types/category/:practice`
    };
    var $k3the;
    var $jZoZG;
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("a7j22")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-types-config/src/index.tsx"
    });
    var $d4145a6e3aeb3bbb$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ebd0dfae741c0d7b$export$a24ec33acfeae48d), {
            page: "ticket-types-config"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c,
            pageId: "project-settings-ticket-types-config",
            shouldShowSpinner: true
        }));
    const $7e5adb0871ecbbba$var$commonTicketTypesConfigRouteEntry = ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
            component: (0, $d4145a6e3aeb3bbb$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource),
                (0, (0, parcelRequire("k8jl5")).servicedeskIssueTypesResource),
                (0, (0, parcelRequire("1cpsA")).servicedeskPortalGroupsResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('enable_jsm_repackaging_changes_vtwk9'), (0, (0, parcelRequire("2pT4g")).jsmRepackagingBannerResource)),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jsm_hr_request_type_groups'), (0, (0, parcelRequire("6sNnq")).featuresResource))
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).REQUEST_TYPES_CONFIG,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).REQUEST_TYPES_CONFIG),
                    teamName: 'jsd-shield'
                }
            },
            perfMetricKey: 'jsm-request-types-configuration',
            ufoName: 'jsm-request-types-configuration'
        });
    const $7e5adb0871ecbbba$export$fa9d0db1668a0662 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jZoZG")).routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute), ()=>({
                ...$7e5adb0871ecbbba$var$commonTicketTypesConfigRouteEntry(),
                component: (0, $d4145a6e3aeb3bbb$export$2e2bcd8739ae039)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e4e0164ff340f46d$export$96fd54e139924473), ()=>({
                ...$7e5adb0871ecbbba$var$commonTicketTypesConfigRouteEntry()
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k3the")).routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute), ()=>({
                ...$7e5adb0871ecbbba$var$commonTicketTypesConfigRouteEntry()
            }))
    ];
    var $aIZdc;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $e9zsZ;
    var $65Ltd;
    const $945f4c839611ad80$export$57dc115194d72385 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-ai-answers`,
        exact: true,
        path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/ai-answers'
    };
    var $65Ltd;
    const $3541a643aa509b4d$export$c8ff4cf64e5540ec = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-browseconversations`,
        exact: true,
        path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations'
    };
    var $65Ltd;
    const $2004c35d63b7590d$export$3e227412713bc57f = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-browse-intents`,
        exact: true,
        path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents'
    };
    var $65Ltd;
    const $929ca13d8a48533c$export$fd091ba8fa858397 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-standard-flows`,
        exact: true,
        path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows'
    };
    var $65Ltd;
    const $f5084469ecd7a21e$export$8c051c399fd812a5 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagentonboarding`,
        exact: true,
        path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent'
    };
    var $65Ltd;
    const $a08dee66d983407c$export$d867623f05adedb3 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-performance`,
        exact: true,
        path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/performance'
    };
    var $65Ltd;
    const $b642a35d67793caf$export$847a7c378c11c645 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-settings`,
        exact: true,
        path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings/:tab(basic|channels)?'
    };
    var $65Ltd;
    const $aecf60273505ed2c$export$bf8131fb060d0e73 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-view-intent`,
        exact: true,
        path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents/:intentId/:tab(flow|training|settings)?'
    };
    var $65Ltd;
    const $f47ba2070dd83bf9$export$c74dca8be49046ea = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-view-standard-flow`,
        exact: true,
        path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows/:flowId/:tab(flow|settings)?'
    };
    var $6Z2mh;
    var $e9YVH;
    var $2vSU6;
    var $aPfsS;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7XluA;
    var $4mO32;
    var $hsmeR;
    var $dAfqg;
    const $e2036dd19a3f68c8$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "125329b9d4e888d6fdabbfee72c3e68f14cb83b841b09ddce260b26dc8ea5dce",
            "metadata": {},
            "name": "uiVirtualAgentIntentTemplatesQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $e2036dd19a3f68c8$export$2e2bcd8739ae039 = $e2036dd19a3f68c8$var$node;
    var $eufEc;
    var $fEDBv;
    const $6713c6429155461a$export$2b1d9dc27ee42f8f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("lRe5k")), {
            moduleId: "a4e9afeb"
        }),
        getPreloadProps: ({ cloudId: cloudId, key: key })=>({
                queries: {
                    intentTemplateQueryReference: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, $e2036dd19a3f68c8$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: cloudId,
                            key: key
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            })
    });
    var $av9sZ;
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $3fd9739904b8669a$exports = {};
    $3fd9739904b8669a$exports = new URL("virtual-agent-intent-template-sidebar-app-skeleton.tpl.e2ff8557.svg", import.meta.url).toString();
    const $61dfebc80ff570f9$var$customCssStyles = null;
    const $61dfebc80ff570f9$export$fa68b26760d5b66f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($3fd9739904b8669a$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $koeKL;
    const $cdb5ff159e084339$var$runtimeProps = {};
    const $cdb5ff159e084339$export$36ad24b9ac79bdc8 = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const panelId = rightSidebarCurrentState?.panelId ?? '';
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: projectContextData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                key: projectContextData?.projectKey ?? ''
            }), [
            cloudId,
            projectContextData
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, $6713c6429155461a$export$2b1d9dc27ee42f8f), entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            if (panelId === 'intentTemplate') entryPointActions.load();
            else entryPointActions.unload();
        }, [
            entryPointActions,
            panelId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "createIntentTemplatesSidebar",
            packageName: "jiraServicedeskSettingsVirtualAgentCreateIntentTemplates",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $61dfebc80ff570f9$export$fa68b26760d5b66f), null),
            errorFallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($cdb5ff159e084339$var$SideBarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("av9sZ")).ErrorDisplay), {
                    refetch: ()=>window.location.reload()
                })),
            runtimeProps: $cdb5ff159e084339$var$runtimeProps
        });
    };
    const $cdb5ff159e084339$var$SideBarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _11q71bhr _1kl7wsm2 _vchhusvi _1p57u2gc _4t3i1osq _18m91wug",
                __cmplp.className
            ])
        });
    });
    var $cdb5ff159e084339$export$2e2bcd8739ae039 = $cdb5ff159e084339$export$36ad24b9ac79bdc8;
    const $3f16128d6d3a9eb8$var$withServiceProjectContext = (Component)=>(0, (0, parcelRequire("aPfsS")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)
            }
        });
    const $3f16128d6d3a9eb8$export$6659f41b213bad05 = (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), {
        rightSidebars: [
            $3f16128d6d3a9eb8$var$withServiceProjectContext((0, $cdb5ff159e084339$export$2e2bcd8739ae039))
        ]
    });
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $f4918ad185cfd8af$exports = {};
    $f4918ad185cfd8af$exports = new URL("virtual-agent-ai-answers-app-skeleton.tpl.283eb0a3.svg", import.meta.url).toString();
    const $72ea56917d7c23c3$var$customCssStyles = null;
    const $72ea56917d7c23c3$export$5fe1280883d32350 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($f4918ad185cfd8af$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $ad27286735078899$exports = {};
    $ad27286735078899$exports = new URL("virtual-agent-browse-conversations-app-skeleton.tpl.9f030add.svg", import.meta.url).toString();
    const $93c172d4ef4f57d3$var$customStyles = null;
    const $93c172d4ef4f57d3$export$4a6267fad85ca589 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($ad27286735078899$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $aAhML;
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $4f6f020c30624e97$exports = {};
    $4f6f020c30624e97$exports = new URL("virtual-agent-browse-standard-flows-app-skeleton.tpl.51e6e95a.svg", import.meta.url).toString();
    const $42ac2f7c560a8df6$var$customCssStyles = null;
    const $42ac2f7c560a8df6$export$c2bd83dd149452bd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($4f6f020c30624e97$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $c4e5e973e166fec5$exports = {};
    $c4e5e973e166fec5$exports = new URL("virtual-agent-landing-app-skeleton.tpl.e8a7897b.svg", import.meta.url).toString();
    const $450c0f05e134cd5f$var$customStyles = null;
    const $450c0f05e134cd5f$export$f4b71d7b732df8a7 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($c4e5e973e166fec5$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $a3d2c3af3a16b398$exports = {};
    $a3d2c3af3a16b398$exports = new URL("virtual-agent-settings-app-skeleton.tpl.1a9c03fe.svg", import.meta.url).toString();
    const $d88dc21ec5f90208$var$customCssStyles = null;
    const $d88dc21ec5f90208$export$429c43ddcb09c14c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($a3d2c3af3a16b398$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $806ba01691200183$exports = {};
    $806ba01691200183$exports = new URL("virtual-agent-view-intent-app-skeleton.tpl.5dd31cbb.svg", import.meta.url).toString();
    const $3817d32b8c9a6704$var$customCssStyles = null;
    const $3817d32b8c9a6704$export$72b20c10a0f18a2f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($806ba01691200183$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $7c12655ddf830494$exports = {};
    $7c12655ddf830494$exports = new URL("virtual-agent-view-standard-flow-app-skeleton.tpl.ec3b149b.svg", import.meta.url).toString();
    const $cedc5dbef30f009d$var$customCssStyles = null;
    const $cedc5dbef30f009d$export$c6d3f04e6931e3f6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($7c12655ddf830494$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    var $dBV63;
    var $eufEc;
    var $fEDBv;
    const $a4434f7c7bc24d2f$export$5dcf9a7e1076ac6 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("bUyP8")), {
            moduleId: "b474af7a"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, (0, parcelRequire("dBV63")).default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    }
                }
            })
    });
    var $d4rfp;
    var $7oHmH;
    const $6a4522a333dd4135$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "f51fece264181c3f3b439059407da8b12752836c06ecefc9193d22e03ba66001",
            "metadata": {},
            "name": "srcVirtualAgentBrowseConversationsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisconversationfilterenabledrelayprovider": (0, (0, parcelRequire("d4rfp")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $6a4522a333dd4135$export$2e2bcd8739ae039 = $6a4522a333dd4135$var$node;
    var $eufEc;
    var $fEDBv;
    const $d5456be03cb88be5$var$DEFAULT_RANGE_DAYS = 14;
    const $d5456be03cb88be5$export$38549013d5d5a440 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("dcMPP")), {
            moduleId: "1bf85952"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const end = new Date();
            const start = new Date(end);
            start.setDate(start.getDate() - $d5456be03cb88be5$var$DEFAULT_RANGE_DAYS);
            return {
                extraProps: {
                    initialDateRange: {
                        start: start,
                        end: end
                    }
                },
                queries: {
                    page: {
                        parameters: (0, $6a4522a333dd4135$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                            startDate: start.toISOString(),
                            endDate: end.toISOString()
                        }
                    }
                }
            };
        }
    });
    var $7oHmH;
    const $84af76b2b1eda3ac$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "0633e4343510cee23e7f7d5bead3fdfd4ceab491801050403e9215a7819d2751",
            "metadata": {},
            "name": "srcVirtualAgentBrowseIntentsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $84af76b2b1eda3ac$export$2e2bcd8739ae039 = $84af76b2b1eda3ac$var$node;
    var $2LxWa;
    const $d3c21345417f9f8e$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "98ff9896a534365343e79a6d1c788e50aedc51a89613efbd1d99e193ec977064",
            "metadata": {},
            "name": "srcVirtualAgentBrowseIntentsStatisticsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableperformancepagerelayprovider": (0, (0, parcelRequire("2LxWa")).default)
            }
        }
    };
    var $d3c21345417f9f8e$export$2e2bcd8739ae039 = $d3c21345417f9f8e$var$node;
    var $eufEc;
    var $fEDBv;
    const $0c1a3d6ae6de7f87$var$DEFAULT_TIME_RANGE_MS = 604800000;
    const $0c1a3d6ae6de7f87$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10);
    const $0c1a3d6ae6de7f87$export$f19c213ae2d7940f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("lIh1i")), {
            moduleId: "85089c8d"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, $84af76b2b1eda3ac$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    },
                    statistics: {
                        parameters: (0, $d3c21345417f9f8e$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            startDate: $0c1a3d6ae6de7f87$var$formatFetchDate(new Date(Date.now() - $0c1a3d6ae6de7f87$var$DEFAULT_TIME_RANGE_MS)),
                            endDate: $0c1a3d6ae6de7f87$var$formatFetchDate(new Date())
                        }
                    }
                }
            })
    });
    var $7oHmH;
    const $4e33e127e8847987$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "b2740e61056af93841794a91099e9b96903f93d7fe50bb2475c769a63f9f5288",
            "metadata": {},
            "name": "srcVirtualAgentBrowseStandardFlowsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $4e33e127e8847987$export$2e2bcd8739ae039 = $4e33e127e8847987$var$node;
    var $eufEc;
    var $fEDBv;
    const $32e48f8946c41f01$export$f7de8593c7455f1 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("eODEk")), {
            moduleId: "c2d13204"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, $4e33e127e8847987$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                        }
                    }
                }
            })
    });
    var $7oHmH;
    var $ie9EN;
    const $588c29ffd4ee84e7$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "feccfb9e3bc379d2a0ebf948557bbffd3c9363945a1e90a8fbb27c275e18b09c",
            "metadata": {},
            "name": "srcVirtualAgentLandingQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaroiteaserm1enabledrelayprovider": (0, (0, parcelRequire("ie9EN")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $588c29ffd4ee84e7$export$2e2bcd8739ae039 = $588c29ffd4ee84e7$var$node;
    var $eufEc;
    var $fEDBv;
    const $0f9dae747ed8bf8a$export$ad927ca7512a3a01 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("j25Gx")), {
            moduleId: "06d84010"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, $588c29ffd4ee84e7$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    }
                }
            })
    });
    var $7oHmH;
    const $7c3ef32003964182$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "65d5189259513d8b049fd133098153332bb49cb7b35cbe258617e4cfaad3cec6",
            "metadata": {},
            "name": "srcVirtualAgentPerformanceQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $7c3ef32003964182$export$2e2bcd8739ae039 = $7c3ef32003964182$var$node;
    var $eufEc;
    var $fEDBv;
    const $94968a7dbb3de852$var$DEFAULT_TIME_RANGE_MS = 604800000;
    const $94968a7dbb3de852$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10);
    const $94968a7dbb3de852$export$52b48527e9315b46 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("b5QrI")), {
            moduleId: "25efd1aa"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, $7c3ef32003964182$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                            startDate: $94968a7dbb3de852$var$formatFetchDate(new Date(Date.now() - $94968a7dbb3de852$var$DEFAULT_TIME_RANGE_MS)),
                            endDate: $94968a7dbb3de852$var$formatFetchDate(new Date())
                        }
                    }
                }
            })
    });
    var $y2RTb;
    var $7oHmH;
    const $a14dfc5f3ce71c58$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "309d872182fe492b7c3e81d26f86714d796cff6575079789e1b34727ffa7d9ba",
            "metadata": {},
            "name": "srcVirtualAgentSettingsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableaianswerspagerelayprovider": (0, (0, parcelRequire("y2RTb")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $a14dfc5f3ce71c58$export$2e2bcd8739ae039 = $a14dfc5f3ce71c58$var$node;
    var $eufEc;
    var $fEDBv;
    const $a9827913d0401124$export$d34e7816b7ac181a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("ifumN")), {
            moduleId: "ed4de71b"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, $a14dfc5f3ce71c58$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                        }
                    }
                }
            })
    });
    var $7oHmH;
    const $45ed8bfdfee83271$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "a770411d52534005c4d94e2f61c74a98ed117522669e7af7701400ccbf2323f3",
            "metadata": {},
            "name": "srcVirtualAgentViewIntentQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $45ed8bfdfee83271$export$2e2bcd8739ae039 = $45ed8bfdfee83271$var$node;
    var $eufEc;
    var $fEDBv;
    const $ac6810a67c998d50$export$f51df662bd71ce39 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("7BEbO")), {
            moduleId: "bc04de30"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, $45ed8bfdfee83271$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            intentId: context.match.params.intentId ?? ''
                        }
                    }
                }
            })
    });
    var $7oHmH;
    const $1bc956e6a804d466$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "ad1b0d9d182a46ab37286f92d3ce29ce06821b61a8e30066a34f05c56ce72317",
            "metadata": {},
            "name": "srcVirtualAgentViewStandardFlowQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $1bc956e6a804d466$export$2e2bcd8739ae039 = $1bc956e6a804d466$var$node;
    var $eufEc;
    var $fEDBv;
    const $8d05ca45dd1a7906$export$4fd7bf09308d4abd = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("2vO2D")), {
            moduleId: "8e1cdfbd"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, $1bc956e6a804d466$export$2e2bcd8739ae039),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            flowId: context.match.params.flowId ?? ''
                        }
                    }
                }
            })
    });
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    const $a6392627f74f3006$export$5575497f0592ee94 = 'servicedesk';
    const $a6392627f74f3006$export$c9b0516439c55d7a = (product)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
            });
    const $8b897edada5ca041$var$browseConversationsPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $d5456be03cb88be5$export$38549013d5d5a440),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$browseIntentsPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $0c1a3d6ae6de7f87$export$f19c213ae2d7940f),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$browseStandardFlowsPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $32e48f8946c41f01$export$f7de8593c7455f1),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$landingPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $0f9dae747ed8bf8a$export$ad927ca7512a3a01),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$settingsPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $a9827913d0401124$export$d34e7816b7ac181a),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$viewStandardFlowPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $8d05ca45dd1a7906$export$4fd7bf09308d4abd),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$viewIntentPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $ac6810a67c998d50$export$f51df662bd71ce39),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$aiAnswersPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $a4434f7c7bc24d2f$export$5dcf9a7e1076ac6),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$performancePageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $94968a7dbb3de852$export$52b48527e9315b46),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$getVirtualAgentRoutesCommon = ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            }
        });
    const $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings = (0, $a6392627f74f3006$export$c9b0516439c55d7a)((0, $a6392627f74f3006$export$5575497f0592ee94));
    const $8b897edada5ca041$export$cf02bed1953597cb = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f5084469ecd7a21e$export$8c051c399fd812a5), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$landingPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, $450c0f05e134cd5f$export$f4b71d7b732df8a7),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2004c35d63b7590d$export$3e227412713bc57f), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$browseIntentsPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                layout: (0, $3f16128d6d3a9eb8$export$6659f41b213bad05),
                skeleton: (0, (0, parcelRequire("aAhML")).VirtualAgentBrowseIntentsSkeleton),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $aecf60273505ed2c$export$bf8131fb060d0e73), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$viewIntentPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, $3817d32b8c9a6704$export$72b20c10a0f18a2f),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $929ca13d8a48533c$export$fd091ba8fa858397), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$browseStandardFlowsPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, $42ac2f7c560a8df6$export$c2bd83dd149452bd),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f47ba2070dd83bf9$export$c74dca8be49046ea), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$viewStandardFlowPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, $cedc5dbef30f009d$export$c6d3f04e6931e3f6),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3541a643aa509b4d$export$c8ff4cf64e5540ec), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$browseConversationsPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, $93c172d4ef4f57d3$export$4a6267fad85ca589),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b642a35d67793caf$export$847a7c378c11c645), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$settingsPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, $d88dc21ec5f90208$export$429c43ddcb09c14c),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $945f4c839611ad80$export$57dc115194d72385), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$aiAnswersPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, $72ea56917d7c23c3$export$5fe1280883d32350),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("e9zsZ")).servicedeskVirtualAgentAiAnswersKbResource)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a08dee66d983407c$export$d867623f05adedb3), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$performancePageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_PERFORMANCE,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_PERFORMANCE),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            }))
    ];
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $dxCvy;
    var $fpjJX;
    var $j1kdz;
    var $6Z2mh;
    var $eufEc;
    var $fEDBv;
    const $5e46ff6da5ce3455$export$12ccdf1d30de8ac = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("jA964")), {
            moduleId: "6be3e66b"
        }),
        getPreloadProps: ()=>({})
    });
    const $0043ec7f595129fa$var$workflowSchemeConfigPageEntrypoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $5e46ff6da5ce3455$export$12ccdf1d30de8ac),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $0043ec7f595129fa$export$212f7f79630d5adc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("j1kdz")).routeGroupsProjectSettingsWorkflowSchemeConfigRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
            entryPoint () {
                return $0043ec7f595129fa$var$workflowSchemeConfigPageEntrypoint;
            },
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            meta: {
                reporting: {
                    id: 'project-settings.workflow-scheme-config',
                    packageName: 'projectSettingsWorkflowSchemeConfig',
                    teamName: 'jsd-shield'
                }
            },
            ufoName: 'project-settings-workflow-scheme-config'
        }));
    var $6Z2mh;
    var $ejiWA;
    var $e9YVH;
    var $7Txnp;
    var $k7tsS;
    var $f8FqB;
    var $jaAyo;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d7e52a3e5f45b58f$export$fa3bc297af95f169 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("aLHab"))), {
        moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
    });
    var $d7e52a3e5f45b58f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d7e52a3e5f45b58f$export$fa3bc297af95f169,
            pageId: "project-settings-app-discovery-settings",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $dAfqg;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $7tQej;
    const $3f52008d1cdfa258$export$246ec9cdadd2a163 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6JK34"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
    });
    const $3f52008d1cdfa258$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
        return shouldRedirect ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
            push: false
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $d7e52a3e5f45b58f$export$2e2bcd8739ae039), null);
    };
    const $3f52008d1cdfa258$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement($3f52008d1cdfa258$var$ConnectAppsRedirectInner, {
                match: match,
                basePath: basePath
            });
    var $3f52008d1cdfa258$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3f52008d1cdfa258$export$246ec9cdadd2a163,
            pageId: "project-settings-connect-app-controls",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $841a04425f045e7e$export$3633e017e520a1c2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("RJn1w"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
    });
    var $841a04425f045e7e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $841a04425f045e7e$export$3633e017e520a1c2,
            pageId: "project-settings-connect-apps",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dYp24"))), {
        moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
    });
    var $953aed1c2ae3d2f5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56,
            pageId: "project-settings-data-classifications",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $3746e6592757d8dd$export$6f16b5efddd5c646 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fU2jM"))), {
        moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
    });
    var $3746e6592757d8dd$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3746e6592757d8dd$export$6f16b5efddd5c646,
            pageId: "project-settings-details",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $c77ac9be273e47d5$export$e309780f520d125a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2RcTH"))), {
        moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
    });
    var $c77ac9be273e47d5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c77ac9be273e47d5$export$e309780f520d125a,
            pageId: "project-settings-fields",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5bkvv;
    var $dxCvy;
    var $5j7Th;
    var $kxZPA;
    const $d4e28d950e086fee$export$ef66d3f49a9953d8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3kJhU")), {
        moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
    });
    const $d4e28d950e086fee$export$33d85a1b2211b38 = [
        (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
        (0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleResource)
    ];
    const $d4e28d950e086fee$export$b943f48844c671a5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d4e28d950e086fee$export$ef66d3f49a9953d8,
            pageId: "forge-spa-project-settings",
            shouldShowSpinner: true
        });
    var $d4e28d950e086fee$export$2e2bcd8739ae039 = $d4e28d950e086fee$export$b943f48844c671a5;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $9d365377dbe2cbf1$export$36dcfb52d47cb93a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("h5Sqc"))), {
        moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
    });
    var $9d365377dbe2cbf1$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { issueTypeId: issueTypeId } = match.params;
        const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9d365377dbe2cbf1$export$36dcfb52d47cb93a,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("c32Mm")), {
        moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
    });
    var $f62e804ec9c6d7ed$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae,
            pageId: "project-settings-jira-automation",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $6229d9dc67e508de$export$ea7d73c94d9369f4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hM6gT"))), {
        moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
    });
    var $6229d9dc67e508de$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6229d9dc67e508de$export$ea7d73c94d9369f4,
            pageId: "project-settings-email-notifications",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $7tQej;
    const $3a1472a535e1ea00$export$7eee4f97b7a1273 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6Eu7X"))), {
        moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
    });
    const $3a1472a535e1ea00$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
            push: false
        });
    const $3a1472a535e1ea00$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement($3a1472a535e1ea00$var$PeopleAccessRedirectInner, {
                match: match,
                basePath: basePath
            });
    var $3a1472a535e1ea00$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3a1472a535e1ea00$export$7eee4f97b7a1273,
            pageId: "project-settings-people",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    const $a51e57eb3887507b$export$5575497f0592ee94 = 'servicedesk';
    const $a51e57eb3887507b$export$c9b0516439c55d7a = (product)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
            });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $5cc0224f486155a9$export$a7d63246a10aedd = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("6luCE")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
    });
    var $5cc0224f486155a9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5cc0224f486155a9$export$a7d63246a10aedd,
            pageId: "project-settings-proforma-jira-form-builder",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $7c82c5f708d0cd7e$export$38414b624a749cec = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("dju2Q")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
    });
    var $7c82c5f708d0cd7e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7c82c5f708d0cd7e$export$38414b624a749cec,
            pageId: "project-settings-proforma-project-forms",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $8fbb06494113daae$export$e674d93688e620b3 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lFHMB"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-change-management-settings/src/index.tsx"
    });
    var $8fbb06494113daae$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8fbb06494113daae$export$e674d93688e620b3,
            pageId: "project-settings-change-management",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $02Psx;
    var $7tQej;
    const $73d598aaa606ce09$export$c7e6c0ac0abe2336 = (pageUrlFragment)=>({ match: match })=>{
            const { projectKey: projectKey } = match.params;
            const url = `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/channels/${pageUrlFragment}`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: url,
                push: false
            });
        };
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    const $7c240e4106c097e5$export$22c86ddb04b1359a = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/chat`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: url
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $955f7623ed5daf83$export$971347f9ac02f862 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("kXpVf")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-chat-settings/src/index.tsx"
    });
    var $955f7623ed5daf83$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $955f7623ed5daf83$export$971347f9ac02f862,
            pageId: "project-settings-widget-settings",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2f67c1468e19aedd$export$eb662b618d6247be = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("a5r6X"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-classic-portal-settings/src/index.tsx"
    });
    var $2f67c1468e19aedd$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2f67c1468e19aedd$export$eb662b618d6247be,
            pageId: "project-settings-classic-portal-settings",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    const $467404e10c7e501f$export$59eedcca37dbbafd = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-permissions`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: url
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $8d9798e9d24a9632$export$5367e40a24f0bd54 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("41qL8"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-permissions/src/index.tsx"
    });
    var $8d9798e9d24a9632$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8d9798e9d24a9632$export$5367e40a24f0bd54,
            pageId: "project-settings-customer-permissions",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    const $f10a7d047f1802a3$export$86c8da903fb97c4f = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/email`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: url
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $881ebeec1a2867ea$export$66d0c668045080de = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("7ESLO")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-email/src/index.tsx"
    });
    var $881ebeec1a2867ea$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ebd0dfae741c0d7b$export$a24ec33acfeae48d), {
            page: "email"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $881ebeec1a2867ea$export$66d0c668045080de,
            pageId: "project-settings-email",
            shouldShowSpinner: true
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $15bcce9a01d18cfd$export$28482a53859ec466 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("274y5"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-external-links/src/index.tsx"
    });
    var $15bcce9a01d18cfd$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $15bcce9a01d18cfd$export$28482a53859ec466,
            pageId: "project-settings-external-links",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $4b8db06fa1ed7bd1$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
    const $4b8db06fa1ed7bd1$export$1aa47348ef6dbdda = 'project/service-desk/settings';
    const $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("1824v")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-feedback-settings/src/index.tsx"
    });
    var $4b8db06fa1ed7bd1$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47,
            pageId: "project-settings-feedback-settings",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $74652d26314b4bbc$export$7796b6d080b8c187 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lVUtH"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-incident-management-settings/src/index.tsx"
    });
    var $74652d26314b4bbc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $74652d26314b4bbc$export$7796b6d080b8c187,
            pageId: "project-settings-incident-management",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    const $68a880eb92a707c3$export$49625f83fe7ecc69 = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/internal-notifications`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: url
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $1956b65a2446b925$export$9c9d293dc6de29d0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5WlEn"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-internal-notifications/src/index.tsx"
    });
    var $1956b65a2446b925$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1956b65a2446b925$export$9c9d293dc6de29d0,
            pageId: "project-settings-internal-notifications",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $402e11ff5e131d95$export$562be1021beb9882 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("iT1h2"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-itsm-features/src/index.tsx"
    });
    var $402e11ff5e131d95$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $402e11ff5e131d95$export$562be1021beb9882,
            pageId: "project-settings-itsm-features",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $4c45ee4ab52677ce$export$213b8279037c9d98 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5UxQx"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-support/src/index.tsx"
    });
    var $4c45ee4ab52677ce$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4c45ee4ab52677ce$export$213b8279037c9d98,
            pageId: "project-settings-language-support",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $818bcbaaddc8bfd3$export$c029d3f514c7b3e0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9Moyk")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-translations/src/index.tsx"
    });
    var $818bcbaaddc8bfd3$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $818bcbaaddc8bfd3$export$c029d3f514c7b3e0,
            pageId: "project-settings-language-translations",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    const $060e0b1586db8e82$export$735e58642f560ddc = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/notification-email`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: url
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $02Psx;
    var $7tQej;
    const $d3615143cfedd2aa$export$59144dd4441639fa = (pageUrlFragment)=>({ match: match })=>{
            const { projectKey: projectKey } = match.params;
            const url = projectKey !== null && projectKey !== undefined ? `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), projectKey)}/notifications/${pageUrlFragment}` : `/projects/${String(projectKey)}/settings/notifications/${pageUrlFragment}`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: url,
                push: false
            });
        };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $9da321ff59a70829$export$fdbd4b1e5ae0e422 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5vpTt")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-portal-settings/src/index.tsx"
    });
    var $9da321ff59a70829$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9da321ff59a70829$export$fdbd4b1e5ae0e422,
            pageId: "project-settings-portal-settings",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    const $1ae3adbbf5c00734$export$8ba256148f9b998f = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/widget`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: url
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $bf4d9e5ccdf213aa$export$216a049c4d917b0 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jzhnL")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-widget-settings/src/index.tsx"
    });
    var $bf4d9e5ccdf213aa$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bf4d9e5ccdf213aa$export$216a049c4d917b0,
            pageId: "project-settings-widget-settings",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $55da4849dbdf5d52$export$cb608e3696682e76 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fYshJ"))), {
        moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
    });
    var $55da4849dbdf5d52$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $55da4849dbdf5d52$export$cb608e3696682e76,
            pageId: "project-settings-workflow-navigation",
            shouldShowSpinner: false
        });
    const $c40db1734fa3af79$var$ufoNamesMap = {
        'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
        'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
    };
    const $c40db1734fa3af79$var$getUFOName = (name)=>$c40db1734fa3af79$var$ufoNamesMap[name] || name;
    const $c40db1734fa3af79$var$commonRouteEntries = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iMriO")).routeGroupsProjectSettingsServicedeskIssuetypesRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ufoName: $c40db1734fa3af79$var$getUFOName(`${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes`),
                component: (0, $9d365377dbe2cbf1$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $9d365377dbe2cbf1$export$36dcfb52d47cb93a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c4193216794a9ba4$export$5ed718db41f9c966), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $55da4849dbdf5d52$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $9d365377dbe2cbf1$export$36dcfb52d47cb93a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6MVjO")).routeGroupsProjectSettingsServicedeskFieldsRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ufoName: 'project-settings.fields.jsm-tmp',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('project_fields_page_for_tmp_-_mvp', (0, $c77ac9be273e47d5$export$2e2bcd8739ae039), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("e7C7O")).fieldSettingsRelayResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $c77ac9be273e47d5$export$e309780f520d125a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cARMJ")).routeGroupsProjectSettingsServicedeskAppsFieldsRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $3f52008d1cdfa258$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3f52008d1cdfa258$export$246ec9cdadd2a163)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5754bd1d880cbd9d$export$7ae67c73ac5367a8), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $841a04425f045e7e$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $841a04425f045e7e$export$3633e017e520a1c2)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7dxyN")).routeGroupsProjectSettingsServicedeskDetailsRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $3746e6592757d8dd$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3746e6592757d8dd$export$6f16b5efddd5c646)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1upsT")).routeGroupsProjectSettingsServicedeskAccessRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsAccessSkeleton),
                component: (0, $3a1472a535e1ea00$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3a1472a535e1ea00$export$7eee4f97b7a1273)
                ],
                ufoName: 'project-settings.access'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $728b3991bd6c3f5e$export$eb1177fbc6c41b97), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $3a1472a535e1ea00$export$45346ed2aa24e3f3)(`/jira/${(0, $a51e57eb3887507b$export$5575497f0592ee94)}`),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3a1472a535e1ea00$export$7eee4f97b7a1273)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dDinN")).routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $7c82c5f708d0cd7e$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $7c82c5f708d0cd7e$export$38414b624a749cec)
                ],
                perfMetricKey: 'forms-settings'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fb231bf25e7005a7$export$ce59d5cb98345f8e), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $5cc0224f486155a9$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $5cc0224f486155a9$export$a7d63246a10aedd)
                ],
                perfMetricKey: 'form-builder'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7HDop")).projectSettingsServicedeskAutomationRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ufoName: `project-settings-automation-${0, $a51e57eb3887507b$export$5575497f0592ee94}`,
                component: (0, $f62e804ec9c6d7ed$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dD71x")).routeGroupsProjectSettingsServicedeskDataClassificationsRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $953aed1c2ae3d2f5$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56)
                ]
            }))
    ];
    const $c40db1734fa3af79$export$37a8204dc4094049 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5AlVM")).routeGroupsProjectSettingsServicedeskClassicAppsRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ufoName: 'service-management.app-discovery',
                component: (0, $3f52008d1cdfa258$export$cc3414a2d9daf70d)(`/jira/${(0, $a51e57eb3887507b$export$5575497f0592ee94)}`),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                isRedirect: true,
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $d7e52a3e5f45b58f$export$fa3bc297af95f169)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).APP_DISCOVERY,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).APP_DISCOVERY),
                        teamName: 'it-solutions-hermes'
                    }
                }
            })),
        ...$c40db1734fa3af79$var$commonRouteEntries,
        ...(0, $62c3d1c204167743$export$f90c0f16cffd8883),
        ...(0, $26c11c644324b9a1$export$caa50198aadcf21c),
        ...(0, $7e5adb0871ecbbba$export$fa9d0db1668a0662),
        ...(0, $da7bdd95981ae4d9$export$8521f0867b2d52e4),
        ...(0, $6cda2c2384bf3147$export$d6bb339f4d05f5c5),
        ...(0, $8b897edada5ca041$export$cf02bed1953597cb),
        ...(0, $89f595ea28ec651e$export$89ee08578c593726),
        ...(0, $6ffe646ddf6221b0$export$5dfc85c70e03c102),
        (0, $0043ec7f595129fa$export$212f7f79630d5adc),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4dsIk")).routeGroupsProjectSettingsServicedeskItsmFeaturesRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ufoName: 'jsm-features-settings',
                component: (0, $402e11ff5e131d95$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("6sNnq")).featuresResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $402e11ff5e131d95$export$562be1021beb9882)
                ],
                perfMetricKey: 'jsm-features-settings'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("f8kSl")).routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ufoName: 'service-management.internal-notifications',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $68a880eb92a707c3$export$49625f83fe7ecc69), (0, $1956b65a2446b925$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, $1956b65a2446b925$export$9c9d293dc6de29d0),
                    (0, (0, parcelRequire("f8FqB")).LazyInternalNotificationSettingsPage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6pNsO")).routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ufoName: 'service-management.internal-notifications',
                component: (0, $1956b65a2446b925$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, $1956b65a2446b925$export$9c9d293dc6de29d0),
                    (0, (0, parcelRequire("f8FqB")).LazyInternalNotificationSettingsPage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("buwAo")).projectSettingsServicedeskNotificationsNotificationEmailRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $060e0b1586db8e82$export$735e58642f560ddc), (0, $6229d9dc67e508de$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, $6229d9dc67e508de$export$ea7d73c94d9369f4)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9ujoJ")).projectSettingsServicedeskNotificationsEmailRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $6229d9dc67e508de$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, $6229d9dc67e508de$export$ea7d73c94d9369f4)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $332bb1f1674139e3$export$18c6f3890d9fd8b8), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $d3615143cfedd2aa$export$59144dd4441639fa)('customer-notifications'),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6Y0Zp")).routeGroupsProjectSettingsServicedeskLanguageKeyRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ufoName: 'service-management.translations',
                component: (0, $818bcbaaddc8bfd3$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("k7tsS")).languageTranslationsResource),
                    (0, (0, parcelRequire("k7tsS")).outgoingEmailStateModelResource)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).LANGUAGE_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).LANGUAGE_SETTINGS),
                        teamName: 'jsm-banana'
                    }
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $818bcbaaddc8bfd3$export$c029d3f514c7b3e0)
                ],
                perfMetricKey: 'jsm-language-translations'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("d3Aot")).routeGroupsProjectSettingsServicedeskLanguage1Route), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ufoName: 'service-management.languages',
                component: (0, $4c45ee4ab52677ce$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $818bcbaaddc8bfd3$export$c029d3f514c7b3e0)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6QV1R")).routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $467404e10c7e501f$export$59eedcca37dbbafd), (0, $8d9798e9d24a9632$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("10cgn")).customerPermissionsPageDataResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8d9798e9d24a9632$export$5367e40a24f0bd54)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_PERMISSIONS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_PERMISSIONS),
                        teamName: 'jsd-flux-capacitors'
                    }
                },
                perfMetricKey: 'jsm-customer-permissions'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e9ygf")).routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $8d9798e9d24a9632$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("10cgn")).customerPermissionsPageDataResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8d9798e9d24a9632$export$5367e40a24f0bd54)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_PERMISSIONS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_PERMISSIONS),
                        teamName: 'jsd-flux-capacitors'
                    }
                },
                perfMetricKey: 'jsm-customer-permissions'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("h1R4C")).routeGroupsProjectSettingsServicedeskChannelsEmailNextGenRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $f10a7d047f1802a3$export$86c8da903fb97c4f), (0, $881ebeec1a2867ea$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $881ebeec1a2867ea$export$66d0c668045080de)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bHuHZ")).routeGroupsProjectSettingsServicedeskEmailRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ufoName: 'service-management.settings.email-channels',
                component: (0, $881ebeec1a2867ea$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $881ebeec1a2867ea$export$66d0c668045080de)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6oHQj")).routeGroupsProjectSettingsServicedeskPortalSettingsRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $2f67c1468e19aedd$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $2f67c1468e19aedd$export$eb662b618d6247be)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).PORTAL_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).PORTAL_SETTINGS),
                        teamName: 'jsd-shield'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("c7Cuy")).routeGroupsProjectSettingsServicedeskChannelsPortalRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $9da321ff59a70829$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("8CwPO")).portalSettingsContextResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $9da321ff59a70829$export$fdbd4b1e5ae0e422)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hllBd")).routeGroupsProjectSettingsServicedeskExternalLinksRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $15bcce9a01d18cfd$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("6sNnq")).featuresResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $15bcce9a01d18cfd$export$28482a53859ec466)
                ],
                perfMetricKey: 'jsm-external-resources'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fCKoM")).routeGroupsProjectSettingsServicedeskChannelsWidgetRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $1ae3adbbf5c00734$export$8ba256148f9b998f), (0, $bf4d9e5ccdf213aa$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $bf4d9e5ccdf213aa$export$216a049c4d917b0)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gIHTV")).routeGroupsProjectSettingsServicedeskWidgetRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $bf4d9e5ccdf213aa$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $bf4d9e5ccdf213aa$export$216a049c4d917b0)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hXPqO")).routeGroupsProjectSettingsServicedeskChangeManagementRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                ufoName: 'service-management.change-management-settings',
                component: (0, $8fbb06494113daae$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
                    (0, (0, parcelRequire("ejiWA")).changeManagementSettingsProjectConfigurationResource),
                    (0, (0, parcelRequire("gmE3I")).jsmChangeManagementSettingsGitLabGatingResource),
                    (0, (0, parcelRequire("6sNnq")).featuresResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('enable_jsm_repackaging_changes_vtwk9'), (0, (0, parcelRequire("2pT4g")).jsmRepackagingBannerResource))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8fbb06494113daae$export$e674d93688e620b3)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5lhuE")).routeGroupsProjectSettingsServicedeskIncidentManagementRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $74652d26314b4bbc$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $74652d26314b4bbc$export$7796b6d080b8c187)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hj1rS")).routeGroupsProjectSettingsServicedeskChannelsChatRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, $7c240e4106c097e5$export$22c86ddb04b1359a), (0, $955f7623ed5daf83$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $955f7623ed5daf83$export$971347f9ac02f862)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k3pgS")).routeGroupsProjectSettingsServicedeskChatRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $955f7623ed5daf83$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $955f7623ed5daf83$export$971347f9ac02f862)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $744f8595a3eb8031$export$77d19d35e71558b3), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $73d598aaa606ce09$export$c7e6c0ac0abe2336)('customer-permissions'),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        ...(0, $e00888b39cabebc3$export$fd1a58e6255623a),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kEqE6")).routeGroupsProjectSettingsServicedeskFeedbackRoute), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $4b8db06fa1ed7bd1$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47),
                    (0, (0, parcelRequire("7Txnp")).LazyCsatSettingsPage)
                ],
                perfMetricKey: 'jsm-feedback-settings',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CSAT_CONFIG,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CSAT_CONFIG),
                        teamName: 'jsm-request-intake'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b9987e58af4bd5dd$export$10bafd1256118bb8), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $d4e28d950e086fee$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    ...(0, $d4e28d950e086fee$export$33d85a1b2211b38),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $d4e28d950e086fee$export$ef66d3f49a9953d8)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $4d7c8f7ead571cf5$export$43b5b901d4988763), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
                component: (0, $a51e57eb3887507b$export$c9b0516439c55d7a)((0, $a51e57eb3887507b$export$5575497f0592ee94)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            }))
    ];
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $ffza4;
    var $1xZqw;
    var $65Ltd;
    var $bwLf9;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $koWFd;
    var $9s3j1;
    var $cD3jo;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $jcw0u;
    var $2YP9W;
    var $dxCvy;
    const $347c2a822ae60413$export$899fd1c46031ece8 = (teamName)=>{
        const { data: data, error: resourceError, loading: loading } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        if (resourceError && data == null) {
            const isErrorErrorType = resourceError instanceof Error;
            const error = isErrorErrorType ? resourceError : new Error(`projectContextResource returned error resourceError: ${JSON.stringify(resourceError)}, loading: ${loading}, data: null`);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'useResourceProjectContext',
                    packageName: 'jiraRouterResourcesProjectContext',
                    teamName: teamName ?? 'magma'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                loading: false,
                error: error,
                projectKey: null
            };
        }
        if (loading) return {
            loading: true,
            error: null,
            projectKey: null
        };
        if (data == null) return {
            loading: false,
            error: new Error('projectContextResource returned data=null when loading false'),
            projectKey: null
        };
        return {
            loading: false,
            projectKey: data.projectKey,
            error: null
        };
    };
    var $e7C7O;
    var $35Wvp;
    var $2FXLN;
    var $7GnDe;
    var $5lsNZ;
    var $65Ltd;
    const $1e07e61b794dca8d$export$37e0dbac44df25b9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS),
        path: '/jira/software/c/projects/:projectKey/settings/details',
        exact: true
    };
    var $65Ltd;
    const $a3d30ca18dd07505$export$d4bf23ba6f4199d7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_FEATURES),
        path: '/jira/software/c/projects/:projectKey/settings/features',
        exact: true
    };
    var $65Ltd;
    const $f327483ffca6ed25$export$4e4a4b8762b611 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_OPSGENIE),
        path: '/jira/software/c/projects/:projectKey/settings/opsgenie',
        exact: true
    };
    var $65Ltd;
    const $631b97d030b0c8f3$export$5e2e0a895d6a14bd = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS),
        path: '/jira/software/c/projects/:projectKey/settings/notifications/issue-logs',
        query: [
            'projectId'
        ]
    };
    var $65Ltd;
    const $db0151a276af1837$export$811ace4fee984f0e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS),
        path: '/jira/software/c/projects/:projectKey/settings/forms/form/:templateFormId/edit',
        exact: true
    };
    var $65Ltd;
    const $7b818f933be215b1$export$2313ca001d58ab27 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS),
        path: '/jira/software/c/projects/:projectKey/settings/forms',
        exact: true
    };
    var $65Ltd;
    const $6521dc442268b2f4$export$2954328f6207617a = 'software';
    const $6521dc442268b2f4$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $6521dc442268b2f4$export$9150f34540b80d8c = (product)=>`${$6521dc442268b2f4$export$5132c64eefe46250(product)}/boards/:boardId`;
    const $eb74524e076aae09$export$99b695c2b8299b5a = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE)}-redirect`,
        path: `/jira/${(0, $6521dc442268b2f4$export$2954328f6207617a)}/c/projects/:projectKey/settings`
    };
    var $65Ltd;
    const $8d33965caf47a037$export$7dbc23deac9553d4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_TOOLCHAIN),
        path: '/jira/software/c/projects/:projectKey/settings/toolchain',
        exact: true
    };
    var $65Ltd;
    const $1e459e992a50ef9a$export$a9509017cabb1e30 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG),
        path: '/secure/ConfigureReleaseNote.jspa',
        query: [
            'projectId',
            'version'
        ]
    };
    var $65Ltd;
    const $6ea4b44e61fd0227$export$6ef734887b6da0c8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE),
        path: '/jira/secure/ReleaseNote.jspa',
        query: [
            'projectId',
            'version'
        ]
    };
    var $65Ltd;
    const $22a22358317ba4be$export$ae89a2a3aaf095ef = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        path: '/jira/software/c/projects/:projectKey/settings/automate'
    };
    var $65Ltd;
    const $c8db0ba1a5916a92$export$8559c4a0b692890e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS_NEXTGEN),
        path: '/jira/software/projects/:projectKey/settings/apps/:appId/:envId/:route?'
    };
    var $65Ltd;
    const $dbb37015acdc19c0$export$f74a0b1be9d5b9f6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS),
        path: '/jira/software/c/projects/:projectKey/settings/apps/:appId/:envId/:route?'
    };
    var $65Ltd;
    const $6ef9ba56e8ee2329$export$c7039de5a4b78802 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_OPSGENIE),
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/opsgenie`,
        exact: true
    };
    var $65Ltd;
    const $fc9d7be9739092f6$export$4d430aeb28b702f8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/automate`
    };
    var $65Ltd;
    const $fd58dce0fef4a2da$export$d3f185a361401db7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD),
        path: `${(0, $6521dc442268b2f4$export$9150f34540b80d8c)((0, $6521dc442268b2f4$export$2954328f6207617a))}/card`,
        exact: true
    };
    var $65Ltd;
    const $e2028f4601d0a4d1$export$88e68eb447e3db49 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM),
        path: `${(0, $6521dc442268b2f4$export$9150f34540b80d8c)((0, $6521dc442268b2f4$export$2954328f6207617a))}/columns`,
        exact: true
    };
    var $65Ltd;
    const $0d2b719554e610ba$export$9bc9b345958a301c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS),
        path: `${(0, $6521dc442268b2f4$export$9150f34540b80d8c)((0, $6521dc442268b2f4$export$2954328f6207617a))}/custom-filters`,
        exact: true
    };
    var $65Ltd;
    const $31cf97a1a4a84207$export$989ca67485551616 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT),
        path: `${(0, $6521dc442268b2f4$export$9150f34540b80d8c)((0, $6521dc442268b2f4$export$2954328f6207617a))}`,
        exact: true
    };
    var $65Ltd;
    const $a1437557f2047801$export$17ccdaa366ec26b8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP),
        path: `${(0, $6521dc442268b2f4$export$9150f34540b80d8c)((0, $6521dc442268b2f4$export$2954328f6207617a))}/roadmap`,
        exact: true
    };
    var $65Ltd;
    const $cc4b8dfb5f37c2a0$export$e116d6b2a5f71426 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE),
        path: `${(0, $6521dc442268b2f4$export$9150f34540b80d8c)((0, $6521dc442268b2f4$export$2954328f6207617a))}/timeline`,
        exact: true
    };
    var $65Ltd;
    const $8a12316e0552f90c$export$b2e044c3dffeca69 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL),
        path: '/jira/software/projects/:projectKey/settings/notifications/notification-email',
        exact: true
    };
    var $65Ltd;
    const $427d02b02ceb584b$export$d4ed083331cb6e00 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL),
        path: '/jira/software/c/projects/:projectKey/settings/notifications/notification-email',
        exact: true
    };
    var $65Ltd;
    const $2685d8d8e87c6306$export$ff4977f79c273b29 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS),
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/notifications/issue-logs`,
        exact: true
    };
    var $65Ltd;
    const $93d386ac6f219e91$export$c1d1892d6c07135a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS),
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/notifications`,
        exact: true
    };
    var $65Ltd;
    const $f16500562a276728$export$e3e3877ec9c5e840 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_TOOLCHAIN),
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/toolchain`,
        exact: true
    };
    var $65Ltd;
    const $ac12be90f354fbe8$export$d782b5257932a66d = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-access-redirect`,
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/people`,
        exact: true
    };
    var $65Ltd;
    const $428cff17ab5f71da$export$9d5b42fcb82012dd = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-access`,
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/access`,
        exact: true
    };
    var $65Ltd;
    const $efb05f01898ef052$export$d9dea7be10efa583 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-apps`,
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/apps/:appId?`,
        exact: true
    };
    var $65Ltd;
    const $45ecf727073b0a90$export$8ddc76f4b4e66b2b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_APPS_FIELDS),
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/apps/app-fields`,
        exact: true
    };
    var $65Ltd;
    const $73f076791d862d0d$export$46e979217c179afd = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-automation`,
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/automation`,
        exact: true
    };
    var $65Ltd;
    const $064bcea443c9fe1a$export$61d54e538063bb07 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-data-classifications`,
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/data-classifications`,
        exact: true
    };
    var $65Ltd;
    const $b39f8e12853ad778$export$18624b8612cb673d = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-details`,
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/details`,
        exact: true
    };
    var $65Ltd;
    const $63d7cdc3e00335a3$export$ad2c16468a73b68 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FIELDS),
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/fields`,
        exact: true
    };
    var $65Ltd;
    const $2251bbe7be4b8bf7$export$dde867834e4a9f47 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-issuetypes`,
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/issuetypes/:issueTypeId?`,
        exact: true
    };
    var $65Ltd;
    const $fc41102b4af07f23$export$955e8eef6e3bccfb = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-issuetypes-workflow`,
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/issuetypes/:issueTypeId/:initialSection(workflow)`,
        exact: true
    };
    var $65Ltd;
    const $8357daefab0bd79e$export$a598c3fe8cbf0c6c = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-next-gen-features`,
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/features`,
        exact: true
    };
    var $65Ltd;
    const $d0587498538d2212$export$394d8f4806a90d7 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-proforma-jira-form-builder`,
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/forms/form/:templateFormId/edit`,
        exact: true
    };
    var $65Ltd;
    const $2a7c0b9f6c35516b$export$396cdbbd6f2abcea = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-proforma-project-forms`,
        path: `${(0, $6521dc442268b2f4$export$5132c64eefe46250)((0, $6521dc442268b2f4$export$2954328f6207617a))}/forms`,
        exact: true
    };
    var $65Ltd;
    const $6611b1127d8eb1f6$export$7ce9914683cb1572 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-redirect`,
        path: `/jira/${(0, $6521dc442268b2f4$export$2954328f6207617a)}/projects/:projectKey/settings`
    };
    var $65Ltd;
    const $45e41e5c15f76352$export$a0223091962262d4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_RELEASE_NOTES),
        path: '/secure/ReleaseNote.jspa',
        query: [
            'projectId'
        ]
    };
    var $jaAyo;
    var $kfztd;
    var $e7bC3;
    var $7tQej;
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $dAfqg;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $7tQej;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ab1da42a9104ecee$export$fa3bc297af95f169 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("aLHab"))), {
        moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
    });
    var $ab1da42a9104ecee$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ab1da42a9104ecee$export$fa3bc297af95f169,
            pageId: "project-settings-app-discovery-settings",
            shouldShowSpinner: false
        });
    const $c49a5a5e07aed0ac$export$246ec9cdadd2a163 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6JK34"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
    });
    const $c49a5a5e07aed0ac$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
        return shouldRedirect ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
            push: false
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ab1da42a9104ecee$export$2e2bcd8739ae039), null);
    };
    const $c49a5a5e07aed0ac$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement($c49a5a5e07aed0ac$var$ConnectAppsRedirectInner, {
                match: match,
                basePath: basePath
            });
    var $c49a5a5e07aed0ac$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c49a5a5e07aed0ac$export$246ec9cdadd2a163,
            pageId: "project-settings-connect-app-controls",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0d3ebe2f9030fc49$export$3633e017e520a1c2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("RJn1w"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
    });
    var $0d3ebe2f9030fc49$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0d3ebe2f9030fc49$export$3633e017e520a1c2,
            pageId: "project-settings-connect-apps",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $11c79a07a4ec83b8$export$9d468faf674a5201 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("fJiVO")), {
        moduleId: "./src/packages/spa-apps/project-settings/connections/src/index.tsx"
    });
    var $11c79a07a4ec83b8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $11c79a07a4ec83b8$export$9d468faf674a5201,
            pageId: "devops-connections-settings",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f25068ef108ee62d$export$de293ea44d0410ca = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bv9IQ"))), {
        moduleId: "./src/packages/spa-apps/project-settings/csm/src/index.tsx"
    });
    var $f25068ef108ee62d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f25068ef108ee62d$export$de293ea44d0410ca,
            pageId: "project-settings-csm",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $26928850e3bfb37f$export$7e21d36a9d4548e6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("i46eT")), {
        moduleId: "./src/packages/spa-apps/project-settings/custom-filters/src/index.tsx"
    });
    var $26928850e3bfb37f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $26928850e3bfb37f$export$7e21d36a9d4548e6,
            pageId: "project-settings-custom-filters",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $81cf21747f4c944d$export$b8abcf8aa8f4df56 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dYp24"))), {
        moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
    });
    var $81cf21747f4c944d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $81cf21747f4c944d$export$b8abcf8aa8f4df56,
            pageId: "project-settings-data-classifications",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $5dcf6caa5da05571$export$6f16b5efddd5c646 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fU2jM"))), {
        moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
    });
    var $5dcf6caa5da05571$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5dcf6caa5da05571$export$6f16b5efddd5c646,
            pageId: "project-settings-details",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $628b742891e4f718$export$e309780f520d125a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2RcTH"))), {
        moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
    });
    var $628b742891e4f718$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $628b742891e4f718$export$e309780f520d125a,
            pageId: "project-settings-fields",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5bkvv;
    var $dxCvy;
    var $5j7Th;
    var $kxZPA;
    const $fa6a5556191902b5$export$ef66d3f49a9953d8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3kJhU")), {
        moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
    });
    const $fa6a5556191902b5$export$33d85a1b2211b38 = [
        (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
        (0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleResource)
    ];
    const $fa6a5556191902b5$export$b943f48844c671a5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fa6a5556191902b5$export$ef66d3f49a9953d8,
            pageId: "forge-spa-project-settings",
            shouldShowSpinner: true
        });
    var $fa6a5556191902b5$export$2e2bcd8739ae039 = $fa6a5556191902b5$export$b943f48844c671a5;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $8f1b2ea450c47b3b$export$36dcfb52d47cb93a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("h5Sqc"))), {
        moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
    });
    var $8f1b2ea450c47b3b$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { issueTypeId: issueTypeId } = match.params;
        const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8f1b2ea450c47b3b$export$36dcfb52d47cb93a,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $4700cd79d99e02ea$export$dea5ad7e8eac12ae = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("c32Mm")), {
        moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
    });
    var $4700cd79d99e02ea$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4700cd79d99e02ea$export$dea5ad7e8eac12ae,
            pageId: "project-settings-jira-automation",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $dab3ab2feb1de470$export$ca5dba69148b337 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jM7hL")), {
        moduleId: "./src/packages/spa-apps/project-settings/link-opsgenie/src/index.tsx"
    });
    var $dab3ab2feb1de470$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $dab3ab2feb1de470$export$ca5dba69148b337,
            pageId: "link-opsgenie-page",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $4e545f86ddd60f53$export$da4d608b99858bfc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5iypu"))), {
        moduleId: "./src/packages/spa-apps/project-settings/next-gen-features/src/index.tsx"
    });
    var $4e545f86ddd60f53$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4e545f86ddd60f53$export$da4d608b99858bfc,
            pageId: "project-settings-next-gen-features",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $6e8f6f53c599ad60$export$ea7d73c94d9369f4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hM6gT"))), {
        moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
    });
    var $6e8f6f53c599ad60$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6e8f6f53c599ad60$export$ea7d73c94d9369f4,
            pageId: "project-settings-email-notifications",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $7tQej;
    const $3671536b80f548b9$export$7eee4f97b7a1273 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6Eu7X"))), {
        moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
    });
    const $3671536b80f548b9$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
            push: false
        });
    const $3671536b80f548b9$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement($3671536b80f548b9$var$PeopleAccessRedirectInner, {
                match: match,
                basePath: basePath
            });
    var $3671536b80f548b9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3671536b80f548b9$export$7eee4f97b7a1273,
            pageId: "project-settings-people",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $1J3t1;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $7tQej;
    const $3caec8e095a44ec5$export$2954328f6207617a = 'software';
    const $3caec8e095a44ec5$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $3caec8e095a44ec5$export$586756e5c0542a50 = ()=>{
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    const $3caec8e095a44ec5$export$fb15a6ba8980fdac = ({ match: match })=>{
        const { data: data } = (0, (0, parcelRequire("1J3t1")).useJiraSoftwareProjectNavigation)();
        const { projectKey: projectKey } = match.params;
        if ((0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) {
            if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
            });
            if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
            });
            if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
        });
    };
    const $3caec8e095a44ec5$export$f9befa0a4925b36d = ({ match: match })=>{
        const { data: data } = (0, (0, parcelRequire("1J3t1")).useJiraSoftwareProjectNavigation)();
        const { projectKey: projectKey } = match.params;
        if ((0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) {
            if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
            });
            if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
            });
            if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
        });
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $4bec2fc264f66dc5$export$40ff283c032abbc4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("fxHpr")), {
        moduleId: "./src/packages/spa-apps/project-settings/board-settings/card/src/index.tsx"
    });
    var $4bec2fc264f66dc5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4bec2fc264f66dc5$export$40ff283c032abbc4,
            pageId: "board-settings-card",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $4R6GH;
    var $j8DrX;
    var $5j7Th;
    var $kxZPA;
    const $50cd29d3245ccefc$export$8eca5454e72ee961 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("hR0vX")), {
        moduleId: "./src/packages/spa-apps/project-settings/board-settings/roadmap/src/index.tsx"
    });
    const $50cd29d3245ccefc$var$AsyncProjectSettingsRoadmap = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "project-settings.roadmap",
            teamName: "chronos",
            attributes: {
                isSynthetic: (0, (0, parcelRequire("4R6GH")).fg)('is_synthetic_tenant') || (0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $50cd29d3245ccefc$export$8eca5454e72ee961,
            pageId: "board-settings-roadmap",
            shouldShowSpinner: false
        }));
    var $50cd29d3245ccefc$export$2e2bcd8739ae039 = $50cd29d3245ccefc$var$AsyncProjectSettingsRoadmap;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $c3a9ed7dcac6be32$export$a7d63246a10aedd = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("6luCE")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
    });
    var $c3a9ed7dcac6be32$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c3a9ed7dcac6be32$export$a7d63246a10aedd,
            pageId: "project-settings-proforma-jira-form-builder",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $97406b66ba2de080$export$38414b624a749cec = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("dju2Q")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
    });
    var $97406b66ba2de080$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $97406b66ba2de080$export$38414b624a749cec,
            pageId: "project-settings-proforma-project-forms",
            shouldShowSpinner: true
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $lmyls;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $e5cbde6b3cad4f8b$export$cd8964bea0e3c2 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $6adcc3494d7c3774$export$97bbdefcbe0571ac),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $e5cbde6b3cad4f8b$export$6960a46ebd209756 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dGsmU"))), {
        moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
    });
    const $e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e5cbde6b3cad4f8b$export$6960a46ebd209756,
            pageId: "project-settings-software-notifications-issue-logs",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $576f902bdb908a77$export$69a64a29d67ca160 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lvyS5"))), {
        moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
    });
    var $576f902bdb908a77$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $576f902bdb908a77$export$69a64a29d67ca160,
            pageId: "project-settings-software-notifications",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $48f5bfd32d483aba$export$cb608e3696682e76 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fYshJ"))), {
        moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
    });
    var $48f5bfd32d483aba$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $48f5bfd32d483aba$export$cb608e3696682e76,
            pageId: "project-settings-workflow-navigation",
            shouldShowSpinner: false
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $70eea33e6c09b198$export$79fe16f960f3d89f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6eBop"))), {
        moduleId: "./src/packages/spa-apps/project-settings/classic-features/src/index.tsx"
    });
    const $70eea33e6c09b198$export$8e6f565615e921dd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $70eea33e6c09b198$export$79fe16f960f3d89f,
            pageId: "classic-features",
            shouldShowSpinner: true
        });
    const $0acb8447d437de85$var$BoardSettingsRedirectToCSM = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/columns`,
            push: false
        });
    const $0acb8447d437de85$var$RoadmapSettingsRedirectToTimelineSettings = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/timeline`,
            push: false
        });
    const $0acb8447d437de85$var$SpaReleaseNoteRedirectToVersionDetails = ({ query: query })=>{
        const { version: versionId } = query;
        const { loading: loading, error: error, projectKey: projectKey } = (0, $347c2a822ae60413$export$899fd1c46031ece8)();
        if (loading === false && error) return null;
        if (loading) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: {
                pathname: `/projects/${projectKey}/versions/${versionId}/tab/release-report-all-issues`,
                hash: '',
                search: (0, ($parcel$interopDefault($ebyGx))).stringify({
                    isReleaseNoteModalOpen: true
                })
            }
        });
    };
    const $0acb8447d437de85$var$LegacyFrontendReleaseNoteRedirect = ({ query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: {
                pathname: '/secure/ReleaseNote.jspa',
                hash: '',
                search: (0, ($parcel$interopDefault($ebyGx))).stringify({
                    ...query,
                    isRedirectedFromLegacy: true
                })
            }
        });
    const $0acb8447d437de85$var$ufoNamesMap = {
        'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
        'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
    };
    const $0acb8447d437de85$var$getUFOName = (name)=>$0acb8447d437de85$var$ufoNamesMap[name] || name;
    const $0acb8447d437de85$var$commonRouteEntries = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2251bbe7be4b8bf7$export$dde867834e4a9f47), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                ufoName: $0acb8447d437de85$var$getUFOName(`${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-issuetypes`),
                component: (0, $8f1b2ea450c47b3b$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8f1b2ea450c47b3b$export$36dcfb52d47cb93a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fc41102b4af07f23$export$955e8eef6e3bccfb), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $48f5bfd32d483aba$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $8f1b2ea450c47b3b$export$36dcfb52d47cb93a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $45ecf727073b0a90$export$8ddc76f4b4e66b2b), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $c49a5a5e07aed0ac$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $c49a5a5e07aed0ac$export$246ec9cdadd2a163)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $efb05f01898ef052$export$d9dea7be10efa583), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $0d3ebe2f9030fc49$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $0d3ebe2f9030fc49$export$3633e017e520a1c2)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b39f8e12853ad778$export$18624b8612cb673d), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $5dcf6caa5da05571$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $5dcf6caa5da05571$export$6f16b5efddd5c646)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $63d7cdc3e00335a3$export$ad2c16468a73b68), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                ufoName: 'project-settings.fields.jsw-tmp',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('project_fields_page_for_tmp_-_mvp', (0, $628b742891e4f718$export$2e2bcd8739ae039), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)(),
                    (0, (0, parcelRequire("e7C7O")).fieldSettingsRelayResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $628b742891e4f718$export$e309780f520d125a)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $428cff17ab5f71da$export$9d5b42fcb82012dd), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsAccessSkeleton),
                component: (0, $3671536b80f548b9$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3671536b80f548b9$export$7eee4f97b7a1273)
                ],
                ufoName: 'project-settings.access'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ac12be90f354fbe8$export$d782b5257932a66d), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $3671536b80f548b9$export$45346ed2aa24e3f3)(`/jira/${(0, $3caec8e095a44ec5$export$2954328f6207617a)}`),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $3671536b80f548b9$export$7eee4f97b7a1273)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2a7c0b9f6c35516b$export$396cdbbd6f2abcea), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $97406b66ba2de080$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $97406b66ba2de080$export$38414b624a749cec)
                ],
                perfMetricKey: 'forms-settings'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d0587498538d2212$export$394d8f4806a90d7), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $c3a9ed7dcac6be32$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $c3a9ed7dcac6be32$export$a7d63246a10aedd)
                ],
                perfMetricKey: 'form-builder'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fc9d7be9739092f6$export$4d430aeb28b702f8), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                ufoName: `project-settings-automation-${0, $3caec8e095a44ec5$export$2954328f6207617a}`,
                component: (0, $4700cd79d99e02ea$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $4700cd79d99e02ea$export$dea5ad7e8eac12ae)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $064bcea443c9fe1a$export$61d54e538063bb07), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $81cf21747f4c944d$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $81cf21747f4c944d$export$b8abcf8aa8f4df56)
                ]
            }))
    ];
    const $0acb8447d437de85$export$792d387b9973c378 = [
        ...$0acb8447d437de85$var$commonRouteEntries,
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1e07e61b794dca8d$export$37e0dbac44df25b9), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $5dcf6caa5da05571$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $5dcf6caa5da05571$export$6f16b5efddd5c646)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8357daefab0bd79e$export$a598c3fe8cbf0c6c), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                ufoName: 'project-settings.next-gen-features',
                component: (0, $4e545f86ddd60f53$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsFeaturesSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $4e545f86ddd60f53$export$da4d608b99858bfc)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $93d386ac6f219e91$export$c1d1892d6c07135a), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                ufoName: 'project-settings.software.notifications',
                component: (0, $576f902bdb908a77$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $576f902bdb908a77$export$69a64a29d67ca160)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $2685d8d8e87c6306$export$ff4977f79c273b29), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                ufoName: 'project-settings.software.notifications.issue-logs',
                component: (0, $e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $e5cbde6b3cad4f8b$export$6960a46ebd209756)
                ],
                entryPoint () {
                    return 0, $e5cbde6b3cad4f8b$export$cd8964bea0e3c2;
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6ef9ba56e8ee2329$export$c7039de5a4b78802), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, (0, parcelRequire("bwLf9")).default)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $dab3ab2feb1de470$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $dab3ab2feb1de470$export$ca5dba69148b337)
                ],
                ufoName: 'project-settings.link-opsgenie'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f327483ffca6ed25$export$4e4a4b8762b611), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, (0, parcelRequire("bwLf9")).default)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $dab3ab2feb1de470$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $dab3ab2feb1de470$export$ca5dba69148b337)
                ],
                ufoName: 'project-settings.link-opsgenie'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f16500562a276728$export$e3e3877ec9c5e840), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, (0, parcelRequire("bwLf9")).default)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $11c79a07a4ec83b8$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)(),
                    (0, (0, parcelRequire("35Wvp")).projectSettingsToolchainResource)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $11c79a07a4ec83b8$export$9d468faf674a5201)
                ],
                ufoName: 'project-settings.devops-connections'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8d33965caf47a037$export$7dbc23deac9553d4), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, (0, parcelRequire("bwLf9")).default)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, $11c79a07a4ec83b8$export$2e2bcd8739ae039)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("35Wvp")).projectSettingsToolchainResource)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $11c79a07a4ec83b8$export$9d468faf674a5201)
                ],
                ufoName: 'project-settings.devops-connections'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a3d30ca18dd07505$export$d4bf23ba6f4199d7), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                ufoName: 'classic-features-page',
                component: (0, $70eea33e6c09b198$export$8e6f565615e921dd),
                skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsFeaturesSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $70eea33e6c09b198$export$79fe16f960f3d89f)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $631b97d030b0c8f3$export$5e2e0a895d6a14bd), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                ufoName: 'project-settings.classic-issue-logs-page',
                component: (0, $e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $e5cbde6b3cad4f8b$export$6960a46ebd209756)
                ],
                entryPoint () {
                    return 0, $e5cbde6b3cad4f8b$export$cd8964bea0e3c2;
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $427d02b02ceb584b$export$d4ed083331cb6e00), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $6e8f6f53c599ad60$export$2e2bcd8739ae039),
                skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsFeaturesSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $70eea33e6c09b198$export$79fe16f960f3d89f),
                    (0, $6e8f6f53c599ad60$export$ea7d73c94d9369f4)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8a12316e0552f90c$export$b2e044c3dffeca69), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $3caec8e095a44ec5$export$fb15a6ba8980fdac),
                skeleton: (0, (0, parcelRequire("jaAyo")).ProjectSettingsFeaturesSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6ea4b44e61fd0227$export$6ef734887b6da0c8), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                resources: [
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                component: $0acb8447d437de85$var$LegacyFrontendReleaseNoteRedirect,
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1e459e992a50ef9a$export$a9509017cabb1e30), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                resources: [
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                component: $0acb8447d437de85$var$LegacyFrontendReleaseNoteRedirect,
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $45e41e5c15f76352$export$a0223091962262d4), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                component: $0acb8447d437de85$var$SpaReleaseNoteRedirectToVersionDetails,
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $73f076791d862d0d$export$46e979217c179afd), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $4700cd79d99e02ea$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $4700cd79d99e02ea$export$dea5ad7e8eac12ae)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7b818f933be215b1$export$2313ca001d58ab27), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $97406b66ba2de080$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $97406b66ba2de080$export$38414b624a749cec)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $db0151a276af1837$export$811ace4fee984f0e), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $c3a9ed7dcac6be32$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $c3a9ed7dcac6be32$export$a7d63246a10aedd)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $31cf97a1a4a84207$export$989ca67485551616), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: $0acb8447d437de85$var$BoardSettingsRedirectToCSM,
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                isRedirect: true,
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e2028f4601d0a4d1$export$88e68eb447e3db49), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                ufoName: 'software.next-gen.boards.column-status-mapping.page.load',
                component: (0, $f25068ef108ee62d$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $f25068ef108ee62d$export$de293ea44d0410ca)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0d2b719554e610ba$export$9bc9b345958a301c), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                ufoName: 'project-settings.custom-filters',
                component: (0, $26928850e3bfb37f$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)(),
                    (0, (0, parcelRequire("cD3jo")).customFiltersResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $26928850e3bfb37f$export$7e21d36a9d4548e6)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fd58dce0fef4a2da$export$d3f185a361401db7), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                ufoName: 'board-settings-apps.card-cover-settings-page.page.load',
                component: (0, $4bec2fc264f66dc5$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)(),
                    (0, (0, parcelRequire("1xZqw")).cardCoverImageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $4bec2fc264f66dc5$export$40ff283c032abbc4)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $a1437557f2047801$export$17ccdaa366ec26b8), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: $0acb8447d437de85$var$RoadmapSettingsRedirectToTimelineSettings,
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)(),
                    (0, (0, parcelRequire("2FXLN")).roadmapSettingsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $50cd29d3245ccefc$export$8eca5454e72ee961)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cc4b8dfb5f37c2a0$export$e116d6b2a5f71426), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                ufoName: 'board-settings-apps.roadmap-settings-page.page.load',
                component: (0, $50cd29d3245ccefc$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)(),
                    (0, (0, parcelRequire("2FXLN")).roadmapSettingsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $50cd29d3245ccefc$export$8eca5454e72ee961)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $22a22358317ba4be$export$ae89a2a3aaf095ef), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                ufoName: 'project-settings-automation-c',
                component: (0, $4700cd79d99e02ea$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $4700cd79d99e02ea$export$dea5ad7e8eac12ae)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $dbb37015acdc19c0$export$f74a0b1be9d5b9f6), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $fa6a5556191902b5$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    ...(0, $fa6a5556191902b5$export$33d85a1b2211b38)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $fa6a5556191902b5$export$ef66d3f49a9953d8)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c8db0ba1a5916a92$export$8559c4a0b692890e), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $fa6a5556191902b5$export$2e2bcd8739ae039),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)(),
                    ...(0, $fa6a5556191902b5$export$33d85a1b2211b38)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, $fa6a5556191902b5$export$ef66d3f49a9953d8)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6611b1127d8eb1f6$export$7ce9914683cb1572), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $3caec8e095a44ec5$export$fb15a6ba8980fdac),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $eb74524e076aae09$export$99b695c2b8299b5a), ()=>({
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
                component: (0, $3caec8e095a44ec5$export$f9befa0a4925b36d),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, $3caec8e095a44ec5$export$586756e5c0542a50)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            }))
    ];
    const $512b517449862f9e$export$fd0ef3739cde76c1 = [
        ...(0, $0acb8447d437de85$export$792d387b9973c378),
        ...(0, $c40db1734fa3af79$export$37a8204dc4094049),
        ...(0, $f037ab3fb0896e94$export$4bad3905623f839b)
    ];
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $03d8cdc4dcb18bd2$export$148fcbe26061b2c9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT),
        path: '/jira/servicedesk/projects/:projectKey',
        query: (0, $e64562bb8c3fa371$export$9bb839aee83bf4d8),
        exact: true
    };
    var $6Z2mh;
    const $ec6bba63502dd6b2$export$72138a83eeba68eb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $03d8cdc4dcb18bd2$export$148fcbe26061b2c9), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $c9a4402f23043c3c$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...(0, $7a1fe7edd9b898b4$export$4c06110e7d14ab3c)(),
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $c9a4402f23043c3c$export$3dadc93ff144628f)
            ],
            ufoName: 'jira-connect'
        }));
    var $ffza4;
    var $65Ltd;
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $7a169ab056601f38$var$LazyViewsNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("kt1Sq")).then(({ ViewsBaseNav: ViewsBaseNav })=>ViewsBaseNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/views/src/ui/index.tsx"
    });
    const $7a169ab056601f38$export$b43adc74b6a33bde = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-jsm-views-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7a169ab056601f38$var$LazyViewsNav, null));
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $f5kpo;
    var $bHhiy;
    var $dxCvy;
    var $fpjJX;
    var $f7Y15;
    var $gNStA;
    var $kk6FJ;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $65Ltd;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    var $7tQej;
    const $2b6a3552fb449509$export$bb5ed4e7838cf30c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5xmYT"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/board/src/index.tsx"
    });
    const $2b6a3552fb449509$export$6828c4b2d0ff0d5d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("743Kh"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/legacy-board-settings/src/index.tsx"
    });
    const $2b6a3552fb449509$export$f058c0d1561d67f3 = (props)=>{
        const { route: route, query: query } = props;
        if (route.name !== (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS)) return null;
        const allowedConfigurations = [
            'columns',
            'filter',
            'quickFilters',
            'swimlanes',
            'cardColors',
            'cardLayout',
            'dateFields'
        ];
        if (query.config && !allowedConfigurations.includes(query.config)) {
            const { config: config, ...restQuery } = query;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: {
                    pathname: props.location.pathname,
                    hash: '',
                    search: (0, ($parcel$interopDefault($ebyGx))).stringify({
                        ...restQuery,
                        config: 'columns'
                    })
                }
            });
        }
        return query.config ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2b6a3552fb449509$export$6828c4b2d0ff0d5d,
            pageId: "spa-apps/servicedesk/boards/legacy-board-settings",
            shouldShowSpinner: true
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2b6a3552fb449509$export$bb5ed4e7838cf30c,
            pageId: "spa-apps/servicedesk/boards/board",
            shouldShowSpinner: true
        });
    };
    const $d84f7f5f7c3d3051$export$848a32cf0fcf8a61 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kk6FJ")).jsmBoardRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $2b6a3552fb449509$export$f058c0d1561d67f3),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            skeleton: (0, $845fd4f51bb92262$export$631611c5fdf027d5),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2b6a3552fb449509$export$bb5ed4e7838cf30c),
                (0, $2b6a3552fb449509$export$6828c4b2d0ff0d5d)
            ],
            perfMetricKey: 'servicedesk-boards-load',
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, $7a169ab056601f38$export$b43adc74b6a33bde),
                horizontalFeatureFlag: 'jsm_views_of_work_phase_1'
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!false, (0, (0, parcelRequire("f7Y15")).uifBoardResource)),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ]
        }));
    var $65Ltd;
    var $4R6GH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $jYeNO;
    var $f7Y15;
    var $gNStA;
    var $65Ltd;
    const $72d318e197b1c24c$export$28a386a00670c893 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR),
        path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/calendar',
        exact: true
    };
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $7172661a469aabc5$exports = {};
    $7172661a469aabc5$exports = new URL("classic-calendar-skeleton.tpl.3dcfde16.svg", import.meta.url).toString();
    const $69a8eba95a06a473$export$49d3670908a8d8fe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($7172661a469aabc5$exports)))
        });
    var $lmyls;
    var $4R6GH;
    var $eufEc;
    var $fEDBv;
    const $d491739a1b7483c1$var$ISSUE_SEARCH_INPUT_STORAGE_KEY = 'calendar-issue-search-input';
    const $d491739a1b7483c1$var$VIEW_SETTINGS_STORAGE_KEY = 'calendar-view-settings';
    const $d491739a1b7483c1$var$DEFAULT_DAY_STARTS_AT = '09:00 AM';
    function $d491739a1b7483c1$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
        return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
    }
    function $d491739a1b7483c1$var$toMidnightUTCString(date) {
        const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        return new Date(utcMilliseconds).toISOString();
    }
    function $d491739a1b7483c1$var$toDate(date) {
        if (!date) return new Date();
        try {
            const _date = new Date(date);
            return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
        } catch (e) {
            return new Date();
        }
    }
    function $d491739a1b7483c1$var$createScope({ context: context, tenantContext: tenantContext }, viewId) {
        const { cloudId: cloudId } = tenantContext;
        return {
            type: 'board',
            boardId: $d491739a1b7483c1$var$toBoardAri({
                siteId: cloudId,
                boardId: String(context.match.params.boardId)
            }),
            projectKeys: [
                String(context.match.params.projectKey)
            ],
            viewId: viewId
        };
    }
    function $d491739a1b7483c1$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
        const { cloudId: cloudId } = tenantContext;
        return {
            ids: [
                scope.boardId
            ],
            projectKeys: {
                cloudId: cloudId,
                keys: scope.projectKeys
            }
        };
    }
    function $d491739a1b7483c1$var$toViewMode(mode) {
        switch(mode){
            case 'week':
                return 'WEEK';
            case 'day':
                return 'DAY';
            default:
                return 'MONTH';
        }
    }
    function $d491739a1b7483c1$var$toWeekStart(weekStart) {
        switch(weekStart){
            case 'monday':
                return 'MONDAY';
            case 'saturday':
                return 'SATURDAY';
            default:
                return 'SUNDAY';
        }
    }
    function $d491739a1b7483c1$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
        return {
            date: $d491739a1b7483c1$var$toMidnightUTCString(selectedDate),
            mode: $d491739a1b7483c1$var$toViewMode(viewRange),
            weekStart: $d491739a1b7483c1$var$toWeekStart(weekStartsOn),
            ...(0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination') ? {
                startDateField: startDateField,
                endDateField: endDateField
            } : {},
            viewId: viewId
        };
    }
    function $d491739a1b7483c1$var$buildStorageKey({ cloudId: cloudId, activationId: activationId, boardId: boardId, featureKey: featureKey }) {
        const viewId = $d491739a1b7483c1$var$buildViewId({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId
        });
        const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
        return `${LOCALSTORAGE_KEY_PREFIX}/view/${viewId}/${featureKey}`;
    }
    function $d491739a1b7483c1$var$getStorageValue(storageKey) {
        if (typeof window !== 'undefined') return localStorage?.getItem(storageKey) || '';
        return '';
    }
    function $d491739a1b7483c1$var$buildIssuesSearchInput(storageKey) {
        return {
            additionalFilterQuery: $d491739a1b7483c1$var$getStorageValue(storageKey) || ''
        };
    }
    function $d491739a1b7483c1$var$buildUnscheduledIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $d491739a1b7483c1$var$buildVersionsSearchInput() {
        return {
            versionStatuses: [
                'RELEASED',
                'UNRELEASED'
            ]
        };
    }
    function $d491739a1b7483c1$var$buildSprintsSearchInput() {
        return {
            sprintStates: [
                'ACTIVE',
                'FUTURE',
                'CLOSED'
            ]
        };
    }
    function $d491739a1b7483c1$var$buildViewId({ cloudId: cloudId, activationId: activationId, boardId: boardId }) {
        return `ari:cloud:jira:${cloudId}:view/activation/${activationId}/board/${boardId}`;
    }
    const $d491739a1b7483c1$export$19cf4b398f638dc6 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("hoyWd")), {
            moduleId: "7a55ad65"
        }),
        getPreloadProps: (entryPointRouteParams)=>{
            const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
            const { cloudId: cloudId, activationId: activationId } = tenantContext;
            const { date: date } = context.query;
            const selectedDate = $d491739a1b7483c1$var$toDate(date);
            const { boardId: boardId, projectKey: projectKey } = context.match.params;
            if (!boardId || !projectKey) throw new Error('boardId and projectKey must be provided.');
            const viewId = $d491739a1b7483c1$var$buildViewId({
                cloudId: cloudId,
                activationId: activationId,
                boardId: boardId
            });
            const scope = $d491739a1b7483c1$var$createScope(entryPointRouteParams, viewId || '');
            const storageKeyForIssueSearchInput = $d491739a1b7483c1$var$buildStorageKey({
                cloudId: cloudId,
                activationId: activationId,
                boardId: boardId,
                featureKey: $d491739a1b7483c1$var$ISSUE_SEARCH_INPUT_STORAGE_KEY
            });
            const storageKeyForViewSettings = $d491739a1b7483c1$var$buildStorageKey({
                cloudId: cloudId,
                activationId: activationId,
                boardId: boardId,
                featureKey: $d491739a1b7483c1$var$VIEW_SETTINGS_STORAGE_KEY
            });
            const defaultViewRange = 'month';
            const storedConfig = $d491739a1b7483c1$var$getStorageValue(storageKeyForViewSettings);
            const viewSettingsConfig = storedConfig ? JSON.parse(storedConfig) : {
                viewRange: defaultViewRange,
                weekStartsOn: null,
                dayStartsAt: $d491739a1b7483c1$var$DEFAULT_DAY_STARTS_AT,
                showWeekends: false,
                showIssueKey: true,
                showIn24HourClock: false,
                colorBy: 'status'
            };
            const viewRange = (0, (0, parcelRequire("4R6GH")).fg)('jsd_shield_jsm_calendar_weekly_view') ? viewSettingsConfig.viewRange ?? 'month' : 'month';
            const weekStartsOn = viewSettingsConfig.weekStartsOn ?? 'sunday';
            const colorBy = viewSettingsConfig.colorBy ?? 'status';
            const startDateField = 'startdate';
            const endDateField = 'duedate';
            const issueEventFields = {
                startDateField: startDateField,
                endDateField: endDateField
            };
            const issuesSearchInput = $d491739a1b7483c1$var$buildIssuesSearchInput(storageKeyForIssueSearchInput);
            return {
                queries: {
                    calendarData: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: $122674b135b0c50b$export$2e2bcd8739ae039,
                        variables: {
                            cloudId: cloudId,
                            scopeInput: $d491739a1b7483c1$var$buildScopeInput(entryPointRouteParams, scope),
                            configurationInput: $d491739a1b7483c1$var$buildConfigurationInput({
                                selectedDate: selectedDate,
                                viewRange: viewRange,
                                weekStartsOn: weekStartsOn,
                                startDateField: startDateField,
                                endDateField: endDateField,
                                viewId: viewId
                            }),
                            issuesPageSize: 50,
                            issuesSearchInput: issuesSearchInput,
                            unscheduledIssuesSearchInput: $d491739a1b7483c1$var$buildUnscheduledIssuesSearchInput(),
                            versionsSearchInput: $d491739a1b7483c1$var$buildVersionsSearchInput(),
                            sprintsSearchInput: $d491739a1b7483c1$var$buildSprintsSearchInput(),
                            skipSprintSearch: false,
                            viewId: viewId,
                            ...(0, (0, parcelRequire("4R6GH")).fg)('jsd_shield_jsm_calendar_weekly_view') && {
                                skipFieldConfig: false
                            },
                            schedulePermissionsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('calendar_schedule_issue_permissions_check'),
                            pageLoadMoreEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_calendar_load_more_pagination'),
                            skipVersionsV1Search: (0, (0, parcelRequire("4R6GH")).fg)('plan-calendar-versions-v2-adoption'),
                            skipVersionsV2Search: !(0, (0, parcelRequire("4R6GH")).fg)('plan-calendar-versions-v2-adoption')
                        }
                    }
                },
                entryPoints: {},
                extraProps: {
                    scope: scope,
                    selectedDate: selectedDate,
                    viewRange: viewRange,
                    weekStartsOn: weekStartsOn,
                    dayStartsAt: viewSettingsConfig.dayStartsAt,
                    issueEventFields: issueEventFields,
                    projectKey: projectKey,
                    storageKeyForViewSettings: storageKeyForViewSettings,
                    storageKeyForIssueSearchInput: storageKeyForIssueSearchInput,
                    showWeekends: viewSettingsConfig.showWeekends,
                    showIssueKey: viewSettingsConfig.showIssueKey,
                    showIn24HourClock: viewSettingsConfig.showIn24HourClock,
                    colorBy: colorBy
                }
            };
        }
    });
    const $c3ff53bf28ecf1c9$export$eda0c2fb67f7d7e7 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $d491739a1b7483c1$export$19cf4b398f638dc6),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $3ce1b2936d5b40e0$export$301bfcedbd0983b7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $72d318e197b1c24c$export$28a386a00670c893), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            ufoName: 'jsm-calendar',
            component: ()=>null,
            skeleton: (0, $69a8eba95a06a473$export$49d3670908a8d8fe),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, $7a169ab056601f38$export$b43adc74b6a33bde),
                horizontalFeatureFlag: 'jsm_views_of_work_phase_1'
            },
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("jYeNO")).getCalendarFilterFieldsResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jsd_shield_weekly_view_fast_follow') && !false, (0, (0, parcelRequire("f7Y15")).uifBoardResource))
            ],
            entryPoint: ()=>(0, $c3ff53bf28ecf1c9$export$eda0c2fb67f7d7e7),
            meta: {
                reporting: {
                    id: 'calendar',
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CALENDAR),
                    teamName: 'jsd-shield'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $co1wz;
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $f4b0e9313c9342f0$export$d9802671a2b1aa20 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8cdhY")).then(({ JSMOperationsHorizontalNav: JSMOperationsHorizontalNav })=>JSMOperationsHorizontalNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/operations/src/ui/index.tsx"
    });
    const $f4b0e9313c9342f0$export$d4493569f106c71 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-operations-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "asyncHorizontalOperationsNav",
            packageName: "jiraHorizontalNavJsmOperations",
            fallback: "flag",
            teamName: "alexstrasza"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f4b0e9313c9342f0$export$d9802671a2b1aa20, null)));
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $2pT4g;
    var $fpjJX;
    var $gNStA;
    var $J5M3r;
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("l6XXN"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/change-calendar/src/index.tsx"
    });
    var $f705f6e0ca7ffaf5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb,
            pageId: "spa-apps/servicedesk/change-calendar",
            shouldShowSpinner: true
        });
    const $76cc3b1301a661ae$export$de5b915e23c7ce7d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("J5M3r")).servicedeskChangeCalendarRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            ufoName: 'service-management.change-calendar',
            component: (0, $f705f6e0ca7ffaf5$export$2e2bcd8739ae039),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, $f4b0e9313c9342f0$export$d4493569f106c71),
                onlyShowHorizontalOnNav4: true
            },
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('enable_jsm_repackaging_changes_vtwk9'), (0, (0, parcelRequire("2pT4g")).jsmRepackagingBannerResource))
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb),
                (0, $f4b0e9313c9342f0$export$d9802671a2b1aa20)
            ],
            meta: {
                reporting: {
                    id: 'changeCalendar',
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CHANGE_CALENDAR),
                    teamName: 'jenga'
                }
            }
        }));
    var $ffza4;
    var $2G9Bk;
    var $65Ltd;
    const $f893c8f0cfb2ffb0$export$9f6d42997c66cc4b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE),
        path: '/jira/servicedesk/assets/configure/global'
    };
    var $e9YVH;
    var $65Ltd;
    var $2BrOV;
    var $lmyls;
    const $b1a753126e2543a9$export$56e7710ffaf62d23 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
        navigation: {
            menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).INSIGHT
        }
    };
    var $4R6GH;
    var $3RJkv;
    var $fpjJX;
    var $gNStA;
    var $gRzZD;
    function $b5734a01d347bbca$export$850433b0663023b8() {
        const servicedeskPageContextResources = (0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)().map((resource)=>(0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('add_service_desk_page_context_resources'), resource));
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            ...servicedeskPageContextResources,
            (0, (0, parcelRequire("gRzZD")).workspaceResource)
        ];
    }
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $faa956883f49da96$export$b80bd807bad3fd0a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("xpgfY")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-v2/src/index.tsx"
    });
    const $faa956883f49da96$var$GlobalConfigure = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $faa956883f49da96$export$b80bd807bad3fd0a,
            pageId: "spa-apps/servicedesk/insight/cmdb-configure",
            shouldShowSpinner: true
        });
    var $faa956883f49da96$export$2e2bcd8739ae039 = $faa956883f49da96$var$GlobalConfigure;
    const $68c0f578026a941d$export$c3f6c49752bd7afb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f893c8f0cfb2ffb0$export$9f6d42997c66cc4b), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            ufoName: 'servicedesk-cmdb-assets-configure',
            component: (0, $faa956883f49da96$export$2e2bcd8739ae039),
            resources: (0, $b5734a01d347bbca$export$850433b0663023b8)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $faa956883f49da96$export$b80bd807bad3fd0a)
            ],
            perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                    teamName: 'falcons'
                }
            }
        }));
    var $ffza4;
    var $2G9Bk;
    var $8naTI;
    var $65Ltd;
    const $fc27518f1ecabc2c$export$620f0fb687461e6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT),
        path: '/jira/servicedesk/assets/object/:objectId'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $3afd4c2d86bdef54$export$411c1981ced22249 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("8oQUA")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-v2/src/index.tsx"
    });
    const $3afd4c2d86bdef54$export$3c208f927c6178ee = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3afd4c2d86bdef54$export$411c1981ced22249,
            pageId: "spa-apps/servicedesk/insight/cmdb-object-v2",
            shouldShowSpinner: true
        });
    var $3afd4c2d86bdef54$export$2e2bcd8739ae039 = $3afd4c2d86bdef54$export$3c208f927c6178ee;
    const $53164b67e15deb5f$export$f38fc8b203c4d12c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fc27518f1ecabc2c$export$620f0fb687461e6), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            component: (0, $3afd4c2d86bdef54$export$3c208f927c6178ee),
            resources: [
                ...(0, $b5734a01d347bbca$export$850433b0663023b8)(),
                (0, (0, parcelRequire("8naTI")).insightObjectResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3afd4c2d86bdef54$export$411c1981ced22249)
            ],
            perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
            ufoName: 'service-management.insight-cmdb.object-view-page-load'
        }));
    var $ffza4;
    var $2G9Bk;
    var $6j0IA;
    var $65Ltd;
    const $3076563cb1feeec0$export$b4a150d67181752 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION),
        path: '/jira/servicedesk/assets/configure/object-schema/:objectSchemaId'
    };
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $af13a504c251f159$export$8305a1bc1c5bee45 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("75ZPm")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-configuration/src/index.tsx"
    });
    const $af13a504c251f159$var$ObjectSchemaConfiguration = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $af13a504c251f159$export$8305a1bc1c5bee45,
            pageId: "spa-apps/servicedesk/insight/cmdb-object-schema-configuration",
            shouldShowSpinner: true
        });
    var $af13a504c251f159$export$2e2bcd8739ae039 = $af13a504c251f159$var$ObjectSchemaConfiguration;
    const $ed12b48fb9ef1967$export$d49dc13ea3690284 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3076563cb1feeec0$export$b4a150d67181752), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            component: (0, $af13a504c251f159$export$2e2bcd8739ae039),
            resources: [
                ...(0, $b5734a01d347bbca$export$850433b0663023b8)(),
                (0, (0, parcelRequire("6j0IA")).serviceDeskAssetsImportTypeForgeDataResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $af13a504c251f159$export$8305a1bc1c5bee45)
            ],
            perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                    teamName: 'krispy-krew'
                }
            }
        }));
    var $ffza4;
    var $2G9Bk;
    var $65Ltd;
    const $0262d48f28c0e863$export$246ae573df78317e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA),
        path: '/jira/servicedesk/assets/object-schema/:objectSchemaId'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4jFTA")), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-v2/src/index.tsx"
    });
    const $3c1950a2c10ba0ce$export$f90a4f33c79fd86e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc,
            pageId: "spa-apps/servicedesk/insight/cmdb-object-schema",
            shouldShowSpinner: true
        });
    var $3c1950a2c10ba0ce$export$2e2bcd8739ae039 = $3c1950a2c10ba0ce$export$f90a4f33c79fd86e;
    const $07e247e1beb9f616$export$e985bd1e5b19c8f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0262d48f28c0e863$export$246ae573df78317e), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            component: (0, $3c1950a2c10ba0ce$export$f90a4f33c79fd86e),
            resources: (0, $b5734a01d347bbca$export$850433b0663023b8)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc)
            ],
            perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
        }));
    var $ffza4;
    var $2G9Bk;
    var $65Ltd;
    const $f41e677a77064268$export$73b901e16d5e5a02 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION),
        path: '/jira/servicedesk/assets/configure/object-type/:objectTypeId'
    };
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $14de2d11a3985015$export$926956539e1f72ba = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("bNaZl")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-object-type/src/index.tsx"
    });
    const $14de2d11a3985015$var$InsightConfigureObjectType = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $14de2d11a3985015$export$926956539e1f72ba,
            pageId: "spa-apps/servicedesk/insight/cmdb-configure-object-type",
            shouldShowSpinner: true
        });
    var $14de2d11a3985015$export$2e2bcd8739ae039 = $14de2d11a3985015$var$InsightConfigureObjectType;
    const $bb1bd6d97041761e$export$5df076b4cb6d7e22 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f41e677a77064268$export$73b901e16d5e5a02), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            component: (0, $14de2d11a3985015$export$2e2bcd8739ae039),
            resources: (0, $b5734a01d347bbca$export$850433b0663023b8)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $14de2d11a3985015$export$926956539e1f72ba)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                    teamName: 'falcons'
                }
            },
            ufoName: 'service-management.insight-cmdb-object-type-configuration'
        }));
    var $ffza4;
    var $7XYc4;
    var $3HwlS;
    var $2G9Bk;
    var $3RJkv;
    var $fpjJX;
    var $65Ltd;
    const $1826fb2735a26891$export$fec4267b02c2291f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT),
        path: '/jira/servicedesk/assets/reports',
        exact: true
    };
    var $e9YVH;
    var $gRzZD;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4jhAF")).then((exportedMembers)=>exportedMembers.CmdbAssetsReports), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
    });
    const $2e02aa1a19501df5$export$2534c3e9f8e70d0d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4jhAF")).then((exportedMembers)=>exportedMembers.CmdbDefaultReportsRedirect), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
    });
    const $2e02aa1a19501df5$export$dec85f15dd805ac4 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("h5ZL2")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports-unsubscribe/src/index.tsx"
    });
    const $2e02aa1a19501df5$export$c56cfef9aa68df09 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("4jhAF")).then((exportedMembers)=>exportedMembers.CmdbAssetsReportsNav4HomePage), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
    });
    const $2e02aa1a19501df5$export$d45b40d40442434 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa,
            pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports",
            shouldShowSpinner: true
        });
    const $2e02aa1a19501df5$export$541b39e6d5be07df = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e02aa1a19501df5$export$dec85f15dd805ac4,
            pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe",
            shouldShowSpinner: true
        });
    const $2e02aa1a19501df5$export$4155da54bfeacf74 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e02aa1a19501df5$export$2534c3e9f8e70d0d,
            pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-default-redirect",
            shouldShowSpinner: true
        });
    const $2e02aa1a19501df5$export$9d28551695f98cae = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e02aa1a19501df5$export$c56cfef9aa68df09,
            pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-home-page",
            shouldShowSpinner: true
        });
    const $8943dfd1674ca99a$export$cf67f47431177236 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1826fb2735a26891$export$fec4267b02c2291f), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, $2e02aa1a19501df5$export$9d28551695f98cae), (0, $2e02aa1a19501df5$export$4155da54bfeacf74)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("gRzZD")).workspaceResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2e02aa1a19501df5$export$2534c3e9f8e70d0d),
                (0, $2e02aa1a19501df5$export$c56cfef9aa68df09)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                    teamName: 'ITSM SAGA'
                }
            }
        }));
    var $ffza4;
    var $9QpK7;
    var $lmyls;
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $d99ccdcd3c9cebe4$export$2260a0528570f8da = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("8ym2X")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/assets-reports/src/index.tsx"
    });
    const $d99ccdcd3c9cebe4$var$AssetsReportsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "assets-reports-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d99ccdcd3c9cebe4$export$2260a0528570f8da, null)));
    $d99ccdcd3c9cebe4$var$AssetsReportsSidebar.displayName = 'AssetsReportsSidebar';
    var $d99ccdcd3c9cebe4$export$2e2bcd8739ae039 = $d99ccdcd3c9cebe4$var$AssetsReportsSidebar;
    var $2G9Bk;
    var $3RJkv;
    var $fpjJX;
    var $5lsNZ;
    var $65Ltd;
    const $5c3155ab36693f37$export$a075d8b7c4c55c41 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS),
        path: '/jira/servicedesk/assets/reports/:templateId',
        exact: true
    };
    var $e9YVH;
    var $gRzZD;
    const $7d8fc8fb38284992$export$a9d327b5b7247f71 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $5c3155ab36693f37$export$a075d8b7c4c55c41), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('jsm-assets-reporting_seqk0', (0, $2e02aa1a19501df5$export$d45b40d40442434), (0, (0, parcelRequire("5lsNZ")).default)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("gRzZD")).workspaceResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, $d99ccdcd3c9cebe4$export$2e2bcd8739ae039)
            },
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS),
                    teamName: 'ITSM SAGA'
                }
            },
            perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template'
        }));
    var $ffza4;
    var $2G9Bk;
    var $3RJkv;
    var $fpjJX;
    var $65Ltd;
    const $8ce2bb095b9742dc$export$66ab60d374e8e458 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE),
        path: '/jira/servicedesk/assets/reports/unsubscribe/:templateId/:subscriptionId',
        exact: true
    };
    var $e9YVH;
    var $gRzZD;
    const $3f95abeddff727cc$export$5842852f274cd739 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8ce2bb095b9742dc$export$66ab60d374e8e458), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            component: (0, $2e02aa1a19501df5$export$541b39e6d5be07df),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("gRzZD")).workspaceResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2e02aa1a19501df5$export$dec85f15dd805ac4)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                    teamName: 'ITSM SAGA'
                }
            }
        }));
    var $ffza4;
    var $2G9Bk;
    var $65Ltd;
    const $ccd7800c69636bda$export$152b5dead07808bc = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS),
        path: '/jira/servicedesk/assets',
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $3371db153f9530b2$export$f6c79e6ff37913ee = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("cFBuN")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-landing-page/src/index.tsx"
    });
    const $3371db153f9530b2$var$LandingPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3371db153f9530b2$export$f6c79e6ff37913ee,
            pageId: "spa-apps/servicedesk/insight/cmdb-landing-page",
            shouldShowSpinner: true
        });
    var $3371db153f9530b2$export$2e2bcd8739ae039 = $3371db153f9530b2$var$LandingPage;
    const $25b44de36ebce345$export$81e75cb2595e7f2a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ccd7800c69636bda$export$152b5dead07808bc), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            component: (0, $3371db153f9530b2$export$2e2bcd8739ae039),
            resources: (0, $b5734a01d347bbca$export$850433b0663023b8)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3371db153f9530b2$export$f6c79e6ff37913ee)
            ],
            perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
        }));
    var $ffza4;
    var $2G9Bk;
    var $65Ltd;
    const $ba065f4b091a02af$export$96e5da52356f214c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
        path: '/jira/servicedesk/insight/configure/global'
    };
    var $e9YVH;
    const $c572a1f6d205e72b$export$69b479583cd0d13f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ba065f4b091a02af$export$96e5da52356f214c), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            ufoName: 'servicedesk-cmdb-insight-configure-global',
            component: (0, $faa956883f49da96$export$2e2bcd8739ae039),
            resources: (0, $b5734a01d347bbca$export$850433b0663023b8)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $faa956883f49da96$export$b80bd807bad3fd0a)
            ],
            perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                    teamName: 'falcons'
                }
            }
        }));
    var $ffza4;
    var $2G9Bk;
    var $65Ltd;
    const $b3ba64550401680b$export$e960ab4fcd3e80b6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
        path: '/jira/servicedesk/insight/configure'
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $9872d73b74d97014$export$8075d4042713bf6d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("5Bl21")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure/src/index.tsx"
    });
    const $9872d73b74d97014$var$InsightConfigure = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9872d73b74d97014$export$8075d4042713bf6d,
            pageId: "spa-apps/servicedesk/insight/cmdb-configure",
            shouldShowSpinner: true
        });
    var $9872d73b74d97014$export$2e2bcd8739ae039 = $9872d73b74d97014$var$InsightConfigure;
    const $495bba4b83c4abb8$export$277a55a31c82cf0e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b3ba64550401680b$export$e960ab4fcd3e80b6), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            ufoName: 'servicedesk-cmdb-insight-configure',
            component: (0, $9872d73b74d97014$export$2e2bcd8739ae039),
            resources: (0, $b5734a01d347bbca$export$850433b0663023b8)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $9872d73b74d97014$export$8075d4042713bf6d)
            ]
        }));
    var $ffza4;
    var $2G9Bk;
    var $8naTI;
    var $65Ltd;
    const $fa024efc61833843$export$223f5bacfd3d39fd = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT),
        path: '/jira/servicedesk/insight/assets/:objectId'
    };
    const $20b7f48df08d140e$export$95574c3333e559d3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $fa024efc61833843$export$223f5bacfd3d39fd), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            component: (0, $3afd4c2d86bdef54$export$3c208f927c6178ee),
            resources: [
                ...(0, $b5734a01d347bbca$export$850433b0663023b8)(),
                (0, (0, parcelRequire("8naTI")).insightObjectResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3afd4c2d86bdef54$export$411c1981ced22249)
            ],
            perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
            ufoName: 'service-management.insight-cmdb.object-view-page-load'
        }));
    var $ffza4;
    var $2G9Bk;
    var $65Ltd;
    const $0be30b09ce65a175$export$f6b688a8729943b3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
        path: '/jira/servicedesk/insight/configure/object-schema/:objectSchemaId'
    };
    var $e9YVH;
    const $dc805604e47f30ff$export$261e9b5115dfbb0a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0be30b09ce65a175$export$f6b688a8729943b3), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            component: (0, $af13a504c251f159$export$2e2bcd8739ae039),
            resources: (0, $b5734a01d347bbca$export$850433b0663023b8)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $af13a504c251f159$export$8305a1bc1c5bee45)
            ],
            perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                    teamName: 'krispy-krew'
                }
            }
        }));
    var $ffza4;
    var $2G9Bk;
    var $65Ltd;
    const $0050a642a1c533ba$export$fcde60ded71d4ae6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA),
        path: '/jira/servicedesk/insight/object-schemas/:objectSchemaId'
    };
    const $390b0c9138642138$export$192b200c13b0b76a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0050a642a1c533ba$export$fcde60ded71d4ae6), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            component: (0, $3c1950a2c10ba0ce$export$f90a4f33c79fd86e),
            resources: (0, $b5734a01d347bbca$export$850433b0663023b8)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc)
            ],
            perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
        }));
    var $ffza4;
    var $2G9Bk;
    var $65Ltd;
    const $de5e134e813298dc$export$12e89d5d79d59785 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION),
        path: '/jira/servicedesk/insight/configure/object-type/:objectTypeId'
    };
    var $e9YVH;
    const $0a9518d238b0ac1f$export$de4ab140a5dbd984 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $de5e134e813298dc$export$12e89d5d79d59785), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            component: (0, $14de2d11a3985015$export$2e2bcd8739ae039),
            resources: (0, $b5734a01d347bbca$export$850433b0663023b8)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $14de2d11a3985015$export$926956539e1f72ba)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                    teamName: 'falcons'
                }
            }
        }));
    var $ffza4;
    var $2G9Bk;
    var $65Ltd;
    const $638ad863a15aceaf$export$1efada07b7203f2d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME),
        path: '/jira/servicedesk/insight',
        exact: true
    };
    const $a395bb20c6d1e9c8$export$3befca4eb012b818 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $638ad863a15aceaf$export$1efada07b7203f2d), ()=>({
            ...(0, $b1a753126e2543a9$export$56e7710ffaf62d23),
            component: (0, $3371db153f9530b2$export$2e2bcd8739ae039),
            resources: (0, $b5734a01d347bbca$export$850433b0663023b8)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3371db153f9530b2$export$f6c79e6ff37913ee)
            ],
            perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $834f9b43560f1ccb$export$1f409a894343952a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT),
        path: '/jira/servicedesk/create-project',
        exact: true
    };
    var $6Z2mh;
    var $e9YVH;
    var $5j7Th;
    var $kxZPA;
    const $3e592ff21679cec3$export$5004e0d4f1e57790 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3pzt9")), {
        moduleId: "./src/packages/spa-apps/servicedesk/create-project/src/index.tsx"
    });
    const $3e592ff21679cec3$export$ffae8a2776195524 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3e592ff21679cec3$export$5004e0d4f1e57790,
            pageId: "spa-apps/servicedesk/create-project",
            shouldShowSpinner: true
        });
    const $3e592ff21679cec3$export$ac25abe07ac3f570 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $834f9b43560f1ccb$export$1f409a894343952a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            isRedirect: true,
            component: $3e592ff21679cec3$export$ffae8a2776195524,
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $3e592ff21679cec3$export$5004e0d4f1e57790
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CREATE_PROJECT,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CREATE_PROJECT),
                    teamName: 'itops-mithril'
                }
            }
        }));
    var $ffza4;
    var $2G9Bk;
    var $fcMlY;
    var $4lqmX;
    var $65Ltd;
    const $42ea45afdbe6f2e0$export$42c0f04d04ecd1f8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS),
        path: '/jira/servicedesk/projects/:projectKey/customers/:customerId',
        exact: true
    };
    var $e9YVH;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $bHhiy;
    var $fpjJX;
    var $6Z2mh;
    const $52ceba7c32850253$export$71eb1f878288699e = ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $11e345ce4933debe$export$864b519a4059ac6b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kBMOn"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/customers-v2/src/index.tsx"
    });
    const $11e345ce4933debe$export$ac54d7814cf71dd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $11e345ce4933debe$export$864b519a4059ac6b,
            pageId: "spa-apps/servicedesk/customers-v2",
            shouldShowSpinner: true
        });
    const $11e345ce4933debe$export$6c5749ec31de847d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("iviTi"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/customer-details/src/index.tsx"
    });
    const $11e345ce4933debe$export$2412523c0e3657cc = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $11e345ce4933debe$export$6c5749ec31de847d,
            pageId: "spa-apps/servicedesk/customer-details",
            shouldShowSpinner: true
        });
    const $742f9da2fde448d1$export$97ee6e9bb7f7bd31 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $42ea45afdbe6f2e0$export$42c0f04d04ecd1f8), ()=>({
            ...(0, $52ceba7c32850253$export$71eb1f878288699e)(),
            component: (0, $11e345ce4933debe$export$2412523c0e3657cc),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $11e345ce4933debe$export$6c5749ec31de847d)
            ],
            perfMetricKey: 'jsm-customer-details-component-load',
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_DETAILS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_DETAILS),
                    teamName: 'boysenberry'
                }
            },
            resources: [
                ...(0, $52ceba7c32850253$export$71eb1f878288699e)().resources,
                (0, (0, parcelRequire("fcMlY")).entitlementsCustomerQueryResource),
                (0, (0, parcelRequire("4lqmX")).uiCustomerDetailsPageQueryResource)
            ]
        }));
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $eAdnc;
    const $499fff83668d7b3b$export$e1fa279356610d18 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eAdnc")).servicedeskCustomersV2Route), ()=>({
            ...(0, $52ceba7c32850253$export$71eb1f878288699e)(),
            component: (0, $11e345ce4933debe$export$ac54d7814cf71dd),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $11e345ce4933debe$export$864b519a4059ac6b)
            ],
            perfMetricKey: 'jsm-customers-component-load',
            ufoName: 'jsm-customers-component-load',
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, $c28aa1a42d481780$export$a237f415539577a5),
                onlyShowHorizontalOnNav4: true
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $7MCPm;
    var $ludxj;
    var $6Z2mh;
    const $3053f9214c133ac3$export$8810bfd4f6a0eb22 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ludxj")).projectServiceDeskRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            isRedirect: true,
            component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $65Ltd;
    var $co1wz;
    var $4R6GH;
    var $lmyls;
    var $ggg5j;
    var $h0bZU;
    var $2G9Bk;
    var $fpjJX;
    var $k8jl5;
    var $5lsNZ;
    var $3Xbwz;
    var $6Z2mh;
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $980ce1cbc2c3fd94$exports = {};
    $980ce1cbc2c3fd94$exports = new URL("getting-started-page-app-skeleton.tpl.b9c0d034.svg", import.meta.url).toString();
    const $562ac3cd506226fa$var$customCssStyles = null;
    const $562ac3cd506226fa$export$525669daa9599ec = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($980ce1cbc2c3fd94$exports))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_rcuj1wug _o81c1wug _1l6u1wug _149m1wug _701wukw8 _9qarbrur"
            ])
        });
    var $eufEc;
    var $fEDBv;
    const $7b51534336e501eb$export$a91a58d8bb93ad8e = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("5gAHG")), {
            moduleId: "99c912b0"
        }),
        getPreloadProps: ()=>({})
    });
    const $e0702275c9800b93$var$gettingStartedPageEntryPoint = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $7b51534336e501eb$export$a91a58d8bb93ad8e),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $e0702275c9800b93$export$9f5707c751b4b364 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3Xbwz")).gspPageRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            perfMetricKey: 'servicedesk-getting-started-page-load',
            skeleton: (0, $562ac3cd506226fa$export$525669daa9599ec),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("k8jl5")).servicedeskIssueTypesResource)
            ],
            entryPoint () {
                return (0, (0, parcelRequire("4R6GH")).fg)('gsp_production_rollout') || (0, (0, parcelRequire("co1wz")).ff)('getting_started_page_production_rollout') ? $e0702275c9800b93$var$gettingStartedPageEntryPoint : undefined;
            },
            component: (0, (0, parcelRequire("5lsNZ")).default)
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $65Ltd;
    const $d8477253737ee5ba$export$5bc288fedb880892 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ITSM_SAMPLE_SPACE),
        path: '/jira/servicedesk/itsm-sample-space',
        exact: true
    };
    var $6Z2mh;
    var $e9YVH;
    var $5j7Th;
    var $kxZPA;
    const $e773d085694b29f0$export$c1a5da0c35411fc1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("6xxAH")), {
        moduleId: "./src/packages/spa-apps/servicedesk/itsm-sample-space/src/index.tsx"
    });
    const $e773d085694b29f0$export$389e7e12a5ae9f5a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e773d085694b29f0$export$c1a5da0c35411fc1,
            pageId: "spa-apps/servicedesk/itsm-sample-space",
            shouldShowSpinner: true
        });
    const $e773d085694b29f0$export$61ad481262acd4e6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d8477253737ee5ba$export$5bc288fedb880892), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            isRedirect: true,
            component: $e773d085694b29f0$export$389e7e12a5ae9f5a,
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $e773d085694b29f0$export$c1a5da0c35411fc1
            ],
            perfMetricKey: 'jsm-sample-space-landing-page',
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).ITSM_SAMPLE_SPACE,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).ITSM_SAMPLE_SPACE),
                    teamName: 'itops-mithril'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $jIAHH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $0168703d3ad589b1$export$20e57a83f181da7b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/browse/page/:pageId'
    };
    var $6Z2mh;
    var $e9YVH;
    var $bjZiV;
    var $fpjJX;
    const $b00efe6c4e255b63$export$5421e48e728c449f = ()=>[
            ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
            (0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource)
        ];
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $7877fae2c22be3a0$export$c73ba7e80a805fb2 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("heMv1"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-articles/src/index.tsx"
    });
    var $7877fae2c22be3a0$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7877fae2c22be3a0$export$c73ba7e80a805fb2,
            pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-articles",
            shouldShowSpinner: true
        });
    const $a340d83cd9968ce2$export$5b55251966102ec = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0168703d3ad589b1$export$20e57a83f181da7b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $7877fae2c22be3a0$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $b00efe6c4e255b63$export$5421e48e728c449f)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7877fae2c22be3a0$export$c73ba7e80a805fb2)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_ARTICLES,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_ARTICLES),
                    teamName: 'jsm-nebula'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $2G9Bk;
    var $fpjJX;
    var $65Ltd;
    const $e0250c214f5345c0$export$bd512c426b095693 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
        query: [
            'draftShareId?',
            'topicId?'
        ]
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $398a28a595927246$export$35c6d2a033ef4c42 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bEyY0"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-article-embed-editor/src/index.tsx"
    });
    var $398a28a595927246$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $398a28a595927246$export$35c6d2a033ef4c42,
            pageId: "knowledge-article-embed-editor",
            shouldShowSpinner: true
        });
    const $a9203ca39324e16d$export$513e093ef937dc06 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e0250c214f5345c0$export$bd512c426b095693), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $398a28a595927246$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $b00efe6c4e255b63$export$5421e48e728c449f)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $398a28a595927246$export$35c6d2a033ef4c42)
            ],
            perfMetricKey: 'service-management.knowledge.ep-editor'
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $cafdb26099846497$export$3afe8482ce820835 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/articles/:articleId'
    };
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $8c5dbaffda117c43$export$efd0ec49853aa81 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kYjOy"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-view-article/src/index.tsx"
    });
    var $8c5dbaffda117c43$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8c5dbaffda117c43$export$efd0ec49853aa81,
            pageId: "spa-apps/servicedesk/knowledge-hub/view-article",
            shouldShowSpinner: true
        });
    const $def4faef06d1a61c$export$a67199ebb12b0f7f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $cafdb26099846497$export$3afe8482ce820835), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            perfMetricKey: 'service-management.knowledge.article',
            component: (0, $8c5dbaffda117c43$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $b00efe6c4e255b63$export$5421e48e728c449f)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $8c5dbaffda117c43$export$efd0ec49853aa81)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE),
                    teamName: 'jsm-nebula'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $4R6GH;
    var $jIAHH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $coVHe;
    var $gNStA;
    var $65Ltd;
    const $ef3c5487d473c383$export$c8e99e3434791c0e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/articles',
        exact: true
    };
    var $6Z2mh;
    var $e9YVH;
    const $4c224bc59177653b$export$de40c949b963d9e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $ef3c5487d473c383$export$c8e99e3434791c0e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $7877fae2c22be3a0$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $b00efe6c4e255b63$export$5421e48e728c449f)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jsm-va-show-touchpoint-in-kb'), (0, (0, parcelRequire("coVHe")).virtualAgentKnowledgebaseTouchpointResource))
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7877fae2c22be3a0$export$c73ba7e80a805fb2)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_ARTICLES,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_ARTICLES),
                    teamName: 'jsm-nebula'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $jIAHH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $74299e4842369ef4$export$256f841794b3f077 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/categories',
        exact: true
    };
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0ed31e41bd08d12a$export$a488cba75f18ade8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("faCrc"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-categories/src/index.tsx"
    });
    var $0ed31e41bd08d12a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0ed31e41bd08d12a$export$a488cba75f18ade8,
            pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-categories",
            shouldShowSpinner: true
        });
    const $578b57d26acf701a$export$dd6c99863524ee59 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $74299e4842369ef4$export$256f841794b3f077), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $0ed31e41bd08d12a$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $b00efe6c4e255b63$export$5421e48e728c449f)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $0ed31e41bd08d12a$export$a488cba75f18ade8)
            ],
            perfMetricKey: 'service-management.kb-categories',
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_CATEGORIES,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_CATEGORIES),
                    teamName: 'jsm-nebula'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $43d5800a4cfdec2f$export$ef8a9ec2979d1b10 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/articles/:articleId'
    };
    var $6Z2mh;
    var $e9YVH;
    const $4bb5aab980a1ec0f$export$abb9cdffbf5c943b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $43d5800a4cfdec2f$export$ef8a9ec2979d1b10), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            perfMetricKey: 'service-management.knowledge.article',
            component: (0, $8c5dbaffda117c43$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $b00efe6c4e255b63$export$5421e48e728c449f)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $8c5dbaffda117c43$export$efd0ec49853aa81)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE),
                    teamName: 'jsm-nebula'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $4f0b06054e994db5$export$79fb48a07e43639a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/browse/page/:pageId'
    };
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $cbedf43cff0d751d$export$c01a896b8d33aa9c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("axq9y"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-category/src/index.tsx"
    });
    var $cbedf43cff0d751d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cbedf43cff0d751d$export$c01a896b8d33aa9c,
            pageId: "spa-apps/servicedesk/knowledge-hub/category",
            shouldShowSpinner: true
        });
    const $298d9707a87dc987$export$464b24032c2aeb02 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $4f0b06054e994db5$export$79fb48a07e43639a), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $cbedf43cff0d751d$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $b00efe6c4e255b63$export$5421e48e728c449f)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cbedf43cff0d751d$export$c01a896b8d33aa9c)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_CATEGORY,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_CATEGORY),
                    teamName: 'jsm-nebula'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $874cf8128fc31da0$export$69ed5b0214ea6ee5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId'
    };
    var $6Z2mh;
    var $e9YVH;
    const $2e1862f21e7b949b$export$416d7b87b4f3205e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $874cf8128fc31da0$export$69ed5b0214ea6ee5), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            ufoName: 'service-management.knowledge.category',
            component: (0, $cbedf43cff0d751d$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $b00efe6c4e255b63$export$5421e48e728c449f)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cbedf43cff0d751d$export$c01a896b8d33aa9c)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_CATEGORY,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_CATEGORY),
                    teamName: 'jsm-nebula'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $jIAHH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $9a661013d8f5290f$export$670f3b59aa55b7ae = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/drafts',
        exact: true
    };
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $e2e95eba21898c94$export$53decb9d1eb60aed = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8wHId"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-drafts/src/index.tsx"
    });
    var $e2e95eba21898c94$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e2e95eba21898c94$export$53decb9d1eb60aed,
            pageId: "spa-apps/servicedesk/knowledge-hub/drafts",
            shouldShowSpinner: true
        });
    const $9ba3413d02e7079e$export$4da743c0d13c2cfc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9a661013d8f5290f$export$670f3b59aa55b7ae), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $e2e95eba21898c94$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $b00efe6c4e255b63$export$5421e48e728c449f)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $e2e95eba21898c94$export$53decb9d1eb60aed)
            ],
            perfMetricKey: 'service-management.kb-drafts',
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_DRAFTS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_DRAFTS),
                    teamName: 'jsm-nebula'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $jIAHH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $bMJcR;
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $f59132c22330e6a8$export$f1266a588cfc310b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aJqiu")), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-landing/src/index.tsx"
    });
    var $f59132c22330e6a8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f59132c22330e6a8$export$f1266a588cfc310b,
            pageId: "spa-apps/servicedesk/knowledge-hub/landing-page",
            shouldShowSpinner: true
        });
    const $cd1258ca8f7bcdbf$export$671687d85e096e5b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMJcR")).knowledgeHubLandingRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $f59132c22330e6a8$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $b00efe6c4e255b63$export$5421e48e728c449f)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $f59132c22330e6a8$export$f1266a588cfc310b)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_LANDING,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_LANDING),
                    teamName: 'jsm-nebula'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $jIAHH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $27dc0fd67ac82331$export$a47c36fb081b544d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/search/articles/:articleId'
    };
    var $6Z2mh;
    var $e9YVH;
    const $1f2e00b6e54dbec2$export$49337a3cc2431ae5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $27dc0fd67ac82331$export$a47c36fb081b544d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $8c5dbaffda117c43$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $b00efe6c4e255b63$export$5421e48e728c449f)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $8c5dbaffda117c43$export$efd0ec49853aa81)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE),
                    teamName: 'jsm-nebula'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $598bde1f568a466c$export$f20770545704547d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SETUP),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/setup'
    };
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $4cd10b3eae0d5ed2$export$6c08040d2dc71e43 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("dMkfh")), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-setup/src/index.tsx"
    });
    var $4cd10b3eae0d5ed2$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4cd10b3eae0d5ed2$export$6c08040d2dc71e43,
            pageId: "spa-apps/servicedesk/knowledge-hub/setup",
            shouldShowSpinner: true
        });
    const $fa00eaf494d4bfab$export$b220f8194ee7c231 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $598bde1f568a466c$export$f20770545704547d), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $4cd10b3eae0d5ed2$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $b00efe6c4e255b63$export$5421e48e728c449f)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $4cd10b3eae0d5ed2$export$6c08040d2dc71e43)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_SETUP,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_SETUP),
                    teamName: 'jsm-nebula'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $jIAHH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $8f32a5b26dce9533$export$54edf5cef1c6b21b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/suggested-topics',
        exact: true
    };
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $2WqFA;
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $70c4d3c688caba8c$export$aee7d96c2ee4c388 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3BoXf"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-suggested-articles/src/index.tsx"
    });
    const $70c4d3c688caba8c$export$ee4623542ebd573e = ()=>{
        const { data: isAdminHubAIEnabled, loading: loading, error: error, fetchAIEnablement: fetchAIEnablement } = (0, (0, parcelRequire("2WqFA")).default)('jira-servicedesk');
        const showSuggestedTopics = (0, (0, parcelRequire("4R6GH")).fg)('suggested_topics_eap') ? !loading && !error && isAdminHubAIEnabled : (0, (0, parcelRequire("4R6GH")).fg)('jsm-suggested-articles-in-kb');
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("4R6GH")).fg)('suggested_topics_eap') && fetchAIEnablement();
        }, [
            fetchAIEnablement
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, showSuggestedTopics && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $70c4d3c688caba8c$export$aee7d96c2ee4c388,
            pageId: "spa-apps/servicedesk/knowledge-hub/suggested-articles",
            shouldShowSpinner: true
        }));
    };
    const $0632a084fe67a48e$export$6a7974939bde7d37 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8f32a5b26dce9533$export$54edf5cef1c6b21b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $70c4d3c688caba8c$export$ee4623542ebd573e),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $b00efe6c4e255b63$export$5421e48e728c449f)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $70c4d3c688caba8c$export$aee7d96c2ee4c388)
            ],
            perfMetricKey: 'service-management.kb-suggested-articles',
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_SUGGESTED_ARTICLES,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_SUGGESTED_ARTICLES),
                    teamName: 'jsm-nebula'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $joRT8;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ce165317fbb6ef87$export$69cba5247233f8bc = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bm2td"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/notification-logs/src/index.tsx"
    });
    const $ce165317fbb6ef87$export$1139895a5af7252e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ce165317fbb6ef87$export$69cba5247233f8bc,
            pageId: "spa-apps/servicedesk/notification-logs",
            shouldShowSpinner: true
        });
    const $8c16ad2f5cbcb35f$export$20ab3a955246df95 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("joRT8")).notificationLogsRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: (0, $ce165317fbb6ef87$export$1139895a5af7252e),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ce165317fbb6ef87$export$69cba5247233f8bc)
            ],
            perfMetricKey: 'jsm-notification-logs-component-load'
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $9kQCa;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $816d970487a82139$export$e8392650fdcd92d5 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("dt8J6")), {
        moduleId: "./src/packages/spa-apps/servicedesk/opsgenie-schedule/src/index.tsx"
    });
    var $816d970487a82139$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $816d970487a82139$export$e8392650fdcd92d5,
            pageId: "spa-apps/servicedesk/opsgenie-schedule",
            shouldShowSpinner: true
        });
    const $010b24cf318456cc$export$36994f6fd22da90e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9kQCa")).servicedeskOncallScheduleRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            ufoName: 'service-management.on-call-schedule',
            component: (0, $816d970487a82139$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, $f4b0e9313c9342f0$export$d4493569f106c71),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $816d970487a82139$export$e8392650fdcd92d5),
                (0, $f4b0e9313c9342f0$export$d9802671a2b1aa20)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $38BXB;
    var $7CBZS;
    var $fpjJX;
    var $6x0wo;
    var $65Ltd;
    const $0e8ebef5d5d75a55$export$7f878f9aeac61f1e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2),
        path: '/jira/servicedesk/projects/:projectKey/organization/:organizationId',
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $f3c20d8fbb399193$export$1c7fcdb58f42db03 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dSzzF"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/organization-v2/src/index.tsx"
    });
    const $f3c20d8fbb399193$export$5f69663d85db303d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f3c20d8fbb399193$export$1c7fcdb58f42db03,
            pageId: "spa-apps/servicedesk/organization-v2",
            shouldShowSpinner: true
        });
    const $5928d6539d724a6d$export$1b6ea96c35c2472c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $0e8ebef5d5d75a55$export$7f878f9aeac61f1e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("6x0wo")).serviceDeskOrganizationPanelForgeDataResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("7CBZS")).productsJsmOrganizationDetailsResource),
                (0, (0, parcelRequire("38BXB")).jsmEmailDomainsListResource)
            ],
            component: (0, $f3c20d8fbb399193$export$5f69663d85db303d),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $f3c20d8fbb399193$export$1c7fcdb58f42db03)
            ],
            perfMetricKey: 'jsm-organizations-component-load'
        }));
    var $ffza4;
    var $2G9Bk;
    var $38BXB;
    var $7CBZS;
    var $8XgXN;
    var $iTeMQ;
    var $65Ltd;
    const $beffe8b6a9e6d0f2$export$eacc4723293cbc36 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS),
        path: '/jira/servicedesk/projects/:projectKey/organizations/:organizationId',
        exact: true
    };
    var $e9YVH;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $bHhiy;
    var $fpjJX;
    var $6Z2mh;
    const $00c40f128b7ee524$export$85902564f5c84c2a = ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        });
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $b9e14ed4e63c050e$export$b40b4bfa472057b9 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lpf7H"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/organizations/src/index.tsx"
    });
    const $b9e14ed4e63c050e$export$4abec67d7b34dda2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b9e14ed4e63c050e$export$b40b4bfa472057b9,
            pageId: "spa-apps/servicedesk/organizations",
            shouldShowSpinner: true
        });
    const $b9e14ed4e63c050e$export$4a01866152e4a375 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("aod5A"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/organization-details/src/index.tsx"
    });
    const $b9e14ed4e63c050e$export$709be875ca0a7ead = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b9e14ed4e63c050e$export$4a01866152e4a375,
            pageId: "spa-apps/servicedesk/organization-details",
            shouldShowSpinner: true
        });
    const $a8b4c58f96e42722$export$a9452a74fdc4d74f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $beffe8b6a9e6d0f2$export$eacc4723293cbc36), ()=>({
            ...(0, $00c40f128b7ee524$export$85902564f5c84c2a)(),
            component: (0, $b9e14ed4e63c050e$export$709be875ca0a7ead),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b9e14ed4e63c050e$export$4a01866152e4a375)
            ],
            perfMetricKey: 'jsm-organization-details-component-load',
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).ORGANIZATION_DETAILS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).ORGANIZATION_DETAILS),
                    teamName: 'boysenberry'
                }
            },
            resources: [
                ...(0, $00c40f128b7ee524$export$85902564f5c84c2a)().resources,
                (0, (0, parcelRequire("8XgXN")).entitlementsOrganizationQueryResource),
                (0, (0, parcelRequire("iTeMQ")).uiOrganizationDetailsPageQueryResource),
                (0, (0, parcelRequire("7CBZS")).productsJsmOrganizationDetailsResource),
                (0, (0, parcelRequire("38BXB")).jsmEmailDomainsListResource)
            ]
        }));
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bkElt;
    var $e9YVH;
    const $51233e7b4d73b144$export$cf20fe731144ca3b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bkElt")).servicedeskOrganizationsRoute), ()=>({
            ...(0, $00c40f128b7ee524$export$85902564f5c84c2a)(),
            component: (0, $b9e14ed4e63c050e$export$4abec67d7b34dda2),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b9e14ed4e63c050e$export$b40b4bfa472057b9)
            ],
            perfMetricKey: 'jsm-organizations-component-load',
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, $c28aa1a42d481780$export$a237f415539577a5),
                onlyShowHorizontalOnNav4: true
            },
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).ORGANIZATIONS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).ORGANIZATIONS),
                    teamName: 'boysenberry'
                }
            }
        }));
    var $65Ltd;
    var $7XYc4;
    var $4R6GH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $5lsNZ;
    var $5wuQF;
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $hCy6k;
    var $e0304552cabc8d2c$exports = {};
    $e0304552cabc8d2c$exports = new URL("project-summary-skeleton.tpl.f2232e71.svg", import.meta.url).toString();
    const $d1cb7759e14ba32c$export$93a223cf4712c63d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCy6k")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($e0304552cabc8d2c$exports)))
        });
    var $lmyls;
    var $eufEc;
    var $fEDBv;
    const $15ffffad92965566$export$95a2fe4e495efca5 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("dHAzH")), {
            moduleId: "ac794fd1"
        }),
        getPreloadProps: ()=>({})
    });
    const $cfa42f0318b6392e$export$ae7c241893e7dab9 = (0, $6a0b20679c309df7$export$955a7619d2679b4c)({
        main: (0, $15ffffad92965566$export$95a2fe4e495efca5),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $2c8ef8f8c8b8bea4$export$a24d68fcf82b16bb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5wuQF")).servicedeskProjectSummaryRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            ufoName: 'jsm.project-summary',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jsm-project-summary'), ()=>null, (0, (0, parcelRequire("5lsNZ")).default)),
            skeleton: (0, $d1cb7759e14ba32c$export$93a223cf4712c63d),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            entryPoint: ()=>(0, (0, parcelRequire("4R6GH")).fg)('jsm-project-summary') ? (0, $cfa42f0318b6392e$export$ae7c241893e7dab9) : undefined,
            meta: {
                reporting: {
                    id: 'project-summary',
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).PROJECT_SUMMARY),
                    teamName: 'jsd-shield'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $co1wz;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $aPfsS;
    var $jlOGG;
    var $bHhiy;
    var $2pT4g;
    var $fpjJX;
    var $gNStA;
    var $urQ6o;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $baa78d0687f01783$export$6f01bfb6fc18a06e = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("36xAX"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-agent-and-issue-view/src/index.tsx"
    });
    const $baa78d0687f01783$export$59d555419fbaa611 = ({ match: match })=>{
        const queueId = match.params && match.params.queueId || '';
        const issueKey = match.params && match.params.issueKey || '';
        const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $baa78d0687f01783$export$6f01bfb6fc18a06e,
            pageId: `spa-apps/servicedesk/queues/${queueId}/${issueKey}/${oldIssueView}`,
            shouldShowSpinner: true
        });
    };
    const $aa74409e2ad842d4$export$b43128c9b5db2a5e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("urQ6o")).customPracticeQueueRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $baa78d0687f01783$export$59d555419fbaa611),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    params: [
                        {
                            key: 'issueKey'
                        }
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getKnowledgeBaseResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getIssueListSsrResource)(),
                (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('enable_jsm_repackaging_changes_vtwk9'), (0, (0, parcelRequire("2pT4g")).jsmRepackagingBannerResource))
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $baa78d0687f01783$export$6f01bfb6fc18a06e)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $aPfsS;
    var $jlOGG;
    var $bHhiy;
    var $fpjJX;
    var $aNLeB;
    var $7M8Tn;
    var $6Z2mh;
    const $9125770532ebae88$export$54a295e04e6cea33 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7M8Tn")).customQueueRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $baa78d0687f01783$export$59d555419fbaa611),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    params: [
                        {
                            key: 'issueKey'
                        }
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getIssueListSsrResource)(),
                (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("aNLeB")).servicedeskIsItsmProjectResource)
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $baa78d0687f01783$export$6f01bfb6fc18a06e)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $1bb6cc8a72a7dc88$export$e146d4ae5415aa9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/issue/:issueKey',
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $3e1702b77575d903$export$52593b5917c5e179 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("gcllV")), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view-redirect/src/index.tsx"
    });
    var $3e1702b77575d903$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3e1702b77575d903$export$52593b5917c5e179,
            pageId: "spa-apps/servicedesk/queues/issue-view-redirect",
            shouldShowSpinner: true
        });
    const $d0c44cd76c7c1b24$export$a4bd7206a6659ad3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1bb6cc8a72a7dc88$export$e146d4ae5415aa9), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $3e1702b77575d903$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getKnowledgeBaseResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $3e1702b77575d903$export$52593b5917c5e179)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $c23ca6ea0acd72bb$export$dfaa99f66db1aa2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit',
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $deaadf08ad128234$export$5bb02347e0261e6a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("coJTW"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-edit-view/src/index.tsx"
    });
    var $deaadf08ad128234$export$2e2bcd8739ae039 = ({ match: match })=>{
        const queueId = match.params && match.params.queueId || '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $deaadf08ad128234$export$5bb02347e0261e6a,
            pageId: `spa-apps/servicedesk/queues/edit/${queueId}`,
            shouldShowSpinner: true
        });
    };
    const $b2af11fd25aabf4a$export$5d9efd0f838d30a1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c23ca6ea0acd72bb$export$dfaa99f66db1aa2), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $deaadf08ad128234$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getIssueListSsrResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $deaadf08ad128234$export$5bb02347e0261e6a)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $aPfsS;
    var $jlOGG;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $b7f41b661071cdd5$export$38a6ee0f22e74bf3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/issue/:issueKey',
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $e8099257b5d2aca0$export$164f2dfdd8dc056b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("1y2nu")), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view/src/index.tsx"
    });
    var $e8099257b5d2aca0$export$2e2bcd8739ae039 = ({ match: match })=>{
        const issueKey = `/${match.params && match.params.issueKey || ''}`;
        const queueId = `/${match.params && match.params.queueId || ''}`;
        const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e8099257b5d2aca0$export$164f2dfdd8dc056b,
            pageId: `spa-apps/servicedesk/queues/issue${queueId}${issueKey}${oldIssueView}`,
            shouldShowSpinner: true
        });
    };
    const $c4ae805410394011$export$ff51f5ad948cb987 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $b7f41b661071cdd5$export$38a6ee0f22e74bf3), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $e8099257b5d2aca0$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)()),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getKnowledgeBaseResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $e8099257b5d2aca0$export$164f2dfdd8dc056b)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $3ecb8d0a4bfa59d9$export$3c859c71be33b36c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/(custom)?',
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $33ab495a6069d0db$export$bdf522692228bb6f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("6d9hm")), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-landing/src/index.tsx"
    });
    var $33ab495a6069d0db$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $33ab495a6069d0db$export$bdf522692228bb6f,
            pageId: "spa-apps/servicedesk/queues/landing",
            shouldShowSpinner: true
        });
    const $8be1362ae286a3b1$export$881d545af6c177f1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3ecb8d0a4bfa59d9$export$3c859c71be33b36c), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            isRedirect: true,
            component: (0, $33ab495a6069d0db$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $33ab495a6069d0db$export$bdf522692228bb6f)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $fpjJX;
    var $65Ltd;
    const $bf1a5a194b52ef2d$export$125e0ab662806584 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/queue-settings',
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $ad9d634f0cdcf391$export$9f1e189198f08c4a = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("eEcjl"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-manage-view/src/index.tsx"
    });
    var $ad9d634f0cdcf391$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ad9d634f0cdcf391$export$9f1e189198f08c4a,
            pageId: "spa-apps/servicedesk/queues/manage",
            shouldShowSpinner: true
        });
    const $1a1c1c43e66f85e4$export$4e1b0df2a8fcae78 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $bf1a5a194b52ef2d$export$125e0ab662806584), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $ad9d634f0cdcf391$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: (0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ad9d634f0cdcf391$export$9f1e189198f08c4a)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $e5aa77a45094c512$export$8595a5452f93a1fd = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/new',
        query: [
            'parentId?'
        ],
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $093d629913ef6b8e$export$c050b699bf9e3e40 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("a8afX"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-create-view/src/index.tsx"
    });
    var $093d629913ef6b8e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $093d629913ef6b8e$export$c050b699bf9e3e40,
            pageId: "spa-apps/servicedesk/queues/create",
            shouldShowSpinner: true
        });
    const $149e7521aa5247f3$export$50a04ec00cb8039 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e5aa77a45094c512$export$8595a5452f93a1fd), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $093d629913ef6b8e$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $093d629913ef6b8e$export$c050b699bf9e3e40)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $4884cbac3a1d9cc0$export$1465f05b88a63f13 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON),
        path: '/jira/servicedesk/projects/:projectKey/queues/addon/:addonKey',
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $6cc059f7849819d9$export$451a7cce84b6b1e6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3Z2MRq")), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-addon-view/src/index.tsx"
    });
    var $6cc059f7849819d9$export$2e2bcd8739ae039 = ({ match: match })=>{
        const addonKey = match.params && match.params.addonKey || '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6cc059f7849819d9$export$451a7cce84b6b1e6,
            pageId: `spa-apps/servicedesk/queues/addon/${addonKey}`,
            shouldShowSpinner: true
        });
    };
    const $59596f7c053ae5d7$export$23a16f20b48235b3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $4884cbac3a1d9cc0$export$1465f05b88a63f13), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $6cc059f7849819d9$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $6cc059f7849819d9$export$451a7cce84b6b1e6)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $f9047204629cbf40$export$f8fd3a1f8c33aff8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT),
        path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit',
        exact: true
    };
    var $6Z2mh;
    const $ce3daf0233f73856$export$ae7b71ac953d95bf = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $f9047204629cbf40$export$f8fd3a1f8c33aff8), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $deaadf08ad128234$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("fpjJX")).getIssueListSsrResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $deaadf08ad128234$export$5bb02347e0261e6a)
            ],
            ufoName: 'service-management.queues.edit'
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $aPfsS;
    var $jlOGG;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $e8668889c15b3639$export$52a24b9cf42d208b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/queues/issue/:issueKey',
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    var $6Z2mh;
    const $af2173f32f306a68$export$2e4931acac9270fc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $e8668889c15b3639$export$52a24b9cf42d208b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $e8099257b5d2aca0$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    params: [
                        {
                            key: 'issueKey'
                        }
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getKnowledgeBaseResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $e8099257b5d2aca0$export$164f2dfdd8dc056b)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $jlOGG;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $c48a2414491b1ed8$export$52b4c044e4929ebc = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING),
        path: '/jira/servicedesk/projects/:projectKey/queues/(default|custom)?',
        exact: true
    };
    var $6Z2mh;
    const $725a0b4233bb029f$export$4242a81237c45c7d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c48a2414491b1ed8$export$52b4c044e4929ebc), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            isRedirect: true,
            component: (0, $33ab495a6069d0db$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $33ab495a6069d0db$export$bdf522692228bb6f)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $fpjJX;
    var $65Ltd;
    const $d770d83963ac1c36$export$7f30d40b906894c5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW),
        path: '/jira/servicedesk/projects/:projectKey/queues/queue-settings',
        exact: true
    };
    var $6Z2mh;
    const $4edb93f2b23424ca$export$7e9e2984a94a07b0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $d770d83963ac1c36$export$7f30d40b906894c5), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $ad9d634f0cdcf391$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: (0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ad9d634f0cdcf391$export$9f1e189198f08c4a)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $52cd0fc2ec934503$export$c1908994722d1e73 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_NEW),
        path: '/jira/servicedesk/projects/:projectKey/queues/custom/new',
        query: [
            'parentId?'
        ],
        exact: true
    };
    var $6Z2mh;
    const $43b55289272bfd02$export$9f7cc3294b3141b1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $52cd0fc2ec934503$export$c1908994722d1e73), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $093d629913ef6b8e$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $093d629913ef6b8e$export$c050b699bf9e3e40)
            ],
            ufoName: 'service-management.queues.new'
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $hejqw;
    var $fpjJX;
    var $65Ltd;
    const $9a654d65b63de676$export$399ef3a2d4288bba = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}${(0, $2a2c96c36181bec8$export$7bcca34e1e3ee9d4)}`,
        exact: true
    };
    var $6Z2mh;
    var $e9YVH;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $8afe4cbad132cc61$export$78ffe2f6530d45d1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gPETo"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/atlassian-analytics/src/index.tsx"
    });
    const $8afe4cbad132cc61$export$6d23a188bb96b7ab = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8afe4cbad132cc61$export$78ffe2f6530d45d1,
            pageId: "spa-apps/servicedesk/atlassian-analytics",
            shouldShowSpinner: true
        });
    const $f87b1ab4700345c2$export$94d6674b63b9d647 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $9a654d65b63de676$export$399ef3a2d4288bba), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $8afe4cbad132cc61$export$6d23a188bb96b7ab),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("hejqw")).servicedeskAtlassianAnalyticsResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $8afe4cbad132cc61$export$78ffe2f6530d45d1)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).ATLASSIAN_ANALYTICS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).ATLASSIAN_ANALYTICS),
                    teamName: 'ITSM Saga'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $abd055c66022393b$export$276e2ed89304d21c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}${(0, $2a2c96c36181bec8$export$95e4474302b2231c)}`
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $12e91a60aa9991e2$export$f86e12b111395ad = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ZGuam"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/kb-requests-reports/src/index.tsx"
    });
    var $12e91a60aa9991e2$export$2e2bcd8739ae039 = ({ match: match })=>{
        const reportType = match.params.reportType || '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $12e91a60aa9991e2$export$f86e12b111395ad,
            pageId: `spa-apps/servicedesk/reports/${reportType}`,
            shouldShowSpinner: true
        });
    };
    const $aba9a99d9cdea566$export$c4c0806ea684088 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $abd055c66022393b$export$276e2ed89304d21c), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            perfMetricKey: 'service-management.reports.kb-requests',
            component: (0, $12e91a60aa9991e2$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $12e91a60aa9991e2$export$f86e12b111395ad)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $aPfsS;
    var $jlOGG;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $8f89a0ced56a7cae$export$296aa46068d40f43 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}${(0, $2a2c96c36181bec8$export$95e4474302b2231c)}${(0, $2a2c96c36181bec8$export$59a54976da551a4d)}${(0, $2a2c96c36181bec8$export$5daa28d10e23592)}`,
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $7281c34e15a34d51$export$c2f0d3c59c9d3bf3 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lROrJ")), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-issue-view/src/index.tsx"
    });
    var $7281c34e15a34d51$export$2e2bcd8739ae039 = ({ match: match })=>{
        const issueKey = `/${match.params && match.params.issueKey || ''}`;
        const timescaleId = `/${match.params && match.params.timescaleId || ''}`;
        const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7281c34e15a34d51$export$c2f0d3c59c9d3bf3,
            pageId: `spa-apps/servicedesk/reports/issue${issueKey}${timescaleId}${oldIssueView}`,
            shouldShowSpinner: true
        });
    };
    const $7f9fdb3f5341d83e$export$280a79a8f002dd58 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $8f89a0ced56a7cae$export$296aa46068d40f43), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $7281c34e15a34d51$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)()),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7281c34e15a34d51$export$c2f0d3c59c9d3bf3)
            ],
            ufoName: 'service-management.reports.issue'
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $7032eddc67e65c51$export$1585b6f8f1838e19 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}${(0, $2a2c96c36181bec8$export$95e4474302b2231c)}${(0, $2a2c96c36181bec8$export$59a54976da551a4d)}`
    };
    var $6Z2mh;
    const $bb1d631cc0a3bc8b$export$1c6b1e308d58ca8b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $7032eddc67e65c51$export$1585b6f8f1838e19), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            perfMetricKey: 'service-management.reports.kb-requests',
            component: (0, $12e91a60aa9991e2$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $12e91a60aa9991e2$export$f86e12b111395ad)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $lmyls;
    var $3HwlS;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $cJTRV;
    var $6Z2mh;
    var $7tQej;
    var $bjZiV;
    var $fpjJX;
    const $61625a3694fd8e06$export$1a63e9cdf8268e40 = ()=>[
            ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
            (0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource)
        ];
    const $11b6f5430511c7a8$export$e4c007d05145b8c2 = '/reports/all-rating';
    const $11b6f5430511c7a8$export$5daa28d10e23592 = '/:issueKey';
    const $11b6f5430511c7a8$export$ddc580d759168f88 = '/reports/workload';
    const $11b6f5430511c7a8$export$13bdc187fca9c33e = '/reports';
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $2636e09e0764ad56$export$121b9cfb2b001a53 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7gVww"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-home-page/src/index.tsx"
    });
    var $2636e09e0764ad56$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2636e09e0764ad56$export$121b9cfb2b001a53,
            pageId: `spa-apps/servicedesk${(0, $11b6f5430511c7a8$export$13bdc187fca9c33e)}}`,
            shouldShowSpinner: true
        });
    const $28c558427771b7f4$var$DefaultReportsRedirect = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/jira/servicedesk/projects/${String(match.params.projectKey)}${(0, $11b6f5430511c7a8$export$ddc580d759168f88)}`
        });
    const $28c558427771b7f4$export$8055c8b2162cf5bd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cJTRV")).servicedeskReports1Route), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, $2636e09e0764ad56$export$2e2bcd8739ae039), $28c558427771b7f4$var$DefaultReportsRedirect),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $61625a3694fd8e06$export$1a63e9cdf8268e40)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $2636e09e0764ad56$export$121b9cfb2b001a53)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $47b22144a185fe3a$export$39325072940fb58c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}${(0, $2a2c96c36181bec8$export$5527975ed7975b27)}`
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $940ea7d208fcfce4$export$3ec5c3d7729889b9 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3Nt4q"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-custom/src/index.tsx"
    });
    var $940ea7d208fcfce4$export$2e2bcd8739ae039 = ({ match: match })=>{
        const reportType = match.params.reportType || '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $940ea7d208fcfce4$export$3ec5c3d7729889b9,
            pageId: `spa-apps/servicedesk/reports/${reportType}`,
            shouldShowSpinner: true
        });
    };
    const $bc9f120c03f314db$export$5ef62fad7280cd08 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $47b22144a185fe3a$export$39325072940fb58c), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $940ea7d208fcfce4$export$2e2bcd8739ae039),
            perfMetricKey: 'service-management.reports.custom',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $940ea7d208fcfce4$export$3ec5c3d7729889b9)
            ],
            ufoName: 'service-management-custom-reports'
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $c5c6b7b61be9d580$export$333e623d5eb41af0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}/reports/custom/new`
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0aaa6fdfa8d01159$export$821b8201b24f8b7d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lKpoc"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-create/src/index.tsx"
    });
    var $0aaa6fdfa8d01159$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0aaa6fdfa8d01159$export$821b8201b24f8b7d,
            pageId: "spa-apps/servicedesk/reports/custom/create",
            shouldShowSpinner: true
        });
    const $2cf0babd3b9237c1$export$b806d1abc9172b6d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c5c6b7b61be9d580$export$333e623d5eb41af0), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            perfMetricKey: 'service-management.reports.custom-create',
            component: (0, $0aaa6fdfa8d01159$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $0aaa6fdfa8d01159$export$821b8201b24f8b7d)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $175ba21e4ba52ddb$export$3b6b3105a9ef9b83 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}${(0, $2a2c96c36181bec8$export$5527975ed7975b27)}/edit`
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $db3dd114755c3f65$export$53def03ace9a6c5b = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hnzof"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-edit/src/index.tsx"
    });
    var $db3dd114755c3f65$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { reportId: reportId } = match.params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $db3dd114755c3f65$export$53def03ace9a6c5b,
            pageId: `spa-apps/servicedesk/reports/custom/${reportId || ''}`,
            shouldShowSpinner: true
        });
    };
    const $79d751c5c6540b74$export$c4c3dcf824e7036e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $175ba21e4ba52ddb$export$3b6b3105a9ef9b83), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            perfMetricKey: 'service-management.reports.custom-edit-view',
            component: (0, $db3dd114755c3f65$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $db3dd114755c3f65$export$53def03ace9a6c5b)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $aPfsS;
    var $jlOGG;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $3e79cb7a6fb28a4d$export$1cfe539c854438e8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}${(0, $2a2c96c36181bec8$export$5527975ed7975b27)}${(0, $2a2c96c36181bec8$export$59a54976da551a4d)}${(0, $2a2c96c36181bec8$export$5daa28d10e23592)}`,
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    var $6Z2mh;
    const $db3c4c23d5eb6125$export$222c6398b69dbc6d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3e79cb7a6fb28a4d$export$1cfe539c854438e8), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $7281c34e15a34d51$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)()),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7281c34e15a34d51$export$c2f0d3c59c9d3bf3)
            ],
            ufoName: 'service-management.reports.issue'
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $3a492ac932fcb1b3$export$eae9a65fe3f035ef = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}${(0, $2a2c96c36181bec8$export$5527975ed7975b27)}${(0, $2a2c96c36181bec8$export$59a54976da551a4d)}`
    };
    var $6Z2mh;
    const $422e88992a614b49$export$508d5e1a59322a54 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $3a492ac932fcb1b3$export$eae9a65fe3f035ef), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $940ea7d208fcfce4$export$2e2bcd8739ae039),
            perfMetricKey: 'service-management.reports.custom',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $940ea7d208fcfce4$export$3ec5c3d7729889b9)
            ],
            ufoName: 'service-management-custom-reports'
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $15dedc31928a1123$export$22fd25b495033fdf = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}${(0, $2a2c96c36181bec8$export$e4c007d05145b8c2)}`
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $66f1c14673116eb8$export$8edc7b9d922cd22f = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4su99"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-satisfaction/src/index.tsx"
    });
    var $66f1c14673116eb8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $66f1c14673116eb8$export$8edc7b9d922cd22f,
            pageId: `spa-apps/servicedesk${(0, $11b6f5430511c7a8$export$e4c007d05145b8c2)}}`,
            shouldShowSpinner: true
        });
    const $eebc12aca0cec40e$export$d6fb66bfd4a40ef = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $15dedc31928a1123$export$22fd25b495033fdf), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            perfMetricKey: 'service-management.reports.satisfaction',
            component: (0, $66f1c14673116eb8$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $66f1c14673116eb8$export$8edc7b9d922cd22f)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $aPfsS;
    var $jlOGG;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $c513c6729e01b870$export$da606765550c7e7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}${(0, $2a2c96c36181bec8$export$e4c007d05145b8c2)}${(0, $2a2c96c36181bec8$export$59a54976da551a4d)}${(0, $2a2c96c36181bec8$export$5daa28d10e23592)}`,
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    var $6Z2mh;
    const $28e15c46fa77f0cb$export$6b98300c0f2ab048 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $c513c6729e01b870$export$da606765550c7e7), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $7281c34e15a34d51$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)()),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            afterPaint: [
                (0, $43c3852afc527b13$export$8c70dcc4643464f8)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7281c34e15a34d51$export$c2f0d3c59c9d3bf3)
            ],
            ufoName: 'service-management.reports.issue'
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $51118689f933b851$export$64ae70b2d6b34c4e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}${(0, $2a2c96c36181bec8$export$e4c007d05145b8c2)}${(0, $2a2c96c36181bec8$export$59a54976da551a4d)}`
    };
    var $6Z2mh;
    const $460b54aef192ce9f$export$8d7026b8c74a8be8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $51118689f933b851$export$64ae70b2d6b34c4e), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            perfMetricKey: 'service-management.reports.satisfaction',
            component: (0, $66f1c14673116eb8$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $66f1c14673116eb8$export$8edc7b9d922cd22f)
            ]
        }));
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $80e1fc4edc9879bd$export$44647b0fd2271ddb = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY),
        path: '(/jira/servicedesk/projects/[^/]+/reports/.+)/summary',
        exact: true
    };
    var $6Z2mh;
    var $7tQej;
    const $f342f91b4b1a84c3$var$returnToSummary = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: String(match.params['0'])
        });
    const $f342f91b4b1a84c3$export$1e9f7a41c4c3aacc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $80e1fc4edc9879bd$export$44647b0fd2271ddb), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: $f342f91b4b1a84c3$var$returnToSummary,
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $aPfsS;
    var $jlOGG;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $48dd2701ffbb9a85$export$b955ac7f09c5dbb = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}/reports/:reportType/:reportId?/:reportsAction?/:timescaleId?/:issueKey?`,
        query: [
            'oldIssueView?'
        ]
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $7131a1cafe24fb0a$export$75e043cf7a4e3661 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("j8Qf3")), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports/src/index.tsx"
    });
    var $7131a1cafe24fb0a$export$2e2bcd8739ae039 = ({ match: match })=>{
        const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7131a1cafe24fb0a$export$75e043cf7a4e3661,
            pageId: `spa-apps/servicedesk/reports/${match ? match.url : ''}${oldIssueView}`,
            shouldShowSpinner: true
        });
    };
    const $2e5063c16517b80e$export$bc47b2df6d39fd3f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $48dd2701ffbb9a85$export$b955ac7f09c5dbb), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $7131a1cafe24fb0a$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("aPfsS")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, $59d96d961d806fee$export$7b113174a456921a)([
                {
                    params: [
                        {
                            key: 'issueKey'
                        }
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, $61625a3694fd8e06$export$1a63e9cdf8268e40)(),
                (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $7131a1cafe24fb0a$export$75e043cf7a4e3661)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $339f526b78d38fe7$export$ce9b409ccf53e93c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD),
        path: `${(0, $2a2c96c36181bec8$export$e05c5e9dacfbd89d)}${(0, $2a2c96c36181bec8$export$ddc580d759168f88)}`,
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $d985dd949edfaeac$export$e805fb47fdcd991 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hKSst"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-workload/src/index.tsx"
    });
    var $d985dd949edfaeac$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d985dd949edfaeac$export$e805fb47fdcd991,
            pageId: `spa-apps/servicedesk${(0, $11b6f5430511c7a8$export$ddc580d759168f88)}}`,
            shouldShowSpinner: true
        });
    const $6d0123422454b447$export$793ba749f18b4dd4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $339f526b78d38fe7$export$ce9b409ccf53e93c), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $d985dd949edfaeac$export$2e2bcd8739ae039),
            perfMetricKey: 'service-management.reports.workload',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $d985dd949edfaeac$export$e805fb47fdcd991)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $65Ltd;
    const $338c1e6694a650ce$export$fe5fe00b6d5eab87 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS),
        path: `${(0, $37ca4af52bd8808a$export$e05c5e9dacfbd89d)}${(0, $37ca4af52bd8808a$export$a00b470f6b2accee)}${(0, $37ca4af52bd8808a$export$e45f794606940226)}`
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $b6f27b3727e127d8$export$b154597f29589502 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("aNOBo"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/service-details-with-project-context/src/index.tsx"
    });
    var $b6f27b3727e127d8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b6f27b3727e127d8$export$b154597f29589502,
            pageId: "spa-apps/servicedesk/service-details",
            shouldShowSpinner: true
        });
    const $9ea7b1d46a5382bf$export$48af7c0b8f21929b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $338c1e6694a650ce$export$fe5fe00b6d5eab87), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            ufoName: 'service-management.service-details',
            component: (0, $b6f27b3727e127d8$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $b6f27b3727e127d8$export$b154597f29589502)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $35fa5222e37aa796$export$25e1d58db18a7c8b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT),
        path: `${(0, $37ca4af52bd8808a$export$8478788f248b5217)}${(0, $37ca4af52bd8808a$export$a00b470f6b2accee)}${(0, $37ca4af52bd8808a$export$e45f794606940226)}`
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $0bd916f0e88ab362$export$ba1931edde0ce20c = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9eS30"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/service-details-without-project-context/src/index.tsx"
    });
    var $0bd916f0e88ab362$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0bd916f0e88ab362$export$ba1931edde0ce20c,
            pageId: "spa-apps/servicedesk/service-details",
            shouldShowSpinner: true
        });
    const $90fd21cadf51bf65$export$de2e645f69483ce = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $35fa5222e37aa796$export$25e1d58db18a7c8b), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            ufoName: 'service-management.service-details-without-project',
            component: (0, $0bd916f0e88ab362$export$2e2bcd8739ae039),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $0bd916f0e88ab362$export$ba1931edde0ce20c)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT),
                    packageName: 'jiraSpaAppsServicedeskServiceDetailsWithoutProjectContext"',
                    teamName: 'Falcons'
                }
            }
        }));
    var $ffza4;
    var $65Ltd;
    var $2G9Bk;
    var $fpjJX;
    var $65Ltd;
    const $6a799f5afeb5f72a$export$319fbbab5eb49cbf = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_EDIT),
        path: `${(0, $37ca4af52bd8808a$export$8478788f248b5217)}${(0, $37ca4af52bd8808a$export$9aab114cbf0ce5e)}${(0, $37ca4af52bd8808a$export$e45f794606940226)}`
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $ca64a28173fa79b9$export$8984aadca7e15d1 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lGL4F")), {
        moduleId: "./src/packages/spa-apps/servicedesk/service-update-modal-without-project-context/src/index.tsx"
    });
    var $ca64a28173fa79b9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ca64a28173fa79b9$export$8984aadca7e15d1,
            pageId: "spa-apps/servicedesk/service-update-modal",
            shouldShowSpinner: true
        });
    const $92695f6b0e89b9c4$export$5698449b623d4af = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $6a799f5afeb5f72a$export$319fbbab5eb49cbf), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $ca64a28173fa79b9$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $ca64a28173fa79b9$export$8984aadca7e15d1)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2G9Bk;
    var $fpjJX;
    var $65Ltd;
    const $feeac99aa6e6a420$export$5b5ea97286af2784 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_NEW),
        path: `${(0, $37ca4af52bd8808a$export$8478788f248b5217)}${(0, $37ca4af52bd8808a$export$9aab114cbf0ce5e)}`,
        exact: true
    };
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $cd397b20b9604e50$export$7f4092c8e7b7d3ec = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("eBC57")), {
        moduleId: "./src/packages/spa-apps/servicedesk/service-create-modal-without-project-context/src/index.tsx"
    });
    var $cd397b20b9604e50$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cd397b20b9604e50$export$7f4092c8e7b7d3ec,
            pageId: "spa-apps/servicedesk/service-create-modal",
            shouldShowSpinner: true
        });
    const $42345241d55d66da$export$75c24699abe8e616 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $feeac99aa6e6a420$export$5b5ea97286af2784), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            component: (0, $cd397b20b9604e50$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $cd397b20b9604e50$export$7f4092c8e7b7d3ec)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $dePjO;
    var $6Z2mh;
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $6f003aeaf484cf06$export$4aa60213b3477cf6 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("6VeJW")), {
        moduleId: "./src/packages/spa-apps/servicedesk/services-with-project-context/src/index.tsx"
    });
    var $6f003aeaf484cf06$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6f003aeaf484cf06$export$4aa60213b3477cf6,
            pageId: "spa-apps/servicedesk/services",
            shouldShowSpinner: true
        });
    const $2498bd7e181dd343$export$5df203501090bc7f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dePjO")).servicedeskServicesRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            ufoName: 'service-management.services',
            component: (0, $6f003aeaf484cf06$export$2e2bcd8739ae039),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, $f4b0e9313c9342f0$export$d4493569f106c71),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $f4b0e9313c9342f0$export$d9802671a2b1aa20),
                (0, $6f003aeaf484cf06$export$4aa60213b3477cf6)
            ]
        }));
    var $ffza4;
    var $65Ltd;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $65Ltd;
    const $1c8a671593efdd17$export$3210e7c54c21be97 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT),
        path: `${(0, $37ca4af52bd8808a$export$8478788f248b5217)}${(0, $37ca4af52bd8808a$export$a00b470f6b2accee)}`,
        exact: true
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $kxZPA;
    const $be661d3f8fec3b0f$export$fc385e1392a8e28 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("9kUwX")), {
        moduleId: "./src/packages/spa-apps/servicedesk/services-without-project-context/src/index.tsx"
    });
    var $be661d3f8fec3b0f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $be661d3f8fec3b0f$export$fc385e1392a8e28,
            pageId: "spa-apps/servicedesk/services",
            shouldShowSpinner: true
        });
    const $48a572bbef08816c$export$7031f96c25be5e14 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, $1c8a671593efdd17$export$3210e7c54c21be97), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
            ufoName: 'service-management.services-without-project',
            component: (0, $be661d3f8fec3b0f$export$2e2bcd8739ae039),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, $be661d3f8fec3b0f$export$fc385e1392a8e28)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT),
                    packageName: 'jiraSpaAppsServicedeskServicesWithoutProjectContext"',
                    teamName: 'Falcons'
                }
            }
        }));
    const $6b03ae00f6427f42$export$b4944bd787708b82 = [
        (0, $cd1258ca8f7bcdbf$export$671687d85e096e5b),
        (0, $4c224bc59177653b$export$de40c949b963d9e),
        (0, $9ba3413d02e7079e$export$4da743c0d13c2cfc),
        (0, $578b57d26acf701a$export$dd6c99863524ee59),
        (0, $0632a084fe67a48e$export$6a7974939bde7d37),
        (0, $4bb5aab980a1ec0f$export$abb9cdffbf5c943b),
        (0, $a9203ca39324e16d$export$513e093ef937dc06),
        (0, $a340d83cd9968ce2$export$5b55251966102ec),
        (0, $def4faef06d1a61c$export$a67199ebb12b0f7f),
        (0, $298d9707a87dc987$export$464b24032c2aeb02),
        (0, $2e1862f21e7b949b$export$416d7b87b4f3205e),
        (0, $1f2e00b6e54dbec2$export$49337a3cc2431ae5),
        (0, $fa00eaf494d4bfab$export$b220f8194ee7c231),
        (0, $f342f91b4b1a84c3$export$1e9f7a41c4c3aacc),
        (0, $28c558427771b7f4$export$8055c8b2162cf5bd),
        (0, $f87b1ab4700345c2$export$94d6674b63b9d647),
        (0, $6d0123422454b447$export$793ba749f18b4dd4),
        (0, $28e15c46fa77f0cb$export$6b98300c0f2ab048),
        (0, $460b54aef192ce9f$export$8d7026b8c74a8be8),
        (0, $eebc12aca0cec40e$export$d6fb66bfd4a40ef),
        (0, $7f9fdb3f5341d83e$export$280a79a8f002dd58),
        (0, $bb1d631cc0a3bc8b$export$1c6b1e308d58ca8b),
        (0, $aba9a99d9cdea566$export$c4c0806ea684088),
        (0, $79d751c5c6540b74$export$c4c3dcf824e7036e),
        (0, $2cf0babd3b9237c1$export$b806d1abc9172b6d),
        (0, $db3c4c23d5eb6125$export$222c6398b69dbc6d),
        (0, $422e88992a614b49$export$508d5e1a59322a54),
        (0, $bc9f120c03f314db$export$5ef62fad7280cd08),
        (0, $2e5063c16517b80e$export$bc47b2df6d39fd3f),
        (0, $d0c44cd76c7c1b24$export$a4bd7206a6659ad3),
        (0, $725a0b4233bb029f$export$4242a81237c45c7d),
        (0, $43b55289272bfd02$export$9f7cc3294b3141b1),
        (0, $ce3daf0233f73856$export$ae7b71ac953d95bf),
        (0, $9125770532ebae88$export$54a295e04e6cea33),
        (0, $af2173f32f306a68$export$2e4931acac9270fc),
        (0, $4edb93f2b23424ca$export$7e9e2984a94a07b0),
        (0, $59596f7c053ae5d7$export$23a16f20b48235b3),
        (0, $8be1362ae286a3b1$export$881d545af6c177f1),
        (0, $149e7521aa5247f3$export$50a04ec00cb8039),
        (0, $1a1c1c43e66f85e4$export$4e1b0df2a8fcae78),
        (0, $b2af11fd25aabf4a$export$5d9efd0f838d30a1),
        (0, $aa74409e2ad842d4$export$b43128c9b5db2a5e),
        (0, $c4ae805410394011$export$ff51f5ad948cb987),
        (0, $d84f7f5f7c3d3051$export$848a32cf0fcf8a61),
        (0, $e0702275c9800b93$export$9f5707c751b4b364),
        (0, $2498bd7e181dd343$export$5df203501090bc7f),
        (0, $9ea7b1d46a5382bf$export$48af7c0b8f21929b),
        (0, $48a572bbef08816c$export$7031f96c25be5e14),
        (0, $90fd21cadf51bf65$export$de2e645f69483ce),
        (0, $42345241d55d66da$export$75c24699abe8e616),
        (0, $92695f6b0e89b9c4$export$5698449b623d4af),
        (0, $742f9da2fde448d1$export$97ee6e9bb7f7bd31),
        (0, $499fff83668d7b3b$export$e1fa279356610d18),
        (0, $a8b4c58f96e42722$export$a9452a74fdc4d74f),
        (0, $51233e7b4d73b144$export$cf20fe731144ca3b),
        (0, $5928d6539d724a6d$export$1b6ea96c35c2472c),
        (0, $010b24cf318456cc$export$36994f6fd22da90e),
        (0, $76cc3b1301a661ae$export$de5b915e23c7ce7d),
        (0, $3ce1b2936d5b40e0$export$301bfcedbd0983b7),
        (0, $2c8ef8f8c8b8bea4$export$a24d68fcf82b16bb),
        (0, $25b44de36ebce345$export$81e75cb2595e7f2a),
        (0, $a395bb20c6d1e9c8$export$3befca4eb012b818),
        (0, $8943dfd1674ca99a$export$cf67f47431177236),
        (0, $7d8fc8fb38284992$export$a9d327b5b7247f71),
        (0, $3f95abeddff727cc$export$5842852f274cd739),
        (0, $07e247e1beb9f616$export$e985bd1e5b19c8f),
        (0, $390b0c9138642138$export$192b200c13b0b76a),
        (0, $bb1bd6d97041761e$export$5df076b4cb6d7e22),
        (0, $0a9518d238b0ac1f$export$de4ab140a5dbd984),
        (0, $68c0f578026a941d$export$c3f6c49752bd7afb),
        (0, $c572a1f6d205e72b$export$69b479583cd0d13f),
        (0, $ed12b48fb9ef1967$export$d49dc13ea3690284),
        (0, $dc805604e47f30ff$export$261e9b5115dfbb0a),
        (0, $495bba4b83c4abb8$export$277a55a31c82cf0e),
        (0, $53164b67e15deb5f$export$f38fc8b203c4d12c),
        (0, $20b7f48df08d140e$export$95574c3333e559d3),
        (0, $8c16ad2f5cbcb35f$export$20ab3a955246df95),
        (0, $ec6bba63502dd6b2$export$72138a83eeba68eb),
        (0, $3053f9214c133ac3$export$8810bfd4f6a0eb22),
        (0, $e773d085694b29f0$export$61ad481262acd4e6),
        (0, $3e592ff21679cec3$export$ac25abe07ac3f570)
    ];
    const $26bc22beafcfd5a4$export$d47aca795954578 = ()=>[
            (0, $70d164d9674a0900$export$487a360459ad1bea),
            (0, $a1bee888763609f4$export$46273ee39bcd958b),
            (0, $eea4a938c8d518ff$export$d8088cb4e7cc7efd),
            (0, $88ce8816647240e1$export$96bdc57a01f2ee48),
            ...(0, $a901f652fe0a27d8$export$b1d92ac5cda62e7e),
            ...(0, $1f4b902ae477a058$export$688b56fcbc2637ac),
            ...(0, $a401463e87f56f84$export$44e0cb320cb148ed),
            (0, $048906688afed449$export$bb72a943d2340466),
            (0, $2fac5cfb84bcd36a$export$f08156edd0ce3853),
            ...(0, $d1067266a88b60d4$export$5b4e616b6b4b672a),
            ...(0, $512b517449862f9e$export$fd0ef3739cde76c1),
            ...(0, $0e0d75857105a821$export$fb2091db9e7f9102),
            ...(0, $e8fc18994c4f5903$export$c9b96dd6f5a7b454),
            (0, $eb7a8f12766dfa01$export$f7d3667678a21360),
            (0, $0bcebe438fd2464d$export$39e83fab54222094),
            (0, $8d888d2aca144cd1$export$26f89b9d922d1bea),
            (0, $b2269bc905327468$export$334720f484807a91),
            (0, $66bc19155bc886e3$export$cccc8c9dd9619d7f),
            (0, $f0855c0baf74da48$export$abd0bbe95839baf7),
            ...(0, $1f4483ba9d8ac23e$export$f9a1f59ec7d1f215),
            (0, $3506fc2f26a58302$export$423a1c80bb2f8b9a),
            (0, $2e7db6c4b913404f$export$875d88a44b1ff74c),
            (0, $202f2f6ea16fcbde$export$422f564c9c56a4f8),
            (0, $6ada90d55b94e879$export$27be010fc1b30f6c),
            (0, $8d5b2002b38c1828$export$90d7a2fe9ba3bc11),
            (0, $1e962caa58edcf31$export$e95be402bc1a646a),
            (0, $5d397d8509ca5a2f$export$aee58781a360177c),
            (0, $821c1a4ddda27ddd$export$14047a53c7c79a48),
            (0, $0d21ee6685c8bd5a$export$7d132f335f852c6e),
            (0, $61850d407ce9e191$export$a0e51305c115ecf7),
            (0, $119aabab50d41e92$export$7234db75929ebc52),
            (0, $6799e9dd8b372fc2$export$e275b3ca0c6ccb5e),
            (0, $6799e9dd8b372fc2$export$cef770e7c16cfcc),
            (0, $8b91974ef292d61a$export$703b5090da478c9c),
            (0, $5c10d3561f01a6f7$export$415552b116808717),
            (0, $056174761f438866$export$578dcb61ac3cb57a),
            (0, $06085f80d69fe841$export$76b74d5744e69817),
            (0, $f8b2ddb194f05043$export$5379c026da4201e6),
            (0, $5e597886ba168534$export$2740cfaa979353b9),
            (0, $b6b724158556afe3$export$ae258fb8ec2c1f86),
            (0, $7f2f7b5455866fc1$export$219b6cc00b2f91a0),
            (0, $c7ed25d526b7ed1b$export$8ea64bac0a832a5c),
            (0, $2c9e65dfb42014f0$export$4df9f9dcaf8565c9),
            (0, $dc548005383aa0ca$export$27d1f352c2f7acae),
            (0, $e0db3e001ba4740c$export$dc5f9e3c3931cc36),
            (0, $66b2e7de35cd3e39$export$8d9d65bb59f2354e),
            (0, $8f20c76692c396ce$export$78ff5b5f42b9de4),
            (0, $00e4719282b1ae8b$export$79292a834772288c),
            (0, $b468f39f7a3e39f4$export$c3c347e60b82f074),
            (0, $e28e6d3f170e3052$export$d5b1a46987369ee4),
            (0, $e677bebc1d8715eb$export$3f6ec3224d4c9da),
            (0, $72a8f02a914333fc$export$47b3bdf88a7d176b),
            (0, $72c99d901431c503$export$5b0670f37204a43d),
            (0, $4b7fc303ce7a2a17$export$b498607b4440c4ef),
            (0, $97d73743db912d34$export$e60f53ff5ae626cd),
            (0, $ad71816b701c4a98$export$72497f4e39dd0df4),
            (0, $3890e3ec7715d603$export$982bc443ef89cc3f),
            (0, $7e202110676952db$export$28887e2da22c839a),
            (0, $1aa15c245eff2860$export$4791201b4877aa5d),
            (0, $5b3bb769f5acfa20$export$5788c5f8c4e440b1),
            (0, $ec177ab479977ba2$export$babf32528ef518e9),
            (0, $024c87aebde011e4$export$95ed5e2f774d3f79),
            (0, $d33ce51d8c4b9036$export$f128c1c4a1f0d631),
            (0, $d33ce51d8c4b9036$export$924db6cf10ba8696),
            (0, $ff9c4f8f4f936d52$export$9b0fdfd6a51a17de),
            (0, $ae18a94b5423e69e$export$6009dd8e88f1a7de),
            (0, $c891244b3388b2f7$export$18226b6422149926),
            (0, $67a8397fa114200d$export$73a377380ff671af),
            (0, $3848740eee1bab7b$export$8dae8091f8e43b97),
            (0, $bc6135fca4882261$export$748e329bd0c282a),
            (0, $819db157557bdd41$export$2a34d21ecf479c40),
            (0, $bb811a13740c7cf1$export$e78b34c999194638),
            (0, $03e59a293d347a10$export$41fb3f2a3e68c7c3),
            (0, $3947322b61fcc480$export$ca77bc660994f51f),
            (0, $d55bc420bfc42a32$export$c2ec350ee9e78717),
            ...(0, $5daf430235f9fc0a$export$d604d3ad2662a845),
            (0, $e27fdc04f14a6641$export$36a7c374f4474cc1),
            (0, $d306aa8b938adbc6$export$8e015e39dbc90d0b),
            (0, $2934b1049cdc0b54$export$b9921058a8a65710),
            (0, $2d67b465f26d4e76$export$eabcbe4dd6fc9f1f),
            (0, $5f2b7d10b2a973db$export$dbcd0bd16f12397d),
            (0, $a36cb3f650c3074c$export$b6bba25826e621b9),
            (0, $13d9e6b7582fbfc8$export$a26fa5cabff8bc7c),
            (0, $38c9ffd9e7c2e0a9$export$f7abc47036ff7dd9),
            (0, $8b3a43559c4bd90e$export$d83c2e469d070766),
            (0, (0, parcelRequire("427L2")).globalSettingsIssuesExplicitFieldAssociationRouteEntry),
            (0, $89fe0e9a025a7c8e$export$c68a412f25295511),
            (0, $360b9bb3a5e4b35a$export$d1c67ceb7c5e2d6a),
            (0, $c72266bbdc090734$export$56f9921db324f30),
            (0, $7846fd35a7cb282e$export$f9891419b34ab305),
            (0, $1733bfec88a8a7ea$export$2f65b1ec4ed05f91),
            (0, $ebdca188f3705262$export$c62ca2d3fcc552a5),
            (0, $5dc17715cd6fddea$export$34d843946d3894aa),
            (0, $d5f0f03722be4af7$export$f7b6cda88404733e),
            (0, $774aaf4ac519071a$export$461f2b06a7a914db),
            (0, $174710657e8d90a3$export$9cc9423a3967333b),
            (0, $b6759abef36b3efc$export$717e134eb971b450),
            (0, $b3d6f3f852ae8387$export$3f8d7424a47f4dd),
            (0, $82450f458637cd82$export$42ca979ec2919b23),
            (0, $aca15c3cadc5a7fe$export$d2ce6f09ef8aa840),
            (0, $e19c93c774607b0f$export$e18a6be3d2ffad71),
            (0, $fc43fd37745c00e2$export$5e1236665a530df4),
            (0, $954e97d3acac763c$export$773f8e3318be1dd5),
            (0, $ff94c4ea1a42404b$export$80a3e4dda2dcd1a4),
            ...(0, $6b03ae00f6427f42$export$b4944bd787708b82),
            (0, $83811b47cb2e3e0c$export$45e68d450757a753),
            (0, $4fedf6a5f46c9101$export$ac09a8d3ecbafc5),
            (0, $1603466baea9815f$export$9fbbaafb58999ac3),
            (0, $29daafdf917937bc$export$15f76f1b0d2d671),
            (0, $98e5774d92d39cbd$export$70386609aff5ba12),
            (0, $3678ca52b1bdf235$export$804f2d81dfbdd5c9),
            (0, $f2c5f02fe8472718$export$6786257309f86d8c),
            (0, $99f00cddc0758136$export$9f80102c0f64ad9b),
            (0, $c52f49db3f216f46$export$4e97658a5cc15eaa),
            (0, $75e3fe7119ee0518$export$949c8177281fcc39),
            (0, $e45e5c76e61613b2$export$309ed92381819b04),
            (0, $b6a501a17ba8d16b$export$2506a377ba649c46),
            (0, $ddc531e0f3e9c8bc$export$3feed0b4da010c52),
            (0, $6fb04257162ebb90$export$bdc2c75e02c29d7),
            (0, $f243e346f149e756$export$a977d398db1904ff),
            (0, $35d5ce46f5d8e5a8$export$103062f08086fba0),
            (0, $e2353036f7312b49$export$4bc10767887a84cc),
            (0, $4711dd8590f23118$export$67c64fea9be584ed),
            (0, $4095f2c0ec8f50cf$export$b874fabd66f10ff4),
            (0, $970ae3ae6d33a9e3$export$c5b46ecd4d9a8abd),
            (0, $d78d9c80df28a675$export$1afc7a9efa99340),
            (0, $cbe1aa5484552af9$export$64d5b46da2e58194),
            (0, $d7dc38a99726fee2$export$1d6300da0c837e02),
            (0, $6183d6997fcdbcf0$export$be96222796ad98f0),
            (0, $cf0e25b45377825b$export$c1319dec79812860),
            (0, $9368211e7352bb42$export$9b6e6b5d471b90f),
            (0, $78ac61c21ed5f382$export$fc7007717398c727),
            (0, $e3235a40cee1f9ea$export$89472d9db6946668),
            (0, $8d454372873657bb$export$cd1b612d0c014154),
            (0, $c2b7559ef928e7c4$export$f0b7e9788ab79be0),
            (0, $e49a66463b867d46$export$2f975c505121e139),
            (0, $304853a89d046ccf$export$53a9ea0e0b05ceb5),
            (0, $ed7f2a4db7ff0a01$export$cc5b7d3f8546a313),
            (0, $c59b8ec61d58752b$export$4652a26319dca4d0),
            (0, $3d84c56e2a698202$export$2a24acea4e628148),
            (0, $e17ef7a70aea4a64$export$d751e3552b21c604),
            (0, $877bd5b2a7f04d5c$export$f85a75f1604118ff),
            (0, $c926071780746d94$export$9cbef73b51558ef),
            (0, $10eae15c25a3521c$export$e9cfdb950d40e917),
            (0, $7a323ef2c1a2c74a$export$e71031acce6d7e47),
            (0, $be1254c729965d54$export$c2a4c5c6576a704c),
            (0, $d1aaabcb7e27c9a6$export$4f9df77811fbdc1f),
            (0, $8a8ca7bd84166494$export$831e8756cdaae4ba),
            (0, $0edb022327e9a2a9$export$851a659e50436cff),
            (0, $ffa726838ac9512f$export$bcb93d8198d511b9),
            (0, $f23486e21e430737$export$de37dab3b3ed8e5c),
            (0, $0f8c358fa6dbfa33$export$94aaa7006da9d63a),
            (0, $08aebbbf84aea52e$export$66928ab349190059),
            (0, $7742cad3c3e8631c$export$2b25520e20820251),
            (0, $fec308ab1c0618bc$export$60de9875bb8ef1d6),
            (0, $29aaea7e1c593cdc$export$565325825b04cec6),
            (0, $06d17d7f82b9f72c$export$bf8ccc758901febd),
            (0, $91ad9944e0af1355$export$39f40714591c98c0),
            (0, $10f9f9ad449ec307$export$c058f4d1c0667ce1),
            (0, $97fc56f25f58996b$export$ded9494f81dd2a4d),
            (0, $d817aeb7fccbfd68$export$52ee366e7b51f38d),
            (0, $46e74e6464e445dd$export$83aea99d18750f08),
            (0, $cd5c132b5b5151e0$export$7e0b6b79953422c1),
            (0, $77c62c16bb189e65$export$d5e169223d2a5d1d),
            (0, $42b9c62ef769e46b$export$6e5cd6656076550f),
            (0, $ed52be46c53ae197$export$790602da39f8af00),
            (0, $675ac2c2cf4991e7$export$62eef9a2917f041f),
            (0, $127c0a8b66d1f657$export$b66abbccbf93e9ad),
            (0, $6535404a8c018f23$export$d30f51d0f351bd8a),
            (0, $1722f4808fc919d6$export$eb1e2324ca2031e2),
            (0, $26e6da78b3e43e9c$export$2ee2f43d380cc210),
            (0, $6214dd8c4ed95f14$export$adde4536d8e5f94c),
            (0, $df54ba0aea7ee8de$export$f1a859c727c30be4),
            (0, $da84e8a7a2986788$export$842d7c81068bb64e),
            (0, $b7a7f1ceb2ac2c2a$export$2c2d6115c4280a08),
            (0, $e4663459434822fe$export$e9c59d0d6bfec8a3),
            (0, $e5934255c94fc385$export$ce2a5648c28a5b48),
            (0, $3f27e199fbc412b1$export$ac245212b12db871),
            (0, $c7dfe385c3b79acf$export$8657ca08ca5cbfc6),
            (0, $b83a8bf24279056f$export$fee33ca9661e49dd),
            (0, $b9f5341ba0d7de14$export$c2ced436a30c60dc),
            (0, $dd0ff3cccea414a4$export$6ff606556e19e12),
            (0, $4357b8f4ed10df63$export$be342a3401146aae),
            (0, $529c88752df4ac9c$export$8c07dc381591dc69),
            (0, $a162d438dc34f2e2$export$6298ff494c460e75),
            (0, $4abc338af93c95e0$export$c63d0942ec0f93c),
            (0, $1afcecac57b51b7c$export$92f4b6644eb6cb88),
            (0, $ea4b5ca423fc7b5e$export$7e604b22ae6e7c1e),
            (0, $8d76deaec1999545$export$c5606e8eeca32c0f),
            (0, $a7106536ac902eff$export$6e8d112a548528b5),
            (0, $d53f4be60f857b27$export$193586b163d4afae),
            (0, $1fb5a93b84172f00$export$90a73fe101848dd),
            (0, $7f20eb6c54fad956$export$cd1c1a81e516fec5),
            (0, $98b5efb8026932b2$export$9c9bab95d425eb6f),
            (0, $34e2a1a3b5a525df$export$c51a4ee3e3f1b270),
            (0, $61761389ad3b32bd$export$6a7fc41fb2523290),
            (0, $5f3f997c6af1c603$export$289cc03f2eacd57a),
            (0, $070da13ff0ee1dfd$export$8b55e723205ec5f3),
            (0, $0e32f5ae634ca894$export$d29dcad8c82ca10d),
            ...(0, $86244a2581bcbace$export$9e08a24be2acc3b6),
            (0, $292badf40134cb3e$export$beae48175e3016b8),
            (0, $083d2dc437d8c2ec$export$c4c012a49b465e94),
            (0, $cd382e3a47206865$export$faa46f8c5e1f06d3),
            ...(0, $39416b69d8da58fe$export$633933bacdaefead),
            (0, $929524b967f2ea63$export$2af76482b576a135),
            (0, $c46fefae40525649$export$27f123cb9320355)
        ];
    const $26bc22beafcfd5a4$var$routes = $26bc22beafcfd5a4$export$d47aca795954578();
    const $26bc22beafcfd5a4$export$2f7745f2f5ab3897 = ()=>{
        return $26bc22beafcfd5a4$var$routes;
    };
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $fr1K2 = parcelRequire("fr1K2");
    var $3NMrl = parcelRequire("3NMrl");
    var $kUr4d = parcelRequire("kUr4d");
    function $96da41f3532a466b$export$2e2bcd8739ae039(route) {
        if (route.ufoName != null) return route.ufoName;
        return route.name;
    }
    function $b76912b89d3451e2$export$aee7516e57289027(document, window) {
        const ssrPlaceholders = document?.querySelectorAll('[data-ssr-placeholder]');
        ssrPlaceholders.forEach((elem)=>{
            const placeholderId = elem.getAttribute('data-ssr-placeholder');
            const boundingClient = elem.getBoundingClientRect();
            if (placeholderId) {
                window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
                window.__SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId] = boundingClient;
            }
        });
    }
    var $0z6W8;
    var $1ciso;
    var $a0hd6;
    var $21pfT;
    var $kuiU5;
    var $hh0bW;
    var $jpY8v;
    var $4Pf62;
    var $jcw0u;
    var $8ApFP;
    const $6a69127f0604feb0$export$649804097de83b3b = [
        {
            browser: 'Chrome',
            browserVersion: '116.0.0',
            errorMessage: /Cannot read properties of undefined \(reading 'target'\)/
        }
    ];
    const $6a69127f0604feb0$var$checkBrowserCondition = (error, filterCriteria)=>filterCriteria.browser != null ? (0, (0, parcelRequire("jpY8v")).getBrowser)().name === filterCriteria.browser : true;
    const $6a69127f0604feb0$var$checkBrowserVersionCondition = (error, filterCriteria)=>filterCriteria.browserVersion != null ? (0, (0, parcelRequire("jpY8v")).getBrowser)().version === filterCriteria.browserVersion : true;
    const $6a69127f0604feb0$var$checkErrorMessageCondition = (error, filterCriteria)=>filterCriteria.errorMessage != null ? error.message.match(filterCriteria.errorMessage) : true;
    const $6a69127f0604feb0$export$a66ce4bea8340820 = (error, errorFilteringCriterias)=>{
        try {
            const conditionCheckers = [
                $6a69127f0604feb0$var$checkBrowserCondition,
                $6a69127f0604feb0$var$checkBrowserVersionCondition,
                $6a69127f0604feb0$var$checkErrorMessageCondition
            ];
            return !errorFilteringCriterias.some((filterCriteria)=>conditionCheckers.every((conditionChecker)=>conditionChecker(error, filterCriteria)));
        } catch (e) {
            return true;
        }
    };
    const $6a69127f0604feb0$export$a5c16644a2d3c205 = async (error)=>{
        const tenantContextData = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        (0, (0, parcelRequire("kuiU5")).default)(tenantContextData);
        if ($6a69127f0604feb0$export$a66ce4bea8340820(error, $6a69127f0604feb0$export$649804097de83b3b)) (0, (0, parcelRequire("hh0bW")).default)({
            analyticsSource: (0, $9ccbd88c704da1ef$export$c9e16a15d65437),
            experience: (0, $9ccbd88c704da1ef$export$b1534bc11f201efd),
            wasExperienceSuccesful: false,
            location: (0, $9ccbd88c704da1ef$export$7dfef0177e883b05),
            application: (0, $9ccbd88c704da1ef$export$aa6008fe0169b864),
            edition: (0, $9ccbd88c704da1ef$export$39418a21fbb51487),
            additionalAttributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        });
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                packageName: 'jiraBootstrapSlaReporter',
                id: 'bootstrap-failure',
                teamName: 'magma'
            },
            error: error,
            attributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        });
        throw error;
    };
    var $aTq2A;
    var $87OsA;
    parcelRequire("2YzDH");
    var $x9xyg;
    var $4Pf62;
    var $frBVt;
    var $7CMCs;
    var $6s1PB;
    var $7bkFJ;
    var $4R6GH;
    var $fz3fB;
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $2SVPM;
    var $erCTW;
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $7XYc4;
    var $5uXOq = parcelRequire("5uXOq");
    var $44v1T;
    const $cf8c915f080efbd8$export$2fcd4100c556a49e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `[data-ds--page-layout--slot="main"] { height: calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)}) }`
            }
        });
    var $3HwlS;
    var $iqLcb;
    var $3Uek9;
    var $gk293;
    var $5M3R9;
    var $5uXOq = parcelRequire("5uXOq");
    var $jD5no;
    var $gAeCk;
    var $2SVPM;
    var $5uXOq = parcelRequire("5uXOq");
    var $fq71H;
    var $8Orxo = parcelRequire("8Orxo");
    var $1u4q7;
    var $bFU4G;
    var $9AgLs;
    function $11585d48f7363869$export$2e2bcd8739ae039(fromUfoName, nextUfoName, nextRouteName, time) {
        (0, (0, parcelRequire("9AgLs")).default).current = nextUfoName;
        const interactionId = (0, (0, parcelRequire("1u4q7")).DefaultInteractionID).current;
        if (interactionId) (0, (0, parcelRequire("bFU4G")).addRedirect)(interactionId, fromUfoName, nextUfoName, nextRouteName, time);
    }
    var $x9xyg;
    var $dJl1T;
    var $7CMCs;
    var $4R6GH;
    var $8zOmE;
    var $2NMNM;
    var $2SVPM;
    var $4oDnX;
    var $ajpes = parcelRequire("ajpes");
    var $65Ltd;
    var $vrkiK;
    const $f43999df472d4d05$var$isReplaceActionAndPIN = (action, route)=>action === 'REPLACE' && route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR);
    const $f43999df472d4d05$export$ffb8c03de895ae3 = ()=>{
        let rapidBoardPaths = [];
        return ({ currentMatch: currentMatch, currentRoute: currentRoute, nextMatch: nextMatch, nextRoute: nextRoute, action: action })=>{
            let shouldReset = true;
            if ($f43999df472d4d05$var$isReplaceActionAndPIN(action, nextRoute) || currentRoute.isRedirect === true) shouldReset = false;
            else {
                const cleanMatch = (0, (0, parcelRequire("vrkiK")).getApdexMatchObject)(currentMatch, currentRoute);
                const cleanNextMatch = (0, (0, parcelRequire("vrkiK")).getApdexMatchObject)(nextMatch, nextRoute);
                shouldReset = !(0, ($parcel$interopDefault($ajpes)))(cleanMatch, cleanNextMatch) && shouldReset;
                if (shouldReset) {
                    const [paths, resetBoolean] = (0, (0, parcelRequire("vrkiK")).calcRapidBoardResetStateV2)(rapidBoardPaths, nextRoute.name, !!nextMatch.query.useStoredSettings);
                    rapidBoardPaths = paths;
                    if ((0, (0, parcelRequire("vrkiK")).isValidRoute)(nextRoute) || nextRoute.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE)) shouldReset = !resetBoolean;
                }
            }
            return shouldReset;
        };
    };
    var $imS60;
    var $lODMY;
    var $2Gs5h;
    var $lVJAU;
    var $gF0M5;
    var $5uXOq = parcelRequire("5uXOq");
    var $5dFS4;
    const $ff247fc2f5e84e0a$export$f2b2f5ef0b498d26 = 5000;
    const $ff247fc2f5e84e0a$export$f2c0b74311ada874 = 3;
    const $ff247fc2f5e84e0a$export$af2ff676951003fe = 60000;
    const $ff247fc2f5e84e0a$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';
    const $e970b58804722f10$export$50dbcb44bba3aa5c = 60;
    const $e970b58804722f10$export$b21f5a6e7051e2c2 = (actionMetas)=>{
        const now = Date.now();
        const timeDiff = now - actionMetas.lastPerformAttemptedAt;
        return timeDiff > $e970b58804722f10$export$50dbcb44bba3aa5c * 1000;
    };
    const $e970b58804722f10$export$6c7cf2cb7d75fad3 = (actionMetas)=>actionMetas.attemptCounts < (0, $ff247fc2f5e84e0a$export$f2c0b74311ada874);
    const $e970b58804722f10$export$6e0db227c9674096 = (action, metas)=>{
        const actionMetas = metas[action.id];
        if (!actionMetas) return true;
        if (!$e970b58804722f10$export$6c7cf2cb7d75fad3(actionMetas)) return false;
        if (!$e970b58804722f10$export$b21f5a6e7051e2c2(actionMetas)) return false;
        return true;
    };
    const $16f1e09eb0055102$export$1bfa74483a8ca772 = ({ actionName: actionName })=>{
        const metas = (0, (0, parcelRequire("5dFS4")).useMeta)();
        const remoteActions = (0, (0, parcelRequire("5dFS4")).useRemoteActionsData)();
        const { saveActionPerformedAttempt: saveActionPerformedAttempt } = (0, (0, parcelRequire("5dFS4")).useRemoteActionsStoreActions)();
        const [actionToPerform, setActionToPerform] = (0, $5uXOq.useState)();
        const [shouldPerformAction, setShouldPerformAction] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            const matchedAction = Object.values(remoteActions).find((action)=>{
                if (action.name !== actionName) return false;
                return true;
            });
            if (!matchedAction) return;
            setActionToPerform(matchedAction);
            setShouldPerformAction((0, $e970b58804722f10$export$6e0db227c9674096)(matchedAction, metas));
        }, [
            actionName,
            remoteActions,
            metas
        ]);
        const performAction = (onSuccess, onCancel)=>{
            if (!actionToPerform) return;
            const metaForAnalytics = {
                attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
                lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
            };
            if (shouldPerformAction) onSuccess(actionToPerform, metaForAnalytics);
            else onCancel(actionToPerform, metaForAnalytics);
            saveActionPerformedAttempt(actionToPerform.id);
            setShouldPerformAction(false);
        };
        return {
            shouldPerformAction: shouldPerformAction,
            performAction: performAction
        };
    };
    var $1AZST;
    var $ajpes = parcelRequire("ajpes");
    const $c27c60eec62bb2f2$var$transitionValidator = (currentMatch, nextMatch)=>{
        if (!currentMatch) return true;
        if (!nextMatch) return false;
        const isSameRoute = currentMatch.route === nextMatch.route;
        const isSameMatch = (0, ($parcel$interopDefault($ajpes)))(currentMatch.match, nextMatch.match);
        if (isSameRoute && isSameMatch) return true;
        const canDoNext = nextMatch.route.canTransitionIn?.(currentMatch, nextMatch) ?? true;
        if (canDoNext) return true;
        return false;
    };
    var $c27c60eec62bb2f2$export$2e2bcd8739ae039 = $c27c60eec62bb2f2$var$transitionValidator;
    var $5uXOq = parcelRequire("5uXOq");
    var $kUr4d = parcelRequire("kUr4d");
    var $jsLXn;
    var $4R6GH;
    var $lODMY;
    var $5uXOq = parcelRequire("5uXOq");
    function $3f6cbe094065dc4a$export$e7a8408a6ddec2cb(props) {
        const { consoleMessage: consoleMessage = 'This route is being rendered with React concurrent rendering go/r18' } = props;
        const [isAdvisoryVisible, setIsAdvisoryVisible] = (0, $5uXOq.useState)(true);
        (0, $5uXOq.useEffect)(()=>{
            console.log(`%c\u{203C}\u{FE0F} ${consoleMessage} \u{203C}\u{FE0F}
If you encounter any problems, report them to https://atlassian.enterprise.slack.com/archives/C06176WU6PQ`, 'color: white; background: darkred; font-size: 16px; padding: 4px');
            const timer = setTimeout(()=>{
                setIsAdvisoryVisible(false);
            }, 5000);
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            consoleMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                position: 'absolute',
                left: 8,
                top: 12,
                display: 'flex',
                alignItems: 'center',
                height: 0,
                overflow: 'visible',
                pointerEvents: 'none'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                backgroundColor: isAdvisoryVisible ? 'white' : 'red',
                borderRadius: '50%',
                width: 8,
                height: 8,
                zIndex: 20
            }
        }), isAdvisoryVisible && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                backgroundColor: 'red',
                color: 'white',
                height: '1.5em',
                marginLeft: -12,
                paddingLeft: 16,
                paddingRight: 8,
                borderRadius: 4,
                zIndex: 10
            }
        }, "Rendered in React concurrent mode go/r18"));
    }
    const $1fd1d5f168f244bb$var$useRouterLocation = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.location);
    const $1fd1d5f168f244bb$var$useRouterAction = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.action);
    const $1fd1d5f168f244bb$var$useRouterQuery = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.query);
    const $1fd1d5f168f244bb$var$useRouterRoute = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.route);
    const $1fd1d5f168f244bb$var$useRouterMatch = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.match);
    const $1fd1d5f168f244bb$var$RouteComponentWithRouterProps = ()=>{
        const location = $1fd1d5f168f244bb$var$useRouterLocation();
        const action = $1fd1d5f168f244bb$var$useRouterAction();
        const query = $1fd1d5f168f244bb$var$useRouterQuery();
        const route = $1fd1d5f168f244bb$var$useRouterRoute();
        const match = $1fd1d5f168f244bb$var$useRouterMatch();
        const { component: RouteComponent } = route;
        return RouteComponent && (0, ($parcel$interopDefault($5uXOq))).createElement(RouteComponent, {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        });
    };
    function $1fd1d5f168f244bb$export$3224d596e9b1971() {
        const containerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!containerRef.current) throw new Error('ref is not set');
            const root = (0, $kUr4d.createRoot)(containerRef.current);
            root.render((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jsLXn")).JiraContextContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($1fd1d5f168f244bb$var$RouteComponentWithRouterProps, null), (0, (0, parcelRequire("4R6GH")).fg)('concurrent-rendering-change-advisory') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3f6cbe094065dc4a$export$e7a8408a6ddec2cb), null) : null));
            return ()=>{
                setTimeout(()=>{
                    root.unmount();
                });
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: "concurrent-route-component",
            ref: containerRef
        });
    }
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $dJl1T;
    var $2Ioew;
    var $frBVt;
    var $7LpuY;
    var $dZw8H;
    const $813341ccf863a0ac$var$LOCATION = 'route-entry-point-container';
    const $813341ccf863a0ac$export$fb85bbdbfb3e6869 = ()=>null;
    const $813341ccf863a0ac$export$3e4cdfb894377bc9 = ({ location: location, route: route, match: match, action: action, query: query })=>{
        const entryPoint = (0, $5uXOq.useMemo)(()=>route.entryPoint?.(), [
            route
        ]);
        const entryPointReference = (0, (0, parcelRequire("2Ioew")).usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48));
        const Skeleton = route.skeleton || $813341ccf863a0ac$export$fb85bbdbfb3e6869;
        (0, $5uXOq.useEffect)(()=>{
            if (route.isRedirect) (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData($813341ccf863a0ac$var$LOCATION, `EntryPoint was used inside a redirect component: ${route.name}`);
        }, [
            route.isRedirect,
            route.name
        ]);
        if (!entryPointReference || !entryPoint) return null;
        let pageId = route.name;
        if (route.pageId) {
            if (typeof route.pageId === 'function') pageId = route.pageId({
                route: route,
                action: action,
                location: location,
                match: match,
                query: query
            });
            else pageId = route.pageId;
        }
        return route.isRedirect ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholder), {
            entryPoint: entryPoint,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null),
            name: "route_entry_point_redirect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: entryPointReference,
            props: {}
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7LpuY")).default), {
            pageId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateContainer), {
            isGlobal: true,
            appId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateAppStartWithMatchCheck), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholder), {
            entryPoint: entryPoint,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null),
            name: "route_entry_point"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: entryPointReference,
            props: {}
        }))));
    };
    const $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF = 'OFF';
    const $308f7fd68513e9ff$var$REMOTE_ACTIONS_PERFORM = 'PERFORM';
    const $308f7fd68513e9ff$var$useRouterLocation = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.location);
    const $308f7fd68513e9ff$var$useRouterAction = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.action);
    const $308f7fd68513e9ff$var$useRouterQuery = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.query);
    const $308f7fd68513e9ff$var$useRouterRoute = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.route);
    const $308f7fd68513e9ff$var$useRouterMatch = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.match);
    const $308f7fd68513e9ff$var$useRouterRoutes = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.routes);
    let $308f7fd68513e9ff$var$hasPendingForceReloadAction = false;
    const $308f7fd68513e9ff$var$getRemoteActionsRolloutStage = ()=>(0, (0, parcelRequire("4R6GH")).fg)('remote_actions_-_killswitch_-_temporary') ? $308f7fd68513e9ff$var$REMOTE_ACTIONS_PERFORM : $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF;
    const $308f7fd68513e9ff$export$88fe66870dd8f843 = (value)=>{
        $308f7fd68513e9ff$var$hasPendingForceReloadAction = value;
    };
    const $308f7fd68513e9ff$export$39e8f9fc07dd3395 = ()=>$308f7fd68513e9ff$var$hasPendingForceReloadAction;
    const $308f7fd68513e9ff$var$fireRemoteActionAnalytics = (analyticsEvent, eventAction, remoteAction, currentRoute, targetRoute, attempts, lastAttemptedAt)=>(0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
            source: 'transitionBlocker',
            actionId: remoteAction != null && remoteAction.id != null ? String(remoteAction.id) : '',
            frontendVersion: window.BUILD_KEY,
            currentRouteName: currentRoute?.route.name || '',
            targetRouteName: targetRoute?.route.name || '',
            remoteActionsRolloutStage: $308f7fd68513e9ff$var$getRemoteActionsRolloutStage(),
            attempts: attempts,
            lastAttemptedAt: lastAttemptedAt
        });
    const $308f7fd68513e9ff$var$updateSentryBreadcrumb = (route, nextRoute)=>{
        const from = route.path + (route.query ? `?${route.query.join('&')}` : '');
        const to = nextRoute?.path + (nextRoute?.query ? `?${nextRoute.query.join('&')}` : '');
        (0, (0, parcelRequire("fq71H")).addBreadcrumb)({
            type: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
    const $308f7fd68513e9ff$var$Spa = ({ routes: routes, initRoute: initRoute = null })=>{
        (0, $5uXOq.useMemo)(()=>{
            (0, (0, parcelRequire("x9xyg")).setMark)('jira-spa/view.start');
        }, []);
        const checkShouldResetPage = (0, $5uXOq.useMemo)(()=>(0, $f43999df472d4d05$export$ffb8c03de895ae3)(), []);
        const currentMatchObjectRef = (0, $5uXOq.useRef)(initRoute);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
        }, []);
        const { registerBlock: registerBlock } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const location = $308f7fd68513e9ff$var$useRouterLocation();
        const action = $308f7fd68513e9ff$var$useRouterAction();
        const query = $308f7fd68513e9ff$var$useRouterQuery();
        const route = $308f7fd68513e9ff$var$useRouterRoute();
        const match = $308f7fd68513e9ff$var$useRouterMatch();
        const routerRoutes = $308f7fd68513e9ff$var$useRouterRoutes();
        if ((0, (0, parcelRequire("gF0M5")).isLazyRouteMapExperimentEnabled)()) routes = routerRoutes;
        const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, $16f1e09eb0055102$export$1bfa74483a8ca772)({
            actionName: 'forceReload'
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        if (route.isRedirect !== true) currentMatchObjectRef.current = {
            route: route,
            match: match
        };
        const [, { resetCurrentPage: resetCurrentPage }] = (0, (0, parcelRequire("4oDnX")).useSpaStateActions)();
        const transitionBlocker = (0, $5uXOq.useCallback)(async (nextLocation, nextAction)=>{
            const nextMatch = (0, (0, parcelRequire("2Gs5h")).default)(routes, nextLocation.pathname, nextLocation.search);
            const canDo = (0, $c27c60eec62bb2f2$export$2e2bcd8739ae039)(currentMatchObjectRef.current, nextMatch);
            if ((0, (0, parcelRequire("gF0M5")).isLazyRouteMapExperimentEnabled)()) {
                if (!canDo && routes.length <= 3) await (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
                    route: nextMatch?.route.name
                });
            }
            if (!canDo) {
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
            }
            const remoteActionsRolloutStage = $308f7fd68513e9ff$var$getRemoteActionsRolloutStage();
            if (remoteActionsRolloutStage !== $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
                const currentMatch = currentMatchObjectRef.current;
                if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $308f7fd68513e9ff$var$hasPendingForceReloadAction === false) {
                    $308f7fd68513e9ff$var$hasPendingForceReloadAction = true;
                    const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                    performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                        $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                        window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
                    }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                        $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    });
                }
            }
            return canDo;
        }, [
            performAction,
            routes,
            shouldPerformAction,
            createAnalyticsEvent
        ]);
        const resetCurrentPageBeforeRouteChangeBlocker = (0, $5uXOq.useCallback)((nextLocation, nextAction)=>{
            const nextMatchObject = (0, (0, parcelRequire("2Gs5h")).default)(routes, nextLocation.pathname, nextLocation.search);
            if (nextMatchObject && match && route) {
                const { match: nextMatch, route: nextRoute } = nextMatchObject;
                const shouldReset = checkShouldResetPage({
                    nextMatch: nextMatch,
                    nextRoute: nextRoute,
                    currentMatch: match,
                    currentRoute: route,
                    action: nextAction
                });
                const nextRouteUfoName = (0, $96da41f3532a466b$export$2e2bcd8739ae039)(nextRoute);
                if (shouldReset) {
                    resetCurrentPage(nextRouteUfoName, nextRoute.name);
                    (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
                }
                const isCurrentRouteRedirecting = route.isRedirect === true;
                if (isCurrentRouteRedirecting) {
                    const currentRouteName = (0, $96da41f3532a466b$export$2e2bcd8739ae039)(route);
                    (0, $11585d48f7363869$export$2e2bcd8739ae039)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
                }
            }
            $308f7fd68513e9ff$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
            return true;
        }, [
            checkShouldResetPage,
            match,
            resetCurrentPage,
            route,
            routes
        ]);
        registerBlock(transitionBlocker);
        registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
        const renderRouteComponent = (0, $5uXOq.useCallback)(()=>{
            const { component: RouteComponent, shouldOptOutConcurrentMode: shouldOptOutConcurrentMode } = route;
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira-concurrent-incremental')) {
                if (!shouldOptOutConcurrentMode) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $1fd1d5f168f244bb$export$3224d596e9b1971), null);
            }
            return RouteComponent && (0, ($parcel$interopDefault($5uXOq))).createElement(RouteComponent, {
                location: location,
                route: route,
                match: match,
                action: action,
                query: query
            });
        }, [
            action,
            location,
            match,
            query,
            route
        ]);
        if (!(route && match)) return null;
        const { meta: meta } = route;
        const entryPoint = route.entryPoint?.();
        const { reporting: reporting } = meta || {};
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
            name: "route-component"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: `routeApp.${String(route.name)}`,
            packageName: "jiraSpa",
            extraEventData: {
                routeGroup: route.group ?? '',
                isSSR: false
            },
            fallback: "page",
            sendToPrivacyUnsafeSplunk: Boolean(reporting),
            ...reporting
        }, entryPoint ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $813341ccf863a0ac$export$3e4cdfb894377bc9), {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        }) : renderRouteComponent()));
    };
    var $308f7fd68513e9ff$export$2e2bcd8739ae039 = $308f7fd68513e9ff$var$Spa;
    const $1f1817a083d388c8$var$onSpaShellReady = ()=>{
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/spa-shell/core', '_jira-spa/spa-shell.start', 'JIRA_SPA_SHELL_READY');
    };
    const $1f1817a083d388c8$var$Spa = ({ initRoute: initRoute = null, routes: routes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            hasErrorBoundary: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: "JIRA_SPA_SHELL_READY",
            onSet: $1f1817a083d388c8$var$onSpaShellReady
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $308f7fd68513e9ff$export$2e2bcd8739ae039), {
            initRoute: initRoute,
            routes: routes
        }));
    var $1f1817a083d388c8$export$2e2bcd8739ae039 = $1f1817a083d388c8$var$Spa;
    var $erBFB;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $571ff4fe4ca2a221$export$712225703044cda = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1bgi _2d3f16n6 _iu1g1fl4",
                __cmplp.className
            ])
        });
    });
    const $780b11bdb912365c$var$SPA_TRACE_KEY = 'spa';
    const $780b11bdb912365c$var$NewContent = (props)=>{
        const { isInset: isInset, hasTheming: hasTheming } = (0, (0, parcelRequire("3Uek9")).useProjectTheme)();
        const renderContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "mainContentSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).MainContentSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
            type: "start"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $1f1817a083d388c8$export$2e2bcd8739ae039), props), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
            type: "end"
        }));
        if (hasTheming) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gk293")).ThemedContentLayout), {
            appearance: isInset ? 'inset' : 'default'
        }, renderContent);
        return renderContent;
    };
    const $780b11bdb912365c$var$OldContent = (props)=>{
        const { isInset: isInset, hasProjectViewNavigation: hasProjectViewNavigation } = (0, (0, parcelRequire("3Uek9")).useProjectTheme)();
        const renderContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cf8c915f080efbd8$export$2fcd4100c556a49e), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "mainContentSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).MainContentSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Main), {
            id: "ak-main-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
            type: "start"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $1f1817a083d388c8$export$2e2bcd8739ae039), props), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
            type: "end"
        })));
        if (hasProjectViewNavigation) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gk293")).ProjectThemeWrapper), {
            withWhiteBackground: isInset
        }, renderContent);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $571ff4fe4ca2a221$export$712225703044cda), null, renderContent);
    };
    const $780b11bdb912365c$export$7c6e2c02157bb7d2 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $780b11bdb912365c$var$NewContent, $780b11bdb912365c$var$OldContent);
    const $454974e68bcf078d$export$6d4069f4b64f7492 = ({ baseUrl: baseUrl, locale: locale, messages: messages, isPrewarming: isPrewarming = false, Router: Router, routes: routes, routerLinkComponent: routerLinkComponent, initRoute: initRoute })=>{
        const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$21473105c510aacc), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), (0, $9ccbd88c704da1ef$export$7114284ca03133ee), true, true);
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erCTW")).PageContainer), {
            baseUrl: baseUrl,
            id: false ? 'jira.entry.ssr' : 'spa',
            locale: locale,
            messages: messages,
            Router: Router,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$7114284ca03133ee),
            onSet: pageContainerPerformanceTiming
        }), isPrewarming !== true && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $780b11bdb912365c$export$7c6e2c02157bb7d2), {
            initRoute: initRoute,
            routes: routes
        }));
    };
    var $cfDZ3;
    var $6jY6G;
    var $5eQ1m;
    var $81ezV;
    var $b7awD;
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $6vAaw = parcelRequire("6vAaw");
    var $gccSB = parcelRequire("gccSB");
    var $6YRTH;
    var $j8DrX;
    var $1bQGJ;
    var $TtQEC;
    const $751334a79f9a31ee$export$c9d44c736471c518 = (name)=>document.querySelector(`meta[name="${name}"]`);
    const $751334a79f9a31ee$var$getHead = ()=>document.head || document.querySelector('head');
    const $751334a79f9a31ee$export$c79fd820617d7f = (name, content)=>{
        if (!name || !content) return;
        const existingMeta = $751334a79f9a31ee$export$c9d44c736471c518(name);
        const meta = document.createElement('meta');
        meta.name = name;
        meta.content = content;
        if (existingMeta) existingMeta.parentNode?.replaceChild(existingMeta, meta);
        else {
            const head = $751334a79f9a31ee$var$getHead();
            if (head) head.appendChild(meta);
        }
    };
    const $751334a79f9a31ee$export$4267657a25105d9d = (name)=>{
        const meta = $751334a79f9a31ee$export$c9d44c736471c518(name);
        if (meta) meta.parentNode?.removeChild(meta);
    };
    var $5Jsi2;
    const $fffa056866f763fb$var$sessionQueryParams = [
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ];
    const $fffa056866f763fb$var$sessionMeta = [
        'ajs-search-session-id',
        'ajs-search-object-id',
        'ajs-search-container-id',
        'ajs-search-content-type'
    ];
    const $fffa056866f763fb$var$removeDwellComponent = (placeholderId)=>{
        if (placeholderId && document.getElementById(placeholderId)) (0, $7nsd3.unmountComponentAtNode)(document.getElementById(placeholderId));
    };
    const $fffa056866f763fb$var$removeSessionMeta = ()=>$fffa056866f763fb$var$sessionMeta.forEach((0, $751334a79f9a31ee$export$4267657a25105d9d));
    const $fffa056866f763fb$var$addSessionMeta = ({ sessionId: sessionId, objectId: objectId, containerId: containerId, objectType: objectType })=>{
        const newMeta = {
            'ajs-search-session-id': sessionId,
            'ajs-search-object-id': objectId,
            'ajs-search-container-id': containerId,
            'ajs-search-content-type': objectType
        };
        Object.entries(newMeta).forEach(([name, content])=>(0, $751334a79f9a31ee$export$c79fd820617d7f)(name, content));
    };
    const $fffa056866f763fb$var$getPreviousSessionId = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-search-session-id');
    class $fffa056866f763fb$export$f1e582dddb502dd6 extends (0, $5uXOq.Component) {
        constructor(props){
            super(props), this.onClearSessionEvent = ()=>{
                if (this.state.shouldRemoveSessionBeIgnored) this.setState({
                    shouldRemoveSessionBeIgnored: false
                });
            }, this.onHistoryChange = (location)=>{
                $fffa056866f763fb$var$removeDwellComponent('search-dwell-time');
                const parsedUrl = (0, ($parcel$interopDefault($6vAaw))).parse(location.pathname + location.search, true);
                const queryString = parsedUrl.query || {};
                const { searchSessionId: searchSessionId, searchObjectId: searchObjectId, searchContainerId: searchContainerId, searchContentType: searchContentType } = queryString;
                const { path: path } = parsedUrl;
                const previousSessionId = $fffa056866f763fb$var$getPreviousSessionId();
                const { shouldRemoveSessionBeIgnored: shouldRemoveSessionBeIgnored } = this.state;
                if (!(0, ($parcel$interopDefault($gccSB)))(previousSessionId) && !shouldRemoveSessionBeIgnored) $fffa056866f763fb$var$removeSessionMeta();
                if (searchSessionId) {
                    (0, (0, parcelRequire("6YRTH")).default)($fffa056866f763fb$var$sessionQueryParams);
                    const newState = {
                        sessionId: searchSessionId,
                        objectId: searchObjectId,
                        objectType: searchContentType,
                        containerId: searchContainerId,
                        previousSessionId: $fffa056866f763fb$var$getPreviousSessionId()
                    };
                    $fffa056866f763fb$var$addSessionMeta(newState);
                    const shouldRemoveSession = !!(0, (0, parcelRequire("5Jsi2")).skipClearSessionURLs).find((skipUrlRegex)=>!(0, ($parcel$interopDefault($gccSB)))(path) ? skipUrlRegex.test(path) : false);
                    this.setState({
                        ...newState,
                        shouldRemoveSessionBeIgnored: shouldRemoveSession
                    });
                }
            };
            this.props.history.listen(this.onHistoryChange);
            this.state = {
                shouldRemoveSessionBeIgnored: false,
                sessionId: ''
            };
        }
        componentDidMount() {
            window.addEventListener((0, (0, parcelRequire("5Jsi2")).CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
        }
        componentWillUnmount() {
            window.removeEventListener((0, (0, parcelRequire("5Jsi2")).CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
        }
        render() {
            if (this.state && this.state.sessionId) {
                const { objectId: objectId, containerId: containerId, objectType: objectType, sessionId: sessionId, previousSessionId: previousSessionId } = this.state;
                const data = {
                    objectId: objectId,
                    containerId: containerId,
                    objectType: objectType,
                    source: objectType,
                    actionSubject: objectType,
                    attributes: {
                        previousSessionId: previousSessionId
                    }
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("TtQEC")).default), {
                    sessionId: sessionId,
                    data: data
                });
            }
            return null;
        }
    }
    var $fffa056866f763fb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("1bQGJ")).withRouter)($fffa056866f763fb$export$f1e582dddb502dd6);
    var $2SVPM;
    var $2SVPM;
    const $e9a0ff6532e2be2e$export$ce440b3d0fa0d5ed = ()=>{
        if (false) return;
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush', 'ssr.spa.early-common-flush:start', 'ssr.spa.early-route-flush:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/common-preload', 'ssr.spa.early-common-flush:start', 'ssr.spa.metatags:start');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/metatags', 'ssr.spa.metatags:start', 'ssr.spa.metatags:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig:start', 'ssr.spa.statsig:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/feature-flags', 'ssr.spa.feature-flags:start', 'ssr.spa.feature-flags:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts', 'ssr.spa.feature-flags:end', 'ssr.spa.early-common-flush:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/route-preload', 'ssr.spa.early-route-flush:start', 'ssr.spa.early-route-flush:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('css-assets', 'ssr.spa.css-assets:start', 'ssr.spa.css-assets:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('ssr-output', 'ssr.spa.start', 'ssr.spa.state');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/styles', 'ssr.spa.start', 'ssr.spa.styles');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/html', 'ssr.spa.styles', 'ssr.spa.html');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/state', 'ssr.spa.html', 'ssr.spa.state');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/language-pack', 'jira-spa/language-pack.start', 'jira-spa/language-pack.end', true, true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    };
    var $bShz7;
    var $dJl1T;
    var $7bpAK = parcelRequire("7bpAK");
    var $2Gs5h;
    const $ab2f047cd976509c$var$LOCATION = 'spa.create-spa-history';
    const $ab2f047cd976509c$var$createCustomHistoryBlock = (routeBlockFns, currentRoutes, history)=>(blockFn)=>{
            const matchedRoute = (0, (0, parcelRequire("2Gs5h")).default)(currentRoutes, history.location.pathname, history.location.search);
            if (!matchedRoute) return ()=>{};
            if (!routeBlockFns.includes(blockFn)) routeBlockFns.push(blockFn);
            return ()=>{
                const idx = routeBlockFns.indexOf(blockFn);
                if (idx !== -1) routeBlockFns.splice(idx, 1);
            };
        };
    const $ab2f047cd976509c$var$createSpaHistory = (initialRoutes)=>{
        const routeBlockFns = [];
        let blockArgs = [];
        let nextMatchedRoute;
        const currentRoutes = initialRoutes;
        const history = (0, $7bpAK.createBrowserHistory)({
            getUserConfirmation: async (__, done)=>{
                try {
                    const matchedRoute = (0, (0, parcelRequire("2Gs5h")).default)(currentRoutes, history.location.pathname, history.location.search);
                    if (!matchedRoute || !nextMatchedRoute) return done(true);
                    for(let i = routeBlockFns.length - 1; i >= 0; i -= 1){
                        const result = await routeBlockFns[i](...blockArgs);
                        if (result === false) return done(false);
                    }
                    routeBlockFns.length = 0;
                    return done(true);
                } catch (err) {
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($ab2f047cd976509c$var$LOCATION, 'Error with getUserConfirmation', err);
                    return done(true);
                }
            }
        });
        history.refreshRoutes = (newRoutes)=>{
            currentRoutes.length = 0;
            currentRoutes.push(...newRoutes);
            routeBlockFns.length = 0;
        };
        history.block((location, action)=>{
            blockArgs = [
                location,
                action
            ];
            nextMatchedRoute = (0, (0, parcelRequire("2Gs5h")).default)(currentRoutes, location.pathname, location.search);
            return '';
        });
        history.block = $ab2f047cd976509c$var$createCustomHistoryBlock(routeBlockFns, currentRoutes, history);
        return history;
    };
    var $ab2f047cd976509c$export$2e2bcd8739ae039 = (routes)=>$ab2f047cd976509c$var$createSpaHistory(routes);
    var $5HG6S;
    var $kKlrY;
    var $l8ruj;
    var $3qHVS;
    var $lGgkA;
    var $ddkdN;
    var $2Gs5h;
    var $lVJAU;
    var $lODMY;
    var $1AZST;
    var $2ChuC = parcelRequire("2ChuC");
    (0, (0, parcelRequire("x9xyg")).setMark)('JIRA_SPA_ENTRY_LOADED');
    window.__SPA__ = true;
    (0, (0, parcelRequire("lGgkA")).LooselyLazy).init({
        mode: (0, (0, parcelRequire("ddkdN")).MODE).RENDER,
        crossOrigin: 'anonymous'
    });
    const $2f70583cb46f9994$var$tenantContext = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
    (0, (0, parcelRequire("x9xyg")).setMark)('jira-spa/language-pack.start');
    var $hWnRN = parcelRequire("hWnRN");
    (0, (0, parcelRequire("x9xyg")).setMark)('jira-spa/language-pack.end');
    const { locale: $2f70583cb46f9994$var$locale } = $2f70583cb46f9994$var$tenantContext;
    const $2f70583cb46f9994$var$superbatchInit = ()=>{
        window.DeferScripts = {
            deferState: 'done'
        };
        document.body && document.body.classList.remove('deferred');
    };
    const $2f70583cb46f9994$var$globalSettingsArgs = {
        navigation: false,
        upflow: false
    };
    const $2f70583cb46f9994$var$InstallGlobalComponentsOnce = ()=>{
        (0, $5uXOq.useEffect)(()=>{
            (0, $2ChuC.default).installLowPriorityApps((0, ($parcel$interopDefault($fr1K2)))($2f70583cb46f9994$var$globalSettingsArgs, [
                'flags',
                'navigation',
                'renderNavigation'
            ]));
            (0, (0, parcelRequire("x9xyg")).setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
        }, []);
        return null;
    };
    const $2f70583cb46f9994$var$updateCapability = (capability)=>{
        (0, (0, parcelRequire("87OsA")).setCapability)(capability);
        if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $281cbd47ba46dd7d$export$9a80695e72849f84]) delete window.AJS.$.ajaxSettings.headers[0, $281cbd47ba46dd7d$export$9a80695e72849f84];
        else window.AJS?.$?.ajaxSetup({
            headers: {
                [(0, $281cbd47ba46dd7d$export$9a80695e72849f84)]: capability
            }
        });
    };
    const $2f70583cb46f9994$var$CapabilityTrackerConnector = ({ routes: routes })=>{
        const { registerBlock: registerBlock } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        registerBlock((nextLocation)=>{
            const nextMatchObject = (0, (0, parcelRequire("2Gs5h")).default)(routes, nextLocation.pathname, nextLocation.search, '');
            $2f70583cb46f9994$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
            return true;
        });
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        $2f70583cb46f9994$var$updateCapability(route.meta?.capability || null);
        return null;
    };
    const $2f70583cb46f9994$var$main = async (getInitialRoutes, loadLazyRoutes)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('add_ssr_placeholder_replacements_to_nin_and_nav')) (0, $b76912b89d3451e2$export$aee7516e57289027)(document, window);
        (0, (0, parcelRequire("kKlrY")).default)();
        (0, (0, parcelRequire("aTq2A")).initBrowserMetrics3)();
        (0, (0, parcelRequire("7bkFJ")).initPlatformFeatureFlags)((0, (0, parcelRequire("3qHVS")).visualRefreshResolverOverride));
        (0, $e9a0ff6532e2be2e$export$ce440b3d0fa0d5ed)();
        (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
        (0, (0, parcelRequire("x9xyg")).setMark)('jira-spa/setup.start');
        const routes = (0, (0, parcelRequire("2SVPM")).measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>getInitialRoutes());
        const history = (0, (0, parcelRequire("2SVPM")).measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $ab2f047cd976509c$export$2e2bcd8739ae039)(routes));
        const initRoute = (0, (0, parcelRequire("2SVPM")).measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
            const matchedRoute = (0, (0, parcelRequire("2Gs5h")).default)(routes, window.location.pathname, window.location.search);
            (0, (0, parcelRequire("cfDZ3")).setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
            return matchedRoute;
        });
        if (initRoute != null) {
            const ufoName = (0, $96da41f3532a466b$export$2e2bcd8739ae039)(initRoute.route);
            (0, (0, parcelRequire("0z6W8")).default)(ufoName, initRoute.route.name);
        }
        const BrowserMetricsConnector = ()=>{
            const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
            (0, (0, parcelRequire("21pfT")).browserMetrics).setRoute(route.name);
            (0, (0, parcelRequire("1ciso")).useUFOTransitionCompleter)();
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
            return null;
        };
        (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
        const routerProps = {
            history: history,
            routes: routes,
            basePath: '',
            initialRoute: initRoute?.route,
            resourceData: window.SPA_STATE,
            resourceContext: (0, (0, parcelRequire("5HG6S")).getSpaRouterContext)({
                tenantContext: $2f70583cb46f9994$var$tenantContext
            }),
            onPrefetch: ({ route: route, match: match })=>{
                (0, (0, parcelRequire("bShz7")).setPrefetchStartMark)(match);
                if (!route.forPaint) return;
                route.forPaint.map((component)=>component.preload && component.preload());
            }
        };
        let SpaClientRouter;
        if (typeof loadLazyRoutes === 'function') {
            const useRouterRoutes = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.routes);
            SpaClientRouter = ({ children: children })=>{
                const actions = (0, (0, parcelRequire("lODMY")).useRouterStoreActions)();
                const currentRoutes = useRouterRoutes();
                (0, $5uXOq.useEffect)(()=>{
                    let isCancelled = false;
                    const loadRoutes = async ()=>{
                        if (!isCancelled) {
                            const getLazyRoutes = await loadLazyRoutes();
                            await actions.setRoutes(getLazyRoutes());
                        }
                    };
                    loadRoutes();
                    return ()=>{
                        isCancelled = true;
                    };
                }, [
                    actions
                ]);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b7awD")).Router), routerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                    id: "spa-main.client-router",
                    packageName: "jiraEntry",
                    fallback: "unmount",
                    teamName: "delorean-spa"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), (0, ($parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$CapabilityTrackerConnector, {
                    routes: currentRoutes
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fffa056866f763fb$export$2e2bcd8739ae039), null)), children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fz3fB")).NonCritical), {
                    id: "spa-main.client-router.non-critical",
                    teamName: "delorean-spa"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$InstallGlobalComponentsOnce, null)));
            };
        } else SpaClientRouter = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b7awD")).Router), routerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), (0, ($parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$CapabilityTrackerConnector, {
                routes: routes
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fffa056866f763fb$export$2e2bcd8739ae039), null)), children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fz3fB")).NonCritical), {
                id: "spa-main.client-router.non-critical",
                teamName: "delorean-spa"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$InstallGlobalComponentsOnce, null)));
        const App = ({ placeholders: placeholders })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQ1m")).StrictMode), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
                name: "jira-spa"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholderContext).Provider, {
                value: placeholders
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $454974e68bcf078d$export$6d4069f4b64f7492), {
                baseUrl: "",
                locale: $2f70583cb46f9994$var$locale,
                messages: $hWnRN,
                Router: SpaClientRouter,
                initRoute: initRoute,
                routes: routes,
                routerLinkComponent: (0, (0, parcelRequire("81ezV")).JiraRouterLinkConfiguration)
            }))));
        window.__NAV_VERSION__ = '3.0.0';
        (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
        (0, (0, parcelRequire("x9xyg")).setMark)('_jira-spa/spa-shell.start');
        const container = document.getElementById('jira-frontend');
        if (container) {
            (0, (0, parcelRequire("a0hd6")).getVCObserver)().setSSRElement(container);
            (0, (0, parcelRequire("a0hd6")).getVCObserver)().setReactRootRenderStart();
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    (0, (0, parcelRequire("a0hd6")).getVCObserver)().setReactRootRenderStop();
                });
            });
            const placeholders = (0, (0, parcelRequire("frBVt")).getPlaceholdersFromHTML)();
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-concurrent-root-jira-spa') && true) (0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement(App, {
                placeholders: placeholders
            }), container);
            if ((0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-concurrent-root-jira-spa')) {
                const root = (0, $kUr4d.createRoot)(container);
                root.render((0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(App, {
                    placeholders: placeholders
                }), (0, (0, parcelRequire("4R6GH")).fg)('concurrent-rendering-change-advisory') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3f6cbe094065dc4a$export$e7a8408a6ddec2cb), {
                    consoleMessage: "This entire site is being rendered with React concurrent rendering go/r18"
                }) : null));
            }
        }
        (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
        (0, (0, parcelRequire("x9xyg")).setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
        setTimeout(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
        });
        if ((0, (0, parcelRequire("6s1PB")).expVal)('uip_preprod_slow', 'value', 0) > 0) {
            (0, (0, parcelRequire("x9xyg")).setMark)('slow-start');
            const end = performance.now() + (0, (0, parcelRequire("6s1PB")).expVal)('uip_preprod_slow', 'value', 0);
            while(performance.now() < end);
            (0, (0, parcelRequire("x9xyg")).setMark)('slow-stop');
        }
        (0, $2ChuC.default).installHighPriorityApps((0, ($parcel$interopDefault($3NMrl)))($2f70583cb46f9994$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        $2f70583cb46f9994$var$superbatchInit();
        return null;
    };
    const $2f70583cb46f9994$export$f71867a5b2484020 = async (getInitialRoutes, loadLazyRoutes)=>{
        return $2f70583cb46f9994$var$main(getInitialRoutes, loadLazyRoutes).catch((reason)=>(0, $6a69127f0604feb0$export$a5c16644a2d3c205)(reason));
    };
    (0, (0, parcelRequire("x9xyg")).setMark)('JIRA_SPA_ENTRY_LOADED');
    (0, $2f70583cb46f9994$export$f71867a5b2484020)((0, $26bc22beafcfd5a4$export$2f7745f2f5ab3897));
}, [
    "eNmuD",
    "dsiAd",
    "hPzOn",
    "2Lfdl",
    "kfXhT",
    "1QYl5",
    "561Jq",
    "i5RRW",
    "kWrFZ",
    "bYT2S",
    "h2MrD",
    "fr9NE",
    "cM9em",
    "1WmWM"
]);
$parcel$global.rlb("jfj4N");
